
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4e29"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4e29"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fLrnc", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "registerAdapter", () => $b7a07a87e1dff17d$export$ddf4d3602a252674);
$parcel$export(module.exports, "createAdapter", () => $b7a07a87e1dff17d$export$968afe682db9f0d4);
$parcel$export(module.exports, "resolveDb", () => $b7a07a87e1dff17d$export$a4b5c162303531b1);
$parcel$export(module.exports, "parseDuration", () => $b7a07a87e1dff17d$export$ecae829bb3747ea6);
$parcel$export(module.exports, "initAdapterAuth", () => $b7a07a87e1dff17d$export$d225206060a26402);
$parcel$export(module.exports, "executeFetch", () => $b7a07a87e1dff17d$export$8ced815accfd9df6);
$parcel$export(module.exports, "queryClient", () => $b7a07a87e1dff17d$export$7c07b633a151f9c5);
$parcel$export(module.exports, "fetchPlugin", () => $b7a07a87e1dff17d$export$3e7aa3050ca4b6c);
$parcel$export(module.exports, "default", () => $b7a07a87e1dff17d$export$2e2bcd8739ae039);
parcelRequire("2oe0q");
var $bmfNh = parcelRequire("bmfNh");
var $fX7ii = parcelRequire("fX7ii");
'use strict';
// --- Adapter resolution ---
const $b7a07a87e1dff17d$var$ADAPTER_METHODS = [
    'select',
    'rpc',
    'insert',
    'update',
    'delete',
    'subscribe'
];



const $b7a07a87e1dff17d$var$BUILTIN_ADAPTERS = {
    supabase: ()=>(parcelRequire("enZpr")),
    rest: ()=>(parcelRequire("6dvJp")),
    local: ()=>(parcelRequire("1IE9l"))
};
const $b7a07a87e1dff17d$export$ddf4d3602a252674 = (name, loader)=>{
    $b7a07a87e1dff17d$var$BUILTIN_ADAPTERS[name] = loader;
};
const $b7a07a87e1dff17d$export$968afe682db9f0d4 = (config)=>{
    const adapter = {};
    for (const method of $b7a07a87e1dff17d$var$ADAPTER_METHODS)if (config[method]) adapter[method] = config[method];
    adapter.name = config.name || 'custom';
    return adapter;
};
const $b7a07a87e1dff17d$export$a4b5c162303531b1 = async (config)=>{
    if (!config) return null;
    if (typeof config.select === 'function') return config;
    const { adapter: adapter, ...options } = config;
    const name = typeof adapter === 'string' ? adapter : typeof config === 'string' ? config : null;
    if (!name) return null;
    const loader = $b7a07a87e1dff17d$var$BUILTIN_ADAPTERS[name];
    if (!loader) throw new Error(`Unknown db adapter: "${name}". Use registerAdapter() for adapters with optional deps.`);
    const mod = await loader();
    return mod.setup(options);
};
// --- Duration parsing ---
const $b7a07a87e1dff17d$export$ecae829bb3747ea6 = (val)=>{
    if (!val) return 0;
    if (typeof val === 'number') return val;
    const match = val.match(/^(\d+)(ms|s|m|h)$/);
    if (!match) return 0;
    const n = parseInt(match[1]);
    const unit = match[2];
    if (unit === 'ms') return n;
    if (unit === 's') return n * 1000;
    if (unit === 'm') return n * 60000;
    if (unit === 'h') return n * 3600000;
    return 0;
};
// --- Query cache ---
const $b7a07a87e1dff17d$var$cacheStore = new Map();
const $b7a07a87e1dff17d$var$querySubscribers = new Map() // key -> Set of elements
;
const $b7a07a87e1dff17d$var$activeQueries = new Map() // key -> Promise (deduplication)
;
// Cache key includes lang when provided so different-locale responses don't
// collide. The fetch plugin injects Accept-Language on requests, so the same
// (from, method, params) tuple yields different bodies per lang. queryClient.
// dropNonLang(keepLang) leans on this suffix to evict stale-language entries
// on a setLang() event without touching the kept lang's cache.
const $b7a07a87e1dff17d$var$buildCacheKey = (config, lang)=>{
    if (config.cache?.key) return config.cache.key;
    const params = $b7a07a87e1dff17d$var$resolveParamsSync(config.params);
    const base = `${config.from}:${config.method}:${JSON.stringify(params || '')}`;
    return lang ? `${base}:${lang}` : base;
};
const $b7a07a87e1dff17d$var$getCacheEntry = (key)=>$b7a07a87e1dff17d$var$cacheStore.get(key) || null;
const $b7a07a87e1dff17d$var$setCacheEntry = (key, data, error)=>{
    const existing = $b7a07a87e1dff17d$var$cacheStore.get(key);
    const entry = {
        data: data,
        error: error,
        time: Date.now(),
        stale: false
    };
    $b7a07a87e1dff17d$var$cacheStore.set(key, entry);
    // Notify all subscribers of this query
    const subs = $b7a07a87e1dff17d$var$querySubscribers.get(key);
    if (subs) {
        for (const sub of subs)if ((0, $fX7ii.isFunction)(sub)) sub(entry);
    }
    return entry;
};
const $b7a07a87e1dff17d$var$invalidateCache = (key)=>{
    if (key) {
        const entry = $b7a07a87e1dff17d$var$cacheStore.get(key);
        if (entry) entry.stale = true;
        return;
    }
    // Invalidate all
    for (const [, entry] of $b7a07a87e1dff17d$var$cacheStore)entry.stale = true;
};
const $b7a07a87e1dff17d$var$removeCache = (key)=>{
    if (key) {
        $b7a07a87e1dff17d$var$cacheStore.delete(key);
        return;
    }
    $b7a07a87e1dff17d$var$cacheStore.clear();
};
const $b7a07a87e1dff17d$var$subscribeToCacheKey = (key, callback)=>{
    if (!$b7a07a87e1dff17d$var$querySubscribers.has(key)) $b7a07a87e1dff17d$var$querySubscribers.set(key, new Set());
    $b7a07a87e1dff17d$var$querySubscribers.get(key).add(callback);
    return ()=>{
        const subs = $b7a07a87e1dff17d$var$querySubscribers.get(key);
        if (subs) {
            subs.delete(callback);
            if (subs.size === 0) $b7a07a87e1dff17d$var$querySubscribers.delete(key);
        }
    };
};
// --- Cache config resolution ---
const $b7a07a87e1dff17d$var$parseCacheConfig = (cache)=>{
    if (!cache && cache !== false) return {
        staleTime: 60000,
        gcTime: 300000
    };
    if (cache === false) return null;
    if (cache === true) return {
        staleTime: 60000,
        gcTime: 300000
    };
    if (typeof cache === 'number') return {
        staleTime: cache,
        gcTime: Math.max(cache * 5, 300000)
    };
    if ((0, $fX7ii.isString)(cache)) return {
        staleTime: $b7a07a87e1dff17d$export$ecae829bb3747ea6(cache),
        gcTime: 300000
    };
    return {
        staleTime: $b7a07a87e1dff17d$export$ecae829bb3747ea6(cache.stale || cache.staleTime) || 60000,
        gcTime: $b7a07a87e1dff17d$export$ecae829bb3747ea6(cache.gc || cache.gcTime || cache.expire) || 300000,
        key: cache.key
    };
};
// --- GC ---
let $b7a07a87e1dff17d$var$gcTimer = null;
const $b7a07a87e1dff17d$var$startGC = ()=>{
    if ($b7a07a87e1dff17d$var$gcTimer) return;
    $b7a07a87e1dff17d$var$gcTimer = setInterval(()=>{
        const now = Date.now();
        for (const [key, entry] of $b7a07a87e1dff17d$var$cacheStore){
            const subs = $b7a07a87e1dff17d$var$querySubscribers.get(key);
            const hasSubscribers = subs && subs.size > 0;
            if (!hasSubscribers && now - entry.time > (entry.gcTime || 300000)) $b7a07a87e1dff17d$var$cacheStore.delete(key);
        }
    }, 30000);
    if ($b7a07a87e1dff17d$var$gcTimer.unref) $b7a07a87e1dff17d$var$gcTimer.unref();
};
$b7a07a87e1dff17d$var$startGC();
// --- Retry logic ---
const $b7a07a87e1dff17d$var$DEFAULT_RETRY = 3;
const $b7a07a87e1dff17d$var$DEFAULT_RETRY_DELAY = (attempt)=>Math.min(1000 * 2 ** attempt, 30000);
const $b7a07a87e1dff17d$var$resolveRetryConfig = (config)=>{
    const retry = config.retry;
    if (retry === false) return {
        count: 0
    };
    if (retry === true || retry === undefined) return {
        count: $b7a07a87e1dff17d$var$DEFAULT_RETRY,
        delay: $b7a07a87e1dff17d$var$DEFAULT_RETRY_DELAY
    };
    if (typeof retry === 'number') return {
        count: retry,
        delay: $b7a07a87e1dff17d$var$DEFAULT_RETRY_DELAY
    };
    return {
        count: retry.count ?? $b7a07a87e1dff17d$var$DEFAULT_RETRY,
        delay: (0, $fX7ii.isFunction)(retry.delay) ? retry.delay : typeof retry.delay === 'number' ? ()=>retry.delay : $b7a07a87e1dff17d$var$DEFAULT_RETRY_DELAY
    };
};
const $b7a07a87e1dff17d$var$withRetry = async (fn, retryConfig)=>{
    const { count: count, delay: delay } = retryConfig;
    let lastError;
    for(let attempt = 0; attempt <= count; attempt++)try {
        const result = await fn();
        if (result?.error) {
            lastError = result.error;
            if (attempt < count) {
                const ms = (0, $fX7ii.isFunction)(delay) ? delay(attempt, lastError) : delay;
                await new Promise((r)=>setTimeout(r, ms));
                continue;
            }
            return result;
        }
        return result;
    } catch (e) {
        lastError = e;
        if (attempt < count) {
            const ms = (0, $fX7ii.isFunction)(delay) ? delay(attempt, e) : delay;
            await new Promise((r)=>setTimeout(r, ms));
            continue;
        }
        throw e;
    }
    return {
        data: null,
        error: lastError
    };
};
// --- Refetch on window focus / reconnect ---
const $b7a07a87e1dff17d$var$globalListeners = {
    focus: new Set(),
    online: new Set()
};
let $b7a07a87e1dff17d$var$globalListenersAttached = false;
const $b7a07a87e1dff17d$var$attachGlobalListeners = ()=>{
    if ($b7a07a87e1dff17d$var$globalListenersAttached || typeof window === 'undefined') return;
    $b7a07a87e1dff17d$var$globalListenersAttached = true;
    const onFocus = ()=>{
        for (const fn of $b7a07a87e1dff17d$var$globalListeners.focus)fn();
    };
    const onOnline = ()=>{
        for (const fn of $b7a07a87e1dff17d$var$globalListeners.online)fn();
    };
    window.addEventListener('visibilitychange', ()=>{
        if (document.visibilityState === 'visible') onFocus();
    });
    window.addEventListener('focus', onFocus);
    window.addEventListener('online', onOnline);
};
// --- Fetch config resolution ---
const $b7a07a87e1dff17d$var$resolveFetchConfig = (fetchProp, element)=>{
    const ref = element.__ref;
    if (fetchProp === true) return {
        from: ref.__state || element.key,
        method: 'select',
        query: true,
        on: 'create'
    };
    if ((0, $fX7ii.isString)(fetchProp)) return {
        from: fetchProp,
        method: 'select',
        query: true,
        on: 'create'
    };
    if ((0, $fX7ii.isObject)(fetchProp)) {
        const config = {
            ...fetchProp
        };
        config.from = config.from || ref.__state || element.key;
        config.method = config.method || 'select';
        config.on = config.on || 'create';
        if (config.query === undefined) config.query = true;
        return config;
    }
    return null;
};
const $b7a07a87e1dff17d$var$resolveParamsSync = (params)=>{
    if (!params || (0, $fX7ii.isFunction)(params)) return params;
    return params;
};
const $b7a07a87e1dff17d$var$resolveLanguage = (element, context)=>{
    const root = element?.state?.root || context?.state?.root;
    if (root?.lang) return root.lang;
    return undefined;
};
const $b7a07a87e1dff17d$var$resolveParams = (params, element, context)=>{
    let resolved;
    if (!params) resolved = undefined;
    else if ((0, $fX7ii.isFunction)(params)) resolved = params(element, element.state);
    else {
        resolved = {};
        for(const key in params){
            const val = params[key];
            resolved[key] = (0, $fX7ii.isFunction)(val) ? val(element, element.state) : val;
        }
    }
    return resolved;
};
const $b7a07a87e1dff17d$export$d225206060a26402 = async (adapter, context)=>{
    if (!adapter || adapter.__authInitialized) return;
    adapter.__authInitialized = true;
    if (!adapter.getSession) return;
    const updateAuth = (user, session)=>{
        const root = context.state?.root;
        if (root?.update) root.update({
            auth: {
                user: user,
                session: session,
                loading: false
            }
        });
    };
    try {
        const session = await adapter.getSession();
        updateAuth(session?.user || null, session);
    } catch (e) {
        console.warn('[fetch] Failed to restore auth session:', e.message);
    }
    if (adapter.onAuthStateChange) adapter.onAuthStateChange((event, session)=>{
        updateAuth(session?.user || null, session);
    });
};
const $b7a07a87e1dff17d$var$resolveAdapter = async (db, context)=>{
    // When adapter is already resolved (e.g. by getDB()), still init auth
    if ((0, $fX7ii.isFunction)(db.select)) {
        if (db.auth !== false) await $b7a07a87e1dff17d$export$d225206060a26402(db, context);
        return db;
    }
    if (db.__resolved) {
        if (db.auth !== false) await $b7a07a87e1dff17d$export$d225206060a26402(db.__resolved, context);
        return db.__resolved;
    }
    if (db.__resolving) return db.__resolving;
    db.__resolving = $b7a07a87e1dff17d$export$a4b5c162303531b1(db);
    const resolved = await db.__resolving;
    delete db.__resolving;
    if (!resolved) return null;
    resolved.auth = db.auth;
    resolved.url = db.url;
    resolved.key = db.key;
    db.__resolved = resolved;
    context.fetch = resolved;
    // Auto-init auth when adapter supports it and db.auth is enabled
    if (db.auth !== false) await $b7a07a87e1dff17d$export$d225206060a26402(resolved, context);
    return resolved;
};
const $b7a07a87e1dff17d$var$triggerCallback = (element, name, ...args)=>{
    const fn = (0, $fX7ii.isFunction)(element[name]) ? element[name] : null;
    if (fn) fn.call(element, ...args, element, element.state, element.context);
};
const $b7a07a87e1dff17d$var$triggerConfigCallback = (config, element, name, ...args)=>{
    const fn = config && (0, $fX7ii.isFunction)(config[name]) ? config[name] : null;
    if (fn) fn.call(element, ...args, element, element.state, element.context);
};
const $b7a07a87e1dff17d$var$collectFormData = (element)=>{
    const data = {};
    const node = element.node;
    if (!node) return data;
    if (node.tagName === 'FORM') {
        const formData = new FormData(node);
        for (const [key, value] of formData.entries())data[key] = value;
        return data;
    }
    const inputs = node.querySelectorAll('input, textarea, select');
    for(let i = 0; i < inputs.length; i++){
        const input = inputs[i];
        const name = input.name || input.getAttribute('name');
        if (!name) continue;
        if (input.type === 'checkbox') data[name] = input.checked;
        else if (input.type === 'file') data[name] = input.files;
        else data[name] = input.value;
    }
    return data;
};
// --- State update helpers ---
const $b7a07a87e1dff17d$var$updateElementState = (element, data, stateKey, options = {})=>{
    const isRoot = stateKey && stateKey.startsWith('~/');
    const target = isRoot ? element.state?.root || element.state : element.state;
    if (!target?.update) return;
    if (isRoot) {
        const key = stateKey.slice(2);
        // If transform returned an object containing the key itself, spread on root
        // e.g. transform returns { transactions: [...], totalSaved: 755 } for as: '~/transactions'
        if (data && typeof data === 'object' && !Array.isArray(data) && key in data) target.update(data, {
            preventFetch: true,
            ...options
        });
        else target.update({
            [key]: data
        }, {
            preventFetch: true,
            ...options
        });
    } else {
        const stateData = stateKey ? {
            [stateKey]: data
        } : data;
        target.update(stateData, {
            preventFetch: true,
            ...options
        });
    }
};
const $b7a07a87e1dff17d$var$setFetchStatus = (element, status)=>{
    // Element may have been torn down (route change, modal close, parent
    // unmount) between the runFetch entry guard and this call site —
    // `runFetch` checks `__ref` once at start, but a long-lived async fetch
    // can outlive the element. Without this null-guard the framework throws
    // `TypeError: Cannot set properties of null` from every status write.
    const ref = element?.__ref;
    if (!ref) return;
    ref.__fetchStatus = status;
    ref.__fetching = status.isFetching;
    ref.__fetchError = status.error;
};
// --- Core fetch runner ---
const $b7a07a87e1dff17d$var$runFetch = async (config, element, context, opts = {})=>{
    const db = context?.fetch;
    if (!db) return;
    // Element may have been torn down (unmounted, navigated away, modal
    // closed) while a reactive dependency on its fetch config was still
    // scheduling this run. `__ref` is the framework's marker for "alive" —
    // if it's gone, bail before anything else touches `element`.
    if (!element || !element.__ref) return;
    // enabled check
    if (config.enabled === false) return;
    if ((0, $fX7ii.isFunction)(config.enabled) && !config.enabled(element, element.state)) return;
    // Also honor `skip` as an alias — some call sites already use it.
    if (config.skip === true) return;
    if ((0, $fX7ii.isFunction)(config.skip) && config.skip(element, element.state)) return;
    const adapter = await $b7a07a87e1dff17d$var$resolveAdapter(db, context);
    if (!adapter) return;
    // Re-check after the await — a slow adapter-resolve can outlive the
    // element that triggered the fetch.
    if (!element.__ref) return;
    const ref = element.__ref;
    const { from: from, method: method, query: query, params: rawParams, cache: cacheRaw, transform: transform, single: single, auth: auth, fields: fields, as: stateKey, limit: limit, offset: offset, order: order, headers: headers, baseUrl: baseUrl, page: // Pagination
    page, cursor: cursor, getNextPageParam: getNextPageParam, getPreviousPageParam: getPreviousPageParam, infinite: infinite, placeholderData: // TanStack-style options
    placeholderData, initialData: initialData, select: selectTransform, keepPreviousData: keepPreviousData } = config;
    let select = (0, $fX7ii.isString)(selectTransform) ? selectTransform : undefined;
    if (query && (0, $fX7ii.isFunction)(element.getQuery)) {
        const q = element.getQuery(adapter.name || 'paths');
        if (q) select = q.select || q.length && q.join(',') || select;
    }
    const params = $b7a07a87e1dff17d$var$resolveParams(rawParams, element, context);
    const cacheConfig = $b7a07a87e1dff17d$var$parseCacheConfig(cacheRaw);
    const retryConfig = $b7a07a87e1dff17d$var$resolveRetryConfig(config);
    const lang = $b7a07a87e1dff17d$var$resolveLanguage(element, context);
    // Build cache key — lang suffix lets queryClient.dropNonLang(keepLang)
    // evict stale-language entries on setLang() without flushing the rest.
    const langSuffix = lang ? `:${lang}` : '';
    const cacheKey = cacheConfig ? cacheRaw?.key || `${from}:${method}:${JSON.stringify(params || '')}${infinite ? ':infinite' : ''}${page ? ':p' + JSON.stringify(page) : ''}${langSuffix}` : null;
    // Apply initial/placeholder data on first mount
    if (!ref.__fetchInitialized && cacheKey) {
        ref.__fetchInitialized = true;
        if (initialData !== undefined) {
            const initData = (0, $fX7ii.isFunction)(initialData) ? initialData() : initialData;
            $b7a07a87e1dff17d$var$setCacheEntry(cacheKey, initData, null);
        }
    }
    // Check cache (stale-while-revalidate)
    if ((method === 'select' || method === 'rpc') && cacheKey && cacheConfig) {
        const cached = $b7a07a87e1dff17d$var$getCacheEntry(cacheKey);
        if (cached && !cached.error) {
            const age = Date.now() - cached.time;
            const isStale = cached.stale || age > (cacheConfig.staleTime || 0);
            let data = cached.data;
            if ((0, $fX7ii.isFunction)(selectTransform)) data = selectTransform(data, element, element.state);
            if (transform) data = transform(data, element, element.state);
            $b7a07a87e1dff17d$var$updateElementState(element, data, stateKey);
            if (!isStale) {
                $b7a07a87e1dff17d$var$setFetchStatus(element, {
                    isFetching: false,
                    isLoading: false,
                    isStale: false,
                    isSuccess: true,
                    error: null,
                    status: 'success',
                    fetchStatus: 'idle'
                });
                return;
            }
        // Stale — continue to background refetch
        } else if (placeholderData !== undefined) {
            const phData = (0, $fX7ii.isFunction)(placeholderData) ? placeholderData(element, element.state) : placeholderData;
            if (phData !== undefined) $b7a07a87e1dff17d$var$updateElementState(element, phData, stateKey);
        }
    }
    // Deduplication — if same query is already in-flight, share the promise (with timeout)
    if (cacheKey && $b7a07a87e1dff17d$var$activeQueries.has(cacheKey) && !opts.force) {
        const existing = $b7a07a87e1dff17d$var$activeQueries.get(cacheKey);
        try {
            const result = await Promise.race([
                existing,
                new Promise((_, r)=>setTimeout(()=>r('DEDUP_TIMEOUT'), 15000))
            ]);
            if (result?.data !== undefined) {
                let finalData = result.data;
                if ((0, $fX7ii.isFunction)(selectTransform)) finalData = selectTransform(finalData, element, element.state);
                if (transform) finalData = transform(finalData, element, element.state);
                $b7a07a87e1dff17d$var$updateElementState(element, finalData, stateKey);
                $b7a07a87e1dff17d$var$triggerCallback(element, 'onFetchComplete', finalData);
                $b7a07a87e1dff17d$var$triggerConfigCallback(config, element, 'onFetchComplete', finalData);
            }
        } catch (e) {
        // Error handled by the original caller
        }
        return;
    }
    // Set loading status
    const isFirstLoad = !$b7a07a87e1dff17d$var$getCacheEntry(cacheKey)?.data;
    $b7a07a87e1dff17d$var$setFetchStatus(element, {
        isFetching: true,
        isLoading: isFirstLoad,
        isStale: false,
        isSuccess: false,
        error: null,
        status: 'pending',
        fetchStatus: 'fetching'
    });
    $b7a07a87e1dff17d$var$triggerCallback(element, 'onFetchStart');
    $b7a07a87e1dff17d$var$triggerConfigCallback(config, element, 'onFetchStart');
    const _emitNet = context?.analyze?.emitNetwork;
    const __analyzeStart = _emitNet ? typeof performance !== 'undefined' ? performance.now() : Date.now() : 0;
    if (_emitNet) _emitNet({
        phase: 'start',
        mode: 'query',
        from: from,
        method: method,
        cacheKey: cacheKey,
        lang: lang
    });
    const doFetch = async ()=>{
        if (auth !== false && adapter.auth !== false && adapter.getSession) {
            const session = await adapter.getSession();
            if (auth === true && !session) {
                const err = {
                    message: 'Not authenticated'
                };
                $b7a07a87e1dff17d$var$setFetchStatus(element, {
                    isFetching: false,
                    isLoading: false,
                    isStale: false,
                    isSuccess: false,
                    error: err,
                    status: 'error',
                    fetchStatus: 'idle'
                });
                $b7a07a87e1dff17d$var$triggerCallback(element, 'onFetchError', err);
                $b7a07a87e1dff17d$var$triggerConfigCallback(config, element, 'onFetchError', err);
                return {
                    data: null,
                    error: err
                };
            }
        }
        const fn = adapter[method];
        if (!(0, $fX7ii.isFunction)(fn)) return {
            data: null,
            error: {
                message: `Method "${method}" not found on adapter`
            }
        };
        const request = {
            from: from,
            select: select,
            params: params,
            single: single,
            limit: limit,
            offset: offset,
            order: order,
            headers: headers,
            baseUrl: baseUrl
        };
        // Inject language into request headers
        const lang = $b7a07a87e1dff17d$var$resolveLanguage(element, context);
        if (lang) request.headers = {
            ...request.headers,
            'Accept-Language': lang
        };
        // Pagination support
        if (page !== undefined) {
            if ((0, $fX7ii.isObject)(page)) {
                if (page.offset !== undefined) request.offset = page.offset;
                if (page.limit !== undefined) request.limit = page.limit;
                if (page.cursor !== undefined) request.params = {
                    ...request.params,
                    cursor: page.cursor
                };
            } else if (typeof page === 'number') {
                const pageSize = config.pageSize || limit || 20;
                request.offset = (page - 1) * pageSize;
                request.limit = pageSize;
            }
        }
        if (cursor !== undefined) request.params = {
            ...request.params,
            cursor: cursor
        };
        if (method === 'insert' || method === 'update' || method === 'upsert') {
            let data;
            if (fields === true || config.on === 'submit') data = $b7a07a87e1dff17d$var$collectFormData(element);
            else if ((0, $fX7ii.isArray)(fields)) {
                const formData = $b7a07a87e1dff17d$var$collectFormData(element);
                data = {};
                for (const f of fields)data[f] = formData[f];
            } else if (element.state?.parse) data = element.state.parse();
            else if ((0, $fX7ii.isObject)(element.state)) data = {
                ...element.state
            };
            if (transform) data = transform(data, element, element.state);
            request.data = data;
        }
        if (method === 'rpc') {
            let rpcParams = params;
            if (config.on === 'submit') {
                const formData = $b7a07a87e1dff17d$var$collectFormData(element);
                rpcParams = config.transformParams ? config.transformParams(formData, element, element.state) : formData;
            }
            request.params = rpcParams;
        }
        if (method === 'subscribe') {
            const unsubscribe = adapter.subscribe({
                from: from,
                params: params,
                on: config.subscribeOn
            }, (newData, oldData, payload)=>{
                $b7a07a87e1dff17d$var$updateElementState(element, newData, stateKey);
                $b7a07a87e1dff17d$var$triggerCallback(element, 'onFetchComplete', newData);
                $b7a07a87e1dff17d$var$triggerConfigCallback(config, element, 'onFetchComplete', newData);
            });
            ref.__unsubscribe = unsubscribe;
            return {
                data: null,
                error: null,
                subscribed: true
            };
        }
        return fn(request);
    };
    // Execute with retry
    const fetchPromise = $b7a07a87e1dff17d$var$withRetry(doFetch, retryConfig);
    // Store for deduplication
    if (cacheKey) $b7a07a87e1dff17d$var$activeQueries.set(cacheKey, fetchPromise);
    try {
        const result = await fetchPromise;
        if (result?.subscribed) return;
        const { data: data, error: error } = result || {};
        if (error) {
            if (cacheKey) $b7a07a87e1dff17d$var$setCacheEntry(cacheKey, null, error);
            $b7a07a87e1dff17d$var$setFetchStatus(element, {
                isFetching: false,
                isLoading: false,
                isStale: false,
                isSuccess: false,
                error: error,
                status: 'error',
                fetchStatus: 'idle'
            });
            $b7a07a87e1dff17d$var$triggerCallback(element, 'onFetchError', error);
            $b7a07a87e1dff17d$var$triggerConfigCallback(config, element, 'onFetchError', error);
            if (_emitNet) _emitNet({
                phase: 'error',
                mode: 'query',
                from: from,
                method: method,
                cacheKey: cacheKey,
                error: error.message || error,
                durationMs: (typeof performance !== 'undefined' ? performance.now() : Date.now()) - __analyzeStart
            });
            return;
        }
        if (data !== undefined) {
            // Update cache
            if ((method === 'select' || method === 'rpc') && cacheKey) {
                const entry = $b7a07a87e1dff17d$var$setCacheEntry(cacheKey, data, null);
                entry.gcTime = cacheConfig?.gcTime || 300000;
            }
            let finalData = data;
            // Infinite query — append pages
            if (infinite && (0, $fX7ii.isArray)(data)) {
                if (!ref.__pages) ref.__pages = [];
                if (opts.direction === 'previous') ref.__pages.unshift(data);
                else ref.__pages.push(data);
                finalData = ref.__pages.flat();
                // Resolve pagination cursors
                if (getNextPageParam) {
                    ref.__nextPageParam = getNextPageParam(data, ref.__pages);
                    ref.__hasNextPage = ref.__nextPageParam != null;
                }
                if (getPreviousPageParam) {
                    ref.__prevPageParam = getPreviousPageParam(data, ref.__pages);
                    ref.__hasPreviousPage = ref.__prevPageParam != null;
                }
            }
            if ((0, $fX7ii.isFunction)(selectTransform)) finalData = selectTransform(finalData, element, element.state);
            if (transform) finalData = transform(finalData, element, element.state);
            // keepPreviousData — don't clear state while fetching new page
            if (!keepPreviousData || finalData !== undefined) $b7a07a87e1dff17d$var$updateElementState(element, finalData, stateKey);
            $b7a07a87e1dff17d$var$setFetchStatus(element, {
                isFetching: false,
                isLoading: false,
                isStale: false,
                isSuccess: true,
                error: null,
                status: 'success',
                fetchStatus: 'idle'
            });
            $b7a07a87e1dff17d$var$triggerCallback(element, 'onFetchComplete', finalData);
            $b7a07a87e1dff17d$var$triggerConfigCallback(config, element, 'onFetchComplete', finalData);
            if (_emitNet) _emitNet({
                phase: 'success',
                mode: 'query',
                ok: true,
                from: from,
                method: method,
                cacheKey: cacheKey,
                durationMs: (typeof performance !== 'undefined' ? performance.now() : Date.now()) - __analyzeStart
            });
        }
    } catch (e) {
        $b7a07a87e1dff17d$var$setFetchStatus(element, {
            isFetching: false,
            isLoading: false,
            isStale: false,
            isSuccess: false,
            error: e,
            status: 'error',
            fetchStatus: 'idle'
        });
        $b7a07a87e1dff17d$var$triggerCallback(element, 'onFetchError', e);
        $b7a07a87e1dff17d$var$triggerConfigCallback(config, element, 'onFetchError', e);
        if (_emitNet) _emitNet({
            phase: 'error',
            mode: 'query',
            from: from,
            method: method,
            cacheKey: cacheKey,
            error: e.message || String(e),
            durationMs: (typeof performance !== 'undefined' ? performance.now() : Date.now()) - __analyzeStart
        });
    } finally{
        if (cacheKey) $b7a07a87e1dff17d$var$activeQueries.delete(cacheKey);
    }
};
// --- Event binding ---
const $b7a07a87e1dff17d$var$bindEvent = (config, element, context)=>{
    const on = config.on;
    const ref = element.__ref;
    if (!ref.__fetchListeners) ref.__fetchListeners = [];
    const runner = config.__runner || $b7a07a87e1dff17d$var$runFetch;
    if (on === 'submit') {
        const handler = (e)=>{
            e.preventDefault();
            runner(config, element, context);
        };
        const node = element.node;
        if (node) {
            node.addEventListener('submit', handler);
            ref.__fetchListeners.push(()=>node.removeEventListener('submit', handler));
        }
    } else if (on === 'click') {
        const handler = ()=>runner(config, element, context);
        const node = element.node;
        if (node) {
            node.addEventListener('click', handler);
            ref.__fetchListeners.push(()=>node.removeEventListener('click', handler));
        }
    } else if (on === 'stateChange') ref.__fetchOnStateChange = ()=>runner(config, element, context);
};
// --- Refetch interval / focus / reconnect binding ---
const $b7a07a87e1dff17d$var$bindAutoRefetch = (config, element, context)=>{
    const ref = element.__ref;
    if (!ref.__fetchCleanups) ref.__fetchCleanups = [];
    $b7a07a87e1dff17d$var$attachGlobalListeners();
    // refetchInterval
    const interval = config.refetchInterval;
    if (interval) {
        const ms = typeof interval === 'number' ? interval : $b7a07a87e1dff17d$export$ecae829bb3747ea6(interval);
        if (ms > 0) {
            const timer = setInterval(()=>{
                // Only refetch if visible (unless refetchIntervalInBackground is set)
                if (config.refetchIntervalInBackground || typeof document === 'undefined' || document.visibilityState === 'visible') $b7a07a87e1dff17d$var$runFetch(config, element, context, {
                    force: true
                });
            }, ms);
            ref.__fetchCleanups.push(()=>clearInterval(timer));
        }
    }
    // refetchOnWindowFocus
    if (config.refetchOnWindowFocus !== false) {
        const onFocus = ()=>{
            const lang = $b7a07a87e1dff17d$var$resolveLanguage(element, context);
            const cacheKey = $b7a07a87e1dff17d$var$buildCacheKey(config, lang);
            const entry = $b7a07a87e1dff17d$var$getCacheEntry(cacheKey);
            const cacheConfig = $b7a07a87e1dff17d$var$parseCacheConfig(config.cache);
            if (!entry || entry.stale || Date.now() - entry.time > (cacheConfig?.staleTime || 0)) $b7a07a87e1dff17d$var$runFetch(config, element, context, {
                force: true
            });
        };
        $b7a07a87e1dff17d$var$globalListeners.focus.add(onFocus);
        ref.__fetchCleanups.push(()=>$b7a07a87e1dff17d$var$globalListeners.focus.delete(onFocus));
    }
    // refetchOnReconnect
    if (config.refetchOnReconnect !== false) {
        const onOnline = ()=>$b7a07a87e1dff17d$var$runFetch(config, element, context, {
                force: true
            });
        $b7a07a87e1dff17d$var$globalListeners.online.add(onOnline);
        ref.__fetchCleanups.push(()=>$b7a07a87e1dff17d$var$globalListeners.online.delete(onOnline));
    }
};
// --- Optimistic updates ---
const $b7a07a87e1dff17d$var$applyOptimisticUpdate = (element, config, mutationData)=>{
    if (!config.optimistic) return null;
    const ref = element.__ref;
    const stateKey = config.as;
    // Snapshot current state for rollback
    const snapshot = element.state?.parse ? element.state.parse() : (0, $fX7ii.isObject)(element.state) ? {
        ...element.state
    } : element.state;
    ref.__optimisticSnapshot = snapshot;
    const optimisticData = (0, $fX7ii.isFunction)(config.optimistic) ? config.optimistic(mutationData, snapshot, element) : config.optimistic;
    if (optimisticData !== undefined) $b7a07a87e1dff17d$var$updateElementState(element, optimisticData, stateKey);
    return snapshot;
};
const $b7a07a87e1dff17d$var$rollbackOptimistic = (element, config)=>{
    const ref = element.__ref;
    const snapshot = ref.__optimisticSnapshot;
    if (snapshot !== undefined) {
        $b7a07a87e1dff17d$var$updateElementState(element, snapshot, config.as);
        delete ref.__optimisticSnapshot;
    }
};
// --- Mutation runner (insert/update/delete with optimistic + invalidation) ---
const $b7a07a87e1dff17d$var$runMutation = async (config, element, context)=>{
    const db = context?.fetch;
    if (!db) return;
    const adapter = await $b7a07a87e1dff17d$var$resolveAdapter(db, context);
    if (!adapter) return;
    const ref = element.__ref;
    const { method: method, from: from, fields: fields, transform: transform, as: stateKey, on: trigger, auth: auth, headers: headers, baseUrl: baseUrl, invalidates: invalidates, optimistic: optimistic, onMutate: onMutate, onSuccess: onSuccess, onError: onError, onSettled: onSettled } = config;
    // Collect mutation data
    let mutationData;
    if (fields === true || trigger === 'submit') mutationData = $b7a07a87e1dff17d$var$collectFormData(element);
    else if ((0, $fX7ii.isArray)(fields)) {
        const formData = $b7a07a87e1dff17d$var$collectFormData(element);
        mutationData = {};
        for (const f of fields)mutationData[f] = formData[f];
    } else if (element.state?.parse) mutationData = element.state.parse();
    else if ((0, $fX7ii.isObject)(element.state)) mutationData = {
        ...element.state
    };
    if (transform) mutationData = transform(mutationData, element, element.state);
    // onMutate callback (runs before fetch)
    if ((0, $fX7ii.isFunction)(onMutate)) onMutate(mutationData, element, element.state);
    // Apply optimistic update
    const snapshot = optimistic ? $b7a07a87e1dff17d$var$applyOptimisticUpdate(element, config, mutationData) : null;
    ref.__fetching = true;
    $b7a07a87e1dff17d$var$setFetchStatus(element, {
        isFetching: true,
        isLoading: false,
        isStale: false,
        isSuccess: false,
        error: null,
        status: 'pending',
        fetchStatus: 'fetching'
    });
    $b7a07a87e1dff17d$var$triggerCallback(element, 'onFetchStart');
    $b7a07a87e1dff17d$var$triggerConfigCallback(config, element, 'onFetchStart');
    const _emitNet = context?.analyze?.emitNetwork;
    const __analyzeStart = _emitNet ? typeof performance !== 'undefined' ? performance.now() : Date.now() : 0;
    if (_emitNet) _emitNet({
        phase: 'start',
        mode: 'mutation',
        from: from,
        method: method
    });
    try {
        if (auth !== false && adapter.auth !== false && adapter.getSession) {
            const session = await adapter.getSession();
            if (auth === true && !session) {
                if (snapshot !== undefined) $b7a07a87e1dff17d$var$rollbackOptimistic(element, config);
                const err = {
                    message: 'Not authenticated'
                };
                $b7a07a87e1dff17d$var$triggerCallback(element, 'onFetchError', err);
                $b7a07a87e1dff17d$var$triggerConfigCallback(config, element, 'onFetchError', err);
                return;
            }
        }
        const fn = adapter[method];
        if (!(0, $fX7ii.isFunction)(fn)) return;
        const request = {
            from: from,
            data: mutationData,
            headers: headers,
            baseUrl: baseUrl
        };
        if (config.params) request.params = $b7a07a87e1dff17d$var$resolveParams(config.params, element, context);
        // Inject language into mutation request headers
        const lang = $b7a07a87e1dff17d$var$resolveLanguage(element, context);
        if (lang) request.headers = {
            ...request.headers,
            'Accept-Language': lang
        };
        const retryConfig = $b7a07a87e1dff17d$var$resolveRetryConfig(config);
        const result = await $b7a07a87e1dff17d$var$withRetry(()=>fn(request), retryConfig);
        const { data: data, error: error } = result || {};
        if (error) {
            if (snapshot !== undefined) $b7a07a87e1dff17d$var$rollbackOptimistic(element, config);
            $b7a07a87e1dff17d$var$setFetchStatus(element, {
                isFetching: false,
                isLoading: false,
                isStale: false,
                isSuccess: false,
                error: error,
                status: 'error',
                fetchStatus: 'idle'
            });
            $b7a07a87e1dff17d$var$triggerCallback(element, 'onFetchError', error);
            if ((0, $fX7ii.isFunction)(onError)) onError(error, mutationData, element);
            if ((0, $fX7ii.isFunction)(onSettled)) onSettled(null, error, mutationData, element);
            if (_emitNet) _emitNet({
                phase: 'error',
                mode: 'mutation',
                from: from,
                method: method,
                error: error.message || String(error),
                durationMs: (typeof performance !== 'undefined' ? performance.now() : Date.now()) - __analyzeStart
            });
            return;
        }
        delete ref.__optimisticSnapshot;
        if (data !== undefined) {
            const finalData = stateKey ? {
                [stateKey]: data
            } : data;
            if (element.state?.update) element.state.update(finalData, {
                preventFetch: true
            });
        }
        $b7a07a87e1dff17d$var$setFetchStatus(element, {
            isFetching: false,
            isLoading: false,
            isStale: false,
            isSuccess: true,
            error: null,
            status: 'success',
            fetchStatus: 'idle'
        });
        $b7a07a87e1dff17d$var$triggerCallback(element, 'onFetchComplete', data);
        $b7a07a87e1dff17d$var$triggerConfigCallback(config, element, 'onFetchComplete', data);
        if ((0, $fX7ii.isFunction)(onSuccess)) onSuccess(data, mutationData, element);
        if ((0, $fX7ii.isFunction)(onSettled)) onSettled(data, null, mutationData, element);
        if (_emitNet) _emitNet({
            phase: 'success',
            mode: 'mutation',
            ok: true,
            from: from,
            method: method,
            durationMs: (typeof performance !== 'undefined' ? performance.now() : Date.now()) - __analyzeStart
        });
        // Invalidate related queries
        if (invalidates) {
            const keys = (0, $fX7ii.isArray)(invalidates) ? invalidates : [
                invalidates
            ];
            for (const k of keys)if (k === true || k === '*') {
                // Invalidate all queries matching this `from`
                for (const [ck] of $b7a07a87e1dff17d$var$cacheStore)if (ck.startsWith(from + ':')) $b7a07a87e1dff17d$var$invalidateCache(ck);
            } else $b7a07a87e1dff17d$var$invalidateCache(k);
        }
    } catch (e) {
        if (snapshot !== undefined) $b7a07a87e1dff17d$var$rollbackOptimistic(element, config);
        $b7a07a87e1dff17d$var$setFetchStatus(element, {
            isFetching: false,
            isLoading: false,
            isStale: false,
            isSuccess: false,
            error: e,
            status: 'error',
            fetchStatus: 'idle'
        });
        $b7a07a87e1dff17d$var$triggerCallback(element, 'onFetchError', e);
        $b7a07a87e1dff17d$var$triggerConfigCallback(config, element, 'onFetchError', e);
        if ((0, $fX7ii.isFunction)(onError)) onError(e, mutationData, element);
        if ((0, $fX7ii.isFunction)(onSettled)) onSettled(null, e, mutationData, element);
        if (_emitNet) _emitNet({
            phase: 'error',
            mode: 'mutation',
            from: from,
            method: method,
            error: e.message || String(e),
            durationMs: (typeof performance !== 'undefined' ? performance.now() : Date.now()) - __analyzeStart
        });
    } finally{
        ref.__fetching = false;
    }
};

const $b7a07a87e1dff17d$export$8ced815accfd9df6 = (param, element, state, context)=>{
    if (!param) return;
    const db = context?.fetch;
    if (!db) return;
    const fetchProp = (0, $bmfNh.exec)(param, element);
    if (!fetchProp) return;
    const configs = (0, $fX7ii.isArray)(fetchProp) ? fetchProp.map((c)=>$b7a07a87e1dff17d$var$resolveFetchConfig((0, $bmfNh.exec)(c, element), element)).filter(Boolean) : [
        $b7a07a87e1dff17d$var$resolveFetchConfig(fetchProp, element)
    ].filter(Boolean);
    for (const config of configs){
        const isMutation = config.method === 'insert' || config.method === 'update' || config.method === 'upsert' || config.method === 'delete';
        const runner = isMutation ? $b7a07a87e1dff17d$var$runMutation : $b7a07a87e1dff17d$var$runFetch;
        if (config.on === 'create') runner(config, element, context);
        else Promise.resolve().then(function() {
            return (parcelRequire("1IE9l"));
        }).then((res)=>{
            $b7a07a87e1dff17d$var$bindEvent({
                ...config,
                __runner: runner
            }, element, context);
        });
        // Bind auto-refetch for queries
        if (!isMutation && config.on === 'create') {
            if (config.refetchInterval || config.refetchOnWindowFocus !== false || config.refetchOnReconnect !== false) $b7a07a87e1dff17d$var$bindAutoRefetch(config, element, context);
        }
    }
    // Expose imperative methods on element
    const ref = element.__ref;
    ref.refetch = (opts)=>{
        for (const config of configs)$b7a07a87e1dff17d$var$runFetch(config, element, context, {
            force: true,
            ...opts
        });
    };
    ref.fetchNextPage = ()=>{
        const config = configs[0];
        if (!config || !config.infinite) return;
        const nextParam = ref.__nextPageParam;
        if (nextParam == null) return;
        const nextConfig = {
            ...config,
            cursor: nextParam
        };
        $b7a07a87e1dff17d$var$runFetch(nextConfig, element, context, {
            direction: 'next',
            force: true
        });
    };
    ref.fetchPreviousPage = ()=>{
        const config = configs[0];
        if (!config || !config.infinite) return;
        const prevParam = ref.__prevPageParam;
        if (prevParam == null) return;
        const prevConfig = {
            ...config,
            cursor: prevParam
        };
        $b7a07a87e1dff17d$var$runFetch(prevConfig, element, context, {
            direction: 'previous',
            force: true
        });
    };
};
const $b7a07a87e1dff17d$export$7c07b633a151f9c5 = {
    invalidateQueries: (keyOrPattern)=>{
        if (!keyOrPattern) {
            $b7a07a87e1dff17d$var$invalidateCache();
            return;
        }
        if ((0, $fX7ii.isString)(keyOrPattern)) {
            for (const [key] of $b7a07a87e1dff17d$var$cacheStore)if (key.startsWith(keyOrPattern) || key.includes(keyOrPattern)) $b7a07a87e1dff17d$var$invalidateCache(key);
        } else if ((0, $fX7ii.isArray)(keyOrPattern)) {
            const pattern = keyOrPattern.join(':');
            for (const [key] of $b7a07a87e1dff17d$var$cacheStore)if (key.includes(pattern)) $b7a07a87e1dff17d$var$invalidateCache(key);
        }
    },
    removeQueries: (keyOrPattern)=>{
        if (!keyOrPattern) {
            $b7a07a87e1dff17d$var$removeCache();
            return;
        }
        if ((0, $fX7ii.isString)(keyOrPattern)) {
            for (const [key] of $b7a07a87e1dff17d$var$cacheStore)if (key.startsWith(keyOrPattern) || key.includes(keyOrPattern)) $b7a07a87e1dff17d$var$removeCache(key);
        }
    },
    getQueryData: (key)=>{
        const entry = $b7a07a87e1dff17d$var$getCacheEntry(key);
        return entry?.data ?? undefined;
    },
    setQueryData: (key, updater)=>{
        const existing = $b7a07a87e1dff17d$var$getCacheEntry(key);
        const data = (0, $fX7ii.isFunction)(updater) ? updater(existing?.data) : updater;
        $b7a07a87e1dff17d$var$setCacheEntry(key, data, null);
    },
    prefetchQuery: async (config, context)=>{
        const db = context?.fetch;
        if (!db) return;
        const adapter = await $b7a07a87e1dff17d$var$resolveAdapter(db, context);
        if (!adapter) return;
        const cacheKey = config.cache?.key || `${config.from}:${config.method || 'select'}:${JSON.stringify(config.params || '')}`;
        const fn = adapter[config.method || 'select'];
        if (!(0, $fX7ii.isFunction)(fn)) return;
        const result = await fn({
            from: config.from,
            params: config.params,
            limit: config.limit,
            offset: config.offset,
            order: config.order,
            single: config.single
        });
        if (result?.data !== undefined && !result?.error) {
            const entry = $b7a07a87e1dff17d$var$setCacheEntry(cacheKey, result.data, null);
            entry.gcTime = $b7a07a87e1dff17d$var$parseCacheConfig(config.cache)?.gcTime || 300000;
        }
        return result;
    },
    getCache: ()=>$b7a07a87e1dff17d$var$cacheStore,
    clear: ()=>$b7a07a87e1dff17d$var$removeCache(),
    // Drop every cache entry whose lang suffix isn't `keepLang`.
    // Cache keys are of the form `${from}:${method}:${params}[:lang]` — entries
    // without a lang suffix are kept (they were inserted before lang gating
    // was active). Used by setLang() to evict stale-language entries while
    // keeping the new active lang's entries warm.
    //
    // The English-fallback policy: callers typically pass `'en'` as keepLang
    // so English bundle stays cached even after switching to e.g. French,
    // since the page's English fallback may still render where French data
    // hasn't loaded yet.
    dropNonLang: (keepLang)=>{
        if (!keepLang) return;
        const keepSuffix = `:${keepLang}`;
        for (const [key] of $b7a07a87e1dff17d$var$cacheStore){
            // Entry without any lang suffix: presence of `:` in middle but not
            // matching any 2-3 letter ISO suffix at the end. Conservative: keep
            // entries whose tail doesn't look like `:xx` or `:xxx`.
            const tailMatch = key.match(/:([a-z]{2,3})$/i);
            if (!tailMatch) continue; // no lang suffix → keep
            if (key.endsWith(keepSuffix)) continue; // matches keepLang → keep
            $b7a07a87e1dff17d$var$removeCache(key);
        }
    }
};
const $b7a07a87e1dff17d$export$3e7aa3050ca4b6c = {
    name: 'fetch',
    // Hook into element creation to auto-execute fetch configs
    create (element) {
        const fetchProp = element.fetch;
        if (!fetchProp) return;
        // Clear stale in-flight queries on root element creation
        if (!element.parent) $b7a07a87e1dff17d$var$activeQueries.clear();
        $b7a07a87e1dff17d$export$8ced815accfd9df6(fetchProp, element, element.state, element.context);
    }
};
var $b7a07a87e1dff17d$export$2e2bcd8739ae039 = $b7a07a87e1dff17d$export$8ced815accfd9df6;

});
parcelRegister("2oe0q", function(module, exports) {

var $60FHT = parcelRequire("60FHT");

var $kt4aQ = parcelRequire("kt4aQ");

var $fX7ii = parcelRequire("fX7ii");

var $bmfNh = parcelRequire("bmfNh");

var $aQqva = parcelRequire("aQqva");

var $j1b7T = parcelRequire("j1b7T");

var $elDKY = parcelRequire("elDKY");

var $cXVIF = parcelRequire("cXVIF");

var $8rNeH = parcelRequire("8rNeH");

var $1zeno = parcelRequire("1zeno");

var $erBZm = parcelRequire("erBZm");

var $hO2Rt = parcelRequire("hO2Rt");

var $6DXv0 = parcelRequire("6DXv0");

var $FzLlj = parcelRequire("FzLlj");

var $5E2zl = parcelRequire("5E2zl");

var $1e3EP = parcelRequire("1e3EP");

var $e4kX4 = parcelRequire("e4kX4");

var $e2xa8 = parcelRequire("e2xa8");

var $350cP = parcelRequire("350cP");

var $6JufH = parcelRequire("6JufH");

var $c5dHw = parcelRequire("c5dHw");

var $l1svM = parcelRequire("l1svM");

var $2I7Zd = parcelRequire("2I7Zd");

var $9VZBt = parcelRequire("9VZBt");

var $7JFRj = parcelRequire("7JFRj");

var $dvkIB = parcelRequire("dvkIB");

var $bbZ29 = parcelRequire("bbZ29");

var $fAw5d = parcelRequire("fAw5d");

var $buium = parcelRequire("buium");

var $iM2sP = parcelRequire("iM2sP");

var $eI8bb = parcelRequire("eI8bb");

var $4YHTc = parcelRequire("4YHTc");

var $dW6MF = parcelRequire("dW6MF");

var $dNcID = parcelRequire("dNcID");

var $bSS0n = parcelRequire("bSS0n");

var $fuahe = parcelRequire("fuahe");

var $36hJi = parcelRequire("36hJi");
'use strict';
$parcel$exportWildcard(module.exports, $60FHT);
$parcel$exportWildcard(module.exports, $kt4aQ);
$parcel$exportWildcard(module.exports, $fX7ii);
$parcel$exportWildcard(module.exports, $bmfNh);
$parcel$exportWildcard(module.exports, $aQqva);
$parcel$exportWildcard(module.exports, $j1b7T);
$parcel$exportWildcard(module.exports, $elDKY);
$parcel$exportWildcard(module.exports, $cXVIF);
$parcel$exportWildcard(module.exports, $8rNeH);
$parcel$exportWildcard(module.exports, $1zeno);
$parcel$exportWildcard(module.exports, $erBZm);
$parcel$exportWildcard(module.exports, $hO2Rt);
$parcel$exportWildcard(module.exports, $6DXv0);
$parcel$exportWildcard(module.exports, $FzLlj);
$parcel$exportWildcard(module.exports, $5E2zl);
$parcel$exportWildcard(module.exports, $1e3EP);
$parcel$exportWildcard(module.exports, $e4kX4);
$parcel$exportWildcard(module.exports, $e2xa8);
$parcel$exportWildcard(module.exports, $350cP);
$parcel$exportWildcard(module.exports, $6JufH);
$parcel$exportWildcard(module.exports, $c5dHw);
$parcel$exportWildcard(module.exports, $l1svM);
$parcel$exportWildcard(module.exports, $2I7Zd);
$parcel$exportWildcard(module.exports, $9VZBt);
$parcel$exportWildcard(module.exports, $7JFRj);
$parcel$exportWildcard(module.exports, $dvkIB);
$parcel$exportWildcard(module.exports, $bbZ29);
$parcel$exportWildcard(module.exports, $fAw5d);
$parcel$exportWildcard(module.exports, $buium);
$parcel$exportWildcard(module.exports, $iM2sP);
$parcel$exportWildcard(module.exports, $eI8bb);
$parcel$exportWildcard(module.exports, $4YHTc);
$parcel$exportWildcard(module.exports, $dW6MF);
$parcel$exportWildcard(module.exports, $dNcID);
$parcel$exportWildcard(module.exports, $bSS0n);
$parcel$exportWildcard(module.exports, $fuahe);
$parcel$exportWildcard(module.exports, $36hJi);

});
parcelRegister("60FHT", function(module, exports) {

$parcel$export(module.exports, "generateKey", () => $460318500871e88b$export$3a7728e868aa3ebd);
$parcel$export(module.exports, "createSnapshotId", () => $460318500871e88b$export$6f8fb29fbb5b5b63);
$parcel$export(module.exports, "createKey", () => $460318500871e88b$export$e2280c1995141b13);

var $bmfNh = parcelRequire("bmfNh");
'use strict';
const $460318500871e88b$export$3a7728e868aa3ebd = function() {
    let index = 0;
    function newId() {
        index++;
        return index;
    }
    return newId;
}();
const $460318500871e88b$export$6f8fb29fbb5b5b63 = $460318500871e88b$export$3a7728e868aa3ebd;
const $460318500871e88b$export$e2280c1995141b13 = (element, parent, key)=>{
    return ((0, $bmfNh.exec)(key, element) || key || element.key || $460318500871e88b$export$3a7728e868aa3ebd()).toString();
};

});
parcelRegister("bmfNh", function(module, exports) {

$parcel$export(module.exports, "exec", () => $844e001b23120d52$export$78e3044358792147);
$parcel$export(module.exports, "map", () => $844e001b23120d52$export$871de8747c9eaa88);
$parcel$export(module.exports, "merge", () => $844e001b23120d52$export$4950aa0f605343fb);
$parcel$export(module.exports, "deepMerge", () => $844e001b23120d52$export$6969335ea1e4e77c);
$parcel$export(module.exports, "clone", () => $844e001b23120d52$export$9cd59f9826255e47);
$parcel$export(module.exports, "deepClone", () => $844e001b23120d52$export$b7d58db314e0ac27);
$parcel$export(module.exports, "deepStringifyFunctions", () => $844e001b23120d52$export$a1b87aa71164cd70);
$parcel$export(module.exports, "objectToString", () => $844e001b23120d52$export$830c053460e5ddf6);
$parcel$export(module.exports, "hasFunction", () => $844e001b23120d52$export$6b15be743c368efa);
$parcel$export(module.exports, "deepDestringifyFunctions", () => $844e001b23120d52$export$4db1ad98392a09bb);
$parcel$export(module.exports, "destringifyGlobalScope", () => $844e001b23120d52$export$9cab894253c5c18e);
$parcel$export(module.exports, "stringToObject", () => $844e001b23120d52$export$a6c9a3ccba61521e);
$parcel$export(module.exports, "hasOwnProperty", () => $844e001b23120d52$export$5a15a386532a5ea4);
$parcel$export(module.exports, "isEmpty", () => $844e001b23120d52$export$dd1bc94b04021eeb);
$parcel$export(module.exports, "isEmptyObject", () => $844e001b23120d52$export$83b788b1a3698c03);
$parcel$export(module.exports, "makeObjectWithoutPrototype", () => $844e001b23120d52$export$d6d64087a1bd2d);
$parcel$export(module.exports, "overwrite", () => $844e001b23120d52$export$d3305692eb3e9a81);
$parcel$export(module.exports, "overwriteShallow", () => $844e001b23120d52$export$1c07155dfdd98f41);
$parcel$export(module.exports, "overwriteDeep", () => $844e001b23120d52$export$f0b277b530b4fffd);
$parcel$export(module.exports, "isEqualDeep", () => $844e001b23120d52$export$683c7d6569f339f4);
$parcel$export(module.exports, "deepContains", () => $844e001b23120d52$export$273cb3019e2f952c);
$parcel$export(module.exports, "removeFromObject", () => $844e001b23120d52$export$bdd7fc6cf95d63b);
$parcel$export(module.exports, "createObjectWithoutPrototype", () => $844e001b23120d52$export$c2a75c92f46bb782);
$parcel$export(module.exports, "createNestedObject", () => $844e001b23120d52$export$a9706fb8026b394a);
$parcel$export(module.exports, "removeNestedKeyByPath", () => $844e001b23120d52$export$33f72cab96f733af);
$parcel$export(module.exports, "setInObjectByPath", () => $844e001b23120d52$export$9c3074cc3d55a00f);
$parcel$export(module.exports, "getInObjectByPath", () => $844e001b23120d52$export$12bc5d09cd221028);
$parcel$export(module.exports, "detectInfiniteLoop", () => $844e001b23120d52$export$ad59efee0c629be2);
$parcel$export(module.exports, "isCyclic", () => $844e001b23120d52$export$831fcc412582ee80);
$parcel$export(module.exports, "excludeKeysFromObject", () => $844e001b23120d52$export$efc42697dda340d9);

var $erBZm = parcelRequire("erBZm");

var $fX7ii = parcelRequire("fX7ii");

var $j1b7T = parcelRequire("j1b7T");

var $1zeno = parcelRequire("1zeno");

var $elDKY = parcelRequire("elDKY");

var $350cP = parcelRequire("350cP");
'use strict';
const $844e001b23120d52$var$ENV = "upcoming";
const $844e001b23120d52$var$_startsWithDunder = (e)=>e.charCodeAt(0) === 95 && e.charCodeAt(1) === 95;
const $844e001b23120d52$export$78e3044358792147 = (param, element, state, context)=>{
    if ((0, $fX7ii.isFunction)(param)) {
        if (!element) return;
        if (typeof param.call !== 'function') return param;
        return param.call(element, element, state || element.state, context || element.context);
    }
    // If param is a non-function value and the context has handler-resolving
    // plugins (e.g. funcql), try to resolve it into a callable function.
    // This enables funcql schemas as property values (text, if, style, etc.).
    // Only attempt for array/object params that could be schemas — skip
    // primitives and DOM nodes to avoid overhead on normal DOMQL values.
    if (param != null && element?.context?.plugins && ((0, $fX7ii.isArray)(param) || (0, $fX7ii.isObject)(param) && !(0, $elDKY.isDOMNode)(param))) {
        const plugins = element.context.plugins;
        for (const plugin of plugins)if (plugin.resolveHandler) {
            const resolved = plugin.resolveHandler(param, element);
            if (typeof resolved === 'function') return $844e001b23120d52$export$78e3044358792147(resolved, element, state, context);
        }
    }
    return param;
};
const $844e001b23120d52$export$871de8747c9eaa88 = (obj, extention, element)=>{
    for(const e in extention)obj[e] = $844e001b23120d52$export$78e3044358792147(extention[e], element);
};
const $844e001b23120d52$export$4950aa0f605343fb = (element, obj, excludeFrom = [])=>{
    const useSet = excludeFrom instanceof Set;
    for(const e in obj){
        if (!Object.prototype.hasOwnProperty.call(obj, e)) continue;
        if ($844e001b23120d52$var$_startsWithDunder(e)) continue;
        if (useSet ? excludeFrom.has(e) : excludeFrom.includes(e)) continue;
        if (element[e] === undefined) element[e] = obj[e];
    }
    return element;
};
const $844e001b23120d52$export$6969335ea1e4e77c = (element, extend, excludeFrom = (0, $350cP.METHODS_EXL))=>{
    return $844e001b23120d52$var$_deepMerge(element, extend, excludeFrom, null);
};
// Internal worker that carries an ancestors stack to break cycles. The stack
// is allocated lazily on first recursion so non-cyclic merges have zero
// overhead. We track only the (element, extend) pairs in the *current
// descent* — once a pair pops off the stack we forget it, so legitimate
// reuse of shared extend objects across siblings is unaffected.
const $844e001b23120d52$var$_deepMerge = (element, extend, excludeFrom, ancestors)=>{
    if (element === extend) return element;
    if (ancestors) for(let i = 0; i < ancestors.length; i += 2){
        if (ancestors[i] === element && ancestors[i + 1] === extend) return element;
    }
    const useSet = excludeFrom instanceof Set;
    for(const e in extend){
        if (!Object.prototype.hasOwnProperty.call(extend, e)) continue;
        if ($844e001b23120d52$var$_startsWithDunder(e)) continue;
        if (useSet ? excludeFrom.has(e) : excludeFrom.includes(e)) continue;
        const elementProp = element[e];
        const extendProp = extend[e];
        if ((0, $fX7ii.isObjectLike)(elementProp) && (0, $fX7ii.isObjectLike)(extendProp)) {
            const stack = ancestors || [];
            stack.push(element, extend);
            $844e001b23120d52$var$_deepMerge(elementProp, extendProp, excludeFrom, stack);
            stack.length -= 2;
        } else if (elementProp === undefined) element[e] = extendProp;
    }
    return element;
};
const $844e001b23120d52$export$9cd59f9826255e47 = (obj, excludeFrom = [])=>{
    const useSet = excludeFrom instanceof Set;
    const o = {};
    for(const prop in obj){
        if (!Object.prototype.hasOwnProperty.call(obj, prop)) continue;
        if ($844e001b23120d52$var$_startsWithDunder(prop)) continue;
        if (useSet ? excludeFrom.has(prop) : excludeFrom.includes(prop)) continue;
        o[prop] = obj[prop];
    }
    return o;
};
const $844e001b23120d52$export$b7d58db314e0ac27 = (obj, options = {})=>{
    const { exclude: exclude = [], cleanUndefined: cleanUndefined = false, cleanNull: cleanNull = false, window: targetWindow, visited: visited = new WeakMap(), handleExtends: handleExtends = false } = options;
    const contentWindow = targetWindow || (0, $erBZm.window) || globalThis;
    // Handle non-object types and special cases
    if (!(0, $fX7ii.isObjectLike)(obj) || (0, $elDKY.isDOMNode)(obj)) return obj;
    // Handle circular references
    if (visited.has(obj)) return visited.get(obj);
    // Create appropriate container based on type and window context
    const isArr = (0, $fX7ii.isArray)(obj);
    const clone = isArr ? [] : {};
    // Store the clone to handle circular references
    visited.set(obj, clone);
    // Convert exclude to Set for O(1) lookups when list is non-trivial
    const excludeSet = exclude instanceof Set ? exclude : exclude.length > 3 ? new Set(exclude) : null;
    // Clone properties
    for(const key in obj){
        if (!Object.prototype.hasOwnProperty.call(obj, key)) continue;
        // Skip excluded properties
        if ($844e001b23120d52$var$_startsWithDunder(key) || key === '__proto__') continue;
        if (excludeSet ? excludeSet.has(key) : exclude.includes(key)) continue;
        const value = obj[key];
        // Skip based on cleanup options
        if (cleanUndefined && value === undefined) continue;
        if (cleanNull && value === null) continue;
        // Handle special cases
        if ((0, $elDKY.isDOMNode)(value)) {
            clone[key] = value;
            continue;
        }
        // Handle 'extends' array if enabled
        if (handleExtends && key === 'extends' && (0, $fX7ii.isArray)(value)) {
            clone[key] = (0, $j1b7T.unstackArrayOfObjects)(value, exclude);
            continue;
        }
        // Handle functions in cross-frame scenario
        // Keep original function references — DOMQL handles window/document
        // isolation via element.context, so eval'ing into iframe scope is
        // unnecessary and breaks closure-dependent functions (e.g. resolveTheme)
        if ((0, $fX7ii.isFunction)(value)) {
            clone[key] = value;
            continue;
        }
        // Recursively clone objects
        if ((0, $fX7ii.isObjectLike)(value)) clone[key] = $844e001b23120d52$export$b7d58db314e0ac27(value, {
            ...options,
            visited: visited
        });
        else clone[key] = value;
    }
    return clone;
};
const $844e001b23120d52$export$a1b87aa71164cd70 = (obj, stringified = {})=>{
    if (obj.node || obj.__ref || obj.parent || obj.__element || obj.parse) {
        (obj.__element || obj.parent?.__element).warn('Trying to clone element or state at', obj);
        obj = obj.parse?.();
    }
    for(const prop in obj){
        const objProp = obj[prop];
        if ((0, $fX7ii.isFunction)(objProp)) stringified[prop] = objProp.toString();
        else if ((0, $fX7ii.isObject)(objProp)) {
            stringified[prop] = {};
            $844e001b23120d52$export$a1b87aa71164cd70(objProp, stringified[prop]);
        } else if ((0, $fX7ii.isArray)(objProp)) {
            const arr = stringified[prop] = [];
            for(let i = 0; i < objProp.length; i++){
                const v = objProp[i];
                if ((0, $fX7ii.isObject)(v)) {
                    arr[i] = {};
                    $844e001b23120d52$export$a1b87aa71164cd70(v, arr[i]);
                } else if ((0, $fX7ii.isFunction)(v)) arr[i] = v.toString();
                else arr[i] = v;
            }
        } else stringified[prop] = objProp;
    }
    return stringified;
};
const $844e001b23120d52$var$OBJ_TO_STR_SPECIAL_CHARS = new Set([
    '&',
    '*',
    '-',
    ':',
    '%',
    '{',
    '}',
    '>',
    '<',
    '@',
    '.',
    '/',
    '!',
    ' '
]);
const $844e001b23120d52$export$830c053460e5ddf6 = (obj = {}, indent = 0)=>{
    // Handle empty object case
    if (obj === null || typeof obj !== 'object') return String(obj);
    // Handle empty object case - avoid Object.keys allocation
    let hasKeys = false;
    for(const _k in obj){
        hasKeys = true;
        break;
    } // eslint-disable-line
    if (!hasKeys) return '{}';
    const spaces = '  '.repeat(indent);
    let str = '{\n';
    for(const key in obj){
        if (!Object.prototype.hasOwnProperty.call(obj, key)) continue;
        const value = obj[key];
        let keyNeedsQuotes = false;
        for(let i = 0; i < key.length; i++)if ($844e001b23120d52$var$OBJ_TO_STR_SPECIAL_CHARS.has(key[i])) {
            keyNeedsQuotes = true;
            break;
        }
        const stringedKey = keyNeedsQuotes ? `'${key}'` : key;
        str += `${spaces}  ${stringedKey}: `;
        if ((0, $fX7ii.isArray)(value)) {
            str += '[\n';
            for (const element of value){
                if ((0, $fX7ii.isObjectLike)(element) && element !== null) str += `${spaces}    ${$844e001b23120d52$export$830c053460e5ddf6(element, indent + 2)},\n`;
                else if ((0, $fX7ii.isString)(element)) str += `${spaces}    '${element}',\n`;
                else str += `${spaces}    ${element},\n`;
            }
            str += `${spaces}  ]`;
        } else if ((0, $fX7ii.isObjectLike)(value)) str += $844e001b23120d52$export$830c053460e5ddf6(value, indent + 1);
        else if ((0, $fX7ii.isString)(value)) str += (0, $1zeno.stringIncludesAny)(value, [
            '\n',
            "'"
        ]) ? `\`${value}\`` : `'${value}'`;
        else str += value;
        str += ',\n';
    }
    str += `${spaces}}`;
    return str;
};
const $844e001b23120d52$var$FN_PATTERNS = [
    /^\(\s*\{[^}]*\}\s*\)\s*=>/,
    /^(\([^)]*\)|[^=]*)\s*=>/,
    /^function[\s(]/,
    /^async\s+/,
    /^\(\s*function/,
    /^[a-zA-Z_$][a-zA-Z0-9_$]*\s*=>/
];
const $844e001b23120d52$var$RE_JSON_LIKE = /^["[{]/;
const $844e001b23120d52$export$6b15be743c368efa = (str)=>{
    if (!str) return false;
    const trimmed = str.trim().replace(/\n\s*/g, ' ').trim();
    if (trimmed === '' || trimmed === '{}' || trimmed === '[]') return false;
    const isFn = $844e001b23120d52$var$FN_PATTERNS.some((pattern)=>pattern.test(trimmed));
    if (!isFn) return false;
    const firstChar = trimmed.charCodeAt(0);
    const hasArrow = trimmed.includes('=>');
    // '{' = 123, '[' = 91
    if (firstChar === 123 && !hasArrow) return false // object literal
    ;
    if (firstChar === 91) return false // array literal
    ;
    if ($844e001b23120d52$var$RE_JSON_LIKE.test(trimmed) && !hasArrow) return false;
    return true;
};
// Indirect eval — invokes the global eval, which works in both browser and
// Node without depending on a `window` object. Required for SSR / Brender
// passes that hit prepareContext without a real DOM.
const $844e001b23120d52$var$__globalEval = (src)=>(0, eval)(src) // eslint-disable-line no-eval
;
const $844e001b23120d52$export$4db1ad98392a09bb = (obj, destringified = {}, opts = {
    window: {
        eval: $844e001b23120d52$var$__globalEval
    }
})=>{
    for(const prop in obj){
        if (!Object.prototype.hasOwnProperty.call(obj, prop)) continue;
        const objProp = obj[prop];
        if ((0, $fX7ii.isString)(objProp)) {
            if ($844e001b23120d52$export$6b15be743c368efa(objProp)) try {
                destringified[prop] = opts.window.eval(`(${objProp})`);
            } catch (e) {
                if (e) destringified[prop] = objProp;
            }
            else destringified[prop] = objProp;
        } else if ((0, $fX7ii.isArray)(objProp)) {
            const arr = destringified[prop] = [];
            for(let i = 0; i < objProp.length; i++){
                const arrProp = objProp[i];
                if ((0, $fX7ii.isString)(arrProp)) {
                    if ($844e001b23120d52$export$6b15be743c368efa(arrProp)) try {
                        arr.push(opts.window.eval(`(${arrProp})`));
                    } catch (e) {
                        if (e) arr.push(arrProp);
                    }
                    else arr.push(arrProp);
                } else if ((0, $fX7ii.isObject)(arrProp)) arr.push($844e001b23120d52$export$4db1ad98392a09bb(arrProp));
                else arr.push(arrProp);
            }
        } else if ((0, $fX7ii.isObject)(objProp)) destringified[prop] = $844e001b23120d52$export$4db1ad98392a09bb(objProp, destringified[prop]);
        else destringified[prop] = objProp;
    }
    return destringified;
};
const $844e001b23120d52$export$9cab894253c5c18e = (gs)=>{
    if (!gs || typeof gs !== 'object') return gs;
    // First pass: collect non-function values (constants, arrays, objects)
    const result = {};
    const fnEntries = [];
    for (const key of Object.keys(gs)){
        const val = gs[key];
        if ((0, $fX7ii.isString)(val) && $844e001b23120d52$export$6b15be743c368efa(val)) fnEntries.push([
            key,
            val
        ]);
        else result[key] = val;
    }
    // Second pass: eval functions in a closure with all values in scope
    for (const [key, fnStr] of fnEntries)try {
        // Build a closure that exposes all current globalScope values
        const varDecls = Object.keys(result).map((k)=>`var ${k} = __gs__[${JSON.stringify(k)}];`).join('\n');
        result[key] = (0, $erBZm.window).eval(`(function(__gs__) { ${varDecls}\n return (${fnStr}); })`)(result);
    } catch (e) {
        // Fallback: try plain eval
        try {
            result[key] = (0, $erBZm.window).eval(`(${fnStr})`);
        } catch (_) {
            result[key] = fnStr;
        }
    }
    return result;
};
const $844e001b23120d52$export$a6c9a3ccba61521e = (str, opts = {
    verbose: true
})=>{
    try {
        return str ? (0, $erBZm.window).eval('(' + str + ')') : {} // eslint-disable-line
        ;
    } catch (e) {
        if (opts.verbose) console.warn(e);
    }
};
const $844e001b23120d52$export$5a15a386532a5ea4 = (o, ...args)=>Object.prototype.hasOwnProperty.call(o, ...args);
const $844e001b23120d52$export$dd1bc94b04021eeb = (o)=>{
    for(const _ in o)return false // eslint-disable-line
    ;
    return true;
};
const $844e001b23120d52$export$83b788b1a3698c03 = (o)=>(0, $fX7ii.isObject)(o) && $844e001b23120d52$export$dd1bc94b04021eeb(o);
const $844e001b23120d52$export$d6d64087a1bd2d = ()=>Object.create(null);
const $844e001b23120d52$export$d3305692eb3e9a81 = (element, params, opts = {})=>{
    const excl = opts.exclude || [];
    const allowDunder = opts.preventUnderscore;
    for(const e in params){
        if (excl.includes(e) || !allowDunder && $844e001b23120d52$var$_startsWithDunder(e)) continue;
        if (params[e] !== undefined) element[e] = params[e];
    }
    return element;
};
const $844e001b23120d52$export$1c07155dfdd98f41 = (obj, params, excludeFrom = [])=>{
    const useSet = excludeFrom instanceof Set;
    for(const e in params){
        if ($844e001b23120d52$var$_startsWithDunder(e)) continue;
        if (useSet ? excludeFrom.has(e) : excludeFrom.includes(e)) continue;
        obj[e] = params[e];
    }
    return obj;
};
const $844e001b23120d52$export$f0b277b530b4fffd = (obj, params, opts = {}, visited = new WeakMap())=>{
    if (!(0, $fX7ii.isObjectLike)(obj) || !(0, $fX7ii.isObjectLike)(params) || (0, $elDKY.isDOMNode)(obj) || (0, $elDKY.isDOMNode)(params)) return params;
    if (visited.has(obj)) return visited.get(obj);
    visited.set(obj, obj);
    const excl = opts.exclude;
    const exclSet = excl ? excl instanceof Set ? excl : new Set(excl) : null;
    const forcedExclude = !opts.preventForce;
    for(const e in params){
        if (!Object.prototype.hasOwnProperty.call(params, e)) continue;
        if (exclSet && exclSet.has(e) || forcedExclude && $844e001b23120d52$var$_startsWithDunder(e)) continue;
        const objProp = obj[e];
        const paramsProp = params[e];
        if ((0, $elDKY.isDOMNode)(paramsProp)) obj[e] = paramsProp;
        else if ((0, $fX7ii.isObjectLike)(objProp) && (0, $fX7ii.isObjectLike)(paramsProp)) obj[e] = $844e001b23120d52$export$f0b277b530b4fffd(objProp, paramsProp, opts, visited);
        else if (paramsProp !== undefined) obj[e] = paramsProp;
    }
    return obj;
};
const $844e001b23120d52$export$683c7d6569f339f4 = (param, element, visited = new Set())=>{
    if (typeof param !== 'object' || typeof element !== 'object' || param === null || element === null) return param === element;
    if (visited.has(param) || visited.has(element)) return true;
    visited.add(param);
    visited.add(element);
    const keysParam = Object.keys(param);
    const keysElement = Object.keys(element);
    if (keysParam.length !== keysElement.length) return false;
    for(let i = 0; i < keysParam.length; i++){
        const key = keysParam[i];
        if (!Object.prototype.hasOwnProperty.call(element, key)) return false;
        if (!$844e001b23120d52$export$683c7d6569f339f4(param[key], element[key], visited)) return false;
    }
    return true;
};
const $844e001b23120d52$var$DEEP_CONTAINS_IGNORED = new Set([
    'node',
    '__ref'
]);
const $844e001b23120d52$export$273cb3019e2f952c = (obj1, obj2, ignoredKeys = $844e001b23120d52$var$DEEP_CONTAINS_IGNORED)=>{
    if (obj1 === obj2) return true;
    if (!(0, $fX7ii.isObjectLike)(obj1) || !(0, $fX7ii.isObjectLike)(obj2)) return obj1 === obj2;
    if ((0, $elDKY.isDOMNode)(obj1) || (0, $elDKY.isDOMNode)(obj2)) return obj1 === obj2;
    const ignored = ignoredKeys instanceof Set ? ignoredKeys : new Set(ignoredKeys);
    const visited = new WeakSet();
    function checkContains(target, source) {
        if (visited.has(source)) return true;
        visited.add(source);
        for(const key in source){
            if (!Object.prototype.hasOwnProperty.call(source, key)) continue;
            if (ignored.has(key)) continue;
            if (!Object.prototype.hasOwnProperty.call(target, key)) return false;
            const sourceValue = source[key];
            const targetValue = target[key];
            if ((0, $elDKY.isDOMNode)(sourceValue) || (0, $elDKY.isDOMNode)(targetValue)) {
                if (sourceValue !== targetValue) return false;
            } else if ((0, $fX7ii.isObjectLike)(sourceValue) && (0, $fX7ii.isObjectLike)(targetValue)) {
                if (!checkContains(targetValue, sourceValue)) return false;
            } else if (sourceValue !== targetValue) return false;
        }
        return true;
    }
    return checkContains(obj1, obj2);
};
const $844e001b23120d52$export$bdd7fc6cf95d63b = (obj, props)=>{
    if (props === undefined || props === null) return obj;
    if ((0, $fX7ii.is)(props)('string', 'number')) delete obj[props];
    else if ((0, $fX7ii.isArray)(props)) for(let i = 0; i < props.length; i++)delete obj[props[i]];
    else throw new Error('Invalid input: props must be a string or an array of strings');
    return obj;
};
const $844e001b23120d52$export$c2a75c92f46bb782 = (obj)=>{
    if (obj === null || typeof obj !== 'object') return obj;
    const newObj = Object.create(null);
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = $844e001b23120d52$export$c2a75c92f46bb782(obj[key]);
    return newObj;
};
const $844e001b23120d52$export$a9706fb8026b394a = (arr, lastValue)=>{
    if (arr.length === 0) return lastValue;
    const nestedObject = {};
    let current = nestedObject;
    for(let i = 0; i < arr.length; i++)if (i === arr.length - 1 && lastValue) current[arr[i]] = lastValue;
    else {
        current[arr[i]] = {};
        current = current[arr[i]];
    }
    return nestedObject;
};
const $844e001b23120d52$export$33f72cab96f733af = (obj, path)=>{
    if (!Array.isArray(path)) throw new Error('Path must be an array.');
    let current = obj;
    for(let i = 0; i < path.length - 1; i++){
        if (current[path[i]] === undefined) return;
        current = current[path[i]];
    }
    const lastKey = path[path.length - 1];
    if (current && Object.prototype.hasOwnProperty.call(current, lastKey)) delete current[lastKey];
};
const $844e001b23120d52$export$9c3074cc3d55a00f = (obj, path, value)=>{
    if (!Array.isArray(path)) throw new Error('Path must be an array.');
    let current = obj;
    for(let i = 0; i < path.length - 1; i++){
        if (!current[path[i]] || typeof current[path[i]] !== 'object') current[path[i]] = {};
        current = current[path[i]];
    }
    current[path[path.length - 1]] = value;
    return obj;
};
const $844e001b23120d52$export$12bc5d09cd221028 = (obj, path)=>{
    if (!Array.isArray(path)) throw new Error('Path must be an array.');
    let current = obj;
    for(let i = 0; i < path.length; i++){
        if (current === undefined || current === null) return undefined;
        current = current[path[i]];
    }
    return current;
};
const $844e001b23120d52$export$ad59efee0c629be2 = (arr)=>{
    const maxRepeats = 10;
    let pattern = [];
    let repeatCount = 0;
    for(let i = 0; i < arr.length; i++)if (pattern.length < 2) pattern.push(arr[i]);
    else {
        if (arr[i] === pattern[i % 2]) repeatCount++;
        else {
            pattern = [
                arr[i - 1],
                arr[i]
            ];
            repeatCount = 1;
        }
        if (repeatCount >= maxRepeats * 2) {
            if ($844e001b23120d52$var$ENV === 'test' || $844e001b23120d52$var$ENV === 'development') console.warn('Warning: Potential infinite loop detected due to repeated sequence:', pattern);
            return true;
        }
    }
};
const $844e001b23120d52$export$831fcc412582ee80 = (obj)=>{
    const seen = new WeakSet();
    function detect(obj) {
        if (obj && typeof obj === 'object') {
            if (seen.has(obj)) return true;
            seen.add(obj);
            for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key) && detect(obj[key])) {
                console.log(obj, 'cycle at ' + key);
                return true;
            }
        }
        return false;
    }
    return detect(obj);
};
const $844e001b23120d52$export$efc42697dda340d9 = (obj, excludedKeys)=>{
    const excluded = excludedKeys instanceof Set ? excludedKeys : new Set(excludedKeys);
    const result = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key) && !excluded.has(key)) result[key] = obj[key];
    return result;
};

});
parcelRegister("erBZm", function(module, exports) {

$parcel$export(module.exports, "global", () => $a8410e15defb18de$export$90b4d2ff6acb88af);
$parcel$export(module.exports, "self", () => $a8410e15defb18de$export$82c2e460fb230c2a);
$parcel$export(module.exports, "window", () => $a8410e15defb18de$export$8291e5b88f90ce4);
$parcel$export(module.exports, "document", () => $a8410e15defb18de$export$5a7bfc01df82fcd1);
'use strict';
const $a8410e15defb18de$export$90b4d2ff6acb88af = globalThis;
const $a8410e15defb18de$export$82c2e460fb230c2a = globalThis;
const $a8410e15defb18de$export$8291e5b88f90ce4 = globalThis;
const $a8410e15defb18de$export$5a7bfc01df82fcd1 = (undefined || $a8410e15defb18de$export$8291e5b88f90ce4).document // eslint-disable-line
;

});

parcelRegister("fX7ii", function(module, exports) {

$parcel$export(module.exports, "isObject", () => $b9d20624a474d82e$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isString", () => $b9d20624a474d82e$export$844ec244b1367d54);
$parcel$export(module.exports, "isNumber", () => $b9d20624a474d82e$export$7e4aa119212bc614);
$parcel$export(module.exports, "isFunction", () => $b9d20624a474d82e$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isBoolean", () => $b9d20624a474d82e$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "isNull", () => $b9d20624a474d82e$export$630801d484da15df);
$parcel$export(module.exports, "isArray", () => $b9d20624a474d82e$export$43bee75e5e14138e);
$parcel$export(module.exports, "isDate", () => $b9d20624a474d82e$export$871608497c498473);
$parcel$export(module.exports, "isObjectLike", () => $b9d20624a474d82e$export$c10d0b04eaa80a43);
$parcel$export(module.exports, "isDefined", () => $b9d20624a474d82e$export$4e62c701997796c1);
$parcel$export(module.exports, "isUndefined", () => $b9d20624a474d82e$export$fce6876652108ab);
$parcel$export(module.exports, "TYPES", () => $b9d20624a474d82e$export$426db7a6155b7a80);
$parcel$export(module.exports, "is", () => $b9d20624a474d82e$export$226b3eccf92c9ed9);
$parcel$export(module.exports, "isNot", () => $b9d20624a474d82e$export$612ae635ef713eeb);

var $elDKY = parcelRequire("elDKY");
'use strict';
const $b9d20624a474d82e$export$a6cdc56e425d0d0a = (arg)=>{
    if (arg === null) return false;
    return typeof arg === 'object' && arg.constructor === Object;
};
const $b9d20624a474d82e$export$844ec244b1367d54 = (arg)=>typeof arg === 'string';
const $b9d20624a474d82e$export$7e4aa119212bc614 = (arg)=>typeof arg === 'number';
const $b9d20624a474d82e$export$f6e2535fb5126e54 = (arg)=>typeof arg === 'function';
const $b9d20624a474d82e$export$f9ce7b637dfbe238 = (arg)=>arg === true || arg === false;
const $b9d20624a474d82e$export$630801d484da15df = (arg)=>arg === null;
const $b9d20624a474d82e$export$43bee75e5e14138e = (arg)=>Array.isArray(arg);
const $b9d20624a474d82e$export$871608497c498473 = (d)=>d instanceof Date;
const $b9d20624a474d82e$export$c10d0b04eaa80a43 = (arg)=>{
    if (arg === null) return false;
    // if (isArray(arg)) return false
    return typeof arg === 'object';
};
const $b9d20624a474d82e$export$4e62c701997796c1 = (arg)=>arg !== undefined;
const $b9d20624a474d82e$export$fce6876652108ab = (arg)=>arg === undefined;
const $b9d20624a474d82e$export$426db7a6155b7a80 = {
    boolean: $b9d20624a474d82e$export$f9ce7b637dfbe238,
    array: $b9d20624a474d82e$export$43bee75e5e14138e,
    object: $b9d20624a474d82e$export$a6cdc56e425d0d0a,
    string: $b9d20624a474d82e$export$844ec244b1367d54,
    date: $b9d20624a474d82e$export$871608497c498473,
    number: $b9d20624a474d82e$export$7e4aa119212bc614,
    null: $b9d20624a474d82e$export$630801d484da15df,
    function: $b9d20624a474d82e$export$f6e2535fb5126e54,
    objectLike: $b9d20624a474d82e$export$c10d0b04eaa80a43,
    node: (0, $elDKY.isNode),
    htmlElement: (0, $elDKY.isHtmlElement),
    defined: $b9d20624a474d82e$export$4e62c701997796c1
};
const $b9d20624a474d82e$export$226b3eccf92c9ed9 = (arg)=>{
    return (...args)=>args.some((val)=>$b9d20624a474d82e$export$426db7a6155b7a80[val](arg));
};
const $b9d20624a474d82e$export$612ae635ef713eeb = (arg)=>{
    return (...args)=>!args.some((val)=>$b9d20624a474d82e$export$426db7a6155b7a80[val](arg));
};

});
parcelRegister("elDKY", function(module, exports) {

$parcel$export(module.exports, "isNode", () => $a721ddad0267b895$export$8ee0fc9ee280b4ee);
$parcel$export(module.exports, "isHtmlElement", () => $a721ddad0267b895$export$211442cb55fb93);
$parcel$export(module.exports, "isDOMNode", () => $a721ddad0267b895$export$b8eb4d3b76e486c2);

var $erBZm = parcelRequire("erBZm");
'use strict';
const $a721ddad0267b895$export$8ee0fc9ee280b4ee = (obj)=>{
    return (typeof Node === 'object' ? obj instanceof (0, $erBZm.window).Node : obj && typeof obj === 'object' && typeof obj.nodeType === 'number' && typeof obj.nodeName === 'string') || false;
};
const $a721ddad0267b895$export$211442cb55fb93 = (obj)=>{
    return (typeof HTMLElement === 'object' ? obj instanceof (0, $erBZm.window).HTMLElement // DOM2
     : obj && typeof obj === 'object' && obj !== null && obj.nodeType === 1 && typeof obj.nodeName === 'string') || false;
};
const $a721ddad0267b895$export$b8eb4d3b76e486c2 = (obj)=>{
    return typeof (0, $erBZm.window) !== 'undefined' && ((0, $erBZm.window).Node && obj instanceof (0, $erBZm.window).Node || (0, $erBZm.window).Window && obj instanceof (0, $erBZm.window).Window || obj === (0, $erBZm.window) || obj === document);
};

});


parcelRegister("j1b7T", function(module, exports) {

$parcel$export(module.exports, "arrayContainsOtherArray", () => $dd86bdc4c6522c80$export$de875babef361e5d);
$parcel$export(module.exports, "getFrequencyInArray", () => $dd86bdc4c6522c80$export$2b3f138fefbb2e97);
$parcel$export(module.exports, "removeFromArray", () => $dd86bdc4c6522c80$export$8af121ae7401c4);
$parcel$export(module.exports, "swapItemsInArray", () => $dd86bdc4c6522c80$export$7e6517ca043a4c76);
$parcel$export(module.exports, "joinArrays", () => $dd86bdc4c6522c80$export$fc359ae9633f7296);
$parcel$export(module.exports, "unstackArrayOfObjects", () => $dd86bdc4c6522c80$export$86332fe6637020e6);
$parcel$export(module.exports, "cutArrayBeforeValue", () => $dd86bdc4c6522c80$export$e1c90dd42d36d8f4);
$parcel$export(module.exports, "cutArrayAfterValue", () => $dd86bdc4c6522c80$export$e9b4b966d876219d);
$parcel$export(module.exports, "removeValueFromArray", () => $dd86bdc4c6522c80$export$7268a0a9258a5297);
$parcel$export(module.exports, "removeValueFromArrayAll", () => $dd86bdc4c6522c80$export$91b305d65813a3f8);
$parcel$export(module.exports, "addItemAfterEveryElement", () => $dd86bdc4c6522c80$export$aefdd0c3cb403b10);
$parcel$export(module.exports, "reorderArrayByValues", () => $dd86bdc4c6522c80$export$402525ce1e0ae04f);
$parcel$export(module.exports, "arraysEqual", () => $dd86bdc4c6522c80$export$234180f8206db11b);
$parcel$export(module.exports, "filterArrays", () => $dd86bdc4c6522c80$export$e43a5cd3407a4eed);
$parcel$export(module.exports, "filterArraysFast", () => $dd86bdc4c6522c80$export$34fca6752b16443b);
$parcel$export(module.exports, "checkIfStringIsInArray", () => $dd86bdc4c6522c80$export$8a158988a0fbe64f);
$parcel$export(module.exports, "removeDuplicatesInArray", () => $dd86bdc4c6522c80$export$21c00e23a20acdb3);
$parcel$export(module.exports, "addProtoToArray", () => $dd86bdc4c6522c80$export$3369abff3c322c4c);

var $bmfNh = parcelRequire("bmfNh");

var $fX7ii = parcelRequire("fX7ii");
'use strict';
const $dd86bdc4c6522c80$export$de875babef361e5d = (arr1, arr2)=>{
    return arr2.every((val)=>arr1.includes(val));
};
const $dd86bdc4c6522c80$export$2b3f138fefbb2e97 = (arr, value)=>{
    let count = 0;
    for(let i = 0; i < arr.length; i++)if (arr[i] === value) count++;
    return count;
};
const $dd86bdc4c6522c80$export$8af121ae7401c4 = (arr, index)=>{
    if ((0, $fX7ii.isString)(index)) index = parseInt(index);
    if ((0, $fX7ii.isNumber)(index)) {
        if (index < 0 || index >= arr.length || isNaN(index)) throw new Error('Invalid index');
        arr.splice(index, 1);
    } else throw new Error('Invalid index');
    return arr;
};
const $dd86bdc4c6522c80$export$7e6517ca043a4c76 = (arr, i, j)=>{
    if (i < 0 || j < 0 || i >= arr.length || j >= arr.length) return;
    [arr[i], arr[j]] = [
        arr[j],
        arr[i]
    ];
};
const $dd86bdc4c6522c80$export$fc359ae9633f7296 = (...arrays)=>{
    return [].concat(...arrays);
};
const $dd86bdc4c6522c80$export$86332fe6637020e6 = (arr, exclude = [])=>{
    return arr.reduce((a, c)=>(0, $bmfNh.deepMerge)(a, (0, $bmfNh.deepClone)(c, {
            exclude: exclude
        }), exclude), {});
};
const $dd86bdc4c6522c80$export$e1c90dd42d36d8f4 = (arr, value)=>{
    const index = arr.indexOf(value);
    if (index !== -1) return arr.slice(0, index);
    return arr;
};
const $dd86bdc4c6522c80$export$e9b4b966d876219d = (arr, value)=>{
    if (!(0, $fX7ii.isArray)(arr)) return;
    const index = arr.indexOf(value);
    if (index !== -1) return arr.slice(index + 1);
    return arr;
};
const $dd86bdc4c6522c80$export$7268a0a9258a5297 = (arr, value)=>{
    const index = arr.indexOf(value);
    if (index > -1) {
        const newArray = [
            ...arr
        ];
        newArray.splice(index, 1);
        return newArray;
    }
    return arr;
};
const $dd86bdc4c6522c80$export$91b305d65813a3f8 = (arr, value)=>{
    return arr.filter((item)=>item !== value);
};
const $dd86bdc4c6522c80$export$aefdd0c3cb403b10 = (array, item)=>{
    // Create a new array to hold the result
    const result = [];
    // Loop through the input array
    for(let i = 0; i < array.length; i++){
        // Add the current element to the result array
        result.push(array[i]);
        // If it's not the last element, add the item
        if (i < array.length - 1) result.push(item);
    }
    return result;
};
const $dd86bdc4c6522c80$export$402525ce1e0ae04f = (array, valueToMove, insertBeforeValue)=>{
    const newArray = [
        ...array
    ] // Create a copy of the original array
    ;
    const indexToMove = newArray.indexOf(valueToMove) // Find the index of the value to move
    ;
    const indexToInsertBefore = newArray.indexOf(insertBeforeValue) // Find the index to insert before
    ;
    if (indexToMove !== -1 && indexToInsertBefore !== -1) {
        const removedItem = newArray.splice(indexToMove, 1)[0] // Remove the item to move
        ;
        const insertIndex = indexToInsertBefore < indexToMove ? indexToInsertBefore : indexToInsertBefore + 1 // Adjust insert index
        ;
        newArray.splice(insertIndex, 0, removedItem) // Insert the removed item before the specified value
        ;
    }
    return newArray;
};
const $dd86bdc4c6522c80$export$234180f8206db11b = (arr1, arr2)=>{
    if (arr1.length !== arr2.length) return false;
    for(let i = 0; i < arr1.length; i++){
        if (arr1[i] !== arr2[i]) return false;
    }
    return true;
};
const $dd86bdc4c6522c80$export$e43a5cd3407a4eed = (sourceArr, excludeArr)=>{
    return sourceArr.filter((item)=>!excludeArr.includes(item));
};
const $dd86bdc4c6522c80$export$34fca6752b16443b = (sourceArr, excludeArr)=>{
    const excludeSet = new Set(excludeArr);
    return sourceArr.filter((item)=>!excludeSet.has(item));
};
const $dd86bdc4c6522c80$export$8a158988a0fbe64f = (string, arr)=>{
    if (!string) return 0;
    let count = 0;
    for(let i = 0; i < arr.length; i++)if (string.includes(arr[i])) count++;
    return count;
};
const $dd86bdc4c6522c80$export$21c00e23a20acdb3 = (arr)=>{
    if (!(0, $fX7ii.isArray)(arr)) return arr;
    return [
        ...new Set(arr)
    ];
};
const $dd86bdc4c6522c80$export$3369abff3c322c4c = (state, proto)=>{
    for(const key in proto)Object.defineProperty(state, key, {
        value: proto[key],
        enumerable: false,
        configurable: true,
        writable: true // Set this to true if you want to allow changing the function later
    });
};

});

parcelRegister("1zeno", function(module, exports) {

$parcel$export(module.exports, "stringIncludesAny", () => $12443629b6126f78$export$5e62532c096c05e0);
$parcel$export(module.exports, "trimStringFromSymbols", () => $12443629b6126f78$export$4cb168a4c77839cc);
$parcel$export(module.exports, "replaceLiteralsWithObjectFields", () => $12443629b6126f78$export$7cb52b7decbd2220);
$parcel$export(module.exports, "lowercaseFirstLetter", () => $12443629b6126f78$export$f08459d87829d2ee);
$parcel$export(module.exports, "findKeyPosition", () => $12443629b6126f78$export$e03c69ff1d8102d5);
$parcel$export(module.exports, "replaceOctalEscapeSequences", () => $12443629b6126f78$export$ed5844ba7edb0ac0);
$parcel$export(module.exports, "encodeNewlines", () => $12443629b6126f78$export$56079d9b77cc851c);
$parcel$export(module.exports, "decodeNewlines", () => $12443629b6126f78$export$d5a58d286266e59c);
$parcel$export(module.exports, "customEncodeURIComponent", () => $12443629b6126f78$export$afdf0655b23d957b);
$parcel$export(module.exports, "customDecodeURIComponent", () => $12443629b6126f78$export$f0dfcf6020c0b258);
'use strict';
const $12443629b6126f78$export$5e62532c096c05e0 = (str, characters)=>{
    for (const char of characters){
        if (str.includes(char)) return true;
    }
    return false;
};
const $12443629b6126f78$export$4cb168a4c77839cc = (str, characters)=>{
    // Create a regular expression pattern to match the specified symbols
    const pattern = new RegExp(`[${characters.join('\\')}]`, 'g');
    // Replace matched symbols with an empty string
    return str.replace(pattern, '');
};
/**
 * Replaces placeholders in a string with corresponding {{ }} values from an object.
 *
 * @param {string} str - The string containing placeholders to replace.
 * @param {object} state - The object containing the values to substitute.
 * @returns {string} The modified string with placeholders replaced by values from the object.
 */ const $12443629b6126f78$var$brackRegex = {
    2: /{{\s*((?:\.\.\/)*)([\w\d.]+)\s*(?:\|\s*([\w\d.]+))?\s*}}/g,
    3: /{{{(\s*(?:\.\.\/)*)([\w\d.]+)\s*(?:\|\s*([\w\d.]+))?\s*}}}/g
};
const $12443629b6126f78$var$getNestedValue = (obj, path)=>{
    return path.split('.').reduce((acc, part)=>{
        return acc?.[part];
    }, obj);
};
function $12443629b6126f78$export$7cb52b7decbd2220(str, state, options = {}) {
    const { bracketsLength: bracketsLength = 2 } = options;
    const bracketPattern = bracketsLength === 3 ? '{{{' : '{{';
    if (!str.includes(bracketPattern)) return str;
    const reg = $12443629b6126f78$var$brackRegex[bracketsLength];
    const obj = state || this.state || {};
    const element = this;
    return str.replace(reg, (_, parentPath, variable, filter)=>{
        const key = variable.trim();
        // Pipe filter: {{ key | filterName }}
        // Always passes the raw key to the filter — the filter is responsible for resolution
        if (filter) {
            const ctx = element?.context;
            const filterFn = ctx?.functions?.[filter] || ctx?.utils?.[filter] || ctx?.methods?.[filter] || ctx?.snippets?.[filter] || element?.[filter];
            if (filterFn && typeof filterFn === 'function') try {
                return String(filterFn.call(element, key) ?? '');
            } catch (e) {
                return '';
            }
            return '';
        }
        if (parentPath) {
            const parentLevels = (parentPath.match(/\.\.\//g) || []).length;
            let parentState = obj;
            for(let i = 0; i < parentLevels; i++){
                if (!parentState || !parentState.parent) return '';
                parentState = parentState.parent;
            }
            // If the variable is 'parent', return the value property
            if (key === 'parent') return String(parentState.value ?? '');
            const value = $12443629b6126f78$var$getNestedValue(parentState, key);
            return String(value ?? '');
        } else {
            // Check state value first
            const value = $12443629b6126f78$var$getNestedValue(obj, key);
            if (value != null) return String(value);
            // Fall back to polyglot translations for current language
            const poly = element?.context?.polyglot;
            if (poly?.translations) {
                const lang = obj?.root?.lang || obj?.lang || element?.context?.state?.lang || poly.defaultLang || 'en';
                const langT = poly.translations[lang];
                if (langT) {
                    const tValue = $12443629b6126f78$var$getNestedValue(langT, key);
                    if (tValue != null && typeof tValue !== 'object') return String(tValue);
                    // Search nested sections (e.g. ka.nav.about for key 'about')
                    for(const section in langT){
                        const sectionData = langT[section];
                        if (sectionData && typeof sectionData === 'object' && !Array.isArray(sectionData)) {
                            const nested = $12443629b6126f78$var$getNestedValue(sectionData, key);
                            if (nested != null && typeof nested !== 'object') return String(nested);
                        }
                    }
                }
                // Check top-level translations
                const topValue = $12443629b6126f78$var$getNestedValue(poly.translations, key);
                if (topValue != null && typeof topValue !== 'object') return String(topValue);
            }
            return '';
        }
    });
}
const $12443629b6126f78$export$f08459d87829d2ee = (inputString)=>{
    return `${inputString.charAt(0).toLowerCase()}${inputString.slice(1)}`;
};
const $12443629b6126f78$export$e03c69ff1d8102d5 = (str, key)=>{
    const lines = str.split('\n');
    let startLineNumber = -1;
    let endLineNumber = -1;
    let startColumn = -1;
    let endColumn = -1;
    const keyPattern = new RegExp(`\\b${key}\\b\\s*:\\s*`);
    let braceCount = 0;
    let foundKey = false;
    for(let i = 0; i < lines.length; i++){
        if (keyPattern.test(lines[i]) && !foundKey) {
            foundKey = true;
            startLineNumber = i + 1;
            startColumn = lines[i].indexOf(key) + 1;
            // Check if the value is an empty object
            if (lines[i].includes('{}')) {
                endLineNumber = startLineNumber;
                endColumn = lines[i].indexOf('{}') + 3;
                break;
            }
            // Check if the value starts with '{' (object) or '[' (array)
            const line = lines[i].slice(startColumn + key.length);
            if (line.includes('{') || line.includes('[')) braceCount = 1;
            else {
                endLineNumber = i + 1;
                endColumn = lines[i].length + 1;
                break;
            }
        } else if (foundKey) {
            braceCount += (lines[i].match(/{/g) || []).length;
            braceCount += (lines[i].match(/\[/g) || []).length;
            braceCount -= (lines[i].match(/}/g) || []).length;
            braceCount -= (lines[i].match(/]/g) || []).length;
            // If braceCount is 0 and we find the end of the object/array
            if (braceCount === 0) {
                endLineNumber = i + 1;
                endColumn = lines[i].lastIndexOf('}') !== -1 ? lines[i].lastIndexOf('}') + 2 : lines[i].length + 1;
                break;
            }
        }
    }
    return {
        startColumn: startColumn,
        endColumn: endColumn,
        startLineNumber: startLineNumber,
        endLineNumber: endLineNumber
    };
};
const $12443629b6126f78$var$RE_OCTAL = /\\([0-7]{1,3})/g;
const $12443629b6126f78$export$ed5844ba7edb0ac0 = (str)=>{
    return str.replace($12443629b6126f78$var$RE_OCTAL, (_, p1)=>String.fromCharCode(parseInt(p1, 8)));
};
const $12443629b6126f78$export$56079d9b77cc851c = (str)=>{
    return str.replace(/\n/g, '/////n').replace(/`/g, '/////tilde').replace(/\$/g, '/////dlrsgn');
};
const $12443629b6126f78$export$d5a58d286266e59c = (encodedStr)=>{
    return encodedStr.replace(/\/\/\/\/\/n/g, '\n').replace(/\/\/\/\/\/tilde/g, '`').replace(/\/\/\/\/\/dlrsgn/g, '$');
};
const $12443629b6126f78$var$RE_NON_ALNUM = /[^a-zA-Z0-9\s]/g;
const $12443629b6126f78$export$afdf0655b23d957b = (str)=>{
    return str.replace($12443629b6126f78$var$RE_NON_ALNUM, (char)=>'%' + char.charCodeAt(0).toString(16).toUpperCase());
};
const $12443629b6126f78$export$f0dfcf6020c0b258 = (encodedStr)=>{
    return encodedStr.replace(/%[0-9A-Fa-f]{2}/g, (match)=>String.fromCharCode(parseInt(match.slice(1), 16)));
};

});

parcelRegister("350cP", function(module, exports) {

$parcel$export(module.exports, "DOMQ_PROPERTIES", () => $23e1ff9f6df500e1$export$c7d5e7f7bf0dae25);
$parcel$export(module.exports, "PARSED_DOMQ_PROPERTIES", () => $23e1ff9f6df500e1$export$965c4b042127881f);
$parcel$export(module.exports, "STATE_PROPERTIES", () => $23e1ff9f6df500e1$export$a42fe85dc7bbfd49);
$parcel$export(module.exports, "STATE_METHODS", () => $23e1ff9f6df500e1$export$76c843b7166304af);
$parcel$export(module.exports, "PROPS_METHODS", () => $23e1ff9f6df500e1$export$36cad52ffe088573);
$parcel$export(module.exports, "METHODS", () => $23e1ff9f6df500e1$export$f0748ddc99f937c7);
$parcel$export(module.exports, "METHODS_EXL", () => $23e1ff9f6df500e1$export$7f0c3d30e5984c9d);
$parcel$export(module.exports, "DOMQL_EVENTS", () => $23e1ff9f6df500e1$export$194d3d0e15158f0b);
'use strict';
const $23e1ff9f6df500e1$export$c7d5e7f7bf0dae25 = new Set([
    'attr',
    'style',
    'text',
    'html',
    'content',
    'data',
    'classlist',
    'state',
    'scope',
    'root',
    'deps',
    'extend',
    'extends',
    '$router',
    'routes',
    'children',
    'childExtend',
    'childExtends',
    'childExtendRecursive',
    'childExtendsRecursive',
    'props',
    'if',
    'define',
    '__name',
    '__ref',
    '__hash',
    '__text',
    'key',
    'tag',
    'query',
    'parent',
    'node',
    'variables',
    'on',
    'fetch',
    'component',
    'context',
    'preventContentUpdate',
    'preventContentRecreate'
]);
const $23e1ff9f6df500e1$export$965c4b042127881f = new Set([
    'attr',
    'style',
    'text',
    'html',
    'content',
    'data',
    'class',
    'state',
    'scope',
    'children',
    'props',
    'if',
    'key',
    'tag',
    'query',
    'on',
    'context'
]);
const $23e1ff9f6df500e1$export$a42fe85dc7bbfd49 = [
    'ref',
    'parent',
    '__element',
    '__depends',
    '__ref',
    '__children',
    'root'
];
const $23e1ff9f6df500e1$export$76c843b7166304af = new Set([
    'update',
    'parse',
    'clean',
    'create',
    'destroy',
    'add',
    'toggle',
    'remove',
    'apply',
    'set',
    'reset',
    'replace',
    'quietReplace',
    'quietUpdate',
    'applyReplace',
    'applyFunction',
    'keys',
    'values',
    'ref',
    'rootUpdate',
    'parentUpdate',
    'parent',
    '__element',
    '__depends',
    '__ref',
    '__children',
    'root',
    'setByPath',
    'setPathCollection',
    'removeByPath',
    'removePathCollection',
    'getByPath'
]);
const $23e1ff9f6df500e1$export$36cad52ffe088573 = new Set([
    'update',
    '__element'
]);
const $23e1ff9f6df500e1$export$f0748ddc99f937c7 = new Set([
    'set',
    'reset',
    'update',
    'remove',
    'updateContent',
    'removeContent',
    'lookup',
    'lookdown',
    'lookdownAll',
    'getRef',
    'getPath',
    'setNodeStyles',
    'spotByPath',
    'keys',
    'parse',
    'setProps',
    'parseDeep',
    'variables',
    'if',
    'log',
    'verbose',
    'warn',
    'error',
    'call',
    'nextElement',
    'previousElement',
    'getRootState',
    'getRoot',
    'getRootData',
    'getRootContext',
    'getContext',
    'getQuery',
    'getDB',
    'getChildren',
    'preventContentUpdate',
    'preventContentRecreate'
]);
const $23e1ff9f6df500e1$export$7f0c3d30e5984c9d = new Set([
    'node',
    'context',
    'extends',
    '__element',
    '__ref',
    ...$23e1ff9f6df500e1$export$f0748ddc99f937c7,
    ...$23e1ff9f6df500e1$export$76c843b7166304af,
    ...$23e1ff9f6df500e1$export$36cad52ffe088573
]);
const $23e1ff9f6df500e1$export$194d3d0e15158f0b = new Set([
    'init',
    'beforeClassAssign',
    'render',
    'renderRouter',
    'attachNode',
    'stateInit',
    'stateCreated',
    'beforeStateUpdate',
    'stateUpdate',
    'beforeUpdate',
    'done',
    'create',
    'complete',
    'frame',
    'update',
    'fetchError',
    'fetchComplete'
]);

});



parcelRegister("kt4aQ", function(module, exports) {

$parcel$export(module.exports, "NODE_ENV", () => $ee69c0f4889074ac$export$dd8826725fa2a3d4);
$parcel$export(module.exports, "ENV", () => $ee69c0f4889074ac$export$83401e34d5e11bf4);
$parcel$export(module.exports, "isProduction", () => $ee69c0f4889074ac$export$f15d00aa73aafac4);
$parcel$export(module.exports, "isTest", () => $ee69c0f4889074ac$export$410cbc2864fa25b5);
$parcel$export(module.exports, "isTesting", () => $ee69c0f4889074ac$export$9592e006a670b581);
$parcel$export(module.exports, "isStaging", () => $ee69c0f4889074ac$export$23da1d24a38b0bde);
$parcel$export(module.exports, "isLocal", () => $ee69c0f4889074ac$export$6dd1bbd39f571125);
$parcel$export(module.exports, "isDevelopment", () => $ee69c0f4889074ac$export$df77466336fe5355);
$parcel$export(module.exports, "getNev", () => $ee69c0f4889074ac$export$d84272657cb7c466);
$parcel$export(module.exports, "isNotProduction", () => $ee69c0f4889074ac$export$eda5083784a7e709);
'use strict';
const $ee69c0f4889074ac$export$dd8826725fa2a3d4 = "upcoming";
const $ee69c0f4889074ac$export$83401e34d5e11bf4 = $ee69c0f4889074ac$export$dd8826725fa2a3d4;
const $ee69c0f4889074ac$export$f15d00aa73aafac4 = (env = $ee69c0f4889074ac$export$dd8826725fa2a3d4)=>env === 'production';
const $ee69c0f4889074ac$export$410cbc2864fa25b5 = (env = $ee69c0f4889074ac$export$dd8826725fa2a3d4)=>env === 'testing' || env === 'test';
const $ee69c0f4889074ac$export$9592e006a670b581 = $ee69c0f4889074ac$export$410cbc2864fa25b5;
const $ee69c0f4889074ac$export$23da1d24a38b0bde = (env = $ee69c0f4889074ac$export$dd8826725fa2a3d4)=>env === 'staging';
const $ee69c0f4889074ac$export$6dd1bbd39f571125 = (env = $ee69c0f4889074ac$export$dd8826725fa2a3d4)=>env === 'local';
const $ee69c0f4889074ac$export$df77466336fe5355 = (env = $ee69c0f4889074ac$export$dd8826725fa2a3d4)=>env === 'development' || env === 'dev' || env === 'local';
const $ee69c0f4889074ac$export$d84272657cb7c466 = (key, env = $ee69c0f4889074ac$export$dd8826725fa2a3d4)=>env[key];
const $ee69c0f4889074ac$export$eda5083784a7e709 = (env = $ee69c0f4889074ac$export$dd8826725fa2a3d4)=>!$ee69c0f4889074ac$export$f15d00aa73aafac4(env);

});

parcelRegister("aQqva", function(module, exports) {

$parcel$export(module.exports, "debounce", () => $7e535167cc803185$export$61fc7d43ac8f84b0);
$parcel$export(module.exports, "debounceOnContext", () => $7e535167cc803185$export$d3757b91c00af798);
$parcel$export(module.exports, "memoize", () => $7e535167cc803185$export$fc10aeed3a532e2a);
$parcel$export(module.exports, "isStringFunction", () => $7e535167cc803185$export$6f017d9966fe4675);
$parcel$export(module.exports, "hasHandlerPlugin", () => $7e535167cc803185$export$2390d6692fc3136c);
$parcel$export(module.exports, "resolveHandler", () => $7e535167cc803185$export$b8a07dcb2ff3a5ee);
$parcel$export(module.exports, "runPluginHook", () => $7e535167cc803185$export$debb685cc6ca2768);
$parcel$export(module.exports, "cloneFunction", () => $7e535167cc803185$export$5c7d787bf6cea16b);
'use strict';
function $7e535167cc803185$export$61fc7d43ac8f84b0(func, wait, immediate) {
    let timeout;
    return function() {
        const context = this;
        const args = arguments;
        const later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}
const $7e535167cc803185$export$d3757b91c00af798 = (element, func, timeout = 300)=>{
    let timer;
    return (...args)=>{
        clearTimeout(timer);
        timer = setTimeout(()=>{
            func.apply(element, args);
        }, timeout);
    };
};
const $7e535167cc803185$export$fc10aeed3a532e2a = (fn)=>{
    const cache = {};
    return (...args)=>{
        const n = args[0];
        if (n in cache) return cache[n];
        else {
            const result = fn(n);
            cache[n] = result;
            return result;
        }
    };
};
const $7e535167cc803185$var$RE_STRING_FUNCTION = /^((function\s*\([^)]*\)\s*\{[^}]*\})|(\([^)]*\)\s*=>))/;
const $7e535167cc803185$export$6f017d9966fe4675 = (inputString)=>{
    return $7e535167cc803185$var$RE_STRING_FUNCTION.test(inputString);
};
const $7e535167cc803185$export$2390d6692fc3136c = (ctx)=>{
    const plugins = ctx?.plugins;
    if (!plugins || !plugins.length) return false;
    for (const plugin of plugins){
        if (plugin.resolveHandler) return true;
    }
    return false;
};
const $7e535167cc803185$export$b8a07dcb2ff3a5ee = (handler, element)=>{
    if (typeof handler === 'function') return handler;
    const plugins = element?.context?.plugins;
    if (!plugins) return handler;
    for (const plugin of plugins)if (plugin.resolveHandler) {
        const resolved = plugin.resolveHandler(handler, element);
        if (typeof resolved === 'function') return resolved;
    }
    return handler;
};
const $7e535167cc803185$export$debb685cc6ca2768 = (hookName, element, ...args)=>{
    const plugins = element?.context?.plugins;
    if (!plugins) return false;
    let handled = false;
    for (const plugin of plugins)if (typeof plugin[hookName] === 'function') {
        plugin[hookName](element, ...args);
        handled = true;
    }
    return handled;
};
function $7e535167cc803185$export$5c7d787bf6cea16b(fn, win = window) {
    const temp = function() {
        return fn.apply(win, arguments);
    };
    // Copy properties from original function
    for(const key in fn)if (Object.prototype.hasOwnProperty.call(fn, key)) temp[key] = fn[key];
    return temp;
}

});

parcelRegister("cXVIF", function(module, exports) {

$parcel$export(module.exports, "createIfConditionFlag", () => $026f9bf1eff42dc5$export$62115f5848b33107);

var $fX7ii = parcelRequire("fX7ii");

var $bmfNh = parcelRequire("bmfNh");
'use strict';
const $026f9bf1eff42dc5$export$62115f5848b33107 = (element, parent)=>{
    const { __ref: ref } = element;
    const ifVal = element.if;
    if ((0, $fX7ii.isFunction)(ifVal)) {
        let result;
        try {
            result = ifVal(element, element.state, element.context);
        } catch (e) {
            if (typeof console !== 'undefined') console.warn('[DOMQL] if condition error:', e);
            delete ref.__if;
            return;
        }
        if (!result) delete ref.__if;
        else ref.__if = true;
    } else if (ifVal != null && typeof ifVal === 'object') {
        // funcql schema — evaluate via exec() which delegates to plugins
        const result = (0, $bmfNh.exec)(ifVal, element);
        if (!result) delete ref.__if;
        else ref.__if = true;
    } else ref.__if = true;
};

});

parcelRegister("8rNeH", function(module, exports) {

$parcel$export(module.exports, "logIf", () => $626709a19b57d890$export$f3730dd3d285b7c6);
$parcel$export(module.exports, "logGroupIf", () => $626709a19b57d890$export$7cea94b68a0c230b);
'use strict';
const $626709a19b57d890$export$f3730dd3d285b7c6 = (bool, ...arg)=>{
    if (bool) arg.map((v)=>console.log(v));
};
const $626709a19b57d890$export$7cea94b68a0c230b = (bool, key, ...arg)=>{
    if (bool) {
        console.group(key);
        arg.map((v)=>console.log(v));
        console.groupEnd(key);
    }
};

});

parcelRegister("hO2Rt", function(module, exports) {

$parcel$export(module.exports, "isMobile", () => $cf69536c9a89edd1$export$d0a8044dce8ff2fc);
$parcel$export(module.exports, "setCookie", () => $cf69536c9a89edd1$export$110700823644f4a6);
$parcel$export(module.exports, "getCookie", () => $cf69536c9a89edd1$export$4be65e66cfa2648a);
$parcel$export(module.exports, "removeCookie", () => $cf69536c9a89edd1$export$6a874b7a74007875);
$parcel$export(module.exports, "getLocalStorage", () => $cf69536c9a89edd1$export$d3720feff416e85b);
$parcel$export(module.exports, "setLocalStorage", () => $cf69536c9a89edd1$export$1f73f60bdb811cb1);

var $fX7ii = parcelRequire("fX7ii");

var $erBZm = parcelRequire("erBZm");
'use strict';
const $cf69536c9a89edd1$export$d0a8044dce8ff2fc = (()=>typeof navigator === 'undefined' ? false : /Mobi/.test(navigator.userAgent))();
const $cf69536c9a89edd1$export$110700823644f4a6 = (cname, cvalue, exdays = 365)=>{
    if ((0, $fX7ii.isUndefined)((0, $erBZm.document)) || (0, $fX7ii.isUndefined)((0, $erBZm.document).cookie)) return;
    const d = new Date();
    d.setTime(d.getTime() + exdays * 86400000);
    const expires = `expires=${d.toUTCString()}`;
    (0, $erBZm.document).cookie = `${cname}=${cvalue};${expires};path=/`;
};
const $cf69536c9a89edd1$export$4be65e66cfa2648a = (cname)=>{
    if ((0, $fX7ii.isUndefined)((0, $erBZm.document)) || (0, $fX7ii.isUndefined)((0, $erBZm.document).cookie)) return;
    const name = `${cname}=`;
    const decodedCookie = decodeURIComponent((0, $erBZm.document).cookie);
    const ca = decodedCookie.split(';');
    for(let i = 0; i < ca.length; i++){
        let c = ca[i];
        while(c.charAt(0) === ' ')c = c.substring(1);
        if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
    }
    return '';
};
const $cf69536c9a89edd1$export$6a874b7a74007875 = (cname)=>{
    if ((0, $fX7ii.isUndefined)((0, $erBZm.document)) || (0, $fX7ii.isUndefined)((0, $erBZm.document).cookie)) return;
    (0, $erBZm.document).cookie = cname + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
};
function $cf69536c9a89edd1$export$d3720feff416e85b(key) {
    if (!window.localStorage) return undefined;
    const item = window.localStorage.getItem(key);
    if (item === null) return undefined;
    try {
        return JSON.parse(item);
    } catch (e) {
        return undefined;
    }
}
function $cf69536c9a89edd1$export$1f73f60bdb811cb1(key, data) {
    if (!window.localStorage || data === undefined || data === null) return;
    const value = typeof data === 'object' ? JSON.stringify(data) : data;
    window.localStorage.setItem(key, value);
}

});

parcelRegister("6DXv0", function(module, exports) {

$parcel$export(module.exports, "HTML_TAGS", () => $4d6489df8d581382$export$4c3fa92ca590c71f);
$parcel$export(module.exports, "SVG_TAGS", () => $4d6489df8d581382$export$23d5ae6d2560d158);
$parcel$export(module.exports, "isValidHtmlTag", () => $4d6489df8d581382$export$52675ca41d41c093);
'use strict';
const $4d6489df8d581382$export$4c3fa92ca590c71f = {
    root: [
        'body',
        'html'
    ],
    head: [
        'title',
        'base',
        'meta',
        'style',
        'noscript',
        'script'
    ],
    body: new Set([
        'string',
        'style',
        'fragment',
        'a',
        'abbr',
        'acronym',
        'address',
        'applet',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'basefont',
        'bdi',
        'bdo',
        'big',
        'blockquote',
        'br',
        'button',
        'canvas',
        'caption',
        'center',
        'cite',
        'code',
        'search',
        'col',
        'colgroup',
        'data',
        'datalist',
        'dd',
        'del',
        'details',
        'dfn',
        'dialog',
        'dir',
        'div',
        'dl',
        'dt',
        'em',
        'embed',
        'fieldset',
        'figcaption',
        'figure',
        'font',
        'footer',
        'form',
        'frame',
        'frameset',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hr',
        'i',
        'iframe',
        'img',
        'input',
        'ins',
        'kbd',
        'label',
        'legend',
        'li',
        'link',
        'main',
        'map',
        'mark',
        'meter',
        'nav',
        'noframes',
        'noscript',
        'object',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'param',
        'picture',
        'pre',
        'progress',
        'hgroup',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'script',
        'section',
        'select',
        'small',
        'source',
        'span',
        'strike',
        'strong',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'template',
        'hgroup',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'tr',
        'track',
        'tt',
        'u',
        'ul',
        'var',
        'video',
        'wbr',
        // SVG
        'svg',
        'path',
        'circle',
        'ellipse',
        'line',
        'polygon',
        'polyline',
        'rect',
        'g',
        'defs',
        'symbol',
        'use',
        'text',
        'tspan',
        'image',
        'clipPath',
        'mask',
        'pattern',
        'marker',
        'linearGradient',
        'radialGradient',
        'stop',
        'filter',
        'feGaussianBlur',
        'feOffset',
        'feMerge',
        'feMergeNode',
        'feBlend',
        'feColorMatrix',
        'feFlood',
        'feComposite',
        'foreignObject'
    ])
};
const $4d6489df8d581382$export$23d5ae6d2560d158 = new Set([
    'svg',
    'path',
    'circle',
    'ellipse',
    'line',
    'polygon',
    'polyline',
    'rect',
    'g',
    'defs',
    'symbol',
    'use',
    'text',
    'tspan',
    'image',
    'clipPath',
    'mask',
    'pattern',
    'marker',
    'linearGradient',
    'radialGradient',
    'stop',
    'filter',
    'feGaussianBlur',
    'feOffset',
    'feMerge',
    'feMergeNode',
    'feBlend',
    'feColorMatrix',
    'feFlood',
    'feComposite',
    'foreignObject'
]);
const $4d6489df8d581382$export$52675ca41d41c093 = (arg)=>$4d6489df8d581382$export$4c3fa92ca590c71f.body.has(arg);

});

parcelRegister("FzLlj", function(module, exports) {

$parcel$export(module.exports, "matchesComponentNaming", () => $07cf9227ea295b90$export$7ee0520502076834);
$parcel$export(module.exports, "getCapitalCaseKeys", () => $07cf9227ea295b90$export$ef62ecae187000fa);
$parcel$export(module.exports, "getSpreadChildren", () => $07cf9227ea295b90$export$e3565e6b9e497c79);
$parcel$export(module.exports, "isContextComponent", () => $07cf9227ea295b90$export$5869b4db06e1780c);

var $1e3EP = parcelRequire("1e3EP");

var $fX7ii = parcelRequire("fX7ii");
'use strict';
const $07cf9227ea295b90$export$7ee0520502076834 = (key)=>{
    if (!(0, $fX7ii.isString)(key) || !key.length) return false;
    const code = key.charCodeAt(0);
    return code >= 65 && code <= 90 // A-Z
    ;
};
function $07cf9227ea295b90$export$ef62ecae187000fa(obj) {
    return Object.keys(obj).filter((key)=>/^[A-Z]/.test(key));
}
function $07cf9227ea295b90$export$e3565e6b9e497c79(obj) {
    return Object.keys(obj).filter((key)=>/^\d+$/.test(key));
}
function $07cf9227ea295b90$export$5869b4db06e1780c(element, parent, passedKey) {
    const { context: context } = parent || {};
    const [extendsKey] = (0, $1e3EP.createExtendsFromKeys)(passedKey);
    const key = passedKey || extendsKey;
    return context?.components?.[key] || context?.pages?.[key];
}

});
parcelRegister("1e3EP", function(module, exports) {

$parcel$export(module.exports, "createExtendsFromKeys", () => $0e49ef95137eb368$export$f99aa3442ed267f1);
$parcel$export(module.exports, "createExtends", () => $0e49ef95137eb368$export$7c6fdf32f38bef77);
$parcel$export(module.exports, "addExtends", () => $0e49ef95137eb368$export$3200adf97fb998d9);
$parcel$export(module.exports, "concatAddExtends", () => $0e49ef95137eb368$export$cfa74393132ebcec);
$parcel$export(module.exports, "generateHash", () => $0e49ef95137eb368$export$daf4c137c5f56404);
$parcel$export(module.exports, "extendStackRegistry", () => $0e49ef95137eb368$export$476cb8ab9adcdb0d);
$parcel$export(module.exports, "extendCachedRegistry", () => $0e49ef95137eb368$export$bc442b6cc8c83971);
$parcel$export(module.exports, "getHashedExtend", () => $0e49ef95137eb368$export$46ce3405574370c6);
$parcel$export(module.exports, "setHashedExtend", () => $0e49ef95137eb368$export$8c8f2806a2edf07f);
$parcel$export(module.exports, "getExtendsStackRegistry", () => $0e49ef95137eb368$export$c4fe3c170ecffa69);
$parcel$export(module.exports, "extractArrayExtend", () => $0e49ef95137eb368$export$2c118161a655606a);
$parcel$export(module.exports, "flattenExtend", () => $0e49ef95137eb368$export$802e3e1ed5ecb3f2);
$parcel$export(module.exports, "deepExtend", () => $0e49ef95137eb368$export$54e9fb29908872fa);
$parcel$export(module.exports, "mapStringsWithContextComponents", () => $0e49ef95137eb368$export$325609fc8b225e02);
$parcel$export(module.exports, "deepMergeExtends", () => $0e49ef95137eb368$export$e0fa903e42ff191c);
$parcel$export(module.exports, "cloneAndMergeArrayExtend", () => $0e49ef95137eb368$export$e2e460d82983fb19);
$parcel$export(module.exports, "jointStacks", () => $0e49ef95137eb368$export$f9f936cf352c3af2);
$parcel$export(module.exports, "getExtendsStack", () => $0e49ef95137eb368$export$f39bb847e2d05ef6);
$parcel$export(module.exports, "addExtend", () => $0e49ef95137eb368$export$2f41615046006887);
$parcel$export(module.exports, "getExtendsInElement", () => $0e49ef95137eb368$export$a23334bdec459c3a);
$parcel$export(module.exports, "createElementExtends", () => $0e49ef95137eb368$export$5adee993743866c4);
$parcel$export(module.exports, "inheritChildPropsExtends", () => $0e49ef95137eb368$export$330789d8e1f3b311);
$parcel$export(module.exports, "inheritChildExtends", () => $0e49ef95137eb368$export$dde729987f06f311);
$parcel$export(module.exports, "inheritRecursiveChildExtends", () => $0e49ef95137eb368$export$4426caec5c659cae);
$parcel$export(module.exports, "createExtendsStack", () => $0e49ef95137eb368$export$5625cedc68348886);
$parcel$export(module.exports, "finalizeExtends", () => $0e49ef95137eb368$export$eef12a49036578e9);
$parcel$export(module.exports, "applyExtends", () => $0e49ef95137eb368$export$1ac92e2b1d1a0b6d);

var $j1b7T = parcelRequire("j1b7T");

var $FzLlj = parcelRequire("FzLlj");

var $bmfNh = parcelRequire("bmfNh");

var $fX7ii = parcelRequire("fX7ii");
'use strict';
const $0e49ef95137eb368$var$ENV = "upcoming";
const $0e49ef95137eb368$var$isSourcemapEnabled = (options)=>options.sourcemap !== false && $0e49ef95137eb368$var$ENV !== 'production';
const $0e49ef95137eb368$export$f99aa3442ed267f1 = (key)=>{
    if (key.includes('+')) return key.split('+').filter((0, $FzLlj.matchesComponentNaming));
    if (key.includes('_')) {
        const [first] = key.split('_');
        return [
            first
        ];
    }
    if (key.includes('.') && !(0, $FzLlj.matchesComponentNaming)(key.split('.')[1])) {
        const [first] = key.split('.');
        return [
            first
        ];
    }
    return [
        key
    ];
};
const $0e49ef95137eb368$export$7c6fdf32f38bef77 = (element, parent, key)=>{
    let __extends = [];
    const keyExtends = $0e49ef95137eb368$export$f99aa3442ed267f1(key);
    if (keyExtends) __extends = [
        ...keyExtends
    ];
    const elementExtends = element.extends;
    if (elementExtends) __extends = (0, $fX7ii.isArray)(elementExtends) ? [
        ...__extends,
        ...elementExtends
    ] : [
        ...__extends,
        elementExtends
    ];
    return __extends;
};
const $0e49ef95137eb368$export$3200adf97fb998d9 = (newExtends, element)=>{
    const { __ref: ref } = element;
    let { __extends: __extends } = ref;
    if (!newExtends) return __extends;
    // Check if the first extend has a variant in components
    const variant = element.variant;
    const context = element.context;
    if (variant && context?.components && !Array.isArray(newExtends) && typeof newExtends === 'string') {
        const variantKey = `${newExtends}.${variant}`;
        if (context.components[variantKey]) newExtends = variantKey;
    }
    if (!__extends.includes(newExtends)) {
        __extends = Array.isArray(newExtends) ? [
            ...__extends,
            ...newExtends
        ] : [
            ...__extends,
            newExtends
        ];
        ref.__extends = __extends;
    }
    return __extends;
};
const $0e49ef95137eb368$export$cfa74393132ebcec = (newExtend, element)=>{
    if (!newExtend) return element;
    const { extends: elementExtend } = element;
    const originalArray = (0, $fX7ii.isArray)(elementExtend) ? elementExtend : [
        elementExtend
    ];
    const receivedArray = (0, $fX7ii.isArray)(newExtend) ? newExtend : [
        newExtend
    ];
    return {
        ...element,
        extends: (0, $j1b7T.joinArrays)(receivedArray, originalArray)
    };
};
const $0e49ef95137eb368$export$daf4c137c5f56404 = ()=>Math.random().toString(36).substring(2);
const $0e49ef95137eb368$export$476cb8ab9adcdb0d = {};
const $0e49ef95137eb368$export$bc442b6cc8c83971 = {};
const $0e49ef95137eb368$export$46ce3405574370c6 = (extend)=>{
    return $0e49ef95137eb368$export$476cb8ab9adcdb0d[extend.__hash];
};
const $0e49ef95137eb368$export$8c8f2806a2edf07f = (extend, stack)=>{
    const hash = $0e49ef95137eb368$export$daf4c137c5f56404();
    if (!(0, $fX7ii.isString)(extend)) extend.__hash = hash;
    if (hash !== '__proto__' && hash !== 'constructor' && hash !== 'prototype') $0e49ef95137eb368$export$476cb8ab9adcdb0d[hash] = stack;
    return stack;
};
const $0e49ef95137eb368$export$c4fe3c170ecffa69 = (extend, stack)=>{
    if (extend.__hash) return stack.concat($0e49ef95137eb368$export$46ce3405574370c6(extend));
    return $0e49ef95137eb368$export$8c8f2806a2edf07f(extend, stack) // stack .concat(hashedExtend)
    ;
};
const $0e49ef95137eb368$export$2c118161a655606a = (extend, stack, context, processed = new Set(), nameStack, componentNameMap)=>{
    for (const each of extend)if ((0, $fX7ii.isArray)(each)) $0e49ef95137eb368$export$2c118161a655606a(each, stack, context, processed, nameStack, componentNameMap);
    else $0e49ef95137eb368$export$802e3e1ed5ecb3f2(each, stack, context, processed, nameStack, undefined, componentNameMap);
    return stack;
};
const $0e49ef95137eb368$export$54e9fb29908872fa = (extend, stack, context, processed = new Set(), nameStack, currentName, componentNameMap)=>{
    const extendOflattenExtend = extend.extends;
    const cleanExtend = {
        ...extend
    };
    delete cleanExtend.extends;
    let hasKeys = false;
    for(const _k in cleanExtend){
        hasKeys = true;
        break;
    } // eslint-disable-line
    if (hasKeys) {
        stack.push(cleanExtend);
        if (nameStack) nameStack.push(currentName);
    }
    if (extendOflattenExtend) $0e49ef95137eb368$export$802e3e1ed5ecb3f2(extendOflattenExtend, stack, context, processed, nameStack, currentName, componentNameMap);
    return stack;
};
const $0e49ef95137eb368$export$802e3e1ed5ecb3f2 = (extend, stack, context, processed = new Set(), nameStack, parentName, componentNameMap)=>{
    if (!extend) return stack;
    if (processed.has(extend)) return stack;
    if ((0, $fX7ii.isArray)(extend)) return $0e49ef95137eb368$export$2c118161a655606a(extend, stack, context, processed, nameStack, componentNameMap);
    let currentName = parentName;
    if ((0, $fX7ii.isString)(extend)) {
        currentName = extend;
        extend = $0e49ef95137eb368$export$325609fc8b225e02(extend, context);
    } else if (componentNameMap && (0, $fX7ii.isObject)(extend) && componentNameMap.has(extend)) // Resolve name from pre-built map (top-level resolved extends)
    currentName = componentNameMap.get(extend);
    processed.add(extend);
    if (extend?.extends) $0e49ef95137eb368$export$54e9fb29908872fa(extend, stack, context, processed, nameStack, currentName, componentNameMap);
    else if (extend) {
        stack.push(extend);
        if (nameStack) nameStack.push(currentName);
    }
    return stack;
};
const $0e49ef95137eb368$var$MERGE_EXTENDS_SKIP = new Set([
    'parent',
    'node',
    '__ref',
    '__proto__',
    'extends',
    'childExtends',
    'childExtendsRecursive'
]);
const $0e49ef95137eb368$export$e0fa903e42ff191c = (element, extend, sourcemap, sourceName, preBuiltSourcemap)=>{
    // Clone extend to prevent mutations
    extend = (0, $bmfNh.deepClone)(extend);
    for(const e in extend){
        if ($0e49ef95137eb368$var$MERGE_EXTENDS_SKIP.has(e)) continue;
        const elementProp = element[e];
        const extendProp = extend[e];
        // Skip if the property is undefined in the extend object
        if (extendProp === undefined) continue;
        // Handle only properties that exist in the extend object
        if (Object.prototype.hasOwnProperty.call(extend, e) && e !== '__proto__' && e !== 'constructor' && e !== 'prototype') {
            if (elementProp === undefined) {
                // For undefined properties in element, copy from extend
                element[e] = extendProp;
                // Track sourcemap for this property
                if (sourcemap && sourceName) {
                    if ((0, $fX7ii.isObject)(extendProp) && !(0, $fX7ii.isArray)(extendProp)) {
                        sourcemap[e] = sourcemap[e] || {};
                        $0e49ef95137eb368$var$trackSourcemapDeep(sourcemap[e], extendProp, sourceName);
                    } else sourcemap[e] = sourceName;
                } else if (sourcemap && preBuiltSourcemap?.[e]) // Copy sourcemap entry from pre-built sourcemap (used in finalizeExtends)
                sourcemap[e] = preBuiltSourcemap[e];
            } else if ((0, $fX7ii.isObject)(elementProp) && (0, $fX7ii.isObject)(extendProp)) {
                // For objects, merge based on type
                const nestedSourcemap = sourcemap ? sourcemap[e] = sourcemap[e] || {} : undefined;
                const nestedPreBuilt = preBuiltSourcemap?.[e];
                if ((0, $FzLlj.matchesComponentNaming)(e)) // For components, override base properties with extended ones
                element[e] = $0e49ef95137eb368$export$e0fa903e42ff191c(elementProp, extendProp, nestedSourcemap, sourceName, nestedPreBuilt);
                else // For other objects, merge normally
                $0e49ef95137eb368$export$e0fa903e42ff191c(elementProp, extendProp, nestedSourcemap, sourceName, nestedPreBuilt);
            }
            if (e === 'extends' || e === 'childExtends' || e === 'childExtendsRecursive') {
                if ((0, $fX7ii.isArray)(elementProp) && (0, $fX7ii.isArray)(extendProp)) element[e] = elementProp.concat(extendProp);
                else if ((0, $fX7ii.isArray)(elementProp) && (0, $fX7ii.isObject)(extendProp)) {
                    const obj = $0e49ef95137eb368$export$e0fa903e42ff191c({}, elementProp);
                    element[e] = $0e49ef95137eb368$export$e0fa903e42ff191c(obj, extendProp);
                }
            }
        // If elementProp is defined and not an object, keep it (don't override)
        // This preserves properties from earlier in the extend chain
        }
    }
    return element;
};
const $0e49ef95137eb368$var$trackSourcemapDeep = (sourcemap, obj, sourceName, seen)=>{
    if (!seen) seen = new WeakSet();
    if (seen.has(obj)) return;
    seen.add(obj);
    for(const key in obj){
        if (!Object.prototype.hasOwnProperty.call(obj, key)) continue;
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') continue;
        const val = obj[key];
        if ((0, $fX7ii.isObject)(val) && !(0, $fX7ii.isArray)(val)) {
            sourcemap[key] = sourcemap[key] || {};
            $0e49ef95137eb368$var$trackSourcemapDeep(sourcemap[key], val, sourceName, seen);
        } else sourcemap[key] = sourceName;
    }
};
const $0e49ef95137eb368$export$e2e460d82983fb19 = (stack, sourcemap, extendNames)=>{
    return stack.reduce((acc, current, i)=>{
        // Clone current extend to avoid mutations
        const cloned = (0, $bmfNh.deepClone)(current);
        const sourceName = extendNames ? extendNames[i] : undefined;
        // Merge into accumulator, giving priority to current extend
        return $0e49ef95137eb368$export$e0fa903e42ff191c(acc, cloned, sourcemap, sourceName);
    }, {});
};
const $0e49ef95137eb368$export$325609fc8b225e02 = (extend, context, options = {}, variant)=>{
    const COMPONENTS = context?.components || options.components;
    const PAGES = context?.pages || options.pages;
    if ((0, $fX7ii.isString)(extend)) {
        const componentExists = COMPONENTS && (COMPONENTS[extend + '.' + variant] || COMPONENTS[extend] || COMPONENTS['smbls.' + extend]);
        const pageExists = PAGES && extend.charCodeAt(0) === 47 && PAGES[extend];
        if (componentExists) return componentExists;
        else if (pageExists) return pageExists;
        else {
            if (options.verbose && ($0e49ef95137eb368$var$ENV === 'test' || $0e49ef95137eb368$var$ENV === 'development')) console.warn('Extend is string but component was not found:', extend);
            return;
        }
    }
    return extend;
};
const $0e49ef95137eb368$export$f9f936cf352c3af2 = (extendStack, childExtendsStack)=>{
    return [].concat(extendStack.slice(0, 1)).concat(childExtendsStack.slice(0, 1)).concat(extendStack.slice(1)).concat(childExtendsStack.slice(1));
};
const $0e49ef95137eb368$export$f39bb847e2d05ef6 = (extend, context, nameStack, componentNameMap)=>{
    if (!extend) return [];
    if (extend.__hash) return $0e49ef95137eb368$export$46ce3405574370c6(extend) || [];
    const processed = new Set();
    const stack = $0e49ef95137eb368$export$802e3e1ed5ecb3f2(extend, [], context, processed, nameStack, undefined, componentNameMap);
    if (nameStack) return stack;
    return $0e49ef95137eb368$export$c4fe3c170ecffa69(extend, stack);
};
const $0e49ef95137eb368$export$2f41615046006887 = (newExtends, elementExtends)=>{
    if (!newExtends) return elementExtends;
    const receivedArray = (0, $fX7ii.isArray)(newExtends) ? newExtends : [
        newExtends
    ];
    return (0, $j1b7T.joinArrays)(receivedArray, elementExtends);
};
const $0e49ef95137eb368$export$a23334bdec459c3a = (obj)=>{
    let result = [];
    function traverse(o) {
        for(const key in o)if (Object.prototype.hasOwnProperty.call(o, key)) {
            // Check if the key starts with a capital letter and exclude keys like @mobileL, $router
            if ((0, $FzLlj.matchesComponentNaming)(key)) result.push(key);
            // Check if the key is "extend" and it's either a string or an array
            if (key === 'extends') {
                // Add the value of the extend key to the result array
                if (typeof o[key] === 'string') result.push(o[key]);
                else if (Array.isArray(o[key])) result = result.concat(o[key]);
            }
            // If the property is an object, traverse it
            if (typeof o[key] === 'object' && o[key] !== null) traverse(o[key]);
        }
    }
    traverse(obj);
    return result;
};
const $0e49ef95137eb368$export$5adee993743866c4 = (element, parent, options = {})=>{
    const { __ref: ref } = element;
    const context = element.context || parent.context;
    const variant = element.variant;
    if (element.extends) {
        if (Array.isArray(element.extends) && element.extends.length > 0) {
            // Handle first item in array specially for variant
            const [firstExtend, ...restExtends] = element.extends;
            if (typeof firstExtend === 'string' && variant && context?.components) {
                const variantKey = `${firstExtend}.${variant}`;
                if (context.components[variantKey]) $0e49ef95137eb368$export$3200adf97fb998d9([
                    variantKey,
                    ...restExtends
                ], element);
                else $0e49ef95137eb368$export$3200adf97fb998d9(element.extends, element);
            } else $0e49ef95137eb368$export$3200adf97fb998d9(element.extends, element);
        } else if (typeof element.extends === 'string' && variant && context?.components) {
            const variantKey = `${element.extends}.${variant}`;
            if (context.components[variantKey]) $0e49ef95137eb368$export$3200adf97fb998d9(variantKey, element);
            else $0e49ef95137eb368$export$3200adf97fb998d9(element.extends, element);
        } else $0e49ef95137eb368$export$3200adf97fb998d9(element.extends, element);
    }
    $0e49ef95137eb368$export$330789d8e1f3b311(element, parent, options);
    $0e49ef95137eb368$export$dde729987f06f311(element, parent, options);
    $0e49ef95137eb368$export$4426caec5c659cae(element, parent, options);
    if (element.component) $0e49ef95137eb368$export$3200adf97fb998d9((0, $bmfNh.exec)(element.component, element), element);
    if (context.defaultExtends) $0e49ef95137eb368$export$3200adf97fb998d9(context.defaultExtends, element);
    return (0, $j1b7T.removeDuplicatesInArray)(ref.__extends);
};
const $0e49ef95137eb368$export$330789d8e1f3b311 = (element, parent, options = {})=>{
    const { __ref: ref } = element;
    const ignoreChildExtends = options.ignoreChildExtends || element.ignoreChildExtends;
    if (!ignoreChildExtends) {
        if (parent.childProps?.extends) $0e49ef95137eb368$export$3200adf97fb998d9(parent.childProps.extends, element);
    }
    return ref.__extends;
};
const $0e49ef95137eb368$export$dde729987f06f311 = (element, parent, options = {})=>{
    const { __ref: ref } = element;
    const ignoreChildExtends = options.ignoreChildExtends || element.ignoreChildExtends;
    const childExtends = parent.childExtends;
    if (!ignoreChildExtends && childExtends) $0e49ef95137eb368$export$3200adf97fb998d9(childExtends, element);
    return ref.__extends;
};
const $0e49ef95137eb368$export$4426caec5c659cae = (element, parent, options = {})=>{
    const { __ref: ref } = element;
    const childExtendsRecursive = parent.childExtendsRecursive;
    const ignoreChildExtendsRecursive = options.ignoreChildExtendsRecursive || element.ignoreChildExtendsRecursive;
    const isText = element.key === '__text';
    if (childExtendsRecursive && !isText && !ignoreChildExtendsRecursive) $0e49ef95137eb368$export$3200adf97fb998d9(childExtendsRecursive, element);
    return ref.__extends;
};
const $0e49ef95137eb368$export$5625cedc68348886 = (element, parent, options = {})=>{
    const { __ref: ref } = element;
    const context = element.context || parent.context;
    const variant = element.variant;
    // Keep original string names before resolution for sourcemap tracking
    const sourcemap = $0e49ef95137eb368$var$isSourcemapEnabled(options);
    const originalExtendNames = sourcemap ? [
        ...ref.__extends
    ] : null;
    const __extends = (0, $j1b7T.removeDuplicatesInArray)(ref.__extends.map((val, i)=>{
        return $0e49ef95137eb368$export$325609fc8b225e02(val, context, options, i === 0 && variant);
    }));
    if (sourcemap) {
        // Build a map from resolved component objects to their original string names
        const componentNameMap = new WeakMap();
        for(let i = 0; i < __extends.length; i++){
            const resolved = __extends[i];
            const originalName = originalExtendNames[i];
            if (resolved && (0, $fX7ii.isObject)(resolved) && (0, $fX7ii.isString)(originalName)) componentNameMap.set(resolved, originalName);
        }
        const nameStack = [];
        const stack = $0e49ef95137eb368$export$f39bb847e2d05ef6(__extends, context, nameStack, componentNameMap);
        ref.__extendsStack = stack;
        ref.__extendsNames = nameStack;
    } else {
        const stack = $0e49ef95137eb368$export$f39bb847e2d05ef6(__extends, context);
        ref.__extendsStack = stack;
    }
    return ref.__extendsStack;
};
const $0e49ef95137eb368$export$eef12a49036578e9 = (element, parent, options = {})=>{
    const { __ref: ref } = element;
    const { __extendsStack: __extendsStack } = ref;
    if ($0e49ef95137eb368$var$isSourcemapEnabled(options)) {
        const sourcemapAcc = {};
        const extendNames = ref.__extendsNames || [];
        const flattenExtends = $0e49ef95137eb368$export$e2e460d82983fb19(__extendsStack, sourcemapAcc, extendNames);
        // Only keep sourcemap entries for properties actually merged into element
        const appliedSourcemap = {};
        $0e49ef95137eb368$export$e0fa903e42ff191c(element, flattenExtends, appliedSourcemap, undefined, sourcemapAcc);
        ref.__sourcemap = appliedSourcemap;
    } else {
        const flattenExtends = $0e49ef95137eb368$export$e2e460d82983fb19(__extendsStack);
        $0e49ef95137eb368$export$e0fa903e42ff191c(element, flattenExtends);
    }
    return element;
};
const $0e49ef95137eb368$export$1ac92e2b1d1a0b6d = (element, parent, options = {})=>{
    $0e49ef95137eb368$export$5adee993743866c4(element, parent, options);
    $0e49ef95137eb368$export$5625cedc68348886(element, parent, options);
    $0e49ef95137eb368$export$eef12a49036578e9(element, parent, options);
    return element;
};

});


parcelRegister("5E2zl", function(module, exports) {

$parcel$export(module.exports, "createProps", () => $41c2ae5820248293$export$c94ea207b45fef3a);
$parcel$export(module.exports, "pickupPropsFromElement", () => $41c2ae5820248293$export$411043fa9345828f);
$parcel$export(module.exports, "pickupElementFromProps", () => $41c2ae5820248293$export$fa8664b35a0bcdc9);
$parcel$export(module.exports, "propertizeElement", () => $41c2ae5820248293$export$4ff756f42aa6b6a4);
$parcel$export(module.exports, "propertizeUpdate", () => $41c2ae5820248293$export$2bbd9d589d78c8ea);
$parcel$export(module.exports, "objectizeStringProperty", () => $41c2ae5820248293$export$5e9fe7243e559e3c);
$parcel$export(module.exports, "propExists", () => $41c2ae5820248293$export$fd415051acfc22d4);
$parcel$export(module.exports, "inheritParentProps", () => $41c2ae5820248293$export$d25057a75c14aff7);
$parcel$export(module.exports, "update", () => $41c2ae5820248293$export$722fbec263ad908a);
$parcel$export(module.exports, "setPropsPrototype", () => $41c2ae5820248293$export$e290b82348b6726c);
$parcel$export(module.exports, "removeDuplicateProps", () => $41c2ae5820248293$export$44466878677fcc43);
$parcel$export(module.exports, "syncProps", () => $41c2ae5820248293$export$b23ca50362483f82);
$parcel$export(module.exports, "createPropsStack", () => $41c2ae5820248293$export$1327128ea5b9a1e8);
$parcel$export(module.exports, "applyProps", () => $41c2ae5820248293$export$d76b848a0167f48b);
$parcel$export(module.exports, "initProps", () => $41c2ae5820248293$export$a121566aadcfe021);
$parcel$export(module.exports, "updateProps", () => $41c2ae5820248293$export$c8dce3c08436e91e);

var $350cP = parcelRequire("350cP");

var $gSDtL = parcelRequire("gSDtL");

var $bmfNh = parcelRequire("bmfNh");

var $fX7ii = parcelRequire("fX7ii");

var $1zeno = parcelRequire("1zeno");

var $aQqva = parcelRequire("aQqva");
'use strict';
const $41c2ae5820248293$var$RE_UPPER = /^[A-Z]/;
const $41c2ae5820248293$var$RE_DIGITS = /^\d+$/;
// Characters that mark css-in-props selectors (pseudo-selectors, media queries, etc.)
// These properties must always live in props so useCssInProps() can process them
const $41c2ae5820248293$var$CSS_SELECTOR_PREFIXES = new Set([
    ':',
    '@',
    '[',
    '*',
    '+',
    '~',
    '&',
    '>',
    '$',
    '-',
    '.',
    '!'
]);
const $41c2ae5820248293$var$ELEMENT_INDICATOR_KEYS = new Set([
    'extend',
    'props',
    'text',
    'tag',
    'on',
    'if',
    'childExtend',
    'children',
    'childrenAs',
    'state',
    'html',
    'attr',
    'define',
    'content'
]);
const $41c2ae5820248293$var$looksLikeElement = (value)=>{
    if (!value || typeof value !== 'object' || Array.isArray(value)) return false;
    for(const k in value){
        if ($41c2ae5820248293$var$ELEMENT_INDICATOR_KEYS.has(k)) return true;
        if ($41c2ae5820248293$var$RE_UPPER.test(k)) return true;
    }
    return false;
};
const $41c2ae5820248293$export$c94ea207b45fef3a = (element, parent, key)=>{
    const { props: props, __ref: ref } = element;
    ref.__propsStack = [];
    if (props) ref.__initialProps = props;
    else return {};
    if (!(0, $fX7ii.isObjectLike)(props)) {
        ref.__propsStack.push(props);
        return {};
    }
    return {
        ...props
    };
};
function $41c2ae5820248293$export$411043fa9345828f(obj, opts = {}) {
    const cachedKeys = opts.cachedKeys || [];
    for(const key in obj){
        const value = obj[key];
        // Move top-level onXxx handlers directly into on.xxx (v3 style)
        const isOnKey = key.length > 2 && key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && key[2] === key[2].toUpperCase();
        const isEventHandler = isOnKey && ((0, $fX7ii.isFunction)(value) || value != null && (0, $aQqva.hasHandlerPlugin)(this.context));
        if (isEventHandler) {
            const eventName = (0, $1zeno.lowercaseFirstLetter)(key.slice(2));
            if (obj.on) obj.on[eventName] = value;
            delete obj[key];
            continue;
        }
        // childProps is a framework property that must always live in props
        // even though its value may contain uppercase keys (Icon, Hgroup, etc.)
        if (key === 'childProps') {
            obj.props[key] = value;
            delete obj[key];
            cachedKeys.push(key);
            continue;
        }
        // Check define handlers - keys with define handlers must stay at root
        // for throughInitialDefine to process them
        const defineValue = this.define?.[key];
        const globalDefineValue = this.context?.define?.[key];
        const hasDefine = (0, $fX7ii.isObject)(defineValue) || (0, $fX7ii.isFunction)(defineValue);
        const hasGlobalDefine = (0, $fX7ii.isObject)(globalDefineValue) || (0, $fX7ii.isFunction)(globalDefineValue);
        if (hasDefine || hasGlobalDefine) continue;
        // CSS-in-props selectors (:after, :hover, @mobileS, etc.) must always
        // live in props so useCssInProps() can process them via transformersByPrefix
        const firstChar = key.charAt(0);
        if ($41c2ae5820248293$var$CSS_SELECTOR_PREFIXES.has(firstChar)) {
            obj.props[key] = value;
            delete obj[key];
            cachedKeys.push(key);
            continue;
        }
        const isElement = $41c2ae5820248293$var$RE_UPPER.test(key) || $41c2ae5820248293$var$RE_DIGITS.test(key) || $41c2ae5820248293$var$looksLikeElement(value);
        const isBuiltin = (0, $350cP.DOMQ_PROPERTIES).has(key);
        // If it's not a special case, move to props
        // Don't overwrite props already set by local definition (e.g. from childrenAs: 'props')
        if (!isElement && !isBuiltin) {
            if (!(key in obj.props)) obj.props[key] = value;
            delete obj[key];
            cachedKeys.push(key);
        }
    }
    return obj;
}
function $41c2ae5820248293$export$fa8664b35a0bcdc9(obj = this, opts) {
    const cachedKeys = opts.cachedKeys || [];
    for(const key in obj.props){
        const value = obj.props[key];
        // Handle event handlers (functions, or plugin schemas when plugins are active)
        const isEvent = key.length > 2 && key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110;
        const isHandler = (0, $fX7ii.isFunction)(value) || value != null && (0, $aQqva.hasHandlerPlugin)(this.context);
        if (isEvent && isHandler) {
            (0, $gSDtL.addEventFromProps)(key, obj);
            delete obj.props[key];
            continue;
        }
        // Skip if key was originally from obj
        if (cachedKeys.includes(key)) continue;
        // childProps must stay in props - it's consumed by inheritParentProps
        if (key === 'childProps') continue;
        // CSS-in-props selectors must stay in props
        const firstChar = key.charAt(0);
        if ($41c2ae5820248293$var$CSS_SELECTOR_PREFIXES.has(firstChar)) continue;
        const defineValue = this.define?.[key];
        const globalDefineValue = this.context?.define?.[key];
        const hasDefine = (0, $fX7ii.isObject)(defineValue) || (0, $fX7ii.isFunction)(defineValue);
        const hasGlobalDefine = (0, $fX7ii.isObject)(globalDefineValue) || (0, $fX7ii.isFunction)(globalDefineValue);
        const isElement = $41c2ae5820248293$var$RE_UPPER.test(key) || $41c2ae5820248293$var$RE_DIGITS.test(key);
        const isBuiltin = (0, $350cP.DOMQ_PROPERTIES).has(key);
        // Move qualifying properties back to obj root
        if (isElement || isBuiltin || hasDefine || hasGlobalDefine) // Don't overwrite if root already has this property explicitly set
        // Exception: null values should override to allow nullifying children from props
        {
            if (obj[key] === undefined || value === null) {
                obj[key] = value;
                if (obj.props) delete obj.props[key];
            }
        }
    }
    return obj;
}
function $41c2ae5820248293$export$4ff756f42aa6b6a4(element = this) {
    const cachedKeys = [];
    $41c2ae5820248293$export$411043fa9345828f.call(this, element, {
        cachedKeys: cachedKeys
    });
    $41c2ae5820248293$export$fa8664b35a0bcdc9.call(this, element, {
        cachedKeys: cachedKeys
    });
    return element;
}
function $41c2ae5820248293$export$2bbd9d589d78c8ea(params = {}) {
    if (!params.on) params.on = {};
    if (!params.props) params.props = {};
    return $41c2ae5820248293$export$4ff756f42aa6b6a4.call(this, params);
}
const $41c2ae5820248293$export$5e9fe7243e559e3c = (propValue)=>{
    if ((0, $fX7ii.is)(propValue)('string', 'number')) return {
        inheritedString: propValue
    };
    return propValue;
};
const $41c2ae5820248293$export$fd415051acfc22d4 = (prop, stack)=>{
    if (!prop || !stack.length) return false;
    return stack.includes(prop);
};
const $41c2ae5820248293$export$d25057a75c14aff7 = (element, parent)=>{
    const { __ref: ref } = element;
    const propsStack = ref.__propsStack || [];
    const parentProps = parent.props;
    if (!parentProps) return propsStack;
    const matchParentKeyProps = parentProps[element.key];
    const matchParentChildProps = parentProps.childProps || parent.childProps;
    // Order matters: key-specific props should be added after childProps
    const ignoreChildProps = element.props?.ignoreChildProps;
    if (matchParentChildProps && !ignoreChildProps) {
        const childProps = $41c2ae5820248293$export$5e9fe7243e559e3c(matchParentChildProps);
        propsStack.unshift(childProps);
    }
    if (matchParentKeyProps) {
        const keyProps = $41c2ae5820248293$export$5e9fe7243e559e3c(matchParentKeyProps);
        propsStack.unshift(keyProps);
    }
    return propsStack;
};
function $41c2ae5820248293$export$722fbec263ad908a(props, options) {
    const element = this.__element;
    element.update({
        props: props
    }, options);
}
function $41c2ae5820248293$export$e290b82348b6726c(element) {
    const methods = {
        update: $41c2ae5820248293$export$722fbec263ad908a.bind(element.props),
        __element: element
    };
    Object.setPrototypeOf(element.props, methods);
}
const $41c2ae5820248293$export$44466878677fcc43 = (propsStack)=>{
    const seen = new Set();
    return propsStack.filter((prop)=>{
        if (!prop || (0, $350cP.PROPS_METHODS).has(prop)) return false;
        if (seen.has(prop)) return false;
        seen.add(prop);
        return true;
    });
};
const $41c2ae5820248293$export$b23ca50362483f82 = (propsStack, element, opts)=>{
    element.props = propsStack.reduce((mergedProps, v)=>{
        if ((0, $350cP.PROPS_METHODS).has(v)) return mergedProps;
        while((0, $fX7ii.isFunction)(v))v = (0, $bmfNh.exec)(v, element);
        return (0, $bmfNh.deepMerge)(mergedProps, (0, $bmfNh.deepClone)(v, {
            exclude: (0, $350cP.PROPS_METHODS)
        }));
    }, {});
    $41c2ae5820248293$export$e290b82348b6726c(element);
    return element.props;
};
const $41c2ae5820248293$export$1327128ea5b9a1e8 = (element, parent)=>{
    const { props: props, __ref: ref } = element;
    // Start with parent props
    let propsStack = ref.__propsStack || [];
    // Get parent props
    if (parent?.props) {
        const parentStack = $41c2ae5820248293$export$d25057a75c14aff7(element, parent);
        propsStack = [
            ...parentStack
        ];
    }
    // Add current props
    if ((0, $fX7ii.isObject)(props)) propsStack.push(props);
    else if (props === 'inherit' && parent?.props) propsStack.push(parent.props);
    else if (props) propsStack.push(props);
    // Add extends props
    if ((0, $fX7ii.isArray)(ref.__extendsStack)) for(let i = 0; i < ref.__extendsStack.length; i++){
        const _extends = ref.__extendsStack[i];
        if (_extends.props && _extends.props !== props) propsStack.push(_extends.props);
    }
    // Remove duplicates and update reference
    ref.__propsStack = $41c2ae5820248293$export$44466878677fcc43(propsStack);
    return ref.__propsStack;
};
const $41c2ae5820248293$export$d76b848a0167f48b = (element, parent)=>{
    const { __ref: ref } = element;
    // Create a fresh props stack
    const propsStack = $41c2ae5820248293$export$1327128ea5b9a1e8(element, parent);
    // Update the element
    if (propsStack.length) $41c2ae5820248293$export$b23ca50362483f82(propsStack, element);
    else {
        ref.__propsStack = [];
        element.props = {};
    }
};
const $41c2ae5820248293$export$a121566aadcfe021 = function(element, parent, options) {
    const { __ref: ref } = element;
    if (ref.__if) $41c2ae5820248293$export$d76b848a0167f48b(element, parent);
    else try {
        $41c2ae5820248293$export$d76b848a0167f48b(element, parent);
    } catch (e) {
        if (element.context?.designSystem?.verbose) console.warn('initProps error at', ref.path?.join('.'), e);
        element.props = {};
        ref.__propsStack = [];
    }
    $41c2ae5820248293$export$e290b82348b6726c(element);
    return element;
};
const $41c2ae5820248293$export$c8dce3c08436e91e = (newProps, element, parent)=>{
    const { __ref: ref } = element;
    const propsStack = ref.__propsStack || [];
    // Create a new array to avoid mutating the original
    let newStack = [
        ...propsStack
    ];
    // Add parent props first if they exist
    const parentProps = $41c2ae5820248293$export$d25057a75c14aff7(element, parent);
    if (parentProps.length) newStack = [
        ...parentProps,
        ...newStack
    ];
    // Add new props if they exist
    if (newProps) newStack = [
        newProps,
        ...newStack
    ];
    // Clean up duplicates
    ref.__propsStack = $41c2ae5820248293$export$44466878677fcc43(newStack);
    if (ref.__propsStack.length) $41c2ae5820248293$export$b23ca50362483f82(ref.__propsStack, element);
    return element;
};

});
parcelRegister("gSDtL", function(module, exports) {

$parcel$export(module.exports, "addEventFromProps", () => $c4a05031ab071991$export$4c071752ff9c2992);

var $1zeno = parcelRequire("1zeno");

var $fX7ii = parcelRequire("fX7ii");
'use strict';
function $c4a05031ab071991$export$4c071752ff9c2992(key, obj) {
    const { props: props, on: on } = obj;
    const eventName = (0, $1zeno.lowercaseFirstLetter)(key.split('on')[1]);
    const origEvent = on[eventName];
    const funcFromProps = props[key];
    if ((0, $fX7ii.isFunction)(origEvent)) on[eventName] = (...args)=>{
        const originalEventRetunrs = origEvent(...args);
        if (originalEventRetunrs !== false) {
            if ((0, $fX7ii.isFunction)(funcFromProps)) return funcFromProps(...args);
        }
    };
    else on[eventName] = funcFromProps;
}

});


parcelRegister("e4kX4", function(module, exports) {

$parcel$export(module.exports, "returnValueAsText", () => $a3e1b0fcad6874d8$export$dfa23c5e4a54ab0c);
$parcel$export(module.exports, "createBasedOnType", () => $a3e1b0fcad6874d8$export$927f99b3b8be13bc);
$parcel$export(module.exports, "addRef", () => $a3e1b0fcad6874d8$export$67a43d775655c9fa);
$parcel$export(module.exports, "createParent", () => $a3e1b0fcad6874d8$export$afa4f66aa2aa78ad);
$parcel$export(module.exports, "createRoot", () => $a3e1b0fcad6874d8$export$882461b6382ed46c);
$parcel$export(module.exports, "createPath", () => $a3e1b0fcad6874d8$export$fe53371bee54353d);
$parcel$export(module.exports, "addContext", () => $a3e1b0fcad6874d8$export$f02680d0c92070c1);
$parcel$export(module.exports, "addCaching", () => $a3e1b0fcad6874d8$export$ffc78f972bfbae8a);
$parcel$export(module.exports, "createElement", () => $a3e1b0fcad6874d8$export$c8a8987d4410bf2d);

var $1e3EP = parcelRequire("1e3EP");

var $60FHT = parcelRequire("60FHT");

var $elDKY = parcelRequire("elDKY");

var $5E2zl = parcelRequire("5E2zl");

var $6DXv0 = parcelRequire("6DXv0");

var $fX7ii = parcelRequire("fX7ii");
'use strict';
const $a3e1b0fcad6874d8$var$ENV = "upcoming";
const $a3e1b0fcad6874d8$export$dfa23c5e4a54ab0c = (element, parent, key)=>{
    const childExtendsTag = parent.childExtends && parent.childExtends.tag;
    const childPropsTag = parent.childProps && parent.childProps.tag;
    const isKeyValidHTMLTag = (0, $6DXv0.HTML_TAGS).body.has(key) && key;
    return {
        text: element,
        tag: childExtendsTag || childPropsTag || isKeyValidHTMLTag || 'string'
    };
};
const $a3e1b0fcad6874d8$export$927f99b3b8be13bc = (element, parent, key)=>{
    // if ELEMENT is not given
    if (element === undefined) {
        if ($a3e1b0fcad6874d8$var$ENV === 'test' || $a3e1b0fcad6874d8$var$ENV === 'development') console.warn(key, 'element is undefined in', parent?.__ref?.path);
        return {};
    }
    if (element === null) return;
    if (element === true) return {};
    if ((0, $fX7ii.is)(element)('string', 'number')) return $a3e1b0fcad6874d8$export$dfa23c5e4a54ab0c(element, parent, key);
    if ((0, $fX7ii.isFunction)(element)) return {
        props: element
    };
    return element;
};
const $a3e1b0fcad6874d8$export$67a43d775655c9fa = (element, parent)=>{
    const ref = {};
    ref.origin = element;
    ref.parent = parent;
    return ref;
};
const $a3e1b0fcad6874d8$export$afa4f66aa2aa78ad = (element, parent, key, options, root)=>{
    if (!parent) return root;
    if ((0, $elDKY.isNode)(parent)) {
        const parentNodeWrapper = {
            key: ':root',
            node: parent
        };
        root[`${key}_parent`] = parentNodeWrapper;
        return parentNodeWrapper;
    }
    return parent;
};
const $a3e1b0fcad6874d8$export$882461b6382ed46c = (element, parent)=>{
    const { __ref: ref } = element;
    const { __ref: parentRef } = parent;
    const hasRoot = parent && parent.key === ':root';
    if (!ref?.root) ref.root = hasRoot ? element : parentRef?.root;
};
const $a3e1b0fcad6874d8$export$fe53371bee54353d = (element, parent, key)=>{
    let { __ref: parentRef } = parent;
    // set the PATH array
    if (!parentRef) parentRef = parent.ref = {};
    if (!parentRef.path) parentRef.path = [];
    return parentRef.path.concat(key);
};
const $a3e1b0fcad6874d8$export$f02680d0c92070c1 = (element, parent, key, options, root)=>{
    const forcedOptionsContext = options.context && !root.context && !element.context;
    if (forcedOptionsContext) root.context = options.context;
    // inherit from parent or root
    return options.context || parent.context || root.context || element.context;
};
const $a3e1b0fcad6874d8$export$ffc78f972bfbae8a = (element, parent, key)=>{
    const ref = $a3e1b0fcad6874d8$export$67a43d775655c9fa(element, parent);
    element.__ref = ref;
    // enable CACHING
    if (!ref.__defineCache) ref.__defineCache = {};
    // enable EXEC
    if (!ref.__exec) ref.__exec = {};
    if (!ref.__execProps) ref.__execProps = {};
    // enable CLASS CACHING
    if (!ref.__class) ref.__class = {};
    if (!ref.__classNames) ref.__classNames = {};
    // enable CLASS CACHING
    if (!ref.__attr) ref.__attr = {};
    // enable CHANGES storing
    if (!ref.__changes) ref.__changes = [];
    // enable CHANGES storing
    if (!ref.__children) ref.__children = [];
    ref.__extends = (0, $1e3EP.createExtends)(element, parent, key);
    ref.path = $a3e1b0fcad6874d8$export$fe53371bee54353d(element, parent, key);
    return ref;
};
const $a3e1b0fcad6874d8$export$c8a8987d4410bf2d = (passedProps, parentEl, passedKey, opts, root)=>{
    const hashed = passedProps?.__hash;
    const element = hashed ? {
        extends: [
            passedProps
        ]
    } : $a3e1b0fcad6874d8$export$927f99b3b8be13bc(passedProps, parentEl, passedKey);
    if (!element) return;
    const parent = $a3e1b0fcad6874d8$export$afa4f66aa2aa78ad(element, parentEl, passedKey, opts, root);
    const key = (0, $60FHT.createKey)(element, parent, passedKey);
    $a3e1b0fcad6874d8$export$ffc78f972bfbae8a(element, parent, key);
    const props = (0, $5E2zl.createProps)(element, parent, key);
    const context = $a3e1b0fcad6874d8$export$f02680d0c92070c1(element, parent, key, opts, root);
    const on = element.on || {};
    return {
        ...element,
        key: key,
        props: props,
        parent: parent,
        context: context,
        on: on
    };
};

});

parcelRegister("e2xa8", function(module, exports) {

$parcel$export(module.exports, "checkForStateTypes", () => $a38af9f74e58d0b2$export$1a615c2b5db1076e);
$parcel$export(module.exports, "getRootStateInKey", () => $a38af9f74e58d0b2$export$c138e045c9d99c0);
$parcel$export(module.exports, "getParentStateInKey", () => $a38af9f74e58d0b2$export$f7dd4f6f6830b29d);
$parcel$export(module.exports, "getChildStateInKey", () => $a38af9f74e58d0b2$export$e6d108f71cc7e736);
$parcel$export(module.exports, "findInheritedState", () => $a38af9f74e58d0b2$export$487549069bb5d2a9);
$parcel$export(module.exports, "checkIfInherits", () => $a38af9f74e58d0b2$export$e187d7e20e9fd8fa);
$parcel$export(module.exports, "createInheritedState", () => $a38af9f74e58d0b2$export$c546cc738d4564ba);
$parcel$export(module.exports, "isState", () => $a38af9f74e58d0b2$export$e5d60a6bbabd36f);
$parcel$export(module.exports, "createNestedObjectByKeyPath", () => $a38af9f74e58d0b2$export$a1831dd7b6191ba4);
$parcel$export(module.exports, "applyDependentState", () => $a38af9f74e58d0b2$export$af8fd5cebbe79a02);
$parcel$export(module.exports, "overwriteState", () => $a38af9f74e58d0b2$export$dd6f28ea13b47393);

var $j1b7T = parcelRequire("j1b7T");

var $350cP = parcelRequire("350cP");

var $bmfNh = parcelRequire("bmfNh");

var $fX7ii = parcelRequire("fX7ii");
'use strict';
const $a38af9f74e58d0b2$export$1a615c2b5db1076e = (element)=>{
    const { state: orig, props: props, __ref: ref } = element;
    const state = props?.state || orig;
    if ((0, $fX7ii.is)(state)('string', 'number')) {
        ref.__state = state;
        return {
            value: state
        };
    } else if (state === true) {
        ref.__state = element.key;
        return {};
    } else if (state) {
        ref.__hasRootState = true;
        return state;
    } else return false;
};
const $a38af9f74e58d0b2$export$c138e045c9d99c0 = (stateKey, parentState)=>{
    if (!stateKey.includes('~/')) return;
    const arr = stateKey.split('~/');
    if (arr.length > 1) return parentState.root;
};
const $a38af9f74e58d0b2$export$f7dd4f6f6830b29d = (stateKey, parentState)=>{
    if (!stateKey.includes('../')) return;
    const arr = stateKey.split('../');
    const arrLength = arr.length - 1;
    for(let i = 0; i < arrLength; i++){
        if (!parentState.parent) return null;
        parentState = parentState.parent;
    }
    return parentState;
};
const $a38af9f74e58d0b2$export$e6d108f71cc7e736 = (stateKey, parentState, options = {})=>{
    const arr = (0, $fX7ii.isString)(stateKey) ? stateKey.split('/') : [
        stateKey
    ];
    const arrLength = arr.length - 1;
    for(let i = 0; i < arrLength; i++){
        const childKey = arr[i];
        const grandChildKey = arr[i + 1];
        if (childKey === '__proto__' || grandChildKey === '__proto__') return;
        let childInParent = parentState[childKey];
        if (!childInParent) childInParent = parentState[childKey] = {} // check for array
        ;
        if (!childInParent[grandChildKey]) childInParent[grandChildKey] = {} // check for array
        ;
        stateKey = grandChildKey;
        parentState = childInParent;
    }
    if (options.returnParent) return parentState;
    return parentState[stateKey];
};
const $a38af9f74e58d0b2$export$487549069bb5d2a9 = (element, parent, options = {})=>{
    const ref = element.__ref;
    let stateKey = ref.__state;
    if (!$a38af9f74e58d0b2$export$e187d7e20e9fd8fa(element)) return;
    const rootState = $a38af9f74e58d0b2$export$c138e045c9d99c0(stateKey, parent.state);
    let parentState = parent.state;
    if (rootState) {
        parentState = rootState;
        stateKey = stateKey.replaceAll('~/', '');
    } else {
        const findGrandParentState = $a38af9f74e58d0b2$export$f7dd4f6f6830b29d(stateKey, parent.state);
        if (findGrandParentState) {
            parentState = findGrandParentState;
            stateKey = stateKey.replaceAll('../', '');
        }
    }
    if (!parentState) return;
    return $a38af9f74e58d0b2$export$e6d108f71cc7e736(stateKey, parentState, options);
};
const $a38af9f74e58d0b2$export$c546cc738d4564ba = (element, parent)=>{
    const ref = element.__ref;
    const inheritedState = $a38af9f74e58d0b2$export$487549069bb5d2a9(element, parent);
    if (inheritedState === undefined) return element.state;
    if ((0, $fX7ii.is)(inheritedState)('object', 'array')) return (0, $bmfNh.deepClone)(inheritedState);
    else if ((0, $fX7ii.is)(inheritedState)('string', 'number', 'boolean')) {
        ref.__stateType = typeof inheritedState;
        return {
            value: inheritedState
        };
    }
    console.warn(ref.__state, 'is not present. Replacing with', {});
};
const $a38af9f74e58d0b2$export$e187d7e20e9fd8fa = (element)=>{
    const { __ref: ref } = element;
    const stateKey = ref?.__state;
    if (stateKey && (0, $fX7ii.is)(stateKey)('number', 'string', 'boolean')) return true;
    return false;
};
const $a38af9f74e58d0b2$export$e5d60a6bbabd36f = function(state) {
    if (!(0, $fX7ii.isObjectLike)(state)) return false;
    return Boolean(state.update && state.parse && state.clean && state.create && state.parent && state.destroy && state.rootUpdate && state.parentUpdate && state.keys && state.values && state.toggle && state.replace && state.quietUpdate && state.quietReplace && state.add && state.apply && state.applyReplace && state.setByPath && state.setPathCollection && state.removeByPath && state.removePathCollection && state.getByPath && state.applyFunction && state.__element && state.__children);
};
const $a38af9f74e58d0b2$export$a1831dd7b6191ba4 = (path, value)=>{
    if (!path) return value || {};
    const keys = path.split('/');
    const obj = {};
    let ref = obj;
    const lastIdx = keys.length - 1;
    for(let i = 0; i <= lastIdx; i++){
        ref[keys[i]] = i === lastIdx ? value || {} : {};
        ref = ref[keys[i]];
    }
    return obj;
};
const $a38af9f74e58d0b2$export$af8fd5cebbe79a02 = (element, state)=>{
    const { __element: __element } = state;
    const origState = __element?.state;
    if (!origState) return;
    const dependentState = (0, $bmfNh.deepClone)(origState, (0, $350cP.STATE_METHODS));
    const newDepends = {
        [element.key]: dependentState
    };
    const __depends = (0, $fX7ii.isObject)(origState.__depends) ? {
        ...origState.__depends,
        ...newDepends
    } : newDepends;
    if (Array.isArray(origState)) (0, $j1b7T.addProtoToArray)(origState, {
        ...Object.getPrototypeOf(origState),
        __depends: __depends
    });
    else Object.setPrototypeOf(origState, {
        ...Object.getPrototypeOf(origState),
        __depends: __depends
    });
    return dependentState;
};
const $a38af9f74e58d0b2$export$dd6f28ea13b47393 = (state, obj, options = {})=>{
    const { overwrite: overwrite } = options;
    if (!overwrite) return;
    const shallow = overwrite === 'shallow';
    const merge = overwrite === 'merge';
    if (merge) {
        (0, $bmfNh.deepMerge)(state, obj, (0, $350cP.STATE_METHODS));
        return;
    }
    const overwriteFunc = shallow ? (0, $bmfNh.overwriteShallow) : (0, $bmfNh.overwriteDeep);
    overwriteFunc(state, obj, (0, $350cP.STATE_METHODS));
};

});

parcelRegister("6JufH", function(module, exports) {

$parcel$export(module.exports, "createScope", () => $4e6e69882f609804$export$41a9651decfe2bde);
'use strict';
const $4e6e69882f609804$export$41a9651decfe2bde = (element, parent)=>{
    const { __ref: ref } = element;
    const context = element.context || parent.context || ref.root?.context;
    // Ensure globalScope exists on context
    if (context && !context.globalScope) context.globalScope = {};
    const parentScope = parent.scope || ref.root?.scope;
    const globalScope = context?.globalScope;
    if (!element.scope) {
        // No own scope defined — inherit parent scope directly
        if (parentScope) element.scope = parentScope;
        else if (globalScope) // No parent scope either — create root-level scope with globalScope as prototype
        element.scope = Object.create(globalScope);
        else element.scope = {};
    } else if (typeof element.scope === 'object' && element.scope !== null) // Element defines its own scope — chain prototype to parent scope (or globalScope)
    {
        if (Object.getPrototypeOf(element.scope) === Object.prototype) {
            const proto = parentScope || globalScope;
            if (proto) Object.setPrototypeOf(element.scope, proto);
        }
    }
};

});

parcelRegister("c5dHw", function(module, exports) {

$parcel$export(module.exports, "spotByPath", () => spotByPath);
$parcel$export(module.exports, "lookup", () => lookup);
$parcel$export(module.exports, "lookdown", () => lookdown);
$parcel$export(module.exports, "lookdownAll", () => lookdownAll);
$parcel$export(module.exports, "setNodeStyles", () => setNodeStyles);
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "get", () => get);
$parcel$export(module.exports, "setProps", () => setProps);
$parcel$export(module.exports, "getRef", () => getRef);
$parcel$export(module.exports, "getChildren", () => getChildren);
$parcel$export(module.exports, "getPath", () => getPath);
$parcel$export(module.exports, "getRootState", () => getRootState);
$parcel$export(module.exports, "getRoot", () => getRoot);
$parcel$export(module.exports, "getRootData", () => getRootData);
$parcel$export(module.exports, "getRootContext", () => getRootContext);
$parcel$export(module.exports, "getContext", () => getContext);
$parcel$export(module.exports, "defineSetter", () => defineSetter);
$parcel$export(module.exports, "keys", () => keys);
$parcel$export(module.exports, "parse", () => parse);
$parcel$export(module.exports, "parseDeep", () => parseDeep);
$parcel$export(module.exports, "verbose", () => verbose);
$parcel$export(module.exports, "log", () => log);
$parcel$export(module.exports, "warn", () => warn);
$parcel$export(module.exports, "error", () => error);
$parcel$export(module.exports, "nextElement", () => nextElement);
$parcel$export(module.exports, "previousElement", () => previousElement);
$parcel$export(module.exports, "variables", () => variables);
$parcel$export(module.exports, "call", () => call);
$parcel$export(module.exports, "getDB", () => getDB);
$parcel$export(module.exports, "getQuery", () => getQuery);
$parcel$export(module.exports, "isMethod", () => isMethod);

var $9VZBt = parcelRequire("9VZBt");

var $350cP = parcelRequire("350cP");

var $fX7ii = parcelRequire("fX7ii");

var $bmfNh = parcelRequire("bmfNh");

var $kt4aQ = parcelRequire("kt4aQ");

var $j1b7T = parcelRequire("j1b7T");

var $l1svM = parcelRequire("l1svM");
'use strict';
const ENV = "upcoming";
function spotByPath(path) {
    const element = this;
    const { __ref: ref } = element;
    const arr = [].concat(path);
    let foundelement = ref.root[arr[0]];
    if (!arr || !arr.length) return console.log(arr, 'on', element.key, 'is undefined');
    while(foundelement.key === arr[0]){
        arr.shift();
        if (!arr.length) break;
        foundelement = foundelement[arr[0]];
        if (!foundelement) return;
    }
    return foundelement;
}
function lookup(param) {
    const el = this;
    let { parent } = el;
    if ((0, $fX7ii.isFunction)(param)) {
        if (parent.state && param(parent, parent.state, parent.context)) return parent;
        else if (parent.parent) return parent.lookup(param);
        else return;
    }
    if (el[param]) return el[param];
    while(parent.param !== param){
        if (parent[param]) return parent[param];
        parent = parent.parent;
        if (!parent) return;
    }
    return parent;
}
function lookdown(param) {
    const el = this;
    const { __ref: ref } = el;
    const children = ref?.__children;
    if (!children) return;
    for(let i = 0; i < children.length; i++){
        const v = children[i];
        const childElem = el[v];
        if (v === param) return childElem;
        else if ((0, $fX7ii.isFunction)(param)) {
            const exec = param(childElem, childElem.state, childElem.context);
            if (childElem.state && exec) return childElem;
        }
        const lookdown = childElem?.lookdown?.(param);
        if (lookdown) return lookdown;
    }
}
function lookdownAll(param, results = []) {
    const el = this;
    const { __ref: ref } = el;
    const children = ref?.__children;
    if (!children) return;
    for(let i = 0; i < children.length; i++){
        const v = children[i];
        const childElem = el[v];
        if (v === param) results.push(childElem);
        else if ((0, $fX7ii.isFunction)(param)) {
            const exec = param(childElem, childElem.state, childElem.context);
            if (childElem.state && exec) results.push(childElem);
        }
        childElem?.lookdownAll?.(param, results);
    }
    return results.length ? results : undefined;
}
function setNodeStyles(params = {}) {
    const el = this;
    if (!el.node?.style) return;
    for(const param in params){
        const value = params[param];
        const childElem = el[param];
        if ((0, $fX7ii.isObject)(value) && childElem) setNodeStyles.call(childElem, value);
        else el.node.style[param] = value;
    }
    return el;
}
function remove(opts) {
    const element = this;
    const beforeRemoveReturns = (0, $9VZBt.triggerEventOn)('beforeRemove', element, opts);
    if (beforeRemoveReturns === false) return element;
    if ((0, $fX7ii.isFunction)(element.node.remove)) element.node.remove();
    else if (!(0, $kt4aQ.isProduction)()) {
        console.warn('This item cant be removed');
        element.log();
    }
    delete element.parent[element.key];
    if (element.parent.__ref) element.parent.__ref.__children = (0, $j1b7T.removeValueFromArray)(element.parent.__ref.__children, element.key);
    (0, $9VZBt.triggerEventOn)('remove', element, opts);
}
function get(param) {
    const element = this;
    return element[param];
}
function setProps(param, options) {
    const element = this;
    if (!param) return;
    element.update(param, options);
    return element;
}
function getRef(key) {
    if (key) return this.__ref && this.__ref[key];
    return this.__ref;
}
function getChildren() {
    const __children = this.getRef('__children');
    return __children.map((k)=>this[k]);
}
function getPath() {
    return this.getRef().path;
}
function getRootState(param) {
    let state = null;
    const hasRootState = (obj)=>obj.__element && obj.root?.isRootState;
    if (!this) state = window.platformState || window.smblsApp?.state;
    else if (hasRootState(this)) state = this.root;
    else if (this.__ref && this.__ref.path) {
        const hasPlatformState = this.state && hasRootState(this.state);
        const hasPlatformStateOnParent = (0, $fX7ii.isFunction)(this.state) && this.parent.state && hasRootState(this.parent.state);
        if (hasPlatformState || hasPlatformStateOnParent) state = this.state.root || this.parent.state.root;
    }
    if (!state) state = window.platformState || window.smblsApp?.state;
    return param ? state?.[param] : state;
}
function getRoot(key) {
    const rootElem = this.getRootState()?.__element;
    return rootElem && Object.keys(rootElem).length > 0 && key ? rootElem[key] : rootElem;
}
function getRootData(key) {
    return this.getRoot('data') && Object.keys(this.getRoot('data')).length > 0 && key ? this.getRoot('data')[key] : this.getRoot('data');
}
function getRootContext(key) {
    const ctx = this.getRoot()?.context;
    return key ? ctx[key] : ctx;
}
function getContext(key) {
    const ctx = this.context;
    return key ? ctx[key] : ctx;
}
const defineSetter = (element, key, get, set)=>Object.defineProperty(element, key, {
        get: get,
        set: set
    });
function keys() {
    const element = this;
    const keys = [];
    for(const param in element){
        if (// (REGISTRY[param] && !DOMQ_PROPERTIES.has(param)) ||
        !Object.prototype.hasOwnProperty.call(element, param) || (0, $350cP.DOMQ_PROPERTIES).has(param) && !(0, $350cP.PARSED_DOMQ_PROPERTIES).has(param)) continue;
        keys.push(param);
    }
    return keys;
}
function parse(excl = []) {
    const element = this;
    const obj = {};
    const keyList = keys.call(element);
    const hasChildren = keyList.includes('children');
    const exclSet = excl.length ? new Set(excl) : null;
    for(let i = 0; i < keyList.length; i++){
        const v = keyList[i];
        if (exclSet && exclSet.has(v) || !Object.prototype.hasOwnProperty.call(element, v)) continue;
        if (hasChildren && v === 'content') continue;
        const val = element[v];
        if (v === 'state') {
            if (element.__ref && !element.__ref.__hasRootState) continue;
            const parsedVal = (0, $fX7ii.isFunction)(val && val.parse) ? val.parse() : val;
            obj[v] = (0, $fX7ii.isFunction)(parsedVal) ? parsedVal : JSON.parse(JSON.stringify(parsedVal || {}));
        } else if (v === 'scope') {
            if (element.__ref && !element.__ref.__hasRootScope) continue;
            obj[v] = JSON.parse(JSON.stringify(val || {}));
        } else if (v === 'props') {
            const { __element, update, ...props } = element[v];
            obj[v] = props;
        } else if ((0, $fX7ii.isDefined)(val) && Object.prototype.hasOwnProperty.call(element, v)) obj[v] = val;
    }
    return obj;
}
function parseDeep(excl = [], visited = new WeakSet()) {
    const element = this;
    if (visited.has(element)) return undefined;
    visited.add(element);
    const obj = parse.call(element, excl);
    const exclSet = excl.length ? new Set(excl) : null;
    for(const v in obj){
        if (exclSet && exclSet.has(v) || !Object.prototype.hasOwnProperty.call(element, v)) continue;
        const val = obj[v];
        if (Array.isArray(val)) obj[v] = val.map((item)=>(0, $fX7ii.isObjectLike)(item) ? parseDeep.call(item, excl, visited) : item);
        else if ((0, $fX7ii.isObjectLike)(val)) obj[v] = parseDeep.call(val, excl, visited);
    }
    return obj;
}
function verbose(...args) {
    if (ENV !== 'test' && ENV !== 'development') return;
    const element = this;
    const { __ref: ref } = element;
    console.groupCollapsed(element.key);
    if (args.length) args.forEach((v)=>console.log(`%c${v}:\n`, 'font-weight: bold', element[v]));
    else {
        console.log(ref.path);
        const keys = element.keys();
        keys.forEach((v)=>console.log(`%c${v}:`, 'font-weight: bold', element[v]));
    }
    console.log(element);
    console.groupEnd(element.key);
    return element;
}
function log(...params) {
    if (ENV === 'test' || ENV === 'development') console.log(...params);
}
function warn(...params) {
    if (ENV === 'test' || ENV === 'development') console.warn(...params);
}
function error(...params) {
    if (ENV === 'test' || ENV === 'development') {
        if (params[params.length - 1]?.debugger) debugger; // eslint-disable-line
        if (params[params.length - 1]?.verbose) verbose.call(this);
        throw new Error(...params);
    }
}
function nextElement() {
    const element = this;
    const { key, parent } = element;
    const { __children } = parent.__ref;
    const currentIndex = __children.indexOf(key);
    const nextChild = __children[currentIndex + 1];
    return parent[nextChild];
}
function previousElement(el) {
    const element = el || this;
    const { key, parent } = element;
    const { __children } = parent.__ref;
    if (!__children) return;
    const currentIndex = __children.indexOf(key);
    return parent[__children[currentIndex - 1]];
}
function variables(obj = {}) {
    const element = this;
    if (!element.data) element.data = {};
    if (!element.data.varCaches) element.data.varCaches = {};
    const varCaches = element.data.varCaches;
    const changes = {};
    let changed;
    for(const key in obj)if (obj[key] !== varCaches[key]) {
        changed = true;
        changes[key] = obj[key];
    }
    return {
        changed: (cb)=>{
            if (!changed) return;
            const returns = cb(changes, (0, $bmfNh.deepClone)(varCaches));
            for(const key in changes)varCaches[key] = changes[key];
            return returns;
        },
        timeout: (cb, timeout)=>{
            if (!changed) return;
            const t = setTimeout(()=>{
                cb(changes);
                clearTimeout(t);
            }, timeout);
        }
    };
}
function call(fnKey, ...args) {
    const context = this.context;
    const fn = context.utils?.[fnKey] || context.functions?.[fnKey] || context.methods?.[fnKey] || context.snippets?.[fnKey];
    if (!fn) return;
    try {
        const result = fn.call(this, ...args);
        if (result && typeof result.then === 'function') result.catch((err)=>{
            error.call(this, err);
        });
        return result;
    } catch (err) {
        error.call(this, err);
        if (context?.strictMode) throw err;
    }
}




async function getDB() {
    const element = this;
    const db = element.context?.fetch;
    if (!db) return null;
    if (typeof db.select === 'function') {
        if (!db.__authInitialized && db.getSession) {
            const { initAdapterAuth } = await Promise.resolve((parcelRequire("fLrnc")));
            await initAdapterAuth(db, element.context);
        }
        return db;
    }
    if (db.__resolved) {
        if (!db.__resolved.__authInitialized && db.__resolved.getSession) {
            const { initAdapterAuth } = await Promise.resolve((parcelRequire("fLrnc")));
            await initAdapterAuth(db.__resolved, element.context);
        }
        return db.__resolved;
    }
    if (db.__resolving) return db.__resolving;
    // Set __resolving synchronously BEFORE the async import to prevent
    // resolveAdapter() from starting a parallel resolveDb() during the yield
    const resolvePromise = Promise.resolve((parcelRequire("fLrnc"))).then(({ resolveDb })=>resolveDb(db));
    db.__resolving = resolvePromise;
    const resolved = await resolvePromise;
    db.__resolved = resolved;
    element.context.fetch = resolved;
    delete db.__resolving;
    if (resolved.getSession) {
        const { initAdapterAuth } = await Promise.resolve((parcelRequire("fLrnc")));
        await initAdapterAuth(resolved, element.context);
    }
    return resolved;
}
function getQuery(format) {
    const element = this;
    const useStateQuery = format || (0, $l1svM.OPTIONS).useStateQuery || element.context?.useStateQuery;
    if (!useStateQuery) return null;
    const query = {};
    buildQueryFromElement(element, query);
    if (useStateQuery === true) return query;
    const formatter = QUERY_FORMATTERS[useStateQuery];
    return formatter ? formatter(query) : query;
}
const buildQueryFromElement = (element, query)=>{
    const ref = element.__ref;
    if (!ref) return;
    const stateKey = ref.__state;
    if (stateKey && typeof stateKey === 'string') setQueryPath(query, stateKey);
    const children = ref.__children;
    if (children) for(let i = 0; i < children.length; i++){
        const child = element[children[i]];
        if (child && child.__ref) buildQueryFromElement(child, query);
    }
    const contentKey = ref.contentElementKey || 'content';
    const content = element[contentKey];
    if (content && content.__ref) buildQueryFromElement(content, query);
};
const setQueryPath = (query, path)=>{
    const clean = path.replaceAll('../', '').replaceAll('~/', '');
    const parts = clean.split('/');
    let current = query;
    for(let i = 0; i < parts.length; i++){
        const part = parts[i];
        if (i === parts.length - 1) {
            if (!current[part]) current[part] = true;
        } else {
            if (current[part] === true) current[part] = {};
            if (!current[part]) current[part] = {};
            current = current[part];
        }
    }
};
// --- Query formatters ---
const queryToGraphQL = (query, indent = 0)=>{
    const pad = '  '.repeat(indent);
    const entries = Object.entries(query);
    if (!entries.length) return '';
    const fields = entries.map(([key, value])=>{
        if (value === true) return `${pad}${key}`;
        return `${pad}${key} {\n${queryToGraphQL(value, indent + 1)}\n${pad}}`;
    });
    return fields.join('\n');
};
const formatGraphQL = (query)=>{
    return `{\n${queryToGraphQL(query, 1)}\n}`;
};
const formatJsonApi = (query)=>{
    const result = {
        fields: {},
        include: []
    };
    const walk = (obj, prefix)=>{
        const fields = [];
        for(const key in obj)if (obj[key] === true) fields.push(key);
        else {
            const nested = prefix ? `${prefix}.${key}` : key;
            result.include.push(nested);
            walk(obj[key], nested);
        }
        if (fields.length) result.fields[prefix || '_root'] = fields;
    };
    walk(query, '');
    return result;
};
const formatOData = (query)=>{
    const build = (obj)=>{
        const select = [];
        const expand = [];
        for(const key in obj)if (obj[key] === true) select.push(key);
        else {
            const nested = build(obj[key]);
            const parts = [];
            if (nested.select) parts.push(`$select=${nested.select}`);
            if (nested.expand) parts.push(`$expand=${nested.expand}`);
            expand.push(parts.length ? `${key}(${parts.join(';')})` : key);
        }
        return {
            select: select.length ? select.join(',') : '',
            expand: expand.length ? expand.join(',') : ''
        };
    };
    const { select, expand } = build(query);
    const parts = [];
    if (select) parts.push(`$select=${select}`);
    if (expand) parts.push(`$expand=${expand}`);
    return parts.join('&');
};
const formatSQL = (query, options)=>{
    const columns = [];
    const joins = [];
    const tables = new Set();
    const walk = (obj, table, parentTable)=>{
        tables.add(table);
        if (parentTable) joins.push(`LEFT JOIN ${table} ON ${table}.${parentTable}_id = ${parentTable}.id`);
        for(const key in obj)if (obj[key] === true) columns.push(`${table}.${key}`);
        else walk(obj[key], key, table);
    };
    const roots = Object.keys(query);
    if (roots.length === 1 && query[roots[0]] !== true) walk(query[roots[0]], roots[0], null);
    else walk(query, '_root', null);
    const from = [
        ...tables
    ][0] || '_root';
    const select = columns.length ? columns.join(', ') : '*';
    const joinStr = joins.length ? '\n' + joins.join('\n') : '';
    return `SELECT ${select}\nFROM ${from}${joinStr}`;
};
const formatPaths = (query)=>{
    const paths = [];
    const walk = (obj, prefix)=>{
        for(const key in obj){
            const path = prefix ? `${prefix}/${key}` : key;
            if (obj[key] === true) paths.push(path);
            else walk(obj[key], path);
        }
    };
    walk(query, '');
    return paths;
};
const formatSupabase = (query)=>{
    const build = (obj)=>{
        const parts = [];
        for(const key in obj)if (obj[key] === true) parts.push(key);
        else parts.push(`${key}(${build(obj[key])})`);
        return parts.join(', ');
    };
    const roots = Object.keys(query);
    if (roots.length === 1 && query[roots[0]] !== true) return {
        from: roots[0],
        select: build(query[roots[0]])
    };
    return {
        from: null,
        select: build(query)
    };
};
const QUERY_FORMATTERS = {
    graphql: formatGraphQL,
    'json-api': formatJsonApi,
    odata: formatOData,
    sql: formatSQL,
    supabase: formatSupabase,
    paths: formatPaths
};
function isMethod(param, element) {
    return Boolean((0, $350cP.METHODS).has(param) || element?.context?.methods?.[param]);
}

});
parcelRegister("9VZBt", function(module, exports) {

$parcel$export(module.exports, "applyEvent", () => $73b9391b45095143$export$27ca81ea148fa005);
$parcel$export(module.exports, "triggerEventOn", () => $73b9391b45095143$export$1bc010482b845252);
$parcel$export(module.exports, "applyEventUpdate", () => $73b9391b45095143$export$906113ec468a9c43);
$parcel$export(module.exports, "triggerEventOnUpdate", () => $73b9391b45095143$export$8fe90418b8a0fc1e);

var $fX7ii = parcelRequire("fX7ii");

var $aQqva = parcelRequire("aQqva");
'use strict';
const $73b9391b45095143$var$getOnOrPropsEvent = (param, element)=>{
    const propKey = 'on' + param.charAt(0).toUpperCase() + param.slice(1);
    return element[propKey];
};
const $73b9391b45095143$export$27ca81ea148fa005 = (param, element, state, context, options)=>{
    param = (0, $aQqva.resolveHandler)(param, element);
    if (!(0, $fX7ii.isFunction)(param)) return;
    try {
        const result = param.call(element, element, state || element.state, context || element.context, options);
        if (result && typeof result.then === 'function') result.catch((err)=>{
            element.error = err;
            if (err instanceof ReferenceError) console.warn('[DOMQL] Async event warning:', err.message);
            else console.error('[DOMQL] Async event error:', err);
        });
        return result;
    } catch (err) {
        element.error = err;
        // In SSR/brender mode, ReferenceErrors for missing client-only helpers
        // are expected (e.g. DOM animation functions). Log concisely.
        if (err instanceof ReferenceError) console.warn('[DOMQL] Event handler warning:', err.message);
        else console.error('[DOMQL] Event handler error:', err);
        if (element.context?.strictMode) throw err;
    }
};
const $73b9391b45095143$export$1bc010482b845252 = (param, element, options)=>{
    if (!element) throw new Error('Element is required');
    (0, $aQqva.runPluginHook)(param, element, options);
    const appliedFunction = $73b9391b45095143$var$getOnOrPropsEvent(param, element);
    if (appliedFunction) {
        const { state: state, context: context } = element;
        return $73b9391b45095143$export$27ca81ea148fa005(appliedFunction, element, state, context, options);
    }
};
const $73b9391b45095143$export$906113ec468a9c43 = (param, updatedObj, element, state, context, options)=>{
    param = (0, $aQqva.resolveHandler)(param, element);
    if (!(0, $fX7ii.isFunction)(param)) return;
    try {
        const result = param.call(element, updatedObj, element, state || element.state, context || element.context, options);
        if (result && typeof result.then === 'function') result.catch((err)=>{
            element.error = err;
            console.error('[DOMQL] Async event update error:', err);
        });
        return result;
    } catch (err) {
        element.error = err;
        console.error('[DOMQL] Event update error:', err);
        if (element.context?.strictMode) throw err;
    }
};
const $73b9391b45095143$export$8fe90418b8a0fc1e = (param, updatedObj, element, options)=>{
    (0, $aQqva.runPluginHook)(param, element, updatedObj, options);
    const appliedFunction = $73b9391b45095143$var$getOnOrPropsEvent(param, element);
    if (appliedFunction) {
        const { state: state, context: context } = element;
        return $73b9391b45095143$export$906113ec468a9c43(appliedFunction, updatedObj, element, state, context, options);
    }
};

});

parcelRegister("l1svM", function(module, exports) {

$parcel$export(module.exports, "cache", () => $f4dfcec97db52ca8$export$69a3209f1a06c04d);
$parcel$export(module.exports, "OPTIONS", () => $f4dfcec97db52ca8$export$8eb3892b442747bd);
'use strict';
const $f4dfcec97db52ca8$export$69a3209f1a06c04d = {};
const $f4dfcec97db52ca8$export$8eb3892b442747bd = {};

});


parcelRegister("2I7Zd", function(module, exports) {

$parcel$export(module.exports, "captureSnapshot", () => $1f95e2bfa2090e59$export$537d05c9e22d9551);

var $60FHT = parcelRequire("60FHT");
'use strict';
const $1f95e2bfa2090e59$var$snapshot = {
    snapshotId: (0, $60FHT.createSnapshotId)
};
const $1f95e2bfa2090e59$export$537d05c9e22d9551 = (element, options)=>{
    const ref = element.__ref;
    const { currentSnapshot: currentSnapshot, calleeElement: calleeElement } = options;
    const isCallee = calleeElement === element;
    if (!calleeElement || isCallee) {
        const createdStanpshot = $1f95e2bfa2090e59$var$snapshot.snapshotId();
        ref.__currentSnapshot = createdStanpshot;
        return [
            createdStanpshot,
            element
        ];
    }
    const snapshotOnCallee = calleeElement.__ref.__currentSnapshot;
    if (currentSnapshot < snapshotOnCallee) return [
        snapshotOnCallee,
        calleeElement,
        true
    ];
    return [
        snapshotOnCallee,
        calleeElement
    ];
};

});

parcelRegister("7JFRj", function(module, exports) {

$parcel$export(module.exports, "UNIVERSAL_RESERVED_KEYS", () => $5a1d34a728128922$export$4576588f065b4083);
$parcel$export(module.exports, "isUniversallyReservedKey", () => $5a1d34a728128922$export$e8eb3f609e2673bd);
// Top-level keys that must never land on `ProjectData.data.*` under any
// circumstance. Two categories are universal and truly non-negotiable:
//
//   - JS-level pollution: assigning to `__proto__` / `constructor` /
//     `prototype` can mutate the global prototype chain.
//   - Mongo / server-owned metadata: `_id` / `__v` / `id` / `createdAt` /
//     `updatedAt` / `schema` are allocated or maintained by the server and
//     must be treated as opaque identity. Clients that accidentally send
//     them would either overwrite server state or corrupt the doc.
//
// That's all that belongs here. The larger set of "Project-schema-owned"
// fields (access, visibility, members, subscription, etc.) is derived on
// the server at runtime from `Project.schema.paths`, not enumerated. See
// the server's `services/ProjectContentGuard.js` for that derivation.
// The CLI only needs the universal floor.
const $5a1d34a728128922$export$4576588f065b4083 = new Set([
    '__proto__',
    'constructor',
    'prototype',
    '_id',
    '__v',
    'id',
    'createdAt',
    'updatedAt',
    'schema'
]);
const $5a1d34a728128922$export$e8eb3f609e2673bd = (key)=>typeof key === 'string' && $5a1d34a728128922$export$4576588f065b4083.has(key);

});

parcelRegister("dvkIB", function(module, exports) {

$parcel$export(module.exports, "toggleFullscreen", () => $9d4e3dda6b360acf$export$1aba1ee5e6dc1474);
'use strict';
async function $9d4e3dda6b360acf$export$1aba1ee5e6dc1474(opts) {
    if (!document.fullscreenElement) try {
        await (this.node || document).requestFullscreen();
    } catch (err) {
        console.warn(`Error attempting to enable fullscreen mode: ${err.message} (${err.name})`);
    }
    else await document.exitFullscreen();
}

});

parcelRegister("bbZ29", function(module, exports) {

$parcel$export(module.exports, "CDN_PROVIDERS", () => $826010d302408183$export$14b025088496860c);
$parcel$export(module.exports, "PACKAGE_MANAGER_TO_CDN", () => $826010d302408183$export$1a8b9f70f9282ea1);
$parcel$export(module.exports, "getCdnProviderFromConfig", () => $826010d302408183$export$b5e67ffeac229970);
$parcel$export(module.exports, "getCDNUrl", () => $826010d302408183$export$8407093f131dcef1);
$parcel$export(module.exports, "getImportMapScript", () => $826010d302408183$export$fe7cd7f7aa440aad);
'use strict';
function $826010d302408183$var$onlyDotsAndNumbers(str) {
    return /^[0-9.]+$/.test(str) && str !== '';
}
const $826010d302408183$export$14b025088496860c = {
    skypack: {
        url: 'https://cdn.skypack.dev',
        formatUrl: (pkg, version)=>`${$826010d302408183$export$14b025088496860c.skypack.url}/${pkg}${version !== 'latest' ? `@${version}` : ''}`
    },
    esmsh: {
        url: 'https://esm.sh',
        formatUrl: (pkg, version)=>`${$826010d302408183$export$14b025088496860c.esmsh.url}/${pkg}${version !== 'latest' ? `@${version}` : ''}`
    },
    unpkg: {
        url: 'https://unpkg.com',
        formatUrl: (pkg, version)=>`${$826010d302408183$export$14b025088496860c.unpkg.url}/${pkg}${version !== 'latest' ? `@${version}` : ''}?module`
    },
    jsdelivr: {
        url: 'https://cdn.jsdelivr.net/npm',
        formatUrl: (pkg, version)=>`${$826010d302408183$export$14b025088496860c.jsdelivr.url}/${pkg}${version !== 'latest' ? `@${version}` : ''}/+esm`
    },
    symbols: {
        url: 'https://pkg.symbo.ls',
        formatUrl: (pkg, version)=>{
            if (pkg.split('/').length > 2 || !$826010d302408183$var$onlyDotsAndNumbers(version)) return `${$826010d302408183$export$14b025088496860c.symbols.url}/${pkg}`;
            return `${$826010d302408183$export$14b025088496860c.symbols.url}/${pkg}/${version}.js`;
        }
    }
};
const $826010d302408183$export$1a8b9f70f9282ea1 = {
    'esm.sh': 'esmsh',
    'unpkg': 'unpkg',
    'skypack': 'skypack',
    'jsdelivr': 'jsdelivr',
    'pkg.symbo.ls': 'symbols'
};
const $826010d302408183$export$b5e67ffeac229970 = (symbolsConfig = {})=>{
    const { packageManager: packageManager } = symbolsConfig;
    return $826010d302408183$export$1a8b9f70f9282ea1[packageManager] || null;
};
const $826010d302408183$export$8407093f131dcef1 = (packageName, version = 'latest', provider = 'esmsh')=>{
    const cdnConfig = $826010d302408183$export$14b025088496860c[provider] || $826010d302408183$export$14b025088496860c.esmsh;
    return cdnConfig.formatUrl(packageName, version);
};
const $826010d302408183$export$fe7cd7f7aa440aad = (data, defaultProvider = 'skypack')=>{
    const dependencies = data.dependencies || {};
    const keys = Object.keys(dependencies);
    if (!keys.length) return '';
    const imports = {};
    for (const pkgName of keys){
        const version = dependencies[pkgName] || 'latest';
        imports[pkgName] = $826010d302408183$export$8407093f131dcef1(pkgName, version, defaultProvider);
    }
    return `<script type="importmap">{
    "imports": ${JSON.stringify(imports, null, 2)}
  }</script>`;
};

});

parcelRegister("fAw5d", function(module, exports) {

$parcel$export(module.exports, "formatDate", () => $b5931ad9c58b69c2$export$3ae94a2503e890a1);
'use strict';
const $b5931ad9c58b69c2$export$3ae94a2503e890a1 = (timestamp)=>{
    if (!timestamp) return '';
    const d = new Date(timestamp);
    const ye = new Intl.DateTimeFormat('en', {
        year: 'numeric'
    }).format(d);
    const mo = new Intl.DateTimeFormat('en', {
        month: 'short'
    }).format(d);
    const da = new Intl.DateTimeFormat('en', {
        day: '2-digit'
    }).format(d);
    return `${da} ${mo}, ${ye}`;
};

});

parcelRegister("buium", function(module, exports) {

$parcel$export(module.exports, "detectHeightOnInit", () => $85d0d67ee3b96c3a$export$ffafacae975780e6);
'use strict';
const $85d0d67ee3b96c3a$export$ffafacae975780e6 = (element, state)=>{
    const heightTimeout = setTimeout(()=>{
        const { props: props } = element;
        if (!state.clientHeight) {
            const { node: { clientHeight: clientHeight } } = element;
            if (clientHeight) state.clientHeight = clientHeight;
        }
        if (state.active) {
            if (props.height === 'auto') return;
            element.update({
                height: state.clientHeight
            }, {
                preventBeforeUpdateListener: true,
                preventChildrenUpdate: true
            });
            const setAutoTimeout = setTimeout(()=>{
                element.update({
                    height: 'auto'
                }, {
                    preventBeforeUpdateListener: true,
                    preventChildrenUpdate: true
                });
                clearTimeout(setAutoTimeout);
            }, 450);
        } else element.update({
            height: '0'
        }, {
            preventBeforeUpdateListener: true,
            preventChildrenUpdate: true
        });
        clearTimeout(heightTimeout);
    });
};

});

parcelRegister("iM2sP", function(module, exports) {

$parcel$export(module.exports, "fibonacciNumberByIndex", () => $daae9efcbc59b0f4$export$6d35f41941932cbd);
'use strict';
const $daae9efcbc59b0f4$export$6d35f41941932cbd = function fibonacciNumberByIndex(n) {
    const fib = [
        0,
        1
    ];
    for(let i = 2; i <= n; i++)fib[i] = fib[i - 1] + fib[i - 2];
    return fib[n];
};

});

parcelRegister("eI8bb", function(module, exports) {

$parcel$export(module.exports, "isPhoto", () => $ab5b8502ffa9e46b$export$722f9ea87a439ca4);
'use strict';
const $ab5b8502ffa9e46b$export$722f9ea87a439ca4 = (format)=>[
        'jpeg',
        'gif',
        'jpg',
        'png',
        'tiff',
        'woff'
    ].includes(format);

});

parcelRegister("4YHTc", function(module, exports) {

$parcel$export(module.exports, "loadJavascriptFile", () => $39fecf8ae00501d6$export$f5254c626a3f7f04);
$parcel$export(module.exports, "loadJavascriptFileSync", () => $39fecf8ae00501d6$export$f846581269718859);
$parcel$export(module.exports, "loadJavascriptFileEmbedSync", () => $39fecf8ae00501d6$export$2e2cf34468b4616);
$parcel$export(module.exports, "loadCssFile", () => $39fecf8ae00501d6$export$adc703d835881894);
$parcel$export(module.exports, "loadJavascript", () => $39fecf8ae00501d6$export$8b7778d7ecfcc995);
$parcel$export(module.exports, "loadRemoteScript", () => $39fecf8ae00501d6$export$c432db100969a36b);
$parcel$export(module.exports, "loadRemoteCSS", () => $39fecf8ae00501d6$export$d146908f5d25486);
'use strict';
const $39fecf8ae00501d6$export$f5254c626a3f7f04 = (FILE_URL, async = false, doc = document, type = 'text/javascript')=>{
    return new Promise((resolve, reject)=>{
        try {
            const scriptEle = doc.createElement('script');
            scriptEle.type = type;
            scriptEle.async = async;
            scriptEle.src = FILE_URL;
            scriptEle.addEventListener('load', (ev)=>{
                resolve({
                    status: true
                });
            });
            scriptEle.addEventListener('error', (ev)=>{
                reject(new Error({
                    status: false,
                    message: `Failed to load the script ${FILE_URL}`
                }));
            });
            doc.body.appendChild(scriptEle);
        } catch (error) {
            reject(error);
        }
    });
};
const $39fecf8ae00501d6$export$f846581269718859 = (fileUrl, doc = document, type = 'text/javascript')=>{
    return new Promise((resolve, reject)=>{
        const scriptEle = doc.createElement('script');
        scriptEle.type = type;
        scriptEle.src = fileUrl;
        // Create a blocking overlay
        const blocker = doc.createElement('div');
        blocker.style.cssText = 'position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(255,255,255,0.8);z-index:9999;';
        doc.body.appendChild(blocker);
        scriptEle.onload = ()=>{
            console.log(`Successfully loaded: ${fileUrl}`);
            doc.body.removeChild(blocker);
            resolve();
        };
        scriptEle.onerror = ()=>{
            doc.body.removeChild(blocker);
            reject(new Error(`Failed to load: ${fileUrl}`));
        };
        doc.body.appendChild(scriptEle);
    });
};
const $39fecf8ae00501d6$export$2e2cf34468b4616 = (FILE_URL, doc = document, fallback, type = 'text/javascript')=>{
    const xhr = new window.XMLHttpRequest();
    xhr.open('GET', FILE_URL, false) // false makes the request synchronous
    ;
    xhr.send();
    if (xhr.status === 200) {
        const scriptEle = doc.createElement('script');
        scriptEle.type = type;
        scriptEle.text = xhr.responseText;
        doc.body.appendChild(scriptEle);
        if (typeof fallback === 'function') fallback();
    } else throw new Error(`Failed to load the script ${FILE_URL}`);
};
const $39fecf8ae00501d6$export$adc703d835881894 = (FILE_URL, async = false, doc = document, type = 'text/javascript')=>{
    return new Promise((resolve, reject)=>{
        try {
            const linkElem = doc.createElement('link');
            linkElem.rel = 'stylesheet';
            linkElem.href = FILE_URL;
            linkElem.addEventListener('load', (ev)=>{
                resolve({
                    status: true
                });
            });
            doc.head.appendChild(linkElem);
        } catch (error) {
            reject(error);
        }
    });
};
const $39fecf8ae00501d6$export$8b7778d7ecfcc995 = (body, async = false, doc = document, type = 'text/javascript', id = 'smbls-script')=>{
    try {
        const scriptEle = doc.createElement('script');
        scriptEle.type = type;
        scriptEle.async = async;
        scriptEle.id = id;
        scriptEle.innerHTML = body;
        doc.body.appendChild(scriptEle);
    } catch (error) {
        console.warn(error);
    }
};
function $39fecf8ae00501d6$export$c432db100969a36b(url, options = {}) {
    const { window: window1 = globalThis } = options;
    const { document: document1 = window1.document } = options;
    return new Promise((resolve, reject)=>{
        // Check if script is already loaded
        const existingScript = document1.querySelector(`script[src="${url}"]`);
        if (existingScript) return resolve(existingScript);
        // Create script element
        const script = document1.createElement('script');
        script.src = url;
        script.async = options.async === true;
        script.type = options.type || 'text/javascript';
        // Add optional attributes
        if (options.id) script.id = options.id;
        if (options.integrity) script.integrity = options.integrity;
        if (options.crossOrigin) script.crossOrigin = options.crossOrigin;
        // Setup load and error handlers
        script.onload = ()=>{
            script.onerror = script.onload = null;
            resolve(script);
        };
        script.onerror = ()=>{
            script.onerror = script.onload = null;
            reject(new Error(`Failed to load script: ${url}`));
        };
        // Append the script to the document head
        document1.head.appendChild(script);
    });
}
async function $39fecf8ae00501d6$export$d146908f5d25486(url, options = {}) {
    const { window: window1 = globalThis } = options;
    const { document: document1 = window1.document } = options;
    return new Promise((resolve, reject)=>{
        // Check if stylesheet is already loaded
        const existingLink = document1.querySelector(`link[href="${url}"]`);
        if (existingLink) return resolve(existingLink);
        // Create link element
        const link = document1.createElement('link');
        link.href = url;
        link.rel = options.rel || 'stylesheet';
        link.type = 'text/css';
        link.media = options.media || 'all';
        // Add optional attributes
        if (options.id) link.id = options.id;
        if (options.integrity) link.integrity = options.integrity;
        if (options.crossOrigin) link.crossOrigin = options.crossOrigin;
        // Setup load and error handlers
        link.onload = ()=>{
            link.onerror = link.onload = null;
            resolve(link);
        };
        link.onerror = ()=>{
            link.onerror = link.onload = null;
            reject(new Error(`Failed to load stylesheet: ${url}`));
        };
        // Append the link to the document head
        document1.head.appendChild(link);
    });
}

});

parcelRegister("dW6MF", function(module, exports) {

$parcel$export(module.exports, "generateMetaTags", () => $a255f44bfb621069$export$1beeb737204e5202);
$parcel$export(module.exports, "getPageMetadata", () => $a255f44bfb621069$export$d6de83dbd93927be);

var $fX7ii = parcelRequire("fX7ii");
'use strict';
const $a255f44bfb621069$var$escapeHtml = (text)=>{
    if (text === null || text === undefined) return '';
    const map = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
    };
    return text.toString().replace(/[&<>"']/g, (m)=>map[m]);
};
const $a255f44bfb621069$var$buildAttrs = (obj)=>Object.entries(obj || {}).filter(([_, v])=>v !== undefined).map(([k, v])=>`${k}="${$a255f44bfb621069$var$escapeHtml(v)}"`).join(' ');
const $a255f44bfb621069$export$1beeb737204e5202 = (metadata, isProduction)=>{
    // For non-production (preview/staging), inject noindex into metadata
    // but still generate full OG/Twitter tags for sharing previews
    if (!isProduction) metadata = {
        ...metadata,
        robots: 'noindex'
    };
    const tags = Object.entries(metadata).reduce((acc, [key, value])=>{
        if (!value && value !== 0 && value !== false) return acc;
        if (key === 'title') {
            acc.push(`<title>${$a255f44bfb621069$var$escapeHtml(value)}</title>`);
            return acc;
        }
        if (key === 'canonical') {
            acc.push(`<link rel="canonical" href="${$a255f44bfb621069$var$escapeHtml(value)}">`);
            return acc;
        }
        if (key === 'manifest') {
            acc.push(`<link rel="manifest" href="${$a255f44bfb621069$var$escapeHtml(value)}">`);
            return acc;
        }
        if (key === 'favicon' || key === 'favicons' || key === 'icon' || key === 'icons') {
            const items = Array.isArray(value) ? value : [
                value
            ];
            items.forEach((item)=>{
                if (typeof item === 'string') acc.push(`<link rel="icon" href="${$a255f44bfb621069$var$escapeHtml(item)}">`);
                else if (typeof item === 'object') {
                    const attrs = $a255f44bfb621069$var$buildAttrs(item);
                    if (!/rel=/.test(attrs)) acc.push(`<link rel="icon" ${attrs}>`);
                    else acc.push(`<link ${attrs}>`);
                }
            });
            return acc;
        }
        if (key === 'alternate') {
            const alternates = Array.isArray(value) ? value : [
                value
            ];
            alternates.forEach((alt)=>{
                if (typeof alt === 'object') {
                    const attrs = Object.entries(alt).filter(([_, attrValue])=>attrValue !== undefined).map(([attrKey, attrValue])=>`${attrKey}="${$a255f44bfb621069$var$escapeHtml(attrValue)}"`).join(' ');
                    acc.push(`<link rel="alternate" ${attrs}>`);
                }
            });
            return acc;
        }
        const processMetaTag = (tagKey, tagValue, attrType = 'name')=>{
            if (typeof tagValue === 'string' || typeof tagValue === 'number' || typeof tagValue === 'boolean') acc.push(`<meta ${attrType}="${$a255f44bfb621069$var$escapeHtml(tagKey)}" content="${$a255f44bfb621069$var$escapeHtml(tagValue)}">`);
            else if (Array.isArray(tagValue)) tagValue.forEach((item)=>{
                if (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean') acc.push(`<meta ${attrType}="${$a255f44bfb621069$var$escapeHtml(tagKey)}" content="${$a255f44bfb621069$var$escapeHtml(item)}">`);
                else if (typeof item === 'object') {
                    const attrs = Object.entries(item).filter(([_, attrValue])=>attrValue !== undefined).map(([attrKey, attrValue])=>`${attrKey}="${$a255f44bfb621069$var$escapeHtml(attrValue)}"`).join(' ');
                    acc.push(`<meta ${attrs}>`);
                }
            });
            else if (typeof tagValue === 'object') {
                const attrs = Object.entries(tagValue).filter(([_, attrValue])=>attrValue !== undefined).map(([attrKey, attrValue])=>`${attrKey}="${$a255f44bfb621069$var$escapeHtml(attrValue)}"`).join(' ');
                acc.push(`<meta ${attrs}>`);
            }
        };
        if (key.startsWith('http-equiv:')) {
            const httpEquivKey = key.replace('http-equiv:', '');
            processMetaTag(httpEquivKey, value, 'http-equiv');
            return acc;
        }
        if (key.startsWith('itemprop:')) {
            const itempropKey = key.replace('itemprop:', '');
            processMetaTag(itempropKey, value, 'itemprop');
            return acc;
        }
        const prefixes = [
            'og:',
            'twitter:',
            'fb:',
            'article:',
            'profile:',
            'book:',
            'business:',
            'music:',
            'product:',
            'video:',
            'DC:',
            'DCTERMS:'
        ];
        const prefix = prefixes.find((p)=>key.startsWith(p));
        if (prefix) {
            const tagKey = key.replace(prefix, '');
            processMetaTag(`${prefix.replace(':', '')}:${tagKey}`, value, prefix === 'twitter:' || prefix === 'DC:' || prefix === 'DCTERMS:' ? 'name' : 'property');
            return acc;
        }
        if (key.startsWith('apple:') || key.startsWith('msapplication:')) {
            const pfx = key.startsWith('apple:') ? 'apple-' : 'msapplication-';
            const tagKey = key.replace(/^apple:|^msapplication:/, '');
            processMetaTag(`${pfx}${tagKey}`, value, 'name');
            return acc;
        }
        processMetaTag(key, value);
        return acc;
    }, [
        '<meta charset="UTF-8">',
        '<meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1, user-scalable=no">'
    ]);
    return tags.join('\n');
};
/**
 * Extract page-level metadata from project data for a given pathname.
 * Merges global SEO (data.integrations.seo) with page-level metadata/helmet/state.
 */ /**
 * Check if a string looks like a bare filename (not an absolute path or URL).
 * These are references to project files from `data.files`.
 */ const $a255f44bfb621069$var$isBareFilename = (val)=>typeof val === 'string' && val.length > 0 && !val.startsWith('/') && !val.startsWith('http');
/**
 * Resolve bare filename references in metadata values against `data.files`.
 * If a metadata value is a plain filename (e.g. "logo.png") and a matching
 * entry exists in `data.files`, replace it with the file's `src` URL.
 */ function $a255f44bfb621069$var$resolveFileReferences(metadata, files) {
    if (!files || typeof files !== 'object') return metadata;
    const resolve = (val)=>{
        if (!$a255f44bfb621069$var$isBareFilename(val)) return val;
        const fileEntry = files[val];
        if (fileEntry?.src) return fileEntry.src;
        return val;
    };
    const result = {
        ...metadata
    };
    for (const [key, value] of Object.entries(result)){
        if (typeof value === 'string') result[key] = resolve(value);
        else if (Array.isArray(value)) result[key] = value.map((item)=>typeof item === 'string' ? resolve(item) : item);
    }
    return result;
}
/**
 * Resolve a dot-path like "item.title_ka" against an object.
 */ function $a255f44bfb621069$var$resolveDotPath(obj, path) {
    if (!obj || !path) return undefined;
    const parts = path.split('.');
    let v = obj;
    for (const p of parts){
        if (v == null || typeof v !== 'object') return undefined;
        v = v[p];
    }
    return v;
}
/**
 * Resolve {{ key | polyglot }} and {{ key | getLocalStateLang }} templates
 * in metadata string values using project polyglot translations and SSR state.
 */ function $a255f44bfb621069$var$resolveMetadataTemplates(metadata, data, ssrContext) {
    const config = data.config || data.settings || {};
    const polyglot = config.polyglot || data.polyglot;
    const defaultLang = ssrContext?.lang || polyglot?.defaultLang || 'en';
    const translations = polyglot?.translations || {};
    const langMap = translations[defaultLang] || {};
    const state = ssrContext?.state || {};
    const result = {
        ...metadata
    };
    for (const [key, value] of Object.entries(result)){
        if (typeof value !== 'string' || !value.includes('{{')) continue;
        result[key] = value.replace(/\{\{\s*([^|{}]+?)\s*(?:\|\s*(\w+)\s*)?\}\}/g, (match, k, filter)=>{
            const trimmed = k.trim();
            if (filter === 'polyglot') return langMap[trimmed] ?? $a255f44bfb621069$var$resolveDotPath(langMap, trimmed) ?? match;
            if (filter === 'getLocalStateLang') {
                // key is like "item.title_" — append lang
                const resolved = $a255f44bfb621069$var$resolveDotPath(state, trimmed + defaultLang);
                return resolved ?? match;
            }
            // No filter — try state lookup, then polyglot
            const fromState = $a255f44bfb621069$var$resolveDotPath(state, trimmed);
            if (fromState !== undefined) return fromState;
            return langMap[trimmed] ?? $a255f44bfb621069$var$resolveDotPath(langMap, trimmed) ?? match;
        });
    }
    return result;
}
/**
 * Convert function-string metadata values to {{ }} templates.
 * Handles common patterns from Symbols page definitions:
 *   (el, s) => s.item ? el.call("getLocalStateLang", "item.title_") : ""
 *   (el, s) => s.item ? s.item.image_url : ""
 */ function $a255f44bfb621069$var$convertFunctionMetaToTemplates(metadata) {
    const result = {
        ...metadata
    };
    for (const [key, value] of Object.entries(result)){
        if (typeof value === 'function') {
            const src = value.toString();
            // Pattern: el.call("getLocalStateLang", "item.title_")
            const langMatch = src.match(/el\.call\(\s*["']getLocalStateLang["']\s*,\s*["']([^"']+)["']\s*\)/);
            if (langMatch) {
                result[key] = `{{ ${langMatch[1]} | getLocalStateLang }}`;
                continue;
            }
            // Pattern: el.call("polyglot", "item.description")
            const polyMatch = src.match(/el\.call\(\s*["']polyglot["']\s*,\s*["']([^"']+)["']\s*\)/);
            if (polyMatch) {
                result[key] = `{{ ${polyMatch[1]} | polyglot }}`;
                continue;
            }
            // Pattern: s.item.field or s.item?.field
            const stateMatch = src.match(/s\.(\w+(?:\.\w+)+)/);
            if (stateMatch) {
                result[key] = `{{ ${stateMatch[1]} }}`;
                continue;
            }
            // Could not parse — drop function value
            delete result[key];
        } else if (typeof value === 'string') {
            // Function-string (not yet destringified)
            const langMatch = value.match(/el\.call\(\s*["']getLocalStateLang["']\s*,\s*["']([^"']+)["']\s*\)/);
            if (langMatch) {
                result[key] = `{{ ${langMatch[1]} | getLocalStateLang }}`;
                continue;
            }
            const polyMatch = value.match(/el\.call\(\s*["']polyglot["']\s*,\s*["']([^"']+)["']\s*\)/);
            if (polyMatch) {
                result[key] = `{{ ${polyMatch[1]} | polyglot }}`;
                continue;
            }
            // Function-string with s.item.field
            if (value.includes('=>') && value.includes('s.')) {
                const stateMatch = value.match(/s\.(\w+(?:\.\w+)+)/);
                if (stateMatch) {
                    result[key] = `{{ ${stateMatch[1]} }}`;
                    continue;
                }
            }
        }
    }
    return result;
}
function $a255f44bfb621069$export$d6de83dbd93927be(data, pathname, ssrContext, { isProduction: isProduction = false, channel: channel = 'production' } = {}) {
    const currentPage = data.pages?.[pathname];
    const stateObject = (0, $fX7ii.isObject)(currentPage?.state) && currentPage?.state;
    const rawPageMeta = currentPage?.metadata || currentPage?.helmet || stateObject || {};
    // Convert function values to {{ }} templates instead of filtering them out
    const pageMetadata = $a255f44bfb621069$var$convertFunctionMetaToTemplates(rawPageMeta);
    // Track which keys the page explicitly sets
    const pageExplicitKeys = new Set(Object.keys(pageMetadata));
    const appMetadata = data.app?.metadata || {};
    const cleanAppMeta = $a255f44bfb621069$var$convertFunctionMetaToTemplates(appMetadata);
    let merged = {};
    if (data.integrations?.seo) merged = {
        ...data.integrations.seo,
        ...cleanAppMeta,
        ...pageMetadata
    };
    else if (Object.keys(cleanAppMeta).length) merged = {
        ...cleanAppMeta,
        ...pageMetadata
    };
    else merged = {
        ...pageMetadata
    };
    if (!merged.title) {
        const label = data.name || data.key;
        if (label) {
            if (isProduction) merged.title = label;
            else if (channel === 'development') merged.title = `${label} / dev:symbo.ls`;
            else if (channel === 'staging') merged.title = `${label} / staging:symbo.ls`;
            else merged.title = `${label} / symbo.ls`;
        } else merged.title = 'Symbols demo';
    }
    // Resolve {{ }} templates in metadata values (polyglot, state, getLocalStateLang)
    merged = $a255f44bfb621069$var$resolveMetadataTemplates(merged, data, ssrContext);
    // Auto-cascade page-level title/description to OG/Twitter tags
    if (merged.title && (pageExplicitKeys.has('title') || !merged['og:title'])) {
        if (!pageExplicitKeys.has('og:title')) merged['og:title'] = merged.title;
    }
    if (merged.description && (pageExplicitKeys.has('description') || !merged['og:description'])) {
        if (!pageExplicitKeys.has('og:description')) merged['og:description'] = merged.description;
    }
    if (merged.title && !merged['twitter:title']) merged['twitter:title'] = merged.title;
    if (merged.description && !merged['twitter:description']) merged['twitter:description'] = merged.description;
    // Make og:url route-aware — use actual pathname if available
    const routeForUrl = ssrContext?.actualPathname || pathname;
    if (merged['og:url'] || merged.url) {
        const baseUrl = (merged['og:url'] || merged.url || '').replace(/\/$/, '');
        if (baseUrl && routeForUrl && routeForUrl !== '/') {
            const cleanRoute = routeForUrl.startsWith('/') ? routeForUrl : '/' + routeForUrl;
            merged['og:url'] = baseUrl + cleanRoute;
        }
    }
    merged = $a255f44bfb621069$var$resolveFileReferences(merged, data.files);
    // Clean up any unresolved {{ }} templates (when prefetch fails or returns no data)
    const siteName = data.name || data.app?.metadata?.title || data.app?.name || '';
    for (const [key, value] of Object.entries(merged))if (typeof value === 'string' && value.includes('{{')) {
        const cleaned = value.replace(/\{\{[^}]*\}\}/g, '').trim();
        if (!cleaned) {
            if (key === 'title') merged[key] = siteName;
            else delete merged[key];
        } else merged[key] = cleaned;
    }
    return merged;
}

});

parcelRegister("dNcID", function(module, exports) {

$parcel$export(module.exports, "findClosestNumber", () => $a0a9b7b0b20b3bd4$export$97a41db892f2d4c);
$parcel$export(module.exports, "findClosestNumberInFactory", () => $a0a9b7b0b20b3bd4$export$63c606e1170dd201);

var $fX7ii = parcelRequire("fX7ii");
'use strict';
const $a0a9b7b0b20b3bd4$export$97a41db892f2d4c = (number, arr)=>{
    return ((0, $fX7ii.isArray)(arr) ? arr : Object.values(arr)).reduce((prev, curr)=>{
        return Math.abs(curr - number) < Math.abs(prev - number) ? curr : prev;
    });
};
const $a0a9b7b0b20b3bd4$export$63c606e1170dd201 = (val, factory)=>{
    val = parseFloat(val);
    if ((0, $fX7ii.isObject)(factory)) factory = Object.values(factory);
    return $a0a9b7b0b20b3bd4$export$97a41db892f2d4c(val, factory);
};

});

parcelRegister("bSS0n", function(module, exports) {

$parcel$export(module.exports, "normalizeLibraryKey", () => $8a6ea120bc7228d1$export$8254761f7cf4c0e0);
$parcel$export(module.exports, "deepDefaults", () => $8a6ea120bc7228d1$export$62d7a9f86a83f052);
$parcel$export(module.exports, "mergeSharedLibraries", () => $8a6ea120bc7228d1$export$b9e6b90332b83419);
$parcel$export(module.exports, "fetchLibraryData", () => $8a6ea120bc7228d1$export$68e1f259e57c59d);
$parcel$export(module.exports, "resolveSharedLibraries", () => $8a6ea120bc7228d1$export$d79adda69733feb);

var $fX7ii = parcelRequire("fX7ii");
'use strict';
const $8a6ea120bc7228d1$var$DEFAULT_LIBRARY_OWNER = 'system';
const $8a6ea120bc7228d1$var$KV_BASE_URL = 'https://smbls-kv.nika-980.workers.dev';
const $8a6ea120bc7228d1$var$API_BASE_URL = 'https://api.symbols.app';
function $8a6ea120bc7228d1$export$8254761f7cf4c0e0(raw) {
    const s = String(raw || '').trim();
    if (!s) return {
        owner: $8a6ea120bc7228d1$var$DEFAULT_LIBRARY_OWNER,
        key: '',
        full: ''
    };
    let owner = null;
    let key = s;
    if (s.includes('/')) {
        const idx = s.indexOf('/');
        owner = s.slice(0, idx);
        key = s.slice(idx + 1);
    }
    // Strip deprecated .symbo.ls suffix
    key = key.replace(/\.symbo\.ls$/iu, '');
    if (!owner) owner = $8a6ea120bc7228d1$var$DEFAULT_LIBRARY_OWNER;
    const full = key ? `${owner}/${key}` : '';
    return {
        owner: owner,
        key: key,
        full: full
    };
}
const $8a6ea120bc7228d1$export$62d7a9f86a83f052 = (target, source)=>{
    for(const k in source){
        if (!(k in target)) target[k] = source[k];
        else if ((0, $fX7ii.isObject)(target[k]) && (0, $fX7ii.isObject)(source[k])) $8a6ea120bc7228d1$export$62d7a9f86a83f052(target[k], source[k]);
    }
};
const $8a6ea120bc7228d1$export$b9e6b90332b83419 = (context, libraries)=>{
    if (!libraries || !libraries.length) return;
    for(let i = 0; i < libraries.length; i++){
        const sharedLib = libraries[i];
        if (!(0, $fX7ii.isObject)(sharedLib)) continue;
        for(const key in sharedLib){
            if (!Object.prototype.hasOwnProperty.call(sharedLib, key)) continue;
            if ((0, $fX7ii.isObject)(sharedLib[key]) && (0, $fX7ii.isObject)(context[key])) {
                if (key === 'designSystem') $8a6ea120bc7228d1$export$62d7a9f86a83f052(context[key], sharedLib[key]);
                else {
                    for(const k in sharedLib[key])if (!(k in context[key])) context[key][k] = sharedLib[key][k];
                }
            } else if (!(key in context)) context[key] = sharedLib[key];
        }
    }
};
async function $8a6ea120bc7228d1$export$68e1f259e57c59d(identifier, opts = {}) {
    const provider = opts.provider || 'kv';
    if (provider === 'api') return $8a6ea120bc7228d1$var$fetchLibraryFromApi(identifier, opts);
    // KV provider (default)
    const result = await $8a6ea120bc7228d1$var$fetchLibraryFromKv(identifier, opts);
    if (result) return result;
    // Fallback to API if KV returns nothing
    return $8a6ea120bc7228d1$var$fetchLibraryFromApi(identifier, opts);
}
async function $8a6ea120bc7228d1$var$fetchLibraryFromKv(identifier, opts = {}) {
    const baseUrl = opts.kvBaseUrl || $8a6ea120bc7228d1$var$KV_BASE_URL;
    const env = opts.env || 'production';
    const url = `${baseUrl}/kv/${encodeURIComponent(identifier)}?env=${env}`;
    try {
        const response = await fetch(url, {
            method: 'GET'
        });
        if (!response.ok) return null;
        const json = await response.json();
        return json?.value || null;
    } catch  {
        return null;
    }
}
async function $8a6ea120bc7228d1$var$fetchLibraryFromApi(identifier, opts = {}) {
    const baseUrl = opts.apiBaseUrl || $8a6ea120bc7228d1$var$API_BASE_URL;
    const { key: key } = $8a6ea120bc7228d1$export$8254761f7cf4c0e0(identifier);
    try {
        // Resolve library ID from the available list
        const listUrl = `${baseUrl}/core/projects/libraries/available?search=${encodeURIComponent(key)}&limit=10`;
        const listRes = await fetch(listUrl, {
            method: 'GET'
        });
        if (!listRes.ok) return null;
        const listJson = await listRes.json();
        const items = listJson?.items || listJson?.data || (Array.isArray(listJson) ? listJson : []);
        const match = items.find((lib)=>{
            const { key: libKey } = $8a6ea120bc7228d1$export$8254761f7cf4c0e0(lib?.key);
            return libKey.toLowerCase() === key.toLowerCase();
        });
        if (!match?.id && !match?._id) return null;
        const libId = match.id || match._id;
        // Fetch full library data
        const dataUrl = `${baseUrl}/core/projects/${encodeURIComponent(libId)}/data?branch=main`;
        const dataRes = await fetch(dataUrl, {
            method: 'GET'
        });
        if (!dataRes.ok) return null;
        const dataJson = await dataRes.json();
        return dataJson?.data || dataJson || null;
    } catch  {
        return null;
    }
}
async function $8a6ea120bc7228d1$export$d79adda69733feb(libraries, opts = {}) {
    if (!libraries || !libraries.length) return [];
    const resolved = await Promise.all(libraries.map(async (entry)=>{
        if ((0, $fX7ii.isObject)(entry)) return entry;
        if ((0, $fX7ii.isString)(entry)) {
            const { full: full } = $8a6ea120bc7228d1$export$8254761f7cf4c0e0(entry);
            if (!full) return null;
            try {
                const data = await $8a6ea120bc7228d1$export$68e1f259e57c59d(full, opts);
                if (!data) console.warn(`[smbls] Shared library "${full}" not found`);
                return data;
            } catch (e) {
                console.warn(`[smbls] Failed to fetch shared library "${full}":`, e.message);
                return null;
            }
        }
        return null;
    }));
    return resolved.filter(Boolean);
}

});

parcelRegister("fuahe", function(module, exports) {

$parcel$export(module.exports, "copyStringToClipboard", () => $b461a12438a528bd$export$4cdfed7d7fed21b8);
$parcel$export(module.exports, "copyJavaScriptToClipboard", () => $b461a12438a528bd$export$62b326c3a2efe2fb);
$parcel$export(module.exports, "removeChars", () => $b461a12438a528bd$export$3cc82ee301fb0516);
$parcel$export(module.exports, "toCamelCase", () => $b461a12438a528bd$export$86f54f62aa7a7514);
$parcel$export(module.exports, "toTitleCase", () => $b461a12438a528bd$export$f06f8b3003f18927);
$parcel$export(module.exports, "toDashCase", () => $b461a12438a528bd$export$6401d9e8afa09755);
$parcel$export(module.exports, "toDescriptionCase", () => $b461a12438a528bd$export$c82070d8669cc24e);
$parcel$export(module.exports, "arrayzeValue", () => $b461a12438a528bd$export$d1ef4b1a340dec10);

var $fX7ii = parcelRequire("fX7ii");
'use strict';
const $b461a12438a528bd$export$4cdfed7d7fed21b8 = async (str)=>{
    try {
        await navigator.clipboard.writeText(str);
    } catch (err) {
        console.warn('Failed to copy text: ', err);
    }
};
const $b461a12438a528bd$export$62b326c3a2efe2fb = async (jsCode)=>{
    try {
        // Create a Blob for the JavaScript code with the 'text/javascript' MIME type
        const blob = new Blob([
            jsCode
        ], {
            type: 'text/javascript'
        });
        // Create a ClipboardItem with the 'text/javascript' Blob
        const clipboardItem = new window.ClipboardItem({
            'text/plain': blob
        });
        // Copy the ClipboardItem to the clipboard
        await navigator.clipboard.write([
            clipboardItem
        ]);
        console.log('JavaScript code copied to clipboard as text/javascript');
    } catch (err) {
        console.error('Failed to copy JavaScript code: ', err);
    }
};
const $b461a12438a528bd$export$3cc82ee301fb0516 = (str)=>{
    return str.replace(/[^a-zA-Z0-9_]/g, '');
};
const $b461a12438a528bd$export$86f54f62aa7a7514 = (str)=>{
    if (typeof str !== 'string') str = String(str || '');
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
    }).replace(/\s+/g, '');
};
const $b461a12438a528bd$export$f06f8b3003f18927 = (str)=>str && str.replace(/\w\S*/g, (txt)=>{
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
const $b461a12438a528bd$export$6401d9e8afa09755 = (val)=>val.replace(/[^a-zA-Z0-9]/g, ' ') // Replace non-alphanumeric characters with spaces
    .trim() // Remove leading and trailing spaces
    .toLowerCase() // Convert to lowercase
    .replace(/\s+/g, '-') // Replace spaces with dashes
    .replace(/-+/g, '-') // Replace consecutive dashes with a single dash
    .replace(/^-|-$/g, '') // Remove leading and trailing dashes
;
const $b461a12438a528bd$export$c82070d8669cc24e = (str = '')=>{
    if (typeof str !== 'string') return;
    const result = str.replace(/([A-Z])/g, ' $1');
    return result.charAt(0).toUpperCase() + result.slice(1);
};
const $b461a12438a528bd$export$d1ef4b1a340dec10 = (val)=>{
    if ((0, $fX7ii.isArray)(val)) return val;
    if ((0, $fX7ii.isString)(val)) return val.split(' ');
    if ((0, $fX7ii.isObject)(val)) return Object.values(val);
    if ((0, $fX7ii.isNumber)(val)) return [
        val
    ];
};

});

parcelRegister("36hJi", function(module, exports) {

$parcel$export(module.exports, "getEmotionStylesheet", () => $241faf621ce86462$export$6163c5ef8e6b8537);
'use strict';
const $241faf621ce86462$export$6163c5ef8e6b8537 = ()=>{
    // Access the first stylesheet
    const stylesheet = document.styleSheets[0];
    let str = '';
    if (stylesheet) try {
        // Access the CSS rules
        const cssRules = stylesheet.cssRules || stylesheet.rules // For older browsers, use `rules`
        ;
        // Iterate over the rules and log them
        for(let i = 0; i < cssRules.length; i++)str += cssRules[i].cssText;
    } catch (error) {
        console.error('Unable to access CSS rules. This may be due to CORS restrictions:', error);
    }
    else console.log('No stylesheets found in document.styleSheets[0].');
    return str;
};

});


parcelRegister("enZpr", function(module, exports) {
module.exports = import("2t7zK").then(()=>parcelRequire('874Oy'));

});

parcelRegister("6dvJp", function(module, exports) {
module.exports = import("a8u7M").then(()=>parcelRequire('4TjzG'));

});

parcelRegister("1IE9l", function(module, exports) {
module.exports = import("dinIE").then(()=>parcelRequire('hF6UP'));

});


parcelRegister("bfqVY", function(module, exports) {

$parcel$export(module.exports, "getSDK", () => $8305fcf2024ab0dd$export$9d1e2f4275173627);
$parcel$export(module.exports, "awaitSDKInit", () => $8305fcf2024ab0dd$export$c4807e473bcddd07);
$parcel$export(module.exports, "getMe", () => $8305fcf2024ab0dd$export$dd7946daa6163e94);
$parcel$export(module.exports, "login", () => $8305fcf2024ab0dd$export$596d806903d1f59e);
$parcel$export(module.exports, "logout", () => $8305fcf2024ab0dd$export$a0973bcfe11b05c9);
$parcel$export(module.exports, "isAuthenticated", () => $8305fcf2024ab0dd$export$83d11f23a23d4a7c);
$parcel$export(module.exports, "getUserProfileCached", () => $8305fcf2024ab0dd$export$6818d085173e34c9);
$parcel$export(module.exports, "listOrganizationsCached", () => $8305fcf2024ab0dd$export$f6a9c14df9bfd7f6);
$parcel$export(module.exports, "invalidateUserDataCache", () => $8305fcf2024ab0dd$export$79e8e60799502aab);
$parcel$export(module.exports, "fetchPublicProjectFromSDK", () => $8305fcf2024ab0dd$export$70dbaf04604f685);
$parcel$export(module.exports, "fetchPublicProjectVisibilityFromSDK", () => $8305fcf2024ab0dd$export$1d28c40907c073c9);
$parcel$export(module.exports, "unlockPublicProjectFromSDK", () => $8305fcf2024ab0dd$export$e034e50a1c9f351e);
$parcel$export(module.exports, "fetchProjectFromSDK", () => $8305fcf2024ab0dd$export$d3c48d303d08f280);
$parcel$export(module.exports, "resolveEnvPublishConfig", () => $8305fcf2024ab0dd$export$170e607e5e4505d9);
$parcel$export(module.exports, "listUserProjects", () => $8305fcf2024ab0dd$export$422c032dc0a6a10c);
$parcel$export(module.exports, "getProjectParamsFromUrl", () => $8305fcf2024ab0dd$export$daf878ec0368a739);

var $3rsQg = parcelRequire("3rsQg");
parcelRequire("2oe0q");
var $bmfNh = parcelRequire("bmfNh");

var $3WCJD = parcelRequire("3WCJD");

var $8RlGv = parcelRequire("8RlGv");

var $ccUH0 = parcelRequire("ccUH0");

var $ghHor = parcelRequire("ghHor");
// SDK token provider for /workspace/* surfaces.
//
// The wrapper at next.api.symbols.app/workspace (and the local express
// bridge) authenticates by reading `Authorization: Bearer <jwt>` and
// extracting the `workspace_id` / `active_workspace_id` claim. The
// Symbols SDK's own token (HS256, signed with SYMBOLS_SERVER secret)
// does NOT carry that claim — only the governance Supabase JWT does.
//
// Without this, `WorkspaceProjectService._resolveAuthHeader` falls back
// to `tokenManager.getAuthHeader()` which sends the SDK token, and every
// /workspace/* call 401s with "missing workspace_id claim" or "invalid
// signature" (depending on which secret the wrapper checks against).
//
// Returns null when no governance JWT is in localStorage so the SDK
// service skips the Authorization header — the wrapper will reply 401
// with a clear "missing bearer token" message and bootShell's auth
// diagnostic surfaces the cause.
const $8305fcf2024ab0dd$var$_workspaceTokenProvider = async ()=>{
    if (typeof window === 'undefined') return null;
    return (0, $ghHor.governanceSessionAccessToken)() || null;
};
// ── SDK instances per apiUrl ────────────────────────────────────────────────
// The SDK (see sdk/src/config/environment.js) picks its own apiUrl based on
// `SYMBOLS_APP_ENVIRONMENT`; we only override with an explicit `apiUrl` when
// the caller opts into `--local` or `--next` so we don't re-hardcode the
// production URL here. Channel URLs come from @symbo.ls/channels — single
// source of truth across sdk, smbls, server, editor, workspace, platform.
const $8305fcf2024ab0dd$var$_sdkByKey = new Map();
const $8305fcf2024ab0dd$var$_initPromiseByKey = new Map();
function $8305fcf2024ab0dd$export$9d1e2f4275173627({ useLocal: useLocal = false, useNext: useNext = true } = {}) {
    // Default: pin to next.api.symbols.app because the SDK's own environment
    // detection would pick `dev.api.symbols.app` for a `*.localhost` host and
    // that domain doesn't resolve.
    const apiUrl = $8305fcf2024ab0dd$var$resolveApiUrl({
        useLocal: useLocal,
        useNext: useNext
    });
    const cacheKey = apiUrl || 'default';
    if (!$8305fcf2024ab0dd$var$_sdkByKey.has(cacheKey)) {
        (0, $8RlGv.hydrateAuthFromCookie)();
        (0, $8RlGv.installAuthSync)();
        const opts = {
            debug: false
        };
        if (apiUrl) opts.apiUrl = apiUrl;
        const sdk = new (0, $3rsQg.SDK)(opts);
        // Pass the governance token provider into SDK init so
        // WorkspaceProjectService._resolveAuthHeader picks the federated
        // governance JWT (which carries workspace_id) over the SDK's own
        // token (which doesn't).
        //
        // `federationSwitchWorkspace` makes `sdk.switchWorkspace(wsId)` the
        // single entry point for org/workspace switching — the SDK calls
        // sdk-bridge under the hood (governance Supabase Edge Function +
        // session refresh). Frontend never imports sdk-bridge for this.
        const initPromise = sdk.initialize({
            workspaceProjectTokenProvider: $8305fcf2024ab0dd$var$_workspaceTokenProvider,
            federationSwitchWorkspace: (0, $8RlGv.switchWorkspace)
        }).catch((err)=>{
            // eslint-disable-next-line no-console
            console.warn('[sdk] initialize failed:', err?.message || err);
        });
        $8305fcf2024ab0dd$var$_initPromiseByKey.set(cacheKey, initPromise);
        $8305fcf2024ab0dd$var$_sdkByKey.set(cacheKey, $8305fcf2024ab0dd$var$wrapWithInitAwait(sdk, initPromise));
    }
    return $8305fcf2024ab0dd$var$_sdkByKey.get(cacheKey);
}
function $8305fcf2024ab0dd$var$resolveApiUrl({ useLocal: useLocal, useNext: useNext } = {}) {
    if (useLocal) return (0, $3WCJD.apiUrl)('local');
    // Single source of truth — `workspaceApiBase` resolves through
    // `@symbo.ls/channels` after honoring runtime + localStorage
    // overrides + the .localhost dev default (auto → `localNext` channel).
    // The SDK and every other workspace API consumer (Supabase
    // passthrough, agentMessages, dashboard slug check) share this base
    // so flipping one knob (`localStorage.symbols_api_channel='localNext'`,
    // or `localStorage.symbols_workspace_api='https://...'`) routes every
    // /workspace/* and /core/* call at once.
    if (typeof window !== 'undefined') return (0, $ccUH0.workspaceApiBase)();
    if (useNext !== false) return (0, $3WCJD.apiUrl)('next');
    return undefined;
}
async function $8305fcf2024ab0dd$export$c4807e473bcddd07(opts = {}) {
    const cacheKey = $8305fcf2024ab0dd$var$resolveApiUrl(opts) || 'default';
    $8305fcf2024ab0dd$export$9d1e2f4275173627(opts);
    return $8305fcf2024ab0dd$var$_initPromiseByKey.get(cacheKey);
}
// Wrap the SDK so every method call awaits initialization first. Property
// reads for non-function values (e.g. sdk.environment, sdk.rootBus) pass
// through synchronously.
// These methods read local state synchronously and must not be wrapped —
// callers use them as guards (!!sdk.getAuthToken()) before async work.
const $8305fcf2024ab0dd$var$_SYNC_PASS = new Set([
    'getAuthToken',
    'isReady',
    'getToken',
    'logout'
]);
function $8305fcf2024ab0dd$var$wrapWithInitAwait(sdk, initPromise) {
    return new Proxy(sdk, {
        get (target, prop) {
            const value = target[prop];
            if (typeof value !== 'function') return value;
            if ($8305fcf2024ab0dd$var$_SYNC_PASS.has(prop)) return value.bind(target);
            return (...args)=>initPromise.then(()=>value.apply(target, args));
        }
    });
}
async function $8305fcf2024ab0dd$export$dd7946daa6163e94(opts) {
    const result = await $8305fcf2024ab0dd$export$9d1e2f4275173627(opts).getMe();
    return result?.data || null;
}
async function $8305fcf2024ab0dd$export$596d806903d1f59e(email, password, opts) {
    return $8305fcf2024ab0dd$export$9d1e2f4275173627(opts).login(email, password);
}
async function $8305fcf2024ab0dd$export$a0973bcfe11b05c9(opts) {
    return $8305fcf2024ab0dd$export$9d1e2f4275173627(opts).logout();
}
function $8305fcf2024ab0dd$export$83d11f23a23d4a7c(opts) {
    return $8305fcf2024ab0dd$export$9d1e2f4275173627(opts).isReady();
}
// sessionStorage-backed caches so every tab/reload doesn't re-hit
// `/me` and `/organizations` — the API rate-limits hard when multiple
// tabs open at once. Each cache also dedupes concurrent callers within
// a single tab via a shared in-flight promise.
const $8305fcf2024ab0dd$var$USER_PROFILE_TTL_MS = 300000;
const $8305fcf2024ab0dd$var$USER_PROFILE_KEY = '__canvas_user_profile_v1';
let $8305fcf2024ab0dd$var$USER_PROFILE_PROMISE = null;
const $8305fcf2024ab0dd$var$USER_ORGS_TTL_MS = 300000;
const $8305fcf2024ab0dd$var$USER_ORGS_KEY = '__canvas_user_orgs_v1';
let $8305fcf2024ab0dd$var$USER_ORGS_PROMISE = null;
function $8305fcf2024ab0dd$var$readCache(key) {
    try {
        const raw = sessionStorage.getItem(key);
        if (!raw) return null;
        const entry = JSON.parse(raw);
        if (!entry?.at) return null;
        return entry;
    } catch  {
        return null;
    }
}
function $8305fcf2024ab0dd$var$writeCache(key, data) {
    try {
        sessionStorage.setItem(key, JSON.stringify({
            at: Date.now(),
            data: data
        }));
    } catch  {}
}
async function $8305fcf2024ab0dd$export$6818d085173e34c9(opts) {
    const entry = $8305fcf2024ab0dd$var$readCache($8305fcf2024ab0dd$var$USER_PROFILE_KEY);
    if (entry && Date.now() - entry.at < $8305fcf2024ab0dd$var$USER_PROFILE_TTL_MS) return entry.data;
    if ($8305fcf2024ab0dd$var$USER_PROFILE_PROMISE) return $8305fcf2024ab0dd$var$USER_PROFILE_PROMISE;
    const sdk = $8305fcf2024ab0dd$export$9d1e2f4275173627(opts);
    $8305fcf2024ab0dd$var$USER_PROFILE_PROMISE = Promise.resolve(sdk.getUserProfile()).then((r)=>{
        const data = r?.data || r || null;
        if (data) $8305fcf2024ab0dd$var$writeCache($8305fcf2024ab0dd$var$USER_PROFILE_KEY, data);
        return data;
    }).catch((err)=>{
        // Fall back to stale cache on 429/network errors — stale user data
        // beats a broken dashboard. Only re-throw when we have nothing.
        if (entry?.data) return entry.data;
        throw err;
    }).finally(()=>{
        $8305fcf2024ab0dd$var$USER_PROFILE_PROMISE = null;
    });
    return $8305fcf2024ab0dd$var$USER_PROFILE_PROMISE;
}
async function $8305fcf2024ab0dd$export$f6a9c14df9bfd7f6(opts) {
    const entry = $8305fcf2024ab0dd$var$readCache($8305fcf2024ab0dd$var$USER_ORGS_KEY);
    if (entry && Date.now() - entry.at < $8305fcf2024ab0dd$var$USER_ORGS_TTL_MS) return entry.data;
    if ($8305fcf2024ab0dd$var$USER_ORGS_PROMISE) return $8305fcf2024ab0dd$var$USER_ORGS_PROMISE;
    const sdk = $8305fcf2024ab0dd$export$9d1e2f4275173627(opts);
    $8305fcf2024ab0dd$var$USER_ORGS_PROMISE = Promise.resolve(sdk.listOrganizations()).then((r)=>{
        const data = Array.isArray(r) ? r : r?.data || r?.organizations || [];
        $8305fcf2024ab0dd$var$writeCache($8305fcf2024ab0dd$var$USER_ORGS_KEY, data);
        return data;
    }).catch((err)=>{
        if (entry?.data) return entry.data;
        throw err;
    }).finally(()=>{
        $8305fcf2024ab0dd$var$USER_ORGS_PROMISE = null;
    });
    return $8305fcf2024ab0dd$var$USER_ORGS_PROMISE;
}
function $8305fcf2024ab0dd$export$79e8e60799502aab() {
    try {
        sessionStorage.removeItem($8305fcf2024ab0dd$var$USER_PROFILE_KEY);
        sessionStorage.removeItem($8305fcf2024ab0dd$var$USER_ORGS_KEY);
    } catch  {}
    $8305fcf2024ab0dd$var$USER_PROFILE_PROMISE = null;
    $8305fcf2024ab0dd$var$USER_ORGS_PROMISE = null;
}
// ── Project ─────────────────────────────────────────────────────────────────
// Split an `owner/key` string into the `{owner, key}` shape the SDK's
// `projectKeyPath` helper expects for the collision-safe 2-seg route.
// Passing the bare string runs `encodeURIComponent` over the whole thing
// — turning `nikoloza/presentation` into `nikoloza%2Fpresentation`,
// which the API treats as a single legacy key (404 against the modern
// owner/key projects). Splitting on the first `/` keeps the slash as a
// path separator. Falls back to a string when no slash is present so
// the helper can still hit the legacy 1-seg route for callers that
// genuinely have a bare key.
const $8305fcf2024ab0dd$var$_splitProjectRef = (ref)=>{
    if (!ref) return ref;
    if (typeof ref === 'object') return ref;
    const idx = String(ref).indexOf('/');
    if (idx === -1) return ref;
    return {
        owner: ref.slice(0, idx),
        key: ref.slice(idx + 1)
    };
};
async function $8305fcf2024ab0dd$export$70dbaf04604f685(owner, key, { envKey: envKey, ...sdkOpts } = {}) {
    if (!envKey) return null;
    const sdk = $8305fcf2024ab0dd$export$9d1e2f4275173627(sdkOpts);
    const result = await sdk.getPublicProjectDataByKey({
        owner: owner,
        key: key
    }, {
        envKey: envKey
    });
    const data = result?.data || result;
    if (!data) return null;
    return typeof data === 'string' ? data : (0, $bmfNh.deepDestringifyFunctions)(data);
}
async function $8305fcf2024ab0dd$export$1d28c40907c073c9(owner, key, sdkOpts = {}) {
    const sdk = $8305fcf2024ab0dd$export$9d1e2f4275173627(sdkOpts);
    return sdk.getPublicProjectVisibility({
        owner: owner,
        key: key
    });
}
async function $8305fcf2024ab0dd$export$e034e50a1c9f351e(owner, key, { envKey: envKey, password: password, ...sdkOpts } = {}) {
    if (!envKey || !password) return null;
    const sdk = $8305fcf2024ab0dd$export$9d1e2f4275173627(sdkOpts);
    const result = await sdk.unlockPublicProjectDataByKey({
        owner: owner,
        key: key
    }, {
        envKey: envKey,
        password: password
    });
    const data = result?.data || result;
    if (!data) return null;
    return typeof data === 'string' ? data : (0, $bmfNh.deepDestringifyFunctions)(data);
}
async function $8305fcf2024ab0dd$export$d3c48d303d08f280(owner, key, options = {}) {
    const sdk = $8305fcf2024ab0dd$export$9d1e2f4275173627(options);
    const result = await sdk.getProjectDataByKey({
        owner: owner,
        key: key
    }, {
        branch: options.branch || 'main',
        version: options.version || 'latest'
    });
    const data = result?.data || result;
    if (!data) return null;
    return typeof data === 'string' ? data : (0, $bmfNh.deepDestringifyFunctions)(data);
}
async function $8305fcf2024ab0dd$export$170e607e5e4505d9(projectKey, envKey, sdkOpts = {}) {
    if (!projectKey || !envKey) return null;
    const sdk = $8305fcf2024ab0dd$export$9d1e2f4275173627(sdkOpts);
    const project = await sdk.getProjectByKey($8305fcf2024ab0dd$var$_splitProjectRef(projectKey));
    const projectId = project?._id || project?.id;
    if (!projectId) return null;
    const envs = await sdk.listEnvironments(projectId);
    const cfg = envs?.environments?.[envKey];
    if (!cfg || cfg.enabled === false) return null;
    const branch = cfg.branch || 'main';
    const version = cfg.mode === 'version' && cfg.version ? cfg.version : 'latest';
    return {
        branch: branch,
        version: version
    };
}
async function $8305fcf2024ab0dd$export$422c032dc0a6a10c(opts) {
    const result = await $8305fcf2024ab0dd$export$9d1e2f4275173627(opts).getUserProjects();
    return result?.data || [];
}
function $8305fcf2024ab0dd$export$daf878ec0368a739() {
    const params = new URLSearchParams(window.location.search);
    return {
        owner: params.get('owner'),
        key: params.get('key'),
        env: params.get('env') || 'development',
        branch: params.get('branch') || 'main'
    };
}

});
parcelRegister("3rsQg", function(module, exports) {

$parcel$export(module.exports, "environment", () => $281a441cdcb2cf36$export$6bc7b24d4e862158);
$parcel$export(module.exports, "governanceSessionAccessToken", () => $281a441cdcb2cf36$export$6742174a7b4553dc);
$parcel$export(module.exports, "createSupabasePassthroughConfig", () => $281a441cdcb2cf36$export$b4f6e555f7229881);
$parcel$export(module.exports, "workspaceProjectEdgeFunctionUrl", () => $281a441cdcb2cf36$export$f1b632eb4ee09df9);
$parcel$export(module.exports, "SDK", () => $281a441cdcb2cf36$export$f7af2da260061f5e);
$parcel$export(module.exports, "default", () => $281a441cdcb2cf36$export$2e2bcd8739ae039);
parcelRequire("2oe0q");
var $kt4aQ = parcelRequire("kt4aQ");
var $2oe0q = parcelRequire("2oe0q");
var $bmfNh = parcelRequire("bmfNh");

var $hPtJY = parcelRequire("hPtJY");

var $6ZWSX = parcelRequire("6ZWSX");
var $281a441cdcb2cf36$require$Buffer = $6ZWSX.Buffer;
var $281a441cdcb2cf36$var$__create = Object.create;
var $281a441cdcb2cf36$var$__defProp = Object.defineProperty;
var $281a441cdcb2cf36$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $281a441cdcb2cf36$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $281a441cdcb2cf36$var$__getProtoOf = Object.getPrototypeOf;
var $281a441cdcb2cf36$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $281a441cdcb2cf36$var$__defNormalProp = (obj, key, value2)=>key in obj ? $281a441cdcb2cf36$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value2
    }) : obj[key] = value2;
var $281a441cdcb2cf36$var$__esm = (fn, res)=>function __init() {
        return fn && (res = (0, fn[$281a441cdcb2cf36$var$__getOwnPropNames(fn)[0]])(fn = 0)), res;
    };
var $281a441cdcb2cf36$var$__commonJS = (cb, mod)=>function __require() {
        return mod || (0, cb[$281a441cdcb2cf36$var$__getOwnPropNames(cb)[0]])((mod = {
            exports: {}
        }).exports, mod), mod.exports;
    };
var $281a441cdcb2cf36$var$__export = (target, all2)=>{
    for(var name in all2)$281a441cdcb2cf36$var$__defProp(target, name, {
        get: all2[name],
        enumerable: true
    });
};
var $281a441cdcb2cf36$var$__copyProps = (to, from2, except, desc)=>{
    if (from2 && typeof from2 === "object" || typeof from2 === "function") {
        for (let key of $281a441cdcb2cf36$var$__getOwnPropNames(from2))if (!$281a441cdcb2cf36$var$__hasOwnProp.call(to, key) && key !== except) $281a441cdcb2cf36$var$__defProp(to, key, {
            get: ()=>from2[key],
            enumerable: !(desc = $281a441cdcb2cf36$var$__getOwnPropDesc(from2, key)) || desc.enumerable
        });
    }
    return to;
};
var $281a441cdcb2cf36$var$__toESM = (mod, isNodeMode, target)=>(target = mod != null ? $281a441cdcb2cf36$var$__create($281a441cdcb2cf36$var$__getProtoOf(mod)) : {}, $281a441cdcb2cf36$var$__copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? $281a441cdcb2cf36$var$__defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod));
var $281a441cdcb2cf36$var$__toCommonJS = (mod)=>$281a441cdcb2cf36$var$__copyProps($281a441cdcb2cf36$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
var $281a441cdcb2cf36$var$__publicField = (obj, key, value2)=>$281a441cdcb2cf36$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value2);
// ../node_modules/lib0/map.js
var $281a441cdcb2cf36$var$create, $281a441cdcb2cf36$var$copy, $281a441cdcb2cf36$var$setIfUndefined, $281a441cdcb2cf36$var$map, $281a441cdcb2cf36$var$any;
var $281a441cdcb2cf36$var$init_map = $281a441cdcb2cf36$var$__esm({
    "../node_modules/lib0/map.js" () {
        $281a441cdcb2cf36$var$create = ()=>/* @__PURE__ */ new Map();
        $281a441cdcb2cf36$var$copy = (m3)=>{
            const r3 = $281a441cdcb2cf36$var$create();
            m3.forEach((v3, k3)=>{
                r3.set(k3, v3);
            });
            return r3;
        };
        $281a441cdcb2cf36$var$setIfUndefined = (map2, key, createT)=>{
            let set = map2.get(key);
            if (set === void 0) map2.set(key, set = createT());
            return set;
        };
        $281a441cdcb2cf36$var$map = (m3, f3)=>{
            const res = [];
            for (const [key, value2] of m3)res.push(f3(value2, key));
            return res;
        };
        $281a441cdcb2cf36$var$any = (m3, f3)=>{
            for (const [key, value2] of m3){
                if (f3(value2, key)) return true;
            }
            return false;
        };
    }
});
// ../node_modules/lib0/set.js
var $281a441cdcb2cf36$var$create2;
var $281a441cdcb2cf36$var$init_set = $281a441cdcb2cf36$var$__esm({
    "../node_modules/lib0/set.js" () {
        $281a441cdcb2cf36$var$create2 = ()=>/* @__PURE__ */ new Set();
    }
});
// ../node_modules/lib0/array.js
var $281a441cdcb2cf36$var$last, $281a441cdcb2cf36$var$appendTo, $281a441cdcb2cf36$var$from, $281a441cdcb2cf36$var$every, $281a441cdcb2cf36$var$some, $281a441cdcb2cf36$var$unfold, $281a441cdcb2cf36$var$isArray;
var $281a441cdcb2cf36$var$init_array = $281a441cdcb2cf36$var$__esm({
    "../node_modules/lib0/array.js" () {
        $281a441cdcb2cf36$var$last = (arr)=>arr[arr.length - 1];
        $281a441cdcb2cf36$var$appendTo = (dest, src)=>{
            for(let i3 = 0; i3 < src.length; i3++)dest.push(src[i3]);
        };
        $281a441cdcb2cf36$var$from = Array.from;
        $281a441cdcb2cf36$var$every = (arr, f3)=>{
            for(let i3 = 0; i3 < arr.length; i3++){
                if (!f3(arr[i3], i3, arr)) return false;
            }
            return true;
        };
        $281a441cdcb2cf36$var$some = (arr, f3)=>{
            for(let i3 = 0; i3 < arr.length; i3++){
                if (f3(arr[i3], i3, arr)) return true;
            }
            return false;
        };
        $281a441cdcb2cf36$var$unfold = (len, f3)=>{
            const array = new Array(len);
            for(let i3 = 0; i3 < len; i3++)array[i3] = f3(i3, array);
            return array;
        };
        $281a441cdcb2cf36$var$isArray = Array.isArray;
    }
});
// ../node_modules/lib0/observable.js
var $281a441cdcb2cf36$var$ObservableV2, $281a441cdcb2cf36$var$Observable;
var $281a441cdcb2cf36$var$init_observable = $281a441cdcb2cf36$var$__esm({
    "../node_modules/lib0/observable.js" () {
        $281a441cdcb2cf36$var$init_map();
        $281a441cdcb2cf36$var$init_set();
        $281a441cdcb2cf36$var$init_array();
        $281a441cdcb2cf36$var$ObservableV2 = class {
            constructor(){
                this._observers = $281a441cdcb2cf36$var$create();
            }
            /**
       * @template {keyof EVENTS & string} NAME
       * @param {NAME} name
       * @param {EVENTS[NAME]} f
       */ on(name, f3) {
                $281a441cdcb2cf36$var$setIfUndefined(this._observers, /** @type {string} */ name, $281a441cdcb2cf36$var$create2).add(f3);
                return f3;
            }
            /**
       * @template {keyof EVENTS & string} NAME
       * @param {NAME} name
       * @param {EVENTS[NAME]} f
       */ once(name, f3) {
                const _f = (...args2)=>{
                    this.off(name, /** @type {any} */ _f);
                    f3(...args2);
                };
                this.on(name, /** @type {any} */ _f);
            }
            /**
       * @template {keyof EVENTS & string} NAME
       * @param {NAME} name
       * @param {EVENTS[NAME]} f
       */ off(name, f3) {
                const observers = this._observers.get(name);
                if (observers !== void 0) {
                    observers.delete(f3);
                    if (observers.size === 0) this._observers.delete(name);
                }
            }
            /**
       * Emit a named event. All registered event listeners that listen to the
       * specified name will receive the event.
       *
       * @todo This should catch exceptions
       *
       * @template {keyof EVENTS & string} NAME
       * @param {NAME} name The event name.
       * @param {Parameters<EVENTS[NAME]>} args The arguments that are applied to the event listener.
       */ emit(name, args2) {
                return $281a441cdcb2cf36$var$from((this._observers.get(name) || $281a441cdcb2cf36$var$create()).values()).forEach((f3)=>f3(...args2));
            }
            destroy() {
                this._observers = $281a441cdcb2cf36$var$create();
            }
        };
        $281a441cdcb2cf36$var$Observable = class {
            constructor(){
                this._observers = $281a441cdcb2cf36$var$create();
            }
            /**
       * @param {N} name
       * @param {function} f
       */ on(name, f3) {
                $281a441cdcb2cf36$var$setIfUndefined(this._observers, name, $281a441cdcb2cf36$var$create2).add(f3);
            }
            /**
       * @param {N} name
       * @param {function} f
       */ once(name, f3) {
                const _f = (...args2)=>{
                    this.off(name, _f);
                    f3(...args2);
                };
                this.on(name, _f);
            }
            /**
       * @param {N} name
       * @param {function} f
       */ off(name, f3) {
                const observers = this._observers.get(name);
                if (observers !== void 0) {
                    observers.delete(f3);
                    if (observers.size === 0) this._observers.delete(name);
                }
            }
            /**
       * Emit a named event. All registered event listeners that listen to the
       * specified name will receive the event.
       *
       * @todo This should catch exceptions
       *
       * @param {N} name The event name.
       * @param {Array<any>} args The arguments that are applied to the event listener.
       */ emit(name, args2) {
                return $281a441cdcb2cf36$var$from((this._observers.get(name) || $281a441cdcb2cf36$var$create()).values()).forEach((f3)=>f3(...args2));
            }
            destroy() {
                this._observers = $281a441cdcb2cf36$var$create();
            }
        };
    }
});
// ../node_modules/lib0/math.js
var $281a441cdcb2cf36$var$floor, $281a441cdcb2cf36$var$abs, $281a441cdcb2cf36$var$min, $281a441cdcb2cf36$var$max, $281a441cdcb2cf36$var$isNaN2, $281a441cdcb2cf36$var$isNegativeZero;
var $281a441cdcb2cf36$var$init_math = $281a441cdcb2cf36$var$__esm({
    "../node_modules/lib0/math.js" () {
        $281a441cdcb2cf36$var$floor = Math.floor;
        $281a441cdcb2cf36$var$abs = Math.abs;
        $281a441cdcb2cf36$var$min = (a3, b3)=>a3 < b3 ? a3 : b3;
        $281a441cdcb2cf36$var$max = (a3, b3)=>a3 > b3 ? a3 : b3;
        $281a441cdcb2cf36$var$isNaN2 = Number.isNaN;
        $281a441cdcb2cf36$var$isNegativeZero = (n3)=>n3 !== 0 ? n3 < 0 : 1 / n3 < 0;
    }
});
// ../node_modules/lib0/binary.js
var $281a441cdcb2cf36$var$BIT1, $281a441cdcb2cf36$var$BIT2, $281a441cdcb2cf36$var$BIT3, $281a441cdcb2cf36$var$BIT4, $281a441cdcb2cf36$var$BIT6, $281a441cdcb2cf36$var$BIT7, $281a441cdcb2cf36$var$BIT8, $281a441cdcb2cf36$var$BIT18, $281a441cdcb2cf36$var$BIT19, $281a441cdcb2cf36$var$BIT20, $281a441cdcb2cf36$var$BIT21, $281a441cdcb2cf36$var$BIT22, $281a441cdcb2cf36$var$BIT23, $281a441cdcb2cf36$var$BIT24, $281a441cdcb2cf36$var$BIT25, $281a441cdcb2cf36$var$BIT26, $281a441cdcb2cf36$var$BIT27, $281a441cdcb2cf36$var$BIT28, $281a441cdcb2cf36$var$BIT29, $281a441cdcb2cf36$var$BIT30, $281a441cdcb2cf36$var$BIT31, $281a441cdcb2cf36$var$BIT32, $281a441cdcb2cf36$var$BITS5, $281a441cdcb2cf36$var$BITS6, $281a441cdcb2cf36$var$BITS7, $281a441cdcb2cf36$var$BITS17, $281a441cdcb2cf36$var$BITS18, $281a441cdcb2cf36$var$BITS19, $281a441cdcb2cf36$var$BITS20, $281a441cdcb2cf36$var$BITS21, $281a441cdcb2cf36$var$BITS22, $281a441cdcb2cf36$var$BITS23, $281a441cdcb2cf36$var$BITS24, $281a441cdcb2cf36$var$BITS25, $281a441cdcb2cf36$var$BITS26, $281a441cdcb2cf36$var$BITS27, $281a441cdcb2cf36$var$BITS28, $281a441cdcb2cf36$var$BITS29, $281a441cdcb2cf36$var$BITS30, $281a441cdcb2cf36$var$BITS31;
var $281a441cdcb2cf36$var$init_binary = $281a441cdcb2cf36$var$__esm({
    "../node_modules/lib0/binary.js" () {
        $281a441cdcb2cf36$var$BIT1 = 1;
        $281a441cdcb2cf36$var$BIT2 = 2;
        $281a441cdcb2cf36$var$BIT3 = 4;
        $281a441cdcb2cf36$var$BIT4 = 8;
        $281a441cdcb2cf36$var$BIT6 = 32;
        $281a441cdcb2cf36$var$BIT7 = 64;
        $281a441cdcb2cf36$var$BIT8 = 128;
        $281a441cdcb2cf36$var$BIT18 = 131072;
        $281a441cdcb2cf36$var$BIT19 = 262144;
        $281a441cdcb2cf36$var$BIT20 = 524288;
        $281a441cdcb2cf36$var$BIT21 = 1048576;
        $281a441cdcb2cf36$var$BIT22 = 2097152;
        $281a441cdcb2cf36$var$BIT23 = 4194304;
        $281a441cdcb2cf36$var$BIT24 = 8388608;
        $281a441cdcb2cf36$var$BIT25 = 16777216;
        $281a441cdcb2cf36$var$BIT26 = 33554432;
        $281a441cdcb2cf36$var$BIT27 = 67108864;
        $281a441cdcb2cf36$var$BIT28 = 134217728;
        $281a441cdcb2cf36$var$BIT29 = 268435456;
        $281a441cdcb2cf36$var$BIT30 = 536870912;
        $281a441cdcb2cf36$var$BIT31 = 1073741824;
        $281a441cdcb2cf36$var$BIT32 = -2147483648;
        $281a441cdcb2cf36$var$BITS5 = 31;
        $281a441cdcb2cf36$var$BITS6 = 63;
        $281a441cdcb2cf36$var$BITS7 = 127;
        $281a441cdcb2cf36$var$BITS17 = $281a441cdcb2cf36$var$BIT18 - 1;
        $281a441cdcb2cf36$var$BITS18 = $281a441cdcb2cf36$var$BIT19 - 1;
        $281a441cdcb2cf36$var$BITS19 = $281a441cdcb2cf36$var$BIT20 - 1;
        $281a441cdcb2cf36$var$BITS20 = $281a441cdcb2cf36$var$BIT21 - 1;
        $281a441cdcb2cf36$var$BITS21 = $281a441cdcb2cf36$var$BIT22 - 1;
        $281a441cdcb2cf36$var$BITS22 = $281a441cdcb2cf36$var$BIT23 - 1;
        $281a441cdcb2cf36$var$BITS23 = $281a441cdcb2cf36$var$BIT24 - 1;
        $281a441cdcb2cf36$var$BITS24 = $281a441cdcb2cf36$var$BIT25 - 1;
        $281a441cdcb2cf36$var$BITS25 = $281a441cdcb2cf36$var$BIT26 - 1;
        $281a441cdcb2cf36$var$BITS26 = $281a441cdcb2cf36$var$BIT27 - 1;
        $281a441cdcb2cf36$var$BITS27 = $281a441cdcb2cf36$var$BIT28 - 1;
        $281a441cdcb2cf36$var$BITS28 = $281a441cdcb2cf36$var$BIT29 - 1;
        $281a441cdcb2cf36$var$BITS29 = $281a441cdcb2cf36$var$BIT30 - 1;
        $281a441cdcb2cf36$var$BITS30 = $281a441cdcb2cf36$var$BIT31 - 1;
        $281a441cdcb2cf36$var$BITS31 = 2147483647;
    }
});
// ../node_modules/lib0/number.js
var $281a441cdcb2cf36$var$MAX_SAFE_INTEGER, $281a441cdcb2cf36$var$MIN_SAFE_INTEGER, $281a441cdcb2cf36$var$LOWEST_INT32, $281a441cdcb2cf36$var$isInteger2, $281a441cdcb2cf36$var$isNaN3, $281a441cdcb2cf36$var$parseInt2;
var $281a441cdcb2cf36$var$init_number = $281a441cdcb2cf36$var$__esm({
    "../node_modules/lib0/number.js" () {
        $281a441cdcb2cf36$var$init_math();
        $281a441cdcb2cf36$var$MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER;
        $281a441cdcb2cf36$var$MIN_SAFE_INTEGER = Number.MIN_SAFE_INTEGER;
        $281a441cdcb2cf36$var$LOWEST_INT32 = -2147483648;
        $281a441cdcb2cf36$var$isInteger2 = Number.isInteger || ((num)=>typeof num === "number" && isFinite(num) && $281a441cdcb2cf36$var$floor(num) === num);
        $281a441cdcb2cf36$var$isNaN3 = Number.isNaN;
        $281a441cdcb2cf36$var$parseInt2 = Number.parseInt;
    }
});
// ../node_modules/lib0/string.js
var $281a441cdcb2cf36$var$fromCharCode, $281a441cdcb2cf36$var$fromCodePoint, $281a441cdcb2cf36$var$MAX_UTF16_CHARACTER, $281a441cdcb2cf36$var$toLowerCase, $281a441cdcb2cf36$var$trimLeftRegex, $281a441cdcb2cf36$var$trimLeft, $281a441cdcb2cf36$var$fromCamelCaseRegex, $281a441cdcb2cf36$var$fromCamelCase, $281a441cdcb2cf36$var$_encodeUtf8Polyfill, $281a441cdcb2cf36$var$utf8TextEncoder, $281a441cdcb2cf36$var$_encodeUtf8Native, $281a441cdcb2cf36$var$encodeUtf8, $281a441cdcb2cf36$var$utf8TextDecoder, $281a441cdcb2cf36$var$repeat;
var $281a441cdcb2cf36$var$init_string = $281a441cdcb2cf36$var$__esm({
    "../node_modules/lib0/string.js" () {
        $281a441cdcb2cf36$var$init_array();
        $281a441cdcb2cf36$var$fromCharCode = String.fromCharCode;
        $281a441cdcb2cf36$var$fromCodePoint = String.fromCodePoint;
        $281a441cdcb2cf36$var$MAX_UTF16_CHARACTER = $281a441cdcb2cf36$var$fromCharCode(65535);
        $281a441cdcb2cf36$var$toLowerCase = (s3)=>s3.toLowerCase();
        $281a441cdcb2cf36$var$trimLeftRegex = /^\s*/g;
        $281a441cdcb2cf36$var$trimLeft = (s3)=>s3.replace($281a441cdcb2cf36$var$trimLeftRegex, "");
        $281a441cdcb2cf36$var$fromCamelCaseRegex = /([A-Z])/g;
        $281a441cdcb2cf36$var$fromCamelCase = (s3, separator)=>$281a441cdcb2cf36$var$trimLeft(s3.replace($281a441cdcb2cf36$var$fromCamelCaseRegex, (match2)=>`${separator}${$281a441cdcb2cf36$var$toLowerCase(match2)}`));
        $281a441cdcb2cf36$var$_encodeUtf8Polyfill = (str)=>{
            const encodedString = unescape(encodeURIComponent(str));
            const len = encodedString.length;
            const buf = new Uint8Array(len);
            for(let i3 = 0; i3 < len; i3++)buf[i3] = /** @type {number} */ encodedString.codePointAt(i3);
            return buf;
        };
        $281a441cdcb2cf36$var$utf8TextEncoder = /** @type {TextEncoder} */ typeof TextEncoder !== "undefined" ? new TextEncoder() : null;
        $281a441cdcb2cf36$var$_encodeUtf8Native = (str)=>$281a441cdcb2cf36$var$utf8TextEncoder.encode(str);
        $281a441cdcb2cf36$var$encodeUtf8 = $281a441cdcb2cf36$var$utf8TextEncoder ? $281a441cdcb2cf36$var$_encodeUtf8Native : $281a441cdcb2cf36$var$_encodeUtf8Polyfill;
        $281a441cdcb2cf36$var$utf8TextDecoder = typeof TextDecoder === "undefined" ? null : new TextDecoder("utf-8", {
            fatal: true,
            ignoreBOM: true
        });
        if ($281a441cdcb2cf36$var$utf8TextDecoder && $281a441cdcb2cf36$var$utf8TextDecoder.decode(new Uint8Array()).length === 1) $281a441cdcb2cf36$var$utf8TextDecoder = null;
        $281a441cdcb2cf36$var$repeat = (source, n3)=>$281a441cdcb2cf36$var$unfold(n3, ()=>source).join("");
    }
});
// ../node_modules/lib0/encoding.js
var $281a441cdcb2cf36$var$Encoder2, $281a441cdcb2cf36$var$createEncoder, $281a441cdcb2cf36$var$length, $281a441cdcb2cf36$var$toUint8Array, $281a441cdcb2cf36$var$verifyLen, $281a441cdcb2cf36$var$write, $281a441cdcb2cf36$var$writeUint8, $281a441cdcb2cf36$var$writeVarUint, $281a441cdcb2cf36$var$writeVarInt, $281a441cdcb2cf36$var$_strBuffer, $281a441cdcb2cf36$var$_maxStrBSize, $281a441cdcb2cf36$var$_writeVarStringNative, $281a441cdcb2cf36$var$_writeVarStringPolyfill, $281a441cdcb2cf36$var$writeVarString, $281a441cdcb2cf36$var$writeUint8Array, $281a441cdcb2cf36$var$writeVarUint8Array, $281a441cdcb2cf36$var$writeOnDataView, $281a441cdcb2cf36$var$writeFloat32, $281a441cdcb2cf36$var$writeFloat64, $281a441cdcb2cf36$var$writeBigInt64, $281a441cdcb2cf36$var$floatTestBed, $281a441cdcb2cf36$var$isFloat32, $281a441cdcb2cf36$var$writeAny, $281a441cdcb2cf36$var$RleEncoder, $281a441cdcb2cf36$var$flushUintOptRleEncoder, $281a441cdcb2cf36$var$UintOptRleEncoder, $281a441cdcb2cf36$var$flushIntDiffOptRleEncoder, $281a441cdcb2cf36$var$IntDiffOptRleEncoder, $281a441cdcb2cf36$var$StringEncoder;
var $281a441cdcb2cf36$var$init_encoding = $281a441cdcb2cf36$var$__esm({
    "../node_modules/lib0/encoding.js" () {
        $281a441cdcb2cf36$var$init_math();
        $281a441cdcb2cf36$var$init_number();
        $281a441cdcb2cf36$var$init_binary();
        $281a441cdcb2cf36$var$init_string();
        $281a441cdcb2cf36$var$init_array();
        $281a441cdcb2cf36$var$Encoder2 = class {
            constructor(){
                this.cpos = 0;
                this.cbuf = new Uint8Array(100);
                this.bufs = [];
            }
        };
        $281a441cdcb2cf36$var$createEncoder = ()=>new $281a441cdcb2cf36$var$Encoder2();
        $281a441cdcb2cf36$var$length = (encoder)=>{
            let len = encoder.cpos;
            for(let i3 = 0; i3 < encoder.bufs.length; i3++)len += encoder.bufs[i3].length;
            return len;
        };
        $281a441cdcb2cf36$var$toUint8Array = (encoder)=>{
            const uint8arr = new Uint8Array($281a441cdcb2cf36$var$length(encoder));
            let curPos = 0;
            for(let i3 = 0; i3 < encoder.bufs.length; i3++){
                const d3 = encoder.bufs[i3];
                uint8arr.set(d3, curPos);
                curPos += d3.length;
            }
            uint8arr.set(new Uint8Array(encoder.cbuf.buffer, 0, encoder.cpos), curPos);
            return uint8arr;
        };
        $281a441cdcb2cf36$var$verifyLen = (encoder, len)=>{
            const bufferLen = encoder.cbuf.length;
            if (bufferLen - encoder.cpos < len) {
                encoder.bufs.push(new Uint8Array(encoder.cbuf.buffer, 0, encoder.cpos));
                encoder.cbuf = new Uint8Array($281a441cdcb2cf36$var$max(bufferLen, len) * 2);
                encoder.cpos = 0;
            }
        };
        $281a441cdcb2cf36$var$write = (encoder, num)=>{
            const bufferLen = encoder.cbuf.length;
            if (encoder.cpos === bufferLen) {
                encoder.bufs.push(encoder.cbuf);
                encoder.cbuf = new Uint8Array(bufferLen * 2);
                encoder.cpos = 0;
            }
            encoder.cbuf[encoder.cpos++] = num;
        };
        $281a441cdcb2cf36$var$writeUint8 = $281a441cdcb2cf36$var$write;
        $281a441cdcb2cf36$var$writeVarUint = (encoder, num)=>{
            while(num > $281a441cdcb2cf36$var$BITS7){
                $281a441cdcb2cf36$var$write(encoder, $281a441cdcb2cf36$var$BIT8 | $281a441cdcb2cf36$var$BITS7 & num);
                num = $281a441cdcb2cf36$var$floor(num / 128);
            }
            $281a441cdcb2cf36$var$write(encoder, $281a441cdcb2cf36$var$BITS7 & num);
        };
        $281a441cdcb2cf36$var$writeVarInt = (encoder, num)=>{
            const isNegative = $281a441cdcb2cf36$var$isNegativeZero(num);
            if (isNegative) num = -num;
            $281a441cdcb2cf36$var$write(encoder, (num > $281a441cdcb2cf36$var$BITS6 ? $281a441cdcb2cf36$var$BIT8 : 0) | (isNegative ? $281a441cdcb2cf36$var$BIT7 : 0) | $281a441cdcb2cf36$var$BITS6 & num);
            num = $281a441cdcb2cf36$var$floor(num / 64);
            while(num > 0){
                $281a441cdcb2cf36$var$write(encoder, (num > $281a441cdcb2cf36$var$BITS7 ? $281a441cdcb2cf36$var$BIT8 : 0) | $281a441cdcb2cf36$var$BITS7 & num);
                num = $281a441cdcb2cf36$var$floor(num / 128);
            }
        };
        $281a441cdcb2cf36$var$_strBuffer = new Uint8Array(3e4);
        $281a441cdcb2cf36$var$_maxStrBSize = $281a441cdcb2cf36$var$_strBuffer.length / 3;
        $281a441cdcb2cf36$var$_writeVarStringNative = (encoder, str)=>{
            if (str.length < $281a441cdcb2cf36$var$_maxStrBSize) {
                const written = $281a441cdcb2cf36$var$utf8TextEncoder.encodeInto(str, $281a441cdcb2cf36$var$_strBuffer).written || 0;
                $281a441cdcb2cf36$var$writeVarUint(encoder, written);
                for(let i3 = 0; i3 < written; i3++)$281a441cdcb2cf36$var$write(encoder, $281a441cdcb2cf36$var$_strBuffer[i3]);
            } else $281a441cdcb2cf36$var$writeVarUint8Array(encoder, $281a441cdcb2cf36$var$encodeUtf8(str));
        };
        $281a441cdcb2cf36$var$_writeVarStringPolyfill = (encoder, str)=>{
            const encodedString = unescape(encodeURIComponent(str));
            const len = encodedString.length;
            $281a441cdcb2cf36$var$writeVarUint(encoder, len);
            for(let i3 = 0; i3 < len; i3++)$281a441cdcb2cf36$var$write(encoder, /** @type {number} */ encodedString.codePointAt(i3));
        };
        $281a441cdcb2cf36$var$writeVarString = $281a441cdcb2cf36$var$utf8TextEncoder && /** @type {any} */ $281a441cdcb2cf36$var$utf8TextEncoder.encodeInto ? $281a441cdcb2cf36$var$_writeVarStringNative : $281a441cdcb2cf36$var$_writeVarStringPolyfill;
        $281a441cdcb2cf36$var$writeUint8Array = (encoder, uint8Array)=>{
            const bufferLen = encoder.cbuf.length;
            const cpos = encoder.cpos;
            const leftCopyLen = $281a441cdcb2cf36$var$min(bufferLen - cpos, uint8Array.length);
            const rightCopyLen = uint8Array.length - leftCopyLen;
            encoder.cbuf.set(uint8Array.subarray(0, leftCopyLen), cpos);
            encoder.cpos += leftCopyLen;
            if (rightCopyLen > 0) {
                encoder.bufs.push(encoder.cbuf);
                encoder.cbuf = new Uint8Array($281a441cdcb2cf36$var$max(bufferLen * 2, rightCopyLen));
                encoder.cbuf.set(uint8Array.subarray(leftCopyLen));
                encoder.cpos = rightCopyLen;
            }
        };
        $281a441cdcb2cf36$var$writeVarUint8Array = (encoder, uint8Array)=>{
            $281a441cdcb2cf36$var$writeVarUint(encoder, uint8Array.byteLength);
            $281a441cdcb2cf36$var$writeUint8Array(encoder, uint8Array);
        };
        $281a441cdcb2cf36$var$writeOnDataView = (encoder, len)=>{
            $281a441cdcb2cf36$var$verifyLen(encoder, len);
            const dview = new DataView(encoder.cbuf.buffer, encoder.cpos, len);
            encoder.cpos += len;
            return dview;
        };
        $281a441cdcb2cf36$var$writeFloat32 = (encoder, num)=>$281a441cdcb2cf36$var$writeOnDataView(encoder, 4).setFloat32(0, num, false);
        $281a441cdcb2cf36$var$writeFloat64 = (encoder, num)=>$281a441cdcb2cf36$var$writeOnDataView(encoder, 8).setFloat64(0, num, false);
        $281a441cdcb2cf36$var$writeBigInt64 = (encoder, num)=>/** @type {any} */ $281a441cdcb2cf36$var$writeOnDataView(encoder, 8).setBigInt64(0, num, false);
        $281a441cdcb2cf36$var$floatTestBed = new DataView(new ArrayBuffer(4));
        $281a441cdcb2cf36$var$isFloat32 = (num)=>{
            $281a441cdcb2cf36$var$floatTestBed.setFloat32(0, num);
            return $281a441cdcb2cf36$var$floatTestBed.getFloat32(0) === num;
        };
        $281a441cdcb2cf36$var$writeAny = (encoder, data2)=>{
            switch(typeof data2){
                case "string":
                    $281a441cdcb2cf36$var$write(encoder, 119);
                    $281a441cdcb2cf36$var$writeVarString(encoder, data2);
                    break;
                case "number":
                    if ($281a441cdcb2cf36$var$isInteger2(data2) && $281a441cdcb2cf36$var$abs(data2) <= $281a441cdcb2cf36$var$BITS31) {
                        $281a441cdcb2cf36$var$write(encoder, 125);
                        $281a441cdcb2cf36$var$writeVarInt(encoder, data2);
                    } else if ($281a441cdcb2cf36$var$isFloat32(data2)) {
                        $281a441cdcb2cf36$var$write(encoder, 124);
                        $281a441cdcb2cf36$var$writeFloat32(encoder, data2);
                    } else {
                        $281a441cdcb2cf36$var$write(encoder, 123);
                        $281a441cdcb2cf36$var$writeFloat64(encoder, data2);
                    }
                    break;
                case "bigint":
                    $281a441cdcb2cf36$var$write(encoder, 122);
                    $281a441cdcb2cf36$var$writeBigInt64(encoder, data2);
                    break;
                case "object":
                    if (data2 === null) $281a441cdcb2cf36$var$write(encoder, 126);
                    else if ($281a441cdcb2cf36$var$isArray(data2)) {
                        $281a441cdcb2cf36$var$write(encoder, 117);
                        $281a441cdcb2cf36$var$writeVarUint(encoder, data2.length);
                        for(let i3 = 0; i3 < data2.length; i3++)$281a441cdcb2cf36$var$writeAny(encoder, data2[i3]);
                    } else if (data2 instanceof Uint8Array) {
                        $281a441cdcb2cf36$var$write(encoder, 116);
                        $281a441cdcb2cf36$var$writeVarUint8Array(encoder, data2);
                    } else {
                        $281a441cdcb2cf36$var$write(encoder, 118);
                        const keys2 = Object.keys(data2);
                        $281a441cdcb2cf36$var$writeVarUint(encoder, keys2.length);
                        for(let i3 = 0; i3 < keys2.length; i3++){
                            const key = keys2[i3];
                            $281a441cdcb2cf36$var$writeVarString(encoder, key);
                            $281a441cdcb2cf36$var$writeAny(encoder, data2[key]);
                        }
                    }
                    break;
                case "boolean":
                    $281a441cdcb2cf36$var$write(encoder, data2 ? 120 : 121);
                    break;
                default:
                    $281a441cdcb2cf36$var$write(encoder, 127);
            }
        };
        $281a441cdcb2cf36$var$RleEncoder = class extends $281a441cdcb2cf36$var$Encoder2 {
            /**
       * @param {function(Encoder, T):void} writer
       */ constructor(writer){
                super();
                this.w = writer;
                this.s = null;
                this.count = 0;
            }
            /**
       * @param {T} v
       */ write(v3) {
                if (this.s === v3) this.count++;
                else {
                    if (this.count > 0) $281a441cdcb2cf36$var$writeVarUint(this, this.count - 1);
                    this.count = 1;
                    this.w(this, v3);
                    this.s = v3;
                }
            }
        };
        $281a441cdcb2cf36$var$flushUintOptRleEncoder = (encoder)=>{
            if (encoder.count > 0) {
                $281a441cdcb2cf36$var$writeVarInt(encoder.encoder, encoder.count === 1 ? encoder.s : -encoder.s);
                if (encoder.count > 1) $281a441cdcb2cf36$var$writeVarUint(encoder.encoder, encoder.count - 2);
            }
        };
        $281a441cdcb2cf36$var$UintOptRleEncoder = class {
            constructor(){
                this.encoder = new $281a441cdcb2cf36$var$Encoder2();
                this.s = 0;
                this.count = 0;
            }
            /**
       * @param {number} v
       */ write(v3) {
                if (this.s === v3) this.count++;
                else {
                    $281a441cdcb2cf36$var$flushUintOptRleEncoder(this);
                    this.count = 1;
                    this.s = v3;
                }
            }
            /**
       * Flush the encoded state and transform this to a Uint8Array.
       *
       * Note that this should only be called once.
       */ toUint8Array() {
                $281a441cdcb2cf36$var$flushUintOptRleEncoder(this);
                return $281a441cdcb2cf36$var$toUint8Array(this.encoder);
            }
        };
        $281a441cdcb2cf36$var$flushIntDiffOptRleEncoder = (encoder)=>{
            if (encoder.count > 0) {
                const encodedDiff = encoder.diff * 2 + (encoder.count === 1 ? 0 : 1);
                $281a441cdcb2cf36$var$writeVarInt(encoder.encoder, encodedDiff);
                if (encoder.count > 1) $281a441cdcb2cf36$var$writeVarUint(encoder.encoder, encoder.count - 2);
            }
        };
        $281a441cdcb2cf36$var$IntDiffOptRleEncoder = class {
            constructor(){
                this.encoder = new $281a441cdcb2cf36$var$Encoder2();
                this.s = 0;
                this.count = 0;
                this.diff = 0;
            }
            /**
       * @param {number} v
       */ write(v3) {
                if (this.diff === v3 - this.s) {
                    this.s = v3;
                    this.count++;
                } else {
                    $281a441cdcb2cf36$var$flushIntDiffOptRleEncoder(this);
                    this.count = 1;
                    this.diff = v3 - this.s;
                    this.s = v3;
                }
            }
            /**
       * Flush the encoded state and transform this to a Uint8Array.
       *
       * Note that this should only be called once.
       */ toUint8Array() {
                $281a441cdcb2cf36$var$flushIntDiffOptRleEncoder(this);
                return $281a441cdcb2cf36$var$toUint8Array(this.encoder);
            }
        };
        $281a441cdcb2cf36$var$StringEncoder = class {
            constructor(){
                this.sarr = [];
                this.s = "";
                this.lensE = new $281a441cdcb2cf36$var$UintOptRleEncoder();
            }
            /**
       * @param {string} string
       */ write(string) {
                this.s += string;
                if (this.s.length > 19) {
                    this.sarr.push(this.s);
                    this.s = "";
                }
                this.lensE.write(string.length);
            }
            toUint8Array() {
                const encoder = new $281a441cdcb2cf36$var$Encoder2();
                this.sarr.push(this.s);
                this.s = "";
                $281a441cdcb2cf36$var$writeVarString(encoder, this.sarr.join(""));
                $281a441cdcb2cf36$var$writeUint8Array(encoder, this.lensE.toUint8Array());
                return $281a441cdcb2cf36$var$toUint8Array(encoder);
            }
        };
    }
});
// ../node_modules/lib0/error.js
var $281a441cdcb2cf36$var$create3, $281a441cdcb2cf36$var$methodUnimplemented, $281a441cdcb2cf36$var$unexpectedCase;
var $281a441cdcb2cf36$var$init_error = $281a441cdcb2cf36$var$__esm({
    "../node_modules/lib0/error.js" () {
        $281a441cdcb2cf36$var$create3 = (s3)=>new Error(s3);
        $281a441cdcb2cf36$var$methodUnimplemented = ()=>{
            throw $281a441cdcb2cf36$var$create3("Method unimplemented");
        };
        $281a441cdcb2cf36$var$unexpectedCase = ()=>{
            throw $281a441cdcb2cf36$var$create3("Unexpected case");
        };
    }
});
// ../node_modules/lib0/decoding.js
var $281a441cdcb2cf36$var$errorUnexpectedEndOfArray, $281a441cdcb2cf36$var$errorIntegerOutOfRange, $281a441cdcb2cf36$var$Decoder2, $281a441cdcb2cf36$var$createDecoder, $281a441cdcb2cf36$var$hasContent, $281a441cdcb2cf36$var$readUint8Array, $281a441cdcb2cf36$var$readVarUint8Array, $281a441cdcb2cf36$var$readUint8, $281a441cdcb2cf36$var$readVarUint, $281a441cdcb2cf36$var$readVarInt, $281a441cdcb2cf36$var$_readVarStringPolyfill, $281a441cdcb2cf36$var$_readVarStringNative, $281a441cdcb2cf36$var$readVarString, $281a441cdcb2cf36$var$readFromDataView, $281a441cdcb2cf36$var$readFloat32, $281a441cdcb2cf36$var$readFloat64, $281a441cdcb2cf36$var$readBigInt64, $281a441cdcb2cf36$var$readAnyLookupTable, $281a441cdcb2cf36$var$readAny, $281a441cdcb2cf36$var$RleDecoder, $281a441cdcb2cf36$var$UintOptRleDecoder, $281a441cdcb2cf36$var$IntDiffOptRleDecoder, $281a441cdcb2cf36$var$StringDecoder;
var $281a441cdcb2cf36$var$init_decoding = $281a441cdcb2cf36$var$__esm({
    "../node_modules/lib0/decoding.js" () {
        $281a441cdcb2cf36$var$init_binary();
        $281a441cdcb2cf36$var$init_math();
        $281a441cdcb2cf36$var$init_number();
        $281a441cdcb2cf36$var$init_string();
        $281a441cdcb2cf36$var$init_error();
        $281a441cdcb2cf36$var$errorUnexpectedEndOfArray = $281a441cdcb2cf36$var$create3("Unexpected end of array");
        $281a441cdcb2cf36$var$errorIntegerOutOfRange = $281a441cdcb2cf36$var$create3("Integer out of Range");
        $281a441cdcb2cf36$var$Decoder2 = class {
            /**
       * @param {Uint8Array<Buf>} uint8Array Binary data to decode
       */ constructor(uint8Array){
                this.arr = uint8Array;
                this.pos = 0;
            }
        };
        $281a441cdcb2cf36$var$createDecoder = (uint8Array)=>new $281a441cdcb2cf36$var$Decoder2(uint8Array);
        $281a441cdcb2cf36$var$hasContent = (decoder)=>decoder.pos !== decoder.arr.length;
        $281a441cdcb2cf36$var$readUint8Array = (decoder, len)=>{
            const view = new Uint8Array(decoder.arr.buffer, decoder.pos + decoder.arr.byteOffset, len);
            decoder.pos += len;
            return view;
        };
        $281a441cdcb2cf36$var$readVarUint8Array = (decoder)=>$281a441cdcb2cf36$var$readUint8Array(decoder, $281a441cdcb2cf36$var$readVarUint(decoder));
        $281a441cdcb2cf36$var$readUint8 = (decoder)=>decoder.arr[decoder.pos++];
        $281a441cdcb2cf36$var$readVarUint = (decoder)=>{
            let num = 0;
            let mult = 1;
            const len = decoder.arr.length;
            while(decoder.pos < len){
                const r3 = decoder.arr[decoder.pos++];
                num = num + (r3 & $281a441cdcb2cf36$var$BITS7) * mult;
                mult *= 128;
                if (r3 < $281a441cdcb2cf36$var$BIT8) return num;
                if (num > $281a441cdcb2cf36$var$MAX_SAFE_INTEGER) throw $281a441cdcb2cf36$var$errorIntegerOutOfRange;
            }
            throw $281a441cdcb2cf36$var$errorUnexpectedEndOfArray;
        };
        $281a441cdcb2cf36$var$readVarInt = (decoder)=>{
            let r3 = decoder.arr[decoder.pos++];
            let num = r3 & $281a441cdcb2cf36$var$BITS6;
            let mult = 64;
            const sign = (r3 & $281a441cdcb2cf36$var$BIT7) > 0 ? -1 : 1;
            if ((r3 & $281a441cdcb2cf36$var$BIT8) === 0) return sign * num;
            const len = decoder.arr.length;
            while(decoder.pos < len){
                r3 = decoder.arr[decoder.pos++];
                num = num + (r3 & $281a441cdcb2cf36$var$BITS7) * mult;
                mult *= 128;
                if (r3 < $281a441cdcb2cf36$var$BIT8) return sign * num;
                if (num > $281a441cdcb2cf36$var$MAX_SAFE_INTEGER) throw $281a441cdcb2cf36$var$errorIntegerOutOfRange;
            }
            throw $281a441cdcb2cf36$var$errorUnexpectedEndOfArray;
        };
        $281a441cdcb2cf36$var$_readVarStringPolyfill = (decoder)=>{
            let remainingLen = $281a441cdcb2cf36$var$readVarUint(decoder);
            if (remainingLen === 0) return "";
            else {
                let encodedString = String.fromCodePoint($281a441cdcb2cf36$var$readUint8(decoder));
                if (--remainingLen < 100) while(remainingLen--)encodedString += String.fromCodePoint($281a441cdcb2cf36$var$readUint8(decoder));
                else while(remainingLen > 0){
                    const nextLen = remainingLen < 1e4 ? remainingLen : 1e4;
                    const bytes = decoder.arr.subarray(decoder.pos, decoder.pos + nextLen);
                    decoder.pos += nextLen;
                    encodedString += String.fromCodePoint.apply(null, /** @type {any} */ bytes);
                    remainingLen -= nextLen;
                }
                return decodeURIComponent(escape(encodedString));
            }
        };
        $281a441cdcb2cf36$var$_readVarStringNative = (decoder)=>/** @type any */ $281a441cdcb2cf36$var$utf8TextDecoder.decode($281a441cdcb2cf36$var$readVarUint8Array(decoder));
        $281a441cdcb2cf36$var$readVarString = $281a441cdcb2cf36$var$utf8TextDecoder ? $281a441cdcb2cf36$var$_readVarStringNative : $281a441cdcb2cf36$var$_readVarStringPolyfill;
        $281a441cdcb2cf36$var$readFromDataView = (decoder, len)=>{
            const dv = new DataView(decoder.arr.buffer, decoder.arr.byteOffset + decoder.pos, len);
            decoder.pos += len;
            return dv;
        };
        $281a441cdcb2cf36$var$readFloat32 = (decoder)=>$281a441cdcb2cf36$var$readFromDataView(decoder, 4).getFloat32(0, false);
        $281a441cdcb2cf36$var$readFloat64 = (decoder)=>$281a441cdcb2cf36$var$readFromDataView(decoder, 8).getFloat64(0, false);
        $281a441cdcb2cf36$var$readBigInt64 = (decoder)=>/** @type {any} */ $281a441cdcb2cf36$var$readFromDataView(decoder, 8).getBigInt64(0, false);
        $281a441cdcb2cf36$var$readAnyLookupTable = [
            (decoder)=>void 0,
            // CASE 127: undefined
            (decoder)=>null,
            // CASE 126: null
            $281a441cdcb2cf36$var$readVarInt,
            // CASE 125: integer
            $281a441cdcb2cf36$var$readFloat32,
            // CASE 124: float32
            $281a441cdcb2cf36$var$readFloat64,
            // CASE 123: float64
            $281a441cdcb2cf36$var$readBigInt64,
            // CASE 122: bigint
            (decoder)=>false,
            // CASE 121: boolean (false)
            (decoder)=>true,
            // CASE 120: boolean (true)
            $281a441cdcb2cf36$var$readVarString,
            // CASE 119: string
            (decoder)=>{
                const len = $281a441cdcb2cf36$var$readVarUint(decoder);
                const obj = {};
                for(let i3 = 0; i3 < len; i3++){
                    const key = $281a441cdcb2cf36$var$readVarString(decoder);
                    obj[key] = $281a441cdcb2cf36$var$readAny(decoder);
                }
                return obj;
            },
            (decoder)=>{
                const len = $281a441cdcb2cf36$var$readVarUint(decoder);
                const arr = [];
                for(let i3 = 0; i3 < len; i3++)arr.push($281a441cdcb2cf36$var$readAny(decoder));
                return arr;
            },
            $281a441cdcb2cf36$var$readVarUint8Array
        ];
        $281a441cdcb2cf36$var$readAny = (decoder)=>$281a441cdcb2cf36$var$readAnyLookupTable[127 - $281a441cdcb2cf36$var$readUint8(decoder)](decoder);
        $281a441cdcb2cf36$var$RleDecoder = class extends $281a441cdcb2cf36$var$Decoder2 {
            /**
       * @param {Uint8Array} uint8Array
       * @param {function(Decoder):T} reader
       */ constructor(uint8Array, reader){
                super(uint8Array);
                this.reader = reader;
                this.s = null;
                this.count = 0;
            }
            read() {
                if (this.count === 0) {
                    this.s = this.reader(this);
                    if ($281a441cdcb2cf36$var$hasContent(this)) this.count = $281a441cdcb2cf36$var$readVarUint(this) + 1;
                    else this.count = -1;
                }
                this.count--;
                return /** @type {T} */ this.s;
            }
        };
        $281a441cdcb2cf36$var$UintOptRleDecoder = class extends $281a441cdcb2cf36$var$Decoder2 {
            /**
       * @param {Uint8Array} uint8Array
       */ constructor(uint8Array){
                super(uint8Array);
                this.s = 0;
                this.count = 0;
            }
            read() {
                if (this.count === 0) {
                    this.s = $281a441cdcb2cf36$var$readVarInt(this);
                    const isNegative = $281a441cdcb2cf36$var$isNegativeZero(this.s);
                    this.count = 1;
                    if (isNegative) {
                        this.s = -this.s;
                        this.count = $281a441cdcb2cf36$var$readVarUint(this) + 2;
                    }
                }
                this.count--;
                return /** @type {number} */ this.s;
            }
        };
        $281a441cdcb2cf36$var$IntDiffOptRleDecoder = class extends $281a441cdcb2cf36$var$Decoder2 {
            /**
       * @param {Uint8Array} uint8Array
       */ constructor(uint8Array){
                super(uint8Array);
                this.s = 0;
                this.count = 0;
                this.diff = 0;
            }
            /**
       * @return {number}
       */ read() {
                if (this.count === 0) {
                    const diff = $281a441cdcb2cf36$var$readVarInt(this);
                    const hasCount = diff & 1;
                    this.diff = $281a441cdcb2cf36$var$floor(diff / 2);
                    this.count = 1;
                    if (hasCount) this.count = $281a441cdcb2cf36$var$readVarUint(this) + 2;
                }
                this.s += this.diff;
                this.count--;
                return this.s;
            }
        };
        $281a441cdcb2cf36$var$StringDecoder = class {
            /**
       * @param {Uint8Array} uint8Array
       */ constructor(uint8Array){
                this.decoder = new $281a441cdcb2cf36$var$UintOptRleDecoder(uint8Array);
                this.str = $281a441cdcb2cf36$var$readVarString(this.decoder);
                this.spos = 0;
            }
            /**
       * @return {string}
       */ read() {
                const end = this.spos + this.decoder.read();
                const res = this.str.slice(this.spos, end);
                this.spos = end;
                return res;
            }
        };
    }
});
// ../node_modules/lib0/webcrypto.js
var $281a441cdcb2cf36$var$subtle, $281a441cdcb2cf36$var$getRandomValues;
var $281a441cdcb2cf36$var$init_webcrypto = $281a441cdcb2cf36$var$__esm({
    "../node_modules/lib0/webcrypto.js" () {
        $281a441cdcb2cf36$var$subtle = crypto.subtle;
        $281a441cdcb2cf36$var$getRandomValues = crypto.getRandomValues.bind(crypto);
    }
});
// ../node_modules/lib0/random.js
var $281a441cdcb2cf36$var$uint32, $281a441cdcb2cf36$var$uuidv4Template, $281a441cdcb2cf36$var$uuidv4;
var $281a441cdcb2cf36$var$init_random = $281a441cdcb2cf36$var$__esm({
    "../node_modules/lib0/random.js" () {
        $281a441cdcb2cf36$var$init_webcrypto();
        $281a441cdcb2cf36$var$uint32 = ()=>$281a441cdcb2cf36$var$getRandomValues(new Uint32Array(1))[0];
        $281a441cdcb2cf36$var$uuidv4Template = "10000000-1000-4000-8000-100000000000";
        $281a441cdcb2cf36$var$uuidv4 = ()=>$281a441cdcb2cf36$var$uuidv4Template.replace(/[018]/g, /** @param {number} c */ (c3)=>(c3 ^ $281a441cdcb2cf36$var$uint32() & 15 >> c3 / 4).toString(16));
    }
});
// ../node_modules/lib0/time.js
var $281a441cdcb2cf36$var$getUnixTime;
var $281a441cdcb2cf36$var$init_time = $281a441cdcb2cf36$var$__esm({
    "../node_modules/lib0/time.js" () {
        $281a441cdcb2cf36$var$getUnixTime = Date.now;
    }
});
// ../node_modules/lib0/promise.js
var $281a441cdcb2cf36$var$create4, $281a441cdcb2cf36$var$all;
var $281a441cdcb2cf36$var$init_promise = $281a441cdcb2cf36$var$__esm({
    "../node_modules/lib0/promise.js" () {
        $281a441cdcb2cf36$var$create4 = (f3)=>/** @type {Promise<T>} */ new Promise(f3);
        $281a441cdcb2cf36$var$all = Promise.all.bind(Promise);
    }
});
// ../node_modules/lib0/conditions.js
var $281a441cdcb2cf36$var$undefinedToNull;
var $281a441cdcb2cf36$var$init_conditions = $281a441cdcb2cf36$var$__esm({
    "../node_modules/lib0/conditions.js" () {
        $281a441cdcb2cf36$var$undefinedToNull = (v3)=>v3 === void 0 ? null : v3;
    }
});
// ../node_modules/lib0/storage.js
var $281a441cdcb2cf36$var$VarStoragePolyfill, $281a441cdcb2cf36$var$_localStorage, $281a441cdcb2cf36$var$usePolyfill, $281a441cdcb2cf36$var$varStorage;
var $281a441cdcb2cf36$var$init_storage = $281a441cdcb2cf36$var$__esm({
    "../node_modules/lib0/storage.js" () {
        $281a441cdcb2cf36$var$VarStoragePolyfill = class {
            constructor(){
                this.map = /* @__PURE__ */ new Map();
            }
            /**
       * @param {string} key
       * @param {any} newValue
       */ setItem(key, newValue) {
                this.map.set(key, newValue);
            }
            /**
       * @param {string} key
       */ getItem(key) {
                return this.map.get(key);
            }
        };
        $281a441cdcb2cf36$var$_localStorage = new $281a441cdcb2cf36$var$VarStoragePolyfill();
        $281a441cdcb2cf36$var$usePolyfill = true;
        try {
            if (typeof localStorage !== "undefined" && localStorage) {
                $281a441cdcb2cf36$var$_localStorage = localStorage;
                $281a441cdcb2cf36$var$usePolyfill = false;
            }
        } catch (e4) {}
        $281a441cdcb2cf36$var$varStorage = $281a441cdcb2cf36$var$_localStorage;
    }
});
// ../node_modules/lib0/trait/equality.js
var $281a441cdcb2cf36$var$EqualityTraitSymbol, $281a441cdcb2cf36$var$equals;
var $281a441cdcb2cf36$var$init_equality = $281a441cdcb2cf36$var$__esm({
    "../node_modules/lib0/trait/equality.js" () {
        $281a441cdcb2cf36$var$EqualityTraitSymbol = /* @__PURE__ */ Symbol("Equality");
        $281a441cdcb2cf36$var$equals = (a3, b3)=>{
            var _a2;
            return a3 === b3 || !!((_a2 = a3 == null ? void 0 : a3[$281a441cdcb2cf36$var$EqualityTraitSymbol]) == null ? void 0 : _a2.call(a3, b3)) || false;
        };
    }
});
// ../node_modules/lib0/object.js
var $281a441cdcb2cf36$var$isObject2, $281a441cdcb2cf36$var$assign, $281a441cdcb2cf36$var$keys, $281a441cdcb2cf36$var$forEach, $281a441cdcb2cf36$var$size, $281a441cdcb2cf36$var$isEmpty, $281a441cdcb2cf36$var$every2, $281a441cdcb2cf36$var$hasProperty, $281a441cdcb2cf36$var$equalFlat, $281a441cdcb2cf36$var$freeze, $281a441cdcb2cf36$var$deepFreeze;
var $281a441cdcb2cf36$var$init_object = $281a441cdcb2cf36$var$__esm({
    "../node_modules/lib0/object.js" () {
        $281a441cdcb2cf36$var$init_equality();
        $281a441cdcb2cf36$var$isObject2 = (o3)=>typeof o3 === "object";
        $281a441cdcb2cf36$var$assign = Object.assign;
        $281a441cdcb2cf36$var$keys = Object.keys;
        $281a441cdcb2cf36$var$forEach = (obj, f3)=>{
            for(const key in obj)f3(obj[key], key);
        };
        $281a441cdcb2cf36$var$size = (obj)=>$281a441cdcb2cf36$var$keys(obj).length;
        $281a441cdcb2cf36$var$isEmpty = (obj)=>{
            for(const _k in obj)return false;
            return true;
        };
        $281a441cdcb2cf36$var$every2 = (obj, f3)=>{
            for(const key in obj){
                if (!f3(obj[key], key)) return false;
            }
            return true;
        };
        $281a441cdcb2cf36$var$hasProperty = (obj, key)=>Object.prototype.hasOwnProperty.call(obj, key);
        $281a441cdcb2cf36$var$equalFlat = (a3, b3)=>a3 === b3 || $281a441cdcb2cf36$var$size(a3) === $281a441cdcb2cf36$var$size(b3) && $281a441cdcb2cf36$var$every2(a3, (val, key)=>(val !== void 0 || $281a441cdcb2cf36$var$hasProperty(b3, key)) && $281a441cdcb2cf36$var$equals(b3[key], val));
        $281a441cdcb2cf36$var$freeze = Object.freeze;
        $281a441cdcb2cf36$var$deepFreeze = (o3)=>{
            for(const key in o3){
                const c3 = o3[key];
                if (typeof c3 === "object" || typeof c3 === "function") $281a441cdcb2cf36$var$deepFreeze(o3[key]);
            }
            return $281a441cdcb2cf36$var$freeze(o3);
        };
    }
});
// ../node_modules/lib0/function.js
var $281a441cdcb2cf36$var$callAll, $281a441cdcb2cf36$var$id, $281a441cdcb2cf36$var$equalityDeep, $281a441cdcb2cf36$var$isOneOf;
var $281a441cdcb2cf36$var$init_function = $281a441cdcb2cf36$var$__esm({
    "../node_modules/lib0/function.js" () {
        $281a441cdcb2cf36$var$init_object();
        $281a441cdcb2cf36$var$init_equality();
        $281a441cdcb2cf36$var$callAll = (fs, args2, i3 = 0)=>{
            try {
                for(; i3 < fs.length; i3++)fs[i3](...args2);
            } finally{
                if (i3 < fs.length) $281a441cdcb2cf36$var$callAll(fs, args2, i3 + 1);
            }
        };
        $281a441cdcb2cf36$var$id = (a3)=>a3;
        $281a441cdcb2cf36$var$equalityDeep = (a3, b3)=>{
            if (a3 === b3) return true;
            if (a3 == null || b3 == null || a3.constructor !== b3.constructor && (a3.constructor || Object) !== (b3.constructor || Object)) return false;
            if (a3[$281a441cdcb2cf36$var$EqualityTraitSymbol] != null) return a3[$281a441cdcb2cf36$var$EqualityTraitSymbol](b3);
            switch(a3.constructor){
                case ArrayBuffer:
                    a3 = new Uint8Array(a3);
                    b3 = new Uint8Array(b3);
                // eslint-disable-next-line no-fallthrough
                case Uint8Array:
                    if (a3.byteLength !== b3.byteLength) return false;
                    for(let i3 = 0; i3 < a3.length; i3++){
                        if (a3[i3] !== b3[i3]) return false;
                    }
                    break;
                case Set:
                    if (a3.size !== b3.size) return false;
                    for (const value2 of a3){
                        if (!b3.has(value2)) return false;
                    }
                    break;
                case Map:
                    if (a3.size !== b3.size) return false;
                    for (const key of a3.keys()){
                        if (!b3.has(key) || !$281a441cdcb2cf36$var$equalityDeep(a3.get(key), b3.get(key))) return false;
                    }
                    break;
                case void 0:
                case Object:
                    if ($281a441cdcb2cf36$var$size(a3) !== $281a441cdcb2cf36$var$size(b3)) return false;
                    for(const key in a3){
                        if (!$281a441cdcb2cf36$var$hasProperty(a3, key) || !$281a441cdcb2cf36$var$equalityDeep(a3[key], b3[key])) return false;
                    }
                    break;
                case Array:
                    if (a3.length !== b3.length) return false;
                    for(let i3 = 0; i3 < a3.length; i3++){
                        if (!$281a441cdcb2cf36$var$equalityDeep(a3[i3], b3[i3])) return false;
                    }
                    break;
                default:
                    return false;
            }
            return true;
        };
        $281a441cdcb2cf36$var$isOneOf = (value2, options)=>options.includes(value2);
    }
});
// ../node_modules/lib0/environment.js
var $281a441cdcb2cf36$var$isNode, $281a441cdcb2cf36$var$isMac, $281a441cdcb2cf36$var$params, $281a441cdcb2cf36$var$args, $281a441cdcb2cf36$var$computeParams, $281a441cdcb2cf36$var$hasParam, $281a441cdcb2cf36$var$getVariable, $281a441cdcb2cf36$var$hasConf, $281a441cdcb2cf36$var$production, $281a441cdcb2cf36$var$forceColor, $281a441cdcb2cf36$var$supportsColor;
var $281a441cdcb2cf36$var$init_environment = $281a441cdcb2cf36$var$__esm({
    "../node_modules/lib0/environment.js" () {
        $281a441cdcb2cf36$var$init_map();
        $281a441cdcb2cf36$var$init_string();
        $281a441cdcb2cf36$var$init_conditions();
        $281a441cdcb2cf36$var$init_storage();
        $281a441cdcb2cf36$var$init_function();
        $281a441cdcb2cf36$var$isNode = false;
        $281a441cdcb2cf36$var$isMac = typeof navigator !== "undefined" ? /Mac/.test(navigator.platform) : false;
        $281a441cdcb2cf36$var$args = [];
        $281a441cdcb2cf36$var$computeParams = ()=>{
            if ($281a441cdcb2cf36$var$params === void 0) {
                if ($281a441cdcb2cf36$var$isNode) {
                    $281a441cdcb2cf36$var$params = $281a441cdcb2cf36$var$create();
                    const pargs = $hPtJY.argv;
                    let currParamName = null;
                    for(let i3 = 0; i3 < pargs.length; i3++){
                        const parg = pargs[i3];
                        if (parg[0] === "-") {
                            if (currParamName !== null) $281a441cdcb2cf36$var$params.set(currParamName, "");
                            currParamName = parg;
                        } else if (currParamName !== null) {
                            $281a441cdcb2cf36$var$params.set(currParamName, parg);
                            currParamName = null;
                        } else $281a441cdcb2cf36$var$args.push(parg);
                    }
                    if (currParamName !== null) $281a441cdcb2cf36$var$params.set(currParamName, "");
                } else if (typeof location === "object") {
                    $281a441cdcb2cf36$var$params = $281a441cdcb2cf36$var$create();
                    (location.search || "?").slice(1).split("&").forEach((kv)=>{
                        if (kv.length !== 0) {
                            const [key, value2] = kv.split("=");
                            $281a441cdcb2cf36$var$params.set(`--${$281a441cdcb2cf36$var$fromCamelCase(key, "-")}`, value2);
                            $281a441cdcb2cf36$var$params.set(`-${$281a441cdcb2cf36$var$fromCamelCase(key, "-")}`, value2);
                        }
                    });
                } else $281a441cdcb2cf36$var$params = $281a441cdcb2cf36$var$create();
            }
            return $281a441cdcb2cf36$var$params;
        };
        $281a441cdcb2cf36$var$hasParam = (name)=>$281a441cdcb2cf36$var$computeParams().has(name);
        $281a441cdcb2cf36$var$getVariable = (name)=>$281a441cdcb2cf36$var$isNode ? $281a441cdcb2cf36$var$undefinedToNull($hPtJY.env[name.toUpperCase().replaceAll("-", "_")]) : $281a441cdcb2cf36$var$undefinedToNull($281a441cdcb2cf36$var$varStorage.getItem(name));
        $281a441cdcb2cf36$var$hasConf = (name)=>$281a441cdcb2cf36$var$hasParam("--" + name) || $281a441cdcb2cf36$var$getVariable(name) !== null;
        $281a441cdcb2cf36$var$production = $281a441cdcb2cf36$var$hasConf("production");
        $281a441cdcb2cf36$var$forceColor = $281a441cdcb2cf36$var$isNode && $281a441cdcb2cf36$var$isOneOf(undefined, [
            "true",
            "1",
            "2"
        ]);
        $281a441cdcb2cf36$var$supportsColor = $281a441cdcb2cf36$var$forceColor || !$281a441cdcb2cf36$var$hasParam("--no-colors") && // @todo deprecate --no-colors
        !$281a441cdcb2cf36$var$hasConf("no-color") && (!$281a441cdcb2cf36$var$isNode || $hPtJY.stdout.isTTY) && (!$281a441cdcb2cf36$var$isNode || $281a441cdcb2cf36$var$hasParam("--color") || $281a441cdcb2cf36$var$getVariable("COLORTERM") !== null || ($281a441cdcb2cf36$var$getVariable("TERM") || "").includes("color"));
    }
});
// ../node_modules/lib0/buffer.js
var $281a441cdcb2cf36$var$createUint8ArrayFromLen, $281a441cdcb2cf36$var$copyUint8Array;
var $281a441cdcb2cf36$var$init_buffer = $281a441cdcb2cf36$var$__esm({
    "../node_modules/lib0/buffer.js" () {
        $281a441cdcb2cf36$var$createUint8ArrayFromLen = (len)=>new Uint8Array(len);
        $281a441cdcb2cf36$var$copyUint8Array = (uint8Array)=>{
            const newBuf = $281a441cdcb2cf36$var$createUint8ArrayFromLen(uint8Array.byteLength);
            newBuf.set(uint8Array);
            return newBuf;
        };
    }
});
// ../node_modules/lib0/pair.js
var $281a441cdcb2cf36$var$Pair, $281a441cdcb2cf36$var$create5;
var $281a441cdcb2cf36$var$init_pair = $281a441cdcb2cf36$var$__esm({
    "../node_modules/lib0/pair.js" () {
        $281a441cdcb2cf36$var$Pair = class {
            /**
       * @param {L} left
       * @param {R} right
       */ constructor(left, right){
                this.left = left;
                this.right = right;
            }
        };
        $281a441cdcb2cf36$var$create5 = (left, right)=>new $281a441cdcb2cf36$var$Pair(left, right);
    }
});
// ../node_modules/lib0/prng.js
var $281a441cdcb2cf36$var$bool, $281a441cdcb2cf36$var$int53, $281a441cdcb2cf36$var$int32, $281a441cdcb2cf36$var$int31, $281a441cdcb2cf36$var$letter, $281a441cdcb2cf36$var$word, $281a441cdcb2cf36$var$oneOf;
var $281a441cdcb2cf36$var$init_prng = $281a441cdcb2cf36$var$__esm({
    "../node_modules/lib0/prng.js" () {
        $281a441cdcb2cf36$var$init_string();
        $281a441cdcb2cf36$var$init_math();
        $281a441cdcb2cf36$var$bool = (gen)=>gen.next() >= 0.5;
        $281a441cdcb2cf36$var$int53 = (gen, min2, max2)=>$281a441cdcb2cf36$var$floor(gen.next() * (max2 + 1 - min2) + min2);
        $281a441cdcb2cf36$var$int32 = (gen, min2, max2)=>$281a441cdcb2cf36$var$floor(gen.next() * (max2 + 1 - min2) + min2);
        $281a441cdcb2cf36$var$int31 = (gen, min2, max2)=>$281a441cdcb2cf36$var$int32(gen, min2, max2);
        $281a441cdcb2cf36$var$letter = (gen)=>$281a441cdcb2cf36$var$fromCharCode($281a441cdcb2cf36$var$int31(gen, 97, 122));
        $281a441cdcb2cf36$var$word = (gen, minLen = 0, maxLen = 20)=>{
            const len = $281a441cdcb2cf36$var$int31(gen, minLen, maxLen);
            let str = "";
            for(let i3 = 0; i3 < len; i3++)str += $281a441cdcb2cf36$var$letter(gen);
            return str;
        };
        $281a441cdcb2cf36$var$oneOf = (gen, array)=>array[$281a441cdcb2cf36$var$int31(gen, 0, array.length - 1)];
    }
});
// ../node_modules/lib0/schema.js
var $281a441cdcb2cf36$var$schemaSymbol, $281a441cdcb2cf36$var$ValidationError, $281a441cdcb2cf36$var$shapeExtends, $281a441cdcb2cf36$var$Schema, $281a441cdcb2cf36$var$$ConstructedBy, $281a441cdcb2cf36$var$$constructedBy, $281a441cdcb2cf36$var$$$constructedBy, $281a441cdcb2cf36$var$$Custom, $281a441cdcb2cf36$var$$custom, $281a441cdcb2cf36$var$$$custom, $281a441cdcb2cf36$var$$Literal, $281a441cdcb2cf36$var$$literal, $281a441cdcb2cf36$var$$$literal, $281a441cdcb2cf36$var$_regexEscape, $281a441cdcb2cf36$var$_schemaStringTemplateToRegex, $281a441cdcb2cf36$var$$StringTemplate, $281a441cdcb2cf36$var$$$stringTemplate, $281a441cdcb2cf36$var$isOptionalSymbol, $281a441cdcb2cf36$var$$Optional, $281a441cdcb2cf36$var$$$optional, $281a441cdcb2cf36$var$$Never, $281a441cdcb2cf36$var$$never, $281a441cdcb2cf36$var$$$never, $281a441cdcb2cf36$var$_$Object, $281a441cdcb2cf36$var$$Object, $281a441cdcb2cf36$var$$object, $281a441cdcb2cf36$var$$$object, $281a441cdcb2cf36$var$$objectAny, $281a441cdcb2cf36$var$$Record, $281a441cdcb2cf36$var$$record, $281a441cdcb2cf36$var$$$record, $281a441cdcb2cf36$var$$Tuple, $281a441cdcb2cf36$var$$tuple, $281a441cdcb2cf36$var$$$tuple, $281a441cdcb2cf36$var$$Array, $281a441cdcb2cf36$var$$array, $281a441cdcb2cf36$var$$$array, $281a441cdcb2cf36$var$$arrayAny, $281a441cdcb2cf36$var$$InstanceOf, $281a441cdcb2cf36$var$$instanceOf, $281a441cdcb2cf36$var$$$instanceOf, $281a441cdcb2cf36$var$$$schema, $281a441cdcb2cf36$var$$Lambda, $281a441cdcb2cf36$var$$$lambda, $281a441cdcb2cf36$var$$function, $281a441cdcb2cf36$var$$Intersection, $281a441cdcb2cf36$var$$$intersect, $281a441cdcb2cf36$var$$Union, $281a441cdcb2cf36$var$$union, $281a441cdcb2cf36$var$$$union, $281a441cdcb2cf36$var$_t, $281a441cdcb2cf36$var$$any, $281a441cdcb2cf36$var$$$any, $281a441cdcb2cf36$var$$bigint, $281a441cdcb2cf36$var$$$bigint, $281a441cdcb2cf36$var$$symbol, $281a441cdcb2cf36$var$$$symbol, $281a441cdcb2cf36$var$$number, $281a441cdcb2cf36$var$$$number, $281a441cdcb2cf36$var$$string, $281a441cdcb2cf36$var$$$string, $281a441cdcb2cf36$var$$boolean, $281a441cdcb2cf36$var$$$boolean, $281a441cdcb2cf36$var$$undefined, $281a441cdcb2cf36$var$$$undefined, $281a441cdcb2cf36$var$$void, $281a441cdcb2cf36$var$$null, $281a441cdcb2cf36$var$$$null, $281a441cdcb2cf36$var$$uint8Array, $281a441cdcb2cf36$var$$$uint8Array, $281a441cdcb2cf36$var$$primitive, $281a441cdcb2cf36$var$$json, $281a441cdcb2cf36$var$$, $281a441cdcb2cf36$var$assert, $281a441cdcb2cf36$var$PatternMatcher, $281a441cdcb2cf36$var$match, $281a441cdcb2cf36$var$_random, $281a441cdcb2cf36$var$random;
var $281a441cdcb2cf36$var$init_schema = $281a441cdcb2cf36$var$__esm({
    "../node_modules/lib0/schema.js" () {
        $281a441cdcb2cf36$var$init_object();
        $281a441cdcb2cf36$var$init_array();
        $281a441cdcb2cf36$var$init_error();
        $281a441cdcb2cf36$var$init_environment();
        $281a441cdcb2cf36$var$init_equality();
        $281a441cdcb2cf36$var$init_function();
        $281a441cdcb2cf36$var$init_string();
        $281a441cdcb2cf36$var$init_prng();
        $281a441cdcb2cf36$var$init_number();
        $281a441cdcb2cf36$var$schemaSymbol = /* @__PURE__ */ Symbol("0schema");
        $281a441cdcb2cf36$var$ValidationError = class {
            constructor(){
                this._rerrs = [];
            }
            /**
       * @param {string?} path
       * @param {string} expected
       * @param {string} has
       * @param {string?} message
       */ extend(path, expected, has, message = null) {
                this._rerrs.push({
                    path: path,
                    expected: expected,
                    has: has,
                    message: message
                });
            }
            toString() {
                const s3 = [];
                for(let i3 = this._rerrs.length - 1; i3 > 0; i3--){
                    const r3 = this._rerrs[i3];
                    s3.push($281a441cdcb2cf36$var$repeat(" ", (this._rerrs.length - i3) * 2) + `${r3.path != null ? `[${r3.path}] ` : ""}${r3.has} doesn't match ${r3.expected}. ${r3.message}`);
                }
                return s3.join("\n");
            }
        };
        $281a441cdcb2cf36$var$shapeExtends = (a3, b3)=>{
            if (a3 === b3) return true;
            if (a3 == null || b3 == null || a3.constructor !== b3.constructor) return false;
            if (a3[$281a441cdcb2cf36$var$EqualityTraitSymbol]) return $281a441cdcb2cf36$var$equals(a3, b3);
            if ($281a441cdcb2cf36$var$isArray(a3)) return $281a441cdcb2cf36$var$every(a3, (aitem)=>$281a441cdcb2cf36$var$some(b3, (bitem)=>$281a441cdcb2cf36$var$shapeExtends(aitem, bitem)));
            else if ($281a441cdcb2cf36$var$isObject2(a3)) return $281a441cdcb2cf36$var$every2(a3, (aitem, akey)=>$281a441cdcb2cf36$var$shapeExtends(aitem, b3[akey]));
            return false;
        };
        $281a441cdcb2cf36$var$Schema = class {
            /**
       * @param {Schema<any>} other
       */ extends(other) {
                let [a3, b3] = [
                    /** @type {any} */ this.shape,
                    /** @type {any} */ other.shape
                ];
                if (/** @type {typeof Schema<any>} */ this.constructor._dilutes) [b3, a3] = [
                    a3,
                    b3
                ];
                return $281a441cdcb2cf36$var$shapeExtends(a3, b3);
            }
            /**
       * Overwrite this when necessary. By default, we only check the `shape` property which every shape
       * should have.
       * @param {Schema<any>} other
       */ equals(other) {
                return this.constructor === other.constructor && $281a441cdcb2cf36$var$equalityDeep(this.shape, other.shape);
            }
            [$281a441cdcb2cf36$var$schemaSymbol]() {
                return true;
            }
            /**
       * @param {object} other
       */ [$281a441cdcb2cf36$var$EqualityTraitSymbol](other) {
                return this.equals(/** @type {any} */ other);
            }
            /**
       * Use `schema.validate(obj)` with a typed parameter that is already of typed to be an instance of
       * Schema. Validate will check the structure of the parameter and return true iff the instance
       * really is an instance of Schema.
       *
       * @param {T} o
       * @return {boolean}
       */ validate(o3) {
                return this.check(o3);
            }
            /* c8 ignore start */ /**
       * Similar to validate, but this method accepts untyped parameters.
       *
       * @param {any} _o
       * @param {ValidationError} [_err]
       * @return {_o is T}
       */ check(_o, _err) {
                $281a441cdcb2cf36$var$methodUnimplemented();
            }
            /* c8 ignore stop */ /**
       * @type {Schema<T?>}
       */ get nullable() {
                return $281a441cdcb2cf36$var$$union(this, $281a441cdcb2cf36$var$$null);
            }
            /**
       * @type {$Optional<Schema<T>>}
       */ get optional() {
                return new $281a441cdcb2cf36$var$$Optional(/** @type {Schema<T>} */ this);
            }
            /**
       * Cast a variable to a specific type. Returns the casted value, or throws an exception otherwise.
       * Use this if you know that the type is of a specific type and you just want to convince the type
       * system.
       *
       * **Do not rely on these error messages!**
       * Performs an assertion check only if not in a production environment.
       *
       * @template OO
       * @param {OO} o
       * @return {Extract<OO, T> extends never ? T : (OO extends Array<never> ? T : Extract<OO,T>)}
       */ cast(o3) {
                $281a441cdcb2cf36$var$assert(o3, this);
                return /** @type {any} */ o3;
            }
            /**
       * EXPECTO PATRONUM!! 🪄
       * This function protects against type errors. Though it may not work in the real world.
       *
       * "After all this time?"
       * "Always." - Snape, talking about type safety
       *
       * Ensures that a variable is a a specific type. Returns the value, or throws an exception if the assertion check failed.
       * Use this if you know that the type is of a specific type and you just want to convince the type
       * system.
       *
       * Can be useful when defining lambdas: `s.lambda(s.$number, s.$void).expect((n) => n + 1)`
       *
       * **Do not rely on these error messages!**
       * Performs an assertion check if not in a production environment.
       *
       * @param {T} o
       * @return {o extends T ? T : never}
       */ expect(o3) {
                $281a441cdcb2cf36$var$assert(o3, this);
                return o3;
            }
        };
        // this.shape must not be defined on Schema. Otherwise typecheck on metatypes (e.g. $$object) won't work as expected anymore
        /**
     * If true, the more things are added to the shape the more objects this schema will accept (e.g.
     * union). By default, the more objects are added, the the fewer objects this schema will accept.
     * @protected
     */ $281a441cdcb2cf36$var$__publicField($281a441cdcb2cf36$var$Schema, "_dilutes", false);
        $281a441cdcb2cf36$var$$ConstructedBy = class extends $281a441cdcb2cf36$var$Schema {
            /**
       * @param {C} c
       * @param {((o:Instance<C>)=>boolean)|null} check
       */ constructor(c3, check){
                super();
                this.shape = c3;
                this._c = check;
            }
            /**
       * @param {any} o
       * @param {ValidationError} [err]
       * @return {o is C extends ((...args:any[]) => infer T) ? T : (C extends (new (...args:any[]) => any) ? InstanceType<C> : never)} o
       */ check(o3, err) {
                const c3 = (o3 == null ? void 0 : o3.constructor) === this.shape && (this._c == null || this._c(o3));
                !c3 && (err == null || err.extend(null, this.shape.name, o3 == null ? void 0 : o3.constructor.name, (o3 == null ? void 0 : o3.constructor) !== this.shape ? "Constructor match failed" : "Check failed"));
                return c3;
            }
        };
        $281a441cdcb2cf36$var$$constructedBy = (c3, check = null)=>new $281a441cdcb2cf36$var$$ConstructedBy(c3, check);
        $281a441cdcb2cf36$var$$$constructedBy = $281a441cdcb2cf36$var$$constructedBy($281a441cdcb2cf36$var$$ConstructedBy);
        $281a441cdcb2cf36$var$$Custom = class extends $281a441cdcb2cf36$var$Schema {
            /**
       * @param {(o:any) => boolean} check
       */ constructor(check){
                super();
                this.shape = check;
            }
            /**
       * @param {any} o
       * @param {ValidationError} err
       * @return {o is any}
       */ check(o3, err) {
                const c3 = this.shape(o3);
                !c3 && (err == null || err.extend(null, "custom prop", o3 == null ? void 0 : o3.constructor.name, "failed to check custom prop"));
                return c3;
            }
        };
        $281a441cdcb2cf36$var$$custom = (check)=>new $281a441cdcb2cf36$var$$Custom(check);
        $281a441cdcb2cf36$var$$$custom = $281a441cdcb2cf36$var$$constructedBy($281a441cdcb2cf36$var$$Custom);
        $281a441cdcb2cf36$var$$Literal = class extends $281a441cdcb2cf36$var$Schema {
            /**
       * @param {Array<T>} literals
       */ constructor(literals){
                super();
                this.shape = literals;
            }
            /**
       *
       * @param {any} o
       * @param {ValidationError} [err]
       * @return {o is T}
       */ check(o3, err) {
                const c3 = this.shape.some((a3)=>a3 === o3);
                !c3 && (err == null || err.extend(null, this.shape.join(" | "), o3.toString()));
                return c3;
            }
        };
        $281a441cdcb2cf36$var$$literal = (...literals)=>new $281a441cdcb2cf36$var$$Literal(literals);
        $281a441cdcb2cf36$var$$$literal = $281a441cdcb2cf36$var$$constructedBy($281a441cdcb2cf36$var$$Literal);
        $281a441cdcb2cf36$var$_regexEscape = /** @type {any} */ RegExp.escape || /** @type {(str:string) => string} */ ((str)=>str.replace(/[().|&,$^[\]]/g, (s3)=>"\\" + s3));
        $281a441cdcb2cf36$var$_schemaStringTemplateToRegex = (s3)=>{
            if ($281a441cdcb2cf36$var$$string.check(s3)) return [
                $281a441cdcb2cf36$var$_regexEscape(s3)
            ];
            if ($281a441cdcb2cf36$var$$$literal.check(s3)) return /** @type {Array<string|number>} */ s3.shape.map((v3)=>v3 + "");
            if ($281a441cdcb2cf36$var$$$number.check(s3)) return [
                "[+-]?\\d+.?\\d*"
            ];
            if ($281a441cdcb2cf36$var$$$string.check(s3)) return [
                ".*"
            ];
            if ($281a441cdcb2cf36$var$$$union.check(s3)) return s3.shape.map($281a441cdcb2cf36$var$_schemaStringTemplateToRegex).flat(1);
            $281a441cdcb2cf36$var$unexpectedCase();
        };
        $281a441cdcb2cf36$var$$StringTemplate = class extends $281a441cdcb2cf36$var$Schema {
            /**
       * @param {T} shape
       */ constructor(shape){
                super();
                this.shape = shape;
                this._r = new RegExp("^" + shape.map($281a441cdcb2cf36$var$_schemaStringTemplateToRegex).map((opts)=>`(${opts.join("|")})`).join("") + "$");
            }
            /**
       * @param {any} o
       * @param {ValidationError} [err]
       * @return {o is CastStringTemplateArgsToTemplate<T>}
       */ check(o3, err) {
                const c3 = this._r.exec(o3) != null;
                !c3 && (err == null || err.extend(null, this._r.toString(), o3.toString(), "String doesn't match string template."));
                return c3;
            }
        };
        $281a441cdcb2cf36$var$$$stringTemplate = $281a441cdcb2cf36$var$$constructedBy($281a441cdcb2cf36$var$$StringTemplate);
        $281a441cdcb2cf36$var$isOptionalSymbol = /* @__PURE__ */ Symbol("optional");
        $281a441cdcb2cf36$var$$Optional = class extends $281a441cdcb2cf36$var$Schema {
            /**
       * @param {S} shape
       */ constructor(shape){
                super();
                this.shape = shape;
            }
            /**
       * @param {any} o
       * @param {ValidationError} [err]
       * @return {o is (Unwrap<S>|undefined)}
       */ check(o3, err) {
                const c3 = o3 === void 0 || this.shape.check(o3);
                !c3 && (err == null || err.extend(null, "undefined (optional)", "()"));
                return c3;
            }
            get [$281a441cdcb2cf36$var$isOptionalSymbol]() {
                return true;
            }
        };
        $281a441cdcb2cf36$var$$$optional = $281a441cdcb2cf36$var$$constructedBy($281a441cdcb2cf36$var$$Optional);
        $281a441cdcb2cf36$var$$Never = class extends $281a441cdcb2cf36$var$Schema {
            /**
       * @param {any} _o
       * @param {ValidationError} [err]
       * @return {_o is never}
       */ check(_o, err) {
                err == null || err.extend(null, "never", typeof _o);
                return false;
            }
        };
        $281a441cdcb2cf36$var$$never = new $281a441cdcb2cf36$var$$Never();
        $281a441cdcb2cf36$var$$$never = $281a441cdcb2cf36$var$$constructedBy($281a441cdcb2cf36$var$$Never);
        $281a441cdcb2cf36$var$_$Object = class _$Object extends $281a441cdcb2cf36$var$Schema {
            /**
       * @param {S} shape
       * @param {boolean} partial
       */ constructor(shape, partial = false){
                super();
                this.shape = shape;
                this._isPartial = partial;
            }
            /**
       * @type {Schema<Partial<$ObjectToType<S>>>}
       */ get partial() {
                return new _$Object(this.shape, true);
            }
            /**
       * @param {any} o
       * @param {ValidationError} err
       * @return {o is $ObjectToType<S>}
       */ check(o3, err) {
                if (o3 == null) {
                    err == null || err.extend(null, "object", "null");
                    return false;
                }
                return $281a441cdcb2cf36$var$every2(this.shape, (vv, vk)=>{
                    const c3 = this._isPartial && !$281a441cdcb2cf36$var$hasProperty(o3, vk) || vv.check(o3[vk], err);
                    !c3 && (err == null || err.extend(vk.toString(), vv.toString(), typeof o3[vk], "Object property does not match"));
                    return c3;
                });
            }
        };
        $281a441cdcb2cf36$var$__publicField($281a441cdcb2cf36$var$_$Object, "_dilutes", true);
        $281a441cdcb2cf36$var$$Object = $281a441cdcb2cf36$var$_$Object;
        $281a441cdcb2cf36$var$$object = (def)=>/** @type {any} */ new $281a441cdcb2cf36$var$$Object(def);
        $281a441cdcb2cf36$var$$$object = $281a441cdcb2cf36$var$$constructedBy($281a441cdcb2cf36$var$$Object);
        $281a441cdcb2cf36$var$$objectAny = $281a441cdcb2cf36$var$$custom((o3)=>o3 != null && (o3.constructor === Object || o3.constructor == null));
        $281a441cdcb2cf36$var$$Record = class extends $281a441cdcb2cf36$var$Schema {
            /**
       * @param {Keys} keys
       * @param {Values} values
       */ constructor(keys2, values){
                super();
                this.shape = {
                    keys: keys2,
                    values: values
                };
            }
            /**
       * @param {any} o
       * @param {ValidationError} err
       * @return {o is { [key in Unwrap<Keys>]: Unwrap<Values> }}
       */ check(o3, err) {
                return o3 != null && $281a441cdcb2cf36$var$every2(o3, (vv, vk)=>{
                    const ck = this.shape.keys.check(vk, err);
                    !ck && (err == null || err.extend(vk + "", "Record", typeof o3, ck ? "Key doesn't match schema" : "Value doesn't match value"));
                    return ck && this.shape.values.check(vv, err);
                });
            }
        };
        $281a441cdcb2cf36$var$$record = (keys2, values)=>new $281a441cdcb2cf36$var$$Record(keys2, values);
        $281a441cdcb2cf36$var$$$record = $281a441cdcb2cf36$var$$constructedBy($281a441cdcb2cf36$var$$Record);
        $281a441cdcb2cf36$var$$Tuple = class extends $281a441cdcb2cf36$var$Schema {
            /**
       * @param {S} shape
       */ constructor(shape){
                super();
                this.shape = shape;
            }
            /**
       * @param {any} o
       * @param {ValidationError} err
       * @return {o is { [K in keyof S]: S[K] extends Schema<infer Type> ? Type : never }}
       */ check(o3, err) {
                return o3 != null && $281a441cdcb2cf36$var$every2(this.shape, (vv, vk)=>{
                    const c3 = /** @type {Schema<any>} */ vv.check(o3[vk], err);
                    !c3 && (err == null || err.extend(vk.toString(), "Tuple", typeof vv));
                    return c3;
                });
            }
        };
        $281a441cdcb2cf36$var$$tuple = (...def)=>new $281a441cdcb2cf36$var$$Tuple(def);
        $281a441cdcb2cf36$var$$$tuple = $281a441cdcb2cf36$var$$constructedBy($281a441cdcb2cf36$var$$Tuple);
        $281a441cdcb2cf36$var$$Array = class extends $281a441cdcb2cf36$var$Schema {
            /**
       * @param {Array<S>} v
       */ constructor(v3){
                super();
                this.shape = v3.length === 1 ? v3[0] : new $281a441cdcb2cf36$var$$Union(v3);
            }
            /**
       * @param {any} o
       * @param {ValidationError} [err]
       * @return {o is Array<S extends Schema<infer T> ? T : never>} o
       */ check(o3, err) {
                const c3 = $281a441cdcb2cf36$var$isArray(o3) && $281a441cdcb2cf36$var$every(o3, (oi)=>this.shape.check(oi));
                !c3 && (err == null || err.extend(null, "Array", ""));
                return c3;
            }
        };
        $281a441cdcb2cf36$var$$array = (...def)=>new $281a441cdcb2cf36$var$$Array(def);
        $281a441cdcb2cf36$var$$$array = $281a441cdcb2cf36$var$$constructedBy($281a441cdcb2cf36$var$$Array);
        $281a441cdcb2cf36$var$$arrayAny = $281a441cdcb2cf36$var$$custom((o3)=>$281a441cdcb2cf36$var$isArray(o3));
        $281a441cdcb2cf36$var$$InstanceOf = class extends $281a441cdcb2cf36$var$Schema {
            /**
       * @param {new (...args:any) => T} constructor
       * @param {((o:T) => boolean)|null} check
       */ constructor(constructor, check){
                super();
                this.shape = constructor;
                this._c = check;
            }
            /**
       * @param {any} o
       * @param {ValidationError} err
       * @return {o is T}
       */ check(o3, err) {
                const c3 = o3 instanceof this.shape && (this._c == null || this._c(o3));
                !c3 && (err == null || err.extend(null, this.shape.name, o3 == null ? void 0 : o3.constructor.name));
                return c3;
            }
        };
        $281a441cdcb2cf36$var$$instanceOf = (c3, check = null)=>new $281a441cdcb2cf36$var$$InstanceOf(c3, check);
        $281a441cdcb2cf36$var$$$instanceOf = $281a441cdcb2cf36$var$$constructedBy($281a441cdcb2cf36$var$$InstanceOf);
        $281a441cdcb2cf36$var$$$schema = $281a441cdcb2cf36$var$$instanceOf($281a441cdcb2cf36$var$Schema);
        $281a441cdcb2cf36$var$$Lambda = class extends $281a441cdcb2cf36$var$Schema {
            /**
       * @param {Args} args
       */ constructor(args2){
                super();
                this.len = args2.length - 1;
                this.args = $281a441cdcb2cf36$var$$tuple(...args2.slice(-1));
                this.res = args2[this.len];
            }
            /**
       * @param {any} f
       * @param {ValidationError} err
       * @return {f is _LArgsToLambdaDef<Args>}
       */ check(f3, err) {
                const c3 = f3.constructor === Function && f3.length <= this.len;
                !c3 && (err == null || err.extend(null, "function", typeof f3));
                return c3;
            }
        };
        $281a441cdcb2cf36$var$$$lambda = $281a441cdcb2cf36$var$$constructedBy($281a441cdcb2cf36$var$$Lambda);
        $281a441cdcb2cf36$var$$function = $281a441cdcb2cf36$var$$custom((o3)=>typeof o3 === "function");
        $281a441cdcb2cf36$var$$Intersection = class extends $281a441cdcb2cf36$var$Schema {
            /**
       * @param {T} v
       */ constructor(v3){
                super();
                this.shape = v3;
            }
            /**
       * @param {any} o
       * @param {ValidationError} [err]
       * @return {o is Intersect<UnwrapArray<T>>}
       */ check(o3, err) {
                const c3 = $281a441cdcb2cf36$var$every(this.shape, (check)=>check.check(o3, err));
                !c3 && (err == null || err.extend(null, "Intersectinon", typeof o3));
                return c3;
            }
        };
        $281a441cdcb2cf36$var$$$intersect = $281a441cdcb2cf36$var$$constructedBy($281a441cdcb2cf36$var$$Intersection, (o3)=>o3.shape.length > 0);
        $281a441cdcb2cf36$var$$Union = class extends $281a441cdcb2cf36$var$Schema {
            /**
       * @param {Array<Schema<S>>} v
       */ constructor(v3){
                super();
                this.shape = v3;
            }
            /**
       * @param {any} o
       * @param {ValidationError} [err]
       * @return {o is S}
       */ check(o3, err) {
                const c3 = $281a441cdcb2cf36$var$some(this.shape, (vv)=>vv.check(o3, err));
                err == null || err.extend(null, "Union", typeof o3);
                return c3;
            }
        };
        $281a441cdcb2cf36$var$__publicField($281a441cdcb2cf36$var$$Union, "_dilutes", true);
        $281a441cdcb2cf36$var$$union = (...schemas)=>schemas.findIndex(($s)=>$281a441cdcb2cf36$var$$$union.check($s)) >= 0 ? $281a441cdcb2cf36$var$$union(...schemas.map(($s)=>$281a441cdcb2cf36$var$$($s)).map(($s)=>$281a441cdcb2cf36$var$$$union.check($s) ? $s.shape : [
                    $s
                ]).flat(1)) : schemas.length === 1 ? schemas[0] : new $281a441cdcb2cf36$var$$Union(schemas);
        $281a441cdcb2cf36$var$$$union = /** @type {Schema<$Union<any>>} */ $281a441cdcb2cf36$var$$constructedBy($281a441cdcb2cf36$var$$Union);
        $281a441cdcb2cf36$var$_t = ()=>true;
        $281a441cdcb2cf36$var$$any = $281a441cdcb2cf36$var$$custom($281a441cdcb2cf36$var$_t);
        $281a441cdcb2cf36$var$$$any = /** @type {Schema<Schema<any>>} */ $281a441cdcb2cf36$var$$constructedBy($281a441cdcb2cf36$var$$Custom, (o3)=>o3.shape === $281a441cdcb2cf36$var$_t);
        $281a441cdcb2cf36$var$$bigint = $281a441cdcb2cf36$var$$custom((o3)=>typeof o3 === "bigint");
        $281a441cdcb2cf36$var$$$bigint = /** @type {Schema<Schema<BigInt>>} */ $281a441cdcb2cf36$var$$custom((o3)=>o3 === $281a441cdcb2cf36$var$$bigint);
        $281a441cdcb2cf36$var$$symbol = $281a441cdcb2cf36$var$$custom((o3)=>typeof o3 === "symbol");
        $281a441cdcb2cf36$var$$$symbol = /** @type {Schema<Schema<Symbol>>} */ $281a441cdcb2cf36$var$$custom((o3)=>o3 === $281a441cdcb2cf36$var$$symbol);
        $281a441cdcb2cf36$var$$number = $281a441cdcb2cf36$var$$custom((o3)=>typeof o3 === "number");
        $281a441cdcb2cf36$var$$$number = /** @type {Schema<Schema<number>>} */ $281a441cdcb2cf36$var$$custom((o3)=>o3 === $281a441cdcb2cf36$var$$number);
        $281a441cdcb2cf36$var$$string = $281a441cdcb2cf36$var$$custom((o3)=>typeof o3 === "string");
        $281a441cdcb2cf36$var$$$string = /** @type {Schema<Schema<string>>} */ $281a441cdcb2cf36$var$$custom((o3)=>o3 === $281a441cdcb2cf36$var$$string);
        $281a441cdcb2cf36$var$$boolean = $281a441cdcb2cf36$var$$custom((o3)=>typeof o3 === "boolean");
        $281a441cdcb2cf36$var$$$boolean = /** @type {Schema<Schema<Boolean>>} */ $281a441cdcb2cf36$var$$custom((o3)=>o3 === $281a441cdcb2cf36$var$$boolean);
        $281a441cdcb2cf36$var$$undefined = $281a441cdcb2cf36$var$$literal(void 0);
        $281a441cdcb2cf36$var$$$undefined = /** @type {Schema<Schema<undefined>>} */ $281a441cdcb2cf36$var$$constructedBy($281a441cdcb2cf36$var$$Literal, (o3)=>o3.shape.length === 1 && o3.shape[0] === void 0);
        $281a441cdcb2cf36$var$$void = $281a441cdcb2cf36$var$$literal(void 0);
        $281a441cdcb2cf36$var$$null = $281a441cdcb2cf36$var$$literal(null);
        $281a441cdcb2cf36$var$$$null = /** @type {Schema<Schema<null>>} */ $281a441cdcb2cf36$var$$constructedBy($281a441cdcb2cf36$var$$Literal, (o3)=>o3.shape.length === 1 && o3.shape[0] === null);
        $281a441cdcb2cf36$var$$uint8Array = $281a441cdcb2cf36$var$$constructedBy(Uint8Array);
        $281a441cdcb2cf36$var$$$uint8Array = /** @type {Schema<Schema<Uint8Array>>} */ $281a441cdcb2cf36$var$$constructedBy($281a441cdcb2cf36$var$$ConstructedBy, (o3)=>o3.shape === Uint8Array);
        $281a441cdcb2cf36$var$$primitive = $281a441cdcb2cf36$var$$union($281a441cdcb2cf36$var$$number, $281a441cdcb2cf36$var$$string, $281a441cdcb2cf36$var$$null, $281a441cdcb2cf36$var$$undefined, $281a441cdcb2cf36$var$$bigint, $281a441cdcb2cf36$var$$boolean, $281a441cdcb2cf36$var$$symbol);
        $281a441cdcb2cf36$var$$json = (()=>{
            const $jsonArr = /** @type {$Array<$any>} */ $281a441cdcb2cf36$var$$array($281a441cdcb2cf36$var$$any);
            const $jsonRecord = /** @type {$Record<$string,$any>} */ $281a441cdcb2cf36$var$$record($281a441cdcb2cf36$var$$string, $281a441cdcb2cf36$var$$any);
            const $json2 = $281a441cdcb2cf36$var$$union($281a441cdcb2cf36$var$$number, $281a441cdcb2cf36$var$$string, $281a441cdcb2cf36$var$$null, $281a441cdcb2cf36$var$$boolean, $jsonArr, $jsonRecord);
            $jsonArr.shape = $json2;
            $jsonRecord.shape.values = $json2;
            return $json2;
        })();
        $281a441cdcb2cf36$var$$ = (o3)=>{
            if ($281a441cdcb2cf36$var$$$schema.check(o3)) return /** @type {any} */ o3;
            else if ($281a441cdcb2cf36$var$$objectAny.check(o3)) {
                const o22 = {};
                for(const k3 in o3)o22[k3] = $281a441cdcb2cf36$var$$(o3[k3]);
                return /** @type {any} */ $281a441cdcb2cf36$var$$object(o22);
            } else if ($281a441cdcb2cf36$var$$arrayAny.check(o3)) return /** @type {any} */ $281a441cdcb2cf36$var$$union(...o3.map($281a441cdcb2cf36$var$$));
            else if ($281a441cdcb2cf36$var$$primitive.check(o3)) return /** @type {any} */ $281a441cdcb2cf36$var$$literal(o3);
            else if ($281a441cdcb2cf36$var$$function.check(o3)) return /** @type {any} */ $281a441cdcb2cf36$var$$constructedBy(/** @type {any} */ o3);
            $281a441cdcb2cf36$var$unexpectedCase();
        };
        $281a441cdcb2cf36$var$assert = $281a441cdcb2cf36$var$production ? ()=>{} : (o3, schema)=>{
            const err = new $281a441cdcb2cf36$var$ValidationError();
            if (!schema.check(o3, err)) throw $281a441cdcb2cf36$var$create3(`Expected value to be of type ${schema.constructor.name}.
${err.toString()}`);
        };
        $281a441cdcb2cf36$var$PatternMatcher = class {
            /**
       * @param {Schema<State>} [$state]
       */ constructor($state){
                this.patterns = [];
                this.$state = $state;
            }
            /**
       * @template P
       * @template R
       * @param {P} pattern
       * @param {(o:NoInfer<Unwrap<ReadSchema<P>>>,s:State)=>R} handler
       * @return {PatternMatcher<State,Patterns|Pattern<Unwrap<ReadSchema<P>>,R>>}
       */ if(pattern, handler) {
                this.patterns.push({
                    if: $281a441cdcb2cf36$var$$(pattern),
                    h: handler
                });
                return this;
            }
            /**
       * @template R
       * @param {(o:any,s:State)=>R} h
       */ else(h3) {
                return this.if($281a441cdcb2cf36$var$$any, h3);
            }
            /**
       * @return {State extends undefined
       *   ? <In extends Unwrap<Patterns['if']>>(o:In,state?:undefined)=>PatternMatchResult<Patterns,In>
       *   : <In extends Unwrap<Patterns['if']>>(o:In,state:State)=>PatternMatchResult<Patterns,In>}
       */ done() {
                return /** @type {any} */ (o3, s3)=>{
                    for(let i3 = 0; i3 < this.patterns.length; i3++){
                        const p3 = this.patterns[i3];
                        if (p3.if.check(o3)) return p3.h(o3, s3);
                    }
                    throw $281a441cdcb2cf36$var$create3("Unhandled pattern");
                };
            }
        };
        $281a441cdcb2cf36$var$match = (state)=>new $281a441cdcb2cf36$var$PatternMatcher(/** @type {any} */ state);
        $281a441cdcb2cf36$var$_random = /** @type {any} */ $281a441cdcb2cf36$var$match(/** @type {Schema<prng.PRNG>} */ $281a441cdcb2cf36$var$$any).if($281a441cdcb2cf36$var$$$number, (_o, gen)=>$281a441cdcb2cf36$var$int53(gen, $281a441cdcb2cf36$var$MIN_SAFE_INTEGER, $281a441cdcb2cf36$var$MAX_SAFE_INTEGER)).if($281a441cdcb2cf36$var$$$string, (_o, gen)=>$281a441cdcb2cf36$var$word(gen)).if($281a441cdcb2cf36$var$$$boolean, (_o, gen)=>$281a441cdcb2cf36$var$bool(gen)).if($281a441cdcb2cf36$var$$$bigint, (_o, gen)=>BigInt($281a441cdcb2cf36$var$int53(gen, $281a441cdcb2cf36$var$MIN_SAFE_INTEGER, $281a441cdcb2cf36$var$MAX_SAFE_INTEGER))).if($281a441cdcb2cf36$var$$$union, (o3, gen)=>$281a441cdcb2cf36$var$random(gen, $281a441cdcb2cf36$var$oneOf(gen, o3.shape))).if($281a441cdcb2cf36$var$$$object, (o3, gen)=>{
            const res = {};
            for(const k3 in o3.shape){
                let prop = o3.shape[k3];
                if ($281a441cdcb2cf36$var$$$optional.check(prop)) {
                    if ($281a441cdcb2cf36$var$bool(gen)) continue;
                    prop = prop.shape;
                }
                res[k3] = $281a441cdcb2cf36$var$_random(prop, gen);
            }
            return res;
        }).if($281a441cdcb2cf36$var$$$array, (o3, gen)=>{
            const arr = [];
            const n3 = $281a441cdcb2cf36$var$int32(gen, 0, 42);
            for(let i3 = 0; i3 < n3; i3++)arr.push($281a441cdcb2cf36$var$random(gen, o3.shape));
            return arr;
        }).if($281a441cdcb2cf36$var$$$literal, (o3, gen)=>{
            return $281a441cdcb2cf36$var$oneOf(gen, o3.shape);
        }).if($281a441cdcb2cf36$var$$$null, (o3, gen)=>{
            return null;
        }).if($281a441cdcb2cf36$var$$$lambda, (o3, gen)=>{
            const res = $281a441cdcb2cf36$var$random(gen, o3.res);
            return ()=>res;
        }).if($281a441cdcb2cf36$var$$$any, (o3, gen)=>$281a441cdcb2cf36$var$random(gen, $281a441cdcb2cf36$var$oneOf(gen, [
                $281a441cdcb2cf36$var$$number,
                $281a441cdcb2cf36$var$$string,
                $281a441cdcb2cf36$var$$null,
                $281a441cdcb2cf36$var$$undefined,
                $281a441cdcb2cf36$var$$bigint,
                $281a441cdcb2cf36$var$$boolean,
                $281a441cdcb2cf36$var$$array($281a441cdcb2cf36$var$$number),
                $281a441cdcb2cf36$var$$record($281a441cdcb2cf36$var$$union("a", "b", "c"), $281a441cdcb2cf36$var$$number)
            ]))).if($281a441cdcb2cf36$var$$$record, (o3, gen)=>{
            const res = {};
            const keysN = $281a441cdcb2cf36$var$int53(gen, 0, 3);
            for(let i3 = 0; i3 < keysN; i3++){
                const key = $281a441cdcb2cf36$var$random(gen, o3.shape.keys);
                const val = $281a441cdcb2cf36$var$random(gen, o3.shape.values);
                res[key] = val;
            }
            return res;
        }).done();
        $281a441cdcb2cf36$var$random = (gen, schema)=>/** @type {any} */ $281a441cdcb2cf36$var$_random($281a441cdcb2cf36$var$$(schema), gen);
    }
});
// ../node_modules/lib0/dom.js
var $281a441cdcb2cf36$var$doc, $281a441cdcb2cf36$var$$fragment, $281a441cdcb2cf36$var$domParser, $281a441cdcb2cf36$var$$element, $281a441cdcb2cf36$var$$text, $281a441cdcb2cf36$var$mapToStyleString, $281a441cdcb2cf36$var$ELEMENT_NODE, $281a441cdcb2cf36$var$TEXT_NODE, $281a441cdcb2cf36$var$CDATA_SECTION_NODE, $281a441cdcb2cf36$var$COMMENT_NODE, $281a441cdcb2cf36$var$DOCUMENT_NODE, $281a441cdcb2cf36$var$DOCUMENT_TYPE_NODE, $281a441cdcb2cf36$var$DOCUMENT_FRAGMENT_NODE, $281a441cdcb2cf36$var$$node;
var $281a441cdcb2cf36$var$init_dom = $281a441cdcb2cf36$var$__esm({
    "../node_modules/lib0/dom.js" () {
        $281a441cdcb2cf36$var$init_map();
        $281a441cdcb2cf36$var$init_schema();
        $281a441cdcb2cf36$var$doc = /** @type {Document} */ typeof document !== "undefined" ? document : {};
        $281a441cdcb2cf36$var$$fragment = $281a441cdcb2cf36$var$$custom((el)=>el.nodeType === $281a441cdcb2cf36$var$DOCUMENT_FRAGMENT_NODE);
        $281a441cdcb2cf36$var$domParser = /** @type {DOMParser} */ typeof DOMParser !== "undefined" ? new DOMParser() : null;
        $281a441cdcb2cf36$var$$element = $281a441cdcb2cf36$var$$custom((el)=>el.nodeType === $281a441cdcb2cf36$var$ELEMENT_NODE);
        $281a441cdcb2cf36$var$$text = $281a441cdcb2cf36$var$$custom((el)=>el.nodeType === $281a441cdcb2cf36$var$TEXT_NODE);
        $281a441cdcb2cf36$var$mapToStyleString = (m3)=>$281a441cdcb2cf36$var$map(m3, (value2, key)=>`${key}:${value2};`).join("");
        $281a441cdcb2cf36$var$ELEMENT_NODE = $281a441cdcb2cf36$var$doc.ELEMENT_NODE;
        $281a441cdcb2cf36$var$TEXT_NODE = $281a441cdcb2cf36$var$doc.TEXT_NODE;
        $281a441cdcb2cf36$var$CDATA_SECTION_NODE = $281a441cdcb2cf36$var$doc.CDATA_SECTION_NODE;
        $281a441cdcb2cf36$var$COMMENT_NODE = $281a441cdcb2cf36$var$doc.COMMENT_NODE;
        $281a441cdcb2cf36$var$DOCUMENT_NODE = $281a441cdcb2cf36$var$doc.DOCUMENT_NODE;
        $281a441cdcb2cf36$var$DOCUMENT_TYPE_NODE = $281a441cdcb2cf36$var$doc.DOCUMENT_TYPE_NODE;
        $281a441cdcb2cf36$var$DOCUMENT_FRAGMENT_NODE = $281a441cdcb2cf36$var$doc.DOCUMENT_FRAGMENT_NODE;
        $281a441cdcb2cf36$var$$node = $281a441cdcb2cf36$var$$custom((el)=>el.nodeType === $281a441cdcb2cf36$var$DOCUMENT_NODE);
    }
});
// ../node_modules/lib0/symbol.js
var $281a441cdcb2cf36$var$create6;
var $281a441cdcb2cf36$var$init_symbol = $281a441cdcb2cf36$var$__esm({
    "../node_modules/lib0/symbol.js" () {
        $281a441cdcb2cf36$var$create6 = Symbol;
    }
});
// ../node_modules/lib0/logging.common.js
var $281a441cdcb2cf36$var$BOLD, $281a441cdcb2cf36$var$UNBOLD, $281a441cdcb2cf36$var$BLUE, $281a441cdcb2cf36$var$GREY, $281a441cdcb2cf36$var$GREEN, $281a441cdcb2cf36$var$RED, $281a441cdcb2cf36$var$PURPLE, $281a441cdcb2cf36$var$ORANGE, $281a441cdcb2cf36$var$UNCOLOR, $281a441cdcb2cf36$var$computeNoColorLoggingArgs, $281a441cdcb2cf36$var$lastLoggingTime;
var $281a441cdcb2cf36$var$init_logging_common = $281a441cdcb2cf36$var$__esm({
    "../node_modules/lib0/logging.common.js" () {
        $281a441cdcb2cf36$var$init_symbol();
        $281a441cdcb2cf36$var$init_time();
        $281a441cdcb2cf36$var$BOLD = $281a441cdcb2cf36$var$create6();
        $281a441cdcb2cf36$var$UNBOLD = $281a441cdcb2cf36$var$create6();
        $281a441cdcb2cf36$var$BLUE = $281a441cdcb2cf36$var$create6();
        $281a441cdcb2cf36$var$GREY = $281a441cdcb2cf36$var$create6();
        $281a441cdcb2cf36$var$GREEN = $281a441cdcb2cf36$var$create6();
        $281a441cdcb2cf36$var$RED = $281a441cdcb2cf36$var$create6();
        $281a441cdcb2cf36$var$PURPLE = $281a441cdcb2cf36$var$create6();
        $281a441cdcb2cf36$var$ORANGE = $281a441cdcb2cf36$var$create6();
        $281a441cdcb2cf36$var$UNCOLOR = $281a441cdcb2cf36$var$create6();
        $281a441cdcb2cf36$var$computeNoColorLoggingArgs = (args2)=>{
            var _a2;
            if (args2.length === 1 && ((_a2 = args2[0]) == null ? void 0 : _a2.constructor) === Function) args2 = /** @type {Array<string|Symbol|Object|number>} */ /** @type {[function]} */ args2[0]();
            const strBuilder = [];
            const logArgs = [];
            let i3 = 0;
            for(; i3 < args2.length; i3++){
                const arg = args2[i3];
                if (arg === void 0) break;
                else if (arg.constructor === String || arg.constructor === Number) strBuilder.push(arg);
                else if (arg.constructor === Object) break;
            }
            if (i3 > 0) logArgs.push(strBuilder.join(""));
            for(; i3 < args2.length; i3++){
                const arg = args2[i3];
                if (!(arg instanceof Symbol)) logArgs.push(arg);
            }
            return logArgs;
        };
        $281a441cdcb2cf36$var$lastLoggingTime = $281a441cdcb2cf36$var$getUnixTime();
    }
});
// ../node_modules/lib0/logging.js
var $281a441cdcb2cf36$var$_browserStyleMap, $281a441cdcb2cf36$var$computeBrowserLoggingArgs, $281a441cdcb2cf36$var$computeLoggingArgs, $281a441cdcb2cf36$var$print, $281a441cdcb2cf36$var$warn, $281a441cdcb2cf36$var$vconsoles;
var $281a441cdcb2cf36$var$init_logging = $281a441cdcb2cf36$var$__esm({
    "../node_modules/lib0/logging.js" () {
        $281a441cdcb2cf36$var$init_environment();
        $281a441cdcb2cf36$var$init_set();
        $281a441cdcb2cf36$var$init_pair();
        $281a441cdcb2cf36$var$init_dom();
        $281a441cdcb2cf36$var$init_map();
        $281a441cdcb2cf36$var$init_logging_common();
        $281a441cdcb2cf36$var$init_logging_common();
        $281a441cdcb2cf36$var$_browserStyleMap = {
            [$281a441cdcb2cf36$var$BOLD]: $281a441cdcb2cf36$var$create5("font-weight", "bold"),
            [$281a441cdcb2cf36$var$UNBOLD]: $281a441cdcb2cf36$var$create5("font-weight", "normal"),
            [$281a441cdcb2cf36$var$BLUE]: $281a441cdcb2cf36$var$create5("color", "blue"),
            [$281a441cdcb2cf36$var$GREEN]: $281a441cdcb2cf36$var$create5("color", "green"),
            [$281a441cdcb2cf36$var$GREY]: $281a441cdcb2cf36$var$create5("color", "grey"),
            [$281a441cdcb2cf36$var$RED]: $281a441cdcb2cf36$var$create5("color", "red"),
            [$281a441cdcb2cf36$var$PURPLE]: $281a441cdcb2cf36$var$create5("color", "purple"),
            [$281a441cdcb2cf36$var$ORANGE]: $281a441cdcb2cf36$var$create5("color", "orange"),
            // not well supported in chrome when debugging node with inspector - TODO: deprecate
            [$281a441cdcb2cf36$var$UNCOLOR]: $281a441cdcb2cf36$var$create5("color", "black")
        };
        $281a441cdcb2cf36$var$computeBrowserLoggingArgs = (args2)=>{
            var _a2;
            if (args2.length === 1 && ((_a2 = args2[0]) == null ? void 0 : _a2.constructor) === Function) args2 = /** @type {Array<string|Symbol|Object|number>} */ /** @type {[function]} */ args2[0]();
            const strBuilder = [];
            const styles = [];
            const currentStyle = $281a441cdcb2cf36$var$create();
            let logArgs = [];
            let i3 = 0;
            for(; i3 < args2.length; i3++){
                const arg = args2[i3];
                const style = $281a441cdcb2cf36$var$_browserStyleMap[arg];
                if (style !== void 0) currentStyle.set(style.left, style.right);
                else {
                    if (arg === void 0) break;
                    if (arg.constructor === String || arg.constructor === Number) {
                        const style2 = $281a441cdcb2cf36$var$mapToStyleString(currentStyle);
                        if (i3 > 0 || style2.length > 0) {
                            strBuilder.push("%c" + arg);
                            styles.push(style2);
                        } else strBuilder.push(arg);
                    } else break;
                }
            }
            if (i3 > 0) {
                logArgs = styles;
                logArgs.unshift(strBuilder.join(""));
            }
            for(; i3 < args2.length; i3++){
                const arg = args2[i3];
                if (!(arg instanceof Symbol)) logArgs.push(arg);
            }
            return logArgs;
        };
        $281a441cdcb2cf36$var$computeLoggingArgs = $281a441cdcb2cf36$var$supportsColor ? $281a441cdcb2cf36$var$computeBrowserLoggingArgs : $281a441cdcb2cf36$var$computeNoColorLoggingArgs;
        $281a441cdcb2cf36$var$print = (...args2)=>{
            console.log(...$281a441cdcb2cf36$var$computeLoggingArgs(args2));
            $281a441cdcb2cf36$var$vconsoles.forEach((vc)=>vc.print(args2));
        };
        $281a441cdcb2cf36$var$warn = (...args2)=>{
            console.warn(...$281a441cdcb2cf36$var$computeLoggingArgs(args2));
            args2.unshift($281a441cdcb2cf36$var$ORANGE);
            $281a441cdcb2cf36$var$vconsoles.forEach((vc)=>vc.print(args2));
        };
        $281a441cdcb2cf36$var$vconsoles = $281a441cdcb2cf36$var$create2();
    }
});
// ../node_modules/lib0/iterator.js
var $281a441cdcb2cf36$var$createIterator, $281a441cdcb2cf36$var$iteratorFilter, $281a441cdcb2cf36$var$iteratorMap;
var $281a441cdcb2cf36$var$init_iterator = $281a441cdcb2cf36$var$__esm({
    "../node_modules/lib0/iterator.js" () {
        $281a441cdcb2cf36$var$createIterator = (next)=>({
                /**
       * @return {IterableIterator<T>}
       */ [Symbol.iterator] () {
                    return this;
                },
                next: // @ts-ignore
                next
            });
        $281a441cdcb2cf36$var$iteratorFilter = (iterator, filter)=>$281a441cdcb2cf36$var$createIterator(()=>{
                let res;
                do res = iterator.next();
                while (!res.done && !filter(res.value));
                return res;
            });
        $281a441cdcb2cf36$var$iteratorMap = (iterator, fmap)=>$281a441cdcb2cf36$var$createIterator(()=>{
                const { done: done, value: value2 } = iterator.next();
                return {
                    done: done,
                    value: done ? void 0 : fmap(value2)
                };
            });
    }
});
// ../node_modules/yjs/dist/yjs.mjs
function* $281a441cdcb2cf36$var$lazyStructReaderGenerator(decoder) {
    const numOfStateUpdates = $281a441cdcb2cf36$var$readVarUint(decoder.restDecoder);
    for(let i3 = 0; i3 < numOfStateUpdates; i3++){
        const numberOfStructs = $281a441cdcb2cf36$var$readVarUint(decoder.restDecoder);
        const client = decoder.readClient();
        let clock = $281a441cdcb2cf36$var$readVarUint(decoder.restDecoder);
        for(let i4 = 0; i4 < numberOfStructs; i4++){
            const info = decoder.readInfo();
            if (info === 10) {
                const len = $281a441cdcb2cf36$var$readVarUint(decoder.restDecoder);
                yield new $281a441cdcb2cf36$var$Skip($281a441cdcb2cf36$var$createID(client, clock), len);
                clock += len;
            } else if (($281a441cdcb2cf36$var$BITS5 & info) !== 0) {
                const cantCopyParentInfo = (info & ($281a441cdcb2cf36$var$BIT7 | $281a441cdcb2cf36$var$BIT8)) === 0;
                const struct = new $281a441cdcb2cf36$var$Item($281a441cdcb2cf36$var$createID(client, clock), null, // left
                (info & $281a441cdcb2cf36$var$BIT8) === $281a441cdcb2cf36$var$BIT8 ? decoder.readLeftID() : null, // origin
                null, // right
                (info & $281a441cdcb2cf36$var$BIT7) === $281a441cdcb2cf36$var$BIT7 ? decoder.readRightID() : null, // right origin
                // @ts-ignore Force writing a string here.
                cantCopyParentInfo ? decoder.readParentInfo() ? decoder.readString() : decoder.readLeftID() : null, // parent
                cantCopyParentInfo && (info & $281a441cdcb2cf36$var$BIT6) === $281a441cdcb2cf36$var$BIT6 ? decoder.readString() : null, // parentSub
                $281a441cdcb2cf36$var$readItemContent(decoder, info));
                yield struct;
                clock += struct.length;
            } else {
                const len = decoder.readLen();
                yield new $281a441cdcb2cf36$var$GC($281a441cdcb2cf36$var$createID(client, clock), len);
                clock += len;
            }
        }
    }
}
var $281a441cdcb2cf36$var$DeleteItem, $281a441cdcb2cf36$var$DeleteSet, $281a441cdcb2cf36$var$iterateDeletedStructs, $281a441cdcb2cf36$var$findIndexDS, $281a441cdcb2cf36$var$isDeleted, $281a441cdcb2cf36$var$sortAndMergeDeleteSet, $281a441cdcb2cf36$var$mergeDeleteSets, $281a441cdcb2cf36$var$addToDeleteSet, $281a441cdcb2cf36$var$createDeleteSet, $281a441cdcb2cf36$var$createDeleteSetFromStructStore, $281a441cdcb2cf36$var$writeDeleteSet, $281a441cdcb2cf36$var$readDeleteSet, $281a441cdcb2cf36$var$readAndApplyDeleteSet, $281a441cdcb2cf36$var$generateNewClientId, $281a441cdcb2cf36$var$Doc, $281a441cdcb2cf36$var$DSDecoderV1, $281a441cdcb2cf36$var$UpdateDecoderV1, $281a441cdcb2cf36$var$DSDecoderV2, $281a441cdcb2cf36$var$UpdateDecoderV2, $281a441cdcb2cf36$var$DSEncoderV1, $281a441cdcb2cf36$var$UpdateEncoderV1, $281a441cdcb2cf36$var$DSEncoderV2, $281a441cdcb2cf36$var$UpdateEncoderV2, $281a441cdcb2cf36$var$writeStructs, $281a441cdcb2cf36$var$writeClientsStructs, $281a441cdcb2cf36$var$readClientsStructRefs, $281a441cdcb2cf36$var$integrateStructs, $281a441cdcb2cf36$var$writeStructsFromTransaction, $281a441cdcb2cf36$var$readUpdateV2, $281a441cdcb2cf36$var$applyUpdateV2, $281a441cdcb2cf36$var$applyUpdate, $281a441cdcb2cf36$var$writeStateAsUpdate, $281a441cdcb2cf36$var$encodeStateAsUpdateV2, $281a441cdcb2cf36$var$encodeStateAsUpdate, $281a441cdcb2cf36$var$readStateVector, $281a441cdcb2cf36$var$decodeStateVector, $281a441cdcb2cf36$var$EventHandler, $281a441cdcb2cf36$var$createEventHandler, $281a441cdcb2cf36$var$addEventHandlerListener, $281a441cdcb2cf36$var$removeEventHandlerListener, $281a441cdcb2cf36$var$callEventHandlerListeners, $281a441cdcb2cf36$var$ID, $281a441cdcb2cf36$var$compareIDs, $281a441cdcb2cf36$var$createID, $281a441cdcb2cf36$var$findRootTypeKey, $281a441cdcb2cf36$var$Snapshot, $281a441cdcb2cf36$var$createSnapshot, $281a441cdcb2cf36$var$emptySnapshot, $281a441cdcb2cf36$var$isVisible, $281a441cdcb2cf36$var$splitSnapshotAffectedStructs, $281a441cdcb2cf36$var$StructStore, $281a441cdcb2cf36$var$getStateVector, $281a441cdcb2cf36$var$getState, $281a441cdcb2cf36$var$addStruct, $281a441cdcb2cf36$var$findIndexSS, $281a441cdcb2cf36$var$find, $281a441cdcb2cf36$var$getItem, $281a441cdcb2cf36$var$findIndexCleanStart, $281a441cdcb2cf36$var$getItemCleanStart, $281a441cdcb2cf36$var$getItemCleanEnd, $281a441cdcb2cf36$var$replaceStruct, $281a441cdcb2cf36$var$iterateStructs, $281a441cdcb2cf36$var$Transaction, $281a441cdcb2cf36$var$writeUpdateMessageFromTransaction, $281a441cdcb2cf36$var$addChangedTypeToTransaction, $281a441cdcb2cf36$var$tryToMergeWithLefts, $281a441cdcb2cf36$var$tryGcDeleteSet, $281a441cdcb2cf36$var$tryMergeDeleteSet, $281a441cdcb2cf36$var$cleanupTransactions, $281a441cdcb2cf36$var$transact, $281a441cdcb2cf36$var$LazyStructReader, $281a441cdcb2cf36$var$LazyStructWriter, $281a441cdcb2cf36$var$mergeUpdates, $281a441cdcb2cf36$var$sliceStruct, $281a441cdcb2cf36$var$mergeUpdatesV2, $281a441cdcb2cf36$var$diffUpdateV2, $281a441cdcb2cf36$var$flushLazyStructWriter, $281a441cdcb2cf36$var$writeStructToLazyStructWriter, $281a441cdcb2cf36$var$finishLazyStructWriting, $281a441cdcb2cf36$var$convertUpdateFormat, $281a441cdcb2cf36$var$convertUpdateFormatV2ToV1, $281a441cdcb2cf36$var$errorComputeChanges, $281a441cdcb2cf36$var$YEvent, $281a441cdcb2cf36$var$getPathTo, $281a441cdcb2cf36$var$warnPrematureAccess, $281a441cdcb2cf36$var$maxSearchMarker, $281a441cdcb2cf36$var$globalSearchMarkerTimestamp, $281a441cdcb2cf36$var$ArraySearchMarker, $281a441cdcb2cf36$var$refreshMarkerTimestamp, $281a441cdcb2cf36$var$overwriteMarker, $281a441cdcb2cf36$var$markPosition, $281a441cdcb2cf36$var$findMarker, $281a441cdcb2cf36$var$updateMarkerChanges, $281a441cdcb2cf36$var$callTypeObservers, $281a441cdcb2cf36$var$AbstractType, $281a441cdcb2cf36$var$typeListSlice, $281a441cdcb2cf36$var$typeListToArray, $281a441cdcb2cf36$var$typeListForEach, $281a441cdcb2cf36$var$typeListMap, $281a441cdcb2cf36$var$typeListCreateIterator, $281a441cdcb2cf36$var$typeListGet, $281a441cdcb2cf36$var$typeListInsertGenericsAfter, $281a441cdcb2cf36$var$lengthExceeded, $281a441cdcb2cf36$var$typeListInsertGenerics, $281a441cdcb2cf36$var$typeListPushGenerics, $281a441cdcb2cf36$var$typeListDelete, $281a441cdcb2cf36$var$typeMapDelete, $281a441cdcb2cf36$var$typeMapSet, $281a441cdcb2cf36$var$typeMapGet, $281a441cdcb2cf36$var$typeMapGetAll, $281a441cdcb2cf36$var$typeMapHas, $281a441cdcb2cf36$var$typeMapGetAllSnapshot, $281a441cdcb2cf36$var$createMapIterator, $281a441cdcb2cf36$var$YArrayEvent, $281a441cdcb2cf36$var$YArray, $281a441cdcb2cf36$var$readYArray, $281a441cdcb2cf36$var$YMapEvent, $281a441cdcb2cf36$var$YMap, $281a441cdcb2cf36$var$readYMap, $281a441cdcb2cf36$var$equalAttrs, $281a441cdcb2cf36$var$ItemTextListPosition, $281a441cdcb2cf36$var$findNextPosition, $281a441cdcb2cf36$var$findPosition, $281a441cdcb2cf36$var$insertNegatedAttributes, $281a441cdcb2cf36$var$updateCurrentAttributes, $281a441cdcb2cf36$var$minimizeAttributeChanges, $281a441cdcb2cf36$var$insertAttributes, $281a441cdcb2cf36$var$insertText, $281a441cdcb2cf36$var$formatText, $281a441cdcb2cf36$var$cleanupFormattingGap, $281a441cdcb2cf36$var$cleanupContextlessFormattingGap, $281a441cdcb2cf36$var$cleanupYTextFormatting, $281a441cdcb2cf36$var$cleanupYTextAfterTransaction, $281a441cdcb2cf36$var$deleteText, $281a441cdcb2cf36$var$YTextEvent, $281a441cdcb2cf36$var$YText, $281a441cdcb2cf36$var$readYText, $281a441cdcb2cf36$var$YXmlTreeWalker, $281a441cdcb2cf36$var$YXmlFragment, $281a441cdcb2cf36$var$readYXmlFragment, $281a441cdcb2cf36$var$YXmlElement, $281a441cdcb2cf36$var$readYXmlElement, $281a441cdcb2cf36$var$YXmlEvent, $281a441cdcb2cf36$var$YXmlHook, $281a441cdcb2cf36$var$readYXmlHook, $281a441cdcb2cf36$var$YXmlText, $281a441cdcb2cf36$var$readYXmlText, $281a441cdcb2cf36$var$AbstractStruct, $281a441cdcb2cf36$var$structGCRefNumber, $281a441cdcb2cf36$var$GC, $281a441cdcb2cf36$var$ContentBinary, $281a441cdcb2cf36$var$readContentBinary, $281a441cdcb2cf36$var$ContentDeleted, $281a441cdcb2cf36$var$readContentDeleted, $281a441cdcb2cf36$var$createDocFromOpts, $281a441cdcb2cf36$var$ContentDoc, $281a441cdcb2cf36$var$readContentDoc, $281a441cdcb2cf36$var$ContentEmbed, $281a441cdcb2cf36$var$readContentEmbed, $281a441cdcb2cf36$var$ContentFormat, $281a441cdcb2cf36$var$readContentFormat, $281a441cdcb2cf36$var$ContentJSON, $281a441cdcb2cf36$var$readContentJSON, $281a441cdcb2cf36$var$isDevMode, $281a441cdcb2cf36$var$ContentAny, $281a441cdcb2cf36$var$readContentAny, $281a441cdcb2cf36$var$ContentString, $281a441cdcb2cf36$var$readContentString, $281a441cdcb2cf36$var$typeRefs, $281a441cdcb2cf36$var$YArrayRefID, $281a441cdcb2cf36$var$YMapRefID, $281a441cdcb2cf36$var$YTextRefID, $281a441cdcb2cf36$var$YXmlElementRefID, $281a441cdcb2cf36$var$YXmlFragmentRefID, $281a441cdcb2cf36$var$YXmlHookRefID, $281a441cdcb2cf36$var$YXmlTextRefID, $281a441cdcb2cf36$var$ContentType, $281a441cdcb2cf36$var$readContentType, $281a441cdcb2cf36$var$splitItem, $281a441cdcb2cf36$var$Item, $281a441cdcb2cf36$var$readItemContent, $281a441cdcb2cf36$var$contentRefs, $281a441cdcb2cf36$var$structSkipRefNumber, $281a441cdcb2cf36$var$Skip, $281a441cdcb2cf36$var$glo, $281a441cdcb2cf36$var$importIdentifier;
var $281a441cdcb2cf36$var$init_yjs = $281a441cdcb2cf36$var$__esm({
    "../node_modules/yjs/dist/yjs.mjs" () {
        $281a441cdcb2cf36$var$init_observable();
        $281a441cdcb2cf36$var$init_array();
        $281a441cdcb2cf36$var$init_math();
        $281a441cdcb2cf36$var$init_map();
        $281a441cdcb2cf36$var$init_encoding();
        $281a441cdcb2cf36$var$init_decoding();
        $281a441cdcb2cf36$var$init_random();
        $281a441cdcb2cf36$var$init_promise();
        $281a441cdcb2cf36$var$init_buffer();
        $281a441cdcb2cf36$var$init_error();
        $281a441cdcb2cf36$var$init_binary();
        $281a441cdcb2cf36$var$init_function();
        $281a441cdcb2cf36$var$init_function();
        $281a441cdcb2cf36$var$init_set();
        $281a441cdcb2cf36$var$init_logging();
        $281a441cdcb2cf36$var$init_iterator();
        $281a441cdcb2cf36$var$init_object();
        $281a441cdcb2cf36$var$init_environment();
        $281a441cdcb2cf36$var$DeleteItem = class {
            /**
       * @param {number} clock
       * @param {number} len
       */ constructor(clock, len){
                this.clock = clock;
                this.len = len;
            }
        };
        $281a441cdcb2cf36$var$DeleteSet = class {
            constructor(){
                this.clients = /* @__PURE__ */ new Map();
            }
        };
        $281a441cdcb2cf36$var$iterateDeletedStructs = (transaction, ds, f3)=>ds.clients.forEach((deletes, clientid)=>{
                const structs = /** @type {Array<GC|Item>} */ transaction.doc.store.clients.get(clientid);
                if (structs != null) {
                    const lastStruct = structs[structs.length - 1];
                    const clockState = lastStruct.id.clock + lastStruct.length;
                    for(let i3 = 0, del2 = deletes[i3]; i3 < deletes.length && del2.clock < clockState; del2 = deletes[++i3])$281a441cdcb2cf36$var$iterateStructs(transaction, structs, del2.clock, del2.len, f3);
                }
            });
        $281a441cdcb2cf36$var$findIndexDS = (dis, clock)=>{
            let left = 0;
            let right = dis.length - 1;
            while(left <= right){
                const midindex = $281a441cdcb2cf36$var$floor((left + right) / 2);
                const mid = dis[midindex];
                const midclock = mid.clock;
                if (midclock <= clock) {
                    if (clock < midclock + mid.len) return midindex;
                    left = midindex + 1;
                } else right = midindex - 1;
            }
            return null;
        };
        $281a441cdcb2cf36$var$isDeleted = (ds, id2)=>{
            const dis = ds.clients.get(id2.client);
            return dis !== void 0 && $281a441cdcb2cf36$var$findIndexDS(dis, id2.clock) !== null;
        };
        $281a441cdcb2cf36$var$sortAndMergeDeleteSet = (ds)=>{
            ds.clients.forEach((dels)=>{
                dels.sort((a3, b3)=>a3.clock - b3.clock);
                let i3, j3;
                for(i3 = 1, j3 = 1; i3 < dels.length; i3++){
                    const left = dels[j3 - 1];
                    const right = dels[i3];
                    if (left.clock + left.len >= right.clock) dels[j3 - 1] = new $281a441cdcb2cf36$var$DeleteItem(left.clock, $281a441cdcb2cf36$var$max(left.len, right.clock + right.len - left.clock));
                    else {
                        if (j3 < i3) dels[j3] = right;
                        j3++;
                    }
                }
                dels.length = j3;
            });
        };
        $281a441cdcb2cf36$var$mergeDeleteSets = (dss)=>{
            const merged = new $281a441cdcb2cf36$var$DeleteSet();
            for(let dssI = 0; dssI < dss.length; dssI++)dss[dssI].clients.forEach((delsLeft, client)=>{
                if (!merged.clients.has(client)) {
                    const dels = delsLeft.slice();
                    for(let i3 = dssI + 1; i3 < dss.length; i3++)$281a441cdcb2cf36$var$appendTo(dels, dss[i3].clients.get(client) || []);
                    merged.clients.set(client, dels);
                }
            });
            $281a441cdcb2cf36$var$sortAndMergeDeleteSet(merged);
            return merged;
        };
        $281a441cdcb2cf36$var$addToDeleteSet = (ds, client, clock, length2)=>{
            $281a441cdcb2cf36$var$setIfUndefined(ds.clients, client, ()=>/** @type {Array<DeleteItem>} */ []).push(new $281a441cdcb2cf36$var$DeleteItem(clock, length2));
        };
        $281a441cdcb2cf36$var$createDeleteSet = ()=>new $281a441cdcb2cf36$var$DeleteSet();
        $281a441cdcb2cf36$var$createDeleteSetFromStructStore = (ss)=>{
            const ds = $281a441cdcb2cf36$var$createDeleteSet();
            ss.clients.forEach((structs, client)=>{
                const dsitems = [];
                for(let i3 = 0; i3 < structs.length; i3++){
                    const struct = structs[i3];
                    if (struct.deleted) {
                        const clock = struct.id.clock;
                        let len = struct.length;
                        if (i3 + 1 < structs.length) for(let next = structs[i3 + 1]; i3 + 1 < structs.length && next.deleted; next = structs[++i3 + 1])len += next.length;
                        dsitems.push(new $281a441cdcb2cf36$var$DeleteItem(clock, len));
                    }
                }
                if (dsitems.length > 0) ds.clients.set(client, dsitems);
            });
            return ds;
        };
        $281a441cdcb2cf36$var$writeDeleteSet = (encoder, ds)=>{
            $281a441cdcb2cf36$var$writeVarUint(encoder.restEncoder, ds.clients.size);
            $281a441cdcb2cf36$var$from(ds.clients.entries()).sort((a3, b3)=>b3[0] - a3[0]).forEach(([client, dsitems])=>{
                encoder.resetDsCurVal();
                $281a441cdcb2cf36$var$writeVarUint(encoder.restEncoder, client);
                const len = dsitems.length;
                $281a441cdcb2cf36$var$writeVarUint(encoder.restEncoder, len);
                for(let i3 = 0; i3 < len; i3++){
                    const item = dsitems[i3];
                    encoder.writeDsClock(item.clock);
                    encoder.writeDsLen(item.len);
                }
            });
        };
        $281a441cdcb2cf36$var$readDeleteSet = (decoder)=>{
            const ds = new $281a441cdcb2cf36$var$DeleteSet();
            const numClients = $281a441cdcb2cf36$var$readVarUint(decoder.restDecoder);
            for(let i3 = 0; i3 < numClients; i3++){
                decoder.resetDsCurVal();
                const client = $281a441cdcb2cf36$var$readVarUint(decoder.restDecoder);
                const numberOfDeletes = $281a441cdcb2cf36$var$readVarUint(decoder.restDecoder);
                if (numberOfDeletes > 0) {
                    const dsField = $281a441cdcb2cf36$var$setIfUndefined(ds.clients, client, ()=>/** @type {Array<DeleteItem>} */ []);
                    for(let i4 = 0; i4 < numberOfDeletes; i4++)dsField.push(new $281a441cdcb2cf36$var$DeleteItem(decoder.readDsClock(), decoder.readDsLen()));
                }
            }
            return ds;
        };
        $281a441cdcb2cf36$var$readAndApplyDeleteSet = (decoder, transaction, store)=>{
            const unappliedDS = new $281a441cdcb2cf36$var$DeleteSet();
            const numClients = $281a441cdcb2cf36$var$readVarUint(decoder.restDecoder);
            for(let i3 = 0; i3 < numClients; i3++){
                decoder.resetDsCurVal();
                const client = $281a441cdcb2cf36$var$readVarUint(decoder.restDecoder);
                const numberOfDeletes = $281a441cdcb2cf36$var$readVarUint(decoder.restDecoder);
                const structs = store.clients.get(client) || [];
                const state = $281a441cdcb2cf36$var$getState(store, client);
                for(let i4 = 0; i4 < numberOfDeletes; i4++){
                    const clock = decoder.readDsClock();
                    const clockEnd = clock + decoder.readDsLen();
                    if (clock < state) {
                        if (state < clockEnd) $281a441cdcb2cf36$var$addToDeleteSet(unappliedDS, client, state, clockEnd - state);
                        let index = $281a441cdcb2cf36$var$findIndexSS(structs, clock);
                        let struct = structs[index];
                        if (!struct.deleted && struct.id.clock < clock) {
                            structs.splice(index + 1, 0, $281a441cdcb2cf36$var$splitItem(transaction, struct, clock - struct.id.clock));
                            index++;
                        }
                        while(index < structs.length){
                            struct = structs[index++];
                            if (struct.id.clock < clockEnd) {
                                if (!struct.deleted) {
                                    if (clockEnd < struct.id.clock + struct.length) structs.splice(index, 0, $281a441cdcb2cf36$var$splitItem(transaction, struct, clockEnd - struct.id.clock));
                                    struct.delete(transaction);
                                }
                            } else break;
                        }
                    } else $281a441cdcb2cf36$var$addToDeleteSet(unappliedDS, client, clock, clockEnd - clock);
                }
            }
            if (unappliedDS.clients.size > 0) {
                const ds = new $281a441cdcb2cf36$var$UpdateEncoderV2();
                $281a441cdcb2cf36$var$writeVarUint(ds.restEncoder, 0);
                $281a441cdcb2cf36$var$writeDeleteSet(ds, unappliedDS);
                return ds.toUint8Array();
            }
            return null;
        };
        $281a441cdcb2cf36$var$generateNewClientId = $281a441cdcb2cf36$var$uint32;
        $281a441cdcb2cf36$var$Doc = class _Doc extends $281a441cdcb2cf36$var$ObservableV2 {
            /**
       * @param {DocOpts} opts configuration
       */ constructor({ guid: guid = $281a441cdcb2cf36$var$uuidv4(), collectionid: collectionid = null, gc: gc = true, gcFilter: gcFilter = ()=>true, meta: meta = null, autoLoad: autoLoad = false, shouldLoad: shouldLoad = true } = {}){
                super();
                this.gc = gc;
                this.gcFilter = gcFilter;
                this.clientID = $281a441cdcb2cf36$var$generateNewClientId();
                this.guid = guid;
                this.collectionid = collectionid;
                this.share = /* @__PURE__ */ new Map();
                this.store = new $281a441cdcb2cf36$var$StructStore();
                this._transaction = null;
                this._transactionCleanups = [];
                this.subdocs = /* @__PURE__ */ new Set();
                this._item = null;
                this.shouldLoad = shouldLoad;
                this.autoLoad = autoLoad;
                this.meta = meta;
                this.isLoaded = false;
                this.isSynced = false;
                this.isDestroyed = false;
                this.whenLoaded = $281a441cdcb2cf36$var$create4((resolve)=>{
                    this.on("load", ()=>{
                        this.isLoaded = true;
                        resolve(this);
                    });
                });
                const provideSyncedPromise = ()=>$281a441cdcb2cf36$var$create4((resolve)=>{
                        const eventHandler = (isSynced)=>{
                            if (isSynced === void 0 || isSynced === true) {
                                this.off("sync", eventHandler);
                                resolve();
                            }
                        };
                        this.on("sync", eventHandler);
                    });
                this.on("sync", (isSynced)=>{
                    if (isSynced === false && this.isSynced) this.whenSynced = provideSyncedPromise();
                    this.isSynced = isSynced === void 0 || isSynced === true;
                    if (this.isSynced && !this.isLoaded) this.emit("load", [
                        this
                    ]);
                });
                this.whenSynced = provideSyncedPromise();
            }
            /**
       * Notify the parent document that you request to load data into this subdocument (if it is a subdocument).
       *
       * `load()` might be used in the future to request any provider to load the most current data.
       *
       * It is safe to call `load()` multiple times.
       */ load() {
                const item = this._item;
                if (item !== null && !this.shouldLoad) $281a441cdcb2cf36$var$transact(/** @type {any} */ item.parent.doc, (transaction)=>{
                    transaction.subdocsLoaded.add(this);
                }, null, true);
                this.shouldLoad = true;
            }
            getSubdocs() {
                return this.subdocs;
            }
            getSubdocGuids() {
                return new Set($281a441cdcb2cf36$var$from(this.subdocs).map((doc2)=>doc2.guid));
            }
            /**
       * Changes that happen inside of a transaction are bundled. This means that
       * the observer fires _after_ the transaction is finished and that all changes
       * that happened inside of the transaction are sent as one message to the
       * other peers.
       *
       * @template T
       * @param {function(Transaction):T} f The function that should be executed as a transaction
       * @param {any} [origin] Origin of who started the transaction. Will be stored on transaction.origin
       * @return T
       *
       * @public
       */ transact(f3, origin = null) {
                return $281a441cdcb2cf36$var$transact(this, f3, origin);
            }
            /**
       * Define a shared data type.
       *
       * Multiple calls of `ydoc.get(name, TypeConstructor)` yield the same result
       * and do not overwrite each other. I.e.
       * `ydoc.get(name, Y.Array) === ydoc.get(name, Y.Array)`
       *
       * After this method is called, the type is also available on `ydoc.share.get(name)`.
       *
       * *Best Practices:*
       * Define all types right after the Y.Doc instance is created and store them in a separate object.
       * Also use the typed methods `getText(name)`, `getArray(name)`, ..
       *
       * @template {typeof AbstractType<any>} Type
       * @example
       *   const ydoc = new Y.Doc(..)
       *   const appState = {
       *     document: ydoc.getText('document')
       *     comments: ydoc.getArray('comments')
       *   }
       *
       * @param {string} name
       * @param {Type} TypeConstructor The constructor of the type definition. E.g. Y.Text, Y.Array, Y.Map, ...
       * @return {InstanceType<Type>} The created type. Constructed with TypeConstructor
       *
       * @public
       */ get(name, TypeConstructor = /** @type {any} */ $281a441cdcb2cf36$var$AbstractType) {
                const type = $281a441cdcb2cf36$var$setIfUndefined(this.share, name, ()=>{
                    const t4 = new TypeConstructor();
                    t4._integrate(this, null);
                    return t4;
                });
                const Constr = type.constructor;
                if (TypeConstructor !== $281a441cdcb2cf36$var$AbstractType && Constr !== TypeConstructor) {
                    if (Constr === $281a441cdcb2cf36$var$AbstractType) {
                        const t4 = new TypeConstructor();
                        t4._map = type._map;
                        type._map.forEach(/** @param {Item?} n */ (n3)=>{
                            for(; n3 !== null; n3 = n3.left)n3.parent = t4;
                        });
                        t4._start = type._start;
                        for(let n3 = t4._start; n3 !== null; n3 = n3.right)n3.parent = t4;
                        t4._length = type._length;
                        this.share.set(name, t4);
                        t4._integrate(this, null);
                        return /** @type {InstanceType<Type>} */ t4;
                    } else throw new Error(`Type with the name ${name} has already been defined with a different constructor`);
                }
                return /** @type {InstanceType<Type>} */ type;
            }
            /**
       * @template T
       * @param {string} [name]
       * @return {YArray<T>}
       *
       * @public
       */ getArray(name = "") {
                return /** @type {YArray<T>} */ this.get(name, $281a441cdcb2cf36$var$YArray);
            }
            /**
       * @param {string} [name]
       * @return {YText}
       *
       * @public
       */ getText(name = "") {
                return this.get(name, $281a441cdcb2cf36$var$YText);
            }
            /**
       * @template T
       * @param {string} [name]
       * @return {YMap<T>}
       *
       * @public
       */ getMap(name = "") {
                return /** @type {YMap<T>} */ this.get(name, $281a441cdcb2cf36$var$YMap);
            }
            /**
       * @param {string} [name]
       * @return {YXmlElement}
       *
       * @public
       */ getXmlElement(name = "") {
                return /** @type {YXmlElement<{[key:string]:string}>} */ this.get(name, $281a441cdcb2cf36$var$YXmlElement);
            }
            /**
       * @param {string} [name]
       * @return {YXmlFragment}
       *
       * @public
       */ getXmlFragment(name = "") {
                return this.get(name, $281a441cdcb2cf36$var$YXmlFragment);
            }
            /**
       * Converts the entire document into a js object, recursively traversing each yjs type
       * Doesn't log types that have not been defined (using ydoc.getType(..)).
       *
       * @deprecated Do not use this method and rather call toJSON directly on the shared types.
       *
       * @return {Object<string, any>}
       */ toJSON() {
                const doc2 = {};
                this.share.forEach((value2, key)=>{
                    doc2[key] = value2.toJSON();
                });
                return doc2;
            }
            /**
       * Emit `destroy` event and unregister all event handlers.
       */ destroy() {
                this.isDestroyed = true;
                $281a441cdcb2cf36$var$from(this.subdocs).forEach((subdoc)=>subdoc.destroy());
                const item = this._item;
                if (item !== null) {
                    this._item = null;
                    const content = /** @type {ContentDoc} */ item.content;
                    content.doc = new _Doc({
                        guid: this.guid,
                        ...content.opts,
                        shouldLoad: false
                    });
                    content.doc._item = item;
                    $281a441cdcb2cf36$var$transact(/** @type {any} */ item.parent.doc, (transaction)=>{
                        const doc2 = content.doc;
                        if (!item.deleted) transaction.subdocsAdded.add(doc2);
                        transaction.subdocsRemoved.add(this);
                    }, null, true);
                }
                this.emit("destroyed", [
                    true
                ]);
                this.emit("destroy", [
                    this
                ]);
                super.destroy();
            }
        };
        $281a441cdcb2cf36$var$DSDecoderV1 = class {
            /**
       * @param {decoding.Decoder} decoder
       */ constructor(decoder){
                this.restDecoder = decoder;
            }
            resetDsCurVal() {}
            /**
       * @return {number}
       */ readDsClock() {
                return $281a441cdcb2cf36$var$readVarUint(this.restDecoder);
            }
            /**
       * @return {number}
       */ readDsLen() {
                return $281a441cdcb2cf36$var$readVarUint(this.restDecoder);
            }
        };
        $281a441cdcb2cf36$var$UpdateDecoderV1 = class extends $281a441cdcb2cf36$var$DSDecoderV1 {
            /**
       * @return {ID}
       */ readLeftID() {
                return $281a441cdcb2cf36$var$createID($281a441cdcb2cf36$var$readVarUint(this.restDecoder), $281a441cdcb2cf36$var$readVarUint(this.restDecoder));
            }
            /**
       * @return {ID}
       */ readRightID() {
                return $281a441cdcb2cf36$var$createID($281a441cdcb2cf36$var$readVarUint(this.restDecoder), $281a441cdcb2cf36$var$readVarUint(this.restDecoder));
            }
            /**
       * Read the next client id.
       * Use this in favor of readID whenever possible to reduce the number of objects created.
       */ readClient() {
                return $281a441cdcb2cf36$var$readVarUint(this.restDecoder);
            }
            /**
       * @return {number} info An unsigned 8-bit integer
       */ readInfo() {
                return $281a441cdcb2cf36$var$readUint8(this.restDecoder);
            }
            /**
       * @return {string}
       */ readString() {
                return $281a441cdcb2cf36$var$readVarString(this.restDecoder);
            }
            /**
       * @return {boolean} isKey
       */ readParentInfo() {
                return $281a441cdcb2cf36$var$readVarUint(this.restDecoder) === 1;
            }
            /**
       * @return {number} info An unsigned 8-bit integer
       */ readTypeRef() {
                return $281a441cdcb2cf36$var$readVarUint(this.restDecoder);
            }
            /**
       * Write len of a struct - well suited for Opt RLE encoder.
       *
       * @return {number} len
       */ readLen() {
                return $281a441cdcb2cf36$var$readVarUint(this.restDecoder);
            }
            /**
       * @return {any}
       */ readAny() {
                return $281a441cdcb2cf36$var$readAny(this.restDecoder);
            }
            /**
       * @return {Uint8Array}
       */ readBuf() {
                return $281a441cdcb2cf36$var$copyUint8Array($281a441cdcb2cf36$var$readVarUint8Array(this.restDecoder));
            }
            /**
       * Legacy implementation uses JSON parse. We use any-decoding in v2.
       *
       * @return {any}
       */ readJSON() {
                return JSON.parse($281a441cdcb2cf36$var$readVarString(this.restDecoder));
            }
            /**
       * @return {string}
       */ readKey() {
                return $281a441cdcb2cf36$var$readVarString(this.restDecoder);
            }
        };
        $281a441cdcb2cf36$var$DSDecoderV2 = class {
            /**
       * @param {decoding.Decoder} decoder
       */ constructor(decoder){
                this.dsCurrVal = 0;
                this.restDecoder = decoder;
            }
            resetDsCurVal() {
                this.dsCurrVal = 0;
            }
            /**
       * @return {number}
       */ readDsClock() {
                this.dsCurrVal += $281a441cdcb2cf36$var$readVarUint(this.restDecoder);
                return this.dsCurrVal;
            }
            /**
       * @return {number}
       */ readDsLen() {
                const diff = $281a441cdcb2cf36$var$readVarUint(this.restDecoder) + 1;
                this.dsCurrVal += diff;
                return diff;
            }
        };
        $281a441cdcb2cf36$var$UpdateDecoderV2 = class extends $281a441cdcb2cf36$var$DSDecoderV2 {
            /**
       * @param {decoding.Decoder} decoder
       */ constructor(decoder){
                super(decoder);
                this.keys = [];
                $281a441cdcb2cf36$var$readVarUint(decoder);
                this.keyClockDecoder = new $281a441cdcb2cf36$var$IntDiffOptRleDecoder($281a441cdcb2cf36$var$readVarUint8Array(decoder));
                this.clientDecoder = new $281a441cdcb2cf36$var$UintOptRleDecoder($281a441cdcb2cf36$var$readVarUint8Array(decoder));
                this.leftClockDecoder = new $281a441cdcb2cf36$var$IntDiffOptRleDecoder($281a441cdcb2cf36$var$readVarUint8Array(decoder));
                this.rightClockDecoder = new $281a441cdcb2cf36$var$IntDiffOptRleDecoder($281a441cdcb2cf36$var$readVarUint8Array(decoder));
                this.infoDecoder = new $281a441cdcb2cf36$var$RleDecoder($281a441cdcb2cf36$var$readVarUint8Array(decoder), $281a441cdcb2cf36$var$readUint8);
                this.stringDecoder = new $281a441cdcb2cf36$var$StringDecoder($281a441cdcb2cf36$var$readVarUint8Array(decoder));
                this.parentInfoDecoder = new $281a441cdcb2cf36$var$RleDecoder($281a441cdcb2cf36$var$readVarUint8Array(decoder), $281a441cdcb2cf36$var$readUint8);
                this.typeRefDecoder = new $281a441cdcb2cf36$var$UintOptRleDecoder($281a441cdcb2cf36$var$readVarUint8Array(decoder));
                this.lenDecoder = new $281a441cdcb2cf36$var$UintOptRleDecoder($281a441cdcb2cf36$var$readVarUint8Array(decoder));
            }
            /**
       * @return {ID}
       */ readLeftID() {
                return new $281a441cdcb2cf36$var$ID(this.clientDecoder.read(), this.leftClockDecoder.read());
            }
            /**
       * @return {ID}
       */ readRightID() {
                return new $281a441cdcb2cf36$var$ID(this.clientDecoder.read(), this.rightClockDecoder.read());
            }
            /**
       * Read the next client id.
       * Use this in favor of readID whenever possible to reduce the number of objects created.
       */ readClient() {
                return this.clientDecoder.read();
            }
            /**
       * @return {number} info An unsigned 8-bit integer
       */ readInfo() {
                return /** @type {number} */ this.infoDecoder.read();
            }
            /**
       * @return {string}
       */ readString() {
                return this.stringDecoder.read();
            }
            /**
       * @return {boolean}
       */ readParentInfo() {
                return this.parentInfoDecoder.read() === 1;
            }
            /**
       * @return {number} An unsigned 8-bit integer
       */ readTypeRef() {
                return this.typeRefDecoder.read();
            }
            /**
       * Write len of a struct - well suited for Opt RLE encoder.
       *
       * @return {number}
       */ readLen() {
                return this.lenDecoder.read();
            }
            /**
       * @return {any}
       */ readAny() {
                return $281a441cdcb2cf36$var$readAny(this.restDecoder);
            }
            /**
       * @return {Uint8Array}
       */ readBuf() {
                return $281a441cdcb2cf36$var$readVarUint8Array(this.restDecoder);
            }
            /**
       * This is mainly here for legacy purposes.
       *
       * Initial we incoded objects using JSON. Now we use the much faster lib0/any-encoder. This method mainly exists for legacy purposes for the v1 encoder.
       *
       * @return {any}
       */ readJSON() {
                return $281a441cdcb2cf36$var$readAny(this.restDecoder);
            }
            /**
       * @return {string}
       */ readKey() {
                const keyClock = this.keyClockDecoder.read();
                if (keyClock < this.keys.length) return this.keys[keyClock];
                else {
                    const key = this.stringDecoder.read();
                    this.keys.push(key);
                    return key;
                }
            }
        };
        $281a441cdcb2cf36$var$DSEncoderV1 = class {
            constructor(){
                this.restEncoder = $281a441cdcb2cf36$var$createEncoder();
            }
            toUint8Array() {
                return $281a441cdcb2cf36$var$toUint8Array(this.restEncoder);
            }
            resetDsCurVal() {}
            /**
       * @param {number} clock
       */ writeDsClock(clock) {
                $281a441cdcb2cf36$var$writeVarUint(this.restEncoder, clock);
            }
            /**
       * @param {number} len
       */ writeDsLen(len) {
                $281a441cdcb2cf36$var$writeVarUint(this.restEncoder, len);
            }
        };
        $281a441cdcb2cf36$var$UpdateEncoderV1 = class extends $281a441cdcb2cf36$var$DSEncoderV1 {
            /**
       * @param {ID} id
       */ writeLeftID(id2) {
                $281a441cdcb2cf36$var$writeVarUint(this.restEncoder, id2.client);
                $281a441cdcb2cf36$var$writeVarUint(this.restEncoder, id2.clock);
            }
            /**
       * @param {ID} id
       */ writeRightID(id2) {
                $281a441cdcb2cf36$var$writeVarUint(this.restEncoder, id2.client);
                $281a441cdcb2cf36$var$writeVarUint(this.restEncoder, id2.clock);
            }
            /**
       * Use writeClient and writeClock instead of writeID if possible.
       * @param {number} client
       */ writeClient(client) {
                $281a441cdcb2cf36$var$writeVarUint(this.restEncoder, client);
            }
            /**
       * @param {number} info An unsigned 8-bit integer
       */ writeInfo(info) {
                $281a441cdcb2cf36$var$writeUint8(this.restEncoder, info);
            }
            /**
       * @param {string} s
       */ writeString(s3) {
                $281a441cdcb2cf36$var$writeVarString(this.restEncoder, s3);
            }
            /**
       * @param {boolean} isYKey
       */ writeParentInfo(isYKey) {
                $281a441cdcb2cf36$var$writeVarUint(this.restEncoder, isYKey ? 1 : 0);
            }
            /**
       * @param {number} info An unsigned 8-bit integer
       */ writeTypeRef(info) {
                $281a441cdcb2cf36$var$writeVarUint(this.restEncoder, info);
            }
            /**
       * Write len of a struct - well suited for Opt RLE encoder.
       *
       * @param {number} len
       */ writeLen(len) {
                $281a441cdcb2cf36$var$writeVarUint(this.restEncoder, len);
            }
            /**
       * @param {any} any
       */ writeAny(any2) {
                $281a441cdcb2cf36$var$writeAny(this.restEncoder, any2);
            }
            /**
       * @param {Uint8Array} buf
       */ writeBuf(buf) {
                $281a441cdcb2cf36$var$writeVarUint8Array(this.restEncoder, buf);
            }
            /**
       * @param {any} embed
       */ writeJSON(embed) {
                $281a441cdcb2cf36$var$writeVarString(this.restEncoder, JSON.stringify(embed));
            }
            /**
       * @param {string} key
       */ writeKey(key) {
                $281a441cdcb2cf36$var$writeVarString(this.restEncoder, key);
            }
        };
        $281a441cdcb2cf36$var$DSEncoderV2 = class {
            constructor(){
                this.restEncoder = $281a441cdcb2cf36$var$createEncoder();
                this.dsCurrVal = 0;
            }
            toUint8Array() {
                return $281a441cdcb2cf36$var$toUint8Array(this.restEncoder);
            }
            resetDsCurVal() {
                this.dsCurrVal = 0;
            }
            /**
       * @param {number} clock
       */ writeDsClock(clock) {
                const diff = clock - this.dsCurrVal;
                this.dsCurrVal = clock;
                $281a441cdcb2cf36$var$writeVarUint(this.restEncoder, diff);
            }
            /**
       * @param {number} len
       */ writeDsLen(len) {
                if (len === 0) $281a441cdcb2cf36$var$unexpectedCase();
                $281a441cdcb2cf36$var$writeVarUint(this.restEncoder, len - 1);
                this.dsCurrVal += len;
            }
        };
        $281a441cdcb2cf36$var$UpdateEncoderV2 = class extends $281a441cdcb2cf36$var$DSEncoderV2 {
            constructor(){
                super();
                this.keyMap = /* @__PURE__ */ new Map();
                this.keyClock = 0;
                this.keyClockEncoder = new $281a441cdcb2cf36$var$IntDiffOptRleEncoder();
                this.clientEncoder = new $281a441cdcb2cf36$var$UintOptRleEncoder();
                this.leftClockEncoder = new $281a441cdcb2cf36$var$IntDiffOptRleEncoder();
                this.rightClockEncoder = new $281a441cdcb2cf36$var$IntDiffOptRleEncoder();
                this.infoEncoder = new $281a441cdcb2cf36$var$RleEncoder($281a441cdcb2cf36$var$writeUint8);
                this.stringEncoder = new $281a441cdcb2cf36$var$StringEncoder();
                this.parentInfoEncoder = new $281a441cdcb2cf36$var$RleEncoder($281a441cdcb2cf36$var$writeUint8);
                this.typeRefEncoder = new $281a441cdcb2cf36$var$UintOptRleEncoder();
                this.lenEncoder = new $281a441cdcb2cf36$var$UintOptRleEncoder();
            }
            toUint8Array() {
                const encoder = $281a441cdcb2cf36$var$createEncoder();
                $281a441cdcb2cf36$var$writeVarUint(encoder, 0);
                $281a441cdcb2cf36$var$writeVarUint8Array(encoder, this.keyClockEncoder.toUint8Array());
                $281a441cdcb2cf36$var$writeVarUint8Array(encoder, this.clientEncoder.toUint8Array());
                $281a441cdcb2cf36$var$writeVarUint8Array(encoder, this.leftClockEncoder.toUint8Array());
                $281a441cdcb2cf36$var$writeVarUint8Array(encoder, this.rightClockEncoder.toUint8Array());
                $281a441cdcb2cf36$var$writeVarUint8Array(encoder, $281a441cdcb2cf36$var$toUint8Array(this.infoEncoder));
                $281a441cdcb2cf36$var$writeVarUint8Array(encoder, this.stringEncoder.toUint8Array());
                $281a441cdcb2cf36$var$writeVarUint8Array(encoder, $281a441cdcb2cf36$var$toUint8Array(this.parentInfoEncoder));
                $281a441cdcb2cf36$var$writeVarUint8Array(encoder, this.typeRefEncoder.toUint8Array());
                $281a441cdcb2cf36$var$writeVarUint8Array(encoder, this.lenEncoder.toUint8Array());
                $281a441cdcb2cf36$var$writeUint8Array(encoder, $281a441cdcb2cf36$var$toUint8Array(this.restEncoder));
                return $281a441cdcb2cf36$var$toUint8Array(encoder);
            }
            /**
       * @param {ID} id
       */ writeLeftID(id2) {
                this.clientEncoder.write(id2.client);
                this.leftClockEncoder.write(id2.clock);
            }
            /**
       * @param {ID} id
       */ writeRightID(id2) {
                this.clientEncoder.write(id2.client);
                this.rightClockEncoder.write(id2.clock);
            }
            /**
       * @param {number} client
       */ writeClient(client) {
                this.clientEncoder.write(client);
            }
            /**
       * @param {number} info An unsigned 8-bit integer
       */ writeInfo(info) {
                this.infoEncoder.write(info);
            }
            /**
       * @param {string} s
       */ writeString(s3) {
                this.stringEncoder.write(s3);
            }
            /**
       * @param {boolean} isYKey
       */ writeParentInfo(isYKey) {
                this.parentInfoEncoder.write(isYKey ? 1 : 0);
            }
            /**
       * @param {number} info An unsigned 8-bit integer
       */ writeTypeRef(info) {
                this.typeRefEncoder.write(info);
            }
            /**
       * Write len of a struct - well suited for Opt RLE encoder.
       *
       * @param {number} len
       */ writeLen(len) {
                this.lenEncoder.write(len);
            }
            /**
       * @param {any} any
       */ writeAny(any2) {
                $281a441cdcb2cf36$var$writeAny(this.restEncoder, any2);
            }
            /**
       * @param {Uint8Array} buf
       */ writeBuf(buf) {
                $281a441cdcb2cf36$var$writeVarUint8Array(this.restEncoder, buf);
            }
            /**
       * This is mainly here for legacy purposes.
       *
       * Initial we incoded objects using JSON. Now we use the much faster lib0/any-encoder. This method mainly exists for legacy purposes for the v1 encoder.
       *
       * @param {any} embed
       */ writeJSON(embed) {
                $281a441cdcb2cf36$var$writeAny(this.restEncoder, embed);
            }
            /**
       * Property keys are often reused. For example, in y-prosemirror the key `bold` might
       * occur very often. For a 3d application, the key `position` might occur very often.
       *
       * We cache these keys in a Map and refer to them via a unique number.
       *
       * @param {string} key
       */ writeKey(key) {
                const clock = this.keyMap.get(key);
                if (clock === void 0) {
                    this.keyClockEncoder.write(this.keyClock++);
                    this.stringEncoder.write(key);
                } else this.keyClockEncoder.write(clock);
            }
        };
        $281a441cdcb2cf36$var$writeStructs = (encoder, structs, client, clock)=>{
            clock = $281a441cdcb2cf36$var$max(clock, structs[0].id.clock);
            const startNewStructs = $281a441cdcb2cf36$var$findIndexSS(structs, clock);
            $281a441cdcb2cf36$var$writeVarUint(encoder.restEncoder, structs.length - startNewStructs);
            encoder.writeClient(client);
            $281a441cdcb2cf36$var$writeVarUint(encoder.restEncoder, clock);
            const firstStruct = structs[startNewStructs];
            firstStruct.write(encoder, clock - firstStruct.id.clock);
            for(let i3 = startNewStructs + 1; i3 < structs.length; i3++)structs[i3].write(encoder, 0);
        };
        $281a441cdcb2cf36$var$writeClientsStructs = (encoder, store, _sm)=>{
            const sm = /* @__PURE__ */ new Map();
            _sm.forEach((clock, client)=>{
                if ($281a441cdcb2cf36$var$getState(store, client) > clock) sm.set(client, clock);
            });
            $281a441cdcb2cf36$var$getStateVector(store).forEach((_clock, client)=>{
                if (!_sm.has(client)) sm.set(client, 0);
            });
            $281a441cdcb2cf36$var$writeVarUint(encoder.restEncoder, sm.size);
            $281a441cdcb2cf36$var$from(sm.entries()).sort((a3, b3)=>b3[0] - a3[0]).forEach(([client, clock])=>{
                $281a441cdcb2cf36$var$writeStructs(encoder, /** @type {Array<GC|Item>} */ store.clients.get(client), client, clock);
            });
        };
        $281a441cdcb2cf36$var$readClientsStructRefs = (decoder, doc2)=>{
            const clientRefs = $281a441cdcb2cf36$var$create();
            const numOfStateUpdates = $281a441cdcb2cf36$var$readVarUint(decoder.restDecoder);
            for(let i3 = 0; i3 < numOfStateUpdates; i3++){
                const numberOfStructs = $281a441cdcb2cf36$var$readVarUint(decoder.restDecoder);
                const refs = new Array(numberOfStructs);
                const client = decoder.readClient();
                let clock = $281a441cdcb2cf36$var$readVarUint(decoder.restDecoder);
                clientRefs.set(client, {
                    i: 0,
                    refs: refs
                });
                for(let i4 = 0; i4 < numberOfStructs; i4++){
                    const info = decoder.readInfo();
                    switch($281a441cdcb2cf36$var$BITS5 & info){
                        case 0:
                            {
                                const len = decoder.readLen();
                                refs[i4] = new $281a441cdcb2cf36$var$GC($281a441cdcb2cf36$var$createID(client, clock), len);
                                clock += len;
                                break;
                            }
                        case 10:
                            {
                                const len = $281a441cdcb2cf36$var$readVarUint(decoder.restDecoder);
                                refs[i4] = new $281a441cdcb2cf36$var$Skip($281a441cdcb2cf36$var$createID(client, clock), len);
                                clock += len;
                                break;
                            }
                        default:
                            {
                                const cantCopyParentInfo = (info & ($281a441cdcb2cf36$var$BIT7 | $281a441cdcb2cf36$var$BIT8)) === 0;
                                const struct = new $281a441cdcb2cf36$var$Item($281a441cdcb2cf36$var$createID(client, clock), null, // left
                                (info & $281a441cdcb2cf36$var$BIT8) === $281a441cdcb2cf36$var$BIT8 ? decoder.readLeftID() : null, // origin
                                null, // right
                                (info & $281a441cdcb2cf36$var$BIT7) === $281a441cdcb2cf36$var$BIT7 ? decoder.readRightID() : null, // right origin
                                cantCopyParentInfo ? decoder.readParentInfo() ? doc2.get(decoder.readString()) : decoder.readLeftID() : null, // parent
                                cantCopyParentInfo && (info & $281a441cdcb2cf36$var$BIT6) === $281a441cdcb2cf36$var$BIT6 ? decoder.readString() : null, // parentSub
                                $281a441cdcb2cf36$var$readItemContent(decoder, info));
                                refs[i4] = struct;
                                clock += struct.length;
                            }
                    }
                }
            }
            return clientRefs;
        };
        $281a441cdcb2cf36$var$integrateStructs = (transaction, store, clientsStructRefs)=>{
            const stack = [];
            let clientsStructRefsIds = $281a441cdcb2cf36$var$from(clientsStructRefs.keys()).sort((a3, b3)=>a3 - b3);
            if (clientsStructRefsIds.length === 0) return null;
            const getNextStructTarget = ()=>{
                if (clientsStructRefsIds.length === 0) return null;
                let nextStructsTarget = /** @type {{i:number,refs:Array<GC|Item>}} */ clientsStructRefs.get(clientsStructRefsIds[clientsStructRefsIds.length - 1]);
                while(nextStructsTarget.refs.length === nextStructsTarget.i){
                    clientsStructRefsIds.pop();
                    if (clientsStructRefsIds.length > 0) nextStructsTarget = /** @type {{i:number,refs:Array<GC|Item>}} */ clientsStructRefs.get(clientsStructRefsIds[clientsStructRefsIds.length - 1]);
                    else return null;
                }
                return nextStructsTarget;
            };
            let curStructsTarget = getNextStructTarget();
            if (curStructsTarget === null) return null;
            const restStructs = new $281a441cdcb2cf36$var$StructStore();
            const missingSV = /* @__PURE__ */ new Map();
            const updateMissingSv = (client, clock)=>{
                const mclock = missingSV.get(client);
                if (mclock == null || mclock > clock) missingSV.set(client, clock);
            };
            let stackHead = /** @type {any} */ curStructsTarget.refs[/** @type {any} */ curStructsTarget.i++];
            const state = /* @__PURE__ */ new Map();
            const addStackToRestSS = ()=>{
                for (const item of stack){
                    const client = item.id.client;
                    const inapplicableItems = clientsStructRefs.get(client);
                    if (inapplicableItems) {
                        inapplicableItems.i--;
                        restStructs.clients.set(client, inapplicableItems.refs.slice(inapplicableItems.i));
                        clientsStructRefs.delete(client);
                        inapplicableItems.i = 0;
                        inapplicableItems.refs = [];
                    } else restStructs.clients.set(client, [
                        item
                    ]);
                    clientsStructRefsIds = clientsStructRefsIds.filter((c3)=>c3 !== client);
                }
                stack.length = 0;
            };
            while(true){
                if (stackHead.constructor !== $281a441cdcb2cf36$var$Skip) {
                    const localClock = $281a441cdcb2cf36$var$setIfUndefined(state, stackHead.id.client, ()=>$281a441cdcb2cf36$var$getState(store, stackHead.id.client));
                    const offset2 = localClock - stackHead.id.clock;
                    if (offset2 < 0) {
                        stack.push(stackHead);
                        updateMissingSv(stackHead.id.client, stackHead.id.clock - 1);
                        addStackToRestSS();
                    } else {
                        const missing = stackHead.getMissing(transaction, store);
                        if (missing !== null) {
                            stack.push(stackHead);
                            const structRefs = clientsStructRefs.get(/** @type {number} */ missing) || {
                                refs: [],
                                i: 0
                            };
                            if (structRefs.refs.length === structRefs.i) {
                                updateMissingSv(/** @type {number} */ missing, $281a441cdcb2cf36$var$getState(store, missing));
                                addStackToRestSS();
                            } else {
                                stackHead = structRefs.refs[structRefs.i++];
                                continue;
                            }
                        } else if (offset2 === 0 || offset2 < stackHead.length) {
                            stackHead.integrate(transaction, offset2);
                            state.set(stackHead.id.client, stackHead.id.clock + stackHead.length);
                        }
                    }
                }
                if (stack.length > 0) stackHead = /** @type {GC|Item} */ stack.pop();
                else if (curStructsTarget !== null && curStructsTarget.i < curStructsTarget.refs.length) stackHead = /** @type {GC|Item} */ curStructsTarget.refs[curStructsTarget.i++];
                else {
                    curStructsTarget = getNextStructTarget();
                    if (curStructsTarget === null) break;
                    else stackHead = /** @type {GC|Item} */ curStructsTarget.refs[curStructsTarget.i++];
                }
            }
            if (restStructs.clients.size > 0) {
                const encoder = new $281a441cdcb2cf36$var$UpdateEncoderV2();
                $281a441cdcb2cf36$var$writeClientsStructs(encoder, restStructs, /* @__PURE__ */ new Map());
                $281a441cdcb2cf36$var$writeVarUint(encoder.restEncoder, 0);
                return {
                    missing: missingSV,
                    update: encoder.toUint8Array()
                };
            }
            return null;
        };
        $281a441cdcb2cf36$var$writeStructsFromTransaction = (encoder, transaction)=>$281a441cdcb2cf36$var$writeClientsStructs(encoder, transaction.doc.store, transaction.beforeState);
        $281a441cdcb2cf36$var$readUpdateV2 = (decoder, ydoc, transactionOrigin, structDecoder = new $281a441cdcb2cf36$var$UpdateDecoderV2(decoder))=>$281a441cdcb2cf36$var$transact(ydoc, (transaction)=>{
                transaction.local = false;
                let retry = false;
                const doc2 = transaction.doc;
                const store = doc2.store;
                const ss = $281a441cdcb2cf36$var$readClientsStructRefs(structDecoder, doc2);
                const restStructs = $281a441cdcb2cf36$var$integrateStructs(transaction, store, ss);
                const pending = store.pendingStructs;
                if (pending) {
                    for (const [client, clock] of pending.missing)if (clock < $281a441cdcb2cf36$var$getState(store, client)) {
                        retry = true;
                        break;
                    }
                    if (restStructs) {
                        for (const [client, clock] of restStructs.missing){
                            const mclock = pending.missing.get(client);
                            if (mclock == null || mclock > clock) pending.missing.set(client, clock);
                        }
                        pending.update = $281a441cdcb2cf36$var$mergeUpdatesV2([
                            pending.update,
                            restStructs.update
                        ]);
                    }
                } else store.pendingStructs = restStructs;
                const dsRest = $281a441cdcb2cf36$var$readAndApplyDeleteSet(structDecoder, transaction, store);
                if (store.pendingDs) {
                    const pendingDSUpdate = new $281a441cdcb2cf36$var$UpdateDecoderV2($281a441cdcb2cf36$var$createDecoder(store.pendingDs));
                    $281a441cdcb2cf36$var$readVarUint(pendingDSUpdate.restDecoder);
                    const dsRest2 = $281a441cdcb2cf36$var$readAndApplyDeleteSet(pendingDSUpdate, transaction, store);
                    if (dsRest && dsRest2) store.pendingDs = $281a441cdcb2cf36$var$mergeUpdatesV2([
                        dsRest,
                        dsRest2
                    ]);
                    else store.pendingDs = dsRest || dsRest2;
                } else store.pendingDs = dsRest;
                if (retry) {
                    const update = /** @type {{update: Uint8Array}} */ store.pendingStructs.update;
                    store.pendingStructs = null;
                    $281a441cdcb2cf36$var$applyUpdateV2(transaction.doc, update);
                }
            }, transactionOrigin, false);
        $281a441cdcb2cf36$var$applyUpdateV2 = (ydoc, update, transactionOrigin, YDecoder = $281a441cdcb2cf36$var$UpdateDecoderV2)=>{
            const decoder = $281a441cdcb2cf36$var$createDecoder(update);
            $281a441cdcb2cf36$var$readUpdateV2(decoder, ydoc, transactionOrigin, new YDecoder(decoder));
        };
        $281a441cdcb2cf36$var$applyUpdate = (ydoc, update, transactionOrigin)=>$281a441cdcb2cf36$var$applyUpdateV2(ydoc, update, transactionOrigin, $281a441cdcb2cf36$var$UpdateDecoderV1);
        $281a441cdcb2cf36$var$writeStateAsUpdate = (encoder, doc2, targetStateVector = /* @__PURE__ */ new Map())=>{
            $281a441cdcb2cf36$var$writeClientsStructs(encoder, doc2.store, targetStateVector);
            $281a441cdcb2cf36$var$writeDeleteSet(encoder, $281a441cdcb2cf36$var$createDeleteSetFromStructStore(doc2.store));
        };
        $281a441cdcb2cf36$var$encodeStateAsUpdateV2 = (doc2, encodedTargetStateVector = new Uint8Array([
            0
        ]), encoder = new $281a441cdcb2cf36$var$UpdateEncoderV2())=>{
            const targetStateVector = $281a441cdcb2cf36$var$decodeStateVector(encodedTargetStateVector);
            $281a441cdcb2cf36$var$writeStateAsUpdate(encoder, doc2, targetStateVector);
            const updates = [
                encoder.toUint8Array()
            ];
            if (doc2.store.pendingDs) updates.push(doc2.store.pendingDs);
            if (doc2.store.pendingStructs) updates.push($281a441cdcb2cf36$var$diffUpdateV2(doc2.store.pendingStructs.update, encodedTargetStateVector));
            if (updates.length > 1) {
                if (encoder.constructor === $281a441cdcb2cf36$var$UpdateEncoderV1) return $281a441cdcb2cf36$var$mergeUpdates(updates.map((update, i3)=>i3 === 0 ? update : $281a441cdcb2cf36$var$convertUpdateFormatV2ToV1(update)));
                else if (encoder.constructor === $281a441cdcb2cf36$var$UpdateEncoderV2) return $281a441cdcb2cf36$var$mergeUpdatesV2(updates);
            }
            return updates[0];
        };
        $281a441cdcb2cf36$var$encodeStateAsUpdate = (doc2, encodedTargetStateVector)=>$281a441cdcb2cf36$var$encodeStateAsUpdateV2(doc2, encodedTargetStateVector, new $281a441cdcb2cf36$var$UpdateEncoderV1());
        $281a441cdcb2cf36$var$readStateVector = (decoder)=>{
            const ss = /* @__PURE__ */ new Map();
            const ssLength = $281a441cdcb2cf36$var$readVarUint(decoder.restDecoder);
            for(let i3 = 0; i3 < ssLength; i3++){
                const client = $281a441cdcb2cf36$var$readVarUint(decoder.restDecoder);
                const clock = $281a441cdcb2cf36$var$readVarUint(decoder.restDecoder);
                ss.set(client, clock);
            }
            return ss;
        };
        $281a441cdcb2cf36$var$decodeStateVector = (decodedState)=>$281a441cdcb2cf36$var$readStateVector(new $281a441cdcb2cf36$var$DSDecoderV1($281a441cdcb2cf36$var$createDecoder(decodedState)));
        $281a441cdcb2cf36$var$EventHandler = class {
            constructor(){
                this.l = [];
            }
        };
        $281a441cdcb2cf36$var$createEventHandler = ()=>new $281a441cdcb2cf36$var$EventHandler();
        $281a441cdcb2cf36$var$addEventHandlerListener = (eventHandler, f3)=>eventHandler.l.push(f3);
        $281a441cdcb2cf36$var$removeEventHandlerListener = (eventHandler, f3)=>{
            const l3 = eventHandler.l;
            const len = l3.length;
            eventHandler.l = l3.filter((g3)=>f3 !== g3);
            if (len === eventHandler.l.length) console.error("[yjs] Tried to remove event handler that doesn't exist.");
        };
        $281a441cdcb2cf36$var$callEventHandlerListeners = (eventHandler, arg0, arg1)=>$281a441cdcb2cf36$var$callAll(eventHandler.l, [
                arg0,
                arg1
            ]);
        $281a441cdcb2cf36$var$ID = class {
            /**
       * @param {number} client client id
       * @param {number} clock unique per client id, continuous number
       */ constructor(client, clock){
                this.client = client;
                this.clock = clock;
            }
        };
        $281a441cdcb2cf36$var$compareIDs = (a3, b3)=>a3 === b3 || a3 !== null && b3 !== null && a3.client === b3.client && a3.clock === b3.clock;
        $281a441cdcb2cf36$var$createID = (client, clock)=>new $281a441cdcb2cf36$var$ID(client, clock);
        $281a441cdcb2cf36$var$findRootTypeKey = (type)=>{
            for (const [key, value2] of type.doc.share.entries()){
                if (value2 === type) return key;
            }
            throw $281a441cdcb2cf36$var$unexpectedCase();
        };
        $281a441cdcb2cf36$var$Snapshot = class {
            /**
       * @param {DeleteSet} ds
       * @param {Map<number,number>} sv state map
       */ constructor(ds, sv){
                this.ds = ds;
                this.sv = sv;
            }
        };
        $281a441cdcb2cf36$var$createSnapshot = (ds, sm)=>new $281a441cdcb2cf36$var$Snapshot(ds, sm);
        $281a441cdcb2cf36$var$emptySnapshot = $281a441cdcb2cf36$var$createSnapshot($281a441cdcb2cf36$var$createDeleteSet(), /* @__PURE__ */ new Map());
        $281a441cdcb2cf36$var$isVisible = (item, snapshot)=>snapshot === void 0 ? !item.deleted : snapshot.sv.has(item.id.client) && (snapshot.sv.get(item.id.client) || 0) > item.id.clock && !$281a441cdcb2cf36$var$isDeleted(snapshot.ds, item.id);
        $281a441cdcb2cf36$var$splitSnapshotAffectedStructs = (transaction, snapshot)=>{
            const meta = $281a441cdcb2cf36$var$setIfUndefined(transaction.meta, $281a441cdcb2cf36$var$splitSnapshotAffectedStructs, $281a441cdcb2cf36$var$create2);
            const store = transaction.doc.store;
            if (!meta.has(snapshot)) {
                snapshot.sv.forEach((clock, client)=>{
                    if (clock < $281a441cdcb2cf36$var$getState(store, client)) $281a441cdcb2cf36$var$getItemCleanStart(transaction, $281a441cdcb2cf36$var$createID(client, clock));
                });
                $281a441cdcb2cf36$var$iterateDeletedStructs(transaction, snapshot.ds, (_item)=>{});
                meta.add(snapshot);
            }
        };
        $281a441cdcb2cf36$var$StructStore = class {
            constructor(){
                this.clients = /* @__PURE__ */ new Map();
                this.pendingStructs = null;
                this.pendingDs = null;
            }
        };
        $281a441cdcb2cf36$var$getStateVector = (store)=>{
            const sm = /* @__PURE__ */ new Map();
            store.clients.forEach((structs, client)=>{
                const struct = structs[structs.length - 1];
                sm.set(client, struct.id.clock + struct.length);
            });
            return sm;
        };
        $281a441cdcb2cf36$var$getState = (store, client)=>{
            const structs = store.clients.get(client);
            if (structs === void 0) return 0;
            const lastStruct = structs[structs.length - 1];
            return lastStruct.id.clock + lastStruct.length;
        };
        $281a441cdcb2cf36$var$addStruct = (store, struct)=>{
            let structs = store.clients.get(struct.id.client);
            if (structs === void 0) {
                structs = [];
                store.clients.set(struct.id.client, structs);
            } else {
                const lastStruct = structs[structs.length - 1];
                if (lastStruct.id.clock + lastStruct.length !== struct.id.clock) throw $281a441cdcb2cf36$var$unexpectedCase();
            }
            structs.push(struct);
        };
        $281a441cdcb2cf36$var$findIndexSS = (structs, clock)=>{
            let left = 0;
            let right = structs.length - 1;
            let mid = structs[right];
            let midclock = mid.id.clock;
            if (midclock === clock) return right;
            let midindex = $281a441cdcb2cf36$var$floor(clock / (midclock + mid.length - 1) * right);
            while(left <= right){
                mid = structs[midindex];
                midclock = mid.id.clock;
                if (midclock <= clock) {
                    if (clock < midclock + mid.length) return midindex;
                    left = midindex + 1;
                } else right = midindex - 1;
                midindex = $281a441cdcb2cf36$var$floor((left + right) / 2);
            }
            throw $281a441cdcb2cf36$var$unexpectedCase();
        };
        $281a441cdcb2cf36$var$find = (store, id2)=>{
            const structs = store.clients.get(id2.client);
            return structs[$281a441cdcb2cf36$var$findIndexSS(structs, id2.clock)];
        };
        $281a441cdcb2cf36$var$getItem = /** @type {function(StructStore,ID):Item} */ $281a441cdcb2cf36$var$find;
        $281a441cdcb2cf36$var$findIndexCleanStart = (transaction, structs, clock)=>{
            const index = $281a441cdcb2cf36$var$findIndexSS(structs, clock);
            const struct = structs[index];
            if (struct.id.clock < clock && struct instanceof $281a441cdcb2cf36$var$Item) {
                structs.splice(index + 1, 0, $281a441cdcb2cf36$var$splitItem(transaction, struct, clock - struct.id.clock));
                return index + 1;
            }
            return index;
        };
        $281a441cdcb2cf36$var$getItemCleanStart = (transaction, id2)=>{
            const structs = /** @type {Array<Item>} */ transaction.doc.store.clients.get(id2.client);
            return structs[$281a441cdcb2cf36$var$findIndexCleanStart(transaction, structs, id2.clock)];
        };
        $281a441cdcb2cf36$var$getItemCleanEnd = (transaction, store, id2)=>{
            const structs = store.clients.get(id2.client);
            const index = $281a441cdcb2cf36$var$findIndexSS(structs, id2.clock);
            const struct = structs[index];
            if (id2.clock !== struct.id.clock + struct.length - 1 && struct.constructor !== $281a441cdcb2cf36$var$GC) structs.splice(index + 1, 0, $281a441cdcb2cf36$var$splitItem(transaction, struct, id2.clock - struct.id.clock + 1));
            return struct;
        };
        $281a441cdcb2cf36$var$replaceStruct = (store, struct, newStruct)=>{
            const structs = /** @type {Array<GC|Item>} */ store.clients.get(struct.id.client);
            structs[$281a441cdcb2cf36$var$findIndexSS(structs, struct.id.clock)] = newStruct;
        };
        $281a441cdcb2cf36$var$iterateStructs = (transaction, structs, clockStart, len, f3)=>{
            if (len === 0) return;
            const clockEnd = clockStart + len;
            let index = $281a441cdcb2cf36$var$findIndexCleanStart(transaction, structs, clockStart);
            let struct;
            do {
                struct = structs[index++];
                if (clockEnd < struct.id.clock + struct.length) $281a441cdcb2cf36$var$findIndexCleanStart(transaction, structs, clockEnd);
                f3(struct);
            }while (index < structs.length && structs[index].id.clock < clockEnd);
        };
        $281a441cdcb2cf36$var$Transaction = class {
            /**
       * @param {Doc} doc
       * @param {any} origin
       * @param {boolean} local
       */ constructor(doc2, origin, local){
                this.doc = doc2;
                this.deleteSet = new $281a441cdcb2cf36$var$DeleteSet();
                this.beforeState = $281a441cdcb2cf36$var$getStateVector(doc2.store);
                this.afterState = /* @__PURE__ */ new Map();
                this.changed = /* @__PURE__ */ new Map();
                this.changedParentTypes = /* @__PURE__ */ new Map();
                this._mergeStructs = [];
                this.origin = origin;
                this.meta = /* @__PURE__ */ new Map();
                this.local = local;
                this.subdocsAdded = /* @__PURE__ */ new Set();
                this.subdocsRemoved = /* @__PURE__ */ new Set();
                this.subdocsLoaded = /* @__PURE__ */ new Set();
                this._needFormattingCleanup = false;
            }
        };
        $281a441cdcb2cf36$var$writeUpdateMessageFromTransaction = (encoder, transaction)=>{
            if (transaction.deleteSet.clients.size === 0 && !$281a441cdcb2cf36$var$any(transaction.afterState, (clock, client)=>transaction.beforeState.get(client) !== clock)) return false;
            $281a441cdcb2cf36$var$sortAndMergeDeleteSet(transaction.deleteSet);
            $281a441cdcb2cf36$var$writeStructsFromTransaction(encoder, transaction);
            $281a441cdcb2cf36$var$writeDeleteSet(encoder, transaction.deleteSet);
            return true;
        };
        $281a441cdcb2cf36$var$addChangedTypeToTransaction = (transaction, type, parentSub)=>{
            const item = type._item;
            if (item === null || item.id.clock < (transaction.beforeState.get(item.id.client) || 0) && !item.deleted) $281a441cdcb2cf36$var$setIfUndefined(transaction.changed, type, $281a441cdcb2cf36$var$create2).add(parentSub);
        };
        $281a441cdcb2cf36$var$tryToMergeWithLefts = (structs, pos)=>{
            let right = structs[pos];
            let left = structs[pos - 1];
            let i3 = pos;
            for(; i3 > 0; right = left, left = structs[--i3 - 1]){
                if (left.deleted === right.deleted && left.constructor === right.constructor) {
                    if (left.mergeWith(right)) {
                        if (right instanceof $281a441cdcb2cf36$var$Item && right.parentSub !== null && /** @type {AbstractType<any>} */ right.parent._map.get(right.parentSub) === right) right.parent._map.set(right.parentSub, /** @type {Item} */ left);
                        continue;
                    }
                }
                break;
            }
            const merged = pos - i3;
            if (merged) structs.splice(pos + 1 - merged, merged);
            return merged;
        };
        $281a441cdcb2cf36$var$tryGcDeleteSet = (ds, store, gcFilter)=>{
            for (const [client, deleteItems] of ds.clients.entries()){
                const structs = /** @type {Array<GC|Item>} */ store.clients.get(client);
                for(let di = deleteItems.length - 1; di >= 0; di--){
                    const deleteItem = deleteItems[di];
                    const endDeleteItemClock = deleteItem.clock + deleteItem.len;
                    for(let si = $281a441cdcb2cf36$var$findIndexSS(structs, deleteItem.clock), struct = structs[si]; si < structs.length && struct.id.clock < endDeleteItemClock; struct = structs[++si]){
                        const struct2 = structs[si];
                        if (deleteItem.clock + deleteItem.len <= struct2.id.clock) break;
                        if (struct2 instanceof $281a441cdcb2cf36$var$Item && struct2.deleted && !struct2.keep && gcFilter(struct2)) struct2.gc(store, false);
                    }
                }
            }
        };
        $281a441cdcb2cf36$var$tryMergeDeleteSet = (ds, store)=>{
            ds.clients.forEach((deleteItems, client)=>{
                const structs = /** @type {Array<GC|Item>} */ store.clients.get(client);
                for(let di = deleteItems.length - 1; di >= 0; di--){
                    const deleteItem = deleteItems[di];
                    const mostRightIndexToCheck = $281a441cdcb2cf36$var$min(structs.length - 1, 1 + $281a441cdcb2cf36$var$findIndexSS(structs, deleteItem.clock + deleteItem.len - 1));
                    for(let si = mostRightIndexToCheck, struct = structs[si]; si > 0 && struct.id.clock >= deleteItem.clock; struct = structs[si])si -= 1 + $281a441cdcb2cf36$var$tryToMergeWithLefts(structs, si);
                }
            });
        };
        $281a441cdcb2cf36$var$cleanupTransactions = (transactionCleanups, i3)=>{
            if (i3 < transactionCleanups.length) {
                const transaction = transactionCleanups[i3];
                const doc2 = transaction.doc;
                const store = doc2.store;
                const ds = transaction.deleteSet;
                const mergeStructs = transaction._mergeStructs;
                try {
                    $281a441cdcb2cf36$var$sortAndMergeDeleteSet(ds);
                    transaction.afterState = $281a441cdcb2cf36$var$getStateVector(transaction.doc.store);
                    doc2.emit("beforeObserverCalls", [
                        transaction,
                        doc2
                    ]);
                    const fs = [];
                    transaction.changed.forEach((subs, itemtype)=>fs.push(()=>{
                            if (itemtype._item === null || !itemtype._item.deleted) itemtype._callObserver(transaction, subs);
                        }));
                    fs.push(()=>{
                        transaction.changedParentTypes.forEach((events, type)=>{
                            if (type._dEH.l.length > 0 && (type._item === null || !type._item.deleted)) {
                                events = events.filter((event)=>event.target._item === null || !event.target._item.deleted);
                                events.forEach((event)=>{
                                    event.currentTarget = type;
                                    event._path = null;
                                });
                                events.sort((event1, event2)=>event1.path.length - event2.path.length);
                                fs.push(()=>{
                                    $281a441cdcb2cf36$var$callEventHandlerListeners(type._dEH, events, transaction);
                                });
                            }
                        });
                        fs.push(()=>doc2.emit("afterTransaction", [
                                transaction,
                                doc2
                            ]));
                        fs.push(()=>{
                            if (transaction._needFormattingCleanup) $281a441cdcb2cf36$var$cleanupYTextAfterTransaction(transaction);
                        });
                    });
                    $281a441cdcb2cf36$var$callAll(fs, []);
                } finally{
                    if (doc2.gc) $281a441cdcb2cf36$var$tryGcDeleteSet(ds, store, doc2.gcFilter);
                    $281a441cdcb2cf36$var$tryMergeDeleteSet(ds, store);
                    transaction.afterState.forEach((clock, client)=>{
                        const beforeClock = transaction.beforeState.get(client) || 0;
                        if (beforeClock !== clock) {
                            const structs = /** @type {Array<GC|Item>} */ store.clients.get(client);
                            const firstChangePos = $281a441cdcb2cf36$var$max($281a441cdcb2cf36$var$findIndexSS(structs, beforeClock), 1);
                            for(let i4 = structs.length - 1; i4 >= firstChangePos;)i4 -= 1 + $281a441cdcb2cf36$var$tryToMergeWithLefts(structs, i4);
                        }
                    });
                    for(let i4 = mergeStructs.length - 1; i4 >= 0; i4--){
                        const { client: client, clock: clock } = mergeStructs[i4].id;
                        const structs = /** @type {Array<GC|Item>} */ store.clients.get(client);
                        const replacedStructPos = $281a441cdcb2cf36$var$findIndexSS(structs, clock);
                        if (replacedStructPos + 1 < structs.length) {
                            if ($281a441cdcb2cf36$var$tryToMergeWithLefts(structs, replacedStructPos + 1) > 1) continue;
                        }
                        if (replacedStructPos > 0) $281a441cdcb2cf36$var$tryToMergeWithLefts(structs, replacedStructPos);
                    }
                    if (!transaction.local && transaction.afterState.get(doc2.clientID) !== transaction.beforeState.get(doc2.clientID)) {
                        $281a441cdcb2cf36$var$print($281a441cdcb2cf36$var$ORANGE, $281a441cdcb2cf36$var$BOLD, "[yjs] ", $281a441cdcb2cf36$var$UNBOLD, $281a441cdcb2cf36$var$RED, "Changed the client-id because another client seems to be using it.");
                        doc2.clientID = $281a441cdcb2cf36$var$generateNewClientId();
                    }
                    doc2.emit("afterTransactionCleanup", [
                        transaction,
                        doc2
                    ]);
                    if (doc2._observers.has("update")) {
                        const encoder = new $281a441cdcb2cf36$var$UpdateEncoderV1();
                        const hasContent2 = $281a441cdcb2cf36$var$writeUpdateMessageFromTransaction(encoder, transaction);
                        if (hasContent2) doc2.emit("update", [
                            encoder.toUint8Array(),
                            transaction.origin,
                            doc2,
                            transaction
                        ]);
                    }
                    if (doc2._observers.has("updateV2")) {
                        const encoder = new $281a441cdcb2cf36$var$UpdateEncoderV2();
                        const hasContent2 = $281a441cdcb2cf36$var$writeUpdateMessageFromTransaction(encoder, transaction);
                        if (hasContent2) doc2.emit("updateV2", [
                            encoder.toUint8Array(),
                            transaction.origin,
                            doc2,
                            transaction
                        ]);
                    }
                    const { subdocsAdded: subdocsAdded, subdocsLoaded: subdocsLoaded, subdocsRemoved: subdocsRemoved } = transaction;
                    if (subdocsAdded.size > 0 || subdocsRemoved.size > 0 || subdocsLoaded.size > 0) {
                        subdocsAdded.forEach((subdoc)=>{
                            subdoc.clientID = doc2.clientID;
                            if (subdoc.collectionid == null) subdoc.collectionid = doc2.collectionid;
                            doc2.subdocs.add(subdoc);
                        });
                        subdocsRemoved.forEach((subdoc)=>doc2.subdocs.delete(subdoc));
                        doc2.emit("subdocs", [
                            {
                                loaded: subdocsLoaded,
                                added: subdocsAdded,
                                removed: subdocsRemoved
                            },
                            doc2,
                            transaction
                        ]);
                        subdocsRemoved.forEach((subdoc)=>subdoc.destroy());
                    }
                    if (transactionCleanups.length <= i3 + 1) {
                        doc2._transactionCleanups = [];
                        doc2.emit("afterAllTransactions", [
                            doc2,
                            transactionCleanups
                        ]);
                    } else $281a441cdcb2cf36$var$cleanupTransactions(transactionCleanups, i3 + 1);
                }
            }
        };
        $281a441cdcb2cf36$var$transact = (doc2, f3, origin = null, local = true)=>{
            const transactionCleanups = doc2._transactionCleanups;
            let initialCall = false;
            let result = null;
            if (doc2._transaction === null) {
                initialCall = true;
                doc2._transaction = new $281a441cdcb2cf36$var$Transaction(doc2, origin, local);
                transactionCleanups.push(doc2._transaction);
                if (transactionCleanups.length === 1) doc2.emit("beforeAllTransactions", [
                    doc2
                ]);
                doc2.emit("beforeTransaction", [
                    doc2._transaction,
                    doc2
                ]);
            }
            try {
                result = f3(doc2._transaction);
            } finally{
                if (initialCall) {
                    const finishCleanup = doc2._transaction === transactionCleanups[0];
                    doc2._transaction = null;
                    if (finishCleanup) $281a441cdcb2cf36$var$cleanupTransactions(transactionCleanups, 0);
                }
            }
            return result;
        };
        $281a441cdcb2cf36$var$LazyStructReader = class {
            /**
       * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
       * @param {boolean} filterSkips
       */ constructor(decoder, filterSkips){
                this.gen = $281a441cdcb2cf36$var$lazyStructReaderGenerator(decoder);
                this.curr = null;
                this.done = false;
                this.filterSkips = filterSkips;
                this.next();
            }
            /**
       * @return {Item | GC | Skip |null}
       */ next() {
                do this.curr = this.gen.next().value || null;
                while (this.filterSkips && this.curr !== null && this.curr.constructor === $281a441cdcb2cf36$var$Skip);
                return this.curr;
            }
        };
        $281a441cdcb2cf36$var$LazyStructWriter = class {
            /**
       * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
       */ constructor(encoder){
                this.currClient = 0;
                this.startClock = 0;
                this.written = 0;
                this.encoder = encoder;
                this.clientStructs = [];
            }
        };
        $281a441cdcb2cf36$var$mergeUpdates = (updates)=>$281a441cdcb2cf36$var$mergeUpdatesV2(updates, $281a441cdcb2cf36$var$UpdateDecoderV1, $281a441cdcb2cf36$var$UpdateEncoderV1);
        $281a441cdcb2cf36$var$sliceStruct = (left, diff)=>{
            if (left.constructor === $281a441cdcb2cf36$var$GC) {
                const { client: client, clock: clock } = left.id;
                return new $281a441cdcb2cf36$var$GC($281a441cdcb2cf36$var$createID(client, clock + diff), left.length - diff);
            } else if (left.constructor === $281a441cdcb2cf36$var$Skip) {
                const { client: client, clock: clock } = left.id;
                return new $281a441cdcb2cf36$var$Skip($281a441cdcb2cf36$var$createID(client, clock + diff), left.length - diff);
            } else {
                const leftItem = /** @type {Item} */ left;
                const { client: client, clock: clock } = leftItem.id;
                return new $281a441cdcb2cf36$var$Item($281a441cdcb2cf36$var$createID(client, clock + diff), null, $281a441cdcb2cf36$var$createID(client, clock + diff - 1), null, leftItem.rightOrigin, leftItem.parent, leftItem.parentSub, leftItem.content.splice(diff));
            }
        };
        $281a441cdcb2cf36$var$mergeUpdatesV2 = (updates, YDecoder = $281a441cdcb2cf36$var$UpdateDecoderV2, YEncoder = $281a441cdcb2cf36$var$UpdateEncoderV2)=>{
            if (updates.length === 1) return updates[0];
            const updateDecoders = updates.map((update)=>new YDecoder($281a441cdcb2cf36$var$createDecoder(update)));
            let lazyStructDecoders = updateDecoders.map((decoder)=>new $281a441cdcb2cf36$var$LazyStructReader(decoder, true));
            let currWrite = null;
            const updateEncoder = new YEncoder();
            const lazyStructEncoder = new $281a441cdcb2cf36$var$LazyStructWriter(updateEncoder);
            while(true){
                lazyStructDecoders = lazyStructDecoders.filter((dec)=>dec.curr !== null);
                lazyStructDecoders.sort(/** @type {function(any,any):number} */ (dec1, dec2)=>{
                    if (dec1.curr.id.client === dec2.curr.id.client) {
                        const clockDiff = dec1.curr.id.clock - dec2.curr.id.clock;
                        if (clockDiff === 0) return dec1.curr.constructor === dec2.curr.constructor ? 0 : dec1.curr.constructor === $281a441cdcb2cf36$var$Skip ? 1 : -1;
                        else return clockDiff;
                    } else return dec2.curr.id.client - dec1.curr.id.client;
                });
                if (lazyStructDecoders.length === 0) break;
                const currDecoder = lazyStructDecoders[0];
                const firstClient = /** @type {Item | GC} */ currDecoder.curr.id.client;
                if (currWrite !== null) {
                    let curr = /** @type {Item | GC | null} */ currDecoder.curr;
                    let iterated = false;
                    while(curr !== null && curr.id.clock + curr.length <= currWrite.struct.id.clock + currWrite.struct.length && curr.id.client >= currWrite.struct.id.client){
                        curr = currDecoder.next();
                        iterated = true;
                    }
                    if (curr === null || // current decoder is empty
                    curr.id.client !== firstClient || // check whether there is another decoder that has has updates from `firstClient`
                    iterated && curr.id.clock > currWrite.struct.id.clock + currWrite.struct.length) continue;
                    if (firstClient !== currWrite.struct.id.client) {
                        $281a441cdcb2cf36$var$writeStructToLazyStructWriter(lazyStructEncoder, currWrite.struct, currWrite.offset);
                        currWrite = {
                            struct: curr,
                            offset: 0
                        };
                        currDecoder.next();
                    } else if (currWrite.struct.id.clock + currWrite.struct.length < curr.id.clock) {
                        if (currWrite.struct.constructor === $281a441cdcb2cf36$var$Skip) currWrite.struct.length = curr.id.clock + curr.length - currWrite.struct.id.clock;
                        else {
                            $281a441cdcb2cf36$var$writeStructToLazyStructWriter(lazyStructEncoder, currWrite.struct, currWrite.offset);
                            const diff = curr.id.clock - currWrite.struct.id.clock - currWrite.struct.length;
                            const struct = new $281a441cdcb2cf36$var$Skip($281a441cdcb2cf36$var$createID(firstClient, currWrite.struct.id.clock + currWrite.struct.length), diff);
                            currWrite = {
                                struct: struct,
                                offset: 0
                            };
                        }
                    } else {
                        const diff = currWrite.struct.id.clock + currWrite.struct.length - curr.id.clock;
                        if (diff > 0) {
                            if (currWrite.struct.constructor === $281a441cdcb2cf36$var$Skip) currWrite.struct.length -= diff;
                            else curr = $281a441cdcb2cf36$var$sliceStruct(curr, diff);
                        }
                        if (!currWrite.struct.mergeWith(/** @type {any} */ curr)) {
                            $281a441cdcb2cf36$var$writeStructToLazyStructWriter(lazyStructEncoder, currWrite.struct, currWrite.offset);
                            currWrite = {
                                struct: curr,
                                offset: 0
                            };
                            currDecoder.next();
                        }
                    }
                } else {
                    currWrite = {
                        struct: /** @type {Item | GC} */ currDecoder.curr,
                        offset: 0
                    };
                    currDecoder.next();
                }
                for(let next = currDecoder.curr; next !== null && next.id.client === firstClient && next.id.clock === currWrite.struct.id.clock + currWrite.struct.length && next.constructor !== $281a441cdcb2cf36$var$Skip; next = currDecoder.next()){
                    $281a441cdcb2cf36$var$writeStructToLazyStructWriter(lazyStructEncoder, currWrite.struct, currWrite.offset);
                    currWrite = {
                        struct: next,
                        offset: 0
                    };
                }
            }
            if (currWrite !== null) {
                $281a441cdcb2cf36$var$writeStructToLazyStructWriter(lazyStructEncoder, currWrite.struct, currWrite.offset);
                currWrite = null;
            }
            $281a441cdcb2cf36$var$finishLazyStructWriting(lazyStructEncoder);
            const dss = updateDecoders.map((decoder)=>$281a441cdcb2cf36$var$readDeleteSet(decoder));
            const ds = $281a441cdcb2cf36$var$mergeDeleteSets(dss);
            $281a441cdcb2cf36$var$writeDeleteSet(updateEncoder, ds);
            return updateEncoder.toUint8Array();
        };
        $281a441cdcb2cf36$var$diffUpdateV2 = (update, sv, YDecoder = $281a441cdcb2cf36$var$UpdateDecoderV2, YEncoder = $281a441cdcb2cf36$var$UpdateEncoderV2)=>{
            const state = $281a441cdcb2cf36$var$decodeStateVector(sv);
            const encoder = new YEncoder();
            const lazyStructWriter = new $281a441cdcb2cf36$var$LazyStructWriter(encoder);
            const decoder = new YDecoder($281a441cdcb2cf36$var$createDecoder(update));
            const reader = new $281a441cdcb2cf36$var$LazyStructReader(decoder, false);
            while(reader.curr){
                const curr = reader.curr;
                const currClient = curr.id.client;
                const svClock = state.get(currClient) || 0;
                if (reader.curr.constructor === $281a441cdcb2cf36$var$Skip) {
                    reader.next();
                    continue;
                }
                if (curr.id.clock + curr.length > svClock) {
                    $281a441cdcb2cf36$var$writeStructToLazyStructWriter(lazyStructWriter, curr, $281a441cdcb2cf36$var$max(svClock - curr.id.clock, 0));
                    reader.next();
                    while(reader.curr && reader.curr.id.client === currClient){
                        $281a441cdcb2cf36$var$writeStructToLazyStructWriter(lazyStructWriter, reader.curr, 0);
                        reader.next();
                    }
                } else while(reader.curr && reader.curr.id.client === currClient && reader.curr.id.clock + reader.curr.length <= svClock)reader.next();
            }
            $281a441cdcb2cf36$var$finishLazyStructWriting(lazyStructWriter);
            const ds = $281a441cdcb2cf36$var$readDeleteSet(decoder);
            $281a441cdcb2cf36$var$writeDeleteSet(encoder, ds);
            return encoder.toUint8Array();
        };
        $281a441cdcb2cf36$var$flushLazyStructWriter = (lazyWriter)=>{
            if (lazyWriter.written > 0) {
                lazyWriter.clientStructs.push({
                    written: lazyWriter.written,
                    restEncoder: $281a441cdcb2cf36$var$toUint8Array(lazyWriter.encoder.restEncoder)
                });
                lazyWriter.encoder.restEncoder = $281a441cdcb2cf36$var$createEncoder();
                lazyWriter.written = 0;
            }
        };
        $281a441cdcb2cf36$var$writeStructToLazyStructWriter = (lazyWriter, struct, offset2)=>{
            if (lazyWriter.written > 0 && lazyWriter.currClient !== struct.id.client) $281a441cdcb2cf36$var$flushLazyStructWriter(lazyWriter);
            if (lazyWriter.written === 0) {
                lazyWriter.currClient = struct.id.client;
                lazyWriter.encoder.writeClient(struct.id.client);
                $281a441cdcb2cf36$var$writeVarUint(lazyWriter.encoder.restEncoder, struct.id.clock + offset2);
            }
            struct.write(lazyWriter.encoder, offset2);
            lazyWriter.written++;
        };
        $281a441cdcb2cf36$var$finishLazyStructWriting = (lazyWriter)=>{
            $281a441cdcb2cf36$var$flushLazyStructWriter(lazyWriter);
            const restEncoder = lazyWriter.encoder.restEncoder;
            $281a441cdcb2cf36$var$writeVarUint(restEncoder, lazyWriter.clientStructs.length);
            for(let i3 = 0; i3 < lazyWriter.clientStructs.length; i3++){
                const partStructs = lazyWriter.clientStructs[i3];
                $281a441cdcb2cf36$var$writeVarUint(restEncoder, partStructs.written);
                $281a441cdcb2cf36$var$writeUint8Array(restEncoder, partStructs.restEncoder);
            }
        };
        $281a441cdcb2cf36$var$convertUpdateFormat = (update, blockTransformer, YDecoder, YEncoder)=>{
            const updateDecoder = new YDecoder($281a441cdcb2cf36$var$createDecoder(update));
            const lazyDecoder = new $281a441cdcb2cf36$var$LazyStructReader(updateDecoder, false);
            const updateEncoder = new YEncoder();
            const lazyWriter = new $281a441cdcb2cf36$var$LazyStructWriter(updateEncoder);
            for(let curr = lazyDecoder.curr; curr !== null; curr = lazyDecoder.next())$281a441cdcb2cf36$var$writeStructToLazyStructWriter(lazyWriter, blockTransformer(curr), 0);
            $281a441cdcb2cf36$var$finishLazyStructWriting(lazyWriter);
            const ds = $281a441cdcb2cf36$var$readDeleteSet(updateDecoder);
            $281a441cdcb2cf36$var$writeDeleteSet(updateEncoder, ds);
            return updateEncoder.toUint8Array();
        };
        $281a441cdcb2cf36$var$convertUpdateFormatV2ToV1 = (update)=>$281a441cdcb2cf36$var$convertUpdateFormat(update, $281a441cdcb2cf36$var$id, $281a441cdcb2cf36$var$UpdateDecoderV2, $281a441cdcb2cf36$var$UpdateEncoderV1);
        $281a441cdcb2cf36$var$errorComputeChanges = "You must not compute changes after the event-handler fired.";
        $281a441cdcb2cf36$var$YEvent = class {
            /**
       * @param {T} target The changed type.
       * @param {Transaction} transaction
       */ constructor(target, transaction){
                this.target = target;
                this.currentTarget = target;
                this.transaction = transaction;
                this._changes = null;
                this._keys = null;
                this._delta = null;
                this._path = null;
            }
            /**
       * Computes the path from `y` to the changed type.
       *
       * @todo v14 should standardize on path: Array<{parent, index}> because that is easier to work with.
       *
       * The following property holds:
       * @example
       *   let type = y
       *   event.path.forEach(dir => {
       *     type = type.get(dir)
       *   })
       *   type === event.target // => true
       */ get path() {
                return this._path || (this._path = $281a441cdcb2cf36$var$getPathTo(this.currentTarget, this.target));
            }
            /**
       * Check if a struct is deleted by this event.
       *
       * In contrast to change.deleted, this method also returns true if the struct was added and then deleted.
       *
       * @param {AbstractStruct} struct
       * @return {boolean}
       */ deletes(struct) {
                return $281a441cdcb2cf36$var$isDeleted(this.transaction.deleteSet, struct.id);
            }
            /**
       * @type {Map<string, { action: 'add' | 'update' | 'delete', oldValue: any }>}
       */ get keys() {
                if (this._keys === null) {
                    if (this.transaction.doc._transactionCleanups.length === 0) throw $281a441cdcb2cf36$var$create3($281a441cdcb2cf36$var$errorComputeChanges);
                    const keys2 = /* @__PURE__ */ new Map();
                    const target = this.target;
                    const changed = /** @type Set<string|null> */ this.transaction.changed.get(target);
                    changed.forEach((key)=>{
                        if (key !== null) {
                            const item = /** @type {Item} */ target._map.get(key);
                            let action;
                            let oldValue;
                            if (this.adds(item)) {
                                let prev = item.left;
                                while(prev !== null && this.adds(prev))prev = prev.left;
                                if (this.deletes(item)) {
                                    if (prev !== null && this.deletes(prev)) {
                                        action = "delete";
                                        oldValue = $281a441cdcb2cf36$var$last(prev.content.getContent());
                                    } else return;
                                } else if (prev !== null && this.deletes(prev)) {
                                    action = "update";
                                    oldValue = $281a441cdcb2cf36$var$last(prev.content.getContent());
                                } else {
                                    action = "add";
                                    oldValue = void 0;
                                }
                            } else {
                                if (this.deletes(item)) {
                                    action = "delete";
                                    oldValue = $281a441cdcb2cf36$var$last(/** @type {Item} */ item.content.getContent());
                                } else return;
                            }
                            keys2.set(key, {
                                action: action,
                                oldValue: oldValue
                            });
                        }
                    });
                    this._keys = keys2;
                }
                return this._keys;
            }
            /**
       * This is a computed property. Note that this can only be safely computed during the
       * event call. Computing this property after other changes happened might result in
       * unexpected behavior (incorrect computation of deltas). A safe way to collect changes
       * is to store the `changes` or the `delta` object. Avoid storing the `transaction` object.
       *
       * @type {Array<{insert?: string | Array<any> | object | AbstractType<any>, retain?: number, delete?: number, attributes?: Object<string, any>}>}
       */ get delta() {
                return this.changes.delta;
            }
            /**
       * Check if a struct is added by this event.
       *
       * In contrast to change.deleted, this method also returns true if the struct was added and then deleted.
       *
       * @param {AbstractStruct} struct
       * @return {boolean}
       */ adds(struct) {
                return struct.id.clock >= (this.transaction.beforeState.get(struct.id.client) || 0);
            }
            /**
       * This is a computed property. Note that this can only be safely computed during the
       * event call. Computing this property after other changes happened might result in
       * unexpected behavior (incorrect computation of deltas). A safe way to collect changes
       * is to store the `changes` or the `delta` object. Avoid storing the `transaction` object.
       *
       * @type {{added:Set<Item>,deleted:Set<Item>,keys:Map<string,{action:'add'|'update'|'delete',oldValue:any}>,delta:Array<{insert?:Array<any>|string, delete?:number, retain?:number}>}}
       */ get changes() {
                let changes = this._changes;
                if (changes === null) {
                    if (this.transaction.doc._transactionCleanups.length === 0) throw $281a441cdcb2cf36$var$create3($281a441cdcb2cf36$var$errorComputeChanges);
                    const target = this.target;
                    const added = $281a441cdcb2cf36$var$create2();
                    const deleted = $281a441cdcb2cf36$var$create2();
                    const delta = [];
                    changes = {
                        added: added,
                        deleted: deleted,
                        delta: delta,
                        keys: this.keys
                    };
                    const changed = /** @type Set<string|null> */ this.transaction.changed.get(target);
                    if (changed.has(null)) {
                        let lastOp = null;
                        const packOp = ()=>{
                            if (lastOp) delta.push(lastOp);
                        };
                        for(let item = target._start; item !== null; item = item.right){
                            if (item.deleted) {
                                if (this.deletes(item) && !this.adds(item)) {
                                    if (lastOp === null || lastOp.delete === void 0) {
                                        packOp();
                                        lastOp = {
                                            delete: 0
                                        };
                                    }
                                    lastOp.delete += item.length;
                                    deleted.add(item);
                                }
                            } else if (this.adds(item)) {
                                if (lastOp === null || lastOp.insert === void 0) {
                                    packOp();
                                    lastOp = {
                                        insert: []
                                    };
                                }
                                lastOp.insert = lastOp.insert.concat(item.content.getContent());
                                added.add(item);
                            } else {
                                if (lastOp === null || lastOp.retain === void 0) {
                                    packOp();
                                    lastOp = {
                                        retain: 0
                                    };
                                }
                                lastOp.retain += item.length;
                            }
                        }
                        if (lastOp !== null && lastOp.retain === void 0) packOp();
                    }
                    this._changes = changes;
                }
                return /** @type {any} */ changes;
            }
        };
        $281a441cdcb2cf36$var$getPathTo = (parent, child)=>{
            const path = [];
            while(child._item !== null && child !== parent){
                if (child._item.parentSub !== null) path.unshift(child._item.parentSub);
                else {
                    let i3 = 0;
                    let c3 = /** @type {AbstractType<any>} */ child._item.parent._start;
                    while(c3 !== child._item && c3 !== null){
                        if (!c3.deleted && c3.countable) i3 += c3.length;
                        c3 = c3.right;
                    }
                    path.unshift(i3);
                }
                child = /** @type {AbstractType<any>} */ child._item.parent;
            }
            return path;
        };
        $281a441cdcb2cf36$var$warnPrematureAccess = ()=>{
            $281a441cdcb2cf36$var$warn("Invalid access: Add Yjs type to a document before reading data.");
        };
        $281a441cdcb2cf36$var$maxSearchMarker = 80;
        $281a441cdcb2cf36$var$globalSearchMarkerTimestamp = 0;
        $281a441cdcb2cf36$var$ArraySearchMarker = class {
            /**
       * @param {Item} p
       * @param {number} index
       */ constructor(p3, index){
                p3.marker = true;
                this.p = p3;
                this.index = index;
                this.timestamp = $281a441cdcb2cf36$var$globalSearchMarkerTimestamp++;
            }
        };
        $281a441cdcb2cf36$var$refreshMarkerTimestamp = (marker)=>{
            marker.timestamp = $281a441cdcb2cf36$var$globalSearchMarkerTimestamp++;
        };
        $281a441cdcb2cf36$var$overwriteMarker = (marker, p3, index)=>{
            marker.p.marker = false;
            marker.p = p3;
            p3.marker = true;
            marker.index = index;
            marker.timestamp = $281a441cdcb2cf36$var$globalSearchMarkerTimestamp++;
        };
        $281a441cdcb2cf36$var$markPosition = (searchMarker, p3, index)=>{
            if (searchMarker.length >= $281a441cdcb2cf36$var$maxSearchMarker) {
                const marker = searchMarker.reduce((a3, b3)=>a3.timestamp < b3.timestamp ? a3 : b3);
                $281a441cdcb2cf36$var$overwriteMarker(marker, p3, index);
                return marker;
            } else {
                const pm = new $281a441cdcb2cf36$var$ArraySearchMarker(p3, index);
                searchMarker.push(pm);
                return pm;
            }
        };
        $281a441cdcb2cf36$var$findMarker = (yarray, index)=>{
            if (yarray._start === null || index === 0 || yarray._searchMarker === null) return null;
            const marker = yarray._searchMarker.length === 0 ? null : yarray._searchMarker.reduce((a3, b3)=>$281a441cdcb2cf36$var$abs(index - a3.index) < $281a441cdcb2cf36$var$abs(index - b3.index) ? a3 : b3);
            let p3 = yarray._start;
            let pindex = 0;
            if (marker !== null) {
                p3 = marker.p;
                pindex = marker.index;
                $281a441cdcb2cf36$var$refreshMarkerTimestamp(marker);
            }
            while(p3.right !== null && pindex < index){
                if (!p3.deleted && p3.countable) {
                    if (index < pindex + p3.length) break;
                    pindex += p3.length;
                }
                p3 = p3.right;
            }
            while(p3.left !== null && pindex > index){
                p3 = p3.left;
                if (!p3.deleted && p3.countable) pindex -= p3.length;
            }
            while(p3.left !== null && p3.left.id.client === p3.id.client && p3.left.id.clock + p3.left.length === p3.id.clock){
                p3 = p3.left;
                if (!p3.deleted && p3.countable) pindex -= p3.length;
            }
            if (marker !== null && $281a441cdcb2cf36$var$abs(marker.index - pindex) < /** @type {YText|YArray<any>} */ p3.parent.length / $281a441cdcb2cf36$var$maxSearchMarker) {
                $281a441cdcb2cf36$var$overwriteMarker(marker, p3, pindex);
                return marker;
            } else return $281a441cdcb2cf36$var$markPosition(yarray._searchMarker, p3, pindex);
        };
        $281a441cdcb2cf36$var$updateMarkerChanges = (searchMarker, index, len)=>{
            for(let i3 = searchMarker.length - 1; i3 >= 0; i3--){
                const m3 = searchMarker[i3];
                if (len > 0) {
                    let p3 = m3.p;
                    p3.marker = false;
                    while(p3 && (p3.deleted || !p3.countable)){
                        p3 = p3.left;
                        if (p3 && !p3.deleted && p3.countable) m3.index -= p3.length;
                    }
                    if (p3 === null || p3.marker === true) {
                        searchMarker.splice(i3, 1);
                        continue;
                    }
                    m3.p = p3;
                    p3.marker = true;
                }
                if (index < m3.index || len > 0 && index === m3.index) m3.index = $281a441cdcb2cf36$var$max(index, m3.index + len);
            }
        };
        $281a441cdcb2cf36$var$callTypeObservers = (type, transaction, event)=>{
            const changedType = type;
            const changedParentTypes = transaction.changedParentTypes;
            while(true){
                $281a441cdcb2cf36$var$setIfUndefined(changedParentTypes, type, ()=>[]).push(event);
                if (type._item === null) break;
                type = /** @type {AbstractType<any>} */ type._item.parent;
            }
            $281a441cdcb2cf36$var$callEventHandlerListeners(changedType._eH, event, transaction);
        };
        $281a441cdcb2cf36$var$AbstractType = class {
            constructor(){
                this._item = null;
                this._map = /* @__PURE__ */ new Map();
                this._start = null;
                this.doc = null;
                this._length = 0;
                this._eH = $281a441cdcb2cf36$var$createEventHandler();
                this._dEH = $281a441cdcb2cf36$var$createEventHandler();
                this._searchMarker = null;
            }
            /**
       * @return {AbstractType<any>|null}
       */ get parent() {
                return this._item ? /** @type {AbstractType<any>} */ this._item.parent : null;
            }
            /**
       * Integrate this type into the Yjs instance.
       *
       * * Save this struct in the os
       * * This type is sent to other client
       * * Observer functions are fired
       *
       * @param {Doc} y The Yjs instance
       * @param {Item|null} item
       */ _integrate(y3, item) {
                this.doc = y3;
                this._item = item;
            }
            /**
       * @return {AbstractType<EventType>}
       */ _copy() {
                throw $281a441cdcb2cf36$var$methodUnimplemented();
            }
            /**
       * Makes a copy of this data type that can be included somewhere else.
       *
       * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
       *
       * @return {AbstractType<EventType>}
       */ clone() {
                throw $281a441cdcb2cf36$var$methodUnimplemented();
            }
            /**
       * @param {UpdateEncoderV1 | UpdateEncoderV2} _encoder
       */ _write(_encoder) {}
            /**
       * The first non-deleted item
       */ get _first() {
                let n3 = this._start;
                while(n3 !== null && n3.deleted)n3 = n3.right;
                return n3;
            }
            /**
       * Creates YEvent and calls all type observers.
       * Must be implemented by each type.
       *
       * @param {Transaction} transaction
       * @param {Set<null|string>} _parentSubs Keys changed on this type. `null` if list was modified.
       */ _callObserver(transaction, _parentSubs) {
                if (!transaction.local && this._searchMarker) this._searchMarker.length = 0;
            }
            /**
       * Observe all events that are created on this type.
       *
       * @param {function(EventType, Transaction):void} f Observer function
       */ observe(f3) {
                $281a441cdcb2cf36$var$addEventHandlerListener(this._eH, f3);
            }
            /**
       * Observe all events that are created by this type and its children.
       *
       * @param {function(Array<YEvent<any>>,Transaction):void} f Observer function
       */ observeDeep(f3) {
                $281a441cdcb2cf36$var$addEventHandlerListener(this._dEH, f3);
            }
            /**
       * Unregister an observer function.
       *
       * @param {function(EventType,Transaction):void} f Observer function
       */ unobserve(f3) {
                $281a441cdcb2cf36$var$removeEventHandlerListener(this._eH, f3);
            }
            /**
       * Unregister an observer function.
       *
       * @param {function(Array<YEvent<any>>,Transaction):void} f Observer function
       */ unobserveDeep(f3) {
                $281a441cdcb2cf36$var$removeEventHandlerListener(this._dEH, f3);
            }
            /**
       * @abstract
       * @return {any}
       */ toJSON() {}
        };
        $281a441cdcb2cf36$var$typeListSlice = (type, start, end)=>{
            var _a2;
            (_a2 = type.doc) != null ? _a2 : $281a441cdcb2cf36$var$warnPrematureAccess();
            if (start < 0) start = type._length + start;
            if (end < 0) end = type._length + end;
            let len = end - start;
            const cs = [];
            let n3 = type._start;
            while(n3 !== null && len > 0){
                if (n3.countable && !n3.deleted) {
                    const c3 = n3.content.getContent();
                    if (c3.length <= start) start -= c3.length;
                    else {
                        for(let i3 = start; i3 < c3.length && len > 0; i3++){
                            cs.push(c3[i3]);
                            len--;
                        }
                        start = 0;
                    }
                }
                n3 = n3.right;
            }
            return cs;
        };
        $281a441cdcb2cf36$var$typeListToArray = (type)=>{
            var _a2;
            (_a2 = type.doc) != null ? _a2 : $281a441cdcb2cf36$var$warnPrematureAccess();
            const cs = [];
            let n3 = type._start;
            while(n3 !== null){
                if (n3.countable && !n3.deleted) {
                    const c3 = n3.content.getContent();
                    for(let i3 = 0; i3 < c3.length; i3++)cs.push(c3[i3]);
                }
                n3 = n3.right;
            }
            return cs;
        };
        $281a441cdcb2cf36$var$typeListForEach = (type, f3)=>{
            var _a2;
            let index = 0;
            let n3 = type._start;
            (_a2 = type.doc) != null ? _a2 : $281a441cdcb2cf36$var$warnPrematureAccess();
            while(n3 !== null){
                if (n3.countable && !n3.deleted) {
                    const c3 = n3.content.getContent();
                    for(let i3 = 0; i3 < c3.length; i3++)f3(c3[i3], index++, type);
                }
                n3 = n3.right;
            }
        };
        $281a441cdcb2cf36$var$typeListMap = (type, f3)=>{
            const result = [];
            $281a441cdcb2cf36$var$typeListForEach(type, (c3, i3)=>{
                result.push(f3(c3, i3, type));
            });
            return result;
        };
        $281a441cdcb2cf36$var$typeListCreateIterator = (type)=>{
            let n3 = type._start;
            let currentContent = null;
            let currentContentIndex = 0;
            return {
                [Symbol.iterator] () {
                    return this;
                },
                next: ()=>{
                    if (currentContent === null) {
                        while(n3 !== null && n3.deleted)n3 = n3.right;
                        if (n3 === null) return {
                            done: true,
                            value: void 0
                        };
                        currentContent = n3.content.getContent();
                        currentContentIndex = 0;
                        n3 = n3.right;
                    }
                    const value2 = currentContent[currentContentIndex++];
                    if (currentContent.length <= currentContentIndex) currentContent = null;
                    return {
                        done: false,
                        value: value2
                    };
                }
            };
        };
        $281a441cdcb2cf36$var$typeListGet = (type, index)=>{
            var _a2;
            (_a2 = type.doc) != null ? _a2 : $281a441cdcb2cf36$var$warnPrematureAccess();
            const marker = $281a441cdcb2cf36$var$findMarker(type, index);
            let n3 = type._start;
            if (marker !== null) {
                n3 = marker.p;
                index -= marker.index;
            }
            for(; n3 !== null; n3 = n3.right)if (!n3.deleted && n3.countable) {
                if (index < n3.length) return n3.content.getContent()[index];
                index -= n3.length;
            }
        };
        $281a441cdcb2cf36$var$typeListInsertGenericsAfter = (transaction, parent, referenceItem, content)=>{
            let left = referenceItem;
            const doc2 = transaction.doc;
            const ownClientId = doc2.clientID;
            const store = doc2.store;
            const right = referenceItem === null ? parent._start : referenceItem.right;
            let jsonContent = [];
            const packJsonContent = ()=>{
                if (jsonContent.length > 0) {
                    left = new $281a441cdcb2cf36$var$Item($281a441cdcb2cf36$var$createID(ownClientId, $281a441cdcb2cf36$var$getState(store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new $281a441cdcb2cf36$var$ContentAny(jsonContent));
                    left.integrate(transaction, 0);
                    jsonContent = [];
                }
            };
            content.forEach((c3)=>{
                if (c3 === null) jsonContent.push(c3);
                else switch(c3.constructor){
                    case Number:
                    case Object:
                    case Boolean:
                    case Array:
                    case String:
                        jsonContent.push(c3);
                        break;
                    default:
                        packJsonContent();
                        switch(c3.constructor){
                            case Uint8Array:
                            case ArrayBuffer:
                                left = new $281a441cdcb2cf36$var$Item($281a441cdcb2cf36$var$createID(ownClientId, $281a441cdcb2cf36$var$getState(store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new $281a441cdcb2cf36$var$ContentBinary(new Uint8Array(/** @type {Uint8Array} */ c3)));
                                left.integrate(transaction, 0);
                                break;
                            case $281a441cdcb2cf36$var$Doc:
                                left = new $281a441cdcb2cf36$var$Item($281a441cdcb2cf36$var$createID(ownClientId, $281a441cdcb2cf36$var$getState(store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new $281a441cdcb2cf36$var$ContentDoc(/** @type {Doc} */ c3));
                                left.integrate(transaction, 0);
                                break;
                            default:
                                if (c3 instanceof $281a441cdcb2cf36$var$AbstractType) {
                                    left = new $281a441cdcb2cf36$var$Item($281a441cdcb2cf36$var$createID(ownClientId, $281a441cdcb2cf36$var$getState(store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new $281a441cdcb2cf36$var$ContentType(c3));
                                    left.integrate(transaction, 0);
                                } else throw new Error("Unexpected content type in insert operation");
                        }
                }
            });
            packJsonContent();
        };
        $281a441cdcb2cf36$var$lengthExceeded = ()=>$281a441cdcb2cf36$var$create3("Length exceeded!");
        $281a441cdcb2cf36$var$typeListInsertGenerics = (transaction, parent, index, content)=>{
            if (index > parent._length) throw $281a441cdcb2cf36$var$lengthExceeded();
            if (index === 0) {
                if (parent._searchMarker) $281a441cdcb2cf36$var$updateMarkerChanges(parent._searchMarker, index, content.length);
                return $281a441cdcb2cf36$var$typeListInsertGenericsAfter(transaction, parent, null, content);
            }
            const startIndex = index;
            const marker = $281a441cdcb2cf36$var$findMarker(parent, index);
            let n3 = parent._start;
            if (marker !== null) {
                n3 = marker.p;
                index -= marker.index;
                if (index === 0) {
                    n3 = n3.prev;
                    index += n3 && n3.countable && !n3.deleted ? n3.length : 0;
                }
            }
            for(; n3 !== null; n3 = n3.right)if (!n3.deleted && n3.countable) {
                if (index <= n3.length) {
                    if (index < n3.length) $281a441cdcb2cf36$var$getItemCleanStart(transaction, $281a441cdcb2cf36$var$createID(n3.id.client, n3.id.clock + index));
                    break;
                }
                index -= n3.length;
            }
            if (parent._searchMarker) $281a441cdcb2cf36$var$updateMarkerChanges(parent._searchMarker, startIndex, content.length);
            return $281a441cdcb2cf36$var$typeListInsertGenericsAfter(transaction, parent, n3, content);
        };
        $281a441cdcb2cf36$var$typeListPushGenerics = (transaction, parent, content)=>{
            const marker = (parent._searchMarker || []).reduce((maxMarker, currMarker)=>currMarker.index > maxMarker.index ? currMarker : maxMarker, {
                index: 0,
                p: parent._start
            });
            let n3 = marker.p;
            if (n3) while(n3.right)n3 = n3.right;
            return $281a441cdcb2cf36$var$typeListInsertGenericsAfter(transaction, parent, n3, content);
        };
        $281a441cdcb2cf36$var$typeListDelete = (transaction, parent, index, length2)=>{
            if (length2 === 0) return;
            const startIndex = index;
            const startLength = length2;
            const marker = $281a441cdcb2cf36$var$findMarker(parent, index);
            let n3 = parent._start;
            if (marker !== null) {
                n3 = marker.p;
                index -= marker.index;
            }
            for(; n3 !== null && index > 0; n3 = n3.right)if (!n3.deleted && n3.countable) {
                if (index < n3.length) $281a441cdcb2cf36$var$getItemCleanStart(transaction, $281a441cdcb2cf36$var$createID(n3.id.client, n3.id.clock + index));
                index -= n3.length;
            }
            while(length2 > 0 && n3 !== null){
                if (!n3.deleted) {
                    if (length2 < n3.length) $281a441cdcb2cf36$var$getItemCleanStart(transaction, $281a441cdcb2cf36$var$createID(n3.id.client, n3.id.clock + length2));
                    n3.delete(transaction);
                    length2 -= n3.length;
                }
                n3 = n3.right;
            }
            if (length2 > 0) throw $281a441cdcb2cf36$var$lengthExceeded();
            if (parent._searchMarker) $281a441cdcb2cf36$var$updateMarkerChanges(parent._searchMarker, startIndex, -startLength + length2);
        };
        $281a441cdcb2cf36$var$typeMapDelete = (transaction, parent, key)=>{
            const c3 = parent._map.get(key);
            if (c3 !== void 0) c3.delete(transaction);
        };
        $281a441cdcb2cf36$var$typeMapSet = (transaction, parent, key, value2)=>{
            const left = parent._map.get(key) || null;
            const doc2 = transaction.doc;
            const ownClientId = doc2.clientID;
            let content;
            if (value2 == null) content = new $281a441cdcb2cf36$var$ContentAny([
                value2
            ]);
            else switch(value2.constructor){
                case Number:
                case Object:
                case Boolean:
                case Array:
                case String:
                case Date:
                case BigInt:
                    content = new $281a441cdcb2cf36$var$ContentAny([
                        value2
                    ]);
                    break;
                case Uint8Array:
                    content = new $281a441cdcb2cf36$var$ContentBinary(/** @type {Uint8Array} */ value2);
                    break;
                case $281a441cdcb2cf36$var$Doc:
                    content = new $281a441cdcb2cf36$var$ContentDoc(/** @type {Doc} */ value2);
                    break;
                default:
                    if (value2 instanceof $281a441cdcb2cf36$var$AbstractType) content = new $281a441cdcb2cf36$var$ContentType(value2);
                    else throw new Error("Unexpected content type");
            }
            new $281a441cdcb2cf36$var$Item($281a441cdcb2cf36$var$createID(ownClientId, $281a441cdcb2cf36$var$getState(doc2.store, ownClientId)), left, left && left.lastId, null, null, parent, key, content).integrate(transaction, 0);
        };
        $281a441cdcb2cf36$var$typeMapGet = (parent, key)=>{
            var _a2;
            (_a2 = parent.doc) != null ? _a2 : $281a441cdcb2cf36$var$warnPrematureAccess();
            const val = parent._map.get(key);
            return val !== void 0 && !val.deleted ? val.content.getContent()[val.length - 1] : void 0;
        };
        $281a441cdcb2cf36$var$typeMapGetAll = (parent)=>{
            var _a2;
            const res = {};
            (_a2 = parent.doc) != null ? _a2 : $281a441cdcb2cf36$var$warnPrematureAccess();
            parent._map.forEach((value2, key)=>{
                if (!value2.deleted) res[key] = value2.content.getContent()[value2.length - 1];
            });
            return res;
        };
        $281a441cdcb2cf36$var$typeMapHas = (parent, key)=>{
            var _a2;
            (_a2 = parent.doc) != null ? _a2 : $281a441cdcb2cf36$var$warnPrematureAccess();
            const val = parent._map.get(key);
            return val !== void 0 && !val.deleted;
        };
        $281a441cdcb2cf36$var$typeMapGetAllSnapshot = (parent, snapshot)=>{
            const res = {};
            parent._map.forEach((value2, key)=>{
                let v3 = value2;
                while(v3 !== null && (!snapshot.sv.has(v3.id.client) || v3.id.clock >= (snapshot.sv.get(v3.id.client) || 0)))v3 = v3.left;
                if (v3 !== null && $281a441cdcb2cf36$var$isVisible(v3, snapshot)) res[key] = v3.content.getContent()[v3.length - 1];
            });
            return res;
        };
        $281a441cdcb2cf36$var$createMapIterator = (type)=>{
            var _a2;
            (_a2 = type.doc) != null ? _a2 : $281a441cdcb2cf36$var$warnPrematureAccess();
            return $281a441cdcb2cf36$var$iteratorFilter(type._map.entries(), /** @param {any} entry */ (entry)=>!entry[1].deleted);
        };
        $281a441cdcb2cf36$var$YArrayEvent = class extends $281a441cdcb2cf36$var$YEvent {
        };
        $281a441cdcb2cf36$var$YArray = class _YArray extends $281a441cdcb2cf36$var$AbstractType {
            constructor(){
                super();
                this._prelimContent = [];
                this._searchMarker = [];
            }
            /**
       * Construct a new YArray containing the specified items.
       * @template {Object<string,any>|Array<any>|number|null|string|Uint8Array} T
       * @param {Array<T>} items
       * @return {YArray<T>}
       */ static from(items) {
                const a3 = new _YArray();
                a3.push(items);
                return a3;
            }
            /**
       * Integrate this type into the Yjs instance.
       *
       * * Save this struct in the os
       * * This type is sent to other client
       * * Observer functions are fired
       *
       * @param {Doc} y The Yjs instance
       * @param {Item} item
       */ _integrate(y3, item) {
                super._integrate(y3, item);
                this.insert(0, /** @type {Array<any>} */ this._prelimContent);
                this._prelimContent = null;
            }
            /**
       * @return {YArray<T>}
       */ _copy() {
                return new _YArray();
            }
            /**
       * Makes a copy of this data type that can be included somewhere else.
       *
       * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
       *
       * @return {YArray<T>}
       */ clone() {
                const arr = new _YArray();
                arr.insert(0, this.toArray().map((el)=>el instanceof $281a441cdcb2cf36$var$AbstractType ? /** @type {typeof el} */ el.clone() : el));
                return arr;
            }
            get length() {
                var _a2;
                (_a2 = this.doc) != null ? _a2 : $281a441cdcb2cf36$var$warnPrematureAccess();
                return this._length;
            }
            /**
       * Creates YArrayEvent and calls observers.
       *
       * @param {Transaction} transaction
       * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
       */ _callObserver(transaction, parentSubs) {
                super._callObserver(transaction, parentSubs);
                $281a441cdcb2cf36$var$callTypeObservers(this, transaction, new $281a441cdcb2cf36$var$YArrayEvent(this, transaction));
            }
            /**
       * Inserts new content at an index.
       *
       * Important: This function expects an array of content. Not just a content
       * object. The reason for this "weirdness" is that inserting several elements
       * is very efficient when it is done as a single operation.
       *
       * @example
       *  // Insert character 'a' at position 0
       *  yarray.insert(0, ['a'])
       *  // Insert numbers 1, 2 at position 1
       *  yarray.insert(1, [1, 2])
       *
       * @param {number} index The index to insert content at.
       * @param {Array<T>} content The array of content
       */ insert(index, content) {
                if (this.doc !== null) $281a441cdcb2cf36$var$transact(this.doc, (transaction)=>{
                    $281a441cdcb2cf36$var$typeListInsertGenerics(transaction, this, index, /** @type {any} */ content);
                });
                else this._prelimContent.splice(index, 0, ...content);
            }
            /**
       * Appends content to this YArray.
       *
       * @param {Array<T>} content Array of content to append.
       *
       * @todo Use the following implementation in all types.
       */ push(content) {
                if (this.doc !== null) $281a441cdcb2cf36$var$transact(this.doc, (transaction)=>{
                    $281a441cdcb2cf36$var$typeListPushGenerics(transaction, this, /** @type {any} */ content);
                });
                else this._prelimContent.push(...content);
            }
            /**
       * Prepends content to this YArray.
       *
       * @param {Array<T>} content Array of content to prepend.
       */ unshift(content) {
                this.insert(0, content);
            }
            /**
       * Deletes elements starting from an index.
       *
       * @param {number} index Index at which to start deleting elements
       * @param {number} length The number of elements to remove. Defaults to 1.
       */ delete(index, length2 = 1) {
                if (this.doc !== null) $281a441cdcb2cf36$var$transact(this.doc, (transaction)=>{
                    $281a441cdcb2cf36$var$typeListDelete(transaction, this, index, length2);
                });
                else this._prelimContent.splice(index, length2);
            }
            /**
       * Returns the i-th element from a YArray.
       *
       * @param {number} index The index of the element to return from the YArray
       * @return {T}
       */ get(index) {
                return $281a441cdcb2cf36$var$typeListGet(this, index);
            }
            /**
       * Transforms this YArray to a JavaScript Array.
       *
       * @return {Array<T>}
       */ toArray() {
                return $281a441cdcb2cf36$var$typeListToArray(this);
            }
            /**
       * Returns a portion of this YArray into a JavaScript Array selected
       * from start to end (end not included).
       *
       * @param {number} [start]
       * @param {number} [end]
       * @return {Array<T>}
       */ slice(start = 0, end = this.length) {
                return $281a441cdcb2cf36$var$typeListSlice(this, start, end);
            }
            /**
       * Transforms this Shared Type to a JSON object.
       *
       * @return {Array<any>}
       */ toJSON() {
                return this.map((c3)=>c3 instanceof $281a441cdcb2cf36$var$AbstractType ? c3.toJSON() : c3);
            }
            /**
       * Returns an Array with the result of calling a provided function on every
       * element of this YArray.
       *
       * @template M
       * @param {function(T,number,YArray<T>):M} f Function that produces an element of the new Array
       * @return {Array<M>} A new array with each element being the result of the
       *                 callback function
       */ map(f3) {
                return $281a441cdcb2cf36$var$typeListMap(this, /** @type {any} */ f3);
            }
            /**
       * Executes a provided function once on every element of this YArray.
       *
       * @param {function(T,number,YArray<T>):void} f A function to execute on every element of this YArray.
       */ forEach(f3) {
                $281a441cdcb2cf36$var$typeListForEach(this, f3);
            }
            /**
       * @return {IterableIterator<T>}
       */ [Symbol.iterator]() {
                return $281a441cdcb2cf36$var$typeListCreateIterator(this);
            }
            /**
       * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
       */ _write(encoder) {
                encoder.writeTypeRef($281a441cdcb2cf36$var$YArrayRefID);
            }
        };
        $281a441cdcb2cf36$var$readYArray = (_decoder)=>new $281a441cdcb2cf36$var$YArray();
        $281a441cdcb2cf36$var$YMapEvent = class extends $281a441cdcb2cf36$var$YEvent {
            /**
       * @param {YMap<T>} ymap The YArray that changed.
       * @param {Transaction} transaction
       * @param {Set<any>} subs The keys that changed.
       */ constructor(ymap, transaction, subs){
                super(ymap, transaction);
                this.keysChanged = subs;
            }
        };
        $281a441cdcb2cf36$var$YMap = class _YMap extends $281a441cdcb2cf36$var$AbstractType {
            /**
       *
       * @param {Iterable<readonly [string, any]>=} entries - an optional iterable to initialize the YMap
       */ constructor(entries){
                super();
                this._prelimContent = null;
                if (entries === void 0) this._prelimContent = /* @__PURE__ */ new Map();
                else this._prelimContent = new Map(entries);
            }
            /**
       * Integrate this type into the Yjs instance.
       *
       * * Save this struct in the os
       * * This type is sent to other client
       * * Observer functions are fired
       *
       * @param {Doc} y The Yjs instance
       * @param {Item} item
       */ _integrate(y3, item) {
                super._integrate(y3, item);
                this._prelimContent.forEach((value2, key)=>{
                    this.set(key, value2);
                });
                this._prelimContent = null;
            }
            /**
       * @return {YMap<MapType>}
       */ _copy() {
                return new _YMap();
            }
            /**
       * Makes a copy of this data type that can be included somewhere else.
       *
       * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
       *
       * @return {YMap<MapType>}
       */ clone() {
                const map2 = new _YMap();
                this.forEach((value2, key)=>{
                    map2.set(key, value2 instanceof $281a441cdcb2cf36$var$AbstractType ? /** @type {typeof value} */ value2.clone() : value2);
                });
                return map2;
            }
            /**
       * Creates YMapEvent and calls observers.
       *
       * @param {Transaction} transaction
       * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
       */ _callObserver(transaction, parentSubs) {
                $281a441cdcb2cf36$var$callTypeObservers(this, transaction, new $281a441cdcb2cf36$var$YMapEvent(this, transaction, parentSubs));
            }
            /**
       * Transforms this Shared Type to a JSON object.
       *
       * @return {Object<string,any>}
       */ toJSON() {
                var _a2;
                (_a2 = this.doc) != null ? _a2 : $281a441cdcb2cf36$var$warnPrematureAccess();
                const map2 = {};
                this._map.forEach((item, key)=>{
                    if (!item.deleted) {
                        const v3 = item.content.getContent()[item.length - 1];
                        map2[key] = v3 instanceof $281a441cdcb2cf36$var$AbstractType ? v3.toJSON() : v3;
                    }
                });
                return map2;
            }
            /**
       * Returns the size of the YMap (count of key/value pairs)
       *
       * @return {number}
       */ get size() {
                return [
                    ...$281a441cdcb2cf36$var$createMapIterator(this)
                ].length;
            }
            /**
       * Returns the keys for each element in the YMap Type.
       *
       * @return {IterableIterator<string>}
       */ keys() {
                return $281a441cdcb2cf36$var$iteratorMap($281a441cdcb2cf36$var$createMapIterator(this), /** @param {any} v */ (v3)=>v3[0]);
            }
            /**
       * Returns the values for each element in the YMap Type.
       *
       * @return {IterableIterator<MapType>}
       */ values() {
                return $281a441cdcb2cf36$var$iteratorMap($281a441cdcb2cf36$var$createMapIterator(this), /** @param {any} v */ (v3)=>v3[1].content.getContent()[v3[1].length - 1]);
            }
            /**
       * Returns an Iterator of [key, value] pairs
       *
       * @return {IterableIterator<[string, MapType]>}
       */ entries() {
                return $281a441cdcb2cf36$var$iteratorMap($281a441cdcb2cf36$var$createMapIterator(this), /** @param {any} v */ (v3)=>/** @type {any} */ [
                        v3[0],
                        v3[1].content.getContent()[v3[1].length - 1]
                    ]);
            }
            /**
       * Executes a provided function on once on every key-value pair.
       *
       * @param {function(MapType,string,YMap<MapType>):void} f A function to execute on every element of this YArray.
       */ forEach(f3) {
                var _a2;
                (_a2 = this.doc) != null ? _a2 : $281a441cdcb2cf36$var$warnPrematureAccess();
                this._map.forEach((item, key)=>{
                    if (!item.deleted) f3(item.content.getContent()[item.length - 1], key, this);
                });
            }
            /**
       * Returns an Iterator of [key, value] pairs
       *
       * @return {IterableIterator<[string, MapType]>}
       */ [Symbol.iterator]() {
                return this.entries();
            }
            /**
       * Remove a specified element from this YMap.
       *
       * @param {string} key The key of the element to remove.
       */ delete(key) {
                if (this.doc !== null) $281a441cdcb2cf36$var$transact(this.doc, (transaction)=>{
                    $281a441cdcb2cf36$var$typeMapDelete(transaction, this, key);
                });
                else this._prelimContent.delete(key);
            }
            /**
       * Adds or updates an element with a specified key and value.
       * @template {MapType} VAL
       *
       * @param {string} key The key of the element to add to this YMap
       * @param {VAL} value The value of the element to add
       * @return {VAL}
       */ set(key, value2) {
                if (this.doc !== null) $281a441cdcb2cf36$var$transact(this.doc, (transaction)=>{
                    $281a441cdcb2cf36$var$typeMapSet(transaction, this, key, /** @type {any} */ value2);
                });
                else this._prelimContent.set(key, value2);
                return value2;
            }
            /**
       * Returns a specified element from this YMap.
       *
       * @param {string} key
       * @return {MapType|undefined}
       */ get(key) {
                return /** @type {any} */ $281a441cdcb2cf36$var$typeMapGet(this, key);
            }
            /**
       * Returns a boolean indicating whether the specified key exists or not.
       *
       * @param {string} key The key to test.
       * @return {boolean}
       */ has(key) {
                return $281a441cdcb2cf36$var$typeMapHas(this, key);
            }
            /**
       * Removes all elements from this YMap.
       */ clear() {
                if (this.doc !== null) $281a441cdcb2cf36$var$transact(this.doc, (transaction)=>{
                    this.forEach(function(_value, key, map2) {
                        $281a441cdcb2cf36$var$typeMapDelete(transaction, map2, key);
                    });
                });
                else this._prelimContent.clear();
            }
            /**
       * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
       */ _write(encoder) {
                encoder.writeTypeRef($281a441cdcb2cf36$var$YMapRefID);
            }
        };
        $281a441cdcb2cf36$var$readYMap = (_decoder)=>new $281a441cdcb2cf36$var$YMap();
        $281a441cdcb2cf36$var$equalAttrs = (a3, b3)=>a3 === b3 || typeof a3 === "object" && typeof b3 === "object" && a3 && b3 && $281a441cdcb2cf36$var$equalFlat(a3, b3);
        $281a441cdcb2cf36$var$ItemTextListPosition = class {
            /**
       * @param {Item|null} left
       * @param {Item|null} right
       * @param {number} index
       * @param {Map<string,any>} currentAttributes
       */ constructor(left, right, index, currentAttributes){
                this.left = left;
                this.right = right;
                this.index = index;
                this.currentAttributes = currentAttributes;
            }
            /**
       * Only call this if you know that this.right is defined
       */ forward() {
                if (this.right === null) $281a441cdcb2cf36$var$unexpectedCase();
                switch(this.right.content.constructor){
                    case $281a441cdcb2cf36$var$ContentFormat:
                        if (!this.right.deleted) $281a441cdcb2cf36$var$updateCurrentAttributes(this.currentAttributes, /** @type {ContentFormat} */ this.right.content);
                        break;
                    default:
                        if (!this.right.deleted) this.index += this.right.length;
                        break;
                }
                this.left = this.right;
                this.right = this.right.right;
            }
        };
        $281a441cdcb2cf36$var$findNextPosition = (transaction, pos, count2)=>{
            while(pos.right !== null && count2 > 0){
                switch(pos.right.content.constructor){
                    case $281a441cdcb2cf36$var$ContentFormat:
                        if (!pos.right.deleted) $281a441cdcb2cf36$var$updateCurrentAttributes(pos.currentAttributes, /** @type {ContentFormat} */ pos.right.content);
                        break;
                    default:
                        if (!pos.right.deleted) {
                            if (count2 < pos.right.length) $281a441cdcb2cf36$var$getItemCleanStart(transaction, $281a441cdcb2cf36$var$createID(pos.right.id.client, pos.right.id.clock + count2));
                            pos.index += pos.right.length;
                            count2 -= pos.right.length;
                        }
                        break;
                }
                pos.left = pos.right;
                pos.right = pos.right.right;
            }
            return pos;
        };
        $281a441cdcb2cf36$var$findPosition = (transaction, parent, index, useSearchMarker)=>{
            const currentAttributes = /* @__PURE__ */ new Map();
            const marker = useSearchMarker ? $281a441cdcb2cf36$var$findMarker(parent, index) : null;
            if (marker) {
                const pos = new $281a441cdcb2cf36$var$ItemTextListPosition(marker.p.left, marker.p, marker.index, currentAttributes);
                return $281a441cdcb2cf36$var$findNextPosition(transaction, pos, index - marker.index);
            } else {
                const pos = new $281a441cdcb2cf36$var$ItemTextListPosition(null, parent._start, 0, currentAttributes);
                return $281a441cdcb2cf36$var$findNextPosition(transaction, pos, index);
            }
        };
        $281a441cdcb2cf36$var$insertNegatedAttributes = (transaction, parent, currPos, negatedAttributes)=>{
            while(currPos.right !== null && (currPos.right.deleted === true || currPos.right.content.constructor === $281a441cdcb2cf36$var$ContentFormat && $281a441cdcb2cf36$var$equalAttrs(negatedAttributes.get(/** @type {ContentFormat} */ currPos.right.content.key), /** @type {ContentFormat} */ currPos.right.content.value))){
                if (!currPos.right.deleted) negatedAttributes.delete(/** @type {ContentFormat} */ currPos.right.content.key);
                currPos.forward();
            }
            const doc2 = transaction.doc;
            const ownClientId = doc2.clientID;
            negatedAttributes.forEach((val, key)=>{
                const left = currPos.left;
                const right = currPos.right;
                const nextFormat = new $281a441cdcb2cf36$var$Item($281a441cdcb2cf36$var$createID(ownClientId, $281a441cdcb2cf36$var$getState(doc2.store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new $281a441cdcb2cf36$var$ContentFormat(key, val));
                nextFormat.integrate(transaction, 0);
                currPos.right = nextFormat;
                currPos.forward();
            });
        };
        $281a441cdcb2cf36$var$updateCurrentAttributes = (currentAttributes, format)=>{
            const { key: key, value: value2 } = format;
            if (value2 === null) currentAttributes.delete(key);
            else currentAttributes.set(key, value2);
        };
        $281a441cdcb2cf36$var$minimizeAttributeChanges = (currPos, attributes)=>{
            var _a2;
            while(true){
                if (currPos.right === null) break;
                else if (currPos.right.deleted || currPos.right.content.constructor === $281a441cdcb2cf36$var$ContentFormat && $281a441cdcb2cf36$var$equalAttrs((_a2 = attributes[/** @type {ContentFormat} */ currPos.right.content.key]) != null ? _a2 : null, /** @type {ContentFormat} */ currPos.right.content.value)) ;
                else break;
                currPos.forward();
            }
        };
        $281a441cdcb2cf36$var$insertAttributes = (transaction, parent, currPos, attributes)=>{
            var _a2;
            const doc2 = transaction.doc;
            const ownClientId = doc2.clientID;
            const negatedAttributes = /* @__PURE__ */ new Map();
            for(const key in attributes){
                const val = attributes[key];
                const currentVal = (_a2 = currPos.currentAttributes.get(key)) != null ? _a2 : null;
                if (!$281a441cdcb2cf36$var$equalAttrs(currentVal, val)) {
                    negatedAttributes.set(key, currentVal);
                    const { left: left, right: right } = currPos;
                    currPos.right = new $281a441cdcb2cf36$var$Item($281a441cdcb2cf36$var$createID(ownClientId, $281a441cdcb2cf36$var$getState(doc2.store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new $281a441cdcb2cf36$var$ContentFormat(key, val));
                    currPos.right.integrate(transaction, 0);
                    currPos.forward();
                }
            }
            return negatedAttributes;
        };
        $281a441cdcb2cf36$var$insertText = (transaction, parent, currPos, text2, attributes)=>{
            currPos.currentAttributes.forEach((_val, key)=>{
                if (attributes[key] === void 0) attributes[key] = null;
            });
            const doc2 = transaction.doc;
            const ownClientId = doc2.clientID;
            $281a441cdcb2cf36$var$minimizeAttributeChanges(currPos, attributes);
            const negatedAttributes = $281a441cdcb2cf36$var$insertAttributes(transaction, parent, currPos, attributes);
            const content = text2.constructor === String ? new $281a441cdcb2cf36$var$ContentString(/** @type {string} */ text2) : text2 instanceof $281a441cdcb2cf36$var$AbstractType ? new $281a441cdcb2cf36$var$ContentType(text2) : new $281a441cdcb2cf36$var$ContentEmbed(text2);
            let { left: left, right: right, index: index } = currPos;
            if (parent._searchMarker) $281a441cdcb2cf36$var$updateMarkerChanges(parent._searchMarker, currPos.index, content.getLength());
            right = new $281a441cdcb2cf36$var$Item($281a441cdcb2cf36$var$createID(ownClientId, $281a441cdcb2cf36$var$getState(doc2.store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, content);
            right.integrate(transaction, 0);
            currPos.right = right;
            currPos.index = index;
            currPos.forward();
            $281a441cdcb2cf36$var$insertNegatedAttributes(transaction, parent, currPos, negatedAttributes);
        };
        $281a441cdcb2cf36$var$formatText = (transaction, parent, currPos, length2, attributes)=>{
            const doc2 = transaction.doc;
            const ownClientId = doc2.clientID;
            $281a441cdcb2cf36$var$minimizeAttributeChanges(currPos, attributes);
            const negatedAttributes = $281a441cdcb2cf36$var$insertAttributes(transaction, parent, currPos, attributes);
            iterationLoop: while(currPos.right !== null && (length2 > 0 || negatedAttributes.size > 0 && (currPos.right.deleted || currPos.right.content.constructor === $281a441cdcb2cf36$var$ContentFormat))){
                if (!currPos.right.deleted) switch(currPos.right.content.constructor){
                    case $281a441cdcb2cf36$var$ContentFormat:
                        {
                            const { key: key, value: value2 } = /** @type {ContentFormat} */ currPos.right.content;
                            const attr = attributes[key];
                            if (attr !== void 0) {
                                if ($281a441cdcb2cf36$var$equalAttrs(attr, value2)) negatedAttributes.delete(key);
                                else {
                                    if (length2 === 0) break iterationLoop;
                                    negatedAttributes.set(key, value2);
                                }
                                currPos.right.delete(transaction);
                            } else currPos.currentAttributes.set(key, value2);
                            break;
                        }
                    default:
                        if (length2 < currPos.right.length) $281a441cdcb2cf36$var$getItemCleanStart(transaction, $281a441cdcb2cf36$var$createID(currPos.right.id.client, currPos.right.id.clock + length2));
                        length2 -= currPos.right.length;
                        break;
                }
                currPos.forward();
            }
            if (length2 > 0) {
                let newlines = "";
                for(; length2 > 0; length2--)newlines += "\n";
                currPos.right = new $281a441cdcb2cf36$var$Item($281a441cdcb2cf36$var$createID(ownClientId, $281a441cdcb2cf36$var$getState(doc2.store, ownClientId)), currPos.left, currPos.left && currPos.left.lastId, currPos.right, currPos.right && currPos.right.id, parent, null, new $281a441cdcb2cf36$var$ContentString(newlines));
                currPos.right.integrate(transaction, 0);
                currPos.forward();
            }
            $281a441cdcb2cf36$var$insertNegatedAttributes(transaction, parent, currPos, negatedAttributes);
        };
        $281a441cdcb2cf36$var$cleanupFormattingGap = (transaction, start, curr, startAttributes, currAttributes)=>{
            var _a2, _b;
            let end = start;
            const endFormats = $281a441cdcb2cf36$var$create();
            while(end && (!end.countable || end.deleted)){
                if (!end.deleted && end.content.constructor === $281a441cdcb2cf36$var$ContentFormat) {
                    const cf = /** @type {ContentFormat} */ end.content;
                    endFormats.set(cf.key, cf);
                }
                end = end.right;
            }
            let cleanups = 0;
            let reachedCurr = false;
            while(start !== end){
                if (curr === start) reachedCurr = true;
                if (!start.deleted) {
                    const content = start.content;
                    switch(content.constructor){
                        case $281a441cdcb2cf36$var$ContentFormat:
                            {
                                const { key: key, value: value2 } = /** @type {ContentFormat} */ content;
                                const startAttrValue = (_a2 = startAttributes.get(key)) != null ? _a2 : null;
                                if (endFormats.get(key) !== content || startAttrValue === value2) {
                                    start.delete(transaction);
                                    cleanups++;
                                    if (!reachedCurr && ((_b = currAttributes.get(key)) != null ? _b : null) === value2 && startAttrValue !== value2) {
                                        if (startAttrValue === null) currAttributes.delete(key);
                                        else currAttributes.set(key, startAttrValue);
                                    }
                                }
                                if (!reachedCurr && !start.deleted) $281a441cdcb2cf36$var$updateCurrentAttributes(currAttributes, /** @type {ContentFormat} */ content);
                                break;
                            }
                    }
                }
                start = /** @type {Item} */ start.right;
            }
            return cleanups;
        };
        $281a441cdcb2cf36$var$cleanupContextlessFormattingGap = (transaction, item)=>{
            while(item && item.right && (item.right.deleted || !item.right.countable))item = item.right;
            const attrs = /* @__PURE__ */ new Set();
            while(item && (item.deleted || !item.countable)){
                if (!item.deleted && item.content.constructor === $281a441cdcb2cf36$var$ContentFormat) {
                    const key = /** @type {ContentFormat} */ item.content.key;
                    if (attrs.has(key)) item.delete(transaction);
                    else attrs.add(key);
                }
                item = item.left;
            }
        };
        $281a441cdcb2cf36$var$cleanupYTextFormatting = (type)=>{
            let res = 0;
            $281a441cdcb2cf36$var$transact(/** @type {Doc} */ type.doc, (transaction)=>{
                let start = /** @type {Item} */ type._start;
                let end = type._start;
                let startAttributes = $281a441cdcb2cf36$var$create();
                const currentAttributes = $281a441cdcb2cf36$var$copy(startAttributes);
                while(end){
                    if (end.deleted === false) switch(end.content.constructor){
                        case $281a441cdcb2cf36$var$ContentFormat:
                            $281a441cdcb2cf36$var$updateCurrentAttributes(currentAttributes, /** @type {ContentFormat} */ end.content);
                            break;
                        default:
                            res += $281a441cdcb2cf36$var$cleanupFormattingGap(transaction, start, end, startAttributes, currentAttributes);
                            startAttributes = $281a441cdcb2cf36$var$copy(currentAttributes);
                            start = end;
                            break;
                    }
                    end = end.right;
                }
            });
            return res;
        };
        $281a441cdcb2cf36$var$cleanupYTextAfterTransaction = (transaction)=>{
            const needFullCleanup = /* @__PURE__ */ new Set();
            const doc2 = transaction.doc;
            for (const [client, afterClock] of transaction.afterState.entries()){
                const clock = transaction.beforeState.get(client) || 0;
                if (afterClock === clock) continue;
                $281a441cdcb2cf36$var$iterateStructs(transaction, /** @type {Array<Item|GC>} */ doc2.store.clients.get(client), clock, afterClock, (item)=>{
                    if (!item.deleted && /** @type {Item} */ item.content.constructor === $281a441cdcb2cf36$var$ContentFormat && item.constructor !== $281a441cdcb2cf36$var$GC) needFullCleanup.add(/** @type {any} */ item.parent);
                });
            }
            $281a441cdcb2cf36$var$transact(doc2, (t4)=>{
                $281a441cdcb2cf36$var$iterateDeletedStructs(transaction, transaction.deleteSet, (item)=>{
                    if (item instanceof $281a441cdcb2cf36$var$GC || !/** @type {YText} */ item.parent._hasFormatting || needFullCleanup.has(/** @type {YText} */ item.parent)) return;
                    const parent = /** @type {YText} */ item.parent;
                    if (item.content.constructor === $281a441cdcb2cf36$var$ContentFormat) needFullCleanup.add(parent);
                    else $281a441cdcb2cf36$var$cleanupContextlessFormattingGap(t4, item);
                });
                for (const yText of needFullCleanup)$281a441cdcb2cf36$var$cleanupYTextFormatting(yText);
            });
        };
        $281a441cdcb2cf36$var$deleteText = (transaction, currPos, length2)=>{
            const startLength = length2;
            const startAttrs = $281a441cdcb2cf36$var$copy(currPos.currentAttributes);
            const start = currPos.right;
            while(length2 > 0 && currPos.right !== null){
                if (currPos.right.deleted === false) switch(currPos.right.content.constructor){
                    case $281a441cdcb2cf36$var$ContentType:
                    case $281a441cdcb2cf36$var$ContentEmbed:
                    case $281a441cdcb2cf36$var$ContentString:
                        if (length2 < currPos.right.length) $281a441cdcb2cf36$var$getItemCleanStart(transaction, $281a441cdcb2cf36$var$createID(currPos.right.id.client, currPos.right.id.clock + length2));
                        length2 -= currPos.right.length;
                        currPos.right.delete(transaction);
                        break;
                }
                currPos.forward();
            }
            if (start) $281a441cdcb2cf36$var$cleanupFormattingGap(transaction, start, currPos.right, startAttrs, currPos.currentAttributes);
            const parent = /** @type {AbstractType<any>} */ /** @type {Item} */ (currPos.left || currPos.right).parent;
            if (parent._searchMarker) $281a441cdcb2cf36$var$updateMarkerChanges(parent._searchMarker, currPos.index, -startLength + length2);
            return currPos;
        };
        $281a441cdcb2cf36$var$YTextEvent = class extends $281a441cdcb2cf36$var$YEvent {
            /**
       * @param {YText} ytext
       * @param {Transaction} transaction
       * @param {Set<any>} subs The keys that changed
       */ constructor(ytext, transaction, subs){
                super(ytext, transaction);
                this.childListChanged = false;
                this.keysChanged = /* @__PURE__ */ new Set();
                subs.forEach((sub)=>{
                    if (sub === null) this.childListChanged = true;
                    else this.keysChanged.add(sub);
                });
            }
            /**
       * @type {{added:Set<Item>,deleted:Set<Item>,keys:Map<string,{action:'add'|'update'|'delete',oldValue:any}>,delta:Array<{insert?:Array<any>|string, delete?:number, retain?:number}>}}
       */ get changes() {
                if (this._changes === null) {
                    const changes = {
                        keys: this.keys,
                        delta: this.delta,
                        added: /* @__PURE__ */ new Set(),
                        deleted: /* @__PURE__ */ new Set()
                    };
                    this._changes = changes;
                }
                return /** @type {any} */ this._changes;
            }
            /**
       * Compute the changes in the delta format.
       * A {@link https://quilljs.com/docs/delta/|Quill Delta}) that represents the changes on the document.
       *
       * @type {Array<{insert?:string|object|AbstractType<any>, delete?:number, retain?:number, attributes?: Object<string,any>}>}
       *
       * @public
       */ get delta() {
                if (this._delta === null) {
                    const y3 = /** @type {Doc} */ this.target.doc;
                    const delta = [];
                    $281a441cdcb2cf36$var$transact(y3, (transaction)=>{
                        var _a2, _b, _c;
                        const currentAttributes = /* @__PURE__ */ new Map();
                        const oldAttributes = /* @__PURE__ */ new Map();
                        let item = this.target._start;
                        let action = null;
                        const attributes = {};
                        let insert = "";
                        let retain = 0;
                        let deleteLen = 0;
                        const addOp = ()=>{
                            if (action !== null) {
                                let op = null;
                                switch(action){
                                    case "delete":
                                        if (deleteLen > 0) op = {
                                            delete: deleteLen
                                        };
                                        deleteLen = 0;
                                        break;
                                    case "insert":
                                        if (typeof insert === "object" || insert.length > 0) {
                                            op = {
                                                insert: insert
                                            };
                                            if (currentAttributes.size > 0) {
                                                op.attributes = {};
                                                currentAttributes.forEach((value2, key)=>{
                                                    if (value2 !== null) op.attributes[key] = value2;
                                                });
                                            }
                                        }
                                        insert = "";
                                        break;
                                    case "retain":
                                        if (retain > 0) {
                                            op = {
                                                retain: retain
                                            };
                                            if (!$281a441cdcb2cf36$var$isEmpty(attributes)) op.attributes = $281a441cdcb2cf36$var$assign({}, attributes);
                                        }
                                        retain = 0;
                                        break;
                                }
                                if (op) delta.push(op);
                                action = null;
                            }
                        };
                        while(item !== null){
                            switch(item.content.constructor){
                                case $281a441cdcb2cf36$var$ContentType:
                                case $281a441cdcb2cf36$var$ContentEmbed:
                                    if (this.adds(item)) {
                                        if (!this.deletes(item)) {
                                            addOp();
                                            action = "insert";
                                            insert = item.content.getContent()[0];
                                            addOp();
                                        }
                                    } else if (this.deletes(item)) {
                                        if (action !== "delete") {
                                            addOp();
                                            action = "delete";
                                        }
                                        deleteLen += 1;
                                    } else if (!item.deleted) {
                                        if (action !== "retain") {
                                            addOp();
                                            action = "retain";
                                        }
                                        retain += 1;
                                    }
                                    break;
                                case $281a441cdcb2cf36$var$ContentString:
                                    if (this.adds(item)) {
                                        if (!this.deletes(item)) {
                                            if (action !== "insert") {
                                                addOp();
                                                action = "insert";
                                            }
                                            insert += /** @type {ContentString} */ item.content.str;
                                        }
                                    } else if (this.deletes(item)) {
                                        if (action !== "delete") {
                                            addOp();
                                            action = "delete";
                                        }
                                        deleteLen += item.length;
                                    } else if (!item.deleted) {
                                        if (action !== "retain") {
                                            addOp();
                                            action = "retain";
                                        }
                                        retain += item.length;
                                    }
                                    break;
                                case $281a441cdcb2cf36$var$ContentFormat:
                                    {
                                        const { key: key, value: value2 } = /** @type {ContentFormat} */ item.content;
                                        if (this.adds(item)) {
                                            if (!this.deletes(item)) {
                                                const curVal = (_a2 = currentAttributes.get(key)) != null ? _a2 : null;
                                                if (!$281a441cdcb2cf36$var$equalAttrs(curVal, value2)) {
                                                    if (action === "retain") addOp();
                                                    if ($281a441cdcb2cf36$var$equalAttrs(value2, (_b = oldAttributes.get(key)) != null ? _b : null)) delete attributes[key];
                                                    else attributes[key] = value2;
                                                } else if (value2 !== null) item.delete(transaction);
                                            }
                                        } else if (this.deletes(item)) {
                                            oldAttributes.set(key, value2);
                                            const curVal = (_c = currentAttributes.get(key)) != null ? _c : null;
                                            if (!$281a441cdcb2cf36$var$equalAttrs(curVal, value2)) {
                                                if (action === "retain") addOp();
                                                attributes[key] = curVal;
                                            }
                                        } else if (!item.deleted) {
                                            oldAttributes.set(key, value2);
                                            const attr = attributes[key];
                                            if (attr !== void 0) {
                                                if (!$281a441cdcb2cf36$var$equalAttrs(attr, value2)) {
                                                    if (action === "retain") addOp();
                                                    if (value2 === null) delete attributes[key];
                                                    else attributes[key] = value2;
                                                } else if (attr !== null) item.delete(transaction);
                                            }
                                        }
                                        if (!item.deleted) {
                                            if (action === "insert") addOp();
                                            $281a441cdcb2cf36$var$updateCurrentAttributes(currentAttributes, /** @type {ContentFormat} */ item.content);
                                        }
                                        break;
                                    }
                            }
                            item = item.right;
                        }
                        addOp();
                        while(delta.length > 0){
                            const lastOp = delta[delta.length - 1];
                            if (lastOp.retain !== void 0 && lastOp.attributes === void 0) delta.pop();
                            else break;
                        }
                    });
                    this._delta = delta;
                }
                return /** @type {any} */ this._delta;
            }
        };
        $281a441cdcb2cf36$var$YText = class _YText extends $281a441cdcb2cf36$var$AbstractType {
            /**
       * @param {String} [string] The initial value of the YText.
       */ constructor(string){
                super();
                this._pending = string !== void 0 ? [
                    ()=>this.insert(0, string)
                ] : [];
                this._searchMarker = [];
                this._hasFormatting = false;
            }
            /**
       * Number of characters of this text type.
       *
       * @type {number}
       */ get length() {
                var _a2;
                (_a2 = this.doc) != null ? _a2 : $281a441cdcb2cf36$var$warnPrematureAccess();
                return this._length;
            }
            /**
       * @param {Doc} y
       * @param {Item} item
       */ _integrate(y3, item) {
                super._integrate(y3, item);
                try {
                    this._pending.forEach((f3)=>f3());
                } catch (e4) {
                    console.error(e4);
                }
                this._pending = null;
            }
            _copy() {
                return new _YText();
            }
            /**
       * Makes a copy of this data type that can be included somewhere else.
       *
       * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
       *
       * @return {YText}
       */ clone() {
                const text2 = new _YText();
                text2.applyDelta(this.toDelta());
                return text2;
            }
            /**
       * Creates YTextEvent and calls observers.
       *
       * @param {Transaction} transaction
       * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
       */ _callObserver(transaction, parentSubs) {
                super._callObserver(transaction, parentSubs);
                const event = new $281a441cdcb2cf36$var$YTextEvent(this, transaction, parentSubs);
                $281a441cdcb2cf36$var$callTypeObservers(this, transaction, event);
                if (!transaction.local && this._hasFormatting) transaction._needFormattingCleanup = true;
            }
            /**
       * Returns the unformatted string representation of this YText type.
       *
       * @public
       */ toString() {
                var _a2;
                (_a2 = this.doc) != null ? _a2 : $281a441cdcb2cf36$var$warnPrematureAccess();
                let str = "";
                let n3 = this._start;
                while(n3 !== null){
                    if (!n3.deleted && n3.countable && n3.content.constructor === $281a441cdcb2cf36$var$ContentString) str += /** @type {ContentString} */ n3.content.str;
                    n3 = n3.right;
                }
                return str;
            }
            /**
       * Returns the unformatted string representation of this YText type.
       *
       * @return {string}
       * @public
       */ toJSON() {
                return this.toString();
            }
            /**
       * Apply a {@link Delta} on this shared YText type.
       *
       * @param {Array<any>} delta The changes to apply on this element.
       * @param {object}  opts
       * @param {boolean} [opts.sanitize] Sanitize input delta. Removes ending newlines if set to true.
       *
       *
       * @public
       */ applyDelta(delta, { sanitize: sanitize = true } = {}) {
                if (this.doc !== null) $281a441cdcb2cf36$var$transact(this.doc, (transaction)=>{
                    const currPos = new $281a441cdcb2cf36$var$ItemTextListPosition(null, this._start, 0, /* @__PURE__ */ new Map());
                    for(let i3 = 0; i3 < delta.length; i3++){
                        const op = delta[i3];
                        if (op.insert !== void 0) {
                            const ins = !sanitize && typeof op.insert === "string" && i3 === delta.length - 1 && currPos.right === null && op.insert.slice(-1) === "\n" ? op.insert.slice(0, -1) : op.insert;
                            if (typeof ins !== "string" || ins.length > 0) $281a441cdcb2cf36$var$insertText(transaction, this, currPos, ins, op.attributes || {});
                        } else if (op.retain !== void 0) $281a441cdcb2cf36$var$formatText(transaction, this, currPos, op.retain, op.attributes || {});
                        else if (op.delete !== void 0) $281a441cdcb2cf36$var$deleteText(transaction, currPos, op.delete);
                    }
                });
                else this._pending.push(()=>this.applyDelta(delta));
            }
            /**
       * Returns the Delta representation of this YText type.
       *
       * @param {Snapshot} [snapshot]
       * @param {Snapshot} [prevSnapshot]
       * @param {function('removed' | 'added', ID):any} [computeYChange]
       * @return {any} The Delta representation of this type.
       *
       * @public
       */ toDelta(snapshot, prevSnapshot, computeYChange) {
                var _a2;
                (_a2 = this.doc) != null ? _a2 : $281a441cdcb2cf36$var$warnPrematureAccess();
                const ops = [];
                const currentAttributes = /* @__PURE__ */ new Map();
                const doc2 = /** @type {Doc} */ this.doc;
                let str = "";
                let n3 = this._start;
                function packStr() {
                    if (str.length > 0) {
                        const attributes = {};
                        let addAttributes = false;
                        currentAttributes.forEach((value2, key)=>{
                            addAttributes = true;
                            attributes[key] = value2;
                        });
                        const op = {
                            insert: str
                        };
                        if (addAttributes) op.attributes = attributes;
                        ops.push(op);
                        str = "";
                    }
                }
                const computeDelta = ()=>{
                    while(n3 !== null){
                        if ($281a441cdcb2cf36$var$isVisible(n3, snapshot) || prevSnapshot !== void 0 && $281a441cdcb2cf36$var$isVisible(n3, prevSnapshot)) switch(n3.content.constructor){
                            case $281a441cdcb2cf36$var$ContentString:
                                {
                                    const cur = currentAttributes.get("ychange");
                                    if (snapshot !== void 0 && !$281a441cdcb2cf36$var$isVisible(n3, snapshot)) {
                                        if (cur === void 0 || cur.user !== n3.id.client || cur.type !== "removed") {
                                            packStr();
                                            currentAttributes.set("ychange", computeYChange ? computeYChange("removed", n3.id) : {
                                                type: "removed"
                                            });
                                        }
                                    } else if (prevSnapshot !== void 0 && !$281a441cdcb2cf36$var$isVisible(n3, prevSnapshot)) {
                                        if (cur === void 0 || cur.user !== n3.id.client || cur.type !== "added") {
                                            packStr();
                                            currentAttributes.set("ychange", computeYChange ? computeYChange("added", n3.id) : {
                                                type: "added"
                                            });
                                        }
                                    } else if (cur !== void 0) {
                                        packStr();
                                        currentAttributes.delete("ychange");
                                    }
                                    str += /** @type {ContentString} */ n3.content.str;
                                    break;
                                }
                            case $281a441cdcb2cf36$var$ContentType:
                            case $281a441cdcb2cf36$var$ContentEmbed:
                                {
                                    packStr();
                                    const op = {
                                        insert: n3.content.getContent()[0]
                                    };
                                    if (currentAttributes.size > 0) {
                                        const attrs = /** @type {Object<string,any>} */ {};
                                        op.attributes = attrs;
                                        currentAttributes.forEach((value2, key)=>{
                                            attrs[key] = value2;
                                        });
                                    }
                                    ops.push(op);
                                    break;
                                }
                            case $281a441cdcb2cf36$var$ContentFormat:
                                if ($281a441cdcb2cf36$var$isVisible(n3, snapshot)) {
                                    packStr();
                                    $281a441cdcb2cf36$var$updateCurrentAttributes(currentAttributes, /** @type {ContentFormat} */ n3.content);
                                }
                                break;
                        }
                        n3 = n3.right;
                    }
                    packStr();
                };
                if (snapshot || prevSnapshot) $281a441cdcb2cf36$var$transact(doc2, (transaction)=>{
                    if (snapshot) $281a441cdcb2cf36$var$splitSnapshotAffectedStructs(transaction, snapshot);
                    if (prevSnapshot) $281a441cdcb2cf36$var$splitSnapshotAffectedStructs(transaction, prevSnapshot);
                    computeDelta();
                }, "cleanup");
                else computeDelta();
                return ops;
            }
            /**
       * Insert text at a given index.
       *
       * @param {number} index The index at which to start inserting.
       * @param {String} text The text to insert at the specified position.
       * @param {TextAttributes} [attributes] Optionally define some formatting
       *                                    information to apply on the inserted
       *                                    Text.
       * @public
       */ insert(index, text2, attributes) {
                if (text2.length <= 0) return;
                const y3 = this.doc;
                if (y3 !== null) $281a441cdcb2cf36$var$transact(y3, (transaction)=>{
                    const pos = $281a441cdcb2cf36$var$findPosition(transaction, this, index, !attributes);
                    if (!attributes) {
                        attributes = {};
                        pos.currentAttributes.forEach((v3, k3)=>{
                            attributes[k3] = v3;
                        });
                    }
                    $281a441cdcb2cf36$var$insertText(transaction, this, pos, text2, attributes);
                });
                else this._pending.push(()=>this.insert(index, text2, attributes));
            }
            /**
       * Inserts an embed at a index.
       *
       * @param {number} index The index to insert the embed at.
       * @param {Object | AbstractType<any>} embed The Object that represents the embed.
       * @param {TextAttributes} [attributes] Attribute information to apply on the
       *                                    embed
       *
       * @public
       */ insertEmbed(index, embed, attributes) {
                const y3 = this.doc;
                if (y3 !== null) $281a441cdcb2cf36$var$transact(y3, (transaction)=>{
                    const pos = $281a441cdcb2cf36$var$findPosition(transaction, this, index, !attributes);
                    $281a441cdcb2cf36$var$insertText(transaction, this, pos, embed, attributes || {});
                });
                else this._pending.push(()=>this.insertEmbed(index, embed, attributes || {}));
            }
            /**
       * Deletes text starting from an index.
       *
       * @param {number} index Index at which to start deleting.
       * @param {number} length The number of characters to remove. Defaults to 1.
       *
       * @public
       */ delete(index, length2) {
                if (length2 === 0) return;
                const y3 = this.doc;
                if (y3 !== null) $281a441cdcb2cf36$var$transact(y3, (transaction)=>{
                    $281a441cdcb2cf36$var$deleteText(transaction, $281a441cdcb2cf36$var$findPosition(transaction, this, index, true), length2);
                });
                else this._pending.push(()=>this.delete(index, length2));
            }
            /**
       * Assigns properties to a range of text.
       *
       * @param {number} index The position where to start formatting.
       * @param {number} length The amount of characters to assign properties to.
       * @param {TextAttributes} attributes Attribute information to apply on the
       *                                    text.
       *
       * @public
       */ format(index, length2, attributes) {
                if (length2 === 0) return;
                const y3 = this.doc;
                if (y3 !== null) $281a441cdcb2cf36$var$transact(y3, (transaction)=>{
                    const pos = $281a441cdcb2cf36$var$findPosition(transaction, this, index, false);
                    if (pos.right === null) return;
                    $281a441cdcb2cf36$var$formatText(transaction, this, pos, length2, attributes);
                });
                else this._pending.push(()=>this.format(index, length2, attributes));
            }
            /**
       * Removes an attribute.
       *
       * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
       *
       * @param {String} attributeName The attribute name that is to be removed.
       *
       * @public
       */ removeAttribute(attributeName) {
                if (this.doc !== null) $281a441cdcb2cf36$var$transact(this.doc, (transaction)=>{
                    $281a441cdcb2cf36$var$typeMapDelete(transaction, this, attributeName);
                });
                else this._pending.push(()=>this.removeAttribute(attributeName));
            }
            /**
       * Sets or updates an attribute.
       *
       * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
       *
       * @param {String} attributeName The attribute name that is to be set.
       * @param {any} attributeValue The attribute value that is to be set.
       *
       * @public
       */ setAttribute(attributeName, attributeValue) {
                if (this.doc !== null) $281a441cdcb2cf36$var$transact(this.doc, (transaction)=>{
                    $281a441cdcb2cf36$var$typeMapSet(transaction, this, attributeName, attributeValue);
                });
                else this._pending.push(()=>this.setAttribute(attributeName, attributeValue));
            }
            /**
       * Returns an attribute value that belongs to the attribute name.
       *
       * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
       *
       * @param {String} attributeName The attribute name that identifies the
       *                               queried value.
       * @return {any} The queried attribute value.
       *
       * @public
       */ getAttribute(attributeName) {
                return /** @type {any} */ $281a441cdcb2cf36$var$typeMapGet(this, attributeName);
            }
            /**
       * Returns all attribute name/value pairs in a JSON Object.
       *
       * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
       *
       * @return {Object<string, any>} A JSON Object that describes the attributes.
       *
       * @public
       */ getAttributes() {
                return $281a441cdcb2cf36$var$typeMapGetAll(this);
            }
            /**
       * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
       */ _write(encoder) {
                encoder.writeTypeRef($281a441cdcb2cf36$var$YTextRefID);
            }
        };
        $281a441cdcb2cf36$var$readYText = (_decoder)=>new $281a441cdcb2cf36$var$YText();
        $281a441cdcb2cf36$var$YXmlTreeWalker = class {
            /**
       * @param {YXmlFragment | YXmlElement} root
       * @param {function(AbstractType<any>):boolean} [f]
       */ constructor(root, f3 = ()=>true){
                var _a2;
                this._filter = f3;
                this._root = root;
                this._currentNode = /** @type {Item} */ root._start;
                this._firstCall = true;
                (_a2 = root.doc) != null ? _a2 : $281a441cdcb2cf36$var$warnPrematureAccess();
            }
            [Symbol.iterator]() {
                return this;
            }
            /**
       * Get the next node.
       *
       * @return {IteratorResult<YXmlElement|YXmlText|YXmlHook>} The next node.
       *
       * @public
       */ next() {
                let n3 = this._currentNode;
                let type = n3 && n3.content && /** @type {any} */ n3.content.type;
                if (n3 !== null && (!this._firstCall || n3.deleted || !this._filter(type))) do {
                    type = /** @type {any} */ n3.content.type;
                    if (!n3.deleted && (type.constructor === $281a441cdcb2cf36$var$YXmlElement || type.constructor === $281a441cdcb2cf36$var$YXmlFragment) && type._start !== null) n3 = type._start;
                    else while(n3 !== null){
                        const nxt = n3.next;
                        if (nxt !== null) {
                            n3 = nxt;
                            break;
                        } else if (n3.parent === this._root) n3 = null;
                        else n3 = /** @type {AbstractType<any>} */ n3.parent._item;
                    }
                }while (n3 !== null && (n3.deleted || !this._filter(/** @type {ContentType} */ n3.content.type)));
                this._firstCall = false;
                if (n3 === null) return {
                    value: void 0,
                    done: true
                };
                this._currentNode = n3;
                return {
                    value: /** @type {any} */ n3.content.type,
                    done: false
                };
            }
        };
        $281a441cdcb2cf36$var$YXmlFragment = class _YXmlFragment extends $281a441cdcb2cf36$var$AbstractType {
            constructor(){
                super();
                this._prelimContent = [];
            }
            /**
       * @type {YXmlElement|YXmlText|null}
       */ get firstChild() {
                const first = this._first;
                return first ? first.content.getContent()[0] : null;
            }
            /**
       * Integrate this type into the Yjs instance.
       *
       * * Save this struct in the os
       * * This type is sent to other client
       * * Observer functions are fired
       *
       * @param {Doc} y The Yjs instance
       * @param {Item} item
       */ _integrate(y3, item) {
                super._integrate(y3, item);
                this.insert(0, /** @type {Array<any>} */ this._prelimContent);
                this._prelimContent = null;
            }
            _copy() {
                return new _YXmlFragment();
            }
            /**
       * Makes a copy of this data type that can be included somewhere else.
       *
       * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
       *
       * @return {YXmlFragment}
       */ clone() {
                const el = new _YXmlFragment();
                el.insert(0, this.toArray().map((item)=>item instanceof $281a441cdcb2cf36$var$AbstractType ? item.clone() : item));
                return el;
            }
            get length() {
                var _a2;
                (_a2 = this.doc) != null ? _a2 : $281a441cdcb2cf36$var$warnPrematureAccess();
                return this._prelimContent === null ? this._length : this._prelimContent.length;
            }
            /**
       * Create a subtree of childNodes.
       *
       * @example
       * const walker = elem.createTreeWalker(dom => dom.nodeName === 'div')
       * for (let node in walker) {
       *   // `node` is a div node
       *   nop(node)
       * }
       *
       * @param {function(AbstractType<any>):boolean} filter Function that is called on each child element and
       *                          returns a Boolean indicating whether the child
       *                          is to be included in the subtree.
       * @return {YXmlTreeWalker} A subtree and a position within it.
       *
       * @public
       */ createTreeWalker(filter) {
                return new $281a441cdcb2cf36$var$YXmlTreeWalker(this, filter);
            }
            /**
       * Returns the first YXmlElement that matches the query.
       * Similar to DOM's {@link querySelector}.
       *
       * Query support:
       *   - tagname
       * TODO:
       *   - id
       *   - attribute
       *
       * @param {CSS_Selector} query The query on the children.
       * @return {YXmlElement|YXmlText|YXmlHook|null} The first element that matches the query or null.
       *
       * @public
       */ querySelector(query) {
                query = query.toUpperCase();
                const iterator = new $281a441cdcb2cf36$var$YXmlTreeWalker(this, (element2)=>element2.nodeName && element2.nodeName.toUpperCase() === query);
                const next = iterator.next();
                if (next.done) return null;
                else return next.value;
            }
            /**
       * Returns all YXmlElements that match the query.
       * Similar to Dom's {@link querySelectorAll}.
       *
       * @todo Does not yet support all queries. Currently only query by tagName.
       *
       * @param {CSS_Selector} query The query on the children
       * @return {Array<YXmlElement|YXmlText|YXmlHook|null>} The elements that match this query.
       *
       * @public
       */ querySelectorAll(query) {
                query = query.toUpperCase();
                return $281a441cdcb2cf36$var$from(new $281a441cdcb2cf36$var$YXmlTreeWalker(this, (element2)=>element2.nodeName && element2.nodeName.toUpperCase() === query));
            }
            /**
       * Creates YXmlEvent and calls observers.
       *
       * @param {Transaction} transaction
       * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
       */ _callObserver(transaction, parentSubs) {
                $281a441cdcb2cf36$var$callTypeObservers(this, transaction, new $281a441cdcb2cf36$var$YXmlEvent(this, parentSubs, transaction));
            }
            /**
       * Get the string representation of all the children of this YXmlFragment.
       *
       * @return {string} The string representation of all children.
       */ toString() {
                return $281a441cdcb2cf36$var$typeListMap(this, (xml)=>xml.toString()).join("");
            }
            /**
       * @return {string}
       */ toJSON() {
                return this.toString();
            }
            /**
       * Creates a Dom Element that mirrors this YXmlElement.
       *
       * @param {Document} [_document=document] The document object (you must define
       *                                        this when calling this method in
       *                                        nodejs)
       * @param {Object<string, any>} [hooks={}] Optional property to customize how hooks
       *                                             are presented in the DOM
       * @param {any} [binding] You should not set this property. This is
       *                               used if DomBinding wants to create a
       *                               association to the created DOM type.
       * @return {Node} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
       *
       * @public
       */ toDOM(_document = document, hooks = {}, binding) {
                const fragment = _document.createDocumentFragment();
                if (binding !== void 0) binding._createAssociation(fragment, this);
                $281a441cdcb2cf36$var$typeListForEach(this, (xmlType)=>{
                    fragment.insertBefore(xmlType.toDOM(_document, hooks, binding), null);
                });
                return fragment;
            }
            /**
       * Inserts new content at an index.
       *
       * @example
       *  // Insert character 'a' at position 0
       *  xml.insert(0, [new Y.XmlText('text')])
       *
       * @param {number} index The index to insert content at
       * @param {Array<YXmlElement|YXmlText>} content The array of content
       */ insert(index, content) {
                if (this.doc !== null) $281a441cdcb2cf36$var$transact(this.doc, (transaction)=>{
                    $281a441cdcb2cf36$var$typeListInsertGenerics(transaction, this, index, content);
                });
                else this._prelimContent.splice(index, 0, ...content);
            }
            /**
       * Inserts new content at an index.
       *
       * @example
       *  // Insert character 'a' at position 0
       *  xml.insert(0, [new Y.XmlText('text')])
       *
       * @param {null|Item|YXmlElement|YXmlText} ref The index to insert content at
       * @param {Array<YXmlElement|YXmlText>} content The array of content
       */ insertAfter(ref2, content) {
                if (this.doc !== null) $281a441cdcb2cf36$var$transact(this.doc, (transaction)=>{
                    const refItem = ref2 && ref2 instanceof $281a441cdcb2cf36$var$AbstractType ? ref2._item : ref2;
                    $281a441cdcb2cf36$var$typeListInsertGenericsAfter(transaction, this, refItem, content);
                });
                else {
                    const pc = /** @type {Array<any>} */ this._prelimContent;
                    const index = ref2 === null ? 0 : pc.findIndex((el)=>el === ref2) + 1;
                    if (index === 0 && ref2 !== null) throw $281a441cdcb2cf36$var$create3("Reference item not found");
                    pc.splice(index, 0, ...content);
                }
            }
            /**
       * Deletes elements starting from an index.
       *
       * @param {number} index Index at which to start deleting elements
       * @param {number} [length=1] The number of elements to remove. Defaults to 1.
       */ delete(index, length2 = 1) {
                if (this.doc !== null) $281a441cdcb2cf36$var$transact(this.doc, (transaction)=>{
                    $281a441cdcb2cf36$var$typeListDelete(transaction, this, index, length2);
                });
                else this._prelimContent.splice(index, length2);
            }
            /**
       * Transforms this YArray to a JavaScript Array.
       *
       * @return {Array<YXmlElement|YXmlText|YXmlHook>}
       */ toArray() {
                return $281a441cdcb2cf36$var$typeListToArray(this);
            }
            /**
       * Appends content to this YArray.
       *
       * @param {Array<YXmlElement|YXmlText>} content Array of content to append.
       */ push(content) {
                this.insert(this.length, content);
            }
            /**
       * Prepends content to this YArray.
       *
       * @param {Array<YXmlElement|YXmlText>} content Array of content to prepend.
       */ unshift(content) {
                this.insert(0, content);
            }
            /**
       * Returns the i-th element from a YArray.
       *
       * @param {number} index The index of the element to return from the YArray
       * @return {YXmlElement|YXmlText}
       */ get(index) {
                return $281a441cdcb2cf36$var$typeListGet(this, index);
            }
            /**
       * Returns a portion of this YXmlFragment into a JavaScript Array selected
       * from start to end (end not included).
       *
       * @param {number} [start]
       * @param {number} [end]
       * @return {Array<YXmlElement|YXmlText>}
       */ slice(start = 0, end = this.length) {
                return $281a441cdcb2cf36$var$typeListSlice(this, start, end);
            }
            /**
       * Executes a provided function on once on every child element.
       *
       * @param {function(YXmlElement|YXmlText,number, typeof self):void} f A function to execute on every element of this YArray.
       */ forEach(f3) {
                $281a441cdcb2cf36$var$typeListForEach(this, f3);
            }
            /**
       * Transform the properties of this type to binary and write it to an
       * BinaryEncoder.
       *
       * This is called when this Item is sent to a remote peer.
       *
       * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
       */ _write(encoder) {
                encoder.writeTypeRef($281a441cdcb2cf36$var$YXmlFragmentRefID);
            }
        };
        $281a441cdcb2cf36$var$readYXmlFragment = (_decoder)=>new $281a441cdcb2cf36$var$YXmlFragment();
        $281a441cdcb2cf36$var$YXmlElement = class _YXmlElement extends $281a441cdcb2cf36$var$YXmlFragment {
            constructor(nodeName = "UNDEFINED"){
                super();
                this.nodeName = nodeName;
                this._prelimAttrs = /* @__PURE__ */ new Map();
            }
            /**
       * @type {YXmlElement|YXmlText|null}
       */ get nextSibling() {
                const n3 = this._item ? this._item.next : null;
                return n3 ? /** @type {YXmlElement|YXmlText} */ /** @type {ContentType} */ n3.content.type : null;
            }
            /**
       * @type {YXmlElement|YXmlText|null}
       */ get prevSibling() {
                const n3 = this._item ? this._item.prev : null;
                return n3 ? /** @type {YXmlElement|YXmlText} */ /** @type {ContentType} */ n3.content.type : null;
            }
            /**
       * Integrate this type into the Yjs instance.
       *
       * * Save this struct in the os
       * * This type is sent to other client
       * * Observer functions are fired
       *
       * @param {Doc} y The Yjs instance
       * @param {Item} item
       */ _integrate(y3, item) {
                super._integrate(y3, item);
                /** @type {Map<string, any>} */ this._prelimAttrs.forEach((value2, key)=>{
                    this.setAttribute(key, value2);
                });
                this._prelimAttrs = null;
            }
            /**
       * Creates an Item with the same effect as this Item (without position effect)
       *
       * @return {YXmlElement}
       */ _copy() {
                return new _YXmlElement(this.nodeName);
            }
            /**
       * Makes a copy of this data type that can be included somewhere else.
       *
       * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
       *
       * @return {YXmlElement<KV>}
       */ clone() {
                const el = new _YXmlElement(this.nodeName);
                const attrs = this.getAttributes();
                $281a441cdcb2cf36$var$forEach(attrs, (value2, key)=>{
                    el.setAttribute(key, /** @type {any} */ value2);
                });
                el.insert(0, this.toArray().map((v3)=>v3 instanceof $281a441cdcb2cf36$var$AbstractType ? v3.clone() : v3));
                return el;
            }
            /**
       * Returns the XML serialization of this YXmlElement.
       * The attributes are ordered by attribute-name, so you can easily use this
       * method to compare YXmlElements
       *
       * @return {string} The string representation of this type.
       *
       * @public
       */ toString() {
                const attrs = this.getAttributes();
                const stringBuilder = [];
                const keys2 = [];
                for(const key in attrs)keys2.push(key);
                keys2.sort();
                const keysLen = keys2.length;
                for(let i3 = 0; i3 < keysLen; i3++){
                    const key = keys2[i3];
                    stringBuilder.push(key + '="' + attrs[key] + '"');
                }
                const nodeName = this.nodeName.toLocaleLowerCase();
                const attrsString = stringBuilder.length > 0 ? " " + stringBuilder.join(" ") : "";
                return `<${nodeName}${attrsString}>${super.toString()}</${nodeName}>`;
            }
            /**
       * Removes an attribute from this YXmlElement.
       *
       * @param {string} attributeName The attribute name that is to be removed.
       *
       * @public
       */ removeAttribute(attributeName) {
                if (this.doc !== null) $281a441cdcb2cf36$var$transact(this.doc, (transaction)=>{
                    $281a441cdcb2cf36$var$typeMapDelete(transaction, this, attributeName);
                });
                else this._prelimAttrs.delete(attributeName);
            }
            /**
       * Sets or updates an attribute.
       *
       * @template {keyof KV & string} KEY
       *
       * @param {KEY} attributeName The attribute name that is to be set.
       * @param {KV[KEY]} attributeValue The attribute value that is to be set.
       *
       * @public
       */ setAttribute(attributeName, attributeValue) {
                if (this.doc !== null) $281a441cdcb2cf36$var$transact(this.doc, (transaction)=>{
                    $281a441cdcb2cf36$var$typeMapSet(transaction, this, attributeName, attributeValue);
                });
                else this._prelimAttrs.set(attributeName, attributeValue);
            }
            /**
       * Returns an attribute value that belongs to the attribute name.
       *
       * @template {keyof KV & string} KEY
       *
       * @param {KEY} attributeName The attribute name that identifies the
       *                               queried value.
       * @return {KV[KEY]|undefined} The queried attribute value.
       *
       * @public
       */ getAttribute(attributeName) {
                return /** @type {any} */ $281a441cdcb2cf36$var$typeMapGet(this, attributeName);
            }
            /**
       * Returns whether an attribute exists
       *
       * @param {string} attributeName The attribute name to check for existence.
       * @return {boolean} whether the attribute exists.
       *
       * @public
       */ hasAttribute(attributeName) {
                return /** @type {any} */ $281a441cdcb2cf36$var$typeMapHas(this, attributeName);
            }
            /**
       * Returns all attribute name/value pairs in a JSON Object.
       *
       * @param {Snapshot} [snapshot]
       * @return {{ [Key in Extract<keyof KV,string>]?: KV[Key]}} A JSON Object that describes the attributes.
       *
       * @public
       */ getAttributes(snapshot) {
                return /** @type {any} */ snapshot ? $281a441cdcb2cf36$var$typeMapGetAllSnapshot(this, snapshot) : $281a441cdcb2cf36$var$typeMapGetAll(this);
            }
            /**
       * Creates a Dom Element that mirrors this YXmlElement.
       *
       * @param {Document} [_document=document] The document object (you must define
       *                                        this when calling this method in
       *                                        nodejs)
       * @param {Object<string, any>} [hooks={}] Optional property to customize how hooks
       *                                             are presented in the DOM
       * @param {any} [binding] You should not set this property. This is
       *                               used if DomBinding wants to create a
       *                               association to the created DOM type.
       * @return {Node} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
       *
       * @public
       */ toDOM(_document = document, hooks = {}, binding) {
                const dom = _document.createElement(this.nodeName);
                const attrs = this.getAttributes();
                for(const key in attrs){
                    const value2 = attrs[key];
                    if (typeof value2 === "string") dom.setAttribute(key, value2);
                }
                $281a441cdcb2cf36$var$typeListForEach(this, (yxml)=>{
                    dom.appendChild(yxml.toDOM(_document, hooks, binding));
                });
                if (binding !== void 0) binding._createAssociation(dom, this);
                return dom;
            }
            /**
       * Transform the properties of this type to binary and write it to an
       * BinaryEncoder.
       *
       * This is called when this Item is sent to a remote peer.
       *
       * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
       */ _write(encoder) {
                encoder.writeTypeRef($281a441cdcb2cf36$var$YXmlElementRefID);
                encoder.writeKey(this.nodeName);
            }
        };
        $281a441cdcb2cf36$var$readYXmlElement = (decoder)=>new $281a441cdcb2cf36$var$YXmlElement(decoder.readKey());
        $281a441cdcb2cf36$var$YXmlEvent = class extends $281a441cdcb2cf36$var$YEvent {
            /**
       * @param {YXmlElement|YXmlText|YXmlFragment} target The target on which the event is created.
       * @param {Set<string|null>} subs The set of changed attributes. `null` is included if the
       *                   child list changed.
       * @param {Transaction} transaction The transaction instance with which the
       *                                  change was created.
       */ constructor(target, subs, transaction){
                super(target, transaction);
                this.childListChanged = false;
                this.attributesChanged = /* @__PURE__ */ new Set();
                subs.forEach((sub)=>{
                    if (sub === null) this.childListChanged = true;
                    else this.attributesChanged.add(sub);
                });
            }
        };
        $281a441cdcb2cf36$var$YXmlHook = class _YXmlHook extends $281a441cdcb2cf36$var$YMap {
            /**
       * @param {string} hookName nodeName of the Dom Node.
       */ constructor(hookName){
                super();
                this.hookName = hookName;
            }
            /**
       * Creates an Item with the same effect as this Item (without position effect)
       */ _copy() {
                return new _YXmlHook(this.hookName);
            }
            /**
       * Makes a copy of this data type that can be included somewhere else.
       *
       * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
       *
       * @return {YXmlHook}
       */ clone() {
                const el = new _YXmlHook(this.hookName);
                this.forEach((value2, key)=>{
                    el.set(key, value2);
                });
                return el;
            }
            /**
       * Creates a Dom Element that mirrors this YXmlElement.
       *
       * @param {Document} [_document=document] The document object (you must define
       *                                        this when calling this method in
       *                                        nodejs)
       * @param {Object.<string, any>} [hooks] Optional property to customize how hooks
       *                                             are presented in the DOM
       * @param {any} [binding] You should not set this property. This is
       *                               used if DomBinding wants to create a
       *                               association to the created DOM type
       * @return {Element} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
       *
       * @public
       */ toDOM(_document = document, hooks = {}, binding) {
                const hook = hooks[this.hookName];
                let dom;
                if (hook !== void 0) dom = hook.createDom(this);
                else dom = document.createElement(this.hookName);
                dom.setAttribute("data-yjs-hook", this.hookName);
                if (binding !== void 0) binding._createAssociation(dom, this);
                return dom;
            }
            /**
       * Transform the properties of this type to binary and write it to an
       * BinaryEncoder.
       *
       * This is called when this Item is sent to a remote peer.
       *
       * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
       */ _write(encoder) {
                encoder.writeTypeRef($281a441cdcb2cf36$var$YXmlHookRefID);
                encoder.writeKey(this.hookName);
            }
        };
        $281a441cdcb2cf36$var$readYXmlHook = (decoder)=>new $281a441cdcb2cf36$var$YXmlHook(decoder.readKey());
        $281a441cdcb2cf36$var$YXmlText = class _YXmlText extends $281a441cdcb2cf36$var$YText {
            /**
       * @type {YXmlElement|YXmlText|null}
       */ get nextSibling() {
                const n3 = this._item ? this._item.next : null;
                return n3 ? /** @type {YXmlElement|YXmlText} */ /** @type {ContentType} */ n3.content.type : null;
            }
            /**
       * @type {YXmlElement|YXmlText|null}
       */ get prevSibling() {
                const n3 = this._item ? this._item.prev : null;
                return n3 ? /** @type {YXmlElement|YXmlText} */ /** @type {ContentType} */ n3.content.type : null;
            }
            _copy() {
                return new _YXmlText();
            }
            /**
       * Makes a copy of this data type that can be included somewhere else.
       *
       * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
       *
       * @return {YXmlText}
       */ clone() {
                const text2 = new _YXmlText();
                text2.applyDelta(this.toDelta());
                return text2;
            }
            /**
       * Creates a Dom Element that mirrors this YXmlText.
       *
       * @param {Document} [_document=document] The document object (you must define
       *                                        this when calling this method in
       *                                        nodejs)
       * @param {Object<string, any>} [hooks] Optional property to customize how hooks
       *                                             are presented in the DOM
       * @param {any} [binding] You should not set this property. This is
       *                               used if DomBinding wants to create a
       *                               association to the created DOM type.
       * @return {Text} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
       *
       * @public
       */ toDOM(_document = document, hooks, binding) {
                const dom = _document.createTextNode(this.toString());
                if (binding !== void 0) binding._createAssociation(dom, this);
                return dom;
            }
            toString() {
                return this.toDelta().map((delta)=>{
                    const nestedNodes = [];
                    for(const nodeName in delta.attributes){
                        const attrs = [];
                        for(const key in delta.attributes[nodeName])attrs.push({
                            key: key,
                            value: delta.attributes[nodeName][key]
                        });
                        attrs.sort((a3, b3)=>a3.key < b3.key ? -1 : 1);
                        nestedNodes.push({
                            nodeName: nodeName,
                            attrs: attrs
                        });
                    }
                    nestedNodes.sort((a3, b3)=>a3.nodeName < b3.nodeName ? -1 : 1);
                    let str = "";
                    for(let i3 = 0; i3 < nestedNodes.length; i3++){
                        const node = nestedNodes[i3];
                        str += `<${node.nodeName}`;
                        for(let j3 = 0; j3 < node.attrs.length; j3++){
                            const attr = node.attrs[j3];
                            str += ` ${attr.key}="${attr.value}"`;
                        }
                        str += ">";
                    }
                    str += delta.insert;
                    for(let i3 = nestedNodes.length - 1; i3 >= 0; i3--)str += `</${nestedNodes[i3].nodeName}>`;
                    return str;
                }).join("");
            }
            /**
       * @return {string}
       */ toJSON() {
                return this.toString();
            }
            /**
       * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
       */ _write(encoder) {
                encoder.writeTypeRef($281a441cdcb2cf36$var$YXmlTextRefID);
            }
        };
        $281a441cdcb2cf36$var$readYXmlText = (decoder)=>new $281a441cdcb2cf36$var$YXmlText();
        $281a441cdcb2cf36$var$AbstractStruct = class {
            /**
       * @param {ID} id
       * @param {number} length
       */ constructor(id2, length2){
                this.id = id2;
                this.length = length2;
            }
            /**
       * @type {boolean}
       */ get deleted() {
                throw $281a441cdcb2cf36$var$methodUnimplemented();
            }
            /**
       * Merge this struct with the item to the right.
       * This method is already assuming that `this.id.clock + this.length === this.id.clock`.
       * Also this method does *not* remove right from StructStore!
       * @param {AbstractStruct} right
       * @return {boolean} whether this merged with right
       */ mergeWith(right) {
                return false;
            }
            /**
       * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
       * @param {number} offset
       * @param {number} encodingRef
       */ write(encoder, offset2, encodingRef) {
                throw $281a441cdcb2cf36$var$methodUnimplemented();
            }
            /**
       * @param {Transaction} transaction
       * @param {number} offset
       */ integrate(transaction, offset2) {
                throw $281a441cdcb2cf36$var$methodUnimplemented();
            }
        };
        $281a441cdcb2cf36$var$structGCRefNumber = 0;
        $281a441cdcb2cf36$var$GC = class extends $281a441cdcb2cf36$var$AbstractStruct {
            get deleted() {
                return true;
            }
            delete() {}
            /**
       * @param {GC} right
       * @return {boolean}
       */ mergeWith(right) {
                if (this.constructor !== right.constructor) return false;
                this.length += right.length;
                return true;
            }
            /**
       * @param {Transaction} transaction
       * @param {number} offset
       */ integrate(transaction, offset2) {
                if (offset2 > 0) {
                    this.id.clock += offset2;
                    this.length -= offset2;
                }
                $281a441cdcb2cf36$var$addStruct(transaction.doc.store, this);
            }
            /**
       * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
       * @param {number} offset
       */ write(encoder, offset2) {
                encoder.writeInfo($281a441cdcb2cf36$var$structGCRefNumber);
                encoder.writeLen(this.length - offset2);
            }
            /**
       * @param {Transaction} transaction
       * @param {StructStore} store
       * @return {null | number}
       */ getMissing(transaction, store) {
                return null;
            }
        };
        $281a441cdcb2cf36$var$ContentBinary = class _ContentBinary {
            /**
       * @param {Uint8Array} content
       */ constructor(content){
                this.content = content;
            }
            /**
       * @return {number}
       */ getLength() {
                return 1;
            }
            /**
       * @return {Array<any>}
       */ getContent() {
                return [
                    this.content
                ];
            }
            /**
       * @return {boolean}
       */ isCountable() {
                return true;
            }
            /**
       * @return {ContentBinary}
       */ copy() {
                return new _ContentBinary(this.content);
            }
            /**
       * @param {number} offset
       * @return {ContentBinary}
       */ splice(offset2) {
                throw $281a441cdcb2cf36$var$methodUnimplemented();
            }
            /**
       * @param {ContentBinary} right
       * @return {boolean}
       */ mergeWith(right) {
                return false;
            }
            /**
       * @param {Transaction} transaction
       * @param {Item} item
       */ integrate(transaction, item) {}
            /**
       * @param {Transaction} transaction
       */ delete(transaction) {}
            /**
       * @param {StructStore} store
       */ gc(store) {}
            /**
       * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
       * @param {number} offset
       */ write(encoder, offset2) {
                encoder.writeBuf(this.content);
            }
            /**
       * @return {number}
       */ getRef() {
                return 3;
            }
        };
        $281a441cdcb2cf36$var$readContentBinary = (decoder)=>new $281a441cdcb2cf36$var$ContentBinary(decoder.readBuf());
        $281a441cdcb2cf36$var$ContentDeleted = class _ContentDeleted {
            /**
       * @param {number} len
       */ constructor(len){
                this.len = len;
            }
            /**
       * @return {number}
       */ getLength() {
                return this.len;
            }
            /**
       * @return {Array<any>}
       */ getContent() {
                return [];
            }
            /**
       * @return {boolean}
       */ isCountable() {
                return false;
            }
            /**
       * @return {ContentDeleted}
       */ copy() {
                return new _ContentDeleted(this.len);
            }
            /**
       * @param {number} offset
       * @return {ContentDeleted}
       */ splice(offset2) {
                const right = new _ContentDeleted(this.len - offset2);
                this.len = offset2;
                return right;
            }
            /**
       * @param {ContentDeleted} right
       * @return {boolean}
       */ mergeWith(right) {
                this.len += right.len;
                return true;
            }
            /**
       * @param {Transaction} transaction
       * @param {Item} item
       */ integrate(transaction, item) {
                $281a441cdcb2cf36$var$addToDeleteSet(transaction.deleteSet, item.id.client, item.id.clock, this.len);
                item.markDeleted();
            }
            /**
       * @param {Transaction} transaction
       */ delete(transaction) {}
            /**
       * @param {StructStore} store
       */ gc(store) {}
            /**
       * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
       * @param {number} offset
       */ write(encoder, offset2) {
                encoder.writeLen(this.len - offset2);
            }
            /**
       * @return {number}
       */ getRef() {
                return 1;
            }
        };
        $281a441cdcb2cf36$var$readContentDeleted = (decoder)=>new $281a441cdcb2cf36$var$ContentDeleted(decoder.readLen());
        $281a441cdcb2cf36$var$createDocFromOpts = (guid, opts)=>new $281a441cdcb2cf36$var$Doc({
                guid: guid,
                ...opts,
                shouldLoad: opts.shouldLoad || opts.autoLoad || false
            });
        $281a441cdcb2cf36$var$ContentDoc = class _ContentDoc {
            /**
       * @param {Doc} doc
       */ constructor(doc2){
                if (doc2._item) console.error("This document was already integrated as a sub-document. You should create a second instance instead with the same guid.");
                this.doc = doc2;
                const opts = {};
                this.opts = opts;
                if (!doc2.gc) opts.gc = false;
                if (doc2.autoLoad) opts.autoLoad = true;
                if (doc2.meta !== null) opts.meta = doc2.meta;
            }
            /**
       * @return {number}
       */ getLength() {
                return 1;
            }
            /**
       * @return {Array<any>}
       */ getContent() {
                return [
                    this.doc
                ];
            }
            /**
       * @return {boolean}
       */ isCountable() {
                return true;
            }
            /**
       * @return {ContentDoc}
       */ copy() {
                return new _ContentDoc($281a441cdcb2cf36$var$createDocFromOpts(this.doc.guid, this.opts));
            }
            /**
       * @param {number} offset
       * @return {ContentDoc}
       */ splice(offset2) {
                throw $281a441cdcb2cf36$var$methodUnimplemented();
            }
            /**
       * @param {ContentDoc} right
       * @return {boolean}
       */ mergeWith(right) {
                return false;
            }
            /**
       * @param {Transaction} transaction
       * @param {Item} item
       */ integrate(transaction, item) {
                this.doc._item = item;
                transaction.subdocsAdded.add(this.doc);
                if (this.doc.shouldLoad) transaction.subdocsLoaded.add(this.doc);
            }
            /**
       * @param {Transaction} transaction
       */ delete(transaction) {
                if (transaction.subdocsAdded.has(this.doc)) transaction.subdocsAdded.delete(this.doc);
                else transaction.subdocsRemoved.add(this.doc);
            }
            /**
       * @param {StructStore} store
       */ gc(store) {}
            /**
       * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
       * @param {number} offset
       */ write(encoder, offset2) {
                encoder.writeString(this.doc.guid);
                encoder.writeAny(this.opts);
            }
            /**
       * @return {number}
       */ getRef() {
                return 9;
            }
        };
        $281a441cdcb2cf36$var$readContentDoc = (decoder)=>new $281a441cdcb2cf36$var$ContentDoc($281a441cdcb2cf36$var$createDocFromOpts(decoder.readString(), decoder.readAny()));
        $281a441cdcb2cf36$var$ContentEmbed = class _ContentEmbed {
            /**
       * @param {Object} embed
       */ constructor(embed){
                this.embed = embed;
            }
            /**
       * @return {number}
       */ getLength() {
                return 1;
            }
            /**
       * @return {Array<any>}
       */ getContent() {
                return [
                    this.embed
                ];
            }
            /**
       * @return {boolean}
       */ isCountable() {
                return true;
            }
            /**
       * @return {ContentEmbed}
       */ copy() {
                return new _ContentEmbed(this.embed);
            }
            /**
       * @param {number} offset
       * @return {ContentEmbed}
       */ splice(offset2) {
                throw $281a441cdcb2cf36$var$methodUnimplemented();
            }
            /**
       * @param {ContentEmbed} right
       * @return {boolean}
       */ mergeWith(right) {
                return false;
            }
            /**
       * @param {Transaction} transaction
       * @param {Item} item
       */ integrate(transaction, item) {}
            /**
       * @param {Transaction} transaction
       */ delete(transaction) {}
            /**
       * @param {StructStore} store
       */ gc(store) {}
            /**
       * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
       * @param {number} offset
       */ write(encoder, offset2) {
                encoder.writeJSON(this.embed);
            }
            /**
       * @return {number}
       */ getRef() {
                return 5;
            }
        };
        $281a441cdcb2cf36$var$readContentEmbed = (decoder)=>new $281a441cdcb2cf36$var$ContentEmbed(decoder.readJSON());
        $281a441cdcb2cf36$var$ContentFormat = class _ContentFormat {
            /**
       * @param {string} key
       * @param {Object} value
       */ constructor(key, value2){
                this.key = key;
                this.value = value2;
            }
            /**
       * @return {number}
       */ getLength() {
                return 1;
            }
            /**
       * @return {Array<any>}
       */ getContent() {
                return [];
            }
            /**
       * @return {boolean}
       */ isCountable() {
                return false;
            }
            /**
       * @return {ContentFormat}
       */ copy() {
                return new _ContentFormat(this.key, this.value);
            }
            /**
       * @param {number} _offset
       * @return {ContentFormat}
       */ splice(_offset) {
                throw $281a441cdcb2cf36$var$methodUnimplemented();
            }
            /**
       * @param {ContentFormat} _right
       * @return {boolean}
       */ mergeWith(_right) {
                return false;
            }
            /**
       * @param {Transaction} _transaction
       * @param {Item} item
       */ integrate(_transaction, item) {
                const p3 = /** @type {YText} */ item.parent;
                p3._searchMarker = null;
                p3._hasFormatting = true;
            }
            /**
       * @param {Transaction} transaction
       */ delete(transaction) {}
            /**
       * @param {StructStore} store
       */ gc(store) {}
            /**
       * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
       * @param {number} offset
       */ write(encoder, offset2) {
                encoder.writeKey(this.key);
                encoder.writeJSON(this.value);
            }
            /**
       * @return {number}
       */ getRef() {
                return 6;
            }
        };
        $281a441cdcb2cf36$var$readContentFormat = (decoder)=>new $281a441cdcb2cf36$var$ContentFormat(decoder.readKey(), decoder.readJSON());
        $281a441cdcb2cf36$var$ContentJSON = class _ContentJSON {
            /**
       * @param {Array<any>} arr
       */ constructor(arr){
                this.arr = arr;
            }
            /**
       * @return {number}
       */ getLength() {
                return this.arr.length;
            }
            /**
       * @return {Array<any>}
       */ getContent() {
                return this.arr;
            }
            /**
       * @return {boolean}
       */ isCountable() {
                return true;
            }
            /**
       * @return {ContentJSON}
       */ copy() {
                return new _ContentJSON(this.arr);
            }
            /**
       * @param {number} offset
       * @return {ContentJSON}
       */ splice(offset2) {
                const right = new _ContentJSON(this.arr.slice(offset2));
                this.arr = this.arr.slice(0, offset2);
                return right;
            }
            /**
       * @param {ContentJSON} right
       * @return {boolean}
       */ mergeWith(right) {
                this.arr = this.arr.concat(right.arr);
                return true;
            }
            /**
       * @param {Transaction} transaction
       * @param {Item} item
       */ integrate(transaction, item) {}
            /**
       * @param {Transaction} transaction
       */ delete(transaction) {}
            /**
       * @param {StructStore} store
       */ gc(store) {}
            /**
       * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
       * @param {number} offset
       */ write(encoder, offset2) {
                const len = this.arr.length;
                encoder.writeLen(len - offset2);
                for(let i3 = offset2; i3 < len; i3++){
                    const c3 = this.arr[i3];
                    encoder.writeString(c3 === void 0 ? "undefined" : JSON.stringify(c3));
                }
            }
            /**
       * @return {number}
       */ getRef() {
                return 2;
            }
        };
        $281a441cdcb2cf36$var$readContentJSON = (decoder)=>{
            const len = decoder.readLen();
            const cs = [];
            for(let i3 = 0; i3 < len; i3++){
                const c3 = decoder.readString();
                if (c3 === "undefined") cs.push(void 0);
                else cs.push(JSON.parse(c3));
            }
            return new $281a441cdcb2cf36$var$ContentJSON(cs);
        };
        $281a441cdcb2cf36$var$isDevMode = $281a441cdcb2cf36$var$getVariable("node_env") === "development";
        $281a441cdcb2cf36$var$ContentAny = class _ContentAny {
            /**
       * @param {Array<any>} arr
       */ constructor(arr){
                this.arr = arr;
                $281a441cdcb2cf36$var$isDevMode && $281a441cdcb2cf36$var$deepFreeze(arr);
            }
            /**
       * @return {number}
       */ getLength() {
                return this.arr.length;
            }
            /**
       * @return {Array<any>}
       */ getContent() {
                return this.arr;
            }
            /**
       * @return {boolean}
       */ isCountable() {
                return true;
            }
            /**
       * @return {ContentAny}
       */ copy() {
                return new _ContentAny(this.arr);
            }
            /**
       * @param {number} offset
       * @return {ContentAny}
       */ splice(offset2) {
                const right = new _ContentAny(this.arr.slice(offset2));
                this.arr = this.arr.slice(0, offset2);
                return right;
            }
            /**
       * @param {ContentAny} right
       * @return {boolean}
       */ mergeWith(right) {
                this.arr = this.arr.concat(right.arr);
                return true;
            }
            /**
       * @param {Transaction} transaction
       * @param {Item} item
       */ integrate(transaction, item) {}
            /**
       * @param {Transaction} transaction
       */ delete(transaction) {}
            /**
       * @param {StructStore} store
       */ gc(store) {}
            /**
       * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
       * @param {number} offset
       */ write(encoder, offset2) {
                const len = this.arr.length;
                encoder.writeLen(len - offset2);
                for(let i3 = offset2; i3 < len; i3++){
                    const c3 = this.arr[i3];
                    encoder.writeAny(c3);
                }
            }
            /**
       * @return {number}
       */ getRef() {
                return 8;
            }
        };
        $281a441cdcb2cf36$var$readContentAny = (decoder)=>{
            const len = decoder.readLen();
            const cs = [];
            for(let i3 = 0; i3 < len; i3++)cs.push(decoder.readAny());
            return new $281a441cdcb2cf36$var$ContentAny(cs);
        };
        $281a441cdcb2cf36$var$ContentString = class _ContentString {
            /**
       * @param {string} str
       */ constructor(str){
                this.str = str;
            }
            /**
       * @return {number}
       */ getLength() {
                return this.str.length;
            }
            /**
       * @return {Array<any>}
       */ getContent() {
                return this.str.split("");
            }
            /**
       * @return {boolean}
       */ isCountable() {
                return true;
            }
            /**
       * @return {ContentString}
       */ copy() {
                return new _ContentString(this.str);
            }
            /**
       * @param {number} offset
       * @return {ContentString}
       */ splice(offset2) {
                const right = new _ContentString(this.str.slice(offset2));
                this.str = this.str.slice(0, offset2);
                const firstCharCode = this.str.charCodeAt(offset2 - 1);
                if (firstCharCode >= 55296 && firstCharCode <= 56319) {
                    this.str = this.str.slice(0, offset2 - 1) + "\uFFFD";
                    right.str = "\uFFFD" + right.str.slice(1);
                }
                return right;
            }
            /**
       * @param {ContentString} right
       * @return {boolean}
       */ mergeWith(right) {
                this.str += right.str;
                return true;
            }
            /**
       * @param {Transaction} transaction
       * @param {Item} item
       */ integrate(transaction, item) {}
            /**
       * @param {Transaction} transaction
       */ delete(transaction) {}
            /**
       * @param {StructStore} store
       */ gc(store) {}
            /**
       * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
       * @param {number} offset
       */ write(encoder, offset2) {
                encoder.writeString(offset2 === 0 ? this.str : this.str.slice(offset2));
            }
            /**
       * @return {number}
       */ getRef() {
                return 4;
            }
        };
        $281a441cdcb2cf36$var$readContentString = (decoder)=>new $281a441cdcb2cf36$var$ContentString(decoder.readString());
        $281a441cdcb2cf36$var$typeRefs = [
            $281a441cdcb2cf36$var$readYArray,
            $281a441cdcb2cf36$var$readYMap,
            $281a441cdcb2cf36$var$readYText,
            $281a441cdcb2cf36$var$readYXmlElement,
            $281a441cdcb2cf36$var$readYXmlFragment,
            $281a441cdcb2cf36$var$readYXmlHook,
            $281a441cdcb2cf36$var$readYXmlText
        ];
        $281a441cdcb2cf36$var$YArrayRefID = 0;
        $281a441cdcb2cf36$var$YMapRefID = 1;
        $281a441cdcb2cf36$var$YTextRefID = 2;
        $281a441cdcb2cf36$var$YXmlElementRefID = 3;
        $281a441cdcb2cf36$var$YXmlFragmentRefID = 4;
        $281a441cdcb2cf36$var$YXmlHookRefID = 5;
        $281a441cdcb2cf36$var$YXmlTextRefID = 6;
        $281a441cdcb2cf36$var$ContentType = class _ContentType {
            /**
       * @param {AbstractType<any>} type
       */ constructor(type){
                this.type = type;
            }
            /**
       * @return {number}
       */ getLength() {
                return 1;
            }
            /**
       * @return {Array<any>}
       */ getContent() {
                return [
                    this.type
                ];
            }
            /**
       * @return {boolean}
       */ isCountable() {
                return true;
            }
            /**
       * @return {ContentType}
       */ copy() {
                return new _ContentType(this.type._copy());
            }
            /**
       * @param {number} offset
       * @return {ContentType}
       */ splice(offset2) {
                throw $281a441cdcb2cf36$var$methodUnimplemented();
            }
            /**
       * @param {ContentType} right
       * @return {boolean}
       */ mergeWith(right) {
                return false;
            }
            /**
       * @param {Transaction} transaction
       * @param {Item} item
       */ integrate(transaction, item) {
                this.type._integrate(transaction.doc, item);
            }
            /**
       * @param {Transaction} transaction
       */ delete(transaction) {
                let item = this.type._start;
                while(item !== null){
                    if (!item.deleted) item.delete(transaction);
                    else if (item.id.clock < (transaction.beforeState.get(item.id.client) || 0)) transaction._mergeStructs.push(item);
                    item = item.right;
                }
                this.type._map.forEach((item2)=>{
                    if (!item2.deleted) item2.delete(transaction);
                    else if (item2.id.clock < (transaction.beforeState.get(item2.id.client) || 0)) transaction._mergeStructs.push(item2);
                });
                transaction.changed.delete(this.type);
            }
            /**
       * @param {StructStore} store
       */ gc(store) {
                let item = this.type._start;
                while(item !== null){
                    item.gc(store, true);
                    item = item.right;
                }
                this.type._start = null;
                this.type._map.forEach(/** @param {Item | null} item */ (item2)=>{
                    while(item2 !== null){
                        item2.gc(store, true);
                        item2 = item2.left;
                    }
                });
                this.type._map = /* @__PURE__ */ new Map();
            }
            /**
       * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
       * @param {number} offset
       */ write(encoder, offset2) {
                this.type._write(encoder);
            }
            /**
       * @return {number}
       */ getRef() {
                return 7;
            }
        };
        $281a441cdcb2cf36$var$readContentType = (decoder)=>new $281a441cdcb2cf36$var$ContentType($281a441cdcb2cf36$var$typeRefs[decoder.readTypeRef()](decoder));
        $281a441cdcb2cf36$var$splitItem = (transaction, leftItem, diff)=>{
            const { client: client, clock: clock } = leftItem.id;
            const rightItem = new $281a441cdcb2cf36$var$Item($281a441cdcb2cf36$var$createID(client, clock + diff), leftItem, $281a441cdcb2cf36$var$createID(client, clock + diff - 1), leftItem.right, leftItem.rightOrigin, leftItem.parent, leftItem.parentSub, leftItem.content.splice(diff));
            if (leftItem.deleted) rightItem.markDeleted();
            if (leftItem.keep) rightItem.keep = true;
            if (leftItem.redone !== null) rightItem.redone = $281a441cdcb2cf36$var$createID(leftItem.redone.client, leftItem.redone.clock + diff);
            leftItem.right = rightItem;
            if (rightItem.right !== null) rightItem.right.left = rightItem;
            transaction._mergeStructs.push(rightItem);
            if (rightItem.parentSub !== null && rightItem.right === null) rightItem.parent._map.set(rightItem.parentSub, rightItem);
            leftItem.length = diff;
            return rightItem;
        };
        $281a441cdcb2cf36$var$Item = class _Item extends $281a441cdcb2cf36$var$AbstractStruct {
            /**
       * @param {ID} id
       * @param {Item | null} left
       * @param {ID | null} origin
       * @param {Item | null} right
       * @param {ID | null} rightOrigin
       * @param {AbstractType<any>|ID|null} parent Is a type if integrated, is null if it is possible to copy parent from left or right, is ID before integration to search for it.
       * @param {string | null} parentSub
       * @param {AbstractContent} content
       */ constructor(id2, left, origin, right, rightOrigin, parent, parentSub, content){
                super(id2, content.getLength());
                this.origin = origin;
                this.left = left;
                this.right = right;
                this.rightOrigin = rightOrigin;
                this.parent = parent;
                this.parentSub = parentSub;
                this.redone = null;
                this.content = content;
                this.info = this.content.isCountable() ? $281a441cdcb2cf36$var$BIT2 : 0;
            }
            /**
       * This is used to mark the item as an indexed fast-search marker
       *
       * @type {boolean}
       */ set marker(isMarked) {
                if ((this.info & $281a441cdcb2cf36$var$BIT4) > 0 !== isMarked) this.info ^= $281a441cdcb2cf36$var$BIT4;
            }
            get marker() {
                return (this.info & $281a441cdcb2cf36$var$BIT4) > 0;
            }
            /**
       * If true, do not garbage collect this Item.
       */ get keep() {
                return (this.info & $281a441cdcb2cf36$var$BIT1) > 0;
            }
            set keep(doKeep) {
                if (this.keep !== doKeep) this.info ^= $281a441cdcb2cf36$var$BIT1;
            }
            get countable() {
                return (this.info & $281a441cdcb2cf36$var$BIT2) > 0;
            }
            /**
       * Whether this item was deleted or not.
       * @type {Boolean}
       */ get deleted() {
                return (this.info & $281a441cdcb2cf36$var$BIT3) > 0;
            }
            set deleted(doDelete) {
                if (this.deleted !== doDelete) this.info ^= $281a441cdcb2cf36$var$BIT3;
            }
            markDeleted() {
                this.info |= $281a441cdcb2cf36$var$BIT3;
            }
            /**
       * Return the creator clientID of the missing op or define missing items and return null.
       *
       * @param {Transaction} transaction
       * @param {StructStore} store
       * @return {null | number}
       */ getMissing(transaction, store) {
                if (this.origin && this.origin.client !== this.id.client && this.origin.clock >= $281a441cdcb2cf36$var$getState(store, this.origin.client)) return this.origin.client;
                if (this.rightOrigin && this.rightOrigin.client !== this.id.client && this.rightOrigin.clock >= $281a441cdcb2cf36$var$getState(store, this.rightOrigin.client)) return this.rightOrigin.client;
                if (this.parent && this.parent.constructor === $281a441cdcb2cf36$var$ID && this.id.client !== this.parent.client && this.parent.clock >= $281a441cdcb2cf36$var$getState(store, this.parent.client)) return this.parent.client;
                if (this.origin) {
                    this.left = $281a441cdcb2cf36$var$getItemCleanEnd(transaction, store, this.origin);
                    this.origin = this.left.lastId;
                }
                if (this.rightOrigin) {
                    this.right = $281a441cdcb2cf36$var$getItemCleanStart(transaction, this.rightOrigin);
                    this.rightOrigin = this.right.id;
                }
                if (this.left && this.left.constructor === $281a441cdcb2cf36$var$GC || this.right && this.right.constructor === $281a441cdcb2cf36$var$GC) this.parent = null;
                else if (!this.parent) {
                    if (this.left && this.left.constructor === _Item) {
                        this.parent = this.left.parent;
                        this.parentSub = this.left.parentSub;
                    } else if (this.right && this.right.constructor === _Item) {
                        this.parent = this.right.parent;
                        this.parentSub = this.right.parentSub;
                    }
                } else if (this.parent.constructor === $281a441cdcb2cf36$var$ID) {
                    const parentItem = $281a441cdcb2cf36$var$getItem(store, this.parent);
                    if (parentItem.constructor === $281a441cdcb2cf36$var$GC) this.parent = null;
                    else this.parent = /** @type {ContentType} */ parentItem.content.type;
                }
                return null;
            }
            /**
       * @param {Transaction} transaction
       * @param {number} offset
       */ integrate(transaction, offset2) {
                if (offset2 > 0) {
                    this.id.clock += offset2;
                    this.left = $281a441cdcb2cf36$var$getItemCleanEnd(transaction, transaction.doc.store, $281a441cdcb2cf36$var$createID(this.id.client, this.id.clock - 1));
                    this.origin = this.left.lastId;
                    this.content = this.content.splice(offset2);
                    this.length -= offset2;
                }
                if (this.parent) {
                    if (!this.left && (!this.right || this.right.left !== null) || this.left && this.left.right !== this.right) {
                        let left = this.left;
                        let o3;
                        if (left !== null) o3 = left.right;
                        else if (this.parentSub !== null) {
                            o3 = /** @type {AbstractType<any>} */ this.parent._map.get(this.parentSub) || null;
                            while(o3 !== null && o3.left !== null)o3 = o3.left;
                        } else o3 = /** @type {AbstractType<any>} */ this.parent._start;
                        const conflictingItems = /* @__PURE__ */ new Set();
                        const itemsBeforeOrigin = /* @__PURE__ */ new Set();
                        while(o3 !== null && o3 !== this.right){
                            itemsBeforeOrigin.add(o3);
                            conflictingItems.add(o3);
                            if ($281a441cdcb2cf36$var$compareIDs(this.origin, o3.origin)) {
                                if (o3.id.client < this.id.client) {
                                    left = o3;
                                    conflictingItems.clear();
                                } else if ($281a441cdcb2cf36$var$compareIDs(this.rightOrigin, o3.rightOrigin)) break;
                            } else if (o3.origin !== null && itemsBeforeOrigin.has($281a441cdcb2cf36$var$getItem(transaction.doc.store, o3.origin))) {
                                if (!conflictingItems.has($281a441cdcb2cf36$var$getItem(transaction.doc.store, o3.origin))) {
                                    left = o3;
                                    conflictingItems.clear();
                                }
                            } else break;
                            o3 = o3.right;
                        }
                        this.left = left;
                    }
                    if (this.left !== null) {
                        const right = this.left.right;
                        this.right = right;
                        this.left.right = this;
                    } else {
                        let r3;
                        if (this.parentSub !== null) {
                            r3 = /** @type {AbstractType<any>} */ this.parent._map.get(this.parentSub) || null;
                            while(r3 !== null && r3.left !== null)r3 = r3.left;
                        } else {
                            r3 = /** @type {AbstractType<any>} */ this.parent._start;
                            this.parent._start = this;
                        }
                        this.right = r3;
                    }
                    if (this.right !== null) this.right.left = this;
                    else if (this.parentSub !== null) {
                        this.parent._map.set(this.parentSub, this);
                        if (this.left !== null) this.left.delete(transaction);
                    }
                    if (this.parentSub === null && this.countable && !this.deleted) this.parent._length += this.length;
                    $281a441cdcb2cf36$var$addStruct(transaction.doc.store, this);
                    this.content.integrate(transaction, this);
                    $281a441cdcb2cf36$var$addChangedTypeToTransaction(transaction, /** @type {AbstractType<any>} */ this.parent, this.parentSub);
                    if (/** @type {AbstractType<any>} */ this.parent._item !== null && /** @type {AbstractType<any>} */ this.parent._item.deleted || this.parentSub !== null && this.right !== null) this.delete(transaction);
                } else new $281a441cdcb2cf36$var$GC(this.id, this.length).integrate(transaction, 0);
            }
            /**
       * Returns the next non-deleted item
       */ get next() {
                let n3 = this.right;
                while(n3 !== null && n3.deleted)n3 = n3.right;
                return n3;
            }
            /**
       * Returns the previous non-deleted item
       */ get prev() {
                let n3 = this.left;
                while(n3 !== null && n3.deleted)n3 = n3.left;
                return n3;
            }
            /**
       * Computes the last content address of this Item.
       */ get lastId() {
                return this.length === 1 ? this.id : $281a441cdcb2cf36$var$createID(this.id.client, this.id.clock + this.length - 1);
            }
            /**
       * Try to merge two items
       *
       * @param {Item} right
       * @return {boolean}
       */ mergeWith(right) {
                if (this.constructor === right.constructor && $281a441cdcb2cf36$var$compareIDs(right.origin, this.lastId) && this.right === right && $281a441cdcb2cf36$var$compareIDs(this.rightOrigin, right.rightOrigin) && this.id.client === right.id.client && this.id.clock + this.length === right.id.clock && this.deleted === right.deleted && this.redone === null && right.redone === null && this.content.constructor === right.content.constructor && this.content.mergeWith(right.content)) {
                    const searchMarker = /** @type {AbstractType<any>} */ this.parent._searchMarker;
                    if (searchMarker) searchMarker.forEach((marker)=>{
                        if (marker.p === right) {
                            marker.p = this;
                            if (!this.deleted && this.countable) marker.index -= this.length;
                        }
                    });
                    if (right.keep) this.keep = true;
                    this.right = right.right;
                    if (this.right !== null) this.right.left = this;
                    this.length += right.length;
                    return true;
                }
                return false;
            }
            /**
       * Mark this Item as deleted.
       *
       * @param {Transaction} transaction
       */ delete(transaction) {
                if (!this.deleted) {
                    const parent = /** @type {AbstractType<any>} */ this.parent;
                    if (this.countable && this.parentSub === null) parent._length -= this.length;
                    this.markDeleted();
                    $281a441cdcb2cf36$var$addToDeleteSet(transaction.deleteSet, this.id.client, this.id.clock, this.length);
                    $281a441cdcb2cf36$var$addChangedTypeToTransaction(transaction, parent, this.parentSub);
                    this.content.delete(transaction);
                }
            }
            /**
       * @param {StructStore} store
       * @param {boolean} parentGCd
       */ gc(store, parentGCd) {
                if (!this.deleted) throw $281a441cdcb2cf36$var$unexpectedCase();
                this.content.gc(store);
                if (parentGCd) $281a441cdcb2cf36$var$replaceStruct(store, this, new $281a441cdcb2cf36$var$GC(this.id, this.length));
                else this.content = new $281a441cdcb2cf36$var$ContentDeleted(this.length);
            }
            /**
       * Transform the properties of this type to binary and write it to an
       * BinaryEncoder.
       *
       * This is called when this Item is sent to a remote peer.
       *
       * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
       * @param {number} offset
       */ write(encoder, offset2) {
                const origin = offset2 > 0 ? $281a441cdcb2cf36$var$createID(this.id.client, this.id.clock + offset2 - 1) : this.origin;
                const rightOrigin = this.rightOrigin;
                const parentSub = this.parentSub;
                const info = this.content.getRef() & $281a441cdcb2cf36$var$BITS5 | (origin === null ? 0 : $281a441cdcb2cf36$var$BIT8) | // origin is defined
                (rightOrigin === null ? 0 : $281a441cdcb2cf36$var$BIT7) | // right origin is defined
                (parentSub === null ? 0 : $281a441cdcb2cf36$var$BIT6);
                encoder.writeInfo(info);
                if (origin !== null) encoder.writeLeftID(origin);
                if (rightOrigin !== null) encoder.writeRightID(rightOrigin);
                if (origin === null && rightOrigin === null) {
                    const parent = /** @type {AbstractType<any>} */ this.parent;
                    if (parent._item !== void 0) {
                        const parentItem = parent._item;
                        if (parentItem === null) {
                            const ykey = $281a441cdcb2cf36$var$findRootTypeKey(parent);
                            encoder.writeParentInfo(true);
                            encoder.writeString(ykey);
                        } else {
                            encoder.writeParentInfo(false);
                            encoder.writeLeftID(parentItem.id);
                        }
                    } else if (parent.constructor === String) {
                        encoder.writeParentInfo(true);
                        encoder.writeString(parent);
                    } else if (parent.constructor === $281a441cdcb2cf36$var$ID) {
                        encoder.writeParentInfo(false);
                        encoder.writeLeftID(parent);
                    } else $281a441cdcb2cf36$var$unexpectedCase();
                    if (parentSub !== null) encoder.writeString(parentSub);
                }
                this.content.write(encoder, offset2);
            }
        };
        $281a441cdcb2cf36$var$readItemContent = (decoder, info)=>$281a441cdcb2cf36$var$contentRefs[info & $281a441cdcb2cf36$var$BITS5](decoder);
        $281a441cdcb2cf36$var$contentRefs = [
            ()=>{
                $281a441cdcb2cf36$var$unexpectedCase();
            },
            // GC is not ItemContent
            $281a441cdcb2cf36$var$readContentDeleted,
            // 1
            $281a441cdcb2cf36$var$readContentJSON,
            // 2
            $281a441cdcb2cf36$var$readContentBinary,
            // 3
            $281a441cdcb2cf36$var$readContentString,
            // 4
            $281a441cdcb2cf36$var$readContentEmbed,
            // 5
            $281a441cdcb2cf36$var$readContentFormat,
            // 6
            $281a441cdcb2cf36$var$readContentType,
            // 7
            $281a441cdcb2cf36$var$readContentAny,
            // 8
            $281a441cdcb2cf36$var$readContentDoc,
            // 9
            ()=>{
                $281a441cdcb2cf36$var$unexpectedCase();
            }
        ];
        $281a441cdcb2cf36$var$structSkipRefNumber = 10;
        $281a441cdcb2cf36$var$Skip = class extends $281a441cdcb2cf36$var$AbstractStruct {
            get deleted() {
                return true;
            }
            delete() {}
            /**
       * @param {Skip} right
       * @return {boolean}
       */ mergeWith(right) {
                if (this.constructor !== right.constructor) return false;
                this.length += right.length;
                return true;
            }
            /**
       * @param {Transaction} transaction
       * @param {number} offset
       */ integrate(transaction, offset2) {
                $281a441cdcb2cf36$var$unexpectedCase();
            }
            /**
       * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
       * @param {number} offset
       */ write(encoder, offset2) {
                encoder.writeInfo($281a441cdcb2cf36$var$structSkipRefNumber);
                $281a441cdcb2cf36$var$writeVarUint(encoder.restEncoder, this.length - offset2);
            }
            /**
       * @param {Transaction} transaction
       * @param {StructStore} store
       * @return {null | number}
       */ getMissing(transaction, store) {
                return null;
            }
        };
        $281a441cdcb2cf36$var$glo = /** @type {any} */ typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {};
        $281a441cdcb2cf36$var$importIdentifier = "__ $YJS$ __";
        if ($281a441cdcb2cf36$var$glo[$281a441cdcb2cf36$var$importIdentifier] === true) console.error("Yjs was already imported. This breaks constructor checks and will lead to issues! - https://github.com/yjs/yjs/issues/438");
        $281a441cdcb2cf36$var$glo[$281a441cdcb2cf36$var$importIdentifier] = true;
    }
});
// ../node_modules/lib0/indexeddb.js
var $281a441cdcb2cf36$var$rtop, $281a441cdcb2cf36$var$openDB, $281a441cdcb2cf36$var$deleteDB, $281a441cdcb2cf36$var$createStores, $281a441cdcb2cf36$var$transact2, $281a441cdcb2cf36$var$count, $281a441cdcb2cf36$var$get, $281a441cdcb2cf36$var$del, $281a441cdcb2cf36$var$put, $281a441cdcb2cf36$var$addAutoKey, $281a441cdcb2cf36$var$getAll, $281a441cdcb2cf36$var$queryFirst, $281a441cdcb2cf36$var$getLastKey, $281a441cdcb2cf36$var$iterateOnRequest, $281a441cdcb2cf36$var$iterateKeys, $281a441cdcb2cf36$var$getStore, $281a441cdcb2cf36$var$createIDBKeyRangeUpperBound, $281a441cdcb2cf36$var$createIDBKeyRangeLowerBound;
var $281a441cdcb2cf36$var$init_indexeddb = $281a441cdcb2cf36$var$__esm({
    "../node_modules/lib0/indexeddb.js" () {
        $281a441cdcb2cf36$var$init_promise();
        $281a441cdcb2cf36$var$init_error();
        $281a441cdcb2cf36$var$rtop = (request)=>$281a441cdcb2cf36$var$create4((resolve, reject)=>{
                request.onerror = (event)=>reject(new Error(event.target.error));
                request.onsuccess = (event)=>resolve(event.target.result);
            });
        $281a441cdcb2cf36$var$openDB = (name, initDB)=>$281a441cdcb2cf36$var$create4((resolve, reject)=>{
                const request = indexedDB.open(name);
                request.onupgradeneeded = (event)=>initDB(event.target.result);
                request.onerror = (event)=>reject($281a441cdcb2cf36$var$create3(event.target.error));
                request.onsuccess = (event)=>{
                    const db = event.target.result;
                    db.onversionchange = ()=>{
                        db.close();
                    };
                    resolve(db);
                };
            });
        $281a441cdcb2cf36$var$deleteDB = (name)=>$281a441cdcb2cf36$var$rtop(indexedDB.deleteDatabase(name));
        $281a441cdcb2cf36$var$createStores = (db, definitions)=>definitions.forEach((d3)=>// @ts-ignore
                db.createObjectStore.apply(db, d3));
        $281a441cdcb2cf36$var$transact2 = (db, stores, access = "readwrite")=>{
            const transaction = db.transaction(stores, access);
            return stores.map((store)=>$281a441cdcb2cf36$var$getStore(transaction, store));
        };
        $281a441cdcb2cf36$var$count = (store, range)=>$281a441cdcb2cf36$var$rtop(store.count(range));
        $281a441cdcb2cf36$var$get = (store, key)=>$281a441cdcb2cf36$var$rtop(store.get(key));
        $281a441cdcb2cf36$var$del = (store, key)=>$281a441cdcb2cf36$var$rtop(store.delete(key));
        $281a441cdcb2cf36$var$put = (store, item, key)=>$281a441cdcb2cf36$var$rtop(store.put(item, key));
        $281a441cdcb2cf36$var$addAutoKey = (store, item)=>$281a441cdcb2cf36$var$rtop(store.add(item));
        $281a441cdcb2cf36$var$getAll = (store, range, limit)=>$281a441cdcb2cf36$var$rtop(store.getAll(range, limit));
        $281a441cdcb2cf36$var$queryFirst = (store, query, direction)=>{
            let first = null;
            return $281a441cdcb2cf36$var$iterateKeys(store, query, (key)=>{
                first = key;
                return false;
            }, direction).then(()=>first);
        };
        $281a441cdcb2cf36$var$getLastKey = (store, range = null)=>$281a441cdcb2cf36$var$queryFirst(store, range, "prev");
        $281a441cdcb2cf36$var$iterateOnRequest = (request, f3)=>$281a441cdcb2cf36$var$create4((resolve, reject)=>{
                request.onerror = reject;
                request.onsuccess = async (event)=>{
                    const cursor = event.target.result;
                    if (cursor === null || await f3(cursor) === false) return resolve();
                    cursor.continue();
                };
            });
        $281a441cdcb2cf36$var$iterateKeys = (store, keyrange, f3, direction = "next")=>$281a441cdcb2cf36$var$iterateOnRequest(store.openKeyCursor(keyrange, direction), (cursor)=>f3(cursor.key));
        $281a441cdcb2cf36$var$getStore = (t4, store)=>t4.objectStore(store);
        $281a441cdcb2cf36$var$createIDBKeyRangeUpperBound = (upper, upperOpen)=>IDBKeyRange.upperBound(upper, upperOpen);
        $281a441cdcb2cf36$var$createIDBKeyRangeLowerBound = (lower, lowerOpen)=>IDBKeyRange.lowerBound(lower, lowerOpen);
    }
});
// ../node_modules/y-indexeddb/src/y-indexeddb.js
var $281a441cdcb2cf36$var$y_indexeddb_exports = {};
$281a441cdcb2cf36$var$__export($281a441cdcb2cf36$var$y_indexeddb_exports, {
    IndexeddbPersistence: ()=>$281a441cdcb2cf36$var$IndexeddbPersistence,
    PREFERRED_TRIM_SIZE: ()=>$281a441cdcb2cf36$var$PREFERRED_TRIM_SIZE,
    clearDocument: ()=>$281a441cdcb2cf36$var$clearDocument,
    fetchUpdates: ()=>$281a441cdcb2cf36$var$fetchUpdates,
    storeState: ()=>$281a441cdcb2cf36$var$storeState
});
var $281a441cdcb2cf36$var$customStoreName, $281a441cdcb2cf36$var$updatesStoreName, $281a441cdcb2cf36$var$PREFERRED_TRIM_SIZE, $281a441cdcb2cf36$var$fetchUpdates, $281a441cdcb2cf36$var$storeState, $281a441cdcb2cf36$var$clearDocument, $281a441cdcb2cf36$var$IndexeddbPersistence;
var $281a441cdcb2cf36$var$init_y_indexeddb = $281a441cdcb2cf36$var$__esm({
    "../node_modules/y-indexeddb/src/y-indexeddb.js" () {
        $281a441cdcb2cf36$var$init_yjs();
        $281a441cdcb2cf36$var$init_indexeddb();
        $281a441cdcb2cf36$var$init_promise();
        $281a441cdcb2cf36$var$init_observable();
        $281a441cdcb2cf36$var$customStoreName = "custom";
        $281a441cdcb2cf36$var$updatesStoreName = "updates";
        $281a441cdcb2cf36$var$PREFERRED_TRIM_SIZE = 500;
        $281a441cdcb2cf36$var$fetchUpdates = (idbPersistence, beforeApplyUpdatesCallback = ()=>{}, afterApplyUpdatesCallback = ()=>{})=>{
            const [updatesStore] = $281a441cdcb2cf36$var$transact2(/** @type {IDBDatabase} */ idbPersistence.db, [
                $281a441cdcb2cf36$var$updatesStoreName
            ]);
            return $281a441cdcb2cf36$var$getAll(updatesStore, $281a441cdcb2cf36$var$createIDBKeyRangeLowerBound(idbPersistence._dbref, false)).then((updates)=>{
                if (!idbPersistence._destroyed) {
                    beforeApplyUpdatesCallback(updatesStore);
                    $281a441cdcb2cf36$var$transact(idbPersistence.doc, ()=>{
                        updates.forEach((val)=>$281a441cdcb2cf36$var$applyUpdate(idbPersistence.doc, val));
                    }, idbPersistence, false);
                    afterApplyUpdatesCallback(updatesStore);
                }
            }).then(()=>$281a441cdcb2cf36$var$getLastKey(updatesStore).then((lastKey)=>{
                    idbPersistence._dbref = lastKey + 1;
                })).then(()=>$281a441cdcb2cf36$var$count(updatesStore).then((cnt)=>{
                    idbPersistence._dbsize = cnt;
                })).then(()=>updatesStore);
        };
        $281a441cdcb2cf36$var$storeState = (idbPersistence, forceStore = true)=>$281a441cdcb2cf36$var$fetchUpdates(idbPersistence).then((updatesStore)=>{
                if (forceStore || idbPersistence._dbsize >= $281a441cdcb2cf36$var$PREFERRED_TRIM_SIZE) $281a441cdcb2cf36$var$addAutoKey(updatesStore, $281a441cdcb2cf36$var$encodeStateAsUpdate(idbPersistence.doc)).then(()=>$281a441cdcb2cf36$var$del(updatesStore, $281a441cdcb2cf36$var$createIDBKeyRangeUpperBound(idbPersistence._dbref, true))).then(()=>$281a441cdcb2cf36$var$count(updatesStore).then((cnt)=>{
                        idbPersistence._dbsize = cnt;
                    }));
            });
        $281a441cdcb2cf36$var$clearDocument = (name)=>$281a441cdcb2cf36$var$deleteDB(name);
        $281a441cdcb2cf36$var$IndexeddbPersistence = class extends $281a441cdcb2cf36$var$Observable {
            /**
       * @param {string} name
       * @param {Y.Doc} doc
       */ constructor(name, doc2){
                super();
                this.doc = doc2;
                this.name = name;
                this._dbref = 0;
                this._dbsize = 0;
                this._destroyed = false;
                this.db = null;
                this.synced = false;
                this._db = $281a441cdcb2cf36$var$openDB(name, (db)=>$281a441cdcb2cf36$var$createStores(db, [
                        [
                            "updates",
                            {
                                autoIncrement: true
                            }
                        ],
                        [
                            "custom"
                        ]
                    ]));
                this.whenSynced = $281a441cdcb2cf36$var$create4((resolve)=>this.on("synced", ()=>resolve(this)));
                this._db.then((db)=>{
                    this.db = db;
                    const beforeApplyUpdatesCallback = (updatesStore)=>$281a441cdcb2cf36$var$addAutoKey(updatesStore, $281a441cdcb2cf36$var$encodeStateAsUpdate(doc2));
                    const afterApplyUpdatesCallback = ()=>{
                        if (this._destroyed) return this;
                        this.synced = true;
                        this.emit("synced", [
                            this
                        ]);
                    };
                    $281a441cdcb2cf36$var$fetchUpdates(this, beforeApplyUpdatesCallback, afterApplyUpdatesCallback);
                });
                this._storeTimeout = 1e3;
                this._storeTimeoutId = null;
                this._storeUpdate = (update, origin)=>{
                    if (this.db && origin !== this) {
                        const [updatesStore] = $281a441cdcb2cf36$var$transact2(/** @type {IDBDatabase} */ this.db, [
                            $281a441cdcb2cf36$var$updatesStoreName
                        ]);
                        $281a441cdcb2cf36$var$addAutoKey(updatesStore, update);
                        if (++this._dbsize >= $281a441cdcb2cf36$var$PREFERRED_TRIM_SIZE) {
                            if (this._storeTimeoutId !== null) clearTimeout(this._storeTimeoutId);
                            this._storeTimeoutId = setTimeout(()=>{
                                $281a441cdcb2cf36$var$storeState(this, false);
                                this._storeTimeoutId = null;
                            }, this._storeTimeout);
                        }
                    }
                };
                doc2.on("update", this._storeUpdate);
                this.destroy = this.destroy.bind(this);
                doc2.on("destroy", this.destroy);
            }
            destroy() {
                if (this._storeTimeoutId) clearTimeout(this._storeTimeoutId);
                this.doc.off("update", this._storeUpdate);
                this.doc.off("destroy", this.destroy);
                this._destroyed = true;
                return this._db.then((db)=>{
                    db.close();
                });
            }
            /**
       * Destroys this instance and removes all data from indexeddb.
       *
       * @return {Promise<void>}
       */ clearData() {
                return this.destroy().then(()=>{
                    $281a441cdcb2cf36$var$deleteDB(this.name);
                });
            }
            /**
       * @param {String | number | ArrayBuffer | Date} key
       * @return {Promise<String | number | ArrayBuffer | Date | any>}
       */ get(key) {
                return this._db.then((db)=>{
                    const [custom] = $281a441cdcb2cf36$var$transact2(db, [
                        $281a441cdcb2cf36$var$customStoreName
                    ], "readonly");
                    return $281a441cdcb2cf36$var$get(custom, key);
                });
            }
            /**
       * @param {String | number | ArrayBuffer | Date} key
       * @param {String | number | ArrayBuffer | Date} value
       * @return {Promise<String | number | ArrayBuffer | Date>}
       */ set(key, value2) {
                return this._db.then((db)=>{
                    const [custom] = $281a441cdcb2cf36$var$transact2(db, [
                        $281a441cdcb2cf36$var$customStoreName
                    ]);
                    return $281a441cdcb2cf36$var$put(custom, value2, key);
                });
            }
            /**
       * @param {String | number | ArrayBuffer | Date} key
       * @return {Promise<undefined>}
       */ del(key) {
                return this._db.then((db)=>{
                    const [custom] = $281a441cdcb2cf36$var$transact2(db, [
                        $281a441cdcb2cf36$var$customStoreName
                    ]);
                    return $281a441cdcb2cf36$var$del(custom, key);
                });
            }
        };
    }
});
// ../node_modules/dexie/dist/dexie.js
var $281a441cdcb2cf36$var$require_dexie = $281a441cdcb2cf36$var$__commonJS({
    "../node_modules/dexie/dist/dexie.js" (exports, module) {
        (function(global3, factory) {
            typeof exports === "object" && typeof module !== "undefined" ? module.exports = factory() : typeof define === "function" && define.amd ? define(factory) : (global3 = typeof globalThis !== "undefined" ? globalThis : global3 || self, global3.Dexie = factory());
        })(exports, function() {
            "use strict";
            var extendStatics = function(d3, b3) {
                extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d4, b4) {
                    d4.__proto__ = b4;
                } || function(d4, b4) {
                    for(var p3 in b4)if (Object.prototype.hasOwnProperty.call(b4, p3)) d4[p3] = b4[p3];
                };
                return extendStatics(d3, b3);
            };
            function __extends(d3, b3) {
                if (typeof b3 !== "function" && b3 !== null) throw new TypeError("Class extends value " + String(b3) + " is not a constructor or null");
                extendStatics(d3, b3);
                function __() {
                    this.constructor = d3;
                }
                d3.prototype = b3 === null ? Object.create(b3) : (__.prototype = b3.prototype, new __());
            }
            var __assign = function() {
                __assign = Object.assign || function __assign2(t4) {
                    for(var s3, i3 = 1, n3 = arguments.length; i3 < n3; i3++){
                        s3 = arguments[i3];
                        for(var p3 in s3)if (Object.prototype.hasOwnProperty.call(s3, p3)) t4[p3] = s3[p3];
                    }
                    return t4;
                };
                return __assign.apply(this, arguments);
            };
            function __spreadArray(to, from2, pack) {
                if (pack || arguments.length === 2) {
                    for(var i3 = 0, l3 = from2.length, ar; i3 < l3; i3++)if (ar || !(i3 in from2)) {
                        if (!ar) ar = Array.prototype.slice.call(from2, 0, i3);
                        ar[i3] = from2[i3];
                    }
                }
                return to.concat(ar || Array.prototype.slice.call(from2));
            }
            typeof SuppressedError === "function" && SuppressedError;
            var _global3 = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
            var keys2 = Object.keys;
            var isArray5 = Array.isArray;
            if (typeof Promise !== "undefined" && !_global3.Promise) _global3.Promise = Promise;
            function extend2(obj, extension) {
                if (typeof extension !== "object") return obj;
                keys2(extension).forEach(function(key) {
                    obj[key] = extension[key];
                });
                return obj;
            }
            var getProto = Object.getPrototypeOf;
            var _hasOwn = {}.hasOwnProperty;
            function hasOwn2(obj, prop) {
                return _hasOwn.call(obj, prop);
            }
            function props(proto, extension) {
                if (typeof extension === "function") extension = extension(getProto(proto));
                (typeof Reflect === "undefined" ? keys2 : Reflect.ownKeys)(extension).forEach(function(key) {
                    setProp(proto, key, extension[key]);
                });
            }
            var defineProperty2 = Object.defineProperty;
            function setProp(obj, prop, functionOrGetSet, options) {
                defineProperty2(obj, prop, extend2(functionOrGetSet && hasOwn2(functionOrGetSet, "get") && typeof functionOrGetSet.get === "function" ? {
                    get: functionOrGetSet.get,
                    set: functionOrGetSet.set,
                    configurable: true
                } : {
                    value: functionOrGetSet,
                    configurable: true,
                    writable: true
                }, options));
            }
            function derive(Child) {
                return {
                    from: function(Parent) {
                        Child.prototype = Object.create(Parent.prototype);
                        setProp(Child.prototype, "constructor", Child);
                        return {
                            extend: props.bind(null, Child.prototype)
                        };
                    }
                };
            }
            var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
            function getPropertyDescriptor(obj, prop) {
                var pd = getOwnPropertyDescriptor(obj, prop);
                var proto;
                return pd || (proto = getProto(obj)) && getPropertyDescriptor(proto, prop);
            }
            var _slice = [].slice;
            function slice(args2, start, end) {
                return _slice.call(args2, start, end);
            }
            function override(origFunc, overridedFactory) {
                return overridedFactory(origFunc);
            }
            function assert2(b3) {
                if (!b3) throw new Error("Assertion Failed");
            }
            function asap$1(fn) {
                if (_global3.setImmediate) setImmediate(fn);
                else setTimeout(fn, 0);
            }
            function arrayToObject(array, extractor) {
                return array.reduce(function(result, item, i3) {
                    var nameAndValue = extractor(item, i3);
                    if (nameAndValue) result[nameAndValue[0]] = nameAndValue[1];
                    return result;
                }, {});
            }
            function getByKeyPath(obj, keyPath) {
                if (typeof keyPath === "string" && hasOwn2(obj, keyPath)) return obj[keyPath];
                if (!keyPath) return obj;
                if (typeof keyPath !== "string") {
                    var rv = [];
                    for(var i3 = 0, l3 = keyPath.length; i3 < l3; ++i3){
                        var val = getByKeyPath(obj, keyPath[i3]);
                        rv.push(val);
                    }
                    return rv;
                }
                var period = keyPath.indexOf(".");
                if (period !== -1) {
                    var innerObj = obj[keyPath.substr(0, period)];
                    return innerObj == null ? void 0 : getByKeyPath(innerObj, keyPath.substr(period + 1));
                }
                return void 0;
            }
            function setByKeyPath(obj, keyPath, value2) {
                if (!obj || keyPath === void 0) return;
                if ("isFrozen" in Object && Object.isFrozen(obj)) return;
                if (typeof keyPath !== "string" && "length" in keyPath) {
                    assert2(typeof value2 !== "string" && "length" in value2);
                    for(var i3 = 0, l3 = keyPath.length; i3 < l3; ++i3)setByKeyPath(obj, keyPath[i3], value2[i3]);
                } else {
                    var period = keyPath.indexOf(".");
                    if (period !== -1) {
                        var currentKeyPath = keyPath.substr(0, period);
                        var remainingKeyPath = keyPath.substr(period + 1);
                        if (remainingKeyPath === "") {
                            if (value2 === void 0) {
                                if (isArray5(obj) && !isNaN(parseInt(currentKeyPath))) obj.splice(currentKeyPath, 1);
                                else delete obj[currentKeyPath];
                            } else obj[currentKeyPath] = value2;
                        } else {
                            var innerObj = obj[currentKeyPath];
                            if (!innerObj || !hasOwn2(obj, currentKeyPath)) innerObj = obj[currentKeyPath] = {};
                            setByKeyPath(innerObj, remainingKeyPath, value2);
                        }
                    } else if (value2 === void 0) {
                        if (isArray5(obj) && !isNaN(parseInt(keyPath))) obj.splice(keyPath, 1);
                        else delete obj[keyPath];
                    } else obj[keyPath] = value2;
                }
            }
            function delByKeyPath(obj, keyPath) {
                if (typeof keyPath === "string") setByKeyPath(obj, keyPath, void 0);
                else if ("length" in keyPath) [].map.call(keyPath, function(kp) {
                    setByKeyPath(obj, kp, void 0);
                });
            }
            function shallowClone(obj) {
                var rv = {};
                for(var m3 in obj)if (hasOwn2(obj, m3)) rv[m3] = obj[m3];
                return rv;
            }
            var concat = [].concat;
            function flatten(a3) {
                return concat.apply([], a3);
            }
            var intrinsicTypeNames = "BigUint64Array,BigInt64Array,Array,Boolean,String,Date,RegExp,Blob,File,FileList,FileSystemFileHandle,FileSystemDirectoryHandle,ArrayBuffer,DataView,Uint8ClampedArray,ImageBitmap,ImageData,Map,Set,CryptoKey".split(",").concat(flatten([
                8,
                16,
                32,
                64
            ].map(function(num) {
                return [
                    "Int",
                    "Uint",
                    "Float"
                ].map(function(t4) {
                    return t4 + num + "Array";
                });
            }))).filter(function(t4) {
                return _global3[t4];
            });
            var intrinsicTypes = new Set(intrinsicTypeNames.map(function(t4) {
                return _global3[t4];
            }));
            function cloneSimpleObjectTree(o3) {
                var rv = {};
                for(var k3 in o3)if (hasOwn2(o3, k3)) {
                    var v3 = o3[k3];
                    rv[k3] = !v3 || typeof v3 !== "object" || intrinsicTypes.has(v3.constructor) ? v3 : cloneSimpleObjectTree(v3);
                }
                return rv;
            }
            var circularRefs = null;
            function deepClone2(any2) {
                circularRefs = /* @__PURE__ */ new WeakMap();
                var rv = innerDeepClone(any2);
                circularRefs = null;
                return rv;
            }
            function innerDeepClone(x3) {
                if (!x3 || typeof x3 !== "object") return x3;
                var rv = circularRefs.get(x3);
                if (rv) return rv;
                if (isArray5(x3)) {
                    rv = [];
                    circularRefs.set(x3, rv);
                    for(var i3 = 0, l3 = x3.length; i3 < l3; ++i3)rv.push(innerDeepClone(x3[i3]));
                } else if (intrinsicTypes.has(x3.constructor)) rv = x3;
                else {
                    var proto = getProto(x3);
                    rv = proto === Object.prototype ? {} : Object.create(proto);
                    circularRefs.set(x3, rv);
                    for(var prop in x3)if (hasOwn2(x3, prop)) rv[prop] = innerDeepClone(x3[prop]);
                }
                return rv;
            }
            var toString3 = {}.toString;
            function toStringTag(o3) {
                return toString3.call(o3).slice(8, -1);
            }
            var iteratorSymbol = typeof Symbol !== "undefined" ? Symbol.iterator : "@@iterator";
            var getIteratorOf = typeof iteratorSymbol === "symbol" ? function(x3) {
                var i3;
                return x3 != null && (i3 = x3[iteratorSymbol]) && i3.apply(x3);
            } : function() {
                return null;
            };
            function delArrayItem(a3, x3) {
                var i3 = a3.indexOf(x3);
                if (i3 >= 0) a3.splice(i3, 1);
                return i3 >= 0;
            }
            var NO_CHAR_ARRAY = {};
            function getArrayOf(arrayLike) {
                var i3, a3, x3, it2;
                if (arguments.length === 1) {
                    if (isArray5(arrayLike)) return arrayLike.slice();
                    if (this === NO_CHAR_ARRAY && typeof arrayLike === "string") return [
                        arrayLike
                    ];
                    if (it2 = getIteratorOf(arrayLike)) {
                        a3 = [];
                        while(x3 = it2.next(), !x3.done)a3.push(x3.value);
                        return a3;
                    }
                    if (arrayLike == null) return [
                        arrayLike
                    ];
                    i3 = arrayLike.length;
                    if (typeof i3 === "number") {
                        a3 = new Array(i3);
                        while(i3--)a3[i3] = arrayLike[i3];
                        return a3;
                    }
                    return [
                        arrayLike
                    ];
                }
                i3 = arguments.length;
                a3 = new Array(i3);
                while(i3--)a3[i3] = arguments[i3];
                return a3;
            }
            var isAsyncFunction = typeof Symbol !== "undefined" ? function(fn) {
                return fn[Symbol.toStringTag] === "AsyncFunction";
            } : function() {
                return false;
            };
            var dexieErrorNames = [
                "Modify",
                "Bulk",
                "OpenFailed",
                "VersionChange",
                "Schema",
                "Upgrade",
                "InvalidTable",
                "MissingAPI",
                "NoSuchDatabase",
                "InvalidArgument",
                "SubTransaction",
                "Unsupported",
                "Internal",
                "DatabaseClosed",
                "PrematureCommit",
                "ForeignAwait"
            ];
            var idbDomErrorNames = [
                "Unknown",
                "Constraint",
                "Data",
                "TransactionInactive",
                "ReadOnly",
                "Version",
                "NotFound",
                "InvalidState",
                "InvalidAccess",
                "Abort",
                "Timeout",
                "QuotaExceeded",
                "Syntax",
                "DataClone"
            ];
            var errorList = dexieErrorNames.concat(idbDomErrorNames);
            var defaultTexts = {
                VersionChanged: "Database version changed by other database connection",
                DatabaseClosed: "Database has been closed",
                Abort: "Transaction aborted",
                TransactionInactive: "Transaction has already completed or failed",
                MissingAPI: "IndexedDB API missing. Please visit https://tinyurl.com/y2uuvskb"
            };
            function DexieError(name, msg) {
                this.name = name;
                this.message = msg;
            }
            derive(DexieError).from(Error).extend({
                toString: function() {
                    return this.name + ": " + this.message;
                }
            });
            function getMultiErrorMessage(msg, failures) {
                return msg + ". Errors: " + Object.keys(failures).map(function(key) {
                    return failures[key].toString();
                }).filter(function(v3, i3, s3) {
                    return s3.indexOf(v3) === i3;
                }).join("\n");
            }
            function ModifyError(msg, failures, successCount, failedKeys) {
                this.failures = failures;
                this.failedKeys = failedKeys;
                this.successCount = successCount;
                this.message = getMultiErrorMessage(msg, failures);
            }
            derive(ModifyError).from(DexieError);
            function BulkError(msg, failures) {
                this.name = "BulkError";
                this.failures = Object.keys(failures).map(function(pos) {
                    return failures[pos];
                });
                this.failuresByPos = failures;
                this.message = getMultiErrorMessage(msg, this.failures);
            }
            derive(BulkError).from(DexieError);
            var errnames = errorList.reduce(function(obj, name) {
                return obj[name] = name + "Error", obj;
            }, {});
            var BaseException = DexieError;
            var exceptions = errorList.reduce(function(obj, name) {
                var fullName = name + "Error";
                function DexieError2(msgOrInner, inner) {
                    this.name = fullName;
                    if (!msgOrInner) {
                        this.message = defaultTexts[name] || fullName;
                        this.inner = null;
                    } else if (typeof msgOrInner === "string") {
                        this.message = "".concat(msgOrInner).concat(!inner ? "" : "\n " + inner);
                        this.inner = inner || null;
                    } else if (typeof msgOrInner === "object") {
                        this.message = "".concat(msgOrInner.name, " ").concat(msgOrInner.message);
                        this.inner = msgOrInner;
                    }
                }
                derive(DexieError2).from(BaseException);
                obj[name] = DexieError2;
                return obj;
            }, {});
            exceptions.Syntax = SyntaxError;
            exceptions.Type = TypeError;
            exceptions.Range = RangeError;
            var exceptionMap = idbDomErrorNames.reduce(function(obj, name) {
                obj[name + "Error"] = exceptions[name];
                return obj;
            }, {});
            function mapError(domError, message) {
                if (!domError || domError instanceof DexieError || domError instanceof TypeError || domError instanceof SyntaxError || !domError.name || !exceptionMap[domError.name]) return domError;
                var rv = new exceptionMap[domError.name](message || domError.message, domError);
                if ("stack" in domError) setProp(rv, "stack", {
                    get: function() {
                        return this.inner.stack;
                    }
                });
                return rv;
            }
            var fullNameExceptions = errorList.reduce(function(obj, name) {
                if ([
                    "Syntax",
                    "Type",
                    "Range"
                ].indexOf(name) === -1) obj[name + "Error"] = exceptions[name];
                return obj;
            }, {});
            fullNameExceptions.ModifyError = ModifyError;
            fullNameExceptions.DexieError = DexieError;
            fullNameExceptions.BulkError = BulkError;
            function nop() {}
            function mirror(val) {
                return val;
            }
            function pureFunctionChain(f1, f22) {
                if (f1 == null || f1 === mirror) return f22;
                return function(val) {
                    return f22(f1(val));
                };
            }
            function callBoth(on1, on2) {
                return function() {
                    on1.apply(this, arguments);
                    on2.apply(this, arguments);
                };
            }
            function hookCreatingChain(f1, f22) {
                if (f1 === nop) return f22;
                return function() {
                    var res = f1.apply(this, arguments);
                    if (res !== void 0) arguments[0] = res;
                    var onsuccess = this.onsuccess, onerror = this.onerror;
                    this.onsuccess = null;
                    this.onerror = null;
                    var res2 = f22.apply(this, arguments);
                    if (onsuccess) this.onsuccess = this.onsuccess ? callBoth(onsuccess, this.onsuccess) : onsuccess;
                    if (onerror) this.onerror = this.onerror ? callBoth(onerror, this.onerror) : onerror;
                    return res2 !== void 0 ? res2 : res;
                };
            }
            function hookDeletingChain(f1, f22) {
                if (f1 === nop) return f22;
                return function() {
                    f1.apply(this, arguments);
                    var onsuccess = this.onsuccess, onerror = this.onerror;
                    this.onsuccess = this.onerror = null;
                    f22.apply(this, arguments);
                    if (onsuccess) this.onsuccess = this.onsuccess ? callBoth(onsuccess, this.onsuccess) : onsuccess;
                    if (onerror) this.onerror = this.onerror ? callBoth(onerror, this.onerror) : onerror;
                };
            }
            function hookUpdatingChain(f1, f22) {
                if (f1 === nop) return f22;
                return function(modifications) {
                    var res = f1.apply(this, arguments);
                    extend2(modifications, res);
                    var onsuccess = this.onsuccess, onerror = this.onerror;
                    this.onsuccess = null;
                    this.onerror = null;
                    var res2 = f22.apply(this, arguments);
                    if (onsuccess) this.onsuccess = this.onsuccess ? callBoth(onsuccess, this.onsuccess) : onsuccess;
                    if (onerror) this.onerror = this.onerror ? callBoth(onerror, this.onerror) : onerror;
                    return res === void 0 ? res2 === void 0 ? void 0 : res2 : extend2(res, res2);
                };
            }
            function reverseStoppableEventChain(f1, f22) {
                if (f1 === nop) return f22;
                return function() {
                    if (f22.apply(this, arguments) === false) return false;
                    return f1.apply(this, arguments);
                };
            }
            function promisableChain(f1, f22) {
                if (f1 === nop) return f22;
                return function() {
                    var res = f1.apply(this, arguments);
                    if (res && typeof res.then === "function") {
                        var thiz = this, i3 = arguments.length, args2 = new Array(i3);
                        while(i3--)args2[i3] = arguments[i3];
                        return res.then(function() {
                            return f22.apply(thiz, args2);
                        });
                    }
                    return f22.apply(this, arguments);
                };
            }
            var debug = typeof location !== "undefined" && /^(http|https):\/\/(localhost|127\.0\.0\.1)/.test(location.href);
            function setDebug2(value2, filter) {
                debug = value2;
            }
            var INTERNAL = {};
            var ZONE_ECHO_LIMIT = 100, _a$1 = typeof Promise === "undefined" ? [] : function() {
                var globalP = Promise.resolve();
                if (typeof crypto === "undefined" || !crypto.subtle) return [
                    globalP,
                    getProto(globalP),
                    globalP
                ];
                var nativeP = crypto.subtle.digest("SHA-512", new Uint8Array([
                    0
                ]));
                return [
                    nativeP,
                    getProto(nativeP),
                    globalP
                ];
            }(), resolvedNativePromise = _a$1[0], nativePromiseProto = _a$1[1], resolvedGlobalPromise = _a$1[2], nativePromiseThen = nativePromiseProto && nativePromiseProto.then;
            var NativePromise = resolvedNativePromise && resolvedNativePromise.constructor;
            var patchGlobalPromise = !!resolvedGlobalPromise;
            function schedulePhysicalTick() {
                queueMicrotask(physicalTick);
            }
            var asap = function(callback, args2) {
                microtickQueue.push([
                    callback,
                    args2
                ]);
                if (needsNewPhysicalTick) {
                    schedulePhysicalTick();
                    needsNewPhysicalTick = false;
                }
            };
            var isOutsideMicroTick = true, needsNewPhysicalTick = true, unhandledErrors = [], rejectingErrors = [], rejectionMapper = mirror;
            var globalPSD = {
                id: "global",
                global: true,
                ref: 0,
                unhandleds: [],
                onunhandled: nop,
                pgp: false,
                env: {},
                finalize: nop
            };
            var PSD = globalPSD;
            var microtickQueue = [];
            var numScheduledCalls = 0;
            var tickFinalizers = [];
            function DexiePromise(fn) {
                if (typeof this !== "object") throw new TypeError("Promises must be constructed via new");
                this._listeners = [];
                this._lib = false;
                var psd = this._PSD = PSD;
                if (typeof fn !== "function") {
                    if (fn !== INTERNAL) throw new TypeError("Not a function");
                    this._state = arguments[1];
                    this._value = arguments[2];
                    if (this._state === false) handleRejection(this, this._value);
                    return;
                }
                this._state = null;
                this._value = null;
                ++psd.ref;
                executePromiseTask(this, fn);
            }
            var thenProp = {
                get: function() {
                    var psd = PSD, microTaskId = totalEchoes;
                    function then(onFulfilled, onRejected) {
                        var _this = this;
                        var possibleAwait = !psd.global && (psd !== PSD || microTaskId !== totalEchoes);
                        var cleanup = possibleAwait && !decrementExpectedAwaits();
                        var rv = new DexiePromise(function(resolve, reject) {
                            propagateToListener(_this, new Listener(nativeAwaitCompatibleWrap(onFulfilled, psd, possibleAwait, cleanup), nativeAwaitCompatibleWrap(onRejected, psd, possibleAwait, cleanup), resolve, reject, psd));
                        });
                        if (this._consoleTask) rv._consoleTask = this._consoleTask;
                        return rv;
                    }
                    then.prototype = INTERNAL;
                    return then;
                },
                set: function(value2) {
                    setProp(this, "then", value2 && value2.prototype === INTERNAL ? thenProp : {
                        get: function() {
                            return value2;
                        },
                        set: thenProp.set
                    });
                }
            };
            props(DexiePromise.prototype, {
                then: thenProp,
                _then: function(onFulfilled, onRejected) {
                    propagateToListener(this, new Listener(null, null, onFulfilled, onRejected, PSD));
                },
                catch: function(onRejected) {
                    if (arguments.length === 1) return this.then(null, onRejected);
                    var type2 = arguments[0], handler = arguments[1];
                    return typeof type2 === "function" ? this.then(null, function(err) {
                        return err instanceof type2 ? handler(err) : PromiseReject(err);
                    }) : this.then(null, function(err) {
                        return err && err.name === type2 ? handler(err) : PromiseReject(err);
                    });
                },
                finally: function(onFinally) {
                    return this.then(function(value2) {
                        return DexiePromise.resolve(onFinally()).then(function() {
                            return value2;
                        });
                    }, function(err) {
                        return DexiePromise.resolve(onFinally()).then(function() {
                            return PromiseReject(err);
                        });
                    });
                },
                timeout: function(ms, msg) {
                    var _this = this;
                    return ms < Infinity ? new DexiePromise(function(resolve, reject) {
                        var handle = setTimeout(function() {
                            return reject(new exceptions.Timeout(msg));
                        }, ms);
                        _this.then(resolve, reject).finally(clearTimeout.bind(null, handle));
                    }) : this;
                }
            });
            if (typeof Symbol !== "undefined" && Symbol.toStringTag) setProp(DexiePromise.prototype, Symbol.toStringTag, "Dexie.Promise");
            globalPSD.env = snapShot();
            function Listener(onFulfilled, onRejected, resolve, reject, zone) {
                this.onFulfilled = typeof onFulfilled === "function" ? onFulfilled : null;
                this.onRejected = typeof onRejected === "function" ? onRejected : null;
                this.resolve = resolve;
                this.reject = reject;
                this.psd = zone;
            }
            props(DexiePromise, {
                all: function() {
                    var values = getArrayOf.apply(null, arguments).map(onPossibleParallellAsync);
                    return new DexiePromise(function(resolve, reject) {
                        if (values.length === 0) resolve([]);
                        var remaining = values.length;
                        values.forEach(function(a3, i3) {
                            return DexiePromise.resolve(a3).then(function(x3) {
                                values[i3] = x3;
                                if (!--remaining) resolve(values);
                            }, reject);
                        });
                    });
                },
                resolve: function(value2) {
                    if (value2 instanceof DexiePromise) return value2;
                    if (value2 && typeof value2.then === "function") return new DexiePromise(function(resolve, reject) {
                        value2.then(resolve, reject);
                    });
                    var rv = new DexiePromise(INTERNAL, true, value2);
                    return rv;
                },
                reject: PromiseReject,
                race: function() {
                    var values = getArrayOf.apply(null, arguments).map(onPossibleParallellAsync);
                    return new DexiePromise(function(resolve, reject) {
                        values.map(function(value2) {
                            return DexiePromise.resolve(value2).then(resolve, reject);
                        });
                    });
                },
                PSD: {
                    get: function() {
                        return PSD;
                    },
                    set: function(value2) {
                        return PSD = value2;
                    }
                },
                totalEchoes: {
                    get: function() {
                        return totalEchoes;
                    }
                },
                newPSD: newScope,
                usePSD: usePSD,
                scheduler: {
                    get: function() {
                        return asap;
                    },
                    set: function(value2) {
                        asap = value2;
                    }
                },
                rejectionMapper: {
                    get: function() {
                        return rejectionMapper;
                    },
                    set: function(value2) {
                        rejectionMapper = value2;
                    }
                },
                follow: function(fn, zoneProps) {
                    return new DexiePromise(function(resolve, reject) {
                        return newScope(function(resolve2, reject2) {
                            var psd = PSD;
                            psd.unhandleds = [];
                            psd.onunhandled = reject2;
                            psd.finalize = callBoth(function() {
                                var _this = this;
                                run_at_end_of_this_or_next_physical_tick(function() {
                                    _this.unhandleds.length === 0 ? resolve2() : reject2(_this.unhandleds[0]);
                                });
                            }, psd.finalize);
                            fn();
                        }, zoneProps, resolve, reject);
                    });
                }
            });
            if (NativePromise) {
                if (NativePromise.allSettled) setProp(DexiePromise, "allSettled", function() {
                    var possiblePromises = getArrayOf.apply(null, arguments).map(onPossibleParallellAsync);
                    return new DexiePromise(function(resolve) {
                        if (possiblePromises.length === 0) resolve([]);
                        var remaining = possiblePromises.length;
                        var results = new Array(remaining);
                        possiblePromises.forEach(function(p3, i3) {
                            return DexiePromise.resolve(p3).then(function(value2) {
                                return results[i3] = {
                                    status: "fulfilled",
                                    value: value2
                                };
                            }, function(reason) {
                                return results[i3] = {
                                    status: "rejected",
                                    reason: reason
                                };
                            }).then(function() {
                                return --remaining || resolve(results);
                            });
                        });
                    });
                });
                if (NativePromise.any && typeof AggregateError !== "undefined") setProp(DexiePromise, "any", function() {
                    var possiblePromises = getArrayOf.apply(null, arguments).map(onPossibleParallellAsync);
                    return new DexiePromise(function(resolve, reject) {
                        if (possiblePromises.length === 0) reject(new AggregateError([]));
                        var remaining = possiblePromises.length;
                        var failures = new Array(remaining);
                        possiblePromises.forEach(function(p3, i3) {
                            return DexiePromise.resolve(p3).then(function(value2) {
                                return resolve(value2);
                            }, function(failure) {
                                failures[i3] = failure;
                                if (!--remaining) reject(new AggregateError(failures));
                            });
                        });
                    });
                });
                if (NativePromise.withResolvers) DexiePromise.withResolvers = NativePromise.withResolvers;
            }
            function executePromiseTask(promise, fn) {
                try {
                    fn(function(value2) {
                        if (promise._state !== null) return;
                        if (value2 === promise) throw new TypeError("A promise cannot be resolved with itself.");
                        var shouldExecuteTick = promise._lib && beginMicroTickScope();
                        if (value2 && typeof value2.then === "function") executePromiseTask(promise, function(resolve, reject) {
                            value2 instanceof DexiePromise ? value2._then(resolve, reject) : value2.then(resolve, reject);
                        });
                        else {
                            promise._state = true;
                            promise._value = value2;
                            propagateAllListeners(promise);
                        }
                        if (shouldExecuteTick) endMicroTickScope();
                    }, handleRejection.bind(null, promise));
                } catch (ex) {
                    handleRejection(promise, ex);
                }
            }
            function handleRejection(promise, reason) {
                rejectingErrors.push(reason);
                if (promise._state !== null) return;
                var shouldExecuteTick = promise._lib && beginMicroTickScope();
                reason = rejectionMapper(reason);
                promise._state = false;
                promise._value = reason;
                addPossiblyUnhandledError(promise);
                propagateAllListeners(promise);
                if (shouldExecuteTick) endMicroTickScope();
            }
            function propagateAllListeners(promise) {
                var listeners = promise._listeners;
                promise._listeners = [];
                for(var i3 = 0, len = listeners.length; i3 < len; ++i3)propagateToListener(promise, listeners[i3]);
                var psd = promise._PSD;
                --psd.ref || psd.finalize();
                if (numScheduledCalls === 0) {
                    ++numScheduledCalls;
                    asap(function() {
                        if (--numScheduledCalls === 0) finalizePhysicalTick();
                    }, []);
                }
            }
            function propagateToListener(promise, listener) {
                if (promise._state === null) {
                    promise._listeners.push(listener);
                    return;
                }
                var cb = promise._state ? listener.onFulfilled : listener.onRejected;
                if (cb === null) return (promise._state ? listener.resolve : listener.reject)(promise._value);
                ++listener.psd.ref;
                ++numScheduledCalls;
                asap(callListener, [
                    cb,
                    promise,
                    listener
                ]);
            }
            function callListener(cb, promise, listener) {
                try {
                    var ret, value2 = promise._value;
                    if (!promise._state && rejectingErrors.length) rejectingErrors = [];
                    ret = debug && promise._consoleTask ? promise._consoleTask.run(function() {
                        return cb(value2);
                    }) : cb(value2);
                    if (!promise._state && rejectingErrors.indexOf(value2) === -1) markErrorAsHandled(promise);
                    listener.resolve(ret);
                } catch (e4) {
                    listener.reject(e4);
                } finally{
                    if (--numScheduledCalls === 0) finalizePhysicalTick();
                    --listener.psd.ref || listener.psd.finalize();
                }
            }
            function physicalTick() {
                usePSD(globalPSD, function() {
                    beginMicroTickScope() && endMicroTickScope();
                });
            }
            function beginMicroTickScope() {
                var wasRootExec = isOutsideMicroTick;
                isOutsideMicroTick = false;
                needsNewPhysicalTick = false;
                return wasRootExec;
            }
            function endMicroTickScope() {
                var callbacks, i3, l3;
                do while(microtickQueue.length > 0){
                    callbacks = microtickQueue;
                    microtickQueue = [];
                    l3 = callbacks.length;
                    for(i3 = 0; i3 < l3; ++i3){
                        var item = callbacks[i3];
                        item[0].apply(null, item[1]);
                    }
                }
                while (microtickQueue.length > 0);
                isOutsideMicroTick = true;
                needsNewPhysicalTick = true;
            }
            function finalizePhysicalTick() {
                var unhandledErrs = unhandledErrors;
                unhandledErrors = [];
                unhandledErrs.forEach(function(p3) {
                    p3._PSD.onunhandled.call(null, p3._value, p3);
                });
                var finalizers = tickFinalizers.slice(0);
                var i3 = finalizers.length;
                while(i3)finalizers[--i3]();
            }
            function run_at_end_of_this_or_next_physical_tick(fn) {
                function finalizer() {
                    fn();
                    tickFinalizers.splice(tickFinalizers.indexOf(finalizer), 1);
                }
                tickFinalizers.push(finalizer);
                ++numScheduledCalls;
                asap(function() {
                    if (--numScheduledCalls === 0) finalizePhysicalTick();
                }, []);
            }
            function addPossiblyUnhandledError(promise) {
                if (!unhandledErrors.some(function(p3) {
                    return p3._value === promise._value;
                })) unhandledErrors.push(promise);
            }
            function markErrorAsHandled(promise) {
                var i3 = unhandledErrors.length;
                while(i3)if (unhandledErrors[--i3]._value === promise._value) {
                    unhandledErrors.splice(i3, 1);
                    return;
                }
            }
            function PromiseReject(reason) {
                return new DexiePromise(INTERNAL, false, reason);
            }
            function wrap2(fn, errorCatcher) {
                var psd = PSD;
                return function() {
                    var wasRootExec = beginMicroTickScope(), outerScope = PSD;
                    try {
                        switchToZone(psd, true);
                        return fn.apply(this, arguments);
                    } catch (e4) {
                        errorCatcher && errorCatcher(e4);
                    } finally{
                        switchToZone(outerScope, false);
                        if (wasRootExec) endMicroTickScope();
                    }
                };
            }
            var task = {
                awaits: 0,
                echoes: 0,
                id: 0
            };
            var taskCounter = 0;
            var zoneStack = [];
            var zoneEchoes = 0;
            var totalEchoes = 0;
            var zone_id_counter = 0;
            function newScope(fn, props2, a1, a22) {
                var parent = PSD, psd = Object.create(parent);
                psd.parent = parent;
                psd.ref = 0;
                psd.global = false;
                psd.id = ++zone_id_counter;
                globalPSD.env;
                psd.env = patchGlobalPromise ? {
                    Promise: DexiePromise,
                    PromiseProp: {
                        value: DexiePromise,
                        configurable: true,
                        writable: true
                    },
                    all: DexiePromise.all,
                    race: DexiePromise.race,
                    allSettled: DexiePromise.allSettled,
                    any: DexiePromise.any,
                    resolve: DexiePromise.resolve,
                    reject: DexiePromise.reject
                } : {};
                if (props2) extend2(psd, props2);
                ++parent.ref;
                psd.finalize = function() {
                    --this.parent.ref || this.parent.finalize();
                };
                var rv = usePSD(psd, fn, a1, a22);
                if (psd.ref === 0) psd.finalize();
                return rv;
            }
            function incrementExpectedAwaits() {
                if (!task.id) task.id = ++taskCounter;
                ++task.awaits;
                task.echoes += ZONE_ECHO_LIMIT;
                return task.id;
            }
            function decrementExpectedAwaits() {
                if (!task.awaits) return false;
                if (--task.awaits === 0) task.id = 0;
                task.echoes = task.awaits * ZONE_ECHO_LIMIT;
                return true;
            }
            if (("" + nativePromiseThen).indexOf("[native code]") === -1) incrementExpectedAwaits = decrementExpectedAwaits = nop;
            function onPossibleParallellAsync(possiblePromise) {
                if (task.echoes && possiblePromise && possiblePromise.constructor === NativePromise) {
                    incrementExpectedAwaits();
                    return possiblePromise.then(function(x3) {
                        decrementExpectedAwaits();
                        return x3;
                    }, function(e4) {
                        decrementExpectedAwaits();
                        return rejection(e4);
                    });
                }
                return possiblePromise;
            }
            function zoneEnterEcho(targetZone) {
                ++totalEchoes;
                if (!task.echoes || --task.echoes === 0) task.echoes = task.awaits = task.id = 0;
                zoneStack.push(PSD);
                switchToZone(targetZone, true);
            }
            function zoneLeaveEcho() {
                var zone = zoneStack[zoneStack.length - 1];
                zoneStack.pop();
                switchToZone(zone, false);
            }
            function switchToZone(targetZone, bEnteringZone) {
                var currentZone = PSD;
                if (bEnteringZone ? task.echoes && (!zoneEchoes++ || targetZone !== PSD) : zoneEchoes && (!--zoneEchoes || targetZone !== PSD)) queueMicrotask(bEnteringZone ? zoneEnterEcho.bind(null, targetZone) : zoneLeaveEcho);
                if (targetZone === PSD) return;
                PSD = targetZone;
                if (currentZone === globalPSD) globalPSD.env = snapShot();
                if (patchGlobalPromise) {
                    var GlobalPromise = globalPSD.env.Promise;
                    var targetEnv = targetZone.env;
                    if (currentZone.global || targetZone.global) {
                        Object.defineProperty(_global3, "Promise", targetEnv.PromiseProp);
                        GlobalPromise.all = targetEnv.all;
                        GlobalPromise.race = targetEnv.race;
                        GlobalPromise.resolve = targetEnv.resolve;
                        GlobalPromise.reject = targetEnv.reject;
                        if (targetEnv.allSettled) GlobalPromise.allSettled = targetEnv.allSettled;
                        if (targetEnv.any) GlobalPromise.any = targetEnv.any;
                    }
                }
            }
            function snapShot() {
                var GlobalPromise = _global3.Promise;
                return patchGlobalPromise ? {
                    Promise: GlobalPromise,
                    PromiseProp: Object.getOwnPropertyDescriptor(_global3, "Promise"),
                    all: GlobalPromise.all,
                    race: GlobalPromise.race,
                    allSettled: GlobalPromise.allSettled,
                    any: GlobalPromise.any,
                    resolve: GlobalPromise.resolve,
                    reject: GlobalPromise.reject
                } : {};
            }
            function usePSD(psd, fn, a1, a22, a3) {
                var outerScope = PSD;
                try {
                    switchToZone(psd, true);
                    return fn(a1, a22, a3);
                } finally{
                    switchToZone(outerScope, false);
                }
            }
            function nativeAwaitCompatibleWrap(fn, zone, possibleAwait, cleanup) {
                return typeof fn !== "function" ? fn : function() {
                    var outerZone = PSD;
                    if (possibleAwait) incrementExpectedAwaits();
                    switchToZone(zone, true);
                    try {
                        return fn.apply(this, arguments);
                    } finally{
                        switchToZone(outerZone, false);
                        if (cleanup) queueMicrotask(decrementExpectedAwaits);
                    }
                };
            }
            function execInGlobalContext(cb) {
                if (Promise === NativePromise && task.echoes === 0) {
                    if (zoneEchoes === 0) cb();
                    else enqueueNativeMicroTask(cb);
                } else setTimeout(cb, 0);
            }
            var rejection = DexiePromise.reject;
            function tempTransaction(db, mode, storeNames, fn) {
                if (!db.idbdb || !db._state.openComplete && !PSD.letThrough && !db._vip) {
                    if (db._state.openComplete) return rejection(new exceptions.DatabaseClosed(db._state.dbOpenError));
                    if (!db._state.isBeingOpened) {
                        if (!db._state.autoOpen) return rejection(new exceptions.DatabaseClosed());
                        db.open().catch(nop);
                    }
                    return db._state.dbReadyPromise.then(function() {
                        return tempTransaction(db, mode, storeNames, fn);
                    });
                } else {
                    var trans = db._createTransaction(mode, storeNames, db._dbSchema);
                    try {
                        trans.create();
                        db._state.PR1398_maxLoop = 3;
                    } catch (ex) {
                        if (ex.name === errnames.InvalidState && db.isOpen() && --db._state.PR1398_maxLoop > 0) {
                            console.warn("Dexie: Need to reopen db");
                            db.close({
                                disableAutoOpen: false
                            });
                            return db.open().then(function() {
                                return tempTransaction(db, mode, storeNames, fn);
                            });
                        }
                        return rejection(ex);
                    }
                    return trans._promise(mode, function(resolve, reject) {
                        return newScope(function() {
                            PSD.trans = trans;
                            return fn(resolve, reject, trans);
                        });
                    }).then(function(result) {
                        if (mode === "readwrite") try {
                            trans.idbtrans.commit();
                        } catch (_a3) {}
                        return mode === "readonly" ? result : trans._completion.then(function() {
                            return result;
                        });
                    });
                }
            }
            var DEXIE_VERSION = "4.4.2";
            var maxString = String.fromCharCode(65535);
            var minKey = -Infinity;
            var INVALID_KEY_ARGUMENT = "Invalid key provided. Keys must be of type string, number, Date or Array<string | number | Date>.";
            var STRING_EXPECTED = "String expected.";
            var DEFAULT_MAX_CONNECTIONS = 1e3;
            var DBNAMES_DB = "__dbnames";
            var READONLY = "readonly";
            var READWRITE = "readwrite";
            function combine(filter1, filter2) {
                return filter1 ? filter2 ? function() {
                    return filter1.apply(this, arguments) && filter2.apply(this, arguments);
                } : filter1 : filter2;
            }
            var AnyRange = {
                type: 3,
                lower: -Infinity,
                lowerOpen: false,
                upper: [
                    []
                ],
                upperOpen: false
            };
            function workaroundForUndefinedPrimKey(keyPath) {
                return typeof keyPath === "string" && !/\./.test(keyPath) ? function(obj) {
                    if (obj[keyPath] === void 0 && keyPath in obj) {
                        obj = deepClone2(obj);
                        delete obj[keyPath];
                    }
                    return obj;
                } : function(obj) {
                    return obj;
                };
            }
            function Entity2() {
                throw exceptions.Type("Entity instances must never be new:ed. Instances are generated by the framework bypassing the constructor.");
            }
            function cmp2(a3, b3) {
                try {
                    var ta = type(a3);
                    var tb = type(b3);
                    if (ta !== tb) {
                        if (ta === "Array") return 1;
                        if (tb === "Array") return -1;
                        if (ta === "binary") return 1;
                        if (tb === "binary") return -1;
                        if (ta === "string") return 1;
                        if (tb === "string") return -1;
                        if (ta === "Date") return 1;
                        if (tb !== "Date") return NaN;
                        return -1;
                    }
                    switch(ta){
                        case "number":
                        case "Date":
                        case "string":
                            return a3 > b3 ? 1 : a3 < b3 ? -1 : 0;
                        case "binary":
                            return compareUint8Arrays(getUint8Array(a3), getUint8Array(b3));
                        case "Array":
                            return compareArrays(a3, b3);
                    }
                } catch (_a3) {}
                return NaN;
            }
            function compareArrays(a3, b3) {
                var al = a3.length;
                var bl = b3.length;
                var l3 = al < bl ? al : bl;
                for(var i3 = 0; i3 < l3; ++i3){
                    var res = cmp2(a3[i3], b3[i3]);
                    if (res !== 0) return res;
                }
                return al === bl ? 0 : al < bl ? -1 : 1;
            }
            function compareUint8Arrays(a3, b3) {
                var al = a3.length;
                var bl = b3.length;
                var l3 = al < bl ? al : bl;
                for(var i3 = 0; i3 < l3; ++i3){
                    if (a3[i3] !== b3[i3]) return a3[i3] < b3[i3] ? -1 : 1;
                }
                return al === bl ? 0 : al < bl ? -1 : 1;
            }
            function type(x3) {
                var t4 = typeof x3;
                if (t4 !== "object") return t4;
                if (ArrayBuffer.isView(x3)) return "binary";
                var tsTag = toStringTag(x3);
                return tsTag === "ArrayBuffer" ? "binary" : tsTag;
            }
            function getUint8Array(a3) {
                if (a3 instanceof Uint8Array) return a3;
                if (ArrayBuffer.isView(a3)) return new Uint8Array(a3.buffer, a3.byteOffset, a3.byteLength);
                return new Uint8Array(a3);
            }
            function builtInDeletionTrigger(table, keys3, res) {
                var yProps = table.schema.yProps;
                if (!yProps) return res;
                if (keys3 && res.numFailures > 0) keys3 = keys3.filter(function(_3, i3) {
                    return !res.failures[i3];
                });
                return Promise.all(yProps.map(function(_a3) {
                    var updatesTable = _a3.updatesTable;
                    return keys3 ? table.db.table(updatesTable).where("k").anyOf(keys3).delete() : table.db.table(updatesTable).clear();
                })).then(function() {
                    return res;
                });
            }
            var PropModification2 = function() {
                function PropModification3(spec) {
                    this["@@propmod"] = spec;
                }
                PropModification3.prototype.execute = function(value2) {
                    var _a3;
                    var spec = this["@@propmod"];
                    if (spec.add !== void 0) {
                        var term = spec.add;
                        if (isArray5(term)) return __spreadArray(__spreadArray([], isArray5(value2) ? value2 : [], true), term, true).sort();
                        if (typeof term === "number") return (Number(value2) || 0) + term;
                        if (typeof term === "bigint") try {
                            return BigInt(value2) + term;
                        } catch (_b) {
                            return BigInt(0) + term;
                        }
                        throw new TypeError("Invalid term ".concat(term));
                    }
                    if (spec.remove !== void 0) {
                        var subtrahend_1 = spec.remove;
                        if (isArray5(subtrahend_1)) return isArray5(value2) ? value2.filter(function(item) {
                            return !subtrahend_1.includes(item);
                        }).sort() : [];
                        if (typeof subtrahend_1 === "number") return Number(value2) - subtrahend_1;
                        if (typeof subtrahend_1 === "bigint") try {
                            return BigInt(value2) - subtrahend_1;
                        } catch (_c) {
                            return BigInt(0) - subtrahend_1;
                        }
                        throw new TypeError("Invalid subtrahend ".concat(subtrahend_1));
                    }
                    var prefixToReplace = (_a3 = spec.replacePrefix) === null || _a3 === void 0 ? void 0 : _a3[0];
                    if (prefixToReplace && typeof value2 === "string" && value2.startsWith(prefixToReplace)) return spec.replacePrefix[1] + value2.substring(prefixToReplace.length);
                    return value2;
                };
                return PropModification3;
            }();
            function applyUpdateSpec(obj, changes) {
                var keyPaths = keys2(changes);
                var numKeys = keyPaths.length;
                var anythingModified = false;
                for(var i3 = 0; i3 < numKeys; ++i3){
                    var keyPath = keyPaths[i3];
                    var value2 = changes[keyPath];
                    var origValue = getByKeyPath(obj, keyPath);
                    if (value2 instanceof PropModification2) {
                        setByKeyPath(obj, keyPath, value2.execute(origValue));
                        anythingModified = true;
                    } else if (origValue !== value2) {
                        setByKeyPath(obj, keyPath, value2);
                        anythingModified = true;
                    }
                }
                return anythingModified;
            }
            var Table = function() {
                function Table2() {}
                Table2.prototype._trans = function(mode, fn, writeLocked) {
                    var trans = this._tx || PSD.trans;
                    var tableName = this.name;
                    var task2 = debug && typeof console !== "undefined" && console.createTask && console.createTask("Dexie: ".concat(mode === "readonly" ? "read" : "write", " ").concat(this.name));
                    function checkTableInTransaction(resolve, reject, trans2) {
                        if (!trans2.schema[tableName]) throw new exceptions.NotFound("Table " + tableName + " not part of transaction");
                        return fn(trans2.idbtrans, trans2);
                    }
                    var wasRootExec = beginMicroTickScope();
                    try {
                        var p3 = trans && trans.db._novip === this.db._novip ? trans === PSD.trans ? trans._promise(mode, checkTableInTransaction, writeLocked) : newScope(function() {
                            return trans._promise(mode, checkTableInTransaction, writeLocked);
                        }, {
                            trans: trans,
                            transless: PSD.transless || PSD
                        }) : tempTransaction(this.db, mode, [
                            this.name
                        ], checkTableInTransaction);
                        if (task2) {
                            p3._consoleTask = task2;
                            p3 = p3.catch(function(err) {
                                console.trace(err);
                                return rejection(err);
                            });
                        }
                        return p3;
                    } finally{
                        if (wasRootExec) endMicroTickScope();
                    }
                };
                Table2.prototype.get = function(keyOrCrit, cb) {
                    var _this = this;
                    if (keyOrCrit && keyOrCrit.constructor === Object) return this.where(keyOrCrit).first(cb);
                    if (keyOrCrit == null) return rejection(new exceptions.Type("Invalid argument to Table.get()"));
                    return this._trans("readonly", function(trans) {
                        return _this.core.get({
                            trans: trans,
                            key: keyOrCrit
                        }).then(function(res) {
                            return _this.hook.reading.fire(res);
                        });
                    }).then(cb);
                };
                Table2.prototype.where = function(indexOrCrit) {
                    if (typeof indexOrCrit === "string") return new this.db.WhereClause(this, indexOrCrit);
                    if (isArray5(indexOrCrit)) return new this.db.WhereClause(this, "[".concat(indexOrCrit.join("+"), "]"));
                    var keyPaths = keys2(indexOrCrit);
                    if (keyPaths.length === 1) return this.where(keyPaths[0]).equals(indexOrCrit[keyPaths[0]]);
                    var compoundIndex = this.schema.indexes.concat(this.schema.primKey).filter(function(ix) {
                        if (ix.compound && keyPaths.every(function(keyPath) {
                            return ix.keyPath.indexOf(keyPath) >= 0;
                        })) {
                            for(var i3 = 0; i3 < keyPaths.length; ++i3){
                                if (keyPaths.indexOf(ix.keyPath[i3]) === -1) return false;
                            }
                            return true;
                        }
                        return false;
                    }).sort(function(a3, b3) {
                        return a3.keyPath.length - b3.keyPath.length;
                    })[0];
                    if (compoundIndex && this.db._maxKey !== maxString) {
                        var keyPathsInValidOrder = compoundIndex.keyPath.slice(0, keyPaths.length);
                        return this.where(keyPathsInValidOrder).equals(keyPathsInValidOrder.map(function(kp) {
                            return indexOrCrit[kp];
                        }));
                    }
                    if (!compoundIndex && debug) console.warn("The query ".concat(JSON.stringify(indexOrCrit), " on ").concat(this.name, " would benefit from a ") + "compound index [".concat(keyPaths.join("+"), "]"));
                    var idxByName = this.schema.idxByName;
                    function equals2(a3, b3) {
                        return cmp2(a3, b3) === 0;
                    }
                    var _a3 = keyPaths.reduce(function(_a4, keyPath) {
                        var prevIndex = _a4[0], prevFilterFn = _a4[1];
                        var index = idxByName[keyPath];
                        var value2 = indexOrCrit[keyPath];
                        return [
                            prevIndex || index,
                            prevIndex || !index ? combine(prevFilterFn, index && index.multi ? function(x3) {
                                var prop = getByKeyPath(x3, keyPath);
                                return isArray5(prop) && prop.some(function(item) {
                                    return equals2(value2, item);
                                });
                            } : function(x3) {
                                return equals2(value2, getByKeyPath(x3, keyPath));
                            }) : prevFilterFn
                        ];
                    }, [
                        null,
                        null
                    ]), idx = _a3[0], filterFunction = _a3[1];
                    return idx ? this.where(idx.name).equals(indexOrCrit[idx.keyPath]).filter(filterFunction) : compoundIndex ? this.filter(filterFunction) : this.where(keyPaths).equals("");
                };
                Table2.prototype.filter = function(filterFunction) {
                    return this.toCollection().and(filterFunction);
                };
                Table2.prototype.count = function(thenShortcut) {
                    return this.toCollection().count(thenShortcut);
                };
                Table2.prototype.offset = function(offset2) {
                    return this.toCollection().offset(offset2);
                };
                Table2.prototype.limit = function(numRows) {
                    return this.toCollection().limit(numRows);
                };
                Table2.prototype.each = function(callback) {
                    return this.toCollection().each(callback);
                };
                Table2.prototype.toArray = function(thenShortcut) {
                    return this.toCollection().toArray(thenShortcut);
                };
                Table2.prototype.toCollection = function() {
                    return new this.db.Collection(new this.db.WhereClause(this));
                };
                Table2.prototype.orderBy = function(index) {
                    return new this.db.Collection(new this.db.WhereClause(this, isArray5(index) ? "[".concat(index.join("+"), "]") : index));
                };
                Table2.prototype.reverse = function() {
                    return this.toCollection().reverse();
                };
                Table2.prototype.mapToClass = function(constructor) {
                    var _a3 = this, db = _a3.db, tableName = _a3.name;
                    this.schema.mappedClass = constructor;
                    if (constructor.prototype instanceof Entity2) constructor = function(_super) {
                        __extends(class_1, _super);
                        function class_1() {
                            return _super !== null && _super.apply(this, arguments) || this;
                        }
                        Object.defineProperty(class_1.prototype, "db", {
                            get: function() {
                                return db;
                            },
                            enumerable: false,
                            configurable: true
                        });
                        class_1.prototype.table = function() {
                            return tableName;
                        };
                        return class_1;
                    }(constructor);
                    var inheritedProps = /* @__PURE__ */ new Set();
                    for(var proto = constructor.prototype; proto; proto = getProto(proto))Object.getOwnPropertyNames(proto).forEach(function(propName) {
                        return inheritedProps.add(propName);
                    });
                    var readHook = function(obj) {
                        if (!obj) return obj;
                        var res = Object.create(constructor.prototype);
                        for(var m3 in obj)if (!inheritedProps.has(m3)) try {
                            res[m3] = obj[m3];
                        } catch (_3) {}
                        return res;
                    };
                    if (this.schema.readHook) this.hook.reading.unsubscribe(this.schema.readHook);
                    this.schema.readHook = readHook;
                    this.hook("reading", readHook);
                    return constructor;
                };
                Table2.prototype.defineClass = function() {
                    function Class(content) {
                        extend2(this, content);
                    }
                    return this.mapToClass(Class);
                };
                Table2.prototype.add = function(obj, key) {
                    var _this = this;
                    var _a3 = this.schema.primKey, auto = _a3.auto, keyPath = _a3.keyPath;
                    var objToAdd = obj;
                    if (keyPath && auto) objToAdd = workaroundForUndefinedPrimKey(keyPath)(obj);
                    return this._trans("readwrite", function(trans) {
                        return _this.core.mutate({
                            trans: trans,
                            type: "add",
                            keys: key != null ? [
                                key
                            ] : null,
                            values: [
                                objToAdd
                            ]
                        });
                    }).then(function(res) {
                        return res.numFailures ? DexiePromise.reject(res.failures[0]) : res.lastResult;
                    }).then(function(lastResult) {
                        if (keyPath) try {
                            setByKeyPath(obj, keyPath, lastResult);
                        } catch (_3) {}
                        return lastResult;
                    });
                };
                Table2.prototype.upsert = function(key, modifications) {
                    var _this = this;
                    var keyPath = this.schema.primKey.keyPath;
                    return this._trans("readwrite", function(trans) {
                        return _this.core.get({
                            trans: trans,
                            key: key
                        }).then(function(existing) {
                            var obj = existing !== null && existing !== void 0 ? existing : {};
                            applyUpdateSpec(obj, modifications);
                            if (keyPath) setByKeyPath(obj, keyPath, key);
                            return _this.core.mutate({
                                trans: trans,
                                type: "put",
                                values: [
                                    obj
                                ],
                                keys: [
                                    key
                                ],
                                upsert: true,
                                updates: {
                                    keys: [
                                        key
                                    ],
                                    changeSpecs: [
                                        modifications
                                    ]
                                }
                            }).then(function(res) {
                                return res.numFailures ? DexiePromise.reject(res.failures[0]) : !!existing;
                            });
                        });
                    });
                };
                Table2.prototype.update = function(keyOrObject, modifications) {
                    if (typeof keyOrObject === "object" && !isArray5(keyOrObject)) {
                        var key = getByKeyPath(keyOrObject, this.schema.primKey.keyPath);
                        if (key === void 0) return rejection(new exceptions.InvalidArgument("Given object does not contain its primary key"));
                        return this.where(":id").equals(key).modify(modifications);
                    } else return this.where(":id").equals(keyOrObject).modify(modifications);
                };
                Table2.prototype.put = function(obj, key) {
                    var _this = this;
                    var _a3 = this.schema.primKey, auto = _a3.auto, keyPath = _a3.keyPath;
                    var objToAdd = obj;
                    if (keyPath && auto) objToAdd = workaroundForUndefinedPrimKey(keyPath)(obj);
                    return this._trans("readwrite", function(trans) {
                        return _this.core.mutate({
                            trans: trans,
                            type: "put",
                            values: [
                                objToAdd
                            ],
                            keys: key != null ? [
                                key
                            ] : null
                        });
                    }).then(function(res) {
                        return res.numFailures ? DexiePromise.reject(res.failures[0]) : res.lastResult;
                    }).then(function(lastResult) {
                        if (keyPath) try {
                            setByKeyPath(obj, keyPath, lastResult);
                        } catch (_3) {}
                        return lastResult;
                    });
                };
                Table2.prototype.delete = function(key) {
                    var _this = this;
                    return this._trans("readwrite", function(trans) {
                        return _this.core.mutate({
                            trans: trans,
                            type: "delete",
                            keys: [
                                key
                            ]
                        }).then(function(res) {
                            return builtInDeletionTrigger(_this, [
                                key
                            ], res);
                        }).then(function(res) {
                            return res.numFailures ? DexiePromise.reject(res.failures[0]) : void 0;
                        });
                    });
                };
                Table2.prototype.clear = function() {
                    var _this = this;
                    return this._trans("readwrite", function(trans) {
                        return _this.core.mutate({
                            trans: trans,
                            type: "deleteRange",
                            range: AnyRange
                        }).then(function(res) {
                            return builtInDeletionTrigger(_this, null, res);
                        });
                    }).then(function(res) {
                        return res.numFailures ? DexiePromise.reject(res.failures[0]) : void 0;
                    });
                };
                Table2.prototype.bulkGet = function(keys3) {
                    var _this = this;
                    return this._trans("readonly", function(trans) {
                        return _this.core.getMany({
                            keys: keys3,
                            trans: trans
                        }).then(function(result) {
                            return result.map(function(res) {
                                return _this.hook.reading.fire(res);
                            });
                        });
                    });
                };
                Table2.prototype.bulkAdd = function(objects, keysOrOptions, options) {
                    var _this = this;
                    var keys3 = Array.isArray(keysOrOptions) ? keysOrOptions : void 0;
                    options = options || (keys3 ? void 0 : keysOrOptions);
                    var wantResults = options ? options.allKeys : void 0;
                    return this._trans("readwrite", function(trans) {
                        var _a3 = _this.schema.primKey, auto = _a3.auto, keyPath = _a3.keyPath;
                        if (keyPath && keys3) throw new exceptions.InvalidArgument("bulkAdd(): keys argument invalid on tables with inbound keys");
                        if (keys3 && keys3.length !== objects.length) throw new exceptions.InvalidArgument("Arguments objects and keys must have the same length");
                        var numObjects = objects.length;
                        var objectsToAdd = keyPath && auto ? objects.map(workaroundForUndefinedPrimKey(keyPath)) : objects;
                        return _this.core.mutate({
                            trans: trans,
                            type: "add",
                            keys: keys3,
                            values: objectsToAdd,
                            wantResults: wantResults
                        }).then(function(_a4) {
                            var numFailures = _a4.numFailures, results = _a4.results, lastResult = _a4.lastResult, failures = _a4.failures;
                            var result = wantResults ? results : lastResult;
                            if (numFailures === 0) return result;
                            throw new BulkError("".concat(_this.name, ".bulkAdd(): ").concat(numFailures, " of ").concat(numObjects, " operations failed"), failures);
                        });
                    });
                };
                Table2.prototype.bulkPut = function(objects, keysOrOptions, options) {
                    var _this = this;
                    var keys3 = Array.isArray(keysOrOptions) ? keysOrOptions : void 0;
                    options = options || (keys3 ? void 0 : keysOrOptions);
                    var wantResults = options ? options.allKeys : void 0;
                    return this._trans("readwrite", function(trans) {
                        var _a3 = _this.schema.primKey, auto = _a3.auto, keyPath = _a3.keyPath;
                        if (keyPath && keys3) throw new exceptions.InvalidArgument("bulkPut(): keys argument invalid on tables with inbound keys");
                        if (keys3 && keys3.length !== objects.length) throw new exceptions.InvalidArgument("Arguments objects and keys must have the same length");
                        var numObjects = objects.length;
                        var objectsToPut = keyPath && auto ? objects.map(workaroundForUndefinedPrimKey(keyPath)) : objects;
                        return _this.core.mutate({
                            trans: trans,
                            type: "put",
                            keys: keys3,
                            values: objectsToPut,
                            wantResults: wantResults
                        }).then(function(_a4) {
                            var numFailures = _a4.numFailures, results = _a4.results, lastResult = _a4.lastResult, failures = _a4.failures;
                            var result = wantResults ? results : lastResult;
                            if (numFailures === 0) return result;
                            throw new BulkError("".concat(_this.name, ".bulkPut(): ").concat(numFailures, " of ").concat(numObjects, " operations failed"), failures);
                        });
                    });
                };
                Table2.prototype.bulkUpdate = function(keysAndChanges) {
                    var _this = this;
                    var coreTable = this.core;
                    var keys3 = keysAndChanges.map(function(entry) {
                        return entry.key;
                    });
                    var changeSpecs = keysAndChanges.map(function(entry) {
                        return entry.changes;
                    });
                    var offsetMap = [];
                    return this._trans("readwrite", function(trans) {
                        return coreTable.getMany({
                            trans: trans,
                            keys: keys3,
                            cache: "clone"
                        }).then(function(objs) {
                            var resultKeys = [];
                            var resultObjs = [];
                            keysAndChanges.forEach(function(_a3, idx) {
                                var key = _a3.key, changes = _a3.changes;
                                var obj = objs[idx];
                                if (obj) {
                                    for(var _i = 0, _b = Object.keys(changes); _i < _b.length; _i++){
                                        var keyPath = _b[_i];
                                        var value2 = changes[keyPath];
                                        if (keyPath === _this.schema.primKey.keyPath) {
                                            if (cmp2(value2, key) !== 0) throw new exceptions.Constraint("Cannot update primary key in bulkUpdate()");
                                        } else setByKeyPath(obj, keyPath, value2);
                                    }
                                    offsetMap.push(idx);
                                    resultKeys.push(key);
                                    resultObjs.push(obj);
                                }
                            });
                            var numEntries = resultKeys.length;
                            return coreTable.mutate({
                                trans: trans,
                                type: "put",
                                keys: resultKeys,
                                values: resultObjs,
                                updates: {
                                    keys: keys3,
                                    changeSpecs: changeSpecs
                                }
                            }).then(function(_a3) {
                                var numFailures = _a3.numFailures, failures = _a3.failures;
                                if (numFailures === 0) return numEntries;
                                for(var _i = 0, _b = Object.keys(failures); _i < _b.length; _i++){
                                    var offset2 = _b[_i];
                                    var mappedOffset = offsetMap[Number(offset2)];
                                    if (mappedOffset != null) {
                                        var failure = failures[offset2];
                                        delete failures[offset2];
                                        failures[mappedOffset] = failure;
                                    }
                                }
                                throw new BulkError("".concat(_this.name, ".bulkUpdate(): ").concat(numFailures, " of ").concat(numEntries, " operations failed"), failures);
                            });
                        });
                    });
                };
                Table2.prototype.bulkDelete = function(keys3) {
                    var _this = this;
                    var numKeys = keys3.length;
                    return this._trans("readwrite", function(trans) {
                        return _this.core.mutate({
                            trans: trans,
                            type: "delete",
                            keys: keys3
                        }).then(function(res) {
                            return builtInDeletionTrigger(_this, keys3, res);
                        });
                    }).then(function(_a3) {
                        var numFailures = _a3.numFailures, lastResult = _a3.lastResult, failures = _a3.failures;
                        if (numFailures === 0) return lastResult;
                        throw new BulkError("".concat(_this.name, ".bulkDelete(): ").concat(numFailures, " of ").concat(numKeys, " operations failed"), failures);
                    });
                };
                return Table2;
            }();
            function Events(ctx) {
                var evs = {};
                var rv = function(eventName, subscriber) {
                    if (subscriber) {
                        var i4 = arguments.length, args2 = new Array(i4 - 1);
                        while(--i4)args2[i4 - 1] = arguments[i4];
                        evs[eventName].subscribe.apply(null, args2);
                        return ctx;
                    } else if (typeof eventName === "string") return evs[eventName];
                };
                rv.addEventType = add3;
                for(var i3 = 1, l3 = arguments.length; i3 < l3; ++i3)add3(arguments[i3]);
                return rv;
                function add3(eventName, chainFunction, defaultFunction) {
                    if (typeof eventName === "object") return addConfiguredEvents(eventName);
                    if (!chainFunction) chainFunction = reverseStoppableEventChain;
                    if (!defaultFunction) defaultFunction = nop;
                    var context2 = {
                        subscribers: [],
                        fire: defaultFunction,
                        subscribe: function(cb) {
                            if (context2.subscribers.indexOf(cb) === -1) {
                                context2.subscribers.push(cb);
                                context2.fire = chainFunction(context2.fire, cb);
                            }
                        },
                        unsubscribe: function(cb) {
                            context2.subscribers = context2.subscribers.filter(function(fn) {
                                return fn !== cb;
                            });
                            context2.fire = context2.subscribers.reduce(chainFunction, defaultFunction);
                        }
                    };
                    evs[eventName] = rv[eventName] = context2;
                    return context2;
                }
                function addConfiguredEvents(cfg) {
                    keys2(cfg).forEach(function(eventName) {
                        var args2 = cfg[eventName];
                        if (isArray5(args2)) add3(eventName, cfg[eventName][0], cfg[eventName][1]);
                        else if (args2 === "asap") var context2 = add3(eventName, mirror, function fire() {
                            var i4 = arguments.length, args3 = new Array(i4);
                            while(i4--)args3[i4] = arguments[i4];
                            context2.subscribers.forEach(function(fn) {
                                asap$1(function fireEvent() {
                                    fn.apply(null, args3);
                                });
                            });
                        });
                        else throw new exceptions.InvalidArgument("Invalid event config");
                    });
                }
            }
            function makeClassConstructor(prototype, constructor) {
                derive(constructor).from({
                    prototype: prototype
                });
                return constructor;
            }
            function createTableConstructor(db) {
                return makeClassConstructor(Table.prototype, function Table2(name, tableSchema, trans) {
                    this.db = db;
                    this._tx = trans;
                    this.name = name;
                    this.schema = tableSchema;
                    this.hook = db._allTables[name] ? db._allTables[name].hook : Events(null, {
                        creating: [
                            hookCreatingChain,
                            nop
                        ],
                        reading: [
                            pureFunctionChain,
                            mirror
                        ],
                        updating: [
                            hookUpdatingChain,
                            nop
                        ],
                        deleting: [
                            hookDeletingChain,
                            nop
                        ]
                    });
                });
            }
            function isPlainKeyRange(ctx, ignoreLimitFilter) {
                return !(ctx.filter || ctx.algorithm || ctx.or) && (ignoreLimitFilter ? ctx.justLimit : !ctx.replayFilter);
            }
            function addFilter(ctx, fn) {
                ctx.filter = combine(ctx.filter, fn);
            }
            function addReplayFilter(ctx, factory, isLimitFilter) {
                var curr = ctx.replayFilter;
                ctx.replayFilter = curr ? function() {
                    return combine(curr(), factory());
                } : factory;
                ctx.justLimit = isLimitFilter && !curr;
            }
            function addMatchFilter(ctx, fn) {
                ctx.isMatch = combine(ctx.isMatch, fn);
            }
            function getIndexOrStore(ctx, coreSchema) {
                if (ctx.isPrimKey) return coreSchema.primaryKey;
                var index = coreSchema.getIndexByKeyPath(ctx.index);
                if (!index) throw new exceptions.Schema("KeyPath " + ctx.index + " on object store " + coreSchema.name + " is not indexed");
                return index;
            }
            function openCursor(ctx, coreTable, trans) {
                var index = getIndexOrStore(ctx, coreTable.schema);
                return coreTable.openCursor({
                    trans: trans,
                    values: !ctx.keysOnly,
                    reverse: ctx.dir === "prev",
                    unique: !!ctx.unique,
                    query: {
                        index: index,
                        range: ctx.range
                    }
                });
            }
            function iter(ctx, fn, coreTrans, coreTable) {
                var filter = ctx.replayFilter ? combine(ctx.filter, ctx.replayFilter()) : ctx.filter;
                if (!ctx.or) return iterate(openCursor(ctx, coreTable, coreTrans), combine(ctx.algorithm, filter), fn, !ctx.keysOnly && ctx.valueMapper);
                else {
                    var set_1 = {};
                    var union = function(item, cursor, advance2) {
                        if (!filter || filter(cursor, advance2, function(result) {
                            return cursor.stop(result);
                        }, function(err) {
                            return cursor.fail(err);
                        })) {
                            var primaryKey = cursor.primaryKey;
                            var key = "" + primaryKey;
                            if (key === "[object ArrayBuffer]") key = "" + new Uint8Array(primaryKey);
                            if (!hasOwn2(set_1, key)) {
                                set_1[key] = true;
                                fn(item, cursor, advance2);
                            }
                        }
                    };
                    return Promise.all([
                        ctx.or._iterate(union, coreTrans),
                        iterate(openCursor(ctx, coreTable, coreTrans), ctx.algorithm, union, !ctx.keysOnly && ctx.valueMapper)
                    ]);
                }
            }
            function iterate(cursorPromise, filter, fn, valueMapper) {
                var mappedFn = valueMapper ? function(x3, c3, a3) {
                    return fn(valueMapper(x3), c3, a3);
                } : fn;
                var wrappedFn = wrap2(mappedFn);
                return cursorPromise.then(function(cursor) {
                    if (cursor) return cursor.start(function() {
                        var c3 = function() {
                            return cursor.continue();
                        };
                        if (!filter || filter(cursor, function(advancer) {
                            return c3 = advancer;
                        }, function(val) {
                            cursor.stop(val);
                            c3 = nop;
                        }, function(e4) {
                            cursor.fail(e4);
                            c3 = nop;
                        })) wrappedFn(cursor.value, cursor, function(advancer) {
                            return c3 = advancer;
                        });
                        c3();
                    });
                });
            }
            var Collection = function() {
                function Collection2() {}
                Collection2.prototype._read = function(fn, cb) {
                    var ctx = this._ctx;
                    return ctx.error ? ctx.table._trans(null, rejection.bind(null, ctx.error)) : ctx.table._trans("readonly", fn).then(cb);
                };
                Collection2.prototype._write = function(fn) {
                    var ctx = this._ctx;
                    return ctx.error ? ctx.table._trans(null, rejection.bind(null, ctx.error)) : ctx.table._trans("readwrite", fn, "locked");
                };
                Collection2.prototype._addAlgorithm = function(fn) {
                    var ctx = this._ctx;
                    ctx.algorithm = combine(ctx.algorithm, fn);
                };
                Collection2.prototype._iterate = function(fn, coreTrans) {
                    return iter(this._ctx, fn, coreTrans, this._ctx.table.core);
                };
                Collection2.prototype.clone = function(props2) {
                    var rv = Object.create(this.constructor.prototype), ctx = Object.create(this._ctx);
                    if (props2) extend2(ctx, props2);
                    rv._ctx = ctx;
                    return rv;
                };
                Collection2.prototype.raw = function() {
                    this._ctx.valueMapper = null;
                    return this;
                };
                Collection2.prototype.each = function(fn) {
                    var ctx = this._ctx;
                    return this._read(function(trans) {
                        return iter(ctx, fn, trans, ctx.table.core);
                    });
                };
                Collection2.prototype.count = function(cb) {
                    var _this = this;
                    return this._read(function(trans) {
                        var ctx = _this._ctx;
                        var coreTable = ctx.table.core;
                        if (isPlainKeyRange(ctx, true)) return coreTable.count({
                            trans: trans,
                            query: {
                                index: getIndexOrStore(ctx, coreTable.schema),
                                range: ctx.range
                            }
                        }).then(function(count3) {
                            return Math.min(count3, ctx.limit);
                        });
                        else {
                            var count2 = 0;
                            return iter(ctx, function() {
                                ++count2;
                                return false;
                            }, trans, coreTable).then(function() {
                                return count2;
                            });
                        }
                    }).then(cb);
                };
                Collection2.prototype.sortBy = function(keyPath, cb) {
                    var parts2 = keyPath.split(".").reverse(), lastPart = parts2[0], lastIndex = parts2.length - 1;
                    function getval(obj, i3) {
                        if (i3) return getval(obj[parts2[i3]], i3 - 1);
                        return obj[lastPart];
                    }
                    var order = this._ctx.dir === "next" ? 1 : -1;
                    function sorter(a3, b3) {
                        var aVal = getval(a3, lastIndex), bVal = getval(b3, lastIndex);
                        return cmp2(aVal, bVal) * order;
                    }
                    return this.toArray(function(a3) {
                        return a3.sort(sorter);
                    }).then(cb);
                };
                Collection2.prototype.toArray = function(cb) {
                    var _this = this;
                    return this._read(function(trans) {
                        var ctx = _this._ctx;
                        if (isPlainKeyRange(ctx, true) && ctx.limit > 0) {
                            var valueMapper_1 = ctx.valueMapper;
                            var index = getIndexOrStore(ctx, ctx.table.core.schema);
                            return ctx.table.core.query({
                                trans: trans,
                                limit: ctx.limit,
                                values: true,
                                direction: ctx.dir === "prev" ? "prev" : void 0,
                                query: {
                                    index: index,
                                    range: ctx.range
                                }
                            }).then(function(_a3) {
                                var result = _a3.result;
                                return valueMapper_1 ? result.map(valueMapper_1) : result;
                            });
                        } else {
                            var a_1 = [];
                            return iter(ctx, function(item) {
                                return a_1.push(item);
                            }, trans, ctx.table.core).then(function() {
                                return a_1;
                            });
                        }
                    }, cb);
                };
                Collection2.prototype.offset = function(offset2) {
                    var ctx = this._ctx;
                    if (offset2 <= 0) return this;
                    ctx.offset += offset2;
                    if (isPlainKeyRange(ctx)) addReplayFilter(ctx, function() {
                        var offsetLeft = offset2;
                        return function(cursor, advance2) {
                            if (offsetLeft === 0) return true;
                            if (offsetLeft === 1) {
                                --offsetLeft;
                                return false;
                            }
                            advance2(function() {
                                cursor.advance(offsetLeft);
                                offsetLeft = 0;
                            });
                            return false;
                        };
                    });
                    else addReplayFilter(ctx, function() {
                        var offsetLeft = offset2;
                        return function() {
                            return --offsetLeft < 0;
                        };
                    });
                    return this;
                };
                Collection2.prototype.limit = function(numRows) {
                    this._ctx.limit = Math.min(this._ctx.limit, numRows);
                    addReplayFilter(this._ctx, function() {
                        var rowsLeft = numRows;
                        return function(cursor, advance2, resolve) {
                            if (--rowsLeft <= 0) advance2(resolve);
                            return rowsLeft >= 0;
                        };
                    }, true);
                    return this;
                };
                Collection2.prototype.until = function(filterFunction, bIncludeStopEntry) {
                    addFilter(this._ctx, function(cursor, advance2, resolve) {
                        if (filterFunction(cursor.value)) {
                            advance2(resolve);
                            return bIncludeStopEntry;
                        } else return true;
                    });
                    return this;
                };
                Collection2.prototype.first = function(cb) {
                    return this.limit(1).toArray(function(a3) {
                        return a3[0];
                    }).then(cb);
                };
                Collection2.prototype.last = function(cb) {
                    return this.reverse().first(cb);
                };
                Collection2.prototype.filter = function(filterFunction) {
                    addFilter(this._ctx, function(cursor) {
                        return filterFunction(cursor.value);
                    });
                    addMatchFilter(this._ctx, filterFunction);
                    return this;
                };
                Collection2.prototype.and = function(filter) {
                    return this.filter(filter);
                };
                Collection2.prototype.or = function(indexName) {
                    return new this.db.WhereClause(this._ctx.table, indexName, this);
                };
                Collection2.prototype.reverse = function() {
                    this._ctx.dir = this._ctx.dir === "prev" ? "next" : "prev";
                    if (this._ondirectionchange) this._ondirectionchange(this._ctx.dir);
                    return this;
                };
                Collection2.prototype.desc = function() {
                    return this.reverse();
                };
                Collection2.prototype.eachKey = function(cb) {
                    var ctx = this._ctx;
                    ctx.keysOnly = !ctx.isMatch;
                    return this.each(function(val, cursor) {
                        cb(cursor.key, cursor);
                    });
                };
                Collection2.prototype.eachUniqueKey = function(cb) {
                    this._ctx.unique = "unique";
                    return this.eachKey(cb);
                };
                Collection2.prototype.eachPrimaryKey = function(cb) {
                    var ctx = this._ctx;
                    ctx.keysOnly = !ctx.isMatch;
                    return this.each(function(val, cursor) {
                        cb(cursor.primaryKey, cursor);
                    });
                };
                Collection2.prototype.keys = function(cb) {
                    var ctx = this._ctx;
                    ctx.keysOnly = !ctx.isMatch;
                    var a3 = [];
                    return this.each(function(item, cursor) {
                        a3.push(cursor.key);
                    }).then(function() {
                        return a3;
                    }).then(cb);
                };
                Collection2.prototype.primaryKeys = function(cb) {
                    var ctx = this._ctx;
                    if (isPlainKeyRange(ctx, true) && ctx.limit > 0) return this._read(function(trans) {
                        var index = getIndexOrStore(ctx, ctx.table.core.schema);
                        return ctx.table.core.query({
                            trans: trans,
                            values: false,
                            limit: ctx.limit,
                            direction: ctx.dir === "prev" ? "prev" : void 0,
                            query: {
                                index: index,
                                range: ctx.range
                            }
                        });
                    }).then(function(_a3) {
                        var result = _a3.result;
                        return result;
                    }).then(cb);
                    ctx.keysOnly = !ctx.isMatch;
                    var a3 = [];
                    return this.each(function(item, cursor) {
                        a3.push(cursor.primaryKey);
                    }).then(function() {
                        return a3;
                    }).then(cb);
                };
                Collection2.prototype.uniqueKeys = function(cb) {
                    this._ctx.unique = "unique";
                    return this.keys(cb);
                };
                Collection2.prototype.firstKey = function(cb) {
                    return this.limit(1).keys(function(a3) {
                        return a3[0];
                    }).then(cb);
                };
                Collection2.prototype.lastKey = function(cb) {
                    return this.reverse().firstKey(cb);
                };
                Collection2.prototype.distinct = function() {
                    var ctx = this._ctx, idx = ctx.index && ctx.table.schema.idxByName[ctx.index];
                    if (!idx || !idx.multi) return this;
                    var set = {};
                    addFilter(this._ctx, function(cursor) {
                        var strKey = cursor.primaryKey.toString();
                        var found = hasOwn2(set, strKey);
                        set[strKey] = true;
                        return !found;
                    });
                    return this;
                };
                Collection2.prototype.modify = function(changes) {
                    var _this = this;
                    var ctx = this._ctx;
                    return this._write(function(trans) {
                        var modifyer;
                        if (typeof changes === "function") modifyer = changes;
                        else modifyer = function(item) {
                            return applyUpdateSpec(item, changes);
                        };
                        var coreTable = ctx.table.core;
                        var _a3 = coreTable.schema.primaryKey, outbound = _a3.outbound, extractKey = _a3.extractKey;
                        var limit = 200;
                        var modifyChunkSize = _this.db._options.modifyChunkSize;
                        if (modifyChunkSize) {
                            if (typeof modifyChunkSize == "object") limit = modifyChunkSize[coreTable.name] || modifyChunkSize["*"] || 200;
                            else limit = modifyChunkSize;
                        }
                        var totalFailures = [];
                        var successCount = 0;
                        var failedKeys = [];
                        var applyMutateResult = function(expectedCount, res) {
                            var failures = res.failures, numFailures = res.numFailures;
                            successCount += expectedCount - numFailures;
                            for(var _i = 0, _a4 = keys2(failures); _i < _a4.length; _i++){
                                var pos = _a4[_i];
                                totalFailures.push(failures[pos]);
                            }
                        };
                        var isUnconditionalDelete = changes === deleteCallback;
                        return _this.clone().primaryKeys().then(function(keys3) {
                            var criteria = isPlainKeyRange(ctx) && ctx.limit === Infinity && (typeof changes !== "function" || isUnconditionalDelete) && {
                                index: ctx.index,
                                range: ctx.range
                            };
                            var nextChunk = function(offset2) {
                                var count2 = Math.min(limit, keys3.length - offset2);
                                var keysInChunk = keys3.slice(offset2, offset2 + count2);
                                return (isUnconditionalDelete ? Promise.resolve([]) : coreTable.getMany({
                                    trans: trans,
                                    keys: keysInChunk,
                                    cache: "immutable"
                                })).then(function(values) {
                                    var addValues = [];
                                    var putValues = [];
                                    var putKeys = outbound ? [] : null;
                                    var deleteKeys = isUnconditionalDelete ? keysInChunk : [];
                                    if (!isUnconditionalDelete) for(var i3 = 0; i3 < count2; ++i3){
                                        var origValue = values[i3];
                                        var ctx_1 = {
                                            value: deepClone2(origValue),
                                            primKey: keys3[offset2 + i3]
                                        };
                                        if (modifyer.call(ctx_1, ctx_1.value, ctx_1) !== false) {
                                            if (ctx_1.value == null) deleteKeys.push(keys3[offset2 + i3]);
                                            else if (!outbound && cmp2(extractKey(origValue), extractKey(ctx_1.value)) !== 0) {
                                                deleteKeys.push(keys3[offset2 + i3]);
                                                addValues.push(ctx_1.value);
                                            } else {
                                                putValues.push(ctx_1.value);
                                                if (outbound) putKeys.push(keys3[offset2 + i3]);
                                            }
                                        }
                                    }
                                    return Promise.resolve(addValues.length > 0 && coreTable.mutate({
                                        trans: trans,
                                        type: "add",
                                        values: addValues
                                    }).then(function(res) {
                                        for(var pos in res.failures)deleteKeys.splice(parseInt(pos), 1);
                                        applyMutateResult(addValues.length, res);
                                    })).then(function() {
                                        return (putValues.length > 0 || criteria && typeof changes === "object") && coreTable.mutate({
                                            trans: trans,
                                            type: "put",
                                            keys: putKeys,
                                            values: putValues,
                                            criteria: criteria,
                                            changeSpec: typeof changes !== "function" && changes,
                                            isAdditionalChunk: offset2 > 0
                                        }).then(function(res) {
                                            return applyMutateResult(putValues.length, res);
                                        });
                                    }).then(function() {
                                        return (deleteKeys.length > 0 || criteria && isUnconditionalDelete) && coreTable.mutate({
                                            trans: trans,
                                            type: "delete",
                                            keys: deleteKeys,
                                            criteria: criteria,
                                            isAdditionalChunk: offset2 > 0
                                        }).then(function(res) {
                                            return builtInDeletionTrigger(ctx.table, deleteKeys, res);
                                        }).then(function(res) {
                                            return applyMutateResult(deleteKeys.length, res);
                                        });
                                    }).then(function() {
                                        return keys3.length > offset2 + count2 && nextChunk(offset2 + limit);
                                    });
                                });
                            };
                            return nextChunk(0).then(function() {
                                if (totalFailures.length > 0) throw new ModifyError("Error modifying one or more objects", totalFailures, successCount, failedKeys);
                                return keys3.length;
                            });
                        });
                    });
                };
                Collection2.prototype.delete = function() {
                    var ctx = this._ctx, range = ctx.range;
                    if (isPlainKeyRange(ctx) && !ctx.table.schema.yProps && (ctx.isPrimKey || range.type === 3)) return this._write(function(trans) {
                        var primaryKey = ctx.table.core.schema.primaryKey;
                        var coreRange = range;
                        return ctx.table.core.count({
                            trans: trans,
                            query: {
                                index: primaryKey,
                                range: coreRange
                            }
                        }).then(function(count2) {
                            return ctx.table.core.mutate({
                                trans: trans,
                                type: "deleteRange",
                                range: coreRange
                            }).then(function(_a3) {
                                var failures = _a3.failures, numFailures = _a3.numFailures;
                                if (numFailures) throw new ModifyError("Could not delete some values", Object.keys(failures).map(function(pos) {
                                    return failures[pos];
                                }), count2 - numFailures);
                                return count2 - numFailures;
                            });
                        });
                    });
                    return this.modify(deleteCallback);
                };
                return Collection2;
            }();
            var deleteCallback = function(value2, ctx) {
                return ctx.value = null;
            };
            function createCollectionConstructor(db) {
                return makeClassConstructor(Collection.prototype, function Collection2(whereClause, keyRangeGenerator) {
                    this.db = db;
                    var keyRange = AnyRange, error = null;
                    if (keyRangeGenerator) try {
                        keyRange = keyRangeGenerator();
                    } catch (ex) {
                        error = ex;
                    }
                    var whereCtx = whereClause._ctx;
                    var table = whereCtx.table;
                    var readingHook = table.hook.reading.fire;
                    this._ctx = {
                        table: table,
                        index: whereCtx.index,
                        isPrimKey: !whereCtx.index || table.schema.primKey.keyPath && whereCtx.index === table.schema.primKey.name,
                        range: keyRange,
                        keysOnly: false,
                        dir: "next",
                        unique: "",
                        algorithm: null,
                        filter: null,
                        replayFilter: null,
                        justLimit: true,
                        isMatch: null,
                        offset: 0,
                        limit: Infinity,
                        error: error,
                        or: whereCtx.or,
                        valueMapper: readingHook !== mirror ? readingHook : null
                    };
                });
            }
            function simpleCompare(a3, b3) {
                return a3 < b3 ? -1 : a3 === b3 ? 0 : 1;
            }
            function simpleCompareReverse(a3, b3) {
                return a3 > b3 ? -1 : a3 === b3 ? 0 : 1;
            }
            function fail(collectionOrWhereClause, err, T3) {
                var collection = collectionOrWhereClause instanceof WhereClause ? new collectionOrWhereClause.Collection(collectionOrWhereClause) : collectionOrWhereClause;
                collection._ctx.error = T3 ? new T3(err) : new TypeError(err);
                return collection;
            }
            function emptyCollection(whereClause) {
                return new whereClause.Collection(whereClause, function() {
                    return rangeEqual("");
                }).limit(0);
            }
            function upperFactory(dir) {
                return dir === "next" ? function(s3) {
                    return s3.toUpperCase();
                } : function(s3) {
                    return s3.toLowerCase();
                };
            }
            function lowerFactory(dir) {
                return dir === "next" ? function(s3) {
                    return s3.toLowerCase();
                } : function(s3) {
                    return s3.toUpperCase();
                };
            }
            function nextCasing(key, lowerKey, upperNeedle, lowerNeedle, cmp3, dir) {
                var length2 = Math.min(key.length, lowerNeedle.length);
                var llp = -1;
                for(var i3 = 0; i3 < length2; ++i3){
                    var lwrKeyChar = lowerKey[i3];
                    if (lwrKeyChar !== lowerNeedle[i3]) {
                        if (cmp3(key[i3], upperNeedle[i3]) < 0) return key.substr(0, i3) + upperNeedle[i3] + upperNeedle.substr(i3 + 1);
                        if (cmp3(key[i3], lowerNeedle[i3]) < 0) return key.substr(0, i3) + lowerNeedle[i3] + upperNeedle.substr(i3 + 1);
                        if (llp >= 0) return key.substr(0, llp) + lowerKey[llp] + upperNeedle.substr(llp + 1);
                        return null;
                    }
                    if (cmp3(key[i3], lwrKeyChar) < 0) llp = i3;
                }
                if (length2 < lowerNeedle.length && dir === "next") return key + upperNeedle.substr(key.length);
                if (length2 < key.length && dir === "prev") return key.substr(0, upperNeedle.length);
                return llp < 0 ? null : key.substr(0, llp) + lowerNeedle[llp] + upperNeedle.substr(llp + 1);
            }
            function addIgnoreCaseAlgorithm(whereClause, match2, needles, suffix) {
                var upper, lower, compare, upperNeedles, lowerNeedles, direction, nextKeySuffix, needlesLen = needles.length;
                if (!needles.every(function(s3) {
                    return typeof s3 === "string";
                })) return fail(whereClause, STRING_EXPECTED);
                function initDirection(dir) {
                    upper = upperFactory(dir);
                    lower = lowerFactory(dir);
                    compare = dir === "next" ? simpleCompare : simpleCompareReverse;
                    var needleBounds = needles.map(function(needle) {
                        return {
                            lower: lower(needle),
                            upper: upper(needle)
                        };
                    }).sort(function(a3, b3) {
                        return compare(a3.lower, b3.lower);
                    });
                    upperNeedles = needleBounds.map(function(nb) {
                        return nb.upper;
                    });
                    lowerNeedles = needleBounds.map(function(nb) {
                        return nb.lower;
                    });
                    direction = dir;
                    nextKeySuffix = dir === "next" ? "" : suffix;
                }
                initDirection("next");
                var c3 = new whereClause.Collection(whereClause, function() {
                    return createRange(upperNeedles[0], lowerNeedles[needlesLen - 1] + suffix);
                });
                c3._ondirectionchange = function(direction2) {
                    initDirection(direction2);
                };
                var firstPossibleNeedle = 0;
                c3._addAlgorithm(function(cursor, advance2, resolve) {
                    var key = cursor.key;
                    if (typeof key !== "string") return false;
                    var lowerKey = lower(key);
                    if (match2(lowerKey, lowerNeedles, firstPossibleNeedle)) return true;
                    else {
                        var lowestPossibleCasing = null;
                        for(var i3 = firstPossibleNeedle; i3 < needlesLen; ++i3){
                            var casing = nextCasing(key, lowerKey, upperNeedles[i3], lowerNeedles[i3], compare, direction);
                            if (casing === null && lowestPossibleCasing === null) firstPossibleNeedle = i3 + 1;
                            else if (lowestPossibleCasing === null || compare(lowestPossibleCasing, casing) > 0) lowestPossibleCasing = casing;
                        }
                        if (lowestPossibleCasing !== null) advance2(function() {
                            cursor.continue(lowestPossibleCasing + nextKeySuffix);
                        });
                        else advance2(resolve);
                        return false;
                    }
                });
                return c3;
            }
            function createRange(lower, upper, lowerOpen, upperOpen) {
                return {
                    type: 2,
                    lower: lower,
                    upper: upper,
                    lowerOpen: lowerOpen,
                    upperOpen: upperOpen
                };
            }
            function rangeEqual(value2) {
                return {
                    type: 1,
                    lower: value2,
                    upper: value2
                };
            }
            var WhereClause = function() {
                function WhereClause2() {}
                Object.defineProperty(WhereClause2.prototype, "Collection", {
                    get: function() {
                        return this._ctx.table.db.Collection;
                    },
                    enumerable: false,
                    configurable: true
                });
                WhereClause2.prototype.between = function(lower, upper, includeLower, includeUpper) {
                    includeLower = includeLower !== false;
                    includeUpper = includeUpper === true;
                    try {
                        if (this._cmp(lower, upper) > 0 || this._cmp(lower, upper) === 0 && (includeLower || includeUpper) && !(includeLower && includeUpper)) return emptyCollection(this);
                        return new this.Collection(this, function() {
                            return createRange(lower, upper, !includeLower, !includeUpper);
                        });
                    } catch (e4) {
                        return fail(this, INVALID_KEY_ARGUMENT);
                    }
                };
                WhereClause2.prototype.equals = function(value2) {
                    if (value2 == null) return fail(this, INVALID_KEY_ARGUMENT);
                    return new this.Collection(this, function() {
                        return rangeEqual(value2);
                    });
                };
                WhereClause2.prototype.above = function(value2) {
                    if (value2 == null) return fail(this, INVALID_KEY_ARGUMENT);
                    return new this.Collection(this, function() {
                        return createRange(value2, void 0, true);
                    });
                };
                WhereClause2.prototype.aboveOrEqual = function(value2) {
                    if (value2 == null) return fail(this, INVALID_KEY_ARGUMENT);
                    return new this.Collection(this, function() {
                        return createRange(value2, void 0, false);
                    });
                };
                WhereClause2.prototype.below = function(value2) {
                    if (value2 == null) return fail(this, INVALID_KEY_ARGUMENT);
                    return new this.Collection(this, function() {
                        return createRange(void 0, value2, false, true);
                    });
                };
                WhereClause2.prototype.belowOrEqual = function(value2) {
                    if (value2 == null) return fail(this, INVALID_KEY_ARGUMENT);
                    return new this.Collection(this, function() {
                        return createRange(void 0, value2);
                    });
                };
                WhereClause2.prototype.startsWith = function(str) {
                    if (typeof str !== "string") return fail(this, STRING_EXPECTED);
                    return this.between(str, str + maxString, true, true);
                };
                WhereClause2.prototype.startsWithIgnoreCase = function(str) {
                    if (str === "") return this.startsWith(str);
                    return addIgnoreCaseAlgorithm(this, function(x3, a3) {
                        return x3.indexOf(a3[0]) === 0;
                    }, [
                        str
                    ], maxString);
                };
                WhereClause2.prototype.equalsIgnoreCase = function(str) {
                    return addIgnoreCaseAlgorithm(this, function(x3, a3) {
                        return x3 === a3[0];
                    }, [
                        str
                    ], "");
                };
                WhereClause2.prototype.anyOfIgnoreCase = function() {
                    var set = getArrayOf.apply(NO_CHAR_ARRAY, arguments);
                    if (set.length === 0) return emptyCollection(this);
                    return addIgnoreCaseAlgorithm(this, function(x3, a3) {
                        return a3.indexOf(x3) !== -1;
                    }, set, "");
                };
                WhereClause2.prototype.startsWithAnyOfIgnoreCase = function() {
                    var set = getArrayOf.apply(NO_CHAR_ARRAY, arguments);
                    if (set.length === 0) return emptyCollection(this);
                    return addIgnoreCaseAlgorithm(this, function(x3, a3) {
                        return a3.some(function(n3) {
                            return x3.indexOf(n3) === 0;
                        });
                    }, set, maxString);
                };
                WhereClause2.prototype.anyOf = function() {
                    var _this = this;
                    var set = getArrayOf.apply(NO_CHAR_ARRAY, arguments);
                    var compare = this._cmp;
                    try {
                        set.sort(compare);
                    } catch (e4) {
                        return fail(this, INVALID_KEY_ARGUMENT);
                    }
                    if (set.length === 0) return emptyCollection(this);
                    var c3 = new this.Collection(this, function() {
                        return createRange(set[0], set[set.length - 1]);
                    });
                    c3._ondirectionchange = function(direction) {
                        compare = direction === "next" ? _this._ascending : _this._descending;
                        set.sort(compare);
                    };
                    var i3 = 0;
                    c3._addAlgorithm(function(cursor, advance2, resolve) {
                        var key = cursor.key;
                        while(compare(key, set[i3]) > 0){
                            ++i3;
                            if (i3 === set.length) {
                                advance2(resolve);
                                return false;
                            }
                        }
                        if (compare(key, set[i3]) === 0) return true;
                        else {
                            advance2(function() {
                                cursor.continue(set[i3]);
                            });
                            return false;
                        }
                    });
                    return c3;
                };
                WhereClause2.prototype.notEqual = function(value2) {
                    return this.inAnyRange([
                        [
                            minKey,
                            value2
                        ],
                        [
                            value2,
                            this.db._maxKey
                        ]
                    ], {
                        includeLowers: false,
                        includeUppers: false
                    });
                };
                WhereClause2.prototype.noneOf = function() {
                    var set = getArrayOf.apply(NO_CHAR_ARRAY, arguments);
                    if (set.length === 0) return new this.Collection(this);
                    try {
                        set.sort(this._ascending);
                    } catch (e4) {
                        return fail(this, INVALID_KEY_ARGUMENT);
                    }
                    var ranges = set.reduce(function(res, val) {
                        return res ? res.concat([
                            [
                                res[res.length - 1][1],
                                val
                            ]
                        ]) : [
                            [
                                minKey,
                                val
                            ]
                        ];
                    }, null);
                    ranges.push([
                        set[set.length - 1],
                        this.db._maxKey
                    ]);
                    return this.inAnyRange(ranges, {
                        includeLowers: false,
                        includeUppers: false
                    });
                };
                WhereClause2.prototype.inAnyRange = function(ranges, options) {
                    var _this = this;
                    var cmp3 = this._cmp, ascending = this._ascending, descending = this._descending, min2 = this._min, max2 = this._max;
                    if (ranges.length === 0) return emptyCollection(this);
                    if (!ranges.every(function(range) {
                        return range[0] !== void 0 && range[1] !== void 0 && ascending(range[0], range[1]) <= 0;
                    })) return fail(this, "First argument to inAnyRange() must be an Array of two-value Arrays [lower,upper] where upper must not be lower than lower", exceptions.InvalidArgument);
                    var includeLowers = !options || options.includeLowers !== false;
                    var includeUppers = options && options.includeUppers === true;
                    function addRange2(ranges2, newRange) {
                        var i3 = 0, l3 = ranges2.length;
                        for(; i3 < l3; ++i3){
                            var range = ranges2[i3];
                            if (cmp3(newRange[0], range[1]) < 0 && cmp3(newRange[1], range[0]) > 0) {
                                range[0] = min2(range[0], newRange[0]);
                                range[1] = max2(range[1], newRange[1]);
                                break;
                            }
                        }
                        if (i3 === l3) ranges2.push(newRange);
                        return ranges2;
                    }
                    var sortDirection = ascending;
                    function rangeSorter(a3, b3) {
                        return sortDirection(a3[0], b3[0]);
                    }
                    var set;
                    try {
                        set = ranges.reduce(addRange2, []);
                        set.sort(rangeSorter);
                    } catch (ex) {
                        return fail(this, INVALID_KEY_ARGUMENT);
                    }
                    var rangePos = 0;
                    var keyIsBeyondCurrentEntry = includeUppers ? function(key) {
                        return ascending(key, set[rangePos][1]) > 0;
                    } : function(key) {
                        return ascending(key, set[rangePos][1]) >= 0;
                    };
                    var keyIsBeforeCurrentEntry = includeLowers ? function(key) {
                        return descending(key, set[rangePos][0]) > 0;
                    } : function(key) {
                        return descending(key, set[rangePos][0]) >= 0;
                    };
                    function keyWithinCurrentRange(key) {
                        return !keyIsBeyondCurrentEntry(key) && !keyIsBeforeCurrentEntry(key);
                    }
                    var checkKey = keyIsBeyondCurrentEntry;
                    var c3 = new this.Collection(this, function() {
                        return createRange(set[0][0], set[set.length - 1][1], !includeLowers, !includeUppers);
                    });
                    c3._ondirectionchange = function(direction) {
                        if (direction === "next") {
                            checkKey = keyIsBeyondCurrentEntry;
                            sortDirection = ascending;
                        } else {
                            checkKey = keyIsBeforeCurrentEntry;
                            sortDirection = descending;
                        }
                        set.sort(rangeSorter);
                    };
                    c3._addAlgorithm(function(cursor, advance2, resolve) {
                        var key = cursor.key;
                        while(checkKey(key)){
                            ++rangePos;
                            if (rangePos === set.length) {
                                advance2(resolve);
                                return false;
                            }
                        }
                        if (keyWithinCurrentRange(key)) return true;
                        else if (_this._cmp(key, set[rangePos][1]) === 0 || _this._cmp(key, set[rangePos][0]) === 0) return false;
                        else {
                            advance2(function() {
                                if (sortDirection === ascending) cursor.continue(set[rangePos][0]);
                                else cursor.continue(set[rangePos][1]);
                            });
                            return false;
                        }
                    });
                    return c3;
                };
                WhereClause2.prototype.startsWithAnyOf = function() {
                    var set = getArrayOf.apply(NO_CHAR_ARRAY, arguments);
                    if (!set.every(function(s3) {
                        return typeof s3 === "string";
                    })) return fail(this, "startsWithAnyOf() only works with strings");
                    if (set.length === 0) return emptyCollection(this);
                    return this.inAnyRange(set.map(function(str) {
                        return [
                            str,
                            str + maxString
                        ];
                    }));
                };
                return WhereClause2;
            }();
            function createWhereClauseConstructor(db) {
                return makeClassConstructor(WhereClause.prototype, function WhereClause2(table, index, orCollection) {
                    this.db = db;
                    this._ctx = {
                        table: table,
                        index: index === ":id" ? null : index,
                        or: orCollection
                    };
                    this._cmp = this._ascending = cmp2;
                    this._descending = function(a3, b3) {
                        return cmp2(b3, a3);
                    };
                    this._max = function(a3, b3) {
                        return cmp2(a3, b3) > 0 ? a3 : b3;
                    };
                    this._min = function(a3, b3) {
                        return cmp2(a3, b3) < 0 ? a3 : b3;
                    };
                    this._IDBKeyRange = db._deps.IDBKeyRange;
                    if (!this._IDBKeyRange) throw new exceptions.MissingAPI();
                });
            }
            function eventRejectHandler(reject) {
                return wrap2(function(event) {
                    preventDefault(event);
                    reject(event.target.error);
                    return false;
                });
            }
            function preventDefault(event) {
                if (event.stopPropagation) event.stopPropagation();
                if (event.preventDefault) event.preventDefault();
            }
            var DEXIE_STORAGE_MUTATED_EVENT_NAME = "storagemutated";
            var STORAGE_MUTATED_DOM_EVENT_NAME = "x-storagemutated-1";
            var globalEvents = Events(null, DEXIE_STORAGE_MUTATED_EVENT_NAME);
            var Transaction2 = function() {
                function Transaction3() {}
                Transaction3.prototype._lock = function() {
                    assert2(!PSD.global);
                    ++this._reculock;
                    if (this._reculock === 1 && !PSD.global) PSD.lockOwnerFor = this;
                    return this;
                };
                Transaction3.prototype._unlock = function() {
                    assert2(!PSD.global);
                    if (--this._reculock === 0) {
                        if (!PSD.global) PSD.lockOwnerFor = null;
                        while(this._blockedFuncs.length > 0 && !this._locked()){
                            var fnAndPSD = this._blockedFuncs.shift();
                            try {
                                usePSD(fnAndPSD[1], fnAndPSD[0]);
                            } catch (e4) {}
                        }
                    }
                    return this;
                };
                Transaction3.prototype._locked = function() {
                    return this._reculock && PSD.lockOwnerFor !== this;
                };
                Transaction3.prototype.create = function(idbtrans) {
                    var _this = this;
                    if (!this.mode) return this;
                    var idbdb = this.db.idbdb;
                    var dbOpenError = this.db._state.dbOpenError;
                    assert2(!this.idbtrans);
                    if (!idbtrans && !idbdb) switch(dbOpenError && dbOpenError.name){
                        case "DatabaseClosedError":
                            throw new exceptions.DatabaseClosed(dbOpenError);
                        case "MissingAPIError":
                            throw new exceptions.MissingAPI(dbOpenError.message, dbOpenError);
                        default:
                            throw new exceptions.OpenFailed(dbOpenError);
                    }
                    if (!this.active) throw new exceptions.TransactionInactive();
                    assert2(this._completion._state === null);
                    idbtrans = this.idbtrans = idbtrans || (this.db.core ? this.db.core.transaction(this.storeNames, this.mode, {
                        durability: this.chromeTransactionDurability
                    }) : idbdb.transaction(this.storeNames, this.mode, {
                        durability: this.chromeTransactionDurability
                    }));
                    idbtrans.onerror = wrap2(function(ev) {
                        preventDefault(ev);
                        _this._reject(idbtrans.error);
                    });
                    idbtrans.onabort = wrap2(function(ev) {
                        preventDefault(ev);
                        _this.active && _this._reject(new exceptions.Abort(idbtrans.error));
                        _this.active = false;
                        _this.on("abort").fire(ev);
                    });
                    idbtrans.oncomplete = wrap2(function() {
                        _this.active = false;
                        _this._resolve();
                        if ("mutatedParts" in idbtrans) globalEvents.storagemutated.fire(idbtrans["mutatedParts"]);
                    });
                    return this;
                };
                Transaction3.prototype._promise = function(mode, fn, bWriteLock) {
                    var _this = this;
                    if (mode === "readwrite" && this.mode !== "readwrite") return rejection(new exceptions.ReadOnly("Transaction is readonly"));
                    if (!this.active) return rejection(new exceptions.TransactionInactive());
                    if (this._locked()) return new DexiePromise(function(resolve, reject) {
                        _this._blockedFuncs.push([
                            function() {
                                _this._promise(mode, fn, bWriteLock).then(resolve, reject);
                            },
                            PSD
                        ]);
                    });
                    else if (bWriteLock) return newScope(function() {
                        var p4 = new DexiePromise(function(resolve, reject) {
                            _this._lock();
                            var rv = fn(resolve, reject, _this);
                            if (rv && rv.then) rv.then(resolve, reject);
                        });
                        p4.finally(function() {
                            return _this._unlock();
                        });
                        p4._lib = true;
                        return p4;
                    });
                    else {
                        var p3 = new DexiePromise(function(resolve, reject) {
                            var rv = fn(resolve, reject, _this);
                            if (rv && rv.then) rv.then(resolve, reject);
                        });
                        p3._lib = true;
                        return p3;
                    }
                };
                Transaction3.prototype._root = function() {
                    return this.parent ? this.parent._root() : this;
                };
                Transaction3.prototype.waitFor = function(promiseLike) {
                    var root = this._root();
                    var promise = DexiePromise.resolve(promiseLike);
                    if (root._waitingFor) root._waitingFor = root._waitingFor.then(function() {
                        return promise;
                    });
                    else {
                        root._waitingFor = promise;
                        root._waitingQueue = [];
                        var store = root.idbtrans.objectStore(root.storeNames[0]);
                        (function spin() {
                            ++root._spinCount;
                            while(root._waitingQueue.length)root._waitingQueue.shift()();
                            if (root._waitingFor) store.get(-Infinity).onsuccess = spin;
                        })();
                    }
                    var currentWaitPromise = root._waitingFor;
                    return new DexiePromise(function(resolve, reject) {
                        promise.then(function(res) {
                            return root._waitingQueue.push(wrap2(resolve.bind(null, res)));
                        }, function(err) {
                            return root._waitingQueue.push(wrap2(reject.bind(null, err)));
                        }).finally(function() {
                            if (root._waitingFor === currentWaitPromise) root._waitingFor = null;
                        });
                    });
                };
                Transaction3.prototype.abort = function() {
                    if (this.active) {
                        this.active = false;
                        if (this.idbtrans) this.idbtrans.abort();
                        this._reject(new exceptions.Abort());
                    }
                };
                Transaction3.prototype.table = function(tableName) {
                    var memoizedTables = this._memoizedTables || (this._memoizedTables = {});
                    if (hasOwn2(memoizedTables, tableName)) return memoizedTables[tableName];
                    var tableSchema = this.schema[tableName];
                    if (!tableSchema) throw new exceptions.NotFound("Table " + tableName + " not part of transaction");
                    var transactionBoundTable = new this.db.Table(tableName, tableSchema, this);
                    transactionBoundTable.core = this.db.core.table(tableName);
                    memoizedTables[tableName] = transactionBoundTable;
                    return transactionBoundTable;
                };
                return Transaction3;
            }();
            function createTransactionConstructor(db) {
                return makeClassConstructor(Transaction2.prototype, function Transaction3(mode, storeNames, dbschema, chromeTransactionDurability, parent) {
                    var _this = this;
                    if (mode !== "readonly") storeNames.forEach(function(storeName) {
                        var _a3;
                        var yProps = (_a3 = dbschema[storeName]) === null || _a3 === void 0 ? void 0 : _a3.yProps;
                        if (yProps) storeNames = storeNames.concat(yProps.map(function(p3) {
                            return p3.updatesTable;
                        }));
                    });
                    this.db = db;
                    this.mode = mode;
                    this.storeNames = storeNames;
                    this.schema = dbschema;
                    this.chromeTransactionDurability = chromeTransactionDurability;
                    this.idbtrans = null;
                    this.on = Events(this, "complete", "error", "abort");
                    this.parent = parent || null;
                    this.active = true;
                    this._reculock = 0;
                    this._blockedFuncs = [];
                    this._resolve = null;
                    this._reject = null;
                    this._waitingFor = null;
                    this._waitingQueue = null;
                    this._spinCount = 0;
                    this._completion = new DexiePromise(function(resolve, reject) {
                        _this._resolve = resolve;
                        _this._reject = reject;
                    });
                    this._completion.then(function() {
                        _this.active = false;
                        _this.on.complete.fire();
                    }, function(e4) {
                        var wasActive = _this.active;
                        _this.active = false;
                        _this.on.error.fire(e4);
                        _this.parent ? _this.parent._reject(e4) : wasActive && _this.idbtrans && _this.idbtrans.abort();
                        return rejection(e4);
                    });
                });
            }
            function createIndexSpec(name, keyPath, unique, multi, auto, compound, isPrimKey, type2) {
                return {
                    name: name,
                    keyPath: keyPath,
                    unique: unique,
                    multi: multi,
                    auto: auto,
                    compound: compound,
                    src: (unique && !isPrimKey ? "&" : "") + (multi ? "*" : "") + (auto ? "++" : "") + nameFromKeyPath(keyPath),
                    type: type2
                };
            }
            function nameFromKeyPath(keyPath) {
                return typeof keyPath === "string" ? keyPath : keyPath ? "[" + [].join.call(keyPath, "+") + "]" : "";
            }
            function createTableSchema(name, primKey, indexes) {
                return {
                    name: name,
                    primKey: primKey,
                    indexes: indexes,
                    mappedClass: null,
                    idxByName: arrayToObject(indexes, function(index) {
                        return [
                            index.name,
                            index
                        ];
                    })
                };
            }
            function safariMultiStoreFix(storeNames) {
                return storeNames.length === 1 ? storeNames[0] : storeNames;
            }
            var getMaxKey = function(IdbKeyRange) {
                try {
                    IdbKeyRange.only([
                        []
                    ]);
                    getMaxKey = function() {
                        return [
                            []
                        ];
                    };
                    return [
                        []
                    ];
                } catch (e4) {
                    getMaxKey = function() {
                        return maxString;
                    };
                    return maxString;
                }
            };
            function getKeyExtractor(keyPath) {
                if (keyPath == null) return function() {
                    return void 0;
                };
                else if (typeof keyPath === "string") return getSinglePathKeyExtractor(keyPath);
                else return function(obj) {
                    return getByKeyPath(obj, keyPath);
                };
            }
            function getSinglePathKeyExtractor(keyPath) {
                var split = keyPath.split(".");
                if (split.length === 1) return function(obj) {
                    return obj[keyPath];
                };
                else return function(obj) {
                    return getByKeyPath(obj, keyPath);
                };
            }
            function arrayify(arrayLike) {
                return [].slice.call(arrayLike);
            }
            var _id_counter = 0;
            function getKeyPathAlias(keyPath) {
                return keyPath == null ? ":id" : typeof keyPath === "string" ? keyPath : "[".concat(keyPath.join("+"), "]");
            }
            function createDBCore(db, IdbKeyRange, tmpTrans) {
                function extractSchema(db2, trans) {
                    var tables2 = arrayify(db2.objectStoreNames);
                    var tempStore = tables2.length > 0 ? trans.objectStore(tables2[0]) : {};
                    return {
                        schema: {
                            name: db2.name,
                            tables: tables2.map(function(table) {
                                return trans.objectStore(table);
                            }).map(function(store) {
                                var keyPath = store.keyPath, autoIncrement = store.autoIncrement;
                                var compound = isArray5(keyPath);
                                var outbound = keyPath == null;
                                var indexByKeyPath = {};
                                var result = {
                                    name: store.name,
                                    primaryKey: {
                                        name: null,
                                        isPrimaryKey: true,
                                        outbound: outbound,
                                        compound: compound,
                                        keyPath: keyPath,
                                        autoIncrement: autoIncrement,
                                        unique: true,
                                        extractKey: getKeyExtractor(keyPath)
                                    },
                                    indexes: arrayify(store.indexNames).map(function(indexName) {
                                        return store.index(indexName);
                                    }).map(function(index) {
                                        var name = index.name, unique = index.unique, multiEntry = index.multiEntry, keyPath2 = index.keyPath;
                                        var compound2 = isArray5(keyPath2);
                                        var result2 = {
                                            name: name,
                                            compound: compound2,
                                            keyPath: keyPath2,
                                            unique: unique,
                                            multiEntry: multiEntry,
                                            extractKey: getKeyExtractor(keyPath2)
                                        };
                                        indexByKeyPath[getKeyPathAlias(keyPath2)] = result2;
                                        return result2;
                                    }),
                                    getIndexByKeyPath: function(keyPath2) {
                                        return indexByKeyPath[getKeyPathAlias(keyPath2)];
                                    }
                                };
                                indexByKeyPath[":id"] = result.primaryKey;
                                if (keyPath != null) indexByKeyPath[getKeyPathAlias(keyPath)] = result.primaryKey;
                                return result;
                            })
                        },
                        hasGetAll: tables2.length > 0 && "getAll" in tempStore && !(typeof navigator !== "undefined" && /Safari/.test(navigator.userAgent) && !/(Chrome\/|Edge\/)/.test(navigator.userAgent) && [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604),
                        hasIdb3Features: "getAllRecords" in tempStore
                    };
                }
                function makeIDBKeyRange(range) {
                    if (range.type === 3) return null;
                    if (range.type === 4) throw new Error("Cannot convert never type to IDBKeyRange");
                    var lower = range.lower, upper = range.upper, lowerOpen = range.lowerOpen, upperOpen = range.upperOpen;
                    var idbRange = lower === void 0 ? upper === void 0 ? null : IdbKeyRange.upperBound(upper, !!upperOpen) : upper === void 0 ? IdbKeyRange.lowerBound(lower, !!lowerOpen) : IdbKeyRange.bound(lower, upper, !!lowerOpen, !!upperOpen);
                    return idbRange;
                }
                function createDbCoreTable(tableSchema) {
                    var tableName = tableSchema.name;
                    function mutate(_a4) {
                        var trans = _a4.trans, type2 = _a4.type, keys3 = _a4.keys, values = _a4.values, range = _a4.range;
                        return new Promise(function(resolve, reject) {
                            resolve = wrap2(resolve);
                            var store = trans.objectStore(tableName);
                            var outbound = store.keyPath == null;
                            var isAddOrPut = type2 === "put" || type2 === "add";
                            if (!isAddOrPut && type2 !== "delete" && type2 !== "deleteRange") throw new Error("Invalid operation type: " + type2);
                            var length2 = (keys3 || values || {
                                length: 1
                            }).length;
                            if (keys3 && values && keys3.length !== values.length) throw new Error("Given keys array must have same length as given values array.");
                            if (length2 === 0) return resolve({
                                numFailures: 0,
                                failures: {},
                                results: [],
                                lastResult: void 0
                            });
                            var req;
                            var reqs = [];
                            var failures = [];
                            var numFailures = 0;
                            var errorHandler = function(event) {
                                ++numFailures;
                                preventDefault(event);
                            };
                            if (type2 === "deleteRange") {
                                if (range.type === 4) return resolve({
                                    numFailures: numFailures,
                                    failures: failures,
                                    results: [],
                                    lastResult: void 0
                                });
                                if (range.type === 3) reqs.push(req = store.clear());
                                else reqs.push(req = store.delete(makeIDBKeyRange(range)));
                            } else {
                                var _a5 = isAddOrPut ? outbound ? [
                                    values,
                                    keys3
                                ] : [
                                    values,
                                    null
                                ] : [
                                    keys3,
                                    null
                                ], args1 = _a5[0], args2 = _a5[1];
                                if (isAddOrPut) for(var i3 = 0; i3 < length2; ++i3){
                                    reqs.push(req = args2 && args2[i3] !== void 0 ? store[type2](args1[i3], args2[i3]) : store[type2](args1[i3]));
                                    req.onerror = errorHandler;
                                }
                                else for(var i3 = 0; i3 < length2; ++i3){
                                    reqs.push(req = store[type2](args1[i3]));
                                    req.onerror = errorHandler;
                                }
                            }
                            var done = function(event) {
                                var lastResult = event.target.result;
                                reqs.forEach(function(req2, i4) {
                                    return req2.error != null && (failures[i4] = req2.error);
                                });
                                resolve({
                                    numFailures: numFailures,
                                    failures: failures,
                                    results: type2 === "delete" ? keys3 : reqs.map(function(req2) {
                                        return req2.result;
                                    }),
                                    lastResult: lastResult
                                });
                            };
                            req.onerror = function(event) {
                                errorHandler(event);
                                done(event);
                            };
                            req.onsuccess = done;
                        });
                    }
                    function openCursor2(_a4) {
                        var trans = _a4.trans, values = _a4.values, query2 = _a4.query, reverse = _a4.reverse, unique = _a4.unique;
                        return new Promise(function(resolve, reject) {
                            resolve = wrap2(resolve);
                            var index = query2.index, range = query2.range;
                            var store = trans.objectStore(tableName);
                            var source = index.isPrimaryKey ? store : store.index(index.name);
                            var direction = reverse ? unique ? "prevunique" : "prev" : unique ? "nextunique" : "next";
                            var req = values || !("openKeyCursor" in source) ? source.openCursor(makeIDBKeyRange(range), direction) : source.openKeyCursor(makeIDBKeyRange(range), direction);
                            req.onerror = eventRejectHandler(reject);
                            req.onsuccess = wrap2(function(ev) {
                                var cursor = req.result;
                                if (!cursor) {
                                    resolve(null);
                                    return;
                                }
                                cursor.___id = ++_id_counter;
                                cursor.done = false;
                                var _cursorContinue = cursor.continue.bind(cursor);
                                var _cursorContinuePrimaryKey = cursor.continuePrimaryKey;
                                if (_cursorContinuePrimaryKey) _cursorContinuePrimaryKey = _cursorContinuePrimaryKey.bind(cursor);
                                var _cursorAdvance = cursor.advance.bind(cursor);
                                var doThrowCursorIsNotStarted = function() {
                                    throw new Error("Cursor not started");
                                };
                                var doThrowCursorIsStopped = function() {
                                    throw new Error("Cursor not stopped");
                                };
                                cursor.trans = trans;
                                cursor.stop = cursor.continue = cursor.continuePrimaryKey = cursor.advance = doThrowCursorIsNotStarted;
                                cursor.fail = wrap2(reject);
                                cursor.next = function() {
                                    var _this = this;
                                    var gotOne = 1;
                                    return this.start(function() {
                                        return gotOne-- ? _this.continue() : _this.stop();
                                    }).then(function() {
                                        return _this;
                                    });
                                };
                                cursor.start = function(callback) {
                                    var iterationPromise = new Promise(function(resolveIteration, rejectIteration) {
                                        resolveIteration = wrap2(resolveIteration);
                                        req.onerror = eventRejectHandler(rejectIteration);
                                        cursor.fail = rejectIteration;
                                        cursor.stop = function(value2) {
                                            cursor.stop = cursor.continue = cursor.continuePrimaryKey = cursor.advance = doThrowCursorIsStopped;
                                            resolveIteration(value2);
                                        };
                                    });
                                    var guardedCallback = function() {
                                        if (req.result) try {
                                            callback();
                                        } catch (err) {
                                            cursor.fail(err);
                                        }
                                        else {
                                            cursor.done = true;
                                            cursor.start = function() {
                                                throw new Error("Cursor behind last entry");
                                            };
                                            cursor.stop();
                                        }
                                    };
                                    req.onsuccess = wrap2(function(ev2) {
                                        req.onsuccess = guardedCallback;
                                        guardedCallback();
                                    });
                                    cursor.continue = _cursorContinue;
                                    cursor.continuePrimaryKey = _cursorContinuePrimaryKey;
                                    cursor.advance = _cursorAdvance;
                                    guardedCallback();
                                    return iterationPromise;
                                };
                                resolve(cursor);
                            }, reject);
                        });
                    }
                    function query(hasGetAll2, hasIdb3Features2) {
                        return function(request) {
                            return new Promise(function(resolve, reject) {
                                var _a4;
                                resolve = wrap2(resolve);
                                var trans = request.trans, values = request.values, limit = request.limit, query2 = request.query;
                                var direction = (_a4 = request.direction) !== null && _a4 !== void 0 ? _a4 : "next";
                                var nonInfinitLimit = limit === Infinity ? void 0 : limit;
                                var index = query2.index, range = query2.range;
                                var store = trans.objectStore(tableName);
                                var source = index.isPrimaryKey ? store : store.index(index.name);
                                var idbKeyRange = makeIDBKeyRange(range);
                                if (limit === 0) return resolve({
                                    result: []
                                });
                                if (hasIdb3Features2) {
                                    var options = {
                                        query: idbKeyRange,
                                        count: nonInfinitLimit,
                                        direction: direction
                                    };
                                    var req = values ? source.getAll(options) : source.getAllKeys(options);
                                    req.onsuccess = function(event) {
                                        return resolve({
                                            result: event.target.result
                                        });
                                    };
                                    req.onerror = eventRejectHandler(reject);
                                } else if (hasGetAll2 && direction === "next") {
                                    var req = values ? source.getAll(idbKeyRange, nonInfinitLimit) : source.getAllKeys(idbKeyRange, nonInfinitLimit);
                                    req.onsuccess = function(event) {
                                        return resolve({
                                            result: event.target.result
                                        });
                                    };
                                    req.onerror = eventRejectHandler(reject);
                                } else {
                                    var count_1 = 0;
                                    var req_1 = values || !("openKeyCursor" in source) ? source.openCursor(idbKeyRange, direction) : source.openKeyCursor(idbKeyRange, direction);
                                    var result_1 = [];
                                    req_1.onsuccess = function() {
                                        var cursor = req_1.result;
                                        if (!cursor) return resolve({
                                            result: result_1
                                        });
                                        result_1.push(values ? cursor.value : cursor.primaryKey);
                                        if (++count_1 === limit) return resolve({
                                            result: result_1
                                        });
                                        cursor.continue();
                                    };
                                    req_1.onerror = eventRejectHandler(reject);
                                }
                            });
                        };
                    }
                    return {
                        name: tableName,
                        schema: tableSchema,
                        mutate: mutate,
                        getMany: function(_a4) {
                            var trans = _a4.trans, keys3 = _a4.keys;
                            return new Promise(function(resolve, reject) {
                                resolve = wrap2(resolve);
                                var store = trans.objectStore(tableName);
                                var length2 = keys3.length;
                                var result = new Array(length2);
                                var keyCount = 0;
                                var callbackCount = 0;
                                var req;
                                var successHandler = function(event) {
                                    var req2 = event.target;
                                    result[req2._pos] = req2.result;
                                    if (++callbackCount === keyCount) resolve(result);
                                };
                                var errorHandler = eventRejectHandler(reject);
                                for(var i3 = 0; i3 < length2; ++i3){
                                    var key = keys3[i3];
                                    if (key != null) {
                                        req = store.get(keys3[i3]);
                                        req._pos = i3;
                                        req.onsuccess = successHandler;
                                        req.onerror = errorHandler;
                                        ++keyCount;
                                    }
                                }
                                if (keyCount === 0) resolve(result);
                            });
                        },
                        get: function(_a4) {
                            var trans = _a4.trans, key = _a4.key;
                            return new Promise(function(resolve, reject) {
                                resolve = wrap2(resolve);
                                var store = trans.objectStore(tableName);
                                var req = store.get(key);
                                req.onsuccess = function(event) {
                                    return resolve(event.target.result);
                                };
                                req.onerror = eventRejectHandler(reject);
                            });
                        },
                        query: query(hasGetAll, hasIdb3Features),
                        openCursor: openCursor2,
                        count: function(_a4) {
                            var query2 = _a4.query, trans = _a4.trans;
                            var index = query2.index, range = query2.range;
                            return new Promise(function(resolve, reject) {
                                var store = trans.objectStore(tableName);
                                var source = index.isPrimaryKey ? store : store.index(index.name);
                                var idbKeyRange = makeIDBKeyRange(range);
                                var req = idbKeyRange ? source.count(idbKeyRange) : source.count();
                                req.onsuccess = wrap2(function(ev) {
                                    return resolve(ev.target.result);
                                });
                                req.onerror = eventRejectHandler(reject);
                            });
                        }
                    };
                }
                var _a3 = extractSchema(db, tmpTrans), schema = _a3.schema, hasGetAll = _a3.hasGetAll, hasIdb3Features = _a3.hasIdb3Features;
                var tables = schema.tables.map(function(tableSchema) {
                    return createDbCoreTable(tableSchema);
                });
                var tableMap = {};
                tables.forEach(function(table) {
                    return tableMap[table.name] = table;
                });
                return {
                    stack: "dbcore",
                    transaction: db.transaction.bind(db),
                    table: function(name) {
                        var result = tableMap[name];
                        if (!result) throw new Error("Table '".concat(name, "' not found"));
                        return tableMap[name];
                    },
                    MIN_KEY: -Infinity,
                    MAX_KEY: getMaxKey(IdbKeyRange),
                    schema: schema
                };
            }
            function createMiddlewareStack(stackImpl, middlewares) {
                return middlewares.reduce(function(down, _a3) {
                    var create7 = _a3.create;
                    return __assign(__assign({}, down), create7(down));
                }, stackImpl);
            }
            function createMiddlewareStacks(middlewares, idbdb, _a3, tmpTrans) {
                var IDBKeyRange2 = _a3.IDBKeyRange;
                _a3.indexedDB;
                var dbcore = createMiddlewareStack(createDBCore(idbdb, IDBKeyRange2, tmpTrans), middlewares.dbcore);
                return {
                    dbcore: dbcore
                };
            }
            function generateMiddlewareStacks(db, tmpTrans) {
                var idbdb = tmpTrans.db;
                var stacks = createMiddlewareStacks(db._middlewares, idbdb, db._deps, tmpTrans);
                db.core = stacks.dbcore;
                db.tables.forEach(function(table) {
                    var tableName = table.name;
                    if (db.core.schema.tables.some(function(tbl) {
                        return tbl.name === tableName;
                    })) {
                        table.core = db.core.table(tableName);
                        if (db[tableName] instanceof db.Table) db[tableName].core = table.core;
                    }
                });
            }
            function setApiOnPlace(db, objs, tableNames, dbschema) {
                tableNames.forEach(function(tableName) {
                    var schema = dbschema[tableName];
                    objs.forEach(function(obj) {
                        var propDesc = getPropertyDescriptor(obj, tableName);
                        if (!propDesc || "value" in propDesc && propDesc.value === void 0) {
                            if (obj === db.Transaction.prototype || obj instanceof db.Transaction) setProp(obj, tableName, {
                                get: function() {
                                    return this.table(tableName);
                                },
                                set: function(value2) {
                                    defineProperty2(this, tableName, {
                                        value: value2,
                                        writable: true,
                                        configurable: true,
                                        enumerable: true
                                    });
                                }
                            });
                            else obj[tableName] = new db.Table(tableName, schema);
                        }
                    });
                });
            }
            function removeTablesApi(db, objs) {
                objs.forEach(function(obj) {
                    for(var key in obj)if (obj[key] instanceof db.Table) delete obj[key];
                });
            }
            function lowerVersionFirst(a3, b3) {
                return a3._cfg.version - b3._cfg.version;
            }
            function runUpgraders(db, oldVersion, idbUpgradeTrans, reject) {
                var globalSchema = db._dbSchema;
                if (idbUpgradeTrans.objectStoreNames.contains("$meta") && !globalSchema.$meta) {
                    globalSchema.$meta = createTableSchema("$meta", parseIndexSyntax("")[0], []);
                    db._storeNames.push("$meta");
                }
                var trans = db._createTransaction("readwrite", db._storeNames, globalSchema);
                trans.create(idbUpgradeTrans);
                trans._completion.catch(reject);
                var rejectTransaction = trans._reject.bind(trans);
                var transless = PSD.transless || PSD;
                newScope(function() {
                    PSD.trans = trans;
                    PSD.transless = transless;
                    if (oldVersion === 0) {
                        keys2(globalSchema).forEach(function(tableName) {
                            createTable(idbUpgradeTrans, tableName, globalSchema[tableName].primKey, globalSchema[tableName].indexes);
                        });
                        generateMiddlewareStacks(db, idbUpgradeTrans);
                        DexiePromise.follow(function() {
                            return db.on.populate.fire(trans);
                        }).catch(rejectTransaction);
                    } else {
                        generateMiddlewareStacks(db, idbUpgradeTrans);
                        return getExistingVersion(db, trans, oldVersion).then(function(oldVersion2) {
                            return updateTablesAndIndexes(db, oldVersion2, trans, idbUpgradeTrans);
                        }).catch(rejectTransaction);
                    }
                });
            }
            function patchCurrentVersion(db, idbUpgradeTrans) {
                createMissingTables(db._dbSchema, idbUpgradeTrans);
                if (idbUpgradeTrans.db.version % 10 === 0 && !idbUpgradeTrans.objectStoreNames.contains("$meta")) idbUpgradeTrans.db.createObjectStore("$meta").add(Math.ceil(idbUpgradeTrans.db.version / 10 - 1), "version");
                var globalSchema = buildGlobalSchema(db, db.idbdb, idbUpgradeTrans);
                adjustToExistingIndexNames(db, db._dbSchema, idbUpgradeTrans);
                var diff = getSchemaDiff(globalSchema, db._dbSchema);
                var _loop_1 = function(tableChange2) {
                    if (tableChange2.change.length || tableChange2.recreate) {
                        console.warn("Unable to patch indexes of table ".concat(tableChange2.name, " because it has changes on the type of index or primary key."));
                        return {
                            value: void 0
                        };
                    }
                    var store = idbUpgradeTrans.objectStore(tableChange2.name);
                    tableChange2.add.forEach(function(idx) {
                        if (debug) console.debug("Dexie upgrade patch: Creating missing index ".concat(tableChange2.name, ".").concat(idx.src));
                        addIndex(store, idx);
                    });
                };
                for(var _i = 0, _a3 = diff.change; _i < _a3.length; _i++){
                    var tableChange = _a3[_i];
                    var state_1 = _loop_1(tableChange);
                    if (typeof state_1 === "object") return state_1.value;
                }
            }
            function getExistingVersion(db, trans, oldVersion) {
                if (trans.storeNames.includes("$meta")) return trans.table("$meta").get("version").then(function(metaVersion) {
                    return metaVersion != null ? metaVersion : oldVersion;
                });
                else return DexiePromise.resolve(oldVersion);
            }
            function updateTablesAndIndexes(db, oldVersion, trans, idbUpgradeTrans) {
                var queue = [];
                var versions = db._versions;
                var globalSchema = db._dbSchema = buildGlobalSchema(db, db.idbdb, idbUpgradeTrans);
                var versToRun = versions.filter(function(v3) {
                    return v3._cfg.version >= oldVersion;
                });
                if (versToRun.length === 0) return DexiePromise.resolve();
                versToRun.forEach(function(version6) {
                    queue.push(function() {
                        var oldSchema = globalSchema;
                        var newSchema = version6._cfg.dbschema;
                        adjustToExistingIndexNames(db, oldSchema, idbUpgradeTrans);
                        adjustToExistingIndexNames(db, newSchema, idbUpgradeTrans);
                        globalSchema = db._dbSchema = newSchema;
                        var diff = getSchemaDiff(oldSchema, newSchema);
                        diff.add.forEach(function(tuple) {
                            createTable(idbUpgradeTrans, tuple[0], tuple[1].primKey, tuple[1].indexes);
                        });
                        diff.change.forEach(function(change) {
                            if (change.recreate) throw new exceptions.Upgrade("Not yet support for changing primary key");
                            else {
                                var store_1 = idbUpgradeTrans.objectStore(change.name);
                                change.add.forEach(function(idx) {
                                    return addIndex(store_1, idx);
                                });
                                change.change.forEach(function(idx) {
                                    store_1.deleteIndex(idx.name);
                                    addIndex(store_1, idx);
                                });
                                change.del.forEach(function(idxName) {
                                    return store_1.deleteIndex(idxName);
                                });
                            }
                        });
                        var contentUpgrade = version6._cfg.contentUpgrade;
                        if (contentUpgrade && version6._cfg.version > oldVersion) {
                            generateMiddlewareStacks(db, idbUpgradeTrans);
                            trans._memoizedTables = {};
                            var upgradeSchema_1 = shallowClone(newSchema);
                            diff.del.forEach(function(table) {
                                upgradeSchema_1[table] = oldSchema[table];
                            });
                            removeTablesApi(db, [
                                db.Transaction.prototype
                            ]);
                            setApiOnPlace(db, [
                                db.Transaction.prototype
                            ], keys2(upgradeSchema_1), upgradeSchema_1);
                            trans.schema = upgradeSchema_1;
                            var contentUpgradeIsAsync_1 = isAsyncFunction(contentUpgrade);
                            if (contentUpgradeIsAsync_1) incrementExpectedAwaits();
                            var returnValue_1;
                            var promiseFollowed = DexiePromise.follow(function() {
                                returnValue_1 = contentUpgrade(trans);
                                if (returnValue_1) {
                                    if (contentUpgradeIsAsync_1) {
                                        var decrementor = decrementExpectedAwaits.bind(null, null);
                                        returnValue_1.then(decrementor, decrementor);
                                    }
                                }
                            });
                            return returnValue_1 && typeof returnValue_1.then === "function" ? DexiePromise.resolve(returnValue_1) : promiseFollowed.then(function() {
                                return returnValue_1;
                            });
                        }
                    });
                    queue.push(function(idbtrans) {
                        var newSchema = version6._cfg.dbschema;
                        deleteRemovedTables(newSchema, idbtrans);
                        removeTablesApi(db, [
                            db.Transaction.prototype
                        ]);
                        setApiOnPlace(db, [
                            db.Transaction.prototype
                        ], db._storeNames, db._dbSchema);
                        trans.schema = db._dbSchema;
                    });
                    queue.push(function(idbtrans) {
                        if (db.idbdb.objectStoreNames.contains("$meta")) {
                            if (Math.ceil(db.idbdb.version / 10) === version6._cfg.version) {
                                db.idbdb.deleteObjectStore("$meta");
                                delete db._dbSchema.$meta;
                                db._storeNames = db._storeNames.filter(function(name) {
                                    return name !== "$meta";
                                });
                            } else idbtrans.objectStore("$meta").put(version6._cfg.version, "version");
                        }
                    });
                });
                function runQueue() {
                    return queue.length ? DexiePromise.resolve(queue.shift()(trans.idbtrans)).then(runQueue) : DexiePromise.resolve();
                }
                return runQueue().then(function() {
                    createMissingTables(globalSchema, idbUpgradeTrans);
                });
            }
            function getSchemaDiff(oldSchema, newSchema) {
                var diff = {
                    del: [],
                    add: [],
                    change: []
                };
                var table;
                for(table in oldSchema)if (!newSchema[table]) diff.del.push(table);
                for(table in newSchema){
                    var oldDef = oldSchema[table], newDef = newSchema[table];
                    if (!oldDef) diff.add.push([
                        table,
                        newDef
                    ]);
                    else {
                        var change = {
                            name: table,
                            def: newDef,
                            recreate: false,
                            del: [],
                            add: [],
                            change: []
                        };
                        if ("" + (oldDef.primKey.keyPath || "") !== "" + (newDef.primKey.keyPath || "") || oldDef.primKey.auto !== newDef.primKey.auto) {
                            change.recreate = true;
                            diff.change.push(change);
                        } else {
                            var oldIndexes = oldDef.idxByName;
                            var newIndexes = newDef.idxByName;
                            var idxName = void 0;
                            for(idxName in oldIndexes)if (!newIndexes[idxName]) change.del.push(idxName);
                            for(idxName in newIndexes){
                                var oldIdx = oldIndexes[idxName], newIdx = newIndexes[idxName];
                                if (!oldIdx) change.add.push(newIdx);
                                else if (oldIdx.src !== newIdx.src) change.change.push(newIdx);
                            }
                            if (change.del.length > 0 || change.add.length > 0 || change.change.length > 0) diff.change.push(change);
                        }
                    }
                }
                return diff;
            }
            function createTable(idbtrans, tableName, primKey, indexes) {
                var store = idbtrans.db.createObjectStore(tableName, primKey.keyPath ? {
                    keyPath: primKey.keyPath,
                    autoIncrement: primKey.auto
                } : {
                    autoIncrement: primKey.auto
                });
                indexes.forEach(function(idx) {
                    return addIndex(store, idx);
                });
                return store;
            }
            function createMissingTables(newSchema, idbtrans) {
                keys2(newSchema).forEach(function(tableName) {
                    if (!idbtrans.db.objectStoreNames.contains(tableName)) {
                        if (debug) console.debug("Dexie: Creating missing table", tableName);
                        createTable(idbtrans, tableName, newSchema[tableName].primKey, newSchema[tableName].indexes);
                    }
                });
            }
            function deleteRemovedTables(newSchema, idbtrans) {
                [].slice.call(idbtrans.db.objectStoreNames).forEach(function(storeName) {
                    return newSchema[storeName] == null && idbtrans.db.deleteObjectStore(storeName);
                });
            }
            function addIndex(store, idx) {
                store.createIndex(idx.name, idx.keyPath, {
                    unique: idx.unique,
                    multiEntry: idx.multi
                });
            }
            function buildGlobalSchema(db, idbdb, tmpTrans) {
                var globalSchema = {};
                var dbStoreNames = slice(idbdb.objectStoreNames, 0);
                dbStoreNames.forEach(function(storeName) {
                    var store = tmpTrans.objectStore(storeName);
                    var keyPath = store.keyPath;
                    var primKey = createIndexSpec(nameFromKeyPath(keyPath), keyPath || "", true, false, !!store.autoIncrement, keyPath && typeof keyPath !== "string", true);
                    var indexes = [];
                    for(var j3 = 0; j3 < store.indexNames.length; ++j3){
                        var idbindex = store.index(store.indexNames[j3]);
                        keyPath = idbindex.keyPath;
                        var index = createIndexSpec(idbindex.name, keyPath, !!idbindex.unique, !!idbindex.multiEntry, false, keyPath && typeof keyPath !== "string", false);
                        indexes.push(index);
                    }
                    globalSchema[storeName] = createTableSchema(storeName, primKey, indexes);
                });
                return globalSchema;
            }
            function readGlobalSchema(db, idbdb, tmpTrans) {
                db.verno = idbdb.version / 10;
                var globalSchema = db._dbSchema = buildGlobalSchema(db, idbdb, tmpTrans);
                db._storeNames = slice(idbdb.objectStoreNames, 0);
                setApiOnPlace(db, [
                    db._allTables
                ], keys2(globalSchema), globalSchema);
            }
            function verifyInstalledSchema(db, tmpTrans) {
                var installedSchema = buildGlobalSchema(db, db.idbdb, tmpTrans);
                var diff = getSchemaDiff(installedSchema, db._dbSchema);
                return !(diff.add.length || diff.change.some(function(ch) {
                    return ch.add.length || ch.change.length;
                }));
            }
            function adjustToExistingIndexNames(db, schema, idbtrans) {
                var storeNames = idbtrans.db.objectStoreNames;
                for(var i3 = 0; i3 < storeNames.length; ++i3){
                    var storeName = storeNames[i3];
                    var store = idbtrans.objectStore(storeName);
                    db._hasGetAll = "getAll" in store;
                    for(var j3 = 0; j3 < store.indexNames.length; ++j3){
                        var indexName = store.indexNames[j3];
                        var keyPath = store.index(indexName).keyPath;
                        var dexieName = typeof keyPath === "string" ? keyPath : "[" + slice(keyPath).join("+") + "]";
                        if (schema[storeName]) {
                            var indexSpec = schema[storeName].idxByName[dexieName];
                            if (indexSpec) {
                                indexSpec.name = indexName;
                                delete schema[storeName].idxByName[dexieName];
                                schema[storeName].idxByName[indexName] = indexSpec;
                            }
                        }
                    }
                }
                if (typeof navigator !== "undefined" && /Safari/.test(navigator.userAgent) && !/(Chrome\/|Edge\/)/.test(navigator.userAgent) && _global3.WorkerGlobalScope && _global3 instanceof _global3.WorkerGlobalScope && [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604) db._hasGetAll = false;
            }
            function parseIndexSyntax(primKeyAndIndexes) {
                return primKeyAndIndexes.split(",").map(function(index, indexNum) {
                    var _a3;
                    var typeSplit = index.split(":");
                    var type2 = (_a3 = typeSplit[1]) === null || _a3 === void 0 ? void 0 : _a3.trim();
                    index = typeSplit[0].trim();
                    var name = index.replace(/([&*]|\+\+)/g, "");
                    var keyPath = /^\[/.test(name) ? name.match(/^\[(.*)\]$/)[1].split("+") : name;
                    return createIndexSpec(name, keyPath || null, /\&/.test(index), /\*/.test(index), /\+\+/.test(index), isArray5(keyPath), indexNum === 0, type2);
                });
            }
            var Version = function() {
                function Version2() {}
                Version2.prototype._createTableSchema = function(name, primKey, indexes) {
                    return createTableSchema(name, primKey, indexes);
                };
                Version2.prototype._parseIndexSyntax = function(primKeyAndIndexes) {
                    return parseIndexSyntax(primKeyAndIndexes);
                };
                Version2.prototype._parseStoresSpec = function(stores, outSchema) {
                    var _this = this;
                    keys2(stores).forEach(function(tableName) {
                        if (stores[tableName] !== null) {
                            var indexes = _this._parseIndexSyntax(stores[tableName]);
                            var primKey = indexes.shift();
                            if (!primKey) throw new exceptions.Schema("Invalid schema for table " + tableName + ": " + stores[tableName]);
                            primKey.unique = true;
                            if (primKey.multi) throw new exceptions.Schema("Primary key cannot be multiEntry*");
                            indexes.forEach(function(idx) {
                                if (idx.auto) throw new exceptions.Schema("Only primary key can be marked as autoIncrement (++)");
                                if (!idx.keyPath) throw new exceptions.Schema("Index must have a name and cannot be an empty string");
                            });
                            var tblSchema = _this._createTableSchema(tableName, primKey, indexes);
                            outSchema[tableName] = tblSchema;
                        }
                    });
                };
                Version2.prototype.stores = function(stores) {
                    var db = this.db;
                    this._cfg.storesSource = this._cfg.storesSource ? extend2(this._cfg.storesSource, stores) : stores;
                    var versions = db._versions;
                    var storesSpec = {};
                    var dbschema = {};
                    versions.forEach(function(version6) {
                        extend2(storesSpec, version6._cfg.storesSource);
                        dbschema = version6._cfg.dbschema = {};
                        version6._parseStoresSpec(storesSpec, dbschema);
                    });
                    db._dbSchema = dbschema;
                    removeTablesApi(db, [
                        db._allTables,
                        db,
                        db.Transaction.prototype
                    ]);
                    setApiOnPlace(db, [
                        db._allTables,
                        db,
                        db.Transaction.prototype,
                        this._cfg.tables
                    ], keys2(dbschema), dbschema);
                    db._storeNames = keys2(dbschema);
                    return this;
                };
                Version2.prototype.upgrade = function(upgradeFunction) {
                    this._cfg.contentUpgrade = promisableChain(this._cfg.contentUpgrade || nop, upgradeFunction);
                    return this;
                };
                return Version2;
            }();
            function createVersionConstructor(db) {
                return makeClassConstructor(Version.prototype, function Version2(versionNumber) {
                    this.db = db;
                    this._cfg = {
                        version: versionNumber,
                        storesSource: null,
                        dbschema: {},
                        tables: {},
                        contentUpgrade: null
                    };
                });
            }
            var connections = createConnectionsManager();
            function createConnectionsManager() {
                if (typeof FinalizationRegistry !== "undefined" && typeof WeakRef !== "undefined") {
                    var _refs_1 = /* @__PURE__ */ new Set();
                    var _registry_1 = new FinalizationRegistry(function(ref2) {
                        _refs_1.delete(ref2);
                    });
                    var toArray3 = function() {
                        return Array.from(_refs_1).map(function(ref2) {
                            return ref2.deref();
                        }).filter(function(db) {
                            return db !== void 0;
                        });
                    };
                    var add3 = function(db) {
                        var ref2 = new WeakRef(db._novip);
                        _refs_1.add(ref2);
                        _registry_1.register(db._novip, ref2, ref2);
                        if (_refs_1.size > db._options.maxConnections) {
                            var oldestRef = _refs_1.values().next().value;
                            _refs_1.delete(oldestRef);
                            _registry_1.unregister(oldestRef);
                        }
                    };
                    var remove4 = function(db) {
                        if (!db) return;
                        var iterator = _refs_1.values();
                        var result = iterator.next();
                        while(!result.done){
                            var ref2 = result.value;
                            if (ref2.deref() === db._novip) {
                                _refs_1.delete(ref2);
                                _registry_1.unregister(ref2);
                                return;
                            }
                            result = iterator.next();
                        }
                    };
                    return {
                        toArray: toArray3,
                        add: add3,
                        remove: remove4
                    };
                } else {
                    var connections_1 = [];
                    var toArray3 = function() {
                        return connections_1;
                    };
                    var add3 = function(db) {
                        connections_1.push(db._novip);
                    };
                    var remove4 = function(db) {
                        if (!db) return;
                        var index = connections_1.indexOf(db._novip);
                        if (index !== -1) connections_1.splice(index, 1);
                    };
                    return {
                        toArray: toArray3,
                        add: add3,
                        remove: remove4
                    };
                }
            }
            function getDbNamesTable(indexedDB2, IDBKeyRange2) {
                var dbNamesDB = indexedDB2["_dbNamesDB"];
                if (!dbNamesDB) {
                    dbNamesDB = indexedDB2["_dbNamesDB"] = new Dexie$1(DBNAMES_DB, {
                        addons: [],
                        indexedDB: indexedDB2,
                        IDBKeyRange: IDBKeyRange2
                    });
                    dbNamesDB.version(1).stores({
                        dbnames: "name"
                    });
                }
                return dbNamesDB.table("dbnames");
            }
            function hasDatabasesNative(indexedDB2) {
                return indexedDB2 && typeof indexedDB2.databases === "function";
            }
            function getDatabaseNames(_a3) {
                var indexedDB2 = _a3.indexedDB, IDBKeyRange2 = _a3.IDBKeyRange;
                return hasDatabasesNative(indexedDB2) ? Promise.resolve(indexedDB2.databases()).then(function(infos) {
                    return infos.map(function(info) {
                        return info.name;
                    }).filter(function(name) {
                        return name !== DBNAMES_DB;
                    });
                }) : getDbNamesTable(indexedDB2, IDBKeyRange2).toCollection().primaryKeys();
            }
            function _onDatabaseCreated(_a3, name) {
                var indexedDB2 = _a3.indexedDB, IDBKeyRange2 = _a3.IDBKeyRange;
                !hasDatabasesNative(indexedDB2) && name !== DBNAMES_DB && getDbNamesTable(indexedDB2, IDBKeyRange2).put({
                    name: name
                }).catch(nop);
            }
            function _onDatabaseDeleted(_a3, name) {
                var indexedDB2 = _a3.indexedDB, IDBKeyRange2 = _a3.IDBKeyRange;
                !hasDatabasesNative(indexedDB2) && name !== DBNAMES_DB && getDbNamesTable(indexedDB2, IDBKeyRange2).delete(name).catch(nop);
            }
            function vip(fn) {
                return newScope(function() {
                    PSD.letThrough = true;
                    return fn();
                });
            }
            function idbReady() {
                var isSafari = !navigator.userAgentData && /Safari\//.test(navigator.userAgent) && !/Chrom(e|ium)\//.test(navigator.userAgent);
                if (!isSafari || !indexedDB.databases) return Promise.resolve();
                var intervalId;
                return new Promise(function(resolve) {
                    var tryIdb = function() {
                        return indexedDB.databases().finally(resolve);
                    };
                    intervalId = setInterval(tryIdb, 100);
                    tryIdb();
                }).finally(function() {
                    return clearInterval(intervalId);
                });
            }
            var _a2;
            function isEmptyRange(node) {
                return !("from" in node);
            }
            var RangeSet2 = function(fromOrTree, to) {
                if (this) extend2(this, arguments.length ? {
                    d: 1,
                    from: fromOrTree,
                    to: arguments.length > 1 ? to : fromOrTree
                } : {
                    d: 0
                });
                else {
                    var rv = new RangeSet2();
                    if (fromOrTree && "d" in fromOrTree) extend2(rv, fromOrTree);
                    return rv;
                }
            };
            props(RangeSet2.prototype, (_a2 = {
                add: function(rangeSet) {
                    mergeRanges2(this, rangeSet);
                    return this;
                },
                addKey: function(key) {
                    addRange(this, key, key);
                    return this;
                },
                addKeys: function(keys3) {
                    var _this = this;
                    keys3.forEach(function(key) {
                        return addRange(_this, key, key);
                    });
                    return this;
                },
                hasKey: function(key) {
                    var node = getRangeSetIterator(this).next(key).value;
                    return node && cmp2(node.from, key) <= 0 && cmp2(node.to, key) >= 0;
                }
            }, _a2[iteratorSymbol] = function() {
                return getRangeSetIterator(this);
            }, _a2));
            function addRange(target, from2, to) {
                var diff = cmp2(from2, to);
                if (isNaN(diff)) return;
                if (diff > 0) throw RangeError();
                if (isEmptyRange(target)) return extend2(target, {
                    from: from2,
                    to: to,
                    d: 1
                });
                var left = target.l;
                var right = target.r;
                if (cmp2(to, target.from) < 0) {
                    left ? addRange(left, from2, to) : target.l = {
                        from: from2,
                        to: to,
                        d: 1,
                        l: null,
                        r: null
                    };
                    return rebalance(target);
                }
                if (cmp2(from2, target.to) > 0) {
                    right ? addRange(right, from2, to) : target.r = {
                        from: from2,
                        to: to,
                        d: 1,
                        l: null,
                        r: null
                    };
                    return rebalance(target);
                }
                if (cmp2(from2, target.from) < 0) {
                    target.from = from2;
                    target.l = null;
                    target.d = right ? right.d + 1 : 1;
                }
                if (cmp2(to, target.to) > 0) {
                    target.to = to;
                    target.r = null;
                    target.d = target.l ? target.l.d + 1 : 1;
                }
                var rightWasCutOff = !target.r;
                if (left && !target.l) mergeRanges2(target, left);
                if (right && rightWasCutOff) mergeRanges2(target, right);
            }
            function mergeRanges2(target, newSet) {
                function _addRangeSet(target2, _a3) {
                    var from2 = _a3.from, to = _a3.to, l3 = _a3.l, r3 = _a3.r;
                    addRange(target2, from2, to);
                    if (l3) _addRangeSet(target2, l3);
                    if (r3) _addRangeSet(target2, r3);
                }
                if (!isEmptyRange(newSet)) _addRangeSet(target, newSet);
            }
            function rangesOverlap2(rangeSet1, rangeSet2) {
                var i1 = getRangeSetIterator(rangeSet2);
                var nextResult1 = i1.next();
                if (nextResult1.done) return false;
                var a3 = nextResult1.value;
                var i22 = getRangeSetIterator(rangeSet1);
                var nextResult2 = i22.next(a3.from);
                var b3 = nextResult2.value;
                while(!nextResult1.done && !nextResult2.done){
                    if (cmp2(b3.from, a3.to) <= 0 && cmp2(b3.to, a3.from) >= 0) return true;
                    cmp2(a3.from, b3.from) < 0 ? a3 = (nextResult1 = i1.next(b3.from)).value : b3 = (nextResult2 = i22.next(a3.from)).value;
                }
                return false;
            }
            function getRangeSetIterator(node) {
                var state = isEmptyRange(node) ? null : {
                    s: 0,
                    n: node
                };
                return {
                    next: function(key) {
                        var keyProvided = arguments.length > 0;
                        while(state)switch(state.s){
                            case 0:
                                state.s = 1;
                                if (keyProvided) while(state.n.l && cmp2(key, state.n.from) < 0)state = {
                                    up: state,
                                    n: state.n.l,
                                    s: 1
                                };
                                else while(state.n.l)state = {
                                    up: state,
                                    n: state.n.l,
                                    s: 1
                                };
                            case 1:
                                state.s = 2;
                                if (!keyProvided || cmp2(key, state.n.to) <= 0) return {
                                    value: state.n,
                                    done: false
                                };
                            case 2:
                                if (state.n.r) {
                                    state.s = 3;
                                    state = {
                                        up: state,
                                        n: state.n.r,
                                        s: 0
                                    };
                                    continue;
                                }
                            case 3:
                                state = state.up;
                        }
                        return {
                            done: true
                        };
                    }
                };
            }
            function rebalance(target) {
                var _a3, _b;
                var diff = (((_a3 = target.r) === null || _a3 === void 0 ? void 0 : _a3.d) || 0) - (((_b = target.l) === null || _b === void 0 ? void 0 : _b.d) || 0);
                var r3 = diff > 1 ? "r" : diff < -1 ? "l" : "";
                if (r3) {
                    var l3 = r3 === "r" ? "l" : "r";
                    var rootClone = __assign({}, target);
                    var oldRootRight = target[r3];
                    target.from = oldRootRight.from;
                    target.to = oldRootRight.to;
                    target[r3] = oldRootRight[r3];
                    rootClone[r3] = oldRootRight[l3];
                    target[l3] = rootClone;
                    rootClone.d = computeDepth(rootClone);
                }
                target.d = computeDepth(target);
            }
            function computeDepth(_a3) {
                var r3 = _a3.r, l3 = _a3.l;
                return (r3 ? l3 ? Math.max(r3.d, l3.d) : r3.d : l3 ? l3.d : 0) + 1;
            }
            function extendObservabilitySet(target, newSet) {
                keys2(newSet).forEach(function(part) {
                    if (target[part]) mergeRanges2(target[part], newSet[part]);
                    else target[part] = cloneSimpleObjectTree(newSet[part]);
                });
                return target;
            }
            function obsSetsOverlap(os1, os2) {
                return os1.all || os2.all || Object.keys(os1).some(function(key) {
                    return os2[key] && rangesOverlap2(os2[key], os1[key]);
                });
            }
            var cache2 = {};
            var unsignaledParts = {};
            var isTaskEnqueued = false;
            function signalSubscribersLazily(part, optimistic) {
                extendObservabilitySet(unsignaledParts, part);
                if (!isTaskEnqueued) {
                    isTaskEnqueued = true;
                    setTimeout(function() {
                        isTaskEnqueued = false;
                        var parts2 = unsignaledParts;
                        unsignaledParts = {};
                        signalSubscribersNow(parts2, false);
                    }, 0);
                }
            }
            function signalSubscribersNow(updatedParts, deleteAffectedCacheEntries) {
                if (deleteAffectedCacheEntries === void 0) deleteAffectedCacheEntries = false;
                var queriesToSignal = /* @__PURE__ */ new Set();
                if (updatedParts.all) for(var _i = 0, _a3 = Object.values(cache2); _i < _a3.length; _i++){
                    var tblCache = _a3[_i];
                    collectTableSubscribers(tblCache, updatedParts, queriesToSignal, deleteAffectedCacheEntries);
                }
                else for(var key in updatedParts){
                    var parts2 = /^idb\:\/\/(.*)\/(.*)\//.exec(key);
                    if (parts2) {
                        var dbName = parts2[1], tableName = parts2[2];
                        var tblCache = cache2["idb://".concat(dbName, "/").concat(tableName)];
                        if (tblCache) collectTableSubscribers(tblCache, updatedParts, queriesToSignal, deleteAffectedCacheEntries);
                    }
                }
                queriesToSignal.forEach(function(requery) {
                    return requery();
                });
            }
            function collectTableSubscribers(tblCache, updatedParts, outQueriesToSignal, deleteAffectedCacheEntries) {
                var updatedEntryLists = [];
                for(var _i = 0, _a3 = Object.entries(tblCache.queries.query); _i < _a3.length; _i++){
                    var _b = _a3[_i], indexName = _b[0], entries = _b[1];
                    var filteredEntries = [];
                    for(var _c = 0, entries_1 = entries; _c < entries_1.length; _c++){
                        var entry = entries_1[_c];
                        if (obsSetsOverlap(updatedParts, entry.obsSet)) entry.subscribers.forEach(function(requery) {
                            return outQueriesToSignal.add(requery);
                        });
                        else if (deleteAffectedCacheEntries) filteredEntries.push(entry);
                    }
                    if (deleteAffectedCacheEntries) updatedEntryLists.push([
                        indexName,
                        filteredEntries
                    ]);
                }
                if (deleteAffectedCacheEntries) for(var _d = 0, updatedEntryLists_1 = updatedEntryLists; _d < updatedEntryLists_1.length; _d++){
                    var _e = updatedEntryLists_1[_d], indexName = _e[0], filteredEntries = _e[1];
                    tblCache.queries.query[indexName] = filteredEntries;
                }
            }
            function dexieOpen(db) {
                var state = db._state;
                var indexedDB2 = db._deps.indexedDB;
                if (state.isBeingOpened || db.idbdb) return state.dbReadyPromise.then(function() {
                    return state.dbOpenError ? rejection(state.dbOpenError) : db;
                });
                state.isBeingOpened = true;
                state.dbOpenError = null;
                state.openComplete = false;
                var openCanceller = state.openCanceller;
                var nativeVerToOpen = Math.round(db.verno * 10);
                var schemaPatchMode = false;
                function throwIfCancelled() {
                    if (state.openCanceller !== openCanceller) throw new exceptions.DatabaseClosed("db.open() was cancelled");
                }
                var resolveDbReady = state.dbReadyResolve, upgradeTransaction = null, wasCreated = false;
                var tryOpenDB = function() {
                    return new DexiePromise(function(resolve, reject) {
                        throwIfCancelled();
                        if (!indexedDB2) throw new exceptions.MissingAPI();
                        var dbName = db.name;
                        var req = state.autoSchema || !nativeVerToOpen ? indexedDB2.open(dbName) : indexedDB2.open(dbName, nativeVerToOpen);
                        if (!req) throw new exceptions.MissingAPI();
                        req.onerror = eventRejectHandler(reject);
                        req.onblocked = wrap2(db._fireOnBlocked);
                        req.onupgradeneeded = wrap2(function(e4) {
                            upgradeTransaction = req.transaction;
                            if (state.autoSchema && !db._options.allowEmptyDB) {
                                req.onerror = preventDefault;
                                upgradeTransaction.abort();
                                req.result.close();
                                var delreq = indexedDB2.deleteDatabase(dbName);
                                delreq.onsuccess = delreq.onerror = wrap2(function() {
                                    reject(new exceptions.NoSuchDatabase("Database ".concat(dbName, " doesnt exist")));
                                });
                            } else {
                                upgradeTransaction.onerror = eventRejectHandler(reject);
                                var oldVer = e4.oldVersion > Math.pow(2, 62) ? 0 : e4.oldVersion;
                                wasCreated = oldVer < 1;
                                db.idbdb = req.result;
                                if (schemaPatchMode) patchCurrentVersion(db, upgradeTransaction);
                                runUpgraders(db, oldVer / 10, upgradeTransaction, reject);
                            }
                        }, reject);
                        req.onsuccess = wrap2(function() {
                            upgradeTransaction = null;
                            var idbdb = db.idbdb = req.result;
                            var objectStoreNames = slice(idbdb.objectStoreNames);
                            if (objectStoreNames.length > 0) try {
                                var tmpTrans = idbdb.transaction(safariMultiStoreFix(objectStoreNames), "readonly");
                                if (state.autoSchema) readGlobalSchema(db, idbdb, tmpTrans);
                                else {
                                    adjustToExistingIndexNames(db, db._dbSchema, tmpTrans);
                                    if (!verifyInstalledSchema(db, tmpTrans) && !schemaPatchMode) {
                                        console.warn("Dexie SchemaDiff: Schema was extended without increasing the number passed to db.version(). Dexie will add missing parts and increment native version number to workaround this.");
                                        idbdb.close();
                                        nativeVerToOpen = idbdb.version + 1;
                                        schemaPatchMode = true;
                                        return resolve(tryOpenDB());
                                    }
                                }
                                generateMiddlewareStacks(db, tmpTrans);
                            } catch (e4) {}
                            connections.add(db);
                            idbdb.onversionchange = wrap2(function(ev) {
                                state.vcFired = true;
                                db.on("versionchange").fire(ev);
                            });
                            idbdb.onclose = wrap2(function() {
                                db.close({
                                    disableAutoOpen: false
                                });
                            });
                            if (wasCreated) _onDatabaseCreated(db._deps, dbName);
                            resolve();
                        }, reject);
                    }).catch(function(err) {
                        switch(err === null || err === void 0 ? void 0 : err.name){
                            case "UnknownError":
                                if (state.PR1398_maxLoop > 0) {
                                    state.PR1398_maxLoop--;
                                    console.warn("Dexie: Workaround for Chrome UnknownError on open()");
                                    return tryOpenDB();
                                }
                                break;
                            case "VersionError":
                                if (nativeVerToOpen > 0) {
                                    nativeVerToOpen = 0;
                                    return tryOpenDB();
                                }
                                break;
                        }
                        return DexiePromise.reject(err);
                    });
                };
                return DexiePromise.race([
                    openCanceller,
                    (typeof navigator === "undefined" ? DexiePromise.resolve() : idbReady()).then(tryOpenDB)
                ]).then(function() {
                    throwIfCancelled();
                    state.onReadyBeingFired = [];
                    return DexiePromise.resolve(vip(function() {
                        return db.on.ready.fire(db.vip);
                    })).then(function fireRemainders() {
                        if (state.onReadyBeingFired.length > 0) {
                            var remainders_1 = state.onReadyBeingFired.reduce(promisableChain, nop);
                            state.onReadyBeingFired = [];
                            return DexiePromise.resolve(vip(function() {
                                return remainders_1(db.vip);
                            })).then(fireRemainders);
                        }
                    });
                }).finally(function() {
                    if (state.openCanceller === openCanceller) {
                        state.onReadyBeingFired = null;
                        state.isBeingOpened = false;
                    }
                }).catch(function(err) {
                    state.dbOpenError = err;
                    try {
                        upgradeTransaction && upgradeTransaction.abort();
                    } catch (_a3) {}
                    if (openCanceller === state.openCanceller) db._close();
                    return rejection(err);
                }).finally(function() {
                    state.openComplete = true;
                    resolveDbReady();
                }).then(function() {
                    if (wasCreated) {
                        var everything_1 = {};
                        db.tables.forEach(function(table) {
                            table.schema.indexes.forEach(function(idx) {
                                if (idx.name) everything_1["idb://".concat(db.name, "/").concat(table.name, "/").concat(idx.name)] = new RangeSet2(-Infinity, [
                                    [
                                        []
                                    ]
                                ]);
                            });
                            everything_1["idb://".concat(db.name, "/").concat(table.name, "/")] = everything_1["idb://".concat(db.name, "/").concat(table.name, "/:dels")] = new RangeSet2(-Infinity, [
                                [
                                    []
                                ]
                            ]);
                        });
                        globalEvents(DEXIE_STORAGE_MUTATED_EVENT_NAME).fire(everything_1);
                        signalSubscribersNow(everything_1, true);
                    }
                    return db;
                });
            }
            function awaitIterator(iterator) {
                var callNext = function(result) {
                    return iterator.next(result);
                }, doThrow = function(error) {
                    return iterator.throw(error);
                }, onSuccess = step(callNext), onError = step(doThrow);
                function step(getNext) {
                    return function(val) {
                        var next = getNext(val), value2 = next.value;
                        return next.done ? value2 : !value2 || typeof value2.then !== "function" ? isArray5(value2) ? Promise.all(value2).then(onSuccess, onError) : onSuccess(value2) : value2.then(onSuccess, onError);
                    };
                }
                return step(callNext)();
            }
            function extractTransactionArgs(mode, _tableArgs_, scopeFunc) {
                var i3 = arguments.length;
                if (i3 < 2) throw new exceptions.InvalidArgument("Too few arguments");
                var args2 = new Array(i3 - 1);
                while(--i3)args2[i3 - 1] = arguments[i3];
                scopeFunc = args2.pop();
                var tables = flatten(args2);
                return [
                    mode,
                    tables,
                    scopeFunc
                ];
            }
            function enterTransactionScope(db, mode, storeNames, parentTransaction, scopeFunc) {
                return DexiePromise.resolve().then(function() {
                    var transless = PSD.transless || PSD;
                    var trans = db._createTransaction(mode, storeNames, db._dbSchema, parentTransaction);
                    trans.explicit = true;
                    var zoneProps = {
                        trans: trans,
                        transless: transless
                    };
                    if (parentTransaction) trans.idbtrans = parentTransaction.idbtrans;
                    else try {
                        trans.create();
                        trans.idbtrans._explicit = true;
                        db._state.PR1398_maxLoop = 3;
                    } catch (ex) {
                        if (ex.name === errnames.InvalidState && db.isOpen() && --db._state.PR1398_maxLoop > 0) {
                            console.warn("Dexie: Need to reopen db");
                            db.close({
                                disableAutoOpen: false
                            });
                            return db.open().then(function() {
                                return enterTransactionScope(db, mode, storeNames, null, scopeFunc);
                            });
                        }
                        return rejection(ex);
                    }
                    var scopeFuncIsAsync = isAsyncFunction(scopeFunc);
                    if (scopeFuncIsAsync) incrementExpectedAwaits();
                    var returnValue;
                    var promiseFollowed = DexiePromise.follow(function() {
                        returnValue = scopeFunc.call(trans, trans);
                        if (returnValue) {
                            if (scopeFuncIsAsync) {
                                var decrementor = decrementExpectedAwaits.bind(null, null);
                                returnValue.then(decrementor, decrementor);
                            } else if (typeof returnValue.next === "function" && typeof returnValue.throw === "function") returnValue = awaitIterator(returnValue);
                        }
                    }, zoneProps);
                    return (returnValue && typeof returnValue.then === "function" ? DexiePromise.resolve(returnValue).then(function(x3) {
                        return trans.active ? x3 : rejection(new exceptions.PrematureCommit("Transaction committed too early. See http://bit.ly/2kdckMn"));
                    }) : promiseFollowed.then(function() {
                        return returnValue;
                    })).then(function(x3) {
                        if (parentTransaction) trans._resolve();
                        return trans._completion.then(function() {
                            return x3;
                        });
                    }).catch(function(e4) {
                        trans._reject(e4);
                        return rejection(e4);
                    });
                });
            }
            function pad(a3, value2, count2) {
                var result = isArray5(a3) ? a3.slice() : [
                    a3
                ];
                for(var i3 = 0; i3 < count2; ++i3)result.push(value2);
                return result;
            }
            function createVirtualIndexMiddleware(down) {
                return __assign(__assign({}, down), {
                    table: function(tableName) {
                        var table = down.table(tableName);
                        var schema = table.schema;
                        var indexLookup = {};
                        var allVirtualIndexes = [];
                        function addVirtualIndexes(keyPath, keyTail, lowLevelIndex) {
                            var keyPathAlias = getKeyPathAlias(keyPath);
                            var indexList = indexLookup[keyPathAlias] = indexLookup[keyPathAlias] || [];
                            var keyLength = keyPath == null ? 0 : typeof keyPath === "string" ? 1 : keyPath.length;
                            var isVirtual = keyTail > 0;
                            var virtualIndex = __assign(__assign({}, lowLevelIndex), {
                                name: isVirtual ? "".concat(keyPathAlias, "(virtual-from:").concat(lowLevelIndex.name, ")") : lowLevelIndex.name,
                                lowLevelIndex: lowLevelIndex,
                                isVirtual: isVirtual,
                                keyTail: keyTail,
                                keyLength: keyLength,
                                extractKey: getKeyExtractor(keyPath),
                                unique: !isVirtual && lowLevelIndex.unique
                            });
                            indexList.push(virtualIndex);
                            if (!virtualIndex.isPrimaryKey) allVirtualIndexes.push(virtualIndex);
                            if (keyLength > 1) {
                                var virtualKeyPath = keyLength === 2 ? keyPath[0] : keyPath.slice(0, keyLength - 1);
                                addVirtualIndexes(virtualKeyPath, keyTail + 1, lowLevelIndex);
                            }
                            indexList.sort(function(a3, b3) {
                                return a3.keyTail - b3.keyTail;
                            });
                            return virtualIndex;
                        }
                        var primaryKey = addVirtualIndexes(schema.primaryKey.keyPath, 0, schema.primaryKey);
                        indexLookup[":id"] = [
                            primaryKey
                        ];
                        for(var _i = 0, _a3 = schema.indexes; _i < _a3.length; _i++){
                            var index = _a3[_i];
                            addVirtualIndexes(index.keyPath, 0, index);
                        }
                        function findBestIndex(keyPath) {
                            var result2 = indexLookup[getKeyPathAlias(keyPath)];
                            return result2 && result2[0];
                        }
                        function translateRange(range, keyTail) {
                            return {
                                type: range.type === 1 ? 2 : range.type,
                                lower: pad(range.lower, range.lowerOpen ? down.MAX_KEY : down.MIN_KEY, keyTail),
                                lowerOpen: true,
                                upper: pad(range.upper, range.upperOpen ? down.MIN_KEY : down.MAX_KEY, keyTail),
                                upperOpen: true
                            };
                        }
                        function translateRequest(req) {
                            var index2 = req.query.index;
                            return index2.isVirtual ? __assign(__assign({}, req), {
                                query: {
                                    index: index2.lowLevelIndex,
                                    range: translateRange(req.query.range, index2.keyTail)
                                }
                            }) : req;
                        }
                        var result = __assign(__assign({}, table), {
                            schema: __assign(__assign({}, schema), {
                                primaryKey: primaryKey,
                                indexes: allVirtualIndexes,
                                getIndexByKeyPath: findBestIndex
                            }),
                            count: function(req) {
                                return table.count(translateRequest(req));
                            },
                            query: function(req) {
                                return table.query(translateRequest(req));
                            },
                            openCursor: function(req) {
                                var _a4 = req.query.index, keyTail = _a4.keyTail, isVirtual = _a4.isVirtual, keyLength = _a4.keyLength;
                                if (!isVirtual) return table.openCursor(req);
                                function createVirtualCursor(cursor) {
                                    function _continue(key) {
                                        key != null ? cursor.continue(pad(key, req.reverse ? down.MAX_KEY : down.MIN_KEY, keyTail)) : req.unique ? cursor.continue(cursor.key.slice(0, keyLength).concat(req.reverse ? down.MIN_KEY : down.MAX_KEY, keyTail)) : cursor.continue();
                                    }
                                    var virtualCursor = Object.create(cursor, {
                                        continue: {
                                            value: _continue
                                        },
                                        continuePrimaryKey: {
                                            value: function(key, primaryKey2) {
                                                cursor.continuePrimaryKey(pad(key, down.MAX_KEY, keyTail), primaryKey2);
                                            }
                                        },
                                        primaryKey: {
                                            get: function() {
                                                return cursor.primaryKey;
                                            }
                                        },
                                        key: {
                                            get: function() {
                                                var key = cursor.key;
                                                return keyLength === 1 ? key[0] : key.slice(0, keyLength);
                                            }
                                        },
                                        value: {
                                            get: function() {
                                                return cursor.value;
                                            }
                                        }
                                    });
                                    return virtualCursor;
                                }
                                return table.openCursor(translateRequest(req)).then(function(cursor) {
                                    return cursor && createVirtualCursor(cursor);
                                });
                            }
                        });
                        return result;
                    }
                });
            }
            var virtualIndexMiddleware = {
                stack: "dbcore",
                name: "VirtualIndexMiddleware",
                level: 1,
                create: createVirtualIndexMiddleware
            };
            function getObjectDiff(a3, b3, rv, prfx) {
                rv = rv || {};
                prfx = prfx || "";
                keys2(a3).forEach(function(prop) {
                    if (!hasOwn2(b3, prop)) rv[prfx + prop] = void 0;
                    else {
                        var ap = a3[prop], bp = b3[prop];
                        if (typeof ap === "object" && typeof bp === "object" && ap && bp) {
                            var apTypeName = toStringTag(ap);
                            var bpTypeName = toStringTag(bp);
                            if (apTypeName !== bpTypeName) rv[prfx + prop] = b3[prop];
                            else if (apTypeName === "Object") getObjectDiff(ap, bp, rv, prfx + prop + ".");
                            else if (ap !== bp) rv[prfx + prop] = b3[prop];
                        } else if (ap !== bp) rv[prfx + prop] = b3[prop];
                    }
                });
                keys2(b3).forEach(function(prop) {
                    if (!hasOwn2(a3, prop)) rv[prfx + prop] = b3[prop];
                });
                return rv;
            }
            function getEffectiveKeys(primaryKey, req) {
                if (req.type === "delete") return req.keys;
                return req.keys || req.values.map(primaryKey.extractKey);
            }
            var hooksMiddleware = {
                stack: "dbcore",
                name: "HooksMiddleware",
                level: 2,
                create: function(downCore) {
                    return __assign(__assign({}, downCore), {
                        table: function(tableName) {
                            var downTable = downCore.table(tableName);
                            var primaryKey = downTable.schema.primaryKey;
                            var tableMiddleware = __assign(__assign({}, downTable), {
                                mutate: function(req) {
                                    var dxTrans = PSD.trans;
                                    var _a3 = dxTrans.table(tableName).hook, deleting = _a3.deleting, creating = _a3.creating, updating = _a3.updating;
                                    switch(req.type){
                                        case "add":
                                            if (creating.fire === nop) break;
                                            return dxTrans._promise("readwrite", function() {
                                                return addPutOrDelete(req);
                                            }, true);
                                        case "put":
                                            if (creating.fire === nop && updating.fire === nop) break;
                                            return dxTrans._promise("readwrite", function() {
                                                return addPutOrDelete(req);
                                            }, true);
                                        case "delete":
                                            if (deleting.fire === nop) break;
                                            return dxTrans._promise("readwrite", function() {
                                                return addPutOrDelete(req);
                                            }, true);
                                        case "deleteRange":
                                            if (deleting.fire === nop) break;
                                            return dxTrans._promise("readwrite", function() {
                                                return deleteRange(req);
                                            }, true);
                                    }
                                    return downTable.mutate(req);
                                    function addPutOrDelete(req2) {
                                        var dxTrans2 = PSD.trans;
                                        var keys3 = req2.keys || getEffectiveKeys(primaryKey, req2);
                                        if (!keys3) throw new Error("Keys missing");
                                        req2 = req2.type === "add" || req2.type === "put" ? __assign(__assign({}, req2), {
                                            keys: keys3
                                        }) : __assign({}, req2);
                                        if (req2.type !== "delete") req2.values = __spreadArray([], req2.values, true);
                                        if (req2.keys) req2.keys = __spreadArray([], req2.keys, true);
                                        return getExistingValues(downTable, req2, keys3).then(function(existingValues) {
                                            var contexts = keys3.map(function(key, i3) {
                                                var existingValue = existingValues[i3];
                                                var ctx = {
                                                    onerror: null,
                                                    onsuccess: null
                                                };
                                                if (req2.type === "delete") deleting.fire.call(ctx, key, existingValue, dxTrans2);
                                                else if (req2.type === "add" || existingValue === void 0) {
                                                    var generatedPrimaryKey = creating.fire.call(ctx, key, req2.values[i3], dxTrans2);
                                                    if (key == null && generatedPrimaryKey != null) {
                                                        key = generatedPrimaryKey;
                                                        req2.keys[i3] = key;
                                                        if (!primaryKey.outbound) setByKeyPath(req2.values[i3], primaryKey.keyPath, key);
                                                    }
                                                } else {
                                                    var objectDiff = getObjectDiff(existingValue, req2.values[i3]);
                                                    var additionalChanges_1 = updating.fire.call(ctx, objectDiff, key, existingValue, dxTrans2);
                                                    if (additionalChanges_1) {
                                                        var requestedValue_1 = req2.values[i3];
                                                        Object.keys(additionalChanges_1).forEach(function(keyPath) {
                                                            if (hasOwn2(requestedValue_1, keyPath)) requestedValue_1[keyPath] = additionalChanges_1[keyPath];
                                                            else setByKeyPath(requestedValue_1, keyPath, additionalChanges_1[keyPath]);
                                                        });
                                                    }
                                                }
                                                return ctx;
                                            });
                                            return downTable.mutate(req2).then(function(_a4) {
                                                var failures = _a4.failures, results = _a4.results, numFailures = _a4.numFailures, lastResult = _a4.lastResult;
                                                for(var i3 = 0; i3 < keys3.length; ++i3){
                                                    var primKey = results ? results[i3] : keys3[i3];
                                                    var ctx = contexts[i3];
                                                    if (primKey == null) ctx.onerror && ctx.onerror(failures[i3]);
                                                    else ctx.onsuccess && ctx.onsuccess(req2.type === "put" && existingValues[i3] ? req2.values[i3] : primKey);
                                                }
                                                return {
                                                    failures: failures,
                                                    results: results,
                                                    numFailures: numFailures,
                                                    lastResult: lastResult
                                                };
                                            }).catch(function(error) {
                                                contexts.forEach(function(ctx) {
                                                    return ctx.onerror && ctx.onerror(error);
                                                });
                                                return Promise.reject(error);
                                            });
                                        });
                                    }
                                    function deleteRange(req2) {
                                        return deleteNextChunk(req2.trans, req2.range, 1e4);
                                    }
                                    function deleteNextChunk(trans, range, limit) {
                                        return downTable.query({
                                            trans: trans,
                                            values: false,
                                            query: {
                                                index: primaryKey,
                                                range: range
                                            },
                                            limit: limit
                                        }).then(function(_a4) {
                                            var result = _a4.result;
                                            return addPutOrDelete({
                                                type: "delete",
                                                keys: result,
                                                trans: trans
                                            }).then(function(res) {
                                                if (res.numFailures > 0) return Promise.reject(res.failures[0]);
                                                if (result.length < limit) return {
                                                    failures: [],
                                                    numFailures: 0,
                                                    lastResult: void 0
                                                };
                                                else return deleteNextChunk(trans, __assign(__assign({}, range), {
                                                    lower: result[result.length - 1],
                                                    lowerOpen: true
                                                }), limit);
                                            });
                                        });
                                    }
                                }
                            });
                            return tableMiddleware;
                        }
                    });
                }
            };
            function getExistingValues(table, req, effectiveKeys) {
                return req.type === "add" ? Promise.resolve([]) : table.getMany({
                    trans: req.trans,
                    keys: effectiveKeys,
                    cache: "immutable"
                });
            }
            function getFromTransactionCache(keys3, cache3, clone) {
                try {
                    if (!cache3) return null;
                    if (cache3.keys.length < keys3.length) return null;
                    var result = [];
                    for(var i3 = 0, j3 = 0; i3 < cache3.keys.length && j3 < keys3.length; ++i3){
                        if (cmp2(cache3.keys[i3], keys3[j3]) !== 0) continue;
                        result.push(clone ? deepClone2(cache3.values[i3]) : cache3.values[i3]);
                        ++j3;
                    }
                    return result.length === keys3.length ? result : null;
                } catch (_a3) {
                    return null;
                }
            }
            var cacheExistingValuesMiddleware = {
                stack: "dbcore",
                level: -1,
                create: function(core) {
                    return {
                        table: function(tableName) {
                            var table = core.table(tableName);
                            return __assign(__assign({}, table), {
                                getMany: function(req) {
                                    if (!req.cache) return table.getMany(req);
                                    var cachedResult = getFromTransactionCache(req.keys, req.trans["_cache"], req.cache === "clone");
                                    if (cachedResult) return DexiePromise.resolve(cachedResult);
                                    return table.getMany(req).then(function(res) {
                                        req.trans["_cache"] = {
                                            keys: req.keys,
                                            values: req.cache === "clone" ? deepClone2(res) : res
                                        };
                                        return res;
                                    });
                                },
                                mutate: function(req) {
                                    if (req.type !== "add") req.trans["_cache"] = null;
                                    return table.mutate(req);
                                }
                            });
                        }
                    };
                }
            };
            function isCachableContext(ctx, table) {
                return ctx.trans.mode === "readonly" && !!ctx.subscr && !ctx.trans.explicit && ctx.trans.db._options.cache !== "disabled" && !table.schema.primaryKey.outbound;
            }
            function isCachableRequest(type2, req) {
                switch(type2){
                    case "query":
                        return req.values && !req.unique;
                    case "get":
                        return false;
                    case "getMany":
                        return false;
                    case "count":
                        return false;
                    case "openCursor":
                        return false;
                }
            }
            var observabilityMiddleware = {
                stack: "dbcore",
                level: 0,
                name: "Observability",
                create: function(core) {
                    var dbName = core.schema.name;
                    var FULL_RANGE = new RangeSet2(core.MIN_KEY, core.MAX_KEY);
                    return __assign(__assign({}, core), {
                        transaction: function(stores, mode, options) {
                            if (PSD.subscr && mode !== "readonly") throw new exceptions.ReadOnly("Readwrite transaction in liveQuery context. Querier source: ".concat(PSD.querier));
                            return core.transaction(stores, mode, options);
                        },
                        table: function(tableName) {
                            var table = core.table(tableName);
                            var schema = table.schema;
                            var primaryKey = schema.primaryKey, indexes = schema.indexes;
                            var extractKey = primaryKey.extractKey, outbound = primaryKey.outbound;
                            var indexesWithAutoIncPK = primaryKey.autoIncrement && indexes.filter(function(index) {
                                return index.compound && index.keyPath.includes(primaryKey.keyPath);
                            });
                            var tableClone = __assign(__assign({}, table), {
                                mutate: function(req) {
                                    var _a3, _b;
                                    var trans = req.trans;
                                    var mutatedParts = req.mutatedParts || (req.mutatedParts = {});
                                    var getRangeSet = function(indexName) {
                                        var part = "idb://".concat(dbName, "/").concat(tableName, "/").concat(indexName);
                                        return mutatedParts[part] || (mutatedParts[part] = new RangeSet2());
                                    };
                                    var pkRangeSet = getRangeSet("");
                                    var delsRangeSet = getRangeSet(":dels");
                                    var type2 = req.type;
                                    var _c = req.type === "deleteRange" ? [
                                        req.range
                                    ] : req.type === "delete" ? [
                                        req.keys
                                    ] : req.values.length < 50 ? [
                                        getEffectiveKeys(primaryKey, req).filter(function(id2) {
                                            return id2;
                                        }),
                                        req.values
                                    ] : [], keys3 = _c[0], newObjs = _c[1];
                                    var oldCache = req.trans["_cache"];
                                    if (isArray5(keys3)) {
                                        pkRangeSet.addKeys(keys3);
                                        var oldObjs = type2 === "delete" || keys3.length === newObjs.length ? getFromTransactionCache(keys3, oldCache) : null;
                                        if (!oldObjs) delsRangeSet.addKeys(keys3);
                                        if (oldObjs || newObjs) trackAffectedIndexes(getRangeSet, schema, oldObjs, newObjs);
                                    } else if (keys3) {
                                        var range = {
                                            from: (_a3 = keys3.lower) !== null && _a3 !== void 0 ? _a3 : core.MIN_KEY,
                                            to: (_b = keys3.upper) !== null && _b !== void 0 ? _b : core.MAX_KEY
                                        };
                                        delsRangeSet.add(range);
                                        pkRangeSet.add(range);
                                    } else {
                                        pkRangeSet.add(FULL_RANGE);
                                        delsRangeSet.add(FULL_RANGE);
                                        schema.indexes.forEach(function(idx) {
                                            return getRangeSet(idx.name).add(FULL_RANGE);
                                        });
                                    }
                                    return table.mutate(req).then(function(res) {
                                        if (keys3 && (req.type === "add" || req.type === "put")) {
                                            pkRangeSet.addKeys(res.results);
                                            if (indexesWithAutoIncPK) indexesWithAutoIncPK.forEach(function(idx) {
                                                var idxVals = req.values.map(function(v3) {
                                                    return idx.extractKey(v3);
                                                });
                                                var pkPos = idx.keyPath.findIndex(function(prop) {
                                                    return prop === primaryKey.keyPath;
                                                });
                                                for(var i3 = 0, len = res.results.length; i3 < len; ++i3)idxVals[i3][pkPos] = res.results[i3];
                                                getRangeSet(idx.name).addKeys(idxVals);
                                            });
                                        }
                                        trans.mutatedParts = extendObservabilitySet(trans.mutatedParts || {}, mutatedParts);
                                        return res;
                                    });
                                }
                            });
                            var getRange = function(_a3) {
                                var _b, _c;
                                var _d = _a3.query, index = _d.index, range = _d.range;
                                return [
                                    index,
                                    new RangeSet2((_b = range.lower) !== null && _b !== void 0 ? _b : core.MIN_KEY, (_c = range.upper) !== null && _c !== void 0 ? _c : core.MAX_KEY)
                                ];
                            };
                            var readSubscribers = {
                                get: function(req) {
                                    return [
                                        primaryKey,
                                        new RangeSet2(req.key)
                                    ];
                                },
                                getMany: function(req) {
                                    return [
                                        primaryKey,
                                        new RangeSet2().addKeys(req.keys)
                                    ];
                                },
                                count: getRange,
                                query: getRange,
                                openCursor: getRange
                            };
                            keys2(readSubscribers).forEach(function(method) {
                                tableClone[method] = function(req) {
                                    var subscr = PSD.subscr;
                                    var isLiveQuery = !!subscr;
                                    var cachable = isCachableContext(PSD, table) && isCachableRequest(method, req);
                                    var obsSet = cachable ? req.obsSet = {} : subscr;
                                    if (isLiveQuery) {
                                        var getRangeSet = function(indexName) {
                                            var part = "idb://".concat(dbName, "/").concat(tableName, "/").concat(indexName);
                                            return obsSet[part] || (obsSet[part] = new RangeSet2());
                                        };
                                        var pkRangeSet_1 = getRangeSet("");
                                        var delsRangeSet_1 = getRangeSet(":dels");
                                        var _a3 = readSubscribers[method](req), queriedIndex = _a3[0], queriedRanges = _a3[1];
                                        if (method === "query" && queriedIndex.isPrimaryKey && !req.values) delsRangeSet_1.add(queriedRanges);
                                        else getRangeSet(queriedIndex.name || "").add(queriedRanges);
                                        if (!queriedIndex.isPrimaryKey) {
                                            if (method === "count") delsRangeSet_1.add(FULL_RANGE);
                                            else {
                                                var keysPromise_1 = method === "query" && outbound && req.values && table.query(__assign(__assign({}, req), {
                                                    values: false
                                                }));
                                                return table[method].apply(this, arguments).then(function(res) {
                                                    if (method === "query") {
                                                        if (outbound && req.values) return keysPromise_1.then(function(_a4) {
                                                            var resultingKeys = _a4.result;
                                                            pkRangeSet_1.addKeys(resultingKeys);
                                                            return res;
                                                        });
                                                        var pKeys = req.values ? res.result.map(extractKey) : res.result;
                                                        if (req.values) pkRangeSet_1.addKeys(pKeys);
                                                        else delsRangeSet_1.addKeys(pKeys);
                                                    } else if (method === "openCursor") {
                                                        var cursor_1 = res;
                                                        var wantValues_1 = req.values;
                                                        return cursor_1 && Object.create(cursor_1, {
                                                            key: {
                                                                get: function() {
                                                                    delsRangeSet_1.addKey(cursor_1.primaryKey);
                                                                    return cursor_1.key;
                                                                }
                                                            },
                                                            primaryKey: {
                                                                get: function() {
                                                                    var pkey = cursor_1.primaryKey;
                                                                    delsRangeSet_1.addKey(pkey);
                                                                    return pkey;
                                                                }
                                                            },
                                                            value: {
                                                                get: function() {
                                                                    wantValues_1 && pkRangeSet_1.addKey(cursor_1.primaryKey);
                                                                    return cursor_1.value;
                                                                }
                                                            }
                                                        });
                                                    }
                                                    return res;
                                                });
                                            }
                                        }
                                    }
                                    return table[method].apply(this, arguments);
                                };
                            });
                            return tableClone;
                        }
                    });
                }
            };
            function trackAffectedIndexes(getRangeSet, schema, oldObjs, newObjs) {
                function addAffectedIndex(ix) {
                    var rangeSet = getRangeSet(ix.name || "");
                    function extractKey(obj) {
                        return obj != null ? ix.extractKey(obj) : null;
                    }
                    var addKeyOrKeys = function(key) {
                        return ix.multiEntry && isArray5(key) ? key.forEach(function(key2) {
                            return rangeSet.addKey(key2);
                        }) : rangeSet.addKey(key);
                    };
                    (oldObjs || newObjs).forEach(function(_3, i3) {
                        var oldKey = oldObjs && extractKey(oldObjs[i3]);
                        var newKey = newObjs && extractKey(newObjs[i3]);
                        if (cmp2(oldKey, newKey) !== 0) {
                            if (oldKey != null) addKeyOrKeys(oldKey);
                            if (newKey != null) addKeyOrKeys(newKey);
                        }
                    });
                }
                schema.indexes.forEach(addAffectedIndex);
            }
            function adjustOptimisticFromFailures(tblCache, req, res) {
                if (res.numFailures === 0) return req;
                if (req.type === "deleteRange") return null;
                var numBulkOps = req.keys ? req.keys.length : "values" in req && req.values ? req.values.length : 1;
                if (res.numFailures === numBulkOps) return null;
                var clone = __assign({}, req);
                if (isArray5(clone.keys)) clone.keys = clone.keys.filter(function(_3, i3) {
                    return !(i3 in res.failures);
                });
                if ("values" in clone && isArray5(clone.values)) clone.values = clone.values.filter(function(_3, i3) {
                    return !(i3 in res.failures);
                });
                return clone;
            }
            function isAboveLower(key, range) {
                return range.lower === void 0 ? true : range.lowerOpen ? cmp2(key, range.lower) > 0 : cmp2(key, range.lower) >= 0;
            }
            function isBelowUpper(key, range) {
                return range.upper === void 0 ? true : range.upperOpen ? cmp2(key, range.upper) < 0 : cmp2(key, range.upper) <= 0;
            }
            function isWithinRange(key, range) {
                return isAboveLower(key, range) && isBelowUpper(key, range);
            }
            function applyOptimisticOps(result, req, ops, table, cacheEntry, immutable) {
                if (!ops || ops.length === 0) return result;
                var index = req.query.index;
                var multiEntry = index.multiEntry;
                var queryRange = req.query.range;
                var primaryKey = table.schema.primaryKey;
                var extractPrimKey = primaryKey.extractKey;
                var extractIndex = index.extractKey;
                var extractLowLevelIndex = (index.lowLevelIndex || index).extractKey;
                var finalResult = ops.reduce(function(result2, op) {
                    var modifedResult = result2;
                    var includedValues = [];
                    if (op.type === "add" || op.type === "put") {
                        var includedPKs = new RangeSet2();
                        for(var i3 = op.values.length - 1; i3 >= 0; --i3){
                            var value2 = op.values[i3];
                            var pk = extractPrimKey(value2);
                            if (includedPKs.hasKey(pk)) continue;
                            var key = extractIndex(value2);
                            if (multiEntry && isArray5(key) ? key.some(function(k3) {
                                return isWithinRange(k3, queryRange);
                            }) : isWithinRange(key, queryRange)) {
                                includedPKs.addKey(pk);
                                includedValues.push(value2);
                            }
                        }
                    }
                    switch(op.type){
                        case "add":
                            var existingKeys_1 = new RangeSet2().addKeys(req.values ? result2.map(function(v3) {
                                return extractPrimKey(v3);
                            }) : result2);
                            modifedResult = result2.concat(req.values ? includedValues.filter(function(v3) {
                                var key2 = extractPrimKey(v3);
                                if (existingKeys_1.hasKey(key2)) return false;
                                existingKeys_1.addKey(key2);
                                return true;
                            }) : includedValues.map(function(v3) {
                                return extractPrimKey(v3);
                            }).filter(function(k3) {
                                if (existingKeys_1.hasKey(k3)) return false;
                                existingKeys_1.addKey(k3);
                                return true;
                            }));
                            break;
                        case "put":
                            var keySet_1 = new RangeSet2().addKeys(op.values.map(function(v3) {
                                return extractPrimKey(v3);
                            }));
                            modifedResult = result2.filter(function(item) {
                                return !keySet_1.hasKey(req.values ? extractPrimKey(item) : item);
                            }).concat(req.values ? includedValues : includedValues.map(function(v3) {
                                return extractPrimKey(v3);
                            }));
                            break;
                        case "delete":
                            var keysToDelete_1 = new RangeSet2().addKeys(op.keys);
                            modifedResult = result2.filter(function(item) {
                                return !keysToDelete_1.hasKey(req.values ? extractPrimKey(item) : item);
                            });
                            break;
                        case "deleteRange":
                            var range_1 = op.range;
                            modifedResult = result2.filter(function(item) {
                                return !isWithinRange(extractPrimKey(item), range_1);
                            });
                            break;
                    }
                    return modifedResult;
                }, result);
                if (finalResult === result) return result;
                var sorter = function(a3, b3) {
                    return cmp2(extractLowLevelIndex(a3), extractLowLevelIndex(b3)) || cmp2(extractPrimKey(a3), extractPrimKey(b3));
                };
                finalResult.sort(req.direction === "prev" || req.direction === "prevunique" ? function(a3, b3) {
                    return sorter(b3, a3);
                } : sorter);
                if (req.limit && req.limit < Infinity) {
                    if (finalResult.length > req.limit) finalResult.length = req.limit;
                    else if (result.length === req.limit && finalResult.length < req.limit) cacheEntry.dirty = true;
                }
                return immutable ? Object.freeze(finalResult) : finalResult;
            }
            function areRangesEqual(r1, r22) {
                return cmp2(r1.lower, r22.lower) === 0 && cmp2(r1.upper, r22.upper) === 0 && !!r1.lowerOpen === !!r22.lowerOpen && !!r1.upperOpen === !!r22.upperOpen;
            }
            function compareLowers(lower1, lower2, lowerOpen1, lowerOpen2) {
                if (lower1 === void 0) return lower2 !== void 0 ? -1 : 0;
                if (lower2 === void 0) return 1;
                var c3 = cmp2(lower1, lower2);
                if (c3 === 0) {
                    if (lowerOpen1 && lowerOpen2) return 0;
                    if (lowerOpen1) return 1;
                    if (lowerOpen2) return -1;
                }
                return c3;
            }
            function compareUppers(upper1, upper2, upperOpen1, upperOpen2) {
                if (upper1 === void 0) return upper2 !== void 0 ? 1 : 0;
                if (upper2 === void 0) return -1;
                var c3 = cmp2(upper1, upper2);
                if (c3 === 0) {
                    if (upperOpen1 && upperOpen2) return 0;
                    if (upperOpen1) return -1;
                    if (upperOpen2) return 1;
                }
                return c3;
            }
            function isSuperRange(r1, r22) {
                return compareLowers(r1.lower, r22.lower, r1.lowerOpen, r22.lowerOpen) <= 0 && compareUppers(r1.upper, r22.upper, r1.upperOpen, r22.upperOpen) >= 0;
            }
            function findCompatibleQuery(dbName, tableName, type2, req) {
                var _a3;
                var tblCache = cache2["idb://".concat(dbName, "/").concat(tableName)];
                if (!tblCache) return [];
                var queries = tblCache.queries[type2];
                if (!queries) return [
                    null,
                    false,
                    tblCache,
                    null
                ];
                var indexName = req.query ? req.query.index.name : null;
                var entries = queries[indexName || ""];
                if (!entries) return [
                    null,
                    false,
                    tblCache,
                    null
                ];
                switch(type2){
                    case "query":
                        var reqDirection_1 = (_a3 = req.direction) !== null && _a3 !== void 0 ? _a3 : "next";
                        var equalEntry = entries.find(function(entry) {
                            var _a4;
                            return entry.req.limit === req.limit && entry.req.values === req.values && ((_a4 = entry.req.direction) !== null && _a4 !== void 0 ? _a4 : "next") === reqDirection_1 && areRangesEqual(entry.req.query.range, req.query.range);
                        });
                        if (equalEntry) return [
                            equalEntry,
                            true,
                            tblCache,
                            entries
                        ];
                        var superEntry = entries.find(function(entry) {
                            var _a4;
                            var limit = "limit" in entry.req ? entry.req.limit : Infinity;
                            return limit >= req.limit && ((_a4 = entry.req.direction) !== null && _a4 !== void 0 ? _a4 : "next") === reqDirection_1 && (req.values ? entry.req.values : true) && isSuperRange(entry.req.query.range, req.query.range);
                        });
                        return [
                            superEntry,
                            false,
                            tblCache,
                            entries
                        ];
                    case "count":
                        var countQuery = entries.find(function(entry) {
                            return areRangesEqual(entry.req.query.range, req.query.range);
                        });
                        return [
                            countQuery,
                            !!countQuery,
                            tblCache,
                            entries
                        ];
                }
            }
            function subscribeToCacheEntry(cacheEntry, container, requery, signal) {
                cacheEntry.subscribers.add(requery);
                signal.addEventListener("abort", function() {
                    cacheEntry.subscribers.delete(requery);
                    if (cacheEntry.subscribers.size === 0) enqueForDeletion(cacheEntry, container);
                });
            }
            function enqueForDeletion(cacheEntry, container) {
                setTimeout(function() {
                    if (cacheEntry.subscribers.size === 0) delArrayItem(container, cacheEntry);
                }, 3e3);
            }
            var cacheMiddleware = {
                stack: "dbcore",
                level: 0,
                name: "Cache",
                create: function(core) {
                    var dbName = core.schema.name;
                    var coreMW = __assign(__assign({}, core), {
                        transaction: function(stores, mode, options) {
                            var idbtrans = core.transaction(stores, mode, options);
                            if (mode === "readwrite") {
                                var ac_1 = new AbortController();
                                var signal = ac_1.signal;
                                var endTransaction = function(wasCommitted) {
                                    return function() {
                                        ac_1.abort();
                                        if (mode === "readwrite") {
                                            var affectedSubscribers_1 = /* @__PURE__ */ new Set();
                                            for(var _i = 0, stores_1 = stores; _i < stores_1.length; _i++){
                                                var storeName = stores_1[_i];
                                                var tblCache = cache2["idb://".concat(dbName, "/").concat(storeName)];
                                                if (tblCache) {
                                                    var table = core.table(storeName);
                                                    var ops = tblCache.optimisticOps.filter(function(op) {
                                                        return op.trans === idbtrans;
                                                    });
                                                    if (idbtrans._explicit && wasCommitted && idbtrans.mutatedParts) for(var _a3 = 0, _b = Object.values(tblCache.queries.query); _a3 < _b.length; _a3++){
                                                        var entries = _b[_a3];
                                                        for(var _c = 0, _d = entries.slice(); _c < _d.length; _c++){
                                                            var entry = _d[_c];
                                                            if (obsSetsOverlap(entry.obsSet, idbtrans.mutatedParts)) {
                                                                delArrayItem(entries, entry);
                                                                entry.subscribers.forEach(function(requery) {
                                                                    return affectedSubscribers_1.add(requery);
                                                                });
                                                            }
                                                        }
                                                    }
                                                    else if (ops.length > 0) {
                                                        tblCache.optimisticOps = tblCache.optimisticOps.filter(function(op) {
                                                            return op.trans !== idbtrans;
                                                        });
                                                        for(var _e = 0, _f = Object.values(tblCache.queries.query); _e < _f.length; _e++){
                                                            var entries = _f[_e];
                                                            for(var _g = 0, _h = entries.slice(); _g < _h.length; _g++){
                                                                var entry = _h[_g];
                                                                if (entry.res != null && idbtrans.mutatedParts) {
                                                                    if (wasCommitted && !entry.dirty) {
                                                                        var freezeResults = Object.isFrozen(entry.res);
                                                                        var modRes = applyOptimisticOps(entry.res, entry.req, ops, table, entry, freezeResults);
                                                                        if (entry.dirty) {
                                                                            delArrayItem(entries, entry);
                                                                            entry.subscribers.forEach(function(requery) {
                                                                                return affectedSubscribers_1.add(requery);
                                                                            });
                                                                        } else if (modRes !== entry.res) {
                                                                            entry.res = modRes;
                                                                            entry.promise = DexiePromise.resolve({
                                                                                result: modRes
                                                                            });
                                                                        }
                                                                    } else {
                                                                        if (entry.dirty) delArrayItem(entries, entry);
                                                                        entry.subscribers.forEach(function(requery) {
                                                                            return affectedSubscribers_1.add(requery);
                                                                        });
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            affectedSubscribers_1.forEach(function(requery) {
                                                return requery();
                                            });
                                        }
                                    };
                                };
                                idbtrans.addEventListener("abort", endTransaction(false), {
                                    signal: signal
                                });
                                idbtrans.addEventListener("error", endTransaction(false), {
                                    signal: signal
                                });
                                idbtrans.addEventListener("complete", endTransaction(true), {
                                    signal: signal
                                });
                            }
                            return idbtrans;
                        },
                        table: function(tableName) {
                            var downTable = core.table(tableName);
                            var primKey = downTable.schema.primaryKey;
                            var tableMW = __assign(__assign({}, downTable), {
                                mutate: function(req) {
                                    var trans = PSD.trans;
                                    if (primKey.outbound || trans.db._options.cache === "disabled" || trans.explicit || trans.idbtrans.mode !== "readwrite") return downTable.mutate(req);
                                    var tblCache = cache2["idb://".concat(dbName, "/").concat(tableName)];
                                    if (!tblCache) return downTable.mutate(req);
                                    var promise = downTable.mutate(req);
                                    if ((req.type === "add" || req.type === "put") && (req.values.length >= 50 || getEffectiveKeys(primKey, req).some(function(key) {
                                        return key == null;
                                    }))) promise.then(function(res) {
                                        var reqWithResolvedKeys = __assign(__assign({}, req), {
                                            values: req.values.map(function(value2, i3) {
                                                var _a3;
                                                if (res.failures[i3]) return value2;
                                                var valueWithKey = ((_a3 = primKey.keyPath) === null || _a3 === void 0 ? void 0 : _a3.includes(".")) ? deepClone2(value2) : __assign({}, value2);
                                                setByKeyPath(valueWithKey, primKey.keyPath, res.results[i3]);
                                                return valueWithKey;
                                            })
                                        });
                                        var adjustedReq = adjustOptimisticFromFailures(tblCache, reqWithResolvedKeys, res);
                                        tblCache.optimisticOps.push(adjustedReq);
                                        queueMicrotask(function() {
                                            return req.mutatedParts && signalSubscribersLazily(req.mutatedParts);
                                        });
                                    });
                                    else {
                                        tblCache.optimisticOps.push(req);
                                        req.mutatedParts && signalSubscribersLazily(req.mutatedParts);
                                        promise.then(function(res) {
                                            if (res.numFailures > 0) {
                                                delArrayItem(tblCache.optimisticOps, req);
                                                var adjustedReq = adjustOptimisticFromFailures(tblCache, req, res);
                                                if (adjustedReq) tblCache.optimisticOps.push(adjustedReq);
                                                req.mutatedParts && signalSubscribersLazily(req.mutatedParts);
                                            }
                                        });
                                        promise.catch(function() {
                                            delArrayItem(tblCache.optimisticOps, req);
                                            req.mutatedParts && signalSubscribersLazily(req.mutatedParts);
                                        });
                                    }
                                    return promise;
                                },
                                query: function(req) {
                                    var _a3;
                                    if (!isCachableContext(PSD, downTable) || !isCachableRequest("query", req)) return downTable.query(req);
                                    var freezeResults = ((_a3 = PSD.trans) === null || _a3 === void 0 ? void 0 : _a3.db._options.cache) === "immutable";
                                    var _b = PSD, requery = _b.requery, signal = _b.signal;
                                    var _c = findCompatibleQuery(dbName, tableName, "query", req), cacheEntry = _c[0], exactMatch = _c[1], tblCache = _c[2], container = _c[3];
                                    if (cacheEntry && exactMatch) cacheEntry.obsSet = req.obsSet;
                                    else {
                                        var promise = downTable.query(req).then(function(res) {
                                            var result = res.result;
                                            if (cacheEntry) cacheEntry.res = result;
                                            if (freezeResults) {
                                                for(var i3 = 0, l3 = result.length; i3 < l3; ++i3)Object.freeze(result[i3]);
                                                Object.freeze(result);
                                            } else res.result = deepClone2(result);
                                            return res;
                                        }).catch(function(error) {
                                            if (container && cacheEntry) delArrayItem(container, cacheEntry);
                                            return Promise.reject(error);
                                        });
                                        cacheEntry = {
                                            obsSet: req.obsSet,
                                            promise: promise,
                                            subscribers: /* @__PURE__ */ new Set(),
                                            type: "query",
                                            req: req,
                                            dirty: false
                                        };
                                        if (container) container.push(cacheEntry);
                                        else {
                                            container = [
                                                cacheEntry
                                            ];
                                            if (!tblCache) tblCache = cache2["idb://".concat(dbName, "/").concat(tableName)] = {
                                                queries: {
                                                    query: {},
                                                    count: {}
                                                },
                                                objs: /* @__PURE__ */ new Map(),
                                                optimisticOps: [],
                                                unsignaledParts: {}
                                            };
                                            tblCache.queries.query[req.query.index.name || ""] = container;
                                        }
                                    }
                                    subscribeToCacheEntry(cacheEntry, container, requery, signal);
                                    return cacheEntry.promise.then(function(res) {
                                        return {
                                            result: applyOptimisticOps(res.result, req, tblCache === null || tblCache === void 0 ? void 0 : tblCache.optimisticOps, downTable, cacheEntry, freezeResults)
                                        };
                                    });
                                }
                            });
                            return tableMW;
                        }
                    });
                    return coreMW;
                }
            };
            function vipify(target, vipDb) {
                return new Proxy(target, {
                    get: function(target2, prop, receiver) {
                        if (prop === "db") return vipDb;
                        return Reflect.get(target2, prop, receiver);
                    }
                });
            }
            var Dexie$1 = function() {
                function Dexie3(name, options) {
                    var _this = this;
                    this._middlewares = {};
                    this.verno = 0;
                    var deps = Dexie3.dependencies;
                    this._options = options = __assign({
                        addons: Dexie3.addons,
                        autoOpen: true,
                        indexedDB: deps.indexedDB,
                        IDBKeyRange: deps.IDBKeyRange,
                        cache: "cloned",
                        maxConnections: DEFAULT_MAX_CONNECTIONS
                    }, options);
                    this._deps = {
                        indexedDB: options.indexedDB,
                        IDBKeyRange: options.IDBKeyRange
                    };
                    var addons = options.addons;
                    this._dbSchema = {};
                    this._versions = [];
                    this._storeNames = [];
                    this._allTables = {};
                    this.idbdb = null;
                    this._novip = this;
                    var state = {
                        dbOpenError: null,
                        isBeingOpened: false,
                        onReadyBeingFired: null,
                        openComplete: false,
                        dbReadyResolve: nop,
                        dbReadyPromise: null,
                        cancelOpen: nop,
                        openCanceller: null,
                        autoSchema: true,
                        PR1398_maxLoop: 3,
                        autoOpen: options.autoOpen
                    };
                    state.dbReadyPromise = new DexiePromise(function(resolve) {
                        state.dbReadyResolve = resolve;
                    });
                    state.openCanceller = new DexiePromise(function(_3, reject) {
                        state.cancelOpen = reject;
                    });
                    this._state = state;
                    this.name = name;
                    this.on = Events(this, "populate", "blocked", "versionchange", "close", {
                        ready: [
                            promisableChain,
                            nop
                        ]
                    });
                    this.once = function(event, callback) {
                        var fn = function() {
                            var args2 = [];
                            for(var _i = 0; _i < arguments.length; _i++)args2[_i] = arguments[_i];
                            _this.on(event).unsubscribe(fn);
                            callback.apply(_this, args2);
                        };
                        return _this.on(event, fn);
                    };
                    this.on.ready.subscribe = override(this.on.ready.subscribe, function(subscribe) {
                        return function(subscriber, bSticky) {
                            Dexie3.vip(function() {
                                var state2 = _this._state;
                                if (state2.openComplete) {
                                    if (!state2.dbOpenError) DexiePromise.resolve().then(subscriber);
                                    if (bSticky) subscribe(subscriber);
                                } else if (state2.onReadyBeingFired) {
                                    state2.onReadyBeingFired.push(subscriber);
                                    if (bSticky) subscribe(subscriber);
                                } else {
                                    subscribe(subscriber);
                                    var db_1 = _this;
                                    if (!bSticky) subscribe(function unsubscribe() {
                                        db_1.on.ready.unsubscribe(subscriber);
                                        db_1.on.ready.unsubscribe(unsubscribe);
                                    });
                                }
                            });
                        };
                    });
                    this.Collection = createCollectionConstructor(this);
                    this.Table = createTableConstructor(this);
                    this.Transaction = createTransactionConstructor(this);
                    this.Version = createVersionConstructor(this);
                    this.WhereClause = createWhereClauseConstructor(this);
                    this.on("versionchange", function(ev) {
                        if (ev.newVersion > 0) console.warn("Another connection wants to upgrade database '".concat(_this.name, "'. Closing db now to resume the upgrade."));
                        else console.warn("Another connection wants to delete database '".concat(_this.name, "'. Closing db now to resume the delete request."));
                        _this.close({
                            disableAutoOpen: false
                        });
                    });
                    this.on("blocked", function(ev) {
                        if (!ev.newVersion || ev.newVersion < ev.oldVersion) console.warn("Dexie.delete('".concat(_this.name, "') was blocked"));
                        else console.warn("Upgrade '".concat(_this.name, "' blocked by other connection holding version ").concat(ev.oldVersion / 10));
                    });
                    this._maxKey = getMaxKey(options.IDBKeyRange);
                    this._createTransaction = function(mode, storeNames, dbschema, parentTransaction) {
                        return new _this.Transaction(mode, storeNames, dbschema, _this._options.chromeTransactionDurability, parentTransaction);
                    };
                    this._fireOnBlocked = function(ev) {
                        _this.on("blocked").fire(ev);
                        connections.toArray().filter(function(c3) {
                            return c3.name === _this.name && c3 !== _this && !c3._state.vcFired;
                        }).map(function(c3) {
                            return c3.on("versionchange").fire(ev);
                        });
                    };
                    this.use(cacheExistingValuesMiddleware);
                    this.use(cacheMiddleware);
                    this.use(observabilityMiddleware);
                    this.use(virtualIndexMiddleware);
                    this.use(hooksMiddleware);
                    var vipDB = new Proxy(this, {
                        get: function(_3, prop, receiver) {
                            if (prop === "_vip") return true;
                            if (prop === "table") return function(tableName) {
                                return vipify(_this.table(tableName), vipDB);
                            };
                            var rv = Reflect.get(_3, prop, receiver);
                            if (rv instanceof Table) return vipify(rv, vipDB);
                            if (prop === "tables") return rv.map(function(t4) {
                                return vipify(t4, vipDB);
                            });
                            if (prop === "_createTransaction") return function() {
                                var tx = rv.apply(this, arguments);
                                return vipify(tx, vipDB);
                            };
                            return rv;
                        }
                    });
                    this.vip = vipDB;
                    addons.forEach(function(addon) {
                        return addon(_this);
                    });
                }
                Dexie3.prototype.version = function(versionNumber) {
                    if (isNaN(versionNumber) || versionNumber < 0.1) throw new exceptions.Type("Given version is not a positive number");
                    versionNumber = Math.round(versionNumber * 10) / 10;
                    if (this.idbdb || this._state.isBeingOpened) throw new exceptions.Schema("Cannot add version when database is open");
                    this.verno = Math.max(this.verno, versionNumber);
                    var versions = this._versions;
                    var versionInstance = versions.filter(function(v3) {
                        return v3._cfg.version === versionNumber;
                    })[0];
                    if (versionInstance) return versionInstance;
                    versionInstance = new this.Version(versionNumber);
                    versions.push(versionInstance);
                    versions.sort(lowerVersionFirst);
                    versionInstance.stores({});
                    this._state.autoSchema = false;
                    return versionInstance;
                };
                Dexie3.prototype._whenReady = function(fn) {
                    var _this = this;
                    return this.idbdb && (this._state.openComplete || PSD.letThrough || this._vip) ? fn() : new DexiePromise(function(resolve, reject) {
                        if (_this._state.openComplete) return reject(new exceptions.DatabaseClosed(_this._state.dbOpenError));
                        if (!_this._state.isBeingOpened) {
                            if (!_this._state.autoOpen) {
                                reject(new exceptions.DatabaseClosed());
                                return;
                            }
                            _this.open().catch(nop);
                        }
                        _this._state.dbReadyPromise.then(resolve, reject);
                    }).then(fn);
                };
                Dexie3.prototype.use = function(_a3) {
                    var stack = _a3.stack, create7 = _a3.create, level = _a3.level, name = _a3.name;
                    if (name) this.unuse({
                        stack: stack,
                        name: name
                    });
                    var middlewares = this._middlewares[stack] || (this._middlewares[stack] = []);
                    middlewares.push({
                        stack: stack,
                        create: create7,
                        level: level == null ? 10 : level,
                        name: name
                    });
                    middlewares.sort(function(a3, b3) {
                        return a3.level - b3.level;
                    });
                    return this;
                };
                Dexie3.prototype.unuse = function(_a3) {
                    var stack = _a3.stack, name = _a3.name, create7 = _a3.create;
                    if (stack && this._middlewares[stack]) this._middlewares[stack] = this._middlewares[stack].filter(function(mw) {
                        return create7 ? mw.create !== create7 : name ? mw.name !== name : false;
                    });
                    return this;
                };
                Dexie3.prototype.open = function() {
                    var _this = this;
                    return usePSD(globalPSD, function() {
                        return dexieOpen(_this);
                    });
                };
                Dexie3.prototype._close = function() {
                    this.on.close.fire(new CustomEvent("close"));
                    var state = this._state;
                    connections.remove(this);
                    if (this.idbdb) {
                        try {
                            this.idbdb.close();
                        } catch (e4) {}
                        this.idbdb = null;
                    }
                    if (!state.isBeingOpened) {
                        state.dbReadyPromise = new DexiePromise(function(resolve) {
                            state.dbReadyResolve = resolve;
                        });
                        state.openCanceller = new DexiePromise(function(_3, reject) {
                            state.cancelOpen = reject;
                        });
                    }
                };
                Dexie3.prototype.close = function(_a3) {
                    var _b = _a3 === void 0 ? {
                        disableAutoOpen: true
                    } : _a3, disableAutoOpen = _b.disableAutoOpen;
                    var state = this._state;
                    if (disableAutoOpen) {
                        if (state.isBeingOpened) state.cancelOpen(new exceptions.DatabaseClosed());
                        this._close();
                        state.autoOpen = false;
                        state.dbOpenError = new exceptions.DatabaseClosed();
                    } else {
                        this._close();
                        state.autoOpen = this._options.autoOpen || state.isBeingOpened;
                        state.openComplete = false;
                        state.dbOpenError = null;
                    }
                };
                Dexie3.prototype.delete = function(closeOptions) {
                    var _this = this;
                    if (closeOptions === void 0) closeOptions = {
                        disableAutoOpen: true
                    };
                    var hasInvalidArguments = arguments.length > 0 && typeof arguments[0] !== "object";
                    var state = this._state;
                    return new DexiePromise(function(resolve, reject) {
                        var doDelete = function() {
                            _this.close(closeOptions);
                            var req = _this._deps.indexedDB.deleteDatabase(_this.name);
                            req.onsuccess = wrap2(function() {
                                _onDatabaseDeleted(_this._deps, _this.name);
                                resolve();
                            });
                            req.onerror = eventRejectHandler(reject);
                            req.onblocked = _this._fireOnBlocked;
                        };
                        if (hasInvalidArguments) throw new exceptions.InvalidArgument("Invalid closeOptions argument to db.delete()");
                        if (state.isBeingOpened) state.dbReadyPromise.then(doDelete);
                        else doDelete();
                    });
                };
                Dexie3.prototype.backendDB = function() {
                    return this.idbdb;
                };
                Dexie3.prototype.isOpen = function() {
                    return this.idbdb !== null;
                };
                Dexie3.prototype.hasBeenClosed = function() {
                    var dbOpenError = this._state.dbOpenError;
                    return dbOpenError && dbOpenError.name === "DatabaseClosed";
                };
                Dexie3.prototype.hasFailed = function() {
                    return this._state.dbOpenError !== null;
                };
                Dexie3.prototype.dynamicallyOpened = function() {
                    return this._state.autoSchema;
                };
                Object.defineProperty(Dexie3.prototype, "tables", {
                    get: function() {
                        var _this = this;
                        return keys2(this._allTables).map(function(name) {
                            return _this._allTables[name];
                        });
                    },
                    enumerable: false,
                    configurable: true
                });
                Dexie3.prototype.transaction = function() {
                    var args2 = extractTransactionArgs.apply(this, arguments);
                    return this._transaction.apply(this, args2);
                };
                Dexie3.prototype._transaction = function(mode, tables, scopeFunc) {
                    var _this = this;
                    var parentTransaction = PSD.trans;
                    if (!parentTransaction || parentTransaction.db !== this || mode.indexOf("!") !== -1) parentTransaction = null;
                    var onlyIfCompatible = mode.indexOf("?") !== -1;
                    mode = mode.replace("!", "").replace("?", "");
                    var idbMode, storeNames;
                    try {
                        storeNames = tables.map(function(table) {
                            var storeName = table instanceof _this.Table ? table.name : table;
                            if (typeof storeName !== "string") throw new TypeError("Invalid table argument to Dexie.transaction(). Only Table or String are allowed");
                            return storeName;
                        });
                        if (mode == "r" || mode === READONLY) idbMode = READONLY;
                        else if (mode == "rw" || mode == READWRITE) idbMode = READWRITE;
                        else throw new exceptions.InvalidArgument("Invalid transaction mode: " + mode);
                        if (parentTransaction) {
                            if (parentTransaction.mode === READONLY && idbMode === READWRITE) {
                                if (onlyIfCompatible) parentTransaction = null;
                                else throw new exceptions.SubTransaction("Cannot enter a sub-transaction with READWRITE mode when parent transaction is READONLY");
                            }
                            if (parentTransaction) storeNames.forEach(function(storeName) {
                                if (parentTransaction && parentTransaction.storeNames.indexOf(storeName) === -1) {
                                    if (onlyIfCompatible) parentTransaction = null;
                                    else throw new exceptions.SubTransaction("Table " + storeName + " not included in parent transaction.");
                                }
                            });
                            if (onlyIfCompatible && parentTransaction && !parentTransaction.active) parentTransaction = null;
                        }
                    } catch (e4) {
                        return parentTransaction ? parentTransaction._promise(null, function(_3, reject) {
                            reject(e4);
                        }) : rejection(e4);
                    }
                    var enterTransaction = enterTransactionScope.bind(null, this, idbMode, storeNames, parentTransaction, scopeFunc);
                    return parentTransaction ? parentTransaction._promise(idbMode, enterTransaction, "lock") : PSD.trans ? usePSD(PSD.transless, function() {
                        return _this._whenReady(enterTransaction);
                    }) : this._whenReady(enterTransaction);
                };
                Dexie3.prototype.table = function(tableName) {
                    if (!hasOwn2(this._allTables, tableName)) throw new exceptions.InvalidTable("Table ".concat(tableName, " does not exist"));
                    return this._allTables[tableName];
                };
                return Dexie3;
            }();
            var symbolObservable = typeof Symbol !== "undefined" && "observable" in Symbol ? Symbol.observable : "@@observable";
            var Observable3 = function() {
                function Observable4(subscribe) {
                    this._subscribe = subscribe;
                }
                Observable4.prototype.subscribe = function(x3, error, complete) {
                    return this._subscribe(!x3 || typeof x3 === "function" ? {
                        next: x3,
                        error: error,
                        complete: complete
                    } : x3);
                };
                Observable4.prototype[symbolObservable] = function() {
                    return this;
                };
                return Observable4;
            }();
            var domDeps;
            try {
                domDeps = {
                    indexedDB: _global3.indexedDB || _global3.mozIndexedDB || _global3.webkitIndexedDB || _global3.msIndexedDB,
                    IDBKeyRange: _global3.IDBKeyRange || _global3.webkitIDBKeyRange
                };
            } catch (e4) {
                domDeps = {
                    indexedDB: null,
                    IDBKeyRange: null
                };
            }
            function liveQuery2(querier) {
                var hasValue = false;
                var currentValue;
                var observable = new Observable3(function(observer) {
                    var scopeFuncIsAsync = isAsyncFunction(querier);
                    function execute(ctx) {
                        var wasRootExec = beginMicroTickScope();
                        try {
                            if (scopeFuncIsAsync) incrementExpectedAwaits();
                            var rv = newScope(querier, ctx);
                            if (scopeFuncIsAsync) rv = rv.finally(decrementExpectedAwaits);
                            return rv;
                        } finally{
                            wasRootExec && endMicroTickScope();
                        }
                    }
                    var closed = false;
                    var abortController;
                    var accumMuts = {};
                    var currentObs = {};
                    var subscription = {
                        get closed () {
                            return closed;
                        },
                        unsubscribe: function() {
                            if (closed) return;
                            closed = true;
                            if (abortController) abortController.abort();
                            if (startedListening) globalEvents.storagemutated.unsubscribe(mutationListener);
                        }
                    };
                    observer.start && observer.start(subscription);
                    var startedListening = false;
                    var doQuery = function() {
                        return execInGlobalContext(_doQuery);
                    };
                    function shouldNotify() {
                        return obsSetsOverlap(currentObs, accumMuts);
                    }
                    var mutationListener = function(parts2) {
                        extendObservabilitySet(accumMuts, parts2);
                        if (shouldNotify()) doQuery();
                    };
                    var _doQuery = function() {
                        if (closed || !domDeps.indexedDB) return;
                        accumMuts = {};
                        var subscr = {};
                        if (abortController) abortController.abort();
                        abortController = new AbortController();
                        var ctx = {
                            subscr: subscr,
                            signal: abortController.signal,
                            requery: doQuery,
                            querier: querier,
                            trans: null
                        };
                        var ret = execute(ctx);
                        if (!startedListening) {
                            globalEvents(DEXIE_STORAGE_MUTATED_EVENT_NAME, mutationListener);
                            startedListening = true;
                        }
                        Promise.resolve(ret).then(function(result) {
                            hasValue = true;
                            currentValue = result;
                            if (closed || ctx.signal.aborted) return;
                            if (shouldNotify()) doQuery();
                            else {
                                currentObs = subscr;
                                if (shouldNotify()) doQuery();
                                else {
                                    accumMuts = {};
                                    execInGlobalContext(function() {
                                        return !closed && observer.next && observer.next(result);
                                    });
                                }
                            }
                        }, function(err) {
                            hasValue = false;
                            if (![
                                "DatabaseClosedError",
                                "AbortError"
                            ].includes(err === null || err === void 0 ? void 0 : err.name)) {
                                if (!closed) execInGlobalContext(function() {
                                    if (closed) return;
                                    observer.error && observer.error(err);
                                });
                            }
                        });
                    };
                    setTimeout(doQuery, 0);
                    return subscription;
                });
                observable.hasValue = function() {
                    return hasValue;
                };
                observable.getValue = function() {
                    return currentValue;
                };
                return observable;
            }
            var Dexie2 = Dexie$1;
            props(Dexie2, __assign(__assign({}, fullNameExceptions), {
                delete: function(databaseName) {
                    var db = new Dexie2(databaseName, {
                        addons: []
                    });
                    return db.delete();
                },
                exists: function(name) {
                    return new Dexie2(name, {
                        addons: []
                    }).open().then(function(db) {
                        db.close();
                        return true;
                    }).catch("NoSuchDatabaseError", function() {
                        return false;
                    });
                },
                getDatabaseNames: function(cb) {
                    try {
                        return getDatabaseNames(Dexie2.dependencies).then(cb);
                    } catch (_a3) {
                        return rejection(new exceptions.MissingAPI());
                    }
                },
                defineClass: function() {
                    function Class(content) {
                        extend2(this, content);
                    }
                    return Class;
                },
                ignoreTransaction: function(scopeFunc) {
                    return PSD.trans ? usePSD(PSD.transless || globalPSD, scopeFunc) : scopeFunc();
                },
                vip: vip,
                async: function(generatorFn) {
                    return function() {
                        try {
                            var rv = awaitIterator(generatorFn.apply(this, arguments));
                            if (!rv || typeof rv.then !== "function") return DexiePromise.resolve(rv);
                            return rv;
                        } catch (e4) {
                            return rejection(e4);
                        }
                    };
                },
                spawn: function(generatorFn, args2, thiz) {
                    try {
                        var rv = awaitIterator(generatorFn.apply(thiz, args2 || []));
                        if (!rv || typeof rv.then !== "function") return DexiePromise.resolve(rv);
                        return rv;
                    } catch (e4) {
                        return rejection(e4);
                    }
                },
                currentTransaction: {
                    get: function() {
                        return PSD.trans || null;
                    }
                },
                waitFor: function(promiseOrFunction, optionalTimeout) {
                    var promise = DexiePromise.resolve(typeof promiseOrFunction === "function" ? Dexie2.ignoreTransaction(promiseOrFunction) : promiseOrFunction).timeout(optionalTimeout || 6e4);
                    return PSD.trans ? PSD.trans.waitFor(promise) : promise;
                },
                Promise: DexiePromise,
                debug: {
                    get: function() {
                        return debug;
                    },
                    set: function(value2) {
                        setDebug2(value2);
                    }
                },
                derive: derive,
                extend: extend2,
                props: props,
                override: override,
                Events: Events,
                on: globalEvents,
                liveQuery: liveQuery2,
                extendObservabilitySet: extendObservabilitySet,
                getByKeyPath: getByKeyPath,
                setByKeyPath: setByKeyPath,
                delByKeyPath: delByKeyPath,
                shallowClone: shallowClone,
                deepClone: deepClone2,
                getObjectDiff: getObjectDiff,
                cmp: cmp2,
                asap: asap$1,
                minKey: minKey,
                addons: [],
                connections: {
                    get: connections.toArray
                },
                errnames: errnames,
                dependencies: domDeps,
                cache: cache2,
                semVer: DEXIE_VERSION,
                version: DEXIE_VERSION.split(".").map(function(n3) {
                    return parseInt(n3);
                }).reduce(function(p3, c3, i3) {
                    return p3 + c3 / Math.pow(10, i3 * 2);
                })
            }));
            Dexie2.maxKey = getMaxKey(Dexie2.dependencies.IDBKeyRange);
            if (typeof dispatchEvent !== "undefined" && typeof addEventListener !== "undefined") {
                globalEvents(DEXIE_STORAGE_MUTATED_EVENT_NAME, function(updatedParts) {
                    if (!propagatingLocally) {
                        var event_1;
                        event_1 = new CustomEvent(STORAGE_MUTATED_DOM_EVENT_NAME, {
                            detail: updatedParts
                        });
                        propagatingLocally = true;
                        dispatchEvent(event_1);
                        propagatingLocally = false;
                    }
                });
                addEventListener(STORAGE_MUTATED_DOM_EVENT_NAME, function(_a3) {
                    var detail = _a3.detail;
                    if (!propagatingLocally) propagateLocally(detail);
                });
            }
            function propagateLocally(updateParts) {
                var wasMe = propagatingLocally;
                try {
                    propagatingLocally = true;
                    globalEvents.storagemutated.fire(updateParts);
                    signalSubscribersNow(updateParts, true);
                } finally{
                    propagatingLocally = wasMe;
                }
            }
            var propagatingLocally = false;
            var bc;
            var createBC = function() {};
            if (typeof BroadcastChannel !== "undefined") {
                createBC = function() {
                    bc = new BroadcastChannel(STORAGE_MUTATED_DOM_EVENT_NAME);
                    bc.onmessage = function(ev) {
                        return ev.data && propagateLocally(ev.data);
                    };
                };
                createBC();
                if (typeof bc.unref === "function") bc.unref();
                globalEvents(DEXIE_STORAGE_MUTATED_EVENT_NAME, function(changedParts) {
                    if (!propagatingLocally) bc.postMessage(changedParts);
                });
            }
            if (typeof addEventListener !== "undefined") {
                addEventListener("pagehide", function(event) {
                    if (!Dexie$1.disableBfCache && event.persisted) {
                        if (debug) console.debug("Dexie: handling persisted pagehide");
                        bc === null || bc === void 0 || bc.close();
                        for(var _i = 0, _a3 = connections.toArray(); _i < _a3.length; _i++){
                            var db = _a3[_i];
                            db.close({
                                disableAutoOpen: false
                            });
                        }
                    }
                });
                addEventListener("pageshow", function(event) {
                    if (!Dexie$1.disableBfCache && event.persisted) {
                        if (debug) console.debug("Dexie: handling persisted pageshow");
                        createBC();
                        propagateLocally({
                            all: new RangeSet2(-Infinity, [
                                []
                            ])
                        });
                    }
                });
            }
            function add2(value2) {
                return new PropModification2({
                    add: value2
                });
            }
            function remove3(value2) {
                return new PropModification2({
                    remove: value2
                });
            }
            function replacePrefix2(a3, b3) {
                return new PropModification2({
                    replacePrefix: [
                        a3,
                        b3
                    ]
                });
            }
            DexiePromise.rejectionMapper = mapError;
            setDebug2(debug);
            var namedExports = /* @__PURE__ */ Object.freeze({
                __proto__: null,
                DEFAULT_MAX_CONNECTIONS: DEFAULT_MAX_CONNECTIONS,
                Dexie: Dexie$1,
                Entity: Entity2,
                PropModification: PropModification2,
                RangeSet: RangeSet2,
                add: add2,
                cmp: cmp2,
                default: Dexie$1,
                liveQuery: liveQuery2,
                mergeRanges: mergeRanges2,
                rangesOverlap: rangesOverlap2,
                remove: remove3,
                replacePrefix: replacePrefix2
            });
            __assign(Dexie$1, namedExports, {
                default: Dexie$1
            });
            return Dexie$1;
        });
    }
});
// ../node_modules/dexie/import-wrapper.mjs
var $281a441cdcb2cf36$var$import_wrapper_exports = {};
$281a441cdcb2cf36$var$__export($281a441cdcb2cf36$var$import_wrapper_exports, {
    Dexie: ()=>$281a441cdcb2cf36$var$Dexie,
    DexieYProvider: ()=>$281a441cdcb2cf36$var$DexieYProvider,
    Entity: ()=>$281a441cdcb2cf36$var$Entity,
    PropModification: ()=>$281a441cdcb2cf36$var$PropModification,
    RangeSet: ()=>$281a441cdcb2cf36$var$RangeSet,
    add: ()=>$281a441cdcb2cf36$var$add,
    cmp: ()=>$281a441cdcb2cf36$var$cmp,
    default: ()=>$281a441cdcb2cf36$var$import_wrapper_default,
    liveQuery: ()=>$281a441cdcb2cf36$var$liveQuery,
    mergeRanges: ()=>$281a441cdcb2cf36$var$mergeRanges,
    rangesOverlap: ()=>$281a441cdcb2cf36$var$rangesOverlap,
    remove: ()=>$281a441cdcb2cf36$var$remove,
    replacePrefix: ()=>$281a441cdcb2cf36$var$replacePrefix
});
var $281a441cdcb2cf36$var$import_dexie, $281a441cdcb2cf36$var$DexieSymbol, $281a441cdcb2cf36$var$Dexie, $281a441cdcb2cf36$var$liveQuery, $281a441cdcb2cf36$var$mergeRanges, $281a441cdcb2cf36$var$rangesOverlap, $281a441cdcb2cf36$var$RangeSet, $281a441cdcb2cf36$var$cmp, $281a441cdcb2cf36$var$Entity, $281a441cdcb2cf36$var$PropModification, $281a441cdcb2cf36$var$replacePrefix, $281a441cdcb2cf36$var$add, $281a441cdcb2cf36$var$remove, $281a441cdcb2cf36$var$DexieYProvider, $281a441cdcb2cf36$var$import_wrapper_default;
var $281a441cdcb2cf36$var$init_import_wrapper = $281a441cdcb2cf36$var$__esm({
    "../node_modules/dexie/import-wrapper.mjs" () {
        $281a441cdcb2cf36$var$import_dexie = $281a441cdcb2cf36$var$__toESM($281a441cdcb2cf36$var$require_dexie(), 1);
        $281a441cdcb2cf36$var$DexieSymbol = /* @__PURE__ */ Symbol.for("Dexie");
        $281a441cdcb2cf36$var$Dexie = globalThis[$281a441cdcb2cf36$var$DexieSymbol] || (globalThis[$281a441cdcb2cf36$var$DexieSymbol] = $281a441cdcb2cf36$var$import_dexie.default);
        if ($281a441cdcb2cf36$var$import_dexie.default.semVer !== $281a441cdcb2cf36$var$Dexie.semVer) throw new Error(`Two different versions of Dexie loaded in the same app: ${$281a441cdcb2cf36$var$import_dexie.default.semVer} and ${$281a441cdcb2cf36$var$Dexie.semVer}`);
        ({ liveQuery: $281a441cdcb2cf36$var$liveQuery, mergeRanges: $281a441cdcb2cf36$var$mergeRanges, rangesOverlap: $281a441cdcb2cf36$var$rangesOverlap, RangeSet: $281a441cdcb2cf36$var$RangeSet, cmp: $281a441cdcb2cf36$var$cmp, Entity: $281a441cdcb2cf36$var$Entity, PropModification: $281a441cdcb2cf36$var$PropModification, replacePrefix: $281a441cdcb2cf36$var$replacePrefix, add: $281a441cdcb2cf36$var$add, remove: $281a441cdcb2cf36$var$remove, DexieYProvider: $281a441cdcb2cf36$var$DexieYProvider } = $281a441cdcb2cf36$var$Dexie);
        $281a441cdcb2cf36$var$import_wrapper_default = $281a441cdcb2cf36$var$Dexie;
    }
});
// ../node_modules/@opentelemetry/api/build/esm/version.js
var $281a441cdcb2cf36$var$VERSION;
var $281a441cdcb2cf36$var$init_version = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api/build/esm/version.js" () {
        $281a441cdcb2cf36$var$VERSION = "1.9.1";
    }
});
// ../node_modules/@opentelemetry/api/build/esm/internal/semver.js
function $281a441cdcb2cf36$var$_makeCompatibilityCheck(ownVersion) {
    const acceptedVersions = /* @__PURE__ */ new Set([
        ownVersion
    ]);
    const rejectedVersions = /* @__PURE__ */ new Set();
    const myVersionMatch = ownVersion.match($281a441cdcb2cf36$var$re2);
    if (!myVersionMatch) return ()=>false;
    const ownVersionParsed = {
        major: +myVersionMatch[1],
        minor: +myVersionMatch[2],
        patch: +myVersionMatch[3],
        prerelease: myVersionMatch[4]
    };
    if (ownVersionParsed.prerelease != null) return function isExactmatch(globalVersion) {
        return globalVersion === ownVersion;
    };
    function _reject(v3) {
        rejectedVersions.add(v3);
        return false;
    }
    function _accept(v3) {
        acceptedVersions.add(v3);
        return true;
    }
    return function isCompatible2(globalVersion) {
        if (acceptedVersions.has(globalVersion)) return true;
        if (rejectedVersions.has(globalVersion)) return false;
        const globalVersionMatch = globalVersion.match($281a441cdcb2cf36$var$re2);
        if (!globalVersionMatch) return _reject(globalVersion);
        const globalVersionParsed = {
            major: +globalVersionMatch[1],
            minor: +globalVersionMatch[2],
            patch: +globalVersionMatch[3],
            prerelease: globalVersionMatch[4]
        };
        if (globalVersionParsed.prerelease != null) return _reject(globalVersion);
        if (ownVersionParsed.major !== globalVersionParsed.major) return _reject(globalVersion);
        if (ownVersionParsed.major === 0) {
            if (ownVersionParsed.minor === globalVersionParsed.minor && ownVersionParsed.patch <= globalVersionParsed.patch) return _accept(globalVersion);
            return _reject(globalVersion);
        }
        if (ownVersionParsed.minor <= globalVersionParsed.minor) return _accept(globalVersion);
        return _reject(globalVersion);
    };
}
var $281a441cdcb2cf36$var$re2, $281a441cdcb2cf36$var$isCompatible;
var $281a441cdcb2cf36$var$init_semver = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api/build/esm/internal/semver.js" () {
        $281a441cdcb2cf36$var$init_version();
        $281a441cdcb2cf36$var$re2 = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
        $281a441cdcb2cf36$var$isCompatible = $281a441cdcb2cf36$var$_makeCompatibilityCheck($281a441cdcb2cf36$var$VERSION);
    }
});
// ../node_modules/@opentelemetry/api/build/esm/internal/global-utils.js
function $281a441cdcb2cf36$var$registerGlobal(type, instance, diag3, allowOverride = false) {
    var _a2;
    const api = $281a441cdcb2cf36$var$_global[$281a441cdcb2cf36$var$GLOBAL_OPENTELEMETRY_API_KEY] = (_a2 = $281a441cdcb2cf36$var$_global[$281a441cdcb2cf36$var$GLOBAL_OPENTELEMETRY_API_KEY]) !== null && _a2 !== void 0 ? _a2 : {
        version: $281a441cdcb2cf36$var$VERSION
    };
    if (!allowOverride && api[type]) {
        const err = new Error(`@opentelemetry/api: Attempted duplicate registration of API: ${type}`);
        diag3.error(err.stack || err.message);
        return false;
    }
    if (api.version !== $281a441cdcb2cf36$var$VERSION) {
        const err = new Error(`@opentelemetry/api: Registration of version v${api.version} for ${type} does not match previously registered API v${$281a441cdcb2cf36$var$VERSION}`);
        diag3.error(err.stack || err.message);
        return false;
    }
    api[type] = instance;
    diag3.debug(`@opentelemetry/api: Registered a global for ${type} v${$281a441cdcb2cf36$var$VERSION}.`);
    return true;
}
function $281a441cdcb2cf36$var$getGlobal(type) {
    var _a2, _b;
    const globalVersion = (_a2 = $281a441cdcb2cf36$var$_global[$281a441cdcb2cf36$var$GLOBAL_OPENTELEMETRY_API_KEY]) === null || _a2 === void 0 ? void 0 : _a2.version;
    if (!globalVersion || !$281a441cdcb2cf36$var$isCompatible(globalVersion)) return;
    return (_b = $281a441cdcb2cf36$var$_global[$281a441cdcb2cf36$var$GLOBAL_OPENTELEMETRY_API_KEY]) === null || _b === void 0 ? void 0 : _b[type];
}
function $281a441cdcb2cf36$var$unregisterGlobal(type, diag3) {
    diag3.debug(`@opentelemetry/api: Unregistering a global for ${type} v${$281a441cdcb2cf36$var$VERSION}.`);
    const api = $281a441cdcb2cf36$var$_global[$281a441cdcb2cf36$var$GLOBAL_OPENTELEMETRY_API_KEY];
    if (api) delete api[type];
}
var $281a441cdcb2cf36$var$major, $281a441cdcb2cf36$var$GLOBAL_OPENTELEMETRY_API_KEY, $281a441cdcb2cf36$var$_global;
var $281a441cdcb2cf36$var$init_global_utils = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api/build/esm/internal/global-utils.js" () {
        $281a441cdcb2cf36$var$init_version();
        $281a441cdcb2cf36$var$init_semver();
        $281a441cdcb2cf36$var$major = $281a441cdcb2cf36$var$VERSION.split(".")[0];
        $281a441cdcb2cf36$var$GLOBAL_OPENTELEMETRY_API_KEY = /* @__PURE__ */ Symbol.for(`opentelemetry.js.api.${$281a441cdcb2cf36$var$major}`);
        $281a441cdcb2cf36$var$_global = typeof globalThis === "object" ? globalThis : typeof self === "object" ? self : typeof window === "object" ? window : typeof $parcel$global === "object" ? $parcel$global : {};
    }
});
// ../node_modules/@opentelemetry/api/build/esm/diag/ComponentLogger.js
function $281a441cdcb2cf36$var$logProxy(funcName, namespace, args2) {
    const logger3 = $281a441cdcb2cf36$var$getGlobal("diag");
    if (!logger3) return;
    return logger3[funcName](namespace, ...args2);
}
var $281a441cdcb2cf36$var$DiagComponentLogger;
var $281a441cdcb2cf36$var$init_ComponentLogger = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api/build/esm/diag/ComponentLogger.js" () {
        $281a441cdcb2cf36$var$init_global_utils();
        $281a441cdcb2cf36$var$DiagComponentLogger = class {
            constructor(props){
                this._namespace = props.namespace || "DiagComponentLogger";
            }
            debug(...args2) {
                return $281a441cdcb2cf36$var$logProxy("debug", this._namespace, args2);
            }
            error(...args2) {
                return $281a441cdcb2cf36$var$logProxy("error", this._namespace, args2);
            }
            info(...args2) {
                return $281a441cdcb2cf36$var$logProxy("info", this._namespace, args2);
            }
            warn(...args2) {
                return $281a441cdcb2cf36$var$logProxy("warn", this._namespace, args2);
            }
            verbose(...args2) {
                return $281a441cdcb2cf36$var$logProxy("verbose", this._namespace, args2);
            }
        };
    }
});
// ../node_modules/@opentelemetry/api/build/esm/diag/types.js
var $281a441cdcb2cf36$var$DiagLogLevel;
var $281a441cdcb2cf36$var$init_types = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api/build/esm/diag/types.js" () {
        (function(DiagLogLevel2) {
            DiagLogLevel2[DiagLogLevel2["NONE"] = 0] = "NONE";
            DiagLogLevel2[DiagLogLevel2["ERROR"] = 30] = "ERROR";
            DiagLogLevel2[DiagLogLevel2["WARN"] = 50] = "WARN";
            DiagLogLevel2[DiagLogLevel2["INFO"] = 60] = "INFO";
            DiagLogLevel2[DiagLogLevel2["DEBUG"] = 70] = "DEBUG";
            DiagLogLevel2[DiagLogLevel2["VERBOSE"] = 80] = "VERBOSE";
            DiagLogLevel2[DiagLogLevel2["ALL"] = 9999] = "ALL";
        })($281a441cdcb2cf36$var$DiagLogLevel || ($281a441cdcb2cf36$var$DiagLogLevel = {}));
    }
});
// ../node_modules/@opentelemetry/api/build/esm/diag/internal/logLevelLogger.js
function $281a441cdcb2cf36$var$createLogLevelDiagLogger(maxLevel, logger3) {
    if (maxLevel < $281a441cdcb2cf36$var$DiagLogLevel.NONE) maxLevel = $281a441cdcb2cf36$var$DiagLogLevel.NONE;
    else if (maxLevel > $281a441cdcb2cf36$var$DiagLogLevel.ALL) maxLevel = $281a441cdcb2cf36$var$DiagLogLevel.ALL;
    logger3 = logger3 || {};
    function _filterFunc(funcName, theLevel) {
        const theFunc = logger3[funcName];
        if (typeof theFunc === "function" && maxLevel >= theLevel) return theFunc.bind(logger3);
        return function() {};
    }
    return {
        error: _filterFunc("error", $281a441cdcb2cf36$var$DiagLogLevel.ERROR),
        warn: _filterFunc("warn", $281a441cdcb2cf36$var$DiagLogLevel.WARN),
        info: _filterFunc("info", $281a441cdcb2cf36$var$DiagLogLevel.INFO),
        debug: _filterFunc("debug", $281a441cdcb2cf36$var$DiagLogLevel.DEBUG),
        verbose: _filterFunc("verbose", $281a441cdcb2cf36$var$DiagLogLevel.VERBOSE)
    };
}
var $281a441cdcb2cf36$var$init_logLevelLogger = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api/build/esm/diag/internal/logLevelLogger.js" () {
        $281a441cdcb2cf36$var$init_types();
    }
});
// ../node_modules/@opentelemetry/api/build/esm/api/diag.js
var $281a441cdcb2cf36$var$API_NAME, $281a441cdcb2cf36$var$DiagAPI;
var $281a441cdcb2cf36$var$init_diag = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api/build/esm/api/diag.js" () {
        $281a441cdcb2cf36$var$init_ComponentLogger();
        $281a441cdcb2cf36$var$init_logLevelLogger();
        $281a441cdcb2cf36$var$init_types();
        $281a441cdcb2cf36$var$init_global_utils();
        $281a441cdcb2cf36$var$API_NAME = "diag";
        $281a441cdcb2cf36$var$DiagAPI = class _DiagAPI {
            /** Get the singleton instance of the DiagAPI API */ static instance() {
                if (!this._instance) this._instance = new _DiagAPI();
                return this._instance;
            }
            /**
       * Private internal constructor
       * @private
       */ constructor(){
                function _logProxy(funcName) {
                    return function(...args2) {
                        const logger3 = $281a441cdcb2cf36$var$getGlobal("diag");
                        if (!logger3) return;
                        return logger3[funcName](...args2);
                    };
                }
                const self2 = this;
                const setLogger = (logger3, optionsOrLogLevel = {
                    logLevel: $281a441cdcb2cf36$var$DiagLogLevel.INFO
                })=>{
                    var _a2, _b, _c;
                    if (logger3 === self2) {
                        const err = new Error("Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation");
                        self2.error((_a2 = err.stack) !== null && _a2 !== void 0 ? _a2 : err.message);
                        return false;
                    }
                    if (typeof optionsOrLogLevel === "number") optionsOrLogLevel = {
                        logLevel: optionsOrLogLevel
                    };
                    const oldLogger = $281a441cdcb2cf36$var$getGlobal("diag");
                    const newLogger = $281a441cdcb2cf36$var$createLogLevelDiagLogger((_b = optionsOrLogLevel.logLevel) !== null && _b !== void 0 ? _b : $281a441cdcb2cf36$var$DiagLogLevel.INFO, logger3);
                    if (oldLogger && !optionsOrLogLevel.suppressOverrideMessage) {
                        const stack = (_c = new Error().stack) !== null && _c !== void 0 ? _c : "<failed to generate stacktrace>";
                        oldLogger.warn(`Current logger will be overwritten from ${stack}`);
                        newLogger.warn(`Current logger will overwrite one already registered from ${stack}`);
                    }
                    return $281a441cdcb2cf36$var$registerGlobal("diag", newLogger, self2, true);
                };
                self2.setLogger = setLogger;
                self2.disable = ()=>{
                    $281a441cdcb2cf36$var$unregisterGlobal($281a441cdcb2cf36$var$API_NAME, self2);
                };
                self2.createComponentLogger = (options)=>{
                    return new $281a441cdcb2cf36$var$DiagComponentLogger(options);
                };
                self2.verbose = _logProxy("verbose");
                self2.debug = _logProxy("debug");
                self2.info = _logProxy("info");
                self2.warn = _logProxy("warn");
                self2.error = _logProxy("error");
            }
        };
    }
});
// ../node_modules/@opentelemetry/api/build/esm/baggage/internal/baggage-impl.js
var $281a441cdcb2cf36$var$BaggageImpl;
var $281a441cdcb2cf36$var$init_baggage_impl = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api/build/esm/baggage/internal/baggage-impl.js" () {
        $281a441cdcb2cf36$var$BaggageImpl = class _BaggageImpl {
            constructor(entries){
                this._entries = entries ? new Map(entries) : /* @__PURE__ */ new Map();
            }
            getEntry(key) {
                const entry = this._entries.get(key);
                if (!entry) return void 0;
                return Object.assign({}, entry);
            }
            getAllEntries() {
                return Array.from(this._entries.entries());
            }
            setEntry(key, entry) {
                const newBaggage = new _BaggageImpl(this._entries);
                newBaggage._entries.set(key, entry);
                return newBaggage;
            }
            removeEntry(key) {
                const newBaggage = new _BaggageImpl(this._entries);
                newBaggage._entries.delete(key);
                return newBaggage;
            }
            removeEntries(...keys2) {
                const newBaggage = new _BaggageImpl(this._entries);
                for (const key of keys2)newBaggage._entries.delete(key);
                return newBaggage;
            }
            clear() {
                return new _BaggageImpl();
            }
        };
    }
});
// ../node_modules/@opentelemetry/api/build/esm/baggage/internal/symbol.js
var $281a441cdcb2cf36$var$baggageEntryMetadataSymbol;
var $281a441cdcb2cf36$var$init_symbol2 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api/build/esm/baggage/internal/symbol.js" () {
        $281a441cdcb2cf36$var$baggageEntryMetadataSymbol = /* @__PURE__ */ Symbol("BaggageEntryMetadata");
    }
});
// ../node_modules/@opentelemetry/api/build/esm/baggage/utils.js
function $281a441cdcb2cf36$var$createBaggage(entries = {}) {
    return new $281a441cdcb2cf36$var$BaggageImpl(new Map(Object.entries(entries)));
}
function $281a441cdcb2cf36$var$baggageEntryMetadataFromString(str) {
    if (typeof str !== "string") {
        $281a441cdcb2cf36$var$diag.error(`Cannot create baggage metadata from unknown type: ${typeof str}`);
        str = "";
    }
    return {
        __TYPE__: $281a441cdcb2cf36$var$baggageEntryMetadataSymbol,
        toString () {
            return str;
        }
    };
}
var $281a441cdcb2cf36$var$diag;
var $281a441cdcb2cf36$var$init_utils = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api/build/esm/baggage/utils.js" () {
        $281a441cdcb2cf36$var$init_diag();
        $281a441cdcb2cf36$var$init_baggage_impl();
        $281a441cdcb2cf36$var$init_symbol2();
        $281a441cdcb2cf36$var$diag = $281a441cdcb2cf36$var$DiagAPI.instance();
    }
});
// ../node_modules/@opentelemetry/api/build/esm/context/context.js
function $281a441cdcb2cf36$var$createContextKey(description) {
    return Symbol.for(description);
}
var $281a441cdcb2cf36$var$BaseContext, $281a441cdcb2cf36$var$ROOT_CONTEXT;
var $281a441cdcb2cf36$var$init_context = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api/build/esm/context/context.js" () {
        $281a441cdcb2cf36$var$BaseContext = class _BaseContext {
            /**
       * Construct a new context which inherits values from an optional parent context.
       *
       * @param parentContext a context from which to inherit values
       */ constructor(parentContext){
                const self2 = this;
                self2._currentContext = parentContext ? new Map(parentContext) : /* @__PURE__ */ new Map();
                self2.getValue = (key)=>self2._currentContext.get(key);
                self2.setValue = (key, value2)=>{
                    const context2 = new _BaseContext(self2._currentContext);
                    context2._currentContext.set(key, value2);
                    return context2;
                };
                self2.deleteValue = (key)=>{
                    const context2 = new _BaseContext(self2._currentContext);
                    context2._currentContext.delete(key);
                    return context2;
                };
            }
        };
        $281a441cdcb2cf36$var$ROOT_CONTEXT = new $281a441cdcb2cf36$var$BaseContext();
    }
});
// ../node_modules/@opentelemetry/api/build/esm/diag/consoleLogger.js
var $281a441cdcb2cf36$var$consoleMap, $281a441cdcb2cf36$var$_originalConsoleMethods, $281a441cdcb2cf36$var$DiagConsoleLogger;
var $281a441cdcb2cf36$var$init_consoleLogger = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api/build/esm/diag/consoleLogger.js" () {
        $281a441cdcb2cf36$var$consoleMap = [
            {
                n: "error",
                c: "error"
            },
            {
                n: "warn",
                c: "warn"
            },
            {
                n: "info",
                c: "info"
            },
            {
                n: "debug",
                c: "debug"
            },
            {
                n: "verbose",
                c: "trace"
            }
        ];
        $281a441cdcb2cf36$var$_originalConsoleMethods = {};
        if (typeof console !== "undefined") {
            const keys2 = [
                "error",
                "warn",
                "info",
                "debug",
                "trace",
                "log"
            ];
            for (const key of keys2)if (typeof console[key] === "function") $281a441cdcb2cf36$var$_originalConsoleMethods[key] = console[key];
        }
        $281a441cdcb2cf36$var$DiagConsoleLogger = class {
            constructor(){
                function _consoleFunc(funcName) {
                    return function(...args2) {
                        let theFunc = $281a441cdcb2cf36$var$_originalConsoleMethods[funcName];
                        if (typeof theFunc !== "function") theFunc = $281a441cdcb2cf36$var$_originalConsoleMethods["log"];
                        if (typeof theFunc !== "function" && console) {
                            theFunc = console[funcName];
                            if (typeof theFunc !== "function") theFunc = console.log;
                        }
                        if (typeof theFunc === "function") return theFunc.apply(console, args2);
                    };
                }
                for(let i3 = 0; i3 < $281a441cdcb2cf36$var$consoleMap.length; i3++)this[$281a441cdcb2cf36$var$consoleMap[i3].n] = _consoleFunc($281a441cdcb2cf36$var$consoleMap[i3].c);
            }
        };
    }
});
// ../node_modules/@opentelemetry/api/build/esm/metrics/NoopMeter.js
function $281a441cdcb2cf36$var$createNoopMeter() {
    return $281a441cdcb2cf36$var$NOOP_METER;
}
var $281a441cdcb2cf36$var$NoopMeter, $281a441cdcb2cf36$var$NoopMetric, $281a441cdcb2cf36$var$NoopCounterMetric, $281a441cdcb2cf36$var$NoopUpDownCounterMetric, $281a441cdcb2cf36$var$NoopGaugeMetric, $281a441cdcb2cf36$var$NoopHistogramMetric, $281a441cdcb2cf36$var$NoopObservableMetric, $281a441cdcb2cf36$var$NoopObservableCounterMetric, $281a441cdcb2cf36$var$NoopObservableGaugeMetric, $281a441cdcb2cf36$var$NoopObservableUpDownCounterMetric, $281a441cdcb2cf36$var$NOOP_METER, $281a441cdcb2cf36$var$NOOP_COUNTER_METRIC, $281a441cdcb2cf36$var$NOOP_GAUGE_METRIC, $281a441cdcb2cf36$var$NOOP_HISTOGRAM_METRIC, $281a441cdcb2cf36$var$NOOP_UP_DOWN_COUNTER_METRIC, $281a441cdcb2cf36$var$NOOP_OBSERVABLE_COUNTER_METRIC, $281a441cdcb2cf36$var$NOOP_OBSERVABLE_GAUGE_METRIC, $281a441cdcb2cf36$var$NOOP_OBSERVABLE_UP_DOWN_COUNTER_METRIC;
var $281a441cdcb2cf36$var$init_NoopMeter = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api/build/esm/metrics/NoopMeter.js" () {
        $281a441cdcb2cf36$var$NoopMeter = class {
            constructor(){}
            /**
       * @see {@link Meter.createGauge}
       */ createGauge(_name, _options) {
                return $281a441cdcb2cf36$var$NOOP_GAUGE_METRIC;
            }
            /**
       * @see {@link Meter.createHistogram}
       */ createHistogram(_name, _options) {
                return $281a441cdcb2cf36$var$NOOP_HISTOGRAM_METRIC;
            }
            /**
       * @see {@link Meter.createCounter}
       */ createCounter(_name, _options) {
                return $281a441cdcb2cf36$var$NOOP_COUNTER_METRIC;
            }
            /**
       * @see {@link Meter.createUpDownCounter}
       */ createUpDownCounter(_name, _options) {
                return $281a441cdcb2cf36$var$NOOP_UP_DOWN_COUNTER_METRIC;
            }
            /**
       * @see {@link Meter.createObservableGauge}
       */ createObservableGauge(_name, _options) {
                return $281a441cdcb2cf36$var$NOOP_OBSERVABLE_GAUGE_METRIC;
            }
            /**
       * @see {@link Meter.createObservableCounter}
       */ createObservableCounter(_name, _options) {
                return $281a441cdcb2cf36$var$NOOP_OBSERVABLE_COUNTER_METRIC;
            }
            /**
       * @see {@link Meter.createObservableUpDownCounter}
       */ createObservableUpDownCounter(_name, _options) {
                return $281a441cdcb2cf36$var$NOOP_OBSERVABLE_UP_DOWN_COUNTER_METRIC;
            }
            /**
       * @see {@link Meter.addBatchObservableCallback}
       */ addBatchObservableCallback(_callback, _observables) {}
            /**
       * @see {@link Meter.removeBatchObservableCallback}
       */ removeBatchObservableCallback(_callback) {}
        };
        $281a441cdcb2cf36$var$NoopMetric = class {
        };
        $281a441cdcb2cf36$var$NoopCounterMetric = class extends $281a441cdcb2cf36$var$NoopMetric {
            add(_value, _attributes) {}
        };
        $281a441cdcb2cf36$var$NoopUpDownCounterMetric = class extends $281a441cdcb2cf36$var$NoopMetric {
            add(_value, _attributes) {}
        };
        $281a441cdcb2cf36$var$NoopGaugeMetric = class extends $281a441cdcb2cf36$var$NoopMetric {
            record(_value, _attributes) {}
        };
        $281a441cdcb2cf36$var$NoopHistogramMetric = class extends $281a441cdcb2cf36$var$NoopMetric {
            record(_value, _attributes) {}
        };
        $281a441cdcb2cf36$var$NoopObservableMetric = class {
            addCallback(_callback) {}
            removeCallback(_callback) {}
        };
        $281a441cdcb2cf36$var$NoopObservableCounterMetric = class extends $281a441cdcb2cf36$var$NoopObservableMetric {
        };
        $281a441cdcb2cf36$var$NoopObservableGaugeMetric = class extends $281a441cdcb2cf36$var$NoopObservableMetric {
        };
        $281a441cdcb2cf36$var$NoopObservableUpDownCounterMetric = class extends $281a441cdcb2cf36$var$NoopObservableMetric {
        };
        $281a441cdcb2cf36$var$NOOP_METER = new $281a441cdcb2cf36$var$NoopMeter();
        $281a441cdcb2cf36$var$NOOP_COUNTER_METRIC = new $281a441cdcb2cf36$var$NoopCounterMetric();
        $281a441cdcb2cf36$var$NOOP_GAUGE_METRIC = new $281a441cdcb2cf36$var$NoopGaugeMetric();
        $281a441cdcb2cf36$var$NOOP_HISTOGRAM_METRIC = new $281a441cdcb2cf36$var$NoopHistogramMetric();
        $281a441cdcb2cf36$var$NOOP_UP_DOWN_COUNTER_METRIC = new $281a441cdcb2cf36$var$NoopUpDownCounterMetric();
        $281a441cdcb2cf36$var$NOOP_OBSERVABLE_COUNTER_METRIC = new $281a441cdcb2cf36$var$NoopObservableCounterMetric();
        $281a441cdcb2cf36$var$NOOP_OBSERVABLE_GAUGE_METRIC = new $281a441cdcb2cf36$var$NoopObservableGaugeMetric();
        $281a441cdcb2cf36$var$NOOP_OBSERVABLE_UP_DOWN_COUNTER_METRIC = new $281a441cdcb2cf36$var$NoopObservableUpDownCounterMetric();
    }
});
// ../node_modules/@opentelemetry/api/build/esm/metrics/Metric.js
var $281a441cdcb2cf36$var$ValueType;
var $281a441cdcb2cf36$var$init_Metric = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api/build/esm/metrics/Metric.js" () {
        (function(ValueType2) {
            ValueType2[ValueType2["INT"] = 0] = "INT";
            ValueType2[ValueType2["DOUBLE"] = 1] = "DOUBLE";
        })($281a441cdcb2cf36$var$ValueType || ($281a441cdcb2cf36$var$ValueType = {}));
    }
});
// ../node_modules/@opentelemetry/api/build/esm/propagation/TextMapPropagator.js
var $281a441cdcb2cf36$var$defaultTextMapGetter, $281a441cdcb2cf36$var$defaultTextMapSetter;
var $281a441cdcb2cf36$var$init_TextMapPropagator = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api/build/esm/propagation/TextMapPropagator.js" () {
        $281a441cdcb2cf36$var$defaultTextMapGetter = {
            get (carrier, key) {
                if (carrier == null) return void 0;
                return carrier[key];
            },
            keys (carrier) {
                if (carrier == null) return [];
                return Object.keys(carrier);
            }
        };
        $281a441cdcb2cf36$var$defaultTextMapSetter = {
            set (carrier, key, value2) {
                if (carrier == null) return;
                carrier[key] = value2;
            }
        };
    }
});
// ../node_modules/@opentelemetry/api/build/esm/context/NoopContextManager.js
var $281a441cdcb2cf36$var$NoopContextManager;
var $281a441cdcb2cf36$var$init_NoopContextManager = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api/build/esm/context/NoopContextManager.js" () {
        $281a441cdcb2cf36$var$init_context();
        $281a441cdcb2cf36$var$NoopContextManager = class {
            active() {
                return $281a441cdcb2cf36$var$ROOT_CONTEXT;
            }
            with(_context, fn, thisArg, ...args2) {
                return fn.call(thisArg, ...args2);
            }
            bind(_context, target) {
                return target;
            }
            enable() {
                return this;
            }
            disable() {
                return this;
            }
        };
    }
});
// ../node_modules/@opentelemetry/api/build/esm/api/context.js
var $281a441cdcb2cf36$var$API_NAME2, $281a441cdcb2cf36$var$NOOP_CONTEXT_MANAGER, $281a441cdcb2cf36$var$ContextAPI;
var $281a441cdcb2cf36$var$init_context2 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api/build/esm/api/context.js" () {
        $281a441cdcb2cf36$var$init_NoopContextManager();
        $281a441cdcb2cf36$var$init_global_utils();
        $281a441cdcb2cf36$var$init_diag();
        $281a441cdcb2cf36$var$API_NAME2 = "context";
        $281a441cdcb2cf36$var$NOOP_CONTEXT_MANAGER = new $281a441cdcb2cf36$var$NoopContextManager();
        $281a441cdcb2cf36$var$ContextAPI = class _ContextAPI {
            /** Empty private constructor prevents end users from constructing a new instance of the API */ constructor(){}
            /** Get the singleton instance of the Context API */ static getInstance() {
                if (!this._instance) this._instance = new _ContextAPI();
                return this._instance;
            }
            /**
       * Set the current context manager.
       *
       * @returns true if the context manager was successfully registered, else false
       */ setGlobalContextManager(contextManager) {
                return $281a441cdcb2cf36$var$registerGlobal($281a441cdcb2cf36$var$API_NAME2, contextManager, $281a441cdcb2cf36$var$DiagAPI.instance());
            }
            /**
       * Get the currently active context
       */ active() {
                return this._getContextManager().active();
            }
            /**
       * Execute a function with an active context
       *
       * @param context context to be active during function execution
       * @param fn function to execute in a context
       * @param thisArg optional receiver to be used for calling fn
       * @param args optional arguments forwarded to fn
       */ with(context2, fn, thisArg, ...args2) {
                return this._getContextManager().with(context2, fn, thisArg, ...args2);
            }
            /**
       * Bind a context to a target function or event emitter
       *
       * @param context context to bind to the event emitter or function. Defaults to the currently active context
       * @param target function or event emitter to bind
       */ bind(context2, target) {
                return this._getContextManager().bind(context2, target);
            }
            _getContextManager() {
                return $281a441cdcb2cf36$var$getGlobal($281a441cdcb2cf36$var$API_NAME2) || $281a441cdcb2cf36$var$NOOP_CONTEXT_MANAGER;
            }
            /** Disable and remove the global context manager */ disable() {
                this._getContextManager().disable();
                $281a441cdcb2cf36$var$unregisterGlobal($281a441cdcb2cf36$var$API_NAME2, $281a441cdcb2cf36$var$DiagAPI.instance());
            }
        };
    }
});
// ../node_modules/@opentelemetry/api/build/esm/trace/trace_flags.js
var $281a441cdcb2cf36$var$TraceFlags;
var $281a441cdcb2cf36$var$init_trace_flags = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api/build/esm/trace/trace_flags.js" () {
        (function(TraceFlags2) {
            TraceFlags2[TraceFlags2["NONE"] = 0] = "NONE";
            TraceFlags2[TraceFlags2["SAMPLED"] = 1] = "SAMPLED";
        })($281a441cdcb2cf36$var$TraceFlags || ($281a441cdcb2cf36$var$TraceFlags = {}));
    }
});
// ../node_modules/@opentelemetry/api/build/esm/trace/invalid-span-constants.js
var $281a441cdcb2cf36$var$INVALID_SPANID, $281a441cdcb2cf36$var$INVALID_TRACEID, $281a441cdcb2cf36$var$INVALID_SPAN_CONTEXT;
var $281a441cdcb2cf36$var$init_invalid_span_constants = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api/build/esm/trace/invalid-span-constants.js" () {
        $281a441cdcb2cf36$var$init_trace_flags();
        $281a441cdcb2cf36$var$INVALID_SPANID = "0000000000000000";
        $281a441cdcb2cf36$var$INVALID_TRACEID = "00000000000000000000000000000000";
        $281a441cdcb2cf36$var$INVALID_SPAN_CONTEXT = {
            traceId: $281a441cdcb2cf36$var$INVALID_TRACEID,
            spanId: $281a441cdcb2cf36$var$INVALID_SPANID,
            traceFlags: $281a441cdcb2cf36$var$TraceFlags.NONE
        };
    }
});
// ../node_modules/@opentelemetry/api/build/esm/trace/NonRecordingSpan.js
var $281a441cdcb2cf36$var$NonRecordingSpan;
var $281a441cdcb2cf36$var$init_NonRecordingSpan = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api/build/esm/trace/NonRecordingSpan.js" () {
        $281a441cdcb2cf36$var$init_invalid_span_constants();
        $281a441cdcb2cf36$var$NonRecordingSpan = class {
            constructor(spanContext = $281a441cdcb2cf36$var$INVALID_SPAN_CONTEXT){
                this._spanContext = spanContext;
            }
            // Returns a SpanContext.
            spanContext() {
                return this._spanContext;
            }
            // By default does nothing
            setAttribute(_key, _value) {
                return this;
            }
            // By default does nothing
            setAttributes(_attributes) {
                return this;
            }
            // By default does nothing
            addEvent(_name, _attributes) {
                return this;
            }
            addLink(_link) {
                return this;
            }
            addLinks(_links) {
                return this;
            }
            // By default does nothing
            setStatus(_status) {
                return this;
            }
            // By default does nothing
            updateName(_name) {
                return this;
            }
            // By default does nothing
            end(_endTime) {}
            // isRecording always returns false for NonRecordingSpan.
            isRecording() {
                return false;
            }
            // By default does nothing
            recordException(_exception, _time) {}
        };
    }
});
// ../node_modules/@opentelemetry/api/build/esm/trace/context-utils.js
function $281a441cdcb2cf36$var$getSpan(context2) {
    return context2.getValue($281a441cdcb2cf36$var$SPAN_KEY) || void 0;
}
function $281a441cdcb2cf36$var$getActiveSpan() {
    return $281a441cdcb2cf36$var$getSpan($281a441cdcb2cf36$var$ContextAPI.getInstance().active());
}
function $281a441cdcb2cf36$var$setSpan(context2, span) {
    return context2.setValue($281a441cdcb2cf36$var$SPAN_KEY, span);
}
function $281a441cdcb2cf36$var$deleteSpan(context2) {
    return context2.deleteValue($281a441cdcb2cf36$var$SPAN_KEY);
}
function $281a441cdcb2cf36$var$setSpanContext(context2, spanContext) {
    return $281a441cdcb2cf36$var$setSpan(context2, new $281a441cdcb2cf36$var$NonRecordingSpan(spanContext));
}
function $281a441cdcb2cf36$var$getSpanContext(context2) {
    var _a2;
    return (_a2 = $281a441cdcb2cf36$var$getSpan(context2)) === null || _a2 === void 0 ? void 0 : _a2.spanContext();
}
var $281a441cdcb2cf36$var$SPAN_KEY;
var $281a441cdcb2cf36$var$init_context_utils = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api/build/esm/trace/context-utils.js" () {
        $281a441cdcb2cf36$var$init_context();
        $281a441cdcb2cf36$var$init_NonRecordingSpan();
        $281a441cdcb2cf36$var$init_context2();
        $281a441cdcb2cf36$var$SPAN_KEY = $281a441cdcb2cf36$var$createContextKey("OpenTelemetry Context Key SPAN");
    }
});
// ../node_modules/@opentelemetry/api/build/esm/trace/spancontext-utils.js
function $281a441cdcb2cf36$var$isValidHex(id2, length2) {
    if (typeof id2 !== "string" || id2.length !== length2) return false;
    let r3 = 0;
    for(let i3 = 0; i3 < id2.length; i3 += 4)r3 += ($281a441cdcb2cf36$var$isHex[id2.charCodeAt(i3)] | 0) + ($281a441cdcb2cf36$var$isHex[id2.charCodeAt(i3 + 1)] | 0) + ($281a441cdcb2cf36$var$isHex[id2.charCodeAt(i3 + 2)] | 0) + ($281a441cdcb2cf36$var$isHex[id2.charCodeAt(i3 + 3)] | 0);
    return r3 === length2;
}
function $281a441cdcb2cf36$var$isValidTraceId(traceId) {
    return $281a441cdcb2cf36$var$isValidHex(traceId, 32) && traceId !== $281a441cdcb2cf36$var$INVALID_TRACEID;
}
function $281a441cdcb2cf36$var$isValidSpanId(spanId) {
    return $281a441cdcb2cf36$var$isValidHex(spanId, 16) && spanId !== $281a441cdcb2cf36$var$INVALID_SPANID;
}
function $281a441cdcb2cf36$var$isSpanContextValid(spanContext) {
    return $281a441cdcb2cf36$var$isValidTraceId(spanContext.traceId) && $281a441cdcb2cf36$var$isValidSpanId(spanContext.spanId);
}
function $281a441cdcb2cf36$var$wrapSpanContext(spanContext) {
    return new $281a441cdcb2cf36$var$NonRecordingSpan(spanContext);
}
var $281a441cdcb2cf36$var$isHex;
var $281a441cdcb2cf36$var$init_spancontext_utils = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api/build/esm/trace/spancontext-utils.js" () {
        $281a441cdcb2cf36$var$init_invalid_span_constants();
        $281a441cdcb2cf36$var$init_NonRecordingSpan();
        $281a441cdcb2cf36$var$isHex = new Uint8Array([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            1,
            1,
            1,
            1,
            1,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            1,
            1,
            1,
            1,
            1
        ]);
    }
});
// ../node_modules/@opentelemetry/api/build/esm/trace/NoopTracer.js
function $281a441cdcb2cf36$var$isSpanContext(spanContext) {
    return spanContext !== null && typeof spanContext === "object" && "spanId" in spanContext && typeof spanContext["spanId"] === "string" && "traceId" in spanContext && typeof spanContext["traceId"] === "string" && "traceFlags" in spanContext && typeof spanContext["traceFlags"] === "number";
}
var $281a441cdcb2cf36$var$contextApi, $281a441cdcb2cf36$var$NoopTracer;
var $281a441cdcb2cf36$var$init_NoopTracer = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api/build/esm/trace/NoopTracer.js" () {
        $281a441cdcb2cf36$var$init_context2();
        $281a441cdcb2cf36$var$init_context_utils();
        $281a441cdcb2cf36$var$init_NonRecordingSpan();
        $281a441cdcb2cf36$var$init_spancontext_utils();
        $281a441cdcb2cf36$var$contextApi = $281a441cdcb2cf36$var$ContextAPI.getInstance();
        $281a441cdcb2cf36$var$NoopTracer = class {
            // startSpan starts a noop span.
            startSpan(name, options, context2 = $281a441cdcb2cf36$var$contextApi.active()) {
                const root = Boolean(options === null || options === void 0 ? void 0 : options.root);
                if (root) return new $281a441cdcb2cf36$var$NonRecordingSpan();
                const parentFromContext = context2 && $281a441cdcb2cf36$var$getSpanContext(context2);
                if ($281a441cdcb2cf36$var$isSpanContext(parentFromContext) && $281a441cdcb2cf36$var$isSpanContextValid(parentFromContext)) return new $281a441cdcb2cf36$var$NonRecordingSpan(parentFromContext);
                else return new $281a441cdcb2cf36$var$NonRecordingSpan();
            }
            startActiveSpan(name, arg2, arg3, arg4) {
                let opts;
                let ctx;
                let fn;
                if (arguments.length < 2) return;
                else if (arguments.length === 2) fn = arg2;
                else if (arguments.length === 3) {
                    opts = arg2;
                    fn = arg3;
                } else {
                    opts = arg2;
                    ctx = arg3;
                    fn = arg4;
                }
                const parentContext = ctx !== null && ctx !== void 0 ? ctx : $281a441cdcb2cf36$var$contextApi.active();
                const span = this.startSpan(name, opts, parentContext);
                const contextWithSpanSet = $281a441cdcb2cf36$var$setSpan(parentContext, span);
                return $281a441cdcb2cf36$var$contextApi.with(contextWithSpanSet, fn, void 0, span);
            }
        };
    }
});
// ../node_modules/@opentelemetry/api/build/esm/trace/ProxyTracer.js
var $281a441cdcb2cf36$var$NOOP_TRACER, $281a441cdcb2cf36$var$ProxyTracer;
var $281a441cdcb2cf36$var$init_ProxyTracer = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api/build/esm/trace/ProxyTracer.js" () {
        $281a441cdcb2cf36$var$init_NoopTracer();
        $281a441cdcb2cf36$var$NOOP_TRACER = new $281a441cdcb2cf36$var$NoopTracer();
        $281a441cdcb2cf36$var$ProxyTracer = class {
            constructor(provider, name, version6, options){
                this._provider = provider;
                this.name = name;
                this.version = version6;
                this.options = options;
            }
            startSpan(name, options, context2) {
                return this._getTracer().startSpan(name, options, context2);
            }
            startActiveSpan(_name, _options, _context, _fn) {
                const tracer = this._getTracer();
                return Reflect.apply(tracer.startActiveSpan, tracer, arguments);
            }
            /**
       * Try to get a tracer from the proxy tracer provider.
       * If the proxy tracer provider has no delegate, return a noop tracer.
       */ _getTracer() {
                if (this._delegate) return this._delegate;
                const tracer = this._provider.getDelegateTracer(this.name, this.version, this.options);
                if (!tracer) return $281a441cdcb2cf36$var$NOOP_TRACER;
                this._delegate = tracer;
                return this._delegate;
            }
        };
    }
});
// ../node_modules/@opentelemetry/api/build/esm/trace/NoopTracerProvider.js
var $281a441cdcb2cf36$var$NoopTracerProvider;
var $281a441cdcb2cf36$var$init_NoopTracerProvider = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api/build/esm/trace/NoopTracerProvider.js" () {
        $281a441cdcb2cf36$var$init_NoopTracer();
        $281a441cdcb2cf36$var$NoopTracerProvider = class {
            getTracer(_name, _version, _options) {
                return new $281a441cdcb2cf36$var$NoopTracer();
            }
        };
    }
});
// ../node_modules/@opentelemetry/api/build/esm/trace/ProxyTracerProvider.js
var $281a441cdcb2cf36$var$NOOP_TRACER_PROVIDER, $281a441cdcb2cf36$var$ProxyTracerProvider;
var $281a441cdcb2cf36$var$init_ProxyTracerProvider = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api/build/esm/trace/ProxyTracerProvider.js" () {
        $281a441cdcb2cf36$var$init_ProxyTracer();
        $281a441cdcb2cf36$var$init_NoopTracerProvider();
        $281a441cdcb2cf36$var$NOOP_TRACER_PROVIDER = new $281a441cdcb2cf36$var$NoopTracerProvider();
        $281a441cdcb2cf36$var$ProxyTracerProvider = class {
            /**
       * Get a {@link ProxyTracer}
       */ getTracer(name, version6, options) {
                var _a2;
                return (_a2 = this.getDelegateTracer(name, version6, options)) !== null && _a2 !== void 0 ? _a2 : new $281a441cdcb2cf36$var$ProxyTracer(this, name, version6, options);
            }
            getDelegate() {
                var _a2;
                return (_a2 = this._delegate) !== null && _a2 !== void 0 ? _a2 : $281a441cdcb2cf36$var$NOOP_TRACER_PROVIDER;
            }
            /**
       * Set the delegate tracer provider
       */ setDelegate(delegate) {
                this._delegate = delegate;
            }
            getDelegateTracer(name, version6, options) {
                var _a2;
                return (_a2 = this._delegate) === null || _a2 === void 0 ? void 0 : _a2.getTracer(name, version6, options);
            }
        };
    }
});
// ../node_modules/@opentelemetry/api/build/esm/trace/SamplingResult.js
var $281a441cdcb2cf36$var$SamplingDecision;
var $281a441cdcb2cf36$var$init_SamplingResult = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api/build/esm/trace/SamplingResult.js" () {
        (function(SamplingDecision3) {
            SamplingDecision3[SamplingDecision3["NOT_RECORD"] = 0] = "NOT_RECORD";
            SamplingDecision3[SamplingDecision3["RECORD"] = 1] = "RECORD";
            SamplingDecision3[SamplingDecision3["RECORD_AND_SAMPLED"] = 2] = "RECORD_AND_SAMPLED";
        })($281a441cdcb2cf36$var$SamplingDecision || ($281a441cdcb2cf36$var$SamplingDecision = {}));
    }
});
// ../node_modules/@opentelemetry/api/build/esm/trace/span_kind.js
var $281a441cdcb2cf36$var$SpanKind;
var $281a441cdcb2cf36$var$init_span_kind = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api/build/esm/trace/span_kind.js" () {
        (function(SpanKind2) {
            SpanKind2[SpanKind2["INTERNAL"] = 0] = "INTERNAL";
            SpanKind2[SpanKind2["SERVER"] = 1] = "SERVER";
            SpanKind2[SpanKind2["CLIENT"] = 2] = "CLIENT";
            SpanKind2[SpanKind2["PRODUCER"] = 3] = "PRODUCER";
            SpanKind2[SpanKind2["CONSUMER"] = 4] = "CONSUMER";
        })($281a441cdcb2cf36$var$SpanKind || ($281a441cdcb2cf36$var$SpanKind = {}));
    }
});
// ../node_modules/@opentelemetry/api/build/esm/trace/status.js
var $281a441cdcb2cf36$var$SpanStatusCode;
var $281a441cdcb2cf36$var$init_status = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api/build/esm/trace/status.js" () {
        (function(SpanStatusCode2) {
            SpanStatusCode2[SpanStatusCode2["UNSET"] = 0] = "UNSET";
            SpanStatusCode2[SpanStatusCode2["OK"] = 1] = "OK";
            SpanStatusCode2[SpanStatusCode2["ERROR"] = 2] = "ERROR";
        })($281a441cdcb2cf36$var$SpanStatusCode || ($281a441cdcb2cf36$var$SpanStatusCode = {}));
    }
});
// ../node_modules/@opentelemetry/api/build/esm/trace/internal/tracestate-validators.js
function $281a441cdcb2cf36$var$validateKey(key) {
    return $281a441cdcb2cf36$var$VALID_KEY_REGEX.test(key);
}
function $281a441cdcb2cf36$var$validateValue(value2) {
    return $281a441cdcb2cf36$var$VALID_VALUE_BASE_REGEX.test(value2) && !$281a441cdcb2cf36$var$INVALID_VALUE_COMMA_EQUAL_REGEX.test(value2);
}
var $281a441cdcb2cf36$var$VALID_KEY_CHAR_RANGE, $281a441cdcb2cf36$var$VALID_KEY, $281a441cdcb2cf36$var$VALID_VENDOR_KEY, $281a441cdcb2cf36$var$VALID_KEY_REGEX, $281a441cdcb2cf36$var$VALID_VALUE_BASE_REGEX, $281a441cdcb2cf36$var$INVALID_VALUE_COMMA_EQUAL_REGEX;
var $281a441cdcb2cf36$var$init_tracestate_validators = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api/build/esm/trace/internal/tracestate-validators.js" () {
        $281a441cdcb2cf36$var$VALID_KEY_CHAR_RANGE = "[_0-9a-z-*/]";
        $281a441cdcb2cf36$var$VALID_KEY = `[a-z]${$281a441cdcb2cf36$var$VALID_KEY_CHAR_RANGE}{0,255}`;
        $281a441cdcb2cf36$var$VALID_VENDOR_KEY = `[a-z0-9]${$281a441cdcb2cf36$var$VALID_KEY_CHAR_RANGE}{0,240}@[a-z]${$281a441cdcb2cf36$var$VALID_KEY_CHAR_RANGE}{0,13}`;
        $281a441cdcb2cf36$var$VALID_KEY_REGEX = new RegExp(`^(?:${$281a441cdcb2cf36$var$VALID_KEY}|${$281a441cdcb2cf36$var$VALID_VENDOR_KEY})$`);
        $281a441cdcb2cf36$var$VALID_VALUE_BASE_REGEX = /^[ -~]{0,255}[!-~]$/;
        $281a441cdcb2cf36$var$INVALID_VALUE_COMMA_EQUAL_REGEX = /,|=/;
    }
});
// ../node_modules/@opentelemetry/api/build/esm/trace/internal/tracestate-impl.js
var $281a441cdcb2cf36$var$MAX_TRACE_STATE_ITEMS, $281a441cdcb2cf36$var$MAX_TRACE_STATE_LEN, $281a441cdcb2cf36$var$LIST_MEMBERS_SEPARATOR, $281a441cdcb2cf36$var$LIST_MEMBER_KEY_VALUE_SPLITTER, $281a441cdcb2cf36$var$TraceStateImpl;
var $281a441cdcb2cf36$var$init_tracestate_impl = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api/build/esm/trace/internal/tracestate-impl.js" () {
        $281a441cdcb2cf36$var$init_tracestate_validators();
        $281a441cdcb2cf36$var$MAX_TRACE_STATE_ITEMS = 32;
        $281a441cdcb2cf36$var$MAX_TRACE_STATE_LEN = 512;
        $281a441cdcb2cf36$var$LIST_MEMBERS_SEPARATOR = ",";
        $281a441cdcb2cf36$var$LIST_MEMBER_KEY_VALUE_SPLITTER = "=";
        $281a441cdcb2cf36$var$TraceStateImpl = class _TraceStateImpl {
            constructor(rawTraceState){
                this._internalState = /* @__PURE__ */ new Map();
                if (rawTraceState) this._parse(rawTraceState);
            }
            set(key, value2) {
                const traceState = this._clone();
                if (traceState._internalState.has(key)) traceState._internalState.delete(key);
                traceState._internalState.set(key, value2);
                return traceState;
            }
            unset(key) {
                const traceState = this._clone();
                traceState._internalState.delete(key);
                return traceState;
            }
            get(key) {
                return this._internalState.get(key);
            }
            serialize() {
                return Array.from(this._internalState.keys()).reduceRight((agg, key)=>{
                    agg.push(key + $281a441cdcb2cf36$var$LIST_MEMBER_KEY_VALUE_SPLITTER + this.get(key));
                    return agg;
                }, []).join($281a441cdcb2cf36$var$LIST_MEMBERS_SEPARATOR);
            }
            _parse(rawTraceState) {
                if (rawTraceState.length > $281a441cdcb2cf36$var$MAX_TRACE_STATE_LEN) return;
                this._internalState = rawTraceState.split($281a441cdcb2cf36$var$LIST_MEMBERS_SEPARATOR).reduceRight((agg, part)=>{
                    const listMember = part.trim();
                    const i3 = listMember.indexOf($281a441cdcb2cf36$var$LIST_MEMBER_KEY_VALUE_SPLITTER);
                    if (i3 !== -1) {
                        const key = listMember.slice(0, i3);
                        const value2 = listMember.slice(i3 + 1, part.length);
                        if ($281a441cdcb2cf36$var$validateKey(key) && $281a441cdcb2cf36$var$validateValue(value2)) agg.set(key, value2);
                    }
                    return agg;
                }, /* @__PURE__ */ new Map());
                if (this._internalState.size > $281a441cdcb2cf36$var$MAX_TRACE_STATE_ITEMS) this._internalState = new Map(Array.from(this._internalState.entries()).reverse().slice(0, $281a441cdcb2cf36$var$MAX_TRACE_STATE_ITEMS));
            }
            // @ts-expect-error TS6133 Accessed in tests only.
            _keys() {
                return Array.from(this._internalState.keys()).reverse();
            }
            _clone() {
                const traceState = new _TraceStateImpl();
                traceState._internalState = new Map(this._internalState);
                return traceState;
            }
        };
    }
});
// ../node_modules/@opentelemetry/api/build/esm/trace/internal/utils.js
function $281a441cdcb2cf36$var$createTraceState(rawTraceState) {
    return new $281a441cdcb2cf36$var$TraceStateImpl(rawTraceState);
}
var $281a441cdcb2cf36$var$init_utils2 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api/build/esm/trace/internal/utils.js" () {
        $281a441cdcb2cf36$var$init_tracestate_impl();
    }
});
// ../node_modules/@opentelemetry/api/build/esm/context-api.js
var $281a441cdcb2cf36$var$context;
var $281a441cdcb2cf36$var$init_context_api = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api/build/esm/context-api.js" () {
        $281a441cdcb2cf36$var$init_context2();
        $281a441cdcb2cf36$var$context = $281a441cdcb2cf36$var$ContextAPI.getInstance();
    }
});
// ../node_modules/@opentelemetry/api/build/esm/diag-api.js
var $281a441cdcb2cf36$var$diag2;
var $281a441cdcb2cf36$var$init_diag_api = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api/build/esm/diag-api.js" () {
        $281a441cdcb2cf36$var$init_diag();
        $281a441cdcb2cf36$var$diag2 = $281a441cdcb2cf36$var$DiagAPI.instance();
    }
});
// ../node_modules/@opentelemetry/api/build/esm/metrics/NoopMeterProvider.js
var $281a441cdcb2cf36$var$NoopMeterProvider, $281a441cdcb2cf36$var$NOOP_METER_PROVIDER;
var $281a441cdcb2cf36$var$init_NoopMeterProvider = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api/build/esm/metrics/NoopMeterProvider.js" () {
        $281a441cdcb2cf36$var$init_NoopMeter();
        $281a441cdcb2cf36$var$NoopMeterProvider = class {
            getMeter(_name, _version, _options) {
                return $281a441cdcb2cf36$var$NOOP_METER;
            }
        };
        $281a441cdcb2cf36$var$NOOP_METER_PROVIDER = new $281a441cdcb2cf36$var$NoopMeterProvider();
    }
});
// ../node_modules/@opentelemetry/api/build/esm/api/metrics.js
var $281a441cdcb2cf36$var$API_NAME3, $281a441cdcb2cf36$var$MetricsAPI;
var $281a441cdcb2cf36$var$init_metrics = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api/build/esm/api/metrics.js" () {
        $281a441cdcb2cf36$var$init_NoopMeterProvider();
        $281a441cdcb2cf36$var$init_global_utils();
        $281a441cdcb2cf36$var$init_diag();
        $281a441cdcb2cf36$var$API_NAME3 = "metrics";
        $281a441cdcb2cf36$var$MetricsAPI = class _MetricsAPI {
            /** Empty private constructor prevents end users from constructing a new instance of the API */ constructor(){}
            /** Get the singleton instance of the Metrics API */ static getInstance() {
                if (!this._instance) this._instance = new _MetricsAPI();
                return this._instance;
            }
            /**
       * Set the current global meter provider.
       * Returns true if the meter provider was successfully registered, else false.
       */ setGlobalMeterProvider(provider) {
                return $281a441cdcb2cf36$var$registerGlobal($281a441cdcb2cf36$var$API_NAME3, provider, $281a441cdcb2cf36$var$DiagAPI.instance());
            }
            /**
       * Returns the global meter provider.
       */ getMeterProvider() {
                return $281a441cdcb2cf36$var$getGlobal($281a441cdcb2cf36$var$API_NAME3) || $281a441cdcb2cf36$var$NOOP_METER_PROVIDER;
            }
            /**
       * Returns a meter from the global meter provider.
       */ getMeter(name, version6, options) {
                return this.getMeterProvider().getMeter(name, version6, options);
            }
            /** Remove the global meter provider */ disable() {
                $281a441cdcb2cf36$var$unregisterGlobal($281a441cdcb2cf36$var$API_NAME3, $281a441cdcb2cf36$var$DiagAPI.instance());
            }
        };
    }
});
// ../node_modules/@opentelemetry/api/build/esm/metrics-api.js
var $281a441cdcb2cf36$var$metrics;
var $281a441cdcb2cf36$var$init_metrics_api = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api/build/esm/metrics-api.js" () {
        $281a441cdcb2cf36$var$init_metrics();
        $281a441cdcb2cf36$var$metrics = $281a441cdcb2cf36$var$MetricsAPI.getInstance();
    }
});
// ../node_modules/@opentelemetry/api/build/esm/propagation/NoopTextMapPropagator.js
var $281a441cdcb2cf36$var$NoopTextMapPropagator;
var $281a441cdcb2cf36$var$init_NoopTextMapPropagator = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api/build/esm/propagation/NoopTextMapPropagator.js" () {
        $281a441cdcb2cf36$var$NoopTextMapPropagator = class {
            /** Noop inject function does nothing */ inject(_context, _carrier) {}
            /** Noop extract function does nothing and returns the input context */ extract(context2, _carrier) {
                return context2;
            }
            fields() {
                return [];
            }
        };
    }
});
// ../node_modules/@opentelemetry/api/build/esm/baggage/context-helpers.js
function $281a441cdcb2cf36$var$getBaggage(context2) {
    return context2.getValue($281a441cdcb2cf36$var$BAGGAGE_KEY) || void 0;
}
function $281a441cdcb2cf36$var$getActiveBaggage() {
    return $281a441cdcb2cf36$var$getBaggage($281a441cdcb2cf36$var$ContextAPI.getInstance().active());
}
function $281a441cdcb2cf36$var$setBaggage(context2, baggage) {
    return context2.setValue($281a441cdcb2cf36$var$BAGGAGE_KEY, baggage);
}
function $281a441cdcb2cf36$var$deleteBaggage(context2) {
    return context2.deleteValue($281a441cdcb2cf36$var$BAGGAGE_KEY);
}
var $281a441cdcb2cf36$var$BAGGAGE_KEY;
var $281a441cdcb2cf36$var$init_context_helpers = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api/build/esm/baggage/context-helpers.js" () {
        $281a441cdcb2cf36$var$init_context2();
        $281a441cdcb2cf36$var$init_context();
        $281a441cdcb2cf36$var$BAGGAGE_KEY = $281a441cdcb2cf36$var$createContextKey("OpenTelemetry Baggage Key");
    }
});
// ../node_modules/@opentelemetry/api/build/esm/api/propagation.js
var $281a441cdcb2cf36$var$API_NAME4, $281a441cdcb2cf36$var$NOOP_TEXT_MAP_PROPAGATOR, $281a441cdcb2cf36$var$PropagationAPI;
var $281a441cdcb2cf36$var$init_propagation = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api/build/esm/api/propagation.js" () {
        $281a441cdcb2cf36$var$init_global_utils();
        $281a441cdcb2cf36$var$init_NoopTextMapPropagator();
        $281a441cdcb2cf36$var$init_TextMapPropagator();
        $281a441cdcb2cf36$var$init_context_helpers();
        $281a441cdcb2cf36$var$init_utils();
        $281a441cdcb2cf36$var$init_diag();
        $281a441cdcb2cf36$var$API_NAME4 = "propagation";
        $281a441cdcb2cf36$var$NOOP_TEXT_MAP_PROPAGATOR = new $281a441cdcb2cf36$var$NoopTextMapPropagator();
        $281a441cdcb2cf36$var$PropagationAPI = class _PropagationAPI {
            /** Empty private constructor prevents end users from constructing a new instance of the API */ constructor(){
                this.createBaggage = $281a441cdcb2cf36$var$createBaggage;
                this.getBaggage = $281a441cdcb2cf36$var$getBaggage;
                this.getActiveBaggage = $281a441cdcb2cf36$var$getActiveBaggage;
                this.setBaggage = $281a441cdcb2cf36$var$setBaggage;
                this.deleteBaggage = $281a441cdcb2cf36$var$deleteBaggage;
            }
            /** Get the singleton instance of the Propagator API */ static getInstance() {
                if (!this._instance) this._instance = new _PropagationAPI();
                return this._instance;
            }
            /**
       * Set the current propagator.
       *
       * @returns true if the propagator was successfully registered, else false
       */ setGlobalPropagator(propagator) {
                return $281a441cdcb2cf36$var$registerGlobal($281a441cdcb2cf36$var$API_NAME4, propagator, $281a441cdcb2cf36$var$DiagAPI.instance());
            }
            /**
       * Inject context into a carrier to be propagated inter-process
       *
       * @param context Context carrying tracing data to inject
       * @param carrier carrier to inject context into
       * @param setter Function used to set values on the carrier
       */ inject(context2, carrier, setter = $281a441cdcb2cf36$var$defaultTextMapSetter) {
                return this._getGlobalPropagator().inject(context2, carrier, setter);
            }
            /**
       * Extract context from a carrier
       *
       * @param context Context which the newly created context will inherit from
       * @param carrier Carrier to extract context from
       * @param getter Function used to extract keys from a carrier
       */ extract(context2, carrier, getter = $281a441cdcb2cf36$var$defaultTextMapGetter) {
                return this._getGlobalPropagator().extract(context2, carrier, getter);
            }
            /**
       * Return a list of all fields which may be used by the propagator.
       */ fields() {
                return this._getGlobalPropagator().fields();
            }
            /** Remove the global propagator */ disable() {
                $281a441cdcb2cf36$var$unregisterGlobal($281a441cdcb2cf36$var$API_NAME4, $281a441cdcb2cf36$var$DiagAPI.instance());
            }
            _getGlobalPropagator() {
                return $281a441cdcb2cf36$var$getGlobal($281a441cdcb2cf36$var$API_NAME4) || $281a441cdcb2cf36$var$NOOP_TEXT_MAP_PROPAGATOR;
            }
        };
    }
});
// ../node_modules/@opentelemetry/api/build/esm/propagation-api.js
var $281a441cdcb2cf36$var$propagation;
var $281a441cdcb2cf36$var$init_propagation_api = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api/build/esm/propagation-api.js" () {
        $281a441cdcb2cf36$var$init_propagation();
        $281a441cdcb2cf36$var$propagation = $281a441cdcb2cf36$var$PropagationAPI.getInstance();
    }
});
// ../node_modules/@opentelemetry/api/build/esm/api/trace.js
var $281a441cdcb2cf36$var$API_NAME5, $281a441cdcb2cf36$var$TraceAPI;
var $281a441cdcb2cf36$var$init_trace = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api/build/esm/api/trace.js" () {
        $281a441cdcb2cf36$var$init_global_utils();
        $281a441cdcb2cf36$var$init_ProxyTracerProvider();
        $281a441cdcb2cf36$var$init_spancontext_utils();
        $281a441cdcb2cf36$var$init_context_utils();
        $281a441cdcb2cf36$var$init_diag();
        $281a441cdcb2cf36$var$API_NAME5 = "trace";
        $281a441cdcb2cf36$var$TraceAPI = class _TraceAPI {
            /** Empty private constructor prevents end users from constructing a new instance of the API */ constructor(){
                this._proxyTracerProvider = new $281a441cdcb2cf36$var$ProxyTracerProvider();
                this.wrapSpanContext = $281a441cdcb2cf36$var$wrapSpanContext;
                this.isSpanContextValid = $281a441cdcb2cf36$var$isSpanContextValid;
                this.deleteSpan = $281a441cdcb2cf36$var$deleteSpan;
                this.getSpan = $281a441cdcb2cf36$var$getSpan;
                this.getActiveSpan = $281a441cdcb2cf36$var$getActiveSpan;
                this.getSpanContext = $281a441cdcb2cf36$var$getSpanContext;
                this.setSpan = $281a441cdcb2cf36$var$setSpan;
                this.setSpanContext = $281a441cdcb2cf36$var$setSpanContext;
            }
            /** Get the singleton instance of the Trace API */ static getInstance() {
                if (!this._instance) this._instance = new _TraceAPI();
                return this._instance;
            }
            /**
       * Set the current global tracer.
       *
       * @returns true if the tracer provider was successfully registered, else false
       */ setGlobalTracerProvider(provider) {
                const success = $281a441cdcb2cf36$var$registerGlobal($281a441cdcb2cf36$var$API_NAME5, this._proxyTracerProvider, $281a441cdcb2cf36$var$DiagAPI.instance());
                if (success) this._proxyTracerProvider.setDelegate(provider);
                return success;
            }
            /**
       * Returns the global tracer provider.
       */ getTracerProvider() {
                return $281a441cdcb2cf36$var$getGlobal($281a441cdcb2cf36$var$API_NAME5) || this._proxyTracerProvider;
            }
            /**
       * Returns a tracer from the global tracer provider.
       */ getTracer(name, version6) {
                return this.getTracerProvider().getTracer(name, version6);
            }
            /** Remove the global tracer provider */ disable() {
                $281a441cdcb2cf36$var$unregisterGlobal($281a441cdcb2cf36$var$API_NAME5, $281a441cdcb2cf36$var$DiagAPI.instance());
                this._proxyTracerProvider = new $281a441cdcb2cf36$var$ProxyTracerProvider();
            }
        };
    }
});
// ../node_modules/@opentelemetry/api/build/esm/trace-api.js
var $281a441cdcb2cf36$var$trace;
var $281a441cdcb2cf36$var$init_trace_api = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api/build/esm/trace-api.js" () {
        $281a441cdcb2cf36$var$init_trace();
        $281a441cdcb2cf36$var$trace = $281a441cdcb2cf36$var$TraceAPI.getInstance();
    }
});
// ../node_modules/@opentelemetry/api/build/esm/index.js
var $281a441cdcb2cf36$var$esm_exports2 = {};
$281a441cdcb2cf36$var$__export($281a441cdcb2cf36$var$esm_exports2, {
    DiagConsoleLogger: ()=>$281a441cdcb2cf36$var$DiagConsoleLogger,
    DiagLogLevel: ()=>$281a441cdcb2cf36$var$DiagLogLevel,
    INVALID_SPANID: ()=>$281a441cdcb2cf36$var$INVALID_SPANID,
    INVALID_SPAN_CONTEXT: ()=>$281a441cdcb2cf36$var$INVALID_SPAN_CONTEXT,
    INVALID_TRACEID: ()=>$281a441cdcb2cf36$var$INVALID_TRACEID,
    ProxyTracer: ()=>$281a441cdcb2cf36$var$ProxyTracer,
    ProxyTracerProvider: ()=>$281a441cdcb2cf36$var$ProxyTracerProvider,
    ROOT_CONTEXT: ()=>$281a441cdcb2cf36$var$ROOT_CONTEXT,
    SamplingDecision: ()=>$281a441cdcb2cf36$var$SamplingDecision,
    SpanKind: ()=>$281a441cdcb2cf36$var$SpanKind,
    SpanStatusCode: ()=>$281a441cdcb2cf36$var$SpanStatusCode,
    TraceFlags: ()=>$281a441cdcb2cf36$var$TraceFlags,
    ValueType: ()=>$281a441cdcb2cf36$var$ValueType,
    baggageEntryMetadataFromString: ()=>$281a441cdcb2cf36$var$baggageEntryMetadataFromString,
    context: ()=>$281a441cdcb2cf36$var$context,
    createContextKey: ()=>$281a441cdcb2cf36$var$createContextKey,
    createNoopMeter: ()=>$281a441cdcb2cf36$var$createNoopMeter,
    createTraceState: ()=>$281a441cdcb2cf36$var$createTraceState,
    default: ()=>$281a441cdcb2cf36$var$esm_default,
    defaultTextMapGetter: ()=>$281a441cdcb2cf36$var$defaultTextMapGetter,
    defaultTextMapSetter: ()=>$281a441cdcb2cf36$var$defaultTextMapSetter,
    diag: ()=>$281a441cdcb2cf36$var$diag2,
    isSpanContextValid: ()=>$281a441cdcb2cf36$var$isSpanContextValid,
    isValidSpanId: ()=>$281a441cdcb2cf36$var$isValidSpanId,
    isValidTraceId: ()=>$281a441cdcb2cf36$var$isValidTraceId,
    metrics: ()=>$281a441cdcb2cf36$var$metrics,
    propagation: ()=>$281a441cdcb2cf36$var$propagation,
    trace: ()=>$281a441cdcb2cf36$var$trace
});
var $281a441cdcb2cf36$var$esm_default;
var $281a441cdcb2cf36$var$init_esm = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api/build/esm/index.js" () {
        $281a441cdcb2cf36$var$init_utils();
        $281a441cdcb2cf36$var$init_context();
        $281a441cdcb2cf36$var$init_consoleLogger();
        $281a441cdcb2cf36$var$init_types();
        $281a441cdcb2cf36$var$init_NoopMeter();
        $281a441cdcb2cf36$var$init_Metric();
        $281a441cdcb2cf36$var$init_TextMapPropagator();
        $281a441cdcb2cf36$var$init_ProxyTracer();
        $281a441cdcb2cf36$var$init_ProxyTracerProvider();
        $281a441cdcb2cf36$var$init_SamplingResult();
        $281a441cdcb2cf36$var$init_span_kind();
        $281a441cdcb2cf36$var$init_status();
        $281a441cdcb2cf36$var$init_trace_flags();
        $281a441cdcb2cf36$var$init_utils2();
        $281a441cdcb2cf36$var$init_spancontext_utils();
        $281a441cdcb2cf36$var$init_invalid_span_constants();
        $281a441cdcb2cf36$var$init_context_api();
        $281a441cdcb2cf36$var$init_diag_api();
        $281a441cdcb2cf36$var$init_metrics_api();
        $281a441cdcb2cf36$var$init_propagation_api();
        $281a441cdcb2cf36$var$init_trace_api();
        $281a441cdcb2cf36$var$esm_default = {
            context: $281a441cdcb2cf36$var$context,
            diag: $281a441cdcb2cf36$var$diag2,
            metrics: $281a441cdcb2cf36$var$metrics,
            propagation: $281a441cdcb2cf36$var$propagation,
            trace: $281a441cdcb2cf36$var$trace
        };
    }
});
// ../node_modules/@opentelemetry/core/build/esm/trace/suppress-tracing.js
function $281a441cdcb2cf36$var$suppressTracing(context2) {
    return context2.setValue($281a441cdcb2cf36$var$SUPPRESS_TRACING_KEY, true);
}
function $281a441cdcb2cf36$var$isTracingSuppressed(context2) {
    return context2.getValue($281a441cdcb2cf36$var$SUPPRESS_TRACING_KEY) === true;
}
var $281a441cdcb2cf36$var$SUPPRESS_TRACING_KEY;
var $281a441cdcb2cf36$var$init_suppress_tracing = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/core/build/esm/trace/suppress-tracing.js" () {
        $281a441cdcb2cf36$var$init_esm();
        $281a441cdcb2cf36$var$SUPPRESS_TRACING_KEY = $281a441cdcb2cf36$var$createContextKey("OpenTelemetry SDK Context Key SUPPRESS_TRACING");
    }
});
// ../node_modules/@opentelemetry/core/build/esm/baggage/constants.js
var $281a441cdcb2cf36$var$BAGGAGE_KEY_PAIR_SEPARATOR, $281a441cdcb2cf36$var$BAGGAGE_PROPERTIES_SEPARATOR, $281a441cdcb2cf36$var$BAGGAGE_ITEMS_SEPARATOR, $281a441cdcb2cf36$var$BAGGAGE_HEADER, $281a441cdcb2cf36$var$BAGGAGE_MAX_NAME_VALUE_PAIRS, $281a441cdcb2cf36$var$BAGGAGE_MAX_PER_NAME_VALUE_PAIRS, $281a441cdcb2cf36$var$BAGGAGE_MAX_TOTAL_LENGTH;
var $281a441cdcb2cf36$var$init_constants = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/core/build/esm/baggage/constants.js" () {
        $281a441cdcb2cf36$var$BAGGAGE_KEY_PAIR_SEPARATOR = "=";
        $281a441cdcb2cf36$var$BAGGAGE_PROPERTIES_SEPARATOR = ";";
        $281a441cdcb2cf36$var$BAGGAGE_ITEMS_SEPARATOR = ",";
        $281a441cdcb2cf36$var$BAGGAGE_HEADER = "baggage";
        $281a441cdcb2cf36$var$BAGGAGE_MAX_NAME_VALUE_PAIRS = 180;
        $281a441cdcb2cf36$var$BAGGAGE_MAX_PER_NAME_VALUE_PAIRS = 4096;
        $281a441cdcb2cf36$var$BAGGAGE_MAX_TOTAL_LENGTH = 8192;
    }
});
// ../node_modules/@opentelemetry/core/build/esm/baggage/utils.js
function $281a441cdcb2cf36$var$serializeKeyPairs(keyPairs) {
    return keyPairs.reduce((hValue, current2)=>{
        const value2 = `${hValue}${hValue !== "" ? $281a441cdcb2cf36$var$BAGGAGE_ITEMS_SEPARATOR : ""}${current2}`;
        return value2.length > $281a441cdcb2cf36$var$BAGGAGE_MAX_TOTAL_LENGTH ? hValue : value2;
    }, "");
}
function $281a441cdcb2cf36$var$getKeyPairs(baggage) {
    return baggage.getAllEntries().map(([key, value2])=>{
        let entry = `${encodeURIComponent(key)}=${encodeURIComponent(value2.value)}`;
        if (value2.metadata !== void 0) entry += $281a441cdcb2cf36$var$BAGGAGE_PROPERTIES_SEPARATOR + value2.metadata.toString();
        return entry;
    });
}
function $281a441cdcb2cf36$var$parsePairKeyValue(entry) {
    if (!entry) return;
    const metadataSeparatorIndex = entry.indexOf($281a441cdcb2cf36$var$BAGGAGE_PROPERTIES_SEPARATOR);
    const keyPairPart = metadataSeparatorIndex === -1 ? entry : entry.substring(0, metadataSeparatorIndex);
    const separatorIndex = keyPairPart.indexOf($281a441cdcb2cf36$var$BAGGAGE_KEY_PAIR_SEPARATOR);
    if (separatorIndex <= 0) return;
    const rawKey = keyPairPart.substring(0, separatorIndex).trim();
    const rawValue = keyPairPart.substring(separatorIndex + 1).trim();
    if (!rawKey || !rawValue) return;
    let key;
    let value2;
    try {
        key = decodeURIComponent(rawKey);
        value2 = decodeURIComponent(rawValue);
    } catch  {
        return;
    }
    let metadata;
    if (metadataSeparatorIndex !== -1 && metadataSeparatorIndex < entry.length - 1) {
        const metadataString = entry.substring(metadataSeparatorIndex + 1);
        metadata = $281a441cdcb2cf36$var$baggageEntryMetadataFromString(metadataString);
    }
    return {
        key: key,
        value: value2,
        metadata: metadata
    };
}
var $281a441cdcb2cf36$var$init_utils3 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/core/build/esm/baggage/utils.js" () {
        $281a441cdcb2cf36$var$init_esm();
        $281a441cdcb2cf36$var$init_constants();
    }
});
// ../node_modules/@opentelemetry/core/build/esm/baggage/propagation/W3CBaggagePropagator.js
var $281a441cdcb2cf36$var$W3CBaggagePropagator;
var $281a441cdcb2cf36$var$init_W3CBaggagePropagator = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/core/build/esm/baggage/propagation/W3CBaggagePropagator.js" () {
        $281a441cdcb2cf36$var$init_esm();
        $281a441cdcb2cf36$var$init_suppress_tracing();
        $281a441cdcb2cf36$var$init_constants();
        $281a441cdcb2cf36$var$init_utils3();
        $281a441cdcb2cf36$var$W3CBaggagePropagator = class {
            inject(context2, carrier, setter) {
                const baggage = $281a441cdcb2cf36$var$propagation.getBaggage(context2);
                if (!baggage || $281a441cdcb2cf36$var$isTracingSuppressed(context2)) return;
                const keyPairs = $281a441cdcb2cf36$var$getKeyPairs(baggage).filter((pair)=>{
                    return pair.length <= $281a441cdcb2cf36$var$BAGGAGE_MAX_PER_NAME_VALUE_PAIRS;
                }).slice(0, $281a441cdcb2cf36$var$BAGGAGE_MAX_NAME_VALUE_PAIRS);
                const headerValue = $281a441cdcb2cf36$var$serializeKeyPairs(keyPairs);
                if (headerValue.length > 0) setter.set(carrier, $281a441cdcb2cf36$var$BAGGAGE_HEADER, headerValue);
            }
            extract(context2, carrier, getter) {
                const headerValue = getter.get(carrier, $281a441cdcb2cf36$var$BAGGAGE_HEADER);
                const baggageString = Array.isArray(headerValue) ? headerValue.join($281a441cdcb2cf36$var$BAGGAGE_ITEMS_SEPARATOR) : headerValue;
                if (!baggageString) return context2;
                const baggage = {};
                if (baggageString.length === 0) return context2;
                const pairs = baggageString.split($281a441cdcb2cf36$var$BAGGAGE_ITEMS_SEPARATOR);
                pairs.forEach((entry)=>{
                    const keyPair = $281a441cdcb2cf36$var$parsePairKeyValue(entry);
                    if (keyPair) {
                        const baggageEntry = {
                            value: keyPair.value
                        };
                        if (keyPair.metadata) baggageEntry.metadata = keyPair.metadata;
                        baggage[keyPair.key] = baggageEntry;
                    }
                });
                if (Object.entries(baggage).length === 0) return context2;
                return $281a441cdcb2cf36$var$propagation.setBaggage(context2, $281a441cdcb2cf36$var$propagation.createBaggage(baggage));
            }
            fields() {
                return [
                    $281a441cdcb2cf36$var$BAGGAGE_HEADER
                ];
            }
        };
    }
});
// ../node_modules/@opentelemetry/core/build/esm/common/attributes.js
function $281a441cdcb2cf36$var$sanitizeAttributes(attributes) {
    const out = {};
    if (typeof attributes !== "object" || attributes == null) return out;
    for(const key in attributes){
        if (!Object.prototype.hasOwnProperty.call(attributes, key)) continue;
        if (!$281a441cdcb2cf36$var$isAttributeKey(key)) {
            $281a441cdcb2cf36$var$diag2.warn(`Invalid attribute key: ${key}`);
            continue;
        }
        const val = attributes[key];
        if (!$281a441cdcb2cf36$var$isAttributeValue(val)) {
            $281a441cdcb2cf36$var$diag2.warn(`Invalid attribute value set for key: ${key}`);
            continue;
        }
        if (Array.isArray(val)) out[key] = val.slice();
        else out[key] = val;
    }
    return out;
}
function $281a441cdcb2cf36$var$isAttributeKey(key) {
    return typeof key === "string" && key !== "";
}
function $281a441cdcb2cf36$var$isAttributeValue(val) {
    if (val == null) return true;
    if (Array.isArray(val)) return $281a441cdcb2cf36$var$isHomogeneousAttributeValueArray(val);
    return $281a441cdcb2cf36$var$isValidPrimitiveAttributeValueType(typeof val);
}
function $281a441cdcb2cf36$var$isHomogeneousAttributeValueArray(arr) {
    let type;
    for (const element2 of arr){
        if (element2 == null) continue;
        const elementType = typeof element2;
        if (elementType === type) continue;
        if (!type) {
            if ($281a441cdcb2cf36$var$isValidPrimitiveAttributeValueType(elementType)) {
                type = elementType;
                continue;
            }
            return false;
        }
        return false;
    }
    return true;
}
function $281a441cdcb2cf36$var$isValidPrimitiveAttributeValueType(valType) {
    switch(valType){
        case "number":
        case "boolean":
        case "string":
            return true;
    }
    return false;
}
var $281a441cdcb2cf36$var$init_attributes = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/core/build/esm/common/attributes.js" () {
        $281a441cdcb2cf36$var$init_esm();
    }
});
// ../node_modules/@opentelemetry/core/build/esm/common/logging-error-handler.js
function $281a441cdcb2cf36$var$loggingErrorHandler() {
    return (ex)=>{
        $281a441cdcb2cf36$var$diag2.error($281a441cdcb2cf36$var$stringifyException(ex));
    };
}
function $281a441cdcb2cf36$var$stringifyException(ex) {
    if (typeof ex === "string") return ex;
    else return JSON.stringify($281a441cdcb2cf36$var$flattenException(ex));
}
function $281a441cdcb2cf36$var$flattenException(ex) {
    const result = {};
    let current2 = ex;
    while(current2 !== null){
        Object.getOwnPropertyNames(current2).forEach((propertyName)=>{
            if (result[propertyName]) return;
            const value2 = current2[propertyName];
            if (value2) result[propertyName] = String(value2);
        });
        current2 = Object.getPrototypeOf(current2);
    }
    return result;
}
var $281a441cdcb2cf36$var$init_logging_error_handler = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/core/build/esm/common/logging-error-handler.js" () {
        $281a441cdcb2cf36$var$init_esm();
    }
});
// ../node_modules/@opentelemetry/core/build/esm/common/global-error-handler.js
function $281a441cdcb2cf36$var$globalErrorHandler(ex) {
    try {
        $281a441cdcb2cf36$var$delegateHandler(ex);
    } catch  {}
}
var $281a441cdcb2cf36$var$delegateHandler;
var $281a441cdcb2cf36$var$init_global_error_handler = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/core/build/esm/common/global-error-handler.js" () {
        $281a441cdcb2cf36$var$init_logging_error_handler();
        $281a441cdcb2cf36$var$delegateHandler = $281a441cdcb2cf36$var$loggingErrorHandler();
    }
});
// ../node_modules/@opentelemetry/core/build/esm/platform/browser/environment.js
function $281a441cdcb2cf36$var$getStringFromEnv(_3) {
    return void 0;
}
function $281a441cdcb2cf36$var$getNumberFromEnv(_3) {
    return void 0;
}
var $281a441cdcb2cf36$var$init_environment2 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/core/build/esm/platform/browser/environment.js" () {}
});
// ../node_modules/@opentelemetry/core/build/esm/version.js
var $281a441cdcb2cf36$var$VERSION2;
var $281a441cdcb2cf36$var$init_version2 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/core/build/esm/version.js" () {
        $281a441cdcb2cf36$var$VERSION2 = "2.7.0";
    }
});
// ../node_modules/@opentelemetry/semantic-conventions/build/esm/internal/utils.js
// @__NO_SIDE_EFFECTS__
function $281a441cdcb2cf36$var$createConstMap(values) {
    let res = {};
    const len = values.length;
    for(let lp = 0; lp < len; lp++){
        const val = values[lp];
        if (val) res[String(val).toUpperCase().replace(/[-.]/g, "_")] = val;
    }
    return res;
}
var $281a441cdcb2cf36$var$init_utils4 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/semantic-conventions/build/esm/internal/utils.js" () {}
});
// ../node_modules/@opentelemetry/semantic-conventions/build/esm/trace/SemanticAttributes.js
var $281a441cdcb2cf36$var$TMP_AWS_LAMBDA_INVOKED_ARN, $281a441cdcb2cf36$var$TMP_DB_SYSTEM, $281a441cdcb2cf36$var$TMP_DB_CONNECTION_STRING, $281a441cdcb2cf36$var$TMP_DB_USER, $281a441cdcb2cf36$var$TMP_DB_JDBC_DRIVER_CLASSNAME, $281a441cdcb2cf36$var$TMP_DB_NAME, $281a441cdcb2cf36$var$TMP_DB_STATEMENT, $281a441cdcb2cf36$var$TMP_DB_OPERATION, $281a441cdcb2cf36$var$TMP_DB_MSSQL_INSTANCE_NAME, $281a441cdcb2cf36$var$TMP_DB_CASSANDRA_KEYSPACE, $281a441cdcb2cf36$var$TMP_DB_CASSANDRA_PAGE_SIZE, $281a441cdcb2cf36$var$TMP_DB_CASSANDRA_CONSISTENCY_LEVEL, $281a441cdcb2cf36$var$TMP_DB_CASSANDRA_TABLE, $281a441cdcb2cf36$var$TMP_DB_CASSANDRA_IDEMPOTENCE, $281a441cdcb2cf36$var$TMP_DB_CASSANDRA_SPECULATIVE_EXECUTION_COUNT, $281a441cdcb2cf36$var$TMP_DB_CASSANDRA_COORDINATOR_ID, $281a441cdcb2cf36$var$TMP_DB_CASSANDRA_COORDINATOR_DC, $281a441cdcb2cf36$var$TMP_DB_HBASE_NAMESPACE, $281a441cdcb2cf36$var$TMP_DB_REDIS_DATABASE_INDEX, $281a441cdcb2cf36$var$TMP_DB_MONGODB_COLLECTION, $281a441cdcb2cf36$var$TMP_DB_SQL_TABLE, $281a441cdcb2cf36$var$TMP_EXCEPTION_TYPE, $281a441cdcb2cf36$var$TMP_EXCEPTION_MESSAGE, $281a441cdcb2cf36$var$TMP_EXCEPTION_STACKTRACE, $281a441cdcb2cf36$var$TMP_EXCEPTION_ESCAPED, $281a441cdcb2cf36$var$TMP_FAAS_TRIGGER, $281a441cdcb2cf36$var$TMP_FAAS_EXECUTION, $281a441cdcb2cf36$var$TMP_FAAS_DOCUMENT_COLLECTION, $281a441cdcb2cf36$var$TMP_FAAS_DOCUMENT_OPERATION, $281a441cdcb2cf36$var$TMP_FAAS_DOCUMENT_TIME, $281a441cdcb2cf36$var$TMP_FAAS_DOCUMENT_NAME, $281a441cdcb2cf36$var$TMP_FAAS_TIME, $281a441cdcb2cf36$var$TMP_FAAS_CRON, $281a441cdcb2cf36$var$TMP_FAAS_COLDSTART, $281a441cdcb2cf36$var$TMP_FAAS_INVOKED_NAME, $281a441cdcb2cf36$var$TMP_FAAS_INVOKED_PROVIDER, $281a441cdcb2cf36$var$TMP_FAAS_INVOKED_REGION, $281a441cdcb2cf36$var$TMP_NET_TRANSPORT, $281a441cdcb2cf36$var$TMP_NET_PEER_IP, $281a441cdcb2cf36$var$TMP_NET_PEER_PORT, $281a441cdcb2cf36$var$TMP_NET_PEER_NAME, $281a441cdcb2cf36$var$TMP_NET_HOST_IP, $281a441cdcb2cf36$var$TMP_NET_HOST_PORT, $281a441cdcb2cf36$var$TMP_NET_HOST_NAME, $281a441cdcb2cf36$var$TMP_NET_HOST_CONNECTION_TYPE, $281a441cdcb2cf36$var$TMP_NET_HOST_CONNECTION_SUBTYPE, $281a441cdcb2cf36$var$TMP_NET_HOST_CARRIER_NAME, $281a441cdcb2cf36$var$TMP_NET_HOST_CARRIER_MCC, $281a441cdcb2cf36$var$TMP_NET_HOST_CARRIER_MNC, $281a441cdcb2cf36$var$TMP_NET_HOST_CARRIER_ICC, $281a441cdcb2cf36$var$TMP_PEER_SERVICE, $281a441cdcb2cf36$var$TMP_ENDUSER_ID, $281a441cdcb2cf36$var$TMP_ENDUSER_ROLE, $281a441cdcb2cf36$var$TMP_ENDUSER_SCOPE, $281a441cdcb2cf36$var$TMP_THREAD_ID, $281a441cdcb2cf36$var$TMP_THREAD_NAME, $281a441cdcb2cf36$var$TMP_CODE_FUNCTION, $281a441cdcb2cf36$var$TMP_CODE_NAMESPACE, $281a441cdcb2cf36$var$TMP_CODE_FILEPATH, $281a441cdcb2cf36$var$TMP_CODE_LINENO, $281a441cdcb2cf36$var$TMP_HTTP_METHOD, $281a441cdcb2cf36$var$TMP_HTTP_URL, $281a441cdcb2cf36$var$TMP_HTTP_TARGET, $281a441cdcb2cf36$var$TMP_HTTP_HOST, $281a441cdcb2cf36$var$TMP_HTTP_SCHEME, $281a441cdcb2cf36$var$TMP_HTTP_STATUS_CODE, $281a441cdcb2cf36$var$TMP_HTTP_FLAVOR, $281a441cdcb2cf36$var$TMP_HTTP_USER_AGENT, $281a441cdcb2cf36$var$TMP_HTTP_REQUEST_CONTENT_LENGTH, $281a441cdcb2cf36$var$TMP_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED, $281a441cdcb2cf36$var$TMP_HTTP_RESPONSE_CONTENT_LENGTH, $281a441cdcb2cf36$var$TMP_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED, $281a441cdcb2cf36$var$TMP_HTTP_SERVER_NAME, $281a441cdcb2cf36$var$TMP_HTTP_ROUTE, $281a441cdcb2cf36$var$TMP_HTTP_CLIENT_IP, $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_TABLE_NAMES, $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_CONSUMED_CAPACITY, $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_ITEM_COLLECTION_METRICS, $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_PROVISIONED_READ_CAPACITY, $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY, $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_CONSISTENT_READ, $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_PROJECTION, $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_LIMIT, $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_ATTRIBUTES_TO_GET, $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_INDEX_NAME, $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_SELECT, $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES, $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES, $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_EXCLUSIVE_START_TABLE, $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_TABLE_COUNT, $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_SCAN_FORWARD, $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_SEGMENT, $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_TOTAL_SEGMENTS, $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_COUNT, $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_SCANNED_COUNT, $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS, $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES, $281a441cdcb2cf36$var$TMP_MESSAGING_SYSTEM, $281a441cdcb2cf36$var$TMP_MESSAGING_DESTINATION, $281a441cdcb2cf36$var$TMP_MESSAGING_DESTINATION_KIND, $281a441cdcb2cf36$var$TMP_MESSAGING_TEMP_DESTINATION, $281a441cdcb2cf36$var$TMP_MESSAGING_PROTOCOL, $281a441cdcb2cf36$var$TMP_MESSAGING_PROTOCOL_VERSION, $281a441cdcb2cf36$var$TMP_MESSAGING_URL, $281a441cdcb2cf36$var$TMP_MESSAGING_MESSAGE_ID, $281a441cdcb2cf36$var$TMP_MESSAGING_CONVERSATION_ID, $281a441cdcb2cf36$var$TMP_MESSAGING_MESSAGE_PAYLOAD_SIZE_BYTES, $281a441cdcb2cf36$var$TMP_MESSAGING_MESSAGE_PAYLOAD_COMPRESSED_SIZE_BYTES, $281a441cdcb2cf36$var$TMP_MESSAGING_OPERATION, $281a441cdcb2cf36$var$TMP_MESSAGING_CONSUMER_ID, $281a441cdcb2cf36$var$TMP_MESSAGING_RABBITMQ_ROUTING_KEY, $281a441cdcb2cf36$var$TMP_MESSAGING_KAFKA_MESSAGE_KEY, $281a441cdcb2cf36$var$TMP_MESSAGING_KAFKA_CONSUMER_GROUP, $281a441cdcb2cf36$var$TMP_MESSAGING_KAFKA_CLIENT_ID, $281a441cdcb2cf36$var$TMP_MESSAGING_KAFKA_PARTITION, $281a441cdcb2cf36$var$TMP_MESSAGING_KAFKA_TOMBSTONE, $281a441cdcb2cf36$var$TMP_RPC_SYSTEM, $281a441cdcb2cf36$var$TMP_RPC_SERVICE, $281a441cdcb2cf36$var$TMP_RPC_METHOD, $281a441cdcb2cf36$var$TMP_RPC_GRPC_STATUS_CODE, $281a441cdcb2cf36$var$TMP_RPC_JSONRPC_VERSION, $281a441cdcb2cf36$var$TMP_RPC_JSONRPC_REQUEST_ID, $281a441cdcb2cf36$var$TMP_RPC_JSONRPC_ERROR_CODE, $281a441cdcb2cf36$var$TMP_RPC_JSONRPC_ERROR_MESSAGE, $281a441cdcb2cf36$var$TMP_MESSAGE_TYPE, $281a441cdcb2cf36$var$TMP_MESSAGE_ID, $281a441cdcb2cf36$var$TMP_MESSAGE_COMPRESSED_SIZE, $281a441cdcb2cf36$var$TMP_MESSAGE_UNCOMPRESSED_SIZE, $281a441cdcb2cf36$var$SEMATTRS_AWS_LAMBDA_INVOKED_ARN, $281a441cdcb2cf36$var$SEMATTRS_DB_SYSTEM, $281a441cdcb2cf36$var$SEMATTRS_DB_CONNECTION_STRING, $281a441cdcb2cf36$var$SEMATTRS_DB_USER, $281a441cdcb2cf36$var$SEMATTRS_DB_JDBC_DRIVER_CLASSNAME, $281a441cdcb2cf36$var$SEMATTRS_DB_NAME, $281a441cdcb2cf36$var$SEMATTRS_DB_STATEMENT, $281a441cdcb2cf36$var$SEMATTRS_DB_OPERATION, $281a441cdcb2cf36$var$SEMATTRS_DB_MSSQL_INSTANCE_NAME, $281a441cdcb2cf36$var$SEMATTRS_DB_CASSANDRA_KEYSPACE, $281a441cdcb2cf36$var$SEMATTRS_DB_CASSANDRA_PAGE_SIZE, $281a441cdcb2cf36$var$SEMATTRS_DB_CASSANDRA_CONSISTENCY_LEVEL, $281a441cdcb2cf36$var$SEMATTRS_DB_CASSANDRA_TABLE, $281a441cdcb2cf36$var$SEMATTRS_DB_CASSANDRA_IDEMPOTENCE, $281a441cdcb2cf36$var$SEMATTRS_DB_CASSANDRA_SPECULATIVE_EXECUTION_COUNT, $281a441cdcb2cf36$var$SEMATTRS_DB_CASSANDRA_COORDINATOR_ID, $281a441cdcb2cf36$var$SEMATTRS_DB_CASSANDRA_COORDINATOR_DC, $281a441cdcb2cf36$var$SEMATTRS_DB_HBASE_NAMESPACE, $281a441cdcb2cf36$var$SEMATTRS_DB_REDIS_DATABASE_INDEX, $281a441cdcb2cf36$var$SEMATTRS_DB_MONGODB_COLLECTION, $281a441cdcb2cf36$var$SEMATTRS_DB_SQL_TABLE, $281a441cdcb2cf36$var$SEMATTRS_EXCEPTION_TYPE, $281a441cdcb2cf36$var$SEMATTRS_EXCEPTION_MESSAGE, $281a441cdcb2cf36$var$SEMATTRS_EXCEPTION_STACKTRACE, $281a441cdcb2cf36$var$SEMATTRS_EXCEPTION_ESCAPED, $281a441cdcb2cf36$var$SEMATTRS_FAAS_TRIGGER, $281a441cdcb2cf36$var$SEMATTRS_FAAS_EXECUTION, $281a441cdcb2cf36$var$SEMATTRS_FAAS_DOCUMENT_COLLECTION, $281a441cdcb2cf36$var$SEMATTRS_FAAS_DOCUMENT_OPERATION, $281a441cdcb2cf36$var$SEMATTRS_FAAS_DOCUMENT_TIME, $281a441cdcb2cf36$var$SEMATTRS_FAAS_DOCUMENT_NAME, $281a441cdcb2cf36$var$SEMATTRS_FAAS_TIME, $281a441cdcb2cf36$var$SEMATTRS_FAAS_CRON, $281a441cdcb2cf36$var$SEMATTRS_FAAS_COLDSTART, $281a441cdcb2cf36$var$SEMATTRS_FAAS_INVOKED_NAME, $281a441cdcb2cf36$var$SEMATTRS_FAAS_INVOKED_PROVIDER, $281a441cdcb2cf36$var$SEMATTRS_FAAS_INVOKED_REGION, $281a441cdcb2cf36$var$SEMATTRS_NET_TRANSPORT, $281a441cdcb2cf36$var$SEMATTRS_NET_PEER_IP, $281a441cdcb2cf36$var$SEMATTRS_NET_PEER_PORT, $281a441cdcb2cf36$var$SEMATTRS_NET_PEER_NAME, $281a441cdcb2cf36$var$SEMATTRS_NET_HOST_IP, $281a441cdcb2cf36$var$SEMATTRS_NET_HOST_PORT, $281a441cdcb2cf36$var$SEMATTRS_NET_HOST_NAME, $281a441cdcb2cf36$var$SEMATTRS_NET_HOST_CONNECTION_TYPE, $281a441cdcb2cf36$var$SEMATTRS_NET_HOST_CONNECTION_SUBTYPE, $281a441cdcb2cf36$var$SEMATTRS_NET_HOST_CARRIER_NAME, $281a441cdcb2cf36$var$SEMATTRS_NET_HOST_CARRIER_MCC, $281a441cdcb2cf36$var$SEMATTRS_NET_HOST_CARRIER_MNC, $281a441cdcb2cf36$var$SEMATTRS_NET_HOST_CARRIER_ICC, $281a441cdcb2cf36$var$SEMATTRS_PEER_SERVICE, $281a441cdcb2cf36$var$SEMATTRS_ENDUSER_ID, $281a441cdcb2cf36$var$SEMATTRS_ENDUSER_ROLE, $281a441cdcb2cf36$var$SEMATTRS_ENDUSER_SCOPE, $281a441cdcb2cf36$var$SEMATTRS_THREAD_ID, $281a441cdcb2cf36$var$SEMATTRS_THREAD_NAME, $281a441cdcb2cf36$var$SEMATTRS_CODE_FUNCTION, $281a441cdcb2cf36$var$SEMATTRS_CODE_NAMESPACE, $281a441cdcb2cf36$var$SEMATTRS_CODE_FILEPATH, $281a441cdcb2cf36$var$SEMATTRS_CODE_LINENO, $281a441cdcb2cf36$var$SEMATTRS_HTTP_METHOD, $281a441cdcb2cf36$var$SEMATTRS_HTTP_URL, $281a441cdcb2cf36$var$SEMATTRS_HTTP_TARGET, $281a441cdcb2cf36$var$SEMATTRS_HTTP_HOST, $281a441cdcb2cf36$var$SEMATTRS_HTTP_SCHEME, $281a441cdcb2cf36$var$SEMATTRS_HTTP_STATUS_CODE, $281a441cdcb2cf36$var$SEMATTRS_HTTP_FLAVOR, $281a441cdcb2cf36$var$SEMATTRS_HTTP_USER_AGENT, $281a441cdcb2cf36$var$SEMATTRS_HTTP_REQUEST_CONTENT_LENGTH, $281a441cdcb2cf36$var$SEMATTRS_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED, $281a441cdcb2cf36$var$SEMATTRS_HTTP_RESPONSE_CONTENT_LENGTH, $281a441cdcb2cf36$var$SEMATTRS_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED, $281a441cdcb2cf36$var$SEMATTRS_HTTP_SERVER_NAME, $281a441cdcb2cf36$var$SEMATTRS_HTTP_ROUTE, $281a441cdcb2cf36$var$SEMATTRS_HTTP_CLIENT_IP, $281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_TABLE_NAMES, $281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_CONSUMED_CAPACITY, $281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_ITEM_COLLECTION_METRICS, $281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_PROVISIONED_READ_CAPACITY, $281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY, $281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_CONSISTENT_READ, $281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_PROJECTION, $281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_LIMIT, $281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_ATTRIBUTES_TO_GET, $281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_INDEX_NAME, $281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_SELECT, $281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES, $281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES, $281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_EXCLUSIVE_START_TABLE, $281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_TABLE_COUNT, $281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_SCAN_FORWARD, $281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_SEGMENT, $281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_TOTAL_SEGMENTS, $281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_COUNT, $281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_SCANNED_COUNT, $281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS, $281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES, $281a441cdcb2cf36$var$SEMATTRS_MESSAGING_SYSTEM, $281a441cdcb2cf36$var$SEMATTRS_MESSAGING_DESTINATION, $281a441cdcb2cf36$var$SEMATTRS_MESSAGING_DESTINATION_KIND, $281a441cdcb2cf36$var$SEMATTRS_MESSAGING_TEMP_DESTINATION, $281a441cdcb2cf36$var$SEMATTRS_MESSAGING_PROTOCOL, $281a441cdcb2cf36$var$SEMATTRS_MESSAGING_PROTOCOL_VERSION, $281a441cdcb2cf36$var$SEMATTRS_MESSAGING_URL, $281a441cdcb2cf36$var$SEMATTRS_MESSAGING_MESSAGE_ID, $281a441cdcb2cf36$var$SEMATTRS_MESSAGING_CONVERSATION_ID, $281a441cdcb2cf36$var$SEMATTRS_MESSAGING_MESSAGE_PAYLOAD_SIZE_BYTES, $281a441cdcb2cf36$var$SEMATTRS_MESSAGING_MESSAGE_PAYLOAD_COMPRESSED_SIZE_BYTES, $281a441cdcb2cf36$var$SEMATTRS_MESSAGING_OPERATION, $281a441cdcb2cf36$var$SEMATTRS_MESSAGING_CONSUMER_ID, $281a441cdcb2cf36$var$SEMATTRS_MESSAGING_RABBITMQ_ROUTING_KEY, $281a441cdcb2cf36$var$SEMATTRS_MESSAGING_KAFKA_MESSAGE_KEY, $281a441cdcb2cf36$var$SEMATTRS_MESSAGING_KAFKA_CONSUMER_GROUP, $281a441cdcb2cf36$var$SEMATTRS_MESSAGING_KAFKA_CLIENT_ID, $281a441cdcb2cf36$var$SEMATTRS_MESSAGING_KAFKA_PARTITION, $281a441cdcb2cf36$var$SEMATTRS_MESSAGING_KAFKA_TOMBSTONE, $281a441cdcb2cf36$var$SEMATTRS_RPC_SYSTEM, $281a441cdcb2cf36$var$SEMATTRS_RPC_SERVICE, $281a441cdcb2cf36$var$SEMATTRS_RPC_METHOD, $281a441cdcb2cf36$var$SEMATTRS_RPC_GRPC_STATUS_CODE, $281a441cdcb2cf36$var$SEMATTRS_RPC_JSONRPC_VERSION, $281a441cdcb2cf36$var$SEMATTRS_RPC_JSONRPC_REQUEST_ID, $281a441cdcb2cf36$var$SEMATTRS_RPC_JSONRPC_ERROR_CODE, $281a441cdcb2cf36$var$SEMATTRS_RPC_JSONRPC_ERROR_MESSAGE, $281a441cdcb2cf36$var$SEMATTRS_MESSAGE_TYPE, $281a441cdcb2cf36$var$SEMATTRS_MESSAGE_ID, $281a441cdcb2cf36$var$SEMATTRS_MESSAGE_COMPRESSED_SIZE, $281a441cdcb2cf36$var$SEMATTRS_MESSAGE_UNCOMPRESSED_SIZE, $281a441cdcb2cf36$var$SemanticAttributes, $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_OTHER_SQL, $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_MSSQL, $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_MYSQL, $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_ORACLE, $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_DB2, $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_POSTGRESQL, $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_REDSHIFT, $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_HIVE, $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_CLOUDSCAPE, $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_HSQLDB, $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_PROGRESS, $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_MAXDB, $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_HANADB, $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_INGRES, $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_FIRSTSQL, $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_EDB, $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_CACHE, $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_ADABAS, $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_FIREBIRD, $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_DERBY, $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_FILEMAKER, $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_INFORMIX, $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_INSTANTDB, $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_INTERBASE, $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_MARIADB, $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_NETEZZA, $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_PERVASIVE, $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_POINTBASE, $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_SQLITE, $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_SYBASE, $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_TERADATA, $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_VERTICA, $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_H2, $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_COLDFUSION, $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_CASSANDRA, $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_HBASE, $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_MONGODB, $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_REDIS, $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_COUCHBASE, $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_COUCHDB, $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_COSMOSDB, $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_DYNAMODB, $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_NEO4J, $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_GEODE, $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_ELASTICSEARCH, $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_MEMCACHED, $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_COCKROACHDB, $281a441cdcb2cf36$var$DBSYSTEMVALUES_OTHER_SQL, $281a441cdcb2cf36$var$DBSYSTEMVALUES_MSSQL, $281a441cdcb2cf36$var$DBSYSTEMVALUES_MYSQL, $281a441cdcb2cf36$var$DBSYSTEMVALUES_ORACLE, $281a441cdcb2cf36$var$DBSYSTEMVALUES_DB2, $281a441cdcb2cf36$var$DBSYSTEMVALUES_POSTGRESQL, $281a441cdcb2cf36$var$DBSYSTEMVALUES_REDSHIFT, $281a441cdcb2cf36$var$DBSYSTEMVALUES_HIVE, $281a441cdcb2cf36$var$DBSYSTEMVALUES_CLOUDSCAPE, $281a441cdcb2cf36$var$DBSYSTEMVALUES_HSQLDB, $281a441cdcb2cf36$var$DBSYSTEMVALUES_PROGRESS, $281a441cdcb2cf36$var$DBSYSTEMVALUES_MAXDB, $281a441cdcb2cf36$var$DBSYSTEMVALUES_HANADB, $281a441cdcb2cf36$var$DBSYSTEMVALUES_INGRES, $281a441cdcb2cf36$var$DBSYSTEMVALUES_FIRSTSQL, $281a441cdcb2cf36$var$DBSYSTEMVALUES_EDB, $281a441cdcb2cf36$var$DBSYSTEMVALUES_CACHE, $281a441cdcb2cf36$var$DBSYSTEMVALUES_ADABAS, $281a441cdcb2cf36$var$DBSYSTEMVALUES_FIREBIRD, $281a441cdcb2cf36$var$DBSYSTEMVALUES_DERBY, $281a441cdcb2cf36$var$DBSYSTEMVALUES_FILEMAKER, $281a441cdcb2cf36$var$DBSYSTEMVALUES_INFORMIX, $281a441cdcb2cf36$var$DBSYSTEMVALUES_INSTANTDB, $281a441cdcb2cf36$var$DBSYSTEMVALUES_INTERBASE, $281a441cdcb2cf36$var$DBSYSTEMVALUES_MARIADB, $281a441cdcb2cf36$var$DBSYSTEMVALUES_NETEZZA, $281a441cdcb2cf36$var$DBSYSTEMVALUES_PERVASIVE, $281a441cdcb2cf36$var$DBSYSTEMVALUES_POINTBASE, $281a441cdcb2cf36$var$DBSYSTEMVALUES_SQLITE, $281a441cdcb2cf36$var$DBSYSTEMVALUES_SYBASE, $281a441cdcb2cf36$var$DBSYSTEMVALUES_TERADATA, $281a441cdcb2cf36$var$DBSYSTEMVALUES_VERTICA, $281a441cdcb2cf36$var$DBSYSTEMVALUES_H2, $281a441cdcb2cf36$var$DBSYSTEMVALUES_COLDFUSION, $281a441cdcb2cf36$var$DBSYSTEMVALUES_CASSANDRA, $281a441cdcb2cf36$var$DBSYSTEMVALUES_HBASE, $281a441cdcb2cf36$var$DBSYSTEMVALUES_MONGODB, $281a441cdcb2cf36$var$DBSYSTEMVALUES_REDIS, $281a441cdcb2cf36$var$DBSYSTEMVALUES_COUCHBASE, $281a441cdcb2cf36$var$DBSYSTEMVALUES_COUCHDB, $281a441cdcb2cf36$var$DBSYSTEMVALUES_COSMOSDB, $281a441cdcb2cf36$var$DBSYSTEMVALUES_DYNAMODB, $281a441cdcb2cf36$var$DBSYSTEMVALUES_NEO4J, $281a441cdcb2cf36$var$DBSYSTEMVALUES_GEODE, $281a441cdcb2cf36$var$DBSYSTEMVALUES_ELASTICSEARCH, $281a441cdcb2cf36$var$DBSYSTEMVALUES_MEMCACHED, $281a441cdcb2cf36$var$DBSYSTEMVALUES_COCKROACHDB, $281a441cdcb2cf36$var$DbSystemValues, $281a441cdcb2cf36$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ALL, $281a441cdcb2cf36$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_EACH_QUORUM, $281a441cdcb2cf36$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_QUORUM, $281a441cdcb2cf36$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_QUORUM, $281a441cdcb2cf36$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ONE, $281a441cdcb2cf36$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_TWO, $281a441cdcb2cf36$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_THREE, $281a441cdcb2cf36$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_ONE, $281a441cdcb2cf36$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ANY, $281a441cdcb2cf36$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_SERIAL, $281a441cdcb2cf36$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_SERIAL, $281a441cdcb2cf36$var$DBCASSANDRACONSISTENCYLEVELVALUES_ALL, $281a441cdcb2cf36$var$DBCASSANDRACONSISTENCYLEVELVALUES_EACH_QUORUM, $281a441cdcb2cf36$var$DBCASSANDRACONSISTENCYLEVELVALUES_QUORUM, $281a441cdcb2cf36$var$DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_QUORUM, $281a441cdcb2cf36$var$DBCASSANDRACONSISTENCYLEVELVALUES_ONE, $281a441cdcb2cf36$var$DBCASSANDRACONSISTENCYLEVELVALUES_TWO, $281a441cdcb2cf36$var$DBCASSANDRACONSISTENCYLEVELVALUES_THREE, $281a441cdcb2cf36$var$DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_ONE, $281a441cdcb2cf36$var$DBCASSANDRACONSISTENCYLEVELVALUES_ANY, $281a441cdcb2cf36$var$DBCASSANDRACONSISTENCYLEVELVALUES_SERIAL, $281a441cdcb2cf36$var$DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_SERIAL, $281a441cdcb2cf36$var$DbCassandraConsistencyLevelValues, $281a441cdcb2cf36$var$TMP_FAASTRIGGERVALUES_DATASOURCE, $281a441cdcb2cf36$var$TMP_FAASTRIGGERVALUES_HTTP, $281a441cdcb2cf36$var$TMP_FAASTRIGGERVALUES_PUBSUB, $281a441cdcb2cf36$var$TMP_FAASTRIGGERVALUES_TIMER, $281a441cdcb2cf36$var$TMP_FAASTRIGGERVALUES_OTHER, $281a441cdcb2cf36$var$FAASTRIGGERVALUES_DATASOURCE, $281a441cdcb2cf36$var$FAASTRIGGERVALUES_HTTP, $281a441cdcb2cf36$var$FAASTRIGGERVALUES_PUBSUB, $281a441cdcb2cf36$var$FAASTRIGGERVALUES_TIMER, $281a441cdcb2cf36$var$FAASTRIGGERVALUES_OTHER, $281a441cdcb2cf36$var$FaasTriggerValues, $281a441cdcb2cf36$var$TMP_FAASDOCUMENTOPERATIONVALUES_INSERT, $281a441cdcb2cf36$var$TMP_FAASDOCUMENTOPERATIONVALUES_EDIT, $281a441cdcb2cf36$var$TMP_FAASDOCUMENTOPERATIONVALUES_DELETE, $281a441cdcb2cf36$var$FAASDOCUMENTOPERATIONVALUES_INSERT, $281a441cdcb2cf36$var$FAASDOCUMENTOPERATIONVALUES_EDIT, $281a441cdcb2cf36$var$FAASDOCUMENTOPERATIONVALUES_DELETE, $281a441cdcb2cf36$var$FaasDocumentOperationValues, $281a441cdcb2cf36$var$TMP_FAASINVOKEDPROVIDERVALUES_ALIBABA_CLOUD, $281a441cdcb2cf36$var$TMP_FAASINVOKEDPROVIDERVALUES_AWS, $281a441cdcb2cf36$var$TMP_FAASINVOKEDPROVIDERVALUES_AZURE, $281a441cdcb2cf36$var$TMP_FAASINVOKEDPROVIDERVALUES_GCP, $281a441cdcb2cf36$var$FAASINVOKEDPROVIDERVALUES_ALIBABA_CLOUD, $281a441cdcb2cf36$var$FAASINVOKEDPROVIDERVALUES_AWS, $281a441cdcb2cf36$var$FAASINVOKEDPROVIDERVALUES_AZURE, $281a441cdcb2cf36$var$FAASINVOKEDPROVIDERVALUES_GCP, $281a441cdcb2cf36$var$FaasInvokedProviderValues, $281a441cdcb2cf36$var$TMP_NETTRANSPORTVALUES_IP_TCP, $281a441cdcb2cf36$var$TMP_NETTRANSPORTVALUES_IP_UDP, $281a441cdcb2cf36$var$TMP_NETTRANSPORTVALUES_IP, $281a441cdcb2cf36$var$TMP_NETTRANSPORTVALUES_UNIX, $281a441cdcb2cf36$var$TMP_NETTRANSPORTVALUES_PIPE, $281a441cdcb2cf36$var$TMP_NETTRANSPORTVALUES_INPROC, $281a441cdcb2cf36$var$TMP_NETTRANSPORTVALUES_OTHER, $281a441cdcb2cf36$var$NETTRANSPORTVALUES_IP_TCP, $281a441cdcb2cf36$var$NETTRANSPORTVALUES_IP_UDP, $281a441cdcb2cf36$var$NETTRANSPORTVALUES_IP, $281a441cdcb2cf36$var$NETTRANSPORTVALUES_UNIX, $281a441cdcb2cf36$var$NETTRANSPORTVALUES_PIPE, $281a441cdcb2cf36$var$NETTRANSPORTVALUES_INPROC, $281a441cdcb2cf36$var$NETTRANSPORTVALUES_OTHER, $281a441cdcb2cf36$var$NetTransportValues, $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONTYPEVALUES_WIFI, $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONTYPEVALUES_WIRED, $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONTYPEVALUES_CELL, $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONTYPEVALUES_UNAVAILABLE, $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONTYPEVALUES_UNKNOWN, $281a441cdcb2cf36$var$NETHOSTCONNECTIONTYPEVALUES_WIFI, $281a441cdcb2cf36$var$NETHOSTCONNECTIONTYPEVALUES_WIRED, $281a441cdcb2cf36$var$NETHOSTCONNECTIONTYPEVALUES_CELL, $281a441cdcb2cf36$var$NETHOSTCONNECTIONTYPEVALUES_UNAVAILABLE, $281a441cdcb2cf36$var$NETHOSTCONNECTIONTYPEVALUES_UNKNOWN, $281a441cdcb2cf36$var$NetHostConnectionTypeValues, $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_GPRS, $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EDGE, $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_UMTS, $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_CDMA, $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_0, $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_A, $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_CDMA2000_1XRTT, $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSDPA, $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSUPA, $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSPA, $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_IDEN, $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_B, $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_LTE, $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EHRPD, $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSPAP, $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_GSM, $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_TD_SCDMA, $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_IWLAN, $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_NR, $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_NRNSA, $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_LTE_CA, $281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_GPRS, $281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_EDGE, $281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_UMTS, $281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_CDMA, $281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_0, $281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_A, $281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_CDMA2000_1XRTT, $281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_HSDPA, $281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_HSUPA, $281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_HSPA, $281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_IDEN, $281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_B, $281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_LTE, $281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_EHRPD, $281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_HSPAP, $281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_GSM, $281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_TD_SCDMA, $281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_IWLAN, $281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_NR, $281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_NRNSA, $281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_LTE_CA, $281a441cdcb2cf36$var$NetHostConnectionSubtypeValues, $281a441cdcb2cf36$var$TMP_HTTPFLAVORVALUES_HTTP_1_0, $281a441cdcb2cf36$var$TMP_HTTPFLAVORVALUES_HTTP_1_1, $281a441cdcb2cf36$var$TMP_HTTPFLAVORVALUES_HTTP_2_0, $281a441cdcb2cf36$var$TMP_HTTPFLAVORVALUES_SPDY, $281a441cdcb2cf36$var$TMP_HTTPFLAVORVALUES_QUIC, $281a441cdcb2cf36$var$HTTPFLAVORVALUES_HTTP_1_0, $281a441cdcb2cf36$var$HTTPFLAVORVALUES_HTTP_1_1, $281a441cdcb2cf36$var$HTTPFLAVORVALUES_HTTP_2_0, $281a441cdcb2cf36$var$HTTPFLAVORVALUES_SPDY, $281a441cdcb2cf36$var$HTTPFLAVORVALUES_QUIC, $281a441cdcb2cf36$var$HttpFlavorValues, $281a441cdcb2cf36$var$TMP_MESSAGINGDESTINATIONKINDVALUES_QUEUE, $281a441cdcb2cf36$var$TMP_MESSAGINGDESTINATIONKINDVALUES_TOPIC, $281a441cdcb2cf36$var$MESSAGINGDESTINATIONKINDVALUES_QUEUE, $281a441cdcb2cf36$var$MESSAGINGDESTINATIONKINDVALUES_TOPIC, $281a441cdcb2cf36$var$MessagingDestinationKindValues, $281a441cdcb2cf36$var$TMP_MESSAGINGOPERATIONVALUES_RECEIVE, $281a441cdcb2cf36$var$TMP_MESSAGINGOPERATIONVALUES_PROCESS, $281a441cdcb2cf36$var$MESSAGINGOPERATIONVALUES_RECEIVE, $281a441cdcb2cf36$var$MESSAGINGOPERATIONVALUES_PROCESS, $281a441cdcb2cf36$var$MessagingOperationValues, $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_OK, $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_CANCELLED, $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_UNKNOWN, $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_INVALID_ARGUMENT, $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_DEADLINE_EXCEEDED, $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_NOT_FOUND, $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_ALREADY_EXISTS, $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_PERMISSION_DENIED, $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_RESOURCE_EXHAUSTED, $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_FAILED_PRECONDITION, $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_ABORTED, $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_OUT_OF_RANGE, $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_UNIMPLEMENTED, $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_INTERNAL, $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_UNAVAILABLE, $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_DATA_LOSS, $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_UNAUTHENTICATED, $281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_OK, $281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_CANCELLED, $281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_UNKNOWN, $281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_INVALID_ARGUMENT, $281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_DEADLINE_EXCEEDED, $281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_NOT_FOUND, $281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_ALREADY_EXISTS, $281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_PERMISSION_DENIED, $281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_RESOURCE_EXHAUSTED, $281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_FAILED_PRECONDITION, $281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_ABORTED, $281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_OUT_OF_RANGE, $281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_UNIMPLEMENTED, $281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_INTERNAL, $281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_UNAVAILABLE, $281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_DATA_LOSS, $281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_UNAUTHENTICATED, $281a441cdcb2cf36$var$RpcGrpcStatusCodeValues, $281a441cdcb2cf36$var$TMP_MESSAGETYPEVALUES_SENT, $281a441cdcb2cf36$var$TMP_MESSAGETYPEVALUES_RECEIVED, $281a441cdcb2cf36$var$MESSAGETYPEVALUES_SENT, $281a441cdcb2cf36$var$MESSAGETYPEVALUES_RECEIVED, $281a441cdcb2cf36$var$MessageTypeValues;
var $281a441cdcb2cf36$var$init_SemanticAttributes = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/semantic-conventions/build/esm/trace/SemanticAttributes.js" () {
        $281a441cdcb2cf36$var$init_utils4();
        $281a441cdcb2cf36$var$TMP_AWS_LAMBDA_INVOKED_ARN = "aws.lambda.invoked_arn";
        $281a441cdcb2cf36$var$TMP_DB_SYSTEM = "db.system";
        $281a441cdcb2cf36$var$TMP_DB_CONNECTION_STRING = "db.connection_string";
        $281a441cdcb2cf36$var$TMP_DB_USER = "db.user";
        $281a441cdcb2cf36$var$TMP_DB_JDBC_DRIVER_CLASSNAME = "db.jdbc.driver_classname";
        $281a441cdcb2cf36$var$TMP_DB_NAME = "db.name";
        $281a441cdcb2cf36$var$TMP_DB_STATEMENT = "db.statement";
        $281a441cdcb2cf36$var$TMP_DB_OPERATION = "db.operation";
        $281a441cdcb2cf36$var$TMP_DB_MSSQL_INSTANCE_NAME = "db.mssql.instance_name";
        $281a441cdcb2cf36$var$TMP_DB_CASSANDRA_KEYSPACE = "db.cassandra.keyspace";
        $281a441cdcb2cf36$var$TMP_DB_CASSANDRA_PAGE_SIZE = "db.cassandra.page_size";
        $281a441cdcb2cf36$var$TMP_DB_CASSANDRA_CONSISTENCY_LEVEL = "db.cassandra.consistency_level";
        $281a441cdcb2cf36$var$TMP_DB_CASSANDRA_TABLE = "db.cassandra.table";
        $281a441cdcb2cf36$var$TMP_DB_CASSANDRA_IDEMPOTENCE = "db.cassandra.idempotence";
        $281a441cdcb2cf36$var$TMP_DB_CASSANDRA_SPECULATIVE_EXECUTION_COUNT = "db.cassandra.speculative_execution_count";
        $281a441cdcb2cf36$var$TMP_DB_CASSANDRA_COORDINATOR_ID = "db.cassandra.coordinator.id";
        $281a441cdcb2cf36$var$TMP_DB_CASSANDRA_COORDINATOR_DC = "db.cassandra.coordinator.dc";
        $281a441cdcb2cf36$var$TMP_DB_HBASE_NAMESPACE = "db.hbase.namespace";
        $281a441cdcb2cf36$var$TMP_DB_REDIS_DATABASE_INDEX = "db.redis.database_index";
        $281a441cdcb2cf36$var$TMP_DB_MONGODB_COLLECTION = "db.mongodb.collection";
        $281a441cdcb2cf36$var$TMP_DB_SQL_TABLE = "db.sql.table";
        $281a441cdcb2cf36$var$TMP_EXCEPTION_TYPE = "exception.type";
        $281a441cdcb2cf36$var$TMP_EXCEPTION_MESSAGE = "exception.message";
        $281a441cdcb2cf36$var$TMP_EXCEPTION_STACKTRACE = "exception.stacktrace";
        $281a441cdcb2cf36$var$TMP_EXCEPTION_ESCAPED = "exception.escaped";
        $281a441cdcb2cf36$var$TMP_FAAS_TRIGGER = "faas.trigger";
        $281a441cdcb2cf36$var$TMP_FAAS_EXECUTION = "faas.execution";
        $281a441cdcb2cf36$var$TMP_FAAS_DOCUMENT_COLLECTION = "faas.document.collection";
        $281a441cdcb2cf36$var$TMP_FAAS_DOCUMENT_OPERATION = "faas.document.operation";
        $281a441cdcb2cf36$var$TMP_FAAS_DOCUMENT_TIME = "faas.document.time";
        $281a441cdcb2cf36$var$TMP_FAAS_DOCUMENT_NAME = "faas.document.name";
        $281a441cdcb2cf36$var$TMP_FAAS_TIME = "faas.time";
        $281a441cdcb2cf36$var$TMP_FAAS_CRON = "faas.cron";
        $281a441cdcb2cf36$var$TMP_FAAS_COLDSTART = "faas.coldstart";
        $281a441cdcb2cf36$var$TMP_FAAS_INVOKED_NAME = "faas.invoked_name";
        $281a441cdcb2cf36$var$TMP_FAAS_INVOKED_PROVIDER = "faas.invoked_provider";
        $281a441cdcb2cf36$var$TMP_FAAS_INVOKED_REGION = "faas.invoked_region";
        $281a441cdcb2cf36$var$TMP_NET_TRANSPORT = "net.transport";
        $281a441cdcb2cf36$var$TMP_NET_PEER_IP = "net.peer.ip";
        $281a441cdcb2cf36$var$TMP_NET_PEER_PORT = "net.peer.port";
        $281a441cdcb2cf36$var$TMP_NET_PEER_NAME = "net.peer.name";
        $281a441cdcb2cf36$var$TMP_NET_HOST_IP = "net.host.ip";
        $281a441cdcb2cf36$var$TMP_NET_HOST_PORT = "net.host.port";
        $281a441cdcb2cf36$var$TMP_NET_HOST_NAME = "net.host.name";
        $281a441cdcb2cf36$var$TMP_NET_HOST_CONNECTION_TYPE = "net.host.connection.type";
        $281a441cdcb2cf36$var$TMP_NET_HOST_CONNECTION_SUBTYPE = "net.host.connection.subtype";
        $281a441cdcb2cf36$var$TMP_NET_HOST_CARRIER_NAME = "net.host.carrier.name";
        $281a441cdcb2cf36$var$TMP_NET_HOST_CARRIER_MCC = "net.host.carrier.mcc";
        $281a441cdcb2cf36$var$TMP_NET_HOST_CARRIER_MNC = "net.host.carrier.mnc";
        $281a441cdcb2cf36$var$TMP_NET_HOST_CARRIER_ICC = "net.host.carrier.icc";
        $281a441cdcb2cf36$var$TMP_PEER_SERVICE = "peer.service";
        $281a441cdcb2cf36$var$TMP_ENDUSER_ID = "enduser.id";
        $281a441cdcb2cf36$var$TMP_ENDUSER_ROLE = "enduser.role";
        $281a441cdcb2cf36$var$TMP_ENDUSER_SCOPE = "enduser.scope";
        $281a441cdcb2cf36$var$TMP_THREAD_ID = "thread.id";
        $281a441cdcb2cf36$var$TMP_THREAD_NAME = "thread.name";
        $281a441cdcb2cf36$var$TMP_CODE_FUNCTION = "code.function";
        $281a441cdcb2cf36$var$TMP_CODE_NAMESPACE = "code.namespace";
        $281a441cdcb2cf36$var$TMP_CODE_FILEPATH = "code.filepath";
        $281a441cdcb2cf36$var$TMP_CODE_LINENO = "code.lineno";
        $281a441cdcb2cf36$var$TMP_HTTP_METHOD = "http.method";
        $281a441cdcb2cf36$var$TMP_HTTP_URL = "http.url";
        $281a441cdcb2cf36$var$TMP_HTTP_TARGET = "http.target";
        $281a441cdcb2cf36$var$TMP_HTTP_HOST = "http.host";
        $281a441cdcb2cf36$var$TMP_HTTP_SCHEME = "http.scheme";
        $281a441cdcb2cf36$var$TMP_HTTP_STATUS_CODE = "http.status_code";
        $281a441cdcb2cf36$var$TMP_HTTP_FLAVOR = "http.flavor";
        $281a441cdcb2cf36$var$TMP_HTTP_USER_AGENT = "http.user_agent";
        $281a441cdcb2cf36$var$TMP_HTTP_REQUEST_CONTENT_LENGTH = "http.request_content_length";
        $281a441cdcb2cf36$var$TMP_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED = "http.request_content_length_uncompressed";
        $281a441cdcb2cf36$var$TMP_HTTP_RESPONSE_CONTENT_LENGTH = "http.response_content_length";
        $281a441cdcb2cf36$var$TMP_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED = "http.response_content_length_uncompressed";
        $281a441cdcb2cf36$var$TMP_HTTP_SERVER_NAME = "http.server_name";
        $281a441cdcb2cf36$var$TMP_HTTP_ROUTE = "http.route";
        $281a441cdcb2cf36$var$TMP_HTTP_CLIENT_IP = "http.client_ip";
        $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_TABLE_NAMES = "aws.dynamodb.table_names";
        $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_CONSUMED_CAPACITY = "aws.dynamodb.consumed_capacity";
        $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_ITEM_COLLECTION_METRICS = "aws.dynamodb.item_collection_metrics";
        $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_PROVISIONED_READ_CAPACITY = "aws.dynamodb.provisioned_read_capacity";
        $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY = "aws.dynamodb.provisioned_write_capacity";
        $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_CONSISTENT_READ = "aws.dynamodb.consistent_read";
        $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_PROJECTION = "aws.dynamodb.projection";
        $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_LIMIT = "aws.dynamodb.limit";
        $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_ATTRIBUTES_TO_GET = "aws.dynamodb.attributes_to_get";
        $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_INDEX_NAME = "aws.dynamodb.index_name";
        $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_SELECT = "aws.dynamodb.select";
        $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES = "aws.dynamodb.global_secondary_indexes";
        $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES = "aws.dynamodb.local_secondary_indexes";
        $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_EXCLUSIVE_START_TABLE = "aws.dynamodb.exclusive_start_table";
        $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_TABLE_COUNT = "aws.dynamodb.table_count";
        $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_SCAN_FORWARD = "aws.dynamodb.scan_forward";
        $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_SEGMENT = "aws.dynamodb.segment";
        $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_TOTAL_SEGMENTS = "aws.dynamodb.total_segments";
        $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_COUNT = "aws.dynamodb.count";
        $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_SCANNED_COUNT = "aws.dynamodb.scanned_count";
        $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS = "aws.dynamodb.attribute_definitions";
        $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES = "aws.dynamodb.global_secondary_index_updates";
        $281a441cdcb2cf36$var$TMP_MESSAGING_SYSTEM = "messaging.system";
        $281a441cdcb2cf36$var$TMP_MESSAGING_DESTINATION = "messaging.destination";
        $281a441cdcb2cf36$var$TMP_MESSAGING_DESTINATION_KIND = "messaging.destination_kind";
        $281a441cdcb2cf36$var$TMP_MESSAGING_TEMP_DESTINATION = "messaging.temp_destination";
        $281a441cdcb2cf36$var$TMP_MESSAGING_PROTOCOL = "messaging.protocol";
        $281a441cdcb2cf36$var$TMP_MESSAGING_PROTOCOL_VERSION = "messaging.protocol_version";
        $281a441cdcb2cf36$var$TMP_MESSAGING_URL = "messaging.url";
        $281a441cdcb2cf36$var$TMP_MESSAGING_MESSAGE_ID = "messaging.message_id";
        $281a441cdcb2cf36$var$TMP_MESSAGING_CONVERSATION_ID = "messaging.conversation_id";
        $281a441cdcb2cf36$var$TMP_MESSAGING_MESSAGE_PAYLOAD_SIZE_BYTES = "messaging.message_payload_size_bytes";
        $281a441cdcb2cf36$var$TMP_MESSAGING_MESSAGE_PAYLOAD_COMPRESSED_SIZE_BYTES = "messaging.message_payload_compressed_size_bytes";
        $281a441cdcb2cf36$var$TMP_MESSAGING_OPERATION = "messaging.operation";
        $281a441cdcb2cf36$var$TMP_MESSAGING_CONSUMER_ID = "messaging.consumer_id";
        $281a441cdcb2cf36$var$TMP_MESSAGING_RABBITMQ_ROUTING_KEY = "messaging.rabbitmq.routing_key";
        $281a441cdcb2cf36$var$TMP_MESSAGING_KAFKA_MESSAGE_KEY = "messaging.kafka.message_key";
        $281a441cdcb2cf36$var$TMP_MESSAGING_KAFKA_CONSUMER_GROUP = "messaging.kafka.consumer_group";
        $281a441cdcb2cf36$var$TMP_MESSAGING_KAFKA_CLIENT_ID = "messaging.kafka.client_id";
        $281a441cdcb2cf36$var$TMP_MESSAGING_KAFKA_PARTITION = "messaging.kafka.partition";
        $281a441cdcb2cf36$var$TMP_MESSAGING_KAFKA_TOMBSTONE = "messaging.kafka.tombstone";
        $281a441cdcb2cf36$var$TMP_RPC_SYSTEM = "rpc.system";
        $281a441cdcb2cf36$var$TMP_RPC_SERVICE = "rpc.service";
        $281a441cdcb2cf36$var$TMP_RPC_METHOD = "rpc.method";
        $281a441cdcb2cf36$var$TMP_RPC_GRPC_STATUS_CODE = "rpc.grpc.status_code";
        $281a441cdcb2cf36$var$TMP_RPC_JSONRPC_VERSION = "rpc.jsonrpc.version";
        $281a441cdcb2cf36$var$TMP_RPC_JSONRPC_REQUEST_ID = "rpc.jsonrpc.request_id";
        $281a441cdcb2cf36$var$TMP_RPC_JSONRPC_ERROR_CODE = "rpc.jsonrpc.error_code";
        $281a441cdcb2cf36$var$TMP_RPC_JSONRPC_ERROR_MESSAGE = "rpc.jsonrpc.error_message";
        $281a441cdcb2cf36$var$TMP_MESSAGE_TYPE = "message.type";
        $281a441cdcb2cf36$var$TMP_MESSAGE_ID = "message.id";
        $281a441cdcb2cf36$var$TMP_MESSAGE_COMPRESSED_SIZE = "message.compressed_size";
        $281a441cdcb2cf36$var$TMP_MESSAGE_UNCOMPRESSED_SIZE = "message.uncompressed_size";
        $281a441cdcb2cf36$var$SEMATTRS_AWS_LAMBDA_INVOKED_ARN = $281a441cdcb2cf36$var$TMP_AWS_LAMBDA_INVOKED_ARN;
        $281a441cdcb2cf36$var$SEMATTRS_DB_SYSTEM = $281a441cdcb2cf36$var$TMP_DB_SYSTEM;
        $281a441cdcb2cf36$var$SEMATTRS_DB_CONNECTION_STRING = $281a441cdcb2cf36$var$TMP_DB_CONNECTION_STRING;
        $281a441cdcb2cf36$var$SEMATTRS_DB_USER = $281a441cdcb2cf36$var$TMP_DB_USER;
        $281a441cdcb2cf36$var$SEMATTRS_DB_JDBC_DRIVER_CLASSNAME = $281a441cdcb2cf36$var$TMP_DB_JDBC_DRIVER_CLASSNAME;
        $281a441cdcb2cf36$var$SEMATTRS_DB_NAME = $281a441cdcb2cf36$var$TMP_DB_NAME;
        $281a441cdcb2cf36$var$SEMATTRS_DB_STATEMENT = $281a441cdcb2cf36$var$TMP_DB_STATEMENT;
        $281a441cdcb2cf36$var$SEMATTRS_DB_OPERATION = $281a441cdcb2cf36$var$TMP_DB_OPERATION;
        $281a441cdcb2cf36$var$SEMATTRS_DB_MSSQL_INSTANCE_NAME = $281a441cdcb2cf36$var$TMP_DB_MSSQL_INSTANCE_NAME;
        $281a441cdcb2cf36$var$SEMATTRS_DB_CASSANDRA_KEYSPACE = $281a441cdcb2cf36$var$TMP_DB_CASSANDRA_KEYSPACE;
        $281a441cdcb2cf36$var$SEMATTRS_DB_CASSANDRA_PAGE_SIZE = $281a441cdcb2cf36$var$TMP_DB_CASSANDRA_PAGE_SIZE;
        $281a441cdcb2cf36$var$SEMATTRS_DB_CASSANDRA_CONSISTENCY_LEVEL = $281a441cdcb2cf36$var$TMP_DB_CASSANDRA_CONSISTENCY_LEVEL;
        $281a441cdcb2cf36$var$SEMATTRS_DB_CASSANDRA_TABLE = $281a441cdcb2cf36$var$TMP_DB_CASSANDRA_TABLE;
        $281a441cdcb2cf36$var$SEMATTRS_DB_CASSANDRA_IDEMPOTENCE = $281a441cdcb2cf36$var$TMP_DB_CASSANDRA_IDEMPOTENCE;
        $281a441cdcb2cf36$var$SEMATTRS_DB_CASSANDRA_SPECULATIVE_EXECUTION_COUNT = $281a441cdcb2cf36$var$TMP_DB_CASSANDRA_SPECULATIVE_EXECUTION_COUNT;
        $281a441cdcb2cf36$var$SEMATTRS_DB_CASSANDRA_COORDINATOR_ID = $281a441cdcb2cf36$var$TMP_DB_CASSANDRA_COORDINATOR_ID;
        $281a441cdcb2cf36$var$SEMATTRS_DB_CASSANDRA_COORDINATOR_DC = $281a441cdcb2cf36$var$TMP_DB_CASSANDRA_COORDINATOR_DC;
        $281a441cdcb2cf36$var$SEMATTRS_DB_HBASE_NAMESPACE = $281a441cdcb2cf36$var$TMP_DB_HBASE_NAMESPACE;
        $281a441cdcb2cf36$var$SEMATTRS_DB_REDIS_DATABASE_INDEX = $281a441cdcb2cf36$var$TMP_DB_REDIS_DATABASE_INDEX;
        $281a441cdcb2cf36$var$SEMATTRS_DB_MONGODB_COLLECTION = $281a441cdcb2cf36$var$TMP_DB_MONGODB_COLLECTION;
        $281a441cdcb2cf36$var$SEMATTRS_DB_SQL_TABLE = $281a441cdcb2cf36$var$TMP_DB_SQL_TABLE;
        $281a441cdcb2cf36$var$SEMATTRS_EXCEPTION_TYPE = $281a441cdcb2cf36$var$TMP_EXCEPTION_TYPE;
        $281a441cdcb2cf36$var$SEMATTRS_EXCEPTION_MESSAGE = $281a441cdcb2cf36$var$TMP_EXCEPTION_MESSAGE;
        $281a441cdcb2cf36$var$SEMATTRS_EXCEPTION_STACKTRACE = $281a441cdcb2cf36$var$TMP_EXCEPTION_STACKTRACE;
        $281a441cdcb2cf36$var$SEMATTRS_EXCEPTION_ESCAPED = $281a441cdcb2cf36$var$TMP_EXCEPTION_ESCAPED;
        $281a441cdcb2cf36$var$SEMATTRS_FAAS_TRIGGER = $281a441cdcb2cf36$var$TMP_FAAS_TRIGGER;
        $281a441cdcb2cf36$var$SEMATTRS_FAAS_EXECUTION = $281a441cdcb2cf36$var$TMP_FAAS_EXECUTION;
        $281a441cdcb2cf36$var$SEMATTRS_FAAS_DOCUMENT_COLLECTION = $281a441cdcb2cf36$var$TMP_FAAS_DOCUMENT_COLLECTION;
        $281a441cdcb2cf36$var$SEMATTRS_FAAS_DOCUMENT_OPERATION = $281a441cdcb2cf36$var$TMP_FAAS_DOCUMENT_OPERATION;
        $281a441cdcb2cf36$var$SEMATTRS_FAAS_DOCUMENT_TIME = $281a441cdcb2cf36$var$TMP_FAAS_DOCUMENT_TIME;
        $281a441cdcb2cf36$var$SEMATTRS_FAAS_DOCUMENT_NAME = $281a441cdcb2cf36$var$TMP_FAAS_DOCUMENT_NAME;
        $281a441cdcb2cf36$var$SEMATTRS_FAAS_TIME = $281a441cdcb2cf36$var$TMP_FAAS_TIME;
        $281a441cdcb2cf36$var$SEMATTRS_FAAS_CRON = $281a441cdcb2cf36$var$TMP_FAAS_CRON;
        $281a441cdcb2cf36$var$SEMATTRS_FAAS_COLDSTART = $281a441cdcb2cf36$var$TMP_FAAS_COLDSTART;
        $281a441cdcb2cf36$var$SEMATTRS_FAAS_INVOKED_NAME = $281a441cdcb2cf36$var$TMP_FAAS_INVOKED_NAME;
        $281a441cdcb2cf36$var$SEMATTRS_FAAS_INVOKED_PROVIDER = $281a441cdcb2cf36$var$TMP_FAAS_INVOKED_PROVIDER;
        $281a441cdcb2cf36$var$SEMATTRS_FAAS_INVOKED_REGION = $281a441cdcb2cf36$var$TMP_FAAS_INVOKED_REGION;
        $281a441cdcb2cf36$var$SEMATTRS_NET_TRANSPORT = $281a441cdcb2cf36$var$TMP_NET_TRANSPORT;
        $281a441cdcb2cf36$var$SEMATTRS_NET_PEER_IP = $281a441cdcb2cf36$var$TMP_NET_PEER_IP;
        $281a441cdcb2cf36$var$SEMATTRS_NET_PEER_PORT = $281a441cdcb2cf36$var$TMP_NET_PEER_PORT;
        $281a441cdcb2cf36$var$SEMATTRS_NET_PEER_NAME = $281a441cdcb2cf36$var$TMP_NET_PEER_NAME;
        $281a441cdcb2cf36$var$SEMATTRS_NET_HOST_IP = $281a441cdcb2cf36$var$TMP_NET_HOST_IP;
        $281a441cdcb2cf36$var$SEMATTRS_NET_HOST_PORT = $281a441cdcb2cf36$var$TMP_NET_HOST_PORT;
        $281a441cdcb2cf36$var$SEMATTRS_NET_HOST_NAME = $281a441cdcb2cf36$var$TMP_NET_HOST_NAME;
        $281a441cdcb2cf36$var$SEMATTRS_NET_HOST_CONNECTION_TYPE = $281a441cdcb2cf36$var$TMP_NET_HOST_CONNECTION_TYPE;
        $281a441cdcb2cf36$var$SEMATTRS_NET_HOST_CONNECTION_SUBTYPE = $281a441cdcb2cf36$var$TMP_NET_HOST_CONNECTION_SUBTYPE;
        $281a441cdcb2cf36$var$SEMATTRS_NET_HOST_CARRIER_NAME = $281a441cdcb2cf36$var$TMP_NET_HOST_CARRIER_NAME;
        $281a441cdcb2cf36$var$SEMATTRS_NET_HOST_CARRIER_MCC = $281a441cdcb2cf36$var$TMP_NET_HOST_CARRIER_MCC;
        $281a441cdcb2cf36$var$SEMATTRS_NET_HOST_CARRIER_MNC = $281a441cdcb2cf36$var$TMP_NET_HOST_CARRIER_MNC;
        $281a441cdcb2cf36$var$SEMATTRS_NET_HOST_CARRIER_ICC = $281a441cdcb2cf36$var$TMP_NET_HOST_CARRIER_ICC;
        $281a441cdcb2cf36$var$SEMATTRS_PEER_SERVICE = $281a441cdcb2cf36$var$TMP_PEER_SERVICE;
        $281a441cdcb2cf36$var$SEMATTRS_ENDUSER_ID = $281a441cdcb2cf36$var$TMP_ENDUSER_ID;
        $281a441cdcb2cf36$var$SEMATTRS_ENDUSER_ROLE = $281a441cdcb2cf36$var$TMP_ENDUSER_ROLE;
        $281a441cdcb2cf36$var$SEMATTRS_ENDUSER_SCOPE = $281a441cdcb2cf36$var$TMP_ENDUSER_SCOPE;
        $281a441cdcb2cf36$var$SEMATTRS_THREAD_ID = $281a441cdcb2cf36$var$TMP_THREAD_ID;
        $281a441cdcb2cf36$var$SEMATTRS_THREAD_NAME = $281a441cdcb2cf36$var$TMP_THREAD_NAME;
        $281a441cdcb2cf36$var$SEMATTRS_CODE_FUNCTION = $281a441cdcb2cf36$var$TMP_CODE_FUNCTION;
        $281a441cdcb2cf36$var$SEMATTRS_CODE_NAMESPACE = $281a441cdcb2cf36$var$TMP_CODE_NAMESPACE;
        $281a441cdcb2cf36$var$SEMATTRS_CODE_FILEPATH = $281a441cdcb2cf36$var$TMP_CODE_FILEPATH;
        $281a441cdcb2cf36$var$SEMATTRS_CODE_LINENO = $281a441cdcb2cf36$var$TMP_CODE_LINENO;
        $281a441cdcb2cf36$var$SEMATTRS_HTTP_METHOD = $281a441cdcb2cf36$var$TMP_HTTP_METHOD;
        $281a441cdcb2cf36$var$SEMATTRS_HTTP_URL = $281a441cdcb2cf36$var$TMP_HTTP_URL;
        $281a441cdcb2cf36$var$SEMATTRS_HTTP_TARGET = $281a441cdcb2cf36$var$TMP_HTTP_TARGET;
        $281a441cdcb2cf36$var$SEMATTRS_HTTP_HOST = $281a441cdcb2cf36$var$TMP_HTTP_HOST;
        $281a441cdcb2cf36$var$SEMATTRS_HTTP_SCHEME = $281a441cdcb2cf36$var$TMP_HTTP_SCHEME;
        $281a441cdcb2cf36$var$SEMATTRS_HTTP_STATUS_CODE = $281a441cdcb2cf36$var$TMP_HTTP_STATUS_CODE;
        $281a441cdcb2cf36$var$SEMATTRS_HTTP_FLAVOR = $281a441cdcb2cf36$var$TMP_HTTP_FLAVOR;
        $281a441cdcb2cf36$var$SEMATTRS_HTTP_USER_AGENT = $281a441cdcb2cf36$var$TMP_HTTP_USER_AGENT;
        $281a441cdcb2cf36$var$SEMATTRS_HTTP_REQUEST_CONTENT_LENGTH = $281a441cdcb2cf36$var$TMP_HTTP_REQUEST_CONTENT_LENGTH;
        $281a441cdcb2cf36$var$SEMATTRS_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED = $281a441cdcb2cf36$var$TMP_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED;
        $281a441cdcb2cf36$var$SEMATTRS_HTTP_RESPONSE_CONTENT_LENGTH = $281a441cdcb2cf36$var$TMP_HTTP_RESPONSE_CONTENT_LENGTH;
        $281a441cdcb2cf36$var$SEMATTRS_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED = $281a441cdcb2cf36$var$TMP_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED;
        $281a441cdcb2cf36$var$SEMATTRS_HTTP_SERVER_NAME = $281a441cdcb2cf36$var$TMP_HTTP_SERVER_NAME;
        $281a441cdcb2cf36$var$SEMATTRS_HTTP_ROUTE = $281a441cdcb2cf36$var$TMP_HTTP_ROUTE;
        $281a441cdcb2cf36$var$SEMATTRS_HTTP_CLIENT_IP = $281a441cdcb2cf36$var$TMP_HTTP_CLIENT_IP;
        $281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_TABLE_NAMES = $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_TABLE_NAMES;
        $281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_CONSUMED_CAPACITY = $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_CONSUMED_CAPACITY;
        $281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_ITEM_COLLECTION_METRICS = $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_ITEM_COLLECTION_METRICS;
        $281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_PROVISIONED_READ_CAPACITY = $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_PROVISIONED_READ_CAPACITY;
        $281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY = $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY;
        $281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_CONSISTENT_READ = $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_CONSISTENT_READ;
        $281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_PROJECTION = $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_PROJECTION;
        $281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_LIMIT = $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_LIMIT;
        $281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_ATTRIBUTES_TO_GET = $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_ATTRIBUTES_TO_GET;
        $281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_INDEX_NAME = $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_INDEX_NAME;
        $281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_SELECT = $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_SELECT;
        $281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES = $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES;
        $281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES = $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES;
        $281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_EXCLUSIVE_START_TABLE = $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_EXCLUSIVE_START_TABLE;
        $281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_TABLE_COUNT = $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_TABLE_COUNT;
        $281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_SCAN_FORWARD = $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_SCAN_FORWARD;
        $281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_SEGMENT = $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_SEGMENT;
        $281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_TOTAL_SEGMENTS = $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_TOTAL_SEGMENTS;
        $281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_COUNT = $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_COUNT;
        $281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_SCANNED_COUNT = $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_SCANNED_COUNT;
        $281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS = $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS;
        $281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES = $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES;
        $281a441cdcb2cf36$var$SEMATTRS_MESSAGING_SYSTEM = $281a441cdcb2cf36$var$TMP_MESSAGING_SYSTEM;
        $281a441cdcb2cf36$var$SEMATTRS_MESSAGING_DESTINATION = $281a441cdcb2cf36$var$TMP_MESSAGING_DESTINATION;
        $281a441cdcb2cf36$var$SEMATTRS_MESSAGING_DESTINATION_KIND = $281a441cdcb2cf36$var$TMP_MESSAGING_DESTINATION_KIND;
        $281a441cdcb2cf36$var$SEMATTRS_MESSAGING_TEMP_DESTINATION = $281a441cdcb2cf36$var$TMP_MESSAGING_TEMP_DESTINATION;
        $281a441cdcb2cf36$var$SEMATTRS_MESSAGING_PROTOCOL = $281a441cdcb2cf36$var$TMP_MESSAGING_PROTOCOL;
        $281a441cdcb2cf36$var$SEMATTRS_MESSAGING_PROTOCOL_VERSION = $281a441cdcb2cf36$var$TMP_MESSAGING_PROTOCOL_VERSION;
        $281a441cdcb2cf36$var$SEMATTRS_MESSAGING_URL = $281a441cdcb2cf36$var$TMP_MESSAGING_URL;
        $281a441cdcb2cf36$var$SEMATTRS_MESSAGING_MESSAGE_ID = $281a441cdcb2cf36$var$TMP_MESSAGING_MESSAGE_ID;
        $281a441cdcb2cf36$var$SEMATTRS_MESSAGING_CONVERSATION_ID = $281a441cdcb2cf36$var$TMP_MESSAGING_CONVERSATION_ID;
        $281a441cdcb2cf36$var$SEMATTRS_MESSAGING_MESSAGE_PAYLOAD_SIZE_BYTES = $281a441cdcb2cf36$var$TMP_MESSAGING_MESSAGE_PAYLOAD_SIZE_BYTES;
        $281a441cdcb2cf36$var$SEMATTRS_MESSAGING_MESSAGE_PAYLOAD_COMPRESSED_SIZE_BYTES = $281a441cdcb2cf36$var$TMP_MESSAGING_MESSAGE_PAYLOAD_COMPRESSED_SIZE_BYTES;
        $281a441cdcb2cf36$var$SEMATTRS_MESSAGING_OPERATION = $281a441cdcb2cf36$var$TMP_MESSAGING_OPERATION;
        $281a441cdcb2cf36$var$SEMATTRS_MESSAGING_CONSUMER_ID = $281a441cdcb2cf36$var$TMP_MESSAGING_CONSUMER_ID;
        $281a441cdcb2cf36$var$SEMATTRS_MESSAGING_RABBITMQ_ROUTING_KEY = $281a441cdcb2cf36$var$TMP_MESSAGING_RABBITMQ_ROUTING_KEY;
        $281a441cdcb2cf36$var$SEMATTRS_MESSAGING_KAFKA_MESSAGE_KEY = $281a441cdcb2cf36$var$TMP_MESSAGING_KAFKA_MESSAGE_KEY;
        $281a441cdcb2cf36$var$SEMATTRS_MESSAGING_KAFKA_CONSUMER_GROUP = $281a441cdcb2cf36$var$TMP_MESSAGING_KAFKA_CONSUMER_GROUP;
        $281a441cdcb2cf36$var$SEMATTRS_MESSAGING_KAFKA_CLIENT_ID = $281a441cdcb2cf36$var$TMP_MESSAGING_KAFKA_CLIENT_ID;
        $281a441cdcb2cf36$var$SEMATTRS_MESSAGING_KAFKA_PARTITION = $281a441cdcb2cf36$var$TMP_MESSAGING_KAFKA_PARTITION;
        $281a441cdcb2cf36$var$SEMATTRS_MESSAGING_KAFKA_TOMBSTONE = $281a441cdcb2cf36$var$TMP_MESSAGING_KAFKA_TOMBSTONE;
        $281a441cdcb2cf36$var$SEMATTRS_RPC_SYSTEM = $281a441cdcb2cf36$var$TMP_RPC_SYSTEM;
        $281a441cdcb2cf36$var$SEMATTRS_RPC_SERVICE = $281a441cdcb2cf36$var$TMP_RPC_SERVICE;
        $281a441cdcb2cf36$var$SEMATTRS_RPC_METHOD = $281a441cdcb2cf36$var$TMP_RPC_METHOD;
        $281a441cdcb2cf36$var$SEMATTRS_RPC_GRPC_STATUS_CODE = $281a441cdcb2cf36$var$TMP_RPC_GRPC_STATUS_CODE;
        $281a441cdcb2cf36$var$SEMATTRS_RPC_JSONRPC_VERSION = $281a441cdcb2cf36$var$TMP_RPC_JSONRPC_VERSION;
        $281a441cdcb2cf36$var$SEMATTRS_RPC_JSONRPC_REQUEST_ID = $281a441cdcb2cf36$var$TMP_RPC_JSONRPC_REQUEST_ID;
        $281a441cdcb2cf36$var$SEMATTRS_RPC_JSONRPC_ERROR_CODE = $281a441cdcb2cf36$var$TMP_RPC_JSONRPC_ERROR_CODE;
        $281a441cdcb2cf36$var$SEMATTRS_RPC_JSONRPC_ERROR_MESSAGE = $281a441cdcb2cf36$var$TMP_RPC_JSONRPC_ERROR_MESSAGE;
        $281a441cdcb2cf36$var$SEMATTRS_MESSAGE_TYPE = $281a441cdcb2cf36$var$TMP_MESSAGE_TYPE;
        $281a441cdcb2cf36$var$SEMATTRS_MESSAGE_ID = $281a441cdcb2cf36$var$TMP_MESSAGE_ID;
        $281a441cdcb2cf36$var$SEMATTRS_MESSAGE_COMPRESSED_SIZE = $281a441cdcb2cf36$var$TMP_MESSAGE_COMPRESSED_SIZE;
        $281a441cdcb2cf36$var$SEMATTRS_MESSAGE_UNCOMPRESSED_SIZE = $281a441cdcb2cf36$var$TMP_MESSAGE_UNCOMPRESSED_SIZE;
        $281a441cdcb2cf36$var$SemanticAttributes = /* @__PURE__ */ $281a441cdcb2cf36$var$createConstMap([
            $281a441cdcb2cf36$var$TMP_AWS_LAMBDA_INVOKED_ARN,
            $281a441cdcb2cf36$var$TMP_DB_SYSTEM,
            $281a441cdcb2cf36$var$TMP_DB_CONNECTION_STRING,
            $281a441cdcb2cf36$var$TMP_DB_USER,
            $281a441cdcb2cf36$var$TMP_DB_JDBC_DRIVER_CLASSNAME,
            $281a441cdcb2cf36$var$TMP_DB_NAME,
            $281a441cdcb2cf36$var$TMP_DB_STATEMENT,
            $281a441cdcb2cf36$var$TMP_DB_OPERATION,
            $281a441cdcb2cf36$var$TMP_DB_MSSQL_INSTANCE_NAME,
            $281a441cdcb2cf36$var$TMP_DB_CASSANDRA_KEYSPACE,
            $281a441cdcb2cf36$var$TMP_DB_CASSANDRA_PAGE_SIZE,
            $281a441cdcb2cf36$var$TMP_DB_CASSANDRA_CONSISTENCY_LEVEL,
            $281a441cdcb2cf36$var$TMP_DB_CASSANDRA_TABLE,
            $281a441cdcb2cf36$var$TMP_DB_CASSANDRA_IDEMPOTENCE,
            $281a441cdcb2cf36$var$TMP_DB_CASSANDRA_SPECULATIVE_EXECUTION_COUNT,
            $281a441cdcb2cf36$var$TMP_DB_CASSANDRA_COORDINATOR_ID,
            $281a441cdcb2cf36$var$TMP_DB_CASSANDRA_COORDINATOR_DC,
            $281a441cdcb2cf36$var$TMP_DB_HBASE_NAMESPACE,
            $281a441cdcb2cf36$var$TMP_DB_REDIS_DATABASE_INDEX,
            $281a441cdcb2cf36$var$TMP_DB_MONGODB_COLLECTION,
            $281a441cdcb2cf36$var$TMP_DB_SQL_TABLE,
            $281a441cdcb2cf36$var$TMP_EXCEPTION_TYPE,
            $281a441cdcb2cf36$var$TMP_EXCEPTION_MESSAGE,
            $281a441cdcb2cf36$var$TMP_EXCEPTION_STACKTRACE,
            $281a441cdcb2cf36$var$TMP_EXCEPTION_ESCAPED,
            $281a441cdcb2cf36$var$TMP_FAAS_TRIGGER,
            $281a441cdcb2cf36$var$TMP_FAAS_EXECUTION,
            $281a441cdcb2cf36$var$TMP_FAAS_DOCUMENT_COLLECTION,
            $281a441cdcb2cf36$var$TMP_FAAS_DOCUMENT_OPERATION,
            $281a441cdcb2cf36$var$TMP_FAAS_DOCUMENT_TIME,
            $281a441cdcb2cf36$var$TMP_FAAS_DOCUMENT_NAME,
            $281a441cdcb2cf36$var$TMP_FAAS_TIME,
            $281a441cdcb2cf36$var$TMP_FAAS_CRON,
            $281a441cdcb2cf36$var$TMP_FAAS_COLDSTART,
            $281a441cdcb2cf36$var$TMP_FAAS_INVOKED_NAME,
            $281a441cdcb2cf36$var$TMP_FAAS_INVOKED_PROVIDER,
            $281a441cdcb2cf36$var$TMP_FAAS_INVOKED_REGION,
            $281a441cdcb2cf36$var$TMP_NET_TRANSPORT,
            $281a441cdcb2cf36$var$TMP_NET_PEER_IP,
            $281a441cdcb2cf36$var$TMP_NET_PEER_PORT,
            $281a441cdcb2cf36$var$TMP_NET_PEER_NAME,
            $281a441cdcb2cf36$var$TMP_NET_HOST_IP,
            $281a441cdcb2cf36$var$TMP_NET_HOST_PORT,
            $281a441cdcb2cf36$var$TMP_NET_HOST_NAME,
            $281a441cdcb2cf36$var$TMP_NET_HOST_CONNECTION_TYPE,
            $281a441cdcb2cf36$var$TMP_NET_HOST_CONNECTION_SUBTYPE,
            $281a441cdcb2cf36$var$TMP_NET_HOST_CARRIER_NAME,
            $281a441cdcb2cf36$var$TMP_NET_HOST_CARRIER_MCC,
            $281a441cdcb2cf36$var$TMP_NET_HOST_CARRIER_MNC,
            $281a441cdcb2cf36$var$TMP_NET_HOST_CARRIER_ICC,
            $281a441cdcb2cf36$var$TMP_PEER_SERVICE,
            $281a441cdcb2cf36$var$TMP_ENDUSER_ID,
            $281a441cdcb2cf36$var$TMP_ENDUSER_ROLE,
            $281a441cdcb2cf36$var$TMP_ENDUSER_SCOPE,
            $281a441cdcb2cf36$var$TMP_THREAD_ID,
            $281a441cdcb2cf36$var$TMP_THREAD_NAME,
            $281a441cdcb2cf36$var$TMP_CODE_FUNCTION,
            $281a441cdcb2cf36$var$TMP_CODE_NAMESPACE,
            $281a441cdcb2cf36$var$TMP_CODE_FILEPATH,
            $281a441cdcb2cf36$var$TMP_CODE_LINENO,
            $281a441cdcb2cf36$var$TMP_HTTP_METHOD,
            $281a441cdcb2cf36$var$TMP_HTTP_URL,
            $281a441cdcb2cf36$var$TMP_HTTP_TARGET,
            $281a441cdcb2cf36$var$TMP_HTTP_HOST,
            $281a441cdcb2cf36$var$TMP_HTTP_SCHEME,
            $281a441cdcb2cf36$var$TMP_HTTP_STATUS_CODE,
            $281a441cdcb2cf36$var$TMP_HTTP_FLAVOR,
            $281a441cdcb2cf36$var$TMP_HTTP_USER_AGENT,
            $281a441cdcb2cf36$var$TMP_HTTP_REQUEST_CONTENT_LENGTH,
            $281a441cdcb2cf36$var$TMP_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED,
            $281a441cdcb2cf36$var$TMP_HTTP_RESPONSE_CONTENT_LENGTH,
            $281a441cdcb2cf36$var$TMP_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED,
            $281a441cdcb2cf36$var$TMP_HTTP_SERVER_NAME,
            $281a441cdcb2cf36$var$TMP_HTTP_ROUTE,
            $281a441cdcb2cf36$var$TMP_HTTP_CLIENT_IP,
            $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_TABLE_NAMES,
            $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_CONSUMED_CAPACITY,
            $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_ITEM_COLLECTION_METRICS,
            $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_PROVISIONED_READ_CAPACITY,
            $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY,
            $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_CONSISTENT_READ,
            $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_PROJECTION,
            $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_LIMIT,
            $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_ATTRIBUTES_TO_GET,
            $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_INDEX_NAME,
            $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_SELECT,
            $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES,
            $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES,
            $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_EXCLUSIVE_START_TABLE,
            $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_TABLE_COUNT,
            $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_SCAN_FORWARD,
            $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_SEGMENT,
            $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_TOTAL_SEGMENTS,
            $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_COUNT,
            $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_SCANNED_COUNT,
            $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS,
            $281a441cdcb2cf36$var$TMP_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES,
            $281a441cdcb2cf36$var$TMP_MESSAGING_SYSTEM,
            $281a441cdcb2cf36$var$TMP_MESSAGING_DESTINATION,
            $281a441cdcb2cf36$var$TMP_MESSAGING_DESTINATION_KIND,
            $281a441cdcb2cf36$var$TMP_MESSAGING_TEMP_DESTINATION,
            $281a441cdcb2cf36$var$TMP_MESSAGING_PROTOCOL,
            $281a441cdcb2cf36$var$TMP_MESSAGING_PROTOCOL_VERSION,
            $281a441cdcb2cf36$var$TMP_MESSAGING_URL,
            $281a441cdcb2cf36$var$TMP_MESSAGING_MESSAGE_ID,
            $281a441cdcb2cf36$var$TMP_MESSAGING_CONVERSATION_ID,
            $281a441cdcb2cf36$var$TMP_MESSAGING_MESSAGE_PAYLOAD_SIZE_BYTES,
            $281a441cdcb2cf36$var$TMP_MESSAGING_MESSAGE_PAYLOAD_COMPRESSED_SIZE_BYTES,
            $281a441cdcb2cf36$var$TMP_MESSAGING_OPERATION,
            $281a441cdcb2cf36$var$TMP_MESSAGING_CONSUMER_ID,
            $281a441cdcb2cf36$var$TMP_MESSAGING_RABBITMQ_ROUTING_KEY,
            $281a441cdcb2cf36$var$TMP_MESSAGING_KAFKA_MESSAGE_KEY,
            $281a441cdcb2cf36$var$TMP_MESSAGING_KAFKA_CONSUMER_GROUP,
            $281a441cdcb2cf36$var$TMP_MESSAGING_KAFKA_CLIENT_ID,
            $281a441cdcb2cf36$var$TMP_MESSAGING_KAFKA_PARTITION,
            $281a441cdcb2cf36$var$TMP_MESSAGING_KAFKA_TOMBSTONE,
            $281a441cdcb2cf36$var$TMP_RPC_SYSTEM,
            $281a441cdcb2cf36$var$TMP_RPC_SERVICE,
            $281a441cdcb2cf36$var$TMP_RPC_METHOD,
            $281a441cdcb2cf36$var$TMP_RPC_GRPC_STATUS_CODE,
            $281a441cdcb2cf36$var$TMP_RPC_JSONRPC_VERSION,
            $281a441cdcb2cf36$var$TMP_RPC_JSONRPC_REQUEST_ID,
            $281a441cdcb2cf36$var$TMP_RPC_JSONRPC_ERROR_CODE,
            $281a441cdcb2cf36$var$TMP_RPC_JSONRPC_ERROR_MESSAGE,
            $281a441cdcb2cf36$var$TMP_MESSAGE_TYPE,
            $281a441cdcb2cf36$var$TMP_MESSAGE_ID,
            $281a441cdcb2cf36$var$TMP_MESSAGE_COMPRESSED_SIZE,
            $281a441cdcb2cf36$var$TMP_MESSAGE_UNCOMPRESSED_SIZE
        ]);
        $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_OTHER_SQL = "other_sql";
        $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_MSSQL = "mssql";
        $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_MYSQL = "mysql";
        $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_ORACLE = "oracle";
        $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_DB2 = "db2";
        $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_POSTGRESQL = "postgresql";
        $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_REDSHIFT = "redshift";
        $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_HIVE = "hive";
        $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_CLOUDSCAPE = "cloudscape";
        $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_HSQLDB = "hsqldb";
        $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_PROGRESS = "progress";
        $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_MAXDB = "maxdb";
        $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_HANADB = "hanadb";
        $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_INGRES = "ingres";
        $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_FIRSTSQL = "firstsql";
        $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_EDB = "edb";
        $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_CACHE = "cache";
        $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_ADABAS = "adabas";
        $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_FIREBIRD = "firebird";
        $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_DERBY = "derby";
        $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_FILEMAKER = "filemaker";
        $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_INFORMIX = "informix";
        $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_INSTANTDB = "instantdb";
        $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_INTERBASE = "interbase";
        $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_MARIADB = "mariadb";
        $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_NETEZZA = "netezza";
        $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_PERVASIVE = "pervasive";
        $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_POINTBASE = "pointbase";
        $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_SQLITE = "sqlite";
        $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_SYBASE = "sybase";
        $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_TERADATA = "teradata";
        $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_VERTICA = "vertica";
        $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_H2 = "h2";
        $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_COLDFUSION = "coldfusion";
        $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_CASSANDRA = "cassandra";
        $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_HBASE = "hbase";
        $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_MONGODB = "mongodb";
        $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_REDIS = "redis";
        $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_COUCHBASE = "couchbase";
        $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_COUCHDB = "couchdb";
        $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_COSMOSDB = "cosmosdb";
        $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_DYNAMODB = "dynamodb";
        $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_NEO4J = "neo4j";
        $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_GEODE = "geode";
        $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_ELASTICSEARCH = "elasticsearch";
        $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_MEMCACHED = "memcached";
        $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_COCKROACHDB = "cockroachdb";
        $281a441cdcb2cf36$var$DBSYSTEMVALUES_OTHER_SQL = $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_OTHER_SQL;
        $281a441cdcb2cf36$var$DBSYSTEMVALUES_MSSQL = $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_MSSQL;
        $281a441cdcb2cf36$var$DBSYSTEMVALUES_MYSQL = $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_MYSQL;
        $281a441cdcb2cf36$var$DBSYSTEMVALUES_ORACLE = $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_ORACLE;
        $281a441cdcb2cf36$var$DBSYSTEMVALUES_DB2 = $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_DB2;
        $281a441cdcb2cf36$var$DBSYSTEMVALUES_POSTGRESQL = $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_POSTGRESQL;
        $281a441cdcb2cf36$var$DBSYSTEMVALUES_REDSHIFT = $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_REDSHIFT;
        $281a441cdcb2cf36$var$DBSYSTEMVALUES_HIVE = $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_HIVE;
        $281a441cdcb2cf36$var$DBSYSTEMVALUES_CLOUDSCAPE = $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_CLOUDSCAPE;
        $281a441cdcb2cf36$var$DBSYSTEMVALUES_HSQLDB = $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_HSQLDB;
        $281a441cdcb2cf36$var$DBSYSTEMVALUES_PROGRESS = $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_PROGRESS;
        $281a441cdcb2cf36$var$DBSYSTEMVALUES_MAXDB = $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_MAXDB;
        $281a441cdcb2cf36$var$DBSYSTEMVALUES_HANADB = $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_HANADB;
        $281a441cdcb2cf36$var$DBSYSTEMVALUES_INGRES = $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_INGRES;
        $281a441cdcb2cf36$var$DBSYSTEMVALUES_FIRSTSQL = $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_FIRSTSQL;
        $281a441cdcb2cf36$var$DBSYSTEMVALUES_EDB = $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_EDB;
        $281a441cdcb2cf36$var$DBSYSTEMVALUES_CACHE = $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_CACHE;
        $281a441cdcb2cf36$var$DBSYSTEMVALUES_ADABAS = $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_ADABAS;
        $281a441cdcb2cf36$var$DBSYSTEMVALUES_FIREBIRD = $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_FIREBIRD;
        $281a441cdcb2cf36$var$DBSYSTEMVALUES_DERBY = $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_DERBY;
        $281a441cdcb2cf36$var$DBSYSTEMVALUES_FILEMAKER = $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_FILEMAKER;
        $281a441cdcb2cf36$var$DBSYSTEMVALUES_INFORMIX = $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_INFORMIX;
        $281a441cdcb2cf36$var$DBSYSTEMVALUES_INSTANTDB = $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_INSTANTDB;
        $281a441cdcb2cf36$var$DBSYSTEMVALUES_INTERBASE = $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_INTERBASE;
        $281a441cdcb2cf36$var$DBSYSTEMVALUES_MARIADB = $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_MARIADB;
        $281a441cdcb2cf36$var$DBSYSTEMVALUES_NETEZZA = $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_NETEZZA;
        $281a441cdcb2cf36$var$DBSYSTEMVALUES_PERVASIVE = $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_PERVASIVE;
        $281a441cdcb2cf36$var$DBSYSTEMVALUES_POINTBASE = $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_POINTBASE;
        $281a441cdcb2cf36$var$DBSYSTEMVALUES_SQLITE = $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_SQLITE;
        $281a441cdcb2cf36$var$DBSYSTEMVALUES_SYBASE = $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_SYBASE;
        $281a441cdcb2cf36$var$DBSYSTEMVALUES_TERADATA = $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_TERADATA;
        $281a441cdcb2cf36$var$DBSYSTEMVALUES_VERTICA = $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_VERTICA;
        $281a441cdcb2cf36$var$DBSYSTEMVALUES_H2 = $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_H2;
        $281a441cdcb2cf36$var$DBSYSTEMVALUES_COLDFUSION = $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_COLDFUSION;
        $281a441cdcb2cf36$var$DBSYSTEMVALUES_CASSANDRA = $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_CASSANDRA;
        $281a441cdcb2cf36$var$DBSYSTEMVALUES_HBASE = $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_HBASE;
        $281a441cdcb2cf36$var$DBSYSTEMVALUES_MONGODB = $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_MONGODB;
        $281a441cdcb2cf36$var$DBSYSTEMVALUES_REDIS = $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_REDIS;
        $281a441cdcb2cf36$var$DBSYSTEMVALUES_COUCHBASE = $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_COUCHBASE;
        $281a441cdcb2cf36$var$DBSYSTEMVALUES_COUCHDB = $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_COUCHDB;
        $281a441cdcb2cf36$var$DBSYSTEMVALUES_COSMOSDB = $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_COSMOSDB;
        $281a441cdcb2cf36$var$DBSYSTEMVALUES_DYNAMODB = $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_DYNAMODB;
        $281a441cdcb2cf36$var$DBSYSTEMVALUES_NEO4J = $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_NEO4J;
        $281a441cdcb2cf36$var$DBSYSTEMVALUES_GEODE = $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_GEODE;
        $281a441cdcb2cf36$var$DBSYSTEMVALUES_ELASTICSEARCH = $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_ELASTICSEARCH;
        $281a441cdcb2cf36$var$DBSYSTEMVALUES_MEMCACHED = $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_MEMCACHED;
        $281a441cdcb2cf36$var$DBSYSTEMVALUES_COCKROACHDB = $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_COCKROACHDB;
        $281a441cdcb2cf36$var$DbSystemValues = /* @__PURE__ */ $281a441cdcb2cf36$var$createConstMap([
            $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_OTHER_SQL,
            $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_MSSQL,
            $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_MYSQL,
            $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_ORACLE,
            $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_DB2,
            $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_POSTGRESQL,
            $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_REDSHIFT,
            $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_HIVE,
            $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_CLOUDSCAPE,
            $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_HSQLDB,
            $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_PROGRESS,
            $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_MAXDB,
            $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_HANADB,
            $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_INGRES,
            $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_FIRSTSQL,
            $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_EDB,
            $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_CACHE,
            $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_ADABAS,
            $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_FIREBIRD,
            $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_DERBY,
            $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_FILEMAKER,
            $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_INFORMIX,
            $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_INSTANTDB,
            $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_INTERBASE,
            $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_MARIADB,
            $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_NETEZZA,
            $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_PERVASIVE,
            $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_POINTBASE,
            $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_SQLITE,
            $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_SYBASE,
            $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_TERADATA,
            $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_VERTICA,
            $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_H2,
            $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_COLDFUSION,
            $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_CASSANDRA,
            $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_HBASE,
            $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_MONGODB,
            $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_REDIS,
            $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_COUCHBASE,
            $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_COUCHDB,
            $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_COSMOSDB,
            $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_DYNAMODB,
            $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_NEO4J,
            $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_GEODE,
            $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_ELASTICSEARCH,
            $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_MEMCACHED,
            $281a441cdcb2cf36$var$TMP_DBSYSTEMVALUES_COCKROACHDB
        ]);
        $281a441cdcb2cf36$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ALL = "all";
        $281a441cdcb2cf36$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_EACH_QUORUM = "each_quorum";
        $281a441cdcb2cf36$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_QUORUM = "quorum";
        $281a441cdcb2cf36$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_QUORUM = "local_quorum";
        $281a441cdcb2cf36$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ONE = "one";
        $281a441cdcb2cf36$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_TWO = "two";
        $281a441cdcb2cf36$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_THREE = "three";
        $281a441cdcb2cf36$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_ONE = "local_one";
        $281a441cdcb2cf36$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ANY = "any";
        $281a441cdcb2cf36$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_SERIAL = "serial";
        $281a441cdcb2cf36$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_SERIAL = "local_serial";
        $281a441cdcb2cf36$var$DBCASSANDRACONSISTENCYLEVELVALUES_ALL = $281a441cdcb2cf36$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ALL;
        $281a441cdcb2cf36$var$DBCASSANDRACONSISTENCYLEVELVALUES_EACH_QUORUM = $281a441cdcb2cf36$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_EACH_QUORUM;
        $281a441cdcb2cf36$var$DBCASSANDRACONSISTENCYLEVELVALUES_QUORUM = $281a441cdcb2cf36$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_QUORUM;
        $281a441cdcb2cf36$var$DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_QUORUM = $281a441cdcb2cf36$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_QUORUM;
        $281a441cdcb2cf36$var$DBCASSANDRACONSISTENCYLEVELVALUES_ONE = $281a441cdcb2cf36$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ONE;
        $281a441cdcb2cf36$var$DBCASSANDRACONSISTENCYLEVELVALUES_TWO = $281a441cdcb2cf36$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_TWO;
        $281a441cdcb2cf36$var$DBCASSANDRACONSISTENCYLEVELVALUES_THREE = $281a441cdcb2cf36$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_THREE;
        $281a441cdcb2cf36$var$DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_ONE = $281a441cdcb2cf36$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_ONE;
        $281a441cdcb2cf36$var$DBCASSANDRACONSISTENCYLEVELVALUES_ANY = $281a441cdcb2cf36$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ANY;
        $281a441cdcb2cf36$var$DBCASSANDRACONSISTENCYLEVELVALUES_SERIAL = $281a441cdcb2cf36$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_SERIAL;
        $281a441cdcb2cf36$var$DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_SERIAL = $281a441cdcb2cf36$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_SERIAL;
        $281a441cdcb2cf36$var$DbCassandraConsistencyLevelValues = /* @__PURE__ */ $281a441cdcb2cf36$var$createConstMap([
            $281a441cdcb2cf36$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ALL,
            $281a441cdcb2cf36$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_EACH_QUORUM,
            $281a441cdcb2cf36$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_QUORUM,
            $281a441cdcb2cf36$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_QUORUM,
            $281a441cdcb2cf36$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ONE,
            $281a441cdcb2cf36$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_TWO,
            $281a441cdcb2cf36$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_THREE,
            $281a441cdcb2cf36$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_ONE,
            $281a441cdcb2cf36$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ANY,
            $281a441cdcb2cf36$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_SERIAL,
            $281a441cdcb2cf36$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_SERIAL
        ]);
        $281a441cdcb2cf36$var$TMP_FAASTRIGGERVALUES_DATASOURCE = "datasource";
        $281a441cdcb2cf36$var$TMP_FAASTRIGGERVALUES_HTTP = "http";
        $281a441cdcb2cf36$var$TMP_FAASTRIGGERVALUES_PUBSUB = "pubsub";
        $281a441cdcb2cf36$var$TMP_FAASTRIGGERVALUES_TIMER = "timer";
        $281a441cdcb2cf36$var$TMP_FAASTRIGGERVALUES_OTHER = "other";
        $281a441cdcb2cf36$var$FAASTRIGGERVALUES_DATASOURCE = $281a441cdcb2cf36$var$TMP_FAASTRIGGERVALUES_DATASOURCE;
        $281a441cdcb2cf36$var$FAASTRIGGERVALUES_HTTP = $281a441cdcb2cf36$var$TMP_FAASTRIGGERVALUES_HTTP;
        $281a441cdcb2cf36$var$FAASTRIGGERVALUES_PUBSUB = $281a441cdcb2cf36$var$TMP_FAASTRIGGERVALUES_PUBSUB;
        $281a441cdcb2cf36$var$FAASTRIGGERVALUES_TIMER = $281a441cdcb2cf36$var$TMP_FAASTRIGGERVALUES_TIMER;
        $281a441cdcb2cf36$var$FAASTRIGGERVALUES_OTHER = $281a441cdcb2cf36$var$TMP_FAASTRIGGERVALUES_OTHER;
        $281a441cdcb2cf36$var$FaasTriggerValues = /* @__PURE__ */ $281a441cdcb2cf36$var$createConstMap([
            $281a441cdcb2cf36$var$TMP_FAASTRIGGERVALUES_DATASOURCE,
            $281a441cdcb2cf36$var$TMP_FAASTRIGGERVALUES_HTTP,
            $281a441cdcb2cf36$var$TMP_FAASTRIGGERVALUES_PUBSUB,
            $281a441cdcb2cf36$var$TMP_FAASTRIGGERVALUES_TIMER,
            $281a441cdcb2cf36$var$TMP_FAASTRIGGERVALUES_OTHER
        ]);
        $281a441cdcb2cf36$var$TMP_FAASDOCUMENTOPERATIONVALUES_INSERT = "insert";
        $281a441cdcb2cf36$var$TMP_FAASDOCUMENTOPERATIONVALUES_EDIT = "edit";
        $281a441cdcb2cf36$var$TMP_FAASDOCUMENTOPERATIONVALUES_DELETE = "delete";
        $281a441cdcb2cf36$var$FAASDOCUMENTOPERATIONVALUES_INSERT = $281a441cdcb2cf36$var$TMP_FAASDOCUMENTOPERATIONVALUES_INSERT;
        $281a441cdcb2cf36$var$FAASDOCUMENTOPERATIONVALUES_EDIT = $281a441cdcb2cf36$var$TMP_FAASDOCUMENTOPERATIONVALUES_EDIT;
        $281a441cdcb2cf36$var$FAASDOCUMENTOPERATIONVALUES_DELETE = $281a441cdcb2cf36$var$TMP_FAASDOCUMENTOPERATIONVALUES_DELETE;
        $281a441cdcb2cf36$var$FaasDocumentOperationValues = /* @__PURE__ */ $281a441cdcb2cf36$var$createConstMap([
            $281a441cdcb2cf36$var$TMP_FAASDOCUMENTOPERATIONVALUES_INSERT,
            $281a441cdcb2cf36$var$TMP_FAASDOCUMENTOPERATIONVALUES_EDIT,
            $281a441cdcb2cf36$var$TMP_FAASDOCUMENTOPERATIONVALUES_DELETE
        ]);
        $281a441cdcb2cf36$var$TMP_FAASINVOKEDPROVIDERVALUES_ALIBABA_CLOUD = "alibaba_cloud";
        $281a441cdcb2cf36$var$TMP_FAASINVOKEDPROVIDERVALUES_AWS = "aws";
        $281a441cdcb2cf36$var$TMP_FAASINVOKEDPROVIDERVALUES_AZURE = "azure";
        $281a441cdcb2cf36$var$TMP_FAASINVOKEDPROVIDERVALUES_GCP = "gcp";
        $281a441cdcb2cf36$var$FAASINVOKEDPROVIDERVALUES_ALIBABA_CLOUD = $281a441cdcb2cf36$var$TMP_FAASINVOKEDPROVIDERVALUES_ALIBABA_CLOUD;
        $281a441cdcb2cf36$var$FAASINVOKEDPROVIDERVALUES_AWS = $281a441cdcb2cf36$var$TMP_FAASINVOKEDPROVIDERVALUES_AWS;
        $281a441cdcb2cf36$var$FAASINVOKEDPROVIDERVALUES_AZURE = $281a441cdcb2cf36$var$TMP_FAASINVOKEDPROVIDERVALUES_AZURE;
        $281a441cdcb2cf36$var$FAASINVOKEDPROVIDERVALUES_GCP = $281a441cdcb2cf36$var$TMP_FAASINVOKEDPROVIDERVALUES_GCP;
        $281a441cdcb2cf36$var$FaasInvokedProviderValues = /* @__PURE__ */ $281a441cdcb2cf36$var$createConstMap([
            $281a441cdcb2cf36$var$TMP_FAASINVOKEDPROVIDERVALUES_ALIBABA_CLOUD,
            $281a441cdcb2cf36$var$TMP_FAASINVOKEDPROVIDERVALUES_AWS,
            $281a441cdcb2cf36$var$TMP_FAASINVOKEDPROVIDERVALUES_AZURE,
            $281a441cdcb2cf36$var$TMP_FAASINVOKEDPROVIDERVALUES_GCP
        ]);
        $281a441cdcb2cf36$var$TMP_NETTRANSPORTVALUES_IP_TCP = "ip_tcp";
        $281a441cdcb2cf36$var$TMP_NETTRANSPORTVALUES_IP_UDP = "ip_udp";
        $281a441cdcb2cf36$var$TMP_NETTRANSPORTVALUES_IP = "ip";
        $281a441cdcb2cf36$var$TMP_NETTRANSPORTVALUES_UNIX = "unix";
        $281a441cdcb2cf36$var$TMP_NETTRANSPORTVALUES_PIPE = "pipe";
        $281a441cdcb2cf36$var$TMP_NETTRANSPORTVALUES_INPROC = "inproc";
        $281a441cdcb2cf36$var$TMP_NETTRANSPORTVALUES_OTHER = "other";
        $281a441cdcb2cf36$var$NETTRANSPORTVALUES_IP_TCP = $281a441cdcb2cf36$var$TMP_NETTRANSPORTVALUES_IP_TCP;
        $281a441cdcb2cf36$var$NETTRANSPORTVALUES_IP_UDP = $281a441cdcb2cf36$var$TMP_NETTRANSPORTVALUES_IP_UDP;
        $281a441cdcb2cf36$var$NETTRANSPORTVALUES_IP = $281a441cdcb2cf36$var$TMP_NETTRANSPORTVALUES_IP;
        $281a441cdcb2cf36$var$NETTRANSPORTVALUES_UNIX = $281a441cdcb2cf36$var$TMP_NETTRANSPORTVALUES_UNIX;
        $281a441cdcb2cf36$var$NETTRANSPORTVALUES_PIPE = $281a441cdcb2cf36$var$TMP_NETTRANSPORTVALUES_PIPE;
        $281a441cdcb2cf36$var$NETTRANSPORTVALUES_INPROC = $281a441cdcb2cf36$var$TMP_NETTRANSPORTVALUES_INPROC;
        $281a441cdcb2cf36$var$NETTRANSPORTVALUES_OTHER = $281a441cdcb2cf36$var$TMP_NETTRANSPORTVALUES_OTHER;
        $281a441cdcb2cf36$var$NetTransportValues = /* @__PURE__ */ $281a441cdcb2cf36$var$createConstMap([
            $281a441cdcb2cf36$var$TMP_NETTRANSPORTVALUES_IP_TCP,
            $281a441cdcb2cf36$var$TMP_NETTRANSPORTVALUES_IP_UDP,
            $281a441cdcb2cf36$var$TMP_NETTRANSPORTVALUES_IP,
            $281a441cdcb2cf36$var$TMP_NETTRANSPORTVALUES_UNIX,
            $281a441cdcb2cf36$var$TMP_NETTRANSPORTVALUES_PIPE,
            $281a441cdcb2cf36$var$TMP_NETTRANSPORTVALUES_INPROC,
            $281a441cdcb2cf36$var$TMP_NETTRANSPORTVALUES_OTHER
        ]);
        $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONTYPEVALUES_WIFI = "wifi";
        $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONTYPEVALUES_WIRED = "wired";
        $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONTYPEVALUES_CELL = "cell";
        $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONTYPEVALUES_UNAVAILABLE = "unavailable";
        $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONTYPEVALUES_UNKNOWN = "unknown";
        $281a441cdcb2cf36$var$NETHOSTCONNECTIONTYPEVALUES_WIFI = $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONTYPEVALUES_WIFI;
        $281a441cdcb2cf36$var$NETHOSTCONNECTIONTYPEVALUES_WIRED = $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONTYPEVALUES_WIRED;
        $281a441cdcb2cf36$var$NETHOSTCONNECTIONTYPEVALUES_CELL = $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONTYPEVALUES_CELL;
        $281a441cdcb2cf36$var$NETHOSTCONNECTIONTYPEVALUES_UNAVAILABLE = $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONTYPEVALUES_UNAVAILABLE;
        $281a441cdcb2cf36$var$NETHOSTCONNECTIONTYPEVALUES_UNKNOWN = $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONTYPEVALUES_UNKNOWN;
        $281a441cdcb2cf36$var$NetHostConnectionTypeValues = /* @__PURE__ */ $281a441cdcb2cf36$var$createConstMap([
            $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONTYPEVALUES_WIFI,
            $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONTYPEVALUES_WIRED,
            $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONTYPEVALUES_CELL,
            $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONTYPEVALUES_UNAVAILABLE,
            $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONTYPEVALUES_UNKNOWN
        ]);
        $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_GPRS = "gprs";
        $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EDGE = "edge";
        $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_UMTS = "umts";
        $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_CDMA = "cdma";
        $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_0 = "evdo_0";
        $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_A = "evdo_a";
        $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_CDMA2000_1XRTT = "cdma2000_1xrtt";
        $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSDPA = "hsdpa";
        $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSUPA = "hsupa";
        $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSPA = "hspa";
        $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_IDEN = "iden";
        $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_B = "evdo_b";
        $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_LTE = "lte";
        $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EHRPD = "ehrpd";
        $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSPAP = "hspap";
        $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_GSM = "gsm";
        $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_TD_SCDMA = "td_scdma";
        $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_IWLAN = "iwlan";
        $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_NR = "nr";
        $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_NRNSA = "nrnsa";
        $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_LTE_CA = "lte_ca";
        $281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_GPRS = $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_GPRS;
        $281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_EDGE = $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EDGE;
        $281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_UMTS = $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_UMTS;
        $281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_CDMA = $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_CDMA;
        $281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_0 = $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_0;
        $281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_A = $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_A;
        $281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_CDMA2000_1XRTT = $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_CDMA2000_1XRTT;
        $281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_HSDPA = $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSDPA;
        $281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_HSUPA = $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSUPA;
        $281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_HSPA = $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSPA;
        $281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_IDEN = $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_IDEN;
        $281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_B = $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_B;
        $281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_LTE = $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_LTE;
        $281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_EHRPD = $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EHRPD;
        $281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_HSPAP = $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSPAP;
        $281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_GSM = $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_GSM;
        $281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_TD_SCDMA = $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_TD_SCDMA;
        $281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_IWLAN = $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_IWLAN;
        $281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_NR = $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_NR;
        $281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_NRNSA = $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_NRNSA;
        $281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_LTE_CA = $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_LTE_CA;
        $281a441cdcb2cf36$var$NetHostConnectionSubtypeValues = /* @__PURE__ */ $281a441cdcb2cf36$var$createConstMap([
            $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_GPRS,
            $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EDGE,
            $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_UMTS,
            $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_CDMA,
            $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_0,
            $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_A,
            $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_CDMA2000_1XRTT,
            $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSDPA,
            $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSUPA,
            $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSPA,
            $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_IDEN,
            $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_B,
            $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_LTE,
            $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EHRPD,
            $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSPAP,
            $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_GSM,
            $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_TD_SCDMA,
            $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_IWLAN,
            $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_NR,
            $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_NRNSA,
            $281a441cdcb2cf36$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_LTE_CA
        ]);
        $281a441cdcb2cf36$var$TMP_HTTPFLAVORVALUES_HTTP_1_0 = "1.0";
        $281a441cdcb2cf36$var$TMP_HTTPFLAVORVALUES_HTTP_1_1 = "1.1";
        $281a441cdcb2cf36$var$TMP_HTTPFLAVORVALUES_HTTP_2_0 = "2.0";
        $281a441cdcb2cf36$var$TMP_HTTPFLAVORVALUES_SPDY = "SPDY";
        $281a441cdcb2cf36$var$TMP_HTTPFLAVORVALUES_QUIC = "QUIC";
        $281a441cdcb2cf36$var$HTTPFLAVORVALUES_HTTP_1_0 = $281a441cdcb2cf36$var$TMP_HTTPFLAVORVALUES_HTTP_1_0;
        $281a441cdcb2cf36$var$HTTPFLAVORVALUES_HTTP_1_1 = $281a441cdcb2cf36$var$TMP_HTTPFLAVORVALUES_HTTP_1_1;
        $281a441cdcb2cf36$var$HTTPFLAVORVALUES_HTTP_2_0 = $281a441cdcb2cf36$var$TMP_HTTPFLAVORVALUES_HTTP_2_0;
        $281a441cdcb2cf36$var$HTTPFLAVORVALUES_SPDY = $281a441cdcb2cf36$var$TMP_HTTPFLAVORVALUES_SPDY;
        $281a441cdcb2cf36$var$HTTPFLAVORVALUES_QUIC = $281a441cdcb2cf36$var$TMP_HTTPFLAVORVALUES_QUIC;
        $281a441cdcb2cf36$var$HttpFlavorValues = {
            HTTP_1_0: $281a441cdcb2cf36$var$TMP_HTTPFLAVORVALUES_HTTP_1_0,
            HTTP_1_1: $281a441cdcb2cf36$var$TMP_HTTPFLAVORVALUES_HTTP_1_1,
            HTTP_2_0: $281a441cdcb2cf36$var$TMP_HTTPFLAVORVALUES_HTTP_2_0,
            SPDY: $281a441cdcb2cf36$var$TMP_HTTPFLAVORVALUES_SPDY,
            QUIC: $281a441cdcb2cf36$var$TMP_HTTPFLAVORVALUES_QUIC
        };
        $281a441cdcb2cf36$var$TMP_MESSAGINGDESTINATIONKINDVALUES_QUEUE = "queue";
        $281a441cdcb2cf36$var$TMP_MESSAGINGDESTINATIONKINDVALUES_TOPIC = "topic";
        $281a441cdcb2cf36$var$MESSAGINGDESTINATIONKINDVALUES_QUEUE = $281a441cdcb2cf36$var$TMP_MESSAGINGDESTINATIONKINDVALUES_QUEUE;
        $281a441cdcb2cf36$var$MESSAGINGDESTINATIONKINDVALUES_TOPIC = $281a441cdcb2cf36$var$TMP_MESSAGINGDESTINATIONKINDVALUES_TOPIC;
        $281a441cdcb2cf36$var$MessagingDestinationKindValues = /* @__PURE__ */ $281a441cdcb2cf36$var$createConstMap([
            $281a441cdcb2cf36$var$TMP_MESSAGINGDESTINATIONKINDVALUES_QUEUE,
            $281a441cdcb2cf36$var$TMP_MESSAGINGDESTINATIONKINDVALUES_TOPIC
        ]);
        $281a441cdcb2cf36$var$TMP_MESSAGINGOPERATIONVALUES_RECEIVE = "receive";
        $281a441cdcb2cf36$var$TMP_MESSAGINGOPERATIONVALUES_PROCESS = "process";
        $281a441cdcb2cf36$var$MESSAGINGOPERATIONVALUES_RECEIVE = $281a441cdcb2cf36$var$TMP_MESSAGINGOPERATIONVALUES_RECEIVE;
        $281a441cdcb2cf36$var$MESSAGINGOPERATIONVALUES_PROCESS = $281a441cdcb2cf36$var$TMP_MESSAGINGOPERATIONVALUES_PROCESS;
        $281a441cdcb2cf36$var$MessagingOperationValues = /* @__PURE__ */ $281a441cdcb2cf36$var$createConstMap([
            $281a441cdcb2cf36$var$TMP_MESSAGINGOPERATIONVALUES_RECEIVE,
            $281a441cdcb2cf36$var$TMP_MESSAGINGOPERATIONVALUES_PROCESS
        ]);
        $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_OK = 0;
        $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_CANCELLED = 1;
        $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_UNKNOWN = 2;
        $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_INVALID_ARGUMENT = 3;
        $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_DEADLINE_EXCEEDED = 4;
        $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_NOT_FOUND = 5;
        $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_ALREADY_EXISTS = 6;
        $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_PERMISSION_DENIED = 7;
        $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_RESOURCE_EXHAUSTED = 8;
        $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_FAILED_PRECONDITION = 9;
        $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_ABORTED = 10;
        $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_OUT_OF_RANGE = 11;
        $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_UNIMPLEMENTED = 12;
        $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_INTERNAL = 13;
        $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_UNAVAILABLE = 14;
        $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_DATA_LOSS = 15;
        $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_UNAUTHENTICATED = 16;
        $281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_OK = $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_OK;
        $281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_CANCELLED = $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_CANCELLED;
        $281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_UNKNOWN = $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_UNKNOWN;
        $281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_INVALID_ARGUMENT = $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_INVALID_ARGUMENT;
        $281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_DEADLINE_EXCEEDED = $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_DEADLINE_EXCEEDED;
        $281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_NOT_FOUND = $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_NOT_FOUND;
        $281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_ALREADY_EXISTS = $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_ALREADY_EXISTS;
        $281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_PERMISSION_DENIED = $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_PERMISSION_DENIED;
        $281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_RESOURCE_EXHAUSTED = $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_RESOURCE_EXHAUSTED;
        $281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_FAILED_PRECONDITION = $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_FAILED_PRECONDITION;
        $281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_ABORTED = $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_ABORTED;
        $281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_OUT_OF_RANGE = $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_OUT_OF_RANGE;
        $281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_UNIMPLEMENTED = $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_UNIMPLEMENTED;
        $281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_INTERNAL = $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_INTERNAL;
        $281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_UNAVAILABLE = $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_UNAVAILABLE;
        $281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_DATA_LOSS = $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_DATA_LOSS;
        $281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_UNAUTHENTICATED = $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_UNAUTHENTICATED;
        $281a441cdcb2cf36$var$RpcGrpcStatusCodeValues = {
            OK: $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_OK,
            CANCELLED: $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_CANCELLED,
            UNKNOWN: $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_UNKNOWN,
            INVALID_ARGUMENT: $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_INVALID_ARGUMENT,
            DEADLINE_EXCEEDED: $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_DEADLINE_EXCEEDED,
            NOT_FOUND: $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_NOT_FOUND,
            ALREADY_EXISTS: $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_ALREADY_EXISTS,
            PERMISSION_DENIED: $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_PERMISSION_DENIED,
            RESOURCE_EXHAUSTED: $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_RESOURCE_EXHAUSTED,
            FAILED_PRECONDITION: $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_FAILED_PRECONDITION,
            ABORTED: $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_ABORTED,
            OUT_OF_RANGE: $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_OUT_OF_RANGE,
            UNIMPLEMENTED: $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_UNIMPLEMENTED,
            INTERNAL: $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_INTERNAL,
            UNAVAILABLE: $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_UNAVAILABLE,
            DATA_LOSS: $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_DATA_LOSS,
            UNAUTHENTICATED: $281a441cdcb2cf36$var$TMP_RPCGRPCSTATUSCODEVALUES_UNAUTHENTICATED
        };
        $281a441cdcb2cf36$var$TMP_MESSAGETYPEVALUES_SENT = "SENT";
        $281a441cdcb2cf36$var$TMP_MESSAGETYPEVALUES_RECEIVED = "RECEIVED";
        $281a441cdcb2cf36$var$MESSAGETYPEVALUES_SENT = $281a441cdcb2cf36$var$TMP_MESSAGETYPEVALUES_SENT;
        $281a441cdcb2cf36$var$MESSAGETYPEVALUES_RECEIVED = $281a441cdcb2cf36$var$TMP_MESSAGETYPEVALUES_RECEIVED;
        $281a441cdcb2cf36$var$MessageTypeValues = /* @__PURE__ */ $281a441cdcb2cf36$var$createConstMap([
            $281a441cdcb2cf36$var$TMP_MESSAGETYPEVALUES_SENT,
            $281a441cdcb2cf36$var$TMP_MESSAGETYPEVALUES_RECEIVED
        ]);
    }
});
// ../node_modules/@opentelemetry/semantic-conventions/build/esm/trace/index.js
var $281a441cdcb2cf36$var$init_trace2 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/semantic-conventions/build/esm/trace/index.js" () {
        $281a441cdcb2cf36$var$init_SemanticAttributes();
    }
});
// ../node_modules/@opentelemetry/semantic-conventions/build/esm/resource/SemanticResourceAttributes.js
var $281a441cdcb2cf36$var$TMP_CLOUD_PROVIDER, $281a441cdcb2cf36$var$TMP_CLOUD_ACCOUNT_ID, $281a441cdcb2cf36$var$TMP_CLOUD_REGION, $281a441cdcb2cf36$var$TMP_CLOUD_AVAILABILITY_ZONE, $281a441cdcb2cf36$var$TMP_CLOUD_PLATFORM, $281a441cdcb2cf36$var$TMP_AWS_ECS_CONTAINER_ARN, $281a441cdcb2cf36$var$TMP_AWS_ECS_CLUSTER_ARN, $281a441cdcb2cf36$var$TMP_AWS_ECS_LAUNCHTYPE, $281a441cdcb2cf36$var$TMP_AWS_ECS_TASK_ARN, $281a441cdcb2cf36$var$TMP_AWS_ECS_TASK_FAMILY, $281a441cdcb2cf36$var$TMP_AWS_ECS_TASK_REVISION, $281a441cdcb2cf36$var$TMP_AWS_EKS_CLUSTER_ARN, $281a441cdcb2cf36$var$TMP_AWS_LOG_GROUP_NAMES, $281a441cdcb2cf36$var$TMP_AWS_LOG_GROUP_ARNS, $281a441cdcb2cf36$var$TMP_AWS_LOG_STREAM_NAMES, $281a441cdcb2cf36$var$TMP_AWS_LOG_STREAM_ARNS, $281a441cdcb2cf36$var$TMP_CONTAINER_NAME, $281a441cdcb2cf36$var$TMP_CONTAINER_ID, $281a441cdcb2cf36$var$TMP_CONTAINER_RUNTIME, $281a441cdcb2cf36$var$TMP_CONTAINER_IMAGE_NAME, $281a441cdcb2cf36$var$TMP_CONTAINER_IMAGE_TAG, $281a441cdcb2cf36$var$TMP_DEPLOYMENT_ENVIRONMENT, $281a441cdcb2cf36$var$TMP_DEVICE_ID, $281a441cdcb2cf36$var$TMP_DEVICE_MODEL_IDENTIFIER, $281a441cdcb2cf36$var$TMP_DEVICE_MODEL_NAME, $281a441cdcb2cf36$var$TMP_FAAS_NAME, $281a441cdcb2cf36$var$TMP_FAAS_ID, $281a441cdcb2cf36$var$TMP_FAAS_VERSION, $281a441cdcb2cf36$var$TMP_FAAS_INSTANCE, $281a441cdcb2cf36$var$TMP_FAAS_MAX_MEMORY, $281a441cdcb2cf36$var$TMP_HOST_ID, $281a441cdcb2cf36$var$TMP_HOST_NAME, $281a441cdcb2cf36$var$TMP_HOST_TYPE, $281a441cdcb2cf36$var$TMP_HOST_ARCH, $281a441cdcb2cf36$var$TMP_HOST_IMAGE_NAME, $281a441cdcb2cf36$var$TMP_HOST_IMAGE_ID, $281a441cdcb2cf36$var$TMP_HOST_IMAGE_VERSION, $281a441cdcb2cf36$var$TMP_K8S_CLUSTER_NAME, $281a441cdcb2cf36$var$TMP_K8S_NODE_NAME, $281a441cdcb2cf36$var$TMP_K8S_NODE_UID, $281a441cdcb2cf36$var$TMP_K8S_NAMESPACE_NAME, $281a441cdcb2cf36$var$TMP_K8S_POD_UID, $281a441cdcb2cf36$var$TMP_K8S_POD_NAME, $281a441cdcb2cf36$var$TMP_K8S_CONTAINER_NAME, $281a441cdcb2cf36$var$TMP_K8S_REPLICASET_UID, $281a441cdcb2cf36$var$TMP_K8S_REPLICASET_NAME, $281a441cdcb2cf36$var$TMP_K8S_DEPLOYMENT_UID, $281a441cdcb2cf36$var$TMP_K8S_DEPLOYMENT_NAME, $281a441cdcb2cf36$var$TMP_K8S_STATEFULSET_UID, $281a441cdcb2cf36$var$TMP_K8S_STATEFULSET_NAME, $281a441cdcb2cf36$var$TMP_K8S_DAEMONSET_UID, $281a441cdcb2cf36$var$TMP_K8S_DAEMONSET_NAME, $281a441cdcb2cf36$var$TMP_K8S_JOB_UID, $281a441cdcb2cf36$var$TMP_K8S_JOB_NAME, $281a441cdcb2cf36$var$TMP_K8S_CRONJOB_UID, $281a441cdcb2cf36$var$TMP_K8S_CRONJOB_NAME, $281a441cdcb2cf36$var$TMP_OS_TYPE, $281a441cdcb2cf36$var$TMP_OS_DESCRIPTION, $281a441cdcb2cf36$var$TMP_OS_NAME, $281a441cdcb2cf36$var$TMP_OS_VERSION, $281a441cdcb2cf36$var$TMP_PROCESS_PID, $281a441cdcb2cf36$var$TMP_PROCESS_EXECUTABLE_NAME, $281a441cdcb2cf36$var$TMP_PROCESS_EXECUTABLE_PATH, $281a441cdcb2cf36$var$TMP_PROCESS_COMMAND, $281a441cdcb2cf36$var$TMP_PROCESS_COMMAND_LINE, $281a441cdcb2cf36$var$TMP_PROCESS_COMMAND_ARGS, $281a441cdcb2cf36$var$TMP_PROCESS_OWNER, $281a441cdcb2cf36$var$TMP_PROCESS_RUNTIME_NAME, $281a441cdcb2cf36$var$TMP_PROCESS_RUNTIME_VERSION, $281a441cdcb2cf36$var$TMP_PROCESS_RUNTIME_DESCRIPTION, $281a441cdcb2cf36$var$TMP_SERVICE_NAME, $281a441cdcb2cf36$var$TMP_SERVICE_NAMESPACE, $281a441cdcb2cf36$var$TMP_SERVICE_INSTANCE_ID, $281a441cdcb2cf36$var$TMP_SERVICE_VERSION, $281a441cdcb2cf36$var$TMP_TELEMETRY_SDK_NAME, $281a441cdcb2cf36$var$TMP_TELEMETRY_SDK_LANGUAGE, $281a441cdcb2cf36$var$TMP_TELEMETRY_SDK_VERSION, $281a441cdcb2cf36$var$TMP_TELEMETRY_AUTO_VERSION, $281a441cdcb2cf36$var$TMP_WEBENGINE_NAME, $281a441cdcb2cf36$var$TMP_WEBENGINE_VERSION, $281a441cdcb2cf36$var$TMP_WEBENGINE_DESCRIPTION, $281a441cdcb2cf36$var$SEMRESATTRS_CLOUD_PROVIDER, $281a441cdcb2cf36$var$SEMRESATTRS_CLOUD_ACCOUNT_ID, $281a441cdcb2cf36$var$SEMRESATTRS_CLOUD_REGION, $281a441cdcb2cf36$var$SEMRESATTRS_CLOUD_AVAILABILITY_ZONE, $281a441cdcb2cf36$var$SEMRESATTRS_CLOUD_PLATFORM, $281a441cdcb2cf36$var$SEMRESATTRS_AWS_ECS_CONTAINER_ARN, $281a441cdcb2cf36$var$SEMRESATTRS_AWS_ECS_CLUSTER_ARN, $281a441cdcb2cf36$var$SEMRESATTRS_AWS_ECS_LAUNCHTYPE, $281a441cdcb2cf36$var$SEMRESATTRS_AWS_ECS_TASK_ARN, $281a441cdcb2cf36$var$SEMRESATTRS_AWS_ECS_TASK_FAMILY, $281a441cdcb2cf36$var$SEMRESATTRS_AWS_ECS_TASK_REVISION, $281a441cdcb2cf36$var$SEMRESATTRS_AWS_EKS_CLUSTER_ARN, $281a441cdcb2cf36$var$SEMRESATTRS_AWS_LOG_GROUP_NAMES, $281a441cdcb2cf36$var$SEMRESATTRS_AWS_LOG_GROUP_ARNS, $281a441cdcb2cf36$var$SEMRESATTRS_AWS_LOG_STREAM_NAMES, $281a441cdcb2cf36$var$SEMRESATTRS_AWS_LOG_STREAM_ARNS, $281a441cdcb2cf36$var$SEMRESATTRS_CONTAINER_NAME, $281a441cdcb2cf36$var$SEMRESATTRS_CONTAINER_ID, $281a441cdcb2cf36$var$SEMRESATTRS_CONTAINER_RUNTIME, $281a441cdcb2cf36$var$SEMRESATTRS_CONTAINER_IMAGE_NAME, $281a441cdcb2cf36$var$SEMRESATTRS_CONTAINER_IMAGE_TAG, $281a441cdcb2cf36$var$SEMRESATTRS_DEPLOYMENT_ENVIRONMENT, $281a441cdcb2cf36$var$SEMRESATTRS_DEVICE_ID, $281a441cdcb2cf36$var$SEMRESATTRS_DEVICE_MODEL_IDENTIFIER, $281a441cdcb2cf36$var$SEMRESATTRS_DEVICE_MODEL_NAME, $281a441cdcb2cf36$var$SEMRESATTRS_FAAS_NAME, $281a441cdcb2cf36$var$SEMRESATTRS_FAAS_ID, $281a441cdcb2cf36$var$SEMRESATTRS_FAAS_VERSION, $281a441cdcb2cf36$var$SEMRESATTRS_FAAS_INSTANCE, $281a441cdcb2cf36$var$SEMRESATTRS_FAAS_MAX_MEMORY, $281a441cdcb2cf36$var$SEMRESATTRS_HOST_ID, $281a441cdcb2cf36$var$SEMRESATTRS_HOST_NAME, $281a441cdcb2cf36$var$SEMRESATTRS_HOST_TYPE, $281a441cdcb2cf36$var$SEMRESATTRS_HOST_ARCH, $281a441cdcb2cf36$var$SEMRESATTRS_HOST_IMAGE_NAME, $281a441cdcb2cf36$var$SEMRESATTRS_HOST_IMAGE_ID, $281a441cdcb2cf36$var$SEMRESATTRS_HOST_IMAGE_VERSION, $281a441cdcb2cf36$var$SEMRESATTRS_K8S_CLUSTER_NAME, $281a441cdcb2cf36$var$SEMRESATTRS_K8S_NODE_NAME, $281a441cdcb2cf36$var$SEMRESATTRS_K8S_NODE_UID, $281a441cdcb2cf36$var$SEMRESATTRS_K8S_NAMESPACE_NAME, $281a441cdcb2cf36$var$SEMRESATTRS_K8S_POD_UID, $281a441cdcb2cf36$var$SEMRESATTRS_K8S_POD_NAME, $281a441cdcb2cf36$var$SEMRESATTRS_K8S_CONTAINER_NAME, $281a441cdcb2cf36$var$SEMRESATTRS_K8S_REPLICASET_UID, $281a441cdcb2cf36$var$SEMRESATTRS_K8S_REPLICASET_NAME, $281a441cdcb2cf36$var$SEMRESATTRS_K8S_DEPLOYMENT_UID, $281a441cdcb2cf36$var$SEMRESATTRS_K8S_DEPLOYMENT_NAME, $281a441cdcb2cf36$var$SEMRESATTRS_K8S_STATEFULSET_UID, $281a441cdcb2cf36$var$SEMRESATTRS_K8S_STATEFULSET_NAME, $281a441cdcb2cf36$var$SEMRESATTRS_K8S_DAEMONSET_UID, $281a441cdcb2cf36$var$SEMRESATTRS_K8S_DAEMONSET_NAME, $281a441cdcb2cf36$var$SEMRESATTRS_K8S_JOB_UID, $281a441cdcb2cf36$var$SEMRESATTRS_K8S_JOB_NAME, $281a441cdcb2cf36$var$SEMRESATTRS_K8S_CRONJOB_UID, $281a441cdcb2cf36$var$SEMRESATTRS_K8S_CRONJOB_NAME, $281a441cdcb2cf36$var$SEMRESATTRS_OS_TYPE, $281a441cdcb2cf36$var$SEMRESATTRS_OS_DESCRIPTION, $281a441cdcb2cf36$var$SEMRESATTRS_OS_NAME, $281a441cdcb2cf36$var$SEMRESATTRS_OS_VERSION, $281a441cdcb2cf36$var$SEMRESATTRS_PROCESS_PID, $281a441cdcb2cf36$var$SEMRESATTRS_PROCESS_EXECUTABLE_NAME, $281a441cdcb2cf36$var$SEMRESATTRS_PROCESS_EXECUTABLE_PATH, $281a441cdcb2cf36$var$SEMRESATTRS_PROCESS_COMMAND, $281a441cdcb2cf36$var$SEMRESATTRS_PROCESS_COMMAND_LINE, $281a441cdcb2cf36$var$SEMRESATTRS_PROCESS_COMMAND_ARGS, $281a441cdcb2cf36$var$SEMRESATTRS_PROCESS_OWNER, $281a441cdcb2cf36$var$SEMRESATTRS_PROCESS_RUNTIME_NAME, $281a441cdcb2cf36$var$SEMRESATTRS_PROCESS_RUNTIME_VERSION, $281a441cdcb2cf36$var$SEMRESATTRS_PROCESS_RUNTIME_DESCRIPTION, $281a441cdcb2cf36$var$SEMRESATTRS_SERVICE_NAME, $281a441cdcb2cf36$var$SEMRESATTRS_SERVICE_NAMESPACE, $281a441cdcb2cf36$var$SEMRESATTRS_SERVICE_INSTANCE_ID, $281a441cdcb2cf36$var$SEMRESATTRS_SERVICE_VERSION, $281a441cdcb2cf36$var$SEMRESATTRS_TELEMETRY_SDK_NAME, $281a441cdcb2cf36$var$SEMRESATTRS_TELEMETRY_SDK_LANGUAGE, $281a441cdcb2cf36$var$SEMRESATTRS_TELEMETRY_SDK_VERSION, $281a441cdcb2cf36$var$SEMRESATTRS_TELEMETRY_AUTO_VERSION, $281a441cdcb2cf36$var$SEMRESATTRS_WEBENGINE_NAME, $281a441cdcb2cf36$var$SEMRESATTRS_WEBENGINE_VERSION, $281a441cdcb2cf36$var$SEMRESATTRS_WEBENGINE_DESCRIPTION, $281a441cdcb2cf36$var$SemanticResourceAttributes, $281a441cdcb2cf36$var$TMP_CLOUDPROVIDERVALUES_ALIBABA_CLOUD, $281a441cdcb2cf36$var$TMP_CLOUDPROVIDERVALUES_AWS, $281a441cdcb2cf36$var$TMP_CLOUDPROVIDERVALUES_AZURE, $281a441cdcb2cf36$var$TMP_CLOUDPROVIDERVALUES_GCP, $281a441cdcb2cf36$var$CLOUDPROVIDERVALUES_ALIBABA_CLOUD, $281a441cdcb2cf36$var$CLOUDPROVIDERVALUES_AWS, $281a441cdcb2cf36$var$CLOUDPROVIDERVALUES_AZURE, $281a441cdcb2cf36$var$CLOUDPROVIDERVALUES_GCP, $281a441cdcb2cf36$var$CloudProviderValues, $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_ALIBABA_CLOUD_ECS, $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_ALIBABA_CLOUD_FC, $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_AWS_EC2, $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_AWS_ECS, $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_AWS_EKS, $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_AWS_LAMBDA, $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_AWS_ELASTIC_BEANSTALK, $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_AZURE_VM, $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_AZURE_CONTAINER_INSTANCES, $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_AZURE_AKS, $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_AZURE_FUNCTIONS, $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_AZURE_APP_SERVICE, $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_GCP_COMPUTE_ENGINE, $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_GCP_CLOUD_RUN, $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_GCP_KUBERNETES_ENGINE, $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_GCP_CLOUD_FUNCTIONS, $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_GCP_APP_ENGINE, $281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_ALIBABA_CLOUD_ECS, $281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_ALIBABA_CLOUD_FC, $281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_AWS_EC2, $281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_AWS_ECS, $281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_AWS_EKS, $281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_AWS_LAMBDA, $281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_AWS_ELASTIC_BEANSTALK, $281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_AZURE_VM, $281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_AZURE_CONTAINER_INSTANCES, $281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_AZURE_AKS, $281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_AZURE_FUNCTIONS, $281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_AZURE_APP_SERVICE, $281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_GCP_COMPUTE_ENGINE, $281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_GCP_CLOUD_RUN, $281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_GCP_KUBERNETES_ENGINE, $281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_GCP_CLOUD_FUNCTIONS, $281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_GCP_APP_ENGINE, $281a441cdcb2cf36$var$CloudPlatformValues, $281a441cdcb2cf36$var$TMP_AWSECSLAUNCHTYPEVALUES_EC2, $281a441cdcb2cf36$var$TMP_AWSECSLAUNCHTYPEVALUES_FARGATE, $281a441cdcb2cf36$var$AWSECSLAUNCHTYPEVALUES_EC2, $281a441cdcb2cf36$var$AWSECSLAUNCHTYPEVALUES_FARGATE, $281a441cdcb2cf36$var$AwsEcsLaunchtypeValues, $281a441cdcb2cf36$var$TMP_HOSTARCHVALUES_AMD64, $281a441cdcb2cf36$var$TMP_HOSTARCHVALUES_ARM32, $281a441cdcb2cf36$var$TMP_HOSTARCHVALUES_ARM64, $281a441cdcb2cf36$var$TMP_HOSTARCHVALUES_IA64, $281a441cdcb2cf36$var$TMP_HOSTARCHVALUES_PPC32, $281a441cdcb2cf36$var$TMP_HOSTARCHVALUES_PPC64, $281a441cdcb2cf36$var$TMP_HOSTARCHVALUES_X86, $281a441cdcb2cf36$var$HOSTARCHVALUES_AMD64, $281a441cdcb2cf36$var$HOSTARCHVALUES_ARM32, $281a441cdcb2cf36$var$HOSTARCHVALUES_ARM64, $281a441cdcb2cf36$var$HOSTARCHVALUES_IA64, $281a441cdcb2cf36$var$HOSTARCHVALUES_PPC32, $281a441cdcb2cf36$var$HOSTARCHVALUES_PPC64, $281a441cdcb2cf36$var$HOSTARCHVALUES_X86, $281a441cdcb2cf36$var$HostArchValues, $281a441cdcb2cf36$var$TMP_OSTYPEVALUES_WINDOWS, $281a441cdcb2cf36$var$TMP_OSTYPEVALUES_LINUX, $281a441cdcb2cf36$var$TMP_OSTYPEVALUES_DARWIN, $281a441cdcb2cf36$var$TMP_OSTYPEVALUES_FREEBSD, $281a441cdcb2cf36$var$TMP_OSTYPEVALUES_NETBSD, $281a441cdcb2cf36$var$TMP_OSTYPEVALUES_OPENBSD, $281a441cdcb2cf36$var$TMP_OSTYPEVALUES_DRAGONFLYBSD, $281a441cdcb2cf36$var$TMP_OSTYPEVALUES_HPUX, $281a441cdcb2cf36$var$TMP_OSTYPEVALUES_AIX, $281a441cdcb2cf36$var$TMP_OSTYPEVALUES_SOLARIS, $281a441cdcb2cf36$var$TMP_OSTYPEVALUES_Z_OS, $281a441cdcb2cf36$var$OSTYPEVALUES_WINDOWS, $281a441cdcb2cf36$var$OSTYPEVALUES_LINUX, $281a441cdcb2cf36$var$OSTYPEVALUES_DARWIN, $281a441cdcb2cf36$var$OSTYPEVALUES_FREEBSD, $281a441cdcb2cf36$var$OSTYPEVALUES_NETBSD, $281a441cdcb2cf36$var$OSTYPEVALUES_OPENBSD, $281a441cdcb2cf36$var$OSTYPEVALUES_DRAGONFLYBSD, $281a441cdcb2cf36$var$OSTYPEVALUES_HPUX, $281a441cdcb2cf36$var$OSTYPEVALUES_AIX, $281a441cdcb2cf36$var$OSTYPEVALUES_SOLARIS, $281a441cdcb2cf36$var$OSTYPEVALUES_Z_OS, $281a441cdcb2cf36$var$OsTypeValues, $281a441cdcb2cf36$var$TMP_TELEMETRYSDKLANGUAGEVALUES_CPP, $281a441cdcb2cf36$var$TMP_TELEMETRYSDKLANGUAGEVALUES_DOTNET, $281a441cdcb2cf36$var$TMP_TELEMETRYSDKLANGUAGEVALUES_ERLANG, $281a441cdcb2cf36$var$TMP_TELEMETRYSDKLANGUAGEVALUES_GO, $281a441cdcb2cf36$var$TMP_TELEMETRYSDKLANGUAGEVALUES_JAVA, $281a441cdcb2cf36$var$TMP_TELEMETRYSDKLANGUAGEVALUES_NODEJS, $281a441cdcb2cf36$var$TMP_TELEMETRYSDKLANGUAGEVALUES_PHP, $281a441cdcb2cf36$var$TMP_TELEMETRYSDKLANGUAGEVALUES_PYTHON, $281a441cdcb2cf36$var$TMP_TELEMETRYSDKLANGUAGEVALUES_RUBY, $281a441cdcb2cf36$var$TMP_TELEMETRYSDKLANGUAGEVALUES_WEBJS, $281a441cdcb2cf36$var$TELEMETRYSDKLANGUAGEVALUES_CPP, $281a441cdcb2cf36$var$TELEMETRYSDKLANGUAGEVALUES_DOTNET, $281a441cdcb2cf36$var$TELEMETRYSDKLANGUAGEVALUES_ERLANG, $281a441cdcb2cf36$var$TELEMETRYSDKLANGUAGEVALUES_GO, $281a441cdcb2cf36$var$TELEMETRYSDKLANGUAGEVALUES_JAVA, $281a441cdcb2cf36$var$TELEMETRYSDKLANGUAGEVALUES_NODEJS, $281a441cdcb2cf36$var$TELEMETRYSDKLANGUAGEVALUES_PHP, $281a441cdcb2cf36$var$TELEMETRYSDKLANGUAGEVALUES_PYTHON, $281a441cdcb2cf36$var$TELEMETRYSDKLANGUAGEVALUES_RUBY, $281a441cdcb2cf36$var$TELEMETRYSDKLANGUAGEVALUES_WEBJS, $281a441cdcb2cf36$var$TelemetrySdkLanguageValues;
var $281a441cdcb2cf36$var$init_SemanticResourceAttributes = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/semantic-conventions/build/esm/resource/SemanticResourceAttributes.js" () {
        $281a441cdcb2cf36$var$init_utils4();
        $281a441cdcb2cf36$var$TMP_CLOUD_PROVIDER = "cloud.provider";
        $281a441cdcb2cf36$var$TMP_CLOUD_ACCOUNT_ID = "cloud.account.id";
        $281a441cdcb2cf36$var$TMP_CLOUD_REGION = "cloud.region";
        $281a441cdcb2cf36$var$TMP_CLOUD_AVAILABILITY_ZONE = "cloud.availability_zone";
        $281a441cdcb2cf36$var$TMP_CLOUD_PLATFORM = "cloud.platform";
        $281a441cdcb2cf36$var$TMP_AWS_ECS_CONTAINER_ARN = "aws.ecs.container.arn";
        $281a441cdcb2cf36$var$TMP_AWS_ECS_CLUSTER_ARN = "aws.ecs.cluster.arn";
        $281a441cdcb2cf36$var$TMP_AWS_ECS_LAUNCHTYPE = "aws.ecs.launchtype";
        $281a441cdcb2cf36$var$TMP_AWS_ECS_TASK_ARN = "aws.ecs.task.arn";
        $281a441cdcb2cf36$var$TMP_AWS_ECS_TASK_FAMILY = "aws.ecs.task.family";
        $281a441cdcb2cf36$var$TMP_AWS_ECS_TASK_REVISION = "aws.ecs.task.revision";
        $281a441cdcb2cf36$var$TMP_AWS_EKS_CLUSTER_ARN = "aws.eks.cluster.arn";
        $281a441cdcb2cf36$var$TMP_AWS_LOG_GROUP_NAMES = "aws.log.group.names";
        $281a441cdcb2cf36$var$TMP_AWS_LOG_GROUP_ARNS = "aws.log.group.arns";
        $281a441cdcb2cf36$var$TMP_AWS_LOG_STREAM_NAMES = "aws.log.stream.names";
        $281a441cdcb2cf36$var$TMP_AWS_LOG_STREAM_ARNS = "aws.log.stream.arns";
        $281a441cdcb2cf36$var$TMP_CONTAINER_NAME = "container.name";
        $281a441cdcb2cf36$var$TMP_CONTAINER_ID = "container.id";
        $281a441cdcb2cf36$var$TMP_CONTAINER_RUNTIME = "container.runtime";
        $281a441cdcb2cf36$var$TMP_CONTAINER_IMAGE_NAME = "container.image.name";
        $281a441cdcb2cf36$var$TMP_CONTAINER_IMAGE_TAG = "container.image.tag";
        $281a441cdcb2cf36$var$TMP_DEPLOYMENT_ENVIRONMENT = "deployment.environment";
        $281a441cdcb2cf36$var$TMP_DEVICE_ID = "device.id";
        $281a441cdcb2cf36$var$TMP_DEVICE_MODEL_IDENTIFIER = "device.model.identifier";
        $281a441cdcb2cf36$var$TMP_DEVICE_MODEL_NAME = "device.model.name";
        $281a441cdcb2cf36$var$TMP_FAAS_NAME = "faas.name";
        $281a441cdcb2cf36$var$TMP_FAAS_ID = "faas.id";
        $281a441cdcb2cf36$var$TMP_FAAS_VERSION = "faas.version";
        $281a441cdcb2cf36$var$TMP_FAAS_INSTANCE = "faas.instance";
        $281a441cdcb2cf36$var$TMP_FAAS_MAX_MEMORY = "faas.max_memory";
        $281a441cdcb2cf36$var$TMP_HOST_ID = "host.id";
        $281a441cdcb2cf36$var$TMP_HOST_NAME = "host.name";
        $281a441cdcb2cf36$var$TMP_HOST_TYPE = "host.type";
        $281a441cdcb2cf36$var$TMP_HOST_ARCH = "host.arch";
        $281a441cdcb2cf36$var$TMP_HOST_IMAGE_NAME = "host.image.name";
        $281a441cdcb2cf36$var$TMP_HOST_IMAGE_ID = "host.image.id";
        $281a441cdcb2cf36$var$TMP_HOST_IMAGE_VERSION = "host.image.version";
        $281a441cdcb2cf36$var$TMP_K8S_CLUSTER_NAME = "k8s.cluster.name";
        $281a441cdcb2cf36$var$TMP_K8S_NODE_NAME = "k8s.node.name";
        $281a441cdcb2cf36$var$TMP_K8S_NODE_UID = "k8s.node.uid";
        $281a441cdcb2cf36$var$TMP_K8S_NAMESPACE_NAME = "k8s.namespace.name";
        $281a441cdcb2cf36$var$TMP_K8S_POD_UID = "k8s.pod.uid";
        $281a441cdcb2cf36$var$TMP_K8S_POD_NAME = "k8s.pod.name";
        $281a441cdcb2cf36$var$TMP_K8S_CONTAINER_NAME = "k8s.container.name";
        $281a441cdcb2cf36$var$TMP_K8S_REPLICASET_UID = "k8s.replicaset.uid";
        $281a441cdcb2cf36$var$TMP_K8S_REPLICASET_NAME = "k8s.replicaset.name";
        $281a441cdcb2cf36$var$TMP_K8S_DEPLOYMENT_UID = "k8s.deployment.uid";
        $281a441cdcb2cf36$var$TMP_K8S_DEPLOYMENT_NAME = "k8s.deployment.name";
        $281a441cdcb2cf36$var$TMP_K8S_STATEFULSET_UID = "k8s.statefulset.uid";
        $281a441cdcb2cf36$var$TMP_K8S_STATEFULSET_NAME = "k8s.statefulset.name";
        $281a441cdcb2cf36$var$TMP_K8S_DAEMONSET_UID = "k8s.daemonset.uid";
        $281a441cdcb2cf36$var$TMP_K8S_DAEMONSET_NAME = "k8s.daemonset.name";
        $281a441cdcb2cf36$var$TMP_K8S_JOB_UID = "k8s.job.uid";
        $281a441cdcb2cf36$var$TMP_K8S_JOB_NAME = "k8s.job.name";
        $281a441cdcb2cf36$var$TMP_K8S_CRONJOB_UID = "k8s.cronjob.uid";
        $281a441cdcb2cf36$var$TMP_K8S_CRONJOB_NAME = "k8s.cronjob.name";
        $281a441cdcb2cf36$var$TMP_OS_TYPE = "os.type";
        $281a441cdcb2cf36$var$TMP_OS_DESCRIPTION = "os.description";
        $281a441cdcb2cf36$var$TMP_OS_NAME = "os.name";
        $281a441cdcb2cf36$var$TMP_OS_VERSION = "os.version";
        $281a441cdcb2cf36$var$TMP_PROCESS_PID = "process.pid";
        $281a441cdcb2cf36$var$TMP_PROCESS_EXECUTABLE_NAME = "process.executable.name";
        $281a441cdcb2cf36$var$TMP_PROCESS_EXECUTABLE_PATH = "process.executable.path";
        $281a441cdcb2cf36$var$TMP_PROCESS_COMMAND = "process.command";
        $281a441cdcb2cf36$var$TMP_PROCESS_COMMAND_LINE = "process.command_line";
        $281a441cdcb2cf36$var$TMP_PROCESS_COMMAND_ARGS = "process.command_args";
        $281a441cdcb2cf36$var$TMP_PROCESS_OWNER = "process.owner";
        $281a441cdcb2cf36$var$TMP_PROCESS_RUNTIME_NAME = "process.runtime.name";
        $281a441cdcb2cf36$var$TMP_PROCESS_RUNTIME_VERSION = "process.runtime.version";
        $281a441cdcb2cf36$var$TMP_PROCESS_RUNTIME_DESCRIPTION = "process.runtime.description";
        $281a441cdcb2cf36$var$TMP_SERVICE_NAME = "service.name";
        $281a441cdcb2cf36$var$TMP_SERVICE_NAMESPACE = "service.namespace";
        $281a441cdcb2cf36$var$TMP_SERVICE_INSTANCE_ID = "service.instance.id";
        $281a441cdcb2cf36$var$TMP_SERVICE_VERSION = "service.version";
        $281a441cdcb2cf36$var$TMP_TELEMETRY_SDK_NAME = "telemetry.sdk.name";
        $281a441cdcb2cf36$var$TMP_TELEMETRY_SDK_LANGUAGE = "telemetry.sdk.language";
        $281a441cdcb2cf36$var$TMP_TELEMETRY_SDK_VERSION = "telemetry.sdk.version";
        $281a441cdcb2cf36$var$TMP_TELEMETRY_AUTO_VERSION = "telemetry.auto.version";
        $281a441cdcb2cf36$var$TMP_WEBENGINE_NAME = "webengine.name";
        $281a441cdcb2cf36$var$TMP_WEBENGINE_VERSION = "webengine.version";
        $281a441cdcb2cf36$var$TMP_WEBENGINE_DESCRIPTION = "webengine.description";
        $281a441cdcb2cf36$var$SEMRESATTRS_CLOUD_PROVIDER = $281a441cdcb2cf36$var$TMP_CLOUD_PROVIDER;
        $281a441cdcb2cf36$var$SEMRESATTRS_CLOUD_ACCOUNT_ID = $281a441cdcb2cf36$var$TMP_CLOUD_ACCOUNT_ID;
        $281a441cdcb2cf36$var$SEMRESATTRS_CLOUD_REGION = $281a441cdcb2cf36$var$TMP_CLOUD_REGION;
        $281a441cdcb2cf36$var$SEMRESATTRS_CLOUD_AVAILABILITY_ZONE = $281a441cdcb2cf36$var$TMP_CLOUD_AVAILABILITY_ZONE;
        $281a441cdcb2cf36$var$SEMRESATTRS_CLOUD_PLATFORM = $281a441cdcb2cf36$var$TMP_CLOUD_PLATFORM;
        $281a441cdcb2cf36$var$SEMRESATTRS_AWS_ECS_CONTAINER_ARN = $281a441cdcb2cf36$var$TMP_AWS_ECS_CONTAINER_ARN;
        $281a441cdcb2cf36$var$SEMRESATTRS_AWS_ECS_CLUSTER_ARN = $281a441cdcb2cf36$var$TMP_AWS_ECS_CLUSTER_ARN;
        $281a441cdcb2cf36$var$SEMRESATTRS_AWS_ECS_LAUNCHTYPE = $281a441cdcb2cf36$var$TMP_AWS_ECS_LAUNCHTYPE;
        $281a441cdcb2cf36$var$SEMRESATTRS_AWS_ECS_TASK_ARN = $281a441cdcb2cf36$var$TMP_AWS_ECS_TASK_ARN;
        $281a441cdcb2cf36$var$SEMRESATTRS_AWS_ECS_TASK_FAMILY = $281a441cdcb2cf36$var$TMP_AWS_ECS_TASK_FAMILY;
        $281a441cdcb2cf36$var$SEMRESATTRS_AWS_ECS_TASK_REVISION = $281a441cdcb2cf36$var$TMP_AWS_ECS_TASK_REVISION;
        $281a441cdcb2cf36$var$SEMRESATTRS_AWS_EKS_CLUSTER_ARN = $281a441cdcb2cf36$var$TMP_AWS_EKS_CLUSTER_ARN;
        $281a441cdcb2cf36$var$SEMRESATTRS_AWS_LOG_GROUP_NAMES = $281a441cdcb2cf36$var$TMP_AWS_LOG_GROUP_NAMES;
        $281a441cdcb2cf36$var$SEMRESATTRS_AWS_LOG_GROUP_ARNS = $281a441cdcb2cf36$var$TMP_AWS_LOG_GROUP_ARNS;
        $281a441cdcb2cf36$var$SEMRESATTRS_AWS_LOG_STREAM_NAMES = $281a441cdcb2cf36$var$TMP_AWS_LOG_STREAM_NAMES;
        $281a441cdcb2cf36$var$SEMRESATTRS_AWS_LOG_STREAM_ARNS = $281a441cdcb2cf36$var$TMP_AWS_LOG_STREAM_ARNS;
        $281a441cdcb2cf36$var$SEMRESATTRS_CONTAINER_NAME = $281a441cdcb2cf36$var$TMP_CONTAINER_NAME;
        $281a441cdcb2cf36$var$SEMRESATTRS_CONTAINER_ID = $281a441cdcb2cf36$var$TMP_CONTAINER_ID;
        $281a441cdcb2cf36$var$SEMRESATTRS_CONTAINER_RUNTIME = $281a441cdcb2cf36$var$TMP_CONTAINER_RUNTIME;
        $281a441cdcb2cf36$var$SEMRESATTRS_CONTAINER_IMAGE_NAME = $281a441cdcb2cf36$var$TMP_CONTAINER_IMAGE_NAME;
        $281a441cdcb2cf36$var$SEMRESATTRS_CONTAINER_IMAGE_TAG = $281a441cdcb2cf36$var$TMP_CONTAINER_IMAGE_TAG;
        $281a441cdcb2cf36$var$SEMRESATTRS_DEPLOYMENT_ENVIRONMENT = $281a441cdcb2cf36$var$TMP_DEPLOYMENT_ENVIRONMENT;
        $281a441cdcb2cf36$var$SEMRESATTRS_DEVICE_ID = $281a441cdcb2cf36$var$TMP_DEVICE_ID;
        $281a441cdcb2cf36$var$SEMRESATTRS_DEVICE_MODEL_IDENTIFIER = $281a441cdcb2cf36$var$TMP_DEVICE_MODEL_IDENTIFIER;
        $281a441cdcb2cf36$var$SEMRESATTRS_DEVICE_MODEL_NAME = $281a441cdcb2cf36$var$TMP_DEVICE_MODEL_NAME;
        $281a441cdcb2cf36$var$SEMRESATTRS_FAAS_NAME = $281a441cdcb2cf36$var$TMP_FAAS_NAME;
        $281a441cdcb2cf36$var$SEMRESATTRS_FAAS_ID = $281a441cdcb2cf36$var$TMP_FAAS_ID;
        $281a441cdcb2cf36$var$SEMRESATTRS_FAAS_VERSION = $281a441cdcb2cf36$var$TMP_FAAS_VERSION;
        $281a441cdcb2cf36$var$SEMRESATTRS_FAAS_INSTANCE = $281a441cdcb2cf36$var$TMP_FAAS_INSTANCE;
        $281a441cdcb2cf36$var$SEMRESATTRS_FAAS_MAX_MEMORY = $281a441cdcb2cf36$var$TMP_FAAS_MAX_MEMORY;
        $281a441cdcb2cf36$var$SEMRESATTRS_HOST_ID = $281a441cdcb2cf36$var$TMP_HOST_ID;
        $281a441cdcb2cf36$var$SEMRESATTRS_HOST_NAME = $281a441cdcb2cf36$var$TMP_HOST_NAME;
        $281a441cdcb2cf36$var$SEMRESATTRS_HOST_TYPE = $281a441cdcb2cf36$var$TMP_HOST_TYPE;
        $281a441cdcb2cf36$var$SEMRESATTRS_HOST_ARCH = $281a441cdcb2cf36$var$TMP_HOST_ARCH;
        $281a441cdcb2cf36$var$SEMRESATTRS_HOST_IMAGE_NAME = $281a441cdcb2cf36$var$TMP_HOST_IMAGE_NAME;
        $281a441cdcb2cf36$var$SEMRESATTRS_HOST_IMAGE_ID = $281a441cdcb2cf36$var$TMP_HOST_IMAGE_ID;
        $281a441cdcb2cf36$var$SEMRESATTRS_HOST_IMAGE_VERSION = $281a441cdcb2cf36$var$TMP_HOST_IMAGE_VERSION;
        $281a441cdcb2cf36$var$SEMRESATTRS_K8S_CLUSTER_NAME = $281a441cdcb2cf36$var$TMP_K8S_CLUSTER_NAME;
        $281a441cdcb2cf36$var$SEMRESATTRS_K8S_NODE_NAME = $281a441cdcb2cf36$var$TMP_K8S_NODE_NAME;
        $281a441cdcb2cf36$var$SEMRESATTRS_K8S_NODE_UID = $281a441cdcb2cf36$var$TMP_K8S_NODE_UID;
        $281a441cdcb2cf36$var$SEMRESATTRS_K8S_NAMESPACE_NAME = $281a441cdcb2cf36$var$TMP_K8S_NAMESPACE_NAME;
        $281a441cdcb2cf36$var$SEMRESATTRS_K8S_POD_UID = $281a441cdcb2cf36$var$TMP_K8S_POD_UID;
        $281a441cdcb2cf36$var$SEMRESATTRS_K8S_POD_NAME = $281a441cdcb2cf36$var$TMP_K8S_POD_NAME;
        $281a441cdcb2cf36$var$SEMRESATTRS_K8S_CONTAINER_NAME = $281a441cdcb2cf36$var$TMP_K8S_CONTAINER_NAME;
        $281a441cdcb2cf36$var$SEMRESATTRS_K8S_REPLICASET_UID = $281a441cdcb2cf36$var$TMP_K8S_REPLICASET_UID;
        $281a441cdcb2cf36$var$SEMRESATTRS_K8S_REPLICASET_NAME = $281a441cdcb2cf36$var$TMP_K8S_REPLICASET_NAME;
        $281a441cdcb2cf36$var$SEMRESATTRS_K8S_DEPLOYMENT_UID = $281a441cdcb2cf36$var$TMP_K8S_DEPLOYMENT_UID;
        $281a441cdcb2cf36$var$SEMRESATTRS_K8S_DEPLOYMENT_NAME = $281a441cdcb2cf36$var$TMP_K8S_DEPLOYMENT_NAME;
        $281a441cdcb2cf36$var$SEMRESATTRS_K8S_STATEFULSET_UID = $281a441cdcb2cf36$var$TMP_K8S_STATEFULSET_UID;
        $281a441cdcb2cf36$var$SEMRESATTRS_K8S_STATEFULSET_NAME = $281a441cdcb2cf36$var$TMP_K8S_STATEFULSET_NAME;
        $281a441cdcb2cf36$var$SEMRESATTRS_K8S_DAEMONSET_UID = $281a441cdcb2cf36$var$TMP_K8S_DAEMONSET_UID;
        $281a441cdcb2cf36$var$SEMRESATTRS_K8S_DAEMONSET_NAME = $281a441cdcb2cf36$var$TMP_K8S_DAEMONSET_NAME;
        $281a441cdcb2cf36$var$SEMRESATTRS_K8S_JOB_UID = $281a441cdcb2cf36$var$TMP_K8S_JOB_UID;
        $281a441cdcb2cf36$var$SEMRESATTRS_K8S_JOB_NAME = $281a441cdcb2cf36$var$TMP_K8S_JOB_NAME;
        $281a441cdcb2cf36$var$SEMRESATTRS_K8S_CRONJOB_UID = $281a441cdcb2cf36$var$TMP_K8S_CRONJOB_UID;
        $281a441cdcb2cf36$var$SEMRESATTRS_K8S_CRONJOB_NAME = $281a441cdcb2cf36$var$TMP_K8S_CRONJOB_NAME;
        $281a441cdcb2cf36$var$SEMRESATTRS_OS_TYPE = $281a441cdcb2cf36$var$TMP_OS_TYPE;
        $281a441cdcb2cf36$var$SEMRESATTRS_OS_DESCRIPTION = $281a441cdcb2cf36$var$TMP_OS_DESCRIPTION;
        $281a441cdcb2cf36$var$SEMRESATTRS_OS_NAME = $281a441cdcb2cf36$var$TMP_OS_NAME;
        $281a441cdcb2cf36$var$SEMRESATTRS_OS_VERSION = $281a441cdcb2cf36$var$TMP_OS_VERSION;
        $281a441cdcb2cf36$var$SEMRESATTRS_PROCESS_PID = $281a441cdcb2cf36$var$TMP_PROCESS_PID;
        $281a441cdcb2cf36$var$SEMRESATTRS_PROCESS_EXECUTABLE_NAME = $281a441cdcb2cf36$var$TMP_PROCESS_EXECUTABLE_NAME;
        $281a441cdcb2cf36$var$SEMRESATTRS_PROCESS_EXECUTABLE_PATH = $281a441cdcb2cf36$var$TMP_PROCESS_EXECUTABLE_PATH;
        $281a441cdcb2cf36$var$SEMRESATTRS_PROCESS_COMMAND = $281a441cdcb2cf36$var$TMP_PROCESS_COMMAND;
        $281a441cdcb2cf36$var$SEMRESATTRS_PROCESS_COMMAND_LINE = $281a441cdcb2cf36$var$TMP_PROCESS_COMMAND_LINE;
        $281a441cdcb2cf36$var$SEMRESATTRS_PROCESS_COMMAND_ARGS = $281a441cdcb2cf36$var$TMP_PROCESS_COMMAND_ARGS;
        $281a441cdcb2cf36$var$SEMRESATTRS_PROCESS_OWNER = $281a441cdcb2cf36$var$TMP_PROCESS_OWNER;
        $281a441cdcb2cf36$var$SEMRESATTRS_PROCESS_RUNTIME_NAME = $281a441cdcb2cf36$var$TMP_PROCESS_RUNTIME_NAME;
        $281a441cdcb2cf36$var$SEMRESATTRS_PROCESS_RUNTIME_VERSION = $281a441cdcb2cf36$var$TMP_PROCESS_RUNTIME_VERSION;
        $281a441cdcb2cf36$var$SEMRESATTRS_PROCESS_RUNTIME_DESCRIPTION = $281a441cdcb2cf36$var$TMP_PROCESS_RUNTIME_DESCRIPTION;
        $281a441cdcb2cf36$var$SEMRESATTRS_SERVICE_NAME = $281a441cdcb2cf36$var$TMP_SERVICE_NAME;
        $281a441cdcb2cf36$var$SEMRESATTRS_SERVICE_NAMESPACE = $281a441cdcb2cf36$var$TMP_SERVICE_NAMESPACE;
        $281a441cdcb2cf36$var$SEMRESATTRS_SERVICE_INSTANCE_ID = $281a441cdcb2cf36$var$TMP_SERVICE_INSTANCE_ID;
        $281a441cdcb2cf36$var$SEMRESATTRS_SERVICE_VERSION = $281a441cdcb2cf36$var$TMP_SERVICE_VERSION;
        $281a441cdcb2cf36$var$SEMRESATTRS_TELEMETRY_SDK_NAME = $281a441cdcb2cf36$var$TMP_TELEMETRY_SDK_NAME;
        $281a441cdcb2cf36$var$SEMRESATTRS_TELEMETRY_SDK_LANGUAGE = $281a441cdcb2cf36$var$TMP_TELEMETRY_SDK_LANGUAGE;
        $281a441cdcb2cf36$var$SEMRESATTRS_TELEMETRY_SDK_VERSION = $281a441cdcb2cf36$var$TMP_TELEMETRY_SDK_VERSION;
        $281a441cdcb2cf36$var$SEMRESATTRS_TELEMETRY_AUTO_VERSION = $281a441cdcb2cf36$var$TMP_TELEMETRY_AUTO_VERSION;
        $281a441cdcb2cf36$var$SEMRESATTRS_WEBENGINE_NAME = $281a441cdcb2cf36$var$TMP_WEBENGINE_NAME;
        $281a441cdcb2cf36$var$SEMRESATTRS_WEBENGINE_VERSION = $281a441cdcb2cf36$var$TMP_WEBENGINE_VERSION;
        $281a441cdcb2cf36$var$SEMRESATTRS_WEBENGINE_DESCRIPTION = $281a441cdcb2cf36$var$TMP_WEBENGINE_DESCRIPTION;
        $281a441cdcb2cf36$var$SemanticResourceAttributes = /* @__PURE__ */ $281a441cdcb2cf36$var$createConstMap([
            $281a441cdcb2cf36$var$TMP_CLOUD_PROVIDER,
            $281a441cdcb2cf36$var$TMP_CLOUD_ACCOUNT_ID,
            $281a441cdcb2cf36$var$TMP_CLOUD_REGION,
            $281a441cdcb2cf36$var$TMP_CLOUD_AVAILABILITY_ZONE,
            $281a441cdcb2cf36$var$TMP_CLOUD_PLATFORM,
            $281a441cdcb2cf36$var$TMP_AWS_ECS_CONTAINER_ARN,
            $281a441cdcb2cf36$var$TMP_AWS_ECS_CLUSTER_ARN,
            $281a441cdcb2cf36$var$TMP_AWS_ECS_LAUNCHTYPE,
            $281a441cdcb2cf36$var$TMP_AWS_ECS_TASK_ARN,
            $281a441cdcb2cf36$var$TMP_AWS_ECS_TASK_FAMILY,
            $281a441cdcb2cf36$var$TMP_AWS_ECS_TASK_REVISION,
            $281a441cdcb2cf36$var$TMP_AWS_EKS_CLUSTER_ARN,
            $281a441cdcb2cf36$var$TMP_AWS_LOG_GROUP_NAMES,
            $281a441cdcb2cf36$var$TMP_AWS_LOG_GROUP_ARNS,
            $281a441cdcb2cf36$var$TMP_AWS_LOG_STREAM_NAMES,
            $281a441cdcb2cf36$var$TMP_AWS_LOG_STREAM_ARNS,
            $281a441cdcb2cf36$var$TMP_CONTAINER_NAME,
            $281a441cdcb2cf36$var$TMP_CONTAINER_ID,
            $281a441cdcb2cf36$var$TMP_CONTAINER_RUNTIME,
            $281a441cdcb2cf36$var$TMP_CONTAINER_IMAGE_NAME,
            $281a441cdcb2cf36$var$TMP_CONTAINER_IMAGE_TAG,
            $281a441cdcb2cf36$var$TMP_DEPLOYMENT_ENVIRONMENT,
            $281a441cdcb2cf36$var$TMP_DEVICE_ID,
            $281a441cdcb2cf36$var$TMP_DEVICE_MODEL_IDENTIFIER,
            $281a441cdcb2cf36$var$TMP_DEVICE_MODEL_NAME,
            $281a441cdcb2cf36$var$TMP_FAAS_NAME,
            $281a441cdcb2cf36$var$TMP_FAAS_ID,
            $281a441cdcb2cf36$var$TMP_FAAS_VERSION,
            $281a441cdcb2cf36$var$TMP_FAAS_INSTANCE,
            $281a441cdcb2cf36$var$TMP_FAAS_MAX_MEMORY,
            $281a441cdcb2cf36$var$TMP_HOST_ID,
            $281a441cdcb2cf36$var$TMP_HOST_NAME,
            $281a441cdcb2cf36$var$TMP_HOST_TYPE,
            $281a441cdcb2cf36$var$TMP_HOST_ARCH,
            $281a441cdcb2cf36$var$TMP_HOST_IMAGE_NAME,
            $281a441cdcb2cf36$var$TMP_HOST_IMAGE_ID,
            $281a441cdcb2cf36$var$TMP_HOST_IMAGE_VERSION,
            $281a441cdcb2cf36$var$TMP_K8S_CLUSTER_NAME,
            $281a441cdcb2cf36$var$TMP_K8S_NODE_NAME,
            $281a441cdcb2cf36$var$TMP_K8S_NODE_UID,
            $281a441cdcb2cf36$var$TMP_K8S_NAMESPACE_NAME,
            $281a441cdcb2cf36$var$TMP_K8S_POD_UID,
            $281a441cdcb2cf36$var$TMP_K8S_POD_NAME,
            $281a441cdcb2cf36$var$TMP_K8S_CONTAINER_NAME,
            $281a441cdcb2cf36$var$TMP_K8S_REPLICASET_UID,
            $281a441cdcb2cf36$var$TMP_K8S_REPLICASET_NAME,
            $281a441cdcb2cf36$var$TMP_K8S_DEPLOYMENT_UID,
            $281a441cdcb2cf36$var$TMP_K8S_DEPLOYMENT_NAME,
            $281a441cdcb2cf36$var$TMP_K8S_STATEFULSET_UID,
            $281a441cdcb2cf36$var$TMP_K8S_STATEFULSET_NAME,
            $281a441cdcb2cf36$var$TMP_K8S_DAEMONSET_UID,
            $281a441cdcb2cf36$var$TMP_K8S_DAEMONSET_NAME,
            $281a441cdcb2cf36$var$TMP_K8S_JOB_UID,
            $281a441cdcb2cf36$var$TMP_K8S_JOB_NAME,
            $281a441cdcb2cf36$var$TMP_K8S_CRONJOB_UID,
            $281a441cdcb2cf36$var$TMP_K8S_CRONJOB_NAME,
            $281a441cdcb2cf36$var$TMP_OS_TYPE,
            $281a441cdcb2cf36$var$TMP_OS_DESCRIPTION,
            $281a441cdcb2cf36$var$TMP_OS_NAME,
            $281a441cdcb2cf36$var$TMP_OS_VERSION,
            $281a441cdcb2cf36$var$TMP_PROCESS_PID,
            $281a441cdcb2cf36$var$TMP_PROCESS_EXECUTABLE_NAME,
            $281a441cdcb2cf36$var$TMP_PROCESS_EXECUTABLE_PATH,
            $281a441cdcb2cf36$var$TMP_PROCESS_COMMAND,
            $281a441cdcb2cf36$var$TMP_PROCESS_COMMAND_LINE,
            $281a441cdcb2cf36$var$TMP_PROCESS_COMMAND_ARGS,
            $281a441cdcb2cf36$var$TMP_PROCESS_OWNER,
            $281a441cdcb2cf36$var$TMP_PROCESS_RUNTIME_NAME,
            $281a441cdcb2cf36$var$TMP_PROCESS_RUNTIME_VERSION,
            $281a441cdcb2cf36$var$TMP_PROCESS_RUNTIME_DESCRIPTION,
            $281a441cdcb2cf36$var$TMP_SERVICE_NAME,
            $281a441cdcb2cf36$var$TMP_SERVICE_NAMESPACE,
            $281a441cdcb2cf36$var$TMP_SERVICE_INSTANCE_ID,
            $281a441cdcb2cf36$var$TMP_SERVICE_VERSION,
            $281a441cdcb2cf36$var$TMP_TELEMETRY_SDK_NAME,
            $281a441cdcb2cf36$var$TMP_TELEMETRY_SDK_LANGUAGE,
            $281a441cdcb2cf36$var$TMP_TELEMETRY_SDK_VERSION,
            $281a441cdcb2cf36$var$TMP_TELEMETRY_AUTO_VERSION,
            $281a441cdcb2cf36$var$TMP_WEBENGINE_NAME,
            $281a441cdcb2cf36$var$TMP_WEBENGINE_VERSION,
            $281a441cdcb2cf36$var$TMP_WEBENGINE_DESCRIPTION
        ]);
        $281a441cdcb2cf36$var$TMP_CLOUDPROVIDERVALUES_ALIBABA_CLOUD = "alibaba_cloud";
        $281a441cdcb2cf36$var$TMP_CLOUDPROVIDERVALUES_AWS = "aws";
        $281a441cdcb2cf36$var$TMP_CLOUDPROVIDERVALUES_AZURE = "azure";
        $281a441cdcb2cf36$var$TMP_CLOUDPROVIDERVALUES_GCP = "gcp";
        $281a441cdcb2cf36$var$CLOUDPROVIDERVALUES_ALIBABA_CLOUD = $281a441cdcb2cf36$var$TMP_CLOUDPROVIDERVALUES_ALIBABA_CLOUD;
        $281a441cdcb2cf36$var$CLOUDPROVIDERVALUES_AWS = $281a441cdcb2cf36$var$TMP_CLOUDPROVIDERVALUES_AWS;
        $281a441cdcb2cf36$var$CLOUDPROVIDERVALUES_AZURE = $281a441cdcb2cf36$var$TMP_CLOUDPROVIDERVALUES_AZURE;
        $281a441cdcb2cf36$var$CLOUDPROVIDERVALUES_GCP = $281a441cdcb2cf36$var$TMP_CLOUDPROVIDERVALUES_GCP;
        $281a441cdcb2cf36$var$CloudProviderValues = /* @__PURE__ */ $281a441cdcb2cf36$var$createConstMap([
            $281a441cdcb2cf36$var$TMP_CLOUDPROVIDERVALUES_ALIBABA_CLOUD,
            $281a441cdcb2cf36$var$TMP_CLOUDPROVIDERVALUES_AWS,
            $281a441cdcb2cf36$var$TMP_CLOUDPROVIDERVALUES_AZURE,
            $281a441cdcb2cf36$var$TMP_CLOUDPROVIDERVALUES_GCP
        ]);
        $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_ALIBABA_CLOUD_ECS = "alibaba_cloud_ecs";
        $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_ALIBABA_CLOUD_FC = "alibaba_cloud_fc";
        $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_AWS_EC2 = "aws_ec2";
        $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_AWS_ECS = "aws_ecs";
        $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_AWS_EKS = "aws_eks";
        $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_AWS_LAMBDA = "aws_lambda";
        $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_AWS_ELASTIC_BEANSTALK = "aws_elastic_beanstalk";
        $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_AZURE_VM = "azure_vm";
        $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_AZURE_CONTAINER_INSTANCES = "azure_container_instances";
        $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_AZURE_AKS = "azure_aks";
        $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_AZURE_FUNCTIONS = "azure_functions";
        $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_AZURE_APP_SERVICE = "azure_app_service";
        $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_GCP_COMPUTE_ENGINE = "gcp_compute_engine";
        $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_GCP_CLOUD_RUN = "gcp_cloud_run";
        $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_GCP_KUBERNETES_ENGINE = "gcp_kubernetes_engine";
        $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_GCP_CLOUD_FUNCTIONS = "gcp_cloud_functions";
        $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_GCP_APP_ENGINE = "gcp_app_engine";
        $281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_ALIBABA_CLOUD_ECS = $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_ALIBABA_CLOUD_ECS;
        $281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_ALIBABA_CLOUD_FC = $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_ALIBABA_CLOUD_FC;
        $281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_AWS_EC2 = $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_AWS_EC2;
        $281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_AWS_ECS = $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_AWS_ECS;
        $281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_AWS_EKS = $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_AWS_EKS;
        $281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_AWS_LAMBDA = $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_AWS_LAMBDA;
        $281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_AWS_ELASTIC_BEANSTALK = $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_AWS_ELASTIC_BEANSTALK;
        $281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_AZURE_VM = $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_AZURE_VM;
        $281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_AZURE_CONTAINER_INSTANCES = $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_AZURE_CONTAINER_INSTANCES;
        $281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_AZURE_AKS = $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_AZURE_AKS;
        $281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_AZURE_FUNCTIONS = $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_AZURE_FUNCTIONS;
        $281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_AZURE_APP_SERVICE = $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_AZURE_APP_SERVICE;
        $281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_GCP_COMPUTE_ENGINE = $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_GCP_COMPUTE_ENGINE;
        $281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_GCP_CLOUD_RUN = $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_GCP_CLOUD_RUN;
        $281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_GCP_KUBERNETES_ENGINE = $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_GCP_KUBERNETES_ENGINE;
        $281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_GCP_CLOUD_FUNCTIONS = $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_GCP_CLOUD_FUNCTIONS;
        $281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_GCP_APP_ENGINE = $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_GCP_APP_ENGINE;
        $281a441cdcb2cf36$var$CloudPlatformValues = /* @__PURE__ */ $281a441cdcb2cf36$var$createConstMap([
            $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_ALIBABA_CLOUD_ECS,
            $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_ALIBABA_CLOUD_FC,
            $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_AWS_EC2,
            $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_AWS_ECS,
            $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_AWS_EKS,
            $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_AWS_LAMBDA,
            $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_AWS_ELASTIC_BEANSTALK,
            $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_AZURE_VM,
            $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_AZURE_CONTAINER_INSTANCES,
            $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_AZURE_AKS,
            $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_AZURE_FUNCTIONS,
            $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_AZURE_APP_SERVICE,
            $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_GCP_COMPUTE_ENGINE,
            $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_GCP_CLOUD_RUN,
            $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_GCP_KUBERNETES_ENGINE,
            $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_GCP_CLOUD_FUNCTIONS,
            $281a441cdcb2cf36$var$TMP_CLOUDPLATFORMVALUES_GCP_APP_ENGINE
        ]);
        $281a441cdcb2cf36$var$TMP_AWSECSLAUNCHTYPEVALUES_EC2 = "ec2";
        $281a441cdcb2cf36$var$TMP_AWSECSLAUNCHTYPEVALUES_FARGATE = "fargate";
        $281a441cdcb2cf36$var$AWSECSLAUNCHTYPEVALUES_EC2 = $281a441cdcb2cf36$var$TMP_AWSECSLAUNCHTYPEVALUES_EC2;
        $281a441cdcb2cf36$var$AWSECSLAUNCHTYPEVALUES_FARGATE = $281a441cdcb2cf36$var$TMP_AWSECSLAUNCHTYPEVALUES_FARGATE;
        $281a441cdcb2cf36$var$AwsEcsLaunchtypeValues = /* @__PURE__ */ $281a441cdcb2cf36$var$createConstMap([
            $281a441cdcb2cf36$var$TMP_AWSECSLAUNCHTYPEVALUES_EC2,
            $281a441cdcb2cf36$var$TMP_AWSECSLAUNCHTYPEVALUES_FARGATE
        ]);
        $281a441cdcb2cf36$var$TMP_HOSTARCHVALUES_AMD64 = "amd64";
        $281a441cdcb2cf36$var$TMP_HOSTARCHVALUES_ARM32 = "arm32";
        $281a441cdcb2cf36$var$TMP_HOSTARCHVALUES_ARM64 = "arm64";
        $281a441cdcb2cf36$var$TMP_HOSTARCHVALUES_IA64 = "ia64";
        $281a441cdcb2cf36$var$TMP_HOSTARCHVALUES_PPC32 = "ppc32";
        $281a441cdcb2cf36$var$TMP_HOSTARCHVALUES_PPC64 = "ppc64";
        $281a441cdcb2cf36$var$TMP_HOSTARCHVALUES_X86 = "x86";
        $281a441cdcb2cf36$var$HOSTARCHVALUES_AMD64 = $281a441cdcb2cf36$var$TMP_HOSTARCHVALUES_AMD64;
        $281a441cdcb2cf36$var$HOSTARCHVALUES_ARM32 = $281a441cdcb2cf36$var$TMP_HOSTARCHVALUES_ARM32;
        $281a441cdcb2cf36$var$HOSTARCHVALUES_ARM64 = $281a441cdcb2cf36$var$TMP_HOSTARCHVALUES_ARM64;
        $281a441cdcb2cf36$var$HOSTARCHVALUES_IA64 = $281a441cdcb2cf36$var$TMP_HOSTARCHVALUES_IA64;
        $281a441cdcb2cf36$var$HOSTARCHVALUES_PPC32 = $281a441cdcb2cf36$var$TMP_HOSTARCHVALUES_PPC32;
        $281a441cdcb2cf36$var$HOSTARCHVALUES_PPC64 = $281a441cdcb2cf36$var$TMP_HOSTARCHVALUES_PPC64;
        $281a441cdcb2cf36$var$HOSTARCHVALUES_X86 = $281a441cdcb2cf36$var$TMP_HOSTARCHVALUES_X86;
        $281a441cdcb2cf36$var$HostArchValues = /* @__PURE__ */ $281a441cdcb2cf36$var$createConstMap([
            $281a441cdcb2cf36$var$TMP_HOSTARCHVALUES_AMD64,
            $281a441cdcb2cf36$var$TMP_HOSTARCHVALUES_ARM32,
            $281a441cdcb2cf36$var$TMP_HOSTARCHVALUES_ARM64,
            $281a441cdcb2cf36$var$TMP_HOSTARCHVALUES_IA64,
            $281a441cdcb2cf36$var$TMP_HOSTARCHVALUES_PPC32,
            $281a441cdcb2cf36$var$TMP_HOSTARCHVALUES_PPC64,
            $281a441cdcb2cf36$var$TMP_HOSTARCHVALUES_X86
        ]);
        $281a441cdcb2cf36$var$TMP_OSTYPEVALUES_WINDOWS = "windows";
        $281a441cdcb2cf36$var$TMP_OSTYPEVALUES_LINUX = "linux";
        $281a441cdcb2cf36$var$TMP_OSTYPEVALUES_DARWIN = "darwin";
        $281a441cdcb2cf36$var$TMP_OSTYPEVALUES_FREEBSD = "freebsd";
        $281a441cdcb2cf36$var$TMP_OSTYPEVALUES_NETBSD = "netbsd";
        $281a441cdcb2cf36$var$TMP_OSTYPEVALUES_OPENBSD = "openbsd";
        $281a441cdcb2cf36$var$TMP_OSTYPEVALUES_DRAGONFLYBSD = "dragonflybsd";
        $281a441cdcb2cf36$var$TMP_OSTYPEVALUES_HPUX = "hpux";
        $281a441cdcb2cf36$var$TMP_OSTYPEVALUES_AIX = "aix";
        $281a441cdcb2cf36$var$TMP_OSTYPEVALUES_SOLARIS = "solaris";
        $281a441cdcb2cf36$var$TMP_OSTYPEVALUES_Z_OS = "z_os";
        $281a441cdcb2cf36$var$OSTYPEVALUES_WINDOWS = $281a441cdcb2cf36$var$TMP_OSTYPEVALUES_WINDOWS;
        $281a441cdcb2cf36$var$OSTYPEVALUES_LINUX = $281a441cdcb2cf36$var$TMP_OSTYPEVALUES_LINUX;
        $281a441cdcb2cf36$var$OSTYPEVALUES_DARWIN = $281a441cdcb2cf36$var$TMP_OSTYPEVALUES_DARWIN;
        $281a441cdcb2cf36$var$OSTYPEVALUES_FREEBSD = $281a441cdcb2cf36$var$TMP_OSTYPEVALUES_FREEBSD;
        $281a441cdcb2cf36$var$OSTYPEVALUES_NETBSD = $281a441cdcb2cf36$var$TMP_OSTYPEVALUES_NETBSD;
        $281a441cdcb2cf36$var$OSTYPEVALUES_OPENBSD = $281a441cdcb2cf36$var$TMP_OSTYPEVALUES_OPENBSD;
        $281a441cdcb2cf36$var$OSTYPEVALUES_DRAGONFLYBSD = $281a441cdcb2cf36$var$TMP_OSTYPEVALUES_DRAGONFLYBSD;
        $281a441cdcb2cf36$var$OSTYPEVALUES_HPUX = $281a441cdcb2cf36$var$TMP_OSTYPEVALUES_HPUX;
        $281a441cdcb2cf36$var$OSTYPEVALUES_AIX = $281a441cdcb2cf36$var$TMP_OSTYPEVALUES_AIX;
        $281a441cdcb2cf36$var$OSTYPEVALUES_SOLARIS = $281a441cdcb2cf36$var$TMP_OSTYPEVALUES_SOLARIS;
        $281a441cdcb2cf36$var$OSTYPEVALUES_Z_OS = $281a441cdcb2cf36$var$TMP_OSTYPEVALUES_Z_OS;
        $281a441cdcb2cf36$var$OsTypeValues = /* @__PURE__ */ $281a441cdcb2cf36$var$createConstMap([
            $281a441cdcb2cf36$var$TMP_OSTYPEVALUES_WINDOWS,
            $281a441cdcb2cf36$var$TMP_OSTYPEVALUES_LINUX,
            $281a441cdcb2cf36$var$TMP_OSTYPEVALUES_DARWIN,
            $281a441cdcb2cf36$var$TMP_OSTYPEVALUES_FREEBSD,
            $281a441cdcb2cf36$var$TMP_OSTYPEVALUES_NETBSD,
            $281a441cdcb2cf36$var$TMP_OSTYPEVALUES_OPENBSD,
            $281a441cdcb2cf36$var$TMP_OSTYPEVALUES_DRAGONFLYBSD,
            $281a441cdcb2cf36$var$TMP_OSTYPEVALUES_HPUX,
            $281a441cdcb2cf36$var$TMP_OSTYPEVALUES_AIX,
            $281a441cdcb2cf36$var$TMP_OSTYPEVALUES_SOLARIS,
            $281a441cdcb2cf36$var$TMP_OSTYPEVALUES_Z_OS
        ]);
        $281a441cdcb2cf36$var$TMP_TELEMETRYSDKLANGUAGEVALUES_CPP = "cpp";
        $281a441cdcb2cf36$var$TMP_TELEMETRYSDKLANGUAGEVALUES_DOTNET = "dotnet";
        $281a441cdcb2cf36$var$TMP_TELEMETRYSDKLANGUAGEVALUES_ERLANG = "erlang";
        $281a441cdcb2cf36$var$TMP_TELEMETRYSDKLANGUAGEVALUES_GO = "go";
        $281a441cdcb2cf36$var$TMP_TELEMETRYSDKLANGUAGEVALUES_JAVA = "java";
        $281a441cdcb2cf36$var$TMP_TELEMETRYSDKLANGUAGEVALUES_NODEJS = "nodejs";
        $281a441cdcb2cf36$var$TMP_TELEMETRYSDKLANGUAGEVALUES_PHP = "php";
        $281a441cdcb2cf36$var$TMP_TELEMETRYSDKLANGUAGEVALUES_PYTHON = "python";
        $281a441cdcb2cf36$var$TMP_TELEMETRYSDKLANGUAGEVALUES_RUBY = "ruby";
        $281a441cdcb2cf36$var$TMP_TELEMETRYSDKLANGUAGEVALUES_WEBJS = "webjs";
        $281a441cdcb2cf36$var$TELEMETRYSDKLANGUAGEVALUES_CPP = $281a441cdcb2cf36$var$TMP_TELEMETRYSDKLANGUAGEVALUES_CPP;
        $281a441cdcb2cf36$var$TELEMETRYSDKLANGUAGEVALUES_DOTNET = $281a441cdcb2cf36$var$TMP_TELEMETRYSDKLANGUAGEVALUES_DOTNET;
        $281a441cdcb2cf36$var$TELEMETRYSDKLANGUAGEVALUES_ERLANG = $281a441cdcb2cf36$var$TMP_TELEMETRYSDKLANGUAGEVALUES_ERLANG;
        $281a441cdcb2cf36$var$TELEMETRYSDKLANGUAGEVALUES_GO = $281a441cdcb2cf36$var$TMP_TELEMETRYSDKLANGUAGEVALUES_GO;
        $281a441cdcb2cf36$var$TELEMETRYSDKLANGUAGEVALUES_JAVA = $281a441cdcb2cf36$var$TMP_TELEMETRYSDKLANGUAGEVALUES_JAVA;
        $281a441cdcb2cf36$var$TELEMETRYSDKLANGUAGEVALUES_NODEJS = $281a441cdcb2cf36$var$TMP_TELEMETRYSDKLANGUAGEVALUES_NODEJS;
        $281a441cdcb2cf36$var$TELEMETRYSDKLANGUAGEVALUES_PHP = $281a441cdcb2cf36$var$TMP_TELEMETRYSDKLANGUAGEVALUES_PHP;
        $281a441cdcb2cf36$var$TELEMETRYSDKLANGUAGEVALUES_PYTHON = $281a441cdcb2cf36$var$TMP_TELEMETRYSDKLANGUAGEVALUES_PYTHON;
        $281a441cdcb2cf36$var$TELEMETRYSDKLANGUAGEVALUES_RUBY = $281a441cdcb2cf36$var$TMP_TELEMETRYSDKLANGUAGEVALUES_RUBY;
        $281a441cdcb2cf36$var$TELEMETRYSDKLANGUAGEVALUES_WEBJS = $281a441cdcb2cf36$var$TMP_TELEMETRYSDKLANGUAGEVALUES_WEBJS;
        $281a441cdcb2cf36$var$TelemetrySdkLanguageValues = /* @__PURE__ */ $281a441cdcb2cf36$var$createConstMap([
            $281a441cdcb2cf36$var$TMP_TELEMETRYSDKLANGUAGEVALUES_CPP,
            $281a441cdcb2cf36$var$TMP_TELEMETRYSDKLANGUAGEVALUES_DOTNET,
            $281a441cdcb2cf36$var$TMP_TELEMETRYSDKLANGUAGEVALUES_ERLANG,
            $281a441cdcb2cf36$var$TMP_TELEMETRYSDKLANGUAGEVALUES_GO,
            $281a441cdcb2cf36$var$TMP_TELEMETRYSDKLANGUAGEVALUES_JAVA,
            $281a441cdcb2cf36$var$TMP_TELEMETRYSDKLANGUAGEVALUES_NODEJS,
            $281a441cdcb2cf36$var$TMP_TELEMETRYSDKLANGUAGEVALUES_PHP,
            $281a441cdcb2cf36$var$TMP_TELEMETRYSDKLANGUAGEVALUES_PYTHON,
            $281a441cdcb2cf36$var$TMP_TELEMETRYSDKLANGUAGEVALUES_RUBY,
            $281a441cdcb2cf36$var$TMP_TELEMETRYSDKLANGUAGEVALUES_WEBJS
        ]);
    }
});
// ../node_modules/@opentelemetry/semantic-conventions/build/esm/resource/index.js
var $281a441cdcb2cf36$var$init_resource = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/semantic-conventions/build/esm/resource/index.js" () {
        $281a441cdcb2cf36$var$init_SemanticResourceAttributes();
    }
});
// ../node_modules/@opentelemetry/semantic-conventions/build/esm/stable_attributes.js
var $281a441cdcb2cf36$var$ATTR_ASPNETCORE_DIAGNOSTICS_EXCEPTION_RESULT, $281a441cdcb2cf36$var$ASPNETCORE_DIAGNOSTICS_EXCEPTION_RESULT_VALUE_ABORTED, $281a441cdcb2cf36$var$ASPNETCORE_DIAGNOSTICS_EXCEPTION_RESULT_VALUE_HANDLED, $281a441cdcb2cf36$var$ASPNETCORE_DIAGNOSTICS_EXCEPTION_RESULT_VALUE_SKIPPED, $281a441cdcb2cf36$var$ASPNETCORE_DIAGNOSTICS_EXCEPTION_RESULT_VALUE_UNHANDLED, $281a441cdcb2cf36$var$ATTR_ASPNETCORE_DIAGNOSTICS_HANDLER_TYPE, $281a441cdcb2cf36$var$ATTR_ASPNETCORE_RATE_LIMITING_POLICY, $281a441cdcb2cf36$var$ATTR_ASPNETCORE_RATE_LIMITING_RESULT, $281a441cdcb2cf36$var$ASPNETCORE_RATE_LIMITING_RESULT_VALUE_ACQUIRED, $281a441cdcb2cf36$var$ASPNETCORE_RATE_LIMITING_RESULT_VALUE_ENDPOINT_LIMITER, $281a441cdcb2cf36$var$ASPNETCORE_RATE_LIMITING_RESULT_VALUE_GLOBAL_LIMITER, $281a441cdcb2cf36$var$ASPNETCORE_RATE_LIMITING_RESULT_VALUE_REQUEST_CANCELED, $281a441cdcb2cf36$var$ATTR_ASPNETCORE_REQUEST_IS_UNHANDLED, $281a441cdcb2cf36$var$ATTR_ASPNETCORE_ROUTING_IS_FALLBACK, $281a441cdcb2cf36$var$ATTR_ASPNETCORE_ROUTING_MATCH_STATUS, $281a441cdcb2cf36$var$ASPNETCORE_ROUTING_MATCH_STATUS_VALUE_FAILURE, $281a441cdcb2cf36$var$ASPNETCORE_ROUTING_MATCH_STATUS_VALUE_SUCCESS, $281a441cdcb2cf36$var$ATTR_ASPNETCORE_USER_IS_AUTHENTICATED, $281a441cdcb2cf36$var$ATTR_CLIENT_ADDRESS, $281a441cdcb2cf36$var$ATTR_CLIENT_PORT, $281a441cdcb2cf36$var$ATTR_CODE_COLUMN_NUMBER, $281a441cdcb2cf36$var$ATTR_CODE_FILE_PATH, $281a441cdcb2cf36$var$ATTR_CODE_FUNCTION_NAME, $281a441cdcb2cf36$var$ATTR_CODE_LINE_NUMBER, $281a441cdcb2cf36$var$ATTR_CODE_STACKTRACE, $281a441cdcb2cf36$var$ATTR_DB_COLLECTION_NAME, $281a441cdcb2cf36$var$ATTR_DB_NAMESPACE, $281a441cdcb2cf36$var$ATTR_DB_OPERATION_BATCH_SIZE, $281a441cdcb2cf36$var$ATTR_DB_OPERATION_NAME, $281a441cdcb2cf36$var$ATTR_DB_QUERY_SUMMARY, $281a441cdcb2cf36$var$ATTR_DB_QUERY_TEXT, $281a441cdcb2cf36$var$ATTR_DB_RESPONSE_STATUS_CODE, $281a441cdcb2cf36$var$ATTR_DB_STORED_PROCEDURE_NAME, $281a441cdcb2cf36$var$ATTR_DB_SYSTEM_NAME, $281a441cdcb2cf36$var$DB_SYSTEM_NAME_VALUE_MARIADB, $281a441cdcb2cf36$var$DB_SYSTEM_NAME_VALUE_MICROSOFT_SQL_SERVER, $281a441cdcb2cf36$var$DB_SYSTEM_NAME_VALUE_MYSQL, $281a441cdcb2cf36$var$DB_SYSTEM_NAME_VALUE_POSTGRESQL, $281a441cdcb2cf36$var$ATTR_DOTNET_GC_HEAP_GENERATION, $281a441cdcb2cf36$var$DOTNET_GC_HEAP_GENERATION_VALUE_GEN0, $281a441cdcb2cf36$var$DOTNET_GC_HEAP_GENERATION_VALUE_GEN1, $281a441cdcb2cf36$var$DOTNET_GC_HEAP_GENERATION_VALUE_GEN2, $281a441cdcb2cf36$var$DOTNET_GC_HEAP_GENERATION_VALUE_LOH, $281a441cdcb2cf36$var$DOTNET_GC_HEAP_GENERATION_VALUE_POH, $281a441cdcb2cf36$var$ATTR_ERROR_TYPE, $281a441cdcb2cf36$var$ERROR_TYPE_VALUE_OTHER, $281a441cdcb2cf36$var$ATTR_EXCEPTION_ESCAPED, $281a441cdcb2cf36$var$ATTR_EXCEPTION_MESSAGE, $281a441cdcb2cf36$var$ATTR_EXCEPTION_STACKTRACE, $281a441cdcb2cf36$var$ATTR_EXCEPTION_TYPE, $281a441cdcb2cf36$var$ATTR_HTTP_REQUEST_HEADER, $281a441cdcb2cf36$var$ATTR_HTTP_REQUEST_METHOD, $281a441cdcb2cf36$var$HTTP_REQUEST_METHOD_VALUE_OTHER, $281a441cdcb2cf36$var$HTTP_REQUEST_METHOD_VALUE_CONNECT, $281a441cdcb2cf36$var$HTTP_REQUEST_METHOD_VALUE_DELETE, $281a441cdcb2cf36$var$HTTP_REQUEST_METHOD_VALUE_GET, $281a441cdcb2cf36$var$HTTP_REQUEST_METHOD_VALUE_HEAD, $281a441cdcb2cf36$var$HTTP_REQUEST_METHOD_VALUE_OPTIONS, $281a441cdcb2cf36$var$HTTP_REQUEST_METHOD_VALUE_PATCH, $281a441cdcb2cf36$var$HTTP_REQUEST_METHOD_VALUE_POST, $281a441cdcb2cf36$var$HTTP_REQUEST_METHOD_VALUE_PUT, $281a441cdcb2cf36$var$HTTP_REQUEST_METHOD_VALUE_TRACE, $281a441cdcb2cf36$var$ATTR_HTTP_REQUEST_METHOD_ORIGINAL, $281a441cdcb2cf36$var$ATTR_HTTP_REQUEST_RESEND_COUNT, $281a441cdcb2cf36$var$ATTR_HTTP_RESPONSE_HEADER, $281a441cdcb2cf36$var$ATTR_HTTP_RESPONSE_STATUS_CODE, $281a441cdcb2cf36$var$ATTR_HTTP_ROUTE, $281a441cdcb2cf36$var$ATTR_JVM_GC_ACTION, $281a441cdcb2cf36$var$ATTR_JVM_GC_NAME, $281a441cdcb2cf36$var$ATTR_JVM_MEMORY_POOL_NAME, $281a441cdcb2cf36$var$ATTR_JVM_MEMORY_TYPE, $281a441cdcb2cf36$var$JVM_MEMORY_TYPE_VALUE_HEAP, $281a441cdcb2cf36$var$JVM_MEMORY_TYPE_VALUE_NON_HEAP, $281a441cdcb2cf36$var$ATTR_JVM_THREAD_DAEMON, $281a441cdcb2cf36$var$ATTR_JVM_THREAD_STATE, $281a441cdcb2cf36$var$JVM_THREAD_STATE_VALUE_BLOCKED, $281a441cdcb2cf36$var$JVM_THREAD_STATE_VALUE_NEW, $281a441cdcb2cf36$var$JVM_THREAD_STATE_VALUE_RUNNABLE, $281a441cdcb2cf36$var$JVM_THREAD_STATE_VALUE_TERMINATED, $281a441cdcb2cf36$var$JVM_THREAD_STATE_VALUE_TIMED_WAITING, $281a441cdcb2cf36$var$JVM_THREAD_STATE_VALUE_WAITING, $281a441cdcb2cf36$var$ATTR_NETWORK_LOCAL_ADDRESS, $281a441cdcb2cf36$var$ATTR_NETWORK_LOCAL_PORT, $281a441cdcb2cf36$var$ATTR_NETWORK_PEER_ADDRESS, $281a441cdcb2cf36$var$ATTR_NETWORK_PEER_PORT, $281a441cdcb2cf36$var$ATTR_NETWORK_PROTOCOL_NAME, $281a441cdcb2cf36$var$ATTR_NETWORK_PROTOCOL_VERSION, $281a441cdcb2cf36$var$ATTR_NETWORK_TRANSPORT, $281a441cdcb2cf36$var$NETWORK_TRANSPORT_VALUE_PIPE, $281a441cdcb2cf36$var$NETWORK_TRANSPORT_VALUE_QUIC, $281a441cdcb2cf36$var$NETWORK_TRANSPORT_VALUE_TCP, $281a441cdcb2cf36$var$NETWORK_TRANSPORT_VALUE_UDP, $281a441cdcb2cf36$var$NETWORK_TRANSPORT_VALUE_UNIX, $281a441cdcb2cf36$var$ATTR_NETWORK_TYPE, $281a441cdcb2cf36$var$NETWORK_TYPE_VALUE_IPV4, $281a441cdcb2cf36$var$NETWORK_TYPE_VALUE_IPV6, $281a441cdcb2cf36$var$ATTR_OTEL_SCOPE_NAME, $281a441cdcb2cf36$var$ATTR_OTEL_SCOPE_VERSION, $281a441cdcb2cf36$var$ATTR_OTEL_STATUS_CODE, $281a441cdcb2cf36$var$OTEL_STATUS_CODE_VALUE_ERROR, $281a441cdcb2cf36$var$OTEL_STATUS_CODE_VALUE_OK, $281a441cdcb2cf36$var$ATTR_OTEL_STATUS_DESCRIPTION, $281a441cdcb2cf36$var$ATTR_SERVER_ADDRESS, $281a441cdcb2cf36$var$ATTR_SERVER_PORT, $281a441cdcb2cf36$var$ATTR_SERVICE_INSTANCE_ID, $281a441cdcb2cf36$var$ATTR_SERVICE_NAME, $281a441cdcb2cf36$var$ATTR_SERVICE_NAMESPACE, $281a441cdcb2cf36$var$ATTR_SERVICE_VERSION, $281a441cdcb2cf36$var$ATTR_SIGNALR_CONNECTION_STATUS, $281a441cdcb2cf36$var$SIGNALR_CONNECTION_STATUS_VALUE_APP_SHUTDOWN, $281a441cdcb2cf36$var$SIGNALR_CONNECTION_STATUS_VALUE_NORMAL_CLOSURE, $281a441cdcb2cf36$var$SIGNALR_CONNECTION_STATUS_VALUE_TIMEOUT, $281a441cdcb2cf36$var$ATTR_SIGNALR_TRANSPORT, $281a441cdcb2cf36$var$SIGNALR_TRANSPORT_VALUE_LONG_POLLING, $281a441cdcb2cf36$var$SIGNALR_TRANSPORT_VALUE_SERVER_SENT_EVENTS, $281a441cdcb2cf36$var$SIGNALR_TRANSPORT_VALUE_WEB_SOCKETS, $281a441cdcb2cf36$var$ATTR_TELEMETRY_SDK_LANGUAGE, $281a441cdcb2cf36$var$TELEMETRY_SDK_LANGUAGE_VALUE_CPP, $281a441cdcb2cf36$var$TELEMETRY_SDK_LANGUAGE_VALUE_DOTNET, $281a441cdcb2cf36$var$TELEMETRY_SDK_LANGUAGE_VALUE_ERLANG, $281a441cdcb2cf36$var$TELEMETRY_SDK_LANGUAGE_VALUE_GO, $281a441cdcb2cf36$var$TELEMETRY_SDK_LANGUAGE_VALUE_JAVA, $281a441cdcb2cf36$var$TELEMETRY_SDK_LANGUAGE_VALUE_NODEJS, $281a441cdcb2cf36$var$TELEMETRY_SDK_LANGUAGE_VALUE_PHP, $281a441cdcb2cf36$var$TELEMETRY_SDK_LANGUAGE_VALUE_PYTHON, $281a441cdcb2cf36$var$TELEMETRY_SDK_LANGUAGE_VALUE_RUBY, $281a441cdcb2cf36$var$TELEMETRY_SDK_LANGUAGE_VALUE_RUST, $281a441cdcb2cf36$var$TELEMETRY_SDK_LANGUAGE_VALUE_SWIFT, $281a441cdcb2cf36$var$TELEMETRY_SDK_LANGUAGE_VALUE_WEBJS, $281a441cdcb2cf36$var$ATTR_TELEMETRY_SDK_NAME, $281a441cdcb2cf36$var$ATTR_TELEMETRY_SDK_VERSION, $281a441cdcb2cf36$var$ATTR_URL_FRAGMENT, $281a441cdcb2cf36$var$ATTR_URL_FULL, $281a441cdcb2cf36$var$ATTR_URL_PATH, $281a441cdcb2cf36$var$ATTR_URL_QUERY, $281a441cdcb2cf36$var$ATTR_URL_SCHEME, $281a441cdcb2cf36$var$ATTR_USER_AGENT_ORIGINAL;
var $281a441cdcb2cf36$var$init_stable_attributes = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/semantic-conventions/build/esm/stable_attributes.js" () {
        $281a441cdcb2cf36$var$ATTR_ASPNETCORE_DIAGNOSTICS_EXCEPTION_RESULT = "aspnetcore.diagnostics.exception.result";
        $281a441cdcb2cf36$var$ASPNETCORE_DIAGNOSTICS_EXCEPTION_RESULT_VALUE_ABORTED = "aborted";
        $281a441cdcb2cf36$var$ASPNETCORE_DIAGNOSTICS_EXCEPTION_RESULT_VALUE_HANDLED = "handled";
        $281a441cdcb2cf36$var$ASPNETCORE_DIAGNOSTICS_EXCEPTION_RESULT_VALUE_SKIPPED = "skipped";
        $281a441cdcb2cf36$var$ASPNETCORE_DIAGNOSTICS_EXCEPTION_RESULT_VALUE_UNHANDLED = "unhandled";
        $281a441cdcb2cf36$var$ATTR_ASPNETCORE_DIAGNOSTICS_HANDLER_TYPE = "aspnetcore.diagnostics.handler.type";
        $281a441cdcb2cf36$var$ATTR_ASPNETCORE_RATE_LIMITING_POLICY = "aspnetcore.rate_limiting.policy";
        $281a441cdcb2cf36$var$ATTR_ASPNETCORE_RATE_LIMITING_RESULT = "aspnetcore.rate_limiting.result";
        $281a441cdcb2cf36$var$ASPNETCORE_RATE_LIMITING_RESULT_VALUE_ACQUIRED = "acquired";
        $281a441cdcb2cf36$var$ASPNETCORE_RATE_LIMITING_RESULT_VALUE_ENDPOINT_LIMITER = "endpoint_limiter";
        $281a441cdcb2cf36$var$ASPNETCORE_RATE_LIMITING_RESULT_VALUE_GLOBAL_LIMITER = "global_limiter";
        $281a441cdcb2cf36$var$ASPNETCORE_RATE_LIMITING_RESULT_VALUE_REQUEST_CANCELED = "request_canceled";
        $281a441cdcb2cf36$var$ATTR_ASPNETCORE_REQUEST_IS_UNHANDLED = "aspnetcore.request.is_unhandled";
        $281a441cdcb2cf36$var$ATTR_ASPNETCORE_ROUTING_IS_FALLBACK = "aspnetcore.routing.is_fallback";
        $281a441cdcb2cf36$var$ATTR_ASPNETCORE_ROUTING_MATCH_STATUS = "aspnetcore.routing.match_status";
        $281a441cdcb2cf36$var$ASPNETCORE_ROUTING_MATCH_STATUS_VALUE_FAILURE = "failure";
        $281a441cdcb2cf36$var$ASPNETCORE_ROUTING_MATCH_STATUS_VALUE_SUCCESS = "success";
        $281a441cdcb2cf36$var$ATTR_ASPNETCORE_USER_IS_AUTHENTICATED = "aspnetcore.user.is_authenticated";
        $281a441cdcb2cf36$var$ATTR_CLIENT_ADDRESS = "client.address";
        $281a441cdcb2cf36$var$ATTR_CLIENT_PORT = "client.port";
        $281a441cdcb2cf36$var$ATTR_CODE_COLUMN_NUMBER = "code.column.number";
        $281a441cdcb2cf36$var$ATTR_CODE_FILE_PATH = "code.file.path";
        $281a441cdcb2cf36$var$ATTR_CODE_FUNCTION_NAME = "code.function.name";
        $281a441cdcb2cf36$var$ATTR_CODE_LINE_NUMBER = "code.line.number";
        $281a441cdcb2cf36$var$ATTR_CODE_STACKTRACE = "code.stacktrace";
        $281a441cdcb2cf36$var$ATTR_DB_COLLECTION_NAME = "db.collection.name";
        $281a441cdcb2cf36$var$ATTR_DB_NAMESPACE = "db.namespace";
        $281a441cdcb2cf36$var$ATTR_DB_OPERATION_BATCH_SIZE = "db.operation.batch.size";
        $281a441cdcb2cf36$var$ATTR_DB_OPERATION_NAME = "db.operation.name";
        $281a441cdcb2cf36$var$ATTR_DB_QUERY_SUMMARY = "db.query.summary";
        $281a441cdcb2cf36$var$ATTR_DB_QUERY_TEXT = "db.query.text";
        $281a441cdcb2cf36$var$ATTR_DB_RESPONSE_STATUS_CODE = "db.response.status_code";
        $281a441cdcb2cf36$var$ATTR_DB_STORED_PROCEDURE_NAME = "db.stored_procedure.name";
        $281a441cdcb2cf36$var$ATTR_DB_SYSTEM_NAME = "db.system.name";
        $281a441cdcb2cf36$var$DB_SYSTEM_NAME_VALUE_MARIADB = "mariadb";
        $281a441cdcb2cf36$var$DB_SYSTEM_NAME_VALUE_MICROSOFT_SQL_SERVER = "microsoft.sql_server";
        $281a441cdcb2cf36$var$DB_SYSTEM_NAME_VALUE_MYSQL = "mysql";
        $281a441cdcb2cf36$var$DB_SYSTEM_NAME_VALUE_POSTGRESQL = "postgresql";
        $281a441cdcb2cf36$var$ATTR_DOTNET_GC_HEAP_GENERATION = "dotnet.gc.heap.generation";
        $281a441cdcb2cf36$var$DOTNET_GC_HEAP_GENERATION_VALUE_GEN0 = "gen0";
        $281a441cdcb2cf36$var$DOTNET_GC_HEAP_GENERATION_VALUE_GEN1 = "gen1";
        $281a441cdcb2cf36$var$DOTNET_GC_HEAP_GENERATION_VALUE_GEN2 = "gen2";
        $281a441cdcb2cf36$var$DOTNET_GC_HEAP_GENERATION_VALUE_LOH = "loh";
        $281a441cdcb2cf36$var$DOTNET_GC_HEAP_GENERATION_VALUE_POH = "poh";
        $281a441cdcb2cf36$var$ATTR_ERROR_TYPE = "error.type";
        $281a441cdcb2cf36$var$ERROR_TYPE_VALUE_OTHER = "_OTHER";
        $281a441cdcb2cf36$var$ATTR_EXCEPTION_ESCAPED = "exception.escaped";
        $281a441cdcb2cf36$var$ATTR_EXCEPTION_MESSAGE = "exception.message";
        $281a441cdcb2cf36$var$ATTR_EXCEPTION_STACKTRACE = "exception.stacktrace";
        $281a441cdcb2cf36$var$ATTR_EXCEPTION_TYPE = "exception.type";
        $281a441cdcb2cf36$var$ATTR_HTTP_REQUEST_HEADER = (key)=>`http.request.header.${key}`;
        $281a441cdcb2cf36$var$ATTR_HTTP_REQUEST_METHOD = "http.request.method";
        $281a441cdcb2cf36$var$HTTP_REQUEST_METHOD_VALUE_OTHER = "_OTHER";
        $281a441cdcb2cf36$var$HTTP_REQUEST_METHOD_VALUE_CONNECT = "CONNECT";
        $281a441cdcb2cf36$var$HTTP_REQUEST_METHOD_VALUE_DELETE = "DELETE";
        $281a441cdcb2cf36$var$HTTP_REQUEST_METHOD_VALUE_GET = "GET";
        $281a441cdcb2cf36$var$HTTP_REQUEST_METHOD_VALUE_HEAD = "HEAD";
        $281a441cdcb2cf36$var$HTTP_REQUEST_METHOD_VALUE_OPTIONS = "OPTIONS";
        $281a441cdcb2cf36$var$HTTP_REQUEST_METHOD_VALUE_PATCH = "PATCH";
        $281a441cdcb2cf36$var$HTTP_REQUEST_METHOD_VALUE_POST = "POST";
        $281a441cdcb2cf36$var$HTTP_REQUEST_METHOD_VALUE_PUT = "PUT";
        $281a441cdcb2cf36$var$HTTP_REQUEST_METHOD_VALUE_TRACE = "TRACE";
        $281a441cdcb2cf36$var$ATTR_HTTP_REQUEST_METHOD_ORIGINAL = "http.request.method_original";
        $281a441cdcb2cf36$var$ATTR_HTTP_REQUEST_RESEND_COUNT = "http.request.resend_count";
        $281a441cdcb2cf36$var$ATTR_HTTP_RESPONSE_HEADER = (key)=>`http.response.header.${key}`;
        $281a441cdcb2cf36$var$ATTR_HTTP_RESPONSE_STATUS_CODE = "http.response.status_code";
        $281a441cdcb2cf36$var$ATTR_HTTP_ROUTE = "http.route";
        $281a441cdcb2cf36$var$ATTR_JVM_GC_ACTION = "jvm.gc.action";
        $281a441cdcb2cf36$var$ATTR_JVM_GC_NAME = "jvm.gc.name";
        $281a441cdcb2cf36$var$ATTR_JVM_MEMORY_POOL_NAME = "jvm.memory.pool.name";
        $281a441cdcb2cf36$var$ATTR_JVM_MEMORY_TYPE = "jvm.memory.type";
        $281a441cdcb2cf36$var$JVM_MEMORY_TYPE_VALUE_HEAP = "heap";
        $281a441cdcb2cf36$var$JVM_MEMORY_TYPE_VALUE_NON_HEAP = "non_heap";
        $281a441cdcb2cf36$var$ATTR_JVM_THREAD_DAEMON = "jvm.thread.daemon";
        $281a441cdcb2cf36$var$ATTR_JVM_THREAD_STATE = "jvm.thread.state";
        $281a441cdcb2cf36$var$JVM_THREAD_STATE_VALUE_BLOCKED = "blocked";
        $281a441cdcb2cf36$var$JVM_THREAD_STATE_VALUE_NEW = "new";
        $281a441cdcb2cf36$var$JVM_THREAD_STATE_VALUE_RUNNABLE = "runnable";
        $281a441cdcb2cf36$var$JVM_THREAD_STATE_VALUE_TERMINATED = "terminated";
        $281a441cdcb2cf36$var$JVM_THREAD_STATE_VALUE_TIMED_WAITING = "timed_waiting";
        $281a441cdcb2cf36$var$JVM_THREAD_STATE_VALUE_WAITING = "waiting";
        $281a441cdcb2cf36$var$ATTR_NETWORK_LOCAL_ADDRESS = "network.local.address";
        $281a441cdcb2cf36$var$ATTR_NETWORK_LOCAL_PORT = "network.local.port";
        $281a441cdcb2cf36$var$ATTR_NETWORK_PEER_ADDRESS = "network.peer.address";
        $281a441cdcb2cf36$var$ATTR_NETWORK_PEER_PORT = "network.peer.port";
        $281a441cdcb2cf36$var$ATTR_NETWORK_PROTOCOL_NAME = "network.protocol.name";
        $281a441cdcb2cf36$var$ATTR_NETWORK_PROTOCOL_VERSION = "network.protocol.version";
        $281a441cdcb2cf36$var$ATTR_NETWORK_TRANSPORT = "network.transport";
        $281a441cdcb2cf36$var$NETWORK_TRANSPORT_VALUE_PIPE = "pipe";
        $281a441cdcb2cf36$var$NETWORK_TRANSPORT_VALUE_QUIC = "quic";
        $281a441cdcb2cf36$var$NETWORK_TRANSPORT_VALUE_TCP = "tcp";
        $281a441cdcb2cf36$var$NETWORK_TRANSPORT_VALUE_UDP = "udp";
        $281a441cdcb2cf36$var$NETWORK_TRANSPORT_VALUE_UNIX = "unix";
        $281a441cdcb2cf36$var$ATTR_NETWORK_TYPE = "network.type";
        $281a441cdcb2cf36$var$NETWORK_TYPE_VALUE_IPV4 = "ipv4";
        $281a441cdcb2cf36$var$NETWORK_TYPE_VALUE_IPV6 = "ipv6";
        $281a441cdcb2cf36$var$ATTR_OTEL_SCOPE_NAME = "otel.scope.name";
        $281a441cdcb2cf36$var$ATTR_OTEL_SCOPE_VERSION = "otel.scope.version";
        $281a441cdcb2cf36$var$ATTR_OTEL_STATUS_CODE = "otel.status_code";
        $281a441cdcb2cf36$var$OTEL_STATUS_CODE_VALUE_ERROR = "ERROR";
        $281a441cdcb2cf36$var$OTEL_STATUS_CODE_VALUE_OK = "OK";
        $281a441cdcb2cf36$var$ATTR_OTEL_STATUS_DESCRIPTION = "otel.status_description";
        $281a441cdcb2cf36$var$ATTR_SERVER_ADDRESS = "server.address";
        $281a441cdcb2cf36$var$ATTR_SERVER_PORT = "server.port";
        $281a441cdcb2cf36$var$ATTR_SERVICE_INSTANCE_ID = "service.instance.id";
        $281a441cdcb2cf36$var$ATTR_SERVICE_NAME = "service.name";
        $281a441cdcb2cf36$var$ATTR_SERVICE_NAMESPACE = "service.namespace";
        $281a441cdcb2cf36$var$ATTR_SERVICE_VERSION = "service.version";
        $281a441cdcb2cf36$var$ATTR_SIGNALR_CONNECTION_STATUS = "signalr.connection.status";
        $281a441cdcb2cf36$var$SIGNALR_CONNECTION_STATUS_VALUE_APP_SHUTDOWN = "app_shutdown";
        $281a441cdcb2cf36$var$SIGNALR_CONNECTION_STATUS_VALUE_NORMAL_CLOSURE = "normal_closure";
        $281a441cdcb2cf36$var$SIGNALR_CONNECTION_STATUS_VALUE_TIMEOUT = "timeout";
        $281a441cdcb2cf36$var$ATTR_SIGNALR_TRANSPORT = "signalr.transport";
        $281a441cdcb2cf36$var$SIGNALR_TRANSPORT_VALUE_LONG_POLLING = "long_polling";
        $281a441cdcb2cf36$var$SIGNALR_TRANSPORT_VALUE_SERVER_SENT_EVENTS = "server_sent_events";
        $281a441cdcb2cf36$var$SIGNALR_TRANSPORT_VALUE_WEB_SOCKETS = "web_sockets";
        $281a441cdcb2cf36$var$ATTR_TELEMETRY_SDK_LANGUAGE = "telemetry.sdk.language";
        $281a441cdcb2cf36$var$TELEMETRY_SDK_LANGUAGE_VALUE_CPP = "cpp";
        $281a441cdcb2cf36$var$TELEMETRY_SDK_LANGUAGE_VALUE_DOTNET = "dotnet";
        $281a441cdcb2cf36$var$TELEMETRY_SDK_LANGUAGE_VALUE_ERLANG = "erlang";
        $281a441cdcb2cf36$var$TELEMETRY_SDK_LANGUAGE_VALUE_GO = "go";
        $281a441cdcb2cf36$var$TELEMETRY_SDK_LANGUAGE_VALUE_JAVA = "java";
        $281a441cdcb2cf36$var$TELEMETRY_SDK_LANGUAGE_VALUE_NODEJS = "nodejs";
        $281a441cdcb2cf36$var$TELEMETRY_SDK_LANGUAGE_VALUE_PHP = "php";
        $281a441cdcb2cf36$var$TELEMETRY_SDK_LANGUAGE_VALUE_PYTHON = "python";
        $281a441cdcb2cf36$var$TELEMETRY_SDK_LANGUAGE_VALUE_RUBY = "ruby";
        $281a441cdcb2cf36$var$TELEMETRY_SDK_LANGUAGE_VALUE_RUST = "rust";
        $281a441cdcb2cf36$var$TELEMETRY_SDK_LANGUAGE_VALUE_SWIFT = "swift";
        $281a441cdcb2cf36$var$TELEMETRY_SDK_LANGUAGE_VALUE_WEBJS = "webjs";
        $281a441cdcb2cf36$var$ATTR_TELEMETRY_SDK_NAME = "telemetry.sdk.name";
        $281a441cdcb2cf36$var$ATTR_TELEMETRY_SDK_VERSION = "telemetry.sdk.version";
        $281a441cdcb2cf36$var$ATTR_URL_FRAGMENT = "url.fragment";
        $281a441cdcb2cf36$var$ATTR_URL_FULL = "url.full";
        $281a441cdcb2cf36$var$ATTR_URL_PATH = "url.path";
        $281a441cdcb2cf36$var$ATTR_URL_QUERY = "url.query";
        $281a441cdcb2cf36$var$ATTR_URL_SCHEME = "url.scheme";
        $281a441cdcb2cf36$var$ATTR_USER_AGENT_ORIGINAL = "user_agent.original";
    }
});
// ../node_modules/@opentelemetry/semantic-conventions/build/esm/stable_metrics.js
var $281a441cdcb2cf36$var$METRIC_ASPNETCORE_DIAGNOSTICS_EXCEPTIONS, $281a441cdcb2cf36$var$METRIC_ASPNETCORE_RATE_LIMITING_ACTIVE_REQUEST_LEASES, $281a441cdcb2cf36$var$METRIC_ASPNETCORE_RATE_LIMITING_QUEUED_REQUESTS, $281a441cdcb2cf36$var$METRIC_ASPNETCORE_RATE_LIMITING_REQUEST_TIME_IN_QUEUE, $281a441cdcb2cf36$var$METRIC_ASPNETCORE_RATE_LIMITING_REQUEST_LEASE_DURATION, $281a441cdcb2cf36$var$METRIC_ASPNETCORE_RATE_LIMITING_REQUESTS, $281a441cdcb2cf36$var$METRIC_ASPNETCORE_ROUTING_MATCH_ATTEMPTS, $281a441cdcb2cf36$var$METRIC_DB_CLIENT_OPERATION_DURATION, $281a441cdcb2cf36$var$METRIC_DOTNET_ASSEMBLY_COUNT, $281a441cdcb2cf36$var$METRIC_DOTNET_EXCEPTIONS, $281a441cdcb2cf36$var$METRIC_DOTNET_GC_COLLECTIONS, $281a441cdcb2cf36$var$METRIC_DOTNET_GC_HEAP_TOTAL_ALLOCATED, $281a441cdcb2cf36$var$METRIC_DOTNET_GC_LAST_COLLECTION_HEAP_FRAGMENTATION_SIZE, $281a441cdcb2cf36$var$METRIC_DOTNET_GC_LAST_COLLECTION_HEAP_SIZE, $281a441cdcb2cf36$var$METRIC_DOTNET_GC_LAST_COLLECTION_MEMORY_COMMITTED_SIZE, $281a441cdcb2cf36$var$METRIC_DOTNET_GC_PAUSE_TIME, $281a441cdcb2cf36$var$METRIC_DOTNET_JIT_COMPILATION_TIME, $281a441cdcb2cf36$var$METRIC_DOTNET_JIT_COMPILED_IL_SIZE, $281a441cdcb2cf36$var$METRIC_DOTNET_JIT_COMPILED_METHODS, $281a441cdcb2cf36$var$METRIC_DOTNET_MONITOR_LOCK_CONTENTIONS, $281a441cdcb2cf36$var$METRIC_DOTNET_PROCESS_CPU_COUNT, $281a441cdcb2cf36$var$METRIC_DOTNET_PROCESS_CPU_TIME, $281a441cdcb2cf36$var$METRIC_DOTNET_PROCESS_MEMORY_WORKING_SET, $281a441cdcb2cf36$var$METRIC_DOTNET_THREAD_POOL_QUEUE_LENGTH, $281a441cdcb2cf36$var$METRIC_DOTNET_THREAD_POOL_THREAD_COUNT, $281a441cdcb2cf36$var$METRIC_DOTNET_THREAD_POOL_WORK_ITEM_COUNT, $281a441cdcb2cf36$var$METRIC_DOTNET_TIMER_COUNT, $281a441cdcb2cf36$var$METRIC_HTTP_CLIENT_REQUEST_DURATION, $281a441cdcb2cf36$var$METRIC_HTTP_SERVER_REQUEST_DURATION, $281a441cdcb2cf36$var$METRIC_JVM_CLASS_COUNT, $281a441cdcb2cf36$var$METRIC_JVM_CLASS_LOADED, $281a441cdcb2cf36$var$METRIC_JVM_CLASS_UNLOADED, $281a441cdcb2cf36$var$METRIC_JVM_CPU_COUNT, $281a441cdcb2cf36$var$METRIC_JVM_CPU_RECENT_UTILIZATION, $281a441cdcb2cf36$var$METRIC_JVM_CPU_TIME, $281a441cdcb2cf36$var$METRIC_JVM_GC_DURATION, $281a441cdcb2cf36$var$METRIC_JVM_MEMORY_COMMITTED, $281a441cdcb2cf36$var$METRIC_JVM_MEMORY_LIMIT, $281a441cdcb2cf36$var$METRIC_JVM_MEMORY_USED, $281a441cdcb2cf36$var$METRIC_JVM_MEMORY_USED_AFTER_LAST_GC, $281a441cdcb2cf36$var$METRIC_JVM_THREAD_COUNT, $281a441cdcb2cf36$var$METRIC_KESTREL_ACTIVE_CONNECTIONS, $281a441cdcb2cf36$var$METRIC_KESTREL_ACTIVE_TLS_HANDSHAKES, $281a441cdcb2cf36$var$METRIC_KESTREL_CONNECTION_DURATION, $281a441cdcb2cf36$var$METRIC_KESTREL_QUEUED_CONNECTIONS, $281a441cdcb2cf36$var$METRIC_KESTREL_QUEUED_REQUESTS, $281a441cdcb2cf36$var$METRIC_KESTREL_REJECTED_CONNECTIONS, $281a441cdcb2cf36$var$METRIC_KESTREL_TLS_HANDSHAKE_DURATION, $281a441cdcb2cf36$var$METRIC_KESTREL_UPGRADED_CONNECTIONS, $281a441cdcb2cf36$var$METRIC_SIGNALR_SERVER_ACTIVE_CONNECTIONS, $281a441cdcb2cf36$var$METRIC_SIGNALR_SERVER_CONNECTION_DURATION;
var $281a441cdcb2cf36$var$init_stable_metrics = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/semantic-conventions/build/esm/stable_metrics.js" () {
        $281a441cdcb2cf36$var$METRIC_ASPNETCORE_DIAGNOSTICS_EXCEPTIONS = "aspnetcore.diagnostics.exceptions";
        $281a441cdcb2cf36$var$METRIC_ASPNETCORE_RATE_LIMITING_ACTIVE_REQUEST_LEASES = "aspnetcore.rate_limiting.active_request_leases";
        $281a441cdcb2cf36$var$METRIC_ASPNETCORE_RATE_LIMITING_QUEUED_REQUESTS = "aspnetcore.rate_limiting.queued_requests";
        $281a441cdcb2cf36$var$METRIC_ASPNETCORE_RATE_LIMITING_REQUEST_TIME_IN_QUEUE = "aspnetcore.rate_limiting.request.time_in_queue";
        $281a441cdcb2cf36$var$METRIC_ASPNETCORE_RATE_LIMITING_REQUEST_LEASE_DURATION = "aspnetcore.rate_limiting.request_lease.duration";
        $281a441cdcb2cf36$var$METRIC_ASPNETCORE_RATE_LIMITING_REQUESTS = "aspnetcore.rate_limiting.requests";
        $281a441cdcb2cf36$var$METRIC_ASPNETCORE_ROUTING_MATCH_ATTEMPTS = "aspnetcore.routing.match_attempts";
        $281a441cdcb2cf36$var$METRIC_DB_CLIENT_OPERATION_DURATION = "db.client.operation.duration";
        $281a441cdcb2cf36$var$METRIC_DOTNET_ASSEMBLY_COUNT = "dotnet.assembly.count";
        $281a441cdcb2cf36$var$METRIC_DOTNET_EXCEPTIONS = "dotnet.exceptions";
        $281a441cdcb2cf36$var$METRIC_DOTNET_GC_COLLECTIONS = "dotnet.gc.collections";
        $281a441cdcb2cf36$var$METRIC_DOTNET_GC_HEAP_TOTAL_ALLOCATED = "dotnet.gc.heap.total_allocated";
        $281a441cdcb2cf36$var$METRIC_DOTNET_GC_LAST_COLLECTION_HEAP_FRAGMENTATION_SIZE = "dotnet.gc.last_collection.heap.fragmentation.size";
        $281a441cdcb2cf36$var$METRIC_DOTNET_GC_LAST_COLLECTION_HEAP_SIZE = "dotnet.gc.last_collection.heap.size";
        $281a441cdcb2cf36$var$METRIC_DOTNET_GC_LAST_COLLECTION_MEMORY_COMMITTED_SIZE = "dotnet.gc.last_collection.memory.committed_size";
        $281a441cdcb2cf36$var$METRIC_DOTNET_GC_PAUSE_TIME = "dotnet.gc.pause.time";
        $281a441cdcb2cf36$var$METRIC_DOTNET_JIT_COMPILATION_TIME = "dotnet.jit.compilation.time";
        $281a441cdcb2cf36$var$METRIC_DOTNET_JIT_COMPILED_IL_SIZE = "dotnet.jit.compiled_il.size";
        $281a441cdcb2cf36$var$METRIC_DOTNET_JIT_COMPILED_METHODS = "dotnet.jit.compiled_methods";
        $281a441cdcb2cf36$var$METRIC_DOTNET_MONITOR_LOCK_CONTENTIONS = "dotnet.monitor.lock_contentions";
        $281a441cdcb2cf36$var$METRIC_DOTNET_PROCESS_CPU_COUNT = "dotnet.process.cpu.count";
        $281a441cdcb2cf36$var$METRIC_DOTNET_PROCESS_CPU_TIME = "dotnet.process.cpu.time";
        $281a441cdcb2cf36$var$METRIC_DOTNET_PROCESS_MEMORY_WORKING_SET = "dotnet.process.memory.working_set";
        $281a441cdcb2cf36$var$METRIC_DOTNET_THREAD_POOL_QUEUE_LENGTH = "dotnet.thread_pool.queue.length";
        $281a441cdcb2cf36$var$METRIC_DOTNET_THREAD_POOL_THREAD_COUNT = "dotnet.thread_pool.thread.count";
        $281a441cdcb2cf36$var$METRIC_DOTNET_THREAD_POOL_WORK_ITEM_COUNT = "dotnet.thread_pool.work_item.count";
        $281a441cdcb2cf36$var$METRIC_DOTNET_TIMER_COUNT = "dotnet.timer.count";
        $281a441cdcb2cf36$var$METRIC_HTTP_CLIENT_REQUEST_DURATION = "http.client.request.duration";
        $281a441cdcb2cf36$var$METRIC_HTTP_SERVER_REQUEST_DURATION = "http.server.request.duration";
        $281a441cdcb2cf36$var$METRIC_JVM_CLASS_COUNT = "jvm.class.count";
        $281a441cdcb2cf36$var$METRIC_JVM_CLASS_LOADED = "jvm.class.loaded";
        $281a441cdcb2cf36$var$METRIC_JVM_CLASS_UNLOADED = "jvm.class.unloaded";
        $281a441cdcb2cf36$var$METRIC_JVM_CPU_COUNT = "jvm.cpu.count";
        $281a441cdcb2cf36$var$METRIC_JVM_CPU_RECENT_UTILIZATION = "jvm.cpu.recent_utilization";
        $281a441cdcb2cf36$var$METRIC_JVM_CPU_TIME = "jvm.cpu.time";
        $281a441cdcb2cf36$var$METRIC_JVM_GC_DURATION = "jvm.gc.duration";
        $281a441cdcb2cf36$var$METRIC_JVM_MEMORY_COMMITTED = "jvm.memory.committed";
        $281a441cdcb2cf36$var$METRIC_JVM_MEMORY_LIMIT = "jvm.memory.limit";
        $281a441cdcb2cf36$var$METRIC_JVM_MEMORY_USED = "jvm.memory.used";
        $281a441cdcb2cf36$var$METRIC_JVM_MEMORY_USED_AFTER_LAST_GC = "jvm.memory.used_after_last_gc";
        $281a441cdcb2cf36$var$METRIC_JVM_THREAD_COUNT = "jvm.thread.count";
        $281a441cdcb2cf36$var$METRIC_KESTREL_ACTIVE_CONNECTIONS = "kestrel.active_connections";
        $281a441cdcb2cf36$var$METRIC_KESTREL_ACTIVE_TLS_HANDSHAKES = "kestrel.active_tls_handshakes";
        $281a441cdcb2cf36$var$METRIC_KESTREL_CONNECTION_DURATION = "kestrel.connection.duration";
        $281a441cdcb2cf36$var$METRIC_KESTREL_QUEUED_CONNECTIONS = "kestrel.queued_connections";
        $281a441cdcb2cf36$var$METRIC_KESTREL_QUEUED_REQUESTS = "kestrel.queued_requests";
        $281a441cdcb2cf36$var$METRIC_KESTREL_REJECTED_CONNECTIONS = "kestrel.rejected_connections";
        $281a441cdcb2cf36$var$METRIC_KESTREL_TLS_HANDSHAKE_DURATION = "kestrel.tls_handshake.duration";
        $281a441cdcb2cf36$var$METRIC_KESTREL_UPGRADED_CONNECTIONS = "kestrel.upgraded_connections";
        $281a441cdcb2cf36$var$METRIC_SIGNALR_SERVER_ACTIVE_CONNECTIONS = "signalr.server.active_connections";
        $281a441cdcb2cf36$var$METRIC_SIGNALR_SERVER_CONNECTION_DURATION = "signalr.server.connection.duration";
    }
});
// ../node_modules/@opentelemetry/semantic-conventions/build/esm/stable_events.js
var $281a441cdcb2cf36$var$EVENT_EXCEPTION;
var $281a441cdcb2cf36$var$init_stable_events = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/semantic-conventions/build/esm/stable_events.js" () {
        $281a441cdcb2cf36$var$EVENT_EXCEPTION = "exception";
    }
});
// ../node_modules/@opentelemetry/semantic-conventions/build/esm/index.js
var $281a441cdcb2cf36$var$esm_exports3 = {};
$281a441cdcb2cf36$var$__export($281a441cdcb2cf36$var$esm_exports3, {
    ASPNETCORE_DIAGNOSTICS_EXCEPTION_RESULT_VALUE_ABORTED: ()=>$281a441cdcb2cf36$var$ASPNETCORE_DIAGNOSTICS_EXCEPTION_RESULT_VALUE_ABORTED,
    ASPNETCORE_DIAGNOSTICS_EXCEPTION_RESULT_VALUE_HANDLED: ()=>$281a441cdcb2cf36$var$ASPNETCORE_DIAGNOSTICS_EXCEPTION_RESULT_VALUE_HANDLED,
    ASPNETCORE_DIAGNOSTICS_EXCEPTION_RESULT_VALUE_SKIPPED: ()=>$281a441cdcb2cf36$var$ASPNETCORE_DIAGNOSTICS_EXCEPTION_RESULT_VALUE_SKIPPED,
    ASPNETCORE_DIAGNOSTICS_EXCEPTION_RESULT_VALUE_UNHANDLED: ()=>$281a441cdcb2cf36$var$ASPNETCORE_DIAGNOSTICS_EXCEPTION_RESULT_VALUE_UNHANDLED,
    ASPNETCORE_RATE_LIMITING_RESULT_VALUE_ACQUIRED: ()=>$281a441cdcb2cf36$var$ASPNETCORE_RATE_LIMITING_RESULT_VALUE_ACQUIRED,
    ASPNETCORE_RATE_LIMITING_RESULT_VALUE_ENDPOINT_LIMITER: ()=>$281a441cdcb2cf36$var$ASPNETCORE_RATE_LIMITING_RESULT_VALUE_ENDPOINT_LIMITER,
    ASPNETCORE_RATE_LIMITING_RESULT_VALUE_GLOBAL_LIMITER: ()=>$281a441cdcb2cf36$var$ASPNETCORE_RATE_LIMITING_RESULT_VALUE_GLOBAL_LIMITER,
    ASPNETCORE_RATE_LIMITING_RESULT_VALUE_REQUEST_CANCELED: ()=>$281a441cdcb2cf36$var$ASPNETCORE_RATE_LIMITING_RESULT_VALUE_REQUEST_CANCELED,
    ASPNETCORE_ROUTING_MATCH_STATUS_VALUE_FAILURE: ()=>$281a441cdcb2cf36$var$ASPNETCORE_ROUTING_MATCH_STATUS_VALUE_FAILURE,
    ASPNETCORE_ROUTING_MATCH_STATUS_VALUE_SUCCESS: ()=>$281a441cdcb2cf36$var$ASPNETCORE_ROUTING_MATCH_STATUS_VALUE_SUCCESS,
    ATTR_ASPNETCORE_DIAGNOSTICS_EXCEPTION_RESULT: ()=>$281a441cdcb2cf36$var$ATTR_ASPNETCORE_DIAGNOSTICS_EXCEPTION_RESULT,
    ATTR_ASPNETCORE_DIAGNOSTICS_HANDLER_TYPE: ()=>$281a441cdcb2cf36$var$ATTR_ASPNETCORE_DIAGNOSTICS_HANDLER_TYPE,
    ATTR_ASPNETCORE_RATE_LIMITING_POLICY: ()=>$281a441cdcb2cf36$var$ATTR_ASPNETCORE_RATE_LIMITING_POLICY,
    ATTR_ASPNETCORE_RATE_LIMITING_RESULT: ()=>$281a441cdcb2cf36$var$ATTR_ASPNETCORE_RATE_LIMITING_RESULT,
    ATTR_ASPNETCORE_REQUEST_IS_UNHANDLED: ()=>$281a441cdcb2cf36$var$ATTR_ASPNETCORE_REQUEST_IS_UNHANDLED,
    ATTR_ASPNETCORE_ROUTING_IS_FALLBACK: ()=>$281a441cdcb2cf36$var$ATTR_ASPNETCORE_ROUTING_IS_FALLBACK,
    ATTR_ASPNETCORE_ROUTING_MATCH_STATUS: ()=>$281a441cdcb2cf36$var$ATTR_ASPNETCORE_ROUTING_MATCH_STATUS,
    ATTR_ASPNETCORE_USER_IS_AUTHENTICATED: ()=>$281a441cdcb2cf36$var$ATTR_ASPNETCORE_USER_IS_AUTHENTICATED,
    ATTR_CLIENT_ADDRESS: ()=>$281a441cdcb2cf36$var$ATTR_CLIENT_ADDRESS,
    ATTR_CLIENT_PORT: ()=>$281a441cdcb2cf36$var$ATTR_CLIENT_PORT,
    ATTR_CODE_COLUMN_NUMBER: ()=>$281a441cdcb2cf36$var$ATTR_CODE_COLUMN_NUMBER,
    ATTR_CODE_FILE_PATH: ()=>$281a441cdcb2cf36$var$ATTR_CODE_FILE_PATH,
    ATTR_CODE_FUNCTION_NAME: ()=>$281a441cdcb2cf36$var$ATTR_CODE_FUNCTION_NAME,
    ATTR_CODE_LINE_NUMBER: ()=>$281a441cdcb2cf36$var$ATTR_CODE_LINE_NUMBER,
    ATTR_CODE_STACKTRACE: ()=>$281a441cdcb2cf36$var$ATTR_CODE_STACKTRACE,
    ATTR_DB_COLLECTION_NAME: ()=>$281a441cdcb2cf36$var$ATTR_DB_COLLECTION_NAME,
    ATTR_DB_NAMESPACE: ()=>$281a441cdcb2cf36$var$ATTR_DB_NAMESPACE,
    ATTR_DB_OPERATION_BATCH_SIZE: ()=>$281a441cdcb2cf36$var$ATTR_DB_OPERATION_BATCH_SIZE,
    ATTR_DB_OPERATION_NAME: ()=>$281a441cdcb2cf36$var$ATTR_DB_OPERATION_NAME,
    ATTR_DB_QUERY_SUMMARY: ()=>$281a441cdcb2cf36$var$ATTR_DB_QUERY_SUMMARY,
    ATTR_DB_QUERY_TEXT: ()=>$281a441cdcb2cf36$var$ATTR_DB_QUERY_TEXT,
    ATTR_DB_RESPONSE_STATUS_CODE: ()=>$281a441cdcb2cf36$var$ATTR_DB_RESPONSE_STATUS_CODE,
    ATTR_DB_STORED_PROCEDURE_NAME: ()=>$281a441cdcb2cf36$var$ATTR_DB_STORED_PROCEDURE_NAME,
    ATTR_DB_SYSTEM_NAME: ()=>$281a441cdcb2cf36$var$ATTR_DB_SYSTEM_NAME,
    ATTR_DOTNET_GC_HEAP_GENERATION: ()=>$281a441cdcb2cf36$var$ATTR_DOTNET_GC_HEAP_GENERATION,
    ATTR_ERROR_TYPE: ()=>$281a441cdcb2cf36$var$ATTR_ERROR_TYPE,
    ATTR_EXCEPTION_ESCAPED: ()=>$281a441cdcb2cf36$var$ATTR_EXCEPTION_ESCAPED,
    ATTR_EXCEPTION_MESSAGE: ()=>$281a441cdcb2cf36$var$ATTR_EXCEPTION_MESSAGE,
    ATTR_EXCEPTION_STACKTRACE: ()=>$281a441cdcb2cf36$var$ATTR_EXCEPTION_STACKTRACE,
    ATTR_EXCEPTION_TYPE: ()=>$281a441cdcb2cf36$var$ATTR_EXCEPTION_TYPE,
    ATTR_HTTP_REQUEST_HEADER: ()=>$281a441cdcb2cf36$var$ATTR_HTTP_REQUEST_HEADER,
    ATTR_HTTP_REQUEST_METHOD: ()=>$281a441cdcb2cf36$var$ATTR_HTTP_REQUEST_METHOD,
    ATTR_HTTP_REQUEST_METHOD_ORIGINAL: ()=>$281a441cdcb2cf36$var$ATTR_HTTP_REQUEST_METHOD_ORIGINAL,
    ATTR_HTTP_REQUEST_RESEND_COUNT: ()=>$281a441cdcb2cf36$var$ATTR_HTTP_REQUEST_RESEND_COUNT,
    ATTR_HTTP_RESPONSE_HEADER: ()=>$281a441cdcb2cf36$var$ATTR_HTTP_RESPONSE_HEADER,
    ATTR_HTTP_RESPONSE_STATUS_CODE: ()=>$281a441cdcb2cf36$var$ATTR_HTTP_RESPONSE_STATUS_CODE,
    ATTR_HTTP_ROUTE: ()=>$281a441cdcb2cf36$var$ATTR_HTTP_ROUTE,
    ATTR_JVM_GC_ACTION: ()=>$281a441cdcb2cf36$var$ATTR_JVM_GC_ACTION,
    ATTR_JVM_GC_NAME: ()=>$281a441cdcb2cf36$var$ATTR_JVM_GC_NAME,
    ATTR_JVM_MEMORY_POOL_NAME: ()=>$281a441cdcb2cf36$var$ATTR_JVM_MEMORY_POOL_NAME,
    ATTR_JVM_MEMORY_TYPE: ()=>$281a441cdcb2cf36$var$ATTR_JVM_MEMORY_TYPE,
    ATTR_JVM_THREAD_DAEMON: ()=>$281a441cdcb2cf36$var$ATTR_JVM_THREAD_DAEMON,
    ATTR_JVM_THREAD_STATE: ()=>$281a441cdcb2cf36$var$ATTR_JVM_THREAD_STATE,
    ATTR_NETWORK_LOCAL_ADDRESS: ()=>$281a441cdcb2cf36$var$ATTR_NETWORK_LOCAL_ADDRESS,
    ATTR_NETWORK_LOCAL_PORT: ()=>$281a441cdcb2cf36$var$ATTR_NETWORK_LOCAL_PORT,
    ATTR_NETWORK_PEER_ADDRESS: ()=>$281a441cdcb2cf36$var$ATTR_NETWORK_PEER_ADDRESS,
    ATTR_NETWORK_PEER_PORT: ()=>$281a441cdcb2cf36$var$ATTR_NETWORK_PEER_PORT,
    ATTR_NETWORK_PROTOCOL_NAME: ()=>$281a441cdcb2cf36$var$ATTR_NETWORK_PROTOCOL_NAME,
    ATTR_NETWORK_PROTOCOL_VERSION: ()=>$281a441cdcb2cf36$var$ATTR_NETWORK_PROTOCOL_VERSION,
    ATTR_NETWORK_TRANSPORT: ()=>$281a441cdcb2cf36$var$ATTR_NETWORK_TRANSPORT,
    ATTR_NETWORK_TYPE: ()=>$281a441cdcb2cf36$var$ATTR_NETWORK_TYPE,
    ATTR_OTEL_SCOPE_NAME: ()=>$281a441cdcb2cf36$var$ATTR_OTEL_SCOPE_NAME,
    ATTR_OTEL_SCOPE_VERSION: ()=>$281a441cdcb2cf36$var$ATTR_OTEL_SCOPE_VERSION,
    ATTR_OTEL_STATUS_CODE: ()=>$281a441cdcb2cf36$var$ATTR_OTEL_STATUS_CODE,
    ATTR_OTEL_STATUS_DESCRIPTION: ()=>$281a441cdcb2cf36$var$ATTR_OTEL_STATUS_DESCRIPTION,
    ATTR_SERVER_ADDRESS: ()=>$281a441cdcb2cf36$var$ATTR_SERVER_ADDRESS,
    ATTR_SERVER_PORT: ()=>$281a441cdcb2cf36$var$ATTR_SERVER_PORT,
    ATTR_SERVICE_INSTANCE_ID: ()=>$281a441cdcb2cf36$var$ATTR_SERVICE_INSTANCE_ID,
    ATTR_SERVICE_NAME: ()=>$281a441cdcb2cf36$var$ATTR_SERVICE_NAME,
    ATTR_SERVICE_NAMESPACE: ()=>$281a441cdcb2cf36$var$ATTR_SERVICE_NAMESPACE,
    ATTR_SERVICE_VERSION: ()=>$281a441cdcb2cf36$var$ATTR_SERVICE_VERSION,
    ATTR_SIGNALR_CONNECTION_STATUS: ()=>$281a441cdcb2cf36$var$ATTR_SIGNALR_CONNECTION_STATUS,
    ATTR_SIGNALR_TRANSPORT: ()=>$281a441cdcb2cf36$var$ATTR_SIGNALR_TRANSPORT,
    ATTR_TELEMETRY_SDK_LANGUAGE: ()=>$281a441cdcb2cf36$var$ATTR_TELEMETRY_SDK_LANGUAGE,
    ATTR_TELEMETRY_SDK_NAME: ()=>$281a441cdcb2cf36$var$ATTR_TELEMETRY_SDK_NAME,
    ATTR_TELEMETRY_SDK_VERSION: ()=>$281a441cdcb2cf36$var$ATTR_TELEMETRY_SDK_VERSION,
    ATTR_URL_FRAGMENT: ()=>$281a441cdcb2cf36$var$ATTR_URL_FRAGMENT,
    ATTR_URL_FULL: ()=>$281a441cdcb2cf36$var$ATTR_URL_FULL,
    ATTR_URL_PATH: ()=>$281a441cdcb2cf36$var$ATTR_URL_PATH,
    ATTR_URL_QUERY: ()=>$281a441cdcb2cf36$var$ATTR_URL_QUERY,
    ATTR_URL_SCHEME: ()=>$281a441cdcb2cf36$var$ATTR_URL_SCHEME,
    ATTR_USER_AGENT_ORIGINAL: ()=>$281a441cdcb2cf36$var$ATTR_USER_AGENT_ORIGINAL,
    AWSECSLAUNCHTYPEVALUES_EC2: ()=>$281a441cdcb2cf36$var$AWSECSLAUNCHTYPEVALUES_EC2,
    AWSECSLAUNCHTYPEVALUES_FARGATE: ()=>$281a441cdcb2cf36$var$AWSECSLAUNCHTYPEVALUES_FARGATE,
    AwsEcsLaunchtypeValues: ()=>$281a441cdcb2cf36$var$AwsEcsLaunchtypeValues,
    CLOUDPLATFORMVALUES_ALIBABA_CLOUD_ECS: ()=>$281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_ALIBABA_CLOUD_ECS,
    CLOUDPLATFORMVALUES_ALIBABA_CLOUD_FC: ()=>$281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_ALIBABA_CLOUD_FC,
    CLOUDPLATFORMVALUES_AWS_EC2: ()=>$281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_AWS_EC2,
    CLOUDPLATFORMVALUES_AWS_ECS: ()=>$281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_AWS_ECS,
    CLOUDPLATFORMVALUES_AWS_EKS: ()=>$281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_AWS_EKS,
    CLOUDPLATFORMVALUES_AWS_ELASTIC_BEANSTALK: ()=>$281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_AWS_ELASTIC_BEANSTALK,
    CLOUDPLATFORMVALUES_AWS_LAMBDA: ()=>$281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_AWS_LAMBDA,
    CLOUDPLATFORMVALUES_AZURE_AKS: ()=>$281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_AZURE_AKS,
    CLOUDPLATFORMVALUES_AZURE_APP_SERVICE: ()=>$281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_AZURE_APP_SERVICE,
    CLOUDPLATFORMVALUES_AZURE_CONTAINER_INSTANCES: ()=>$281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_AZURE_CONTAINER_INSTANCES,
    CLOUDPLATFORMVALUES_AZURE_FUNCTIONS: ()=>$281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_AZURE_FUNCTIONS,
    CLOUDPLATFORMVALUES_AZURE_VM: ()=>$281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_AZURE_VM,
    CLOUDPLATFORMVALUES_GCP_APP_ENGINE: ()=>$281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_GCP_APP_ENGINE,
    CLOUDPLATFORMVALUES_GCP_CLOUD_FUNCTIONS: ()=>$281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_GCP_CLOUD_FUNCTIONS,
    CLOUDPLATFORMVALUES_GCP_CLOUD_RUN: ()=>$281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_GCP_CLOUD_RUN,
    CLOUDPLATFORMVALUES_GCP_COMPUTE_ENGINE: ()=>$281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_GCP_COMPUTE_ENGINE,
    CLOUDPLATFORMVALUES_GCP_KUBERNETES_ENGINE: ()=>$281a441cdcb2cf36$var$CLOUDPLATFORMVALUES_GCP_KUBERNETES_ENGINE,
    CLOUDPROVIDERVALUES_ALIBABA_CLOUD: ()=>$281a441cdcb2cf36$var$CLOUDPROVIDERVALUES_ALIBABA_CLOUD,
    CLOUDPROVIDERVALUES_AWS: ()=>$281a441cdcb2cf36$var$CLOUDPROVIDERVALUES_AWS,
    CLOUDPROVIDERVALUES_AZURE: ()=>$281a441cdcb2cf36$var$CLOUDPROVIDERVALUES_AZURE,
    CLOUDPROVIDERVALUES_GCP: ()=>$281a441cdcb2cf36$var$CLOUDPROVIDERVALUES_GCP,
    CloudPlatformValues: ()=>$281a441cdcb2cf36$var$CloudPlatformValues,
    CloudProviderValues: ()=>$281a441cdcb2cf36$var$CloudProviderValues,
    DBCASSANDRACONSISTENCYLEVELVALUES_ALL: ()=>$281a441cdcb2cf36$var$DBCASSANDRACONSISTENCYLEVELVALUES_ALL,
    DBCASSANDRACONSISTENCYLEVELVALUES_ANY: ()=>$281a441cdcb2cf36$var$DBCASSANDRACONSISTENCYLEVELVALUES_ANY,
    DBCASSANDRACONSISTENCYLEVELVALUES_EACH_QUORUM: ()=>$281a441cdcb2cf36$var$DBCASSANDRACONSISTENCYLEVELVALUES_EACH_QUORUM,
    DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_ONE: ()=>$281a441cdcb2cf36$var$DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_ONE,
    DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_QUORUM: ()=>$281a441cdcb2cf36$var$DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_QUORUM,
    DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_SERIAL: ()=>$281a441cdcb2cf36$var$DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_SERIAL,
    DBCASSANDRACONSISTENCYLEVELVALUES_ONE: ()=>$281a441cdcb2cf36$var$DBCASSANDRACONSISTENCYLEVELVALUES_ONE,
    DBCASSANDRACONSISTENCYLEVELVALUES_QUORUM: ()=>$281a441cdcb2cf36$var$DBCASSANDRACONSISTENCYLEVELVALUES_QUORUM,
    DBCASSANDRACONSISTENCYLEVELVALUES_SERIAL: ()=>$281a441cdcb2cf36$var$DBCASSANDRACONSISTENCYLEVELVALUES_SERIAL,
    DBCASSANDRACONSISTENCYLEVELVALUES_THREE: ()=>$281a441cdcb2cf36$var$DBCASSANDRACONSISTENCYLEVELVALUES_THREE,
    DBCASSANDRACONSISTENCYLEVELVALUES_TWO: ()=>$281a441cdcb2cf36$var$DBCASSANDRACONSISTENCYLEVELVALUES_TWO,
    DBSYSTEMVALUES_ADABAS: ()=>$281a441cdcb2cf36$var$DBSYSTEMVALUES_ADABAS,
    DBSYSTEMVALUES_CACHE: ()=>$281a441cdcb2cf36$var$DBSYSTEMVALUES_CACHE,
    DBSYSTEMVALUES_CASSANDRA: ()=>$281a441cdcb2cf36$var$DBSYSTEMVALUES_CASSANDRA,
    DBSYSTEMVALUES_CLOUDSCAPE: ()=>$281a441cdcb2cf36$var$DBSYSTEMVALUES_CLOUDSCAPE,
    DBSYSTEMVALUES_COCKROACHDB: ()=>$281a441cdcb2cf36$var$DBSYSTEMVALUES_COCKROACHDB,
    DBSYSTEMVALUES_COLDFUSION: ()=>$281a441cdcb2cf36$var$DBSYSTEMVALUES_COLDFUSION,
    DBSYSTEMVALUES_COSMOSDB: ()=>$281a441cdcb2cf36$var$DBSYSTEMVALUES_COSMOSDB,
    DBSYSTEMVALUES_COUCHBASE: ()=>$281a441cdcb2cf36$var$DBSYSTEMVALUES_COUCHBASE,
    DBSYSTEMVALUES_COUCHDB: ()=>$281a441cdcb2cf36$var$DBSYSTEMVALUES_COUCHDB,
    DBSYSTEMVALUES_DB2: ()=>$281a441cdcb2cf36$var$DBSYSTEMVALUES_DB2,
    DBSYSTEMVALUES_DERBY: ()=>$281a441cdcb2cf36$var$DBSYSTEMVALUES_DERBY,
    DBSYSTEMVALUES_DYNAMODB: ()=>$281a441cdcb2cf36$var$DBSYSTEMVALUES_DYNAMODB,
    DBSYSTEMVALUES_EDB: ()=>$281a441cdcb2cf36$var$DBSYSTEMVALUES_EDB,
    DBSYSTEMVALUES_ELASTICSEARCH: ()=>$281a441cdcb2cf36$var$DBSYSTEMVALUES_ELASTICSEARCH,
    DBSYSTEMVALUES_FILEMAKER: ()=>$281a441cdcb2cf36$var$DBSYSTEMVALUES_FILEMAKER,
    DBSYSTEMVALUES_FIREBIRD: ()=>$281a441cdcb2cf36$var$DBSYSTEMVALUES_FIREBIRD,
    DBSYSTEMVALUES_FIRSTSQL: ()=>$281a441cdcb2cf36$var$DBSYSTEMVALUES_FIRSTSQL,
    DBSYSTEMVALUES_GEODE: ()=>$281a441cdcb2cf36$var$DBSYSTEMVALUES_GEODE,
    DBSYSTEMVALUES_H2: ()=>$281a441cdcb2cf36$var$DBSYSTEMVALUES_H2,
    DBSYSTEMVALUES_HANADB: ()=>$281a441cdcb2cf36$var$DBSYSTEMVALUES_HANADB,
    DBSYSTEMVALUES_HBASE: ()=>$281a441cdcb2cf36$var$DBSYSTEMVALUES_HBASE,
    DBSYSTEMVALUES_HIVE: ()=>$281a441cdcb2cf36$var$DBSYSTEMVALUES_HIVE,
    DBSYSTEMVALUES_HSQLDB: ()=>$281a441cdcb2cf36$var$DBSYSTEMVALUES_HSQLDB,
    DBSYSTEMVALUES_INFORMIX: ()=>$281a441cdcb2cf36$var$DBSYSTEMVALUES_INFORMIX,
    DBSYSTEMVALUES_INGRES: ()=>$281a441cdcb2cf36$var$DBSYSTEMVALUES_INGRES,
    DBSYSTEMVALUES_INSTANTDB: ()=>$281a441cdcb2cf36$var$DBSYSTEMVALUES_INSTANTDB,
    DBSYSTEMVALUES_INTERBASE: ()=>$281a441cdcb2cf36$var$DBSYSTEMVALUES_INTERBASE,
    DBSYSTEMVALUES_MARIADB: ()=>$281a441cdcb2cf36$var$DBSYSTEMVALUES_MARIADB,
    DBSYSTEMVALUES_MAXDB: ()=>$281a441cdcb2cf36$var$DBSYSTEMVALUES_MAXDB,
    DBSYSTEMVALUES_MEMCACHED: ()=>$281a441cdcb2cf36$var$DBSYSTEMVALUES_MEMCACHED,
    DBSYSTEMVALUES_MONGODB: ()=>$281a441cdcb2cf36$var$DBSYSTEMVALUES_MONGODB,
    DBSYSTEMVALUES_MSSQL: ()=>$281a441cdcb2cf36$var$DBSYSTEMVALUES_MSSQL,
    DBSYSTEMVALUES_MYSQL: ()=>$281a441cdcb2cf36$var$DBSYSTEMVALUES_MYSQL,
    DBSYSTEMVALUES_NEO4J: ()=>$281a441cdcb2cf36$var$DBSYSTEMVALUES_NEO4J,
    DBSYSTEMVALUES_NETEZZA: ()=>$281a441cdcb2cf36$var$DBSYSTEMVALUES_NETEZZA,
    DBSYSTEMVALUES_ORACLE: ()=>$281a441cdcb2cf36$var$DBSYSTEMVALUES_ORACLE,
    DBSYSTEMVALUES_OTHER_SQL: ()=>$281a441cdcb2cf36$var$DBSYSTEMVALUES_OTHER_SQL,
    DBSYSTEMVALUES_PERVASIVE: ()=>$281a441cdcb2cf36$var$DBSYSTEMVALUES_PERVASIVE,
    DBSYSTEMVALUES_POINTBASE: ()=>$281a441cdcb2cf36$var$DBSYSTEMVALUES_POINTBASE,
    DBSYSTEMVALUES_POSTGRESQL: ()=>$281a441cdcb2cf36$var$DBSYSTEMVALUES_POSTGRESQL,
    DBSYSTEMVALUES_PROGRESS: ()=>$281a441cdcb2cf36$var$DBSYSTEMVALUES_PROGRESS,
    DBSYSTEMVALUES_REDIS: ()=>$281a441cdcb2cf36$var$DBSYSTEMVALUES_REDIS,
    DBSYSTEMVALUES_REDSHIFT: ()=>$281a441cdcb2cf36$var$DBSYSTEMVALUES_REDSHIFT,
    DBSYSTEMVALUES_SQLITE: ()=>$281a441cdcb2cf36$var$DBSYSTEMVALUES_SQLITE,
    DBSYSTEMVALUES_SYBASE: ()=>$281a441cdcb2cf36$var$DBSYSTEMVALUES_SYBASE,
    DBSYSTEMVALUES_TERADATA: ()=>$281a441cdcb2cf36$var$DBSYSTEMVALUES_TERADATA,
    DBSYSTEMVALUES_VERTICA: ()=>$281a441cdcb2cf36$var$DBSYSTEMVALUES_VERTICA,
    DB_SYSTEM_NAME_VALUE_MARIADB: ()=>$281a441cdcb2cf36$var$DB_SYSTEM_NAME_VALUE_MARIADB,
    DB_SYSTEM_NAME_VALUE_MICROSOFT_SQL_SERVER: ()=>$281a441cdcb2cf36$var$DB_SYSTEM_NAME_VALUE_MICROSOFT_SQL_SERVER,
    DB_SYSTEM_NAME_VALUE_MYSQL: ()=>$281a441cdcb2cf36$var$DB_SYSTEM_NAME_VALUE_MYSQL,
    DB_SYSTEM_NAME_VALUE_POSTGRESQL: ()=>$281a441cdcb2cf36$var$DB_SYSTEM_NAME_VALUE_POSTGRESQL,
    DOTNET_GC_HEAP_GENERATION_VALUE_GEN0: ()=>$281a441cdcb2cf36$var$DOTNET_GC_HEAP_GENERATION_VALUE_GEN0,
    DOTNET_GC_HEAP_GENERATION_VALUE_GEN1: ()=>$281a441cdcb2cf36$var$DOTNET_GC_HEAP_GENERATION_VALUE_GEN1,
    DOTNET_GC_HEAP_GENERATION_VALUE_GEN2: ()=>$281a441cdcb2cf36$var$DOTNET_GC_HEAP_GENERATION_VALUE_GEN2,
    DOTNET_GC_HEAP_GENERATION_VALUE_LOH: ()=>$281a441cdcb2cf36$var$DOTNET_GC_HEAP_GENERATION_VALUE_LOH,
    DOTNET_GC_HEAP_GENERATION_VALUE_POH: ()=>$281a441cdcb2cf36$var$DOTNET_GC_HEAP_GENERATION_VALUE_POH,
    DbCassandraConsistencyLevelValues: ()=>$281a441cdcb2cf36$var$DbCassandraConsistencyLevelValues,
    DbSystemValues: ()=>$281a441cdcb2cf36$var$DbSystemValues,
    ERROR_TYPE_VALUE_OTHER: ()=>$281a441cdcb2cf36$var$ERROR_TYPE_VALUE_OTHER,
    EVENT_EXCEPTION: ()=>$281a441cdcb2cf36$var$EVENT_EXCEPTION,
    FAASDOCUMENTOPERATIONVALUES_DELETE: ()=>$281a441cdcb2cf36$var$FAASDOCUMENTOPERATIONVALUES_DELETE,
    FAASDOCUMENTOPERATIONVALUES_EDIT: ()=>$281a441cdcb2cf36$var$FAASDOCUMENTOPERATIONVALUES_EDIT,
    FAASDOCUMENTOPERATIONVALUES_INSERT: ()=>$281a441cdcb2cf36$var$FAASDOCUMENTOPERATIONVALUES_INSERT,
    FAASINVOKEDPROVIDERVALUES_ALIBABA_CLOUD: ()=>$281a441cdcb2cf36$var$FAASINVOKEDPROVIDERVALUES_ALIBABA_CLOUD,
    FAASINVOKEDPROVIDERVALUES_AWS: ()=>$281a441cdcb2cf36$var$FAASINVOKEDPROVIDERVALUES_AWS,
    FAASINVOKEDPROVIDERVALUES_AZURE: ()=>$281a441cdcb2cf36$var$FAASINVOKEDPROVIDERVALUES_AZURE,
    FAASINVOKEDPROVIDERVALUES_GCP: ()=>$281a441cdcb2cf36$var$FAASINVOKEDPROVIDERVALUES_GCP,
    FAASTRIGGERVALUES_DATASOURCE: ()=>$281a441cdcb2cf36$var$FAASTRIGGERVALUES_DATASOURCE,
    FAASTRIGGERVALUES_HTTP: ()=>$281a441cdcb2cf36$var$FAASTRIGGERVALUES_HTTP,
    FAASTRIGGERVALUES_OTHER: ()=>$281a441cdcb2cf36$var$FAASTRIGGERVALUES_OTHER,
    FAASTRIGGERVALUES_PUBSUB: ()=>$281a441cdcb2cf36$var$FAASTRIGGERVALUES_PUBSUB,
    FAASTRIGGERVALUES_TIMER: ()=>$281a441cdcb2cf36$var$FAASTRIGGERVALUES_TIMER,
    FaasDocumentOperationValues: ()=>$281a441cdcb2cf36$var$FaasDocumentOperationValues,
    FaasInvokedProviderValues: ()=>$281a441cdcb2cf36$var$FaasInvokedProviderValues,
    FaasTriggerValues: ()=>$281a441cdcb2cf36$var$FaasTriggerValues,
    HOSTARCHVALUES_AMD64: ()=>$281a441cdcb2cf36$var$HOSTARCHVALUES_AMD64,
    HOSTARCHVALUES_ARM32: ()=>$281a441cdcb2cf36$var$HOSTARCHVALUES_ARM32,
    HOSTARCHVALUES_ARM64: ()=>$281a441cdcb2cf36$var$HOSTARCHVALUES_ARM64,
    HOSTARCHVALUES_IA64: ()=>$281a441cdcb2cf36$var$HOSTARCHVALUES_IA64,
    HOSTARCHVALUES_PPC32: ()=>$281a441cdcb2cf36$var$HOSTARCHVALUES_PPC32,
    HOSTARCHVALUES_PPC64: ()=>$281a441cdcb2cf36$var$HOSTARCHVALUES_PPC64,
    HOSTARCHVALUES_X86: ()=>$281a441cdcb2cf36$var$HOSTARCHVALUES_X86,
    HTTPFLAVORVALUES_HTTP_1_0: ()=>$281a441cdcb2cf36$var$HTTPFLAVORVALUES_HTTP_1_0,
    HTTPFLAVORVALUES_HTTP_1_1: ()=>$281a441cdcb2cf36$var$HTTPFLAVORVALUES_HTTP_1_1,
    HTTPFLAVORVALUES_HTTP_2_0: ()=>$281a441cdcb2cf36$var$HTTPFLAVORVALUES_HTTP_2_0,
    HTTPFLAVORVALUES_QUIC: ()=>$281a441cdcb2cf36$var$HTTPFLAVORVALUES_QUIC,
    HTTPFLAVORVALUES_SPDY: ()=>$281a441cdcb2cf36$var$HTTPFLAVORVALUES_SPDY,
    HTTP_REQUEST_METHOD_VALUE_CONNECT: ()=>$281a441cdcb2cf36$var$HTTP_REQUEST_METHOD_VALUE_CONNECT,
    HTTP_REQUEST_METHOD_VALUE_DELETE: ()=>$281a441cdcb2cf36$var$HTTP_REQUEST_METHOD_VALUE_DELETE,
    HTTP_REQUEST_METHOD_VALUE_GET: ()=>$281a441cdcb2cf36$var$HTTP_REQUEST_METHOD_VALUE_GET,
    HTTP_REQUEST_METHOD_VALUE_HEAD: ()=>$281a441cdcb2cf36$var$HTTP_REQUEST_METHOD_VALUE_HEAD,
    HTTP_REQUEST_METHOD_VALUE_OPTIONS: ()=>$281a441cdcb2cf36$var$HTTP_REQUEST_METHOD_VALUE_OPTIONS,
    HTTP_REQUEST_METHOD_VALUE_OTHER: ()=>$281a441cdcb2cf36$var$HTTP_REQUEST_METHOD_VALUE_OTHER,
    HTTP_REQUEST_METHOD_VALUE_PATCH: ()=>$281a441cdcb2cf36$var$HTTP_REQUEST_METHOD_VALUE_PATCH,
    HTTP_REQUEST_METHOD_VALUE_POST: ()=>$281a441cdcb2cf36$var$HTTP_REQUEST_METHOD_VALUE_POST,
    HTTP_REQUEST_METHOD_VALUE_PUT: ()=>$281a441cdcb2cf36$var$HTTP_REQUEST_METHOD_VALUE_PUT,
    HTTP_REQUEST_METHOD_VALUE_TRACE: ()=>$281a441cdcb2cf36$var$HTTP_REQUEST_METHOD_VALUE_TRACE,
    HostArchValues: ()=>$281a441cdcb2cf36$var$HostArchValues,
    HttpFlavorValues: ()=>$281a441cdcb2cf36$var$HttpFlavorValues,
    JVM_MEMORY_TYPE_VALUE_HEAP: ()=>$281a441cdcb2cf36$var$JVM_MEMORY_TYPE_VALUE_HEAP,
    JVM_MEMORY_TYPE_VALUE_NON_HEAP: ()=>$281a441cdcb2cf36$var$JVM_MEMORY_TYPE_VALUE_NON_HEAP,
    JVM_THREAD_STATE_VALUE_BLOCKED: ()=>$281a441cdcb2cf36$var$JVM_THREAD_STATE_VALUE_BLOCKED,
    JVM_THREAD_STATE_VALUE_NEW: ()=>$281a441cdcb2cf36$var$JVM_THREAD_STATE_VALUE_NEW,
    JVM_THREAD_STATE_VALUE_RUNNABLE: ()=>$281a441cdcb2cf36$var$JVM_THREAD_STATE_VALUE_RUNNABLE,
    JVM_THREAD_STATE_VALUE_TERMINATED: ()=>$281a441cdcb2cf36$var$JVM_THREAD_STATE_VALUE_TERMINATED,
    JVM_THREAD_STATE_VALUE_TIMED_WAITING: ()=>$281a441cdcb2cf36$var$JVM_THREAD_STATE_VALUE_TIMED_WAITING,
    JVM_THREAD_STATE_VALUE_WAITING: ()=>$281a441cdcb2cf36$var$JVM_THREAD_STATE_VALUE_WAITING,
    MESSAGETYPEVALUES_RECEIVED: ()=>$281a441cdcb2cf36$var$MESSAGETYPEVALUES_RECEIVED,
    MESSAGETYPEVALUES_SENT: ()=>$281a441cdcb2cf36$var$MESSAGETYPEVALUES_SENT,
    MESSAGINGDESTINATIONKINDVALUES_QUEUE: ()=>$281a441cdcb2cf36$var$MESSAGINGDESTINATIONKINDVALUES_QUEUE,
    MESSAGINGDESTINATIONKINDVALUES_TOPIC: ()=>$281a441cdcb2cf36$var$MESSAGINGDESTINATIONKINDVALUES_TOPIC,
    MESSAGINGOPERATIONVALUES_PROCESS: ()=>$281a441cdcb2cf36$var$MESSAGINGOPERATIONVALUES_PROCESS,
    MESSAGINGOPERATIONVALUES_RECEIVE: ()=>$281a441cdcb2cf36$var$MESSAGINGOPERATIONVALUES_RECEIVE,
    METRIC_ASPNETCORE_DIAGNOSTICS_EXCEPTIONS: ()=>$281a441cdcb2cf36$var$METRIC_ASPNETCORE_DIAGNOSTICS_EXCEPTIONS,
    METRIC_ASPNETCORE_RATE_LIMITING_ACTIVE_REQUEST_LEASES: ()=>$281a441cdcb2cf36$var$METRIC_ASPNETCORE_RATE_LIMITING_ACTIVE_REQUEST_LEASES,
    METRIC_ASPNETCORE_RATE_LIMITING_QUEUED_REQUESTS: ()=>$281a441cdcb2cf36$var$METRIC_ASPNETCORE_RATE_LIMITING_QUEUED_REQUESTS,
    METRIC_ASPNETCORE_RATE_LIMITING_REQUESTS: ()=>$281a441cdcb2cf36$var$METRIC_ASPNETCORE_RATE_LIMITING_REQUESTS,
    METRIC_ASPNETCORE_RATE_LIMITING_REQUEST_LEASE_DURATION: ()=>$281a441cdcb2cf36$var$METRIC_ASPNETCORE_RATE_LIMITING_REQUEST_LEASE_DURATION,
    METRIC_ASPNETCORE_RATE_LIMITING_REQUEST_TIME_IN_QUEUE: ()=>$281a441cdcb2cf36$var$METRIC_ASPNETCORE_RATE_LIMITING_REQUEST_TIME_IN_QUEUE,
    METRIC_ASPNETCORE_ROUTING_MATCH_ATTEMPTS: ()=>$281a441cdcb2cf36$var$METRIC_ASPNETCORE_ROUTING_MATCH_ATTEMPTS,
    METRIC_DB_CLIENT_OPERATION_DURATION: ()=>$281a441cdcb2cf36$var$METRIC_DB_CLIENT_OPERATION_DURATION,
    METRIC_DOTNET_ASSEMBLY_COUNT: ()=>$281a441cdcb2cf36$var$METRIC_DOTNET_ASSEMBLY_COUNT,
    METRIC_DOTNET_EXCEPTIONS: ()=>$281a441cdcb2cf36$var$METRIC_DOTNET_EXCEPTIONS,
    METRIC_DOTNET_GC_COLLECTIONS: ()=>$281a441cdcb2cf36$var$METRIC_DOTNET_GC_COLLECTIONS,
    METRIC_DOTNET_GC_HEAP_TOTAL_ALLOCATED: ()=>$281a441cdcb2cf36$var$METRIC_DOTNET_GC_HEAP_TOTAL_ALLOCATED,
    METRIC_DOTNET_GC_LAST_COLLECTION_HEAP_FRAGMENTATION_SIZE: ()=>$281a441cdcb2cf36$var$METRIC_DOTNET_GC_LAST_COLLECTION_HEAP_FRAGMENTATION_SIZE,
    METRIC_DOTNET_GC_LAST_COLLECTION_HEAP_SIZE: ()=>$281a441cdcb2cf36$var$METRIC_DOTNET_GC_LAST_COLLECTION_HEAP_SIZE,
    METRIC_DOTNET_GC_LAST_COLLECTION_MEMORY_COMMITTED_SIZE: ()=>$281a441cdcb2cf36$var$METRIC_DOTNET_GC_LAST_COLLECTION_MEMORY_COMMITTED_SIZE,
    METRIC_DOTNET_GC_PAUSE_TIME: ()=>$281a441cdcb2cf36$var$METRIC_DOTNET_GC_PAUSE_TIME,
    METRIC_DOTNET_JIT_COMPILATION_TIME: ()=>$281a441cdcb2cf36$var$METRIC_DOTNET_JIT_COMPILATION_TIME,
    METRIC_DOTNET_JIT_COMPILED_IL_SIZE: ()=>$281a441cdcb2cf36$var$METRIC_DOTNET_JIT_COMPILED_IL_SIZE,
    METRIC_DOTNET_JIT_COMPILED_METHODS: ()=>$281a441cdcb2cf36$var$METRIC_DOTNET_JIT_COMPILED_METHODS,
    METRIC_DOTNET_MONITOR_LOCK_CONTENTIONS: ()=>$281a441cdcb2cf36$var$METRIC_DOTNET_MONITOR_LOCK_CONTENTIONS,
    METRIC_DOTNET_PROCESS_CPU_COUNT: ()=>$281a441cdcb2cf36$var$METRIC_DOTNET_PROCESS_CPU_COUNT,
    METRIC_DOTNET_PROCESS_CPU_TIME: ()=>$281a441cdcb2cf36$var$METRIC_DOTNET_PROCESS_CPU_TIME,
    METRIC_DOTNET_PROCESS_MEMORY_WORKING_SET: ()=>$281a441cdcb2cf36$var$METRIC_DOTNET_PROCESS_MEMORY_WORKING_SET,
    METRIC_DOTNET_THREAD_POOL_QUEUE_LENGTH: ()=>$281a441cdcb2cf36$var$METRIC_DOTNET_THREAD_POOL_QUEUE_LENGTH,
    METRIC_DOTNET_THREAD_POOL_THREAD_COUNT: ()=>$281a441cdcb2cf36$var$METRIC_DOTNET_THREAD_POOL_THREAD_COUNT,
    METRIC_DOTNET_THREAD_POOL_WORK_ITEM_COUNT: ()=>$281a441cdcb2cf36$var$METRIC_DOTNET_THREAD_POOL_WORK_ITEM_COUNT,
    METRIC_DOTNET_TIMER_COUNT: ()=>$281a441cdcb2cf36$var$METRIC_DOTNET_TIMER_COUNT,
    METRIC_HTTP_CLIENT_REQUEST_DURATION: ()=>$281a441cdcb2cf36$var$METRIC_HTTP_CLIENT_REQUEST_DURATION,
    METRIC_HTTP_SERVER_REQUEST_DURATION: ()=>$281a441cdcb2cf36$var$METRIC_HTTP_SERVER_REQUEST_DURATION,
    METRIC_JVM_CLASS_COUNT: ()=>$281a441cdcb2cf36$var$METRIC_JVM_CLASS_COUNT,
    METRIC_JVM_CLASS_LOADED: ()=>$281a441cdcb2cf36$var$METRIC_JVM_CLASS_LOADED,
    METRIC_JVM_CLASS_UNLOADED: ()=>$281a441cdcb2cf36$var$METRIC_JVM_CLASS_UNLOADED,
    METRIC_JVM_CPU_COUNT: ()=>$281a441cdcb2cf36$var$METRIC_JVM_CPU_COUNT,
    METRIC_JVM_CPU_RECENT_UTILIZATION: ()=>$281a441cdcb2cf36$var$METRIC_JVM_CPU_RECENT_UTILIZATION,
    METRIC_JVM_CPU_TIME: ()=>$281a441cdcb2cf36$var$METRIC_JVM_CPU_TIME,
    METRIC_JVM_GC_DURATION: ()=>$281a441cdcb2cf36$var$METRIC_JVM_GC_DURATION,
    METRIC_JVM_MEMORY_COMMITTED: ()=>$281a441cdcb2cf36$var$METRIC_JVM_MEMORY_COMMITTED,
    METRIC_JVM_MEMORY_LIMIT: ()=>$281a441cdcb2cf36$var$METRIC_JVM_MEMORY_LIMIT,
    METRIC_JVM_MEMORY_USED: ()=>$281a441cdcb2cf36$var$METRIC_JVM_MEMORY_USED,
    METRIC_JVM_MEMORY_USED_AFTER_LAST_GC: ()=>$281a441cdcb2cf36$var$METRIC_JVM_MEMORY_USED_AFTER_LAST_GC,
    METRIC_JVM_THREAD_COUNT: ()=>$281a441cdcb2cf36$var$METRIC_JVM_THREAD_COUNT,
    METRIC_KESTREL_ACTIVE_CONNECTIONS: ()=>$281a441cdcb2cf36$var$METRIC_KESTREL_ACTIVE_CONNECTIONS,
    METRIC_KESTREL_ACTIVE_TLS_HANDSHAKES: ()=>$281a441cdcb2cf36$var$METRIC_KESTREL_ACTIVE_TLS_HANDSHAKES,
    METRIC_KESTREL_CONNECTION_DURATION: ()=>$281a441cdcb2cf36$var$METRIC_KESTREL_CONNECTION_DURATION,
    METRIC_KESTREL_QUEUED_CONNECTIONS: ()=>$281a441cdcb2cf36$var$METRIC_KESTREL_QUEUED_CONNECTIONS,
    METRIC_KESTREL_QUEUED_REQUESTS: ()=>$281a441cdcb2cf36$var$METRIC_KESTREL_QUEUED_REQUESTS,
    METRIC_KESTREL_REJECTED_CONNECTIONS: ()=>$281a441cdcb2cf36$var$METRIC_KESTREL_REJECTED_CONNECTIONS,
    METRIC_KESTREL_TLS_HANDSHAKE_DURATION: ()=>$281a441cdcb2cf36$var$METRIC_KESTREL_TLS_HANDSHAKE_DURATION,
    METRIC_KESTREL_UPGRADED_CONNECTIONS: ()=>$281a441cdcb2cf36$var$METRIC_KESTREL_UPGRADED_CONNECTIONS,
    METRIC_SIGNALR_SERVER_ACTIVE_CONNECTIONS: ()=>$281a441cdcb2cf36$var$METRIC_SIGNALR_SERVER_ACTIVE_CONNECTIONS,
    METRIC_SIGNALR_SERVER_CONNECTION_DURATION: ()=>$281a441cdcb2cf36$var$METRIC_SIGNALR_SERVER_CONNECTION_DURATION,
    MessageTypeValues: ()=>$281a441cdcb2cf36$var$MessageTypeValues,
    MessagingDestinationKindValues: ()=>$281a441cdcb2cf36$var$MessagingDestinationKindValues,
    MessagingOperationValues: ()=>$281a441cdcb2cf36$var$MessagingOperationValues,
    NETHOSTCONNECTIONSUBTYPEVALUES_CDMA: ()=>$281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_CDMA,
    NETHOSTCONNECTIONSUBTYPEVALUES_CDMA2000_1XRTT: ()=>$281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_CDMA2000_1XRTT,
    NETHOSTCONNECTIONSUBTYPEVALUES_EDGE: ()=>$281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_EDGE,
    NETHOSTCONNECTIONSUBTYPEVALUES_EHRPD: ()=>$281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_EHRPD,
    NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_0: ()=>$281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_0,
    NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_A: ()=>$281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_A,
    NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_B: ()=>$281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_B,
    NETHOSTCONNECTIONSUBTYPEVALUES_GPRS: ()=>$281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_GPRS,
    NETHOSTCONNECTIONSUBTYPEVALUES_GSM: ()=>$281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_GSM,
    NETHOSTCONNECTIONSUBTYPEVALUES_HSDPA: ()=>$281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_HSDPA,
    NETHOSTCONNECTIONSUBTYPEVALUES_HSPA: ()=>$281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_HSPA,
    NETHOSTCONNECTIONSUBTYPEVALUES_HSPAP: ()=>$281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_HSPAP,
    NETHOSTCONNECTIONSUBTYPEVALUES_HSUPA: ()=>$281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_HSUPA,
    NETHOSTCONNECTIONSUBTYPEVALUES_IDEN: ()=>$281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_IDEN,
    NETHOSTCONNECTIONSUBTYPEVALUES_IWLAN: ()=>$281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_IWLAN,
    NETHOSTCONNECTIONSUBTYPEVALUES_LTE: ()=>$281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_LTE,
    NETHOSTCONNECTIONSUBTYPEVALUES_LTE_CA: ()=>$281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_LTE_CA,
    NETHOSTCONNECTIONSUBTYPEVALUES_NR: ()=>$281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_NR,
    NETHOSTCONNECTIONSUBTYPEVALUES_NRNSA: ()=>$281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_NRNSA,
    NETHOSTCONNECTIONSUBTYPEVALUES_TD_SCDMA: ()=>$281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_TD_SCDMA,
    NETHOSTCONNECTIONSUBTYPEVALUES_UMTS: ()=>$281a441cdcb2cf36$var$NETHOSTCONNECTIONSUBTYPEVALUES_UMTS,
    NETHOSTCONNECTIONTYPEVALUES_CELL: ()=>$281a441cdcb2cf36$var$NETHOSTCONNECTIONTYPEVALUES_CELL,
    NETHOSTCONNECTIONTYPEVALUES_UNAVAILABLE: ()=>$281a441cdcb2cf36$var$NETHOSTCONNECTIONTYPEVALUES_UNAVAILABLE,
    NETHOSTCONNECTIONTYPEVALUES_UNKNOWN: ()=>$281a441cdcb2cf36$var$NETHOSTCONNECTIONTYPEVALUES_UNKNOWN,
    NETHOSTCONNECTIONTYPEVALUES_WIFI: ()=>$281a441cdcb2cf36$var$NETHOSTCONNECTIONTYPEVALUES_WIFI,
    NETHOSTCONNECTIONTYPEVALUES_WIRED: ()=>$281a441cdcb2cf36$var$NETHOSTCONNECTIONTYPEVALUES_WIRED,
    NETTRANSPORTVALUES_INPROC: ()=>$281a441cdcb2cf36$var$NETTRANSPORTVALUES_INPROC,
    NETTRANSPORTVALUES_IP: ()=>$281a441cdcb2cf36$var$NETTRANSPORTVALUES_IP,
    NETTRANSPORTVALUES_IP_TCP: ()=>$281a441cdcb2cf36$var$NETTRANSPORTVALUES_IP_TCP,
    NETTRANSPORTVALUES_IP_UDP: ()=>$281a441cdcb2cf36$var$NETTRANSPORTVALUES_IP_UDP,
    NETTRANSPORTVALUES_OTHER: ()=>$281a441cdcb2cf36$var$NETTRANSPORTVALUES_OTHER,
    NETTRANSPORTVALUES_PIPE: ()=>$281a441cdcb2cf36$var$NETTRANSPORTVALUES_PIPE,
    NETTRANSPORTVALUES_UNIX: ()=>$281a441cdcb2cf36$var$NETTRANSPORTVALUES_UNIX,
    NETWORK_TRANSPORT_VALUE_PIPE: ()=>$281a441cdcb2cf36$var$NETWORK_TRANSPORT_VALUE_PIPE,
    NETWORK_TRANSPORT_VALUE_QUIC: ()=>$281a441cdcb2cf36$var$NETWORK_TRANSPORT_VALUE_QUIC,
    NETWORK_TRANSPORT_VALUE_TCP: ()=>$281a441cdcb2cf36$var$NETWORK_TRANSPORT_VALUE_TCP,
    NETWORK_TRANSPORT_VALUE_UDP: ()=>$281a441cdcb2cf36$var$NETWORK_TRANSPORT_VALUE_UDP,
    NETWORK_TRANSPORT_VALUE_UNIX: ()=>$281a441cdcb2cf36$var$NETWORK_TRANSPORT_VALUE_UNIX,
    NETWORK_TYPE_VALUE_IPV4: ()=>$281a441cdcb2cf36$var$NETWORK_TYPE_VALUE_IPV4,
    NETWORK_TYPE_VALUE_IPV6: ()=>$281a441cdcb2cf36$var$NETWORK_TYPE_VALUE_IPV6,
    NetHostConnectionSubtypeValues: ()=>$281a441cdcb2cf36$var$NetHostConnectionSubtypeValues,
    NetHostConnectionTypeValues: ()=>$281a441cdcb2cf36$var$NetHostConnectionTypeValues,
    NetTransportValues: ()=>$281a441cdcb2cf36$var$NetTransportValues,
    OSTYPEVALUES_AIX: ()=>$281a441cdcb2cf36$var$OSTYPEVALUES_AIX,
    OSTYPEVALUES_DARWIN: ()=>$281a441cdcb2cf36$var$OSTYPEVALUES_DARWIN,
    OSTYPEVALUES_DRAGONFLYBSD: ()=>$281a441cdcb2cf36$var$OSTYPEVALUES_DRAGONFLYBSD,
    OSTYPEVALUES_FREEBSD: ()=>$281a441cdcb2cf36$var$OSTYPEVALUES_FREEBSD,
    OSTYPEVALUES_HPUX: ()=>$281a441cdcb2cf36$var$OSTYPEVALUES_HPUX,
    OSTYPEVALUES_LINUX: ()=>$281a441cdcb2cf36$var$OSTYPEVALUES_LINUX,
    OSTYPEVALUES_NETBSD: ()=>$281a441cdcb2cf36$var$OSTYPEVALUES_NETBSD,
    OSTYPEVALUES_OPENBSD: ()=>$281a441cdcb2cf36$var$OSTYPEVALUES_OPENBSD,
    OSTYPEVALUES_SOLARIS: ()=>$281a441cdcb2cf36$var$OSTYPEVALUES_SOLARIS,
    OSTYPEVALUES_WINDOWS: ()=>$281a441cdcb2cf36$var$OSTYPEVALUES_WINDOWS,
    OSTYPEVALUES_Z_OS: ()=>$281a441cdcb2cf36$var$OSTYPEVALUES_Z_OS,
    OTEL_STATUS_CODE_VALUE_ERROR: ()=>$281a441cdcb2cf36$var$OTEL_STATUS_CODE_VALUE_ERROR,
    OTEL_STATUS_CODE_VALUE_OK: ()=>$281a441cdcb2cf36$var$OTEL_STATUS_CODE_VALUE_OK,
    OsTypeValues: ()=>$281a441cdcb2cf36$var$OsTypeValues,
    RPCGRPCSTATUSCODEVALUES_ABORTED: ()=>$281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_ABORTED,
    RPCGRPCSTATUSCODEVALUES_ALREADY_EXISTS: ()=>$281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_ALREADY_EXISTS,
    RPCGRPCSTATUSCODEVALUES_CANCELLED: ()=>$281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_CANCELLED,
    RPCGRPCSTATUSCODEVALUES_DATA_LOSS: ()=>$281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_DATA_LOSS,
    RPCGRPCSTATUSCODEVALUES_DEADLINE_EXCEEDED: ()=>$281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_DEADLINE_EXCEEDED,
    RPCGRPCSTATUSCODEVALUES_FAILED_PRECONDITION: ()=>$281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_FAILED_PRECONDITION,
    RPCGRPCSTATUSCODEVALUES_INTERNAL: ()=>$281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_INTERNAL,
    RPCGRPCSTATUSCODEVALUES_INVALID_ARGUMENT: ()=>$281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_INVALID_ARGUMENT,
    RPCGRPCSTATUSCODEVALUES_NOT_FOUND: ()=>$281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_NOT_FOUND,
    RPCGRPCSTATUSCODEVALUES_OK: ()=>$281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_OK,
    RPCGRPCSTATUSCODEVALUES_OUT_OF_RANGE: ()=>$281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_OUT_OF_RANGE,
    RPCGRPCSTATUSCODEVALUES_PERMISSION_DENIED: ()=>$281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_PERMISSION_DENIED,
    RPCGRPCSTATUSCODEVALUES_RESOURCE_EXHAUSTED: ()=>$281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_RESOURCE_EXHAUSTED,
    RPCGRPCSTATUSCODEVALUES_UNAUTHENTICATED: ()=>$281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_UNAUTHENTICATED,
    RPCGRPCSTATUSCODEVALUES_UNAVAILABLE: ()=>$281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_UNAVAILABLE,
    RPCGRPCSTATUSCODEVALUES_UNIMPLEMENTED: ()=>$281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_UNIMPLEMENTED,
    RPCGRPCSTATUSCODEVALUES_UNKNOWN: ()=>$281a441cdcb2cf36$var$RPCGRPCSTATUSCODEVALUES_UNKNOWN,
    RpcGrpcStatusCodeValues: ()=>$281a441cdcb2cf36$var$RpcGrpcStatusCodeValues,
    SEMATTRS_AWS_DYNAMODB_ATTRIBUTES_TO_GET: ()=>$281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_ATTRIBUTES_TO_GET,
    SEMATTRS_AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS: ()=>$281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS,
    SEMATTRS_AWS_DYNAMODB_CONSISTENT_READ: ()=>$281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_CONSISTENT_READ,
    SEMATTRS_AWS_DYNAMODB_CONSUMED_CAPACITY: ()=>$281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_CONSUMED_CAPACITY,
    SEMATTRS_AWS_DYNAMODB_COUNT: ()=>$281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_COUNT,
    SEMATTRS_AWS_DYNAMODB_EXCLUSIVE_START_TABLE: ()=>$281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_EXCLUSIVE_START_TABLE,
    SEMATTRS_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES: ()=>$281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES,
    SEMATTRS_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES: ()=>$281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES,
    SEMATTRS_AWS_DYNAMODB_INDEX_NAME: ()=>$281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_INDEX_NAME,
    SEMATTRS_AWS_DYNAMODB_ITEM_COLLECTION_METRICS: ()=>$281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_ITEM_COLLECTION_METRICS,
    SEMATTRS_AWS_DYNAMODB_LIMIT: ()=>$281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_LIMIT,
    SEMATTRS_AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES: ()=>$281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES,
    SEMATTRS_AWS_DYNAMODB_PROJECTION: ()=>$281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_PROJECTION,
    SEMATTRS_AWS_DYNAMODB_PROVISIONED_READ_CAPACITY: ()=>$281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_PROVISIONED_READ_CAPACITY,
    SEMATTRS_AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY: ()=>$281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY,
    SEMATTRS_AWS_DYNAMODB_SCANNED_COUNT: ()=>$281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_SCANNED_COUNT,
    SEMATTRS_AWS_DYNAMODB_SCAN_FORWARD: ()=>$281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_SCAN_FORWARD,
    SEMATTRS_AWS_DYNAMODB_SEGMENT: ()=>$281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_SEGMENT,
    SEMATTRS_AWS_DYNAMODB_SELECT: ()=>$281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_SELECT,
    SEMATTRS_AWS_DYNAMODB_TABLE_COUNT: ()=>$281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_TABLE_COUNT,
    SEMATTRS_AWS_DYNAMODB_TABLE_NAMES: ()=>$281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_TABLE_NAMES,
    SEMATTRS_AWS_DYNAMODB_TOTAL_SEGMENTS: ()=>$281a441cdcb2cf36$var$SEMATTRS_AWS_DYNAMODB_TOTAL_SEGMENTS,
    SEMATTRS_AWS_LAMBDA_INVOKED_ARN: ()=>$281a441cdcb2cf36$var$SEMATTRS_AWS_LAMBDA_INVOKED_ARN,
    SEMATTRS_CODE_FILEPATH: ()=>$281a441cdcb2cf36$var$SEMATTRS_CODE_FILEPATH,
    SEMATTRS_CODE_FUNCTION: ()=>$281a441cdcb2cf36$var$SEMATTRS_CODE_FUNCTION,
    SEMATTRS_CODE_LINENO: ()=>$281a441cdcb2cf36$var$SEMATTRS_CODE_LINENO,
    SEMATTRS_CODE_NAMESPACE: ()=>$281a441cdcb2cf36$var$SEMATTRS_CODE_NAMESPACE,
    SEMATTRS_DB_CASSANDRA_CONSISTENCY_LEVEL: ()=>$281a441cdcb2cf36$var$SEMATTRS_DB_CASSANDRA_CONSISTENCY_LEVEL,
    SEMATTRS_DB_CASSANDRA_COORDINATOR_DC: ()=>$281a441cdcb2cf36$var$SEMATTRS_DB_CASSANDRA_COORDINATOR_DC,
    SEMATTRS_DB_CASSANDRA_COORDINATOR_ID: ()=>$281a441cdcb2cf36$var$SEMATTRS_DB_CASSANDRA_COORDINATOR_ID,
    SEMATTRS_DB_CASSANDRA_IDEMPOTENCE: ()=>$281a441cdcb2cf36$var$SEMATTRS_DB_CASSANDRA_IDEMPOTENCE,
    SEMATTRS_DB_CASSANDRA_KEYSPACE: ()=>$281a441cdcb2cf36$var$SEMATTRS_DB_CASSANDRA_KEYSPACE,
    SEMATTRS_DB_CASSANDRA_PAGE_SIZE: ()=>$281a441cdcb2cf36$var$SEMATTRS_DB_CASSANDRA_PAGE_SIZE,
    SEMATTRS_DB_CASSANDRA_SPECULATIVE_EXECUTION_COUNT: ()=>$281a441cdcb2cf36$var$SEMATTRS_DB_CASSANDRA_SPECULATIVE_EXECUTION_COUNT,
    SEMATTRS_DB_CASSANDRA_TABLE: ()=>$281a441cdcb2cf36$var$SEMATTRS_DB_CASSANDRA_TABLE,
    SEMATTRS_DB_CONNECTION_STRING: ()=>$281a441cdcb2cf36$var$SEMATTRS_DB_CONNECTION_STRING,
    SEMATTRS_DB_HBASE_NAMESPACE: ()=>$281a441cdcb2cf36$var$SEMATTRS_DB_HBASE_NAMESPACE,
    SEMATTRS_DB_JDBC_DRIVER_CLASSNAME: ()=>$281a441cdcb2cf36$var$SEMATTRS_DB_JDBC_DRIVER_CLASSNAME,
    SEMATTRS_DB_MONGODB_COLLECTION: ()=>$281a441cdcb2cf36$var$SEMATTRS_DB_MONGODB_COLLECTION,
    SEMATTRS_DB_MSSQL_INSTANCE_NAME: ()=>$281a441cdcb2cf36$var$SEMATTRS_DB_MSSQL_INSTANCE_NAME,
    SEMATTRS_DB_NAME: ()=>$281a441cdcb2cf36$var$SEMATTRS_DB_NAME,
    SEMATTRS_DB_OPERATION: ()=>$281a441cdcb2cf36$var$SEMATTRS_DB_OPERATION,
    SEMATTRS_DB_REDIS_DATABASE_INDEX: ()=>$281a441cdcb2cf36$var$SEMATTRS_DB_REDIS_DATABASE_INDEX,
    SEMATTRS_DB_SQL_TABLE: ()=>$281a441cdcb2cf36$var$SEMATTRS_DB_SQL_TABLE,
    SEMATTRS_DB_STATEMENT: ()=>$281a441cdcb2cf36$var$SEMATTRS_DB_STATEMENT,
    SEMATTRS_DB_SYSTEM: ()=>$281a441cdcb2cf36$var$SEMATTRS_DB_SYSTEM,
    SEMATTRS_DB_USER: ()=>$281a441cdcb2cf36$var$SEMATTRS_DB_USER,
    SEMATTRS_ENDUSER_ID: ()=>$281a441cdcb2cf36$var$SEMATTRS_ENDUSER_ID,
    SEMATTRS_ENDUSER_ROLE: ()=>$281a441cdcb2cf36$var$SEMATTRS_ENDUSER_ROLE,
    SEMATTRS_ENDUSER_SCOPE: ()=>$281a441cdcb2cf36$var$SEMATTRS_ENDUSER_SCOPE,
    SEMATTRS_EXCEPTION_ESCAPED: ()=>$281a441cdcb2cf36$var$SEMATTRS_EXCEPTION_ESCAPED,
    SEMATTRS_EXCEPTION_MESSAGE: ()=>$281a441cdcb2cf36$var$SEMATTRS_EXCEPTION_MESSAGE,
    SEMATTRS_EXCEPTION_STACKTRACE: ()=>$281a441cdcb2cf36$var$SEMATTRS_EXCEPTION_STACKTRACE,
    SEMATTRS_EXCEPTION_TYPE: ()=>$281a441cdcb2cf36$var$SEMATTRS_EXCEPTION_TYPE,
    SEMATTRS_FAAS_COLDSTART: ()=>$281a441cdcb2cf36$var$SEMATTRS_FAAS_COLDSTART,
    SEMATTRS_FAAS_CRON: ()=>$281a441cdcb2cf36$var$SEMATTRS_FAAS_CRON,
    SEMATTRS_FAAS_DOCUMENT_COLLECTION: ()=>$281a441cdcb2cf36$var$SEMATTRS_FAAS_DOCUMENT_COLLECTION,
    SEMATTRS_FAAS_DOCUMENT_NAME: ()=>$281a441cdcb2cf36$var$SEMATTRS_FAAS_DOCUMENT_NAME,
    SEMATTRS_FAAS_DOCUMENT_OPERATION: ()=>$281a441cdcb2cf36$var$SEMATTRS_FAAS_DOCUMENT_OPERATION,
    SEMATTRS_FAAS_DOCUMENT_TIME: ()=>$281a441cdcb2cf36$var$SEMATTRS_FAAS_DOCUMENT_TIME,
    SEMATTRS_FAAS_EXECUTION: ()=>$281a441cdcb2cf36$var$SEMATTRS_FAAS_EXECUTION,
    SEMATTRS_FAAS_INVOKED_NAME: ()=>$281a441cdcb2cf36$var$SEMATTRS_FAAS_INVOKED_NAME,
    SEMATTRS_FAAS_INVOKED_PROVIDER: ()=>$281a441cdcb2cf36$var$SEMATTRS_FAAS_INVOKED_PROVIDER,
    SEMATTRS_FAAS_INVOKED_REGION: ()=>$281a441cdcb2cf36$var$SEMATTRS_FAAS_INVOKED_REGION,
    SEMATTRS_FAAS_TIME: ()=>$281a441cdcb2cf36$var$SEMATTRS_FAAS_TIME,
    SEMATTRS_FAAS_TRIGGER: ()=>$281a441cdcb2cf36$var$SEMATTRS_FAAS_TRIGGER,
    SEMATTRS_HTTP_CLIENT_IP: ()=>$281a441cdcb2cf36$var$SEMATTRS_HTTP_CLIENT_IP,
    SEMATTRS_HTTP_FLAVOR: ()=>$281a441cdcb2cf36$var$SEMATTRS_HTTP_FLAVOR,
    SEMATTRS_HTTP_HOST: ()=>$281a441cdcb2cf36$var$SEMATTRS_HTTP_HOST,
    SEMATTRS_HTTP_METHOD: ()=>$281a441cdcb2cf36$var$SEMATTRS_HTTP_METHOD,
    SEMATTRS_HTTP_REQUEST_CONTENT_LENGTH: ()=>$281a441cdcb2cf36$var$SEMATTRS_HTTP_REQUEST_CONTENT_LENGTH,
    SEMATTRS_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED: ()=>$281a441cdcb2cf36$var$SEMATTRS_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED,
    SEMATTRS_HTTP_RESPONSE_CONTENT_LENGTH: ()=>$281a441cdcb2cf36$var$SEMATTRS_HTTP_RESPONSE_CONTENT_LENGTH,
    SEMATTRS_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED: ()=>$281a441cdcb2cf36$var$SEMATTRS_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED,
    SEMATTRS_HTTP_ROUTE: ()=>$281a441cdcb2cf36$var$SEMATTRS_HTTP_ROUTE,
    SEMATTRS_HTTP_SCHEME: ()=>$281a441cdcb2cf36$var$SEMATTRS_HTTP_SCHEME,
    SEMATTRS_HTTP_SERVER_NAME: ()=>$281a441cdcb2cf36$var$SEMATTRS_HTTP_SERVER_NAME,
    SEMATTRS_HTTP_STATUS_CODE: ()=>$281a441cdcb2cf36$var$SEMATTRS_HTTP_STATUS_CODE,
    SEMATTRS_HTTP_TARGET: ()=>$281a441cdcb2cf36$var$SEMATTRS_HTTP_TARGET,
    SEMATTRS_HTTP_URL: ()=>$281a441cdcb2cf36$var$SEMATTRS_HTTP_URL,
    SEMATTRS_HTTP_USER_AGENT: ()=>$281a441cdcb2cf36$var$SEMATTRS_HTTP_USER_AGENT,
    SEMATTRS_MESSAGE_COMPRESSED_SIZE: ()=>$281a441cdcb2cf36$var$SEMATTRS_MESSAGE_COMPRESSED_SIZE,
    SEMATTRS_MESSAGE_ID: ()=>$281a441cdcb2cf36$var$SEMATTRS_MESSAGE_ID,
    SEMATTRS_MESSAGE_TYPE: ()=>$281a441cdcb2cf36$var$SEMATTRS_MESSAGE_TYPE,
    SEMATTRS_MESSAGE_UNCOMPRESSED_SIZE: ()=>$281a441cdcb2cf36$var$SEMATTRS_MESSAGE_UNCOMPRESSED_SIZE,
    SEMATTRS_MESSAGING_CONSUMER_ID: ()=>$281a441cdcb2cf36$var$SEMATTRS_MESSAGING_CONSUMER_ID,
    SEMATTRS_MESSAGING_CONVERSATION_ID: ()=>$281a441cdcb2cf36$var$SEMATTRS_MESSAGING_CONVERSATION_ID,
    SEMATTRS_MESSAGING_DESTINATION: ()=>$281a441cdcb2cf36$var$SEMATTRS_MESSAGING_DESTINATION,
    SEMATTRS_MESSAGING_DESTINATION_KIND: ()=>$281a441cdcb2cf36$var$SEMATTRS_MESSAGING_DESTINATION_KIND,
    SEMATTRS_MESSAGING_KAFKA_CLIENT_ID: ()=>$281a441cdcb2cf36$var$SEMATTRS_MESSAGING_KAFKA_CLIENT_ID,
    SEMATTRS_MESSAGING_KAFKA_CONSUMER_GROUP: ()=>$281a441cdcb2cf36$var$SEMATTRS_MESSAGING_KAFKA_CONSUMER_GROUP,
    SEMATTRS_MESSAGING_KAFKA_MESSAGE_KEY: ()=>$281a441cdcb2cf36$var$SEMATTRS_MESSAGING_KAFKA_MESSAGE_KEY,
    SEMATTRS_MESSAGING_KAFKA_PARTITION: ()=>$281a441cdcb2cf36$var$SEMATTRS_MESSAGING_KAFKA_PARTITION,
    SEMATTRS_MESSAGING_KAFKA_TOMBSTONE: ()=>$281a441cdcb2cf36$var$SEMATTRS_MESSAGING_KAFKA_TOMBSTONE,
    SEMATTRS_MESSAGING_MESSAGE_ID: ()=>$281a441cdcb2cf36$var$SEMATTRS_MESSAGING_MESSAGE_ID,
    SEMATTRS_MESSAGING_MESSAGE_PAYLOAD_COMPRESSED_SIZE_BYTES: ()=>$281a441cdcb2cf36$var$SEMATTRS_MESSAGING_MESSAGE_PAYLOAD_COMPRESSED_SIZE_BYTES,
    SEMATTRS_MESSAGING_MESSAGE_PAYLOAD_SIZE_BYTES: ()=>$281a441cdcb2cf36$var$SEMATTRS_MESSAGING_MESSAGE_PAYLOAD_SIZE_BYTES,
    SEMATTRS_MESSAGING_OPERATION: ()=>$281a441cdcb2cf36$var$SEMATTRS_MESSAGING_OPERATION,
    SEMATTRS_MESSAGING_PROTOCOL: ()=>$281a441cdcb2cf36$var$SEMATTRS_MESSAGING_PROTOCOL,
    SEMATTRS_MESSAGING_PROTOCOL_VERSION: ()=>$281a441cdcb2cf36$var$SEMATTRS_MESSAGING_PROTOCOL_VERSION,
    SEMATTRS_MESSAGING_RABBITMQ_ROUTING_KEY: ()=>$281a441cdcb2cf36$var$SEMATTRS_MESSAGING_RABBITMQ_ROUTING_KEY,
    SEMATTRS_MESSAGING_SYSTEM: ()=>$281a441cdcb2cf36$var$SEMATTRS_MESSAGING_SYSTEM,
    SEMATTRS_MESSAGING_TEMP_DESTINATION: ()=>$281a441cdcb2cf36$var$SEMATTRS_MESSAGING_TEMP_DESTINATION,
    SEMATTRS_MESSAGING_URL: ()=>$281a441cdcb2cf36$var$SEMATTRS_MESSAGING_URL,
    SEMATTRS_NET_HOST_CARRIER_ICC: ()=>$281a441cdcb2cf36$var$SEMATTRS_NET_HOST_CARRIER_ICC,
    SEMATTRS_NET_HOST_CARRIER_MCC: ()=>$281a441cdcb2cf36$var$SEMATTRS_NET_HOST_CARRIER_MCC,
    SEMATTRS_NET_HOST_CARRIER_MNC: ()=>$281a441cdcb2cf36$var$SEMATTRS_NET_HOST_CARRIER_MNC,
    SEMATTRS_NET_HOST_CARRIER_NAME: ()=>$281a441cdcb2cf36$var$SEMATTRS_NET_HOST_CARRIER_NAME,
    SEMATTRS_NET_HOST_CONNECTION_SUBTYPE: ()=>$281a441cdcb2cf36$var$SEMATTRS_NET_HOST_CONNECTION_SUBTYPE,
    SEMATTRS_NET_HOST_CONNECTION_TYPE: ()=>$281a441cdcb2cf36$var$SEMATTRS_NET_HOST_CONNECTION_TYPE,
    SEMATTRS_NET_HOST_IP: ()=>$281a441cdcb2cf36$var$SEMATTRS_NET_HOST_IP,
    SEMATTRS_NET_HOST_NAME: ()=>$281a441cdcb2cf36$var$SEMATTRS_NET_HOST_NAME,
    SEMATTRS_NET_HOST_PORT: ()=>$281a441cdcb2cf36$var$SEMATTRS_NET_HOST_PORT,
    SEMATTRS_NET_PEER_IP: ()=>$281a441cdcb2cf36$var$SEMATTRS_NET_PEER_IP,
    SEMATTRS_NET_PEER_NAME: ()=>$281a441cdcb2cf36$var$SEMATTRS_NET_PEER_NAME,
    SEMATTRS_NET_PEER_PORT: ()=>$281a441cdcb2cf36$var$SEMATTRS_NET_PEER_PORT,
    SEMATTRS_NET_TRANSPORT: ()=>$281a441cdcb2cf36$var$SEMATTRS_NET_TRANSPORT,
    SEMATTRS_PEER_SERVICE: ()=>$281a441cdcb2cf36$var$SEMATTRS_PEER_SERVICE,
    SEMATTRS_RPC_GRPC_STATUS_CODE: ()=>$281a441cdcb2cf36$var$SEMATTRS_RPC_GRPC_STATUS_CODE,
    SEMATTRS_RPC_JSONRPC_ERROR_CODE: ()=>$281a441cdcb2cf36$var$SEMATTRS_RPC_JSONRPC_ERROR_CODE,
    SEMATTRS_RPC_JSONRPC_ERROR_MESSAGE: ()=>$281a441cdcb2cf36$var$SEMATTRS_RPC_JSONRPC_ERROR_MESSAGE,
    SEMATTRS_RPC_JSONRPC_REQUEST_ID: ()=>$281a441cdcb2cf36$var$SEMATTRS_RPC_JSONRPC_REQUEST_ID,
    SEMATTRS_RPC_JSONRPC_VERSION: ()=>$281a441cdcb2cf36$var$SEMATTRS_RPC_JSONRPC_VERSION,
    SEMATTRS_RPC_METHOD: ()=>$281a441cdcb2cf36$var$SEMATTRS_RPC_METHOD,
    SEMATTRS_RPC_SERVICE: ()=>$281a441cdcb2cf36$var$SEMATTRS_RPC_SERVICE,
    SEMATTRS_RPC_SYSTEM: ()=>$281a441cdcb2cf36$var$SEMATTRS_RPC_SYSTEM,
    SEMATTRS_THREAD_ID: ()=>$281a441cdcb2cf36$var$SEMATTRS_THREAD_ID,
    SEMATTRS_THREAD_NAME: ()=>$281a441cdcb2cf36$var$SEMATTRS_THREAD_NAME,
    SEMRESATTRS_AWS_ECS_CLUSTER_ARN: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_AWS_ECS_CLUSTER_ARN,
    SEMRESATTRS_AWS_ECS_CONTAINER_ARN: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_AWS_ECS_CONTAINER_ARN,
    SEMRESATTRS_AWS_ECS_LAUNCHTYPE: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_AWS_ECS_LAUNCHTYPE,
    SEMRESATTRS_AWS_ECS_TASK_ARN: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_AWS_ECS_TASK_ARN,
    SEMRESATTRS_AWS_ECS_TASK_FAMILY: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_AWS_ECS_TASK_FAMILY,
    SEMRESATTRS_AWS_ECS_TASK_REVISION: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_AWS_ECS_TASK_REVISION,
    SEMRESATTRS_AWS_EKS_CLUSTER_ARN: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_AWS_EKS_CLUSTER_ARN,
    SEMRESATTRS_AWS_LOG_GROUP_ARNS: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_AWS_LOG_GROUP_ARNS,
    SEMRESATTRS_AWS_LOG_GROUP_NAMES: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_AWS_LOG_GROUP_NAMES,
    SEMRESATTRS_AWS_LOG_STREAM_ARNS: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_AWS_LOG_STREAM_ARNS,
    SEMRESATTRS_AWS_LOG_STREAM_NAMES: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_AWS_LOG_STREAM_NAMES,
    SEMRESATTRS_CLOUD_ACCOUNT_ID: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_CLOUD_ACCOUNT_ID,
    SEMRESATTRS_CLOUD_AVAILABILITY_ZONE: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_CLOUD_AVAILABILITY_ZONE,
    SEMRESATTRS_CLOUD_PLATFORM: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_CLOUD_PLATFORM,
    SEMRESATTRS_CLOUD_PROVIDER: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_CLOUD_PROVIDER,
    SEMRESATTRS_CLOUD_REGION: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_CLOUD_REGION,
    SEMRESATTRS_CONTAINER_ID: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_CONTAINER_ID,
    SEMRESATTRS_CONTAINER_IMAGE_NAME: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_CONTAINER_IMAGE_NAME,
    SEMRESATTRS_CONTAINER_IMAGE_TAG: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_CONTAINER_IMAGE_TAG,
    SEMRESATTRS_CONTAINER_NAME: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_CONTAINER_NAME,
    SEMRESATTRS_CONTAINER_RUNTIME: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_CONTAINER_RUNTIME,
    SEMRESATTRS_DEPLOYMENT_ENVIRONMENT: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_DEPLOYMENT_ENVIRONMENT,
    SEMRESATTRS_DEVICE_ID: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_DEVICE_ID,
    SEMRESATTRS_DEVICE_MODEL_IDENTIFIER: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_DEVICE_MODEL_IDENTIFIER,
    SEMRESATTRS_DEVICE_MODEL_NAME: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_DEVICE_MODEL_NAME,
    SEMRESATTRS_FAAS_ID: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_FAAS_ID,
    SEMRESATTRS_FAAS_INSTANCE: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_FAAS_INSTANCE,
    SEMRESATTRS_FAAS_MAX_MEMORY: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_FAAS_MAX_MEMORY,
    SEMRESATTRS_FAAS_NAME: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_FAAS_NAME,
    SEMRESATTRS_FAAS_VERSION: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_FAAS_VERSION,
    SEMRESATTRS_HOST_ARCH: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_HOST_ARCH,
    SEMRESATTRS_HOST_ID: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_HOST_ID,
    SEMRESATTRS_HOST_IMAGE_ID: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_HOST_IMAGE_ID,
    SEMRESATTRS_HOST_IMAGE_NAME: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_HOST_IMAGE_NAME,
    SEMRESATTRS_HOST_IMAGE_VERSION: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_HOST_IMAGE_VERSION,
    SEMRESATTRS_HOST_NAME: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_HOST_NAME,
    SEMRESATTRS_HOST_TYPE: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_HOST_TYPE,
    SEMRESATTRS_K8S_CLUSTER_NAME: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_K8S_CLUSTER_NAME,
    SEMRESATTRS_K8S_CONTAINER_NAME: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_K8S_CONTAINER_NAME,
    SEMRESATTRS_K8S_CRONJOB_NAME: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_K8S_CRONJOB_NAME,
    SEMRESATTRS_K8S_CRONJOB_UID: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_K8S_CRONJOB_UID,
    SEMRESATTRS_K8S_DAEMONSET_NAME: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_K8S_DAEMONSET_NAME,
    SEMRESATTRS_K8S_DAEMONSET_UID: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_K8S_DAEMONSET_UID,
    SEMRESATTRS_K8S_DEPLOYMENT_NAME: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_K8S_DEPLOYMENT_NAME,
    SEMRESATTRS_K8S_DEPLOYMENT_UID: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_K8S_DEPLOYMENT_UID,
    SEMRESATTRS_K8S_JOB_NAME: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_K8S_JOB_NAME,
    SEMRESATTRS_K8S_JOB_UID: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_K8S_JOB_UID,
    SEMRESATTRS_K8S_NAMESPACE_NAME: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_K8S_NAMESPACE_NAME,
    SEMRESATTRS_K8S_NODE_NAME: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_K8S_NODE_NAME,
    SEMRESATTRS_K8S_NODE_UID: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_K8S_NODE_UID,
    SEMRESATTRS_K8S_POD_NAME: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_K8S_POD_NAME,
    SEMRESATTRS_K8S_POD_UID: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_K8S_POD_UID,
    SEMRESATTRS_K8S_REPLICASET_NAME: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_K8S_REPLICASET_NAME,
    SEMRESATTRS_K8S_REPLICASET_UID: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_K8S_REPLICASET_UID,
    SEMRESATTRS_K8S_STATEFULSET_NAME: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_K8S_STATEFULSET_NAME,
    SEMRESATTRS_K8S_STATEFULSET_UID: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_K8S_STATEFULSET_UID,
    SEMRESATTRS_OS_DESCRIPTION: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_OS_DESCRIPTION,
    SEMRESATTRS_OS_NAME: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_OS_NAME,
    SEMRESATTRS_OS_TYPE: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_OS_TYPE,
    SEMRESATTRS_OS_VERSION: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_OS_VERSION,
    SEMRESATTRS_PROCESS_COMMAND: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_PROCESS_COMMAND,
    SEMRESATTRS_PROCESS_COMMAND_ARGS: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_PROCESS_COMMAND_ARGS,
    SEMRESATTRS_PROCESS_COMMAND_LINE: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_PROCESS_COMMAND_LINE,
    SEMRESATTRS_PROCESS_EXECUTABLE_NAME: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_PROCESS_EXECUTABLE_NAME,
    SEMRESATTRS_PROCESS_EXECUTABLE_PATH: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_PROCESS_EXECUTABLE_PATH,
    SEMRESATTRS_PROCESS_OWNER: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_PROCESS_OWNER,
    SEMRESATTRS_PROCESS_PID: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_PROCESS_PID,
    SEMRESATTRS_PROCESS_RUNTIME_DESCRIPTION: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_PROCESS_RUNTIME_DESCRIPTION,
    SEMRESATTRS_PROCESS_RUNTIME_NAME: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_PROCESS_RUNTIME_NAME,
    SEMRESATTRS_PROCESS_RUNTIME_VERSION: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_PROCESS_RUNTIME_VERSION,
    SEMRESATTRS_SERVICE_INSTANCE_ID: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_SERVICE_INSTANCE_ID,
    SEMRESATTRS_SERVICE_NAME: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_SERVICE_NAME,
    SEMRESATTRS_SERVICE_NAMESPACE: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_SERVICE_NAMESPACE,
    SEMRESATTRS_SERVICE_VERSION: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_SERVICE_VERSION,
    SEMRESATTRS_TELEMETRY_AUTO_VERSION: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_TELEMETRY_AUTO_VERSION,
    SEMRESATTRS_TELEMETRY_SDK_LANGUAGE: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_TELEMETRY_SDK_LANGUAGE,
    SEMRESATTRS_TELEMETRY_SDK_NAME: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_TELEMETRY_SDK_NAME,
    SEMRESATTRS_TELEMETRY_SDK_VERSION: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_TELEMETRY_SDK_VERSION,
    SEMRESATTRS_WEBENGINE_DESCRIPTION: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_WEBENGINE_DESCRIPTION,
    SEMRESATTRS_WEBENGINE_NAME: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_WEBENGINE_NAME,
    SEMRESATTRS_WEBENGINE_VERSION: ()=>$281a441cdcb2cf36$var$SEMRESATTRS_WEBENGINE_VERSION,
    SIGNALR_CONNECTION_STATUS_VALUE_APP_SHUTDOWN: ()=>$281a441cdcb2cf36$var$SIGNALR_CONNECTION_STATUS_VALUE_APP_SHUTDOWN,
    SIGNALR_CONNECTION_STATUS_VALUE_NORMAL_CLOSURE: ()=>$281a441cdcb2cf36$var$SIGNALR_CONNECTION_STATUS_VALUE_NORMAL_CLOSURE,
    SIGNALR_CONNECTION_STATUS_VALUE_TIMEOUT: ()=>$281a441cdcb2cf36$var$SIGNALR_CONNECTION_STATUS_VALUE_TIMEOUT,
    SIGNALR_TRANSPORT_VALUE_LONG_POLLING: ()=>$281a441cdcb2cf36$var$SIGNALR_TRANSPORT_VALUE_LONG_POLLING,
    SIGNALR_TRANSPORT_VALUE_SERVER_SENT_EVENTS: ()=>$281a441cdcb2cf36$var$SIGNALR_TRANSPORT_VALUE_SERVER_SENT_EVENTS,
    SIGNALR_TRANSPORT_VALUE_WEB_SOCKETS: ()=>$281a441cdcb2cf36$var$SIGNALR_TRANSPORT_VALUE_WEB_SOCKETS,
    SemanticAttributes: ()=>$281a441cdcb2cf36$var$SemanticAttributes,
    SemanticResourceAttributes: ()=>$281a441cdcb2cf36$var$SemanticResourceAttributes,
    TELEMETRYSDKLANGUAGEVALUES_CPP: ()=>$281a441cdcb2cf36$var$TELEMETRYSDKLANGUAGEVALUES_CPP,
    TELEMETRYSDKLANGUAGEVALUES_DOTNET: ()=>$281a441cdcb2cf36$var$TELEMETRYSDKLANGUAGEVALUES_DOTNET,
    TELEMETRYSDKLANGUAGEVALUES_ERLANG: ()=>$281a441cdcb2cf36$var$TELEMETRYSDKLANGUAGEVALUES_ERLANG,
    TELEMETRYSDKLANGUAGEVALUES_GO: ()=>$281a441cdcb2cf36$var$TELEMETRYSDKLANGUAGEVALUES_GO,
    TELEMETRYSDKLANGUAGEVALUES_JAVA: ()=>$281a441cdcb2cf36$var$TELEMETRYSDKLANGUAGEVALUES_JAVA,
    TELEMETRYSDKLANGUAGEVALUES_NODEJS: ()=>$281a441cdcb2cf36$var$TELEMETRYSDKLANGUAGEVALUES_NODEJS,
    TELEMETRYSDKLANGUAGEVALUES_PHP: ()=>$281a441cdcb2cf36$var$TELEMETRYSDKLANGUAGEVALUES_PHP,
    TELEMETRYSDKLANGUAGEVALUES_PYTHON: ()=>$281a441cdcb2cf36$var$TELEMETRYSDKLANGUAGEVALUES_PYTHON,
    TELEMETRYSDKLANGUAGEVALUES_RUBY: ()=>$281a441cdcb2cf36$var$TELEMETRYSDKLANGUAGEVALUES_RUBY,
    TELEMETRYSDKLANGUAGEVALUES_WEBJS: ()=>$281a441cdcb2cf36$var$TELEMETRYSDKLANGUAGEVALUES_WEBJS,
    TELEMETRY_SDK_LANGUAGE_VALUE_CPP: ()=>$281a441cdcb2cf36$var$TELEMETRY_SDK_LANGUAGE_VALUE_CPP,
    TELEMETRY_SDK_LANGUAGE_VALUE_DOTNET: ()=>$281a441cdcb2cf36$var$TELEMETRY_SDK_LANGUAGE_VALUE_DOTNET,
    TELEMETRY_SDK_LANGUAGE_VALUE_ERLANG: ()=>$281a441cdcb2cf36$var$TELEMETRY_SDK_LANGUAGE_VALUE_ERLANG,
    TELEMETRY_SDK_LANGUAGE_VALUE_GO: ()=>$281a441cdcb2cf36$var$TELEMETRY_SDK_LANGUAGE_VALUE_GO,
    TELEMETRY_SDK_LANGUAGE_VALUE_JAVA: ()=>$281a441cdcb2cf36$var$TELEMETRY_SDK_LANGUAGE_VALUE_JAVA,
    TELEMETRY_SDK_LANGUAGE_VALUE_NODEJS: ()=>$281a441cdcb2cf36$var$TELEMETRY_SDK_LANGUAGE_VALUE_NODEJS,
    TELEMETRY_SDK_LANGUAGE_VALUE_PHP: ()=>$281a441cdcb2cf36$var$TELEMETRY_SDK_LANGUAGE_VALUE_PHP,
    TELEMETRY_SDK_LANGUAGE_VALUE_PYTHON: ()=>$281a441cdcb2cf36$var$TELEMETRY_SDK_LANGUAGE_VALUE_PYTHON,
    TELEMETRY_SDK_LANGUAGE_VALUE_RUBY: ()=>$281a441cdcb2cf36$var$TELEMETRY_SDK_LANGUAGE_VALUE_RUBY,
    TELEMETRY_SDK_LANGUAGE_VALUE_RUST: ()=>$281a441cdcb2cf36$var$TELEMETRY_SDK_LANGUAGE_VALUE_RUST,
    TELEMETRY_SDK_LANGUAGE_VALUE_SWIFT: ()=>$281a441cdcb2cf36$var$TELEMETRY_SDK_LANGUAGE_VALUE_SWIFT,
    TELEMETRY_SDK_LANGUAGE_VALUE_WEBJS: ()=>$281a441cdcb2cf36$var$TELEMETRY_SDK_LANGUAGE_VALUE_WEBJS,
    TelemetrySdkLanguageValues: ()=>$281a441cdcb2cf36$var$TelemetrySdkLanguageValues
});
var $281a441cdcb2cf36$var$init_esm2 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/semantic-conventions/build/esm/index.js" () {
        $281a441cdcb2cf36$var$init_trace2();
        $281a441cdcb2cf36$var$init_resource();
        $281a441cdcb2cf36$var$init_stable_attributes();
        $281a441cdcb2cf36$var$init_stable_metrics();
        $281a441cdcb2cf36$var$init_stable_events();
    }
});
// ../node_modules/@opentelemetry/core/build/esm/semconv.js
var $281a441cdcb2cf36$var$ATTR_PROCESS_RUNTIME_NAME;
var $281a441cdcb2cf36$var$init_semconv = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/core/build/esm/semconv.js" () {
        $281a441cdcb2cf36$var$ATTR_PROCESS_RUNTIME_NAME = "process.runtime.name";
    }
});
// ../node_modules/@opentelemetry/core/build/esm/platform/browser/sdk-info.js
var $281a441cdcb2cf36$var$SDK_INFO;
var $281a441cdcb2cf36$var$init_sdk_info = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/core/build/esm/platform/browser/sdk-info.js" () {
        $281a441cdcb2cf36$var$init_version2();
        $281a441cdcb2cf36$var$init_esm2();
        $281a441cdcb2cf36$var$init_semconv();
        $281a441cdcb2cf36$var$SDK_INFO = {
            [$281a441cdcb2cf36$var$ATTR_TELEMETRY_SDK_NAME]: "opentelemetry",
            [$281a441cdcb2cf36$var$ATTR_PROCESS_RUNTIME_NAME]: "browser",
            [$281a441cdcb2cf36$var$ATTR_TELEMETRY_SDK_LANGUAGE]: $281a441cdcb2cf36$var$TELEMETRY_SDK_LANGUAGE_VALUE_WEBJS,
            [$281a441cdcb2cf36$var$ATTR_TELEMETRY_SDK_VERSION]: $281a441cdcb2cf36$var$VERSION2
        };
    }
});
// ../node_modules/@opentelemetry/core/build/esm/platform/browser/index.js
var $281a441cdcb2cf36$var$otperformance;
var $281a441cdcb2cf36$var$init_browser = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/core/build/esm/platform/browser/index.js" () {
        $281a441cdcb2cf36$var$init_environment2();
        $281a441cdcb2cf36$var$init_sdk_info();
        $281a441cdcb2cf36$var$otperformance = performance;
    }
});
// ../node_modules/@opentelemetry/core/build/esm/common/time.js
function $281a441cdcb2cf36$var$millisToHrTime(epochMillis) {
    const epochSeconds = epochMillis / 1e3;
    const seconds = Math.trunc(epochSeconds);
    const nanos = Math.round(epochMillis % 1e3 * $281a441cdcb2cf36$var$MILLISECONDS_TO_NANOSECONDS);
    return [
        seconds,
        nanos
    ];
}
function $281a441cdcb2cf36$var$hrTime(performanceNow) {
    const timeOrigin = $281a441cdcb2cf36$var$millisToHrTime($281a441cdcb2cf36$var$otperformance.timeOrigin);
    const now = $281a441cdcb2cf36$var$millisToHrTime(typeof performanceNow === "number" ? performanceNow : $281a441cdcb2cf36$var$otperformance.now());
    return $281a441cdcb2cf36$var$addHrTimes(timeOrigin, now);
}
function $281a441cdcb2cf36$var$hrTimeDuration(startTime, endTime) {
    let seconds = endTime[0] - startTime[0];
    let nanos = endTime[1] - startTime[1];
    if (nanos < 0) {
        seconds -= 1;
        nanos += $281a441cdcb2cf36$var$SECOND_TO_NANOSECONDS;
    }
    return [
        seconds,
        nanos
    ];
}
function $281a441cdcb2cf36$var$isTimeInputHrTime(value2) {
    return Array.isArray(value2) && value2.length === 2 && typeof value2[0] === "number" && typeof value2[1] === "number";
}
function $281a441cdcb2cf36$var$isTimeInput(value2) {
    return $281a441cdcb2cf36$var$isTimeInputHrTime(value2) || typeof value2 === "number" || value2 instanceof Date;
}
function $281a441cdcb2cf36$var$addHrTimes(time1, time2) {
    const out = [
        time1[0] + time2[0],
        time1[1] + time2[1]
    ];
    if (out[1] >= $281a441cdcb2cf36$var$SECOND_TO_NANOSECONDS) {
        out[1] -= $281a441cdcb2cf36$var$SECOND_TO_NANOSECONDS;
        out[0] += 1;
    }
    return out;
}
var $281a441cdcb2cf36$var$NANOSECOND_DIGITS, $281a441cdcb2cf36$var$NANOSECOND_DIGITS_IN_MILLIS, $281a441cdcb2cf36$var$MILLISECONDS_TO_NANOSECONDS, $281a441cdcb2cf36$var$SECOND_TO_NANOSECONDS;
var $281a441cdcb2cf36$var$init_time2 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/core/build/esm/common/time.js" () {
        $281a441cdcb2cf36$var$init_browser();
        $281a441cdcb2cf36$var$NANOSECOND_DIGITS = 9;
        $281a441cdcb2cf36$var$NANOSECOND_DIGITS_IN_MILLIS = 6;
        $281a441cdcb2cf36$var$MILLISECONDS_TO_NANOSECONDS = Math.pow(10, $281a441cdcb2cf36$var$NANOSECOND_DIGITS_IN_MILLIS);
        $281a441cdcb2cf36$var$SECOND_TO_NANOSECONDS = Math.pow(10, $281a441cdcb2cf36$var$NANOSECOND_DIGITS);
    }
});
// ../node_modules/@opentelemetry/core/build/esm/ExportResult.js
var $281a441cdcb2cf36$var$ExportResultCode;
var $281a441cdcb2cf36$var$init_ExportResult = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/core/build/esm/ExportResult.js" () {
        (function(ExportResultCode2) {
            ExportResultCode2[ExportResultCode2["SUCCESS"] = 0] = "SUCCESS";
            ExportResultCode2[ExportResultCode2["FAILED"] = 1] = "FAILED";
        })($281a441cdcb2cf36$var$ExportResultCode || ($281a441cdcb2cf36$var$ExportResultCode = {}));
    }
});
// ../node_modules/@opentelemetry/core/build/esm/propagation/composite.js
var $281a441cdcb2cf36$var$CompositePropagator;
var $281a441cdcb2cf36$var$init_composite = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/core/build/esm/propagation/composite.js" () {
        $281a441cdcb2cf36$var$init_esm();
        $281a441cdcb2cf36$var$CompositePropagator = class {
            /**
       * Construct a composite propagator from a list of propagators.
       *
       * @param [config] Configuration object for composite propagator
       */ constructor(config = {}){
                $281a441cdcb2cf36$var$__publicField(this, "_propagators");
                $281a441cdcb2cf36$var$__publicField(this, "_fields");
                var _a2;
                this._propagators = (_a2 = config.propagators) != null ? _a2 : [];
                this._fields = Array.from(new Set(this._propagators.map((p3)=>typeof p3.fields === "function" ? p3.fields() : []).reduce((x3, y3)=>x3.concat(y3), [])));
            }
            /**
       * Run each of the configured propagators with the given context and carrier.
       * Propagators are run in the order they are configured, so if multiple
       * propagators write the same carrier key, the propagator later in the list
       * will "win".
       *
       * @param context Context to inject
       * @param carrier Carrier into which context will be injected
       */ inject(context2, carrier, setter) {
                for (const propagator of this._propagators)try {
                    propagator.inject(context2, carrier, setter);
                } catch (err) {
                    $281a441cdcb2cf36$var$diag2.warn(`Failed to inject with ${propagator.constructor.name}. Err: ${err.message}`);
                }
            }
            /**
       * Run each of the configured propagators with the given context and carrier.
       * Propagators are run in the order they are configured, so if multiple
       * propagators write the same context key, the propagator later in the list
       * will "win".
       *
       * @param context Context to add values to
       * @param carrier Carrier from which to extract context
       */ extract(context2, carrier, getter) {
                return this._propagators.reduce((ctx, propagator)=>{
                    try {
                        return propagator.extract(ctx, carrier, getter);
                    } catch (err) {
                        $281a441cdcb2cf36$var$diag2.warn(`Failed to extract with ${propagator.constructor.name}. Err: ${err.message}`);
                    }
                    return ctx;
                }, context2);
            }
            fields() {
                return this._fields.slice();
            }
        };
    }
});
// ../node_modules/@opentelemetry/core/build/esm/internal/validators.js
function $281a441cdcb2cf36$var$validateKey2(key) {
    return $281a441cdcb2cf36$var$VALID_KEY_REGEX2.test(key);
}
function $281a441cdcb2cf36$var$validateValue2(value2) {
    return $281a441cdcb2cf36$var$VALID_VALUE_BASE_REGEX2.test(value2) && !$281a441cdcb2cf36$var$INVALID_VALUE_COMMA_EQUAL_REGEX2.test(value2);
}
var $281a441cdcb2cf36$var$VALID_KEY_CHAR_RANGE2, $281a441cdcb2cf36$var$VALID_KEY2, $281a441cdcb2cf36$var$VALID_VENDOR_KEY2, $281a441cdcb2cf36$var$VALID_KEY_REGEX2, $281a441cdcb2cf36$var$VALID_VALUE_BASE_REGEX2, $281a441cdcb2cf36$var$INVALID_VALUE_COMMA_EQUAL_REGEX2;
var $281a441cdcb2cf36$var$init_validators = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/core/build/esm/internal/validators.js" () {
        $281a441cdcb2cf36$var$VALID_KEY_CHAR_RANGE2 = "[_0-9a-z-*/]";
        $281a441cdcb2cf36$var$VALID_KEY2 = `[a-z]${$281a441cdcb2cf36$var$VALID_KEY_CHAR_RANGE2}{0,255}`;
        $281a441cdcb2cf36$var$VALID_VENDOR_KEY2 = `[a-z0-9]${$281a441cdcb2cf36$var$VALID_KEY_CHAR_RANGE2}{0,240}@[a-z]${$281a441cdcb2cf36$var$VALID_KEY_CHAR_RANGE2}{0,13}`;
        $281a441cdcb2cf36$var$VALID_KEY_REGEX2 = new RegExp(`^(?:${$281a441cdcb2cf36$var$VALID_KEY2}|${$281a441cdcb2cf36$var$VALID_VENDOR_KEY2})$`);
        $281a441cdcb2cf36$var$VALID_VALUE_BASE_REGEX2 = /^[ -~]{0,255}[!-~]$/;
        $281a441cdcb2cf36$var$INVALID_VALUE_COMMA_EQUAL_REGEX2 = /,|=/;
    }
});
// ../node_modules/@opentelemetry/core/build/esm/trace/TraceState.js
var $281a441cdcb2cf36$var$MAX_TRACE_STATE_ITEMS2, $281a441cdcb2cf36$var$MAX_TRACE_STATE_LEN2, $281a441cdcb2cf36$var$LIST_MEMBERS_SEPARATOR2, $281a441cdcb2cf36$var$LIST_MEMBER_KEY_VALUE_SPLITTER2, $281a441cdcb2cf36$var$TraceState;
var $281a441cdcb2cf36$var$init_TraceState = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/core/build/esm/trace/TraceState.js" () {
        $281a441cdcb2cf36$var$init_validators();
        $281a441cdcb2cf36$var$MAX_TRACE_STATE_ITEMS2 = 32;
        $281a441cdcb2cf36$var$MAX_TRACE_STATE_LEN2 = 512;
        $281a441cdcb2cf36$var$LIST_MEMBERS_SEPARATOR2 = ",";
        $281a441cdcb2cf36$var$LIST_MEMBER_KEY_VALUE_SPLITTER2 = "=";
        $281a441cdcb2cf36$var$TraceState = class _TraceState {
            constructor(rawTraceState){
                $281a441cdcb2cf36$var$__publicField(this, "_internalState", /* @__PURE__ */ new Map());
                if (rawTraceState) this._parse(rawTraceState);
            }
            set(key, value2) {
                const traceState = this._clone();
                if (traceState._internalState.has(key)) traceState._internalState.delete(key);
                traceState._internalState.set(key, value2);
                return traceState;
            }
            unset(key) {
                const traceState = this._clone();
                traceState._internalState.delete(key);
                return traceState;
            }
            get(key) {
                return this._internalState.get(key);
            }
            serialize() {
                return this._keys().reduce((agg, key)=>{
                    agg.push(key + $281a441cdcb2cf36$var$LIST_MEMBER_KEY_VALUE_SPLITTER2 + this.get(key));
                    return agg;
                }, []).join($281a441cdcb2cf36$var$LIST_MEMBERS_SEPARATOR2);
            }
            _parse(rawTraceState) {
                if (rawTraceState.length > $281a441cdcb2cf36$var$MAX_TRACE_STATE_LEN2) return;
                this._internalState = rawTraceState.split($281a441cdcb2cf36$var$LIST_MEMBERS_SEPARATOR2).reverse().reduce((agg, part)=>{
                    const listMember = part.trim();
                    const i3 = listMember.indexOf($281a441cdcb2cf36$var$LIST_MEMBER_KEY_VALUE_SPLITTER2);
                    if (i3 !== -1) {
                        const key = listMember.slice(0, i3);
                        const value2 = listMember.slice(i3 + 1, part.length);
                        if ($281a441cdcb2cf36$var$validateKey2(key) && $281a441cdcb2cf36$var$validateValue2(value2)) agg.set(key, value2);
                    }
                    return agg;
                }, /* @__PURE__ */ new Map());
                if (this._internalState.size > $281a441cdcb2cf36$var$MAX_TRACE_STATE_ITEMS2) this._internalState = new Map(Array.from(this._internalState.entries()).reverse().slice(0, $281a441cdcb2cf36$var$MAX_TRACE_STATE_ITEMS2));
            }
            _keys() {
                return Array.from(this._internalState.keys()).reverse();
            }
            _clone() {
                const traceState = new _TraceState();
                traceState._internalState = new Map(this._internalState);
                return traceState;
            }
        };
    }
});
// ../node_modules/@opentelemetry/core/build/esm/trace/W3CTraceContextPropagator.js
function $281a441cdcb2cf36$var$parseTraceParent(traceParent) {
    const match2 = $281a441cdcb2cf36$var$TRACE_PARENT_REGEX.exec(traceParent);
    if (!match2) return null;
    if (match2[1] === "00" && match2[5]) return null;
    return {
        traceId: match2[2],
        spanId: match2[3],
        traceFlags: parseInt(match2[4], 16)
    };
}
var $281a441cdcb2cf36$var$TRACE_PARENT_HEADER, $281a441cdcb2cf36$var$TRACE_STATE_HEADER, $281a441cdcb2cf36$var$VERSION3, $281a441cdcb2cf36$var$VERSION_PART, $281a441cdcb2cf36$var$TRACE_ID_PART, $281a441cdcb2cf36$var$PARENT_ID_PART, $281a441cdcb2cf36$var$FLAGS_PART, $281a441cdcb2cf36$var$TRACE_PARENT_REGEX, $281a441cdcb2cf36$var$W3CTraceContextPropagator;
var $281a441cdcb2cf36$var$init_W3CTraceContextPropagator = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/core/build/esm/trace/W3CTraceContextPropagator.js" () {
        $281a441cdcb2cf36$var$init_esm();
        $281a441cdcb2cf36$var$init_suppress_tracing();
        $281a441cdcb2cf36$var$init_TraceState();
        $281a441cdcb2cf36$var$TRACE_PARENT_HEADER = "traceparent";
        $281a441cdcb2cf36$var$TRACE_STATE_HEADER = "tracestate";
        $281a441cdcb2cf36$var$VERSION3 = "00";
        $281a441cdcb2cf36$var$VERSION_PART = "(?!ff)[\\da-f]{2}";
        $281a441cdcb2cf36$var$TRACE_ID_PART = "(?![0]{32})[\\da-f]{32}";
        $281a441cdcb2cf36$var$PARENT_ID_PART = "(?![0]{16})[\\da-f]{16}";
        $281a441cdcb2cf36$var$FLAGS_PART = "[\\da-f]{2}";
        $281a441cdcb2cf36$var$TRACE_PARENT_REGEX = new RegExp(`^\\s?(${$281a441cdcb2cf36$var$VERSION_PART})-(${$281a441cdcb2cf36$var$TRACE_ID_PART})-(${$281a441cdcb2cf36$var$PARENT_ID_PART})-(${$281a441cdcb2cf36$var$FLAGS_PART})(-.*)?\\s?$`);
        $281a441cdcb2cf36$var$W3CTraceContextPropagator = class {
            inject(context2, carrier, setter) {
                const spanContext = $281a441cdcb2cf36$var$trace.getSpanContext(context2);
                if (!spanContext || $281a441cdcb2cf36$var$isTracingSuppressed(context2) || !$281a441cdcb2cf36$var$isSpanContextValid(spanContext)) return;
                const traceParent = `${$281a441cdcb2cf36$var$VERSION3}-${spanContext.traceId}-${spanContext.spanId}-0${Number(spanContext.traceFlags || $281a441cdcb2cf36$var$TraceFlags.NONE).toString(16)}`;
                setter.set(carrier, $281a441cdcb2cf36$var$TRACE_PARENT_HEADER, traceParent);
                if (spanContext.traceState) setter.set(carrier, $281a441cdcb2cf36$var$TRACE_STATE_HEADER, spanContext.traceState.serialize());
            }
            extract(context2, carrier, getter) {
                const traceParentHeader = getter.get(carrier, $281a441cdcb2cf36$var$TRACE_PARENT_HEADER);
                if (!traceParentHeader) return context2;
                const traceParent = Array.isArray(traceParentHeader) ? traceParentHeader[0] : traceParentHeader;
                if (typeof traceParent !== "string") return context2;
                const spanContext = $281a441cdcb2cf36$var$parseTraceParent(traceParent);
                if (!spanContext) return context2;
                spanContext.isRemote = true;
                const traceStateHeader = getter.get(carrier, $281a441cdcb2cf36$var$TRACE_STATE_HEADER);
                if (traceStateHeader) {
                    const state = Array.isArray(traceStateHeader) ? traceStateHeader.join(",") : traceStateHeader;
                    spanContext.traceState = new $281a441cdcb2cf36$var$TraceState(typeof state === "string" ? state : void 0);
                }
                return $281a441cdcb2cf36$var$trace.setSpanContext(context2, spanContext);
            }
            fields() {
                return [
                    $281a441cdcb2cf36$var$TRACE_PARENT_HEADER,
                    $281a441cdcb2cf36$var$TRACE_STATE_HEADER
                ];
            }
        };
    }
});
// ../node_modules/@opentelemetry/core/build/esm/utils/lodash.merge.js
function $281a441cdcb2cf36$var$isPlainObject3(value2) {
    if (!$281a441cdcb2cf36$var$isObjectLike2(value2) || $281a441cdcb2cf36$var$baseGetTag(value2) !== $281a441cdcb2cf36$var$objectTag) return false;
    const proto = $281a441cdcb2cf36$var$getPrototypeOf(value2);
    if (proto === null) return true;
    const Ctor = $281a441cdcb2cf36$var$hasOwnProperty2.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $281a441cdcb2cf36$var$funcToString.call(Ctor) === $281a441cdcb2cf36$var$objectCtorString;
}
function $281a441cdcb2cf36$var$isObjectLike2(value2) {
    return value2 != null && typeof value2 == "object";
}
function $281a441cdcb2cf36$var$baseGetTag(value2) {
    if (value2 == null) return value2 === void 0 ? $281a441cdcb2cf36$var$undefinedTag : $281a441cdcb2cf36$var$nullTag;
    return $281a441cdcb2cf36$var$symToStringTag && $281a441cdcb2cf36$var$symToStringTag in Object(value2) ? $281a441cdcb2cf36$var$getRawTag(value2) : $281a441cdcb2cf36$var$objectToString(value2);
}
function $281a441cdcb2cf36$var$getRawTag(value2) {
    const isOwn = $281a441cdcb2cf36$var$hasOwnProperty2.call(value2, $281a441cdcb2cf36$var$symToStringTag), tag = value2[$281a441cdcb2cf36$var$symToStringTag];
    let unmasked = false;
    try {
        value2[$281a441cdcb2cf36$var$symToStringTag] = void 0;
        unmasked = true;
    } catch  {}
    const result = $281a441cdcb2cf36$var$nativeObjectToString.call(value2);
    if (unmasked) {
        if (isOwn) value2[$281a441cdcb2cf36$var$symToStringTag] = tag;
        else delete value2[$281a441cdcb2cf36$var$symToStringTag];
    }
    return result;
}
function $281a441cdcb2cf36$var$objectToString(value2) {
    return $281a441cdcb2cf36$var$nativeObjectToString.call(value2);
}
var $281a441cdcb2cf36$var$objectTag, $281a441cdcb2cf36$var$nullTag, $281a441cdcb2cf36$var$undefinedTag, $281a441cdcb2cf36$var$funcProto, $281a441cdcb2cf36$var$funcToString, $281a441cdcb2cf36$var$objectCtorString, $281a441cdcb2cf36$var$getPrototypeOf, $281a441cdcb2cf36$var$objectProto, $281a441cdcb2cf36$var$hasOwnProperty2, $281a441cdcb2cf36$var$symToStringTag, $281a441cdcb2cf36$var$nativeObjectToString;
var $281a441cdcb2cf36$var$init_lodash_merge = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/core/build/esm/utils/lodash.merge.js" () {
        $281a441cdcb2cf36$var$objectTag = "[object Object]";
        $281a441cdcb2cf36$var$nullTag = "[object Null]";
        $281a441cdcb2cf36$var$undefinedTag = "[object Undefined]";
        $281a441cdcb2cf36$var$funcProto = Function.prototype;
        $281a441cdcb2cf36$var$funcToString = $281a441cdcb2cf36$var$funcProto.toString;
        $281a441cdcb2cf36$var$objectCtorString = $281a441cdcb2cf36$var$funcToString.call(Object);
        $281a441cdcb2cf36$var$getPrototypeOf = Object.getPrototypeOf;
        $281a441cdcb2cf36$var$objectProto = Object.prototype;
        $281a441cdcb2cf36$var$hasOwnProperty2 = $281a441cdcb2cf36$var$objectProto.hasOwnProperty;
        $281a441cdcb2cf36$var$symToStringTag = Symbol ? Symbol.toStringTag : void 0;
        $281a441cdcb2cf36$var$nativeObjectToString = $281a441cdcb2cf36$var$objectProto.toString;
    }
});
// ../node_modules/@opentelemetry/core/build/esm/utils/merge.js
function $281a441cdcb2cf36$var$merge(...args2) {
    let result = args2.shift();
    const objects = /* @__PURE__ */ new WeakMap();
    while(args2.length > 0)result = $281a441cdcb2cf36$var$mergeTwoObjects(result, args2.shift(), 0, objects);
    return result;
}
function $281a441cdcb2cf36$var$takeValue(value2) {
    if ($281a441cdcb2cf36$var$isArray3(value2)) return value2.slice();
    return value2;
}
function $281a441cdcb2cf36$var$mergeTwoObjects(one, two, level = 0, objects) {
    let result;
    if (level > $281a441cdcb2cf36$var$MAX_LEVEL) return void 0;
    level++;
    if ($281a441cdcb2cf36$var$isPrimitive(one) || $281a441cdcb2cf36$var$isPrimitive(two) || $281a441cdcb2cf36$var$isFunction2(two)) result = $281a441cdcb2cf36$var$takeValue(two);
    else if ($281a441cdcb2cf36$var$isArray3(one)) {
        result = one.slice();
        if ($281a441cdcb2cf36$var$isArray3(two)) for(let i3 = 0, j3 = two.length; i3 < j3; i3++)result.push($281a441cdcb2cf36$var$takeValue(two[i3]));
        else if ($281a441cdcb2cf36$var$isObject3(two)) {
            const keys2 = Object.keys(two);
            for(let i3 = 0, j3 = keys2.length; i3 < j3; i3++){
                const key = keys2[i3];
                if (key === "__proto__" || key === "constructor" || key === "prototype") continue;
                result[key] = $281a441cdcb2cf36$var$takeValue(two[key]);
            }
        }
    } else if ($281a441cdcb2cf36$var$isObject3(one)) {
        if ($281a441cdcb2cf36$var$isObject3(two)) {
            if (!$281a441cdcb2cf36$var$shouldMerge(one, two)) return two;
            result = Object.assign({}, one);
            const keys2 = Object.keys(two);
            for(let i3 = 0, j3 = keys2.length; i3 < j3; i3++){
                const key = keys2[i3];
                if (key === "__proto__" || key === "constructor" || key === "prototype") continue;
                const twoValue = two[key];
                if ($281a441cdcb2cf36$var$isPrimitive(twoValue)) {
                    if (typeof twoValue === "undefined") delete result[key];
                    else result[key] = twoValue;
                } else {
                    const obj1 = result[key];
                    const obj2 = twoValue;
                    if ($281a441cdcb2cf36$var$wasObjectReferenced(one, key, objects) || $281a441cdcb2cf36$var$wasObjectReferenced(two, key, objects)) delete result[key];
                    else {
                        if ($281a441cdcb2cf36$var$isObject3(obj1) && $281a441cdcb2cf36$var$isObject3(obj2)) {
                            const arr1 = objects.get(obj1) || [];
                            const arr2 = objects.get(obj2) || [];
                            arr1.push({
                                obj: one,
                                key: key
                            });
                            arr2.push({
                                obj: two,
                                key: key
                            });
                            objects.set(obj1, arr1);
                            objects.set(obj2, arr2);
                        }
                        result[key] = $281a441cdcb2cf36$var$mergeTwoObjects(result[key], twoValue, level, objects);
                    }
                }
            }
        } else result = two;
    }
    return result;
}
function $281a441cdcb2cf36$var$wasObjectReferenced(obj, key, objects) {
    const arr = objects.get(obj[key]) || [];
    for(let i3 = 0, j3 = arr.length; i3 < j3; i3++){
        const info = arr[i3];
        if (info.key === key && info.obj === obj) return true;
    }
    return false;
}
function $281a441cdcb2cf36$var$isArray3(value2) {
    return Array.isArray(value2);
}
function $281a441cdcb2cf36$var$isFunction2(value2) {
    return typeof value2 === "function";
}
function $281a441cdcb2cf36$var$isObject3(value2) {
    return !$281a441cdcb2cf36$var$isPrimitive(value2) && !$281a441cdcb2cf36$var$isArray3(value2) && !$281a441cdcb2cf36$var$isFunction2(value2) && typeof value2 === "object";
}
function $281a441cdcb2cf36$var$isPrimitive(value2) {
    return typeof value2 === "string" || typeof value2 === "number" || typeof value2 === "boolean" || typeof value2 === "undefined" || value2 instanceof Date || value2 instanceof RegExp || value2 === null;
}
function $281a441cdcb2cf36$var$shouldMerge(one, two) {
    if (!$281a441cdcb2cf36$var$isPlainObject3(one) || !$281a441cdcb2cf36$var$isPlainObject3(two)) return false;
    return true;
}
var $281a441cdcb2cf36$var$MAX_LEVEL;
var $281a441cdcb2cf36$var$init_merge = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/core/build/esm/utils/merge.js" () {
        $281a441cdcb2cf36$var$init_lodash_merge();
        $281a441cdcb2cf36$var$MAX_LEVEL = 20;
    }
});
// ../node_modules/@opentelemetry/core/build/esm/utils/promise.js
var $281a441cdcb2cf36$var$Deferred;
var $281a441cdcb2cf36$var$init_promise2 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/core/build/esm/utils/promise.js" () {
        $281a441cdcb2cf36$var$Deferred = class {
            constructor(){
                $281a441cdcb2cf36$var$__publicField(this, "_promise");
                $281a441cdcb2cf36$var$__publicField(this, "_resolve");
                $281a441cdcb2cf36$var$__publicField(this, "_reject");
                this._promise = new Promise((resolve, reject)=>{
                    this._resolve = resolve;
                    this._reject = reject;
                });
            }
            get promise() {
                return this._promise;
            }
            resolve(val) {
                this._resolve(val);
            }
            reject(err) {
                this._reject(err);
            }
        };
    }
});
// ../node_modules/@opentelemetry/core/build/esm/utils/callback.js
var $281a441cdcb2cf36$var$BindOnceFuture;
var $281a441cdcb2cf36$var$init_callback = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/core/build/esm/utils/callback.js" () {
        $281a441cdcb2cf36$var$init_promise2();
        $281a441cdcb2cf36$var$BindOnceFuture = class {
            constructor(callback, that){
                $281a441cdcb2cf36$var$__publicField(this, "_isCalled", false);
                $281a441cdcb2cf36$var$__publicField(this, "_deferred", new $281a441cdcb2cf36$var$Deferred());
                $281a441cdcb2cf36$var$__publicField(this, "_callback");
                $281a441cdcb2cf36$var$__publicField(this, "_that");
                this._callback = callback;
                this._that = that;
            }
            get isCalled() {
                return this._isCalled;
            }
            get promise() {
                return this._deferred.promise;
            }
            call(...args2) {
                if (!this._isCalled) {
                    this._isCalled = true;
                    try {
                        Promise.resolve(this._callback.call(this._that, ...args2)).then((val)=>this._deferred.resolve(val), (err)=>this._deferred.reject(err));
                    } catch (err) {
                        this._deferred.reject(err);
                    }
                }
                return this._deferred.promise;
            }
        };
    }
});
// ../node_modules/@opentelemetry/core/build/esm/index.js
var $281a441cdcb2cf36$var$init_esm3 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/core/build/esm/index.js" () {
        $281a441cdcb2cf36$var$init_W3CBaggagePropagator();
        $281a441cdcb2cf36$var$init_attributes();
        $281a441cdcb2cf36$var$init_global_error_handler();
        $281a441cdcb2cf36$var$init_time2();
        $281a441cdcb2cf36$var$init_ExportResult();
        $281a441cdcb2cf36$var$init_browser();
        $281a441cdcb2cf36$var$init_composite();
        $281a441cdcb2cf36$var$init_W3CTraceContextPropagator();
        $281a441cdcb2cf36$var$init_suppress_tracing();
        $281a441cdcb2cf36$var$init_merge();
        $281a441cdcb2cf36$var$init_callback();
    }
});
// ../node_modules/@opentelemetry/otlp-transformer/build/src/common/internal.js
var $281a441cdcb2cf36$var$require_internal = $281a441cdcb2cf36$var$__commonJS({
    "../node_modules/@opentelemetry/otlp-transformer/build/src/common/internal.js" (exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.toAnyValue = exports.toKeyValue = exports.toAttributes = exports.createInstrumentationScope = exports.createResource = void 0;
        function createResource(resource) {
            return {
                attributes: toAttributes(resource.attributes),
                droppedAttributesCount: 0
            };
        }
        exports.createResource = createResource;
        function createInstrumentationScope(scope) {
            return {
                name: scope.name,
                version: scope.version
            };
        }
        exports.createInstrumentationScope = createInstrumentationScope;
        function toAttributes(attributes) {
            return Object.keys(attributes).map((key)=>toKeyValue(key, attributes[key]));
        }
        exports.toAttributes = toAttributes;
        function toKeyValue(key, value2) {
            return {
                key: key,
                value: toAnyValue(value2)
            };
        }
        exports.toKeyValue = toKeyValue;
        function toAnyValue(value2) {
            const t4 = typeof value2;
            if (t4 === "string") return {
                stringValue: value2
            };
            if (t4 === "number") {
                if (!Number.isInteger(value2)) return {
                    doubleValue: value2
                };
                return {
                    intValue: value2
                };
            }
            if (t4 === "boolean") return {
                boolValue: value2
            };
            if (value2 instanceof Uint8Array) return {
                bytesValue: value2
            };
            if (Array.isArray(value2)) return {
                arrayValue: {
                    values: value2.map(toAnyValue)
                }
            };
            if (t4 === "object" && value2 != null) return {
                kvlistValue: {
                    values: Object.entries(value2).map(([k3, v3])=>toKeyValue(k3, v3))
                }
            };
            return {};
        }
        exports.toAnyValue = toAnyValue;
    }
});
// ../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/trace/suppress-tracing.js
var $281a441cdcb2cf36$var$require_suppress_tracing = $281a441cdcb2cf36$var$__commonJS({
    "../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/trace/suppress-tracing.js" (exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.isTracingSuppressed = exports.unsuppressTracing = exports.suppressTracing = void 0;
        var api_1 = ($281a441cdcb2cf36$var$init_esm(), $281a441cdcb2cf36$var$__toCommonJS($281a441cdcb2cf36$var$esm_exports2));
        var SUPPRESS_TRACING_KEY2 = (0, api_1.createContextKey)("OpenTelemetry SDK Context Key SUPPRESS_TRACING");
        function suppressTracing2(context2) {
            return context2.setValue(SUPPRESS_TRACING_KEY2, true);
        }
        exports.suppressTracing = suppressTracing2;
        function unsuppressTracing2(context2) {
            return context2.deleteValue(SUPPRESS_TRACING_KEY2);
        }
        exports.unsuppressTracing = unsuppressTracing2;
        function isTracingSuppressed2(context2) {
            return context2.getValue(SUPPRESS_TRACING_KEY2) === true;
        }
        exports.isTracingSuppressed = isTracingSuppressed2;
    }
});
// ../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/baggage/constants.js
var $281a441cdcb2cf36$var$require_constants = $281a441cdcb2cf36$var$__commonJS({
    "../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/baggage/constants.js" (exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.BAGGAGE_MAX_TOTAL_LENGTH = exports.BAGGAGE_MAX_PER_NAME_VALUE_PAIRS = exports.BAGGAGE_MAX_NAME_VALUE_PAIRS = exports.BAGGAGE_HEADER = exports.BAGGAGE_ITEMS_SEPARATOR = exports.BAGGAGE_PROPERTIES_SEPARATOR = exports.BAGGAGE_KEY_PAIR_SEPARATOR = void 0;
        exports.BAGGAGE_KEY_PAIR_SEPARATOR = "=";
        exports.BAGGAGE_PROPERTIES_SEPARATOR = ";";
        exports.BAGGAGE_ITEMS_SEPARATOR = ",";
        exports.BAGGAGE_HEADER = "baggage";
        exports.BAGGAGE_MAX_NAME_VALUE_PAIRS = 180;
        exports.BAGGAGE_MAX_PER_NAME_VALUE_PAIRS = 4096;
        exports.BAGGAGE_MAX_TOTAL_LENGTH = 8192;
    }
});
// ../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/baggage/utils.js
var $281a441cdcb2cf36$var$require_utils = $281a441cdcb2cf36$var$__commonJS({
    "../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/baggage/utils.js" (exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.parseKeyPairsIntoRecord = exports.parsePairKeyValue = exports.getKeyPairs = exports.serializeKeyPairs = void 0;
        var api_1 = ($281a441cdcb2cf36$var$init_esm(), $281a441cdcb2cf36$var$__toCommonJS($281a441cdcb2cf36$var$esm_exports2));
        var constants_1 = $281a441cdcb2cf36$var$require_constants();
        function serializeKeyPairs2(keyPairs) {
            return keyPairs.reduce((hValue, current2)=>{
                const value2 = `${hValue}${hValue !== "" ? constants_1.BAGGAGE_ITEMS_SEPARATOR : ""}${current2}`;
                return value2.length > constants_1.BAGGAGE_MAX_TOTAL_LENGTH ? hValue : value2;
            }, "");
        }
        exports.serializeKeyPairs = serializeKeyPairs2;
        function getKeyPairs2(baggage) {
            return baggage.getAllEntries().map(([key, value2])=>{
                let entry = `${encodeURIComponent(key)}=${encodeURIComponent(value2.value)}`;
                if (value2.metadata !== void 0) entry += constants_1.BAGGAGE_PROPERTIES_SEPARATOR + value2.metadata.toString();
                return entry;
            });
        }
        exports.getKeyPairs = getKeyPairs2;
        function parsePairKeyValue2(entry) {
            const valueProps = entry.split(constants_1.BAGGAGE_PROPERTIES_SEPARATOR);
            if (valueProps.length <= 0) return;
            const keyPairPart = valueProps.shift();
            if (!keyPairPart) return;
            const separatorIndex = keyPairPart.indexOf(constants_1.BAGGAGE_KEY_PAIR_SEPARATOR);
            if (separatorIndex <= 0) return;
            const key = decodeURIComponent(keyPairPart.substring(0, separatorIndex).trim());
            const value2 = decodeURIComponent(keyPairPart.substring(separatorIndex + 1).trim());
            let metadata;
            if (valueProps.length > 0) metadata = (0, api_1.baggageEntryMetadataFromString)(valueProps.join(constants_1.BAGGAGE_PROPERTIES_SEPARATOR));
            return {
                key: key,
                value: value2,
                metadata: metadata
            };
        }
        exports.parsePairKeyValue = parsePairKeyValue2;
        function parseKeyPairsIntoRecord(value2) {
            const result = {};
            if (typeof value2 === "string" && value2.length > 0) value2.split(constants_1.BAGGAGE_ITEMS_SEPARATOR).forEach((entry)=>{
                const keyPair = parsePairKeyValue2(entry);
                if (keyPair !== void 0 && keyPair.value.length > 0) result[keyPair.key] = keyPair.value;
            });
            return result;
        }
        exports.parseKeyPairsIntoRecord = parseKeyPairsIntoRecord;
    }
});
// ../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/baggage/propagation/W3CBaggagePropagator.js
var $281a441cdcb2cf36$var$require_W3CBaggagePropagator = $281a441cdcb2cf36$var$__commonJS({
    "../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/baggage/propagation/W3CBaggagePropagator.js" (exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.W3CBaggagePropagator = void 0;
        var api_1 = ($281a441cdcb2cf36$var$init_esm(), $281a441cdcb2cf36$var$__toCommonJS($281a441cdcb2cf36$var$esm_exports2));
        var suppress_tracing_1 = $281a441cdcb2cf36$var$require_suppress_tracing();
        var constants_1 = $281a441cdcb2cf36$var$require_constants();
        var utils_1 = $281a441cdcb2cf36$var$require_utils();
        var W3CBaggagePropagator2 = class {
            inject(context2, carrier, setter) {
                const baggage = api_1.propagation.getBaggage(context2);
                if (!baggage || (0, suppress_tracing_1.isTracingSuppressed)(context2)) return;
                const keyPairs = (0, utils_1.getKeyPairs)(baggage).filter((pair)=>{
                    return pair.length <= constants_1.BAGGAGE_MAX_PER_NAME_VALUE_PAIRS;
                }).slice(0, constants_1.BAGGAGE_MAX_NAME_VALUE_PAIRS);
                const headerValue = (0, utils_1.serializeKeyPairs)(keyPairs);
                if (headerValue.length > 0) setter.set(carrier, constants_1.BAGGAGE_HEADER, headerValue);
            }
            extract(context2, carrier, getter) {
                const headerValue = getter.get(carrier, constants_1.BAGGAGE_HEADER);
                const baggageString = Array.isArray(headerValue) ? headerValue.join(constants_1.BAGGAGE_ITEMS_SEPARATOR) : headerValue;
                if (!baggageString) return context2;
                const baggage = {};
                if (baggageString.length === 0) return context2;
                const pairs = baggageString.split(constants_1.BAGGAGE_ITEMS_SEPARATOR);
                pairs.forEach((entry)=>{
                    const keyPair = (0, utils_1.parsePairKeyValue)(entry);
                    if (keyPair) {
                        const baggageEntry = {
                            value: keyPair.value
                        };
                        if (keyPair.metadata) baggageEntry.metadata = keyPair.metadata;
                        baggage[keyPair.key] = baggageEntry;
                    }
                });
                if (Object.entries(baggage).length === 0) return context2;
                return api_1.propagation.setBaggage(context2, api_1.propagation.createBaggage(baggage));
            }
            fields() {
                return [
                    constants_1.BAGGAGE_HEADER
                ];
            }
        };
        exports.W3CBaggagePropagator = W3CBaggagePropagator2;
    }
});
// ../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/common/anchored-clock.js
var $281a441cdcb2cf36$var$require_anchored_clock = $281a441cdcb2cf36$var$__commonJS({
    "../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/common/anchored-clock.js" (exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.AnchoredClock = void 0;
        var AnchoredClock = class {
            /**
       * Create a new AnchoredClock anchored to the current time returned by systemClock.
       *
       * @param systemClock should be a clock that returns the number of milliseconds since January 1 1970 such as Date
       * @param monotonicClock should be a clock that counts milliseconds monotonically such as window.performance or perf_hooks.performance
       */ constructor(systemClock, monotonicClock){
                $281a441cdcb2cf36$var$__publicField(this, "_monotonicClock");
                $281a441cdcb2cf36$var$__publicField(this, "_epochMillis");
                $281a441cdcb2cf36$var$__publicField(this, "_performanceMillis");
                this._monotonicClock = monotonicClock;
                this._epochMillis = systemClock.now();
                this._performanceMillis = monotonicClock.now();
            }
            /**
       * Returns the current time by adding the number of milliseconds since the
       * AnchoredClock was created to the creation epoch time
       */ now() {
                const delta = this._monotonicClock.now() - this._performanceMillis;
                return this._epochMillis + delta;
            }
        };
        exports.AnchoredClock = AnchoredClock;
    }
});
// ../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/common/attributes.js
var $281a441cdcb2cf36$var$require_attributes = $281a441cdcb2cf36$var$__commonJS({
    "../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/common/attributes.js" (exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.isAttributeValue = exports.isAttributeKey = exports.sanitizeAttributes = void 0;
        var api_1 = ($281a441cdcb2cf36$var$init_esm(), $281a441cdcb2cf36$var$__toCommonJS($281a441cdcb2cf36$var$esm_exports2));
        function sanitizeAttributes3(attributes) {
            const out = {};
            if (typeof attributes !== "object" || attributes == null) return out;
            for (const [key, val] of Object.entries(attributes)){
                if (!isAttributeKey2(key)) {
                    api_1.diag.warn(`Invalid attribute key: ${key}`);
                    continue;
                }
                if (!isAttributeValue2(val)) {
                    api_1.diag.warn(`Invalid attribute value set for key: ${key}`);
                    continue;
                }
                if (Array.isArray(val)) out[key] = val.slice();
                else out[key] = val;
            }
            return out;
        }
        exports.sanitizeAttributes = sanitizeAttributes3;
        function isAttributeKey2(key) {
            return typeof key === "string" && key.length > 0;
        }
        exports.isAttributeKey = isAttributeKey2;
        function isAttributeValue2(val) {
            if (val == null) return true;
            if (Array.isArray(val)) return isHomogeneousAttributeValueArray2(val);
            return isValidPrimitiveAttributeValue(val);
        }
        exports.isAttributeValue = isAttributeValue2;
        function isHomogeneousAttributeValueArray2(arr) {
            let type;
            for (const element2 of arr){
                if (element2 == null) continue;
                if (!type) {
                    if (isValidPrimitiveAttributeValue(element2)) {
                        type = typeof element2;
                        continue;
                    }
                    return false;
                }
                if (typeof element2 === type) continue;
                return false;
            }
            return true;
        }
        function isValidPrimitiveAttributeValue(val) {
            switch(typeof val){
                case "number":
                case "boolean":
                case "string":
                    return true;
            }
            return false;
        }
    }
});
// ../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/common/logging-error-handler.js
var $281a441cdcb2cf36$var$require_logging_error_handler = $281a441cdcb2cf36$var$__commonJS({
    "../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/common/logging-error-handler.js" (exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.loggingErrorHandler = void 0;
        var api_1 = ($281a441cdcb2cf36$var$init_esm(), $281a441cdcb2cf36$var$__toCommonJS($281a441cdcb2cf36$var$esm_exports2));
        function loggingErrorHandler2() {
            return (ex)=>{
                api_1.diag.error(stringifyException2(ex));
            };
        }
        exports.loggingErrorHandler = loggingErrorHandler2;
        function stringifyException2(ex) {
            if (typeof ex === "string") return ex;
            else return JSON.stringify(flattenException2(ex));
        }
        function flattenException2(ex) {
            const result = {};
            let current2 = ex;
            while(current2 !== null){
                Object.getOwnPropertyNames(current2).forEach((propertyName)=>{
                    if (result[propertyName]) return;
                    const value2 = current2[propertyName];
                    if (value2) result[propertyName] = String(value2);
                });
                current2 = Object.getPrototypeOf(current2);
            }
            return result;
        }
    }
});
// ../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/common/global-error-handler.js
var $281a441cdcb2cf36$var$require_global_error_handler = $281a441cdcb2cf36$var$__commonJS({
    "../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/common/global-error-handler.js" (exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.globalErrorHandler = exports.setGlobalErrorHandler = void 0;
        var logging_error_handler_1 = $281a441cdcb2cf36$var$require_logging_error_handler();
        var delegateHandler2 = (0, logging_error_handler_1.loggingErrorHandler)();
        function setGlobalErrorHandler2(handler) {
            delegateHandler2 = handler;
        }
        exports.setGlobalErrorHandler = setGlobalErrorHandler2;
        function globalErrorHandler2(ex) {
            try {
                delegateHandler2(ex);
            } catch  {}
        }
        exports.globalErrorHandler = globalErrorHandler2;
    }
});
// ../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/platform/browser/environment.js
var $281a441cdcb2cf36$var$require_environment = $281a441cdcb2cf36$var$__commonJS({
    "../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/platform/browser/environment.js" (exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.getStringListFromEnv = exports.getNumberFromEnv = exports.getBooleanFromEnv = exports.getStringFromEnv = void 0;
        function getStringFromEnv4(_3) {
            return void 0;
        }
        exports.getStringFromEnv = getStringFromEnv4;
        function getBooleanFromEnv4(_3) {
            return void 0;
        }
        exports.getBooleanFromEnv = getBooleanFromEnv4;
        function getNumberFromEnv4(_3) {
            return void 0;
        }
        exports.getNumberFromEnv = getNumberFromEnv4;
        function getStringListFromEnv4(_3) {
            return void 0;
        }
        exports.getStringListFromEnv = getStringListFromEnv4;
    }
});
// ../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/platform/browser/globalThis.js
var $281a441cdcb2cf36$var$require_globalThis = $281a441cdcb2cf36$var$__commonJS({
    "../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/platform/browser/globalThis.js" (exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports._globalThis = void 0;
        exports._globalThis = typeof globalThis === "object" ? globalThis : typeof self === "object" ? self : typeof window === "object" ? window : typeof $parcel$global === "object" ? $parcel$global : {};
    }
});
// ../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/platform/browser/performance.js
var $281a441cdcb2cf36$var$require_performance = $281a441cdcb2cf36$var$__commonJS({
    "../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/platform/browser/performance.js" (exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.otperformance = void 0;
        exports.otperformance = performance;
    }
});
// ../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/version.js
var $281a441cdcb2cf36$var$require_version = $281a441cdcb2cf36$var$__commonJS({
    "../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/version.js" (exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.VERSION = void 0;
        exports.VERSION = "2.0.1";
    }
});
// ../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/semconv.js
var $281a441cdcb2cf36$var$require_semconv = $281a441cdcb2cf36$var$__commonJS({
    "../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/semconv.js" (exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.ATTR_PROCESS_RUNTIME_NAME = void 0;
        exports.ATTR_PROCESS_RUNTIME_NAME = "process.runtime.name";
    }
});
// ../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/platform/browser/sdk-info.js
var $281a441cdcb2cf36$var$require_sdk_info = $281a441cdcb2cf36$var$__commonJS({
    "../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/platform/browser/sdk-info.js" (exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.SDK_INFO = void 0;
        var version_1 = $281a441cdcb2cf36$var$require_version();
        var semantic_conventions_1 = ($281a441cdcb2cf36$var$init_esm2(), $281a441cdcb2cf36$var$__toCommonJS($281a441cdcb2cf36$var$esm_exports3));
        var semconv_1 = $281a441cdcb2cf36$var$require_semconv();
        exports.SDK_INFO = {
            [semantic_conventions_1.ATTR_TELEMETRY_SDK_NAME]: "opentelemetry",
            [semconv_1.ATTR_PROCESS_RUNTIME_NAME]: "browser",
            [semantic_conventions_1.ATTR_TELEMETRY_SDK_LANGUAGE]: semantic_conventions_1.TELEMETRY_SDK_LANGUAGE_VALUE_WEBJS,
            [semantic_conventions_1.ATTR_TELEMETRY_SDK_VERSION]: version_1.VERSION
        };
    }
});
// ../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/platform/browser/timer-util.js
var $281a441cdcb2cf36$var$require_timer_util = $281a441cdcb2cf36$var$__commonJS({
    "../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/platform/browser/timer-util.js" (exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.unrefTimer = void 0;
        function unrefTimer3(_timer) {}
        exports.unrefTimer = unrefTimer3;
    }
});
// ../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/platform/browser/index.js
var $281a441cdcb2cf36$var$require_browser = $281a441cdcb2cf36$var$__commonJS({
    "../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/platform/browser/index.js" (exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.unrefTimer = exports.SDK_INFO = exports.otperformance = exports._globalThis = exports.getStringListFromEnv = exports.getNumberFromEnv = exports.getBooleanFromEnv = exports.getStringFromEnv = void 0;
        var environment_1 = $281a441cdcb2cf36$var$require_environment();
        Object.defineProperty(exports, "getStringFromEnv", {
            enumerable: true,
            get: function() {
                return environment_1.getStringFromEnv;
            }
        });
        Object.defineProperty(exports, "getBooleanFromEnv", {
            enumerable: true,
            get: function() {
                return environment_1.getBooleanFromEnv;
            }
        });
        Object.defineProperty(exports, "getNumberFromEnv", {
            enumerable: true,
            get: function() {
                return environment_1.getNumberFromEnv;
            }
        });
        Object.defineProperty(exports, "getStringListFromEnv", {
            enumerable: true,
            get: function() {
                return environment_1.getStringListFromEnv;
            }
        });
        var globalThis_1 = $281a441cdcb2cf36$var$require_globalThis();
        Object.defineProperty(exports, "_globalThis", {
            enumerable: true,
            get: function() {
                return globalThis_1._globalThis;
            }
        });
        var performance_1 = $281a441cdcb2cf36$var$require_performance();
        Object.defineProperty(exports, "otperformance", {
            enumerable: true,
            get: function() {
                return performance_1.otperformance;
            }
        });
        var sdk_info_1 = $281a441cdcb2cf36$var$require_sdk_info();
        Object.defineProperty(exports, "SDK_INFO", {
            enumerable: true,
            get: function() {
                return sdk_info_1.SDK_INFO;
            }
        });
        var timer_util_1 = $281a441cdcb2cf36$var$require_timer_util();
        Object.defineProperty(exports, "unrefTimer", {
            enumerable: true,
            get: function() {
                return timer_util_1.unrefTimer;
            }
        });
    }
});
// ../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/common/time.js
var $281a441cdcb2cf36$var$require_time = $281a441cdcb2cf36$var$__commonJS({
    "../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/common/time.js" (exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.addHrTimes = exports.isTimeInput = exports.isTimeInputHrTime = exports.hrTimeToMicroseconds = exports.hrTimeToMilliseconds = exports.hrTimeToNanoseconds = exports.hrTimeToTimeStamp = exports.hrTimeDuration = exports.timeInputToHrTime = exports.hrTime = exports.getTimeOrigin = exports.millisToHrTime = void 0;
        var platform_1 = $281a441cdcb2cf36$var$require_browser();
        var NANOSECOND_DIGITS4 = 9;
        var NANOSECOND_DIGITS_IN_MILLIS4 = 6;
        var MILLISECONDS_TO_NANOSECONDS4 = Math.pow(10, NANOSECOND_DIGITS_IN_MILLIS4);
        var SECOND_TO_NANOSECONDS4 = Math.pow(10, NANOSECOND_DIGITS4);
        function millisToHrTime4(epochMillis) {
            const epochSeconds = epochMillis / 1e3;
            const seconds = Math.trunc(epochSeconds);
            const nanos = Math.round(epochMillis % 1e3 * MILLISECONDS_TO_NANOSECONDS4);
            return [
                seconds,
                nanos
            ];
        }
        exports.millisToHrTime = millisToHrTime4;
        function getTimeOrigin4() {
            let timeOrigin = platform_1.otperformance.timeOrigin;
            if (typeof timeOrigin !== "number") {
                const perf = platform_1.otperformance;
                timeOrigin = perf.timing && perf.timing.fetchStart;
            }
            return timeOrigin;
        }
        exports.getTimeOrigin = getTimeOrigin4;
        function hrTime4(performanceNow) {
            const timeOrigin = millisToHrTime4(getTimeOrigin4());
            const now = millisToHrTime4(typeof performanceNow === "number" ? performanceNow : platform_1.otperformance.now());
            return addHrTimes4(timeOrigin, now);
        }
        exports.hrTime = hrTime4;
        function timeInputToHrTime4(time) {
            if (isTimeInputHrTime4(time)) return time;
            else if (typeof time === "number") {
                if (time < getTimeOrigin4()) return hrTime4(time);
                else return millisToHrTime4(time);
            } else if (time instanceof Date) return millisToHrTime4(time.getTime());
            else throw TypeError("Invalid input type");
        }
        exports.timeInputToHrTime = timeInputToHrTime4;
        function hrTimeDuration4(startTime, endTime) {
            let seconds = endTime[0] - startTime[0];
            let nanos = endTime[1] - startTime[1];
            if (nanos < 0) {
                seconds -= 1;
                nanos += SECOND_TO_NANOSECONDS4;
            }
            return [
                seconds,
                nanos
            ];
        }
        exports.hrTimeDuration = hrTimeDuration4;
        function hrTimeToTimeStamp4(time) {
            const precision = NANOSECOND_DIGITS4;
            const tmp = `${"0".repeat(precision)}${time[1]}Z`;
            const nanoString = tmp.substring(tmp.length - precision - 1);
            const date = new Date(time[0] * 1e3).toISOString();
            return date.replace("000Z", nanoString);
        }
        exports.hrTimeToTimeStamp = hrTimeToTimeStamp4;
        function hrTimeToNanoseconds4(time) {
            return time[0] * SECOND_TO_NANOSECONDS4 + time[1];
        }
        exports.hrTimeToNanoseconds = hrTimeToNanoseconds4;
        function hrTimeToMilliseconds4(time) {
            return time[0] * 1e3 + time[1] / 1e6;
        }
        exports.hrTimeToMilliseconds = hrTimeToMilliseconds4;
        function hrTimeToMicroseconds4(time) {
            return time[0] * 1e6 + time[1] / 1e3;
        }
        exports.hrTimeToMicroseconds = hrTimeToMicroseconds4;
        function isTimeInputHrTime4(value2) {
            return Array.isArray(value2) && value2.length === 2 && typeof value2[0] === "number" && typeof value2[1] === "number";
        }
        exports.isTimeInputHrTime = isTimeInputHrTime4;
        function isTimeInput4(value2) {
            return isTimeInputHrTime4(value2) || typeof value2 === "number" || value2 instanceof Date;
        }
        exports.isTimeInput = isTimeInput4;
        function addHrTimes4(time1, time2) {
            const out = [
                time1[0] + time2[0],
                time1[1] + time2[1]
            ];
            if (out[1] >= SECOND_TO_NANOSECONDS4) {
                out[1] -= SECOND_TO_NANOSECONDS4;
                out[0] += 1;
            }
            return out;
        }
        exports.addHrTimes = addHrTimes4;
    }
});
// ../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/ExportResult.js
var $281a441cdcb2cf36$var$require_ExportResult = $281a441cdcb2cf36$var$__commonJS({
    "../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/ExportResult.js" (exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.ExportResultCode = void 0;
        var ExportResultCode2;
        (function(ExportResultCode3) {
            ExportResultCode3[ExportResultCode3["SUCCESS"] = 0] = "SUCCESS";
            ExportResultCode3[ExportResultCode3["FAILED"] = 1] = "FAILED";
        })(ExportResultCode2 = exports.ExportResultCode || (exports.ExportResultCode = {}));
    }
});
// ../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/propagation/composite.js
var $281a441cdcb2cf36$var$require_composite = $281a441cdcb2cf36$var$__commonJS({
    "../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/propagation/composite.js" (exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.CompositePropagator = void 0;
        var api_1 = ($281a441cdcb2cf36$var$init_esm(), $281a441cdcb2cf36$var$__toCommonJS($281a441cdcb2cf36$var$esm_exports2));
        var CompositePropagator2 = class {
            /**
       * Construct a composite propagator from a list of propagators.
       *
       * @param [config] Configuration object for composite propagator
       */ constructor(config = {}){
                $281a441cdcb2cf36$var$__publicField(this, "_propagators");
                $281a441cdcb2cf36$var$__publicField(this, "_fields");
                var _a2;
                this._propagators = (_a2 = config.propagators) != null ? _a2 : [];
                this._fields = Array.from(new Set(this._propagators.map((p3)=>typeof p3.fields === "function" ? p3.fields() : []).reduce((x3, y3)=>x3.concat(y3), [])));
            }
            /**
       * Run each of the configured propagators with the given context and carrier.
       * Propagators are run in the order they are configured, so if multiple
       * propagators write the same carrier key, the propagator later in the list
       * will "win".
       *
       * @param context Context to inject
       * @param carrier Carrier into which context will be injected
       */ inject(context2, carrier, setter) {
                for (const propagator of this._propagators)try {
                    propagator.inject(context2, carrier, setter);
                } catch (err) {
                    api_1.diag.warn(`Failed to inject with ${propagator.constructor.name}. Err: ${err.message}`);
                }
            }
            /**
       * Run each of the configured propagators with the given context and carrier.
       * Propagators are run in the order they are configured, so if multiple
       * propagators write the same context key, the propagator later in the list
       * will "win".
       *
       * @param context Context to add values to
       * @param carrier Carrier from which to extract context
       */ extract(context2, carrier, getter) {
                return this._propagators.reduce((ctx, propagator)=>{
                    try {
                        return propagator.extract(ctx, carrier, getter);
                    } catch (err) {
                        api_1.diag.warn(`Failed to extract with ${propagator.constructor.name}. Err: ${err.message}`);
                    }
                    return ctx;
                }, context2);
            }
            fields() {
                return this._fields.slice();
            }
        };
        exports.CompositePropagator = CompositePropagator2;
    }
});
// ../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/internal/validators.js
var $281a441cdcb2cf36$var$require_validators = $281a441cdcb2cf36$var$__commonJS({
    "../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/internal/validators.js" (exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.validateValue = exports.validateKey = void 0;
        var VALID_KEY_CHAR_RANGE3 = "[_0-9a-z-*/]";
        var VALID_KEY3 = `[a-z]${VALID_KEY_CHAR_RANGE3}{0,255}`;
        var VALID_VENDOR_KEY3 = `[a-z0-9]${VALID_KEY_CHAR_RANGE3}{0,240}@[a-z]${VALID_KEY_CHAR_RANGE3}{0,13}`;
        var VALID_KEY_REGEX3 = new RegExp(`^(?:${VALID_KEY3}|${VALID_VENDOR_KEY3})$`);
        var VALID_VALUE_BASE_REGEX3 = /^[ -~]{0,255}[!-~]$/;
        var INVALID_VALUE_COMMA_EQUAL_REGEX3 = /,|=/;
        function validateKey3(key) {
            return VALID_KEY_REGEX3.test(key);
        }
        exports.validateKey = validateKey3;
        function validateValue3(value2) {
            return VALID_VALUE_BASE_REGEX3.test(value2) && !INVALID_VALUE_COMMA_EQUAL_REGEX3.test(value2);
        }
        exports.validateValue = validateValue3;
    }
});
// ../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/trace/TraceState.js
var $281a441cdcb2cf36$var$require_TraceState = $281a441cdcb2cf36$var$__commonJS({
    "../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/trace/TraceState.js" (exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.TraceState = void 0;
        var validators_1 = $281a441cdcb2cf36$var$require_validators();
        var MAX_TRACE_STATE_ITEMS3 = 32;
        var MAX_TRACE_STATE_LEN3 = 512;
        var LIST_MEMBERS_SEPARATOR3 = ",";
        var LIST_MEMBER_KEY_VALUE_SPLITTER3 = "=";
        var TraceState2 = class _TraceState {
            constructor(rawTraceState){
                $281a441cdcb2cf36$var$__publicField(this, "_internalState", /* @__PURE__ */ new Map());
                if (rawTraceState) this._parse(rawTraceState);
            }
            set(key, value2) {
                const traceState = this._clone();
                if (traceState._internalState.has(key)) traceState._internalState.delete(key);
                traceState._internalState.set(key, value2);
                return traceState;
            }
            unset(key) {
                const traceState = this._clone();
                traceState._internalState.delete(key);
                return traceState;
            }
            get(key) {
                return this._internalState.get(key);
            }
            serialize() {
                return this._keys().reduce((agg, key)=>{
                    agg.push(key + LIST_MEMBER_KEY_VALUE_SPLITTER3 + this.get(key));
                    return agg;
                }, []).join(LIST_MEMBERS_SEPARATOR3);
            }
            _parse(rawTraceState) {
                if (rawTraceState.length > MAX_TRACE_STATE_LEN3) return;
                this._internalState = rawTraceState.split(LIST_MEMBERS_SEPARATOR3).reverse().reduce((agg, part)=>{
                    const listMember = part.trim();
                    const i3 = listMember.indexOf(LIST_MEMBER_KEY_VALUE_SPLITTER3);
                    if (i3 !== -1) {
                        const key = listMember.slice(0, i3);
                        const value2 = listMember.slice(i3 + 1, part.length);
                        if ((0, validators_1.validateKey)(key) && (0, validators_1.validateValue)(value2)) agg.set(key, value2);
                    }
                    return agg;
                }, /* @__PURE__ */ new Map());
                if (this._internalState.size > MAX_TRACE_STATE_ITEMS3) this._internalState = new Map(Array.from(this._internalState.entries()).reverse().slice(0, MAX_TRACE_STATE_ITEMS3));
            }
            _keys() {
                return Array.from(this._internalState.keys()).reverse();
            }
            _clone() {
                const traceState = new _TraceState();
                traceState._internalState = new Map(this._internalState);
                return traceState;
            }
        };
        exports.TraceState = TraceState2;
    }
});
// ../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/trace/W3CTraceContextPropagator.js
var $281a441cdcb2cf36$var$require_W3CTraceContextPropagator = $281a441cdcb2cf36$var$__commonJS({
    "../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/trace/W3CTraceContextPropagator.js" (exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.W3CTraceContextPropagator = exports.parseTraceParent = exports.TRACE_STATE_HEADER = exports.TRACE_PARENT_HEADER = void 0;
        var api_1 = ($281a441cdcb2cf36$var$init_esm(), $281a441cdcb2cf36$var$__toCommonJS($281a441cdcb2cf36$var$esm_exports2));
        var suppress_tracing_1 = $281a441cdcb2cf36$var$require_suppress_tracing();
        var TraceState_1 = $281a441cdcb2cf36$var$require_TraceState();
        exports.TRACE_PARENT_HEADER = "traceparent";
        exports.TRACE_STATE_HEADER = "tracestate";
        var VERSION8 = "00";
        var VERSION_PART2 = "(?!ff)[\\da-f]{2}";
        var TRACE_ID_PART2 = "(?![0]{32})[\\da-f]{32}";
        var PARENT_ID_PART2 = "(?![0]{16})[\\da-f]{16}";
        var FLAGS_PART2 = "[\\da-f]{2}";
        var TRACE_PARENT_REGEX2 = new RegExp(`^\\s?(${VERSION_PART2})-(${TRACE_ID_PART2})-(${PARENT_ID_PART2})-(${FLAGS_PART2})(-.*)?\\s?$`);
        function parseTraceParent2(traceParent) {
            const match2 = TRACE_PARENT_REGEX2.exec(traceParent);
            if (!match2) return null;
            if (match2[1] === "00" && match2[5]) return null;
            return {
                traceId: match2[2],
                spanId: match2[3],
                traceFlags: parseInt(match2[4], 16)
            };
        }
        exports.parseTraceParent = parseTraceParent2;
        var W3CTraceContextPropagator2 = class {
            inject(context2, carrier, setter) {
                const spanContext = api_1.trace.getSpanContext(context2);
                if (!spanContext || (0, suppress_tracing_1.isTracingSuppressed)(context2) || !(0, api_1.isSpanContextValid)(spanContext)) return;
                const traceParent = `${VERSION8}-${spanContext.traceId}-${spanContext.spanId}-0${Number(spanContext.traceFlags || api_1.TraceFlags.NONE).toString(16)}`;
                setter.set(carrier, exports.TRACE_PARENT_HEADER, traceParent);
                if (spanContext.traceState) setter.set(carrier, exports.TRACE_STATE_HEADER, spanContext.traceState.serialize());
            }
            extract(context2, carrier, getter) {
                const traceParentHeader = getter.get(carrier, exports.TRACE_PARENT_HEADER);
                if (!traceParentHeader) return context2;
                const traceParent = Array.isArray(traceParentHeader) ? traceParentHeader[0] : traceParentHeader;
                if (typeof traceParent !== "string") return context2;
                const spanContext = parseTraceParent2(traceParent);
                if (!spanContext) return context2;
                spanContext.isRemote = true;
                const traceStateHeader = getter.get(carrier, exports.TRACE_STATE_HEADER);
                if (traceStateHeader) {
                    const state = Array.isArray(traceStateHeader) ? traceStateHeader.join(",") : traceStateHeader;
                    spanContext.traceState = new TraceState_1.TraceState(typeof state === "string" ? state : void 0);
                }
                return api_1.trace.setSpanContext(context2, spanContext);
            }
            fields() {
                return [
                    exports.TRACE_PARENT_HEADER,
                    exports.TRACE_STATE_HEADER
                ];
            }
        };
        exports.W3CTraceContextPropagator = W3CTraceContextPropagator2;
    }
});
// ../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/trace/rpc-metadata.js
var $281a441cdcb2cf36$var$require_rpc_metadata = $281a441cdcb2cf36$var$__commonJS({
    "../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/trace/rpc-metadata.js" (exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.getRPCMetadata = exports.deleteRPCMetadata = exports.setRPCMetadata = exports.RPCType = void 0;
        var api_1 = ($281a441cdcb2cf36$var$init_esm(), $281a441cdcb2cf36$var$__toCommonJS($281a441cdcb2cf36$var$esm_exports2));
        var RPC_METADATA_KEY = (0, api_1.createContextKey)("OpenTelemetry SDK Context Key RPC_METADATA");
        var RPCType;
        (function(RPCType2) {
            RPCType2["HTTP"] = "http";
        })(RPCType = exports.RPCType || (exports.RPCType = {}));
        function setRPCMetadata(context2, meta) {
            return context2.setValue(RPC_METADATA_KEY, meta);
        }
        exports.setRPCMetadata = setRPCMetadata;
        function deleteRPCMetadata(context2) {
            return context2.deleteValue(RPC_METADATA_KEY);
        }
        exports.deleteRPCMetadata = deleteRPCMetadata;
        function getRPCMetadata(context2) {
            return context2.getValue(RPC_METADATA_KEY);
        }
        exports.getRPCMetadata = getRPCMetadata;
    }
});
// ../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/utils/lodash.merge.js
var $281a441cdcb2cf36$var$require_lodash_merge = $281a441cdcb2cf36$var$__commonJS({
    "../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/utils/lodash.merge.js" (exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.isPlainObject = void 0;
        var objectTag2 = "[object Object]";
        var nullTag2 = "[object Null]";
        var undefinedTag2 = "[object Undefined]";
        var funcProto2 = Function.prototype;
        var funcToString2 = funcProto2.toString;
        var objectCtorString2 = funcToString2.call(Object);
        var getPrototypeOf2 = Object.getPrototypeOf;
        var objectProto2 = Object.prototype;
        var hasOwnProperty3 = objectProto2.hasOwnProperty;
        var symToStringTag2 = Symbol ? Symbol.toStringTag : void 0;
        var nativeObjectToString2 = objectProto2.toString;
        function isPlainObject5(value2) {
            if (!isObjectLike3(value2) || baseGetTag2(value2) !== objectTag2) return false;
            const proto = getPrototypeOf2(value2);
            if (proto === null) return true;
            const Ctor = hasOwnProperty3.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString2.call(Ctor) === objectCtorString2;
        }
        exports.isPlainObject = isPlainObject5;
        function isObjectLike3(value2) {
            return value2 != null && typeof value2 == "object";
        }
        function baseGetTag2(value2) {
            if (value2 == null) return value2 === void 0 ? undefinedTag2 : nullTag2;
            return symToStringTag2 && symToStringTag2 in Object(value2) ? getRawTag2(value2) : objectToString2(value2);
        }
        function getRawTag2(value2) {
            const isOwn = hasOwnProperty3.call(value2, symToStringTag2), tag = value2[symToStringTag2];
            let unmasked = false;
            try {
                value2[symToStringTag2] = void 0;
                unmasked = true;
            } catch (e4) {}
            const result = nativeObjectToString2.call(value2);
            if (unmasked) {
                if (isOwn) value2[symToStringTag2] = tag;
                else delete value2[symToStringTag2];
            }
            return result;
        }
        function objectToString2(value2) {
            return nativeObjectToString2.call(value2);
        }
    }
});
// ../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/utils/merge.js
var $281a441cdcb2cf36$var$require_merge = $281a441cdcb2cf36$var$__commonJS({
    "../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/utils/merge.js" (exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.merge = void 0;
        var lodash_merge_1 = $281a441cdcb2cf36$var$require_lodash_merge();
        var MAX_LEVEL2 = 20;
        function merge2(...args2) {
            let result = args2.shift();
            const objects = /* @__PURE__ */ new WeakMap();
            while(args2.length > 0)result = mergeTwoObjects2(result, args2.shift(), 0, objects);
            return result;
        }
        exports.merge = merge2;
        function takeValue2(value2) {
            if (isArray5(value2)) return value2.slice();
            return value2;
        }
        function mergeTwoObjects2(one, two, level = 0, objects) {
            let result;
            if (level > MAX_LEVEL2) return void 0;
            level++;
            if (isPrimitive3(one) || isPrimitive3(two) || isFunction4(two)) result = takeValue2(two);
            else if (isArray5(one)) {
                result = one.slice();
                if (isArray5(two)) for(let i3 = 0, j3 = two.length; i3 < j3; i3++)result.push(takeValue2(two[i3]));
                else if (isObject5(two)) {
                    const keys2 = Object.keys(two);
                    for(let i3 = 0, j3 = keys2.length; i3 < j3; i3++){
                        const key = keys2[i3];
                        result[key] = takeValue2(two[key]);
                    }
                }
            } else if (isObject5(one)) {
                if (isObject5(two)) {
                    if (!shouldMerge2(one, two)) return two;
                    result = Object.assign({}, one);
                    const keys2 = Object.keys(two);
                    for(let i3 = 0, j3 = keys2.length; i3 < j3; i3++){
                        const key = keys2[i3];
                        const twoValue = two[key];
                        if (isPrimitive3(twoValue)) {
                            if (typeof twoValue === "undefined") delete result[key];
                            else result[key] = twoValue;
                        } else {
                            const obj1 = result[key];
                            const obj2 = twoValue;
                            if (wasObjectReferenced2(one, key, objects) || wasObjectReferenced2(two, key, objects)) delete result[key];
                            else {
                                if (isObject5(obj1) && isObject5(obj2)) {
                                    const arr1 = objects.get(obj1) || [];
                                    const arr2 = objects.get(obj2) || [];
                                    arr1.push({
                                        obj: one,
                                        key: key
                                    });
                                    arr2.push({
                                        obj: two,
                                        key: key
                                    });
                                    objects.set(obj1, arr1);
                                    objects.set(obj2, arr2);
                                }
                                result[key] = mergeTwoObjects2(result[key], twoValue, level, objects);
                            }
                        }
                    }
                } else result = two;
            }
            return result;
        }
        function wasObjectReferenced2(obj, key, objects) {
            const arr = objects.get(obj[key]) || [];
            for(let i3 = 0, j3 = arr.length; i3 < j3; i3++){
                const info = arr[i3];
                if (info.key === key && info.obj === obj) return true;
            }
            return false;
        }
        function isArray5(value2) {
            return Array.isArray(value2);
        }
        function isFunction4(value2) {
            return typeof value2 === "function";
        }
        function isObject5(value2) {
            return !isPrimitive3(value2) && !isArray5(value2) && !isFunction4(value2) && typeof value2 === "object";
        }
        function isPrimitive3(value2) {
            return typeof value2 === "string" || typeof value2 === "number" || typeof value2 === "boolean" || typeof value2 === "undefined" || value2 instanceof Date || value2 instanceof RegExp || value2 === null;
        }
        function shouldMerge2(one, two) {
            if (!(0, lodash_merge_1.isPlainObject)(one) || !(0, lodash_merge_1.isPlainObject)(two)) return false;
            return true;
        }
    }
});
// ../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/utils/timeout.js
var $281a441cdcb2cf36$var$require_timeout = $281a441cdcb2cf36$var$__commonJS({
    "../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/utils/timeout.js" (exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.callWithTimeout = exports.TimeoutError = void 0;
        var TimeoutError = class _TimeoutError extends Error {
            constructor(message){
                super(message);
                Object.setPrototypeOf(this, _TimeoutError.prototype);
            }
        };
        exports.TimeoutError = TimeoutError;
        function callWithTimeout(promise, timeout) {
            let timeoutHandle;
            const timeoutPromise = new Promise(function timeoutFunction(_resolve, reject) {
                timeoutHandle = setTimeout(function timeoutHandler() {
                    reject(new TimeoutError("Operation timed out."));
                }, timeout);
            });
            return Promise.race([
                promise,
                timeoutPromise
            ]).then((result)=>{
                clearTimeout(timeoutHandle);
                return result;
            }, (reason)=>{
                clearTimeout(timeoutHandle);
                throw reason;
            });
        }
        exports.callWithTimeout = callWithTimeout;
    }
});
// ../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/utils/url.js
var $281a441cdcb2cf36$var$require_url = $281a441cdcb2cf36$var$__commonJS({
    "../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/utils/url.js" (exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.isUrlIgnored = exports.urlMatches = void 0;
        function urlMatches3(url2, urlToMatch) {
            if (typeof urlToMatch === "string") return url2 === urlToMatch;
            else return !!url2.match(urlToMatch);
        }
        exports.urlMatches = urlMatches3;
        function isUrlIgnored4(url2, ignoredUrls) {
            if (!ignoredUrls) return false;
            for (const ignoreUrl of ignoredUrls){
                if (urlMatches3(url2, ignoreUrl)) return true;
            }
            return false;
        }
        exports.isUrlIgnored = isUrlIgnored4;
    }
});
// ../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/utils/promise.js
var $281a441cdcb2cf36$var$require_promise = $281a441cdcb2cf36$var$__commonJS({
    "../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/utils/promise.js" (exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.Deferred = void 0;
        var Deferred3 = class {
            constructor(){
                $281a441cdcb2cf36$var$__publicField(this, "_promise");
                $281a441cdcb2cf36$var$__publicField(this, "_resolve");
                $281a441cdcb2cf36$var$__publicField(this, "_reject");
                this._promise = new Promise((resolve, reject)=>{
                    this._resolve = resolve;
                    this._reject = reject;
                });
            }
            get promise() {
                return this._promise;
            }
            resolve(val) {
                this._resolve(val);
            }
            reject(err) {
                this._reject(err);
            }
        };
        exports.Deferred = Deferred3;
    }
});
// ../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/utils/callback.js
var $281a441cdcb2cf36$var$require_callback = $281a441cdcb2cf36$var$__commonJS({
    "../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/utils/callback.js" (exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.BindOnceFuture = void 0;
        var promise_1 = $281a441cdcb2cf36$var$require_promise();
        var BindOnceFuture2 = class {
            constructor(_callback, _that){
                $281a441cdcb2cf36$var$__publicField(this, "_callback");
                $281a441cdcb2cf36$var$__publicField(this, "_that");
                $281a441cdcb2cf36$var$__publicField(this, "_isCalled", false);
                $281a441cdcb2cf36$var$__publicField(this, "_deferred", new promise_1.Deferred());
                this._callback = _callback;
                this._that = _that;
            }
            get isCalled() {
                return this._isCalled;
            }
            get promise() {
                return this._deferred.promise;
            }
            call(...args2) {
                if (!this._isCalled) {
                    this._isCalled = true;
                    try {
                        Promise.resolve(this._callback.call(this._that, ...args2)).then((val)=>this._deferred.resolve(val), (err)=>this._deferred.reject(err));
                    } catch (err) {
                        this._deferred.reject(err);
                    }
                }
                return this._deferred.promise;
            }
        };
        exports.BindOnceFuture = BindOnceFuture2;
    }
});
// ../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/utils/configuration.js
var $281a441cdcb2cf36$var$require_configuration = $281a441cdcb2cf36$var$__commonJS({
    "../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/utils/configuration.js" (exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.diagLogLevelFromString = void 0;
        var api_1 = ($281a441cdcb2cf36$var$init_esm(), $281a441cdcb2cf36$var$__toCommonJS($281a441cdcb2cf36$var$esm_exports2));
        var logLevelMap = {
            ALL: api_1.DiagLogLevel.ALL,
            VERBOSE: api_1.DiagLogLevel.VERBOSE,
            DEBUG: api_1.DiagLogLevel.DEBUG,
            INFO: api_1.DiagLogLevel.INFO,
            WARN: api_1.DiagLogLevel.WARN,
            ERROR: api_1.DiagLogLevel.ERROR,
            NONE: api_1.DiagLogLevel.NONE
        };
        function diagLogLevelFromString(value2) {
            if (value2 == null) return void 0;
            const resolvedLogLevel = logLevelMap[value2.toUpperCase()];
            if (resolvedLogLevel == null) {
                api_1.diag.warn(`Unknown log level "${value2}", expected one of ${Object.keys(logLevelMap)}, using default`);
                return api_1.DiagLogLevel.INFO;
            }
            return resolvedLogLevel;
        }
        exports.diagLogLevelFromString = diagLogLevelFromString;
    }
});
// ../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/internal/exporter.js
var $281a441cdcb2cf36$var$require_exporter = $281a441cdcb2cf36$var$__commonJS({
    "../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/internal/exporter.js" (exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports._export = void 0;
        var api_1 = ($281a441cdcb2cf36$var$init_esm(), $281a441cdcb2cf36$var$__toCommonJS($281a441cdcb2cf36$var$esm_exports2));
        var suppress_tracing_1 = $281a441cdcb2cf36$var$require_suppress_tracing();
        function _export(exporter, arg) {
            return new Promise((resolve)=>{
                api_1.context.with((0, suppress_tracing_1.suppressTracing)(api_1.context.active()), ()=>{
                    exporter.export(arg, (result)=>{
                        resolve(result);
                    });
                });
            });
        }
        exports._export = _export;
    }
});
// ../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/index.js
var $281a441cdcb2cf36$var$require_src = $281a441cdcb2cf36$var$__commonJS({
    "../node_modules/@opentelemetry/otlp-transformer/node_modules/@opentelemetry/core/build/src/index.js" (exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.internal = exports.diagLogLevelFromString = exports.BindOnceFuture = exports.urlMatches = exports.isUrlIgnored = exports.callWithTimeout = exports.TimeoutError = exports.merge = exports.TraceState = exports.unsuppressTracing = exports.suppressTracing = exports.isTracingSuppressed = exports.setRPCMetadata = exports.getRPCMetadata = exports.deleteRPCMetadata = exports.RPCType = exports.parseTraceParent = exports.W3CTraceContextPropagator = exports.TRACE_STATE_HEADER = exports.TRACE_PARENT_HEADER = exports.CompositePropagator = exports.unrefTimer = exports.otperformance = exports.getStringListFromEnv = exports.getNumberFromEnv = exports.getBooleanFromEnv = exports.getStringFromEnv = exports._globalThis = exports.SDK_INFO = exports.parseKeyPairsIntoRecord = exports.ExportResultCode = exports.timeInputToHrTime = exports.millisToHrTime = exports.isTimeInputHrTime = exports.isTimeInput = exports.hrTimeToTimeStamp = exports.hrTimeToNanoseconds = exports.hrTimeToMilliseconds = exports.hrTimeToMicroseconds = exports.hrTimeDuration = exports.hrTime = exports.getTimeOrigin = exports.addHrTimes = exports.loggingErrorHandler = exports.setGlobalErrorHandler = exports.globalErrorHandler = exports.sanitizeAttributes = exports.isAttributeValue = exports.AnchoredClock = exports.W3CBaggagePropagator = void 0;
        var W3CBaggagePropagator_1 = $281a441cdcb2cf36$var$require_W3CBaggagePropagator();
        Object.defineProperty(exports, "W3CBaggagePropagator", {
            enumerable: true,
            get: function() {
                return W3CBaggagePropagator_1.W3CBaggagePropagator;
            }
        });
        var anchored_clock_1 = $281a441cdcb2cf36$var$require_anchored_clock();
        Object.defineProperty(exports, "AnchoredClock", {
            enumerable: true,
            get: function() {
                return anchored_clock_1.AnchoredClock;
            }
        });
        var attributes_1 = $281a441cdcb2cf36$var$require_attributes();
        Object.defineProperty(exports, "isAttributeValue", {
            enumerable: true,
            get: function() {
                return attributes_1.isAttributeValue;
            }
        });
        Object.defineProperty(exports, "sanitizeAttributes", {
            enumerable: true,
            get: function() {
                return attributes_1.sanitizeAttributes;
            }
        });
        var global_error_handler_1 = $281a441cdcb2cf36$var$require_global_error_handler();
        Object.defineProperty(exports, "globalErrorHandler", {
            enumerable: true,
            get: function() {
                return global_error_handler_1.globalErrorHandler;
            }
        });
        Object.defineProperty(exports, "setGlobalErrorHandler", {
            enumerable: true,
            get: function() {
                return global_error_handler_1.setGlobalErrorHandler;
            }
        });
        var logging_error_handler_1 = $281a441cdcb2cf36$var$require_logging_error_handler();
        Object.defineProperty(exports, "loggingErrorHandler", {
            enumerable: true,
            get: function() {
                return logging_error_handler_1.loggingErrorHandler;
            }
        });
        var time_1 = $281a441cdcb2cf36$var$require_time();
        Object.defineProperty(exports, "addHrTimes", {
            enumerable: true,
            get: function() {
                return time_1.addHrTimes;
            }
        });
        Object.defineProperty(exports, "getTimeOrigin", {
            enumerable: true,
            get: function() {
                return time_1.getTimeOrigin;
            }
        });
        Object.defineProperty(exports, "hrTime", {
            enumerable: true,
            get: function() {
                return time_1.hrTime;
            }
        });
        Object.defineProperty(exports, "hrTimeDuration", {
            enumerable: true,
            get: function() {
                return time_1.hrTimeDuration;
            }
        });
        Object.defineProperty(exports, "hrTimeToMicroseconds", {
            enumerable: true,
            get: function() {
                return time_1.hrTimeToMicroseconds;
            }
        });
        Object.defineProperty(exports, "hrTimeToMilliseconds", {
            enumerable: true,
            get: function() {
                return time_1.hrTimeToMilliseconds;
            }
        });
        Object.defineProperty(exports, "hrTimeToNanoseconds", {
            enumerable: true,
            get: function() {
                return time_1.hrTimeToNanoseconds;
            }
        });
        Object.defineProperty(exports, "hrTimeToTimeStamp", {
            enumerable: true,
            get: function() {
                return time_1.hrTimeToTimeStamp;
            }
        });
        Object.defineProperty(exports, "isTimeInput", {
            enumerable: true,
            get: function() {
                return time_1.isTimeInput;
            }
        });
        Object.defineProperty(exports, "isTimeInputHrTime", {
            enumerable: true,
            get: function() {
                return time_1.isTimeInputHrTime;
            }
        });
        Object.defineProperty(exports, "millisToHrTime", {
            enumerable: true,
            get: function() {
                return time_1.millisToHrTime;
            }
        });
        Object.defineProperty(exports, "timeInputToHrTime", {
            enumerable: true,
            get: function() {
                return time_1.timeInputToHrTime;
            }
        });
        var ExportResult_1 = $281a441cdcb2cf36$var$require_ExportResult();
        Object.defineProperty(exports, "ExportResultCode", {
            enumerable: true,
            get: function() {
                return ExportResult_1.ExportResultCode;
            }
        });
        var utils_1 = $281a441cdcb2cf36$var$require_utils();
        Object.defineProperty(exports, "parseKeyPairsIntoRecord", {
            enumerable: true,
            get: function() {
                return utils_1.parseKeyPairsIntoRecord;
            }
        });
        var platform_1 = $281a441cdcb2cf36$var$require_browser();
        Object.defineProperty(exports, "SDK_INFO", {
            enumerable: true,
            get: function() {
                return platform_1.SDK_INFO;
            }
        });
        Object.defineProperty(exports, "_globalThis", {
            enumerable: true,
            get: function() {
                return platform_1._globalThis;
            }
        });
        Object.defineProperty(exports, "getStringFromEnv", {
            enumerable: true,
            get: function() {
                return platform_1.getStringFromEnv;
            }
        });
        Object.defineProperty(exports, "getBooleanFromEnv", {
            enumerable: true,
            get: function() {
                return platform_1.getBooleanFromEnv;
            }
        });
        Object.defineProperty(exports, "getNumberFromEnv", {
            enumerable: true,
            get: function() {
                return platform_1.getNumberFromEnv;
            }
        });
        Object.defineProperty(exports, "getStringListFromEnv", {
            enumerable: true,
            get: function() {
                return platform_1.getStringListFromEnv;
            }
        });
        Object.defineProperty(exports, "otperformance", {
            enumerable: true,
            get: function() {
                return platform_1.otperformance;
            }
        });
        Object.defineProperty(exports, "unrefTimer", {
            enumerable: true,
            get: function() {
                return platform_1.unrefTimer;
            }
        });
        var composite_1 = $281a441cdcb2cf36$var$require_composite();
        Object.defineProperty(exports, "CompositePropagator", {
            enumerable: true,
            get: function() {
                return composite_1.CompositePropagator;
            }
        });
        var W3CTraceContextPropagator_1 = $281a441cdcb2cf36$var$require_W3CTraceContextPropagator();
        Object.defineProperty(exports, "TRACE_PARENT_HEADER", {
            enumerable: true,
            get: function() {
                return W3CTraceContextPropagator_1.TRACE_PARENT_HEADER;
            }
        });
        Object.defineProperty(exports, "TRACE_STATE_HEADER", {
            enumerable: true,
            get: function() {
                return W3CTraceContextPropagator_1.TRACE_STATE_HEADER;
            }
        });
        Object.defineProperty(exports, "W3CTraceContextPropagator", {
            enumerable: true,
            get: function() {
                return W3CTraceContextPropagator_1.W3CTraceContextPropagator;
            }
        });
        Object.defineProperty(exports, "parseTraceParent", {
            enumerable: true,
            get: function() {
                return W3CTraceContextPropagator_1.parseTraceParent;
            }
        });
        var rpc_metadata_1 = $281a441cdcb2cf36$var$require_rpc_metadata();
        Object.defineProperty(exports, "RPCType", {
            enumerable: true,
            get: function() {
                return rpc_metadata_1.RPCType;
            }
        });
        Object.defineProperty(exports, "deleteRPCMetadata", {
            enumerable: true,
            get: function() {
                return rpc_metadata_1.deleteRPCMetadata;
            }
        });
        Object.defineProperty(exports, "getRPCMetadata", {
            enumerable: true,
            get: function() {
                return rpc_metadata_1.getRPCMetadata;
            }
        });
        Object.defineProperty(exports, "setRPCMetadata", {
            enumerable: true,
            get: function() {
                return rpc_metadata_1.setRPCMetadata;
            }
        });
        var suppress_tracing_1 = $281a441cdcb2cf36$var$require_suppress_tracing();
        Object.defineProperty(exports, "isTracingSuppressed", {
            enumerable: true,
            get: function() {
                return suppress_tracing_1.isTracingSuppressed;
            }
        });
        Object.defineProperty(exports, "suppressTracing", {
            enumerable: true,
            get: function() {
                return suppress_tracing_1.suppressTracing;
            }
        });
        Object.defineProperty(exports, "unsuppressTracing", {
            enumerable: true,
            get: function() {
                return suppress_tracing_1.unsuppressTracing;
            }
        });
        var TraceState_1 = $281a441cdcb2cf36$var$require_TraceState();
        Object.defineProperty(exports, "TraceState", {
            enumerable: true,
            get: function() {
                return TraceState_1.TraceState;
            }
        });
        var merge_1 = $281a441cdcb2cf36$var$require_merge();
        Object.defineProperty(exports, "merge", {
            enumerable: true,
            get: function() {
                return merge_1.merge;
            }
        });
        var timeout_1 = $281a441cdcb2cf36$var$require_timeout();
        Object.defineProperty(exports, "TimeoutError", {
            enumerable: true,
            get: function() {
                return timeout_1.TimeoutError;
            }
        });
        Object.defineProperty(exports, "callWithTimeout", {
            enumerable: true,
            get: function() {
                return timeout_1.callWithTimeout;
            }
        });
        var url_1 = $281a441cdcb2cf36$var$require_url();
        Object.defineProperty(exports, "isUrlIgnored", {
            enumerable: true,
            get: function() {
                return url_1.isUrlIgnored;
            }
        });
        Object.defineProperty(exports, "urlMatches", {
            enumerable: true,
            get: function() {
                return url_1.urlMatches;
            }
        });
        var callback_1 = $281a441cdcb2cf36$var$require_callback();
        Object.defineProperty(exports, "BindOnceFuture", {
            enumerable: true,
            get: function() {
                return callback_1.BindOnceFuture;
            }
        });
        var configuration_1 = $281a441cdcb2cf36$var$require_configuration();
        Object.defineProperty(exports, "diagLogLevelFromString", {
            enumerable: true,
            get: function() {
                return configuration_1.diagLogLevelFromString;
            }
        });
        var exporter_1 = $281a441cdcb2cf36$var$require_exporter();
        exports.internal = {
            _export: exporter_1._export
        };
    }
});
// ../node_modules/@opentelemetry/otlp-transformer/build/src/common/hex-to-binary.js
var $281a441cdcb2cf36$var$require_hex_to_binary = $281a441cdcb2cf36$var$__commonJS({
    "../node_modules/@opentelemetry/otlp-transformer/build/src/common/hex-to-binary.js" (exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.hexToBinary = void 0;
        function intValue(charCode) {
            if (charCode >= 48 && charCode <= 57) return charCode - 48;
            if (charCode >= 97 && charCode <= 102) return charCode - 87;
            return charCode - 55;
        }
        function hexToBinary(hexStr) {
            const buf = new Uint8Array(hexStr.length / 2);
            let offset2 = 0;
            for(let i3 = 0; i3 < hexStr.length; i3 += 2){
                const hi = intValue(hexStr.charCodeAt(i3));
                const lo = intValue(hexStr.charCodeAt(i3 + 1));
                buf[offset2++] = hi << 4 | lo;
            }
            return buf;
        }
        exports.hexToBinary = hexToBinary;
    }
});
// ../node_modules/@opentelemetry/otlp-transformer/build/src/common/utils.js
var $281a441cdcb2cf36$var$require_utils2 = $281a441cdcb2cf36$var$__commonJS({
    "../node_modules/@opentelemetry/otlp-transformer/build/src/common/utils.js" (exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.getOtlpEncoder = exports.encodeAsString = exports.encodeAsLongBits = exports.toLongBits = exports.hrTimeToNanos = void 0;
        var core_1 = $281a441cdcb2cf36$var$require_src();
        var hex_to_binary_1 = $281a441cdcb2cf36$var$require_hex_to_binary();
        function hrTimeToNanos(hrTime4) {
            const NANOSECONDS = BigInt(1e9);
            return BigInt(hrTime4[0]) * NANOSECONDS + BigInt(hrTime4[1]);
        }
        exports.hrTimeToNanos = hrTimeToNanos;
        function toLongBits(value2) {
            const low = Number(BigInt.asUintN(32, value2));
            const high = Number(BigInt.asUintN(32, value2 >> BigInt(32)));
            return {
                low: low,
                high: high
            };
        }
        exports.toLongBits = toLongBits;
        function encodeAsLongBits(hrTime4) {
            const nanos = hrTimeToNanos(hrTime4);
            return toLongBits(nanos);
        }
        exports.encodeAsLongBits = encodeAsLongBits;
        function encodeAsString(hrTime4) {
            const nanos = hrTimeToNanos(hrTime4);
            return nanos.toString();
        }
        exports.encodeAsString = encodeAsString;
        var encodeTimestamp = typeof BigInt !== "undefined" ? encodeAsString : core_1.hrTimeToNanoseconds;
        function identity(value2) {
            return value2;
        }
        function optionalHexToBinary(str) {
            if (str === void 0) return void 0;
            return (0, hex_to_binary_1.hexToBinary)(str);
        }
        var DEFAULT_ENCODER = {
            encodeHrTime: encodeAsLongBits,
            encodeSpanContext: hex_to_binary_1.hexToBinary,
            encodeOptionalSpanContext: optionalHexToBinary
        };
        function getOtlpEncoder(options) {
            var _a2, _b;
            if (options === void 0) return DEFAULT_ENCODER;
            const useLongBits = (_a2 = options.useLongBits) != null ? _a2 : true;
            const useHex = (_b = options.useHex) != null ? _b : false;
            return {
                encodeHrTime: useLongBits ? encodeAsLongBits : encodeTimestamp,
                encodeSpanContext: useHex ? identity : hex_to_binary_1.hexToBinary,
                encodeOptionalSpanContext: useHex ? identity : optionalHexToBinary
            };
        }
        exports.getOtlpEncoder = getOtlpEncoder;
    }
});
// ../node_modules/@opentelemetry/otlp-transformer/build/src/trace/internal.js
var $281a441cdcb2cf36$var$require_internal2 = $281a441cdcb2cf36$var$__commonJS({
    "../node_modules/@opentelemetry/otlp-transformer/build/src/trace/internal.js" (exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.createExportTraceServiceRequest = exports.toOtlpSpanEvent = exports.toOtlpLink = exports.sdkSpanToOtlpSpan = void 0;
        var internal_1 = $281a441cdcb2cf36$var$require_internal();
        var utils_1 = $281a441cdcb2cf36$var$require_utils2();
        function sdkSpanToOtlpSpan(span, encoder) {
            var _a2, _b, _c;
            const ctx = span.spanContext();
            const status = span.status;
            const parentSpanId = ((_a2 = span.parentSpanContext) == null ? void 0 : _a2.spanId) ? encoder.encodeSpanContext((_b = span.parentSpanContext) == null ? void 0 : _b.spanId) : void 0;
            return {
                traceId: encoder.encodeSpanContext(ctx.traceId),
                spanId: encoder.encodeSpanContext(ctx.spanId),
                parentSpanId: parentSpanId,
                traceState: (_c = ctx.traceState) == null ? void 0 : _c.serialize(),
                name: span.name,
                // Span kind is offset by 1 because the API does not define a value for unset
                kind: span.kind == null ? 0 : span.kind + 1,
                startTimeUnixNano: encoder.encodeHrTime(span.startTime),
                endTimeUnixNano: encoder.encodeHrTime(span.endTime),
                attributes: (0, internal_1.toAttributes)(span.attributes),
                droppedAttributesCount: span.droppedAttributesCount,
                events: span.events.map((event)=>toOtlpSpanEvent(event, encoder)),
                droppedEventsCount: span.droppedEventsCount,
                status: {
                    // API and proto enums share the same values
                    code: status.code,
                    message: status.message
                },
                links: span.links.map((link)=>toOtlpLink(link, encoder)),
                droppedLinksCount: span.droppedLinksCount
            };
        }
        exports.sdkSpanToOtlpSpan = sdkSpanToOtlpSpan;
        function toOtlpLink(link, encoder) {
            var _a2;
            return {
                attributes: link.attributes ? (0, internal_1.toAttributes)(link.attributes) : [],
                spanId: encoder.encodeSpanContext(link.context.spanId),
                traceId: encoder.encodeSpanContext(link.context.traceId),
                traceState: (_a2 = link.context.traceState) == null ? void 0 : _a2.serialize(),
                droppedAttributesCount: link.droppedAttributesCount || 0
            };
        }
        exports.toOtlpLink = toOtlpLink;
        function toOtlpSpanEvent(timedEvent, encoder) {
            return {
                attributes: timedEvent.attributes ? (0, internal_1.toAttributes)(timedEvent.attributes) : [],
                name: timedEvent.name,
                timeUnixNano: encoder.encodeHrTime(timedEvent.time),
                droppedAttributesCount: timedEvent.droppedAttributesCount || 0
            };
        }
        exports.toOtlpSpanEvent = toOtlpSpanEvent;
        function createExportTraceServiceRequest2(spans, options) {
            const encoder = (0, utils_1.getOtlpEncoder)(options);
            return {
                resourceSpans: spanRecordsToResourceSpans(spans, encoder)
            };
        }
        exports.createExportTraceServiceRequest = createExportTraceServiceRequest2;
        function createResourceMap(readableSpans) {
            const resourceMap = /* @__PURE__ */ new Map();
            for (const record of readableSpans){
                let ilsMap = resourceMap.get(record.resource);
                if (!ilsMap) {
                    ilsMap = /* @__PURE__ */ new Map();
                    resourceMap.set(record.resource, ilsMap);
                }
                const instrumentationScopeKey = `${record.instrumentationScope.name}@${record.instrumentationScope.version || ""}:${record.instrumentationScope.schemaUrl || ""}`;
                let records = ilsMap.get(instrumentationScopeKey);
                if (!records) {
                    records = [];
                    ilsMap.set(instrumentationScopeKey, records);
                }
                records.push(record);
            }
            return resourceMap;
        }
        function spanRecordsToResourceSpans(readableSpans, encoder) {
            const resourceMap = createResourceMap(readableSpans);
            const out = [];
            const entryIterator = resourceMap.entries();
            let entry = entryIterator.next();
            while(!entry.done){
                const [resource, ilmMap] = entry.value;
                const scopeResourceSpans = [];
                const ilmIterator = ilmMap.values();
                let ilmEntry = ilmIterator.next();
                while(!ilmEntry.done){
                    const scopeSpans = ilmEntry.value;
                    if (scopeSpans.length > 0) {
                        const spans = scopeSpans.map((readableSpan)=>sdkSpanToOtlpSpan(readableSpan, encoder));
                        scopeResourceSpans.push({
                            scope: (0, internal_1.createInstrumentationScope)(scopeSpans[0].instrumentationScope),
                            spans: spans,
                            schemaUrl: scopeSpans[0].instrumentationScope.schemaUrl
                        });
                    }
                    ilmEntry = ilmIterator.next();
                }
                const transformedSpans = {
                    resource: (0, internal_1.createResource)(resource),
                    scopeSpans: scopeResourceSpans,
                    schemaUrl: void 0
                };
                out.push(transformedSpans);
                entry = entryIterator.next();
            }
            return out;
        }
    }
});
// ../node_modules/@opentelemetry/otlp-transformer/build/src/trace/internal-types.js
var $281a441cdcb2cf36$var$require_internal_types = $281a441cdcb2cf36$var$__commonJS({
    "../node_modules/@opentelemetry/otlp-transformer/build/src/trace/internal-types.js" (exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.EStatusCode = exports.ESpanKind = void 0;
        var ESpanKind2;
        (function(ESpanKind3) {
            ESpanKind3[ESpanKind3["SPAN_KIND_UNSPECIFIED"] = 0] = "SPAN_KIND_UNSPECIFIED";
            ESpanKind3[ESpanKind3["SPAN_KIND_INTERNAL"] = 1] = "SPAN_KIND_INTERNAL";
            ESpanKind3[ESpanKind3["SPAN_KIND_SERVER"] = 2] = "SPAN_KIND_SERVER";
            ESpanKind3[ESpanKind3["SPAN_KIND_CLIENT"] = 3] = "SPAN_KIND_CLIENT";
            ESpanKind3[ESpanKind3["SPAN_KIND_PRODUCER"] = 4] = "SPAN_KIND_PRODUCER";
            ESpanKind3[ESpanKind3["SPAN_KIND_CONSUMER"] = 5] = "SPAN_KIND_CONSUMER";
        })(ESpanKind2 = exports.ESpanKind || (exports.ESpanKind = {}));
        var EStatusCode;
        (function(EStatusCode2) {
            EStatusCode2[EStatusCode2["STATUS_CODE_UNSET"] = 0] = "STATUS_CODE_UNSET";
            EStatusCode2[EStatusCode2["STATUS_CODE_OK"] = 1] = "STATUS_CODE_OK";
            EStatusCode2[EStatusCode2["STATUS_CODE_ERROR"] = 2] = "STATUS_CODE_ERROR";
        })(EStatusCode = exports.EStatusCode || (exports.EStatusCode = {}));
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/utils/is.js
function $281a441cdcb2cf36$var$isTypeof(value2, type) {
    return typeof value2 === type;
}
function $281a441cdcb2cf36$var$isToString(value2, type) {
    return Object.prototype.toString.call(value2) === `[object ${type}]`;
}
function $281a441cdcb2cf36$var$isInstanceOf(value2, reference) {
    try {
        return value2 instanceof reference;
    } catch (err) {
        return false;
    }
}
function $281a441cdcb2cf36$var$isEmpty2(value2) {
    if (value2 == null) return true;
    if ($281a441cdcb2cf36$var$isArray4(value2) || $281a441cdcb2cf36$var$isString(value2)) return value2.length === 0;
    if ($281a441cdcb2cf36$var$isObject4(value2)) return Object.keys(value2).length === 0;
    return false;
}
var $281a441cdcb2cf36$var$isUndefined, $281a441cdcb2cf36$var$isNull, $281a441cdcb2cf36$var$isString, $281a441cdcb2cf36$var$isNumber, $281a441cdcb2cf36$var$isInt, $281a441cdcb2cf36$var$isBoolean, $281a441cdcb2cf36$var$isSymbol, $281a441cdcb2cf36$var$isObject4, $281a441cdcb2cf36$var$isFunction3, $281a441cdcb2cf36$var$isArray4, $281a441cdcb2cf36$var$isRegExp, $281a441cdcb2cf36$var$isThenable, $281a441cdcb2cf36$var$isPrimitive2, $281a441cdcb2cf36$var$isEventDefined, $281a441cdcb2cf36$var$isEvent, $281a441cdcb2cf36$var$isErrorDefined, $281a441cdcb2cf36$var$isError, $281a441cdcb2cf36$var$isErrorEvent, $281a441cdcb2cf36$var$isDomError, $281a441cdcb2cf36$var$isDomException, $281a441cdcb2cf36$var$isElementDefined, $281a441cdcb2cf36$var$isElement, $281a441cdcb2cf36$var$isMapDefined, $281a441cdcb2cf36$var$isMap, $281a441cdcb2cf36$var$isSyntheticEvent;
var $281a441cdcb2cf36$var$init_is = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/utils/is.js" () {
        $281a441cdcb2cf36$var$isUndefined = (value2)=>$281a441cdcb2cf36$var$isTypeof(value2, "undefined");
        $281a441cdcb2cf36$var$isNull = (value2)=>$281a441cdcb2cf36$var$isTypeof(value2, "null");
        $281a441cdcb2cf36$var$isString = (value2)=>$281a441cdcb2cf36$var$isTypeof(value2, "string");
        $281a441cdcb2cf36$var$isNumber = (value2)=>$281a441cdcb2cf36$var$isTypeof(value2, "number") && !isNaN(value2) || $281a441cdcb2cf36$var$isTypeof(value2, "bigint");
        $281a441cdcb2cf36$var$isInt = (value2)=>$281a441cdcb2cf36$var$isNumber(value2) && Number.isInteger(value2);
        $281a441cdcb2cf36$var$isBoolean = (value2)=>$281a441cdcb2cf36$var$isTypeof(value2, "boolean");
        $281a441cdcb2cf36$var$isSymbol = (value2)=>$281a441cdcb2cf36$var$isTypeof(value2, "symbol");
        $281a441cdcb2cf36$var$isObject4 = (value2)=>!$281a441cdcb2cf36$var$isNull(value2) && $281a441cdcb2cf36$var$isTypeof(value2, "object");
        $281a441cdcb2cf36$var$isFunction3 = (value2)=>$281a441cdcb2cf36$var$isTypeof(value2, "function");
        $281a441cdcb2cf36$var$isArray4 = (value2)=>$281a441cdcb2cf36$var$isToString(value2, "Array");
        $281a441cdcb2cf36$var$isRegExp = (value2)=>$281a441cdcb2cf36$var$isToString(value2, "RegExp");
        $281a441cdcb2cf36$var$isThenable = (value2)=>$281a441cdcb2cf36$var$isFunction3(value2 === null || value2 === void 0 ? void 0 : value2.then);
        $281a441cdcb2cf36$var$isPrimitive2 = (value2)=>!$281a441cdcb2cf36$var$isObject4(value2) && !$281a441cdcb2cf36$var$isFunction3(value2);
        $281a441cdcb2cf36$var$isEventDefined = typeof Event !== "undefined";
        $281a441cdcb2cf36$var$isEvent = (value2)=>$281a441cdcb2cf36$var$isEventDefined && $281a441cdcb2cf36$var$isInstanceOf(value2, Event);
        $281a441cdcb2cf36$var$isErrorDefined = typeof Error !== "undefined";
        $281a441cdcb2cf36$var$isError = (value2)=>$281a441cdcb2cf36$var$isErrorDefined && $281a441cdcb2cf36$var$isInstanceOf(value2, Error);
        $281a441cdcb2cf36$var$isErrorEvent = (value2)=>$281a441cdcb2cf36$var$isToString(value2, "ErrorEvent");
        $281a441cdcb2cf36$var$isDomError = (value2)=>$281a441cdcb2cf36$var$isToString(value2, "DOMError");
        $281a441cdcb2cf36$var$isDomException = (value2)=>$281a441cdcb2cf36$var$isToString(value2, "DOMException");
        $281a441cdcb2cf36$var$isElementDefined = typeof Element !== "undefined";
        $281a441cdcb2cf36$var$isElement = (value2)=>$281a441cdcb2cf36$var$isElementDefined && $281a441cdcb2cf36$var$isInstanceOf(value2, Element);
        $281a441cdcb2cf36$var$isMapDefined = typeof Map !== "undefined";
        $281a441cdcb2cf36$var$isMap = (value2)=>$281a441cdcb2cf36$var$isMapDefined && $281a441cdcb2cf36$var$isInstanceOf(value2, Map);
        $281a441cdcb2cf36$var$isSyntheticEvent = (value2)=>$281a441cdcb2cf36$var$isObject4(value2) && "nativeEvent" in value2 && "preventDefault" in value2 && "stopPropagation" in value2;
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/utils/deepEqual.js
function $281a441cdcb2cf36$var$deepEqual2(a3, b3) {
    if (a3 === b3) return true;
    if ($281a441cdcb2cf36$var$isTypeof(a3, "number") && isNaN(a3)) return $281a441cdcb2cf36$var$isTypeof(b3, "number") && isNaN(b3);
    const aIsArray = $281a441cdcb2cf36$var$isArray4(a3);
    const bIsArray = $281a441cdcb2cf36$var$isArray4(b3);
    if (aIsArray !== bIsArray) return false;
    if (aIsArray && bIsArray) {
        const length2 = a3.length;
        if (length2 !== b3.length) return false;
        for(let idx = length2; idx-- !== 0;){
            if (!$281a441cdcb2cf36$var$deepEqual2(a3[idx], b3[idx])) return false;
        }
        return true;
    }
    const aIsObject = $281a441cdcb2cf36$var$isObject4(a3);
    const bIsObject = $281a441cdcb2cf36$var$isObject4(b3);
    if (aIsObject !== bIsObject) return false;
    if (a3 && b3 && aIsObject && bIsObject) {
        const aKeys = Object.keys(a3);
        const bKeys = Object.keys(b3);
        const aLength = aKeys.length;
        const bLength = bKeys.length;
        if (aLength !== bLength) return false;
        for (let aKey of aKeys){
            if (!bKeys.includes(aKey)) return false;
        }
        for (let aKey of aKeys){
            if (!$281a441cdcb2cf36$var$deepEqual2(a3[aKey], b3[aKey])) return false;
        }
        return true;
    }
    return false;
}
var $281a441cdcb2cf36$var$init_deepEqual = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/utils/deepEqual.js" () {
        $281a441cdcb2cf36$var$init_is();
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/utils/date.js
function $281a441cdcb2cf36$var$dateNow() {
    return Date.now();
}
function $281a441cdcb2cf36$var$getCurrentTimestamp() {
    return /* @__PURE__ */ new Date().toISOString();
}
function $281a441cdcb2cf36$var$timestampToIsoString(value2) {
    return new Date(value2).toISOString();
}
var $281a441cdcb2cf36$var$init_date = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/utils/date.js" () {}
});
// ../node_modules/@grafana/faro-core/dist/esm/utils/logLevels.js
var $281a441cdcb2cf36$var$LogLevel, $281a441cdcb2cf36$var$defaultLogLevel, $281a441cdcb2cf36$var$allLogLevels;
var $281a441cdcb2cf36$var$init_logLevels = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/utils/logLevels.js" () {
        (function(LogLevel2) {
            LogLevel2["TRACE"] = "trace";
            LogLevel2["DEBUG"] = "debug";
            LogLevel2["INFO"] = "info";
            LogLevel2["LOG"] = "log";
            LogLevel2["WARN"] = "warn";
            LogLevel2["ERROR"] = "error";
        })($281a441cdcb2cf36$var$LogLevel || ($281a441cdcb2cf36$var$LogLevel = {}));
        $281a441cdcb2cf36$var$defaultLogLevel = $281a441cdcb2cf36$var$LogLevel.LOG;
        $281a441cdcb2cf36$var$allLogLevels = [
            $281a441cdcb2cf36$var$LogLevel.TRACE,
            $281a441cdcb2cf36$var$LogLevel.DEBUG,
            $281a441cdcb2cf36$var$LogLevel.INFO,
            $281a441cdcb2cf36$var$LogLevel.LOG,
            $281a441cdcb2cf36$var$LogLevel.WARN,
            $281a441cdcb2cf36$var$LogLevel.ERROR
        ];
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/utils/noop.js
function $281a441cdcb2cf36$var$noop2() {}
var $281a441cdcb2cf36$var$init_noop = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/utils/noop.js" () {}
});
// ../node_modules/@grafana/faro-core/dist/esm/utils/promiseBuffer.js
function $281a441cdcb2cf36$var$createPromiseBuffer(options) {
    const { size: size2, concurrency: concurrency } = options;
    const buffer = [];
    let inProgress = 0;
    const work = ()=>{
        if (inProgress < concurrency && buffer.length) {
            const { producer: producer, resolve: resolve, reject: reject } = buffer.shift();
            inProgress++;
            producer().then((result)=>{
                inProgress--;
                work();
                resolve(result);
            }, (reason)=>{
                inProgress--;
                work();
                reject(reason);
            });
        }
    };
    const add2 = (promiseProducer)=>{
        if (buffer.length + inProgress >= size2) throw new Error("Task buffer full");
        return new Promise((resolve, reject)=>{
            buffer.push({
                producer: promiseProducer,
                resolve: resolve,
                reject: reject
            });
            work();
        });
    };
    return {
        add: add2
    };
}
var $281a441cdcb2cf36$var$init_promiseBuffer = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/utils/promiseBuffer.js" () {}
});
// ../node_modules/@grafana/faro-core/dist/esm/utils/shortId.js
function $281a441cdcb2cf36$var$genShortID(length2 = 10) {
    return Array.from(Array(length2)).map(()=>$281a441cdcb2cf36$var$alphabet[Math.floor(Math.random() * $281a441cdcb2cf36$var$alphabet.length)]).join("");
}
var $281a441cdcb2cf36$var$alphabet;
var $281a441cdcb2cf36$var$init_shortId = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/utils/shortId.js" () {
        $281a441cdcb2cf36$var$alphabet = "abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ0123456789";
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/globalObject/globalObject.js
var $281a441cdcb2cf36$var$globalObject;
var $281a441cdcb2cf36$var$init_globalObject = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/globalObject/globalObject.js" () {
        $281a441cdcb2cf36$var$globalObject = typeof globalThis !== "undefined" ? globalThis : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : void 0;
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/globalObject/index.js
var $281a441cdcb2cf36$var$init_globalObject2 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/globalObject/index.js" () {
        $281a441cdcb2cf36$var$init_globalObject();
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/utils/sourceMaps.js
function $281a441cdcb2cf36$var$getBundleId(appName) {
    return $281a441cdcb2cf36$var$globalObject === null || $281a441cdcb2cf36$var$globalObject === void 0 ? void 0 : $281a441cdcb2cf36$var$globalObject[`__faroBundleId_${appName}`];
}
var $281a441cdcb2cf36$var$init_sourceMaps = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/utils/sourceMaps.js" () {
        $281a441cdcb2cf36$var$init_globalObject2();
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/utils/json.js
function $281a441cdcb2cf36$var$getCircularDependencyReplacer() {
    const valueSeen = /* @__PURE__ */ new WeakSet();
    return function(_key, value2) {
        if ($281a441cdcb2cf36$var$isObject4(value2) && value2 !== null) {
            if (valueSeen.has(value2)) return null;
            valueSeen.add(value2);
        }
        return value2;
    };
}
function $281a441cdcb2cf36$var$stringifyExternalJson(json = {}) {
    return JSON.stringify(json !== null && json !== void 0 ? json : {}, $281a441cdcb2cf36$var$getCircularDependencyReplacer());
}
function $281a441cdcb2cf36$var$stringifyObjectValues(obj = {}) {
    const o3 = {};
    for (const [key, value2] of Object.entries(obj))o3[key] = $281a441cdcb2cf36$var$isObject4(value2) && value2 !== null ? $281a441cdcb2cf36$var$stringifyExternalJson(value2) : String(value2);
    return o3;
}
var $281a441cdcb2cf36$var$init_json = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/utils/json.js" () {
        $281a441cdcb2cf36$var$init_is();
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/utils/reactive.js
var $281a441cdcb2cf36$var$Observable2;
var $281a441cdcb2cf36$var$init_reactive = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/utils/reactive.js" () {
        $281a441cdcb2cf36$var$Observable2 = class _Observable {
            constructor(){
                this.subscribers = [];
            }
            subscribe(subscriber) {
                this.subscribers.push(subscriber);
                return {
                    unsubscribe: ()=>this.unsubscribe(subscriber)
                };
            }
            unsubscribe(subscriber) {
                this.subscribers = this.subscribers.filter((sub)=>sub !== subscriber);
            }
            notify(value2) {
                this.subscribers.forEach((subscriber)=>subscriber(value2));
            }
            first() {
                const result = new _Observable();
                const internalSubscriber = (data2)=>{
                    result.notify(data2);
                    subscription.unsubscribe();
                };
                const subscription = this.subscribe(internalSubscriber);
                const resultUnsubscribeFn = result.unsubscribe.bind(result);
                return this.withUnsubscribeOverride(result, resultUnsubscribeFn, internalSubscriber);
            }
            takeWhile(predicate) {
                const result = new _Observable();
                const internalSubscriber = (value2)=>{
                    if (predicate(value2)) result.notify(value2);
                    else result.unsubscribe(internalSubscriber);
                };
                this.subscribe(internalSubscriber);
                const resultUnsubscribeFn = result.unsubscribe.bind(result);
                return this.withUnsubscribeOverride(result, resultUnsubscribeFn, internalSubscriber);
            }
            filter(predicate) {
                const result = new _Observable();
                const internalSubscriber = (value2)=>{
                    if (predicate(value2)) result.notify(value2);
                };
                this.subscribe(internalSubscriber);
                const resultUnsubscribeFn = result.unsubscribe.bind(result);
                return this.withUnsubscribeOverride(result, resultUnsubscribeFn, internalSubscriber);
            }
            merge(...observables) {
                const mergerObservable = new _Observable();
                const subscriptions = [];
                observables.forEach((observable)=>{
                    const subscription = observable.subscribe((value2)=>{
                        mergerObservable.notify(value2);
                    });
                    subscriptions.push(subscription);
                });
                const originalUnsubscribeAll = mergerObservable.unsubscribeAll.bind(mergerObservable);
                mergerObservable.unsubscribe = ()=>{
                    subscriptions.forEach((subscription)=>subscription.unsubscribe());
                    originalUnsubscribeAll();
                };
                return mergerObservable;
            }
            withUnsubscribeOverride(observable, resultUnsubscribeFn, internalSubscriber) {
                observable.unsubscribe = (subscriber)=>{
                    resultUnsubscribeFn(subscriber);
                    this.unsubscribe(internalSubscriber);
                };
                return observable;
            }
            unsubscribeAll() {
                this.subscribers = [];
            }
        };
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/utils/index.js
var $281a441cdcb2cf36$var$init_utils5 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/utils/index.js" () {
        $281a441cdcb2cf36$var$init_deepEqual();
        $281a441cdcb2cf36$var$init_date();
        $281a441cdcb2cf36$var$init_is();
        $281a441cdcb2cf36$var$init_logLevels();
        $281a441cdcb2cf36$var$init_noop();
        $281a441cdcb2cf36$var$init_promiseBuffer();
        $281a441cdcb2cf36$var$init_shortId();
        $281a441cdcb2cf36$var$init_date();
        $281a441cdcb2cf36$var$init_json();
        $281a441cdcb2cf36$var$init_reactive();
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/transports/batchExecutor.js
var $281a441cdcb2cf36$var$DEFAULT_SEND_TIMEOUT_MS, $281a441cdcb2cf36$var$DEFAULT_BATCH_ITEM_LIMIT, $281a441cdcb2cf36$var$BatchExecutor;
var $281a441cdcb2cf36$var$init_batchExecutor = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/transports/batchExecutor.js" () {
        $281a441cdcb2cf36$var$DEFAULT_SEND_TIMEOUT_MS = 250;
        $281a441cdcb2cf36$var$DEFAULT_BATCH_ITEM_LIMIT = 50;
        $281a441cdcb2cf36$var$BatchExecutor = class {
            constructor(sendFn, options){
                var _a2, _b;
                this.signalBuffer = [];
                this.itemLimit = (_a2 = options === null || options === void 0 ? void 0 : options.itemLimit) !== null && _a2 !== void 0 ? _a2 : $281a441cdcb2cf36$var$DEFAULT_BATCH_ITEM_LIMIT;
                this.sendTimeout = (_b = options === null || options === void 0 ? void 0 : options.sendTimeout) !== null && _b !== void 0 ? _b : $281a441cdcb2cf36$var$DEFAULT_SEND_TIMEOUT_MS;
                this.paused = (options === null || options === void 0 ? void 0 : options.paused) || false;
                this.sendFn = sendFn;
                this.flushInterval = -1;
                if (!this.paused) this.start();
                document.addEventListener("visibilitychange", ()=>{
                    if (document.visibilityState === "hidden") this.flush();
                });
            }
            addItem(item) {
                if (this.paused) return;
                this.signalBuffer.push(item);
                if (this.signalBuffer.length >= this.itemLimit) this.flush();
            }
            start() {
                this.paused = false;
                if (this.sendTimeout > 0) this.flushInterval = window.setInterval(()=>this.flush(), this.sendTimeout);
            }
            pause() {
                this.paused = true;
                clearInterval(this.flushInterval);
            }
            groupItems(items) {
                const itemMap = /* @__PURE__ */ new Map();
                items.forEach((item)=>{
                    const metaKey = JSON.stringify(item.meta);
                    let currentItems = itemMap.get(metaKey);
                    if (currentItems === void 0) currentItems = [
                        item
                    ];
                    else currentItems = [
                        ...currentItems,
                        item
                    ];
                    itemMap.set(metaKey, currentItems);
                });
                return Array.from(itemMap.values());
            }
            flush() {
                if (this.paused || this.signalBuffer.length === 0) return;
                const itemGroups = this.groupItems(this.signalBuffer);
                itemGroups.forEach(this.sendFn);
                this.signalBuffer = [];
            }
        };
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/transports/const.js
var $281a441cdcb2cf36$var$TransportItemType, $281a441cdcb2cf36$var$transportItemTypeToBodyKey;
var $281a441cdcb2cf36$var$init_const = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/transports/const.js" () {
        (function(TransportItemType2) {
            TransportItemType2["EXCEPTION"] = "exception";
            TransportItemType2["LOG"] = "log";
            TransportItemType2["MEASUREMENT"] = "measurement";
            TransportItemType2["TRACE"] = "trace";
            TransportItemType2["EVENT"] = "event";
        })($281a441cdcb2cf36$var$TransportItemType || ($281a441cdcb2cf36$var$TransportItemType = {}));
        $281a441cdcb2cf36$var$transportItemTypeToBodyKey = {
            [$281a441cdcb2cf36$var$TransportItemType.EXCEPTION]: "exceptions",
            [$281a441cdcb2cf36$var$TransportItemType.LOG]: "logs",
            [$281a441cdcb2cf36$var$TransportItemType.MEASUREMENT]: "measurements",
            [$281a441cdcb2cf36$var$TransportItemType.TRACE]: "traces",
            [$281a441cdcb2cf36$var$TransportItemType.EVENT]: "events"
        };
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/transports/initialize.js
function $281a441cdcb2cf36$var$initializeTransports(unpatchedConsole2, internalLogger2, config, metas) {
    var _a2;
    internalLogger2.debug("Initializing transports");
    const transports2 = [];
    let paused = config.paused;
    let beforeSendHooks = [];
    const add2 = (...newTransports)=>{
        internalLogger2.debug("Adding transports");
        newTransports.forEach((newTransport)=>{
            internalLogger2.debug(`Adding "${newTransport.name}" transport`);
            const exists = transports2.some((existingTransport)=>existingTransport === newTransport);
            if (exists) {
                internalLogger2.warn(`Transport ${newTransport.name} is already added`);
                return;
            }
            newTransport.unpatchedConsole = unpatchedConsole2;
            newTransport.internalLogger = internalLogger2;
            newTransport.config = config;
            newTransport.metas = metas;
            transports2.push(newTransport);
        });
    };
    const addBeforeSendHooks = (...newBeforeSendHooks)=>{
        internalLogger2.debug("Adding beforeSendHooks\n", beforeSendHooks);
        newBeforeSendHooks.forEach((beforeSendHook)=>{
            if (beforeSendHook) beforeSendHooks.push(beforeSendHook);
        });
    };
    const applyBeforeSendHooks = (items)=>{
        let filteredItems = items;
        for (const hook of beforeSendHooks){
            const modified = filteredItems.map(hook).filter(Boolean);
            if (modified.length === 0) return [];
            filteredItems = $281a441cdcb2cf36$var$sanitizeItems(modified, config);
        }
        return filteredItems;
    };
    const batchedSend = (items)=>{
        const filteredItems = applyBeforeSendHooks(items);
        if (filteredItems.length === 0) return;
        for (const transport of transports2){
            internalLogger2.debug(`Transporting item using ${transport.name}
`, filteredItems);
            if (transport.isBatched()) transport.send(filteredItems);
        }
    };
    const instantSend = (item)=>{
        var _a3, _b;
        if (((_a3 = config.batching) === null || _a3 === void 0 ? void 0 : _a3.enabled) && transports2.every((transport)=>transport.isBatched())) return;
        const [filteredItem] = applyBeforeSendHooks([
            item
        ]);
        if (filteredItem === void 0) return;
        for (const transport of transports2){
            internalLogger2.debug(`Transporting item using ${transport.name}
`, filteredItem);
            if (!transport.isBatched()) transport.send(filteredItem);
            else if (!((_b = config.batching) === null || _b === void 0 ? void 0 : _b.enabled)) transport.send([
                filteredItem
            ]);
        }
    };
    let batchExecutor;
    if ((_a2 = config.batching) === null || _a2 === void 0 ? void 0 : _a2.enabled) batchExecutor = new $281a441cdcb2cf36$var$BatchExecutor(batchedSend, {
        sendTimeout: config.batching.sendTimeout,
        itemLimit: config.batching.itemLimit,
        paused: paused
    });
    const execute = (item)=>{
        var _a3;
        if (paused) return;
        if ((_a3 = config.batching) === null || _a3 === void 0 ? void 0 : _a3.enabled) batchExecutor === null || batchExecutor === void 0 || batchExecutor.addItem(item);
        instantSend(item);
    };
    const getBeforeSendHooks = ()=>[
            ...beforeSendHooks
        ];
    const isPaused = ()=>paused;
    const pause = ()=>{
        internalLogger2.debug("Pausing transports");
        batchExecutor === null || batchExecutor === void 0 || batchExecutor.pause();
        paused = true;
    };
    const remove3 = (...transportsToRemove)=>{
        internalLogger2.debug("Removing transports");
        transportsToRemove.forEach((transportToRemove)=>{
            internalLogger2.debug(`Removing "${transportToRemove.name}" transport`);
            const existingTransportIndex = transports2.indexOf(transportToRemove);
            if (existingTransportIndex === -1) {
                internalLogger2.warn(`Transport "${transportToRemove.name}" is not added`);
                return;
            }
            transports2.splice(existingTransportIndex, 1);
        });
    };
    const removeBeforeSendHooks = (...beforeSendHooksToRemove)=>{
        beforeSendHooks.filter((beforeSendHook)=>!beforeSendHooksToRemove.includes(beforeSendHook));
    };
    const unpause = ()=>{
        internalLogger2.debug("Unpausing transports");
        batchExecutor === null || batchExecutor === void 0 || batchExecutor.start();
        paused = false;
    };
    return {
        add: add2,
        addBeforeSendHooks: addBeforeSendHooks,
        getBeforeSendHooks: getBeforeSendHooks,
        execute: execute,
        isPaused: isPaused,
        pause: pause,
        remove: remove3,
        removeBeforeSendHooks: removeBeforeSendHooks,
        get transports () {
            return [
                ...transports2
            ];
        },
        unpause: unpause
    };
}
function $281a441cdcb2cf36$var$sanitizeItems(filteredItems, config) {
    if (config.preserveOriginalError) {
        for (const item of filteredItems)if (item.type === $281a441cdcb2cf36$var$TransportItemType.EXCEPTION) delete item.payload.originalError;
    }
    return filteredItems;
}
var $281a441cdcb2cf36$var$init_initialize = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/transports/initialize.js" () {
        $281a441cdcb2cf36$var$init_batchExecutor();
        $281a441cdcb2cf36$var$init_const();
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/internalLogger/const.js
var $281a441cdcb2cf36$var$InternalLoggerLevel, $281a441cdcb2cf36$var$defaultInternalLoggerPrefix, $281a441cdcb2cf36$var$defaultInternalLogger, $281a441cdcb2cf36$var$defaultInternalLoggerLevel;
var $281a441cdcb2cf36$var$init_const2 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/internalLogger/const.js" () {
        $281a441cdcb2cf36$var$init_utils5();
        (function(InternalLoggerLevel2) {
            InternalLoggerLevel2[InternalLoggerLevel2["OFF"] = 0] = "OFF";
            InternalLoggerLevel2[InternalLoggerLevel2["ERROR"] = 1] = "ERROR";
            InternalLoggerLevel2[InternalLoggerLevel2["WARN"] = 2] = "WARN";
            InternalLoggerLevel2[InternalLoggerLevel2["INFO"] = 3] = "INFO";
            InternalLoggerLevel2[InternalLoggerLevel2["VERBOSE"] = 4] = "VERBOSE";
        })($281a441cdcb2cf36$var$InternalLoggerLevel || ($281a441cdcb2cf36$var$InternalLoggerLevel = {}));
        $281a441cdcb2cf36$var$defaultInternalLoggerPrefix = "Faro";
        $281a441cdcb2cf36$var$defaultInternalLogger = {
            debug: $281a441cdcb2cf36$var$noop2,
            error: $281a441cdcb2cf36$var$noop2,
            info: $281a441cdcb2cf36$var$noop2,
            prefix: $281a441cdcb2cf36$var$defaultInternalLoggerPrefix,
            warn: $281a441cdcb2cf36$var$noop2
        };
        $281a441cdcb2cf36$var$defaultInternalLoggerLevel = $281a441cdcb2cf36$var$InternalLoggerLevel.ERROR;
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/unpatchedConsole/const.js
var $281a441cdcb2cf36$var$defaultUnpatchedConsole;
var $281a441cdcb2cf36$var$init_const3 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/unpatchedConsole/const.js" () {
        $281a441cdcb2cf36$var$defaultUnpatchedConsole = Object.assign({}, console);
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/unpatchedConsole/initialize.js
function $281a441cdcb2cf36$var$initializeUnpatchedConsole(config) {
    var _a2;
    $281a441cdcb2cf36$var$unpatchedConsole = (_a2 = config.unpatchedConsole) !== null && _a2 !== void 0 ? _a2 : $281a441cdcb2cf36$var$unpatchedConsole;
    return $281a441cdcb2cf36$var$unpatchedConsole;
}
var $281a441cdcb2cf36$var$unpatchedConsole;
var $281a441cdcb2cf36$var$init_initialize2 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/unpatchedConsole/initialize.js" () {
        $281a441cdcb2cf36$var$init_const3();
        $281a441cdcb2cf36$var$unpatchedConsole = $281a441cdcb2cf36$var$defaultUnpatchedConsole;
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/unpatchedConsole/index.js
var $281a441cdcb2cf36$var$init_unpatchedConsole = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/unpatchedConsole/index.js" () {
        $281a441cdcb2cf36$var$init_const3();
        $281a441cdcb2cf36$var$init_initialize2();
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/internalLogger/createInternalLogger.js
function $281a441cdcb2cf36$var$createInternalLogger(unpatchedConsole2 = $281a441cdcb2cf36$var$defaultUnpatchedConsole, internalLoggerLevel = $281a441cdcb2cf36$var$defaultInternalLoggerLevel) {
    const internalLogger2 = $281a441cdcb2cf36$var$defaultInternalLogger;
    if (internalLoggerLevel > $281a441cdcb2cf36$var$InternalLoggerLevel.OFF) {
        internalLogger2.error = internalLoggerLevel >= $281a441cdcb2cf36$var$InternalLoggerLevel.ERROR ? function(...args2) {
            unpatchedConsole2.error(`${internalLogger2.prefix}
`, ...args2);
        } : $281a441cdcb2cf36$var$noop2;
        internalLogger2.warn = internalLoggerLevel >= $281a441cdcb2cf36$var$InternalLoggerLevel.WARN ? function(...args2) {
            unpatchedConsole2.warn(`${internalLogger2.prefix}
`, ...args2);
        } : $281a441cdcb2cf36$var$noop2;
        internalLogger2.info = internalLoggerLevel >= $281a441cdcb2cf36$var$InternalLoggerLevel.INFO ? function(...args2) {
            unpatchedConsole2.info(`${internalLogger2.prefix}
`, ...args2);
        } : $281a441cdcb2cf36$var$noop2;
        internalLogger2.debug = internalLoggerLevel >= $281a441cdcb2cf36$var$InternalLoggerLevel.VERBOSE ? function(...args2) {
            unpatchedConsole2.debug(`${internalLogger2.prefix}
`, ...args2);
        } : $281a441cdcb2cf36$var$noop2;
    }
    return internalLogger2;
}
var $281a441cdcb2cf36$var$init_createInternalLogger = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/internalLogger/createInternalLogger.js" () {
        $281a441cdcb2cf36$var$init_unpatchedConsole();
        $281a441cdcb2cf36$var$init_utils5();
        $281a441cdcb2cf36$var$init_const2();
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/internalLogger/initialize.js
function $281a441cdcb2cf36$var$initializeInternalLogger(unpatchedConsole2, config) {
    $281a441cdcb2cf36$var$internalLogger = $281a441cdcb2cf36$var$createInternalLogger(unpatchedConsole2, config.internalLoggerLevel);
    return $281a441cdcb2cf36$var$internalLogger;
}
var $281a441cdcb2cf36$var$internalLogger;
var $281a441cdcb2cf36$var$init_initialize3 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/internalLogger/initialize.js" () {
        $281a441cdcb2cf36$var$init_const2();
        $281a441cdcb2cf36$var$init_createInternalLogger();
        $281a441cdcb2cf36$var$internalLogger = $281a441cdcb2cf36$var$defaultInternalLogger;
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/internalLogger/index.js
var $281a441cdcb2cf36$var$init_internalLogger = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/internalLogger/index.js" () {
        $281a441cdcb2cf36$var$init_const2();
        $281a441cdcb2cf36$var$init_createInternalLogger();
        $281a441cdcb2cf36$var$init_initialize3();
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/extensions/baseExtension.js
var $281a441cdcb2cf36$var$BaseExtension;
var $281a441cdcb2cf36$var$init_baseExtension = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/extensions/baseExtension.js" () {
        $281a441cdcb2cf36$var$init_internalLogger();
        $281a441cdcb2cf36$var$init_unpatchedConsole();
        $281a441cdcb2cf36$var$BaseExtension = class {
            constructor(){
                this.unpatchedConsole = $281a441cdcb2cf36$var$defaultUnpatchedConsole;
                this.internalLogger = $281a441cdcb2cf36$var$defaultInternalLogger;
                this.config = {};
                this.metas = {};
            }
            logDebug(...args2) {
                this.internalLogger.debug(`${this.name}
`, ...args2);
            }
            logInfo(...args2) {
                this.internalLogger.info(`${this.name}
`, ...args2);
            }
            logWarn(...args2) {
                this.internalLogger.warn(`${this.name}
`, ...args2);
            }
            logError(...args2) {
                this.internalLogger.error(`${this.name}
`, ...args2);
            }
        };
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/extensions/index.js
var $281a441cdcb2cf36$var$init_extensions = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/extensions/index.js" () {
        $281a441cdcb2cf36$var$init_baseExtension();
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/transports/base.js
var $281a441cdcb2cf36$var$BaseTransport;
var $281a441cdcb2cf36$var$init_base = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/transports/base.js" () {
        $281a441cdcb2cf36$var$init_extensions();
        $281a441cdcb2cf36$var$BaseTransport = class extends $281a441cdcb2cf36$var$BaseExtension {
            isBatched() {
                return false;
            }
            getIgnoreUrls() {
                return [];
            }
        };
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/transports/registerInitial.js
function $281a441cdcb2cf36$var$registerInitialTransports(faro2) {
    faro2.transports.add(...faro2.config.transports);
    faro2.transports.addBeforeSendHooks(faro2.config.beforeSend);
}
var $281a441cdcb2cf36$var$init_registerInitial = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/transports/registerInitial.js" () {}
});
// ../node_modules/@grafana/faro-core/dist/esm/transports/utils.js
function $281a441cdcb2cf36$var$mergeResourceSpans(traces, resourceSpans) {
    var _a2, _b;
    if (resourceSpans === void 0) return traces;
    if (traces === void 0) return {
        resourceSpans: resourceSpans
    };
    const currentResource = (_a2 = traces.resourceSpans) === null || _a2 === void 0 ? void 0 : _a2[0];
    if (currentResource === void 0) return traces;
    const currentSpans = (currentResource === null || currentResource === void 0 ? void 0 : currentResource.scopeSpans) || [];
    const newSpans = ((_b = resourceSpans === null || resourceSpans === void 0 ? void 0 : resourceSpans[0]) === null || _b === void 0 ? void 0 : _b.scopeSpans) || [];
    return Object.assign(Object.assign({}, traces), {
        resourceSpans: [
            Object.assign(Object.assign({}, currentResource), {
                scopeSpans: [
                    ...currentSpans,
                    ...newSpans
                ]
            })
        ]
    });
}
function $281a441cdcb2cf36$var$getTransportBody(item) {
    let body = {
        meta: {}
    };
    if (item[0] !== void 0) body.meta = item[0].meta;
    item.forEach((currentItem)=>{
        switch(currentItem.type){
            case $281a441cdcb2cf36$var$TransportItemType.LOG:
            case $281a441cdcb2cf36$var$TransportItemType.EVENT:
            case $281a441cdcb2cf36$var$TransportItemType.EXCEPTION:
            case $281a441cdcb2cf36$var$TransportItemType.MEASUREMENT:
                const bk = $281a441cdcb2cf36$var$transportItemTypeToBodyKey[currentItem.type];
                const signals = body[bk];
                body = Object.assign(Object.assign({}, body), {
                    [bk]: signals === void 0 ? [
                        currentItem.payload
                    ] : [
                        ...signals,
                        currentItem.payload
                    ]
                });
                break;
            case $281a441cdcb2cf36$var$TransportItemType.TRACE:
                body = Object.assign(Object.assign({}, body), {
                    traces: $281a441cdcb2cf36$var$mergeResourceSpans(body.traces, currentItem.payload.resourceSpans)
                });
                break;
        }
    });
    return body;
}
var $281a441cdcb2cf36$var$init_utils6 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/transports/utils.js" () {
        $281a441cdcb2cf36$var$init_const();
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/transports/index.js
var $281a441cdcb2cf36$var$init_transports = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/transports/index.js" () {
        $281a441cdcb2cf36$var$init_initialize();
        $281a441cdcb2cf36$var$init_base();
        $281a441cdcb2cf36$var$init_const();
        $281a441cdcb2cf36$var$init_registerInitial();
        $281a441cdcb2cf36$var$init_utils6();
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/api/const.js
var $281a441cdcb2cf36$var$USER_ACTION_START, $281a441cdcb2cf36$var$USER_ACTION_END, $281a441cdcb2cf36$var$USER_ACTION_CANCEL, $281a441cdcb2cf36$var$USER_ACTION_HALT;
var $281a441cdcb2cf36$var$init_const4 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/api/const.js" () {
        $281a441cdcb2cf36$var$USER_ACTION_START = "user-action-start";
        $281a441cdcb2cf36$var$USER_ACTION_END = "user-action-end";
        $281a441cdcb2cf36$var$USER_ACTION_CANCEL = "user-action-cancel";
        $281a441cdcb2cf36$var$USER_ACTION_HALT = "user-action-halt";
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/api/events/initialize.js
function $281a441cdcb2cf36$var$initializeEventsAPI({ internalLogger: internalLogger2, config: config, metas: metas, transports: transports2, tracesApi: tracesApi, actionBuffer: actionBuffer, getMessage: getMessage }) {
    let lastPayload = null;
    const pushEvent = (name, attributes, domain, { skipDedupe: skipDedupe, spanContext: spanContext, timestampOverwriteMs: timestampOverwriteMs, customPayloadTransformer: customPayloadTransformer = (payload)=>payload } = {})=>{
        try {
            const attrs = $281a441cdcb2cf36$var$stringifyObjectValues(attributes);
            const item = {
                meta: metas.value,
                payload: customPayloadTransformer({
                    name: name,
                    domain: domain !== null && domain !== void 0 ? domain : config.eventDomain,
                    attributes: $281a441cdcb2cf36$var$isEmpty2(attrs) ? void 0 : attrs,
                    timestamp: timestampOverwriteMs ? $281a441cdcb2cf36$var$timestampToIsoString(timestampOverwriteMs) : $281a441cdcb2cf36$var$getCurrentTimestamp(),
                    trace: spanContext ? {
                        trace_id: spanContext.traceId,
                        span_id: spanContext.spanId
                    } : tracesApi.getTraceContext()
                }),
                type: $281a441cdcb2cf36$var$TransportItemType.EVENT
            };
            const testingPayload = {
                name: item.payload.name,
                attributes: item.payload.attributes,
                domain: item.payload.domain
            };
            if (!skipDedupe && config.dedupe && !$281a441cdcb2cf36$var$isNull(lastPayload) && $281a441cdcb2cf36$var$deepEqual2(testingPayload, lastPayload)) {
                internalLogger2.debug("Skipping event push because it is the same as the last one\n", item.payload);
                return;
            }
            lastPayload = testingPayload;
            internalLogger2.debug("Pushing event\n", item);
            const msg = getMessage();
            if (msg && msg.type === $281a441cdcb2cf36$var$USER_ACTION_START) actionBuffer.addItem(item);
            else transports2.execute(item);
        } catch (err) {
            internalLogger2.error("Error pushing event", err);
        }
    };
    return {
        pushEvent: pushEvent
    };
}
var $281a441cdcb2cf36$var$init_initialize4 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/api/events/initialize.js" () {
        $281a441cdcb2cf36$var$init_transports();
        $281a441cdcb2cf36$var$init_utils5();
        $281a441cdcb2cf36$var$init_date();
        $281a441cdcb2cf36$var$init_const4();
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/api/events/index.js
var $281a441cdcb2cf36$var$init_events = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/api/events/index.js" () {
        $281a441cdcb2cf36$var$init_initialize4();
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/api/exceptions/const.js
var $281a441cdcb2cf36$var$defaultExceptionType, $281a441cdcb2cf36$var$defaultErrorArgsSerializer;
var $281a441cdcb2cf36$var$init_const5 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/api/exceptions/const.js" () {
        $281a441cdcb2cf36$var$init_utils5();
        $281a441cdcb2cf36$var$defaultExceptionType = "Error";
        $281a441cdcb2cf36$var$defaultErrorArgsSerializer = (args2)=>{
            return args2.map((arg)=>{
                if ($281a441cdcb2cf36$var$isObject4(arg)) return $281a441cdcb2cf36$var$stringifyExternalJson(arg);
                return String(arg);
            }).join(" ");
        };
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/api/utils.js
function $281a441cdcb2cf36$var$shouldIgnoreEvent(patterns, msg) {
    return patterns.some((pattern)=>{
        return $281a441cdcb2cf36$var$isString(pattern) ? msg.includes(pattern) : !!msg.match(pattern);
    });
}
var $281a441cdcb2cf36$var$init_utils7 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/api/utils.js" () {
        $281a441cdcb2cf36$var$init_is();
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/api/exceptions/initialize.js
function $281a441cdcb2cf36$var$initializeExceptionsAPI({ internalLogger: internalLogger2, config: config, metas: metas, transports: transports2, tracesApi: tracesApi, actionBuffer: actionBuffer, getMessage: getMessage }) {
    var _a2;
    internalLogger2.debug("Initializing exceptions API");
    let lastPayload = null;
    $281a441cdcb2cf36$var$stacktraceParser = (_a2 = config.parseStacktrace) !== null && _a2 !== void 0 ? _a2 : $281a441cdcb2cf36$var$stacktraceParser;
    const changeStacktraceParser = (newStacktraceParser)=>{
        internalLogger2.debug("Changing stacktrace parser");
        $281a441cdcb2cf36$var$stacktraceParser = newStacktraceParser !== null && newStacktraceParser !== void 0 ? newStacktraceParser : $281a441cdcb2cf36$var$stacktraceParser;
    };
    const getStacktraceParser = ()=>$281a441cdcb2cf36$var$stacktraceParser;
    const { ignoreErrors: ignoreErrors = [], preserveOriginalError: preserveOriginalError } = config;
    const pushError = (error, { skipDedupe: skipDedupe, stackFrames: stackFrames, type: type, context: context2, spanContext: spanContext, timestampOverwriteMs: timestampOverwriteMs, originalError: originalError } = {})=>{
        if ($281a441cdcb2cf36$var$isErrorIgnored(ignoreErrors, originalError !== null && originalError !== void 0 ? originalError : error)) return;
        try {
            const ctx = $281a441cdcb2cf36$var$stringifyObjectValues(Object.assign(Object.assign({}, $281a441cdcb2cf36$var$parseCause(originalError !== null && originalError !== void 0 ? originalError : error)), context2 !== null && context2 !== void 0 ? context2 : {}));
            const item = {
                meta: metas.value,
                payload: Object.assign(Object.assign({
                    type: type || error.name || $281a441cdcb2cf36$var$defaultExceptionType,
                    value: error.message,
                    timestamp: timestampOverwriteMs ? $281a441cdcb2cf36$var$timestampToIsoString(timestampOverwriteMs) : $281a441cdcb2cf36$var$getCurrentTimestamp(),
                    trace: spanContext ? {
                        trace_id: spanContext.traceId,
                        span_id: spanContext.spanId
                    } : tracesApi.getTraceContext()
                }, $281a441cdcb2cf36$var$isEmpty2(ctx) ? {} : {
                    context: ctx
                }), preserveOriginalError ? {
                    originalError: originalError
                } : {}),
                type: $281a441cdcb2cf36$var$TransportItemType.EXCEPTION
            };
            stackFrames = stackFrames !== null && stackFrames !== void 0 ? stackFrames : error.stack ? $281a441cdcb2cf36$var$stacktraceParser === null || $281a441cdcb2cf36$var$stacktraceParser === void 0 ? void 0 : $281a441cdcb2cf36$var$stacktraceParser(error).frames : void 0;
            if (stackFrames === null || stackFrames === void 0 ? void 0 : stackFrames.length) item.payload.stacktrace = {
                frames: stackFrames
            };
            const testingPayload = {
                type: item.payload.type,
                value: item.payload.value,
                stackTrace: item.payload.stacktrace,
                context: item.payload.context
            };
            if (!skipDedupe && config.dedupe && !$281a441cdcb2cf36$var$isNull(lastPayload) && $281a441cdcb2cf36$var$deepEqual2(testingPayload, lastPayload)) {
                internalLogger2.debug("Skipping error push because it is the same as the last one\n", item.payload);
                return;
            }
            lastPayload = testingPayload;
            internalLogger2.debug("Pushing exception\n", item);
            const msg = getMessage();
            if (msg && msg.type === $281a441cdcb2cf36$var$USER_ACTION_START) actionBuffer.addItem(item);
            else transports2.execute(item);
        } catch (err) {
            internalLogger2.error("Error pushing event", err);
        }
    };
    changeStacktraceParser(config.parseStacktrace);
    return {
        changeStacktraceParser: changeStacktraceParser,
        getStacktraceParser: getStacktraceParser,
        pushError: pushError
    };
}
function $281a441cdcb2cf36$var$parseCause(error) {
    let cause = error.cause;
    if ($281a441cdcb2cf36$var$isError(cause)) cause = error.cause.toString();
    else if (cause !== null && ($281a441cdcb2cf36$var$isObject4(error.cause) || $281a441cdcb2cf36$var$isArray4(error.cause))) cause = $281a441cdcb2cf36$var$stringifyExternalJson(error.cause);
    else if (cause != null) cause = error.cause.toString();
    return cause == null ? {} : {
        cause: cause
    };
}
function $281a441cdcb2cf36$var$isErrorIgnored(ignoreErrors, error) {
    const { message: message, name: name, stack: stack } = error;
    return $281a441cdcb2cf36$var$shouldIgnoreEvent(ignoreErrors, message + " " + name + " " + stack);
}
var $281a441cdcb2cf36$var$stacktraceParser;
var $281a441cdcb2cf36$var$init_initialize5 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/api/exceptions/initialize.js" () {
        $281a441cdcb2cf36$var$init_transports();
        $281a441cdcb2cf36$var$init_utils5();
        $281a441cdcb2cf36$var$init_date();
        $281a441cdcb2cf36$var$init_const4();
        $281a441cdcb2cf36$var$init_utils7();
        $281a441cdcb2cf36$var$init_const5();
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/api/exceptions/index.js
var $281a441cdcb2cf36$var$init_exceptions = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/api/exceptions/index.js" () {
        $281a441cdcb2cf36$var$init_const5();
        $281a441cdcb2cf36$var$init_initialize5();
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/api/logs/const.js
var $281a441cdcb2cf36$var$defaultLogArgsSerializer;
var $281a441cdcb2cf36$var$init_const6 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/api/logs/const.js" () {
        $281a441cdcb2cf36$var$defaultLogArgsSerializer = (args2)=>args2.map((arg)=>{
                try {
                    return String(arg);
                } catch (err) {
                    return "";
                }
            }).join(" ");
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/api/logs/initialize.js
function $281a441cdcb2cf36$var$initializeLogsAPI({ internalLogger: internalLogger2, config: config, metas: metas, transports: transports2, tracesApi: tracesApi, actionBuffer: actionBuffer, getMessage: getMessage }) {
    var _a2;
    internalLogger2.debug("Initializing logs API");
    let lastPayload = null;
    const logArgsSerializer = (_a2 = config.logArgsSerializer) !== null && _a2 !== void 0 ? _a2 : $281a441cdcb2cf36$var$defaultLogArgsSerializer;
    const pushLog = (args2, { context: context2, level: level, skipDedupe: skipDedupe, spanContext: spanContext, timestampOverwriteMs: timestampOverwriteMs } = {})=>{
        try {
            const ctx = $281a441cdcb2cf36$var$stringifyObjectValues(context2);
            const item = {
                type: $281a441cdcb2cf36$var$TransportItemType.LOG,
                payload: {
                    message: logArgsSerializer(args2),
                    level: level !== null && level !== void 0 ? level : $281a441cdcb2cf36$var$defaultLogLevel,
                    context: $281a441cdcb2cf36$var$isEmpty2(ctx) ? void 0 : ctx,
                    timestamp: timestampOverwriteMs ? $281a441cdcb2cf36$var$timestampToIsoString(timestampOverwriteMs) : $281a441cdcb2cf36$var$getCurrentTimestamp(),
                    trace: spanContext ? {
                        trace_id: spanContext.traceId,
                        span_id: spanContext.spanId
                    } : tracesApi.getTraceContext()
                },
                meta: metas.value
            };
            const testingPayload = {
                message: item.payload.message,
                level: item.payload.level,
                context: item.payload.context
            };
            if (!skipDedupe && config.dedupe && !$281a441cdcb2cf36$var$isNull(lastPayload) && $281a441cdcb2cf36$var$deepEqual2(testingPayload, lastPayload)) {
                internalLogger2.debug("Skipping log push because it is the same as the last one\n", item.payload);
                return;
            }
            lastPayload = testingPayload;
            internalLogger2.debug("Pushing log\n", item);
            const msg = getMessage();
            if (msg && msg.type === $281a441cdcb2cf36$var$USER_ACTION_START) actionBuffer.addItem(item);
            else transports2.execute(item);
        } catch (err) {
            internalLogger2.error("Error pushing log\n", err);
        }
    };
    return {
        pushLog: pushLog
    };
}
var $281a441cdcb2cf36$var$init_initialize6 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/api/logs/initialize.js" () {
        $281a441cdcb2cf36$var$init_transports();
        $281a441cdcb2cf36$var$init_utils5();
        $281a441cdcb2cf36$var$init_date();
        $281a441cdcb2cf36$var$init_const4();
        $281a441cdcb2cf36$var$init_const6();
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/api/logs/index.js
var $281a441cdcb2cf36$var$init_logs = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/api/logs/index.js" () {
        $281a441cdcb2cf36$var$init_const6();
        $281a441cdcb2cf36$var$init_initialize6();
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/api/measurements/initialize.js
function $281a441cdcb2cf36$var$initializeMeasurementsAPI({ internalLogger: internalLogger2, config: config, metas: metas, transports: transports2, tracesApi: tracesApi, actionBuffer: actionBuffer, getMessage: getMessage }) {
    internalLogger2.debug("Initializing measurements API");
    let lastPayload = null;
    const pushMeasurement = (payload, { skipDedupe: skipDedupe, context: context2, spanContext: spanContext, timestampOverwriteMs: timestampOverwriteMs } = {})=>{
        try {
            const ctx = $281a441cdcb2cf36$var$stringifyObjectValues(context2);
            const item = {
                type: $281a441cdcb2cf36$var$TransportItemType.MEASUREMENT,
                payload: Object.assign(Object.assign({}, payload), {
                    trace: spanContext ? {
                        trace_id: spanContext.traceId,
                        span_id: spanContext.spanId
                    } : tracesApi.getTraceContext(),
                    timestamp: timestampOverwriteMs ? $281a441cdcb2cf36$var$timestampToIsoString(timestampOverwriteMs) : $281a441cdcb2cf36$var$getCurrentTimestamp(),
                    context: $281a441cdcb2cf36$var$isEmpty2(ctx) ? void 0 : ctx
                }),
                meta: metas.value
            };
            const testingPayload = {
                type: item.payload.type,
                values: item.payload.values,
                context: item.payload.context
            };
            if (!skipDedupe && config.dedupe && !$281a441cdcb2cf36$var$isNull(lastPayload) && $281a441cdcb2cf36$var$deepEqual2(testingPayload, lastPayload)) {
                internalLogger2.debug("Skipping measurement push because it is the same as the last one\n", item.payload);
                return;
            }
            lastPayload = testingPayload;
            internalLogger2.debug("Pushing measurement\n", item);
            const msg = getMessage();
            if (msg && msg.type === $281a441cdcb2cf36$var$USER_ACTION_START) actionBuffer.addItem(item);
            else transports2.execute(item);
        } catch (err) {
            internalLogger2.error("Error pushing measurement\n", err);
        }
    };
    return {
        pushMeasurement: pushMeasurement
    };
}
var $281a441cdcb2cf36$var$init_initialize7 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/api/measurements/initialize.js" () {
        $281a441cdcb2cf36$var$init_transports();
        $281a441cdcb2cf36$var$init_utils5();
        $281a441cdcb2cf36$var$init_date();
        $281a441cdcb2cf36$var$init_const4();
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/api/measurements/index.js
var $281a441cdcb2cf36$var$init_measurements = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/api/measurements/index.js" () {
        $281a441cdcb2cf36$var$init_initialize7();
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/api/meta/initialize.js
function $281a441cdcb2cf36$var$initializeMetaAPI({ internalLogger: internalLogger2, metas: metas }) {
    internalLogger2.debug("Initializing meta API");
    let metaSession = void 0;
    let metaUser = void 0;
    let metaView = void 0;
    let metaPage = void 0;
    const setUser = (user)=>{
        if (metaUser) metas.remove(metaUser);
        metaUser = {
            user: user
        };
        metas.add(metaUser);
    };
    const setSession = (session, options)=>{
        var _a2;
        const newOverrides = options === null || options === void 0 ? void 0 : options.overrides;
        const overrides = newOverrides ? {
            overrides: Object.assign(Object.assign({}, (_a2 = metaSession === null || metaSession === void 0 ? void 0 : metaSession.session) === null || _a2 === void 0 ? void 0 : _a2.overrides), newOverrides)
        } : {};
        if (metaSession) metas.remove(metaSession);
        metaSession = {
            session: Object.assign(Object.assign({}, $281a441cdcb2cf36$var$isEmpty2(session) ? void 0 : session), overrides)
        };
        metas.add(metaSession);
    };
    const getSession = ()=>metas.value.session;
    const setView = (view, options)=>{
        var _a2;
        if (options === null || options === void 0 ? void 0 : options.overrides) setSession(getSession(), {
            overrides: options.overrides
        });
        if (((_a2 = metaView === null || metaView === void 0 ? void 0 : metaView.view) === null || _a2 === void 0 ? void 0 : _a2.name) === (view === null || view === void 0 ? void 0 : view.name)) return;
        const previousView = metaView;
        metaView = {
            view: view
        };
        metas.add(metaView);
        if (previousView) metas.remove(previousView);
    };
    const getView = ()=>metas.value.view;
    const setPage = (page)=>{
        var _a2;
        const pageMeta = $281a441cdcb2cf36$var$isString(page) ? Object.assign(Object.assign({}, (_a2 = metaPage === null || metaPage === void 0 ? void 0 : metaPage.page) !== null && _a2 !== void 0 ? _a2 : getPage()), {
            id: page
        }) : page;
        if (metaPage) metas.remove(metaPage);
        metaPage = {
            page: pageMeta
        };
        metas.add(metaPage);
    };
    const getPage = ()=>metas.value.page;
    return {
        setUser: setUser,
        resetUser: setUser,
        setSession: setSession,
        resetSession: setSession,
        getSession: getSession,
        setView: setView,
        getView: getView,
        setPage: setPage,
        getPage: getPage
    };
}
var $281a441cdcb2cf36$var$init_initialize8 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/api/meta/initialize.js" () {
        $281a441cdcb2cf36$var$init_is();
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/api/meta/index.js
var $281a441cdcb2cf36$var$init_meta = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/api/meta/index.js" () {
        $281a441cdcb2cf36$var$init_initialize8();
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/api/traces/initialize.js
function $281a441cdcb2cf36$var$initializeTracesAPI(_unpatchedConsole, internalLogger2, _config, metas, transports2) {
    internalLogger2.debug("Initializing traces API");
    let otel = void 0;
    const initOTEL = (trace2, context2)=>{
        internalLogger2.debug("Initializing OpenTelemetry");
        otel = {
            trace: trace2,
            context: context2
        };
    };
    const getTraceContext = ()=>{
        const ctx = otel === null || otel === void 0 ? void 0 : otel.trace.getSpanContext(otel.context.active());
        return !ctx ? void 0 : {
            trace_id: ctx.traceId,
            span_id: ctx.spanId
        };
    };
    const pushTraces = (payload)=>{
        try {
            const item = {
                type: $281a441cdcb2cf36$var$TransportItemType.TRACE,
                payload: payload,
                meta: metas.value
            };
            internalLogger2.debug("Pushing trace\n", item);
            transports2.execute(item);
        } catch (err) {
            internalLogger2.error("Error pushing trace\n", err);
        }
    };
    const getOTEL = ()=>otel;
    const isOTELInitialized = ()=>!!otel;
    return {
        getOTEL: getOTEL,
        getTraceContext: getTraceContext,
        initOTEL: initOTEL,
        isOTELInitialized: isOTELInitialized,
        pushTraces: pushTraces
    };
}
var $281a441cdcb2cf36$var$init_initialize9 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/api/traces/initialize.js" () {
        $281a441cdcb2cf36$var$init_transports();
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/api/traces/index.js
var $281a441cdcb2cf36$var$init_traces = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/api/traces/index.js" () {
        $281a441cdcb2cf36$var$init_initialize9();
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/api/ItemBuffer.js
var $281a441cdcb2cf36$var$ItemBuffer;
var $281a441cdcb2cf36$var$init_ItemBuffer = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/api/ItemBuffer.js" () {
        $281a441cdcb2cf36$var$init_is();
        $281a441cdcb2cf36$var$ItemBuffer = class {
            constructor(){
                this.buffer = [];
            }
            addItem(item) {
                this.buffer.push(item);
            }
            flushBuffer(cb) {
                if ($281a441cdcb2cf36$var$isFunction3(cb)) for (const item of this.buffer)cb(item);
                this.buffer.length = 0;
            }
            size() {
                return this.buffer.length;
            }
        };
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/api/userActionLifecycleHandler.js
function $281a441cdcb2cf36$var$createUserActionLifecycleHandler({ apiMessageBus: apiMessageBus2, transports: transports2, config: config }) {
    const actionBuffer = new $281a441cdcb2cf36$var$ItemBuffer();
    const trackUserActionsExcludeItem = config.trackUserActionsExcludeItem;
    let message;
    apiMessageBus2.subscribe((msg)=>{
        if ($281a441cdcb2cf36$var$USER_ACTION_START === msg.type || $281a441cdcb2cf36$var$USER_ACTION_HALT === msg.type) {
            message = msg;
            return;
        }
        if (msg.type === $281a441cdcb2cf36$var$USER_ACTION_END) {
            const { id: id2, name: name } = msg;
            actionBuffer.flushBuffer((item)=>{
                if ($281a441cdcb2cf36$var$isExcludeFromUserAction(item, trackUserActionsExcludeItem)) {
                    transports2.execute(item);
                    return;
                }
                const userActionItem = Object.assign(Object.assign({}, item), {
                    payload: Object.assign(Object.assign({}, item.payload), {
                        action: {
                            parentId: id2,
                            name: name
                        }
                    })
                });
                transports2.execute(userActionItem);
            });
            message = void 0;
            return;
        }
        if (msg.type === $281a441cdcb2cf36$var$USER_ACTION_CANCEL) {
            message = void 0;
            actionBuffer.flushBuffer((item)=>{
                transports2.execute(item);
            });
        }
    });
    const getMessage = ()=>message;
    return {
        actionBuffer: actionBuffer,
        getMessage: getMessage
    };
}
function $281a441cdcb2cf36$var$isExcludeFromUserAction(item, trackUserActionsExcludeItem) {
    return (trackUserActionsExcludeItem === null || trackUserActionsExcludeItem === void 0 ? void 0 : trackUserActionsExcludeItem(item)) || item.type === $281a441cdcb2cf36$var$TransportItemType.MEASUREMENT && item.payload.type === "web-vitals";
}
var $281a441cdcb2cf36$var$init_userActionLifecycleHandler = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/api/userActionLifecycleHandler.js" () {
        $281a441cdcb2cf36$var$init_transports();
        $281a441cdcb2cf36$var$init_const4();
        $281a441cdcb2cf36$var$init_ItemBuffer();
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/api/initialize.js
function $281a441cdcb2cf36$var$initializeAPI(unpatchedConsole2, internalLogger2, config, metas, transports2) {
    internalLogger2.debug("Initializing API");
    const { actionBuffer: actionBuffer, getMessage: getMessage } = $281a441cdcb2cf36$var$createUserActionLifecycleHandler({
        apiMessageBus: $281a441cdcb2cf36$var$apiMessageBus,
        transports: transports2,
        config: config
    });
    const tracesApi = $281a441cdcb2cf36$var$initializeTracesAPI(unpatchedConsole2, internalLogger2, config, metas, transports2);
    const props = {
        unpatchedConsole: unpatchedConsole2,
        internalLogger: internalLogger2,
        config: config,
        metas: metas,
        transports: transports2,
        tracesApi: tracesApi,
        actionBuffer: actionBuffer,
        getMessage: getMessage
    };
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, tracesApi), $281a441cdcb2cf36$var$initializeExceptionsAPI(props)), $281a441cdcb2cf36$var$initializeMetaAPI(props)), $281a441cdcb2cf36$var$initializeLogsAPI(props)), $281a441cdcb2cf36$var$initializeMeasurementsAPI(props)), $281a441cdcb2cf36$var$initializeEventsAPI(props));
}
var $281a441cdcb2cf36$var$apiMessageBus;
var $281a441cdcb2cf36$var$init_initialize10 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/api/initialize.js" () {
        $281a441cdcb2cf36$var$init_utils5();
        $281a441cdcb2cf36$var$init_events();
        $281a441cdcb2cf36$var$init_exceptions();
        $281a441cdcb2cf36$var$init_logs();
        $281a441cdcb2cf36$var$init_measurements();
        $281a441cdcb2cf36$var$init_meta();
        $281a441cdcb2cf36$var$init_traces();
        $281a441cdcb2cf36$var$init_userActionLifecycleHandler();
        $281a441cdcb2cf36$var$apiMessageBus = new $281a441cdcb2cf36$var$Observable2();
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/api/index.js
var $281a441cdcb2cf36$var$init_api = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/api/index.js" () {
        $281a441cdcb2cf36$var$init_initialize10();
        $281a441cdcb2cf36$var$init_exceptions();
        $281a441cdcb2cf36$var$init_logs();
        $281a441cdcb2cf36$var$init_initialize10();
        $281a441cdcb2cf36$var$init_const4();
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/instrumentations/base.js
var $281a441cdcb2cf36$var$BaseInstrumentation;
var $281a441cdcb2cf36$var$init_base2 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/instrumentations/base.js" () {
        $281a441cdcb2cf36$var$init_extensions();
        $281a441cdcb2cf36$var$BaseInstrumentation = class extends $281a441cdcb2cf36$var$BaseExtension {
            constructor(){
                super(...arguments);
                this.api = {};
                this.transports = {};
            }
        };
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/instrumentations/initialize.js
function $281a441cdcb2cf36$var$initializeInstrumentations(unpatchedConsole2, internalLogger2, config, metas, transports2, api) {
    internalLogger2.debug("Initializing instrumentations");
    const instrumentations = [];
    const add2 = (...newInstrumentations)=>{
        internalLogger2.debug("Adding instrumentations");
        newInstrumentations.forEach((newInstrumentation)=>{
            internalLogger2.debug(`Adding "${newInstrumentation.name}" instrumentation`);
            const exists = instrumentations.some((existingInstrumentation)=>existingInstrumentation.name === newInstrumentation.name);
            if (exists) {
                internalLogger2.warn(`Instrumentation ${newInstrumentation.name} is already added`);
                return;
            }
            newInstrumentation.unpatchedConsole = unpatchedConsole2;
            newInstrumentation.internalLogger = internalLogger2;
            newInstrumentation.config = config;
            newInstrumentation.metas = metas;
            newInstrumentation.transports = transports2;
            newInstrumentation.api = api;
            instrumentations.push(newInstrumentation);
            newInstrumentation.initialize();
        });
    };
    const remove3 = (...instrumentationsToRemove)=>{
        internalLogger2.debug("Removing instrumentations");
        instrumentationsToRemove.forEach((instrumentationToRemove)=>{
            var _a2, _b;
            internalLogger2.debug(`Removing "${instrumentationToRemove.name}" instrumentation`);
            const existingInstrumentationIndex = instrumentations.reduce((acc, existingInstrumentation, existingTransportIndex)=>{
                if (acc === null && existingInstrumentation.name === instrumentationToRemove.name) return existingTransportIndex;
                return null;
            }, null);
            if (existingInstrumentationIndex === null) {
                internalLogger2.warn(`Instrumentation "${instrumentationToRemove.name}" is not added`);
                return;
            }
            (_b = (_a2 = instrumentations[existingInstrumentationIndex]).destroy) === null || _b === void 0 || _b.call(_a2);
            instrumentations.splice(existingInstrumentationIndex, 1);
        });
    };
    return {
        add: add2,
        get instrumentations () {
            return [
                ...instrumentations
            ];
        },
        remove: remove3
    };
}
var $281a441cdcb2cf36$var$init_initialize11 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/instrumentations/initialize.js" () {}
});
// ../node_modules/@grafana/faro-core/dist/esm/instrumentations/registerInitial.js
function $281a441cdcb2cf36$var$registerInitialInstrumentations(faro2) {
    faro2.instrumentations.add(...faro2.config.instrumentations);
}
var $281a441cdcb2cf36$var$init_registerInitial2 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/instrumentations/registerInitial.js" () {}
});
// ../node_modules/@grafana/faro-core/dist/esm/instrumentations/index.js
var $281a441cdcb2cf36$var$init_instrumentations = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/instrumentations/index.js" () {
        $281a441cdcb2cf36$var$init_base2();
        $281a441cdcb2cf36$var$init_initialize11();
        $281a441cdcb2cf36$var$init_registerInitial2();
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/metas/initialize.js
function $281a441cdcb2cf36$var$initializeMetas(_unpatchedConsole, internalLogger2, _config) {
    let items = [];
    let listeners = [];
    const getValue = ()=>items.reduce((acc, item)=>Object.assign(acc, $281a441cdcb2cf36$var$isFunction3(item) ? item() : item), {});
    const notifyListeners = ()=>{
        if (listeners.length) {
            const value2 = getValue();
            listeners.forEach((listener)=>listener(value2));
        }
    };
    const add2 = (...newItems)=>{
        internalLogger2.debug("Adding metas\n", newItems);
        items.push(...newItems);
        notifyListeners();
    };
    const remove3 = (...itemsToRemove)=>{
        internalLogger2.debug("Removing metas\n", itemsToRemove);
        items = items.filter((currentItem)=>!itemsToRemove.includes(currentItem));
        notifyListeners();
    };
    const addListener = (listener)=>{
        internalLogger2.debug("Adding metas listener\n", listener);
        listeners.push(listener);
    };
    const removeListener = (listener)=>{
        internalLogger2.debug("Removing metas listener\n", listener);
        listeners = listeners.filter((currentListener)=>currentListener !== listener);
    };
    return {
        add: add2,
        remove: remove3,
        addListener: addListener,
        removeListener: removeListener,
        get value () {
            return getValue();
        }
    };
}
var $281a441cdcb2cf36$var$init_initialize12 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/metas/initialize.js" () {
        $281a441cdcb2cf36$var$init_utils5();
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/version.js
var $281a441cdcb2cf36$var$VERSION4;
var $281a441cdcb2cf36$var$init_version3 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/version.js" () {
        $281a441cdcb2cf36$var$VERSION4 = "1.19.0";
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/metas/registerInitial.js
function $281a441cdcb2cf36$var$registerInitialMetas(faro2) {
    var _a2, _b;
    const initial = {
        sdk: {
            version: $281a441cdcb2cf36$var$VERSION4
        },
        app: {
            bundleId: faro2.config.app.name && $281a441cdcb2cf36$var$getBundleId(faro2.config.app.name)
        }
    };
    const session = (_a2 = faro2.config.sessionTracking) === null || _a2 === void 0 ? void 0 : _a2.session;
    if (session) faro2.api.setSession(session);
    if (faro2.config.app) initial.app = Object.assign(Object.assign({}, faro2.config.app), initial.app);
    if (faro2.config.user) initial.user = faro2.config.user;
    if (faro2.config.view) initial.view = faro2.config.view;
    faro2.metas.add(initial, ...(_b = faro2.config.metas) !== null && _b !== void 0 ? _b : []);
}
var $281a441cdcb2cf36$var$init_registerInitial3 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/metas/registerInitial.js" () {
        $281a441cdcb2cf36$var$init_sourceMaps();
        $281a441cdcb2cf36$var$init_version3();
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/metas/index.js
var $281a441cdcb2cf36$var$init_metas = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/metas/index.js" () {
        $281a441cdcb2cf36$var$init_initialize12();
        $281a441cdcb2cf36$var$init_registerInitial3();
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/sdk/const.js
var $281a441cdcb2cf36$var$internalGlobalObjectKey;
var $281a441cdcb2cf36$var$init_const7 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/sdk/const.js" () {
        $281a441cdcb2cf36$var$internalGlobalObjectKey = "_faroInternal";
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/sdk/faroGlobalObject.js
function $281a441cdcb2cf36$var$setFaroOnGlobalObject(faro2) {
    if (!faro2.config.preventGlobalExposure) {
        faro2.internalLogger.debug(`Registering public faro reference in the global scope using "${faro2.config.globalObjectKey}" key`);
        if (faro2.config.globalObjectKey in $281a441cdcb2cf36$var$globalObject) {
            faro2.internalLogger.warn(`Skipping global registration due to key "${faro2.config.globalObjectKey}" being used already. Please set "globalObjectKey" to something else or set "preventGlobalExposure" to "true"`);
            return;
        }
        Object.defineProperty($281a441cdcb2cf36$var$globalObject, faro2.config.globalObjectKey, {
            configurable: false,
            writable: false,
            value: faro2
        });
    } else faro2.internalLogger.debug("Skipping registering public Faro instance in the global scope");
}
var $281a441cdcb2cf36$var$init_faroGlobalObject = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/sdk/faroGlobalObject.js" () {
        $281a441cdcb2cf36$var$init_globalObject2();
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/sdk/internalFaroGlobalObject.js
function $281a441cdcb2cf36$var$getInternalFromGlobalObject() {
    return $281a441cdcb2cf36$var$globalObject[$281a441cdcb2cf36$var$internalGlobalObjectKey];
}
function $281a441cdcb2cf36$var$setInternalFaroOnGlobalObject(faro2) {
    if (!faro2.config.isolate) {
        faro2.internalLogger.debug("Registering internal Faro instance on global object");
        Object.defineProperty($281a441cdcb2cf36$var$globalObject, $281a441cdcb2cf36$var$internalGlobalObjectKey, {
            configurable: false,
            enumerable: false,
            writable: false,
            value: faro2
        });
    } else faro2.internalLogger.debug("Skipping registering internal Faro instance on global object");
}
function $281a441cdcb2cf36$var$isInternalFaroOnGlobalObject() {
    return $281a441cdcb2cf36$var$internalGlobalObjectKey in $281a441cdcb2cf36$var$globalObject;
}
var $281a441cdcb2cf36$var$init_internalFaroGlobalObject = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/sdk/internalFaroGlobalObject.js" () {
        $281a441cdcb2cf36$var$init_globalObject2();
        $281a441cdcb2cf36$var$init_const7();
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/sdk/registerFaro.js
function $281a441cdcb2cf36$var$registerFaro(unpatchedConsole2, internalLogger2, config, metas, transports2, api, instrumentations) {
    internalLogger2.debug("Initializing Faro");
    $281a441cdcb2cf36$var$faro = {
        api: api,
        config: config,
        instrumentations: instrumentations,
        internalLogger: internalLogger2,
        metas: metas,
        pause: transports2.pause,
        transports: transports2,
        unpatchedConsole: unpatchedConsole2,
        unpause: transports2.unpause
    };
    $281a441cdcb2cf36$var$setInternalFaroOnGlobalObject($281a441cdcb2cf36$var$faro);
    $281a441cdcb2cf36$var$setFaroOnGlobalObject($281a441cdcb2cf36$var$faro);
    return $281a441cdcb2cf36$var$faro;
}
var $281a441cdcb2cf36$var$faro;
var $281a441cdcb2cf36$var$init_registerFaro = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/sdk/registerFaro.js" () {
        $281a441cdcb2cf36$var$init_faroGlobalObject();
        $281a441cdcb2cf36$var$init_internalFaroGlobalObject();
        $281a441cdcb2cf36$var$faro = {};
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/sdk/index.js
var $281a441cdcb2cf36$var$init_sdk = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/sdk/index.js" () {
        $281a441cdcb2cf36$var$init_const7();
        $281a441cdcb2cf36$var$init_registerFaro();
        $281a441cdcb2cf36$var$init_internalFaroGlobalObject();
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/initialize.js
function $281a441cdcb2cf36$var$initializeFaro(config) {
    const unpatchedConsole2 = $281a441cdcb2cf36$var$initializeUnpatchedConsole(config);
    const internalLogger2 = $281a441cdcb2cf36$var$initializeInternalLogger(unpatchedConsole2, config);
    if ($281a441cdcb2cf36$var$isInternalFaroOnGlobalObject() && !config.isolate) {
        internalLogger2.error('Faro is already registered. Either add instrumentations, transports etc. to the global faro instance or use the "isolate" property');
        return void 0;
    }
    internalLogger2.debug("Initializing");
    const metas = $281a441cdcb2cf36$var$initializeMetas(unpatchedConsole2, internalLogger2, config);
    const transports2 = $281a441cdcb2cf36$var$initializeTransports(unpatchedConsole2, internalLogger2, config, metas);
    const api = $281a441cdcb2cf36$var$initializeAPI(unpatchedConsole2, internalLogger2, config, metas, transports2);
    const instrumentations = $281a441cdcb2cf36$var$initializeInstrumentations(unpatchedConsole2, internalLogger2, config, metas, transports2, api);
    const faro2 = $281a441cdcb2cf36$var$registerFaro(unpatchedConsole2, internalLogger2, config, metas, transports2, api, instrumentations);
    $281a441cdcb2cf36$var$registerInitialMetas(faro2);
    $281a441cdcb2cf36$var$registerInitialTransports(faro2);
    $281a441cdcb2cf36$var$registerInitialInstrumentations(faro2);
    return faro2;
}
var $281a441cdcb2cf36$var$init_initialize13 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/initialize.js" () {
        $281a441cdcb2cf36$var$init_api();
        $281a441cdcb2cf36$var$init_instrumentations();
        $281a441cdcb2cf36$var$init_internalLogger();
        $281a441cdcb2cf36$var$init_metas();
        $281a441cdcb2cf36$var$init_sdk();
        $281a441cdcb2cf36$var$init_transports();
        $281a441cdcb2cf36$var$init_unpatchedConsole();
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/config/const.js
var $281a441cdcb2cf36$var$defaultGlobalObjectKey, $281a441cdcb2cf36$var$defaultBatchingConfig;
var $281a441cdcb2cf36$var$init_const8 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/config/const.js" () {
        $281a441cdcb2cf36$var$defaultGlobalObjectKey = "faro";
        $281a441cdcb2cf36$var$defaultBatchingConfig = {
            enabled: true,
            sendTimeout: 250,
            itemLimit: 50
        };
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/config/index.js
var $281a441cdcb2cf36$var$init_config = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/config/index.js" () {
        $281a441cdcb2cf36$var$init_const8();
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/semantic.js
var $281a441cdcb2cf36$var$Conventions, $281a441cdcb2cf36$var$EVENT_CLICK, $281a441cdcb2cf36$var$EVENT_NAVIGATION, $281a441cdcb2cf36$var$EVENT_VIEW_CHANGED, $281a441cdcb2cf36$var$EVENT_SESSION_START, $281a441cdcb2cf36$var$EVENT_SESSION_RESUME, $281a441cdcb2cf36$var$EVENT_SESSION_EXTEND, $281a441cdcb2cf36$var$EVENT_OVERRIDES_SERVICE_NAME, $281a441cdcb2cf36$var$EVENT_ROUTE_CHANGE;
var $281a441cdcb2cf36$var$init_semantic = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/semantic.js" () {
        $281a441cdcb2cf36$var$Conventions = {
            /**
       * @deprecated The event names object will be removed in a future version
       */ EventNames: {
                CLICK: "click",
                NAVIGATION: "navigation",
                SESSION_START: "session_start",
                VIEW_CHANGED: "view_changed"
            }
        };
        $281a441cdcb2cf36$var$EVENT_CLICK = "click";
        $281a441cdcb2cf36$var$EVENT_NAVIGATION = "navigation";
        $281a441cdcb2cf36$var$EVENT_VIEW_CHANGED = "view_changed";
        $281a441cdcb2cf36$var$EVENT_SESSION_START = "session_start";
        $281a441cdcb2cf36$var$EVENT_SESSION_RESUME = "session_resume";
        $281a441cdcb2cf36$var$EVENT_SESSION_EXTEND = "session_extend";
        $281a441cdcb2cf36$var$EVENT_OVERRIDES_SERVICE_NAME = "service_name_override";
        $281a441cdcb2cf36$var$EVENT_ROUTE_CHANGE = "route_change";
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/consts.js
var $281a441cdcb2cf36$var$unknownString;
var $281a441cdcb2cf36$var$init_consts = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/consts.js" () {
        $281a441cdcb2cf36$var$unknownString = "unknown";
    }
});
// ../node_modules/@grafana/faro-core/dist/esm/index.js
var $281a441cdcb2cf36$var$init_esm4 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-core/dist/esm/index.js" () {
        $281a441cdcb2cf36$var$init_api();
        $281a441cdcb2cf36$var$init_extensions();
        $281a441cdcb2cf36$var$init_globalObject2();
        $281a441cdcb2cf36$var$init_initialize13();
        $281a441cdcb2cf36$var$init_config();
        $281a441cdcb2cf36$var$init_instrumentations();
        $281a441cdcb2cf36$var$init_internalLogger();
        $281a441cdcb2cf36$var$init_sdk();
        $281a441cdcb2cf36$var$init_semantic();
        $281a441cdcb2cf36$var$init_transports();
        $281a441cdcb2cf36$var$init_unpatchedConsole();
        $281a441cdcb2cf36$var$init_utils5();
        $281a441cdcb2cf36$var$init_version3();
        $281a441cdcb2cf36$var$init_consts();
    }
});
// ../node_modules/ua-parser-js/src/ua-parser.js
var $281a441cdcb2cf36$var$require_ua_parser = $281a441cdcb2cf36$var$__commonJS({
    "../node_modules/ua-parser-js/src/ua-parser.js" (exports, module) {
        (function(window2, undefined2) {
            "use strict";
            var LIBVERSION = "1.0.41", EMPTY = "", UNKNOWN = "?", FUNC_TYPE = "function", UNDEF_TYPE = "undefined", OBJ_TYPE = "object", STR_TYPE = "string", MAJOR = "major", MODEL = "model", NAME = "name", TYPE = "type", VENDOR = "vendor", VERSION8 = "version", ARCHITECTURE = "architecture", CONSOLE = "console", MOBILE = "mobile", TABLET = "tablet", SMARTTV = "smarttv", WEARABLE = "wearable", EMBEDDED = "embedded", UA_MAX_LENGTH = 500;
            var AMAZON = "Amazon", APPLE = "Apple", ASUS = "ASUS", BLACKBERRY = "BlackBerry", BROWSER = "Browser", CHROME = "Chrome", EDGE = "Edge", FIREFOX = "Firefox", GOOGLE = "Google", HONOR = "Honor", HUAWEI = "Huawei", LENOVO = "Lenovo", LG = "LG", MICROSOFT = "Microsoft", MOTOROLA = "Motorola", NVIDIA = "Nvidia", ONEPLUS = "OnePlus", OPERA = "Opera", OPPO = "OPPO", SAMSUNG = "Samsung", SHARP = "Sharp", SONY = "Sony", XIAOMI = "Xiaomi", ZEBRA = "Zebra", FACEBOOK = "Facebook", CHROMIUM_OS = "Chromium OS", MAC_OS = "Mac OS", SUFFIX_BROWSER = " Browser";
            var extend2 = function(regexes2, extensions) {
                var mergedRegexes = {};
                for(var i3 in regexes2)if (extensions[i3] && extensions[i3].length % 2 === 0) mergedRegexes[i3] = extensions[i3].concat(regexes2[i3]);
                else mergedRegexes[i3] = regexes2[i3];
                return mergedRegexes;
            }, enumerize = function(arr) {
                var enums = {};
                for(var i3 = 0; i3 < arr.length; i3++)enums[arr[i3].toUpperCase()] = arr[i3];
                return enums;
            }, has = function(str1, str2) {
                return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
            }, lowerize = function(str) {
                return str.toLowerCase();
            }, majorize = function(version6) {
                return typeof version6 === STR_TYPE ? version6.replace(/[^\d\.]/g, EMPTY).split(".")[0] : undefined2;
            }, trim = function(str, len) {
                if (typeof str === STR_TYPE) {
                    str = str.replace(/^\s\s*/, EMPTY);
                    return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
                }
            };
            var rgxMapper = function(ua, arrays) {
                var i3 = 0, j3, k3, p3, q3, matches, match2;
                while(i3 < arrays.length && !matches){
                    var regex = arrays[i3], props = arrays[i3 + 1];
                    j3 = k3 = 0;
                    while(j3 < regex.length && !matches){
                        if (!regex[j3]) break;
                        matches = regex[j3++].exec(ua);
                        if (!!matches) for(p3 = 0; p3 < props.length; p3++){
                            match2 = matches[++k3];
                            q3 = props[p3];
                            if (typeof q3 === OBJ_TYPE && q3.length > 0) {
                                if (q3.length === 2) {
                                    if (typeof q3[1] == FUNC_TYPE) this[q3[0]] = q3[1].call(this, match2);
                                    else this[q3[0]] = q3[1];
                                } else if (q3.length === 3) {
                                    if (typeof q3[1] === FUNC_TYPE && !(q3[1].exec && q3[1].test)) this[q3[0]] = match2 ? q3[1].call(this, match2, q3[2]) : undefined2;
                                    else this[q3[0]] = match2 ? match2.replace(q3[1], q3[2]) : undefined2;
                                } else if (q3.length === 4) this[q3[0]] = match2 ? q3[3].call(this, match2.replace(q3[1], q3[2])) : undefined2;
                            } else this[q3] = match2 ? match2 : undefined2;
                        }
                    }
                    i3 += 2;
                }
            }, strMapper = function(str, map2) {
                for(var i3 in map2){
                    if (typeof map2[i3] === OBJ_TYPE && map2[i3].length > 0) for(var j3 = 0; j3 < map2[i3].length; j3++){
                        if (has(map2[i3][j3], str)) return i3 === UNKNOWN ? undefined2 : i3;
                    }
                    else if (has(map2[i3], str)) return i3 === UNKNOWN ? undefined2 : i3;
                }
                return map2.hasOwnProperty("*") ? map2["*"] : str;
            };
            var oldSafariMap = {
                "1.0": "/8",
                "1.2": "/1",
                "1.3": "/3",
                "2.0": "/412",
                "2.0.2": "/416",
                "2.0.3": "/417",
                "2.0.4": "/419",
                "?": "/"
            }, windowsVersionMap = {
                "ME": "4.90",
                "NT 3.11": "NT3.51",
                "NT 4.0": "NT4.0",
                "2000": "NT 5.0",
                "XP": [
                    "NT 5.1",
                    "NT 5.2"
                ],
                "Vista": "NT 6.0",
                "7": "NT 6.1",
                "8": "NT 6.2",
                "8.1": "NT 6.3",
                "10": [
                    "NT 6.4",
                    "NT 10.0"
                ],
                "RT": "ARM"
            };
            var regexes = {
                browser: [
                    [
                        /\b(?:crmo|crios)\/([\w\.]+)/i
                    ],
                    [
                        VERSION8,
                        [
                            NAME,
                            "Chrome"
                        ]
                    ],
                    [
                        /edg(?:e|ios|a)?\/([\w\.]+)/i
                    ],
                    [
                        VERSION8,
                        [
                            NAME,
                            "Edge"
                        ]
                    ],
                    [
                        // Presto based
                        /(opera mini)\/([-\w\.]+)/i,
                        // Opera Mini
                        /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                        // Opera Mobi/Tablet
                        /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
                    ],
                    [
                        NAME,
                        VERSION8
                    ],
                    [
                        /opios[\/ ]+([\w\.]+)/i
                    ],
                    [
                        VERSION8,
                        [
                            NAME,
                            OPERA + " Mini"
                        ]
                    ],
                    [
                        /\bop(?:rg)?x\/([\w\.]+)/i
                    ],
                    [
                        VERSION8,
                        [
                            NAME,
                            OPERA + " GX"
                        ]
                    ],
                    [
                        /\bopr\/([\w\.]+)/i
                    ],
                    [
                        VERSION8,
                        [
                            NAME,
                            OPERA
                        ]
                    ],
                    [
                        // Mixed
                        /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
                    ],
                    [
                        VERSION8,
                        [
                            NAME,
                            "Baidu"
                        ]
                    ],
                    [
                        /\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i
                    ],
                    [
                        VERSION8,
                        [
                            NAME,
                            "Maxthon"
                        ]
                    ],
                    [
                        /(kindle)\/([\w\.]+)/i,
                        // Kindle
                        /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,
                        // Lunascape/Maxthon/Netfront/Jasmine/Blazer/Sleipnir
                        // Trident based
                        /(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,
                        // Avant/IEMobile/SlimBrowser/SlimBoat/Slimjet
                        /(?:ms|\()(ie) ([\w\.]+)/i,
                        // Internet Explorer
                        // Blink/Webkit/KHTML based                                         // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
                        /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i,
                        // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ//Vivaldi/DuckDuckGo/Klar/Helio/Dragon
                        /(heytap|ovi|115)browser\/([\d\.]+)/i,
                        // HeyTap/Ovi/115
                        /(weibo)__([\d\.]+)/i
                    ],
                    [
                        NAME,
                        VERSION8
                    ],
                    [
                        /quark(?:pc)?\/([-\w\.]+)/i
                    ],
                    [
                        VERSION8,
                        [
                            NAME,
                            "Quark"
                        ]
                    ],
                    [
                        /\bddg\/([\w\.]+)/i
                    ],
                    [
                        VERSION8,
                        [
                            NAME,
                            "DuckDuckGo"
                        ]
                    ],
                    [
                        /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
                    ],
                    [
                        VERSION8,
                        [
                            NAME,
                            "UC" + BROWSER
                        ]
                    ],
                    [
                        /microm.+\bqbcore\/([\w\.]+)/i,
                        // WeChat Desktop for Windows Built-in Browser
                        /\bqbcore\/([\w\.]+).+microm/i,
                        /micromessenger\/([\w\.]+)/i
                    ],
                    [
                        VERSION8,
                        [
                            NAME,
                            "WeChat"
                        ]
                    ],
                    [
                        /konqueror\/([\w\.]+)/i
                    ],
                    [
                        VERSION8,
                        [
                            NAME,
                            "Konqueror"
                        ]
                    ],
                    [
                        /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
                    ],
                    [
                        VERSION8,
                        [
                            NAME,
                            "IE"
                        ]
                    ],
                    [
                        /ya(?:search)?browser\/([\w\.]+)/i
                    ],
                    [
                        VERSION8,
                        [
                            NAME,
                            "Yandex"
                        ]
                    ],
                    [
                        /slbrowser\/([\w\.]+)/i
                    ],
                    [
                        VERSION8,
                        [
                            NAME,
                            "Smart Lenovo " + BROWSER
                        ]
                    ],
                    [
                        /(avast|avg)\/([\w\.]+)/i
                    ],
                    [
                        [
                            NAME,
                            /(.+)/,
                            "$1 Secure " + BROWSER
                        ],
                        VERSION8
                    ],
                    [
                        /\bfocus\/([\w\.]+)/i
                    ],
                    [
                        VERSION8,
                        [
                            NAME,
                            FIREFOX + " Focus"
                        ]
                    ],
                    [
                        /\bopt\/([\w\.]+)/i
                    ],
                    [
                        VERSION8,
                        [
                            NAME,
                            OPERA + " Touch"
                        ]
                    ],
                    [
                        /coc_coc\w+\/([\w\.]+)/i
                    ],
                    [
                        VERSION8,
                        [
                            NAME,
                            "Coc Coc"
                        ]
                    ],
                    [
                        /dolfin\/([\w\.]+)/i
                    ],
                    [
                        VERSION8,
                        [
                            NAME,
                            "Dolphin"
                        ]
                    ],
                    [
                        /coast\/([\w\.]+)/i
                    ],
                    [
                        VERSION8,
                        [
                            NAME,
                            OPERA + " Coast"
                        ]
                    ],
                    [
                        /miuibrowser\/([\w\.]+)/i
                    ],
                    [
                        VERSION8,
                        [
                            NAME,
                            "MIUI" + SUFFIX_BROWSER
                        ]
                    ],
                    [
                        /fxios\/([\w\.-]+)/i
                    ],
                    [
                        VERSION8,
                        [
                            NAME,
                            FIREFOX
                        ]
                    ],
                    [
                        /\bqihoobrowser\/?([\w\.]*)/i
                    ],
                    [
                        VERSION8,
                        [
                            NAME,
                            "360"
                        ]
                    ],
                    [
                        /\b(qq)\/([\w\.]+)/i
                    ],
                    [
                        [
                            NAME,
                            /(.+)/,
                            "$1Browser"
                        ],
                        VERSION8
                    ],
                    [
                        /(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i
                    ],
                    [
                        [
                            NAME,
                            /(.+)/,
                            "$1" + SUFFIX_BROWSER
                        ],
                        VERSION8
                    ],
                    [
                        // Oculus/Sailfish/HuaweiBrowser/VivoBrowser/PicoBrowser
                        /samsungbrowser\/([\w\.]+)/i
                    ],
                    [
                        VERSION8,
                        [
                            NAME,
                            SAMSUNG + " Internet"
                        ]
                    ],
                    [
                        /metasr[\/ ]?([\d\.]+)/i
                    ],
                    [
                        VERSION8,
                        [
                            NAME,
                            "Sogou Explorer"
                        ]
                    ],
                    [
                        /(sogou)mo\w+\/([\d\.]+)/i
                    ],
                    [
                        [
                            NAME,
                            "Sogou Mobile"
                        ],
                        VERSION8
                    ],
                    [
                        /(electron)\/([\w\.]+) safari/i,
                        // Electron-based App
                        /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                        // Tesla
                        /m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i
                    ],
                    [
                        NAME,
                        VERSION8
                    ],
                    [
                        /(lbbrowser|rekonq)/i,
                        // LieBao Browser/Rekonq
                        /\[(linkedin)app\]/i
                    ],
                    [
                        NAME
                    ],
                    [
                        /ome\/([\w\.]+) \w* ?(iron) saf/i,
                        // Iron
                        /ome\/([\w\.]+).+qihu (360)[es]e/i
                    ],
                    [
                        VERSION8,
                        NAME
                    ],
                    [
                        // WebView
                        /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
                    ],
                    [
                        [
                            NAME,
                            FACEBOOK
                        ],
                        VERSION8
                    ],
                    [
                        /(Klarna)\/([\w\.]+)/i,
                        // Klarna Shopping Browser for iOS & Android
                        /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                        // Kakao App
                        /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                        // Naver InApp
                        /(daum)apps[\/ ]([\w\.]+)/i,
                        // Daum App
                        /safari (line)\/([\w\.]+)/i,
                        // Line App for iOS
                        /\b(line)\/([\w\.]+)\/iab/i,
                        // Line App for Android
                        /(alipay)client\/([\w\.]+)/i,
                        // Alipay
                        /(twitter)(?:and| f.+e\/([\w\.]+))/i,
                        // Twitter
                        /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i
                    ],
                    [
                        NAME,
                        VERSION8
                    ],
                    [
                        /\bgsa\/([\w\.]+) .*safari\//i
                    ],
                    [
                        VERSION8,
                        [
                            NAME,
                            "GSA"
                        ]
                    ],
                    [
                        /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
                    ],
                    [
                        VERSION8,
                        [
                            NAME,
                            "TikTok"
                        ]
                    ],
                    [
                        /headlesschrome(?:\/([\w\.]+)| )/i
                    ],
                    [
                        VERSION8,
                        [
                            NAME,
                            CHROME + " Headless"
                        ]
                    ],
                    [
                        / wv\).+(chrome)\/([\w\.]+)/i
                    ],
                    [
                        [
                            NAME,
                            CHROME + " WebView"
                        ],
                        VERSION8
                    ],
                    [
                        /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
                    ],
                    [
                        VERSION8,
                        [
                            NAME,
                            "Android " + BROWSER
                        ]
                    ],
                    [
                        /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
                    ],
                    [
                        NAME,
                        VERSION8
                    ],
                    [
                        /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
                    ],
                    [
                        VERSION8,
                        [
                            NAME,
                            "Mobile Safari"
                        ]
                    ],
                    [
                        /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
                    ],
                    [
                        VERSION8,
                        NAME
                    ],
                    [
                        /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
                    ],
                    [
                        NAME,
                        [
                            VERSION8,
                            strMapper,
                            oldSafariMap
                        ]
                    ],
                    [
                        /(webkit|khtml)\/([\w\.]+)/i
                    ],
                    [
                        NAME,
                        VERSION8
                    ],
                    [
                        // Gecko based
                        /(navigator|netscape\d?)\/([-\w\.]+)/i
                    ],
                    [
                        [
                            NAME,
                            "Netscape"
                        ],
                        VERSION8
                    ],
                    [
                        /(wolvic|librewolf)\/([\w\.]+)/i
                    ],
                    [
                        NAME,
                        VERSION8
                    ],
                    [
                        /mobile vr; rv:([\w\.]+)\).+firefox/i
                    ],
                    [
                        VERSION8,
                        [
                            NAME,
                            FIREFOX + " Reality"
                        ]
                    ],
                    [
                        /ekiohf.+(flow)\/([\w\.]+)/i,
                        // Flow
                        /(swiftfox)/i,
                        // Swiftfox
                        /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
                        // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
                        /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                        // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
                        /(firefox)\/([\w\.]+)/i,
                        // Other Firefox-based
                        /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                        // Mozilla
                        // Other
                        /(amaya|dillo|doris|icab|ladybird|lynx|mosaic|netsurf|obigo|polaris|w3m|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                        // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Obigo/Mosaic/Go/ICE/UP.Browser/Ladybird
                        /\b(links) \(([\w\.]+)/i
                    ],
                    [
                        NAME,
                        [
                            VERSION8,
                            /_/g,
                            "."
                        ]
                    ],
                    [
                        /(cobalt)\/([\w\.]+)/i
                    ],
                    [
                        NAME,
                        [
                            VERSION8,
                            /master.|lts./,
                            ""
                        ]
                    ]
                ],
                cpu: [
                    [
                        /\b((amd|x|x86[-_]?|wow|win)64)\b/i
                    ],
                    [
                        [
                            ARCHITECTURE,
                            "amd64"
                        ]
                    ],
                    [
                        /(ia32(?=;))/i,
                        // IA32 (quicktime)
                        /\b((i[346]|x)86)(pc)?\b/i
                    ],
                    [
                        [
                            ARCHITECTURE,
                            "ia32"
                        ]
                    ],
                    [
                        /\b(aarch64|arm(v?[89]e?l?|_?64))\b/i
                    ],
                    [
                        [
                            ARCHITECTURE,
                            "arm64"
                        ]
                    ],
                    [
                        /\b(arm(v[67])?ht?n?[fl]p?)\b/i
                    ],
                    [
                        [
                            ARCHITECTURE,
                            "armhf"
                        ]
                    ],
                    [
                        // PocketPC mistakenly identified as PowerPC
                        /( (ce|mobile); ppc;|\/[\w\.]+arm\b)/i
                    ],
                    [
                        [
                            ARCHITECTURE,
                            "arm"
                        ]
                    ],
                    [
                        /((ppc|powerpc)(64)?)( mac|;|\))/i
                    ],
                    [
                        [
                            ARCHITECTURE,
                            /ower/,
                            EMPTY,
                            lowerize
                        ]
                    ],
                    [
                        / sun4\w[;\)]/i
                    ],
                    [
                        [
                            ARCHITECTURE,
                            "sparc"
                        ]
                    ],
                    [
                        /\b(avr32|ia64(?=;)|68k(?=\))|\barm(?=v([1-7]|[5-7]1)l?|;|eabi)|(irix|mips|sparc)(64)?\b|pa-risc)/i
                    ],
                    [
                        [
                            ARCHITECTURE,
                            lowerize
                        ]
                    ]
                ],
                device: [
                    [
                        //////////////////////////
                        // MOBILES & TABLETS
                        /////////////////////////
                        // Samsung
                        /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            SAMSUNG
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                        /samsung[- ]((?!sm-[lr])[-\w]+)/i,
                        /sec-(sgh\w+)/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            SAMSUNG
                        ],
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        // Apple
                        /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            APPLE
                        ],
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        /\((ipad);[-\w\),; ]+apple/i,
                        // iPad
                        /applecoremedia\/[\w\.]+ \((ipad)/i,
                        /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            APPLE
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /(macintosh);/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            APPLE
                        ]
                    ],
                    [
                        // Sharp
                        /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            SHARP
                        ],
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        // Honor
                        /\b((?:brt|eln|hey2?|gdi|jdn)-a?[lnw]09|(?:ag[rm]3?|jdn2|kob2)-a?[lw]0[09]hn)(?: bui|\)|;)/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            HONOR
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /honor([-\w ]+)[;\)]/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            HONOR
                        ],
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        // Huawei
                        /\b((?:ag[rs][2356]?k?|bah[234]?|bg[2o]|bt[kv]|cmr|cpn|db[ry]2?|jdn2|got|kob2?k?|mon|pce|scm|sht?|[tw]gr|vrd)-[ad]?[lw][0125][09]b?|605hw|bg2-u03|(?:gem|fdr|m2|ple|t1)-[7a]0[1-4][lu]|t1-a2[13][lw]|mediapad[\w\. ]*(?= bui|\)))\b(?!.+d\/s)/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            HUAWEI
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /(?:huawei)([-\w ]+)[;\)]/i,
                        /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            HUAWEI
                        ],
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        // Xiaomi
                        /oid[^\)]+; (2[\dbc]{4}(182|283|rp\w{2})[cgl]|m2105k81a?c)(?: bui|\))/i,
                        /\b((?:red)?mi[-_ ]?pad[\w- ]*)(?: bui|\))/i
                    ],
                    [
                        [
                            MODEL,
                            /_/g,
                            " "
                        ],
                        [
                            VENDOR,
                            XIAOMI
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
                        // Xiaomi POCO
                        /\b; (\w+) build\/hm\1/i,
                        // Xiaomi Hongmi 'numeric' models
                        /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                        // Xiaomi Hongmi
                        /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                        // Xiaomi Redmi
                        /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
                        // Xiaomi Redmi 'numeric' models
                        /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i,
                        // Xiaomi Mi
                        / ([\w ]+) miui\/v?\d/i
                    ],
                    [
                        [
                            MODEL,
                            /_/g,
                            " "
                        ],
                        [
                            VENDOR,
                            XIAOMI
                        ],
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        // OPPO
                        /; (\w+) bui.+ oppo/i,
                        /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            OPPO
                        ],
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        /\b(opd2(\d{3}a?))(?: bui|\))/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            strMapper,
                            {
                                "OnePlus": [
                                    "304",
                                    "403",
                                    "203"
                                ],
                                "*": OPPO
                            }
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        // Vivo
                        /vivo (\w+)(?: bui|\))/i,
                        /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Vivo"
                        ],
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        // Realme
                        /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Realme"
                        ],
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        // Motorola
                        /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                        /\bmot(?:orola)?[- ](\w*)/i,
                        /((?:moto(?! 360)[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            MOTOROLA
                        ],
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        /\b(mz60\d|xoom[2 ]{0,2}) build\//i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            MOTOROLA
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        // LG
                        /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            LG
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                        /\blg[-e;\/ ]+((?!browser|netcast|android tv|watch)\w+)/i,
                        /\blg-?([\d\w]+) bui/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            LG
                        ],
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        // Lenovo
                        /(ideatab[-\w ]+|602lv|d-42a|a101lv|a2109a|a3500-hv|s[56]000|pb-6505[my]|tb-?x?\d{3,4}(?:f[cu]|xu|[av])|yt\d?-[jx]?\d+[lfmx])( bui|;|\)|\/)/i,
                        /lenovo ?(b[68]0[08]0-?[hf]?|tab(?:[\w- ]+?)|tb[\w-]{6,7})( bui|;|\)|\/)/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            LENOVO
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        // Nokia
                        /(nokia) (t[12][01])/i
                    ],
                    [
                        VENDOR,
                        MODEL,
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /(?:maemo|nokia).*(n900|lumia \d+|rm-\d+)/i,
                        /nokia[-_ ]?(([-\w\. ]*))/i
                    ],
                    [
                        [
                            MODEL,
                            /_/g,
                            " "
                        ],
                        [
                            TYPE,
                            MOBILE
                        ],
                        [
                            VENDOR,
                            "Nokia"
                        ]
                    ],
                    [
                        // Google
                        /(pixel (c|tablet))\b/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            GOOGLE
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            GOOGLE
                        ],
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        // Sony
                        /droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            SONY
                        ],
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        /sony tablet [ps]/i,
                        /\b(?:sony)?sgp\w+(?: bui|\))/i
                    ],
                    [
                        [
                            MODEL,
                            "Xperia Tablet"
                        ],
                        [
                            VENDOR,
                            SONY
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        // OnePlus
                        / (kb2005|in20[12]5|be20[12][59])\b/i,
                        /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            ONEPLUS
                        ],
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        // Amazon
                        /(alexa)webm/i,
                        /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,
                        // Kindle Fire without Silk / Echo Show
                        /(kf[a-z]+)( bui|\)).+silk\//i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            AMAZON
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
                    ],
                    [
                        [
                            MODEL,
                            /(.+)/g,
                            "Fire Phone $1"
                        ],
                        [
                            VENDOR,
                            AMAZON
                        ],
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        // BlackBerry
                        /(playbook);[-\w\),; ]+(rim)/i
                    ],
                    [
                        MODEL,
                        VENDOR,
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /\b((?:bb[a-f]|st[hv])100-\d)/i,
                        /\(bb10; (\w+)/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            BLACKBERRY
                        ],
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        // Asus
                        /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            ASUS
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            ASUS
                        ],
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        // HTC
                        /(nexus 9)/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "HTC"
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                        // HTC
                        // ZTE
                        /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                        /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
                    ],
                    [
                        VENDOR,
                        [
                            MODEL,
                            /_/g,
                            " "
                        ],
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        // TCL
                        /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "TCL"
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        // itel
                        /(itel) ((\w+))/i
                    ],
                    [
                        [
                            VENDOR,
                            lowerize
                        ],
                        MODEL,
                        [
                            TYPE,
                            strMapper,
                            {
                                "tablet": [
                                    "p10001l",
                                    "w7001"
                                ],
                                "*": "mobile"
                            }
                        ]
                    ],
                    [
                        // Acer
                        /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Acer"
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        // Meizu
                        /droid.+; (m[1-5] note) bui/i,
                        /\bmz-([-\w]{2,})/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Meizu"
                        ],
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        // Ulefone
                        /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Ulefone"
                        ],
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        // Energizer
                        /; (energy ?\w+)(?: bui|\))/i,
                        /; energizer ([\w ]+)(?: bui|\))/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Energizer"
                        ],
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        // Cat
                        /; cat (b35);/i,
                        /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Cat"
                        ],
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        // Smartfren
                        /((?:new )?andromax[\w- ]+)(?: bui|\))/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Smartfren"
                        ],
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        // Nothing
                        /droid.+; (a(?:015|06[35]|142p?))/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Nothing"
                        ],
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        // Archos
                        /; (x67 5g|tikeasy \w+|ac[1789]\d\w+)( b|\))/i,
                        /archos ?(5|gamepad2?|([\w ]*[t1789]|hello) ?\d+[\w ]*)( b|\))/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Archos"
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /archos ([\w ]+)( b|\))/i,
                        /; (ac[3-6]\d\w{2,8})( b|\))/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Archos"
                        ],
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        // MIXED
                        /(imo) (tab \w+)/i,
                        // IMO
                        /(infinix) (x1101b?)/i
                    ],
                    [
                        VENDOR,
                        MODEL,
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus(?! zenw)|dell|jolla|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i,
                        // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron/Infinix/Tecno/Micromax/Advan
                        /; (hmd|imo) ([\w ]+?)(?: bui|\))/i,
                        // HMD/IMO
                        /(hp) ([\w ]+\w)/i,
                        // HP iPAQ
                        /(microsoft); (lumia[\w ]+)/i,
                        // Microsoft Lumia
                        /(lenovo)[-_ ]?([-\w ]+?)(?: bui|\)|\/)/i,
                        // Lenovo
                        /(oppo) ?([\w ]+) bui/i
                    ],
                    [
                        VENDOR,
                        MODEL,
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        /(kobo)\s(ereader|touch)/i,
                        // Kobo
                        /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                        // HP TouchPad
                        /(kindle)\/([\w\.]+)/i,
                        // Kindle
                        /(nook)[\w ]+build\/(\w+)/i,
                        // Nook
                        /(dell) (strea[kpr\d ]*[\dko])/i,
                        // Dell Streak
                        /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                        // Le Pan Tablets
                        /(trinity)[- ]*(t\d{3}) bui/i,
                        // Trinity Tablets
                        /(gigaset)[- ]+(q\w{1,9}) bui/i,
                        // Gigaset Tablets
                        /(vodafone) ([\w ]+)(?:\)| bui)/i
                    ],
                    [
                        VENDOR,
                        MODEL,
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /(surface duo)/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            MICROSOFT
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /droid [\d\.]+; (fp\du?)(?: b|\))/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Fairphone"
                        ],
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        /(u304aa)/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "AT&T"
                        ],
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        /\bsie-(\w*)/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Siemens"
                        ],
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        /\b(rct\w+) b/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "RCA"
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /\b(venue[\d ]{2,7}) b/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Dell"
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /\b(q(?:mv|ta)\w+) b/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Verizon"
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Barnes & Noble"
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /\b(tm\d{3}\w+) b/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "NuVision"
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /\b(k88) b/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "ZTE"
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /\b(nx\d{3}j) b/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "ZTE"
                        ],
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        /\b(gen\d{3}) b.+49h/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Swiss"
                        ],
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        /\b(zur\d{3}) b/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Swiss"
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /\b((zeki)?tb.*\b) b/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Zeki"
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /\b([yr]\d{2}) b/i,
                        /\b(dragon[- ]+touch |dt)(\w{5}) b/i
                    ],
                    [
                        [
                            VENDOR,
                            "Dragon Touch"
                        ],
                        MODEL,
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /\b(ns-?\w{0,9}) b/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Insignia"
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /\b((nxa|next)-?\w{0,9}) b/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "NextBook"
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
                    ],
                    [
                        [
                            VENDOR,
                            "Voice"
                        ],
                        MODEL,
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        /\b(lvtel\-)?(v1[12]) b/i
                    ],
                    [
                        [
                            VENDOR,
                            "LvTel"
                        ],
                        MODEL,
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        /\b(ph-1) /i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Essential"
                        ],
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        /\b(v(100md|700na|7011|917g).*\b) b/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Envizen"
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /\b(trio[-\w\. ]+) b/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "MachSpeed"
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /\btu_(1491) b/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Rotor"
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /((?:tegranote|shield t(?!.+d tv))[\w- ]*?)(?: b|\))/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            NVIDIA
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /(sprint) (\w+)/i
                    ],
                    [
                        VENDOR,
                        MODEL,
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        /(kin\.[onetw]{3})/i
                    ],
                    [
                        [
                            MODEL,
                            /\./g,
                            " "
                        ],
                        [
                            VENDOR,
                            MICROSOFT
                        ],
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            ZEBRA
                        ],
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            ZEBRA
                        ],
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        ///////////////////
                        // SMARTTVS
                        ///////////////////
                        /smart-tv.+(samsung)/i
                    ],
                    [
                        VENDOR,
                        [
                            TYPE,
                            SMARTTV
                        ]
                    ],
                    [
                        /hbbtv.+maple;(\d+)/i
                    ],
                    [
                        [
                            MODEL,
                            /^/,
                            "SmartTV"
                        ],
                        [
                            VENDOR,
                            SAMSUNG
                        ],
                        [
                            TYPE,
                            SMARTTV
                        ]
                    ],
                    [
                        /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
                    ],
                    [
                        [
                            VENDOR,
                            LG
                        ],
                        [
                            TYPE,
                            SMARTTV
                        ]
                    ],
                    [
                        /(apple) ?tv/i
                    ],
                    [
                        VENDOR,
                        [
                            MODEL,
                            APPLE + " TV"
                        ],
                        [
                            TYPE,
                            SMARTTV
                        ]
                    ],
                    [
                        /crkey/i
                    ],
                    [
                        [
                            MODEL,
                            CHROME + "cast"
                        ],
                        [
                            VENDOR,
                            GOOGLE
                        ],
                        [
                            TYPE,
                            SMARTTV
                        ]
                    ],
                    [
                        /droid.+aft(\w+)( bui|\))/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            AMAZON
                        ],
                        [
                            TYPE,
                            SMARTTV
                        ]
                    ],
                    [
                        /(shield \w+ tv)/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            NVIDIA
                        ],
                        [
                            TYPE,
                            SMARTTV
                        ]
                    ],
                    [
                        /\(dtv[\);].+(aquos)/i,
                        /(aquos-tv[\w ]+)\)/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            SHARP
                        ],
                        [
                            TYPE,
                            SMARTTV
                        ]
                    ],
                    [
                        /(bravia[\w ]+)( bui|\))/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            SONY
                        ],
                        [
                            TYPE,
                            SMARTTV
                        ]
                    ],
                    [
                        /(mi(tv|box)-?\w+) bui/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            XIAOMI
                        ],
                        [
                            TYPE,
                            SMARTTV
                        ]
                    ],
                    [
                        /Hbbtv.*(technisat) (.*);/i
                    ],
                    [
                        VENDOR,
                        MODEL,
                        [
                            TYPE,
                            SMARTTV
                        ]
                    ],
                    [
                        /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                        // Roku
                        /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
                    ],
                    [
                        [
                            VENDOR,
                            trim
                        ],
                        [
                            MODEL,
                            trim
                        ],
                        [
                            TYPE,
                            SMARTTV
                        ]
                    ],
                    [
                        // SmartTV from Unidentified Vendors
                        /droid.+; ([\w- ]+) (?:android tv|smart[- ]?tv)/i
                    ],
                    [
                        MODEL,
                        [
                            TYPE,
                            SMARTTV
                        ]
                    ],
                    [
                        /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
                    ],
                    [
                        [
                            TYPE,
                            SMARTTV
                        ]
                    ],
                    [
                        ///////////////////
                        // CONSOLES
                        ///////////////////
                        /(ouya)/i,
                        // Ouya
                        /(nintendo) ([wids3utch]+)/i
                    ],
                    [
                        VENDOR,
                        MODEL,
                        [
                            TYPE,
                            CONSOLE
                        ]
                    ],
                    [
                        /droid.+; (shield)( bui|\))/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            NVIDIA
                        ],
                        [
                            TYPE,
                            CONSOLE
                        ]
                    ],
                    [
                        /(playstation \w+)/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            SONY
                        ],
                        [
                            TYPE,
                            CONSOLE
                        ]
                    ],
                    [
                        /\b(xbox(?: one)?(?!; xbox))[\); ]/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            MICROSOFT
                        ],
                        [
                            TYPE,
                            CONSOLE
                        ]
                    ],
                    [
                        ///////////////////
                        // WEARABLES
                        ///////////////////
                        /\b(sm-[lr]\d\d[0156][fnuw]?s?|gear live)\b/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            SAMSUNG
                        ],
                        [
                            TYPE,
                            WEARABLE
                        ]
                    ],
                    [
                        /((pebble))app/i,
                        // Pebble
                        /(asus|google|lg|oppo) ((pixel |zen)?watch[\w ]*)( bui|\))/i
                    ],
                    [
                        VENDOR,
                        MODEL,
                        [
                            TYPE,
                            WEARABLE
                        ]
                    ],
                    [
                        /(ow(?:19|20)?we?[1-3]{1,3})/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            OPPO
                        ],
                        [
                            TYPE,
                            WEARABLE
                        ]
                    ],
                    [
                        /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            APPLE
                        ],
                        [
                            TYPE,
                            WEARABLE
                        ]
                    ],
                    [
                        /(opwwe\d{3})/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            ONEPLUS
                        ],
                        [
                            TYPE,
                            WEARABLE
                        ]
                    ],
                    [
                        /(moto 360)/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            MOTOROLA
                        ],
                        [
                            TYPE,
                            WEARABLE
                        ]
                    ],
                    [
                        /(smartwatch 3)/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            SONY
                        ],
                        [
                            TYPE,
                            WEARABLE
                        ]
                    ],
                    [
                        /(g watch r)/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            LG
                        ],
                        [
                            TYPE,
                            WEARABLE
                        ]
                    ],
                    [
                        /droid.+; (wt63?0{2,3})\)/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            ZEBRA
                        ],
                        [
                            TYPE,
                            WEARABLE
                        ]
                    ],
                    [
                        ///////////////////
                        // XR
                        ///////////////////
                        /droid.+; (glass) \d/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            GOOGLE
                        ],
                        [
                            TYPE,
                            WEARABLE
                        ]
                    ],
                    [
                        /(pico) (4|neo3(?: link|pro)?)/i
                    ],
                    [
                        VENDOR,
                        MODEL,
                        [
                            TYPE,
                            WEARABLE
                        ]
                    ],
                    [
                        /; (quest( \d| pro)?)/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            FACEBOOK
                        ],
                        [
                            TYPE,
                            WEARABLE
                        ]
                    ],
                    [
                        ///////////////////
                        // EMBEDDED
                        ///////////////////
                        /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
                    ],
                    [
                        VENDOR,
                        [
                            TYPE,
                            EMBEDDED
                        ]
                    ],
                    [
                        /(aeobc)\b/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            AMAZON
                        ],
                        [
                            TYPE,
                            EMBEDDED
                        ]
                    ],
                    [
                        /(homepod).+mac os/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            APPLE
                        ],
                        [
                            TYPE,
                            EMBEDDED
                        ]
                    ],
                    [
                        /windows iot/i
                    ],
                    [
                        [
                            TYPE,
                            EMBEDDED
                        ]
                    ],
                    [
                        ////////////////////
                        // MIXED (GENERIC)
                        ///////////////////
                        /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i
                    ],
                    [
                        MODEL,
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
                    ],
                    [
                        MODEL,
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
                    ],
                    [
                        [
                            TYPE,
                            TABLET
                        ]
                    ],
                    [
                        /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
                    ],
                    [
                        [
                            TYPE,
                            MOBILE
                        ]
                    ],
                    [
                        /droid .+?; ([\w\. -]+)( bui|\))/i
                    ],
                    [
                        MODEL,
                        [
                            VENDOR,
                            "Generic"
                        ]
                    ]
                ],
                engine: [
                    [
                        /windows.+ edge\/([\w\.]+)/i
                    ],
                    [
                        VERSION8,
                        [
                            NAME,
                            EDGE + "HTML"
                        ]
                    ],
                    [
                        /(arkweb)\/([\w\.]+)/i
                    ],
                    [
                        NAME,
                        VERSION8
                    ],
                    [
                        /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
                    ],
                    [
                        VERSION8,
                        [
                            NAME,
                            "Blink"
                        ]
                    ],
                    [
                        /(presto)\/([\w\.]+)/i,
                        // Presto
                        /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,
                        // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna/Servo
                        /ekioh(flow)\/([\w\.]+)/i,
                        // Flow
                        /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                        // KHTML/Tasman/Links
                        /(icab)[\/ ]([23]\.[\d\.]+)/i,
                        // iCab
                        /\b(libweb)/i
                    ],
                    [
                        NAME,
                        VERSION8
                    ],
                    [
                        /ladybird\//i
                    ],
                    [
                        [
                            NAME,
                            "LibWeb"
                        ]
                    ],
                    [
                        /rv\:([\w\.]{1,9})\b.+(gecko)/i
                    ],
                    [
                        VERSION8,
                        NAME
                    ]
                ],
                os: [
                    [
                        // Windows
                        /microsoft (windows) (vista|xp)/i
                    ],
                    [
                        NAME,
                        VERSION8
                    ],
                    [
                        /(windows (?:phone(?: os)?|mobile|iot))[\/ ]?([\d\.\w ]*)/i
                    ],
                    [
                        NAME,
                        [
                            VERSION8,
                            strMapper,
                            windowsVersionMap
                        ]
                    ],
                    [
                        /windows nt 6\.2; (arm)/i,
                        // Windows RT
                        /windows[\/ ]([ntce\d\. ]+\w)(?!.+xbox)/i,
                        /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
                    ],
                    [
                        [
                            VERSION8,
                            strMapper,
                            windowsVersionMap
                        ],
                        [
                            NAME,
                            "Windows"
                        ]
                    ],
                    [
                        // iOS/macOS
                        /[adehimnop]{4,7}\b(?:.*os ([\w]+) like mac|; opera)/i,
                        // iOS
                        /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
                        /cfnetwork\/.+darwin/i
                    ],
                    [
                        [
                            VERSION8,
                            /_/g,
                            "."
                        ],
                        [
                            NAME,
                            "iOS"
                        ]
                    ],
                    [
                        /(mac os x) ?([\w\. ]*)/i,
                        /(macintosh|mac_powerpc\b)(?!.+haiku)/i
                    ],
                    [
                        [
                            NAME,
                            MAC_OS
                        ],
                        [
                            VERSION8,
                            /_/g,
                            "."
                        ]
                    ],
                    [
                        // Mobile OSes
                        /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
                    ],
                    [
                        VERSION8,
                        NAME
                    ],
                    [
                        /(ubuntu) ([\w\.]+) like android/i
                    ],
                    [
                        [
                            NAME,
                            /(.+)/,
                            "$1 Touch"
                        ],
                        VERSION8
                    ],
                    [
                        // Android/Blackberry/WebOS/QNX/Bada/RIM/KaiOS/Maemo/MeeGo/S40/Sailfish OS/OpenHarmony/Tizen
                        /(android|bada|blackberry|kaios|maemo|meego|openharmony|qnx|rim tablet os|sailfish|series40|symbian|tizen|webos)\w*[-\/; ]?([\d\.]*)/i
                    ],
                    [
                        NAME,
                        VERSION8
                    ],
                    [
                        /\(bb(10);/i
                    ],
                    [
                        VERSION8,
                        [
                            NAME,
                            BLACKBERRY
                        ]
                    ],
                    [
                        /(?:symbian ?os|symbos|s60(?=;)|series ?60)[-\/ ]?([\w\.]*)/i
                    ],
                    [
                        VERSION8,
                        [
                            NAME,
                            "Symbian"
                        ]
                    ],
                    [
                        /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
                    ],
                    [
                        VERSION8,
                        [
                            NAME,
                            FIREFOX + " OS"
                        ]
                    ],
                    [
                        /web0s;.+rt(tv)/i,
                        /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
                    ],
                    [
                        VERSION8,
                        [
                            NAME,
                            "webOS"
                        ]
                    ],
                    [
                        /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
                    ],
                    [
                        VERSION8,
                        [
                            NAME,
                            "watchOS"
                        ]
                    ],
                    [
                        // Google Chromecast
                        /crkey\/([\d\.]+)/i
                    ],
                    [
                        VERSION8,
                        [
                            NAME,
                            CHROME + "cast"
                        ]
                    ],
                    [
                        /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
                    ],
                    [
                        [
                            NAME,
                            CHROMIUM_OS
                        ],
                        VERSION8
                    ],
                    [
                        // Smart TVs
                        /panasonic;(viera)/i,
                        // Panasonic Viera
                        /(netrange)mmh/i,
                        // Netrange
                        /(nettv)\/(\d+\.[\w\.]+)/i,
                        // NetTV
                        // Console
                        /(nintendo|playstation) ([wids345portablevuch]+)/i,
                        // Nintendo/Playstation
                        /(xbox); +xbox ([^\);]+)/i,
                        // Microsoft Xbox (360, One, X, S, Series X, Series S)
                        // Other
                        /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                        // Joli/Palm
                        /(mint)[\/\(\) ]?(\w*)/i,
                        // Mint
                        /(mageia|vectorlinux)[; ]/i,
                        // Mageia/VectorLinux
                        /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                        // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
                        /(hurd|linux)(?: arm\w*| x86\w*| ?)([\w\.]*)/i,
                        // Hurd/Linux
                        /(gnu) ?([\w\.]*)/i,
                        // GNU
                        /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                        // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
                        /(haiku) (\w+)/i
                    ],
                    [
                        NAME,
                        VERSION8
                    ],
                    [
                        /(sunos) ?([\w\.\d]*)/i
                    ],
                    [
                        [
                            NAME,
                            "Solaris"
                        ],
                        VERSION8
                    ],
                    [
                        /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                        // Solaris
                        /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                        // AIX
                        /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                        // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX/SerenityOS
                        /(unix) ?([\w\.]*)/i
                    ],
                    [
                        NAME,
                        VERSION8
                    ]
                ]
            };
            var UAParser2 = function(ua, extensions) {
                if (typeof ua === OBJ_TYPE) {
                    extensions = ua;
                    ua = undefined2;
                }
                if (!(this instanceof UAParser2)) return new UAParser2(ua, extensions).getResult();
                var _navigator = typeof window2 !== UNDEF_TYPE && window2.navigator ? window2.navigator : undefined2;
                var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
                var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined2;
                var _rgxmap = extensions ? extend2(regexes, extensions) : regexes;
                var _isSelfNav = _navigator && _navigator.userAgent == _ua;
                this.getBrowser = function() {
                    var _browser = {};
                    _browser[NAME] = undefined2;
                    _browser[VERSION8] = undefined2;
                    rgxMapper.call(_browser, _ua, _rgxmap.browser);
                    _browser[MAJOR] = majorize(_browser[VERSION8]);
                    if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) _browser[NAME] = "Brave";
                    return _browser;
                };
                this.getCPU = function() {
                    var _cpu = {};
                    _cpu[ARCHITECTURE] = undefined2;
                    rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
                    return _cpu;
                };
                this.getDevice = function() {
                    var _device = {};
                    _device[VENDOR] = undefined2;
                    _device[MODEL] = undefined2;
                    _device[TYPE] = undefined2;
                    rgxMapper.call(_device, _ua, _rgxmap.device);
                    if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) _device[TYPE] = MOBILE;
                    if (_isSelfNav && _device[MODEL] == "Macintosh" && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                        _device[MODEL] = "iPad";
                        _device[TYPE] = TABLET;
                    }
                    return _device;
                };
                this.getEngine = function() {
                    var _engine = {};
                    _engine[NAME] = undefined2;
                    _engine[VERSION8] = undefined2;
                    rgxMapper.call(_engine, _ua, _rgxmap.engine);
                    return _engine;
                };
                this.getOS = function() {
                    var _os = {};
                    _os[NAME] = undefined2;
                    _os[VERSION8] = undefined2;
                    rgxMapper.call(_os, _ua, _rgxmap.os);
                    if (_isSelfNav && !_os[NAME] && _uach && _uach.platform && _uach.platform != "Unknown") _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS);
                    return _os;
                };
                this.getResult = function() {
                    return {
                        ua: this.getUA(),
                        browser: this.getBrowser(),
                        engine: this.getEngine(),
                        os: this.getOS(),
                        device: this.getDevice(),
                        cpu: this.getCPU()
                    };
                };
                this.getUA = function() {
                    return _ua;
                };
                this.setUA = function(ua2) {
                    _ua = typeof ua2 === STR_TYPE && ua2.length > UA_MAX_LENGTH ? trim(ua2, UA_MAX_LENGTH) : ua2;
                    return this;
                };
                this.setUA(_ua);
                return this;
            };
            UAParser2.VERSION = LIBVERSION;
            UAParser2.BROWSER = enumerize([
                NAME,
                VERSION8,
                MAJOR
            ]);
            UAParser2.CPU = enumerize([
                ARCHITECTURE
            ]);
            UAParser2.DEVICE = enumerize([
                MODEL,
                VENDOR,
                TYPE,
                CONSOLE,
                MOBILE,
                SMARTTV,
                TABLET,
                WEARABLE,
                EMBEDDED
            ]);
            UAParser2.ENGINE = UAParser2.OS = enumerize([
                NAME,
                VERSION8
            ]);
            if (typeof exports !== UNDEF_TYPE) {
                if (typeof module !== UNDEF_TYPE && module.exports) exports = module.exports = UAParser2;
                exports.UAParser = UAParser2;
            } else {
                if (typeof define === FUNC_TYPE && define.amd) define(function() {
                    return UAParser2;
                });
                else if (typeof window2 !== UNDEF_TYPE) window2.UAParser = UAParser2;
            }
            var $4 = typeof window2 !== UNDEF_TYPE && (window2.jQuery || window2.Zepto);
            if ($4 && !$4.ua) {
                var parser = new UAParser2();
                $4.ua = parser.getResult();
                $4.ua.get = function() {
                    return parser.getUA();
                };
                $4.ua.set = function(ua) {
                    parser.setUA(ua);
                    var result = parser.getResult();
                    for(var prop in result)$4.ua[prop] = result[prop];
                };
            }
        })(typeof window === "object" ? window : exports);
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/metas/browser/meta.js
var $281a441cdcb2cf36$var$import_ua_parser_js, $281a441cdcb2cf36$var$browserMeta;
var $281a441cdcb2cf36$var$init_meta2 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/metas/browser/meta.js" () {
        $281a441cdcb2cf36$var$import_ua_parser_js = $281a441cdcb2cf36$var$__toESM($281a441cdcb2cf36$var$require_ua_parser());
        $281a441cdcb2cf36$var$init_esm4();
        $281a441cdcb2cf36$var$browserMeta = ()=>{
            const parser = new $281a441cdcb2cf36$var$import_ua_parser_js.UAParser();
            const { name: name, version: version6 } = parser.getBrowser();
            const { name: osName, version: osVersion } = parser.getOS();
            const userAgent = parser.getUA();
            const language = navigator.language;
            const mobile = navigator.userAgent.includes("Mobi");
            const brands = getBrands();
            return {
                browser: {
                    name: name !== null && name !== void 0 ? name : $281a441cdcb2cf36$var$unknownString,
                    version: version6 !== null && version6 !== void 0 ? version6 : $281a441cdcb2cf36$var$unknownString,
                    os: `${osName !== null && osName !== void 0 ? osName : $281a441cdcb2cf36$var$unknownString} ${osVersion !== null && osVersion !== void 0 ? osVersion : $281a441cdcb2cf36$var$unknownString}`,
                    userAgent: userAgent !== null && userAgent !== void 0 ? userAgent : $281a441cdcb2cf36$var$unknownString,
                    language: language !== null && language !== void 0 ? language : $281a441cdcb2cf36$var$unknownString,
                    mobile: mobile,
                    brands: brands !== null && brands !== void 0 ? brands : $281a441cdcb2cf36$var$unknownString,
                    viewportWidth: `${window.innerWidth}`,
                    viewportHeight: `${window.innerHeight}`
                }
            };
            function getBrands() {
                if (!name || !version6) return void 0;
                if ("userAgentData" in navigator && navigator.userAgentData) return navigator.userAgentData.brands;
                return void 0;
            }
        };
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/metas/browser/index.js
var $281a441cdcb2cf36$var$init_browser2 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/metas/browser/index.js" () {
        $281a441cdcb2cf36$var$init_meta2();
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/metas/session/createSession.js
function $281a441cdcb2cf36$var$createSession(attributes) {
    var _a2, _b, _c, _d;
    return {
        id: (_d = (_c = (_b = (_a2 = $281a441cdcb2cf36$var$faro.config) === null || _a2 === void 0 ? void 0 : _a2.sessionTracking) === null || _b === void 0 ? void 0 : _b.generateSessionId) === null || _c === void 0 ? void 0 : _c.call(_b)) !== null && _d !== void 0 ? _d : $281a441cdcb2cf36$var$genShortID(),
        attributes: attributes
    };
}
var $281a441cdcb2cf36$var$init_createSession = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/metas/session/createSession.js" () {
        $281a441cdcb2cf36$var$init_esm4();
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/metas/session/index.js
var $281a441cdcb2cf36$var$init_session = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/metas/session/index.js" () {
        $281a441cdcb2cf36$var$init_createSession();
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/metas/sdk/meta.js
var $281a441cdcb2cf36$var$sdkMeta;
var $281a441cdcb2cf36$var$init_meta3 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/metas/sdk/meta.js" () {
        $281a441cdcb2cf36$var$init_esm4();
        $281a441cdcb2cf36$var$sdkMeta = ()=>({
                sdk: {
                    name: "@grafana/faro-core",
                    version: $281a441cdcb2cf36$var$VERSION4,
                    integrations: $281a441cdcb2cf36$var$faro.config.instrumentations.map(({ name: name, version: version6 })=>({
                            name: name,
                            version: version6
                        }))
                }
            });
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/metas/sdk/index.js
var $281a441cdcb2cf36$var$init_sdk2 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/metas/sdk/index.js" () {
        $281a441cdcb2cf36$var$init_meta3();
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/metas/index.js
var $281a441cdcb2cf36$var$init_metas2 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/metas/index.js" () {
        $281a441cdcb2cf36$var$init_browser2();
        $281a441cdcb2cf36$var$init_session();
        $281a441cdcb2cf36$var$init_sdk2();
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/utils/webStorage.js
function $281a441cdcb2cf36$var$isWebStorageAvailable(type) {
    var _a2;
    try {
        let storage;
        storage = window[type];
        const testItem = "__faro_storage_test__";
        storage.setItem(testItem, testItem);
        storage.removeItem(testItem);
        return true;
    } catch (error) {
        (_a2 = $281a441cdcb2cf36$var$faro.internalLogger) === null || _a2 === void 0 || _a2.info(`Web storage of type ${type} is not available. Reason: ${error}`);
        return false;
    }
}
function $281a441cdcb2cf36$var$getItem2(key, webStorageMechanism) {
    if ($281a441cdcb2cf36$var$isWebStorageTypeAvailable(webStorageMechanism)) return window[webStorageMechanism].getItem(key);
    return null;
}
function $281a441cdcb2cf36$var$setItem(key, value2, webStorageMechanism) {
    if ($281a441cdcb2cf36$var$isWebStorageTypeAvailable(webStorageMechanism)) try {
        window[webStorageMechanism].setItem(key, value2);
    } catch (error) {}
}
function $281a441cdcb2cf36$var$removeItem(key, webStorageMechanism) {
    if ($281a441cdcb2cf36$var$isWebStorageTypeAvailable(webStorageMechanism)) window[webStorageMechanism].removeItem(key);
}
function $281a441cdcb2cf36$var$isWebStorageTypeAvailable(webStorageMechanism) {
    if (webStorageMechanism === $281a441cdcb2cf36$var$webStorageType.local) return $281a441cdcb2cf36$var$isLocalStorageAvailable;
    if (webStorageMechanism === $281a441cdcb2cf36$var$webStorageType.session) return $281a441cdcb2cf36$var$isSessionStorageAvailable;
    return false;
}
var $281a441cdcb2cf36$var$webStorageType, $281a441cdcb2cf36$var$isLocalStorageAvailable, $281a441cdcb2cf36$var$isSessionStorageAvailable;
var $281a441cdcb2cf36$var$init_webStorage = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/utils/webStorage.js" () {
        $281a441cdcb2cf36$var$init_esm4();
        $281a441cdcb2cf36$var$webStorageType = {
            session: "sessionStorage",
            local: "localStorage"
        };
        $281a441cdcb2cf36$var$isLocalStorageAvailable = $281a441cdcb2cf36$var$isWebStorageAvailable($281a441cdcb2cf36$var$webStorageType.local);
        $281a441cdcb2cf36$var$isSessionStorageAvailable = $281a441cdcb2cf36$var$isWebStorageAvailable($281a441cdcb2cf36$var$webStorageType.session);
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/utils/throttle.js
function $281a441cdcb2cf36$var$throttle(callback, delay) {
    let pause = false;
    let lastPending;
    const timeoutBehavior = ()=>{
        if (lastPending == null) {
            pause = false;
            return;
        }
        callback(...lastPending);
        lastPending = null;
        setTimeout(timeoutBehavior, delay);
    };
    return (...args2)=>{
        if (pause) {
            lastPending = args2;
            return;
        }
        callback(...args2);
        pause = true;
        setTimeout(timeoutBehavior, delay);
    };
}
var $281a441cdcb2cf36$var$init_throttle = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/utils/throttle.js" () {}
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/utils/url.js
function $281a441cdcb2cf36$var$getIgnoreUrls() {
    return $281a441cdcb2cf36$var$faro.transports.transports.flatMap((transport)=>transport.getIgnoreUrls());
}
function $281a441cdcb2cf36$var$isUrlIgnored(url2 = "") {
    return $281a441cdcb2cf36$var$getIgnoreUrls().some((ignoredUrl)=>url2 && url2.match(ignoredUrl) != null);
}
function $281a441cdcb2cf36$var$getUrlFromResource(resource) {
    if ($281a441cdcb2cf36$var$isString(resource)) return resource;
    if (resource instanceof URL) return resource.href;
    if (!$281a441cdcb2cf36$var$isEmpty2(resource) && $281a441cdcb2cf36$var$isFunction3(resource === null || resource === void 0 ? void 0 : resource.toString)) return resource.toString();
    return void 0;
}
var $281a441cdcb2cf36$var$init_url = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/utils/url.js" () {
        $281a441cdcb2cf36$var$init_esm4();
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/utils/index.js
var $281a441cdcb2cf36$var$init_utils8 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/utils/index.js" () {
        $281a441cdcb2cf36$var$init_webStorage();
        $281a441cdcb2cf36$var$init_throttle();
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/session/sessionManager/sessionConstants.js
var $281a441cdcb2cf36$var$STORAGE_KEY, $281a441cdcb2cf36$var$SESSION_EXPIRATION_TIME, $281a441cdcb2cf36$var$SESSION_INACTIVITY_TIME, $281a441cdcb2cf36$var$STORAGE_UPDATE_DELAY, $281a441cdcb2cf36$var$MAX_SESSION_PERSISTENCE_TIME_BUFFER, $281a441cdcb2cf36$var$MAX_SESSION_PERSISTENCE_TIME, $281a441cdcb2cf36$var$defaultSessionTrackingConfig;
var $281a441cdcb2cf36$var$init_sessionConstants = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/session/sessionManager/sessionConstants.js" () {
        $281a441cdcb2cf36$var$STORAGE_KEY = "com.grafana.faro.session";
        $281a441cdcb2cf36$var$SESSION_EXPIRATION_TIME = 14400000;
        $281a441cdcb2cf36$var$SESSION_INACTIVITY_TIME = 900000;
        $281a441cdcb2cf36$var$STORAGE_UPDATE_DELAY = 1000;
        $281a441cdcb2cf36$var$MAX_SESSION_PERSISTENCE_TIME_BUFFER = 60000;
        $281a441cdcb2cf36$var$MAX_SESSION_PERSISTENCE_TIME = $281a441cdcb2cf36$var$SESSION_INACTIVITY_TIME;
        $281a441cdcb2cf36$var$defaultSessionTrackingConfig = {
            enabled: true,
            persistent: false,
            maxSessionPersistenceTime: $281a441cdcb2cf36$var$MAX_SESSION_PERSISTENCE_TIME
        };
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/session/sessionManager/sampling.js
function $281a441cdcb2cf36$var$isSampled() {
    var _a2, _b, _c;
    const sendAllSignals = 1;
    const sessionTracking = $281a441cdcb2cf36$var$faro.config.sessionTracking;
    let samplingRate = (_c = (_b = (_a2 = sessionTracking === null || sessionTracking === void 0 ? void 0 : sessionTracking.sampler) === null || _a2 === void 0 ? void 0 : _a2.call(sessionTracking, {
        metas: $281a441cdcb2cf36$var$faro.metas.value
    })) !== null && _b !== void 0 ? _b : sessionTracking === null || sessionTracking === void 0 ? void 0 : sessionTracking.samplingRate) !== null && _c !== void 0 ? _c : sendAllSignals;
    if (typeof samplingRate !== "number") {
        const sendNoSignals = 0;
        samplingRate = sendNoSignals;
    }
    return Math.random() < samplingRate;
}
var $281a441cdcb2cf36$var$init_sampling = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/session/sessionManager/sampling.js" () {
        $281a441cdcb2cf36$var$init_esm4();
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/session/sessionManager/sessionManagerUtils.js
function $281a441cdcb2cf36$var$createUserSessionObject({ sessionId: sessionId, started: started, lastActivity: lastActivity, isSampled: isSampled2 = true } = {}) {
    var _a2, _b;
    const now = $281a441cdcb2cf36$var$dateNow();
    const generateSessionId = (_b = (_a2 = $281a441cdcb2cf36$var$faro.config) === null || _a2 === void 0 ? void 0 : _a2.sessionTracking) === null || _b === void 0 ? void 0 : _b.generateSessionId;
    if (sessionId == null) sessionId = typeof generateSessionId === "function" ? generateSessionId() : $281a441cdcb2cf36$var$genShortID();
    return {
        sessionId: sessionId,
        lastActivity: lastActivity !== null && lastActivity !== void 0 ? lastActivity : now,
        started: started !== null && started !== void 0 ? started : now,
        isSampled: isSampled2
    };
}
function $281a441cdcb2cf36$var$isUserSessionValid(session) {
    if (session == null) return false;
    const now = $281a441cdcb2cf36$var$dateNow();
    const lifetimeValid = now - session.started < $281a441cdcb2cf36$var$SESSION_EXPIRATION_TIME;
    if (!lifetimeValid) return false;
    const inactivityPeriodValid = now - session.lastActivity < $281a441cdcb2cf36$var$SESSION_INACTIVITY_TIME;
    return inactivityPeriodValid;
}
function $281a441cdcb2cf36$var$getUserSessionUpdater({ fetchUserSession: fetchUserSession, storeUserSession: storeUserSession }) {
    return function updateSession({ forceSessionExtend: forceSessionExtend } = {
        forceSessionExtend: false
    }) {
        var _a2, _b, _c;
        if (!fetchUserSession || !storeUserSession) return;
        const sessionTrackingConfig = $281a441cdcb2cf36$var$faro.config.sessionTracking;
        const isPersistentSessions = sessionTrackingConfig === null || sessionTrackingConfig === void 0 ? void 0 : sessionTrackingConfig.persistent;
        if (isPersistentSessions && !$281a441cdcb2cf36$var$isLocalStorageAvailable || !isPersistentSessions && !$281a441cdcb2cf36$var$isSessionStorageAvailable) return;
        const sessionFromStorage = fetchUserSession();
        if (forceSessionExtend === false && $281a441cdcb2cf36$var$isUserSessionValid(sessionFromStorage)) storeUserSession(Object.assign(Object.assign({}, sessionFromStorage), {
            lastActivity: $281a441cdcb2cf36$var$dateNow()
        }));
        else {
            let newSession = $281a441cdcb2cf36$var$addSessionMetadataToNextSession($281a441cdcb2cf36$var$createUserSessionObject({
                isSampled: $281a441cdcb2cf36$var$isSampled()
            }), sessionFromStorage);
            storeUserSession(newSession);
            (_a2 = $281a441cdcb2cf36$var$faro.api) === null || _a2 === void 0 || _a2.setSession(newSession.sessionMeta);
            (_b = sessionTrackingConfig === null || sessionTrackingConfig === void 0 ? void 0 : sessionTrackingConfig.onSessionChange) === null || _b === void 0 || _b.call(sessionTrackingConfig, (_c = sessionFromStorage === null || sessionFromStorage === void 0 ? void 0 : sessionFromStorage.sessionMeta) !== null && _c !== void 0 ? _c : null, newSession.sessionMeta);
        }
    };
}
function $281a441cdcb2cf36$var$addSessionMetadataToNextSession(newSession, previousSession) {
    var _a2, _b, _c, _d, _e, _f, _g;
    const sessionWithMeta = Object.assign(Object.assign({}, newSession), {
        sessionMeta: {
            id: newSession.sessionId,
            attributes: Object.assign(Object.assign(Object.assign({}, (_b = (_a2 = $281a441cdcb2cf36$var$faro.config.sessionTracking) === null || _a2 === void 0 ? void 0 : _a2.session) === null || _b === void 0 ? void 0 : _b.attributes), (_d = (_c = $281a441cdcb2cf36$var$faro.metas.value.session) === null || _c === void 0 ? void 0 : _c.attributes) !== null && _d !== void 0 ? _d : {}), {
                isSampled: newSession.isSampled.toString()
            })
        }
    });
    const overrides = (_f = (_e = $281a441cdcb2cf36$var$faro.metas.value.session) === null || _e === void 0 ? void 0 : _e.overrides) !== null && _f !== void 0 ? _f : (_g = previousSession === null || previousSession === void 0 ? void 0 : previousSession.sessionMeta) === null || _g === void 0 ? void 0 : _g.overrides;
    if (!$281a441cdcb2cf36$var$isEmpty2(overrides)) sessionWithMeta.sessionMeta.overrides = overrides;
    const previousSessionId = previousSession === null || previousSession === void 0 ? void 0 : previousSession.sessionId;
    if (previousSessionId != null) sessionWithMeta.sessionMeta.attributes["previousSession"] = previousSessionId;
    return sessionWithMeta;
}
function $281a441cdcb2cf36$var$getSessionMetaUpdateHandler({ fetchUserSession: fetchUserSession, storeUserSession: storeUserSession }) {
    return function syncSessionIfChangedExternally(meta) {
        const session = meta.session;
        const sessionFromSessionStorage = fetchUserSession();
        let sessionId = session === null || session === void 0 ? void 0 : session.id;
        const sessionAttributes = session === null || session === void 0 ? void 0 : session.attributes;
        const sessionOverrides = session === null || session === void 0 ? void 0 : session.overrides;
        const storedSessionMeta = sessionFromSessionStorage === null || sessionFromSessionStorage === void 0 ? void 0 : sessionFromSessionStorage.sessionMeta;
        const storedSessionMetaOverrides = storedSessionMeta === null || storedSessionMeta === void 0 ? void 0 : storedSessionMeta.overrides;
        const hasSessionOverridesChanged = !!sessionOverrides && !$281a441cdcb2cf36$var$deepEqual2(sessionOverrides, storedSessionMetaOverrides);
        const hasAttributesChanged = !!sessionAttributes && !$281a441cdcb2cf36$var$deepEqual2(sessionAttributes, storedSessionMeta === null || storedSessionMeta === void 0 ? void 0 : storedSessionMeta.attributes);
        const hasSessionIdChanged = !!session && sessionId !== (sessionFromSessionStorage === null || sessionFromSessionStorage === void 0 ? void 0 : sessionFromSessionStorage.sessionId);
        if (hasSessionIdChanged || hasAttributesChanged || hasSessionOverridesChanged) {
            const userSession = $281a441cdcb2cf36$var$addSessionMetadataToNextSession($281a441cdcb2cf36$var$createUserSessionObject({
                sessionId: sessionId,
                isSampled: $281a441cdcb2cf36$var$isSampled()
            }), sessionFromSessionStorage);
            storeUserSession(userSession);
            $281a441cdcb2cf36$var$sendOverrideEvent(hasSessionOverridesChanged, sessionOverrides, storedSessionMetaOverrides);
            $281a441cdcb2cf36$var$faro.api.setSession(userSession.sessionMeta);
        }
    };
}
function $281a441cdcb2cf36$var$sendOverrideEvent(hasSessionOverridesChanged, sessionOverrides = {}, storedSessionOverrides = {}) {
    var _a2, _b, _c;
    if (!hasSessionOverridesChanged) return;
    const serviceName2 = sessionOverrides.serviceName;
    const previousServiceName = (_c = (_a2 = storedSessionOverrides.serviceName) !== null && _a2 !== void 0 ? _a2 : (_b = $281a441cdcb2cf36$var$faro.metas.value.app) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : "";
    if (serviceName2 && serviceName2 !== previousServiceName) $281a441cdcb2cf36$var$faro.api.pushEvent($281a441cdcb2cf36$var$EVENT_OVERRIDES_SERVICE_NAME, {
        serviceName: serviceName2,
        previousServiceName: previousServiceName
    });
}
var $281a441cdcb2cf36$var$init_sessionManagerUtils = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/session/sessionManager/sessionManagerUtils.js" () {
        $281a441cdcb2cf36$var$init_esm4();
        $281a441cdcb2cf36$var$init_utils8();
        $281a441cdcb2cf36$var$init_sampling();
        $281a441cdcb2cf36$var$init_sessionConstants();
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/session/sessionManager/PersistentSessionsManager.js
var $281a441cdcb2cf36$var$PersistentSessionsManager;
var $281a441cdcb2cf36$var$init_PersistentSessionsManager = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/session/sessionManager/PersistentSessionsManager.js" () {
        $281a441cdcb2cf36$var$init_esm4();
        $281a441cdcb2cf36$var$init_utils8();
        $281a441cdcb2cf36$var$init_webStorage();
        $281a441cdcb2cf36$var$init_sessionConstants();
        $281a441cdcb2cf36$var$init_sessionManagerUtils();
        $281a441cdcb2cf36$var$PersistentSessionsManager = class _PersistentSessionsManager {
            constructor(){
                this.updateSession = $281a441cdcb2cf36$var$throttle(()=>this.updateUserSession(), $281a441cdcb2cf36$var$STORAGE_UPDATE_DELAY);
                this.updateUserSession = $281a441cdcb2cf36$var$getUserSessionUpdater({
                    fetchUserSession: _PersistentSessionsManager.fetchUserSession,
                    storeUserSession: _PersistentSessionsManager.storeUserSession
                });
                this.init();
            }
            static removeUserSession() {
                $281a441cdcb2cf36$var$removeItem($281a441cdcb2cf36$var$STORAGE_KEY, _PersistentSessionsManager.storageTypeLocal);
            }
            static storeUserSession(session) {
                $281a441cdcb2cf36$var$setItem($281a441cdcb2cf36$var$STORAGE_KEY, $281a441cdcb2cf36$var$stringifyExternalJson(session), _PersistentSessionsManager.storageTypeLocal);
            }
            static fetchUserSession() {
                const storedSession = $281a441cdcb2cf36$var$getItem2($281a441cdcb2cf36$var$STORAGE_KEY, _PersistentSessionsManager.storageTypeLocal);
                if (storedSession) return JSON.parse(storedSession);
                return null;
            }
            init() {
                document.addEventListener("visibilitychange", ()=>{
                    if (document.visibilityState === "visible") this.updateSession();
                });
                $281a441cdcb2cf36$var$faro.metas.addListener($281a441cdcb2cf36$var$getSessionMetaUpdateHandler({
                    fetchUserSession: _PersistentSessionsManager.fetchUserSession,
                    storeUserSession: _PersistentSessionsManager.storeUserSession
                }));
            }
        };
        $281a441cdcb2cf36$var$PersistentSessionsManager.storageTypeLocal = $281a441cdcb2cf36$var$webStorageType.local;
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/session/sessionManager/VolatileSessionManager.js
var $281a441cdcb2cf36$var$VolatileSessionsManager;
var $281a441cdcb2cf36$var$init_VolatileSessionManager = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/session/sessionManager/VolatileSessionManager.js" () {
        $281a441cdcb2cf36$var$init_esm4();
        $281a441cdcb2cf36$var$init_utils8();
        $281a441cdcb2cf36$var$init_webStorage();
        $281a441cdcb2cf36$var$init_sessionConstants();
        $281a441cdcb2cf36$var$init_sessionManagerUtils();
        $281a441cdcb2cf36$var$VolatileSessionsManager = class _VolatileSessionsManager {
            constructor(){
                this.updateSession = $281a441cdcb2cf36$var$throttle(()=>this.updateUserSession(), $281a441cdcb2cf36$var$STORAGE_UPDATE_DELAY);
                this.updateUserSession = $281a441cdcb2cf36$var$getUserSessionUpdater({
                    fetchUserSession: _VolatileSessionsManager.fetchUserSession,
                    storeUserSession: _VolatileSessionsManager.storeUserSession
                });
                this.init();
            }
            static removeUserSession() {
                $281a441cdcb2cf36$var$removeItem($281a441cdcb2cf36$var$STORAGE_KEY, _VolatileSessionsManager.storageTypeSession);
            }
            static storeUserSession(session) {
                $281a441cdcb2cf36$var$setItem($281a441cdcb2cf36$var$STORAGE_KEY, $281a441cdcb2cf36$var$stringifyExternalJson(session), _VolatileSessionsManager.storageTypeSession);
            }
            static fetchUserSession() {
                const storedSession = $281a441cdcb2cf36$var$getItem2($281a441cdcb2cf36$var$STORAGE_KEY, _VolatileSessionsManager.storageTypeSession);
                if (storedSession) return JSON.parse(storedSession);
                return null;
            }
            init() {
                document.addEventListener("visibilitychange", ()=>{
                    if (document.visibilityState === "visible") this.updateSession();
                });
                $281a441cdcb2cf36$var$faro.metas.addListener($281a441cdcb2cf36$var$getSessionMetaUpdateHandler({
                    fetchUserSession: _VolatileSessionsManager.fetchUserSession,
                    storeUserSession: _VolatileSessionsManager.storeUserSession
                }));
            }
        };
        $281a441cdcb2cf36$var$VolatileSessionsManager.storageTypeSession = $281a441cdcb2cf36$var$webStorageType.session;
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/session/sessionManager/getSessionManagerByConfig.js
function $281a441cdcb2cf36$var$getSessionManagerByConfig(sessionTrackingConfig) {
    return (sessionTrackingConfig === null || sessionTrackingConfig === void 0 ? void 0 : sessionTrackingConfig.persistent) ? $281a441cdcb2cf36$var$PersistentSessionsManager : $281a441cdcb2cf36$var$VolatileSessionsManager;
}
var $281a441cdcb2cf36$var$init_getSessionManagerByConfig = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/session/sessionManager/getSessionManagerByConfig.js" () {
        $281a441cdcb2cf36$var$init_PersistentSessionsManager();
        $281a441cdcb2cf36$var$init_VolatileSessionManager();
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/session/sessionManager/index.js
var $281a441cdcb2cf36$var$init_sessionManager = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/session/sessionManager/index.js" () {
        $281a441cdcb2cf36$var$init_PersistentSessionsManager();
        $281a441cdcb2cf36$var$init_VolatileSessionManager();
        $281a441cdcb2cf36$var$init_sessionConstants();
        $281a441cdcb2cf36$var$init_sampling();
        $281a441cdcb2cf36$var$init_getSessionManagerByConfig();
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/session/instrumentation.js
var $281a441cdcb2cf36$var$SessionInstrumentation;
var $281a441cdcb2cf36$var$init_instrumentation = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/session/instrumentation.js" () {
        $281a441cdcb2cf36$var$init_esm4();
        $281a441cdcb2cf36$var$init_metas2();
        $281a441cdcb2cf36$var$init_sessionManager();
        $281a441cdcb2cf36$var$init_PersistentSessionsManager();
        $281a441cdcb2cf36$var$init_sessionManagerUtils();
        $281a441cdcb2cf36$var$SessionInstrumentation = class extends $281a441cdcb2cf36$var$BaseInstrumentation {
            constructor(){
                super(...arguments);
                this.name = "@grafana/faro-web-sdk:instrumentation-session";
                this.version = $281a441cdcb2cf36$var$VERSION4;
            }
            sendSessionStartEvent(meta) {
                var _a2, _b;
                const session = meta.session;
                if (session && session.id !== ((_a2 = this.notifiedSession) === null || _a2 === void 0 ? void 0 : _a2.id)) {
                    if (this.notifiedSession && this.notifiedSession.id === ((_b = session.attributes) === null || _b === void 0 ? void 0 : _b["previousSession"])) {
                        this.api.pushEvent($281a441cdcb2cf36$var$EVENT_SESSION_EXTEND, {}, void 0, {
                            skipDedupe: true
                        });
                        this.notifiedSession = session;
                        return;
                    }
                    this.notifiedSession = session;
                    this.api.pushEvent($281a441cdcb2cf36$var$EVENT_SESSION_START, {}, void 0, {
                        skipDedupe: true
                    });
                }
            }
            createInitialSession(SessionManager, sessionsConfig) {
                var _a2, _b, _c, _d, _e, _f;
                let storedUserSession = SessionManager.fetchUserSession();
                if (sessionsConfig.persistent && sessionsConfig.maxSessionPersistenceTime && storedUserSession) {
                    const now = $281a441cdcb2cf36$var$dateNow();
                    const shouldClearPersistentSession = storedUserSession.lastActivity < now - sessionsConfig.maxSessionPersistenceTime;
                    if (shouldClearPersistentSession) {
                        $281a441cdcb2cf36$var$PersistentSessionsManager.removeUserSession();
                        storedUserSession = null;
                    }
                }
                let lifecycleType;
                let initialSession;
                if ($281a441cdcb2cf36$var$isUserSessionValid(storedUserSession)) {
                    const sessionId = storedUserSession === null || storedUserSession === void 0 ? void 0 : storedUserSession.sessionId;
                    initialSession = $281a441cdcb2cf36$var$createUserSessionObject({
                        sessionId: sessionId,
                        isSampled: storedUserSession.isSampled || false,
                        started: storedUserSession === null || storedUserSession === void 0 ? void 0 : storedUserSession.started
                    });
                    const storedUserSessionMeta = storedUserSession === null || storedUserSession === void 0 ? void 0 : storedUserSession.sessionMeta;
                    const overrides = Object.assign(Object.assign({}, (_a2 = sessionsConfig.session) === null || _a2 === void 0 ? void 0 : _a2.overrides), storedUserSessionMeta === null || storedUserSessionMeta === void 0 ? void 0 : storedUserSessionMeta.overrides);
                    initialSession.sessionMeta = Object.assign(Object.assign({}, sessionsConfig.session), {
                        id: sessionId,
                        attributes: Object.assign(Object.assign(Object.assign({}, (_b = sessionsConfig.session) === null || _b === void 0 ? void 0 : _b.attributes), storedUserSessionMeta === null || storedUserSessionMeta === void 0 ? void 0 : storedUserSessionMeta.attributes), {
                            // For valid resumed sessions we do not want to recalculate the sampling decision on each init phase.
                            isSampled: initialSession.isSampled.toString()
                        }),
                        overrides: overrides
                    });
                    lifecycleType = $281a441cdcb2cf36$var$EVENT_SESSION_RESUME;
                } else {
                    const sessionId = (_d = (_c = sessionsConfig.session) === null || _c === void 0 ? void 0 : _c.id) !== null && _d !== void 0 ? _d : $281a441cdcb2cf36$var$createSession().id;
                    initialSession = $281a441cdcb2cf36$var$createUserSessionObject({
                        sessionId: sessionId,
                        isSampled: $281a441cdcb2cf36$var$isSampled()
                    });
                    const overrides = (_e = sessionsConfig.session) === null || _e === void 0 ? void 0 : _e.overrides;
                    initialSession.sessionMeta = Object.assign({
                        id: sessionId,
                        attributes: Object.assign({
                            isSampled: initialSession.isSampled.toString()
                        }, (_f = sessionsConfig.session) === null || _f === void 0 ? void 0 : _f.attributes)
                    }, overrides ? {
                        overrides: overrides
                    } : {});
                    lifecycleType = $281a441cdcb2cf36$var$EVENT_SESSION_START;
                }
                return {
                    initialSession: initialSession,
                    lifecycleType: lifecycleType
                };
            }
            registerBeforeSendHook(SessionManager) {
                var _a2;
                const { updateSession: updateSession } = new SessionManager();
                (_a2 = this.transports) === null || _a2 === void 0 || _a2.addBeforeSendHooks((item)=>{
                    var _a3, _b, _c;
                    updateSession();
                    const attributes = (_a3 = item.meta.session) === null || _a3 === void 0 ? void 0 : _a3.attributes;
                    if (attributes && (attributes === null || attributes === void 0 ? void 0 : attributes["isSampled"]) === "true") {
                        let newItem = JSON.parse(JSON.stringify(item));
                        const newAttributes = (_b = newItem.meta.session) === null || _b === void 0 ? void 0 : _b.attributes;
                        newAttributes === null || newAttributes === void 0 || delete newAttributes["isSampled"];
                        if (Object.keys(newAttributes !== null && newAttributes !== void 0 ? newAttributes : {}).length === 0) (_c = newItem.meta.session) === null || _c === void 0 || delete _c.attributes;
                        return newItem;
                    }
                    return null;
                });
            }
            initialize() {
                this.logDebug("init session instrumentation");
                const sessionTrackingConfig = this.config.sessionTracking;
                if (sessionTrackingConfig === null || sessionTrackingConfig === void 0 ? void 0 : sessionTrackingConfig.enabled) {
                    const SessionManager = $281a441cdcb2cf36$var$getSessionManagerByConfig(sessionTrackingConfig);
                    this.registerBeforeSendHook(SessionManager);
                    const { initialSession: initialSession, lifecycleType: lifecycleType } = this.createInitialSession(SessionManager, sessionTrackingConfig);
                    SessionManager.storeUserSession(initialSession);
                    const initialSessionMeta = initialSession.sessionMeta;
                    this.notifiedSession = initialSessionMeta;
                    this.api.setSession(initialSessionMeta);
                    if (lifecycleType === $281a441cdcb2cf36$var$EVENT_SESSION_START) this.api.pushEvent($281a441cdcb2cf36$var$EVENT_SESSION_START, {}, void 0, {
                        skipDedupe: true
                    });
                    if (lifecycleType === $281a441cdcb2cf36$var$EVENT_SESSION_RESUME) this.api.pushEvent($281a441cdcb2cf36$var$EVENT_SESSION_RESUME, {}, void 0, {
                        skipDedupe: true
                    });
                }
                this.metas.addListener(this.sendSessionStartEvent.bind(this));
            }
        };
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/session/index.js
var $281a441cdcb2cf36$var$init_session2 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/session/index.js" () {
        $281a441cdcb2cf36$var$init_instrumentation();
        $281a441cdcb2cf36$var$init_sessionManager();
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/errors/const.js
var $281a441cdcb2cf36$var$primitiveUnhandledValue, $281a441cdcb2cf36$var$primitiveUnhandledType, $281a441cdcb2cf36$var$domErrorType, $281a441cdcb2cf36$var$domExceptionType, $281a441cdcb2cf36$var$objectEventValue, $281a441cdcb2cf36$var$unknownSymbolString, $281a441cdcb2cf36$var$valueTypeRegex;
var $281a441cdcb2cf36$var$init_const9 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/errors/const.js" () {
        $281a441cdcb2cf36$var$primitiveUnhandledValue = "Non-Error promise rejection captured with value:";
        $281a441cdcb2cf36$var$primitiveUnhandledType = "UnhandledRejection";
        $281a441cdcb2cf36$var$domErrorType = "DOMError";
        $281a441cdcb2cf36$var$domExceptionType = "DOMException";
        $281a441cdcb2cf36$var$objectEventValue = "Non-Error exception captured with keys:";
        $281a441cdcb2cf36$var$unknownSymbolString = "?";
        $281a441cdcb2cf36$var$valueTypeRegex = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/errors/getValueAndTypeFromMessage.js
function $281a441cdcb2cf36$var$getValueAndTypeFromMessage(message) {
    var _a2, _b;
    const groups = message.match($281a441cdcb2cf36$var$valueTypeRegex);
    const type = (_a2 = groups === null || groups === void 0 ? void 0 : groups[1]) !== null && _a2 !== void 0 ? _a2 : $281a441cdcb2cf36$var$defaultExceptionType;
    const value2 = (_b = groups === null || groups === void 0 ? void 0 : groups[2]) !== null && _b !== void 0 ? _b : message;
    return [
        value2,
        type
    ];
}
var $281a441cdcb2cf36$var$init_getValueAndTypeFromMessage = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/errors/getValueAndTypeFromMessage.js" () {
        $281a441cdcb2cf36$var$init_esm4();
        $281a441cdcb2cf36$var$init_const9();
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/errors/stackFrames/const.js
var $281a441cdcb2cf36$var$newLineString, $281a441cdcb2cf36$var$evalString, $281a441cdcb2cf36$var$unknownSymbolString2, $281a441cdcb2cf36$var$atString, $281a441cdcb2cf36$var$webkitLineRegex, $281a441cdcb2cf36$var$webkitEvalRegex, $281a441cdcb2cf36$var$webkitEvalString, $281a441cdcb2cf36$var$webkitAddressAtString, $281a441cdcb2cf36$var$webkitAddressAtStringLength, $281a441cdcb2cf36$var$firefoxLineRegex, $281a441cdcb2cf36$var$firefoxEvalRegex, $281a441cdcb2cf36$var$firefoxEvalString, $281a441cdcb2cf36$var$safariExtensionString, $281a441cdcb2cf36$var$safariWebExtensionString, $281a441cdcb2cf36$var$reactMinifiedRegex;
var $281a441cdcb2cf36$var$init_const10 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/errors/stackFrames/const.js" () {
        $281a441cdcb2cf36$var$newLineString = "\n";
        $281a441cdcb2cf36$var$evalString = "eval";
        $281a441cdcb2cf36$var$unknownSymbolString2 = "?";
        $281a441cdcb2cf36$var$atString = "@";
        $281a441cdcb2cf36$var$webkitLineRegex = /^\s*at (?:(.*?) ?\((?:address at )?)?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
        $281a441cdcb2cf36$var$webkitEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
        $281a441cdcb2cf36$var$webkitEvalString = "eval";
        $281a441cdcb2cf36$var$webkitAddressAtString = "address at ";
        $281a441cdcb2cf36$var$webkitAddressAtStringLength = $281a441cdcb2cf36$var$webkitAddressAtString.length;
        $281a441cdcb2cf36$var$firefoxLineRegex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|safari-extension|safari-web-extension|capacitor)?:\/.*?|\[native code]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
        $281a441cdcb2cf36$var$firefoxEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
        $281a441cdcb2cf36$var$firefoxEvalString = " > eval";
        $281a441cdcb2cf36$var$safariExtensionString = "safari-extension";
        $281a441cdcb2cf36$var$safariWebExtensionString = "safari-web-extension";
        $281a441cdcb2cf36$var$reactMinifiedRegex = /Minified React error #\d+;/i;
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/errors/stackFrames/buildStackFrame.js
function $281a441cdcb2cf36$var$buildStackFrame(filename, func, lineno, colno) {
    const stackFrame = {
        filename: filename || document.location.href,
        function: func || $281a441cdcb2cf36$var$unknownSymbolString2
    };
    if (lineno !== void 0) stackFrame.lineno = lineno;
    if (colno !== void 0) stackFrame.colno = colno;
    return stackFrame;
}
var $281a441cdcb2cf36$var$init_buildStackFrame = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/errors/stackFrames/buildStackFrame.js" () {
        $281a441cdcb2cf36$var$init_const10();
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/errors/stackFrames/getDataFromSafariExtensions.js
function $281a441cdcb2cf36$var$getDataFromSafariExtensions(func, filename) {
    const isSafariExtension = func === null || func === void 0 ? void 0 : func.includes($281a441cdcb2cf36$var$safariExtensionString);
    const isSafariWebExtension = !isSafariExtension && (func === null || func === void 0 ? void 0 : func.includes($281a441cdcb2cf36$var$safariWebExtensionString));
    if (!isSafariExtension && !isSafariWebExtension) return [
        func,
        filename
    ];
    return [
        (func === null || func === void 0 ? void 0 : func.includes($281a441cdcb2cf36$var$atString)) ? func.split($281a441cdcb2cf36$var$atString)[0] : func,
        isSafariExtension ? `${$281a441cdcb2cf36$var$safariExtensionString}:${filename}` : `${$281a441cdcb2cf36$var$safariWebExtensionString}:${filename}`
    ];
}
var $281a441cdcb2cf36$var$init_getDataFromSafariExtensions = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/errors/stackFrames/getDataFromSafariExtensions.js" () {
        $281a441cdcb2cf36$var$init_const10();
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/errors/stackFrames/getStackFramesFromError.js
function $281a441cdcb2cf36$var$getStackFramesFromError(error) {
    let lines = [];
    if (error.stacktrace) lines = error.stacktrace.split($281a441cdcb2cf36$var$newLineString).filter((_line, idx)=>idx % 2 === 0);
    else if (error.stack) lines = error.stack.split($281a441cdcb2cf36$var$newLineString);
    const stackFrames = lines.reduce((acc, line, idx)=>{
        let parts2;
        let func;
        let filename;
        let lineno;
        let colno;
        if (parts2 = $281a441cdcb2cf36$var$webkitLineRegex.exec(line)) {
            func = parts2[1];
            filename = parts2[2];
            lineno = parts2[3];
            colno = parts2[4];
            if (filename === null || filename === void 0 ? void 0 : filename.startsWith($281a441cdcb2cf36$var$webkitEvalString)) {
                const submatch = $281a441cdcb2cf36$var$webkitEvalRegex.exec(filename);
                if (submatch) {
                    filename = submatch[1];
                    lineno = submatch[2];
                    colno = submatch[3];
                }
            }
            filename = (filename === null || filename === void 0 ? void 0 : filename.startsWith($281a441cdcb2cf36$var$webkitAddressAtString)) ? filename.substring($281a441cdcb2cf36$var$webkitAddressAtStringLength) : filename;
            [func, filename] = $281a441cdcb2cf36$var$getDataFromSafariExtensions(func, filename);
        } else if (parts2 = $281a441cdcb2cf36$var$firefoxLineRegex.exec(line)) {
            func = parts2[1];
            filename = parts2[3];
            lineno = parts2[4];
            colno = parts2[5];
            if (!!filename && filename.includes($281a441cdcb2cf36$var$firefoxEvalString)) {
                const submatch = $281a441cdcb2cf36$var$firefoxEvalRegex.exec(filename);
                if (submatch) {
                    func = func || $281a441cdcb2cf36$var$evalString;
                    filename = submatch[1];
                    lineno = submatch[2];
                }
            } else if (idx === 0 && !colno && $281a441cdcb2cf36$var$isNumber(error.columnNumber)) colno = String(error.columnNumber + 1);
            [func, filename] = $281a441cdcb2cf36$var$getDataFromSafariExtensions(func, filename);
        }
        if (filename || func) acc.push($281a441cdcb2cf36$var$buildStackFrame(filename, func, lineno ? Number(lineno) : void 0, colno ? Number(colno) : void 0));
        return acc;
    }, []);
    if ($281a441cdcb2cf36$var$reactMinifiedRegex.test(error.message)) return stackFrames.slice(1);
    return stackFrames;
}
var $281a441cdcb2cf36$var$init_getStackFramesFromError = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/errors/stackFrames/getStackFramesFromError.js" () {
        $281a441cdcb2cf36$var$init_esm4();
        $281a441cdcb2cf36$var$init_buildStackFrame();
        $281a441cdcb2cf36$var$init_const10();
        $281a441cdcb2cf36$var$init_getDataFromSafariExtensions();
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/errors/stackFrames/parseStacktrace.js
function $281a441cdcb2cf36$var$parseStacktrace(error) {
    return {
        frames: $281a441cdcb2cf36$var$getStackFramesFromError(error)
    };
}
var $281a441cdcb2cf36$var$init_parseStacktrace = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/errors/stackFrames/parseStacktrace.js" () {
        $281a441cdcb2cf36$var$init_getStackFramesFromError();
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/errors/stackFrames/index.js
var $281a441cdcb2cf36$var$init_stackFrames = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/errors/stackFrames/index.js" () {
        $281a441cdcb2cf36$var$init_buildStackFrame();
        $281a441cdcb2cf36$var$init_getDataFromSafariExtensions();
        $281a441cdcb2cf36$var$init_getStackFramesFromError();
        $281a441cdcb2cf36$var$init_parseStacktrace();
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/errors/getErrorDetails.js
function $281a441cdcb2cf36$var$getErrorDetails(evt) {
    let value2;
    let type;
    let stackFrames = [];
    let isDomErrorRes;
    let isEventRes;
    if ($281a441cdcb2cf36$var$isErrorEvent(evt) && evt.error) {
        value2 = evt.error.message;
        type = evt.error.name;
        stackFrames = $281a441cdcb2cf36$var$getStackFramesFromError(evt.error);
    } else if ((isDomErrorRes = $281a441cdcb2cf36$var$isDomError(evt)) || $281a441cdcb2cf36$var$isDomException(evt)) {
        const { name: name, message: message } = evt;
        type = name !== null && name !== void 0 ? name : isDomErrorRes ? $281a441cdcb2cf36$var$domErrorType : $281a441cdcb2cf36$var$domExceptionType;
        value2 = message ? `${type}: ${message}` : type;
    } else if ($281a441cdcb2cf36$var$isError(evt)) {
        value2 = evt.message;
        stackFrames = $281a441cdcb2cf36$var$getStackFramesFromError(evt);
    } else if ($281a441cdcb2cf36$var$isObject4(evt) || (isEventRes = $281a441cdcb2cf36$var$isEvent(evt))) {
        type = isEventRes ? evt.constructor.name : void 0;
        value2 = `${$281a441cdcb2cf36$var$objectEventValue} ${Object.keys(evt)}`;
    }
    return [
        value2,
        type,
        stackFrames
    ];
}
function $281a441cdcb2cf36$var$getDetailsFromErrorArgs(args2) {
    const [evt, source, lineno, colno, error] = args2;
    let value2;
    let type;
    let stackFrames = [];
    const eventIsString = $281a441cdcb2cf36$var$isString(evt);
    const initialStackFrame = $281a441cdcb2cf36$var$buildStackFrame(source, $281a441cdcb2cf36$var$unknownSymbolString, lineno, colno);
    if (error || !eventIsString) {
        [value2, type, stackFrames] = $281a441cdcb2cf36$var$getErrorDetails(error !== null && error !== void 0 ? error : evt);
        if (stackFrames.length === 0) stackFrames = [
            initialStackFrame
        ];
    } else if (eventIsString) {
        [value2, type] = $281a441cdcb2cf36$var$getValueAndTypeFromMessage(evt);
        stackFrames = [
            initialStackFrame
        ];
    }
    return {
        value: value2,
        type: type,
        stackFrames: stackFrames
    };
}
function $281a441cdcb2cf36$var$getDetailsFromConsoleErrorArgs(args2, serializer) {
    if ($281a441cdcb2cf36$var$isError(args2[0])) return $281a441cdcb2cf36$var$getDetailsFromErrorArgs(args2);
    else return {
        value: serializer(args2)
    };
}
var $281a441cdcb2cf36$var$init_getErrorDetails = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/errors/getErrorDetails.js" () {
        $281a441cdcb2cf36$var$init_esm4();
        $281a441cdcb2cf36$var$init_const9();
        $281a441cdcb2cf36$var$init_getValueAndTypeFromMessage();
        $281a441cdcb2cf36$var$init_stackFrames();
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/console/instrumentation.js
var $281a441cdcb2cf36$var$ConsoleInstrumentation;
var $281a441cdcb2cf36$var$init_instrumentation2 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/console/instrumentation.js" () {
        $281a441cdcb2cf36$var$init_esm4();
        $281a441cdcb2cf36$var$init_getErrorDetails();
        $281a441cdcb2cf36$var$ConsoleInstrumentation = class _ConsoleInstrumentation extends $281a441cdcb2cf36$var$BaseInstrumentation {
            constructor(options = {}){
                super();
                this.options = options;
                this.name = "@grafana/faro-web-sdk:instrumentation-console";
                this.version = $281a441cdcb2cf36$var$VERSION4;
                this.errorSerializer = $281a441cdcb2cf36$var$defaultLogArgsSerializer;
            }
            initialize() {
                var _a2, _b, _c, _d;
                this.options = Object.assign(Object.assign({}, this.options), this.config.consoleInstrumentation);
                const serializeErrors = ((_a2 = this.options) === null || _a2 === void 0 ? void 0 : _a2.serializeErrors) || !!((_b = this.options) === null || _b === void 0 ? void 0 : _b.errorSerializer);
                this.errorSerializer = serializeErrors ? (_d = (_c = this.options) === null || _c === void 0 ? void 0 : _c.errorSerializer) !== null && _d !== void 0 ? _d : $281a441cdcb2cf36$var$defaultErrorArgsSerializer : $281a441cdcb2cf36$var$defaultLogArgsSerializer;
                $281a441cdcb2cf36$var$allLogLevels.filter((level)=>{
                    var _a3, _b2;
                    return !((_b2 = (_a3 = this.options) === null || _a3 === void 0 ? void 0 : _a3.disabledLevels) !== null && _b2 !== void 0 ? _b2 : _ConsoleInstrumentation.defaultDisabledLevels).includes(level);
                }).forEach((level)=>{
                    console[level] = (...args2)=>{
                        var _a3, _b2;
                        try {
                            if (level === $281a441cdcb2cf36$var$LogLevel.ERROR && !((_a3 = this.options) === null || _a3 === void 0 ? void 0 : _a3.consoleErrorAsLog)) {
                                const { value: value2, type: type, stackFrames: stackFrames } = $281a441cdcb2cf36$var$getDetailsFromConsoleErrorArgs(args2, this.errorSerializer);
                                if (value2 && !type && !stackFrames) {
                                    this.api.pushError(new Error(_ConsoleInstrumentation.consoleErrorPrefix + value2));
                                    return;
                                }
                                this.api.pushError(new Error(_ConsoleInstrumentation.consoleErrorPrefix + value2), {
                                    type: type,
                                    stackFrames: stackFrames
                                });
                            } else if (level === $281a441cdcb2cf36$var$LogLevel.ERROR && ((_b2 = this.options) === null || _b2 === void 0 ? void 0 : _b2.consoleErrorAsLog)) {
                                const { value: value2, type: type, stackFrames: stackFrames } = $281a441cdcb2cf36$var$getDetailsFromConsoleErrorArgs(args2, this.errorSerializer);
                                this.api.pushLog(value2 ? [
                                    _ConsoleInstrumentation.consoleErrorPrefix + value2
                                ] : args2, {
                                    level: level,
                                    context: {
                                        value: value2 !== null && value2 !== void 0 ? value2 : "",
                                        type: type !== null && type !== void 0 ? type : "",
                                        stackFrames: (stackFrames === null || stackFrames === void 0 ? void 0 : stackFrames.length) ? $281a441cdcb2cf36$var$defaultErrorArgsSerializer(stackFrames) : ""
                                    }
                                });
                            } else this.api.pushLog(args2, {
                                level: level
                            });
                        } catch (err) {
                            this.logError(err);
                        } finally{
                            this.unpatchedConsole[level](...args2);
                        }
                    };
                });
            }
        };
        $281a441cdcb2cf36$var$ConsoleInstrumentation.defaultDisabledLevels = [
            $281a441cdcb2cf36$var$LogLevel.DEBUG,
            $281a441cdcb2cf36$var$LogLevel.TRACE,
            $281a441cdcb2cf36$var$LogLevel.LOG
        ];
        $281a441cdcb2cf36$var$ConsoleInstrumentation.consoleErrorPrefix = "console.error: ";
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/console/index.js
var $281a441cdcb2cf36$var$init_console = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/console/index.js" () {
        $281a441cdcb2cf36$var$init_instrumentation2();
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/errors/registerOnerror.js
function $281a441cdcb2cf36$var$registerOnerror(api) {
    const oldOnerror = window.onerror;
    window.onerror = (...args2)=>{
        try {
            const { value: value2, type: type, stackFrames: stackFrames } = $281a441cdcb2cf36$var$getDetailsFromErrorArgs(args2);
            const originalError = args2[4];
            if (value2) {
                const options = {
                    type: type,
                    stackFrames: stackFrames
                };
                if (originalError != null) options.originalError = originalError;
                api.pushError(new Error(value2), options);
            }
        } finally{
            oldOnerror === null || oldOnerror === void 0 || oldOnerror.apply(window, args2);
        }
    };
}
var $281a441cdcb2cf36$var$init_registerOnerror = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/errors/registerOnerror.js" () {
        $281a441cdcb2cf36$var$init_getErrorDetails();
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/errors/registerOnunhandledrejection.js
function $281a441cdcb2cf36$var$registerOnunhandledrejection(api) {
    window.addEventListener("unhandledrejection", (evt)=>{
        var _a2, _b;
        let error = evt;
        if (error.reason) error = evt.reason;
        else if ((_a2 = evt.detail) === null || _a2 === void 0 ? void 0 : _a2.reason) error = (_b = evt.detail) === null || _b === void 0 ? void 0 : _b.reason;
        let value2;
        let type;
        let stackFrames = [];
        if ($281a441cdcb2cf36$var$isPrimitive2(error)) {
            value2 = `${$281a441cdcb2cf36$var$primitiveUnhandledValue} ${String(error)}`;
            type = $281a441cdcb2cf36$var$primitiveUnhandledType;
        } else [value2, type, stackFrames] = $281a441cdcb2cf36$var$getErrorDetails(error);
        if (value2) api.pushError(new Error(value2), {
            type: type,
            stackFrames: stackFrames
        });
    });
}
var $281a441cdcb2cf36$var$init_registerOnunhandledrejection = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/errors/registerOnunhandledrejection.js" () {
        $281a441cdcb2cf36$var$init_esm4();
        $281a441cdcb2cf36$var$init_const9();
        $281a441cdcb2cf36$var$init_getErrorDetails();
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/errors/instrumentation.js
var $281a441cdcb2cf36$var$ErrorsInstrumentation;
var $281a441cdcb2cf36$var$init_instrumentation3 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/errors/instrumentation.js" () {
        $281a441cdcb2cf36$var$init_esm4();
        $281a441cdcb2cf36$var$init_registerOnerror();
        $281a441cdcb2cf36$var$init_registerOnunhandledrejection();
        $281a441cdcb2cf36$var$ErrorsInstrumentation = class extends $281a441cdcb2cf36$var$BaseInstrumentation {
            constructor(){
                super(...arguments);
                this.name = "@grafana/faro-web-sdk:instrumentation-errors";
                this.version = $281a441cdcb2cf36$var$VERSION4;
            }
            initialize() {
                this.logDebug("Initializing");
                $281a441cdcb2cf36$var$registerOnerror(this.api);
                $281a441cdcb2cf36$var$registerOnunhandledrejection(this.api);
            }
        };
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/errors/index.js
var $281a441cdcb2cf36$var$init_errors = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/errors/index.js" () {
        $281a441cdcb2cf36$var$init_instrumentation3();
        $281a441cdcb2cf36$var$init_stackFrames();
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/view/instrumentation.js
var $281a441cdcb2cf36$var$ViewInstrumentation;
var $281a441cdcb2cf36$var$init_instrumentation4 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/view/instrumentation.js" () {
        $281a441cdcb2cf36$var$init_esm4();
        $281a441cdcb2cf36$var$ViewInstrumentation = class extends $281a441cdcb2cf36$var$BaseInstrumentation {
            constructor(){
                super(...arguments);
                this.name = "@grafana/faro-web-sdk:instrumentation-view";
                this.version = $281a441cdcb2cf36$var$VERSION4;
            }
            sendViewChangedEvent(meta) {
                var _a2, _b, _c, _d;
                const view = meta.view;
                if (view && view.name !== ((_a2 = this.notifiedView) === null || _a2 === void 0 ? void 0 : _a2.name)) {
                    this.api.pushEvent($281a441cdcb2cf36$var$EVENT_VIEW_CHANGED, {
                        fromView: (_c = (_b = this.notifiedView) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : $281a441cdcb2cf36$var$unknownString,
                        toView: (_d = view.name) !== null && _d !== void 0 ? _d : $281a441cdcb2cf36$var$unknownString
                    }, void 0, {
                        skipDedupe: true
                    });
                    this.notifiedView = view;
                }
            }
            initialize() {
                this.metas.addListener(this.sendViewChangedEvent.bind(this));
            }
        };
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/view/index.js
var $281a441cdcb2cf36$var$init_view = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/view/index.js" () {
        $281a441cdcb2cf36$var$init_instrumentation4();
    }
});
// ../node_modules/web-vitals/dist/web-vitals.js
var $281a441cdcb2cf36$var$e, $281a441cdcb2cf36$var$n, $281a441cdcb2cf36$var$t, $281a441cdcb2cf36$var$r, $281a441cdcb2cf36$var$i, $281a441cdcb2cf36$var$o, $281a441cdcb2cf36$var$a, $281a441cdcb2cf36$var$c, $281a441cdcb2cf36$var$u, $281a441cdcb2cf36$var$f, $281a441cdcb2cf36$var$s, $281a441cdcb2cf36$var$d, $281a441cdcb2cf36$var$l, $281a441cdcb2cf36$var$p, $281a441cdcb2cf36$var$v, $281a441cdcb2cf36$var$m, $281a441cdcb2cf36$var$h, $281a441cdcb2cf36$var$g, $281a441cdcb2cf36$var$y, $281a441cdcb2cf36$var$T, $281a441cdcb2cf36$var$E, $281a441cdcb2cf36$var$C, $281a441cdcb2cf36$var$b, $281a441cdcb2cf36$var$S, $281a441cdcb2cf36$var$L, $281a441cdcb2cf36$var$w, $281a441cdcb2cf36$var$A, $281a441cdcb2cf36$var$I, $281a441cdcb2cf36$var$P, $281a441cdcb2cf36$var$M, $281a441cdcb2cf36$var$k, $281a441cdcb2cf36$var$F, $281a441cdcb2cf36$var$D, $281a441cdcb2cf36$var$x, $281a441cdcb2cf36$var$R, $281a441cdcb2cf36$var$B, $281a441cdcb2cf36$var$H, $281a441cdcb2cf36$var$q, $281a441cdcb2cf36$var$O, $281a441cdcb2cf36$var$N, $281a441cdcb2cf36$var$j, $281a441cdcb2cf36$var$_, $281a441cdcb2cf36$var$z, $281a441cdcb2cf36$var$G, $281a441cdcb2cf36$var$J, $281a441cdcb2cf36$var$K, $281a441cdcb2cf36$var$Q, $281a441cdcb2cf36$var$U, $281a441cdcb2cf36$var$V, $281a441cdcb2cf36$var$W, $281a441cdcb2cf36$var$X, $281a441cdcb2cf36$var$Y, $281a441cdcb2cf36$var$Z, $281a441cdcb2cf36$var$$2, $281a441cdcb2cf36$var$ee;
var $281a441cdcb2cf36$var$init_web_vitals = $281a441cdcb2cf36$var$__esm({
    "../node_modules/web-vitals/dist/web-vitals.js" () {
        $281a441cdcb2cf36$var$o = -1;
        $281a441cdcb2cf36$var$a = function(e4) {
            addEventListener("pageshow", function(n3) {
                n3.persisted && ($281a441cdcb2cf36$var$o = n3.timeStamp, e4(n3));
            }, true);
        };
        $281a441cdcb2cf36$var$c = function() {
            var e4 = self.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
            if (e4 && e4.responseStart > 0 && e4.responseStart < performance.now()) return e4;
        };
        $281a441cdcb2cf36$var$u = function() {
            var e4 = $281a441cdcb2cf36$var$c();
            return e4 && e4.activationStart || 0;
        };
        $281a441cdcb2cf36$var$f = function(e4, n3) {
            var t4 = $281a441cdcb2cf36$var$c(), r3 = "navigate";
            $281a441cdcb2cf36$var$o >= 0 ? r3 = "back-forward-cache" : t4 && (document.prerendering || $281a441cdcb2cf36$var$u() > 0 ? r3 = "prerender" : document.wasDiscarded ? r3 = "restore" : t4.type && (r3 = t4.type.replace(/_/g, "-")));
            return {
                name: e4,
                value: void 0 === n3 ? -1 : n3,
                rating: "good",
                delta: 0,
                entries: [],
                id: "v4-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12),
                navigationType: r3
            };
        };
        $281a441cdcb2cf36$var$s = function(e4, n3, t4) {
            try {
                if (PerformanceObserver.supportedEntryTypes.includes(e4)) {
                    var r3 = new PerformanceObserver(function(e5) {
                        Promise.resolve().then(function() {
                            n3(e5.getEntries());
                        });
                    });
                    return r3.observe(Object.assign({
                        type: e4,
                        buffered: true
                    }, t4 || {})), r3;
                }
            } catch (e5) {}
        };
        $281a441cdcb2cf36$var$d = function(e4, n3, t4, r3) {
            var i3, o3;
            return function(a3) {
                n3.value >= 0 && (a3 || r3) && ((o3 = n3.value - (i3 || 0)) || void 0 === i3) && (i3 = n3.value, n3.delta = o3, n3.rating = function(e5, n4) {
                    return e5 > n4[1] ? "poor" : e5 > n4[0] ? "needs-improvement" : "good";
                }(n3.value, t4), e4(n3));
            };
        };
        $281a441cdcb2cf36$var$l = function(e4) {
            requestAnimationFrame(function() {
                return requestAnimationFrame(function() {
                    return e4();
                });
            });
        };
        $281a441cdcb2cf36$var$p = function(e4) {
            document.addEventListener("visibilitychange", function() {
                "hidden" === document.visibilityState && e4();
            });
        };
        $281a441cdcb2cf36$var$v = function(e4) {
            var n3 = false;
            return function() {
                n3 || (e4(), n3 = true);
            };
        };
        $281a441cdcb2cf36$var$m = -1;
        $281a441cdcb2cf36$var$h = function() {
            return "hidden" !== document.visibilityState || document.prerendering ? 1 / 0 : 0;
        };
        $281a441cdcb2cf36$var$g = function(e4) {
            "hidden" === document.visibilityState && $281a441cdcb2cf36$var$m > -1 && ($281a441cdcb2cf36$var$m = "visibilitychange" === e4.type ? e4.timeStamp : 0, $281a441cdcb2cf36$var$T());
        };
        $281a441cdcb2cf36$var$y = function() {
            addEventListener("visibilitychange", $281a441cdcb2cf36$var$g, true), addEventListener("prerenderingchange", $281a441cdcb2cf36$var$g, true);
        };
        $281a441cdcb2cf36$var$T = function() {
            removeEventListener("visibilitychange", $281a441cdcb2cf36$var$g, true), removeEventListener("prerenderingchange", $281a441cdcb2cf36$var$g, true);
        };
        $281a441cdcb2cf36$var$E = function() {
            return $281a441cdcb2cf36$var$m < 0 && ($281a441cdcb2cf36$var$m = $281a441cdcb2cf36$var$h(), $281a441cdcb2cf36$var$y(), $281a441cdcb2cf36$var$a(function() {
                setTimeout(function() {
                    $281a441cdcb2cf36$var$m = $281a441cdcb2cf36$var$h(), $281a441cdcb2cf36$var$y();
                }, 0);
            })), {
                get firstHiddenTime () {
                    return $281a441cdcb2cf36$var$m;
                }
            };
        };
        $281a441cdcb2cf36$var$C = function(e4) {
            document.prerendering ? addEventListener("prerenderingchange", function() {
                return e4();
            }, true) : e4();
        };
        $281a441cdcb2cf36$var$b = [
            1800,
            3e3
        ];
        $281a441cdcb2cf36$var$S = function(e4, n3) {
            n3 = n3 || {}, $281a441cdcb2cf36$var$C(function() {
                var t4, r3 = $281a441cdcb2cf36$var$E(), i3 = $281a441cdcb2cf36$var$f("FCP"), o3 = $281a441cdcb2cf36$var$s("paint", function(e5) {
                    e5.forEach(function(e6) {
                        "first-contentful-paint" === e6.name && (o3.disconnect(), e6.startTime < r3.firstHiddenTime && (i3.value = Math.max(e6.startTime - $281a441cdcb2cf36$var$u(), 0), i3.entries.push(e6), t4(true)));
                    });
                });
                o3 && (t4 = $281a441cdcb2cf36$var$d(e4, i3, $281a441cdcb2cf36$var$b, n3.reportAllChanges), $281a441cdcb2cf36$var$a(function(r4) {
                    i3 = $281a441cdcb2cf36$var$f("FCP"), t4 = $281a441cdcb2cf36$var$d(e4, i3, $281a441cdcb2cf36$var$b, n3.reportAllChanges), $281a441cdcb2cf36$var$l(function() {
                        i3.value = performance.now() - r4.timeStamp, t4(true);
                    });
                }));
            });
        };
        $281a441cdcb2cf36$var$L = [
            0.1,
            0.25
        ];
        $281a441cdcb2cf36$var$w = function(e4, n3) {
            n3 = n3 || {}, $281a441cdcb2cf36$var$S($281a441cdcb2cf36$var$v(function() {
                var t4, r3 = $281a441cdcb2cf36$var$f("CLS", 0), i3 = 0, o3 = [], c3 = function(e5) {
                    e5.forEach(function(e6) {
                        if (!e6.hadRecentInput) {
                            var n4 = o3[0], t5 = o3[o3.length - 1];
                            i3 && e6.startTime - t5.startTime < 1e3 && e6.startTime - n4.startTime < 5e3 ? (i3 += e6.value, o3.push(e6)) : (i3 = e6.value, o3 = [
                                e6
                            ]);
                        }
                    }), i3 > r3.value && (r3.value = i3, r3.entries = o3, t4());
                }, u3 = $281a441cdcb2cf36$var$s("layout-shift", c3);
                u3 && (t4 = $281a441cdcb2cf36$var$d(e4, r3, $281a441cdcb2cf36$var$L, n3.reportAllChanges), $281a441cdcb2cf36$var$p(function() {
                    c3(u3.takeRecords()), t4(true);
                }), $281a441cdcb2cf36$var$a(function() {
                    i3 = 0, r3 = $281a441cdcb2cf36$var$f("CLS", 0), t4 = $281a441cdcb2cf36$var$d(e4, r3, $281a441cdcb2cf36$var$L, n3.reportAllChanges), $281a441cdcb2cf36$var$l(function() {
                        return t4();
                    });
                }), setTimeout(t4, 0));
            }));
        };
        $281a441cdcb2cf36$var$A = 0;
        $281a441cdcb2cf36$var$I = 1 / 0;
        $281a441cdcb2cf36$var$P = 0;
        $281a441cdcb2cf36$var$M = function(e4) {
            e4.forEach(function(e5) {
                e5.interactionId && ($281a441cdcb2cf36$var$I = Math.min($281a441cdcb2cf36$var$I, e5.interactionId), $281a441cdcb2cf36$var$P = Math.max($281a441cdcb2cf36$var$P, e5.interactionId), $281a441cdcb2cf36$var$A = $281a441cdcb2cf36$var$P ? ($281a441cdcb2cf36$var$P - $281a441cdcb2cf36$var$I) / 7 + 1 : 0);
            });
        };
        $281a441cdcb2cf36$var$k = function() {
            return $281a441cdcb2cf36$var$e ? $281a441cdcb2cf36$var$A : performance.interactionCount || 0;
        };
        $281a441cdcb2cf36$var$F = function() {
            "interactionCount" in performance || $281a441cdcb2cf36$var$e || ($281a441cdcb2cf36$var$e = $281a441cdcb2cf36$var$s("event", $281a441cdcb2cf36$var$M, {
                type: "event",
                buffered: true,
                durationThreshold: 0
            }));
        };
        $281a441cdcb2cf36$var$D = [];
        $281a441cdcb2cf36$var$x = /* @__PURE__ */ new Map();
        $281a441cdcb2cf36$var$R = 0;
        $281a441cdcb2cf36$var$B = function() {
            var e4 = Math.min($281a441cdcb2cf36$var$D.length - 1, Math.floor(($281a441cdcb2cf36$var$k() - $281a441cdcb2cf36$var$R) / 50));
            return $281a441cdcb2cf36$var$D[e4];
        };
        $281a441cdcb2cf36$var$H = [];
        $281a441cdcb2cf36$var$q = function(e4) {
            if ($281a441cdcb2cf36$var$H.forEach(function(n4) {
                return n4(e4);
            }), e4.interactionId || "first-input" === e4.entryType) {
                var n3 = $281a441cdcb2cf36$var$D[$281a441cdcb2cf36$var$D.length - 1], t4 = $281a441cdcb2cf36$var$x.get(e4.interactionId);
                if (t4 || $281a441cdcb2cf36$var$D.length < 10 || e4.duration > n3.latency) {
                    if (t4) e4.duration > t4.latency ? (t4.entries = [
                        e4
                    ], t4.latency = e4.duration) : e4.duration === t4.latency && e4.startTime === t4.entries[0].startTime && t4.entries.push(e4);
                    else {
                        var r3 = {
                            id: e4.interactionId,
                            latency: e4.duration,
                            entries: [
                                e4
                            ]
                        };
                        $281a441cdcb2cf36$var$x.set(r3.id, r3), $281a441cdcb2cf36$var$D.push(r3);
                    }
                    $281a441cdcb2cf36$var$D.sort(function(e5, n4) {
                        return n4.latency - e5.latency;
                    }), $281a441cdcb2cf36$var$D.length > 10 && $281a441cdcb2cf36$var$D.splice(10).forEach(function(e5) {
                        return $281a441cdcb2cf36$var$x.delete(e5.id);
                    });
                }
            }
        };
        $281a441cdcb2cf36$var$O = function(e4) {
            var n3 = self.requestIdleCallback || self.setTimeout, t4 = -1;
            return e4 = $281a441cdcb2cf36$var$v(e4), "hidden" === document.visibilityState ? e4() : (t4 = n3(e4), $281a441cdcb2cf36$var$p(e4)), t4;
        };
        $281a441cdcb2cf36$var$N = [
            200,
            500
        ];
        $281a441cdcb2cf36$var$j = function(e4, n3) {
            "PerformanceEventTiming" in self && "interactionId" in PerformanceEventTiming.prototype && (n3 = n3 || {}, $281a441cdcb2cf36$var$C(function() {
                var t4;
                $281a441cdcb2cf36$var$F();
                var r3, i3 = $281a441cdcb2cf36$var$f("INP"), o3 = function(e5) {
                    $281a441cdcb2cf36$var$O(function() {
                        e5.forEach($281a441cdcb2cf36$var$q);
                        var n4 = $281a441cdcb2cf36$var$B();
                        n4 && n4.latency !== i3.value && (i3.value = n4.latency, i3.entries = n4.entries, r3());
                    });
                }, c3 = $281a441cdcb2cf36$var$s("event", o3, {
                    durationThreshold: null !== (t4 = n3.durationThreshold) && void 0 !== t4 ? t4 : 40
                });
                r3 = $281a441cdcb2cf36$var$d(e4, i3, $281a441cdcb2cf36$var$N, n3.reportAllChanges), c3 && (c3.observe({
                    type: "first-input",
                    buffered: true
                }), $281a441cdcb2cf36$var$p(function() {
                    o3(c3.takeRecords()), r3(true);
                }), $281a441cdcb2cf36$var$a(function() {
                    $281a441cdcb2cf36$var$R = $281a441cdcb2cf36$var$k(), $281a441cdcb2cf36$var$D.length = 0, $281a441cdcb2cf36$var$x.clear(), i3 = $281a441cdcb2cf36$var$f("INP"), r3 = $281a441cdcb2cf36$var$d(e4, i3, $281a441cdcb2cf36$var$N, n3.reportAllChanges);
                }));
            }));
        };
        $281a441cdcb2cf36$var$_ = [
            2500,
            4e3
        ];
        $281a441cdcb2cf36$var$z = {};
        $281a441cdcb2cf36$var$G = function(e4, n3) {
            n3 = n3 || {}, $281a441cdcb2cf36$var$C(function() {
                var t4, r3 = $281a441cdcb2cf36$var$E(), i3 = $281a441cdcb2cf36$var$f("LCP"), o3 = function(e5) {
                    n3.reportAllChanges || (e5 = e5.slice(-1)), e5.forEach(function(e6) {
                        e6.startTime < r3.firstHiddenTime && (i3.value = Math.max(e6.startTime - $281a441cdcb2cf36$var$u(), 0), i3.entries = [
                            e6
                        ], t4());
                    });
                }, c3 = $281a441cdcb2cf36$var$s("largest-contentful-paint", o3);
                if (c3) {
                    t4 = $281a441cdcb2cf36$var$d(e4, i3, $281a441cdcb2cf36$var$_, n3.reportAllChanges);
                    var m3 = $281a441cdcb2cf36$var$v(function() {
                        $281a441cdcb2cf36$var$z[i3.id] || (o3(c3.takeRecords()), c3.disconnect(), $281a441cdcb2cf36$var$z[i3.id] = true, t4(true));
                    });
                    [
                        "keydown",
                        "click"
                    ].forEach(function(e5) {
                        addEventListener(e5, function() {
                            return $281a441cdcb2cf36$var$O(m3);
                        }, {
                            once: true,
                            capture: true
                        });
                    }), $281a441cdcb2cf36$var$p(m3), $281a441cdcb2cf36$var$a(function(r4) {
                        i3 = $281a441cdcb2cf36$var$f("LCP"), t4 = $281a441cdcb2cf36$var$d(e4, i3, $281a441cdcb2cf36$var$_, n3.reportAllChanges), $281a441cdcb2cf36$var$l(function() {
                            i3.value = performance.now() - r4.timeStamp, $281a441cdcb2cf36$var$z[i3.id] = true, t4(true);
                        });
                    });
                }
            });
        };
        $281a441cdcb2cf36$var$J = [
            800,
            1800
        ];
        $281a441cdcb2cf36$var$K = function e2(n3) {
            document.prerendering ? $281a441cdcb2cf36$var$C(function() {
                return e2(n3);
            }) : "complete" !== document.readyState ? addEventListener("load", function() {
                return e2(n3);
            }, true) : setTimeout(n3, 0);
        };
        $281a441cdcb2cf36$var$Q = function(e4, n3) {
            n3 = n3 || {};
            var t4 = $281a441cdcb2cf36$var$f("TTFB"), r3 = $281a441cdcb2cf36$var$d(e4, t4, $281a441cdcb2cf36$var$J, n3.reportAllChanges);
            $281a441cdcb2cf36$var$K(function() {
                var i3 = $281a441cdcb2cf36$var$c();
                i3 && (t4.value = Math.max(i3.responseStart - $281a441cdcb2cf36$var$u(), 0), t4.entries = [
                    i3
                ], r3(true), $281a441cdcb2cf36$var$a(function() {
                    t4 = $281a441cdcb2cf36$var$f("TTFB", 0), (r3 = $281a441cdcb2cf36$var$d(e4, t4, $281a441cdcb2cf36$var$J, n3.reportAllChanges))(true);
                }));
            });
        };
        $281a441cdcb2cf36$var$U = {
            passive: true,
            capture: true
        };
        $281a441cdcb2cf36$var$V = /* @__PURE__ */ new Date();
        $281a441cdcb2cf36$var$W = function(e4, i3) {
            $281a441cdcb2cf36$var$n || ($281a441cdcb2cf36$var$n = i3, $281a441cdcb2cf36$var$t = e4, $281a441cdcb2cf36$var$r = /* @__PURE__ */ new Date(), $281a441cdcb2cf36$var$Z(removeEventListener), $281a441cdcb2cf36$var$X());
        };
        $281a441cdcb2cf36$var$X = function() {
            if ($281a441cdcb2cf36$var$t >= 0 && $281a441cdcb2cf36$var$t < $281a441cdcb2cf36$var$r - $281a441cdcb2cf36$var$V) {
                var e4 = {
                    entryType: "first-input",
                    name: $281a441cdcb2cf36$var$n.type,
                    target: $281a441cdcb2cf36$var$n.target,
                    cancelable: $281a441cdcb2cf36$var$n.cancelable,
                    startTime: $281a441cdcb2cf36$var$n.timeStamp,
                    processingStart: $281a441cdcb2cf36$var$n.timeStamp + $281a441cdcb2cf36$var$t
                };
                $281a441cdcb2cf36$var$i.forEach(function(n3) {
                    n3(e4);
                }), $281a441cdcb2cf36$var$i = [];
            }
        };
        $281a441cdcb2cf36$var$Y = function(e4) {
            if (e4.cancelable) {
                var n3 = (e4.timeStamp > 1e12 ? /* @__PURE__ */ new Date() : performance.now()) - e4.timeStamp;
                "pointerdown" == e4.type ? function(e5, n4) {
                    var t4 = function() {
                        $281a441cdcb2cf36$var$W(e5, n4), i3();
                    }, r3 = function() {
                        i3();
                    }, i3 = function() {
                        removeEventListener("pointerup", t4, $281a441cdcb2cf36$var$U), removeEventListener("pointercancel", r3, $281a441cdcb2cf36$var$U);
                    };
                    addEventListener("pointerup", t4, $281a441cdcb2cf36$var$U), addEventListener("pointercancel", r3, $281a441cdcb2cf36$var$U);
                }(n3, e4) : $281a441cdcb2cf36$var$W(n3, e4);
            }
        };
        $281a441cdcb2cf36$var$Z = function(e4) {
            [
                "mousedown",
                "keydown",
                "touchstart",
                "pointerdown"
            ].forEach(function(n3) {
                return e4(n3, $281a441cdcb2cf36$var$Y, $281a441cdcb2cf36$var$U);
            });
        };
        $281a441cdcb2cf36$var$$2 = [
            100,
            300
        ];
        $281a441cdcb2cf36$var$ee = function(e4, r3) {
            r3 = r3 || {}, $281a441cdcb2cf36$var$C(function() {
                var o3, c3 = $281a441cdcb2cf36$var$E(), u3 = $281a441cdcb2cf36$var$f("FID"), l3 = function(e5) {
                    e5.startTime < c3.firstHiddenTime && (u3.value = e5.processingStart - e5.startTime, u3.entries.push(e5), o3(true));
                }, m3 = function(e5) {
                    e5.forEach(l3);
                }, h3 = $281a441cdcb2cf36$var$s("first-input", m3);
                o3 = $281a441cdcb2cf36$var$d(e4, u3, $281a441cdcb2cf36$var$$2, r3.reportAllChanges), h3 && ($281a441cdcb2cf36$var$p($281a441cdcb2cf36$var$v(function() {
                    m3(h3.takeRecords()), h3.disconnect();
                })), $281a441cdcb2cf36$var$a(function() {
                    var a3;
                    u3 = $281a441cdcb2cf36$var$f("FID"), o3 = $281a441cdcb2cf36$var$d(e4, u3, $281a441cdcb2cf36$var$$2, r3.reportAllChanges), $281a441cdcb2cf36$var$i = [], $281a441cdcb2cf36$var$t = -1, $281a441cdcb2cf36$var$n = null, $281a441cdcb2cf36$var$Z(addEventListener), a3 = l3, $281a441cdcb2cf36$var$i.push(a3), $281a441cdcb2cf36$var$X();
                }));
            });
        };
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/webVitals/webVitalsBasic.js
var $281a441cdcb2cf36$var$WebVitalsBasic;
var $281a441cdcb2cf36$var$init_webVitalsBasic = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/webVitals/webVitalsBasic.js" () {
        $281a441cdcb2cf36$var$init_web_vitals();
        $281a441cdcb2cf36$var$WebVitalsBasic = class _WebVitalsBasic {
            constructor(pushMeasurement, webVitalConfig){
                this.pushMeasurement = pushMeasurement;
                this.webVitalConfig = webVitalConfig;
            }
            initialize() {
                Object.entries(_WebVitalsBasic.mapping).forEach(([indicator, executor])=>{
                    var _a2;
                    executor((metric)=>{
                        this.pushMeasurement({
                            type: "web-vitals",
                            values: {
                                [indicator]: metric.value
                            }
                        });
                    }, {
                        reportAllChanges: (_a2 = this.webVitalConfig) === null || _a2 === void 0 ? void 0 : _a2.reportAllChanges
                    });
                });
            }
        };
        $281a441cdcb2cf36$var$WebVitalsBasic.mapping = {
            cls: $281a441cdcb2cf36$var$w,
            fcp: $281a441cdcb2cf36$var$S,
            fid: $281a441cdcb2cf36$var$ee,
            inp: $281a441cdcb2cf36$var$j,
            lcp: $281a441cdcb2cf36$var$G,
            ttfb: $281a441cdcb2cf36$var$Q
        };
    }
});
// ../node_modules/web-vitals/dist/web-vitals.attribution.js
var $281a441cdcb2cf36$var$t2, $281a441cdcb2cf36$var$e3, $281a441cdcb2cf36$var$n2, $281a441cdcb2cf36$var$r2, $281a441cdcb2cf36$var$i2, $281a441cdcb2cf36$var$a2, $281a441cdcb2cf36$var$o2, $281a441cdcb2cf36$var$c2, $281a441cdcb2cf36$var$u2, $281a441cdcb2cf36$var$s2, $281a441cdcb2cf36$var$f2, $281a441cdcb2cf36$var$d2, $281a441cdcb2cf36$var$l2, $281a441cdcb2cf36$var$m2, $281a441cdcb2cf36$var$p2, $281a441cdcb2cf36$var$v2, $281a441cdcb2cf36$var$g2, $281a441cdcb2cf36$var$h2, $281a441cdcb2cf36$var$T2, $281a441cdcb2cf36$var$y2, $281a441cdcb2cf36$var$E2, $281a441cdcb2cf36$var$S2, $281a441cdcb2cf36$var$b2, $281a441cdcb2cf36$var$L2, $281a441cdcb2cf36$var$C2, $281a441cdcb2cf36$var$M2, $281a441cdcb2cf36$var$D2, $281a441cdcb2cf36$var$w2, $281a441cdcb2cf36$var$x2, $281a441cdcb2cf36$var$I2, $281a441cdcb2cf36$var$k2, $281a441cdcb2cf36$var$A2, $281a441cdcb2cf36$var$F2, $281a441cdcb2cf36$var$P2, $281a441cdcb2cf36$var$B2, $281a441cdcb2cf36$var$O2, $281a441cdcb2cf36$var$R2, $281a441cdcb2cf36$var$j2, $281a441cdcb2cf36$var$q2, $281a441cdcb2cf36$var$H2, $281a441cdcb2cf36$var$N2, $281a441cdcb2cf36$var$W2, $281a441cdcb2cf36$var$z2, $281a441cdcb2cf36$var$U2, $281a441cdcb2cf36$var$V2, $281a441cdcb2cf36$var$_2, $281a441cdcb2cf36$var$G2, $281a441cdcb2cf36$var$J2, $281a441cdcb2cf36$var$K2, $281a441cdcb2cf36$var$Q2, $281a441cdcb2cf36$var$X2, $281a441cdcb2cf36$var$Y2, $281a441cdcb2cf36$var$Z2, $281a441cdcb2cf36$var$$3, $281a441cdcb2cf36$var$tt, $281a441cdcb2cf36$var$et, $281a441cdcb2cf36$var$nt, $281a441cdcb2cf36$var$rt, $281a441cdcb2cf36$var$it, $281a441cdcb2cf36$var$at2, $281a441cdcb2cf36$var$ot, $281a441cdcb2cf36$var$ct, $281a441cdcb2cf36$var$ut, $281a441cdcb2cf36$var$st, $281a441cdcb2cf36$var$ft, $281a441cdcb2cf36$var$dt, $281a441cdcb2cf36$var$lt, $281a441cdcb2cf36$var$mt, $281a441cdcb2cf36$var$pt, $281a441cdcb2cf36$var$vt, $281a441cdcb2cf36$var$gt, $281a441cdcb2cf36$var$ht, $281a441cdcb2cf36$var$Tt, $281a441cdcb2cf36$var$yt;
var $281a441cdcb2cf36$var$init_web_vitals_attribution = $281a441cdcb2cf36$var$__esm({
    "../node_modules/web-vitals/dist/web-vitals.attribution.js" () {
        $281a441cdcb2cf36$var$n2 = function() {
            var t4 = self.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
            if (t4 && t4.responseStart > 0 && t4.responseStart < performance.now()) return t4;
        };
        $281a441cdcb2cf36$var$r2 = function(t4) {
            if ("loading" === document.readyState) return "loading";
            var e4 = $281a441cdcb2cf36$var$n2();
            if (e4) {
                if (t4 < e4.domInteractive) return "loading";
                if (0 === e4.domContentLoadedEventStart || t4 < e4.domContentLoadedEventStart) return "dom-interactive";
                if (0 === e4.domComplete || t4 < e4.domComplete) return "dom-content-loaded";
            }
            return "complete";
        };
        $281a441cdcb2cf36$var$i2 = function(t4) {
            var e4 = t4.nodeName;
            return 1 === t4.nodeType ? e4.toLowerCase() : e4.toUpperCase().replace(/^#/, "");
        };
        $281a441cdcb2cf36$var$a2 = function(t4, e4) {
            var n3 = "";
            try {
                for(; t4 && 9 !== t4.nodeType;){
                    var r3 = t4, a3 = r3.id ? "#" + r3.id : $281a441cdcb2cf36$var$i2(r3) + (r3.classList && r3.classList.value && r3.classList.value.trim() && r3.classList.value.trim().length ? "." + r3.classList.value.trim().replace(/\s+/g, ".") : "");
                    if (n3.length + a3.length > (e4 || 100) - 1) return n3 || a3;
                    if (n3 = n3 ? a3 + ">" + n3 : a3, r3.id) break;
                    t4 = r3.parentNode;
                }
            } catch (t5) {}
            return n3;
        };
        $281a441cdcb2cf36$var$o2 = -1;
        $281a441cdcb2cf36$var$c2 = function() {
            return $281a441cdcb2cf36$var$o2;
        };
        $281a441cdcb2cf36$var$u2 = function(t4) {
            addEventListener("pageshow", function(e4) {
                e4.persisted && ($281a441cdcb2cf36$var$o2 = e4.timeStamp, t4(e4));
            }, true);
        };
        $281a441cdcb2cf36$var$s2 = function() {
            var t4 = $281a441cdcb2cf36$var$n2();
            return t4 && t4.activationStart || 0;
        };
        $281a441cdcb2cf36$var$f2 = function(t4, e4) {
            var r3 = $281a441cdcb2cf36$var$n2(), i3 = "navigate";
            $281a441cdcb2cf36$var$c2() >= 0 ? i3 = "back-forward-cache" : r3 && (document.prerendering || $281a441cdcb2cf36$var$s2() > 0 ? i3 = "prerender" : document.wasDiscarded ? i3 = "restore" : r3.type && (i3 = r3.type.replace(/_/g, "-")));
            return {
                name: t4,
                value: void 0 === e4 ? -1 : e4,
                rating: "good",
                delta: 0,
                entries: [],
                id: "v4-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12),
                navigationType: i3
            };
        };
        $281a441cdcb2cf36$var$d2 = function(t4, e4, n3) {
            try {
                if (PerformanceObserver.supportedEntryTypes.includes(t4)) {
                    var r3 = new PerformanceObserver(function(t5) {
                        Promise.resolve().then(function() {
                            e4(t5.getEntries());
                        });
                    });
                    return r3.observe(Object.assign({
                        type: t4,
                        buffered: true
                    }, n3 || {})), r3;
                }
            } catch (t5) {}
        };
        $281a441cdcb2cf36$var$l2 = function(t4, e4, n3, r3) {
            var i3, a3;
            return function(o3) {
                e4.value >= 0 && (o3 || r3) && ((a3 = e4.value - (i3 || 0)) || void 0 === i3) && (i3 = e4.value, e4.delta = a3, e4.rating = function(t5, e5) {
                    return t5 > e5[1] ? "poor" : t5 > e5[0] ? "needs-improvement" : "good";
                }(e4.value, n3), t4(e4));
            };
        };
        $281a441cdcb2cf36$var$m2 = function(t4) {
            requestAnimationFrame(function() {
                return requestAnimationFrame(function() {
                    return t4();
                });
            });
        };
        $281a441cdcb2cf36$var$p2 = function(t4) {
            document.addEventListener("visibilitychange", function() {
                "hidden" === document.visibilityState && t4();
            });
        };
        $281a441cdcb2cf36$var$v2 = function(t4) {
            var e4 = false;
            return function() {
                e4 || (t4(), e4 = true);
            };
        };
        $281a441cdcb2cf36$var$g2 = -1;
        $281a441cdcb2cf36$var$h2 = function() {
            return "hidden" !== document.visibilityState || document.prerendering ? 1 / 0 : 0;
        };
        $281a441cdcb2cf36$var$T2 = function(t4) {
            "hidden" === document.visibilityState && $281a441cdcb2cf36$var$g2 > -1 && ($281a441cdcb2cf36$var$g2 = "visibilitychange" === t4.type ? t4.timeStamp : 0, $281a441cdcb2cf36$var$E2());
        };
        $281a441cdcb2cf36$var$y2 = function() {
            addEventListener("visibilitychange", $281a441cdcb2cf36$var$T2, true), addEventListener("prerenderingchange", $281a441cdcb2cf36$var$T2, true);
        };
        $281a441cdcb2cf36$var$E2 = function() {
            removeEventListener("visibilitychange", $281a441cdcb2cf36$var$T2, true), removeEventListener("prerenderingchange", $281a441cdcb2cf36$var$T2, true);
        };
        $281a441cdcb2cf36$var$S2 = function() {
            return $281a441cdcb2cf36$var$g2 < 0 && ($281a441cdcb2cf36$var$g2 = $281a441cdcb2cf36$var$h2(), $281a441cdcb2cf36$var$y2(), $281a441cdcb2cf36$var$u2(function() {
                setTimeout(function() {
                    $281a441cdcb2cf36$var$g2 = $281a441cdcb2cf36$var$h2(), $281a441cdcb2cf36$var$y2();
                }, 0);
            })), {
                get firstHiddenTime () {
                    return $281a441cdcb2cf36$var$g2;
                }
            };
        };
        $281a441cdcb2cf36$var$b2 = function(t4) {
            document.prerendering ? addEventListener("prerenderingchange", function() {
                return t4();
            }, true) : t4();
        };
        $281a441cdcb2cf36$var$L2 = [
            1800,
            3e3
        ];
        $281a441cdcb2cf36$var$C2 = function(t4, e4) {
            e4 = e4 || {}, $281a441cdcb2cf36$var$b2(function() {
                var n3, r3 = $281a441cdcb2cf36$var$S2(), i3 = $281a441cdcb2cf36$var$f2("FCP"), a3 = $281a441cdcb2cf36$var$d2("paint", function(t5) {
                    t5.forEach(function(t6) {
                        "first-contentful-paint" === t6.name && (a3.disconnect(), t6.startTime < r3.firstHiddenTime && (i3.value = Math.max(t6.startTime - $281a441cdcb2cf36$var$s2(), 0), i3.entries.push(t6), n3(true)));
                    });
                });
                a3 && (n3 = $281a441cdcb2cf36$var$l2(t4, i3, $281a441cdcb2cf36$var$L2, e4.reportAllChanges), $281a441cdcb2cf36$var$u2(function(r4) {
                    i3 = $281a441cdcb2cf36$var$f2("FCP"), n3 = $281a441cdcb2cf36$var$l2(t4, i3, $281a441cdcb2cf36$var$L2, e4.reportAllChanges), $281a441cdcb2cf36$var$m2(function() {
                        i3.value = performance.now() - r4.timeStamp, n3(true);
                    });
                }));
            });
        };
        $281a441cdcb2cf36$var$M2 = [
            0.1,
            0.25
        ];
        $281a441cdcb2cf36$var$D2 = function(t4, e4) {
            !function(t5, e5) {
                e5 = e5 || {}, $281a441cdcb2cf36$var$C2($281a441cdcb2cf36$var$v2(function() {
                    var n3, r3 = $281a441cdcb2cf36$var$f2("CLS", 0), i3 = 0, a3 = [], o3 = function(t6) {
                        t6.forEach(function(t7) {
                            if (!t7.hadRecentInput) {
                                var e6 = a3[0], n4 = a3[a3.length - 1];
                                i3 && t7.startTime - n4.startTime < 1e3 && t7.startTime - e6.startTime < 5e3 ? (i3 += t7.value, a3.push(t7)) : (i3 = t7.value, a3 = [
                                    t7
                                ]);
                            }
                        }), i3 > r3.value && (r3.value = i3, r3.entries = a3, n3());
                    }, c3 = $281a441cdcb2cf36$var$d2("layout-shift", o3);
                    c3 && (n3 = $281a441cdcb2cf36$var$l2(t5, r3, $281a441cdcb2cf36$var$M2, e5.reportAllChanges), $281a441cdcb2cf36$var$p2(function() {
                        o3(c3.takeRecords()), n3(true);
                    }), $281a441cdcb2cf36$var$u2(function() {
                        i3 = 0, r3 = $281a441cdcb2cf36$var$f2("CLS", 0), n3 = $281a441cdcb2cf36$var$l2(t5, r3, $281a441cdcb2cf36$var$M2, e5.reportAllChanges), $281a441cdcb2cf36$var$m2(function() {
                            return n3();
                        });
                    }), setTimeout(n3, 0));
                }));
            }(function(e5) {
                var n3 = function(t5) {
                    var e6, n4 = {};
                    if (t5.entries.length) {
                        var i3 = t5.entries.reduce(function(t6, e7) {
                            return t6 && t6.value > e7.value ? t6 : e7;
                        });
                        if (i3 && i3.sources && i3.sources.length) {
                            var o3 = (e6 = i3.sources).find(function(t6) {
                                return t6.node && 1 === t6.node.nodeType;
                            }) || e6[0];
                            o3 && (n4 = {
                                largestShiftTarget: $281a441cdcb2cf36$var$a2(o3.node),
                                largestShiftTime: i3.startTime,
                                largestShiftValue: i3.value,
                                largestShiftSource: o3,
                                largestShiftEntry: i3,
                                loadState: $281a441cdcb2cf36$var$r2(i3.startTime)
                            });
                        }
                    }
                    return Object.assign(t5, {
                        attribution: n4
                    });
                }(e5);
                t4(n3);
            }, e4);
        };
        $281a441cdcb2cf36$var$w2 = function(t4, e4) {
            $281a441cdcb2cf36$var$C2(function(e5) {
                var i3 = function(t5) {
                    var e6 = {
                        timeToFirstByte: 0,
                        firstByteToFCP: t5.value,
                        loadState: $281a441cdcb2cf36$var$r2($281a441cdcb2cf36$var$c2())
                    };
                    if (t5.entries.length) {
                        var i4 = $281a441cdcb2cf36$var$n2(), a3 = t5.entries[t5.entries.length - 1];
                        if (i4) {
                            var o3 = i4.activationStart || 0, u3 = Math.max(0, i4.responseStart - o3);
                            e6 = {
                                timeToFirstByte: u3,
                                firstByteToFCP: t5.value - u3,
                                loadState: $281a441cdcb2cf36$var$r2(t5.entries[0].startTime),
                                navigationEntry: i4,
                                fcpEntry: a3
                            };
                        }
                    }
                    return Object.assign(t5, {
                        attribution: e6
                    });
                }(e5);
                t4(i3);
            }, e4);
        };
        $281a441cdcb2cf36$var$x2 = 0;
        $281a441cdcb2cf36$var$I2 = 1 / 0;
        $281a441cdcb2cf36$var$k2 = 0;
        $281a441cdcb2cf36$var$A2 = function(t4) {
            t4.forEach(function(t5) {
                t5.interactionId && ($281a441cdcb2cf36$var$I2 = Math.min($281a441cdcb2cf36$var$I2, t5.interactionId), $281a441cdcb2cf36$var$k2 = Math.max($281a441cdcb2cf36$var$k2, t5.interactionId), $281a441cdcb2cf36$var$x2 = $281a441cdcb2cf36$var$k2 ? ($281a441cdcb2cf36$var$k2 - $281a441cdcb2cf36$var$I2) / 7 + 1 : 0);
            });
        };
        $281a441cdcb2cf36$var$F2 = function() {
            return $281a441cdcb2cf36$var$t2 ? $281a441cdcb2cf36$var$x2 : performance.interactionCount || 0;
        };
        $281a441cdcb2cf36$var$P2 = function() {
            "interactionCount" in performance || $281a441cdcb2cf36$var$t2 || ($281a441cdcb2cf36$var$t2 = $281a441cdcb2cf36$var$d2("event", $281a441cdcb2cf36$var$A2, {
                type: "event",
                buffered: true,
                durationThreshold: 0
            }));
        };
        $281a441cdcb2cf36$var$B2 = [];
        $281a441cdcb2cf36$var$O2 = /* @__PURE__ */ new Map();
        $281a441cdcb2cf36$var$R2 = 0;
        $281a441cdcb2cf36$var$j2 = function() {
            var t4 = Math.min($281a441cdcb2cf36$var$B2.length - 1, Math.floor(($281a441cdcb2cf36$var$F2() - $281a441cdcb2cf36$var$R2) / 50));
            return $281a441cdcb2cf36$var$B2[t4];
        };
        $281a441cdcb2cf36$var$q2 = [];
        $281a441cdcb2cf36$var$H2 = function(t4) {
            if ($281a441cdcb2cf36$var$q2.forEach(function(e5) {
                return e5(t4);
            }), t4.interactionId || "first-input" === t4.entryType) {
                var e4 = $281a441cdcb2cf36$var$B2[$281a441cdcb2cf36$var$B2.length - 1], n3 = $281a441cdcb2cf36$var$O2.get(t4.interactionId);
                if (n3 || $281a441cdcb2cf36$var$B2.length < 10 || t4.duration > e4.latency) {
                    if (n3) t4.duration > n3.latency ? (n3.entries = [
                        t4
                    ], n3.latency = t4.duration) : t4.duration === n3.latency && t4.startTime === n3.entries[0].startTime && n3.entries.push(t4);
                    else {
                        var r3 = {
                            id: t4.interactionId,
                            latency: t4.duration,
                            entries: [
                                t4
                            ]
                        };
                        $281a441cdcb2cf36$var$O2.set(r3.id, r3), $281a441cdcb2cf36$var$B2.push(r3);
                    }
                    $281a441cdcb2cf36$var$B2.sort(function(t5, e5) {
                        return e5.latency - t5.latency;
                    }), $281a441cdcb2cf36$var$B2.length > 10 && $281a441cdcb2cf36$var$B2.splice(10).forEach(function(t5) {
                        return $281a441cdcb2cf36$var$O2.delete(t5.id);
                    });
                }
            }
        };
        $281a441cdcb2cf36$var$N2 = function(t4) {
            var e4 = self.requestIdleCallback || self.setTimeout, n3 = -1;
            return t4 = $281a441cdcb2cf36$var$v2(t4), "hidden" === document.visibilityState ? t4() : (n3 = e4(t4), $281a441cdcb2cf36$var$p2(t4)), n3;
        };
        $281a441cdcb2cf36$var$W2 = [
            200,
            500
        ];
        $281a441cdcb2cf36$var$z2 = function(t4, e4) {
            "PerformanceEventTiming" in self && "interactionId" in PerformanceEventTiming.prototype && (e4 = e4 || {}, $281a441cdcb2cf36$var$b2(function() {
                var n3;
                $281a441cdcb2cf36$var$P2();
                var r3, i3 = $281a441cdcb2cf36$var$f2("INP"), a3 = function(t5) {
                    $281a441cdcb2cf36$var$N2(function() {
                        t5.forEach($281a441cdcb2cf36$var$H2);
                        var e5 = $281a441cdcb2cf36$var$j2();
                        e5 && e5.latency !== i3.value && (i3.value = e5.latency, i3.entries = e5.entries, r3());
                    });
                }, o3 = $281a441cdcb2cf36$var$d2("event", a3, {
                    durationThreshold: null !== (n3 = e4.durationThreshold) && void 0 !== n3 ? n3 : 40
                });
                r3 = $281a441cdcb2cf36$var$l2(t4, i3, $281a441cdcb2cf36$var$W2, e4.reportAllChanges), o3 && (o3.observe({
                    type: "first-input",
                    buffered: true
                }), $281a441cdcb2cf36$var$p2(function() {
                    a3(o3.takeRecords()), r3(true);
                }), $281a441cdcb2cf36$var$u2(function() {
                    $281a441cdcb2cf36$var$R2 = $281a441cdcb2cf36$var$F2(), $281a441cdcb2cf36$var$B2.length = 0, $281a441cdcb2cf36$var$O2.clear(), i3 = $281a441cdcb2cf36$var$f2("INP"), r3 = $281a441cdcb2cf36$var$l2(t4, i3, $281a441cdcb2cf36$var$W2, e4.reportAllChanges);
                }));
            }));
        };
        $281a441cdcb2cf36$var$U2 = [];
        $281a441cdcb2cf36$var$V2 = [];
        $281a441cdcb2cf36$var$_2 = 0;
        $281a441cdcb2cf36$var$G2 = /* @__PURE__ */ new WeakMap();
        $281a441cdcb2cf36$var$J2 = /* @__PURE__ */ new Map();
        $281a441cdcb2cf36$var$K2 = -1;
        $281a441cdcb2cf36$var$Q2 = function(t4) {
            $281a441cdcb2cf36$var$U2 = $281a441cdcb2cf36$var$U2.concat(t4), $281a441cdcb2cf36$var$X2();
        };
        $281a441cdcb2cf36$var$X2 = function() {
            $281a441cdcb2cf36$var$K2 < 0 && ($281a441cdcb2cf36$var$K2 = $281a441cdcb2cf36$var$N2($281a441cdcb2cf36$var$Y2));
        };
        $281a441cdcb2cf36$var$Y2 = function() {
            $281a441cdcb2cf36$var$J2.size > 10 && $281a441cdcb2cf36$var$J2.forEach(function(t5, e5) {
                $281a441cdcb2cf36$var$O2.has(e5) || $281a441cdcb2cf36$var$J2.delete(e5);
            });
            var t4 = $281a441cdcb2cf36$var$B2.map(function(t5) {
                return $281a441cdcb2cf36$var$G2.get(t5.entries[0]);
            }), e4 = $281a441cdcb2cf36$var$V2.length - 50;
            $281a441cdcb2cf36$var$V2 = $281a441cdcb2cf36$var$V2.filter(function(n4, r4) {
                return r4 >= e4 || t4.includes(n4);
            });
            for(var n3 = /* @__PURE__ */ new Set(), r3 = 0; r3 < $281a441cdcb2cf36$var$V2.length; r3++){
                var i3 = $281a441cdcb2cf36$var$V2[r3];
                $281a441cdcb2cf36$var$nt(i3.startTime, i3.processingEnd).forEach(function(t5) {
                    n3.add(t5);
                });
            }
            var a3 = $281a441cdcb2cf36$var$U2.length - 1 - 50;
            $281a441cdcb2cf36$var$U2 = $281a441cdcb2cf36$var$U2.filter(function(t5, e5) {
                return t5.startTime > $281a441cdcb2cf36$var$_2 && e5 > a3 || n3.has(t5);
            }), $281a441cdcb2cf36$var$K2 = -1;
        };
        $281a441cdcb2cf36$var$q2.push(function(t4) {
            t4.interactionId && t4.target && !$281a441cdcb2cf36$var$J2.has(t4.interactionId) && $281a441cdcb2cf36$var$J2.set(t4.interactionId, t4.target);
        }, function(t4) {
            var e4, n3 = t4.startTime + t4.duration;
            $281a441cdcb2cf36$var$_2 = Math.max($281a441cdcb2cf36$var$_2, t4.processingEnd);
            for(var r3 = $281a441cdcb2cf36$var$V2.length - 1; r3 >= 0; r3--){
                var i3 = $281a441cdcb2cf36$var$V2[r3];
                if (Math.abs(n3 - i3.renderTime) <= 8) {
                    (e4 = i3).startTime = Math.min(t4.startTime, e4.startTime), e4.processingStart = Math.min(t4.processingStart, e4.processingStart), e4.processingEnd = Math.max(t4.processingEnd, e4.processingEnd), e4.entries.push(t4);
                    break;
                }
            }
            e4 || (e4 = {
                startTime: t4.startTime,
                processingStart: t4.processingStart,
                processingEnd: t4.processingEnd,
                renderTime: n3,
                entries: [
                    t4
                ]
            }, $281a441cdcb2cf36$var$V2.push(e4)), (t4.interactionId || "first-input" === t4.entryType) && $281a441cdcb2cf36$var$G2.set(t4, e4), $281a441cdcb2cf36$var$X2();
        });
        $281a441cdcb2cf36$var$nt = function(t4, e4) {
            for(var n3, r3 = [], i3 = 0; n3 = $281a441cdcb2cf36$var$U2[i3]; i3++)if (!(n3.startTime + n3.duration < t4)) {
                if (n3.startTime > e4) break;
                r3.push(n3);
            }
            return r3;
        };
        $281a441cdcb2cf36$var$rt = function(t4, n3) {
            $281a441cdcb2cf36$var$e3 || ($281a441cdcb2cf36$var$e3 = $281a441cdcb2cf36$var$d2("long-animation-frame", $281a441cdcb2cf36$var$Q2)), $281a441cdcb2cf36$var$z2(function(e4) {
                var n4 = function(t5) {
                    var e5 = t5.entries[0], n5 = $281a441cdcb2cf36$var$G2.get(e5), i3 = e5.processingStart, o3 = n5.processingEnd, c3 = n5.entries.sort(function(t6, e6) {
                        return t6.processingStart - e6.processingStart;
                    }), u3 = $281a441cdcb2cf36$var$nt(e5.startTime, o3), s3 = t5.entries.find(function(t6) {
                        return t6.target;
                    }), f3 = s3 && s3.target || $281a441cdcb2cf36$var$J2.get(e5.interactionId), d3 = [
                        e5.startTime + e5.duration,
                        o3
                    ].concat(u3.map(function(t6) {
                        return t6.startTime + t6.duration;
                    })), l3 = Math.max.apply(Math, d3), m3 = {
                        interactionTarget: $281a441cdcb2cf36$var$a2(f3),
                        interactionTargetElement: f3,
                        interactionType: e5.name.startsWith("key") ? "keyboard" : "pointer",
                        interactionTime: e5.startTime,
                        nextPaintTime: l3,
                        processedEventEntries: c3,
                        longAnimationFrameEntries: u3,
                        inputDelay: i3 - e5.startTime,
                        processingDuration: o3 - i3,
                        presentationDelay: Math.max(l3 - o3, 0),
                        loadState: $281a441cdcb2cf36$var$r2(e5.startTime)
                    };
                    return Object.assign(t5, {
                        attribution: m3
                    });
                }(e4);
                t4(n4);
            }, n3);
        };
        $281a441cdcb2cf36$var$it = [
            2500,
            4e3
        ];
        $281a441cdcb2cf36$var$at2 = {};
        $281a441cdcb2cf36$var$ot = function(t4, e4) {
            !function(t5, e5) {
                e5 = e5 || {}, $281a441cdcb2cf36$var$b2(function() {
                    var n3, r3 = $281a441cdcb2cf36$var$S2(), i3 = $281a441cdcb2cf36$var$f2("LCP"), a3 = function(t6) {
                        e5.reportAllChanges || (t6 = t6.slice(-1)), t6.forEach(function(t7) {
                            t7.startTime < r3.firstHiddenTime && (i3.value = Math.max(t7.startTime - $281a441cdcb2cf36$var$s2(), 0), i3.entries = [
                                t7
                            ], n3());
                        });
                    }, o3 = $281a441cdcb2cf36$var$d2("largest-contentful-paint", a3);
                    if (o3) {
                        n3 = $281a441cdcb2cf36$var$l2(t5, i3, $281a441cdcb2cf36$var$it, e5.reportAllChanges);
                        var c3 = $281a441cdcb2cf36$var$v2(function() {
                            $281a441cdcb2cf36$var$at2[i3.id] || (a3(o3.takeRecords()), o3.disconnect(), $281a441cdcb2cf36$var$at2[i3.id] = true, n3(true));
                        });
                        [
                            "keydown",
                            "click"
                        ].forEach(function(t6) {
                            addEventListener(t6, function() {
                                return $281a441cdcb2cf36$var$N2(c3);
                            }, {
                                once: true,
                                capture: true
                            });
                        }), $281a441cdcb2cf36$var$p2(c3), $281a441cdcb2cf36$var$u2(function(r4) {
                            i3 = $281a441cdcb2cf36$var$f2("LCP"), n3 = $281a441cdcb2cf36$var$l2(t5, i3, $281a441cdcb2cf36$var$it, e5.reportAllChanges), $281a441cdcb2cf36$var$m2(function() {
                                i3.value = performance.now() - r4.timeStamp, $281a441cdcb2cf36$var$at2[i3.id] = true, n3(true);
                            });
                        });
                    }
                });
            }(function(e5) {
                var r3 = function(t5) {
                    var e6 = {
                        timeToFirstByte: 0,
                        resourceLoadDelay: 0,
                        resourceLoadDuration: 0,
                        elementRenderDelay: t5.value
                    };
                    if (t5.entries.length) {
                        var r4 = $281a441cdcb2cf36$var$n2();
                        if (r4) {
                            var i3 = r4.activationStart || 0, o3 = t5.entries[t5.entries.length - 1], c3 = o3.url && performance.getEntriesByType("resource").filter(function(t6) {
                                return t6.name === o3.url;
                            })[0], u3 = Math.max(0, r4.responseStart - i3), s3 = Math.max(u3, c3 ? (c3.requestStart || c3.startTime) - i3 : 0), f3 = Math.max(s3, c3 ? c3.responseEnd - i3 : 0), d3 = Math.max(f3, o3.startTime - i3);
                            e6 = {
                                element: $281a441cdcb2cf36$var$a2(o3.element),
                                timeToFirstByte: u3,
                                resourceLoadDelay: s3 - u3,
                                resourceLoadDuration: f3 - s3,
                                elementRenderDelay: d3 - f3,
                                navigationEntry: r4,
                                lcpEntry: o3
                            }, o3.url && (e6.url = o3.url), c3 && (e6.lcpResourceEntry = c3);
                        }
                    }
                    return Object.assign(t5, {
                        attribution: e6
                    });
                }(e5);
                t4(r3);
            }, e4);
        };
        $281a441cdcb2cf36$var$ct = [
            800,
            1800
        ];
        $281a441cdcb2cf36$var$ut = function t3(e4) {
            document.prerendering ? $281a441cdcb2cf36$var$b2(function() {
                return t3(e4);
            }) : "complete" !== document.readyState ? addEventListener("load", function() {
                return t3(e4);
            }, true) : setTimeout(e4, 0);
        };
        $281a441cdcb2cf36$var$st = function(t4, e4) {
            e4 = e4 || {};
            var r3 = $281a441cdcb2cf36$var$f2("TTFB"), i3 = $281a441cdcb2cf36$var$l2(t4, r3, $281a441cdcb2cf36$var$ct, e4.reportAllChanges);
            $281a441cdcb2cf36$var$ut(function() {
                var a3 = $281a441cdcb2cf36$var$n2();
                a3 && (r3.value = Math.max(a3.responseStart - $281a441cdcb2cf36$var$s2(), 0), r3.entries = [
                    a3
                ], i3(true), $281a441cdcb2cf36$var$u2(function() {
                    r3 = $281a441cdcb2cf36$var$f2("TTFB", 0), (i3 = $281a441cdcb2cf36$var$l2(t4, r3, $281a441cdcb2cf36$var$ct, e4.reportAllChanges))(true);
                }));
            });
        };
        $281a441cdcb2cf36$var$ft = function(t4, e4) {
            $281a441cdcb2cf36$var$st(function(e5) {
                var n3 = function(t5) {
                    var e6 = {
                        waitingDuration: 0,
                        cacheDuration: 0,
                        dnsDuration: 0,
                        connectionDuration: 0,
                        requestDuration: 0
                    };
                    if (t5.entries.length) {
                        var n4 = t5.entries[0], r3 = n4.activationStart || 0, i3 = Math.max((n4.workerStart || n4.fetchStart) - r3, 0), a3 = Math.max(n4.domainLookupStart - r3, 0), o3 = Math.max(n4.connectStart - r3, 0), c3 = Math.max(n4.connectEnd - r3, 0);
                        e6 = {
                            waitingDuration: i3,
                            cacheDuration: a3 - i3,
                            dnsDuration: o3 - a3,
                            connectionDuration: c3 - o3,
                            requestDuration: t5.value - c3,
                            navigationEntry: n4
                        };
                    }
                    return Object.assign(t5, {
                        attribution: e6
                    });
                }(e5);
                t4(n3);
            }, e4);
        };
        $281a441cdcb2cf36$var$dt = {
            passive: true,
            capture: true
        };
        $281a441cdcb2cf36$var$lt = /* @__PURE__ */ new Date();
        $281a441cdcb2cf36$var$mt = function(t4, e4) {
            $281a441cdcb2cf36$var$Z2 || ($281a441cdcb2cf36$var$Z2 = e4, $281a441cdcb2cf36$var$$3 = t4, $281a441cdcb2cf36$var$tt = /* @__PURE__ */ new Date(), $281a441cdcb2cf36$var$gt(removeEventListener), $281a441cdcb2cf36$var$pt());
        };
        $281a441cdcb2cf36$var$pt = function() {
            if ($281a441cdcb2cf36$var$$3 >= 0 && $281a441cdcb2cf36$var$$3 < $281a441cdcb2cf36$var$tt - $281a441cdcb2cf36$var$lt) {
                var t4 = {
                    entryType: "first-input",
                    name: $281a441cdcb2cf36$var$Z2.type,
                    target: $281a441cdcb2cf36$var$Z2.target,
                    cancelable: $281a441cdcb2cf36$var$Z2.cancelable,
                    startTime: $281a441cdcb2cf36$var$Z2.timeStamp,
                    processingStart: $281a441cdcb2cf36$var$Z2.timeStamp + $281a441cdcb2cf36$var$$3
                };
                $281a441cdcb2cf36$var$et.forEach(function(e4) {
                    e4(t4);
                }), $281a441cdcb2cf36$var$et = [];
            }
        };
        $281a441cdcb2cf36$var$vt = function(t4) {
            if (t4.cancelable) {
                var e4 = (t4.timeStamp > 1e12 ? /* @__PURE__ */ new Date() : performance.now()) - t4.timeStamp;
                "pointerdown" == t4.type ? function(t5, e5) {
                    var n3 = function() {
                        $281a441cdcb2cf36$var$mt(t5, e5), i3();
                    }, r3 = function() {
                        i3();
                    }, i3 = function() {
                        removeEventListener("pointerup", n3, $281a441cdcb2cf36$var$dt), removeEventListener("pointercancel", r3, $281a441cdcb2cf36$var$dt);
                    };
                    addEventListener("pointerup", n3, $281a441cdcb2cf36$var$dt), addEventListener("pointercancel", r3, $281a441cdcb2cf36$var$dt);
                }(e4, t4) : $281a441cdcb2cf36$var$mt(e4, t4);
            }
        };
        $281a441cdcb2cf36$var$gt = function(t4) {
            [
                "mousedown",
                "keydown",
                "touchstart",
                "pointerdown"
            ].forEach(function(e4) {
                return t4(e4, $281a441cdcb2cf36$var$vt, $281a441cdcb2cf36$var$dt);
            });
        };
        $281a441cdcb2cf36$var$ht = [
            100,
            300
        ];
        $281a441cdcb2cf36$var$Tt = function(t4, e4) {
            e4 = e4 || {}, $281a441cdcb2cf36$var$b2(function() {
                var n3, r3 = $281a441cdcb2cf36$var$S2(), i3 = $281a441cdcb2cf36$var$f2("FID"), a3 = function(t5) {
                    t5.startTime < r3.firstHiddenTime && (i3.value = t5.processingStart - t5.startTime, i3.entries.push(t5), n3(true));
                }, o3 = function(t5) {
                    t5.forEach(a3);
                }, c3 = $281a441cdcb2cf36$var$d2("first-input", o3);
                n3 = $281a441cdcb2cf36$var$l2(t4, i3, $281a441cdcb2cf36$var$ht, e4.reportAllChanges), c3 && ($281a441cdcb2cf36$var$p2($281a441cdcb2cf36$var$v2(function() {
                    o3(c3.takeRecords()), c3.disconnect();
                })), $281a441cdcb2cf36$var$u2(function() {
                    var r4;
                    i3 = $281a441cdcb2cf36$var$f2("FID"), n3 = $281a441cdcb2cf36$var$l2(t4, i3, $281a441cdcb2cf36$var$ht, e4.reportAllChanges), $281a441cdcb2cf36$var$et = [], $281a441cdcb2cf36$var$$3 = -1, $281a441cdcb2cf36$var$Z2 = null, $281a441cdcb2cf36$var$gt(addEventListener), r4 = a3, $281a441cdcb2cf36$var$et.push(r4), $281a441cdcb2cf36$var$pt();
                }));
            });
        };
        $281a441cdcb2cf36$var$yt = function(t4, e4) {
            $281a441cdcb2cf36$var$Tt(function(e5) {
                var n3 = function(t5) {
                    var e6 = t5.entries[0], n4 = {
                        eventTarget: $281a441cdcb2cf36$var$a2(e6.target),
                        eventType: e6.name,
                        eventTime: e6.startTime,
                        eventEntry: e6,
                        loadState: $281a441cdcb2cf36$var$r2(e6.startTime)
                    };
                    return Object.assign(t5, {
                        attribution: n4
                    });
                }(e5);
                t4(n3);
            }, e4);
        };
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/instrumentationConstants.js
var $281a441cdcb2cf36$var$NAVIGATION_ID_STORAGE_KEY;
var $281a441cdcb2cf36$var$init_instrumentationConstants = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/instrumentationConstants.js" () {
        $281a441cdcb2cf36$var$NAVIGATION_ID_STORAGE_KEY = "com.grafana.faro.lastNavigationId";
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/webVitals/webVitalsWithAttribution.js
var $281a441cdcb2cf36$var$loadStateKey, $281a441cdcb2cf36$var$timeToFirstByteKey, $281a441cdcb2cf36$var$WebVitalsWithAttribution;
var $281a441cdcb2cf36$var$init_webVitalsWithAttribution = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/webVitals/webVitalsWithAttribution.js" () {
        $281a441cdcb2cf36$var$init_web_vitals_attribution();
        $281a441cdcb2cf36$var$init_esm4();
        $281a441cdcb2cf36$var$init_utils8();
        $281a441cdcb2cf36$var$init_instrumentationConstants();
        $281a441cdcb2cf36$var$loadStateKey = "load_state";
        $281a441cdcb2cf36$var$timeToFirstByteKey = "time_to_first_byte";
        $281a441cdcb2cf36$var$WebVitalsWithAttribution = class {
            constructor(corePushMeasurement, webVitalConfig){
                this.corePushMeasurement = corePushMeasurement;
                this.webVitalConfig = webVitalConfig;
            }
            initialize() {
                this.measureCLS();
                this.measureFCP();
                this.measureFID();
                this.measureINP();
                this.measureLCP();
                this.measureTTFB();
            }
            measureCLS() {
                var _a2;
                $281a441cdcb2cf36$var$D2((metric)=>{
                    const { loadState: loadState, largestShiftValue: largestShiftValue, largestShiftTime: largestShiftTime, largestShiftTarget: largestShiftTarget } = metric.attribution;
                    const values = this.buildInitialValues(metric);
                    this.addIfPresent(values, "largest_shift_value", largestShiftValue);
                    this.addIfPresent(values, "largest_shift_time", largestShiftTime);
                    const context2 = this.buildInitialContext(metric);
                    this.addIfPresent(context2, $281a441cdcb2cf36$var$loadStateKey, loadState);
                    this.addIfPresent(context2, "largest_shift_target", largestShiftTarget);
                    this.pushMeasurement(values, context2);
                }, {
                    reportAllChanges: (_a2 = this.webVitalConfig) === null || _a2 === void 0 ? void 0 : _a2.reportAllChanges
                });
            }
            measureFCP() {
                var _a2;
                $281a441cdcb2cf36$var$w2((metric)=>{
                    const { firstByteToFCP: firstByteToFCP, timeToFirstByte: timeToFirstByte, loadState: loadState } = metric.attribution;
                    const values = this.buildInitialValues(metric);
                    this.addIfPresent(values, "first_byte_to_fcp", firstByteToFCP);
                    this.addIfPresent(values, $281a441cdcb2cf36$var$timeToFirstByteKey, timeToFirstByte);
                    const context2 = this.buildInitialContext(metric);
                    this.addIfPresent(context2, $281a441cdcb2cf36$var$loadStateKey, loadState);
                    this.pushMeasurement(values, context2);
                }, {
                    reportAllChanges: (_a2 = this.webVitalConfig) === null || _a2 === void 0 ? void 0 : _a2.reportAllChanges
                });
            }
            measureFID() {
                var _a2;
                $281a441cdcb2cf36$var$yt((metric)=>{
                    const { eventTime: eventTime, eventTarget: eventTarget, eventType: eventType, loadState: loadState } = metric.attribution;
                    const values = this.buildInitialValues(metric);
                    this.addIfPresent(values, "event_time", eventTime);
                    const context2 = this.buildInitialContext(metric);
                    this.addIfPresent(context2, "event_target", eventTarget);
                    this.addIfPresent(context2, "event_type", eventType);
                    this.addIfPresent(context2, $281a441cdcb2cf36$var$loadStateKey, loadState);
                    this.pushMeasurement(values, context2);
                }, {
                    reportAllChanges: (_a2 = this.webVitalConfig) === null || _a2 === void 0 ? void 0 : _a2.reportAllChanges
                });
            }
            measureINP() {
                var _a2;
                $281a441cdcb2cf36$var$rt((metric)=>{
                    const { interactionTime: interactionTime, presentationDelay: presentationDelay, inputDelay: inputDelay, processingDuration: processingDuration, nextPaintTime: nextPaintTime, loadState: loadState, interactionTarget: interactionTarget, interactionType: interactionType } = metric.attribution;
                    const values = this.buildInitialValues(metric);
                    this.addIfPresent(values, "interaction_time", interactionTime);
                    this.addIfPresent(values, "presentation_delay", presentationDelay);
                    this.addIfPresent(values, "input_delay", inputDelay);
                    this.addIfPresent(values, "processing_duration", processingDuration);
                    this.addIfPresent(values, "next_paint_time", nextPaintTime);
                    const context2 = this.buildInitialContext(metric);
                    this.addIfPresent(context2, $281a441cdcb2cf36$var$loadStateKey, loadState);
                    this.addIfPresent(context2, "interaction_target", interactionTarget);
                    this.addIfPresent(context2, "interaction_type", interactionType);
                    this.pushMeasurement(values, context2);
                }, {
                    reportAllChanges: (_a2 = this.webVitalConfig) === null || _a2 === void 0 ? void 0 : _a2.reportAllChanges
                });
            }
            measureLCP() {
                var _a2;
                $281a441cdcb2cf36$var$ot((metric)=>{
                    const { elementRenderDelay: elementRenderDelay, resourceLoadDelay: resourceLoadDelay, resourceLoadDuration: resourceLoadDuration, timeToFirstByte: timeToFirstByte, element: element2 } = metric.attribution;
                    const values = this.buildInitialValues(metric);
                    this.addIfPresent(values, "element_render_delay", elementRenderDelay);
                    this.addIfPresent(values, "resource_load_delay", resourceLoadDelay);
                    this.addIfPresent(values, "resource_load_duration", resourceLoadDuration);
                    this.addIfPresent(values, $281a441cdcb2cf36$var$timeToFirstByteKey, timeToFirstByte);
                    const context2 = this.buildInitialContext(metric);
                    this.addIfPresent(context2, "element", element2);
                    this.pushMeasurement(values, context2);
                }, {
                    reportAllChanges: (_a2 = this.webVitalConfig) === null || _a2 === void 0 ? void 0 : _a2.reportAllChanges
                });
            }
            measureTTFB() {
                var _a2;
                $281a441cdcb2cf36$var$ft((metric)=>{
                    const { dnsDuration: dnsDuration, connectionDuration: connectionDuration, requestDuration: requestDuration, waitingDuration: waitingDuration, cacheDuration: cacheDuration } = metric.attribution;
                    const values = this.buildInitialValues(metric);
                    this.addIfPresent(values, "dns_duration", dnsDuration);
                    this.addIfPresent(values, "connection_duration", connectionDuration);
                    this.addIfPresent(values, "request_duration", requestDuration);
                    this.addIfPresent(values, "waiting_duration", waitingDuration);
                    this.addIfPresent(values, "cache_duration", cacheDuration);
                    const context2 = this.buildInitialContext(metric);
                    this.pushMeasurement(values, context2);
                }, {
                    reportAllChanges: (_a2 = this.webVitalConfig) === null || _a2 === void 0 ? void 0 : _a2.reportAllChanges
                });
            }
            buildInitialValues(metric) {
                const indicator = metric.name.toLowerCase();
                return {
                    [indicator]: metric.value,
                    delta: metric.delta
                };
            }
            buildInitialContext(metric) {
                var _a2;
                const navigationEntryId = (_a2 = $281a441cdcb2cf36$var$getItem2($281a441cdcb2cf36$var$NAVIGATION_ID_STORAGE_KEY, $281a441cdcb2cf36$var$webStorageType.session)) !== null && _a2 !== void 0 ? _a2 : $281a441cdcb2cf36$var$unknownString;
                return {
                    id: metric.id,
                    rating: metric.rating,
                    navigation_type: metric.navigationType,
                    navigation_entry_id: navigationEntryId
                };
            }
            pushMeasurement(values, context2) {
                const type = "web-vitals";
                this.corePushMeasurement({
                    type: type,
                    values: values
                }, {
                    context: context2
                });
            }
            addIfPresent(source, key, metric) {
                if (metric) source[key] = metric;
            }
        };
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/webVitals/instrumentation.js
var $281a441cdcb2cf36$var$WebVitalsInstrumentation;
var $281a441cdcb2cf36$var$init_instrumentation5 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/webVitals/instrumentation.js" () {
        $281a441cdcb2cf36$var$init_esm4();
        $281a441cdcb2cf36$var$init_webVitalsBasic();
        $281a441cdcb2cf36$var$init_webVitalsWithAttribution();
        $281a441cdcb2cf36$var$WebVitalsInstrumentation = class extends $281a441cdcb2cf36$var$BaseInstrumentation {
            constructor(){
                super(...arguments);
                this.name = "@grafana/faro-web-sdk:instrumentation-web-vitals";
                this.version = $281a441cdcb2cf36$var$VERSION4;
            }
            initialize() {
                this.logDebug("Initializing");
                const webVitals = this.intializeWebVitalsInstrumentation();
                webVitals.initialize();
            }
            intializeWebVitalsInstrumentation() {
                var _a2, _b, _c;
                if (((_a2 = this.config) === null || _a2 === void 0 ? void 0 : _a2.trackWebVitalsAttribution) === false || ((_c = (_b = this.config) === null || _b === void 0 ? void 0 : _b.webVitalsInstrumentation) === null || _c === void 0 ? void 0 : _c.trackAttribution) === false) return new $281a441cdcb2cf36$var$WebVitalsBasic(this.api.pushMeasurement, this.config.webVitalsInstrumentation);
                return new $281a441cdcb2cf36$var$WebVitalsWithAttribution(this.api.pushMeasurement, this.config.webVitalsInstrumentation);
            }
        };
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/webVitals/index.js
var $281a441cdcb2cf36$var$init_webVitals = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/webVitals/index.js" () {
        $281a441cdcb2cf36$var$init_instrumentation5();
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/performance/performanceConstants.js
var $281a441cdcb2cf36$var$NAVIGATION_ENTRY, $281a441cdcb2cf36$var$RESOURCE_ENTRY;
var $281a441cdcb2cf36$var$init_performanceConstants = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/performance/performanceConstants.js" () {
        $281a441cdcb2cf36$var$NAVIGATION_ENTRY = "navigation";
        $281a441cdcb2cf36$var$RESOURCE_ENTRY = "resource";
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/performance/performanceUtils.js
function $281a441cdcb2cf36$var$getSpanContextFromServerTiming(serverTimings = []) {
    for (const serverEntry of serverTimings)if (serverEntry.name === "traceparent") {
        if (!$281a441cdcb2cf36$var$w3cTraceparentFormat.test(serverEntry.description)) continue;
        const [, traceId, spanId] = serverEntry.description.split("-");
        if (traceId != null && spanId != null) return {
            traceId: traceId,
            spanId: spanId
        };
        break;
    }
    return void 0;
}
function $281a441cdcb2cf36$var$performanceObserverSupported() {
    return "PerformanceObserver" in window;
}
function $281a441cdcb2cf36$var$onDocumentReady(handleReady) {
    if (document.readyState === "complete") handleReady();
    else {
        const readyStateCompleteHandler = ()=>{
            if (document.readyState === "complete") {
                handleReady();
                document.removeEventListener("readystatechange", readyStateCompleteHandler);
            }
        };
        document.addEventListener("readystatechange", readyStateCompleteHandler);
    }
}
function $281a441cdcb2cf36$var$includePerformanceEntry(performanceEntryJSON, allowProps = {}) {
    for (const [allowPropKey, allowPropValue] of Object.entries(allowProps)){
        const perfEntryPropVal = performanceEntryJSON[allowPropKey];
        if (perfEntryPropVal == null) return false;
        if ($281a441cdcb2cf36$var$isArray4(allowPropValue)) return allowPropValue.includes(perfEntryPropVal);
        return perfEntryPropVal === allowPropValue;
    }
    return true;
}
function $281a441cdcb2cf36$var$createFaroResourceTiming(resourceEntryRaw) {
    const { connectEnd: connectEnd, connectStart: connectStart, decodedBodySize: decodedBodySize, domainLookupEnd: domainLookupEnd, domainLookupStart: domainLookupStart, duration: duration, encodedBodySize: encodedBodySize, fetchStart: fetchStart, initiatorType: initiatorType, name: name, nextHopProtocol: nextHopProtocol, redirectEnd: redirectEnd, redirectStart: redirectStart, // @ts-expect-error the renderBlockingStatus property is not available in all browsers
    renderBlockingStatus: rbs, requestStart: requestStart, responseEnd: responseEnd, responseStart: responseStart, responseStatus: responseStatus, secureConnectionStart: secureConnectionStart, transferSize: transferSize, workerStart: workerStart } = resourceEntryRaw;
    return {
        name: name,
        duration: $281a441cdcb2cf36$var$toFaroPerformanceTimingString(duration),
        tcpHandshakeTime: $281a441cdcb2cf36$var$toFaroPerformanceTimingString(connectEnd - connectStart),
        dnsLookupTime: $281a441cdcb2cf36$var$toFaroPerformanceTimingString(domainLookupEnd - domainLookupStart),
        tlsNegotiationTime: $281a441cdcb2cf36$var$toFaroPerformanceTimingString(connectEnd - secureConnectionStart),
        responseStatus: $281a441cdcb2cf36$var$toFaroPerformanceTimingString(responseStatus),
        redirectTime: $281a441cdcb2cf36$var$toFaroPerformanceTimingString(redirectEnd - redirectStart),
        requestTime: $281a441cdcb2cf36$var$toFaroPerformanceTimingString(responseStart - requestStart),
        responseTime: $281a441cdcb2cf36$var$toFaroPerformanceTimingString(responseEnd - responseStart),
        fetchTime: $281a441cdcb2cf36$var$toFaroPerformanceTimingString(responseEnd - fetchStart),
        serviceWorkerTime: $281a441cdcb2cf36$var$toFaroPerformanceTimingString(fetchStart - workerStart),
        decodedBodySize: $281a441cdcb2cf36$var$toFaroPerformanceTimingString(decodedBodySize),
        encodedBodySize: $281a441cdcb2cf36$var$toFaroPerformanceTimingString(encodedBodySize),
        cacheHitStatus: getCacheType(),
        renderBlockingStatus: $281a441cdcb2cf36$var$toFaroPerformanceTimingString(rbs),
        protocol: nextHopProtocol,
        initiatorType: initiatorType,
        visibilityState: document.visibilityState,
        ttfb: $281a441cdcb2cf36$var$toFaroPerformanceTimingString(responseStart - requestStart),
        transferSize: $281a441cdcb2cf36$var$toFaroPerformanceTimingString(transferSize)
    };
    function getCacheType() {
        let cacheType = "fullLoad";
        if (transferSize === 0) {
            if (decodedBodySize > 0) cacheType = "cache";
        } else {
            if (responseStatus != null) {
                if (responseStatus === 304) cacheType = "conditionalFetch";
            } else if (encodedBodySize > 0 && transferSize < encodedBodySize) cacheType = "conditionalFetch";
        }
        return cacheType;
    }
}
function $281a441cdcb2cf36$var$createFaroNavigationTiming(navigationEntryRaw) {
    const { activationStart: activationStart, domComplete: domComplete, domContentLoadedEventEnd: domContentLoadedEventEnd, domContentLoadedEventStart: domContentLoadedEventStart, domInteractive: domInteractive, fetchStart: fetchStart, loadEventEnd: loadEventEnd, loadEventStart: loadEventStart, responseStart: responseStart, type: type } = navigationEntryRaw;
    const parserStart = $281a441cdcb2cf36$var$getDocumentParsingTime();
    return Object.assign(Object.assign({}, $281a441cdcb2cf36$var$createFaroResourceTiming(navigationEntryRaw)), {
        pageLoadTime: $281a441cdcb2cf36$var$toFaroPerformanceTimingString(domComplete - fetchStart),
        documentParsingTime: $281a441cdcb2cf36$var$toFaroPerformanceTimingString(parserStart ? domInteractive - parserStart : null),
        domProcessingTime: $281a441cdcb2cf36$var$toFaroPerformanceTimingString(domComplete - domInteractive),
        domContentLoadHandlerTime: $281a441cdcb2cf36$var$toFaroPerformanceTimingString(domContentLoadedEventEnd - domContentLoadedEventStart),
        onLoadTime: $281a441cdcb2cf36$var$toFaroPerformanceTimingString(loadEventEnd - loadEventStart),
        // For navigation entries we can calculate the TTFB based on activationStart. We overwrite the TTFB value coming with the resource entry.
        // For more accuracy on prerendered pages page we calculate relative top the activationStart instead of the start of the navigation.
        // clamp to 0 if activationStart occurs after first byte is received.
        ttfb: $281a441cdcb2cf36$var$toFaroPerformanceTimingString(Math.max(responseStart - (activationStart !== null && activationStart !== void 0 ? activationStart : 0), 0)),
        type: type
    });
}
function $281a441cdcb2cf36$var$getDocumentParsingTime() {
    var _a2;
    if (((_a2 = performance.timing) === null || _a2 === void 0 ? void 0 : _a2.domLoading) != null) return performance.timing.domLoading - performance.timeOrigin;
    return null;
}
function $281a441cdcb2cf36$var$toFaroPerformanceTimingString(v3) {
    if (v3 == null) return $281a441cdcb2cf36$var$unknownString;
    if (typeof v3 === "number") return Math.round(v3 > 0 ? v3 : 0).toString();
    return v3.toString();
}
var $281a441cdcb2cf36$var$w3cTraceparentFormat;
var $281a441cdcb2cf36$var$init_performanceUtils = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/performance/performanceUtils.js" () {
        $281a441cdcb2cf36$var$init_esm4();
        $281a441cdcb2cf36$var$w3cTraceparentFormat = /^00-[a-f0-9]{32}-[a-f0-9]{16}-[0-9]{1,2}$/;
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/performance/navigation.js
function $281a441cdcb2cf36$var$getNavigationTimings(pushEvent) {
    let faroNavigationEntryResolve;
    const faroNavigationEntryPromise = new Promise((resolve)=>{
        faroNavigationEntryResolve = resolve;
    });
    const observer = new PerformanceObserver((observedEntries)=>{
        var _a2;
        const [navigationEntryRaw] = observedEntries.getEntries();
        if (navigationEntryRaw == null || $281a441cdcb2cf36$var$isUrlIgnored(navigationEntryRaw.name)) return;
        const navEntryJson = navigationEntryRaw.toJSON();
        let spanContext = $281a441cdcb2cf36$var$getSpanContextFromServerTiming(navEntryJson === null || navEntryJson === void 0 ? void 0 : navEntryJson.serverTiming);
        const faroPreviousNavigationId = (_a2 = $281a441cdcb2cf36$var$getItem2($281a441cdcb2cf36$var$NAVIGATION_ID_STORAGE_KEY, $281a441cdcb2cf36$var$webStorageType.session)) !== null && _a2 !== void 0 ? _a2 : $281a441cdcb2cf36$var$unknownString;
        const faroNavigationEntry = Object.assign(Object.assign({}, $281a441cdcb2cf36$var$createFaroNavigationTiming(navEntryJson)), {
            faroNavigationId: $281a441cdcb2cf36$var$genShortID(),
            faroPreviousNavigationId: faroPreviousNavigationId
        });
        $281a441cdcb2cf36$var$setItem($281a441cdcb2cf36$var$NAVIGATION_ID_STORAGE_KEY, faroNavigationEntry.faroNavigationId, $281a441cdcb2cf36$var$webStorageType.session);
        pushEvent("faro.performance.navigation", faroNavigationEntry, void 0, {
            spanContext: spanContext,
            timestampOverwriteMs: performance.timeOrigin + navEntryJson.startTime
        });
        faroNavigationEntryResolve(faroNavigationEntry);
    });
    observer.observe({
        type: $281a441cdcb2cf36$var$NAVIGATION_ENTRY,
        buffered: true
    });
    return faroNavigationEntryPromise;
}
var $281a441cdcb2cf36$var$init_navigation = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/performance/navigation.js" () {
        $281a441cdcb2cf36$var$init_esm4();
        $281a441cdcb2cf36$var$init_utils8();
        $281a441cdcb2cf36$var$init_url();
        $281a441cdcb2cf36$var$init_instrumentationConstants();
        $281a441cdcb2cf36$var$init_performanceConstants();
        $281a441cdcb2cf36$var$init_performanceUtils();
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/performance/resource.js
function $281a441cdcb2cf36$var$observeResourceTimings(faroNavigationId, pushEvent, observable) {
    const trackResources = $281a441cdcb2cf36$var$faro.config.trackResources;
    const observer = new PerformanceObserver((observedEntries)=>{
        const entries = observedEntries.getEntries();
        for (const resourceEntryRaw of entries){
            if ($281a441cdcb2cf36$var$isUrlIgnored(resourceEntryRaw.name)) return;
            const resourceEntryJson = resourceEntryRaw.toJSON();
            let spanContext = $281a441cdcb2cf36$var$getSpanContextFromServerTiming(resourceEntryJson === null || resourceEntryJson === void 0 ? void 0 : resourceEntryJson.serverTiming);
            if (trackResources == null && $281a441cdcb2cf36$var$includePerformanceEntry(resourceEntryJson, $281a441cdcb2cf36$var$DEFAULT_TRACK_RESOURCES) || trackResources) {
                const faroResourceEntry = Object.assign(Object.assign({}, $281a441cdcb2cf36$var$createFaroResourceTiming(resourceEntryJson)), {
                    faroNavigationId: faroNavigationId,
                    faroResourceId: $281a441cdcb2cf36$var$genShortID()
                });
                if ($281a441cdcb2cf36$var$faro.config.trackUserActionsPreview) observable === null || observable === void 0 || observable.notify({
                    type: $281a441cdcb2cf36$var$RESOURCE_ENTRY
                });
                pushEvent("faro.performance.resource", faroResourceEntry, void 0, {
                    spanContext: spanContext,
                    timestampOverwriteMs: performance.timeOrigin + resourceEntryJson.startTime
                });
            }
        }
    });
    observer.observe({
        type: $281a441cdcb2cf36$var$RESOURCE_ENTRY,
        buffered: true
    });
}
var $281a441cdcb2cf36$var$DEFAULT_TRACK_RESOURCES;
var $281a441cdcb2cf36$var$init_resource2 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/performance/resource.js" () {
        $281a441cdcb2cf36$var$init_esm4();
        $281a441cdcb2cf36$var$init_url();
        $281a441cdcb2cf36$var$init_performanceConstants();
        $281a441cdcb2cf36$var$init_performanceUtils();
        $281a441cdcb2cf36$var$DEFAULT_TRACK_RESOURCES = {
            initiatorType: [
                "xmlhttprequest",
                "fetch"
            ]
        };
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/performance/instrumentation.js
var $281a441cdcb2cf36$var$__awaiter, $281a441cdcb2cf36$var$performanceEntriesSubscription, $281a441cdcb2cf36$var$PerformanceInstrumentation;
var $281a441cdcb2cf36$var$init_instrumentation6 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/performance/instrumentation.js" () {
        $281a441cdcb2cf36$var$init_esm4();
        $281a441cdcb2cf36$var$init_navigation();
        $281a441cdcb2cf36$var$init_performanceUtils();
        $281a441cdcb2cf36$var$init_resource2();
        $281a441cdcb2cf36$var$__awaiter = function(thisArg, _arguments, P3, generator) {
            function adopt(value2) {
                return value2 instanceof P3 ? value2 : new P3(function(resolve) {
                    resolve(value2);
                });
            }
            return new (P3 || (P3 = Promise))(function(resolve, reject) {
                function fulfilled(value2) {
                    try {
                        step(generator.next(value2));
                    } catch (e4) {
                        reject(e4);
                    }
                }
                function rejected(value2) {
                    try {
                        step(generator["throw"](value2));
                    } catch (e4) {
                        reject(e4);
                    }
                }
                function step(result) {
                    result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                }
                step((generator = generator.apply(thisArg, _arguments || [])).next());
            });
        };
        $281a441cdcb2cf36$var$performanceEntriesSubscription = new $281a441cdcb2cf36$var$Observable2();
        $281a441cdcb2cf36$var$PerformanceInstrumentation = class extends $281a441cdcb2cf36$var$BaseInstrumentation {
            constructor(){
                super(...arguments);
                this.name = "@grafana/faro-web-sdk:instrumentation-performance";
                this.version = $281a441cdcb2cf36$var$VERSION4;
            }
            initialize() {
                if (!$281a441cdcb2cf36$var$performanceObserverSupported()) {
                    this.logDebug("performance observer not supported. Disable performance instrumentation.");
                    return;
                }
                $281a441cdcb2cf36$var$onDocumentReady(()=>$281a441cdcb2cf36$var$__awaiter(this, void 0, void 0, function*() {
                        const pushEvent = this.api.pushEvent;
                        const { faroNavigationId: faroNavigationId } = yield $281a441cdcb2cf36$var$getNavigationTimings(pushEvent);
                        if (faroNavigationId != null) $281a441cdcb2cf36$var$observeResourceTimings(faroNavigationId, pushEvent, $281a441cdcb2cf36$var$performanceEntriesSubscription);
                    }));
            }
        };
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/performance/index.js
var $281a441cdcb2cf36$var$init_performance = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/performance/index.js" () {
        $281a441cdcb2cf36$var$init_instrumentation6();
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/userActions/const.js
var $281a441cdcb2cf36$var$MESSAGE_TYPE_RESOURCE_ENTRY, $281a441cdcb2cf36$var$MESSAGE_TYPE_HTTP_REQUEST_START, $281a441cdcb2cf36$var$MESSAGE_TYPE_HTTP_REQUEST_END, $281a441cdcb2cf36$var$MESSAGE_TYPE_DOM_MUTATION, $281a441cdcb2cf36$var$userActionDataAttributeParsed, $281a441cdcb2cf36$var$userActionDataAttribute, $281a441cdcb2cf36$var$userActionStartByApiCallEventName;
var $281a441cdcb2cf36$var$init_const11 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/userActions/const.js" () {
        $281a441cdcb2cf36$var$MESSAGE_TYPE_RESOURCE_ENTRY = "resource-entry";
        $281a441cdcb2cf36$var$MESSAGE_TYPE_HTTP_REQUEST_START = "http-request-start";
        $281a441cdcb2cf36$var$MESSAGE_TYPE_HTTP_REQUEST_END = "http-request-end";
        $281a441cdcb2cf36$var$MESSAGE_TYPE_DOM_MUTATION = "dom-mutation";
        $281a441cdcb2cf36$var$userActionDataAttributeParsed = "faroUserActionName";
        $281a441cdcb2cf36$var$userActionDataAttribute = "data-faro-user-action-name";
        $281a441cdcb2cf36$var$userActionStartByApiCallEventName = "faroApiCall";
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/userActions/domMutationMonitor.js
function $281a441cdcb2cf36$var$monitorDomMutations() {
    const observable = new $281a441cdcb2cf36$var$Observable2();
    const observer = new MutationObserver((_mutationsList, _observer)=>{
        observable.notify({
            type: $281a441cdcb2cf36$var$MESSAGE_TYPE_DOM_MUTATION
        });
    });
    observer.observe(document, {
        attributes: true,
        childList: true,
        subtree: true,
        characterData: true
    });
    return observable;
}
var $281a441cdcb2cf36$var$init_domMutationMonitor = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/userActions/domMutationMonitor.js" () {
        $281a441cdcb2cf36$var$init_esm4();
        $281a441cdcb2cf36$var$init_const11();
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/userActions/httpRequestMonitor.js
function $281a441cdcb2cf36$var$monitorHttpRequests() {
    const observable = new $281a441cdcb2cf36$var$Observable2();
    function emitStartMessage(requestProps) {
        observable.notify({
            type: $281a441cdcb2cf36$var$MESSAGE_TYPE_HTTP_REQUEST_START,
            request: requestProps
        });
    }
    function emitEndMessage(requestProps) {
        observable.notify({
            type: $281a441cdcb2cf36$var$MESSAGE_TYPE_HTTP_REQUEST_END,
            request: requestProps
        });
    }
    $281a441cdcb2cf36$var$monitorFetch({
        onRequestStart: emitStartMessage,
        onRequestEnd: emitEndMessage
    });
    $281a441cdcb2cf36$var$monitorXhr({
        onRequestStart: emitStartMessage,
        onRequestEnd: emitEndMessage
    });
    return observable;
}
function $281a441cdcb2cf36$var$monitorXhr({ onRequestStart: onRequestStart, onRequestEnd: onRequestEnd }) {
    const originalOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function() {
        const url2 = arguments[1];
        const isIgnoredUrl = $281a441cdcb2cf36$var$isUrlIgnored(url2);
        const method = arguments[0];
        const requestId = $281a441cdcb2cf36$var$genShortID();
        this.addEventListener("loadstart", function() {
            if (!isIgnoredUrl) onRequestStart({
                url: url2,
                method: method,
                requestId: requestId,
                apiType: $281a441cdcb2cf36$var$apiTypeXhr
            });
        });
        this.addEventListener("load", function() {
            if (!isIgnoredUrl) onRequestEnd({
                url: url2,
                method: method,
                requestId: requestId,
                apiType: $281a441cdcb2cf36$var$apiTypeXhr
            });
        });
        this.addEventListener("error", function() {
            if (!isIgnoredUrl) onRequestEnd({
                url: url2,
                method: method,
                requestId: requestId,
                apiType: $281a441cdcb2cf36$var$apiTypeXhr
            });
        });
        this.addEventListener("abort", function() {
            if (!isIgnoredUrl) onRequestEnd({
                url: url2,
                method: method,
                requestId: requestId,
                apiType: $281a441cdcb2cf36$var$apiTypeXhr
            });
        });
        originalOpen.apply(this, arguments);
    };
}
function $281a441cdcb2cf36$var$monitorFetch({ onRequestEnd: onRequestEnd, onRequestStart: onRequestStart }) {
    const originalFetch = window.fetch;
    window.fetch = function() {
        var _a2, _b;
        const url2 = (_a2 = $281a441cdcb2cf36$var$getUrlFromResource(arguments[0])) !== null && _a2 !== void 0 ? _a2 : "";
        const isIgnoredUrl = $281a441cdcb2cf36$var$isUrlIgnored(url2);
        const method = ((_b = arguments[1]) !== null && _b !== void 0 ? _b : {}).method;
        const requestId = $281a441cdcb2cf36$var$genShortID();
        if (!isIgnoredUrl) onRequestStart({
            url: url2,
            method: method,
            requestId: requestId,
            apiType: $281a441cdcb2cf36$var$apiTypeFetch
        });
        return originalFetch.apply(this, arguments).then((response)=>{
            if (!isIgnoredUrl) onRequestEnd({
                url: url2,
                method: method,
                requestId: requestId,
                apiType: $281a441cdcb2cf36$var$apiTypeFetch
            });
            return response;
        }).catch((error)=>{
            if (!isIgnoredUrl) onRequestEnd({
                url: url2,
                method: method,
                requestId: requestId,
                apiType: $281a441cdcb2cf36$var$apiTypeFetch
            });
            throw error;
        });
    };
}
var $281a441cdcb2cf36$var$apiTypeFetch, $281a441cdcb2cf36$var$apiTypeXhr;
var $281a441cdcb2cf36$var$init_httpRequestMonitor = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/userActions/httpRequestMonitor.js" () {
        $281a441cdcb2cf36$var$init_esm4();
        $281a441cdcb2cf36$var$init_url();
        $281a441cdcb2cf36$var$init_const11();
        $281a441cdcb2cf36$var$apiTypeFetch = "fetch";
        $281a441cdcb2cf36$var$apiTypeXhr = "xhr";
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/userActions/performanceEntriesMonitor.js
function $281a441cdcb2cf36$var$monitorPerformanceEntries() {
    const observable = new $281a441cdcb2cf36$var$Observable2();
    $281a441cdcb2cf36$var$performanceEntriesSubscription.subscribe((data2)=>{
        if (data2.type === $281a441cdcb2cf36$var$RESOURCE_ENTRY) observable.notify({
            type: $281a441cdcb2cf36$var$MESSAGE_TYPE_RESOURCE_ENTRY
        });
    });
    return observable;
}
var $281a441cdcb2cf36$var$init_performanceEntriesMonitor = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/userActions/performanceEntriesMonitor.js" () {
        $281a441cdcb2cf36$var$init_esm4();
        $281a441cdcb2cf36$var$init_instrumentation6();
        $281a441cdcb2cf36$var$init_performanceConstants();
        $281a441cdcb2cf36$var$init_const11();
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/userActions/util.js
function $281a441cdcb2cf36$var$convertDataAttributeName(userActionDataAttribute2) {
    const withoutData = userActionDataAttribute2.split("data-")[1];
    const withUpperCase = withoutData === null || withoutData === void 0 ? void 0 : withoutData.replace(/-(.)/g, (_3, char)=>char.toUpperCase());
    return withUpperCase === null || withUpperCase === void 0 ? void 0 : withUpperCase.replace(/-/g, "");
}
var $281a441cdcb2cf36$var$init_util = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/userActions/util.js" () {}
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/userActions/processUserActionEventHandler.js
function $281a441cdcb2cf36$var$getUserEventHandler(faro2) {
    const { api: api, config: config } = faro2;
    const httpMonitor = $281a441cdcb2cf36$var$monitorHttpRequests();
    const domMutationsMonitor = $281a441cdcb2cf36$var$monitorDomMutations();
    const performanceEntriesMonitor = $281a441cdcb2cf36$var$monitorPerformanceEntries();
    let timeoutId;
    let actionRunning = false;
    function processUserEvent(event) {
        var _a2;
        let userActionName;
        const isApiEventDetected = $281a441cdcb2cf36$var$isApiEvent(event);
        if (isApiEventDetected) userActionName = event.name;
        else userActionName = $281a441cdcb2cf36$var$getUserActionName(event.target, (_a2 = config.trackUserActionsDataAttributeName) !== null && _a2 !== void 0 ? _a2 : $281a441cdcb2cf36$var$userActionDataAttributeParsed);
        if (actionRunning || userActionName == null) return;
        actionRunning = true;
        const startTime = $281a441cdcb2cf36$var$dateNow();
        let endTime;
        const actionId = $281a441cdcb2cf36$var$genShortID();
        $281a441cdcb2cf36$var$apiMessageBus.notify({
            type: $281a441cdcb2cf36$var$USER_ACTION_START,
            name: userActionName,
            startTime: startTime,
            parentId: actionId
        });
        timeoutId = $281a441cdcb2cf36$var$startTimeout(timeoutId, ()=>{
            endTime = $281a441cdcb2cf36$var$dateNow();
            actionRunning = false;
            $281a441cdcb2cf36$var$sendUserActionCancelMessage(userActionName, actionId);
        }, $281a441cdcb2cf36$var$maxFollowUpActionTimeRange);
        const runningRequests = /* @__PURE__ */ new Map();
        let isHalted = false;
        let pendingActionTimeoutId;
        const allMonitorsSub = new $281a441cdcb2cf36$var$Observable2().merge(httpMonitor, domMutationsMonitor, performanceEntriesMonitor).takeWhile(()=>actionRunning).filter((msg)=>{
            if (isHalted && !($281a441cdcb2cf36$var$isRequestEndMessage(msg) && runningRequests.has(msg.request.requestId))) return false;
            return true;
        }).subscribe((msg)=>{
            if ($281a441cdcb2cf36$var$isRequestStartMessage(msg)) runningRequests.set(msg.request.requestId, msg.request);
            if ($281a441cdcb2cf36$var$isRequestEndMessage(msg)) runningRequests.delete(msg.request.requestId);
            timeoutId = $281a441cdcb2cf36$var$startTimeout(timeoutId, ()=>{
                endTime = $281a441cdcb2cf36$var$dateNow();
                const userActionParentEventProps = Object.assign({
                    api: api,
                    userActionName: userActionName,
                    startTime: startTime,
                    endTime: endTime,
                    actionId: actionId,
                    event: event
                }, isApiEventDetected ? {
                    attributes: event.attributes
                } : {});
                const hasPendingRequests = runningRequests.size > 0;
                const isAllPendingRequestsResolved = isHalted && !hasPendingRequests;
                if (isAllPendingRequestsResolved) {
                    clearTimeout(pendingActionTimeoutId);
                    isHalted = false;
                }
                if (hasPendingRequests) {
                    isHalted = true;
                    $281a441cdcb2cf36$var$apiMessageBus.notify({
                        type: $281a441cdcb2cf36$var$USER_ACTION_HALT,
                        name: userActionName,
                        parentId: actionId,
                        reason: "pending-requests",
                        haltTime: $281a441cdcb2cf36$var$dateNow()
                    });
                    pendingActionTimeoutId = $281a441cdcb2cf36$var$startTimeout(void 0, ()=>{
                        $281a441cdcb2cf36$var$unsubscribeAllMonitors(allMonitorsSub);
                        $281a441cdcb2cf36$var$endUserAction(userActionParentEventProps);
                        actionRunning = false;
                        isHalted = false;
                    }, 10000);
                } else {
                    $281a441cdcb2cf36$var$unsubscribeAllMonitors(allMonitorsSub);
                    $281a441cdcb2cf36$var$endUserAction(userActionParentEventProps);
                    actionRunning = false;
                    isHalted = false;
                }
            }, $281a441cdcb2cf36$var$maxFollowUpActionTimeRange);
        });
    }
    return processUserEvent;
}
function $281a441cdcb2cf36$var$endUserAction(props) {
    const { api: api, userActionName: userActionName, startTime: startTime, endTime: endTime, actionId: actionId, event: event, attributes: attributes } = props;
    const duration = endTime - startTime;
    const eventType = event.type;
    $281a441cdcb2cf36$var$apiMessageBus.notify({
        type: $281a441cdcb2cf36$var$USER_ACTION_END,
        name: userActionName,
        id: actionId,
        startTime: startTime,
        endTime: endTime,
        duration: duration,
        eventType: eventType
    });
    api.pushEvent(userActionName, Object.assign({
        userActionStartTime: startTime.toString(),
        userActionEndTime: endTime.toString(),
        userActionDuration: duration.toString(),
        userActionTrigger: eventType
    }, $281a441cdcb2cf36$var$stringifyObjectValues(attributes)), void 0, {
        timestampOverwriteMs: startTime,
        customPayloadTransformer: (payload)=>{
            payload.action = {
                id: actionId,
                name: userActionName
            };
            return payload;
        }
    });
}
function $281a441cdcb2cf36$var$getUserActionName(element2, dataAttributeName) {
    const parsedDataAttributeName = $281a441cdcb2cf36$var$convertDataAttributeName(dataAttributeName);
    const dataset = element2.dataset;
    for(const key in dataset){
        if (key === parsedDataAttributeName) return dataset[key];
    }
    return void 0;
}
function $281a441cdcb2cf36$var$startTimeout(timeoutId, cb, delay) {
    if (timeoutId) clearTimeout(timeoutId);
    timeoutId = setTimeout(()=>{
        cb();
    }, delay);
    return timeoutId;
}
function $281a441cdcb2cf36$var$sendUserActionCancelMessage(userActionName, actionId) {
    $281a441cdcb2cf36$var$apiMessageBus.notify({
        type: $281a441cdcb2cf36$var$USER_ACTION_CANCEL,
        name: userActionName,
        parentId: actionId
    });
}
function $281a441cdcb2cf36$var$unsubscribeAllMonitors(allMonitorsSub) {
    allMonitorsSub === null || allMonitorsSub === void 0 || allMonitorsSub.unsubscribe();
    allMonitorsSub = void 0;
}
function $281a441cdcb2cf36$var$isRequestStartMessage(msg) {
    return msg.type === $281a441cdcb2cf36$var$MESSAGE_TYPE_HTTP_REQUEST_START;
}
function $281a441cdcb2cf36$var$isRequestEndMessage(msg) {
    return msg.type === $281a441cdcb2cf36$var$MESSAGE_TYPE_HTTP_REQUEST_END;
}
function $281a441cdcb2cf36$var$isApiEvent(apiEvent) {
    return apiEvent.type === $281a441cdcb2cf36$var$userActionStartByApiCallEventName && typeof apiEvent.name === "string";
}
var $281a441cdcb2cf36$var$maxFollowUpActionTimeRange;
var $281a441cdcb2cf36$var$init_processUserActionEventHandler = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/userActions/processUserActionEventHandler.js" () {
        $281a441cdcb2cf36$var$init_esm4();
        $281a441cdcb2cf36$var$init_const11();
        $281a441cdcb2cf36$var$init_domMutationMonitor();
        $281a441cdcb2cf36$var$init_httpRequestMonitor();
        $281a441cdcb2cf36$var$init_performanceEntriesMonitor();
        $281a441cdcb2cf36$var$init_util();
        $281a441cdcb2cf36$var$maxFollowUpActionTimeRange = 100;
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/userActions/instrumentation.js
function $281a441cdcb2cf36$var$startUserAction(name, attributes) {
    $281a441cdcb2cf36$var$processUserEventHandler === null || $281a441cdcb2cf36$var$processUserEventHandler === void 0 || $281a441cdcb2cf36$var$processUserEventHandler($281a441cdcb2cf36$var$createUserActionApiEvent(name, attributes));
}
function $281a441cdcb2cf36$var$createUserActionApiEvent(name, attributes) {
    return {
        name: name,
        attributes: attributes,
        type: $281a441cdcb2cf36$var$userActionStartByApiCallEventName
    };
}
var $281a441cdcb2cf36$var$processUserEventHandler, $281a441cdcb2cf36$var$UserActionInstrumentation;
var $281a441cdcb2cf36$var$init_instrumentation7 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/userActions/instrumentation.js" () {
        $281a441cdcb2cf36$var$init_esm4();
        $281a441cdcb2cf36$var$init_const11();
        $281a441cdcb2cf36$var$init_processUserActionEventHandler();
        $281a441cdcb2cf36$var$UserActionInstrumentation = class extends $281a441cdcb2cf36$var$BaseInstrumentation {
            constructor(){
                super(...arguments);
                this.name = "@grafana/faro-web-sdk:instrumentation-user-action";
                this.version = $281a441cdcb2cf36$var$VERSION4;
            }
            initialize() {
                $281a441cdcb2cf36$var$processUserEventHandler = $281a441cdcb2cf36$var$getUserEventHandler($281a441cdcb2cf36$var$faro);
                window.addEventListener("pointerdown", $281a441cdcb2cf36$var$processUserEventHandler);
                window.addEventListener("keydown", $281a441cdcb2cf36$var$processUserEventHandler);
            }
        };
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/userActions/index.js
var $281a441cdcb2cf36$var$init_userActions = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/userActions/index.js" () {
        $281a441cdcb2cf36$var$init_instrumentation7();
        $281a441cdcb2cf36$var$init_const11();
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/csp/instrumentation.js
var $281a441cdcb2cf36$var$CSPInstrumentation;
var $281a441cdcb2cf36$var$init_instrumentation8 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/csp/instrumentation.js" () {
        $281a441cdcb2cf36$var$init_esm4();
        $281a441cdcb2cf36$var$CSPInstrumentation = class extends $281a441cdcb2cf36$var$BaseInstrumentation {
            constructor(){
                super();
                this.name = "@grafana/faro-web-sdk:instrumentation-csp";
                this.version = $281a441cdcb2cf36$var$VERSION4;
            }
            initialize() {
                document.addEventListener("securitypolicyviolation", this.securitypolicyviolationHandler.bind(this));
            }
            destroy() {
                document.removeEventListener("securitypolicyviolation", this.securitypolicyviolationHandler);
            }
            securitypolicyviolationHandler(ev) {
                this.api.pushEvent("securitypolicyviolation", $281a441cdcb2cf36$var$stringifyObjectValues(ev));
            }
        };
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/csp/index.js
var $281a441cdcb2cf36$var$init_csp = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/csp/index.js" () {
        $281a441cdcb2cf36$var$init_instrumentation8();
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/index.js
var $281a441cdcb2cf36$var$init_instrumentations2 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/instrumentations/index.js" () {
        $281a441cdcb2cf36$var$init_session2();
        $281a441cdcb2cf36$var$init_console();
        $281a441cdcb2cf36$var$init_errors();
        $281a441cdcb2cf36$var$init_view();
        $281a441cdcb2cf36$var$init_webVitals();
        $281a441cdcb2cf36$var$init_performance();
        $281a441cdcb2cf36$var$init_userActions();
        $281a441cdcb2cf36$var$init_csp();
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/config/getWebInstrumentations.js
function $281a441cdcb2cf36$var$getWebInstrumentations(options = {}) {
    const instrumentations = [
        new $281a441cdcb2cf36$var$UserActionInstrumentation(),
        new $281a441cdcb2cf36$var$ErrorsInstrumentation(),
        new $281a441cdcb2cf36$var$WebVitalsInstrumentation(),
        new $281a441cdcb2cf36$var$SessionInstrumentation(),
        new $281a441cdcb2cf36$var$ViewInstrumentation()
    ];
    if (options.enablePerformanceInstrumentation !== false) instrumentations.unshift(new $281a441cdcb2cf36$var$PerformanceInstrumentation());
    if (options.enableContentSecurityPolicyInstrumentation !== false) instrumentations.push(new $281a441cdcb2cf36$var$CSPInstrumentation());
    if (options.captureConsole !== false) instrumentations.push(new $281a441cdcb2cf36$var$ConsoleInstrumentation({
        disabledLevels: options.captureConsoleDisabledLevels
    }));
    return instrumentations;
}
var $281a441cdcb2cf36$var$init_getWebInstrumentations = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/config/getWebInstrumentations.js" () {
        $281a441cdcb2cf36$var$init_instrumentations2();
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/consts.js
var $281a441cdcb2cf36$var$defaultEventDomain;
var $281a441cdcb2cf36$var$init_consts2 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/consts.js" () {
        $281a441cdcb2cf36$var$defaultEventDomain = "browser";
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/metas/k6/meta.js
var $281a441cdcb2cf36$var$k6Meta;
var $281a441cdcb2cf36$var$init_meta4 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/metas/k6/meta.js" () {
        $281a441cdcb2cf36$var$k6Meta = ()=>{
            const k6Properties = window.k6;
            return {
                k6: Object.assign({
                    // we only add the k6 meta if Faro is running inside a k6 environment, so this is always true
                    isK6Browser: true
                }, (k6Properties === null || k6Properties === void 0 ? void 0 : k6Properties.testRunId) && {
                    testRunId: k6Properties === null || k6Properties === void 0 ? void 0 : k6Properties.testRunId
                })
            };
        };
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/metas/k6/index.js
var $281a441cdcb2cf36$var$init_k6 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/metas/k6/index.js" () {
        $281a441cdcb2cf36$var$init_meta4();
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/metas/page/meta.js
function $281a441cdcb2cf36$var$createPageMeta({ generatePageId: generatePageId, initialPageMeta: initialPageMeta } = {}) {
    const pageMeta = ()=>{
        const locationHref = location.href;
        if ($281a441cdcb2cf36$var$isFunction3(generatePageId) && $281a441cdcb2cf36$var$currentHref !== locationHref) {
            $281a441cdcb2cf36$var$currentHref = locationHref;
            $281a441cdcb2cf36$var$pageId = generatePageId(location);
        }
        return {
            page: Object.assign(Object.assign({
                url: locationHref
            }, $281a441cdcb2cf36$var$pageId ? {
                id: $281a441cdcb2cf36$var$pageId
            } : {}), initialPageMeta)
        };
    };
    return pageMeta;
}
var $281a441cdcb2cf36$var$currentHref, $281a441cdcb2cf36$var$pageId;
var $281a441cdcb2cf36$var$init_meta5 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/metas/page/meta.js" () {
        $281a441cdcb2cf36$var$init_esm4();
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/metas/page/index.js
var $281a441cdcb2cf36$var$init_page = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/metas/page/index.js" () {
        $281a441cdcb2cf36$var$init_meta5();
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/transports/console/transport.js
var $281a441cdcb2cf36$var$ConsoleTransport;
var $281a441cdcb2cf36$var$init_transport = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/transports/console/transport.js" () {
        $281a441cdcb2cf36$var$init_esm4();
        $281a441cdcb2cf36$var$ConsoleTransport = class extends $281a441cdcb2cf36$var$BaseTransport {
            constructor(options = {}){
                super();
                this.options = options;
                this.name = "@grafana/faro-web-sdk:transport-console";
                this.version = $281a441cdcb2cf36$var$VERSION4;
            }
            send(item) {
                var _a2;
                return this.unpatchedConsole[(_a2 = this.options.level) !== null && _a2 !== void 0 ? _a2 : $281a441cdcb2cf36$var$LogLevel.DEBUG]("New event", $281a441cdcb2cf36$var$getTransportBody([
                    item
                ]));
            }
        };
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/transports/console/index.js
var $281a441cdcb2cf36$var$init_console2 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/transports/console/index.js" () {
        $281a441cdcb2cf36$var$init_transport();
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/transports/fetch/transport.js
var $281a441cdcb2cf36$var$__awaiter2, $281a441cdcb2cf36$var$__rest, $281a441cdcb2cf36$var$DEFAULT_BUFFER_SIZE, $281a441cdcb2cf36$var$DEFAULT_CONCURRENCY, $281a441cdcb2cf36$var$DEFAULT_RATE_LIMIT_BACKOFF_MS, $281a441cdcb2cf36$var$BEACON_BODY_SIZE_LIMIT, $281a441cdcb2cf36$var$TOO_MANY_REQUESTS, $281a441cdcb2cf36$var$ACCEPTED, $281a441cdcb2cf36$var$FetchTransport;
var $281a441cdcb2cf36$var$init_transport2 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/transports/fetch/transport.js" () {
        $281a441cdcb2cf36$var$init_esm4();
        $281a441cdcb2cf36$var$init_sessionManager();
        $281a441cdcb2cf36$var$init_sessionManagerUtils();
        $281a441cdcb2cf36$var$__awaiter2 = function(thisArg, _arguments, P3, generator) {
            function adopt(value2) {
                return value2 instanceof P3 ? value2 : new P3(function(resolve) {
                    resolve(value2);
                });
            }
            return new (P3 || (P3 = Promise))(function(resolve, reject) {
                function fulfilled(value2) {
                    try {
                        step(generator.next(value2));
                    } catch (e4) {
                        reject(e4);
                    }
                }
                function rejected(value2) {
                    try {
                        step(generator["throw"](value2));
                    } catch (e4) {
                        reject(e4);
                    }
                }
                function step(result) {
                    result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                }
                step((generator = generator.apply(thisArg, _arguments || [])).next());
            });
        };
        $281a441cdcb2cf36$var$__rest = function(s3, e4) {
            var t4 = {};
            for(var p3 in s3)if (Object.prototype.hasOwnProperty.call(s3, p3) && e4.indexOf(p3) < 0) t4[p3] = s3[p3];
            if (s3 != null && typeof Object.getOwnPropertySymbols === "function") {
                for(var i3 = 0, p3 = Object.getOwnPropertySymbols(s3); i3 < p3.length; i3++)if (e4.indexOf(p3[i3]) < 0 && Object.prototype.propertyIsEnumerable.call(s3, p3[i3])) t4[p3[i3]] = s3[p3[i3]];
            }
            return t4;
        };
        $281a441cdcb2cf36$var$DEFAULT_BUFFER_SIZE = 30;
        $281a441cdcb2cf36$var$DEFAULT_CONCURRENCY = 5;
        $281a441cdcb2cf36$var$DEFAULT_RATE_LIMIT_BACKOFF_MS = 5e3;
        $281a441cdcb2cf36$var$BEACON_BODY_SIZE_LIMIT = 6e4;
        $281a441cdcb2cf36$var$TOO_MANY_REQUESTS = 429;
        $281a441cdcb2cf36$var$ACCEPTED = 202;
        $281a441cdcb2cf36$var$FetchTransport = class extends $281a441cdcb2cf36$var$BaseTransport {
            constructor(options){
                var _a2, _b, _c, _d;
                super();
                this.options = options;
                this.name = "@grafana/faro-web-sdk:transport-fetch";
                this.version = $281a441cdcb2cf36$var$VERSION4;
                this.disabledUntil = /* @__PURE__ */ new Date();
                this.rateLimitBackoffMs = (_a2 = options.defaultRateLimitBackoffMs) !== null && _a2 !== void 0 ? _a2 : $281a441cdcb2cf36$var$DEFAULT_RATE_LIMIT_BACKOFF_MS;
                this.getNow = (_b = options.getNow) !== null && _b !== void 0 ? _b : ()=>Date.now();
                this.promiseBuffer = $281a441cdcb2cf36$var$createPromiseBuffer({
                    size: (_c = options.bufferSize) !== null && _c !== void 0 ? _c : $281a441cdcb2cf36$var$DEFAULT_BUFFER_SIZE,
                    concurrency: (_d = options.concurrency) !== null && _d !== void 0 ? _d : $281a441cdcb2cf36$var$DEFAULT_CONCURRENCY
                });
            }
            send(items) {
                return $281a441cdcb2cf36$var$__awaiter2(this, void 0, void 0, function*() {
                    try {
                        if (this.disabledUntil > new Date(this.getNow())) {
                            this.logWarn(`Dropping transport item due to too many requests. Backoff until ${this.disabledUntil}`);
                            return Promise.resolve();
                        }
                        yield this.promiseBuffer.add(()=>{
                            const body = JSON.stringify($281a441cdcb2cf36$var$getTransportBody(items));
                            const { url: url2, requestOptions: requestOptions, apiKey: apiKey } = this.options;
                            const _a2 = requestOptions !== null && requestOptions !== void 0 ? requestOptions : {}, { headers: headers } = _a2, restOfRequestOptions = $281a441cdcb2cf36$var$__rest(_a2, [
                                "headers"
                            ]);
                            let sessionId;
                            const sessionMeta = this.metas.value.session;
                            if (sessionMeta != null) sessionId = sessionMeta.id;
                            return fetch(url2, Object.assign({
                                method: "POST",
                                headers: Object.assign(Object.assign(Object.assign({
                                    "Content-Type": "application/json"
                                }, headers !== null && headers !== void 0 ? headers : {}), apiKey ? {
                                    "x-api-key": apiKey
                                } : {}), sessionId ? {
                                    "x-faro-session-id": sessionId
                                } : {}),
                                body: body,
                                keepalive: body.length <= $281a441cdcb2cf36$var$BEACON_BODY_SIZE_LIMIT
                            }, restOfRequestOptions !== null && restOfRequestOptions !== void 0 ? restOfRequestOptions : {})).then((response)=>$281a441cdcb2cf36$var$__awaiter2(this, void 0, void 0, function*() {
                                    if (response.status === $281a441cdcb2cf36$var$ACCEPTED) {
                                        const sessionExpired = response.headers.get("X-Faro-Session-Status") === "invalid";
                                        if (sessionExpired) this.extendFaroSession(this.config, this.logDebug);
                                    }
                                    if (response.status === $281a441cdcb2cf36$var$TOO_MANY_REQUESTS) {
                                        this.disabledUntil = this.getRetryAfterDate(response);
                                        this.logWarn(`Too many requests, backing off until ${this.disabledUntil}`);
                                    }
                                    response.text().catch($281a441cdcb2cf36$var$noop2);
                                    return response;
                                })).catch((err)=>{
                                this.logError("Failed sending payload to the receiver\n", JSON.parse(body), err);
                            });
                        });
                    } catch (err) {
                        this.logError(err);
                    }
                });
            }
            getIgnoreUrls() {
                var _a2;
                return [
                    this.options.url
                ].concat((_a2 = this.config.ignoreUrls) !== null && _a2 !== void 0 ? _a2 : []);
            }
            isBatched() {
                return true;
            }
            getRetryAfterDate(response) {
                const now = this.getNow();
                const retryAfterHeader = response.headers.get("Retry-After");
                if (retryAfterHeader) {
                    const delay = Number(retryAfterHeader);
                    if (!isNaN(delay)) return new Date(delay * 1e3 + now);
                    const date = Date.parse(retryAfterHeader);
                    if (!isNaN(date)) return new Date(date);
                }
                return new Date(now + this.rateLimitBackoffMs);
            }
            extendFaroSession(config, logDebug) {
                const SessionExpiredString = `Session expired`;
                const sessionTrackingConfig = config.sessionTracking;
                if (sessionTrackingConfig === null || sessionTrackingConfig === void 0 ? void 0 : sessionTrackingConfig.enabled) {
                    const { fetchUserSession: fetchUserSession, storeUserSession: storeUserSession } = $281a441cdcb2cf36$var$getSessionManagerByConfig(sessionTrackingConfig);
                    $281a441cdcb2cf36$var$getUserSessionUpdater({
                        fetchUserSession: fetchUserSession,
                        storeUserSession: storeUserSession
                    })({
                        forceSessionExtend: true
                    });
                    logDebug(`${SessionExpiredString} created new session.`);
                } else logDebug(`${SessionExpiredString}.`);
            }
        };
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/transports/fetch/index.js
var $281a441cdcb2cf36$var$init_fetch = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/transports/fetch/index.js" () {
        $281a441cdcb2cf36$var$init_transport2();
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/transports/index.js
var $281a441cdcb2cf36$var$init_transports2 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/transports/index.js" () {
        $281a441cdcb2cf36$var$init_console2();
        $281a441cdcb2cf36$var$init_fetch();
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/config/makeCoreConfig.js
function $281a441cdcb2cf36$var$makeCoreConfig(browserConfig) {
    var _a2;
    const transports2 = [];
    const internalLogger2 = $281a441cdcb2cf36$var$createInternalLogger(browserConfig.unpatchedConsole, browserConfig.internalLoggerLevel);
    if (browserConfig.transports) {
        if (browserConfig.url || browserConfig.apiKey) internalLogger2.error('if "transports" is defined, "url" and "apiKey" should not be defined');
        transports2.push(...browserConfig.transports);
    } else if (browserConfig.url) transports2.push(new $281a441cdcb2cf36$var$FetchTransport({
        url: browserConfig.url,
        apiKey: browserConfig.apiKey
    }));
    else internalLogger2.error('either "url" or "transports" must be defined');
    const { dedupe: // properties with default values
    dedupe = true, eventDomain: eventDomain = $281a441cdcb2cf36$var$defaultEventDomain, globalObjectKey: globalObjectKey = $281a441cdcb2cf36$var$defaultGlobalObjectKey, instrumentations: instrumentations = $281a441cdcb2cf36$var$getWebInstrumentations(), internalLoggerLevel: internalLoggerLevel = $281a441cdcb2cf36$var$defaultInternalLoggerLevel, isolate: isolate = false, logArgsSerializer: logArgsSerializer = $281a441cdcb2cf36$var$defaultLogArgsSerializer, metas: metas = $281a441cdcb2cf36$var$createDefaultMetas(browserConfig), paused: paused = false, preventGlobalExposure: preventGlobalExposure = false, unpatchedConsole: unpatchedConsole2 = $281a441cdcb2cf36$var$defaultUnpatchedConsole, trackUserActionsPreview: trackUserActionsPreview = false, trackUserActionsDataAttributeName: trackUserActionsDataAttributeName = $281a441cdcb2cf36$var$userActionDataAttribute, url: browserConfigUrl } = browserConfig, restProperties = $281a441cdcb2cf36$var$__rest2(browserConfig, [
        "dedupe",
        "eventDomain",
        "globalObjectKey",
        "instrumentations",
        "internalLoggerLevel",
        "isolate",
        "logArgsSerializer",
        "metas",
        "paused",
        "preventGlobalExposure",
        "unpatchedConsole",
        "trackUserActionsPreview",
        "trackUserActionsDataAttributeName",
        "url"
    ]);
    return Object.assign(Object.assign({}, restProperties), {
        batching: Object.assign(Object.assign({}, $281a441cdcb2cf36$var$defaultBatchingConfig), browserConfig.batching),
        dedupe: dedupe,
        globalObjectKey: globalObjectKey,
        instrumentations: $281a441cdcb2cf36$var$getFilteredInstrumentations(instrumentations, browserConfig),
        internalLoggerLevel: internalLoggerLevel,
        isolate: isolate,
        logArgsSerializer: logArgsSerializer,
        metas: metas,
        parseStacktrace: $281a441cdcb2cf36$var$parseStacktrace,
        paused: paused,
        preventGlobalExposure: preventGlobalExposure,
        transports: transports2,
        unpatchedConsole: unpatchedConsole2,
        eventDomain: eventDomain,
        ignoreUrls: [
            ...(_a2 = browserConfig.ignoreUrls) !== null && _a2 !== void 0 ? _a2 : [],
            // ignore configured cloud collector url by default
            ...browserConfigUrl ? [
                browserConfigUrl
            ] : [],
            // Try our best to exclude collector URLs form other Faro instances. By default these are URLs ending with /collect or /collect/ followed by alphanumeric characters.
            /\/collect(?:\/[\w]*)?$/
        ],
        sessionTracking: Object.assign(Object.assign(Object.assign({}, $281a441cdcb2cf36$var$defaultSessionTrackingConfig), browserConfig.sessionTracking), $281a441cdcb2cf36$var$crateSessionMeta({
            trackGeolocation: browserConfig.trackGeolocation,
            sessionTracking: browserConfig.sessionTracking
        })),
        trackUserActionsPreview: trackUserActionsPreview,
        trackUserActionsDataAttributeName: trackUserActionsDataAttributeName
    });
}
function $281a441cdcb2cf36$var$getFilteredInstrumentations(instrumentations, { trackUserActionsPreview: trackUserActionsPreview }) {
    return instrumentations.filter((instr)=>{
        if (instr.name === "@grafana/faro-web-sdk:instrumentation-user-action" && !trackUserActionsPreview) return false;
        return true;
    });
}
function $281a441cdcb2cf36$var$createDefaultMetas(browserConfig) {
    var _a2, _b;
    const { page: page, generatePageId: generatePageId } = (_a2 = browserConfig === null || browserConfig === void 0 ? void 0 : browserConfig.pageTracking) !== null && _a2 !== void 0 ? _a2 : {};
    const initialMetas = [
        $281a441cdcb2cf36$var$browserMeta,
        $281a441cdcb2cf36$var$createPageMeta({
            generatePageId: generatePageId,
            initialPageMeta: page
        }),
        ...(_b = browserConfig.metas) !== null && _b !== void 0 ? _b : []
    ];
    const isK6BrowserSession = $281a441cdcb2cf36$var$isObject4(window.k6);
    if (isK6BrowserSession) return [
        ...initialMetas,
        $281a441cdcb2cf36$var$k6Meta
    ];
    return initialMetas;
}
function $281a441cdcb2cf36$var$crateSessionMeta({ trackGeolocation: trackGeolocation, sessionTracking: sessionTracking }) {
    var _a2;
    const overrides = {};
    if ($281a441cdcb2cf36$var$isBoolean(trackGeolocation)) overrides.geoLocationTrackingEnabled = trackGeolocation;
    if ($281a441cdcb2cf36$var$isEmpty2(overrides)) return {};
    return {
        session: Object.assign(Object.assign({}, (_a2 = sessionTracking === null || sessionTracking === void 0 ? void 0 : sessionTracking.session) !== null && _a2 !== void 0 ? _a2 : {}), {
            overrides: overrides
        })
    };
}
var $281a441cdcb2cf36$var$__rest2;
var $281a441cdcb2cf36$var$init_makeCoreConfig = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/config/makeCoreConfig.js" () {
        $281a441cdcb2cf36$var$init_esm4();
        $281a441cdcb2cf36$var$init_consts2();
        $281a441cdcb2cf36$var$init_instrumentations2();
        $281a441cdcb2cf36$var$init_session2();
        $281a441cdcb2cf36$var$init_const11();
        $281a441cdcb2cf36$var$init_metas2();
        $281a441cdcb2cf36$var$init_k6();
        $281a441cdcb2cf36$var$init_page();
        $281a441cdcb2cf36$var$init_transports2();
        $281a441cdcb2cf36$var$init_getWebInstrumentations();
        $281a441cdcb2cf36$var$__rest2 = function(s3, e4) {
            var t4 = {};
            for(var p3 in s3)if (Object.prototype.hasOwnProperty.call(s3, p3) && e4.indexOf(p3) < 0) t4[p3] = s3[p3];
            if (s3 != null && typeof Object.getOwnPropertySymbols === "function") {
                for(var i3 = 0, p3 = Object.getOwnPropertySymbols(s3); i3 < p3.length; i3++)if (e4.indexOf(p3[i3]) < 0 && Object.prototype.propertyIsEnumerable.call(s3, p3[i3])) t4[p3[i3]] = s3[p3[i3]];
            }
            return t4;
        };
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/config/index.js
var $281a441cdcb2cf36$var$init_config2 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/config/index.js" () {
        $281a441cdcb2cf36$var$init_getWebInstrumentations();
        $281a441cdcb2cf36$var$init_makeCoreConfig();
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/initialize.js
function $281a441cdcb2cf36$var$initializeFaro2(config) {
    const coreConfig = $281a441cdcb2cf36$var$makeCoreConfig(config);
    if (!coreConfig) return void 0;
    return $281a441cdcb2cf36$var$initializeFaro(coreConfig);
}
var $281a441cdcb2cf36$var$init_initialize14 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/initialize.js" () {
        $281a441cdcb2cf36$var$init_esm4();
        $281a441cdcb2cf36$var$init_config2();
    }
});
// ../node_modules/@grafana/faro-web-sdk/dist/esm/index.js
var $281a441cdcb2cf36$var$esm_exports4 = {};
$281a441cdcb2cf36$var$__export($281a441cdcb2cf36$var$esm_exports4, {
    BaseExtension: ()=>$281a441cdcb2cf36$var$BaseExtension,
    BaseInstrumentation: ()=>$281a441cdcb2cf36$var$BaseInstrumentation,
    BaseTransport: ()=>$281a441cdcb2cf36$var$BaseTransport,
    CSPInstrumentation: ()=>$281a441cdcb2cf36$var$CSPInstrumentation,
    ConsoleInstrumentation: ()=>$281a441cdcb2cf36$var$ConsoleInstrumentation,
    ConsoleTransport: ()=>$281a441cdcb2cf36$var$ConsoleTransport,
    Conventions: ()=>$281a441cdcb2cf36$var$Conventions,
    EVENT_CLICK: ()=>$281a441cdcb2cf36$var$EVENT_CLICK,
    EVENT_NAVIGATION: ()=>$281a441cdcb2cf36$var$EVENT_NAVIGATION,
    EVENT_ROUTE_CHANGE: ()=>$281a441cdcb2cf36$var$EVENT_ROUTE_CHANGE,
    EVENT_SESSION_EXTEND: ()=>$281a441cdcb2cf36$var$EVENT_SESSION_EXTEND,
    EVENT_SESSION_RESUME: ()=>$281a441cdcb2cf36$var$EVENT_SESSION_RESUME,
    EVENT_SESSION_START: ()=>$281a441cdcb2cf36$var$EVENT_SESSION_START,
    EVENT_VIEW_CHANGED: ()=>$281a441cdcb2cf36$var$EVENT_VIEW_CHANGED,
    ErrorsInstrumentation: ()=>$281a441cdcb2cf36$var$ErrorsInstrumentation,
    FetchTransport: ()=>$281a441cdcb2cf36$var$FetchTransport,
    InternalLoggerLevel: ()=>$281a441cdcb2cf36$var$InternalLoggerLevel,
    LogLevel: ()=>$281a441cdcb2cf36$var$LogLevel,
    MAX_SESSION_PERSISTENCE_TIME: ()=>$281a441cdcb2cf36$var$MAX_SESSION_PERSISTENCE_TIME,
    MAX_SESSION_PERSISTENCE_TIME_BUFFER: ()=>$281a441cdcb2cf36$var$MAX_SESSION_PERSISTENCE_TIME_BUFFER,
    Observable: ()=>$281a441cdcb2cf36$var$Observable2,
    PerformanceInstrumentation: ()=>$281a441cdcb2cf36$var$PerformanceInstrumentation,
    PersistentSessionsManager: ()=>$281a441cdcb2cf36$var$PersistentSessionsManager,
    SESSION_EXPIRATION_TIME: ()=>$281a441cdcb2cf36$var$SESSION_EXPIRATION_TIME,
    SESSION_INACTIVITY_TIME: ()=>$281a441cdcb2cf36$var$SESSION_INACTIVITY_TIME,
    STORAGE_KEY: ()=>$281a441cdcb2cf36$var$STORAGE_KEY,
    SessionInstrumentation: ()=>$281a441cdcb2cf36$var$SessionInstrumentation,
    TransportItemType: ()=>$281a441cdcb2cf36$var$TransportItemType,
    USER_ACTION_CANCEL: ()=>$281a441cdcb2cf36$var$USER_ACTION_CANCEL,
    USER_ACTION_END: ()=>$281a441cdcb2cf36$var$USER_ACTION_END,
    USER_ACTION_HALT: ()=>$281a441cdcb2cf36$var$USER_ACTION_HALT,
    USER_ACTION_START: ()=>$281a441cdcb2cf36$var$USER_ACTION_START,
    UserActionInstrumentation: ()=>$281a441cdcb2cf36$var$UserActionInstrumentation,
    VERSION: ()=>$281a441cdcb2cf36$var$VERSION4,
    ViewInstrumentation: ()=>$281a441cdcb2cf36$var$ViewInstrumentation,
    VolatileSessionsManager: ()=>$281a441cdcb2cf36$var$VolatileSessionsManager,
    WebVitalsInstrumentation: ()=>$281a441cdcb2cf36$var$WebVitalsInstrumentation,
    allLogLevels: ()=>$281a441cdcb2cf36$var$allLogLevels,
    apiMessageBus: ()=>$281a441cdcb2cf36$var$apiMessageBus,
    browserMeta: ()=>$281a441cdcb2cf36$var$browserMeta,
    buildStackFrame: ()=>$281a441cdcb2cf36$var$buildStackFrame,
    createInternalLogger: ()=>$281a441cdcb2cf36$var$createInternalLogger,
    createPromiseBuffer: ()=>$281a441cdcb2cf36$var$createPromiseBuffer,
    createSession: ()=>$281a441cdcb2cf36$var$createSession,
    deepEqual: ()=>$281a441cdcb2cf36$var$deepEqual2,
    defaultEventDomain: ()=>$281a441cdcb2cf36$var$defaultEventDomain,
    defaultExceptionType: ()=>$281a441cdcb2cf36$var$defaultExceptionType,
    defaultGlobalObjectKey: ()=>$281a441cdcb2cf36$var$defaultGlobalObjectKey,
    defaultInternalLoggerLevel: ()=>$281a441cdcb2cf36$var$defaultInternalLoggerLevel,
    defaultLogLevel: ()=>$281a441cdcb2cf36$var$defaultLogLevel,
    faro: ()=>$281a441cdcb2cf36$var$faro,
    genShortID: ()=>$281a441cdcb2cf36$var$genShortID,
    getCurrentTimestamp: ()=>$281a441cdcb2cf36$var$getCurrentTimestamp,
    getDataFromSafariExtensions: ()=>$281a441cdcb2cf36$var$getDataFromSafariExtensions,
    getIgnoreUrls: ()=>$281a441cdcb2cf36$var$getIgnoreUrls,
    getInternalFaroFromGlobalObject: ()=>$281a441cdcb2cf36$var$getInternalFromGlobalObject,
    getStackFramesFromError: ()=>$281a441cdcb2cf36$var$getStackFramesFromError,
    getTransportBody: ()=>$281a441cdcb2cf36$var$getTransportBody,
    getUrlFromResource: ()=>$281a441cdcb2cf36$var$getUrlFromResource,
    getWebInstrumentations: ()=>$281a441cdcb2cf36$var$getWebInstrumentations,
    globalObject: ()=>$281a441cdcb2cf36$var$globalObject,
    initializeFaro: ()=>$281a441cdcb2cf36$var$initializeFaro2,
    internalGlobalObjectKey: ()=>$281a441cdcb2cf36$var$internalGlobalObjectKey,
    isArray: ()=>$281a441cdcb2cf36$var$isArray4,
    isBoolean: ()=>$281a441cdcb2cf36$var$isBoolean,
    isDomError: ()=>$281a441cdcb2cf36$var$isDomError,
    isDomException: ()=>$281a441cdcb2cf36$var$isDomException,
    isElement: ()=>$281a441cdcb2cf36$var$isElement,
    isElementDefined: ()=>$281a441cdcb2cf36$var$isElementDefined,
    isEmpty: ()=>$281a441cdcb2cf36$var$isEmpty2,
    isError: ()=>$281a441cdcb2cf36$var$isError,
    isErrorDefined: ()=>$281a441cdcb2cf36$var$isErrorDefined,
    isErrorEvent: ()=>$281a441cdcb2cf36$var$isErrorEvent,
    isEvent: ()=>$281a441cdcb2cf36$var$isEvent,
    isEventDefined: ()=>$281a441cdcb2cf36$var$isEventDefined,
    isFunction: ()=>$281a441cdcb2cf36$var$isFunction3,
    isInstanceOf: ()=>$281a441cdcb2cf36$var$isInstanceOf,
    isInt: ()=>$281a441cdcb2cf36$var$isInt,
    isInternalFaroOnGlobalObject: ()=>$281a441cdcb2cf36$var$isInternalFaroOnGlobalObject,
    isMap: ()=>$281a441cdcb2cf36$var$isMap,
    isMapDefined: ()=>$281a441cdcb2cf36$var$isMapDefined,
    isNull: ()=>$281a441cdcb2cf36$var$isNull,
    isNumber: ()=>$281a441cdcb2cf36$var$isNumber,
    isObject: ()=>$281a441cdcb2cf36$var$isObject4,
    isPrimitive: ()=>$281a441cdcb2cf36$var$isPrimitive2,
    isRegExp: ()=>$281a441cdcb2cf36$var$isRegExp,
    isString: ()=>$281a441cdcb2cf36$var$isString,
    isSymbol: ()=>$281a441cdcb2cf36$var$isSymbol,
    isSyntheticEvent: ()=>$281a441cdcb2cf36$var$isSyntheticEvent,
    isThenable: ()=>$281a441cdcb2cf36$var$isThenable,
    isToString: ()=>$281a441cdcb2cf36$var$isToString,
    isTypeof: ()=>$281a441cdcb2cf36$var$isTypeof,
    isUndefined: ()=>$281a441cdcb2cf36$var$isUndefined,
    makeCoreConfig: ()=>$281a441cdcb2cf36$var$makeCoreConfig,
    noop: ()=>$281a441cdcb2cf36$var$noop2,
    parseStacktrace: ()=>$281a441cdcb2cf36$var$parseStacktrace,
    sdkMeta: ()=>$281a441cdcb2cf36$var$sdkMeta,
    setInternalFaroOnGlobalObject: ()=>$281a441cdcb2cf36$var$setInternalFaroOnGlobalObject,
    startUserAction: ()=>$281a441cdcb2cf36$var$startUserAction,
    transportItemTypeToBodyKey: ()=>$281a441cdcb2cf36$var$transportItemTypeToBodyKey,
    unknownString: ()=>$281a441cdcb2cf36$var$unknownString,
    userActionDataAttribute: ()=>$281a441cdcb2cf36$var$userActionDataAttribute
});
var $281a441cdcb2cf36$var$init_esm5 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-sdk/dist/esm/index.js" () {
        $281a441cdcb2cf36$var$init_config2();
        $281a441cdcb2cf36$var$init_consts2();
        $281a441cdcb2cf36$var$init_initialize14();
        $281a441cdcb2cf36$var$init_instrumentations2();
        $281a441cdcb2cf36$var$init_metas2();
        $281a441cdcb2cf36$var$init_transports2();
        $281a441cdcb2cf36$var$init_esm4();
        $281a441cdcb2cf36$var$init_session2();
        $281a441cdcb2cf36$var$init_url();
        $281a441cdcb2cf36$var$init_userActions();
    }
});
// ../node_modules/@grafana/faro-web-tracing/dist/esm/faroTraceExporter.utils.js
function $281a441cdcb2cf36$var$sendFaroEvents(resourceSpans = []) {
    var _a2, _b;
    for (const resourceSpan of resourceSpans){
        const { scopeSpans: scopeSpans } = resourceSpan;
        for (const scopeSpan of scopeSpans){
            const { scope: scope, spans: spans = [] } = scopeSpan;
            for (const span of spans){
                if (span.kind !== $281a441cdcb2cf36$var$import_internal_types.ESpanKind.SPAN_KIND_CLIENT) continue;
                const spanContext = {
                    traceId: span.traceId.toString(),
                    spanId: span.spanId.toString()
                };
                const faroEventAttributes = {};
                for (const attribute of span.attributes)faroEventAttributes[attribute.key] = String(Object.values(attribute.value)[0]);
                if (!Number.isNaN(span.endTimeUnixNano) && !Number.isNaN(span.startTimeUnixNano)) faroEventAttributes[$281a441cdcb2cf36$var$DURATION_NS_KEY] = String(Number(span.endTimeUnixNano) - Number(span.startTimeUnixNano));
                const index = ((_a2 = scope === null || scope === void 0 ? void 0 : scope.name) !== null && _a2 !== void 0 ? _a2 : "").indexOf("-");
                let eventName = $281a441cdcb2cf36$var$unknownString;
                if (scope === null || scope === void 0 ? void 0 : scope.name) {
                    if (index === -1) eventName = (_b = scope.name.split("/")[1]) !== null && _b !== void 0 ? _b : scope.name;
                    if (index > -1) eventName = scope === null || scope === void 0 ? void 0 : scope.name.substring(index + 1);
                }
                $281a441cdcb2cf36$var$faro.api.pushEvent(`faro.tracing.${eventName}`, faroEventAttributes, void 0, {
                    spanContext: spanContext,
                    // Convert nanoseconds to milliseconds
                    timestampOverwriteMs: Number(span.endTimeUnixNano) / 1e6,
                    customPayloadTransformer: (payload)=>{
                        var _a3, _b2;
                        if (faroEventAttributes["faro.action.user.name"] != null && faroEventAttributes["faro.action.user.parentId"] != null) {
                            payload.action = {
                                name: faroEventAttributes["faro.action.user.name"],
                                parentId: faroEventAttributes["faro.action.user.parentId"]
                            };
                            (_a3 = payload.attributes) === null || _a3 === void 0 || delete _a3["faro.action.user.name"];
                            (_b2 = payload.attributes) === null || _b2 === void 0 || delete _b2["faro.action.user.parentId"];
                        }
                        return payload;
                    }
                });
            }
        }
    }
}
var $281a441cdcb2cf36$var$import_internal_types, $281a441cdcb2cf36$var$DURATION_NS_KEY;
var $281a441cdcb2cf36$var$init_faroTraceExporter_utils = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-tracing/dist/esm/faroTraceExporter.utils.js" () {
        $281a441cdcb2cf36$var$import_internal_types = $281a441cdcb2cf36$var$__toESM($281a441cdcb2cf36$var$require_internal_types());
        $281a441cdcb2cf36$var$init_esm5();
        $281a441cdcb2cf36$var$DURATION_NS_KEY = "duration_ns";
    }
});
// ../node_modules/@grafana/faro-web-tracing/dist/esm/faroTraceExporter.js
var $281a441cdcb2cf36$var$import_internal, $281a441cdcb2cf36$var$FaroTraceExporter;
var $281a441cdcb2cf36$var$init_faroTraceExporter = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-tracing/dist/esm/faroTraceExporter.js" () {
        $281a441cdcb2cf36$var$init_esm3();
        $281a441cdcb2cf36$var$import_internal = $281a441cdcb2cf36$var$__toESM($281a441cdcb2cf36$var$require_internal2());
        $281a441cdcb2cf36$var$init_faroTraceExporter_utils();
        $281a441cdcb2cf36$var$FaroTraceExporter = class {
            constructor(config){
                this.config = config;
            }
            export(spans, resultCallback) {
                const traceEvent = (0, $281a441cdcb2cf36$var$import_internal.createExportTraceServiceRequest)(spans, {
                    useHex: true,
                    useLongBits: false
                });
                this.config.api.pushTraces(traceEvent);
                $281a441cdcb2cf36$var$sendFaroEvents(traceEvent.resourceSpans);
                resultCallback({
                    code: $281a441cdcb2cf36$var$ExportResultCode.SUCCESS
                });
            }
            shutdown() {
                return Promise.resolve(void 0);
            }
        };
    }
});
// ../node_modules/@grafana/faro-web-tracing/dist/esm/semconv.js
var $281a441cdcb2cf36$var$ATTR_SESSION_ID, $281a441cdcb2cf36$var$ATTR_DEPLOYMENT_ENVIRONMENT_NAME, $281a441cdcb2cf36$var$ATTR_SERVICE_NAMESPACE2, $281a441cdcb2cf36$var$ATTR_PROCESS_RUNTIME_NAME2, $281a441cdcb2cf36$var$ATTR_PROCESS_RUNTIME_VERSION, $281a441cdcb2cf36$var$ATTR_TELEMETRY_DISTRO_NAME, $281a441cdcb2cf36$var$ATTR_TELEMETRY_DISTRO_VERSION, $281a441cdcb2cf36$var$ATTR_BROWSER_BRANDS, $281a441cdcb2cf36$var$ATTR_BROWSER_LANGUAGE, $281a441cdcb2cf36$var$ATTR_BROWSER_MOBILE, $281a441cdcb2cf36$var$ATTR_BROWSER_PLATFORM;
var $281a441cdcb2cf36$var$init_semconv2 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-tracing/dist/esm/semconv.js" () {
        $281a441cdcb2cf36$var$ATTR_SESSION_ID = "session.id";
        $281a441cdcb2cf36$var$ATTR_DEPLOYMENT_ENVIRONMENT_NAME = "deployment.environment.name";
        $281a441cdcb2cf36$var$ATTR_SERVICE_NAMESPACE2 = "service.namespace";
        $281a441cdcb2cf36$var$ATTR_PROCESS_RUNTIME_NAME2 = "process.runtime.name";
        $281a441cdcb2cf36$var$ATTR_PROCESS_RUNTIME_VERSION = "process.runtime.version";
        $281a441cdcb2cf36$var$ATTR_TELEMETRY_DISTRO_NAME = "telemetry.distro.name";
        $281a441cdcb2cf36$var$ATTR_TELEMETRY_DISTRO_VERSION = "telemetry.distro.version";
        $281a441cdcb2cf36$var$ATTR_BROWSER_BRANDS = "browser.brands";
        $281a441cdcb2cf36$var$ATTR_BROWSER_LANGUAGE = "browser.language";
        $281a441cdcb2cf36$var$ATTR_BROWSER_MOBILE = "browser.mobile";
        $281a441cdcb2cf36$var$ATTR_BROWSER_PLATFORM = "browser.platform";
    }
});
// ../node_modules/@grafana/faro-web-tracing/dist/esm/sessionSpanProcessor.js
var $281a441cdcb2cf36$var$FaroSessionSpanProcessor;
var $281a441cdcb2cf36$var$init_sessionSpanProcessor = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-tracing/dist/esm/sessionSpanProcessor.js" () {
        $281a441cdcb2cf36$var$init_semconv2();
        $281a441cdcb2cf36$var$FaroSessionSpanProcessor = class {
            constructor(processor, metas){
                this.processor = processor;
                this.metas = metas;
            }
            forceFlush() {
                return this.processor.forceFlush();
            }
            onStart(span, parentContext) {
                const session = this.metas.value.session;
                if (session === null || session === void 0 ? void 0 : session.id) {
                    span.attributes[$281a441cdcb2cf36$var$ATTR_SESSION_ID] = session.id;
                    span.attributes["session_id"] = session.id;
                }
                this.processor.onStart(span, parentContext);
            }
            onEnd(span) {
                this.processor.onEnd(span);
            }
            shutdown() {
                return this.processor.shutdown();
            }
        };
    }
});
// ../node_modules/@opentelemetry/api-logs/build/esm/NoopLogger.js
var $281a441cdcb2cf36$var$NoopLogger, $281a441cdcb2cf36$var$NOOP_LOGGER;
var $281a441cdcb2cf36$var$init_NoopLogger = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api-logs/build/esm/NoopLogger.js" () {
        $281a441cdcb2cf36$var$NoopLogger = class {
            emit(_logRecord) {}
        };
        $281a441cdcb2cf36$var$NOOP_LOGGER = new $281a441cdcb2cf36$var$NoopLogger();
    }
});
// ../node_modules/@opentelemetry/api-logs/build/esm/NoopLoggerProvider.js
var $281a441cdcb2cf36$var$NoopLoggerProvider, $281a441cdcb2cf36$var$NOOP_LOGGER_PROVIDER;
var $281a441cdcb2cf36$var$init_NoopLoggerProvider = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api-logs/build/esm/NoopLoggerProvider.js" () {
        $281a441cdcb2cf36$var$init_NoopLogger();
        $281a441cdcb2cf36$var$NoopLoggerProvider = class {
            getLogger(_name, _version, _options) {
                return new $281a441cdcb2cf36$var$NoopLogger();
            }
        };
        $281a441cdcb2cf36$var$NOOP_LOGGER_PROVIDER = new $281a441cdcb2cf36$var$NoopLoggerProvider();
    }
});
// ../node_modules/@opentelemetry/api-logs/build/esm/ProxyLogger.js
var $281a441cdcb2cf36$var$ProxyLogger;
var $281a441cdcb2cf36$var$init_ProxyLogger = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api-logs/build/esm/ProxyLogger.js" () {
        $281a441cdcb2cf36$var$init_NoopLogger();
        $281a441cdcb2cf36$var$ProxyLogger = class {
            constructor(_provider, name, version6, options){
                this._provider = _provider;
                this.name = name;
                this.version = version6;
                this.options = options;
            }
            /**
       * Emit a log record. This method should only be used by log appenders.
       *
       * @param logRecord
       */ emit(logRecord) {
                this._getLogger().emit(logRecord);
            }
            /**
       * Try to get a logger from the proxy logger provider.
       * If the proxy logger provider has no delegate, return a noop logger.
       */ _getLogger() {
                if (this._delegate) return this._delegate;
                const logger3 = this._provider.getDelegateLogger(this.name, this.version, this.options);
                if (!logger3) return $281a441cdcb2cf36$var$NOOP_LOGGER;
                this._delegate = logger3;
                return this._delegate;
            }
        };
    }
});
// ../node_modules/@opentelemetry/api-logs/build/esm/ProxyLoggerProvider.js
var $281a441cdcb2cf36$var$ProxyLoggerProvider;
var $281a441cdcb2cf36$var$init_ProxyLoggerProvider = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api-logs/build/esm/ProxyLoggerProvider.js" () {
        $281a441cdcb2cf36$var$init_NoopLoggerProvider();
        $281a441cdcb2cf36$var$init_ProxyLogger();
        $281a441cdcb2cf36$var$ProxyLoggerProvider = class {
            getLogger(name, version6, options) {
                var _a2;
                return (_a2 = this.getDelegateLogger(name, version6, options)) !== null && _a2 !== void 0 ? _a2 : new $281a441cdcb2cf36$var$ProxyLogger(this, name, version6, options);
            }
            getDelegate() {
                var _a2;
                return (_a2 = this._delegate) !== null && _a2 !== void 0 ? _a2 : $281a441cdcb2cf36$var$NOOP_LOGGER_PROVIDER;
            }
            /**
       * Set the delegate logger provider
       */ setDelegate(delegate) {
                this._delegate = delegate;
            }
            getDelegateLogger(name, version6, options) {
                var _a2;
                return (_a2 = this._delegate) === null || _a2 === void 0 ? void 0 : _a2.getLogger(name, version6, options);
            }
        };
    }
});
// ../node_modules/@opentelemetry/api-logs/build/esm/platform/browser/globalThis.js
var $281a441cdcb2cf36$var$_globalThis2;
var $281a441cdcb2cf36$var$init_globalThis = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api-logs/build/esm/platform/browser/globalThis.js" () {
        $281a441cdcb2cf36$var$_globalThis2 = typeof globalThis === "object" ? globalThis : typeof self === "object" ? self : typeof window === "object" ? window : typeof $parcel$global === "object" ? $parcel$global : {};
    }
});
// ../node_modules/@opentelemetry/api-logs/build/esm/platform/browser/index.js
var $281a441cdcb2cf36$var$init_browser3 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api-logs/build/esm/platform/browser/index.js" () {
        $281a441cdcb2cf36$var$init_globalThis();
    }
});
// ../node_modules/@opentelemetry/api-logs/build/esm/internal/global-utils.js
function $281a441cdcb2cf36$var$makeGetter(requiredVersion, instance, fallback) {
    return (version6)=>version6 === requiredVersion ? instance : fallback;
}
var $281a441cdcb2cf36$var$GLOBAL_LOGS_API_KEY, $281a441cdcb2cf36$var$_global2, $281a441cdcb2cf36$var$API_BACKWARDS_COMPATIBILITY_VERSION;
var $281a441cdcb2cf36$var$init_global_utils2 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api-logs/build/esm/internal/global-utils.js" () {
        $281a441cdcb2cf36$var$init_browser3();
        $281a441cdcb2cf36$var$GLOBAL_LOGS_API_KEY = /* @__PURE__ */ Symbol.for("io.opentelemetry.js.api.logs");
        $281a441cdcb2cf36$var$_global2 = $281a441cdcb2cf36$var$_globalThis2;
        $281a441cdcb2cf36$var$API_BACKWARDS_COMPATIBILITY_VERSION = 1;
    }
});
// ../node_modules/@opentelemetry/api-logs/build/esm/api/logs.js
var $281a441cdcb2cf36$var$LogsAPI;
var $281a441cdcb2cf36$var$init_logs2 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api-logs/build/esm/api/logs.js" () {
        $281a441cdcb2cf36$var$init_global_utils2();
        $281a441cdcb2cf36$var$init_NoopLoggerProvider();
        $281a441cdcb2cf36$var$init_ProxyLoggerProvider();
        $281a441cdcb2cf36$var$LogsAPI = class _LogsAPI {
            constructor(){
                this._proxyLoggerProvider = new $281a441cdcb2cf36$var$ProxyLoggerProvider();
            }
            static getInstance() {
                if (!this._instance) this._instance = new _LogsAPI();
                return this._instance;
            }
            setGlobalLoggerProvider(provider) {
                if ($281a441cdcb2cf36$var$_global2[$281a441cdcb2cf36$var$GLOBAL_LOGS_API_KEY]) return this.getLoggerProvider();
                $281a441cdcb2cf36$var$_global2[$281a441cdcb2cf36$var$GLOBAL_LOGS_API_KEY] = $281a441cdcb2cf36$var$makeGetter($281a441cdcb2cf36$var$API_BACKWARDS_COMPATIBILITY_VERSION, provider, $281a441cdcb2cf36$var$NOOP_LOGGER_PROVIDER);
                this._proxyLoggerProvider.setDelegate(provider);
                return provider;
            }
            /**
       * Returns the global logger provider.
       *
       * @returns LoggerProvider
       */ getLoggerProvider() {
                var _a2, _b;
                return (_b = (_a2 = $281a441cdcb2cf36$var$_global2[$281a441cdcb2cf36$var$GLOBAL_LOGS_API_KEY]) === null || _a2 === void 0 ? void 0 : _a2.call($281a441cdcb2cf36$var$_global2, $281a441cdcb2cf36$var$API_BACKWARDS_COMPATIBILITY_VERSION)) !== null && _b !== void 0 ? _b : this._proxyLoggerProvider;
            }
            /**
       * Returns a logger from the global logger provider.
       *
       * @returns Logger
       */ getLogger(name, version6, options) {
                return this.getLoggerProvider().getLogger(name, version6, options);
            }
            /** Remove the global logger provider */ disable() {
                delete $281a441cdcb2cf36$var$_global2[$281a441cdcb2cf36$var$GLOBAL_LOGS_API_KEY];
                this._proxyLoggerProvider = new $281a441cdcb2cf36$var$ProxyLoggerProvider();
            }
        };
    }
});
// ../node_modules/@opentelemetry/api-logs/build/esm/index.js
var $281a441cdcb2cf36$var$logs;
var $281a441cdcb2cf36$var$init_esm6 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/api-logs/build/esm/index.js" () {
        $281a441cdcb2cf36$var$init_logs2();
        $281a441cdcb2cf36$var$logs = $281a441cdcb2cf36$var$LogsAPI.getInstance();
    }
});
// ../node_modules/@opentelemetry/instrumentation/build/esm/autoLoaderUtils.js
function $281a441cdcb2cf36$var$enableInstrumentations(instrumentations, tracerProvider, meterProvider, loggerProvider) {
    for(let i3 = 0, j3 = instrumentations.length; i3 < j3; i3++){
        const instrumentation = instrumentations[i3];
        if (tracerProvider) instrumentation.setTracerProvider(tracerProvider);
        if (meterProvider) instrumentation.setMeterProvider(meterProvider);
        if (loggerProvider && instrumentation.setLoggerProvider) instrumentation.setLoggerProvider(loggerProvider);
        if (!instrumentation.getConfig().enabled) instrumentation.enable();
    }
}
function $281a441cdcb2cf36$var$disableInstrumentations(instrumentations) {
    instrumentations.forEach((instrumentation)=>instrumentation.disable());
}
var $281a441cdcb2cf36$var$init_autoLoaderUtils = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/instrumentation/build/esm/autoLoaderUtils.js" () {}
});
// ../node_modules/@opentelemetry/instrumentation/build/esm/autoLoader.js
function $281a441cdcb2cf36$var$registerInstrumentations(options) {
    var _a2, _b;
    const tracerProvider = options.tracerProvider || $281a441cdcb2cf36$var$trace.getTracerProvider();
    const meterProvider = options.meterProvider || $281a441cdcb2cf36$var$metrics.getMeterProvider();
    const loggerProvider = options.loggerProvider || $281a441cdcb2cf36$var$logs.getLoggerProvider();
    const instrumentations = (_b = (_a2 = options.instrumentations) == null ? void 0 : _a2.flat()) != null ? _b : [];
    $281a441cdcb2cf36$var$enableInstrumentations(instrumentations, tracerProvider, meterProvider, loggerProvider);
    return ()=>{
        $281a441cdcb2cf36$var$disableInstrumentations(instrumentations);
    };
}
var $281a441cdcb2cf36$var$init_autoLoader = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/instrumentation/build/esm/autoLoader.js" () {
        $281a441cdcb2cf36$var$init_esm();
        $281a441cdcb2cf36$var$init_esm6();
        $281a441cdcb2cf36$var$init_autoLoaderUtils();
    }
});
// ../node_modules/@opentelemetry/instrumentation/build/esm/shimmer.js
function $281a441cdcb2cf36$var$defineProperty(obj, name, value2) {
    const enumerable = !!obj[name] && Object.prototype.propertyIsEnumerable.call(obj, name);
    Object.defineProperty(obj, name, {
        configurable: true,
        enumerable: enumerable,
        writable: true,
        value: value2
    });
}
function $281a441cdcb2cf36$var$shimmer(options) {
    if (options && options.logger) {
        if (typeof options.logger !== "function") $281a441cdcb2cf36$var$logger2("new logger isn't a function, not replacing");
        else $281a441cdcb2cf36$var$logger2 = options.logger;
    }
}
var $281a441cdcb2cf36$var$logger2, $281a441cdcb2cf36$var$wrap, $281a441cdcb2cf36$var$massWrap, $281a441cdcb2cf36$var$unwrap, $281a441cdcb2cf36$var$massUnwrap;
var $281a441cdcb2cf36$var$init_shimmer = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/instrumentation/build/esm/shimmer.js" () {
        $281a441cdcb2cf36$var$logger2 = console.error.bind(console);
        $281a441cdcb2cf36$var$wrap = (nodule, name, wrapper)=>{
            if (!nodule || !nodule[name]) {
                $281a441cdcb2cf36$var$logger2("no original function " + String(name) + " to wrap");
                return;
            }
            if (!wrapper) {
                $281a441cdcb2cf36$var$logger2("no wrapper function");
                $281a441cdcb2cf36$var$logger2(new Error().stack);
                return;
            }
            const original = nodule[name];
            if (typeof original !== "function" || typeof wrapper !== "function") {
                $281a441cdcb2cf36$var$logger2("original object and wrapper must be functions");
                return;
            }
            const wrapped = wrapper(original, name);
            $281a441cdcb2cf36$var$defineProperty(wrapped, "__original", original);
            $281a441cdcb2cf36$var$defineProperty(wrapped, "__unwrap", ()=>{
                if (nodule[name] === wrapped) $281a441cdcb2cf36$var$defineProperty(nodule, name, original);
            });
            $281a441cdcb2cf36$var$defineProperty(wrapped, "__wrapped", true);
            $281a441cdcb2cf36$var$defineProperty(nodule, name, wrapped);
            return wrapped;
        };
        $281a441cdcb2cf36$var$massWrap = (nodules, names, wrapper)=>{
            if (!nodules) {
                $281a441cdcb2cf36$var$logger2("must provide one or more modules to patch");
                $281a441cdcb2cf36$var$logger2(new Error().stack);
                return;
            } else if (!Array.isArray(nodules)) nodules = [
                nodules
            ];
            if (!(names && Array.isArray(names))) {
                $281a441cdcb2cf36$var$logger2("must provide one or more functions to wrap on modules");
                return;
            }
            nodules.forEach((nodule)=>{
                names.forEach((name)=>{
                    $281a441cdcb2cf36$var$wrap(nodule, name, wrapper);
                });
            });
        };
        $281a441cdcb2cf36$var$unwrap = (nodule, name)=>{
            if (!nodule || !nodule[name]) {
                $281a441cdcb2cf36$var$logger2("no function to unwrap.");
                $281a441cdcb2cf36$var$logger2(new Error().stack);
                return;
            }
            const wrapped = nodule[name];
            if (!wrapped.__unwrap) $281a441cdcb2cf36$var$logger2("no original to unwrap to -- has " + String(name) + " already been unwrapped?");
            else {
                wrapped.__unwrap();
                return;
            }
        };
        $281a441cdcb2cf36$var$massUnwrap = (nodules, names)=>{
            if (!nodules) {
                $281a441cdcb2cf36$var$logger2("must provide one or more modules to patch");
                $281a441cdcb2cf36$var$logger2(new Error().stack);
                return;
            } else if (!Array.isArray(nodules)) nodules = [
                nodules
            ];
            if (!(names && Array.isArray(names))) {
                $281a441cdcb2cf36$var$logger2("must provide one or more functions to unwrap on modules");
                return;
            }
            nodules.forEach((nodule)=>{
                names.forEach((name)=>{
                    $281a441cdcb2cf36$var$unwrap(nodule, name);
                });
            });
        };
        $281a441cdcb2cf36$var$shimmer.wrap = $281a441cdcb2cf36$var$wrap;
        $281a441cdcb2cf36$var$shimmer.massWrap = $281a441cdcb2cf36$var$massWrap;
        $281a441cdcb2cf36$var$shimmer.unwrap = $281a441cdcb2cf36$var$unwrap;
        $281a441cdcb2cf36$var$shimmer.massUnwrap = $281a441cdcb2cf36$var$massUnwrap;
    }
});
// ../node_modules/@opentelemetry/instrumentation/build/esm/instrumentation.js
var $281a441cdcb2cf36$var$InstrumentationAbstract;
var $281a441cdcb2cf36$var$init_instrumentation9 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/instrumentation/build/esm/instrumentation.js" () {
        $281a441cdcb2cf36$var$init_esm();
        $281a441cdcb2cf36$var$init_esm6();
        $281a441cdcb2cf36$var$init_shimmer();
        $281a441cdcb2cf36$var$InstrumentationAbstract = class {
            constructor(instrumentationName, instrumentationVersion, config){
                $281a441cdcb2cf36$var$__publicField(this, "instrumentationName");
                $281a441cdcb2cf36$var$__publicField(this, "instrumentationVersion");
                $281a441cdcb2cf36$var$__publicField(this, "_config", {});
                $281a441cdcb2cf36$var$__publicField(this, "_tracer");
                $281a441cdcb2cf36$var$__publicField(this, "_meter");
                $281a441cdcb2cf36$var$__publicField(this, "_logger");
                $281a441cdcb2cf36$var$__publicField(this, "_diag");
                /* Api to wrap instrumented method */ $281a441cdcb2cf36$var$__publicField(this, "_wrap", $281a441cdcb2cf36$var$wrap);
                /* Api to unwrap instrumented methods */ $281a441cdcb2cf36$var$__publicField(this, "_unwrap", $281a441cdcb2cf36$var$unwrap);
                /* Api to mass wrap instrumented method */ $281a441cdcb2cf36$var$__publicField(this, "_massWrap", $281a441cdcb2cf36$var$massWrap);
                /* Api to mass unwrap instrumented methods */ $281a441cdcb2cf36$var$__publicField(this, "_massUnwrap", $281a441cdcb2cf36$var$massUnwrap);
                this.instrumentationName = instrumentationName;
                this.instrumentationVersion = instrumentationVersion;
                this.setConfig(config);
                this._diag = $281a441cdcb2cf36$var$diag2.createComponentLogger({
                    namespace: instrumentationName
                });
                this._tracer = $281a441cdcb2cf36$var$trace.getTracer(instrumentationName, instrumentationVersion);
                this._meter = $281a441cdcb2cf36$var$metrics.getMeter(instrumentationName, instrumentationVersion);
                this._logger = $281a441cdcb2cf36$var$logs.getLogger(instrumentationName, instrumentationVersion);
                this._updateMetricInstruments();
            }
            /* Returns meter */ get meter() {
                return this._meter;
            }
            /**
       * Sets MeterProvider to this plugin
       * @param meterProvider
       */ setMeterProvider(meterProvider) {
                this._meter = meterProvider.getMeter(this.instrumentationName, this.instrumentationVersion);
                this._updateMetricInstruments();
            }
            /* Returns logger */ get logger() {
                return this._logger;
            }
            /**
       * Sets LoggerProvider to this plugin
       * @param loggerProvider
       */ setLoggerProvider(loggerProvider) {
                this._logger = loggerProvider.getLogger(this.instrumentationName, this.instrumentationVersion);
            }
            /**
       * @experimental
       *
       * Get module definitions defined by {@link init}.
       * This can be used for experimental compile-time instrumentation.
       *
       * @returns an array of {@link InstrumentationModuleDefinition}
       */ getModuleDefinitions() {
                var _a2;
                const initResult = (_a2 = this.init()) != null ? _a2 : [];
                if (!Array.isArray(initResult)) return [
                    initResult
                ];
                return initResult;
            }
            /**
       * Sets the new metric instruments with the current Meter.
       */ _updateMetricInstruments() {
                return;
            }
            /* Returns InstrumentationConfig */ getConfig() {
                return this._config;
            }
            /**
       * Sets InstrumentationConfig to this plugin
       * @param config
       */ setConfig(config) {
                this._config = {
                    enabled: true,
                    ...config
                };
            }
            /**
       * Sets TraceProvider to this plugin
       * @param tracerProvider
       */ setTracerProvider(tracerProvider) {
                this._tracer = tracerProvider.getTracer(this.instrumentationName, this.instrumentationVersion);
            }
            /* Returns tracer */ get tracer() {
                return this._tracer;
            }
            /**
       * Execute span customization hook, if configured, and log any errors.
       * Any semantics of the trigger and info are defined by the specific instrumentation.
       * @param hookHandler The optional hook handler which the user has configured via instrumentation config
       * @param triggerName The name of the trigger for executing the hook for logging purposes
       * @param span The span to which the hook should be applied
       * @param info The info object to be passed to the hook, with useful data the hook may use
       */ _runSpanCustomizationHook(hookHandler, triggerName, span, info) {
                if (!hookHandler) return;
                try {
                    hookHandler(span, info);
                } catch (e4) {
                    this._diag.error(`Error running span customization hook due to exception in handler`, {
                        triggerName: triggerName
                    }, e4);
                }
            }
        };
    }
});
// ../node_modules/@opentelemetry/instrumentation/build/esm/platform/browser/instrumentation.js
var $281a441cdcb2cf36$var$InstrumentationBase;
var $281a441cdcb2cf36$var$init_instrumentation10 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/instrumentation/build/esm/platform/browser/instrumentation.js" () {
        $281a441cdcb2cf36$var$init_instrumentation9();
        $281a441cdcb2cf36$var$InstrumentationBase = class extends $281a441cdcb2cf36$var$InstrumentationAbstract {
            constructor(instrumentationName, instrumentationVersion, config){
                super(instrumentationName, instrumentationVersion, config);
                if (this._config.enabled) this.enable();
            }
        };
    }
});
// ../node_modules/@opentelemetry/instrumentation/build/esm/platform/browser/index.js
var $281a441cdcb2cf36$var$init_browser4 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/instrumentation/build/esm/platform/browser/index.js" () {
        $281a441cdcb2cf36$var$init_instrumentation10();
    }
});
// ../node_modules/@opentelemetry/instrumentation/build/esm/utils.js
function $281a441cdcb2cf36$var$safeExecuteInTheMiddle(execute, onFinish, preventThrowingError) {
    let error;
    let result;
    try {
        result = execute();
    } catch (e4) {
        error = e4;
    } finally{
        onFinish(error, result);
        if (error && !preventThrowingError) throw error;
        return result;
    }
}
function $281a441cdcb2cf36$var$isWrapped(func) {
    return typeof func === "function" && typeof func.__original === "function" && typeof func.__unwrap === "function" && func.__wrapped === true;
}
var $281a441cdcb2cf36$var$init_utils9 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/instrumentation/build/esm/utils.js" () {}
});
// ../node_modules/@opentelemetry/instrumentation/build/esm/semconvStability.js
function $281a441cdcb2cf36$var$semconvStabilityFromStr(namespace, str) {
    let semconvStability = $281a441cdcb2cf36$var$SemconvStability.OLD;
    const entries = str == null ? void 0 : str.split(",").map((v3)=>v3.trim()).filter((s3)=>s3 !== "");
    for (const entry of entries != null ? entries : []){
        if (entry.toLowerCase() === namespace + "/dup") {
            semconvStability = $281a441cdcb2cf36$var$SemconvStability.DUPLICATE;
            break;
        } else if (entry.toLowerCase() === namespace) semconvStability = $281a441cdcb2cf36$var$SemconvStability.STABLE;
    }
    return semconvStability;
}
var $281a441cdcb2cf36$var$SemconvStability;
var $281a441cdcb2cf36$var$init_semconvStability = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/instrumentation/build/esm/semconvStability.js" () {
        (function(SemconvStability2) {
            SemconvStability2[SemconvStability2["STABLE"] = 1] = "STABLE";
            SemconvStability2[SemconvStability2["OLD"] = 2] = "OLD";
            SemconvStability2[SemconvStability2["DUPLICATE"] = 3] = "DUPLICATE";
        })($281a441cdcb2cf36$var$SemconvStability || ($281a441cdcb2cf36$var$SemconvStability = {}));
    }
});
// ../node_modules/@opentelemetry/instrumentation/build/esm/index.js
var $281a441cdcb2cf36$var$init_esm7 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/instrumentation/build/esm/index.js" () {
        $281a441cdcb2cf36$var$init_autoLoader();
        $281a441cdcb2cf36$var$init_browser4();
        $281a441cdcb2cf36$var$init_utils9();
        $281a441cdcb2cf36$var$init_semconvStability();
    }
});
// ../node_modules/@opentelemetry/instrumentation-fetch/node_modules/@opentelemetry/core/build/esm/platform/browser/environment.js
function $281a441cdcb2cf36$var$getStringListFromEnv2(_3) {
    return void 0;
}
var $281a441cdcb2cf36$var$init_environment3 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/instrumentation-fetch/node_modules/@opentelemetry/core/build/esm/platform/browser/environment.js" () {}
});
// ../node_modules/@opentelemetry/instrumentation-fetch/node_modules/@opentelemetry/core/build/esm/platform/browser/globalThis.js
var $281a441cdcb2cf36$var$_globalThis3;
var $281a441cdcb2cf36$var$init_globalThis2 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/instrumentation-fetch/node_modules/@opentelemetry/core/build/esm/platform/browser/globalThis.js" () {
        $281a441cdcb2cf36$var$_globalThis3 = typeof globalThis === "object" ? globalThis : typeof self === "object" ? self : typeof window === "object" ? window : typeof $parcel$global === "object" ? $parcel$global : {};
    }
});
// ../node_modules/@opentelemetry/instrumentation-fetch/node_modules/@opentelemetry/core/build/esm/platform/browser/performance.js
var $281a441cdcb2cf36$var$otperformance2;
var $281a441cdcb2cf36$var$init_performance2 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/instrumentation-fetch/node_modules/@opentelemetry/core/build/esm/platform/browser/performance.js" () {
        $281a441cdcb2cf36$var$otperformance2 = performance;
    }
});
// ../node_modules/@opentelemetry/instrumentation-fetch/node_modules/@opentelemetry/core/build/esm/platform/browser/index.js
var $281a441cdcb2cf36$var$init_browser5 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/instrumentation-fetch/node_modules/@opentelemetry/core/build/esm/platform/browser/index.js" () {
        $281a441cdcb2cf36$var$init_environment3();
        $281a441cdcb2cf36$var$init_globalThis2();
        $281a441cdcb2cf36$var$init_performance2();
    }
});
// ../node_modules/@opentelemetry/instrumentation-fetch/node_modules/@opentelemetry/core/build/esm/common/time.js
function $281a441cdcb2cf36$var$millisToHrTime2(epochMillis) {
    const epochSeconds = epochMillis / 1e3;
    const seconds = Math.trunc(epochSeconds);
    const nanos = Math.round(epochMillis % 1e3 * $281a441cdcb2cf36$var$MILLISECONDS_TO_NANOSECONDS2);
    return [
        seconds,
        nanos
    ];
}
function $281a441cdcb2cf36$var$getTimeOrigin2() {
    let timeOrigin = $281a441cdcb2cf36$var$otperformance2.timeOrigin;
    if (typeof timeOrigin !== "number") {
        const perf = $281a441cdcb2cf36$var$otperformance2;
        timeOrigin = perf.timing && perf.timing.fetchStart;
    }
    return timeOrigin;
}
function $281a441cdcb2cf36$var$hrTime2(performanceNow) {
    const timeOrigin = $281a441cdcb2cf36$var$millisToHrTime2($281a441cdcb2cf36$var$getTimeOrigin2());
    const now = $281a441cdcb2cf36$var$millisToHrTime2(typeof performanceNow === "number" ? performanceNow : $281a441cdcb2cf36$var$otperformance2.now());
    return $281a441cdcb2cf36$var$addHrTimes2(timeOrigin, now);
}
function $281a441cdcb2cf36$var$timeInputToHrTime2(time) {
    if ($281a441cdcb2cf36$var$isTimeInputHrTime2(time)) return time;
    else if (typeof time === "number") {
        if (time < $281a441cdcb2cf36$var$getTimeOrigin2()) return $281a441cdcb2cf36$var$hrTime2(time);
        else return $281a441cdcb2cf36$var$millisToHrTime2(time);
    } else if (time instanceof Date) return $281a441cdcb2cf36$var$millisToHrTime2(time.getTime());
    else throw TypeError("Invalid input type");
}
function $281a441cdcb2cf36$var$hrTimeToNanoseconds2(time) {
    return time[0] * $281a441cdcb2cf36$var$SECOND_TO_NANOSECONDS2 + time[1];
}
function $281a441cdcb2cf36$var$isTimeInputHrTime2(value2) {
    return Array.isArray(value2) && value2.length === 2 && typeof value2[0] === "number" && typeof value2[1] === "number";
}
function $281a441cdcb2cf36$var$addHrTimes2(time1, time2) {
    const out = [
        time1[0] + time2[0],
        time1[1] + time2[1]
    ];
    if (out[1] >= $281a441cdcb2cf36$var$SECOND_TO_NANOSECONDS2) {
        out[1] -= $281a441cdcb2cf36$var$SECOND_TO_NANOSECONDS2;
        out[0] += 1;
    }
    return out;
}
var $281a441cdcb2cf36$var$NANOSECOND_DIGITS2, $281a441cdcb2cf36$var$NANOSECOND_DIGITS_IN_MILLIS2, $281a441cdcb2cf36$var$MILLISECONDS_TO_NANOSECONDS2, $281a441cdcb2cf36$var$SECOND_TO_NANOSECONDS2;
var $281a441cdcb2cf36$var$init_time3 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/instrumentation-fetch/node_modules/@opentelemetry/core/build/esm/common/time.js" () {
        $281a441cdcb2cf36$var$init_browser5();
        $281a441cdcb2cf36$var$NANOSECOND_DIGITS2 = 9;
        $281a441cdcb2cf36$var$NANOSECOND_DIGITS_IN_MILLIS2 = 6;
        $281a441cdcb2cf36$var$MILLISECONDS_TO_NANOSECONDS2 = Math.pow(10, $281a441cdcb2cf36$var$NANOSECOND_DIGITS_IN_MILLIS2);
        $281a441cdcb2cf36$var$SECOND_TO_NANOSECONDS2 = Math.pow(10, $281a441cdcb2cf36$var$NANOSECOND_DIGITS2);
    }
});
// ../node_modules/@opentelemetry/instrumentation-fetch/node_modules/@opentelemetry/core/build/esm/utils/url.js
function $281a441cdcb2cf36$var$urlMatches(url2, urlToMatch) {
    if (typeof urlToMatch === "string") return url2 === urlToMatch;
    else return !!url2.match(urlToMatch);
}
function $281a441cdcb2cf36$var$isUrlIgnored2(url2, ignoredUrls) {
    if (!ignoredUrls) return false;
    for (const ignoreUrl of ignoredUrls){
        if ($281a441cdcb2cf36$var$urlMatches(url2, ignoreUrl)) return true;
    }
    return false;
}
var $281a441cdcb2cf36$var$init_url2 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/instrumentation-fetch/node_modules/@opentelemetry/core/build/esm/utils/url.js" () {}
});
// ../node_modules/@opentelemetry/instrumentation-fetch/node_modules/@opentelemetry/core/build/esm/index.js
var $281a441cdcb2cf36$var$init_esm8 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/instrumentation-fetch/node_modules/@opentelemetry/core/build/esm/index.js" () {
        $281a441cdcb2cf36$var$init_time3();
        $281a441cdcb2cf36$var$init_browser5();
        $281a441cdcb2cf36$var$init_url2();
    }
});
// ../node_modules/@opentelemetry/instrumentation-fetch/node_modules/@opentelemetry/sdk-trace-web/build/esm/enums/PerformanceTimingNames.js
var $281a441cdcb2cf36$var$PerformanceTimingNames;
var $281a441cdcb2cf36$var$init_PerformanceTimingNames = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/instrumentation-fetch/node_modules/@opentelemetry/sdk-trace-web/build/esm/enums/PerformanceTimingNames.js" () {
        (function(PerformanceTimingNames3) {
            PerformanceTimingNames3["CONNECT_END"] = "connectEnd";
            PerformanceTimingNames3["CONNECT_START"] = "connectStart";
            PerformanceTimingNames3["DECODED_BODY_SIZE"] = "decodedBodySize";
            PerformanceTimingNames3["DOM_COMPLETE"] = "domComplete";
            PerformanceTimingNames3["DOM_CONTENT_LOADED_EVENT_END"] = "domContentLoadedEventEnd";
            PerformanceTimingNames3["DOM_CONTENT_LOADED_EVENT_START"] = "domContentLoadedEventStart";
            PerformanceTimingNames3["DOM_INTERACTIVE"] = "domInteractive";
            PerformanceTimingNames3["DOMAIN_LOOKUP_END"] = "domainLookupEnd";
            PerformanceTimingNames3["DOMAIN_LOOKUP_START"] = "domainLookupStart";
            PerformanceTimingNames3["ENCODED_BODY_SIZE"] = "encodedBodySize";
            PerformanceTimingNames3["FETCH_START"] = "fetchStart";
            PerformanceTimingNames3["LOAD_EVENT_END"] = "loadEventEnd";
            PerformanceTimingNames3["LOAD_EVENT_START"] = "loadEventStart";
            PerformanceTimingNames3["NAVIGATION_START"] = "navigationStart";
            PerformanceTimingNames3["REDIRECT_END"] = "redirectEnd";
            PerformanceTimingNames3["REDIRECT_START"] = "redirectStart";
            PerformanceTimingNames3["REQUEST_START"] = "requestStart";
            PerformanceTimingNames3["RESPONSE_END"] = "responseEnd";
            PerformanceTimingNames3["RESPONSE_START"] = "responseStart";
            PerformanceTimingNames3["SECURE_CONNECTION_START"] = "secureConnectionStart";
            PerformanceTimingNames3["START_TIME"] = "startTime";
            PerformanceTimingNames3["UNLOAD_EVENT_END"] = "unloadEventEnd";
            PerformanceTimingNames3["UNLOAD_EVENT_START"] = "unloadEventStart";
        })($281a441cdcb2cf36$var$PerformanceTimingNames || ($281a441cdcb2cf36$var$PerformanceTimingNames = {}));
    }
});
// ../node_modules/@opentelemetry/instrumentation-fetch/node_modules/@opentelemetry/sdk-trace-web/build/esm/semconv.js
var $281a441cdcb2cf36$var$ATTR_HTTP_RESPONSE_CONTENT_LENGTH, $281a441cdcb2cf36$var$ATTR_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED;
var $281a441cdcb2cf36$var$init_semconv3 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/instrumentation-fetch/node_modules/@opentelemetry/sdk-trace-web/build/esm/semconv.js" () {
        $281a441cdcb2cf36$var$ATTR_HTTP_RESPONSE_CONTENT_LENGTH = "http.response_content_length";
        $281a441cdcb2cf36$var$ATTR_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED = "http.response_content_length_uncompressed";
    }
});
// ../node_modules/@opentelemetry/instrumentation-fetch/node_modules/@opentelemetry/sdk-trace-web/build/esm/utils.js
function $281a441cdcb2cf36$var$getUrlNormalizingAnchor() {
    if (!$281a441cdcb2cf36$var$urlNormalizingAnchor) $281a441cdcb2cf36$var$urlNormalizingAnchor = document.createElement("a");
    return $281a441cdcb2cf36$var$urlNormalizingAnchor;
}
function $281a441cdcb2cf36$var$hasKey(obj, key) {
    return key in obj;
}
function $281a441cdcb2cf36$var$addSpanNetworkEvent(span, performanceName, entries, ignoreZeros = true) {
    if ($281a441cdcb2cf36$var$hasKey(entries, performanceName) && typeof entries[performanceName] === "number" && !(ignoreZeros && entries[performanceName] === 0)) return span.addEvent(performanceName, entries[performanceName]);
    return void 0;
}
function $281a441cdcb2cf36$var$addSpanNetworkEvents(span, resource, ignoreNetworkEvents = false, ignoreZeros, skipOldSemconvContentLengthAttrs) {
    if (ignoreZeros === void 0) ignoreZeros = resource[$281a441cdcb2cf36$var$PerformanceTimingNames.START_TIME] !== 0;
    if (!ignoreNetworkEvents) {
        $281a441cdcb2cf36$var$addSpanNetworkEvent(span, $281a441cdcb2cf36$var$PerformanceTimingNames.FETCH_START, resource, ignoreZeros);
        $281a441cdcb2cf36$var$addSpanNetworkEvent(span, $281a441cdcb2cf36$var$PerformanceTimingNames.DOMAIN_LOOKUP_START, resource, ignoreZeros);
        $281a441cdcb2cf36$var$addSpanNetworkEvent(span, $281a441cdcb2cf36$var$PerformanceTimingNames.DOMAIN_LOOKUP_END, resource, ignoreZeros);
        $281a441cdcb2cf36$var$addSpanNetworkEvent(span, $281a441cdcb2cf36$var$PerformanceTimingNames.CONNECT_START, resource, ignoreZeros);
        $281a441cdcb2cf36$var$addSpanNetworkEvent(span, $281a441cdcb2cf36$var$PerformanceTimingNames.SECURE_CONNECTION_START, resource, ignoreZeros);
        $281a441cdcb2cf36$var$addSpanNetworkEvent(span, $281a441cdcb2cf36$var$PerformanceTimingNames.CONNECT_END, resource, ignoreZeros);
        $281a441cdcb2cf36$var$addSpanNetworkEvent(span, $281a441cdcb2cf36$var$PerformanceTimingNames.REQUEST_START, resource, ignoreZeros);
        $281a441cdcb2cf36$var$addSpanNetworkEvent(span, $281a441cdcb2cf36$var$PerformanceTimingNames.RESPONSE_START, resource, ignoreZeros);
        $281a441cdcb2cf36$var$addSpanNetworkEvent(span, $281a441cdcb2cf36$var$PerformanceTimingNames.RESPONSE_END, resource, ignoreZeros);
    }
    if (!skipOldSemconvContentLengthAttrs) {
        const encodedLength = resource[$281a441cdcb2cf36$var$PerformanceTimingNames.ENCODED_BODY_SIZE];
        if (encodedLength !== void 0) span.setAttribute($281a441cdcb2cf36$var$ATTR_HTTP_RESPONSE_CONTENT_LENGTH, encodedLength);
        const decodedLength = resource[$281a441cdcb2cf36$var$PerformanceTimingNames.DECODED_BODY_SIZE];
        if (decodedLength !== void 0 && encodedLength !== decodedLength) span.setAttribute($281a441cdcb2cf36$var$ATTR_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED, decodedLength);
    }
}
function $281a441cdcb2cf36$var$sortResources(filteredResources) {
    return filteredResources.slice().sort((a3, b3)=>{
        const valueA = a3[$281a441cdcb2cf36$var$PerformanceTimingNames.FETCH_START];
        const valueB = b3[$281a441cdcb2cf36$var$PerformanceTimingNames.FETCH_START];
        if (valueA > valueB) return 1;
        else if (valueA < valueB) return -1;
        return 0;
    });
}
function $281a441cdcb2cf36$var$getOrigin() {
    return typeof location !== "undefined" ? location.origin : void 0;
}
function $281a441cdcb2cf36$var$getResource(spanUrl, startTimeHR, endTimeHR, resources, ignoredResources = /* @__PURE__ */ new WeakSet(), initiatorType) {
    const parsedSpanUrl = $281a441cdcb2cf36$var$parseUrl(spanUrl);
    spanUrl = parsedSpanUrl.toString();
    const filteredResources = $281a441cdcb2cf36$var$filterResourcesForSpan(spanUrl, startTimeHR, endTimeHR, resources, ignoredResources, initiatorType);
    if (filteredResources.length === 0) return {
        mainRequest: void 0
    };
    if (filteredResources.length === 1) return {
        mainRequest: filteredResources[0]
    };
    const sorted = $281a441cdcb2cf36$var$sortResources(filteredResources);
    if (parsedSpanUrl.origin !== $281a441cdcb2cf36$var$getOrigin() && sorted.length > 1) {
        let corsPreFlightRequest = sorted[0];
        let mainRequest = $281a441cdcb2cf36$var$findMainRequest(sorted, corsPreFlightRequest[$281a441cdcb2cf36$var$PerformanceTimingNames.RESPONSE_END], endTimeHR);
        const responseEnd = corsPreFlightRequest[$281a441cdcb2cf36$var$PerformanceTimingNames.RESPONSE_END];
        const fetchStart = mainRequest[$281a441cdcb2cf36$var$PerformanceTimingNames.FETCH_START];
        if (fetchStart < responseEnd) {
            mainRequest = corsPreFlightRequest;
            corsPreFlightRequest = void 0;
        }
        return {
            corsPreFlightRequest: corsPreFlightRequest,
            mainRequest: mainRequest
        };
    } else return {
        mainRequest: filteredResources[0]
    };
}
function $281a441cdcb2cf36$var$findMainRequest(resources, corsPreFlightRequestEndTime, spanEndTimeHR) {
    const spanEndTime = $281a441cdcb2cf36$var$hrTimeToNanoseconds2(spanEndTimeHR);
    const minTime = $281a441cdcb2cf36$var$hrTimeToNanoseconds2($281a441cdcb2cf36$var$timeInputToHrTime2(corsPreFlightRequestEndTime));
    let mainRequest = resources[1];
    let bestGap;
    const length2 = resources.length;
    for(let i3 = 1; i3 < length2; i3++){
        const resource = resources[i3];
        const resourceStartTime = $281a441cdcb2cf36$var$hrTimeToNanoseconds2($281a441cdcb2cf36$var$timeInputToHrTime2(resource[$281a441cdcb2cf36$var$PerformanceTimingNames.FETCH_START]));
        const resourceEndTime = $281a441cdcb2cf36$var$hrTimeToNanoseconds2($281a441cdcb2cf36$var$timeInputToHrTime2(resource[$281a441cdcb2cf36$var$PerformanceTimingNames.RESPONSE_END]));
        const currentGap = spanEndTime - resourceEndTime;
        if (resourceStartTime >= minTime && (!bestGap || currentGap < bestGap)) {
            bestGap = currentGap;
            mainRequest = resource;
        }
    }
    return mainRequest;
}
function $281a441cdcb2cf36$var$filterResourcesForSpan(spanUrl, startTimeHR, endTimeHR, resources, ignoredResources, initiatorType) {
    const startTime = $281a441cdcb2cf36$var$hrTimeToNanoseconds2(startTimeHR);
    const endTime = $281a441cdcb2cf36$var$hrTimeToNanoseconds2(endTimeHR);
    let filteredResources = resources.filter((resource)=>{
        const resourceStartTime = $281a441cdcb2cf36$var$hrTimeToNanoseconds2($281a441cdcb2cf36$var$timeInputToHrTime2(resource[$281a441cdcb2cf36$var$PerformanceTimingNames.FETCH_START]));
        const resourceEndTime = $281a441cdcb2cf36$var$hrTimeToNanoseconds2($281a441cdcb2cf36$var$timeInputToHrTime2(resource[$281a441cdcb2cf36$var$PerformanceTimingNames.RESPONSE_END]));
        return resource.initiatorType.toLowerCase() === (initiatorType || "xmlhttprequest") && resource.name === spanUrl && resourceStartTime >= startTime && resourceEndTime <= endTime;
    });
    if (filteredResources.length > 0) filteredResources = filteredResources.filter((resource)=>{
        return !ignoredResources.has(resource);
    });
    return filteredResources;
}
function $281a441cdcb2cf36$var$parseUrl(url2) {
    if (typeof URL === "function") return new URL(url2, typeof document !== "undefined" ? document.baseURI : typeof location !== "undefined" ? location.href : void 0);
    const element2 = $281a441cdcb2cf36$var$getUrlNormalizingAnchor();
    element2.href = url2;
    return element2;
}
function $281a441cdcb2cf36$var$shouldPropagateTraceHeaders(spanUrl, propagateTraceHeaderCorsUrls) {
    let propagateTraceHeaderUrls = propagateTraceHeaderCorsUrls || [];
    if (typeof propagateTraceHeaderUrls === "string" || propagateTraceHeaderUrls instanceof RegExp) propagateTraceHeaderUrls = [
        propagateTraceHeaderUrls
    ];
    const parsedSpanUrl = $281a441cdcb2cf36$var$parseUrl(spanUrl);
    if (parsedSpanUrl.origin === $281a441cdcb2cf36$var$getOrigin()) return true;
    else return propagateTraceHeaderUrls.some((propagateTraceHeaderUrl)=>$281a441cdcb2cf36$var$urlMatches(spanUrl, propagateTraceHeaderUrl));
}
var $281a441cdcb2cf36$var$urlNormalizingAnchor;
var $281a441cdcb2cf36$var$init_utils10 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/instrumentation-fetch/node_modules/@opentelemetry/sdk-trace-web/build/esm/utils.js" () {
        $281a441cdcb2cf36$var$init_PerformanceTimingNames();
        $281a441cdcb2cf36$var$init_esm8();
        $281a441cdcb2cf36$var$init_semconv3();
    }
});
// ../node_modules/@opentelemetry/instrumentation-fetch/node_modules/@opentelemetry/sdk-trace-web/build/esm/index.js
var $281a441cdcb2cf36$var$init_esm9 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/instrumentation-fetch/node_modules/@opentelemetry/sdk-trace-web/build/esm/index.js" () {
        $281a441cdcb2cf36$var$init_PerformanceTimingNames();
        $281a441cdcb2cf36$var$init_utils10();
    }
});
// ../node_modules/@opentelemetry/instrumentation-fetch/build/esm/enums/AttributeNames.js
var $281a441cdcb2cf36$var$AttributeNames;
var $281a441cdcb2cf36$var$init_AttributeNames = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/instrumentation-fetch/build/esm/enums/AttributeNames.js" () {
        (function(AttributeNames3) {
            AttributeNames3["COMPONENT"] = "component";
            AttributeNames3["HTTP_STATUS_TEXT"] = "http.status_text";
        })($281a441cdcb2cf36$var$AttributeNames || ($281a441cdcb2cf36$var$AttributeNames = {}));
    }
});
// ../node_modules/@opentelemetry/instrumentation-fetch/build/src/semconv.js
var $281a441cdcb2cf36$var$require_semconv2 = $281a441cdcb2cf36$var$__commonJS({
    "../node_modules/@opentelemetry/instrumentation-fetch/build/src/semconv.js" (exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.ATTR_HTTP_USER_AGENT = exports.ATTR_HTTP_URL = exports.ATTR_HTTP_STATUS_CODE = exports.ATTR_HTTP_SCHEME = exports.ATTR_HTTP_RESPONSE_CONTENT_LENGTH = exports.ATTR_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED = exports.ATTR_HTTP_REQUEST_BODY_SIZE = exports.ATTR_HTTP_METHOD = exports.ATTR_HTTP_HOST = void 0;
        exports.ATTR_HTTP_HOST = "http.host";
        exports.ATTR_HTTP_METHOD = "http.method";
        exports.ATTR_HTTP_REQUEST_BODY_SIZE = "http.request.body.size";
        exports.ATTR_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED = "http.request_content_length_uncompressed";
        exports.ATTR_HTTP_RESPONSE_CONTENT_LENGTH = "http.response_content_length";
        exports.ATTR_HTTP_SCHEME = "http.scheme";
        exports.ATTR_HTTP_STATUS_CODE = "http.status_code";
        exports.ATTR_HTTP_URL = "http.url";
        exports.ATTR_HTTP_USER_AGENT = "http.user_agent";
    }
});
// ../node_modules/@opentelemetry/instrumentation-fetch/build/esm/utils.js
function $281a441cdcb2cf36$var$getFetchBodyLength(...args2) {
    if (args2[0] instanceof URL || typeof args2[0] === "string") {
        const requestInit = args2[1];
        if (!(requestInit == null ? void 0 : requestInit.body)) return Promise.resolve();
        if (requestInit.body instanceof ReadableStream) {
            const { body: body, length: length2 } = $281a441cdcb2cf36$var$_getBodyNonDestructively(requestInit.body);
            requestInit.body = body;
            return length2;
        } else return Promise.resolve($281a441cdcb2cf36$var$getXHRBodyLength(requestInit.body));
    } else {
        const info = args2[0];
        if (!(info == null ? void 0 : info.body)) return Promise.resolve();
        return info.clone().text().then((t4)=>$281a441cdcb2cf36$var$getByteLength(t4));
    }
}
function $281a441cdcb2cf36$var$_getBodyNonDestructively(body) {
    if (!body.pipeThrough) {
        $281a441cdcb2cf36$var$DIAG_LOGGER.warn("Platform has ReadableStream but not pipeThrough!");
        return {
            body: body,
            length: Promise.resolve(void 0)
        };
    }
    let length2 = 0;
    let resolveLength;
    const lengthPromise = new Promise((resolve)=>{
        resolveLength = resolve;
    });
    const transform = new TransformStream({
        start () {},
        async transform (chunk, controller) {
            const bytearray = await chunk;
            length2 += bytearray.byteLength;
            controller.enqueue(chunk);
        },
        flush () {
            resolveLength(length2);
        }
    });
    return {
        body: body.pipeThrough(transform),
        length: lengthPromise
    };
}
function $281a441cdcb2cf36$var$isDocument(value2) {
    return typeof Document !== "undefined" && value2 instanceof Document;
}
function $281a441cdcb2cf36$var$getXHRBodyLength(body) {
    if ($281a441cdcb2cf36$var$isDocument(body)) return new XMLSerializer().serializeToString(document).length;
    if (typeof body === "string") return $281a441cdcb2cf36$var$getByteLength(body);
    if (body instanceof Blob) return body.size;
    if (body instanceof FormData) return $281a441cdcb2cf36$var$getFormDataSize(body);
    if (body instanceof URLSearchParams) return $281a441cdcb2cf36$var$getByteLength(body.toString());
    if (body.byteLength !== void 0) return body.byteLength;
    $281a441cdcb2cf36$var$DIAG_LOGGER.warn("unknown body type");
    return void 0;
}
function $281a441cdcb2cf36$var$getByteLength(s3) {
    return $281a441cdcb2cf36$var$TEXT_ENCODER2.encode(s3).byteLength;
}
function $281a441cdcb2cf36$var$getFormDataSize(formData) {
    let size2 = 0;
    for (const [key, value2] of formData.entries()){
        size2 += key.length;
        if (value2 instanceof Blob) size2 += value2.size;
        else size2 += value2.length;
    }
    return size2;
}
function $281a441cdcb2cf36$var$normalizeHttpRequestMethod(method) {
    const knownMethods3 = $281a441cdcb2cf36$var$getKnownMethods();
    const methUpper = method.toUpperCase();
    if (methUpper in knownMethods3) return methUpper;
    else return "_OTHER";
}
function $281a441cdcb2cf36$var$getKnownMethods() {
    if ($281a441cdcb2cf36$var$knownMethods === void 0) {
        const cfgMethods = $281a441cdcb2cf36$var$getStringListFromEnv2("OTEL_INSTRUMENTATION_HTTP_KNOWN_METHODS");
        if (cfgMethods && cfgMethods.length > 0) {
            $281a441cdcb2cf36$var$knownMethods = {};
            cfgMethods.forEach((m3)=>{
                $281a441cdcb2cf36$var$knownMethods[m3] = true;
            });
        } else $281a441cdcb2cf36$var$knownMethods = $281a441cdcb2cf36$var$DEFAULT_KNOWN_METHODS;
    }
    return $281a441cdcb2cf36$var$knownMethods;
}
function $281a441cdcb2cf36$var$serverPortFromUrl(url2) {
    const serverPort = Number(url2.port || $281a441cdcb2cf36$var$HTTP_PORT_FROM_PROTOCOL[url2.protocol]);
    if (serverPort && !isNaN(serverPort)) return serverPort;
    else return void 0;
}
var $281a441cdcb2cf36$var$DIAG_LOGGER, $281a441cdcb2cf36$var$TEXT_ENCODER2, $281a441cdcb2cf36$var$DEFAULT_KNOWN_METHODS, $281a441cdcb2cf36$var$knownMethods, $281a441cdcb2cf36$var$HTTP_PORT_FROM_PROTOCOL;
var $281a441cdcb2cf36$var$init_utils11 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/instrumentation-fetch/build/esm/utils.js" () {
        $281a441cdcb2cf36$var$init_esm();
        $281a441cdcb2cf36$var$init_esm8();
        $281a441cdcb2cf36$var$DIAG_LOGGER = $281a441cdcb2cf36$var$diag2.createComponentLogger({
            namespace: "@opentelemetry/opentelemetry-instrumentation-fetch/utils"
        });
        $281a441cdcb2cf36$var$TEXT_ENCODER2 = new TextEncoder();
        $281a441cdcb2cf36$var$DEFAULT_KNOWN_METHODS = {
            CONNECT: true,
            DELETE: true,
            GET: true,
            HEAD: true,
            OPTIONS: true,
            PATCH: true,
            POST: true,
            PUT: true,
            TRACE: true
        };
        $281a441cdcb2cf36$var$HTTP_PORT_FROM_PROTOCOL = {
            "https:": "443",
            "http:": "80"
        };
    }
});
// ../node_modules/@opentelemetry/instrumentation-fetch/build/esm/version.js
var $281a441cdcb2cf36$var$VERSION5;
var $281a441cdcb2cf36$var$init_version4 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/instrumentation-fetch/build/esm/version.js" () {
        $281a441cdcb2cf36$var$VERSION5 = "0.202.0";
    }
});
// ../node_modules/@opentelemetry/instrumentation-fetch/build/esm/fetch.js
var $281a441cdcb2cf36$var$import_semconv4, $281a441cdcb2cf36$var$OBSERVER_WAIT_TIME_MS, $281a441cdcb2cf36$var$_a, $281a441cdcb2cf36$var$isNode2, $281a441cdcb2cf36$var$FetchInstrumentation;
var $281a441cdcb2cf36$var$init_fetch2 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/instrumentation-fetch/build/esm/fetch.js" () {
        $281a441cdcb2cf36$var$init_esm();
        $281a441cdcb2cf36$var$init_esm7();
        $281a441cdcb2cf36$var$init_esm8();
        $281a441cdcb2cf36$var$init_esm9();
        $281a441cdcb2cf36$var$init_AttributeNames();
        $281a441cdcb2cf36$var$import_semconv4 = $281a441cdcb2cf36$var$__toESM($281a441cdcb2cf36$var$require_semconv2());
        $281a441cdcb2cf36$var$init_esm2();
        $281a441cdcb2cf36$var$init_utils11();
        $281a441cdcb2cf36$var$init_version4();
        $281a441cdcb2cf36$var$init_esm8();
        $281a441cdcb2cf36$var$OBSERVER_WAIT_TIME_MS = 300;
        $281a441cdcb2cf36$var$isNode2 = false;
        $281a441cdcb2cf36$var$FetchInstrumentation = class extends $281a441cdcb2cf36$var$InstrumentationBase {
            constructor(config = {}){
                super("@opentelemetry/instrumentation-fetch", $281a441cdcb2cf36$var$VERSION5, config);
                $281a441cdcb2cf36$var$__publicField(this, "component", "fetch");
                $281a441cdcb2cf36$var$__publicField(this, "version", $281a441cdcb2cf36$var$VERSION5);
                $281a441cdcb2cf36$var$__publicField(this, "moduleName", this.component);
                $281a441cdcb2cf36$var$__publicField(this, "_usedResources", /* @__PURE__ */ new WeakSet());
                $281a441cdcb2cf36$var$__publicField(this, "_tasksCount", 0);
                $281a441cdcb2cf36$var$__publicField(this, "_semconvStability");
                this._semconvStability = $281a441cdcb2cf36$var$semconvStabilityFromStr("http", config == null ? void 0 : config.semconvStabilityOptIn);
            }
            init() {}
            /**
       * Add cors pre flight child span
       * @param span
       * @param corsPreFlightRequest
       */ _addChildSpan(span, corsPreFlightRequest) {
                const childSpan = this.tracer.startSpan("CORS Preflight", {
                    startTime: corsPreFlightRequest[$281a441cdcb2cf36$var$PerformanceTimingNames.FETCH_START]
                }, $281a441cdcb2cf36$var$trace.setSpan($281a441cdcb2cf36$var$context.active(), span));
                const skipOldSemconvContentLengthAttrs = !(this._semconvStability & $281a441cdcb2cf36$var$SemconvStability.OLD);
                $281a441cdcb2cf36$var$addSpanNetworkEvents(childSpan, corsPreFlightRequest, this.getConfig().ignoreNetworkEvents, void 0, skipOldSemconvContentLengthAttrs);
                childSpan.end(corsPreFlightRequest[$281a441cdcb2cf36$var$PerformanceTimingNames.RESPONSE_END]);
            }
            /**
       * Adds more attributes to span just before ending it
       * @param span
       * @param response
       */ _addFinalSpanAttributes(span, response) {
                const parsedUrl = $281a441cdcb2cf36$var$parseUrl(response.url);
                if (this._semconvStability & $281a441cdcb2cf36$var$SemconvStability.OLD) {
                    span.setAttribute($281a441cdcb2cf36$var$import_semconv4.ATTR_HTTP_STATUS_CODE, response.status);
                    if (response.statusText != null) span.setAttribute($281a441cdcb2cf36$var$AttributeNames.HTTP_STATUS_TEXT, response.statusText);
                    span.setAttribute($281a441cdcb2cf36$var$import_semconv4.ATTR_HTTP_HOST, parsedUrl.host);
                    span.setAttribute($281a441cdcb2cf36$var$import_semconv4.ATTR_HTTP_SCHEME, parsedUrl.protocol.replace(":", ""));
                    if (typeof navigator !== "undefined") span.setAttribute($281a441cdcb2cf36$var$import_semconv4.ATTR_HTTP_USER_AGENT, navigator.userAgent);
                }
                if (this._semconvStability & $281a441cdcb2cf36$var$SemconvStability.STABLE) {
                    span.setAttribute($281a441cdcb2cf36$var$ATTR_HTTP_RESPONSE_STATUS_CODE, response.status);
                    span.setAttribute($281a441cdcb2cf36$var$ATTR_SERVER_ADDRESS, parsedUrl.hostname);
                    const serverPort = $281a441cdcb2cf36$var$serverPortFromUrl(parsedUrl);
                    if (serverPort) span.setAttribute($281a441cdcb2cf36$var$ATTR_SERVER_PORT, serverPort);
                }
            }
            /**
       * Add headers
       * @param options
       * @param spanUrl
       */ _addHeaders(options, spanUrl) {
                if (!$281a441cdcb2cf36$var$shouldPropagateTraceHeaders(spanUrl, this.getConfig().propagateTraceHeaderCorsUrls)) {
                    const headers = {};
                    $281a441cdcb2cf36$var$propagation.inject($281a441cdcb2cf36$var$context.active(), headers);
                    if (Object.keys(headers).length > 0) this._diag.debug("headers inject skipped due to CORS policy");
                    return;
                }
                if (options instanceof Request) $281a441cdcb2cf36$var$propagation.inject($281a441cdcb2cf36$var$context.active(), options.headers, {
                    set: (h3, k3, v3)=>h3.set(k3, typeof v3 === "string" ? v3 : String(v3))
                });
                else if (options.headers instanceof Headers) $281a441cdcb2cf36$var$propagation.inject($281a441cdcb2cf36$var$context.active(), options.headers, {
                    set: (h3, k3, v3)=>h3.set(k3, typeof v3 === "string" ? v3 : String(v3))
                });
                else if (options.headers instanceof Map) $281a441cdcb2cf36$var$propagation.inject($281a441cdcb2cf36$var$context.active(), options.headers, {
                    set: (h3, k3, v3)=>h3.set(k3, typeof v3 === "string" ? v3 : String(v3))
                });
                else {
                    const headers = {};
                    $281a441cdcb2cf36$var$propagation.inject($281a441cdcb2cf36$var$context.active(), headers);
                    options.headers = Object.assign({}, headers, options.headers || {});
                }
            }
            /**
       * Clears the resource timings and all resources assigned with spans
       *     when {@link FetchPluginConfig.clearTimingResources} is
       *     set to true (default false)
       * @private
       */ _clearResources() {
                if (this._tasksCount === 0 && this.getConfig().clearTimingResources) {
                    performance.clearResourceTimings();
                    this._usedResources = /* @__PURE__ */ new WeakSet();
                }
            }
            /**
       * Creates a new span
       * @param url
       * @param options
       */ _createSpan(url2, options = {}) {
                if ($281a441cdcb2cf36$var$isUrlIgnored2(url2, this.getConfig().ignoreUrls)) {
                    this._diag.debug("ignoring span as url matches ignored url");
                    return;
                }
                let name = "";
                const attributes = {};
                if (this._semconvStability & $281a441cdcb2cf36$var$SemconvStability.OLD) {
                    const method = (options.method || "GET").toUpperCase();
                    name = `HTTP ${method}`;
                    attributes[$281a441cdcb2cf36$var$AttributeNames.COMPONENT] = this.moduleName;
                    attributes[$281a441cdcb2cf36$var$import_semconv4.ATTR_HTTP_METHOD] = method;
                    attributes[$281a441cdcb2cf36$var$import_semconv4.ATTR_HTTP_URL] = url2;
                }
                if (this._semconvStability & $281a441cdcb2cf36$var$SemconvStability.STABLE) {
                    const origMethod = options.method;
                    const normMethod = $281a441cdcb2cf36$var$normalizeHttpRequestMethod(options.method || "GET");
                    if (!name) name = normMethod;
                    attributes[$281a441cdcb2cf36$var$ATTR_HTTP_REQUEST_METHOD] = normMethod;
                    if (normMethod !== origMethod) attributes[$281a441cdcb2cf36$var$ATTR_HTTP_REQUEST_METHOD_ORIGINAL] = origMethod;
                    attributes[$281a441cdcb2cf36$var$ATTR_URL_FULL] = url2;
                }
                return this.tracer.startSpan(name, {
                    kind: $281a441cdcb2cf36$var$SpanKind.CLIENT,
                    attributes: attributes
                });
            }
            /**
       * Finds appropriate resource and add network events to the span
       * @param span
       * @param resourcesObserver
       * @param endTime
       */ _findResourceAndAddNetworkEvents(span, resourcesObserver, endTime) {
                let resources = resourcesObserver.entries;
                if (!resources.length) {
                    if (!performance.getEntriesByType) return;
                    resources = performance.getEntriesByType("resource");
                }
                const resource = $281a441cdcb2cf36$var$getResource(resourcesObserver.spanUrl, resourcesObserver.startTime, endTime, resources, this._usedResources, "fetch");
                if (resource.mainRequest) {
                    const mainRequest = resource.mainRequest;
                    this._markResourceAsUsed(mainRequest);
                    const corsPreFlightRequest = resource.corsPreFlightRequest;
                    if (corsPreFlightRequest) {
                        this._addChildSpan(span, corsPreFlightRequest);
                        this._markResourceAsUsed(corsPreFlightRequest);
                    }
                    const skipOldSemconvContentLengthAttrs = !(this._semconvStability & $281a441cdcb2cf36$var$SemconvStability.OLD);
                    $281a441cdcb2cf36$var$addSpanNetworkEvents(span, mainRequest, this.getConfig().ignoreNetworkEvents, void 0, skipOldSemconvContentLengthAttrs);
                }
            }
            /**
       * Marks certain [resource]{@link PerformanceResourceTiming} when information
       * from this is used to add events to span.
       * This is done to avoid reusing the same resource again for next span
       * @param resource
       */ _markResourceAsUsed(resource) {
                this._usedResources.add(resource);
            }
            /**
       * Finish span, add attributes, network events etc.
       * @param span
       * @param spanData
       * @param response
       */ _endSpan(span, spanData, response) {
                const endTime = $281a441cdcb2cf36$var$millisToHrTime2(Date.now());
                const performanceEndTime = $281a441cdcb2cf36$var$hrTime2();
                this._addFinalSpanAttributes(span, response);
                if (this._semconvStability & $281a441cdcb2cf36$var$SemconvStability.STABLE) {
                    if (response.status >= 400) {
                        span.setStatus({
                            code: $281a441cdcb2cf36$var$SpanStatusCode.ERROR
                        });
                        span.setAttribute($281a441cdcb2cf36$var$ATTR_ERROR_TYPE, String(response.status));
                    }
                }
                setTimeout(()=>{
                    var _a2;
                    (_a2 = spanData.observer) == null || _a2.disconnect();
                    this._findResourceAndAddNetworkEvents(span, spanData, performanceEndTime);
                    this._tasksCount--;
                    this._clearResources();
                    span.end(endTime);
                }, $281a441cdcb2cf36$var$OBSERVER_WAIT_TIME_MS);
            }
            /**
       * Patches the constructor of fetch
       */ _patchConstructor() {
                return (original)=>{
                    const plugin = this;
                    return function patchConstructor(...args2) {
                        const self2 = this;
                        const url2 = $281a441cdcb2cf36$var$parseUrl(args2[0] instanceof Request ? args2[0].url : String(args2[0])).href;
                        const options = args2[0] instanceof Request ? args2[0] : args2[1] || {};
                        const createdSpan = plugin._createSpan(url2, options);
                        if (!createdSpan) return original.apply(this, args2);
                        const spanData = plugin._prepareSpanData(url2);
                        if (plugin.getConfig().measureRequestSize) $281a441cdcb2cf36$var$getFetchBodyLength(...args2).then((bodyLength)=>{
                            if (!bodyLength) return;
                            if (plugin._semconvStability & $281a441cdcb2cf36$var$SemconvStability.OLD) createdSpan.setAttribute($281a441cdcb2cf36$var$import_semconv4.ATTR_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED, bodyLength);
                            if (plugin._semconvStability & $281a441cdcb2cf36$var$SemconvStability.STABLE) createdSpan.setAttribute($281a441cdcb2cf36$var$import_semconv4.ATTR_HTTP_REQUEST_BODY_SIZE, bodyLength);
                        }).catch((error)=>{
                            plugin._diag.warn("getFetchBodyLength", error);
                        });
                        function endSpanOnError(span, error) {
                            plugin._applyAttributesAfterFetch(span, options, error);
                            plugin._endSpan(span, spanData, {
                                status: error.status || 0,
                                statusText: error.message,
                                url: url2
                            });
                        }
                        function endSpanOnSuccess(span, response) {
                            plugin._applyAttributesAfterFetch(span, options, response);
                            if (response.status >= 200 && response.status < 400) plugin._endSpan(span, spanData, response);
                            else plugin._endSpan(span, spanData, {
                                status: response.status,
                                statusText: response.statusText,
                                url: url2
                            });
                        }
                        function onSuccess(span, resolve, response) {
                            try {
                                const resClone = response.clone();
                                const body = resClone.body;
                                if (body) {
                                    const reader = body.getReader();
                                    const read = ()=>{
                                        reader.read().then(({ done: done })=>{
                                            if (done) endSpanOnSuccess(span, response);
                                            else read();
                                        }, (error)=>{
                                            endSpanOnError(span, error);
                                        });
                                    };
                                    read();
                                } else endSpanOnSuccess(span, response);
                            } finally{
                                resolve(response);
                            }
                        }
                        function onError(span, reject, error) {
                            try {
                                endSpanOnError(span, error);
                            } finally{
                                reject(error);
                            }
                        }
                        return new Promise((resolve, reject)=>{
                            return $281a441cdcb2cf36$var$context.with($281a441cdcb2cf36$var$trace.setSpan($281a441cdcb2cf36$var$context.active(), createdSpan), ()=>{
                                plugin._addHeaders(options, url2);
                                plugin._callRequestHook(createdSpan, options);
                                plugin._tasksCount++;
                                return original.apply(self2, options instanceof Request ? [
                                    options
                                ] : [
                                    url2,
                                    options
                                ]).then(onSuccess.bind(self2, createdSpan, resolve), onError.bind(self2, createdSpan, reject));
                            });
                        });
                    };
                };
            }
            _applyAttributesAfterFetch(span, request, result) {
                const applyCustomAttributesOnSpan = this.getConfig().applyCustomAttributesOnSpan;
                if (applyCustomAttributesOnSpan) $281a441cdcb2cf36$var$safeExecuteInTheMiddle(()=>applyCustomAttributesOnSpan(span, request, result), (error)=>{
                    if (!error) return;
                    this._diag.error("applyCustomAttributesOnSpan", error);
                }, true);
            }
            _callRequestHook(span, request) {
                const requestHook = this.getConfig().requestHook;
                if (requestHook) $281a441cdcb2cf36$var$safeExecuteInTheMiddle(()=>requestHook(span, request), (error)=>{
                    if (!error) return;
                    this._diag.error("requestHook", error);
                }, true);
            }
            /**
       * Prepares a span data - needed later for matching appropriate network
       *     resources
       * @param spanUrl
       */ _prepareSpanData(spanUrl) {
                const startTime = $281a441cdcb2cf36$var$hrTime2();
                const entries = [];
                if (typeof PerformanceObserver !== "function") return {
                    entries: entries,
                    startTime: startTime,
                    spanUrl: spanUrl
                };
                const observer = new PerformanceObserver((list)=>{
                    const perfObsEntries = list.getEntries();
                    perfObsEntries.forEach((entry)=>{
                        if (entry.initiatorType === "fetch" && entry.name === spanUrl) entries.push(entry);
                    });
                });
                observer.observe({
                    entryTypes: [
                        "resource"
                    ]
                });
                return {
                    entries: entries,
                    observer: observer,
                    startTime: startTime,
                    spanUrl: spanUrl
                };
            }
            /**
       * implements enable function
       */ enable() {
                if ($281a441cdcb2cf36$var$isNode2) {
                    this._diag.warn("this instrumentation is intended for web usage only, it does not instrument Node.js's fetch()");
                    return;
                }
                if ($281a441cdcb2cf36$var$isWrapped(fetch)) {
                    this._unwrap($281a441cdcb2cf36$var$_globalThis3, "fetch");
                    this._diag.debug("removing previous patch for constructor");
                }
                this._wrap($281a441cdcb2cf36$var$_globalThis3, "fetch", this._patchConstructor());
            }
            /**
       * implements unpatch function
       */ disable() {
                if ($281a441cdcb2cf36$var$isNode2) return;
                this._unwrap($281a441cdcb2cf36$var$_globalThis3, "fetch");
                this._usedResources = /* @__PURE__ */ new WeakSet();
            }
        };
    }
});
// ../node_modules/@opentelemetry/instrumentation-fetch/build/esm/index.js
var $281a441cdcb2cf36$var$init_esm10 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/instrumentation-fetch/build/esm/index.js" () {
        $281a441cdcb2cf36$var$init_fetch2();
    }
});
// ../node_modules/@opentelemetry/instrumentation-xml-http-request/node_modules/@opentelemetry/core/build/esm/platform/browser/environment.js
function $281a441cdcb2cf36$var$getStringListFromEnv3(_3) {
    return void 0;
}
var $281a441cdcb2cf36$var$init_environment4 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/instrumentation-xml-http-request/node_modules/@opentelemetry/core/build/esm/platform/browser/environment.js" () {}
});
// ../node_modules/@opentelemetry/instrumentation-xml-http-request/node_modules/@opentelemetry/core/build/esm/platform/browser/performance.js
var $281a441cdcb2cf36$var$otperformance3;
var $281a441cdcb2cf36$var$init_performance3 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/instrumentation-xml-http-request/node_modules/@opentelemetry/core/build/esm/platform/browser/performance.js" () {
        $281a441cdcb2cf36$var$otperformance3 = performance;
    }
});
// ../node_modules/@opentelemetry/instrumentation-xml-http-request/node_modules/@opentelemetry/core/build/esm/platform/browser/index.js
var $281a441cdcb2cf36$var$init_browser6 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/instrumentation-xml-http-request/node_modules/@opentelemetry/core/build/esm/platform/browser/index.js" () {
        $281a441cdcb2cf36$var$init_environment4();
        $281a441cdcb2cf36$var$init_performance3();
    }
});
// ../node_modules/@opentelemetry/instrumentation-xml-http-request/node_modules/@opentelemetry/core/build/esm/common/time.js
function $281a441cdcb2cf36$var$millisToHrTime3(epochMillis) {
    const epochSeconds = epochMillis / 1e3;
    const seconds = Math.trunc(epochSeconds);
    const nanos = Math.round(epochMillis % 1e3 * $281a441cdcb2cf36$var$MILLISECONDS_TO_NANOSECONDS3);
    return [
        seconds,
        nanos
    ];
}
function $281a441cdcb2cf36$var$getTimeOrigin3() {
    let timeOrigin = $281a441cdcb2cf36$var$otperformance3.timeOrigin;
    if (typeof timeOrigin !== "number") {
        const perf = $281a441cdcb2cf36$var$otperformance3;
        timeOrigin = perf.timing && perf.timing.fetchStart;
    }
    return timeOrigin;
}
function $281a441cdcb2cf36$var$hrTime3(performanceNow) {
    const timeOrigin = $281a441cdcb2cf36$var$millisToHrTime3($281a441cdcb2cf36$var$getTimeOrigin3());
    const now = $281a441cdcb2cf36$var$millisToHrTime3(typeof performanceNow === "number" ? performanceNow : $281a441cdcb2cf36$var$otperformance3.now());
    return $281a441cdcb2cf36$var$addHrTimes3(timeOrigin, now);
}
function $281a441cdcb2cf36$var$timeInputToHrTime3(time) {
    if ($281a441cdcb2cf36$var$isTimeInputHrTime3(time)) return time;
    else if (typeof time === "number") {
        if (time < $281a441cdcb2cf36$var$getTimeOrigin3()) return $281a441cdcb2cf36$var$hrTime3(time);
        else return $281a441cdcb2cf36$var$millisToHrTime3(time);
    } else if (time instanceof Date) return $281a441cdcb2cf36$var$millisToHrTime3(time.getTime());
    else throw TypeError("Invalid input type");
}
function $281a441cdcb2cf36$var$hrTimeToNanoseconds3(time) {
    return time[0] * $281a441cdcb2cf36$var$SECOND_TO_NANOSECONDS3 + time[1];
}
function $281a441cdcb2cf36$var$isTimeInputHrTime3(value2) {
    return Array.isArray(value2) && value2.length === 2 && typeof value2[0] === "number" && typeof value2[1] === "number";
}
function $281a441cdcb2cf36$var$addHrTimes3(time1, time2) {
    const out = [
        time1[0] + time2[0],
        time1[1] + time2[1]
    ];
    if (out[1] >= $281a441cdcb2cf36$var$SECOND_TO_NANOSECONDS3) {
        out[1] -= $281a441cdcb2cf36$var$SECOND_TO_NANOSECONDS3;
        out[0] += 1;
    }
    return out;
}
var $281a441cdcb2cf36$var$NANOSECOND_DIGITS3, $281a441cdcb2cf36$var$NANOSECOND_DIGITS_IN_MILLIS3, $281a441cdcb2cf36$var$MILLISECONDS_TO_NANOSECONDS3, $281a441cdcb2cf36$var$SECOND_TO_NANOSECONDS3;
var $281a441cdcb2cf36$var$init_time4 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/instrumentation-xml-http-request/node_modules/@opentelemetry/core/build/esm/common/time.js" () {
        $281a441cdcb2cf36$var$init_browser6();
        $281a441cdcb2cf36$var$NANOSECOND_DIGITS3 = 9;
        $281a441cdcb2cf36$var$NANOSECOND_DIGITS_IN_MILLIS3 = 6;
        $281a441cdcb2cf36$var$MILLISECONDS_TO_NANOSECONDS3 = Math.pow(10, $281a441cdcb2cf36$var$NANOSECOND_DIGITS_IN_MILLIS3);
        $281a441cdcb2cf36$var$SECOND_TO_NANOSECONDS3 = Math.pow(10, $281a441cdcb2cf36$var$NANOSECOND_DIGITS3);
    }
});
// ../node_modules/@opentelemetry/instrumentation-xml-http-request/node_modules/@opentelemetry/core/build/esm/utils/url.js
function $281a441cdcb2cf36$var$urlMatches2(url2, urlToMatch) {
    if (typeof urlToMatch === "string") return url2 === urlToMatch;
    else return !!url2.match(urlToMatch);
}
function $281a441cdcb2cf36$var$isUrlIgnored3(url2, ignoredUrls) {
    if (!ignoredUrls) return false;
    for (const ignoreUrl of ignoredUrls){
        if ($281a441cdcb2cf36$var$urlMatches2(url2, ignoreUrl)) return true;
    }
    return false;
}
var $281a441cdcb2cf36$var$init_url3 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/instrumentation-xml-http-request/node_modules/@opentelemetry/core/build/esm/utils/url.js" () {}
});
// ../node_modules/@opentelemetry/instrumentation-xml-http-request/node_modules/@opentelemetry/core/build/esm/index.js
var $281a441cdcb2cf36$var$init_esm11 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/instrumentation-xml-http-request/node_modules/@opentelemetry/core/build/esm/index.js" () {
        $281a441cdcb2cf36$var$init_time4();
        $281a441cdcb2cf36$var$init_browser6();
        $281a441cdcb2cf36$var$init_url3();
    }
});
// ../node_modules/@opentelemetry/instrumentation-xml-http-request/node_modules/@opentelemetry/sdk-trace-web/build/esm/enums/PerformanceTimingNames.js
var $281a441cdcb2cf36$var$PerformanceTimingNames2;
var $281a441cdcb2cf36$var$init_PerformanceTimingNames2 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/instrumentation-xml-http-request/node_modules/@opentelemetry/sdk-trace-web/build/esm/enums/PerformanceTimingNames.js" () {
        (function(PerformanceTimingNames3) {
            PerformanceTimingNames3["CONNECT_END"] = "connectEnd";
            PerformanceTimingNames3["CONNECT_START"] = "connectStart";
            PerformanceTimingNames3["DECODED_BODY_SIZE"] = "decodedBodySize";
            PerformanceTimingNames3["DOM_COMPLETE"] = "domComplete";
            PerformanceTimingNames3["DOM_CONTENT_LOADED_EVENT_END"] = "domContentLoadedEventEnd";
            PerformanceTimingNames3["DOM_CONTENT_LOADED_EVENT_START"] = "domContentLoadedEventStart";
            PerformanceTimingNames3["DOM_INTERACTIVE"] = "domInteractive";
            PerformanceTimingNames3["DOMAIN_LOOKUP_END"] = "domainLookupEnd";
            PerformanceTimingNames3["DOMAIN_LOOKUP_START"] = "domainLookupStart";
            PerformanceTimingNames3["ENCODED_BODY_SIZE"] = "encodedBodySize";
            PerformanceTimingNames3["FETCH_START"] = "fetchStart";
            PerformanceTimingNames3["LOAD_EVENT_END"] = "loadEventEnd";
            PerformanceTimingNames3["LOAD_EVENT_START"] = "loadEventStart";
            PerformanceTimingNames3["NAVIGATION_START"] = "navigationStart";
            PerformanceTimingNames3["REDIRECT_END"] = "redirectEnd";
            PerformanceTimingNames3["REDIRECT_START"] = "redirectStart";
            PerformanceTimingNames3["REQUEST_START"] = "requestStart";
            PerformanceTimingNames3["RESPONSE_END"] = "responseEnd";
            PerformanceTimingNames3["RESPONSE_START"] = "responseStart";
            PerformanceTimingNames3["SECURE_CONNECTION_START"] = "secureConnectionStart";
            PerformanceTimingNames3["START_TIME"] = "startTime";
            PerformanceTimingNames3["UNLOAD_EVENT_END"] = "unloadEventEnd";
            PerformanceTimingNames3["UNLOAD_EVENT_START"] = "unloadEventStart";
        })($281a441cdcb2cf36$var$PerformanceTimingNames2 || ($281a441cdcb2cf36$var$PerformanceTimingNames2 = {}));
    }
});
// ../node_modules/@opentelemetry/instrumentation-xml-http-request/node_modules/@opentelemetry/sdk-trace-web/build/esm/semconv.js
var $281a441cdcb2cf36$var$ATTR_HTTP_RESPONSE_CONTENT_LENGTH2, $281a441cdcb2cf36$var$ATTR_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED2;
var $281a441cdcb2cf36$var$init_semconv4 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/instrumentation-xml-http-request/node_modules/@opentelemetry/sdk-trace-web/build/esm/semconv.js" () {
        $281a441cdcb2cf36$var$ATTR_HTTP_RESPONSE_CONTENT_LENGTH2 = "http.response_content_length";
        $281a441cdcb2cf36$var$ATTR_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED2 = "http.response_content_length_uncompressed";
    }
});
// ../node_modules/@opentelemetry/instrumentation-xml-http-request/node_modules/@opentelemetry/sdk-trace-web/build/esm/utils.js
function $281a441cdcb2cf36$var$getUrlNormalizingAnchor2() {
    if (!$281a441cdcb2cf36$var$urlNormalizingAnchor2) $281a441cdcb2cf36$var$urlNormalizingAnchor2 = document.createElement("a");
    return $281a441cdcb2cf36$var$urlNormalizingAnchor2;
}
function $281a441cdcb2cf36$var$hasKey2(obj, key) {
    return key in obj;
}
function $281a441cdcb2cf36$var$addSpanNetworkEvent2(span, performanceName, entries, ignoreZeros = true) {
    if ($281a441cdcb2cf36$var$hasKey2(entries, performanceName) && typeof entries[performanceName] === "number" && !(ignoreZeros && entries[performanceName] === 0)) return span.addEvent(performanceName, entries[performanceName]);
    return void 0;
}
function $281a441cdcb2cf36$var$addSpanNetworkEvents2(span, resource, ignoreNetworkEvents = false, ignoreZeros, skipOldSemconvContentLengthAttrs) {
    if (ignoreZeros === void 0) ignoreZeros = resource[$281a441cdcb2cf36$var$PerformanceTimingNames2.START_TIME] !== 0;
    if (!ignoreNetworkEvents) {
        $281a441cdcb2cf36$var$addSpanNetworkEvent2(span, $281a441cdcb2cf36$var$PerformanceTimingNames2.FETCH_START, resource, ignoreZeros);
        $281a441cdcb2cf36$var$addSpanNetworkEvent2(span, $281a441cdcb2cf36$var$PerformanceTimingNames2.DOMAIN_LOOKUP_START, resource, ignoreZeros);
        $281a441cdcb2cf36$var$addSpanNetworkEvent2(span, $281a441cdcb2cf36$var$PerformanceTimingNames2.DOMAIN_LOOKUP_END, resource, ignoreZeros);
        $281a441cdcb2cf36$var$addSpanNetworkEvent2(span, $281a441cdcb2cf36$var$PerformanceTimingNames2.CONNECT_START, resource, ignoreZeros);
        $281a441cdcb2cf36$var$addSpanNetworkEvent2(span, $281a441cdcb2cf36$var$PerformanceTimingNames2.SECURE_CONNECTION_START, resource, ignoreZeros);
        $281a441cdcb2cf36$var$addSpanNetworkEvent2(span, $281a441cdcb2cf36$var$PerformanceTimingNames2.CONNECT_END, resource, ignoreZeros);
        $281a441cdcb2cf36$var$addSpanNetworkEvent2(span, $281a441cdcb2cf36$var$PerformanceTimingNames2.REQUEST_START, resource, ignoreZeros);
        $281a441cdcb2cf36$var$addSpanNetworkEvent2(span, $281a441cdcb2cf36$var$PerformanceTimingNames2.RESPONSE_START, resource, ignoreZeros);
        $281a441cdcb2cf36$var$addSpanNetworkEvent2(span, $281a441cdcb2cf36$var$PerformanceTimingNames2.RESPONSE_END, resource, ignoreZeros);
    }
    if (!skipOldSemconvContentLengthAttrs) {
        const encodedLength = resource[$281a441cdcb2cf36$var$PerformanceTimingNames2.ENCODED_BODY_SIZE];
        if (encodedLength !== void 0) span.setAttribute($281a441cdcb2cf36$var$ATTR_HTTP_RESPONSE_CONTENT_LENGTH2, encodedLength);
        const decodedLength = resource[$281a441cdcb2cf36$var$PerformanceTimingNames2.DECODED_BODY_SIZE];
        if (decodedLength !== void 0 && encodedLength !== decodedLength) span.setAttribute($281a441cdcb2cf36$var$ATTR_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED2, decodedLength);
    }
}
function $281a441cdcb2cf36$var$sortResources2(filteredResources) {
    return filteredResources.slice().sort((a3, b3)=>{
        const valueA = a3[$281a441cdcb2cf36$var$PerformanceTimingNames2.FETCH_START];
        const valueB = b3[$281a441cdcb2cf36$var$PerformanceTimingNames2.FETCH_START];
        if (valueA > valueB) return 1;
        else if (valueA < valueB) return -1;
        return 0;
    });
}
function $281a441cdcb2cf36$var$getOrigin2() {
    return typeof location !== "undefined" ? location.origin : void 0;
}
function $281a441cdcb2cf36$var$getResource2(spanUrl, startTimeHR, endTimeHR, resources, ignoredResources = /* @__PURE__ */ new WeakSet(), initiatorType) {
    const parsedSpanUrl = $281a441cdcb2cf36$var$parseUrl2(spanUrl);
    spanUrl = parsedSpanUrl.toString();
    const filteredResources = $281a441cdcb2cf36$var$filterResourcesForSpan2(spanUrl, startTimeHR, endTimeHR, resources, ignoredResources, initiatorType);
    if (filteredResources.length === 0) return {
        mainRequest: void 0
    };
    if (filteredResources.length === 1) return {
        mainRequest: filteredResources[0]
    };
    const sorted = $281a441cdcb2cf36$var$sortResources2(filteredResources);
    if (parsedSpanUrl.origin !== $281a441cdcb2cf36$var$getOrigin2() && sorted.length > 1) {
        let corsPreFlightRequest = sorted[0];
        let mainRequest = $281a441cdcb2cf36$var$findMainRequest2(sorted, corsPreFlightRequest[$281a441cdcb2cf36$var$PerformanceTimingNames2.RESPONSE_END], endTimeHR);
        const responseEnd = corsPreFlightRequest[$281a441cdcb2cf36$var$PerformanceTimingNames2.RESPONSE_END];
        const fetchStart = mainRequest[$281a441cdcb2cf36$var$PerformanceTimingNames2.FETCH_START];
        if (fetchStart < responseEnd) {
            mainRequest = corsPreFlightRequest;
            corsPreFlightRequest = void 0;
        }
        return {
            corsPreFlightRequest: corsPreFlightRequest,
            mainRequest: mainRequest
        };
    } else return {
        mainRequest: filteredResources[0]
    };
}
function $281a441cdcb2cf36$var$findMainRequest2(resources, corsPreFlightRequestEndTime, spanEndTimeHR) {
    const spanEndTime = $281a441cdcb2cf36$var$hrTimeToNanoseconds3(spanEndTimeHR);
    const minTime = $281a441cdcb2cf36$var$hrTimeToNanoseconds3($281a441cdcb2cf36$var$timeInputToHrTime3(corsPreFlightRequestEndTime));
    let mainRequest = resources[1];
    let bestGap;
    const length2 = resources.length;
    for(let i3 = 1; i3 < length2; i3++){
        const resource = resources[i3];
        const resourceStartTime = $281a441cdcb2cf36$var$hrTimeToNanoseconds3($281a441cdcb2cf36$var$timeInputToHrTime3(resource[$281a441cdcb2cf36$var$PerformanceTimingNames2.FETCH_START]));
        const resourceEndTime = $281a441cdcb2cf36$var$hrTimeToNanoseconds3($281a441cdcb2cf36$var$timeInputToHrTime3(resource[$281a441cdcb2cf36$var$PerformanceTimingNames2.RESPONSE_END]));
        const currentGap = spanEndTime - resourceEndTime;
        if (resourceStartTime >= minTime && (!bestGap || currentGap < bestGap)) {
            bestGap = currentGap;
            mainRequest = resource;
        }
    }
    return mainRequest;
}
function $281a441cdcb2cf36$var$filterResourcesForSpan2(spanUrl, startTimeHR, endTimeHR, resources, ignoredResources, initiatorType) {
    const startTime = $281a441cdcb2cf36$var$hrTimeToNanoseconds3(startTimeHR);
    const endTime = $281a441cdcb2cf36$var$hrTimeToNanoseconds3(endTimeHR);
    let filteredResources = resources.filter((resource)=>{
        const resourceStartTime = $281a441cdcb2cf36$var$hrTimeToNanoseconds3($281a441cdcb2cf36$var$timeInputToHrTime3(resource[$281a441cdcb2cf36$var$PerformanceTimingNames2.FETCH_START]));
        const resourceEndTime = $281a441cdcb2cf36$var$hrTimeToNanoseconds3($281a441cdcb2cf36$var$timeInputToHrTime3(resource[$281a441cdcb2cf36$var$PerformanceTimingNames2.RESPONSE_END]));
        return resource.initiatorType.toLowerCase() === (initiatorType || "xmlhttprequest") && resource.name === spanUrl && resourceStartTime >= startTime && resourceEndTime <= endTime;
    });
    if (filteredResources.length > 0) filteredResources = filteredResources.filter((resource)=>{
        return !ignoredResources.has(resource);
    });
    return filteredResources;
}
function $281a441cdcb2cf36$var$parseUrl2(url2) {
    if (typeof URL === "function") return new URL(url2, typeof document !== "undefined" ? document.baseURI : typeof location !== "undefined" ? location.href : void 0);
    const element2 = $281a441cdcb2cf36$var$getUrlNormalizingAnchor2();
    element2.href = url2;
    return element2;
}
function $281a441cdcb2cf36$var$shouldPropagateTraceHeaders2(spanUrl, propagateTraceHeaderCorsUrls) {
    let propagateTraceHeaderUrls = propagateTraceHeaderCorsUrls || [];
    if (typeof propagateTraceHeaderUrls === "string" || propagateTraceHeaderUrls instanceof RegExp) propagateTraceHeaderUrls = [
        propagateTraceHeaderUrls
    ];
    const parsedSpanUrl = $281a441cdcb2cf36$var$parseUrl2(spanUrl);
    if (parsedSpanUrl.origin === $281a441cdcb2cf36$var$getOrigin2()) return true;
    else return propagateTraceHeaderUrls.some((propagateTraceHeaderUrl)=>$281a441cdcb2cf36$var$urlMatches2(spanUrl, propagateTraceHeaderUrl));
}
var $281a441cdcb2cf36$var$urlNormalizingAnchor2;
var $281a441cdcb2cf36$var$init_utils12 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/instrumentation-xml-http-request/node_modules/@opentelemetry/sdk-trace-web/build/esm/utils.js" () {
        $281a441cdcb2cf36$var$init_PerformanceTimingNames2();
        $281a441cdcb2cf36$var$init_esm11();
        $281a441cdcb2cf36$var$init_semconv4();
    }
});
// ../node_modules/@opentelemetry/instrumentation-xml-http-request/node_modules/@opentelemetry/sdk-trace-web/build/esm/index.js
var $281a441cdcb2cf36$var$init_esm12 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/instrumentation-xml-http-request/node_modules/@opentelemetry/sdk-trace-web/build/esm/index.js" () {
        $281a441cdcb2cf36$var$init_PerformanceTimingNames2();
        $281a441cdcb2cf36$var$init_utils12();
    }
});
// ../node_modules/@opentelemetry/instrumentation-xml-http-request/build/esm/semconv.js
var $281a441cdcb2cf36$var$ATTR_HTTP_HOST2, $281a441cdcb2cf36$var$ATTR_HTTP_METHOD2, $281a441cdcb2cf36$var$ATTR_HTTP_REQUEST_BODY_SIZE2, $281a441cdcb2cf36$var$ATTR_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED2, $281a441cdcb2cf36$var$ATTR_HTTP_SCHEME2, $281a441cdcb2cf36$var$ATTR_HTTP_STATUS_CODE2, $281a441cdcb2cf36$var$ATTR_HTTP_URL2, $281a441cdcb2cf36$var$ATTR_HTTP_USER_AGENT2;
var $281a441cdcb2cf36$var$init_semconv5 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/instrumentation-xml-http-request/build/esm/semconv.js" () {
        $281a441cdcb2cf36$var$ATTR_HTTP_HOST2 = "http.host";
        $281a441cdcb2cf36$var$ATTR_HTTP_METHOD2 = "http.method";
        $281a441cdcb2cf36$var$ATTR_HTTP_REQUEST_BODY_SIZE2 = "http.request.body.size";
        $281a441cdcb2cf36$var$ATTR_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED2 = "http.request_content_length_uncompressed";
        $281a441cdcb2cf36$var$ATTR_HTTP_SCHEME2 = "http.scheme";
        $281a441cdcb2cf36$var$ATTR_HTTP_STATUS_CODE2 = "http.status_code";
        $281a441cdcb2cf36$var$ATTR_HTTP_URL2 = "http.url";
        $281a441cdcb2cf36$var$ATTR_HTTP_USER_AGENT2 = "http.user_agent";
    }
});
// ../node_modules/@opentelemetry/instrumentation-xml-http-request/build/esm/enums/EventNames.js
var $281a441cdcb2cf36$var$EventNames;
var $281a441cdcb2cf36$var$init_EventNames = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/instrumentation-xml-http-request/build/esm/enums/EventNames.js" () {
        (function(EventNames2) {
            EventNames2["METHOD_OPEN"] = "open";
            EventNames2["METHOD_SEND"] = "send";
            EventNames2["EVENT_ABORT"] = "abort";
            EventNames2["EVENT_ERROR"] = "error";
            EventNames2["EVENT_LOAD"] = "loaded";
            EventNames2["EVENT_TIMEOUT"] = "timeout";
        })($281a441cdcb2cf36$var$EventNames || ($281a441cdcb2cf36$var$EventNames = {}));
    }
});
// ../node_modules/@opentelemetry/instrumentation-xml-http-request/build/esm/utils.js
function $281a441cdcb2cf36$var$isDocument2(value2) {
    return typeof Document !== "undefined" && value2 instanceof Document;
}
function $281a441cdcb2cf36$var$getXHRBodyLength2(body) {
    if ($281a441cdcb2cf36$var$isDocument2(body)) return new XMLSerializer().serializeToString(document).length;
    if (typeof body === "string") return $281a441cdcb2cf36$var$getByteLength2(body);
    if (body instanceof Blob) return body.size;
    if (body instanceof FormData) return $281a441cdcb2cf36$var$getFormDataSize2(body);
    if (body instanceof URLSearchParams) return $281a441cdcb2cf36$var$getByteLength2(body.toString());
    if (body.byteLength !== void 0) return body.byteLength;
    $281a441cdcb2cf36$var$DIAG_LOGGER2.warn("unknown body type");
    return void 0;
}
function $281a441cdcb2cf36$var$getByteLength2(s3) {
    return $281a441cdcb2cf36$var$TEXT_ENCODER3.encode(s3).byteLength;
}
function $281a441cdcb2cf36$var$getFormDataSize2(formData) {
    let size2 = 0;
    for (const [key, value2] of formData.entries()){
        size2 += key.length;
        if (value2 instanceof Blob) size2 += value2.size;
        else size2 += value2.length;
    }
    return size2;
}
function $281a441cdcb2cf36$var$normalizeHttpRequestMethod2(method) {
    const knownMethods3 = $281a441cdcb2cf36$var$getKnownMethods2();
    const methUpper = method.toUpperCase();
    if (methUpper in knownMethods3) return methUpper;
    else return "_OTHER";
}
function $281a441cdcb2cf36$var$getKnownMethods2() {
    if ($281a441cdcb2cf36$var$knownMethods2 === void 0) {
        const cfgMethods = $281a441cdcb2cf36$var$getStringListFromEnv3("OTEL_INSTRUMENTATION_HTTP_KNOWN_METHODS");
        if (cfgMethods && cfgMethods.length > 0) {
            $281a441cdcb2cf36$var$knownMethods2 = {};
            cfgMethods.forEach((m3)=>{
                $281a441cdcb2cf36$var$knownMethods2[m3] = true;
            });
        } else $281a441cdcb2cf36$var$knownMethods2 = $281a441cdcb2cf36$var$DEFAULT_KNOWN_METHODS2;
    }
    return $281a441cdcb2cf36$var$knownMethods2;
}
function $281a441cdcb2cf36$var$serverPortFromUrl2(url2) {
    const serverPort = Number(url2.port || $281a441cdcb2cf36$var$HTTP_PORT_FROM_PROTOCOL2[url2.protocol]);
    if (serverPort && !isNaN(serverPort)) return serverPort;
    else return void 0;
}
var $281a441cdcb2cf36$var$DIAG_LOGGER2, $281a441cdcb2cf36$var$TEXT_ENCODER3, $281a441cdcb2cf36$var$DEFAULT_KNOWN_METHODS2, $281a441cdcb2cf36$var$knownMethods2, $281a441cdcb2cf36$var$HTTP_PORT_FROM_PROTOCOL2;
var $281a441cdcb2cf36$var$init_utils13 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/instrumentation-xml-http-request/build/esm/utils.js" () {
        $281a441cdcb2cf36$var$init_esm();
        $281a441cdcb2cf36$var$init_esm11();
        $281a441cdcb2cf36$var$DIAG_LOGGER2 = $281a441cdcb2cf36$var$diag2.createComponentLogger({
            namespace: "@opentelemetry/opentelemetry-instrumentation-xml-http-request/utils"
        });
        $281a441cdcb2cf36$var$TEXT_ENCODER3 = new TextEncoder();
        $281a441cdcb2cf36$var$DEFAULT_KNOWN_METHODS2 = {
            CONNECT: true,
            DELETE: true,
            GET: true,
            HEAD: true,
            OPTIONS: true,
            PATCH: true,
            POST: true,
            PUT: true,
            TRACE: true
        };
        $281a441cdcb2cf36$var$HTTP_PORT_FROM_PROTOCOL2 = {
            "https:": "443",
            "http:": "80"
        };
    }
});
// ../node_modules/@opentelemetry/instrumentation-xml-http-request/build/esm/version.js
var $281a441cdcb2cf36$var$VERSION6;
var $281a441cdcb2cf36$var$init_version5 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/instrumentation-xml-http-request/build/esm/version.js" () {
        $281a441cdcb2cf36$var$VERSION6 = "0.202.0";
    }
});
// ../node_modules/@opentelemetry/instrumentation-xml-http-request/build/esm/enums/AttributeNames.js
var $281a441cdcb2cf36$var$AttributeNames2;
var $281a441cdcb2cf36$var$init_AttributeNames2 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/instrumentation-xml-http-request/build/esm/enums/AttributeNames.js" () {
        (function(AttributeNames3) {
            AttributeNames3["HTTP_STATUS_TEXT"] = "http.status_text";
        })($281a441cdcb2cf36$var$AttributeNames2 || ($281a441cdcb2cf36$var$AttributeNames2 = {}));
    }
});
// ../node_modules/@opentelemetry/instrumentation-xml-http-request/build/esm/xhr.js
var $281a441cdcb2cf36$var$OBSERVER_WAIT_TIME_MS2, $281a441cdcb2cf36$var$XMLHttpRequestInstrumentation;
var $281a441cdcb2cf36$var$init_xhr = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/instrumentation-xml-http-request/build/esm/xhr.js" () {
        $281a441cdcb2cf36$var$init_esm();
        $281a441cdcb2cf36$var$init_esm7();
        $281a441cdcb2cf36$var$init_esm11();
        $281a441cdcb2cf36$var$init_esm12();
        $281a441cdcb2cf36$var$init_esm2();
        $281a441cdcb2cf36$var$init_semconv5();
        $281a441cdcb2cf36$var$init_EventNames();
        $281a441cdcb2cf36$var$init_utils13();
        $281a441cdcb2cf36$var$init_version5();
        $281a441cdcb2cf36$var$init_AttributeNames2();
        $281a441cdcb2cf36$var$OBSERVER_WAIT_TIME_MS2 = 300;
        $281a441cdcb2cf36$var$XMLHttpRequestInstrumentation = class extends $281a441cdcb2cf36$var$InstrumentationBase {
            constructor(config = {}){
                super("@opentelemetry/instrumentation-xml-http-request", $281a441cdcb2cf36$var$VERSION6, config);
                $281a441cdcb2cf36$var$__publicField(this, "component", "xml-http-request");
                $281a441cdcb2cf36$var$__publicField(this, "version", $281a441cdcb2cf36$var$VERSION6);
                $281a441cdcb2cf36$var$__publicField(this, "moduleName", this.component);
                $281a441cdcb2cf36$var$__publicField(this, "_tasksCount", 0);
                $281a441cdcb2cf36$var$__publicField(this, "_xhrMem", /* @__PURE__ */ new WeakMap());
                $281a441cdcb2cf36$var$__publicField(this, "_usedResources", /* @__PURE__ */ new WeakSet());
                $281a441cdcb2cf36$var$__publicField(this, "_semconvStability");
                this._semconvStability = $281a441cdcb2cf36$var$semconvStabilityFromStr("http", config == null ? void 0 : config.semconvStabilityOptIn);
            }
            init() {}
            /**
       * Adds custom headers to XMLHttpRequest
       * @param xhr
       * @param spanUrl
       * @private
       */ _addHeaders(xhr, spanUrl) {
                const url2 = $281a441cdcb2cf36$var$parseUrl2(spanUrl).href;
                if (!$281a441cdcb2cf36$var$shouldPropagateTraceHeaders2(url2, this.getConfig().propagateTraceHeaderCorsUrls)) {
                    const headers2 = {};
                    $281a441cdcb2cf36$var$propagation.inject($281a441cdcb2cf36$var$context.active(), headers2);
                    if (Object.keys(headers2).length > 0) this._diag.debug("headers inject skipped due to CORS policy");
                    return;
                }
                const headers = {};
                $281a441cdcb2cf36$var$propagation.inject($281a441cdcb2cf36$var$context.active(), headers);
                Object.keys(headers).forEach((key)=>{
                    xhr.setRequestHeader(key, String(headers[key]));
                });
            }
            /**
       * Add cors pre flight child span
       * @param span
       * @param corsPreFlightRequest
       * @private
       */ _addChildSpan(span, corsPreFlightRequest) {
                $281a441cdcb2cf36$var$context.with($281a441cdcb2cf36$var$trace.setSpan($281a441cdcb2cf36$var$context.active(), span), ()=>{
                    const childSpan = this.tracer.startSpan("CORS Preflight", {
                        startTime: corsPreFlightRequest[$281a441cdcb2cf36$var$PerformanceTimingNames2.FETCH_START]
                    });
                    const skipOldSemconvContentLengthAttrs = !(this._semconvStability & $281a441cdcb2cf36$var$SemconvStability.OLD);
                    $281a441cdcb2cf36$var$addSpanNetworkEvents2(childSpan, corsPreFlightRequest, this.getConfig().ignoreNetworkEvents, void 0, skipOldSemconvContentLengthAttrs);
                    childSpan.end(corsPreFlightRequest[$281a441cdcb2cf36$var$PerformanceTimingNames2.RESPONSE_END]);
                });
            }
            /**
       * Add attributes when span is going to end
       * @param span
       * @param xhr
       * @param spanUrl
       * @private
       */ _addFinalSpanAttributes(span, xhrMem, spanUrl) {
                if (this._semconvStability & $281a441cdcb2cf36$var$SemconvStability.OLD) {
                    if (xhrMem.status !== void 0) span.setAttribute($281a441cdcb2cf36$var$ATTR_HTTP_STATUS_CODE2, xhrMem.status);
                    if (xhrMem.statusText !== void 0) span.setAttribute($281a441cdcb2cf36$var$AttributeNames2.HTTP_STATUS_TEXT, xhrMem.statusText);
                    if (typeof spanUrl === "string") {
                        const parsedUrl = $281a441cdcb2cf36$var$parseUrl2(spanUrl);
                        span.setAttribute($281a441cdcb2cf36$var$ATTR_HTTP_HOST2, parsedUrl.host);
                        span.setAttribute($281a441cdcb2cf36$var$ATTR_HTTP_SCHEME2, parsedUrl.protocol.replace(":", ""));
                    }
                    span.setAttribute($281a441cdcb2cf36$var$ATTR_HTTP_USER_AGENT2, navigator.userAgent);
                }
                if (this._semconvStability & $281a441cdcb2cf36$var$SemconvStability.STABLE) {
                    if (xhrMem.status) span.setAttribute($281a441cdcb2cf36$var$ATTR_HTTP_RESPONSE_STATUS_CODE, xhrMem.status);
                }
            }
            _applyAttributesAfterXHR(span, xhr) {
                const applyCustomAttributesOnSpan = this.getConfig().applyCustomAttributesOnSpan;
                if (typeof applyCustomAttributesOnSpan === "function") $281a441cdcb2cf36$var$safeExecuteInTheMiddle(()=>applyCustomAttributesOnSpan(span, xhr), (error)=>{
                    if (!error) return;
                    this._diag.error("applyCustomAttributesOnSpan", error);
                }, true);
            }
            /**
       * will collect information about all resources created
       * between "send" and "end" with additional waiting for main resource
       * @param xhr
       * @param spanUrl
       * @private
       */ _addResourceObserver(xhr, spanUrl) {
                const xhrMem = this._xhrMem.get(xhr);
                if (!xhrMem || typeof PerformanceObserver !== "function" || typeof PerformanceResourceTiming !== "function") return;
                xhrMem.createdResources = {
                    observer: new PerformanceObserver((list)=>{
                        const entries = list.getEntries();
                        const parsedUrl = $281a441cdcb2cf36$var$parseUrl2(spanUrl);
                        entries.forEach((entry)=>{
                            if (entry.initiatorType === "xmlhttprequest" && entry.name === parsedUrl.href) {
                                if (xhrMem.createdResources) xhrMem.createdResources.entries.push(entry);
                            }
                        });
                    }),
                    entries: []
                };
                xhrMem.createdResources.observer.observe({
                    entryTypes: [
                        "resource"
                    ]
                });
            }
            /**
       * Clears the resource timings and all resources assigned with spans
       *     when {@link XMLHttpRequestInstrumentationConfig.clearTimingResources} is
       *     set to true (default false)
       * @private
       */ _clearResources() {
                if (this._tasksCount === 0 && this.getConfig().clearTimingResources) {
                    $281a441cdcb2cf36$var$otperformance3.clearResourceTimings();
                    this._xhrMem = /* @__PURE__ */ new WeakMap();
                    this._usedResources = /* @__PURE__ */ new WeakSet();
                }
            }
            /**
       * Finds appropriate resource and add network events to the span
       * @param span
       */ _findResourceAndAddNetworkEvents(xhrMem, span, spanUrl, startTime, endTime) {
                if (!spanUrl || !startTime || !endTime || !xhrMem.createdResources) return;
                let resources = xhrMem.createdResources.entries;
                if (!resources || !resources.length) resources = $281a441cdcb2cf36$var$otperformance3.getEntriesByType("resource");
                const resource = $281a441cdcb2cf36$var$getResource2($281a441cdcb2cf36$var$parseUrl2(spanUrl).href, startTime, endTime, resources, this._usedResources);
                if (resource.mainRequest) {
                    const mainRequest = resource.mainRequest;
                    this._markResourceAsUsed(mainRequest);
                    const corsPreFlightRequest = resource.corsPreFlightRequest;
                    if (corsPreFlightRequest) {
                        this._addChildSpan(span, corsPreFlightRequest);
                        this._markResourceAsUsed(corsPreFlightRequest);
                    }
                    const skipOldSemconvContentLengthAttrs = !(this._semconvStability & $281a441cdcb2cf36$var$SemconvStability.OLD);
                    $281a441cdcb2cf36$var$addSpanNetworkEvents2(span, mainRequest, this.getConfig().ignoreNetworkEvents, void 0, skipOldSemconvContentLengthAttrs);
                }
            }
            /**
       * Removes the previous information about span.
       * This might happened when the same xhr is used again.
       * @param xhr
       * @private
       */ _cleanPreviousSpanInformation(xhr) {
                const xhrMem = this._xhrMem.get(xhr);
                if (xhrMem) {
                    const callbackToRemoveEvents = xhrMem.callbackToRemoveEvents;
                    if (callbackToRemoveEvents) callbackToRemoveEvents();
                    this._xhrMem.delete(xhr);
                }
            }
            /**
       * Creates a new span when method "open" is called
       * @param xhr
       * @param url
       * @param method
       * @private
       */ _createSpan(xhr, url2, method) {
                if ($281a441cdcb2cf36$var$isUrlIgnored3(url2, this.getConfig().ignoreUrls)) {
                    this._diag.debug("ignoring span as url matches ignored url");
                    return;
                }
                let name = "";
                const parsedUrl = $281a441cdcb2cf36$var$parseUrl2(url2);
                const attributes = {};
                if (this._semconvStability & $281a441cdcb2cf36$var$SemconvStability.OLD) {
                    name = method.toUpperCase();
                    attributes[$281a441cdcb2cf36$var$ATTR_HTTP_METHOD2] = method;
                    attributes[$281a441cdcb2cf36$var$ATTR_HTTP_URL2] = parsedUrl.toString();
                }
                if (this._semconvStability & $281a441cdcb2cf36$var$SemconvStability.STABLE) {
                    const origMethod = method;
                    const normMethod = $281a441cdcb2cf36$var$normalizeHttpRequestMethod2(method);
                    if (!name) name = normMethod;
                    attributes[$281a441cdcb2cf36$var$ATTR_HTTP_REQUEST_METHOD] = normMethod;
                    if (normMethod !== origMethod) attributes[$281a441cdcb2cf36$var$ATTR_HTTP_REQUEST_METHOD_ORIGINAL] = origMethod;
                    attributes[$281a441cdcb2cf36$var$ATTR_URL_FULL] = parsedUrl.toString();
                    attributes[$281a441cdcb2cf36$var$ATTR_SERVER_ADDRESS] = parsedUrl.hostname;
                    const serverPort = $281a441cdcb2cf36$var$serverPortFromUrl2(parsedUrl);
                    if (serverPort) attributes[$281a441cdcb2cf36$var$ATTR_SERVER_PORT] = serverPort;
                }
                const currentSpan = this.tracer.startSpan(name, {
                    kind: $281a441cdcb2cf36$var$SpanKind.CLIENT,
                    attributes: attributes
                });
                currentSpan.addEvent($281a441cdcb2cf36$var$EventNames.METHOD_OPEN);
                this._cleanPreviousSpanInformation(xhr);
                this._xhrMem.set(xhr, {
                    span: currentSpan,
                    spanUrl: url2
                });
                return currentSpan;
            }
            /**
       * Marks certain [resource]{@link PerformanceResourceTiming} when information
       * from this is used to add events to span.
       * This is done to avoid reusing the same resource again for next span
       * @param resource
       * @private
       */ _markResourceAsUsed(resource) {
                this._usedResources.add(resource);
            }
            /**
       * Patches the method open
       * @private
       */ _patchOpen() {
                return (original)=>{
                    const plugin = this;
                    return function patchOpen(...args2) {
                        const method = args2[0];
                        const url2 = args2[1];
                        plugin._createSpan(this, url2, method);
                        return original.apply(this, args2);
                    };
                };
            }
            /**
       * Patches the method send
       * @private
       */ _patchSend() {
                const plugin = this;
                function endSpanTimeout(eventName, xhrMem, performanceEndTime, endTime) {
                    const callbackToRemoveEvents = xhrMem.callbackToRemoveEvents;
                    if (typeof callbackToRemoveEvents === "function") callbackToRemoveEvents();
                    const { span: span, spanUrl: spanUrl, sendStartTime: sendStartTime } = xhrMem;
                    if (span) {
                        plugin._findResourceAndAddNetworkEvents(xhrMem, span, spanUrl, sendStartTime, performanceEndTime);
                        span.addEvent(eventName, endTime);
                        plugin._addFinalSpanAttributes(span, xhrMem, spanUrl);
                        span.end(endTime);
                        plugin._tasksCount--;
                    }
                    plugin._clearResources();
                }
                function endSpan(eventName, xhr, isError2, errorType) {
                    const xhrMem = plugin._xhrMem.get(xhr);
                    if (!xhrMem) return;
                    xhrMem.status = xhr.status;
                    xhrMem.statusText = xhr.statusText;
                    plugin._xhrMem.delete(xhr);
                    if (xhrMem.span) {
                        const span = xhrMem.span;
                        plugin._applyAttributesAfterXHR(span, xhr);
                        if (plugin._semconvStability & $281a441cdcb2cf36$var$SemconvStability.STABLE) {
                            if (isError2) {
                                if (errorType) {
                                    span.setStatus({
                                        code: $281a441cdcb2cf36$var$SpanStatusCode.ERROR,
                                        message: errorType
                                    });
                                    span.setAttribute($281a441cdcb2cf36$var$ATTR_ERROR_TYPE, errorType);
                                }
                            } else if (xhrMem.status && xhrMem.status >= 400) {
                                span.setStatus({
                                    code: $281a441cdcb2cf36$var$SpanStatusCode.ERROR
                                });
                                span.setAttribute($281a441cdcb2cf36$var$ATTR_ERROR_TYPE, String(xhrMem.status));
                            }
                        }
                    }
                    const performanceEndTime = $281a441cdcb2cf36$var$hrTime3();
                    const endTime = Date.now();
                    setTimeout(()=>{
                        endSpanTimeout(eventName, xhrMem, performanceEndTime, endTime);
                    }, $281a441cdcb2cf36$var$OBSERVER_WAIT_TIME_MS2);
                }
                function onError() {
                    endSpan($281a441cdcb2cf36$var$EventNames.EVENT_ERROR, this, true, "error");
                }
                function onAbort() {
                    endSpan($281a441cdcb2cf36$var$EventNames.EVENT_ABORT, this, false);
                }
                function onTimeout() {
                    endSpan($281a441cdcb2cf36$var$EventNames.EVENT_TIMEOUT, this, true, "timeout");
                }
                function onLoad() {
                    if (this.status < 299) endSpan($281a441cdcb2cf36$var$EventNames.EVENT_LOAD, this, false);
                    else endSpan($281a441cdcb2cf36$var$EventNames.EVENT_ERROR, this, false);
                }
                function unregister(xhr) {
                    xhr.removeEventListener("abort", onAbort);
                    xhr.removeEventListener("error", onError);
                    xhr.removeEventListener("load", onLoad);
                    xhr.removeEventListener("timeout", onTimeout);
                    const xhrMem = plugin._xhrMem.get(xhr);
                    if (xhrMem) xhrMem.callbackToRemoveEvents = void 0;
                }
                return (original)=>{
                    return function patchSend(...args2) {
                        const xhrMem = plugin._xhrMem.get(this);
                        if (!xhrMem) return original.apply(this, args2);
                        const currentSpan = xhrMem.span;
                        const spanUrl = xhrMem.spanUrl;
                        if (currentSpan && spanUrl) {
                            if (plugin.getConfig().measureRequestSize && (args2 == null ? void 0 : args2[0])) {
                                const body = args2[0];
                                const bodyLength = $281a441cdcb2cf36$var$getXHRBodyLength2(body);
                                if (bodyLength !== void 0) {
                                    if (plugin._semconvStability & $281a441cdcb2cf36$var$SemconvStability.OLD) currentSpan.setAttribute($281a441cdcb2cf36$var$ATTR_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED2, bodyLength);
                                    if (plugin._semconvStability & $281a441cdcb2cf36$var$SemconvStability.STABLE) currentSpan.setAttribute($281a441cdcb2cf36$var$ATTR_HTTP_REQUEST_BODY_SIZE2, bodyLength);
                                }
                            }
                            $281a441cdcb2cf36$var$context.with($281a441cdcb2cf36$var$trace.setSpan($281a441cdcb2cf36$var$context.active(), currentSpan), ()=>{
                                plugin._tasksCount++;
                                xhrMem.sendStartTime = $281a441cdcb2cf36$var$hrTime3();
                                currentSpan.addEvent($281a441cdcb2cf36$var$EventNames.METHOD_SEND);
                                this.addEventListener("abort", onAbort);
                                this.addEventListener("error", onError);
                                this.addEventListener("load", onLoad);
                                this.addEventListener("timeout", onTimeout);
                                xhrMem.callbackToRemoveEvents = ()=>{
                                    unregister(this);
                                    if (xhrMem.createdResources) xhrMem.createdResources.observer.disconnect();
                                };
                                plugin._addHeaders(this, spanUrl);
                                plugin._addResourceObserver(this, spanUrl);
                            });
                        }
                        return original.apply(this, args2);
                    };
                };
            }
            /**
       * implements enable function
       */ enable() {
                this._diag.debug("applying patch to", this.moduleName, this.version);
                if ($281a441cdcb2cf36$var$isWrapped(XMLHttpRequest.prototype.open)) {
                    this._unwrap(XMLHttpRequest.prototype, "open");
                    this._diag.debug("removing previous patch from method open");
                }
                if ($281a441cdcb2cf36$var$isWrapped(XMLHttpRequest.prototype.send)) {
                    this._unwrap(XMLHttpRequest.prototype, "send");
                    this._diag.debug("removing previous patch from method send");
                }
                this._wrap(XMLHttpRequest.prototype, "open", this._patchOpen());
                this._wrap(XMLHttpRequest.prototype, "send", this._patchSend());
            }
            /**
       * implements disable function
       */ disable() {
                this._diag.debug("removing patch from", this.moduleName, this.version);
                this._unwrap(XMLHttpRequest.prototype, "open");
                this._unwrap(XMLHttpRequest.prototype, "send");
                this._tasksCount = 0;
                this._xhrMem = /* @__PURE__ */ new WeakMap();
                this._usedResources = /* @__PURE__ */ new WeakSet();
            }
        };
    }
});
// ../node_modules/@opentelemetry/instrumentation-xml-http-request/build/esm/index.js
var $281a441cdcb2cf36$var$init_esm13 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/instrumentation-xml-http-request/build/esm/index.js" () {
        $281a441cdcb2cf36$var$init_xhr();
    }
});
// ../node_modules/@grafana/faro-web-tracing/dist/esm/faroXhrInstrumentation.js
var $281a441cdcb2cf36$var$FaroXhrInstrumentation;
var $281a441cdcb2cf36$var$init_faroXhrInstrumentation = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-tracing/dist/esm/faroXhrInstrumentation.js" () {
        $281a441cdcb2cf36$var$init_esm13();
        $281a441cdcb2cf36$var$init_esm5();
        $281a441cdcb2cf36$var$FaroXhrInstrumentation = class extends $281a441cdcb2cf36$var$XMLHttpRequestInstrumentation {
            constructor(config = {}){
                super(config);
                const self2 = this;
                this.parentCreateSpan = self2._createSpan.bind(this);
            }
            // Patching the parent's private method to handle url type string or URL
            _patchOpen() {
                return (original)=>{
                    const plugin = this;
                    return function patchOpen(...args2) {
                        try {
                            const method = args2[0];
                            let url2 = $281a441cdcb2cf36$var$getUrlFromResource(args2[1]);
                            plugin.parentCreateSpan(this, url2, method);
                        } catch (error) {
                            $281a441cdcb2cf36$var$faro.internalLogger.error(error);
                        }
                        return original.apply(this, args2);
                    };
                };
            }
        };
    }
});
// ../node_modules/@grafana/faro-web-tracing/dist/esm/instrumentationUtils.js
function $281a441cdcb2cf36$var$setSpanStatusOnFetchError(span, _request2, result) {
    const httpStatusCode = result instanceof Error ? 0 : result.status;
    $281a441cdcb2cf36$var$setSpanStatus(span, httpStatusCode);
}
function $281a441cdcb2cf36$var$setSpanStatusOnXMLHttpRequestError(span, xhr) {
    $281a441cdcb2cf36$var$setSpanStatus(span, xhr.status);
}
function $281a441cdcb2cf36$var$setSpanStatus(span, httpStatusCode) {
    if (httpStatusCode == null) return;
    const isError2 = httpStatusCode === 0;
    const isClientOrServerError = httpStatusCode >= 400 && httpStatusCode < 600;
    if (isError2 || isClientOrServerError) span.setStatus({
        code: $281a441cdcb2cf36$var$SpanStatusCode.ERROR
    });
}
function $281a441cdcb2cf36$var$fetchCustomAttributeFunctionWithDefaults(callback) {
    return (span, request, result)=>{
        $281a441cdcb2cf36$var$setSpanStatusOnFetchError(span, request, result);
        callback === null || callback === void 0 || callback(span, request, result);
    };
}
function $281a441cdcb2cf36$var$xhrCustomAttributeFunctionWithDefaults(callback) {
    return (span, xhr)=>{
        $281a441cdcb2cf36$var$setSpanStatusOnXMLHttpRequestError(span, xhr);
        callback === null || callback === void 0 || callback(span, xhr);
    };
}
var $281a441cdcb2cf36$var$init_instrumentationUtils = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-tracing/dist/esm/instrumentationUtils.js" () {
        $281a441cdcb2cf36$var$init_esm();
    }
});
// ../node_modules/@grafana/faro-web-tracing/dist/esm/getDefaultOTELInstrumentations.js
function $281a441cdcb2cf36$var$getDefaultOTELInstrumentations(options = {}) {
    const { fetchInstrumentationOptions: fetchInstrumentationOptions, xhrInstrumentationOptions: xhrInstrumentationOptions } = options, sharedOptions = $281a441cdcb2cf36$var$__rest3(options, [
        "fetchInstrumentationOptions",
        "xhrInstrumentationOptions"
    ]);
    const fetchOpts = $281a441cdcb2cf36$var$createFetchInstrumentationOptions(fetchInstrumentationOptions, sharedOptions);
    const xhrOpts = $281a441cdcb2cf36$var$createXhrInstrumentationOptions(xhrInstrumentationOptions, sharedOptions);
    return [
        new $281a441cdcb2cf36$var$FetchInstrumentation(fetchOpts),
        new $281a441cdcb2cf36$var$FaroXhrInstrumentation(xhrOpts)
    ];
}
function $281a441cdcb2cf36$var$createFetchInstrumentationOptions(fetchInstrumentationOptions, sharedOptions) {
    return Object.assign(Object.assign(Object.assign(Object.assign({}, sharedOptions), {
        ignoreNetworkEvents: true
    }), fetchInstrumentationOptions), {
        // always keep this function
        applyCustomAttributesOnSpan: $281a441cdcb2cf36$var$fetchCustomAttributeFunctionWithDefaults(fetchInstrumentationOptions === null || fetchInstrumentationOptions === void 0 ? void 0 : fetchInstrumentationOptions.applyCustomAttributesOnSpan)
    });
}
function $281a441cdcb2cf36$var$createXhrInstrumentationOptions(xhrInstrumentationOptions, sharedOptions) {
    return Object.assign(Object.assign(Object.assign(Object.assign({}, sharedOptions), {
        ignoreNetworkEvents: true
    }), xhrInstrumentationOptions), {
        // always keep this function
        applyCustomAttributesOnSpan: $281a441cdcb2cf36$var$xhrCustomAttributeFunctionWithDefaults(xhrInstrumentationOptions === null || xhrInstrumentationOptions === void 0 ? void 0 : xhrInstrumentationOptions.applyCustomAttributesOnSpan)
    });
}
var $281a441cdcb2cf36$var$__rest3;
var $281a441cdcb2cf36$var$init_getDefaultOTELInstrumentations = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-tracing/dist/esm/getDefaultOTELInstrumentations.js" () {
        $281a441cdcb2cf36$var$init_esm10();
        $281a441cdcb2cf36$var$init_faroXhrInstrumentation();
        $281a441cdcb2cf36$var$init_instrumentationUtils();
        $281a441cdcb2cf36$var$__rest3 = function(s3, e4) {
            var t4 = {};
            for(var p3 in s3)if (Object.prototype.hasOwnProperty.call(s3, p3) && e4.indexOf(p3) < 0) t4[p3] = s3[p3];
            if (s3 != null && typeof Object.getOwnPropertySymbols === "function") {
                for(var i3 = 0, p3 = Object.getOwnPropertySymbols(s3); i3 < p3.length; i3++)if (e4.indexOf(p3[i3]) < 0 && Object.prototype.propertyIsEnumerable.call(s3, p3[i3])) t4[p3[i3]] = s3[p3[i3]];
            }
            return t4;
        };
    }
});
// ../node_modules/@opentelemetry/resources/build/esm/default-service-name.js
function $281a441cdcb2cf36$var$defaultServiceName() {
    if ($281a441cdcb2cf36$var$serviceName === void 0) try {
        const argv0 = globalThis.process.argv0;
        $281a441cdcb2cf36$var$serviceName = argv0 ? `unknown_service:${argv0}` : "unknown_service";
    } catch  {
        $281a441cdcb2cf36$var$serviceName = "unknown_service";
    }
    return $281a441cdcb2cf36$var$serviceName;
}
var $281a441cdcb2cf36$var$serviceName;
var $281a441cdcb2cf36$var$init_default_service_name = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/resources/build/esm/default-service-name.js" () {}
});
// ../node_modules/@opentelemetry/resources/build/esm/utils.js
var $281a441cdcb2cf36$var$isPromiseLike;
var $281a441cdcb2cf36$var$init_utils14 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/resources/build/esm/utils.js" () {
        $281a441cdcb2cf36$var$isPromiseLike = (val)=>{
            return val !== null && typeof val === "object" && typeof val.then === "function";
        };
    }
});
// ../node_modules/@opentelemetry/resources/build/esm/ResourceImpl.js
function $281a441cdcb2cf36$var$resourceFromAttributes(attributes, options) {
    return $281a441cdcb2cf36$var$ResourceImpl.FromAttributeList(Object.entries(attributes), options);
}
function $281a441cdcb2cf36$var$defaultResource() {
    return $281a441cdcb2cf36$var$resourceFromAttributes({
        [$281a441cdcb2cf36$var$ATTR_SERVICE_NAME]: $281a441cdcb2cf36$var$defaultServiceName(),
        [$281a441cdcb2cf36$var$ATTR_TELEMETRY_SDK_LANGUAGE]: $281a441cdcb2cf36$var$SDK_INFO[$281a441cdcb2cf36$var$ATTR_TELEMETRY_SDK_LANGUAGE],
        [$281a441cdcb2cf36$var$ATTR_TELEMETRY_SDK_NAME]: $281a441cdcb2cf36$var$SDK_INFO[$281a441cdcb2cf36$var$ATTR_TELEMETRY_SDK_NAME],
        [$281a441cdcb2cf36$var$ATTR_TELEMETRY_SDK_VERSION]: $281a441cdcb2cf36$var$SDK_INFO[$281a441cdcb2cf36$var$ATTR_TELEMETRY_SDK_VERSION]
    });
}
function $281a441cdcb2cf36$var$guardedRawAttributes(attributes) {
    return attributes.map(([k3, v3])=>{
        if ($281a441cdcb2cf36$var$isPromiseLike(v3)) return [
            k3,
            v3.catch((err)=>{
                $281a441cdcb2cf36$var$diag2.debug("promise rejection for resource attribute: %s - %s", k3, err);
                return void 0;
            })
        ];
        return [
            k3,
            v3
        ];
    });
}
function $281a441cdcb2cf36$var$validateSchemaUrl(schemaUrl) {
    if (typeof schemaUrl === "string" || schemaUrl === void 0) return schemaUrl;
    $281a441cdcb2cf36$var$diag2.warn("Schema URL must be string or undefined, got %s. Schema URL will be ignored.", schemaUrl);
    return void 0;
}
function $281a441cdcb2cf36$var$mergeSchemaUrl(old, updating) {
    const oldSchemaUrl = old == null ? void 0 : old.schemaUrl;
    const updatingSchemaUrl = updating == null ? void 0 : updating.schemaUrl;
    const isOldEmpty = oldSchemaUrl === void 0 || oldSchemaUrl === "";
    const isUpdatingEmpty = updatingSchemaUrl === void 0 || updatingSchemaUrl === "";
    if (isOldEmpty) return updatingSchemaUrl;
    if (isUpdatingEmpty) return oldSchemaUrl;
    if (oldSchemaUrl === updatingSchemaUrl) return oldSchemaUrl;
    $281a441cdcb2cf36$var$diag2.warn('Schema URL merge conflict: old resource has "%s", updating resource has "%s". Resulting resource will have undefined Schema URL.', oldSchemaUrl, updatingSchemaUrl);
    return void 0;
}
var $281a441cdcb2cf36$var$ResourceImpl;
var $281a441cdcb2cf36$var$init_ResourceImpl = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/resources/build/esm/ResourceImpl.js" () {
        $281a441cdcb2cf36$var$init_esm();
        $281a441cdcb2cf36$var$init_esm3();
        $281a441cdcb2cf36$var$init_esm2();
        $281a441cdcb2cf36$var$init_default_service_name();
        $281a441cdcb2cf36$var$init_utils14();
        $281a441cdcb2cf36$var$ResourceImpl = class _ResourceImpl {
            constructor(resource, options){
                $281a441cdcb2cf36$var$__publicField(this, "_rawAttributes");
                $281a441cdcb2cf36$var$__publicField(this, "_asyncAttributesPending", false);
                $281a441cdcb2cf36$var$__publicField(this, "_schemaUrl");
                $281a441cdcb2cf36$var$__publicField(this, "_memoizedAttributes");
                var _a2;
                const attributes = (_a2 = resource.attributes) != null ? _a2 : {};
                this._rawAttributes = Object.entries(attributes).map(([k3, v3])=>{
                    if ($281a441cdcb2cf36$var$isPromiseLike(v3)) this._asyncAttributesPending = true;
                    return [
                        k3,
                        v3
                    ];
                });
                this._rawAttributes = $281a441cdcb2cf36$var$guardedRawAttributes(this._rawAttributes);
                this._schemaUrl = $281a441cdcb2cf36$var$validateSchemaUrl(options == null ? void 0 : options.schemaUrl);
            }
            static FromAttributeList(attributes, options) {
                const res = new _ResourceImpl({}, options);
                res._rawAttributes = $281a441cdcb2cf36$var$guardedRawAttributes(attributes);
                res._asyncAttributesPending = attributes.filter(([_3, val])=>$281a441cdcb2cf36$var$isPromiseLike(val)).length > 0;
                return res;
            }
            get asyncAttributesPending() {
                return this._asyncAttributesPending;
            }
            async waitForAsyncAttributes() {
                if (!this.asyncAttributesPending) return;
                for(let i3 = 0; i3 < this._rawAttributes.length; i3++){
                    const [k3, v3] = this._rawAttributes[i3];
                    this._rawAttributes[i3] = [
                        k3,
                        $281a441cdcb2cf36$var$isPromiseLike(v3) ? await v3 : v3
                    ];
                }
                this._asyncAttributesPending = false;
            }
            get attributes() {
                var _a2;
                if (this.asyncAttributesPending) $281a441cdcb2cf36$var$diag2.error("Accessing resource attributes before async attributes settled");
                if (this._memoizedAttributes) return this._memoizedAttributes;
                const attrs = {};
                for (const [k3, v3] of this._rawAttributes){
                    if ($281a441cdcb2cf36$var$isPromiseLike(v3)) {
                        $281a441cdcb2cf36$var$diag2.debug(`Unsettled resource attribute ${k3} skipped`);
                        continue;
                    }
                    if (v3 != null) (_a2 = attrs[k3]) != null ? _a2 : attrs[k3] = v3;
                }
                if (!this._asyncAttributesPending) this._memoizedAttributes = attrs;
                return attrs;
            }
            getRawAttributes() {
                return this._rawAttributes;
            }
            get schemaUrl() {
                return this._schemaUrl;
            }
            merge(resource) {
                if (resource == null) return this;
                const mergedSchemaUrl = $281a441cdcb2cf36$var$mergeSchemaUrl(this, resource);
                const mergedOptions = mergedSchemaUrl ? {
                    schemaUrl: mergedSchemaUrl
                } : void 0;
                return _ResourceImpl.FromAttributeList([
                    ...resource.getRawAttributes(),
                    ...this.getRawAttributes()
                ], mergedOptions);
            }
        };
    }
});
// ../node_modules/@opentelemetry/resources/build/esm/index.js
var $281a441cdcb2cf36$var$init_esm14 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/resources/build/esm/index.js" () {
        $281a441cdcb2cf36$var$init_ResourceImpl();
    }
});
// ../node_modules/@opentelemetry/sdk-trace-web/node_modules/@opentelemetry/sdk-trace-base/build/esm/enums.js
var $281a441cdcb2cf36$var$ExceptionEventName;
var $281a441cdcb2cf36$var$init_enums = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/sdk-trace-web/node_modules/@opentelemetry/sdk-trace-base/build/esm/enums.js" () {
        $281a441cdcb2cf36$var$ExceptionEventName = "exception";
    }
});
// ../node_modules/@opentelemetry/sdk-trace-web/node_modules/@opentelemetry/sdk-trace-base/build/esm/Span.js
var $281a441cdcb2cf36$var$SpanImpl;
var $281a441cdcb2cf36$var$init_Span = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/sdk-trace-web/node_modules/@opentelemetry/sdk-trace-base/build/esm/Span.js" () {
        $281a441cdcb2cf36$var$init_esm();
        $281a441cdcb2cf36$var$init_esm3();
        $281a441cdcb2cf36$var$init_esm2();
        $281a441cdcb2cf36$var$init_enums();
        $281a441cdcb2cf36$var$SpanImpl = class {
            /**
       * Constructs a new SpanImpl instance.
       */ constructor(opts){
                // Below properties are included to implement ReadableSpan for export
                // purposes but are not intended to be written-to directly.
                $281a441cdcb2cf36$var$__publicField(this, "_spanContext");
                $281a441cdcb2cf36$var$__publicField(this, "kind");
                $281a441cdcb2cf36$var$__publicField(this, "parentSpanContext");
                $281a441cdcb2cf36$var$__publicField(this, "attributes", {});
                $281a441cdcb2cf36$var$__publicField(this, "links", []);
                $281a441cdcb2cf36$var$__publicField(this, "events", []);
                $281a441cdcb2cf36$var$__publicField(this, "startTime");
                $281a441cdcb2cf36$var$__publicField(this, "resource");
                $281a441cdcb2cf36$var$__publicField(this, "instrumentationScope");
                $281a441cdcb2cf36$var$__publicField(this, "_droppedAttributesCount", 0);
                $281a441cdcb2cf36$var$__publicField(this, "_droppedEventsCount", 0);
                $281a441cdcb2cf36$var$__publicField(this, "_droppedLinksCount", 0);
                $281a441cdcb2cf36$var$__publicField(this, "_attributesCount", 0);
                $281a441cdcb2cf36$var$__publicField(this, "name");
                $281a441cdcb2cf36$var$__publicField(this, "status", {
                    code: $281a441cdcb2cf36$var$SpanStatusCode.UNSET
                });
                $281a441cdcb2cf36$var$__publicField(this, "endTime", [
                    0,
                    0
                ]);
                $281a441cdcb2cf36$var$__publicField(this, "_ended", false);
                $281a441cdcb2cf36$var$__publicField(this, "_duration", [
                    -1,
                    -1
                ]);
                $281a441cdcb2cf36$var$__publicField(this, "_spanProcessor");
                $281a441cdcb2cf36$var$__publicField(this, "_spanLimits");
                $281a441cdcb2cf36$var$__publicField(this, "_attributeValueLengthLimit");
                $281a441cdcb2cf36$var$__publicField(this, "_recordEndMetrics");
                $281a441cdcb2cf36$var$__publicField(this, "_performanceStartTime");
                $281a441cdcb2cf36$var$__publicField(this, "_performanceOffset");
                $281a441cdcb2cf36$var$__publicField(this, "_startTimeProvided");
                var _a2, _b;
                const now = Date.now();
                this._spanContext = opts.spanContext;
                this._performanceStartTime = $281a441cdcb2cf36$var$otperformance.now();
                this._performanceOffset = now - (this._performanceStartTime + $281a441cdcb2cf36$var$otperformance.timeOrigin);
                this._startTimeProvided = opts.startTime != null;
                this._spanLimits = opts.spanLimits;
                this._attributeValueLengthLimit = (_a2 = this._spanLimits.attributeValueLengthLimit) != null ? _a2 : 0;
                this._spanProcessor = opts.spanProcessor;
                this.name = opts.name;
                this.parentSpanContext = opts.parentSpanContext;
                this.kind = opts.kind;
                if (opts.links) for (const link of opts.links)this.addLink(link);
                this.startTime = this._getTime((_b = opts.startTime) != null ? _b : now);
                this.resource = opts.resource;
                this.instrumentationScope = opts.scope;
                this._recordEndMetrics = opts.recordEndMetrics;
                if (opts.attributes != null) this.setAttributes(opts.attributes);
                this._spanProcessor.onStart(this, opts.context);
            }
            spanContext() {
                return this._spanContext;
            }
            setAttribute(key, value2) {
                if (value2 == null || this._isSpanEnded()) return this;
                if (key.length === 0) {
                    $281a441cdcb2cf36$var$diag2.warn(`Invalid attribute key: ${key}`);
                    return this;
                }
                if (!$281a441cdcb2cf36$var$isAttributeValue(value2)) {
                    $281a441cdcb2cf36$var$diag2.warn(`Invalid attribute value set for key: ${key}`);
                    return this;
                }
                const { attributeCountLimit: attributeCountLimit } = this._spanLimits;
                const isNewKey = !Object.prototype.hasOwnProperty.call(this.attributes, key);
                if (attributeCountLimit !== void 0 && this._attributesCount >= attributeCountLimit && isNewKey) {
                    this._droppedAttributesCount++;
                    return this;
                }
                this.attributes[key] = this._truncateToSize(value2);
                if (isNewKey) this._attributesCount++;
                return this;
            }
            setAttributes(attributes) {
                for(const key in attributes)if (Object.prototype.hasOwnProperty.call(attributes, key)) this.setAttribute(key, attributes[key]);
                return this;
            }
            /**
       *
       * @param name Span Name
       * @param [attributesOrStartTime] Span attributes or start time
       *     if type is {@type TimeInput} and 3rd param is undefined
       * @param [timeStamp] Specified time stamp for the event
       */ addEvent(name, attributesOrStartTime, timeStamp) {
                if (this._isSpanEnded()) return this;
                const { eventCountLimit: eventCountLimit } = this._spanLimits;
                if (eventCountLimit === 0) {
                    $281a441cdcb2cf36$var$diag2.warn("No events allowed.");
                    this._droppedEventsCount++;
                    return this;
                }
                if (eventCountLimit !== void 0 && this.events.length >= eventCountLimit) {
                    if (this._droppedEventsCount === 0) $281a441cdcb2cf36$var$diag2.debug("Dropping extra events.");
                    this.events.shift();
                    this._droppedEventsCount++;
                }
                if ($281a441cdcb2cf36$var$isTimeInput(attributesOrStartTime)) {
                    if (!$281a441cdcb2cf36$var$isTimeInput(timeStamp)) timeStamp = attributesOrStartTime;
                    attributesOrStartTime = void 0;
                }
                const sanitized = $281a441cdcb2cf36$var$sanitizeAttributes(attributesOrStartTime);
                const { attributePerEventCountLimit: attributePerEventCountLimit } = this._spanLimits;
                const attributes = {};
                let droppedAttributesCount = 0;
                let eventAttributesCount = 0;
                for(const attr in sanitized){
                    if (!Object.prototype.hasOwnProperty.call(sanitized, attr)) continue;
                    const attrVal = sanitized[attr];
                    if (attributePerEventCountLimit !== void 0 && eventAttributesCount >= attributePerEventCountLimit) {
                        droppedAttributesCount++;
                        continue;
                    }
                    attributes[attr] = this._truncateToSize(attrVal);
                    eventAttributesCount++;
                }
                this.events.push({
                    name: name,
                    attributes: attributes,
                    time: this._getTime(timeStamp),
                    droppedAttributesCount: droppedAttributesCount
                });
                return this;
            }
            addLink(link) {
                if (this._isSpanEnded()) return this;
                const { linkCountLimit: linkCountLimit } = this._spanLimits;
                if (linkCountLimit === 0) {
                    this._droppedLinksCount++;
                    return this;
                }
                if (linkCountLimit !== void 0 && this.links.length >= linkCountLimit) {
                    if (this._droppedLinksCount === 0) $281a441cdcb2cf36$var$diag2.debug("Dropping extra links.");
                    this.links.shift();
                    this._droppedLinksCount++;
                }
                const { attributePerLinkCountLimit: attributePerLinkCountLimit } = this._spanLimits;
                const sanitized = $281a441cdcb2cf36$var$sanitizeAttributes(link.attributes);
                const attributes = {};
                let droppedAttributesCount = 0;
                let linkAttributesCount = 0;
                for(const attr in sanitized){
                    if (!Object.prototype.hasOwnProperty.call(sanitized, attr)) continue;
                    const attrVal = sanitized[attr];
                    if (attributePerLinkCountLimit !== void 0 && linkAttributesCount >= attributePerLinkCountLimit) {
                        droppedAttributesCount++;
                        continue;
                    }
                    attributes[attr] = this._truncateToSize(attrVal);
                    linkAttributesCount++;
                }
                const processedLink = {
                    context: link.context
                };
                if (linkAttributesCount > 0) processedLink.attributes = attributes;
                if (droppedAttributesCount > 0) processedLink.droppedAttributesCount = droppedAttributesCount;
                this.links.push(processedLink);
                return this;
            }
            addLinks(links) {
                for (const link of links)this.addLink(link);
                return this;
            }
            setStatus(status) {
                if (this._isSpanEnded()) return this;
                if (status.code === $281a441cdcb2cf36$var$SpanStatusCode.UNSET) return this;
                if (this.status.code === $281a441cdcb2cf36$var$SpanStatusCode.OK) return this;
                const newStatus = {
                    code: status.code
                };
                if (status.code === $281a441cdcb2cf36$var$SpanStatusCode.ERROR) {
                    if (typeof status.message === "string") newStatus.message = status.message;
                    else if (status.message != null) $281a441cdcb2cf36$var$diag2.warn(`Dropping invalid status.message of type '${typeof status.message}', expected 'string'`);
                }
                this.status = newStatus;
                return this;
            }
            updateName(name) {
                if (this._isSpanEnded()) return this;
                this.name = name;
                return this;
            }
            end(endTime) {
                var _a2;
                if (this._isSpanEnded()) {
                    $281a441cdcb2cf36$var$diag2.error(`${this.name} ${this._spanContext.traceId}-${this._spanContext.spanId} - You can only call end() on a span once.`);
                    return;
                }
                this.endTime = this._getTime(endTime);
                this._duration = $281a441cdcb2cf36$var$hrTimeDuration(this.startTime, this.endTime);
                if (this._duration[0] < 0) {
                    $281a441cdcb2cf36$var$diag2.warn("Inconsistent start and end time, startTime > endTime. Setting span duration to 0ms.", this.startTime, this.endTime);
                    this.endTime = this.startTime.slice();
                    this._duration = [
                        0,
                        0
                    ];
                }
                if (this._droppedEventsCount > 0) $281a441cdcb2cf36$var$diag2.warn(`Dropped ${this._droppedEventsCount} events because eventCountLimit reached`);
                if (this._droppedLinksCount > 0) $281a441cdcb2cf36$var$diag2.warn(`Dropped ${this._droppedLinksCount} links because linkCountLimit reached`);
                if (this._spanProcessor.onEnding) this._spanProcessor.onEnding(this);
                (_a2 = this._recordEndMetrics) == null || _a2.call(this);
                this._ended = true;
                this._spanProcessor.onEnd(this);
            }
            _getTime(inp) {
                if (typeof inp === "number" && inp <= $281a441cdcb2cf36$var$otperformance.now()) return $281a441cdcb2cf36$var$hrTime(inp + this._performanceOffset);
                if (typeof inp === "number") return $281a441cdcb2cf36$var$millisToHrTime(inp);
                if (inp instanceof Date) return $281a441cdcb2cf36$var$millisToHrTime(inp.getTime());
                if ($281a441cdcb2cf36$var$isTimeInputHrTime(inp)) return inp;
                if (this._startTimeProvided) return $281a441cdcb2cf36$var$millisToHrTime(Date.now());
                const msDuration = $281a441cdcb2cf36$var$otperformance.now() - this._performanceStartTime;
                return $281a441cdcb2cf36$var$addHrTimes(this.startTime, $281a441cdcb2cf36$var$millisToHrTime(msDuration));
            }
            isRecording() {
                return this._ended === false;
            }
            recordException(exception, time) {
                const attributes = {};
                if (typeof exception === "string") attributes[$281a441cdcb2cf36$var$ATTR_EXCEPTION_MESSAGE] = exception;
                else if (exception) {
                    if (exception.code) attributes[$281a441cdcb2cf36$var$ATTR_EXCEPTION_TYPE] = exception.code.toString();
                    else if (exception.name) attributes[$281a441cdcb2cf36$var$ATTR_EXCEPTION_TYPE] = exception.name;
                    if (exception.message) attributes[$281a441cdcb2cf36$var$ATTR_EXCEPTION_MESSAGE] = exception.message;
                    if (exception.stack) attributes[$281a441cdcb2cf36$var$ATTR_EXCEPTION_STACKTRACE] = exception.stack;
                }
                if (attributes[$281a441cdcb2cf36$var$ATTR_EXCEPTION_TYPE] || attributes[$281a441cdcb2cf36$var$ATTR_EXCEPTION_MESSAGE]) this.addEvent($281a441cdcb2cf36$var$ExceptionEventName, attributes, time);
                else $281a441cdcb2cf36$var$diag2.warn(`Failed to record an exception ${exception}`);
            }
            get duration() {
                return this._duration;
            }
            get ended() {
                return this._ended;
            }
            get droppedAttributesCount() {
                return this._droppedAttributesCount;
            }
            get droppedEventsCount() {
                return this._droppedEventsCount;
            }
            get droppedLinksCount() {
                return this._droppedLinksCount;
            }
            _isSpanEnded() {
                if (this._ended) {
                    const error = new Error(`Operation attempted on ended Span {traceId: ${this._spanContext.traceId}, spanId: ${this._spanContext.spanId}}`);
                    $281a441cdcb2cf36$var$diag2.warn(`Cannot execute the operation on ended Span {traceId: ${this._spanContext.traceId}, spanId: ${this._spanContext.spanId}}`, error);
                }
                return this._ended;
            }
            // Utility function to truncate given value within size
            // for value type of string, will truncate to given limit
            // for type of non-string, will return same value
            _truncateToLimitUtil(value2, limit) {
                if (value2.length <= limit) return value2;
                return value2.substring(0, limit);
            }
            /**
       * If the given attribute value is of type string and has more characters than given {@code attributeValueLengthLimit} then
       * return string with truncated to {@code attributeValueLengthLimit} characters
       *
       * If the given attribute value is array of strings then
       * return new array of strings with each element truncated to {@code attributeValueLengthLimit} characters
       *
       * Otherwise return same Attribute {@code value}
       *
       * @param value Attribute value
       * @returns truncated attribute value if required, otherwise same value
       */ _truncateToSize(value2) {
                const limit = this._attributeValueLengthLimit;
                if (limit <= 0) {
                    $281a441cdcb2cf36$var$diag2.warn(`Attribute value limit must be positive, got ${limit}`);
                    return value2;
                }
                if (typeof value2 === "string") return this._truncateToLimitUtil(value2, limit);
                if (Array.isArray(value2)) return value2.map((val)=>typeof val === "string" ? this._truncateToLimitUtil(val, limit) : val);
                return value2;
            }
        };
    }
});
// ../node_modules/@opentelemetry/sdk-trace-web/node_modules/@opentelemetry/sdk-trace-base/build/esm/Sampler.js
var $281a441cdcb2cf36$var$SamplingDecision2;
var $281a441cdcb2cf36$var$init_Sampler = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/sdk-trace-web/node_modules/@opentelemetry/sdk-trace-base/build/esm/Sampler.js" () {
        (function(SamplingDecision3) {
            SamplingDecision3[SamplingDecision3["NOT_RECORD"] = 0] = "NOT_RECORD";
            SamplingDecision3[SamplingDecision3["RECORD"] = 1] = "RECORD";
            SamplingDecision3[SamplingDecision3["RECORD_AND_SAMPLED"] = 2] = "RECORD_AND_SAMPLED";
        })($281a441cdcb2cf36$var$SamplingDecision2 || ($281a441cdcb2cf36$var$SamplingDecision2 = {}));
    }
});
// ../node_modules/@opentelemetry/sdk-trace-web/node_modules/@opentelemetry/sdk-trace-base/build/esm/sampler/AlwaysOffSampler.js
var $281a441cdcb2cf36$var$AlwaysOffSampler;
var $281a441cdcb2cf36$var$init_AlwaysOffSampler = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/sdk-trace-web/node_modules/@opentelemetry/sdk-trace-base/build/esm/sampler/AlwaysOffSampler.js" () {
        $281a441cdcb2cf36$var$init_Sampler();
        $281a441cdcb2cf36$var$AlwaysOffSampler = class {
            shouldSample() {
                return {
                    decision: $281a441cdcb2cf36$var$SamplingDecision2.NOT_RECORD
                };
            }
            toString() {
                return "AlwaysOffSampler";
            }
        };
    }
});
// ../node_modules/@opentelemetry/sdk-trace-web/node_modules/@opentelemetry/sdk-trace-base/build/esm/sampler/AlwaysOnSampler.js
var $281a441cdcb2cf36$var$AlwaysOnSampler;
var $281a441cdcb2cf36$var$init_AlwaysOnSampler = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/sdk-trace-web/node_modules/@opentelemetry/sdk-trace-base/build/esm/sampler/AlwaysOnSampler.js" () {
        $281a441cdcb2cf36$var$init_Sampler();
        $281a441cdcb2cf36$var$AlwaysOnSampler = class {
            shouldSample() {
                return {
                    decision: $281a441cdcb2cf36$var$SamplingDecision2.RECORD_AND_SAMPLED
                };
            }
            toString() {
                return "AlwaysOnSampler";
            }
        };
    }
});
// ../node_modules/@opentelemetry/sdk-trace-web/node_modules/@opentelemetry/sdk-trace-base/build/esm/sampler/ParentBasedSampler.js
var $281a441cdcb2cf36$var$ParentBasedSampler;
var $281a441cdcb2cf36$var$init_ParentBasedSampler = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/sdk-trace-web/node_modules/@opentelemetry/sdk-trace-base/build/esm/sampler/ParentBasedSampler.js" () {
        $281a441cdcb2cf36$var$init_esm();
        $281a441cdcb2cf36$var$init_esm3();
        $281a441cdcb2cf36$var$init_AlwaysOffSampler();
        $281a441cdcb2cf36$var$init_AlwaysOnSampler();
        $281a441cdcb2cf36$var$ParentBasedSampler = class {
            constructor(config){
                $281a441cdcb2cf36$var$__publicField(this, "_root");
                $281a441cdcb2cf36$var$__publicField(this, "_remoteParentSampled");
                $281a441cdcb2cf36$var$__publicField(this, "_remoteParentNotSampled");
                $281a441cdcb2cf36$var$__publicField(this, "_localParentSampled");
                $281a441cdcb2cf36$var$__publicField(this, "_localParentNotSampled");
                var _a2, _b, _c, _d;
                this._root = config.root;
                if (!this._root) {
                    $281a441cdcb2cf36$var$globalErrorHandler(new Error("ParentBasedSampler must have a root sampler configured"));
                    this._root = new $281a441cdcb2cf36$var$AlwaysOnSampler();
                }
                this._remoteParentSampled = (_a2 = config.remoteParentSampled) != null ? _a2 : new $281a441cdcb2cf36$var$AlwaysOnSampler();
                this._remoteParentNotSampled = (_b = config.remoteParentNotSampled) != null ? _b : new $281a441cdcb2cf36$var$AlwaysOffSampler();
                this._localParentSampled = (_c = config.localParentSampled) != null ? _c : new $281a441cdcb2cf36$var$AlwaysOnSampler();
                this._localParentNotSampled = (_d = config.localParentNotSampled) != null ? _d : new $281a441cdcb2cf36$var$AlwaysOffSampler();
            }
            shouldSample(context2, traceId, spanName, spanKind, attributes, links) {
                const parentContext = $281a441cdcb2cf36$var$trace.getSpanContext(context2);
                if (!parentContext || !$281a441cdcb2cf36$var$isSpanContextValid(parentContext)) return this._root.shouldSample(context2, traceId, spanName, spanKind, attributes, links);
                if (parentContext.isRemote) {
                    if (parentContext.traceFlags & $281a441cdcb2cf36$var$TraceFlags.SAMPLED) return this._remoteParentSampled.shouldSample(context2, traceId, spanName, spanKind, attributes, links);
                    return this._remoteParentNotSampled.shouldSample(context2, traceId, spanName, spanKind, attributes, links);
                }
                if (parentContext.traceFlags & $281a441cdcb2cf36$var$TraceFlags.SAMPLED) return this._localParentSampled.shouldSample(context2, traceId, spanName, spanKind, attributes, links);
                return this._localParentNotSampled.shouldSample(context2, traceId, spanName, spanKind, attributes, links);
            }
            toString() {
                return `ParentBased{root=${this._root.toString()}, remoteParentSampled=${this._remoteParentSampled.toString()}, remoteParentNotSampled=${this._remoteParentNotSampled.toString()}, localParentSampled=${this._localParentSampled.toString()}, localParentNotSampled=${this._localParentNotSampled.toString()}}`;
            }
        };
    }
});
// ../node_modules/@opentelemetry/sdk-trace-web/node_modules/@opentelemetry/sdk-trace-base/build/esm/sampler/TraceIdRatioBasedSampler.js
var $281a441cdcb2cf36$var$TraceIdRatioBasedSampler;
var $281a441cdcb2cf36$var$init_TraceIdRatioBasedSampler = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/sdk-trace-web/node_modules/@opentelemetry/sdk-trace-base/build/esm/sampler/TraceIdRatioBasedSampler.js" () {
        $281a441cdcb2cf36$var$init_esm();
        $281a441cdcb2cf36$var$init_Sampler();
        $281a441cdcb2cf36$var$TraceIdRatioBasedSampler = class {
            constructor(ratio = 0){
                $281a441cdcb2cf36$var$__publicField(this, "_ratio");
                $281a441cdcb2cf36$var$__publicField(this, "_upperBound");
                this._ratio = this._normalize(ratio);
                this._upperBound = Math.floor(this._ratio * 4294967295);
            }
            shouldSample(context2, traceId) {
                return {
                    decision: $281a441cdcb2cf36$var$isValidTraceId(traceId) && this._accumulate(traceId) < this._upperBound ? $281a441cdcb2cf36$var$SamplingDecision2.RECORD_AND_SAMPLED : $281a441cdcb2cf36$var$SamplingDecision2.NOT_RECORD
                };
            }
            toString() {
                return `TraceIdRatioBased{${this._ratio}}`;
            }
            _normalize(ratio) {
                if (typeof ratio !== "number" || isNaN(ratio)) return 0;
                return ratio >= 1 ? 1 : ratio <= 0 ? 0 : ratio;
            }
            _accumulate(traceId) {
                let accumulation = 0;
                for(let i3 = 0; i3 < traceId.length / 8; i3++){
                    const pos = i3 * 8;
                    const part = parseInt(traceId.slice(pos, pos + 8), 16);
                    accumulation = (accumulation ^ part) >>> 0;
                }
                return accumulation;
            }
        };
    }
});
// ../node_modules/@opentelemetry/sdk-trace-web/node_modules/@opentelemetry/sdk-trace-base/build/esm/config.js
function $281a441cdcb2cf36$var$loadDefaultConfig() {
    var _a2, _b, _c, _d, _e, _f, _g, _h;
    return {
        sampler: $281a441cdcb2cf36$var$buildSamplerFromEnv(),
        forceFlushTimeoutMillis: 3e4,
        generalLimits: {
            attributeValueLengthLimit: (_a2 = $281a441cdcb2cf36$var$getNumberFromEnv("OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT")) != null ? _a2 : Infinity,
            attributeCountLimit: (_b = $281a441cdcb2cf36$var$getNumberFromEnv("OTEL_ATTRIBUTE_COUNT_LIMIT")) != null ? _b : 128
        },
        spanLimits: {
            attributeValueLengthLimit: (_c = $281a441cdcb2cf36$var$getNumberFromEnv("OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT")) != null ? _c : Infinity,
            attributeCountLimit: (_d = $281a441cdcb2cf36$var$getNumberFromEnv("OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT")) != null ? _d : 128,
            linkCountLimit: (_e = $281a441cdcb2cf36$var$getNumberFromEnv("OTEL_SPAN_LINK_COUNT_LIMIT")) != null ? _e : 128,
            eventCountLimit: (_f = $281a441cdcb2cf36$var$getNumberFromEnv("OTEL_SPAN_EVENT_COUNT_LIMIT")) != null ? _f : 128,
            attributePerEventCountLimit: (_g = $281a441cdcb2cf36$var$getNumberFromEnv("OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT")) != null ? _g : 128,
            attributePerLinkCountLimit: (_h = $281a441cdcb2cf36$var$getNumberFromEnv("OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT")) != null ? _h : 128
        }
    };
}
function $281a441cdcb2cf36$var$buildSamplerFromEnv() {
    var _a2;
    const sampler = (_a2 = $281a441cdcb2cf36$var$getStringFromEnv("OTEL_TRACES_SAMPLER")) != null ? _a2 : $281a441cdcb2cf36$var$TracesSamplerValues.ParentBasedAlwaysOn;
    switch(sampler){
        case $281a441cdcb2cf36$var$TracesSamplerValues.AlwaysOn:
            return new $281a441cdcb2cf36$var$AlwaysOnSampler();
        case $281a441cdcb2cf36$var$TracesSamplerValues.AlwaysOff:
            return new $281a441cdcb2cf36$var$AlwaysOffSampler();
        case $281a441cdcb2cf36$var$TracesSamplerValues.ParentBasedAlwaysOn:
            return new $281a441cdcb2cf36$var$ParentBasedSampler({
                root: new $281a441cdcb2cf36$var$AlwaysOnSampler()
            });
        case $281a441cdcb2cf36$var$TracesSamplerValues.ParentBasedAlwaysOff:
            return new $281a441cdcb2cf36$var$ParentBasedSampler({
                root: new $281a441cdcb2cf36$var$AlwaysOffSampler()
            });
        case $281a441cdcb2cf36$var$TracesSamplerValues.TraceIdRatio:
            return new $281a441cdcb2cf36$var$TraceIdRatioBasedSampler($281a441cdcb2cf36$var$getSamplerProbabilityFromEnv());
        case $281a441cdcb2cf36$var$TracesSamplerValues.ParentBasedTraceIdRatio:
            return new $281a441cdcb2cf36$var$ParentBasedSampler({
                root: new $281a441cdcb2cf36$var$TraceIdRatioBasedSampler($281a441cdcb2cf36$var$getSamplerProbabilityFromEnv())
            });
        default:
            $281a441cdcb2cf36$var$diag2.error(`OTEL_TRACES_SAMPLER value "${sampler}" invalid, defaulting to "${$281a441cdcb2cf36$var$TracesSamplerValues.ParentBasedAlwaysOn}".`);
            return new $281a441cdcb2cf36$var$ParentBasedSampler({
                root: new $281a441cdcb2cf36$var$AlwaysOnSampler()
            });
    }
}
function $281a441cdcb2cf36$var$getSamplerProbabilityFromEnv() {
    const probability = $281a441cdcb2cf36$var$getNumberFromEnv("OTEL_TRACES_SAMPLER_ARG");
    if (probability == null) {
        $281a441cdcb2cf36$var$diag2.error(`OTEL_TRACES_SAMPLER_ARG is blank, defaulting to ${$281a441cdcb2cf36$var$DEFAULT_RATIO}.`);
        return $281a441cdcb2cf36$var$DEFAULT_RATIO;
    }
    if (probability < 0 || probability > 1) {
        $281a441cdcb2cf36$var$diag2.error(`OTEL_TRACES_SAMPLER_ARG=${probability} was given, but it is out of range ([0..1]), defaulting to ${$281a441cdcb2cf36$var$DEFAULT_RATIO}.`);
        return $281a441cdcb2cf36$var$DEFAULT_RATIO;
    }
    return probability;
}
var $281a441cdcb2cf36$var$TracesSamplerValues, $281a441cdcb2cf36$var$DEFAULT_RATIO;
var $281a441cdcb2cf36$var$init_config3 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/sdk-trace-web/node_modules/@opentelemetry/sdk-trace-base/build/esm/config.js" () {
        $281a441cdcb2cf36$var$init_esm();
        $281a441cdcb2cf36$var$init_esm3();
        $281a441cdcb2cf36$var$init_AlwaysOffSampler();
        $281a441cdcb2cf36$var$init_AlwaysOnSampler();
        $281a441cdcb2cf36$var$init_ParentBasedSampler();
        $281a441cdcb2cf36$var$init_TraceIdRatioBasedSampler();
        (function(TracesSamplerValues2) {
            TracesSamplerValues2["AlwaysOff"] = "always_off";
            TracesSamplerValues2["AlwaysOn"] = "always_on";
            TracesSamplerValues2["ParentBasedAlwaysOff"] = "parentbased_always_off";
            TracesSamplerValues2["ParentBasedAlwaysOn"] = "parentbased_always_on";
            TracesSamplerValues2["ParentBasedTraceIdRatio"] = "parentbased_traceidratio";
            TracesSamplerValues2["TraceIdRatio"] = "traceidratio";
        })($281a441cdcb2cf36$var$TracesSamplerValues || ($281a441cdcb2cf36$var$TracesSamplerValues = {}));
        $281a441cdcb2cf36$var$DEFAULT_RATIO = 1;
    }
});
// ../node_modules/@opentelemetry/sdk-trace-web/node_modules/@opentelemetry/sdk-trace-base/build/esm/utility.js
function $281a441cdcb2cf36$var$mergeConfig(userConfig) {
    const perInstanceDefaults = {
        sampler: $281a441cdcb2cf36$var$buildSamplerFromEnv()
    };
    const DEFAULT_CONFIG = $281a441cdcb2cf36$var$loadDefaultConfig();
    const target = Object.assign({}, DEFAULT_CONFIG, perInstanceDefaults, userConfig);
    target.generalLimits = Object.assign({}, DEFAULT_CONFIG.generalLimits, userConfig.generalLimits || {});
    target.spanLimits = Object.assign({}, DEFAULT_CONFIG.spanLimits, userConfig.spanLimits || {});
    return target;
}
function $281a441cdcb2cf36$var$reconfigureLimits(userConfig) {
    var _a2, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
    const spanLimits = Object.assign({}, userConfig.spanLimits);
    spanLimits.attributeCountLimit = (_f = (_e = (_d = (_c = (_a2 = userConfig.spanLimits) == null ? void 0 : _a2.attributeCountLimit) != null ? _c : (_b = userConfig.generalLimits) == null ? void 0 : _b.attributeCountLimit) != null ? _d : $281a441cdcb2cf36$var$getNumberFromEnv("OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT")) != null ? _e : $281a441cdcb2cf36$var$getNumberFromEnv("OTEL_ATTRIBUTE_COUNT_LIMIT")) != null ? _f : $281a441cdcb2cf36$var$DEFAULT_ATTRIBUTE_COUNT_LIMIT;
    spanLimits.attributeValueLengthLimit = (_l = (_k = (_j = (_i = (_g = userConfig.spanLimits) == null ? void 0 : _g.attributeValueLengthLimit) != null ? _i : (_h = userConfig.generalLimits) == null ? void 0 : _h.attributeValueLengthLimit) != null ? _j : $281a441cdcb2cf36$var$getNumberFromEnv("OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT")) != null ? _k : $281a441cdcb2cf36$var$getNumberFromEnv("OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT")) != null ? _l : $281a441cdcb2cf36$var$DEFAULT_ATTRIBUTE_VALUE_LENGTH_LIMIT;
    return Object.assign({}, userConfig, {
        spanLimits: spanLimits
    });
}
var $281a441cdcb2cf36$var$DEFAULT_ATTRIBUTE_COUNT_LIMIT, $281a441cdcb2cf36$var$DEFAULT_ATTRIBUTE_VALUE_LENGTH_LIMIT;
var $281a441cdcb2cf36$var$init_utility = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/sdk-trace-web/node_modules/@opentelemetry/sdk-trace-base/build/esm/utility.js" () {
        $281a441cdcb2cf36$var$init_config3();
        $281a441cdcb2cf36$var$init_esm3();
        $281a441cdcb2cf36$var$DEFAULT_ATTRIBUTE_COUNT_LIMIT = 128;
        $281a441cdcb2cf36$var$DEFAULT_ATTRIBUTE_VALUE_LENGTH_LIMIT = Infinity;
    }
});
// ../node_modules/@opentelemetry/sdk-trace-web/node_modules/@opentelemetry/sdk-trace-base/build/esm/export/BatchSpanProcessorBase.js
var $281a441cdcb2cf36$var$BatchSpanProcessorBase;
var $281a441cdcb2cf36$var$init_BatchSpanProcessorBase = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/sdk-trace-web/node_modules/@opentelemetry/sdk-trace-base/build/esm/export/BatchSpanProcessorBase.js" () {
        $281a441cdcb2cf36$var$init_esm();
        $281a441cdcb2cf36$var$init_esm3();
        $281a441cdcb2cf36$var$BatchSpanProcessorBase = class {
            constructor(exporter, config){
                $281a441cdcb2cf36$var$__publicField(this, "_maxExportBatchSize");
                $281a441cdcb2cf36$var$__publicField(this, "_maxQueueSize");
                $281a441cdcb2cf36$var$__publicField(this, "_scheduledDelayMillis");
                $281a441cdcb2cf36$var$__publicField(this, "_exportTimeoutMillis");
                $281a441cdcb2cf36$var$__publicField(this, "_exporter");
                $281a441cdcb2cf36$var$__publicField(this, "_isExporting", false);
                $281a441cdcb2cf36$var$__publicField(this, "_finishedSpans", []);
                $281a441cdcb2cf36$var$__publicField(this, "_timer");
                $281a441cdcb2cf36$var$__publicField(this, "_shutdownOnce");
                $281a441cdcb2cf36$var$__publicField(this, "_droppedSpansCount", 0);
                var _a2, _b, _c, _d;
                this._exporter = exporter;
                this._maxExportBatchSize = typeof (config == null ? void 0 : config.maxExportBatchSize) === "number" ? config.maxExportBatchSize : (_a2 = $281a441cdcb2cf36$var$getNumberFromEnv("OTEL_BSP_MAX_EXPORT_BATCH_SIZE")) != null ? _a2 : 512;
                this._maxQueueSize = typeof (config == null ? void 0 : config.maxQueueSize) === "number" ? config.maxQueueSize : (_b = $281a441cdcb2cf36$var$getNumberFromEnv("OTEL_BSP_MAX_QUEUE_SIZE")) != null ? _b : 2048;
                this._scheduledDelayMillis = typeof (config == null ? void 0 : config.scheduledDelayMillis) === "number" ? config.scheduledDelayMillis : (_c = $281a441cdcb2cf36$var$getNumberFromEnv("OTEL_BSP_SCHEDULE_DELAY")) != null ? _c : 5e3;
                this._exportTimeoutMillis = typeof (config == null ? void 0 : config.exportTimeoutMillis) === "number" ? config.exportTimeoutMillis : (_d = $281a441cdcb2cf36$var$getNumberFromEnv("OTEL_BSP_EXPORT_TIMEOUT")) != null ? _d : 3e4;
                this._shutdownOnce = new $281a441cdcb2cf36$var$BindOnceFuture(this._shutdown, this);
                if (this._maxExportBatchSize > this._maxQueueSize) {
                    $281a441cdcb2cf36$var$diag2.warn("BatchSpanProcessor: maxExportBatchSize must be smaller or equal to maxQueueSize, setting maxExportBatchSize to match maxQueueSize");
                    this._maxExportBatchSize = this._maxQueueSize;
                }
            }
            forceFlush() {
                if (this._shutdownOnce.isCalled) return this._shutdownOnce.promise;
                return this._flushAll();
            }
            // does nothing.
            onStart(_span, _parentContext) {}
            onEnd(span) {
                if (this._shutdownOnce.isCalled) return;
                if ((span.spanContext().traceFlags & $281a441cdcb2cf36$var$TraceFlags.SAMPLED) === 0) return;
                this._addToBuffer(span);
            }
            shutdown() {
                return this._shutdownOnce.call();
            }
            _shutdown() {
                return Promise.resolve().then(()=>{
                    return this.onShutdown();
                }).then(()=>{
                    return this._flushAll();
                }).then(()=>{
                    return this._exporter.shutdown();
                });
            }
            /** Add a span in the buffer. */ _addToBuffer(span) {
                if (this._finishedSpans.length >= this._maxQueueSize) {
                    if (this._droppedSpansCount === 0) $281a441cdcb2cf36$var$diag2.debug("maxQueueSize reached, dropping spans");
                    this._droppedSpansCount++;
                    return;
                }
                if (this._droppedSpansCount > 0) {
                    $281a441cdcb2cf36$var$diag2.warn(`Dropped ${this._droppedSpansCount} spans because maxQueueSize reached`);
                    this._droppedSpansCount = 0;
                }
                this._finishedSpans.push(span);
                this._maybeStartTimer();
            }
            /**
       * Send all spans to the exporter respecting the batch size limit
       * This function is used only on forceFlush or shutdown,
       * for all other cases _flush should be used
       * */ _flushAll() {
                return new Promise((resolve, reject)=>{
                    const promises = [];
                    const count2 = Math.ceil(this._finishedSpans.length / this._maxExportBatchSize);
                    for(let i3 = 0, j3 = count2; i3 < j3; i3++)promises.push(this._flushOneBatch());
                    Promise.all(promises).then(()=>{
                        resolve();
                    }).catch(reject);
                });
            }
            _flushOneBatch() {
                this._clearTimer();
                if (this._finishedSpans.length === 0) return Promise.resolve();
                return new Promise((resolve, reject)=>{
                    const timer = setTimeout(()=>{
                        reject(new Error("Timeout"));
                    }, this._exportTimeoutMillis);
                    $281a441cdcb2cf36$var$context.with($281a441cdcb2cf36$var$suppressTracing($281a441cdcb2cf36$var$context.active()), ()=>{
                        let spans;
                        if (this._finishedSpans.length <= this._maxExportBatchSize) {
                            spans = this._finishedSpans;
                            this._finishedSpans = [];
                        } else spans = this._finishedSpans.splice(0, this._maxExportBatchSize);
                        const doExport = ()=>this._exporter.export(spans, (result)=>{
                                var _a2;
                                clearTimeout(timer);
                                if (result.code === $281a441cdcb2cf36$var$ExportResultCode.SUCCESS) resolve();
                                else reject((_a2 = result.error) != null ? _a2 : new Error("BatchSpanProcessor: span export failed"));
                            });
                        let pendingResources = null;
                        for(let i3 = 0, len = spans.length; i3 < len; i3++){
                            const span = spans[i3];
                            if (span.resource.asyncAttributesPending && span.resource.waitForAsyncAttributes) {
                                pendingResources != null ? pendingResources : pendingResources = [];
                                pendingResources.push(span.resource.waitForAsyncAttributes());
                            }
                        }
                        if (pendingResources === null) doExport();
                        else Promise.all(pendingResources).then(doExport, (err)=>{
                            $281a441cdcb2cf36$var$globalErrorHandler(err);
                            reject(err);
                        });
                    });
                });
            }
            _maybeStartTimer() {
                if (this._isExporting) return;
                const flush = ()=>{
                    this._isExporting = true;
                    this._flushOneBatch().finally(()=>{
                        this._isExporting = false;
                        if (this._finishedSpans.length > 0) {
                            this._clearTimer();
                            this._maybeStartTimer();
                        }
                    }).catch((e4)=>{
                        this._isExporting = false;
                        $281a441cdcb2cf36$var$globalErrorHandler(e4);
                    });
                };
                if (this._finishedSpans.length >= this._maxExportBatchSize) return flush();
                if (this._timer !== void 0) return;
                this._timer = setTimeout(()=>flush(), this._scheduledDelayMillis);
                if (typeof this._timer !== "number") this._timer.unref();
            }
            _clearTimer() {
                if (this._timer !== void 0) {
                    clearTimeout(this._timer);
                    this._timer = void 0;
                }
            }
        };
    }
});
// ../node_modules/@opentelemetry/sdk-trace-web/node_modules/@opentelemetry/sdk-trace-base/build/esm/platform/browser/export/BatchSpanProcessor.js
var $281a441cdcb2cf36$var$BatchSpanProcessor;
var $281a441cdcb2cf36$var$init_BatchSpanProcessor = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/sdk-trace-web/node_modules/@opentelemetry/sdk-trace-base/build/esm/platform/browser/export/BatchSpanProcessor.js" () {
        $281a441cdcb2cf36$var$init_BatchSpanProcessorBase();
        $281a441cdcb2cf36$var$init_esm3();
        $281a441cdcb2cf36$var$BatchSpanProcessor = class extends $281a441cdcb2cf36$var$BatchSpanProcessorBase {
            constructor(_exporter, config){
                super(_exporter, config);
                $281a441cdcb2cf36$var$__publicField(this, "_visibilityChangeListener");
                $281a441cdcb2cf36$var$__publicField(this, "_pageHideListener");
                this.onInit(config);
            }
            onInit(config) {
                if ((config == null ? void 0 : config.disableAutoFlushOnDocumentHide) !== true && typeof document !== "undefined") {
                    this._visibilityChangeListener = ()=>{
                        if (document.visibilityState === "hidden") this.forceFlush().catch((error)=>{
                            $281a441cdcb2cf36$var$globalErrorHandler(error);
                        });
                    };
                    this._pageHideListener = ()=>{
                        this.forceFlush().catch((error)=>{
                            $281a441cdcb2cf36$var$globalErrorHandler(error);
                        });
                    };
                    document.addEventListener("visibilitychange", this._visibilityChangeListener);
                    document.addEventListener("pagehide", this._pageHideListener);
                }
            }
            onShutdown() {
                if (typeof document !== "undefined") {
                    if (this._visibilityChangeListener) document.removeEventListener("visibilitychange", this._visibilityChangeListener);
                    if (this._pageHideListener) document.removeEventListener("pagehide", this._pageHideListener);
                }
            }
        };
    }
});
// ../node_modules/@opentelemetry/sdk-trace-web/node_modules/@opentelemetry/sdk-trace-base/build/esm/platform/browser/RandomIdGenerator.js
function $281a441cdcb2cf36$var$randomFill(buf) {
    for(let i3 = 0; i3 < buf.length; i3++)buf[i3] = Math.random() * 256 >>> 0;
    for(let i3 = 0; i3 < buf.length; i3++){
        if (buf[i3] > 0) return;
    }
    buf[buf.length - 1] = 1;
}
function $281a441cdcb2cf36$var$toHex(buf) {
    let hex = "";
    for(let i3 = 0; i3 < buf.length; i3++)hex += $281a441cdcb2cf36$var$HEX[buf[i3]];
    return hex;
}
var $281a441cdcb2cf36$var$TRACE_ID_BYTES, $281a441cdcb2cf36$var$SPAN_ID_BYTES, $281a441cdcb2cf36$var$TRACE_BUFFER, $281a441cdcb2cf36$var$SPAN_BUFFER, $281a441cdcb2cf36$var$HEX, $281a441cdcb2cf36$var$RandomIdGenerator;
var $281a441cdcb2cf36$var$init_RandomIdGenerator = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/sdk-trace-web/node_modules/@opentelemetry/sdk-trace-base/build/esm/platform/browser/RandomIdGenerator.js" () {
        $281a441cdcb2cf36$var$TRACE_ID_BYTES = 16;
        $281a441cdcb2cf36$var$SPAN_ID_BYTES = 8;
        $281a441cdcb2cf36$var$TRACE_BUFFER = new Uint8Array($281a441cdcb2cf36$var$TRACE_ID_BYTES);
        $281a441cdcb2cf36$var$SPAN_BUFFER = new Uint8Array($281a441cdcb2cf36$var$SPAN_ID_BYTES);
        $281a441cdcb2cf36$var$HEX = Array.from({
            length: 256
        }, (_3, i3)=>i3.toString(16).padStart(2, "0"));
        $281a441cdcb2cf36$var$RandomIdGenerator = class {
            /**
       * Returns a random 16-byte trace ID formatted/encoded as a 32 lowercase hex
       * characters corresponding to 128 bits.
       */ generateTraceId() {
                $281a441cdcb2cf36$var$randomFill($281a441cdcb2cf36$var$TRACE_BUFFER);
                return $281a441cdcb2cf36$var$toHex($281a441cdcb2cf36$var$TRACE_BUFFER);
            }
            /**
       * Returns a random 8-byte span ID formatted/encoded as a 16 lowercase hex
       * characters corresponding to 64 bits.
       */ generateSpanId() {
                $281a441cdcb2cf36$var$randomFill($281a441cdcb2cf36$var$SPAN_BUFFER);
                return $281a441cdcb2cf36$var$toHex($281a441cdcb2cf36$var$SPAN_BUFFER);
            }
        };
    }
});
// ../node_modules/@opentelemetry/sdk-trace-web/node_modules/@opentelemetry/sdk-trace-base/build/esm/platform/browser/index.js
var $281a441cdcb2cf36$var$init_browser7 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/sdk-trace-web/node_modules/@opentelemetry/sdk-trace-base/build/esm/platform/browser/index.js" () {
        $281a441cdcb2cf36$var$init_BatchSpanProcessor();
        $281a441cdcb2cf36$var$init_RandomIdGenerator();
    }
});
// ../node_modules/@opentelemetry/sdk-trace-web/node_modules/@opentelemetry/sdk-trace-base/build/esm/semconv.js
var $281a441cdcb2cf36$var$ATTR_OTEL_SPAN_PARENT_ORIGIN, $281a441cdcb2cf36$var$ATTR_OTEL_SPAN_SAMPLING_RESULT, $281a441cdcb2cf36$var$METRIC_OTEL_SDK_SPAN_LIVE, $281a441cdcb2cf36$var$METRIC_OTEL_SDK_SPAN_STARTED;
var $281a441cdcb2cf36$var$init_semconv6 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/sdk-trace-web/node_modules/@opentelemetry/sdk-trace-base/build/esm/semconv.js" () {
        $281a441cdcb2cf36$var$ATTR_OTEL_SPAN_PARENT_ORIGIN = "otel.span.parent.origin";
        $281a441cdcb2cf36$var$ATTR_OTEL_SPAN_SAMPLING_RESULT = "otel.span.sampling_result";
        $281a441cdcb2cf36$var$METRIC_OTEL_SDK_SPAN_LIVE = "otel.sdk.span.live";
        $281a441cdcb2cf36$var$METRIC_OTEL_SDK_SPAN_STARTED = "otel.sdk.span.started";
    }
});
// ../node_modules/@opentelemetry/sdk-trace-web/node_modules/@opentelemetry/sdk-trace-base/build/esm/TracerMetrics.js
function $281a441cdcb2cf36$var$parentOrigin(parentSpanContext) {
    if (!parentSpanContext) return "none";
    if (parentSpanContext.isRemote) return "remote";
    return "local";
}
function $281a441cdcb2cf36$var$samplingDecisionToString(decision) {
    switch(decision){
        case $281a441cdcb2cf36$var$SamplingDecision2.RECORD_AND_SAMPLED:
            return "RECORD_AND_SAMPLE";
        case $281a441cdcb2cf36$var$SamplingDecision2.RECORD:
            return "RECORD_ONLY";
        case $281a441cdcb2cf36$var$SamplingDecision2.NOT_RECORD:
            return "DROP";
    }
}
var $281a441cdcb2cf36$var$TracerMetrics;
var $281a441cdcb2cf36$var$init_TracerMetrics = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/sdk-trace-web/node_modules/@opentelemetry/sdk-trace-base/build/esm/TracerMetrics.js" () {
        $281a441cdcb2cf36$var$init_Sampler();
        $281a441cdcb2cf36$var$init_semconv6();
        $281a441cdcb2cf36$var$TracerMetrics = class {
            constructor(meter){
                $281a441cdcb2cf36$var$__publicField(this, "startedSpans");
                $281a441cdcb2cf36$var$__publicField(this, "liveSpans");
                this.startedSpans = meter.createCounter($281a441cdcb2cf36$var$METRIC_OTEL_SDK_SPAN_STARTED, {
                    unit: "{span}",
                    description: "The number of created spans."
                });
                this.liveSpans = meter.createUpDownCounter($281a441cdcb2cf36$var$METRIC_OTEL_SDK_SPAN_LIVE, {
                    unit: "{span}",
                    description: "The number of currently live spans."
                });
            }
            startSpan(parentSpanCtx, samplingDecision) {
                const samplingDecisionStr = $281a441cdcb2cf36$var$samplingDecisionToString(samplingDecision);
                this.startedSpans.add(1, {
                    [$281a441cdcb2cf36$var$ATTR_OTEL_SPAN_PARENT_ORIGIN]: $281a441cdcb2cf36$var$parentOrigin(parentSpanCtx),
                    [$281a441cdcb2cf36$var$ATTR_OTEL_SPAN_SAMPLING_RESULT]: samplingDecisionStr
                });
                if (samplingDecision === $281a441cdcb2cf36$var$SamplingDecision2.NOT_RECORD) return ()=>{};
                const liveSpanAttributes = {
                    [$281a441cdcb2cf36$var$ATTR_OTEL_SPAN_SAMPLING_RESULT]: samplingDecisionStr
                };
                this.liveSpans.add(1, liveSpanAttributes);
                return ()=>{
                    this.liveSpans.add(-1, liveSpanAttributes);
                };
            }
        };
    }
});
// ../node_modules/@opentelemetry/sdk-trace-web/node_modules/@opentelemetry/sdk-trace-base/build/esm/version.js
var $281a441cdcb2cf36$var$VERSION7;
var $281a441cdcb2cf36$var$init_version6 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/sdk-trace-web/node_modules/@opentelemetry/sdk-trace-base/build/esm/version.js" () {
        $281a441cdcb2cf36$var$VERSION7 = "2.7.0";
    }
});
// ../node_modules/@opentelemetry/sdk-trace-web/node_modules/@opentelemetry/sdk-trace-base/build/esm/Tracer.js
var $281a441cdcb2cf36$var$Tracer;
var $281a441cdcb2cf36$var$init_Tracer = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/sdk-trace-web/node_modules/@opentelemetry/sdk-trace-base/build/esm/Tracer.js" () {
        $281a441cdcb2cf36$var$init_esm();
        $281a441cdcb2cf36$var$init_esm3();
        $281a441cdcb2cf36$var$init_Span();
        $281a441cdcb2cf36$var$init_utility();
        $281a441cdcb2cf36$var$init_browser7();
        $281a441cdcb2cf36$var$init_TracerMetrics();
        $281a441cdcb2cf36$var$init_version6();
        $281a441cdcb2cf36$var$Tracer = class {
            /**
       * Constructs a new Tracer instance.
       */ constructor(instrumentationScope, config, resource, spanProcessor){
                $281a441cdcb2cf36$var$__publicField(this, "_sampler");
                $281a441cdcb2cf36$var$__publicField(this, "_generalLimits");
                $281a441cdcb2cf36$var$__publicField(this, "_spanLimits");
                $281a441cdcb2cf36$var$__publicField(this, "_idGenerator");
                $281a441cdcb2cf36$var$__publicField(this, "instrumentationScope");
                $281a441cdcb2cf36$var$__publicField(this, "_resource");
                $281a441cdcb2cf36$var$__publicField(this, "_spanProcessor");
                $281a441cdcb2cf36$var$__publicField(this, "_tracerMetrics");
                const localConfig = $281a441cdcb2cf36$var$mergeConfig(config);
                this._sampler = localConfig.sampler;
                this._generalLimits = localConfig.generalLimits;
                this._spanLimits = localConfig.spanLimits;
                this._idGenerator = config.idGenerator || new $281a441cdcb2cf36$var$RandomIdGenerator();
                this._resource = resource;
                this._spanProcessor = spanProcessor;
                this.instrumentationScope = instrumentationScope;
                const meter = localConfig.meterProvider ? localConfig.meterProvider.getMeter("@opentelemetry/sdk-trace", $281a441cdcb2cf36$var$VERSION7) : $281a441cdcb2cf36$var$createNoopMeter();
                this._tracerMetrics = new $281a441cdcb2cf36$var$TracerMetrics(meter);
            }
            /**
       * Starts a new Span or returns the default NoopSpan based on the sampling
       * decision.
       */ startSpan(name, options = {}, context2 = $281a441cdcb2cf36$var$context.active()) {
                var _a2, _b, _c;
                if (options.root) context2 = $281a441cdcb2cf36$var$trace.deleteSpan(context2);
                const parentSpan = $281a441cdcb2cf36$var$trace.getSpan(context2);
                if ($281a441cdcb2cf36$var$isTracingSuppressed(context2)) {
                    $281a441cdcb2cf36$var$diag2.debug("Instrumentation suppressed, returning Noop Span");
                    const nonRecordingSpan = $281a441cdcb2cf36$var$trace.wrapSpanContext($281a441cdcb2cf36$var$INVALID_SPAN_CONTEXT);
                    return nonRecordingSpan;
                }
                const parentSpanContext = parentSpan == null ? void 0 : parentSpan.spanContext();
                const spanId = this._idGenerator.generateSpanId();
                let validParentSpanContext;
                let traceId;
                let traceState;
                if (!parentSpanContext || !$281a441cdcb2cf36$var$trace.isSpanContextValid(parentSpanContext)) traceId = this._idGenerator.generateTraceId();
                else {
                    traceId = parentSpanContext.traceId;
                    traceState = parentSpanContext.traceState;
                    validParentSpanContext = parentSpanContext;
                }
                const spanKind = (_a2 = options.kind) != null ? _a2 : $281a441cdcb2cf36$var$SpanKind.INTERNAL;
                const links = ((_b = options.links) != null ? _b : []).map((link)=>{
                    return {
                        context: link.context,
                        attributes: $281a441cdcb2cf36$var$sanitizeAttributes(link.attributes)
                    };
                });
                const attributes = $281a441cdcb2cf36$var$sanitizeAttributes(options.attributes);
                const samplingResult = this._sampler.shouldSample(context2, traceId, name, spanKind, attributes, links);
                const recordEndMetrics = this._tracerMetrics.startSpan(parentSpanContext, samplingResult.decision);
                traceState = (_c = samplingResult.traceState) != null ? _c : traceState;
                const traceFlags = samplingResult.decision === $281a441cdcb2cf36$var$SamplingDecision.RECORD_AND_SAMPLED ? $281a441cdcb2cf36$var$TraceFlags.SAMPLED : $281a441cdcb2cf36$var$TraceFlags.NONE;
                const spanContext = {
                    traceId: traceId,
                    spanId: spanId,
                    traceFlags: traceFlags,
                    traceState: traceState
                };
                if (samplingResult.decision === $281a441cdcb2cf36$var$SamplingDecision.NOT_RECORD) {
                    $281a441cdcb2cf36$var$diag2.debug("Recording is off, propagating context in a non-recording span");
                    const nonRecordingSpan = $281a441cdcb2cf36$var$trace.wrapSpanContext(spanContext);
                    return nonRecordingSpan;
                }
                const initAttributes = $281a441cdcb2cf36$var$sanitizeAttributes(Object.assign(attributes, samplingResult.attributes));
                const span = new $281a441cdcb2cf36$var$SpanImpl({
                    resource: this._resource,
                    scope: this.instrumentationScope,
                    context: context2,
                    spanContext: spanContext,
                    name: name,
                    kind: spanKind,
                    links: links,
                    parentSpanContext: validParentSpanContext,
                    attributes: initAttributes,
                    startTime: options.startTime,
                    spanProcessor: this._spanProcessor,
                    spanLimits: this._spanLimits,
                    recordEndMetrics: recordEndMetrics
                });
                return span;
            }
            startActiveSpan(name, arg2, arg3, arg4) {
                let opts;
                let ctx;
                let fn;
                if (arguments.length < 2) return;
                else if (arguments.length === 2) fn = arg2;
                else if (arguments.length === 3) {
                    opts = arg2;
                    fn = arg3;
                } else {
                    opts = arg2;
                    ctx = arg3;
                    fn = arg4;
                }
                const parentContext = ctx != null ? ctx : $281a441cdcb2cf36$var$context.active();
                const span = this.startSpan(name, opts, parentContext);
                const contextWithSpanSet = $281a441cdcb2cf36$var$trace.setSpan(parentContext, span);
                return $281a441cdcb2cf36$var$context.with(contextWithSpanSet, fn, void 0, span);
            }
            /** Returns the active {@link GeneralLimits}. */ getGeneralLimits() {
                return this._generalLimits;
            }
            /** Returns the active {@link SpanLimits}. */ getSpanLimits() {
                return this._spanLimits;
            }
        };
    }
});
// ../node_modules/@opentelemetry/sdk-trace-web/node_modules/@opentelemetry/sdk-trace-base/build/esm/MultiSpanProcessor.js
var $281a441cdcb2cf36$var$MultiSpanProcessor;
var $281a441cdcb2cf36$var$init_MultiSpanProcessor = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/sdk-trace-web/node_modules/@opentelemetry/sdk-trace-base/build/esm/MultiSpanProcessor.js" () {
        $281a441cdcb2cf36$var$init_esm3();
        $281a441cdcb2cf36$var$MultiSpanProcessor = class {
            constructor(spanProcessors){
                $281a441cdcb2cf36$var$__publicField(this, "_spanProcessors");
                this._spanProcessors = spanProcessors;
            }
            forceFlush() {
                const promises = [];
                for (const spanProcessor of this._spanProcessors)promises.push(spanProcessor.forceFlush());
                return new Promise((resolve)=>{
                    Promise.all(promises).then(()=>{
                        resolve();
                    }).catch((error)=>{
                        $281a441cdcb2cf36$var$globalErrorHandler(error || new Error("MultiSpanProcessor: forceFlush failed"));
                        resolve();
                    });
                });
            }
            onStart(span, context2) {
                for (const spanProcessor of this._spanProcessors)spanProcessor.onStart(span, context2);
            }
            onEnding(span) {
                for (const spanProcessor of this._spanProcessors)if (spanProcessor.onEnding) spanProcessor.onEnding(span);
            }
            onEnd(span) {
                for (const spanProcessor of this._spanProcessors)spanProcessor.onEnd(span);
            }
            shutdown() {
                const promises = [];
                for (const spanProcessor of this._spanProcessors)promises.push(spanProcessor.shutdown());
                return new Promise((resolve, reject)=>{
                    Promise.all(promises).then(()=>{
                        resolve();
                    }, reject);
                });
            }
        };
    }
});
// ../node_modules/@opentelemetry/sdk-trace-web/node_modules/@opentelemetry/sdk-trace-base/build/esm/BasicTracerProvider.js
var $281a441cdcb2cf36$var$ForceFlushState, $281a441cdcb2cf36$var$BasicTracerProvider;
var $281a441cdcb2cf36$var$init_BasicTracerProvider = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/sdk-trace-web/node_modules/@opentelemetry/sdk-trace-base/build/esm/BasicTracerProvider.js" () {
        $281a441cdcb2cf36$var$init_esm3();
        $281a441cdcb2cf36$var$init_esm14();
        $281a441cdcb2cf36$var$init_Tracer();
        $281a441cdcb2cf36$var$init_config3();
        $281a441cdcb2cf36$var$init_MultiSpanProcessor();
        $281a441cdcb2cf36$var$init_utility();
        (function(ForceFlushState2) {
            ForceFlushState2[ForceFlushState2["resolved"] = 0] = "resolved";
            ForceFlushState2[ForceFlushState2["timeout"] = 1] = "timeout";
            ForceFlushState2[ForceFlushState2["error"] = 2] = "error";
            ForceFlushState2[ForceFlushState2["unresolved"] = 3] = "unresolved";
        })($281a441cdcb2cf36$var$ForceFlushState || ($281a441cdcb2cf36$var$ForceFlushState = {}));
        $281a441cdcb2cf36$var$BasicTracerProvider = class {
            constructor(config = {}){
                $281a441cdcb2cf36$var$__publicField(this, "_config");
                $281a441cdcb2cf36$var$__publicField(this, "_tracers", /* @__PURE__ */ new Map());
                $281a441cdcb2cf36$var$__publicField(this, "_resource");
                $281a441cdcb2cf36$var$__publicField(this, "_activeSpanProcessor");
                var _a2, _b;
                const mergedConfig = $281a441cdcb2cf36$var$merge({}, $281a441cdcb2cf36$var$loadDefaultConfig(), $281a441cdcb2cf36$var$reconfigureLimits(config));
                this._resource = (_a2 = mergedConfig.resource) != null ? _a2 : $281a441cdcb2cf36$var$defaultResource();
                this._config = Object.assign({}, mergedConfig, {
                    resource: this._resource
                });
                const spanProcessors = [];
                if ((_b = config.spanProcessors) == null ? void 0 : _b.length) spanProcessors.push(...config.spanProcessors);
                this._activeSpanProcessor = new $281a441cdcb2cf36$var$MultiSpanProcessor(spanProcessors);
            }
            getTracer(name, version6, options) {
                const key = `${name}@${version6 || ""}:${(options == null ? void 0 : options.schemaUrl) || ""}`;
                if (!this._tracers.has(key)) this._tracers.set(key, new $281a441cdcb2cf36$var$Tracer({
                    name: name,
                    version: version6,
                    schemaUrl: options == null ? void 0 : options.schemaUrl
                }, this._config, this._resource, this._activeSpanProcessor));
                return this._tracers.get(key);
            }
            forceFlush() {
                const timeout = this._config.forceFlushTimeoutMillis;
                const promises = this._activeSpanProcessor["_spanProcessors"].map((spanProcessor)=>{
                    return new Promise((resolve)=>{
                        let state;
                        const timeoutInterval = setTimeout(()=>{
                            resolve(new Error(`Span processor did not completed within timeout period of ${timeout} ms`));
                            state = $281a441cdcb2cf36$var$ForceFlushState.timeout;
                        }, timeout);
                        spanProcessor.forceFlush().then(()=>{
                            clearTimeout(timeoutInterval);
                            if (state !== $281a441cdcb2cf36$var$ForceFlushState.timeout) {
                                state = $281a441cdcb2cf36$var$ForceFlushState.resolved;
                                resolve(state);
                            }
                        }).catch((error)=>{
                            clearTimeout(timeoutInterval);
                            state = $281a441cdcb2cf36$var$ForceFlushState.error;
                            resolve(error);
                        });
                    });
                });
                return new Promise((resolve, reject)=>{
                    Promise.all(promises).then((results)=>{
                        const errors = results.filter((result)=>result !== $281a441cdcb2cf36$var$ForceFlushState.resolved);
                        if (errors.length > 0) reject(errors);
                        else resolve();
                    }).catch((error)=>reject([
                            error
                        ]));
                });
            }
            shutdown() {
                return this._activeSpanProcessor.shutdown();
            }
        };
    }
});
// ../node_modules/@opentelemetry/sdk-trace-web/node_modules/@opentelemetry/sdk-trace-base/build/esm/index.js
var $281a441cdcb2cf36$var$init_esm15 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/sdk-trace-web/node_modules/@opentelemetry/sdk-trace-base/build/esm/index.js" () {
        $281a441cdcb2cf36$var$init_BasicTracerProvider();
        $281a441cdcb2cf36$var$init_browser7();
        $281a441cdcb2cf36$var$init_Sampler();
    }
});
// ../node_modules/@opentelemetry/sdk-trace-web/build/esm/StackContextManager.js
var $281a441cdcb2cf36$var$StackContextManager;
var $281a441cdcb2cf36$var$init_StackContextManager = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/sdk-trace-web/build/esm/StackContextManager.js" () {
        $281a441cdcb2cf36$var$init_esm();
        $281a441cdcb2cf36$var$StackContextManager = class {
            constructor(){
                /**
         * whether the context manager is enabled or not
         */ $281a441cdcb2cf36$var$__publicField(this, "_enabled", false);
                /**
         * Keeps the reference to current context
         */ $281a441cdcb2cf36$var$__publicField(this, "_currentContext", $281a441cdcb2cf36$var$ROOT_CONTEXT);
            }
            /**
       *
       * @param context
       * @param target Function to be executed within the context
       */ // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
            _bindFunction(context2 = $281a441cdcb2cf36$var$ROOT_CONTEXT, target) {
                const manager = this;
                const contextWrapper = function(...args2) {
                    return manager.with(context2, ()=>target.apply(this, args2));
                };
                Object.defineProperty(contextWrapper, "length", {
                    enumerable: false,
                    configurable: true,
                    writable: false,
                    value: target.length
                });
                return contextWrapper;
            }
            /**
       * Returns the active context
       */ active() {
                return this._currentContext;
            }
            /**
       * Binds a the certain context or the active one to the target function and then returns the target
       * @param context A context (span) to be bind to target
       * @param target a function or event emitter. When target or one of its callbacks is called,
       *  the provided context will be used as the active context for the duration of the call.
       */ bind(context2, target) {
                if (context2 === void 0) context2 = this.active();
                if (typeof target === "function") return this._bindFunction(context2, target);
                return target;
            }
            /**
       * Disable the context manager (clears the current context)
       */ disable() {
                this._currentContext = $281a441cdcb2cf36$var$ROOT_CONTEXT;
                this._enabled = false;
                return this;
            }
            /**
       * Enables the context manager and creates a default(root) context
       */ enable() {
                if (this._enabled) return this;
                this._enabled = true;
                this._currentContext = $281a441cdcb2cf36$var$ROOT_CONTEXT;
                return this;
            }
            /**
       * Calls the callback function [fn] with the provided [context]. If [context] is undefined then it will use the window.
       * The context will be set as active
       * @param context
       * @param fn Callback function
       * @param thisArg optional receiver to be used for calling fn
       * @param args optional arguments forwarded to fn
       */ with(context2, fn, thisArg, ...args2) {
                const previousContext = this._currentContext;
                this._currentContext = context2 || $281a441cdcb2cf36$var$ROOT_CONTEXT;
                try {
                    return fn.call(thisArg, ...args2);
                } finally{
                    this._currentContext = previousContext;
                }
            }
        };
    }
});
// ../node_modules/@opentelemetry/sdk-trace-web/build/esm/WebTracerProvider.js
function $281a441cdcb2cf36$var$setupContextManager(contextManager) {
    if (contextManager === null) return;
    if (contextManager === void 0) {
        const defaultContextManager = new $281a441cdcb2cf36$var$StackContextManager();
        defaultContextManager.enable();
        $281a441cdcb2cf36$var$context.setGlobalContextManager(defaultContextManager);
        return;
    }
    contextManager.enable();
    $281a441cdcb2cf36$var$context.setGlobalContextManager(contextManager);
}
function $281a441cdcb2cf36$var$setupPropagator(propagator) {
    if (propagator === null) return;
    if (propagator === void 0) {
        $281a441cdcb2cf36$var$propagation.setGlobalPropagator(new $281a441cdcb2cf36$var$CompositePropagator({
            propagators: [
                new $281a441cdcb2cf36$var$W3CTraceContextPropagator(),
                new $281a441cdcb2cf36$var$W3CBaggagePropagator()
            ]
        }));
        return;
    }
    $281a441cdcb2cf36$var$propagation.setGlobalPropagator(propagator);
}
var $281a441cdcb2cf36$var$WebTracerProvider;
var $281a441cdcb2cf36$var$init_WebTracerProvider = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/sdk-trace-web/build/esm/WebTracerProvider.js" () {
        $281a441cdcb2cf36$var$init_esm15();
        $281a441cdcb2cf36$var$init_StackContextManager();
        $281a441cdcb2cf36$var$init_esm();
        $281a441cdcb2cf36$var$init_esm3();
        $281a441cdcb2cf36$var$WebTracerProvider = class extends $281a441cdcb2cf36$var$BasicTracerProvider {
            /**
       * Constructs a new Tracer instance.
       * @param config Web Tracer config
       */ constructor(config = {}){
                super(config);
            }
            /**
       * Register this TracerProvider for use with the OpenTelemetry API.
       * Undefined values may be replaced with defaults, and
       * null values will be skipped.
       *
       * @param config Configuration object for SDK registration
       */ register(config = {}) {
                $281a441cdcb2cf36$var$trace.setGlobalTracerProvider(this);
                $281a441cdcb2cf36$var$setupPropagator(config.propagator);
                $281a441cdcb2cf36$var$setupContextManager(config.contextManager);
            }
        };
    }
});
// ../node_modules/@opentelemetry/sdk-trace-web/build/esm/index.js
var $281a441cdcb2cf36$var$init_esm16 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@opentelemetry/sdk-trace-web/build/esm/index.js" () {
        $281a441cdcb2cf36$var$init_WebTracerProvider();
        $281a441cdcb2cf36$var$init_esm15();
    }
});
// ../node_modules/@grafana/faro-web-tracing/dist/esm/faroMetaAttributesSpanProcessor.js
var $281a441cdcb2cf36$var$FaroMetaAttributesSpanProcessor;
var $281a441cdcb2cf36$var$init_faroMetaAttributesSpanProcessor = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-tracing/dist/esm/faroMetaAttributesSpanProcessor.js" () {
        $281a441cdcb2cf36$var$init_semconv2();
        $281a441cdcb2cf36$var$FaroMetaAttributesSpanProcessor = class {
            constructor(processor, metas){
                this.processor = processor;
                this.metas = metas;
            }
            forceFlush() {
                return this.processor.forceFlush();
            }
            onStart(span, parentContext) {
                var _a2;
                const session = this.metas.value.session;
                if (session === null || session === void 0 ? void 0 : session.id) {
                    span.attributes[$281a441cdcb2cf36$var$ATTR_SESSION_ID] = session.id;
                    span.attributes["session_id"] = session.id;
                }
                const user = (_a2 = this.metas.value.user) !== null && _a2 !== void 0 ? _a2 : {};
                if (user.email) span.attributes["user.email"] = user.email;
                if (user.id) span.attributes["user.id"] = user.id;
                if (user.username) span.attributes["user.name"] = user.username;
                if (user.fullName) span.attributes["user.full_name"] = user.fullName;
                if (user.roles) span.attributes["user.roles"] = user.roles.split(",").map((role)=>role.trim());
                if (user.hash) span.attributes["user.hash"] = user.hash;
                this.processor.onStart(span, parentContext);
            }
            onEnd(span) {
                this.processor.onEnd(span);
            }
            shutdown() {
                return this.processor.shutdown();
            }
        };
    }
});
// ../node_modules/@grafana/faro-web-tracing/dist/esm/faroUserActionSpanProcessor.js
var $281a441cdcb2cf36$var$FaroUserActionSpanProcessor;
var $281a441cdcb2cf36$var$init_faroUserActionSpanProcessor = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-tracing/dist/esm/faroUserActionSpanProcessor.js" () {
        $281a441cdcb2cf36$var$init_esm();
        $281a441cdcb2cf36$var$init_esm5();
        $281a441cdcb2cf36$var$FaroUserActionSpanProcessor = class {
            constructor(processor){
                this.processor = processor;
                $281a441cdcb2cf36$var$apiMessageBus.subscribe((msg)=>{
                    if (msg.type === $281a441cdcb2cf36$var$USER_ACTION_START) {
                        this.message = msg;
                        return;
                    }
                    if ([
                        $281a441cdcb2cf36$var$USER_ACTION_END,
                        $281a441cdcb2cf36$var$USER_ACTION_HALT,
                        $281a441cdcb2cf36$var$USER_ACTION_CANCEL
                    ].includes(msg.type)) this.message = void 0;
                });
            }
            forceFlush() {
                return this.processor.forceFlush();
            }
            onStart(span, parentContext) {
                var _a2, _b;
                if (span.kind === $281a441cdcb2cf36$var$SpanKind.CLIENT) {
                    if (this.message) {
                        span.attributes["faro.action.user.name"] = (_a2 = this.message) === null || _a2 === void 0 ? void 0 : _a2.name;
                        span.attributes["faro.action.user.parentId"] = (_b = this.message) === null || _b === void 0 ? void 0 : _b.parentId;
                    }
                }
                this.processor.onStart(span, parentContext);
            }
            onEnd(span) {
                this.processor.onEnd(span);
            }
            shutdown() {
                return this.processor.shutdown();
            }
        };
    }
});
// ../node_modules/@grafana/faro-web-tracing/dist/esm/sampler.js
function $281a441cdcb2cf36$var$getSamplingDecision(sessionMeta = {}) {
    var _a2;
    const isSessionSampled = ((_a2 = sessionMeta.attributes) === null || _a2 === void 0 ? void 0 : _a2["isSampled"]) === "true";
    const samplingDecision = isSessionSampled ? $281a441cdcb2cf36$var$SamplingDecision2.RECORD_AND_SAMPLED : $281a441cdcb2cf36$var$SamplingDecision2.NOT_RECORD;
    return samplingDecision;
}
var $281a441cdcb2cf36$var$init_sampler = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-tracing/dist/esm/sampler.js" () {
        $281a441cdcb2cf36$var$init_esm16();
    }
});
// ../node_modules/@grafana/faro-web-tracing/dist/esm/instrumentation.js
var $281a441cdcb2cf36$var$TracingInstrumentation;
var $281a441cdcb2cf36$var$init_instrumentation11 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-tracing/dist/esm/instrumentation.js" () {
        $281a441cdcb2cf36$var$init_esm();
        $281a441cdcb2cf36$var$init_esm3();
        $281a441cdcb2cf36$var$init_esm7();
        $281a441cdcb2cf36$var$init_esm14();
        $281a441cdcb2cf36$var$init_esm16();
        $281a441cdcb2cf36$var$init_esm2();
        $281a441cdcb2cf36$var$init_esm5();
        $281a441cdcb2cf36$var$init_faroMetaAttributesSpanProcessor();
        $281a441cdcb2cf36$var$init_faroTraceExporter();
        $281a441cdcb2cf36$var$init_faroUserActionSpanProcessor();
        $281a441cdcb2cf36$var$init_getDefaultOTELInstrumentations();
        $281a441cdcb2cf36$var$init_sampler();
        $281a441cdcb2cf36$var$init_semconv2();
        $281a441cdcb2cf36$var$TracingInstrumentation = class _TracingInstrumentation extends $281a441cdcb2cf36$var$BaseInstrumentation {
            constructor(options = {}){
                super();
                this.options = options;
                this.name = "@grafana/faro-web-tracing";
                this.version = $281a441cdcb2cf36$var$VERSION4;
            }
            initialize() {
                var _a2, _b, _c, _d, _e;
                const options = this.options;
                const attributes = {};
                if (this.config.app.name) attributes[$281a441cdcb2cf36$var$ATTR_SERVICE_NAME] = this.config.app.name;
                if (this.config.app.namespace) attributes[$281a441cdcb2cf36$var$ATTR_SERVICE_NAMESPACE2] = this.config.app.namespace;
                if (this.config.app.version) attributes[$281a441cdcb2cf36$var$ATTR_SERVICE_VERSION] = this.config.app.version;
                if (this.config.app.environment) {
                    attributes[$281a441cdcb2cf36$var$ATTR_DEPLOYMENT_ENVIRONMENT_NAME] = this.config.app.environment;
                    attributes[$281a441cdcb2cf36$var$SEMRESATTRS_DEPLOYMENT_ENVIRONMENT] = this.config.app.environment;
                }
                const browserMeta2 = this.metas.value.browser;
                if ($281a441cdcb2cf36$var$isArray4(browserMeta2 === null || browserMeta2 === void 0 ? void 0 : browserMeta2.brands)) attributes[$281a441cdcb2cf36$var$ATTR_BROWSER_BRANDS] = browserMeta2.brands.map((entry)=>entry.brand);
                if (browserMeta2 === null || browserMeta2 === void 0 ? void 0 : browserMeta2.language) attributes[$281a441cdcb2cf36$var$ATTR_BROWSER_LANGUAGE] = browserMeta2.language;
                if (typeof (browserMeta2 === null || browserMeta2 === void 0 ? void 0 : browserMeta2.mobile) === "boolean") attributes[$281a441cdcb2cf36$var$ATTR_BROWSER_MOBILE] = Boolean(browserMeta2.mobile);
                if (browserMeta2 === null || browserMeta2 === void 0 ? void 0 : browserMeta2.os) attributes[$281a441cdcb2cf36$var$ATTR_BROWSER_PLATFORM] = browserMeta2.os;
                if (browserMeta2 === null || browserMeta2 === void 0 ? void 0 : browserMeta2.userAgent) attributes[$281a441cdcb2cf36$var$ATTR_USER_AGENT_ORIGINAL] = browserMeta2.userAgent;
                attributes[$281a441cdcb2cf36$var$ATTR_PROCESS_RUNTIME_NAME2] = "browser";
                attributes[$281a441cdcb2cf36$var$ATTR_PROCESS_RUNTIME_VERSION] = (_a2 = this.metas.value.browser) === null || _a2 === void 0 ? void 0 : _a2.userAgent;
                attributes[$281a441cdcb2cf36$var$ATTR_TELEMETRY_DISTRO_NAME] = "faro-web-sdk";
                attributes[$281a441cdcb2cf36$var$ATTR_TELEMETRY_DISTRO_VERSION] = $281a441cdcb2cf36$var$VERSION4;
                Object.assign(attributes, options.resourceAttributes);
                const resource = $281a441cdcb2cf36$var$defaultResource().merge($281a441cdcb2cf36$var$resourceFromAttributes(attributes));
                const provider = new $281a441cdcb2cf36$var$WebTracerProvider({
                    resource: resource,
                    sampler: {
                        shouldSample: ()=>{
                            return {
                                decision: $281a441cdcb2cf36$var$getSamplingDecision(this.api.getSession())
                            };
                        }
                    },
                    spanProcessors: [
                        (_b = options.spanProcessor) !== null && _b !== void 0 ? _b : new $281a441cdcb2cf36$var$FaroUserActionSpanProcessor(new $281a441cdcb2cf36$var$FaroMetaAttributesSpanProcessor(new $281a441cdcb2cf36$var$BatchSpanProcessor(new $281a441cdcb2cf36$var$FaroTraceExporter({
                            api: this.api
                        }), {
                            scheduledDelayMillis: _TracingInstrumentation.SCHEDULED_BATCH_DELAY_MS,
                            maxExportBatchSize: 30
                        }), this.metas))
                    ]
                });
                provider.register({
                    propagator: (_c = options.propagator) !== null && _c !== void 0 ? _c : new $281a441cdcb2cf36$var$W3CTraceContextPropagator(),
                    contextManager: options.contextManager
                });
                const { propagateTraceHeaderCorsUrls: propagateTraceHeaderCorsUrls, fetchInstrumentationOptions: fetchInstrumentationOptions, xhrInstrumentationOptions: xhrInstrumentationOptions } = (_d = this.options.instrumentationOptions) !== null && _d !== void 0 ? _d : {};
                $281a441cdcb2cf36$var$registerInstrumentations({
                    instrumentations: (_e = options.instrumentations) !== null && _e !== void 0 ? _e : $281a441cdcb2cf36$var$getDefaultOTELInstrumentations({
                        ignoreUrls: this.getIgnoreUrls(),
                        propagateTraceHeaderCorsUrls: propagateTraceHeaderCorsUrls,
                        fetchInstrumentationOptions: fetchInstrumentationOptions,
                        xhrInstrumentationOptions: xhrInstrumentationOptions
                    })
                });
                this.api.initOTEL($281a441cdcb2cf36$var$trace, $281a441cdcb2cf36$var$context);
            }
            getIgnoreUrls() {
                return this.transports.transports.flatMap((transport)=>transport.getIgnoreUrls());
            }
        };
        $281a441cdcb2cf36$var$TracingInstrumentation.SCHEDULED_BATCH_DELAY_MS = 1e3;
    }
});
// ../node_modules/@grafana/faro-web-tracing/dist/esm/index.js
var $281a441cdcb2cf36$var$esm_exports7 = {};
$281a441cdcb2cf36$var$__export($281a441cdcb2cf36$var$esm_exports7, {
    FaroSessionSpanProcessor: ()=>$281a441cdcb2cf36$var$FaroSessionSpanProcessor,
    FaroTraceExporter: ()=>$281a441cdcb2cf36$var$FaroTraceExporter,
    TracingInstrumentation: ()=>$281a441cdcb2cf36$var$TracingInstrumentation,
    fetchCustomAttributeFunctionWithDefaults: ()=>$281a441cdcb2cf36$var$fetchCustomAttributeFunctionWithDefaults,
    getDefaultOTELInstrumentations: ()=>$281a441cdcb2cf36$var$getDefaultOTELInstrumentations,
    getSamplingDecision: ()=>$281a441cdcb2cf36$var$getSamplingDecision,
    setSpanStatusOnFetchError: ()=>$281a441cdcb2cf36$var$setSpanStatusOnFetchError
});
var $281a441cdcb2cf36$var$init_esm17 = $281a441cdcb2cf36$var$__esm({
    "../node_modules/@grafana/faro-web-tracing/dist/esm/index.js" () {
        $281a441cdcb2cf36$var$init_faroTraceExporter();
        $281a441cdcb2cf36$var$init_sessionSpanProcessor();
        $281a441cdcb2cf36$var$init_getDefaultOTELInstrumentations();
        $281a441cdcb2cf36$var$init_instrumentation11();
        $281a441cdcb2cf36$var$init_sampler();
        $281a441cdcb2cf36$var$init_instrumentationUtils();
    }
});
// ../server/packages/channels/channels.json
var $281a441cdcb2cf36$var$channels_default = {
    channels: {
        local: {
            api: "http://localhost:8080",
            socket: "http://localhost:8080",
            shell: "http://my.localhost:1355",
            preview: "http://preview.localhost:1355",
            mermaidApex: "localhost:1355",
            deploy: {}
        },
        localNext: {
            api: "http://localhost:8080",
            socket: "http://localhost:8080",
            shell: "http://my.localhost:1355",
            preview: "http://preview.localhost:1355",
            mermaidApex: "localhost:1355",
            deploy: {}
        },
        development: {
            api: "https://dev.api.symbols.app",
            socket: "https://dev.api.symbols.app",
            shell: "https://dev.my.symbols.app",
            preview: "https://dev.preview.symbols.app",
            mermaidApex: "dev.symbo.ls",
            deploy: {
                shellBucket: "smbls-my-dev",
                previewWorker: "smbls-preview-dev",
                mermaidWorker: "mermaid-dev"
            }
        },
        next: {
            api: "https://next.api.symbols.app",
            socket: "https://next.api.symbols.app",
            shell: "https://next.my.symbols.app",
            preview: "https://next.preview.symbols.app",
            mermaidApex: "next.symbo.ls",
            deploy: {
                shellBucket: "smbls-my-next",
                previewWorker: "smbls-preview-next",
                mermaidWorker: "mermaid-next"
            }
        },
        test: {
            api: "https://test.api.symbols.app",
            socket: "https://test.api.symbols.app",
            shell: "https://test.my.symbols.app",
            preview: "https://test.preview.symbols.app",
            mermaidApex: "test.symbo.ls",
            deploy: {
                shellBucket: "smbls-my-test",
                previewWorker: "smbls-preview-test",
                mermaidWorker: "mermaid-test"
            }
        },
        upcoming: {
            api: "https://upcoming.api.symbols.app",
            socket: "https://upcoming.api.symbols.app",
            shell: "https://upcoming.my.symbols.app",
            preview: "https://upcoming.preview.symbols.app",
            mermaidApex: "upcoming.symbo.ls",
            deploy: {
                shellBucket: "smbls-my-upcoming",
                previewWorker: "smbls-preview-upcoming",
                mermaidWorker: "mermaid-upcoming"
            }
        },
        staging: {
            api: "https://staging.api.symbols.app",
            socket: "https://staging.api.symbols.app",
            shell: "https://staging.my.symbols.app",
            preview: "https://staging.preview.symbols.app",
            mermaidApex: "staging.symbo.ls",
            deploy: {
                shellBucket: "smbls-my-staging",
                previewWorker: "smbls-preview-staging",
                mermaidWorker: "mermaid-staging"
            }
        },
        production: {
            api: "https://api.symbols.app",
            socket: "https://api.symbols.app",
            shell: "https://my.symbols.app",
            preview: "https://preview.symbols.app",
            mermaidApex: "symbo.ls",
            deploy: {
                shellBucket: "smbls-my-prod",
                previewWorker: "smbls-preview",
                mermaidWorker: "mermaid"
            }
        }
    },
    defaultChannel: "next"
};
// ../server/packages/channels/index.js
var $281a441cdcb2cf36$var$channelNames = Object.keys($281a441cdcb2cf36$var$channels_default.channels);
var $281a441cdcb2cf36$var$resolveChannel = (name)=>{
    if (name && $281a441cdcb2cf36$var$channels_default.channels[name]) return $281a441cdcb2cf36$var$channels_default.channels[name];
    return $281a441cdcb2cf36$var$channels_default.channels[$281a441cdcb2cf36$var$channels_default.defaultChannel];
};
var $281a441cdcb2cf36$var$currentChannel = ()=>{
    const env = null;
    if (env && $281a441cdcb2cf36$var$channels_default.channels[env]) return env;
    return $281a441cdcb2cf36$var$channels_default.defaultChannel;
};
var $281a441cdcb2cf36$var$apiUrl = (name = $281a441cdcb2cf36$var$currentChannel())=>{
    return $281a441cdcb2cf36$var$resolveChannel(name).api;
};
var $281a441cdcb2cf36$var$socketUrl = (name = $281a441cdcb2cf36$var$currentChannel())=>{
    return $281a441cdcb2cf36$var$resolveChannel(name).socket;
};
var $281a441cdcb2cf36$var$defaultChannel = $281a441cdcb2cf36$var$channels_default.defaultChannel;
// src/utils/logger.js
var $281a441cdcb2cf36$var$isBrowser = typeof window !== "undefined" && true;
var $281a441cdcb2cf36$var$_debug = false;
var $281a441cdcb2cf36$var$setDebug = (value2)=>{
    $281a441cdcb2cf36$var$_debug = value2;
};
var $281a441cdcb2cf36$var$noop = ()=>{};
var $281a441cdcb2cf36$var$logger = {
    get log () {
        return $281a441cdcb2cf36$var$_debug || $281a441cdcb2cf36$var$isBrowser ? console.log.bind(console) : $281a441cdcb2cf36$var$noop;
    },
    get warn () {
        return $281a441cdcb2cf36$var$_debug || $281a441cdcb2cf36$var$isBrowser ? console.warn.bind(console) : $281a441cdcb2cf36$var$noop;
    },
    get error () {
        return $281a441cdcb2cf36$var$_debug || $281a441cdcb2cf36$var$isBrowser ? console.error.bind(console) : $281a441cdcb2cf36$var$noop;
    }
};
// src/config/environment.js
var $281a441cdcb2cf36$var$CONFIG = {
    // Common defaults for all environments
    common: {
        // NOTE: Google client id for google auth, need to configure URLs for each environment in Google console
        googleClientId: "686286207466-bvd2fqs31rlm64fgich7rtpnc8ns2tqg.apps.googleusercontent.com",
        // Feature toggles that apply across all environments by default
        features: {
            newUserOnboarding: true,
            betaFeatures: false,
            // Tracking is enabled by default unless overridden per environment
            trackingEnabled: true
        }
    },
    // Environment-specific configurations.
    // socketUrl/apiUrl are NOT set here — they come from @symbo.ls/channels.
    local: {
        dnsWorkerUrl: "https://dns.symbo.ls",
        githubClientId: "Ov23liAFrsR0StbAO6PO",
        grafanaAppName: "Symbols Localhost",
        features: {
            trackingEnabled: false,
            betaFeatures: true,
            newUserOnboarding: true
        },
        typesenseCollectionName: "docs"
    },
    development: {
        dnsWorkerUrl: "https://dns.symbo.ls",
        githubClientId: "Ov23liHxyWFBxS8f1gnF",
        grafanaAppName: "Symbols Dev",
        typesenseCollectionName: "docs"
    },
    test: {
        githubClientId: "Ov23liHxyWFBxS8f1gnF",
        grafanaAppName: "Symbols Test",
        typesenseCollectionName: "docs"
    },
    next: {
        githubClientId: "Ov23liHxyWFBxS8f1gnF",
        grafanaAppName: "Symbols Next",
        typesenseCollectionName: "docs"
    },
    upcoming: {
        githubClientId: "Ov23liWF7NvdZ056RV5J",
        grafanaAppName: "Symbols Upcoming",
        typesenseCollectionName: "docs"
    },
    staging: {
        githubClientId: "Ov23ligwZDQVD0VfuWNa",
        grafanaAppName: "Symbols Staging",
        typesenseCollectionName: "docs"
    },
    preview: {
        dnsWorkerUrl: "https://dns.symbo.ls",
        githubClientId: "Ov23liFAlOEIXtX3dBtR",
        grafanaAppName: "Symbols Preview",
        typesenseCollectionName: "docs"
    },
    production: {
        dnsWorkerUrl: "https://dns.symbo.ls",
        githubClientId: "Ov23liFAlOEIXtX3dBtR",
        grafanaAppName: "Symbols",
        typesenseCollectionName: "docs"
    }
};
$281a441cdcb2cf36$var$CONFIG.testing = $281a441cdcb2cf36$var$CONFIG.test;
var $281a441cdcb2cf36$var$parseSearchEndpoint = (apiUrl2)=>{
    let host = "";
    let port = "";
    let protocol4 = "";
    try {
        const u3 = new URL(apiUrl2);
        host = u3.hostname;
        protocol4 = u3.protocol.replace(":", "");
        port = u3.port || (protocol4 === "https" ? "443" : "80");
    } catch (_e) {}
    return {
        typesenseSearchUrl: `${apiUrl2}/search/docs/multi_search`,
        typesenseSearchPath: "/search/docs",
        typesenseHost: host,
        typesensePort: port,
        typesenseProtocol: protocol4,
        // Placeholder string sent to the proxy; the server replaces it with
        // the real key from its .env. Consumers using direct Typesense access
        // override via TYPESENSE_API_KEY env.
        typesenseApiKey: "proxy"
    };
};
var $281a441cdcb2cf36$var$getEnvironment = ()=>{
    const env = "upcoming";
    if (!$281a441cdcb2cf36$var$CONFIG[env]) throw new Error(`Unknown environment "${env}"`);
    return env;
};
var $281a441cdcb2cf36$var$getConfig = ()=>{
    try {
        const env = $281a441cdcb2cf36$var$getEnvironment();
        const envConfig = {
            ...$281a441cdcb2cf36$var$CONFIG.common,
            ...$281a441cdcb2cf36$var$CONFIG[env]
        };
        const channelName = env === "testing" ? "test" : env;
        const apiUrl2 = $281a441cdcb2cf36$var$apiUrl(channelName);
        const finalConfig = {
            ...envConfig,
            // Deep-merge feature flags so env-specific overrides don't drop common defaults
            features: {
                ...$281a441cdcb2cf36$var$CONFIG.common.features || {},
                ...$281a441cdcb2cf36$var$CONFIG[env] && $281a441cdcb2cf36$var$CONFIG[env].features || {}
            },
            // URLs come from @symbo.ls/channels (single source of truth across
            // sdk, smbls, server, editor, workspace, platform). SYMBOLS_API_URL /
            // SYMBOLS_SOCKET_URL env-var overrides honored inside the helpers.
            socketUrl: $281a441cdcb2cf36$var$socketUrl(channelName),
            apiUrl: apiUrl2,
            githubClientId: envConfig.githubClientId,
            // Grafana Faro telemetry: SDK posts events to the server proxy at
            // ${apiUrl}/telemetry/faro. The server holds the actual collector URL
            // + token in its .env (GRAFANA_FARO_URL). Direct override honored for
            // self-hosted/dev scenarios via SYMBOLS_APP_GRAFANA_URL.
            grafanaUrl: `${apiUrl2}/telemetry/faro`,
            // Cloudflare KV worker URL. No hardcoded fallback — set via env or
            // initialize KvService with an explicit url option.
            kvUrl: "",
            dnsWorkerUrl: envConfig.dnsWorkerUrl,
            dnsApiKey: "",
            // Typesense docs search: SDK calls the server proxy at
            // ${apiUrl}/search/docs/multi_search. Server holds TYPESENSE_API_KEY +
            // TYPESENSE_HOST in its .env. Direct Typesense access still possible
            // via env vars for self-hosted/dev (e.g. local docker). Pre-parsed
            // host/port/protocol/path fields are exported so consumers can plug
            // them straight into typesense-docsearch.js's `nodes[0]` config.
            ...$281a441cdcb2cf36$var$parseSearchEndpoint(apiUrl2),
            typesenseCollectionName: envConfig.typesenseCollectionName,
            channel: channelName,
            isDevelopment: (0, $kt4aQ.isDevelopment)(env),
            isTest: env === "test" || env === "testing",
            isStaging: env === "staging",
            isPreview: env === "preview",
            isProduction: env === "production"
        };
        const requiredFields = [
            "socketUrl",
            "apiUrl",
            "githubClientId",
            "googleClientId"
        ];
        const missingFields = requiredFields.filter((field)=>!finalConfig[field]);
        if (missingFields.length > 0) $281a441cdcb2cf36$var$logger.error(`Missing required configuration: ${missingFields.join(", ")}`);
        if ($parcel$global.window) $parcel$global.window.finalConfig = finalConfig;
        return finalConfig;
    } catch (error) {
        $281a441cdcb2cf36$var$logger.error("Failed to load environment configuration:", error);
        return {
            ...$281a441cdcb2cf36$var$CONFIG.development
        };
    }
};
var $281a441cdcb2cf36$export$6bc7b24d4e862158 = $281a441cdcb2cf36$var$getConfig();
// src/utils/TokenManager.js
var $281a441cdcb2cf36$var$TokenManager = class {
    constructor(options = {}){
        /**
     * Memory storage fallback for server-side rendering
     */ $281a441cdcb2cf36$var$__publicField(this, "_memoryStorage", {
            _data: {},
            getItem: (key)=>this._memoryStorage._data[key] || null,
            setItem: (key, value2)=>{
                this._memoryStorage._data[key] = value2;
            },
            removeItem: (key)=>{
                delete this._memoryStorage._data[key];
            },
            clear: ()=>{
                this._memoryStorage._data = {};
            }
        });
        this.config = {
            storagePrefix: "symbols_",
            storageType: typeof window === "undefined" || false || false ? "memory" : "localStorage",
            // 'localStorage' | 'sessionStorage' | 'memory'
            refreshBuffer: 60000,
            // Refresh 1 minute before expiry
            maxRetries: 3,
            apiUrl: options.apiUrl || "/api",
            onTokenRefresh: options.onTokenRefresh || null,
            onTokenExpired: options.onTokenExpired || null,
            onTokenError: options.onTokenError || null,
            ...options
        };
        this.tokens = {
            accessToken: null,
            refreshToken: null,
            expiresAt: null,
            expiresIn: null
        };
        this.refreshPromise = null;
        this.refreshTimeout = null;
        this.retryCount = 0;
        this.loadTokens();
    }
    /**
   * Storage keys
   */ get storageKeys() {
        return {
            accessToken: `${this.config.storagePrefix}access_token`,
            refreshToken: `${this.config.storagePrefix}refresh_token`,
            expiresAt: `${this.config.storagePrefix}expires_at`,
            expiresIn: `${this.config.storagePrefix}expires_in`
        };
    }
    /**
   * Get storage instance based on configuration
   */ get storage() {
        if (typeof window === "undefined") return this._memoryStorage;
        const safeGetStorage = (provider)=>{
            try {
                const storage = provider();
                const testKey = `${this.config.storagePrefix}__tm_test__`;
                storage.setItem(testKey, "1");
                storage.removeItem(testKey);
                return storage;
            } catch  {
                return null;
            }
        };
        const localStorageInstance = safeGetStorage(()=>window.localStorage);
        const sessionStorageInstance = safeGetStorage(()=>window.sessionStorage);
        switch(this.config.storageType){
            case "sessionStorage":
                return sessionStorageInstance || this._memoryStorage;
            case "memory":
                return this._memoryStorage;
            default:
                return localStorageInstance || this._memoryStorage;
        }
    }
    /**
   * Set tokens and persist to storage
   */ setTokens(tokenData) {
        const { access_token: accessToken, refresh_token: refreshToken, expires_in: expiresIn, token_type: tokenType = "Bearer" } = tokenData;
        if (!accessToken) throw new Error("Access token is required");
        const now = Date.now();
        const expiresAt2 = expiresIn ? now + expiresIn * 1e3 : null;
        this.tokens = {
            accessToken: accessToken,
            refreshToken: refreshToken || this.tokens.refreshToken,
            expiresAt: expiresAt2,
            expiresIn: expiresIn,
            tokenType: tokenType
        };
        this.saveTokens();
        this.scheduleRefresh();
        if (this.config.onTokenRefresh) this.config.onTokenRefresh(this.tokens);
        return this.tokens;
    }
    /**
   * Get current access token
   */ getAccessToken() {
        return this.tokens.accessToken;
    }
    /**
   * Get current refresh token
   */ getRefreshToken() {
        return this.tokens.refreshToken;
    }
    /**
   * Get authorization header value
   */ getAuthHeader() {
        const token = this.getAccessToken();
        if (!token) return null;
        return `${this.tokens.tokenType || "Bearer"} ${token}`;
    }
    /**
   * Check if access token is valid and not expired
   */ isAccessTokenValid() {
        if (!this.tokens.accessToken) return false;
        if (!this.tokens.expiresAt) return true;
        const now = Date.now();
        const isValid = now < this.tokens.expiresAt - this.config.refreshBuffer;
        if (!isValid) $281a441cdcb2cf36$var$logger.log("[TokenManager] Access token is expired or near expiry:", {
            now: new Date(now).toISOString(),
            expiresAt: new Date(this.tokens.expiresAt).toISOString(),
            refreshBuffer: this.config.refreshBuffer
        });
        return isValid;
    }
    /**
   * Check if access token exists and is not expired (without refresh buffer)
   */ isAccessTokenActuallyValid() {
        if (!this.tokens.accessToken) return false;
        if (!this.tokens.expiresAt) return true;
        const now = Date.now();
        return now < this.tokens.expiresAt;
    }
    /**
   * Check if tokens exist (regardless of expiry)
   */ hasTokens() {
        return Boolean(this.tokens.accessToken);
    }
    /**
   * Check if refresh token exists
   */ hasRefreshToken() {
        return Boolean(this.tokens.refreshToken);
    }
    /**
   * Automatically refresh tokens if needed
   */ async ensureValidToken() {
        if (!this.hasTokens()) return null;
        if (this.isAccessTokenValid()) return this.getAccessToken();
        if (!this.hasRefreshToken()) {
            this.clearTokens();
            if (this.config.onTokenExpired) this.config.onTokenExpired();
            return null;
        }
        try {
            await this.refreshTokens();
            return this.getAccessToken();
        } catch (error) {
            this.clearTokens();
            if (this.config.onTokenError) this.config.onTokenError(error);
            throw error;
        }
    }
    /**
   * Refresh access token using refresh token
   */ async refreshTokens() {
        if (this.refreshPromise) return this.refreshPromise;
        if (!this.hasRefreshToken()) throw new Error("No refresh token available");
        if (this.retryCount >= this.config.maxRetries) throw new Error("Max refresh retries exceeded");
        this.refreshPromise = this._performRefresh();
        try {
            const result = await this.refreshPromise;
            this.retryCount = 0;
            return result;
        } catch (error) {
            this.retryCount++;
            throw error;
        } finally{
            this.refreshPromise = null;
        }
    }
    /**
   * Perform the actual token refresh request
   */ async _performRefresh() {
        var _a2;
        const refreshToken = this.getRefreshToken();
        const response = await fetch(`${this.config.apiUrl}/core/auth/refresh`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                refreshToken: refreshToken
            })
        });
        if (!response.ok) {
            const errorData = await response.json().catch(()=>({}));
            throw new Error(errorData.message || `Token refresh failed: ${response.status}`);
        }
        const responseData = await response.json();
        if (responseData.success && responseData.data && responseData.data.tokens) {
            const { tokens: tokens } = responseData.data;
            const tokenData = {
                access_token: tokens.accessToken,
                refresh_token: tokens.refreshToken,
                expires_in: (_a2 = tokens.accessTokenExp) == null ? void 0 : _a2.expiresIn,
                token_type: "Bearer"
            };
            return this.setTokens(tokenData);
        }
        return this.setTokens(responseData);
    }
    /**
   * Schedule automatic token refresh
   */ scheduleRefresh() {
        if (this.refreshTimeout) {
            clearTimeout(this.refreshTimeout);
            this.refreshTimeout = null;
        }
        if (!this.tokens.expiresAt || !this.hasRefreshToken()) return;
        const now = Date.now();
        const refreshTime = this.tokens.expiresAt - this.config.refreshBuffer;
        const delay = Math.max(0, refreshTime - now);
        this.refreshTimeout = setTimeout(async ()=>{
            try {
                await this.refreshTokens();
            } catch (error) {
                $281a441cdcb2cf36$var$logger.error("Automatic token refresh failed:", error);
                if (this.config.onTokenError) this.config.onTokenError(error);
            }
        }, delay);
    }
    /**
   * Save tokens to storage
   */ saveTokens() {
        try {
            const { storage: storage } = this;
            const keys2 = this.storageKeys;
            if (this.tokens.accessToken) storage.setItem(keys2.accessToken, this.tokens.accessToken);
            if (this.tokens.refreshToken) storage.setItem(keys2.refreshToken, this.tokens.refreshToken);
            if (this.tokens.expiresAt) storage.setItem(keys2.expiresAt, this.tokens.expiresAt.toString());
            if (this.tokens.expiresIn) storage.setItem(keys2.expiresIn, this.tokens.expiresIn.toString());
        } catch (error) {
            $281a441cdcb2cf36$var$logger.error("[TokenManager] Error saving tokens to storage:", error);
        }
    }
    /**
   * Load tokens from storage
   */ loadTokens() {
        try {
            const { storage: storage } = this;
            const keys2 = this.storageKeys;
            const accessToken = storage.getItem(keys2.accessToken);
            const refreshToken = storage.getItem(keys2.refreshToken);
            const expiresAt2 = storage.getItem(keys2.expiresAt);
            const expiresIn = storage.getItem(keys2.expiresIn);
            if (accessToken) {
                this.tokens = {
                    accessToken: accessToken,
                    refreshToken: refreshToken,
                    expiresAt: expiresAt2 ? parseInt(expiresAt2, 10) : null,
                    expiresIn: expiresIn ? parseInt(expiresIn, 10) : null,
                    tokenType: "Bearer"
                };
                this.scheduleRefresh();
            }
        } catch (error) {
            $281a441cdcb2cf36$var$logger.error("[TokenManager] Error loading tokens from storage:", error);
            this.tokens = {
                accessToken: null,
                refreshToken: null,
                expiresAt: null,
                expiresIn: null
            };
        }
    }
    /**
   * Clear all tokens
   */ clearTokens() {
        this.tokens = {
            accessToken: null,
            refreshToken: null,
            expiresAt: null,
            expiresIn: null
        };
        const { storage: storage } = this;
        const keys2 = this.storageKeys;
        Object.values(keys2).forEach((key)=>{
            storage.removeItem(key);
        });
        if (this.refreshTimeout) {
            clearTimeout(this.refreshTimeout);
            this.refreshTimeout = null;
        }
        this.retryCount = 0;
    }
    /**
   * Get token status information
   */ getTokenStatus() {
        const hasTokens = this.hasTokens();
        const isValid = this.isAccessTokenValid();
        const { expiresAt: expiresAt2 } = this.tokens;
        const timeToExpiry = expiresAt2 ? expiresAt2 - Date.now() : null;
        return {
            hasTokens: hasTokens,
            isValid: isValid,
            hasRefreshToken: this.hasRefreshToken(),
            expiresAt: expiresAt2,
            timeToExpiry: timeToExpiry,
            willExpireSoon: timeToExpiry ? timeToExpiry < this.config.refreshBuffer : false
        };
    }
    /**
   * Cleanup resources
   */ destroy() {
        if (this.refreshTimeout) {
            clearTimeout(this.refreshTimeout);
            this.refreshTimeout = null;
        }
        this.refreshPromise = null;
    }
};
var $281a441cdcb2cf36$var$defaultTokenManager = null;
var $281a441cdcb2cf36$var$getTokenManager = (options)=>{
    if (!$281a441cdcb2cf36$var$defaultTokenManager) $281a441cdcb2cf36$var$defaultTokenManager = new $281a441cdcb2cf36$var$TokenManager(options);
    return $281a441cdcb2cf36$var$defaultTokenManager;
};
// src/services/BaseService.js
var $281a441cdcb2cf36$var$BaseService = class {
    constructor({ context: context2, options: options } = {}){
        this._context = context2 || {};
        this._options = options || {};
        this._ready = false;
        this._error = null;
        this._apiUrl = null;
        this._tokenManager = null;
    }
    // Initialize service
    init({ context: context2 }) {
        try {
            const { apiUrl: apiUrl2 } = context2 || this._context;
            this._apiUrl = apiUrl2 || $281a441cdcb2cf36$export$6bc7b24d4e862158.apiUrl;
            if (!this._apiUrl) throw new Error("Service base URL not configured");
            this._tokenManager = $281a441cdcb2cf36$var$getTokenManager({
                apiUrl: this._apiUrl,
                onTokenError: (error)=>{
                    $281a441cdcb2cf36$var$logger.error("Token management error:", error);
                }
            });
            const ctx = context2 || this._context;
            if (ctx.authToken && !this._tokenManager.getAccessToken()) this._tokenManager.setTokens({
                access_token: ctx.authToken
            });
            this._setReady();
        } catch (error) {
            this._setError(error);
            throw error;
        }
    }
    // Update context
    updateContext(context2) {
        if (context2 && typeof context2 === "object") Object.assign(this._context, context2);
    }
    // Get service status
    getStatus() {
        return {
            ready: this._ready,
            error: this._error,
            context: {
                ...this._context
            }
        };
    }
    // Check if service is ready
    isReady() {
        return this._ready;
    }
    // Protected helper methods
    _setReady(ready = true) {
        this._ready = ready;
        this._error = null;
    }
    _setError(error) {
        this._ready = false;
        this._error = error;
    }
    _getTrackingService() {
        var _a2;
        const services = (_a2 = this._context) == null ? void 0 : _a2.services;
        const tracking = services == null ? void 0 : services.tracking;
        if (!tracking || typeof tracking.trackError !== "function") return null;
        return tracking;
    }
    _shouldTrackErrors() {
        var _a2;
        const name = (_a2 = this == null ? void 0 : this.constructor) == null ? void 0 : _a2.name;
        return name !== "TrackingService";
    }
    _trackServiceError(error, details = {}) {
        var _a2;
        if (!this._shouldTrackErrors()) return;
        try {
            const tracking = this._getTrackingService();
            if (!tracking) return;
            const context2 = {
                service: ((_a2 = this == null ? void 0 : this.constructor) == null ? void 0 : _a2.name) || "UnknownService",
                apiUrl: this._apiUrl || null,
                ...details
            };
            tracking.trackError(error instanceof Error ? error : new Error(String(error)), context2);
        } catch  {}
    }
    _requireAuth() {
        if (!this.getAuthToken()) throw new Error("Authentication required");
    }
    _requireReady(methodName = "unknown") {
        if (!this.isReady()) throw new Error(`Service not initialized for method: ${methodName}`);
    }
    // Shared HTTP request method
    async _request(endpoint, options = {}) {
        const url2 = `${this._apiUrl}/core${endpoint}`;
        const defaultHeaders = {};
        if (!(options.body instanceof FormData)) defaultHeaders["Content-Type"] = "application/json";
        if (this._requiresInit(options.methodName) && this._tokenManager) try {
            const validToken = await this._tokenManager.ensureValidToken();
            if (validToken) {
                const authHeader = this._tokenManager.getAuthHeader();
                if (authHeader) defaultHeaders.Authorization = authHeader;
            }
        } catch (error) {
            $281a441cdcb2cf36$var$logger.warn("Token management failed, proceeding without authentication:", error);
        }
        try {
            const response = await fetch(url2, {
                ...options,
                headers: {
                    ...defaultHeaders,
                    ...options.headers
                }
            });
            if (!response.ok) {
                let error = {
                    message: `HTTP ${response.status}: ${response.statusText}`
                };
                try {
                    error = await response.json();
                } catch  {}
                this._trackServiceError(new Error(error.message || error.error || `HTTP ${response.status}: ${response.statusText}`), {
                    endpoint: endpoint,
                    methodName: options.methodName,
                    status: response.status,
                    statusText: response.statusText
                });
                throw new Error(error.message || error.error || "Request failed", {
                    cause: error
                });
            }
            return response.status === 204 ? null : response.json();
        } catch (error) {
            this._trackServiceError(error, {
                endpoint: endpoint,
                methodName: options.methodName
            });
            throw new Error(`Request failed: ${error.message}`, {
                cause: error
            });
        }
    }
    // Envelope-aware request: expects the server to respond with
    // { success, data, message } and unwraps to `data` on success or throws
    // `new Error(message)` otherwise. Collapses the ~5 lines of boilerplate
    // that every service method repeats.
    async _call(methodName, endpoint, { method: method = "GET", body: body, headers: headers } = {}) {
        this._requireReady(methodName);
        const init = {
            method: method,
            methodName: methodName
        };
        if (headers) init.headers = headers;
        if (body !== void 0) init.body = body instanceof FormData ? body : JSON.stringify(body);
        const response = await this._request(endpoint, init);
        if (response && typeof response === "object" && "success" in response) {
            if (response.success) return response.data;
            throw new Error(response.message || `${methodName} failed`);
        }
        return response;
    }
    // Helper method to determine if a method requires initialization
    _requiresInit(methodName) {
        const noInitMethods = /* @__PURE__ */ new Set([
            "register",
            "login",
            "googleAuth",
            "googleAuthCallback",
            "githubAuth",
            "requestPasswordReset",
            "confirmPasswordReset",
            "confirmRegistration",
            "verifyEmail",
            "getPlans",
            "getPlan",
            "listPublicProjects",
            "getPublicProject"
        ]);
        return !noInitMethods.has(methodName);
    }
    // Register subdomain DNS records via cloudflare-dns worker
    // Creates: {name}.symbo.ls and *.{name}.symbo.ls
    async _createSubdomainRecords(name) {
        var _a2, _b;
        const dnsUrl = ((_a2 = this._context) == null ? void 0 : _a2.dnsWorkerUrl) || $281a441cdcb2cf36$export$6bc7b24d4e862158.dnsWorkerUrl;
        const dnsKey = ((_b = this._context) == null ? void 0 : _b.dnsApiKey) || $281a441cdcb2cf36$export$6bc7b24d4e862158.dnsApiKey;
        if (!dnsUrl) {
            $281a441cdcb2cf36$var$logger.warn("DNS worker URL not configured, skipping subdomain registration");
            return;
        }
        const resp = await fetch(`${dnsUrl}/register`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                ...dnsKey ? {
                    Authorization: `Bearer ${dnsKey}`
                } : {}
            },
            body: JSON.stringify({
                name: name
            })
        });
        if (!resp.ok) {
            const err = await resp.json().catch(()=>({
                    error: resp.statusText
                }));
            throw new Error(err.error || `DNS registration failed (${resp.status})`);
        }
        return resp.json();
    }
    // Cleanup method
    destroy() {
        if (this._tokenManager) {
            this._tokenManager.destroy();
            this._tokenManager = null;
        }
        this._ready = false;
        this._setReady(false);
    }
};
// src/utils/permission.js
var $281a441cdcb2cf36$var$ROLE_PERMISSIONS = {
    guest: [
        "viewPublicProjects"
    ],
    user: [
        "viewPublicProjects"
    ],
    admin: [
        "viewPublicProjects",
        "governance"
    ],
    superAdmin: [
        "viewPublicProjects",
        "governance",
        "managePlatform"
    ]
};
var $281a441cdcb2cf36$var$TIER_FEATURES = {
    ready: [
        "editMode",
        "freeDomain",
        "accessToSymbolsLibrary",
        "canvasPages",
        "versionHistory",
        "downloadAsSVG",
        "branching",
        "noWatermark"
    ],
    free: [
        "editMode",
        "freeDomain",
        "accessToSymbolsLibrary",
        "marketplace",
        "downloadAsReact",
        "vscodeSync",
        "chromeExtension",
        "canvasPages",
        "versionHistory",
        "importFromFigma",
        "privateProjects",
        "sharing",
        "aiCopilot:3",
        "aiChatbot:3"
    ],
    pro1: [
        "editMode",
        "freeDomain",
        "accessToSymbolsLibrary",
        "marketplace",
        "downloadAsReact",
        "vscodeSync",
        "chromeExtension",
        "canvasPages",
        "versionHistory",
        "sharedLibraries",
        "downloadAsSVG",
        "customDomain",
        "branching",
        "plugins",
        "autoDesignDocs",
        "importFromFigma",
        "exportToFigma",
        "customBackendIntegration",
        "privateProjects",
        "sharing",
        "inviteMembersIAM",
        "aiCopilot:5",
        "aiChatbot:5"
    ],
    pro2: [
        "editMode",
        "freeDomain",
        "accessToSymbolsLibrary",
        "marketplace",
        "downloadAsReact",
        "vscodeSync",
        "chromeExtension",
        "canvasPages",
        "versionHistory",
        "sharedLibraries",
        "downloadAsSVG",
        "customDomain",
        "branching",
        "plugins",
        "autoDesignDocs",
        "noWatermark",
        "importFromFigma",
        "exportToFigma",
        "customBackendIntegration",
        "integrationsSDK",
        "backendFunctions",
        "privateProjects",
        "sharing",
        "inviteMembersIAM",
        "workspaceAdministration",
        "teamRolesAndPermissions",
        "aiCopilot:15",
        "aiChatbot:15"
    ],
    enterprise: [
        "analytics",
        "crashalytics",
        "projectManagementTools",
        "testingTools",
        "stripeConnect",
        "dompilerCloud"
    ]
};
var $281a441cdcb2cf36$var$PROJECT_ROLE_PERMISSIONS = {
    unauthenticated: [
        "platformSettings",
        "showContent"
    ],
    guest: [
        "platformSettings",
        "showContent"
    ],
    editor: [
        "platformSettings",
        "showContent",
        "showCode",
        "editMode",
        "versions"
    ],
    admin: [
        "platformSettings",
        "showContent",
        "showCode",
        "editMode",
        "versions",
        "inviteMembers",
        "branchProtection",
        "projectSettings"
    ],
    owner: [
        "platformSettings",
        "showContent",
        "showCode",
        "editMode",
        "versions",
        "inviteMembers",
        "branchProtection",
        "projectSettings",
        "copyPasteAllowanceSetting",
        "iam"
    ]
};
// src/services/AuthService.js
var $281a441cdcb2cf36$var$PLUGIN_SESSION_STORAGE_KEY = "plugin_auth_session";
var $281a441cdcb2cf36$var$AuthService = class extends $281a441cdcb2cf36$var$BaseService {
    constructor(config){
        var _a2, _b;
        super(config);
        this._userRoles = /* @__PURE__ */ new Set([
            "guest",
            "editor",
            "admin",
            "owner"
        ]);
        this._projectTiers = /* @__PURE__ */ new Set([
            "ready",
            "starter",
            "pro1",
            "pro2",
            "enterprise"
        ]);
        this._projectRoleCache = /* @__PURE__ */ new Map();
        this._roleCacheExpiry = 300000;
        this._pluginSession = null;
        this._authListeners = /* @__PURE__ */ new Set();
        this._resolvePluginSession((config == null ? void 0 : config.session) || (config == null ? void 0 : config.pluginSession) || ((_a2 = config == null ? void 0 : config.options) == null ? void 0 : _a2.pluginSession) || ((_b = config == null ? void 0 : config.context) == null ? void 0 : _b.pluginSession) || null);
    }
    // Use BaseService.init/_request/_requireReady implementations
    // ==================== AUTH METHODS ====================
    async register(userData, options = {}) {
        var _a2, _b;
        try {
            const { payload: payload, session: session } = this._preparePluginPayload({
                ...userData || {}
            }, options.session);
            const response = await this._request("/auth/register", {
                method: "POST",
                body: JSON.stringify(payload),
                methodName: "register"
            });
            if (response.success) {
                if (session) this._clearPluginSession(session);
                const username = (_b = (_a2 = response.data) == null ? void 0 : _a2.user) == null ? void 0 : _b.username;
                if (username) this._createSubdomainRecords(username).catch((err)=>{
                    $281a441cdcb2cf36$var$logger.warn("Failed to create DNS records for user:", (err == null ? void 0 : err.message) || err);
                });
                return response.data;
            }
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Registration failed: ${error.message}`, {
                cause: error
            });
        }
    }
    async login(email, password, options = {}) {
        var _a2, _b, _c;
        try {
            const { payload: payload, session: session } = this._preparePluginPayload({
                email: email,
                password: password
            }, options.session);
            const response = await this._request("/auth/login", {
                method: "POST",
                body: JSON.stringify(payload),
                methodName: "login"
            });
            if (response.success && response.data && response.data.tokens) {
                const { tokens: tokens } = response.data;
                const tokenData = {
                    access_token: tokens.accessToken,
                    refresh_token: tokens.refreshToken,
                    expires_in: (_a2 = tokens.accessTokenExp) == null ? void 0 : _a2.expiresIn,
                    token_type: "Bearer"
                };
                if (this._tokenManager) this._tokenManager.setTokens(tokenData);
                this._currentUser = ((_b = response.data) == null ? void 0 : _b.user) || null;
                (_c = this._emitAuth) == null || _c.call(this, "SIGNED_IN");
            }
            if (response.success) {
                if (session) this._clearPluginSession(session);
                return response.data;
            }
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Login failed: ${error.message}`, {
                cause: error
            });
        }
    }
    async logout() {
        var _a2, _b;
        this._requireReady("logout");
        try {
            await this._request("/auth/logout", {
                method: "POST",
                methodName: "logout"
            });
            if (this._tokenManager) this._tokenManager.clearTokens();
            this._currentUser = null;
            (_a2 = this._emitAuth) == null || _a2.call(this, "SIGNED_OUT");
        } catch (error) {
            if (this._tokenManager) this._tokenManager.clearTokens();
            this._currentUser = null;
            (_b = this._emitAuth) == null || _b.call(this, "SIGNED_OUT");
            throw new Error(`Logout failed: ${error.message}`, {
                cause: error
            });
        }
    }
    async refreshToken(refreshToken) {
        try {
            const response = await this._request("/auth/refresh", {
                method: "POST",
                body: JSON.stringify({
                    refreshToken: refreshToken
                }),
                methodName: "refreshToken"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Token refresh failed: ${error.message}`, {
                cause: error
            });
        }
    }
    async googleAuth(idToken, inviteToken = null, options = {}) {
        var _a2;
        try {
            const { payload: payload, session: session } = this._preparePluginPayload({
                idToken: idToken
            }, options.session);
            if (inviteToken) payload.inviteToken = inviteToken;
            const response = await this._request("/auth/google", {
                method: "POST",
                body: JSON.stringify(payload),
                methodName: "googleAuth"
            });
            if (response.success && response.data && response.data.tokens) {
                const { tokens: tokens } = response.data;
                const tokenData = {
                    access_token: tokens.accessToken,
                    refresh_token: tokens.refreshToken,
                    expires_in: (_a2 = tokens.accessTokenExp) == null ? void 0 : _a2.expiresIn,
                    token_type: "Bearer"
                };
                if (this._tokenManager) this._tokenManager.setTokens(tokenData);
            }
            if (response.success) {
                if (session) this._clearPluginSession(session);
                return response.data;
            }
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Google auth failed: ${error.message}`, {
                cause: error
            });
        }
    }
    async githubAuth(code, inviteToken = null, options = {}) {
        var _a2;
        try {
            const { payload: payload, session: session } = this._preparePluginPayload({
                code: code
            }, options.session);
            if (inviteToken) payload.inviteToken = inviteToken;
            const response = await this._request("/auth/github", {
                method: "POST",
                body: JSON.stringify(payload),
                methodName: "githubAuth"
            });
            if (response.success && response.data && response.data.tokens) {
                const { tokens: tokens } = response.data;
                const tokenData = {
                    access_token: tokens.accessToken,
                    refresh_token: tokens.refreshToken,
                    expires_in: (_a2 = tokens.accessTokenExp) == null ? void 0 : _a2.expiresIn,
                    token_type: "Bearer"
                };
                if (this._tokenManager) this._tokenManager.setTokens(tokenData);
            }
            if (response.success) {
                if (session) this._clearPluginSession(session);
                return response.data;
            }
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`GitHub auth failed: ${error.message}`, {
                cause: error
            });
        }
    }
    async googleAuthCallback(code, redirectUri, inviteToken = null, options = {}) {
        var _a2;
        try {
            const { payload: body, session: session } = this._preparePluginPayload({
                code: code,
                redirectUri: redirectUri
            }, options.session);
            if (inviteToken) body.inviteToken = inviteToken;
            const response = await this._request("/auth/google/callback", {
                method: "POST",
                body: JSON.stringify(body),
                methodName: "googleAuthCallback"
            });
            if (response.success && response.data && response.data.tokens) {
                const { tokens: tokens } = response.data;
                const tokenData = {
                    access_token: tokens.accessToken,
                    refresh_token: tokens.refreshToken,
                    expires_in: (_a2 = tokens.accessTokenExp) == null ? void 0 : _a2.expiresIn,
                    token_type: "Bearer"
                };
                if (this._tokenManager) this._tokenManager.setTokens(tokenData);
            }
            if (response.success) {
                if (session) this._clearPluginSession(session);
                return response.data;
            }
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Google auth callback failed: ${error.message}`, {
                cause: error
            });
        }
    }
    async requestPasswordReset(email) {
        try {
            const response = await this._request("/auth/request-password-reset", {
                method: "POST",
                body: JSON.stringify({
                    email: email
                }),
                methodName: "requestPasswordReset"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Password reset request failed: ${error.message}`, {
                cause: error
            });
        }
    }
    async confirmPasswordReset(token, password) {
        try {
            const response = await this._request("/auth/reset-password-confirm", {
                method: "POST",
                body: JSON.stringify({
                    token: token,
                    password: password
                }),
                methodName: "confirmPasswordReset"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Password reset confirmation failed: ${error.message}`, {
                cause: error
            });
        }
    }
    async confirmRegistration(token) {
        try {
            const response = await this._request("/auth/register-confirmation", {
                method: "POST",
                body: JSON.stringify({
                    token: token
                }),
                methodName: "confirmRegistration"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Registration confirmation failed: ${error.message}`, {
                cause: error
            });
        }
    }
    async requestPasswordChange() {
        this._requireReady("requestPasswordChange");
        try {
            const response = await this._request("/auth/request-password-change", {
                method: "POST",
                methodName: "requestPasswordChange"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Password change request failed: ${error.message}`, {
                cause: error
            });
        }
    }
    async confirmPasswordChange(currentPassword, newPassword, code) {
        this._requireReady("confirmPasswordChange");
        try {
            const response = await this._request("/auth/confirm-password-change", {
                method: "POST",
                body: JSON.stringify({
                    currentPassword: currentPassword,
                    newPassword: newPassword,
                    code: code
                }),
                methodName: "confirmPasswordChange"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Password change confirmation failed: ${error.message}`, {
                cause: error
            });
        }
    }
    async getMe(options = {}) {
        var _a2, _b;
        this._requireReady("getMe");
        try {
            const session = this._resolvePluginSession(options.session);
            const response = session ? await this._request(`/auth/me?session=${encodeURIComponent(session)}`, {
                method: "GET",
                methodName: "getMe"
            }) : await this._request("/auth/me", {
                method: "GET",
                methodName: "getMe"
            });
            if (response.success) {
                this._currentUser = ((_a2 = response.data) == null ? void 0 : _a2.user) || response.data || null;
                (_b = this._emitAuth) == null || _b.call(this, "USER_UPDATED");
                return response.data;
            }
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to get user profile: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Update the current user's profile / preferences.
   * Replaces the (now-removed) `sdk.auth.updateMe(...)` call sites that
   * existed before SERVICE_METHODS flattened auth methods. Body shape is
   * forwarded to /auth/me PATCH; server decides what columns are mutable.
   */ async updateMe(payload) {
        var _a2, _b;
        this._requireReady("updateMe");
        try {
            const response = await this._request("/auth/me", {
                method: "PATCH",
                body: JSON.stringify(payload || {}),
                methodName: "updateMe"
            });
            if (response.success) {
                this._currentUser = ((_a2 = response.data) == null ? void 0 : _a2.user) || response.data || this._currentUser;
                (_b = this._emitAuth) == null || _b.call(this, "USER_UPDATED");
                return response.data;
            }
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to update user profile: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Fetch the caller's permission set, optionally scoped to an org.
   * Replaces sb()-side workspace_role lookups + the legacy
   * sdk.auth.getPermissions() call sites in the workspace switchers.
   */ async getPermissions(orgId) {
        this._requireReady("getPermissions");
        try {
            const url2 = orgId ? `/auth/permissions?org=${encodeURIComponent(orgId)}` : "/auth/permissions";
            const response = await this._request(url2, {
                method: "GET",
                methodName: "getPermissions"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to fetch permissions: ${error.message}`, {
                cause: error
            });
        }
    }
    getAuthToken() {
        if (!this._tokenManager) return null;
        return this._tokenManager.getAccessToken();
    }
    // ==================== SESSION + STATE-CHANGE ====================
    //
    // SDK-side equivalents of Supabase auth.getSession() / auth.onAuthStateChange().
    // These let frontend consumers migrate off direct supabase-js usage without
    // losing their auth-state observation pattern. The shape mimics Supabase's
    // session object so call sites only need a one-line shim during migration.
    /**
   * Returns the currently-active session, or null when there are no tokens.
   * Shape:
   *   { access_token, refresh_token, expires_at, token_type: 'bearer', user }
   */ getSession() {
        var _a2, _b, _c, _d;
        const tm = this._tokenManager;
        if (!tm || !((_a2 = tm.hasTokens) == null ? void 0 : _a2.call(tm))) return null;
        const access_token = (_b = tm.getAccessToken) == null ? void 0 : _b.call(tm);
        const refresh_token = (_c = tm.getRefreshToken) == null ? void 0 : _c.call(tm);
        if (!access_token) return null;
        return {
            access_token: access_token,
            refresh_token: refresh_token,
            expires_at: ((_d = tm.tokens) == null ? void 0 : _d.expiresAt) || null,
            token_type: "bearer",
            // _currentUser is hydrated by getMe()/login()/refresh paths; leave
            // null if the consumer hasn't asked for the profile yet — they can
            // call sdk.getMe() to populate it.
            user: this._currentUser || null
        };
    }
    /**
   * Subscribe to auth state transitions (login, logout, token refresh).
   * Returns an unsubscribe function. Mirrors Supabase's
   * `onAuthStateChange((event, session) => {...})` callback shape so
   * migrating call sites only need to swap the import.
   *
   * Events:
   *   'INITIAL_SESSION'  — fires once on subscribe, current session (or null)
   *   'SIGNED_IN'        — login / register success
   *   'SIGNED_OUT'       — logout / token clear
   *   'TOKEN_REFRESHED'  — refresh path completed
   *   'USER_UPDATED'     — getMe / updateMe refreshed _currentUser
   */ onAuthStateChange(callback) {
        if (typeof callback !== "function") return ()=>{};
        this._authListeners.add(callback);
        try {
            callback("INITIAL_SESSION", this.getSession());
        } catch (_3) {}
        return ()=>{
            this._authListeners.delete(callback);
        };
    }
    // Internal: emit an auth event to all subscribers. Login/logout/refresh
    // call this on completion so consumers stay in sync without polling.
    _emitAuth(event) {
        const session = this.getSession();
        for (const listener of this._authListeners)try {
            listener(event, session);
        } catch (_3) {}
    }
    /**
   * Get stored authentication state (backward compatibility method)
   * Replaces AuthService.getStoredAuthState()
   */ async getStoredAuthState() {
        try {
            if (!this._tokenManager) return {
                userId: false,
                authToken: false
            };
            const tokenStatus = this._tokenManager.getTokenStatus();
            if (!tokenStatus.hasTokens) return {
                userId: false,
                authToken: false
            };
            if (!tokenStatus.isValid && tokenStatus.hasRefreshToken) try {
                await this._tokenManager.ensureValidToken();
            } catch (error) {
                $281a441cdcb2cf36$var$logger.warn("[AuthService] Token refresh failed:", error.message);
                if (error.message.includes("401") || error.message.includes("403") || error.message.includes("invalid") || error.message.includes("expired")) {
                    this._tokenManager.clearTokens();
                    return {
                        userId: false,
                        authToken: false,
                        error: `Authentication failed: ${error.message}`
                    };
                }
                return {
                    userId: false,
                    authToken: this._tokenManager.getAccessToken(),
                    error: `Network error during token refresh: ${error.message}`,
                    hasTokens: true
                };
            }
            const currentAccessToken = this._tokenManager.getAccessToken();
            if (!currentAccessToken) return {
                userId: false,
                authToken: false
            };
            try {
                const currentUser = await this.getMe();
                return {
                    userId: currentUser.user.id,
                    authToken: currentAccessToken,
                    ...currentUser,
                    error: null
                };
            } catch (error) {
                $281a441cdcb2cf36$var$logger.warn("[AuthService] Failed to get user data:", error.message);
                if (error.message.includes("401") || error.message.includes("403")) {
                    this._tokenManager.clearTokens();
                    return {
                        userId: false,
                        authToken: false,
                        error: `Authentication failed: ${error.message}`
                    };
                }
                return {
                    userId: false,
                    authToken: currentAccessToken,
                    error: `Failed to get user data: ${error.message}`,
                    hasTokens: true
                };
            }
        } catch (error) {
            $281a441cdcb2cf36$var$logger.error("[AuthService] Unexpected error in getStoredAuthState:", error);
            return {
                userId: false,
                authToken: false,
                error: `Failed to get stored auth state: ${error.message}`
            };
        }
    }
    // ==================== USER METHODS ====================
    async getUserProfile() {
        this._requireReady("getUserProfile");
        try {
            const response = await this._request("/users/profile", {
                method: "GET",
                methodName: "getUserProfile"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to get user profile: ${error.message}`, {
                cause: error
            });
        }
    }
    async updateUserProfile(profileData) {
        this._requireReady("updateUserProfile");
        try {
            const response = await this._request("/users/profile", {
                method: "PATCH",
                body: JSON.stringify(profileData),
                methodName: "updateUserProfile"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to update user profile: ${error.message}`, {
                cause: error
            });
        }
    }
    async getUserProjects() {
        this._requireReady("getUserProjects");
        try {
            const response = await this._request("/users/projects", {
                method: "GET",
                methodName: "getUserProjects"
            });
            if (response.success) return response.data.map((project)=>({
                    ...project,
                    ...project.icon && {
                        icon: {
                            src: `${this._apiUrl}/core/files/public/${project.icon.id}/download`,
                            ...project.icon
                        }
                    }
                }));
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to get user projects: ${error.message}`, {
                cause: error
            });
        }
    }
    async getUser(userId) {
        this._requireReady("getUser");
        if (!userId) throw new Error("User ID is required");
        try {
            const response = await this._request(`/users/${userId}`, {
                method: "GET",
                methodName: "getUser"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to get user: ${error.message}`, {
                cause: error
            });
        }
    }
    async getUserByEmail(email) {
        this._requireReady("getUserByEmail");
        if (!email) throw new Error("Email is required");
        try {
            const response = await this._request(`/auth/user?email=${email}`, {
                method: "GET",
                methodName: "getUserByEmail"
            });
            if (response.success) return response.data.user;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to get user by email: ${error.message}`, {
                cause: error
            });
        }
    }
    // ==================== PROJECT ROLE METHODS ====================
    /**
   * Get the current user's role for a specific project by project ID
   * Uses caching to avoid repeated API calls
   */ async getMyProjectRole(projectId) {
        this._requireReady("getMyProjectRole");
        if (!projectId) throw new Error("Project ID is required");
        if (!this.hasValidTokens()) return "guest";
        const cacheKey = `role_${projectId}`;
        const cached = this._projectRoleCache.get(cacheKey);
        if (cached && Date.now() - cached.timestamp < this._roleCacheExpiry) return cached.role;
        try {
            const response = await this._request(`/projects/${projectId}/role`, {
                method: "GET",
                methodName: "getMyProjectRole"
            });
            if (response.success) {
                const { role: role } = response.data;
                this._projectRoleCache.set(cacheKey, {
                    role: role,
                    timestamp: Date.now()
                });
                return role;
            }
            throw new Error(response.message);
        } catch (error) {
            const message = (error == null ? void 0 : error.message) || "";
            if (/401|403|unauthorized|no token|invalid token/iu.test(message)) return "guest";
            throw new Error(`Failed to get project role: ${message}`, {
                cause: error
            });
        }
    }
    /**
   * Get the current user's role for a specific project by project key.
   *
   * Pass `{owner, key}` to use the collision-safe 2-seg route when the
   * owner is known. Cache is scoped by the full (owner, key) tuple so two
   * owners sharing a bare key never share a cached role entry.
   *
   * @param {string | { owner?: string, key: string }} keyOrSpec
   */ async getMyProjectRoleByKey(keyOrSpec) {
        this._requireReady("getMyProjectRoleByKey");
        let owner = null;
        let projectKey = null;
        if (keyOrSpec && typeof keyOrSpec === "object") {
            owner = keyOrSpec.owner || null;
            projectKey = keyOrSpec.key;
        } else projectKey = keyOrSpec;
        if (!projectKey) throw new Error("Project key is required");
        if (!this.hasValidTokens()) return "guest";
        const cacheKey = owner ? `role_key_${owner}/${projectKey}` : `role_key_${projectKey}`;
        const cached = this._projectRoleCache.get(cacheKey);
        if (cached && Date.now() - cached.timestamp < this._roleCacheExpiry) return cached.role;
        const path = owner ? `${encodeURIComponent(owner)}/${encodeURIComponent(projectKey)}` : encodeURIComponent(projectKey);
        try {
            const response = await this._request(`/projects/key/${path}/role`, {
                method: "GET",
                methodName: "getMyProjectRoleByKey"
            });
            if (response.success) {
                const { role: role } = response.data;
                this._projectRoleCache.set(cacheKey, {
                    role: role,
                    timestamp: Date.now()
                });
                return role;
            }
            throw new Error(response.message);
        } catch (error) {
            const message = (error == null ? void 0 : error.message) || "";
            if (/401|403|unauthorized|no token|invalid token/iu.test(message)) return "guest";
            throw new Error(`Failed to get project role by key: ${message}`, {
                cause: error
            });
        }
    }
    /**
   * Clear the project role cache for a specific project or all projects
   */ clearProjectRoleCache(projectId = null) {
        if (projectId) {
            this._projectRoleCache.delete(`role_${projectId}`);
            for (const [key] of this._projectRoleCache)if (key.startsWith("role_key_")) this._projectRoleCache.delete(key);
        } else this._projectRoleCache.clear();
    }
    /**
   * Get project role with fallback to user projects list
   * This method tries to get the role from user projects first,
   * then falls back to API call if not found
   */ async getProjectRoleWithFallback(projectId, userProjects = null) {
        this._requireReady("getProjectRoleWithFallback");
        if (!projectId) throw new Error("Project ID is required");
        if (userProjects && Array.isArray(userProjects)) {
            const userProject = userProjects.find((p3)=>p3.id === projectId);
            if (userProject && userProject.role) return userProject.role;
        }
        return await this.getMyProjectRole(projectId);
    }
    /**
   * Get project role with fallback to user projects list (by project key)
   * This method tries to get the role from user projects first,
   * then falls back to API call if not found
   */ async getProjectRoleByKeyWithFallback(projectKey, userProjects = null) {
        this._requireReady("getProjectRoleByKeyWithFallback");
        if (!projectKey) throw new Error("Project key is required");
        if (userProjects && Array.isArray(userProjects)) {
            const userProject = userProjects.find((p3)=>p3.key === projectKey);
            if (userProject && userProject.role) return userProject.role;
        }
        return await this.getMyProjectRoleByKey(projectKey);
    }
    // ==================== AUTH HELPER METHODS ====================
    /**
   * Debug method to check token status
   */ getTokenDebugInfo() {
        if (!this._tokenManager) return {
            tokenManagerExists: false,
            error: "TokenManager not initialized"
        };
        const tokenStatus = this._tokenManager.getTokenStatus();
        const { tokens: tokens } = this._tokenManager;
        return {
            tokenManagerExists: true,
            tokenStatus: tokenStatus,
            hasAccessToken: Boolean(tokens.accessToken),
            hasRefreshToken: Boolean(tokens.refreshToken),
            accessTokenPreview: tokens.accessToken ? `${tokens.accessToken.substring(0, 20)}...` : null,
            expiresAt: tokens.expiresAt,
            timeToExpiry: tokenStatus.timeToExpiry,
            authHeader: this._tokenManager.getAuthHeader()
        };
    }
    /**
   * Helper method to check if user is authenticated
   */ isAuthenticated() {
        if (!this._tokenManager) return false;
        return this._tokenManager.hasTokens();
    }
    /**
   * Helper method to check if user has valid tokens
   */ hasValidTokens() {
        if (!this._tokenManager) return false;
        return this._tokenManager.hasTokens() && this._tokenManager.isAccessTokenValid();
    }
    /**
   * Helper method to get current user info
   */ async getCurrentUser() {
        try {
            return await this.getMe();
        } catch (error) {
            throw new Error(`Failed to get current user: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Helper method to validate user data for registration
   */ validateRegistrationData(userData) {
        const errors = [];
        if (!userData.email || typeof userData.email !== "string") errors.push("Email is required and must be a string");
        else if (!this._isValidEmail(userData.email)) errors.push("Email must be a valid email address");
        if (!userData.password || typeof userData.password !== "string") errors.push("Password is required and must be a string");
        else if (userData.password.length < 8) errors.push("Password must be at least 8 characters long");
        if (userData.username && typeof userData.username !== "string") errors.push("Username must be a string");
        else if (userData.username && userData.username.length < 3) errors.push("Username must be at least 3 characters long");
        return {
            isValid: errors.length === 0,
            errors: errors
        };
    }
    /**
   * Helper method to register with validation
   */ async registerWithValidation(userData, options = {}) {
        const validation = this.validateRegistrationData(userData);
        if (!validation.isValid) throw new Error(`Validation failed: ${validation.errors.join(", ")}`);
        return await this.register(userData, options);
    }
    /**
   * Helper method to login with validation
   */ async loginWithValidation(email, password, options = {}) {
        if (!email || typeof email !== "string") throw new Error("Email is required and must be a string");
        if (!password || typeof password !== "string") throw new Error("Password is required and must be a string");
        if (!this._isValidEmail(email)) throw new Error("Email must be a valid email address");
        return await this.login(email, password, options);
    }
    /**
   * Private helper to validate email format
   */ _isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/u;
        return emailRegex.test(email);
    }
    // ==================== PERMISSION METHODS (Existing) ====================
    hasPermission(requiredPermission) {
        var _a2;
        const authState = (_a2 = this._context) == null ? void 0 : _a2.state;
        if (!authState) return false;
        if (this.hasGlobalPermission(authState.globalRole, requiredPermission)) return true;
        return this.checkProjectPermission(authState.projectRole, requiredPermission);
    }
    hasGlobalPermission(globalRole, requiredPermission) {
        var _a2;
        return ((_a2 = $281a441cdcb2cf36$var$ROLE_PERMISSIONS[globalRole]) == null ? void 0 : _a2.includes(requiredPermission)) || false;
    }
    checkProjectPermission(projectRole, requiredPermission) {
        var _a2;
        return ((_a2 = $281a441cdcb2cf36$var$PROJECT_ROLE_PERMISSIONS[projectRole]) == null ? void 0 : _a2.includes(requiredPermission)) || false;
    }
    checkProjectFeature(projectTier, feature) {
        var _a2, _b;
        if (feature.startsWith("aiCopilot") || feature.startsWith("aiChatbot")) {
            const [featureBase] = feature.split(":");
            const tierFeature = (_a2 = $281a441cdcb2cf36$var$TIER_FEATURES[projectTier]) == null ? void 0 : _a2.find((f3)=>f3.startsWith(featureBase));
            if (!tierFeature) return false;
            const [, tierTokens] = tierFeature.split(":");
            return parseInt(tierTokens, 10) || 0;
        }
        return ((_b = $281a441cdcb2cf36$var$TIER_FEATURES[projectTier]) == null ? void 0 : _b.includes(feature)) || false;
    }
    // Operation checking
    async canPerformOperation(projectId, operation, options = {}) {
        this._requireReady();
        if (!projectId) throw new Error("Project ID is required");
        const { checkFeatures: checkFeatures = true, requireAll: requireAll = true } = options;
        const operationConfig = this._permissionMap[operation];
        if (!operationConfig) return false;
        const { permissions: permissions = [], features: features = [] } = operationConfig;
        try {
            const permissionResults = await Promise.all(permissions.map((permission)=>this.checkProjectPermission(projectId, permission)));
            const hasPermissions = requireAll ? permissionResults.every(Boolean) : permissionResults.some(Boolean);
            if (!hasPermissions) return false;
            if (checkFeatures && features.length > 0) {
                const featureResults = features.map((feature)=>{
                    const result = this.hasProjectFeature(projectId, feature);
                    return feature.includes(":") ? typeof result === "number" && result > 0 : result;
                });
                const hasFeatures = requireAll ? featureResults.every(Boolean) : featureResults.some(Boolean);
                if (!hasFeatures) return false;
            }
            return true;
        } catch (error) {
            this._setError(error);
            return false;
        }
    }
    // Higher-level permission methods
    async withPermission(projectId, operation, action) {
        this._requireReady();
        if (!projectId) throw new Error("Project ID is required");
        const canPerform = await this.canPerformOperation(projectId, operation);
        if (!canPerform) throw new Error(`Permission denied: Cannot perform ${operation} operation`);
        return action();
    }
    // Cleanup
    destroy() {
        if (this._tokenManager) {
            this._tokenManager.destroy();
            this._tokenManager = null;
        }
        this._projectRoleCache.clear();
        this._setReady(false);
    }
    _preparePluginPayload(payload, sessionOverride = null) {
        const target = payload && typeof payload === "object" ? {
            ...payload
        } : {};
        const session = this._resolvePluginSession(sessionOverride);
        if (session && !Object.hasOwn(target, "session")) {
            target.session = session;
            return {
                payload: target,
                session: session
            };
        }
        return {
            payload: target,
            session: null
        };
    }
    _resolvePluginSession(sessionOverride = null) {
        var _a2, _b;
        if (sessionOverride) return this._cachePluginSession(sessionOverride);
        if (this._pluginSession) return this._pluginSession;
        const optionSession = (_a2 = this._options) == null ? void 0 : _a2.pluginSession;
        if (optionSession) return this._cachePluginSession(optionSession);
        const contextSession = (_b = this._context) == null ? void 0 : _b.pluginSession;
        if (contextSession) return this._cachePluginSession(contextSession);
        if (typeof window !== "undefined") {
            try {
                const sessionFromUrl = new URL(window.location.href).searchParams.get("session");
                if (sessionFromUrl) return this._cachePluginSession(sessionFromUrl);
            } catch  {}
            try {
                if (window.localStorage) {
                    const stored = window.localStorage.getItem($281a441cdcb2cf36$var$PLUGIN_SESSION_STORAGE_KEY);
                    if (stored) {
                        this._pluginSession = stored;
                        return stored;
                    }
                }
            } catch  {}
        }
        return null;
    }
    _cachePluginSession(session) {
        if (!session) return null;
        this._pluginSession = session;
        if (typeof window !== "undefined") try {
            if (window.localStorage) window.localStorage.setItem($281a441cdcb2cf36$var$PLUGIN_SESSION_STORAGE_KEY, session);
        } catch  {}
        return session;
    }
    setPluginSession(session) {
        this._cachePluginSession(session);
    }
    _clearPluginSession(session = null) {
        if (!session || this._pluginSession === session) this._pluginSession = null;
        if (typeof window !== "undefined") try {
            if (window.localStorage) window.localStorage.removeItem($281a441cdcb2cf36$var$PLUGIN_SESSION_STORAGE_KEY);
        } catch  {}
    }
    /**
   * Cross-org notification badge counts for the org-switcher dropdown.
   * NEEDED_FOR_INTRANET §I8. Fails-soft to `{counts: {}}` when the
   * governance edge-fn is unavailable.
   *
   * @returns {Promise<{counts: Record<string, {mentions?: number, ticketsAssigned?: number, meetingInvites?: number}>}>}
   */ async getMyOrgNotifications() {
        this._requireReady("getMyOrgNotifications");
        const response = await this._request("/auth/me/org-notifications", {
            method: "GET",
            methodName: "getMyOrgNotifications"
        });
        if (response == null ? void 0 : response.success) return response.data;
        return {
            counts: {}
        };
    }
    /**
   * Cross-org calendar busy slots for the unified calendar.
   * NEEDED_FOR_INTRANET §I9. Fails-soft to `{slots: []}`.
   *
   * @param {{from: string, to: string}} window - ISO 8601 timestamps
   * @returns {Promise<{slots: Array<{workspaceId: string, orgId: string, start_at: string, end_at: string, title?: string}>}>}
   */ async getMyFreebusy({ from: from2, to: to }) {
        this._requireReady("getMyFreebusy");
        if (!from2 || !to) throw new Error("from + to (ISO 8601) required");
        const qs = new URLSearchParams({
            from: from2,
            to: to
        }).toString();
        const response = await this._request(`/auth/me/freebusy?${qs}`, {
            method: "GET",
            methodName: "getMyFreebusy"
        });
        if (response == null ? void 0 : response.success) return response.data;
        return {
            slots: []
        };
    }
    /**
   * List every project the authenticated user has any role on, across
   * every org they're a member of. Combines owner + collaborator
   * projects into one flat list. Server paginates by default.
   *
   * @returns {Promise<{projects: Array<object>, total?: number}>}
   */ async getMyProjects() {
        this._requireReady("getMyProjects");
        const response = await this._request("/auth/me/projects", {
            method: "GET",
            methodName: "getMyProjects"
        });
        if (response == null ? void 0 : response.success) return response.data;
        return {
            projects: []
        };
    }
    /**
   * List every team the authenticated user belongs to, grouped by org.
   * Mirrors the `teams[]` claim surfaced via sessionClaims — but a
   * direct fetch avoids stale free-tier claims.
   *
   * @returns {Promise<{teams: Array<{id: string, name: string, organization: string, type: string, role: string}>}>}
   */ async getMyTeams() {
        this._requireReady("getMyTeams");
        const response = await this._request("/auth/me/teams", {
            method: "GET",
            methodName: "getMyTeams"
        });
        if (response == null ? void 0 : response.success) return response.data;
        return {
            teams: []
        };
    }
    /**
   * List every org the authenticated user is a member of, with role +
   * ownership flags. Source for workspace-switcher UIs.
   *
   * @returns {Promise<{memberships: Array<{orgId: string, role: string, isOwner: boolean, workspaces?: Array<object>}>}>}
   */ async getMyOrgMemberships() {
        this._requireReady("getMyOrgMemberships");
        const response = await this._request("/auth/me/org-memberships", {
            method: "GET",
            methodName: "getMyOrgMemberships"
        });
        if (response == null ? void 0 : response.success) return response.data;
        return {
            memberships: []
        };
    }
    /**
   * Resend the email verification link for the authenticated user.
   * Requires auth (the server takes `req.user` as the resend target).
   * No-op idempotent on the client — server rate-limits resends.
   */ async resendVerification() {
        return this._call("resendVerification", "/auth/resend-verification", {
            method: "POST"
        });
    }
    /**
   * Confirm email verification using a token. The token is the one
   * emailed to the user — no auth required; verification completes the
   * sign-up flow for the user the token identifies.
   * @param {string} token
   */ async verifyEmail(token) {
        if (!token) throw new Error("token is required");
        return this._call("verifyEmail", `/auth/verify-email/${encodeURIComponent(token)}`);
    }
    /**
   * Role-enrichment feed for the People page. Returns every OrgMember
   * row in `orgId` with the user's email attached, so consumers can
   * match by email (common join key in legacy views) and read the raw
   * role key (builtin or custom). Caller must be an org member.
   *
   * Replaces legacy `public.people` + `public.user_roles` view reliance
   * per NEEDED_FOR_INTRANET §90.
   *
   * @param {string} orgId
   * @returns {Promise<{members: Array<{email: string, role: string}>}>}
   */ async getOrgMemberRoles(orgId) {
        this._requireReady("getOrgMemberRoles");
        if (!orgId) throw new Error("orgId is required");
        const response = await this._request(`/auth/org/${encodeURIComponent(orgId)}/member-roles`, {
            method: "GET",
            methodName: "getOrgMemberRoles"
        });
        if (response == null ? void 0 : response.success) return response.data;
        return {
            members: []
        };
    }
};
// ../node_modules/engine.io-parser/build/esm/commons.js
var $281a441cdcb2cf36$var$PACKET_TYPES = /* @__PURE__ */ Object.create(null);
$281a441cdcb2cf36$var$PACKET_TYPES["open"] = "0";
$281a441cdcb2cf36$var$PACKET_TYPES["close"] = "1";
$281a441cdcb2cf36$var$PACKET_TYPES["ping"] = "2";
$281a441cdcb2cf36$var$PACKET_TYPES["pong"] = "3";
$281a441cdcb2cf36$var$PACKET_TYPES["message"] = "4";
$281a441cdcb2cf36$var$PACKET_TYPES["upgrade"] = "5";
$281a441cdcb2cf36$var$PACKET_TYPES["noop"] = "6";
var $281a441cdcb2cf36$var$PACKET_TYPES_REVERSE = /* @__PURE__ */ Object.create(null);
Object.keys($281a441cdcb2cf36$var$PACKET_TYPES).forEach((key)=>{
    $281a441cdcb2cf36$var$PACKET_TYPES_REVERSE[$281a441cdcb2cf36$var$PACKET_TYPES[key]] = key;
});
var $281a441cdcb2cf36$var$ERROR_PACKET = {
    type: "error",
    data: "parser error"
};
// ../node_modules/engine.io-parser/build/esm/encodePacket.browser.js
var $281a441cdcb2cf36$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]";
var $281a441cdcb2cf36$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
var $281a441cdcb2cf36$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj && obj.buffer instanceof ArrayBuffer;
};
var $281a441cdcb2cf36$var$encodePacket = ({ type: type, data: data2 }, supportsBinary, callback)=>{
    if ($281a441cdcb2cf36$var$withNativeBlob && data2 instanceof Blob) {
        if (supportsBinary) return callback(data2);
        else return $281a441cdcb2cf36$var$encodeBlobAsBase64(data2, callback);
    } else if ($281a441cdcb2cf36$var$withNativeArrayBuffer && (data2 instanceof ArrayBuffer || $281a441cdcb2cf36$var$isView(data2))) {
        if (supportsBinary) return callback(data2);
        else return $281a441cdcb2cf36$var$encodeBlobAsBase64(new Blob([
            data2
        ]), callback);
    }
    return callback($281a441cdcb2cf36$var$PACKET_TYPES[type] + (data2 || ""));
};
var $281a441cdcb2cf36$var$encodeBlobAsBase64 = (data2, callback)=>{
    const fileReader = new FileReader();
    fileReader.onload = function() {
        const content = fileReader.result.split(",")[1];
        callback("b" + (content || ""));
    };
    return fileReader.readAsDataURL(data2);
};
function $281a441cdcb2cf36$var$toArray(data2) {
    if (data2 instanceof Uint8Array) return data2;
    else if (data2 instanceof ArrayBuffer) return new Uint8Array(data2);
    else return new Uint8Array(data2.buffer, data2.byteOffset, data2.byteLength);
}
var $281a441cdcb2cf36$var$TEXT_ENCODER;
function $281a441cdcb2cf36$var$encodePacketToBinary(packet, callback) {
    if ($281a441cdcb2cf36$var$withNativeBlob && packet.data instanceof Blob) return packet.data.arrayBuffer().then($281a441cdcb2cf36$var$toArray).then(callback);
    else if ($281a441cdcb2cf36$var$withNativeArrayBuffer && (packet.data instanceof ArrayBuffer || $281a441cdcb2cf36$var$isView(packet.data))) return callback($281a441cdcb2cf36$var$toArray(packet.data));
    $281a441cdcb2cf36$var$encodePacket(packet, false, (encoded)=>{
        if (!$281a441cdcb2cf36$var$TEXT_ENCODER) $281a441cdcb2cf36$var$TEXT_ENCODER = new TextEncoder();
        callback($281a441cdcb2cf36$var$TEXT_ENCODER.encode(encoded));
    });
}
// ../node_modules/engine.io-parser/build/esm/contrib/base64-arraybuffer.js
var $281a441cdcb2cf36$var$chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var $281a441cdcb2cf36$var$lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for(let i3 = 0; i3 < $281a441cdcb2cf36$var$chars.length; i3++)$281a441cdcb2cf36$var$lookup[$281a441cdcb2cf36$var$chars.charCodeAt(i3)] = i3;
var $281a441cdcb2cf36$var$decode = (base64)=>{
    let bufferLength = base64.length * 0.75, len = base64.length, i3, p3 = 0, encoded1, encoded2, encoded3, encoded4;
    if (base64[base64.length - 1] === "=") {
        bufferLength--;
        if (base64[base64.length - 2] === "=") bufferLength--;
    }
    const arraybuffer = new ArrayBuffer(bufferLength), bytes = new Uint8Array(arraybuffer);
    for(i3 = 0; i3 < len; i3 += 4){
        encoded1 = $281a441cdcb2cf36$var$lookup[base64.charCodeAt(i3)];
        encoded2 = $281a441cdcb2cf36$var$lookup[base64.charCodeAt(i3 + 1)];
        encoded3 = $281a441cdcb2cf36$var$lookup[base64.charCodeAt(i3 + 2)];
        encoded4 = $281a441cdcb2cf36$var$lookup[base64.charCodeAt(i3 + 3)];
        bytes[p3++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p3++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p3++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return arraybuffer;
};
// ../node_modules/engine.io-parser/build/esm/decodePacket.browser.js
var $281a441cdcb2cf36$var$withNativeArrayBuffer2 = typeof ArrayBuffer === "function";
var $281a441cdcb2cf36$var$decodePacket = (encodedPacket, binaryType)=>{
    if (typeof encodedPacket !== "string") return {
        type: "message",
        data: $281a441cdcb2cf36$var$mapBinary(encodedPacket, binaryType)
    };
    const type = encodedPacket.charAt(0);
    if (type === "b") return {
        type: "message",
        data: $281a441cdcb2cf36$var$decodeBase64Packet(encodedPacket.substring(1), binaryType)
    };
    const packetType = $281a441cdcb2cf36$var$PACKET_TYPES_REVERSE[type];
    if (!packetType) return $281a441cdcb2cf36$var$ERROR_PACKET;
    return encodedPacket.length > 1 ? {
        type: $281a441cdcb2cf36$var$PACKET_TYPES_REVERSE[type],
        data: encodedPacket.substring(1)
    } : {
        type: $281a441cdcb2cf36$var$PACKET_TYPES_REVERSE[type]
    };
};
var $281a441cdcb2cf36$var$decodeBase64Packet = (data2, binaryType)=>{
    if ($281a441cdcb2cf36$var$withNativeArrayBuffer2) {
        const decoded = $281a441cdcb2cf36$var$decode(data2);
        return $281a441cdcb2cf36$var$mapBinary(decoded, binaryType);
    } else return {
        base64: true,
        data: data2
    };
};
var $281a441cdcb2cf36$var$mapBinary = (data2, binaryType)=>{
    switch(binaryType){
        case "blob":
            if (data2 instanceof Blob) return data2;
            else return new Blob([
                data2
            ]);
        case "arraybuffer":
        default:
            if (data2 instanceof ArrayBuffer) return data2;
            else return data2.buffer;
    }
};
// ../node_modules/engine.io-parser/build/esm/index.js
var $281a441cdcb2cf36$var$SEPARATOR = String.fromCharCode(30);
var $281a441cdcb2cf36$var$encodePayload = (packets, callback)=>{
    const length2 = packets.length;
    const encodedPackets = new Array(length2);
    let count2 = 0;
    packets.forEach((packet, i3)=>{
        $281a441cdcb2cf36$var$encodePacket(packet, false, (encodedPacket)=>{
            encodedPackets[i3] = encodedPacket;
            if (++count2 === length2) callback(encodedPackets.join($281a441cdcb2cf36$var$SEPARATOR));
        });
    });
};
var $281a441cdcb2cf36$var$decodePayload = (encodedPayload, binaryType)=>{
    const encodedPackets = encodedPayload.split($281a441cdcb2cf36$var$SEPARATOR);
    const packets = [];
    for(let i3 = 0; i3 < encodedPackets.length; i3++){
        const decodedPacket = $281a441cdcb2cf36$var$decodePacket(encodedPackets[i3], binaryType);
        packets.push(decodedPacket);
        if (decodedPacket.type === "error") break;
    }
    return packets;
};
function $281a441cdcb2cf36$var$createPacketEncoderStream() {
    return new TransformStream({
        transform (packet, controller) {
            $281a441cdcb2cf36$var$encodePacketToBinary(packet, (encodedPacket)=>{
                const payloadLength = encodedPacket.length;
                let header;
                if (payloadLength < 126) {
                    header = new Uint8Array(1);
                    new DataView(header.buffer).setUint8(0, payloadLength);
                } else if (payloadLength < 65536) {
                    header = new Uint8Array(3);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 126);
                    view.setUint16(1, payloadLength);
                } else {
                    header = new Uint8Array(9);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 127);
                    view.setBigUint64(1, BigInt(payloadLength));
                }
                if (packet.data && typeof packet.data !== "string") header[0] |= 128;
                controller.enqueue(header);
                controller.enqueue(encodedPacket);
            });
        }
    });
}
var $281a441cdcb2cf36$var$TEXT_DECODER;
function $281a441cdcb2cf36$var$totalLength(chunks) {
    return chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
}
function $281a441cdcb2cf36$var$concatChunks(chunks, size2) {
    if (chunks[0].length === size2) return chunks.shift();
    const buffer = new Uint8Array(size2);
    let j3 = 0;
    for(let i3 = 0; i3 < size2; i3++){
        buffer[i3] = chunks[0][j3++];
        if (j3 === chunks[0].length) {
            chunks.shift();
            j3 = 0;
        }
    }
    if (chunks.length && j3 < chunks[0].length) chunks[0] = chunks[0].slice(j3);
    return buffer;
}
function $281a441cdcb2cf36$var$createPacketDecoderStream(maxPayload, binaryType) {
    if (!$281a441cdcb2cf36$var$TEXT_DECODER) $281a441cdcb2cf36$var$TEXT_DECODER = new TextDecoder();
    const chunks = [];
    let state = 0;
    let expectedLength = -1;
    let isBinary2 = false;
    return new TransformStream({
        transform (chunk, controller) {
            chunks.push(chunk);
            while(true){
                if (state === 0) {
                    if ($281a441cdcb2cf36$var$totalLength(chunks) < 1) break;
                    const header = $281a441cdcb2cf36$var$concatChunks(chunks, 1);
                    isBinary2 = (header[0] & 128) === 128;
                    expectedLength = header[0] & 127;
                    if (expectedLength < 126) state = 3;
                    else if (expectedLength === 126) state = 1;
                    else state = 2;
                } else if (state === 1) {
                    if ($281a441cdcb2cf36$var$totalLength(chunks) < 2) break;
                    const headerArray = $281a441cdcb2cf36$var$concatChunks(chunks, 2);
                    expectedLength = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length).getUint16(0);
                    state = 3;
                } else if (state === 2) {
                    if ($281a441cdcb2cf36$var$totalLength(chunks) < 8) break;
                    const headerArray = $281a441cdcb2cf36$var$concatChunks(chunks, 8);
                    const view = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length);
                    const n3 = view.getUint32(0);
                    if (n3 > Math.pow(2, 21) - 1) {
                        controller.enqueue($281a441cdcb2cf36$var$ERROR_PACKET);
                        break;
                    }
                    expectedLength = n3 * Math.pow(2, 32) + view.getUint32(4);
                    state = 3;
                } else {
                    if ($281a441cdcb2cf36$var$totalLength(chunks) < expectedLength) break;
                    const data2 = $281a441cdcb2cf36$var$concatChunks(chunks, expectedLength);
                    controller.enqueue($281a441cdcb2cf36$var$decodePacket(isBinary2 ? data2 : $281a441cdcb2cf36$var$TEXT_DECODER.decode(data2), binaryType));
                    state = 0;
                }
                if (expectedLength === 0 || expectedLength > maxPayload) {
                    controller.enqueue($281a441cdcb2cf36$var$ERROR_PACKET);
                    break;
                }
            }
        }
    });
}
var $281a441cdcb2cf36$var$protocol = 4;
// ../node_modules/@socket.io/component-emitter/lib/esm/index.js
function $281a441cdcb2cf36$var$Emitter(obj) {
    if (obj) return $281a441cdcb2cf36$var$mixin(obj);
}
function $281a441cdcb2cf36$var$mixin(obj) {
    for(var key in $281a441cdcb2cf36$var$Emitter.prototype)obj[key] = $281a441cdcb2cf36$var$Emitter.prototype[key];
    return obj;
}
$281a441cdcb2cf36$var$Emitter.prototype.on = $281a441cdcb2cf36$var$Emitter.prototype.addEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    (this._callbacks["$" + event] = this._callbacks["$" + event] || []).push(fn);
    return this;
};
$281a441cdcb2cf36$var$Emitter.prototype.once = function(event, fn) {
    function on2() {
        this.off(event, on2);
        fn.apply(this, arguments);
    }
    on2.fn = fn;
    this.on(event, on2);
    return this;
};
$281a441cdcb2cf36$var$Emitter.prototype.off = $281a441cdcb2cf36$var$Emitter.prototype.removeListener = $281a441cdcb2cf36$var$Emitter.prototype.removeAllListeners = $281a441cdcb2cf36$var$Emitter.prototype.removeEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    if (0 == arguments.length) {
        this._callbacks = {};
        return this;
    }
    var callbacks = this._callbacks["$" + event];
    if (!callbacks) return this;
    if (1 == arguments.length) {
        delete this._callbacks["$" + event];
        return this;
    }
    var cb;
    for(var i3 = 0; i3 < callbacks.length; i3++){
        cb = callbacks[i3];
        if (cb === fn || cb.fn === fn) {
            callbacks.splice(i3, 1);
            break;
        }
    }
    if (callbacks.length === 0) delete this._callbacks["$" + event];
    return this;
};
$281a441cdcb2cf36$var$Emitter.prototype.emit = function(event) {
    this._callbacks = this._callbacks || {};
    var args2 = new Array(arguments.length - 1), callbacks = this._callbacks["$" + event];
    for(var i3 = 1; i3 < arguments.length; i3++)args2[i3 - 1] = arguments[i3];
    if (callbacks) {
        callbacks = callbacks.slice(0);
        for(var i3 = 0, len = callbacks.length; i3 < len; ++i3)callbacks[i3].apply(this, args2);
    }
    return this;
};
$281a441cdcb2cf36$var$Emitter.prototype.emitReserved = $281a441cdcb2cf36$var$Emitter.prototype.emit;
$281a441cdcb2cf36$var$Emitter.prototype.listeners = function(event) {
    this._callbacks = this._callbacks || {};
    return this._callbacks["$" + event] || [];
};
$281a441cdcb2cf36$var$Emitter.prototype.hasListeners = function(event) {
    return !!this.listeners(event).length;
};
// ../node_modules/engine.io-client/build/esm/globals.js
var $281a441cdcb2cf36$var$nextTick = (()=>{
    const isPromiseAvailable = typeof Promise === "function" && typeof Promise.resolve === "function";
    if (isPromiseAvailable) return (cb)=>Promise.resolve().then(cb);
    else return (cb, setTimeoutFn)=>setTimeoutFn(cb, 0);
})();
var $281a441cdcb2cf36$var$globalThisShim = (()=>{
    if (typeof self !== "undefined") return self;
    else if (typeof window !== "undefined") return window;
    else return Function("return this")();
})();
var $281a441cdcb2cf36$var$defaultBinaryType = "arraybuffer";
function $281a441cdcb2cf36$var$createCookieJar() {}
// ../node_modules/engine.io-client/build/esm/util.js
function $281a441cdcb2cf36$var$pick(obj, ...attr) {
    return attr.reduce((acc, k3)=>{
        if (obj.hasOwnProperty(k3)) acc[k3] = obj[k3];
        return acc;
    }, {});
}
var $281a441cdcb2cf36$var$NATIVE_SET_TIMEOUT = $281a441cdcb2cf36$var$globalThisShim.setTimeout;
var $281a441cdcb2cf36$var$NATIVE_CLEAR_TIMEOUT = $281a441cdcb2cf36$var$globalThisShim.clearTimeout;
function $281a441cdcb2cf36$var$installTimerFunctions(obj, opts) {
    if (opts.useNativeTimers) {
        obj.setTimeoutFn = $281a441cdcb2cf36$var$NATIVE_SET_TIMEOUT.bind($281a441cdcb2cf36$var$globalThisShim);
        obj.clearTimeoutFn = $281a441cdcb2cf36$var$NATIVE_CLEAR_TIMEOUT.bind($281a441cdcb2cf36$var$globalThisShim);
    } else {
        obj.setTimeoutFn = $281a441cdcb2cf36$var$globalThisShim.setTimeout.bind($281a441cdcb2cf36$var$globalThisShim);
        obj.clearTimeoutFn = $281a441cdcb2cf36$var$globalThisShim.clearTimeout.bind($281a441cdcb2cf36$var$globalThisShim);
    }
}
var $281a441cdcb2cf36$var$BASE64_OVERHEAD = 1.33;
function $281a441cdcb2cf36$var$byteLength(obj) {
    if (typeof obj === "string") return $281a441cdcb2cf36$var$utf8Length(obj);
    return Math.ceil((obj.byteLength || obj.size) * $281a441cdcb2cf36$var$BASE64_OVERHEAD);
}
function $281a441cdcb2cf36$var$utf8Length(str) {
    let c3 = 0, length2 = 0;
    for(let i3 = 0, l3 = str.length; i3 < l3; i3++){
        c3 = str.charCodeAt(i3);
        if (c3 < 128) length2 += 1;
        else if (c3 < 2048) length2 += 2;
        else if (c3 < 55296 || c3 >= 57344) length2 += 3;
        else {
            i3++;
            length2 += 4;
        }
    }
    return length2;
}
function $281a441cdcb2cf36$var$randomString() {
    return Date.now().toString(36).substring(3) + Math.random().toString(36).substring(2, 5);
}
// ../node_modules/engine.io-client/build/esm/contrib/parseqs.js
function $281a441cdcb2cf36$var$encode(obj) {
    let str = "";
    for(let i3 in obj)if (obj.hasOwnProperty(i3)) {
        if (str.length) str += "&";
        str += encodeURIComponent(i3) + "=" + encodeURIComponent(obj[i3]);
    }
    return str;
}
function $281a441cdcb2cf36$var$decode2(qs) {
    let qry = {};
    let pairs = qs.split("&");
    for(let i3 = 0, l3 = pairs.length; i3 < l3; i3++){
        let pair = pairs[i3].split("=");
        qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }
    return qry;
}
// ../node_modules/engine.io-client/build/esm/transport.js
var $281a441cdcb2cf36$var$TransportError = class extends Error {
    constructor(reason, description, context2){
        super(reason);
        this.description = description;
        this.context = context2;
        this.type = "TransportError";
    }
};
var $281a441cdcb2cf36$var$Transport = class extends $281a441cdcb2cf36$var$Emitter {
    /**
   * Transport abstract constructor.
   *
   * @param {Object} opts - options
   * @protected
   */ constructor(opts){
        super();
        this.writable = false;
        $281a441cdcb2cf36$var$installTimerFunctions(this, opts);
        this.opts = opts;
        this.query = opts.query;
        this.socket = opts.socket;
        this.supportsBinary = !opts.forceBase64;
    }
    /**
   * Emits an error.
   *
   * @param {String} reason
   * @param description
   * @param context - the error context
   * @return {Transport} for chaining
   * @protected
   */ onError(reason, description, context2) {
        super.emitReserved("error", new $281a441cdcb2cf36$var$TransportError(reason, description, context2));
        return this;
    }
    /**
   * Opens the transport.
   */ open() {
        this.readyState = "opening";
        this.doOpen();
        return this;
    }
    /**
   * Closes the transport.
   */ close() {
        if (this.readyState === "opening" || this.readyState === "open") {
            this.doClose();
            this.onClose();
        }
        return this;
    }
    /**
   * Sends multiple packets.
   *
   * @param {Array} packets
   */ send(packets) {
        if (this.readyState === "open") this.write(packets);
    }
    /**
   * Called upon open
   *
   * @protected
   */ onOpen() {
        this.readyState = "open";
        this.writable = true;
        super.emitReserved("open");
    }
    /**
   * Called with data.
   *
   * @param {String} data
   * @protected
   */ onData(data2) {
        const packet = $281a441cdcb2cf36$var$decodePacket(data2, this.socket.binaryType);
        this.onPacket(packet);
    }
    /**
   * Called with a decoded packet.
   *
   * @protected
   */ onPacket(packet) {
        super.emitReserved("packet", packet);
    }
    /**
   * Called upon close.
   *
   * @protected
   */ onClose(details) {
        this.readyState = "closed";
        super.emitReserved("close", details);
    }
    /**
   * Pauses the transport, in order not to lose packets during an upgrade.
   *
   * @param onPause
   */ pause(onPause) {}
    createUri(schema, query = {}) {
        return schema + "://" + this._hostname() + this._port() + this.opts.path + this._query(query);
    }
    _hostname() {
        const hostname = this.opts.hostname;
        return hostname.indexOf(":") === -1 ? hostname : "[" + hostname + "]";
    }
    _port() {
        if (this.opts.port && (this.opts.secure && Number(this.opts.port) !== 443 || !this.opts.secure && Number(this.opts.port) !== 80)) return ":" + this.opts.port;
        else return "";
    }
    _query(query) {
        const encodedQuery = $281a441cdcb2cf36$var$encode(query);
        return encodedQuery.length ? "?" + encodedQuery : "";
    }
};
// ../node_modules/engine.io-client/build/esm/transports/polling.js
var $281a441cdcb2cf36$var$Polling = class extends $281a441cdcb2cf36$var$Transport {
    constructor(){
        super(...arguments);
        this._polling = false;
    }
    get name() {
        return "polling";
    }
    /**
   * Opens the socket (triggers polling). We write a PING message to determine
   * when the transport is open.
   *
   * @protected
   */ doOpen() {
        this._poll();
    }
    /**
   * Pauses polling.
   *
   * @param {Function} onPause - callback upon buffers are flushed and transport is paused
   * @package
   */ pause(onPause) {
        this.readyState = "pausing";
        const pause = ()=>{
            this.readyState = "paused";
            onPause();
        };
        if (this._polling || !this.writable) {
            let total = 0;
            if (this._polling) {
                total++;
                this.once("pollComplete", function() {
                    --total || pause();
                });
            }
            if (!this.writable) {
                total++;
                this.once("drain", function() {
                    --total || pause();
                });
            }
        } else pause();
    }
    /**
   * Starts polling cycle.
   *
   * @private
   */ _poll() {
        this._polling = true;
        this.doPoll();
        this.emitReserved("poll");
    }
    /**
   * Overloads onData to detect payloads.
   *
   * @protected
   */ onData(data2) {
        const callback = (packet)=>{
            if ("opening" === this.readyState && packet.type === "open") this.onOpen();
            if ("close" === packet.type) {
                this.onClose({
                    description: "transport closed by the server"
                });
                return false;
            }
            this.onPacket(packet);
        };
        $281a441cdcb2cf36$var$decodePayload(data2, this.socket.binaryType).forEach(callback);
        if ("closed" !== this.readyState) {
            this._polling = false;
            this.emitReserved("pollComplete");
            if ("open" === this.readyState) this._poll();
        }
    }
    /**
   * For polling, send a close packet.
   *
   * @protected
   */ doClose() {
        const close = ()=>{
            this.write([
                {
                    type: "close"
                }
            ]);
        };
        if ("open" === this.readyState) close();
        else this.once("open", close);
    }
    /**
   * Writes a packets payload.
   *
   * @param {Array} packets - data packets
   * @protected
   */ write(packets) {
        this.writable = false;
        $281a441cdcb2cf36$var$encodePayload(packets, (data2)=>{
            this.doWrite(data2, ()=>{
                this.writable = true;
                this.emitReserved("drain");
            });
        });
    }
    /**
   * Generates uri for connection.
   *
   * @private
   */ uri() {
        const schema = this.opts.secure ? "https" : "http";
        const query = this.query || {};
        if (false !== this.opts.timestampRequests) query[this.opts.timestampParam] = $281a441cdcb2cf36$var$randomString();
        if (!this.supportsBinary && !query.sid) query.b64 = 1;
        return this.createUri(schema, query);
    }
};
// ../node_modules/engine.io-client/build/esm/contrib/has-cors.js
var $281a441cdcb2cf36$var$value = false;
try {
    $281a441cdcb2cf36$var$value = typeof XMLHttpRequest !== "undefined" && "withCredentials" in new XMLHttpRequest();
} catch (err) {}
var $281a441cdcb2cf36$var$hasCORS = $281a441cdcb2cf36$var$value;
// ../node_modules/engine.io-client/build/esm/transports/polling-xhr.js
function $281a441cdcb2cf36$var$empty() {}
var $281a441cdcb2cf36$var$BaseXHR = class extends $281a441cdcb2cf36$var$Polling {
    /**
   * XHR Polling constructor.
   *
   * @param {Object} opts
   * @package
   */ constructor(opts){
        super(opts);
        if (typeof location !== "undefined") {
            const isSSL = "https:" === location.protocol;
            let port = location.port;
            if (!port) port = isSSL ? "443" : "80";
            this.xd = typeof location !== "undefined" && opts.hostname !== location.hostname || port !== opts.port;
        }
    }
    /**
   * Sends data.
   *
   * @param {String} data to send.
   * @param {Function} called upon flush.
   * @private
   */ doWrite(data2, fn) {
        const req = this.request({
            method: "POST",
            data: data2
        });
        req.on("success", fn);
        req.on("error", (xhrStatus, context2)=>{
            this.onError("xhr post error", xhrStatus, context2);
        });
    }
    /**
   * Starts a poll cycle.
   *
   * @private
   */ doPoll() {
        const req = this.request();
        req.on("data", this.onData.bind(this));
        req.on("error", (xhrStatus, context2)=>{
            this.onError("xhr poll error", xhrStatus, context2);
        });
        this.pollXhr = req;
    }
};
var $281a441cdcb2cf36$var$Request2 = class _Request extends $281a441cdcb2cf36$var$Emitter {
    /**
   * Request constructor
   *
   * @param {Object} options
   * @package
   */ constructor(createRequest, uri, opts){
        super();
        this.createRequest = createRequest;
        $281a441cdcb2cf36$var$installTimerFunctions(this, opts);
        this._opts = opts;
        this._method = opts.method || "GET";
        this._uri = uri;
        this._data = void 0 !== opts.data ? opts.data : null;
        this._create();
    }
    /**
   * Creates the XHR object and sends the request.
   *
   * @private
   */ _create() {
        var _a2;
        const opts = $281a441cdcb2cf36$var$pick(this._opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
        opts.xdomain = !!this._opts.xd;
        const xhr = this._xhr = this.createRequest(opts);
        try {
            xhr.open(this._method, this._uri, true);
            try {
                if (this._opts.extraHeaders) {
                    xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
                    for(let i3 in this._opts.extraHeaders)if (this._opts.extraHeaders.hasOwnProperty(i3)) xhr.setRequestHeader(i3, this._opts.extraHeaders[i3]);
                }
            } catch (e4) {}
            if ("POST" === this._method) try {
                xhr.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
            } catch (e4) {}
            try {
                xhr.setRequestHeader("Accept", "*/*");
            } catch (e4) {}
            (_a2 = this._opts.cookieJar) === null || _a2 === void 0 || _a2.addCookies(xhr);
            if ("withCredentials" in xhr) xhr.withCredentials = this._opts.withCredentials;
            if (this._opts.requestTimeout) xhr.timeout = this._opts.requestTimeout;
            xhr.onreadystatechange = ()=>{
                var _a3;
                if (xhr.readyState === 3) (_a3 = this._opts.cookieJar) === null || _a3 === void 0 || _a3.parseCookies(// @ts-ignore
                xhr.getResponseHeader("set-cookie"));
                if (4 !== xhr.readyState) return;
                if (200 === xhr.status || 1223 === xhr.status) this._onLoad();
                else this.setTimeoutFn(()=>{
                    this._onError(typeof xhr.status === "number" ? xhr.status : 0);
                }, 0);
            };
            xhr.send(this._data);
        } catch (e4) {
            this.setTimeoutFn(()=>{
                this._onError(e4);
            }, 0);
            return;
        }
        if (typeof document !== "undefined") {
            this._index = _Request.requestsCount++;
            _Request.requests[this._index] = this;
        }
    }
    /**
   * Called upon error.
   *
   * @private
   */ _onError(err) {
        this.emitReserved("error", err, this._xhr);
        this._cleanup(true);
    }
    /**
   * Cleans up house.
   *
   * @private
   */ _cleanup(fromError) {
        if ("undefined" === typeof this._xhr || null === this._xhr) return;
        this._xhr.onreadystatechange = $281a441cdcb2cf36$var$empty;
        if (fromError) try {
            this._xhr.abort();
        } catch (e4) {}
        if (typeof document !== "undefined") delete _Request.requests[this._index];
        this._xhr = null;
    }
    /**
   * Called upon load.
   *
   * @private
   */ _onLoad() {
        const data2 = this._xhr.responseText;
        if (data2 !== null) {
            this.emitReserved("data", data2);
            this.emitReserved("success");
            this._cleanup();
        }
    }
    /**
   * Aborts the request.
   *
   * @package
   */ abort() {
        this._cleanup();
    }
};
$281a441cdcb2cf36$var$Request2.requestsCount = 0;
$281a441cdcb2cf36$var$Request2.requests = {};
if (typeof document !== "undefined") {
    if (typeof attachEvent === "function") attachEvent("onunload", $281a441cdcb2cf36$var$unloadHandler);
    else if (typeof addEventListener === "function") {
        const terminationEvent = "onpagehide" in $281a441cdcb2cf36$var$globalThisShim ? "pagehide" : "unload";
        addEventListener(terminationEvent, $281a441cdcb2cf36$var$unloadHandler, false);
    }
}
function $281a441cdcb2cf36$var$unloadHandler() {
    for(let i3 in $281a441cdcb2cf36$var$Request2.requests)if ($281a441cdcb2cf36$var$Request2.requests.hasOwnProperty(i3)) $281a441cdcb2cf36$var$Request2.requests[i3].abort();
}
var $281a441cdcb2cf36$var$hasXHR2 = function() {
    const xhr = $281a441cdcb2cf36$var$newRequest({
        xdomain: false
    });
    return xhr && xhr.responseType !== null;
}();
var $281a441cdcb2cf36$var$XHR = class extends $281a441cdcb2cf36$var$BaseXHR {
    constructor(opts){
        super(opts);
        const forceBase64 = opts && opts.forceBase64;
        this.supportsBinary = $281a441cdcb2cf36$var$hasXHR2 && !forceBase64;
    }
    request(opts = {}) {
        Object.assign(opts, {
            xd: this.xd
        }, this.opts);
        return new $281a441cdcb2cf36$var$Request2($281a441cdcb2cf36$var$newRequest, this.uri(), opts);
    }
};
function $281a441cdcb2cf36$var$newRequest(opts) {
    const xdomain = opts.xdomain;
    try {
        if ("undefined" !== typeof XMLHttpRequest && (!xdomain || $281a441cdcb2cf36$var$hasCORS)) return new XMLHttpRequest();
    } catch (e4) {}
    if (!xdomain) try {
        return new $281a441cdcb2cf36$var$globalThisShim[[
            "Active"
        ].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch (e4) {}
}
// ../node_modules/engine.io-client/build/esm/transports/websocket.js
var $281a441cdcb2cf36$var$isReactNative = typeof navigator !== "undefined" && typeof navigator.product === "string" && navigator.product.toLowerCase() === "reactnative";
var $281a441cdcb2cf36$var$BaseWS = class extends $281a441cdcb2cf36$var$Transport {
    get name() {
        return "websocket";
    }
    doOpen() {
        const uri = this.uri();
        const protocols = this.opts.protocols;
        const opts = $281a441cdcb2cf36$var$isReactNative ? {} : $281a441cdcb2cf36$var$pick(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
        if (this.opts.extraHeaders) opts.headers = this.opts.extraHeaders;
        try {
            this.ws = this.createSocket(uri, protocols, opts);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this.ws.binaryType = this.socket.binaryType;
        this.addEventListeners();
    }
    /**
   * Adds event listeners to the socket
   *
   * @private
   */ addEventListeners() {
        this.ws.onopen = ()=>{
            if (this.opts.autoUnref) this.ws._socket.unref();
            this.onOpen();
        };
        this.ws.onclose = (closeEvent)=>this.onClose({
                description: "websocket connection closed",
                context: closeEvent
            });
        this.ws.onmessage = (ev)=>this.onData(ev.data);
        this.ws.onerror = (e4)=>this.onError("websocket error", e4);
    }
    write(packets) {
        this.writable = false;
        for(let i3 = 0; i3 < packets.length; i3++){
            const packet = packets[i3];
            const lastPacket = i3 === packets.length - 1;
            $281a441cdcb2cf36$var$encodePacket(packet, this.supportsBinary, (data2)=>{
                try {
                    this.doWrite(packet, data2);
                } catch (e4) {}
                if (lastPacket) $281a441cdcb2cf36$var$nextTick(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        if (typeof this.ws !== "undefined") {
            this.ws.onerror = ()=>{};
            this.ws.close();
            this.ws = null;
        }
    }
    /**
   * Generates uri for connection.
   *
   * @private
   */ uri() {
        const schema = this.opts.secure ? "wss" : "ws";
        const query = this.query || {};
        if (this.opts.timestampRequests) query[this.opts.timestampParam] = $281a441cdcb2cf36$var$randomString();
        if (!this.supportsBinary) query.b64 = 1;
        return this.createUri(schema, query);
    }
};
var $281a441cdcb2cf36$var$WebSocketCtor = $281a441cdcb2cf36$var$globalThisShim.WebSocket || $281a441cdcb2cf36$var$globalThisShim.MozWebSocket;
var $281a441cdcb2cf36$var$WS = class extends $281a441cdcb2cf36$var$BaseWS {
    createSocket(uri, protocols, opts) {
        return !$281a441cdcb2cf36$var$isReactNative ? protocols ? new $281a441cdcb2cf36$var$WebSocketCtor(uri, protocols) : new $281a441cdcb2cf36$var$WebSocketCtor(uri) : new $281a441cdcb2cf36$var$WebSocketCtor(uri, protocols, opts);
    }
    doWrite(_packet, data2) {
        this.ws.send(data2);
    }
};
// ../node_modules/engine.io-client/build/esm/transports/webtransport.js
var $281a441cdcb2cf36$var$WT = class extends $281a441cdcb2cf36$var$Transport {
    get name() {
        return "webtransport";
    }
    doOpen() {
        try {
            this._transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this._transport.closed.then(()=>{
            this.onClose();
        }).catch((err)=>{
            this.onError("webtransport error", err);
        });
        this._transport.ready.then(()=>{
            this._transport.createBidirectionalStream().then((stream)=>{
                const decoderStream = $281a441cdcb2cf36$var$createPacketDecoderStream(Number.MAX_SAFE_INTEGER, this.socket.binaryType);
                const reader = stream.readable.pipeThrough(decoderStream).getReader();
                const encoderStream = $281a441cdcb2cf36$var$createPacketEncoderStream();
                encoderStream.readable.pipeTo(stream.writable);
                this._writer = encoderStream.writable.getWriter();
                const read = ()=>{
                    reader.read().then(({ done: done, value: value2 })=>{
                        if (done) return;
                        this.onPacket(value2);
                        read();
                    }).catch((err)=>{});
                };
                read();
                const packet = {
                    type: "open"
                };
                if (this.query.sid) packet.data = `{"sid":"${this.query.sid}"}`;
                this._writer.write(packet).then(()=>this.onOpen());
            });
        });
    }
    write(packets) {
        this.writable = false;
        for(let i3 = 0; i3 < packets.length; i3++){
            const packet = packets[i3];
            const lastPacket = i3 === packets.length - 1;
            this._writer.write(packet).then(()=>{
                if (lastPacket) $281a441cdcb2cf36$var$nextTick(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        var _a2;
        (_a2 = this._transport) === null || _a2 === void 0 || _a2.close();
    }
};
// ../node_modules/engine.io-client/build/esm/transports/index.js
var $281a441cdcb2cf36$var$transports = {
    websocket: $281a441cdcb2cf36$var$WS,
    webtransport: $281a441cdcb2cf36$var$WT,
    polling: $281a441cdcb2cf36$var$XHR
};
// ../node_modules/engine.io-client/build/esm/contrib/parseuri.js
var $281a441cdcb2cf36$var$re = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
var $281a441cdcb2cf36$var$parts = [
    "source",
    "protocol",
    "authority",
    "userInfo",
    "user",
    "password",
    "host",
    "port",
    "relative",
    "path",
    "directory",
    "file",
    "query",
    "anchor"
];
function $281a441cdcb2cf36$var$parse(str) {
    if (str.length > 8e3) throw "URI too long";
    const src = str, b3 = str.indexOf("["), e4 = str.indexOf("]");
    if (b3 != -1 && e4 != -1) str = str.substring(0, b3) + str.substring(b3, e4).replace(/:/g, ";") + str.substring(e4, str.length);
    let m3 = $281a441cdcb2cf36$var$re.exec(str || ""), uri = {}, i3 = 14;
    while(i3--)uri[$281a441cdcb2cf36$var$parts[i3]] = m3[i3] || "";
    if (b3 != -1 && e4 != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ":");
        uri.authority = uri.authority.replace("[", "").replace("]", "").replace(/;/g, ":");
        uri.ipv6uri = true;
    }
    uri.pathNames = $281a441cdcb2cf36$var$pathNames(uri, uri["path"]);
    uri.queryKey = $281a441cdcb2cf36$var$queryKey(uri, uri["query"]);
    return uri;
}
function $281a441cdcb2cf36$var$pathNames(obj, path) {
    const regx = /\/{2,9}/g, names = path.replace(regx, "/").split("/");
    if (path.slice(0, 1) == "/" || path.length === 0) names.splice(0, 1);
    if (path.slice(-1) == "/") names.splice(names.length - 1, 1);
    return names;
}
function $281a441cdcb2cf36$var$queryKey(uri, query) {
    const data2 = {};
    query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function($0, $1, $22) {
        if ($1) data2[$1] = $22;
    });
    return data2;
}
// ../node_modules/engine.io-client/build/esm/socket.js
var $281a441cdcb2cf36$var$withEventListeners = typeof addEventListener === "function" && typeof removeEventListener === "function";
var $281a441cdcb2cf36$var$OFFLINE_EVENT_LISTENERS = [];
if ($281a441cdcb2cf36$var$withEventListeners) addEventListener("offline", ()=>{
    $281a441cdcb2cf36$var$OFFLINE_EVENT_LISTENERS.forEach((listener)=>listener());
}, false);
var $281a441cdcb2cf36$var$SocketWithoutUpgrade = class _SocketWithoutUpgrade extends $281a441cdcb2cf36$var$Emitter {
    /**
   * Socket constructor.
   *
   * @param {String|Object} uri - uri or options
   * @param {Object} opts - options
   */ constructor(uri, opts){
        super();
        this.binaryType = $281a441cdcb2cf36$var$defaultBinaryType;
        this.writeBuffer = [];
        this._prevBufferLen = 0;
        this._pingInterval = -1;
        this._pingTimeout = -1;
        this._maxPayload = -1;
        this._pingTimeoutTime = Infinity;
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = null;
        }
        if (uri) {
            const parsedUri = $281a441cdcb2cf36$var$parse(uri);
            opts.hostname = parsedUri.host;
            opts.secure = parsedUri.protocol === "https" || parsedUri.protocol === "wss";
            opts.port = parsedUri.port;
            if (parsedUri.query) opts.query = parsedUri.query;
        } else if (opts.host) opts.hostname = $281a441cdcb2cf36$var$parse(opts.host).host;
        $281a441cdcb2cf36$var$installTimerFunctions(this, opts);
        this.secure = null != opts.secure ? opts.secure : typeof location !== "undefined" && "https:" === location.protocol;
        if (opts.hostname && !opts.port) opts.port = this.secure ? "443" : "80";
        this.hostname = opts.hostname || (typeof location !== "undefined" ? location.hostname : "localhost");
        this.port = opts.port || (typeof location !== "undefined" && location.port ? location.port : this.secure ? "443" : "80");
        this.transports = [];
        this._transportsByName = {};
        opts.transports.forEach((t4)=>{
            const transportName = t4.prototype.name;
            this.transports.push(transportName);
            this._transportsByName[transportName] = t4;
        });
        this.opts = Object.assign({
            path: "/engine.io",
            agent: false,
            withCredentials: false,
            upgrade: true,
            timestampParam: "t",
            rememberUpgrade: false,
            addTrailingSlash: true,
            rejectUnauthorized: true,
            perMessageDeflate: {
                threshold: 1024
            },
            transportOptions: {},
            closeOnBeforeunload: false
        }, opts);
        this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : "");
        if (typeof this.opts.query === "string") this.opts.query = $281a441cdcb2cf36$var$decode2(this.opts.query);
        if ($281a441cdcb2cf36$var$withEventListeners) {
            if (this.opts.closeOnBeforeunload) {
                this._beforeunloadEventListener = ()=>{
                    if (this.transport) {
                        this.transport.removeAllListeners();
                        this.transport.close();
                    }
                };
                addEventListener("beforeunload", this._beforeunloadEventListener, false);
            }
            if (this.hostname !== "localhost") {
                this._offlineEventListener = ()=>{
                    this._onClose("transport close", {
                        description: "network connection lost"
                    });
                };
                $281a441cdcb2cf36$var$OFFLINE_EVENT_LISTENERS.push(this._offlineEventListener);
            }
        }
        if (this.opts.withCredentials) this._cookieJar = $281a441cdcb2cf36$var$createCookieJar();
        this._open();
    }
    /**
   * Creates transport of the given type.
   *
   * @param {String} name - transport name
   * @return {Transport}
   * @private
   */ createTransport(name) {
        const query = Object.assign({}, this.opts.query);
        query.EIO = $281a441cdcb2cf36$var$protocol;
        query.transport = name;
        if (this.id) query.sid = this.id;
        const opts = Object.assign({}, this.opts, {
            query: query,
            socket: this,
            hostname: this.hostname,
            secure: this.secure,
            port: this.port
        }, this.opts.transportOptions[name]);
        return new this._transportsByName[name](opts);
    }
    /**
   * Initializes transport to use and starts probe.
   *
   * @private
   */ _open() {
        if (this.transports.length === 0) {
            this.setTimeoutFn(()=>{
                this.emitReserved("error", "No transports available");
            }, 0);
            return;
        }
        const transportName = this.opts.rememberUpgrade && _SocketWithoutUpgrade.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1 ? "websocket" : this.transports[0];
        this.readyState = "opening";
        const transport = this.createTransport(transportName);
        transport.open();
        this.setTransport(transport);
    }
    /**
   * Sets the current transport. Disables the existing one (if any).
   *
   * @private
   */ setTransport(transport) {
        if (this.transport) this.transport.removeAllListeners();
        this.transport = transport;
        transport.on("drain", this._onDrain.bind(this)).on("packet", this._onPacket.bind(this)).on("error", this._onError.bind(this)).on("close", (reason)=>this._onClose("transport close", reason));
    }
    /**
   * Called when connection is deemed open.
   *
   * @private
   */ onOpen() {
        this.readyState = "open";
        _SocketWithoutUpgrade.priorWebsocketSuccess = "websocket" === this.transport.name;
        this.emitReserved("open");
        this.flush();
    }
    /**
   * Handles a packet.
   *
   * @private
   */ _onPacket(packet) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            this.emitReserved("packet", packet);
            this.emitReserved("heartbeat");
            switch(packet.type){
                case "open":
                    this.onHandshake(JSON.parse(packet.data));
                    break;
                case "ping":
                    this._sendPacket("pong");
                    this.emitReserved("ping");
                    this.emitReserved("pong");
                    this._resetPingTimeout();
                    break;
                case "error":
                    const err = new Error("server error");
                    err.code = packet.data;
                    this._onError(err);
                    break;
                case "message":
                    this.emitReserved("data", packet.data);
                    this.emitReserved("message", packet.data);
                    break;
            }
        }
    }
    /**
   * Called upon handshake completion.
   *
   * @param {Object} data - handshake obj
   * @private
   */ onHandshake(data2) {
        this.emitReserved("handshake", data2);
        this.id = data2.sid;
        this.transport.query.sid = data2.sid;
        this._pingInterval = data2.pingInterval;
        this._pingTimeout = data2.pingTimeout;
        this._maxPayload = data2.maxPayload;
        this.onOpen();
        if ("closed" === this.readyState) return;
        this._resetPingTimeout();
    }
    /**
   * Sets and resets ping timeout timer based on server pings.
   *
   * @private
   */ _resetPingTimeout() {
        this.clearTimeoutFn(this._pingTimeoutTimer);
        const delay = this._pingInterval + this._pingTimeout;
        this._pingTimeoutTime = Date.now() + delay;
        this._pingTimeoutTimer = this.setTimeoutFn(()=>{
            this._onClose("ping timeout");
        }, delay);
        if (this.opts.autoUnref) this._pingTimeoutTimer.unref();
    }
    /**
   * Called on `drain` event
   *
   * @private
   */ _onDrain() {
        this.writeBuffer.splice(0, this._prevBufferLen);
        this._prevBufferLen = 0;
        if (0 === this.writeBuffer.length) this.emitReserved("drain");
        else this.flush();
    }
    /**
   * Flush write buffers.
   *
   * @private
   */ flush() {
        if ("closed" !== this.readyState && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
            const packets = this._getWritablePackets();
            this.transport.send(packets);
            this._prevBufferLen = packets.length;
            this.emitReserved("flush");
        }
    }
    /**
   * Ensure the encoded size of the writeBuffer is below the maxPayload value sent by the server (only for HTTP
   * long-polling)
   *
   * @private
   */ _getWritablePackets() {
        const shouldCheckPayloadSize = this._maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1;
        if (!shouldCheckPayloadSize) return this.writeBuffer;
        let payloadSize = 1;
        for(let i3 = 0; i3 < this.writeBuffer.length; i3++){
            const data2 = this.writeBuffer[i3].data;
            if (data2) payloadSize += $281a441cdcb2cf36$var$byteLength(data2);
            if (i3 > 0 && payloadSize > this._maxPayload) return this.writeBuffer.slice(0, i3);
            payloadSize += 2;
        }
        return this.writeBuffer;
    }
    /**
   * Checks whether the heartbeat timer has expired but the socket has not yet been notified.
   *
   * Note: this method is private for now because it does not really fit the WebSocket API, but if we put it in the
   * `write()` method then the message would not be buffered by the Socket.IO client.
   *
   * @return {boolean}
   * @private
   */ /* private */ _hasPingExpired() {
        if (!this._pingTimeoutTime) return true;
        const hasExpired = Date.now() > this._pingTimeoutTime;
        if (hasExpired) {
            this._pingTimeoutTime = 0;
            $281a441cdcb2cf36$var$nextTick(()=>{
                this._onClose("ping timeout");
            }, this.setTimeoutFn);
        }
        return hasExpired;
    }
    /**
   * Sends a message.
   *
   * @param {String} msg - message.
   * @param {Object} options.
   * @param {Function} fn - callback function.
   * @return {Socket} for chaining.
   */ write(msg, options, fn) {
        this._sendPacket("message", msg, options, fn);
        return this;
    }
    /**
   * Sends a message. Alias of {@link Socket#write}.
   *
   * @param {String} msg - message.
   * @param {Object} options.
   * @param {Function} fn - callback function.
   * @return {Socket} for chaining.
   */ send(msg, options, fn) {
        this._sendPacket("message", msg, options, fn);
        return this;
    }
    /**
   * Sends a packet.
   *
   * @param {String} type: packet type.
   * @param {String} data.
   * @param {Object} options.
   * @param {Function} fn - callback function.
   * @private
   */ _sendPacket(type, data2, options, fn) {
        if ("function" === typeof data2) {
            fn = data2;
            data2 = void 0;
        }
        if ("function" === typeof options) {
            fn = options;
            options = null;
        }
        if ("closing" === this.readyState || "closed" === this.readyState) return;
        options = options || {};
        options.compress = false !== options.compress;
        const packet = {
            type: type,
            data: data2,
            options: options
        };
        this.emitReserved("packetCreate", packet);
        this.writeBuffer.push(packet);
        if (fn) this.once("flush", fn);
        this.flush();
    }
    /**
   * Closes the connection.
   */ close() {
        const close = ()=>{
            this._onClose("forced close");
            this.transport.close();
        };
        const cleanupAndClose = ()=>{
            this.off("upgrade", cleanupAndClose);
            this.off("upgradeError", cleanupAndClose);
            close();
        };
        const waitForUpgrade = ()=>{
            this.once("upgrade", cleanupAndClose);
            this.once("upgradeError", cleanupAndClose);
        };
        if ("opening" === this.readyState || "open" === this.readyState) {
            this.readyState = "closing";
            if (this.writeBuffer.length) this.once("drain", ()=>{
                if (this.upgrading) waitForUpgrade();
                else close();
            });
            else if (this.upgrading) waitForUpgrade();
            else close();
        }
        return this;
    }
    /**
   * Called upon transport error
   *
   * @private
   */ _onError(err) {
        _SocketWithoutUpgrade.priorWebsocketSuccess = false;
        if (this.opts.tryAllTransports && this.transports.length > 1 && this.readyState === "opening") {
            this.transports.shift();
            return this._open();
        }
        this.emitReserved("error", err);
        this._onClose("transport error", err);
    }
    /**
   * Called upon transport close.
   *
   * @private
   */ _onClose(reason, description) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            this.clearTimeoutFn(this._pingTimeoutTimer);
            this.transport.removeAllListeners("close");
            this.transport.close();
            this.transport.removeAllListeners();
            if ($281a441cdcb2cf36$var$withEventListeners) {
                if (this._beforeunloadEventListener) removeEventListener("beforeunload", this._beforeunloadEventListener, false);
                if (this._offlineEventListener) {
                    const i3 = $281a441cdcb2cf36$var$OFFLINE_EVENT_LISTENERS.indexOf(this._offlineEventListener);
                    if (i3 !== -1) $281a441cdcb2cf36$var$OFFLINE_EVENT_LISTENERS.splice(i3, 1);
                }
            }
            this.readyState = "closed";
            this.id = null;
            this.emitReserved("close", reason, description);
            this.writeBuffer = [];
            this._prevBufferLen = 0;
        }
    }
};
$281a441cdcb2cf36$var$SocketWithoutUpgrade.protocol = $281a441cdcb2cf36$var$protocol;
var $281a441cdcb2cf36$var$SocketWithUpgrade = class extends $281a441cdcb2cf36$var$SocketWithoutUpgrade {
    constructor(){
        super(...arguments);
        this._upgrades = [];
    }
    onOpen() {
        super.onOpen();
        if ("open" === this.readyState && this.opts.upgrade) for(let i3 = 0; i3 < this._upgrades.length; i3++)this._probe(this._upgrades[i3]);
    }
    /**
   * Probes a transport.
   *
   * @param {String} name - transport name
   * @private
   */ _probe(name) {
        let transport = this.createTransport(name);
        let failed = false;
        $281a441cdcb2cf36$var$SocketWithoutUpgrade.priorWebsocketSuccess = false;
        const onTransportOpen = ()=>{
            if (failed) return;
            transport.send([
                {
                    type: "ping",
                    data: "probe"
                }
            ]);
            transport.once("packet", (msg)=>{
                if (failed) return;
                if ("pong" === msg.type && "probe" === msg.data) {
                    this.upgrading = true;
                    this.emitReserved("upgrading", transport);
                    if (!transport) return;
                    $281a441cdcb2cf36$var$SocketWithoutUpgrade.priorWebsocketSuccess = "websocket" === transport.name;
                    this.transport.pause(()=>{
                        if (failed) return;
                        if ("closed" === this.readyState) return;
                        cleanup();
                        this.setTransport(transport);
                        transport.send([
                            {
                                type: "upgrade"
                            }
                        ]);
                        this.emitReserved("upgrade", transport);
                        transport = null;
                        this.upgrading = false;
                        this.flush();
                    });
                } else {
                    const err = new Error("probe error");
                    err.transport = transport.name;
                    this.emitReserved("upgradeError", err);
                }
            });
        };
        function freezeTransport() {
            if (failed) return;
            failed = true;
            cleanup();
            transport.close();
            transport = null;
        }
        const onerror = (err)=>{
            const error = new Error("probe error: " + err);
            error.transport = transport.name;
            freezeTransport();
            this.emitReserved("upgradeError", error);
        };
        function onTransportClose() {
            onerror("transport closed");
        }
        function onclose() {
            onerror("socket closed");
        }
        function onupgrade(to) {
            if (transport && to.name !== transport.name) freezeTransport();
        }
        const cleanup = ()=>{
            transport.removeListener("open", onTransportOpen);
            transport.removeListener("error", onerror);
            transport.removeListener("close", onTransportClose);
            this.off("close", onclose);
            this.off("upgrading", onupgrade);
        };
        transport.once("open", onTransportOpen);
        transport.once("error", onerror);
        transport.once("close", onTransportClose);
        this.once("close", onclose);
        this.once("upgrading", onupgrade);
        if (this._upgrades.indexOf("webtransport") !== -1 && name !== "webtransport") this.setTimeoutFn(()=>{
            if (!failed) transport.open();
        }, 200);
        else transport.open();
    }
    onHandshake(data2) {
        this._upgrades = this._filterUpgrades(data2.upgrades);
        super.onHandshake(data2);
    }
    /**
   * Filters upgrades, returning only those matching client transports.
   *
   * @param {Array} upgrades - server upgrades
   * @private
   */ _filterUpgrades(upgrades) {
        const filteredUpgrades = [];
        for(let i3 = 0; i3 < upgrades.length; i3++)if (~this.transports.indexOf(upgrades[i3])) filteredUpgrades.push(upgrades[i3]);
        return filteredUpgrades;
    }
};
var $281a441cdcb2cf36$var$Socket = class extends $281a441cdcb2cf36$var$SocketWithUpgrade {
    constructor(uri, opts = {}){
        const o3 = typeof uri === "object" ? uri : opts;
        if (!o3.transports || o3.transports && typeof o3.transports[0] === "string") o3.transports = (o3.transports || [
            "polling",
            "websocket",
            "webtransport"
        ]).map((transportName)=>$281a441cdcb2cf36$var$transports[transportName]).filter((t4)=>!!t4);
        super(uri, o3);
    }
};
// ../node_modules/engine.io-client/build/esm/index.js
var $281a441cdcb2cf36$var$protocol2 = $281a441cdcb2cf36$var$Socket.protocol;
// ../node_modules/socket.io-client/build/esm/url.js
function $281a441cdcb2cf36$var$url(uri, path = "", loc) {
    let obj = uri;
    loc = loc || typeof location !== "undefined" && location;
    if (null == uri) uri = loc.protocol + "//" + loc.host;
    if (typeof uri === "string") {
        if ("/" === uri.charAt(0)) {
            if ("/" === uri.charAt(1)) uri = loc.protocol + uri;
            else uri = loc.host + uri;
        }
        if (!/^(https?|wss?):\/\//.test(uri)) {
            if ("undefined" !== typeof loc) uri = loc.protocol + "//" + uri;
            else uri = "https://" + uri;
        }
        obj = $281a441cdcb2cf36$var$parse(uri);
    }
    if (!obj.port) {
        if (/^(http|ws)$/.test(obj.protocol)) obj.port = "80";
        else if (/^(http|ws)s$/.test(obj.protocol)) obj.port = "443";
    }
    obj.path = obj.path || "/";
    const ipv6 = obj.host.indexOf(":") !== -1;
    const host = ipv6 ? "[" + obj.host + "]" : obj.host;
    obj.id = obj.protocol + "://" + host + ":" + obj.port + path;
    obj.href = obj.protocol + "://" + host + (loc && loc.port === obj.port ? "" : ":" + obj.port);
    return obj;
}
// ../node_modules/socket.io-parser/build/esm/index.js
var $281a441cdcb2cf36$var$esm_exports = {};
$281a441cdcb2cf36$var$__export($281a441cdcb2cf36$var$esm_exports, {
    Decoder: ()=>$281a441cdcb2cf36$var$Decoder,
    Encoder: ()=>$281a441cdcb2cf36$var$Encoder,
    PacketType: ()=>$281a441cdcb2cf36$var$PacketType,
    isPacketValid: ()=>$281a441cdcb2cf36$var$isPacketValid,
    protocol: ()=>$281a441cdcb2cf36$var$protocol3
});
// ../node_modules/socket.io-parser/build/esm/is-binary.js
var $281a441cdcb2cf36$var$withNativeArrayBuffer3 = typeof ArrayBuffer === "function";
var $281a441cdcb2cf36$var$isView2 = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj.buffer instanceof ArrayBuffer;
};
var $281a441cdcb2cf36$var$toString = Object.prototype.toString;
var $281a441cdcb2cf36$var$withNativeBlob2 = typeof Blob === "function" || typeof Blob !== "undefined" && $281a441cdcb2cf36$var$toString.call(Blob) === "[object BlobConstructor]";
var $281a441cdcb2cf36$var$withNativeFile = typeof File === "function" || typeof File !== "undefined" && $281a441cdcb2cf36$var$toString.call(File) === "[object FileConstructor]";
function $281a441cdcb2cf36$var$isBinary(obj) {
    return $281a441cdcb2cf36$var$withNativeArrayBuffer3 && (obj instanceof ArrayBuffer || $281a441cdcb2cf36$var$isView2(obj)) || $281a441cdcb2cf36$var$withNativeBlob2 && obj instanceof Blob || $281a441cdcb2cf36$var$withNativeFile && obj instanceof File;
}
function $281a441cdcb2cf36$var$hasBinary(obj, toJSON) {
    if (!obj || typeof obj !== "object") return false;
    if (Array.isArray(obj)) {
        for(let i3 = 0, l3 = obj.length; i3 < l3; i3++){
            if ($281a441cdcb2cf36$var$hasBinary(obj[i3])) return true;
        }
        return false;
    }
    if ($281a441cdcb2cf36$var$isBinary(obj)) return true;
    if (obj.toJSON && typeof obj.toJSON === "function" && arguments.length === 1) return $281a441cdcb2cf36$var$hasBinary(obj.toJSON(), true);
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key) && $281a441cdcb2cf36$var$hasBinary(obj[key])) return true;
    }
    return false;
}
// ../node_modules/socket.io-parser/build/esm/binary.js
function $281a441cdcb2cf36$var$deconstructPacket(packet) {
    const buffers = [];
    const packetData = packet.data;
    const pack = packet;
    pack.data = $281a441cdcb2cf36$var$_deconstructPacket(packetData, buffers);
    pack.attachments = buffers.length;
    return {
        packet: pack,
        buffers: buffers
    };
}
function $281a441cdcb2cf36$var$_deconstructPacket(data2, buffers) {
    if (!data2) return data2;
    if ($281a441cdcb2cf36$var$isBinary(data2)) {
        const placeholder = {
            _placeholder: true,
            num: buffers.length
        };
        buffers.push(data2);
        return placeholder;
    } else if (Array.isArray(data2)) {
        const newData = new Array(data2.length);
        for(let i3 = 0; i3 < data2.length; i3++)newData[i3] = $281a441cdcb2cf36$var$_deconstructPacket(data2[i3], buffers);
        return newData;
    } else if (typeof data2 === "object" && !(data2 instanceof Date)) {
        const newData = {};
        for(const key in data2)if (Object.prototype.hasOwnProperty.call(data2, key)) newData[key] = $281a441cdcb2cf36$var$_deconstructPacket(data2[key], buffers);
        return newData;
    }
    return data2;
}
function $281a441cdcb2cf36$var$reconstructPacket(packet, buffers) {
    packet.data = $281a441cdcb2cf36$var$_reconstructPacket(packet.data, buffers);
    delete packet.attachments;
    return packet;
}
function $281a441cdcb2cf36$var$_reconstructPacket(data2, buffers) {
    if (!data2) return data2;
    if (data2 && data2._placeholder === true) {
        const isIndexValid = typeof data2.num === "number" && data2.num >= 0 && data2.num < buffers.length;
        if (isIndexValid) return buffers[data2.num];
        else throw new Error("illegal attachments");
    } else if (Array.isArray(data2)) for(let i3 = 0; i3 < data2.length; i3++)data2[i3] = $281a441cdcb2cf36$var$_reconstructPacket(data2[i3], buffers);
    else if (typeof data2 === "object") {
        for(const key in data2)if (Object.prototype.hasOwnProperty.call(data2, key)) data2[key] = $281a441cdcb2cf36$var$_reconstructPacket(data2[key], buffers);
    }
    return data2;
}
// ../node_modules/socket.io-parser/build/esm/index.js
var $281a441cdcb2cf36$var$RESERVED_EVENTS = [
    "connect",
    // used on the client side
    "connect_error",
    // used on the client side
    "disconnect",
    // used on both sides
    "disconnecting",
    // used on the server side
    "newListener",
    // used by the Node.js EventEmitter
    "removeListener"
];
var $281a441cdcb2cf36$var$protocol3 = 5;
var $281a441cdcb2cf36$var$PacketType;
(function(PacketType2) {
    PacketType2[PacketType2["CONNECT"] = 0] = "CONNECT";
    PacketType2[PacketType2["DISCONNECT"] = 1] = "DISCONNECT";
    PacketType2[PacketType2["EVENT"] = 2] = "EVENT";
    PacketType2[PacketType2["ACK"] = 3] = "ACK";
    PacketType2[PacketType2["CONNECT_ERROR"] = 4] = "CONNECT_ERROR";
    PacketType2[PacketType2["BINARY_EVENT"] = 5] = "BINARY_EVENT";
    PacketType2[PacketType2["BINARY_ACK"] = 6] = "BINARY_ACK";
})($281a441cdcb2cf36$var$PacketType || ($281a441cdcb2cf36$var$PacketType = {}));
var $281a441cdcb2cf36$var$Encoder = class {
    /**
   * Encoder constructor
   *
   * @param {function} replacer - custom replacer to pass down to JSON.parse
   */ constructor(replacer){
        this.replacer = replacer;
    }
    /**
   * Encode a packet as a single string if non-binary, or as a
   * buffer sequence, depending on packet type.
   *
   * @param {Object} obj - packet object
   */ encode(obj) {
        if (obj.type === $281a441cdcb2cf36$var$PacketType.EVENT || obj.type === $281a441cdcb2cf36$var$PacketType.ACK) {
            if ($281a441cdcb2cf36$var$hasBinary(obj)) return this.encodeAsBinary({
                type: obj.type === $281a441cdcb2cf36$var$PacketType.EVENT ? $281a441cdcb2cf36$var$PacketType.BINARY_EVENT : $281a441cdcb2cf36$var$PacketType.BINARY_ACK,
                nsp: obj.nsp,
                data: obj.data,
                id: obj.id
            });
        }
        return [
            this.encodeAsString(obj)
        ];
    }
    /**
   * Encode packet as string.
   */ encodeAsString(obj) {
        let str = "" + obj.type;
        if (obj.type === $281a441cdcb2cf36$var$PacketType.BINARY_EVENT || obj.type === $281a441cdcb2cf36$var$PacketType.BINARY_ACK) str += obj.attachments + "-";
        if (obj.nsp && "/" !== obj.nsp) str += obj.nsp + ",";
        if (null != obj.id) str += obj.id;
        if (null != obj.data) str += JSON.stringify(obj.data, this.replacer);
        return str;
    }
    /**
   * Encode packet as 'buffer sequence' by removing blobs, and
   * deconstructing packet into object with placeholders and
   * a list of buffers.
   */ encodeAsBinary(obj) {
        const deconstruction = $281a441cdcb2cf36$var$deconstructPacket(obj);
        const pack = this.encodeAsString(deconstruction.packet);
        const buffers = deconstruction.buffers;
        buffers.unshift(pack);
        return buffers;
    }
};
var $281a441cdcb2cf36$var$Decoder = class _Decoder extends $281a441cdcb2cf36$var$Emitter {
    /**
   * Decoder constructor
   */ constructor(opts){
        super();
        this.opts = Object.assign({
            reviver: void 0,
            maxAttachments: 10
        }, typeof opts === "function" ? {
            reviver: opts
        } : opts);
    }
    /**
   * Decodes an encoded packet string into packet JSON.
   *
   * @param {String} obj - encoded packet
   */ add(obj) {
        let packet;
        if (typeof obj === "string") {
            if (this.reconstructor) throw new Error("got plaintext data when reconstructing a packet");
            packet = this.decodeString(obj);
            const isBinaryEvent = packet.type === $281a441cdcb2cf36$var$PacketType.BINARY_EVENT;
            if (isBinaryEvent || packet.type === $281a441cdcb2cf36$var$PacketType.BINARY_ACK) {
                packet.type = isBinaryEvent ? $281a441cdcb2cf36$var$PacketType.EVENT : $281a441cdcb2cf36$var$PacketType.ACK;
                this.reconstructor = new $281a441cdcb2cf36$var$BinaryReconstructor(packet);
                if (packet.attachments === 0) super.emitReserved("decoded", packet);
            } else super.emitReserved("decoded", packet);
        } else if ($281a441cdcb2cf36$var$isBinary(obj) || obj.base64) {
            if (!this.reconstructor) throw new Error("got binary data when not reconstructing a packet");
            else {
                packet = this.reconstructor.takeBinaryData(obj);
                if (packet) {
                    this.reconstructor = null;
                    super.emitReserved("decoded", packet);
                }
            }
        } else throw new Error("Unknown type: " + obj);
    }
    /**
   * Decode a packet String (JSON data)
   *
   * @param {String} str
   * @return {Object} packet
   */ decodeString(str) {
        let i3 = 0;
        const p3 = {
            type: Number(str.charAt(0))
        };
        if ($281a441cdcb2cf36$var$PacketType[p3.type] === void 0) throw new Error("unknown packet type " + p3.type);
        if (p3.type === $281a441cdcb2cf36$var$PacketType.BINARY_EVENT || p3.type === $281a441cdcb2cf36$var$PacketType.BINARY_ACK) {
            const start = i3 + 1;
            while(str.charAt(++i3) !== "-" && i3 != str.length);
            const buf = str.substring(start, i3);
            if (buf != Number(buf) || str.charAt(i3) !== "-") throw new Error("Illegal attachments");
            const n3 = Number(buf);
            if (!$281a441cdcb2cf36$var$isInteger(n3) || n3 < 0) throw new Error("Illegal attachments");
            else if (n3 > this.opts.maxAttachments) throw new Error("too many attachments");
            p3.attachments = n3;
        }
        if ("/" === str.charAt(i3 + 1)) {
            const start = i3 + 1;
            while(++i3){
                const c3 = str.charAt(i3);
                if ("," === c3) break;
                if (i3 === str.length) break;
            }
            p3.nsp = str.substring(start, i3);
        } else p3.nsp = "/";
        const next = str.charAt(i3 + 1);
        if ("" !== next && Number(next) == next) {
            const start = i3 + 1;
            while(++i3){
                const c3 = str.charAt(i3);
                if (null == c3 || Number(c3) != c3) {
                    --i3;
                    break;
                }
                if (i3 === str.length) break;
            }
            p3.id = Number(str.substring(start, i3 + 1));
        }
        if (str.charAt(++i3)) {
            const payload = this.tryParse(str.substr(i3));
            if (_Decoder.isPayloadValid(p3.type, payload)) p3.data = payload;
            else throw new Error("invalid payload");
        }
        return p3;
    }
    tryParse(str) {
        try {
            return JSON.parse(str, this.opts.reviver);
        } catch (e4) {
            return false;
        }
    }
    static isPayloadValid(type, payload) {
        switch(type){
            case $281a441cdcb2cf36$var$PacketType.CONNECT:
                return $281a441cdcb2cf36$var$isObject(payload);
            case $281a441cdcb2cf36$var$PacketType.DISCONNECT:
                return payload === void 0;
            case $281a441cdcb2cf36$var$PacketType.CONNECT_ERROR:
                return typeof payload === "string" || $281a441cdcb2cf36$var$isObject(payload);
            case $281a441cdcb2cf36$var$PacketType.EVENT:
            case $281a441cdcb2cf36$var$PacketType.BINARY_EVENT:
                return Array.isArray(payload) && (typeof payload[0] === "number" || typeof payload[0] === "string" && $281a441cdcb2cf36$var$RESERVED_EVENTS.indexOf(payload[0]) === -1);
            case $281a441cdcb2cf36$var$PacketType.ACK:
            case $281a441cdcb2cf36$var$PacketType.BINARY_ACK:
                return Array.isArray(payload);
        }
    }
    /**
   * Deallocates a parser's resources
   */ destroy() {
        if (this.reconstructor) {
            this.reconstructor.finishedReconstruction();
            this.reconstructor = null;
        }
    }
};
var $281a441cdcb2cf36$var$BinaryReconstructor = class {
    constructor(packet){
        this.packet = packet;
        this.buffers = [];
        this.reconPack = packet;
    }
    /**
   * Method to be called when binary data received from connection
   * after a BINARY_EVENT packet.
   *
   * @param {Buffer | ArrayBuffer} binData - the raw binary data received
   * @return {null | Object} returns null if more binary data is expected or
   *   a reconstructed packet object if all buffers have been received.
   */ takeBinaryData(binData) {
        this.buffers.push(binData);
        if (this.buffers.length === this.reconPack.attachments) {
            const packet = $281a441cdcb2cf36$var$reconstructPacket(this.reconPack, this.buffers);
            this.finishedReconstruction();
            return packet;
        }
        return null;
    }
    /**
   * Cleans up binary packet reconstruction variables.
   */ finishedReconstruction() {
        this.reconPack = null;
        this.buffers = [];
    }
};
function $281a441cdcb2cf36$var$isNamespaceValid(nsp) {
    return typeof nsp === "string";
}
var $281a441cdcb2cf36$var$isInteger = Number.isInteger || function(value2) {
    return typeof value2 === "number" && isFinite(value2) && Math.floor(value2) === value2;
};
function $281a441cdcb2cf36$var$isAckIdValid(id2) {
    return id2 === void 0 || $281a441cdcb2cf36$var$isInteger(id2);
}
function $281a441cdcb2cf36$var$isObject(value2) {
    return Object.prototype.toString.call(value2) === "[object Object]";
}
function $281a441cdcb2cf36$var$isDataValid(type, payload) {
    switch(type){
        case $281a441cdcb2cf36$var$PacketType.CONNECT:
            return payload === void 0 || $281a441cdcb2cf36$var$isObject(payload);
        case $281a441cdcb2cf36$var$PacketType.DISCONNECT:
            return payload === void 0;
        case $281a441cdcb2cf36$var$PacketType.EVENT:
            return Array.isArray(payload) && (typeof payload[0] === "number" || typeof payload[0] === "string" && $281a441cdcb2cf36$var$RESERVED_EVENTS.indexOf(payload[0]) === -1);
        case $281a441cdcb2cf36$var$PacketType.ACK:
            return Array.isArray(payload);
        case $281a441cdcb2cf36$var$PacketType.CONNECT_ERROR:
            return typeof payload === "string" || $281a441cdcb2cf36$var$isObject(payload);
        default:
            return false;
    }
}
function $281a441cdcb2cf36$var$isPacketValid(packet) {
    return $281a441cdcb2cf36$var$isNamespaceValid(packet.nsp) && $281a441cdcb2cf36$var$isAckIdValid(packet.id) && $281a441cdcb2cf36$var$isDataValid(packet.type, packet.data);
}
// ../node_modules/socket.io-client/build/esm/on.js
function $281a441cdcb2cf36$var$on(obj, ev, fn) {
    obj.on(ev, fn);
    return function subDestroy() {
        obj.off(ev, fn);
    };
}
// ../node_modules/socket.io-client/build/esm/socket.js
var $281a441cdcb2cf36$var$RESERVED_EVENTS2 = Object.freeze({
    connect: 1,
    connect_error: 1,
    disconnect: 1,
    disconnecting: 1,
    // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
    newListener: 1,
    removeListener: 1
});
var $281a441cdcb2cf36$var$Socket2 = class extends $281a441cdcb2cf36$var$Emitter {
    /**
   * `Socket` constructor.
   */ constructor(io, nsp, opts){
        super();
        this.connected = false;
        this.recovered = false;
        this.receiveBuffer = [];
        this.sendBuffer = [];
        this._queue = [];
        this._queueSeq = 0;
        this.ids = 0;
        this.acks = {};
        this.flags = {};
        this.io = io;
        this.nsp = nsp;
        if (opts && opts.auth) this.auth = opts.auth;
        this._opts = Object.assign({}, opts);
        if (this.io._autoConnect) this.open();
    }
    /**
   * Whether the socket is currently disconnected
   *
   * @example
   * const socket = io();
   *
   * socket.on("connect", () => {
   *   console.log(socket.disconnected); // false
   * });
   *
   * socket.on("disconnect", () => {
   *   console.log(socket.disconnected); // true
   * });
   */ get disconnected() {
        return !this.connected;
    }
    /**
   * Subscribe to open, close and packet events
   *
   * @private
   */ subEvents() {
        if (this.subs) return;
        const io = this.io;
        this.subs = [
            $281a441cdcb2cf36$var$on(io, "open", this.onopen.bind(this)),
            $281a441cdcb2cf36$var$on(io, "packet", this.onpacket.bind(this)),
            $281a441cdcb2cf36$var$on(io, "error", this.onerror.bind(this)),
            $281a441cdcb2cf36$var$on(io, "close", this.onclose.bind(this))
        ];
    }
    /**
   * Whether the Socket will try to reconnect when its Manager connects or reconnects.
   *
   * @example
   * const socket = io();
   *
   * console.log(socket.active); // true
   *
   * socket.on("disconnect", (reason) => {
   *   if (reason === "io server disconnect") {
   *     // the disconnection was initiated by the server, you need to manually reconnect
   *     console.log(socket.active); // false
   *   }
   *   // else the socket will automatically try to reconnect
   *   console.log(socket.active); // true
   * });
   */ get active() {
        return !!this.subs;
    }
    /**
   * "Opens" the socket.
   *
   * @example
   * const socket = io({
   *   autoConnect: false
   * });
   *
   * socket.connect();
   */ connect() {
        if (this.connected) return this;
        this.subEvents();
        if (!this.io["_reconnecting"]) this.io.open();
        if ("open" === this.io._readyState) this.onopen();
        return this;
    }
    /**
   * Alias for {@link connect()}.
   */ open() {
        return this.connect();
    }
    /**
   * Sends a `message` event.
   *
   * This method mimics the WebSocket.send() method.
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send
   *
   * @example
   * socket.send("hello");
   *
   * // this is equivalent to
   * socket.emit("message", "hello");
   *
   * @return self
   */ send(...args2) {
        args2.unshift("message");
        this.emit.apply(this, args2);
        return this;
    }
    /**
   * Override `emit`.
   * If the event is in `events`, it's emitted normally.
   *
   * @example
   * socket.emit("hello", "world");
   *
   * // all serializable datastructures are supported (no need to call JSON.stringify)
   * socket.emit("hello", 1, "2", { 3: ["4"], 5: Uint8Array.from([6]) });
   *
   * // with an acknowledgement from the server
   * socket.emit("hello", "world", (val) => {
   *   // ...
   * });
   *
   * @return self
   */ emit(ev, ...args2) {
        var _a2, _b, _c;
        if ($281a441cdcb2cf36$var$RESERVED_EVENTS2.hasOwnProperty(ev)) throw new Error('"' + ev.toString() + '" is a reserved event name');
        args2.unshift(ev);
        if (this._opts.retries && !this.flags.fromQueue && !this.flags.volatile) {
            this._addToQueue(args2);
            return this;
        }
        const packet = {
            type: $281a441cdcb2cf36$var$PacketType.EVENT,
            data: args2
        };
        packet.options = {};
        packet.options.compress = this.flags.compress !== false;
        if ("function" === typeof args2[args2.length - 1]) {
            const id2 = this.ids++;
            const ack = args2.pop();
            this._registerAckCallback(id2, ack);
            packet.id = id2;
        }
        const isTransportWritable = (_b = (_a2 = this.io.engine) === null || _a2 === void 0 ? void 0 : _a2.transport) === null || _b === void 0 ? void 0 : _b.writable;
        const isConnected = this.connected && !((_c = this.io.engine) === null || _c === void 0 ? void 0 : _c._hasPingExpired());
        const discardPacket = this.flags.volatile && !isTransportWritable;
        if (discardPacket) ;
        else if (isConnected) {
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        } else this.sendBuffer.push(packet);
        this.flags = {};
        return this;
    }
    /**
   * @private
   */ _registerAckCallback(id2, ack) {
        var _a2;
        const timeout = (_a2 = this.flags.timeout) !== null && _a2 !== void 0 ? _a2 : this._opts.ackTimeout;
        if (timeout === void 0) {
            this.acks[id2] = ack;
            return;
        }
        const timer = this.io.setTimeoutFn(()=>{
            delete this.acks[id2];
            for(let i3 = 0; i3 < this.sendBuffer.length; i3++)if (this.sendBuffer[i3].id === id2) this.sendBuffer.splice(i3, 1);
            ack.call(this, new Error("operation has timed out"));
        }, timeout);
        const fn = (...args2)=>{
            this.io.clearTimeoutFn(timer);
            ack.apply(this, args2);
        };
        fn.withError = true;
        this.acks[id2] = fn;
    }
    /**
   * Emits an event and waits for an acknowledgement
   *
   * @example
   * // without timeout
   * const response = await socket.emitWithAck("hello", "world");
   *
   * // with a specific timeout
   * try {
   *   const response = await socket.timeout(1000).emitWithAck("hello", "world");
   * } catch (err) {
   *   // the server did not acknowledge the event in the given delay
   * }
   *
   * @return a Promise that will be fulfilled when the server acknowledges the event
   */ emitWithAck(ev, ...args2) {
        return new Promise((resolve, reject)=>{
            const fn = (arg1, arg2)=>{
                return arg1 ? reject(arg1) : resolve(arg2);
            };
            fn.withError = true;
            args2.push(fn);
            this.emit(ev, ...args2);
        });
    }
    /**
   * Add the packet to the queue.
   * @param args
   * @private
   */ _addToQueue(args2) {
        let ack;
        if (typeof args2[args2.length - 1] === "function") ack = args2.pop();
        const packet = {
            id: this._queueSeq++,
            tryCount: 0,
            pending: false,
            args: args2,
            flags: Object.assign({
                fromQueue: true
            }, this.flags)
        };
        args2.push((err, ...responseArgs)=>{
            this._queue[0];
            const hasError = err !== null;
            if (hasError) {
                if (packet.tryCount > this._opts.retries) {
                    this._queue.shift();
                    if (ack) ack(err);
                }
            } else {
                this._queue.shift();
                if (ack) ack(null, ...responseArgs);
            }
            packet.pending = false;
            return this._drainQueue();
        });
        this._queue.push(packet);
        this._drainQueue();
    }
    /**
   * Send the first packet of the queue, and wait for an acknowledgement from the server.
   * @param force - whether to resend a packet that has not been acknowledged yet
   *
   * @private
   */ _drainQueue(force = false) {
        if (!this.connected || this._queue.length === 0) return;
        const packet = this._queue[0];
        if (packet.pending && !force) return;
        packet.pending = true;
        packet.tryCount++;
        this.flags = packet.flags;
        this.emit.apply(this, packet.args);
    }
    /**
   * Sends a packet.
   *
   * @param packet
   * @private
   */ packet(packet) {
        packet.nsp = this.nsp;
        this.io._packet(packet);
    }
    /**
   * Called upon engine `open`.
   *
   * @private
   */ onopen() {
        if (typeof this.auth == "function") this.auth((data2)=>{
            this._sendConnectPacket(data2);
        });
        else this._sendConnectPacket(this.auth);
    }
    /**
   * Sends a CONNECT packet to initiate the Socket.IO session.
   *
   * @param data
   * @private
   */ _sendConnectPacket(data2) {
        this.packet({
            type: $281a441cdcb2cf36$var$PacketType.CONNECT,
            data: this._pid ? Object.assign({
                pid: this._pid,
                offset: this._lastOffset
            }, data2) : data2
        });
    }
    /**
   * Called upon engine or manager `error`.
   *
   * @param err
   * @private
   */ onerror(err) {
        if (!this.connected) this.emitReserved("connect_error", err);
    }
    /**
   * Called upon engine `close`.
   *
   * @param reason
   * @param description
   * @private
   */ onclose(reason, description) {
        this.connected = false;
        delete this.id;
        this.emitReserved("disconnect", reason, description);
        this._clearAcks();
    }
    /**
   * Clears the acknowledgement handlers upon disconnection, since the client will never receive an acknowledgement from
   * the server.
   *
   * @private
   */ _clearAcks() {
        Object.keys(this.acks).forEach((id2)=>{
            const isBuffered = this.sendBuffer.some((packet)=>String(packet.id) === id2);
            if (!isBuffered) {
                const ack = this.acks[id2];
                delete this.acks[id2];
                if (ack.withError) ack.call(this, new Error("socket has been disconnected"));
            }
        });
    }
    /**
   * Called with socket packet.
   *
   * @param packet
   * @private
   */ onpacket(packet) {
        const sameNamespace = packet.nsp === this.nsp;
        if (!sameNamespace) return;
        switch(packet.type){
            case $281a441cdcb2cf36$var$PacketType.CONNECT:
                if (packet.data && packet.data.sid) this.onconnect(packet.data.sid, packet.data.pid);
                else this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
                break;
            case $281a441cdcb2cf36$var$PacketType.EVENT:
            case $281a441cdcb2cf36$var$PacketType.BINARY_EVENT:
                this.onevent(packet);
                break;
            case $281a441cdcb2cf36$var$PacketType.ACK:
            case $281a441cdcb2cf36$var$PacketType.BINARY_ACK:
                this.onack(packet);
                break;
            case $281a441cdcb2cf36$var$PacketType.DISCONNECT:
                this.ondisconnect();
                break;
            case $281a441cdcb2cf36$var$PacketType.CONNECT_ERROR:
                this.destroy();
                const err = new Error(packet.data.message);
                err.data = packet.data.data;
                this.emitReserved("connect_error", err);
                break;
        }
    }
    /**
   * Called upon a server event.
   *
   * @param packet
   * @private
   */ onevent(packet) {
        const args2 = packet.data || [];
        if (null != packet.id) args2.push(this.ack(packet.id));
        if (this.connected) this.emitEvent(args2);
        else this.receiveBuffer.push(Object.freeze(args2));
    }
    emitEvent(args2) {
        if (this._anyListeners && this._anyListeners.length) {
            const listeners = this._anyListeners.slice();
            for (const listener of listeners)listener.apply(this, args2);
        }
        super.emit.apply(this, args2);
        if (this._pid && args2.length && typeof args2[args2.length - 1] === "string") this._lastOffset = args2[args2.length - 1];
    }
    /**
   * Produces an ack callback to emit with an event.
   *
   * @private
   */ ack(id2) {
        const self2 = this;
        let sent = false;
        return function(...args2) {
            if (sent) return;
            sent = true;
            self2.packet({
                type: $281a441cdcb2cf36$var$PacketType.ACK,
                id: id2,
                data: args2
            });
        };
    }
    /**
   * Called upon a server acknowledgement.
   *
   * @param packet
   * @private
   */ onack(packet) {
        const ack = this.acks[packet.id];
        if (typeof ack !== "function") return;
        delete this.acks[packet.id];
        if (ack.withError) packet.data.unshift(null);
        ack.apply(this, packet.data);
    }
    /**
   * Called upon server connect.
   *
   * @private
   */ onconnect(id2, pid) {
        this.id = id2;
        this.recovered = pid && this._pid === pid;
        this._pid = pid;
        this.connected = true;
        this.emitBuffered();
        this._drainQueue(true);
        this.emitReserved("connect");
    }
    /**
   * Emit buffered events (received and emitted).
   *
   * @private
   */ emitBuffered() {
        this.receiveBuffer.forEach((args2)=>this.emitEvent(args2));
        this.receiveBuffer = [];
        this.sendBuffer.forEach((packet)=>{
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        });
        this.sendBuffer = [];
    }
    /**
   * Called upon server disconnect.
   *
   * @private
   */ ondisconnect() {
        this.destroy();
        this.onclose("io server disconnect");
    }
    /**
   * Called upon forced client/server side disconnections,
   * this method ensures the manager stops tracking us and
   * that reconnections don't get triggered for this.
   *
   * @private
   */ destroy() {
        if (this.subs) {
            this.subs.forEach((subDestroy)=>subDestroy());
            this.subs = void 0;
        }
        this.io["_destroy"](this);
    }
    /**
   * Disconnects the socket manually. In that case, the socket will not try to reconnect.
   *
   * If this is the last active Socket instance of the {@link Manager}, the low-level connection will be closed.
   *
   * @example
   * const socket = io();
   *
   * socket.on("disconnect", (reason) => {
   *   // console.log(reason); prints "io client disconnect"
   * });
   *
   * socket.disconnect();
   *
   * @return self
   */ disconnect() {
        if (this.connected) this.packet({
            type: $281a441cdcb2cf36$var$PacketType.DISCONNECT
        });
        this.destroy();
        if (this.connected) this.onclose("io client disconnect");
        return this;
    }
    /**
   * Alias for {@link disconnect()}.
   *
   * @return self
   */ close() {
        return this.disconnect();
    }
    /**
   * Sets the compress flag.
   *
   * @example
   * socket.compress(false).emit("hello");
   *
   * @param compress - if `true`, compresses the sending data
   * @return self
   */ compress(compress) {
        this.flags.compress = compress;
        return this;
    }
    /**
   * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
   * ready to send messages.
   *
   * @example
   * socket.volatile.emit("hello"); // the server may or may not receive it
   *
   * @returns self
   */ get volatile() {
        this.flags.volatile = true;
        return this;
    }
    /**
   * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
   * given number of milliseconds have elapsed without an acknowledgement from the server:
   *
   * @example
   * socket.timeout(5000).emit("my-event", (err) => {
   *   if (err) {
   *     // the server did not acknowledge the event in the given delay
   *   }
   * });
   *
   * @returns self
   */ timeout(timeout) {
        this.flags.timeout = timeout;
        return this;
    }
    /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback.
   *
   * @example
   * socket.onAny((event, ...args) => {
   *   console.log(`got ${event}`);
   * });
   *
   * @param listener
   */ onAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.push(listener);
        return this;
    }
    /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback. The listener is added to the beginning of the listeners array.
   *
   * @example
   * socket.prependAny((event, ...args) => {
   *   console.log(`got event ${event}`);
   * });
   *
   * @param listener
   */ prependAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.unshift(listener);
        return this;
    }
    /**
   * Removes the listener that will be fired when any event is emitted.
   *
   * @example
   * const catchAllListener = (event, ...args) => {
   *   console.log(`got event ${event}`);
   * }
   *
   * socket.onAny(catchAllListener);
   *
   * // remove a specific listener
   * socket.offAny(catchAllListener);
   *
   * // or remove all listeners
   * socket.offAny();
   *
   * @param listener
   */ offAny(listener) {
        if (!this._anyListeners) return this;
        if (listener) {
            const listeners = this._anyListeners;
            for(let i3 = 0; i3 < listeners.length; i3++)if (listener === listeners[i3]) {
                listeners.splice(i3, 1);
                return this;
            }
        } else this._anyListeners = [];
        return this;
    }
    /**
   * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
   * e.g. to remove listeners.
   */ listenersAny() {
        return this._anyListeners || [];
    }
    /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback.
   *
   * Note: acknowledgements sent to the server are not included.
   *
   * @example
   * socket.onAnyOutgoing((event, ...args) => {
   *   console.log(`sent event ${event}`);
   * });
   *
   * @param listener
   */ onAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.push(listener);
        return this;
    }
    /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback. The listener is added to the beginning of the listeners array.
   *
   * Note: acknowledgements sent to the server are not included.
   *
   * @example
   * socket.prependAnyOutgoing((event, ...args) => {
   *   console.log(`sent event ${event}`);
   * });
   *
   * @param listener
   */ prependAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.unshift(listener);
        return this;
    }
    /**
   * Removes the listener that will be fired when any event is emitted.
   *
   * @example
   * const catchAllListener = (event, ...args) => {
   *   console.log(`sent event ${event}`);
   * }
   *
   * socket.onAnyOutgoing(catchAllListener);
   *
   * // remove a specific listener
   * socket.offAnyOutgoing(catchAllListener);
   *
   * // or remove all listeners
   * socket.offAnyOutgoing();
   *
   * @param [listener] - the catch-all listener (optional)
   */ offAnyOutgoing(listener) {
        if (!this._anyOutgoingListeners) return this;
        if (listener) {
            const listeners = this._anyOutgoingListeners;
            for(let i3 = 0; i3 < listeners.length; i3++)if (listener === listeners[i3]) {
                listeners.splice(i3, 1);
                return this;
            }
        } else this._anyOutgoingListeners = [];
        return this;
    }
    /**
   * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
   * e.g. to remove listeners.
   */ listenersAnyOutgoing() {
        return this._anyOutgoingListeners || [];
    }
    /**
   * Notify the listeners for each packet sent
   *
   * @param packet
   *
   * @private
   */ notifyOutgoingListeners(packet) {
        if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
            const listeners = this._anyOutgoingListeners.slice();
            for (const listener of listeners)listener.apply(this, packet.data);
        }
    }
};
// ../node_modules/socket.io-client/build/esm/contrib/backo2.js
function $281a441cdcb2cf36$var$Backoff(opts) {
    opts = opts || {};
    this.ms = opts.min || 100;
    this.max = opts.max || 1e4;
    this.factor = opts.factor || 2;
    this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
    this.attempts = 0;
}
$281a441cdcb2cf36$var$Backoff.prototype.duration = function() {
    var ms = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
        var rand = Math.random();
        var deviation = Math.floor(rand * this.jitter * ms);
        ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
    }
    return Math.min(ms, this.max) | 0;
};
$281a441cdcb2cf36$var$Backoff.prototype.reset = function() {
    this.attempts = 0;
};
$281a441cdcb2cf36$var$Backoff.prototype.setMin = function(min2) {
    this.ms = min2;
};
$281a441cdcb2cf36$var$Backoff.prototype.setMax = function(max2) {
    this.max = max2;
};
$281a441cdcb2cf36$var$Backoff.prototype.setJitter = function(jitter) {
    this.jitter = jitter;
};
// ../node_modules/socket.io-client/build/esm/manager.js
var $281a441cdcb2cf36$var$Manager = class extends $281a441cdcb2cf36$var$Emitter {
    constructor(uri, opts){
        var _a2;
        super();
        this.nsps = {};
        this.subs = [];
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = void 0;
        }
        opts = opts || {};
        opts.path = opts.path || "/socket.io";
        this.opts = opts;
        $281a441cdcb2cf36$var$installTimerFunctions(this, opts);
        this.reconnection(opts.reconnection !== false);
        this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
        this.reconnectionDelay(opts.reconnectionDelay || 1e3);
        this.reconnectionDelayMax(opts.reconnectionDelayMax || 5e3);
        this.randomizationFactor((_a2 = opts.randomizationFactor) !== null && _a2 !== void 0 ? _a2 : 0.5);
        this.backoff = new $281a441cdcb2cf36$var$Backoff({
            min: this.reconnectionDelay(),
            max: this.reconnectionDelayMax(),
            jitter: this.randomizationFactor()
        });
        this.timeout(null == opts.timeout ? 2e4 : opts.timeout);
        this._readyState = "closed";
        this.uri = uri;
        const _parser = opts.parser || $281a441cdcb2cf36$var$esm_exports;
        this.encoder = new _parser.Encoder();
        this.decoder = new _parser.Decoder();
        this._autoConnect = opts.autoConnect !== false;
        if (this._autoConnect) this.open();
    }
    reconnection(v3) {
        if (!arguments.length) return this._reconnection;
        this._reconnection = !!v3;
        if (!v3) this.skipReconnect = true;
        return this;
    }
    reconnectionAttempts(v3) {
        if (v3 === void 0) return this._reconnectionAttempts;
        this._reconnectionAttempts = v3;
        return this;
    }
    reconnectionDelay(v3) {
        var _a2;
        if (v3 === void 0) return this._reconnectionDelay;
        this._reconnectionDelay = v3;
        (_a2 = this.backoff) === null || _a2 === void 0 || _a2.setMin(v3);
        return this;
    }
    randomizationFactor(v3) {
        var _a2;
        if (v3 === void 0) return this._randomizationFactor;
        this._randomizationFactor = v3;
        (_a2 = this.backoff) === null || _a2 === void 0 || _a2.setJitter(v3);
        return this;
    }
    reconnectionDelayMax(v3) {
        var _a2;
        if (v3 === void 0) return this._reconnectionDelayMax;
        this._reconnectionDelayMax = v3;
        (_a2 = this.backoff) === null || _a2 === void 0 || _a2.setMax(v3);
        return this;
    }
    timeout(v3) {
        if (!arguments.length) return this._timeout;
        this._timeout = v3;
        return this;
    }
    /**
   * Starts trying to reconnect if reconnection is enabled and we have not
   * started reconnecting yet
   *
   * @private
   */ maybeReconnectOnOpen() {
        if (!this._reconnecting && this._reconnection && this.backoff.attempts === 0) this.reconnect();
    }
    /**
   * Sets the current transport `socket`.
   *
   * @param {Function} fn - optional, callback
   * @return self
   * @public
   */ open(fn) {
        if (~this._readyState.indexOf("open")) return this;
        this.engine = new $281a441cdcb2cf36$var$Socket(this.uri, this.opts);
        const socket = this.engine;
        const self2 = this;
        this._readyState = "opening";
        this.skipReconnect = false;
        const openSubDestroy = $281a441cdcb2cf36$var$on(socket, "open", function() {
            self2.onopen();
            fn && fn();
        });
        const onError = (err)=>{
            this.cleanup();
            this._readyState = "closed";
            this.emitReserved("error", err);
            if (fn) fn(err);
            else this.maybeReconnectOnOpen();
        };
        const errorSub = $281a441cdcb2cf36$var$on(socket, "error", onError);
        if (false !== this._timeout) {
            const timeout = this._timeout;
            const timer = this.setTimeoutFn(()=>{
                openSubDestroy();
                onError(new Error("timeout"));
                socket.close();
            }, timeout);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
        this.subs.push(openSubDestroy);
        this.subs.push(errorSub);
        return this;
    }
    /**
   * Alias for open()
   *
   * @return self
   * @public
   */ connect(fn) {
        return this.open(fn);
    }
    /**
   * Called upon transport open.
   *
   * @private
   */ onopen() {
        this.cleanup();
        this._readyState = "open";
        this.emitReserved("open");
        const socket = this.engine;
        this.subs.push($281a441cdcb2cf36$var$on(socket, "ping", this.onping.bind(this)), $281a441cdcb2cf36$var$on(socket, "data", this.ondata.bind(this)), $281a441cdcb2cf36$var$on(socket, "error", this.onerror.bind(this)), $281a441cdcb2cf36$var$on(socket, "close", this.onclose.bind(this)), // @ts-ignore
        $281a441cdcb2cf36$var$on(this.decoder, "decoded", this.ondecoded.bind(this)));
    }
    /**
   * Called upon a ping.
   *
   * @private
   */ onping() {
        this.emitReserved("ping");
    }
    /**
   * Called with data.
   *
   * @private
   */ ondata(data2) {
        try {
            this.decoder.add(data2);
        } catch (e4) {
            this.onclose("parse error", e4);
        }
    }
    /**
   * Called when parser fully decodes a packet.
   *
   * @private
   */ ondecoded(packet) {
        $281a441cdcb2cf36$var$nextTick(()=>{
            this.emitReserved("packet", packet);
        }, this.setTimeoutFn);
    }
    /**
   * Called upon socket error.
   *
   * @private
   */ onerror(err) {
        this.emitReserved("error", err);
    }
    /**
   * Creates a new socket for the given `nsp`.
   *
   * @return {Socket}
   * @public
   */ socket(nsp, opts) {
        let socket = this.nsps[nsp];
        if (!socket) {
            socket = new $281a441cdcb2cf36$var$Socket2(this, nsp, opts);
            this.nsps[nsp] = socket;
        } else if (this._autoConnect && !socket.active) socket.connect();
        return socket;
    }
    /**
   * Called upon a socket close.
   *
   * @param socket
   * @private
   */ _destroy(socket) {
        const nsps = Object.keys(this.nsps);
        for (const nsp of nsps){
            const socket2 = this.nsps[nsp];
            if (socket2.active) return;
        }
        this._close();
    }
    /**
   * Writes a packet.
   *
   * @param packet
   * @private
   */ _packet(packet) {
        const encodedPackets = this.encoder.encode(packet);
        for(let i3 = 0; i3 < encodedPackets.length; i3++)this.engine.write(encodedPackets[i3], packet.options);
    }
    /**
   * Clean up transport subscriptions and packet buffer.
   *
   * @private
   */ cleanup() {
        this.subs.forEach((subDestroy)=>subDestroy());
        this.subs.length = 0;
        this.decoder.destroy();
    }
    /**
   * Close the current socket.
   *
   * @private
   */ _close() {
        this.skipReconnect = true;
        this._reconnecting = false;
        this.onclose("forced close");
    }
    /**
   * Alias for close()
   *
   * @private
   */ disconnect() {
        return this._close();
    }
    /**
   * Called when:
   *
   * - the low-level engine is closed
   * - the parser encountered a badly formatted packet
   * - all sockets are disconnected
   *
   * @private
   */ onclose(reason, description) {
        var _a2;
        this.cleanup();
        (_a2 = this.engine) === null || _a2 === void 0 || _a2.close();
        this.backoff.reset();
        this._readyState = "closed";
        this.emitReserved("close", reason, description);
        if (this._reconnection && !this.skipReconnect) this.reconnect();
    }
    /**
   * Attempt a reconnection.
   *
   * @private
   */ reconnect() {
        if (this._reconnecting || this.skipReconnect) return this;
        const self2 = this;
        if (this.backoff.attempts >= this._reconnectionAttempts) {
            this.backoff.reset();
            this.emitReserved("reconnect_failed");
            this._reconnecting = false;
        } else {
            const delay = this.backoff.duration();
            this._reconnecting = true;
            const timer = this.setTimeoutFn(()=>{
                if (self2.skipReconnect) return;
                this.emitReserved("reconnect_attempt", self2.backoff.attempts);
                if (self2.skipReconnect) return;
                self2.open((err)=>{
                    if (err) {
                        self2._reconnecting = false;
                        self2.reconnect();
                        this.emitReserved("reconnect_error", err);
                    } else self2.onreconnect();
                });
            }, delay);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
    }
    /**
   * Called upon successful reconnect.
   *
   * @private
   */ onreconnect() {
        const attempt = this.backoff.attempts;
        this._reconnecting = false;
        this.backoff.reset();
        this.emitReserved("reconnect", attempt);
    }
};
// ../node_modules/socket.io-client/build/esm/index.js
var $281a441cdcb2cf36$var$cache = {};
function $281a441cdcb2cf36$var$lookup2(uri, opts) {
    if (typeof uri === "object") {
        opts = uri;
        uri = void 0;
    }
    opts = opts || {};
    const parsed = $281a441cdcb2cf36$var$url(uri, opts.path || "/socket.io");
    const source = parsed.source;
    const id2 = parsed.id;
    const path = parsed.path;
    const sameNamespace = $281a441cdcb2cf36$var$cache[id2] && path in $281a441cdcb2cf36$var$cache[id2]["nsps"];
    const newConnection = opts.forceNew || opts["force new connection"] || false === opts.multiplex || sameNamespace;
    let io;
    if (newConnection) io = new $281a441cdcb2cf36$var$Manager(source, opts);
    else {
        if (!$281a441cdcb2cf36$var$cache[id2]) $281a441cdcb2cf36$var$cache[id2] = new $281a441cdcb2cf36$var$Manager(source, opts);
        io = $281a441cdcb2cf36$var$cache[id2];
    }
    if (parsed.query && !opts.query) opts.query = parsed.queryKey;
    return io.socket(parsed.path, opts);
}
Object.assign($281a441cdcb2cf36$var$lookup2, {
    Manager: $281a441cdcb2cf36$var$Manager,
    Socket: $281a441cdcb2cf36$var$Socket2,
    io: $281a441cdcb2cf36$var$lookup2,
    connect: $281a441cdcb2cf36$var$lookup2
});
// src/utils/CollabClient.js
$281a441cdcb2cf36$var$init_yjs();
// ../node_modules/nanoid/url-alphabet/index.js
var $281a441cdcb2cf36$var$urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
// ../node_modules/nanoid/index.browser.js
var $281a441cdcb2cf36$var$nanoid = (size2 = 21)=>{
    let id2 = "";
    let bytes = crypto.getRandomValues(new Uint8Array(size2 |= 0));
    while(size2--)id2 += $281a441cdcb2cf36$var$urlAlphabet[bytes[size2] & 63];
    return id2;
};
// src/utils/jsonDiff.js
$281a441cdcb2cf36$var$init_yjs();
function $281a441cdcb2cf36$var$isPlainObject(o3) {
    return o3 && typeof o3 === "object" && !Array.isArray(o3);
}
function $281a441cdcb2cf36$var$deepEqual(a3, b3) {
    if (Object.is(a3, b3)) return true;
    if (typeof a3 === "function" && typeof b3 === "function") try {
        return a3.toString() === b3.toString();
    } catch  {
        return false;
    }
    if (typeof a3 === "function" || typeof b3 === "function") return false;
    if (a3 instanceof Date && b3 instanceof Date) return a3.getTime() === b3.getTime();
    if (a3 instanceof RegExp && b3 instanceof RegExp) return String(a3) === String(b3);
    if (Array.isArray(a3) && Array.isArray(b3)) {
        if (a3.length !== b3.length) return false;
        for(let i3 = 0; i3 < a3.length; i3++){
            if (!$281a441cdcb2cf36$var$deepEqual(a3[i3], b3[i3])) return false;
        }
        return true;
    }
    if (a3 && b3 && typeof a3 === "object" && typeof b3 === "object") {
        const aKeys = Object.keys(a3);
        const bKeys = Object.keys(b3);
        if (aKeys.length !== bKeys.length) return false;
        for(let i3 = 0; i3 < aKeys.length; i3++){
            const key = aKeys[i3];
            if (!Object.hasOwn(b3, key)) return false;
            if (!$281a441cdcb2cf36$var$deepEqual(a3[key], b3[key])) return false;
        }
        return true;
    }
    return false;
}
function $281a441cdcb2cf36$var$getRootMap(ydoc) {
    return ydoc.getMap("root");
}
function $281a441cdcb2cf36$var$diffJson(prev, next, prefix = []) {
    const ops = [];
    const _prefix = Array.isArray(prefix) ? prefix : [];
    for(const key in prev)if (Object.hasOwn(prev, key) && !(key in next)) ops.push({
        action: "del",
        path: [
            ..._prefix,
            key
        ]
    });
    for(const key in next)if (Object.hasOwn(next, key)) {
        const pVal = prev == null ? void 0 : prev[key];
        const nVal = next[key];
        if ($281a441cdcb2cf36$var$isPlainObject(pVal) && $281a441cdcb2cf36$var$isPlainObject(nVal)) ops.push(...$281a441cdcb2cf36$var$diffJson(pVal, nVal, [
            ..._prefix,
            key
        ]));
        else if (!$281a441cdcb2cf36$var$deepEqual(pVal, nVal)) ops.push({
            action: "set",
            path: [
                ..._prefix,
                key
            ],
            value: nVal
        });
    }
    return ops;
}
function $281a441cdcb2cf36$var$applyOpsToJson(ops, ydoc) {
    if (!ydoc || !Array.isArray(ops) || !ops.length) return;
    ydoc.transact(()=>{
        const root = $281a441cdcb2cf36$var$getRootMap(ydoc);
        ops.forEach((op)=>{
            const { action: action, path: path = [], value: value2 } = op || {};
            if (!path.length) return;
            let target = root;
            for(let i3 = 0; i3 < path.length - 1; i3++){
                const key = path[i3];
                let next = target.get(key);
                if (!(next instanceof $281a441cdcb2cf36$var$YMap)) {
                    const fresh = new $281a441cdcb2cf36$var$YMap();
                    if ($281a441cdcb2cf36$var$isPlainObject(next)) Object.entries(next).forEach(([k3, v3])=>fresh.set(k3, v3));
                    target.set(key, fresh);
                    next = fresh;
                }
                target = next;
            }
            const last2 = path[path.length - 1];
            if (action === "set") target.set(last2, value2);
            else if (action === "del") target.delete(last2);
        });
    }, "remote");
}
// src/utils/CollabClient.js
var $281a441cdcb2cf36$var$CollabClient = class {
    constructor({ jwt: jwt, projectId: projectId, branch: branch = "main", live: live = false }){
        /* public fields */ $281a441cdcb2cf36$var$__publicField(this, "socket", null);
        $281a441cdcb2cf36$var$__publicField(this, "ydoc", null);
        $281a441cdcb2cf36$var$__publicField(this, "branch", "main");
        $281a441cdcb2cf36$var$__publicField(this, "live", false);
        $281a441cdcb2cf36$var$__publicField(this, "projectId", null);
        $281a441cdcb2cf36$var$__publicField(this, "jwt", null);
        /* private state */ $281a441cdcb2cf36$var$__publicField(this, "_buffer", []);
        $281a441cdcb2cf36$var$__publicField(this, "_flushTimer", null);
        $281a441cdcb2cf36$var$__publicField(this, "_clientId", $281a441cdcb2cf36$var$nanoid());
        $281a441cdcb2cf36$var$__publicField(this, "_outboxStore", $281a441cdcb2cf36$var$createMemoryOutbox());
        // Dexie table fallback
        $281a441cdcb2cf36$var$__publicField(this, "_readyResolve");
        $281a441cdcb2cf36$var$__publicField(this, "ready", new Promise((res)=>this._readyResolve = res));
        /* ---------- private handlers ---------- */ $281a441cdcb2cf36$var$__publicField(this, "_onSnapshot", ({ data: data2 })=>{
            if (Array.isArray(data2) ? data2.length : data2 && data2.byteLength) $281a441cdcb2cf36$var$applyUpdate(this.ydoc, Uint8Array.from(data2));
            else $281a441cdcb2cf36$var$logger.warn("[collab] Received empty snapshot \u2013 skipping applyUpdate");
            this._prevJson = this.ydoc.getMap("root").toJSON();
            if (typeof this._readyResolve === "function") {
                this._readyResolve();
                this._readyResolve = null;
            }
        });
        $281a441cdcb2cf36$var$__publicField(this, "_onOps", ({ changes: changes })=>{
            $281a441cdcb2cf36$var$applyOpsToJson(changes, this.ydoc);
            this._prevJson = this.ydoc.getMap("root").toJSON();
        });
        $281a441cdcb2cf36$var$__publicField(this, "_onCommit", async ({ version: version6 })=>{
            await this._outboxStore.clear();
            $281a441cdcb2cf36$var$logger.log("[collab] committed", version6);
        });
        $281a441cdcb2cf36$var$__publicField(this, "_onConnect", async ()=>{
            if (typeof this._readyResolve === "function") {
                this._readyResolve();
                this._readyResolve = null;
            }
            const queued = await this._outboxStore.toArray();
            if (queued.length) {
                this.socket.emit("ops", {
                    changes: queued.flatMap((e4)=>e4.ops),
                    ts: Date.now(),
                    clientId: this._clientId
                });
                await this._outboxStore.clear();
            }
        });
        $281a441cdcb2cf36$var$__publicField(this, "_onLiveMode", (flag)=>{
            this.live = flag;
        });
        $281a441cdcb2cf36$var$__publicField(this, "_onError", (e4)=>{
            $281a441cdcb2cf36$var$logger.warn("[collab] socket error", e4);
        });
        Object.assign(this, {
            jwt: jwt,
            projectId: projectId,
            branch: branch,
            live: live
        });
        this.ydoc = new $281a441cdcb2cf36$var$Doc();
        const hasIndexedDB = typeof globalThis.indexedDB !== "undefined";
        if (typeof window === "undefined" || !hasIndexedDB) $281a441cdcb2cf36$var$logger.log("[CollabClient] IndexedDB not available \u2013 skipping offline persistence");
        else Promise.resolve().then(()=>($281a441cdcb2cf36$var$init_y_indexeddb(), $281a441cdcb2cf36$var$y_indexeddb_exports)).then(({ IndexeddbPersistence: IndexeddbPersistence2 })=>{
            new IndexeddbPersistence2(`${projectId}:${branch}`, this.ydoc);
        }).catch((err)=>{
            $281a441cdcb2cf36$var$logger.warn("[CollabClient] Failed to load IndexeddbPersistence:", err);
        });
        if (typeof window !== "undefined" && hasIndexedDB) $281a441cdcb2cf36$var$createDexieOutbox(`${projectId}:${branch}`).then((outboxStore)=>{
            this._outboxStore = outboxStore;
        }).catch((err)=>{
            $281a441cdcb2cf36$var$logger.warn("[CollabClient] Failed to load Dexie:", err);
        });
        this.socket = $281a441cdcb2cf36$var$lookup2($281a441cdcb2cf36$export$6bc7b24d4e862158.socketUrl, {
            path: "/collab-socket",
            transports: [
                "websocket"
            ],
            auth: {
                token: jwt,
                projectId: projectId,
                branch: branch,
                live: live
            },
            reconnectionAttempts: Infinity,
            reconnectionDelayMax: 4e3
        });
        this.socket.on("snapshot", this._onSnapshot).on("ops", this._onOps).on("commit", this._onCommit).on("liveMode", this._onLiveMode).on("connect", this._onConnect).on("error", this._onError);
        this._prevJson = this.ydoc.getMap("root").toJSON();
        this.ydoc.on("afterTransaction", (tr)=>{
            if (tr.origin === "remote") return;
            const currentJson = this.ydoc.getMap("root").toJSON();
            const ops = $281a441cdcb2cf36$var$diffJson(this._prevJson, currentJson);
            this._prevJson = currentJson;
            if (!ops.length) return;
            this._queueOps(ops);
        });
    }
    /* ---------- public helpers ---------- */ toggleLive(flag) {
        this.socket.emit("toggleLive", Boolean(flag));
    }
    sendCursor(data2) {
        this.socket.emit("cursor", data2);
    }
    sendPresence(d3) {
        this.socket.emit("presence", d3);
    }
    /* ---------- buffering & debounce ---------- */ _queueOps(ops) {
        this._buffer.push(...ops);
        this._outboxStore.put({
            id: $281a441cdcb2cf36$var$nanoid(),
            ops: ops
        });
        if (this.live && this.socket.connected) this._flushNow();
        else {
            clearTimeout(this._flushTimer);
            this._flushTimer = setTimeout(()=>this._flushNow(), 40);
        }
    }
    _flushNow() {
        if (!this._buffer.length || !this.socket.connected) return;
        this.socket.emit("ops", {
            changes: this._buffer,
            ts: Date.now(),
            clientId: this._clientId
        });
        this._buffer.length = 0;
    }
    dispose() {
        var _a2;
        clearTimeout(this._flushTimer);
        this._flushTimer = null;
        this._buffer.length = 0;
        if ((_a2 = this._outboxStore) == null ? void 0 : _a2.clear) try {
            const result = this._outboxStore.clear();
            if (result && typeof result.catch === "function") result.catch(()=>{});
        } catch (error) {
            $281a441cdcb2cf36$var$logger.warn("[CollabClient] Failed to clear outbox store during dispose:", error);
        }
        if (this.socket) {
            this.socket.off("snapshot", this._onSnapshot);
            this.socket.off("ops", this._onOps);
            this.socket.off("commit", this._onCommit);
            this.socket.off("liveMode", this._onLiveMode);
            this.socket.off("connect", this._onConnect);
            this.socket.off("error", this._onError);
            this.socket.removeAllListeners();
            this.socket.disconnect();
            this.socket = null;
        }
        if (this.ydoc) {
            this.ydoc.destroy();
            this.ydoc = null;
        }
        if (typeof this._readyResolve === "function") {
            this._readyResolve();
            this._readyResolve = null;
        }
    }
};
function $281a441cdcb2cf36$var$createMemoryOutbox() {
    const store = /* @__PURE__ */ new Map();
    return {
        put: (item)=>store.set(item.id, item),
        toArray: ()=>Array.from(store.values()),
        clear: ()=>store.clear()
    };
}
async function $281a441cdcb2cf36$var$createDexieOutbox(name) {
    const { default: Dexie2 } = await Promise.resolve().then(()=>($281a441cdcb2cf36$var$init_import_wrapper(), $281a441cdcb2cf36$var$import_wrapper_exports));
    const db = new Dexie2(`collab-${name}`);
    db.version(1).stores({
        outbox: "id, ops"
    });
    return db.table("outbox");
}
// src/state/rootEventBus.js
var $281a441cdcb2cf36$var$getGlobalBus = ()=>{
    if (globalThis.__SMBLS_ROOT_BUS__) return globalThis.__SMBLS_ROOT_BUS__;
    const events = {};
    const lastPayloads = {};
    const bus = {
        on (event, handler) {
            (events[event] || (events[event] = [])).push(handler);
            if (Object.hasOwn(lastPayloads, event)) try {
                handler(lastPayloads[event]);
            } catch (err) {
                $281a441cdcb2cf36$var$logger.error("[rootBus] handler error for (replay)", event, err);
            }
        },
        off (event, handler) {
            const list = events[event];
            if (!list) return;
            const idx = list.indexOf(handler);
            if (idx !== -1) list.splice(idx, 1);
        },
        emit (event, payload) {
            lastPayloads[event] = payload;
            const list = events[event];
            if (!list || !list.length) return;
            list.slice().forEach((fn)=>{
                try {
                    fn(payload);
                } catch (err) {
                    $281a441cdcb2cf36$var$logger.error("[rootBus] handler error for", event, err);
                }
            });
        }
    };
    Object.defineProperty(bus, "_listeners", {
        value: events,
        enumerable: false
    });
    globalThis.__SMBLS_ROOT_BUS__ = bus;
    return bus;
};
var $281a441cdcb2cf36$var$rootBus = $281a441cdcb2cf36$var$getGlobalBus();
// src/state/RootStateManager.js
var { isFunction: $281a441cdcb2cf36$var$isFunction } = $2oe0q.default || $2oe0q;
var $281a441cdcb2cf36$var$RootStateManager = class {
    constructor(rootState){
        this._rootState = rootState;
    }
    /**
   * Apply change tuples to the root state using the built-in setPathCollection
   * of Symbo.ls APP state tree.
   *
   * @param {Array} changes – eg. ['update', ['foo'], 'bar']
   * @param {Object} opts   – forwarded to setPathCollection
   */ async applyChanges(changes = [], opts = {}) {
        if (!this._rootState || !$281a441cdcb2cf36$var$isFunction(this._rootState.setPathCollection)) return;
        const result = await this._rootState.setPathCollection(changes, {
            preventUpdate: true,
            ...opts
        });
        return result;
    }
    setVersion(v3) {
        if (this._rootState) this._rootState.version = v3;
    }
    get root() {
        return this._rootState;
    }
};
// ../node_modules/acorn/dist/acorn.mjs
var $281a441cdcb2cf36$var$astralIdentifierCodes = [
    509,
    0,
    227,
    0,
    150,
    4,
    294,
    9,
    1368,
    2,
    2,
    1,
    6,
    3,
    41,
    2,
    5,
    0,
    166,
    1,
    574,
    3,
    9,
    9,
    7,
    9,
    32,
    4,
    318,
    1,
    78,
    5,
    71,
    10,
    50,
    3,
    123,
    2,
    54,
    14,
    32,
    10,
    3,
    1,
    11,
    3,
    46,
    10,
    8,
    0,
    46,
    9,
    7,
    2,
    37,
    13,
    2,
    9,
    6,
    1,
    45,
    0,
    13,
    2,
    49,
    13,
    9,
    3,
    2,
    11,
    83,
    11,
    7,
    0,
    3,
    0,
    158,
    11,
    6,
    9,
    7,
    3,
    56,
    1,
    2,
    6,
    3,
    1,
    3,
    2,
    10,
    0,
    11,
    1,
    3,
    6,
    4,
    4,
    68,
    8,
    2,
    0,
    3,
    0,
    2,
    3,
    2,
    4,
    2,
    0,
    15,
    1,
    83,
    17,
    10,
    9,
    5,
    0,
    82,
    19,
    13,
    9,
    214,
    6,
    3,
    8,
    28,
    1,
    83,
    16,
    16,
    9,
    82,
    12,
    9,
    9,
    7,
    19,
    58,
    14,
    5,
    9,
    243,
    14,
    166,
    9,
    71,
    5,
    2,
    1,
    3,
    3,
    2,
    0,
    2,
    1,
    13,
    9,
    120,
    6,
    3,
    6,
    4,
    0,
    29,
    9,
    41,
    6,
    2,
    3,
    9,
    0,
    10,
    10,
    47,
    15,
    199,
    7,
    137,
    9,
    54,
    7,
    2,
    7,
    17,
    9,
    57,
    21,
    2,
    13,
    123,
    5,
    4,
    0,
    2,
    1,
    2,
    6,
    2,
    0,
    9,
    9,
    49,
    4,
    2,
    1,
    2,
    4,
    9,
    9,
    55,
    9,
    266,
    3,
    10,
    1,
    2,
    0,
    49,
    6,
    4,
    4,
    14,
    10,
    5350,
    0,
    7,
    14,
    11465,
    27,
    2343,
    9,
    87,
    9,
    39,
    4,
    60,
    6,
    26,
    9,
    535,
    9,
    470,
    0,
    2,
    54,
    8,
    3,
    82,
    0,
    12,
    1,
    19628,
    1,
    4178,
    9,
    519,
    45,
    3,
    22,
    543,
    4,
    4,
    5,
    9,
    7,
    3,
    6,
    31,
    3,
    149,
    2,
    1418,
    49,
    513,
    54,
    5,
    49,
    9,
    0,
    15,
    0,
    23,
    4,
    2,
    14,
    1361,
    6,
    2,
    16,
    3,
    6,
    2,
    1,
    2,
    4,
    101,
    0,
    161,
    6,
    10,
    9,
    357,
    0,
    62,
    13,
    499,
    13,
    245,
    1,
    2,
    9,
    233,
    0,
    3,
    0,
    8,
    1,
    6,
    0,
    475,
    6,
    110,
    6,
    6,
    9,
    4759,
    9,
    787719,
    239
];
var $281a441cdcb2cf36$var$astralIdentifierStartCodes = [
    0,
    11,
    2,
    25,
    2,
    18,
    2,
    1,
    2,
    14,
    3,
    13,
    35,
    122,
    70,
    52,
    268,
    28,
    4,
    48,
    48,
    31,
    14,
    29,
    6,
    37,
    11,
    29,
    3,
    35,
    5,
    7,
    2,
    4,
    43,
    157,
    19,
    35,
    5,
    35,
    5,
    39,
    9,
    51,
    13,
    10,
    2,
    14,
    2,
    6,
    2,
    1,
    2,
    10,
    2,
    14,
    2,
    6,
    2,
    1,
    4,
    51,
    13,
    310,
    10,
    21,
    11,
    7,
    25,
    5,
    2,
    41,
    2,
    8,
    70,
    5,
    3,
    0,
    2,
    43,
    2,
    1,
    4,
    0,
    3,
    22,
    11,
    22,
    10,
    30,
    66,
    18,
    2,
    1,
    11,
    21,
    11,
    25,
    7,
    25,
    39,
    55,
    7,
    1,
    65,
    0,
    16,
    3,
    2,
    2,
    2,
    28,
    43,
    28,
    4,
    28,
    36,
    7,
    2,
    27,
    28,
    53,
    11,
    21,
    11,
    18,
    14,
    17,
    111,
    72,
    56,
    50,
    14,
    50,
    14,
    35,
    39,
    27,
    10,
    22,
    251,
    41,
    7,
    1,
    17,
    5,
    57,
    28,
    11,
    0,
    9,
    21,
    43,
    17,
    47,
    20,
    28,
    22,
    13,
    52,
    58,
    1,
    3,
    0,
    14,
    44,
    33,
    24,
    27,
    35,
    30,
    0,
    3,
    0,
    9,
    34,
    4,
    0,
    13,
    47,
    15,
    3,
    22,
    0,
    2,
    0,
    36,
    17,
    2,
    24,
    20,
    1,
    64,
    6,
    2,
    0,
    2,
    3,
    2,
    14,
    2,
    9,
    8,
    46,
    39,
    7,
    3,
    1,
    3,
    21,
    2,
    6,
    2,
    1,
    2,
    4,
    4,
    0,
    19,
    0,
    13,
    4,
    31,
    9,
    2,
    0,
    3,
    0,
    2,
    37,
    2,
    0,
    26,
    0,
    2,
    0,
    45,
    52,
    19,
    3,
    21,
    2,
    31,
    47,
    21,
    1,
    2,
    0,
    185,
    46,
    42,
    3,
    37,
    47,
    21,
    0,
    60,
    42,
    14,
    0,
    72,
    26,
    38,
    6,
    186,
    43,
    117,
    63,
    32,
    7,
    3,
    0,
    3,
    7,
    2,
    1,
    2,
    23,
    16,
    0,
    2,
    0,
    95,
    7,
    3,
    38,
    17,
    0,
    2,
    0,
    29,
    0,
    11,
    39,
    8,
    0,
    22,
    0,
    12,
    45,
    20,
    0,
    19,
    72,
    200,
    32,
    32,
    8,
    2,
    36,
    18,
    0,
    50,
    29,
    113,
    6,
    2,
    1,
    2,
    37,
    22,
    0,
    26,
    5,
    2,
    1,
    2,
    31,
    15,
    0,
    24,
    43,
    261,
    18,
    16,
    0,
    2,
    12,
    2,
    33,
    125,
    0,
    80,
    921,
    103,
    110,
    18,
    195,
    2637,
    96,
    16,
    1071,
    18,
    5,
    26,
    3994,
    6,
    582,
    6842,
    29,
    1763,
    568,
    8,
    30,
    18,
    78,
    18,
    29,
    19,
    47,
    17,
    3,
    32,
    20,
    6,
    18,
    433,
    44,
    212,
    63,
    33,
    24,
    3,
    24,
    45,
    74,
    6,
    0,
    67,
    12,
    65,
    1,
    2,
    0,
    15,
    4,
    10,
    7381,
    42,
    31,
    98,
    114,
    8702,
    3,
    2,
    6,
    2,
    1,
    2,
    290,
    16,
    0,
    30,
    2,
    3,
    0,
    15,
    3,
    9,
    395,
    2309,
    106,
    6,
    12,
    4,
    8,
    8,
    9,
    5991,
    84,
    2,
    70,
    2,
    1,
    3,
    0,
    3,
    1,
    3,
    3,
    2,
    11,
    2,
    0,
    2,
    6,
    2,
    64,
    2,
    3,
    3,
    7,
    2,
    6,
    2,
    27,
    2,
    3,
    2,
    4,
    2,
    0,
    4,
    6,
    2,
    339,
    3,
    24,
    2,
    24,
    2,
    30,
    2,
    24,
    2,
    30,
    2,
    24,
    2,
    30,
    2,
    24,
    2,
    30,
    2,
    24,
    2,
    7,
    1845,
    30,
    7,
    5,
    262,
    61,
    147,
    44,
    11,
    6,
    17,
    0,
    322,
    29,
    19,
    43,
    485,
    27,
    229,
    29,
    3,
    0,
    208,
    30,
    2,
    2,
    2,
    1,
    2,
    6,
    3,
    4,
    10,
    1,
    225,
    6,
    2,
    3,
    2,
    1,
    2,
    14,
    2,
    196,
    60,
    67,
    8,
    0,
    1205,
    3,
    2,
    26,
    2,
    1,
    2,
    0,
    3,
    0,
    2,
    9,
    2,
    3,
    2,
    0,
    2,
    0,
    7,
    0,
    5,
    0,
    2,
    0,
    2,
    0,
    2,
    2,
    2,
    1,
    2,
    0,
    3,
    0,
    2,
    0,
    2,
    0,
    2,
    0,
    2,
    0,
    2,
    1,
    2,
    0,
    3,
    3,
    2,
    6,
    2,
    3,
    2,
    3,
    2,
    0,
    2,
    9,
    2,
    16,
    6,
    2,
    2,
    4,
    2,
    16,
    4421,
    42719,
    33,
    4381,
    3,
    5773,
    3,
    7472,
    16,
    621,
    2467,
    541,
    1507,
    4938,
    6,
    8489
];
var $281a441cdcb2cf36$var$nonASCIIidentifierChars = "\u200C\u200D\xB7\u0300-\u036F\u0387\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u0669\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u06F0-\u06F9\u0711\u0730-\u074A\u07A6-\u07B0\u07C0-\u07C9\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u0897-\u089F\u08CA-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0966-\u096F\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09E6-\u09EF\u09FE\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A66-\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AE6-\u0AEF\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B66-\u0B6F\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0BE6-\u0BEF\u0C00-\u0C04\u0C3C\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C66-\u0C6F\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0CE6-\u0CEF\u0CF3\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D66-\u0D6F\u0D81-\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0E50-\u0E59\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECE\u0ED0-\u0ED9\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1040-\u1049\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F-\u109D\u135D-\u135F\u1369-\u1371\u1712-\u1715\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u17E0-\u17E9\u180B-\u180D\u180F-\u1819\u18A9\u1920-\u192B\u1930-\u193B\u1946-\u194F\u19D0-\u19DA\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AB0-\u1ABD\u1ABF-\u1ADD\u1AE0-\u1AEB\u1B00-\u1B04\u1B34-\u1B44\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BB0-\u1BB9\u1BE6-\u1BF3\u1C24-\u1C37\u1C40-\u1C49\u1C50-\u1C59\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DFF\u200C\u200D\u203F\u2040\u2054\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\u30FB\uA620-\uA629\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA82C\uA880\uA881\uA8B4-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F1\uA8FF-\uA909\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9D0-\uA9D9\uA9E5\uA9F0-\uA9F9\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA50-\uAA59\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uABF0-\uABF9\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFF10-\uFF19\uFF3F\uFF65";
var $281a441cdcb2cf36$var$nonASCIIidentifierStartChars = "\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088F\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5C\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDC-\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C8A\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7DC\uA7F1-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC";
var $281a441cdcb2cf36$var$reservedWords = {
    3: "abstract boolean byte char class double enum export extends final float goto implements import int interface long native package private protected public short static super synchronized throws transient volatile",
    5: "class enum extends super const export import",
    6: "enum",
    strict: "implements interface let package private protected public static yield",
    strictBind: "eval arguments"
};
var $281a441cdcb2cf36$var$ecma5AndLessKeywords = "break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this";
var $281a441cdcb2cf36$var$keywords$1 = {
    5: $281a441cdcb2cf36$var$ecma5AndLessKeywords,
    "5module": $281a441cdcb2cf36$var$ecma5AndLessKeywords + " export import",
    6: $281a441cdcb2cf36$var$ecma5AndLessKeywords + " const class extends export import super"
};
var $281a441cdcb2cf36$var$keywordRelationalOperator = /^in(stanceof)?$/;
var $281a441cdcb2cf36$var$nonASCIIidentifierStart = new RegExp("[" + $281a441cdcb2cf36$var$nonASCIIidentifierStartChars + "]");
var $281a441cdcb2cf36$var$nonASCIIidentifier = new RegExp("[" + $281a441cdcb2cf36$var$nonASCIIidentifierStartChars + $281a441cdcb2cf36$var$nonASCIIidentifierChars + "]");
function $281a441cdcb2cf36$var$isInAstralSet(code, set) {
    var pos = 65536;
    for(var i3 = 0; i3 < set.length; i3 += 2){
        pos += set[i3];
        if (pos > code) return false;
        pos += set[i3 + 1];
        if (pos >= code) return true;
    }
    return false;
}
function $281a441cdcb2cf36$var$isIdentifierStart(code, astral) {
    if (code < 65) return code === 36;
    if (code < 91) return true;
    if (code < 97) return code === 95;
    if (code < 123) return true;
    if (code <= 65535) return code >= 170 && $281a441cdcb2cf36$var$nonASCIIidentifierStart.test(String.fromCharCode(code));
    if (astral === false) return false;
    return $281a441cdcb2cf36$var$isInAstralSet(code, $281a441cdcb2cf36$var$astralIdentifierStartCodes);
}
function $281a441cdcb2cf36$var$isIdentifierChar(code, astral) {
    if (code < 48) return code === 36;
    if (code < 58) return true;
    if (code < 65) return false;
    if (code < 91) return true;
    if (code < 97) return code === 95;
    if (code < 123) return true;
    if (code <= 65535) return code >= 170 && $281a441cdcb2cf36$var$nonASCIIidentifier.test(String.fromCharCode(code));
    if (astral === false) return false;
    return $281a441cdcb2cf36$var$isInAstralSet(code, $281a441cdcb2cf36$var$astralIdentifierStartCodes) || $281a441cdcb2cf36$var$isInAstralSet(code, $281a441cdcb2cf36$var$astralIdentifierCodes);
}
var $281a441cdcb2cf36$var$TokenType = function TokenType2(label, conf) {
    if (conf === void 0) conf = {};
    this.label = label;
    this.keyword = conf.keyword;
    this.beforeExpr = !!conf.beforeExpr;
    this.startsExpr = !!conf.startsExpr;
    this.isLoop = !!conf.isLoop;
    this.isAssign = !!conf.isAssign;
    this.prefix = !!conf.prefix;
    this.postfix = !!conf.postfix;
    this.binop = conf.binop || null;
    this.updateContext = null;
};
function $281a441cdcb2cf36$var$binop(name, prec) {
    return new $281a441cdcb2cf36$var$TokenType(name, {
        beforeExpr: true,
        binop: prec
    });
}
var $281a441cdcb2cf36$var$beforeExpr = {
    beforeExpr: true
};
var $281a441cdcb2cf36$var$startsExpr = {
    startsExpr: true
};
var $281a441cdcb2cf36$var$keywords = {};
function $281a441cdcb2cf36$var$kw(name, options) {
    if (options === void 0) options = {};
    options.keyword = name;
    return $281a441cdcb2cf36$var$keywords[name] = new $281a441cdcb2cf36$var$TokenType(name, options);
}
var $281a441cdcb2cf36$var$types$1 = {
    num: new $281a441cdcb2cf36$var$TokenType("num", $281a441cdcb2cf36$var$startsExpr),
    regexp: new $281a441cdcb2cf36$var$TokenType("regexp", $281a441cdcb2cf36$var$startsExpr),
    string: new $281a441cdcb2cf36$var$TokenType("string", $281a441cdcb2cf36$var$startsExpr),
    name: new $281a441cdcb2cf36$var$TokenType("name", $281a441cdcb2cf36$var$startsExpr),
    privateId: new $281a441cdcb2cf36$var$TokenType("privateId", $281a441cdcb2cf36$var$startsExpr),
    eof: new $281a441cdcb2cf36$var$TokenType("eof"),
    // Punctuation token types.
    bracketL: new $281a441cdcb2cf36$var$TokenType("[", {
        beforeExpr: true,
        startsExpr: true
    }),
    bracketR: new $281a441cdcb2cf36$var$TokenType("]"),
    braceL: new $281a441cdcb2cf36$var$TokenType("{", {
        beforeExpr: true,
        startsExpr: true
    }),
    braceR: new $281a441cdcb2cf36$var$TokenType("}"),
    parenL: new $281a441cdcb2cf36$var$TokenType("(", {
        beforeExpr: true,
        startsExpr: true
    }),
    parenR: new $281a441cdcb2cf36$var$TokenType(")"),
    comma: new $281a441cdcb2cf36$var$TokenType(",", $281a441cdcb2cf36$var$beforeExpr),
    semi: new $281a441cdcb2cf36$var$TokenType(";", $281a441cdcb2cf36$var$beforeExpr),
    colon: new $281a441cdcb2cf36$var$TokenType(":", $281a441cdcb2cf36$var$beforeExpr),
    dot: new $281a441cdcb2cf36$var$TokenType("."),
    question: new $281a441cdcb2cf36$var$TokenType("?", $281a441cdcb2cf36$var$beforeExpr),
    questionDot: new $281a441cdcb2cf36$var$TokenType("?."),
    arrow: new $281a441cdcb2cf36$var$TokenType("=>", $281a441cdcb2cf36$var$beforeExpr),
    template: new $281a441cdcb2cf36$var$TokenType("template"),
    invalidTemplate: new $281a441cdcb2cf36$var$TokenType("invalidTemplate"),
    ellipsis: new $281a441cdcb2cf36$var$TokenType("...", $281a441cdcb2cf36$var$beforeExpr),
    backQuote: new $281a441cdcb2cf36$var$TokenType("`", $281a441cdcb2cf36$var$startsExpr),
    dollarBraceL: new $281a441cdcb2cf36$var$TokenType("${", {
        beforeExpr: true,
        startsExpr: true
    }),
    // Operators. These carry several kinds of properties to help the
    // parser use them properly (the presence of these properties is
    // what categorizes them as operators).
    //
    // `binop`, when present, specifies that this operator is a binary
    // operator, and will refer to its precedence.
    //
    // `prefix` and `postfix` mark the operator as a prefix or postfix
    // unary operator.
    //
    // `isAssign` marks all of `=`, `+=`, `-=` etcetera, which act as
    // binary operators with a very low precedence, that should result
    // in AssignmentExpression nodes.
    eq: new $281a441cdcb2cf36$var$TokenType("=", {
        beforeExpr: true,
        isAssign: true
    }),
    assign: new $281a441cdcb2cf36$var$TokenType("_=", {
        beforeExpr: true,
        isAssign: true
    }),
    incDec: new $281a441cdcb2cf36$var$TokenType("++/--", {
        prefix: true,
        postfix: true,
        startsExpr: true
    }),
    prefix: new $281a441cdcb2cf36$var$TokenType("!/~", {
        beforeExpr: true,
        prefix: true,
        startsExpr: true
    }),
    logicalOR: $281a441cdcb2cf36$var$binop("||", 1),
    logicalAND: $281a441cdcb2cf36$var$binop("&&", 2),
    bitwiseOR: $281a441cdcb2cf36$var$binop("|", 3),
    bitwiseXOR: $281a441cdcb2cf36$var$binop("^", 4),
    bitwiseAND: $281a441cdcb2cf36$var$binop("&", 5),
    equality: $281a441cdcb2cf36$var$binop("==/!=/===/!==", 6),
    relational: $281a441cdcb2cf36$var$binop("</>/<=/>=", 7),
    bitShift: $281a441cdcb2cf36$var$binop("<</>>/>>>", 8),
    plusMin: new $281a441cdcb2cf36$var$TokenType("+/-", {
        beforeExpr: true,
        binop: 9,
        prefix: true,
        startsExpr: true
    }),
    modulo: $281a441cdcb2cf36$var$binop("%", 10),
    star: $281a441cdcb2cf36$var$binop("*", 10),
    slash: $281a441cdcb2cf36$var$binop("/", 10),
    starstar: new $281a441cdcb2cf36$var$TokenType("**", {
        beforeExpr: true
    }),
    coalesce: $281a441cdcb2cf36$var$binop("??", 1),
    // Keyword token types.
    _break: $281a441cdcb2cf36$var$kw("break"),
    _case: $281a441cdcb2cf36$var$kw("case", $281a441cdcb2cf36$var$beforeExpr),
    _catch: $281a441cdcb2cf36$var$kw("catch"),
    _continue: $281a441cdcb2cf36$var$kw("continue"),
    _debugger: $281a441cdcb2cf36$var$kw("debugger"),
    _default: $281a441cdcb2cf36$var$kw("default", $281a441cdcb2cf36$var$beforeExpr),
    _do: $281a441cdcb2cf36$var$kw("do", {
        isLoop: true,
        beforeExpr: true
    }),
    _else: $281a441cdcb2cf36$var$kw("else", $281a441cdcb2cf36$var$beforeExpr),
    _finally: $281a441cdcb2cf36$var$kw("finally"),
    _for: $281a441cdcb2cf36$var$kw("for", {
        isLoop: true
    }),
    _function: $281a441cdcb2cf36$var$kw("function", $281a441cdcb2cf36$var$startsExpr),
    _if: $281a441cdcb2cf36$var$kw("if"),
    _return: $281a441cdcb2cf36$var$kw("return", $281a441cdcb2cf36$var$beforeExpr),
    _switch: $281a441cdcb2cf36$var$kw("switch"),
    _throw: $281a441cdcb2cf36$var$kw("throw", $281a441cdcb2cf36$var$beforeExpr),
    _try: $281a441cdcb2cf36$var$kw("try"),
    _var: $281a441cdcb2cf36$var$kw("var"),
    _const: $281a441cdcb2cf36$var$kw("const"),
    _while: $281a441cdcb2cf36$var$kw("while", {
        isLoop: true
    }),
    _with: $281a441cdcb2cf36$var$kw("with"),
    _new: $281a441cdcb2cf36$var$kw("new", {
        beforeExpr: true,
        startsExpr: true
    }),
    _this: $281a441cdcb2cf36$var$kw("this", $281a441cdcb2cf36$var$startsExpr),
    _super: $281a441cdcb2cf36$var$kw("super", $281a441cdcb2cf36$var$startsExpr),
    _class: $281a441cdcb2cf36$var$kw("class", $281a441cdcb2cf36$var$startsExpr),
    _extends: $281a441cdcb2cf36$var$kw("extends", $281a441cdcb2cf36$var$beforeExpr),
    _export: $281a441cdcb2cf36$var$kw("export"),
    _import: $281a441cdcb2cf36$var$kw("import", $281a441cdcb2cf36$var$startsExpr),
    _null: $281a441cdcb2cf36$var$kw("null", $281a441cdcb2cf36$var$startsExpr),
    _true: $281a441cdcb2cf36$var$kw("true", $281a441cdcb2cf36$var$startsExpr),
    _false: $281a441cdcb2cf36$var$kw("false", $281a441cdcb2cf36$var$startsExpr),
    _in: $281a441cdcb2cf36$var$kw("in", {
        beforeExpr: true,
        binop: 7
    }),
    _instanceof: $281a441cdcb2cf36$var$kw("instanceof", {
        beforeExpr: true,
        binop: 7
    }),
    _typeof: $281a441cdcb2cf36$var$kw("typeof", {
        beforeExpr: true,
        prefix: true,
        startsExpr: true
    }),
    _void: $281a441cdcb2cf36$var$kw("void", {
        beforeExpr: true,
        prefix: true,
        startsExpr: true
    }),
    _delete: $281a441cdcb2cf36$var$kw("delete", {
        beforeExpr: true,
        prefix: true,
        startsExpr: true
    })
};
var $281a441cdcb2cf36$var$lineBreak = /\r\n?|\n|\u2028|\u2029/;
var $281a441cdcb2cf36$var$lineBreakG = new RegExp($281a441cdcb2cf36$var$lineBreak.source, "g");
function $281a441cdcb2cf36$var$isNewLine(code) {
    return code === 10 || code === 13 || code === 8232 || code === 8233;
}
function $281a441cdcb2cf36$var$nextLineBreak(code, from2, end) {
    if (end === void 0) end = code.length;
    for(var i3 = from2; i3 < end; i3++){
        var next = code.charCodeAt(i3);
        if ($281a441cdcb2cf36$var$isNewLine(next)) return i3 < end - 1 && next === 13 && code.charCodeAt(i3 + 1) === 10 ? i3 + 2 : i3 + 1;
    }
    return -1;
}
var $281a441cdcb2cf36$var$nonASCIIwhitespace = /[\u1680\u2000-\u200a\u202f\u205f\u3000\ufeff]/;
var $281a441cdcb2cf36$var$skipWhiteSpace = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g;
var $281a441cdcb2cf36$var$ref = Object.prototype;
var $281a441cdcb2cf36$var$hasOwnProperty = $281a441cdcb2cf36$var$ref.hasOwnProperty;
var $281a441cdcb2cf36$var$toString2 = $281a441cdcb2cf36$var$ref.toString;
var $281a441cdcb2cf36$var$hasOwn = Object.hasOwn || function(obj, propName) {
    return $281a441cdcb2cf36$var$hasOwnProperty.call(obj, propName);
};
var $281a441cdcb2cf36$var$isArray2 = Array.isArray || function(obj) {
    return $281a441cdcb2cf36$var$toString2.call(obj) === "[object Array]";
};
var $281a441cdcb2cf36$var$regexpCache = /* @__PURE__ */ Object.create(null);
function $281a441cdcb2cf36$var$wordsRegexp(words) {
    return $281a441cdcb2cf36$var$regexpCache[words] || ($281a441cdcb2cf36$var$regexpCache[words] = new RegExp("^(?:" + words.replace(/ /g, "|") + ")$"));
}
function $281a441cdcb2cf36$var$codePointToString(code) {
    if (code <= 65535) return String.fromCharCode(code);
    code -= 65536;
    return String.fromCharCode((code >> 10) + 55296, (code & 1023) + 56320);
}
var $281a441cdcb2cf36$var$loneSurrogate = /(?:[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/;
var $281a441cdcb2cf36$var$Position = function Position2(line, col) {
    this.line = line;
    this.column = col;
};
$281a441cdcb2cf36$var$Position.prototype.offset = function offset(n3) {
    return new $281a441cdcb2cf36$var$Position(this.line, this.column + n3);
};
var $281a441cdcb2cf36$var$SourceLocation = function SourceLocation2(p3, start, end) {
    this.start = start;
    this.end = end;
    if (p3.sourceFile !== null) this.source = p3.sourceFile;
};
function $281a441cdcb2cf36$var$getLineInfo(input, offset2) {
    for(var line = 1, cur = 0;;){
        var nextBreak = $281a441cdcb2cf36$var$nextLineBreak(input, cur, offset2);
        if (nextBreak < 0) return new $281a441cdcb2cf36$var$Position(line, offset2 - cur);
        ++line;
        cur = nextBreak;
    }
}
var $281a441cdcb2cf36$var$defaultOptions = {
    // `ecmaVersion` indicates the ECMAScript version to parse. Must be
    // either 3, 5, 6 (or 2015), 7 (2016), 8 (2017), 9 (2018), 10
    // (2019), 11 (2020), 12 (2021), 13 (2022), 14 (2023), or `"latest"`
    // (the latest version the library supports). This influences
    // support for strict mode, the set of reserved words, and support
    // for new syntax features.
    ecmaVersion: null,
    // `sourceType` indicates the mode the code should be parsed in.
    // Can be either `"script"`, `"module"` or `"commonjs"`. This influences global
    // strict mode and parsing of `import` and `export` declarations.
    sourceType: "script",
    // `onInsertedSemicolon` can be a callback that will be called when
    // a semicolon is automatically inserted. It will be passed the
    // position of the inserted semicolon as an offset, and if
    // `locations` is enabled, it is given the location as a `{line,
    // column}` object as second argument.
    onInsertedSemicolon: null,
    // `onTrailingComma` is similar to `onInsertedSemicolon`, but for
    // trailing commas.
    onTrailingComma: null,
    // By default, reserved words are only enforced if ecmaVersion >= 5.
    // Set `allowReserved` to a boolean value to explicitly turn this on
    // an off. When this option has the value "never", reserved words
    // and keywords can also not be used as property names.
    allowReserved: null,
    // When enabled, a return at the top level is not considered an
    // error.
    allowReturnOutsideFunction: false,
    // When enabled, import/export statements are not constrained to
    // appearing at the top of the program, and an import.meta expression
    // in a script isn't considered an error.
    allowImportExportEverywhere: false,
    // By default, await identifiers are allowed to appear at the top-level scope only if ecmaVersion >= 2022.
    // When enabled, await identifiers are allowed to appear at the top-level scope,
    // but they are still not allowed in non-async functions.
    allowAwaitOutsideFunction: null,
    // When enabled, super identifiers are not constrained to
    // appearing in methods and do not raise an error when they appear elsewhere.
    allowSuperOutsideMethod: null,
    // When enabled, hashbang directive in the beginning of file is
    // allowed and treated as a line comment. Enabled by default when
    // `ecmaVersion` >= 2023.
    allowHashBang: false,
    // By default, the parser will verify that private properties are
    // only used in places where they are valid and have been declared.
    // Set this to false to turn such checks off.
    checkPrivateFields: true,
    // When `locations` is on, `loc` properties holding objects with
    // `start` and `end` properties in `{line, column}` form (with
    // line being 1-based and column 0-based) will be attached to the
    // nodes.
    locations: false,
    // A function can be passed as `onToken` option, which will
    // cause Acorn to call that function with object in the same
    // format as tokens returned from `tokenizer().getToken()`. Note
    // that you are not allowed to call the parser from the
    // callback—that will corrupt its internal state.
    onToken: null,
    // A function can be passed as `onComment` option, which will
    // cause Acorn to call that function with `(block, text, start,
    // end)` parameters whenever a comment is skipped. `block` is a
    // boolean indicating whether this is a block (`/* */`) comment,
    // `text` is the content of the comment, and `start` and `end` are
    // character offsets that denote the start and end of the comment.
    // When the `locations` option is on, two more parameters are
    // passed, the full `{line, column}` locations of the start and
    // end of the comments. Note that you are not allowed to call the
    // parser from the callback—that will corrupt its internal state.
    // When this option has an array as value, objects representing the
    // comments are pushed to it.
    onComment: null,
    // Nodes have their start and end characters offsets recorded in
    // `start` and `end` properties (directly on the node, rather than
    // the `loc` object, which holds line/column data. To also add a
    // [semi-standardized][range] `range` property holding a `[start,
    // end]` array with the same numbers, set the `ranges` option to
    // `true`.
    //
    // [range]: https://bugzilla.mozilla.org/show_bug.cgi?id=745678
    ranges: false,
    // It is possible to parse multiple files into a single AST by
    // passing the tree produced by parsing the first file as
    // `program` option in subsequent parses. This will add the
    // toplevel forms of the parsed file to the `Program` (top) node
    // of an existing parse tree.
    program: null,
    // When `locations` is on, you can pass this to record the source
    // file in every node's `loc` object.
    sourceFile: null,
    // This value, if given, is stored in every node, whether
    // `locations` is on or off.
    directSourceFile: null,
    // When enabled, parenthesized expressions are represented by
    // (non-standard) ParenthesizedExpression nodes
    preserveParens: false
};
var $281a441cdcb2cf36$var$warnedAboutEcmaVersion = false;
function $281a441cdcb2cf36$var$getOptions(opts) {
    var options = {};
    for(var opt in $281a441cdcb2cf36$var$defaultOptions)options[opt] = opts && $281a441cdcb2cf36$var$hasOwn(opts, opt) ? opts[opt] : $281a441cdcb2cf36$var$defaultOptions[opt];
    if (options.ecmaVersion === "latest") options.ecmaVersion = 1e8;
    else if (options.ecmaVersion == null) {
        if (!$281a441cdcb2cf36$var$warnedAboutEcmaVersion && typeof console === "object" && console.warn) {
            $281a441cdcb2cf36$var$warnedAboutEcmaVersion = true;
            console.warn("Since Acorn 8.0.0, options.ecmaVersion is required.\nDefaulting to 2020, but this will stop working in the future.");
        }
        options.ecmaVersion = 11;
    } else if (options.ecmaVersion >= 2015) options.ecmaVersion -= 2009;
    if (options.allowReserved == null) options.allowReserved = options.ecmaVersion < 5;
    if (!opts || opts.allowHashBang == null) options.allowHashBang = options.ecmaVersion >= 14;
    if ($281a441cdcb2cf36$var$isArray2(options.onToken)) {
        var tokens = options.onToken;
        options.onToken = function(token) {
            return tokens.push(token);
        };
    }
    if ($281a441cdcb2cf36$var$isArray2(options.onComment)) options.onComment = $281a441cdcb2cf36$var$pushComment(options, options.onComment);
    if (options.sourceType === "commonjs" && options.allowAwaitOutsideFunction) throw new Error("Cannot use allowAwaitOutsideFunction with sourceType: commonjs");
    return options;
}
function $281a441cdcb2cf36$var$pushComment(options, array) {
    return function(block, text2, start, end, startLoc, endLoc) {
        var comment = {
            type: block ? "Block" : "Line",
            value: text2,
            start: start,
            end: end
        };
        if (options.locations) comment.loc = new $281a441cdcb2cf36$var$SourceLocation(this, startLoc, endLoc);
        if (options.ranges) comment.range = [
            start,
            end
        ];
        array.push(comment);
    };
}
var $281a441cdcb2cf36$var$SCOPE_TOP = 1;
var $281a441cdcb2cf36$var$SCOPE_FUNCTION = 2;
var $281a441cdcb2cf36$var$SCOPE_ASYNC = 4;
var $281a441cdcb2cf36$var$SCOPE_GENERATOR = 8;
var $281a441cdcb2cf36$var$SCOPE_ARROW = 16;
var $281a441cdcb2cf36$var$SCOPE_SIMPLE_CATCH = 32;
var $281a441cdcb2cf36$var$SCOPE_SUPER = 64;
var $281a441cdcb2cf36$var$SCOPE_DIRECT_SUPER = 128;
var $281a441cdcb2cf36$var$SCOPE_CLASS_STATIC_BLOCK = 256;
var $281a441cdcb2cf36$var$SCOPE_CLASS_FIELD_INIT = 512;
var $281a441cdcb2cf36$var$SCOPE_SWITCH = 1024;
var $281a441cdcb2cf36$var$SCOPE_VAR = $281a441cdcb2cf36$var$SCOPE_TOP | $281a441cdcb2cf36$var$SCOPE_FUNCTION | $281a441cdcb2cf36$var$SCOPE_CLASS_STATIC_BLOCK;
function $281a441cdcb2cf36$var$functionFlags(async, generator) {
    return $281a441cdcb2cf36$var$SCOPE_FUNCTION | (async ? $281a441cdcb2cf36$var$SCOPE_ASYNC : 0) | (generator ? $281a441cdcb2cf36$var$SCOPE_GENERATOR : 0);
}
var $281a441cdcb2cf36$var$BIND_NONE = 0;
var $281a441cdcb2cf36$var$BIND_VAR = 1;
var $281a441cdcb2cf36$var$BIND_LEXICAL = 2;
var $281a441cdcb2cf36$var$BIND_FUNCTION = 3;
var $281a441cdcb2cf36$var$BIND_SIMPLE_CATCH = 4;
var $281a441cdcb2cf36$var$BIND_OUTSIDE = 5;
var $281a441cdcb2cf36$var$Parser = function Parser2(options, input, startPos) {
    this.options = options = $281a441cdcb2cf36$var$getOptions(options);
    this.sourceFile = options.sourceFile;
    this.keywords = $281a441cdcb2cf36$var$wordsRegexp($281a441cdcb2cf36$var$keywords$1[options.ecmaVersion >= 6 ? 6 : options.sourceType === "module" ? "5module" : 5]);
    var reserved = "";
    if (options.allowReserved !== true) {
        reserved = $281a441cdcb2cf36$var$reservedWords[options.ecmaVersion >= 6 ? 6 : options.ecmaVersion === 5 ? 5 : 3];
        if (options.sourceType === "module") reserved += " await";
    }
    this.reservedWords = $281a441cdcb2cf36$var$wordsRegexp(reserved);
    var reservedStrict = (reserved ? reserved + " " : "") + $281a441cdcb2cf36$var$reservedWords.strict;
    this.reservedWordsStrict = $281a441cdcb2cf36$var$wordsRegexp(reservedStrict);
    this.reservedWordsStrictBind = $281a441cdcb2cf36$var$wordsRegexp(reservedStrict + " " + $281a441cdcb2cf36$var$reservedWords.strictBind);
    this.input = String(input);
    this.containsEsc = false;
    if (startPos) {
        this.pos = startPos;
        this.lineStart = this.input.lastIndexOf("\n", startPos - 1) + 1;
        this.curLine = this.input.slice(0, this.lineStart).split($281a441cdcb2cf36$var$lineBreak).length;
    } else {
        this.pos = this.lineStart = 0;
        this.curLine = 1;
    }
    this.type = $281a441cdcb2cf36$var$types$1.eof;
    this.value = null;
    this.start = this.end = this.pos;
    this.startLoc = this.endLoc = this.curPosition();
    this.lastTokEndLoc = this.lastTokStartLoc = null;
    this.lastTokStart = this.lastTokEnd = this.pos;
    this.context = this.initialContext();
    this.exprAllowed = true;
    this.inModule = options.sourceType === "module";
    this.strict = this.inModule || this.strictDirective(this.pos);
    this.potentialArrowAt = -1;
    this.potentialArrowInForAwait = false;
    this.yieldPos = this.awaitPos = this.awaitIdentPos = 0;
    this.labels = [];
    this.undefinedExports = /* @__PURE__ */ Object.create(null);
    if (this.pos === 0 && options.allowHashBang && this.input.slice(0, 2) === "#!") this.skipLineComment(2);
    this.scopeStack = [];
    this.enterScope(this.options.sourceType === "commonjs" ? $281a441cdcb2cf36$var$SCOPE_FUNCTION : $281a441cdcb2cf36$var$SCOPE_TOP);
    this.regexpState = null;
    this.privateNameStack = [];
};
var $281a441cdcb2cf36$var$prototypeAccessors = {
    inFunction: {
        configurable: true
    },
    inGenerator: {
        configurable: true
    },
    inAsync: {
        configurable: true
    },
    canAwait: {
        configurable: true
    },
    allowReturn: {
        configurable: true
    },
    allowSuper: {
        configurable: true
    },
    allowDirectSuper: {
        configurable: true
    },
    treatFunctionsAsVar: {
        configurable: true
    },
    allowNewDotTarget: {
        configurable: true
    },
    allowUsing: {
        configurable: true
    },
    inClassStaticBlock: {
        configurable: true
    }
};
$281a441cdcb2cf36$var$Parser.prototype.parse = function parse2() {
    var node = this.options.program || this.startNode();
    this.nextToken();
    return this.parseTopLevel(node);
};
$281a441cdcb2cf36$var$prototypeAccessors.inFunction.get = function() {
    return (this.currentVarScope().flags & $281a441cdcb2cf36$var$SCOPE_FUNCTION) > 0;
};
$281a441cdcb2cf36$var$prototypeAccessors.inGenerator.get = function() {
    return (this.currentVarScope().flags & $281a441cdcb2cf36$var$SCOPE_GENERATOR) > 0;
};
$281a441cdcb2cf36$var$prototypeAccessors.inAsync.get = function() {
    return (this.currentVarScope().flags & $281a441cdcb2cf36$var$SCOPE_ASYNC) > 0;
};
$281a441cdcb2cf36$var$prototypeAccessors.canAwait.get = function() {
    for(var i3 = this.scopeStack.length - 1; i3 >= 0; i3--){
        var ref2 = this.scopeStack[i3];
        var flags = ref2.flags;
        if (flags & ($281a441cdcb2cf36$var$SCOPE_CLASS_STATIC_BLOCK | $281a441cdcb2cf36$var$SCOPE_CLASS_FIELD_INIT)) return false;
        if (flags & $281a441cdcb2cf36$var$SCOPE_FUNCTION) return (flags & $281a441cdcb2cf36$var$SCOPE_ASYNC) > 0;
    }
    return this.inModule && this.options.ecmaVersion >= 13 || this.options.allowAwaitOutsideFunction;
};
$281a441cdcb2cf36$var$prototypeAccessors.allowReturn.get = function() {
    if (this.inFunction) return true;
    if (this.options.allowReturnOutsideFunction && this.currentVarScope().flags & $281a441cdcb2cf36$var$SCOPE_TOP) return true;
    return false;
};
$281a441cdcb2cf36$var$prototypeAccessors.allowSuper.get = function() {
    var ref2 = this.currentThisScope();
    var flags = ref2.flags;
    return (flags & $281a441cdcb2cf36$var$SCOPE_SUPER) > 0 || this.options.allowSuperOutsideMethod;
};
$281a441cdcb2cf36$var$prototypeAccessors.allowDirectSuper.get = function() {
    return (this.currentThisScope().flags & $281a441cdcb2cf36$var$SCOPE_DIRECT_SUPER) > 0;
};
$281a441cdcb2cf36$var$prototypeAccessors.treatFunctionsAsVar.get = function() {
    return this.treatFunctionsAsVarInScope(this.currentScope());
};
$281a441cdcb2cf36$var$prototypeAccessors.allowNewDotTarget.get = function() {
    for(var i3 = this.scopeStack.length - 1; i3 >= 0; i3--){
        var ref2 = this.scopeStack[i3];
        var flags = ref2.flags;
        if (flags & ($281a441cdcb2cf36$var$SCOPE_CLASS_STATIC_BLOCK | $281a441cdcb2cf36$var$SCOPE_CLASS_FIELD_INIT) || flags & $281a441cdcb2cf36$var$SCOPE_FUNCTION && !(flags & $281a441cdcb2cf36$var$SCOPE_ARROW)) return true;
    }
    return false;
};
$281a441cdcb2cf36$var$prototypeAccessors.allowUsing.get = function() {
    var ref2 = this.currentScope();
    var flags = ref2.flags;
    if (flags & $281a441cdcb2cf36$var$SCOPE_SWITCH) return false;
    if (!this.inModule && flags & $281a441cdcb2cf36$var$SCOPE_TOP) return false;
    return true;
};
$281a441cdcb2cf36$var$prototypeAccessors.inClassStaticBlock.get = function() {
    return (this.currentVarScope().flags & $281a441cdcb2cf36$var$SCOPE_CLASS_STATIC_BLOCK) > 0;
};
$281a441cdcb2cf36$var$Parser.extend = function extend() {
    var plugins = [], len = arguments.length;
    while(len--)plugins[len] = arguments[len];
    var cls = this;
    for(var i3 = 0; i3 < plugins.length; i3++)cls = plugins[i3](cls);
    return cls;
};
$281a441cdcb2cf36$var$Parser.parse = function parse3(input, options) {
    return new this(options, input).parse();
};
$281a441cdcb2cf36$var$Parser.parseExpressionAt = function parseExpressionAt(input, pos, options) {
    var parser = new this(options, input, pos);
    parser.nextToken();
    return parser.parseExpression();
};
$281a441cdcb2cf36$var$Parser.tokenizer = function tokenizer(input, options) {
    return new this(options, input);
};
Object.defineProperties($281a441cdcb2cf36$var$Parser.prototype, $281a441cdcb2cf36$var$prototypeAccessors);
var $281a441cdcb2cf36$var$pp$9 = $281a441cdcb2cf36$var$Parser.prototype;
var $281a441cdcb2cf36$var$literal = /^(?:'((?:\\[^]|[^'\\])*?)'|"((?:\\[^]|[^"\\])*?)")/;
$281a441cdcb2cf36$var$pp$9.strictDirective = function(start) {
    if (this.options.ecmaVersion < 5) return false;
    for(;;){
        $281a441cdcb2cf36$var$skipWhiteSpace.lastIndex = start;
        start += $281a441cdcb2cf36$var$skipWhiteSpace.exec(this.input)[0].length;
        var match2 = $281a441cdcb2cf36$var$literal.exec(this.input.slice(start));
        if (!match2) return false;
        if ((match2[1] || match2[2]) === "use strict") {
            $281a441cdcb2cf36$var$skipWhiteSpace.lastIndex = start + match2[0].length;
            var spaceAfter = $281a441cdcb2cf36$var$skipWhiteSpace.exec(this.input), end = spaceAfter.index + spaceAfter[0].length;
            var next = this.input.charAt(end);
            return next === ";" || next === "}" || $281a441cdcb2cf36$var$lineBreak.test(spaceAfter[0]) && !(/[(`.[+\-/*%<>=,?^&]/.test(next) || next === "!" && this.input.charAt(end + 1) === "=");
        }
        start += match2[0].length;
        $281a441cdcb2cf36$var$skipWhiteSpace.lastIndex = start;
        start += $281a441cdcb2cf36$var$skipWhiteSpace.exec(this.input)[0].length;
        if (this.input[start] === ";") start++;
    }
};
$281a441cdcb2cf36$var$pp$9.eat = function(type) {
    if (this.type === type) {
        this.next();
        return true;
    } else return false;
};
$281a441cdcb2cf36$var$pp$9.isContextual = function(name) {
    return this.type === $281a441cdcb2cf36$var$types$1.name && this.value === name && !this.containsEsc;
};
$281a441cdcb2cf36$var$pp$9.eatContextual = function(name) {
    if (!this.isContextual(name)) return false;
    this.next();
    return true;
};
$281a441cdcb2cf36$var$pp$9.expectContextual = function(name) {
    if (!this.eatContextual(name)) this.unexpected();
};
$281a441cdcb2cf36$var$pp$9.canInsertSemicolon = function() {
    return this.type === $281a441cdcb2cf36$var$types$1.eof || this.type === $281a441cdcb2cf36$var$types$1.braceR || $281a441cdcb2cf36$var$lineBreak.test(this.input.slice(this.lastTokEnd, this.start));
};
$281a441cdcb2cf36$var$pp$9.insertSemicolon = function() {
    if (this.canInsertSemicolon()) {
        if (this.options.onInsertedSemicolon) this.options.onInsertedSemicolon(this.lastTokEnd, this.lastTokEndLoc);
        return true;
    }
};
$281a441cdcb2cf36$var$pp$9.semicolon = function() {
    if (!this.eat($281a441cdcb2cf36$var$types$1.semi) && !this.insertSemicolon()) this.unexpected();
};
$281a441cdcb2cf36$var$pp$9.afterTrailingComma = function(tokType, notNext) {
    if (this.type === tokType) {
        if (this.options.onTrailingComma) this.options.onTrailingComma(this.lastTokStart, this.lastTokStartLoc);
        if (!notNext) this.next();
        return true;
    }
};
$281a441cdcb2cf36$var$pp$9.expect = function(type) {
    this.eat(type) || this.unexpected();
};
$281a441cdcb2cf36$var$pp$9.unexpected = function(pos) {
    this.raise(pos != null ? pos : this.start, "Unexpected token");
};
var $281a441cdcb2cf36$var$DestructuringErrors = function DestructuringErrors2() {
    this.shorthandAssign = this.trailingComma = this.parenthesizedAssign = this.parenthesizedBind = this.doubleProto = -1;
};
$281a441cdcb2cf36$var$pp$9.checkPatternErrors = function(refDestructuringErrors, isAssign) {
    if (!refDestructuringErrors) return;
    if (refDestructuringErrors.trailingComma > -1) this.raiseRecoverable(refDestructuringErrors.trailingComma, "Comma is not permitted after the rest element");
    var parens = isAssign ? refDestructuringErrors.parenthesizedAssign : refDestructuringErrors.parenthesizedBind;
    if (parens > -1) this.raiseRecoverable(parens, isAssign ? "Assigning to rvalue" : "Parenthesized pattern");
};
$281a441cdcb2cf36$var$pp$9.checkExpressionErrors = function(refDestructuringErrors, andThrow) {
    if (!refDestructuringErrors) return false;
    var shorthandAssign = refDestructuringErrors.shorthandAssign;
    var doubleProto = refDestructuringErrors.doubleProto;
    if (!andThrow) return shorthandAssign >= 0 || doubleProto >= 0;
    if (shorthandAssign >= 0) this.raise(shorthandAssign, "Shorthand property assignments are valid only in destructuring patterns");
    if (doubleProto >= 0) this.raiseRecoverable(doubleProto, "Redefinition of __proto__ property");
};
$281a441cdcb2cf36$var$pp$9.checkYieldAwaitInDefaultParams = function() {
    if (this.yieldPos && (!this.awaitPos || this.yieldPos < this.awaitPos)) this.raise(this.yieldPos, "Yield expression cannot be a default value");
    if (this.awaitPos) this.raise(this.awaitPos, "Await expression cannot be a default value");
};
$281a441cdcb2cf36$var$pp$9.isSimpleAssignTarget = function(expr) {
    if (expr.type === "ParenthesizedExpression") return this.isSimpleAssignTarget(expr.expression);
    return expr.type === "Identifier" || expr.type === "MemberExpression";
};
var $281a441cdcb2cf36$var$pp$8 = $281a441cdcb2cf36$var$Parser.prototype;
$281a441cdcb2cf36$var$pp$8.parseTopLevel = function(node) {
    var exports = /* @__PURE__ */ Object.create(null);
    if (!node.body) node.body = [];
    while(this.type !== $281a441cdcb2cf36$var$types$1.eof){
        var stmt = this.parseStatement(null, true, exports);
        node.body.push(stmt);
    }
    if (this.inModule) for(var i3 = 0, list = Object.keys(this.undefinedExports); i3 < list.length; i3 += 1){
        var name = list[i3];
        this.raiseRecoverable(this.undefinedExports[name].start, "Export '" + name + "' is not defined");
    }
    this.adaptDirectivePrologue(node.body);
    this.next();
    node.sourceType = this.options.sourceType === "commonjs" ? "script" : this.options.sourceType;
    return this.finishNode(node, "Program");
};
var $281a441cdcb2cf36$var$loopLabel = {
    kind: "loop"
};
var $281a441cdcb2cf36$var$switchLabel = {
    kind: "switch"
};
$281a441cdcb2cf36$var$pp$8.isLet = function(context2) {
    if (this.options.ecmaVersion < 6 || !this.isContextual("let")) return false;
    $281a441cdcb2cf36$var$skipWhiteSpace.lastIndex = this.pos;
    var skip = $281a441cdcb2cf36$var$skipWhiteSpace.exec(this.input);
    var next = this.pos + skip[0].length, nextCh = this.fullCharCodeAt(next);
    if (nextCh === 91 || nextCh === 92) return true;
    if (context2) return false;
    if (nextCh === 123) return true;
    if ($281a441cdcb2cf36$var$isIdentifierStart(nextCh)) {
        var start = next;
        do next += nextCh <= 65535 ? 1 : 2;
        while ($281a441cdcb2cf36$var$isIdentifierChar(nextCh = this.fullCharCodeAt(next)));
        if (nextCh === 92) return true;
        var ident = this.input.slice(start, next);
        if (!$281a441cdcb2cf36$var$keywordRelationalOperator.test(ident)) return true;
    }
    return false;
};
$281a441cdcb2cf36$var$pp$8.isAsyncFunction = function() {
    if (this.options.ecmaVersion < 8 || !this.isContextual("async")) return false;
    $281a441cdcb2cf36$var$skipWhiteSpace.lastIndex = this.pos;
    var skip = $281a441cdcb2cf36$var$skipWhiteSpace.exec(this.input);
    var next = this.pos + skip[0].length, after;
    return !$281a441cdcb2cf36$var$lineBreak.test(this.input.slice(this.pos, next)) && this.input.slice(next, next + 8) === "function" && (next + 8 === this.input.length || !($281a441cdcb2cf36$var$isIdentifierChar(after = this.fullCharCodeAt(next + 8)) || after === 92));
};
$281a441cdcb2cf36$var$pp$8.isUsingKeyword = function(isAwaitUsing, isFor) {
    if (this.options.ecmaVersion < 17 || !this.isContextual(isAwaitUsing ? "await" : "using")) return false;
    $281a441cdcb2cf36$var$skipWhiteSpace.lastIndex = this.pos;
    var skip = $281a441cdcb2cf36$var$skipWhiteSpace.exec(this.input);
    var next = this.pos + skip[0].length;
    if ($281a441cdcb2cf36$var$lineBreak.test(this.input.slice(this.pos, next))) return false;
    if (isAwaitUsing) {
        var usingEndPos = next + 5, after;
        if (this.input.slice(next, usingEndPos) !== "using" || usingEndPos === this.input.length || $281a441cdcb2cf36$var$isIdentifierChar(after = this.fullCharCodeAt(usingEndPos)) || after === 92) return false;
        $281a441cdcb2cf36$var$skipWhiteSpace.lastIndex = usingEndPos;
        var skipAfterUsing = $281a441cdcb2cf36$var$skipWhiteSpace.exec(this.input);
        next = usingEndPos + skipAfterUsing[0].length;
        if (skipAfterUsing && $281a441cdcb2cf36$var$lineBreak.test(this.input.slice(usingEndPos, next))) return false;
    }
    var ch = this.fullCharCodeAt(next);
    if (!$281a441cdcb2cf36$var$isIdentifierStart(ch) && ch !== 92) return false;
    var idStart = next;
    do next += ch <= 65535 ? 1 : 2;
    while ($281a441cdcb2cf36$var$isIdentifierChar(ch = this.fullCharCodeAt(next)));
    if (ch === 92) return true;
    var id2 = this.input.slice(idStart, next);
    if ($281a441cdcb2cf36$var$keywordRelationalOperator.test(id2) || isFor && id2 === "of") return false;
    return true;
};
$281a441cdcb2cf36$var$pp$8.isAwaitUsing = function(isFor) {
    return this.isUsingKeyword(true, isFor);
};
$281a441cdcb2cf36$var$pp$8.isUsing = function(isFor) {
    return this.isUsingKeyword(false, isFor);
};
$281a441cdcb2cf36$var$pp$8.parseStatement = function(context2, topLevel, exports) {
    var starttype = this.type, node = this.startNode(), kind;
    if (this.isLet(context2)) {
        starttype = $281a441cdcb2cf36$var$types$1._var;
        kind = "let";
    }
    switch(starttype){
        case $281a441cdcb2cf36$var$types$1._break:
        case $281a441cdcb2cf36$var$types$1._continue:
            return this.parseBreakContinueStatement(node, starttype.keyword);
        case $281a441cdcb2cf36$var$types$1._debugger:
            return this.parseDebuggerStatement(node);
        case $281a441cdcb2cf36$var$types$1._do:
            return this.parseDoStatement(node);
        case $281a441cdcb2cf36$var$types$1._for:
            return this.parseForStatement(node);
        case $281a441cdcb2cf36$var$types$1._function:
            if (context2 && (this.strict || context2 !== "if" && context2 !== "label") && this.options.ecmaVersion >= 6) this.unexpected();
            return this.parseFunctionStatement(node, false, !context2);
        case $281a441cdcb2cf36$var$types$1._class:
            if (context2) this.unexpected();
            return this.parseClass(node, true);
        case $281a441cdcb2cf36$var$types$1._if:
            return this.parseIfStatement(node);
        case $281a441cdcb2cf36$var$types$1._return:
            return this.parseReturnStatement(node);
        case $281a441cdcb2cf36$var$types$1._switch:
            return this.parseSwitchStatement(node);
        case $281a441cdcb2cf36$var$types$1._throw:
            return this.parseThrowStatement(node);
        case $281a441cdcb2cf36$var$types$1._try:
            return this.parseTryStatement(node);
        case $281a441cdcb2cf36$var$types$1._const:
        case $281a441cdcb2cf36$var$types$1._var:
            kind = kind || this.value;
            if (context2 && kind !== "var") this.unexpected();
            return this.parseVarStatement(node, kind);
        case $281a441cdcb2cf36$var$types$1._while:
            return this.parseWhileStatement(node);
        case $281a441cdcb2cf36$var$types$1._with:
            return this.parseWithStatement(node);
        case $281a441cdcb2cf36$var$types$1.braceL:
            return this.parseBlock(true, node);
        case $281a441cdcb2cf36$var$types$1.semi:
            return this.parseEmptyStatement(node);
        case $281a441cdcb2cf36$var$types$1._export:
        case $281a441cdcb2cf36$var$types$1._import:
            if (this.options.ecmaVersion > 10 && starttype === $281a441cdcb2cf36$var$types$1._import) {
                $281a441cdcb2cf36$var$skipWhiteSpace.lastIndex = this.pos;
                var skip = $281a441cdcb2cf36$var$skipWhiteSpace.exec(this.input);
                var next = this.pos + skip[0].length, nextCh = this.input.charCodeAt(next);
                if (nextCh === 40 || nextCh === 46) return this.parseExpressionStatement(node, this.parseExpression());
            }
            if (!this.options.allowImportExportEverywhere) {
                if (!topLevel) this.raise(this.start, "'import' and 'export' may only appear at the top level");
                if (!this.inModule) this.raise(this.start, "'import' and 'export' may appear only with 'sourceType: module'");
            }
            return starttype === $281a441cdcb2cf36$var$types$1._import ? this.parseImport(node) : this.parseExport(node, exports);
        // If the statement does not start with a statement keyword or a
        // brace, it's an ExpressionStatement or LabeledStatement. We
        // simply start parsing an expression, and afterwards, if the
        // next token is a colon and the expression was a simple
        // Identifier node, we switch to interpreting it as a label.
        default:
            if (this.isAsyncFunction()) {
                if (context2) this.unexpected();
                this.next();
                return this.parseFunctionStatement(node, true, !context2);
            }
            var usingKind = this.isAwaitUsing(false) ? "await using" : this.isUsing(false) ? "using" : null;
            if (usingKind) {
                if (!this.allowUsing) this.raise(this.start, "Using declaration cannot appear in the top level when source type is `script` or in the bare case statement");
                if (usingKind === "await using") {
                    if (!this.canAwait) this.raise(this.start, "Await using cannot appear outside of async function");
                    this.next();
                }
                this.next();
                this.parseVar(node, false, usingKind);
                this.semicolon();
                return this.finishNode(node, "VariableDeclaration");
            }
            var maybeName = this.value, expr = this.parseExpression();
            if (starttype === $281a441cdcb2cf36$var$types$1.name && expr.type === "Identifier" && this.eat($281a441cdcb2cf36$var$types$1.colon)) return this.parseLabeledStatement(node, maybeName, expr, context2);
            else return this.parseExpressionStatement(node, expr);
    }
};
$281a441cdcb2cf36$var$pp$8.parseBreakContinueStatement = function(node, keyword) {
    var isBreak = keyword === "break";
    this.next();
    if (this.eat($281a441cdcb2cf36$var$types$1.semi) || this.insertSemicolon()) node.label = null;
    else if (this.type !== $281a441cdcb2cf36$var$types$1.name) this.unexpected();
    else {
        node.label = this.parseIdent();
        this.semicolon();
    }
    var i3 = 0;
    for(; i3 < this.labels.length; ++i3){
        var lab = this.labels[i3];
        if (node.label == null || lab.name === node.label.name) {
            if (lab.kind != null && (isBreak || lab.kind === "loop")) break;
            if (node.label && isBreak) break;
        }
    }
    if (i3 === this.labels.length) this.raise(node.start, "Unsyntactic " + keyword);
    return this.finishNode(node, isBreak ? "BreakStatement" : "ContinueStatement");
};
$281a441cdcb2cf36$var$pp$8.parseDebuggerStatement = function(node) {
    this.next();
    this.semicolon();
    return this.finishNode(node, "DebuggerStatement");
};
$281a441cdcb2cf36$var$pp$8.parseDoStatement = function(node) {
    this.next();
    this.labels.push($281a441cdcb2cf36$var$loopLabel);
    node.body = this.parseStatement("do");
    this.labels.pop();
    this.expect($281a441cdcb2cf36$var$types$1._while);
    node.test = this.parseParenExpression();
    if (this.options.ecmaVersion >= 6) this.eat($281a441cdcb2cf36$var$types$1.semi);
    else this.semicolon();
    return this.finishNode(node, "DoWhileStatement");
};
$281a441cdcb2cf36$var$pp$8.parseForStatement = function(node) {
    this.next();
    var awaitAt = this.options.ecmaVersion >= 9 && this.canAwait && this.eatContextual("await") ? this.lastTokStart : -1;
    this.labels.push($281a441cdcb2cf36$var$loopLabel);
    this.enterScope(0);
    this.expect($281a441cdcb2cf36$var$types$1.parenL);
    if (this.type === $281a441cdcb2cf36$var$types$1.semi) {
        if (awaitAt > -1) this.unexpected(awaitAt);
        return this.parseFor(node, null);
    }
    var isLet = this.isLet();
    if (this.type === $281a441cdcb2cf36$var$types$1._var || this.type === $281a441cdcb2cf36$var$types$1._const || isLet) {
        var init$1 = this.startNode(), kind = isLet ? "let" : this.value;
        this.next();
        this.parseVar(init$1, true, kind);
        this.finishNode(init$1, "VariableDeclaration");
        return this.parseForAfterInit(node, init$1, awaitAt);
    }
    var startsWithLet = this.isContextual("let"), isForOf = false;
    var usingKind = this.isUsing(true) ? "using" : this.isAwaitUsing(true) ? "await using" : null;
    if (usingKind) {
        var init$2 = this.startNode();
        this.next();
        if (usingKind === "await using") {
            if (!this.canAwait) this.raise(this.start, "Await using cannot appear outside of async function");
            this.next();
        }
        this.parseVar(init$2, true, usingKind);
        this.finishNode(init$2, "VariableDeclaration");
        return this.parseForAfterInit(node, init$2, awaitAt);
    }
    var containsEsc = this.containsEsc;
    var refDestructuringErrors = new $281a441cdcb2cf36$var$DestructuringErrors();
    var initPos = this.start;
    var init = awaitAt > -1 ? this.parseExprSubscripts(refDestructuringErrors, "await") : this.parseExpression(true, refDestructuringErrors);
    if (this.type === $281a441cdcb2cf36$var$types$1._in || (isForOf = this.options.ecmaVersion >= 6 && this.isContextual("of"))) {
        if (awaitAt > -1) {
            if (this.type === $281a441cdcb2cf36$var$types$1._in) this.unexpected(awaitAt);
            node.await = true;
        } else if (isForOf && this.options.ecmaVersion >= 8) {
            if (init.start === initPos && !containsEsc && init.type === "Identifier" && init.name === "async") this.unexpected();
            else if (this.options.ecmaVersion >= 9) node.await = false;
        }
        if (startsWithLet && isForOf) this.raise(init.start, "The left-hand side of a for-of loop may not start with 'let'.");
        this.toAssignable(init, false, refDestructuringErrors);
        this.checkLValPattern(init);
        return this.parseForIn(node, init);
    } else this.checkExpressionErrors(refDestructuringErrors, true);
    if (awaitAt > -1) this.unexpected(awaitAt);
    return this.parseFor(node, init);
};
$281a441cdcb2cf36$var$pp$8.parseForAfterInit = function(node, init, awaitAt) {
    if ((this.type === $281a441cdcb2cf36$var$types$1._in || this.options.ecmaVersion >= 6 && this.isContextual("of")) && init.declarations.length === 1) {
        if (this.options.ecmaVersion >= 9) {
            if (this.type === $281a441cdcb2cf36$var$types$1._in) {
                if (awaitAt > -1) this.unexpected(awaitAt);
            } else node.await = awaitAt > -1;
        }
        return this.parseForIn(node, init);
    }
    if (awaitAt > -1) this.unexpected(awaitAt);
    return this.parseFor(node, init);
};
$281a441cdcb2cf36$var$pp$8.parseFunctionStatement = function(node, isAsync, declarationPosition) {
    this.next();
    return this.parseFunction(node, $281a441cdcb2cf36$var$FUNC_STATEMENT | (declarationPosition ? 0 : $281a441cdcb2cf36$var$FUNC_HANGING_STATEMENT), false, isAsync);
};
$281a441cdcb2cf36$var$pp$8.parseIfStatement = function(node) {
    this.next();
    node.test = this.parseParenExpression();
    node.consequent = this.parseStatement("if");
    node.alternate = this.eat($281a441cdcb2cf36$var$types$1._else) ? this.parseStatement("if") : null;
    return this.finishNode(node, "IfStatement");
};
$281a441cdcb2cf36$var$pp$8.parseReturnStatement = function(node) {
    if (!this.allowReturn) this.raise(this.start, "'return' outside of function");
    this.next();
    if (this.eat($281a441cdcb2cf36$var$types$1.semi) || this.insertSemicolon()) node.argument = null;
    else {
        node.argument = this.parseExpression();
        this.semicolon();
    }
    return this.finishNode(node, "ReturnStatement");
};
$281a441cdcb2cf36$var$pp$8.parseSwitchStatement = function(node) {
    this.next();
    node.discriminant = this.parseParenExpression();
    node.cases = [];
    this.expect($281a441cdcb2cf36$var$types$1.braceL);
    this.labels.push($281a441cdcb2cf36$var$switchLabel);
    this.enterScope($281a441cdcb2cf36$var$SCOPE_SWITCH);
    var cur;
    for(var sawDefault = false; this.type !== $281a441cdcb2cf36$var$types$1.braceR;)if (this.type === $281a441cdcb2cf36$var$types$1._case || this.type === $281a441cdcb2cf36$var$types$1._default) {
        var isCase = this.type === $281a441cdcb2cf36$var$types$1._case;
        if (cur) this.finishNode(cur, "SwitchCase");
        node.cases.push(cur = this.startNode());
        cur.consequent = [];
        this.next();
        if (isCase) cur.test = this.parseExpression();
        else {
            if (sawDefault) this.raiseRecoverable(this.lastTokStart, "Multiple default clauses");
            sawDefault = true;
            cur.test = null;
        }
        this.expect($281a441cdcb2cf36$var$types$1.colon);
    } else {
        if (!cur) this.unexpected();
        cur.consequent.push(this.parseStatement(null));
    }
    this.exitScope();
    if (cur) this.finishNode(cur, "SwitchCase");
    this.next();
    this.labels.pop();
    return this.finishNode(node, "SwitchStatement");
};
$281a441cdcb2cf36$var$pp$8.parseThrowStatement = function(node) {
    this.next();
    if ($281a441cdcb2cf36$var$lineBreak.test(this.input.slice(this.lastTokEnd, this.start))) this.raise(this.lastTokEnd, "Illegal newline after throw");
    node.argument = this.parseExpression();
    this.semicolon();
    return this.finishNode(node, "ThrowStatement");
};
var $281a441cdcb2cf36$var$empty$1 = [];
$281a441cdcb2cf36$var$pp$8.parseCatchClauseParam = function() {
    var param = this.parseBindingAtom();
    var simple = param.type === "Identifier";
    this.enterScope(simple ? $281a441cdcb2cf36$var$SCOPE_SIMPLE_CATCH : 0);
    this.checkLValPattern(param, simple ? $281a441cdcb2cf36$var$BIND_SIMPLE_CATCH : $281a441cdcb2cf36$var$BIND_LEXICAL);
    this.expect($281a441cdcb2cf36$var$types$1.parenR);
    return param;
};
$281a441cdcb2cf36$var$pp$8.parseTryStatement = function(node) {
    this.next();
    node.block = this.parseBlock();
    node.handler = null;
    if (this.type === $281a441cdcb2cf36$var$types$1._catch) {
        var clause = this.startNode();
        this.next();
        if (this.eat($281a441cdcb2cf36$var$types$1.parenL)) clause.param = this.parseCatchClauseParam();
        else {
            if (this.options.ecmaVersion < 10) this.unexpected();
            clause.param = null;
            this.enterScope(0);
        }
        clause.body = this.parseBlock(false);
        this.exitScope();
        node.handler = this.finishNode(clause, "CatchClause");
    }
    node.finalizer = this.eat($281a441cdcb2cf36$var$types$1._finally) ? this.parseBlock() : null;
    if (!node.handler && !node.finalizer) this.raise(node.start, "Missing catch or finally clause");
    return this.finishNode(node, "TryStatement");
};
$281a441cdcb2cf36$var$pp$8.parseVarStatement = function(node, kind, allowMissingInitializer) {
    this.next();
    this.parseVar(node, false, kind, allowMissingInitializer);
    this.semicolon();
    return this.finishNode(node, "VariableDeclaration");
};
$281a441cdcb2cf36$var$pp$8.parseWhileStatement = function(node) {
    this.next();
    node.test = this.parseParenExpression();
    this.labels.push($281a441cdcb2cf36$var$loopLabel);
    node.body = this.parseStatement("while");
    this.labels.pop();
    return this.finishNode(node, "WhileStatement");
};
$281a441cdcb2cf36$var$pp$8.parseWithStatement = function(node) {
    if (this.strict) this.raise(this.start, "'with' in strict mode");
    this.next();
    node.object = this.parseParenExpression();
    node.body = this.parseStatement("with");
    return this.finishNode(node, "WithStatement");
};
$281a441cdcb2cf36$var$pp$8.parseEmptyStatement = function(node) {
    this.next();
    return this.finishNode(node, "EmptyStatement");
};
$281a441cdcb2cf36$var$pp$8.parseLabeledStatement = function(node, maybeName, expr, context2) {
    for(var i$1 = 0, list = this.labels; i$1 < list.length; i$1 += 1){
        var label = list[i$1];
        if (label.name === maybeName) this.raise(expr.start, "Label '" + maybeName + "' is already declared");
    }
    var kind = this.type.isLoop ? "loop" : this.type === $281a441cdcb2cf36$var$types$1._switch ? "switch" : null;
    for(var i3 = this.labels.length - 1; i3 >= 0; i3--){
        var label$1 = this.labels[i3];
        if (label$1.statementStart === node.start) {
            label$1.statementStart = this.start;
            label$1.kind = kind;
        } else break;
    }
    this.labels.push({
        name: maybeName,
        kind: kind,
        statementStart: this.start
    });
    node.body = this.parseStatement(context2 ? context2.indexOf("label") === -1 ? context2 + "label" : context2 : "label");
    this.labels.pop();
    node.label = expr;
    return this.finishNode(node, "LabeledStatement");
};
$281a441cdcb2cf36$var$pp$8.parseExpressionStatement = function(node, expr) {
    node.expression = expr;
    this.semicolon();
    return this.finishNode(node, "ExpressionStatement");
};
$281a441cdcb2cf36$var$pp$8.parseBlock = function(createNewLexicalScope, node, exitStrict) {
    if (createNewLexicalScope === void 0) createNewLexicalScope = true;
    if (node === void 0) node = this.startNode();
    node.body = [];
    this.expect($281a441cdcb2cf36$var$types$1.braceL);
    if (createNewLexicalScope) this.enterScope(0);
    while(this.type !== $281a441cdcb2cf36$var$types$1.braceR){
        var stmt = this.parseStatement(null);
        node.body.push(stmt);
    }
    if (exitStrict) this.strict = false;
    this.next();
    if (createNewLexicalScope) this.exitScope();
    return this.finishNode(node, "BlockStatement");
};
$281a441cdcb2cf36$var$pp$8.parseFor = function(node, init) {
    node.init = init;
    this.expect($281a441cdcb2cf36$var$types$1.semi);
    node.test = this.type === $281a441cdcb2cf36$var$types$1.semi ? null : this.parseExpression();
    this.expect($281a441cdcb2cf36$var$types$1.semi);
    node.update = this.type === $281a441cdcb2cf36$var$types$1.parenR ? null : this.parseExpression();
    this.expect($281a441cdcb2cf36$var$types$1.parenR);
    node.body = this.parseStatement("for");
    this.exitScope();
    this.labels.pop();
    return this.finishNode(node, "ForStatement");
};
$281a441cdcb2cf36$var$pp$8.parseForIn = function(node, init) {
    var isForIn = this.type === $281a441cdcb2cf36$var$types$1._in;
    this.next();
    if (init.type === "VariableDeclaration" && init.declarations[0].init != null && (!isForIn || this.options.ecmaVersion < 8 || this.strict || init.kind !== "var" || init.declarations[0].id.type !== "Identifier")) this.raise(init.start, (isForIn ? "for-in" : "for-of") + " loop variable declaration may not have an initializer");
    node.left = init;
    node.right = isForIn ? this.parseExpression() : this.parseMaybeAssign();
    this.expect($281a441cdcb2cf36$var$types$1.parenR);
    node.body = this.parseStatement("for");
    this.exitScope();
    this.labels.pop();
    return this.finishNode(node, isForIn ? "ForInStatement" : "ForOfStatement");
};
$281a441cdcb2cf36$var$pp$8.parseVar = function(node, isFor, kind, allowMissingInitializer) {
    node.declarations = [];
    node.kind = kind;
    for(;;){
        var decl = this.startNode();
        this.parseVarId(decl, kind);
        if (this.eat($281a441cdcb2cf36$var$types$1.eq)) decl.init = this.parseMaybeAssign(isFor);
        else if (!allowMissingInitializer && kind === "const" && !(this.type === $281a441cdcb2cf36$var$types$1._in || this.options.ecmaVersion >= 6 && this.isContextual("of"))) this.unexpected();
        else if (!allowMissingInitializer && (kind === "using" || kind === "await using") && this.options.ecmaVersion >= 17 && this.type !== $281a441cdcb2cf36$var$types$1._in && !this.isContextual("of")) this.raise(this.lastTokEnd, "Missing initializer in " + kind + " declaration");
        else if (!allowMissingInitializer && decl.id.type !== "Identifier" && !(isFor && (this.type === $281a441cdcb2cf36$var$types$1._in || this.isContextual("of")))) this.raise(this.lastTokEnd, "Complex binding patterns require an initialization value");
        else decl.init = null;
        node.declarations.push(this.finishNode(decl, "VariableDeclarator"));
        if (!this.eat($281a441cdcb2cf36$var$types$1.comma)) break;
    }
    return node;
};
$281a441cdcb2cf36$var$pp$8.parseVarId = function(decl, kind) {
    decl.id = kind === "using" || kind === "await using" ? this.parseIdent() : this.parseBindingAtom();
    this.checkLValPattern(decl.id, kind === "var" ? $281a441cdcb2cf36$var$BIND_VAR : $281a441cdcb2cf36$var$BIND_LEXICAL, false);
};
var $281a441cdcb2cf36$var$FUNC_STATEMENT = 1;
var $281a441cdcb2cf36$var$FUNC_HANGING_STATEMENT = 2;
var $281a441cdcb2cf36$var$FUNC_NULLABLE_ID = 4;
$281a441cdcb2cf36$var$pp$8.parseFunction = function(node, statement, allowExpressionBody, isAsync, forInit) {
    this.initFunction(node);
    if (this.options.ecmaVersion >= 9 || this.options.ecmaVersion >= 6 && !isAsync) {
        if (this.type === $281a441cdcb2cf36$var$types$1.star && statement & $281a441cdcb2cf36$var$FUNC_HANGING_STATEMENT) this.unexpected();
        node.generator = this.eat($281a441cdcb2cf36$var$types$1.star);
    }
    if (this.options.ecmaVersion >= 8) node.async = !!isAsync;
    if (statement & $281a441cdcb2cf36$var$FUNC_STATEMENT) {
        node.id = statement & $281a441cdcb2cf36$var$FUNC_NULLABLE_ID && this.type !== $281a441cdcb2cf36$var$types$1.name ? null : this.parseIdent();
        if (node.id && !(statement & $281a441cdcb2cf36$var$FUNC_HANGING_STATEMENT)) this.checkLValSimple(node.id, this.strict || node.generator || node.async ? this.treatFunctionsAsVar ? $281a441cdcb2cf36$var$BIND_VAR : $281a441cdcb2cf36$var$BIND_LEXICAL : $281a441cdcb2cf36$var$BIND_FUNCTION);
    }
    var oldYieldPos = this.yieldPos, oldAwaitPos = this.awaitPos, oldAwaitIdentPos = this.awaitIdentPos;
    this.yieldPos = 0;
    this.awaitPos = 0;
    this.awaitIdentPos = 0;
    this.enterScope($281a441cdcb2cf36$var$functionFlags(node.async, node.generator));
    if (!(statement & $281a441cdcb2cf36$var$FUNC_STATEMENT)) node.id = this.type === $281a441cdcb2cf36$var$types$1.name ? this.parseIdent() : null;
    this.parseFunctionParams(node);
    this.parseFunctionBody(node, allowExpressionBody, false, forInit);
    this.yieldPos = oldYieldPos;
    this.awaitPos = oldAwaitPos;
    this.awaitIdentPos = oldAwaitIdentPos;
    return this.finishNode(node, statement & $281a441cdcb2cf36$var$FUNC_STATEMENT ? "FunctionDeclaration" : "FunctionExpression");
};
$281a441cdcb2cf36$var$pp$8.parseFunctionParams = function(node) {
    this.expect($281a441cdcb2cf36$var$types$1.parenL);
    node.params = this.parseBindingList($281a441cdcb2cf36$var$types$1.parenR, false, this.options.ecmaVersion >= 8);
    this.checkYieldAwaitInDefaultParams();
};
$281a441cdcb2cf36$var$pp$8.parseClass = function(node, isStatement) {
    this.next();
    var oldStrict = this.strict;
    this.strict = true;
    this.parseClassId(node, isStatement);
    this.parseClassSuper(node);
    var privateNameMap = this.enterClassBody();
    var classBody = this.startNode();
    var hadConstructor = false;
    classBody.body = [];
    this.expect($281a441cdcb2cf36$var$types$1.braceL);
    while(this.type !== $281a441cdcb2cf36$var$types$1.braceR){
        var element2 = this.parseClassElement(node.superClass !== null);
        if (element2) {
            classBody.body.push(element2);
            if (element2.type === "MethodDefinition" && element2.kind === "constructor") {
                if (hadConstructor) this.raiseRecoverable(element2.start, "Duplicate constructor in the same class");
                hadConstructor = true;
            } else if (element2.key && element2.key.type === "PrivateIdentifier" && $281a441cdcb2cf36$var$isPrivateNameConflicted(privateNameMap, element2)) this.raiseRecoverable(element2.key.start, "Identifier '#" + element2.key.name + "' has already been declared");
        }
    }
    this.strict = oldStrict;
    this.next();
    node.body = this.finishNode(classBody, "ClassBody");
    this.exitClassBody();
    return this.finishNode(node, isStatement ? "ClassDeclaration" : "ClassExpression");
};
$281a441cdcb2cf36$var$pp$8.parseClassElement = function(constructorAllowsSuper) {
    if (this.eat($281a441cdcb2cf36$var$types$1.semi)) return null;
    var ecmaVersion = this.options.ecmaVersion;
    var node = this.startNode();
    var keyName = "";
    var isGenerator = false;
    var isAsync = false;
    var kind = "method";
    var isStatic = false;
    if (this.eatContextual("static")) {
        if (ecmaVersion >= 13 && this.eat($281a441cdcb2cf36$var$types$1.braceL)) {
            this.parseClassStaticBlock(node);
            return node;
        }
        if (this.isClassElementNameStart() || this.type === $281a441cdcb2cf36$var$types$1.star) isStatic = true;
        else keyName = "static";
    }
    node.static = isStatic;
    if (!keyName && ecmaVersion >= 8 && this.eatContextual("async")) {
        if ((this.isClassElementNameStart() || this.type === $281a441cdcb2cf36$var$types$1.star) && !this.canInsertSemicolon()) isAsync = true;
        else keyName = "async";
    }
    if (!keyName && (ecmaVersion >= 9 || !isAsync) && this.eat($281a441cdcb2cf36$var$types$1.star)) isGenerator = true;
    if (!keyName && !isAsync && !isGenerator) {
        var lastValue = this.value;
        if (this.eatContextual("get") || this.eatContextual("set")) {
            if (this.isClassElementNameStart()) kind = lastValue;
            else keyName = lastValue;
        }
    }
    if (keyName) {
        node.computed = false;
        node.key = this.startNodeAt(this.lastTokStart, this.lastTokStartLoc);
        node.key.name = keyName;
        this.finishNode(node.key, "Identifier");
    } else this.parseClassElementName(node);
    if (ecmaVersion < 13 || this.type === $281a441cdcb2cf36$var$types$1.parenL || kind !== "method" || isGenerator || isAsync) {
        var isConstructor = !node.static && $281a441cdcb2cf36$var$checkKeyName(node, "constructor");
        var allowsDirectSuper = isConstructor && constructorAllowsSuper;
        if (isConstructor && kind !== "method") this.raise(node.key.start, "Constructor can't have get/set modifier");
        node.kind = isConstructor ? "constructor" : kind;
        this.parseClassMethod(node, isGenerator, isAsync, allowsDirectSuper);
    } else this.parseClassField(node);
    return node;
};
$281a441cdcb2cf36$var$pp$8.isClassElementNameStart = function() {
    return this.type === $281a441cdcb2cf36$var$types$1.name || this.type === $281a441cdcb2cf36$var$types$1.privateId || this.type === $281a441cdcb2cf36$var$types$1.num || this.type === $281a441cdcb2cf36$var$types$1.string || this.type === $281a441cdcb2cf36$var$types$1.bracketL || this.type.keyword;
};
$281a441cdcb2cf36$var$pp$8.parseClassElementName = function(element2) {
    if (this.type === $281a441cdcb2cf36$var$types$1.privateId) {
        if (this.value === "constructor") this.raise(this.start, "Classes can't have an element named '#constructor'");
        element2.computed = false;
        element2.key = this.parsePrivateIdent();
    } else this.parsePropertyName(element2);
};
$281a441cdcb2cf36$var$pp$8.parseClassMethod = function(method, isGenerator, isAsync, allowsDirectSuper) {
    var key = method.key;
    if (method.kind === "constructor") {
        if (isGenerator) this.raise(key.start, "Constructor can't be a generator");
        if (isAsync) this.raise(key.start, "Constructor can't be an async method");
    } else if (method.static && $281a441cdcb2cf36$var$checkKeyName(method, "prototype")) this.raise(key.start, "Classes may not have a static property named prototype");
    var value2 = method.value = this.parseMethod(isGenerator, isAsync, allowsDirectSuper);
    if (method.kind === "get" && value2.params.length !== 0) this.raiseRecoverable(value2.start, "getter should have no params");
    if (method.kind === "set" && value2.params.length !== 1) this.raiseRecoverable(value2.start, "setter should have exactly one param");
    if (method.kind === "set" && value2.params[0].type === "RestElement") this.raiseRecoverable(value2.params[0].start, "Setter cannot use rest params");
    return this.finishNode(method, "MethodDefinition");
};
$281a441cdcb2cf36$var$pp$8.parseClassField = function(field) {
    if ($281a441cdcb2cf36$var$checkKeyName(field, "constructor")) this.raise(field.key.start, "Classes can't have a field named 'constructor'");
    else if (field.static && $281a441cdcb2cf36$var$checkKeyName(field, "prototype")) this.raise(field.key.start, "Classes can't have a static field named 'prototype'");
    if (this.eat($281a441cdcb2cf36$var$types$1.eq)) {
        this.enterScope($281a441cdcb2cf36$var$SCOPE_CLASS_FIELD_INIT | $281a441cdcb2cf36$var$SCOPE_SUPER);
        field.value = this.parseMaybeAssign();
        this.exitScope();
    } else field.value = null;
    this.semicolon();
    return this.finishNode(field, "PropertyDefinition");
};
$281a441cdcb2cf36$var$pp$8.parseClassStaticBlock = function(node) {
    node.body = [];
    var oldLabels = this.labels;
    this.labels = [];
    this.enterScope($281a441cdcb2cf36$var$SCOPE_CLASS_STATIC_BLOCK | $281a441cdcb2cf36$var$SCOPE_SUPER);
    while(this.type !== $281a441cdcb2cf36$var$types$1.braceR){
        var stmt = this.parseStatement(null);
        node.body.push(stmt);
    }
    this.next();
    this.exitScope();
    this.labels = oldLabels;
    return this.finishNode(node, "StaticBlock");
};
$281a441cdcb2cf36$var$pp$8.parseClassId = function(node, isStatement) {
    if (this.type === $281a441cdcb2cf36$var$types$1.name) {
        node.id = this.parseIdent();
        if (isStatement) this.checkLValSimple(node.id, $281a441cdcb2cf36$var$BIND_LEXICAL, false);
    } else {
        if (isStatement === true) this.unexpected();
        node.id = null;
    }
};
$281a441cdcb2cf36$var$pp$8.parseClassSuper = function(node) {
    node.superClass = this.eat($281a441cdcb2cf36$var$types$1._extends) ? this.parseExprSubscripts(null, false) : null;
};
$281a441cdcb2cf36$var$pp$8.enterClassBody = function() {
    var element2 = {
        declared: /* @__PURE__ */ Object.create(null),
        used: []
    };
    this.privateNameStack.push(element2);
    return element2.declared;
};
$281a441cdcb2cf36$var$pp$8.exitClassBody = function() {
    var ref2 = this.privateNameStack.pop();
    var declared = ref2.declared;
    var used = ref2.used;
    if (!this.options.checkPrivateFields) return;
    var len = this.privateNameStack.length;
    var parent = len === 0 ? null : this.privateNameStack[len - 1];
    for(var i3 = 0; i3 < used.length; ++i3){
        var id2 = used[i3];
        if (!$281a441cdcb2cf36$var$hasOwn(declared, id2.name)) {
            if (parent) parent.used.push(id2);
            else this.raiseRecoverable(id2.start, "Private field '#" + id2.name + "' must be declared in an enclosing class");
        }
    }
};
function $281a441cdcb2cf36$var$isPrivateNameConflicted(privateNameMap, element2) {
    var name = element2.key.name;
    var curr = privateNameMap[name];
    var next = "true";
    if (element2.type === "MethodDefinition" && (element2.kind === "get" || element2.kind === "set")) next = (element2.static ? "s" : "i") + element2.kind;
    if (curr === "iget" && next === "iset" || curr === "iset" && next === "iget" || curr === "sget" && next === "sset" || curr === "sset" && next === "sget") {
        privateNameMap[name] = "true";
        return false;
    } else if (!curr) {
        privateNameMap[name] = next;
        return false;
    } else return true;
}
function $281a441cdcb2cf36$var$checkKeyName(node, name) {
    var computed = node.computed;
    var key = node.key;
    return !computed && (key.type === "Identifier" && key.name === name || key.type === "Literal" && key.value === name);
}
$281a441cdcb2cf36$var$pp$8.parseExportAllDeclaration = function(node, exports) {
    if (this.options.ecmaVersion >= 11) {
        if (this.eatContextual("as")) {
            node.exported = this.parseModuleExportName();
            this.checkExport(exports, node.exported, this.lastTokStart);
        } else node.exported = null;
    }
    this.expectContextual("from");
    if (this.type !== $281a441cdcb2cf36$var$types$1.string) this.unexpected();
    node.source = this.parseExprAtom();
    if (this.options.ecmaVersion >= 16) node.attributes = this.parseWithClause();
    this.semicolon();
    return this.finishNode(node, "ExportAllDeclaration");
};
$281a441cdcb2cf36$var$pp$8.parseExport = function(node, exports) {
    this.next();
    if (this.eat($281a441cdcb2cf36$var$types$1.star)) return this.parseExportAllDeclaration(node, exports);
    if (this.eat($281a441cdcb2cf36$var$types$1._default)) {
        this.checkExport(exports, "default", this.lastTokStart);
        node.declaration = this.parseExportDefaultDeclaration();
        return this.finishNode(node, "ExportDefaultDeclaration");
    }
    if (this.shouldParseExportStatement()) {
        node.declaration = this.parseExportDeclaration(node);
        if (node.declaration.type === "VariableDeclaration") this.checkVariableExport(exports, node.declaration.declarations);
        else this.checkExport(exports, node.declaration.id, node.declaration.id.start);
        node.specifiers = [];
        node.source = null;
        if (this.options.ecmaVersion >= 16) node.attributes = [];
    } else {
        node.declaration = null;
        node.specifiers = this.parseExportSpecifiers(exports);
        if (this.eatContextual("from")) {
            if (this.type !== $281a441cdcb2cf36$var$types$1.string) this.unexpected();
            node.source = this.parseExprAtom();
            if (this.options.ecmaVersion >= 16) node.attributes = this.parseWithClause();
        } else {
            for(var i3 = 0, list = node.specifiers; i3 < list.length; i3 += 1){
                var spec = list[i3];
                this.checkUnreserved(spec.local);
                this.checkLocalExport(spec.local);
                if (spec.local.type === "Literal") this.raise(spec.local.start, "A string literal cannot be used as an exported binding without `from`.");
            }
            node.source = null;
            if (this.options.ecmaVersion >= 16) node.attributes = [];
        }
        this.semicolon();
    }
    return this.finishNode(node, "ExportNamedDeclaration");
};
$281a441cdcb2cf36$var$pp$8.parseExportDeclaration = function(node) {
    return this.parseStatement(null);
};
$281a441cdcb2cf36$var$pp$8.parseExportDefaultDeclaration = function() {
    var isAsync;
    if (this.type === $281a441cdcb2cf36$var$types$1._function || (isAsync = this.isAsyncFunction())) {
        var fNode = this.startNode();
        this.next();
        if (isAsync) this.next();
        return this.parseFunction(fNode, $281a441cdcb2cf36$var$FUNC_STATEMENT | $281a441cdcb2cf36$var$FUNC_NULLABLE_ID, false, isAsync);
    } else if (this.type === $281a441cdcb2cf36$var$types$1._class) {
        var cNode = this.startNode();
        return this.parseClass(cNode, "nullableID");
    } else {
        var declaration = this.parseMaybeAssign();
        this.semicolon();
        return declaration;
    }
};
$281a441cdcb2cf36$var$pp$8.checkExport = function(exports, name, pos) {
    if (!exports) return;
    if (typeof name !== "string") name = name.type === "Identifier" ? name.name : name.value;
    if ($281a441cdcb2cf36$var$hasOwn(exports, name)) this.raiseRecoverable(pos, "Duplicate export '" + name + "'");
    exports[name] = true;
};
$281a441cdcb2cf36$var$pp$8.checkPatternExport = function(exports, pat) {
    var type = pat.type;
    if (type === "Identifier") this.checkExport(exports, pat, pat.start);
    else if (type === "ObjectPattern") for(var i3 = 0, list = pat.properties; i3 < list.length; i3 += 1){
        var prop = list[i3];
        this.checkPatternExport(exports, prop);
    }
    else if (type === "ArrayPattern") for(var i$1 = 0, list$1 = pat.elements; i$1 < list$1.length; i$1 += 1){
        var elt = list$1[i$1];
        if (elt) this.checkPatternExport(exports, elt);
    }
    else if (type === "Property") this.checkPatternExport(exports, pat.value);
    else if (type === "AssignmentPattern") this.checkPatternExport(exports, pat.left);
    else if (type === "RestElement") this.checkPatternExport(exports, pat.argument);
};
$281a441cdcb2cf36$var$pp$8.checkVariableExport = function(exports, decls) {
    if (!exports) return;
    for(var i3 = 0, list = decls; i3 < list.length; i3 += 1){
        var decl = list[i3];
        this.checkPatternExport(exports, decl.id);
    }
};
$281a441cdcb2cf36$var$pp$8.shouldParseExportStatement = function() {
    return this.type.keyword === "var" || this.type.keyword === "const" || this.type.keyword === "class" || this.type.keyword === "function" || this.isLet() || this.isAsyncFunction();
};
$281a441cdcb2cf36$var$pp$8.parseExportSpecifier = function(exports) {
    var node = this.startNode();
    node.local = this.parseModuleExportName();
    node.exported = this.eatContextual("as") ? this.parseModuleExportName() : node.local;
    this.checkExport(exports, node.exported, node.exported.start);
    return this.finishNode(node, "ExportSpecifier");
};
$281a441cdcb2cf36$var$pp$8.parseExportSpecifiers = function(exports) {
    var nodes = [], first = true;
    this.expect($281a441cdcb2cf36$var$types$1.braceL);
    while(!this.eat($281a441cdcb2cf36$var$types$1.braceR)){
        if (!first) {
            this.expect($281a441cdcb2cf36$var$types$1.comma);
            if (this.afterTrailingComma($281a441cdcb2cf36$var$types$1.braceR)) break;
        } else first = false;
        nodes.push(this.parseExportSpecifier(exports));
    }
    return nodes;
};
$281a441cdcb2cf36$var$pp$8.parseImport = function(node) {
    this.next();
    if (this.type === $281a441cdcb2cf36$var$types$1.string) {
        node.specifiers = $281a441cdcb2cf36$var$empty$1;
        node.source = this.parseExprAtom();
    } else {
        node.specifiers = this.parseImportSpecifiers();
        this.expectContextual("from");
        node.source = this.type === $281a441cdcb2cf36$var$types$1.string ? this.parseExprAtom() : this.unexpected();
    }
    if (this.options.ecmaVersion >= 16) node.attributes = this.parseWithClause();
    this.semicolon();
    return this.finishNode(node, "ImportDeclaration");
};
$281a441cdcb2cf36$var$pp$8.parseImportSpecifier = function() {
    var node = this.startNode();
    node.imported = this.parseModuleExportName();
    if (this.eatContextual("as")) node.local = this.parseIdent();
    else {
        this.checkUnreserved(node.imported);
        node.local = node.imported;
    }
    this.checkLValSimple(node.local, $281a441cdcb2cf36$var$BIND_LEXICAL);
    return this.finishNode(node, "ImportSpecifier");
};
$281a441cdcb2cf36$var$pp$8.parseImportDefaultSpecifier = function() {
    var node = this.startNode();
    node.local = this.parseIdent();
    this.checkLValSimple(node.local, $281a441cdcb2cf36$var$BIND_LEXICAL);
    return this.finishNode(node, "ImportDefaultSpecifier");
};
$281a441cdcb2cf36$var$pp$8.parseImportNamespaceSpecifier = function() {
    var node = this.startNode();
    this.next();
    this.expectContextual("as");
    node.local = this.parseIdent();
    this.checkLValSimple(node.local, $281a441cdcb2cf36$var$BIND_LEXICAL);
    return this.finishNode(node, "ImportNamespaceSpecifier");
};
$281a441cdcb2cf36$var$pp$8.parseImportSpecifiers = function() {
    var nodes = [], first = true;
    if (this.type === $281a441cdcb2cf36$var$types$1.name) {
        nodes.push(this.parseImportDefaultSpecifier());
        if (!this.eat($281a441cdcb2cf36$var$types$1.comma)) return nodes;
    }
    if (this.type === $281a441cdcb2cf36$var$types$1.star) {
        nodes.push(this.parseImportNamespaceSpecifier());
        return nodes;
    }
    this.expect($281a441cdcb2cf36$var$types$1.braceL);
    while(!this.eat($281a441cdcb2cf36$var$types$1.braceR)){
        if (!first) {
            this.expect($281a441cdcb2cf36$var$types$1.comma);
            if (this.afterTrailingComma($281a441cdcb2cf36$var$types$1.braceR)) break;
        } else first = false;
        nodes.push(this.parseImportSpecifier());
    }
    return nodes;
};
$281a441cdcb2cf36$var$pp$8.parseWithClause = function() {
    var nodes = [];
    if (!this.eat($281a441cdcb2cf36$var$types$1._with)) return nodes;
    this.expect($281a441cdcb2cf36$var$types$1.braceL);
    var attributeKeys = {};
    var first = true;
    while(!this.eat($281a441cdcb2cf36$var$types$1.braceR)){
        if (!first) {
            this.expect($281a441cdcb2cf36$var$types$1.comma);
            if (this.afterTrailingComma($281a441cdcb2cf36$var$types$1.braceR)) break;
        } else first = false;
        var attr = this.parseImportAttribute();
        var keyName = attr.key.type === "Identifier" ? attr.key.name : attr.key.value;
        if ($281a441cdcb2cf36$var$hasOwn(attributeKeys, keyName)) this.raiseRecoverable(attr.key.start, "Duplicate attribute key '" + keyName + "'");
        attributeKeys[keyName] = true;
        nodes.push(attr);
    }
    return nodes;
};
$281a441cdcb2cf36$var$pp$8.parseImportAttribute = function() {
    var node = this.startNode();
    node.key = this.type === $281a441cdcb2cf36$var$types$1.string ? this.parseExprAtom() : this.parseIdent(this.options.allowReserved !== "never");
    this.expect($281a441cdcb2cf36$var$types$1.colon);
    if (this.type !== $281a441cdcb2cf36$var$types$1.string) this.unexpected();
    node.value = this.parseExprAtom();
    return this.finishNode(node, "ImportAttribute");
};
$281a441cdcb2cf36$var$pp$8.parseModuleExportName = function() {
    if (this.options.ecmaVersion >= 13 && this.type === $281a441cdcb2cf36$var$types$1.string) {
        var stringLiteral = this.parseLiteral(this.value);
        if ($281a441cdcb2cf36$var$loneSurrogate.test(stringLiteral.value)) this.raise(stringLiteral.start, "An export name cannot include a lone surrogate.");
        return stringLiteral;
    }
    return this.parseIdent(true);
};
$281a441cdcb2cf36$var$pp$8.adaptDirectivePrologue = function(statements) {
    for(var i3 = 0; i3 < statements.length && this.isDirectiveCandidate(statements[i3]); ++i3)statements[i3].directive = statements[i3].expression.raw.slice(1, -1);
};
$281a441cdcb2cf36$var$pp$8.isDirectiveCandidate = function(statement) {
    return this.options.ecmaVersion >= 5 && statement.type === "ExpressionStatement" && statement.expression.type === "Literal" && typeof statement.expression.value === "string" && // Reject parenthesized strings.
    (this.input[statement.start] === '"' || this.input[statement.start] === "'");
};
var $281a441cdcb2cf36$var$pp$7 = $281a441cdcb2cf36$var$Parser.prototype;
$281a441cdcb2cf36$var$pp$7.toAssignable = function(node, isBinding, refDestructuringErrors) {
    if (this.options.ecmaVersion >= 6 && node) switch(node.type){
        case "Identifier":
            if (this.inAsync && node.name === "await") this.raise(node.start, "Cannot use 'await' as identifier inside an async function");
            break;
        case "ObjectPattern":
        case "ArrayPattern":
        case "AssignmentPattern":
        case "RestElement":
            break;
        case "ObjectExpression":
            node.type = "ObjectPattern";
            if (refDestructuringErrors) this.checkPatternErrors(refDestructuringErrors, true);
            for(var i3 = 0, list = node.properties; i3 < list.length; i3 += 1){
                var prop = list[i3];
                this.toAssignable(prop, isBinding);
                if (prop.type === "RestElement" && (prop.argument.type === "ArrayPattern" || prop.argument.type === "ObjectPattern")) this.raise(prop.argument.start, "Unexpected token");
            }
            break;
        case "Property":
            if (node.kind !== "init") this.raise(node.key.start, "Object pattern can't contain getter or setter");
            this.toAssignable(node.value, isBinding);
            break;
        case "ArrayExpression":
            node.type = "ArrayPattern";
            if (refDestructuringErrors) this.checkPatternErrors(refDestructuringErrors, true);
            this.toAssignableList(node.elements, isBinding);
            break;
        case "SpreadElement":
            node.type = "RestElement";
            this.toAssignable(node.argument, isBinding);
            if (node.argument.type === "AssignmentPattern") this.raise(node.argument.start, "Rest elements cannot have a default value");
            break;
        case "AssignmentExpression":
            if (node.operator !== "=") this.raise(node.left.end, "Only '=' operator can be used for specifying default value.");
            node.type = "AssignmentPattern";
            delete node.operator;
            this.toAssignable(node.left, isBinding);
            break;
        case "ParenthesizedExpression":
            this.toAssignable(node.expression, isBinding, refDestructuringErrors);
            break;
        case "ChainExpression":
            this.raiseRecoverable(node.start, "Optional chaining cannot appear in left-hand side");
            break;
        case "MemberExpression":
            if (!isBinding) break;
        default:
            this.raise(node.start, "Assigning to rvalue");
    }
    else if (refDestructuringErrors) this.checkPatternErrors(refDestructuringErrors, true);
    return node;
};
$281a441cdcb2cf36$var$pp$7.toAssignableList = function(exprList, isBinding) {
    var end = exprList.length;
    for(var i3 = 0; i3 < end; i3++){
        var elt = exprList[i3];
        if (elt) this.toAssignable(elt, isBinding);
    }
    if (end) {
        var last2 = exprList[end - 1];
        if (this.options.ecmaVersion === 6 && isBinding && last2 && last2.type === "RestElement" && last2.argument.type !== "Identifier") this.unexpected(last2.argument.start);
    }
    return exprList;
};
$281a441cdcb2cf36$var$pp$7.parseSpread = function(refDestructuringErrors) {
    var node = this.startNode();
    this.next();
    node.argument = this.parseMaybeAssign(false, refDestructuringErrors);
    return this.finishNode(node, "SpreadElement");
};
$281a441cdcb2cf36$var$pp$7.parseRestBinding = function() {
    var node = this.startNode();
    this.next();
    if (this.options.ecmaVersion === 6 && this.type !== $281a441cdcb2cf36$var$types$1.name) this.unexpected();
    node.argument = this.parseBindingAtom();
    return this.finishNode(node, "RestElement");
};
$281a441cdcb2cf36$var$pp$7.parseBindingAtom = function() {
    if (this.options.ecmaVersion >= 6) switch(this.type){
        case $281a441cdcb2cf36$var$types$1.bracketL:
            var node = this.startNode();
            this.next();
            node.elements = this.parseBindingList($281a441cdcb2cf36$var$types$1.bracketR, true, true);
            return this.finishNode(node, "ArrayPattern");
        case $281a441cdcb2cf36$var$types$1.braceL:
            return this.parseObj(true);
    }
    return this.parseIdent();
};
$281a441cdcb2cf36$var$pp$7.parseBindingList = function(close, allowEmpty, allowTrailingComma, allowModifiers) {
    var elts = [], first = true;
    while(!this.eat(close)){
        if (first) first = false;
        else this.expect($281a441cdcb2cf36$var$types$1.comma);
        if (allowEmpty && this.type === $281a441cdcb2cf36$var$types$1.comma) elts.push(null);
        else if (allowTrailingComma && this.afterTrailingComma(close)) break;
        else if (this.type === $281a441cdcb2cf36$var$types$1.ellipsis) {
            var rest = this.parseRestBinding();
            this.parseBindingListItem(rest);
            elts.push(rest);
            if (this.type === $281a441cdcb2cf36$var$types$1.comma) this.raiseRecoverable(this.start, "Comma is not permitted after the rest element");
            this.expect(close);
            break;
        } else elts.push(this.parseAssignableListItem(allowModifiers));
    }
    return elts;
};
$281a441cdcb2cf36$var$pp$7.parseAssignableListItem = function(allowModifiers) {
    var elem = this.parseMaybeDefault(this.start, this.startLoc);
    this.parseBindingListItem(elem);
    return elem;
};
$281a441cdcb2cf36$var$pp$7.parseBindingListItem = function(param) {
    return param;
};
$281a441cdcb2cf36$var$pp$7.parseMaybeDefault = function(startPos, startLoc, left) {
    left = left || this.parseBindingAtom();
    if (this.options.ecmaVersion < 6 || !this.eat($281a441cdcb2cf36$var$types$1.eq)) return left;
    var node = this.startNodeAt(startPos, startLoc);
    node.left = left;
    node.right = this.parseMaybeAssign();
    return this.finishNode(node, "AssignmentPattern");
};
$281a441cdcb2cf36$var$pp$7.checkLValSimple = function(expr, bindingType, checkClashes) {
    if (bindingType === void 0) bindingType = $281a441cdcb2cf36$var$BIND_NONE;
    var isBind = bindingType !== $281a441cdcb2cf36$var$BIND_NONE;
    switch(expr.type){
        case "Identifier":
            if (this.strict && this.reservedWordsStrictBind.test(expr.name)) this.raiseRecoverable(expr.start, (isBind ? "Binding " : "Assigning to ") + expr.name + " in strict mode");
            if (isBind) {
                if (bindingType === $281a441cdcb2cf36$var$BIND_LEXICAL && expr.name === "let") this.raiseRecoverable(expr.start, "let is disallowed as a lexically bound name");
                if (checkClashes) {
                    if ($281a441cdcb2cf36$var$hasOwn(checkClashes, expr.name)) this.raiseRecoverable(expr.start, "Argument name clash");
                    checkClashes[expr.name] = true;
                }
                if (bindingType !== $281a441cdcb2cf36$var$BIND_OUTSIDE) this.declareName(expr.name, bindingType, expr.start);
            }
            break;
        case "ChainExpression":
            this.raiseRecoverable(expr.start, "Optional chaining cannot appear in left-hand side");
            break;
        case "MemberExpression":
            if (isBind) this.raiseRecoverable(expr.start, "Binding member expression");
            break;
        case "ParenthesizedExpression":
            if (isBind) this.raiseRecoverable(expr.start, "Binding parenthesized expression");
            return this.checkLValSimple(expr.expression, bindingType, checkClashes);
        default:
            this.raise(expr.start, (isBind ? "Binding" : "Assigning to") + " rvalue");
    }
};
$281a441cdcb2cf36$var$pp$7.checkLValPattern = function(expr, bindingType, checkClashes) {
    if (bindingType === void 0) bindingType = $281a441cdcb2cf36$var$BIND_NONE;
    switch(expr.type){
        case "ObjectPattern":
            for(var i3 = 0, list = expr.properties; i3 < list.length; i3 += 1){
                var prop = list[i3];
                this.checkLValInnerPattern(prop, bindingType, checkClashes);
            }
            break;
        case "ArrayPattern":
            for(var i$1 = 0, list$1 = expr.elements; i$1 < list$1.length; i$1 += 1){
                var elem = list$1[i$1];
                if (elem) this.checkLValInnerPattern(elem, bindingType, checkClashes);
            }
            break;
        default:
            this.checkLValSimple(expr, bindingType, checkClashes);
    }
};
$281a441cdcb2cf36$var$pp$7.checkLValInnerPattern = function(expr, bindingType, checkClashes) {
    if (bindingType === void 0) bindingType = $281a441cdcb2cf36$var$BIND_NONE;
    switch(expr.type){
        case "Property":
            this.checkLValInnerPattern(expr.value, bindingType, checkClashes);
            break;
        case "AssignmentPattern":
            this.checkLValPattern(expr.left, bindingType, checkClashes);
            break;
        case "RestElement":
            this.checkLValPattern(expr.argument, bindingType, checkClashes);
            break;
        default:
            this.checkLValPattern(expr, bindingType, checkClashes);
    }
};
var $281a441cdcb2cf36$var$TokContext = function TokContext2(token, isExpr, preserveSpace, override, generator) {
    this.token = token;
    this.isExpr = !!isExpr;
    this.preserveSpace = !!preserveSpace;
    this.override = override;
    this.generator = !!generator;
};
var $281a441cdcb2cf36$var$types = {
    b_stat: new $281a441cdcb2cf36$var$TokContext("{", false),
    b_expr: new $281a441cdcb2cf36$var$TokContext("{", true),
    b_tmpl: new $281a441cdcb2cf36$var$TokContext("${", false),
    p_stat: new $281a441cdcb2cf36$var$TokContext("(", false),
    p_expr: new $281a441cdcb2cf36$var$TokContext("(", true),
    q_tmpl: new $281a441cdcb2cf36$var$TokContext("`", true, true, function(p3) {
        return p3.tryReadTemplateToken();
    }),
    f_stat: new $281a441cdcb2cf36$var$TokContext("function", false),
    f_expr: new $281a441cdcb2cf36$var$TokContext("function", true),
    f_expr_gen: new $281a441cdcb2cf36$var$TokContext("function", true, false, null, true),
    f_gen: new $281a441cdcb2cf36$var$TokContext("function", false, false, null, true)
};
var $281a441cdcb2cf36$var$pp$6 = $281a441cdcb2cf36$var$Parser.prototype;
$281a441cdcb2cf36$var$pp$6.initialContext = function() {
    return [
        $281a441cdcb2cf36$var$types.b_stat
    ];
};
$281a441cdcb2cf36$var$pp$6.curContext = function() {
    return this.context[this.context.length - 1];
};
$281a441cdcb2cf36$var$pp$6.braceIsBlock = function(prevType) {
    var parent = this.curContext();
    if (parent === $281a441cdcb2cf36$var$types.f_expr || parent === $281a441cdcb2cf36$var$types.f_stat) return true;
    if (prevType === $281a441cdcb2cf36$var$types$1.colon && (parent === $281a441cdcb2cf36$var$types.b_stat || parent === $281a441cdcb2cf36$var$types.b_expr)) return !parent.isExpr;
    if (prevType === $281a441cdcb2cf36$var$types$1._return || prevType === $281a441cdcb2cf36$var$types$1.name && this.exprAllowed) return $281a441cdcb2cf36$var$lineBreak.test(this.input.slice(this.lastTokEnd, this.start));
    if (prevType === $281a441cdcb2cf36$var$types$1._else || prevType === $281a441cdcb2cf36$var$types$1.semi || prevType === $281a441cdcb2cf36$var$types$1.eof || prevType === $281a441cdcb2cf36$var$types$1.parenR || prevType === $281a441cdcb2cf36$var$types$1.arrow) return true;
    if (prevType === $281a441cdcb2cf36$var$types$1.braceL) return parent === $281a441cdcb2cf36$var$types.b_stat;
    if (prevType === $281a441cdcb2cf36$var$types$1._var || prevType === $281a441cdcb2cf36$var$types$1._const || prevType === $281a441cdcb2cf36$var$types$1.name) return false;
    return !this.exprAllowed;
};
$281a441cdcb2cf36$var$pp$6.inGeneratorContext = function() {
    for(var i3 = this.context.length - 1; i3 >= 1; i3--){
        var context2 = this.context[i3];
        if (context2.token === "function") return context2.generator;
    }
    return false;
};
$281a441cdcb2cf36$var$pp$6.updateContext = function(prevType) {
    var update, type = this.type;
    if (type.keyword && prevType === $281a441cdcb2cf36$var$types$1.dot) this.exprAllowed = false;
    else if (update = type.updateContext) update.call(this, prevType);
    else this.exprAllowed = type.beforeExpr;
};
$281a441cdcb2cf36$var$pp$6.overrideContext = function(tokenCtx) {
    if (this.curContext() !== tokenCtx) this.context[this.context.length - 1] = tokenCtx;
};
$281a441cdcb2cf36$var$types$1.parenR.updateContext = $281a441cdcb2cf36$var$types$1.braceR.updateContext = function() {
    if (this.context.length === 1) {
        this.exprAllowed = true;
        return;
    }
    var out = this.context.pop();
    if (out === $281a441cdcb2cf36$var$types.b_stat && this.curContext().token === "function") out = this.context.pop();
    this.exprAllowed = !out.isExpr;
};
$281a441cdcb2cf36$var$types$1.braceL.updateContext = function(prevType) {
    this.context.push(this.braceIsBlock(prevType) ? $281a441cdcb2cf36$var$types.b_stat : $281a441cdcb2cf36$var$types.b_expr);
    this.exprAllowed = true;
};
$281a441cdcb2cf36$var$types$1.dollarBraceL.updateContext = function() {
    this.context.push($281a441cdcb2cf36$var$types.b_tmpl);
    this.exprAllowed = true;
};
$281a441cdcb2cf36$var$types$1.parenL.updateContext = function(prevType) {
    var statementParens = prevType === $281a441cdcb2cf36$var$types$1._if || prevType === $281a441cdcb2cf36$var$types$1._for || prevType === $281a441cdcb2cf36$var$types$1._with || prevType === $281a441cdcb2cf36$var$types$1._while;
    this.context.push(statementParens ? $281a441cdcb2cf36$var$types.p_stat : $281a441cdcb2cf36$var$types.p_expr);
    this.exprAllowed = true;
};
$281a441cdcb2cf36$var$types$1.incDec.updateContext = function() {};
$281a441cdcb2cf36$var$types$1._function.updateContext = $281a441cdcb2cf36$var$types$1._class.updateContext = function(prevType) {
    if (prevType.beforeExpr && prevType !== $281a441cdcb2cf36$var$types$1._else && !(prevType === $281a441cdcb2cf36$var$types$1.semi && this.curContext() !== $281a441cdcb2cf36$var$types.p_stat) && !(prevType === $281a441cdcb2cf36$var$types$1._return && $281a441cdcb2cf36$var$lineBreak.test(this.input.slice(this.lastTokEnd, this.start))) && !((prevType === $281a441cdcb2cf36$var$types$1.colon || prevType === $281a441cdcb2cf36$var$types$1.braceL) && this.curContext() === $281a441cdcb2cf36$var$types.b_stat)) this.context.push($281a441cdcb2cf36$var$types.f_expr);
    else this.context.push($281a441cdcb2cf36$var$types.f_stat);
    this.exprAllowed = false;
};
$281a441cdcb2cf36$var$types$1.colon.updateContext = function() {
    if (this.curContext().token === "function") this.context.pop();
    this.exprAllowed = true;
};
$281a441cdcb2cf36$var$types$1.backQuote.updateContext = function() {
    if (this.curContext() === $281a441cdcb2cf36$var$types.q_tmpl) this.context.pop();
    else this.context.push($281a441cdcb2cf36$var$types.q_tmpl);
    this.exprAllowed = false;
};
$281a441cdcb2cf36$var$types$1.star.updateContext = function(prevType) {
    if (prevType === $281a441cdcb2cf36$var$types$1._function) {
        var index = this.context.length - 1;
        if (this.context[index] === $281a441cdcb2cf36$var$types.f_expr) this.context[index] = $281a441cdcb2cf36$var$types.f_expr_gen;
        else this.context[index] = $281a441cdcb2cf36$var$types.f_gen;
    }
    this.exprAllowed = true;
};
$281a441cdcb2cf36$var$types$1.name.updateContext = function(prevType) {
    var allowed = false;
    if (this.options.ecmaVersion >= 6 && prevType !== $281a441cdcb2cf36$var$types$1.dot) {
        if (this.value === "of" && !this.exprAllowed || this.value === "yield" && this.inGeneratorContext()) allowed = true;
    }
    this.exprAllowed = allowed;
};
var $281a441cdcb2cf36$var$pp$5 = $281a441cdcb2cf36$var$Parser.prototype;
$281a441cdcb2cf36$var$pp$5.checkPropClash = function(prop, propHash, refDestructuringErrors) {
    if (this.options.ecmaVersion >= 9 && prop.type === "SpreadElement") return;
    if (this.options.ecmaVersion >= 6 && (prop.computed || prop.method || prop.shorthand)) return;
    var key = prop.key;
    var name;
    switch(key.type){
        case "Identifier":
            name = key.name;
            break;
        case "Literal":
            name = String(key.value);
            break;
        default:
            return;
    }
    var kind = prop.kind;
    if (this.options.ecmaVersion >= 6) {
        if (name === "__proto__" && kind === "init") {
            if (propHash.proto) {
                if (refDestructuringErrors) {
                    if (refDestructuringErrors.doubleProto < 0) refDestructuringErrors.doubleProto = key.start;
                } else this.raiseRecoverable(key.start, "Redefinition of __proto__ property");
            }
            propHash.proto = true;
        }
        return;
    }
    name = "$" + name;
    var other = propHash[name];
    if (other) {
        var redefinition;
        if (kind === "init") redefinition = this.strict && other.init || other.get || other.set;
        else redefinition = other.init || other[kind];
        if (redefinition) this.raiseRecoverable(key.start, "Redefinition of property");
    } else other = propHash[name] = {
        init: false,
        get: false,
        set: false
    };
    other[kind] = true;
};
$281a441cdcb2cf36$var$pp$5.parseExpression = function(forInit, refDestructuringErrors) {
    var startPos = this.start, startLoc = this.startLoc;
    var expr = this.parseMaybeAssign(forInit, refDestructuringErrors);
    if (this.type === $281a441cdcb2cf36$var$types$1.comma) {
        var node = this.startNodeAt(startPos, startLoc);
        node.expressions = [
            expr
        ];
        while(this.eat($281a441cdcb2cf36$var$types$1.comma))node.expressions.push(this.parseMaybeAssign(forInit, refDestructuringErrors));
        return this.finishNode(node, "SequenceExpression");
    }
    return expr;
};
$281a441cdcb2cf36$var$pp$5.parseMaybeAssign = function(forInit, refDestructuringErrors, afterLeftParse) {
    if (this.isContextual("yield")) {
        if (this.inGenerator) return this.parseYield(forInit);
        else this.exprAllowed = false;
    }
    var ownDestructuringErrors = false, oldParenAssign = -1, oldTrailingComma = -1, oldDoubleProto = -1;
    if (refDestructuringErrors) {
        oldParenAssign = refDestructuringErrors.parenthesizedAssign;
        oldTrailingComma = refDestructuringErrors.trailingComma;
        oldDoubleProto = refDestructuringErrors.doubleProto;
        refDestructuringErrors.parenthesizedAssign = refDestructuringErrors.trailingComma = -1;
    } else {
        refDestructuringErrors = new $281a441cdcb2cf36$var$DestructuringErrors();
        ownDestructuringErrors = true;
    }
    var startPos = this.start, startLoc = this.startLoc;
    if (this.type === $281a441cdcb2cf36$var$types$1.parenL || this.type === $281a441cdcb2cf36$var$types$1.name) {
        this.potentialArrowAt = this.start;
        this.potentialArrowInForAwait = forInit === "await";
    }
    var left = this.parseMaybeConditional(forInit, refDestructuringErrors);
    if (afterLeftParse) left = afterLeftParse.call(this, left, startPos, startLoc);
    if (this.type.isAssign) {
        var node = this.startNodeAt(startPos, startLoc);
        node.operator = this.value;
        if (this.type === $281a441cdcb2cf36$var$types$1.eq) left = this.toAssignable(left, false, refDestructuringErrors);
        if (!ownDestructuringErrors) refDestructuringErrors.parenthesizedAssign = refDestructuringErrors.trailingComma = refDestructuringErrors.doubleProto = -1;
        if (refDestructuringErrors.shorthandAssign >= left.start) refDestructuringErrors.shorthandAssign = -1;
        if (this.type === $281a441cdcb2cf36$var$types$1.eq) this.checkLValPattern(left);
        else this.checkLValSimple(left);
        node.left = left;
        this.next();
        node.right = this.parseMaybeAssign(forInit);
        if (oldDoubleProto > -1) refDestructuringErrors.doubleProto = oldDoubleProto;
        return this.finishNode(node, "AssignmentExpression");
    } else if (ownDestructuringErrors) this.checkExpressionErrors(refDestructuringErrors, true);
    if (oldParenAssign > -1) refDestructuringErrors.parenthesizedAssign = oldParenAssign;
    if (oldTrailingComma > -1) refDestructuringErrors.trailingComma = oldTrailingComma;
    return left;
};
$281a441cdcb2cf36$var$pp$5.parseMaybeConditional = function(forInit, refDestructuringErrors) {
    var startPos = this.start, startLoc = this.startLoc;
    var expr = this.parseExprOps(forInit, refDestructuringErrors);
    if (this.checkExpressionErrors(refDestructuringErrors)) return expr;
    if (this.eat($281a441cdcb2cf36$var$types$1.question)) {
        var node = this.startNodeAt(startPos, startLoc);
        node.test = expr;
        node.consequent = this.parseMaybeAssign();
        this.expect($281a441cdcb2cf36$var$types$1.colon);
        node.alternate = this.parseMaybeAssign(forInit);
        return this.finishNode(node, "ConditionalExpression");
    }
    return expr;
};
$281a441cdcb2cf36$var$pp$5.parseExprOps = function(forInit, refDestructuringErrors) {
    var startPos = this.start, startLoc = this.startLoc;
    var expr = this.parseMaybeUnary(refDestructuringErrors, false, false, forInit);
    if (this.checkExpressionErrors(refDestructuringErrors)) return expr;
    return expr.start === startPos && expr.type === "ArrowFunctionExpression" ? expr : this.parseExprOp(expr, startPos, startLoc, -1, forInit);
};
$281a441cdcb2cf36$var$pp$5.parseExprOp = function(left, leftStartPos, leftStartLoc, minPrec, forInit) {
    var prec = this.type.binop;
    if (prec != null && (!forInit || this.type !== $281a441cdcb2cf36$var$types$1._in)) {
        if (prec > minPrec) {
            var logical = this.type === $281a441cdcb2cf36$var$types$1.logicalOR || this.type === $281a441cdcb2cf36$var$types$1.logicalAND;
            var coalesce = this.type === $281a441cdcb2cf36$var$types$1.coalesce;
            if (coalesce) prec = $281a441cdcb2cf36$var$types$1.logicalAND.binop;
            var op = this.value;
            this.next();
            var startPos = this.start, startLoc = this.startLoc;
            var right = this.parseExprOp(this.parseMaybeUnary(null, false, false, forInit), startPos, startLoc, prec, forInit);
            var node = this.buildBinary(leftStartPos, leftStartLoc, left, right, op, logical || coalesce);
            if (logical && this.type === $281a441cdcb2cf36$var$types$1.coalesce || coalesce && (this.type === $281a441cdcb2cf36$var$types$1.logicalOR || this.type === $281a441cdcb2cf36$var$types$1.logicalAND)) this.raiseRecoverable(this.start, "Logical expressions and coalesce expressions cannot be mixed. Wrap either by parentheses");
            return this.parseExprOp(node, leftStartPos, leftStartLoc, minPrec, forInit);
        }
    }
    return left;
};
$281a441cdcb2cf36$var$pp$5.buildBinary = function(startPos, startLoc, left, right, op, logical) {
    if (right.type === "PrivateIdentifier") this.raise(right.start, "Private identifier can only be left side of binary expression");
    var node = this.startNodeAt(startPos, startLoc);
    node.left = left;
    node.operator = op;
    node.right = right;
    return this.finishNode(node, logical ? "LogicalExpression" : "BinaryExpression");
};
$281a441cdcb2cf36$var$pp$5.parseMaybeUnary = function(refDestructuringErrors, sawUnary, incDec, forInit) {
    var startPos = this.start, startLoc = this.startLoc, expr;
    if (this.isContextual("await") && this.canAwait) {
        expr = this.parseAwait(forInit);
        sawUnary = true;
    } else if (this.type.prefix) {
        var node = this.startNode(), update = this.type === $281a441cdcb2cf36$var$types$1.incDec;
        node.operator = this.value;
        node.prefix = true;
        this.next();
        node.argument = this.parseMaybeUnary(null, true, update, forInit);
        this.checkExpressionErrors(refDestructuringErrors, true);
        if (update) this.checkLValSimple(node.argument);
        else if (this.strict && node.operator === "delete" && $281a441cdcb2cf36$var$isLocalVariableAccess(node.argument)) this.raiseRecoverable(node.start, "Deleting local variable in strict mode");
        else if (node.operator === "delete" && $281a441cdcb2cf36$var$isPrivateFieldAccess(node.argument)) this.raiseRecoverable(node.start, "Private fields can not be deleted");
        else sawUnary = true;
        expr = this.finishNode(node, update ? "UpdateExpression" : "UnaryExpression");
    } else if (!sawUnary && this.type === $281a441cdcb2cf36$var$types$1.privateId) {
        if ((forInit || this.privateNameStack.length === 0) && this.options.checkPrivateFields) this.unexpected();
        expr = this.parsePrivateIdent();
        if (this.type !== $281a441cdcb2cf36$var$types$1._in) this.unexpected();
    } else {
        expr = this.parseExprSubscripts(refDestructuringErrors, forInit);
        if (this.checkExpressionErrors(refDestructuringErrors)) return expr;
        while(this.type.postfix && !this.canInsertSemicolon()){
            var node$1 = this.startNodeAt(startPos, startLoc);
            node$1.operator = this.value;
            node$1.prefix = false;
            node$1.argument = expr;
            this.checkLValSimple(expr);
            this.next();
            expr = this.finishNode(node$1, "UpdateExpression");
        }
    }
    if (!incDec && this.eat($281a441cdcb2cf36$var$types$1.starstar)) {
        if (sawUnary) this.unexpected(this.lastTokStart);
        else return this.buildBinary(startPos, startLoc, expr, this.parseMaybeUnary(null, false, false, forInit), "**", false);
    } else return expr;
};
function $281a441cdcb2cf36$var$isLocalVariableAccess(node) {
    return node.type === "Identifier" || node.type === "ParenthesizedExpression" && $281a441cdcb2cf36$var$isLocalVariableAccess(node.expression);
}
function $281a441cdcb2cf36$var$isPrivateFieldAccess(node) {
    return node.type === "MemberExpression" && node.property.type === "PrivateIdentifier" || node.type === "ChainExpression" && $281a441cdcb2cf36$var$isPrivateFieldAccess(node.expression) || node.type === "ParenthesizedExpression" && $281a441cdcb2cf36$var$isPrivateFieldAccess(node.expression);
}
$281a441cdcb2cf36$var$pp$5.parseExprSubscripts = function(refDestructuringErrors, forInit) {
    var startPos = this.start, startLoc = this.startLoc;
    var expr = this.parseExprAtom(refDestructuringErrors, forInit);
    if (expr.type === "ArrowFunctionExpression" && this.input.slice(this.lastTokStart, this.lastTokEnd) !== ")") return expr;
    var result = this.parseSubscripts(expr, startPos, startLoc, false, forInit);
    if (refDestructuringErrors && result.type === "MemberExpression") {
        if (refDestructuringErrors.parenthesizedAssign >= result.start) refDestructuringErrors.parenthesizedAssign = -1;
        if (refDestructuringErrors.parenthesizedBind >= result.start) refDestructuringErrors.parenthesizedBind = -1;
        if (refDestructuringErrors.trailingComma >= result.start) refDestructuringErrors.trailingComma = -1;
    }
    return result;
};
$281a441cdcb2cf36$var$pp$5.parseSubscripts = function(base2, startPos, startLoc, noCalls, forInit) {
    var maybeAsyncArrow = this.options.ecmaVersion >= 8 && base2.type === "Identifier" && base2.name === "async" && this.lastTokEnd === base2.end && !this.canInsertSemicolon() && base2.end - base2.start === 5 && this.potentialArrowAt === base2.start;
    var optionalChained = false;
    while(true){
        var element2 = this.parseSubscript(base2, startPos, startLoc, noCalls, maybeAsyncArrow, optionalChained, forInit);
        if (element2.optional) optionalChained = true;
        if (element2 === base2 || element2.type === "ArrowFunctionExpression") {
            if (optionalChained) {
                var chainNode = this.startNodeAt(startPos, startLoc);
                chainNode.expression = element2;
                element2 = this.finishNode(chainNode, "ChainExpression");
            }
            return element2;
        }
        base2 = element2;
    }
};
$281a441cdcb2cf36$var$pp$5.shouldParseAsyncArrow = function() {
    return !this.canInsertSemicolon() && this.eat($281a441cdcb2cf36$var$types$1.arrow);
};
$281a441cdcb2cf36$var$pp$5.parseSubscriptAsyncArrow = function(startPos, startLoc, exprList, forInit) {
    return this.parseArrowExpression(this.startNodeAt(startPos, startLoc), exprList, true, forInit);
};
$281a441cdcb2cf36$var$pp$5.parseSubscript = function(base2, startPos, startLoc, noCalls, maybeAsyncArrow, optionalChained, forInit) {
    var optionalSupported = this.options.ecmaVersion >= 11;
    var optional = optionalSupported && this.eat($281a441cdcb2cf36$var$types$1.questionDot);
    if (noCalls && optional) this.raise(this.lastTokStart, "Optional chaining cannot appear in the callee of new expressions");
    var computed = this.eat($281a441cdcb2cf36$var$types$1.bracketL);
    if (computed || optional && this.type !== $281a441cdcb2cf36$var$types$1.parenL && this.type !== $281a441cdcb2cf36$var$types$1.backQuote || this.eat($281a441cdcb2cf36$var$types$1.dot)) {
        var node = this.startNodeAt(startPos, startLoc);
        node.object = base2;
        if (computed) {
            node.property = this.parseExpression();
            this.expect($281a441cdcb2cf36$var$types$1.bracketR);
        } else if (this.type === $281a441cdcb2cf36$var$types$1.privateId && base2.type !== "Super") node.property = this.parsePrivateIdent();
        else node.property = this.parseIdent(this.options.allowReserved !== "never");
        node.computed = !!computed;
        if (optionalSupported) node.optional = optional;
        base2 = this.finishNode(node, "MemberExpression");
    } else if (!noCalls && this.eat($281a441cdcb2cf36$var$types$1.parenL)) {
        var refDestructuringErrors = new $281a441cdcb2cf36$var$DestructuringErrors(), oldYieldPos = this.yieldPos, oldAwaitPos = this.awaitPos, oldAwaitIdentPos = this.awaitIdentPos;
        this.yieldPos = 0;
        this.awaitPos = 0;
        this.awaitIdentPos = 0;
        var exprList = this.parseExprList($281a441cdcb2cf36$var$types$1.parenR, this.options.ecmaVersion >= 8, false, refDestructuringErrors);
        if (maybeAsyncArrow && !optional && this.shouldParseAsyncArrow()) {
            this.checkPatternErrors(refDestructuringErrors, false);
            this.checkYieldAwaitInDefaultParams();
            if (this.awaitIdentPos > 0) this.raise(this.awaitIdentPos, "Cannot use 'await' as identifier inside an async function");
            this.yieldPos = oldYieldPos;
            this.awaitPos = oldAwaitPos;
            this.awaitIdentPos = oldAwaitIdentPos;
            return this.parseSubscriptAsyncArrow(startPos, startLoc, exprList, forInit);
        }
        this.checkExpressionErrors(refDestructuringErrors, true);
        this.yieldPos = oldYieldPos || this.yieldPos;
        this.awaitPos = oldAwaitPos || this.awaitPos;
        this.awaitIdentPos = oldAwaitIdentPos || this.awaitIdentPos;
        var node$1 = this.startNodeAt(startPos, startLoc);
        node$1.callee = base2;
        node$1.arguments = exprList;
        if (optionalSupported) node$1.optional = optional;
        base2 = this.finishNode(node$1, "CallExpression");
    } else if (this.type === $281a441cdcb2cf36$var$types$1.backQuote) {
        if (optional || optionalChained) this.raise(this.start, "Optional chaining cannot appear in the tag of tagged template expressions");
        var node$2 = this.startNodeAt(startPos, startLoc);
        node$2.tag = base2;
        node$2.quasi = this.parseTemplate({
            isTagged: true
        });
        base2 = this.finishNode(node$2, "TaggedTemplateExpression");
    }
    return base2;
};
$281a441cdcb2cf36$var$pp$5.parseExprAtom = function(refDestructuringErrors, forInit, forNew) {
    if (this.type === $281a441cdcb2cf36$var$types$1.slash) this.readRegexp();
    var node, canBeArrow = this.potentialArrowAt === this.start;
    switch(this.type){
        case $281a441cdcb2cf36$var$types$1._super:
            if (!this.allowSuper) this.raise(this.start, "'super' keyword outside a method");
            node = this.startNode();
            this.next();
            if (this.type === $281a441cdcb2cf36$var$types$1.parenL && !this.allowDirectSuper) this.raise(node.start, "super() call outside constructor of a subclass");
            if (this.type !== $281a441cdcb2cf36$var$types$1.dot && this.type !== $281a441cdcb2cf36$var$types$1.bracketL && this.type !== $281a441cdcb2cf36$var$types$1.parenL) this.unexpected();
            return this.finishNode(node, "Super");
        case $281a441cdcb2cf36$var$types$1._this:
            node = this.startNode();
            this.next();
            return this.finishNode(node, "ThisExpression");
        case $281a441cdcb2cf36$var$types$1.name:
            var startPos = this.start, startLoc = this.startLoc, containsEsc = this.containsEsc;
            var id2 = this.parseIdent(false);
            if (this.options.ecmaVersion >= 8 && !containsEsc && id2.name === "async" && !this.canInsertSemicolon() && this.eat($281a441cdcb2cf36$var$types$1._function)) {
                this.overrideContext($281a441cdcb2cf36$var$types.f_expr);
                return this.parseFunction(this.startNodeAt(startPos, startLoc), 0, false, true, forInit);
            }
            if (canBeArrow && !this.canInsertSemicolon()) {
                if (this.eat($281a441cdcb2cf36$var$types$1.arrow)) return this.parseArrowExpression(this.startNodeAt(startPos, startLoc), [
                    id2
                ], false, forInit);
                if (this.options.ecmaVersion >= 8 && id2.name === "async" && this.type === $281a441cdcb2cf36$var$types$1.name && !containsEsc && (!this.potentialArrowInForAwait || this.value !== "of" || this.containsEsc)) {
                    id2 = this.parseIdent(false);
                    if (this.canInsertSemicolon() || !this.eat($281a441cdcb2cf36$var$types$1.arrow)) this.unexpected();
                    return this.parseArrowExpression(this.startNodeAt(startPos, startLoc), [
                        id2
                    ], true, forInit);
                }
            }
            return id2;
        case $281a441cdcb2cf36$var$types$1.regexp:
            var value2 = this.value;
            node = this.parseLiteral(value2.value);
            node.regex = {
                pattern: value2.pattern,
                flags: value2.flags
            };
            return node;
        case $281a441cdcb2cf36$var$types$1.num:
        case $281a441cdcb2cf36$var$types$1.string:
            return this.parseLiteral(this.value);
        case $281a441cdcb2cf36$var$types$1._null:
        case $281a441cdcb2cf36$var$types$1._true:
        case $281a441cdcb2cf36$var$types$1._false:
            node = this.startNode();
            node.value = this.type === $281a441cdcb2cf36$var$types$1._null ? null : this.type === $281a441cdcb2cf36$var$types$1._true;
            node.raw = this.type.keyword;
            this.next();
            return this.finishNode(node, "Literal");
        case $281a441cdcb2cf36$var$types$1.parenL:
            var start = this.start, expr = this.parseParenAndDistinguishExpression(canBeArrow, forInit);
            if (refDestructuringErrors) {
                if (refDestructuringErrors.parenthesizedAssign < 0 && !this.isSimpleAssignTarget(expr)) refDestructuringErrors.parenthesizedAssign = start;
                if (refDestructuringErrors.parenthesizedBind < 0) refDestructuringErrors.parenthesizedBind = start;
            }
            return expr;
        case $281a441cdcb2cf36$var$types$1.bracketL:
            node = this.startNode();
            this.next();
            node.elements = this.parseExprList($281a441cdcb2cf36$var$types$1.bracketR, true, true, refDestructuringErrors);
            return this.finishNode(node, "ArrayExpression");
        case $281a441cdcb2cf36$var$types$1.braceL:
            this.overrideContext($281a441cdcb2cf36$var$types.b_expr);
            return this.parseObj(false, refDestructuringErrors);
        case $281a441cdcb2cf36$var$types$1._function:
            node = this.startNode();
            this.next();
            return this.parseFunction(node, 0);
        case $281a441cdcb2cf36$var$types$1._class:
            return this.parseClass(this.startNode(), false);
        case $281a441cdcb2cf36$var$types$1._new:
            return this.parseNew();
        case $281a441cdcb2cf36$var$types$1.backQuote:
            return this.parseTemplate();
        case $281a441cdcb2cf36$var$types$1._import:
            if (this.options.ecmaVersion >= 11) return this.parseExprImport(forNew);
            else return this.unexpected();
        default:
            return this.parseExprAtomDefault();
    }
};
$281a441cdcb2cf36$var$pp$5.parseExprAtomDefault = function() {
    this.unexpected();
};
$281a441cdcb2cf36$var$pp$5.parseExprImport = function(forNew) {
    var node = this.startNode();
    if (this.containsEsc) this.raiseRecoverable(this.start, "Escape sequence in keyword import");
    this.next();
    if (this.type === $281a441cdcb2cf36$var$types$1.parenL && !forNew) return this.parseDynamicImport(node);
    else if (this.type === $281a441cdcb2cf36$var$types$1.dot) {
        var meta = this.startNodeAt(node.start, node.loc && node.loc.start);
        meta.name = "import";
        node.meta = this.finishNode(meta, "Identifier");
        return this.parseImportMeta(node);
    } else this.unexpected();
};
$281a441cdcb2cf36$var$pp$5.parseDynamicImport = function(node) {
    this.next();
    node.source = this.parseMaybeAssign();
    if (this.options.ecmaVersion >= 16) {
        if (!this.eat($281a441cdcb2cf36$var$types$1.parenR)) {
            this.expect($281a441cdcb2cf36$var$types$1.comma);
            if (!this.afterTrailingComma($281a441cdcb2cf36$var$types$1.parenR)) {
                node.options = this.parseMaybeAssign();
                if (!this.eat($281a441cdcb2cf36$var$types$1.parenR)) {
                    this.expect($281a441cdcb2cf36$var$types$1.comma);
                    if (!this.afterTrailingComma($281a441cdcb2cf36$var$types$1.parenR)) this.unexpected();
                }
            } else node.options = null;
        } else node.options = null;
    } else if (!this.eat($281a441cdcb2cf36$var$types$1.parenR)) {
        var errorPos = this.start;
        if (this.eat($281a441cdcb2cf36$var$types$1.comma) && this.eat($281a441cdcb2cf36$var$types$1.parenR)) this.raiseRecoverable(errorPos, "Trailing comma is not allowed in import()");
        else this.unexpected(errorPos);
    }
    return this.finishNode(node, "ImportExpression");
};
$281a441cdcb2cf36$var$pp$5.parseImportMeta = function(node) {
    this.next();
    var containsEsc = this.containsEsc;
    node.property = this.parseIdent(true);
    if (node.property.name !== "meta") this.raiseRecoverable(node.property.start, "The only valid meta property for import is 'import.meta'");
    if (containsEsc) this.raiseRecoverable(node.start, "'import.meta' must not contain escaped characters");
    if (this.options.sourceType !== "module" && !this.options.allowImportExportEverywhere) this.raiseRecoverable(node.start, "Cannot use 'import.meta' outside a module");
    return this.finishNode(node, "MetaProperty");
};
$281a441cdcb2cf36$var$pp$5.parseLiteral = function(value2) {
    var node = this.startNode();
    node.value = value2;
    node.raw = this.input.slice(this.start, this.end);
    if (node.raw.charCodeAt(node.raw.length - 1) === 110) node.bigint = node.value != null ? node.value.toString() : node.raw.slice(0, -1).replace(/_/g, "");
    this.next();
    return this.finishNode(node, "Literal");
};
$281a441cdcb2cf36$var$pp$5.parseParenExpression = function() {
    this.expect($281a441cdcb2cf36$var$types$1.parenL);
    var val = this.parseExpression();
    this.expect($281a441cdcb2cf36$var$types$1.parenR);
    return val;
};
$281a441cdcb2cf36$var$pp$5.shouldParseArrow = function(exprList) {
    return !this.canInsertSemicolon();
};
$281a441cdcb2cf36$var$pp$5.parseParenAndDistinguishExpression = function(canBeArrow, forInit) {
    var startPos = this.start, startLoc = this.startLoc, val, allowTrailingComma = this.options.ecmaVersion >= 8;
    if (this.options.ecmaVersion >= 6) {
        this.next();
        var innerStartPos = this.start, innerStartLoc = this.startLoc;
        var exprList = [], first = true, lastIsComma = false;
        var refDestructuringErrors = new $281a441cdcb2cf36$var$DestructuringErrors(), oldYieldPos = this.yieldPos, oldAwaitPos = this.awaitPos, spreadStart;
        this.yieldPos = 0;
        this.awaitPos = 0;
        while(this.type !== $281a441cdcb2cf36$var$types$1.parenR){
            first ? first = false : this.expect($281a441cdcb2cf36$var$types$1.comma);
            if (allowTrailingComma && this.afterTrailingComma($281a441cdcb2cf36$var$types$1.parenR, true)) {
                lastIsComma = true;
                break;
            } else if (this.type === $281a441cdcb2cf36$var$types$1.ellipsis) {
                spreadStart = this.start;
                exprList.push(this.parseParenItem(this.parseRestBinding()));
                if (this.type === $281a441cdcb2cf36$var$types$1.comma) this.raiseRecoverable(this.start, "Comma is not permitted after the rest element");
                break;
            } else exprList.push(this.parseMaybeAssign(false, refDestructuringErrors, this.parseParenItem));
        }
        var innerEndPos = this.lastTokEnd, innerEndLoc = this.lastTokEndLoc;
        this.expect($281a441cdcb2cf36$var$types$1.parenR);
        if (canBeArrow && this.shouldParseArrow(exprList) && this.eat($281a441cdcb2cf36$var$types$1.arrow)) {
            this.checkPatternErrors(refDestructuringErrors, false);
            this.checkYieldAwaitInDefaultParams();
            this.yieldPos = oldYieldPos;
            this.awaitPos = oldAwaitPos;
            return this.parseParenArrowList(startPos, startLoc, exprList, forInit);
        }
        if (!exprList.length || lastIsComma) this.unexpected(this.lastTokStart);
        if (spreadStart) this.unexpected(spreadStart);
        this.checkExpressionErrors(refDestructuringErrors, true);
        this.yieldPos = oldYieldPos || this.yieldPos;
        this.awaitPos = oldAwaitPos || this.awaitPos;
        if (exprList.length > 1) {
            val = this.startNodeAt(innerStartPos, innerStartLoc);
            val.expressions = exprList;
            this.finishNodeAt(val, "SequenceExpression", innerEndPos, innerEndLoc);
        } else val = exprList[0];
    } else val = this.parseParenExpression();
    if (this.options.preserveParens) {
        var par = this.startNodeAt(startPos, startLoc);
        par.expression = val;
        return this.finishNode(par, "ParenthesizedExpression");
    } else return val;
};
$281a441cdcb2cf36$var$pp$5.parseParenItem = function(item) {
    return item;
};
$281a441cdcb2cf36$var$pp$5.parseParenArrowList = function(startPos, startLoc, exprList, forInit) {
    return this.parseArrowExpression(this.startNodeAt(startPos, startLoc), exprList, false, forInit);
};
var $281a441cdcb2cf36$var$empty2 = [];
$281a441cdcb2cf36$var$pp$5.parseNew = function() {
    if (this.containsEsc) this.raiseRecoverable(this.start, "Escape sequence in keyword new");
    var node = this.startNode();
    this.next();
    if (this.options.ecmaVersion >= 6 && this.type === $281a441cdcb2cf36$var$types$1.dot) {
        var meta = this.startNodeAt(node.start, node.loc && node.loc.start);
        meta.name = "new";
        node.meta = this.finishNode(meta, "Identifier");
        this.next();
        var containsEsc = this.containsEsc;
        node.property = this.parseIdent(true);
        if (node.property.name !== "target") this.raiseRecoverable(node.property.start, "The only valid meta property for new is 'new.target'");
        if (containsEsc) this.raiseRecoverable(node.start, "'new.target' must not contain escaped characters");
        if (!this.allowNewDotTarget) this.raiseRecoverable(node.start, "'new.target' can only be used in functions and class static block");
        return this.finishNode(node, "MetaProperty");
    }
    var startPos = this.start, startLoc = this.startLoc;
    node.callee = this.parseSubscripts(this.parseExprAtom(null, false, true), startPos, startLoc, true, false);
    if (this.eat($281a441cdcb2cf36$var$types$1.parenL)) node.arguments = this.parseExprList($281a441cdcb2cf36$var$types$1.parenR, this.options.ecmaVersion >= 8, false);
    else node.arguments = $281a441cdcb2cf36$var$empty2;
    return this.finishNode(node, "NewExpression");
};
$281a441cdcb2cf36$var$pp$5.parseTemplateElement = function(ref2) {
    var isTagged = ref2.isTagged;
    var elem = this.startNode();
    if (this.type === $281a441cdcb2cf36$var$types$1.invalidTemplate) {
        if (!isTagged) this.raiseRecoverable(this.start, "Bad escape sequence in untagged template literal");
        elem.value = {
            raw: this.value.replace(/\r\n?/g, "\n"),
            cooked: null
        };
    } else elem.value = {
        raw: this.input.slice(this.start, this.end).replace(/\r\n?/g, "\n"),
        cooked: this.value
    };
    this.next();
    elem.tail = this.type === $281a441cdcb2cf36$var$types$1.backQuote;
    return this.finishNode(elem, "TemplateElement");
};
$281a441cdcb2cf36$var$pp$5.parseTemplate = function(ref2) {
    if (ref2 === void 0) ref2 = {};
    var isTagged = ref2.isTagged;
    if (isTagged === void 0) isTagged = false;
    var node = this.startNode();
    this.next();
    node.expressions = [];
    var curElt = this.parseTemplateElement({
        isTagged: isTagged
    });
    node.quasis = [
        curElt
    ];
    while(!curElt.tail){
        if (this.type === $281a441cdcb2cf36$var$types$1.eof) this.raise(this.pos, "Unterminated template literal");
        this.expect($281a441cdcb2cf36$var$types$1.dollarBraceL);
        node.expressions.push(this.parseExpression());
        this.expect($281a441cdcb2cf36$var$types$1.braceR);
        node.quasis.push(curElt = this.parseTemplateElement({
            isTagged: isTagged
        }));
    }
    this.next();
    return this.finishNode(node, "TemplateLiteral");
};
$281a441cdcb2cf36$var$pp$5.isAsyncProp = function(prop) {
    return !prop.computed && prop.key.type === "Identifier" && prop.key.name === "async" && (this.type === $281a441cdcb2cf36$var$types$1.name || this.type === $281a441cdcb2cf36$var$types$1.num || this.type === $281a441cdcb2cf36$var$types$1.string || this.type === $281a441cdcb2cf36$var$types$1.bracketL || this.type.keyword || this.options.ecmaVersion >= 9 && this.type === $281a441cdcb2cf36$var$types$1.star) && !$281a441cdcb2cf36$var$lineBreak.test(this.input.slice(this.lastTokEnd, this.start));
};
$281a441cdcb2cf36$var$pp$5.parseObj = function(isPattern, refDestructuringErrors) {
    var node = this.startNode(), first = true, propHash = {};
    node.properties = [];
    this.next();
    while(!this.eat($281a441cdcb2cf36$var$types$1.braceR)){
        if (!first) {
            this.expect($281a441cdcb2cf36$var$types$1.comma);
            if (this.options.ecmaVersion >= 5 && this.afterTrailingComma($281a441cdcb2cf36$var$types$1.braceR)) break;
        } else first = false;
        var prop = this.parseProperty(isPattern, refDestructuringErrors);
        if (!isPattern) this.checkPropClash(prop, propHash, refDestructuringErrors);
        node.properties.push(prop);
    }
    return this.finishNode(node, isPattern ? "ObjectPattern" : "ObjectExpression");
};
$281a441cdcb2cf36$var$pp$5.parseProperty = function(isPattern, refDestructuringErrors) {
    var prop = this.startNode(), isGenerator, isAsync, startPos, startLoc;
    if (this.options.ecmaVersion >= 9 && this.eat($281a441cdcb2cf36$var$types$1.ellipsis)) {
        if (isPattern) {
            prop.argument = this.parseIdent(false);
            if (this.type === $281a441cdcb2cf36$var$types$1.comma) this.raiseRecoverable(this.start, "Comma is not permitted after the rest element");
            return this.finishNode(prop, "RestElement");
        }
        prop.argument = this.parseMaybeAssign(false, refDestructuringErrors);
        if (this.type === $281a441cdcb2cf36$var$types$1.comma && refDestructuringErrors && refDestructuringErrors.trailingComma < 0) refDestructuringErrors.trailingComma = this.start;
        return this.finishNode(prop, "SpreadElement");
    }
    if (this.options.ecmaVersion >= 6) {
        prop.method = false;
        prop.shorthand = false;
        if (isPattern || refDestructuringErrors) {
            startPos = this.start;
            startLoc = this.startLoc;
        }
        if (!isPattern) isGenerator = this.eat($281a441cdcb2cf36$var$types$1.star);
    }
    var containsEsc = this.containsEsc;
    this.parsePropertyName(prop);
    if (!isPattern && !containsEsc && this.options.ecmaVersion >= 8 && !isGenerator && this.isAsyncProp(prop)) {
        isAsync = true;
        isGenerator = this.options.ecmaVersion >= 9 && this.eat($281a441cdcb2cf36$var$types$1.star);
        this.parsePropertyName(prop);
    } else isAsync = false;
    this.parsePropertyValue(prop, isPattern, isGenerator, isAsync, startPos, startLoc, refDestructuringErrors, containsEsc);
    return this.finishNode(prop, "Property");
};
$281a441cdcb2cf36$var$pp$5.parseGetterSetter = function(prop) {
    var kind = prop.key.name;
    this.parsePropertyName(prop);
    prop.value = this.parseMethod(false);
    prop.kind = kind;
    var paramCount = prop.kind === "get" ? 0 : 1;
    if (prop.value.params.length !== paramCount) {
        var start = prop.value.start;
        if (prop.kind === "get") this.raiseRecoverable(start, "getter should have no params");
        else this.raiseRecoverable(start, "setter should have exactly one param");
    } else if (prop.kind === "set" && prop.value.params[0].type === "RestElement") this.raiseRecoverable(prop.value.params[0].start, "Setter cannot use rest params");
};
$281a441cdcb2cf36$var$pp$5.parsePropertyValue = function(prop, isPattern, isGenerator, isAsync, startPos, startLoc, refDestructuringErrors, containsEsc) {
    if ((isGenerator || isAsync) && this.type === $281a441cdcb2cf36$var$types$1.colon) this.unexpected();
    if (this.eat($281a441cdcb2cf36$var$types$1.colon)) {
        prop.value = isPattern ? this.parseMaybeDefault(this.start, this.startLoc) : this.parseMaybeAssign(false, refDestructuringErrors);
        prop.kind = "init";
    } else if (this.options.ecmaVersion >= 6 && this.type === $281a441cdcb2cf36$var$types$1.parenL) {
        if (isPattern) this.unexpected();
        prop.method = true;
        prop.value = this.parseMethod(isGenerator, isAsync);
        prop.kind = "init";
    } else if (!isPattern && !containsEsc && this.options.ecmaVersion >= 5 && !prop.computed && prop.key.type === "Identifier" && (prop.key.name === "get" || prop.key.name === "set") && this.type !== $281a441cdcb2cf36$var$types$1.comma && this.type !== $281a441cdcb2cf36$var$types$1.braceR && this.type !== $281a441cdcb2cf36$var$types$1.eq) {
        if (isGenerator || isAsync) this.unexpected();
        this.parseGetterSetter(prop);
    } else if (this.options.ecmaVersion >= 6 && !prop.computed && prop.key.type === "Identifier") {
        if (isGenerator || isAsync) this.unexpected();
        this.checkUnreserved(prop.key);
        if (prop.key.name === "await" && !this.awaitIdentPos) this.awaitIdentPos = startPos;
        if (isPattern) prop.value = this.parseMaybeDefault(startPos, startLoc, this.copyNode(prop.key));
        else if (this.type === $281a441cdcb2cf36$var$types$1.eq && refDestructuringErrors) {
            if (refDestructuringErrors.shorthandAssign < 0) refDestructuringErrors.shorthandAssign = this.start;
            prop.value = this.parseMaybeDefault(startPos, startLoc, this.copyNode(prop.key));
        } else prop.value = this.copyNode(prop.key);
        prop.kind = "init";
        prop.shorthand = true;
    } else this.unexpected();
};
$281a441cdcb2cf36$var$pp$5.parsePropertyName = function(prop) {
    if (this.options.ecmaVersion >= 6) {
        if (this.eat($281a441cdcb2cf36$var$types$1.bracketL)) {
            prop.computed = true;
            prop.key = this.parseMaybeAssign();
            this.expect($281a441cdcb2cf36$var$types$1.bracketR);
            return prop.key;
        } else prop.computed = false;
    }
    return prop.key = this.type === $281a441cdcb2cf36$var$types$1.num || this.type === $281a441cdcb2cf36$var$types$1.string ? this.parseExprAtom() : this.parseIdent(this.options.allowReserved !== "never");
};
$281a441cdcb2cf36$var$pp$5.initFunction = function(node) {
    node.id = null;
    if (this.options.ecmaVersion >= 6) node.generator = node.expression = false;
    if (this.options.ecmaVersion >= 8) node.async = false;
};
$281a441cdcb2cf36$var$pp$5.parseMethod = function(isGenerator, isAsync, allowDirectSuper) {
    var node = this.startNode(), oldYieldPos = this.yieldPos, oldAwaitPos = this.awaitPos, oldAwaitIdentPos = this.awaitIdentPos;
    this.initFunction(node);
    if (this.options.ecmaVersion >= 6) node.generator = isGenerator;
    if (this.options.ecmaVersion >= 8) node.async = !!isAsync;
    this.yieldPos = 0;
    this.awaitPos = 0;
    this.awaitIdentPos = 0;
    this.enterScope($281a441cdcb2cf36$var$functionFlags(isAsync, node.generator) | $281a441cdcb2cf36$var$SCOPE_SUPER | (allowDirectSuper ? $281a441cdcb2cf36$var$SCOPE_DIRECT_SUPER : 0));
    this.expect($281a441cdcb2cf36$var$types$1.parenL);
    node.params = this.parseBindingList($281a441cdcb2cf36$var$types$1.parenR, false, this.options.ecmaVersion >= 8);
    this.checkYieldAwaitInDefaultParams();
    this.parseFunctionBody(node, false, true, false);
    this.yieldPos = oldYieldPos;
    this.awaitPos = oldAwaitPos;
    this.awaitIdentPos = oldAwaitIdentPos;
    return this.finishNode(node, "FunctionExpression");
};
$281a441cdcb2cf36$var$pp$5.parseArrowExpression = function(node, params2, isAsync, forInit) {
    var oldYieldPos = this.yieldPos, oldAwaitPos = this.awaitPos, oldAwaitIdentPos = this.awaitIdentPos;
    this.enterScope($281a441cdcb2cf36$var$functionFlags(isAsync, false) | $281a441cdcb2cf36$var$SCOPE_ARROW);
    this.initFunction(node);
    if (this.options.ecmaVersion >= 8) node.async = !!isAsync;
    this.yieldPos = 0;
    this.awaitPos = 0;
    this.awaitIdentPos = 0;
    node.params = this.toAssignableList(params2, true);
    this.parseFunctionBody(node, true, false, forInit);
    this.yieldPos = oldYieldPos;
    this.awaitPos = oldAwaitPos;
    this.awaitIdentPos = oldAwaitIdentPos;
    return this.finishNode(node, "ArrowFunctionExpression");
};
$281a441cdcb2cf36$var$pp$5.parseFunctionBody = function(node, isArrowFunction, isMethod, forInit) {
    var isExpression = isArrowFunction && this.type !== $281a441cdcb2cf36$var$types$1.braceL;
    var oldStrict = this.strict, useStrict = false;
    if (isExpression) {
        node.body = this.parseMaybeAssign(forInit);
        node.expression = true;
        this.checkParams(node, false);
    } else {
        var nonSimple = this.options.ecmaVersion >= 7 && !this.isSimpleParamList(node.params);
        if (!oldStrict || nonSimple) {
            useStrict = this.strictDirective(this.end);
            if (useStrict && nonSimple) this.raiseRecoverable(node.start, "Illegal 'use strict' directive in function with non-simple parameter list");
        }
        var oldLabels = this.labels;
        this.labels = [];
        if (useStrict) this.strict = true;
        this.checkParams(node, !oldStrict && !useStrict && !isArrowFunction && !isMethod && this.isSimpleParamList(node.params));
        if (this.strict && node.id) this.checkLValSimple(node.id, $281a441cdcb2cf36$var$BIND_OUTSIDE);
        node.body = this.parseBlock(false, void 0, useStrict && !oldStrict);
        node.expression = false;
        this.adaptDirectivePrologue(node.body.body);
        this.labels = oldLabels;
    }
    this.exitScope();
};
$281a441cdcb2cf36$var$pp$5.isSimpleParamList = function(params2) {
    for(var i3 = 0, list = params2; i3 < list.length; i3 += 1){
        var param = list[i3];
        if (param.type !== "Identifier") return false;
    }
    return true;
};
$281a441cdcb2cf36$var$pp$5.checkParams = function(node, allowDuplicates) {
    var nameHash = /* @__PURE__ */ Object.create(null);
    for(var i3 = 0, list = node.params; i3 < list.length; i3 += 1){
        var param = list[i3];
        this.checkLValInnerPattern(param, $281a441cdcb2cf36$var$BIND_VAR, allowDuplicates ? null : nameHash);
    }
};
$281a441cdcb2cf36$var$pp$5.parseExprList = function(close, allowTrailingComma, allowEmpty, refDestructuringErrors) {
    var elts = [], first = true;
    while(!this.eat(close)){
        if (!first) {
            this.expect($281a441cdcb2cf36$var$types$1.comma);
            if (allowTrailingComma && this.afterTrailingComma(close)) break;
        } else first = false;
        var elt = void 0;
        if (allowEmpty && this.type === $281a441cdcb2cf36$var$types$1.comma) elt = null;
        else if (this.type === $281a441cdcb2cf36$var$types$1.ellipsis) {
            elt = this.parseSpread(refDestructuringErrors);
            if (refDestructuringErrors && this.type === $281a441cdcb2cf36$var$types$1.comma && refDestructuringErrors.trailingComma < 0) refDestructuringErrors.trailingComma = this.start;
        } else elt = this.parseMaybeAssign(false, refDestructuringErrors);
        elts.push(elt);
    }
    return elts;
};
$281a441cdcb2cf36$var$pp$5.checkUnreserved = function(ref2) {
    var start = ref2.start;
    var end = ref2.end;
    var name = ref2.name;
    if (this.inGenerator && name === "yield") this.raiseRecoverable(start, "Cannot use 'yield' as identifier inside a generator");
    if (this.inAsync && name === "await") this.raiseRecoverable(start, "Cannot use 'await' as identifier inside an async function");
    if (!(this.currentThisScope().flags & $281a441cdcb2cf36$var$SCOPE_VAR) && name === "arguments") this.raiseRecoverable(start, "Cannot use 'arguments' in class field initializer");
    if (this.inClassStaticBlock && (name === "arguments" || name === "await")) this.raise(start, "Cannot use " + name + " in class static initialization block");
    if (this.keywords.test(name)) this.raise(start, "Unexpected keyword '" + name + "'");
    if (this.options.ecmaVersion < 6 && this.input.slice(start, end).indexOf("\\") !== -1) return;
    var re3 = this.strict ? this.reservedWordsStrict : this.reservedWords;
    if (re3.test(name)) {
        if (!this.inAsync && name === "await") this.raiseRecoverable(start, "Cannot use keyword 'await' outside an async function");
        this.raiseRecoverable(start, "The keyword '" + name + "' is reserved");
    }
};
$281a441cdcb2cf36$var$pp$5.parseIdent = function(liberal) {
    var node = this.parseIdentNode();
    this.next(!!liberal);
    this.finishNode(node, "Identifier");
    if (!liberal) {
        this.checkUnreserved(node);
        if (node.name === "await" && !this.awaitIdentPos) this.awaitIdentPos = node.start;
    }
    return node;
};
$281a441cdcb2cf36$var$pp$5.parseIdentNode = function() {
    var node = this.startNode();
    if (this.type === $281a441cdcb2cf36$var$types$1.name) node.name = this.value;
    else if (this.type.keyword) {
        node.name = this.type.keyword;
        if ((node.name === "class" || node.name === "function") && (this.lastTokEnd !== this.lastTokStart + 1 || this.input.charCodeAt(this.lastTokStart) !== 46)) this.context.pop();
        this.type = $281a441cdcb2cf36$var$types$1.name;
    } else this.unexpected();
    return node;
};
$281a441cdcb2cf36$var$pp$5.parsePrivateIdent = function() {
    var node = this.startNode();
    if (this.type === $281a441cdcb2cf36$var$types$1.privateId) node.name = this.value;
    else this.unexpected();
    this.next();
    this.finishNode(node, "PrivateIdentifier");
    if (this.options.checkPrivateFields) {
        if (this.privateNameStack.length === 0) this.raise(node.start, "Private field '#" + node.name + "' must be declared in an enclosing class");
        else this.privateNameStack[this.privateNameStack.length - 1].used.push(node);
    }
    return node;
};
$281a441cdcb2cf36$var$pp$5.parseYield = function(forInit) {
    if (!this.yieldPos) this.yieldPos = this.start;
    var node = this.startNode();
    this.next();
    if (this.type === $281a441cdcb2cf36$var$types$1.semi || this.canInsertSemicolon() || this.type !== $281a441cdcb2cf36$var$types$1.star && !this.type.startsExpr) {
        node.delegate = false;
        node.argument = null;
    } else {
        node.delegate = this.eat($281a441cdcb2cf36$var$types$1.star);
        node.argument = this.parseMaybeAssign(forInit);
    }
    return this.finishNode(node, "YieldExpression");
};
$281a441cdcb2cf36$var$pp$5.parseAwait = function(forInit) {
    if (!this.awaitPos) this.awaitPos = this.start;
    var node = this.startNode();
    this.next();
    node.argument = this.parseMaybeUnary(null, true, false, forInit);
    return this.finishNode(node, "AwaitExpression");
};
var $281a441cdcb2cf36$var$pp$4 = $281a441cdcb2cf36$var$Parser.prototype;
$281a441cdcb2cf36$var$pp$4.raise = function(pos, message) {
    var loc = $281a441cdcb2cf36$var$getLineInfo(this.input, pos);
    message += " (" + loc.line + ":" + loc.column + ")";
    if (this.sourceFile) message += " in " + this.sourceFile;
    var err = new SyntaxError(message);
    err.pos = pos;
    err.loc = loc;
    err.raisedAt = this.pos;
    throw err;
};
$281a441cdcb2cf36$var$pp$4.raiseRecoverable = $281a441cdcb2cf36$var$pp$4.raise;
$281a441cdcb2cf36$var$pp$4.curPosition = function() {
    if (this.options.locations) return new $281a441cdcb2cf36$var$Position(this.curLine, this.pos - this.lineStart);
};
var $281a441cdcb2cf36$var$pp$3 = $281a441cdcb2cf36$var$Parser.prototype;
var $281a441cdcb2cf36$var$Scope = function Scope2(flags) {
    this.flags = flags;
    this.var = [];
    this.lexical = [];
    this.functions = [];
};
$281a441cdcb2cf36$var$pp$3.enterScope = function(flags) {
    this.scopeStack.push(new $281a441cdcb2cf36$var$Scope(flags));
};
$281a441cdcb2cf36$var$pp$3.exitScope = function() {
    this.scopeStack.pop();
};
$281a441cdcb2cf36$var$pp$3.treatFunctionsAsVarInScope = function(scope) {
    return scope.flags & $281a441cdcb2cf36$var$SCOPE_FUNCTION || !this.inModule && scope.flags & $281a441cdcb2cf36$var$SCOPE_TOP;
};
$281a441cdcb2cf36$var$pp$3.declareName = function(name, bindingType, pos) {
    var redeclared = false;
    if (bindingType === $281a441cdcb2cf36$var$BIND_LEXICAL) {
        var scope = this.currentScope();
        redeclared = scope.lexical.indexOf(name) > -1 || scope.functions.indexOf(name) > -1 || scope.var.indexOf(name) > -1;
        scope.lexical.push(name);
        if (this.inModule && scope.flags & $281a441cdcb2cf36$var$SCOPE_TOP) delete this.undefinedExports[name];
    } else if (bindingType === $281a441cdcb2cf36$var$BIND_SIMPLE_CATCH) {
        var scope$1 = this.currentScope();
        scope$1.lexical.push(name);
    } else if (bindingType === $281a441cdcb2cf36$var$BIND_FUNCTION) {
        var scope$2 = this.currentScope();
        if (this.treatFunctionsAsVar) redeclared = scope$2.lexical.indexOf(name) > -1;
        else redeclared = scope$2.lexical.indexOf(name) > -1 || scope$2.var.indexOf(name) > -1;
        scope$2.functions.push(name);
    } else for(var i3 = this.scopeStack.length - 1; i3 >= 0; --i3){
        var scope$3 = this.scopeStack[i3];
        if (scope$3.lexical.indexOf(name) > -1 && !(scope$3.flags & $281a441cdcb2cf36$var$SCOPE_SIMPLE_CATCH && scope$3.lexical[0] === name) || !this.treatFunctionsAsVarInScope(scope$3) && scope$3.functions.indexOf(name) > -1) {
            redeclared = true;
            break;
        }
        scope$3.var.push(name);
        if (this.inModule && scope$3.flags & $281a441cdcb2cf36$var$SCOPE_TOP) delete this.undefinedExports[name];
        if (scope$3.flags & $281a441cdcb2cf36$var$SCOPE_VAR) break;
    }
    if (redeclared) this.raiseRecoverable(pos, "Identifier '" + name + "' has already been declared");
};
$281a441cdcb2cf36$var$pp$3.checkLocalExport = function(id2) {
    if (this.scopeStack[0].lexical.indexOf(id2.name) === -1 && this.scopeStack[0].var.indexOf(id2.name) === -1) this.undefinedExports[id2.name] = id2;
};
$281a441cdcb2cf36$var$pp$3.currentScope = function() {
    return this.scopeStack[this.scopeStack.length - 1];
};
$281a441cdcb2cf36$var$pp$3.currentVarScope = function() {
    for(var i3 = this.scopeStack.length - 1;; i3--){
        var scope = this.scopeStack[i3];
        if (scope.flags & ($281a441cdcb2cf36$var$SCOPE_VAR | $281a441cdcb2cf36$var$SCOPE_CLASS_FIELD_INIT | $281a441cdcb2cf36$var$SCOPE_CLASS_STATIC_BLOCK)) return scope;
    }
};
$281a441cdcb2cf36$var$pp$3.currentThisScope = function() {
    for(var i3 = this.scopeStack.length - 1;; i3--){
        var scope = this.scopeStack[i3];
        if (scope.flags & ($281a441cdcb2cf36$var$SCOPE_VAR | $281a441cdcb2cf36$var$SCOPE_CLASS_FIELD_INIT | $281a441cdcb2cf36$var$SCOPE_CLASS_STATIC_BLOCK) && !(scope.flags & $281a441cdcb2cf36$var$SCOPE_ARROW)) return scope;
    }
};
var $281a441cdcb2cf36$var$Node2 = function Node3(parser, pos, loc) {
    this.type = "";
    this.start = pos;
    this.end = 0;
    if (parser.options.locations) this.loc = new $281a441cdcb2cf36$var$SourceLocation(parser, loc);
    if (parser.options.directSourceFile) this.sourceFile = parser.options.directSourceFile;
    if (parser.options.ranges) this.range = [
        pos,
        0
    ];
};
var $281a441cdcb2cf36$var$pp$2 = $281a441cdcb2cf36$var$Parser.prototype;
$281a441cdcb2cf36$var$pp$2.startNode = function() {
    return new $281a441cdcb2cf36$var$Node2(this, this.start, this.startLoc);
};
$281a441cdcb2cf36$var$pp$2.startNodeAt = function(pos, loc) {
    return new $281a441cdcb2cf36$var$Node2(this, pos, loc);
};
function $281a441cdcb2cf36$var$finishNodeAt(node, type, pos, loc) {
    node.type = type;
    node.end = pos;
    if (this.options.locations) node.loc.end = loc;
    if (this.options.ranges) node.range[1] = pos;
    return node;
}
$281a441cdcb2cf36$var$pp$2.finishNode = function(node, type) {
    return $281a441cdcb2cf36$var$finishNodeAt.call(this, node, type, this.lastTokEnd, this.lastTokEndLoc);
};
$281a441cdcb2cf36$var$pp$2.finishNodeAt = function(node, type, pos, loc) {
    return $281a441cdcb2cf36$var$finishNodeAt.call(this, node, type, pos, loc);
};
$281a441cdcb2cf36$var$pp$2.copyNode = function(node) {
    var newNode = new $281a441cdcb2cf36$var$Node2(this, node.start, this.startLoc);
    for(var prop in node)newNode[prop] = node[prop];
    return newNode;
};
var $281a441cdcb2cf36$var$scriptValuesAddedInUnicode = "Berf Beria_Erfe Gara Garay Gukh Gurung_Khema Hrkt Katakana_Or_Hiragana Kawi Kirat_Rai Krai Nag_Mundari Nagm Ol_Onal Onao Sidetic Sidt Sunu Sunuwar Tai_Yo Tayo Todhri Todr Tolong_Siki Tols Tulu_Tigalari Tutg Unknown Zzzz";
var $281a441cdcb2cf36$var$ecma9BinaryProperties = "ASCII ASCII_Hex_Digit AHex Alphabetic Alpha Any Assigned Bidi_Control Bidi_C Bidi_Mirrored Bidi_M Case_Ignorable CI Cased Changes_When_Casefolded CWCF Changes_When_Casemapped CWCM Changes_When_Lowercased CWL Changes_When_NFKC_Casefolded CWKCF Changes_When_Titlecased CWT Changes_When_Uppercased CWU Dash Default_Ignorable_Code_Point DI Deprecated Dep Diacritic Dia Emoji Emoji_Component Emoji_Modifier Emoji_Modifier_Base Emoji_Presentation Extender Ext Grapheme_Base Gr_Base Grapheme_Extend Gr_Ext Hex_Digit Hex IDS_Binary_Operator IDSB IDS_Trinary_Operator IDST ID_Continue IDC ID_Start IDS Ideographic Ideo Join_Control Join_C Logical_Order_Exception LOE Lowercase Lower Math Noncharacter_Code_Point NChar Pattern_Syntax Pat_Syn Pattern_White_Space Pat_WS Quotation_Mark QMark Radical Regional_Indicator RI Sentence_Terminal STerm Soft_Dotted SD Terminal_Punctuation Term Unified_Ideograph UIdeo Uppercase Upper Variation_Selector VS White_Space space XID_Continue XIDC XID_Start XIDS";
var $281a441cdcb2cf36$var$ecma10BinaryProperties = $281a441cdcb2cf36$var$ecma9BinaryProperties + " Extended_Pictographic";
var $281a441cdcb2cf36$var$ecma11BinaryProperties = $281a441cdcb2cf36$var$ecma10BinaryProperties;
var $281a441cdcb2cf36$var$ecma12BinaryProperties = $281a441cdcb2cf36$var$ecma11BinaryProperties + " EBase EComp EMod EPres ExtPict";
var $281a441cdcb2cf36$var$ecma13BinaryProperties = $281a441cdcb2cf36$var$ecma12BinaryProperties;
var $281a441cdcb2cf36$var$ecma14BinaryProperties = $281a441cdcb2cf36$var$ecma13BinaryProperties;
var $281a441cdcb2cf36$var$unicodeBinaryProperties = {
    9: $281a441cdcb2cf36$var$ecma9BinaryProperties,
    10: $281a441cdcb2cf36$var$ecma10BinaryProperties,
    11: $281a441cdcb2cf36$var$ecma11BinaryProperties,
    12: $281a441cdcb2cf36$var$ecma12BinaryProperties,
    13: $281a441cdcb2cf36$var$ecma13BinaryProperties,
    14: $281a441cdcb2cf36$var$ecma14BinaryProperties
};
var $281a441cdcb2cf36$var$ecma14BinaryPropertiesOfStrings = "Basic_Emoji Emoji_Keycap_Sequence RGI_Emoji_Modifier_Sequence RGI_Emoji_Flag_Sequence RGI_Emoji_Tag_Sequence RGI_Emoji_ZWJ_Sequence RGI_Emoji";
var $281a441cdcb2cf36$var$unicodeBinaryPropertiesOfStrings = {
    9: "",
    10: "",
    11: "",
    12: "",
    13: "",
    14: $281a441cdcb2cf36$var$ecma14BinaryPropertiesOfStrings
};
var $281a441cdcb2cf36$var$unicodeGeneralCategoryValues = "Cased_Letter LC Close_Punctuation Pe Connector_Punctuation Pc Control Cc cntrl Currency_Symbol Sc Dash_Punctuation Pd Decimal_Number Nd digit Enclosing_Mark Me Final_Punctuation Pf Format Cf Initial_Punctuation Pi Letter L Letter_Number Nl Line_Separator Zl Lowercase_Letter Ll Mark M Combining_Mark Math_Symbol Sm Modifier_Letter Lm Modifier_Symbol Sk Nonspacing_Mark Mn Number N Open_Punctuation Ps Other C Other_Letter Lo Other_Number No Other_Punctuation Po Other_Symbol So Paragraph_Separator Zp Private_Use Co Punctuation P punct Separator Z Space_Separator Zs Spacing_Mark Mc Surrogate Cs Symbol S Titlecase_Letter Lt Unassigned Cn Uppercase_Letter Lu";
var $281a441cdcb2cf36$var$ecma9ScriptValues = "Adlam Adlm Ahom Anatolian_Hieroglyphs Hluw Arabic Arab Armenian Armn Avestan Avst Balinese Bali Bamum Bamu Bassa_Vah Bass Batak Batk Bengali Beng Bhaiksuki Bhks Bopomofo Bopo Brahmi Brah Braille Brai Buginese Bugi Buhid Buhd Canadian_Aboriginal Cans Carian Cari Caucasian_Albanian Aghb Chakma Cakm Cham Cham Cherokee Cher Common Zyyy Coptic Copt Qaac Cuneiform Xsux Cypriot Cprt Cyrillic Cyrl Deseret Dsrt Devanagari Deva Duployan Dupl Egyptian_Hieroglyphs Egyp Elbasan Elba Ethiopic Ethi Georgian Geor Glagolitic Glag Gothic Goth Grantha Gran Greek Grek Gujarati Gujr Gurmukhi Guru Han Hani Hangul Hang Hanunoo Hano Hatran Hatr Hebrew Hebr Hiragana Hira Imperial_Aramaic Armi Inherited Zinh Qaai Inscriptional_Pahlavi Phli Inscriptional_Parthian Prti Javanese Java Kaithi Kthi Kannada Knda Katakana Kana Kayah_Li Kali Kharoshthi Khar Khmer Khmr Khojki Khoj Khudawadi Sind Lao Laoo Latin Latn Lepcha Lepc Limbu Limb Linear_A Lina Linear_B Linb Lisu Lisu Lycian Lyci Lydian Lydi Mahajani Mahj Malayalam Mlym Mandaic Mand Manichaean Mani Marchen Marc Masaram_Gondi Gonm Meetei_Mayek Mtei Mende_Kikakui Mend Meroitic_Cursive Merc Meroitic_Hieroglyphs Mero Miao Plrd Modi Mongolian Mong Mro Mroo Multani Mult Myanmar Mymr Nabataean Nbat New_Tai_Lue Talu Newa Newa Nko Nkoo Nushu Nshu Ogham Ogam Ol_Chiki Olck Old_Hungarian Hung Old_Italic Ital Old_North_Arabian Narb Old_Permic Perm Old_Persian Xpeo Old_South_Arabian Sarb Old_Turkic Orkh Oriya Orya Osage Osge Osmanya Osma Pahawh_Hmong Hmng Palmyrene Palm Pau_Cin_Hau Pauc Phags_Pa Phag Phoenician Phnx Psalter_Pahlavi Phlp Rejang Rjng Runic Runr Samaritan Samr Saurashtra Saur Sharada Shrd Shavian Shaw Siddham Sidd SignWriting Sgnw Sinhala Sinh Sora_Sompeng Sora Soyombo Soyo Sundanese Sund Syloti_Nagri Sylo Syriac Syrc Tagalog Tglg Tagbanwa Tagb Tai_Le Tale Tai_Tham Lana Tai_Viet Tavt Takri Takr Tamil Taml Tangut Tang Telugu Telu Thaana Thaa Thai Thai Tibetan Tibt Tifinagh Tfng Tirhuta Tirh Ugaritic Ugar Vai Vaii Warang_Citi Wara Yi Yiii Zanabazar_Square Zanb";
var $281a441cdcb2cf36$var$ecma10ScriptValues = $281a441cdcb2cf36$var$ecma9ScriptValues + " Dogra Dogr Gunjala_Gondi Gong Hanifi_Rohingya Rohg Makasar Maka Medefaidrin Medf Old_Sogdian Sogo Sogdian Sogd";
var $281a441cdcb2cf36$var$ecma11ScriptValues = $281a441cdcb2cf36$var$ecma10ScriptValues + " Elymaic Elym Nandinagari Nand Nyiakeng_Puachue_Hmong Hmnp Wancho Wcho";
var $281a441cdcb2cf36$var$ecma12ScriptValues = $281a441cdcb2cf36$var$ecma11ScriptValues + " Chorasmian Chrs Diak Dives_Akuru Khitan_Small_Script Kits Yezi Yezidi";
var $281a441cdcb2cf36$var$ecma13ScriptValues = $281a441cdcb2cf36$var$ecma12ScriptValues + " Cypro_Minoan Cpmn Old_Uyghur Ougr Tangsa Tnsa Toto Vithkuqi Vith";
var $281a441cdcb2cf36$var$ecma14ScriptValues = $281a441cdcb2cf36$var$ecma13ScriptValues + " " + $281a441cdcb2cf36$var$scriptValuesAddedInUnicode;
var $281a441cdcb2cf36$var$unicodeScriptValues = {
    9: $281a441cdcb2cf36$var$ecma9ScriptValues,
    10: $281a441cdcb2cf36$var$ecma10ScriptValues,
    11: $281a441cdcb2cf36$var$ecma11ScriptValues,
    12: $281a441cdcb2cf36$var$ecma12ScriptValues,
    13: $281a441cdcb2cf36$var$ecma13ScriptValues,
    14: $281a441cdcb2cf36$var$ecma14ScriptValues
};
var $281a441cdcb2cf36$var$data = {};
function $281a441cdcb2cf36$var$buildUnicodeData(ecmaVersion) {
    var d3 = $281a441cdcb2cf36$var$data[ecmaVersion] = {
        binary: $281a441cdcb2cf36$var$wordsRegexp($281a441cdcb2cf36$var$unicodeBinaryProperties[ecmaVersion] + " " + $281a441cdcb2cf36$var$unicodeGeneralCategoryValues),
        binaryOfStrings: $281a441cdcb2cf36$var$wordsRegexp($281a441cdcb2cf36$var$unicodeBinaryPropertiesOfStrings[ecmaVersion]),
        nonBinary: {
            General_Category: $281a441cdcb2cf36$var$wordsRegexp($281a441cdcb2cf36$var$unicodeGeneralCategoryValues),
            Script: $281a441cdcb2cf36$var$wordsRegexp($281a441cdcb2cf36$var$unicodeScriptValues[ecmaVersion])
        }
    };
    d3.nonBinary.Script_Extensions = d3.nonBinary.Script;
    d3.nonBinary.gc = d3.nonBinary.General_Category;
    d3.nonBinary.sc = d3.nonBinary.Script;
    d3.nonBinary.scx = d3.nonBinary.Script_Extensions;
}
for($281a441cdcb2cf36$var$i3 = 0, $281a441cdcb2cf36$var$list = [
    9,
    10,
    11,
    12,
    13,
    14
]; $281a441cdcb2cf36$var$i3 < $281a441cdcb2cf36$var$list.length; $281a441cdcb2cf36$var$i3 += 1){
    $281a441cdcb2cf36$var$ecmaVersion = $281a441cdcb2cf36$var$list[$281a441cdcb2cf36$var$i3];
    $281a441cdcb2cf36$var$buildUnicodeData($281a441cdcb2cf36$var$ecmaVersion);
}
var $281a441cdcb2cf36$var$ecmaVersion;
var $281a441cdcb2cf36$var$i3;
var $281a441cdcb2cf36$var$list;
var $281a441cdcb2cf36$var$pp$1 = $281a441cdcb2cf36$var$Parser.prototype;
var $281a441cdcb2cf36$var$BranchID = function BranchID2(parent, base2) {
    this.parent = parent;
    this.base = base2 || this;
};
$281a441cdcb2cf36$var$BranchID.prototype.separatedFrom = function separatedFrom(alt) {
    for(var self2 = this; self2; self2 = self2.parent)for(var other = alt; other; other = other.parent){
        if (self2.base === other.base && self2 !== other) return true;
    }
    return false;
};
$281a441cdcb2cf36$var$BranchID.prototype.sibling = function sibling() {
    return new $281a441cdcb2cf36$var$BranchID(this.parent, this.base);
};
var $281a441cdcb2cf36$var$RegExpValidationState = function RegExpValidationState2(parser) {
    this.parser = parser;
    this.validFlags = "gim" + (parser.options.ecmaVersion >= 6 ? "uy" : "") + (parser.options.ecmaVersion >= 9 ? "s" : "") + (parser.options.ecmaVersion >= 13 ? "d" : "") + (parser.options.ecmaVersion >= 15 ? "v" : "");
    this.unicodeProperties = $281a441cdcb2cf36$var$data[parser.options.ecmaVersion >= 14 ? 14 : parser.options.ecmaVersion];
    this.source = "";
    this.flags = "";
    this.start = 0;
    this.switchU = false;
    this.switchV = false;
    this.switchN = false;
    this.pos = 0;
    this.lastIntValue = 0;
    this.lastStringValue = "";
    this.lastAssertionIsQuantifiable = false;
    this.numCapturingParens = 0;
    this.maxBackReference = 0;
    this.groupNames = /* @__PURE__ */ Object.create(null);
    this.backReferenceNames = [];
    this.branchID = null;
};
$281a441cdcb2cf36$var$RegExpValidationState.prototype.reset = function reset(start, pattern, flags) {
    var unicodeSets = flags.indexOf("v") !== -1;
    var unicode = flags.indexOf("u") !== -1;
    this.start = start | 0;
    this.source = pattern + "";
    this.flags = flags;
    if (unicodeSets && this.parser.options.ecmaVersion >= 15) {
        this.switchU = true;
        this.switchV = true;
        this.switchN = true;
    } else {
        this.switchU = unicode && this.parser.options.ecmaVersion >= 6;
        this.switchV = false;
        this.switchN = unicode && this.parser.options.ecmaVersion >= 9;
    }
};
$281a441cdcb2cf36$var$RegExpValidationState.prototype.raise = function raise(message) {
    this.parser.raiseRecoverable(this.start, "Invalid regular expression: /" + this.source + "/: " + message);
};
$281a441cdcb2cf36$var$RegExpValidationState.prototype.at = function at(i3, forceU) {
    if (forceU === void 0) forceU = false;
    var s3 = this.source;
    var l3 = s3.length;
    if (i3 >= l3) return -1;
    var c3 = s3.charCodeAt(i3);
    if (!(forceU || this.switchU) || c3 <= 55295 || c3 >= 57344 || i3 + 1 >= l3) return c3;
    var next = s3.charCodeAt(i3 + 1);
    return next >= 56320 && next <= 57343 ? (c3 << 10) + next - 56613888 : c3;
};
$281a441cdcb2cf36$var$RegExpValidationState.prototype.nextIndex = function nextIndex(i3, forceU) {
    if (forceU === void 0) forceU = false;
    var s3 = this.source;
    var l3 = s3.length;
    if (i3 >= l3) return l3;
    var c3 = s3.charCodeAt(i3), next;
    if (!(forceU || this.switchU) || c3 <= 55295 || c3 >= 57344 || i3 + 1 >= l3 || (next = s3.charCodeAt(i3 + 1)) < 56320 || next > 57343) return i3 + 1;
    return i3 + 2;
};
$281a441cdcb2cf36$var$RegExpValidationState.prototype.current = function current(forceU) {
    if (forceU === void 0) forceU = false;
    return this.at(this.pos, forceU);
};
$281a441cdcb2cf36$var$RegExpValidationState.prototype.lookahead = function lookahead(forceU) {
    if (forceU === void 0) forceU = false;
    return this.at(this.nextIndex(this.pos, forceU), forceU);
};
$281a441cdcb2cf36$var$RegExpValidationState.prototype.advance = function advance(forceU) {
    if (forceU === void 0) forceU = false;
    this.pos = this.nextIndex(this.pos, forceU);
};
$281a441cdcb2cf36$var$RegExpValidationState.prototype.eat = function eat(ch, forceU) {
    if (forceU === void 0) forceU = false;
    if (this.current(forceU) === ch) {
        this.advance(forceU);
        return true;
    }
    return false;
};
$281a441cdcb2cf36$var$RegExpValidationState.prototype.eatChars = function eatChars(chs, forceU) {
    if (forceU === void 0) forceU = false;
    var pos = this.pos;
    for(var i3 = 0, list = chs; i3 < list.length; i3 += 1){
        var ch = list[i3];
        var current2 = this.at(pos, forceU);
        if (current2 === -1 || current2 !== ch) return false;
        pos = this.nextIndex(pos, forceU);
    }
    this.pos = pos;
    return true;
};
$281a441cdcb2cf36$var$pp$1.validateRegExpFlags = function(state) {
    var validFlags = state.validFlags;
    var flags = state.flags;
    var u3 = false;
    var v3 = false;
    for(var i3 = 0; i3 < flags.length; i3++){
        var flag = flags.charAt(i3);
        if (validFlags.indexOf(flag) === -1) this.raise(state.start, "Invalid regular expression flag");
        if (flags.indexOf(flag, i3 + 1) > -1) this.raise(state.start, "Duplicate regular expression flag");
        if (flag === "u") u3 = true;
        if (flag === "v") v3 = true;
    }
    if (this.options.ecmaVersion >= 15 && u3 && v3) this.raise(state.start, "Invalid regular expression flag");
};
function $281a441cdcb2cf36$var$hasProp(obj) {
    for(var _3 in obj)return true;
    return false;
}
$281a441cdcb2cf36$var$pp$1.validateRegExpPattern = function(state) {
    this.regexp_pattern(state);
    if (!state.switchN && this.options.ecmaVersion >= 9 && $281a441cdcb2cf36$var$hasProp(state.groupNames)) {
        state.switchN = true;
        this.regexp_pattern(state);
    }
};
$281a441cdcb2cf36$var$pp$1.regexp_pattern = function(state) {
    state.pos = 0;
    state.lastIntValue = 0;
    state.lastStringValue = "";
    state.lastAssertionIsQuantifiable = false;
    state.numCapturingParens = 0;
    state.maxBackReference = 0;
    state.groupNames = /* @__PURE__ */ Object.create(null);
    state.backReferenceNames.length = 0;
    state.branchID = null;
    this.regexp_disjunction(state);
    if (state.pos !== state.source.length) {
        if (state.eat(41)) state.raise("Unmatched ')'");
        if (state.eat(93) || state.eat(125)) state.raise("Lone quantifier brackets");
    }
    if (state.maxBackReference > state.numCapturingParens) state.raise("Invalid escape");
    for(var i3 = 0, list = state.backReferenceNames; i3 < list.length; i3 += 1){
        var name = list[i3];
        if (!state.groupNames[name]) state.raise("Invalid named capture referenced");
    }
};
$281a441cdcb2cf36$var$pp$1.regexp_disjunction = function(state) {
    var trackDisjunction = this.options.ecmaVersion >= 16;
    if (trackDisjunction) state.branchID = new $281a441cdcb2cf36$var$BranchID(state.branchID, null);
    this.regexp_alternative(state);
    while(state.eat(124)){
        if (trackDisjunction) state.branchID = state.branchID.sibling();
        this.regexp_alternative(state);
    }
    if (trackDisjunction) state.branchID = state.branchID.parent;
    if (this.regexp_eatQuantifier(state, true)) state.raise("Nothing to repeat");
    if (state.eat(123)) state.raise("Lone quantifier brackets");
};
$281a441cdcb2cf36$var$pp$1.regexp_alternative = function(state) {
    while(state.pos < state.source.length && this.regexp_eatTerm(state));
};
$281a441cdcb2cf36$var$pp$1.regexp_eatTerm = function(state) {
    if (this.regexp_eatAssertion(state)) {
        if (state.lastAssertionIsQuantifiable && this.regexp_eatQuantifier(state)) {
            if (state.switchU) state.raise("Invalid quantifier");
        }
        return true;
    }
    if (state.switchU ? this.regexp_eatAtom(state) : this.regexp_eatExtendedAtom(state)) {
        this.regexp_eatQuantifier(state);
        return true;
    }
    return false;
};
$281a441cdcb2cf36$var$pp$1.regexp_eatAssertion = function(state) {
    var start = state.pos;
    state.lastAssertionIsQuantifiable = false;
    if (state.eat(94) || state.eat(36)) return true;
    if (state.eat(92)) {
        if (state.eat(66) || state.eat(98)) return true;
        state.pos = start;
    }
    if (state.eat(40) && state.eat(63)) {
        var lookbehind = false;
        if (this.options.ecmaVersion >= 9) lookbehind = state.eat(60);
        if (state.eat(61) || state.eat(33)) {
            this.regexp_disjunction(state);
            if (!state.eat(41)) state.raise("Unterminated group");
            state.lastAssertionIsQuantifiable = !lookbehind;
            return true;
        }
    }
    state.pos = start;
    return false;
};
$281a441cdcb2cf36$var$pp$1.regexp_eatQuantifier = function(state, noError) {
    if (noError === void 0) noError = false;
    if (this.regexp_eatQuantifierPrefix(state, noError)) {
        state.eat(63);
        return true;
    }
    return false;
};
$281a441cdcb2cf36$var$pp$1.regexp_eatQuantifierPrefix = function(state, noError) {
    return state.eat(42) || state.eat(43) || state.eat(63) || this.regexp_eatBracedQuantifier(state, noError);
};
$281a441cdcb2cf36$var$pp$1.regexp_eatBracedQuantifier = function(state, noError) {
    var start = state.pos;
    if (state.eat(123)) {
        var min2 = 0, max2 = -1;
        if (this.regexp_eatDecimalDigits(state)) {
            min2 = state.lastIntValue;
            if (state.eat(44) && this.regexp_eatDecimalDigits(state)) max2 = state.lastIntValue;
            if (state.eat(125)) {
                if (max2 !== -1 && max2 < min2 && !noError) state.raise("numbers out of order in {} quantifier");
                return true;
            }
        }
        if (state.switchU && !noError) state.raise("Incomplete quantifier");
        state.pos = start;
    }
    return false;
};
$281a441cdcb2cf36$var$pp$1.regexp_eatAtom = function(state) {
    return this.regexp_eatPatternCharacters(state) || state.eat(46) || this.regexp_eatReverseSolidusAtomEscape(state) || this.regexp_eatCharacterClass(state) || this.regexp_eatUncapturingGroup(state) || this.regexp_eatCapturingGroup(state);
};
$281a441cdcb2cf36$var$pp$1.regexp_eatReverseSolidusAtomEscape = function(state) {
    var start = state.pos;
    if (state.eat(92)) {
        if (this.regexp_eatAtomEscape(state)) return true;
        state.pos = start;
    }
    return false;
};
$281a441cdcb2cf36$var$pp$1.regexp_eatUncapturingGroup = function(state) {
    var start = state.pos;
    if (state.eat(40)) {
        if (state.eat(63)) {
            if (this.options.ecmaVersion >= 16) {
                var addModifiers = this.regexp_eatModifiers(state);
                var hasHyphen = state.eat(45);
                if (addModifiers || hasHyphen) {
                    for(var i3 = 0; i3 < addModifiers.length; i3++){
                        var modifier = addModifiers.charAt(i3);
                        if (addModifiers.indexOf(modifier, i3 + 1) > -1) state.raise("Duplicate regular expression modifiers");
                    }
                    if (hasHyphen) {
                        var removeModifiers = this.regexp_eatModifiers(state);
                        if (!addModifiers && !removeModifiers && state.current() === 58) state.raise("Invalid regular expression modifiers");
                        for(var i$1 = 0; i$1 < removeModifiers.length; i$1++){
                            var modifier$1 = removeModifiers.charAt(i$1);
                            if (removeModifiers.indexOf(modifier$1, i$1 + 1) > -1 || addModifiers.indexOf(modifier$1) > -1) state.raise("Duplicate regular expression modifiers");
                        }
                    }
                }
            }
            if (state.eat(58)) {
                this.regexp_disjunction(state);
                if (state.eat(41)) return true;
                state.raise("Unterminated group");
            }
        }
        state.pos = start;
    }
    return false;
};
$281a441cdcb2cf36$var$pp$1.regexp_eatCapturingGroup = function(state) {
    if (state.eat(40)) {
        if (this.options.ecmaVersion >= 9) this.regexp_groupSpecifier(state);
        else if (state.current() === 63) state.raise("Invalid group");
        this.regexp_disjunction(state);
        if (state.eat(41)) {
            state.numCapturingParens += 1;
            return true;
        }
        state.raise("Unterminated group");
    }
    return false;
};
$281a441cdcb2cf36$var$pp$1.regexp_eatModifiers = function(state) {
    var modifiers = "";
    var ch = 0;
    while((ch = state.current()) !== -1 && $281a441cdcb2cf36$var$isRegularExpressionModifier(ch)){
        modifiers += $281a441cdcb2cf36$var$codePointToString(ch);
        state.advance();
    }
    return modifiers;
};
function $281a441cdcb2cf36$var$isRegularExpressionModifier(ch) {
    return ch === 105 || ch === 109 || ch === 115;
}
$281a441cdcb2cf36$var$pp$1.regexp_eatExtendedAtom = function(state) {
    return state.eat(46) || this.regexp_eatReverseSolidusAtomEscape(state) || this.regexp_eatCharacterClass(state) || this.regexp_eatUncapturingGroup(state) || this.regexp_eatCapturingGroup(state) || this.regexp_eatInvalidBracedQuantifier(state) || this.regexp_eatExtendedPatternCharacter(state);
};
$281a441cdcb2cf36$var$pp$1.regexp_eatInvalidBracedQuantifier = function(state) {
    if (this.regexp_eatBracedQuantifier(state, true)) state.raise("Nothing to repeat");
    return false;
};
$281a441cdcb2cf36$var$pp$1.regexp_eatSyntaxCharacter = function(state) {
    var ch = state.current();
    if ($281a441cdcb2cf36$var$isSyntaxCharacter(ch)) {
        state.lastIntValue = ch;
        state.advance();
        return true;
    }
    return false;
};
function $281a441cdcb2cf36$var$isSyntaxCharacter(ch) {
    return ch === 36 || ch >= 40 && ch <= 43 || ch === 46 || ch === 63 || ch >= 91 && ch <= 94 || ch >= 123 && ch <= 125;
}
$281a441cdcb2cf36$var$pp$1.regexp_eatPatternCharacters = function(state) {
    var start = state.pos;
    var ch = 0;
    while((ch = state.current()) !== -1 && !$281a441cdcb2cf36$var$isSyntaxCharacter(ch))state.advance();
    return state.pos !== start;
};
$281a441cdcb2cf36$var$pp$1.regexp_eatExtendedPatternCharacter = function(state) {
    var ch = state.current();
    if (ch !== -1 && ch !== 36 && !(ch >= 40 && ch <= 43) && ch !== 46 && ch !== 63 && ch !== 91 && ch !== 94 && ch !== 124) {
        state.advance();
        return true;
    }
    return false;
};
$281a441cdcb2cf36$var$pp$1.regexp_groupSpecifier = function(state) {
    if (state.eat(63)) {
        if (!this.regexp_eatGroupName(state)) state.raise("Invalid group");
        var trackDisjunction = this.options.ecmaVersion >= 16;
        var known = state.groupNames[state.lastStringValue];
        if (known) {
            if (trackDisjunction) for(var i3 = 0, list = known; i3 < list.length; i3 += 1){
                var altID = list[i3];
                if (!altID.separatedFrom(state.branchID)) state.raise("Duplicate capture group name");
            }
            else state.raise("Duplicate capture group name");
        }
        if (trackDisjunction) (known || (state.groupNames[state.lastStringValue] = [])).push(state.branchID);
        else state.groupNames[state.lastStringValue] = true;
    }
};
$281a441cdcb2cf36$var$pp$1.regexp_eatGroupName = function(state) {
    state.lastStringValue = "";
    if (state.eat(60)) {
        if (this.regexp_eatRegExpIdentifierName(state) && state.eat(62)) return true;
        state.raise("Invalid capture group name");
    }
    return false;
};
$281a441cdcb2cf36$var$pp$1.regexp_eatRegExpIdentifierName = function(state) {
    state.lastStringValue = "";
    if (this.regexp_eatRegExpIdentifierStart(state)) {
        state.lastStringValue += $281a441cdcb2cf36$var$codePointToString(state.lastIntValue);
        while(this.regexp_eatRegExpIdentifierPart(state))state.lastStringValue += $281a441cdcb2cf36$var$codePointToString(state.lastIntValue);
        return true;
    }
    return false;
};
$281a441cdcb2cf36$var$pp$1.regexp_eatRegExpIdentifierStart = function(state) {
    var start = state.pos;
    var forceU = this.options.ecmaVersion >= 11;
    var ch = state.current(forceU);
    state.advance(forceU);
    if (ch === 92 && this.regexp_eatRegExpUnicodeEscapeSequence(state, forceU)) ch = state.lastIntValue;
    if ($281a441cdcb2cf36$var$isRegExpIdentifierStart(ch)) {
        state.lastIntValue = ch;
        return true;
    }
    state.pos = start;
    return false;
};
function $281a441cdcb2cf36$var$isRegExpIdentifierStart(ch) {
    return $281a441cdcb2cf36$var$isIdentifierStart(ch, true) || ch === 36 || ch === 95;
}
$281a441cdcb2cf36$var$pp$1.regexp_eatRegExpIdentifierPart = function(state) {
    var start = state.pos;
    var forceU = this.options.ecmaVersion >= 11;
    var ch = state.current(forceU);
    state.advance(forceU);
    if (ch === 92 && this.regexp_eatRegExpUnicodeEscapeSequence(state, forceU)) ch = state.lastIntValue;
    if ($281a441cdcb2cf36$var$isRegExpIdentifierPart(ch)) {
        state.lastIntValue = ch;
        return true;
    }
    state.pos = start;
    return false;
};
function $281a441cdcb2cf36$var$isRegExpIdentifierPart(ch) {
    return $281a441cdcb2cf36$var$isIdentifierChar(ch, true) || ch === 36 || ch === 95 || ch === 8204 || ch === 8205;
}
$281a441cdcb2cf36$var$pp$1.regexp_eatAtomEscape = function(state) {
    if (this.regexp_eatBackReference(state) || this.regexp_eatCharacterClassEscape(state) || this.regexp_eatCharacterEscape(state) || state.switchN && this.regexp_eatKGroupName(state)) return true;
    if (state.switchU) {
        if (state.current() === 99) state.raise("Invalid unicode escape");
        state.raise("Invalid escape");
    }
    return false;
};
$281a441cdcb2cf36$var$pp$1.regexp_eatBackReference = function(state) {
    var start = state.pos;
    if (this.regexp_eatDecimalEscape(state)) {
        var n3 = state.lastIntValue;
        if (state.switchU) {
            if (n3 > state.maxBackReference) state.maxBackReference = n3;
            return true;
        }
        if (n3 <= state.numCapturingParens) return true;
        state.pos = start;
    }
    return false;
};
$281a441cdcb2cf36$var$pp$1.regexp_eatKGroupName = function(state) {
    if (state.eat(107)) {
        if (this.regexp_eatGroupName(state)) {
            state.backReferenceNames.push(state.lastStringValue);
            return true;
        }
        state.raise("Invalid named reference");
    }
    return false;
};
$281a441cdcb2cf36$var$pp$1.regexp_eatCharacterEscape = function(state) {
    return this.regexp_eatControlEscape(state) || this.regexp_eatCControlLetter(state) || this.regexp_eatZero(state) || this.regexp_eatHexEscapeSequence(state) || this.regexp_eatRegExpUnicodeEscapeSequence(state, false) || !state.switchU && this.regexp_eatLegacyOctalEscapeSequence(state) || this.regexp_eatIdentityEscape(state);
};
$281a441cdcb2cf36$var$pp$1.regexp_eatCControlLetter = function(state) {
    var start = state.pos;
    if (state.eat(99)) {
        if (this.regexp_eatControlLetter(state)) return true;
        state.pos = start;
    }
    return false;
};
$281a441cdcb2cf36$var$pp$1.regexp_eatZero = function(state) {
    if (state.current() === 48 && !$281a441cdcb2cf36$var$isDecimalDigit(state.lookahead())) {
        state.lastIntValue = 0;
        state.advance();
        return true;
    }
    return false;
};
$281a441cdcb2cf36$var$pp$1.regexp_eatControlEscape = function(state) {
    var ch = state.current();
    if (ch === 116) {
        state.lastIntValue = 9;
        state.advance();
        return true;
    }
    if (ch === 110) {
        state.lastIntValue = 10;
        state.advance();
        return true;
    }
    if (ch === 118) {
        state.lastIntValue = 11;
        state.advance();
        return true;
    }
    if (ch === 102) {
        state.lastIntValue = 12;
        state.advance();
        return true;
    }
    if (ch === 114) {
        state.lastIntValue = 13;
        state.advance();
        return true;
    }
    return false;
};
$281a441cdcb2cf36$var$pp$1.regexp_eatControlLetter = function(state) {
    var ch = state.current();
    if ($281a441cdcb2cf36$var$isControlLetter(ch)) {
        state.lastIntValue = ch % 32;
        state.advance();
        return true;
    }
    return false;
};
function $281a441cdcb2cf36$var$isControlLetter(ch) {
    return ch >= 65 && ch <= 90 || ch >= 97 && ch <= 122;
}
$281a441cdcb2cf36$var$pp$1.regexp_eatRegExpUnicodeEscapeSequence = function(state, forceU) {
    if (forceU === void 0) forceU = false;
    var start = state.pos;
    var switchU = forceU || state.switchU;
    if (state.eat(117)) {
        if (this.regexp_eatFixedHexDigits(state, 4)) {
            var lead = state.lastIntValue;
            if (switchU && lead >= 55296 && lead <= 56319) {
                var leadSurrogateEnd = state.pos;
                if (state.eat(92) && state.eat(117) && this.regexp_eatFixedHexDigits(state, 4)) {
                    var trail = state.lastIntValue;
                    if (trail >= 56320 && trail <= 57343) {
                        state.lastIntValue = (lead - 55296) * 1024 + (trail - 56320) + 65536;
                        return true;
                    }
                }
                state.pos = leadSurrogateEnd;
                state.lastIntValue = lead;
            }
            return true;
        }
        if (switchU && state.eat(123) && this.regexp_eatHexDigits(state) && state.eat(125) && $281a441cdcb2cf36$var$isValidUnicode(state.lastIntValue)) return true;
        if (switchU) state.raise("Invalid unicode escape");
        state.pos = start;
    }
    return false;
};
function $281a441cdcb2cf36$var$isValidUnicode(ch) {
    return ch >= 0 && ch <= 1114111;
}
$281a441cdcb2cf36$var$pp$1.regexp_eatIdentityEscape = function(state) {
    if (state.switchU) {
        if (this.regexp_eatSyntaxCharacter(state)) return true;
        if (state.eat(47)) {
            state.lastIntValue = 47;
            return true;
        }
        return false;
    }
    var ch = state.current();
    if (ch !== 99 && (!state.switchN || ch !== 107)) {
        state.lastIntValue = ch;
        state.advance();
        return true;
    }
    return false;
};
$281a441cdcb2cf36$var$pp$1.regexp_eatDecimalEscape = function(state) {
    state.lastIntValue = 0;
    var ch = state.current();
    if (ch >= 49 && ch <= 57) {
        do {
            state.lastIntValue = 10 * state.lastIntValue + (ch - 48);
            state.advance();
        }while ((ch = state.current()) >= 48 && ch <= 57);
        return true;
    }
    return false;
};
var $281a441cdcb2cf36$var$CharSetNone = 0;
var $281a441cdcb2cf36$var$CharSetOk = 1;
var $281a441cdcb2cf36$var$CharSetString = 2;
$281a441cdcb2cf36$var$pp$1.regexp_eatCharacterClassEscape = function(state) {
    var ch = state.current();
    if ($281a441cdcb2cf36$var$isCharacterClassEscape(ch)) {
        state.lastIntValue = -1;
        state.advance();
        return $281a441cdcb2cf36$var$CharSetOk;
    }
    var negate = false;
    if (state.switchU && this.options.ecmaVersion >= 9 && ((negate = ch === 80) || ch === 112)) {
        state.lastIntValue = -1;
        state.advance();
        var result;
        if (state.eat(123) && (result = this.regexp_eatUnicodePropertyValueExpression(state)) && state.eat(125)) {
            if (negate && result === $281a441cdcb2cf36$var$CharSetString) state.raise("Invalid property name");
            return result;
        }
        state.raise("Invalid property name");
    }
    return $281a441cdcb2cf36$var$CharSetNone;
};
function $281a441cdcb2cf36$var$isCharacterClassEscape(ch) {
    return ch === 100 || ch === 68 || ch === 115 || ch === 83 || ch === 119 || ch === 87;
}
$281a441cdcb2cf36$var$pp$1.regexp_eatUnicodePropertyValueExpression = function(state) {
    var start = state.pos;
    if (this.regexp_eatUnicodePropertyName(state) && state.eat(61)) {
        var name = state.lastStringValue;
        if (this.regexp_eatUnicodePropertyValue(state)) {
            var value2 = state.lastStringValue;
            this.regexp_validateUnicodePropertyNameAndValue(state, name, value2);
            return $281a441cdcb2cf36$var$CharSetOk;
        }
    }
    state.pos = start;
    if (this.regexp_eatLoneUnicodePropertyNameOrValue(state)) {
        var nameOrValue = state.lastStringValue;
        return this.regexp_validateUnicodePropertyNameOrValue(state, nameOrValue);
    }
    return $281a441cdcb2cf36$var$CharSetNone;
};
$281a441cdcb2cf36$var$pp$1.regexp_validateUnicodePropertyNameAndValue = function(state, name, value2) {
    if (!$281a441cdcb2cf36$var$hasOwn(state.unicodeProperties.nonBinary, name)) state.raise("Invalid property name");
    if (!state.unicodeProperties.nonBinary[name].test(value2)) state.raise("Invalid property value");
};
$281a441cdcb2cf36$var$pp$1.regexp_validateUnicodePropertyNameOrValue = function(state, nameOrValue) {
    if (state.unicodeProperties.binary.test(nameOrValue)) return $281a441cdcb2cf36$var$CharSetOk;
    if (state.switchV && state.unicodeProperties.binaryOfStrings.test(nameOrValue)) return $281a441cdcb2cf36$var$CharSetString;
    state.raise("Invalid property name");
};
$281a441cdcb2cf36$var$pp$1.regexp_eatUnicodePropertyName = function(state) {
    var ch = 0;
    state.lastStringValue = "";
    while($281a441cdcb2cf36$var$isUnicodePropertyNameCharacter(ch = state.current())){
        state.lastStringValue += $281a441cdcb2cf36$var$codePointToString(ch);
        state.advance();
    }
    return state.lastStringValue !== "";
};
function $281a441cdcb2cf36$var$isUnicodePropertyNameCharacter(ch) {
    return $281a441cdcb2cf36$var$isControlLetter(ch) || ch === 95;
}
$281a441cdcb2cf36$var$pp$1.regexp_eatUnicodePropertyValue = function(state) {
    var ch = 0;
    state.lastStringValue = "";
    while($281a441cdcb2cf36$var$isUnicodePropertyValueCharacter(ch = state.current())){
        state.lastStringValue += $281a441cdcb2cf36$var$codePointToString(ch);
        state.advance();
    }
    return state.lastStringValue !== "";
};
function $281a441cdcb2cf36$var$isUnicodePropertyValueCharacter(ch) {
    return $281a441cdcb2cf36$var$isUnicodePropertyNameCharacter(ch) || $281a441cdcb2cf36$var$isDecimalDigit(ch);
}
$281a441cdcb2cf36$var$pp$1.regexp_eatLoneUnicodePropertyNameOrValue = function(state) {
    return this.regexp_eatUnicodePropertyValue(state);
};
$281a441cdcb2cf36$var$pp$1.regexp_eatCharacterClass = function(state) {
    if (state.eat(91)) {
        var negate = state.eat(94);
        var result = this.regexp_classContents(state);
        if (!state.eat(93)) state.raise("Unterminated character class");
        if (negate && result === $281a441cdcb2cf36$var$CharSetString) state.raise("Negated character class may contain strings");
        return true;
    }
    return false;
};
$281a441cdcb2cf36$var$pp$1.regexp_classContents = function(state) {
    if (state.current() === 93) return $281a441cdcb2cf36$var$CharSetOk;
    if (state.switchV) return this.regexp_classSetExpression(state);
    this.regexp_nonEmptyClassRanges(state);
    return $281a441cdcb2cf36$var$CharSetOk;
};
$281a441cdcb2cf36$var$pp$1.regexp_nonEmptyClassRanges = function(state) {
    while(this.regexp_eatClassAtom(state)){
        var left = state.lastIntValue;
        if (state.eat(45) && this.regexp_eatClassAtom(state)) {
            var right = state.lastIntValue;
            if (state.switchU && (left === -1 || right === -1)) state.raise("Invalid character class");
            if (left !== -1 && right !== -1 && left > right) state.raise("Range out of order in character class");
        }
    }
};
$281a441cdcb2cf36$var$pp$1.regexp_eatClassAtom = function(state) {
    var start = state.pos;
    if (state.eat(92)) {
        if (this.regexp_eatClassEscape(state)) return true;
        if (state.switchU) {
            var ch$1 = state.current();
            if (ch$1 === 99 || $281a441cdcb2cf36$var$isOctalDigit(ch$1)) state.raise("Invalid class escape");
            state.raise("Invalid escape");
        }
        state.pos = start;
    }
    var ch = state.current();
    if (ch !== 93) {
        state.lastIntValue = ch;
        state.advance();
        return true;
    }
    return false;
};
$281a441cdcb2cf36$var$pp$1.regexp_eatClassEscape = function(state) {
    var start = state.pos;
    if (state.eat(98)) {
        state.lastIntValue = 8;
        return true;
    }
    if (state.switchU && state.eat(45)) {
        state.lastIntValue = 45;
        return true;
    }
    if (!state.switchU && state.eat(99)) {
        if (this.regexp_eatClassControlLetter(state)) return true;
        state.pos = start;
    }
    return this.regexp_eatCharacterClassEscape(state) || this.regexp_eatCharacterEscape(state);
};
$281a441cdcb2cf36$var$pp$1.regexp_classSetExpression = function(state) {
    var result = $281a441cdcb2cf36$var$CharSetOk, subResult;
    if (this.regexp_eatClassSetRange(state)) ;
    else if (subResult = this.regexp_eatClassSetOperand(state)) {
        if (subResult === $281a441cdcb2cf36$var$CharSetString) result = $281a441cdcb2cf36$var$CharSetString;
        var start = state.pos;
        while(state.eatChars([
            38,
            38
        ])){
            if (state.current() !== 38 && (subResult = this.regexp_eatClassSetOperand(state))) {
                if (subResult !== $281a441cdcb2cf36$var$CharSetString) result = $281a441cdcb2cf36$var$CharSetOk;
                continue;
            }
            state.raise("Invalid character in character class");
        }
        if (start !== state.pos) return result;
        while(state.eatChars([
            45,
            45
        ])){
            if (this.regexp_eatClassSetOperand(state)) continue;
            state.raise("Invalid character in character class");
        }
        if (start !== state.pos) return result;
    } else state.raise("Invalid character in character class");
    for(;;){
        if (this.regexp_eatClassSetRange(state)) continue;
        subResult = this.regexp_eatClassSetOperand(state);
        if (!subResult) return result;
        if (subResult === $281a441cdcb2cf36$var$CharSetString) result = $281a441cdcb2cf36$var$CharSetString;
    }
};
$281a441cdcb2cf36$var$pp$1.regexp_eatClassSetRange = function(state) {
    var start = state.pos;
    if (this.regexp_eatClassSetCharacter(state)) {
        var left = state.lastIntValue;
        if (state.eat(45) && this.regexp_eatClassSetCharacter(state)) {
            var right = state.lastIntValue;
            if (left !== -1 && right !== -1 && left > right) state.raise("Range out of order in character class");
            return true;
        }
        state.pos = start;
    }
    return false;
};
$281a441cdcb2cf36$var$pp$1.regexp_eatClassSetOperand = function(state) {
    if (this.regexp_eatClassSetCharacter(state)) return $281a441cdcb2cf36$var$CharSetOk;
    return this.regexp_eatClassStringDisjunction(state) || this.regexp_eatNestedClass(state);
};
$281a441cdcb2cf36$var$pp$1.regexp_eatNestedClass = function(state) {
    var start = state.pos;
    if (state.eat(91)) {
        var negate = state.eat(94);
        var result = this.regexp_classContents(state);
        if (state.eat(93)) {
            if (negate && result === $281a441cdcb2cf36$var$CharSetString) state.raise("Negated character class may contain strings");
            return result;
        }
        state.pos = start;
    }
    if (state.eat(92)) {
        var result$1 = this.regexp_eatCharacterClassEscape(state);
        if (result$1) return result$1;
        state.pos = start;
    }
    return null;
};
$281a441cdcb2cf36$var$pp$1.regexp_eatClassStringDisjunction = function(state) {
    var start = state.pos;
    if (state.eatChars([
        92,
        113
    ])) {
        if (state.eat(123)) {
            var result = this.regexp_classStringDisjunctionContents(state);
            if (state.eat(125)) return result;
        } else state.raise("Invalid escape");
        state.pos = start;
    }
    return null;
};
$281a441cdcb2cf36$var$pp$1.regexp_classStringDisjunctionContents = function(state) {
    var result = this.regexp_classString(state);
    while(state.eat(124))if (this.regexp_classString(state) === $281a441cdcb2cf36$var$CharSetString) result = $281a441cdcb2cf36$var$CharSetString;
    return result;
};
$281a441cdcb2cf36$var$pp$1.regexp_classString = function(state) {
    var count2 = 0;
    while(this.regexp_eatClassSetCharacter(state))count2++;
    return count2 === 1 ? $281a441cdcb2cf36$var$CharSetOk : $281a441cdcb2cf36$var$CharSetString;
};
$281a441cdcb2cf36$var$pp$1.regexp_eatClassSetCharacter = function(state) {
    var start = state.pos;
    if (state.eat(92)) {
        if (this.regexp_eatCharacterEscape(state) || this.regexp_eatClassSetReservedPunctuator(state)) return true;
        if (state.eat(98)) {
            state.lastIntValue = 8;
            return true;
        }
        state.pos = start;
        return false;
    }
    var ch = state.current();
    if (ch < 0 || ch === state.lookahead() && $281a441cdcb2cf36$var$isClassSetReservedDoublePunctuatorCharacter(ch)) return false;
    if ($281a441cdcb2cf36$var$isClassSetSyntaxCharacter(ch)) return false;
    state.advance();
    state.lastIntValue = ch;
    return true;
};
function $281a441cdcb2cf36$var$isClassSetReservedDoublePunctuatorCharacter(ch) {
    return ch === 33 || ch >= 35 && ch <= 38 || ch >= 42 && ch <= 44 || ch === 46 || ch >= 58 && ch <= 64 || ch === 94 || ch === 96 || ch === 126;
}
function $281a441cdcb2cf36$var$isClassSetSyntaxCharacter(ch) {
    return ch === 40 || ch === 41 || ch === 45 || ch === 47 || ch >= 91 && ch <= 93 || ch >= 123 && ch <= 125;
}
$281a441cdcb2cf36$var$pp$1.regexp_eatClassSetReservedPunctuator = function(state) {
    var ch = state.current();
    if ($281a441cdcb2cf36$var$isClassSetReservedPunctuator(ch)) {
        state.lastIntValue = ch;
        state.advance();
        return true;
    }
    return false;
};
function $281a441cdcb2cf36$var$isClassSetReservedPunctuator(ch) {
    return ch === 33 || ch === 35 || ch === 37 || ch === 38 || ch === 44 || ch === 45 || ch >= 58 && ch <= 62 || ch === 64 || ch === 96 || ch === 126;
}
$281a441cdcb2cf36$var$pp$1.regexp_eatClassControlLetter = function(state) {
    var ch = state.current();
    if ($281a441cdcb2cf36$var$isDecimalDigit(ch) || ch === 95) {
        state.lastIntValue = ch % 32;
        state.advance();
        return true;
    }
    return false;
};
$281a441cdcb2cf36$var$pp$1.regexp_eatHexEscapeSequence = function(state) {
    var start = state.pos;
    if (state.eat(120)) {
        if (this.regexp_eatFixedHexDigits(state, 2)) return true;
        if (state.switchU) state.raise("Invalid escape");
        state.pos = start;
    }
    return false;
};
$281a441cdcb2cf36$var$pp$1.regexp_eatDecimalDigits = function(state) {
    var start = state.pos;
    var ch = 0;
    state.lastIntValue = 0;
    while($281a441cdcb2cf36$var$isDecimalDigit(ch = state.current())){
        state.lastIntValue = 10 * state.lastIntValue + (ch - 48);
        state.advance();
    }
    return state.pos !== start;
};
function $281a441cdcb2cf36$var$isDecimalDigit(ch) {
    return ch >= 48 && ch <= 57;
}
$281a441cdcb2cf36$var$pp$1.regexp_eatHexDigits = function(state) {
    var start = state.pos;
    var ch = 0;
    state.lastIntValue = 0;
    while($281a441cdcb2cf36$var$isHexDigit(ch = state.current())){
        state.lastIntValue = 16 * state.lastIntValue + $281a441cdcb2cf36$var$hexToInt(ch);
        state.advance();
    }
    return state.pos !== start;
};
function $281a441cdcb2cf36$var$isHexDigit(ch) {
    return ch >= 48 && ch <= 57 || ch >= 65 && ch <= 70 || ch >= 97 && ch <= 102;
}
function $281a441cdcb2cf36$var$hexToInt(ch) {
    if (ch >= 65 && ch <= 70) return 10 + (ch - 65);
    if (ch >= 97 && ch <= 102) return 10 + (ch - 97);
    return ch - 48;
}
$281a441cdcb2cf36$var$pp$1.regexp_eatLegacyOctalEscapeSequence = function(state) {
    if (this.regexp_eatOctalDigit(state)) {
        var n1 = state.lastIntValue;
        if (this.regexp_eatOctalDigit(state)) {
            var n22 = state.lastIntValue;
            if (n1 <= 3 && this.regexp_eatOctalDigit(state)) state.lastIntValue = n1 * 64 + n22 * 8 + state.lastIntValue;
            else state.lastIntValue = n1 * 8 + n22;
        } else state.lastIntValue = n1;
        return true;
    }
    return false;
};
$281a441cdcb2cf36$var$pp$1.regexp_eatOctalDigit = function(state) {
    var ch = state.current();
    if ($281a441cdcb2cf36$var$isOctalDigit(ch)) {
        state.lastIntValue = ch - 48;
        state.advance();
        return true;
    }
    state.lastIntValue = 0;
    return false;
};
function $281a441cdcb2cf36$var$isOctalDigit(ch) {
    return ch >= 48 && ch <= 55;
}
$281a441cdcb2cf36$var$pp$1.regexp_eatFixedHexDigits = function(state, length2) {
    var start = state.pos;
    state.lastIntValue = 0;
    for(var i3 = 0; i3 < length2; ++i3){
        var ch = state.current();
        if (!$281a441cdcb2cf36$var$isHexDigit(ch)) {
            state.pos = start;
            return false;
        }
        state.lastIntValue = 16 * state.lastIntValue + $281a441cdcb2cf36$var$hexToInt(ch);
        state.advance();
    }
    return true;
};
var $281a441cdcb2cf36$var$Token = function Token2(p3) {
    this.type = p3.type;
    this.value = p3.value;
    this.start = p3.start;
    this.end = p3.end;
    if (p3.options.locations) this.loc = new $281a441cdcb2cf36$var$SourceLocation(p3, p3.startLoc, p3.endLoc);
    if (p3.options.ranges) this.range = [
        p3.start,
        p3.end
    ];
};
var $281a441cdcb2cf36$var$pp = $281a441cdcb2cf36$var$Parser.prototype;
$281a441cdcb2cf36$var$pp.next = function(ignoreEscapeSequenceInKeyword) {
    if (!ignoreEscapeSequenceInKeyword && this.type.keyword && this.containsEsc) this.raiseRecoverable(this.start, "Escape sequence in keyword " + this.type.keyword);
    if (this.options.onToken) this.options.onToken(new $281a441cdcb2cf36$var$Token(this));
    this.lastTokEnd = this.end;
    this.lastTokStart = this.start;
    this.lastTokEndLoc = this.endLoc;
    this.lastTokStartLoc = this.startLoc;
    this.nextToken();
};
$281a441cdcb2cf36$var$pp.getToken = function() {
    this.next();
    return new $281a441cdcb2cf36$var$Token(this);
};
if (typeof Symbol !== "undefined") $281a441cdcb2cf36$var$pp[Symbol.iterator] = function() {
    var this$1$1 = this;
    return {
        next: function() {
            var token = this$1$1.getToken();
            return {
                done: token.type === $281a441cdcb2cf36$var$types$1.eof,
                value: token
            };
        }
    };
};
$281a441cdcb2cf36$var$pp.nextToken = function() {
    var curContext = this.curContext();
    if (!curContext || !curContext.preserveSpace) this.skipSpace();
    this.start = this.pos;
    if (this.options.locations) this.startLoc = this.curPosition();
    if (this.pos >= this.input.length) return this.finishToken($281a441cdcb2cf36$var$types$1.eof);
    if (curContext.override) return curContext.override(this);
    else this.readToken(this.fullCharCodeAtPos());
};
$281a441cdcb2cf36$var$pp.readToken = function(code) {
    if ($281a441cdcb2cf36$var$isIdentifierStart(code, this.options.ecmaVersion >= 6) || code === 92) return this.readWord();
    return this.getTokenFromCode(code);
};
$281a441cdcb2cf36$var$pp.fullCharCodeAt = function(pos) {
    var code = this.input.charCodeAt(pos);
    if (code <= 55295 || code >= 56320) return code;
    var next = this.input.charCodeAt(pos + 1);
    return next <= 56319 || next >= 57344 ? code : (code << 10) + next - 56613888;
};
$281a441cdcb2cf36$var$pp.fullCharCodeAtPos = function() {
    return this.fullCharCodeAt(this.pos);
};
$281a441cdcb2cf36$var$pp.skipBlockComment = function() {
    var startLoc = this.options.onComment && this.curPosition();
    var start = this.pos, end = this.input.indexOf("*/", this.pos += 2);
    if (end === -1) this.raise(this.pos - 2, "Unterminated comment");
    this.pos = end + 2;
    if (this.options.locations) for(var nextBreak = void 0, pos = start; (nextBreak = $281a441cdcb2cf36$var$nextLineBreak(this.input, pos, this.pos)) > -1;){
        ++this.curLine;
        pos = this.lineStart = nextBreak;
    }
    if (this.options.onComment) this.options.onComment(true, this.input.slice(start + 2, end), start, this.pos, startLoc, this.curPosition());
};
$281a441cdcb2cf36$var$pp.skipLineComment = function(startSkip) {
    var start = this.pos;
    var startLoc = this.options.onComment && this.curPosition();
    var ch = this.input.charCodeAt(this.pos += startSkip);
    while(this.pos < this.input.length && !$281a441cdcb2cf36$var$isNewLine(ch))ch = this.input.charCodeAt(++this.pos);
    if (this.options.onComment) this.options.onComment(false, this.input.slice(start + startSkip, this.pos), start, this.pos, startLoc, this.curPosition());
};
$281a441cdcb2cf36$var$pp.skipSpace = function() {
    loop: while(this.pos < this.input.length){
        var ch = this.input.charCodeAt(this.pos);
        switch(ch){
            case 32:
            case 160:
                ++this.pos;
                break;
            case 13:
                if (this.input.charCodeAt(this.pos + 1) === 10) ++this.pos;
            case 10:
            case 8232:
            case 8233:
                ++this.pos;
                if (this.options.locations) {
                    ++this.curLine;
                    this.lineStart = this.pos;
                }
                break;
            case 47:
                switch(this.input.charCodeAt(this.pos + 1)){
                    case 42:
                        this.skipBlockComment();
                        break;
                    case 47:
                        this.skipLineComment(2);
                        break;
                    default:
                        break loop;
                }
                break;
            default:
                if (ch > 8 && ch < 14 || ch >= 5760 && $281a441cdcb2cf36$var$nonASCIIwhitespace.test(String.fromCharCode(ch))) ++this.pos;
                else break loop;
        }
    }
};
$281a441cdcb2cf36$var$pp.finishToken = function(type, val) {
    this.end = this.pos;
    if (this.options.locations) this.endLoc = this.curPosition();
    var prevType = this.type;
    this.type = type;
    this.value = val;
    this.updateContext(prevType);
};
$281a441cdcb2cf36$var$pp.readToken_dot = function() {
    var next = this.input.charCodeAt(this.pos + 1);
    if (next >= 48 && next <= 57) return this.readNumber(true);
    var next2 = this.input.charCodeAt(this.pos + 2);
    if (this.options.ecmaVersion >= 6 && next === 46 && next2 === 46) {
        this.pos += 3;
        return this.finishToken($281a441cdcb2cf36$var$types$1.ellipsis);
    } else {
        ++this.pos;
        return this.finishToken($281a441cdcb2cf36$var$types$1.dot);
    }
};
$281a441cdcb2cf36$var$pp.readToken_slash = function() {
    var next = this.input.charCodeAt(this.pos + 1);
    if (this.exprAllowed) {
        ++this.pos;
        return this.readRegexp();
    }
    if (next === 61) return this.finishOp($281a441cdcb2cf36$var$types$1.assign, 2);
    return this.finishOp($281a441cdcb2cf36$var$types$1.slash, 1);
};
$281a441cdcb2cf36$var$pp.readToken_mult_modulo_exp = function(code) {
    var next = this.input.charCodeAt(this.pos + 1);
    var size2 = 1;
    var tokentype = code === 42 ? $281a441cdcb2cf36$var$types$1.star : $281a441cdcb2cf36$var$types$1.modulo;
    if (this.options.ecmaVersion >= 7 && code === 42 && next === 42) {
        ++size2;
        tokentype = $281a441cdcb2cf36$var$types$1.starstar;
        next = this.input.charCodeAt(this.pos + 2);
    }
    if (next === 61) return this.finishOp($281a441cdcb2cf36$var$types$1.assign, size2 + 1);
    return this.finishOp(tokentype, size2);
};
$281a441cdcb2cf36$var$pp.readToken_pipe_amp = function(code) {
    var next = this.input.charCodeAt(this.pos + 1);
    if (next === code) {
        if (this.options.ecmaVersion >= 12) {
            var next2 = this.input.charCodeAt(this.pos + 2);
            if (next2 === 61) return this.finishOp($281a441cdcb2cf36$var$types$1.assign, 3);
        }
        return this.finishOp(code === 124 ? $281a441cdcb2cf36$var$types$1.logicalOR : $281a441cdcb2cf36$var$types$1.logicalAND, 2);
    }
    if (next === 61) return this.finishOp($281a441cdcb2cf36$var$types$1.assign, 2);
    return this.finishOp(code === 124 ? $281a441cdcb2cf36$var$types$1.bitwiseOR : $281a441cdcb2cf36$var$types$1.bitwiseAND, 1);
};
$281a441cdcb2cf36$var$pp.readToken_caret = function() {
    var next = this.input.charCodeAt(this.pos + 1);
    if (next === 61) return this.finishOp($281a441cdcb2cf36$var$types$1.assign, 2);
    return this.finishOp($281a441cdcb2cf36$var$types$1.bitwiseXOR, 1);
};
$281a441cdcb2cf36$var$pp.readToken_plus_min = function(code) {
    var next = this.input.charCodeAt(this.pos + 1);
    if (next === code) {
        if (next === 45 && !this.inModule && this.input.charCodeAt(this.pos + 2) === 62 && (this.lastTokEnd === 0 || $281a441cdcb2cf36$var$lineBreak.test(this.input.slice(this.lastTokEnd, this.pos)))) {
            this.skipLineComment(3);
            this.skipSpace();
            return this.nextToken();
        }
        return this.finishOp($281a441cdcb2cf36$var$types$1.incDec, 2);
    }
    if (next === 61) return this.finishOp($281a441cdcb2cf36$var$types$1.assign, 2);
    return this.finishOp($281a441cdcb2cf36$var$types$1.plusMin, 1);
};
$281a441cdcb2cf36$var$pp.readToken_lt_gt = function(code) {
    var next = this.input.charCodeAt(this.pos + 1);
    var size2 = 1;
    if (next === code) {
        size2 = code === 62 && this.input.charCodeAt(this.pos + 2) === 62 ? 3 : 2;
        if (this.input.charCodeAt(this.pos + size2) === 61) return this.finishOp($281a441cdcb2cf36$var$types$1.assign, size2 + 1);
        return this.finishOp($281a441cdcb2cf36$var$types$1.bitShift, size2);
    }
    if (next === 33 && code === 60 && !this.inModule && this.input.charCodeAt(this.pos + 2) === 45 && this.input.charCodeAt(this.pos + 3) === 45) {
        this.skipLineComment(4);
        this.skipSpace();
        return this.nextToken();
    }
    if (next === 61) size2 = 2;
    return this.finishOp($281a441cdcb2cf36$var$types$1.relational, size2);
};
$281a441cdcb2cf36$var$pp.readToken_eq_excl = function(code) {
    var next = this.input.charCodeAt(this.pos + 1);
    if (next === 61) return this.finishOp($281a441cdcb2cf36$var$types$1.equality, this.input.charCodeAt(this.pos + 2) === 61 ? 3 : 2);
    if (code === 61 && next === 62 && this.options.ecmaVersion >= 6) {
        this.pos += 2;
        return this.finishToken($281a441cdcb2cf36$var$types$1.arrow);
    }
    return this.finishOp(code === 61 ? $281a441cdcb2cf36$var$types$1.eq : $281a441cdcb2cf36$var$types$1.prefix, 1);
};
$281a441cdcb2cf36$var$pp.readToken_question = function() {
    var ecmaVersion = this.options.ecmaVersion;
    if (ecmaVersion >= 11) {
        var next = this.input.charCodeAt(this.pos + 1);
        if (next === 46) {
            var next2 = this.input.charCodeAt(this.pos + 2);
            if (next2 < 48 || next2 > 57) return this.finishOp($281a441cdcb2cf36$var$types$1.questionDot, 2);
        }
        if (next === 63) {
            if (ecmaVersion >= 12) {
                var next2$1 = this.input.charCodeAt(this.pos + 2);
                if (next2$1 === 61) return this.finishOp($281a441cdcb2cf36$var$types$1.assign, 3);
            }
            return this.finishOp($281a441cdcb2cf36$var$types$1.coalesce, 2);
        }
    }
    return this.finishOp($281a441cdcb2cf36$var$types$1.question, 1);
};
$281a441cdcb2cf36$var$pp.readToken_numberSign = function() {
    var ecmaVersion = this.options.ecmaVersion;
    var code = 35;
    if (ecmaVersion >= 13) {
        ++this.pos;
        code = this.fullCharCodeAtPos();
        if ($281a441cdcb2cf36$var$isIdentifierStart(code, true) || code === 92) return this.finishToken($281a441cdcb2cf36$var$types$1.privateId, this.readWord1());
    }
    this.raise(this.pos, "Unexpected character '" + $281a441cdcb2cf36$var$codePointToString(code) + "'");
};
$281a441cdcb2cf36$var$pp.getTokenFromCode = function(code) {
    switch(code){
        // The interpretation of a dot depends on whether it is followed
        // by a digit or another two dots.
        case 46:
            return this.readToken_dot();
        // Punctuation tokens.
        case 40:
            ++this.pos;
            return this.finishToken($281a441cdcb2cf36$var$types$1.parenL);
        case 41:
            ++this.pos;
            return this.finishToken($281a441cdcb2cf36$var$types$1.parenR);
        case 59:
            ++this.pos;
            return this.finishToken($281a441cdcb2cf36$var$types$1.semi);
        case 44:
            ++this.pos;
            return this.finishToken($281a441cdcb2cf36$var$types$1.comma);
        case 91:
            ++this.pos;
            return this.finishToken($281a441cdcb2cf36$var$types$1.bracketL);
        case 93:
            ++this.pos;
            return this.finishToken($281a441cdcb2cf36$var$types$1.bracketR);
        case 123:
            ++this.pos;
            return this.finishToken($281a441cdcb2cf36$var$types$1.braceL);
        case 125:
            ++this.pos;
            return this.finishToken($281a441cdcb2cf36$var$types$1.braceR);
        case 58:
            ++this.pos;
            return this.finishToken($281a441cdcb2cf36$var$types$1.colon);
        case 96:
            if (this.options.ecmaVersion < 6) break;
            ++this.pos;
            return this.finishToken($281a441cdcb2cf36$var$types$1.backQuote);
        case 48:
            var next = this.input.charCodeAt(this.pos + 1);
            if (next === 120 || next === 88) return this.readRadixNumber(16);
            if (this.options.ecmaVersion >= 6) {
                if (next === 111 || next === 79) return this.readRadixNumber(8);
                if (next === 98 || next === 66) return this.readRadixNumber(2);
            }
        // Anything else beginning with a digit is an integer, octal
        // number, or float.
        case 49:
        case 50:
        case 51:
        case 52:
        case 53:
        case 54:
        case 55:
        case 56:
        case 57:
            return this.readNumber(false);
        // Quotes produce strings.
        case 34:
        case 39:
            return this.readString(code);
        // Operators are parsed inline in tiny state machines. '=' (61) is
        // often referred to. `finishOp` simply skips the amount of
        // characters it is given as second argument, and returns a token
        // of the type given by its first argument.
        case 47:
            return this.readToken_slash();
        case 37:
        case 42:
            return this.readToken_mult_modulo_exp(code);
        case 124:
        case 38:
            return this.readToken_pipe_amp(code);
        case 94:
            return this.readToken_caret();
        case 43:
        case 45:
            return this.readToken_plus_min(code);
        case 60:
        case 62:
            return this.readToken_lt_gt(code);
        case 61:
        case 33:
            return this.readToken_eq_excl(code);
        case 63:
            return this.readToken_question();
        case 126:
            return this.finishOp($281a441cdcb2cf36$var$types$1.prefix, 1);
        case 35:
            return this.readToken_numberSign();
    }
    this.raise(this.pos, "Unexpected character '" + $281a441cdcb2cf36$var$codePointToString(code) + "'");
};
$281a441cdcb2cf36$var$pp.finishOp = function(type, size2) {
    var str = this.input.slice(this.pos, this.pos + size2);
    this.pos += size2;
    return this.finishToken(type, str);
};
$281a441cdcb2cf36$var$pp.readRegexp = function() {
    var escaped, inClass, start = this.pos;
    for(;;){
        if (this.pos >= this.input.length) this.raise(start, "Unterminated regular expression");
        var ch = this.input.charAt(this.pos);
        if ($281a441cdcb2cf36$var$lineBreak.test(ch)) this.raise(start, "Unterminated regular expression");
        if (!escaped) {
            if (ch === "[") inClass = true;
            else if (ch === "]" && inClass) inClass = false;
            else if (ch === "/" && !inClass) break;
            escaped = ch === "\\";
        } else escaped = false;
        ++this.pos;
    }
    var pattern = this.input.slice(start, this.pos);
    ++this.pos;
    var flagsStart = this.pos;
    var flags = this.readWord1();
    if (this.containsEsc) this.unexpected(flagsStart);
    var state = this.regexpState || (this.regexpState = new $281a441cdcb2cf36$var$RegExpValidationState(this));
    state.reset(start, pattern, flags);
    this.validateRegExpFlags(state);
    this.validateRegExpPattern(state);
    var value2 = null;
    try {
        value2 = new RegExp(pattern, flags);
    } catch (e4) {}
    return this.finishToken($281a441cdcb2cf36$var$types$1.regexp, {
        pattern: pattern,
        flags: flags,
        value: value2
    });
};
$281a441cdcb2cf36$var$pp.readInt = function(radix, len, maybeLegacyOctalNumericLiteral) {
    var allowSeparators = this.options.ecmaVersion >= 12 && len === void 0;
    var isLegacyOctalNumericLiteral = maybeLegacyOctalNumericLiteral && this.input.charCodeAt(this.pos) === 48;
    var start = this.pos, total = 0, lastCode = 0;
    for(var i3 = 0, e4 = len == null ? Infinity : len; i3 < e4; ++i3, ++this.pos){
        var code = this.input.charCodeAt(this.pos), val = void 0;
        if (allowSeparators && code === 95) {
            if (isLegacyOctalNumericLiteral) this.raiseRecoverable(this.pos, "Numeric separator is not allowed in legacy octal numeric literals");
            if (lastCode === 95) this.raiseRecoverable(this.pos, "Numeric separator must be exactly one underscore");
            if (i3 === 0) this.raiseRecoverable(this.pos, "Numeric separator is not allowed at the first of digits");
            lastCode = code;
            continue;
        }
        if (code >= 97) val = code - 97 + 10;
        else if (code >= 65) val = code - 65 + 10;
        else if (code >= 48 && code <= 57) val = code - 48;
        else val = Infinity;
        if (val >= radix) break;
        lastCode = code;
        total = total * radix + val;
    }
    if (allowSeparators && lastCode === 95) this.raiseRecoverable(this.pos - 1, "Numeric separator is not allowed at the last of digits");
    if (this.pos === start || len != null && this.pos - start !== len) return null;
    return total;
};
function $281a441cdcb2cf36$var$stringToNumber(str, isLegacyOctalNumericLiteral) {
    if (isLegacyOctalNumericLiteral) return parseInt(str, 8);
    return parseFloat(str.replace(/_/g, ""));
}
function $281a441cdcb2cf36$var$stringToBigInt(str) {
    if (typeof BigInt !== "function") return null;
    return BigInt(str.replace(/_/g, ""));
}
$281a441cdcb2cf36$var$pp.readRadixNumber = function(radix) {
    var start = this.pos;
    this.pos += 2;
    var val = this.readInt(radix);
    if (val == null) this.raise(this.start + 2, "Expected number in radix " + radix);
    if (this.options.ecmaVersion >= 11 && this.input.charCodeAt(this.pos) === 110) {
        val = $281a441cdcb2cf36$var$stringToBigInt(this.input.slice(start, this.pos));
        ++this.pos;
    } else if ($281a441cdcb2cf36$var$isIdentifierStart(this.fullCharCodeAtPos())) this.raise(this.pos, "Identifier directly after number");
    return this.finishToken($281a441cdcb2cf36$var$types$1.num, val);
};
$281a441cdcb2cf36$var$pp.readNumber = function(startsWithDot) {
    var start = this.pos;
    if (!startsWithDot && this.readInt(10, void 0, true) === null) this.raise(start, "Invalid number");
    var octal = this.pos - start >= 2 && this.input.charCodeAt(start) === 48;
    if (octal && this.strict) this.raise(start, "Invalid number");
    var next = this.input.charCodeAt(this.pos);
    if (!octal && !startsWithDot && this.options.ecmaVersion >= 11 && next === 110) {
        var val$1 = $281a441cdcb2cf36$var$stringToBigInt(this.input.slice(start, this.pos));
        ++this.pos;
        if ($281a441cdcb2cf36$var$isIdentifierStart(this.fullCharCodeAtPos())) this.raise(this.pos, "Identifier directly after number");
        return this.finishToken($281a441cdcb2cf36$var$types$1.num, val$1);
    }
    if (octal && /[89]/.test(this.input.slice(start, this.pos))) octal = false;
    if (next === 46 && !octal) {
        ++this.pos;
        this.readInt(10);
        next = this.input.charCodeAt(this.pos);
    }
    if ((next === 69 || next === 101) && !octal) {
        next = this.input.charCodeAt(++this.pos);
        if (next === 43 || next === 45) ++this.pos;
        if (this.readInt(10) === null) this.raise(start, "Invalid number");
    }
    if ($281a441cdcb2cf36$var$isIdentifierStart(this.fullCharCodeAtPos())) this.raise(this.pos, "Identifier directly after number");
    var val = $281a441cdcb2cf36$var$stringToNumber(this.input.slice(start, this.pos), octal);
    return this.finishToken($281a441cdcb2cf36$var$types$1.num, val);
};
$281a441cdcb2cf36$var$pp.readCodePoint = function() {
    var ch = this.input.charCodeAt(this.pos), code;
    if (ch === 123) {
        if (this.options.ecmaVersion < 6) this.unexpected();
        var codePos = ++this.pos;
        code = this.readHexChar(this.input.indexOf("}", this.pos) - this.pos);
        ++this.pos;
        if (code > 1114111) this.invalidStringToken(codePos, "Code point out of bounds");
    } else code = this.readHexChar(4);
    return code;
};
$281a441cdcb2cf36$var$pp.readString = function(quote) {
    var out = "", chunkStart = ++this.pos;
    for(;;){
        if (this.pos >= this.input.length) this.raise(this.start, "Unterminated string constant");
        var ch = this.input.charCodeAt(this.pos);
        if (ch === quote) break;
        if (ch === 92) {
            out += this.input.slice(chunkStart, this.pos);
            out += this.readEscapedChar(false);
            chunkStart = this.pos;
        } else if (ch === 8232 || ch === 8233) {
            if (this.options.ecmaVersion < 10) this.raise(this.start, "Unterminated string constant");
            ++this.pos;
            if (this.options.locations) {
                this.curLine++;
                this.lineStart = this.pos;
            }
        } else {
            if ($281a441cdcb2cf36$var$isNewLine(ch)) this.raise(this.start, "Unterminated string constant");
            ++this.pos;
        }
    }
    out += this.input.slice(chunkStart, this.pos++);
    return this.finishToken($281a441cdcb2cf36$var$types$1.string, out);
};
var $281a441cdcb2cf36$var$INVALID_TEMPLATE_ESCAPE_ERROR = {};
$281a441cdcb2cf36$var$pp.tryReadTemplateToken = function() {
    this.inTemplateElement = true;
    try {
        this.readTmplToken();
    } catch (err) {
        if (err === $281a441cdcb2cf36$var$INVALID_TEMPLATE_ESCAPE_ERROR) this.readInvalidTemplateToken();
        else throw err;
    }
    this.inTemplateElement = false;
};
$281a441cdcb2cf36$var$pp.invalidStringToken = function(position, message) {
    if (this.inTemplateElement && this.options.ecmaVersion >= 9) throw $281a441cdcb2cf36$var$INVALID_TEMPLATE_ESCAPE_ERROR;
    else this.raise(position, message);
};
$281a441cdcb2cf36$var$pp.readTmplToken = function() {
    var out = "", chunkStart = this.pos;
    for(;;){
        if (this.pos >= this.input.length) this.raise(this.start, "Unterminated template");
        var ch = this.input.charCodeAt(this.pos);
        if (ch === 96 || ch === 36 && this.input.charCodeAt(this.pos + 1) === 123) {
            if (this.pos === this.start && (this.type === $281a441cdcb2cf36$var$types$1.template || this.type === $281a441cdcb2cf36$var$types$1.invalidTemplate)) {
                if (ch === 36) {
                    this.pos += 2;
                    return this.finishToken($281a441cdcb2cf36$var$types$1.dollarBraceL);
                } else {
                    ++this.pos;
                    return this.finishToken($281a441cdcb2cf36$var$types$1.backQuote);
                }
            }
            out += this.input.slice(chunkStart, this.pos);
            return this.finishToken($281a441cdcb2cf36$var$types$1.template, out);
        }
        if (ch === 92) {
            out += this.input.slice(chunkStart, this.pos);
            out += this.readEscapedChar(true);
            chunkStart = this.pos;
        } else if ($281a441cdcb2cf36$var$isNewLine(ch)) {
            out += this.input.slice(chunkStart, this.pos);
            ++this.pos;
            switch(ch){
                case 13:
                    if (this.input.charCodeAt(this.pos) === 10) ++this.pos;
                case 10:
                    out += "\n";
                    break;
                default:
                    out += String.fromCharCode(ch);
                    break;
            }
            if (this.options.locations) {
                ++this.curLine;
                this.lineStart = this.pos;
            }
            chunkStart = this.pos;
        } else ++this.pos;
    }
};
$281a441cdcb2cf36$var$pp.readInvalidTemplateToken = function() {
    for(; this.pos < this.input.length; this.pos++)switch(this.input[this.pos]){
        case "\\":
            ++this.pos;
            break;
        case "$":
            if (this.input[this.pos + 1] !== "{") break;
        // fall through
        case "`":
            return this.finishToken($281a441cdcb2cf36$var$types$1.invalidTemplate, this.input.slice(this.start, this.pos));
        case "\r":
            if (this.input[this.pos + 1] === "\n") ++this.pos;
        // fall through
        case "\n":
        case "\u2028":
        case "\u2029":
            ++this.curLine;
            this.lineStart = this.pos + 1;
            break;
    }
    this.raise(this.start, "Unterminated template");
};
$281a441cdcb2cf36$var$pp.readEscapedChar = function(inTemplate) {
    var ch = this.input.charCodeAt(++this.pos);
    ++this.pos;
    switch(ch){
        case 110:
            return "\n";
        // 'n' -> '\n'
        case 114:
            return "\r";
        // 'r' -> '\r'
        case 120:
            return String.fromCharCode(this.readHexChar(2));
        // 'x'
        case 117:
            return $281a441cdcb2cf36$var$codePointToString(this.readCodePoint());
        // 'u'
        case 116:
            return "	";
        // 't' -> '\t'
        case 98:
            return "\b";
        // 'b' -> '\b'
        case 118:
            return "\v";
        // 'v' -> '\u000b'
        case 102:
            return "\f";
        // 'f' -> '\f'
        case 13:
            if (this.input.charCodeAt(this.pos) === 10) ++this.pos;
        // '\r\n'
        case 10:
            if (this.options.locations) {
                this.lineStart = this.pos;
                ++this.curLine;
            }
            return "";
        case 56:
        case 57:
            if (this.strict) this.invalidStringToken(this.pos - 1, "Invalid escape sequence");
            if (inTemplate) {
                var codePos = this.pos - 1;
                this.invalidStringToken(codePos, "Invalid escape sequence in template string");
            }
        default:
            if (ch >= 48 && ch <= 55) {
                var octalStr = this.input.substr(this.pos - 1, 3).match(/^[0-7]+/)[0];
                var octal = parseInt(octalStr, 8);
                if (octal > 255) {
                    octalStr = octalStr.slice(0, -1);
                    octal = parseInt(octalStr, 8);
                }
                this.pos += octalStr.length - 1;
                ch = this.input.charCodeAt(this.pos);
                if ((octalStr !== "0" || ch === 56 || ch === 57) && (this.strict || inTemplate)) this.invalidStringToken(this.pos - 1 - octalStr.length, inTemplate ? "Octal literal in template string" : "Octal literal in strict mode");
                return String.fromCharCode(octal);
            }
            if ($281a441cdcb2cf36$var$isNewLine(ch)) {
                if (this.options.locations) {
                    this.lineStart = this.pos;
                    ++this.curLine;
                }
                return "";
            }
            return String.fromCharCode(ch);
    }
};
$281a441cdcb2cf36$var$pp.readHexChar = function(len) {
    var codePos = this.pos;
    var n3 = this.readInt(16, len);
    if (n3 === null) this.invalidStringToken(codePos, "Bad character escape sequence");
    return n3;
};
$281a441cdcb2cf36$var$pp.readWord1 = function() {
    this.containsEsc = false;
    var word2 = "", first = true, chunkStart = this.pos;
    var astral = this.options.ecmaVersion >= 6;
    while(this.pos < this.input.length){
        var ch = this.fullCharCodeAtPos();
        if ($281a441cdcb2cf36$var$isIdentifierChar(ch, astral)) this.pos += ch <= 65535 ? 1 : 2;
        else if (ch === 92) {
            this.containsEsc = true;
            word2 += this.input.slice(chunkStart, this.pos);
            var escStart = this.pos;
            if (this.input.charCodeAt(++this.pos) !== 117) this.invalidStringToken(this.pos, "Expecting Unicode escape sequence \\uXXXX");
            ++this.pos;
            var esc = this.readCodePoint();
            if (!(first ? $281a441cdcb2cf36$var$isIdentifierStart : $281a441cdcb2cf36$var$isIdentifierChar)(esc, astral)) this.invalidStringToken(escStart, "Invalid Unicode escape");
            word2 += $281a441cdcb2cf36$var$codePointToString(esc);
            chunkStart = this.pos;
        } else break;
        first = false;
    }
    return word2 + this.input.slice(chunkStart, this.pos);
};
$281a441cdcb2cf36$var$pp.readWord = function() {
    var word2 = this.readWord1();
    var type = $281a441cdcb2cf36$var$types$1.name;
    if (this.keywords.test(word2)) type = $281a441cdcb2cf36$var$keywords[word2];
    return this.finishToken(type, word2);
};
var $281a441cdcb2cf36$var$version = "8.16.0";
$281a441cdcb2cf36$var$Parser.acorn = {
    Parser: $281a441cdcb2cf36$var$Parser,
    version: $281a441cdcb2cf36$var$version,
    defaultOptions: $281a441cdcb2cf36$var$defaultOptions,
    Position: $281a441cdcb2cf36$var$Position,
    SourceLocation: $281a441cdcb2cf36$var$SourceLocation,
    getLineInfo: $281a441cdcb2cf36$var$getLineInfo,
    Node: $281a441cdcb2cf36$var$Node2,
    TokenType: $281a441cdcb2cf36$var$TokenType,
    tokTypes: $281a441cdcb2cf36$var$types$1,
    keywordTypes: $281a441cdcb2cf36$var$keywords,
    TokContext: $281a441cdcb2cf36$var$TokContext,
    tokContexts: $281a441cdcb2cf36$var$types,
    isIdentifierChar: $281a441cdcb2cf36$var$isIdentifierChar,
    isIdentifierStart: $281a441cdcb2cf36$var$isIdentifierStart,
    Token: $281a441cdcb2cf36$var$Token,
    isNewLine: $281a441cdcb2cf36$var$isNewLine,
    lineBreak: $281a441cdcb2cf36$var$lineBreak,
    lineBreakG: $281a441cdcb2cf36$var$lineBreakG,
    nonASCIIwhitespace: $281a441cdcb2cf36$var$nonASCIIwhitespace
};
function $281a441cdcb2cf36$var$parse4(input, options) {
    return $281a441cdcb2cf36$var$Parser.parse(input, options);
}
// ../node_modules/acorn-walk/dist/walk.mjs
function $281a441cdcb2cf36$var$full(node, callback, baseVisitor, state, override) {
    if (!baseVisitor) baseVisitor = $281a441cdcb2cf36$var$base;
    var last2;
    (function c3(node2, st2, override2) {
        var type = override2 || node2.type;
        $281a441cdcb2cf36$var$visitNode(baseVisitor, type, node2, st2, c3);
        if (last2 !== node2) {
            callback(node2, st2, type);
            last2 = node2;
        }
    })(node, state, override);
}
function $281a441cdcb2cf36$var$skipThrough(node, st2, c3) {
    c3(node, st2);
}
function $281a441cdcb2cf36$var$ignore(_node, _st, _c) {}
function $281a441cdcb2cf36$var$visitNode(baseVisitor, type, node, st2, c3) {
    if (baseVisitor[type] == null) throw new Error("No walker function defined for node type " + type);
    baseVisitor[type](node, st2, c3);
}
var $281a441cdcb2cf36$var$base = {};
$281a441cdcb2cf36$var$base.Program = $281a441cdcb2cf36$var$base.BlockStatement = $281a441cdcb2cf36$var$base.StaticBlock = function(node, st2, c3) {
    for(var i3 = 0, list = node.body; i3 < list.length; i3 += 1){
        var stmt = list[i3];
        c3(stmt, st2, "Statement");
    }
};
$281a441cdcb2cf36$var$base.Statement = $281a441cdcb2cf36$var$skipThrough;
$281a441cdcb2cf36$var$base.EmptyStatement = $281a441cdcb2cf36$var$ignore;
$281a441cdcb2cf36$var$base.ExpressionStatement = $281a441cdcb2cf36$var$base.ParenthesizedExpression = $281a441cdcb2cf36$var$base.ChainExpression = function(node, st2, c3) {
    return c3(node.expression, st2, "Expression");
};
$281a441cdcb2cf36$var$base.IfStatement = function(node, st2, c3) {
    c3(node.test, st2, "Expression");
    c3(node.consequent, st2, "Statement");
    if (node.alternate) c3(node.alternate, st2, "Statement");
};
$281a441cdcb2cf36$var$base.LabeledStatement = function(node, st2, c3) {
    return c3(node.body, st2, "Statement");
};
$281a441cdcb2cf36$var$base.BreakStatement = $281a441cdcb2cf36$var$base.ContinueStatement = $281a441cdcb2cf36$var$ignore;
$281a441cdcb2cf36$var$base.WithStatement = function(node, st2, c3) {
    c3(node.object, st2, "Expression");
    c3(node.body, st2, "Statement");
};
$281a441cdcb2cf36$var$base.SwitchStatement = function(node, st2, c3) {
    c3(node.discriminant, st2, "Expression");
    for(var i3 = 0, list = node.cases; i3 < list.length; i3 += 1){
        var cs = list[i3];
        c3(cs, st2);
    }
};
$281a441cdcb2cf36$var$base.SwitchCase = function(node, st2, c3) {
    if (node.test) c3(node.test, st2, "Expression");
    for(var i3 = 0, list = node.consequent; i3 < list.length; i3 += 1){
        var cons = list[i3];
        c3(cons, st2, "Statement");
    }
};
$281a441cdcb2cf36$var$base.ReturnStatement = $281a441cdcb2cf36$var$base.YieldExpression = $281a441cdcb2cf36$var$base.AwaitExpression = function(node, st2, c3) {
    if (node.argument) c3(node.argument, st2, "Expression");
};
$281a441cdcb2cf36$var$base.ThrowStatement = $281a441cdcb2cf36$var$base.SpreadElement = function(node, st2, c3) {
    return c3(node.argument, st2, "Expression");
};
$281a441cdcb2cf36$var$base.TryStatement = function(node, st2, c3) {
    c3(node.block, st2, "Statement");
    if (node.handler) c3(node.handler, st2);
    if (node.finalizer) c3(node.finalizer, st2, "Statement");
};
$281a441cdcb2cf36$var$base.CatchClause = function(node, st2, c3) {
    if (node.param) c3(node.param, st2, "Pattern");
    c3(node.body, st2, "Statement");
};
$281a441cdcb2cf36$var$base.WhileStatement = $281a441cdcb2cf36$var$base.DoWhileStatement = function(node, st2, c3) {
    c3(node.test, st2, "Expression");
    c3(node.body, st2, "Statement");
};
$281a441cdcb2cf36$var$base.ForStatement = function(node, st2, c3) {
    if (node.init) c3(node.init, st2, "ForInit");
    if (node.test) c3(node.test, st2, "Expression");
    if (node.update) c3(node.update, st2, "Expression");
    c3(node.body, st2, "Statement");
};
$281a441cdcb2cf36$var$base.ForInStatement = $281a441cdcb2cf36$var$base.ForOfStatement = function(node, st2, c3) {
    c3(node.left, st2, "ForInit");
    c3(node.right, st2, "Expression");
    c3(node.body, st2, "Statement");
};
$281a441cdcb2cf36$var$base.ForInit = function(node, st2, c3) {
    if (node.type === "VariableDeclaration") c3(node, st2);
    else c3(node, st2, "Expression");
};
$281a441cdcb2cf36$var$base.DebuggerStatement = $281a441cdcb2cf36$var$ignore;
$281a441cdcb2cf36$var$base.FunctionDeclaration = function(node, st2, c3) {
    return c3(node, st2, "Function");
};
$281a441cdcb2cf36$var$base.VariableDeclaration = function(node, st2, c3) {
    for(var i3 = 0, list = node.declarations; i3 < list.length; i3 += 1){
        var decl = list[i3];
        c3(decl, st2);
    }
};
$281a441cdcb2cf36$var$base.VariableDeclarator = function(node, st2, c3) {
    c3(node.id, st2, "Pattern");
    if (node.init) c3(node.init, st2, "Expression");
};
$281a441cdcb2cf36$var$base.Function = function(node, st2, c3) {
    if (node.id) c3(node.id, st2, "Pattern");
    for(var i3 = 0, list = node.params; i3 < list.length; i3 += 1){
        var param = list[i3];
        c3(param, st2, "Pattern");
    }
    c3(node.body, st2, node.expression ? "Expression" : "Statement");
};
$281a441cdcb2cf36$var$base.Pattern = function(node, st2, c3) {
    if (node.type === "Identifier") c3(node, st2, "VariablePattern");
    else if (node.type === "MemberExpression") c3(node, st2, "MemberPattern");
    else c3(node, st2);
};
$281a441cdcb2cf36$var$base.VariablePattern = $281a441cdcb2cf36$var$ignore;
$281a441cdcb2cf36$var$base.MemberPattern = $281a441cdcb2cf36$var$skipThrough;
$281a441cdcb2cf36$var$base.RestElement = function(node, st2, c3) {
    return c3(node.argument, st2, "Pattern");
};
$281a441cdcb2cf36$var$base.ArrayPattern = function(node, st2, c3) {
    for(var i3 = 0, list = node.elements; i3 < list.length; i3 += 1){
        var elt = list[i3];
        if (elt) c3(elt, st2, "Pattern");
    }
};
$281a441cdcb2cf36$var$base.ObjectPattern = function(node, st2, c3) {
    for(var i3 = 0, list = node.properties; i3 < list.length; i3 += 1){
        var prop = list[i3];
        if (prop.type === "Property") {
            if (prop.computed) c3(prop.key, st2, "Expression");
            c3(prop.value, st2, "Pattern");
        } else if (prop.type === "RestElement") c3(prop.argument, st2, "Pattern");
    }
};
$281a441cdcb2cf36$var$base.Expression = $281a441cdcb2cf36$var$skipThrough;
$281a441cdcb2cf36$var$base.ThisExpression = $281a441cdcb2cf36$var$base.Super = $281a441cdcb2cf36$var$base.MetaProperty = $281a441cdcb2cf36$var$ignore;
$281a441cdcb2cf36$var$base.ArrayExpression = function(node, st2, c3) {
    for(var i3 = 0, list = node.elements; i3 < list.length; i3 += 1){
        var elt = list[i3];
        if (elt) c3(elt, st2, "Expression");
    }
};
$281a441cdcb2cf36$var$base.ObjectExpression = function(node, st2, c3) {
    for(var i3 = 0, list = node.properties; i3 < list.length; i3 += 1){
        var prop = list[i3];
        c3(prop, st2);
    }
};
$281a441cdcb2cf36$var$base.FunctionExpression = $281a441cdcb2cf36$var$base.ArrowFunctionExpression = $281a441cdcb2cf36$var$base.FunctionDeclaration;
$281a441cdcb2cf36$var$base.SequenceExpression = function(node, st2, c3) {
    for(var i3 = 0, list = node.expressions; i3 < list.length; i3 += 1){
        var expr = list[i3];
        c3(expr, st2, "Expression");
    }
};
$281a441cdcb2cf36$var$base.TemplateLiteral = function(node, st2, c3) {
    for(var i3 = 0, list = node.quasis; i3 < list.length; i3 += 1){
        var quasi = list[i3];
        c3(quasi, st2);
    }
    for(var i$1 = 0, list$1 = node.expressions; i$1 < list$1.length; i$1 += 1){
        var expr = list$1[i$1];
        c3(expr, st2, "Expression");
    }
};
$281a441cdcb2cf36$var$base.TemplateElement = $281a441cdcb2cf36$var$ignore;
$281a441cdcb2cf36$var$base.UnaryExpression = $281a441cdcb2cf36$var$base.UpdateExpression = function(node, st2, c3) {
    c3(node.argument, st2, "Expression");
};
$281a441cdcb2cf36$var$base.BinaryExpression = $281a441cdcb2cf36$var$base.LogicalExpression = function(node, st2, c3) {
    c3(node.left, st2, "Expression");
    c3(node.right, st2, "Expression");
};
$281a441cdcb2cf36$var$base.AssignmentExpression = $281a441cdcb2cf36$var$base.AssignmentPattern = function(node, st2, c3) {
    c3(node.left, st2, "Pattern");
    c3(node.right, st2, "Expression");
};
$281a441cdcb2cf36$var$base.ConditionalExpression = function(node, st2, c3) {
    c3(node.test, st2, "Expression");
    c3(node.consequent, st2, "Expression");
    c3(node.alternate, st2, "Expression");
};
$281a441cdcb2cf36$var$base.NewExpression = $281a441cdcb2cf36$var$base.CallExpression = function(node, st2, c3) {
    c3(node.callee, st2, "Expression");
    if (node.arguments) for(var i3 = 0, list = node.arguments; i3 < list.length; i3 += 1){
        var arg = list[i3];
        c3(arg, st2, "Expression");
    }
};
$281a441cdcb2cf36$var$base.MemberExpression = function(node, st2, c3) {
    c3(node.object, st2, "Expression");
    if (node.computed) c3(node.property, st2, "Expression");
};
$281a441cdcb2cf36$var$base.ExportNamedDeclaration = $281a441cdcb2cf36$var$base.ExportDefaultDeclaration = function(node, st2, c3) {
    if (node.declaration) c3(node.declaration, st2, node.type === "ExportNamedDeclaration" || node.declaration.id ? "Statement" : "Expression");
    if (node.source) c3(node.source, st2, "Expression");
    if (node.attributes) for(var i3 = 0, list = node.attributes; i3 < list.length; i3 += 1){
        var attr = list[i3];
        c3(attr, st2);
    }
};
$281a441cdcb2cf36$var$base.ExportAllDeclaration = function(node, st2, c3) {
    if (node.exported) c3(node.exported, st2);
    c3(node.source, st2, "Expression");
    if (node.attributes) for(var i3 = 0, list = node.attributes; i3 < list.length; i3 += 1){
        var attr = list[i3];
        c3(attr, st2);
    }
};
$281a441cdcb2cf36$var$base.ImportAttribute = function(node, st2, c3) {
    c3(node.value, st2, "Expression");
};
$281a441cdcb2cf36$var$base.ImportDeclaration = function(node, st2, c3) {
    for(var i3 = 0, list = node.specifiers; i3 < list.length; i3 += 1){
        var spec = list[i3];
        c3(spec, st2);
    }
    c3(node.source, st2, "Expression");
    if (node.attributes) for(var i$1 = 0, list$1 = node.attributes; i$1 < list$1.length; i$1 += 1){
        var attr = list$1[i$1];
        c3(attr, st2);
    }
};
$281a441cdcb2cf36$var$base.ImportExpression = function(node, st2, c3) {
    c3(node.source, st2, "Expression");
    if (node.options) c3(node.options, st2, "Expression");
};
$281a441cdcb2cf36$var$base.ImportSpecifier = $281a441cdcb2cf36$var$base.ImportDefaultSpecifier = $281a441cdcb2cf36$var$base.ImportNamespaceSpecifier = $281a441cdcb2cf36$var$base.Identifier = $281a441cdcb2cf36$var$base.PrivateIdentifier = $281a441cdcb2cf36$var$base.Literal = $281a441cdcb2cf36$var$ignore;
$281a441cdcb2cf36$var$base.TaggedTemplateExpression = function(node, st2, c3) {
    c3(node.tag, st2, "Expression");
    c3(node.quasi, st2, "Expression");
};
$281a441cdcb2cf36$var$base.ClassDeclaration = $281a441cdcb2cf36$var$base.ClassExpression = function(node, st2, c3) {
    return c3(node, st2, "Class");
};
$281a441cdcb2cf36$var$base.Class = function(node, st2, c3) {
    if (node.id) c3(node.id, st2, "Pattern");
    if (node.superClass) c3(node.superClass, st2, "Expression");
    c3(node.body, st2);
};
$281a441cdcb2cf36$var$base.ClassBody = function(node, st2, c3) {
    for(var i3 = 0, list = node.body; i3 < list.length; i3 += 1){
        var elt = list[i3];
        c3(elt, st2);
    }
};
$281a441cdcb2cf36$var$base.MethodDefinition = $281a441cdcb2cf36$var$base.PropertyDefinition = $281a441cdcb2cf36$var$base.Property = function(node, st2, c3) {
    if (node.computed) c3(node.key, st2, "Expression");
    if (node.value) c3(node.value, st2, "Expression");
};
// src/utils/validation.js
var $281a441cdcb2cf36$var$RESERVED_KEYWORDS = [
    "abstract",
    "arguments",
    "await",
    "boolean",
    "break",
    "byte",
    "case",
    "catch",
    "char",
    "class",
    "const",
    "continue",
    "debugger",
    "default",
    "delete",
    "do",
    "double",
    "else",
    "enum",
    "eval",
    "export",
    "extends",
    "false",
    "final",
    "finally",
    "float",
    "for",
    "function",
    "goto",
    "if",
    "implements",
    "import",
    "in",
    "instanceof",
    "int",
    "interface",
    "let",
    "long",
    "native",
    "new",
    "null",
    "package",
    "private",
    "protected",
    "public",
    "return",
    "short",
    "static",
    "super",
    "switch",
    "synchronized",
    "this",
    "throw",
    "throws",
    "transient",
    "true",
    "try",
    "typeof",
    "var",
    "void",
    "volatile",
    "while",
    "with",
    "yield"
];
var $281a441cdcb2cf36$var$CODE_TYPES = [
    "snippets",
    "functions"
];
var $281a441cdcb2cf36$var$checkCodeForReservedKeywords = (code)=>{
    try {
        const cleanCode = code.replace(/\/\/\/\/\/n/gu, "\n");
        const ast = $281a441cdcb2cf36$var$parse4(cleanCode, {
            ecmaVersion: "latest",
            sourceType: "module",
            allowReserved: true
        });
        const findReservedDeclarations = (node)=>{
            var _a2, _b, _c;
            if (node.type === "FunctionDeclaration") {
                const name = (_a2 = node.id) == null ? void 0 : _a2.name;
                if (name && $281a441cdcb2cf36$var$RESERVED_KEYWORDS.includes(name)) throw new Error(`Found reserved keyword "${name}" used as function name`);
                node.params.forEach((param)=>{
                    if (param.type === "Identifier" && $281a441cdcb2cf36$var$RESERVED_KEYWORDS.includes(param.name)) throw new Error(`Found reserved keyword "${param.name}" used as parameter name`);
                });
            }
            if (node.type === "VariableDeclarator") {
                const name = (_b = node.id) == null ? void 0 : _b.name;
                if (name && $281a441cdcb2cf36$var$RESERVED_KEYWORDS.includes(name)) throw new Error(`Found reserved keyword "${name}" used as variable name`);
            }
            if (node.type === "Identifier" && ((_c = node.parent) == null ? void 0 : _c.type) === "VariableDeclarator") {
                if ($281a441cdcb2cf36$var$RESERVED_KEYWORDS.includes(node.name)) throw new Error(`Found reserved keyword "${node.name}" used as variable name`);
            }
        };
        $281a441cdcb2cf36$var$full(ast, (node)=>{
            findReservedDeclarations(node);
        });
    } catch (error) {
        if (error.message.includes("reserved keyword")) throw error;
        return true;
    }
};
var $281a441cdcb2cf36$var$validateParams = {
    type: (type)=>{
        if (!type) throw new Error("Type parameter is required");
        if (typeof type !== "string") throw new Error("Type must be a string");
        return true;
    },
    key: (key, type)=>{
        if (!key) throw new Error("Key parameter is required");
        if (typeof key !== "string") throw new Error("Key must be a string");
        if ($281a441cdcb2cf36$var$CODE_TYPES.includes(type) && $281a441cdcb2cf36$var$RESERVED_KEYWORDS.includes(key)) throw new Error(`Key "${key}" is a reserved JavaScript keyword and cannot be used`);
        return true;
    },
    data: (data2, type)=>{
        if (!data2) throw new Error("Data parameter is required");
        if (typeof data2 !== "object") throw new Error("Data must be an object");
        if (!data2.key) throw new Error("Data must contain a key property");
        if ($281a441cdcb2cf36$var$CODE_TYPES.includes(type)) {
            if ($281a441cdcb2cf36$var$RESERVED_KEYWORDS.includes(data2.key)) throw new Error(`Key "${data2.key}" is a reserved JavaScript keyword and cannot be used`);
            if (data2.value) {
                const codeToCheck = data2.value;
                if (typeof codeToCheck === "string") $281a441cdcb2cf36$var$checkCodeForReservedKeywords(codeToCheck);
            }
        }
        return true;
    }
};
// src/utils/ordering.js
function $281a441cdcb2cf36$var$isObjectLike(val) {
    return val && typeof val === "object" && !Array.isArray(val);
}
function $281a441cdcb2cf36$var$normalizePath(path) {
    if (Array.isArray(path)) return path;
    if (typeof path === "string") return [
        path
    ];
    return [];
}
function $281a441cdcb2cf36$var$getParentPathsFromTuples(tuples = []) {
    const seen = /* @__PURE__ */ new Set();
    const parents = [];
    const META_KEYS = /* @__PURE__ */ new Set([
        "style",
        "class",
        "text",
        "html",
        "content",
        "data",
        "attr",
        "state",
        "scope",
        "define",
        "on",
        "extend",
        "extends",
        "childExtend",
        "childExtends",
        "children",
        "component",
        "context",
        "tag",
        "key",
        "__order",
        "if"
    ]);
    for(let i3 = 0; i3 < tuples.length; i3++){
        const tuple = tuples[i3];
        if (!Array.isArray(tuple) || tuple.length < 2) continue;
        const path = $281a441cdcb2cf36$var$normalizePath(tuple[1]);
        if (!path.length) continue;
        if (path[0] === "schema") continue;
        const immediateParent = path.slice(0, -1);
        if (immediateParent.length) {
            const key = JSON.stringify(immediateParent);
            if (!seen.has(key)) {
                seen.add(key);
                parents.push(immediateParent);
            }
        }
        const last2 = path[path.length - 1];
        if (META_KEYS.has(last2) && path.length >= 2) {
            const containerParent = path.slice(0, -2);
            if (containerParent.length) {
                const key2 = JSON.stringify(containerParent);
                if (!seen.has(key2)) {
                    seen.add(key2);
                    parents.push(containerParent);
                }
            }
        }
        for(let j3 = 0; j3 < path.length; j3++){
            const seg = path[j3];
            if (!META_KEYS.has(seg)) continue;
            const containerParent2 = path.slice(0, j3);
            if (!containerParent2.length) continue;
            const key3 = JSON.stringify(containerParent2);
            if (!seen.has(key3)) {
                seen.add(key3);
                parents.push(containerParent2);
            }
        }
    }
    return parents;
}
function $281a441cdcb2cf36$var$computeOrdersFromState(root, parentPaths = []) {
    if (!root || typeof root.getByPath !== "function") return [];
    const orders = [];
    const EXCLUDE_KEYS = /* @__PURE__ */ new Set([
        "__order"
    ]);
    for(let i3 = 0; i3 < parentPaths.length; i3++){
        const parentPath = parentPaths[i3];
        const obj = (()=>{
            try {
                return root.getByPath(parentPath);
            } catch  {
                return null;
            }
        })();
        if (!$281a441cdcb2cf36$var$isObjectLike(obj)) continue;
        const keys2 = Object.keys(obj).filter((k3)=>!EXCLUDE_KEYS.has(k3));
        orders.push({
            path: parentPath,
            keys: keys2
        });
    }
    return orders;
}
function $281a441cdcb2cf36$var$normaliseSchemaCode(code) {
    if (typeof code !== "string" || !code.length) return "";
    return code.replaceAll("/////n", "\n").replaceAll("/////tilde", "`");
}
function $281a441cdcb2cf36$var$parseExportedObject(code) {
    const src = $281a441cdcb2cf36$var$normaliseSchemaCode(code);
    if (!src) return null;
    const body = src.replace(/^\s*export\s+default\s*/u, "return ");
    try {
        return new Function(body)();
    } catch  {
        return null;
    }
}
function $281a441cdcb2cf36$var$extractTopLevelKeysFromCode(code) {
    const obj = $281a441cdcb2cf36$var$parseExportedObject(code);
    if (!obj || typeof obj !== "object") return [];
    return Object.keys(obj);
}
function $281a441cdcb2cf36$var$computeOrdersForTuples(root, tuples = []) {
    const pendingChildrenByContainer = /* @__PURE__ */ new Map();
    for(let i3 = 0; i3 < tuples.length; i3++){
        const t4 = tuples[i3];
        if (!Array.isArray(t4)) continue;
        const [action, path] = t4;
        const p3 = $281a441cdcb2cf36$var$normalizePath(path);
        if (!Array.isArray(p3) || p3.length < 2) continue;
        if (p3[0] === "schema") continue;
        const containerPath = p3.slice(0, -1);
        const childKey = p3[p3.length - 1];
        const key = JSON.stringify(containerPath);
        if (!pendingChildrenByContainer.has(key)) pendingChildrenByContainer.set(key, /* @__PURE__ */ new Set());
        if (action === "update" || action === "set") pendingChildrenByContainer.get(key).add(childKey);
    }
    const preferredOrderMap = /* @__PURE__ */ new Map();
    for(let i3 = 0; i3 < tuples.length; i3++){
        const t4 = tuples[i3];
        if (!Array.isArray(t4)) continue;
        const [action, path, value2] = t4;
        const p3 = $281a441cdcb2cf36$var$normalizePath(path);
        if (action !== "update" || !Array.isArray(p3) || p3.length < 3) continue;
        if (p3[0] !== "schema") continue;
        const [, type, key] = p3;
        const containerPath = [
            type,
            key
        ];
        const uses = value2 && Array.isArray(value2.uses) ? value2.uses : null;
        const code = value2 && value2.code;
        const obj = (()=>{
            try {
                return root && typeof root.getByPath === "function" ? root.getByPath(containerPath) : null;
            } catch  {
                return null;
            }
        })();
        if (!obj) continue;
        const present = new Set(Object.keys(obj));
        const EXCLUDE_KEYS = /* @__PURE__ */ new Set([
            "__order"
        ]);
        const codeKeys = $281a441cdcb2cf36$var$extractTopLevelKeysFromCode(code);
        let resolved = [];
        const pendingKey = JSON.stringify(containerPath);
        const pendingChildren = pendingChildrenByContainer.get(pendingKey) || /* @__PURE__ */ new Set();
        const eligible = /* @__PURE__ */ new Set([
            ...present,
            ...pendingChildren
        ]);
        if (Array.isArray(codeKeys) && codeKeys.length) resolved = codeKeys.filter((k3)=>eligible.has(k3) && !EXCLUDE_KEYS.has(k3));
        if (Array.isArray(uses) && uses.length) for(let u3 = 0; u3 < uses.length; u3++){
            const keyName = uses[u3];
            if (eligible.has(keyName) && !EXCLUDE_KEYS.has(keyName) && !resolved.includes(keyName)) resolved.push(keyName);
        }
        if (pendingChildren.size) {
            for (const child of pendingChildren)if (!EXCLUDE_KEYS.has(child) && !resolved.includes(child)) resolved.push(child);
        }
        if (resolved.length) preferredOrderMap.set(JSON.stringify(containerPath), {
            path: containerPath,
            keys: resolved
        });
    }
    const parents = $281a441cdcb2cf36$var$getParentPathsFromTuples(tuples);
    const orders = [];
    const seen = /* @__PURE__ */ new Set();
    preferredOrderMap.forEach((v3)=>{
        const k3 = JSON.stringify(v3.path);
        if (!seen.has(k3)) {
            seen.add(k3);
            orders.push(v3);
        }
    });
    const fallbackOrders = $281a441cdcb2cf36$var$computeOrdersFromState(root, parents);
    for(let i3 = 0; i3 < fallbackOrders.length; i3++){
        const v3 = fallbackOrders[i3];
        const k3 = JSON.stringify(v3.path);
        if (seen.has(k3)) continue;
        const pending = pendingChildrenByContainer.get(k3);
        if (pending && pending.size) {
            const existingKeys = v3.keys;
            const existingSet = new Set(existingKeys);
            const META_KEYS = /* @__PURE__ */ new Set([
                "style",
                "class",
                "text",
                "html",
                "content",
                "data",
                "attr",
                "state",
                "scope",
                "define",
                "on",
                "extend",
                "extends",
                "childExtend",
                "childExtends",
                "children",
                "component",
                "context",
                "tag",
                "key",
                "__order",
                "if"
            ]);
            let firstMetaIndex = existingKeys.length;
            for(let j3 = 0; j3 < existingKeys.length; j3++)if (META_KEYS.has(existingKeys[j3])) {
                firstMetaIndex = j3;
                break;
            }
            for (const child of pending){
                if (existingSet.has(child)) continue;
                const insertIndex = firstMetaIndex;
                existingKeys.splice(insertIndex, 0, child);
                existingSet.add(child);
                firstMetaIndex++;
            }
        }
        seen.add(k3);
        orders.push(v3);
    }
    return orders;
}
// src/utils/changePreprocessor.js
function $281a441cdcb2cf36$var$isPlainObject2(val) {
    return val && typeof val === "object" && !Array.isArray(val);
}
function $281a441cdcb2cf36$var$getByPathSafe(root, path) {
    if (!root || typeof root.getByPath !== "function") return null;
    try {
        return root.getByPath(path);
    } catch  {
        return null;
    }
}
function $281a441cdcb2cf36$var$resolveNextValueFromTuples(tuples, path) {
    if (!Array.isArray(tuples) || !Array.isArray(path)) return null;
    for(let i3 = tuples.length - 1; i3 >= 0; i3--){
        const t4 = tuples[i3];
        if (!Array.isArray(t4) || t4.length < 3) continue;
        const [action, tuplePath, tupleValue] = t4;
        if (action !== "update" && action !== "set" || !Array.isArray(tuplePath)) continue;
        if (tuplePath.length > path.length) continue;
        let isPrefix = true;
        for(let j3 = 0; j3 < tuplePath.length; j3++)if (tuplePath[j3] !== path[j3]) {
            isPrefix = false;
            break;
        }
        if (!isPrefix) continue;
        if (tuplePath.length === path.length) return tupleValue;
        let current2 = tupleValue;
        for(let j3 = tuplePath.length; j3 < path.length; j3++){
            if (current2 == null) return null;
            current2 = current2[path[j3]];
        }
        if (current2 !== null) return current2;
    }
    return null;
}
function $281a441cdcb2cf36$var$preprocessChanges(root, tuples = [], options = {}) {
    const expandTuple = (t4)=>{
        const [action, path, value2] = t4 || [];
        const isSchemaPath = Array.isArray(path) && path[0] === "schema";
        const isFilesPath = Array.isArray(path) && path[0] === "files";
        if (action === "delete") return [
            t4
        ];
        const canConsiderExpansion = action === "update" && Array.isArray(path) && (path.length === 1 || path.length === 2 || isSchemaPath && path.length === 3) && $281a441cdcb2cf36$var$isPlainObject2(value2);
        if (!canConsiderExpansion || isFilesPath || value2 && value2.type === "files") return [
            t4
        ];
        const prevRaw = $281a441cdcb2cf36$var$getByPathSafe(root, path);
        const isCreatePath = Array.isArray(path) && action === "update" && // e.g. ['update', ['components', 'NewKey'], {...}]
        (!isSchemaPath && path.length === 2 || // e.g. ['update', ['schema', 'components', 'NewKey'], {...}]
        isSchemaPath && path.length === 3) && (prevRaw === null || typeof prevRaw === "undefined");
        if (isCreatePath) return [
            t4
        ];
        const prev = prevRaw || {};
        const next = value2 || {};
        if (!$281a441cdcb2cf36$var$isPlainObject2(prev) || !$281a441cdcb2cf36$var$isPlainObject2(next)) return [
            t4
        ];
        const ops = $281a441cdcb2cf36$var$diffJson(prev, next, []);
        if (!ops.length) return [
            t4
        ];
        const out = [];
        for(let i3 = 0; i3 < ops.length; i3++){
            const op = ops[i3];
            const fullPath = [
                ...path,
                ...op.path
            ];
            const last2 = fullPath[fullPath.length - 1];
            if (op.action === "set") out.push([
                "update",
                fullPath,
                op.value
            ]);
            else if (op.action === "del") {
                if (last2 !== "__order") out.push([
                    "delete",
                    fullPath
                ]);
            }
        }
        return out;
    };
    const minimizeTuples = (input)=>{
        const out = [];
        const seen2 = /* @__PURE__ */ new Set();
        for(let i3 = 0; i3 < input.length; i3++){
            const expanded = expandTuple(input[i3]);
            for(let k3 = 0; k3 < expanded.length; k3++){
                const tuple = expanded[k3];
                const isDelete = Array.isArray(tuple) && tuple[0] === "delete";
                const isOrderKey = isDelete && Array.isArray(tuple[1]) && tuple[1][tuple[1].length - 1] === "__order";
                if (!isOrderKey) {
                    const key = JSON.stringify(tuple);
                    if (!seen2.has(key)) {
                        seen2.add(key);
                        out.push(tuple);
                    }
                }
            }
        }
        return out;
    };
    const granularChanges = (()=>{
        try {
            const res = minimizeTuples(tuples);
            if (options.append && options.append.length) res.push(...options.append);
            return res;
        } catch  {
            return Array.isArray(tuples) ? tuples.slice() : [];
        }
    })();
    const hydratedGranularChanges = granularChanges.map((t4)=>{
        if (!Array.isArray(t4) || t4.length < 3) return t4;
        const [action, path] = t4;
        if (action !== "update" && action !== "set" || !Array.isArray(path)) return t4;
        const nextValue = $281a441cdcb2cf36$var$resolveNextValueFromTuples(tuples, path);
        if (nextValue === null) return t4;
        return [
            action,
            path,
            nextValue
        ];
    });
    const baseOrders = $281a441cdcb2cf36$var$computeOrdersForTuples(root, hydratedGranularChanges);
    const preferOrdersMap = /* @__PURE__ */ new Map();
    for(let i3 = 0; i3 < tuples.length; i3++){
        const t4 = tuples[i3];
        if (!Array.isArray(t4) || t4.length < 3) continue;
        const [action, path, value2] = t4;
        const isFilesPath = Array.isArray(path) && path[0] === "files";
        if (action !== "update" || !Array.isArray(path) || path.length !== 1 && path.length !== 2 || !$281a441cdcb2cf36$var$isPlainObject2(value2) || isFilesPath || value2 && value2.type === "files") continue;
        const keys2 = Object.keys(value2).filter((k3)=>k3 !== "__order");
        const key = JSON.stringify(path);
        preferOrdersMap.set(key, {
            path: path,
            keys: keys2
        });
    }
    const mergedOrders = [];
    const seen = /* @__PURE__ */ new Set();
    preferOrdersMap.forEach((v3, k3)=>{
        seen.add(k3);
        mergedOrders.push(v3);
    });
    for(let i3 = 0; i3 < baseOrders.length; i3++){
        const v3 = baseOrders[i3];
        const k3 = JSON.stringify(v3.path);
        if (!seen.has(k3)) {
            seen.add(k3);
            mergedOrders.push(v3);
        }
    }
    return {
        granularChanges: hydratedGranularChanges,
        orders: mergedOrders
    };
}
// src/services/CollabService.js
var $281a441cdcb2cf36$var$FUNCTION_META_KEYS = [
    "node",
    "__ref",
    "__element",
    "parent",
    "parse"
];
function $281a441cdcb2cf36$var$stringifyFunctionsForTransport(value2, seen = /* @__PURE__ */ new WeakMap()) {
    if (value2 === null || typeof value2 !== "object") return typeof value2 === "function" ? value2.toString() : value2;
    if (seen.has(value2)) return seen.get(value2);
    const clone = Array.isArray(value2) ? [] : {};
    seen.set(value2, clone);
    if (Array.isArray(value2)) {
        for(let i3 = 0; i3 < value2.length; i3++)clone[i3] = $281a441cdcb2cf36$var$stringifyFunctionsForTransport(value2[i3], seen);
        return clone;
    }
    const keys2 = Object.keys(value2);
    for(let i3 = 0; i3 < keys2.length; i3++){
        const key = keys2[i3];
        if (!$281a441cdcb2cf36$var$FUNCTION_META_KEYS.includes(key)) clone[key] = $281a441cdcb2cf36$var$stringifyFunctionsForTransport(value2[key], seen);
    }
    return clone;
}
var $281a441cdcb2cf36$var$CollabService = class extends $281a441cdcb2cf36$var$BaseService {
    constructor(config){
        super(config);
        this._client = null;
        this._stateManager = null;
        this._connected = false;
        this._connecting = false;
        this._connectPromise = null;
        this._connectionMeta = null;
        this._pendingConnectReject = null;
        this._undoStack = [];
        this._redoStack = [];
        this._isUndoRedo = false;
        this._pendingOps = [];
        this._onSocketConnect = this._onSocketConnect.bind(this);
        this._onSocketDisconnect = this._onSocketDisconnect.bind(this);
        this._onSocketError = this._onSocketError.bind(this);
    }
    init({ context: context2 }) {
        super.init({
            context: context2
        });
        if (context2 == null ? void 0 : context2.state) try {
            this._stateManager = new $281a441cdcb2cf36$var$RootStateManager(context2.state);
        } catch (err) {
            this._setError(err);
            throw err;
        }
        this._setReady();
    }
    /**
   * Overridden to re-initialise the state manager once the root state becomes
   * available via a subsequent SDK `updateContext()` call.
   */ updateContext(context2 = {}) {
        super.updateContext(context2);
        if (context2.state) this._stateManager = new $281a441cdcb2cf36$var$RootStateManager(context2.state);
    }
    /**
   * Ensure that the state manager exists. This is called right before any
   * operation that requires access to the root state (e.g. `connect()`).
   * Throws an explicit error if the root state is still missing so that the
   * caller can react accordingly.
   */ _ensureStateManager() {
        var _a2, _b;
        if (!this._stateManager) {
            if (!((_a2 = this._context) == null ? void 0 : _a2.state)) throw new Error("[CollabService] Cannot operate without root state");
            this._stateManager = new $281a441cdcb2cf36$var$RootStateManager(this._context.state);
        }
        const root = (_b = this._stateManager) == null ? void 0 : _b.root;
        if (root && !root.__element) root.__element = {
            /**
         * Very small subset of the DOMQL `call` API that we rely on inside the
         * CollabService for browser notifications and data helpers.
         * In a Node.js test context we simply log or return fallbacks.
         */ call: (method, ...args2)=>{
                switch(method){
                    case "openNotification":
                        {
                            const [payload = {}] = args2;
                            const { type: type = "info", title: title = "", message: message = "" } = payload;
                            const logFn = type === "error" ? $281a441cdcb2cf36$var$logger.error : $281a441cdcb2cf36$var$logger.log;
                            logFn(`[Notification] ${title}${message ? ` \u2013 ${message}` : ""}`);
                            return;
                        }
                    case "deepStringifyFunctions":
                        return (0, $bmfNh.deepStringifyFunctions)(...args2);
                    default:
                        return {};
                }
            }
        };
    }
    /* ---------- Connection Management ---------- */ async connect(options = {}) {
        if (this._connectPromise) return this._connectPromise;
        this._connectPromise = (async ()=>{
            var _a2;
            this._connecting = true;
            this._connected = false;
            this._ensureStateManager();
            const mergedOptions = {
                ...this._context,
                ...options
            };
            let { authToken: jwt } = mergedOptions;
            const { projectId: projectId, branch: branch = "main", pro: pro } = mergedOptions;
            if (!jwt && this._tokenManager) {
                try {
                    jwt = await this._tokenManager.ensureValidToken();
                } catch (error) {
                    $281a441cdcb2cf36$var$logger.warn("[CollabService] Failed to obtain auth token from token manager", error);
                }
                if (!jwt && typeof this._tokenManager.getAccessToken === "function") jwt = this._tokenManager.getAccessToken();
            }
            if (!jwt) throw new Error("[CollabService] Cannot connect without auth token");
            this._context = {
                ...this._context,
                authToken: jwt,
                projectId: projectId,
                branch: branch,
                pro: pro
            };
            if (!projectId) {
                const state = (_a2 = this._stateManager) == null ? void 0 : _a2.root;
                const el = state.__element;
                el.call("openNotification", {
                    type: "error",
                    title: "projectId is required",
                    message: "projectId is required for CollabService connection"
                });
                throw new Error("projectId is required for CollabService connection");
            }
            if (this._client) await this.disconnect();
            this._client = new $281a441cdcb2cf36$var$CollabClient({
                jwt: jwt,
                projectId: projectId,
                branch: branch,
                live: Boolean(pro)
            });
            const { socket: socket } = this._client;
            try {
                await new Promise((resolve, reject)=>{
                    if (!socket) {
                        reject(new Error("[CollabService] Socket instance missing"));
                        return;
                    }
                    if (socket.connected) {
                        resolve();
                        return;
                    }
                    const cleanup = ()=>{
                        socket.off("connect", handleConnect);
                        socket.off("connect_error", handleError3);
                        socket.off("error", handleError3);
                        socket.off("disconnect", handleDisconnect);
                        if (this._pendingConnectReject === handleError3) this._pendingConnectReject = null;
                    };
                    const handleConnect = ()=>{
                        cleanup();
                        resolve();
                    };
                    const handleError3 = (error)=>{
                        cleanup();
                        reject(error instanceof Error ? error : new Error(String(error || "Unknown connection error")));
                    };
                    const handleDisconnect = (reason)=>{
                        handleError3(reason instanceof Error ? reason : new Error(`[CollabService] Socket disconnected before connect: ${reason || "unknown"}`));
                    };
                    this._pendingConnectReject = handleError3;
                    socket.once("connect", handleConnect);
                    socket.once("connect_error", handleError3);
                    socket.once("error", handleError3);
                    socket.once("disconnect", handleDisconnect);
                });
            } catch (error) {
                socket == null || socket.disconnect();
                this._client = null;
                this._connectionMeta = null;
                throw error;
            }
            this._attachSocketLifecycleListeners();
            if (socket == null ? void 0 : socket.connected) this._onSocketConnect();
            socket == null || socket.on("ops", ({ changes: changes })=>{
                $281a441cdcb2cf36$var$logger.log(`ops event`);
                this._stateManager.applyChanges(changes, {
                    fromSocket: true
                });
            });
            socket == null || socket.on("commit", ({ version: version6 })=>{
                if (version6) this._stateManager.setVersion(version6);
                $281a441cdcb2cf36$var$rootBus.emit("checkpoint:done", {
                    version: version6,
                    origin: "auto"
                });
            });
            socket == null || socket.on("clients", this._handleClientsEvent.bind(this));
            socket == null || socket.on("bundle:done", this._handleBundleDoneEvent.bind(this));
            socket == null || socket.on("bundle:error", this._handleBundleErrorEvent.bind(this));
            if (this._pendingOps.length) {
                $281a441cdcb2cf36$var$logger.log(`[CollabService] Flushing ${this._pendingOps.length} offline operation batch(es)`);
                this._pendingOps.forEach(({ changes: changes, granularChanges: granularChanges, orders: orders, options: opOptions })=>{
                    const { message: message } = opOptions || {};
                    const ts = Date.now();
                    const payload = {
                        changes: changes,
                        granularChanges: granularChanges,
                        orders: orders,
                        ts: ts
                    };
                    if (message) payload.message = message;
                    this.socket.emit("ops", payload);
                });
                this._pendingOps.length = 0;
            }
            await this._client.ready;
            this._connectionMeta = {
                projectId: projectId,
                branch: branch,
                live: Boolean(pro)
            };
            return this.getConnectionInfo();
        })();
        try {
            return await this._connectPromise;
        } finally{
            this._connecting = false;
            this._connectPromise = null;
        }
    }
    disconnect() {
        var _a2;
        if ((_a2 = this._client) == null ? void 0 : _a2.socket) {
            if (this._pendingConnectReject) {
                this._pendingConnectReject(new Error("[CollabService] Connection attempt aborted"));
                this._pendingConnectReject = null;
            }
            this._detachSocketLifecycleListeners();
            if (typeof this._client.dispose === "function") this._client.dispose();
            else this._client.socket.disconnect();
        }
        this._client = null;
        this._connected = false;
        this._connecting = false;
        this._connectionMeta = null;
        this._pendingConnectReject = null;
        $281a441cdcb2cf36$var$logger.log("[CollabService] Disconnected");
    }
    isConnected() {
        var _a2, _b;
        return Boolean(this._connected && ((_b = (_a2 = this._client) == null ? void 0 : _a2.socket) == null ? void 0 : _b.connected));
    }
    getConnectionInfo() {
        var _a2, _b, _c, _d, _e, _f;
        return {
            connected: this.isConnected(),
            connecting: this._connecting,
            projectId: (_b = (_a2 = this._connectionMeta) == null ? void 0 : _a2.projectId) != null ? _b : null,
            branch: (_d = (_c = this._connectionMeta) == null ? void 0 : _c.branch) != null ? _d : null,
            live: (_f = (_e = this._connectionMeta) == null ? void 0 : _e.live) != null ? _f : null,
            pendingOps: this._pendingOps.length,
            undoStackSize: this.getUndoStackSize(),
            redoStackSize: this.getRedoStackSize()
        };
    }
    /* convenient shortcuts */ get ydoc() {
        var _a2;
        return (_a2 = this._client) == null ? void 0 : _a2.ydoc;
    }
    get socket() {
        var _a2;
        return (_a2 = this._client) == null ? void 0 : _a2.socket;
    }
    toggleLive(f3) {
        var _a2;
        (_a2 = this._client) == null || _a2.toggleLive(f3);
    }
    sendCursor(d3) {
        var _a2;
        (_a2 = this._client) == null || _a2.sendCursor(d3);
    }
    sendPresence(d3) {
        var _a2;
        (_a2 = this._client) == null || _a2.sendPresence(d3);
    }
    /* ---------- data helpers ---------- */ updateData(tuples, options = {}) {
        var _a2, _b;
        this._ensureStateManager();
        const { isUndo: isUndo = false, isRedo: isRedo = false } = options;
        if (!isUndo && !isRedo && !this._isUndoRedo) this._trackForUndo(tuples, options);
        const root = (_a2 = this._stateManager) == null ? void 0 : _a2.root;
        const { granularChanges: processedTuples, orders: orders } = $281a441cdcb2cf36$var$preprocessChanges(root, tuples, options);
        if (options.append && options.append.length) processedTuples.push(...options.append);
        this._stateManager.applyChanges(tuples, {
            ...options
        });
        const stringifiedGranularTuples = $281a441cdcb2cf36$var$stringifyFunctionsForTransport(processedTuples);
        const stringifiedTuples = $281a441cdcb2cf36$var$stringifyFunctionsForTransport(tuples);
        const { message: message } = options;
        if (!this.isConnected()) {
            $281a441cdcb2cf36$var$logger.warn("[CollabService] Not connected, queuing real-time update");
            this._pendingOps.push({
                changes: stringifiedTuples,
                granularChanges: stringifiedGranularTuples,
                orders: orders,
                options: options
            });
            return;
        }
        if ((_b = this.socket) == null ? void 0 : _b.connected) {
            const ts = Date.now();
            const payload = {
                changes: stringifiedTuples,
                granularChanges: stringifiedGranularTuples,
                orders: orders,
                ts: ts
            };
            if (message) payload.message = message;
            this.socket.emit("ops", payload);
        }
        return {
            success: true
        };
    }
    _trackForUndo(tuples, options) {
        var _a2;
        const undoOperations = tuples.map((tuple)=>{
            const [action, path] = tuple;
            const currentValue = this._getValueAtPath(path);
            if (action === "delete") return [
                "update",
                path,
                currentValue
            ];
            if (typeof currentValue !== "undefined") return [
                "update",
                path,
                currentValue
            ];
            return [
                "delete",
                path
            ];
        });
        this._undoStack.push({
            operations: undoOperations,
            originalOperations: tuples,
            options: options,
            timestamp: Date.now()
        });
        this._redoStack.length = 0;
        const maxUndoSteps = ((_a2 = this._options) == null ? void 0 : _a2.maxUndoSteps) || 50;
        if (this._undoStack.length > maxUndoSteps) this._undoStack.shift();
    }
    _getValueAtPath(path) {
        var _a2;
        const state = (_a2 = this._stateManager) == null ? void 0 : _a2.root;
        if (!state || !state.getByPath) return null;
        try {
            return state.getByPath(path);
        } catch (error) {
            $281a441cdcb2cf36$var$logger.warn("[CollabService] Could not get value at path:", path, error);
            return null;
        }
    }
    undo() {
        var _a2;
        if (!this._undoStack.length) {
            const state = (_a2 = this._stateManager) == null ? void 0 : _a2.root;
            const el = state.__element;
            el.call("openNotification", {
                type: "error",
                title: "Nothing to undo"
            });
            throw new Error("Nothing to undo");
        }
        if (!this.isConnected()) {
            $281a441cdcb2cf36$var$logger.warn("[CollabService] Not connected, cannot undo");
            return;
        }
        const undoItem = this._undoStack.pop();
        const { operations: operations, originalOperations: originalOperations, options: options } = undoItem;
        this._redoStack.push({
            operations: originalOperations,
            originalOperations: operations,
            options: options,
            timestamp: Date.now()
        });
        this._isUndoRedo = true;
        try {
            this.updateData(operations, {
                ...options,
                isUndo: true,
                message: `Undo: ${options.message || "operation"}`
            });
        } finally{
            this._isUndoRedo = false;
        }
        return operations;
    }
    redo() {
        var _a2;
        if (!this._redoStack.length) {
            const state = (_a2 = this._stateManager) == null ? void 0 : _a2.root;
            const el = state.__element;
            el.call("openNotification", {
                type: "error",
                title: "Nothing to redo"
            });
            throw new Error("Nothing to redo");
        }
        if (!this.isConnected()) {
            $281a441cdcb2cf36$var$logger.warn("[CollabService] Not connected, cannot redo");
            return;
        }
        const redoItem = this._redoStack.pop();
        const { operations: operations, originalOperations: originalOperations, options: options } = redoItem;
        this._undoStack.push({
            operations: originalOperations,
            originalOperations: operations,
            options: options,
            timestamp: Date.now()
        });
        this._isUndoRedo = true;
        try {
            this.updateData(operations, {
                ...options,
                isRedo: true,
                message: `Redo: ${options.message || "operation"}`
            });
        } finally{
            this._isUndoRedo = false;
        }
        return operations;
    }
    /* ---------- Undo/Redo State ---------- */ canUndo() {
        return this._undoStack.length > 0;
    }
    canRedo() {
        return this._redoStack.length > 0;
    }
    getUndoStackSize() {
        return this._undoStack.length;
    }
    getRedoStackSize() {
        return this._redoStack.length;
    }
    clearUndoHistory() {
        this._undoStack.length = 0;
        this._redoStack.length = 0;
    }
    addItem(type, data2, opts = {}) {
        try {
            $281a441cdcb2cf36$var$validateParams.type(type);
            $281a441cdcb2cf36$var$validateParams.data(data2, type);
            const { value: value2, ...schema } = data2;
            const tuples = [
                [
                    "update",
                    [
                        type,
                        data2.key
                    ],
                    value2
                ],
                [
                    "update",
                    [
                        "schema",
                        type,
                        data2.key
                    ],
                    schema || {}
                ]
            ];
            const updatedOpts = {
                ...opts,
                skipComponentsChangedEvent: true
            };
            return this.updateData(tuples, updatedOpts);
        } catch (error) {
            throw new Error(`Failed to add item: ${error.message}`, {
                cause: error
            });
        }
    }
    addMultipleItems(items, opts = {}) {
        var _a2;
        const tuples = [];
        try {
            items.forEach(([type, data2])=>{
                $281a441cdcb2cf36$var$validateParams.type(type);
                $281a441cdcb2cf36$var$validateParams.data(data2, type);
                const { value: value2, ...schema } = data2;
                tuples.push([
                    "update",
                    [
                        type,
                        data2.key
                    ],
                    value2
                ], [
                    "update",
                    [
                        "schema",
                        type,
                        data2.key
                    ],
                    schema
                ]);
            });
            this.updateData([
                ...tuples,
                ...opts.append || []
            ], {
                message: `Created ${tuples.length} items`,
                ...opts
            });
            return tuples;
        } catch (error) {
            const state = (_a2 = this._stateManager) == null ? void 0 : _a2.root;
            const el = state.__element;
            el.call("openNotification", {
                type: "error",
                title: "Failed to add item",
                message: error.message
            });
            throw new Error(`Failed to add item: ${error.message}`, {
                cause: error
            });
        }
    }
    updateItem(type, data2, opts = {}) {
        var _a2;
        try {
            $281a441cdcb2cf36$var$validateParams.type(type);
            $281a441cdcb2cf36$var$validateParams.data(data2, type);
            const { value: value2, ...schema } = data2;
            const tuples = [
                [
                    "update",
                    [
                        type,
                        data2.key
                    ],
                    value2
                ],
                [
                    "update",
                    [
                        "schema",
                        type,
                        data2.key
                    ],
                    schema
                ]
            ];
            return this.updateData(tuples, opts);
        } catch (error) {
            const state = (_a2 = this._stateManager) == null ? void 0 : _a2.root;
            const el = state.__element;
            el.call("openNotification", {
                type: "error",
                title: "Failed to update item",
                message: error.message
            });
            throw new Error(`Failed to update item: ${error.message}`, {
                cause: error
            });
        }
    }
    deleteItem(type, key, opts = {}) {
        var _a2;
        try {
            $281a441cdcb2cf36$var$validateParams.type(type);
            $281a441cdcb2cf36$var$validateParams.key(key, type);
            const tuples = [
                [
                    "delete",
                    [
                        type,
                        key
                    ]
                ],
                [
                    "delete",
                    [
                        "schema",
                        type,
                        key
                    ]
                ],
                ...opts.append || []
            ];
            return this.updateData(tuples, {
                message: `Deleted ${key} from ${type}`,
                ...opts
            });
        } catch (error) {
            const state = (_a2 = this._stateManager) == null ? void 0 : _a2.root;
            const el = state.__element;
            el.call("openNotification", {
                type: "error",
                title: "Failed to delete item",
                message: error.message
            });
            throw new Error(`Failed to delete item: ${error.message}`, {
                cause: error
            });
        }
    }
    /* ---------- socket event helpers ---------- */ /**
   * Handle "clients" or "presence" events coming from the collab socket.
   * The backend sends the full `clients` object which we directly patch to
   * the root state, mimicking the legacy SocketService behaviour so that
   * existing UI components keep working unmodified.
   */ _handleClientsEvent(data2 = {}) {
        var _a2;
        const root = (_a2 = this._stateManager) == null ? void 0 : _a2.root;
        if (root && typeof root.replace === "function") root.clients = data2;
        $281a441cdcb2cf36$var$rootBus.emit("clients:updated", data2);
    }
    /* ---------- Dependency bundling events ---------- */ _handleBundleDoneEvent({ project: project, ticket: ticket, dependencies: dependencies = {}, schema: schema = {} } = {}) {
        var _a2;
        $281a441cdcb2cf36$var$logger.log("[CollabService] Bundle done", {
            project: project,
            ticket: ticket
        });
        try {
            this._ensureStateManager();
            const { dependencies: schemaDependencies = {} } = schema || {};
            const tuples = [
                [
                    "update",
                    [
                        "dependencies"
                    ],
                    dependencies
                ],
                [
                    "update",
                    [
                        "schema",
                        "dependencies"
                    ],
                    schemaDependencies
                ]
            ];
            this._stateManager.applyChanges(tuples, {
                fromSocket: true,
                preventFetchDeps: true,
                preventUpdate: [
                    "Iframe"
                ]
            });
        } catch (err) {
            $281a441cdcb2cf36$var$logger.error("[CollabService] Failed to update deps after bundle", err);
        }
        const root = (_a2 = this._stateManager) == null ? void 0 : _a2.root;
        const el = root == null ? void 0 : root.__element;
        if (el == null ? void 0 : el.call) el.call("openNotification", {
            type: "success",
            title: "Dependencies ready",
            message: `Project ${project} dependencies have been bundled successfully.`
        });
        $281a441cdcb2cf36$var$rootBus.emit("bundle:done", {
            project: project,
            ticket: ticket
        });
    }
    _handleBundleErrorEvent({ project: project, ticket: ticket, error: error } = {}) {
        var _a2;
        $281a441cdcb2cf36$var$logger.error("[CollabService] Bundle error", {
            project: project,
            ticket: ticket,
            error: error
        });
        const root = (_a2 = this._stateManager) == null ? void 0 : _a2.root;
        const el = root == null ? void 0 : root.__element;
        if (el == null ? void 0 : el.call) el.call("openNotification", {
            type: "error",
            title: "Dependency bundle failed",
            message: error || `An error occurred while bundling dependencies for project ${project}.`
        });
        $281a441cdcb2cf36$var$rootBus.emit("bundle:error", {
            project: project,
            ticket: ticket,
            error: error
        });
    }
    /* ---------- Manual checkpoint ---------- */ _attachSocketLifecycleListeners() {
        var _a2;
        const socket = (_a2 = this._client) == null ? void 0 : _a2.socket;
        if (!socket) return;
        socket.on("connect", this._onSocketConnect);
        socket.on("disconnect", this._onSocketDisconnect);
        socket.on("connect_error", this._onSocketError);
    }
    _detachSocketLifecycleListeners() {
        var _a2;
        const socket = (_a2 = this._client) == null ? void 0 : _a2.socket;
        if (!socket) return;
        socket.off("connect", this._onSocketConnect);
        socket.off("disconnect", this._onSocketDisconnect);
        socket.off("connect_error", this._onSocketError);
    }
    _onSocketConnect() {
        this._connected = true;
    }
    _onSocketDisconnect(reason) {
        this._connected = false;
        if (reason && reason !== "io client disconnect") $281a441cdcb2cf36$var$logger.warn("[CollabService] Socket disconnected", reason);
    }
    _onSocketError(error) {
        $281a441cdcb2cf36$var$logger.warn("[CollabService] Socket connection error", error);
    }
    /**
   * Manually request a checkpoint / commit of buffered operations on the server.
   * Resolves with the new version number once the backend confirms via the
   * regular "commit" event.
   */ checkpoint() {
        if (!this.isConnected()) {
            $281a441cdcb2cf36$var$logger.warn("[CollabService] Not connected, cannot request checkpoint");
            return Promise.reject(new Error("Not connected"));
        }
        return new Promise((resolve)=>{
            var _a2, _b;
            const handler = ({ version: version6 })=>{
                var _a3;
                (_a3 = this.socket) == null || _a3.off("commit", handler);
                $281a441cdcb2cf36$var$rootBus.emit("checkpoint:done", {
                    version: version6,
                    origin: "manual"
                });
                resolve(version6);
            };
            (_a2 = this.socket) == null || _a2.once("commit", handler);
            (_b = this.socket) == null || _b.emit("checkpoint");
        });
    }
};
// src/constants/roles.js
var $281a441cdcb2cf36$var$WORKSPACE_MEMBER_ROLES = [
    "owner",
    "admin",
    "editor",
    "viewer",
    "guest"
];
var $281a441cdcb2cf36$var$TEAM_GRANT_ROLES = [
    "admin",
    "editor",
    "guest",
    "viewer"
];
var $281a441cdcb2cf36$var$PROJECT_SOURCE_ACCESS = [
    "public",
    "org",
    "workspace",
    "restricted"
];
// src/utils/projectKeyPath.js
function $281a441cdcb2cf36$var$projectKeyPath(input) {
    if (input && typeof input === "object") {
        const { owner: owner, key: key } = input;
        if (!key) throw new Error("Project key is required");
        if (owner) return `${encodeURIComponent(owner)}/${encodeURIComponent(key)}`;
        return encodeURIComponent(key);
    }
    if (!input) throw new Error("Project key is required");
    return encodeURIComponent(String(input));
}
// src/services/ProjectService.js
var $281a441cdcb2cf36$var$ProjectService = class extends $281a441cdcb2cf36$var$BaseService {
    // ==================== PROJECT METHODS ====================
    /**
   * Create a user-owned project (owner = authenticated user).
   *
   * For org-owned projects use `organizationService.createOrgProject(orgId, data)`
   * which hits `POST /organizations/:orgId/projects` and scopes ownership
   * to the org.
   *
   * `projectData.key` / `projectData.slug` is optional — server mints a
   * bare slug via allocateUniqueProjectKey when omitted. Accepted shapes:
   *   - bare slug (canonical): `{ name, projectType, slug: 'my-app' }`
   *   - legacy compound: `{ name, slug: 'owner--my-app' }` — server strips
   *     the owner segment via parseOwnerProjectKey
   *   - legacy suffix: `{ name, slug: 'my-app.symbo.ls' }` — stripped
   *
   * Post-§45 identity is `(ownerOrganization|ownerUser FK, key)`; two
   * different owners can legitimately reuse the same bare slug.
   *
   * @param {object} projectData - { name, projectType, slug?, workspaceId?, ...content }
   */ async createProject(projectData) {
        this._requireReady("createProject");
        try {
            const response = await this._request("/projects", {
                method: "POST",
                body: JSON.stringify(projectData),
                methodName: "createProject"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to create project: ${error.message}`, {
                cause: error
            });
        }
    }
    async getProjects(params2 = {}) {
        this._requireReady("getProjects");
        try {
            const queryParams = new URLSearchParams();
            Object.keys(params2).forEach((key)=>{
                if (params2[key] != null) queryParams.append(key, params2[key]);
            });
            const queryString = queryParams.toString();
            const response = queryString ? await this._request(`/projects?${queryString}`, {
                method: "GET",
                methodName: "getProjects"
            }) : await this._request("/projects", {
                method: "GET",
                methodName: "getProjects"
            });
            if (response.success) return response;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to get projects: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Alias for getProjects for consistency with API naming
   */ async listProjects(params2 = {}) {
        return await this.getProjects(params2);
    }
    /**
   * List only public projects (no authentication required)
   */ async listPublicProjects(params2 = {}) {
        try {
            const queryParams = new URLSearchParams();
            Object.keys(params2).forEach((key)=>{
                if (params2[key] != null) queryParams.append(key, params2[key]);
            });
            const queryString = queryParams.toString();
            const response = queryString ? await this._request(`/projects/public?${queryString}`, {
                method: "GET",
                methodName: "listPublicProjects"
            }) : await this._request("/projects/public", {
                method: "GET",
                methodName: "listPublicProjects"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to list public projects: ${error.message}`, {
                cause: error
            });
        }
    }
    async getProject(projectId) {
        this._requireReady("getProject");
        if (!projectId) throw new Error("Project ID is required");
        try {
            const response = await this._request(`/projects/${projectId}`, {
                method: "GET",
                methodName: "getProject"
            });
            if (response.success) {
                const iconSrc = response.data.icon ? `${this._apiUrl}/core/files/public/${response.data.icon.id}/download` : null;
                return {
                    ...response.data,
                    icon: {
                        src: iconSrc,
                        ...response.data.icon
                    }
                };
            }
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to get project: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Get a public project by ID (no authentication required)
   * Corresponds to router.get('/public/:projectId', ProjectController.getPublicProject)
   */ async getPublicProject(projectId) {
        if (!projectId) throw new Error("Project ID is required");
        try {
            const response = await this._request(`/projects/public/${projectId}`, {
                method: "GET",
                methodName: "getPublicProject"
            });
            if (response.success) {
                const iconSrc = response.data.icon ? `${this._apiUrl}/core/files/public/${response.data.icon.id}/download` : null;
                return {
                    ...response.data,
                    icon: {
                        src: iconSrc,
                        ...response.data.icon
                    }
                };
            }
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to get public project: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Look up a project by its key. Pass `{owner, key}` to use the
   * collision-safe 2-seg route when the owner is known.
   *
   * @param {string | { owner?: string, key: string }} keyOrSpec
   */ async getProjectByKey(keyOrSpec) {
        this._requireReady("getProjectByKey");
        const path = $281a441cdcb2cf36$var$projectKeyPath(keyOrSpec);
        try {
            const response = await this._request(`/projects/key/${path}`, {
                method: "GET",
                methodName: "getProjectByKey"
            });
            if (response.success) {
                const iconSrc = response.data.icon ? `${this._apiUrl}/core/files/public/${response.data.icon.id}/download` : null;
                return {
                    ...response.data,
                    icon: {
                        src: iconSrc,
                        ...response.data.icon
                    }
                };
            }
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to get project by key: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Get current project data by key (no project ID required). Pass
   * `{owner, key}` to use the collision-safe 2-seg route when owner is
   * known.
   *
   * @param {string | { owner?: string, key: string }} keyOrSpec
   * @param {object} [options]
   */ async getProjectDataByKey(keyOrSpec, options = {}) {
        this._requireReady("getProjectDataByKey");
        const path = $281a441cdcb2cf36$var$projectKeyPath(keyOrSpec);
        const { branch: branch = "main", version: version6 = "latest", includeHistory: includeHistory = false, headers: headers } = options;
        const queryParams = new URLSearchParams({
            branch: branch,
            version: version6,
            includeHistory: includeHistory.toString()
        }).toString();
        try {
            const response = await this._request(`/projects/key/${path}/data?${queryParams}`, {
                method: "GET",
                methodName: "getProjectDataByKey",
                ...headers ? {
                    headers: headers
                } : {}
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to get project data by key: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Anonymous read of a public project's current data for a given env.
   * Server-side gated on `project.visibility === 'public'`. Returns null on
   * 403/404 so callers can fall back to the authed route. Pass `{owner, key}`
   * to use the collision-safe 2-seg route.
   *
   * @param {string | { owner?: string, key: string }} keyOrSpec
   * @param {{ envKey: string }} opts
   */ async getPublicProjectDataByKey(keyOrSpec, { envKey: envKey } = {}) {
        var _a2;
        if (!envKey) throw new Error("Environment key is required");
        const path = $281a441cdcb2cf36$var$projectKeyPath(keyOrSpec);
        try {
            const response = await this._request(`/projects/key/${path}/public/${encodeURIComponent(envKey)}/data`, {
                method: "GET",
                methodName: "getPublicProjectDataByKey"
            });
            if (response == null ? void 0 : response.success) return response.data;
            return null;
        } catch (error) {
            const status = ((_a2 = error == null ? void 0 : error.cause) == null ? void 0 : _a2.status) || (error == null ? void 0 : error.status);
            if (status === 403 || status === 404) return null;
            throw new Error(`Failed to get public project data by key: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Resolve a domain / hostname / appkey to `{owner, key}`. Used by mermaid
   * edge + any client that needs the canonical `(owner, key)` pair from a
   * raw hostname (e.g. `silverbreeze.silverbreeze-labs.symbo.ls`).
   *
   * @param {string} appkey - hostname, custom domain, or bare key
   * @returns {Promise<{ owner: string | null, key: string }>}
   */ async resolveAppkey(appkey) {
        if (!appkey) throw new Error("appkey is required");
        const response = await this._request(`/projects/resolve/${encodeURIComponent(appkey)}`, {
            method: "GET",
            methodName: "resolveAppkey"
        });
        if ((response == null ? void 0 : response.owner) !== void 0 || (response == null ? void 0 : response.key) !== void 0) return response;
        if ((response == null ? void 0 : response.success) && response.data) return response.data;
        throw new Error((response == null ? void 0 : response.message) || "Failed to resolve appkey");
    }
    async updateProject(projectId, data2) {
        this._requireReady("updateProject");
        if (!projectId) throw new Error("Project ID is required");
        try {
            const response = await this._request(`/projects/${projectId}`, {
                method: "PATCH",
                body: JSON.stringify(data2),
                methodName: "updateProject"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to update project: ${error.message}`, {
                cause: error
            });
        }
    }
    async updateProjectComponents(projectId, components) {
        this._requireReady("updateProjectComponents");
        if (!projectId) throw new Error("Project ID is required");
        try {
            const response = await this._request(`/projects/${projectId}/components`, {
                method: "PATCH",
                body: JSON.stringify({
                    components: components
                }),
                methodName: "updateProjectComponents"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to update project components: ${error.message}`, {
                cause: error
            });
        }
    }
    async updateProjectSettings(projectId, settings) {
        this._requireReady("updateProjectSettings");
        if (!projectId) throw new Error("Project ID is required");
        try {
            const response = await this._request(`/projects/${projectId}/settings`, {
                method: "PATCH",
                body: JSON.stringify({
                    settings: settings
                }),
                methodName: "updateProjectSettings"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to update project settings: ${error.message}`, {
                cause: error
            });
        }
    }
    async updateProjectName(projectId, name) {
        this._requireReady("updateProjectName");
        if (!projectId) throw new Error("Project ID is required");
        try {
            const response = await this._request(`/projects/${projectId}`, {
                method: "PATCH",
                body: JSON.stringify({
                    name: name
                }),
                methodName: "updateProjectName"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to update project name: ${error.message}`, {
                cause: error
            });
        }
    }
    // Single axis controlling both source read scope AND library consumption scope.
    // Replaces setProjectAccess / setProjectVisibility.
    async setProjectSourceAccess(projectId, sourceAccess) {
        if (!projectId) throw new Error("Project ID is required");
        if (!sourceAccess) throw new Error("sourceAccess is required");
        if (!$281a441cdcb2cf36$var$PROJECT_SOURCE_ACCESS.includes(sourceAccess)) throw new Error(`Invalid sourceAccess: ${sourceAccess}. Must be one of: ${$281a441cdcb2cf36$var$PROJECT_SOURCE_ACCESS.join(", ")}`);
        return this._call("setProjectSourceAccess", `/projects/${projectId}`, {
            method: "PATCH",
            body: {
                sourceAccess: sourceAccess
            }
        });
    }
    /** @deprecated Use setProjectSourceAccess. Removed when server drops Project.access (Phase 3). */ async setProjectAccess(projectId, access) {
        this._requireReady("setProjectAccess");
        if (!projectId) throw new Error("Project ID is required");
        if (!access) throw new Error("Access level is required");
        const allowedAccessValues = [
            "account",
            "team",
            "organization",
            "public"
        ];
        if (!allowedAccessValues.includes(access)) throw new Error(`Invalid access value: ${access}. Must be one of: ${allowedAccessValues.join(", ")}`);
        try {
            const response = await this._request(`/projects/${projectId}`, {
                method: "PATCH",
                body: JSON.stringify({
                    access: access
                }),
                methodName: "setProjectAccess"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to set project access: ${error.message}`, {
                cause: error
            });
        }
    }
    /** @deprecated visibility moved to per-env (MODEL.md §Project). Kept for compatibility until Phase 3 removes it server-side. */ async setProjectVisibility(projectId, visibility) {
        this._requireReady("setProjectVisibility");
        if (!projectId) throw new Error("Project ID is required");
        if (!visibility) throw new Error("Visibility is required");
        const allowedVisibilityValues = [
            "public",
            "private",
            "password-protected"
        ];
        if (!allowedVisibilityValues.includes(visibility)) throw new Error(`Invalid visibility value: ${visibility}. Must be one of: ${allowedVisibilityValues.join(", ")}`);
        try {
            const response = await this._request(`/projects/${projectId}`, {
                method: "PATCH",
                body: JSON.stringify({
                    visibility: visibility
                }),
                methodName: "setProjectVisibility"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to set project visibility: ${error.message}`, {
                cause: error
            });
        }
    }
    async updateProjectPackage(projectId, pkg) {
        this._requireReady("updateProjectPackage");
        if (!projectId) throw new Error("Project ID is required");
        try {
            const response = await this._request(`/projects/${projectId}/package`, {
                method: "PATCH",
                body: JSON.stringify({
                    package: pkg
                }),
                methodName: "updateProjectPackage"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to update project package: ${error.message}`, {
                cause: error
            });
        }
    }
    async duplicateProject(projectId, newName, newKey, targetUserId) {
        this._requireReady("duplicateProject");
        if (!projectId) throw new Error("Project ID is required");
        try {
            const response = await this._request(`/projects/${projectId}/duplicate`, {
                method: "POST",
                body: JSON.stringify({
                    name: newName,
                    key: newKey,
                    targetUserId: targetUserId
                }),
                methodName: "duplicateProject"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to duplicate project: ${error.message}`, {
                cause: error
            });
        }
    }
    async removeProject(projectId) {
        this._requireReady("removeProject");
        if (!projectId) throw new Error("Project ID is required");
        try {
            const response = await this._request(`/projects/${projectId}`, {
                method: "DELETE",
                methodName: "removeProject"
            });
            if (response.success) return response;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to remove project: ${error.message}`, {
                cause: error
            });
        }
    }
    async transferProjectOwnership(projectId, { targetType: targetType, userId: userId, organizationId: organizationId }) {
        this._requireReady("transferProjectOwnership");
        if (!projectId) throw new Error("Project ID is required");
        if (!targetType) throw new Error("targetType is required (user or organization)");
        const response = await this._request(`/projects/${projectId}/transfer-ownership`, {
            method: "POST",
            body: JSON.stringify({
                targetType: targetType,
                userId: userId,
                organizationId: organizationId
            }),
            methodName: "transferProjectOwnership"
        });
        if (response.success) return response.data;
        throw new Error(response.message);
    }
    async transferProjectToWorkspace(projectId, targetWorkspaceId) {
        this._requireReady("transferProjectToWorkspace");
        if (!projectId) throw new Error("Project ID is required");
        if (!targetWorkspaceId) throw new Error("targetWorkspaceId is required");
        const response = await this._request(`/projects/${projectId}/transfer-workspace`, {
            method: "POST",
            body: JSON.stringify({
                targetWorkspaceId: targetWorkspaceId
            }),
            methodName: "transferProjectToWorkspace"
        });
        if (response.success) return response.data;
        throw new Error(response.message);
    }
    async checkProjectKeyAvailability(key) {
        this._requireReady("checkProjectKeyAvailability");
        if (!key) throw new Error("Project key is required");
        try {
            const response = await this._request(`/projects/check-key/${key}`, {
                method: "GET",
                methodName: "checkProjectKeyAvailability"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to check project key availability: ${error.message}`, {
                cause: error
            });
        }
    }
    // ==================== PROJECT PERMISSION CONFIG METHODS ====================
    /**
   * Fetch effective role → permissions configuration for a project.
   * Mirrors ProjectController.getProjectRolePermissionsConfig.
   */ async getProjectRolePermissionsConfig(projectId, options = {}) {
        this._requireReady("getProjectRolePermissionsConfig");
        if (!projectId) throw new Error("Project ID is required");
        const { headers: headers } = options;
        try {
            const response = await this._request(`/projects/${projectId}/permissions`, {
                method: "GET",
                ...headers ? {
                    headers: headers
                } : {},
                methodName: "getProjectRolePermissionsConfig"
            });
            if (response && response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to get project role permissions config: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Update project-level role → permissions overrides.
   * Mirrors ProjectController.updateProjectRolePermissionsConfig.
   */ async updateProjectRolePermissionsConfig(projectId, rolePermissions, options = {}) {
        this._requireReady("updateProjectRolePermissionsConfig");
        if (!projectId) throw new Error("Project ID is required");
        if (!rolePermissions || typeof rolePermissions !== "object") throw new Error("rolePermissions object is required");
        const { headers: headers } = options;
        try {
            const response = await this._request(`/projects/${projectId}/permissions`, {
                method: "PATCH",
                body: JSON.stringify({
                    rolePermissions: rolePermissions
                }),
                ...headers ? {
                    headers: headers
                } : {},
                methodName: "updateProjectRolePermissionsConfig"
            });
            if (response && response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to update project role permissions config: ${error.message}`, {
                cause: error
            });
        }
    }
    // ==================== PROJECT MEMBER METHODS ====================
    async getProjectMembers(projectId) {
        this._requireReady("getProjectMembers");
        if (!projectId) throw new Error("Project ID is required");
        try {
            const response = await this._request(`/projects/${projectId}/members`, {
                method: "GET",
                methodName: "getProjectMembers"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to get project members: ${error.message}`, {
                cause: error
            });
        }
    }
    async inviteMember(projectId, email, role = "guest", options = {}) {
        this._requireReady("inviteMember");
        if (!projectId || !email || !role) throw new Error("Project ID, email, and role are required");
        const { name: name, callbackUrl: callbackUrl, headers: headers } = options;
        const defaultCallbackUrl = typeof window === "undefined" ? "https://app.symbols.com/accept-invite" : `${window.location.origin}/accept-invite`;
        try {
            const requestBody = {
                email: email,
                role: role,
                callbackUrl: callbackUrl || defaultCallbackUrl
            };
            if (name) requestBody.name = name;
            const response = await this._request(`/projects/${projectId}/invite`, {
                method: "POST",
                body: JSON.stringify(requestBody),
                ...headers ? {
                    headers: headers
                } : {},
                methodName: "inviteMember"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to invite member: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Create a magic invite link for a project.
   * The backend returns a token and URL that can be shared directly.
   */ async createMagicInviteLink(projectId, options = {}) {
        this._requireReady("createMagicInviteLink");
        if (!projectId) throw new Error("Project ID is required");
        const { headers: headers } = options;
        try {
            const response = await this._request(`/projects/${projectId}/invite-link`, {
                method: "POST",
                ...headers ? {
                    headers: headers
                } : {},
                methodName: "createMagicInviteLink"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to create magic invite link: ${error.message}`, {
                cause: error
            });
        }
    }
    async acceptInvite(token) {
        this._requireReady("acceptInvite");
        if (!token) throw new Error("Invitation token is required");
        try {
            const response = await this._request("/projects/accept-invite", {
                method: "POST",
                body: JSON.stringify({
                    token: token
                }),
                methodName: "acceptInvite"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to accept invite: ${error.message}`, {
                cause: error
            });
        }
    }
    async updateMemberRole(projectId, memberId, role) {
        this._requireReady("updateMemberRole");
        if (!projectId || !memberId || !role) throw new Error("Project ID, member ID, and role are required");
        try {
            const response = await this._request(`/projects/${projectId}/members/${memberId}`, {
                method: "PATCH",
                body: JSON.stringify({
                    role: role
                }),
                methodName: "updateMemberRole"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to update member role: ${error.message}`, {
                cause: error
            });
        }
    }
    async removeMember(projectId, memberId) {
        this._requireReady("removeMember");
        if (!projectId || !memberId) throw new Error("Project ID and member ID are required");
        try {
            const response = await this._request(`/projects/${projectId}/members/${memberId}`, {
                method: "DELETE",
                methodName: "removeMember"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to remove member: ${error.message}`, {
                cause: error
            });
        }
    }
    // ==================== PROJECT LIBRARY METHODS ====================
    async getAvailableLibraries(params2 = {}) {
        this._requireReady("getAvailableLibraries");
        const queryParams = new URLSearchParams(params2).toString();
        try {
            const response = await this._request(`/projects/libraries/available?${queryParams}`, {
                method: "GET",
                methodName: "getAvailableLibraries"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to get available libraries: ${error.message}`, {
                cause: error
            });
        }
    }
    async getProjectLibraries(projectId) {
        this._requireReady("getProjectLibraries");
        if (!projectId) throw new Error("Project ID is required");
        try {
            const response = await this._request(`/projects/${projectId}/libraries`, {
                method: "GET",
                methodName: "getProjectLibraries"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to get project libraries: ${error.message}`, {
                cause: error
            });
        }
    }
    async addProjectLibraries(projectId, libraryIds) {
        this._requireReady("addProjectLibraries");
        if (!projectId || !libraryIds) throw new Error("Project ID and library IDs are required");
        try {
            const response = await this._request(`/projects/${projectId}/libraries`, {
                method: "POST",
                body: JSON.stringify({
                    libraryIds: libraryIds
                }),
                methodName: "addProjectLibraries"
            });
            if (response.success) return response;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to add project libraries: ${error.message}`, {
                cause: error
            });
        }
    }
    async removeProjectLibraries(projectId, libraryIds) {
        this._requireReady("removeProjectLibraries");
        if (!projectId || !libraryIds) throw new Error("Project ID and library IDs are required");
        try {
            const response = await this._request(`/projects/${projectId}/libraries`, {
                method: "DELETE",
                body: JSON.stringify({
                    libraryIds: libraryIds
                }),
                methodName: "removeProjectLibraries"
            });
            if (response.success) return response;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to remove project libraries: ${error.message}`, {
                cause: error
            });
        }
    }
    // ==================== PROJECT DATA METHODS (SYMSTORY REPLACEMENT) ====================
    /**
   * Apply changes to a project, creating a new version
   * Replaces: SymstoryService.updateData()
   */ async applyProjectChanges(projectId, changes, options = {}) {
        this._requireReady("applyProjectChanges");
        if (!projectId) throw new Error("Project ID is required");
        if (!Array.isArray(changes)) throw new Error("Changes must be an array");
        const { message: message, branch: branch = "main", type: type = "patch", headers: headers } = options;
        const state = this._context && this._context.state;
        const { granularChanges: granularChanges, orders: preprocessorOrders } = $281a441cdcb2cf36$var$preprocessChanges(state, changes, options);
        const derivedOrders = options.orders || (preprocessorOrders && preprocessorOrders.length ? preprocessorOrders : state ? $281a441cdcb2cf36$var$computeOrdersForTuples(state, granularChanges) : []);
        const stringify = (val)=>(0, $bmfNh.deepStringifyFunctions)(val, Array.isArray(val) ? [] : {});
        try {
            const response = await this._request(`/projects/${projectId}/changes`, {
                method: "POST",
                body: JSON.stringify({
                    changes: stringify(changes),
                    granularChanges: stringify(granularChanges),
                    message: message,
                    branch: branch,
                    type: type,
                    ...derivedOrders && derivedOrders.length ? {
                        orders: derivedOrders
                    } : {}
                }),
                ...headers ? {
                    headers: headers
                } : {},
                methodName: "applyProjectChanges"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to apply project changes: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Get current project data for a specific branch
   * Replaces: SymstoryService.getData()
   */ async getProjectData(projectId, options = {}) {
        this._requireReady("getProjectData");
        if (!projectId) throw new Error("Project ID is required");
        const { branch: branch = "main", version: version6 = "latest", includeHistory: includeHistory = false, headers: headers } = options;
        const queryParams = new URLSearchParams({
            branch: branch,
            version: version6,
            includeHistory: includeHistory.toString()
        }).toString();
        try {
            const response = await this._request(`/projects/${projectId}/data?${queryParams}`, {
                method: "GET",
                methodName: "getProjectData",
                ...headers ? {
                    headers: headers
                } : {}
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to get project data: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Get project versions with pagination
   */ async getProjectVersions(projectId, options = {}) {
        this._requireReady("getProjectVersions");
        if (!projectId) throw new Error("Project ID is required");
        const { branch: branch = "main", page: page = 1, limit: limit = 50, headers: headers } = options;
        const queryParams = new URLSearchParams({
            branch: branch,
            page: page.toString(),
            limit: limit.toString()
        }).toString();
        try {
            const response = await this._request(`/projects/${projectId}/versions?${queryParams}`, {
                method: "GET",
                methodName: "getProjectVersions",
                ...headers ? {
                    headers: headers
                } : {}
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to get project versions: ${error.message}`, {
                cause: error
            });
        }
    }
    // ==================== PROJECT ENVIRONMENT METHODS ====================
    /**
   * List all environments for a project along with plan limits and activation state.
   * Mirrors ProjectController.listEnvironments.
   */ async listEnvironments(projectId, options = {}) {
        this._requireReady("listEnvironments");
        if (!projectId) throw new Error("Project ID is required");
        const { headers: headers } = options;
        try {
            const response = await this._request(`/projects/${projectId}/environments`, {
                method: "GET",
                ...headers ? {
                    headers: headers
                } : {},
                methodName: "listEnvironments"
            });
            if (response && response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to list environments: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Create or update (upsert) an environment config for a project.
   * Mirrors ProjectController.upsertEnvironment.
   */ async upsertEnvironment(projectId, envKey, config, options = {}) {
        this._requireReady("upsertEnvironment");
        if (!projectId) throw new Error("Project ID is required");
        if (!envKey) throw new Error("Environment key is required");
        if (!config || typeof config !== "object") throw new Error("Environment config object is required");
        const { headers: headers } = options;
        try {
            const response = await this._request(`/projects/${projectId}/environments`, {
                method: "POST",
                body: JSON.stringify({
                    envKey: envKey,
                    config: config
                }),
                ...headers ? {
                    headers: headers
                } : {},
                methodName: "upsertEnvironment"
            });
            if (response && response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to upsert environment: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Update an existing environment config.
   * Mirrors ProjectController.updateEnvironment.
   */ async updateEnvironment(projectId, envKey, updates, options = {}) {
        this._requireReady("updateEnvironment");
        if (!projectId) throw new Error("Project ID is required");
        if (!envKey) throw new Error("Environment key is required");
        if (!updates || typeof updates !== "object") throw new Error("Environment updates object is required");
        const { headers: headers } = options;
        try {
            const response = await this._request(`/projects/${projectId}/environments/${encodeURIComponent(envKey)}`, {
                method: "PATCH",
                body: JSON.stringify(updates),
                ...headers ? {
                    headers: headers
                } : {},
                methodName: "updateEnvironment"
            });
            if (response && response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to update environment: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Publish a project to a specific environment (set its effective mode/version/branch).
   * Mirrors ProjectController.publishToEnvironment.
   */ async publishToEnvironment(projectId, envKey, payload, options = {}) {
        this._requireReady("publishToEnvironment");
        if (!projectId) throw new Error("Project ID is required");
        if (!envKey) throw new Error("Environment key is required");
        if (!payload || typeof payload !== "object") throw new Error("Publish payload is required");
        const { headers: headers } = options;
        try {
            const response = await this._request(`/projects/${projectId}/environments/${encodeURIComponent(envKey)}/publish`, {
                method: "POST",
                body: JSON.stringify(payload),
                ...headers ? {
                    headers: headers
                } : {},
                methodName: "publishToEnvironment"
            });
            if (response && response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to publish to environment: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Delete an environment from a project.
   * Mirrors ProjectController.deleteEnvironment.
   */ async deleteEnvironment(projectId, envKey, options = {}) {
        this._requireReady("deleteEnvironment");
        if (!projectId) throw new Error("Project ID is required");
        if (!envKey) throw new Error("Environment key is required");
        const { headers: headers } = options;
        try {
            const response = await this._request(`/projects/${projectId}/environments/${encodeURIComponent(envKey)}`, {
                method: "DELETE",
                ...headers ? {
                    headers: headers
                } : {},
                methodName: "deleteEnvironment"
            });
            if (response && response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to delete environment: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Promote content between environments (simple pipeline).
   * Mirrors ProjectController.promoteEnvironment.
   */ async promoteEnvironment(projectId, fromEnvKey, toEnvKey, options = {}) {
        this._requireReady("promoteEnvironment");
        if (!projectId) throw new Error("Project ID is required");
        if (!fromEnvKey || !toEnvKey) throw new Error("Both fromEnvKey and toEnvKey are required");
        if (fromEnvKey === toEnvKey) throw new Error("fromEnvKey and toEnvKey must be different");
        const { headers: headers } = options;
        try {
            const response = await this._request(`/projects/${projectId}/pipeline/promote`, {
                method: "POST",
                body: JSON.stringify({
                    from: fromEnvKey,
                    to: toEnvKey
                }),
                ...headers ? {
                    headers: headers
                } : {},
                methodName: "promoteEnvironment"
            });
            if (response && response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to promote environment: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Restore project to a previous version
   * Replaces: SymstoryService.restoreVersion()
   */ async restoreProjectVersion(projectId, version6, options = {}) {
        this._requireReady("restoreProjectVersion");
        if (!projectId) throw new Error("Project ID is required");
        if (!version6) throw new Error("Version is required");
        const { message: message, branch: branch = "main", type: type = "patch", headers: headers } = options;
        try {
            const response = await this._request(`/projects/${projectId}/restore`, {
                method: "POST",
                body: JSON.stringify({
                    version: version6,
                    message: message,
                    branch: branch,
                    type: type
                }),
                ...headers ? {
                    headers: headers
                } : {},
                methodName: "restoreProjectVersion"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to restore project version: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Helper method to update a single item in the project
   * Convenience wrapper around applyProjectChanges
   */ async updateProjectItem(projectId, path, value2, options = {}) {
        const changes = [
            [
                "update",
                path,
                value2
            ]
        ];
        const message = options.message || `Updated ${Array.isArray(path) ? path.join(".") : path}`;
        return await this.applyProjectChanges(projectId, changes, {
            ...options,
            message: message
        });
    }
    /**
   * Helper method to delete an item from the project
   * Convenience wrapper around applyProjectChanges
   */ async deleteProjectItem(projectId, path, options = {}) {
        const changes = [
            [
                "delete",
                path
            ]
        ];
        const message = options.message || `Deleted ${Array.isArray(path) ? path.join(".") : path}`;
        return await this.applyProjectChanges(projectId, changes, {
            ...options,
            message: message
        });
    }
    /**
   * Helper method to set a value in the project (alias for update)
   * Convenience wrapper around applyProjectChanges
   */ async setProjectValue(projectId, path, value2, options = {}) {
        const changes = [
            [
                "set",
                path,
                value2
            ]
        ];
        const message = options.message || `Set ${Array.isArray(path) ? path.join(".") : path}`;
        return await this.applyProjectChanges(projectId, changes, {
            ...options,
            message: message
        });
    }
    /**
   * Helper method to add multiple items to the project
   * Convenience wrapper around applyProjectChanges
   */ async addProjectItems(projectId, items, options = {}) {
        const changes = items.map((item)=>{
            const [type, data2] = item;
            const { value: value2, ...schema } = data2;
            return [
                [
                    "update",
                    [
                        type,
                        data2.key
                    ],
                    value2
                ],
                [
                    "update",
                    [
                        "schema",
                        type,
                        data2.key
                    ],
                    schema
                ]
            ];
        }).flat();
        const message = options.message || `Added ${items.length} items`;
        return await this.applyProjectChanges(projectId, changes, {
            ...options,
            message: message
        });
    }
    /**
   * Helper method to get specific data from project by path
   * Convenience wrapper that gets project data and extracts specific path
   */ async getProjectItemByPath(projectId, path, options = {}) {
        const projectData = await this.getProjectData(projectId, options);
        if (!(projectData == null ? void 0 : projectData.data)) return null;
        let current2 = projectData.data;
        const pathArray = Array.isArray(path) ? path : [
            path
        ];
        for (const segment of pathArray){
            if (current2 && typeof current2 === "object" && segment in current2) current2 = current2[segment];
            else return null;
        }
        return current2;
    }
    // ==================== FAVORITE PROJECT METHODS ====================
    async getFavoriteProjects() {
        this._requireReady("getFavoriteProjects");
        try {
            const response = await this._request("/users/favorites", {
                method: "GET",
                methodName: "getFavoriteProjects"
            });
            if (response.success) return (response.data || []).map((project)=>({
                    isFavorite: true,
                    ...project,
                    ...project.icon && {
                        icon: {
                            src: `${this._apiUrl}/core/files/public/${project.icon.id}/download`,
                            ...project.icon
                        }
                    }
                }));
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to get favorite projects: ${error.message}`, {
                cause: error
            });
        }
    }
    async addFavoriteProject(projectId) {
        this._requireReady("addFavoriteProject");
        if (!projectId) throw new Error("Project ID is required");
        try {
            const response = await this._request(`/users/favorites/${projectId}`, {
                method: "POST",
                methodName: "addFavoriteProject"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to add favorite project: ${error.message}`, {
                cause: error
            });
        }
    }
    async removeFavoriteProject(projectId) {
        this._requireReady("removeFavoriteProject");
        if (!projectId) throw new Error("Project ID is required");
        try {
            const response = await this._request(`/users/favorites/${projectId}`, {
                method: "DELETE",
                methodName: "removeFavoriteProject"
            });
            if (response.success) return response.message || "Project removed from favorites";
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to remove favorite project: ${error.message}`, {
                cause: error
            });
        }
    }
    // ==================== RECENT PROJECT METHODS ====================
    async getRecentProjects(options = {}) {
        this._requireReady("getRecentProjects");
        const { limit: limit = 20, headers: headers } = options;
        const queryString = new URLSearchParams({
            limit: limit.toString()
        }).toString();
        try {
            const response = queryString ? await this._request(`/users/projects/recent?${queryString}`, {
                method: "GET",
                ...headers ? {
                    headers: headers
                } : {},
                methodName: "getRecentProjects"
            }) : await this._request("/users/projects/recent", {
                method: "GET",
                ...headers ? {
                    headers: headers
                } : {},
                methodName: "getRecentProjects"
            });
            if (response.success) return (response.data || []).map((item)=>({
                    ...item.project,
                    ...item.project && item.project.icon && {
                        icon: {
                            src: `${this._apiUrl}/core/files/public/${item.project.icon.id}/download`,
                            ...item.project.icon
                        }
                    }
                }));
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to get recent projects: ${error.message}`, {
                cause: error
            });
        }
    }
    // ==================== RESOURCE ENUMERATION ====================
    //
    // Read-only resource listings (components / functions / pages) for a
    // given project. Two addressing modes — by numeric/ObjectId id, or by
    // bare project key. The key-based routes are 1-seg on the server
    // today; see 🤝 REQUEST → SERVER in NEEDED_FOR_SDK.md for the 2-seg
    // follow-up (post-§45 collision safety).
    //
    // Response envelope follows the server convention:
    //   { success: true, data: [ { id, name, ... } ], total? }
    // Fails-soft to `{ items: [] }` on non-success so UIs don't crash when
    // the server is briefly unreachable.
    /**
   * List all component resources for a project by id.
   * @param {string} projectId
   * @returns {Promise<{items: Array<object>, total?: number}>}
   */ async getProjectComponents(projectId) {
        this._requireReady("getProjectComponents");
        if (!projectId) throw new Error("projectId is required");
        const response = await this._request(`/projects/${encodeURIComponent(projectId)}/resources/components`, {
            method: "GET",
            methodName: "getProjectComponents"
        });
        if (response == null ? void 0 : response.success) return response;
        return {
            items: []
        };
    }
    /**
   * List all function resources for a project by id.
   * @param {string} projectId
   * @returns {Promise<{items: Array<object>, total?: number}>}
   */ async getProjectFunctions(projectId) {
        this._requireReady("getProjectFunctions");
        if (!projectId) throw new Error("projectId is required");
        const response = await this._request(`/projects/${encodeURIComponent(projectId)}/resources/functions`, {
            method: "GET",
            methodName: "getProjectFunctions"
        });
        if (response == null ? void 0 : response.success) return response;
        return {
            items: []
        };
    }
    /**
   * List all page resources for a project by id.
   * @param {string} projectId
   * @returns {Promise<{items: Array<object>, total?: number}>}
   */ async getProjectPages(projectId) {
        this._requireReady("getProjectPages");
        if (!projectId) throw new Error("projectId is required");
        const response = await this._request(`/projects/${encodeURIComponent(projectId)}/resources/pages`, {
            method: "GET",
            methodName: "getProjectPages"
        });
        if (response == null ? void 0 : response.success) return response;
        return {
            items: []
        };
    }
    /**
   * List all component resources for a project by key. Today the server
   * only exposes the 1-seg variant; pass a bare key (string) or
   * `{ key }` object. `{ owner, key }` is accepted for forward-compat
   * but currently hits the 1-seg route (owner segment is a no-op).
   * @param {string | { owner?: string, key: string }} projectKey
   * @returns {Promise<{items: Array<object>, total?: number}>}
   */ async getProjectComponentsByKey(projectKey) {
        this._requireReady("getProjectComponentsByKey");
        if (!projectKey) throw new Error("projectKey is required");
        const response = await this._request(`/projects/key/${$281a441cdcb2cf36$var$projectKeyPath(projectKey)}/resources/components`, {
            method: "GET",
            methodName: "getProjectComponentsByKey"
        });
        if (response == null ? void 0 : response.success) return response;
        return {
            items: []
        };
    }
    /**
   * List all function resources for a project by key. See
   * `getProjectComponentsByKey` for the key-shape contract.
   * @param {string | { owner?: string, key: string }} projectKey
   * @returns {Promise<{items: Array<object>, total?: number}>}
   */ async getProjectFunctionsByKey(projectKey) {
        this._requireReady("getProjectFunctionsByKey");
        if (!projectKey) throw new Error("projectKey is required");
        const response = await this._request(`/projects/key/${$281a441cdcb2cf36$var$projectKeyPath(projectKey)}/resources/functions`, {
            method: "GET",
            methodName: "getProjectFunctionsByKey"
        });
        if (response == null ? void 0 : response.success) return response;
        return {
            items: []
        };
    }
    /**
   * List all page resources for a project by key. See
   * `getProjectComponentsByKey` for the key-shape contract.
   * @param {string | { owner?: string, key: string }} projectKey
   * @returns {Promise<{items: Array<object>, total?: number}>}
   */ async getProjectPagesByKey(projectKey) {
        this._requireReady("getProjectPagesByKey");
        if (!projectKey) throw new Error("projectKey is required");
        const response = await this._request(`/projects/key/${$281a441cdcb2cf36$var$projectKeyPath(projectKey)}/resources/pages`, {
            method: "GET",
            methodName: "getProjectPagesByKey"
        });
        if (response == null ? void 0 : response.success) return response;
        return {
            items: []
        };
    }
    // ==================== OWNERSHIP (admin-only) ====================
    //
    // Global-admin-only endpoints for auditing + fixing project ownership.
    // Surfaced on the SDK so internal admin UIs and ops scripts can hit
    // them without hand-rolling fetches. All three reject with 403 for
    // non-admins on the server side.
    /**
   * List projects with their ownership status. Admin-only on the server.
   * Useful for finding orphaned projects (no owner) or auditing a specific
   * owner's footprint.
   *
   * @param {{ hasOwner?: 'true' | 'false', search?: string, page?: number, limit?: number }} [params]
   * @returns {Promise<{success: boolean, data: {items: Array<object>, total: number, page: number, limit: number}}>}
   */ async listProjectOwnership(params2 = {}) {
        this._requireReady("listProjectOwnership");
        const qs = new URLSearchParams();
        Object.keys(params2).forEach((k3)=>{
            if (params2[k3] != null) qs.append(k3, String(params2[k3]));
        });
        const queryString = qs.toString();
        const response = queryString ? await this._request(`/projects/ownership?${queryString}`, {
            method: "GET",
            methodName: "listProjectOwnership"
        }) : await this._request("/projects/ownership", {
            method: "GET",
            methodName: "listProjectOwnership"
        });
        if (response == null ? void 0 : response.success) return response;
        return {
            success: false,
            data: {
                items: [],
                total: 0
            }
        };
    }
    /**
   * Assign a specific user as project owner. Admin-only on the server.
   * If another owner exists they are downgraded to admin. Identifies the
   * target project by id OR key, and the target user by id OR email.
   *
   * @param {{ projectId?: string, projectKey?: string, userId?: string, email?: string }} args
   * @returns {Promise<object>} - server response envelope
   */ async assignProjectOwner(args2 = {}) {
        if (!args2.projectId && !args2.projectKey) throw new Error("projectId or projectKey is required");
        if (!args2.userId && !args2.email) throw new Error("userId or email is required");
        return this._call("assignProjectOwner", "/projects/ownership/assign", {
            method: "POST",
            body: args2
        });
    }
    /**
   * Bulk-promote the earliest-joined admin of each ownerless project to
   * owner. Admin-only. Returns counts + per-project error list.
   *
   * @param {{ limit?: number, skipProjectIds?: Array<string> }} [args]
   * @returns {Promise<{success: boolean, data: {processed: number, updated: number, skipped: number, errors: Array<object>}}>}
   */ async autoAssignProjectOwners(args2 = {}) {
        return this._call("autoAssignProjectOwners", "/projects/ownership/auto-assign", {
            method: "POST",
            body: args2
        });
    }
};
// src/services/PlanService.js
var $281a441cdcb2cf36$var$PlanService = class extends $281a441cdcb2cf36$var$BaseService {
    // ==================== PLAN METHODS ====================
    /**
   * Get list of public plans (no authentication required)
   */ async getPlans() {
        try {
            const response = await this._request("/plans", {
                method: "GET",
                methodName: "getPlans"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to get plans: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Get list of public plans with enhanced pricing information (no authentication required)
   */ async getPlansWithPricing() {
        try {
            const response = await this._request("/plans/pricing", {
                method: "GET",
                methodName: "getPlansWithPricing"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to get plans with pricing: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Get a specific plan by ID (no authentication required)
   */ async getPlan(planId) {
        if (!planId) throw new Error("Plan ID is required");
        try {
            const response = await this._request(`/plans/${planId}`, {
                method: "GET",
                methodName: "getPlan"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to get plan: ${error.message}`, {
                cause: error
            });
        }
    }
    // ==================== ADMIN PLAN METHODS ====================
    /**
   * Get all plans including inactive ones (admin only)
   */ async getAdminPlans() {
        this._requireReady("getAdminPlans");
        try {
            const response = await this._request("/admin/plans", {
                method: "GET",
                methodName: "getAdminPlans"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to get admin plans: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Create a new plan (admin only)
   */ async createPlan(planData) {
        this._requireReady("createPlan");
        if (!planData || typeof planData !== "object") throw new Error("Plan data is required");
        try {
            const response = await this._request("/admin/plans", {
                method: "POST",
                body: JSON.stringify(planData),
                methodName: "createPlan"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to create plan: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Update an existing plan (admin only)
   */ async updatePlan(planId, planData) {
        this._requireReady("updatePlan");
        if (!planId) throw new Error("Plan ID is required");
        if (!planData || typeof planData !== "object") throw new Error("Plan data is required");
        try {
            const response = await this._request(`/admin/plans/${planId}`, {
                method: "PATCH",
                body: JSON.stringify(planData),
                methodName: "updatePlan"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to update plan: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Delete a plan (soft delete + archive Stripe product) (admin only)
   */ async deletePlan(planId) {
        this._requireReady("deletePlan");
        if (!planId) throw new Error("Plan ID is required");
        try {
            const response = await this._request(`/admin/plans/${planId}`, {
                method: "DELETE",
                methodName: "deletePlan"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to delete plan: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Initialize default plans (admin only)
   */ async initializePlans() {
        this._requireReady("initializePlans");
        try {
            const response = await this._request("/admin/plans/initialize", {
                method: "POST",
                methodName: "initializePlans"
            });
            if (response.success) return response;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to initialize plans: ${error.message}`, {
                cause: error
            });
        }
    }
    // ==================== PLAN HELPER METHODS ====================
    /**
   * Helper method to get plans with validation
   */ async getPlansWithValidation() {
        try {
            const plans = await this.getPlans();
            if (!Array.isArray(plans)) throw new Error("Invalid response format: plans should be an array");
            return plans;
        } catch (error) {
            throw new Error(`Failed to get plans with validation: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Helper method to get a plan by ID with validation
   */ async getPlanWithValidation(planId) {
        if (!planId || typeof planId !== "string") throw new Error("Plan ID must be a valid string");
        try {
            const plan = await this.getPlan(planId);
            if (!plan || typeof plan !== "object") throw new Error("Invalid plan data received");
            return plan;
        } catch (error) {
            throw new Error(`Failed to get plan with validation: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Helper method to create a plan with validation (admin only)
   */ async createPlanWithValidation(planData) {
        if (!planData || typeof planData !== "object") throw new Error("Plan data must be a valid object");
        const requiredFields = [
            "name",
            "description"
        ];
        for (const field of requiredFields){
            if (!planData[field]) throw new Error(`Required field '${field}' is missing`);
        }
        if (Object.hasOwn(planData, "price")) throw new Error('Field "price" is no longer supported. Use unified "pricingOptions" with "amount" instead.');
        if (planData.pricingOptions != null) {
            if (!Array.isArray(planData.pricingOptions) || planData.pricingOptions.length === 0) throw new Error("pricingOptions must be a non-empty array when provided");
            const allowedIntervals = /* @__PURE__ */ new Set([
                "month",
                "year",
                "week",
                "day",
                null
            ]);
            planData.pricingOptions.forEach((option, index)=>{
                if (!option || typeof option !== "object") throw new Error(`Pricing option at index ${index} must be an object`);
                const { key: key, displayName: displayName, amount: amount, interval: interval, lookupKey: lookupKey } = option;
                if (!key || typeof key !== "string") throw new Error(`Pricing option at index ${index} is missing required field 'key'`);
                if (!/^[a-z0-9-]+$/u.test(key)) throw new Error(`Pricing option key '${key}' must contain only lowercase letters, numbers, and hyphens`);
                if (!displayName || typeof displayName !== "string") throw new Error(`Pricing option '${key}' is missing required field 'displayName'`);
                if (typeof amount !== "number" || amount < 0) throw new Error(`Pricing option '${key}' must have a non-negative numeric 'amount'`);
                if (interval !== null && !allowedIntervals.has(interval)) throw new Error(`Pricing option '${key}' has invalid interval '${interval}'. Allowed: month, year, week, day or null`);
                if (!lookupKey || typeof lookupKey !== "string") throw new Error(`Pricing option '${key}' is missing required field 'lookupKey'`);
            });
        }
        if (Object.hasOwn(planData, "key") && planData.key == null) throw new Error("Plan key must be a valid string");
        if (planData.key && !/^[a-z0-9-]+$/u.test(planData.key)) throw new Error("Plan key must contain only lowercase letters, numbers, and hyphens");
        return await this.createPlan(planData);
    }
    /**
   * Helper method to update a plan with validation (admin only)
   */ async updatePlanWithValidation(planId, planData) {
        if (!planId || typeof planId !== "string") throw new Error("Plan ID must be a valid string");
        if (!planData || typeof planData !== "object") throw new Error("Plan data must be a valid object");
        if (Object.hasOwn(planData, "price")) throw new Error('Field "price" is no longer supported. Use unified "pricingOptions" with "amount" instead.');
        if (planData.pricingOptions != null) {
            if (!Array.isArray(planData.pricingOptions) || planData.pricingOptions.length === 0) throw new Error("pricingOptions must be a non-empty array when provided");
            const allowedIntervals = /* @__PURE__ */ new Set([
                "month",
                "year",
                "week",
                "day",
                null
            ]);
            planData.pricingOptions.forEach((option, index)=>{
                if (!option || typeof option !== "object") throw new Error(`Pricing option at index ${index} must be an object`);
                const { key: key, displayName: displayName, amount: amount, interval: interval, lookupKey: lookupKey } = option;
                if (!key || typeof key !== "string") throw new Error(`Pricing option at index ${index} is missing required field 'key'`);
                if (!/^[a-z0-9-]+$/u.test(key)) throw new Error(`Pricing option key '${key}' must contain only lowercase letters, numbers, and hyphens`);
                if (!displayName || typeof displayName !== "string") throw new Error(`Pricing option '${key}' is missing required field 'displayName'`);
                if (typeof amount !== "number" || amount < 0) throw new Error(`Pricing option '${key}' must have a non-negative numeric 'amount'`);
                if (interval !== null && !allowedIntervals.has(interval)) throw new Error(`Pricing option '${key}' has invalid interval '${interval}'. Allowed: month, year, week, day or null`);
                if (!lookupKey || typeof lookupKey !== "string") throw new Error(`Pricing option '${key}' is missing required field 'lookupKey'`);
            });
        }
        if (Object.hasOwn(planData, "key") && planData.key == null) throw new Error("Plan key must be a valid string");
        if (planData.key && !/^[a-z0-9-]+$/u.test(planData.key)) throw new Error("Plan key must contain only lowercase letters, numbers, and hyphens");
        return await this.updatePlan(planId, planData);
    }
    /**
   * Helper method to get active plans only
   */ async getActivePlans() {
        try {
            const plans = await this.getPlans();
            return plans.filter((plan)=>plan.status === "active" && plan.isVisible !== false);
        } catch (error) {
            throw new Error(`Failed to get active plans: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Helper method to get plans by price range
   */ async getPlansByPriceRange(minPrice = 0, maxPrice = Infinity) {
        try {
            const plans = await this.getPlansWithPricing();
            return plans.filter((plan)=>{
                var _a2, _b, _c;
                const price = (_c = (_b = (_a2 = plan == null ? void 0 : plan.pricing) == null ? void 0 : _a2.bestPrice) == null ? void 0 : _b.amount) != null ? _c : 0;
                return price >= minPrice && price <= maxPrice;
            });
        } catch (error) {
            throw new Error(`Failed to get plans by price range: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Helper method to find plan by key
   */ async getPlanByKey(key) {
        if (!key) throw new Error("Plan key is required");
        try {
            const plans = await this.getPlans();
            const plan = plans.find((p3)=>p3.key === key);
            if (!plan) throw new Error(`Plan with key '${key}' not found`);
            return plan;
        } catch (error) {
            throw new Error(`Failed to get plan by key: ${error.message}`, {
                cause: error
            });
        }
    }
};
// src/services/SubscriptionService.js
var $281a441cdcb2cf36$var$SubscriptionService = class extends $281a441cdcb2cf36$var$BaseService {
    // ==================== SUBSCRIPTION METHODS ====================
    /**
   * Create a new subscription checkout session
   */ async createSubscription(subscriptionData) {
        this._requireReady("createSubscription");
        if (!subscriptionData || typeof subscriptionData !== "object") throw new Error("Subscription data is required");
        const { projectId: projectId, workspaceId: workspaceId, planId: planId, pricingKey: pricingKey = "monthly", seats: seats = 1, successUrl: successUrl, cancelUrl: cancelUrl } = subscriptionData;
        if (!projectId && !workspaceId) throw new Error("Project ID or Workspace ID is required");
        if (!planId) throw new Error("Plan ID is required");
        try {
            const response = await this._request("/subscriptions", {
                method: "POST",
                body: JSON.stringify({
                    projectId: projectId,
                    workspaceId: workspaceId,
                    planId: planId,
                    pricingKey: pricingKey,
                    seats: seats,
                    successUrl: successUrl,
                    cancelUrl: cancelUrl
                }),
                methodName: "createSubscription"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to create subscription: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Get subscription status and usage for a project
   */ async getProjectStatus(projectId) {
        this._requireReady("getProjectStatus");
        if (!projectId) throw new Error("Project ID is required");
        try {
            const response = await this._request(`/subscriptions/project/${projectId}`, {
                method: "GET",
                methodName: "getProjectStatus"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to get project subscription status: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Get usage data for a subscription
   */ async getUsage(subscriptionId) {
        this._requireReady("getUsage");
        if (!subscriptionId) throw new Error("Subscription ID is required");
        try {
            const response = await this._request(`/subscriptions/${subscriptionId}/usage`, {
                method: "GET",
                methodName: "getUsage"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to get subscription usage: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Cancel a subscription
   */ async cancelSubscription(subscriptionId) {
        this._requireReady("cancelSubscription");
        if (!subscriptionId) throw new Error("Subscription ID is required");
        try {
            const response = await this._request(`/subscriptions/${subscriptionId}/cancel`, {
                method: "POST",
                methodName: "cancelSubscription"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to cancel subscription: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * List invoices for a subscription
   */ async listInvoices(subscriptionId, options = {}) {
        this._requireReady("listInvoices");
        if (!subscriptionId) throw new Error("Subscription ID is required");
        const { page: page = 1, limit: limit = 20, status: status, startingAfter: startingAfter } = options;
        try {
            const queryParams = new URLSearchParams();
            if (page) queryParams.append("page", page.toString());
            if (limit) queryParams.append("limit", limit.toString());
            if (status) queryParams.append("status", status);
            if (startingAfter) queryParams.append("startingAfter", startingAfter);
            const queryString = queryParams.toString();
            const response = queryString ? await this._request(`/subscriptions/${subscriptionId}/invoices?${queryString}`, {
                method: "GET",
                methodName: "listInvoices"
            }) : await this._request(`/subscriptions/${subscriptionId}/invoices`, {
                method: "GET",
                methodName: "listInvoices"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to list invoices: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Get customer portal URL for a subscription
   */ async getPortalUrl(subscriptionId, returnUrl) {
        this._requireReady("getPortalUrl");
        if (!subscriptionId) throw new Error("Subscription ID is required");
        try {
            const queryParams = new URLSearchParams();
            if (returnUrl) queryParams.append("returnUrl", returnUrl);
            const queryString = queryParams.toString();
            const response = queryString ? await this._request(`/subscriptions/${subscriptionId}/portal?${queryString}`, {
                method: "GET",
                methodName: "getPortalUrl"
            }) : await this._request(`/subscriptions/${subscriptionId}/portal`, {
                method: "GET",
                methodName: "getPortalUrl"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to get portal URL: ${error.message}`, {
                cause: error
            });
        }
    }
    // ==================== SUBSCRIPTION HELPER METHODS ====================
    /**
   * Helper method to create subscription with validation
   */ async createSubscriptionWithValidation(subscriptionData) {
        if (!subscriptionData || typeof subscriptionData !== "object") throw new Error("Subscription data must be a valid object");
        if (!subscriptionData.projectId && !subscriptionData.workspaceId) throw new Error("Required field 'projectId' or 'workspaceId' is missing");
        if (!subscriptionData.planId) throw new Error("Required field 'planId' is missing");
        if (subscriptionData.seats != null) {
            if (!Number.isInteger(subscriptionData.seats) || subscriptionData.seats < 1) throw new Error("Seats must be a positive integer");
        }
        if (subscriptionData.pricingKey && ![
            "monthly",
            "yearly"
        ].includes(subscriptionData.pricingKey)) throw new Error('Pricing key must be either "monthly" or "yearly"');
        return await this.createSubscription(subscriptionData);
    }
    /**
   * Helper method to check if project has active subscription
   */ async hasActiveSubscription(projectId) {
        try {
            const status = await this.getProjectStatus(projectId);
            return status.hasSubscription === true;
        } catch (error) {
            throw new Error(`Failed to check subscription status: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Helper method to get subscription details for a project
   */ async getProjectSubscription(projectId) {
        try {
            const status = await this.getProjectStatus(projectId);
            if (!status.hasSubscription) return null;
            return status.subscription;
        } catch (error) {
            throw new Error(`Failed to get project subscription: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Helper method to get usage with limits for a project
   */ async getProjectUsage(projectId) {
        try {
            const status = await this.getProjectStatus(projectId);
            if (!status.hasSubscription) return null;
            return status.usage;
        } catch (error) {
            throw new Error(`Failed to get project usage: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Helper method to get invoices with pagination
   */ async getInvoicesWithPagination(subscriptionId, options = {}) {
        try {
            const result = await this.listInvoices(subscriptionId, options);
            return {
                invoices: result.data || [],
                pagination: result.pagination || {}
            };
        } catch (error) {
            throw new Error(`Failed to get invoices with pagination: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Helper method to check if subscription is active
   */ async isSubscriptionActive(subscriptionId) {
        try {
            const usage = await this.getUsage(subscriptionId);
            return usage && usage.subscription && usage.subscription.status === "active";
        } catch (error) {
            throw new Error(`Failed to check subscription status: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Helper method to get subscription limits
   */ async getSubscriptionLimits(subscriptionId) {
        try {
            const usage = await this.getUsage(subscriptionId);
            return usage.limits || {};
        } catch (error) {
            throw new Error(`Failed to get subscription limits: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Change subscription (unified endpoint for all pricing changes)
   */ async changeSubscription(changeData) {
        this._requireReady("changeSubscription");
        if (!changeData || typeof changeData !== "object") throw new Error("Change data is required");
        const { subscriptionId: subscriptionId, planId: planId, pricingKey: pricingKey, seats: seats = 1, projectId: projectId, successUrl: successUrl, cancelUrl: cancelUrl } = changeData;
        if (!subscriptionId) throw new Error("Subscription ID is required");
        if (!pricingKey) throw new Error("Pricing key is required");
        try {
            const response = await this._request(`/subscriptions/${subscriptionId}/change`, {
                method: "POST",
                body: JSON.stringify({
                    planId: planId,
                    pricingKey: pricingKey,
                    seats: seats,
                    projectId: projectId,
                    successUrl: successUrl,
                    cancelUrl: cancelUrl
                }),
                methodName: "changeSubscription"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to change subscription: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Downgrade subscription to free plan
   */ async downgrade(downgradeData) {
        this._requireReady("downgrade");
        if (!downgradeData || typeof downgradeData !== "object") throw new Error("Downgrade data is required");
        const { subscriptionId: subscriptionId, reason: reason } = downgradeData;
        if (!subscriptionId) throw new Error("Subscription ID is required");
        try {
            const response = await this._request(`/subscriptions/${subscriptionId}/downgrade`, {
                method: "POST",
                body: JSON.stringify({
                    reason: reason
                }),
                methodName: "downgrade"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to downgrade subscription: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Helper method to change subscription with validation
   */ async changeSubscriptionWithValidation(changeData) {
        if (!changeData || typeof changeData !== "object") throw new Error("Change data must be a valid object");
        const requiredFields = [
            "subscriptionId",
            "pricingKey"
        ];
        for (const field of requiredFields){
            if (!changeData[field]) throw new Error(`Required field '${field}' is missing`);
        }
        if (changeData.seats != null) {
            if (!Number.isInteger(changeData.seats) || changeData.seats < 1) throw new Error("Seats must be a positive integer");
        }
        if (typeof changeData.subscriptionId !== "string") throw new Error("Subscription ID must be a valid string");
        if (changeData.planId && typeof changeData.planId !== "string") throw new Error("Plan ID must be a valid string");
        return await this.changeSubscription(changeData);
    }
    /**
   * Helper method to downgrade subscription with validation
   */ async downgradeWithValidation(downgradeData) {
        if (!downgradeData || typeof downgradeData !== "object") throw new Error("Downgrade data must be a valid object");
        if (!downgradeData.subscriptionId) throw new Error("Subscription ID is required");
        if (typeof downgradeData.subscriptionId !== "string") throw new Error("Subscription ID must be a valid string");
        if (downgradeData.reason && typeof downgradeData.reason !== "string") throw new Error("Reason must be a valid string");
        return await this.downgrade(downgradeData);
    }
    // ==================== PRICING + FEATURES ====================
    /**
   * Retrieve the set of plans + upgrade/downgrade options applicable to
   * a subscription. Used by upgrade UIs to render the plan-picker
   * without hitting Stripe directly.
   * @param {string} subscriptionId
   * @returns {Promise<{plans: Array<object>, currentPlan?: object}>}
   */ async getPricingOptions(subscriptionId) {
        if (!subscriptionId) throw new Error("subscriptionId is required");
        return this._call("getPricingOptions", `/subscriptions/${subscriptionId}/pricing-options`);
    }
    /**
   * Check whether a project has access to a named feature. Server
   * resolves the subscription's feature set + any per-project grants.
   * Open to any project member.
   * @param {string} projectId
   * @param {string} featureKey
   * @returns {Promise<{canAccess: boolean, reason?: string, source?: string}>}
   */ async canAccessProjectFeature(projectId, featureKey) {
        this._requireReady("canAccessProjectFeature");
        if (!projectId) throw new Error("projectId is required");
        if (!featureKey) throw new Error("featureKey is required");
        const response = await this._request(`/subscriptions/project/${projectId}/features/${encodeURIComponent(featureKey)}/can-access`, {
            method: "GET",
            methodName: "canAccessProjectFeature"
        });
        if (response == null ? void 0 : response.success) return response.data;
        return {
            canAccess: false
        };
    }
    /**
   * Grant a project-scoped feature override — admin-tier only on the
   * server. Useful for beta/trial access without touching the plan.
   * @param {string} projectId
   * @param {string} featureKey
   * @returns {Promise<object>}
   */ async grantProjectFeature(projectId, featureKey) {
        if (!projectId) throw new Error("projectId is required");
        if (!featureKey) throw new Error("featureKey is required");
        return this._call("grantProjectFeature", `/subscriptions/project/${projectId}/features/${encodeURIComponent(featureKey)}/grant`, {
            method: "POST"
        });
    }
    /**
   * Revoke a previously granted project-scoped feature override. After
   * revoke, access reverts to whatever the subscription plan allows.
   * @param {string} projectId
   * @param {string} featureKey
   * @returns {Promise<object>}
   */ async revokeProjectFeature(projectId, featureKey) {
        if (!projectId) throw new Error("projectId is required");
        if (!featureKey) throw new Error("featureKey is required");
        return this._call("revokeProjectFeature", `/subscriptions/project/${projectId}/features/${encodeURIComponent(featureKey)}/revoke`, {
            method: "POST"
        });
    }
};
// src/services/FileService.js
var $281a441cdcb2cf36$var$FileService = class extends $281a441cdcb2cf36$var$BaseService {
    // ==================== FILE METHODS ====================
    async uploadFile(file, options = {}) {
        var _a2;
        this._requireReady("uploadFile");
        if (!file) throw new Error("File is required for upload");
        const formData = new FormData();
        formData.append("file", file);
        const hasProjectIdOption = Object.hasOwn(options, "projectId");
        const projectId = hasProjectIdOption ? options.projectId : (_a2 = this._context.project) == null ? void 0 : _a2.id;
        if (projectId != null && projectId !== "") formData.append("projectId", projectId);
        if (options.tags) formData.append("tags", JSON.stringify(options.tags));
        if (options.visibility) formData.append("visibility", options.visibility || "public");
        if (options.metadata) formData.append("metadata", JSON.stringify(options.metadata));
        try {
            const response = await this._request("/files/upload", {
                method: "POST",
                body: formData,
                headers: {},
                // Let browser set Content-Type for FormData
                methodName: "uploadFile"
            });
            if (!response.success) throw new Error(response.message);
            return response.data;
        } catch (error) {
            throw new Error(`File upload failed: ${error.message}`, {
                cause: error
            });
        }
    }
    async updateProjectIcon(projectId, iconFile) {
        this._requireReady("updateProjectIcon");
        if (!projectId || !iconFile) throw new Error("Project ID and icon file are required");
        const formData = new FormData();
        formData.append("icon", iconFile);
        formData.append("projectId", projectId);
        try {
            const response = await this._request("/files/upload-project-icon", {
                method: "POST",
                body: formData,
                headers: {},
                // Let browser set Content-Type for FormData
                methodName: "updateProjectIcon"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to update project icon: ${error.message}`, {
                cause: error
            });
        }
    }
    // ==================== FILE HELPER METHODS ====================
    /**
   * Helper method to upload file with validation
   */ async uploadFileWithValidation(file, options = {}) {
        if (!file) throw new Error("File is required");
        const maxSize = options.maxSize || 10485760;
        if (file.size > maxSize) throw new Error(`File size exceeds maximum allowed size of ${maxSize / 1048576}MB`);
        const allowedTypes = options.allowedTypes || [
            "image/*",
            "application/pdf",
            "text/*"
        ];
        if (allowedTypes.length > 0) {
            const isValidType = allowedTypes.some((type)=>{
                if (type.endsWith("/*")) return file.type.startsWith(type.replace("/*", ""));
                return file.type === type;
            });
            if (!isValidType) throw new Error(`File type '${file.type}' is not allowed. Allowed types: ${allowedTypes.join(", ")}`);
        }
        return await this.uploadFile(file, options);
    }
    /**
   * Helper method to upload image file specifically
   */ async uploadImage(imageFile, options = {}) {
        const imageOptions = {
            ...options,
            allowedTypes: [
                "image/jpeg",
                "image/png",
                "image/gif",
                "image/webp"
            ],
            maxSize: options.maxSize || 5242880
        };
        return await this.uploadFileWithValidation(imageFile, imageOptions);
    }
    /**
   * Helper method to upload document file
   */ async uploadDocument(documentFile, options = {}) {
        const documentOptions = {
            ...options,
            allowedTypes: [
                "application/pdf",
                "text/plain",
                "application/msword",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            ],
            maxSize: options.maxSize || 20971520
        };
        return await this.uploadFileWithValidation(documentFile, documentOptions);
    }
    /**
   * Helper method to get file URL by ID
   */ getFileUrl(fileId) {
        if (!fileId) throw new Error("File ID is required");
        return `${this._apiUrl}/core/files/public/${fileId}/download`;
    }
    /**
   * Helper method to validate file before upload
   */ validateFile(file, options = {}) {
        const errors = [];
        if (!file) {
            errors.push("File is required");
            return errors;
        }
        const maxSize = options.maxSize || 10485760;
        if (file.size > maxSize) errors.push(`File size (${(file.size / 1048576).toFixed(2)}MB) exceeds maximum allowed size of ${maxSize / 1048576}MB`);
        const allowedTypes = options.allowedTypes || [];
        if (allowedTypes.length > 0) {
            const isValidType = allowedTypes.some((type)=>{
                if (type.endsWith("/*")) return file.type.startsWith(type.replace("/*", ""));
                return file.type === type;
            });
            if (!isValidType) errors.push(`File type '${file.type}' is not allowed. Allowed types: ${allowedTypes.join(", ")}`);
        }
        return errors;
    }
    /**
   * Helper method to create FormData with file and metadata
   */ createFileFormData(file, metadata = {}) {
        const formData = new FormData();
        formData.append("file", file);
        if (Object.keys(metadata).length > 0) formData.append("metadata", JSON.stringify(metadata));
        return formData;
    }
    /**
   * Helper method to upload multiple files
   */ async uploadMultipleFiles(files, options = {}) {
        if (!Array.isArray(files) || files.length === 0) throw new Error("Files array is required and must not be empty");
        const uploadPromises = files.map((file)=>this.uploadFile(file, options));
        const results = await Promise.allSettled(uploadPromises);
        return results.map((result, index)=>({
                file: files[index],
                success: result.status === "fulfilled",
                data: result.status === "fulfilled" ? result.value : null,
                error: result.status === "rejected" ? result.reason.message : null
            }));
    }
    // ==================== PROJECT FILE UPLOAD ====================
    /**
   * Upload a file to the server and add its metadata to the project files map.
   *
   * Uses the project key from symbols.json (passed via context or options) to
   * associate the upload with a project. After upload, patches the project's
   * `files` map with a metadata entry matching the format used in the local
   * `files/` directory (content.src, key, type, format).
   *
   * @param {File|Blob} file - The file to upload
   * @param {Object} options
   * @param {string} options.key - File key in the project files map (defaults to file.name)
   * @param {string} options.projectId - Project ID (falls back to context)
   * @param {string} options.projectKey - Project key from symbols.json (falls back to context.appKey)
   * @param {string} options.visibility - File visibility (default: 'public')
   * @param {string[]} options.tags - Tags for the uploaded file
   * @param {Object} options.metadata - Extra metadata for the upload
   * @param {string} options.branch - Project branch (default: 'main')
   * @returns {Object} The file metadata entry that was added to the project
   */ async uploadProjectFile(file, options = {}) {
        var _a2, _b, _c;
        this._requireReady("uploadProjectFile");
        if (!file) throw new Error("File is required for upload");
        const fileKey = options.key || file.name;
        if (!fileKey) throw new Error("File key is required (provide options.key or a file with a name)");
        const uploadData = await this.uploadFile(file, {
            projectId: options.projectId,
            visibility: options.visibility || "public",
            tags: options.tags,
            metadata: options.metadata
        });
        const fileId = uploadData._id || uploadData.id;
        const format = $281a441cdcb2cf36$var$_extractFormat(fileKey, uploadData);
        const entry = {
            content: {
                src: this.getFileUrl(fileId)
            },
            code: "",
            key: fileKey,
            type: "file",
            format: format
        };
        const projectService = (_b = (_a2 = this._context) == null ? void 0 : _a2.services) == null ? void 0 : _b.project;
        const projectId = options.projectId || ((_c = this._context.project) == null ? void 0 : _c.id);
        if (projectService && projectId) {
            const branch = options.branch || "main";
            const changes = [
                [
                    "update",
                    [
                        "files",
                        fileKey
                    ],
                    entry
                ]
            ];
            await projectService.applyProjectChanges(projectId, changes, {
                branch: branch
            });
        }
        return entry;
    }
    /**
   * Upload multiple files to the project files map.
   *
   * @param {Array<File|Blob>} files - Files to upload
   * @param {Object} options - Same options as uploadProjectFile (key is derived from each file name)
   * @returns {Array<Object>} Results with success/error status and metadata entries
   */ async uploadMultipleProjectFiles(files, options = {}) {
        if (!Array.isArray(files) || files.length === 0) throw new Error("Files array is required and must not be empty");
        const results = [];
        for (const file of files)try {
            const entry = await this.uploadProjectFile(file, {
                ...options,
                key: file.name || options.key
            });
            results.push({
                file: file,
                success: true,
                data: entry,
                error: null
            });
        } catch (error) {
            results.push({
                file: file,
                success: false,
                data: null,
                error: error.message
            });
        }
        return results;
    }
    // ==================== FILE CRUD ====================
    /**
   * Fetch file metadata by id (no content). Access control scoped to
   * owner + shared-project members on the server.
   * @param {string} fileId
   * @returns {Promise<object>}
   */ async getFile(fileId) {
        if (!fileId) throw new Error("fileId is required");
        return this._call("getFile", `/files/${fileId}`);
    }
    /**
   * Patch file metadata (tags, visibility, metadata). Not for binary
   * content — replace by re-uploading.
   * @param {string} fileId
   * @param {{tags?: Array<string>, visibility?: string, metadata?: object}} updates
   */ async updateFile(fileId, updates = {}) {
        if (!fileId) throw new Error("fileId is required");
        return this._call("updateFile", `/files/${fileId}`, {
            method: "PUT",
            body: updates
        });
    }
    /**
   * Delete a file. Owner-only on the server. Also removes from R2.
   * @param {string} fileId
   */ async deleteFile(fileId) {
        if (!fileId) throw new Error("fileId is required");
        return this._call("deleteFile", `/files/${fileId}`, {
            method: "DELETE"
        });
    }
    /**
   * List the authenticated user's own uploads. Paginated.
   * @param {{page?: number, limit?: number, sortBy?: string, sortOrder?: 'asc' | 'desc'}} [options]
   */ async listMyUploads({ page: page = 1, limit: limit = 20, sortBy: sortBy, sortOrder: sortOrder } = {}) {
        const qs = new URLSearchParams({
            page: String(page),
            limit: String(limit)
        });
        if (sortBy) qs.append("sortBy", sortBy);
        if (sortOrder) qs.append("sortOrder", sortOrder);
        return this._call("listMyUploads", `/files/my-uploads?${qs.toString()}`);
    }
    /**
   * Upload a marketplace thumbnail. Admin-gated on the server (temporary
   * until the marketplace schema carries a seller FK). Multipart — R2 +
   * CDN-worker pipeline owned by the SCREENSHOTS agent, routed by SERVER.
   *
   * @param {File | Blob} thumbnailFile - image bytes
   * @param {{itemId: string, kind: string}} args - itemId: slug
   *   (alphanumerics + dashes, ≤64 chars); kind: one of the server's
   *   KIND_WHITELIST (e.g. 'template', 'component', 'page').
   * @returns {Promise<object>} - server response {thumbnailUrl, …}
   */ async uploadMarketplaceThumbnail(thumbnailFile, { itemId: itemId, kind: kind } = {}) {
        this._requireReady("uploadMarketplaceThumbnail");
        if (!thumbnailFile) throw new Error("thumbnailFile is required");
        if (!itemId) throw new Error("itemId is required");
        if (!kind) throw new Error("kind is required");
        const formData = new FormData();
        formData.append("file", thumbnailFile);
        formData.append("itemId", itemId);
        formData.append("kind", kind);
        const response = await this._request("/marketplace/thumbnail", {
            method: "POST",
            body: formData,
            headers: {},
            // let browser set Content-Type for FormData
            methodName: "uploadMarketplaceThumbnail"
        });
        if (response == null ? void 0 : response.success) return response.data;
        throw new Error((response == null ? void 0 : response.message) || "Failed to upload marketplace thumbnail");
    }
};
function $281a441cdcb2cf36$var$_extractFormat(fileKey, uploadData) {
    if (uploadData.extension) return uploadData.extension.toLowerCase();
    const dotIdx = fileKey.lastIndexOf(".");
    if (dotIdx !== -1) return fileKey.slice(dotIdx + 1).toLowerCase();
    return "";
}
// src/services/PaymentService.js
var $281a441cdcb2cf36$var$PaymentService = class extends $281a441cdcb2cf36$var$BaseService {
    // ==================== PAYMENT METHODS ====================
    async checkout(options = {}) {
        this._requireReady("checkout");
        const { projectId: projectId, seats: seats = 1, price: price = "starter_monthly", successUrl: successUrl = `${window.location.origin}/success`, cancelUrl: cancelUrl = `${window.location.origin}/pricing` } = options;
        if (!projectId) throw new Error("Project ID is required for checkout");
        try {
            const response = await this._request("/payments/checkout", {
                method: "POST",
                body: JSON.stringify({
                    projectId: projectId,
                    seats: seats,
                    price: price,
                    successUrl: successUrl,
                    cancelUrl: cancelUrl
                }),
                methodName: "checkout"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to checkout: ${error.message}`, {
                cause: error
            });
        }
    }
    async getSubscriptionStatus(projectId) {
        this._requireReady("getSubscriptionStatus");
        if (!projectId) throw new Error("Project ID is required");
        try {
            const response = await this._request(`/payments/subscription/${projectId}`, {
                method: "GET",
                methodName: "getSubscriptionStatus"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to get subscription status: ${error.message}`, {
                cause: error
            });
        }
    }
    // ==================== PAYMENT HELPER METHODS ====================
    /**
   * Helper method to create checkout with validation
   */ async checkoutWithValidation(options = {}) {
        const { projectId: projectId, seats: seats, price: price, successUrl: successUrl, cancelUrl: cancelUrl } = options;
        if (!projectId) throw new Error("Project ID is required");
        if (seats && (typeof seats !== "number" || seats < 1)) throw new Error("Seats must be a positive number");
        if (price && typeof price !== "string") throw new Error("Price must be a string");
        if (successUrl && !this._isValidUrl(successUrl)) throw new Error("Success URL must be a valid URL");
        if (cancelUrl && !this._isValidUrl(cancelUrl)) throw new Error("Cancel URL must be a valid URL");
        return await this.checkout(options);
    }
    /**
   * Helper method to get subscription status with validation
   */ async getSubscriptionStatusWithValidation(projectId) {
        if (!projectId || typeof projectId !== "string") throw new Error("Project ID must be a valid string");
        return await this.getSubscriptionStatus(projectId);
    }
    /**
   * Helper method to check if project has active subscription
   */ async hasActiveSubscription(projectId) {
        try {
            const status = await this.getSubscriptionStatus(projectId);
            return (status == null ? void 0 : status.active) === true;
        } catch (error) {
            $281a441cdcb2cf36$var$logger.warn("Failed to check subscription status:", error.message);
            return false;
        }
    }
    /**
   * Helper method to get subscription details
   */ async getSubscriptionDetails(projectId) {
        try {
            const status = await this.getSubscriptionStatus(projectId);
            if (!status) return {
                hasSubscription: false,
                active: false,
                message: "No subscription found"
            };
            return {
                hasSubscription: true,
                active: status.active || false,
                plan: status.plan,
                seats: status.seats,
                nextBillingDate: status.nextBillingDate,
                amount: status.amount,
                currency: status.currency,
                status: status.status
            };
        } catch (error) {
            throw new Error(`Failed to get subscription details: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Helper method to create checkout for specific plan
   */ async checkoutForPlan(projectId, planKey, options = {}) {
        if (!projectId) throw new Error("Project ID is required");
        if (!planKey) throw new Error("Plan key is required");
        const checkoutOptions = {
            projectId: projectId,
            price: planKey,
            ...options
        };
        return await this.checkoutWithValidation(checkoutOptions);
    }
    /**
   * Helper method to create checkout for team plan
   */ async checkoutForTeam(projectId, seats, options = {}) {
        if (!projectId) throw new Error("Project ID is required");
        if (!seats || seats < 1) throw new Error("Seats must be a positive number");
        const checkoutOptions = {
            projectId: projectId,
            seats: seats,
            price: "team_monthly",
            ...options
        };
        return await this.checkoutWithValidation(checkoutOptions);
    }
    /**
   * Helper method to validate subscription status
   */ validateSubscriptionStatus(status) {
        if (!status || typeof status !== "object") return {
            isValid: false,
            error: "Invalid subscription status format"
        };
        const requiredFields = [
            "active",
            "plan",
            "seats"
        ];
        const missingFields = requiredFields.filter((field)=>!(field in status));
        if (missingFields.length > 0) return {
            isValid: false,
            error: `Missing required fields: ${missingFields.join(", ")}`
        };
        return {
            isValid: true,
            error: null
        };
    }
    /**
   * Helper method to format subscription amount
   */ formatSubscriptionAmount(amount, currency = "USD") {
        if (!amount || typeof amount !== "number") return "N/A";
        return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: currency
        }).format(amount / 100);
    }
    /**
   * Helper method to get subscription summary
   */ async getSubscriptionSummary(projectId) {
        try {
            const details = await this.getSubscriptionDetails(projectId);
            if (!details.hasSubscription) return {
                status: "no_subscription",
                message: "No active subscription",
                action: "subscribe"
            };
            if (!details.active) return {
                status: "inactive",
                message: "Subscription is inactive",
                action: "reactivate"
            };
            return {
                status: "active",
                message: `Active ${details.plan} plan with ${details.seats} seats`,
                action: "manage",
                details: details
            };
        } catch (error) {
            return {
                status: "error",
                message: `Failed to get subscription: ${error.message}`,
                action: "retry"
            };
        }
    }
    /**
   * Private helper to validate URL
   */ _isValidUrl(string) {
        try {
            const url2 = new URL(string);
            return Boolean(url2);
        } catch  {
            return false;
        }
    }
};
// src/services/DnsService.js
var $281a441cdcb2cf36$var$DnsService = class extends $281a441cdcb2cf36$var$BaseService {
    // ==================== DNS METHODS ====================
    async createDnsRecord(domain, options = {}) {
        this._requireReady("createDnsRecord");
        if (!domain) throw new Error("Domain is required");
        try {
            const response = await this._request("/dns/records", {
                method: "POST",
                body: JSON.stringify({
                    domain: domain,
                    ...options
                }),
                methodName: "createDnsRecord"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to create DNS record: ${error.message}`, {
                cause: error
            });
        }
    }
    async getDnsRecord(domain) {
        this._requireReady("getDnsRecord");
        if (!domain) throw new Error("Domain is required");
        try {
            const response = await this._request(`/dns/records/${domain}`, {
                method: "GET",
                methodName: "getDnsRecord"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to get DNS record: ${error.message}`, {
                cause: error
            });
        }
    }
    async getCustomHost(hostname) {
        this._requireReady("getCustomHost");
        if (!hostname) throw new Error("Hostname is required");
        try {
            const response = await this._request(`/dns/custom-hosts/${encodeURIComponent(hostname)}`, {
                method: "GET",
                methodName: "getCustomHost"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to get custom host: ${error.message}`, {
                cause: error
            });
        }
    }
    async removeDnsRecord(domain) {
        this._requireReady("removeDnsRecord");
        if (!domain) throw new Error("Domain is required");
        try {
            const response = await this._request(`/dns/records/${domain}`, {
                method: "DELETE",
                methodName: "removeDnsRecord"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to remove DNS record: ${error.message}`, {
                cause: error
            });
        }
    }
    // customDomains could be a string or an array of strings
    async addProjectCustomDomains(projectId, customDomains, options = {}) {
        this._requireReady("addProjectCustomDomains");
        if (!projectId) throw new Error("Project ID is required");
        if (!customDomains || Array.isArray(customDomains) && !customDomains.length) throw new Error("customDomains is required and must be a non-empty string or array");
        const { envKey: envKey, headers: headers } = options;
        try {
            const response = await this._request(`/projects/${projectId}/domains`, {
                method: "PATCH",
                body: JSON.stringify({
                    customDomains: customDomains,
                    ...envKey ? {
                        envKey: envKey
                    } : {}
                }),
                ...headers ? {
                    headers: headers
                } : {},
                methodName: "addProjectCustomDomains"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to update project custom domains: ${error.message}`, {
                cause: error
            });
        }
    }
    // ==================== DNS HELPER METHODS ====================
    /**
   * Helper method to validate domain format
   */ validateDomain(domain) {
        if (!domain || typeof domain !== "string") return {
            isValid: false,
            error: "Domain must be a non-empty string"
        };
        const domainRegex = /^[a-zA-Z0-9](?:(?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)?(?:\.[a-zA-Z0-9](?:(?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)?)*$/u;
        if (!domainRegex.test(domain)) return {
            isValid: false,
            error: "Invalid domain format"
        };
        const tldRegex = /\.[a-zA-Z]{2,}$/u;
        if (!tldRegex.test(domain)) return {
            isValid: false,
            error: "Domain must have a valid top-level domain"
        };
        return {
            isValid: true,
            error: null
        };
    }
    /**
   * Helper method to create DNS record with validation
   */ async createDnsRecordWithValidation(domain, options = {}) {
        const validation = this.validateDomain(domain);
        if (!validation.isValid) throw new Error(validation.error);
        return await this.createDnsRecord(domain, options);
    }
    /**
   * Helper method to get DNS record with validation
   */ async getDnsRecordWithValidation(domain) {
        const validation = this.validateDomain(domain);
        if (!validation.isValid) throw new Error(validation.error);
        return await this.getDnsRecord(domain);
    }
    /**
   * Helper method to remove DNS record with validation
   */ async removeDnsRecordWithValidation(domain) {
        const validation = this.validateDomain(domain);
        if (!validation.isValid) throw new Error(validation.error);
        return await this.removeDnsRecord(domain);
    }
    /**
   * Helper method to add project custom domains with validation
   */ async addProjectCustomDomainsWithValidation(projectId, customDomains, options = {}) {
        if (!projectId || typeof projectId !== "string") throw new Error("Project ID must be a valid string");
        if (!customDomains) throw new Error("Custom domains are required");
        const domainsArray = Array.isArray(customDomains) ? customDomains : [
            customDomains
        ];
        if (domainsArray.length === 0) throw new Error("At least one custom domain is required");
        for (const domain of domainsArray){
            const validation = this.validateDomain(domain);
            if (!validation.isValid) throw new Error(`Invalid domain '${domain}': ${validation.error}`);
        }
        return await this.addProjectCustomDomains(projectId, customDomains, options);
    }
    /**
   * Helper method to check if domain is available
   */ async isDomainAvailable(domain) {
        try {
            await this.getDnsRecord(domain);
            return false;
        } catch (error) {
            if (error.message.includes("not found") || error.message.includes("404")) return true;
            throw error;
        }
    }
    /**
   * Helper method to get domain status
   */ async getDomainStatus(domain) {
        try {
            const record = await this.getDnsRecord(domain);
            return {
                exists: true,
                active: record.active || false,
                verified: record.verified || false,
                record: record
            };
        } catch (error) {
            if (error.message.includes("not found") || error.message.includes("404")) return {
                exists: false,
                active: false,
                verified: false,
                error: "Domain not found"
            };
            throw error;
        }
    }
    /**
   * Helper method to verify domain ownership
   */ async verifyDomainOwnership(domain) {
        try {
            const record = await this.getDnsRecord(domain);
            if (!record.verified) return {
                verified: false,
                needsVerification: true,
                verificationMethod: record.verificationMethod || "dns",
                verificationRecord: record.verificationRecord
            };
            return {
                verified: true,
                needsVerification: false
            };
        } catch (error) {
            throw new Error(`Failed to verify domain ownership: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Helper method to get project domains
   */ async getProjectDomains(projectId) {
        this._requireReady("getProjectDomains");
        if (!projectId) throw new Error("Project ID is required");
        try {
            const response = await this._request(`/projects/${projectId}/domains`, {
                method: "GET",
                methodName: "getProjectDomains"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to get project domains: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Helper method to remove project custom domain
   */ async removeProjectCustomDomain(projectId, domain) {
        this._requireReady("removeProjectCustomDomain");
        if (!projectId) throw new Error("Project ID is required");
        if (!domain) throw new Error("Domain is required");
        try {
            const response = await this._request(`/projects/${projectId}/domains/${encodeURIComponent(domain)}`, {
                method: "DELETE",
                methodName: "removeProjectCustomDomain"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to remove project custom domain: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Helper method to format domain for display
   */ formatDomain(domain) {
        if (!domain) return "";
        const cleanDomain = domain.replace(/^https?:\/\//u, "");
        return cleanDomain.replace(/\/$/u, "");
    }
    /**
   * Helper method to extract domain from URL
   */ extractDomainFromUrl(url2) {
        try {
            const urlObj = new URL(url2);
            return urlObj.hostname;
        } catch  {
            return null;
        }
    }
};
// src/services/BranchService.js
var $281a441cdcb2cf36$var$BranchService = class extends $281a441cdcb2cf36$var$BaseService {
    // ==================== BRANCH MANAGEMENT METHODS ====================
    /**
   * Get all branches for a project
   */ async listBranches(projectId) {
        this._requireReady("listBranches");
        if (!projectId) throw new Error("Project ID is required");
        try {
            const response = await this._request(`/projects/${projectId}/branches`, {
                method: "GET",
                methodName: "listBranches"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to list branches: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Create a new branch from an existing branch
   */ async createBranch(projectId, branchData) {
        this._requireReady("createBranch");
        if (!projectId) throw new Error("Project ID is required");
        if (!branchData.name) throw new Error("Branch name is required");
        const { name: name, source: source = "main" } = branchData;
        try {
            const response = await this._request(`/projects/${projectId}/branches`, {
                method: "POST",
                body: JSON.stringify({
                    name: name,
                    source: source
                }),
                methodName: "createBranch"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to create branch: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Delete a branch (cannot delete main branch)
   */ async deleteBranch(projectId, branchName) {
        this._requireReady("deleteBranch");
        if (!projectId) throw new Error("Project ID is required");
        if (!branchName) throw new Error("Branch name is required");
        if (branchName === "main") throw new Error("Cannot delete main branch");
        try {
            const response = await this._request(`/projects/${projectId}/branches/${encodeURIComponent(branchName)}`, {
                method: "DELETE",
                methodName: "deleteBranch"
            });
            if (response.success) return response;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to delete branch: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Rename a branch (cannot rename main branch)
   */ async renameBranch(projectId, branchName, newName) {
        this._requireReady("renameBranch");
        if (!projectId) throw new Error("Project ID is required");
        if (!branchName) throw new Error("Current branch name is required");
        if (!newName) throw new Error("New branch name is required");
        if (branchName === "main") throw new Error("Cannot rename main branch");
        try {
            const response = await this._request(`/projects/${projectId}/branches/${encodeURIComponent(branchName)}/rename`, {
                method: "POST",
                body: JSON.stringify({
                    newName: newName
                }),
                methodName: "renameBranch"
            });
            if (response.success) return response;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to rename branch: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Get changes/diff for a branch compared to another version
   */ async getBranchChanges(projectId, branchName = "main", options = {}) {
        this._requireReady("getBranchChanges");
        if (!projectId) throw new Error("Project ID is required");
        if (!branchName) throw new Error("Branch name is required");
        const { versionId: versionId, versionValue: versionValue, target: target } = options;
        const queryParams = new URLSearchParams();
        if (versionId) queryParams.append("versionId", versionId);
        if (versionValue) queryParams.append("versionValue", versionValue);
        if (target) queryParams.append("target", target);
        const queryString = queryParams.toString();
        try {
            const response = queryString ? await this._request(`/projects/${projectId}/branches/${encodeURIComponent(branchName)}/changes?${queryString}`, {
                method: "GET",
                methodName: "getBranchChanges"
            }) : await this._request(`/projects/${projectId}/branches/${encodeURIComponent(branchName)}/changes`, {
                method: "GET",
                methodName: "getBranchChanges"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to get branch changes: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Merge changes between branches (preview or commit)
   */ async mergeBranch(projectId, branchName, mergeData = {}) {
        this._requireReady("mergeBranch");
        if (!projectId) throw new Error("Project ID is required");
        if (!branchName) throw new Error("Source branch name is required");
        const { target: target = "main", message: message, type: type = "patch", commit: commit = false, changes: changes } = mergeData;
        const requestBody = {
            target: target,
            type: type,
            commit: commit,
            ...message && {
                message: message
            },
            ...changes && {
                changes: changes
            }
        };
        try {
            const response = await this._request(`/projects/${projectId}/branches/${encodeURIComponent(branchName)}/merge`, {
                method: "POST",
                body: JSON.stringify(requestBody),
                methodName: "mergeBranch"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            if (error.message.includes("conflicts") || error.message.includes("409")) throw new Error(`Merge conflicts detected: ${error.message}`, {
                cause: error
            });
            throw new Error(`Failed to merge branch: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Reset a branch to a clean state
   */ async resetBranch(projectId, branchName) {
        this._requireReady("resetBranch");
        if (!projectId) throw new Error("Project ID is required");
        if (!branchName) throw new Error("Branch name is required");
        try {
            const response = await this._request(`/projects/${projectId}/branches/${encodeURIComponent(branchName)}/reset`, {
                method: "POST",
                methodName: "resetBranch"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to reset branch: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Publish a specific version as the live version
   */ async publishVersion(projectId, publishData) {
        this._requireReady("publishVersion");
        if (!projectId) throw new Error("Project ID is required");
        if (!publishData.version) throw new Error("Version is required");
        const { version: version6, branch: branch = "main" } = publishData;
        try {
            const response = await this._request(`/projects/${projectId}/publish`, {
                method: "POST",
                body: JSON.stringify({
                    version: version6,
                    branch: branch
                }),
                methodName: "publishVersion"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to publish version: ${error.message}`, {
                cause: error
            });
        }
    }
    // ==================== BRANCH HELPER METHODS ====================
    /**
   * Helper method to create a branch with validation
   */ async createBranchWithValidation(projectId, name, source = "main") {
        if (!name || name.trim().length === 0) throw new Error("Branch name cannot be empty");
        if (name.includes(" ")) throw new Error("Branch name cannot contain spaces");
        if (name === "main") throw new Error('Cannot create a branch named "main"');
        const sanitizedName = name.trim().toLowerCase().replace(/[^a-z0-9-_]/gu, "-");
        return await this.createBranch(projectId, {
            name: sanitizedName,
            source: source
        });
    }
    /**
   * Helper method to check if a branch exists
   */ async branchExists(projectId, branchName) {
        var _a2;
        try {
            const branches = await this.listBranches(projectId);
            return ((_a2 = branches == null ? void 0 : branches.data) == null ? void 0 : _a2.includes(branchName)) || false;
        } catch (error) {
            throw new Error(`Failed to check if branch exists: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Helper method to preview merge without committing
   */ async previewMerge(projectId, sourceBranch, targetBranch = "main") {
        return await this.mergeBranch(projectId, sourceBranch, {
            target: targetBranch,
            commit: false
        });
    }
    /**
   * Helper method to commit merge after preview
   */ async commitMerge(projectId, sourceBranch, options = {}) {
        const { target: target = "main", message: message = `Merge ${sourceBranch} into ${target}`, type: type = "patch", changes: changes } = options;
        return await this.mergeBranch(projectId, sourceBranch, {
            target: target,
            message: message,
            type: type,
            commit: true,
            changes: changes
        });
    }
    /**
   * Helper method to create a feature branch from main
   */ async createFeatureBranch(projectId, featureName) {
        const branchName = `feature/${featureName.toLowerCase().replace(/[^a-z0-9-]/gu, "-")}`;
        return await this.createBranch(projectId, {
            name: branchName,
            source: "main"
        });
    }
    /**
   * Helper method to create a hotfix branch from main
   */ async createHotfixBranch(projectId, hotfixName) {
        const branchName = `hotfix/${hotfixName.toLowerCase().replace(/[^a-z0-9-]/gu, "-")}`;
        return await this.createBranch(projectId, {
            name: branchName,
            source: "main"
        });
    }
    /**
   * Helper method to get branch status summary
   */ async getBranchStatus(projectId, branchName) {
        var _a2, _b, _c;
        try {
            const [branches, changes] = await Promise.all([
                this.listBranches(projectId),
                this.getBranchChanges(projectId, branchName).catch(()=>null)
            ]);
            const exists = ((_a2 = branches == null ? void 0 : branches.data) == null ? void 0 : _a2.includes(branchName)) || false;
            const hasChanges = ((_b = changes == null ? void 0 : changes.data) == null ? void 0 : _b.length) > 0;
            return {
                exists: exists,
                hasChanges: hasChanges,
                changeCount: ((_c = changes == null ? void 0 : changes.data) == null ? void 0 : _c.length) || 0,
                canDelete: exists && branchName !== "main",
                canRename: exists && branchName !== "main"
            };
        } catch (error) {
            throw new Error(`Failed to get branch status: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Helper method to safely delete a branch with confirmation
   */ async deleteBranchSafely(projectId, branchName, options = {}) {
        const { force: force = false } = options;
        if (!force) {
            const status = await this.getBranchStatus(projectId, branchName);
            if (!status.exists) throw new Error(`Branch '${branchName}' does not exist`);
            if (!status.canDelete) throw new Error(`Branch '${branchName}' cannot be deleted`);
            if (status.hasChanges) throw new Error(`Branch '${branchName}' has uncommitted changes. Use force option to delete anyway.`);
        }
        return await this.deleteBranch(projectId, branchName);
    }
    /**
   * Helper method to get all branches with their status
   */ async getBranchesWithStatus(projectId) {
        try {
            const branches = await this.listBranches(projectId);
            const branchList = (branches == null ? void 0 : branches.data) || [];
            const branchStatuses = await Promise.all(branchList.map(async (branchName)=>{
                try {
                    const status = await this.getBranchStatus(projectId, branchName);
                    return {
                        name: branchName,
                        ...status
                    };
                } catch (error) {
                    return {
                        name: branchName,
                        exists: true,
                        hasChanges: false,
                        changeCount: 0,
                        canDelete: branchName !== "main",
                        canRename: branchName !== "main",
                        error: error.message
                    };
                }
            }));
            return branchStatuses;
        } catch (error) {
            throw new Error(`Failed to get branches with status: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Helper method to validate branch name
   */ validateBranchName(branchName) {
        if (!branchName || typeof branchName !== "string") return {
            isValid: false,
            error: "Branch name must be a non-empty string"
        };
        if (branchName.trim().length === 0) return {
            isValid: false,
            error: "Branch name cannot be empty"
        };
        if (branchName.includes(" ")) return {
            isValid: false,
            error: "Branch name cannot contain spaces"
        };
        if (branchName === "main") return {
            isValid: false,
            error: 'Cannot use "main" as a branch name'
        };
        if (!/^[a-zA-Z0-9-_]+$/u.test(branchName)) return {
            isValid: false,
            error: "Branch name can only contain letters, numbers, hyphens, and underscores"
        };
        return {
            isValid: true,
            error: null
        };
    }
    /**
   * Helper method to sanitize branch name
   */ sanitizeBranchName(branchName) {
        if (!branchName) return "";
        return branchName.trim().toLowerCase().replace(/[^a-z0-9-_]/gu, "-").replace(/-+/gu, "-").replace(/^-|-$/gu, "");
    }
};
// src/services/PullRequestService.js
var $281a441cdcb2cf36$var$PullRequestService = class extends $281a441cdcb2cf36$var$BaseService {
    // ==================== PULL REQUEST METHODS ====================
    /**
   * Create a new pull request
   */ async createPullRequest(projectId, pullRequestData) {
        this._requireReady("createPullRequest");
        if (!projectId) throw new Error("Project ID is required");
        if (!pullRequestData.source || !pullRequestData.target || !pullRequestData.title) throw new Error("Source branch, target branch, and title are required");
        try {
            const response = await this._request(`/projects/${projectId}/pull-requests`, {
                method: "POST",
                body: JSON.stringify(pullRequestData),
                methodName: "createPullRequest"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to create pull request: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * List pull requests for a project with filtering options
   */ async listPullRequests(projectId, options = {}) {
        this._requireReady("listPullRequests");
        if (!projectId) throw new Error("Project ID is required");
        const { status: status = "open", source: source, target: target, page: page = 1, limit: limit = 20 } = options;
        const queryParams = new URLSearchParams({
            status: status,
            page: page.toString(),
            limit: limit.toString()
        });
        if (source) queryParams.append("source", source);
        if (target) queryParams.append("target", target);
        try {
            const response = await this._request(`/projects/${projectId}/pull-requests?${queryParams.toString()}`, {
                method: "GET",
                methodName: "listPullRequests"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to list pull requests: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Get detailed information about a specific pull request
   */ async getPullRequest(projectId, prId) {
        this._requireReady("getPullRequest");
        if (!projectId) throw new Error("Project ID is required");
        if (!prId) throw new Error("Pull request ID is required");
        try {
            const response = await this._request(`/projects/${projectId}/pull-requests/${prId}`, {
                method: "GET",
                methodName: "getPullRequest"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to get pull request: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Submit a review for a pull request
   */ async reviewPullRequest(projectId, prId, reviewData) {
        this._requireReady("reviewPullRequest");
        if (!projectId) throw new Error("Project ID is required");
        if (!prId) throw new Error("Pull request ID is required");
        const validStatuses = [
            "approved",
            "requested_changes",
            "feedback"
        ];
        if (reviewData.status && !validStatuses.includes(reviewData.status)) throw new Error(`Invalid review status. Must be one of: ${validStatuses.join(", ")}`);
        try {
            const response = await this._request(`/projects/${projectId}/pull-requests/${prId}/review`, {
                method: "POST",
                body: JSON.stringify(reviewData),
                methodName: "reviewPullRequest"
            });
            if (response.success) return response;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to review pull request: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Add a comment to an existing review thread
   */ async addPullRequestComment(projectId, prId, commentData) {
        this._requireReady("addPullRequestComment");
        if (!projectId) throw new Error("Project ID is required");
        if (!prId) throw new Error("Pull request ID is required");
        if (!commentData.value) throw new Error("Comment value is required");
        try {
            const response = await this._request(`/projects/${projectId}/pull-requests/${prId}/comment`, {
                method: "POST",
                body: JSON.stringify(commentData),
                methodName: "addPullRequestComment"
            });
            if (response.success) return response;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to add pull request comment: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Merge an approved pull request
   */ async mergePullRequest(projectId, prId) {
        this._requireReady("mergePullRequest");
        if (!projectId) throw new Error("Project ID is required");
        if (!prId) throw new Error("Pull request ID is required");
        try {
            const response = await this._request(`/projects/${projectId}/pull-requests/${prId}/merge`, {
                method: "POST",
                methodName: "mergePullRequest"
            });
            if (response.success) return response;
            throw new Error(response.message);
        } catch (error) {
            if (error.message.includes("conflicts") || error.message.includes("409")) throw new Error(`Pull request has merge conflicts: ${error.message}`, {
                cause: error
            });
            throw new Error(`Failed to merge pull request: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Get the diff/changes for a pull request
   */ async getPullRequestDiff(projectId, prId) {
        this._requireReady("getPullRequestDiff");
        if (!projectId) throw new Error("Project ID is required");
        if (!prId) throw new Error("Pull request ID is required");
        try {
            const response = await this._request(`/projects/${projectId}/pull-requests/${prId}/diff`, {
                method: "GET",
                methodName: "getPullRequestDiff"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to get pull request diff: ${error.message}`, {
                cause: error
            });
        }
    }
    // ==================== PULL REQUEST HELPER METHODS ====================
    /**
   * Helper method to create a pull request with validation
   */ async createPullRequestWithValidation(projectId, data2) {
        const { source: source, target: target, title: title, description: description, changes: changes } = data2;
        if (source === target) throw new Error("Source and target branches cannot be the same");
        if (!title || title.trim().length === 0) throw new Error("Pull request title cannot be empty");
        if (title.length > 200) throw new Error("Pull request title cannot exceed 200 characters");
        const pullRequestData = {
            source: source.trim(),
            target: target.trim(),
            title: title.trim(),
            ...description && {
                description: description.trim()
            },
            ...changes && {
                changes: changes
            }
        };
        return await this.createPullRequest(projectId, pullRequestData);
    }
    /**
   * Helper method to approve a pull request
   */ async approvePullRequest(projectId, prId, comment = "") {
        const reviewData = {
            status: "approved",
            ...comment && {
                threads: [
                    {
                        comment: comment,
                        type: "praise"
                    }
                ]
            }
        };
        return await this.reviewPullRequest(projectId, prId, reviewData);
    }
    /**
   * Helper method to request changes on a pull request
   */ async requestPullRequestChanges(projectId, prId, threads = []) {
        if (!threads || threads.length === 0) throw new Error("Must provide specific feedback when requesting changes");
        const reviewData = {
            status: "requested_changes",
            threads: threads
        };
        return await this.reviewPullRequest(projectId, prId, reviewData);
    }
    /**
   * Helper method to get pull requests by status
   */ async getOpenPullRequests(projectId, options = {}) {
        return await this.listPullRequests(projectId, {
            ...options,
            status: "open"
        });
    }
    async getClosedPullRequests(projectId, options = {}) {
        return await this.listPullRequests(projectId, {
            ...options,
            status: "closed"
        });
    }
    async getMergedPullRequests(projectId, options = {}) {
        return await this.listPullRequests(projectId, {
            ...options,
            status: "merged"
        });
    }
    /**
   * Helper method to check if a pull request is canMerge
   */ async isPullRequestMergeable(projectId, prId) {
        var _a2;
        try {
            const prData = await this.getPullRequest(projectId, prId);
            return ((_a2 = prData == null ? void 0 : prData.data) == null ? void 0 : _a2.canMerge) || false;
        } catch (error) {
            throw new Error(`Failed to check pull request mergeability: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Helper method to get pull request status summary
   */ async getPullRequestStatusSummary(projectId, prId) {
        var _a2, _b, _c;
        try {
            const prData = await this.getPullRequest(projectId, prId);
            const pr = prData == null ? void 0 : prData.data;
            if (!pr) throw new Error("Pull request not found");
            return {
                status: pr.status,
                reviewStatus: pr.reviewStatus,
                canMerge: pr.canMerge,
                hasConflicts: !pr.canMerge,
                reviewCount: ((_a2 = pr.reviews) == null ? void 0 : _a2.length) || 0,
                approvedReviews: ((_b = pr.reviews) == null ? void 0 : _b.filter((r3)=>r3.status === "approved").length) || 0,
                changesRequested: ((_c = pr.reviews) == null ? void 0 : _c.filter((r3)=>r3.status === "requested_changes").length) || 0
            };
        } catch (error) {
            throw new Error(`Failed to get pull request status summary: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Helper method to validate pull request data
   */ validatePullRequestData(data2) {
        const errors = [];
        if (!data2.source || typeof data2.source !== "string") errors.push("Source branch is required and must be a string");
        if (!data2.target || typeof data2.target !== "string") errors.push("Target branch is required and must be a string");
        if (data2.source === data2.target) errors.push("Source and target branches cannot be the same");
        if (!data2.title || typeof data2.title !== "string") errors.push("Title is required and must be a string");
        else if (data2.title.trim().length === 0) errors.push("Title cannot be empty");
        else if (data2.title.length > 200) errors.push("Title cannot exceed 200 characters");
        if (data2.description && typeof data2.description !== "string") errors.push("Description must be a string");
        return {
            isValid: errors.length === 0,
            errors: errors
        };
    }
    /**
   * Helper method to validate review data
   */ validateReviewData(reviewData) {
        const errors = [];
        const validStatuses = [
            "approved",
            "requested_changes",
            "feedback"
        ];
        if (reviewData.status && !validStatuses.includes(reviewData.status)) errors.push(`Invalid review status. Must be one of: ${validStatuses.join(", ")}`);
        if (reviewData.threads && !Array.isArray(reviewData.threads)) errors.push("Threads must be an array");
        if (reviewData.threads) reviewData.threads.forEach((thread, index)=>{
            if (!thread.comment || typeof thread.comment !== "string") errors.push(`Thread ${index + 1}: Comment is required and must be a string`);
            if (thread.type && ![
                "praise",
                "issue",
                "suggestion"
            ].includes(thread.type)) errors.push(`Thread ${index + 1}: Invalid thread type`);
        });
        return {
            isValid: errors.length === 0,
            errors: errors
        };
    }
    /**
   * Helper method to get pull request statistics
   */ async getPullRequestStats(projectId, options = {}) {
        try {
            const { status: status = "open" } = options;
            const pullRequests = await this.listPullRequests(projectId, {
                status: status
            });
            const stats = {
                total: pullRequests.length,
                open: 0,
                closed: 0,
                merged: 0,
                withConflicts: 0,
                readyToMerge: 0
            };
            pullRequests.forEach((pr)=>{
                if (pr.status === "open") stats.open++;
                if (pr.status === "closed") stats.closed++;
                if (pr.status === "merged") stats.merged++;
                if (pr.hasConflicts) stats.withConflicts++;
                if (pr.canMerge) stats.readyToMerge++;
            });
            return stats;
        } catch (error) {
            throw new Error(`Failed to get pull request stats: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Helper method to close a pull request
   */ async closePullRequest(projectId, prId) {
        this._requireReady("closePullRequest");
        if (!projectId) throw new Error("Project ID is required");
        if (!prId) throw new Error("Pull request ID is required");
        try {
            const response = await this._request(`/projects/${projectId}/pull-requests/${prId}/close`, {
                method: "POST",
                methodName: "closePullRequest"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to close pull request: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Helper method to reopen a closed pull request
   */ async reopenPullRequest(projectId, prId) {
        this._requireReady("reopenPullRequest");
        if (!projectId) throw new Error("Project ID is required");
        if (!prId) throw new Error("Pull request ID is required");
        try {
            const response = await this._request(`/projects/${projectId}/pull-requests/${prId}/reopen`, {
                method: "POST",
                methodName: "reopenPullRequest"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to reopen pull request: ${error.message}`, {
                cause: error
            });
        }
    }
};
// src/services/AdminService.js
var $281a441cdcb2cf36$var$AdminService = class extends $281a441cdcb2cf36$var$BaseService {
    // ==================== ADMIN METHODS ====================
    /**
   * Get admin users list with comprehensive filtering and search capabilities
   * Requires admin or super_admin global role
   */ async getAdminUsers(params2 = {}) {
        this._requireReady("getAdminUsers");
        const { emails: emails, ids: ids, query: query, status: status, team: team, page: page = 1, limit: limit = 50, sort: sort = {
            field: "createdAt",
            order: "desc"
        } } = params2;
        const queryParams = new URLSearchParams();
        if (emails) queryParams.append("emails", emails);
        if (ids) queryParams.append("ids", ids);
        if (query) queryParams.append("query", query);
        if (status) queryParams.append("status", status);
        if (page) queryParams.append("page", page.toString());
        if (limit) queryParams.append("limit", limit.toString());
        if (sort && sort.field) {
            queryParams.append("sort[field]", sort.field);
            queryParams.append("sort[order]", sort.order || "desc");
        }
        if (team != null) queryParams.append("team", team);
        const queryString = queryParams.toString();
        try {
            const response = queryString ? await this._request(`/users/admin/users?${queryString}`, {
                method: "GET",
                methodName: "getAdminUsers"
            }) : await this._request("/users/admin/users", {
                method: "GET",
                methodName: "getAdminUsers"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to get admin users: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Assign projects to a specific user
   * Requires admin or super_admin global role
   */ async assignProjectsToUser(userId, options = {}) {
        this._requireReady("assignProjectsToUser");
        if (!userId) throw new Error("User ID is required");
        const { projectIds: projectIds, role: role = "guest" } = options;
        const requestBody = {
            userId: userId,
            role: role
        };
        if (projectIds && Array.isArray(projectIds)) requestBody.projectIds = projectIds;
        try {
            const response = await this._request("/users/assign-projects", {
                method: "POST",
                body: JSON.stringify(requestBody),
                methodName: "assignProjectsToUser"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to assign projects to user: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Update user information (admin only)
   */ async updateUser(userId, userData) {
        var _a2;
        this._requireReady("updateUser");
        if (!userId) throw new Error("User ID is required");
        if (!userData || typeof userData !== "object" || Object.keys(userData).length === 0) throw new Error("userData must be a non-empty object");
        try {
            const response = await this._request(`/users/${userId}`, {
                method: "PATCH",
                body: JSON.stringify(userData),
                methodName: "updateUser"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            if ((_a2 = error.message) == null ? void 0 : _a2.includes("Duplicate")) throw new Error("Username already exists");
            throw new Error(`Failed to update user: ${error.message}`, {
                cause: error
            });
        }
    }
    // ==================== ADMIN HELPER METHODS ====================
    /**
   * Helper method for admin users search
   */ async searchAdminUsers(searchQuery, options = {}) {
        return await this.getAdminUsers({
            query: searchQuery,
            ...options
        });
    }
    /**
   * Helper method to get admin users by email list
   */ async getAdminUsersByEmails(emails, options = {}) {
        const emailList = Array.isArray(emails) ? emails.join(",") : emails;
        return await this.getAdminUsers({
            emails: emailList,
            ...options
        });
    }
    /**
   * Helper method to get admin users by ID list
   */ async getAdminUsersByIds(ids, options = {}) {
        const idList = Array.isArray(ids) ? ids.join(",") : ids;
        return await this.getAdminUsers({
            ids: idList,
            ...options
        });
    }
    /**
   * Helper method to assign specific projects to a user with a specific role
   */ async assignSpecificProjectsToUser(userId, projectIds, role = "guest") {
        if (!Array.isArray(projectIds) || projectIds.length === 0) throw new Error("Project IDs must be a non-empty array");
        return await this.assignProjectsToUser(userId, {
            projectIds: projectIds,
            role: role
        });
    }
    /**
   * Helper method to assign all projects to a user with a specific role
   */ async assignAllProjectsToUser(userId, role = "guest") {
        return await this.assignProjectsToUser(userId, {
            role: role
        });
    }
    /**
   * Helper method to validate user data for updates
   */ validateUserData(userData) {
        const errors = [];
        if (!userData || typeof userData !== "object") {
            errors.push("User data must be an object");
            return {
                isValid: false,
                errors: errors
            };
        }
        if (userData.email && typeof userData.email !== "string") errors.push("Email must be a string");
        else if (userData.email && !this._isValidEmail(userData.email)) errors.push("Email must be a valid email address");
        if (userData.username && typeof userData.username !== "string") errors.push("Username must be a string");
        else if (userData.username && userData.username.length < 3) errors.push("Username must be at least 3 characters long");
        if (userData.role && ![
            "admin",
            "user",
            "guest"
        ].includes(userData.role)) errors.push("Role must be one of: admin, user, guest");
        if (userData.status && ![
            "active",
            "inactive",
            "suspended"
        ].includes(userData.status)) errors.push("Status must be one of: active, inactive, suspended");
        return {
            isValid: errors.length === 0,
            errors: errors
        };
    }
    /**
   * Helper method to update user with validation
   */ async updateUserWithValidation(userId, userData) {
        const validation = this.validateUserData(userData);
        if (!validation.isValid) throw new Error(`Validation failed: ${validation.errors.join(", ")}`);
        return await this.updateUser(userId, userData);
    }
    /**
   * Helper method to get user statistics
   */ async getUserStats() {
        try {
            const users = await this.getAdminUsers({
                limit: 1e3
            });
            const stats = {
                total: users.length,
                active: 0,
                inactive: 0,
                suspended: 0,
                admins: 0,
                users: 0,
                guests: 0
            };
            users.forEach((user)=>{
                if (user.status === "active") stats.active++;
                if (user.status === "inactive") stats.inactive++;
                if (user.status === "suspended") stats.suspended++;
                if (user.role === "admin") stats.admins++;
                if (user.role === "user") stats.users++;
                if (user.role === "guest") stats.guests++;
            });
            return stats;
        } catch (error) {
            throw new Error(`Failed to get user stats: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Helper method to bulk update users
   */ async bulkUpdateUsers(userUpdates) {
        if (!Array.isArray(userUpdates) || userUpdates.length === 0) throw new Error("User updates must be a non-empty array");
        const updatePromises = userUpdates.map(async (update)=>{
            try {
                const result = await this.updateUser(update.userId, update.userData);
                return {
                    userId: update.userId,
                    success: true,
                    data: result
                };
            } catch (error) {
                return {
                    userId: update.userId,
                    success: false,
                    error: error.message
                };
            }
        });
        const results = await Promise.all(updatePromises);
        return {
            total: results.length,
            successful: results.filter((r3)=>r3.success).length,
            failed: results.filter((r3)=>!r3.success).length,
            results: results
        };
    }
    /**
   * Helper method to get users by role
   */ async getUsersByRole(role, options = {}) {
        const users = await this.getAdminUsers(options);
        return users.filter((user)=>user.role === role);
    }
    /**
   * Helper method to get users by status
   */ async getUsersByStatus(status, options = {}) {
        const users = await this.getAdminUsers(options);
        return users.filter((user)=>user.status === status);
    }
    /**
   * Helper method to activate a user
   */ async activateUser(userId) {
        return await this.updateUser(userId, {
            status: "active"
        });
    }
    /**
   * Helper method to deactivate a user
   */ async deactivateUser(userId) {
        return await this.updateUser(userId, {
            status: "inactive"
        });
    }
    /**
   * Helper method to suspend a user
   */ async suspendUser(userId) {
        return await this.updateUser(userId, {
            status: "suspended"
        });
    }
    /**
   * Helper method to promote user to admin
   */ async promoteToAdmin(userId) {
        return await this.updateUser(userId, {
            role: "admin"
        });
    }
    /**
   * Helper method to demote user from admin
   */ async demoteFromAdmin(userId) {
        return await this.updateUser(userId, {
            role: "user"
        });
    }
    /**
   * Get rate-limit stats (admin-only). Exposes the middleware's current
   * per-user/per-IP counters for ops debugging.
   */ async getRateLimitStats() {
        this._requireReady("getRateLimitStats");
        try {
            const response = await this._request("/users/admin/rate-limit-stats", {
                method: "GET",
                methodName: "getRateLimitStats"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to get rate limit stats: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Get Project.key migration health (admin-only). Surfaces bare vs
   * compound vs suffixed counts, missing-owner-FK count, and any
   * duplicate `(owner, key)` tuples (should be 0 post-§46).
   */ async getProjectKeyStats() {
        this._requireReady("getProjectKeyStats");
        const response = await this._request("/users/admin/project-key-stats", {
            method: "GET",
            methodName: "getProjectKeyStats"
        });
        if (response.success) return response.data;
        throw new Error(response.message || "Failed to get project key stats");
    }
    /**
   * Private helper to validate email format
   */ _isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/u;
        return emailRegex.test(email);
    }
};
// src/services/ScreenshotService.js
var $281a441cdcb2cf36$var$ScreenshotService = class extends $281a441cdcb2cf36$var$BaseService {
    constructor(config){
        super(config);
        this._debounceTimers = /* @__PURE__ */ new Map();
        this._inflightRefreshes = /* @__PURE__ */ new Map();
    }
    // ==================== PROJECT-LEVEL OPERATIONS ====================
    async createScreenshotProject(payload) {
        this._requireReady("createScreenshotProject");
        try {
            const response = await this._request("/screenshots/projects", {
                method: "POST",
                body: JSON.stringify(payload),
                methodName: "createScreenshotProject"
            });
            if (response.success) return response;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to create screenshot project: ${error.message}`, {
                cause: error
            });
        }
    }
    async getProjectScreenshots(projectKey, params2 = {}) {
        this._requireReady("getProjectScreenshots");
        if (!projectKey) throw new Error("projectKey is required");
        const { type: type = "all", status: status, limit: limit = 50, offset: offset2 = 0 } = params2;
        const qs = new URLSearchParams();
        if (type) qs.set("type", type);
        if (status) qs.set("status", status);
        if (limit != null) qs.set("limit", String(limit));
        if (offset2 != null) qs.set("offset", String(offset2));
        try {
            const response = await this._request(`/screenshots/projects/${$281a441cdcb2cf36$var$projectKeyPath(projectKey)}${qs.toString() ? `?${qs.toString()}` : ""}`, {
                method: "GET",
                methodName: "getProjectScreenshots"
            });
            if (response.success) return response;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to get project screenshots: ${error.message}`, {
                cause: error
            });
        }
    }
    async reprocessProjectScreenshots(projectKey, body = {}) {
        this._requireReady("reprocessProjectScreenshots");
        if (!projectKey) throw new Error("projectKey is required");
        try {
            const response = await this._request(`/screenshots/projects/${$281a441cdcb2cf36$var$projectKeyPath(projectKey)}/reprocess`, {
                method: "POST",
                body: JSON.stringify(body),
                methodName: "reprocessProjectScreenshots"
            });
            if (response.success) return response;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to reprocess screenshots: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Recreate screenshots for a project. Smart delta by default; pass
   * `force: true` to re-render everything. Server-side this enqueues via
   * BullMQ so the call returns as soon as jobs are queued.
   *
   * Body fields:
   *   - `environment`: 'development' | 'staging' | 'production' (default production).
   *     Screenshots are captured per-environment — dev/staging/prod don't
   *     overwrite each other. Only `production` updates `project.thumbnail`.
   *   - `process_pages` / `process_components` / `process_descriptions`: booleans
   *   - `force`: boolean — bypass the delta check
   *   - `priority`: number (default 5)
   *   - `only_one` + `page_path` | `page_key` | `component_key` | `screenshot_id`: target a single shot
   *   - `prefer`: 'auto' | 'page' | 'component'
   *
   * Note: normal editor saves + publishes already auto-trigger a 15-min
   * debounced refresh via the server's `scheduleDebouncedRefresh` hook
   * (dev on save, stag/prod on publish). Only call this directly when you
   * need an immediate capture or a force-all refresh.
   */ async recreateProjectScreenshots(projectKey, body = {}) {
        this._requireReady("recreateProjectScreenshots");
        if (!projectKey) throw new Error("projectKey is required");
        try {
            const response = await this._request(`/screenshots/projects/${$281a441cdcb2cf36$var$projectKeyPath(projectKey)}/recreate`, {
                method: "POST",
                body: JSON.stringify(body),
                methodName: "recreateProjectScreenshots"
            });
            if (response.success) return response;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to recreate screenshots: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Convenience wrapper: force-refresh screenshots for a specific
   * environment. Equivalent to `recreateProjectScreenshots(projectKey,
   * { environment, force: true })`.
   */ async refreshForEnvironment(projectKey, environment = "production", extra = {}) {
        if (![
            "development",
            "staging",
            "production"
        ].includes(environment)) throw new Error(`environment must be development | staging | production, got ${environment}`);
        return this.recreateProjectScreenshots(projectKey, {
            environment: environment,
            force: true,
            ...extra
        });
    }
    async deleteProjectScreenshots(projectKey) {
        this._requireReady("deleteProjectScreenshots");
        if (!projectKey) throw new Error("projectKey is required");
        try {
            const response = await this._request(`/screenshots/projects/${$281a441cdcb2cf36$var$projectKeyPath(projectKey)}`, {
                method: "DELETE",
                methodName: "deleteProjectScreenshots"
            });
            if (response.success) return response;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to delete project screenshots: ${error.message}`, {
                cause: error
            });
        }
    }
    // ==================== THUMBNAIL ====================
    async getThumbnailCandidate(projectKey, options = {}) {
        this._requireReady("getThumbnailCandidate");
        if (!projectKey) throw new Error("projectKey is required");
        const { includeData: includeData = false } = options;
        const qs = new URLSearchParams();
        if (includeData) qs.set("include_data", "true");
        try {
            const response = await this._request(`/screenshots/projects/${$281a441cdcb2cf36$var$projectKeyPath(projectKey)}/thumbnail/candidate${qs.toString() ? `?${qs.toString()}` : ""}`, {
                method: "GET",
                methodName: "getThumbnailCandidate"
            });
            if (response.success) return response;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to get thumbnail candidate: ${error.message}`, {
                cause: error
            });
        }
    }
    async updateProjectThumbnail(projectKey, body = {}) {
        this._requireReady("updateProjectThumbnail");
        if (!projectKey) throw new Error("projectKey is required");
        try {
            const response = await this._request(`/screenshots/projects/${$281a441cdcb2cf36$var$projectKeyPath(projectKey)}/thumbnail`, {
                method: "POST",
                body: JSON.stringify(body),
                methodName: "updateProjectThumbnail"
            });
            if (response.success) return response;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to update project thumbnail: ${error.message}`, {
                cause: error
            });
        }
    }
    // ==================== INDIVIDUAL SHOTS ====================
    async getPageScreenshot(screenshotId, format = "json") {
        this._requireReady("getPageScreenshot");
        if (!screenshotId) throw new Error("screenshotId is required");
        const qs = new URLSearchParams();
        if (format) qs.set("format", format);
        try {
            return await this._request(`/screenshots/pages/${encodeURIComponent(screenshotId)}${qs.toString() ? `?${qs.toString()}` : ""}`, {
                method: "GET",
                methodName: "getPageScreenshot"
            });
        } catch (error) {
            throw new Error(`Failed to get page screenshot: ${error.message}`, {
                cause: error
            });
        }
    }
    async getComponentScreenshot(screenshotId, format = "json") {
        this._requireReady("getComponentScreenshot");
        if (!screenshotId) throw new Error("screenshotId is required");
        const qs = new URLSearchParams();
        if (format) qs.set("format", format);
        try {
            return await this._request(`/screenshots/components/${encodeURIComponent(screenshotId)}${qs.toString() ? `?${qs.toString()}` : ""}`, {
                method: "GET",
                methodName: "getComponentScreenshot"
            });
        } catch (error) {
            throw new Error(`Failed to get component screenshot: ${error.message}`, {
                cause: error
            });
        }
    }
    async getScreenshotByKey(projectKey, type, key, format = "json") {
        this._requireReady("getScreenshotByKey");
        if (!projectKey) throw new Error("projectKey is required");
        if (!type || ![
            "component",
            "page"
        ].includes(String(type))) throw new Error("type must be 'component' or 'page'");
        if (!key) throw new Error("key is required");
        const query = format ? `?${new URLSearchParams({
            format: format
        }).toString()}` : "";
        try {
            if (type === "component") return await this._request(`/screenshots/projects/${$281a441cdcb2cf36$var$projectKeyPath(projectKey)}/components/${encodeURIComponent(key)}${query}`, {
                method: "GET",
                methodName: "getScreenshotByKey"
            });
            return await this._request(`/screenshots/projects/${$281a441cdcb2cf36$var$projectKeyPath(projectKey)}/pages/${encodeURIComponent(key)}${query}`, {
                method: "GET",
                methodName: "getScreenshotByKey"
            });
        } catch (error) {
            throw new Error(`Failed to get screenshot by key: ${error.message}`, {
                cause: error
            });
        }
    }
    async getQueueStatistics() {
        this._requireReady("getQueueStatistics");
        try {
            const response = await this._request("/screenshots/queue/stats", {
                method: "GET",
                methodName: "getQueueStatistics"
            });
            if (response.success) return response;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to get queue statistics: ${error.message}`, {
                cause: error
            });
        }
    }
    // ==================== COMBINATION/DEBOUNCED ====================
    /**
   * Debounced thumbnail refresh that recreates screenshots and then updates thumbnail.
   * Subsequent calls within debounce window reset the timer.
   */ async refreshThumbnail(projectKey, options = {}) {
        this._requireReady("refreshThumbnail");
        if (!projectKey) throw new Error("projectKey is required");
        const { debounceMs: debounceMs = 15e3, waitAfterRecreateMs: waitAfterRecreateMs = 2e4, recreate: recreate = {
            process_pages: true,
            process_components: false,
            process_descriptions: false,
            force: false,
            priority: 5
        }, thumbnail: thumbnail = {
            strategy: "auto",
            force: true
        } } = options;
        const debounceKey = projectKey && typeof projectKey === "object" ? `${projectKey.owner || ""}/${projectKey.key || ""}` : String(projectKey);
        const existingTimer = this._debounceTimers.get(debounceKey);
        if (existingTimer) clearTimeout(existingTimer);
        const executionPromise = await new Promise((resolve)=>{
            const timer = setTimeout(async ()=>{
                try {
                    await this.recreateProjectScreenshots(projectKey, recreate);
                    await new Promise((resolveDelay)=>{
                        setTimeout(resolveDelay, waitAfterRecreateMs);
                    });
                    const result = await this.updateProjectThumbnail(projectKey, thumbnail);
                    resolve(result);
                } catch (e4) {
                    resolve({
                        success: false,
                        error: (e4 == null ? void 0 : e4.message) || String(e4)
                    });
                } finally{
                    this._debounceTimers.delete(debounceKey);
                    this._inflightRefreshes.delete(debounceKey);
                }
            }, debounceMs);
            this._debounceTimers.set(debounceKey, timer);
        });
        this._inflightRefreshes.set(debounceKey, executionPromise);
        return executionPromise;
    }
};
// src/services/TrackingService.js
var $281a441cdcb2cf36$var$DEFAULT_MAX_QUEUE_SIZE = 100;
var $281a441cdcb2cf36$var$isBrowserEnvironment = ()=>typeof window !== "undefined";
var $281a441cdcb2cf36$var$DEFAULT_TRACKING_OPTIONS = {
    // Enabled by default unless explicitly disabled via SDK options or runtime config
    enabled: true,
    sessionTracking: true,
    enableTracing: true,
    maxQueueSize: $281a441cdcb2cf36$var$DEFAULT_MAX_QUEUE_SIZE,
    transports: null,
    instrumentations: null,
    instrumentationsFactory: null,
    webInstrumentationOptions: null,
    globalAttributes: {},
    transport: null,
    user: null
};
var $281a441cdcb2cf36$var$sanitizeAttributes2 = (value2)=>{
    if (!value2 || typeof value2 !== "object") return {};
    try {
        return JSON.parse(JSON.stringify(value2));
    } catch (error) {
        $281a441cdcb2cf36$var$logger.warn("[TrackingService] Failed to sanitize attributes:", error);
        return {
            ...value2
        };
    }
};
var $281a441cdcb2cf36$var$TrackingService = class extends $281a441cdcb2cf36$var$BaseService {
    constructor({ context: context2, options: options } = {}){
        super({
            context: context2,
            options: options
        });
        this._faroClient = null;
        this._queue = [];
        this._initialized = false;
        this._enabled = $281a441cdcb2cf36$var$DEFAULT_TRACKING_OPTIONS.enabled;
        this._runtimeConfig = {};
        this._setupPromise = null;
        this._trackingOptions = {
            ...$281a441cdcb2cf36$var$DEFAULT_TRACKING_OPTIONS,
            ...(options == null ? void 0 : options.tracking) || {}
        };
        this._globalAttributes = $281a441cdcb2cf36$var$sanitizeAttributes2(this._trackingOptions.globalAttributes || {});
        this._trackingOptions.globalAttributes = {
            ...this._globalAttributes
        };
    }
    async init({ context: context2 = {}, options: options = {} } = {}) {
        var _a2;
        this.updateContext(context2);
        this._trackingOptions = {
            ...$281a441cdcb2cf36$var$DEFAULT_TRACKING_OPTIONS,
            ...this._trackingOptions,
            ...((_a2 = this._options) == null ? void 0 : _a2.tracking) || {},
            ...options.tracking || {}
        };
        this._globalAttributes = $281a441cdcb2cf36$var$sanitizeAttributes2(this._trackingOptions.globalAttributes || {});
        this._enabled = this._trackingOptions.enabled !== false;
        if (!this._enabled) {
            this._setReady();
            return this;
        }
        if (!$281a441cdcb2cf36$var$isBrowserEnvironment()) {
            this._enabled = false;
            this._setReady();
            return this;
        }
        this._runtimeConfig = this._buildRuntimeConfig();
        this._trackingOptions.transports = this._runtimeConfig.transports;
        const hasCustomTransports = Array.isArray(this._runtimeConfig.transports) && this._runtimeConfig.transports.length > 0;
        if (!this._runtimeConfig.url && !hasCustomTransports) {
            $281a441cdcb2cf36$var$logger.warn("[TrackingService] Grafana Faro URL missing. Tracking will stay disabled.");
            this._enabled = false;
            this._setReady();
            return this;
        }
        if (this._initialized) {
            this._setReady();
            return this;
        }
        if (!this._setupPromise) this._setupPromise = this._loadFaroClient(this._runtimeConfig);
        await this._setupPromise;
        return this;
    }
    updateContext(context2) {
        super.updateContext(context2);
        const trackingContext = context2 == null ? void 0 : context2.tracking;
        if (trackingContext) {
            if (Object.hasOwn(trackingContext, "user")) this.setUser(trackingContext.user, {
                queue: false
            });
            if (Object.hasOwn(trackingContext, "globalAttributes")) this.setGlobalAttributes(trackingContext.globalAttributes);
        }
    }
    configureTracking(trackingOptions = {}) {
        if (!trackingOptions || typeof trackingOptions !== "object") return this;
        this._trackingOptions = {
            ...this._trackingOptions,
            ...trackingOptions
        };
        if (Object.hasOwn(trackingOptions, "globalAttributes")) this.setGlobalAttributes(trackingOptions.globalAttributes);
        if (Object.hasOwn(trackingOptions, "user")) {
            this.setUser(trackingOptions.user);
            this._trackingOptions.user = trackingOptions.user;
        }
        return this;
    }
    configure(trackingOptions = {}) {
        return this.configureTracking(trackingOptions);
    }
    trackEvent(name, attributes, options = {}) {
        if (!name) throw new Error("Event name is required for trackEvent");
        const mergedAttributes = this._mergeAttributes(attributes);
        const eventOptions = options && typeof options === "object" ? options : {};
        const { domain: domain, queue: queue, ...restOptions } = eventOptions;
        const eventDomain = Object.hasOwn(eventOptions, "domain") ? domain : null;
        const invokeTracking = (client)=>{
            const api = client == null ? void 0 : client.api;
            if (!(api == null ? void 0 : api.pushEvent)) {
                $281a441cdcb2cf36$var$logger.warn("[TrackingService] Faro pushEvent API not available");
                return;
            }
            api.pushEvent(name, mergedAttributes, eventDomain, restOptions);
        };
        if (Object.hasOwn(eventOptions, "queue")) this._withClient(invokeTracking, {
            queue: Boolean(queue)
        });
        else this._withClient(invokeTracking);
    }
    trackError(error, options = {}) {
        if (!error) return;
        const err = error instanceof Error ? error : new Error(typeof error === "string" ? error : "Unknown error captured by TrackingService");
        const isContextOnly = options && typeof options === "object" && options !== null && !("context" in options || "type" in options || "stackFrames" in options || "skipDedupe" in options || "spanContext" in options || "timestampOverwriteMs" in options || "originalError" in options);
        const normalizedOptions = isContextOnly ? {
            context: options
        } : options || {};
        const mergedContext = this._mergeAttributes(normalizedOptions.context);
        const apiOptions = {
            ...normalizedOptions,
            ...Object.keys(mergedContext).length > 0 ? {
                context: mergedContext
            } : {}
        };
        const queueConfigured = Object.hasOwn(apiOptions, "queue");
        const { queue: queue, ...errorOptions } = apiOptions;
        const invokeTracking = (client)=>{
            const api = client == null ? void 0 : client.api;
            if (!(api == null ? void 0 : api.pushError)) {
                $281a441cdcb2cf36$var$logger.warn("[TrackingService] Faro pushError API not available");
                return;
            }
            api.pushError(err, errorOptions);
        };
        if (queueConfigured) this._withClient(invokeTracking, {
            queue: Boolean(queue)
        });
        else this._withClient(invokeTracking);
    }
    captureException(error, options = {}) {
        this.trackError(error, options);
    }
    logMessage(message, level = "info", context2 = null) {
        if (!message) return;
        const payload = Array.isArray(message) ? message : [
            message
        ];
        const logContext = this._mergeAttributes(context2);
        const severity = level || "info";
        const options = {
            level: severity,
            ...Object.keys(logContext).length > 0 ? {
                context: logContext
            } : {}
        };
        this._withClient((client)=>{
            const api = client == null ? void 0 : client.api;
            if (!(api == null ? void 0 : api.pushLog)) {
                $281a441cdcb2cf36$var$logger.warn("[TrackingService] Faro pushLog API not available");
                return;
            }
            api.pushLog(payload, options);
        });
    }
    logDebug(message, context2) {
        this.logMessage(message, "debug", context2);
    }
    logInfo(message, context2) {
        this.logMessage(message, "info", context2);
    }
    logWarning(message, context2) {
        this.logMessage(message, "warn", context2);
    }
    logWarn(message, context2) {
        this.logWarning(message, context2);
    }
    logErrorMessage(message, context2) {
        this.logMessage(message, "error", context2);
    }
    logError(message, context2) {
        this.logErrorMessage(message, context2);
    }
    addBreadcrumb(message, attributes) {
        if (!message) return;
        const breadcrumbAttributes = {
            category: "custom",
            ...$281a441cdcb2cf36$var$sanitizeAttributes2(attributes || {}),
            message: message
        };
        this.trackEvent("breadcrumb", breadcrumbAttributes);
    }
    trackMeasurement(type, values, options = {}) {
        if (!type) throw new Error("Measurement type is required for trackMeasurement");
        if (values == null) throw new Error("Measurement values are required for trackMeasurement");
        const measurementValues = typeof values === "object" && !Array.isArray(values) ? $281a441cdcb2cf36$var$sanitizeAttributes2(values) : {
            value: Number(values)
        };
        if (typeof measurementValues.value === "number" && Number.isNaN(measurementValues.value)) throw new Error("Measurement value must be a valid number");
        const measurementOptions = options && typeof options === "object" ? options : {};
        const { attributes: measurementAttributesOption, context: measurementContextOption, queue: queue, ...transportOptions } = measurementOptions;
        const hasGlobalAttributes = Object.keys(this._globalAttributes).length > 0;
        const attributePayload = measurementAttributesOption ? this._mergeAttributes(measurementAttributesOption) : hasGlobalAttributes ? {
            ...this._globalAttributes
        } : {};
        const payload = {
            type: type,
            values: measurementValues,
            ...attributePayload && Object.keys(attributePayload).length > 0 ? {
                attributes: attributePayload
            } : {}
        };
        const context2 = measurementContextOption ? this._mergeAttributes(measurementContextOption) : hasGlobalAttributes ? {
            ...this._globalAttributes
        } : {};
        const apiOptions = {
            ...transportOptions,
            ...Object.keys(context2).length > 0 ? {
                context: context2
            } : {}
        };
        const invokeTracking = (client)=>{
            const api = client == null ? void 0 : client.api;
            if (!(api == null ? void 0 : api.pushMeasurement)) {
                $281a441cdcb2cf36$var$logger.warn("[TrackingService] Faro pushMeasurement API not available");
                return;
            }
            api.pushMeasurement(payload, apiOptions);
        };
        if (Object.hasOwn(measurementOptions, "queue")) this._withClient(invokeTracking, {
            queue: Boolean(queue)
        });
        else this._withClient(invokeTracking);
    }
    trackView(name, attributes) {
        if (!name) throw new Error("View name is required for trackView");
        const viewAttributes = $281a441cdcb2cf36$var$sanitizeAttributes2(attributes || {});
        const merged = this._mergeAttributes(viewAttributes);
        this._withClient((client)=>{
            const api = client == null ? void 0 : client.api;
            if (!(api == null ? void 0 : api.setView)) {
                $281a441cdcb2cf36$var$logger.warn("[TrackingService] Faro setView API not available");
                return;
            }
            api.setView({
                name: name,
                ...merged
            });
        });
    }
    setUser(user, options = {}) {
        if (user == null) {
            this.clearUser();
            return;
        }
        if (typeof user !== "object") throw new Error("User must be an object");
        const userData = $281a441cdcb2cf36$var$sanitizeAttributes2(user);
        const queueConfigured = options && typeof options === "object" && Object.hasOwn(options, "queue");
        const invokeTracking = (client)=>{
            const api = client == null ? void 0 : client.api;
            if (!(api == null ? void 0 : api.setUser)) {
                $281a441cdcb2cf36$var$logger.warn("[TrackingService] Faro setUser API not available");
                return;
            }
            api.setUser(userData);
        };
        if (queueConfigured) this._withClient(invokeTracking, {
            queue: Boolean(options.queue)
        });
        else this._withClient(invokeTracking);
    }
    clearUser() {
        this._withClient((client)=>{
            const api = client == null ? void 0 : client.api;
            if (api == null ? void 0 : api.setUser) api.setUser(null);
            else $281a441cdcb2cf36$var$logger.warn("[TrackingService] Faro setUser API not available");
        });
    }
    setSession(session, options = {}) {
        if (session == null) {
            this.clearSession();
            return;
        }
        if (typeof session !== "object") throw new Error("Session must be an object");
        const sessionData = $281a441cdcb2cf36$var$sanitizeAttributes2(session);
        const queueConfigured = Object.hasOwn(options, "queue");
        const { queue: queue, ...sessionOptions } = options;
        const invokeTracking = (client)=>{
            const api = client == null ? void 0 : client.api;
            if (!(api == null ? void 0 : api.setSession)) {
                $281a441cdcb2cf36$var$logger.warn("[TrackingService] Faro setSession API not available");
                return;
            }
            api.setSession(sessionData, sessionOptions);
        };
        if (queueConfigured) this._withClient(invokeTracking, {
            queue: Boolean(queue)
        });
        else this._withClient(invokeTracking);
    }
    clearSession() {
        this._withClient((client)=>{
            const api = client == null ? void 0 : client.api;
            if (api == null ? void 0 : api.setSession) api.setSession(null);
            else $281a441cdcb2cf36$var$logger.warn("[TrackingService] Faro setSession API not available");
        });
    }
    setGlobalAttributes(attributes) {
        if (attributes == null) {
            this._globalAttributes = {};
            this._trackingOptions.globalAttributes = {};
            return;
        }
        if (typeof attributes !== "object") throw new Error("Global attributes must be an object");
        const sanitized = $281a441cdcb2cf36$var$sanitizeAttributes2(attributes);
        this._globalAttributes = sanitized;
        this._trackingOptions.globalAttributes = sanitized;
    }
    setGlobalAttribute(key, value2) {
        if (!key) throw new Error("Global attribute key is required");
        const sanitized = $281a441cdcb2cf36$var$sanitizeAttributes2({
            [key]: value2
        });
        this._globalAttributes = {
            ...this._globalAttributes,
            ...sanitized
        };
        this._trackingOptions.globalAttributes = {
            ...this._globalAttributes
        };
    }
    removeGlobalAttribute(key) {
        if (!key) throw new Error("Global attribute key is required to remove it");
        if (Object.hasOwn(this._globalAttributes, key)) {
            const rest = {
                ...this._globalAttributes
            };
            delete rest[key];
            this._globalAttributes = rest;
            this._trackingOptions.globalAttributes = rest;
        }
    }
    _mergeAttributes(attributes) {
        const hasInput = attributes && typeof attributes === "object";
        const sanitized = hasInput ? $281a441cdcb2cf36$var$sanitizeAttributes2(attributes) : {};
        if (!this._globalAttributes || Object.keys(this._globalAttributes).length === 0) return sanitized;
        return {
            ...this._globalAttributes,
            ...sanitized
        };
    }
    flushQueue() {
        if (!this._queue.length) return;
        const queue = [
            ...this._queue
        ];
        this._queue.length = 0;
        if (!this._faroClient) return;
        queue.forEach((callback)=>{
            try {
                callback(this._faroClient);
            } catch (error) {
                $281a441cdcb2cf36$var$logger.error("[TrackingService] Failed to flush queued tracking call", error);
            }
        });
    }
    getClient() {
        return this._faroClient;
    }
    isEnabled() {
        return this._enabled && Boolean(this._faroClient);
    }
    isInitialized() {
        return this._initialized;
    }
    destroy() {
        var _a2;
        this._queue.length = 0;
        if ((_a2 = this._faroClient) == null ? void 0 : _a2.destroy) try {
            this._faroClient.destroy();
        } catch (error) {
            $281a441cdcb2cf36$var$logger.warn("[TrackingService] Failed to destroy Faro client cleanly", error);
        }
        if ($281a441cdcb2cf36$var$isBrowserEnvironment() && window.symbols && window.symbols.faro === this._faroClient) delete window.symbols.faro;
        this._faroClient = null;
        this._initialized = false;
        this._setupPromise = null;
        this._setReady(false);
        this._enabled = this._trackingOptions.enabled !== false;
    }
    _buildRuntimeConfig() {
        var _a2, _b;
        const contextConfig = ((_a2 = this._context) == null ? void 0 : _a2.tracking) || {};
        const merged = {
            ...$281a441cdcb2cf36$var$DEFAULT_TRACKING_OPTIONS,
            ...this._trackingOptions,
            ...contextConfig
        };
        const transportList = [];
        if (Array.isArray(merged.transports)) transportList.push(...merged.transports.filter(Boolean));
        else if (merged.transport) transportList.push(merged.transport);
        const configuredUrl = merged.url || contextConfig.url || this._trackingOptions.url;
        let url2 = configuredUrl;
        if (!url2 && transportList.length === 0) url2 = $281a441cdcb2cf36$export$6bc7b24d4e862158.grafanaUrl;
        const appName = merged.appName || contextConfig.appName || this._trackingOptions.appName || $281a441cdcb2cf36$export$6bc7b24d4e862158.grafanaAppName || "Symbols Platform";
        const appVersion = merged.appVersion || contextConfig.appVersion || this._trackingOptions.appVersion || ((_b = this._context) == null ? void 0 : _b.appVersion);
        const environmentName = merged.environment || contextConfig.environment || this._trackingOptions.environment || this._resolveEnvironmentName();
        const contextGlobalAttributes = $281a441cdcb2cf36$var$sanitizeAttributes2(contextConfig.globalAttributes || {});
        const globalAttributes = $281a441cdcb2cf36$var$sanitizeAttributes2({
            ...this._globalAttributes,
            ...contextGlobalAttributes
        });
        const runtimeConfig = {
            url: url2,
            appName: appName,
            appVersion: appVersion,
            environment: environmentName,
            globalAttributes: globalAttributes,
            sessionTracking: merged.sessionTracking !== false,
            enableTracing: merged.enableTracing !== false,
            user: merged.user,
            maxQueueSize: typeof merged.maxQueueSize === "number" && merged.maxQueueSize > 0 ? merged.maxQueueSize : $281a441cdcb2cf36$var$DEFAULT_MAX_QUEUE_SIZE
        };
        if (typeof merged.isolate === "boolean") runtimeConfig.isolate = merged.isolate;
        if (Array.isArray(merged.instrumentations)) runtimeConfig.instrumentations = merged.instrumentations;
        if (typeof merged.instrumentationsFactory === "function") runtimeConfig.instrumentationsFactory = merged.instrumentationsFactory;
        if (merged.webInstrumentationOptions != null) runtimeConfig.webInstrumentationOptions = merged.webInstrumentationOptions;
        if (transportList.length > 0) runtimeConfig.transports = transportList;
        return runtimeConfig;
    }
    _resolveEnvironmentName() {
        if ($281a441cdcb2cf36$export$6bc7b24d4e862158.isProduction) return "production";
        if ($281a441cdcb2cf36$export$6bc7b24d4e862158.isStaging) return "staging";
        if ($281a441cdcb2cf36$export$6bc7b24d4e862158.isTesting) return "testing";
        if ($281a441cdcb2cf36$export$6bc7b24d4e862158.isDevelopment) return "development";
        return "upcoming";
    }
    async _loadFaroClient(runtimeConfig) {
        try {
            const tracingImport = runtimeConfig.enableTracing === false ? Promise.resolve(null) : Promise.resolve().then(()=>($281a441cdcb2cf36$var$init_esm17(), $281a441cdcb2cf36$var$esm_exports7)).catch((error)=>{
                $281a441cdcb2cf36$var$logger.warn("[TrackingService] Tracing instrumentation failed to load:", error);
                return null;
            });
            const [{ initializeFaro: initializeFaro3, getWebInstrumentations: getWebInstrumentations2 }, tracingModule] = await Promise.all([
                Promise.resolve().then(()=>($281a441cdcb2cf36$var$init_esm5(), $281a441cdcb2cf36$var$esm_exports4)),
                tracingImport
            ]);
            const TracingInstrumentation2 = tracingModule == null ? void 0 : tracingModule.TracingInstrumentation;
            const instrumentations = await this._resolveInstrumentations({
                runtimeConfig: runtimeConfig,
                getWebInstrumentations: getWebInstrumentations2,
                TracingInstrumentation: TracingInstrumentation2
            });
            const initializeOptions = {
                app: {
                    name: runtimeConfig.appName,
                    version: runtimeConfig.appVersion,
                    environment: runtimeConfig.environment
                },
                instrumentations: instrumentations,
                globalAttributes: $281a441cdcb2cf36$var$sanitizeAttributes2(runtimeConfig.globalAttributes)
            };
            if (runtimeConfig.url) initializeOptions.url = runtimeConfig.url;
            if (Array.isArray(runtimeConfig.transports) && runtimeConfig.transports.length > 0) initializeOptions.transports = runtimeConfig.transports;
            if (runtimeConfig.sessionTracking === false) initializeOptions.sessionTracking = false;
            if (runtimeConfig.isolate === true) initializeOptions.isolate = true;
            this._faroClient = initializeFaro3(initializeOptions);
            if (runtimeConfig.user) this.setUser(runtimeConfig.user, {
                queue: false
            });
            if ($281a441cdcb2cf36$var$isBrowserEnvironment()) {
                window.symbols || (window.symbols = {});
                window.symbols.faro = this._faroClient;
            }
            this._initialized = true;
            this._setReady();
            this.flushQueue();
        } catch (error) {
            this._enabled = false;
            this._setError(error);
            this._ready = true;
            $281a441cdcb2cf36$var$logger.error("[TrackingService] Failed to initialize Grafana Faro client:", error);
        } finally{
            this._setupPromise = null;
        }
    }
    async _resolveInstrumentations({ runtimeConfig: runtimeConfig, getWebInstrumentations: getWebInstrumentations2, TracingInstrumentation: TracingInstrumentation2 }) {
        if (Array.isArray(runtimeConfig.instrumentations)) return runtimeConfig.instrumentations;
        if (typeof runtimeConfig.instrumentationsFactory === "function") try {
            const instrumentations = await runtimeConfig.instrumentationsFactory({
                runtimeConfig: runtimeConfig,
                getWebInstrumentations: getWebInstrumentations2,
                TracingInstrumentation: TracingInstrumentation2
            });
            if (Array.isArray(instrumentations)) return instrumentations;
        } catch (error) {
            $281a441cdcb2cf36$var$logger.warn("[TrackingService] Custom instrumentation factory failed:", error);
        }
        const instrumentationOptions = runtimeConfig.webInstrumentationOptions == null ? {} : runtimeConfig.webInstrumentationOptions;
        const defaultInstrumentations = getWebInstrumentations2(instrumentationOptions);
        if (runtimeConfig.enableTracing !== false && TracingInstrumentation2) try {
            defaultInstrumentations.push(new TracingInstrumentation2());
        } catch (error) {
            $281a441cdcb2cf36$var$logger.warn("[TrackingService] Failed to instantiate tracing instrumentation:", error);
        }
        return defaultInstrumentations;
    }
    _withClient(callback, options = {}) {
        var _a2, _b;
        if (!this._enabled) return null;
        if (this._faroClient) try {
            return callback(this._faroClient);
        } catch (error) {
            $281a441cdcb2cf36$var$logger.error("[TrackingService] Tracking callback failed:", error);
            return null;
        }
        if (options.queue === false) return null;
        const queueLimit = (_b = (_a2 = this._runtimeConfig.maxQueueSize) != null ? _a2 : this._trackingOptions.maxQueueSize) != null ? _b : $281a441cdcb2cf36$var$DEFAULT_MAX_QUEUE_SIZE;
        if (this._queue.length >= queueLimit) this._queue.shift();
        this._queue.push(callback);
        return null;
    }
};
// src/services/WaitlistService.js
var $281a441cdcb2cf36$var$WaitlistService = class extends $281a441cdcb2cf36$var$BaseService {
    // ==================== WAITLIST METHODS ====================
    /**
   * Join a waitlist campaign (public).
   *
   * Mirrors: POST /waitlist (WaitlistController.join)
   */ async joinWaitlist(data2 = {}) {
        this._requireReady("joinWaitlist");
        if (!data2 || typeof data2 !== "object") throw new Error("Waitlist join payload is required");
        if (!data2.email) throw new Error("Email is required");
        try {
            const response = await this._request("/waitlist", {
                method: "POST",
                body: JSON.stringify(data2),
                methodName: "joinWaitlist"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to join waitlist: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * List waitlist entries (admin).
   *
   * Mirrors: GET /waitlist (WaitlistController.list)
   */ async listWaitlistEntries(options = {}) {
        this._requireReady("listWaitlistEntries");
        const { campaignKey: campaignKey, status: status, search: search, page: page, limit: limit } = options || {};
        const queryParams = new URLSearchParams();
        if (campaignKey != null) queryParams.append("campaignKey", String(campaignKey));
        if (status != null) queryParams.append("status", String(status));
        if (search != null) queryParams.append("search", String(search));
        if (page != null) queryParams.append("page", String(page));
        if (limit != null) queryParams.append("limit", String(limit));
        const queryString = queryParams.toString();
        try {
            const response = queryString ? await this._request(`/waitlist?${queryString}`, {
                method: "GET",
                methodName: "listWaitlistEntries"
            }) : await this._request("/waitlist", {
                method: "GET",
                methodName: "listWaitlistEntries"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to list waitlist entries: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Update a waitlist entry (admin).
   *
   * Mirrors: PATCH /waitlist/:id (WaitlistController.update)
   */ async updateWaitlistEntry(id2, update = {}) {
        this._requireReady("updateWaitlistEntry");
        if (!id2) throw new Error("Waitlist entry ID is required");
        if (!update || typeof update !== "object") throw new Error("Update payload is required");
        try {
            const response = await this._request(`/waitlist/${id2}`, {
                method: "PATCH",
                body: JSON.stringify(update),
                methodName: "updateWaitlistEntry"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to update waitlist entry: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Send an invitation email for a waitlist entry (admin).
   *
   * Mirrors: POST /waitlist/:id/invite (WaitlistController.invite)
   */ async inviteWaitlistEntry(id2) {
        this._requireReady("inviteWaitlistEntry");
        if (!id2) throw new Error("Waitlist entry ID is required");
        try {
            const response = await this._request(`/waitlist/${id2}/invite`, {
                method: "POST",
                methodName: "inviteWaitlistEntry"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to invite waitlist entry: ${error.message}`, {
                cause: error
            });
        }
    }
};
// src/services/MetricsService.js
var $281a441cdcb2cf36$var$MetricsService = class extends $281a441cdcb2cf36$var$BaseService {
    // ==================== METRICS METHODS ====================
    /**
   * Contribution heat-map stats.
   *
   * Mirrors: GET /metrics/contributions (MetricsController.getContributions)
   */ async getContributions(options = {}) {
        this._requireReady("getContributions");
        const { projectId: projectId, userId: userId, from: from2, to: to } = options || {};
        const queryParams = new URLSearchParams();
        if (projectId != null) queryParams.append("projectId", String(projectId));
        if (userId != null) queryParams.append("userId", String(userId));
        if (from2 != null) queryParams.append("from", String(from2));
        if (to != null) queryParams.append("to", String(to));
        const queryString = queryParams.toString();
        try {
            const response = queryString ? await this._request(`/metrics/contributions?${queryString}`, {
                method: "GET",
                methodName: "getContributions"
            }) : await this._request("/metrics/contributions", {
                method: "GET",
                methodName: "getContributions"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to get contribution stats: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Current billing-cycle usage summary for a project. Server routes
   * through the subscription cascade — Enterprise projects resolve
   * to the org's HQ subscription; workspace-scoped projects resolve
   * to their workspace subscription.
   *
   * Mirrors: GET /usage/project/:projectId (UsageController.summary)
   *
   * @param {string} projectId
   * @returns {Promise<object>} - { creditsUsed, creditsLimit, period, breakdown? }
   */ async getProjectUsage(projectId) {
        if (!projectId) throw new Error("projectId is required");
        return this._call("getProjectUsage", `/usage/project/${projectId}`);
    }
};
// src/services/IntegrationService.js
var $281a441cdcb2cf36$var$IntegrationService = class extends $281a441cdcb2cf36$var$BaseService {
    // ==================== INTEGRATION METHODS ====================
    /**
   * Programmatic auth sanity check (API key based).
   *
   * Mirrors: GET /integrations/whoami (requireApiKey)
   *
   * Assumption: backend reads API key from `x-api-key` header.
   * You can override via `options.headers`.
   */ async integrationWhoami(apiKey, options = {}) {
        this._requireReady("integrationWhoami");
        if (!apiKey) throw new Error("API key is required");
        const headers = {
            "x-api-key": apiKey,
            ...options.headers || {}
        };
        try {
            const response = await this._request("/integrations/whoami", {
                method: "GET",
                headers: headers,
                methodName: "integrationWhoami"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to validate integration API key: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * List integrations visible to the user.
   *
   * Mirrors: GET /integrations?orgId=&projectId=
   */ async listIntegrations(options = {}) {
        this._requireReady("listIntegrations");
        const { orgId: orgId, projectId: projectId } = options || {};
        const queryParams = new URLSearchParams();
        if (orgId != null) queryParams.append("orgId", String(orgId));
        if (projectId != null) queryParams.append("projectId", String(projectId));
        const queryString = queryParams.toString();
        try {
            const response = queryString ? await this._request(`/integrations?${queryString}`, {
                method: "GET",
                methodName: "listIntegrations"
            }) : await this._request("/integrations", {
                method: "GET",
                methodName: "listIntegrations"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to list integrations: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Create an integration.
   *
   * Mirrors: POST /integrations
   */ async createIntegration(data2 = {}) {
        this._requireReady("createIntegration");
        if (!data2 || typeof data2 !== "object") throw new Error("Integration payload is required");
        if (!data2.name) throw new Error("Integration name is required");
        if (!data2.ownerType) throw new Error("ownerType is required");
        try {
            const response = await this._request("/integrations", {
                method: "POST",
                body: JSON.stringify(data2),
                methodName: "createIntegration"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to create integration: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Update an integration.
   *
   * Mirrors: PATCH /integrations/:integrationId
   */ async updateIntegration(integrationId, update = {}) {
        this._requireReady("updateIntegration");
        if (!integrationId) throw new Error("Integration ID is required");
        if (!update || typeof update !== "object") throw new Error("Update payload is required");
        try {
            const response = await this._request(`/integrations/${integrationId}`, {
                method: "PATCH",
                body: JSON.stringify(update),
                methodName: "updateIntegration"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to update integration: ${error.message}`, {
                cause: error
            });
        }
    }
    // ==================== INTEGRATION API KEY METHODS ====================
    /**
   * Create a new API key for an integration.
   *
   * Mirrors: POST /integrations/:integrationId/api-keys
   */ async createIntegrationApiKey(integrationId, data2 = {}) {
        this._requireReady("createIntegrationApiKey");
        if (!integrationId) throw new Error("Integration ID is required");
        if (!data2 || typeof data2 !== "object") throw new Error("API key payload is required");
        try {
            const response = await this._request(`/integrations/${integrationId}/api-keys`, {
                method: "POST",
                body: JSON.stringify(data2),
                methodName: "createIntegrationApiKey"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to create integration API key: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * List API keys for an integration.
   *
   * Mirrors: GET /integrations/:integrationId/api-keys
   */ async listIntegrationApiKeys(integrationId) {
        this._requireReady("listIntegrationApiKeys");
        if (!integrationId) throw new Error("Integration ID is required");
        try {
            const response = await this._request(`/integrations/${integrationId}/api-keys`, {
                method: "GET",
                methodName: "listIntegrationApiKeys"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to list integration API keys: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Revoke an API key for an integration.
   *
   * Mirrors: POST /integrations/:integrationId/api-keys/:keyId/revoke
   */ async revokeIntegrationApiKey(integrationId, keyId) {
        this._requireReady("revokeIntegrationApiKey");
        if (!integrationId) throw new Error("Integration ID is required");
        if (!keyId) throw new Error("API key ID is required");
        try {
            const response = await this._request(`/integrations/${integrationId}/api-keys/${keyId}/revoke`, {
                method: "POST",
                methodName: "revokeIntegrationApiKey"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to revoke integration API key: ${error.message}`, {
                cause: error
            });
        }
    }
    // ==================== WEBHOOK METHODS ====================
    /**
   * Create a webhook endpoint for an integration.
   *
   * Mirrors: POST /integrations/:integrationId/webhooks
   */ async createIntegrationWebhook(integrationId, data2 = {}) {
        this._requireReady("createIntegrationWebhook");
        if (!integrationId) throw new Error("Integration ID is required");
        if (!data2 || typeof data2 !== "object") throw new Error("Webhook payload is required");
        try {
            const response = await this._request(`/integrations/${integrationId}/webhooks`, {
                method: "POST",
                body: JSON.stringify(data2),
                methodName: "createIntegrationWebhook"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to create integration webhook: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * List webhook endpoints for an integration.
   *
   * Mirrors: GET /integrations/:integrationId/webhooks
   */ async listIntegrationWebhooks(integrationId) {
        this._requireReady("listIntegrationWebhooks");
        if (!integrationId) throw new Error("Integration ID is required");
        try {
            const response = await this._request(`/integrations/${integrationId}/webhooks`, {
                method: "GET",
                methodName: "listIntegrationWebhooks"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to list integration webhooks: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Update a webhook endpoint for an integration.
   *
   * Mirrors: PATCH /integrations/:integrationId/webhooks/:webhookId
   */ async updateIntegrationWebhook(integrationId, webhookId, update = {}) {
        this._requireReady("updateIntegrationWebhook");
        if (!integrationId) throw new Error("Integration ID is required");
        if (!webhookId) throw new Error("Webhook ID is required");
        if (!update || typeof update !== "object") throw new Error("Update payload is required");
        try {
            const response = await this._request(`/integrations/${integrationId}/webhooks/${webhookId}`, {
                method: "PATCH",
                body: JSON.stringify(update),
                methodName: "updateIntegrationWebhook"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to update integration webhook: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Delete a webhook endpoint for an integration.
   *
   * Mirrors: DELETE /integrations/:integrationId/webhooks/:webhookId
   */ async deleteIntegrationWebhook(integrationId, webhookId) {
        this._requireReady("deleteIntegrationWebhook");
        if (!integrationId) throw new Error("Integration ID is required");
        if (!webhookId) throw new Error("Webhook ID is required");
        try {
            const response = await this._request(`/integrations/${integrationId}/webhooks/${webhookId}`, {
                method: "DELETE",
                methodName: "deleteIntegrationWebhook"
            });
            if (response && response.success) return response.data;
            if (response == null) return null;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to delete integration webhook: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * List webhook deliveries for an integration webhook.
   *
   * Mirrors: GET /integrations/:integrationId/webhooks/:webhookId/deliveries
   */ async listIntegrationWebhookDeliveries(integrationId, webhookId, options = {}) {
        this._requireReady("listIntegrationWebhookDeliveries");
        if (!integrationId) throw new Error("Integration ID is required");
        if (!webhookId) throw new Error("Webhook ID is required");
        const { page: page, limit: limit, status: status, includePayload: includePayload } = options || {};
        const queryParams = new URLSearchParams();
        if (page != null) queryParams.append("page", String(page));
        if (limit != null) queryParams.append("limit", String(limit));
        if (status != null) queryParams.append("status", String(status));
        if (includePayload != null) queryParams.append("includePayload", String(includePayload));
        const queryString = queryParams.toString();
        try {
            const response = queryString ? await this._request(`/integrations/${integrationId}/webhooks/${webhookId}/deliveries?${queryString}`, {
                method: "GET",
                methodName: "listIntegrationWebhookDeliveries"
            }) : await this._request(`/integrations/${integrationId}/webhooks/${webhookId}/deliveries`, {
                method: "GET",
                methodName: "listIntegrationWebhookDeliveries"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to list webhook deliveries: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Replay a webhook delivery.
   *
   * Mirrors: POST /integrations/:integrationId/webhooks/:webhookId/replay
   * Body: { deliveryId }
   */ async replayIntegrationWebhookDelivery(integrationId, webhookId, deliveryId) {
        this._requireReady("replayIntegrationWebhookDelivery");
        if (!integrationId) throw new Error("Integration ID is required");
        if (!webhookId) throw new Error("Webhook ID is required");
        if (!deliveryId) throw new Error("deliveryId is required");
        try {
            const response = await this._request(`/integrations/${integrationId}/webhooks/${webhookId}/replay`, {
                method: "POST",
                body: JSON.stringify({
                    deliveryId: deliveryId
                }),
                methodName: "replayIntegrationWebhookDelivery"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to replay webhook delivery: ${error.message}`, {
                cause: error
            });
        }
    }
    // ==================== CONNECTOR METHODS (GITHUB) ====================
    /**
   * List GitHub connectors for an integration.
   *
   * Mirrors: GET /integrations/:integrationId/connectors/github
   */ async listGitHubConnectors(integrationId) {
        this._requireReady("listGitHubConnectors");
        if (!integrationId) throw new Error("Integration ID is required");
        try {
            const response = await this._request(`/integrations/${integrationId}/connectors/github`, {
                method: "GET",
                methodName: "listGitHubConnectors"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to list GitHub connectors: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Create a GitHub connector for an integration.
   *
   * Mirrors: POST /integrations/:integrationId/connectors/github
   */ async createGitHubConnector(integrationId, data2 = {}) {
        this._requireReady("createGitHubConnector");
        if (!integrationId) throw new Error("Integration ID is required");
        if (!data2 || typeof data2 !== "object") throw new Error("Connector payload is required");
        if (!data2.projectId) throw new Error("projectId is required");
        if (!data2.repository) throw new Error("repository is required");
        try {
            const response = await this._request(`/integrations/${integrationId}/connectors/github`, {
                method: "POST",
                body: JSON.stringify(data2),
                methodName: "createGitHubConnector"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to create GitHub connector: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Update a GitHub connector.
   *
   * Mirrors: PATCH /integrations/:integrationId/connectors/github/:connectorId
   */ async updateGitHubConnector(integrationId, connectorId, update = {}) {
        this._requireReady("updateGitHubConnector");
        if (!integrationId) throw new Error("Integration ID is required");
        if (!connectorId) throw new Error("Connector ID is required");
        if (!update || typeof update !== "object") throw new Error("Update payload is required");
        try {
            const response = await this._request(`/integrations/${integrationId}/connectors/github/${connectorId}`, {
                method: "PATCH",
                body: JSON.stringify(update),
                methodName: "updateGitHubConnector"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to update GitHub connector: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Delete a GitHub connector.
   *
   * Mirrors: DELETE /integrations/:integrationId/connectors/github/:connectorId
   */ async deleteGitHubConnector(integrationId, connectorId) {
        this._requireReady("deleteGitHubConnector");
        if (!integrationId) throw new Error("Integration ID is required");
        if (!connectorId) throw new Error("Connector ID is required");
        try {
            const response = await this._request(`/integrations/${integrationId}/connectors/github/${connectorId}`, {
                method: "DELETE",
                methodName: "deleteGitHubConnector"
            });
            if (response && response.success) return response.data;
            if (response == null) return null;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to delete GitHub connector: ${error.message}`, {
                cause: error
            });
        }
    }
};
// src/services/FeatureFlagService.js
function $281a441cdcb2cf36$var$normalizeKeysParam(keys2) {
    if (!keys2) return null;
    if (Array.isArray(keys2)) {
        const flattened = keys2.flatMap((k3)=>String(k3).split(","));
        const cleaned2 = flattened.map((s3)=>s3.trim()).filter(Boolean);
        return cleaned2.length ? cleaned2.join(",") : null;
    }
    const cleaned = String(keys2).split(",").map((s3)=>s3.trim()).filter(Boolean);
    return cleaned.length ? cleaned.join(",") : null;
}
var $281a441cdcb2cf36$var$FeatureFlagService = class extends $281a441cdcb2cf36$var$BaseService {
    // ==================== USER FEATURE FLAGS (optional auth) ====================
    /**
   * Evaluate feature flags for the current user (or anonymous).
   * @param {Object} [params]
   * @param {string[]|string} [params.keys] Optional subset of keys (array or comma-separated string)
   * @returns {Promise<{flags: Record<string, {enabled: boolean, variant: string|null, payload: any}>}>}
   */ async getFeatureFlags(params2 = {}) {
        this._requireReady("getFeatureFlags");
        const { keys: keys2 } = params2 || {};
        const queryParams = new URLSearchParams();
        const keysParam = $281a441cdcb2cf36$var$normalizeKeysParam(keys2);
        if (keysParam) queryParams.append("keys", keysParam);
        const queryString = queryParams.toString();
        try {
            const response = queryString ? await this._request(`/feature-flags?${queryString}`, {
                method: "GET",
                methodName: "getFeatureFlags"
            }) : await this._request("/feature-flags", {
                method: "GET",
                methodName: "getFeatureFlags"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to get feature flags: ${error.message}`, {
                cause: error
            });
        }
    }
    /**
   * Evaluate a single feature flag for the current user (or anonymous).
   */ async getFeatureFlag(key) {
        this._requireReady("getFeatureFlag");
        if (!key) throw new Error("Feature flag key is required");
        try {
            const response = await this._request(`/feature-flags/${encodeURIComponent(String(key))}`, {
                method: "GET",
                methodName: "getFeatureFlag"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to get feature flag: ${error.message}`, {
                cause: error
            });
        }
    }
    // ==================== ADMIN FEATURE FLAGS (admin only) ====================
    async getAdminFeatureFlags(params2 = {}) {
        this._requireReady("getAdminFeatureFlags");
        const { includeArchived: includeArchived = true } = params2 || {};
        const queryParams = new URLSearchParams();
        if (includeArchived === false) queryParams.append("includeArchived", "false");
        const queryString = queryParams.toString();
        try {
            const response = queryString ? await this._request(`/admin/feature-flags?${queryString}`, {
                method: "GET",
                methodName: "getAdminFeatureFlags"
            }) : await this._request("/admin/feature-flags", {
                method: "GET",
                methodName: "getAdminFeatureFlags"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to get admin feature flags: ${error.message}`, {
                cause: error
            });
        }
    }
    async createFeatureFlag(flagData) {
        this._requireReady("createFeatureFlag");
        if (!flagData || typeof flagData !== "object") throw new Error("Feature flag data is required");
        if (!flagData.key) throw new Error("Feature flag key is required");
        try {
            const response = await this._request("/admin/feature-flags", {
                method: "POST",
                body: JSON.stringify(flagData),
                methodName: "createFeatureFlag"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to create feature flag: ${error.message}`, {
                cause: error
            });
        }
    }
    async updateFeatureFlag(id2, patch) {
        this._requireReady("updateFeatureFlag");
        if (!id2) throw new Error("Feature flag id is required");
        if (!patch || typeof patch !== "object") throw new Error("Feature flag patch is required");
        try {
            const response = await this._request(`/admin/feature-flags/${encodeURIComponent(String(id2))}`, {
                method: "PATCH",
                body: JSON.stringify(patch),
                methodName: "updateFeatureFlag"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to update feature flag: ${error.message}`, {
                cause: error
            });
        }
    }
    async archiveFeatureFlag(id2) {
        this._requireReady("archiveFeatureFlag");
        if (!id2) throw new Error("Feature flag id is required");
        try {
            const response = await this._request(`/admin/feature-flags/${encodeURIComponent(String(id2))}`, {
                method: "DELETE",
                methodName: "archiveFeatureFlag"
            });
            if (response.success) return response.data;
            throw new Error(response.message);
        } catch (error) {
            throw new Error(`Failed to archive feature flag: ${error.message}`, {
                cause: error
            });
        }
    }
};
// src/services/OrganizationService.js
var $281a441cdcb2cf36$var$OrganizationService = class extends $281a441cdcb2cf36$var$BaseService {
    // ==================== ORGANIZATION CRUD ====================
    async createOrganization({ name: name, slug: slug }) {
        this._requireReady("createOrganization");
        if (!name || !slug) throw new Error("name and slug are required");
        const response = await this._request("/organizations", {
            method: "POST",
            body: JSON.stringify({
                name: name,
                slug: slug
            }),
            methodName: "createOrganization"
        });
        if (response.success) {
            this._createSubdomainRecords(slug).catch((err)=>{
                $281a441cdcb2cf36$var$logger.warn("Failed to create DNS records for organization:", (err == null ? void 0 : err.message) || err);
            });
            return response.data;
        }
        throw new Error(response.message);
    }
    async listOrganizations() {
        this._requireReady("listOrganizations");
        const response = await this._request("/organizations", {
            method: "GET",
            methodName: "listOrganizations"
        });
        if (response.success) return response.data;
        throw new Error(response.message);
    }
    /**
   * Check whether a slug is available (not taken by a non-deleted org).
   * Server returns 404 when free, 200 with the org row when taken.
   * Returns: true = available, false = taken, null = check failed.
   *
   * Used by the NoOrgOverlay slug picker to debounce-check live as the
   * user types. Replaces a raw `fetch('/organizations?slug=X&_check=1')`
   * call site that bypassed the SDK auth header.
   */ async checkOrganizationSlug(slug) {
        var _a2;
        this._requireReady("checkOrganizationSlug");
        if (!slug) return null;
        try {
            const response = await this._request(`/organizations?slug=${encodeURIComponent(slug)}&_check=1`, {
                method: "GET",
                methodName: "checkOrganizationSlug"
            });
            if ((response == null ? void 0 : response.success) === false) return null;
            const data2 = (_a2 = response == null ? void 0 : response.data) != null ? _a2 : response;
            if (Array.isArray(data2)) return data2.length === 0;
            if (data2 && (data2.id || data2.slug)) return false;
            return true;
        } catch (err) {
            const msg = (err == null ? void 0 : err.message) || "";
            if (/404|not.?found/iu.test(msg)) return true;
            return null;
        }
    }
    async getOrganization(orgId) {
        this._requireReady("getOrganization");
        if (!orgId) throw new Error("orgId is required");
        const response = await this._request(`/organizations/${orgId}`, {
            method: "GET",
            methodName: "getOrganization"
        });
        if (response.success) return response.data;
        throw new Error(response.message);
    }
    async updateOrganization(orgId, updates) {
        this._requireReady("updateOrganization");
        if (!orgId) throw new Error("orgId is required");
        const response = await this._request(`/organizations/${orgId}`, {
            method: "PATCH",
            body: JSON.stringify(updates),
            methodName: "updateOrganization"
        });
        if (response.success) return response.data;
        throw new Error(response.message);
    }
    async transferOrgOwnership(orgId, { userId: userId }) {
        this._requireReady("transferOrgOwnership");
        if (!orgId) throw new Error("orgId is required");
        if (!userId) throw new Error("userId is required");
        const response = await this._request(`/organizations/${orgId}/transfer-ownership`, {
            method: "POST",
            body: JSON.stringify({
                userId: userId
            }),
            methodName: "transferOrgOwnership"
        });
        if (response.success) return response.data;
        throw new Error(response.message);
    }
    async deleteOrganization(orgId) {
        this._requireReady("deleteOrganization");
        if (!orgId) throw new Error("orgId is required");
        const response = await this._request(`/organizations/${orgId}`, {
            method: "DELETE",
            methodName: "deleteOrganization"
        });
        if (response.success) return response.data;
        throw new Error(response.message);
    }
    // ==================== MEMBERS ====================
    async listOrgMembers(orgId) {
        this._requireReady("listOrgMembers");
        if (!orgId) throw new Error("orgId is required");
        const response = await this._request(`/organizations/${orgId}/members`, {
            method: "GET",
            methodName: "listOrgMembers"
        });
        if (response.success) return response.data;
        throw new Error(response.message);
    }
    async addOrgMember(orgId, { userId: userId, role: role = "member" }) {
        this._requireReady("addOrgMember");
        if (!orgId) throw new Error("orgId is required");
        if (!userId) throw new Error("userId is required");
        const response = await this._request(`/organizations/${orgId}/members`, {
            method: "POST",
            body: JSON.stringify({
                userId: userId,
                role: role
            }),
            methodName: "addOrgMember"
        });
        if (response.success) return response.data;
        throw new Error(response.message);
    }
    async updateOrgMember(orgId, memberId, { role: role }) {
        this._requireReady("updateOrgMember");
        if (!orgId || !memberId) throw new Error("orgId and memberId are required");
        const response = await this._request(`/organizations/${orgId}/members/${memberId}`, {
            method: "PATCH",
            body: JSON.stringify({
                role: role
            }),
            methodName: "updateOrgMember"
        });
        if (response.success) return response.data;
        throw new Error(response.message);
    }
    async removeOrgMember(orgId, memberId) {
        this._requireReady("removeOrgMember");
        if (!orgId || !memberId) throw new Error("orgId and memberId are required");
        const response = await this._request(`/organizations/${orgId}/members/${memberId}`, {
            method: "DELETE",
            methodName: "removeOrgMember"
        });
        if (response.success) return response.data;
        throw new Error(response.message);
    }
    // ==================== TEAMS ====================
    async createTeam(orgId, { name: name, slug: slug, parentTeam: parentTeam }) {
        this._requireReady("createTeam");
        if (!orgId) throw new Error("orgId is required");
        if (!name) throw new Error("name is required");
        const response = await this._request(`/organizations/${orgId}/teams`, {
            method: "POST",
            body: JSON.stringify({
                name: name,
                slug: slug,
                parentTeam: parentTeam
            }),
            methodName: "createTeam"
        });
        if (response.success) return response.data;
        throw new Error(response.message);
    }
    async listTeams(orgId) {
        this._requireReady("listTeams");
        if (!orgId) throw new Error("orgId is required");
        const response = await this._request(`/organizations/${orgId}/teams`, {
            method: "GET",
            methodName: "listTeams"
        });
        if (response.success) return response.data;
        throw new Error(response.message);
    }
    async updateTeam(orgId, teamId, updates) {
        this._requireReady("updateTeam");
        if (!orgId || !teamId) throw new Error("orgId and teamId are required");
        const response = await this._request(`/organizations/${orgId}/teams/${teamId}`, {
            method: "PATCH",
            body: JSON.stringify(updates),
            methodName: "updateTeam"
        });
        if (response.success) return response.data;
        throw new Error(response.message);
    }
    async deleteTeam(orgId, teamId) {
        this._requireReady("deleteTeam");
        if (!orgId || !teamId) throw new Error("orgId and teamId are required");
        const response = await this._request(`/organizations/${orgId}/teams/${teamId}`, {
            method: "DELETE",
            methodName: "deleteTeam"
        });
        if (response.success) return response.data;
        throw new Error(response.message);
    }
    // ==================== TEAM MEMBERS ====================
    async listTeamMembers(orgId, teamId) {
        this._requireReady("listTeamMembers");
        if (!orgId || !teamId) throw new Error("orgId and teamId are required");
        const response = await this._request(`/organizations/${orgId}/teams/${teamId}/members`, {
            method: "GET",
            methodName: "listTeamMembers"
        });
        if (response.success) return response.data;
        throw new Error(response.message);
    }
    async addTeamMember(orgId, teamId, { userId: userId, role: role = "member" }) {
        this._requireReady("addTeamMember");
        if (!orgId || !teamId) throw new Error("orgId and teamId are required");
        if (!userId) throw new Error("userId is required");
        const response = await this._request(`/organizations/${orgId}/teams/${teamId}/members`, {
            method: "POST",
            body: JSON.stringify({
                userId: userId,
                role: role
            }),
            methodName: "addTeamMember"
        });
        if (response.success) return response.data;
        throw new Error(response.message);
    }
    async updateTeamMember(orgId, teamId, teamMemberId, { role: role }) {
        this._requireReady("updateTeamMember");
        if (!orgId || !teamId || !teamMemberId) throw new Error("orgId, teamId and teamMemberId are required");
        const response = await this._request(`/organizations/${orgId}/teams/${teamId}/members/${teamMemberId}`, {
            method: "PATCH",
            body: JSON.stringify({
                role: role
            }),
            methodName: "updateTeamMember"
        });
        if (response.success) return response.data;
        throw new Error(response.message);
    }
    async removeTeamMember(orgId, teamId, teamMemberId) {
        this._requireReady("removeTeamMember");
        if (!orgId || !teamId || !teamMemberId) throw new Error("orgId, teamId and teamMemberId are required");
        const response = await this._request(`/organizations/${orgId}/teams/${teamId}/members/${teamMemberId}`, {
            method: "DELETE",
            methodName: "removeTeamMember"
        });
        if (response.success) return response.data;
        throw new Error(response.message);
    }
    // ==================== INVITATIONS ====================
    async createOrgInvitation(orgId, { email: email, role: role = "member", teams: teams }) {
        this._requireReady("createOrgInvitation");
        if (!orgId) throw new Error("orgId is required");
        if (!email) throw new Error("email is required");
        const response = await this._request(`/organizations/${orgId}/invitations`, {
            method: "POST",
            body: JSON.stringify({
                email: email,
                role: role,
                teams: teams
            }),
            methodName: "createOrgInvitation"
        });
        if (response.success) return response.data;
        throw new Error(response.message);
    }
    async listOrgInvitations(orgId) {
        this._requireReady("listOrgInvitations");
        if (!orgId) throw new Error("orgId is required");
        const response = await this._request(`/organizations/${orgId}/invitations`, {
            method: "GET",
            methodName: "listOrgInvitations"
        });
        if (response.success) return response.data;
        throw new Error(response.message);
    }
    async revokeOrgInvitation(orgId, inviteId) {
        this._requireReady("revokeOrgInvitation");
        if (!orgId || !inviteId) throw new Error("orgId and inviteId are required");
        const response = await this._request(`/organizations/${orgId}/invitations/${inviteId}/revoke`, {
            method: "POST",
            methodName: "revokeOrgInvitation"
        });
        if (response.success) return response.data;
        throw new Error(response.message);
    }
    async acceptOrgInvitation({ token: token }) {
        this._requireReady("acceptOrgInvitation");
        if (!token) throw new Error("token is required");
        const response = await this._request("/organizations/accept-invitation", {
            method: "POST",
            body: JSON.stringify({
                token: token
            }),
            methodName: "acceptOrgInvitation"
        });
        if (response.success) return response.data;
        throw new Error(response.message);
    }
    // ==================== PROJECT PERMISSIONS ====================
    async getOrgProjectPermissions(orgId) {
        this._requireReady("getOrgProjectPermissions");
        if (!orgId) throw new Error("orgId is required");
        const response = await this._request(`/organizations/${orgId}/project-permissions`, {
            method: "GET",
            methodName: "getOrgProjectPermissions"
        });
        if (response.success) return response.data;
        throw new Error(response.message);
    }
    async updateOrgProjectPermissions(orgId, permissions) {
        this._requireReady("updateOrgProjectPermissions");
        if (!orgId) throw new Error("orgId is required");
        const response = await this._request(`/organizations/${orgId}/project-permissions`, {
            method: "PATCH",
            body: JSON.stringify(permissions),
            methodName: "updateOrgProjectPermissions"
        });
        if (response.success) return response.data;
        throw new Error(response.message);
    }
    // ==================== TEAM PROJECT ACCESS ====================
    async listTeamAccess(orgId, teamId) {
        this._requireReady("listTeamAccess");
        if (!orgId || !teamId) throw new Error("orgId and teamId are required");
        const response = await this._request(`/organizations/${orgId}/teams/${teamId}/access`, {
            method: "GET",
            methodName: "listTeamAccess"
        });
        if (response.success) return response.data;
        throw new Error(response.message);
    }
    async grantTeamAccess(orgId, teamId, { projectId: projectId, role: role = "editor" }) {
        this._requireReady("grantTeamAccess");
        if (!orgId || !teamId) throw new Error("orgId and teamId are required");
        if (!projectId) throw new Error("projectId is required");
        const response = await this._request(`/organizations/${orgId}/teams/${teamId}/access`, {
            method: "POST",
            body: JSON.stringify({
                projectId: projectId,
                role: role
            }),
            methodName: "grantTeamAccess"
        });
        if (response.success) return response.data;
        throw new Error(response.message);
    }
    async updateTeamAccess(orgId, teamId, accessId, { role: role }) {
        this._requireReady("updateTeamAccess");
        if (!orgId || !teamId || !accessId) throw new Error("orgId, teamId and accessId are required");
        const response = await this._request(`/organizations/${orgId}/teams/${teamId}/access/${accessId}`, {
            method: "PATCH",
            body: JSON.stringify({
                role: role
            }),
            methodName: "updateTeamAccess"
        });
        if (response.success) return response.data;
        throw new Error(response.message);
    }
    async revokeTeamAccess(orgId, teamId, accessId) {
        this._requireReady("revokeTeamAccess");
        if (!orgId || !teamId || !accessId) throw new Error("orgId, teamId and accessId are required");
        const response = await this._request(`/organizations/${orgId}/teams/${teamId}/access/${accessId}`, {
            method: "DELETE",
            methodName: "revokeTeamAccess"
        });
        if (response.success) return response.data;
        throw new Error(response.message);
    }
    // ==================== ORG PROJECTS ====================
    async createOrgProject(orgId, projectData) {
        this._requireReady("createOrgProject");
        if (!orgId) throw new Error("orgId is required");
        const response = await this._request(`/organizations/${orgId}/projects`, {
            method: "POST",
            body: JSON.stringify(projectData),
            methodName: "createOrgProject"
        });
        if (response.success) return response.data;
        throw new Error(response.message);
    }
    // ==================== CREDIT POOL ====================
    async getCreditPool(orgId) {
        this._requireReady("getCreditPool");
        if (!orgId) throw new Error("orgId is required");
        const response = await this._request(`/organizations/${orgId}/credit-pool`, {
            method: "GET",
            methodName: "getCreditPool"
        });
        if (response.success) return response.data;
        throw new Error(response.message);
    }
    async updateCreditPool(orgId, pooledCredits) {
        this._requireReady("updateCreditPool");
        if (!orgId) throw new Error("orgId is required");
        const response = await this._request(`/organizations/${orgId}/credit-pool`, {
            method: "PATCH",
            body: JSON.stringify({
                pooledCredits: pooledCredits
            }),
            methodName: "updateCreditPool"
        });
        if (response.success) return response.data;
        throw new Error(response.message);
    }
    // ==================== SSO ====================
    async getSso(orgId) {
        this._requireReady("getSso");
        if (!orgId) throw new Error("orgId is required");
        const response = await this._request(`/organizations/${orgId}/sso`, {
            method: "GET",
            methodName: "getSso"
        });
        if (response.success) return response.data;
        throw new Error(response.message);
    }
    async updateSso(orgId, sso) {
        this._requireReady("updateSso");
        if (!orgId) throw new Error("orgId is required");
        const response = await this._request(`/organizations/${orgId}/sso`, {
            method: "PATCH",
            body: JSON.stringify(sso || {}),
            methodName: "updateSso"
        });
        if (response.success) return response.data;
        throw new Error(response.message);
    }
    // ==================== SCIM ====================
    async getScim(orgId) {
        this._requireReady("getScim");
        if (!orgId) throw new Error("orgId is required");
        const response = await this._request(`/organizations/${orgId}/scim`, {
            method: "GET",
            methodName: "getScim"
        });
        if (response.success) return response.data;
        throw new Error(response.message);
    }
    async updateScim(orgId, { enabled: enabled, rotateToken: rotateToken } = {}) {
        this._requireReady("updateScim");
        if (!orgId) throw new Error("orgId is required");
        const body = {};
        if (enabled !== void 0) body.enabled = enabled;
        if (rotateToken !== void 0) body.rotateToken = rotateToken;
        const response = await this._request(`/organizations/${orgId}/scim`, {
            method: "PATCH",
            body: JSON.stringify(body),
            methodName: "updateScim"
        });
        if (response.success) return response.data;
        throw new Error(response.message);
    }
    // ==================== ADMIN ====================
    // ==================== CUSTOM ROLES (Phase C/D) ====================
    //
    // Per-org custom roles layered on top of the built-in tier (owner /
    // co-owner / admin / member). Each custom role declares a `baseTier`
    // (the fallback authority) + an optional `additionalPermissions`
    // list from the enum in constants/orgPermissions.js. Mutations are
    // gated to owner / co-owner / admin on the server.
    //
    // `effective-role` resolves any member to their final `{ role,
    // baseTier, permissions, isBuiltin, source }` — factoring in custom
    // role assignments. Listing is open to any org member.
    /**
   * List every role defined for an org — builtin tiers plus org-specific
   * custom roles. Open to any org member.
   * @param {string} orgId
   * @returns {Promise<object>} - server response envelope
   */ async listOrgRoles(orgId) {
        if (!orgId) throw new Error("orgId is required");
        return this._call("listOrgRoles", `/organizations/${orgId}/roles`);
    }
    /**
   * Create a custom role on an org. Server slugifies `key` and 409s on
   * collision with an existing role. `additionalPermissions` is optional.
   * @param {string} orgId
   * @param {{key: string, name: string, baseTier: string, description?: string, additionalPermissions?: Array<string>}} role
   */ async createOrgRole(orgId, role = {}) {
        if (!orgId) throw new Error("orgId is required");
        if (!role.key) throw new Error("role.key is required");
        if (!role.name) throw new Error("role.name is required");
        if (!role.baseTier) throw new Error("role.baseTier is required");
        return this._call("createOrgRole", `/organizations/${orgId}/roles`, {
            method: "POST",
            body: role
        });
    }
    /**
   * Patch an existing custom role. Pass only the fields that should change.
   * @param {string} orgId
   * @param {string} roleKey
   * @param {{name?: string, description?: string, baseTier?: string, additionalPermissions?: Array<string>}} updates
   */ async updateOrgRole(orgId, roleKey, updates = {}) {
        if (!orgId) throw new Error("orgId is required");
        if (!roleKey) throw new Error("roleKey is required");
        if (Object.keys(updates).length === 0) throw new Error("updates cannot be empty");
        return this._call("updateOrgRole", `/organizations/${orgId}/roles/${encodeURIComponent(roleKey)}`, {
            method: "PATCH",
            body: updates
        });
    }
    /**
   * Delete a custom role. Every member currently holding it is
   * auto-reassigned to the role's `baseTier` on the server side.
   * Audit-logged.
   * @param {string} orgId
   * @param {string} roleKey
   */ async deleteOrgRole(orgId, roleKey) {
        if (!orgId) throw new Error("orgId is required");
        if (!roleKey) throw new Error("roleKey is required");
        return this._call("deleteOrgRole", `/organizations/${orgId}/roles/${encodeURIComponent(roleKey)}`, {
            method: "DELETE"
        });
    }
    /**
   * Resolve a member's effective authority — baseTier + permissions after
   * folding in any custom role they hold. Read-only; open to any org
   * member for auditing.
   * @param {string} orgId
   * @param {string} memberId
   * @returns {Promise<{role: string, baseTier: string, permissions: Array<string>, isBuiltin: boolean, source: string}>}
   */ async getMemberEffectiveRole(orgId, memberId) {
        if (!orgId) throw new Error("orgId is required");
        if (!memberId) throw new Error("memberId is required");
        return this._call("getMemberEffectiveRole", `/organizations/${orgId}/members/${memberId}/effective-role`);
    }
    /**
   * List org-level Payment rows (Enterprise consolidated billing).
   * Server-side gate: owner / co-owner (BILLING_EXCLUSIVE tier);
   * admins do NOT see financial history by default.
   * @param {string} orgId
   * @returns {Promise<{payments: Array<object>, total?: number}>}
   */ async listOrgPayments(orgId) {
        this._requireReady("listOrgPayments");
        if (!orgId) throw new Error("orgId is required");
        const response = await this._request(`/organizations/${orgId}/payments`, {
            method: "GET",
            methodName: "listOrgPayments"
        });
        if (response == null ? void 0 : response.success) return response.data;
        return {
            payments: []
        };
    }
    // ==================== TEAM INVITATIONS (Phase B) ====================
    //
    // Email-based invitations scoped to a single team. Token carries the
    // (org, team, email, inviteId) tuple so the accept endpoint doesn't
    // need path params. All mutations gated to owner / co-owner / admin
    // on the server.
    /**
   * List pending invitations for a team.
   * @param {string} orgId
   * @param {string} teamId
   * @returns {Promise<{invitations: Array<object>}>}
   */ async listTeamInvitations(orgId, teamId) {
        this._requireReady("listTeamInvitations");
        if (!orgId || !teamId) throw new Error("orgId and teamId are required");
        const response = await this._request(`/organizations/${orgId}/teams/${teamId}/invitations`, {
            method: "GET",
            methodName: "listTeamInvitations"
        });
        if (response == null ? void 0 : response.success) return response.data;
        return {
            invitations: []
        };
    }
    /**
   * Send a team invitation by email. `recipientName` is optional; the
   * server generates a nanoid token + expiry.
   * @param {string} orgId
   * @param {string} teamId
   * @param {{email: string, recipientName?: string}} args
   */ async createTeamInvitation(orgId, teamId, { email: email, recipientName: recipientName } = {}) {
        if (!orgId || !teamId) throw new Error("orgId and teamId are required");
        if (!email) throw new Error("email is required");
        return this._call("createTeamInvitation", `/organizations/${orgId}/teams/${teamId}/invitations`, {
            method: "POST",
            body: {
                email: email,
                ...recipientName ? {
                    recipientName: recipientName
                } : {}
            }
        });
    }
    /**
   * Alias for createTeamInvitation — read-friendly name for DOMQL call
   * sites that say "invite this email to this team" rather than spelling
   * out the create-invitation operation. Surfaced via SERVICE_METHODS so
   * `getSDK().inviteToTeam(orgId, teamId, payload)` works flat.
   */ async inviteToTeam(orgId, teamId, payload) {
        return this.createTeamInvitation(orgId, teamId, payload);
    }
    /**
   * Revoke a pending team invitation. 404 if already accepted/revoked.
   * @param {string} orgId
   * @param {string} teamId
   * @param {string} inviteId
   */ async revokeTeamInvitation(orgId, teamId, inviteId) {
        if (!orgId || !teamId) throw new Error("orgId and teamId are required");
        if (!inviteId) throw new Error("inviteId is required");
        return this._call("revokeTeamInvitation", `/organizations/${orgId}/teams/${teamId}/invitations/${inviteId}/revoke`, {
            method: "POST"
        });
    }
    /**
   * Accept a team invitation. The signed token carries org / team /
   * email / inviteId — no path params needed.
   * @param {{token: string}} args
   */ async acceptTeamInvitation({ token: token } = {}) {
        if (!token) throw new Error("token is required");
        return this._call("acceptTeamInvitation", "/organizations/accept-team-invitation", {
            method: "POST",
            body: {
                token: token
            }
        });
    }
    // ==================== TEAM WORKSPACE ACCESS ====================
    //
    // Parallel to team-project access (see listTeamAccess / grantTeamAccess
    // above) but at the workspace level. Cross-tenant grants blocked
    // server-side — the team + workspace must share the same org.
    /**
   * List all workspace-level access grants for a team.
   * @param {string} orgId
   * @param {string} teamId
   * @returns {Promise<{grants: Array<object>}>}
   */ async listTeamWorkspaceAccess(orgId, teamId) {
        this._requireReady("listTeamWorkspaceAccess");
        if (!orgId || !teamId) throw new Error("orgId and teamId are required");
        const response = await this._request(`/organizations/${orgId}/teams/${teamId}/workspace-access`, {
            method: "GET",
            methodName: "listTeamWorkspaceAccess"
        });
        if (response == null ? void 0 : response.success) return response.data;
        return {
            grants: []
        };
    }
    /**
   * Grant a team access to a workspace. Idempotent upsert — same
   * (team, workspace) always maps to a single row; role updates
   * transparently.
   * @param {string} orgId
   * @param {string} teamId
   * @param {{workspaceId: string, role?: string}} args - role defaults to 'guest'
   */ async grantTeamWorkspaceAccess(orgId, teamId, { workspaceId: workspaceId, role: role = "guest" } = {}) {
        if (!orgId || !teamId) throw new Error("orgId and teamId are required");
        if (!workspaceId) throw new Error("workspaceId is required");
        return this._call("grantTeamWorkspaceAccess", `/organizations/${orgId}/teams/${teamId}/workspace-access`, {
            method: "POST",
            body: {
                workspaceId: workspaceId,
                role: role
            }
        });
    }
    /**
   * Change the role of an existing team-workspace grant.
   * @param {string} orgId
   * @param {string} teamId
   * @param {string} accessId
   * @param {{role: string}} updates
   */ async updateTeamWorkspaceAccess(orgId, teamId, accessId, { role: role } = {}) {
        if (!orgId || !teamId || !accessId) throw new Error("orgId, teamId and accessId are required");
        if (!role) throw new Error("role is required");
        return this._call("updateTeamWorkspaceAccess", `/organizations/${orgId}/teams/${teamId}/workspace-access/${accessId}`, {
            method: "PATCH",
            body: {
                role: role
            }
        });
    }
    /**
   * Revoke a team-workspace access grant.
   * @param {string} orgId
   * @param {string} teamId
   * @param {string} accessId
   */ async revokeTeamWorkspaceAccess(orgId, teamId, accessId) {
        if (!orgId || !teamId || !accessId) throw new Error("orgId, teamId and accessId are required");
        return this._call("revokeTeamWorkspaceAccess", `/organizations/${orgId}/teams/${teamId}/workspace-access/${accessId}`, {
            method: "DELETE"
        });
    }
    async adminListOrganizations(params2 = {}) {
        this._requireReady("adminListOrganizations");
        const queryParams = new URLSearchParams();
        if (params2.status) queryParams.append("status", params2.status);
        if (params2.page) queryParams.append("page", params2.page.toString());
        if (params2.limit) queryParams.append("limit", params2.limit.toString());
        const queryString = queryParams.toString();
        const response = queryString ? await this._request(`/organizations/admin?${queryString}`, {
            method: "GET",
            methodName: "adminListOrganizations"
        }) : await this._request("/organizations/admin", {
            method: "GET",
            methodName: "adminListOrganizations"
        });
        if (response.success) return response.data;
        throw new Error(response.message);
    }
    // ==================== ADMIN-ONLY / ENTERPRISE BOOTSTRAP ====================
    /**
   * List every team in an org including confidential ones. Owner /
   * co-owner only on the server — admin bypass of the default team
   * visibility filter for audit + governance use.
   * @param {string} orgId
   * @returns {Promise<{teams: Array<object>}>}
   */ async adminListAllTeams(orgId) {
        this._requireReady("adminListAllTeams");
        if (!orgId) throw new Error("orgId is required");
        const response = await this._request(`/organizations/${orgId}/teams/admin/all`, {
            method: "GET",
            methodName: "adminListAllTeams"
        });
        if (response == null ? void 0 : response.success) return response.data;
        return {
            teams: []
        };
    }
    /**
   * Add the calling owner / co-owner to a confidential team as
   * team-maintainer — break-glass for audit situations where the admin
   * isn't a member. Audit-logged on the server. 400s if the team is not
   * `isolation === 'confidential'`.
   * @param {string} orgId
   * @param {string} teamId
   */ async adminOverrideTeam(orgId, teamId) {
        if (!orgId || !teamId) throw new Error("orgId and teamId are required");
        return this._call("adminOverrideTeam", `/organizations/${orgId}/teams/${teamId}/admin-override`, {
            method: "POST"
        });
    }
    /**
   * Idempotently bootstrap the org's unified Enterprise Stripe customer.
   * Global-admin-only on the server. Used by ops during Enterprise
   * provisioning; self-service Enterprise upgrades land in a later phase.
   * @param {string} orgId
   * @returns {Promise<{orgId: string, stripeCustomerId: string, created: boolean}>}
   */ async ensureOrgStripeCustomer(orgId) {
        if (!orgId) throw new Error("orgId is required");
        return this._call("ensureOrgStripeCustomer", `/organizations/${orgId}/stripe/customer`, {
            method: "POST"
        });
    }
};
// src/services/WorkspaceService.js
var $281a441cdcb2cf36$var$WorkspaceService = class extends $281a441cdcb2cf36$var$BaseService {
    // ==================== WORKSPACE CRUD ====================
    async createWorkspace({ organization: organization, displayName: displayName, slug: slug }) {
        if (!organization) throw new Error("organization is required");
        if (!displayName) throw new Error("displayName is required");
        return this._call("createWorkspace", "/workspaces", {
            method: "POST",
            body: {
                organization: organization,
                displayName: displayName,
                slug: slug
            }
        });
    }
    async listWorkspaces({ organization: organization, page: page, limit: limit } = {}) {
        const params2 = new URLSearchParams();
        if (organization) params2.set("organization", organization);
        if (page) params2.set("page", String(page));
        if (limit) params2.set("limit", String(limit));
        const qs = params2.toString() ? `?${params2}` : "";
        return this._call("listWorkspaces", `/workspaces${qs}`);
    }
    async getWorkspace(workspaceId) {
        if (!workspaceId) throw new Error("workspaceId is required");
        return this._call("getWorkspace", `/workspaces/${workspaceId}`);
    }
    async updateWorkspace(workspaceId, updates) {
        if (!workspaceId) throw new Error("workspaceId is required");
        return this._call("updateWorkspace", `/workspaces/${workspaceId}`, {
            method: "PATCH",
            body: updates
        });
    }
    async deleteWorkspace(workspaceId) {
        if (!workspaceId) throw new Error("workspaceId is required");
        return this._call("deleteWorkspace", `/workspaces/${workspaceId}`, {
            method: "DELETE"
        });
    }
    // ==================== MEMBERS ====================
    async listWorkspaceMembers(workspaceId) {
        if (!workspaceId) throw new Error("workspaceId is required");
        return this._call("listWorkspaceMembers", `/workspaces/${workspaceId}/members`);
    }
    async addWorkspaceMember(workspaceId, { userId: userId, role: role = "editor" }) {
        if (!workspaceId) throw new Error("workspaceId is required");
        if (!userId) throw new Error("userId is required");
        if (!$281a441cdcb2cf36$var$WORKSPACE_MEMBER_ROLES.includes(role)) throw new Error(`Invalid role: ${role}. Must be one of: ${$281a441cdcb2cf36$var$WORKSPACE_MEMBER_ROLES.join(", ")}`);
        return this._call("addWorkspaceMember", `/workspaces/${workspaceId}/members`, {
            method: "POST",
            body: {
                userId: userId,
                role: role
            }
        });
    }
    async updateWorkspaceMemberRole(workspaceId, userId, { role: role }) {
        if (!workspaceId || !userId || !role) throw new Error("workspaceId, userId, role are required");
        if (!$281a441cdcb2cf36$var$WORKSPACE_MEMBER_ROLES.includes(role)) throw new Error(`Invalid role: ${role}. Must be one of: ${$281a441cdcb2cf36$var$WORKSPACE_MEMBER_ROLES.join(", ")}`);
        return this._call("updateWorkspaceMemberRole", `/workspaces/${workspaceId}/members/${userId}`, {
            method: "PATCH",
            body: {
                role: role
            }
        });
    }
    async removeWorkspaceMember(workspaceId, userId) {
        if (!workspaceId || !userId) throw new Error("workspaceId and userId are required");
        return this._call("removeWorkspaceMember", `/workspaces/${workspaceId}/members/${userId}`, {
            method: "DELETE"
        });
    }
    // ==================== TEAM GRANTS (TeamWorkspaceAccess) ====================
    async grantWorkspaceTeamAccess(workspaceId, { teamId: teamId, role: role = "guest" }) {
        if (!workspaceId || !teamId) throw new Error("workspaceId and teamId are required");
        if (!$281a441cdcb2cf36$var$TEAM_GRANT_ROLES.includes(role)) throw new Error(`Invalid role: ${role}. Must be one of: ${$281a441cdcb2cf36$var$TEAM_GRANT_ROLES.join(", ")}`);
        return this._call("grantWorkspaceTeamAccess", `/workspaces/${workspaceId}/team-access`, {
            method: "POST",
            body: {
                teamId: teamId,
                role: role
            }
        });
    }
    async revokeWorkspaceTeamAccess(workspaceId, teamId) {
        if (!workspaceId || !teamId) throw new Error("workspaceId and teamId are required");
        return this._call("revokeWorkspaceTeamAccess", `/workspaces/${workspaceId}/team-access/${teamId}`, {
            method: "DELETE"
        });
    }
    // ==================== BILLING + CREDITS ====================
    async getBilling(workspaceId) {
        if (!workspaceId) throw new Error("workspaceId is required");
        return this._call("getBilling", `/workspaces/${workspaceId}/billing`);
    }
    async getCreditBalance(workspaceId) {
        if (!workspaceId) throw new Error("workspaceId is required");
        return this._call("getCreditBalance", `/workspaces/${workspaceId}/credits/balance`);
    }
    async getCreditLedger(workspaceId, { limit: limit, before: before, reason: reason } = {}) {
        if (!workspaceId) throw new Error("workspaceId is required");
        const params2 = new URLSearchParams();
        if (limit) params2.set("limit", String(limit));
        if (before) params2.set("before", String(before));
        if (reason) params2.set("reason", String(reason));
        const qs = params2.toString() ? `?${params2}` : "";
        return this._call("getCreditLedger", `/workspaces/${workspaceId}/credits/ledger${qs}`);
    }
    // ==================== SPEND CONTROLS ====================
    async getSpendControls(workspaceId) {
        if (!workspaceId) throw new Error("workspaceId is required");
        return this._call("getSpendControls", `/workspaces/${workspaceId}/spend-controls`);
    }
    async updateSpendControls(workspaceId, controls) {
        if (!workspaceId) throw new Error("workspaceId is required");
        return this._call("updateSpendControls", `/workspaces/${workspaceId}/spend-controls`, {
            method: "PATCH",
            body: controls
        });
    }
    // ==================== PERMISSIONS ====================
    /**
   * Return the caller's resolved workspace permissions — source-of-truth
   * for UI gating (edit/invite/billing/etc.). Open to any workspace
   * member.
   * @param {string} workspaceId
   */ async getWorkspacePermissions(workspaceId) {
        if (!workspaceId) throw new Error("workspaceId is required");
        return this._call("getWorkspacePermissions", `/workspaces/${workspaceId}/permissions`);
    }
    // ==================== WORKSPACE-SCOPED PROJECTS ====================
    /**
   * Create a project scoped to a workspace. Server aliases this to
   * `POST /projects` with the workspace FK pre-populated — owner is the
   * calling user, workspace is the path param.
   * @param {string} workspaceId
   * @param {object} projectData - same shape as `projectService.createProject`
   */ async createWorkspaceProject(workspaceId, projectData) {
        if (!workspaceId) throw new Error("workspaceId is required");
        return this._call("createWorkspaceProject", `/workspaces/${workspaceId}/projects`, {
            method: "POST",
            body: projectData
        });
    }
    // ==================== INVITATIONS ====================
    //
    // Email-based invites scoped to a workspace. Owner/admin-gated for
    // create + revoke; listing returns only the caller's pending invites
    // for non-admin members. Accept is public (authenticated) — the token
    // carries the workspaceId + inviteId.
    /**
   * List pending workspace invitations. Owner/admin see all; regular
   * members see only their own.
   * @param {string} workspaceId
   */ async listWorkspaceInvitations(workspaceId) {
        if (!workspaceId) throw new Error("workspaceId is required");
        return this._call("listWorkspaceInvitations", `/workspaces/${workspaceId}/invitations`);
    }
    /**
   * Send a workspace invitation by email.
   * @param {string} workspaceId
   * @param {{email: string, role?: string, recipientName?: string}} args - role defaults to 'editor'
   */ async createWorkspaceInvitation(workspaceId, { email: email, role: role = "editor", recipientName: recipientName } = {}) {
        if (!workspaceId) throw new Error("workspaceId is required");
        if (!email) throw new Error("email is required");
        return this._call("createWorkspaceInvitation", `/workspaces/${workspaceId}/invitations`, {
            method: "POST",
            body: {
                email: email,
                role: role,
                ...recipientName ? {
                    recipientName: recipientName
                } : {}
            }
        });
    }
    /**
   * Revoke a pending workspace invitation. 404 if already accepted or
   * revoked.
   * @param {string} workspaceId
   * @param {string} inviteId
   */ async revokeWorkspaceInvitation(workspaceId, inviteId) {
        if (!workspaceId) throw new Error("workspaceId is required");
        if (!inviteId) throw new Error("inviteId is required");
        return this._call("revokeWorkspaceInvitation", `/workspaces/${workspaceId}/invitations/${inviteId}/revoke`, {
            method: "POST"
        });
    }
    /**
   * Accept a workspace invitation. The signed token carries
   * workspaceId + inviteId + invited email — no path params. Idempotent:
   * double-click on the same invite returns 200 without creating
   * duplicate memberships.
   * @param {{token: string}} args
   */ async acceptWorkspaceInvitation({ token: token } = {}) {
        if (!token) throw new Error("token is required");
        return this._call("acceptWorkspaceInvitation", "/workspaces/accept-invitation", {
            method: "POST",
            body: {
                token: token
            }
        });
    }
};
// src/services/WorkspaceProjectService.js
var $281a441cdcb2cf36$var$WORKSPACE_PROJECT_PREFIX = "/workspace-project";
var $281a441cdcb2cf36$export$59dd0c3383896351 = (apiBase)=>`${apiBase}${$281a441cdcb2cf36$var$WORKSPACE_PROJECT_PREFIX}`;
var $281a441cdcb2cf36$var$WorkspaceDataService = class extends $281a441cdcb2cf36$var$BaseService {
    constructor(){
        super(...arguments);
        // --- Tickets ----------------------------------------------------------------
        $281a441cdcb2cf36$var$__publicField(this, "tickets", {
            list: (filter, options)=>this._ws("tickets.list", "/tickets", {
                    method: "POST",
                    body: {
                        filter: filter,
                        options: options
                    }
                }),
            get: (number)=>this._ws("tickets.get", `/tickets/${encodeURIComponent(number)}`),
            create: (payload)=>this._ws("tickets.create", "/tickets", {
                    method: "POST",
                    body: {
                        payload: payload
                    }
                }),
            update: (number, payload)=>this._ws("tickets.update", `/tickets/${encodeURIComponent(number)}`, {
                    method: "PATCH",
                    body: {
                        payload: payload
                    }
                }),
            remove: (number)=>this._ws("tickets.remove", `/tickets/${encodeURIComponent(number)}`, {
                    method: "DELETE"
                }),
            epicCounts: ()=>this._ws("tickets.epicCounts", "/tickets/epic-counts"),
            assign: (id2, assigneeEmail)=>this._ws("tickets.assign", `/tickets/${encodeURIComponent(id2)}/assign`, {
                    method: "POST",
                    body: {
                        assigneeEmail: assigneeEmail
                    }
                })
        });
        // --- Chat -------------------------------------------------------------------
        $281a441cdcb2cf36$var$__publicField(this, "chat", {
            listChannels: ()=>this._ws("chat.listChannels", "/chat/channels"),
            createChannel: (payload)=>this._ws("chat.createChannel", "/chat/channels", {
                    method: "POST",
                    body: {
                        payload: payload
                    }
                }),
            updateChannel: (channelId, payload)=>this._ws("chat.updateChannel", `/chat/channels/${encodeURIComponent(channelId)}`, {
                    method: "PATCH",
                    body: {
                        payload: payload
                    }
                }),
            removeChannel: (channelId)=>this._ws("chat.removeChannel", `/chat/channels/${encodeURIComponent(channelId)}`, {
                    method: "DELETE"
                }),
            listMessages: (channelId, options)=>channelId ? this._ws("chat.listMessages", `/chat/channels/${encodeURIComponent(channelId)}/messages`, {
                    ...options ? {
                        method: "POST",
                        body: {
                            options: options
                        }
                    } : {}
                }) : this._ws("chat.listAllMessages", "/chat/messages"),
            sendMessage: (channelId, payload)=>this._ws("chat.sendMessage", `/chat/channels/${encodeURIComponent(channelId)}/messages`, {
                    method: "POST",
                    body: {
                        payload: payload
                    }
                }),
            updateMessage: (messageId, payload)=>this._ws("chat.updateMessage", `/chat/messages/${encodeURIComponent(messageId)}`, {
                    method: "PATCH",
                    body: {
                        payload: payload
                    }
                }),
            removeMessage: (messageId)=>this._ws("chat.removeMessage", `/chat/messages/${encodeURIComponent(messageId)}`, {
                    method: "DELETE"
                }),
            toggleReaction: (messageId, emoji, userId)=>this._ws("chat.toggleReaction", `/chat/messages/${encodeURIComponent(messageId)}/reactions`, {
                    method: "POST",
                    body: {
                        emoji: emoji,
                        userId: userId
                    }
                }),
            listMembers: (channelId)=>channelId ? this._ws("chat.listMembers", `/chat/channels/${encodeURIComponent(channelId)}/members`) : this._ws("chat.listAllMembers", "/chat/members"),
            addMember: (channelId, payload)=>this._ws("chat.addMember", `/chat/channels/${encodeURIComponent(channelId)}/members`, {
                    method: "POST",
                    body: {
                        payload: payload
                    }
                }),
            updateMember: (channelId, userId, payload)=>this._ws("chat.updateMember", `/chat/channels/${encodeURIComponent(channelId)}/members/${encodeURIComponent(userId)}`, {
                    method: "PATCH",
                    body: {
                        payload: payload
                    }
                }),
            removeMember: (channelId, userId)=>this._ws("chat.removeMember", `/chat/channels/${encodeURIComponent(channelId)}/members/${encodeURIComponent(userId)}`, {
                    method: "DELETE"
                }),
            markRead: (channelId, userId, lastReadAt)=>this._ws("chat.markRead", `/chat/channels/${encodeURIComponent(channelId)}/members/${encodeURIComponent(userId)}/read`, {
                    method: "POST",
                    body: {
                        lastReadAt: lastReadAt
                    }
                }),
            muteChannel: (channelId, userId, muted)=>this._ws("chat.muteChannel", `/chat/channels/${encodeURIComponent(channelId)}/members/${encodeURIComponent(userId)}/mute`, {
                    method: "POST",
                    body: {
                        muted: muted
                    }
                }),
            listMentions: (filter, options)=>this._ws("chat.listMentions", "/chat/mentions", {
                    method: "POST",
                    body: {
                        filter: filter,
                        options: options
                    }
                }),
            // Mark every chat_mention for the caller in a channel as read. Wraps the
            // chat_mark_mentions_read SQL function — see migration 0015.
            markMentionsRead: (channelId, callerEmail)=>this._ws("chat.markMentionsRead", `/chat/channels/${encodeURIComponent(channelId)}/mentions/read`, {
                    method: "POST",
                    body: {
                        callerEmail: callerEmail
                    }
                }),
            // Full-text search over messages in channels the caller belongs to.
            // Wraps the chat_search_messages SQL function — see migration 0014.
            searchMessages: (q3, callerEmail)=>this._ws("chat.searchMessages", "/chat/search", {
                    method: "POST",
                    body: {
                        q: q3,
                        callerEmail: callerEmail
                    }
                })
        });
        // --- Calendar ---------------------------------------------------------------
        $281a441cdcb2cf36$var$__publicField(this, "calendar", {
            listEvents: (filter)=>this._ws("calendar.listEvents", "/calendar/events", {
                    method: "POST",
                    body: {
                        filter: filter
                    }
                }),
            getEvent: (id2)=>this._ws("calendar.getEvent", `/calendar/events/${encodeURIComponent(id2)}`),
            createEvent: (payload)=>this._ws("calendar.createEvent", "/calendar/events", {
                    method: "POST",
                    body: {
                        payload: payload
                    }
                }),
            updateEvent: (id2, payload)=>this._ws("calendar.updateEvent", `/calendar/events/${encodeURIComponent(id2)}`, {
                    method: "PATCH",
                    body: {
                        payload: payload
                    }
                }),
            deleteEvent: (id2)=>this._ws("calendar.deleteEvent", `/calendar/events/${encodeURIComponent(id2)}`, {
                    method: "DELETE"
                }),
            sync: (params2)=>this._ws("calendar.sync", "/calendar/sync", {
                    method: "POST",
                    body: {
                        params: params2
                    }
                })
        });
        // --- Meet -------------------------------------------------------------------
        $281a441cdcb2cf36$var$__publicField(this, "meet", {
            listRooms: ()=>this._ws("meet.listRooms", "/meet/rooms"),
            createRoom: (payload)=>this._ws("meet.createRoom", "/meet/rooms", {
                    method: "POST",
                    body: {
                        payload: payload
                    }
                }),
            getRoom: (id2)=>this._ws("meet.getRoom", `/meet/rooms/${encodeURIComponent(id2)}`),
            // Update a meet_rooms row — name, privacy, guest-join policy, etc.
            // Replaces direct sb.from('meet_rooms').update(...).eq('id', id) calls
            // in updateRoomSettings.js. RLS policy meet_rooms_update gates this to
            // the room creator/admins.
            updateRoom: (id2, payload)=>this._ws("meet.updateRoom", `/meet/rooms/${encodeURIComponent(id2)}`, {
                    method: "PATCH",
                    body: {
                        payload: payload
                    }
                }),
            // Mark the room as ended (sets ended_at). Distinct PATCH ergonomically —
            // callers don't have to construct the timestamp; server stamps it.
            // Reopening a room flips ended_at back to null (see reopenRoom).
            endRoom: (id2)=>this._ws("meet.endRoom", `/meet/rooms/${encodeURIComponent(id2)}/end`, {
                    method: "POST"
                }),
            reopenRoom: (id2)=>this._ws("meet.reopenRoom", `/meet/rooms/${encodeURIComponent(id2)}/reopen`, {
                    method: "POST"
                }),
            listMembers: (id2)=>this._ws("meet.listMembers", `/meet/rooms/${encodeURIComponent(id2)}/members`),
            // Add a member row to a meet room. Replaces direct
            // sb.from('meet_room_members').insert(...) in createRoom.js — the
            // meet_members_insert RLS policy allows user_id = auth.uid() inserts
            // so self-join from a shared URL still works.
            addMember: (roomId, payload)=>this._ws("meet.addMember", `/meet/rooms/${encodeURIComponent(roomId)}/members`, {
                    method: "POST",
                    body: {
                        payload: payload
                    }
                }),
            listTranscripts: (id2)=>this._ws("meet.listTranscripts", `/meet/rooms/${encodeURIComponent(id2)}/transcripts`),
            // Raw transcribed utterances (was sb().from('meet_transcripts').select())
            // — individual speech segments, distinct from the higher-level
            // transcript analysis summaries returned by listTranscripts.
            listUtterances: (id2)=>this._ws("meet.listUtterances", `/meet/rooms/${encodeURIComponent(id2)}/utterances`),
            waitingRoom: ()=>this._ws("meet.waitingRoom", "/meet/waiting-room"),
            // Host actions on a meet_waiting_room row. RLS policy
            // meet_waiting_room_update gates these to the parent room's creator
            // via is_meet_room_owner. Replaces direct sb.from('meet_waiting_room')
            // .update() calls in updateRoomSettings.js.
            admitGuest: (waitingId)=>this._ws("meet.admitGuest", `/meet/waiting-room/${encodeURIComponent(waitingId)}/admit`, {
                    method: "POST"
                }),
            rejectGuest: (waitingId)=>this._ws("meet.rejectGuest", `/meet/waiting-room/${encodeURIComponent(waitingId)}/reject`, {
                    method: "POST"
                }),
            issueToken: (params2)=>this._ws("meet.issueToken", "/meet/token", {
                    method: "POST",
                    body: {
                        params: params2
                    }
                }),
            // Combined transcript+analysis view — wraps the
            // `get_meet_transcript_view(uuid)` RPC. Returns
            // { utterances, analysis } in a single round-trip; replaces the
            // previous two-query pattern in MeetTranscriptPage.
            getTranscriptView: (roomId)=>this._ws("meet.getTranscriptView", `/meet/rooms/${encodeURIComponent(roomId)}/transcript-view`),
            // Patch the `applied_items` array on a meet_transcript_analyses row
            // when the user "applies" a suggestion (saves as note, creates
            // ticket, etc). RLS allows room members to modify this column only.
            updateAnalysisAppliedItems: (roomId, appliedItems)=>this._ws("meet.updateAnalysisAppliedItems", `/meet/rooms/${encodeURIComponent(roomId)}/analysis/applied-items`, {
                    method: "PATCH",
                    body: {
                        applied_items: appliedItems
                    }
                })
        });
        // --- Documents --------------------------------------------------------------
        $281a441cdcb2cf36$var$__publicField(this, "documents", {
            list: ()=>this._ws("documents.list", "/documents"),
            create: (payload)=>this._ws("documents.create", "/documents", {
                    method: "POST",
                    body: {
                        payload: payload
                    }
                }),
            get: (id2)=>this._ws("documents.get", `/documents/${encodeURIComponent(id2)}`),
            update: (id2, payload)=>this._ws("documents.update", `/documents/${encodeURIComponent(id2)}`, {
                    method: "PATCH",
                    body: {
                        payload: payload
                    }
                }),
            remove: (id2)=>this._ws("documents.remove", `/documents/${encodeURIComponent(id2)}`, {
                    method: "DELETE"
                }),
            listKb: ()=>this._ws("documents.listKb", "/documents/kb"),
            // Create a knowledge-base article. Wraps the `kb_articles` table insert
            // so consumers (KnowledgeBase UI, AI auto-generated KB entries) can route
            // through the SDK rather than direct supabase.from('kb_articles').insert().
            createKbArticle: (payload)=>this._ws("documents.createKbArticle", "/documents/kb", {
                    method: "POST",
                    body: {
                        payload: payload
                    }
                }),
            // Update a knowledge-base article in-place (used by KB editor save +
            // saveKbArticle helper).
            updateKbArticle: (id2, payload)=>this._ws("documents.updateKbArticle", `/documents/kb/${encodeURIComponent(id2)}`, {
                    method: "PATCH",
                    body: {
                        payload: payload
                    }
                }),
            // Documents-adjacent notes (separate `notes` table — distinct from
            // activity.listNotes which targets activity_log style entries).
            listNotes: ()=>this._ws("documents.listNotes", "/documents/notes"),
            // Create a personal/team note. Wraps the `notes` table insert so
            // consumers (Notes UI, "Save as note" buttons) can route through the
            // SDK rather than direct supabase.from('notes').insert().
            createNote: (payload)=>this._ws("documents.createNote", "/documents/notes", {
                    method: "POST",
                    body: {
                        payload: payload
                    }
                }),
            listResourceLinks: ()=>this._ws("documents.listResourceLinks", "/documents/resource-links"),
            addResourceLink: (payload)=>this._ws("documents.addResourceLink", "/documents/resource-links", {
                    method: "POST",
                    body: {
                        payload: payload
                    }
                }),
            updateResourceLink: (id2, payload)=>this._ws("documents.updateResourceLink", `/documents/resource-links/${encodeURIComponent(id2)}`, {
                    method: "PATCH",
                    body: {
                        payload: payload
                    }
                }),
            removeResourceLink: (id2)=>this._ws("documents.removeResourceLink", `/documents/resource-links/${encodeURIComponent(id2)}`, {
                    method: "DELETE"
                }),
            // Composite-key delete — unlink paths don't carry the row id, only the
            // (a_type, a_id, b_type, b_id) tuple. Kept distinct from
            // removeResourceLink(id) so callers express intent at the call site.
            removeResourceLinkByPair: (filter)=>this._ws("documents.removeResourceLinkByPair", "/documents/resource-links", {
                    method: "DELETE",
                    body: {
                        filter: filter
                    }
                }),
            // User-scoped personal documents (was sb().from('user_documents'))
            listUserDocuments: (userId)=>this._ws("documents.listUserDocuments", `/documents/users/${encodeURIComponent(userId || "me")}`),
            createUserDocument: (payload)=>this._ws("documents.createUserDocument", "/documents/users", {
                    method: "POST",
                    body: {
                        payload: payload
                    }
                }),
            updateUserDocument: (id2, payload)=>this._ws("documents.updateUserDocument", `/documents/users/${encodeURIComponent(id2)}`, {
                    method: "PATCH",
                    body: {
                        payload: payload
                    }
                }),
            removeUserDocument: (id2)=>this._ws("documents.removeUserDocument", `/documents/users/${encodeURIComponent(id2)}`, {
                    method: "DELETE"
                })
        });
        // --- Presence ---------------------------------------------------------------
        $281a441cdcb2cf36$var$__publicField(this, "presence", {
            online: ()=>this._ws("presence.online", "/presence/online"),
            heartbeat: ()=>this._ws("presence.heartbeat", "/presence/heartbeat", {
                    method: "POST"
                })
        });
        // --- Notifications ----------------------------------------------------------
        $281a441cdcb2cf36$var$__publicField(this, "notifications", {
            list: ()=>this._ws("notifications.list", "/notifications"),
            unreadCount: ()=>this._ws("notifications.unreadCount", "/notifications/unread-count"),
            // POSTs a single notification row through the wrapper. Replaces direct
            // sb().from('notifications').insert(...) in shared/functions/
            // notifications/createNotification.js.
            create: (payload)=>this._ws("notifications.create", "/notifications", {
                    method: "POST",
                    body: {
                        payload: payload
                    }
                }),
            markRead: (id2)=>this._ws("notifications.markRead", `/notifications/${encodeURIComponent(id2)}/read`, {
                    method: "POST"
                }),
            markAllRead: ()=>this._ws("notifications.markAllRead", "/notifications/mark-all-read", {
                    method: "POST"
                })
        });
        // --- Search -----------------------------------------------------------------
        $281a441cdcb2cf36$var$__publicField(this, "search", (q3, opts)=>this._ws("search", "/search", {
                method: "POST",
                body: {
                    q: q3,
                    ...opts
                }
            }));
        // --- Permissions ------------------------------------------------------------
        $281a441cdcb2cf36$var$__publicField(this, "permissions", {
            me: ()=>this._ws("permissions.me", "/permissions/me"),
            check: (action, resource)=>this._ws("permissions.check", "/permissions/check", {
                    method: "POST",
                    body: {
                        action: action,
                        resource: resource
                    }
                })
        });
        // --- System -----------------------------------------------------------------
        $281a441cdcb2cf36$var$__publicField(this, "system", {
            status: ()=>this._ws("system.status", "/system/status"),
            featureFlags: ()=>this._ws("system.featureFlags", "/system/feature-flags")
        });
        // --- People -----------------------------------------------------------------
        $281a441cdcb2cf36$var$__publicField(this, "people", {
            list: ()=>this._ws("people.list", "/people"),
            get: (id2)=>this._ws("people.get", `/people/${encodeURIComponent(id2)}`),
            me: ()=>this._ws("people.me", "/people/me")
        });
        // --- Activity ---------------------------------------------------------------
        $281a441cdcb2cf36$var$__publicField(this, "activity", {
            listNotes: ()=>this._ws("activity.listNotes", "/activity/notes"),
            addNote: (payload)=>this._ws("activity.addNote", "/activity/notes", {
                    method: "POST",
                    body: {
                        payload: payload
                    }
                }),
            scoringConfig: ()=>this._ws("activity.scoringConfig", "/activity/scoring-config"),
            // Bulk PATCH activity_scoring_config rows. The body shape is
            // { rows: [{ activity_type, enabled, score, … }, …] } — server iterates
            // and applies each (admin-gated). Returns { ok: true } on success.
            updateScoringConfig: (payload)=>this._ws("activity.updateScoringConfig", "/activity/scoring-config", {
                    method: "PATCH",
                    body: {
                        payload: payload
                    }
                }),
            // Aggregated activity_events count grid for the heatmap UI. Returns
            // rows from public.activity_events scoped to the caller and a date
            // range (defaults to the last 365 days). Heavily used by the
            // ActivityHeatmap component — the wrapper does the user_email +
            // workspace_id scoping server-side.
            heatmap: (filter)=>this._ws("activity.heatmap", "/activity/heatmap", {
                    method: "POST",
                    body: {
                        filter: filter
                    }
                }),
            // Per-day activity_events list for one user. Used by the heatmap
            // tooltip / details drawer.
            listEvents: (filter)=>this._ws("activity.listEvents", "/activity/events", {
                    method: "POST",
                    body: {
                        filter: filter
                    }
                })
        });
        // ────────────────────────────────────────────────────────────────────────
        // Tenant tables routed through the existing /workspace/sb/rest/v1/* Supabase
        // passthrough — RLS enforces workspace_id scoping server-side, so the
        // frontend doesn't need a curated wrapper route per table. Each entity is
        // a thin `_sbCrud(<table>)` factory call; for tables that need filter
        // defaults (e.g. ticket_dependencies must always filter by ticket_id),
        // override the .list method explicitly.
        //
        // Why passthrough instead of curated routes: the wrapper's `sb.js` surface
        // already proxies the user's bearer token to Supabase REST, with RLS
        // policies as the only auth boundary. Adding 30 hand-written `relay()`
        // routes per table would just duplicate that scoping ceremony. Promote any
        // entity to a curated wrapper route only when it needs server-side
        // validation, denormalization, or composition.
        // ────────────────────────────────────────────────────────────────────────
        $281a441cdcb2cf36$var$__publicField(this, "announcements", this._sbCrud("announcements"));
        $281a441cdcb2cf36$var$__publicField(this, "birthdays", this._sbCrud("birthdays"));
        $281a441cdcb2cf36$var$__publicField(this, "stories", this._sbCrud("stories"));
        $281a441cdcb2cf36$var$__publicField(this, "valuations", this._sbCrud("valuations"));
        // Single-row org metadata — companyInfo (key/value pairs) + companySettings
        // (one record per org). Provide list + upsert (PostgREST-merge) shapes
        // that match the legacy sb().from('company_info').upsert() call sites.
        $281a441cdcb2cf36$var$__publicField(this, "companyInfo", {
            list: (filter, options)=>this._sb("companyInfo.list", "company_info", "list", {
                    filter: filter,
                    options: options
                }),
            upsert: (payload)=>this._sb("companyInfo.upsert", "company_info", "create", {
                    payload: payload,
                    options: {
                        upsertOnConflict: "key"
                    }
                })
        });
        $281a441cdcb2cf36$var$__publicField(this, "companySettings", {
            get: ()=>this._sb("companySettings.get", "company_settings", "list", {
                    options: {
                        single: true
                    }
                }),
            update: (payload)=>// Single-row table; PATCH first matching row.
                this._sb("companySettings.update", "company_settings", "update", {
                    id: 1,
                    payload: payload
                })
        });
        // Per-user preferences — one row keyed by user_id. RLS scopes to caller.
        // Use `list` (not `single`) so a missing row returns [] instead of the
        // PostgREST "Cannot coerce the result to a single JSON object" error.
        // Caller treats null as "no prefs yet" and renders defaults.
        $281a441cdcb2cf36$var$__publicField(this, "userPreferences", {
            get: async ()=>{
                const rows = await this._sb("userPreferences.get", "user_preferences", "list", {
                    options: {
                        limit: 1
                    }
                });
                return Array.isArray(rows) ? rows[0] || null : rows || null;
            },
            upsert: (payload)=>this._sb("userPreferences.upsert", "user_preferences", "create", {
                    payload: payload,
                    options: {
                        upsertOnConflict: "user_id"
                    }
                })
        });
        $281a441cdcb2cf36$var$__publicField(this, "userGrants", this._sbCrud("user_grants"));
        // user_profiles is keyed by user_id, not numeric id. Override get/update.
        $281a441cdcb2cf36$var$__publicField(this, "userProfiles", {
            list: (filter, options)=>this._sb("userProfiles.list", "user_profiles", "list", {
                    filter: filter,
                    options: options
                }),
            get: (userId)=>this._sb("userProfiles.get", "user_profiles", "list", {
                    filter: {
                        user_id: userId
                    },
                    options: {
                        single: true
                    }
                }),
            update: (userId, payload)=>this._sb("userProfiles.update", "user_profiles", "update", {
                    filter: {
                        user_id: userId
                    },
                    payload: payload
                })
        });
        $281a441cdcb2cf36$var$__publicField(this, "ticketColumns", {
            list: (filter, options)=>this._sb("ticketColumns.list", "ticket_columns", "list", {
                    filter: filter,
                    options: {
                        order: "position.asc",
                        ...options || {}
                    }
                }),
            update: (id2, payload)=>this._sb("ticketColumns.update", "ticket_columns", "update", {
                    id: id2,
                    payload: payload
                })
        });
        // ticket_dependencies has a composite key (ticket_id + depends_on_ticket_id);
        // expose list scoped to a single ticket plus the standard create/remove.
        $281a441cdcb2cf36$var$__publicField(this, "ticketDependencies", {
            list: (ticketId)=>this._sb("ticketDependencies.list", "ticket_dependencies", "list", {
                    filter: {
                        ticket_id: ticketId
                    }
                }),
            create: (payload)=>this._sb("ticketDependencies.create", "ticket_dependencies", "create", {
                    payload: payload
                }),
            remove: (id2)=>this._sb("ticketDependencies.remove", "ticket_dependencies", "remove", {
                    id: id2
                })
        });
        // ticket_comments is per-ticket; .list takes a ticketId, others take id.
        $281a441cdcb2cf36$var$__publicField(this, "ticketComments", {
            list: (ticketId, options)=>this._sb("ticketComments.list", "ticket_comments", "list", {
                    filter: {
                        ticket_id: ticketId
                    },
                    options: {
                        order: "created_at.asc",
                        ...options || {}
                    }
                }),
            create: (ticketId, payload)=>this._sb("ticketComments.create", "ticket_comments", "create", {
                    payload: {
                        ticket_id: ticketId,
                        ...payload || {}
                    }
                }),
            update: (id2, payload)=>this._sb("ticketComments.update", "ticket_comments", "update", {
                    id: id2,
                    payload: payload
                }),
            remove: (id2)=>this._sb("ticketComments.remove", "ticket_comments", "remove", {
                    id: id2
                })
        });
        // Daily standup rows — one per (author_email, date). Upsert merges on
        // the unique index from migration 0033 so idempotent re-submits replace.
        $281a441cdcb2cf36$var$__publicField(this, "standups", {
            list: (filter, options)=>this._sb("standups.list", "standup_activity", "list", {
                    filter: filter,
                    options: options
                }),
            get: (id2)=>this._sb("standups.get", "standup_activity", "get", {
                    id: id2
                }),
            create: (payload)=>this._sb("standups.create", "standup_activity", "create", {
                    payload: payload
                }),
            update: (id2, payload)=>this._sb("standups.update", "standup_activity", "update", {
                    id: id2,
                    payload: payload
                }),
            upsert: (payload)=>this._sb("standups.upsert", "standup_activity", "create", {
                    payload: payload,
                    options: {
                        upsertOnConflict: "author_email,date"
                    }
                })
        });
        // Audit log — backend table is `activity_events`. Filter shape passes
        // straight through PostgREST: { actor_email_in: [...], created_at: { gte } }
        $281a441cdcb2cf36$var$__publicField(this, "auditLog", {
            list: (filter, options)=>this._sb("auditLog.list", "activity_events", "list", {
                    filter: filter,
                    options: {
                        order: "created_at.desc",
                        ...options || {}
                    }
                })
        });
        // Role permission catalog (admin read-only).
        $281a441cdcb2cf36$var$__publicField(this, "rolePermissions", {
            list: ()=>this._sb("rolePermissions.list", "role_permissions", "list", {
                    options: {
                        order: "role,resource,action"
                    }
                })
        });
        // --- AI (workspace-scoped chat / analysis edge fns) ------------------------
        // Replaces direct fetch(`/functions/v1/ai-chat`, …) and meet-analyze /
        // meet-token edge calls scattered across the workspace UI.
        $281a441cdcb2cf36$var$__publicField(this, "ai", {
            chat: (payload)=>this._ws("ai.chat", "/ai/chat", {
                    method: "POST",
                    body: {
                        payload: payload
                    }
                }),
            meetAnalyze: (payload)=>this._ws("ai.meetAnalyze", "/ai/meet-analyze", {
                    method: "POST",
                    body: {
                        payload: payload
                    }
                })
        });
        // --- Agent walkie-talkie (Simona ↔ Chuvaka) — passthrough-routed ---------
        // Routes through /workspace/sb/rest/v1/agent_messages (RLS-scoped). Browser
        // path. The node ops path keeps a service-role REST fetch in
        // shared/functions/agentMessages.js — admin token issuance flow not yet
        // available outside a user session.
        $281a441cdcb2cf36$var$__publicField(this, "agentMessages", {
            list: (filter, options)=>this._sb("agentMessages.list", "agent_messages", "list", {
                    filter: filter,
                    options: options
                }),
            create: (payload)=>this._sb("agentMessages.create", "agent_messages", "create", {
                    payload: payload
                }),
            update: (id2, payload)=>this._sb("agentMessages.update", "agent_messages", "update", {
                    id: id2,
                    payload: payload
                }),
            remove: (id2)=>this._sb("agentMessages.remove", "agent_messages", "remove", {
                    id: id2
                }),
            // Realtime subscription stub — wires through socket once backend ships.
            subscribe: (_toAgent)=>()=>{}
        });
        // --- i18n (translation stream) --------------------------------------------
        // Stub backend wire-up — TranslationWatcher subscribes to translation diffs
        // for the active lang+namespace tuple. Returns a noop unsub today; once
        // backend ships an i18n stream, fill in subscribeTranslations.
        $281a441cdcb2cf36$var$__publicField(this, "i18n", {
            subscribeTranslations: (_filter, _cb)=>{
                return ()=>{};
            }
        });
        $281a441cdcb2cf36$var$__publicField(this, "realtime", {
            // chat_messages — fired on INSERT/UPDATE in a channel.
            subscribeMessages: ({ channelId: channelId } = {}, cb)=>this._realtimeSubscribe("chat.messages", {
                    channelId: channelId
                }, cb),
            // chat_channels + chat_channel_members combined feed (rename, archive,
            // membership). callback receives ('INSERT'|'UPDATE'|'DELETE', payload).
            subscribeChannels: (filter = {}, cb)=>this._realtimeSubscribe("chat.channels", filter, cb),
            // chat_mentions — fired on @-mention insert addressed to userEmail.
            subscribeMentions: ({ userEmail: userEmail } = {}, cb)=>this._realtimeSubscribe("chat.mentions", {
                    userEmail: userEmail
                }, cb),
            // tickets — fired on ticket INSERT/UPDATE within the active workspace.
            subscribeTickets: (filter = {}, cb)=>this._realtimeSubscribe("tickets", filter, cb),
            // notifications — fired on notification INSERT for the caller.
            subscribeNotifications: ({ userEmail: userEmail } = {}, cb)=>this._realtimeSubscribe("notifications", {
                    userEmail: userEmail
                }, cb),
            // presence — multi-user presence tracker; cb receives ('sync'|'join'|'leave', state).
            subscribePresence: ({ scope: scope = "workspace", userKey: userKey } = {}, cb)=>this._realtimeSubscribe("presence", {
                    scope: scope,
                    userKey: userKey
                }, cb),
            // meet_rooms / meet_participants / meet_waiting_room combined feed for a
            // single room. cb receives ('room'|'participant'|'waiting', payload).
            subscribeMeet: ({ roomId: roomId } = {}, cb)=>this._realtimeSubscribe("meet", {
                    roomId: roomId
                }, cb),
            // agent_messages — fired on INSERT addressed to `toAgent`. Used by the
            // walkie-talkie ops layer (Simona/Chuvaka).
            subscribeAgentMessages: ({ toAgent: toAgent } = {}, cb)=>this._realtimeSubscribe("agentMessages", {
                    toAgent: toAgent
                }, cb)
        });
        // --- Storage (workspace-tenant buckets: contracts, chat-attachments, …) ---
        // Replaces direct `sb().storage.from(bucket).upload/createSignedUrl` calls
        // in the workspace UI. The workspace wrapper at /workspace/storage/* is the
        // authority on bucket access — RLS for storage moved server-side, so the
        // frontend never sees the underlying bucket service-role key.
        //
        // Three-arg signed-URL: bucket + path + ttl (seconds). Default TTL 5 min
        // matches the legacy `sb.storage.from('contracts').createSignedUrl(path, 300)`
        // call site in MemberProfile so callers don't need to pass it explicitly.
        $281a441cdcb2cf36$var$__publicField(this, "storage", {
            createSignedUrl: (bucket, path, ttl = 300)=>this._ws("storage.createSignedUrl", `/storage/${encodeURIComponent(bucket)}/signed-url`, {
                    method: "POST",
                    body: {
                        path: path,
                        ttl: ttl
                    }
                }),
            // multipart upload — body must be a FormData carrying { file, path? }.
            // The wrapper extracts `file` and forwards to the storage backend.
            upload: (bucket, formData, options = {})=>{
                const _doUpload = async ()=>{
                    this._requireReady("storage.upload");
                    const url2 = `${this._workspacePrefix}/storage/${encodeURIComponent(bucket)}/upload`;
                    const init = {
                        method: "POST",
                        body: formData,
                        headers: {}
                    };
                    const auth = await this._resolveAuthHeader();
                    if (auth) init.headers.Authorization = auth;
                    const res = await fetch(url2, init);
                    const json = await res.json().catch(()=>({}));
                    if (!res.ok) throw new Error((json == null ? void 0 : json.message) || `HTTP ${res.status}`);
                    return json;
                };
                return _doUpload();
            },
            remove: (bucket, path)=>this._ws("storage.remove", `/storage/${encodeURIComponent(bucket)}/object`, {
                    method: "DELETE",
                    body: {
                        path: path
                    }
                }),
            // Public download URL for a stored object — wraps the wrapper's signed
            // GET endpoint so callers don't need the bucket service-role key.
            publicUrl: (bucket, path)=>this._ws("storage.publicUrl", `/storage/${encodeURIComponent(bucket)}/public-url`, {
                    method: "POST",
                    body: {
                        path: path
                    }
                })
        });
        // --- Generic escape hatch ---------------------------------------------------
        $281a441cdcb2cf36$var$__publicField(this, "query", (body)=>this._ws("query", "/query", {
                method: "POST",
                body: body
            }));
    }
    init({ context: context2 }) {
        super.init({
            context: context2
        });
        this._workspacePrefix = $281a441cdcb2cf36$export$59dd0c3383896351((context2 == null ? void 0 : context2.workspaceApiUrl) || this._apiUrl);
        this._tokenProvider = (context2 == null ? void 0 : context2.workspaceProjectTokenProvider) || null;
    }
    async _resolveAuthHeader() {
        if (this._tokenProvider) try {
            const result = await this._tokenProvider();
            if (!result) return null;
            if (typeof result === "string") return `Bearer ${result}`;
            if (result.token) return `Bearer ${result.token}`;
            if (result.access_token) return `Bearer ${result.access_token}`;
        } catch  {}
        if (this._tokenManager) try {
            await this._tokenManager.ensureValidToken();
            return this._tokenManager.getAuthHeader();
        } catch  {}
        return null;
    }
    async _ws(methodName, endpoint, { method: method = "GET", body: body, headers: headers } = {}) {
        var _a2;
        this._requireReady(methodName);
        const url2 = `${this._workspacePrefix}${endpoint}`;
        const init = {
            method: method,
            headers: {
                ...headers || {}
            }
        };
        if (body !== void 0) {
            init.body = JSON.stringify(body);
            init.headers["Content-Type"] = "application/json";
        }
        const auth = await this._resolveAuthHeader();
        if (auth) init.headers.Authorization = auth;
        const res = await fetch(url2, init);
        const json = await res.json().catch(()=>({}));
        if (!res.ok) throw new Error((json == null ? void 0 : json.message) || ((_a2 = json == null ? void 0 : json.error) == null ? void 0 : _a2.message) || `HTTP ${res.status}`);
        return json;
    }
    // PostgREST-style call routed through the workspace wrapper's existing
    // Supabase passthrough at /workspace/sb/rest/v1/*. Lets us expose any
    // workspace-tenant table on the SDK without writing a curated server
    // route per entity — RLS still enforces auth/scope server-side because
    // the passthrough forwards the user's bearer token unchanged.
    //
    // op vocabulary (matches sdk.execute):
    //   list   → GET /rest/v1/{table}?{filter as PostgREST query string}
    //   get    → GET /rest/v1/{table}?{single}=eq.{id}  (Accept: pgrst.object+json)
    //   create → POST /rest/v1/{table}                  (Prefer: return=representation)
    //   update → PATCH /rest/v1/{table}?id=eq.{id}      (Prefer: return=representation)
    //   remove → DELETE /rest/v1/{table}?id=eq.{id}
    //   rpc    → POST /rest/v1/rpc/{table}              (table doubles as fn name)
    //
    // filter shape (mirrors the curated wrappers):
    //   plain value  → eq.value
    //   array        → in.(a,b,c)
    //   { gte, lte, gt, lt, like, ilike, is, neq } → operator.value
    //   <key>_in: [..] → key=in.(a,b,c)        — convenience for prefilter
    //   null         → is.null
    //
    // options:
    //   columns: 'id,name'  → select=id,name
    //   order: 'name.asc' or 'name'
    //   limit, offset
    //   single: true   → use Accept: pgrst.object+json (returns one row)
    async _sb(methodName, table, op, args2 = {}) {
        var _a2, _b;
        this._requireReady(methodName);
        const { filter: filter, payload: payload, options: options = {} } = args2 || {};
        const idValue = (_a2 = options.id) != null ? _a2 : args2 == null ? void 0 : args2.id;
        const qs = new URLSearchParams();
        const _enc = (v3)=>v3 === null ? "null" : String(v3);
        if (filter && typeof filter === "object") for (const [rawKey, val] of Object.entries(filter)){
            if (val === void 0) continue;
            if (rawKey.endsWith("_in") && Array.isArray(val)) {
                qs.append(rawKey.slice(0, -3), `in.(${val.map(_enc).join(",")})`);
                continue;
            }
            if (val === null) qs.append(rawKey, "is.null");
            else if (Array.isArray(val)) qs.append(rawKey, `in.(${val.map(_enc).join(",")})`);
            else if (typeof val === "object") for (const [opName, opVal] of Object.entries(val))qs.append(rawKey, `${opName}.${_enc(opVal)}`);
            else qs.append(rawKey, `eq.${_enc(val)}`);
        }
        if (op === "get" && idValue !== void 0 && !qs.has("id")) qs.append("id", `eq.${_enc(idValue)}`);
        if (op === "update" && idValue !== void 0 && !qs.has("id")) qs.append("id", `eq.${_enc(idValue)}`);
        if (op === "remove" && idValue !== void 0 && !qs.has("id")) qs.append("id", `eq.${_enc(idValue)}`);
        if (options.columns) qs.set("select", options.columns);
        if (options.order) qs.set("order", options.order);
        if (options.limit != null) qs.set("limit", String(options.limit));
        if (options.offset != null) qs.set("offset", String(options.offset));
        if (op === "create" && options.upsertOnConflict) qs.set("on_conflict", options.upsertOnConflict);
        const httpMethod = op === "list" || op === "get" ? "GET" : op === "create" ? "POST" : op === "update" ? "PATCH" : op === "remove" ? "DELETE" : op === "rpc" ? "POST" : "GET";
        const restPath = op === "rpc" ? `rpc/${encodeURIComponent(table)}` : encodeURIComponent(table);
        const queryStr = qs.toString();
        const url2 = `${this._workspacePrefix}/sb/rest/v1/${restPath}${queryStr ? "?" + queryStr : ""}`;
        const init = {
            method: httpMethod,
            headers: {}
        };
        const auth = await this._resolveAuthHeader();
        if (auth) init.headers.Authorization = auth;
        if (op === "create" || op === "update" || op === "rpc") {
            init.body = JSON.stringify(payload != null ? payload : {});
            init.headers["Content-Type"] = "application/json";
            if (op !== "rpc") {
                const prefer = options.upsertOnConflict ? "resolution=merge-duplicates,return=representation" : "return=representation";
                init.headers["Prefer"] = prefer;
            }
        }
        if (op === "get" || op === "list" && options.single) init.headers["Accept"] = "application/vnd.pgrst.object+json";
        const res = await fetch(url2, init);
        const text2 = await res.text();
        let json = null;
        try {
            json = text2 ? JSON.parse(text2) : null;
        } catch  {
            json = text2;
        }
        if (!res.ok) {
            const msg = json && (json.message || ((_b = json.error) == null ? void 0 : _b.message)) || text2 || `HTTP ${res.status}`;
            throw new Error(`[${methodName}] ${msg}`);
        }
        return json;
    }
    // Factory for the common (filter, options) / (id) / (id, payload) shape
    // — most table-only entity namespaces follow it. Each method returns the
    // raw _sb() promise so consumers see the unwrapped Supabase response.
    _sbCrud(table, listOptions = {}) {
        return {
            list: (filter, options)=>this._sb(`${table}.list`, table, "list", {
                    filter: filter,
                    options: {
                        ...listOptions,
                        ...options || {}
                    }
                }),
            get: (id2)=>this._sb(`${table}.get`, table, "get", {
                    id: id2,
                    options: {
                        single: true
                    }
                }),
            create: (payload)=>this._sb(`${table}.create`, table, "create", {
                    payload: payload
                }),
            update: (id2, payload)=>this._sb(`${table}.update`, table, "update", {
                    id: id2,
                    payload: payload
                }),
            remove: (id2)=>this._sb(`${table}.remove`, table, "remove", {
                    id: id2
                })
        };
    }
    // ────────────────────────────────────────────────────────────────────────
    // Realtime — pluggable provider. The SDK's realtime API is stable; the
    // transport (Supabase realtime today, socket.io/SSE in the future) is
    // injected at boot via `setRealtimeProvider`. That keeps consumers
    // (`fetch: { from: 'workspaceProject.realtime.messages', method: 'subscribe' }`)
    // unchanged when transport flips.
    //
    // Provider contract:
    //   provider({ op, filter, callback }) → unsubscribe
    // Where:
    //   op       — 'chat.messages' | 'chat.channels' | 'chat.mentions' |
    //              'tickets' | 'notifications' | 'presence' |
    //              'meet' | 'agentMessages'
    //   filter   — op-specific args (e.g. { channelId }, { userEmail }, { roomId })
    //   callback — fired on each event with (eventType, payload). Shape mirrors
    //              Supabase postgres_changes payload for backwards compat.
    //
    // Without a provider every subscribe returns a noop unsubscribe — same as
    // before — so call sites that subscribe defensively (no live data, but no
    // crash) keep working.
    // ────────────────────────────────────────────────────────────────────────
    setRealtimeProvider(fn) {
        this._realtimeProvider = typeof fn === "function" ? fn : null;
    }
    _realtimeSubscribe(op, filter, callback) {
        const p3 = this._realtimeProvider;
        if (typeof p3 !== "function" || typeof callback !== "function") return ()=>{};
        try {
            const unsub = p3({
                op: op,
                filter: filter || {},
                callback: callback
            });
            return typeof unsub === "function" ? unsub : ()=>{};
        } catch (err) {
            console.warn(`[sdk.workspaceProject.realtime] provider failed for op '${op}':`, (err == null ? void 0 : err.message) || err);
            return ()=>{};
        }
    }
};
// ../node_modules/tslib/tslib.es6.mjs
function $281a441cdcb2cf36$var$__rest4(s3, e4) {
    var t4 = {};
    for(var p3 in s3)if (Object.prototype.hasOwnProperty.call(s3, p3) && e4.indexOf(p3) < 0) t4[p3] = s3[p3];
    if (s3 != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i3 = 0, p3 = Object.getOwnPropertySymbols(s3); i3 < p3.length; i3++)if (e4.indexOf(p3[i3]) < 0 && Object.prototype.propertyIsEnumerable.call(s3, p3[i3])) t4[p3[i3]] = s3[p3[i3]];
    }
    return t4;
}
function $281a441cdcb2cf36$var$__awaiter3(thisArg, _arguments, P3, generator) {
    function adopt(value2) {
        return value2 instanceof P3 ? value2 : new P3(function(resolve) {
            resolve(value2);
        });
    }
    return new (P3 || (P3 = Promise))(function(resolve, reject) {
        function fulfilled(value2) {
            try {
                step(generator.next(value2));
            } catch (e4) {
                reject(e4);
            }
        }
        function rejected(value2) {
            try {
                step(generator["throw"](value2));
            } catch (e4) {
                reject(e4);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
// ../node_modules/@supabase/functions-js/dist/module/helper.js
var $281a441cdcb2cf36$var$resolveFetch = (customFetch)=>{
    if (customFetch) return (...args2)=>customFetch(...args2);
    return (...args2)=>fetch(...args2);
};
// ../node_modules/@supabase/functions-js/dist/module/types.js
var $281a441cdcb2cf36$var$FunctionsError = class extends Error {
    constructor(message, name = "FunctionsError", context2){
        super(message);
        this.name = name;
        this.context = context2;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            context: this.context
        };
    }
};
var $281a441cdcb2cf36$var$FunctionsFetchError = class extends $281a441cdcb2cf36$var$FunctionsError {
    constructor(context2){
        super("Failed to send a request to the Edge Function", "FunctionsFetchError", context2);
    }
};
var $281a441cdcb2cf36$var$FunctionsRelayError = class extends $281a441cdcb2cf36$var$FunctionsError {
    constructor(context2){
        super("Relay Error invoking the Edge Function", "FunctionsRelayError", context2);
    }
};
var $281a441cdcb2cf36$var$FunctionsHttpError = class extends $281a441cdcb2cf36$var$FunctionsError {
    constructor(context2){
        super("Edge Function returned a non-2xx status code", "FunctionsHttpError", context2);
    }
};
var $281a441cdcb2cf36$var$FunctionRegion;
(function(FunctionRegion2) {
    FunctionRegion2["Any"] = "any";
    FunctionRegion2["ApNortheast1"] = "ap-northeast-1";
    FunctionRegion2["ApNortheast2"] = "ap-northeast-2";
    FunctionRegion2["ApSouth1"] = "ap-south-1";
    FunctionRegion2["ApSoutheast1"] = "ap-southeast-1";
    FunctionRegion2["ApSoutheast2"] = "ap-southeast-2";
    FunctionRegion2["CaCentral1"] = "ca-central-1";
    FunctionRegion2["EuCentral1"] = "eu-central-1";
    FunctionRegion2["EuWest1"] = "eu-west-1";
    FunctionRegion2["EuWest2"] = "eu-west-2";
    FunctionRegion2["EuWest3"] = "eu-west-3";
    FunctionRegion2["SaEast1"] = "sa-east-1";
    FunctionRegion2["UsEast1"] = "us-east-1";
    FunctionRegion2["UsWest1"] = "us-west-1";
    FunctionRegion2["UsWest2"] = "us-west-2";
})($281a441cdcb2cf36$var$FunctionRegion || ($281a441cdcb2cf36$var$FunctionRegion = {}));
// ../node_modules/@supabase/functions-js/dist/module/FunctionsClient.js
var $281a441cdcb2cf36$var$FunctionsClient = class {
    /**
   * Creates a new Functions client bound to an Edge Functions URL.
   *
   * @example Using supabase-js (recommended)
   * ```ts
   * import { createClient } from '@supabase/supabase-js'
   *
   * const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
   * const { data, error } = await supabase.functions.invoke('hello-world')
   * ```
   *
   * @category Functions
   *
   * @example Standalone import for bundle-sensitive environments
   * ```ts
   * import { FunctionsClient, FunctionRegion } from '@supabase/functions-js'
   *
   * const functions = new FunctionsClient('https://xyzcompany.supabase.co/functions/v1', {
   *   headers: { apikey: 'your-publishable-key' },
   *   region: FunctionRegion.UsEast1,
   * })
   * ```
   */ constructor(url2, { headers: headers = {}, customFetch: customFetch, region: region = $281a441cdcb2cf36$var$FunctionRegion.Any } = {}){
        this.url = url2;
        this.headers = headers;
        this.region = region;
        this.fetch = $281a441cdcb2cf36$var$resolveFetch(customFetch);
    }
    /**
   * Updates the authorization header
   * @param token - the new jwt token sent in the authorisation header
   *
   * @category Functions
   *
   * @example Setting the authorization header
   * ```ts
   * functions.setAuth(session.access_token)
   * ```
   */ setAuth(token) {
        this.headers.Authorization = `Bearer ${token}`;
    }
    /**
   * Invokes a function
   * @param functionName - The name of the Function to invoke.
   * @param options - Options for invoking the Function.
   * @example
   * ```ts
   * const { data, error } = await functions.invoke('hello-world', {
   *   body: { name: 'Ada' },
   * })
   * ```
   *
   * @category Functions
   *
   * @remarks
   * - Requires an Authorization header.
   * - Invoke params generally match the [Fetch API](https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API) spec.
   * - When you pass in a body to your function, we automatically attach the Content-Type header for `Blob`, `ArrayBuffer`, `File`, `FormData` and `String`. If it doesn't match any of these types we assume the payload is `json`, serialize it and attach the `Content-Type` header as `application/json`. You can override this behavior by passing in a `Content-Type` header of your own.
   * - Responses are automatically parsed as `json`, `blob` and `form-data` depending on the `Content-Type` header sent by your function. Responses are parsed as `text` by default.
   *
   * @example Basic invocation
   * ```js
   * const { data, error } = await supabase.functions.invoke('hello', {
   *   body: { foo: 'bar' }
   * })
   * ```
   *
   * @exampleDescription Error handling
   * A `FunctionsHttpError` error is returned if your function throws an error, `FunctionsRelayError` if the Supabase Relay has an error processing your function and `FunctionsFetchError` if there is a network error in calling your function.
   *
   * @example Error handling
   * ```js
   * import { FunctionsHttpError, FunctionsRelayError, FunctionsFetchError } from "@supabase/supabase-js";
   *
   * const { data, error } = await supabase.functions.invoke('hello', {
   *   headers: {
   *     "my-custom-header": 'my-custom-header-value'
   *   },
   *   body: { foo: 'bar' }
   * })
   *
   * if (error instanceof FunctionsHttpError) {
   *   const errorMessage = await error.context.json()
   *   console.log('Function returned an error', errorMessage)
   * } else if (error instanceof FunctionsRelayError) {
   *   console.log('Relay error:', error.message)
   * } else if (error instanceof FunctionsFetchError) {
   *   console.log('Fetch error:', error.message)
   * }
   * ```
   *
   * @exampleDescription Passing custom headers
   * You can pass custom headers to your function. Note: supabase-js automatically passes the `Authorization` header with the signed in user's JWT.
   *
   * @example Passing custom headers
   * ```js
   * const { data, error } = await supabase.functions.invoke('hello', {
   *   headers: {
   *     "my-custom-header": 'my-custom-header-value'
   *   },
   *   body: { foo: 'bar' }
   * })
   * ```
   *
   * @exampleDescription Calling with DELETE HTTP verb
   * You can also set the HTTP verb to `DELETE` when calling your Edge Function.
   *
   * @example Calling with DELETE HTTP verb
   * ```js
   * const { data, error } = await supabase.functions.invoke('hello', {
   *   headers: {
   *     "my-custom-header": 'my-custom-header-value'
   *   },
   *   body: { foo: 'bar' },
   *   method: 'DELETE'
   * })
   * ```
   *
   * @exampleDescription Invoking a Function in the UsEast1 region
   * Here are the available regions:
   * - `FunctionRegion.Any`
   * - `FunctionRegion.ApNortheast1`
   * - `FunctionRegion.ApNortheast2`
   * - `FunctionRegion.ApSouth1`
   * - `FunctionRegion.ApSoutheast1`
   * - `FunctionRegion.ApSoutheast2`
   * - `FunctionRegion.CaCentral1`
   * - `FunctionRegion.EuCentral1`
   * - `FunctionRegion.EuWest1`
   * - `FunctionRegion.EuWest2`
   * - `FunctionRegion.EuWest3`
   * - `FunctionRegion.SaEast1`
   * - `FunctionRegion.UsEast1`
   * - `FunctionRegion.UsWest1`
   * - `FunctionRegion.UsWest2`
   *
   * @example Invoking a Function in the UsEast1 region
   * ```js
   * import { createClient, FunctionRegion } from '@supabase/supabase-js'
   *
   * const { data, error } = await supabase.functions.invoke('hello', {
   *   body: { foo: 'bar' },
   *   region: FunctionRegion.UsEast1
   * })
   * ```
   *
   * @exampleDescription Calling with GET HTTP verb
   * You can also set the HTTP verb to `GET` when calling your Edge Function.
   *
   * @example Calling with GET HTTP verb
   * ```js
   * const { data, error } = await supabase.functions.invoke('hello', {
   *   headers: {
   *     "my-custom-header": 'my-custom-header-value'
   *   },
   *   method: 'GET'
   * })
   * ```
   *
   * @example Example 7
   * ```ts
   * const { data, error } = await functions.invoke('hello-world', {
   *   body: { name: 'Ada' },
   * })
   * ```
   */ invoke(functionName_1) {
        return $281a441cdcb2cf36$var$__awaiter3(this, arguments, void 0, function*(functionName, options = {}) {
            var _a2;
            let timeoutId;
            let timeoutController;
            try {
                const { headers: headers, method: method, body: functionArgs, signal: signal, timeout: timeout } = options;
                let _headers = {};
                let { region: region } = options;
                if (!region) region = this.region;
                const url2 = new URL(`${this.url}/${functionName}`);
                if (region && region !== "any") {
                    _headers["x-region"] = region;
                    url2.searchParams.set("forceFunctionRegion", region);
                }
                let body;
                if (functionArgs && (headers && !Object.prototype.hasOwnProperty.call(headers, "Content-Type") || !headers)) {
                    if (typeof Blob !== "undefined" && functionArgs instanceof Blob || functionArgs instanceof ArrayBuffer) {
                        _headers["Content-Type"] = "application/octet-stream";
                        body = functionArgs;
                    } else if (typeof functionArgs === "string") {
                        _headers["Content-Type"] = "text/plain";
                        body = functionArgs;
                    } else if (typeof FormData !== "undefined" && functionArgs instanceof FormData) body = functionArgs;
                    else {
                        _headers["Content-Type"] = "application/json";
                        body = JSON.stringify(functionArgs);
                    }
                } else if (functionArgs && typeof functionArgs !== "string" && !(typeof Blob !== "undefined" && functionArgs instanceof Blob) && !(functionArgs instanceof ArrayBuffer) && !(typeof FormData !== "undefined" && functionArgs instanceof FormData)) body = JSON.stringify(functionArgs);
                else body = functionArgs;
                let effectiveSignal = signal;
                if (timeout) {
                    timeoutController = new AbortController();
                    timeoutId = setTimeout(()=>timeoutController.abort(), timeout);
                    if (signal) {
                        effectiveSignal = timeoutController.signal;
                        signal.addEventListener("abort", ()=>timeoutController.abort());
                    } else effectiveSignal = timeoutController.signal;
                }
                const response = yield this.fetch(url2.toString(), {
                    method: method || "POST",
                    // headers priority is (high to low):
                    // 1. invoke-level headers
                    // 2. client-level headers
                    // 3. default Content-Type header
                    headers: Object.assign(Object.assign(Object.assign({}, _headers), this.headers), headers),
                    body: body,
                    signal: effectiveSignal
                }).catch((fetchError)=>{
                    throw new $281a441cdcb2cf36$var$FunctionsFetchError(fetchError);
                });
                const isRelayError = response.headers.get("x-relay-error");
                if (isRelayError && isRelayError === "true") throw new $281a441cdcb2cf36$var$FunctionsRelayError(response);
                if (!response.ok) throw new $281a441cdcb2cf36$var$FunctionsHttpError(response);
                let responseType = ((_a2 = response.headers.get("Content-Type")) !== null && _a2 !== void 0 ? _a2 : "text/plain").split(";")[0].trim();
                let data2;
                if (responseType === "application/json") data2 = yield response.json();
                else if (responseType === "application/octet-stream" || responseType === "application/pdf") data2 = yield response.blob();
                else if (responseType === "text/event-stream") data2 = response;
                else if (responseType === "multipart/form-data") data2 = yield response.formData();
                else data2 = yield response.text();
                return {
                    data: data2,
                    error: null,
                    response: response
                };
            } catch (error) {
                return {
                    data: null,
                    error: error,
                    response: error instanceof $281a441cdcb2cf36$var$FunctionsHttpError || error instanceof $281a441cdcb2cf36$var$FunctionsRelayError ? error.context : void 0
                };
            } finally{
                if (timeoutId) clearTimeout(timeoutId);
            }
        });
    }
};
// ../node_modules/@supabase/postgrest-js/dist/index.mjs
var $281a441cdcb2cf36$var$DEFAULT_MAX_RETRIES = 3;
var $281a441cdcb2cf36$var$getRetryDelay = (attemptIndex)=>Math.min(1e3 * 2 ** attemptIndex, 3e4);
var $281a441cdcb2cf36$var$RETRYABLE_STATUS_CODES = [
    520,
    503
];
var $281a441cdcb2cf36$var$RETRYABLE_METHODS = [
    "GET",
    "HEAD",
    "OPTIONS"
];
var $281a441cdcb2cf36$var$PostgrestError = class extends Error {
    /**
  * @example
  * ```ts
  * import PostgrestError from '@supabase/postgrest-js'
  *
  * throw new PostgrestError({
  *   message: 'Row level security prevented the request',
  *   details: 'RLS denied the insert',
  *   hint: 'Check your policies',
  *   code: 'PGRST301',
  * })
  * ```
  */ constructor(context2){
        super(context2.message);
        this.name = "PostgrestError";
        this.details = context2.details;
        this.hint = context2.hint;
        this.code = context2.code;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            details: this.details,
            hint: this.hint,
            code: this.code
        };
    }
};
function $281a441cdcb2cf36$var$sleep(ms, signal) {
    return new Promise((resolve)=>{
        if (signal === null || signal === void 0 ? void 0 : signal.aborted) {
            resolve();
            return;
        }
        const id2 = setTimeout(()=>{
            signal === null || signal === void 0 || signal.removeEventListener("abort", onAbort);
            resolve();
        }, ms);
        function onAbort() {
            clearTimeout(id2);
            resolve();
        }
        signal === null || signal === void 0 || signal.addEventListener("abort", onAbort);
    });
}
function $281a441cdcb2cf36$var$shouldRetry(method, status, attemptCount, retryEnabled) {
    if (!retryEnabled || attemptCount >= $281a441cdcb2cf36$var$DEFAULT_MAX_RETRIES) return false;
    if (!$281a441cdcb2cf36$var$RETRYABLE_METHODS.includes(method)) return false;
    if (!$281a441cdcb2cf36$var$RETRYABLE_STATUS_CODES.includes(status)) return false;
    return true;
}
var $281a441cdcb2cf36$var$PostgrestBuilder = class {
    /**
  * Creates a builder configured for a specific PostgREST request.
  *
  * @example Using supabase-js (recommended)
  * ```ts
  * import { createClient } from '@supabase/supabase-js'
  *
  * const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
  * const { data, error } = await supabase.from('users').select('*')
  * ```
  *
  * @category Database
  *
  * @example Standalone import for bundle-sensitive environments
  * ```ts
  * import { PostgrestQueryBuilder } from '@supabase/postgrest-js'
  *
  * const builder = new PostgrestQueryBuilder(
  *   new URL('https://xyzcompany.supabase.co/rest/v1/users'),
  *   { headers: new Headers({ apikey: 'your-publishable-key' }) }
  * )
  * ```
  */ constructor(builder){
        var _builder$shouldThrowO, _builder$isMaybeSingl, _builder$shouldStripN, _builder$urlLengthLim, _builder$retry;
        this.shouldThrowOnError = false;
        this.retryEnabled = true;
        this.method = builder.method;
        this.url = builder.url;
        this.headers = new Headers(builder.headers);
        this.schema = builder.schema;
        this.body = builder.body;
        this.shouldThrowOnError = (_builder$shouldThrowO = builder.shouldThrowOnError) !== null && _builder$shouldThrowO !== void 0 ? _builder$shouldThrowO : false;
        this.signal = builder.signal;
        this.isMaybeSingle = (_builder$isMaybeSingl = builder.isMaybeSingle) !== null && _builder$isMaybeSingl !== void 0 ? _builder$isMaybeSingl : false;
        this.shouldStripNulls = (_builder$shouldStripN = builder.shouldStripNulls) !== null && _builder$shouldStripN !== void 0 ? _builder$shouldStripN : false;
        this.urlLengthLimit = (_builder$urlLengthLim = builder.urlLengthLimit) !== null && _builder$urlLengthLim !== void 0 ? _builder$urlLengthLim : 8e3;
        this.retryEnabled = (_builder$retry = builder.retry) !== null && _builder$retry !== void 0 ? _builder$retry : true;
        if (builder.fetch) this.fetch = builder.fetch;
        else this.fetch = fetch;
    }
    /**
  * If there's an error with the query, throwOnError will reject the promise by
  * throwing the error instead of returning it as part of a successful response.
  *
  * {@link https://github.com/supabase/supabase-js/issues/92}
  *
  * @category Database
  */ throwOnError() {
        this.shouldThrowOnError = true;
        return this;
    }
    /**
  * Strip null values from the response data. Properties with `null` values
  * will be omitted from the returned JSON objects.
  *
  * Requires PostgREST 11.2.0+.
  *
  * {@link https://docs.postgrest.org/en/stable/references/api/resource_representation.html#stripped-nulls}
  *
  * @category Database
  *
  * @example With `select()`
  * ```ts
  * const { data, error } = await supabase
  *   .from('characters')
  *   .select()
  *   .stripNulls()
  * ```
  *
  * @exampleSql With `select()`
  * ```sql
  * create table
  *   characters (id int8 primary key, name text, bio text);
  *
  * insert into
  *   characters (id, name, bio)
  * values
  *   (1, 'Luke', null),
  *   (2, 'Leia', 'Princess of Alderaan');
  * ```
  *
  * @exampleResponse With `select()`
  * ```json
  * {
  *   "data": [
  *     {
  *       "id": 1,
  *       "name": "Luke"
  *     },
  *     {
  *       "id": 2,
  *       "name": "Leia",
  *       "bio": "Princess of Alderaan"
  *     }
  *   ],
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  */ stripNulls() {
        if (this.headers.get("Accept") === "text/csv") throw new Error("stripNulls() cannot be used with csv()");
        this.shouldStripNulls = true;
        return this;
    }
    /**
  * Set an HTTP header for the request.
  *
  * @category Database
  */ setHeader(name, value2) {
        this.headers = new Headers(this.headers);
        this.headers.set(name, value2);
        return this;
    }
    /**
  * @category Database
  *
  * Configure retry behavior for this request.
  *
  * By default, retries are enabled for idempotent requests (GET, HEAD, OPTIONS)
  * that fail with network errors or specific HTTP status codes (503, 520).
  * Retries use exponential backoff (1s, 2s, 4s) with a maximum of 3 attempts.
  *
  * @param enabled - Whether to enable retries for this request
  *
  * @example
  * ```ts
  * // Disable retries for a specific query
  * const { data, error } = await supabase
  *   .from('users')
  *   .select()
  *   .retry(false)
  * ```
  */ retry(enabled) {
        this.retryEnabled = enabled;
        return this;
    }
    then(onfulfilled, onrejected) {
        var _this = this;
        if (this.schema === void 0) ;
        else if ([
            "GET",
            "HEAD"
        ].includes(this.method)) this.headers.set("Accept-Profile", this.schema);
        else this.headers.set("Content-Profile", this.schema);
        if (this.method !== "GET" && this.method !== "HEAD") this.headers.set("Content-Type", "application/json");
        if (this.shouldStripNulls) {
            const currentAccept = this.headers.get("Accept");
            if (currentAccept === "application/vnd.pgrst.object+json") this.headers.set("Accept", "application/vnd.pgrst.object+json;nulls=stripped");
            else if (!currentAccept || currentAccept === "application/json") this.headers.set("Accept", "application/vnd.pgrst.array+json;nulls=stripped");
        }
        const _fetch = this.fetch;
        const executeWithRetry = async ()=>{
            let attemptCount = 0;
            while(true){
                const requestHeaders = new Headers(_this.headers);
                if (attemptCount > 0) requestHeaders.set("X-Retry-Count", String(attemptCount));
                let res$1;
                try {
                    res$1 = await _fetch(_this.url.toString(), {
                        method: _this.method,
                        headers: requestHeaders,
                        body: JSON.stringify(_this.body, (_3, value2)=>typeof value2 === "bigint" ? value2.toString() : value2),
                        signal: _this.signal
                    });
                } catch (fetchError) {
                    if ((fetchError === null || fetchError === void 0 ? void 0 : fetchError.name) === "AbortError" || (fetchError === null || fetchError === void 0 ? void 0 : fetchError.code) === "ABORT_ERR") throw fetchError;
                    if (!$281a441cdcb2cf36$var$RETRYABLE_METHODS.includes(_this.method)) throw fetchError;
                    if (_this.retryEnabled && attemptCount < $281a441cdcb2cf36$var$DEFAULT_MAX_RETRIES) {
                        const delay = $281a441cdcb2cf36$var$getRetryDelay(attemptCount);
                        attemptCount++;
                        await $281a441cdcb2cf36$var$sleep(delay, _this.signal);
                        continue;
                    }
                    throw fetchError;
                }
                if ($281a441cdcb2cf36$var$shouldRetry(_this.method, res$1.status, attemptCount, _this.retryEnabled)) {
                    var _res$headers$get, _res$headers;
                    const retryAfterHeader = (_res$headers$get = (_res$headers = res$1.headers) === null || _res$headers === void 0 ? void 0 : _res$headers.get("Retry-After")) !== null && _res$headers$get !== void 0 ? _res$headers$get : null;
                    const delay = retryAfterHeader !== null ? Math.max(0, parseInt(retryAfterHeader, 10) || 0) * 1e3 : $281a441cdcb2cf36$var$getRetryDelay(attemptCount);
                    await res$1.text();
                    attemptCount++;
                    await $281a441cdcb2cf36$var$sleep(delay, _this.signal);
                    continue;
                }
                return await _this.processResponse(res$1);
            }
        };
        let res = executeWithRetry();
        if (!this.shouldThrowOnError) res = res.catch((fetchError)=>{
            var _fetchError$name2;
            let errorDetails = "";
            let hint = "";
            let code = "";
            const cause = fetchError === null || fetchError === void 0 ? void 0 : fetchError.cause;
            if (cause) {
                var _cause$message, _cause$code, _fetchError$name, _cause$name;
                const causeMessage = (_cause$message = cause === null || cause === void 0 ? void 0 : cause.message) !== null && _cause$message !== void 0 ? _cause$message : "";
                const causeCode = (_cause$code = cause === null || cause === void 0 ? void 0 : cause.code) !== null && _cause$code !== void 0 ? _cause$code : "";
                errorDetails = `${(_fetchError$name = fetchError === null || fetchError === void 0 ? void 0 : fetchError.name) !== null && _fetchError$name !== void 0 ? _fetchError$name : "FetchError"}: ${fetchError === null || fetchError === void 0 ? void 0 : fetchError.message}`;
                errorDetails += `

Caused by: ${(_cause$name = cause === null || cause === void 0 ? void 0 : cause.name) !== null && _cause$name !== void 0 ? _cause$name : "Error"}: ${causeMessage}`;
                if (causeCode) errorDetails += ` (${causeCode})`;
                if (cause === null || cause === void 0 ? void 0 : cause.stack) errorDetails += `
${cause.stack}`;
            } else {
                var _fetchError$stack;
                errorDetails = (_fetchError$stack = fetchError === null || fetchError === void 0 ? void 0 : fetchError.stack) !== null && _fetchError$stack !== void 0 ? _fetchError$stack : "";
            }
            const urlLength = this.url.toString().length;
            if ((fetchError === null || fetchError === void 0 ? void 0 : fetchError.name) === "AbortError" || (fetchError === null || fetchError === void 0 ? void 0 : fetchError.code) === "ABORT_ERR") {
                code = "";
                hint = "Request was aborted (timeout or manual cancellation)";
                if (urlLength > this.urlLengthLimit) hint += `. Note: Your request URL is ${urlLength} characters, which may exceed server limits. If selecting many fields, consider using views. If filtering with large arrays (e.g., .in('id', [many IDs])), consider using an RPC function to pass values server-side.`;
            } else if ((cause === null || cause === void 0 ? void 0 : cause.name) === "HeadersOverflowError" || (cause === null || cause === void 0 ? void 0 : cause.code) === "UND_ERR_HEADERS_OVERFLOW") {
                code = "";
                hint = "HTTP headers exceeded server limits (typically 16KB)";
                if (urlLength > this.urlLengthLimit) hint += `. Your request URL is ${urlLength} characters. If selecting many fields, consider using views. If filtering with large arrays (e.g., .in('id', [200+ IDs])), consider using an RPC function instead.`;
            }
            return {
                success: false,
                error: {
                    message: `${(_fetchError$name2 = fetchError === null || fetchError === void 0 ? void 0 : fetchError.name) !== null && _fetchError$name2 !== void 0 ? _fetchError$name2 : "FetchError"}: ${fetchError === null || fetchError === void 0 ? void 0 : fetchError.message}`,
                    details: errorDetails,
                    hint: hint,
                    code: code
                },
                data: null,
                count: null,
                status: 0,
                statusText: ""
            };
        });
        return res.then(onfulfilled, onrejected);
    }
    /**
  * Process a fetch response and return the standardized postgrest response.
  */ async processResponse(res) {
        var _this2 = this;
        let error = null;
        let data2 = null;
        let count2 = null;
        let status = res.status;
        let statusText = res.statusText;
        if (res.ok) {
            var _this$headers$get2, _res$headers$get2;
            if (_this2.method !== "HEAD") {
                var _this$headers$get;
                const body = await res.text();
                if (body === "") ;
                else if (_this2.headers.get("Accept") === "text/csv") data2 = body;
                else if (_this2.headers.get("Accept") && ((_this$headers$get = _this2.headers.get("Accept")) === null || _this$headers$get === void 0 ? void 0 : _this$headers$get.includes("application/vnd.pgrst.plan+text"))) data2 = body;
                else data2 = JSON.parse(body);
            }
            const countHeader = (_this$headers$get2 = _this2.headers.get("Prefer")) === null || _this$headers$get2 === void 0 ? void 0 : _this$headers$get2.match(/count=(exact|planned|estimated)/);
            const contentRange = (_res$headers$get2 = res.headers.get("content-range")) === null || _res$headers$get2 === void 0 ? void 0 : _res$headers$get2.split("/");
            if (countHeader && contentRange && contentRange.length > 1) count2 = parseInt(contentRange[1]);
            if (_this2.isMaybeSingle && Array.isArray(data2)) {
                if (data2.length > 1) {
                    error = {
                        code: "PGRST116",
                        details: `Results contain ${data2.length} rows, application/vnd.pgrst.object+json requires 1 row`,
                        hint: null,
                        message: "JSON object requested, multiple (or no) rows returned"
                    };
                    data2 = null;
                    count2 = null;
                    status = 406;
                    statusText = "Not Acceptable";
                } else if (data2.length === 1) data2 = data2[0];
                else data2 = null;
            }
        } else {
            const body = await res.text();
            try {
                error = JSON.parse(body);
                if (Array.isArray(error) && res.status === 404) {
                    data2 = [];
                    error = null;
                    status = 200;
                    statusText = "OK";
                }
            } catch (_unused) {
                if (res.status === 404 && body === "") {
                    status = 204;
                    statusText = "No Content";
                } else error = {
                    message: body
                };
            }
            if (error && _this2.shouldThrowOnError) throw new $281a441cdcb2cf36$var$PostgrestError(error);
        }
        return {
            success: error === null,
            error: error,
            data: data2,
            count: count2,
            status: status,
            statusText: statusText
        };
    }
    /**
  * Override the type of the returned `data`.
  *
  * @typeParam NewResult - The new result type to override with
  * @deprecated Use overrideTypes<yourType, { merge: false }>() method at the end of your call chain instead
  *
  * @category Database
  */ returns() {
        return this;
    }
    /**
  * Override the type of the returned `data` field in the response.
  *
  * @typeParam NewResult - The new type to cast the response data to
  * @typeParam Options - Optional type configuration (defaults to { merge: true })
  * @typeParam Options.merge - When true, merges the new type with existing return type. When false, replaces the existing types entirely (defaults to true)
  * @example
  * ```typescript
  * // Merge with existing types (default behavior)
  * const query = supabase
  *   .from('users')
  *   .select()
  *   .overrideTypes<{ custom_field: string }>()
  *
  * // Replace existing types completely
  * const replaceQuery = supabase
  *   .from('users')
  *   .select()
  *   .overrideTypes<{ id: number; name: string }, { merge: false }>()
  * ```
  * @returns A PostgrestBuilder instance with the new type
  *
  * @category Database
  *
  * @example Complete Override type of successful response
  * ```ts
  * const { data } = await supabase
  *   .from('countries')
  *   .select()
  *   .overrideTypes<Array<MyType>, { merge: false }>()
  * ```
  *
  * @exampleResponse Complete Override type of successful response
  * ```ts
  * let x: typeof data // MyType[]
  * ```
  *
  * @example Complete Override type of object response
  * ```ts
  * const { data } = await supabase
  *   .from('countries')
  *   .select()
  *   .maybeSingle()
  *   .overrideTypes<MyType, { merge: false }>()
  * ```
  *
  * @exampleResponse Complete Override type of object response
  * ```ts
  * let x: typeof data // MyType | null
  * ```
  *
  * @example Partial Override type of successful response
  * ```ts
  * const { data } = await supabase
  *   .from('countries')
  *   .select()
  *   .overrideTypes<Array<{ status: "A" | "B" }>>()
  * ```
  *
  * @exampleResponse Partial Override type of successful response
  * ```ts
  * let x: typeof data // Array<CountryRowProperties & { status: "A" | "B" }>
  * ```
  *
  * @example Partial Override type of object response
  * ```ts
  * const { data } = await supabase
  *   .from('countries')
  *   .select()
  *   .maybeSingle()
  *   .overrideTypes<{ status: "A" | "B" }>()
  * ```
  *
  * @exampleResponse Partial Override type of object response
  * ```ts
  * let x: typeof data // CountryRowProperties & { status: "A" | "B" } | null
  * ```
  *
  * @example Example 5
  * ```typescript
  * // Merge with existing types (default behavior)
  * const query = supabase
  *   .from('users')
  *   .select()
  *   .overrideTypes<{ custom_field: string }>()
  *
  * // Replace existing types completely
  * const replaceQuery = supabase
  *   .from('users')
  *   .select()
  *   .overrideTypes<{ id: number; name: string }, { merge: false }>()
  * ```
  */ overrideTypes() {
        return this;
    }
};
var $281a441cdcb2cf36$var$PostgrestTransformBuilder = class extends $281a441cdcb2cf36$var$PostgrestBuilder {
    /**
  * Perform a SELECT on the query result.
  *
  * By default, `.insert()`, `.update()`, `.upsert()`, and `.delete()` do not
  * return modified rows. By calling this method, modified rows are returned in
  * `data`.
  *
  * @param columns - The columns to retrieve, separated by commas
  *
  * @category Database
  *
  * @example With `upsert()`
  * ```ts
  * const { data, error } = await supabase
  *   .from('characters')
  *   .upsert({ id: 1, name: 'Han Solo' })
  *   .select()
  * ```
  *
  * @exampleSql With `upsert()`
  * ```sql
  * create table
  *   characters (id int8 primary key, name text);
  *
  * insert into
  *   characters (id, name)
  * values
  *   (1, 'Han');
  * ```
  *
  * @exampleResponse With `upsert()`
  * ```json
  * {
  *   "data": [
  *     {
  *       "id": 1,
  *       "name": "Han Solo"
  *     }
  *   ],
  *   "status": 201,
  *   "statusText": "Created"
  * }
  * ```
  */ select(columns) {
        let quoted = false;
        const cleanedColumns = (columns !== null && columns !== void 0 ? columns : "*").split("").map((c3)=>{
            if (/\s/.test(c3) && !quoted) return "";
            if (c3 === '"') quoted = !quoted;
            return c3;
        }).join("");
        this.url.searchParams.set("select", cleanedColumns);
        this.headers.append("Prefer", "return=representation");
        return this;
    }
    /**
  * Order the query result by `column`.
  *
  * You can call this method multiple times to order by multiple columns.
  *
  * You can order referenced tables, but it only affects the ordering of the
  * parent table if you use `!inner` in the query.
  *
  * @param column - The column to order by
  * @param options - Named parameters
  * @param options.ascending - If `true`, the result will be in ascending order
  * @param options.nullsFirst - If `true`, `null`s appear first. If `false`,
  * `null`s appear last.
  * @param options.referencedTable - Set this to order a referenced table by
  * its columns
  * @param options.foreignTable - Deprecated, use `options.referencedTable`
  * instead
  *
  * @category Database
  *
  * @example With `select()`
  * ```ts
  * const { data, error } = await supabase
  *   .from('characters')
  *   .select('id, name')
  *   .order('id', { ascending: false })
  * ```
  *
  * @exampleSql With `select()`
  * ```sql
  * create table
  *   characters (id int8 primary key, name text);
  *
  * insert into
  *   characters (id, name)
  * values
  *   (1, 'Luke'),
  *   (2, 'Leia'),
  *   (3, 'Han');
  * ```
  *
  * @exampleResponse With `select()`
  * ```json
  * {
  *   "data": [
  *     {
  *       "id": 3,
  *       "name": "Han"
  *     },
  *     {
  *       "id": 2,
  *       "name": "Leia"
  *     },
  *     {
  *       "id": 1,
  *       "name": "Luke"
  *     }
  *   ],
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  *
  * @exampleDescription On a referenced table
  * Ordering with `referencedTable` doesn't affect the ordering of the
  * parent table.
  *
  * @example On a referenced table
  * ```ts
  *   const { data, error } = await supabase
  *     .from('orchestral_sections')
  *     .select(`
  *       name,
  *       instruments (
  *         name
  *       )
  *     `)
  *     .order('name', { referencedTable: 'instruments', ascending: false })
  *
  * ```
  *
  * @exampleSql On a referenced table
  * ```sql
  * create table
  *   orchestral_sections (id int8 primary key, name text);
  * create table
  *   instruments (
  *     id int8 primary key,
  *     section_id int8 not null references orchestral_sections,
  *     name text
  *   );
  *
  * insert into
  *   orchestral_sections (id, name)
  * values
  *   (1, 'strings'),
  *   (2, 'woodwinds');
  * insert into
  *   instruments (id, section_id, name)
  * values
  *   (1, 1, 'harp'),
  *   (2, 1, 'violin');
  * ```
  *
  * @exampleResponse On a referenced table
  * ```json
  * {
  *   "data": [
  *     {
  *       "name": "strings",
  *       "instruments": [
  *         {
  *           "name": "violin"
  *         },
  *         {
  *           "name": "harp"
  *         }
  *       ]
  *     },
  *     {
  *       "name": "woodwinds",
  *       "instruments": []
  *     }
  *   ],
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  *
  * @exampleDescription Order parent table by a referenced table
  * Ordering with `referenced_table(col)` affects the ordering of the
  * parent table.
  *
  * @example Order parent table by a referenced table
  * ```ts
  *   const { data, error } = await supabase
  *     .from('instruments')
  *     .select(`
  *       name,
  *       section:orchestral_sections (
  *         name
  *       )
  *     `)
  *     .order('section(name)', { ascending: true })
  *
  * ```
  *
  * @exampleSql Order parent table by a referenced table
  * ```sql
  * create table
  *   orchestral_sections (id int8 primary key, name text);
  * create table
  *   instruments (
  *     id int8 primary key,
  *     section_id int8 not null references orchestral_sections,
  *     name text
  *   );
  *
  * insert into
  *   orchestral_sections (id, name)
  * values
  *   (1, 'strings'),
  *   (2, 'woodwinds');
  * insert into
  *   instruments (id, section_id, name)
  * values
  *   (1, 2, 'flute'),
  *   (2, 1, 'violin');
  * ```
  *
  * @exampleResponse Order parent table by a referenced table
  * ```json
  * {
  *   "data": [
  *     {
  *       "name": "violin",
  *       "orchestral_sections": {"name": "strings"}
  *     },
  *     {
  *       "name": "flute",
  *       "orchestral_sections": {"name": "woodwinds"}
  *     }
  *   ],
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  */ order(column, { ascending: ascending = true, nullsFirst: nullsFirst, foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const key = referencedTable ? `${referencedTable}.order` : "order";
        const existingOrder = this.url.searchParams.get(key);
        this.url.searchParams.set(key, `${existingOrder ? `${existingOrder},` : ""}${column}.${ascending ? "asc" : "desc"}${nullsFirst === void 0 ? "" : nullsFirst ? ".nullsfirst" : ".nullslast"}`);
        return this;
    }
    /**
  * Limit the query result by `count`.
  *
  * @param count - The maximum number of rows to return
  * @param options - Named parameters
  * @param options.referencedTable - Set this to limit rows of referenced
  * tables instead of the parent table
  * @param options.foreignTable - Deprecated, use `options.referencedTable`
  * instead
  *
  * @category Database
  *
  * @example With `select()`
  * ```ts
  * const { data, error } = await supabase
  *   .from('characters')
  *   .select('name')
  *   .limit(1)
  * ```
  *
  * @exampleSql With `select()`
  * ```sql
  * create table
  *   characters (id int8 primary key, name text);
  *
  * insert into
  *   characters (id, name)
  * values
  *   (1, 'Luke'),
  *   (2, 'Leia'),
  *   (3, 'Han');
  * ```
  *
  * @exampleResponse With `select()`
  * ```json
  * {
  *   "data": [
  *     {
  *       "name": "Luke"
  *     }
  *   ],
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  *
  * @example On a referenced table
  * ```ts
  * const { data, error } = await supabase
  *   .from('orchestral_sections')
  *   .select(`
  *     name,
  *     instruments (
  *       name
  *     )
  *   `)
  *   .limit(1, { referencedTable: 'instruments' })
  * ```
  *
  * @exampleSql On a referenced table
  * ```sql
  * create table
  *   orchestral_sections (id int8 primary key, name text);
  * create table
  *   instruments (
  *     id int8 primary key,
  *     section_id int8 not null references orchestral_sections,
  *     name text
  *   );
  *
  * insert into
  *   orchestral_sections (id, name)
  * values
  *   (1, 'strings');
  * insert into
  *   instruments (id, section_id, name)
  * values
  *   (1, 1, 'harp'),
  *   (2, 1, 'violin');
  * ```
  *
  * @exampleResponse On a referenced table
  * ```json
  * {
  *   "data": [
  *     {
  *       "name": "strings",
  *       "instruments": [
  *         {
  *           "name": "violin"
  *         }
  *       ]
  *     }
  *   ],
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  */ limit(count2, { foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const key = typeof referencedTable === "undefined" ? "limit" : `${referencedTable}.limit`;
        this.url.searchParams.set(key, `${count2}`);
        return this;
    }
    /**
  * Limit the query result by starting at an offset `from` and ending at the offset `to`.
  * Only records within this range are returned.
  * This respects the query order and if there is no order clause the range could behave unexpectedly.
  * The `from` and `to` values are 0-based and inclusive: `range(1, 3)` will include the second, third
  * and fourth rows of the query.
  *
  * @param from - The starting index from which to limit the result
  * @param to - The last index to which to limit the result
  * @param options - Named parameters
  * @param options.referencedTable - Set this to limit rows of referenced
  * tables instead of the parent table
  * @param options.foreignTable - Deprecated, use `options.referencedTable`
  * instead
  *
  * @category Database
  *
  * @example With `select()`
  * ```ts
  * const { data, error } = await supabase
  *   .from('characters')
  *   .select('name')
  *   .range(0, 1)
  * ```
  *
  * @exampleSql With `select()`
  * ```sql
  * create table
  *   characters (id int8 primary key, name text);
  *
  * insert into
  *   characters (id, name)
  * values
  *   (1, 'Luke'),
  *   (2, 'Leia'),
  *   (3, 'Han');
  * ```
  *
  * @exampleResponse With `select()`
  * ```json
  * {
  *   "data": [
  *     {
  *       "name": "Luke"
  *     },
  *     {
  *       "name": "Leia"
  *     }
  *   ],
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  */ range(from2, to, { foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const keyOffset = typeof referencedTable === "undefined" ? "offset" : `${referencedTable}.offset`;
        const keyLimit = typeof referencedTable === "undefined" ? "limit" : `${referencedTable}.limit`;
        this.url.searchParams.set(keyOffset, `${from2}`);
        this.url.searchParams.set(keyLimit, `${to - from2 + 1}`);
        return this;
    }
    /**
  * Set the AbortSignal for the fetch request.
  *
  * @param signal - The AbortSignal to use for the fetch request
  *
  * @category Database
  *
  * @remarks
  * You can use this to set a timeout for the request.
  *
  * @exampleDescription Aborting requests in-flight
  * You can use an [`AbortController`](https://developer.mozilla.org/en-US/docs/Web/API/AbortController) to abort requests.
  * Note that `status` and `statusText` don't mean anything for aborted requests as the request wasn't fulfilled.
  *
  * @example Aborting requests in-flight
  * ```ts
  * const ac = new AbortController()
  *
  * const { data, error } = await supabase
  *   .from('very_big_table')
  *   .select()
  *   .abortSignal(ac.signal)
  *
  * // Abort the request after 100 ms
  * setTimeout(() => ac.abort(), 100)
  * ```
  *
  * @exampleResponse Aborting requests in-flight
  * ```json
  *   {
  *     "error": {
  *       "message": "AbortError: The user aborted a request.",
  *       "details": "",
  *       "hint": "The request was aborted locally via the provided AbortSignal.",
  *       "code": ""
  *     },
  *     "status": 0,
  *     "statusText": ""
  *   }
  *
  * ```
  *
  * @example Set a timeout
  * ```ts
  * const { data, error } = await supabase
  *   .from('very_big_table')
  *   .select()
  *   .abortSignal(AbortSignal.timeout(1000 /* ms *\/))
  * ```
  *
  * @exampleResponse Set a timeout
  * ```json
  *   {
  *     "error": {
  *       "message": "FetchError: The user aborted a request.",
  *       "details": "",
  *       "hint": "",
  *       "code": ""
  *     },
  *     "status": 400,
  *     "statusText": "Bad Request"
  *   }
  *
  * ```
  */ abortSignal(signal) {
        this.signal = signal;
        return this;
    }
    /**
  * Return `data` as a single object instead of an array of objects.
  *
  * Query result must be one row (e.g. using `.limit(1)`), otherwise this
  * returns an error.
  *
  * @category Database
  *
  * @example With `select()`
  * ```ts
  * const { data, error } = await supabase
  *   .from('characters')
  *   .select('name')
  *   .limit(1)
  *   .single()
  * ```
  *
  * @exampleSql With `select()`
  * ```sql
  * create table
  *   characters (id int8 primary key, name text);
  *
  * insert into
  *   characters (id, name)
  * values
  *   (1, 'Luke'),
  *   (2, 'Leia'),
  *   (3, 'Han');
  * ```
  *
  * @exampleResponse With `select()`
  * ```json
  * {
  *   "data": {
  *     "name": "Luke"
  *   },
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  */ single() {
        this.headers.set("Accept", "application/vnd.pgrst.object+json");
        return this;
    }
    /**
  * Return `data` as a single object instead of an array of objects.
  *
  * Query result must be zero or one row (e.g. using `.limit(1)`), otherwise
  * this returns an error.
  *
  * @category Database
  *
  * @example With `select()`
  * ```ts
  * const { data, error } = await supabase
  *   .from('characters')
  *   .select()
  *   .eq('name', 'Katniss')
  *   .maybeSingle()
  * ```
  *
  * @exampleSql With `select()`
  * ```sql
  * create table
  *   characters (id int8 primary key, name text);
  *
  * insert into
  *   characters (id, name)
  * values
  *   (1, 'Luke'),
  *   (2, 'Leia'),
  *   (3, 'Han');
  * ```
  *
  * @exampleResponse With `select()`
  * ```json
  * {
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  */ maybeSingle() {
        this.isMaybeSingle = true;
        return this;
    }
    /**
  * Return `data` as a string in CSV format.
  *
  * @category Database
  *
  * @exampleDescription Return data as CSV
  * By default, the data is returned in JSON format, but can also be returned as Comma Separated Values.
  *
  * @example Return data as CSV
  * ```ts
  * const { data, error } = await supabase
  *   .from('characters')
  *   .select()
  *   .csv()
  * ```
  *
  * @exampleSql Return data as CSV
  * ```sql
  * create table
  *   characters (id int8 primary key, name text);
  *
  * insert into
  *   characters (id, name)
  * values
  *   (1, 'Luke'),
  *   (2, 'Leia'),
  *   (3, 'Han');
  * ```
  *
  * @exampleResponse Return data as CSV
  * ```json
  * {
  *   "data": "id,name\n1,Luke\n2,Leia\n3,Han",
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  */ csv() {
        this.headers.set("Accept", "text/csv");
        return this;
    }
    /**
  * Return `data` as an object in [GeoJSON](https://geojson.org) format.
  *
  * @category Database
  */ geojson() {
        this.headers.set("Accept", "application/geo+json");
        return this;
    }
    /**
  * Return `data` as the EXPLAIN plan for the query.
  *
  * You need to enable the
  * [db_plan_enabled](https://supabase.com/docs/guides/database/debugging-performance#enabling-explain)
  * setting before using this method.
  *
  * @param options - Named parameters
  *
  * @param options.analyze - If `true`, the query will be executed and the
  * actual run time will be returned
  *
  * @param options.verbose - If `true`, the query identifier will be returned
  * and `data` will include the output columns of the query
  *
  * @param options.settings - If `true`, include information on configuration
  * parameters that affect query planning
  *
  * @param options.buffers - If `true`, include information on buffer usage
  *
  * @param options.wal - If `true`, include information on WAL record generation
  *
  * @param options.format - The format of the output, can be `"text"` (default)
  * or `"json"`
  *
  * @category Database
  *
  * @exampleDescription Get the execution plan
  * By default, the data is returned in TEXT format, but can also be returned as JSON by using the `format` parameter.
  *
  * @example Get the execution plan
  * ```ts
  * const { data, error } = await supabase
  *   .from('characters')
  *   .select()
  *   .explain()
  * ```
  *
  * @exampleSql Get the execution plan
  * ```sql
  * create table
  *   characters (id int8 primary key, name text);
  *
  * insert into
  *   characters (id, name)
  * values
  *   (1, 'Luke'),
  *   (2, 'Leia'),
  *   (3, 'Han');
  * ```
  *
  * @exampleResponse Get the execution plan
  * ```js
  * Aggregate  (cost=33.34..33.36 rows=1 width=112)
  *   ->  Limit  (cost=0.00..18.33 rows=1000 width=40)
  *         ->  Seq Scan on characters  (cost=0.00..22.00 rows=1200 width=40)
  * ```
  *
  * @exampleDescription Get the execution plan with analyze and verbose
  * By default, the data is returned in TEXT format, but can also be returned as JSON by using the `format` parameter.
  *
  * @example Get the execution plan with analyze and verbose
  * ```ts
  * const { data, error } = await supabase
  *   .from('characters')
  *   .select()
  *   .explain({analyze:true,verbose:true})
  * ```
  *
  * @exampleSql Get the execution plan with analyze and verbose
  * ```sql
  * create table
  *   characters (id int8 primary key, name text);
  *
  * insert into
  *   characters (id, name)
  * values
  *   (1, 'Luke'),
  *   (2, 'Leia'),
  *   (3, 'Han');
  * ```
  *
  * @exampleResponse Get the execution plan with analyze and verbose
  * ```js
  * Aggregate  (cost=33.34..33.36 rows=1 width=112) (actual time=0.041..0.041 rows=1 loops=1)
  *   Output: NULL::bigint, count(ROW(characters.id, characters.name)), COALESCE(json_agg(ROW(characters.id, characters.name)), '[]'::json), NULLIF(current_setting('response.headers'::text, true), ''::text), NULLIF(current_setting('response.status'::text, true), ''::text)
  *   ->  Limit  (cost=0.00..18.33 rows=1000 width=40) (actual time=0.005..0.006 rows=3 loops=1)
  *         Output: characters.id, characters.name
  *         ->  Seq Scan on public.characters  (cost=0.00..22.00 rows=1200 width=40) (actual time=0.004..0.005 rows=3 loops=1)
  *               Output: characters.id, characters.name
  * Query Identifier: -4730654291623321173
  * Planning Time: 0.407 ms
  * Execution Time: 0.119 ms
  * ```
  */ explain({ analyze: analyze = false, verbose: verbose = false, settings: settings = false, buffers: buffers = false, wal: wal = false, format: format = "text" } = {}) {
        var _this$headers$get;
        const options = [
            analyze ? "analyze" : null,
            verbose ? "verbose" : null,
            settings ? "settings" : null,
            buffers ? "buffers" : null,
            wal ? "wal" : null
        ].filter(Boolean).join("|");
        const forMediatype = (_this$headers$get = this.headers.get("Accept")) !== null && _this$headers$get !== void 0 ? _this$headers$get : "application/json";
        this.headers.set("Accept", `application/vnd.pgrst.plan+${format}; for="${forMediatype}"; options=${options};`);
        if (format === "json") return this;
        else return this;
    }
    /**
  * Rollback the query.
  *
  * `data` will still be returned, but the query is not committed.
  *
  * @category Database
  */ rollback() {
        this.headers.append("Prefer", "tx=rollback");
        return this;
    }
    /**
  * Override the type of the returned `data`.
  *
  * @typeParam NewResult - The new result type to override with
  * @deprecated Use overrideTypes<yourType, { merge: false }>() method at the end of your call chain instead
  *
  * @category Database
  *
  * @remarks
  * - Deprecated: use overrideTypes method instead
  *
  * @example Override type of successful response
  * ```ts
  * const { data } = await supabase
  *   .from('countries')
  *   .select()
  *   .returns<Array<MyType>>()
  * ```
  *
  * @exampleResponse Override type of successful response
  * ```js
  * let x: typeof data // MyType[]
  * ```
  *
  * @example Override type of object response
  * ```ts
  * const { data } = await supabase
  *   .from('countries')
  *   .select()
  *   .maybeSingle()
  *   .returns<MyType>()
  * ```
  *
  * @exampleResponse Override type of object response
  * ```js
  * let x: typeof data // MyType | null
  * ```
  */ returns() {
        return this;
    }
    /**
  * Set the maximum number of rows that can be affected by the query.
  * Only available in PostgREST v13+ and only works with PATCH and DELETE methods.
  *
  * @param value - The maximum number of rows that can be affected
  *
  * @category Database
  */ maxAffected(value2) {
        this.headers.append("Prefer", "handling=strict");
        this.headers.append("Prefer", `max-affected=${value2}`);
        return this;
    }
};
var $281a441cdcb2cf36$var$PostgrestReservedCharsRegexp = /* @__PURE__ */ new RegExp("[,()]");
var $281a441cdcb2cf36$var$PostgrestFilterBuilder = class extends $281a441cdcb2cf36$var$PostgrestTransformBuilder {
    /**
  * Match only rows where `column` is equal to `value`.
  *
  * To check if the value of `column` is NULL, you should use `.is()` instead.
  *
  * @param column - The column to filter on
  * @param value - The value to filter with
  *
  * @category Database
  *
  * @example With `select()`
  * ```ts
  * const { data, error } = await supabase
  *   .from('characters')
  *   .select()
  *   .eq('name', 'Leia')
  * ```
  *
  * @exampleSql With `select()`
  * ```sql
  * create table
  *   characters (id int8 primary key, name text);
  *
  * insert into
  *   characters (id, name)
  * values
  *   (1, 'Luke'),
  *   (2, 'Leia'),
  *   (3, 'Han');
  * ```
  *
  * @exampleResponse With `select()`
  * ```json
  * {
  *   "data": [
  *     {
  *       "id": 2,
  *       "name": "Leia"
  *     }
  *   ],
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  */ eq(column, value2) {
        this.url.searchParams.append(column, `eq.${value2}`);
        return this;
    }
    /**
  * Match only rows where `column` is not equal to `value`.
  *
  * @param column - The column to filter on
  * @param value - The value to filter with
  *
  * @category Database
  *
  * @example With `select()`
  * ```ts
  * const { data, error } = await supabase
  *   .from('characters')
  *   .select()
  *   .neq('name', 'Leia')
  * ```
  *
  * @exampleSql With `select()`
  * ```sql
  * create table
  *   characters (id int8 primary key, name text);
  *
  * insert into
  *   characters (id, name)
  * values
  *   (1, 'Luke'),
  *   (2, 'Leia'),
  *   (3, 'Han');
  * ```
  *
  * @exampleResponse With `select()`
  * ```json
  * {
  *   "data": [
  *     {
  *       "id": 1,
  *       "name": "Luke"
  *     },
  *     {
  *       "id": 3,
  *       "name": "Han"
  *     }
  *   ],
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  */ neq(column, value2) {
        this.url.searchParams.append(column, `neq.${value2}`);
        return this;
    }
    /**
  * Match only rows where `column` is greater than `value`.
  *
  * @param column - The column to filter on
  * @param value - The value to filter with
  *
  * @category Database
  *
  * @exampleDescription With `select()`
  * When using [reserved words](https://www.postgresql.org/docs/current/sql-keywords-appendix.html) for column names you need
  * to add double quotes e.g. `.gt('"order"', 2)`
  *
  * @example With `select()`
  * ```ts
  * const { data, error } = await supabase
  *   .from('characters')
  *   .select()
  *   .gt('id', 2)
  * ```
  *
  * @exampleSql With `select()`
  * ```sql
  * create table
  *   characters (id int8 primary key, name text);
  *
  * insert into
  *   characters (id, name)
  * values
  *   (1, 'Luke'),
  *   (2, 'Leia'),
  *   (3, 'Han');
  * ```
  *
  * @exampleResponse With `select()`
  * ```json
  * {
  *   "data": [
  *     {
  *       "id": 3,
  *       "name": "Han"
  *     }
  *   ],
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  */ gt(column, value2) {
        this.url.searchParams.append(column, `gt.${value2}`);
        return this;
    }
    /**
  * Match only rows where `column` is greater than or equal to `value`.
  *
  * @param column - The column to filter on
  * @param value - The value to filter with
  *
  * @category Database
  *
  * @example With `select()`
  * ```ts
  * const { data, error } = await supabase
  *   .from('characters')
  *   .select()
  *   .gte('id', 2)
  * ```
  *
  * @exampleSql With `select()`
  * ```sql
  * create table
  *   characters (id int8 primary key, name text);
  *
  * insert into
  *   characters (id, name)
  * values
  *   (1, 'Luke'),
  *   (2, 'Leia'),
  *   (3, 'Han');
  * ```
  *
  * @exampleResponse With `select()`
  * ```json
  * {
  *   "data": [
  *     {
  *       "id": 2,
  *       "name": "Leia"
  *     },
  *     {
  *       "id": 3,
  *       "name": "Han"
  *     }
  *   ],
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  */ gte(column, value2) {
        this.url.searchParams.append(column, `gte.${value2}`);
        return this;
    }
    /**
  * Match only rows where `column` is less than `value`.
  *
  * @param column - The column to filter on
  * @param value - The value to filter with
  *
  * @category Database
  *
  * @example With `select()`
  * ```ts
  * const { data, error } = await supabase
  *   .from('characters')
  *   .select()
  *   .lt('id', 2)
  * ```
  *
  * @exampleSql With `select()`
  * ```sql
  * create table
  *   characters (id int8 primary key, name text);
  *
  * insert into
  *   characters (id, name)
  * values
  *   (1, 'Luke'),
  *   (2, 'Leia'),
  *   (3, 'Han');
  * ```
  *
  * @exampleResponse With `select()`
  * ```json
  * {
  *   "data": [
  *     {
  *       "id": 1,
  *       "name": "Luke"
  *     }
  *   ],
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  */ lt(column, value2) {
        this.url.searchParams.append(column, `lt.${value2}`);
        return this;
    }
    /**
  * Match only rows where `column` is less than or equal to `value`.
  *
  * @param column - The column to filter on
  * @param value - The value to filter with
  *
  * @category Database
  *
  * @example With `select()`
  * ```ts
  * const { data, error } = await supabase
  *   .from('characters')
  *   .select()
  *   .lte('id', 2)
  * ```
  *
  * @exampleSql With `select()`
  * ```sql
  * create table
  *   characters (id int8 primary key, name text);
  *
  * insert into
  *   characters (id, name)
  * values
  *   (1, 'Luke'),
  *   (2, 'Leia'),
  *   (3, 'Han');
  * ```
  *
  * @exampleResponse With `select()`
  * ```json
  * {
  *   "data": [
  *     {
  *       "id": 1,
  *       "name": "Luke"
  *     },
  *     {
  *       "id": 2,
  *       "name": "Leia"
  *     }
  *   ],
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  */ lte(column, value2) {
        this.url.searchParams.append(column, `lte.${value2}`);
        return this;
    }
    /**
  * Match only rows where `column` matches `pattern` case-sensitively.
  *
  * @param column - The column to filter on
  * @param pattern - The pattern to match with
  *
  * @category Database
  *
  * @example With `select()`
  * ```ts
  * const { data, error } = await supabase
  *   .from('characters')
  *   .select()
  *   .like('name', '%Lu%')
  * ```
  *
  * @exampleSql With `select()`
  * ```sql
  * create table
  *   characters (id int8 primary key, name text);
  *
  * insert into
  *   characters (id, name)
  * values
  *   (1, 'Luke'),
  *   (2, 'Leia'),
  *   (3, 'Han');
  * ```
  *
  * @exampleResponse With `select()`
  * ```json
  * {
  *   "data": [
  *     {
  *       "id": 1,
  *       "name": "Luke"
  *     }
  *   ],
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  */ like(column, pattern) {
        this.url.searchParams.append(column, `like.${pattern}`);
        return this;
    }
    /**
  * Match only rows where `column` matches all of `patterns` case-sensitively.
  *
  * @param column - The column to filter on
  * @param patterns - The patterns to match with
  *
  * @category Database
  */ likeAllOf(column, patterns) {
        this.url.searchParams.append(column, `like(all).{${patterns.join(",")}}`);
        return this;
    }
    /**
  * Match only rows where `column` matches any of `patterns` case-sensitively.
  *
  * @param column - The column to filter on
  * @param patterns - The patterns to match with
  *
  * @category Database
  */ likeAnyOf(column, patterns) {
        this.url.searchParams.append(column, `like(any).{${patterns.join(",")}}`);
        return this;
    }
    /**
  * Match only rows where `column` matches `pattern` case-insensitively.
  *
  * @param column - The column to filter on
  * @param pattern - The pattern to match with
  *
  * @category Database
  *
  * @example With `select()`
  * ```ts
  * const { data, error } = await supabase
  *   .from('characters')
  *   .select()
  *   .ilike('name', '%lu%')
  * ```
  *
  * @exampleSql With `select()`
  * ```sql
  * create table
  *   characters (id int8 primary key, name text);
  *
  * insert into
  *   characters (id, name)
  * values
  *   (1, 'Luke'),
  *   (2, 'Leia'),
  *   (3, 'Han');
  * ```
  *
  * @exampleResponse With `select()`
  * ```json
  * {
  *   "data": [
  *     {
  *       "id": 1,
  *       "name": "Luke"
  *     }
  *   ],
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  */ ilike(column, pattern) {
        this.url.searchParams.append(column, `ilike.${pattern}`);
        return this;
    }
    /**
  * Match only rows where `column` matches all of `patterns` case-insensitively.
  *
  * @param column - The column to filter on
  * @param patterns - The patterns to match with
  *
  * @category Database
  */ ilikeAllOf(column, patterns) {
        this.url.searchParams.append(column, `ilike(all).{${patterns.join(",")}}`);
        return this;
    }
    /**
  * Match only rows where `column` matches any of `patterns` case-insensitively.
  *
  * @param column - The column to filter on
  * @param patterns - The patterns to match with
  *
  * @category Database
  */ ilikeAnyOf(column, patterns) {
        this.url.searchParams.append(column, `ilike(any).{${patterns.join(",")}}`);
        return this;
    }
    /**
  * Match only rows where `column` matches the PostgreSQL regex `pattern`
  * case-sensitively (using the `~` operator).
  *
  * @param column - The column to filter on
  * @param pattern - The PostgreSQL regular expression pattern to match with
  */ regexMatch(column, pattern) {
        this.url.searchParams.append(column, `match.${pattern}`);
        return this;
    }
    /**
  * Match only rows where `column` matches the PostgreSQL regex `pattern`
  * case-insensitively (using the `~*` operator).
  *
  * @param column - The column to filter on
  * @param pattern - The PostgreSQL regular expression pattern to match with
  */ regexIMatch(column, pattern) {
        this.url.searchParams.append(column, `imatch.${pattern}`);
        return this;
    }
    /**
  * Match only rows where `column` IS `value`.
  *
  * For non-boolean columns, this is only relevant for checking if the value of
  * `column` is NULL by setting `value` to `null`.
  *
  * For boolean columns, you can also set `value` to `true` or `false` and it
  * will behave the same way as `.eq()`.
  *
  * @param column - The column to filter on
  * @param value - The value to filter with
  *
  * @category Database
  *
  * @exampleDescription Checking for nullness, true or false
  * Using the `eq()` filter doesn't work when filtering for `null`.
  *
  * Instead, you need to use `is()`.
  *
  * @example Checking for nullness, true or false
  * ```ts
  * const { data, error } = await supabase
  *   .from('countries')
  *   .select()
  *   .is('name', null)
  * ```
  *
  * @exampleSql Checking for nullness, true or false
  * ```sql
  * create table
  *   countries (id int8 primary key, name text);
  *
  * insert into
  *   countries (id, name)
  * values
  *   (1, 'null'),
  *   (2, null);
  * ```
  *
  * @exampleResponse Checking for nullness, true or false
  * ```json
  * {
  *   "data": [
  *     {
  *       "id": 2,
  *       "name": "null"
  *     }
  *   ],
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  */ is(column, value2) {
        this.url.searchParams.append(column, `is.${value2}`);
        return this;
    }
    /**
  * Match only rows where `column` IS DISTINCT FROM `value`.
  *
  * Unlike `.neq()`, this treats `NULL` as a comparable value. Two `NULL` values
  * are considered equal (not distinct), and comparing `NULL` with any non-NULL
  * value returns true (distinct).
  *
  * @param column - The column to filter on
  * @param value - The value to filter with
  */ isDistinct(column, value2) {
        this.url.searchParams.append(column, `isdistinct.${value2}`);
        return this;
    }
    /**
  * Match only rows where `column` is included in the `values` array.
  *
  * @param column - The column to filter on
  * @param values - The values array to filter with
  *
  * @category Database
  *
  * @example With `select()`
  * ```ts
  * const { data, error } = await supabase
  *   .from('characters')
  *   .select()
  *   .in('name', ['Leia', 'Han'])
  * ```
  *
  * @exampleSql With `select()`
  * ```sql
  * create table
  *   characters (id int8 primary key, name text);
  *
  * insert into
  *   characters (id, name)
  * values
  *   (1, 'Luke'),
  *   (2, 'Leia'),
  *   (3, 'Han');
  * ```
  *
  * @exampleResponse With `select()`
  * ```json
  * {
  *   "data": [
  *     {
  *       "id": 2,
  *       "name": "Leia"
  *     },
  *     {
  *       "id": 3,
  *       "name": "Han"
  *     }
  *   ],
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  */ in(column, values) {
        const cleanedValues = Array.from(new Set(values)).map((s3)=>{
            if (typeof s3 === "string" && $281a441cdcb2cf36$var$PostgrestReservedCharsRegexp.test(s3)) return `"${s3}"`;
            else return `${s3}`;
        }).join(",");
        this.url.searchParams.append(column, `in.(${cleanedValues})`);
        return this;
    }
    /**
  * Match only rows where `column` is NOT included in the `values` array.
  *
  * @param column - The column to filter on
  * @param values - The values array to filter with
  */ notIn(column, values) {
        const cleanedValues = Array.from(new Set(values)).map((s3)=>{
            if (typeof s3 === "string" && $281a441cdcb2cf36$var$PostgrestReservedCharsRegexp.test(s3)) return `"${s3}"`;
            else return `${s3}`;
        }).join(",");
        this.url.searchParams.append(column, `not.in.(${cleanedValues})`);
        return this;
    }
    /**
  * Only relevant for jsonb, array, and range columns. Match only rows where
  * `column` contains every element appearing in `value`.
  *
  * @param column - The jsonb, array, or range column to filter on
  * @param value - The jsonb, array, or range value to filter with
  *
  * @category Database
  *
  * @example On array columns
  * ```ts
  * const { data, error } = await supabase
  *   .from('issues')
  *   .select()
  *   .contains('tags', ['is:open', 'priority:low'])
  * ```
  *
  * @exampleSql On array columns
  * ```sql
  * create table
  *   issues (
  *     id int8 primary key,
  *     title text,
  *     tags text[]
  *   );
  *
  * insert into
  *   issues (id, title, tags)
  * values
  *   (1, 'Cache invalidation is not working', array['is:open', 'severity:high', 'priority:low']),
  *   (2, 'Use better names', array['is:open', 'severity:low', 'priority:medium']);
  * ```
  *
  * @exampleResponse On array columns
  * ```json
  * {
  *   "data": [
  *     {
  *       "title": "Cache invalidation is not working"
  *     }
  *   ],
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  *
  * @exampleDescription On range columns
  * Postgres supports a number of [range
  * types](https://www.postgresql.org/docs/current/rangetypes.html). You
  * can filter on range columns using the string representation of range
  * values.
  *
  * @example On range columns
  * ```ts
  * const { data, error } = await supabase
  *   .from('reservations')
  *   .select()
  *   .contains('during', '[2000-01-01 13:00, 2000-01-01 13:30)')
  * ```
  *
  * @exampleSql On range columns
  * ```sql
  * create table
  *   reservations (
  *     id int8 primary key,
  *     room_name text,
  *     during tsrange
  *   );
  *
  * insert into
  *   reservations (id, room_name, during)
  * values
  *   (1, 'Emerald', '[2000-01-01 13:00, 2000-01-01 15:00)'),
  *   (2, 'Topaz', '[2000-01-02 09:00, 2000-01-02 10:00)');
  * ```
  *
  * @exampleResponse On range columns
  * ```json
  * {
  *   "data": [
  *     {
  *       "id": 1,
  *       "room_name": "Emerald",
  *       "during": "[\"2000-01-01 13:00:00\",\"2000-01-01 15:00:00\")"
  *     }
  *   ],
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  *
  * @example On `jsonb` columns
  * ```ts
  * const { data, error } = await supabase
  *   .from('users')
  *   .select('name')
  *   .contains('address', { postcode: 90210 })
  * ```
  *
  * @exampleSql On `jsonb` columns
  * ```sql
  * create table
  *   users (
  *     id int8 primary key,
  *     name text,
  *     address jsonb
  *   );
  *
  * insert into
  *   users (id, name, address)
  * values
  *   (1, 'Michael', '{ "postcode": 90210, "street": "Melrose Place" }'),
  *   (2, 'Jane', '{}');
  * ```
  *
  * @exampleResponse On `jsonb` columns
  * ```json
  * {
  *   "data": [
  *     {
  *       "name": "Michael"
  *     }
  *   ],
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  */ contains(column, value2) {
        if (typeof value2 === "string") this.url.searchParams.append(column, `cs.${value2}`);
        else if (Array.isArray(value2)) this.url.searchParams.append(column, `cs.{${value2.join(",")}}`);
        else this.url.searchParams.append(column, `cs.${JSON.stringify(value2)}`);
        return this;
    }
    /**
  * Only relevant for jsonb, array, and range columns. Match only rows where
  * every element appearing in `column` is contained by `value`.
  *
  * @param column - The jsonb, array, or range column to filter on
  * @param value - The jsonb, array, or range value to filter with
  *
  * @category Database
  *
  * @example On array columns
  * ```ts
  * const { data, error } = await supabase
  *   .from('classes')
  *   .select('name')
  *   .containedBy('days', ['monday', 'tuesday', 'wednesday', 'friday'])
  * ```
  *
  * @exampleSql On array columns
  * ```sql
  * create table
  *   classes (
  *     id int8 primary key,
  *     name text,
  *     days text[]
  *   );
  *
  * insert into
  *   classes (id, name, days)
  * values
  *   (1, 'Chemistry', array['monday', 'friday']),
  *   (2, 'History', array['monday', 'wednesday', 'thursday']);
  * ```
  *
  * @exampleResponse On array columns
  * ```json
  * {
  *   "data": [
  *     {
  *       "name": "Chemistry"
  *     }
  *   ],
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  *
  * @exampleDescription On range columns
  * Postgres supports a number of [range
  * types](https://www.postgresql.org/docs/current/rangetypes.html). You
  * can filter on range columns using the string representation of range
  * values.
  *
  * @example On range columns
  * ```ts
  * const { data, error } = await supabase
  *   .from('reservations')
  *   .select()
  *   .containedBy('during', '[2000-01-01 00:00, 2000-01-01 23:59)')
  * ```
  *
  * @exampleSql On range columns
  * ```sql
  * create table
  *   reservations (
  *     id int8 primary key,
  *     room_name text,
  *     during tsrange
  *   );
  *
  * insert into
  *   reservations (id, room_name, during)
  * values
  *   (1, 'Emerald', '[2000-01-01 13:00, 2000-01-01 15:00)'),
  *   (2, 'Topaz', '[2000-01-02 09:00, 2000-01-02 10:00)');
  * ```
  *
  * @exampleResponse On range columns
  * ```json
  * {
  *   "data": [
  *     {
  *       "id": 1,
  *       "room_name": "Emerald",
  *       "during": "[\"2000-01-01 13:00:00\",\"2000-01-01 15:00:00\")"
  *     }
  *   ],
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  *
  * @example On `jsonb` columns
  * ```ts
  * const { data, error } = await supabase
  *   .from('users')
  *   .select('name')
  *   .containedBy('address', {})
  * ```
  *
  * @exampleSql On `jsonb` columns
  * ```sql
  * create table
  *   users (
  *     id int8 primary key,
  *     name text,
  *     address jsonb
  *   );
  *
  * insert into
  *   users (id, name, address)
  * values
  *   (1, 'Michael', '{ "postcode": 90210, "street": "Melrose Place" }'),
  *   (2, 'Jane', '{}');
  * ```
  *
  * @exampleResponse On `jsonb` columns
  * ```json
  *   {
  *     "data": [
  *       {
  *         "name": "Jane"
  *       }
  *     ],
  *     "status": 200,
  *     "statusText": "OK"
  *   }
  *
  * ```
  */ containedBy(column, value2) {
        if (typeof value2 === "string") this.url.searchParams.append(column, `cd.${value2}`);
        else if (Array.isArray(value2)) this.url.searchParams.append(column, `cd.{${value2.join(",")}}`);
        else this.url.searchParams.append(column, `cd.${JSON.stringify(value2)}`);
        return this;
    }
    /**
  * Only relevant for range columns. Match only rows where every element in
  * `column` is greater than any element in `range`.
  *
  * @param column - The range column to filter on
  * @param range - The range to filter with
  *
  * @category Database
  *
  * @exampleDescription With `select()`
  * Postgres supports a number of [range
  * types](https://www.postgresql.org/docs/current/rangetypes.html). You
  * can filter on range columns using the string representation of range
  * values.
  *
  * @example With `select()`
  * ```ts
  * const { data, error } = await supabase
  *   .from('reservations')
  *   .select()
  *   .rangeGt('during', '[2000-01-02 08:00, 2000-01-02 09:00)')
  * ```
  *
  * @exampleSql With `select()`
  * ```sql
  * create table
  *   reservations (
  *     id int8 primary key,
  *     room_name text,
  *     during tsrange
  *   );
  *
  * insert into
  *   reservations (id, room_name, during)
  * values
  *   (1, 'Emerald', '[2000-01-01 13:00, 2000-01-01 15:00)'),
  *   (2, 'Topaz', '[2000-01-02 09:00, 2000-01-02 10:00)');
  * ```
  *
  * @exampleResponse With `select()`
  * ```json
  *   {
  *     "data": [
  *       {
  *         "id": 2,
  *         "room_name": "Topaz",
  *         "during": "[\"2000-01-02 09:00:00\",\"2000-01-02 10:00:00\")"
  *       }
  *     ],
  *     "status": 200,
  *     "statusText": "OK"
  *   }
  *
  * ```
  */ rangeGt(column, range) {
        this.url.searchParams.append(column, `sr.${range}`);
        return this;
    }
    /**
  * Only relevant for range columns. Match only rows where every element in
  * `column` is either contained in `range` or greater than any element in
  * `range`.
  *
  * @param column - The range column to filter on
  * @param range - The range to filter with
  *
  * @category Database
  *
  * @exampleDescription With `select()`
  * Postgres supports a number of [range
  * types](https://www.postgresql.org/docs/current/rangetypes.html). You
  * can filter on range columns using the string representation of range
  * values.
  *
  * @example With `select()`
  * ```ts
  * const { data, error } = await supabase
  *   .from('reservations')
  *   .select()
  *   .rangeGte('during', '[2000-01-02 08:30, 2000-01-02 09:30)')
  * ```
  *
  * @exampleSql With `select()`
  * ```sql
  * create table
  *   reservations (
  *     id int8 primary key,
  *     room_name text,
  *     during tsrange
  *   );
  *
  * insert into
  *   reservations (id, room_name, during)
  * values
  *   (1, 'Emerald', '[2000-01-01 13:00, 2000-01-01 15:00)'),
  *   (2, 'Topaz', '[2000-01-02 09:00, 2000-01-02 10:00)');
  * ```
  *
  * @exampleResponse With `select()`
  * ```json
  *   {
  *     "data": [
  *       {
  *         "id": 2,
  *         "room_name": "Topaz",
  *         "during": "[\"2000-01-02 09:00:00\",\"2000-01-02 10:00:00\")"
  *       }
  *     ],
  *     "status": 200,
  *     "statusText": "OK"
  *   }
  *
  * ```
  */ rangeGte(column, range) {
        this.url.searchParams.append(column, `nxl.${range}`);
        return this;
    }
    /**
  * Only relevant for range columns. Match only rows where every element in
  * `column` is less than any element in `range`.
  *
  * @param column - The range column to filter on
  * @param range - The range to filter with
  *
  * @category Database
  *
  * @exampleDescription With `select()`
  * Postgres supports a number of [range
  * types](https://www.postgresql.org/docs/current/rangetypes.html). You
  * can filter on range columns using the string representation of range
  * values.
  *
  * @example With `select()`
  * ```ts
  * const { data, error } = await supabase
  *   .from('reservations')
  *   .select()
  *   .rangeLt('during', '[2000-01-01 15:00, 2000-01-01 16:00)')
  * ```
  *
  * @exampleSql With `select()`
  * ```sql
  * create table
  *   reservations (
  *     id int8 primary key,
  *     room_name text,
  *     during tsrange
  *   );
  *
  * insert into
  *   reservations (id, room_name, during)
  * values
  *   (1, 'Emerald', '[2000-01-01 13:00, 2000-01-01 15:00)'),
  *   (2, 'Topaz', '[2000-01-02 09:00, 2000-01-02 10:00)');
  * ```
  *
  * @exampleResponse With `select()`
  * ```json
  * {
  *   "data": [
  *     {
  *       "id": 1,
  *       "room_name": "Emerald",
  *       "during": "[\"2000-01-01 13:00:00\",\"2000-01-01 15:00:00\")"
  *     }
  *   ],
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  */ rangeLt(column, range) {
        this.url.searchParams.append(column, `sl.${range}`);
        return this;
    }
    /**
  * Only relevant for range columns. Match only rows where every element in
  * `column` is either contained in `range` or less than any element in
  * `range`.
  *
  * @param column - The range column to filter on
  * @param range - The range to filter with
  *
  * @category Database
  *
  * @exampleDescription With `select()`
  * Postgres supports a number of [range
  * types](https://www.postgresql.org/docs/current/rangetypes.html). You
  * can filter on range columns using the string representation of range
  * values.
  *
  * @example With `select()`
  * ```ts
  * const { data, error } = await supabase
  *   .from('reservations')
  *   .select()
  *   .rangeLte('during', '[2000-01-01 14:00, 2000-01-01 16:00)')
  * ```
  *
  * @exampleSql With `select()`
  * ```sql
  * create table
  *   reservations (
  *     id int8 primary key,
  *     room_name text,
  *     during tsrange
  *   );
  *
  * insert into
  *   reservations (id, room_name, during)
  * values
  *   (1, 'Emerald', '[2000-01-01 13:00, 2000-01-01 15:00)'),
  *   (2, 'Topaz', '[2000-01-02 09:00, 2000-01-02 10:00)');
  * ```
  *
  * @exampleResponse With `select()`
  * ```json
  *   {
  *     "data": [
  *       {
  *         "id": 1,
  *         "room_name": "Emerald",
  *         "during": "[\"2000-01-01 13:00:00\",\"2000-01-01 15:00:00\")"
  *       }
  *     ],
  *     "status": 200,
  *     "statusText": "OK"
  *   }
  *
  * ```
  */ rangeLte(column, range) {
        this.url.searchParams.append(column, `nxr.${range}`);
        return this;
    }
    /**
  * Only relevant for range columns. Match only rows where `column` is
  * mutually exclusive to `range` and there can be no element between the two
  * ranges.
  *
  * @param column - The range column to filter on
  * @param range - The range to filter with
  *
  * @category Database
  *
  * @exampleDescription With `select()`
  * Postgres supports a number of [range
  * types](https://www.postgresql.org/docs/current/rangetypes.html). You
  * can filter on range columns using the string representation of range
  * values.
  *
  * @example With `select()`
  * ```ts
  * const { data, error } = await supabase
  *   .from('reservations')
  *   .select()
  *   .rangeAdjacent('during', '[2000-01-01 12:00, 2000-01-01 13:00)')
  * ```
  *
  * @exampleSql With `select()`
  * ```sql
  * create table
  *   reservations (
  *     id int8 primary key,
  *     room_name text,
  *     during tsrange
  *   );
  *
  * insert into
  *   reservations (id, room_name, during)
  * values
  *   (1, 'Emerald', '[2000-01-01 13:00, 2000-01-01 15:00)'),
  *   (2, 'Topaz', '[2000-01-02 09:00, 2000-01-02 10:00)');
  * ```
  *
  * @exampleResponse With `select()`
  * ```json
  * {
  *   "data": [
  *     {
  *       "id": 1,
  *       "room_name": "Emerald",
  *       "during": "[\"2000-01-01 13:00:00\",\"2000-01-01 15:00:00\")"
  *     }
  *   ],
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  */ rangeAdjacent(column, range) {
        this.url.searchParams.append(column, `adj.${range}`);
        return this;
    }
    /**
  * Only relevant for array and range columns. Match only rows where
  * `column` and `value` have an element in common.
  *
  * @param column - The array or range column to filter on
  * @param value - The array or range value to filter with
  *
  * @category Database
  *
  * @example On array columns
  * ```ts
  * const { data, error } = await supabase
  *   .from('issues')
  *   .select('title')
  *   .overlaps('tags', ['is:closed', 'severity:high'])
  * ```
  *
  * @exampleSql On array columns
  * ```sql
  * create table
  *   issues (
  *     id int8 primary key,
  *     title text,
  *     tags text[]
  *   );
  *
  * insert into
  *   issues (id, title, tags)
  * values
  *   (1, 'Cache invalidation is not working', array['is:open', 'severity:high', 'priority:low']),
  *   (2, 'Use better names', array['is:open', 'severity:low', 'priority:medium']);
  * ```
  *
  * @exampleResponse On array columns
  * ```json
  * {
  *   "data": [
  *     {
  *       "title": "Cache invalidation is not working"
  *     }
  *   ],
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  *
  * @exampleDescription On range columns
  * Postgres supports a number of [range
  * types](https://www.postgresql.org/docs/current/rangetypes.html). You
  * can filter on range columns using the string representation of range
  * values.
  *
  * @example On range columns
  * ```ts
  * const { data, error } = await supabase
  *   .from('reservations')
  *   .select()
  *   .overlaps('during', '[2000-01-01 12:45, 2000-01-01 13:15)')
  * ```
  *
  * @exampleSql On range columns
  * ```sql
  * create table
  *   reservations (
  *     id int8 primary key,
  *     room_name text,
  *     during tsrange
  *   );
  *
  * insert into
  *   reservations (id, room_name, during)
  * values
  *   (1, 'Emerald', '[2000-01-01 13:00, 2000-01-01 15:00)'),
  *   (2, 'Topaz', '[2000-01-02 09:00, 2000-01-02 10:00)');
  * ```
  *
  * @exampleResponse On range columns
  * ```json
  * {
  *   "data": [
  *     {
  *       "id": 1,
  *       "room_name": "Emerald",
  *       "during": "[\"2000-01-01 13:00:00\",\"2000-01-01 15:00:00\")"
  *     }
  *   ],
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  */ overlaps(column, value2) {
        if (typeof value2 === "string") this.url.searchParams.append(column, `ov.${value2}`);
        else this.url.searchParams.append(column, `ov.{${value2.join(",")}}`);
        return this;
    }
    /**
  * Only relevant for text and tsvector columns. Match only rows where
  * `column` matches the query string in `query`.
  *
  * @param column - The text or tsvector column to filter on
  * @param query - The query text to match with
  * @param options - Named parameters
  * @param options.config - The text search configuration to use
  * @param options.type - Change how the `query` text is interpreted
  *
  * @category Database
  *
  * @remarks
  * - For more information, see [Postgres full text search](/docs/guides/database/full-text-search).
  *
  * @example Text search
  * ```ts
  * const result = await supabase
  *   .from("texts")
  *   .select("content")
  *   .textSearch("content", `'eggs' & 'ham'`, {
  *     config: "english",
  *   });
  * ```
  *
  * @exampleSql Text search
  * ```sql
  * create table texts (
  *   id      bigint
  *           primary key
  *           generated always as identity,
  *   content text
  * );
  *
  * insert into texts (content) values
  *     ('Four score and seven years ago'),
  *     ('The road goes ever on and on'),
  *     ('Green eggs and ham')
  * ;
  * ```
  *
  * @exampleResponse Text search
  * ```json
  * {
  *   "data": [
  *     {
  *       "content": "Green eggs and ham"
  *     }
  *   ],
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  *
  * @exampleDescription Basic normalization
  * Uses PostgreSQL's `plainto_tsquery` function.
  *
  * @example Basic normalization
  * ```ts
  * const { data, error } = await supabase
  *   .from('quotes')
  *   .select('catchphrase')
  *   .textSearch('catchphrase', `'fat' & 'cat'`, {
  *     type: 'plain',
  *     config: 'english'
  *   })
  * ```
  *
  * @exampleDescription Full normalization
  * Uses PostgreSQL's `phraseto_tsquery` function.
  *
  * @example Full normalization
  * ```ts
  * const { data, error } = await supabase
  *   .from('quotes')
  *   .select('catchphrase')
  *   .textSearch('catchphrase', `'fat' & 'cat'`, {
  *     type: 'phrase',
  *     config: 'english'
  *   })
  * ```
  *
  * @exampleDescription Websearch
  * Uses PostgreSQL's `websearch_to_tsquery` function.
  * This function will never raise syntax errors, which makes it possible to use raw user-supplied input for search, and can be used
  * with advanced operators.
  *
  * - `unquoted text`: text not inside quote marks will be converted to terms separated by & operators, as if processed by plainto_tsquery.
  * - `"quoted text"`: text inside quote marks will be converted to terms separated by `<->` operators, as if processed by phraseto_tsquery.
  * - `OR`: the word “or” will be converted to the | operator.
  * - `-`: a dash will be converted to the ! operator.
  *
  * @example Websearch
  * ```ts
  * const { data, error } = await supabase
  *   .from('quotes')
  *   .select('catchphrase')
  *   .textSearch('catchphrase', `'fat or cat'`, {
  *     type: 'websearch',
  *     config: 'english'
  *   })
  * ```
  */ textSearch(column, query, { config: config, type: type } = {}) {
        let typePart = "";
        if (type === "plain") typePart = "pl";
        else if (type === "phrase") typePart = "ph";
        else if (type === "websearch") typePart = "w";
        const configPart = config === void 0 ? "" : `(${config})`;
        this.url.searchParams.append(column, `${typePart}fts${configPart}.${query}`);
        return this;
    }
    /**
  * Match only rows where each column in `query` keys is equal to its
  * associated value. Shorthand for multiple `.eq()`s.
  *
  * @param query - The object to filter with, with column names as keys mapped
  * to their filter values
  *
  * @category Database
  *
  * @example With `select()`
  * ```ts
  * const { data, error } = await supabase
  *   .from('characters')
  *   .select('name')
  *   .match({ id: 2, name: 'Leia' })
  * ```
  *
  * @exampleSql With `select()`
  * ```sql
  * create table
  *   characters (id int8 primary key, name text);
  *
  * insert into
  *   characters (id, name)
  * values
  *   (1, 'Luke'),
  *   (2, 'Leia'),
  *   (3, 'Han');
  * ```
  *
  * @exampleResponse With `select()`
  * ```json
  * {
  *   "data": [
  *     {
  *       "name": "Leia"
  *     }
  *   ],
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  */ match(query) {
        Object.entries(query).filter(([_3, value2])=>value2 !== void 0).forEach(([column, value2])=>{
            this.url.searchParams.append(column, `eq.${value2}`);
        });
        return this;
    }
    /**
  * Match only rows which doesn't satisfy the filter.
  *
  * Unlike most filters, `opearator` and `value` are used as-is and need to
  * follow [PostgREST
  * syntax](https://postgrest.org/en/stable/api.html#operators). You also need
  * to make sure they are properly sanitized.
  *
  * @param column - The column to filter on
  * @param operator - The operator to be negated to filter with, following
  * PostgREST syntax
  * @param value - The value to filter with, following PostgREST syntax
  *
  * @category Database
  *
  * @remarks
  * not() expects you to use the raw PostgREST syntax for the filter values.
  *
  * ```ts
  * .not('id', 'in', '(5,6,7)')  // Use `()` for `in` filter
  * .not('arraycol', 'cs', '{"a","b"}')  // Use `cs` for `contains()`, `{}` for array values
  * ```
  *
  * @example With `select()`
  * ```ts
  * const { data, error } = await supabase
  *   .from('countries')
  *   .select()
  *   .not('name', 'is', null)
  * ```
  *
  * @exampleSql With `select()`
  * ```sql
  * create table
  *   countries (id int8 primary key, name text);
  *
  * insert into
  *   countries (id, name)
  * values
  *   (1, 'null'),
  *   (2, null);
  * ```
  *
  * @exampleResponse With `select()`
  * ```json
  *   {
  *     "data": [
  *       {
  *         "id": 1,
  *         "name": "null"
  *       }
  *     ],
  *     "status": 200,
  *     "statusText": "OK"
  *   }
  *
  * ```
  */ not(column, operator, value2) {
        this.url.searchParams.append(column, `not.${operator}.${value2}`);
        return this;
    }
    /**
  * Match only rows which satisfy at least one of the filters.
  *
  * Unlike most filters, `filters` is used as-is and needs to follow [PostgREST
  * syntax](https://postgrest.org/en/stable/api.html#operators). You also need
  * to make sure it's properly sanitized.
  *
  * It's currently not possible to do an `.or()` filter across multiple tables.
  *
  * @param filters - The filters to use, following PostgREST syntax
  * @param options - Named parameters
  * @param options.referencedTable - Set this to filter on referenced tables
  * instead of the parent table
  * @param options.foreignTable - Deprecated, use `referencedTable` instead
  *
  * @category Database
  *
  * @remarks
  * or() expects you to use the raw PostgREST syntax for the filter names and values.
  *
  * ```ts
  * .or('id.in.(5,6,7), arraycol.cs.{"a","b"}')  // Use `()` for `in` filter, `{}` for array values and `cs` for `contains()`.
  * .or('id.in.(5,6,7), arraycol.cd.{"a","b"}')  // Use `cd` for `containedBy()`
  * ```
  *
  * @example With `select()`
  * ```ts
  * const { data, error } = await supabase
  *   .from('characters')
  *   .select('name')
  *   .or('id.eq.2,name.eq.Han')
  * ```
  *
  * @exampleSql With `select()`
  * ```sql
  * create table
  *   characters (id int8 primary key, name text);
  *
  * insert into
  *   characters (id, name)
  * values
  *   (1, 'Luke'),
  *   (2, 'Leia'),
  *   (3, 'Han');
  * ```
  *
  * @exampleResponse With `select()`
  * ```json
  * {
  *   "data": [
  *     {
  *       "name": "Leia"
  *     },
  *     {
  *       "name": "Han"
  *     }
  *   ],
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  *
  * @example Use `or` with `and`
  * ```ts
  * const { data, error } = await supabase
  *   .from('characters')
  *   .select('name')
  *   .or('id.gt.3,and(id.eq.1,name.eq.Luke)')
  * ```
  *
  * @exampleSql Use `or` with `and`
  * ```sql
  * create table
  *   characters (id int8 primary key, name text);
  *
  * insert into
  *   characters (id, name)
  * values
  *   (1, 'Luke'),
  *   (2, 'Leia'),
  *   (3, 'Han');
  * ```
  *
  * @exampleResponse Use `or` with `and`
  * ```json
  * {
  *   "data": [
  *     {
  *       "name": "Luke"
  *     }
  *   ],
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  *
  * @example Use `or` on referenced tables
  * ```ts
  * const { data, error } = await supabase
  *   .from('orchestral_sections')
  *   .select(`
  *     name,
  *     instruments!inner (
  *       name
  *     )
  *   `)
  *   .or('section_id.eq.1,name.eq.guzheng', { referencedTable: 'instruments' })
  * ```
  *
  * @exampleSql Use `or` on referenced tables
  * ```sql
  * create table
  *   orchestral_sections (id int8 primary key, name text);
  * create table
  *   instruments (
  *     id int8 primary key,
  *     section_id int8 not null references orchestral_sections,
  *     name text
  *   );
  *
  * insert into
  *   orchestral_sections (id, name)
  * values
  *   (1, 'strings'),
  *   (2, 'woodwinds');
  * insert into
  *   instruments (id, section_id, name)
  * values
  *   (1, 2, 'flute'),
  *   (2, 1, 'violin');
  * ```
  *
  * @exampleResponse Use `or` on referenced tables
  * ```json
  * {
  *   "data": [
  *     {
  *       "name": "strings",
  *       "instruments": [
  *         {
  *           "name": "violin"
  *         }
  *       ]
  *     }
  *   ],
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  */ or(filters, { foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const key = referencedTable ? `${referencedTable}.or` : "or";
        this.url.searchParams.append(key, `(${filters})`);
        return this;
    }
    /**
  * Match only rows which satisfy the filter. This is an escape hatch - you
  * should use the specific filter methods wherever possible.
  *
  * Unlike most filters, `opearator` and `value` are used as-is and need to
  * follow [PostgREST
  * syntax](https://postgrest.org/en/stable/api.html#operators). You also need
  * to make sure they are properly sanitized.
  *
  * @param column - The column to filter on
  * @param operator - The operator to filter with, following PostgREST syntax
  * @param value - The value to filter with, following PostgREST syntax
  *
  * @category Database
  *
  * @remarks
  * filter() expects you to use the raw PostgREST syntax for the filter values.
  *
  * ```ts
  * .filter('id', 'in', '(5,6,7)')  // Use `()` for `in` filter
  * .filter('arraycol', 'cs', '{"a","b"}')  // Use `cs` for `contains()`, `{}` for array values
  * ```
  *
  * @example With `select()`
  * ```ts
  * const { data, error } = await supabase
  *   .from('characters')
  *   .select()
  *   .filter('name', 'in', '("Han","Yoda")')
  * ```
  *
  * @exampleSql With `select()`
  * ```sql
  * create table
  *   characters (id int8 primary key, name text);
  *
  * insert into
  *   characters (id, name)
  * values
  *   (1, 'Luke'),
  *   (2, 'Leia'),
  *   (3, 'Han');
  * ```
  *
  * @exampleResponse With `select()`
  * ```json
  * {
  *   "data": [
  *     {
  *       "id": 3,
  *       "name": "Han"
  *     }
  *   ],
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  *
  * @example On a referenced table
  * ```ts
  * const { data, error } = await supabase
  *   .from('orchestral_sections')
  *   .select(`
  *     name,
  *     instruments!inner (
  *       name
  *     )
  *   `)
  *   .filter('instruments.name', 'eq', 'flute')
  * ```
  *
  * @exampleSql On a referenced table
  * ```sql
  * create table
  *   orchestral_sections (id int8 primary key, name text);
  * create table
  *    instruments (
  *     id int8 primary key,
  *     section_id int8 not null references orchestral_sections,
  *     name text
  *   );
  *
  * insert into
  *   orchestral_sections (id, name)
  * values
  *   (1, 'strings'),
  *   (2, 'woodwinds');
  * insert into
  *   instruments (id, section_id, name)
  * values
  *   (1, 2, 'flute'),
  *   (2, 1, 'violin');
  * ```
  *
  * @exampleResponse On a referenced table
  * ```json
  * {
  *   "data": [
  *     {
  *       "name": "woodwinds",
  *       "instruments": [
  *         {
  *           "name": "flute"
  *         }
  *       ]
  *     }
  *   ],
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  */ filter(column, operator, value2) {
        this.url.searchParams.append(column, `${operator}.${value2}`);
        return this;
    }
};
var $281a441cdcb2cf36$var$PostgrestQueryBuilder = class {
    /**
  * Creates a query builder scoped to a Postgres table or view.
  *
  * @category Database
  *
  * @param url - The URL for the query
  * @param options - Named parameters
  * @param options.headers - Custom headers
  * @param options.schema - Postgres schema to use
  * @param options.fetch - Custom fetch implementation
  * @param options.urlLengthLimit - Maximum URL length before warning
  * @param options.retry - Enable automatic retries for transient errors (default: true)
  *
  * @example Using supabase-js (recommended)
  * ```ts
  * import { createClient } from '@supabase/supabase-js'
  *
  * const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
  * const { data, error } = await supabase.from('users').select('*')
  * ```
  *
  * @example Standalone import for bundle-sensitive environments
  * ```ts
  * import { PostgrestQueryBuilder } from '@supabase/postgrest-js'
  *
  * const query = new PostgrestQueryBuilder(
  *   new URL('https://xyzcompany.supabase.co/rest/v1/users'),
  *   { headers: { apikey: 'your-publishable-key' }, retry: true }
  * )
  * ```
  */ constructor(url2, { headers: headers = {}, schema: schema, fetch: fetch$1, urlLengthLimit: urlLengthLimit = 8e3, retry: retry }){
        this.url = url2;
        this.headers = new Headers(headers);
        this.schema = schema;
        this.fetch = fetch$1;
        this.urlLengthLimit = urlLengthLimit;
        this.retry = retry;
    }
    /**
  * Clone URL and headers to prevent shared state between operations.
  */ cloneRequestState() {
        return {
            url: new URL(this.url.toString()),
            headers: new Headers(this.headers)
        };
    }
    /**
  * Perform a SELECT query on the table or view.
  *
  * @param columns - The columns to retrieve, separated by commas. Columns can be renamed when returned with `customName:columnName`
  *
  * @param options - Named parameters
  *
  * @param options.head - When set to `true`, `data` will not be returned.
  * Useful if you only need the count.
  *
  * @param options.count - Count algorithm to use to count rows in the table or view.
  *
  * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
  * hood.
  *
  * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
  * statistics under the hood.
  *
  * `"estimated"`: Uses exact count for low numbers and planned count for high
  * numbers.
  *
  * @remarks
  * When using `count` with `.range()` or `.limit()`, the returned `count` is the total number of rows
  * that match your filters, not the number of rows in the current page. Use this to build pagination UI.
  
  * - By default, Supabase projects return a maximum of 1,000 rows. This setting can be changed in your project's [API settings](/dashboard/project/_/settings/api). It's recommended that you keep it low to limit the payload size of accidental or malicious requests. You can use `range()` queries to paginate through your data.
  * - `select()` can be combined with [Filters](/docs/reference/javascript/using-filters)
  * - `select()` can be combined with [Modifiers](/docs/reference/javascript/using-modifiers)
  * - `apikey` is a reserved keyword if you're using the [Supabase Platform](/docs/guides/platform) and [should be avoided as a column name](https://github.com/supabase/supabase/issues/5465). *
  * @category Database
  *
  * @example Getting your data
  * ```js
  * const { data, error } = await supabase
  *   .from('characters')
  *   .select()
  * ```
  *
  * @exampleSql Getting your data
  * ```sql
  * create table
  *   characters (id int8 primary key, name text);
  *
  * insert into
  *   characters (id, name)
  * values
  *   (1, 'Harry'),
  *   (2, 'Frodo'),
  *   (3, 'Katniss');
  * ```
  *
  * @exampleResponse Getting your data
  * ```json
  * {
  *   "data": [
  *     {
  *       "id": 1,
  *       "name": "Harry"
  *     },
  *     {
  *       "id": 2,
  *       "name": "Frodo"
  *     },
  *     {
  *       "id": 3,
  *       "name": "Katniss"
  *     }
  *   ],
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  *
  * @example Selecting specific columns
  * ```js
  * const { data, error } = await supabase
  *   .from('characters')
  *   .select('name')
  * ```
  *
  * @exampleSql Selecting specific columns
  * ```sql
  * create table
  *   characters (id int8 primary key, name text);
  *
  * insert into
  *   characters (id, name)
  * values
  *   (1, 'Frodo'),
  *   (2, 'Harry'),
  *   (3, 'Katniss');
  * ```
  *
  * @exampleResponse Selecting specific columns
  * ```json
  * {
  *   "data": [
  *     {
  *       "name": "Frodo"
  *     },
  *     {
  *       "name": "Harry"
  *     },
  *     {
  *       "name": "Katniss"
  *     }
  *   ],
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  *
  * @exampleDescription Query referenced tables
  * If your database has foreign key relationships, you can query related tables too.
  *
  * @example Query referenced tables
  * ```js
  * const { data, error } = await supabase
  *   .from('orchestral_sections')
  *   .select(`
  *     name,
  *     instruments (
  *       name
  *     )
  *   `)
  * ```
  *
  * @exampleSql Query referenced tables
  * ```sql
  * create table
  *   orchestral_sections (id int8 primary key, name text);
  * create table
  *   instruments (
  *     id int8 primary key,
  *     section_id int8 not null references orchestral_sections,
  *     name text
  *   );
  *
  * insert into
  *   orchestral_sections (id, name)
  * values
  *   (1, 'strings'),
  *   (2, 'woodwinds');
  * insert into
  *   instruments (id, section_id, name)
  * values
  *   (1, 2, 'flute'),
  *   (2, 1, 'violin');
  * ```
  *
  * @exampleResponse Query referenced tables
  * ```json
  * {
  *   "data": [
  *     {
  *       "name": "strings",
  *       "instruments": [
  *         {
  *           "name": "violin"
  *         }
  *       ]
  *     },
  *     {
  *       "name": "woodwinds",
  *       "instruments": [
  *         {
  *           "name": "flute"
  *         }
  *       ]
  *     }
  *   ],
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  *
  * @exampleDescription Query referenced tables with spaces in their names
  * If your table name contains spaces, you must use double quotes in the `select` statement to reference the table.
  *
  * @example Query referenced tables with spaces in their names
  * ```js
  * const { data, error } = await supabase
  *   .from('orchestral sections')
  *   .select(`
  *     name,
  *     "musical instruments" (
  *       name
  *     )
  *   `)
  * ```
  *
  * @exampleSql Query referenced tables with spaces in their names
  * ```sql
  * create table
  *   "orchestral sections" (id int8 primary key, name text);
  * create table
  *   "musical instruments" (
  *     id int8 primary key,
  *     section_id int8 not null references "orchestral sections",
  *     name text
  *   );
  *
  * insert into
  *   "orchestral sections" (id, name)
  * values
  *   (1, 'strings'),
  *   (2, 'woodwinds');
  * insert into
  *   "musical instruments" (id, section_id, name)
  * values
  *   (1, 2, 'flute'),
  *   (2, 1, 'violin');
  * ```
  *
  * @exampleResponse Query referenced tables with spaces in their names
  * ```json
  * {
  *   "data": [
  *     {
  *       "name": "strings",
  *       "musical instruments": [
  *         {
  *           "name": "violin"
  *         }
  *       ]
  *     },
  *     {
  *       "name": "woodwinds",
  *       "musical instruments": [
  *         {
  *           "name": "flute"
  *         }
  *       ]
  *     }
  *   ],
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  *
  * @exampleDescription Query referenced tables through a join table
  * If you're in a situation where your tables are **NOT** directly
  * related, but instead are joined by a _join table_, you can still use
  * the `select()` method to query the related data. The join table needs
  * to have the foreign keys as part of its composite primary key.
  *
  * @example Query referenced tables through a join table
  * ```ts
  * const { data, error } = await supabase
  *   .from('users')
  *   .select(`
  *     name,
  *     teams (
  *       name
  *     )
  *   `)
  *   
  * ```
  *
  * @exampleSql Query referenced tables through a join table
  * ```sql
  * create table
  *   users (
  *     id int8 primary key,
  *     name text
  *   );
  * create table
  *   teams (
  *     id int8 primary key,
  *     name text
  *   );
  * -- join table
  * create table
  *   users_teams (
  *     user_id int8 not null references users,
  *     team_id int8 not null references teams,
  *     -- both foreign keys must be part of a composite primary key
  *     primary key (user_id, team_id)
  *   );
  *
  * insert into
  *   users (id, name)
  * values
  *   (1, 'Kiran'),
  *   (2, 'Evan');
  * insert into
  *   teams (id, name)
  * values
  *   (1, 'Green'),
  *   (2, 'Blue');
  * insert into
  *   users_teams (user_id, team_id)
  * values
  *   (1, 1),
  *   (1, 2),
  *   (2, 2);
  * ```
  *
  * @exampleResponse Query referenced tables through a join table
  * ```json
  *   {
  *     "data": [
  *       {
  *         "name": "Kiran",
  *         "teams": [
  *           {
  *             "name": "Green"
  *           },
  *           {
  *             "name": "Blue"
  *           }
  *         ]
  *       },
  *       {
  *         "name": "Evan",
  *         "teams": [
  *           {
  *             "name": "Blue"
  *           }
  *         ]
  *       }
  *     ],
  *     "status": 200,
  *     "statusText": "OK"
  *   }
  *   
  * ```
  *
  * @exampleDescription Query the same referenced table multiple times
  * If you need to query the same referenced table twice, use the name of the
  * joined column to identify which join to use. You can also give each
  * column an alias.
  *
  * @example Query the same referenced table multiple times
  * ```ts
  * const { data, error } = await supabase
  *   .from('messages')
  *   .select(`
  *     content,
  *     from:sender_id(name),
  *     to:receiver_id(name)
  *   `)
  *
  * // To infer types, use the name of the table (in this case `users`) and
  * // the name of the foreign key constraint.
  * const { data, error } = await supabase
  *   .from('messages')
  *   .select(`
  *     content,
  *     from:users!messages_sender_id_fkey(name),
  *     to:users!messages_receiver_id_fkey(name)
  *   `)
  * ```
  *
  * @exampleSql Query the same referenced table multiple times
  * ```sql
  *  create table
  *  users (id int8 primary key, name text);
  *
  *  create table
  *    messages (
  *      sender_id int8 not null references users,
  *      receiver_id int8 not null references users,
  *      content text
  *    );
  *
  *  insert into
  *    users (id, name)
  *  values
  *    (1, 'Kiran'),
  *    (2, 'Evan');
  *
  *  insert into
  *    messages (sender_id, receiver_id, content)
  *  values
  *    (1, 2, '👋');
  *  ```
  * ```
  *
  * @exampleResponse Query the same referenced table multiple times
  * ```json
  * {
  *   "data": [
  *     {
  *       "content": "👋",
  *       "from": {
  *         "name": "Kiran"
  *       },
  *       "to": {
  *         "name": "Evan"
  *       }
  *     }
  *   ],
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  *
  * @exampleDescription Query nested foreign tables through a join table
  * You can use the result of a joined table to gather data in
  * another foreign table. With multiple references to the same foreign
  * table you must specify the column on which to conduct the join.
  *
  * @example Query nested foreign tables through a join table
  * ```ts
  *   const { data, error } = await supabase
  *     .from('games')
  *     .select(`
  *       game_id:id,
  *       away_team:teams!games_away_team_fkey (
  *         users (
  *           id,
  *           name
  *         )
  *       )
  *     `)
  *   
  * ```
  *
  * @exampleSql Query nested foreign tables through a join table
  * ```sql
  * ```sql
  * create table
  *   users (
  *     id int8 primary key,
  *     name text
  *   );
  * create table
  *   teams (
  *     id int8 primary key,
  *     name text
  *   );
  * -- join table
  * create table
  *   users_teams (
  *     user_id int8 not null references users,
  *     team_id int8 not null references teams,
  *
  *     primary key (user_id, team_id)
  *   );
  * create table
  *   games (
  *     id int8 primary key,
  *     home_team int8 not null references teams,
  *     away_team int8 not null references teams,
  *     name text
  *   );
  *
  * insert into users (id, name)
  * values
  *   (1, 'Kiran'),
  *   (2, 'Evan');
  * insert into
  *   teams (id, name)
  * values
  *   (1, 'Green'),
  *   (2, 'Blue');
  * insert into
  *   users_teams (user_id, team_id)
  * values
  *   (1, 1),
  *   (1, 2),
  *   (2, 2);
  * insert into
  *   games (id, home_team, away_team, name)
  * values
  *   (1, 1, 2, 'Green vs Blue'),
  *   (2, 2, 1, 'Blue vs Green');
  * ```
  *
  * @exampleResponse Query nested foreign tables through a join table
  * ```json
  *   {
  *     "data": [
  *       {
  *         "game_id": 1,
  *         "away_team": {
  *           "users": [
  *             {
  *               "id": 1,
  *               "name": "Kiran"
  *             },
  *             {
  *               "id": 2,
  *               "name": "Evan"
  *             }
  *           ]
  *         }
  *       },
  *       {
  *         "game_id": 2,
  *         "away_team": {
  *           "users": [
  *             {
  *               "id": 1,
  *               "name": "Kiran"
  *             }
  *           ]
  *         }
  *       }
  *     ],
  *     "status": 200,
  *     "statusText": "OK"
  *   }
  *   
  * ```
  *
  * @exampleDescription Filtering through referenced tables
  * If the filter on a referenced table's column is not satisfied, the referenced
  * table returns `[]` or `null` but the parent table is not filtered out.
  * If you want to filter out the parent table rows, use the `!inner` hint
  *
  * @example Filtering through referenced tables
  * ```ts
  * const { data, error } = await supabase
  *   .from('instruments')
  *   .select('name, orchestral_sections(*)')
  *   .eq('orchestral_sections.name', 'percussion')
  * ```
  *
  * @exampleSql Filtering through referenced tables
  * ```sql
  * create table
  *   orchestral_sections (id int8 primary key, name text);
  * create table
  *   instruments (
  *     id int8 primary key,
  *     section_id int8 not null references orchestral_sections,
  *     name text
  *   );
  *
  * insert into
  *   orchestral_sections (id, name)
  * values
  *   (1, 'strings'),
  *   (2, 'woodwinds');
  * insert into
  *   instruments (id, section_id, name)
  * values
  *   (1, 2, 'flute'),
  *   (2, 1, 'violin');
  * ```
  *
  * @exampleResponse Filtering through referenced tables
  * ```json
  * {
  *   "data": [
  *     {
  *       "name": "flute",
  *       "orchestral_sections": null
  *     },
  *     {
  *       "name": "violin",
  *       "orchestral_sections": null
  *     }
  *   ],
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  *
  * @exampleDescription Querying referenced table with count
  * You can get the number of rows in a related table by using the
  * **count** property.
  *
  * @example Querying referenced table with count
  * ```ts
  * const { data, error } = await supabase
  *   .from('orchestral_sections')
  *   .select(`*, instruments(count)`)
  * ```
  *
  * @exampleSql Querying referenced table with count
  * ```sql
  * create table orchestral_sections (
  *   "id" "uuid" primary key default "extensions"."uuid_generate_v4"() not null,
  *   "name" text
  * );
  *
  * create table characters (
  *   "id" "uuid" primary key default "extensions"."uuid_generate_v4"() not null,
  *   "name" text,
  *   "section_id" "uuid" references public.orchestral_sections on delete cascade
  * );
  *
  * with section as (
  *   insert into orchestral_sections (name)
  *   values ('strings') returning id
  * )
  * insert into instruments (name, section_id) values
  * ('violin', (select id from section)),
  * ('viola', (select id from section)),
  * ('cello', (select id from section)),
  * ('double bass', (select id from section));
  * ```
  *
  * @exampleResponse Querying referenced table with count
  * ```json
  * [
  *   {
  *     "id": "693694e7-d993-4360-a6d7-6294e325d9b6",
  *     "name": "strings",
  *     "instruments": [
  *       {
  *         "count": 4
  *       }
  *     ]
  *   }
  * ]
  * ```
  *
  * @exampleDescription Querying with count option
  * You can get the number of rows by using the
  * [count](/docs/reference/javascript/select#parameters) option.
  *
  * @example Querying with count option
  * ```ts
  * const { count, error } = await supabase
  *   .from('characters')
  *   .select('*', { count: 'exact', head: true })
  * ```
  *
  * @exampleSql Querying with count option
  * ```sql
  * create table
  *   characters (id int8 primary key, name text);
  *
  * insert into
  *   characters (id, name)
  * values
  *   (1, 'Luke'),
  *   (2, 'Leia'),
  *   (3, 'Han');
  * ```
  *
  * @exampleResponse Querying with count option
  * ```json
  * {
  *   "count": 3,
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  *
  * @exampleDescription Querying JSON data
  * You can select and filter data inside of
  * [JSON](/docs/guides/database/json) columns. Postgres offers some
  * [operators](/docs/guides/database/json#query-the-jsonb-data) for
  * querying JSON data.
  *
  * @example Querying JSON data
  * ```ts
  * const { data, error } = await supabase
  *   .from('users')
  *   .select(`
  *     id, name,
  *     address->city
  *   `)
  * ```
  *
  * @exampleSql Querying JSON data
  * ```sql
  * create table
  *   users (
  *     id int8 primary key,
  *     name text,
  *     address jsonb
  *   );
  *
  * insert into
  *   users (id, name, address)
  * values
  *   (1, 'Frodo', '{"city":"Hobbiton"}');
  * ```
  *
  * @exampleResponse Querying JSON data
  * ```json
  * {
  *   "data": [
  *     {
  *       "id": 1,
  *       "name": "Frodo",
  *       "city": "Hobbiton"
  *     }
  *   ],
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  *
  * @exampleDescription Querying referenced table with inner join
  * If you don't want to return the referenced table contents, you can leave the parenthesis empty.
  * Like `.select('name, orchestral_sections!inner()')`.
  *
  * @example Querying referenced table with inner join
  * ```ts
  * const { data, error } = await supabase
  *   .from('instruments')
  *   .select('name, orchestral_sections!inner(name)')
  *   .eq('orchestral_sections.name', 'woodwinds')
  *   .limit(1)
  * ```
  *
  * @exampleSql Querying referenced table with inner join
  * ```sql
  * create table orchestral_sections (
  *   "id" "uuid" primary key default "extensions"."uuid_generate_v4"() not null,
  *   "name" text
  * );
  *
  * create table instruments (
  *   "id" "uuid" primary key default "extensions"."uuid_generate_v4"() not null,
  *   "name" text,
  *   "section_id" "uuid" references public.orchestral_sections on delete cascade
  * );
  *
  * with section as (
  *   insert into orchestral_sections (name)
  *   values ('woodwinds') returning id
  * )
  * insert into instruments (name, section_id) values
  * ('flute', (select id from section)),
  * ('clarinet', (select id from section)),
  * ('bassoon', (select id from section)),
  * ('piccolo', (select id from section));
  * ```
  *
  * @exampleResponse Querying referenced table with inner join
  * ```json
  * {
  *   "data": [
  *     {
  *       "name": "flute",
  *       "orchestral_sections": {"name": "woodwinds"}
  *     }
  *   ],
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  *
  * @exampleDescription Switching schemas per query
  * In addition to setting the schema during initialization, you can also switch schemas on a per-query basis.
  * Make sure you've set up your [database privileges and API settings](/docs/guides/api/using-custom-schemas).
  *
  * @example Switching schemas per query
  * ```ts
  * const { data, error } = await supabase
  *   .schema('myschema')
  *   .from('mytable')
  *   .select()
  * ```
  *
  * @exampleSql Switching schemas per query
  * ```sql
  * create schema myschema;
  *
  * create table myschema.mytable (
  *   id uuid primary key default gen_random_uuid(),
  *   data text
  * );
  *
  * insert into myschema.mytable (data) values ('mydata');
  * ```
  *
  * @exampleResponse Switching schemas per query
  * ```json
  * {
  *   "data": [
  *     {
  *       "id": "4162e008-27b0-4c0f-82dc-ccaeee9a624d",
  *       "data": "mydata"
  *     }
  *   ],
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  */ select(columns, options) {
        const { head: head2 = false, count: count2 } = options !== null && options !== void 0 ? options : {};
        const method = head2 ? "HEAD" : "GET";
        let quoted = false;
        const cleanedColumns = (columns !== null && columns !== void 0 ? columns : "*").split("").map((c3)=>{
            if (/\s/.test(c3) && !quoted) return "";
            if (c3 === '"') quoted = !quoted;
            return c3;
        }).join("");
        const { url: url2, headers: headers } = this.cloneRequestState();
        url2.searchParams.set("select", cleanedColumns);
        if (count2) headers.append("Prefer", `count=${count2}`);
        return new $281a441cdcb2cf36$var$PostgrestFilterBuilder({
            method: method,
            url: url2,
            headers: headers,
            schema: this.schema,
            fetch: this.fetch,
            urlLengthLimit: this.urlLengthLimit,
            retry: this.retry
        });
    }
    /**
  * Perform an INSERT into the table or view.
  *
  * By default, inserted rows are not returned. To return it, chain the call
  * with `.select()`.
  *
  * @param values - The values to insert. Pass an object to insert a single row
  * or an array to insert multiple rows.
  *
  * @param options - Named parameters
  *
  * @param options.count - Count algorithm to use to count inserted rows.
  *
  * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
  * hood.
  *
  * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
  * statistics under the hood.
  *
  * `"estimated"`: Uses exact count for low numbers and planned count for high
  * numbers.
  *
  * @param options.defaultToNull - Make missing fields default to `null`.
  * Otherwise, use the default value for the column. Only applies for bulk
  * inserts.
  *
  * @category Database
  *
  * @example Create a record
  * ```ts
  * const { error } = await supabase
  *   .from('countries')
  *   .insert({ id: 1, name: 'Mordor' })
  * ```
  *
  * @exampleSql Create a record
  * ```sql
  * create table
  *   countries (id int8 primary key, name text);
  * ```
  *
  * @exampleResponse Create a record
  * ```json
  * {
  *   "status": 201,
  *   "statusText": "Created"
  * }
  * ```
  *
  * @example Create a record and return it
  * ```ts
  * const { data, error } = await supabase
  *   .from('countries')
  *   .insert({ id: 1, name: 'Mordor' })
  *   .select()
  * ```
  *
  * @exampleSql Create a record and return it
  * ```sql
  * create table
  *   countries (id int8 primary key, name text);
  * ```
  *
  * @exampleResponse Create a record and return it
  * ```json
  * {
  *   "data": [
  *     {
  *       "id": 1,
  *       "name": "Mordor"
  *     }
  *   ],
  *   "status": 201,
  *   "statusText": "Created"
  * }
  * ```
  *
  * @exampleDescription Bulk create
  * A bulk create operation is handled in a single transaction.
  * If any of the inserts fail, none of the rows are inserted.
  *
  * @example Bulk create
  * ```ts
  * const { error } = await supabase
  *   .from('countries')
  *   .insert([
  *     { id: 1, name: 'Mordor' },
  *     { id: 1, name: 'The Shire' },
  *   ])
  * ```
  *
  * @exampleSql Bulk create
  * ```sql
  * create table
  *   countries (id int8 primary key, name text);
  * ```
  *
  * @exampleResponse Bulk create
  * ```json
  * {
  *   "error": {
  *     "code": "23505",
  *     "details": "Key (id)=(1) already exists.",
  *     "hint": null,
  *     "message": "duplicate key value violates unique constraint \"countries_pkey\""
  *   },
  *   "status": 409,
  *   "statusText": "Conflict"
  * }
  * ```
  */ insert(values, { count: count2, defaultToNull: defaultToNull = true } = {}) {
        var _this$fetch;
        const method = "POST";
        const { url: url2, headers: headers } = this.cloneRequestState();
        if (count2) headers.append("Prefer", `count=${count2}`);
        if (!defaultToNull) headers.append("Prefer", `missing=default`);
        if (Array.isArray(values)) {
            const columns = values.reduce((acc, x3)=>acc.concat(Object.keys(x3)), []);
            if (columns.length > 0) {
                const uniqueColumns = [
                    ...new Set(columns)
                ].map((column)=>`"${column}"`);
                url2.searchParams.set("columns", uniqueColumns.join(","));
            }
        }
        return new $281a441cdcb2cf36$var$PostgrestFilterBuilder({
            method: method,
            url: url2,
            headers: headers,
            schema: this.schema,
            body: values,
            fetch: (_this$fetch = this.fetch) !== null && _this$fetch !== void 0 ? _this$fetch : fetch,
            urlLengthLimit: this.urlLengthLimit,
            retry: this.retry
        });
    }
    /**
  * Perform an UPSERT on the table or view. Depending on the column(s) passed
  * to `onConflict`, `.upsert()` allows you to perform the equivalent of
  * `.insert()` if a row with the corresponding `onConflict` columns doesn't
  * exist, or if it does exist, perform an alternative action depending on
  * `ignoreDuplicates`.
  *
  * By default, upserted rows are not returned. To return it, chain the call
  * with `.select()`.
  *
  * @param values - The values to upsert with. Pass an object to upsert a
  * single row or an array to upsert multiple rows.
  *
  * @param options - Named parameters
  *
  * @param options.onConflict - Comma-separated UNIQUE column(s) to specify how
  * duplicate rows are determined. Two rows are duplicates if all the
  * `onConflict` columns are equal.
  *
  * @param options.ignoreDuplicates - If `true`, duplicate rows are ignored. If
  * `false`, duplicate rows are merged with existing rows.
  *
  * @param options.count - Count algorithm to use to count upserted rows.
  *
  * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
  * hood.
  *
  * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
  * statistics under the hood.
  *
  * `"estimated"`: Uses exact count for low numbers and planned count for high
  * numbers.
  *
  * @param options.defaultToNull - Make missing fields default to `null`.
  * Otherwise, use the default value for the column. This only applies when
  * inserting new rows, not when merging with existing rows under
  * `ignoreDuplicates: false`. This also only applies when doing bulk upserts.
  *
  * @example Upsert a single row using a unique key
  * ```ts
  * // Upserting a single row, overwriting based on the 'username' unique column
  * const { data, error } = await supabase
  *   .from('users')
  *   .upsert({ username: 'supabot' }, { onConflict: 'username' })
  *
  * // Example response:
  * // {
  * //   data: [
  * //     { id: 4, message: 'bar', username: 'supabot' }
  * //   ],
  * //   error: null
  * // }
  * ```
  *
  * @example Upsert with conflict resolution and exact row counting
  * ```ts
  * // Upserting and returning exact count
  * const { data, error, count } = await supabase
  *   .from('users')
  *   .upsert(
  *     {
  *       id: 3,
  *       message: 'foo',
  *       username: 'supabot'
  *     },
  *     {
  *       onConflict: 'username',
  *       count: 'exact'
  *     }
  *   )
  *
  * // Example response:
  * // {
  * //   data: [
  * //     {
  * //       id: 42,
  * //       handle: "saoirse",
  * //       display_name: "Saoirse"
  * //     }
  * //   ],
  * //   count: 1,
  * //   error: null
  * // }
  * ```
  *
  * @category Database
  *
  * @remarks
  * - Primary keys must be included in `values` to use upsert.
  *
  * @example Upsert your data
  * ```ts
  * const { data, error } = await supabase
  *   .from('instruments')
  *   .upsert({ id: 1, name: 'piano' })
  *   .select()
  * ```
  *
  * @exampleSql Upsert your data
  * ```sql
  * create table
  *   instruments (id int8 primary key, name text);
  *
  * insert into
  *   instruments (id, name)
  * values
  *   (1, 'harpsichord');
  * ```
  *
  * @exampleResponse Upsert your data
  * ```json
  * {
  *   "data": [
  *     {
  *       "id": 1,
  *       "name": "piano"
  *     }
  *   ],
  *   "status": 201,
  *   "statusText": "Created"
  * }
  * ```
  *
  * @example Bulk Upsert your data
  * ```ts
  * const { data, error } = await supabase
  *   .from('instruments')
  *   .upsert([
  *     { id: 1, name: 'piano' },
  *     { id: 2, name: 'harp' },
  *   ])
  *   .select()
  * ```
  *
  * @exampleSql Bulk Upsert your data
  * ```sql
  * create table
  *   instruments (id int8 primary key, name text);
  *
  * insert into
  *   instruments (id, name)
  * values
  *   (1, 'harpsichord');
  * ```
  *
  * @exampleResponse Bulk Upsert your data
  * ```json
  * {
  *   "data": [
  *     {
  *       "id": 1,
  *       "name": "piano"
  *     },
  *     {
  *       "id": 2,
  *       "name": "harp"
  *     }
  *   ],
  *   "status": 201,
  *   "statusText": "Created"
  * }
  * ```
  *
  * @exampleDescription Upserting into tables with constraints
  * In the following query, `upsert()` implicitly uses the `id`
  * (primary key) column to determine conflicts. If there is no existing
  * row with the same `id`, `upsert()` inserts a new row, which
  * will fail in this case as there is already a row with `handle` `"saoirse"`.
  * Using the `onConflict` option, you can instruct `upsert()` to use
  * another column with a unique constraint to determine conflicts.
  *
  * @example Upserting into tables with constraints
  * ```ts
  * const { data, error } = await supabase
  *   .from('users')
  *   .upsert({ id: 42, handle: 'saoirse', display_name: 'Saoirse' })
  *   .select()
  * ```
  *
  * @exampleSql Upserting into tables with constraints
  * ```sql
  * create table
  *   users (
  *     id int8 generated by default as identity primary key,
  *     handle text not null unique,
  *     display_name text
  *   );
  *
  * insert into
  *   users (id, handle, display_name)
  * values
  *   (1, 'saoirse', null);
  * ```
  *
  * @exampleResponse Upserting into tables with constraints
  * ```json
  * {
  *   "error": {
  *     "code": "23505",
  *     "details": "Key (handle)=(saoirse) already exists.",
  *     "hint": null,
  *     "message": "duplicate key value violates unique constraint \"users_handle_key\""
  *   },
  *   "status": 409,
  *   "statusText": "Conflict"
  * }
  * ```
  */ upsert(values, { onConflict: onConflict, ignoreDuplicates: ignoreDuplicates = false, count: count2, defaultToNull: defaultToNull = true } = {}) {
        var _this$fetch2;
        const method = "POST";
        const { url: url2, headers: headers } = this.cloneRequestState();
        headers.append("Prefer", `resolution=${ignoreDuplicates ? "ignore" : "merge"}-duplicates`);
        if (onConflict !== void 0) url2.searchParams.set("on_conflict", onConflict);
        if (count2) headers.append("Prefer", `count=${count2}`);
        if (!defaultToNull) headers.append("Prefer", "missing=default");
        if (Array.isArray(values)) {
            const columns = values.reduce((acc, x3)=>acc.concat(Object.keys(x3)), []);
            if (columns.length > 0) {
                const uniqueColumns = [
                    ...new Set(columns)
                ].map((column)=>`"${column}"`);
                url2.searchParams.set("columns", uniqueColumns.join(","));
            }
        }
        return new $281a441cdcb2cf36$var$PostgrestFilterBuilder({
            method: method,
            url: url2,
            headers: headers,
            schema: this.schema,
            body: values,
            fetch: (_this$fetch2 = this.fetch) !== null && _this$fetch2 !== void 0 ? _this$fetch2 : fetch,
            urlLengthLimit: this.urlLengthLimit,
            retry: this.retry
        });
    }
    /**
  * Perform an UPDATE on the table or view.
  *
  * By default, updated rows are not returned. To return it, chain the call
  * with `.select()` after filters.
  *
  * @param values - The values to update with
  *
  * @param options - Named parameters
  *
  * @param options.count - Count algorithm to use to count updated rows.
  *
  * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
  * hood.
  *
  * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
  * statistics under the hood.
  *
  * `"estimated"`: Uses exact count for low numbers and planned count for high
  * numbers.
  *
  * @category Database
  *
  * @remarks
  * - `update()` should always be combined with [Filters](/docs/reference/javascript/using-filters) to target the item(s) you wish to update.
  *
  * @example Updating your data
  * ```ts
  * const { error } = await supabase
  *   .from('instruments')
  *   .update({ name: 'piano' })
  *   .eq('id', 1)
  * ```
  *
  * @exampleSql Updating your data
  * ```sql
  * create table
  *   instruments (id int8 primary key, name text);
  *
  * insert into
  *   instruments (id, name)
  * values
  *   (1, 'harpsichord');
  * ```
  *
  * @exampleResponse Updating your data
  * ```json
  * {
  *   "status": 204,
  *   "statusText": "No Content"
  * }
  * ```
  *
  * @example Update a record and return it
  * ```ts
  * const { data, error } = await supabase
  *   .from('instruments')
  *   .update({ name: 'piano' })
  *   .eq('id', 1)
  *   .select()
  * ```
  *
  * @exampleSql Update a record and return it
  * ```sql
  * create table
  *   instruments (id int8 primary key, name text);
  *
  * insert into
  *   instruments (id, name)
  * values
  *   (1, 'harpsichord');
  * ```
  *
  * @exampleResponse Update a record and return it
  * ```json
  * {
  *   "data": [
  *     {
  *       "id": 1,
  *       "name": "piano"
  *     }
  *   ],
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  *
  * @exampleDescription Updating JSON data
  * Postgres offers some
  * [operators](/docs/guides/database/json#query-the-jsonb-data) for
  * working with JSON data. Currently, it is only possible to update the entire JSON document.
  *
  * @example Updating JSON data
  * ```ts
  * const { data, error } = await supabase
  *   .from('users')
  *   .update({
  *     address: {
  *       street: 'Melrose Place',
  *       postcode: 90210
  *     }
  *   })
  *   .eq('address->postcode', 90210)
  *   .select()
  * ```
  *
  * @exampleSql Updating JSON data
  * ```sql
  * create table
  *   users (
  *     id int8 primary key,
  *     name text,
  *     address jsonb
  *   );
  *
  * insert into
  *   users (id, name, address)
  * values
  *   (1, 'Michael', '{ "postcode": 90210 }');
  * ```
  *
  * @exampleResponse Updating JSON data
  * ```json
  * {
  *   "data": [
  *     {
  *       "id": 1,
  *       "name": "Michael",
  *       "address": {
  *         "street": "Melrose Place",
  *         "postcode": 90210
  *       }
  *     }
  *   ],
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  */ update(values, { count: count2 } = {}) {
        var _this$fetch3;
        const method = "PATCH";
        const { url: url2, headers: headers } = this.cloneRequestState();
        if (count2) headers.append("Prefer", `count=${count2}`);
        return new $281a441cdcb2cf36$var$PostgrestFilterBuilder({
            method: method,
            url: url2,
            headers: headers,
            schema: this.schema,
            body: values,
            fetch: (_this$fetch3 = this.fetch) !== null && _this$fetch3 !== void 0 ? _this$fetch3 : fetch,
            urlLengthLimit: this.urlLengthLimit,
            retry: this.retry
        });
    }
    /**
  * Perform a DELETE on the table or view.
  *
  * By default, deleted rows are not returned. To return it, chain the call
  * with `.select()` after filters.
  *
  * @param options - Named parameters
  *
  * @param options.count - Count algorithm to use to count deleted rows.
  *
  * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
  * hood.
  *
  * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
  * statistics under the hood.
  *
  * `"estimated"`: Uses exact count for low numbers and planned count for high
  * numbers.
  *
  * @category Database
  *
  * @remarks
  * - `delete()` should always be combined with [filters](/docs/reference/javascript/using-filters) to target the item(s) you wish to delete.
  * - If you use `delete()` with filters and you have
  *   [RLS](/docs/learn/auth-deep-dive/auth-row-level-security) enabled, only
  *   rows visible through `SELECT` policies are deleted. Note that by default
  *   no rows are visible, so you need at least one `SELECT`/`ALL` policy that
  *   makes the rows visible.
  * - When using `delete().in()`, specify an array of values to target multiple rows with a single query. This is particularly useful for batch deleting entries that share common criteria, such as deleting users by their IDs. Ensure that the array you provide accurately represents all records you intend to delete to avoid unintended data removal.
  *
  * @example Delete a single record
  * ```ts
  * const response = await supabase
  *   .from('countries')
  *   .delete()
  *   .eq('id', 1)
  * ```
  *
  * @exampleSql Delete a single record
  * ```sql
  * create table
  *   countries (id int8 primary key, name text);
  *
  * insert into
  *   countries (id, name)
  * values
  *   (1, 'Mordor');
  * ```
  *
  * @exampleResponse Delete a single record
  * ```json
  * {
  *   "status": 204,
  *   "statusText": "No Content"
  * }
  * ```
  *
  * @example Delete a record and return it
  * ```ts
  * const { data, error } = await supabase
  *   .from('countries')
  *   .delete()
  *   .eq('id', 1)
  *   .select()
  * ```
  *
  * @exampleSql Delete a record and return it
  * ```sql
  * create table
  *   countries (id int8 primary key, name text);
  *
  * insert into
  *   countries (id, name)
  * values
  *   (1, 'Mordor');
  * ```
  *
  * @exampleResponse Delete a record and return it
  * ```json
  * {
  *   "data": [
  *     {
  *       "id": 1,
  *       "name": "Mordor"
  *     }
  *   ],
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  *
  * @example Delete multiple records
  * ```ts
  * const response = await supabase
  *   .from('countries')
  *   .delete()
  *   .in('id', [1, 2, 3])
  * ```
  *
  * @exampleSql Delete multiple records
  * ```sql
  * create table
  *   countries (id int8 primary key, name text);
  *
  * insert into
  *   countries (id, name)
  * values
  *   (1, 'Rohan'), (2, 'The Shire'), (3, 'Mordor');
  * ```
  *
  * @exampleResponse Delete multiple records
  * ```json
  * {
  *   "status": 204,
  *   "statusText": "No Content"
  * }
  * ```
  */ delete({ count: count2 } = {}) {
        var _this$fetch4;
        const method = "DELETE";
        const { url: url2, headers: headers } = this.cloneRequestState();
        if (count2) headers.append("Prefer", `count=${count2}`);
        return new $281a441cdcb2cf36$var$PostgrestFilterBuilder({
            method: method,
            url: url2,
            headers: headers,
            schema: this.schema,
            fetch: (_this$fetch4 = this.fetch) !== null && _this$fetch4 !== void 0 ? _this$fetch4 : fetch,
            urlLengthLimit: this.urlLengthLimit,
            retry: this.retry
        });
    }
};
function $281a441cdcb2cf36$var$_typeof(o3) {
    "@babel/helpers - typeof";
    return $281a441cdcb2cf36$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o$1) {
        return typeof o$1;
    } : function(o$1) {
        return o$1 && "function" == typeof Symbol && o$1.constructor === Symbol && o$1 !== Symbol.prototype ? "symbol" : typeof o$1;
    }, $281a441cdcb2cf36$var$_typeof(o3);
}
function $281a441cdcb2cf36$var$toPrimitive(t4, r3) {
    if ("object" != $281a441cdcb2cf36$var$_typeof(t4) || !t4) return t4;
    var e4 = t4[Symbol.toPrimitive];
    if (void 0 !== e4) {
        var i3 = e4.call(t4, r3 || "default");
        if ("object" != $281a441cdcb2cf36$var$_typeof(i3)) return i3;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r3 ? String : Number)(t4);
}
function $281a441cdcb2cf36$var$toPropertyKey(t4) {
    var i3 = $281a441cdcb2cf36$var$toPrimitive(t4, "string");
    return "symbol" == $281a441cdcb2cf36$var$_typeof(i3) ? i3 : i3 + "";
}
function $281a441cdcb2cf36$var$_defineProperty(e4, r3, t4) {
    return (r3 = $281a441cdcb2cf36$var$toPropertyKey(r3)) in e4 ? Object.defineProperty(e4, r3, {
        value: t4,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e4[r3] = t4, e4;
}
function $281a441cdcb2cf36$var$ownKeys(e4, r3) {
    var t4 = Object.keys(e4);
    if (Object.getOwnPropertySymbols) {
        var o3 = Object.getOwnPropertySymbols(e4);
        r3 && (o3 = o3.filter(function(r$1) {
            return Object.getOwnPropertyDescriptor(e4, r$1).enumerable;
        })), t4.push.apply(t4, o3);
    }
    return t4;
}
function $281a441cdcb2cf36$var$_objectSpread2(e4) {
    for(var r3 = 1; r3 < arguments.length; r3++){
        var t4 = null != arguments[r3] ? arguments[r3] : {};
        r3 % 2 ? $281a441cdcb2cf36$var$ownKeys(Object(t4), true).forEach(function(r$1) {
            $281a441cdcb2cf36$var$_defineProperty(e4, r$1, t4[r$1]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : $281a441cdcb2cf36$var$ownKeys(Object(t4)).forEach(function(r$1) {
            Object.defineProperty(e4, r$1, Object.getOwnPropertyDescriptor(t4, r$1));
        });
    }
    return e4;
}
var $281a441cdcb2cf36$var$PostgrestClient = class PostgrestClient2 {
    /**
  * Creates a PostgREST client.
  *
  * @param url - URL of the PostgREST endpoint
  * @param options - Named parameters
  * @param options.headers - Custom headers
  * @param options.schema - Postgres schema to switch to
  * @param options.fetch - Custom fetch
  * @param options.timeout - Optional timeout in milliseconds for all requests. When set, requests will automatically abort after this duration to prevent indefinite hangs.
  * @param options.urlLengthLimit - Maximum URL length in characters before warnings/errors are triggered. Defaults to 8000.
  * @param options.retry - Enable or disable automatic retries for transient errors.
  *   When enabled, idempotent requests (GET, HEAD, OPTIONS) that fail with network
  *   errors or HTTP 503/520 responses will be automatically retried up to 3 times
  *   with exponential backoff (1s, 2s, 4s). Defaults to `true`.
  * @example Using supabase-js (recommended)
  * ```ts
  * import { createClient } from '@supabase/supabase-js'
  *
  * const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
  * const { data, error } = await supabase.from('profiles').select('*')
  * ```
  *
  * @category Database
  *
  * @remarks
  * - A `timeout` option (in milliseconds) can be set to automatically abort requests that take too long.
  * - A `urlLengthLimit` option (default: 8000) can be set to control when URL length warnings are included in error messages for aborted requests.
  *
  * @example Standalone import for bundle-sensitive environments
  * ```ts
  * import { PostgrestClient } from '@supabase/postgrest-js'
  *
  * const postgrest = new PostgrestClient('https://xyzcompany.supabase.co/rest/v1', {
  *   headers: { apikey: 'your-publishable-key' },
  *   schema: 'public',
  *   timeout: 30000, // 30 second timeout
  * })
  * ```
  */ constructor(url2, { headers: headers = {}, schema: schema, fetch: fetch$1, timeout: timeout, urlLengthLimit: urlLengthLimit = 8e3, retry: retry } = {}){
        this.url = url2;
        this.headers = new Headers(headers);
        this.schemaName = schema;
        this.urlLengthLimit = urlLengthLimit;
        const originalFetch = fetch$1 !== null && fetch$1 !== void 0 ? fetch$1 : globalThis.fetch;
        if (timeout !== void 0 && timeout > 0) this.fetch = (input, init)=>{
            const controller = new AbortController();
            const timeoutId = setTimeout(()=>controller.abort(), timeout);
            const existingSignal = init === null || init === void 0 ? void 0 : init.signal;
            if (existingSignal) {
                if (existingSignal.aborted) {
                    clearTimeout(timeoutId);
                    return originalFetch(input, init);
                }
                const abortHandler = ()=>{
                    clearTimeout(timeoutId);
                    controller.abort();
                };
                existingSignal.addEventListener("abort", abortHandler, {
                    once: true
                });
                return originalFetch(input, $281a441cdcb2cf36$var$_objectSpread2($281a441cdcb2cf36$var$_objectSpread2({}, init), {}, {
                    signal: controller.signal
                })).finally(()=>{
                    clearTimeout(timeoutId);
                    existingSignal.removeEventListener("abort", abortHandler);
                });
            }
            return originalFetch(input, $281a441cdcb2cf36$var$_objectSpread2($281a441cdcb2cf36$var$_objectSpread2({}, init), {}, {
                signal: controller.signal
            })).finally(()=>clearTimeout(timeoutId));
        };
        else this.fetch = originalFetch;
        this.retry = retry;
    }
    /**
  * Perform a query on a table or a view.
  *
  * @param relation - The table or view name to query
  *
  * @category Database
  */ from(relation) {
        if (!relation || typeof relation !== "string" || relation.trim() === "") throw new Error("Invalid relation name: relation must be a non-empty string.");
        return new $281a441cdcb2cf36$var$PostgrestQueryBuilder(new URL(`${this.url}/${relation}`), {
            headers: new Headers(this.headers),
            schema: this.schemaName,
            fetch: this.fetch,
            urlLengthLimit: this.urlLengthLimit,
            retry: this.retry
        });
    }
    /**
  * Select a schema to query or perform an function (rpc) call.
  *
  * The schema needs to be on the list of exposed schemas inside Supabase.
  *
  * @param schema - The schema to query
  *
  * @category Database
  */ schema(schema) {
        return new PostgrestClient2(this.url, {
            headers: this.headers,
            schema: schema,
            fetch: this.fetch,
            urlLengthLimit: this.urlLengthLimit,
            retry: this.retry
        });
    }
    /**
  * Perform a function call.
  *
  * @param fn - The function name to call
  * @param args - The arguments to pass to the function call
  * @param options - Named parameters
  * @param options.head - When set to `true`, `data` will not be returned.
  * Useful if you only need the count.
  * @param options.get - When set to `true`, the function will be called with
  * read-only access mode.
  * @param options.count - Count algorithm to use to count rows returned by the
  * function. Only applicable for [set-returning
  * functions](https://www.postgresql.org/docs/current/functions-srf.html).
  *
  * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
  * hood.
  *
  * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
  * statistics under the hood.
  *
  * `"estimated"`: Uses exact count for low numbers and planned count for high
  * numbers.
  *
  * @example
  * ```ts
  * // For cross-schema functions where type inference fails, use overrideTypes:
  * const { data } = await supabase
  *   .schema('schema_b')
  *   .rpc('function_a', {})
  *   .overrideTypes<{ id: string; user_id: string }[]>()
  * ```
  *
  * @category Database
  *
  * @example Call a Postgres function without arguments
  * ```ts
  * const { data, error } = await supabase.rpc('hello_world')
  * ```
  *
  * @exampleSql Call a Postgres function without arguments
  * ```sql
  * create function hello_world() returns text as $$
  *   select 'Hello world';
  * $$ language sql;
  * ```
  *
  * @exampleResponse Call a Postgres function without arguments
  * ```json
  * {
  *   "data": "Hello world",
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  *
  * @example Call a Postgres function with arguments
  * ```ts
  * const { data, error } = await supabase.rpc('echo', { say: '👋' })
  * ```
  *
  * @exampleSql Call a Postgres function with arguments
  * ```sql
  * create function echo(say text) returns text as $$
  *   select say;
  * $$ language sql;
  * ```
  *
  * @exampleResponse Call a Postgres function with arguments
  * ```json
  *   {
  *     "data": "👋",
  *     "status": 200,
  *     "statusText": "OK"
  *   }
  *
  * ```
  *
  * @exampleDescription Bulk processing
  * You can process large payloads by passing in an array as an argument.
  *
  * @example Bulk processing
  * ```ts
  * const { data, error } = await supabase.rpc('add_one_each', { arr: [1, 2, 3] })
  * ```
  *
  * @exampleSql Bulk processing
  * ```sql
  * create function add_one_each(arr int[]) returns int[] as $$
  *   select array_agg(n + 1) from unnest(arr) as n;
  * $$ language sql;
  * ```
  *
  * @exampleResponse Bulk processing
  * ```json
  * {
  *   "data": [
  *     2,
  *     3,
  *     4
  *   ],
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  *
  * @exampleDescription Call a Postgres function with filters
  * Postgres functions that return tables can also be combined with [Filters](/docs/reference/javascript/using-filters) and [Modifiers](/docs/reference/javascript/using-modifiers).
  *
  * @example Call a Postgres function with filters
  * ```ts
  * const { data, error } = await supabase
  *   .rpc('list_stored_countries')
  *   .eq('id', 1)
  *   .single()
  * ```
  *
  * @exampleSql Call a Postgres function with filters
  * ```sql
  * create table
  *   countries (id int8 primary key, name text);
  *
  * insert into
  *   countries (id, name)
  * values
  *   (1, 'Rohan'),
  *   (2, 'The Shire');
  *
  * create function list_stored_countries() returns setof countries as $$
  *   select * from countries;
  * $$ language sql;
  * ```
  *
  * @exampleResponse Call a Postgres function with filters
  * ```json
  * {
  *   "data": {
  *     "id": 1,
  *     "name": "Rohan"
  *   },
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  *
  * @example Call a read-only Postgres function
  * ```ts
  * const { data, error } = await supabase.rpc('hello_world', undefined, { get: true })
  * ```
  *
  * @exampleSql Call a read-only Postgres function
  * ```sql
  * create function hello_world() returns text as $$
  *   select 'Hello world';
  * $$ language sql;
  * ```
  *
  * @exampleResponse Call a read-only Postgres function
  * ```json
  * {
  *   "data": "Hello world",
  *   "status": 200,
  *   "statusText": "OK"
  * }
  * ```
  */ rpc(fn, args2 = {}, { head: head2 = false, get: get3 = false, count: count2 } = {}) {
        var _this$fetch;
        let method;
        const url2 = new URL(`${this.url}/rpc/${fn}`);
        let body;
        const _isObject = (v3)=>v3 !== null && typeof v3 === "object" && (!Array.isArray(v3) || v3.some(_isObject));
        const _hasObjectArg = head2 && Object.values(args2).some(_isObject);
        if (_hasObjectArg) {
            method = "POST";
            body = args2;
        } else if (head2 || get3) {
            method = head2 ? "HEAD" : "GET";
            Object.entries(args2).filter(([_3, value2])=>value2 !== void 0).map(([name, value2])=>[
                    name,
                    Array.isArray(value2) ? `{${value2.join(",")}}` : `${value2}`
                ]).forEach(([name, value2])=>{
                url2.searchParams.append(name, value2);
            });
        } else {
            method = "POST";
            body = args2;
        }
        const headers = new Headers(this.headers);
        if (_hasObjectArg) headers.set("Prefer", count2 ? `count=${count2},return=minimal` : "return=minimal");
        else if (count2) headers.set("Prefer", `count=${count2}`);
        return new $281a441cdcb2cf36$var$PostgrestFilterBuilder({
            method: method,
            url: url2,
            headers: headers,
            schema: this.schemaName,
            body: body,
            fetch: (_this$fetch = this.fetch) !== null && _this$fetch !== void 0 ? _this$fetch : fetch,
            urlLengthLimit: this.urlLengthLimit,
            retry: this.retry
        });
    }
};
// ../node_modules/@supabase/realtime-js/dist/module/lib/websocket-factory.js
var $281a441cdcb2cf36$var$WebSocketFactory = class {
    /**
   * Static-only utility – prevent instantiation.
   */ constructor(){}
    static detectEnvironment() {
        var _a2;
        if (typeof WebSocket !== "undefined") return {
            type: "native",
            constructor: WebSocket
        };
        if (typeof globalThis !== "undefined" && typeof globalThis.WebSocket !== "undefined") return {
            type: "native",
            constructor: globalThis.WebSocket
        };
        if (typeof $parcel$global !== "undefined" && typeof $parcel$global.WebSocket !== "undefined") return {
            type: "native",
            constructor: $parcel$global.WebSocket
        };
        if (typeof globalThis !== "undefined" && typeof globalThis.WebSocketPair !== "undefined" && typeof globalThis.WebSocket === "undefined") return {
            type: "cloudflare",
            error: "Cloudflare Workers detected. WebSocket clients are not supported in Cloudflare Workers.",
            workaround: "Use Cloudflare Workers WebSocket API for server-side WebSocket handling, or deploy to a different runtime."
        };
        if (typeof globalThis !== "undefined" && globalThis.EdgeRuntime || typeof navigator !== "undefined" && ((_a2 = navigator.userAgent) === null || _a2 === void 0 ? void 0 : _a2.includes("Vercel-Edge"))) return {
            type: "unsupported",
            error: "Edge runtime detected (Vercel Edge/Netlify Edge). WebSockets are not supported in edge functions.",
            workaround: "Use serverless functions or a different deployment target for WebSocket functionality."
        };
        const _process = globalThis["process"];
        if (_process) {
            const processVersions = _process["versions"];
            if (processVersions && processVersions["node"]) {
                const versionString = processVersions["node"];
                const nodeVersion = parseInt(versionString.replace(/^v/, "").split(".")[0]);
                if (nodeVersion >= 22) {
                    if (typeof globalThis.WebSocket !== "undefined") return {
                        type: "native",
                        constructor: globalThis.WebSocket
                    };
                    return {
                        type: "unsupported",
                        error: `Node.js ${nodeVersion} detected but native WebSocket not found.`,
                        workaround: "Provide a WebSocket implementation via the transport option."
                    };
                }
                return {
                    type: "unsupported",
                    error: `Node.js ${nodeVersion} detected without native WebSocket support.`,
                    workaround: 'For Node.js < 22, install "ws" package and provide it via the transport option:\nimport ws from "ws"\nnew RealtimeClient(url, { transport: ws })'
                };
            }
        }
        return {
            type: "unsupported",
            error: "Unknown JavaScript runtime without WebSocket support.",
            workaround: "Ensure you're running in a supported environment (browser, Node.js, Deno) or provide a custom WebSocket implementation."
        };
    }
    /**
   * Returns the best available WebSocket constructor for the current runtime.
   *
   * @category Realtime
   *
   * @example Example with error handling
   * ```ts
   * try {
   *   const WS = WebSocketFactory.getWebSocketConstructor()
   *   const socket = new WS('wss://example.com/socket')
   * } catch (error) {
   *   console.error('WebSocket not available in this environment.', error)
   * }
   * ```
   */ static getWebSocketConstructor() {
        const env = this.detectEnvironment();
        if (env.constructor) return env.constructor;
        let errorMessage = env.error || "WebSocket not supported in this environment.";
        if (env.workaround) errorMessage += `

Suggested solution: ${env.workaround}`;
        throw new Error(errorMessage);
    }
    /**
   * Detects whether the runtime can establish WebSocket connections.
   *
   * @category Realtime
   *
   * @example Example in a Node.js script
   * ```ts
   * if (!WebSocketFactory.isWebSocketSupported()) {
   *   console.error('WebSockets are required for this script.')
   *   process.exitCode = 1
   * }
   * ```
   */ static isWebSocketSupported() {
        try {
            const env = this.detectEnvironment();
            return env.type === "native" || env.type === "ws";
        } catch (_a2) {
            return false;
        }
    }
};
var $281a441cdcb2cf36$var$websocket_factory_default = $281a441cdcb2cf36$var$WebSocketFactory;
// ../node_modules/@supabase/realtime-js/dist/module/lib/version.js
var $281a441cdcb2cf36$var$version2 = "2.105.1";
// ../node_modules/@supabase/realtime-js/dist/module/lib/constants.js
var $281a441cdcb2cf36$var$DEFAULT_VERSION = `realtime-js/${$281a441cdcb2cf36$var$version2}`;
var $281a441cdcb2cf36$var$VSN_1_0_0 = "1.0.0";
var $281a441cdcb2cf36$var$VSN_2_0_0 = "2.0.0";
var $281a441cdcb2cf36$var$DEFAULT_VSN = $281a441cdcb2cf36$var$VSN_2_0_0;
var $281a441cdcb2cf36$var$DEFAULT_TIMEOUT = 1e4;
var $281a441cdcb2cf36$var$MAX_PUSH_BUFFER_SIZE = 100;
var $281a441cdcb2cf36$var$CHANNEL_STATES = {
    closed: "closed",
    errored: "errored",
    joined: "joined",
    joining: "joining",
    leaving: "leaving"
};
var $281a441cdcb2cf36$var$CHANNEL_EVENTS = {
    close: "phx_close",
    error: "phx_error",
    join: "phx_join",
    reply: "phx_reply",
    leave: "phx_leave",
    access_token: "access_token"
};
var $281a441cdcb2cf36$var$CONNECTION_STATE = {
    connecting: "connecting",
    open: "open",
    closing: "closing",
    closed: "closed"
};
// ../node_modules/@supabase/realtime-js/dist/module/lib/serializer.js
var $281a441cdcb2cf36$var$Serializer = class {
    constructor(allowedMetadataKeys){
        this.HEADER_LENGTH = 1;
        this.USER_BROADCAST_PUSH_META_LENGTH = 6;
        this.KINDS = {
            userBroadcastPush: 3,
            userBroadcast: 4
        };
        this.BINARY_ENCODING = 0;
        this.JSON_ENCODING = 1;
        this.BROADCAST_EVENT = "broadcast";
        this.allowedMetadataKeys = [];
        this.allowedMetadataKeys = allowedMetadataKeys !== null && allowedMetadataKeys !== void 0 ? allowedMetadataKeys : [];
    }
    encode(msg, callback) {
        if (msg.event === this.BROADCAST_EVENT && !(msg.payload instanceof ArrayBuffer) && typeof msg.payload.event === "string") return callback(this._binaryEncodeUserBroadcastPush(msg));
        let payload = [
            msg.join_ref,
            msg.ref,
            msg.topic,
            msg.event,
            msg.payload
        ];
        return callback(JSON.stringify(payload));
    }
    _binaryEncodeUserBroadcastPush(message) {
        var _a2;
        if (this._isArrayBuffer((_a2 = message.payload) === null || _a2 === void 0 ? void 0 : _a2.payload)) return this._encodeBinaryUserBroadcastPush(message);
        else return this._encodeJsonUserBroadcastPush(message);
    }
    _encodeBinaryUserBroadcastPush(message) {
        var _a2, _b;
        const userPayload = (_b = (_a2 = message.payload) === null || _a2 === void 0 ? void 0 : _a2.payload) !== null && _b !== void 0 ? _b : new ArrayBuffer(0);
        return this._encodeUserBroadcastPush(message, this.BINARY_ENCODING, userPayload);
    }
    _encodeJsonUserBroadcastPush(message) {
        var _a2, _b;
        const userPayload = (_b = (_a2 = message.payload) === null || _a2 === void 0 ? void 0 : _a2.payload) !== null && _b !== void 0 ? _b : {};
        const encoder = new TextEncoder();
        const encodedUserPayload = encoder.encode(JSON.stringify(userPayload)).buffer;
        return this._encodeUserBroadcastPush(message, this.JSON_ENCODING, encodedUserPayload);
    }
    _encodeUserBroadcastPush(message, encodingType, encodedPayload) {
        var _a2, _b;
        const topic = message.topic;
        const ref2 = (_a2 = message.ref) !== null && _a2 !== void 0 ? _a2 : "";
        const joinRef = (_b = message.join_ref) !== null && _b !== void 0 ? _b : "";
        const userEvent = message.payload.event;
        const rest = this.allowedMetadataKeys ? this._pick(message.payload, this.allowedMetadataKeys) : {};
        const metadata = Object.keys(rest).length === 0 ? "" : JSON.stringify(rest);
        if (joinRef.length > 255) throw new Error(`joinRef length ${joinRef.length} exceeds maximum of 255`);
        if (ref2.length > 255) throw new Error(`ref length ${ref2.length} exceeds maximum of 255`);
        if (topic.length > 255) throw new Error(`topic length ${topic.length} exceeds maximum of 255`);
        if (userEvent.length > 255) throw new Error(`userEvent length ${userEvent.length} exceeds maximum of 255`);
        if (metadata.length > 255) throw new Error(`metadata length ${metadata.length} exceeds maximum of 255`);
        const metaLength = this.USER_BROADCAST_PUSH_META_LENGTH + joinRef.length + ref2.length + topic.length + userEvent.length + metadata.length;
        const header = new ArrayBuffer(this.HEADER_LENGTH + metaLength);
        let view = new DataView(header);
        let offset2 = 0;
        view.setUint8(offset2++, this.KINDS.userBroadcastPush);
        view.setUint8(offset2++, joinRef.length);
        view.setUint8(offset2++, ref2.length);
        view.setUint8(offset2++, topic.length);
        view.setUint8(offset2++, userEvent.length);
        view.setUint8(offset2++, metadata.length);
        view.setUint8(offset2++, encodingType);
        Array.from(joinRef, (char)=>view.setUint8(offset2++, char.charCodeAt(0)));
        Array.from(ref2, (char)=>view.setUint8(offset2++, char.charCodeAt(0)));
        Array.from(topic, (char)=>view.setUint8(offset2++, char.charCodeAt(0)));
        Array.from(userEvent, (char)=>view.setUint8(offset2++, char.charCodeAt(0)));
        Array.from(metadata, (char)=>view.setUint8(offset2++, char.charCodeAt(0)));
        var combined = new Uint8Array(header.byteLength + encodedPayload.byteLength);
        combined.set(new Uint8Array(header), 0);
        combined.set(new Uint8Array(encodedPayload), header.byteLength);
        return combined.buffer;
    }
    decode(rawPayload, callback) {
        if (this._isArrayBuffer(rawPayload)) {
            let result = this._binaryDecode(rawPayload);
            return callback(result);
        }
        if (typeof rawPayload === "string") {
            const jsonPayload = JSON.parse(rawPayload);
            const [join_ref, ref2, topic, event, payload] = jsonPayload;
            return callback({
                join_ref: join_ref,
                ref: ref2,
                topic: topic,
                event: event,
                payload: payload
            });
        }
        return callback({});
    }
    _binaryDecode(buffer) {
        const view = new DataView(buffer);
        const kind = view.getUint8(0);
        const decoder = new TextDecoder();
        switch(kind){
            case this.KINDS.userBroadcast:
                return this._decodeUserBroadcast(buffer, view, decoder);
        }
    }
    _decodeUserBroadcast(buffer, view, decoder) {
        const topicSize = view.getUint8(1);
        const userEventSize = view.getUint8(2);
        const metadataSize = view.getUint8(3);
        const payloadEncoding = view.getUint8(4);
        let offset2 = this.HEADER_LENGTH + 4;
        const topic = decoder.decode(buffer.slice(offset2, offset2 + topicSize));
        offset2 = offset2 + topicSize;
        const userEvent = decoder.decode(buffer.slice(offset2, offset2 + userEventSize));
        offset2 = offset2 + userEventSize;
        const metadata = decoder.decode(buffer.slice(offset2, offset2 + metadataSize));
        offset2 = offset2 + metadataSize;
        const payload = buffer.slice(offset2, buffer.byteLength);
        const parsedPayload = payloadEncoding === this.JSON_ENCODING ? JSON.parse(decoder.decode(payload)) : payload;
        const data2 = {
            type: this.BROADCAST_EVENT,
            event: userEvent,
            payload: parsedPayload
        };
        if (metadataSize > 0) data2["meta"] = JSON.parse(metadata);
        return {
            join_ref: null,
            ref: null,
            topic: topic,
            event: this.BROADCAST_EVENT,
            payload: data2
        };
    }
    _isArrayBuffer(buffer) {
        var _a2;
        return buffer instanceof ArrayBuffer || ((_a2 = buffer === null || buffer === void 0 ? void 0 : buffer.constructor) === null || _a2 === void 0 ? void 0 : _a2.name) === "ArrayBuffer";
    }
    _pick(obj, keys2) {
        if (!obj || typeof obj !== "object") return {};
        return Object.fromEntries(Object.entries(obj).filter(([key])=>keys2.includes(key)));
    }
};
// ../node_modules/@supabase/realtime-js/dist/module/lib/transformers.js
var $281a441cdcb2cf36$var$PostgresTypes;
(function(PostgresTypes2) {
    PostgresTypes2["abstime"] = "abstime";
    PostgresTypes2["bool"] = "bool";
    PostgresTypes2["date"] = "date";
    PostgresTypes2["daterange"] = "daterange";
    PostgresTypes2["float4"] = "float4";
    PostgresTypes2["float8"] = "float8";
    PostgresTypes2["int2"] = "int2";
    PostgresTypes2["int4"] = "int4";
    PostgresTypes2["int4range"] = "int4range";
    PostgresTypes2["int8"] = "int8";
    PostgresTypes2["int8range"] = "int8range";
    PostgresTypes2["json"] = "json";
    PostgresTypes2["jsonb"] = "jsonb";
    PostgresTypes2["money"] = "money";
    PostgresTypes2["numeric"] = "numeric";
    PostgresTypes2["oid"] = "oid";
    PostgresTypes2["reltime"] = "reltime";
    PostgresTypes2["text"] = "text";
    PostgresTypes2["time"] = "time";
    PostgresTypes2["timestamp"] = "timestamp";
    PostgresTypes2["timestamptz"] = "timestamptz";
    PostgresTypes2["timetz"] = "timetz";
    PostgresTypes2["tsrange"] = "tsrange";
    PostgresTypes2["tstzrange"] = "tstzrange";
})($281a441cdcb2cf36$var$PostgresTypes || ($281a441cdcb2cf36$var$PostgresTypes = {}));
var $281a441cdcb2cf36$var$convertChangeData = (columns, record, options = {})=>{
    var _a2;
    const skipTypes = (_a2 = options.skipTypes) !== null && _a2 !== void 0 ? _a2 : [];
    if (!record) return {};
    return Object.keys(record).reduce((acc, rec_key)=>{
        acc[rec_key] = $281a441cdcb2cf36$var$convertColumn(rec_key, columns, record, skipTypes);
        return acc;
    }, {});
};
var $281a441cdcb2cf36$var$convertColumn = (columnName, columns, record, skipTypes)=>{
    const column = columns.find((x3)=>x3.name === columnName);
    const colType = column === null || column === void 0 ? void 0 : column.type;
    const value2 = record[columnName];
    if (colType && !skipTypes.includes(colType)) return $281a441cdcb2cf36$var$convertCell(colType, value2);
    return $281a441cdcb2cf36$var$noop3(value2);
};
var $281a441cdcb2cf36$var$convertCell = (type, value2)=>{
    if (type.charAt(0) === "_") {
        const dataType = type.slice(1, type.length);
        return $281a441cdcb2cf36$var$toArray2(value2, dataType);
    }
    switch(type){
        case $281a441cdcb2cf36$var$PostgresTypes.bool:
            return $281a441cdcb2cf36$var$toBoolean(value2);
        case $281a441cdcb2cf36$var$PostgresTypes.float4:
        case $281a441cdcb2cf36$var$PostgresTypes.float8:
        case $281a441cdcb2cf36$var$PostgresTypes.int2:
        case $281a441cdcb2cf36$var$PostgresTypes.int4:
        case $281a441cdcb2cf36$var$PostgresTypes.int8:
        case $281a441cdcb2cf36$var$PostgresTypes.numeric:
        case $281a441cdcb2cf36$var$PostgresTypes.oid:
            return $281a441cdcb2cf36$var$toNumber(value2);
        case $281a441cdcb2cf36$var$PostgresTypes.json:
        case $281a441cdcb2cf36$var$PostgresTypes.jsonb:
            return $281a441cdcb2cf36$var$toJson(value2);
        case $281a441cdcb2cf36$var$PostgresTypes.timestamp:
            return $281a441cdcb2cf36$var$toTimestampString(value2);
        // Format to be consistent with PostgREST
        case $281a441cdcb2cf36$var$PostgresTypes.abstime:
        // To allow users to cast it based on Timezone
        case $281a441cdcb2cf36$var$PostgresTypes.date:
        // To allow users to cast it based on Timezone
        case $281a441cdcb2cf36$var$PostgresTypes.daterange:
        case $281a441cdcb2cf36$var$PostgresTypes.int4range:
        case $281a441cdcb2cf36$var$PostgresTypes.int8range:
        case $281a441cdcb2cf36$var$PostgresTypes.money:
        case $281a441cdcb2cf36$var$PostgresTypes.reltime:
        // To allow users to cast it based on Timezone
        case $281a441cdcb2cf36$var$PostgresTypes.text:
        case $281a441cdcb2cf36$var$PostgresTypes.time:
        // To allow users to cast it based on Timezone
        case $281a441cdcb2cf36$var$PostgresTypes.timestamptz:
        // To allow users to cast it based on Timezone
        case $281a441cdcb2cf36$var$PostgresTypes.timetz:
        // To allow users to cast it based on Timezone
        case $281a441cdcb2cf36$var$PostgresTypes.tsrange:
        case $281a441cdcb2cf36$var$PostgresTypes.tstzrange:
            return $281a441cdcb2cf36$var$noop3(value2);
        default:
            return $281a441cdcb2cf36$var$noop3(value2);
    }
};
var $281a441cdcb2cf36$var$noop3 = (value2)=>{
    return value2;
};
var $281a441cdcb2cf36$var$toBoolean = (value2)=>{
    switch(value2){
        case "t":
            return true;
        case "f":
            return false;
        default:
            return value2;
    }
};
var $281a441cdcb2cf36$var$toNumber = (value2)=>{
    if (typeof value2 === "string") {
        const parsedValue = parseFloat(value2);
        if (!Number.isNaN(parsedValue)) return parsedValue;
    }
    return value2;
};
var $281a441cdcb2cf36$var$toJson = (value2)=>{
    if (typeof value2 === "string") try {
        return JSON.parse(value2);
    } catch (_a2) {
        return value2;
    }
    return value2;
};
var $281a441cdcb2cf36$var$toArray2 = (value2, type)=>{
    if (typeof value2 !== "string") return value2;
    const lastIdx = value2.length - 1;
    const closeBrace = value2[lastIdx];
    const openBrace = value2[0];
    if (openBrace === "{" && closeBrace === "}") {
        let arr;
        const valTrim = value2.slice(1, lastIdx);
        try {
            arr = JSON.parse("[" + valTrim + "]");
        } catch (_3) {
            arr = valTrim ? valTrim.split(",") : [];
        }
        return arr.map((val)=>$281a441cdcb2cf36$var$convertCell(type, val));
    }
    return value2;
};
var $281a441cdcb2cf36$var$toTimestampString = (value2)=>{
    if (typeof value2 === "string") return value2.replace(" ", "T");
    return value2;
};
var $281a441cdcb2cf36$var$httpEndpointURL = (socketUrl2)=>{
    const wsUrl = new URL(socketUrl2);
    wsUrl.protocol = wsUrl.protocol.replace(/^ws/i, "http");
    wsUrl.pathname = wsUrl.pathname.replace(/\/+$/, "").replace(/\/socket\/websocket$/i, "").replace(/\/socket$/i, "").replace(/\/websocket$/i, "");
    if (wsUrl.pathname === "" || wsUrl.pathname === "/") wsUrl.pathname = "/api/broadcast";
    else wsUrl.pathname = wsUrl.pathname + "/api/broadcast";
    return wsUrl.href;
};
// ../node_modules/@supabase/phoenix/priv/static/phoenix.mjs
var $281a441cdcb2cf36$var$closure = (value2)=>{
    if (typeof value2 === "function") return /** @type {() => T} */ value2;
    else {
        let closure2 = function() {
            return value2;
        };
        return closure2;
    }
};
var $281a441cdcb2cf36$var$globalSelf = typeof self !== "undefined" ? self : null;
var $281a441cdcb2cf36$var$phxWindow = typeof window !== "undefined" ? window : null;
var $281a441cdcb2cf36$var$global2 = $281a441cdcb2cf36$var$globalSelf || $281a441cdcb2cf36$var$phxWindow || globalThis;
var $281a441cdcb2cf36$var$DEFAULT_VSN2 = "2.0.0";
var $281a441cdcb2cf36$var$DEFAULT_TIMEOUT2 = 1e4;
var $281a441cdcb2cf36$var$WS_CLOSE_NORMAL = 1e3;
var $281a441cdcb2cf36$var$SOCKET_STATES = /** @type {const} */ {
    connecting: 0,
    open: 1,
    closing: 2,
    closed: 3
};
var $281a441cdcb2cf36$var$CHANNEL_STATES2 = /** @type {const} */ {
    closed: "closed",
    errored: "errored",
    joined: "joined",
    joining: "joining",
    leaving: "leaving"
};
var $281a441cdcb2cf36$var$CHANNEL_EVENTS2 = /** @type {const} */ {
    close: "phx_close",
    error: "phx_error",
    join: "phx_join",
    reply: "phx_reply",
    leave: "phx_leave"
};
var $281a441cdcb2cf36$var$TRANSPORTS = /** @type {const} */ {
    longpoll: "longpoll",
    websocket: "websocket"
};
var $281a441cdcb2cf36$var$XHR_STATES = /** @type {const} */ {
    complete: 4
};
var $281a441cdcb2cf36$var$AUTH_TOKEN_PREFIX = "base64url.bearer.phx.";
var $281a441cdcb2cf36$var$Push = class {
    /**
   * Initializes the Push
   * @param {Channel} channel - The Channel
   * @param {ChannelEvent} event - The event, for example `"phx_join"`
   * @param {() => Record<string, unknown>} payload - The payload, for example `{user_id: 123}`
   * @param {number} timeout - The push timeout in milliseconds
   */ constructor(channel, event, payload, timeout){
        this.channel = channel;
        this.event = event;
        this.payload = payload || function() {
            return {};
        };
        this.receivedResp = null;
        this.timeout = timeout;
        this.timeoutTimer = null;
        this.recHooks = [];
        this.sent = false;
        this.ref = void 0;
    }
    /**
   *
   * @param {number} timeout
   */ resend(timeout) {
        this.timeout = timeout;
        this.reset();
        this.send();
    }
    /**
   *
   */ send() {
        if (this.hasReceived("timeout")) return;
        this.startTimeout();
        this.sent = true;
        this.channel.socket.push({
            topic: this.channel.topic,
            event: this.event,
            payload: this.payload(),
            ref: this.ref,
            join_ref: this.channel.joinRef()
        });
    }
    /**
   *
   * @param {string} status
   * @param {(response: any) => void} callback
   */ receive(status, callback) {
        if (this.hasReceived(status)) callback(this.receivedResp.response);
        this.recHooks.push({
            status: status,
            callback: callback
        });
        return this;
    }
    reset() {
        this.cancelRefEvent();
        this.ref = null;
        this.refEvent = null;
        this.receivedResp = null;
        this.sent = false;
    }
    destroy() {
        this.cancelRefEvent();
        this.cancelTimeout();
    }
    /**
   * @private
   */ matchReceive({ status: status, response: response, _ref: _ref }) {
        this.recHooks.filter((h3)=>h3.status === status).forEach((h3)=>h3.callback(response));
    }
    /**
   * @private
   */ cancelRefEvent() {
        if (!this.refEvent) return;
        this.channel.off(this.refEvent);
    }
    cancelTimeout() {
        clearTimeout(this.timeoutTimer);
        this.timeoutTimer = null;
    }
    startTimeout() {
        if (this.timeoutTimer) this.cancelTimeout();
        this.ref = this.channel.socket.makeRef();
        this.refEvent = this.channel.replyEventName(this.ref);
        this.channel.on(this.refEvent, (payload)=>{
            this.cancelRefEvent();
            this.cancelTimeout();
            this.receivedResp = payload;
            this.matchReceive(payload);
        });
        this.timeoutTimer = setTimeout(()=>{
            this.trigger("timeout", {});
        }, this.timeout);
    }
    /**
   * @private
   */ hasReceived(status) {
        return this.receivedResp && this.receivedResp.status === status;
    }
    trigger(status, response) {
        this.channel.trigger(this.refEvent, {
            status: status,
            response: response
        });
    }
};
var $281a441cdcb2cf36$var$Timer = class {
    /**
  * @param {() => void} callback
  * @param {(tries: number) => number} timerCalc
  */ constructor(callback, timerCalc){
        this.callback = callback;
        this.timerCalc = timerCalc;
        this.timer = void 0;
        this.tries = 0;
    }
    reset() {
        this.tries = 0;
        clearTimeout(this.timer);
    }
    /**
   * Cancels any previous scheduleTimeout and schedules callback
   */ scheduleTimeout() {
        clearTimeout(this.timer);
        this.timer = setTimeout(()=>{
            this.tries = this.tries + 1;
            this.callback();
        }, this.timerCalc(this.tries + 1));
    }
};
var $281a441cdcb2cf36$var$Channel = class {
    /**
   * @param {string} topic
   * @param {Params | (() => Params)} params
   * @param {Socket} socket
   */ constructor(topic, params2, socket){
        this.state = $281a441cdcb2cf36$var$CHANNEL_STATES2.closed;
        this.topic = topic;
        this.params = $281a441cdcb2cf36$var$closure(params2 || {});
        this.socket = socket;
        this.bindings = [];
        this.bindingRef = 0;
        this.timeout = this.socket.timeout;
        this.joinedOnce = false;
        this.joinPush = new $281a441cdcb2cf36$var$Push(this, $281a441cdcb2cf36$var$CHANNEL_EVENTS2.join, this.params, this.timeout);
        this.pushBuffer = [];
        this.stateChangeRefs = [];
        this.rejoinTimer = new $281a441cdcb2cf36$var$Timer(()=>{
            if (this.socket.isConnected()) this.rejoin();
        }, this.socket.rejoinAfterMs);
        this.stateChangeRefs.push(this.socket.onError(()=>this.rejoinTimer.reset()));
        this.stateChangeRefs.push(this.socket.onOpen(()=>{
            this.rejoinTimer.reset();
            if (this.isErrored()) this.rejoin();
        }));
        this.joinPush.receive("ok", ()=>{
            this.state = $281a441cdcb2cf36$var$CHANNEL_STATES2.joined;
            this.rejoinTimer.reset();
            this.pushBuffer.forEach((pushEvent)=>pushEvent.send());
            this.pushBuffer = [];
        });
        this.joinPush.receive("error", (reason)=>{
            this.state = $281a441cdcb2cf36$var$CHANNEL_STATES2.errored;
            if (this.socket.hasLogger()) this.socket.log("channel", `error ${this.topic}`, reason);
            if (this.socket.isConnected()) this.rejoinTimer.scheduleTimeout();
        });
        this.onClose(()=>{
            this.rejoinTimer.reset();
            if (this.socket.hasLogger()) this.socket.log("channel", `close ${this.topic}`);
            this.state = $281a441cdcb2cf36$var$CHANNEL_STATES2.closed;
            this.socket.remove(this);
        });
        this.onError((reason)=>{
            if (this.socket.hasLogger()) this.socket.log("channel", `error ${this.topic}`, reason);
            if (this.isJoining()) this.joinPush.reset();
            this.state = $281a441cdcb2cf36$var$CHANNEL_STATES2.errored;
            if (this.socket.isConnected()) this.rejoinTimer.scheduleTimeout();
        });
        this.joinPush.receive("timeout", ()=>{
            if (this.socket.hasLogger()) this.socket.log("channel", `timeout ${this.topic}`, this.joinPush.timeout);
            let leavePush = new $281a441cdcb2cf36$var$Push(this, $281a441cdcb2cf36$var$CHANNEL_EVENTS2.leave, $281a441cdcb2cf36$var$closure({}), this.timeout);
            leavePush.send();
            this.state = $281a441cdcb2cf36$var$CHANNEL_STATES2.errored;
            this.joinPush.reset();
            if (this.socket.isConnected()) this.rejoinTimer.scheduleTimeout();
        });
        this.on($281a441cdcb2cf36$var$CHANNEL_EVENTS2.reply, (payload, ref2)=>{
            this.trigger(this.replyEventName(ref2), payload);
        });
    }
    /**
   * Join the channel
   * @param {number} timeout
   * @returns {Push}
   */ join(timeout = this.timeout) {
        if (this.joinedOnce) throw new Error("tried to join multiple times. 'join' can only be called a single time per channel instance");
        else {
            this.timeout = timeout;
            this.joinedOnce = true;
            this.rejoin();
            return this.joinPush;
        }
    }
    /**
   * Teardown the channel.
   *
   * Destroys and stops related timers.
   */ teardown() {
        this.pushBuffer.forEach((push)=>push.destroy());
        this.pushBuffer = [];
        this.rejoinTimer.reset();
        this.joinPush.destroy();
        this.state = $281a441cdcb2cf36$var$CHANNEL_STATES2.closed;
        this.bindings = [];
    }
    /**
   * Hook into channel close
   * @param {ChannelBindingCallback} callback
   */ onClose(callback) {
        this.on($281a441cdcb2cf36$var$CHANNEL_EVENTS2.close, callback);
    }
    /**
   * Hook into channel errors
   * @param {ChannelOnErrorCallback} callback
   * @return {number}
   */ onError(callback) {
        return this.on($281a441cdcb2cf36$var$CHANNEL_EVENTS2.error, (reason)=>callback(reason));
    }
    /**
   * Subscribes on channel events
   *
   * Subscription returns a ref counter, which can be used later to
   * unsubscribe the exact event listener
   *
   * @example
   * const ref1 = channel.on("event", do_stuff)
   * const ref2 = channel.on("event", do_other_stuff)
   * channel.off("event", ref1)
   * // Since unsubscription, do_stuff won't fire,
   * // while do_other_stuff will keep firing on the "event"
   *
   * @param {string} event
   * @param {ChannelBindingCallback} callback
   * @returns {number} ref
   */ on(event, callback) {
        let ref2 = this.bindingRef++;
        this.bindings.push({
            event: event,
            ref: ref2,
            callback: callback
        });
        return ref2;
    }
    /**
   * Unsubscribes off of channel events
   *
   * Use the ref returned from a channel.on() to unsubscribe one
   * handler, or pass nothing for the ref to unsubscribe all
   * handlers for the given event.
   *
   * @example
   * // Unsubscribe the do_stuff handler
   * const ref1 = channel.on("event", do_stuff)
   * channel.off("event", ref1)
   *
   * // Unsubscribe all handlers from event
   * channel.off("event")
   *
   * @param {string} event
   * @param {number} [ref]
   */ off(event, ref2) {
        this.bindings = this.bindings.filter((bind)=>{
            return !(bind.event === event && (typeof ref2 === "undefined" || ref2 === bind.ref));
        });
    }
    /**
   * @private
   */ canPush() {
        return this.socket.isConnected() && this.isJoined();
    }
    /**
   * Sends a message `event` to phoenix with the payload `payload`.
   * Phoenix receives this in the `handle_in(event, payload, socket)`
   * function. if phoenix replies or it times out (default 10000ms),
   * then optionally the reply can be received.
   *
   * @example
   * channel.push("event")
   *   .receive("ok", payload => console.log("phoenix replied:", payload))
   *   .receive("error", err => console.log("phoenix errored", err))
   *   .receive("timeout", () => console.log("timed out pushing"))
   * @param {string} event
   * @param {Object} payload
   * @param {number} [timeout]
   * @returns {Push}
   */ push(event, payload, timeout = this.timeout) {
        payload = payload || {};
        if (!this.joinedOnce) throw new Error(`tried to push '${event}' to '${this.topic}' before joining. Use channel.join() before pushing events`);
        let pushEvent = new $281a441cdcb2cf36$var$Push(this, event, function() {
            return payload;
        }, timeout);
        if (this.canPush()) pushEvent.send();
        else {
            pushEvent.startTimeout();
            this.pushBuffer.push(pushEvent);
        }
        return pushEvent;
    }
    /** Leaves the channel
   *
   * Unsubscribes from server events, and
   * instructs channel to terminate on server
   *
   * Triggers onClose() hooks
   *
   * To receive leave acknowledgements, use the `receive`
   * hook to bind to the server ack, ie:
   *
   * @example
   * channel.leave().receive("ok", () => alert("left!") )
   *
   * @param {number} timeout
   * @returns {Push}
   */ leave(timeout = this.timeout) {
        this.rejoinTimer.reset();
        this.joinPush.cancelTimeout();
        this.state = $281a441cdcb2cf36$var$CHANNEL_STATES2.leaving;
        let onClose = ()=>{
            if (this.socket.hasLogger()) this.socket.log("channel", `leave ${this.topic}`);
            this.trigger($281a441cdcb2cf36$var$CHANNEL_EVENTS2.close, "leave");
        };
        let leavePush = new $281a441cdcb2cf36$var$Push(this, $281a441cdcb2cf36$var$CHANNEL_EVENTS2.leave, $281a441cdcb2cf36$var$closure({}), timeout);
        leavePush.receive("ok", ()=>onClose()).receive("timeout", ()=>onClose());
        leavePush.send();
        if (!this.canPush()) leavePush.trigger("ok", {});
        return leavePush;
    }
    /**
   * Overridable message hook
   *
   * Receives all events for specialized message handling
   * before dispatching to the channel callbacks.
   *
   * Must return the payload, modified or unmodified
   * @type{ChannelOnMessage}
   */ onMessage(_event, payload, _ref) {
        return payload;
    }
    /**
   * Overridable filter hook
   *
   * If this function returns `true`, `binding`'s callback will be called.
   *
   * @type{ChannelFilterBindings}
   */ filterBindings(_binding, _payload, _ref) {
        return true;
    }
    isMember(topic, event, payload, joinRef) {
        if (this.topic !== topic) return false;
        if (joinRef && joinRef !== this.joinRef()) {
            if (this.socket.hasLogger()) this.socket.log("channel", "dropping outdated message", {
                topic: topic,
                event: event,
                payload: payload,
                joinRef: joinRef
            });
            return false;
        } else return true;
    }
    joinRef() {
        return this.joinPush.ref;
    }
    /**
   * @private
   */ rejoin(timeout = this.timeout) {
        if (this.isLeaving()) return;
        this.socket.leaveOpenTopic(this.topic);
        this.state = $281a441cdcb2cf36$var$CHANNEL_STATES2.joining;
        this.joinPush.resend(timeout);
    }
    /**
   * @param {string} event
   * @param {unknown} [payload]
   * @param {?string} [ref]
   * @param {?string} [joinRef]
   */ trigger(event, payload, ref2, joinRef) {
        let handledPayload = this.onMessage(event, payload, ref2, joinRef);
        if (payload && !handledPayload) throw new Error("channel onMessage callbacks must return the payload, modified or unmodified");
        let eventBindings = this.bindings.filter((bind)=>bind.event === event && this.filterBindings(bind, payload, ref2));
        for(let i3 = 0; i3 < eventBindings.length; i3++){
            let bind = eventBindings[i3];
            bind.callback(handledPayload, ref2, joinRef || this.joinRef());
        }
    }
    /**
  * @param {string} ref
  */ replyEventName(ref2) {
        return `chan_reply_${ref2}`;
    }
    isClosed() {
        return this.state === $281a441cdcb2cf36$var$CHANNEL_STATES2.closed;
    }
    isErrored() {
        return this.state === $281a441cdcb2cf36$var$CHANNEL_STATES2.errored;
    }
    isJoined() {
        return this.state === $281a441cdcb2cf36$var$CHANNEL_STATES2.joined;
    }
    isJoining() {
        return this.state === $281a441cdcb2cf36$var$CHANNEL_STATES2.joining;
    }
    isLeaving() {
        return this.state === $281a441cdcb2cf36$var$CHANNEL_STATES2.leaving;
    }
};
var $281a441cdcb2cf36$var$Ajax = class {
    static request(method, endPoint, headers, body, timeout, ontimeout, callback) {
        if ($281a441cdcb2cf36$var$global2.XDomainRequest) {
            let req = new $281a441cdcb2cf36$var$global2.XDomainRequest();
            return this.xdomainRequest(req, method, endPoint, body, timeout, ontimeout, callback);
        } else if ($281a441cdcb2cf36$var$global2.XMLHttpRequest) {
            let req = new $281a441cdcb2cf36$var$global2.XMLHttpRequest();
            return this.xhrRequest(req, method, endPoint, headers, body, timeout, ontimeout, callback);
        } else if ($281a441cdcb2cf36$var$global2.fetch && $281a441cdcb2cf36$var$global2.AbortController) return this.fetchRequest(method, endPoint, headers, body, timeout, ontimeout, callback);
        else throw new Error("No suitable XMLHttpRequest implementation found");
    }
    static fetchRequest(method, endPoint, headers, body, timeout, ontimeout, callback) {
        let options = {
            method: method,
            headers: headers,
            body: body
        };
        let controller = null;
        if (timeout) {
            controller = new AbortController();
            const _timeoutId = setTimeout(()=>controller.abort(), timeout);
            options.signal = controller.signal;
        }
        $281a441cdcb2cf36$var$global2.fetch(endPoint, options).then((response)=>response.text()).then((data2)=>this.parseJSON(data2)).then((data2)=>callback && callback(data2)).catch((err)=>{
            if (err.name === "AbortError" && ontimeout) ontimeout();
            else callback && callback(null);
        });
        return controller;
    }
    static xdomainRequest(req, method, endPoint, body, timeout, ontimeout, callback) {
        req.timeout = timeout;
        req.open(method, endPoint);
        req.onload = ()=>{
            let response = this.parseJSON(req.responseText);
            callback && callback(response);
        };
        if (ontimeout) req.ontimeout = ontimeout;
        req.onprogress = ()=>{};
        req.send(body);
        return req;
    }
    static xhrRequest(req, method, endPoint, headers, body, timeout, ontimeout, callback) {
        req.open(method, endPoint, true);
        req.timeout = timeout;
        for (let [key, value2] of Object.entries(headers))req.setRequestHeader(key, value2);
        req.onerror = ()=>callback && callback(null);
        req.onreadystatechange = ()=>{
            if (req.readyState === $281a441cdcb2cf36$var$XHR_STATES.complete && callback) {
                let response = this.parseJSON(req.responseText);
                callback(response);
            }
        };
        if (ontimeout) req.ontimeout = ontimeout;
        req.send(body);
        return req;
    }
    static parseJSON(resp) {
        if (!resp || resp === "") return null;
        try {
            return JSON.parse(resp);
        } catch  {
            console && console.log("failed to parse JSON response", resp);
            return null;
        }
    }
    static serialize(obj, parentKey) {
        let queryStr = [];
        for(var key in obj){
            if (!Object.prototype.hasOwnProperty.call(obj, key)) continue;
            let paramKey = parentKey ? `${parentKey}[${key}]` : key;
            let paramVal = obj[key];
            if (typeof paramVal === "object") queryStr.push(this.serialize(paramVal, paramKey));
            else queryStr.push(encodeURIComponent(paramKey) + "=" + encodeURIComponent(paramVal));
        }
        return queryStr.join("&");
    }
    static appendParams(url2, params2) {
        if (Object.keys(params2).length === 0) return url2;
        let prefix = url2.match(/\?/) ? "&" : "?";
        return `${url2}${prefix}${this.serialize(params2)}`;
    }
};
var $281a441cdcb2cf36$var$arrayBufferToBase64 = (buffer)=>{
    let binary = "";
    let bytes = new Uint8Array(buffer);
    let len = bytes.byteLength;
    for(let i3 = 0; i3 < len; i3++)binary += String.fromCharCode(bytes[i3]);
    return btoa(binary);
};
var $281a441cdcb2cf36$var$LongPoll = class {
    constructor(endPoint, protocols){
        if (protocols && protocols.length === 2 && protocols[1].startsWith($281a441cdcb2cf36$var$AUTH_TOKEN_PREFIX)) this.authToken = atob(protocols[1].slice($281a441cdcb2cf36$var$AUTH_TOKEN_PREFIX.length));
        this.endPoint = null;
        this.token = null;
        this.skipHeartbeat = true;
        this.reqs = /* @__PURE__ */ new Set();
        this.awaitingBatchAck = false;
        this.currentBatch = null;
        this.currentBatchTimer = null;
        this.batchBuffer = [];
        this.onopen = function() {};
        this.onerror = function() {};
        this.onmessage = function() {};
        this.onclose = function() {};
        this.pollEndpoint = this.normalizeEndpoint(endPoint);
        this.readyState = $281a441cdcb2cf36$var$SOCKET_STATES.connecting;
        setTimeout(()=>this.poll(), 0);
    }
    normalizeEndpoint(endPoint) {
        return endPoint.replace("ws://", "http://").replace("wss://", "https://").replace(new RegExp("(.*)/" + $281a441cdcb2cf36$var$TRANSPORTS.websocket), "$1/" + $281a441cdcb2cf36$var$TRANSPORTS.longpoll);
    }
    endpointURL() {
        return $281a441cdcb2cf36$var$Ajax.appendParams(this.pollEndpoint, {
            token: this.token
        });
    }
    closeAndRetry(code, reason, wasClean) {
        this.close(code, reason, wasClean);
        this.readyState = $281a441cdcb2cf36$var$SOCKET_STATES.connecting;
    }
    ontimeout() {
        this.onerror("timeout");
        this.closeAndRetry(1005, "timeout", false);
    }
    isActive() {
        return this.readyState === $281a441cdcb2cf36$var$SOCKET_STATES.open || this.readyState === $281a441cdcb2cf36$var$SOCKET_STATES.connecting;
    }
    poll() {
        const headers = {
            "Accept": "application/json"
        };
        if (this.authToken) headers["X-Phoenix-AuthToken"] = this.authToken;
        this.ajax("GET", headers, null, ()=>this.ontimeout(), (resp)=>{
            if (resp) {
                var { status: status, token: token, messages: messages } = resp;
                if (status === 410 && this.token !== null) {
                    this.onerror(410);
                    this.closeAndRetry(3410, "session_gone", false);
                    return;
                }
                this.token = token;
            } else status = 0;
            switch(status){
                case 200:
                    messages.forEach((msg)=>{
                        setTimeout(()=>this.onmessage({
                                data: msg
                            }), 0);
                    });
                    this.poll();
                    break;
                case 204:
                    this.poll();
                    break;
                case 410:
                    this.readyState = $281a441cdcb2cf36$var$SOCKET_STATES.open;
                    this.onopen({});
                    this.poll();
                    break;
                case 403:
                    this.onerror(403);
                    this.close(1008, "forbidden", false);
                    break;
                case 0:
                case 500:
                    this.onerror(500);
                    this.closeAndRetry(1011, "internal server error", 500);
                    break;
                default:
                    throw new Error(`unhandled poll status ${status}`);
            }
        });
    }
    // we collect all pushes within the current event loop by
    // setTimeout 0, which optimizes back-to-back procedural
    // pushes against an empty buffer
    send(body) {
        if (typeof body !== "string") body = $281a441cdcb2cf36$var$arrayBufferToBase64(body);
        if (this.currentBatch) this.currentBatch.push(body);
        else if (this.awaitingBatchAck) this.batchBuffer.push(body);
        else {
            this.currentBatch = [
                body
            ];
            this.currentBatchTimer = setTimeout(()=>{
                this.batchSend(this.currentBatch);
                this.currentBatch = null;
            }, 0);
        }
    }
    batchSend(messages) {
        this.awaitingBatchAck = true;
        this.ajax("POST", {
            "Content-Type": "application/x-ndjson"
        }, messages.join("\n"), ()=>this.onerror("timeout"), (resp)=>{
            this.awaitingBatchAck = false;
            if (!resp || resp.status !== 200) {
                this.onerror(resp && resp.status);
                this.closeAndRetry(1011, "internal server error", false);
            } else if (this.batchBuffer.length > 0) {
                this.batchSend(this.batchBuffer);
                this.batchBuffer = [];
            }
        });
    }
    close(code, reason, wasClean) {
        for (let req of this.reqs)req.abort();
        this.readyState = $281a441cdcb2cf36$var$SOCKET_STATES.closed;
        let opts = Object.assign({
            code: 1e3,
            reason: void 0,
            wasClean: true
        }, {
            code: code,
            reason: reason,
            wasClean: wasClean
        });
        this.batchBuffer = [];
        clearTimeout(this.currentBatchTimer);
        this.currentBatchTimer = null;
        if (typeof CloseEvent !== "undefined") this.onclose(new CloseEvent("close", opts));
        else this.onclose(opts);
    }
    ajax(method, headers, body, onCallerTimeout, callback) {
        let req;
        let ontimeout = ()=>{
            this.reqs.delete(req);
            onCallerTimeout();
        };
        req = $281a441cdcb2cf36$var$Ajax.request(method, this.endpointURL(), headers, body, this.timeout, ontimeout, (resp)=>{
            this.reqs.delete(req);
            if (this.isActive()) callback(resp);
        });
        this.reqs.add(req);
    }
};
var $281a441cdcb2cf36$var$Presence = class _Presence {
    /**
   * Initializes the Presence
   * @param {Channel} channel - The Channel
   * @param {PresenceOptions} [opts] - The options, for example `{events: {state: "state", diff: "diff"}}`
   */ constructor(channel, opts = {}){
        let events = opts.events || /** @type {PresenceEvents} */ {
            state: "presence_state",
            diff: "presence_diff"
        };
        this.state = {};
        this.pendingDiffs = [];
        this.channel = channel;
        this.joinRef = null;
        this.caller = {
            onJoin: function() {},
            onLeave: function() {},
            onSync: function() {}
        };
        this.channel.on(events.state, (newState)=>{
            let { onJoin: onJoin, onLeave: onLeave, onSync: onSync } = this.caller;
            this.joinRef = this.channel.joinRef();
            this.state = _Presence.syncState(this.state, newState, onJoin, onLeave);
            this.pendingDiffs.forEach((diff)=>{
                this.state = _Presence.syncDiff(this.state, diff, onJoin, onLeave);
            });
            this.pendingDiffs = [];
            onSync();
        });
        this.channel.on(events.diff, (diff)=>{
            let { onJoin: onJoin, onLeave: onLeave, onSync: onSync } = this.caller;
            if (this.inPendingSyncState()) this.pendingDiffs.push(diff);
            else {
                this.state = _Presence.syncDiff(this.state, diff, onJoin, onLeave);
                onSync();
            }
        });
    }
    /**
   * @param {PresenceOnJoin} callback
   */ onJoin(callback) {
        this.caller.onJoin = callback;
    }
    /**
   * @param {PresenceOnLeave} callback
   */ onLeave(callback) {
        this.caller.onLeave = callback;
    }
    /**
   * @param {PresenceOnSync} callback
   */ onSync(callback) {
        this.caller.onSync = callback;
    }
    /**
   * Returns the array of presences, with selected metadata.
   *
   * @template [T=PresenceState]
   * @param {((key: string, obj: PresenceState) => T)} [by]
   *
   * @returns {T[]}
   */ list(by) {
        return _Presence.list(this.state, by);
    }
    inPendingSyncState() {
        return !this.joinRef || this.joinRef !== this.channel.joinRef();
    }
    // lower-level public static API
    /**
   * Used to sync the list of presences on the server
   * with the client's state. An optional `onJoin` and `onLeave` callback can
   * be provided to react to changes in the client's local presences across
   * disconnects and reconnects with the server.
   *
   * @param {Record<string, PresenceState>} currentState
   * @param {Record<string, PresenceState>} newState
   * @param {PresenceOnJoin} onJoin
   * @param {PresenceOnLeave} onLeave
   *
   * @returns {Record<string, PresenceState>}
   */ static syncState(currentState, newState, onJoin, onLeave) {
        let state = this.clone(currentState);
        let joins = {};
        let leaves = {};
        this.map(state, (key, presence)=>{
            if (!newState[key]) leaves[key] = presence;
        });
        this.map(newState, (key, newPresence)=>{
            let currentPresence = state[key];
            if (currentPresence) {
                let newRefs = newPresence.metas.map((m3)=>m3.phx_ref);
                let curRefs = currentPresence.metas.map((m3)=>m3.phx_ref);
                let joinedMetas = newPresence.metas.filter((m3)=>curRefs.indexOf(m3.phx_ref) < 0);
                let leftMetas = currentPresence.metas.filter((m3)=>newRefs.indexOf(m3.phx_ref) < 0);
                if (joinedMetas.length > 0) {
                    joins[key] = newPresence;
                    joins[key].metas = joinedMetas;
                }
                if (leftMetas.length > 0) {
                    leaves[key] = this.clone(currentPresence);
                    leaves[key].metas = leftMetas;
                }
            } else joins[key] = newPresence;
        });
        return this.syncDiff(state, {
            joins: joins,
            leaves: leaves
        }, onJoin, onLeave);
    }
    /**
   *
   * Used to sync a diff of presence join and leave
   * events from the server, as they happen. Like `syncState`, `syncDiff`
   * accepts optional `onJoin` and `onLeave` callbacks to react to a user
   * joining or leaving from a device.
   *
   * @param {Record<string, PresenceState>} state
   * @param {PresenceDiff} diff
   * @param {PresenceOnJoin} onJoin
   * @param {PresenceOnLeave} onLeave
   *
   * @returns {Record<string, PresenceState>}
   */ static syncDiff(state, diff, onJoin, onLeave) {
        let { joins: joins, leaves: leaves } = this.clone(diff);
        if (!onJoin) onJoin = function() {};
        if (!onLeave) onLeave = function() {};
        this.map(joins, (key, newPresence)=>{
            let currentPresence = state[key];
            state[key] = this.clone(newPresence);
            if (currentPresence) {
                let joinedRefs = state[key].metas.map((m3)=>m3.phx_ref);
                let curMetas = currentPresence.metas.filter((m3)=>joinedRefs.indexOf(m3.phx_ref) < 0);
                state[key].metas.unshift(...curMetas);
            }
            onJoin(key, currentPresence, newPresence);
        });
        this.map(leaves, (key, leftPresence)=>{
            let currentPresence = state[key];
            if (!currentPresence) return;
            let refsToRemove = leftPresence.metas.map((m3)=>m3.phx_ref);
            currentPresence.metas = currentPresence.metas.filter((p3)=>{
                return refsToRemove.indexOf(p3.phx_ref) < 0;
            });
            onLeave(key, currentPresence, leftPresence);
            if (currentPresence.metas.length === 0) delete state[key];
        });
        return state;
    }
    /**
   * Returns the array of presences, with selected metadata.
   *
   * @template [T=PresenceState]
   * @param {Record<string, PresenceState>} presences
   * @param {((key: string, obj: PresenceState) => T)} [chooser]
   *
   * @returns {T[]}
   */ static list(presences, chooser) {
        if (!chooser) chooser = function(key, pres) {
            return pres;
        };
        return this.map(presences, (key, presence)=>{
            return chooser(key, presence);
        });
    }
    // private
    /**
  * @template T
  * @param {Record<string, PresenceState>} obj
  * @param {(key: string, obj: PresenceState) => T} func
  */ static map(obj, func) {
        return Object.getOwnPropertyNames(obj).map((key)=>func(key, obj[key]));
    }
    /**
  * @template T
  * @param {T} obj
  * @returns {T}
  */ static clone(obj) {
        return JSON.parse(JSON.stringify(obj));
    }
};
var $281a441cdcb2cf36$var$serializer_default = {
    HEADER_LENGTH: 1,
    META_LENGTH: 4,
    KINDS: {
        push: 0,
        reply: 1,
        broadcast: 2
    },
    /**
  * @template T
  * @param {Message<Record<string, any>>} msg
  * @param {(msg: ArrayBuffer | string) => T} callback
  * @returns {T}
  */ encode (msg, callback) {
        if (msg.payload.constructor === ArrayBuffer) return callback(this.binaryEncode(msg));
        else {
            let payload = [
                msg.join_ref,
                msg.ref,
                msg.topic,
                msg.event,
                msg.payload
            ];
            return callback(JSON.stringify(payload));
        }
    },
    /**
  * @template T
  * @param {ArrayBuffer | string} rawPayload
  * @param {(msg: Message<unknown>) => T} callback
  * @returns {T}
  */ decode (rawPayload, callback) {
        if (rawPayload.constructor === ArrayBuffer) return callback(this.binaryDecode(rawPayload));
        else {
            let [join_ref, ref2, topic, event, payload] = JSON.parse(rawPayload);
            return callback({
                join_ref: join_ref,
                ref: ref2,
                topic: topic,
                event: event,
                payload: payload
            });
        }
    },
    /** @private */ binaryEncode (message) {
        let { join_ref: join_ref, ref: ref2, event: event, topic: topic, payload: payload } = message;
        let metaLength = this.META_LENGTH + join_ref.length + ref2.length + topic.length + event.length;
        let header = new ArrayBuffer(this.HEADER_LENGTH + metaLength);
        let view = new DataView(header);
        let offset2 = 0;
        view.setUint8(offset2++, this.KINDS.push);
        view.setUint8(offset2++, join_ref.length);
        view.setUint8(offset2++, ref2.length);
        view.setUint8(offset2++, topic.length);
        view.setUint8(offset2++, event.length);
        Array.from(join_ref, (char)=>view.setUint8(offset2++, char.charCodeAt(0)));
        Array.from(ref2, (char)=>view.setUint8(offset2++, char.charCodeAt(0)));
        Array.from(topic, (char)=>view.setUint8(offset2++, char.charCodeAt(0)));
        Array.from(event, (char)=>view.setUint8(offset2++, char.charCodeAt(0)));
        var combined = new Uint8Array(header.byteLength + payload.byteLength);
        combined.set(new Uint8Array(header), 0);
        combined.set(new Uint8Array(payload), header.byteLength);
        return combined.buffer;
    },
    /**
  * @private
  */ binaryDecode (buffer) {
        let view = new DataView(buffer);
        let kind = view.getUint8(0);
        let decoder = new TextDecoder();
        switch(kind){
            case this.KINDS.push:
                return this.decodePush(buffer, view, decoder);
            case this.KINDS.reply:
                return this.decodeReply(buffer, view, decoder);
            case this.KINDS.broadcast:
                return this.decodeBroadcast(buffer, view, decoder);
        }
    },
    /** @private */ decodePush (buffer, view, decoder) {
        let joinRefSize = view.getUint8(1);
        let topicSize = view.getUint8(2);
        let eventSize = view.getUint8(3);
        let offset2 = this.HEADER_LENGTH + this.META_LENGTH - 1;
        let joinRef = decoder.decode(buffer.slice(offset2, offset2 + joinRefSize));
        offset2 = offset2 + joinRefSize;
        let topic = decoder.decode(buffer.slice(offset2, offset2 + topicSize));
        offset2 = offset2 + topicSize;
        let event = decoder.decode(buffer.slice(offset2, offset2 + eventSize));
        offset2 = offset2 + eventSize;
        let data2 = buffer.slice(offset2, buffer.byteLength);
        return {
            join_ref: joinRef,
            ref: null,
            topic: topic,
            event: event,
            payload: data2
        };
    },
    /** @private */ decodeReply (buffer, view, decoder) {
        let joinRefSize = view.getUint8(1);
        let refSize = view.getUint8(2);
        let topicSize = view.getUint8(3);
        let eventSize = view.getUint8(4);
        let offset2 = this.HEADER_LENGTH + this.META_LENGTH;
        let joinRef = decoder.decode(buffer.slice(offset2, offset2 + joinRefSize));
        offset2 = offset2 + joinRefSize;
        let ref2 = decoder.decode(buffer.slice(offset2, offset2 + refSize));
        offset2 = offset2 + refSize;
        let topic = decoder.decode(buffer.slice(offset2, offset2 + topicSize));
        offset2 = offset2 + topicSize;
        let event = decoder.decode(buffer.slice(offset2, offset2 + eventSize));
        offset2 = offset2 + eventSize;
        let data2 = buffer.slice(offset2, buffer.byteLength);
        let payload = {
            status: event,
            response: data2
        };
        return {
            join_ref: joinRef,
            ref: ref2,
            topic: topic,
            event: $281a441cdcb2cf36$var$CHANNEL_EVENTS2.reply,
            payload: payload
        };
    },
    /** @private */ decodeBroadcast (buffer, view, decoder) {
        let topicSize = view.getUint8(1);
        let eventSize = view.getUint8(2);
        let offset2 = this.HEADER_LENGTH + 2;
        let topic = decoder.decode(buffer.slice(offset2, offset2 + topicSize));
        offset2 = offset2 + topicSize;
        let event = decoder.decode(buffer.slice(offset2, offset2 + eventSize));
        offset2 = offset2 + eventSize;
        let data2 = buffer.slice(offset2, buffer.byteLength);
        return {
            join_ref: null,
            ref: null,
            topic: topic,
            event: event,
            payload: data2
        };
    }
};
var $281a441cdcb2cf36$var$Socket3 = class {
    /** Initializes the Socket *
   *
   * For IE8 support use an ES5-shim (https://github.com/es-shims/es5-shim)
   *
   * @constructor
   * @param {string} endPoint - The string WebSocket endpoint, ie, `"ws://example.com/socket"`,
   *                                               `"wss://example.com"`
   *                                               `"/socket"` (inherited host & protocol)
   * @param {SocketOptions} [opts] - Optional configuration
   */ constructor(endPoint, opts = {}){
        var _a2, _b;
        this.stateChangeCallbacks = {
            open: [],
            close: [],
            error: [],
            message: []
        };
        this.channels = [];
        this.sendBuffer = [];
        this.ref = 0;
        this.fallbackRef = null;
        this.timeout = opts.timeout || $281a441cdcb2cf36$var$DEFAULT_TIMEOUT2;
        this.transport = opts.transport || $281a441cdcb2cf36$var$global2.WebSocket || $281a441cdcb2cf36$var$LongPoll;
        this.conn = void 0;
        this.primaryPassedHealthCheck = false;
        this.longPollFallbackMs = opts.longPollFallbackMs;
        this.fallbackTimer = null;
        this.sessionStore = opts.sessionStorage || $281a441cdcb2cf36$var$global2 && $281a441cdcb2cf36$var$global2.sessionStorage;
        this.establishedConnections = 0;
        this.defaultEncoder = $281a441cdcb2cf36$var$serializer_default.encode.bind($281a441cdcb2cf36$var$serializer_default);
        this.defaultDecoder = $281a441cdcb2cf36$var$serializer_default.decode.bind($281a441cdcb2cf36$var$serializer_default);
        this.closeWasClean = true;
        this.disconnecting = false;
        this.binaryType = opts.binaryType || "arraybuffer";
        this.connectClock = 1;
        this.pageHidden = false;
        this.encode = void 0;
        this.decode = void 0;
        if (this.transport !== $281a441cdcb2cf36$var$LongPoll) {
            this.encode = opts.encode || this.defaultEncoder;
            this.decode = opts.decode || this.defaultDecoder;
        } else {
            this.encode = this.defaultEncoder;
            this.decode = this.defaultDecoder;
        }
        let awaitingConnectionOnPageShow = null;
        if ($281a441cdcb2cf36$var$phxWindow && $281a441cdcb2cf36$var$phxWindow.addEventListener) {
            $281a441cdcb2cf36$var$phxWindow.addEventListener("pagehide", (_e)=>{
                if (this.conn) {
                    this.disconnect();
                    awaitingConnectionOnPageShow = this.connectClock;
                }
            });
            $281a441cdcb2cf36$var$phxWindow.addEventListener("pageshow", (_e)=>{
                if (awaitingConnectionOnPageShow === this.connectClock) {
                    awaitingConnectionOnPageShow = null;
                    this.connect();
                }
            });
            $281a441cdcb2cf36$var$phxWindow.addEventListener("visibilitychange", ()=>{
                if (document.visibilityState === "hidden") this.pageHidden = true;
                else {
                    this.pageHidden = false;
                    if (!this.isConnected() && !this.closeWasClean) this.teardown(()=>this.connect());
                }
            });
        }
        this.heartbeatIntervalMs = opts.heartbeatIntervalMs || 3e4;
        this.autoSendHeartbeat = (_a2 = opts.autoSendHeartbeat) != null ? _a2 : true;
        this.heartbeatCallback = (_b = opts.heartbeatCallback) != null ? _b : ()=>{};
        this.rejoinAfterMs = (tries)=>{
            if (opts.rejoinAfterMs) return opts.rejoinAfterMs(tries);
            else return [
                1e3,
                2e3,
                5e3
            ][tries - 1] || 1e4;
        };
        this.reconnectAfterMs = (tries)=>{
            if (opts.reconnectAfterMs) return opts.reconnectAfterMs(tries);
            else return [
                10,
                50,
                100,
                150,
                200,
                250,
                500,
                1e3,
                2e3
            ][tries - 1] || 5e3;
        };
        this.logger = opts.logger || null;
        if (!this.logger && opts.debug) this.logger = (kind, msg, data2)=>{
            console.log(`${kind}: ${msg}`, data2);
        };
        this.longpollerTimeout = opts.longpollerTimeout || 2e4;
        this.params = $281a441cdcb2cf36$var$closure(opts.params || {});
        this.endPoint = `${endPoint}/${$281a441cdcb2cf36$var$TRANSPORTS.websocket}`;
        this.vsn = opts.vsn || $281a441cdcb2cf36$var$DEFAULT_VSN2;
        this.heartbeatTimeoutTimer = null;
        this.heartbeatTimer = null;
        this.heartbeatSentAt = null;
        this.pendingHeartbeatRef = null;
        this.reconnectTimer = new $281a441cdcb2cf36$var$Timer(()=>{
            if (this.pageHidden) {
                this.log("Not reconnecting as page is hidden!");
                this.teardown();
                return;
            }
            this.teardown(async ()=>{
                if (opts.beforeReconnect) await opts.beforeReconnect();
                this.connect();
            });
        }, this.reconnectAfterMs);
        this.authToken = opts.authToken;
    }
    /**
   * Returns the LongPoll transport reference
   */ getLongPollTransport() {
        return $281a441cdcb2cf36$var$LongPoll;
    }
    /**
   * Disconnects and replaces the active transport
   *
   * @param {SocketTransport} newTransport - The new transport class to instantiate
   *
   */ replaceTransport(newTransport) {
        this.connectClock++;
        this.closeWasClean = true;
        clearTimeout(this.fallbackTimer);
        this.reconnectTimer.reset();
        if (this.conn) {
            this.conn.close();
            this.conn = null;
        }
        this.transport = newTransport;
    }
    /**
   * Returns the socket protocol
   *
   * @returns {"wss" | "ws"}
   */ protocol() {
        return location.protocol.match(/^https/) ? "wss" : "ws";
    }
    /**
   * The fully qualified socket url
   *
   * @returns {string}
   */ endPointURL() {
        let uri = $281a441cdcb2cf36$var$Ajax.appendParams($281a441cdcb2cf36$var$Ajax.appendParams(this.endPoint, this.params()), {
            vsn: this.vsn
        });
        if (uri.charAt(0) !== "/") return uri;
        if (uri.charAt(1) === "/") return `${this.protocol()}:${uri}`;
        return `${this.protocol()}://${location.host}${uri}`;
    }
    /**
   * Disconnects the socket
   *
   * See https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent#Status_codes for valid status codes.
   *
   * @param {() => void} [callback] - Optional callback which is called after socket is disconnected.
   * @param {number} [code] - A status code for disconnection (Optional).
   * @param {string} [reason] - A textual description of the reason to disconnect. (Optional)
   */ disconnect(callback, code, reason) {
        this.connectClock++;
        this.disconnecting = true;
        this.closeWasClean = true;
        clearTimeout(this.fallbackTimer);
        this.reconnectTimer.reset();
        this.teardown(()=>{
            this.disconnecting = false;
            callback && callback();
        }, code, reason);
    }
    /**
   * @param {Params} [params] - [DEPRECATED] The params to send when connecting, for example `{user_id: userToken}`
   *
   * Passing params to connect is deprecated; pass them in the Socket constructor instead:
   * `new Socket("/socket", {params: {user_id: userToken}})`.
   */ connect(params2) {
        if (params2) {
            console && console.log("passing params to connect is deprecated. Instead pass :params to the Socket constructor");
            this.params = $281a441cdcb2cf36$var$closure(params2);
        }
        if (this.conn && !this.disconnecting) return;
        if (this.longPollFallbackMs && this.transport !== $281a441cdcb2cf36$var$LongPoll) this.connectWithFallback($281a441cdcb2cf36$var$LongPoll, this.longPollFallbackMs);
        else this.transportConnect();
    }
    /**
   * Logs the message. Override `this.logger` for specialized logging. noops by default
   * @param {string} kind
   * @param {string} msg
   * @param {Object} data
   */ log(kind, msg, data2) {
        this.logger && this.logger(kind, msg, data2);
    }
    /**
   * Returns true if a logger has been set on this socket.
   */ hasLogger() {
        return this.logger !== null;
    }
    /**
   * Registers callbacks for connection open events
   *
   * @example socket.onOpen(function(){ console.info("the socket was opened") })
   *
   * @param {SocketOnOpen} callback
   */ onOpen(callback) {
        let ref2 = this.makeRef();
        this.stateChangeCallbacks.open.push([
            ref2,
            callback
        ]);
        return ref2;
    }
    /**
   * Registers callbacks for connection close events
   * @param {SocketOnClose} callback
   * @returns {string}
   */ onClose(callback) {
        let ref2 = this.makeRef();
        this.stateChangeCallbacks.close.push([
            ref2,
            callback
        ]);
        return ref2;
    }
    /**
   * Registers callbacks for connection error events
   *
   * @example socket.onError(function(error){ alert("An error occurred") })
   *
   * @param {SocketOnError} callback
   * @returns {string}
   */ onError(callback) {
        let ref2 = this.makeRef();
        this.stateChangeCallbacks.error.push([
            ref2,
            callback
        ]);
        return ref2;
    }
    /**
   * Registers callbacks for connection message events
   * @param {SocketOnMessage} callback
   * @returns {string}
   */ onMessage(callback) {
        let ref2 = this.makeRef();
        this.stateChangeCallbacks.message.push([
            ref2,
            callback
        ]);
        return ref2;
    }
    /**
   * Sets a callback that receives lifecycle events for internal heartbeat messages.
   * Useful for instrumenting connection health (e.g. sent/ok/timeout/disconnected).
   * @param {HeartbeatCallback} callback
   */ onHeartbeat(callback) {
        this.heartbeatCallback = callback;
    }
    /**
   * Pings the server and invokes the callback with the RTT in milliseconds
   * @param {(timeDelta: number) => void} callback
   *
   * Returns true if the ping was pushed or false if unable to be pushed.
   */ ping(callback) {
        if (!this.isConnected()) return false;
        let ref2 = this.makeRef();
        let startTime = Date.now();
        this.push({
            topic: "phoenix",
            event: "heartbeat",
            payload: {},
            ref: ref2
        });
        let onMsgRef = this.onMessage((msg)=>{
            if (msg.ref === ref2) {
                this.off([
                    onMsgRef
                ]);
                callback(Date.now() - startTime);
            }
        });
        return true;
    }
    /**
   * @private
   *
   * @param {Function}
   */ transportName(transport) {
        switch(transport){
            case $281a441cdcb2cf36$var$LongPoll:
                return "LongPoll";
            default:
                return transport.name;
        }
    }
    /**
   * @private
   */ transportConnect() {
        this.connectClock++;
        this.closeWasClean = false;
        let protocols = void 0;
        if (this.authToken) protocols = [
            "phoenix",
            `${$281a441cdcb2cf36$var$AUTH_TOKEN_PREFIX}${btoa(this.authToken).replace(/=/g, "")}`
        ];
        this.conn = new this.transport(this.endPointURL(), protocols);
        this.conn.binaryType = this.binaryType;
        this.conn.timeout = this.longpollerTimeout;
        this.conn.onopen = ()=>this.onConnOpen();
        this.conn.onerror = (error)=>this.onConnError(error);
        this.conn.onmessage = (event)=>this.onConnMessage(event);
        this.conn.onclose = (event)=>this.onConnClose(event);
    }
    getSession(key) {
        return this.sessionStore && this.sessionStore.getItem(key);
    }
    storeSession(key, val) {
        this.sessionStore && this.sessionStore.setItem(key, val);
    }
    connectWithFallback(fallbackTransport, fallbackThreshold = 2500) {
        clearTimeout(this.fallbackTimer);
        let established = false;
        let primaryTransport = true;
        let openRef, errorRef;
        let fallbackTransportName = this.transportName(fallbackTransport);
        let fallback = (reason)=>{
            this.log("transport", `falling back to ${fallbackTransportName}...`, reason);
            this.off([
                openRef,
                errorRef
            ]);
            primaryTransport = false;
            this.replaceTransport(fallbackTransport);
            this.transportConnect();
        };
        if (this.getSession(`phx:fallback:${fallbackTransportName}`)) return fallback("memorized");
        this.fallbackTimer = setTimeout(fallback, fallbackThreshold);
        errorRef = this.onError((reason)=>{
            this.log("transport", "error", reason);
            if (primaryTransport && !established) {
                clearTimeout(this.fallbackTimer);
                fallback(reason);
            }
        });
        if (this.fallbackRef) this.off([
            this.fallbackRef
        ]);
        this.fallbackRef = this.onOpen(()=>{
            established = true;
            if (!primaryTransport) {
                let fallbackTransportName2 = this.transportName(fallbackTransport);
                if (!this.primaryPassedHealthCheck) this.storeSession(`phx:fallback:${fallbackTransportName2}`, "true");
                return this.log("transport", `established ${fallbackTransportName2} fallback`);
            }
            clearTimeout(this.fallbackTimer);
            this.fallbackTimer = setTimeout(fallback, fallbackThreshold);
            this.ping((rtt)=>{
                this.log("transport", "connected to primary after", rtt);
                this.primaryPassedHealthCheck = true;
                clearTimeout(this.fallbackTimer);
            });
        });
        this.transportConnect();
    }
    clearHeartbeats() {
        clearTimeout(this.heartbeatTimer);
        clearTimeout(this.heartbeatTimeoutTimer);
    }
    onConnOpen() {
        if (this.hasLogger()) this.log("transport", `connected to ${this.endPointURL()}`);
        this.closeWasClean = false;
        this.disconnecting = false;
        this.establishedConnections++;
        this.flushSendBuffer();
        this.reconnectTimer.reset();
        if (this.autoSendHeartbeat) this.resetHeartbeat();
        this.triggerStateCallbacks("open");
    }
    /**
   * @private
   */ heartbeatTimeout() {
        if (this.pendingHeartbeatRef) {
            this.pendingHeartbeatRef = null;
            this.heartbeatSentAt = null;
            if (this.hasLogger()) this.log("transport", "heartbeat timeout. Attempting to re-establish connection");
            try {
                this.heartbeatCallback("timeout");
            } catch (e4) {
                this.log("error", "error in heartbeat callback", e4);
            }
            this.triggerChanError(new Error("heartbeat timeout"));
            this.closeWasClean = false;
            this.teardown(()=>this.reconnectTimer.scheduleTimeout(), $281a441cdcb2cf36$var$WS_CLOSE_NORMAL, "heartbeat timeout");
        }
    }
    resetHeartbeat() {
        if (this.conn && this.conn.skipHeartbeat) return;
        this.pendingHeartbeatRef = null;
        this.clearHeartbeats();
        this.heartbeatTimer = setTimeout(()=>this.sendHeartbeat(), this.heartbeatIntervalMs);
    }
    teardown(callback, code, reason) {
        if (!this.conn) return callback && callback();
        const connToClose = this.conn;
        this.waitForBufferDone(connToClose, ()=>{
            if (code) connToClose.close(code, reason || "");
            else connToClose.close();
            this.waitForSocketClosed(connToClose, ()=>{
                if (this.conn === connToClose) {
                    this.conn.onopen = function() {};
                    this.conn.onerror = function() {};
                    this.conn.onmessage = function() {};
                    this.conn.onclose = function() {};
                    this.conn = null;
                }
                callback && callback();
            });
        });
    }
    waitForBufferDone(conn, callback, tries = 1) {
        if (tries === 5 || !conn.bufferedAmount) {
            callback();
            return;
        }
        setTimeout(()=>{
            this.waitForBufferDone(conn, callback, tries + 1);
        }, 150 * tries);
    }
    waitForSocketClosed(conn, callback, tries = 1) {
        if (tries === 5 || conn.readyState === $281a441cdcb2cf36$var$SOCKET_STATES.closed) {
            callback();
            return;
        }
        setTimeout(()=>{
            this.waitForSocketClosed(conn, callback, tries + 1);
        }, 150 * tries);
    }
    /**
  * @param {CloseEvent} event
  */ onConnClose(event) {
        if (this.conn) this.conn.onclose = ()=>{};
        if (this.hasLogger()) this.log("transport", "close", event);
        this.triggerChanError(event);
        this.clearHeartbeats();
        if (!this.closeWasClean) this.reconnectTimer.scheduleTimeout();
        this.triggerStateCallbacks("close", event);
    }
    /**
   * @private
   * @param {Event} error
   */ onConnError(error) {
        if (this.hasLogger()) this.log("transport", "error", error);
        let transportBefore = this.transport;
        let establishedBefore = this.establishedConnections;
        this.triggerStateCallbacks("error", error, transportBefore, establishedBefore);
        if (transportBefore === this.transport || establishedBefore > 0) this.triggerChanError(error);
    }
    /**
   * @private
   * @param {unknown} [reason] underlying close/error event forwarded to channel error listeners
   */ triggerChanError(reason) {
        this.channels.forEach((channel)=>{
            if (!(channel.isErrored() || channel.isLeaving() || channel.isClosed())) channel.trigger($281a441cdcb2cf36$var$CHANNEL_EVENTS2.error, reason);
        });
    }
    /**
   * @returns {string}
   */ connectionState() {
        switch(this.conn && this.conn.readyState){
            case $281a441cdcb2cf36$var$SOCKET_STATES.connecting:
                return "connecting";
            case $281a441cdcb2cf36$var$SOCKET_STATES.open:
                return "open";
            case $281a441cdcb2cf36$var$SOCKET_STATES.closing:
                return "closing";
            default:
                return "closed";
        }
    }
    /**
   * @returns {boolean}
   */ isConnected() {
        return this.connectionState() === "open";
    }
    /**
   *
   * @param {Channel} channel
   */ remove(channel) {
        this.off(channel.stateChangeRefs);
        this.channels = this.channels.filter((c3)=>c3 !== channel);
    }
    /**
   * Removes `onOpen`, `onClose`, `onError,` and `onMessage` registrations.
   *
   * @param {string[]} refs - list of refs returned by calls to
   *                 `onOpen`, `onClose`, `onError,` and `onMessage`
   */ off(refs) {
        for(let key in this.stateChangeCallbacks)this.stateChangeCallbacks[key] = this.stateChangeCallbacks[key].filter(([ref2])=>{
            return refs.indexOf(ref2) === -1;
        });
    }
    /**
   * Initiates a new channel for the given topic
   *
   * @param {string} topic
   * @param {Params | (() => Params)} [chanParams]- Parameters for the channel
   * @returns {Channel}
   */ channel(topic, chanParams = {}) {
        let chan = new $281a441cdcb2cf36$var$Channel(topic, chanParams, this);
        this.channels.push(chan);
        return chan;
    }
    /**
   * @param {Message<Record<string, any>>} data
   */ push(data2) {
        if (this.hasLogger()) {
            let { topic: topic, event: event, payload: payload, ref: ref2, join_ref: join_ref } = data2;
            this.log("push", `${topic} ${event} (${join_ref}, ${ref2})`, payload);
        }
        if (this.isConnected()) this.encode(data2, (result)=>this.conn.send(result));
        else this.sendBuffer.push(()=>this.encode(data2, (result)=>this.conn.send(result)));
    }
    /**
   * Return the next message ref, accounting for overflows
   * @returns {string}
   */ makeRef() {
        let newRef = this.ref + 1;
        if (newRef === this.ref) this.ref = 0;
        else this.ref = newRef;
        return this.ref.toString();
    }
    sendHeartbeat() {
        if (!this.isConnected()) {
            try {
                this.heartbeatCallback("disconnected");
            } catch (e4) {
                this.log("error", "error in heartbeat callback", e4);
            }
            return;
        }
        if (this.pendingHeartbeatRef) {
            this.heartbeatTimeout();
            return;
        }
        this.pendingHeartbeatRef = this.makeRef();
        this.heartbeatSentAt = Date.now();
        this.push({
            topic: "phoenix",
            event: "heartbeat",
            payload: {},
            ref: this.pendingHeartbeatRef
        });
        try {
            this.heartbeatCallback("sent");
        } catch (e4) {
            this.log("error", "error in heartbeat callback", e4);
        }
        this.heartbeatTimeoutTimer = setTimeout(()=>this.heartbeatTimeout(), this.heartbeatIntervalMs);
    }
    flushSendBuffer() {
        if (this.isConnected() && this.sendBuffer.length > 0) {
            this.sendBuffer.forEach((callback)=>callback());
            this.sendBuffer = [];
        }
    }
    /**
  * @param {MessageEvent<any>} rawMessage
  */ onConnMessage(rawMessage) {
        this.decode(rawMessage.data, (msg)=>{
            let { topic: topic, event: event, payload: payload, ref: ref2, join_ref: join_ref } = msg;
            if (ref2 && ref2 === this.pendingHeartbeatRef) {
                const latency = this.heartbeatSentAt ? Date.now() - this.heartbeatSentAt : void 0;
                this.clearHeartbeats();
                try {
                    this.heartbeatCallback(payload.status === "ok" ? "ok" : "error", latency);
                } catch (e4) {
                    this.log("error", "error in heartbeat callback", e4);
                }
                this.pendingHeartbeatRef = null;
                this.heartbeatSentAt = null;
                if (this.autoSendHeartbeat) this.heartbeatTimer = setTimeout(()=>this.sendHeartbeat(), this.heartbeatIntervalMs);
            }
            if (this.hasLogger()) this.log("receive", `${payload.status || ""} ${topic} ${event} ${ref2 && "(" + ref2 + ")" || ""}`.trim(), payload);
            for(let i3 = 0; i3 < this.channels.length; i3++){
                const channel = this.channels[i3];
                if (!channel.isMember(topic, event, payload, join_ref)) continue;
                channel.trigger(event, payload, ref2, join_ref);
            }
            this.triggerStateCallbacks("message", msg);
        });
    }
    /**
   * @private
   * @template {keyof SocketStateChangeCallbacks} K
   * @param {K} event
   * @param {...Parameters<SocketStateChangeCallbacks[K][number][1]>} args
   * @returns {void}
   */ triggerStateCallbacks(event, ...args2) {
        try {
            this.stateChangeCallbacks[event].forEach(([_3, callback])=>{
                try {
                    callback(...args2);
                } catch (e4) {
                    this.log("error", `error in ${event} callback`, e4);
                }
            });
        } catch (e4) {
            this.log("error", `error triggering ${event} callbacks`, e4);
        }
    }
    leaveOpenTopic(topic) {
        let dupChannel = this.channels.find((c3)=>c3.topic === topic && (c3.isJoined() || c3.isJoining()));
        if (dupChannel) {
            if (this.hasLogger()) this.log("transport", `leaving duplicate topic "${topic}"`);
            dupChannel.leave();
        }
    }
};
// ../node_modules/@supabase/realtime-js/dist/module/phoenix/presenceAdapter.js
var $281a441cdcb2cf36$var$PresenceAdapter = class _PresenceAdapter {
    constructor(channel, opts){
        const phoenixOptions = $281a441cdcb2cf36$var$phoenixPresenceOptions(opts);
        this.presence = new $281a441cdcb2cf36$var$Presence(channel.getChannel(), phoenixOptions);
        this.presence.onJoin((key, currentPresence, newPresence)=>{
            const onJoinPayload = _PresenceAdapter.onJoinPayload(key, currentPresence, newPresence);
            channel.getChannel().trigger("presence", onJoinPayload);
        });
        this.presence.onLeave((key, currentPresence, leftPresence)=>{
            const onLeavePayload = _PresenceAdapter.onLeavePayload(key, currentPresence, leftPresence);
            channel.getChannel().trigger("presence", onLeavePayload);
        });
        this.presence.onSync(()=>{
            channel.getChannel().trigger("presence", {
                event: "sync"
            });
        });
    }
    get state() {
        return _PresenceAdapter.transformState(this.presence.state);
    }
    /**
   * @private
   * Remove 'metas' key
   * Change 'phx_ref' to 'presence_ref'
   * Remove 'phx_ref' and 'phx_ref_prev'
   *
   * @example Transform state
   * // returns {
   *  abc123: [
   *    { presence_ref: '2', user_id: 1 },
   *    { presence_ref: '3', user_id: 2 }
   *  ]
   * }
   * RealtimePresence.transformState({
   *  abc123: {
   *    metas: [
   *      { phx_ref: '2', phx_ref_prev: '1' user_id: 1 },
   *      { phx_ref: '3', user_id: 2 }
   *    ]
   *  }
   * })
   *
   */ static transformState(state) {
        state = $281a441cdcb2cf36$var$cloneState(state);
        return Object.getOwnPropertyNames(state).reduce((newState, key)=>{
            const presences = state[key];
            newState[key] = $281a441cdcb2cf36$var$transformState(presences);
            return newState;
        }, {});
    }
    static onJoinPayload(key, currentPresence, newPresence) {
        const currentPresences = $281a441cdcb2cf36$var$parseCurrentPresences(currentPresence);
        const newPresences = $281a441cdcb2cf36$var$transformState(newPresence);
        return {
            event: "join",
            key: key,
            currentPresences: currentPresences,
            newPresences: newPresences
        };
    }
    static onLeavePayload(key, currentPresence, leftPresence) {
        const currentPresences = $281a441cdcb2cf36$var$parseCurrentPresences(currentPresence);
        const leftPresences = $281a441cdcb2cf36$var$transformState(leftPresence);
        return {
            event: "leave",
            key: key,
            currentPresences: currentPresences,
            leftPresences: leftPresences
        };
    }
};
function $281a441cdcb2cf36$var$transformState(presences) {
    return presences.metas.map((presence)=>{
        presence["presence_ref"] = presence["phx_ref"];
        delete presence["phx_ref"];
        delete presence["phx_ref_prev"];
        return presence;
    });
}
function $281a441cdcb2cf36$var$cloneState(state) {
    return JSON.parse(JSON.stringify(state));
}
function $281a441cdcb2cf36$var$phoenixPresenceOptions(opts) {
    return (opts === null || opts === void 0 ? void 0 : opts.events) && {
        events: opts.events
    };
}
function $281a441cdcb2cf36$var$parseCurrentPresences(currentPresences) {
    return (currentPresences === null || currentPresences === void 0 ? void 0 : currentPresences.metas) ? $281a441cdcb2cf36$var$transformState(currentPresences) : [];
}
// ../node_modules/@supabase/realtime-js/dist/module/RealtimePresence.js
var $281a441cdcb2cf36$var$REALTIME_PRESENCE_LISTEN_EVENTS;
(function(REALTIME_PRESENCE_LISTEN_EVENTS2) {
    REALTIME_PRESENCE_LISTEN_EVENTS2["SYNC"] = "sync";
    REALTIME_PRESENCE_LISTEN_EVENTS2["JOIN"] = "join";
    REALTIME_PRESENCE_LISTEN_EVENTS2["LEAVE"] = "leave";
})($281a441cdcb2cf36$var$REALTIME_PRESENCE_LISTEN_EVENTS || ($281a441cdcb2cf36$var$REALTIME_PRESENCE_LISTEN_EVENTS = {}));
var $281a441cdcb2cf36$var$RealtimePresence = class {
    get state() {
        return this.presenceAdapter.state;
    }
    /**
   * Creates a Presence helper that keeps the local presence state in sync with the server.
   *
   * @param channel - The realtime channel to bind to.
   * @param opts - Optional custom event names, e.g. `{ events: { state: 'state', diff: 'diff' } }`.
   *
   * @category Realtime
   *
   * @example Example for a presence channel
   * ```ts
   * const presence = new RealtimePresence(channel)
   *
   * channel.on('presence', ({ event, key }) => {
   *   console.log(`Presence ${event} on ${key}`)
   * })
   * ```
   */ constructor(channel, opts){
        this.channel = channel;
        this.presenceAdapter = new $281a441cdcb2cf36$var$PresenceAdapter(this.channel.channelAdapter, opts);
    }
};
// ../node_modules/@supabase/realtime-js/dist/module/lib/normalizeChannelError.js
function $281a441cdcb2cf36$var$normalizeChannelError(reason) {
    if (reason instanceof Error) return reason;
    if (typeof reason === "string") return new Error(reason);
    if (reason && typeof reason === "object") {
        const obj = reason;
        if (typeof obj.code === "number") {
            const detail = typeof obj.reason === "string" && obj.reason ? ` (${obj.reason})` : "";
            return new Error(`socket closed: ${obj.code}${detail}`, {
                cause: reason
            });
        }
        return new Error("channel error: transport failure", {
            cause: reason
        });
    }
    return new Error("channel error: connection lost");
}
// ../node_modules/@supabase/realtime-js/dist/module/phoenix/channelAdapter.js
var $281a441cdcb2cf36$var$ChannelAdapter = class {
    constructor(socket, topic, params2){
        const phoenixParams = $281a441cdcb2cf36$var$phoenixChannelParams(params2);
        this.channel = socket.getSocket().channel(topic, phoenixParams);
        this.socket = socket;
    }
    get state() {
        return this.channel.state;
    }
    set state(state) {
        this.channel.state = state;
    }
    get joinedOnce() {
        return this.channel.joinedOnce;
    }
    get joinPush() {
        return this.channel.joinPush;
    }
    get rejoinTimer() {
        return this.channel.rejoinTimer;
    }
    on(event, callback) {
        return this.channel.on(event, callback);
    }
    off(event, refNumber) {
        this.channel.off(event, refNumber);
    }
    subscribe(timeout) {
        return this.channel.join(timeout);
    }
    unsubscribe(timeout) {
        return this.channel.leave(timeout);
    }
    teardown() {
        this.channel.teardown();
    }
    onClose(callback) {
        this.channel.onClose(callback);
    }
    onError(callback) {
        return this.channel.onError(callback);
    }
    push(event, payload, timeout) {
        let push;
        try {
            push = this.channel.push(event, payload, timeout);
        } catch (error) {
            throw new Error(`tried to push '${event}' to '${this.channel.topic}' before joining. Use channel.subscribe() before pushing events`);
        }
        if (this.channel.pushBuffer.length > $281a441cdcb2cf36$var$MAX_PUSH_BUFFER_SIZE) {
            const removedPush = this.channel.pushBuffer.shift();
            removedPush.cancelTimeout();
            this.socket.log("channel", `discarded push due to buffer overflow: ${removedPush.event}`, removedPush.payload());
        }
        return push;
    }
    updateJoinPayload(payload) {
        const oldPayload = this.channel.joinPush.payload();
        this.channel.joinPush.payload = ()=>Object.assign(Object.assign({}, oldPayload), payload);
    }
    canPush() {
        return this.socket.isConnected() && this.state === $281a441cdcb2cf36$var$CHANNEL_STATES.joined;
    }
    isJoined() {
        return this.state === $281a441cdcb2cf36$var$CHANNEL_STATES.joined;
    }
    isJoining() {
        return this.state === $281a441cdcb2cf36$var$CHANNEL_STATES.joining;
    }
    isClosed() {
        return this.state === $281a441cdcb2cf36$var$CHANNEL_STATES.closed;
    }
    isLeaving() {
        return this.state === $281a441cdcb2cf36$var$CHANNEL_STATES.leaving;
    }
    updateFilterBindings(filterBindings) {
        this.channel.filterBindings = filterBindings;
    }
    updatePayloadTransform(callback) {
        this.channel.onMessage = callback;
    }
    /**
   * @internal
   */ getChannel() {
        return this.channel;
    }
};
function $281a441cdcb2cf36$var$phoenixChannelParams(options) {
    return {
        config: Object.assign({
            broadcast: {
                ack: false,
                self: false
            },
            presence: {
                key: "",
                enabled: false
            },
            private: false
        }, options.config)
    };
}
// ../node_modules/@supabase/realtime-js/dist/module/RealtimeChannel.js
var $281a441cdcb2cf36$var$REALTIME_POSTGRES_CHANGES_LISTEN_EVENT;
(function(REALTIME_POSTGRES_CHANGES_LISTEN_EVENT2) {
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT2["ALL"] = "*";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT2["INSERT"] = "INSERT";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT2["UPDATE"] = "UPDATE";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT2["DELETE"] = "DELETE";
})($281a441cdcb2cf36$var$REALTIME_POSTGRES_CHANGES_LISTEN_EVENT || ($281a441cdcb2cf36$var$REALTIME_POSTGRES_CHANGES_LISTEN_EVENT = {}));
var $281a441cdcb2cf36$var$REALTIME_LISTEN_TYPES;
(function(REALTIME_LISTEN_TYPES2) {
    REALTIME_LISTEN_TYPES2["BROADCAST"] = "broadcast";
    REALTIME_LISTEN_TYPES2["PRESENCE"] = "presence";
    REALTIME_LISTEN_TYPES2["POSTGRES_CHANGES"] = "postgres_changes";
    REALTIME_LISTEN_TYPES2["SYSTEM"] = "system";
})($281a441cdcb2cf36$var$REALTIME_LISTEN_TYPES || ($281a441cdcb2cf36$var$REALTIME_LISTEN_TYPES = {}));
var $281a441cdcb2cf36$var$REALTIME_SUBSCRIBE_STATES;
(function(REALTIME_SUBSCRIBE_STATES2) {
    REALTIME_SUBSCRIBE_STATES2["SUBSCRIBED"] = "SUBSCRIBED";
    REALTIME_SUBSCRIBE_STATES2["TIMED_OUT"] = "TIMED_OUT";
    REALTIME_SUBSCRIBE_STATES2["CLOSED"] = "CLOSED";
    REALTIME_SUBSCRIBE_STATES2["CHANNEL_ERROR"] = "CHANNEL_ERROR";
})($281a441cdcb2cf36$var$REALTIME_SUBSCRIBE_STATES || ($281a441cdcb2cf36$var$REALTIME_SUBSCRIBE_STATES = {}));
var $281a441cdcb2cf36$var$RealtimeChannel = class _RealtimeChannel {
    get state() {
        return this.channelAdapter.state;
    }
    set state(state) {
        this.channelAdapter.state = state;
    }
    get joinedOnce() {
        return this.channelAdapter.joinedOnce;
    }
    get timeout() {
        return this.socket.timeout;
    }
    get joinPush() {
        return this.channelAdapter.joinPush;
    }
    get rejoinTimer() {
        return this.channelAdapter.rejoinTimer;
    }
    /**
   * Creates a channel that can broadcast messages, sync presence, and listen to Postgres changes.
   *
   * The topic determines which realtime stream you are subscribing to. Config options let you
   * enable acknowledgement for broadcasts, presence tracking, or private channels.
   *
   * @category Realtime
   *
   * @example Using supabase-js (recommended)
   * ```ts
   * import { createClient } from '@supabase/supabase-js'
   *
   * const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
   * const channel = supabase.channel('room1')
   * channel
   *   .on('broadcast', { event: 'cursor-pos' }, (payload) => console.log(payload))
   *   .subscribe()
   * ```
   *
   * @example Standalone import for bundle-sensitive environments
   * ```ts
   * import RealtimeClient from '@supabase/realtime-js'
   *
   * const client = new RealtimeClient('https://xyzcompany.supabase.co/realtime/v1', {
   *   params: { apikey: 'your-publishable-key' },
   * })
   * const channel = new RealtimeChannel('realtime:public:messages', { config: {} }, client)
   * ```
   */ constructor(topic, params2 = {
        config: {}
    }, socket){
        var _a2, _b;
        this.topic = topic;
        this.params = params2;
        this.socket = socket;
        this.bindings = {};
        this.subTopic = topic.replace(/^realtime:/i, "");
        this.params.config = Object.assign({
            broadcast: {
                ack: false,
                self: false
            },
            presence: {
                key: "",
                enabled: false
            },
            private: false
        }, params2.config);
        this.channelAdapter = new $281a441cdcb2cf36$var$ChannelAdapter(this.socket.socketAdapter, topic, this.params);
        this.presence = new $281a441cdcb2cf36$var$RealtimePresence(this);
        this._onClose(()=>{
            this.socket._remove(this);
        });
        this._updateFilterTransform();
        this.broadcastEndpointURL = $281a441cdcb2cf36$var$httpEndpointURL(this.socket.socketAdapter.endPointURL());
        this.private = this.params.config.private || false;
        if (!this.private && ((_b = (_a2 = this.params.config) === null || _a2 === void 0 ? void 0 : _a2.broadcast) === null || _b === void 0 ? void 0 : _b.replay)) throw new Error(`tried to use replay on public channel '${this.topic}'. It must be a private channel.`);
    }
    /**
   * Subscribe registers your client with the server
   * @category Realtime
   */ subscribe(callback, timeout = this.timeout) {
        var _a2, _b, _c;
        if (!this.socket.isConnected()) this.socket.connect();
        if (this.channelAdapter.isClosed()) {
            const { config: { broadcast: broadcast, presence: presence, private: isPrivate } } = this.params;
            const postgres_changes = (_b = (_a2 = this.bindings.postgres_changes) === null || _a2 === void 0 ? void 0 : _a2.map((r3)=>r3.filter)) !== null && _b !== void 0 ? _b : [];
            const presence_enabled = !!this.bindings[$281a441cdcb2cf36$var$REALTIME_LISTEN_TYPES.PRESENCE] && this.bindings[$281a441cdcb2cf36$var$REALTIME_LISTEN_TYPES.PRESENCE].length > 0 || ((_c = this.params.config.presence) === null || _c === void 0 ? void 0 : _c.enabled) === true;
            const accessTokenPayload = {};
            const config = {
                broadcast: broadcast,
                presence: Object.assign(Object.assign({}, presence), {
                    enabled: presence_enabled
                }),
                postgres_changes: postgres_changes,
                private: isPrivate
            };
            if (this.socket.accessTokenValue) accessTokenPayload.access_token = this.socket.accessTokenValue;
            this._onError((reason)=>{
                callback === null || callback === void 0 || callback($281a441cdcb2cf36$var$REALTIME_SUBSCRIBE_STATES.CHANNEL_ERROR, $281a441cdcb2cf36$var$normalizeChannelError(reason));
            });
            this._onClose(()=>callback === null || callback === void 0 ? void 0 : callback($281a441cdcb2cf36$var$REALTIME_SUBSCRIBE_STATES.CLOSED));
            this.updateJoinPayload(Object.assign({
                config: config
            }, accessTokenPayload));
            this._updateFilterMessage();
            this.channelAdapter.subscribe(timeout).receive("ok", async ({ postgres_changes: postgres_changes2 })=>{
                if (!this.socket._isManualToken()) this.socket.setAuth();
                if (postgres_changes2 === void 0) {
                    callback === null || callback === void 0 || callback($281a441cdcb2cf36$var$REALTIME_SUBSCRIBE_STATES.SUBSCRIBED);
                    return;
                }
                this._updatePostgresBindings(postgres_changes2, callback);
            }).receive("error", (error)=>{
                this.state = $281a441cdcb2cf36$var$CHANNEL_STATES.errored;
                const message = Object.values(error).join(", ") || "error";
                callback === null || callback === void 0 || callback($281a441cdcb2cf36$var$REALTIME_SUBSCRIBE_STATES.CHANNEL_ERROR, new Error(message, {
                    cause: error
                }));
            }).receive("timeout", ()=>{
                callback === null || callback === void 0 || callback($281a441cdcb2cf36$var$REALTIME_SUBSCRIBE_STATES.TIMED_OUT);
            });
        }
        return this;
    }
    _updatePostgresBindings(postgres_changes, callback) {
        var _a2;
        const clientPostgresBindings = this.bindings.postgres_changes;
        const bindingsLen = (_a2 = clientPostgresBindings === null || clientPostgresBindings === void 0 ? void 0 : clientPostgresBindings.length) !== null && _a2 !== void 0 ? _a2 : 0;
        const newPostgresBindings = [];
        for(let i3 = 0; i3 < bindingsLen; i3++){
            const clientPostgresBinding = clientPostgresBindings[i3];
            const { filter: { event: event, schema: schema, table: table, filter: filter } } = clientPostgresBinding;
            const serverPostgresFilter = postgres_changes && postgres_changes[i3];
            if (serverPostgresFilter && serverPostgresFilter.event === event && _RealtimeChannel.isFilterValueEqual(serverPostgresFilter.schema, schema) && _RealtimeChannel.isFilterValueEqual(serverPostgresFilter.table, table) && _RealtimeChannel.isFilterValueEqual(serverPostgresFilter.filter, filter)) newPostgresBindings.push(Object.assign(Object.assign({}, clientPostgresBinding), {
                id: serverPostgresFilter.id
            }));
            else {
                this.unsubscribe();
                this.state = $281a441cdcb2cf36$var$CHANNEL_STATES.errored;
                callback === null || callback === void 0 || callback($281a441cdcb2cf36$var$REALTIME_SUBSCRIBE_STATES.CHANNEL_ERROR, new Error("mismatch between server and client bindings for postgres changes"));
                return;
            }
        }
        this.bindings.postgres_changes = newPostgresBindings;
        if (this.state != $281a441cdcb2cf36$var$CHANNEL_STATES.errored && callback) callback($281a441cdcb2cf36$var$REALTIME_SUBSCRIBE_STATES.SUBSCRIBED);
    }
    /**
   * Returns the current presence state for this channel.
   *
   * The shape is a map keyed by presence key (for example a user id) where each entry contains the
   * tracked metadata for that user.
   *
   * @category Realtime
   */ presenceState() {
        return this.presence.state;
    }
    /**
   * Sends the supplied payload to the presence tracker so other subscribers can see that this
   * client is online. Use `untrack` to stop broadcasting presence for the same key.
   *
   * @category Realtime
   */ async track(payload, opts = {}) {
        return await this.send({
            type: "presence",
            event: "track",
            payload: payload
        }, opts.timeout || this.timeout);
    }
    /**
   * Removes the current presence state for this client.
   *
   * @category Realtime
   */ async untrack(opts = {}) {
        return await this.send({
            type: "presence",
            event: "untrack"
        }, opts);
    }
    /**
   * Listen to realtime events on this channel.
   * @category Realtime
   *
   * @remarks
   * - By default, Broadcast and Presence are enabled for all projects.
   * - By default, listening to database changes is disabled for new projects due to database performance and security concerns. You can turn it on by managing Realtime's [replication](/docs/guides/api#realtime-api-overview).
   * - You can receive the "previous" data for updates and deletes by setting the table's `REPLICA IDENTITY` to `FULL` (e.g., `ALTER TABLE your_table REPLICA IDENTITY FULL;`).
   * - Row level security is not applied to delete statements. When RLS is enabled and replica identity is set to full, only the primary key is sent to clients.
   *
   * @example Listen to broadcast messages
   * ```js
   * const channel = supabase.channel("room1")
   *
   * channel.on("broadcast", { event: "cursor-pos" }, (payload) => {
   *   console.log("Cursor position received!", payload);
   * }).subscribe((status) => {
   *   if (status === "SUBSCRIBED") {
   *     channel.send({
   *       type: "broadcast",
   *       event: "cursor-pos",
   *       payload: { x: Math.random(), y: Math.random() },
   *     });
   *   }
   * });
   * ```
   *
   * @example Listen to presence sync
   * ```js
   * const channel = supabase.channel('room1')
   * channel
   *   .on('presence', { event: 'sync' }, () => {
   *     console.log('Synced presence state: ', channel.presenceState())
   *   })
   *   .subscribe(async (status) => {
   *     if (status === 'SUBSCRIBED') {
   *       await channel.track({ online_at: new Date().toISOString() })
   *     }
   *   })
   * ```
   *
   * @example Listen to presence join
   * ```js
   * const channel = supabase.channel('room1')
   * channel
   *   .on('presence', { event: 'join' }, ({ newPresences }) => {
   *     console.log('Newly joined presences: ', newPresences)
   *   })
   *   .subscribe(async (status) => {
   *     if (status === 'SUBSCRIBED') {
   *       await channel.track({ online_at: new Date().toISOString() })
   *     }
   *   })
   * ```
   *
   * @example Listen to presence leave
   * ```js
   * const channel = supabase.channel('room1')
   * channel
   *   .on('presence', { event: 'leave' }, ({ leftPresences }) => {
   *     console.log('Newly left presences: ', leftPresences)
   *   })
   *   .subscribe(async (status) => {
   *     if (status === 'SUBSCRIBED') {
   *       await channel.track({ online_at: new Date().toISOString() })
   *       await channel.untrack()
   *     }
   *   })
   * ```
   *
   * @example Listen to all database changes
   * ```js
   * supabase
   *   .channel('room1')
   *   .on('postgres_changes', { event: '*', schema: '*' }, payload => {
   *     console.log('Change received!', payload)
   *   })
   *   .subscribe()
   * ```
   *
   * @example Listen to a specific table
   * ```js
   * supabase
   *   .channel('room1')
   *   .on('postgres_changes', { event: '*', schema: 'public', table: 'countries' }, payload => {
   *     console.log('Change received!', payload)
   *   })
   *   .subscribe()
   * ```
   *
   * @example Listen to inserts
   * ```js
   * supabase
   *   .channel('room1')
   *   .on('postgres_changes', { event: 'INSERT', schema: 'public', table: 'countries' }, payload => {
   *     console.log('Change received!', payload)
   *   })
   *   .subscribe()
   * ```
   *
   * @exampleDescription Listen to updates
   * By default, Supabase will send only the updated record. If you want to receive the previous values as well you can
   * enable full replication for the table you are listening to:
   *
   * ```sql
   * alter table "your_table" replica identity full;
   * ```
   *
   * @example Listen to updates
   * ```js
   * supabase
   *   .channel('room1')
   *   .on('postgres_changes', { event: 'UPDATE', schema: 'public', table: 'countries' }, payload => {
   *     console.log('Change received!', payload)
   *   })
   *   .subscribe()
   * ```
   *
   * @exampleDescription Listen to deletes
   * By default, Supabase does not send deleted records. If you want to receive the deleted record you can
   * enable full replication for the table you are listening to:
   *
   * ```sql
   * alter table "your_table" replica identity full;
   * ```
   *
   * @example Listen to deletes
   * ```js
   * supabase
   *   .channel('room1')
   *   .on('postgres_changes', { event: 'DELETE', schema: 'public', table: 'countries' }, payload => {
   *     console.log('Change received!', payload)
   *   })
   *   .subscribe()
   * ```
   *
   * @exampleDescription Listen to multiple events
   * You can chain listeners if you want to listen to multiple events for each table.
   *
   * @example Listen to multiple events
   * ```js
   * supabase
   *   .channel('room1')
   *   .on('postgres_changes', { event: 'INSERT', schema: 'public', table: 'countries' }, handleRecordInserted)
   *   .on('postgres_changes', { event: 'DELETE', schema: 'public', table: 'countries' }, handleRecordDeleted)
   *   .subscribe()
   * ```
   *
   * @exampleDescription Listen to row level changes
   * You can listen to individual rows using the format `{table}:{col}=eq.{val}` - where `{col}` is the column name, and `{val}` is the value which you want to match.
   *
   * @example Listen to row level changes
   * ```js
   * supabase
   *   .channel('room1')
   *   .on('postgres_changes', { event: 'UPDATE', schema: 'public', table: 'countries', filter: 'id=eq.200' }, handleRecordUpdated)
   *   .subscribe()
   * ```
   */ on(type, filter, callback) {
        const stateCheck = this.channelAdapter.isJoined() || this.channelAdapter.isJoining();
        const typeCheck = type === $281a441cdcb2cf36$var$REALTIME_LISTEN_TYPES.PRESENCE || type === $281a441cdcb2cf36$var$REALTIME_LISTEN_TYPES.POSTGRES_CHANGES;
        if (stateCheck && typeCheck) {
            this.socket.log("channel", `cannot add \`${type}\` callbacks for ${this.topic} after \`subscribe()\`.`);
            throw new Error(`cannot add \`${type}\` callbacks for ${this.topic} after \`subscribe()\`.`);
        }
        return this._on(type, filter, callback);
    }
    /**
   * Sends a broadcast message explicitly via REST API.
   *
   * This method always uses the REST API endpoint regardless of WebSocket connection state.
   * Useful when you want to guarantee REST delivery or when gradually migrating from implicit REST fallback.
   *
   * @param event The name of the broadcast event
   * @param payload Payload to be sent (required)
   * @param opts Options including timeout
   * @returns Promise resolving to object with success status, and error details if failed
   *
   * @category Realtime
   */ async httpSend(event, payload, opts = {}) {
        var _a2;
        if (payload === void 0 || payload === null) return Promise.reject(new Error("Payload is required for httpSend()"));
        const headers = {
            apikey: this.socket.apiKey ? this.socket.apiKey : "",
            "Content-Type": "application/json"
        };
        if (this.socket.accessTokenValue) headers["Authorization"] = `Bearer ${this.socket.accessTokenValue}`;
        const options = {
            method: "POST",
            headers: headers,
            body: JSON.stringify({
                messages: [
                    {
                        topic: this.subTopic,
                        event: event,
                        payload: payload,
                        private: this.private
                    }
                ]
            })
        };
        const response = await this._fetchWithTimeout(this.broadcastEndpointURL, options, (_a2 = opts.timeout) !== null && _a2 !== void 0 ? _a2 : this.timeout);
        if (response.status === 202) return {
            success: true
        };
        let errorMessage = response.statusText;
        try {
            const errorBody = await response.json();
            errorMessage = errorBody.error || errorBody.message || errorMessage;
        } catch (_b) {}
        return Promise.reject(new Error(errorMessage));
    }
    /**
   * Sends a message into the channel.
   *
   * @param args Arguments to send to channel
   * @param args.type The type of event to send
   * @param args.event The name of the event being sent
   * @param args.payload Payload to be sent
   * @param opts Options to be used during the send process
   *
   * @category Realtime
   *
   * @remarks
   * - When using REST you don't need to subscribe to the channel
   * - REST calls are only available from 2.37.0 onwards
   *
   * @example Send a message via websocket
   * ```js
   * const channel = supabase.channel('room1')
   *
   * channel.subscribe((status) => {
   *   if (status === 'SUBSCRIBED') {
   *     channel.send({
   *       type: 'broadcast',
   *       event: 'cursor-pos',
   *       payload: { x: Math.random(), y: Math.random() },
   *     })
   *   }
   * })
   * ```
   *
   * @exampleResponse Send a message via websocket
   * ```js
   * ok | timed out | error
   * ```
   *
   * @example Send a message via REST
   * ```js
   * supabase
   *   .channel('room1')
   *   .httpSend('cursor-pos', { x: Math.random(), y: Math.random() })
   * ```
   */ async send(args2, opts = {}) {
        var _a2, _b;
        if (!this.channelAdapter.canPush() && args2.type === "broadcast") {
            console.warn("Realtime send() is automatically falling back to REST API. This behavior will be deprecated in the future. Please use httpSend() explicitly for REST delivery.");
            const { event: event, payload: endpoint_payload } = args2;
            const headers = {
                apikey: this.socket.apiKey ? this.socket.apiKey : "",
                "Content-Type": "application/json"
            };
            if (this.socket.accessTokenValue) headers["Authorization"] = `Bearer ${this.socket.accessTokenValue}`;
            const options = {
                method: "POST",
                headers: headers,
                body: JSON.stringify({
                    messages: [
                        {
                            topic: this.subTopic,
                            event: event,
                            payload: endpoint_payload,
                            private: this.private
                        }
                    ]
                })
            };
            try {
                const response = await this._fetchWithTimeout(this.broadcastEndpointURL, options, (_a2 = opts.timeout) !== null && _a2 !== void 0 ? _a2 : this.timeout);
                await ((_b = response.body) === null || _b === void 0 ? void 0 : _b.cancel());
                return response.ok ? "ok" : "error";
            } catch (error) {
                if (error.name === "AbortError") return "timed out";
                else return "error";
            }
        } else return new Promise((resolve)=>{
            var _a3, _b2, _c;
            const push = this.channelAdapter.push(args2.type, args2, opts.timeout || this.timeout);
            if (args2.type === "broadcast" && !((_c = (_b2 = (_a3 = this.params) === null || _a3 === void 0 ? void 0 : _a3.config) === null || _b2 === void 0 ? void 0 : _b2.broadcast) === null || _c === void 0 ? void 0 : _c.ack)) resolve("ok");
            push.receive("ok", ()=>resolve("ok"));
            push.receive("error", ()=>resolve("error"));
            push.receive("timeout", ()=>resolve("timed out"));
        });
    }
    /**
   * Updates the payload that will be sent the next time the channel joins (reconnects).
   * Useful for rotating access tokens or updating config without re-creating the channel.
   *
   * @category Realtime
   */ updateJoinPayload(payload) {
        this.channelAdapter.updateJoinPayload(payload);
    }
    /**
   * Leaves the channel.
   *
   * Unsubscribes from server events, and instructs channel to terminate on server.
   * Triggers onClose() hooks.
   *
   * To receive leave acknowledgements, use the a `receive` hook to bind to the server ack, ie:
   * channel.unsubscribe().receive("ok", () => alert("left!") )
   *
   * @category Realtime
   */ async unsubscribe(timeout = this.timeout) {
        return new Promise((resolve)=>{
            this.channelAdapter.unsubscribe(timeout).receive("ok", ()=>resolve("ok")).receive("timeout", ()=>resolve("timed out")).receive("error", ()=>resolve("error"));
        });
    }
    /**
   * Destroys and stops related timers.
   *
   * @category Realtime
   */ teardown() {
        this.channelAdapter.teardown();
    }
    /** @internal */ async _fetchWithTimeout(url2, options, timeout) {
        const controller = new AbortController();
        const id2 = setTimeout(()=>controller.abort(), timeout);
        const response = await this.socket.fetch(url2, Object.assign(Object.assign({}, options), {
            signal: controller.signal
        }));
        clearTimeout(id2);
        return response;
    }
    /** @internal */ _on(type, filter, callback) {
        const typeLower = type.toLocaleLowerCase();
        const ref2 = this.channelAdapter.on(type, callback);
        const binding = {
            type: typeLower,
            filter: filter,
            callback: callback,
            ref: ref2
        };
        if (this.bindings[typeLower]) this.bindings[typeLower].push(binding);
        else this.bindings[typeLower] = [
            binding
        ];
        this._updateFilterMessage();
        return this;
    }
    /**
   * Registers a callback that will be executed when the channel closes.
   *
   * @internal
   */ _onClose(callback) {
        this.channelAdapter.onClose(callback);
    }
    /**
   * Registers a callback that will be executed when the channel encounteres an error.
   *
   * @internal
   */ _onError(callback) {
        this.channelAdapter.onError(callback);
    }
    /** @internal */ _updateFilterMessage() {
        this.channelAdapter.updateFilterBindings((binding, payload, ref2)=>{
            var _a2, _b, _c, _d, _e, _f, _g;
            const typeLower = binding.event.toLocaleLowerCase();
            if (this._notThisChannelEvent(typeLower, ref2)) return false;
            const bind = (_a2 = this.bindings[typeLower]) === null || _a2 === void 0 ? void 0 : _a2.find((bind2)=>bind2.ref === binding.ref);
            if (!bind) return true;
            if ([
                "broadcast",
                "presence",
                "postgres_changes"
            ].includes(typeLower)) {
                if ("id" in bind) {
                    const bindId = bind.id;
                    const bindEvent = (_b = bind.filter) === null || _b === void 0 ? void 0 : _b.event;
                    return bindId && ((_c = payload.ids) === null || _c === void 0 ? void 0 : _c.includes(bindId)) && (bindEvent === "*" || (bindEvent === null || bindEvent === void 0 ? void 0 : bindEvent.toLocaleLowerCase()) === ((_d = payload.data) === null || _d === void 0 ? void 0 : _d.type.toLocaleLowerCase()));
                } else {
                    const bindEvent = (_f = (_e = bind === null || bind === void 0 ? void 0 : bind.filter) === null || _e === void 0 ? void 0 : _e.event) === null || _f === void 0 ? void 0 : _f.toLocaleLowerCase();
                    return bindEvent === "*" || bindEvent === ((_g = payload === null || payload === void 0 ? void 0 : payload.event) === null || _g === void 0 ? void 0 : _g.toLocaleLowerCase());
                }
            } else return bind.type.toLocaleLowerCase() === typeLower;
        });
    }
    /** @internal */ _notThisChannelEvent(event, ref2) {
        const { close: close, error: error, leave: leave, join: join } = $281a441cdcb2cf36$var$CHANNEL_EVENTS;
        const events = [
            close,
            error,
            leave,
            join
        ];
        return ref2 && events.includes(event) && ref2 !== this.joinPush.ref;
    }
    /** @internal */ _updateFilterTransform() {
        this.channelAdapter.updatePayloadTransform((event, payload, ref2)=>{
            if (typeof payload === "object" && "ids" in payload) {
                const postgresChanges = payload.data;
                const { schema: schema, table: table, commit_timestamp: commit_timestamp, type: type, errors: errors } = postgresChanges;
                const enrichedPayload = {
                    schema: schema,
                    table: table,
                    commit_timestamp: commit_timestamp,
                    eventType: type,
                    new: {},
                    old: {},
                    errors: errors
                };
                return Object.assign(Object.assign({}, enrichedPayload), this._getPayloadRecords(postgresChanges));
            }
            return payload;
        });
    }
    copyBindings(other) {
        if (this.joinedOnce) throw new Error("cannot copy bindings into joined channel");
        for(const kind in other.bindings)for (const binding of other.bindings[kind])this._on(binding.type, binding.filter, binding.callback);
    }
    /**
   * Compares two optional filter values for equality.
   * Treats undefined, null, and empty string as equivalent empty values.
   * @internal
   */ static isFilterValueEqual(serverValue, clientValue) {
        const normalizedServer = serverValue !== null && serverValue !== void 0 ? serverValue : void 0;
        const normalizedClient = clientValue !== null && clientValue !== void 0 ? clientValue : void 0;
        return normalizedServer === normalizedClient;
    }
    /** @internal */ _getPayloadRecords(payload) {
        const records = {
            new: {},
            old: {}
        };
        if (payload.type === "INSERT" || payload.type === "UPDATE") records.new = $281a441cdcb2cf36$var$convertChangeData(payload.columns, payload.record);
        if (payload.type === "UPDATE" || payload.type === "DELETE") records.old = $281a441cdcb2cf36$var$convertChangeData(payload.columns, payload.old_record);
        return records;
    }
};
// ../node_modules/@supabase/realtime-js/dist/module/phoenix/socketAdapter.js
var $281a441cdcb2cf36$var$SocketAdapter = class {
    constructor(endPoint, options){
        this.socket = new $281a441cdcb2cf36$var$Socket3(endPoint, options);
    }
    get timeout() {
        return this.socket.timeout;
    }
    get endPoint() {
        return this.socket.endPoint;
    }
    get transport() {
        return this.socket.transport;
    }
    get heartbeatIntervalMs() {
        return this.socket.heartbeatIntervalMs;
    }
    get heartbeatCallback() {
        return this.socket.heartbeatCallback;
    }
    set heartbeatCallback(callback) {
        this.socket.heartbeatCallback = callback;
    }
    get heartbeatTimer() {
        return this.socket.heartbeatTimer;
    }
    get pendingHeartbeatRef() {
        return this.socket.pendingHeartbeatRef;
    }
    get reconnectTimer() {
        return this.socket.reconnectTimer;
    }
    get vsn() {
        return this.socket.vsn;
    }
    get encode() {
        return this.socket.encode;
    }
    get decode() {
        return this.socket.decode;
    }
    get reconnectAfterMs() {
        return this.socket.reconnectAfterMs;
    }
    get sendBuffer() {
        return this.socket.sendBuffer;
    }
    get stateChangeCallbacks() {
        return this.socket.stateChangeCallbacks;
    }
    connect() {
        this.socket.connect();
    }
    disconnect(callback, code, reason, timeout = 1e4) {
        return new Promise((resolve)=>{
            setTimeout(()=>resolve("timeout"), timeout);
            this.socket.disconnect(()=>{
                callback();
                resolve("ok");
            }, code, reason);
        });
    }
    push(data2) {
        this.socket.push(data2);
    }
    log(kind, msg, data2) {
        this.socket.log(kind, msg, data2);
    }
    makeRef() {
        return this.socket.makeRef();
    }
    onOpen(callback) {
        this.socket.onOpen(callback);
    }
    onClose(callback) {
        this.socket.onClose(callback);
    }
    onError(callback) {
        this.socket.onError(callback);
    }
    onMessage(callback) {
        this.socket.onMessage(callback);
    }
    isConnected() {
        return this.socket.isConnected();
    }
    isConnecting() {
        return this.socket.connectionState() == $281a441cdcb2cf36$var$CONNECTION_STATE.connecting;
    }
    isDisconnecting() {
        return this.socket.connectionState() == $281a441cdcb2cf36$var$CONNECTION_STATE.closing;
    }
    connectionState() {
        return this.socket.connectionState();
    }
    endPointURL() {
        return this.socket.endPointURL();
    }
    sendHeartbeat() {
        this.socket.sendHeartbeat();
    }
    /**
   * @internal
   */ getSocket() {
        return this.socket;
    }
};
// ../node_modules/@supabase/realtime-js/dist/module/RealtimeClient.js
var $281a441cdcb2cf36$var$CONNECTION_TIMEOUTS = {
    HEARTBEAT_INTERVAL: 25e3,
    RECONNECT_DELAY: 10,
    HEARTBEAT_TIMEOUT_FALLBACK: 100
};
var $281a441cdcb2cf36$var$RECONNECT_INTERVALS = [
    1e3,
    2e3,
    5e3,
    1e4
];
var $281a441cdcb2cf36$var$DEFAULT_RECONNECT_FALLBACK = 1e4;
var $281a441cdcb2cf36$var$WORKER_SCRIPT = `
  addEventListener("message", (e) => {
    if (e.data.event === "start") {
      setInterval(() => postMessage({ event: "keepAlive" }), e.data.interval);
    }
  });`;
var $281a441cdcb2cf36$var$RealtimeClient = class {
    get endPoint() {
        return this.socketAdapter.endPoint;
    }
    get timeout() {
        return this.socketAdapter.timeout;
    }
    get transport() {
        return this.socketAdapter.transport;
    }
    get heartbeatCallback() {
        return this.socketAdapter.heartbeatCallback;
    }
    get heartbeatIntervalMs() {
        return this.socketAdapter.heartbeatIntervalMs;
    }
    get heartbeatTimer() {
        if (this.worker) return this._workerHeartbeatTimer;
        return this.socketAdapter.heartbeatTimer;
    }
    get pendingHeartbeatRef() {
        if (this.worker) return this._pendingWorkerHeartbeatRef;
        return this.socketAdapter.pendingHeartbeatRef;
    }
    get reconnectTimer() {
        return this.socketAdapter.reconnectTimer;
    }
    get vsn() {
        return this.socketAdapter.vsn;
    }
    get encode() {
        return this.socketAdapter.encode;
    }
    get decode() {
        return this.socketAdapter.decode;
    }
    get reconnectAfterMs() {
        return this.socketAdapter.reconnectAfterMs;
    }
    get sendBuffer() {
        return this.socketAdapter.sendBuffer;
    }
    get stateChangeCallbacks() {
        return this.socketAdapter.stateChangeCallbacks;
    }
    /**
   * Initializes the Socket.
   *
   * @param endPoint The string WebSocket endpoint, ie, "ws://example.com/socket", "wss://example.com", "/socket" (inherited host & protocol)
   * @param httpEndpoint The string HTTP endpoint, ie, "https://example.com", "/" (inherited host & protocol)
   * @param options.transport The Websocket Transport, for example WebSocket. This can be a custom implementation
   * @param options.timeout The default timeout in milliseconds to trigger push timeouts.
   * @param options.params The optional params to pass when connecting.
   * @param options.headers Deprecated: headers cannot be set on websocket connections and this option will be removed in the future.
   * @param options.heartbeatIntervalMs The millisec interval to send a heartbeat message.
   * @param options.heartbeatCallback The optional function to handle heartbeat status and latency.
   * @param options.logger The optional function for specialized logging, ie: logger: (kind, msg, data) => { console.log(`${kind}: ${msg}`, data) }
   * @param options.logLevel Sets the log level for Realtime
   * @param options.encode The function to encode outgoing messages. Defaults to JSON: (payload, callback) => callback(JSON.stringify(payload))
   * @param options.decode The function to decode incoming messages. Defaults to Serializer's decode.
   * @param options.reconnectAfterMs he optional function that returns the millsec reconnect interval. Defaults to stepped backoff off.
   * @param options.worker Use Web Worker to set a side flow. Defaults to false.
   * @param options.workerUrl The URL of the worker script. Defaults to https://realtime.supabase.com/worker.js that includes a heartbeat event call to keep the connection alive.
   * @param options.vsn The protocol version to use when connecting. Supported versions are "1.0.0" and "2.0.0". Defaults to "2.0.0".
   *
   * @category Realtime
   *
   * @example Using supabase-js (recommended)
   * ```ts
   * import { createClient } from '@supabase/supabase-js'
   *
   * const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
   * const channel = supabase.channel('room1')
   * channel
   *   .on('broadcast', { event: 'cursor-pos' }, (payload) => console.log(payload))
   *   .subscribe()
   * ```
   *
   * @example Standalone import for bundle-sensitive environments
   * ```ts
   * import RealtimeClient from '@supabase/realtime-js'
   *
   * const client = new RealtimeClient('https://xyzcompany.supabase.co/realtime/v1', {
   *   params: { apikey: 'your-publishable-key' },
   * })
   * client.connect()
   * ```
   */ constructor(endPoint, options){
        var _a2;
        this.channels = new Array();
        this.accessTokenValue = null;
        this.accessToken = null;
        this.apiKey = null;
        this.httpEndpoint = "";
        this.headers = {};
        this.params = {};
        this.ref = 0;
        this.serializer = new $281a441cdcb2cf36$var$Serializer();
        this._manuallySetToken = false;
        this._authPromise = null;
        this._workerHeartbeatTimer = void 0;
        this._pendingWorkerHeartbeatRef = null;
        this._pendingDisconnectTimer = null;
        this._disconnectOnEmptyChannelsAfterMs = 0;
        this._resolveFetch = (customFetch)=>{
            if (customFetch) return (...args2)=>customFetch(...args2);
            return (...args2)=>fetch(...args2);
        };
        if (!((_a2 = options === null || options === void 0 ? void 0 : options.params) === null || _a2 === void 0 ? void 0 : _a2.apikey)) throw new Error("API key is required to connect to Realtime");
        this.apiKey = options.params.apikey;
        const socketAdapterOptions = this._initializeOptions(options);
        this.socketAdapter = new $281a441cdcb2cf36$var$SocketAdapter(endPoint, socketAdapterOptions);
        this.httpEndpoint = $281a441cdcb2cf36$var$httpEndpointURL(endPoint);
        this.fetch = this._resolveFetch(options === null || options === void 0 ? void 0 : options.fetch);
    }
    /**
   * Connects the socket, unless already connected.
   *
   * @category Realtime
   */ connect() {
        if (this.isConnecting() || this.isDisconnecting() || this.isConnected()) return;
        if (this.accessToken && !this._authPromise) this._setAuthSafely("connect");
        this._setupConnectionHandlers();
        try {
            this.socketAdapter.connect();
        } catch (error) {
            const errorMessage = error.message;
            if (errorMessage.includes("Node.js")) throw new Error(`${errorMessage}

To use Realtime in Node.js, you need to provide a WebSocket implementation:

Option 1: Use Node.js 22+ which has native WebSocket support
Option 2: Install and provide the "ws" package:

  npm install ws

  import ws from "ws"
  const client = new RealtimeClient(url, {
    ...options,
    transport: ws
  })`);
            throw new Error(`WebSocket not available: ${errorMessage}`);
        }
        this._handleNodeJsRaceCondition();
    }
    /**
   * Returns the URL of the websocket.
   * @returns string The URL of the websocket.
   *
   * @category Realtime
   */ endpointURL() {
        return this.socketAdapter.endPointURL();
    }
    /**
   * Disconnects the socket.
   *
   * @param code A numeric status code to send on disconnect.
   * @param reason A custom reason for the disconnect.
   *
   * @category Realtime
   */ async disconnect(code, reason) {
        this._cancelPendingDisconnect();
        if (this.isDisconnecting()) return "ok";
        return await this.socketAdapter.disconnect(()=>{
            clearInterval(this._workerHeartbeatTimer);
            this._terminateWorker();
        }, code, reason);
    }
    /**
   * Returns all created channels
   *
   * @category Realtime
   */ getChannels() {
        return this.channels;
    }
    /**
   * Unsubscribes, removes and tears down a single channel
   * @param channel A RealtimeChannel instance
   *
   * @category Realtime
   */ async removeChannel(channel) {
        const status = await channel.unsubscribe();
        if (status === "ok") channel.teardown();
        return status;
    }
    /**
   * Unsubscribes, removes and tears down all channels
   *
   * @category Realtime
   */ async removeAllChannels() {
        const promises = this.channels.map(async (channel)=>{
            const result2 = await channel.unsubscribe();
            channel.teardown();
            return result2;
        });
        const result = await Promise.all(promises);
        await this.disconnect();
        return result;
    }
    /**
   * Logs the message.
   *
   * For customized logging, `this.logger` can be overridden in Client constructor.
   *
   * @category Realtime
   */ log(kind, msg, data2) {
        this.socketAdapter.log(kind, msg, data2);
    }
    /**
   * Returns the current state of the socket.
   *
   * @category Realtime
   */ connectionState() {
        return this.socketAdapter.connectionState() || $281a441cdcb2cf36$var$CONNECTION_STATE.closed;
    }
    /**
   * Returns `true` is the connection is open.
   *
   * @category Realtime
   */ isConnected() {
        return this.socketAdapter.isConnected();
    }
    /**
   * Returns `true` if the connection is currently connecting.
   *
   * @category Realtime
   */ isConnecting() {
        return this.socketAdapter.isConnecting();
    }
    /**
   * Returns `true` if the connection is currently disconnecting.
   *
   * @category Realtime
   */ isDisconnecting() {
        return this.socketAdapter.isDisconnecting();
    }
    /**
   * Creates (or reuses) a {@link RealtimeChannel} for the provided topic.
   *
   * Topics are automatically prefixed with `realtime:` to match the Realtime service.
   * If a channel with the same topic already exists it will be returned instead of creating
   * a duplicate connection.
   *
   * @category Realtime
   */ channel(topic, params2 = {
        config: {}
    }) {
        const realtimeTopic = `realtime:${topic}`;
        const exists = this.getChannels().find((c3)=>c3.topic === realtimeTopic);
        if (!exists) {
            const chan = new $281a441cdcb2cf36$var$RealtimeChannel(`realtime:${topic}`, params2, this);
            this._cancelPendingDisconnect();
            this.channels.push(chan);
            return chan;
        } else return exists;
    }
    /**
   * Push out a message if the socket is connected.
   *
   * If the socket is not connected, the message gets enqueued within a local buffer, and sent out when a connection is next established.
   *
   * @category Realtime
   */ push(data2) {
        this.socketAdapter.push(data2);
    }
    /**
   * Sets the JWT access token used for channel subscription authorization and Realtime RLS.
   *
   * If param is null it will use the `accessToken` callback function or the token set on the client.
   *
   * On callback used, it will set the value of the token internal to the client.
   *
   * When a token is explicitly provided, it will be preserved across channel operations
   * (including removeChannel and resubscribe). The `accessToken` callback will not be
   * invoked until `setAuth()` is called without arguments.
   *
   * @param token A JWT string to override the token set on the client.
   *
   * @example Setting the authorization header
   * // Use a manual token (preserved across resubscribes, ignores accessToken callback)
   * client.realtime.setAuth('my-custom-jwt')
   *
   * // Switch back to using the accessToken callback
   * client.realtime.setAuth()
   *
   * @category Realtime
   */ async setAuth(token = null) {
        this._authPromise = this._performAuth(token);
        try {
            await this._authPromise;
        } finally{
            this._authPromise = null;
        }
    }
    /**
   * Returns true if the current access token was explicitly set via setAuth(token),
   * false if it was obtained via the accessToken callback.
   * @internal
   */ _isManualToken() {
        return this._manuallySetToken;
    }
    /**
   * Sends a heartbeat message if the socket is connected.
   *
   * @category Realtime
   */ async sendHeartbeat() {
        this.socketAdapter.sendHeartbeat();
    }
    /**
   * Sets a callback that receives lifecycle events for internal heartbeat messages.
   * Useful for instrumenting connection health (e.g. sent/ok/timeout/disconnected).
   *
   * @category Realtime
   */ onHeartbeat(callback) {
        this.socketAdapter.heartbeatCallback = this._wrapHeartbeatCallback(callback);
    }
    /**
   * Return the next message ref, accounting for overflows
   *
   * @internal
   */ _makeRef() {
        return this.socketAdapter.makeRef();
    }
    /**
   * Removes a channel from RealtimeClient
   *
   * @param channel An open subscription.
   *
   * @internal
   */ _remove(channel) {
        this.channels = this.channels.filter((c3)=>c3.topic !== channel.topic);
        if (this.channels.length === 0) {
            this.log("transport", "no channels remaining, scheduling disconnect");
            this._schedulePendingDisconnect();
        }
    }
    /** @internal */ _schedulePendingDisconnect() {
        this._cancelPendingDisconnect();
        if (this._disconnectOnEmptyChannelsAfterMs === 0) {
            this.log("transport", "disconnecting immediately - no channels");
            this.disconnect();
            return;
        }
        this._pendingDisconnectTimer = setTimeout(()=>{
            this._pendingDisconnectTimer = null;
            if (this.channels.length === 0) {
                this.log("transport", "deferred disconnect fired - no channels, disconnecting");
                this.disconnect();
            }
        }, this._disconnectOnEmptyChannelsAfterMs);
        this.log("transport", `deferred disconnect scheduled in ${this._disconnectOnEmptyChannelsAfterMs}ms`);
    }
    /** @internal */ _cancelPendingDisconnect() {
        if (this._pendingDisconnectTimer !== null) {
            this.log("transport", "pending disconnect cancelled - channel activity detected");
            clearTimeout(this._pendingDisconnectTimer);
            this._pendingDisconnectTimer = null;
        }
    }
    /**
   * Perform the actual auth operation
   * @internal
   */ async _performAuth(token = null) {
        let tokenToSend;
        let isManualToken = false;
        if (token) {
            tokenToSend = token;
            isManualToken = true;
        } else if (this.accessToken) try {
            tokenToSend = await this.accessToken();
        } catch (e4) {
            this.log("error", "Error fetching access token from callback", e4);
            tokenToSend = this.accessTokenValue;
        }
        else tokenToSend = this.accessTokenValue;
        if (isManualToken) this._manuallySetToken = true;
        else if (this.accessToken) this._manuallySetToken = false;
        if (this.accessTokenValue != tokenToSend) {
            this.accessTokenValue = tokenToSend;
            this.channels.forEach((channel)=>{
                const payload = {
                    access_token: tokenToSend,
                    version: $281a441cdcb2cf36$var$DEFAULT_VERSION
                };
                tokenToSend && channel.updateJoinPayload(payload);
                if (channel.joinedOnce && channel.channelAdapter.isJoined()) channel.channelAdapter.push($281a441cdcb2cf36$var$CHANNEL_EVENTS.access_token, {
                    access_token: tokenToSend
                });
            });
        }
    }
    /**
   * Wait for any in-flight auth operations to complete
   * @internal
   */ async _waitForAuthIfNeeded() {
        if (this._authPromise) await this._authPromise;
    }
    /**
   * Safely call setAuth with standardized error handling
   * @internal
   */ _setAuthSafely(context2 = "general") {
        if (!this._isManualToken()) this.setAuth().catch((e4)=>{
            this.log("error", `Error setting auth in ${context2}`, e4);
        });
    }
    /** @internal */ _setupConnectionHandlers() {
        this.socketAdapter.onOpen(()=>{
            const authPromise = this._authPromise || (this.accessToken && !this.accessTokenValue ? this.setAuth() : Promise.resolve());
            authPromise.catch((e4)=>{
                this.log("error", "error waiting for auth on connect", e4);
            });
            if (this.worker && !this.workerRef) this._startWorkerHeartbeat();
        });
        this.socketAdapter.onClose(()=>{
            if (this.worker && this.workerRef) this._terminateWorker();
        });
        this.socketAdapter.onMessage((message)=>{
            if (message.ref && message.ref === this._pendingWorkerHeartbeatRef) this._pendingWorkerHeartbeatRef = null;
        });
    }
    /** @internal */ _handleNodeJsRaceCondition() {
        if (this.socketAdapter.isConnected()) this.socketAdapter.getSocket().onConnOpen();
    }
    /** @internal */ _wrapHeartbeatCallback(heartbeatCallback) {
        return (status, latency)=>{
            if (status == "sent") this._setAuthSafely();
            if (heartbeatCallback) heartbeatCallback(status, latency);
        };
    }
    /** @internal */ _startWorkerHeartbeat() {
        if (this.workerUrl) this.log("worker", `starting worker for from ${this.workerUrl}`);
        else this.log("worker", `starting default worker`);
        const objectUrl = this._workerObjectUrl(this.workerUrl);
        this.workerRef = new Worker(objectUrl);
        this.workerRef.onerror = (error)=>{
            this.log("worker", "worker error", error.message);
            this._terminateWorker();
            this.disconnect();
        };
        this.workerRef.onmessage = (event)=>{
            if (event.data.event === "keepAlive") this.sendHeartbeat();
        };
        this.workerRef.postMessage({
            event: "start",
            interval: this.heartbeatIntervalMs
        });
    }
    /**
   * Terminate the Web Worker and clear the reference
   * @internal
   */ _terminateWorker() {
        if (this.workerRef) {
            this.log("worker", "terminating worker");
            this.workerRef.terminate();
            this.workerRef = void 0;
        }
    }
    /** @internal */ _workerObjectUrl(url2) {
        let result_url;
        if (url2) result_url = url2;
        else {
            const blob = new Blob([
                $281a441cdcb2cf36$var$WORKER_SCRIPT
            ], {
                type: "application/javascript"
            });
            result_url = URL.createObjectURL(blob);
        }
        return result_url;
    }
    /**
   * Initialize socket options with defaults
   * @internal
   */ _initializeOptions(options) {
        var _a2, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        this.worker = (_a2 = options === null || options === void 0 ? void 0 : options.worker) !== null && _a2 !== void 0 ? _a2 : false;
        this.accessToken = (_b = options === null || options === void 0 ? void 0 : options.accessToken) !== null && _b !== void 0 ? _b : null;
        const result = {};
        result.timeout = (_c = options === null || options === void 0 ? void 0 : options.timeout) !== null && _c !== void 0 ? _c : $281a441cdcb2cf36$var$DEFAULT_TIMEOUT;
        result.heartbeatIntervalMs = (_d = options === null || options === void 0 ? void 0 : options.heartbeatIntervalMs) !== null && _d !== void 0 ? _d : $281a441cdcb2cf36$var$CONNECTION_TIMEOUTS.HEARTBEAT_INTERVAL;
        this._disconnectOnEmptyChannelsAfterMs = (_e = options === null || options === void 0 ? void 0 : options.disconnectOnEmptyChannelsAfterMs) !== null && _e !== void 0 ? _e : 2 * ((_f = options === null || options === void 0 ? void 0 : options.heartbeatIntervalMs) !== null && _f !== void 0 ? _f : $281a441cdcb2cf36$var$CONNECTION_TIMEOUTS.HEARTBEAT_INTERVAL);
        result.transport = (_g = options === null || options === void 0 ? void 0 : options.transport) !== null && _g !== void 0 ? _g : $281a441cdcb2cf36$var$websocket_factory_default.getWebSocketConstructor();
        result.params = options === null || options === void 0 ? void 0 : options.params;
        result.logger = options === null || options === void 0 ? void 0 : options.logger;
        result.heartbeatCallback = this._wrapHeartbeatCallback(options === null || options === void 0 ? void 0 : options.heartbeatCallback);
        result.reconnectAfterMs = (_h = options === null || options === void 0 ? void 0 : options.reconnectAfterMs) !== null && _h !== void 0 ? _h : (tries)=>{
            return $281a441cdcb2cf36$var$RECONNECT_INTERVALS[tries - 1] || $281a441cdcb2cf36$var$DEFAULT_RECONNECT_FALLBACK;
        };
        let defaultEncode;
        let defaultDecode;
        const vsn = (_j = options === null || options === void 0 ? void 0 : options.vsn) !== null && _j !== void 0 ? _j : $281a441cdcb2cf36$var$DEFAULT_VSN;
        switch(vsn){
            case $281a441cdcb2cf36$var$VSN_1_0_0:
                defaultEncode = (payload, callback)=>{
                    return callback(JSON.stringify(payload));
                };
                defaultDecode = (payload, callback)=>{
                    return callback(JSON.parse(payload));
                };
                break;
            case $281a441cdcb2cf36$var$VSN_2_0_0:
                defaultEncode = this.serializer.encode.bind(this.serializer);
                defaultDecode = this.serializer.decode.bind(this.serializer);
                break;
            default:
                throw new Error(`Unsupported serializer version: ${result.vsn}`);
        }
        result.vsn = vsn;
        result.encode = (_k = options === null || options === void 0 ? void 0 : options.encode) !== null && _k !== void 0 ? _k : defaultEncode;
        result.decode = (_l = options === null || options === void 0 ? void 0 : options.decode) !== null && _l !== void 0 ? _l : defaultDecode;
        result.beforeReconnect = this._reconnectAuth.bind(this);
        if ((options === null || options === void 0 ? void 0 : options.logLevel) || (options === null || options === void 0 ? void 0 : options.log_level)) {
            this.logLevel = options.logLevel || options.log_level;
            result.params = Object.assign(Object.assign({}, result.params), {
                log_level: this.logLevel
            });
        }
        if (this.worker) {
            if (typeof window !== "undefined" && !window.Worker) throw new Error("Web Worker is not supported");
            this.workerUrl = options === null || options === void 0 ? void 0 : options.workerUrl;
            result.autoSendHeartbeat = !this.worker;
        }
        return result;
    }
    /** @internal */ async _reconnectAuth() {
        await this._waitForAuthIfNeeded();
        if (!this.isConnected()) this.connect();
    }
};
// ../node_modules/iceberg-js/dist/index.mjs
var $281a441cdcb2cf36$var$IcebergError = class extends Error {
    constructor(message, opts){
        var _a2;
        super(message);
        this.name = "IcebergError";
        this.status = opts.status;
        this.icebergType = opts.icebergType;
        this.icebergCode = opts.icebergCode;
        this.details = opts.details;
        this.isCommitStateUnknown = opts.icebergType === "CommitStateUnknownException" || [
            500,
            502,
            504
        ].includes(opts.status) && ((_a2 = opts.icebergType) == null ? void 0 : _a2.includes("CommitState")) === true;
    }
    /**
   * Returns true if the error is a 404 Not Found error.
   */ isNotFound() {
        return this.status === 404;
    }
    /**
   * Returns true if the error is a 409 Conflict error.
   */ isConflict() {
        return this.status === 409;
    }
    /**
   * Returns true if the error is a 419 Authentication Timeout error.
   */ isAuthenticationTimeout() {
        return this.status === 419;
    }
};
function $281a441cdcb2cf36$var$buildUrl(baseUrl, path, query) {
    const url2 = new URL(path, baseUrl);
    if (query) {
        for (const [key, value2] of Object.entries(query))if (value2 !== void 0) url2.searchParams.set(key, value2);
    }
    return url2.toString();
}
async function $281a441cdcb2cf36$var$buildAuthHeaders(auth) {
    if (!auth || auth.type === "none") return {};
    if (auth.type === "bearer") return {
        Authorization: `Bearer ${auth.token}`
    };
    if (auth.type === "header") return {
        [auth.name]: auth.value
    };
    if (auth.type === "custom") return await auth.getHeaders();
    return {};
}
function $281a441cdcb2cf36$var$createFetchClient(options) {
    var _a2;
    const fetchFn = (_a2 = options.fetchImpl) != null ? _a2 : globalThis.fetch;
    return {
        async request ({ method: method, path: path, query: query, body: body, headers: headers }) {
            var _a3;
            const url2 = $281a441cdcb2cf36$var$buildUrl(options.baseUrl, path, query);
            const authHeaders = await $281a441cdcb2cf36$var$buildAuthHeaders(options.auth);
            const res = await fetchFn(url2, {
                method: method,
                headers: {
                    ...body ? {
                        "Content-Type": "application/json"
                    } : {},
                    ...authHeaders,
                    ...headers
                },
                body: body ? JSON.stringify(body) : void 0
            });
            const text2 = await res.text();
            const isJson = (res.headers.get("content-type") || "").includes("application/json");
            const data2 = isJson && text2 ? JSON.parse(text2) : text2;
            if (!res.ok) {
                const errBody = isJson ? data2 : void 0;
                const errorDetail = errBody == null ? void 0 : errBody.error;
                throw new $281a441cdcb2cf36$var$IcebergError((_a3 = errorDetail == null ? void 0 : errorDetail.message) != null ? _a3 : `Request failed with status ${res.status}`, {
                    status: res.status,
                    icebergType: errorDetail == null ? void 0 : errorDetail.type,
                    icebergCode: errorDetail == null ? void 0 : errorDetail.code,
                    details: errBody
                });
            }
            return {
                status: res.status,
                headers: res.headers,
                data: data2
            };
        }
    };
}
function $281a441cdcb2cf36$var$namespaceToPath(namespace) {
    return namespace.join("");
}
var $281a441cdcb2cf36$var$NamespaceOperations = class {
    constructor(client, prefix = ""){
        this.client = client;
        this.prefix = prefix;
    }
    async listNamespaces(parent) {
        const query = parent ? {
            parent: $281a441cdcb2cf36$var$namespaceToPath(parent.namespace)
        } : void 0;
        const response = await this.client.request({
            method: "GET",
            path: `${this.prefix}/namespaces`,
            query: query
        });
        return response.data.namespaces.map((ns)=>({
                namespace: ns
            }));
    }
    async createNamespace(id2, metadata) {
        const request = {
            namespace: id2.namespace,
            properties: metadata == null ? void 0 : metadata.properties
        };
        const response = await this.client.request({
            method: "POST",
            path: `${this.prefix}/namespaces`,
            body: request
        });
        return response.data;
    }
    async dropNamespace(id2) {
        await this.client.request({
            method: "DELETE",
            path: `${this.prefix}/namespaces/${$281a441cdcb2cf36$var$namespaceToPath(id2.namespace)}`
        });
    }
    async loadNamespaceMetadata(id2) {
        const response = await this.client.request({
            method: "GET",
            path: `${this.prefix}/namespaces/${$281a441cdcb2cf36$var$namespaceToPath(id2.namespace)}`
        });
        return {
            properties: response.data.properties
        };
    }
    async namespaceExists(id2) {
        try {
            await this.client.request({
                method: "HEAD",
                path: `${this.prefix}/namespaces/${$281a441cdcb2cf36$var$namespaceToPath(id2.namespace)}`
            });
            return true;
        } catch (error) {
            if (error instanceof $281a441cdcb2cf36$var$IcebergError && error.status === 404) return false;
            throw error;
        }
    }
    async createNamespaceIfNotExists(id2, metadata) {
        try {
            return await this.createNamespace(id2, metadata);
        } catch (error) {
            if (error instanceof $281a441cdcb2cf36$var$IcebergError && error.status === 409) return;
            throw error;
        }
    }
};
function $281a441cdcb2cf36$var$namespaceToPath2(namespace) {
    return namespace.join("");
}
var $281a441cdcb2cf36$var$TableOperations = class {
    constructor(client, prefix = "", accessDelegation){
        this.client = client;
        this.prefix = prefix;
        this.accessDelegation = accessDelegation;
    }
    async listTables(namespace) {
        const response = await this.client.request({
            method: "GET",
            path: `${this.prefix}/namespaces/${$281a441cdcb2cf36$var$namespaceToPath2(namespace.namespace)}/tables`
        });
        return response.data.identifiers;
    }
    async createTable(namespace, request) {
        const headers = {};
        if (this.accessDelegation) headers["X-Iceberg-Access-Delegation"] = this.accessDelegation;
        const response = await this.client.request({
            method: "POST",
            path: `${this.prefix}/namespaces/${$281a441cdcb2cf36$var$namespaceToPath2(namespace.namespace)}/tables`,
            body: request,
            headers: headers
        });
        return response.data.metadata;
    }
    async updateTable(id2, request) {
        const response = await this.client.request({
            method: "POST",
            path: `${this.prefix}/namespaces/${$281a441cdcb2cf36$var$namespaceToPath2(id2.namespace)}/tables/${id2.name}`,
            body: request
        });
        return {
            "metadata-location": response.data["metadata-location"],
            metadata: response.data.metadata
        };
    }
    async dropTable(id2, options) {
        var _a2;
        await this.client.request({
            method: "DELETE",
            path: `${this.prefix}/namespaces/${$281a441cdcb2cf36$var$namespaceToPath2(id2.namespace)}/tables/${id2.name}`,
            query: {
                purgeRequested: String((_a2 = options == null ? void 0 : options.purge) != null ? _a2 : false)
            }
        });
    }
    async loadTable(id2) {
        const headers = {};
        if (this.accessDelegation) headers["X-Iceberg-Access-Delegation"] = this.accessDelegation;
        const response = await this.client.request({
            method: "GET",
            path: `${this.prefix}/namespaces/${$281a441cdcb2cf36$var$namespaceToPath2(id2.namespace)}/tables/${id2.name}`,
            headers: headers
        });
        return response.data.metadata;
    }
    async tableExists(id2) {
        const headers = {};
        if (this.accessDelegation) headers["X-Iceberg-Access-Delegation"] = this.accessDelegation;
        try {
            await this.client.request({
                method: "HEAD",
                path: `${this.prefix}/namespaces/${$281a441cdcb2cf36$var$namespaceToPath2(id2.namespace)}/tables/${id2.name}`,
                headers: headers
            });
            return true;
        } catch (error) {
            if (error instanceof $281a441cdcb2cf36$var$IcebergError && error.status === 404) return false;
            throw error;
        }
    }
    async createTableIfNotExists(namespace, request) {
        try {
            return await this.createTable(namespace, request);
        } catch (error) {
            if (error instanceof $281a441cdcb2cf36$var$IcebergError && error.status === 409) return await this.loadTable({
                namespace: namespace.namespace,
                name: request.name
            });
            throw error;
        }
    }
};
var $281a441cdcb2cf36$var$IcebergRestCatalog = class {
    /**
   * Creates a new Iceberg REST Catalog client.
   *
   * @param options - Configuration options for the catalog client
   */ constructor(options){
        var _a2;
        let prefix = "v1";
        if (options.catalogName) prefix += `/${options.catalogName}`;
        const baseUrl = options.baseUrl.endsWith("/") ? options.baseUrl : `${options.baseUrl}/`;
        this.client = $281a441cdcb2cf36$var$createFetchClient({
            baseUrl: baseUrl,
            auth: options.auth,
            fetchImpl: options.fetch
        });
        this.accessDelegation = (_a2 = options.accessDelegation) == null ? void 0 : _a2.join(",");
        this.namespaceOps = new $281a441cdcb2cf36$var$NamespaceOperations(this.client, prefix);
        this.tableOps = new $281a441cdcb2cf36$var$TableOperations(this.client, prefix, this.accessDelegation);
    }
    /**
   * Lists all namespaces in the catalog.
   *
   * @param parent - Optional parent namespace to list children under
   * @returns Array of namespace identifiers
   *
   * @example
   * ```typescript
   * // List all top-level namespaces
   * const namespaces = await catalog.listNamespaces();
   *
   * // List namespaces under a parent
   * const children = await catalog.listNamespaces({ namespace: ['analytics'] });
   * ```
   */ async listNamespaces(parent) {
        return this.namespaceOps.listNamespaces(parent);
    }
    /**
   * Creates a new namespace in the catalog.
   *
   * @param id - Namespace identifier to create
   * @param metadata - Optional metadata properties for the namespace
   * @returns Response containing the created namespace and its properties
   *
   * @example
   * ```typescript
   * const response = await catalog.createNamespace(
   *   { namespace: ['analytics'] },
   *   { properties: { owner: 'data-team' } }
   * );
   * console.log(response.namespace); // ['analytics']
   * console.log(response.properties); // { owner: 'data-team', ... }
   * ```
   */ async createNamespace(id2, metadata) {
        return this.namespaceOps.createNamespace(id2, metadata);
    }
    /**
   * Drops a namespace from the catalog.
   *
   * The namespace must be empty (contain no tables) before it can be dropped.
   *
   * @param id - Namespace identifier to drop
   *
   * @example
   * ```typescript
   * await catalog.dropNamespace({ namespace: ['analytics'] });
   * ```
   */ async dropNamespace(id2) {
        await this.namespaceOps.dropNamespace(id2);
    }
    /**
   * Loads metadata for a namespace.
   *
   * @param id - Namespace identifier to load
   * @returns Namespace metadata including properties
   *
   * @example
   * ```typescript
   * const metadata = await catalog.loadNamespaceMetadata({ namespace: ['analytics'] });
   * console.log(metadata.properties);
   * ```
   */ async loadNamespaceMetadata(id2) {
        return this.namespaceOps.loadNamespaceMetadata(id2);
    }
    /**
   * Lists all tables in a namespace.
   *
   * @param namespace - Namespace identifier to list tables from
   * @returns Array of table identifiers
   *
   * @example
   * ```typescript
   * const tables = await catalog.listTables({ namespace: ['analytics'] });
   * console.log(tables); // [{ namespace: ['analytics'], name: 'events' }, ...]
   * ```
   */ async listTables(namespace) {
        return this.tableOps.listTables(namespace);
    }
    /**
   * Creates a new table in the catalog.
   *
   * @param namespace - Namespace to create the table in
   * @param request - Table creation request including name, schema, partition spec, etc.
   * @returns Table metadata for the created table
   *
   * @example
   * ```typescript
   * const metadata = await catalog.createTable(
   *   { namespace: ['analytics'] },
   *   {
   *     name: 'events',
   *     schema: {
   *       type: 'struct',
   *       fields: [
   *         { id: 1, name: 'id', type: 'long', required: true },
   *         { id: 2, name: 'timestamp', type: 'timestamp', required: true }
   *       ],
   *       'schema-id': 0
   *     },
   *     'partition-spec': {
   *       'spec-id': 0,
   *       fields: [
   *         { source_id: 2, field_id: 1000, name: 'ts_day', transform: 'day' }
   *       ]
   *     }
   *   }
   * );
   * ```
   */ async createTable(namespace, request) {
        return this.tableOps.createTable(namespace, request);
    }
    /**
   * Updates an existing table's metadata.
   *
   * Can update the schema, partition spec, or properties of a table.
   *
   * @param id - Table identifier to update
   * @param request - Update request with fields to modify
   * @returns Response containing the metadata location and updated table metadata
   *
   * @example
   * ```typescript
   * const response = await catalog.updateTable(
   *   { namespace: ['analytics'], name: 'events' },
   *   {
   *     properties: { 'read.split.target-size': '134217728' }
   *   }
   * );
   * console.log(response['metadata-location']); // s3://...
   * console.log(response.metadata); // TableMetadata object
   * ```
   */ async updateTable(id2, request) {
        return this.tableOps.updateTable(id2, request);
    }
    /**
   * Drops a table from the catalog.
   *
   * @param id - Table identifier to drop
   *
   * @example
   * ```typescript
   * await catalog.dropTable({ namespace: ['analytics'], name: 'events' });
   * ```
   */ async dropTable(id2, options) {
        await this.tableOps.dropTable(id2, options);
    }
    /**
   * Loads metadata for a table.
   *
   * @param id - Table identifier to load
   * @returns Table metadata including schema, partition spec, location, etc.
   *
   * @example
   * ```typescript
   * const metadata = await catalog.loadTable({ namespace: ['analytics'], name: 'events' });
   * console.log(metadata.schema);
   * console.log(metadata.location);
   * ```
   */ async loadTable(id2) {
        return this.tableOps.loadTable(id2);
    }
    /**
   * Checks if a namespace exists in the catalog.
   *
   * @param id - Namespace identifier to check
   * @returns True if the namespace exists, false otherwise
   *
   * @example
   * ```typescript
   * const exists = await catalog.namespaceExists({ namespace: ['analytics'] });
   * console.log(exists); // true or false
   * ```
   */ async namespaceExists(id2) {
        return this.namespaceOps.namespaceExists(id2);
    }
    /**
   * Checks if a table exists in the catalog.
   *
   * @param id - Table identifier to check
   * @returns True if the table exists, false otherwise
   *
   * @example
   * ```typescript
   * const exists = await catalog.tableExists({ namespace: ['analytics'], name: 'events' });
   * console.log(exists); // true or false
   * ```
   */ async tableExists(id2) {
        return this.tableOps.tableExists(id2);
    }
    /**
   * Creates a namespace if it does not exist.
   *
   * If the namespace already exists, returns void. If created, returns the response.
   *
   * @param id - Namespace identifier to create
   * @param metadata - Optional metadata properties for the namespace
   * @returns Response containing the created namespace and its properties, or void if it already exists
   *
   * @example
   * ```typescript
   * const response = await catalog.createNamespaceIfNotExists(
   *   { namespace: ['analytics'] },
   *   { properties: { owner: 'data-team' } }
   * );
   * if (response) {
   *   console.log('Created:', response.namespace);
   * } else {
   *   console.log('Already exists');
   * }
   * ```
   */ async createNamespaceIfNotExists(id2, metadata) {
        return this.namespaceOps.createNamespaceIfNotExists(id2, metadata);
    }
    /**
   * Creates a table if it does not exist.
   *
   * If the table already exists, returns its metadata instead.
   *
   * @param namespace - Namespace to create the table in
   * @param request - Table creation request including name, schema, partition spec, etc.
   * @returns Table metadata for the created or existing table
   *
   * @example
   * ```typescript
   * const metadata = await catalog.createTableIfNotExists(
   *   { namespace: ['analytics'] },
   *   {
   *     name: 'events',
   *     schema: {
   *       type: 'struct',
   *       fields: [
   *         { id: 1, name: 'id', type: 'long', required: true },
   *         { id: 2, name: 'timestamp', type: 'timestamp', required: true }
   *       ],
   *       'schema-id': 0
   *     }
   *   }
   * );
   * ```
   */ async createTableIfNotExists(namespace, request) {
        return this.tableOps.createTableIfNotExists(namespace, request);
    }
};
// ../node_modules/@supabase/storage-js/dist/index.mjs
function $281a441cdcb2cf36$var$_typeof2(o3) {
    "@babel/helpers - typeof";
    return $281a441cdcb2cf36$var$_typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o$1) {
        return typeof o$1;
    } : function(o$1) {
        return o$1 && "function" == typeof Symbol && o$1.constructor === Symbol && o$1 !== Symbol.prototype ? "symbol" : typeof o$1;
    }, $281a441cdcb2cf36$var$_typeof2(o3);
}
function $281a441cdcb2cf36$var$toPrimitive2(t4, r3) {
    if ("object" != $281a441cdcb2cf36$var$_typeof2(t4) || !t4) return t4;
    var e4 = t4[Symbol.toPrimitive];
    if (void 0 !== e4) {
        var i3 = e4.call(t4, r3 || "default");
        if ("object" != $281a441cdcb2cf36$var$_typeof2(i3)) return i3;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r3 ? String : Number)(t4);
}
function $281a441cdcb2cf36$var$toPropertyKey2(t4) {
    var i3 = $281a441cdcb2cf36$var$toPrimitive2(t4, "string");
    return "symbol" == $281a441cdcb2cf36$var$_typeof2(i3) ? i3 : i3 + "";
}
function $281a441cdcb2cf36$var$_defineProperty2(e4, r3, t4) {
    return (r3 = $281a441cdcb2cf36$var$toPropertyKey2(r3)) in e4 ? Object.defineProperty(e4, r3, {
        value: t4,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e4[r3] = t4, e4;
}
function $281a441cdcb2cf36$var$ownKeys2(e4, r3) {
    var t4 = Object.keys(e4);
    if (Object.getOwnPropertySymbols) {
        var o3 = Object.getOwnPropertySymbols(e4);
        r3 && (o3 = o3.filter(function(r$1) {
            return Object.getOwnPropertyDescriptor(e4, r$1).enumerable;
        })), t4.push.apply(t4, o3);
    }
    return t4;
}
function $281a441cdcb2cf36$var$_objectSpread22(e4) {
    for(var r3 = 1; r3 < arguments.length; r3++){
        var t4 = null != arguments[r3] ? arguments[r3] : {};
        r3 % 2 ? $281a441cdcb2cf36$var$ownKeys2(Object(t4), true).forEach(function(r$1) {
            $281a441cdcb2cf36$var$_defineProperty2(e4, r$1, t4[r$1]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : $281a441cdcb2cf36$var$ownKeys2(Object(t4)).forEach(function(r$1) {
            Object.defineProperty(e4, r$1, Object.getOwnPropertyDescriptor(t4, r$1));
        });
    }
    return e4;
}
var $281a441cdcb2cf36$var$StorageError = class extends Error {
    constructor(message, namespace = "storage", status, statusCode){
        super(message);
        this.__isStorageError = true;
        this.namespace = namespace;
        this.name = namespace === "vectors" ? "StorageVectorsError" : "StorageError";
        this.status = status;
        this.statusCode = statusCode;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status,
            statusCode: this.statusCode
        };
    }
};
function $281a441cdcb2cf36$var$isStorageError(error) {
    return typeof error === "object" && error !== null && "__isStorageError" in error;
}
var $281a441cdcb2cf36$var$StorageApiError = class extends $281a441cdcb2cf36$var$StorageError {
    constructor(message, status, statusCode, namespace = "storage"){
        super(message, namespace, status, statusCode);
        this.name = namespace === "vectors" ? "StorageVectorsApiError" : "StorageApiError";
        this.status = status;
        this.statusCode = statusCode;
    }
    toJSON() {
        return $281a441cdcb2cf36$var$_objectSpread22({}, super.toJSON());
    }
};
var $281a441cdcb2cf36$var$StorageUnknownError = class extends $281a441cdcb2cf36$var$StorageError {
    constructor(message, originalError, namespace = "storage"){
        super(message, namespace);
        this.name = namespace === "vectors" ? "StorageVectorsUnknownError" : "StorageUnknownError";
        this.originalError = originalError;
    }
};
function $281a441cdcb2cf36$var$setHeader(headers, name, value2) {
    const result = $281a441cdcb2cf36$var$_objectSpread22({}, headers);
    const nameLower = name.toLowerCase();
    for (const key of Object.keys(result))if (key.toLowerCase() === nameLower) delete result[key];
    result[nameLower] = value2;
    return result;
}
function $281a441cdcb2cf36$var$normalizeHeaders(headers) {
    const result = {};
    for (const [key, value2] of Object.entries(headers))result[key.toLowerCase()] = value2;
    return result;
}
var $281a441cdcb2cf36$var$resolveFetch2 = (customFetch)=>{
    if (customFetch) return (...args2)=>customFetch(...args2);
    return (...args2)=>fetch(...args2);
};
var $281a441cdcb2cf36$var$isPlainObject4 = (value2)=>{
    if (typeof value2 !== "object" || value2 === null) return false;
    const prototype = Object.getPrototypeOf(value2);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value2) && !(Symbol.iterator in value2);
};
var $281a441cdcb2cf36$var$recursiveToCamel = (item)=>{
    if (Array.isArray(item)) return item.map((el)=>$281a441cdcb2cf36$var$recursiveToCamel(el));
    else if (typeof item === "function" || item !== Object(item)) return item;
    const result = {};
    Object.entries(item).forEach(([key, value2])=>{
        const newKey = key.replace(/([-_][a-z])/gi, (c3)=>c3.toUpperCase().replace(/[-_]/g, ""));
        result[newKey] = $281a441cdcb2cf36$var$recursiveToCamel(value2);
    });
    return result;
};
var $281a441cdcb2cf36$var$isValidBucketName = (bucketName)=>{
    if (!bucketName || typeof bucketName !== "string") return false;
    if (bucketName.length === 0 || bucketName.length > 100) return false;
    if (bucketName.trim() !== bucketName) return false;
    if (bucketName.includes("/") || bucketName.includes("\\")) return false;
    return /^[\w!.\*'() &$@=;:+,?-]+$/.test(bucketName);
};
var $281a441cdcb2cf36$var$_getErrorMessage = (err)=>{
    var _err$error;
    return err.msg || err.message || err.error_description || (typeof err.error === "string" ? err.error : (_err$error = err.error) === null || _err$error === void 0 ? void 0 : _err$error.message) || JSON.stringify(err);
};
var $281a441cdcb2cf36$var$handleError = async (error, reject, options, namespace)=>{
    if (error !== null && typeof error === "object" && typeof error.json === "function") {
        const responseError = error;
        let status = parseInt(responseError.status, 10);
        if (!Number.isFinite(status)) status = 500;
        responseError.json().then((err)=>{
            const statusCode = (err === null || err === void 0 ? void 0 : err.statusCode) || (err === null || err === void 0 ? void 0 : err.code) || status + "";
            reject(new $281a441cdcb2cf36$var$StorageApiError($281a441cdcb2cf36$var$_getErrorMessage(err), status, statusCode, namespace));
        }).catch(()=>{
            const statusCode = status + "";
            reject(new $281a441cdcb2cf36$var$StorageApiError(responseError.statusText || `HTTP ${status} error`, status, statusCode, namespace));
        });
    } else reject(new $281a441cdcb2cf36$var$StorageUnknownError($281a441cdcb2cf36$var$_getErrorMessage(error), error, namespace));
};
var $281a441cdcb2cf36$var$_getRequestParams = (method, options, parameters, body)=>{
    const params2 = {
        method: method,
        headers: (options === null || options === void 0 ? void 0 : options.headers) || {}
    };
    if (method === "GET" || method === "HEAD" || !body) return $281a441cdcb2cf36$var$_objectSpread22($281a441cdcb2cf36$var$_objectSpread22({}, params2), parameters);
    if ($281a441cdcb2cf36$var$isPlainObject4(body)) {
        var _contentType;
        const headers = (options === null || options === void 0 ? void 0 : options.headers) || {};
        let contentType;
        for (const [key, value2] of Object.entries(headers))if (key.toLowerCase() === "content-type") contentType = value2;
        params2.headers = $281a441cdcb2cf36$var$setHeader(headers, "Content-Type", (_contentType = contentType) !== null && _contentType !== void 0 ? _contentType : "application/json");
        params2.body = JSON.stringify(body);
    } else params2.body = body;
    if (options === null || options === void 0 ? void 0 : options.duplex) params2.duplex = options.duplex;
    return $281a441cdcb2cf36$var$_objectSpread22($281a441cdcb2cf36$var$_objectSpread22({}, params2), parameters);
};
async function $281a441cdcb2cf36$var$_handleRequest(fetcher, method, url2, options, parameters, body, namespace) {
    return new Promise((resolve, reject)=>{
        fetcher(url2, $281a441cdcb2cf36$var$_getRequestParams(method, options, parameters, body)).then((result)=>{
            if (!result.ok) throw result;
            if (options === null || options === void 0 ? void 0 : options.noResolveJson) return result;
            if (namespace === "vectors") {
                const contentType = result.headers.get("content-type");
                if (result.headers.get("content-length") === "0" || result.status === 204) return {};
                if (!contentType || !contentType.includes("application/json")) return {};
            }
            return result.json();
        }).then((data2)=>resolve(data2)).catch((error)=>$281a441cdcb2cf36$var$handleError(error, reject, options, namespace));
    });
}
function $281a441cdcb2cf36$var$createFetchApi(namespace = "storage") {
    return {
        get: async (fetcher, url2, options, parameters)=>{
            return $281a441cdcb2cf36$var$_handleRequest(fetcher, "GET", url2, options, parameters, void 0, namespace);
        },
        post: async (fetcher, url2, body, options, parameters)=>{
            return $281a441cdcb2cf36$var$_handleRequest(fetcher, "POST", url2, options, parameters, body, namespace);
        },
        put: async (fetcher, url2, body, options, parameters)=>{
            return $281a441cdcb2cf36$var$_handleRequest(fetcher, "PUT", url2, options, parameters, body, namespace);
        },
        head: async (fetcher, url2, options, parameters)=>{
            return $281a441cdcb2cf36$var$_handleRequest(fetcher, "HEAD", url2, $281a441cdcb2cf36$var$_objectSpread22($281a441cdcb2cf36$var$_objectSpread22({}, options), {}, {
                noResolveJson: true
            }), parameters, void 0, namespace);
        },
        remove: async (fetcher, url2, body, options, parameters)=>{
            return $281a441cdcb2cf36$var$_handleRequest(fetcher, "DELETE", url2, options, parameters, body, namespace);
        }
    };
}
var $281a441cdcb2cf36$var$defaultApi = $281a441cdcb2cf36$var$createFetchApi("storage");
var { get: $281a441cdcb2cf36$var$get2, post: $281a441cdcb2cf36$var$post, put: $281a441cdcb2cf36$var$put2, head: $281a441cdcb2cf36$var$head, remove: $281a441cdcb2cf36$var$remove2 } = $281a441cdcb2cf36$var$defaultApi;
var $281a441cdcb2cf36$var$vectorsApi = $281a441cdcb2cf36$var$createFetchApi("vectors");
var $281a441cdcb2cf36$var$BaseApiClient = class {
    /**
  * Creates a new BaseApiClient instance
  * @param url - Base URL for API requests
  * @param headers - Default headers for API requests
  * @param fetch - Optional custom fetch implementation
  * @param namespace - Error namespace ('storage' or 'vectors')
  */ constructor(url2, headers = {}, fetch$1, namespace = "storage"){
        this.shouldThrowOnError = false;
        this.url = url2;
        this.headers = $281a441cdcb2cf36$var$normalizeHeaders(headers);
        this.fetch = $281a441cdcb2cf36$var$resolveFetch2(fetch$1);
        this.namespace = namespace;
    }
    /**
  * Enable throwing errors instead of returning them.
  * When enabled, errors are thrown instead of returned in { data, error } format.
  *
  * @returns this - For method chaining
  */ throwOnError() {
        this.shouldThrowOnError = true;
        return this;
    }
    /**
  * Set an HTTP header for the request.
  * Creates a shallow copy of headers to avoid mutating shared state.
  *
  * @param name - Header name
  * @param value - Header value
  * @returns this - For method chaining
  */ setHeader(name, value2) {
        this.headers = $281a441cdcb2cf36$var$setHeader(this.headers, name, value2);
        return this;
    }
    /**
  * Handles API operation with standardized error handling
  * Eliminates repetitive try-catch blocks across all API methods
  *
  * This wrapper:
  * 1. Executes the operation
  * 2. Returns { data, error: null } on success
  * 3. Returns { data: null, error } on failure (if shouldThrowOnError is false)
  * 4. Throws error on failure (if shouldThrowOnError is true)
  *
  * @typeParam T - The expected data type from the operation
  * @param operation - Async function that performs the API call
  * @returns Promise with { data, error } tuple
  *
  * @example Handling an operation
  * ```typescript
  * async listBuckets() {
  *   return this.handleOperation(async () => {
  *     return await get(this.fetch, `${this.url}/bucket`, {
  *       headers: this.headers,
  *     })
  *   })
  * }
  * ```
  */ async handleOperation(operation) {
        var _this = this;
        try {
            return {
                data: await operation(),
                error: null
            };
        } catch (error) {
            if (_this.shouldThrowOnError) throw error;
            if ($281a441cdcb2cf36$var$isStorageError(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
};
var $281a441cdcb2cf36$var$StreamDownloadBuilder = class {
    constructor(downloadFn, shouldThrowOnError){
        this.downloadFn = downloadFn;
        this.shouldThrowOnError = shouldThrowOnError;
    }
    then(onfulfilled, onrejected) {
        return this.execute().then(onfulfilled, onrejected);
    }
    async execute() {
        var _this = this;
        try {
            return {
                data: (await _this.downloadFn()).body,
                error: null
            };
        } catch (error) {
            if (_this.shouldThrowOnError) throw error;
            if ($281a441cdcb2cf36$var$isStorageError(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
};
var $281a441cdcb2cf36$var$_Symbol$toStringTag;
$281a441cdcb2cf36$var$_Symbol$toStringTag = Symbol.toStringTag;
var $281a441cdcb2cf36$var$BlobDownloadBuilder = class {
    constructor(downloadFn, shouldThrowOnError){
        this.downloadFn = downloadFn;
        this.shouldThrowOnError = shouldThrowOnError;
        this[$281a441cdcb2cf36$var$_Symbol$toStringTag] = "BlobDownloadBuilder";
        this.promise = null;
    }
    asStream() {
        return new $281a441cdcb2cf36$var$StreamDownloadBuilder(this.downloadFn, this.shouldThrowOnError);
    }
    then(onfulfilled, onrejected) {
        return this.getPromise().then(onfulfilled, onrejected);
    }
    catch(onrejected) {
        return this.getPromise().catch(onrejected);
    }
    finally(onfinally) {
        return this.getPromise().finally(onfinally);
    }
    getPromise() {
        if (!this.promise) this.promise = this.execute();
        return this.promise;
    }
    async execute() {
        var _this = this;
        try {
            return {
                data: await (await _this.downloadFn()).blob(),
                error: null
            };
        } catch (error) {
            if (_this.shouldThrowOnError) throw error;
            if ($281a441cdcb2cf36$var$isStorageError(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
};
var $281a441cdcb2cf36$var$DEFAULT_SEARCH_OPTIONS = {
    limit: 100,
    offset: 0,
    sortBy: {
        column: "name",
        order: "asc"
    }
};
var $281a441cdcb2cf36$var$DEFAULT_FILE_OPTIONS = {
    cacheControl: "3600",
    contentType: "text/plain;charset=UTF-8",
    upsert: false
};
var $281a441cdcb2cf36$var$StorageFileApi = class extends $281a441cdcb2cf36$var$BaseApiClient {
    constructor(url2, headers = {}, bucketId, fetch$1){
        super(url2, headers, fetch$1, "storage");
        this.bucketId = bucketId;
    }
    /**
  * Uploads a file to an existing bucket or replaces an existing file at the specified path with a new one.
  *
  * @param method HTTP method.
  * @param path The relative file path. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
  * @param fileBody The body of the file to be stored in the bucket.
  */ async uploadOrUpdate(method, path, fileBody, fileOptions) {
        var _this = this;
        return _this.handleOperation(async ()=>{
            let body;
            const options = $281a441cdcb2cf36$var$_objectSpread22($281a441cdcb2cf36$var$_objectSpread22({}, $281a441cdcb2cf36$var$DEFAULT_FILE_OPTIONS), fileOptions);
            let headers = $281a441cdcb2cf36$var$_objectSpread22($281a441cdcb2cf36$var$_objectSpread22({}, _this.headers), method === "POST" && {
                "x-upsert": String(options.upsert)
            });
            const metadata = options.metadata;
            if (typeof Blob !== "undefined" && fileBody instanceof Blob) {
                body = new FormData();
                body.append("cacheControl", options.cacheControl);
                if (metadata) body.append("metadata", _this.encodeMetadata(metadata));
                body.append("", fileBody);
            } else if (typeof FormData !== "undefined" && fileBody instanceof FormData) {
                body = fileBody;
                if (!body.has("cacheControl")) body.append("cacheControl", options.cacheControl);
                if (metadata && !body.has("metadata")) body.append("metadata", _this.encodeMetadata(metadata));
            } else {
                body = fileBody;
                headers["cache-control"] = `max-age=${options.cacheControl}`;
                headers["content-type"] = options.contentType;
                if (metadata) headers["x-metadata"] = _this.toBase64(_this.encodeMetadata(metadata));
                if ((typeof ReadableStream !== "undefined" && body instanceof ReadableStream || body && typeof body === "object" && "pipe" in body && typeof body.pipe === "function") && !options.duplex) options.duplex = "half";
            }
            if (fileOptions === null || fileOptions === void 0 ? void 0 : fileOptions.headers) for (const [key, value2] of Object.entries(fileOptions.headers))headers = $281a441cdcb2cf36$var$setHeader(headers, key, value2);
            const cleanPath = _this._removeEmptyFolders(path);
            const _path = _this._getFinalPath(cleanPath);
            const data2 = await (method == "PUT" ? $281a441cdcb2cf36$var$put2 : $281a441cdcb2cf36$var$post)(_this.fetch, `${_this.url}/object/${_path}`, body, $281a441cdcb2cf36$var$_objectSpread22({
                headers: headers
            }, (options === null || options === void 0 ? void 0 : options.duplex) ? {
                duplex: options.duplex
            } : {}));
            return {
                path: cleanPath,
                id: data2.Id,
                fullPath: data2.Key
            };
        });
    }
    /**
  * Uploads a file to an existing bucket.
  *
  * @category File Buckets
  * @param path The file path, including the file name. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
  * @param fileBody The body of the file to be stored in the bucket.
  * @param fileOptions Optional file upload options including cacheControl, contentType, upsert, and metadata.
  * @returns Promise with response containing file path, id, and fullPath or error
  *
  * @example Upload file
  * ```js
  * const avatarFile = event.target.files[0]
  * const { data, error } = await supabase
  *   .storage
  *   .from('avatars')
  *   .upload('public/avatar1.png', avatarFile, {
  *     cacheControl: '3600',
  *     upsert: false
  *   })
  * ```
  *
  * Response:
  * ```json
  * {
  *   "data": {
  *     "path": "public/avatar1.png",
  *     "fullPath": "avatars/public/avatar1.png"
  *   },
  *   "error": null
  * }
  * ```
  *
  * @example Upload file using `ArrayBuffer` from base64 file data
  * ```js
  * import { decode } from 'base64-arraybuffer'
  *
  * const { data, error } = await supabase
  *   .storage
  *   .from('avatars')
  *   .upload('public/avatar1.png', decode('base64FileData'), {
  *     contentType: 'image/png'
  *   })
  * ```
  *
  * @remarks
  * - RLS policy permissions required:
  *   - `buckets` table permissions: none
  *   - `objects` table permissions: only `insert` when you are uploading new files and `select`, `insert` and `update` when you are upserting files
  * - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
  * - For React Native, using either `Blob`, `File` or `FormData` does not work as intended. Upload file using `ArrayBuffer` from base64 file data instead, see example below.
  */ async upload(path, fileBody, fileOptions) {
        return this.uploadOrUpdate("POST", path, fileBody, fileOptions);
    }
    /**
  * Upload a file with a token generated from `createSignedUploadUrl`.
  *
  * @category File Buckets
  * @param path The file path, including the file name. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
  * @param token The token generated from `createSignedUploadUrl`
  * @param fileBody The body of the file to be stored in the bucket.
  * @param fileOptions HTTP headers (cacheControl, contentType, etc.).
  * **Note:** The `upsert` option has no effect here. To enable upsert behavior,
  * pass `{ upsert: true }` when calling `createSignedUploadUrl()` instead.
  * @returns Promise with response containing file path and fullPath or error
  *
  * @example Upload to a signed URL
  * ```js
  * const { data, error } = await supabase
  *   .storage
  *   .from('avatars')
  *   .uploadToSignedUrl('folder/cat.jpg', 'token-from-createSignedUploadUrl', file)
  * ```
  *
  * Response:
  * ```json
  * {
  *   "data": {
  *     "path": "folder/cat.jpg",
  *     "fullPath": "avatars/folder/cat.jpg"
  *   },
  *   "error": null
  * }
  * ```
  *
  * @remarks
  * - RLS policy permissions required:
  *   - `buckets` table permissions: none
  *   - `objects` table permissions: none
  * - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
  */ async uploadToSignedUrl(path, token, fileBody, fileOptions) {
        var _this3 = this;
        const cleanPath = _this3._removeEmptyFolders(path);
        const _path = _this3._getFinalPath(cleanPath);
        const url2 = new URL(_this3.url + `/object/upload/sign/${_path}`);
        url2.searchParams.set("token", token);
        return _this3.handleOperation(async ()=>{
            let body;
            const options = $281a441cdcb2cf36$var$_objectSpread22($281a441cdcb2cf36$var$_objectSpread22({}, $281a441cdcb2cf36$var$DEFAULT_FILE_OPTIONS), fileOptions);
            let headers = $281a441cdcb2cf36$var$_objectSpread22($281a441cdcb2cf36$var$_objectSpread22({}, _this3.headers), {
                "x-upsert": String(options.upsert)
            });
            const metadata = options.metadata;
            if (typeof Blob !== "undefined" && fileBody instanceof Blob) {
                body = new FormData();
                body.append("cacheControl", options.cacheControl);
                if (metadata) body.append("metadata", _this3.encodeMetadata(metadata));
                body.append("", fileBody);
            } else if (typeof FormData !== "undefined" && fileBody instanceof FormData) {
                body = fileBody;
                if (!body.has("cacheControl")) body.append("cacheControl", options.cacheControl);
                if (metadata && !body.has("metadata")) body.append("metadata", _this3.encodeMetadata(metadata));
            } else {
                body = fileBody;
                headers["cache-control"] = `max-age=${options.cacheControl}`;
                headers["content-type"] = options.contentType;
                if (metadata) headers["x-metadata"] = _this3.toBase64(_this3.encodeMetadata(metadata));
                if ((typeof ReadableStream !== "undefined" && body instanceof ReadableStream || body && typeof body === "object" && "pipe" in body && typeof body.pipe === "function") && !options.duplex) options.duplex = "half";
            }
            if (fileOptions === null || fileOptions === void 0 ? void 0 : fileOptions.headers) for (const [key, value2] of Object.entries(fileOptions.headers))headers = $281a441cdcb2cf36$var$setHeader(headers, key, value2);
            return {
                path: cleanPath,
                fullPath: (await $281a441cdcb2cf36$var$put2(_this3.fetch, url2.toString(), body, $281a441cdcb2cf36$var$_objectSpread22({
                    headers: headers
                }, (options === null || options === void 0 ? void 0 : options.duplex) ? {
                    duplex: options.duplex
                } : {}))).Key
            };
        });
    }
    /**
  * Creates a signed upload URL.
  * Signed upload URLs can be used to upload files to the bucket without further authentication.
  * They are valid for 2 hours.
  *
  * @category File Buckets
  * @param path The file path, including the current file name. For example `folder/image.png`.
  * @param options.upsert If set to true, allows the file to be overwritten if it already exists.
  * @returns Promise with response containing signed upload URL, token, and path or error
  *
  * @example Create Signed Upload URL
  * ```js
  * const { data, error } = await supabase
  *   .storage
  *   .from('avatars')
  *   .createSignedUploadUrl('folder/cat.jpg')
  * ```
  *
  * Response:
  * ```json
  * {
  *   "data": {
  *     "signedUrl": "https://example.supabase.co/storage/v1/object/upload/sign/avatars/folder/cat.jpg?token=<TOKEN>",
  *     "path": "folder/cat.jpg",
  *     "token": "<TOKEN>"
  *   },
  *   "error": null
  * }
  * ```
  *
  * @remarks
  * - RLS policy permissions required:
  *   - `buckets` table permissions: none
  *   - `objects` table permissions: `insert`
  * - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
  */ async createSignedUploadUrl(path, options) {
        var _this4 = this;
        return _this4.handleOperation(async ()=>{
            let _path = _this4._getFinalPath(path);
            const headers = $281a441cdcb2cf36$var$_objectSpread22({}, _this4.headers);
            if (options === null || options === void 0 ? void 0 : options.upsert) headers["x-upsert"] = "true";
            const data2 = await $281a441cdcb2cf36$var$post(_this4.fetch, `${_this4.url}/object/upload/sign/${_path}`, {}, {
                headers: headers
            });
            const url2 = new URL(_this4.url + data2.url);
            const token = url2.searchParams.get("token");
            if (!token) throw new $281a441cdcb2cf36$var$StorageError("No token returned by API");
            return {
                signedUrl: url2.toString(),
                path: path,
                token: token
            };
        });
    }
    /**
  * Replaces an existing file at the specified path with a new one.
  *
  * @category File Buckets
  * @param path The relative file path. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to update.
  * @param fileBody The body of the file to be stored in the bucket.
  * @param fileOptions Optional file upload options including cacheControl, contentType, and metadata.
  * **Note:** The `upsert` option has no effect here. `update()` always replaces the
  * file at the given path, so the `x-upsert` header is not sent. To control upsert
  * behavior, use `upload()` instead.
  * @returns Promise with response containing file path, id, and fullPath or error
  *
  * @example Update file
  * ```js
  * const avatarFile = event.target.files[0]
  * const { data, error } = await supabase
  *   .storage
  *   .from('avatars')
  *   .update('public/avatar1.png', avatarFile, {
  *     cacheControl: '3600'
  *   })
  * ```
  *
  * Response:
  * ```json
  * {
  *   "data": {
  *     "path": "public/avatar1.png",
  *     "fullPath": "avatars/public/avatar1.png"
  *   },
  *   "error": null
  * }
  * ```
  *
  * @example Update file using `ArrayBuffer` from base64 file data
  * ```js
  * import {decode} from 'base64-arraybuffer'
  *
  * const { data, error } = await supabase
  *   .storage
  *   .from('avatars')
  *   .update('public/avatar1.png', decode('base64FileData'), {
  *     contentType: 'image/png'
  *   })
  * ```
  *
  * @remarks
  * - RLS policy permissions required:
  *   - `buckets` table permissions: none
  *   - `objects` table permissions: `update` and `select`
  * - `update()` always replaces the file at the given path regardless of the `upsert` option.
  * - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
  * - For React Native, using either `Blob`, `File` or `FormData` does not work as intended. Update file using `ArrayBuffer` from base64 file data instead, see example below.
  */ async update(path, fileBody, fileOptions) {
        return this.uploadOrUpdate("PUT", path, fileBody, fileOptions);
    }
    /**
  * Moves an existing file to a new path in the same bucket.
  *
  * @category File Buckets
  * @param fromPath The original file path, including the current file name. For example `folder/image.png`.
  * @param toPath The new file path, including the new file name. For example `folder/image-new.png`.
  * @param options The destination options.
  * @returns Promise with response containing success message or error
  *
  * @example Move file
  * ```js
  * const { data, error } = await supabase
  *   .storage
  *   .from('avatars')
  *   .move('public/avatar1.png', 'private/avatar2.png')
  * ```
  *
  * Response:
  * ```json
  * {
  *   "data": {
  *     "message": "Successfully moved"
  *   },
  *   "error": null
  * }
  * ```
  *
  * @remarks
  * - RLS policy permissions required:
  *   - `buckets` table permissions: none
  *   - `objects` table permissions: `update` and `select`
  * - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
  */ async move(fromPath, toPath, options) {
        var _this6 = this;
        return _this6.handleOperation(async ()=>{
            return await $281a441cdcb2cf36$var$post(_this6.fetch, `${_this6.url}/object/move`, {
                bucketId: _this6.bucketId,
                sourceKey: fromPath,
                destinationKey: toPath,
                destinationBucket: options === null || options === void 0 ? void 0 : options.destinationBucket
            }, {
                headers: _this6.headers
            });
        });
    }
    /**
  * Copies an existing file to a new path in the same bucket.
  *
  * @category File Buckets
  * @param fromPath The original file path, including the current file name. For example `folder/image.png`.
  * @param toPath The new file path, including the new file name. For example `folder/image-copy.png`.
  * @param options The destination options.
  * @returns Promise with response containing copied file path or error
  *
  * @example Copy file
  * ```js
  * const { data, error } = await supabase
  *   .storage
  *   .from('avatars')
  *   .copy('public/avatar1.png', 'private/avatar2.png')
  * ```
  *
  * Response:
  * ```json
  * {
  *   "data": {
  *     "path": "avatars/private/avatar2.png"
  *   },
  *   "error": null
  * }
  * ```
  *
  * @remarks
  * - RLS policy permissions required:
  *   - `buckets` table permissions: none
  *   - `objects` table permissions: `insert` and `select`
  * - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
  */ async copy(fromPath, toPath, options) {
        var _this7 = this;
        return _this7.handleOperation(async ()=>{
            return {
                path: (await $281a441cdcb2cf36$var$post(_this7.fetch, `${_this7.url}/object/copy`, {
                    bucketId: _this7.bucketId,
                    sourceKey: fromPath,
                    destinationKey: toPath,
                    destinationBucket: options === null || options === void 0 ? void 0 : options.destinationBucket
                }, {
                    headers: _this7.headers
                })).Key
            };
        });
    }
    /**
  * Creates a signed URL. Use a signed URL to share a file for a fixed amount of time.
  *
  * @category File Buckets
  * @param path The file path, including the current file name. For example `folder/image.png`.
  * @param expiresIn The number of seconds until the signed URL expires. For example, `60` for a URL which is valid for one minute.
  * @param options.download triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
  * @param options.transform Transform the asset before serving it to the client.
  * @param options.cacheNonce Append a cache nonce parameter to the URL to invalidate the cache.
  * @returns Promise with response containing signed URL or error
  *
  * @example Create Signed URL
  * ```js
  * const { data, error } = await supabase
  *   .storage
  *   .from('avatars')
  *   .createSignedUrl('folder/avatar1.png', 60)
  * ```
  *
  * Response:
  * ```json
  * {
  *   "data": {
  *     "signedUrl": "https://example.supabase.co/storage/v1/object/sign/avatars/folder/avatar1.png?token=<TOKEN>"
  *   },
  *   "error": null
  * }
  * ```
  *
  * @example Create a signed URL for an asset with transformations
  * ```js
  * const { data } = await supabase
  *   .storage
  *   .from('avatars')
  *   .createSignedUrl('folder/avatar1.png', 60, {
  *     transform: {
  *       width: 100,
  *       height: 100,
  *     }
  *   })
  * ```
  *
  * @example Create a signed URL which triggers the download of the asset
  * ```js
  * const { data } = await supabase
  *   .storage
  *   .from('avatars')
  *   .createSignedUrl('folder/avatar1.png', 60, {
  *     download: true,
  *   })
  * ```
  *
  * @remarks
  * - RLS policy permissions required:
  *   - `buckets` table permissions: none
  *   - `objects` table permissions: `select`
  * - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
  */ async createSignedUrl(path, expiresIn, options) {
        var _this8 = this;
        return _this8.handleOperation(async ()=>{
            let _path = _this8._getFinalPath(path);
            const hasTransform = typeof (options === null || options === void 0 ? void 0 : options.transform) === "object" && options.transform !== null && Object.keys(options.transform).length > 0;
            let data2 = await $281a441cdcb2cf36$var$post(_this8.fetch, `${_this8.url}/object/sign/${_path}`, $281a441cdcb2cf36$var$_objectSpread22({
                expiresIn: expiresIn
            }, hasTransform ? {
                transform: options.transform
            } : {}), {
                headers: _this8.headers
            });
            const query = new URLSearchParams();
            if (options === null || options === void 0 ? void 0 : options.download) query.set("download", options.download === true ? "" : options.download);
            if ((options === null || options === void 0 ? void 0 : options.cacheNonce) != null) query.set("cacheNonce", String(options.cacheNonce));
            const queryString = query.toString();
            return {
                signedUrl: encodeURI(`${_this8.url}${data2.signedURL}${queryString ? `&${queryString}` : ""}`)
            };
        });
    }
    /**
  * Creates multiple signed URLs. Use a signed URL to share a file for a fixed amount of time.
  *
  * @category File Buckets
  * @param paths The file paths to be downloaded, including the current file names. For example `['folder/image.png', 'folder2/image2.png']`.
  * @param expiresIn The number of seconds until the signed URLs expire. For example, `60` for URLs which are valid for one minute.
  * @param options.download triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
  * @param options.cacheNonce Append a cache nonce parameter to the URL to invalidate the cache.
  * @returns Promise with response containing array of objects with signedUrl, path, and error or error
  *
  * @example Create Signed URLs
  * ```js
  * const { data, error } = await supabase
  *   .storage
  *   .from('avatars')
  *   .createSignedUrls(['folder/avatar1.png', 'folder/avatar2.png'], 60)
  * ```
  *
  * Response:
  * ```json
  * {
  *   "data": [
  *     {
  *       "error": null,
  *       "path": "folder/avatar1.png",
  *       "signedURL": "/object/sign/avatars/folder/avatar1.png?token=<TOKEN>",
  *       "signedUrl": "https://example.supabase.co/storage/v1/object/sign/avatars/folder/avatar1.png?token=<TOKEN>"
  *     },
  *     {
  *       "error": null,
  *       "path": "folder/avatar2.png",
  *       "signedURL": "/object/sign/avatars/folder/avatar2.png?token=<TOKEN>",
  *       "signedUrl": "https://example.supabase.co/storage/v1/object/sign/avatars/folder/avatar2.png?token=<TOKEN>"
  *     }
  *   ],
  *   "error": null
  * }
  * ```
  *
  * @remarks
  * - RLS policy permissions required:
  *   - `buckets` table permissions: none
  *   - `objects` table permissions: `select`
  * - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
  */ async createSignedUrls(paths, expiresIn, options) {
        var _this9 = this;
        return _this9.handleOperation(async ()=>{
            const data2 = await $281a441cdcb2cf36$var$post(_this9.fetch, `${_this9.url}/object/sign/${_this9.bucketId}`, {
                expiresIn: expiresIn,
                paths: paths
            }, {
                headers: _this9.headers
            });
            const query = new URLSearchParams();
            if (options === null || options === void 0 ? void 0 : options.download) query.set("download", options.download === true ? "" : options.download);
            if ((options === null || options === void 0 ? void 0 : options.cacheNonce) != null) query.set("cacheNonce", String(options.cacheNonce));
            const queryString = query.toString();
            return data2.map((datum)=>$281a441cdcb2cf36$var$_objectSpread22($281a441cdcb2cf36$var$_objectSpread22({}, datum), {}, {
                    signedUrl: datum.signedURL ? encodeURI(`${_this9.url}${datum.signedURL}${queryString ? `&${queryString}` : ""}`) : null
                }));
        });
    }
    /**
  * Downloads a file from a private bucket. For public buckets, make a request to the URL returned from `getPublicUrl` instead.
  *
  * @category File Buckets
  * @param path The full path and file name of the file to be downloaded. For example `folder/image.png`.
  * @param options.transform Transform the asset before serving it to the client.
  * @param options.cacheNonce Append a cache nonce parameter to the URL to invalidate the cache.
  * @param parameters Additional fetch parameters like signal for cancellation. Supports standard fetch options including cache control.
  * @returns BlobDownloadBuilder instance for downloading the file
  *
  * @example Download file
  * ```js
  * const { data, error } = await supabase
  *   .storage
  *   .from('avatars')
  *   .download('folder/avatar1.png')
  * ```
  *
  * Response:
  * ```json
  * {
  *   "data": <BLOB>,
  *   "error": null
  * }
  * ```
  *
  * @example Download file with transformations
  * ```js
  * const { data, error } = await supabase
  *   .storage
  *   .from('avatars')
  *   .download('folder/avatar1.png', {
  *     transform: {
  *       width: 100,
  *       height: 100,
  *       quality: 80
  *     }
  *   })
  * ```
  *
  * @example Download with cache control (useful in Edge Functions)
  * ```js
  * const { data, error } = await supabase
  *   .storage
  *   .from('avatars')
  *   .download('folder/avatar1.png', {}, { cache: 'no-store' })
  * ```
  *
  * @example Download with abort signal
  * ```js
  * const controller = new AbortController()
  * setTimeout(() => controller.abort(), 5000)
  *
  * const { data, error } = await supabase
  *   .storage
  *   .from('avatars')
  *   .download('folder/avatar1.png', {}, { signal: controller.signal })
  * ```
  *
  * @remarks
  * - RLS policy permissions required:
  *   - `buckets` table permissions: none
  *   - `objects` table permissions: `select`
  * - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
  */ download(path, options, parameters) {
        const renderPath = typeof (options === null || options === void 0 ? void 0 : options.transform) === "object" && options.transform !== null && Object.keys(options.transform).length > 0 ? "render/image/authenticated" : "object";
        const query = new URLSearchParams();
        if (options === null || options === void 0 ? void 0 : options.transform) this.applyTransformOptsToQuery(query, options.transform);
        if ((options === null || options === void 0 ? void 0 : options.cacheNonce) != null) query.set("cacheNonce", String(options.cacheNonce));
        const queryString = query.toString();
        const _path = this._getFinalPath(path);
        const downloadFn = ()=>$281a441cdcb2cf36$var$get2(this.fetch, `${this.url}/${renderPath}/${_path}${queryString ? `?${queryString}` : ""}`, {
                headers: this.headers,
                noResolveJson: true
            }, parameters);
        return new $281a441cdcb2cf36$var$BlobDownloadBuilder(downloadFn, this.shouldThrowOnError);
    }
    /**
  * Retrieves the details of an existing file.
  *
  * Returns detailed file metadata including size, content type, and timestamps.
  * Note: The API returns `last_modified` field, not `updated_at`.
  *
  * @category File Buckets
  * @param path The file path, including the file name. For example `folder/image.png`.
  * @returns Promise with response containing file metadata or error
  *
  * @example Get file info
  * ```js
  * const { data, error } = await supabase
  *   .storage
  *   .from('avatars')
  *   .info('folder/avatar1.png')
  *
  * if (data) {
  *   console.log('Last modified:', data.lastModified)
  *   console.log('Size:', data.size)
  * }
  * ```
  */ async info(path) {
        var _this10 = this;
        const _path = _this10._getFinalPath(path);
        return _this10.handleOperation(async ()=>{
            return $281a441cdcb2cf36$var$recursiveToCamel(await $281a441cdcb2cf36$var$get2(_this10.fetch, `${_this10.url}/object/info/${_path}`, {
                headers: _this10.headers
            }));
        });
    }
    /**
  * Checks the existence of a file.
  *
  * @category File Buckets
  * @param path The file path, including the file name. For example `folder/image.png`.
  * @returns Promise with response containing boolean indicating file existence or error
  *
  * @example Check file existence
  * ```js
  * const { data, error } = await supabase
  *   .storage
  *   .from('avatars')
  *   .exists('folder/avatar1.png')
  * ```
  */ async exists(path) {
        var _this11 = this;
        const _path = _this11._getFinalPath(path);
        try {
            await $281a441cdcb2cf36$var$head(_this11.fetch, `${_this11.url}/object/${_path}`, {
                headers: _this11.headers
            });
            return {
                data: true,
                error: null
            };
        } catch (error) {
            if (_this11.shouldThrowOnError) throw error;
            if ($281a441cdcb2cf36$var$isStorageError(error)) {
                var _error$originalError;
                const status = error instanceof $281a441cdcb2cf36$var$StorageApiError ? error.status : error instanceof $281a441cdcb2cf36$var$StorageUnknownError ? (_error$originalError = error.originalError) === null || _error$originalError === void 0 ? void 0 : _error$originalError.status : void 0;
                if (status !== void 0 && [
                    400,
                    404
                ].includes(status)) return {
                    data: false,
                    error: error
                };
            }
            throw error;
        }
    }
    /**
  * A simple convenience function to get the URL for an asset in a public bucket. If you do not want to use this function, you can construct the public URL by concatenating the bucket URL with the path to the asset.
  * This function does not verify if the bucket is public. If a public URL is created for a bucket which is not public, you will not be able to download the asset.
  *
  * @category File Buckets
  * @param path The path and name of the file to generate the public URL for. For example `folder/image.png`.
  * @param options.download Triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
  * @param options.transform Transform the asset before serving it to the client.
  * @param options.cacheNonce Append a cache nonce parameter to the URL to invalidate the cache.
  * @returns Object with public URL
  *
  * @example Returns the URL for an asset in a public bucket
  * ```js
  * const { data } = supabase
  *   .storage
  *   .from('public-bucket')
  *   .getPublicUrl('folder/avatar1.png')
  * ```
  *
  * Response:
  * ```json
  * {
  *   "data": {
  *     "publicUrl": "https://example.supabase.co/storage/v1/object/public/public-bucket/folder/avatar1.png"
  *   }
  * }
  * ```
  *
  * @example Returns the URL for an asset in a public bucket with transformations
  * ```js
  * const { data } = supabase
  *   .storage
  *   .from('public-bucket')
  *   .getPublicUrl('folder/avatar1.png', {
  *     transform: {
  *       width: 100,
  *       height: 100,
  *     }
  *   })
  * ```
  *
  * @example Returns the URL which triggers the download of an asset in a public bucket
  * ```js
  * const { data } = supabase
  *   .storage
  *   .from('public-bucket')
  *   .getPublicUrl('folder/avatar1.png', {
  *     download: true,
  *   })
  * ```
  *
  * @remarks
  * - The bucket needs to be set to public, either via [updateBucket()](/docs/reference/javascript/storage-updatebucket) or by going to Storage on [supabase.com/dashboard](https://supabase.com/dashboard), clicking the overflow menu on a bucket and choosing "Make public"
  * - RLS policy permissions required:
  *   - `buckets` table permissions: none
  *   - `objects` table permissions: none
  * - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
  */ getPublicUrl(path, options) {
        const _path = this._getFinalPath(path);
        const query = new URLSearchParams();
        if (options === null || options === void 0 ? void 0 : options.download) query.set("download", options.download === true ? "" : options.download);
        if (options === null || options === void 0 ? void 0 : options.transform) this.applyTransformOptsToQuery(query, options.transform);
        if ((options === null || options === void 0 ? void 0 : options.cacheNonce) != null) query.set("cacheNonce", String(options.cacheNonce));
        const queryString = query.toString();
        const renderPath = typeof (options === null || options === void 0 ? void 0 : options.transform) === "object" && options.transform !== null && Object.keys(options.transform).length > 0 ? "render/image" : "object";
        return {
            data: {
                publicUrl: encodeURI(`${this.url}/${renderPath}/public/${_path}`) + (queryString ? `?${queryString}` : "")
            }
        };
    }
    /**
  * Deletes files within the same bucket
  *
  * Returns an array of FileObject entries for the deleted files. Note that deprecated
  * fields like `bucket_id` may or may not be present in the response - do not rely on them.
  *
  * @category File Buckets
  * @param paths An array of files to delete, including the path and file name. For example [`'folder/image.png'`].
  * @returns Promise with response containing array of deleted file objects or error
  *
  * @example Delete file
  * ```js
  * const { data, error } = await supabase
  *   .storage
  *   .from('avatars')
  *   .remove(['folder/avatar1.png'])
  * ```
  *
  * Response:
  * ```json
  * {
  *   "data": [],
  *   "error": null
  * }
  * ```
  *
  * @remarks
  * - RLS policy permissions required:
  *   - `buckets` table permissions: none
  *   - `objects` table permissions: `delete` and `select`
  * - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
  */ async remove(paths) {
        var _this12 = this;
        return _this12.handleOperation(async ()=>{
            return await $281a441cdcb2cf36$var$remove2(_this12.fetch, `${_this12.url}/object/${_this12.bucketId}`, {
                prefixes: paths
            }, {
                headers: _this12.headers
            });
        });
    }
    /**
  * Get file metadata
  * @param id the file id to retrieve metadata
  */ /**
  * Update file metadata
  * @param id the file id to update metadata
  * @param meta the new file metadata
  */ /**
  * Lists all the files and folders within a path of the bucket.
  *
  * **Important:** For folder entries, fields like `id`, `updated_at`, `created_at`,
  * `last_accessed_at`, and `metadata` will be `null`. Only files have these fields populated.
  * Additionally, deprecated fields like `bucket_id`, `owner`, and `buckets` are NOT returned
  * by this method.
  *
  * @category File Buckets
  * @param path The folder path.
  * @param options Search options including limit (defaults to 100), offset, sortBy, and search
  * @param parameters Optional fetch parameters including signal for cancellation
  * @returns Promise with response containing array of files/folders or error
  *
  * @example List files in a bucket
  * ```js
  * const { data, error } = await supabase
  *   .storage
  *   .from('avatars')
  *   .list('folder', {
  *     limit: 100,
  *     offset: 0,
  *     sortBy: { column: 'name', order: 'asc' },
  *   })
  *
  * // Handle files vs folders
  * data?.forEach(item => {
  *   if (item.id !== null) {
  *     // It's a file
  *     console.log('File:', item.name, 'Size:', item.metadata?.size)
  *   } else {
  *     // It's a folder
  *     console.log('Folder:', item.name)
  *   }
  * })
  * ```
  *
  * Response:
  * ```json
  * {
  *   "data": [
  *     {
  *       "name": "avatar1.png",
  *       "id": "e668cf7f-821b-4a2f-9dce-7dfa5dd1cfd2",
  *       "updated_at": "2024-05-22T23:06:05.580Z",
  *       "created_at": "2024-05-22T23:04:34.443Z",
  *       "last_accessed_at": "2024-05-22T23:04:34.443Z",
  *       "metadata": {
  *         "eTag": "\"c5e8c553235d9af30ef4f6e280790b92\"",
  *         "size": 32175,
  *         "mimetype": "image/png",
  *         "cacheControl": "max-age=3600",
  *         "lastModified": "2024-05-22T23:06:05.574Z",
  *         "contentLength": 32175,
  *         "httpStatusCode": 200
  *       }
  *     }
  *   ],
  *   "error": null
  * }
  * ```
  *
  * @example Search files in a bucket
  * ```js
  * const { data, error } = await supabase
  *   .storage
  *   .from('avatars')
  *   .list('folder', {
  *     limit: 100,
  *     offset: 0,
  *     sortBy: { column: 'name', order: 'asc' },
  *     search: 'jon'
  *   })
  * ```
  *
  * @remarks
  * - RLS policy permissions required:
  *   - `buckets` table permissions: none
  *   - `objects` table permissions: `select`
  * - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
  */ async list(path, options, parameters) {
        var _this13 = this;
        return _this13.handleOperation(async ()=>{
            const body = $281a441cdcb2cf36$var$_objectSpread22($281a441cdcb2cf36$var$_objectSpread22($281a441cdcb2cf36$var$_objectSpread22({}, $281a441cdcb2cf36$var$DEFAULT_SEARCH_OPTIONS), options), {}, {
                prefix: path || ""
            });
            return await $281a441cdcb2cf36$var$post(_this13.fetch, `${_this13.url}/object/list/${_this13.bucketId}`, body, {
                headers: _this13.headers
            }, parameters);
        });
    }
    /**
  * Lists all the files and folders within a bucket using the V2 API with pagination support.
  *
  * **Important:** Folder entries in the `folders` array only contain `name` and optionally `key` —
  * they have no `id`, timestamps, or `metadata` fields. Full file metadata is only available
  * on entries in the `objects` array.
  *
  * @experimental this method signature might change in the future
  *
  * @category File Buckets
  * @param options Search options including prefix, cursor for pagination, limit, with_delimiter
  * @param parameters Optional fetch parameters including signal for cancellation
  * @returns Promise with response containing folders/objects arrays with pagination info or error
  *
  * @example List files with pagination
  * ```js
  * const { data, error } = await supabase
  *   .storage
  *   .from('avatars')
  *   .listV2({
  *     prefix: 'folder/',
  *     limit: 100,
  *   })
  *
  * // Handle pagination
  * if (data?.hasNext) {
  *   const nextPage = await supabase
  *     .storage
  *     .from('avatars')
  *     .listV2({
  *       prefix: 'folder/',
  *       cursor: data.nextCursor,
  *     })
  * }
  *
  * // Handle files vs folders
  * data?.objects.forEach(file => {
  *   if (file.id !== null) {
  *     console.log('File:', file.name, 'Size:', file.metadata?.size)
  *   }
  * })
  * data?.folders.forEach(folder => {
  *   console.log('Folder:', folder.name)
  * })
  * ```
  */ async listV2(options, parameters) {
        var _this14 = this;
        return _this14.handleOperation(async ()=>{
            const body = $281a441cdcb2cf36$var$_objectSpread22({}, options);
            return await $281a441cdcb2cf36$var$post(_this14.fetch, `${_this14.url}/object/list-v2/${_this14.bucketId}`, body, {
                headers: _this14.headers
            }, parameters);
        });
    }
    encodeMetadata(metadata) {
        return JSON.stringify(metadata);
    }
    toBase64(data2) {
        if (typeof $281a441cdcb2cf36$require$Buffer !== "undefined") return $281a441cdcb2cf36$require$Buffer.from(data2).toString("base64");
        return btoa(data2);
    }
    _getFinalPath(path) {
        return `${this.bucketId}/${path.replace(/^\/+/, "")}`;
    }
    _removeEmptyFolders(path) {
        return path.replace(/^\/|\/$/g, "").replace(/\/+/g, "/");
    }
    /** Modifies the `query`, appending values the from `transform` */ applyTransformOptsToQuery(query, transform) {
        if (transform.width) query.set("width", transform.width.toString());
        if (transform.height) query.set("height", transform.height.toString());
        if (transform.resize) query.set("resize", transform.resize);
        if (transform.format) query.set("format", transform.format);
        if (transform.quality) query.set("quality", transform.quality.toString());
        return query;
    }
};
var $281a441cdcb2cf36$var$version3 = "2.105.1";
var $281a441cdcb2cf36$var$DEFAULT_HEADERS = {
    "X-Client-Info": `storage-js/${$281a441cdcb2cf36$var$version3}`
};
var $281a441cdcb2cf36$var$StorageBucketApi = class extends $281a441cdcb2cf36$var$BaseApiClient {
    constructor(url2, headers = {}, fetch$1, opts){
        const baseUrl = new URL(url2);
        if (opts === null || opts === void 0 ? void 0 : opts.useNewHostname) {
            if (/supabase\.(co|in|red)$/.test(baseUrl.hostname) && !baseUrl.hostname.includes("storage.supabase.")) baseUrl.hostname = baseUrl.hostname.replace("supabase.", "storage.supabase.");
        }
        const finalUrl = baseUrl.href.replace(/\/$/, "");
        const finalHeaders = $281a441cdcb2cf36$var$_objectSpread22($281a441cdcb2cf36$var$_objectSpread22({}, $281a441cdcb2cf36$var$DEFAULT_HEADERS), headers);
        super(finalUrl, finalHeaders, fetch$1, "storage");
    }
    /**
  * Retrieves the details of all Storage buckets within an existing project.
  *
  * @category File Buckets
  * @param options Query parameters for listing buckets
  * @param options.limit Maximum number of buckets to return
  * @param options.offset Number of buckets to skip
  * @param options.sortColumn Column to sort by ('id', 'name', 'created_at', 'updated_at')
  * @param options.sortOrder Sort order ('asc' or 'desc')
  * @param options.search Search term to filter bucket names
  * @returns Promise with response containing array of buckets or error
  *
  * @example List buckets
  * ```js
  * const { data, error } = await supabase
  *   .storage
  *   .listBuckets()
  * ```
  *
  * @example List buckets with options
  * ```js
  * const { data, error } = await supabase
  *   .storage
  *   .listBuckets({
  *     limit: 10,
  *     offset: 0,
  *     sortColumn: 'created_at',
  *     sortOrder: 'desc',
  *     search: 'prod'
  *   })
  * ```
  *
  * @remarks
  * - RLS policy permissions required:
  *   - `buckets` table permissions: `select`
  *   - `objects` table permissions: none
  * - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
  */ async listBuckets(options) {
        var _this = this;
        return _this.handleOperation(async ()=>{
            const queryString = _this.listBucketOptionsToQueryString(options);
            return await $281a441cdcb2cf36$var$get2(_this.fetch, `${_this.url}/bucket${queryString}`, {
                headers: _this.headers
            });
        });
    }
    /**
  * Retrieves the details of an existing Storage bucket.
  *
  * @category File Buckets
  * @param id The unique identifier of the bucket you would like to retrieve.
  * @returns Promise with response containing bucket details or error
  *
  * @example Get bucket
  * ```js
  * const { data, error } = await supabase
  *   .storage
  *   .getBucket('avatars')
  * ```
  *
  * Response:
  * ```json
  * {
  *   "data": {
  *     "id": "avatars",
  *     "name": "avatars",
  *     "owner": "",
  *     "public": false,
  *     "file_size_limit": 1024,
  *     "allowed_mime_types": [
  *       "image/png"
  *     ],
  *     "created_at": "2024-05-22T22:26:05.100Z",
  *     "updated_at": "2024-05-22T22:26:05.100Z"
  *   },
  *   "error": null
  * }
  * ```
  *
  * @remarks
  * - RLS policy permissions required:
  *   - `buckets` table permissions: `select`
  *   - `objects` table permissions: none
  * - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
  */ async getBucket(id2) {
        var _this2 = this;
        return _this2.handleOperation(async ()=>{
            return await $281a441cdcb2cf36$var$get2(_this2.fetch, `${_this2.url}/bucket/${id2}`, {
                headers: _this2.headers
            });
        });
    }
    /**
  * Creates a new Storage bucket
  *
  * @category File Buckets
  * @param id A unique identifier for the bucket you are creating.
  * @param options.public The visibility of the bucket. Public buckets don't require an authorization token to download objects, but still require a valid token for all other operations. By default, buckets are private.
  * @param options.fileSizeLimit specifies the max file size in bytes that can be uploaded to this bucket.
  * The global file size limit takes precedence over this value.
  * The default value is null, which doesn't set a per bucket file size limit.
  * @param options.allowedMimeTypes specifies the allowed mime types that this bucket can accept during upload.
  * The default value is null, which allows files with all mime types to be uploaded.
  * Each mime type specified can be a wildcard, e.g. image/*, or a specific mime type, e.g. image/png.
  * @param options.type (private-beta) specifies the bucket type. see `BucketType` for more details.
  *   - default bucket type is `STANDARD`
  * @returns Promise with response containing newly created bucket name or error
  *
  * @example Create bucket
  * ```js
  * const { data, error } = await supabase
  *   .storage
  *   .createBucket('avatars', {
  *     public: false,
  *     allowedMimeTypes: ['image/png'],
  *     fileSizeLimit: 1024
  *   })
  * ```
  *
  * Response:
  * ```json
  * {
  *   "data": {
  *     "name": "avatars"
  *   },
  *   "error": null
  * }
  * ```
  *
  * @remarks
  * - RLS policy permissions required:
  *   - `buckets` table permissions: `insert`
  *   - `objects` table permissions: none
  * - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
  */ async createBucket(id2, options = {
        public: false
    }) {
        var _this3 = this;
        return _this3.handleOperation(async ()=>{
            return await $281a441cdcb2cf36$var$post(_this3.fetch, `${_this3.url}/bucket`, {
                id: id2,
                name: id2,
                type: options.type,
                public: options.public,
                file_size_limit: options.fileSizeLimit,
                allowed_mime_types: options.allowedMimeTypes
            }, {
                headers: _this3.headers
            });
        });
    }
    /**
  * Updates a Storage bucket
  *
  * @category File Buckets
  * @param id A unique identifier for the bucket you are updating.
  * @param options.public The visibility of the bucket. Public buckets don't require an authorization token to download objects, but still require a valid token for all other operations.
  * @param options.fileSizeLimit specifies the max file size in bytes that can be uploaded to this bucket.
  * The global file size limit takes precedence over this value.
  * The default value is null, which doesn't set a per bucket file size limit.
  * @param options.allowedMimeTypes specifies the allowed mime types that this bucket can accept during upload.
  * The default value is null, which allows files with all mime types to be uploaded.
  * Each mime type specified can be a wildcard, e.g. image/*, or a specific mime type, e.g. image/png.
  * @returns Promise with response containing success message or error
  *
  * @example Update bucket
  * ```js
  * const { data, error } = await supabase
  *   .storage
  *   .updateBucket('avatars', {
  *     public: false,
  *     allowedMimeTypes: ['image/png'],
  *     fileSizeLimit: 1024
  *   })
  * ```
  *
  * Response:
  * ```json
  * {
  *   "data": {
  *     "message": "Successfully updated"
  *   },
  *   "error": null
  * }
  * ```
  *
  * @remarks
  * - RLS policy permissions required:
  *   - `buckets` table permissions: `select` and `update`
  *   - `objects` table permissions: none
  * - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
  */ async updateBucket(id2, options) {
        var _this4 = this;
        return _this4.handleOperation(async ()=>{
            return await $281a441cdcb2cf36$var$put2(_this4.fetch, `${_this4.url}/bucket/${id2}`, {
                id: id2,
                name: id2,
                public: options.public,
                file_size_limit: options.fileSizeLimit,
                allowed_mime_types: options.allowedMimeTypes
            }, {
                headers: _this4.headers
            });
        });
    }
    /**
  * Removes all objects inside a single bucket.
  *
  * @category File Buckets
  * @param id The unique identifier of the bucket you would like to empty.
  * @returns Promise with success message or error
  *
  * @example Empty bucket
  * ```js
  * const { data, error } = await supabase
  *   .storage
  *   .emptyBucket('avatars')
  * ```
  *
  * Response:
  * ```json
  * {
  *   "data": {
  *     "message": "Successfully emptied"
  *   },
  *   "error": null
  * }
  * ```
  *
  * @remarks
  * - RLS policy permissions required:
  *   - `buckets` table permissions: `select`
  *   - `objects` table permissions: `select` and `delete`
  * - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
  */ async emptyBucket(id2) {
        var _this5 = this;
        return _this5.handleOperation(async ()=>{
            return await $281a441cdcb2cf36$var$post(_this5.fetch, `${_this5.url}/bucket/${id2}/empty`, {}, {
                headers: _this5.headers
            });
        });
    }
    /**
  * Deletes an existing bucket. A bucket can't be deleted with existing objects inside it.
  * You must first `empty()` the bucket.
  *
  * @category File Buckets
  * @param id The unique identifier of the bucket you would like to delete.
  * @returns Promise with success message or error
  *
  * @example Delete bucket
  * ```js
  * const { data, error } = await supabase
  *   .storage
  *   .deleteBucket('avatars')
  * ```
  *
  * Response:
  * ```json
  * {
  *   "data": {
  *     "message": "Successfully deleted"
  *   },
  *   "error": null
  * }
  * ```
  *
  * @remarks
  * - RLS policy permissions required:
  *   - `buckets` table permissions: `select` and `delete`
  *   - `objects` table permissions: none
  * - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
  */ async deleteBucket(id2) {
        var _this6 = this;
        return _this6.handleOperation(async ()=>{
            return await $281a441cdcb2cf36$var$remove2(_this6.fetch, `${_this6.url}/bucket/${id2}`, {}, {
                headers: _this6.headers
            });
        });
    }
    listBucketOptionsToQueryString(options) {
        const params2 = {};
        if (options) {
            if ("limit" in options) params2.limit = String(options.limit);
            if ("offset" in options) params2.offset = String(options.offset);
            if (options.search) params2.search = options.search;
            if (options.sortColumn) params2.sortColumn = options.sortColumn;
            if (options.sortOrder) params2.sortOrder = options.sortOrder;
        }
        return Object.keys(params2).length > 0 ? "?" + new URLSearchParams(params2).toString() : "";
    }
};
var $281a441cdcb2cf36$var$StorageAnalyticsClient = class extends $281a441cdcb2cf36$var$BaseApiClient {
    /**
  * @alpha
  *
  * Creates a new StorageAnalyticsClient instance
  *
  * **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
  *
  * @category Analytics Buckets
  * @param url - The base URL for the storage API
  * @param headers - HTTP headers to include in requests
  * @param fetch - Optional custom fetch implementation
  *
  * @example Using supabase-js (recommended)
  * ```typescript
  * import { createClient } from '@supabase/supabase-js'
  *
  * const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
  * const { data, error } = await supabase.storage.analytics.listBuckets()
  * ```
  *
  * @example Standalone import for bundle-sensitive environments
  * ```typescript
  * import { StorageAnalyticsClient } from '@supabase/storage-js'
  *
  * const client = new StorageAnalyticsClient(url, headers)
  * ```
  */ constructor(url2, headers = {}, fetch$1){
        const finalUrl = url2.replace(/\/$/, "");
        const finalHeaders = $281a441cdcb2cf36$var$_objectSpread22($281a441cdcb2cf36$var$_objectSpread22({}, $281a441cdcb2cf36$var$DEFAULT_HEADERS), headers);
        super(finalUrl, finalHeaders, fetch$1, "storage");
    }
    /**
  * @alpha
  *
  * Creates a new analytics bucket using Iceberg tables
  * Analytics buckets are optimized for analytical queries and data processing
  *
  * **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
  *
  * @category Analytics Buckets
  * @param name A unique name for the bucket you are creating
  * @returns Promise with response containing newly created analytics bucket or error
  *
  * @example Create analytics bucket
  * ```js
  * const { data, error } = await supabase
  *   .storage
  *   .analytics
  *   .createBucket('analytics-data')
  * ```
  *
  * Response:
  * ```json
  * {
  *   "data": {
  *     "name": "analytics-data",
  *     "type": "ANALYTICS",
  *     "format": "iceberg",
  *     "created_at": "2024-05-22T22:26:05.100Z",
  *     "updated_at": "2024-05-22T22:26:05.100Z"
  *   },
  *   "error": null
  * }
  * ```
  *
  * @remarks
  * - Creates a new analytics bucket using Iceberg tables
  * - Analytics buckets are optimized for analytical queries and data processing
  */ async createBucket(name) {
        var _this = this;
        return _this.handleOperation(async ()=>{
            return await $281a441cdcb2cf36$var$post(_this.fetch, `${_this.url}/bucket`, {
                name: name
            }, {
                headers: _this.headers
            });
        });
    }
    /**
  * @alpha
  *
  * Retrieves the details of all Analytics Storage buckets within an existing project
  * Only returns buckets of type 'ANALYTICS'
  *
  * **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
  *
  * @category Analytics Buckets
  * @param options Query parameters for listing buckets
  * @param options.limit Maximum number of buckets to return
  * @param options.offset Number of buckets to skip
  * @param options.sortColumn Column to sort by ('name', 'created_at', 'updated_at')
  * @param options.sortOrder Sort order ('asc' or 'desc')
  * @param options.search Search term to filter bucket names
  * @returns Promise with response containing array of analytics buckets or error
  *
  * @example List analytics buckets
  * ```js
  * const { data, error } = await supabase
  *   .storage
  *   .analytics
  *   .listBuckets({
  *     limit: 10,
  *     offset: 0,
  *     sortColumn: 'created_at',
  *     sortOrder: 'desc'
  *   })
  * ```
  *
  * Response:
  * ```json
  * {
  *   "data": [
  *     {
  *       "name": "analytics-data",
  *       "type": "ANALYTICS",
  *       "format": "iceberg",
  *       "created_at": "2024-05-22T22:26:05.100Z",
  *       "updated_at": "2024-05-22T22:26:05.100Z"
  *     }
  *   ],
  *   "error": null
  * }
  * ```
  *
  * @remarks
  * - Retrieves the details of all Analytics Storage buckets within an existing project
  * - Only returns buckets of type 'ANALYTICS'
  */ async listBuckets(options) {
        var _this2 = this;
        return _this2.handleOperation(async ()=>{
            const queryParams = new URLSearchParams();
            if ((options === null || options === void 0 ? void 0 : options.limit) !== void 0) queryParams.set("limit", options.limit.toString());
            if ((options === null || options === void 0 ? void 0 : options.offset) !== void 0) queryParams.set("offset", options.offset.toString());
            if (options === null || options === void 0 ? void 0 : options.sortColumn) queryParams.set("sortColumn", options.sortColumn);
            if (options === null || options === void 0 ? void 0 : options.sortOrder) queryParams.set("sortOrder", options.sortOrder);
            if (options === null || options === void 0 ? void 0 : options.search) queryParams.set("search", options.search);
            const queryString = queryParams.toString();
            const url2 = queryString ? `${_this2.url}/bucket?${queryString}` : `${_this2.url}/bucket`;
            return await $281a441cdcb2cf36$var$get2(_this2.fetch, url2, {
                headers: _this2.headers
            });
        });
    }
    /**
  * @alpha
  *
  * Deletes an existing analytics bucket
  * A bucket can't be deleted with existing objects inside it
  * You must first empty the bucket before deletion
  *
  * **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
  *
  * @category Analytics Buckets
  * @param bucketName The unique identifier of the bucket you would like to delete
  * @returns Promise with response containing success message or error
  *
  * @example Delete analytics bucket
  * ```js
  * const { data, error } = await supabase
  *   .storage
  *   .analytics
  *   .deleteBucket('analytics-data')
  * ```
  *
  * Response:
  * ```json
  * {
  *   "data": {
  *     "message": "Successfully deleted"
  *   },
  *   "error": null
  * }
  * ```
  *
  * @remarks
  * - Deletes an analytics bucket
  */ async deleteBucket(bucketName) {
        var _this3 = this;
        return _this3.handleOperation(async ()=>{
            return await $281a441cdcb2cf36$var$remove2(_this3.fetch, `${_this3.url}/bucket/${bucketName}`, {}, {
                headers: _this3.headers
            });
        });
    }
    /**
  * @alpha
  *
  * Get an Iceberg REST Catalog client configured for a specific analytics bucket
  * Use this to perform advanced table and namespace operations within the bucket
  * The returned client provides full access to the Apache Iceberg REST Catalog API
  * with the Supabase `{ data, error }` pattern for consistent error handling on all operations.
  *
  * **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
  *
  * @category Analytics Buckets
  * @param bucketName - The name of the analytics bucket (warehouse) to connect to
  * @returns The wrapped Iceberg catalog client
  * @throws {StorageError} If the bucket name is invalid
  *
  * @example Get catalog and create table
  * ```js
  * // First, create an analytics bucket
  * const { data: bucket, error: bucketError } = await supabase
  *   .storage
  *   .analytics
  *   .createBucket('analytics-data')
  *
  * // Get the Iceberg catalog for that bucket
  * const catalog = supabase.storage.analytics.from('analytics-data')
  *
  * // Create a namespace
  * const { error: nsError } = await catalog.createNamespace({ namespace: ['default'] })
  *
  * // Create a table with schema
  * const { data: tableMetadata, error: tableError } = await catalog.createTable(
  *   { namespace: ['default'] },
  *   {
  *     name: 'events',
  *     schema: {
  *       type: 'struct',
  *       fields: [
  *         { id: 1, name: 'id', type: 'long', required: true },
  *         { id: 2, name: 'timestamp', type: 'timestamp', required: true },
  *         { id: 3, name: 'user_id', type: 'string', required: false }
  *       ],
  *       'schema-id': 0,
  *       'identifier-field-ids': [1]
  *     },
  *     'partition-spec': {
  *       'spec-id': 0,
  *       fields: []
  *     },
  *     'write-order': {
  *       'order-id': 0,
  *       fields: []
  *     },
  *     properties: {
  *       'write.format.default': 'parquet'
  *     }
  *   }
  * )
  * ```
  *
  * @example List tables in namespace
  * ```js
  * const catalog = supabase.storage.analytics.from('analytics-data')
  *
  * // List all tables in the default namespace
  * const { data: tables, error: listError } = await catalog.listTables({ namespace: ['default'] })
  * if (listError) {
  *   if (listError.isNotFound()) {
  *     console.log('Namespace not found')
  *   }
  *   return
  * }
  * console.log(tables) // [{ namespace: ['default'], name: 'events' }]
  * ```
  *
  * @example Working with namespaces
  * ```js
  * const catalog = supabase.storage.analytics.from('analytics-data')
  *
  * // List all namespaces
  * const { data: namespaces } = await catalog.listNamespaces()
  *
  * // Create namespace with properties
  * await catalog.createNamespace(
  *   { namespace: ['production'] },
  *   { properties: { owner: 'data-team', env: 'prod' } }
  * )
  * ```
  *
  * @example Cleanup operations
  * ```js
  * const catalog = supabase.storage.analytics.from('analytics-data')
  *
  * // Drop table with purge option (removes all data)
  * const { error: dropError } = await catalog.dropTable(
  *   { namespace: ['default'], name: 'events' },
  *   { purge: true }
  * )
  *
  * if (dropError?.isNotFound()) {
  *   console.log('Table does not exist')
  * }
  *
  * // Drop namespace (must be empty)
  * await catalog.dropNamespace({ namespace: ['default'] })
  * ```
  *
  * @remarks
  * This method provides a bridge between Supabase's bucket management and the standard
  * Apache Iceberg REST Catalog API. The bucket name maps to the Iceberg warehouse parameter.
  * All authentication and configuration is handled automatically using your Supabase credentials.
  *
  * **Error Handling**: Invalid bucket names throw immediately. All catalog
  * operations return `{ data, error }` where errors are `IcebergError` instances from iceberg-js.
  * Use helper methods like `error.isNotFound()` or check `error.status` for specific error handling.
  * Use `.throwOnError()` on the analytics client if you prefer exceptions for catalog operations.
  *
  * **Cleanup Operations**: When using `dropTable`, the `purge: true` option permanently
  * deletes all table data. Without it, the table is marked as deleted but data remains.
  *
  * **Library Dependency**: The returned catalog wraps `IcebergRestCatalog` from iceberg-js.
  * For complete API documentation and advanced usage, refer to the
  * [iceberg-js documentation](https://supabase.github.io/iceberg-js/).
  */ from(bucketName) {
        var _this4 = this;
        if (!$281a441cdcb2cf36$var$isValidBucketName(bucketName)) throw new $281a441cdcb2cf36$var$StorageError("Invalid bucket name: File, folder, and bucket names must follow AWS object key naming guidelines and should avoid the use of any other characters.");
        const catalog = new $281a441cdcb2cf36$var$IcebergRestCatalog({
            baseUrl: this.url,
            catalogName: bucketName,
            auth: {
                type: "custom",
                getHeaders: async ()=>_this4.headers
            },
            fetch: this.fetch
        });
        const shouldThrowOnError = this.shouldThrowOnError;
        return new Proxy(catalog, {
            get (target, prop) {
                const value2 = target[prop];
                if (typeof value2 !== "function") return value2;
                return async (...args2)=>{
                    try {
                        return {
                            data: await value2.apply(target, args2),
                            error: null
                        };
                    } catch (error) {
                        if (shouldThrowOnError) throw error;
                        return {
                            data: null,
                            error: error
                        };
                    }
                };
            }
        });
    }
};
var $281a441cdcb2cf36$var$VectorIndexApi = class extends $281a441cdcb2cf36$var$BaseApiClient {
    /** Creates a new VectorIndexApi instance */ constructor(url2, headers = {}, fetch$1){
        const finalUrl = url2.replace(/\/$/, "");
        const finalHeaders = $281a441cdcb2cf36$var$_objectSpread22($281a441cdcb2cf36$var$_objectSpread22({}, $281a441cdcb2cf36$var$DEFAULT_HEADERS), {}, {
            "Content-Type": "application/json"
        }, headers);
        super(finalUrl, finalHeaders, fetch$1, "vectors");
    }
    /** Creates a new vector index within a bucket */ async createIndex(options) {
        var _this = this;
        return _this.handleOperation(async ()=>{
            return await $281a441cdcb2cf36$var$vectorsApi.post(_this.fetch, `${_this.url}/CreateIndex`, options, {
                headers: _this.headers
            }) || {};
        });
    }
    /** Retrieves metadata for a specific vector index */ async getIndex(vectorBucketName, indexName) {
        var _this2 = this;
        return _this2.handleOperation(async ()=>{
            return await $281a441cdcb2cf36$var$vectorsApi.post(_this2.fetch, `${_this2.url}/GetIndex`, {
                vectorBucketName: vectorBucketName,
                indexName: indexName
            }, {
                headers: _this2.headers
            });
        });
    }
    /** Lists vector indexes within a bucket with optional filtering and pagination */ async listIndexes(options) {
        var _this3 = this;
        return _this3.handleOperation(async ()=>{
            return await $281a441cdcb2cf36$var$vectorsApi.post(_this3.fetch, `${_this3.url}/ListIndexes`, options, {
                headers: _this3.headers
            });
        });
    }
    /** Deletes a vector index and all its data */ async deleteIndex(vectorBucketName, indexName) {
        var _this4 = this;
        return _this4.handleOperation(async ()=>{
            return await $281a441cdcb2cf36$var$vectorsApi.post(_this4.fetch, `${_this4.url}/DeleteIndex`, {
                vectorBucketName: vectorBucketName,
                indexName: indexName
            }, {
                headers: _this4.headers
            }) || {};
        });
    }
};
var $281a441cdcb2cf36$var$VectorDataApi = class extends $281a441cdcb2cf36$var$BaseApiClient {
    /** Creates a new VectorDataApi instance */ constructor(url2, headers = {}, fetch$1){
        const finalUrl = url2.replace(/\/$/, "");
        const finalHeaders = $281a441cdcb2cf36$var$_objectSpread22($281a441cdcb2cf36$var$_objectSpread22({}, $281a441cdcb2cf36$var$DEFAULT_HEADERS), {}, {
            "Content-Type": "application/json"
        }, headers);
        super(finalUrl, finalHeaders, fetch$1, "vectors");
    }
    /** Inserts or updates vectors in batch (1-500 per request) */ async putVectors(options) {
        var _this = this;
        if (options.vectors.length < 1 || options.vectors.length > 500) throw new Error("Vector batch size must be between 1 and 500 items");
        return _this.handleOperation(async ()=>{
            return await $281a441cdcb2cf36$var$vectorsApi.post(_this.fetch, `${_this.url}/PutVectors`, options, {
                headers: _this.headers
            }) || {};
        });
    }
    /** Retrieves vectors by their keys in batch */ async getVectors(options) {
        var _this2 = this;
        return _this2.handleOperation(async ()=>{
            return await $281a441cdcb2cf36$var$vectorsApi.post(_this2.fetch, `${_this2.url}/GetVectors`, options, {
                headers: _this2.headers
            });
        });
    }
    /** Lists vectors in an index with pagination */ async listVectors(options) {
        var _this3 = this;
        if (options.segmentCount !== void 0) {
            if (options.segmentCount < 1 || options.segmentCount > 16) throw new Error("segmentCount must be between 1 and 16");
            if (options.segmentIndex !== void 0) {
                if (options.segmentIndex < 0 || options.segmentIndex >= options.segmentCount) throw new Error(`segmentIndex must be between 0 and ${options.segmentCount - 1}`);
            }
        }
        return _this3.handleOperation(async ()=>{
            return await $281a441cdcb2cf36$var$vectorsApi.post(_this3.fetch, `${_this3.url}/ListVectors`, options, {
                headers: _this3.headers
            });
        });
    }
    /** Queries for similar vectors using approximate nearest neighbor search */ async queryVectors(options) {
        var _this4 = this;
        return _this4.handleOperation(async ()=>{
            return await $281a441cdcb2cf36$var$vectorsApi.post(_this4.fetch, `${_this4.url}/QueryVectors`, options, {
                headers: _this4.headers
            });
        });
    }
    /** Deletes vectors by their keys in batch (1-500 per request) */ async deleteVectors(options) {
        var _this5 = this;
        if (options.keys.length < 1 || options.keys.length > 500) throw new Error("Keys batch size must be between 1 and 500 items");
        return _this5.handleOperation(async ()=>{
            return await $281a441cdcb2cf36$var$vectorsApi.post(_this5.fetch, `${_this5.url}/DeleteVectors`, options, {
                headers: _this5.headers
            }) || {};
        });
    }
};
var $281a441cdcb2cf36$var$VectorBucketApi = class extends $281a441cdcb2cf36$var$BaseApiClient {
    /** Creates a new VectorBucketApi instance */ constructor(url2, headers = {}, fetch$1){
        const finalUrl = url2.replace(/\/$/, "");
        const finalHeaders = $281a441cdcb2cf36$var$_objectSpread22($281a441cdcb2cf36$var$_objectSpread22({}, $281a441cdcb2cf36$var$DEFAULT_HEADERS), {}, {
            "Content-Type": "application/json"
        }, headers);
        super(finalUrl, finalHeaders, fetch$1, "vectors");
    }
    /** Creates a new vector bucket */ async createBucket(vectorBucketName) {
        var _this = this;
        return _this.handleOperation(async ()=>{
            return await $281a441cdcb2cf36$var$vectorsApi.post(_this.fetch, `${_this.url}/CreateVectorBucket`, {
                vectorBucketName: vectorBucketName
            }, {
                headers: _this.headers
            }) || {};
        });
    }
    /** Retrieves metadata for a specific vector bucket */ async getBucket(vectorBucketName) {
        var _this2 = this;
        return _this2.handleOperation(async ()=>{
            return await $281a441cdcb2cf36$var$vectorsApi.post(_this2.fetch, `${_this2.url}/GetVectorBucket`, {
                vectorBucketName: vectorBucketName
            }, {
                headers: _this2.headers
            });
        });
    }
    /** Lists vector buckets with optional filtering and pagination */ async listBuckets(options = {}) {
        var _this3 = this;
        return _this3.handleOperation(async ()=>{
            return await $281a441cdcb2cf36$var$vectorsApi.post(_this3.fetch, `${_this3.url}/ListVectorBuckets`, options, {
                headers: _this3.headers
            });
        });
    }
    /** Deletes a vector bucket (must be empty first) */ async deleteBucket(vectorBucketName) {
        var _this4 = this;
        return _this4.handleOperation(async ()=>{
            return await $281a441cdcb2cf36$var$vectorsApi.post(_this4.fetch, `${_this4.url}/DeleteVectorBucket`, {
                vectorBucketName: vectorBucketName
            }, {
                headers: _this4.headers
            }) || {};
        });
    }
};
var $281a441cdcb2cf36$var$StorageVectorsClient = class extends $281a441cdcb2cf36$var$VectorBucketApi {
    /**
  * @alpha
  *
  * Creates a StorageVectorsClient that can manage buckets, indexes, and vectors.
  *
  * **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
  *
  * @category Vector Buckets
  * @param url - Base URL of the Storage Vectors REST API.
  * @param options.headers - Optional headers (for example `Authorization`) applied to every request.
  * @param options.fetch - Optional custom `fetch` implementation for non-browser runtimes.
  *
  * @example Using supabase-js (recommended)
  * ```typescript
  * import { createClient } from '@supabase/supabase-js'
  *
  * const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
  * const bucket = supabase.storage.vectors.from('embeddings-prod')
  * ```
  *
  * @example Standalone import for bundle-sensitive environments
  * ```typescript
  * import { StorageVectorsClient } from '@supabase/storage-js'
  *
  * const client = new StorageVectorsClient(url, options)
  * ```
  */ constructor(url2, options = {}){
        super(url2, options.headers || {}, options.fetch);
    }
    /**
  *
  * @alpha
  *
  * Access operations for a specific vector bucket
  * Returns a scoped client for index and vector operations within the bucket
  *
  * **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
  *
  * @category Vector Buckets
  * @param vectorBucketName - Name of the vector bucket
  * @returns Bucket-scoped client with index and vector operations
  *
  * @example Accessing a vector bucket
  * ```typescript
  * const bucket = supabase.storage.vectors.from('embeddings-prod')
  * ```
  */ from(vectorBucketName) {
        return new $281a441cdcb2cf36$var$VectorBucketScope(this.url, this.headers, vectorBucketName, this.fetch);
    }
    /**
  *
  * @alpha
  *
  * Creates a new vector bucket
  * Vector buckets are containers for vector indexes and their data
  *
  * **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
  *
  * @category Vector Buckets
  * @param vectorBucketName - Unique name for the vector bucket
  * @returns Promise with empty response on success or error
  *
  * @example Creating a vector bucket
  * ```typescript
  * const { data, error } = await supabase
  *   .storage
  *   .vectors
  *   .createBucket('embeddings-prod')
  * ```
  */ async createBucket(vectorBucketName) {
        var _superprop_getCreateBucket = ()=>super.createBucket, _this = this;
        return _superprop_getCreateBucket().call(_this, vectorBucketName);
    }
    /**
  *
  * @alpha
  *
  * Retrieves metadata for a specific vector bucket
  *
  * **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
  *
  * @category Vector Buckets
  * @param vectorBucketName - Name of the vector bucket
  * @returns Promise with bucket metadata or error
  *
  * @example Get bucket metadata
  * ```typescript
  * const { data, error } = await supabase
  *   .storage
  *   .vectors
  *   .getBucket('embeddings-prod')
  *
  * console.log('Bucket created:', data?.vectorBucket.creationTime)
  * ```
  */ async getBucket(vectorBucketName) {
        var _superprop_getGetBucket = ()=>super.getBucket, _this2 = this;
        return _superprop_getGetBucket().call(_this2, vectorBucketName);
    }
    /**
  *
  * @alpha
  *
  * Lists all vector buckets with optional filtering and pagination
  *
  * **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
  *
  * @category Vector Buckets
  * @param options - Optional filters (prefix, maxResults, nextToken)
  * @returns Promise with list of buckets or error
  *
  * @example List vector buckets
  * ```typescript
  * const { data, error } = await supabase
  *   .storage
  *   .vectors
  *   .listBuckets({ prefix: 'embeddings-' })
  *
  * data?.vectorBuckets.forEach(bucket => {
  *   console.log(bucket.vectorBucketName)
  * })
  * ```
  */ async listBuckets(options = {}) {
        var _superprop_getListBuckets = ()=>super.listBuckets, _this3 = this;
        return _superprop_getListBuckets().call(_this3, options);
    }
    /**
  *
  * @alpha
  *
  * Deletes a vector bucket (bucket must be empty)
  * All indexes must be deleted before deleting the bucket
  *
  * **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
  *
  * @category Vector Buckets
  * @param vectorBucketName - Name of the vector bucket to delete
  * @returns Promise with empty response on success or error
  *
  * @example Delete a vector bucket
  * ```typescript
  * const { data, error } = await supabase
  *   .storage
  *   .vectors
  *   .deleteBucket('embeddings-old')
  * ```
  */ async deleteBucket(vectorBucketName) {
        var _superprop_getDeleteBucket = ()=>super.deleteBucket, _this4 = this;
        return _superprop_getDeleteBucket().call(_this4, vectorBucketName);
    }
};
var $281a441cdcb2cf36$var$VectorBucketScope = class extends $281a441cdcb2cf36$var$VectorIndexApi {
    /**
  * @alpha
  *
  * Creates a helper that automatically scopes all index operations to the provided bucket.
  *
  * **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
  *
  * @category Vector Buckets
  * @example Creating a vector bucket scope
  * ```typescript
  * const bucket = supabase.storage.vectors.from('embeddings-prod')
  * ```
  */ constructor(url2, headers, vectorBucketName, fetch$1){
        super(url2, headers, fetch$1);
        this.vectorBucketName = vectorBucketName;
    }
    /**
  *
  * @alpha
  *
  * Creates a new vector index in this bucket
  * Convenience method that automatically includes the bucket name
  *
  * **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
  *
  * @category Vector Buckets
  * @param options - Index configuration (vectorBucketName is automatically set)
  * @returns Promise with empty response on success or error
  *
  * @example Creating a vector index
  * ```typescript
  * const bucket = supabase.storage.vectors.from('embeddings-prod')
  * await bucket.createIndex({
  *   indexName: 'documents-openai',
  *   dataType: 'float32',
  *   dimension: 1536,
  *   distanceMetric: 'cosine',
  *   metadataConfiguration: {
  *     nonFilterableMetadataKeys: ['raw_text']
  *   }
  * })
  * ```
  */ async createIndex(options) {
        var _superprop_getCreateIndex = ()=>super.createIndex, _this5 = this;
        return _superprop_getCreateIndex().call(_this5, $281a441cdcb2cf36$var$_objectSpread22($281a441cdcb2cf36$var$_objectSpread22({}, options), {}, {
            vectorBucketName: _this5.vectorBucketName
        }));
    }
    /**
  *
  * @alpha
  *
  * Lists indexes in this bucket
  * Convenience method that automatically includes the bucket name
  *
  * **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
  *
  * @category Vector Buckets
  * @param options - Listing options (vectorBucketName is automatically set)
  * @returns Promise with response containing indexes array and pagination token or error
  *
  * @example List indexes
  * ```typescript
  * const bucket = supabase.storage.vectors.from('embeddings-prod')
  * const { data } = await bucket.listIndexes({ prefix: 'documents-' })
  * ```
  */ async listIndexes(options = {}) {
        var _superprop_getListIndexes = ()=>super.listIndexes, _this6 = this;
        return _superprop_getListIndexes().call(_this6, $281a441cdcb2cf36$var$_objectSpread22($281a441cdcb2cf36$var$_objectSpread22({}, options), {}, {
            vectorBucketName: _this6.vectorBucketName
        }));
    }
    /**
  *
  * @alpha
  *
  * Retrieves metadata for a specific index in this bucket
  * Convenience method that automatically includes the bucket name
  *
  * **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
  *
  * @category Vector Buckets
  * @param indexName - Name of the index to retrieve
  * @returns Promise with index metadata or error
  *
  * @example Get index metadata
  * ```typescript
  * const bucket = supabase.storage.vectors.from('embeddings-prod')
  * const { data } = await bucket.getIndex('documents-openai')
  * console.log('Dimension:', data?.index.dimension)
  * ```
  */ async getIndex(indexName) {
        var _superprop_getGetIndex = ()=>super.getIndex, _this7 = this;
        return _superprop_getGetIndex().call(_this7, _this7.vectorBucketName, indexName);
    }
    /**
  *
  * @alpha
  *
  * Deletes an index from this bucket
  * Convenience method that automatically includes the bucket name
  *
  * **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
  *
  * @category Vector Buckets
  * @param indexName - Name of the index to delete
  * @returns Promise with empty response on success or error
  *
  * @example Delete an index
  * ```typescript
  * const bucket = supabase.storage.vectors.from('embeddings-prod')
  * await bucket.deleteIndex('old-index')
  * ```
  */ async deleteIndex(indexName) {
        var _superprop_getDeleteIndex = ()=>super.deleteIndex, _this8 = this;
        return _superprop_getDeleteIndex().call(_this8, _this8.vectorBucketName, indexName);
    }
    /**
  *
  * @alpha
  *
  * Access operations for a specific index within this bucket
  * Returns a scoped client for vector data operations
  *
  * **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
  *
  * @category Vector Buckets
  * @param indexName - Name of the index
  * @returns Index-scoped client with vector data operations
  *
  * @example Accessing an index
  * ```typescript
  * const index = supabase.storage.vectors.from('embeddings-prod').index('documents-openai')
  *
  * // Insert vectors
  * await index.putVectors({
  *   vectors: [
  *     { key: 'doc-1', data: { float32: [...] }, metadata: { title: 'Intro' } }
  *   ]
  * })
  *
  * // Query similar vectors
  * const { data } = await index.queryVectors({
  *   queryVector: { float32: [...] },
  *   topK: 5
  * })
  * ```
  */ index(indexName) {
        return new $281a441cdcb2cf36$var$VectorIndexScope(this.url, this.headers, this.vectorBucketName, indexName, this.fetch);
    }
};
var $281a441cdcb2cf36$var$VectorIndexScope = class extends $281a441cdcb2cf36$var$VectorDataApi {
    /**
  *
  * @alpha
  *
  * Creates a helper that automatically scopes all vector operations to the provided bucket/index names.
  *
  * **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
  *
  * @category Vector Buckets
  * @example Creating a vector index scope
  * ```typescript
  * const index = supabase.storage.vectors.from('embeddings-prod').index('documents-openai')
  * ```
  */ constructor(url2, headers, vectorBucketName, indexName, fetch$1){
        super(url2, headers, fetch$1);
        this.vectorBucketName = vectorBucketName;
        this.indexName = indexName;
    }
    /**
  *
  * @alpha
  *
  * Inserts or updates vectors in this index
  * Convenience method that automatically includes bucket and index names
  *
  * **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
  *
  * @category Vector Buckets
  * @param options - Vector insertion options (bucket and index names automatically set)
  * @returns Promise with empty response on success or error
  *
  * @example Insert vectors into an index
  * ```typescript
  * const index = supabase.storage.vectors.from('embeddings-prod').index('documents-openai')
  * await index.putVectors({
  *   vectors: [
  *     {
  *       key: 'doc-1',
  *       data: { float32: [0.1, 0.2, ...] },
  *       metadata: { title: 'Introduction', page: 1 }
  *     }
  *   ]
  * })
  * ```
  */ async putVectors(options) {
        var _superprop_getPutVectors = ()=>super.putVectors, _this9 = this;
        return _superprop_getPutVectors().call(_this9, $281a441cdcb2cf36$var$_objectSpread22($281a441cdcb2cf36$var$_objectSpread22({}, options), {}, {
            vectorBucketName: _this9.vectorBucketName,
            indexName: _this9.indexName
        }));
    }
    /**
  *
  * @alpha
  *
  * Retrieves vectors by keys from this index
  * Convenience method that automatically includes bucket and index names
  *
  * **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
  *
  * @category Vector Buckets
  * @param options - Vector retrieval options (bucket and index names automatically set)
  * @returns Promise with response containing vectors array or error
  *
  * @example Get vectors by keys
  * ```typescript
  * const index = supabase.storage.vectors.from('embeddings-prod').index('documents-openai')
  * const { data } = await index.getVectors({
  *   keys: ['doc-1', 'doc-2'],
  *   returnMetadata: true
  * })
  * ```
  */ async getVectors(options) {
        var _superprop_getGetVectors = ()=>super.getVectors, _this10 = this;
        return _superprop_getGetVectors().call(_this10, $281a441cdcb2cf36$var$_objectSpread22($281a441cdcb2cf36$var$_objectSpread22({}, options), {}, {
            vectorBucketName: _this10.vectorBucketName,
            indexName: _this10.indexName
        }));
    }
    /**
  *
  * @alpha
  *
  * Lists vectors in this index with pagination
  * Convenience method that automatically includes bucket and index names
  *
  * **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
  *
  * @category Vector Buckets
  * @param options - Listing options (bucket and index names automatically set)
  * @returns Promise with response containing vectors array and pagination token or error
  *
  * @example List vectors with pagination
  * ```typescript
  * const index = supabase.storage.vectors.from('embeddings-prod').index('documents-openai')
  * const { data } = await index.listVectors({
  *   maxResults: 500,
  *   returnMetadata: true
  * })
  * ```
  */ async listVectors(options = {}) {
        var _superprop_getListVectors = ()=>super.listVectors, _this11 = this;
        return _superprop_getListVectors().call(_this11, $281a441cdcb2cf36$var$_objectSpread22($281a441cdcb2cf36$var$_objectSpread22({}, options), {}, {
            vectorBucketName: _this11.vectorBucketName,
            indexName: _this11.indexName
        }));
    }
    /**
  *
  * @alpha
  *
  * Queries for similar vectors in this index
  * Convenience method that automatically includes bucket and index names
  *
  * **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
  *
  * @category Vector Buckets
  * @param options - Query options (bucket and index names automatically set)
  * @returns Promise with response containing matches array of similar vectors ordered by distance or error
  *
  * @example Query similar vectors
  * ```typescript
  * const index = supabase.storage.vectors.from('embeddings-prod').index('documents-openai')
  * const { data } = await index.queryVectors({
  *   queryVector: { float32: [0.1, 0.2, ...] },
  *   topK: 5,
  *   filter: { category: 'technical' },
  *   returnDistance: true,
  *   returnMetadata: true
  * })
  * ```
  */ async queryVectors(options) {
        var _superprop_getQueryVectors = ()=>super.queryVectors, _this12 = this;
        return _superprop_getQueryVectors().call(_this12, $281a441cdcb2cf36$var$_objectSpread22($281a441cdcb2cf36$var$_objectSpread22({}, options), {}, {
            vectorBucketName: _this12.vectorBucketName,
            indexName: _this12.indexName
        }));
    }
    /**
  *
  * @alpha
  *
  * Deletes vectors by keys from this index
  * Convenience method that automatically includes bucket and index names
  *
  * **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
  *
  * @category Vector Buckets
  * @param options - Deletion options (bucket and index names automatically set)
  * @returns Promise with empty response on success or error
  *
  * @example Delete vectors by keys
  * ```typescript
  * const index = supabase.storage.vectors.from('embeddings-prod').index('documents-openai')
  * await index.deleteVectors({
  *   keys: ['doc-1', 'doc-2', 'doc-3']
  * })
  * ```
  */ async deleteVectors(options) {
        var _superprop_getDeleteVectors = ()=>super.deleteVectors, _this13 = this;
        return _superprop_getDeleteVectors().call(_this13, $281a441cdcb2cf36$var$_objectSpread22($281a441cdcb2cf36$var$_objectSpread22({}, options), {}, {
            vectorBucketName: _this13.vectorBucketName,
            indexName: _this13.indexName
        }));
    }
};
var $281a441cdcb2cf36$var$StorageClient = class extends $281a441cdcb2cf36$var$StorageBucketApi {
    /**
  * Creates a client for Storage buckets, files, analytics, and vectors.
  *
  * @category File Buckets
  * @example Using supabase-js (recommended)
  * ```ts
  * import { createClient } from '@supabase/supabase-js'
  *
  * const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
  * const avatars = supabase.storage.from('avatars')
  * ```
  *
  * @example Standalone import for bundle-sensitive environments
  * ```ts
  * import { StorageClient } from '@supabase/storage-js'
  *
  * const storage = new StorageClient('https://xyzcompany.supabase.co/storage/v1', {
  *   apikey: 'your-publishable-key',
  * })
  * const avatars = storage.from('avatars')
  * ```
  */ constructor(url2, headers = {}, fetch$1, opts){
        super(url2, headers, fetch$1, opts);
    }
    /**
  * Perform file operation in a bucket.
  *
  * @category File Buckets
  * @param id The bucket id to operate on.
  *
  * @example Accessing a bucket
  * ```typescript
  * const avatars = supabase.storage.from('avatars')
  * ```
  */ from(id2) {
        return new $281a441cdcb2cf36$var$StorageFileApi(this.url, this.headers, id2, this.fetch);
    }
    /**
  *
  * @alpha
  *
  * Access vector storage operations.
  *
  * **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
  *
  * @category Vector Buckets
  * @returns A StorageVectorsClient instance configured with the current storage settings.
  */ get vectors() {
        return new $281a441cdcb2cf36$var$StorageVectorsClient(this.url + "/vector", {
            headers: this.headers,
            fetch: this.fetch
        });
    }
    /**
  *
  * @alpha
  *
  * Access analytics storage operations using Iceberg tables.
  *
  * **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
  *
  * @category Analytics Buckets
  * @returns A StorageAnalyticsClient instance configured with the current storage settings.
  */ get analytics() {
        return new $281a441cdcb2cf36$var$StorageAnalyticsClient(this.url + "/iceberg", this.headers, this.fetch);
    }
};
// ../node_modules/@supabase/auth-js/dist/module/lib/version.js
var $281a441cdcb2cf36$var$version4 = "2.105.1";
// ../node_modules/@supabase/auth-js/dist/module/lib/constants.js
var $281a441cdcb2cf36$var$AUTO_REFRESH_TICK_DURATION_MS = 30000;
var $281a441cdcb2cf36$var$AUTO_REFRESH_TICK_THRESHOLD = 3;
var $281a441cdcb2cf36$var$EXPIRY_MARGIN_MS = $281a441cdcb2cf36$var$AUTO_REFRESH_TICK_THRESHOLD * $281a441cdcb2cf36$var$AUTO_REFRESH_TICK_DURATION_MS;
var $281a441cdcb2cf36$var$GOTRUE_URL = "http://localhost:9999";
var $281a441cdcb2cf36$var$STORAGE_KEY2 = "supabase.auth.token";
var $281a441cdcb2cf36$var$DEFAULT_HEADERS2 = {
    "X-Client-Info": `gotrue-js/${$281a441cdcb2cf36$var$version4}`
};
var $281a441cdcb2cf36$var$API_VERSION_HEADER_NAME = "X-Supabase-Api-Version";
var $281a441cdcb2cf36$var$API_VERSIONS = {
    "2024-01-01": {
        timestamp: Date.parse("2024-01-01T00:00:00.0Z"),
        name: "2024-01-01"
    }
};
var $281a441cdcb2cf36$var$BASE64URL_REGEX = /^([a-z0-9_-]{4})*($|[a-z0-9_-]{3}$|[a-z0-9_-]{2}$)$/i;
var $281a441cdcb2cf36$var$JWKS_TTL = 600000;
// ../node_modules/@supabase/auth-js/dist/module/lib/errors.js
var $281a441cdcb2cf36$var$AuthError = class extends Error {
    constructor(message, status, code){
        super(message);
        this.__isAuthError = true;
        this.name = "AuthError";
        this.status = status;
        this.code = code;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status,
            code: this.code
        };
    }
};
function $281a441cdcb2cf36$var$isAuthError(error) {
    return typeof error === "object" && error !== null && "__isAuthError" in error;
}
var $281a441cdcb2cf36$var$AuthApiError = class extends $281a441cdcb2cf36$var$AuthError {
    constructor(message, status, code){
        super(message, status, code);
        this.name = "AuthApiError";
        this.status = status;
        this.code = code;
    }
};
function $281a441cdcb2cf36$var$isAuthApiError(error) {
    return $281a441cdcb2cf36$var$isAuthError(error) && error.name === "AuthApiError";
}
var $281a441cdcb2cf36$var$AuthUnknownError = class extends $281a441cdcb2cf36$var$AuthError {
    constructor(message, originalError){
        super(message);
        this.name = "AuthUnknownError";
        this.originalError = originalError;
    }
};
var $281a441cdcb2cf36$var$CustomAuthError = class extends $281a441cdcb2cf36$var$AuthError {
    constructor(message, name, status, code){
        super(message, status, code);
        this.name = name;
        this.status = status;
    }
};
var $281a441cdcb2cf36$var$AuthSessionMissingError = class extends $281a441cdcb2cf36$var$CustomAuthError {
    constructor(){
        super("Auth session missing!", "AuthSessionMissingError", 400, void 0);
    }
};
function $281a441cdcb2cf36$var$isAuthSessionMissingError(error) {
    return $281a441cdcb2cf36$var$isAuthError(error) && error.name === "AuthSessionMissingError";
}
var $281a441cdcb2cf36$var$AuthInvalidTokenResponseError = class extends $281a441cdcb2cf36$var$CustomAuthError {
    constructor(){
        super("Auth session or user missing", "AuthInvalidTokenResponseError", 500, void 0);
    }
};
var $281a441cdcb2cf36$var$AuthInvalidCredentialsError = class extends $281a441cdcb2cf36$var$CustomAuthError {
    constructor(message){
        super(message, "AuthInvalidCredentialsError", 400, void 0);
    }
};
var $281a441cdcb2cf36$var$AuthImplicitGrantRedirectError = class extends $281a441cdcb2cf36$var$CustomAuthError {
    constructor(message, details = null){
        super(message, "AuthImplicitGrantRedirectError", 500, void 0);
        this.details = null;
        this.details = details;
    }
    toJSON() {
        return Object.assign(Object.assign({}, super.toJSON()), {
            details: this.details
        });
    }
};
function $281a441cdcb2cf36$var$isAuthImplicitGrantRedirectError(error) {
    return $281a441cdcb2cf36$var$isAuthError(error) && error.name === "AuthImplicitGrantRedirectError";
}
var $281a441cdcb2cf36$var$AuthPKCEGrantCodeExchangeError = class extends $281a441cdcb2cf36$var$CustomAuthError {
    constructor(message, details = null){
        super(message, "AuthPKCEGrantCodeExchangeError", 500, void 0);
        this.details = null;
        this.details = details;
    }
    toJSON() {
        return Object.assign(Object.assign({}, super.toJSON()), {
            details: this.details
        });
    }
};
var $281a441cdcb2cf36$var$AuthPKCECodeVerifierMissingError = class extends $281a441cdcb2cf36$var$CustomAuthError {
    constructor(){
        super("PKCE code verifier not found in storage. This can happen if the auth flow was initiated in a different browser or device, or if the storage was cleared. For SSR frameworks (Next.js, SvelteKit, etc.), use @supabase/ssr on both the server and client to store the code verifier in cookies.", "AuthPKCECodeVerifierMissingError", 400, "pkce_code_verifier_not_found");
    }
};
var $281a441cdcb2cf36$var$AuthRetryableFetchError = class extends $281a441cdcb2cf36$var$CustomAuthError {
    constructor(message, status){
        super(message, "AuthRetryableFetchError", status, void 0);
    }
};
function $281a441cdcb2cf36$var$isAuthRetryableFetchError(error) {
    return $281a441cdcb2cf36$var$isAuthError(error) && error.name === "AuthRetryableFetchError";
}
var $281a441cdcb2cf36$var$AuthWeakPasswordError = class extends $281a441cdcb2cf36$var$CustomAuthError {
    constructor(message, status, reasons){
        super(message, "AuthWeakPasswordError", status, "weak_password");
        this.reasons = reasons;
    }
    toJSON() {
        return Object.assign(Object.assign({}, super.toJSON()), {
            reasons: this.reasons
        });
    }
};
var $281a441cdcb2cf36$var$AuthInvalidJwtError = class extends $281a441cdcb2cf36$var$CustomAuthError {
    constructor(message){
        super(message, "AuthInvalidJwtError", 400, "invalid_jwt");
    }
};
// ../node_modules/@supabase/auth-js/dist/module/lib/base64url.js
var $281a441cdcb2cf36$var$TO_BASE64URL = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_".split("");
var $281a441cdcb2cf36$var$IGNORE_BASE64URL = " 	\n\r=".split("");
var $281a441cdcb2cf36$var$FROM_BASE64URL = (()=>{
    const charMap = new Array(128);
    for(let i3 = 0; i3 < charMap.length; i3 += 1)charMap[i3] = -1;
    for(let i3 = 0; i3 < $281a441cdcb2cf36$var$IGNORE_BASE64URL.length; i3 += 1)charMap[$281a441cdcb2cf36$var$IGNORE_BASE64URL[i3].charCodeAt(0)] = -2;
    for(let i3 = 0; i3 < $281a441cdcb2cf36$var$TO_BASE64URL.length; i3 += 1)charMap[$281a441cdcb2cf36$var$TO_BASE64URL[i3].charCodeAt(0)] = i3;
    return charMap;
})();
function $281a441cdcb2cf36$var$byteToBase64URL(byte, state, emit) {
    if (byte !== null) {
        state.queue = state.queue << 8 | byte;
        state.queuedBits += 8;
        while(state.queuedBits >= 6){
            const pos = state.queue >> state.queuedBits - 6 & 63;
            emit($281a441cdcb2cf36$var$TO_BASE64URL[pos]);
            state.queuedBits -= 6;
        }
    } else if (state.queuedBits > 0) {
        state.queue = state.queue << 6 - state.queuedBits;
        state.queuedBits = 6;
        while(state.queuedBits >= 6){
            const pos = state.queue >> state.queuedBits - 6 & 63;
            emit($281a441cdcb2cf36$var$TO_BASE64URL[pos]);
            state.queuedBits -= 6;
        }
    }
}
function $281a441cdcb2cf36$var$byteFromBase64URL(charCode, state, emit) {
    const bits = $281a441cdcb2cf36$var$FROM_BASE64URL[charCode];
    if (bits > -1) {
        state.queue = state.queue << 6 | bits;
        state.queuedBits += 6;
        while(state.queuedBits >= 8){
            emit(state.queue >> state.queuedBits - 8 & 255);
            state.queuedBits -= 8;
        }
    } else if (bits === -2) return;
    else throw new Error(`Invalid Base64-URL character "${String.fromCharCode(charCode)}"`);
}
function $281a441cdcb2cf36$var$stringFromBase64URL(str) {
    const conv = [];
    const utf8Emit = (codepoint)=>{
        conv.push(String.fromCodePoint(codepoint));
    };
    const utf8State = {
        utf8seq: 0,
        codepoint: 0
    };
    const b64State = {
        queue: 0,
        queuedBits: 0
    };
    const byteEmit = (byte)=>{
        $281a441cdcb2cf36$var$stringFromUTF8(byte, utf8State, utf8Emit);
    };
    for(let i3 = 0; i3 < str.length; i3 += 1)$281a441cdcb2cf36$var$byteFromBase64URL(str.charCodeAt(i3), b64State, byteEmit);
    return conv.join("");
}
function $281a441cdcb2cf36$var$codepointToUTF8(codepoint, emit) {
    if (codepoint <= 127) {
        emit(codepoint);
        return;
    } else if (codepoint <= 2047) {
        emit(192 | codepoint >> 6);
        emit(128 | codepoint & 63);
        return;
    } else if (codepoint <= 65535) {
        emit(224 | codepoint >> 12);
        emit(128 | codepoint >> 6 & 63);
        emit(128 | codepoint & 63);
        return;
    } else if (codepoint <= 1114111) {
        emit(240 | codepoint >> 18);
        emit(128 | codepoint >> 12 & 63);
        emit(128 | codepoint >> 6 & 63);
        emit(128 | codepoint & 63);
        return;
    }
    throw new Error(`Unrecognized Unicode codepoint: ${codepoint.toString(16)}`);
}
function $281a441cdcb2cf36$var$stringToUTF8(str, emit) {
    for(let i3 = 0; i3 < str.length; i3 += 1){
        let codepoint = str.charCodeAt(i3);
        if (codepoint > 55295 && codepoint <= 56319) {
            const highSurrogate = (codepoint - 55296) * 1024 & 65535;
            const lowSurrogate = str.charCodeAt(i3 + 1) - 56320 & 65535;
            codepoint = (lowSurrogate | highSurrogate) + 65536;
            i3 += 1;
        }
        $281a441cdcb2cf36$var$codepointToUTF8(codepoint, emit);
    }
}
function $281a441cdcb2cf36$var$stringFromUTF8(byte, state, emit) {
    if (state.utf8seq === 0) {
        if (byte <= 127) {
            emit(byte);
            return;
        }
        for(let leadingBit = 1; leadingBit < 6; leadingBit += 1)if ((byte >> 7 - leadingBit & 1) === 0) {
            state.utf8seq = leadingBit;
            break;
        }
        if (state.utf8seq === 2) state.codepoint = byte & 31;
        else if (state.utf8seq === 3) state.codepoint = byte & 15;
        else if (state.utf8seq === 4) state.codepoint = byte & 7;
        else throw new Error("Invalid UTF-8 sequence");
        state.utf8seq -= 1;
    } else if (state.utf8seq > 0) {
        if (byte <= 127) throw new Error("Invalid UTF-8 sequence");
        state.codepoint = state.codepoint << 6 | byte & 63;
        state.utf8seq -= 1;
        if (state.utf8seq === 0) emit(state.codepoint);
    }
}
function $281a441cdcb2cf36$var$base64UrlToUint8Array(str) {
    const result = [];
    const state = {
        queue: 0,
        queuedBits: 0
    };
    const onByte = (byte)=>{
        result.push(byte);
    };
    for(let i3 = 0; i3 < str.length; i3 += 1)$281a441cdcb2cf36$var$byteFromBase64URL(str.charCodeAt(i3), state, onByte);
    return new Uint8Array(result);
}
function $281a441cdcb2cf36$var$stringToUint8Array(str) {
    const result = [];
    $281a441cdcb2cf36$var$stringToUTF8(str, (byte)=>result.push(byte));
    return new Uint8Array(result);
}
function $281a441cdcb2cf36$var$bytesToBase64URL(bytes) {
    const result = [];
    const state = {
        queue: 0,
        queuedBits: 0
    };
    const onChar = (char)=>{
        result.push(char);
    };
    bytes.forEach((byte)=>$281a441cdcb2cf36$var$byteToBase64URL(byte, state, onChar));
    $281a441cdcb2cf36$var$byteToBase64URL(null, state, onChar);
    return result.join("");
}
// ../node_modules/@supabase/auth-js/dist/module/lib/helpers.js
function $281a441cdcb2cf36$var$expiresAt(expiresIn) {
    const timeNow = Math.round(Date.now() / 1e3);
    return timeNow + expiresIn;
}
function $281a441cdcb2cf36$var$generateCallbackId() {
    return /* @__PURE__ */ Symbol("auth-callback");
}
var $281a441cdcb2cf36$var$isBrowser3 = ()=>typeof window !== "undefined" && typeof document !== "undefined";
var $281a441cdcb2cf36$var$localStorageWriteTests = {
    tested: false,
    writable: false
};
var $281a441cdcb2cf36$var$supportsLocalStorage = ()=>{
    if (!$281a441cdcb2cf36$var$isBrowser3()) return false;
    try {
        if (typeof globalThis.localStorage !== "object") return false;
    } catch (e4) {
        return false;
    }
    if ($281a441cdcb2cf36$var$localStorageWriteTests.tested) return $281a441cdcb2cf36$var$localStorageWriteTests.writable;
    const randomKey = `lswt-${Math.random()}${Math.random()}`;
    try {
        globalThis.localStorage.setItem(randomKey, randomKey);
        globalThis.localStorage.removeItem(randomKey);
        $281a441cdcb2cf36$var$localStorageWriteTests.tested = true;
        $281a441cdcb2cf36$var$localStorageWriteTests.writable = true;
    } catch (e4) {
        $281a441cdcb2cf36$var$localStorageWriteTests.tested = true;
        $281a441cdcb2cf36$var$localStorageWriteTests.writable = false;
    }
    return $281a441cdcb2cf36$var$localStorageWriteTests.writable;
};
function $281a441cdcb2cf36$var$parseParametersFromURL(href) {
    const result = {};
    const url2 = new URL(href);
    if (url2.hash && url2.hash[0] === "#") try {
        const hashSearchParams = new URLSearchParams(url2.hash.substring(1));
        hashSearchParams.forEach((value2, key)=>{
            result[key] = value2;
        });
    } catch (e4) {}
    url2.searchParams.forEach((value2, key)=>{
        result[key] = value2;
    });
    return result;
}
var $281a441cdcb2cf36$var$resolveFetch3 = (customFetch)=>{
    if (customFetch) return (...args2)=>customFetch(...args2);
    return (...args2)=>fetch(...args2);
};
var $281a441cdcb2cf36$var$looksLikeFetchResponse = (maybeResponse)=>{
    return typeof maybeResponse === "object" && maybeResponse !== null && "status" in maybeResponse && "ok" in maybeResponse && "json" in maybeResponse && typeof maybeResponse.json === "function";
};
var $281a441cdcb2cf36$var$setItemAsync = async (storage, key, data2)=>{
    await storage.setItem(key, JSON.stringify(data2));
};
var $281a441cdcb2cf36$var$getItemAsync = async (storage, key)=>{
    const value2 = await storage.getItem(key);
    if (!value2) return null;
    try {
        return JSON.parse(value2);
    } catch (_a2) {
        return value2;
    }
};
var $281a441cdcb2cf36$var$removeItemAsync = async (storage, key)=>{
    await storage.removeItem(key);
};
var $281a441cdcb2cf36$var$Deferred2 = class _Deferred {
    constructor(){
        this.promise = new _Deferred.promiseConstructor((res, rej)=>{
            this.resolve = res;
            this.reject = rej;
        });
    }
};
$281a441cdcb2cf36$var$Deferred2.promiseConstructor = Promise;
function $281a441cdcb2cf36$var$decodeJWT(token) {
    const parts2 = token.split(".");
    if (parts2.length !== 3) throw new $281a441cdcb2cf36$var$AuthInvalidJwtError("Invalid JWT structure");
    for(let i3 = 0; i3 < parts2.length; i3++){
        if (!$281a441cdcb2cf36$var$BASE64URL_REGEX.test(parts2[i3])) throw new $281a441cdcb2cf36$var$AuthInvalidJwtError("JWT not in base64url format");
    }
    const data2 = {
        // using base64url lib
        header: JSON.parse($281a441cdcb2cf36$var$stringFromBase64URL(parts2[0])),
        payload: JSON.parse($281a441cdcb2cf36$var$stringFromBase64URL(parts2[1])),
        signature: $281a441cdcb2cf36$var$base64UrlToUint8Array(parts2[2]),
        raw: {
            header: parts2[0],
            payload: parts2[1]
        }
    };
    return data2;
}
async function $281a441cdcb2cf36$var$sleep2(time) {
    return await new Promise((accept)=>{
        setTimeout(()=>accept(null), time);
    });
}
function $281a441cdcb2cf36$var$retryable(fn, isRetryable) {
    const promise = new Promise((accept, reject)=>{
        (async ()=>{
            for(let attempt = 0; attempt < Infinity; attempt++)try {
                const result = await fn(attempt);
                if (!isRetryable(attempt, null, result)) {
                    accept(result);
                    return;
                }
            } catch (e4) {
                if (!isRetryable(attempt, e4)) {
                    reject(e4);
                    return;
                }
            }
        })();
    });
    return promise;
}
function $281a441cdcb2cf36$var$dec2hex(dec) {
    return ("0" + dec.toString(16)).substr(-2);
}
function $281a441cdcb2cf36$var$generatePKCEVerifier() {
    const verifierLength = 56;
    const array = new Uint32Array(verifierLength);
    if (typeof crypto === "undefined") {
        const charSet = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";
        const charSetLen = charSet.length;
        let verifier = "";
        for(let i3 = 0; i3 < verifierLength; i3++)verifier += charSet.charAt(Math.floor(Math.random() * charSetLen));
        return verifier;
    }
    crypto.getRandomValues(array);
    return Array.from(array, $281a441cdcb2cf36$var$dec2hex).join("");
}
async function $281a441cdcb2cf36$var$sha256(randomString2) {
    const encoder = new TextEncoder();
    const encodedData = encoder.encode(randomString2);
    const hash = await crypto.subtle.digest("SHA-256", encodedData);
    const bytes = new Uint8Array(hash);
    return Array.from(bytes).map((c3)=>String.fromCharCode(c3)).join("");
}
async function $281a441cdcb2cf36$var$generatePKCEChallenge(verifier) {
    const hasCryptoSupport = typeof crypto !== "undefined" && typeof crypto.subtle !== "undefined" && typeof TextEncoder !== "undefined";
    if (!hasCryptoSupport) {
        console.warn("WebCrypto API is not supported. Code challenge method will default to use plain instead of sha256.");
        return verifier;
    }
    const hashed = await $281a441cdcb2cf36$var$sha256(verifier);
    return btoa(hashed).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
async function $281a441cdcb2cf36$var$getCodeChallengeAndMethod(storage, storageKey, isPasswordRecovery = false) {
    const codeVerifier = $281a441cdcb2cf36$var$generatePKCEVerifier();
    let storedCodeVerifier = codeVerifier;
    if (isPasswordRecovery) storedCodeVerifier += "/recovery";
    await $281a441cdcb2cf36$var$setItemAsync(storage, `${storageKey}-code-verifier`, storedCodeVerifier);
    const codeChallenge = await $281a441cdcb2cf36$var$generatePKCEChallenge(codeVerifier);
    const codeChallengeMethod = codeVerifier === codeChallenge ? "plain" : "s256";
    return [
        codeChallenge,
        codeChallengeMethod
    ];
}
var $281a441cdcb2cf36$var$API_VERSION_REGEX = /^2[0-9]{3}-(0[1-9]|1[0-2])-(0[1-9]|1[0-9]|2[0-9]|3[0-1])$/i;
function $281a441cdcb2cf36$var$parseResponseAPIVersion(response) {
    const apiVersion = response.headers.get($281a441cdcb2cf36$var$API_VERSION_HEADER_NAME);
    if (!apiVersion) return null;
    if (!apiVersion.match($281a441cdcb2cf36$var$API_VERSION_REGEX)) return null;
    try {
        const date = /* @__PURE__ */ new Date(`${apiVersion}T00:00:00.0Z`);
        return date;
    } catch (e4) {
        return null;
    }
}
function $281a441cdcb2cf36$var$validateExp(exp) {
    if (!exp) throw new Error("Missing exp claim");
    const timeNow = Math.floor(Date.now() / 1e3);
    if (exp <= timeNow) throw new Error("JWT has expired");
}
function $281a441cdcb2cf36$var$getAlgorithm(alg) {
    switch(alg){
        case "RS256":
            return {
                name: "RSASSA-PKCS1-v1_5",
                hash: {
                    name: "SHA-256"
                }
            };
        case "ES256":
            return {
                name: "ECDSA",
                namedCurve: "P-256",
                hash: {
                    name: "SHA-256"
                }
            };
        default:
            throw new Error("Invalid alg claim");
    }
}
var $281a441cdcb2cf36$var$UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;
function $281a441cdcb2cf36$var$validateUUID(str) {
    if (!$281a441cdcb2cf36$var$UUID_REGEX.test(str)) throw new Error("@supabase/auth-js: Expected parameter to be UUID but is not");
}
function $281a441cdcb2cf36$var$assertPasskeyExperimentalEnabled(experimental) {
    if (!experimental.passkey) throw new Error("@supabase/auth-js: the passkey API is experimental and disabled by default. Enable it by passing `auth: { experimental: { passkey: true } }` to createClient (or to the GoTrueClient constructor).");
}
function $281a441cdcb2cf36$var$userNotAvailableProxy() {
    const proxyTarget = {};
    return new Proxy(proxyTarget, {
        get: (target, prop)=>{
            if (prop === "__isUserNotAvailableProxy") return true;
            if (typeof prop === "symbol") {
                const sProp = prop.toString();
                if (sProp === "Symbol(Symbol.toPrimitive)" || sProp === "Symbol(Symbol.toStringTag)" || sProp === "Symbol(util.inspect.custom)") return void 0;
            }
            throw new Error(`@supabase/auth-js: client was created with userStorage option and there was no user stored in the user storage. Accessing the "${prop}" property of the session object is not supported. Please use getUser() instead.`);
        },
        set: (_target, prop)=>{
            throw new Error(`@supabase/auth-js: client was created with userStorage option and there was no user stored in the user storage. Setting the "${prop}" property of the session object is not supported. Please use getUser() to fetch a user object you can manipulate.`);
        },
        deleteProperty: (_target, prop)=>{
            throw new Error(`@supabase/auth-js: client was created with userStorage option and there was no user stored in the user storage. Deleting the "${prop}" property of the session object is not supported. Please use getUser() to fetch a user object you can manipulate.`);
        }
    });
}
function $281a441cdcb2cf36$var$insecureUserWarningProxy(user, suppressWarningRef) {
    return new Proxy(user, {
        get: (target, prop, receiver)=>{
            if (prop === "__isInsecureUserWarningProxy") return true;
            if (typeof prop === "symbol") {
                const sProp = prop.toString();
                if (sProp === "Symbol(Symbol.toPrimitive)" || sProp === "Symbol(Symbol.toStringTag)" || sProp === "Symbol(util.inspect.custom)" || sProp === "Symbol(nodejs.util.inspect.custom)") return Reflect.get(target, prop, receiver);
            }
            if (!suppressWarningRef.value && typeof prop === "string") {
                console.warn("Using the user object as returned from supabase.auth.getSession() or from some supabase.auth.onAuthStateChange() events could be insecure! This value comes directly from the storage medium (usually cookies on the server) and may not be authentic. Use supabase.auth.getUser() instead which authenticates the data by contacting the Supabase Auth server.");
                suppressWarningRef.value = true;
            }
            return Reflect.get(target, prop, receiver);
        }
    });
}
function $281a441cdcb2cf36$var$deepClone(obj) {
    return JSON.parse(JSON.stringify(obj));
}
// ../node_modules/@supabase/auth-js/dist/module/lib/fetch.js
var $281a441cdcb2cf36$var$_getErrorMessage2 = (err)=>err.msg || err.message || err.error_description || err.error || JSON.stringify(err);
var $281a441cdcb2cf36$var$NETWORK_ERROR_CODES = [
    502,
    503,
    504,
    520,
    521,
    522,
    523,
    524,
    530
];
async function $281a441cdcb2cf36$var$handleError2(error) {
    var _a2;
    if (!$281a441cdcb2cf36$var$looksLikeFetchResponse(error)) throw new $281a441cdcb2cf36$var$AuthRetryableFetchError($281a441cdcb2cf36$var$_getErrorMessage2(error), 0);
    if ($281a441cdcb2cf36$var$NETWORK_ERROR_CODES.includes(error.status)) throw new $281a441cdcb2cf36$var$AuthRetryableFetchError($281a441cdcb2cf36$var$_getErrorMessage2(error), error.status);
    let data2;
    try {
        data2 = await error.json();
    } catch (e4) {
        throw new $281a441cdcb2cf36$var$AuthUnknownError($281a441cdcb2cf36$var$_getErrorMessage2(e4), e4);
    }
    let errorCode = void 0;
    const responseAPIVersion = $281a441cdcb2cf36$var$parseResponseAPIVersion(error);
    if (responseAPIVersion && responseAPIVersion.getTime() >= $281a441cdcb2cf36$var$API_VERSIONS["2024-01-01"].timestamp && typeof data2 === "object" && data2 && typeof data2.code === "string") errorCode = data2.code;
    else if (typeof data2 === "object" && data2 && typeof data2.error_code === "string") errorCode = data2.error_code;
    if (!errorCode) {
        if (typeof data2 === "object" && data2 && typeof data2.weak_password === "object" && data2.weak_password && Array.isArray(data2.weak_password.reasons) && data2.weak_password.reasons.length && data2.weak_password.reasons.reduce((a3, i3)=>a3 && typeof i3 === "string", true)) throw new $281a441cdcb2cf36$var$AuthWeakPasswordError($281a441cdcb2cf36$var$_getErrorMessage2(data2), error.status, data2.weak_password.reasons);
    } else if (errorCode === "weak_password") throw new $281a441cdcb2cf36$var$AuthWeakPasswordError($281a441cdcb2cf36$var$_getErrorMessage2(data2), error.status, ((_a2 = data2.weak_password) === null || _a2 === void 0 ? void 0 : _a2.reasons) || []);
    else if (errorCode === "session_not_found") throw new $281a441cdcb2cf36$var$AuthSessionMissingError();
    throw new $281a441cdcb2cf36$var$AuthApiError($281a441cdcb2cf36$var$_getErrorMessage2(data2), error.status || 500, errorCode);
}
var $281a441cdcb2cf36$var$_getRequestParams2 = (method, options, parameters, body)=>{
    const params2 = {
        method: method,
        headers: (options === null || options === void 0 ? void 0 : options.headers) || {}
    };
    if (method === "GET") return params2;
    params2.headers = Object.assign({
        "Content-Type": "application/json;charset=UTF-8"
    }, options === null || options === void 0 ? void 0 : options.headers);
    params2.body = JSON.stringify(body);
    return Object.assign(Object.assign({}, params2), parameters);
};
async function $281a441cdcb2cf36$var$_request(fetcher, method, url2, options) {
    var _a2;
    const headers = Object.assign({}, options === null || options === void 0 ? void 0 : options.headers);
    if (!headers[$281a441cdcb2cf36$var$API_VERSION_HEADER_NAME]) headers[$281a441cdcb2cf36$var$API_VERSION_HEADER_NAME] = $281a441cdcb2cf36$var$API_VERSIONS["2024-01-01"].name;
    if (options === null || options === void 0 ? void 0 : options.jwt) headers["Authorization"] = `Bearer ${options.jwt}`;
    const qs = (_a2 = options === null || options === void 0 ? void 0 : options.query) !== null && _a2 !== void 0 ? _a2 : {};
    if (options === null || options === void 0 ? void 0 : options.redirectTo) qs["redirect_to"] = options.redirectTo;
    const queryString = Object.keys(qs).length ? "?" + new URLSearchParams(qs).toString() : "";
    const data2 = await $281a441cdcb2cf36$var$_handleRequest2(fetcher, method, url2 + queryString, {
        headers: headers,
        noResolveJson: options === null || options === void 0 ? void 0 : options.noResolveJson
    }, {}, options === null || options === void 0 ? void 0 : options.body);
    return (options === null || options === void 0 ? void 0 : options.xform) ? options === null || options === void 0 ? void 0 : options.xform(data2) : {
        data: Object.assign({}, data2),
        error: null
    };
}
async function $281a441cdcb2cf36$var$_handleRequest2(fetcher, method, url2, options, parameters, body) {
    const requestParams = $281a441cdcb2cf36$var$_getRequestParams2(method, options, parameters, body);
    let result;
    try {
        result = await fetcher(url2, Object.assign({}, requestParams));
    } catch (e4) {
        console.error(e4);
        throw new $281a441cdcb2cf36$var$AuthRetryableFetchError($281a441cdcb2cf36$var$_getErrorMessage2(e4), 0);
    }
    if (!result.ok) await $281a441cdcb2cf36$var$handleError2(result);
    if (options === null || options === void 0 ? void 0 : options.noResolveJson) return result;
    try {
        return await result.json();
    } catch (e4) {
        await $281a441cdcb2cf36$var$handleError2(e4);
    }
}
function $281a441cdcb2cf36$var$_sessionResponse(data2) {
    var _a2;
    let session = null;
    if ($281a441cdcb2cf36$var$hasSession(data2)) {
        session = Object.assign({}, data2);
        if (!data2.expires_at) session.expires_at = $281a441cdcb2cf36$var$expiresAt(data2.expires_in);
    }
    const user = (_a2 = data2.user) !== null && _a2 !== void 0 ? _a2 : data2;
    return {
        data: {
            session: session,
            user: user
        },
        error: null
    };
}
function $281a441cdcb2cf36$var$_sessionResponsePassword(data2) {
    const response = $281a441cdcb2cf36$var$_sessionResponse(data2);
    if (!response.error && data2.weak_password && typeof data2.weak_password === "object" && Array.isArray(data2.weak_password.reasons) && data2.weak_password.reasons.length && data2.weak_password.message && typeof data2.weak_password.message === "string" && data2.weak_password.reasons.reduce((a3, i3)=>a3 && typeof i3 === "string", true)) response.data.weak_password = data2.weak_password;
    return response;
}
function $281a441cdcb2cf36$var$_userResponse(data2) {
    var _a2;
    const user = (_a2 = data2.user) !== null && _a2 !== void 0 ? _a2 : data2;
    return {
        data: {
            user: user
        },
        error: null
    };
}
function $281a441cdcb2cf36$var$_ssoResponse(data2) {
    return {
        data: data2,
        error: null
    };
}
function $281a441cdcb2cf36$var$_generateLinkResponse(data2) {
    const { action_link: action_link, email_otp: email_otp, hashed_token: hashed_token, redirect_to: redirect_to, verification_type: verification_type } = data2, rest = $281a441cdcb2cf36$var$__rest4(data2, [
        "action_link",
        "email_otp",
        "hashed_token",
        "redirect_to",
        "verification_type"
    ]);
    const properties = {
        action_link: action_link,
        email_otp: email_otp,
        hashed_token: hashed_token,
        redirect_to: redirect_to,
        verification_type: verification_type
    };
    const user = Object.assign({}, rest);
    return {
        data: {
            properties: properties,
            user: user
        },
        error: null
    };
}
function $281a441cdcb2cf36$var$_noResolveJsonResponse(data2) {
    return data2;
}
function $281a441cdcb2cf36$var$hasSession(data2) {
    return data2.access_token && data2.refresh_token && data2.expires_in;
}
// ../node_modules/@supabase/auth-js/dist/module/lib/types.js
var $281a441cdcb2cf36$var$SIGN_OUT_SCOPES = [
    "global",
    "local",
    "others"
];
// ../node_modules/@supabase/auth-js/dist/module/GoTrueAdminApi.js
var $281a441cdcb2cf36$var$GoTrueAdminApi = class {
    /**
   * Creates an admin API client that can be used to manage users and OAuth clients.
   *
   * @example Using supabase-js (recommended)
   * ```ts
   * import { createClient } from '@supabase/supabase-js'
   *
   * const supabase = createClient('https://xyzcompany.supabase.co', 'your-secret-key')
   * const { data, error } = await supabase.auth.admin.listUsers()
   * ```
   *
   * @example Standalone import for bundle-sensitive environments
   * ```ts
   * import { GoTrueAdminApi } from '@supabase/auth-js'
   *
   * const admin = new GoTrueAdminApi({
   *   url: 'https://xyzcompany.supabase.co/auth/v1',
   *   headers: { Authorization: `Bearer ${process.env.SUPABASE_SECRET_KEY}` },
   * })
   * ```
   */ constructor({ url: url2 = "", headers: headers = {}, fetch: fetch2, experimental: experimental }){
        this.url = url2;
        this.headers = headers;
        this.fetch = $281a441cdcb2cf36$var$resolveFetch3(fetch2);
        this.experimental = experimental !== null && experimental !== void 0 ? experimental : {};
        this.mfa = {
            listFactors: this._listFactors.bind(this),
            deleteFactor: this._deleteFactor.bind(this)
        };
        this.oauth = {
            listClients: this._listOAuthClients.bind(this),
            createClient: this._createOAuthClient.bind(this),
            getClient: this._getOAuthClient.bind(this),
            updateClient: this._updateOAuthClient.bind(this),
            deleteClient: this._deleteOAuthClient.bind(this),
            regenerateClientSecret: this._regenerateOAuthClientSecret.bind(this)
        };
        this.customProviders = {
            listProviders: this._listCustomProviders.bind(this),
            createProvider: this._createCustomProvider.bind(this),
            getProvider: this._getCustomProvider.bind(this),
            updateProvider: this._updateCustomProvider.bind(this),
            deleteProvider: this._deleteCustomProvider.bind(this)
        };
        this.passkey = {
            listPasskeys: this._adminListPasskeys.bind(this),
            deletePasskey: this._adminDeletePasskey.bind(this)
        };
    }
    /**
   * Removes a logged-in session.
   * @param jwt A valid, logged-in JWT.
   * @param scope The logout sope.
   *
   * @category Auth
   */ async signOut(jwt, scope = $281a441cdcb2cf36$var$SIGN_OUT_SCOPES[0]) {
        if ($281a441cdcb2cf36$var$SIGN_OUT_SCOPES.indexOf(scope) < 0) throw new Error(`@supabase/auth-js: Parameter scope must be one of ${$281a441cdcb2cf36$var$SIGN_OUT_SCOPES.join(", ")}`);
        try {
            await $281a441cdcb2cf36$var$_request(this.fetch, "POST", `${this.url}/logout?scope=${scope}`, {
                headers: this.headers,
                jwt: jwt,
                noResolveJson: true
            });
            return {
                data: null,
                error: null
            };
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
   * Sends an invite link to an email address.
   * @param email The email address of the user.
   * @param options Additional options to be included when inviting.
   *
   * @category Auth
   *
   * @remarks
   * - Sends an invite link to the user's email address.
   * - The `inviteUserByEmail()` method is typically used by administrators to invite users to join the application.
   * - Note that PKCE is not supported when using `inviteUserByEmail`. This is because the browser initiating the invite is often different from the browser accepting the invite which makes it difficult to provide the security guarantees required of the PKCE flow.
   *
   * @example Invite a user
   * ```js
   * const { data, error } = await supabase.auth.admin.inviteUserByEmail('email@example.com')
   * ```
   *
   * @exampleResponse Invite a user
   * ```json
   * {
   *   "data": {
   *     "user": {
   *       "id": "11111111-1111-1111-1111-111111111111",
   *       "aud": "authenticated",
   *       "role": "authenticated",
   *       "email": "example@email.com",
   *       "invited_at": "2024-01-01T00:00:00Z",
   *       "phone": "",
   *       "confirmation_sent_at": "2024-01-01T00:00:00Z",
   *       "app_metadata": {
   *         "provider": "email",
   *         "providers": [
   *           "email"
   *         ]
   *       },
   *       "user_metadata": {},
   *       "identities": [
   *         {
   *           "identity_id": "22222222-2222-2222-2222-222222222222",
   *           "id": "11111111-1111-1111-1111-111111111111",
   *           "user_id": "11111111-1111-1111-1111-111111111111",
   *           "identity_data": {
   *             "email": "example@email.com",
   *             "email_verified": false,
   *             "phone_verified": false,
   *             "sub": "11111111-1111-1111-1111-111111111111"
   *           },
   *           "provider": "email",
   *           "last_sign_in_at": "2024-01-01T00:00:00Z",
   *           "created_at": "2024-01-01T00:00:00Z",
   *           "updated_at": "2024-01-01T00:00:00Z",
   *           "email": "example@email.com"
   *         }
   *       ],
   *       "created_at": "2024-01-01T00:00:00Z",
   *       "updated_at": "2024-01-01T00:00:00Z",
   *       "is_anonymous": false
   *     }
   *   },
   *   "error": null
   * }
   * ```
   */ async inviteUserByEmail(email, options = {}) {
        try {
            return await $281a441cdcb2cf36$var$_request(this.fetch, "POST", `${this.url}/invite`, {
                body: {
                    email: email,
                    data: options.data
                },
                headers: this.headers,
                redirectTo: options.redirectTo,
                xform: $281a441cdcb2cf36$var$_userResponse
            });
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
   * Generates email links and OTPs to be sent via a custom email provider.
   * @param email The user's email.
   * @param options.password User password. For signup only.
   * @param options.data Optional user metadata. For signup only.
   * @param options.redirectTo The redirect url which should be appended to the generated link
   *
   * @category Auth
   *
   * @remarks
   * - The following types can be passed into `generateLink()`: `signup`, `magiclink`, `invite`, `recovery`, `email_change_current`, `email_change_new`, `phone_change`.
   * - `generateLink()` only generates the email link for `email_change_email` if the **Secure email change** is enabled in your project's [email auth provider settings](/dashboard/project/_/auth/providers).
   * - `generateLink()` handles the creation of the user for `signup`, `invite` and `magiclink`.
   *
   * @example Generate a signup link
   * ```js
   * const { data, error } = await supabase.auth.admin.generateLink({
   *   type: 'signup',
   *   email: 'email@example.com',
   *   password: 'secret'
   * })
   * ```
   *
   * @exampleResponse Generate a signup link
   * ```json
   * {
   *   "data": {
   *     "properties": {
   *       "action_link": "<LINK_TO_SEND_TO_USER>",
   *       "email_otp": "999999",
   *       "hashed_token": "<HASHED_TOKEN",
   *       "redirect_to": "<REDIRECT_URL>",
   *       "verification_type": "signup"
   *     },
   *     "user": {
   *       "id": "11111111-1111-1111-1111-111111111111",
   *       "aud": "authenticated",
   *       "role": "authenticated",
   *       "email": "email@example.com",
   *       "phone": "",
   *       "confirmation_sent_at": "2024-01-01T00:00:00Z",
   *       "app_metadata": {
   *         "provider": "email",
   *         "providers": [
   *           "email"
   *         ]
   *       },
   *       "user_metadata": {},
   *       "identities": [
   *         {
   *           "identity_id": "22222222-2222-2222-2222-222222222222",
   *           "id": "11111111-1111-1111-1111-111111111111",
   *           "user_id": "11111111-1111-1111-1111-111111111111",
   *           "identity_data": {
   *             "email": "email@example.com",
   *             "email_verified": false,
   *             "phone_verified": false,
   *             "sub": "11111111-1111-1111-1111-111111111111"
   *           },
   *           "provider": "email",
   *           "last_sign_in_at": "2024-01-01T00:00:00Z",
   *           "created_at": "2024-01-01T00:00:00Z",
   *           "updated_at": "2024-01-01T00:00:00Z",
   *           "email": "email@example.com"
   *         }
   *       ],
   *       "created_at": "2024-01-01T00:00:00Z",
   *       "updated_at": "2024-01-01T00:00:00Z",
   *       "is_anonymous": false
   *     }
   *   },
   *   "error": null
   * }
   * ```
   *
   * @example Generate an invite link
   * ```js
   * const { data, error } = await supabase.auth.admin.generateLink({
   *   type: 'invite',
   *   email: 'email@example.com'
   * })
   * ```
   *
   * @example Generate a magic link
   * ```js
   * const { data, error } = await supabase.auth.admin.generateLink({
   *   type: 'magiclink',
   *   email: 'email@example.com'
   * })
   * ```
   *
   * @example Generate a recovery link
   * ```js
   * const { data, error } = await supabase.auth.admin.generateLink({
   *   type: 'recovery',
   *   email: 'email@example.com'
   * })
   * ```
   *
   * @example Generate links to change current email address
   * ```js
   * // generate an email change link to be sent to the current email address
   * const { data, error } = await supabase.auth.admin.generateLink({
   *   type: 'email_change_current',
   *   email: 'current.email@example.com',
   *   newEmail: 'new.email@example.com'
   * })
   *
   * // generate an email change link to be sent to the new email address
   * const { data, error } = await supabase.auth.admin.generateLink({
   *   type: 'email_change_new',
   *   email: 'current.email@example.com',
   *   newEmail: 'new.email@example.com'
   * })
   * ```
   */ async generateLink(params2) {
        try {
            const { options: options } = params2, rest = $281a441cdcb2cf36$var$__rest4(params2, [
                "options"
            ]);
            const body = Object.assign(Object.assign({}, rest), options);
            if ("newEmail" in rest) {
                body.new_email = rest === null || rest === void 0 ? void 0 : rest.newEmail;
                delete body["newEmail"];
            }
            return await $281a441cdcb2cf36$var$_request(this.fetch, "POST", `${this.url}/admin/generate_link`, {
                body: body,
                headers: this.headers,
                xform: $281a441cdcb2cf36$var$_generateLinkResponse,
                redirectTo: options === null || options === void 0 ? void 0 : options.redirectTo
            });
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return {
                data: {
                    properties: null,
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    // User Admin API
    /**
   * Creates a new user.
   * This function should only be called on a server. Never expose your `service_role` key in the browser.
   *
   * @category Auth
   *
   * @remarks
   * - To confirm the user's email address or phone number, set `email_confirm` or `phone_confirm` to true. Both arguments default to false.
   * - `createUser()` will not send a confirmation email to the user. You can use [`inviteUserByEmail()`](/docs/reference/javascript/auth-admin-inviteuserbyemail) if you want to send them an email invite instead.
   * - If you are sure that the created user's email or phone number is legitimate and verified, you can set the `email_confirm` or `phone_confirm` param to `true`.
   *
   * @example With custom user metadata
   * ```js
   * const { data, error } = await supabase.auth.admin.createUser({
   *   email: 'user@email.com',
   *   password: 'password',
   *   user_metadata: { name: 'Yoda' }
   * })
   * ```
   *
   * @exampleResponse With custom user metadata
   * ```json
   * {
   *   data: {
   *     user: {
   *       id: '1',
   *       aud: 'authenticated',
   *       role: 'authenticated',
   *       email: 'example@email.com',
   *       email_confirmed_at: '2024-01-01T00:00:00Z',
   *       phone: '',
   *       confirmation_sent_at: '2024-01-01T00:00:00Z',
   *       confirmed_at: '2024-01-01T00:00:00Z',
   *       last_sign_in_at: '2024-01-01T00:00:00Z',
   *       app_metadata: {},
   *       user_metadata: {},
   *       identities: [
   *         {
   *           "identity_id": "22222222-2222-2222-2222-222222222222",
   *           "id": "1",
   *           "user_id": "1",
   *           "identity_data": {
   *             "email": "example@email.com",
   *             "email_verified": true,
   *             "phone_verified": false,
   *             "sub": "1"
   *           },
   *           "provider": "email",
   *           "last_sign_in_at": "2024-01-01T00:00:00Z",
   *           "created_at": "2024-01-01T00:00:00Z",
   *           "updated_at": "2024-01-01T00:00:00Z",
   *           "email": "email@example.com"
   *         },
   *       ],
   *       created_at: '2024-01-01T00:00:00Z',
   *       updated_at: '2024-01-01T00:00:00Z',
   *       is_anonymous: false,
   *     }
   *   }
   *   error: null
   * }
   * ```
   *
   * @example Auto-confirm the user's email
   * ```js
   * const { data, error } = await supabase.auth.admin.createUser({
   *   email: 'user@email.com',
   *   email_confirm: true
   * })
   * ```
   *
   * @example Auto-confirm the user's phone number
   * ```js
   * const { data, error } = await supabase.auth.admin.createUser({
   *   phone: '1234567890',
   *   phone_confirm: true
   * })
   * ```
   */ async createUser(attributes) {
        try {
            return await $281a441cdcb2cf36$var$_request(this.fetch, "POST", `${this.url}/admin/users`, {
                body: attributes,
                headers: this.headers,
                xform: $281a441cdcb2cf36$var$_userResponse
            });
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
   * Get a list of users.
   *
   * This function should only be called on a server. Never expose your `service_role` key in the browser.
   * @param params An object which supports `page` and `perPage` as numbers, to alter the paginated results.
   *
   * @category Auth
   *
   * @remarks
   * - Defaults to return 50 users per page.
   *
   * @example Get a page of users
   * ```js
   * const { data: { users }, error } = await supabase.auth.admin.listUsers()
   * ```
   *
   * @example Paginated list of users
   * ```js
   * const { data: { users }, error } = await supabase.auth.admin.listUsers({
   *   page: 1,
   *   perPage: 1000
   * })
   * ```
   */ async listUsers(params2) {
        var _a2, _b, _c, _d, _e, _f, _g;
        try {
            const pagination = {
                nextPage: null,
                lastPage: 0,
                total: 0
            };
            const response = await $281a441cdcb2cf36$var$_request(this.fetch, "GET", `${this.url}/admin/users`, {
                headers: this.headers,
                noResolveJson: true,
                query: {
                    page: (_b = (_a2 = params2 === null || params2 === void 0 ? void 0 : params2.page) === null || _a2 === void 0 ? void 0 : _a2.toString()) !== null && _b !== void 0 ? _b : "",
                    per_page: (_d = (_c = params2 === null || params2 === void 0 ? void 0 : params2.perPage) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : ""
                },
                xform: $281a441cdcb2cf36$var$_noResolveJsonResponse
            });
            if (response.error) throw response.error;
            const users = await response.json();
            const total = (_e = response.headers.get("x-total-count")) !== null && _e !== void 0 ? _e : 0;
            const links = (_g = (_f = response.headers.get("link")) === null || _f === void 0 ? void 0 : _f.split(",")) !== null && _g !== void 0 ? _g : [];
            if (links.length > 0) {
                links.forEach((link)=>{
                    const page = parseInt(link.split(";")[0].split("=")[1].substring(0, 1));
                    const rel = JSON.parse(link.split(";")[1].split("=")[1]);
                    pagination[`${rel}Page`] = page;
                });
                pagination.total = parseInt(total);
            }
            return {
                data: Object.assign(Object.assign({}, users), pagination),
                error: null
            };
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return {
                data: {
                    users: []
                },
                error: error
            };
            throw error;
        }
    }
    /**
   * Get user by id.
   *
   * @param uid The user's unique identifier
   *
   * This function should only be called on a server. Never expose your `service_role` key in the browser.
   *
   * @category Auth
   *
   * @remarks
   * - Fetches the user object from the database based on the user's id.
   * - The `getUserById()` method requires the user's id which maps to the `auth.users.id` column.
   *
   * @example Fetch the user object using the access_token jwt
   * ```js
   * const { data, error } = await supabase.auth.admin.getUserById(1)
   * ```
   *
   * @exampleResponse Fetch the user object using the access_token jwt
   * ```json
   * {
   *   data: {
   *     user: {
   *       id: '1',
   *       aud: 'authenticated',
   *       role: 'authenticated',
   *       email: 'example@email.com',
   *       email_confirmed_at: '2024-01-01T00:00:00Z',
   *       phone: '',
   *       confirmation_sent_at: '2024-01-01T00:00:00Z',
   *       confirmed_at: '2024-01-01T00:00:00Z',
   *       last_sign_in_at: '2024-01-01T00:00:00Z',
   *       app_metadata: {},
   *       user_metadata: {},
   *       identities: [
   *         {
   *           "identity_id": "22222222-2222-2222-2222-222222222222",
   *           "id": "1",
   *           "user_id": "1",
   *           "identity_data": {
   *             "email": "example@email.com",
   *             "email_verified": true,
   *             "phone_verified": false,
   *             "sub": "1"
   *           },
   *           "provider": "email",
   *           "last_sign_in_at": "2024-01-01T00:00:00Z",
   *           "created_at": "2024-01-01T00:00:00Z",
   *           "updated_at": "2024-01-01T00:00:00Z",
   *           "email": "email@example.com"
   *         },
   *       ],
   *       created_at: '2024-01-01T00:00:00Z',
   *       updated_at: '2024-01-01T00:00:00Z',
   *       is_anonymous: false,
   *     }
   *   }
   *   error: null
   * }
   * ```
   */ async getUserById(uid) {
        $281a441cdcb2cf36$var$validateUUID(uid);
        try {
            return await $281a441cdcb2cf36$var$_request(this.fetch, "GET", `${this.url}/admin/users/${uid}`, {
                headers: this.headers,
                xform: $281a441cdcb2cf36$var$_userResponse
            });
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
   * Updates the user data. Changes are applied directly without confirmation flows.
   *
   * @param uid The user's unique identifier
   * @param attributes The data you want to update.
   *
   * This function should only be called on a server. Never expose your `service_role` key in the browser.
   *
   * @remarks
   * **Important:** This is a server-side operation and does **not** trigger client-side
   * `onAuthStateChange` listeners. The admin API has no connection to client state.
   *
   * To sync changes to the client after calling this method:
   * 1. On the client, call `supabase.auth.refreshSession()` to fetch the updated user data
   * 2. This will trigger the `TOKEN_REFRESHED` event and notify all listeners
   *
   * @example
   * ```typescript
   * // Server-side (Edge Function)
   * const { data, error } = await supabase.auth.admin.updateUserById(
   *   userId,
   *   { user_metadata: { preferences: { theme: 'dark' } } }
   * )
   *
   * // Client-side (to sync the changes)
   * const { data, error } = await supabase.auth.refreshSession()
   * // onAuthStateChange listeners will now be notified with updated user
   * ```
   *
   * @see {@link GoTrueClient.refreshSession} for syncing admin changes to the client
   * @see {@link GoTrueClient.updateUser} for client-side user updates (triggers listeners automatically)
   *
   * @category Auth
   *
   * @example Updates a user's email
   * ```js
   * const { data: user, error } = await supabase.auth.admin.updateUserById(
   *   '11111111-1111-1111-1111-111111111111',
   *   { email: 'new@email.com' }
   * )
   * ```
   *
   * @exampleResponse Updates a user's email
   * ```json
   * {
   *   "data": {
   *     "user": {
   *       "id": "11111111-1111-1111-1111-111111111111",
   *       "aud": "authenticated",
   *       "role": "authenticated",
   *       "email": "new@email.com",
   *       "email_confirmed_at": "2024-01-01T00:00:00Z",
   *       "phone": "",
   *       "confirmed_at": "2024-01-01T00:00:00Z",
   *       "recovery_sent_at": "2024-01-01T00:00:00Z",
   *       "last_sign_in_at": "2024-01-01T00:00:00Z",
   *       "app_metadata": {
   *         "provider": "email",
   *         "providers": [
   *           "email"
   *         ]
   *       },
   *       "user_metadata": {
   *         "email": "example@email.com",
   *         "email_verified": false,
   *         "phone_verified": false,
   *         "sub": "11111111-1111-1111-1111-111111111111"
   *       },
   *       "identities": [
   *         {
   *           "identity_id": "22222222-2222-2222-2222-222222222222",
   *           "id": "11111111-1111-1111-1111-111111111111",
   *           "user_id": "11111111-1111-1111-1111-111111111111",
   *           "identity_data": {
   *             "email": "example@email.com",
   *             "email_verified": false,
   *             "phone_verified": false,
   *             "sub": "11111111-1111-1111-1111-111111111111"
   *           },
   *           "provider": "email",
   *           "last_sign_in_at": "2024-01-01T00:00:00Z",
   *           "created_at": "2024-01-01T00:00:00Z",
   *           "updated_at": "2024-01-01T00:00:00Z",
   *           "email": "example@email.com"
   *         }
   *       ],
   *       "created_at": "2024-01-01T00:00:00Z",
   *       "updated_at": "2024-01-01T00:00:00Z",
   *       "is_anonymous": false
   *     }
   *   },
   *   "error": null
   * }
   * ```
   *
   * @example Updates a user's password
   * ```js
   * const { data: user, error } = await supabase.auth.admin.updateUserById(
   *   '6aa5d0d4-2a9f-4483-b6c8-0cf4c6c98ac4',
   *   { password: 'new_password' }
   * )
   * ```
   *
   * @example Updates a user's metadata
   * ```js
   * const { data: user, error } = await supabase.auth.admin.updateUserById(
   *   '6aa5d0d4-2a9f-4483-b6c8-0cf4c6c98ac4',
   *   { user_metadata: { hello: 'world' } }
   * )
   * ```
   *
   * @example Updates a user's app_metadata
   * ```js
   * const { data: user, error } = await supabase.auth.admin.updateUserById(
   *   '6aa5d0d4-2a9f-4483-b6c8-0cf4c6c98ac4',
   *   { app_metadata: { plan: 'trial' } }
   * )
   * ```
   *
   * @example Confirms a user's email address
   * ```js
   * const { data: user, error } = await supabase.auth.admin.updateUserById(
   *   '6aa5d0d4-2a9f-4483-b6c8-0cf4c6c98ac4',
   *   { email_confirm: true }
   * )
   * ```
   *
   * @example Confirms a user's phone number
   * ```js
   * const { data: user, error } = await supabase.auth.admin.updateUserById(
   *   '6aa5d0d4-2a9f-4483-b6c8-0cf4c6c98ac4',
   *   { phone_confirm: true }
   * )
   * ```
   *
   * @example Ban a user for 100 years
   * ```js
   * const { data: user, error } = await supabase.auth.admin.updateUserById(
   *   '6aa5d0d4-2a9f-4483-b6c8-0cf4c6c98ac4',
   *   { ban_duration: '876000h' }
   * )
   * ```
   */ async updateUserById(uid, attributes) {
        $281a441cdcb2cf36$var$validateUUID(uid);
        try {
            return await $281a441cdcb2cf36$var$_request(this.fetch, "PUT", `${this.url}/admin/users/${uid}`, {
                body: attributes,
                headers: this.headers,
                xform: $281a441cdcb2cf36$var$_userResponse
            });
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
   * Delete a user. Requires a `service_role` key.
   *
   * @param id The user id you want to remove.
   * @param shouldSoftDelete If true, then the user will be soft-deleted from the auth schema. Soft deletion allows user identification from the hashed user ID but is not reversible.
   * Defaults to false for backward compatibility.
   *
   * This function should only be called on a server. Never expose your `service_role` key in the browser.
   *
   * @category Auth
   *
   * @remarks
   * - The `deleteUser()` method requires the user's ID, which maps to the `auth.users.id` column.
   *
   * @example Removes a user
   * ```js
   * const { data, error } = await supabase.auth.admin.deleteUser(
   *   '715ed5db-f090-4b8c-a067-640ecee36aa0'
   * )
   * ```
   *
   * @exampleResponse Removes a user
   * ```json
   * {
   *   "data": {
   *     "user": {}
   *   },
   *   "error": null
   * }
   * ```
   */ async deleteUser(id2, shouldSoftDelete = false) {
        $281a441cdcb2cf36$var$validateUUID(id2);
        try {
            return await $281a441cdcb2cf36$var$_request(this.fetch, "DELETE", `${this.url}/admin/users/${id2}`, {
                headers: this.headers,
                body: {
                    should_soft_delete: shouldSoftDelete
                },
                xform: $281a441cdcb2cf36$var$_userResponse
            });
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    async _listFactors(params2) {
        $281a441cdcb2cf36$var$validateUUID(params2.userId);
        try {
            const { data: data2, error: error } = await $281a441cdcb2cf36$var$_request(this.fetch, "GET", `${this.url}/admin/users/${params2.userId}/factors`, {
                headers: this.headers,
                xform: (factors)=>{
                    return {
                        data: {
                            factors: factors
                        },
                        error: null
                    };
                }
            });
            return {
                data: data2,
                error: error
            };
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    async _deleteFactor(params2) {
        $281a441cdcb2cf36$var$validateUUID(params2.userId);
        $281a441cdcb2cf36$var$validateUUID(params2.id);
        try {
            const data2 = await $281a441cdcb2cf36$var$_request(this.fetch, "DELETE", `${this.url}/admin/users/${params2.userId}/factors/${params2.id}`, {
                headers: this.headers
            });
            return {
                data: data2,
                error: null
            };
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
   * Lists all OAuth clients with optional pagination.
   * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
   *
   * This function should only be called on a server. Never expose your `service_role` key in the browser.
   */ async _listOAuthClients(params2) {
        var _a2, _b, _c, _d, _e, _f, _g;
        try {
            const pagination = {
                nextPage: null,
                lastPage: 0,
                total: 0
            };
            const response = await $281a441cdcb2cf36$var$_request(this.fetch, "GET", `${this.url}/admin/oauth/clients`, {
                headers: this.headers,
                noResolveJson: true,
                query: {
                    page: (_b = (_a2 = params2 === null || params2 === void 0 ? void 0 : params2.page) === null || _a2 === void 0 ? void 0 : _a2.toString()) !== null && _b !== void 0 ? _b : "",
                    per_page: (_d = (_c = params2 === null || params2 === void 0 ? void 0 : params2.perPage) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : ""
                },
                xform: $281a441cdcb2cf36$var$_noResolveJsonResponse
            });
            if (response.error) throw response.error;
            const clients = await response.json();
            const total = (_e = response.headers.get("x-total-count")) !== null && _e !== void 0 ? _e : 0;
            const links = (_g = (_f = response.headers.get("link")) === null || _f === void 0 ? void 0 : _f.split(",")) !== null && _g !== void 0 ? _g : [];
            if (links.length > 0) {
                links.forEach((link)=>{
                    const page = parseInt(link.split(";")[0].split("=")[1].substring(0, 1));
                    const rel = JSON.parse(link.split(";")[1].split("=")[1]);
                    pagination[`${rel}Page`] = page;
                });
                pagination.total = parseInt(total);
            }
            return {
                data: Object.assign(Object.assign({}, clients), pagination),
                error: null
            };
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return {
                data: {
                    clients: []
                },
                error: error
            };
            throw error;
        }
    }
    /**
   * Creates a new OAuth client.
   * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
   *
   * This function should only be called on a server. Never expose your `service_role` key in the browser.
   */ async _createOAuthClient(params2) {
        try {
            return await $281a441cdcb2cf36$var$_request(this.fetch, "POST", `${this.url}/admin/oauth/clients`, {
                body: params2,
                headers: this.headers,
                xform: (client)=>{
                    return {
                        data: client,
                        error: null
                    };
                }
            });
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
   * Gets details of a specific OAuth client.
   * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
   *
   * This function should only be called on a server. Never expose your `service_role` key in the browser.
   */ async _getOAuthClient(clientId) {
        try {
            return await $281a441cdcb2cf36$var$_request(this.fetch, "GET", `${this.url}/admin/oauth/clients/${clientId}`, {
                headers: this.headers,
                xform: (client)=>{
                    return {
                        data: client,
                        error: null
                    };
                }
            });
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
   * Updates an existing OAuth client.
   * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
   *
   * This function should only be called on a server. Never expose your `service_role` key in the browser.
   */ async _updateOAuthClient(clientId, params2) {
        try {
            return await $281a441cdcb2cf36$var$_request(this.fetch, "PUT", `${this.url}/admin/oauth/clients/${clientId}`, {
                body: params2,
                headers: this.headers,
                xform: (client)=>{
                    return {
                        data: client,
                        error: null
                    };
                }
            });
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
   * Deletes an OAuth client.
   * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
   *
   * This function should only be called on a server. Never expose your `service_role` key in the browser.
   */ async _deleteOAuthClient(clientId) {
        try {
            await $281a441cdcb2cf36$var$_request(this.fetch, "DELETE", `${this.url}/admin/oauth/clients/${clientId}`, {
                headers: this.headers,
                noResolveJson: true
            });
            return {
                data: null,
                error: null
            };
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
   * Regenerates the secret for an OAuth client.
   * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
   *
   * This function should only be called on a server. Never expose your `service_role` key in the browser.
   */ async _regenerateOAuthClientSecret(clientId) {
        try {
            return await $281a441cdcb2cf36$var$_request(this.fetch, "POST", `${this.url}/admin/oauth/clients/${clientId}/regenerate_secret`, {
                headers: this.headers,
                xform: (client)=>{
                    return {
                        data: client,
                        error: null
                    };
                }
            });
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
   * Lists all custom providers with optional type filter.
   *
   * This function should only be called on a server. Never expose your `service_role` key in the browser.
   */ async _listCustomProviders(params2) {
        try {
            const query = {};
            if (params2 === null || params2 === void 0 ? void 0 : params2.type) query.type = params2.type;
            return await $281a441cdcb2cf36$var$_request(this.fetch, "GET", `${this.url}/admin/custom-providers`, {
                headers: this.headers,
                query: query,
                xform: (data2)=>{
                    var _a2;
                    return {
                        data: {
                            providers: (_a2 = data2 === null || data2 === void 0 ? void 0 : data2.providers) !== null && _a2 !== void 0 ? _a2 : []
                        },
                        error: null
                    };
                }
            });
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return {
                data: {
                    providers: []
                },
                error: error
            };
            throw error;
        }
    }
    /**
   * Creates a new custom OIDC/OAuth provider.
   *
   * For OIDC providers, the server fetches and validates the OpenID Connect discovery document
   * from the issuer's well-known endpoint (or the provided `discovery_url`) at creation time.
   * This may return a validation error (`error_code: "validation_failed"`) if the discovery
   * document is unreachable, not valid JSON, missing required fields, or if the issuer
   * in the document does not match the expected issuer.
   *
   * This function should only be called on a server. Never expose your `service_role` key in the browser.
   */ async _createCustomProvider(params2) {
        try {
            return await $281a441cdcb2cf36$var$_request(this.fetch, "POST", `${this.url}/admin/custom-providers`, {
                body: params2,
                headers: this.headers,
                xform: (provider)=>{
                    return {
                        data: provider,
                        error: null
                    };
                }
            });
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
   * Gets details of a specific custom provider by identifier.
   *
   * This function should only be called on a server. Never expose your `service_role` key in the browser.
   */ async _getCustomProvider(identifier) {
        try {
            return await $281a441cdcb2cf36$var$_request(this.fetch, "GET", `${this.url}/admin/custom-providers/${identifier}`, {
                headers: this.headers,
                xform: (provider)=>{
                    return {
                        data: provider,
                        error: null
                    };
                }
            });
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
   * Updates an existing custom provider.
   *
   * When `issuer` or `discovery_url` is changed on an OIDC provider, the server re-fetches and
   * validates the discovery document before persisting. This may return a validation error
   * (`error_code: "validation_failed"`) if the discovery document is unreachable, invalid, or
   * the issuer does not match.
   *
   * This function should only be called on a server. Never expose your `service_role` key in the browser.
   */ async _updateCustomProvider(identifier, params2) {
        try {
            return await $281a441cdcb2cf36$var$_request(this.fetch, "PUT", `${this.url}/admin/custom-providers/${identifier}`, {
                body: params2,
                headers: this.headers,
                xform: (provider)=>{
                    return {
                        data: provider,
                        error: null
                    };
                }
            });
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
   * Deletes a custom provider.
   *
   * This function should only be called on a server. Never expose your `service_role` key in the browser.
   */ async _deleteCustomProvider(identifier) {
        try {
            await $281a441cdcb2cf36$var$_request(this.fetch, "DELETE", `${this.url}/admin/custom-providers/${identifier}`, {
                headers: this.headers,
                noResolveJson: true
            });
            return {
                data: null,
                error: null
            };
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
   * Lists all passkeys for a user.
   *
   * This function should only be called on a server. Never expose your secret key in the browser.
   *
   * Requires `auth.experimental.passkey: true`.
   */ async _adminListPasskeys(params2) {
        $281a441cdcb2cf36$var$assertPasskeyExperimentalEnabled(this.experimental);
        $281a441cdcb2cf36$var$validateUUID(params2.userId);
        try {
            return await $281a441cdcb2cf36$var$_request(this.fetch, "GET", `${this.url}/admin/users/${params2.userId}/passkeys`, {
                headers: this.headers,
                xform: (data2)=>({
                        data: data2,
                        error: null
                    })
            });
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
   * Deletes a user's passkey.
   *
   * This function should only be called on a server. Never expose your secret key in the browser.
   *
   * Requires `auth.experimental.passkey: true`.
   */ async _adminDeletePasskey(params2) {
        $281a441cdcb2cf36$var$assertPasskeyExperimentalEnabled(this.experimental);
        $281a441cdcb2cf36$var$validateUUID(params2.userId);
        $281a441cdcb2cf36$var$validateUUID(params2.passkeyId);
        try {
            await $281a441cdcb2cf36$var$_request(this.fetch, "DELETE", `${this.url}/admin/users/${params2.userId}/passkeys/${params2.passkeyId}`, {
                headers: this.headers,
                noResolveJson: true
            });
            return {
                data: null,
                error: null
            };
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
};
// ../node_modules/@supabase/auth-js/dist/module/lib/local-storage.js
function $281a441cdcb2cf36$var$memoryLocalStorageAdapter(store = {}) {
    return {
        getItem: (key)=>{
            return store[key] || null;
        },
        setItem: (key, value2)=>{
            store[key] = value2;
        },
        removeItem: (key)=>{
            delete store[key];
        }
    };
}
// ../node_modules/@supabase/auth-js/dist/module/lib/locks.js
var $281a441cdcb2cf36$var$internals = {
    /**
   * @experimental
   */ debug: !!(globalThis && $281a441cdcb2cf36$var$supportsLocalStorage() && globalThis.localStorage && globalThis.localStorage.getItem("supabase.gotrue-js.locks.debug") === "true")
};
var $281a441cdcb2cf36$var$LockAcquireTimeoutError = class extends Error {
    constructor(message){
        super(message);
        this.isAcquireTimeout = true;
    }
};
var $281a441cdcb2cf36$var$NavigatorLockAcquireTimeoutError = class extends $281a441cdcb2cf36$var$LockAcquireTimeoutError {
};
async function $281a441cdcb2cf36$var$navigatorLock(name, acquireTimeout, fn) {
    if ($281a441cdcb2cf36$var$internals.debug) console.log("@supabase/gotrue-js: navigatorLock: acquire lock", name, acquireTimeout);
    const abortController = new globalThis.AbortController();
    let acquireTimeoutTimer;
    if (acquireTimeout > 0) acquireTimeoutTimer = setTimeout(()=>{
        abortController.abort();
        if ($281a441cdcb2cf36$var$internals.debug) console.log("@supabase/gotrue-js: navigatorLock acquire timed out", name);
    }, acquireTimeout);
    await Promise.resolve();
    try {
        return await globalThis.navigator.locks.request(name, acquireTimeout === 0 ? {
            mode: "exclusive",
            ifAvailable: true
        } : {
            mode: "exclusive",
            signal: abortController.signal
        }, async (lock)=>{
            if (lock) {
                clearTimeout(acquireTimeoutTimer);
                if ($281a441cdcb2cf36$var$internals.debug) console.log("@supabase/gotrue-js: navigatorLock: acquired", name, lock.name);
                try {
                    return await fn();
                } finally{
                    if ($281a441cdcb2cf36$var$internals.debug) console.log("@supabase/gotrue-js: navigatorLock: released", name, lock.name);
                }
            } else if (acquireTimeout === 0) {
                if ($281a441cdcb2cf36$var$internals.debug) console.log("@supabase/gotrue-js: navigatorLock: not immediately available", name);
                throw new $281a441cdcb2cf36$var$NavigatorLockAcquireTimeoutError(`Acquiring an exclusive Navigator LockManager lock "${name}" immediately failed`);
            } else {
                if ($281a441cdcb2cf36$var$internals.debug) try {
                    const result = await globalThis.navigator.locks.query();
                    console.log("@supabase/gotrue-js: Navigator LockManager state", JSON.stringify(result, null, "  "));
                } catch (e4) {
                    console.warn("@supabase/gotrue-js: Error when querying Navigator LockManager state", e4);
                }
                console.warn("@supabase/gotrue-js: Navigator LockManager returned a null lock when using #request without ifAvailable set to true, it appears this browser is not following the LockManager spec https://developer.mozilla.org/en-US/docs/Web/API/LockManager/request");
                clearTimeout(acquireTimeoutTimer);
                return await fn();
            }
        });
    } catch (e4) {
        if (acquireTimeout > 0) clearTimeout(acquireTimeoutTimer);
        if ((e4 === null || e4 === void 0 ? void 0 : e4.name) === "AbortError" && acquireTimeout > 0) {
            if (abortController.signal.aborted) {
                if ($281a441cdcb2cf36$var$internals.debug) console.log("@supabase/gotrue-js: navigatorLock: acquire timeout, recovering by stealing lock", name);
                console.warn(`@supabase/gotrue-js: Lock "${name}" was not released within ${acquireTimeout}ms. This may indicate an orphaned lock from a component unmount (e.g., React Strict Mode). Forcefully acquiring the lock to recover.`);
                return await Promise.resolve().then(()=>globalThis.navigator.locks.request(name, {
                        mode: "exclusive",
                        steal: true
                    }, async (lock)=>{
                        if (lock) {
                            if ($281a441cdcb2cf36$var$internals.debug) console.log("@supabase/gotrue-js: navigatorLock: recovered (stolen)", name, lock.name);
                            try {
                                return await fn();
                            } finally{
                                if ($281a441cdcb2cf36$var$internals.debug) console.log("@supabase/gotrue-js: navigatorLock: released (stolen)", name, lock.name);
                            }
                        } else {
                            console.warn("@supabase/gotrue-js: Navigator LockManager returned null lock even with steal: true");
                            return await fn();
                        }
                    }));
            } else {
                if ($281a441cdcb2cf36$var$internals.debug) console.log("@supabase/gotrue-js: navigatorLock: lock was stolen by another request", name);
                throw new $281a441cdcb2cf36$var$NavigatorLockAcquireTimeoutError(`Lock "${name}" was released because another request stole it`);
            }
        }
        throw e4;
    }
}
// ../node_modules/@supabase/auth-js/dist/module/lib/polyfills.js
function $281a441cdcb2cf36$var$polyfillGlobalThis() {
    if (typeof globalThis === "object") return;
    try {
        Object.defineProperty(Object.prototype, "__magic__", {
            get: function() {
                return this;
            },
            configurable: true
        });
        __magic__.globalThis = __magic__;
        delete Object.prototype.__magic__;
    } catch (e4) {
        if (typeof self !== "undefined") self.globalThis = self;
    }
}
// ../node_modules/@supabase/auth-js/dist/module/lib/web3/ethereum.js
function $281a441cdcb2cf36$var$getAddress(address) {
    if (!/^0x[a-fA-F0-9]{40}$/.test(address)) throw new Error(`@supabase/auth-js: Address "${address}" is invalid.`);
    return address.toLowerCase();
}
function $281a441cdcb2cf36$var$fromHex(hex) {
    return parseInt(hex, 16);
}
function $281a441cdcb2cf36$var$toHex2(value2) {
    const bytes = new TextEncoder().encode(value2);
    const hex = Array.from(bytes, (byte)=>byte.toString(16).padStart(2, "0")).join("");
    return "0x" + hex;
}
function $281a441cdcb2cf36$var$createSiweMessage(parameters) {
    var _a2;
    const { chainId: chainId, domain: domain, expirationTime: expirationTime, issuedAt: issuedAt = /* @__PURE__ */ new Date(), nonce: nonce, notBefore: notBefore, requestId: requestId, resources: resources, scheme: scheme, uri: uri, version: version6 } = parameters;
    if (!Number.isInteger(chainId)) throw new Error(`@supabase/auth-js: Invalid SIWE message field "chainId". Chain ID must be a EIP-155 chain ID. Provided value: ${chainId}`);
    if (!domain) throw new Error(`@supabase/auth-js: Invalid SIWE message field "domain". Domain must be provided.`);
    if (nonce && nonce.length < 8) throw new Error(`@supabase/auth-js: Invalid SIWE message field "nonce". Nonce must be at least 8 characters. Provided value: ${nonce}`);
    if (!uri) throw new Error(`@supabase/auth-js: Invalid SIWE message field "uri". URI must be provided.`);
    if (version6 !== "1") throw new Error(`@supabase/auth-js: Invalid SIWE message field "version". Version must be '1'. Provided value: ${version6}`);
    if ((_a2 = parameters.statement) === null || _a2 === void 0 ? void 0 : _a2.includes("\n")) throw new Error(`@supabase/auth-js: Invalid SIWE message field "statement". Statement must not include '\\n'. Provided value: ${parameters.statement}`);
    const address = $281a441cdcb2cf36$var$getAddress(parameters.address);
    const origin = scheme ? `${scheme}://${domain}` : domain;
    const statement = parameters.statement ? `${parameters.statement}
` : "";
    const prefix = `${origin} wants you to sign in with your Ethereum account:
${address}

${statement}`;
    let suffix = `URI: ${uri}
Version: ${version6}
Chain ID: ${chainId}${nonce ? `
Nonce: ${nonce}` : ""}
Issued At: ${issuedAt.toISOString()}`;
    if (expirationTime) suffix += `
Expiration Time: ${expirationTime.toISOString()}`;
    if (notBefore) suffix += `
Not Before: ${notBefore.toISOString()}`;
    if (requestId) suffix += `
Request ID: ${requestId}`;
    if (resources) {
        let content = "\nResources:";
        for (const resource of resources){
            if (!resource || typeof resource !== "string") throw new Error(`@supabase/auth-js: Invalid SIWE message field "resources". Every resource must be a valid string. Provided value: ${resource}`);
            content += `
- ${resource}`;
        }
        suffix += content;
    }
    return `${prefix}
${suffix}`;
}
// ../node_modules/@supabase/auth-js/dist/module/lib/webauthn.errors.js
var $281a441cdcb2cf36$var$WebAuthnError = class extends Error {
    constructor({ message: message, code: code, cause: cause, name: name }){
        var _a2;
        super(message, {
            cause: cause
        });
        this.__isWebAuthnError = true;
        this.name = (_a2 = name !== null && name !== void 0 ? name : cause instanceof Error ? cause.name : void 0) !== null && _a2 !== void 0 ? _a2 : "Unknown Error";
        this.code = code;
    }
};
var $281a441cdcb2cf36$var$WebAuthnUnknownError = class extends $281a441cdcb2cf36$var$WebAuthnError {
    constructor(message, originalError){
        super({
            code: "ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY",
            cause: originalError,
            message: message
        });
        this.name = "WebAuthnUnknownError";
        this.originalError = originalError;
    }
};
function $281a441cdcb2cf36$var$identifyRegistrationError({ error: error, options: options }) {
    var _a2, _b, _c;
    const { publicKey: publicKey } = options;
    if (!publicKey) throw Error("options was missing required publicKey property");
    if (error.name === "AbortError") {
        if (options.signal instanceof AbortSignal) return new $281a441cdcb2cf36$var$WebAuthnError({
            message: "Registration ceremony was sent an abort signal",
            code: "ERROR_CEREMONY_ABORTED",
            cause: error
        });
    } else if (error.name === "ConstraintError") {
        if (((_a2 = publicKey.authenticatorSelection) === null || _a2 === void 0 ? void 0 : _a2.requireResidentKey) === true) return new $281a441cdcb2cf36$var$WebAuthnError({
            message: "Discoverable credentials were required but no available authenticator supported it",
            code: "ERROR_AUTHENTICATOR_MISSING_DISCOVERABLE_CREDENTIAL_SUPPORT",
            cause: error
        });
        else if (// @ts-ignore: `mediation` doesn't yet exist on CredentialCreationOptions but it's possible as of Sept 2024
        options.mediation === "conditional" && ((_b = publicKey.authenticatorSelection) === null || _b === void 0 ? void 0 : _b.userVerification) === "required") return new $281a441cdcb2cf36$var$WebAuthnError({
            message: "User verification was required during automatic registration but it could not be performed",
            code: "ERROR_AUTO_REGISTER_USER_VERIFICATION_FAILURE",
            cause: error
        });
        else if (((_c = publicKey.authenticatorSelection) === null || _c === void 0 ? void 0 : _c.userVerification) === "required") return new $281a441cdcb2cf36$var$WebAuthnError({
            message: "User verification was required but no available authenticator supported it",
            code: "ERROR_AUTHENTICATOR_MISSING_USER_VERIFICATION_SUPPORT",
            cause: error
        });
    } else if (error.name === "InvalidStateError") return new $281a441cdcb2cf36$var$WebAuthnError({
        message: "The authenticator was previously registered",
        code: "ERROR_AUTHENTICATOR_PREVIOUSLY_REGISTERED",
        cause: error
    });
    else if (error.name === "NotAllowedError") return new $281a441cdcb2cf36$var$WebAuthnError({
        message: error.message,
        code: "ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY",
        cause: error
    });
    else if (error.name === "NotSupportedError") {
        const validPubKeyCredParams = publicKey.pubKeyCredParams.filter((param)=>param.type === "public-key");
        if (validPubKeyCredParams.length === 0) return new $281a441cdcb2cf36$var$WebAuthnError({
            message: 'No entry in pubKeyCredParams was of type "public-key"',
            code: "ERROR_MALFORMED_PUBKEYCREDPARAMS",
            cause: error
        });
        return new $281a441cdcb2cf36$var$WebAuthnError({
            message: "No available authenticator supported any of the specified pubKeyCredParams algorithms",
            code: "ERROR_AUTHENTICATOR_NO_SUPPORTED_PUBKEYCREDPARAMS_ALG",
            cause: error
        });
    } else if (error.name === "SecurityError") {
        const effectiveDomain = window.location.hostname;
        if (!$281a441cdcb2cf36$var$isValidDomain(effectiveDomain)) return new $281a441cdcb2cf36$var$WebAuthnError({
            message: `${window.location.hostname} is an invalid domain`,
            code: "ERROR_INVALID_DOMAIN",
            cause: error
        });
        else if (publicKey.rp.id !== effectiveDomain) return new $281a441cdcb2cf36$var$WebAuthnError({
            message: `The RP ID "${publicKey.rp.id}" is invalid for this domain`,
            code: "ERROR_INVALID_RP_ID",
            cause: error
        });
    } else if (error.name === "TypeError") {
        if (publicKey.user.id.byteLength < 1 || publicKey.user.id.byteLength > 64) return new $281a441cdcb2cf36$var$WebAuthnError({
            message: "User ID was not between 1 and 64 characters",
            code: "ERROR_INVALID_USER_ID_LENGTH",
            cause: error
        });
    } else if (error.name === "UnknownError") return new $281a441cdcb2cf36$var$WebAuthnError({
        message: "The authenticator was unable to process the specified options, or could not create a new credential",
        code: "ERROR_AUTHENTICATOR_GENERAL_ERROR",
        cause: error
    });
    return new $281a441cdcb2cf36$var$WebAuthnError({
        message: "a Non-Webauthn related error has occurred",
        code: "ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY",
        cause: error
    });
}
function $281a441cdcb2cf36$var$identifyAuthenticationError({ error: error, options: options }) {
    const { publicKey: publicKey } = options;
    if (!publicKey) throw Error("options was missing required publicKey property");
    if (error.name === "AbortError") {
        if (options.signal instanceof AbortSignal) return new $281a441cdcb2cf36$var$WebAuthnError({
            message: "Authentication ceremony was sent an abort signal",
            code: "ERROR_CEREMONY_ABORTED",
            cause: error
        });
    } else if (error.name === "NotAllowedError") return new $281a441cdcb2cf36$var$WebAuthnError({
        message: error.message,
        code: "ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY",
        cause: error
    });
    else if (error.name === "SecurityError") {
        const effectiveDomain = window.location.hostname;
        if (!$281a441cdcb2cf36$var$isValidDomain(effectiveDomain)) return new $281a441cdcb2cf36$var$WebAuthnError({
            message: `${window.location.hostname} is an invalid domain`,
            code: "ERROR_INVALID_DOMAIN",
            cause: error
        });
        else if (publicKey.rpId !== effectiveDomain) return new $281a441cdcb2cf36$var$WebAuthnError({
            message: `The RP ID "${publicKey.rpId}" is invalid for this domain`,
            code: "ERROR_INVALID_RP_ID",
            cause: error
        });
    } else if (error.name === "UnknownError") return new $281a441cdcb2cf36$var$WebAuthnError({
        message: "The authenticator was unable to process the specified options, or could not create a new assertion signature",
        code: "ERROR_AUTHENTICATOR_GENERAL_ERROR",
        cause: error
    });
    return new $281a441cdcb2cf36$var$WebAuthnError({
        message: "a Non-Webauthn related error has occurred",
        code: "ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY",
        cause: error
    });
}
// ../node_modules/@supabase/auth-js/dist/module/lib/webauthn.js
var $281a441cdcb2cf36$var$WebAuthnAbortService = class {
    /**
   * Create an abort signal for a new WebAuthn operation.
   * Automatically cancels any existing operation.
   *
   * @returns {AbortSignal} Signal to pass to navigator.credentials.create() or .get()
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/AbortSignal MDN - AbortSignal}
   */ createNewAbortSignal() {
        if (this.controller) {
            const abortError = new Error("Cancelling existing WebAuthn API call for new one");
            abortError.name = "AbortError";
            this.controller.abort(abortError);
        }
        const newController = new AbortController();
        this.controller = newController;
        return newController.signal;
    }
    /**
   * Manually cancel the current WebAuthn operation.
   * Useful for cleaning up when user cancels or navigates away.
   *
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/AbortController/abort MDN - AbortController.abort}
   */ cancelCeremony() {
        if (this.controller) {
            const abortError = new Error("Manually cancelling existing WebAuthn API call");
            abortError.name = "AbortError";
            this.controller.abort(abortError);
            this.controller = void 0;
        }
    }
};
var $281a441cdcb2cf36$var$webAuthnAbortService = new $281a441cdcb2cf36$var$WebAuthnAbortService();
function $281a441cdcb2cf36$var$deserializeCredentialCreationOptions(options) {
    if (!options) throw new Error("Credential creation options are required");
    if (typeof PublicKeyCredential !== "undefined" && "parseCreationOptionsFromJSON" in PublicKeyCredential && typeof PublicKeyCredential.parseCreationOptionsFromJSON === "function") return PublicKeyCredential.parseCreationOptionsFromJSON(/** we assert the options here as typescript still doesn't know about future webauthn types */ options);
    const { challenge: challengeStr, user: userOpts, excludeCredentials: excludeCredentials } = options, restOptions = $281a441cdcb2cf36$var$__rest4(options, [
        "challenge",
        "user",
        "excludeCredentials"
    ]);
    const challenge = $281a441cdcb2cf36$var$base64UrlToUint8Array(challengeStr).buffer;
    const user = Object.assign(Object.assign({}, userOpts), {
        id: $281a441cdcb2cf36$var$base64UrlToUint8Array(userOpts.id).buffer
    });
    const result = Object.assign(Object.assign({}, restOptions), {
        challenge: challenge,
        user: user
    });
    if (excludeCredentials && excludeCredentials.length > 0) {
        result.excludeCredentials = new Array(excludeCredentials.length);
        for(let i3 = 0; i3 < excludeCredentials.length; i3++){
            const cred = excludeCredentials[i3];
            result.excludeCredentials[i3] = Object.assign(Object.assign({}, cred), {
                id: $281a441cdcb2cf36$var$base64UrlToUint8Array(cred.id).buffer,
                type: cred.type || "public-key",
                // Cast transports to handle future transport types like "cable"
                transports: cred.transports
            });
        }
    }
    return result;
}
function $281a441cdcb2cf36$var$deserializeCredentialRequestOptions(options) {
    if (!options) throw new Error("Credential request options are required");
    if (typeof PublicKeyCredential !== "undefined" && "parseRequestOptionsFromJSON" in PublicKeyCredential && typeof PublicKeyCredential.parseRequestOptionsFromJSON === "function") return PublicKeyCredential.parseRequestOptionsFromJSON(options);
    const { challenge: challengeStr, allowCredentials: allowCredentials } = options, restOptions = $281a441cdcb2cf36$var$__rest4(options, [
        "challenge",
        "allowCredentials"
    ]);
    const challenge = $281a441cdcb2cf36$var$base64UrlToUint8Array(challengeStr).buffer;
    const result = Object.assign(Object.assign({}, restOptions), {
        challenge: challenge
    });
    if (allowCredentials && allowCredentials.length > 0) {
        result.allowCredentials = new Array(allowCredentials.length);
        for(let i3 = 0; i3 < allowCredentials.length; i3++){
            const cred = allowCredentials[i3];
            result.allowCredentials[i3] = Object.assign(Object.assign({}, cred), {
                id: $281a441cdcb2cf36$var$base64UrlToUint8Array(cred.id).buffer,
                type: cred.type || "public-key",
                // Cast transports to handle future transport types like "cable"
                transports: cred.transports
            });
        }
    }
    return result;
}
function $281a441cdcb2cf36$var$serializeCredentialCreationResponse(credential) {
    var _a2;
    if ("toJSON" in credential && typeof credential.toJSON === "function") return credential.toJSON();
    const credentialWithAttachment = credential;
    return {
        id: credential.id,
        rawId: credential.id,
        response: {
            attestationObject: $281a441cdcb2cf36$var$bytesToBase64URL(new Uint8Array(credential.response.attestationObject)),
            clientDataJSON: $281a441cdcb2cf36$var$bytesToBase64URL(new Uint8Array(credential.response.clientDataJSON))
        },
        type: "public-key",
        clientExtensionResults: credential.getClientExtensionResults(),
        // Convert null to undefined and cast to AuthenticatorAttachment type
        authenticatorAttachment: (_a2 = credentialWithAttachment.authenticatorAttachment) !== null && _a2 !== void 0 ? _a2 : void 0
    };
}
function $281a441cdcb2cf36$var$serializeCredentialRequestResponse(credential) {
    var _a2;
    if ("toJSON" in credential && typeof credential.toJSON === "function") return credential.toJSON();
    const credentialWithAttachment = credential;
    const clientExtensionResults = credential.getClientExtensionResults();
    const assertionResponse = credential.response;
    return {
        id: credential.id,
        rawId: credential.id,
        // W3C spec expects rawId to match id for JSON format
        response: {
            authenticatorData: $281a441cdcb2cf36$var$bytesToBase64URL(new Uint8Array(assertionResponse.authenticatorData)),
            clientDataJSON: $281a441cdcb2cf36$var$bytesToBase64URL(new Uint8Array(assertionResponse.clientDataJSON)),
            signature: $281a441cdcb2cf36$var$bytesToBase64URL(new Uint8Array(assertionResponse.signature)),
            userHandle: assertionResponse.userHandle ? $281a441cdcb2cf36$var$bytesToBase64URL(new Uint8Array(assertionResponse.userHandle)) : void 0
        },
        type: "public-key",
        clientExtensionResults: clientExtensionResults,
        // Convert null to undefined and cast to AuthenticatorAttachment type
        authenticatorAttachment: (_a2 = credentialWithAttachment.authenticatorAttachment) !== null && _a2 !== void 0 ? _a2 : void 0
    };
}
function $281a441cdcb2cf36$var$isValidDomain(hostname) {
    return(// Consider localhost valid as well since it's okay wrt Secure Contexts
    hostname === "localhost" || /^([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,}$/i.test(hostname));
}
function $281a441cdcb2cf36$var$browserSupportsWebAuthn() {
    var _a2, _b;
    return !!($281a441cdcb2cf36$var$isBrowser3() && "PublicKeyCredential" in window && window.PublicKeyCredential && "credentials" in navigator && typeof ((_a2 = navigator === null || navigator === void 0 ? void 0 : navigator.credentials) === null || _a2 === void 0 ? void 0 : _a2.create) === "function" && typeof ((_b = navigator === null || navigator === void 0 ? void 0 : navigator.credentials) === null || _b === void 0 ? void 0 : _b.get) === "function");
}
async function $281a441cdcb2cf36$var$createCredential(options) {
    try {
        const response = await navigator.credentials.create(/** we assert the type here until typescript types are updated */ options);
        if (!response) return {
            data: null,
            error: new $281a441cdcb2cf36$var$WebAuthnUnknownError("Empty credential response", response)
        };
        if (!(response instanceof PublicKeyCredential)) return {
            data: null,
            error: new $281a441cdcb2cf36$var$WebAuthnUnknownError("Browser returned unexpected credential type", response)
        };
        return {
            data: response,
            error: null
        };
    } catch (err) {
        return {
            data: null,
            error: $281a441cdcb2cf36$var$identifyRegistrationError({
                error: err,
                options: options
            })
        };
    }
}
async function $281a441cdcb2cf36$var$getCredential(options) {
    try {
        const response = await navigator.credentials.get(/** we assert the type here until typescript types are updated */ options);
        if (!response) return {
            data: null,
            error: new $281a441cdcb2cf36$var$WebAuthnUnknownError("Empty credential response", response)
        };
        if (!(response instanceof PublicKeyCredential)) return {
            data: null,
            error: new $281a441cdcb2cf36$var$WebAuthnUnknownError("Browser returned unexpected credential type", response)
        };
        return {
            data: response,
            error: null
        };
    } catch (err) {
        return {
            data: null,
            error: $281a441cdcb2cf36$var$identifyAuthenticationError({
                error: err,
                options: options
            })
        };
    }
}
var $281a441cdcb2cf36$var$DEFAULT_CREATION_OPTIONS = {
    hints: [
        "security-key"
    ],
    authenticatorSelection: {
        authenticatorAttachment: "cross-platform",
        requireResidentKey: false,
        /** set to preferred because older yubikeys don't have PIN/Biometric */ userVerification: "preferred",
        residentKey: "discouraged"
    },
    attestation: "direct"
};
var $281a441cdcb2cf36$var$DEFAULT_REQUEST_OPTIONS = {
    /** set to preferred because older yubikeys don't have PIN/Biometric */ userVerification: "preferred",
    hints: [
        "security-key"
    ],
    attestation: "direct"
};
function $281a441cdcb2cf36$var$deepMerge(...sources) {
    const isObject5 = (val)=>val !== null && typeof val === "object" && !Array.isArray(val);
    const isArrayBufferLike = (val)=>val instanceof ArrayBuffer || ArrayBuffer.isView(val);
    const result = {};
    for (const source of sources){
        if (!source) continue;
        for(const key in source){
            const value2 = source[key];
            if (value2 === void 0) continue;
            if (Array.isArray(value2)) result[key] = value2;
            else if (isArrayBufferLike(value2)) result[key] = value2;
            else if (isObject5(value2)) {
                const existing = result[key];
                if (isObject5(existing)) result[key] = $281a441cdcb2cf36$var$deepMerge(existing, value2);
                else result[key] = $281a441cdcb2cf36$var$deepMerge(value2);
            } else result[key] = value2;
        }
    }
    return result;
}
function $281a441cdcb2cf36$var$mergeCredentialCreationOptions(baseOptions, overrides) {
    return $281a441cdcb2cf36$var$deepMerge($281a441cdcb2cf36$var$DEFAULT_CREATION_OPTIONS, baseOptions, overrides || {});
}
function $281a441cdcb2cf36$var$mergeCredentialRequestOptions(baseOptions, overrides) {
    return $281a441cdcb2cf36$var$deepMerge($281a441cdcb2cf36$var$DEFAULT_REQUEST_OPTIONS, baseOptions, overrides || {});
}
var $281a441cdcb2cf36$var$WebAuthnApi = class {
    constructor(client){
        this.client = client;
        this.enroll = this._enroll.bind(this);
        this.challenge = this._challenge.bind(this);
        this.verify = this._verify.bind(this);
        this.authenticate = this._authenticate.bind(this);
        this.register = this._register.bind(this);
    }
    /**
   * Enroll a new WebAuthn factor.
   * Creates an unverified WebAuthn factor that must be verified with a credential.
   *
   * @experimental This method is experimental and may change in future releases
   * @param {Omit<MFAEnrollWebauthnParams, 'factorType'>} params - Enrollment parameters (friendlyName required)
   * @returns {Promise<AuthMFAEnrollWebauthnResponse>} Enrolled factor details or error
   * @see {@link https://w3c.github.io/webauthn/#sctn-registering-a-new-credential W3C WebAuthn Spec - Registering a New Credential}
   */ async _enroll(params2) {
        return this.client.mfa.enroll(Object.assign(Object.assign({}, params2), {
            factorType: "webauthn"
        }));
    }
    /**
   * Challenge for WebAuthn credential creation or authentication.
   * Combines server challenge with browser credential operations.
   * Handles both registration (create) and authentication (request) flows.
   *
   * @experimental This method is experimental and may change in future releases
   * @param {MFAChallengeWebauthnParams & { friendlyName?: string; signal?: AbortSignal }} params - Challenge parameters including factorId
   * @param {Object} overrides - Allows you to override the parameters passed to navigator.credentials
   * @param {PublicKeyCredentialCreationOptionsFuture} overrides.create - Override options for credential creation
   * @param {PublicKeyCredentialRequestOptionsFuture} overrides.request - Override options for credential request
   * @returns {Promise<RequestResult>} Challenge response with credential or error
   * @see {@link https://w3c.github.io/webauthn/#sctn-credential-creation W3C WebAuthn Spec - Credential Creation}
   * @see {@link https://w3c.github.io/webauthn/#sctn-verifying-assertion W3C WebAuthn Spec - Verifying Assertion}
   */ async _challenge({ factorId: factorId, webauthn: webauthn, friendlyName: friendlyName, signal: signal }, overrides) {
        var _a2;
        try {
            const { data: challengeResponse, error: challengeError } = await this.client.mfa.challenge({
                factorId: factorId,
                webauthn: webauthn
            });
            if (!challengeResponse) return {
                data: null,
                error: challengeError
            };
            const abortSignal = signal !== null && signal !== void 0 ? signal : $281a441cdcb2cf36$var$webAuthnAbortService.createNewAbortSignal();
            if (challengeResponse.webauthn.type === "create") {
                const { user: user } = challengeResponse.webauthn.credential_options.publicKey;
                if (!user.name) {
                    const nameToUse = friendlyName;
                    if (!nameToUse) {
                        const currentUser = await this.client.getUser();
                        const userData = currentUser.data.user;
                        const fallbackName = ((_a2 = userData === null || userData === void 0 ? void 0 : userData.user_metadata) === null || _a2 === void 0 ? void 0 : _a2.name) || (userData === null || userData === void 0 ? void 0 : userData.email) || (userData === null || userData === void 0 ? void 0 : userData.id) || "User";
                        user.name = `${user.id}:${fallbackName}`;
                    } else user.name = `${user.id}:${nameToUse}`;
                }
                if (!user.displayName) user.displayName = user.name;
            }
            switch(challengeResponse.webauthn.type){
                case "create":
                    {
                        const options = $281a441cdcb2cf36$var$mergeCredentialCreationOptions(challengeResponse.webauthn.credential_options.publicKey, overrides === null || overrides === void 0 ? void 0 : overrides.create);
                        const { data: data2, error: error } = await $281a441cdcb2cf36$var$createCredential({
                            publicKey: options,
                            signal: abortSignal
                        });
                        if (data2) return {
                            data: {
                                factorId: factorId,
                                challengeId: challengeResponse.id,
                                webauthn: {
                                    type: challengeResponse.webauthn.type,
                                    credential_response: data2
                                }
                            },
                            error: null
                        };
                        return {
                            data: null,
                            error: error
                        };
                    }
                case "request":
                    {
                        const options = $281a441cdcb2cf36$var$mergeCredentialRequestOptions(challengeResponse.webauthn.credential_options.publicKey, overrides === null || overrides === void 0 ? void 0 : overrides.request);
                        const { data: data2, error: error } = await $281a441cdcb2cf36$var$getCredential(Object.assign(Object.assign({}, challengeResponse.webauthn.credential_options), {
                            publicKey: options,
                            signal: abortSignal
                        }));
                        if (data2) return {
                            data: {
                                factorId: factorId,
                                challengeId: challengeResponse.id,
                                webauthn: {
                                    type: challengeResponse.webauthn.type,
                                    credential_response: data2
                                }
                            },
                            error: null
                        };
                        return {
                            data: null,
                            error: error
                        };
                    }
            }
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return {
                data: null,
                error: error
            };
            return {
                data: null,
                error: new $281a441cdcb2cf36$var$AuthUnknownError("Unexpected error in challenge", error)
            };
        }
    }
    /**
   * Verify a WebAuthn credential with the server.
   * Completes the WebAuthn ceremony by sending the credential to the server for verification.
   *
   * @experimental This method is experimental and may change in future releases
   * @param {Object} params - Verification parameters
   * @param {string} params.challengeId - ID of the challenge being verified
   * @param {string} params.factorId - ID of the WebAuthn factor
   * @param {MFAVerifyWebauthnParams<T>['webauthn']} params.webauthn - WebAuthn credential response
   * @returns {Promise<AuthMFAVerifyResponse>} Verification result with session or error
   * @see {@link https://w3c.github.io/webauthn/#sctn-verifying-assertion W3C WebAuthn Spec - Verifying an Authentication Assertion}
   * */ async _verify({ challengeId: challengeId, factorId: factorId, webauthn: webauthn }) {
        return this.client.mfa.verify({
            factorId: factorId,
            challengeId: challengeId,
            webauthn: webauthn
        });
    }
    /**
   * Complete WebAuthn authentication flow.
   * Performs challenge and verification in a single operation for existing credentials.
   *
   * @experimental This method is experimental and may change in future releases
   * @param {Object} params - Authentication parameters
   * @param {string} params.factorId - ID of the WebAuthn factor to authenticate with
   * @param {Object} params.webauthn - WebAuthn configuration
   * @param {string} params.webauthn.rpId - Relying Party ID (defaults to current hostname)
   * @param {string[]} params.webauthn.rpOrigins - Allowed origins (defaults to current origin)
   * @param {AbortSignal} params.webauthn.signal - Optional abort signal
   * @param {PublicKeyCredentialRequestOptionsFuture} overrides - Override options for navigator.credentials.get
   * @returns {Promise<RequestResult<AuthMFAVerifyResponseData, WebAuthnError | AuthError>>} Authentication result
   * @see {@link https://w3c.github.io/webauthn/#sctn-authentication W3C WebAuthn Spec - Authentication Ceremony}
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/PublicKeyCredentialRequestOptions MDN - PublicKeyCredentialRequestOptions}
   */ async _authenticate({ factorId: factorId, webauthn: { rpId: rpId = typeof window !== "undefined" ? window.location.hostname : void 0, rpOrigins: rpOrigins = typeof window !== "undefined" ? [
        window.location.origin
    ] : void 0, signal: signal } = {} }, overrides) {
        if (!rpId) return {
            data: null,
            error: new $281a441cdcb2cf36$var$AuthError("rpId is required for WebAuthn authentication")
        };
        try {
            if (!$281a441cdcb2cf36$var$browserSupportsWebAuthn()) return {
                data: null,
                error: new $281a441cdcb2cf36$var$AuthUnknownError("Browser does not support WebAuthn", null)
            };
            const { data: challengeResponse, error: challengeError } = await this.challenge({
                factorId: factorId,
                webauthn: {
                    rpId: rpId,
                    rpOrigins: rpOrigins
                },
                signal: signal
            }, {
                request: overrides
            });
            if (!challengeResponse) return {
                data: null,
                error: challengeError
            };
            const { webauthn: webauthn } = challengeResponse;
            return this._verify({
                factorId: factorId,
                challengeId: challengeResponse.challengeId,
                webauthn: {
                    type: webauthn.type,
                    rpId: rpId,
                    rpOrigins: rpOrigins,
                    credential_response: webauthn.credential_response
                }
            });
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return {
                data: null,
                error: error
            };
            return {
                data: null,
                error: new $281a441cdcb2cf36$var$AuthUnknownError("Unexpected error in authenticate", error)
            };
        }
    }
    /**
   * Complete WebAuthn registration flow.
   * Performs enrollment, challenge, and verification in a single operation for new credentials.
   *
   * @experimental This method is experimental and may change in future releases
   * @param {Object} params - Registration parameters
   * @param {string} params.friendlyName - User-friendly name for the credential
   * @param {string} params.rpId - Relying Party ID (defaults to current hostname)
   * @param {string[]} params.rpOrigins - Allowed origins (defaults to current origin)
   * @param {AbortSignal} params.signal - Optional abort signal
   * @param {PublicKeyCredentialCreationOptionsFuture} overrides - Override options for navigator.credentials.create
   * @returns {Promise<RequestResult<AuthMFAVerifyResponseData, WebAuthnError | AuthError>>} Registration result
   * @see {@link https://w3c.github.io/webauthn/#sctn-registering-a-new-credential W3C WebAuthn Spec - Registration Ceremony}
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/PublicKeyCredentialCreationOptions MDN - PublicKeyCredentialCreationOptions}
   */ async _register({ friendlyName: friendlyName, webauthn: { rpId: rpId = typeof window !== "undefined" ? window.location.hostname : void 0, rpOrigins: rpOrigins = typeof window !== "undefined" ? [
        window.location.origin
    ] : void 0, signal: signal } = {} }, overrides) {
        if (!rpId) return {
            data: null,
            error: new $281a441cdcb2cf36$var$AuthError("rpId is required for WebAuthn registration")
        };
        try {
            if (!$281a441cdcb2cf36$var$browserSupportsWebAuthn()) return {
                data: null,
                error: new $281a441cdcb2cf36$var$AuthUnknownError("Browser does not support WebAuthn", null)
            };
            const { data: factor, error: enrollError } = await this._enroll({
                friendlyName: friendlyName
            });
            if (!factor) {
                await this.client.mfa.listFactors().then((factors)=>{
                    var _a2;
                    return (_a2 = factors.data) === null || _a2 === void 0 ? void 0 : _a2.all.find((v3)=>v3.factor_type === "webauthn" && v3.friendly_name === friendlyName && v3.status !== "unverified");
                }).then((factor2)=>factor2 ? this.client.mfa.unenroll({
                        factorId: factor2 === null || factor2 === void 0 ? void 0 : factor2.id
                    }) : void 0);
                return {
                    data: null,
                    error: enrollError
                };
            }
            const { data: challengeResponse, error: challengeError } = await this._challenge({
                factorId: factor.id,
                friendlyName: factor.friendly_name,
                webauthn: {
                    rpId: rpId,
                    rpOrigins: rpOrigins
                },
                signal: signal
            }, {
                create: overrides
            });
            if (!challengeResponse) return {
                data: null,
                error: challengeError
            };
            return this._verify({
                factorId: factor.id,
                challengeId: challengeResponse.challengeId,
                webauthn: {
                    rpId: rpId,
                    rpOrigins: rpOrigins,
                    type: challengeResponse.webauthn.type,
                    credential_response: challengeResponse.webauthn.credential_response
                }
            });
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return {
                data: null,
                error: error
            };
            return {
                data: null,
                error: new $281a441cdcb2cf36$var$AuthUnknownError("Unexpected error in register", error)
            };
        }
    }
};
// ../node_modules/@supabase/auth-js/dist/module/GoTrueClient.js
$281a441cdcb2cf36$var$polyfillGlobalThis();
var $281a441cdcb2cf36$var$DEFAULT_OPTIONS = {
    url: $281a441cdcb2cf36$var$GOTRUE_URL,
    storageKey: $281a441cdcb2cf36$var$STORAGE_KEY2,
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    headers: $281a441cdcb2cf36$var$DEFAULT_HEADERS2,
    flowType: "implicit",
    debug: false,
    hasCustomAuthorizationHeader: false,
    throwOnError: false,
    lockAcquireTimeout: 5e3,
    // 5 seconds
    skipAutoInitialize: false,
    experimental: {}
};
async function $281a441cdcb2cf36$var$lockNoOp(name, acquireTimeout, fn) {
    return await fn();
}
var $281a441cdcb2cf36$var$GLOBAL_JWKS = {};
var $281a441cdcb2cf36$var$GoTrueClient = class _GoTrueClient {
    /**
   * The JWKS used for verifying asymmetric JWTs
   */ get jwks() {
        var _a2, _b;
        return (_b = (_a2 = $281a441cdcb2cf36$var$GLOBAL_JWKS[this.storageKey]) === null || _a2 === void 0 ? void 0 : _a2.jwks) !== null && _b !== void 0 ? _b : {
            keys: []
        };
    }
    set jwks(value2) {
        $281a441cdcb2cf36$var$GLOBAL_JWKS[this.storageKey] = Object.assign(Object.assign({}, $281a441cdcb2cf36$var$GLOBAL_JWKS[this.storageKey]), {
            jwks: value2
        });
    }
    get jwks_cached_at() {
        var _a2, _b;
        return (_b = (_a2 = $281a441cdcb2cf36$var$GLOBAL_JWKS[this.storageKey]) === null || _a2 === void 0 ? void 0 : _a2.cachedAt) !== null && _b !== void 0 ? _b : Number.MIN_SAFE_INTEGER;
    }
    set jwks_cached_at(value2) {
        $281a441cdcb2cf36$var$GLOBAL_JWKS[this.storageKey] = Object.assign(Object.assign({}, $281a441cdcb2cf36$var$GLOBAL_JWKS[this.storageKey]), {
            cachedAt: value2
        });
    }
    /**
   * Create a new client for use in the browser.
   *
   * @example Using supabase-js (recommended)
   * ```ts
   * import { createClient } from '@supabase/supabase-js'
   *
   * const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
   * const { data, error } = await supabase.auth.getUser()
   * ```
   *
   * @example Standalone import for bundle-sensitive environments
   * ```ts
   * import { GoTrueClient } from '@supabase/auth-js'
   *
   * const auth = new GoTrueClient({
   *   url: 'https://xyzcompany.supabase.co/auth/v1',
   *   headers: { apikey: 'your-publishable-key' },
   *   storageKey: 'supabase-auth',
   * })
   * ```
   */ constructor(options){
        var _a2, _b, _c, _d;
        this.userStorage = null;
        this.memoryStorage = null;
        this.stateChangeEmitters = /* @__PURE__ */ new Map();
        this.autoRefreshTicker = null;
        this.autoRefreshTickTimeout = null;
        this.visibilityChangedCallback = null;
        this.refreshingDeferred = null;
        this.initializePromise = null;
        this.detectSessionInUrl = true;
        this.hasCustomAuthorizationHeader = false;
        this.suppressGetSessionWarning = false;
        this.lockAcquired = false;
        this.pendingInLock = [];
        this.broadcastChannel = null;
        this.logger = console.log;
        const settings = Object.assign(Object.assign({}, $281a441cdcb2cf36$var$DEFAULT_OPTIONS), options);
        this.storageKey = settings.storageKey;
        this.instanceID = (_a2 = _GoTrueClient.nextInstanceID[this.storageKey]) !== null && _a2 !== void 0 ? _a2 : 0;
        _GoTrueClient.nextInstanceID[this.storageKey] = this.instanceID + 1;
        this.logDebugMessages = !!settings.debug;
        if (typeof settings.debug === "function") this.logger = settings.debug;
        if (this.instanceID > 0 && $281a441cdcb2cf36$var$isBrowser3()) {
            const message = `${this._logPrefix()} Multiple GoTrueClient instances detected in the same browser context. It is not an error, but this should be avoided as it may produce undefined behavior when used concurrently under the same storage key.`;
            console.warn(message);
            if (this.logDebugMessages) console.trace(message);
        }
        this.persistSession = settings.persistSession;
        this.autoRefreshToken = settings.autoRefreshToken;
        this.experimental = (_b = settings.experimental) !== null && _b !== void 0 ? _b : {};
        this.admin = new $281a441cdcb2cf36$var$GoTrueAdminApi({
            url: settings.url,
            headers: settings.headers,
            fetch: settings.fetch,
            experimental: this.experimental
        });
        this.url = settings.url;
        this.headers = settings.headers;
        this.fetch = $281a441cdcb2cf36$var$resolveFetch3(settings.fetch);
        this.lock = settings.lock || $281a441cdcb2cf36$var$lockNoOp;
        this.detectSessionInUrl = settings.detectSessionInUrl;
        this.flowType = settings.flowType;
        this.hasCustomAuthorizationHeader = settings.hasCustomAuthorizationHeader;
        this.throwOnError = settings.throwOnError;
        this.lockAcquireTimeout = settings.lockAcquireTimeout;
        if (settings.lock) this.lock = settings.lock;
        else if (this.persistSession && $281a441cdcb2cf36$var$isBrowser3() && ((_c = globalThis === null || globalThis === void 0 ? void 0 : globalThis.navigator) === null || _c === void 0 ? void 0 : _c.locks)) this.lock = $281a441cdcb2cf36$var$navigatorLock;
        else this.lock = $281a441cdcb2cf36$var$lockNoOp;
        if (!this.jwks) {
            this.jwks = {
                keys: []
            };
            this.jwks_cached_at = Number.MIN_SAFE_INTEGER;
        }
        this.mfa = {
            verify: this._verify.bind(this),
            enroll: this._enroll.bind(this),
            unenroll: this._unenroll.bind(this),
            challenge: this._challenge.bind(this),
            listFactors: this._listFactors.bind(this),
            challengeAndVerify: this._challengeAndVerify.bind(this),
            getAuthenticatorAssuranceLevel: this._getAuthenticatorAssuranceLevel.bind(this),
            webauthn: new $281a441cdcb2cf36$var$WebAuthnApi(this)
        };
        this.oauth = {
            getAuthorizationDetails: this._getAuthorizationDetails.bind(this),
            approveAuthorization: this._approveAuthorization.bind(this),
            denyAuthorization: this._denyAuthorization.bind(this),
            listGrants: this._listOAuthGrants.bind(this),
            revokeGrant: this._revokeOAuthGrant.bind(this)
        };
        this.passkey = {
            startRegistration: this._startPasskeyRegistration.bind(this),
            verifyRegistration: this._verifyPasskeyRegistration.bind(this),
            startAuthentication: this._startPasskeyAuthentication.bind(this),
            verifyAuthentication: this._verifyPasskeyAuthentication.bind(this),
            list: this._listPasskeys.bind(this),
            update: this._updatePasskey.bind(this),
            delete: this._deletePasskey.bind(this)
        };
        if (this.persistSession) {
            if (settings.storage) this.storage = settings.storage;
            else if ($281a441cdcb2cf36$var$supportsLocalStorage()) this.storage = globalThis.localStorage;
            else {
                this.memoryStorage = {};
                this.storage = $281a441cdcb2cf36$var$memoryLocalStorageAdapter(this.memoryStorage);
            }
            if (settings.userStorage) this.userStorage = settings.userStorage;
        } else {
            this.memoryStorage = {};
            this.storage = $281a441cdcb2cf36$var$memoryLocalStorageAdapter(this.memoryStorage);
        }
        if ($281a441cdcb2cf36$var$isBrowser3() && globalThis.BroadcastChannel && this.persistSession && this.storageKey) {
            try {
                this.broadcastChannel = new globalThis.BroadcastChannel(this.storageKey);
            } catch (e4) {
                console.error("Failed to create a new BroadcastChannel, multi-tab state changes will not be available", e4);
            }
            (_d = this.broadcastChannel) === null || _d === void 0 || _d.addEventListener("message", async (event)=>{
                this._debug("received broadcast notification from other tab or client", event);
                try {
                    await this._notifyAllSubscribers(event.data.event, event.data.session, false);
                } catch (error) {
                    this._debug("#broadcastChannel", "error", error);
                }
            });
        }
        if (!settings.skipAutoInitialize) this.initialize().catch((error)=>{
            this._debug("#initialize()", "error", error);
        });
    }
    /**
   * Returns whether error throwing mode is enabled for this client.
   */ isThrowOnErrorEnabled() {
        return this.throwOnError;
    }
    /**
   * Centralizes return handling with optional error throwing. When `throwOnError` is enabled
   * and the provided result contains a non-nullish error, the error is thrown instead of
   * being returned. This ensures consistent behavior across all public API methods.
   */ _returnResult(result) {
        if (this.throwOnError && result && result.error) throw result.error;
        return result;
    }
    _logPrefix() {
        return `GoTrueClient@${this.storageKey}:${this.instanceID} (${$281a441cdcb2cf36$var$version4}) ${/* @__PURE__ */ new Date().toISOString()}`;
    }
    _debug(...args2) {
        if (this.logDebugMessages) this.logger(this._logPrefix(), ...args2);
        return this;
    }
    /**
   * Initializes the client session either from the url or from storage.
   * This method is automatically called when instantiating the client, but should also be called
   * manually when checking for an error from an auth redirect (oauth, magiclink, password recovery, etc).
   *
   * @category Auth
   */ async initialize() {
        if (this.initializePromise) return await this.initializePromise;
        this.initializePromise = (async ()=>{
            return await this._acquireLock(this.lockAcquireTimeout, async ()=>{
                return await this._initialize();
            });
        })();
        return await this.initializePromise;
    }
    /**
   * IMPORTANT:
   * 1. Never throw in this method, as it is called from the constructor
   * 2. Never return a session from this method as it would be cached over
   *    the whole lifetime of the client
   */ async _initialize() {
        var _a2;
        try {
            let params2 = {};
            let callbackUrlType = "none";
            if ($281a441cdcb2cf36$var$isBrowser3()) {
                params2 = $281a441cdcb2cf36$var$parseParametersFromURL(window.location.href);
                if (this._isImplicitGrantCallback(params2)) callbackUrlType = "implicit";
                else if (await this._isPKCECallback(params2)) callbackUrlType = "pkce";
            }
            if ($281a441cdcb2cf36$var$isBrowser3() && this.detectSessionInUrl && callbackUrlType !== "none") {
                const { data: data2, error: error } = await this._getSessionFromURL(params2, callbackUrlType);
                if (error) {
                    this._debug("#_initialize()", "error detecting session from URL", error);
                    if ($281a441cdcb2cf36$var$isAuthImplicitGrantRedirectError(error)) {
                        const errorCode = (_a2 = error.details) === null || _a2 === void 0 ? void 0 : _a2.code;
                        if (errorCode === "identity_already_exists" || errorCode === "identity_not_found" || errorCode === "single_identity_not_deletable") return {
                            error: error
                        };
                    }
                    return {
                        error: error
                    };
                }
                const { session: session, redirectType: redirectType } = data2;
                this._debug("#_initialize()", "detected session in URL", session, "redirect type", redirectType);
                await this._saveSession(session);
                setTimeout(async ()=>{
                    if (redirectType === "recovery") await this._notifyAllSubscribers("PASSWORD_RECOVERY", session);
                    else await this._notifyAllSubscribers("SIGNED_IN", session);
                }, 0);
                return {
                    error: null
                };
            }
            await this._recoverAndRefresh();
            return {
                error: null
            };
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return this._returnResult({
                error: error
            });
            return this._returnResult({
                error: new $281a441cdcb2cf36$var$AuthUnknownError("Unexpected error during initialization", error)
            });
        } finally{
            await this._handleVisibilityChange();
            this._debug("#_initialize()", "end");
        }
    }
    /**
   * Creates a new anonymous user.
   *
   * @returns A session where the is_anonymous claim in the access token JWT set to true
   *
   * @category Auth
   *
   * @remarks
   * - Returns an anonymous user
   * - It is recommended to set up captcha for anonymous sign-ins to prevent abuse. You can pass in the captcha token in the `options` param.
   *
   * @example Create an anonymous user
   * ```js
   * const { data, error } = await supabase.auth.signInAnonymously({
   *   options: {
   *     captchaToken
   *   }
   * });
   * ```
   *
   * @exampleResponse Create an anonymous user
   * ```json
   * {
   *   "data": {
   *     "user": {
   *       "id": "11111111-1111-1111-1111-111111111111",
   *       "aud": "authenticated",
   *       "role": "authenticated",
   *       "email": "",
   *       "phone": "",
   *       "last_sign_in_at": "2024-01-01T00:00:00Z",
   *       "app_metadata": {},
   *       "user_metadata": {},
   *       "identities": [],
   *       "created_at": "2024-01-01T00:00:00Z",
   *       "updated_at": "2024-01-01T00:00:00Z",
   *       "is_anonymous": true
   *     },
   *     "session": {
   *       "access_token": "<ACCESS_TOKEN>",
   *       "token_type": "bearer",
   *       "expires_in": 3600,
   *       "expires_at": 1700000000,
   *       "refresh_token": "<REFRESH_TOKEN>",
   *       "user": {
   *         "id": "11111111-1111-1111-1111-111111111111",
   *         "aud": "authenticated",
   *         "role": "authenticated",
   *         "email": "",
   *         "phone": "",
   *         "last_sign_in_at": "2024-01-01T00:00:00Z",
   *         "app_metadata": {},
   *         "user_metadata": {},
   *         "identities": [],
   *         "created_at": "2024-01-01T00:00:00Z",
   *         "updated_at": "2024-01-01T00:00:00Z",
   *         "is_anonymous": true
   *       }
   *     }
   *   },
   *   "error": null
   * }
   * ```
   *
   * @example Create an anonymous user with custom user metadata
   * ```js
   * const { data, error } = await supabase.auth.signInAnonymously({
   *   options: {
   *     data
   *   }
   * })
   * ```
   */ async signInAnonymously(credentials) {
        var _a2, _b, _c;
        try {
            const res = await $281a441cdcb2cf36$var$_request(this.fetch, "POST", `${this.url}/signup`, {
                headers: this.headers,
                body: {
                    data: (_b = (_a2 = credentials === null || credentials === void 0 ? void 0 : credentials.options) === null || _a2 === void 0 ? void 0 : _a2.data) !== null && _b !== void 0 ? _b : {},
                    gotrue_meta_security: {
                        captcha_token: (_c = credentials === null || credentials === void 0 ? void 0 : credentials.options) === null || _c === void 0 ? void 0 : _c.captchaToken
                    }
                },
                xform: $281a441cdcb2cf36$var$_sessionResponse
            });
            const { data: data2, error: error } = res;
            if (error || !data2) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            const session = data2.session;
            const user = data2.user;
            if (data2.session) {
                await this._saveSession(data2.session);
                await this._notifyAllSubscribers("SIGNED_IN", session);
            }
            return this._returnResult({
                data: {
                    user: user,
                    session: session
                },
                error: null
            });
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
   * Creates a new user.
   *
   * Be aware that if a user account exists in the system you may get back an
   * error message that attempts to hide this information from the user.
   * This method has support for PKCE via email signups. The PKCE flow cannot be used when autoconfirm is enabled.
   *
   * @returns A logged-in session if the server has "autoconfirm" ON
   * @returns A user if the server has "autoconfirm" OFF
   *
   * @category Auth
   *
   * @remarks
   * - By default, the user needs to verify their email address before logging in. To turn this off, disable **Confirm email** in [your project](/dashboard/project/_/auth/providers).
   * - **Confirm email** determines if users need to confirm their email address after signing up.
   *   - If **Confirm email** is enabled, a `user` is returned but `session` is null.
   *   - If **Confirm email** is disabled, both a `user` and a `session` are returned.
   * - When the user confirms their email address, they are redirected to the [`SITE_URL`](/docs/guides/auth/redirect-urls#use-wildcards-in-redirect-urls) by default. You can modify your `SITE_URL` or add additional redirect URLs in [your project](/dashboard/project/_/auth/url-configuration).
   * - If signUp() is called for an existing confirmed user:
   *   - When both **Confirm email** and **Confirm phone** (even when phone provider is disabled) are enabled in [your project](/dashboard/project/_/auth/providers), an obfuscated/fake user object is returned.
   *   - When either **Confirm email** or **Confirm phone** (even when phone provider is disabled) is disabled, the error message, `User already registered` is returned.
   * - To fetch the currently logged-in user, refer to [`getUser()`](/docs/reference/javascript/auth-getuser).
   *
   * @example Sign up with an email and password
   * ```js
   * const { data, error } = await supabase.auth.signUp({
   *   email: 'example@email.com',
   *   password: 'example-password',
   * })
   * ```
   *
   * @exampleResponse Sign up with an email and password
   * ```json
   * // Some fields may be null if "confirm email" is enabled.
   * {
   *   "data": {
   *     "user": {
   *       "id": "11111111-1111-1111-1111-111111111111",
   *       "aud": "authenticated",
   *       "role": "authenticated",
   *       "email": "example@email.com",
   *       "email_confirmed_at": "2024-01-01T00:00:00Z",
   *       "phone": "",
   *       "last_sign_in_at": "2024-01-01T00:00:00Z",
   *       "app_metadata": {
   *         "provider": "email",
   *         "providers": [
   *           "email"
   *         ]
   *       },
   *       "user_metadata": {},
   *       "identities": [
   *         {
   *           "identity_id": "22222222-2222-2222-2222-222222222222",
   *           "id": "11111111-1111-1111-1111-111111111111",
   *           "user_id": "11111111-1111-1111-1111-111111111111",
   *           "identity_data": {
   *             "email": "example@email.com",
   *             "email_verified": false,
   *             "phone_verified": false,
   *             "sub": "11111111-1111-1111-1111-111111111111"
   *           },
   *           "provider": "email",
   *           "last_sign_in_at": "2024-01-01T00:00:00Z",
   *           "created_at": "2024-01-01T00:00:00Z",
   *           "updated_at": "2024-01-01T00:00:00Z",
   *           "email": "example@email.com"
   *         }
   *       ],
   *       "created_at": "2024-01-01T00:00:00Z",
   *       "updated_at": "2024-01-01T00:00:00Z"
   *     },
   *     "session": {
   *       "access_token": "<ACCESS_TOKEN>",
   *       "token_type": "bearer",
   *       "expires_in": 3600,
   *       "expires_at": 1700000000,
   *       "refresh_token": "<REFRESH_TOKEN>",
   *       "user": {
   *         "id": "11111111-1111-1111-1111-111111111111",
   *         "aud": "authenticated",
   *         "role": "authenticated",
   *         "email": "example@email.com",
   *         "email_confirmed_at": "2024-01-01T00:00:00Z",
   *         "phone": "",
   *         "last_sign_in_at": "2024-01-01T00:00:00Z",
   *         "app_metadata": {
   *           "provider": "email",
   *           "providers": [
   *             "email"
   *           ]
   *         },
   *         "user_metadata": {},
   *         "identities": [
   *           {
   *             "identity_id": "22222222-2222-2222-2222-222222222222",
   *             "id": "11111111-1111-1111-1111-111111111111",
   *             "user_id": "11111111-1111-1111-1111-111111111111",
   *             "identity_data": {
   *               "email": "example@email.com",
   *               "email_verified": false,
   *               "phone_verified": false,
   *               "sub": "11111111-1111-1111-1111-111111111111"
   *             },
   *             "provider": "email",
   *             "last_sign_in_at": "2024-01-01T00:00:00Z",
   *             "created_at": "2024-01-01T00:00:00Z",
   *             "updated_at": "2024-01-01T00:00:00Z",
   *             "email": "example@email.com"
   *           }
   *         ],
   *         "created_at": "2024-01-01T00:00:00Z",
   *         "updated_at": "2024-01-01T00:00:00Z"
   *       }
   *     }
   *   },
   *   "error": null
   * }
   * ```
   *
   * @example Sign up with a phone number and password (SMS)
   * ```js
   * const { data, error } = await supabase.auth.signUp({
   *   phone: '123456789',
   *   password: 'example-password',
   *   options: {
   *     channel: 'sms'
   *   }
   * })
   * ```
   *
   * @exampleDescription Sign up with a phone number and password (whatsapp)
   * The user will be sent a WhatsApp message which contains a OTP. By default, a given user can only request a OTP once every 60 seconds. Note that a user will need to have a valid WhatsApp account that is linked to Twilio in order to use this feature.
   *
   * @example Sign up with a phone number and password (whatsapp)
   * ```js
   * const { data, error } = await supabase.auth.signUp({
   *   phone: '123456789',
   *   password: 'example-password',
   *   options: {
   *     channel: 'whatsapp'
   *   }
   * })
   * ```
   *
   * @example Sign up with additional user metadata
   * ```js
   * const { data, error } = await supabase.auth.signUp(
   *   {
   *     email: 'example@email.com',
   *     password: 'example-password',
   *     options: {
   *       data: {
   *         first_name: 'John',
   *         age: 27,
   *       }
   *     }
   *   }
   * )
   * ```
   *
   * @exampleDescription Sign up with a redirect URL
   * - See [redirect URLs and wildcards](/docs/guides/auth/redirect-urls#use-wildcards-in-redirect-urls) to add additional redirect URLs to your project.
   *
   * @example Sign up with a redirect URL
   * ```js
   * const { data, error } = await supabase.auth.signUp(
   *   {
   *     email: 'example@email.com',
   *     password: 'example-password',
   *     options: {
   *       emailRedirectTo: 'https://example.com/welcome'
   *     }
   *   }
   * )
   * ```
   */ async signUp(credentials) {
        var _a2, _b, _c;
        try {
            let res;
            if ("email" in credentials) {
                const { email: email, password: password, options: options } = credentials;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === "pkce") [codeChallenge, codeChallengeMethod] = await $281a441cdcb2cf36$var$getCodeChallengeAndMethod(this.storage, this.storageKey);
                res = await $281a441cdcb2cf36$var$_request(this.fetch, "POST", `${this.url}/signup`, {
                    headers: this.headers,
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo,
                    body: {
                        email: email,
                        password: password,
                        data: (_a2 = options === null || options === void 0 ? void 0 : options.data) !== null && _a2 !== void 0 ? _a2 : {},
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    },
                    xform: $281a441cdcb2cf36$var$_sessionResponse
                });
            } else if ("phone" in credentials) {
                const { phone: phone, password: password, options: options } = credentials;
                res = await $281a441cdcb2cf36$var$_request(this.fetch, "POST", `${this.url}/signup`, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        password: password,
                        data: (_b = options === null || options === void 0 ? void 0 : options.data) !== null && _b !== void 0 ? _b : {},
                        channel: (_c = options === null || options === void 0 ? void 0 : options.channel) !== null && _c !== void 0 ? _c : "sms",
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: $281a441cdcb2cf36$var$_sessionResponse
                });
            } else throw new $281a441cdcb2cf36$var$AuthInvalidCredentialsError("You must provide either an email or phone number and a password");
            const { data: data2, error: error } = res;
            if (error || !data2) {
                await $281a441cdcb2cf36$var$removeItemAsync(this.storage, `${this.storageKey}-code-verifier`);
                return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
            }
            const session = data2.session;
            const user = data2.user;
            if (data2.session) {
                await this._saveSession(data2.session);
                await this._notifyAllSubscribers("SIGNED_IN", session);
            }
            return this._returnResult({
                data: {
                    user: user,
                    session: session
                },
                error: null
            });
        } catch (error) {
            await $281a441cdcb2cf36$var$removeItemAsync(this.storage, `${this.storageKey}-code-verifier`);
            if ($281a441cdcb2cf36$var$isAuthError(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
   * Log in an existing user with an email and password or phone and password.
   *
   * Be aware that you may get back an error message that will not distinguish
   * between the cases where the account does not exist or that the
   * email/phone and password combination is wrong or that the account can only
   * be accessed via social login.
   *
   * @category Auth
   *
   * @remarks
   * - Requires either an email and password or a phone number and password.
   *
   * @example Sign in with email and password
   * ```js
   * const { data, error } = await supabase.auth.signInWithPassword({
   *   email: 'example@email.com',
   *   password: 'example-password',
   * })
   * ```
   *
   * @exampleResponse Sign in with email and password
   * ```json
   * {
   *   "data": {
   *     "user": {
   *       "id": "11111111-1111-1111-1111-111111111111",
   *       "aud": "authenticated",
   *       "role": "authenticated",
   *       "email": "example@email.com",
   *       "email_confirmed_at": "2024-01-01T00:00:00Z",
   *       "phone": "",
   *       "last_sign_in_at": "2024-01-01T00:00:00Z",
   *       "app_metadata": {
   *         "provider": "email",
   *         "providers": [
   *           "email"
   *         ]
   *       },
   *       "user_metadata": {},
   *       "identities": [
   *         {
   *           "identity_id": "22222222-2222-2222-2222-222222222222",
   *           "id": "11111111-1111-1111-1111-111111111111",
   *           "user_id": "11111111-1111-1111-1111-111111111111",
   *           "identity_data": {
   *             "email": "example@email.com",
   *             "email_verified": false,
   *             "phone_verified": false,
   *             "sub": "11111111-1111-1111-1111-111111111111"
   *           },
   *           "provider": "email",
   *           "last_sign_in_at": "2024-01-01T00:00:00Z",
   *           "created_at": "2024-01-01T00:00:00Z",
   *           "updated_at": "2024-01-01T00:00:00Z",
   *           "email": "example@email.com"
   *         }
   *       ],
   *       "created_at": "2024-01-01T00:00:00Z",
   *       "updated_at": "2024-01-01T00:00:00Z"
   *     },
   *     "session": {
   *       "access_token": "<ACCESS_TOKEN>",
   *       "token_type": "bearer",
   *       "expires_in": 3600,
   *       "expires_at": 1700000000,
   *       "refresh_token": "<REFRESH_TOKEN>",
   *       "user": {
   *         "id": "11111111-1111-1111-1111-111111111111",
   *         "aud": "authenticated",
   *         "role": "authenticated",
   *         "email": "example@email.com",
   *         "email_confirmed_at": "2024-01-01T00:00:00Z",
   *         "phone": "",
   *         "last_sign_in_at": "2024-01-01T00:00:00Z",
   *         "app_metadata": {
   *           "provider": "email",
   *           "providers": [
   *             "email"
   *           ]
   *         },
   *         "user_metadata": {},
   *         "identities": [
   *           {
   *             "identity_id": "22222222-2222-2222-2222-222222222222",
   *             "id": "11111111-1111-1111-1111-111111111111",
   *             "user_id": "11111111-1111-1111-1111-111111111111",
   *             "identity_data": {
   *               "email": "example@email.com",
   *               "email_verified": false,
   *               "phone_verified": false,
   *               "sub": "11111111-1111-1111-1111-111111111111"
   *             },
   *             "provider": "email",
   *             "last_sign_in_at": "2024-01-01T00:00:00Z",
   *             "created_at": "2024-01-01T00:00:00Z",
   *             "updated_at": "2024-01-01T00:00:00Z",
   *             "email": "example@email.com"
   *           }
   *         ],
   *         "created_at": "2024-01-01T00:00:00Z",
   *         "updated_at": "2024-01-01T00:00:00Z"
   *       }
   *     }
   *   },
   *   "error": null
   * }
   * ```
   *
   * @example Sign in with phone and password
   * ```js
   * const { data, error } = await supabase.auth.signInWithPassword({
   *   phone: '+13334445555',
   *   password: 'some-password',
   * })
   * ```
   */ async signInWithPassword(credentials) {
        try {
            let res;
            if ("email" in credentials) {
                const { email: email, password: password, options: options } = credentials;
                res = await $281a441cdcb2cf36$var$_request(this.fetch, "POST", `${this.url}/token?grant_type=password`, {
                    headers: this.headers,
                    body: {
                        email: email,
                        password: password,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: $281a441cdcb2cf36$var$_sessionResponsePassword
                });
            } else if ("phone" in credentials) {
                const { phone: phone, password: password, options: options } = credentials;
                res = await $281a441cdcb2cf36$var$_request(this.fetch, "POST", `${this.url}/token?grant_type=password`, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        password: password,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: $281a441cdcb2cf36$var$_sessionResponsePassword
                });
            } else throw new $281a441cdcb2cf36$var$AuthInvalidCredentialsError("You must provide either an email or phone number and a password");
            const { data: data2, error: error } = res;
            if (error) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            else if (!data2 || !data2.session || !data2.user) {
                const invalidTokenError = new $281a441cdcb2cf36$var$AuthInvalidTokenResponseError();
                return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: invalidTokenError
                });
            }
            if (data2.session) {
                await this._saveSession(data2.session);
                await this._notifyAllSubscribers("SIGNED_IN", data2.session);
            }
            return this._returnResult({
                data: Object.assign({
                    user: data2.user,
                    session: data2.session
                }, data2.weak_password ? {
                    weakPassword: data2.weak_password
                } : null),
                error: error
            });
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
   * Log in an existing user via a third-party provider.
   * This method supports the PKCE flow.
   *
   * @category Auth
   *
   * @remarks
   * - This method is used for signing in using [Social Login (OAuth) providers](/docs/guides/auth#configure-third-party-providers).
   * - It works by redirecting your application to the provider's authorization screen, before bringing back the user to your app.
   *
   * @example Sign in using a third-party provider
   * ```js
   * const { data, error } = await supabase.auth.signInWithOAuth({
   *   provider: 'github'
   * })
   * ```
   *
   * @exampleResponse Sign in using a third-party provider
   * ```json
   * {
   *   data: {
   *     provider: 'github',
   *     url: <PROVIDER_URL_TO_REDIRECT_TO>
   *   },
   *   error: null
   * }
   * ```
   *
   * @exampleDescription Sign in using a third-party provider with redirect
   * - When the OAuth provider successfully authenticates the user, they are redirected to the URL specified in the `redirectTo` parameter. This parameter defaults to the [`SITE_URL`](/docs/guides/auth/redirect-urls#use-wildcards-in-redirect-urls). It does not redirect the user immediately after invoking this method.
   * - See [redirect URLs and wildcards](/docs/guides/auth/redirect-urls#use-wildcards-in-redirect-urls) to add additional redirect URLs to your project.
   *
   * @example Sign in using a third-party provider with redirect
   * ```js
   * const { data, error } = await supabase.auth.signInWithOAuth({
   *   provider: 'github',
   *   options: {
   *     redirectTo: 'https://example.com/welcome'
   *   }
   * })
   * ```
   *
   * @exampleDescription Sign in with scopes and access provider tokens
   * If you need additional access from an OAuth provider, in order to access provider specific APIs in the name of the user, you can do this by passing in the scopes the user should authorize for your application. Note that the `scopes` option takes in **a space-separated list** of scopes.
   *
   * Because OAuth sign-in often includes redirects, you should register an `onAuthStateChange` callback immediately after you create the Supabase client. This callback will listen for the presence of `provider_token` and `provider_refresh_token` properties on the `session` object and store them in local storage. The client library will emit these values **only once** immediately after the user signs in. You can then access them by looking them up in local storage, or send them to your backend servers for further processing.
   *
   * Finally, make sure you remove them from local storage on the `SIGNED_OUT` event. If the OAuth provider supports token revocation, make sure you call those APIs either from the frontend or schedule them to be called on the backend.
   *
   * @example Sign in with scopes and access provider tokens
   * ```js
   * // Register this immediately after calling createClient!
   * // Because signInWithOAuth causes a redirect, you need to fetch the
   * // provider tokens from the callback.
   * supabase.auth.onAuthStateChange((event, session) => {
   *   if (session && session.provider_token) {
   *     window.localStorage.setItem('oauth_provider_token', session.provider_token)
   *   }
   *
   *   if (session && session.provider_refresh_token) {
   *     window.localStorage.setItem('oauth_provider_refresh_token', session.provider_refresh_token)
   *   }
   *
   *   if (event === 'SIGNED_OUT') {
   *     window.localStorage.removeItem('oauth_provider_token')
   *     window.localStorage.removeItem('oauth_provider_refresh_token')
   *   }
   * })
   *
   * // Call this on your Sign in with GitHub button to initiate OAuth
   * // with GitHub with the requested elevated scopes.
   * await supabase.auth.signInWithOAuth({
   *   provider: 'github',
   *   options: {
   *     scopes: 'repo gist notifications'
   *   }
   * })
   * ```
   */ async signInWithOAuth(credentials) {
        var _a2, _b, _c, _d;
        return await this._handleProviderSignIn(credentials.provider, {
            redirectTo: (_a2 = credentials.options) === null || _a2 === void 0 ? void 0 : _a2.redirectTo,
            scopes: (_b = credentials.options) === null || _b === void 0 ? void 0 : _b.scopes,
            queryParams: (_c = credentials.options) === null || _c === void 0 ? void 0 : _c.queryParams,
            skipBrowserRedirect: (_d = credentials.options) === null || _d === void 0 ? void 0 : _d.skipBrowserRedirect
        });
    }
    /**
   * Log in an existing user by exchanging an Auth Code issued during the PKCE flow.
   *
   * @category Auth
   *
   * @remarks
   * - Used when `flowType` is set to `pkce` in client options.
   *
   * @example Exchange Auth Code
   * ```js
   * supabase.auth.exchangeCodeForSession('34e770dd-9ff9-416c-87fa-43b31d7ef225')
   * ```
   *
   * @exampleResponse Exchange Auth Code
   * ```json
   * {
   *   "data": {
   *     session: {
   *       access_token: '<ACCESS_TOKEN>',
   *       token_type: 'bearer',
   *       expires_in: 3600,
   *       expires_at: 1700000000,
   *       refresh_token: '<REFRESH_TOKEN>',
   *       user: {
   *         id: '11111111-1111-1111-1111-111111111111',
   *         aud: 'authenticated',
   *         role: 'authenticated',
   *         email: 'example@email.com'
   *         email_confirmed_at: '2024-01-01T00:00:00Z',
   *         phone: '',
   *         confirmation_sent_at: '2024-01-01T00:00:00Z',
   *         confirmed_at: '2024-01-01T00:00:00Z',
   *         last_sign_in_at: '2024-01-01T00:00:00Z',
   *         app_metadata: {
   *           "provider": "email",
   *           "providers": [
   *             "email",
   *             "<OTHER_PROVIDER>"
   *           ]
   *         },
   *         user_metadata: {
   *           email: 'email@email.com',
   *           email_verified: true,
   *           full_name: 'User Name',
   *           iss: '<ISS>',
   *           name: 'User Name',
   *           phone_verified: false,
   *           provider_id: '<PROVIDER_ID>',
   *           sub: '<SUB>'
   *         },
   *         identities: [
   *           {
   *             "identity_id": "22222222-2222-2222-2222-222222222222",
   *             "id": "11111111-1111-1111-1111-111111111111",
   *             "user_id": "11111111-1111-1111-1111-111111111111",
   *             "identity_data": {
   *               "email": "example@email.com",
   *               "email_verified": false,
   *               "phone_verified": false,
   *               "sub": "11111111-1111-1111-1111-111111111111"
   *             },
   *             "provider": "email",
   *             "last_sign_in_at": "2024-01-01T00:00:00Z",
   *             "created_at": "2024-01-01T00:00:00Z",
   *             "updated_at": "2024-01-01T00:00:00Z",
   *             "email": "email@example.com"
   *           },
   *           {
   *             "identity_id": "33333333-3333-3333-3333-333333333333",
   *             "id": "<ID>",
   *             "user_id": "<USER_ID>",
   *             "identity_data": {
   *               "email": "example@email.com",
   *               "email_verified": true,
   *               "full_name": "User Name",
   *               "iss": "<ISS>",
   *               "name": "User Name",
   *               "phone_verified": false,
   *               "provider_id": "<PROVIDER_ID>",
   *               "sub": "<SUB>"
   *             },
   *             "provider": "<PROVIDER>",
   *             "last_sign_in_at": "2024-01-01T00:00:00Z",
   *             "created_at": "2024-01-01T00:00:00Z",
   *             "updated_at": "2024-01-01T00:00:00Z",
   *             "email": "example@email.com"
   *           }
   *         ],
   *         created_at: '2024-01-01T00:00:00Z',
   *         updated_at: '2024-01-01T00:00:00Z',
   *         is_anonymous: false
   *       },
   *       provider_token: '<PROVIDER_TOKEN>',
   *       provider_refresh_token: '<PROVIDER_REFRESH_TOKEN>'
   *     },
   *     user: {
   *       id: '11111111-1111-1111-1111-111111111111',
   *       aud: 'authenticated',
   *       role: 'authenticated',
   *       email: 'example@email.com',
   *       email_confirmed_at: '2024-01-01T00:00:00Z',
   *       phone: '',
   *       confirmation_sent_at: '2024-01-01T00:00:00Z',
   *       confirmed_at: '2024-01-01T00:00:00Z',
   *       last_sign_in_at: '2024-01-01T00:00:00Z',
   *       app_metadata: {
   *         provider: 'email',
   *         providers: [
   *           "email",
   *           "<OTHER_PROVIDER>"
   *         ]
   *       },
   *       user_metadata: {
   *         email: 'email@email.com',
   *         email_verified: true,
   *         full_name: 'User Name',
   *         iss: '<ISS>',
   *         name: 'User Name',
   *         phone_verified: false,
   *         provider_id: '<PROVIDER_ID>',
   *         sub: '<SUB>'
   *       },
   *       identities: [
   *         {
   *           "identity_id": "22222222-2222-2222-2222-222222222222",
   *           "id": "11111111-1111-1111-1111-111111111111",
   *           "user_id": "11111111-1111-1111-1111-111111111111",
   *           "identity_data": {
   *             "email": "example@email.com",
   *             "email_verified": false,
   *             "phone_verified": false,
   *             "sub": "11111111-1111-1111-1111-111111111111"
   *           },
   *           "provider": "email",
   *           "last_sign_in_at": "2024-01-01T00:00:00Z",
   *           "created_at": "2024-01-01T00:00:00Z",
   *           "updated_at": "2024-01-01T00:00:00Z",
   *           "email": "email@example.com"
   *         },
   *         {
   *           "identity_id": "33333333-3333-3333-3333-333333333333",
   *           "id": "<ID>",
   *           "user_id": "<USER_ID>",
   *           "identity_data": {
   *             "email": "example@email.com",
   *             "email_verified": true,
   *             "full_name": "User Name",
   *             "iss": "<ISS>",
   *             "name": "User Name",
   *             "phone_verified": false,
   *             "provider_id": "<PROVIDER_ID>",
   *             "sub": "<SUB>"
   *           },
   *           "provider": "<PROVIDER>",
   *           "last_sign_in_at": "2024-01-01T00:00:00Z",
   *           "created_at": "2024-01-01T00:00:00Z",
   *           "updated_at": "2024-01-01T00:00:00Z",
   *           "email": "example@email.com"
   *         }
   *       ],
   *       created_at: '2024-01-01T00:00:00Z',
   *       updated_at: '2024-01-01T00:00:00Z',
   *       is_anonymous: false
   *     },
   *     redirectType: null
   *   },
   *   "error": null
   * }
   * ```
   */ async exchangeCodeForSession(authCode) {
        await this.initializePromise;
        return this._acquireLock(this.lockAcquireTimeout, async ()=>{
            return this._exchangeCodeForSession(authCode);
        });
    }
    /**
   * Signs in a user by verifying a message signed by the user's private key.
   * Supports Ethereum (via Sign-In-With-Ethereum) & Solana (Sign-In-With-Solana) standards,
   * both of which derive from the EIP-4361 standard
   * With slight variation on Solana's side.
   * @reference https://eips.ethereum.org/EIPS/eip-4361
   *
   * @category Auth
   *
   * @remarks
   * - Uses a Web3 (Ethereum, Solana) wallet to sign a user in.
   * - Read up on the [potential for abuse](/docs/guides/auth/auth-web3#potential-for-abuse) before using it.
   *
   * @example Sign in with Solana or Ethereum (Window API)
   * ```js
   *   // uses window.ethereum for the wallet
   *   const { data, error } = await supabase.auth.signInWithWeb3({
   *     chain: 'ethereum',
   *     statement: 'I accept the Terms of Service at https://example.com/tos'
   *   })
   *
   *   // uses window.solana for the wallet
   *   const { data, error } = await supabase.auth.signInWithWeb3({
   *     chain: 'solana',
   *     statement: 'I accept the Terms of Service at https://example.com/tos'
   *   })
   * ```
   *
   * @example Sign in with Ethereum (Message and Signature)
   * ```js
   *   const { data, error } = await supabase.auth.signInWithWeb3({
   *     chain: 'ethereum',
   *     message: '<sign in with ethereum message>',
   *     signature: '<hex of the ethereum signature over the message>',
   *   })
   * ```
   *
   * @example Sign in with Solana (Brave)
   * ```js
   *   const { data, error } = await supabase.auth.signInWithWeb3({
   *     chain: 'solana',
   *     statement: 'I accept the Terms of Service at https://example.com/tos',
   *     wallet: window.braveSolana
   *   })
   * ```
   *
   * @example Sign in with Solana (Wallet Adapter)
   * ```jsx
   *   function SignInButton() {
   *   const wallet = useWallet()
   *
   *   return (
   *     <>
   *       {wallet.connected ? (
   *         <button
   *           onClick={() => {
   *             supabase.auth.signInWithWeb3({
   *               chain: 'solana',
   *               statement: 'I accept the Terms of Service at https://example.com/tos',
   *               wallet,
   *             })
   *           }}
   *         >
   *           Sign in with Solana
   *         </button>
   *       ) : (
   *         <WalletMultiButton />
   *       )}
   *     </>
   *   )
   * }
   *
   * function App() {
   *   const endpoint = clusterApiUrl('devnet')
   *   const wallets = useMemo(() => [], [])
   *
   *   return (
   *     <ConnectionProvider endpoint={endpoint}>
   *       <WalletProvider wallets={wallets}>
   *         <WalletModalProvider>
   *           <SignInButton />
   *         </WalletModalProvider>
   *       </WalletProvider>
   *     </ConnectionProvider>
   *   )
   * }
   * ```
   */ async signInWithWeb3(credentials) {
        const { chain: chain } = credentials;
        switch(chain){
            case "ethereum":
                return await this.signInWithEthereum(credentials);
            case "solana":
                return await this.signInWithSolana(credentials);
            default:
                throw new Error(`@supabase/auth-js: Unsupported chain "${chain}"`);
        }
    }
    async signInWithEthereum(credentials) {
        var _a2, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        let message;
        let signature;
        if ("message" in credentials) {
            message = credentials.message;
            signature = credentials.signature;
        } else {
            const { chain: chain, wallet: wallet, statement: statement, options: options } = credentials;
            let resolvedWallet;
            if (!$281a441cdcb2cf36$var$isBrowser3()) {
                if (typeof wallet !== "object" || !(options === null || options === void 0 ? void 0 : options.url)) throw new Error("@supabase/auth-js: Both wallet and url must be specified in non-browser environments.");
                resolvedWallet = wallet;
            } else if (typeof wallet === "object") resolvedWallet = wallet;
            else {
                const windowAny = window;
                if ("ethereum" in windowAny && typeof windowAny.ethereum === "object" && "request" in windowAny.ethereum && typeof windowAny.ethereum.request === "function") resolvedWallet = windowAny.ethereum;
                else throw new Error(`@supabase/auth-js: No compatible Ethereum wallet interface on the window object (window.ethereum) detected. Make sure the user already has a wallet installed and connected for this app. Prefer passing the wallet interface object directly to signInWithWeb3({ chain: 'ethereum', wallet: resolvedUserWallet }) instead.`);
            }
            const url2 = new URL((_a2 = options === null || options === void 0 ? void 0 : options.url) !== null && _a2 !== void 0 ? _a2 : window.location.href);
            const accounts = await resolvedWallet.request({
                method: "eth_requestAccounts"
            }).then((accs)=>accs).catch(()=>{
                throw new Error(`@supabase/auth-js: Wallet method eth_requestAccounts is missing or invalid`);
            });
            if (!accounts || accounts.length === 0) throw new Error(`@supabase/auth-js: No accounts available. Please ensure the wallet is connected.`);
            const address = $281a441cdcb2cf36$var$getAddress(accounts[0]);
            let chainId = (_b = options === null || options === void 0 ? void 0 : options.signInWithEthereum) === null || _b === void 0 ? void 0 : _b.chainId;
            if (!chainId) {
                const chainIdHex = await resolvedWallet.request({
                    method: "eth_chainId"
                });
                chainId = $281a441cdcb2cf36$var$fromHex(chainIdHex);
            }
            const siweMessage = {
                domain: url2.host,
                address: address,
                statement: statement,
                uri: url2.href,
                version: "1",
                chainId: chainId,
                nonce: (_c = options === null || options === void 0 ? void 0 : options.signInWithEthereum) === null || _c === void 0 ? void 0 : _c.nonce,
                issuedAt: (_e = (_d = options === null || options === void 0 ? void 0 : options.signInWithEthereum) === null || _d === void 0 ? void 0 : _d.issuedAt) !== null && _e !== void 0 ? _e : /* @__PURE__ */ new Date(),
                expirationTime: (_f = options === null || options === void 0 ? void 0 : options.signInWithEthereum) === null || _f === void 0 ? void 0 : _f.expirationTime,
                notBefore: (_g = options === null || options === void 0 ? void 0 : options.signInWithEthereum) === null || _g === void 0 ? void 0 : _g.notBefore,
                requestId: (_h = options === null || options === void 0 ? void 0 : options.signInWithEthereum) === null || _h === void 0 ? void 0 : _h.requestId,
                resources: (_j = options === null || options === void 0 ? void 0 : options.signInWithEthereum) === null || _j === void 0 ? void 0 : _j.resources
            };
            message = $281a441cdcb2cf36$var$createSiweMessage(siweMessage);
            signature = await resolvedWallet.request({
                method: "personal_sign",
                params: [
                    $281a441cdcb2cf36$var$toHex2(message),
                    address
                ]
            });
        }
        try {
            const { data: data2, error: error } = await $281a441cdcb2cf36$var$_request(this.fetch, "POST", `${this.url}/token?grant_type=web3`, {
                headers: this.headers,
                body: Object.assign({
                    chain: "ethereum",
                    message: message,
                    signature: signature
                }, ((_k = credentials.options) === null || _k === void 0 ? void 0 : _k.captchaToken) ? {
                    gotrue_meta_security: {
                        captcha_token: (_l = credentials.options) === null || _l === void 0 ? void 0 : _l.captchaToken
                    }
                } : null),
                xform: $281a441cdcb2cf36$var$_sessionResponse
            });
            if (error) throw error;
            if (!data2 || !data2.session || !data2.user) {
                const invalidTokenError = new $281a441cdcb2cf36$var$AuthInvalidTokenResponseError();
                return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: invalidTokenError
                });
            }
            if (data2.session) {
                await this._saveSession(data2.session);
                await this._notifyAllSubscribers("SIGNED_IN", data2.session);
            }
            return this._returnResult({
                data: Object.assign({}, data2),
                error: error
            });
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    async signInWithSolana(credentials) {
        var _a2, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        let message;
        let signature;
        if ("message" in credentials) {
            message = credentials.message;
            signature = credentials.signature;
        } else {
            const { chain: chain, wallet: wallet, statement: statement, options: options } = credentials;
            let resolvedWallet;
            if (!$281a441cdcb2cf36$var$isBrowser3()) {
                if (typeof wallet !== "object" || !(options === null || options === void 0 ? void 0 : options.url)) throw new Error("@supabase/auth-js: Both wallet and url must be specified in non-browser environments.");
                resolvedWallet = wallet;
            } else if (typeof wallet === "object") resolvedWallet = wallet;
            else {
                const windowAny = window;
                if ("solana" in windowAny && typeof windowAny.solana === "object" && ("signIn" in windowAny.solana && typeof windowAny.solana.signIn === "function" || "signMessage" in windowAny.solana && typeof windowAny.solana.signMessage === "function")) resolvedWallet = windowAny.solana;
                else throw new Error(`@supabase/auth-js: No compatible Solana wallet interface on the window object (window.solana) detected. Make sure the user already has a wallet installed and connected for this app. Prefer passing the wallet interface object directly to signInWithWeb3({ chain: 'solana', wallet: resolvedUserWallet }) instead.`);
            }
            const url2 = new URL((_a2 = options === null || options === void 0 ? void 0 : options.url) !== null && _a2 !== void 0 ? _a2 : window.location.href);
            if ("signIn" in resolvedWallet && resolvedWallet.signIn) {
                const output = await resolvedWallet.signIn(Object.assign(Object.assign(Object.assign({
                    issuedAt: /* @__PURE__ */ new Date().toISOString()
                }, options === null || options === void 0 ? void 0 : options.signInWithSolana), {
                    // non-overridable properties
                    version: "1",
                    domain: url2.host,
                    uri: url2.href
                }), statement ? {
                    statement: statement
                } : null));
                let outputToProcess;
                if (Array.isArray(output) && output[0] && typeof output[0] === "object") outputToProcess = output[0];
                else if (output && typeof output === "object" && "signedMessage" in output && "signature" in output) outputToProcess = output;
                else throw new Error("@supabase/auth-js: Wallet method signIn() returned unrecognized value");
                if ("signedMessage" in outputToProcess && "signature" in outputToProcess && (typeof outputToProcess.signedMessage === "string" || outputToProcess.signedMessage instanceof Uint8Array) && outputToProcess.signature instanceof Uint8Array) {
                    message = typeof outputToProcess.signedMessage === "string" ? outputToProcess.signedMessage : new TextDecoder().decode(outputToProcess.signedMessage);
                    signature = outputToProcess.signature;
                } else throw new Error("@supabase/auth-js: Wallet method signIn() API returned object without signedMessage and signature fields");
            } else {
                if (!("signMessage" in resolvedWallet) || typeof resolvedWallet.signMessage !== "function" || !("publicKey" in resolvedWallet) || typeof resolvedWallet !== "object" || !resolvedWallet.publicKey || !("toBase58" in resolvedWallet.publicKey) || typeof resolvedWallet.publicKey.toBase58 !== "function") throw new Error("@supabase/auth-js: Wallet does not have a compatible signMessage() and publicKey.toBase58() API");
                message = [
                    `${url2.host} wants you to sign in with your Solana account:`,
                    resolvedWallet.publicKey.toBase58(),
                    ...statement ? [
                        "",
                        statement,
                        ""
                    ] : [
                        ""
                    ],
                    "Version: 1",
                    `URI: ${url2.href}`,
                    `Issued At: ${(_c = (_b = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _b === void 0 ? void 0 : _b.issuedAt) !== null && _c !== void 0 ? _c : /* @__PURE__ */ new Date().toISOString()}`,
                    ...((_d = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _d === void 0 ? void 0 : _d.notBefore) ? [
                        `Not Before: ${options.signInWithSolana.notBefore}`
                    ] : [],
                    ...((_e = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _e === void 0 ? void 0 : _e.expirationTime) ? [
                        `Expiration Time: ${options.signInWithSolana.expirationTime}`
                    ] : [],
                    ...((_f = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _f === void 0 ? void 0 : _f.chainId) ? [
                        `Chain ID: ${options.signInWithSolana.chainId}`
                    ] : [],
                    ...((_g = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _g === void 0 ? void 0 : _g.nonce) ? [
                        `Nonce: ${options.signInWithSolana.nonce}`
                    ] : [],
                    ...((_h = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _h === void 0 ? void 0 : _h.requestId) ? [
                        `Request ID: ${options.signInWithSolana.requestId}`
                    ] : [],
                    ...((_k = (_j = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _j === void 0 ? void 0 : _j.resources) === null || _k === void 0 ? void 0 : _k.length) ? [
                        "Resources",
                        ...options.signInWithSolana.resources.map((resource)=>`- ${resource}`)
                    ] : []
                ].join("\n");
                const maybeSignature = await resolvedWallet.signMessage(new TextEncoder().encode(message), "utf8");
                if (!maybeSignature || !(maybeSignature instanceof Uint8Array)) throw new Error("@supabase/auth-js: Wallet signMessage() API returned an recognized value");
                signature = maybeSignature;
            }
        }
        try {
            const { data: data2, error: error } = await $281a441cdcb2cf36$var$_request(this.fetch, "POST", `${this.url}/token?grant_type=web3`, {
                headers: this.headers,
                body: Object.assign({
                    chain: "solana",
                    message: message,
                    signature: $281a441cdcb2cf36$var$bytesToBase64URL(signature)
                }, ((_l = credentials.options) === null || _l === void 0 ? void 0 : _l.captchaToken) ? {
                    gotrue_meta_security: {
                        captcha_token: (_m = credentials.options) === null || _m === void 0 ? void 0 : _m.captchaToken
                    }
                } : null),
                xform: $281a441cdcb2cf36$var$_sessionResponse
            });
            if (error) throw error;
            if (!data2 || !data2.session || !data2.user) {
                const invalidTokenError = new $281a441cdcb2cf36$var$AuthInvalidTokenResponseError();
                return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: invalidTokenError
                });
            }
            if (data2.session) {
                await this._saveSession(data2.session);
                await this._notifyAllSubscribers("SIGNED_IN", data2.session);
            }
            return this._returnResult({
                data: Object.assign({}, data2),
                error: error
            });
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    async _exchangeCodeForSession(authCode) {
        const storageItem = await $281a441cdcb2cf36$var$getItemAsync(this.storage, `${this.storageKey}-code-verifier`);
        const [codeVerifier, redirectType] = (storageItem !== null && storageItem !== void 0 ? storageItem : "").split("/");
        try {
            if (!codeVerifier && this.flowType === "pkce") throw new $281a441cdcb2cf36$var$AuthPKCECodeVerifierMissingError();
            const { data: data2, error: error } = await $281a441cdcb2cf36$var$_request(this.fetch, "POST", `${this.url}/token?grant_type=pkce`, {
                headers: this.headers,
                body: {
                    auth_code: authCode,
                    code_verifier: codeVerifier
                },
                xform: $281a441cdcb2cf36$var$_sessionResponse
            });
            await $281a441cdcb2cf36$var$removeItemAsync(this.storage, `${this.storageKey}-code-verifier`);
            if (error) throw error;
            if (!data2 || !data2.session || !data2.user) {
                const invalidTokenError = new $281a441cdcb2cf36$var$AuthInvalidTokenResponseError();
                return this._returnResult({
                    data: {
                        user: null,
                        session: null,
                        redirectType: null
                    },
                    error: invalidTokenError
                });
            }
            if (data2.session) {
                await this._saveSession(data2.session);
                await this._notifyAllSubscribers(redirectType === "recovery" ? "PASSWORD_RECOVERY" : "SIGNED_IN", data2.session);
            }
            return this._returnResult({
                data: Object.assign(Object.assign({}, data2), {
                    redirectType: redirectType !== null && redirectType !== void 0 ? redirectType : null
                }),
                error: error
            });
        } catch (error) {
            await $281a441cdcb2cf36$var$removeItemAsync(this.storage, `${this.storageKey}-code-verifier`);
            if ($281a441cdcb2cf36$var$isAuthError(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null,
                    redirectType: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
   * Allows signing in with an OIDC ID token. The authentication provider used
   * should be enabled and configured.
   *
   * @category Auth
   *
   * @remarks
   * - Use an ID token to sign in.
   * - Especially useful when implementing sign in using native platform dialogs in mobile or desktop apps using Sign in with Apple or Sign in with Google on iOS and Android.
   * - You can also use Google's [One Tap](https://developers.google.com/identity/gsi/web/guides/display-google-one-tap) and [Automatic sign-in](https://developers.google.com/identity/gsi/web/guides/automatic-sign-in-sign-out) via this API.
   *
   * @example Sign In using ID Token
   * ```js
   * const { data, error } = await supabase.auth.signInWithIdToken({
   *   provider: 'google',
   *   token: 'your-id-token'
   * })
   * ```
   *
   * @exampleResponse Sign In using ID Token
   * ```json
   * {
   *   "data": {
   *     "user": {
   *       "id": "11111111-1111-1111-1111-111111111111",
   *       "aud": "authenticated",
   *       "role": "authenticated",
   *       "last_sign_in_at": "2024-01-01T00:00:00Z",
   *       "app_metadata": {
   *         ...
   *       },
   *       "user_metadata": {
   *         ...
   *       },
   *       "identities": [
   *         {
   *           "identity_id": "22222222-2222-2222-2222-222222222222",
   *           "provider": "google",
   *         }
   *       ],
   *       "created_at": "2024-01-01T00:00:00Z",
   *       "updated_at": "2024-01-01T00:00:00Z",
   *     },
   *     "session": {
   *       "access_token": "<ACCESS_TOKEN>",
   *       "token_type": "bearer",
   *       "expires_in": 3600,
   *       "expires_at": 1700000000,
   *       "refresh_token": "<REFRESH_TOKEN>",
   *       "user": {
   *         "id": "11111111-1111-1111-1111-111111111111",
   *         "aud": "authenticated",
   *         "role": "authenticated",
   *         "last_sign_in_at": "2024-01-01T00:00:00Z",
   *         "app_metadata": {
   *           ...
   *         },
   *         "user_metadata": {
   *           ...
   *         },
   *         "identities": [
   *           {
   *             "identity_id": "22222222-2222-2222-2222-222222222222",
   *             "provider": "google",
   *           }
   *         ],
   *         "created_at": "2024-01-01T00:00:00Z",
   *         "updated_at": "2024-01-01T00:00:00Z",
   *       }
   *     }
   *   },
   *   "error": null
   * }
   * ```
   */ async signInWithIdToken(credentials) {
        try {
            const { options: options, provider: provider, token: token, access_token: access_token, nonce: nonce } = credentials;
            const res = await $281a441cdcb2cf36$var$_request(this.fetch, "POST", `${this.url}/token?grant_type=id_token`, {
                headers: this.headers,
                body: {
                    provider: provider,
                    id_token: token,
                    access_token: access_token,
                    nonce: nonce,
                    gotrue_meta_security: {
                        captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                    }
                },
                xform: $281a441cdcb2cf36$var$_sessionResponse
            });
            const { data: data2, error: error } = res;
            if (error) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            else if (!data2 || !data2.session || !data2.user) {
                const invalidTokenError = new $281a441cdcb2cf36$var$AuthInvalidTokenResponseError();
                return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: invalidTokenError
                });
            }
            if (data2.session) {
                await this._saveSession(data2.session);
                await this._notifyAllSubscribers("SIGNED_IN", data2.session);
            }
            return this._returnResult({
                data: data2,
                error: error
            });
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
   * Log in a user using magiclink or a one-time password (OTP).
   *
   * If the `{{ .ConfirmationURL }}` variable is specified in the email template, a magiclink will be sent.
   * If the `{{ .Token }}` variable is specified in the email template, an OTP will be sent.
   * If you're using phone sign-ins, only an OTP will be sent. You won't be able to send a magiclink for phone sign-ins.
   *
   * Be aware that you may get back an error message that will not distinguish
   * between the cases where the account does not exist or, that the account
   * can only be accessed via social login.
   *
   * Do note that you will need to configure a Whatsapp sender on Twilio
   * if you are using phone sign in with the 'whatsapp' channel. The whatsapp
   * channel is not supported on other providers
   * at this time.
   * This method supports PKCE when an email is passed.
   *
   * @category Auth
   *
   * @remarks
   * - Requires either an email or phone number.
   * - This method is used for passwordless sign-ins where a OTP is sent to the user's email or phone number.
   * - If the user doesn't exist, `signInWithOtp()` will signup the user instead. To restrict this behavior, you can set `shouldCreateUser` in `SignInWithPasswordlessCredentials.options` to `false`.
   * - If you're using an email, you can configure whether you want the user to receive a magiclink or a OTP.
   * - If you're using phone, you can configure whether you want the user to receive a OTP.
   * - The magic link's destination URL is determined by the [`SITE_URL`](/docs/guides/auth/redirect-urls#use-wildcards-in-redirect-urls).
   * - See [redirect URLs and wildcards](/docs/guides/auth/redirect-urls#use-wildcards-in-redirect-urls) to add additional redirect URLs to your project.
   * - Magic links and OTPs share the same implementation. To send users a one-time code instead of a magic link, [modify the magic link email template](/dashboard/project/_/auth/templates) to include `{{ .Token }}` instead of `{{ .ConfirmationURL }}`.
   * - See our [Twilio Phone Auth Guide](/docs/guides/auth/phone-login?showSMSProvider=Twilio) for details about configuring WhatsApp sign in.
   *
   * @exampleDescription Sign in with email
   * The user will be sent an email which contains either a magiclink or a OTP or both. By default, a given user can only request a OTP once every 60 seconds.
   *
   * @example Sign in with email
   * ```js
   * const { data, error } = await supabase.auth.signInWithOtp({
   *   email: 'example@email.com',
   *   options: {
   *     emailRedirectTo: 'https://example.com/welcome'
   *   }
   * })
   * ```
   *
   * @exampleResponse Sign in with email
   * ```json
   * {
   *   "data": {
   *     "user": null,
   *     "session": null
   *   },
   *   "error": null
   * }
   * ```
   *
   * @exampleDescription Sign in with SMS OTP
   * The user will be sent a SMS which contains a OTP. By default, a given user can only request a OTP once every 60 seconds.
   *
   * @example Sign in with SMS OTP
   * ```js
   * const { data, error } = await supabase.auth.signInWithOtp({
   *   phone: '+13334445555',
   * })
   * ```
   *
   * @exampleDescription Sign in with WhatsApp OTP
   * The user will be sent a WhatsApp message which contains a OTP. By default, a given user can only request a OTP once every 60 seconds. Note that a user will need to have a valid WhatsApp account that is linked to Twilio in order to use this feature.
   *
   * @example Sign in with WhatsApp OTP
   * ```js
   * const { data, error } = await supabase.auth.signInWithOtp({
   *   phone: '+13334445555',
   *   options: {
   *     channel:'whatsapp',
   *   }
   * })
   * ```
   */ async signInWithOtp(credentials) {
        var _a2, _b, _c, _d, _e;
        try {
            if ("email" in credentials) {
                const { email: email, options: options } = credentials;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === "pkce") [codeChallenge, codeChallengeMethod] = await $281a441cdcb2cf36$var$getCodeChallengeAndMethod(this.storage, this.storageKey);
                const { error: error } = await $281a441cdcb2cf36$var$_request(this.fetch, "POST", `${this.url}/otp`, {
                    headers: this.headers,
                    body: {
                        email: email,
                        data: (_a2 = options === null || options === void 0 ? void 0 : options.data) !== null && _a2 !== void 0 ? _a2 : {},
                        create_user: (_b = options === null || options === void 0 ? void 0 : options.shouldCreateUser) !== null && _b !== void 0 ? _b : true,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    },
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo
                });
                return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
            }
            if ("phone" in credentials) {
                const { phone: phone, options: options } = credentials;
                const { data: data2, error: error } = await $281a441cdcb2cf36$var$_request(this.fetch, "POST", `${this.url}/otp`, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        data: (_c = options === null || options === void 0 ? void 0 : options.data) !== null && _c !== void 0 ? _c : {},
                        create_user: (_d = options === null || options === void 0 ? void 0 : options.shouldCreateUser) !== null && _d !== void 0 ? _d : true,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        channel: (_e = options === null || options === void 0 ? void 0 : options.channel) !== null && _e !== void 0 ? _e : "sms"
                    }
                });
                return this._returnResult({
                    data: {
                        user: null,
                        session: null,
                        messageId: data2 === null || data2 === void 0 ? void 0 : data2.message_id
                    },
                    error: error
                });
            }
            throw new $281a441cdcb2cf36$var$AuthInvalidCredentialsError("You must provide either an email or phone number.");
        } catch (error) {
            await $281a441cdcb2cf36$var$removeItemAsync(this.storage, `${this.storageKey}-code-verifier`);
            if ($281a441cdcb2cf36$var$isAuthError(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
   * Log in a user given a User supplied OTP or TokenHash received through mobile or email.
   *
   * @category Auth
   *
   * @remarks
   * - The `verifyOtp` method takes in different verification types.
   * - If a phone number is used, the type can either be:
   *   1. `sms` – Used when verifying a one-time password (OTP) sent via SMS during sign-up or sign-in.
   *   2. `phone_change` – Used when verifying an OTP sent to a new phone number during a phone number update process.
   * - If an email address is used, the type can be one of the following (note: `signup` and `magiclink` types are deprecated):
   *   1. `email` – Used when verifying an OTP sent to the user's email during sign-up or sign-in.
   *   2. `recovery` – Used when verifying an OTP sent for account recovery, typically after a password reset request.
   *   3. `invite` – Used when verifying an OTP sent as part of an invitation to join a project or organization.
   *   4. `email_change` – Used when verifying an OTP sent to a new email address during an email update process.
   * - The verification type used should be determined based on the corresponding auth method called before `verifyOtp` to sign up / sign-in a user.
   * - The `TokenHash` is contained in the [email templates](/docs/guides/auth/auth-email-templates) and can be used to sign in.  You may wish to use the hash for the PKCE flow for Server Side Auth. Read [the Password-based Auth guide](/docs/guides/auth/passwords) for more details.
   *
   * @example Verify Signup One-Time Password (OTP)
   * ```js
   * const { data, error } = await supabase.auth.verifyOtp({ email, token, type: 'email'})
   * ```
   *
   * @exampleResponse Verify Signup One-Time Password (OTP)
   * ```json
   * {
   *   "data": {
   *     "user": {
   *       "id": "11111111-1111-1111-1111-111111111111",
   *       "aud": "authenticated",
   *       "role": "authenticated",
   *       "email": "example@email.com",
   *       "email_confirmed_at": "2024-01-01T00:00:00Z",
   *       "phone": "",
   *       "confirmed_at": "2024-01-01T00:00:00Z",
   *       "recovery_sent_at": "2024-01-01T00:00:00Z",
   *       "last_sign_in_at": "2024-01-01T00:00:00Z",
   *       "app_metadata": {
   *         "provider": "email",
   *         "providers": [
   *           "email"
   *         ]
   *       },
   *       "user_metadata": {
   *         "email": "example@email.com",
   *         "email_verified": false,
   *         "phone_verified": false,
   *         "sub": "11111111-1111-1111-1111-111111111111"
   *       },
   *       "identities": [
   *         {
   *           "identity_id": "22222222-2222-2222-2222-222222222222",
   *           "id": "11111111-1111-1111-1111-111111111111",
   *           "user_id": "11111111-1111-1111-1111-111111111111",
   *           "identity_data": {
   *             "email": "example@email.com",
   *             "email_verified": false,
   *             "phone_verified": false,
   *             "sub": "11111111-1111-1111-1111-111111111111"
   *           },
   *           "provider": "email",
   *           "last_sign_in_at": "2024-01-01T00:00:00Z",
   *           "created_at": "2024-01-01T00:00:00Z",
   *           "updated_at": "2024-01-01T00:00:00Z",
   *           "email": "example@email.com"
   *         }
   *       ],
   *       "created_at": "2024-01-01T00:00:00Z",
   *       "updated_at": "2024-01-01T00:00:00Z",
   *       "is_anonymous": false
   *     },
   *     "session": {
   *       "access_token": "<ACCESS_TOKEN>",
   *       "token_type": "bearer",
   *       "expires_in": 3600,
   *       "expires_at": 1700000000,
   *       "refresh_token": "<REFRESH_TOKEN>",
   *       "user": {
   *         "id": "11111111-1111-1111-1111-111111111111",
   *         "aud": "authenticated",
   *         "role": "authenticated",
   *         "email": "example@email.com",
   *         "email_confirmed_at": "2024-01-01T00:00:00Z",
   *         "phone": "",
   *         "confirmed_at": "2024-01-01T00:00:00Z",
   *         "recovery_sent_at": "2024-01-01T00:00:00Z",
   *         "last_sign_in_at": "2024-01-01T00:00:00Z",
   *         "app_metadata": {
   *           "provider": "email",
   *           "providers": [
   *             "email"
   *           ]
   *         },
   *         "user_metadata": {
   *           "email": "example@email.com",
   *           "email_verified": false,
   *           "phone_verified": false,
   *           "sub": "11111111-1111-1111-1111-111111111111"
   *         },
   *         "identities": [
   *           {
   *             "identity_id": "22222222-2222-2222-2222-222222222222",
   *             "id": "11111111-1111-1111-1111-111111111111",
   *             "user_id": "11111111-1111-1111-1111-111111111111",
   *             "identity_data": {
   *               "email": "example@email.com",
   *               "email_verified": false,
   *               "phone_verified": false,
   *               "sub": "11111111-1111-1111-1111-111111111111"
   *             },
   *             "provider": "email",
   *             "last_sign_in_at": "2024-01-01T00:00:00Z",
   *             "created_at": "2024-01-01T00:00:00Z",
   *             "updated_at": "2024-01-01T00:00:00Z",
   *             "email": "example@email.com"
   *           }
   *         ],
   *         "created_at": "2024-01-01T00:00:00Z",
   *         "updated_at": "2024-01-01T00:00:00Z",
   *         "is_anonymous": false
   *       }
   *     }
   *   },
   *   "error": null
   * }
   * ```
   *
   * @example Verify SMS One-Time Password (OTP)
   * ```js
   * const { data, error } = await supabase.auth.verifyOtp({ phone, token, type: 'sms'})
   * ```
   *
   * @example Verify Email Auth (Token Hash)
   * ```js
   * const { data, error } = await supabase.auth.verifyOtp({ token_hash: tokenHash, type: 'email'})
   * ```
   */ async verifyOtp(params2) {
        var _a2, _b;
        try {
            let redirectTo = void 0;
            let captchaToken = void 0;
            if ("options" in params2) {
                redirectTo = (_a2 = params2.options) === null || _a2 === void 0 ? void 0 : _a2.redirectTo;
                captchaToken = (_b = params2.options) === null || _b === void 0 ? void 0 : _b.captchaToken;
            }
            const { data: data2, error: error } = await $281a441cdcb2cf36$var$_request(this.fetch, "POST", `${this.url}/verify`, {
                headers: this.headers,
                body: Object.assign(Object.assign({}, params2), {
                    gotrue_meta_security: {
                        captcha_token: captchaToken
                    }
                }),
                redirectTo: redirectTo,
                xform: $281a441cdcb2cf36$var$_sessionResponse
            });
            if (error) throw error;
            if (!data2) {
                const tokenVerificationError = new Error("An error occurred on token verification.");
                throw tokenVerificationError;
            }
            const session = data2.session;
            const user = data2.user;
            if (session === null || session === void 0 ? void 0 : session.access_token) {
                await this._saveSession(session);
                await this._notifyAllSubscribers(params2.type == "recovery" ? "PASSWORD_RECOVERY" : "SIGNED_IN", session);
            }
            return this._returnResult({
                data: {
                    user: user,
                    session: session
                },
                error: null
            });
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
   * Attempts a single-sign on using an enterprise Identity Provider. A
   * successful SSO attempt will redirect the current page to the identity
   * provider authorization page. The redirect URL is implementation and SSO
   * protocol specific.
   *
   * You can use it by providing a SSO domain. Typically you can extract this
   * domain by asking users for their email address. If this domain is
   * registered on the Auth instance the redirect will use that organization's
   * currently active SSO Identity Provider for the login.
   *
   * If you have built an organization-specific login page, you can use the
   * organization's SSO Identity Provider UUID directly instead.
   *
   * @category Auth
   *
   * @remarks
   * - Before you can call this method you need to [establish a connection](/docs/guides/auth/sso/auth-sso-saml#managing-saml-20-connections) to an identity provider. Use the [CLI commands](/docs/reference/cli/supabase-sso) to do this.
   * - If you've associated an email domain to the identity provider, you can use the `domain` property to start a sign-in flow.
   * - In case you need to use a different way to start the authentication flow with an identity provider, you can use the `providerId` property. For example:
   *     - Mapping specific user email addresses with an identity provider.
   *     - Using different hints to identity the identity provider to be used by the user, like a company-specific page, IP address or other tracking information.
   *
   * @example Sign in with email domain
   * ```js
   *   // You can extract the user's email domain and use it to trigger the
   *   // authentication flow with the correct identity provider.
   *
   *   const { data, error } = await supabase.auth.signInWithSSO({
   *     domain: 'company.com'
   *   })
   *
   *   if (data?.url) {
   *     // redirect the user to the identity provider's authentication flow
   *     window.location.href = data.url
   *   }
   * ```
   *
   * @example Sign in with provider UUID
   * ```js
   *   // Useful when you need to map a user's sign in request according
   *   // to different rules that can't use email domains.
   *
   *   const { data, error } = await supabase.auth.signInWithSSO({
   *     providerId: '21648a9d-8d5a-4555-a9d1-d6375dc14e92'
   *   })
   *
   *   if (data?.url) {
   *     // redirect the user to the identity provider's authentication flow
   *     window.location.href = data.url
   *   }
   * ```
   */ async signInWithSSO(params2) {
        var _a2, _b, _c, _d, _e;
        try {
            let codeChallenge = null;
            let codeChallengeMethod = null;
            if (this.flowType === "pkce") [codeChallenge, codeChallengeMethod] = await $281a441cdcb2cf36$var$getCodeChallengeAndMethod(this.storage, this.storageKey);
            const result = await $281a441cdcb2cf36$var$_request(this.fetch, "POST", `${this.url}/sso`, {
                body: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, "providerId" in params2 ? {
                    provider_id: params2.providerId
                } : null), "domain" in params2 ? {
                    domain: params2.domain
                } : null), {
                    redirect_to: (_b = (_a2 = params2.options) === null || _a2 === void 0 ? void 0 : _a2.redirectTo) !== null && _b !== void 0 ? _b : void 0
                }), ((_c = params2 === null || params2 === void 0 ? void 0 : params2.options) === null || _c === void 0 ? void 0 : _c.captchaToken) ? {
                    gotrue_meta_security: {
                        captcha_token: params2.options.captchaToken
                    }
                } : null), {
                    skip_http_redirect: true,
                    code_challenge: codeChallenge,
                    code_challenge_method: codeChallengeMethod
                }),
                headers: this.headers,
                xform: $281a441cdcb2cf36$var$_ssoResponse
            });
            if (((_d = result.data) === null || _d === void 0 ? void 0 : _d.url) && $281a441cdcb2cf36$var$isBrowser3() && !((_e = params2.options) === null || _e === void 0 ? void 0 : _e.skipBrowserRedirect)) window.location.assign(result.data.url);
            return this._returnResult(result);
        } catch (error) {
            await $281a441cdcb2cf36$var$removeItemAsync(this.storage, `${this.storageKey}-code-verifier`);
            if ($281a441cdcb2cf36$var$isAuthError(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
   * Sends a reauthentication OTP to the user's email or phone number.
   * Requires the user to be signed-in.
   *
   * @category Auth
   *
   * @remarks
   * - This method is used together with `updateUser()` when a user's password needs to be updated.
   * - If you require your user to reauthenticate before updating their password, you need to enable the **Secure password change** option in your [project's email provider settings](/dashboard/project/_/auth/providers).
   * - A user is only require to reauthenticate before updating their password if **Secure password change** is enabled and the user **hasn't recently signed in**. A user is deemed recently signed in if the session was created in the last 24 hours.
   * - This method will send a nonce to the user's email. If the user doesn't have a confirmed email address, the method will send the nonce to the user's confirmed phone number instead.
   * - After receiving the OTP, include it as the `nonce` in your `updateUser()` call to finalize the password change.
   *
   * @exampleDescription Send reauthentication nonce
   * Sends a reauthentication nonce to the user's email or phone number.
   *
   * @example Send reauthentication nonce
   * ```js
   * const { error } = await supabase.auth.reauthenticate()
   * ```
   */ async reauthenticate() {
        await this.initializePromise;
        return await this._acquireLock(this.lockAcquireTimeout, async ()=>{
            return await this._reauthenticate();
        });
    }
    async _reauthenticate() {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) throw sessionError;
                if (!session) throw new $281a441cdcb2cf36$var$AuthSessionMissingError();
                const { error: error } = await $281a441cdcb2cf36$var$_request(this.fetch, "GET", `${this.url}/reauthenticate`, {
                    headers: this.headers,
                    jwt: session.access_token
                });
                return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
            });
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
   * Resends an existing signup confirmation email, email change email, SMS OTP or phone change OTP.
   *
   * @category Auth
   *
   * @remarks
   * - Resends a signup confirmation, email change or phone change email to the user.
   * - Passwordless sign-ins can be resent by calling the `signInWithOtp()` method again.
   * - Password recovery emails can be resent by calling the `resetPasswordForEmail()` method again.
   * - This method will only resend an email or phone OTP to the user if there was an initial signup, email change or phone change request being made(note: For existing users signing in with OTP, you should use `signInWithOtp()` again to resend the OTP).
   * - You can specify a redirect url when you resend an email link using the `emailRedirectTo` option.
   *
   * @exampleDescription Resend an email signup confirmation
   * Resends the email signup confirmation to the user
   *
   * @example Resend an email signup confirmation
   * ```js
   * const { error } = await supabase.auth.resend({
   *   type: 'signup',
   *   email: 'email@example.com',
   *   options: {
   *     emailRedirectTo: 'https://example.com/welcome'
   *   }
   * })
   * ```
   *
   * @exampleDescription Resend a phone signup confirmation
   * Resends the phone signup confirmation email to the user
   *
   * @example Resend a phone signup confirmation
   * ```js
   * const { error } = await supabase.auth.resend({
   *   type: 'sms',
   *   phone: '1234567890'
   * })
   * ```
   *
   * @exampleDescription Resend email change email
   * Resends the email change email to the user
   *
   * @example Resend email change email
   * ```js
   * const { error } = await supabase.auth.resend({
   *   type: 'email_change',
   *   email: 'email@example.com'
   * })
   * ```
   *
   * @exampleDescription Resend phone change OTP
   * Resends the phone change OTP to the user
   *
   * @example Resend phone change OTP
   * ```js
   * const { error } = await supabase.auth.resend({
   *   type: 'phone_change',
   *   phone: '1234567890'
   * })
   * ```
   */ async resend(credentials) {
        try {
            const endpoint = `${this.url}/resend`;
            if ("email" in credentials) {
                const { email: email, type: type, options: options } = credentials;
                const { error: error } = await $281a441cdcb2cf36$var$_request(this.fetch, "POST", endpoint, {
                    headers: this.headers,
                    body: {
                        email: email,
                        type: type,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo
                });
                return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
            } else if ("phone" in credentials) {
                const { phone: phone, type: type, options: options } = credentials;
                const { data: data2, error: error } = await $281a441cdcb2cf36$var$_request(this.fetch, "POST", endpoint, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        type: type,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    }
                });
                return this._returnResult({
                    data: {
                        user: null,
                        session: null,
                        messageId: data2 === null || data2 === void 0 ? void 0 : data2.message_id
                    },
                    error: error
                });
            }
            throw new $281a441cdcb2cf36$var$AuthInvalidCredentialsError("You must provide either an email or phone number and a type");
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
   * Returns the session, refreshing it if necessary.
   *
   * The session returned can be null if the session is not detected which can happen in the event a user is not signed-in or has logged out.
   *
   * **IMPORTANT:** This method loads values directly from the storage attached
   * to the client. If that storage is based on request cookies for example,
   * the values in it may not be authentic and therefore it's strongly advised
   * against using this method and its results in such circumstances. A warning
   * will be emitted if this is detected. Use {@link #getUser()} instead.
   *
   * @category Auth
   *
   * @remarks
   * - Since the introduction of [asymmetric JWT signing keys](/docs/guides/auth/signing-keys), this method is considered low-level and we encourage you to use `getClaims()` or `getUser()` instead.
   * - Retrieves the current [user session](/docs/guides/auth/sessions) from the storage medium (local storage, cookies).
   * - The session contains an access token (signed JWT), a refresh token and the user object.
   * - If the session's access token is expired or is about to expire, this method will use the refresh token to refresh the session.
   * - When using in a browser, or you've called `startAutoRefresh()` in your environment (React Native, etc.) this function always returns a valid access token without refreshing the session itself, as this is done in the background. This function returns very fast.
   * - **IMPORTANT SECURITY NOTICE:** If using an insecure storage medium, such as cookies or request headers, the user object returned by this function **must not be trusted**. Always verify the JWT using `getClaims()` or your own JWT verification library to securely establish the user's identity and access. You can also use `getUser()` to fetch the user object directly from the Auth server for this purpose.
   * - When using in a browser, this function is synchronized across all tabs using the [LockManager](https://developer.mozilla.org/en-US/docs/Web/API/LockManager) API. In other environments make sure you've defined a proper `lock` property, if necessary, to make sure there are no race conditions while the session is being refreshed.
   *
   * @example Get the session data
   * ```js
   * const { data, error } = await supabase.auth.getSession()
   * ```
   *
   * @exampleResponse Get the session data
   * ```json
   * {
   *   "data": {
   *     "session": {
   *       "access_token": "<ACCESS_TOKEN>",
   *       "token_type": "bearer",
   *       "expires_in": 3600,
   *       "expires_at": 1700000000,
   *       "refresh_token": "<REFRESH_TOKEN>",
   *       "user": {
   *         "id": "11111111-1111-1111-1111-111111111111",
   *         "aud": "authenticated",
   *         "role": "authenticated",
   *         "email": "example@email.com",
   *         "email_confirmed_at": "2024-01-01T00:00:00Z",
   *         "phone": "",
   *         "last_sign_in_at": "2024-01-01T00:00:00Z",
   *         "app_metadata": {
   *           "provider": "email",
   *           "providers": [
   *             "email"
   *           ]
   *         },
   *         "user_metadata": {
   *           "email": "example@email.com",
   *           "email_verified": false,
   *           "phone_verified": false,
   *           "sub": "11111111-1111-1111-1111-111111111111"
   *         },
   *         "identities": [
   *           {
   *             "identity_id": "22222222-2222-2222-2222-222222222222",
   *             "id": "11111111-1111-1111-1111-111111111111",
   *             "user_id": "11111111-1111-1111-1111-111111111111",
   *             "identity_data": {
   *               "email": "example@email.com",
   *               "email_verified": false,
   *               "phone_verified": false,
   *               "sub": "11111111-1111-1111-1111-111111111111"
   *             },
   *             "provider": "email",
   *             "last_sign_in_at": "2024-01-01T00:00:00Z",
   *             "created_at": "2024-01-01T00:00:00Z",
   *             "updated_at": "2024-01-01T00:00:00Z",
   *             "email": "example@email.com"
   *           }
   *         ],
   *         "created_at": "2024-01-01T00:00:00Z",
   *         "updated_at": "2024-01-01T00:00:00Z",
   *         "is_anonymous": false
   *       }
   *     }
   *   },
   *   "error": null
   * }
   * ```
   */ async getSession() {
        await this.initializePromise;
        const result = await this._acquireLock(this.lockAcquireTimeout, async ()=>{
            return this._useSession(async (result2)=>{
                return result2;
            });
        });
        return result;
    }
    /**
   * Acquires a global lock based on the storage key.
   */ async _acquireLock(acquireTimeout, fn) {
        this._debug("#_acquireLock", "begin", acquireTimeout);
        try {
            if (this.lockAcquired) {
                const last2 = this.pendingInLock.length ? this.pendingInLock[this.pendingInLock.length - 1] : Promise.resolve();
                const result = (async ()=>{
                    await last2;
                    return await fn();
                })();
                this.pendingInLock.push((async ()=>{
                    try {
                        await result;
                    } catch (e4) {}
                })());
                return result;
            }
            return await this.lock(`lock:${this.storageKey}`, acquireTimeout, async ()=>{
                this._debug("#_acquireLock", "lock acquired for storage key", this.storageKey);
                try {
                    this.lockAcquired = true;
                    const result = fn();
                    this.pendingInLock.push((async ()=>{
                        try {
                            await result;
                        } catch (e4) {}
                    })());
                    await result;
                    while(this.pendingInLock.length){
                        const waitOn = [
                            ...this.pendingInLock
                        ];
                        await Promise.all(waitOn);
                        this.pendingInLock.splice(0, waitOn.length);
                    }
                    return await result;
                } finally{
                    this._debug("#_acquireLock", "lock released for storage key", this.storageKey);
                    this.lockAcquired = false;
                }
            });
        } finally{
            this._debug("#_acquireLock", "end");
        }
    }
    /**
   * Use instead of {@link #getSession} inside the library. It is
   * semantically usually what you want, as getting a session involves some
   * processing afterwards that requires only one client operating on the
   * session at once across multiple tabs or processes.
   */ async _useSession(fn) {
        this._debug("#_useSession", "begin");
        try {
            const result = await this.__loadSession();
            return await fn(result);
        } finally{
            this._debug("#_useSession", "end");
        }
    }
    /**
   * NEVER USE DIRECTLY!
   *
   * Always use {@link #_useSession}.
   */ async __loadSession() {
        this._debug("#__loadSession()", "begin");
        if (!this.lockAcquired) this._debug("#__loadSession()", "used outside of an acquired lock!", new Error().stack);
        try {
            let currentSession = null;
            const maybeSession = await $281a441cdcb2cf36$var$getItemAsync(this.storage, this.storageKey);
            this._debug("#getSession()", "session from storage", maybeSession);
            if (maybeSession !== null) {
                if (this._isValidSession(maybeSession)) currentSession = maybeSession;
                else {
                    this._debug("#getSession()", "session from storage is not valid");
                    await this._removeSession();
                }
            }
            if (!currentSession) return {
                data: {
                    session: null
                },
                error: null
            };
            const hasExpired = currentSession.expires_at ? currentSession.expires_at * 1e3 - Date.now() < $281a441cdcb2cf36$var$EXPIRY_MARGIN_MS : false;
            this._debug("#__loadSession()", `session has${hasExpired ? "" : " not"} expired`, "expires_at", currentSession.expires_at);
            if (!hasExpired) {
                if (this.userStorage) {
                    const maybeUser = await $281a441cdcb2cf36$var$getItemAsync(this.userStorage, this.storageKey + "-user");
                    if (maybeUser === null || maybeUser === void 0 ? void 0 : maybeUser.user) currentSession.user = maybeUser.user;
                    else currentSession.user = $281a441cdcb2cf36$var$userNotAvailableProxy();
                }
                if (this.storage.isServer && currentSession.user && !currentSession.user.__isUserNotAvailableProxy) {
                    const suppressWarningRef = {
                        value: this.suppressGetSessionWarning
                    };
                    currentSession.user = $281a441cdcb2cf36$var$insecureUserWarningProxy(currentSession.user, suppressWarningRef);
                    if (suppressWarningRef.value) this.suppressGetSessionWarning = true;
                }
                return {
                    data: {
                        session: currentSession
                    },
                    error: null
                };
            }
            const { data: session, error: error } = await this._callRefreshToken(currentSession.refresh_token);
            if (error) return this._returnResult({
                data: {
                    session: null
                },
                error: error
            });
            return this._returnResult({
                data: {
                    session: session
                },
                error: null
            });
        } finally{
            this._debug("#__loadSession()", "end");
        }
    }
    /**
   * Gets the current user details if there is an existing session. This method
   * performs a network request to the Supabase Auth server, so the returned
   * value is authentic and can be used to base authorization rules on.
   *
   * @param jwt Takes in an optional access token JWT. If no JWT is provided, the JWT from the current session is used.
   *
   * @category Auth
   *
   * @remarks
   * - This method fetches the user object from the database instead of local session.
   * - This method is useful for checking if the user is authorized because it validates the user's access token JWT on the server.
   * - Should always be used when checking for user authorization on the server. On the client, you can instead use `getSession().session.user` for faster results. `getSession` is insecure on the server.
   *
   * @example Get the logged in user with the current existing session
   * ```js
   * const { data: { user } } = await supabase.auth.getUser()
   * ```
   *
   * @exampleResponse Get the logged in user with the current existing session
   * ```json
   * {
   *   "data": {
   *     "user": {
   *       "id": "11111111-1111-1111-1111-111111111111",
   *       "aud": "authenticated",
   *       "role": "authenticated",
   *       "email": "example@email.com",
   *       "email_confirmed_at": "2024-01-01T00:00:00Z",
   *       "phone": "",
   *       "confirmed_at": "2024-01-01T00:00:00Z",
   *       "last_sign_in_at": "2024-01-01T00:00:00Z",
   *       "app_metadata": {
   *         "provider": "email",
   *         "providers": [
   *           "email"
   *         ]
   *       },
   *       "user_metadata": {
   *         "email": "example@email.com",
   *         "email_verified": false,
   *         "phone_verified": false,
   *         "sub": "11111111-1111-1111-1111-111111111111"
   *       },
   *       "identities": [
   *         {
   *           "identity_id": "22222222-2222-2222-2222-222222222222",
   *           "id": "11111111-1111-1111-1111-111111111111",
   *           "user_id": "11111111-1111-1111-1111-111111111111",
   *           "identity_data": {
   *             "email": "example@email.com",
   *             "email_verified": false,
   *             "phone_verified": false,
   *             "sub": "11111111-1111-1111-1111-111111111111"
   *           },
   *           "provider": "email",
   *           "last_sign_in_at": "2024-01-01T00:00:00Z",
   *           "created_at": "2024-01-01T00:00:00Z",
   *           "updated_at": "2024-01-01T00:00:00Z",
   *           "email": "example@email.com"
   *         }
   *       ],
   *       "created_at": "2024-01-01T00:00:00Z",
   *       "updated_at": "2024-01-01T00:00:00Z",
   *       "is_anonymous": false
   *     }
   *   },
   *   "error": null
   * }
   * ```
   *
   * @example Get the logged in user with a custom access token jwt
   * ```js
   * const { data: { user } } = await supabase.auth.getUser(jwt)
   * ```
   */ async getUser(jwt) {
        if (jwt) return await this._getUser(jwt);
        await this.initializePromise;
        const result = await this._acquireLock(this.lockAcquireTimeout, async ()=>{
            return await this._getUser();
        });
        if (result.data.user) this.suppressGetSessionWarning = true;
        return result;
    }
    async _getUser(jwt) {
        try {
            if (jwt) return await $281a441cdcb2cf36$var$_request(this.fetch, "GET", `${this.url}/user`, {
                headers: this.headers,
                jwt: jwt,
                xform: $281a441cdcb2cf36$var$_userResponse
            });
            return await this._useSession(async (result)=>{
                var _a2, _b, _c;
                const { data: data2, error: error } = result;
                if (error) throw error;
                if (!((_a2 = data2.session) === null || _a2 === void 0 ? void 0 : _a2.access_token) && !this.hasCustomAuthorizationHeader) return {
                    data: {
                        user: null
                    },
                    error: new $281a441cdcb2cf36$var$AuthSessionMissingError()
                };
                return await $281a441cdcb2cf36$var$_request(this.fetch, "GET", `${this.url}/user`, {
                    headers: this.headers,
                    jwt: (_c = (_b = data2.session) === null || _b === void 0 ? void 0 : _b.access_token) !== null && _c !== void 0 ? _c : void 0,
                    xform: $281a441cdcb2cf36$var$_userResponse
                });
            });
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) {
                if ($281a441cdcb2cf36$var$isAuthSessionMissingError(error)) {
                    await this._removeSession();
                    await $281a441cdcb2cf36$var$removeItemAsync(this.storage, `${this.storageKey}-code-verifier`);
                }
                return this._returnResult({
                    data: {
                        user: null
                    },
                    error: error
                });
            }
            throw error;
        }
    }
    /**
   * Updates user data for a logged in user.
   *
   * @category Auth
   *
   * @remarks
   * - In order to use the `updateUser()` method, the user needs to be signed in first.
   * - By default, email updates sends a confirmation link to both the user's current and new email.
   * To only send a confirmation link to the user's new email, disable **Secure email change** in your project's [email auth provider settings](/dashboard/project/_/auth/providers).
   *
   * @exampleDescription Update the email for an authenticated user
   * Sends a "Confirm Email Change" email to the new address. If **Secure Email Change** is enabled (default), confirmation is also required from the **old email** before the change is applied. To skip dual confirmation and apply the change after only the new email is verified, disable **Secure Email Change** in the [Email Auth Provider settings](/dashboard/project/_/auth/providers?provider=Email).
   *
   * @example Update the email for an authenticated user
   * ```js
   * const { data, error } = await supabase.auth.updateUser({
   *   email: 'new@email.com'
   * })
   * ```
   *
   * @exampleResponse Update the email for an authenticated user
   * ```json
   * {
   *   "data": {
   *     "user": {
   *       "id": "11111111-1111-1111-1111-111111111111",
   *       "aud": "authenticated",
   *       "role": "authenticated",
   *       "email": "example@email.com",
   *       "email_confirmed_at": "2024-01-01T00:00:00Z",
   *       "phone": "",
   *       "confirmed_at": "2024-01-01T00:00:00Z",
   *       "new_email": "new@email.com",
   *       "email_change_sent_at": "2024-01-01T00:00:00Z",
   *       "last_sign_in_at": "2024-01-01T00:00:00Z",
   *       "app_metadata": {
   *         "provider": "email",
   *         "providers": [
   *           "email"
   *         ]
   *       },
   *       "user_metadata": {
   *         "email": "example@email.com",
   *         "email_verified": false,
   *         "phone_verified": false,
   *         "sub": "11111111-1111-1111-1111-111111111111"
   *       },
   *       "identities": [
   *         {
   *           "identity_id": "22222222-2222-2222-2222-222222222222",
   *           "id": "11111111-1111-1111-1111-111111111111",
   *           "user_id": "11111111-1111-1111-1111-111111111111",
   *           "identity_data": {
   *             "email": "example@email.com",
   *             "email_verified": false,
   *             "phone_verified": false,
   *             "sub": "11111111-1111-1111-1111-111111111111"
   *           },
   *           "provider": "email",
   *           "last_sign_in_at": "2024-01-01T00:00:00Z",
   *           "created_at": "2024-01-01T00:00:00Z",
   *           "updated_at": "2024-01-01T00:00:00Z",
   *           "email": "example@email.com"
   *         }
   *       ],
   *       "created_at": "2024-01-01T00:00:00Z",
   *       "updated_at": "2024-01-01T00:00:00Z",
   *       "is_anonymous": false
   *     }
   *   },
   *   "error": null
   * }
   * ```
   *
   * @exampleDescription Update the phone number for an authenticated user
   * Sends a one-time password (OTP) to the new phone number.
   *
   * @example Update the phone number for an authenticated user
   * ```js
   * const { data, error } = await supabase.auth.updateUser({
   *   phone: '123456789'
   * })
   * ```
   *
   * @example Update the password for an authenticated user
   * ```js
   * const { data, error } = await supabase.auth.updateUser({
   *   password: 'new password'
   * })
   * ```
   *
   * @exampleDescription Update the user's metadata
   * Updates the user's custom metadata.
   *
   * **Note**: The `data` field maps to the `auth.users.raw_user_meta_data` column in your Supabase database. When calling `getUser()`, the data will be available as `user.user_metadata`.
   *
   * @example Update the user's metadata
   * ```js
   * const { data, error } = await supabase.auth.updateUser({
   *   data: { hello: 'world' }
   * })
   * ```
   *
   * @exampleDescription Update the user's password with a nonce
   * If **Secure password change** is enabled in your [project's email provider settings](/dashboard/project/_/auth/providers), updating the user's password would require a nonce if the user **hasn't recently signed in**. The nonce is sent to the user's email or phone number. A user is deemed recently signed in if the session was created in the last 24 hours.
   *
   * @example Update the user's password with a nonce
   * ```js
   * const { data, error } = await supabase.auth.updateUser({
   *   password: 'new password',
   *   nonce: '123456'
   * })
   * ```
   */ async updateUser(attributes, options = {}) {
        await this.initializePromise;
        return await this._acquireLock(this.lockAcquireTimeout, async ()=>{
            return await this._updateUser(attributes, options);
        });
    }
    async _updateUser(attributes, options = {}) {
        try {
            return await this._useSession(async (result)=>{
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) throw sessionError;
                if (!sessionData.session) throw new $281a441cdcb2cf36$var$AuthSessionMissingError();
                const session = sessionData.session;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === "pkce" && attributes.email != null) [codeChallenge, codeChallengeMethod] = await $281a441cdcb2cf36$var$getCodeChallengeAndMethod(this.storage, this.storageKey);
                const { data: data2, error: userError } = await $281a441cdcb2cf36$var$_request(this.fetch, "PUT", `${this.url}/user`, {
                    headers: this.headers,
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo,
                    body: Object.assign(Object.assign({}, attributes), {
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    }),
                    jwt: session.access_token,
                    xform: $281a441cdcb2cf36$var$_userResponse
                });
                if (userError) throw userError;
                session.user = data2.user;
                await this._saveSession(session);
                await this._notifyAllSubscribers("USER_UPDATED", session);
                return this._returnResult({
                    data: {
                        user: session.user
                    },
                    error: null
                });
            });
        } catch (error) {
            await $281a441cdcb2cf36$var$removeItemAsync(this.storage, `${this.storageKey}-code-verifier`);
            if ($281a441cdcb2cf36$var$isAuthError(error)) return this._returnResult({
                data: {
                    user: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
   * Sets the session data from the current session. If the current session is expired, setSession will take care of refreshing it to obtain a new session.
   * If the refresh token or access token in the current session is invalid, an error will be thrown.
   * @param currentSession The current session that minimally contains an access token and refresh token.
   *
   * @category Auth
   *
   * @remarks
   * - This method sets the session using an `access_token` and `refresh_token`.
   * - If successful, a `SIGNED_IN` event is emitted.
   *
   * @exampleDescription Set the session
   * Sets the session data from an access_token and refresh_token, then returns an auth response or error.
   *
   * @example Set the session
   * ```js
   *   const { data, error } = await supabase.auth.setSession({
   *     access_token,
   *     refresh_token
   *   })
   * ```
   *
   * @exampleResponse Set the session
   * ```json
   * {
   *   "data": {
   *     "user": {
   *       "id": "11111111-1111-1111-1111-111111111111",
   *       "aud": "authenticated",
   *       "role": "authenticated",
   *       "email": "example@email.com",
   *       "email_confirmed_at": "2024-01-01T00:00:00Z",
   *       "phone": "",
   *       "confirmed_at": "2024-01-01T00:00:00Z",
   *       "last_sign_in_at": "2024-01-01T00:00:00Z",
   *       "app_metadata": {
   *         "provider": "email",
   *         "providers": [
   *           "email"
   *         ]
   *       },
   *       "user_metadata": {
   *         "email": "example@email.com",
   *         "email_verified": false,
   *         "phone_verified": false,
   *         "sub": "11111111-1111-1111-1111-111111111111"
   *       },
   *       "identities": [
   *         {
   *           "identity_id": "22222222-2222-2222-2222-222222222222",
   *           "id": "11111111-1111-1111-1111-111111111111",
   *           "user_id": "11111111-1111-1111-1111-111111111111",
   *           "identity_data": {
   *             "email": "example@email.com",
   *             "email_verified": false,
   *             "phone_verified": false,
   *             "sub": "11111111-1111-1111-1111-111111111111"
   *           },
   *           "provider": "email",
   *           "last_sign_in_at": "2024-01-01T00:00:00Z",
   *           "created_at": "2024-01-01T00:00:00Z",
   *           "updated_at": "2024-01-01T00:00:00Z",
   *           "email": "example@email.com"
   *         }
   *       ],
   *       "created_at": "2024-01-01T00:00:00Z",
   *       "updated_at": "2024-01-01T00:00:00Z",
   *       "is_anonymous": false
   *     },
   *     "session": {
   *       "access_token": "<ACCESS_TOKEN>",
   *       "refresh_token": "<REFRESH_TOKEN>",
   *       "user": {
   *         "id": "11111111-1111-1111-1111-111111111111",
   *         "aud": "authenticated",
   *         "role": "authenticated",
   *         "email": "example@email.com",
   *         "email_confirmed_at": "2024-01-01T00:00:00Z",
   *         "phone": "",
   *         "confirmed_at": "2024-01-01T00:00:00Z",
   *         "last_sign_in_at": "11111111-1111-1111-1111-111111111111",
   *         "app_metadata": {
   *           "provider": "email",
   *           "providers": [
   *             "email"
   *           ]
   *         },
   *         "user_metadata": {
   *           "email": "example@email.com",
   *           "email_verified": false,
   *           "phone_verified": false,
   *           "sub": "11111111-1111-1111-1111-111111111111"
   *         },
   *         "identities": [
   *           {
   *             "identity_id": "2024-01-01T00:00:00Z",
   *             "id": "11111111-1111-1111-1111-111111111111",
   *             "user_id": "11111111-1111-1111-1111-111111111111",
   *             "identity_data": {
   *               "email": "example@email.com",
   *               "email_verified": false,
   *               "phone_verified": false,
   *               "sub": "11111111-1111-1111-1111-111111111111"
   *             },
   *             "provider": "email",
   *             "last_sign_in_at": "2024-01-01T00:00:00Z",
   *             "created_at": "2024-01-01T00:00:00Z",
   *             "updated_at": "2024-01-01T00:00:00Z",
   *             "email": "example@email.com"
   *           }
   *         ],
   *         "created_at": "2024-01-01T00:00:00Z",
   *         "updated_at": "2024-01-01T00:00:00Z",
   *         "is_anonymous": false
   *       },
   *       "token_type": "bearer",
   *       "expires_in": 3500,
   *       "expires_at": 1700000000
   *     }
   *   },
   *   "error": null
   * }
   * ```
   */ async setSession(currentSession) {
        await this.initializePromise;
        return await this._acquireLock(this.lockAcquireTimeout, async ()=>{
            return await this._setSession(currentSession);
        });
    }
    async _setSession(currentSession) {
        try {
            if (!currentSession.access_token || !currentSession.refresh_token) throw new $281a441cdcb2cf36$var$AuthSessionMissingError();
            const timeNow = Date.now() / 1e3;
            let expiresAt2 = timeNow;
            let hasExpired = true;
            let session = null;
            const { payload: payload } = $281a441cdcb2cf36$var$decodeJWT(currentSession.access_token);
            if (payload.exp) {
                expiresAt2 = payload.exp;
                hasExpired = expiresAt2 <= timeNow;
            }
            if (hasExpired) {
                const { data: refreshedSession, error: error } = await this._callRefreshToken(currentSession.refresh_token);
                if (error) return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
                if (!refreshedSession) return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: null
                };
                session = refreshedSession;
            } else {
                const { data: data2, error: error } = await this._getUser(currentSession.access_token);
                if (error) return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
                session = {
                    access_token: currentSession.access_token,
                    refresh_token: currentSession.refresh_token,
                    user: data2.user,
                    token_type: "bearer",
                    expires_in: expiresAt2 - timeNow,
                    expires_at: expiresAt2
                };
                await this._saveSession(session);
                await this._notifyAllSubscribers("SIGNED_IN", session);
            }
            return this._returnResult({
                data: {
                    user: session.user,
                    session: session
                },
                error: null
            });
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return this._returnResult({
                data: {
                    session: null,
                    user: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
   * Returns a new session, regardless of expiry status.
   * Takes in an optional current session. If not passed in, then refreshSession() will attempt to retrieve it from getSession().
   * If the current session's refresh token is invalid, an error will be thrown.
   * @param currentSession The current session. If passed in, it must contain a refresh token.
   *
   * @category Auth
   *
   * @remarks
   * - This method will refresh and return a new session whether the current one is expired or not.
   *
   * @example Refresh session using the current session
   * ```js
   * const { data, error } = await supabase.auth.refreshSession()
   * const { session, user } = data
   * ```
   *
   * @exampleResponse Refresh session using the current session
   * ```json
   * {
   *   "data": {
   *     "user": {
   *       "id": "11111111-1111-1111-1111-111111111111",
   *       "aud": "authenticated",
   *       "role": "authenticated",
   *       "email": "example@email.com",
   *       "email_confirmed_at": "2024-01-01T00:00:00Z",
   *       "phone": "",
   *       "confirmed_at": "2024-01-01T00:00:00Z",
   *       "last_sign_in_at": "2024-01-01T00:00:00Z",
   *       "app_metadata": {
   *         "provider": "email",
   *         "providers": [
   *           "email"
   *         ]
   *       },
   *       "user_metadata": {
   *         "email": "example@email.com",
   *         "email_verified": false,
   *         "phone_verified": false,
   *         "sub": "11111111-1111-1111-1111-111111111111"
   *       },
   *       "identities": [
   *         {
   *           "identity_id": "22222222-2222-2222-2222-222222222222",
   *           "id": "11111111-1111-1111-1111-111111111111",
   *           "user_id": "11111111-1111-1111-1111-111111111111",
   *           "identity_data": {
   *             "email": "example@email.com",
   *             "email_verified": false,
   *             "phone_verified": false,
   *             "sub": "11111111-1111-1111-1111-111111111111"
   *           },
   *           "provider": "email",
   *           "last_sign_in_at": "2024-01-01T00:00:00Z",
   *           "created_at": "2024-01-01T00:00:00Z",
   *           "updated_at": "2024-01-01T00:00:00Z",
   *           "email": "example@email.com"
   *         }
   *       ],
   *       "created_at": "2024-01-01T00:00:00Z",
   *       "updated_at": "2024-01-01T00:00:00Z",
   *       "is_anonymous": false
   *     },
   *     "session": {
   *       "access_token": "<ACCESS_TOKEN>",
   *       "token_type": "bearer",
   *       "expires_in": 3600,
   *       "expires_at": 1700000000,
   *       "refresh_token": "<REFRESH_TOKEN>",
   *       "user": {
   *         "id": "11111111-1111-1111-1111-111111111111",
   *         "aud": "authenticated",
   *         "role": "authenticated",
   *         "email": "example@email.com",
   *         "email_confirmed_at": "2024-01-01T00:00:00Z",
   *         "phone": "",
   *         "confirmed_at": "2024-01-01T00:00:00Z",
   *         "last_sign_in_at": "2024-01-01T00:00:00Z",
   *         "app_metadata": {
   *           "provider": "email",
   *           "providers": [
   *             "email"
   *           ]
   *         },
   *         "user_metadata": {
   *           "email": "example@email.com",
   *           "email_verified": false,
   *           "phone_verified": false,
   *           "sub": "11111111-1111-1111-1111-111111111111"
   *         },
   *         "identities": [
   *           {
   *             "identity_id": "22222222-2222-2222-2222-222222222222",
   *             "id": "11111111-1111-1111-1111-111111111111",
   *             "user_id": "11111111-1111-1111-1111-111111111111",
   *             "identity_data": {
   *               "email": "example@email.com",
   *               "email_verified": false,
   *               "phone_verified": false,
   *               "sub": "11111111-1111-1111-1111-111111111111"
   *             },
   *             "provider": "email",
   *             "last_sign_in_at": "2024-01-01T00:00:00Z",
   *             "created_at": "2024-01-01T00:00:00Z",
   *             "updated_at": "2024-01-01T00:00:00Z",
   *             "email": "example@email.com"
   *           }
   *         ],
   *         "created_at": "2024-01-01T00:00:00Z",
   *         "updated_at": "2024-01-01T00:00:00Z",
   *         "is_anonymous": false
   *       }
   *     }
   *   },
   *   "error": null
   * }
   * ```
   *
   * @example Refresh session using a refresh token
   * ```js
   * const { data, error } = await supabase.auth.refreshSession({ refresh_token })
   * const { session, user } = data
   * ```
   */ async refreshSession(currentSession) {
        await this.initializePromise;
        return await this._acquireLock(this.lockAcquireTimeout, async ()=>{
            return await this._refreshSession(currentSession);
        });
    }
    async _refreshSession(currentSession) {
        try {
            return await this._useSession(async (result)=>{
                var _a2;
                if (!currentSession) {
                    const { data: data2, error: error2 } = result;
                    if (error2) throw error2;
                    currentSession = (_a2 = data2.session) !== null && _a2 !== void 0 ? _a2 : void 0;
                }
                if (!(currentSession === null || currentSession === void 0 ? void 0 : currentSession.refresh_token)) throw new $281a441cdcb2cf36$var$AuthSessionMissingError();
                const { data: session, error: error } = await this._callRefreshToken(currentSession.refresh_token);
                if (error) return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
                if (!session) return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: null
                });
                return this._returnResult({
                    data: {
                        user: session.user,
                        session: session
                    },
                    error: null
                });
            });
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
   * Gets the session data from a URL string
   */ async _getSessionFromURL(params2, callbackUrlType) {
        var _a2;
        try {
            if (!$281a441cdcb2cf36$var$isBrowser3()) throw new $281a441cdcb2cf36$var$AuthImplicitGrantRedirectError("No browser detected.");
            if (params2.error || params2.error_description || params2.error_code) throw new $281a441cdcb2cf36$var$AuthImplicitGrantRedirectError(params2.error_description || "Error in URL with unspecified error_description", {
                error: params2.error || "unspecified_error",
                code: params2.error_code || "unspecified_code"
            });
            switch(callbackUrlType){
                case "implicit":
                    if (this.flowType === "pkce") throw new $281a441cdcb2cf36$var$AuthPKCEGrantCodeExchangeError("Not a valid PKCE flow url.");
                    break;
                case "pkce":
                    if (this.flowType === "implicit") throw new $281a441cdcb2cf36$var$AuthImplicitGrantRedirectError("Not a valid implicit grant flow url.");
                    break;
                default:
            }
            if (callbackUrlType === "pkce") {
                this._debug("#_initialize()", "begin", "is PKCE flow", true);
                if (!params2.code) throw new $281a441cdcb2cf36$var$AuthPKCEGrantCodeExchangeError("No code detected.");
                const { data: data3, error: error2 } = await this._exchangeCodeForSession(params2.code);
                if (error2) throw error2;
                const url2 = new URL(window.location.href);
                url2.searchParams.delete("code");
                window.history.replaceState(window.history.state, "", url2.toString());
                return {
                    data: {
                        session: data3.session,
                        redirectType: (_a2 = data3.redirectType) !== null && _a2 !== void 0 ? _a2 : null
                    },
                    error: null
                };
            }
            const { provider_token: provider_token, provider_refresh_token: provider_refresh_token, access_token: access_token, refresh_token: refresh_token, expires_in: expires_in, expires_at: expires_at, token_type: token_type } = params2;
            if (!access_token || !expires_in || !refresh_token || !token_type) throw new $281a441cdcb2cf36$var$AuthImplicitGrantRedirectError("No session defined in URL");
            const timeNow = Math.round(Date.now() / 1e3);
            const expiresIn = parseInt(expires_in);
            let expiresAt2 = timeNow + expiresIn;
            if (expires_at) expiresAt2 = parseInt(expires_at);
            const actuallyExpiresIn = expiresAt2 - timeNow;
            if (actuallyExpiresIn * 1e3 <= $281a441cdcb2cf36$var$AUTO_REFRESH_TICK_DURATION_MS) console.warn(`@supabase/gotrue-js: Session as retrieved from URL expires in ${actuallyExpiresIn}s, should have been closer to ${expiresIn}s`);
            const issuedAt = expiresAt2 - expiresIn;
            if (timeNow - issuedAt >= 120) console.warn("@supabase/gotrue-js: Session as retrieved from URL was issued over 120s ago, URL could be stale", issuedAt, expiresAt2, timeNow);
            else if (timeNow - issuedAt < 0) console.warn("@supabase/gotrue-js: Session as retrieved from URL was issued in the future? Check the device clock for skew", issuedAt, expiresAt2, timeNow);
            const { data: data2, error: error } = await this._getUser(access_token);
            if (error) throw error;
            const session = {
                provider_token: provider_token,
                provider_refresh_token: provider_refresh_token,
                access_token: access_token,
                expires_in: expiresIn,
                expires_at: expiresAt2,
                refresh_token: refresh_token,
                token_type: token_type,
                user: data2.user
            };
            window.location.hash = "";
            this._debug("#_getSessionFromURL()", "clearing window.location.hash");
            return this._returnResult({
                data: {
                    session: session,
                    redirectType: params2.type
                },
                error: null
            });
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return this._returnResult({
                data: {
                    session: null,
                    redirectType: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
   * Checks if the current URL contains parameters given by an implicit oauth grant flow (https://www.rfc-editor.org/rfc/rfc6749.html#section-4.2)
   *
   * If `detectSessionInUrl` is a function, it will be called with the URL and params to determine
   * if the URL should be processed as a Supabase auth callback. This allows users to exclude
   * URLs from other OAuth providers (e.g., Facebook Login) that also return access_token in the fragment.
   */ _isImplicitGrantCallback(params2) {
        if (typeof this.detectSessionInUrl === "function") return this.detectSessionInUrl(new URL(window.location.href), params2);
        return Boolean(params2.access_token || params2.error_description);
    }
    /**
   * Checks if the current URL and backing storage contain parameters given by a PKCE flow
   */ async _isPKCECallback(params2) {
        const currentStorageContent = await $281a441cdcb2cf36$var$getItemAsync(this.storage, `${this.storageKey}-code-verifier`);
        return !!(params2.code && currentStorageContent);
    }
    /**
   * Inside a browser context, `signOut()` will remove the logged in user from the browser session and log them out - removing all items from localstorage and then trigger a `"SIGNED_OUT"` event.
   *
   * For server-side management, you can revoke all refresh tokens for a user by passing a user's JWT through to `auth.api.signOut(JWT: string)`.
   * There is no way to revoke a user's access token jwt until it expires. It is recommended to set a shorter expiry on the jwt for this reason.
   *
   * If using `others` scope, no `SIGNED_OUT` event is fired!
   *
   * **Warning:** the default `scope` is `'global'`. This signs the user out of
   * **every device they are currently signed in on**, not just the current
   * tab/session. If you only want to sign the user out of the current session
   * (the behavior most other auth libraries default to), pass
   * `{ scope: 'local' }` explicitly.
   *
   * @category Auth
   *
   * @remarks
   * - In order to use the `signOut()` method, the user needs to be signed in first.
   * - By default, `signOut()` uses the **global** scope, which signs out the user
   *   on every device they are signed in on (not just the current one). Pass
   *   `{ scope: 'local' }` to only sign out the current session. This is
   *   usually what apps want on a "Sign out" button, especially when users
   *   sign in from multiple devices and do not expect signing out of one to
   *   terminate the others.
   * - Since Supabase Auth uses JWTs for authentication, the access token JWT will be valid until it's expired. When the user signs out, Supabase revokes the refresh token and deletes the JWT from the client-side. This does not revoke the JWT and it will still be valid until it expires.
   *
   * @example Sign out of every device (global – default)
   * ```js
   * const { error } = await supabase.auth.signOut()
   * ```
   *
   * @example Sign out only the current session (recommended for most apps)
   * ```js
   * const { error } = await supabase.auth.signOut({ scope: 'local' })
   * ```
   *
   * @example Sign out of all other sessions, keep the current one
   * ```js
   * const { error } = await supabase.auth.signOut({ scope: 'others' })
   * ```
   */ async signOut(options = {
        scope: "global"
    }) {
        await this.initializePromise;
        return await this._acquireLock(this.lockAcquireTimeout, async ()=>{
            return await this._signOut(options);
        });
    }
    async _signOut({ scope: scope } = {
        scope: "global"
    }) {
        return await this._useSession(async (result)=>{
            var _a2;
            const { data: data2, error: sessionError } = result;
            if (sessionError && !$281a441cdcb2cf36$var$isAuthSessionMissingError(sessionError)) return this._returnResult({
                error: sessionError
            });
            const accessToken = (_a2 = data2.session) === null || _a2 === void 0 ? void 0 : _a2.access_token;
            if (accessToken) {
                const { error: error } = await this.admin.signOut(accessToken, scope);
                if (error) {
                    if (!($281a441cdcb2cf36$var$isAuthApiError(error) && (error.status === 404 || error.status === 401 || error.status === 403) || $281a441cdcb2cf36$var$isAuthSessionMissingError(error))) return this._returnResult({
                        error: error
                    });
                }
            }
            if (scope !== "others") {
                await this._removeSession();
                await $281a441cdcb2cf36$var$removeItemAsync(this.storage, `${this.storageKey}-code-verifier`);
            }
            return this._returnResult({
                error: null
            });
        });
    }
    /**  *
   * @category Auth
   *
   * @remarks
   * - Subscribes to important events occurring on the user's session.
   * - Use on the frontend/client. It is less useful on the server.
   * - Events are emitted across tabs to keep your application's UI up-to-date. Some events can fire very frequently, based on the number of tabs open. Use a quick and efficient callback function, and defer or debounce as many operations as you can to be performed outside of the callback.
   * - **Important:** A callback can be an `async` function and it runs synchronously during the processing of the changes causing the event. You can easily create a dead-lock by using `await` on a call to another method of the Supabase library.
   *   - Avoid using `async` functions as callbacks.
   *   - Limit the number of `await` calls in `async` callbacks.
   *   - Do not use other Supabase functions in the callback function. If you must, dispatch the functions once the callback has finished executing. Use this as a quick way to achieve this:
   *     ```js
   *     supabase.auth.onAuthStateChange((event, session) => {
   *       setTimeout(async () => {
   *         // await on other Supabase function here
   *         // this runs right after the callback has finished
   *       }, 0)
   *     })
   *     ```
   * - Emitted events:
   *   - `INITIAL_SESSION`
   *     - Emitted right after the Supabase client is constructed and the initial session from storage is loaded.
   *   - `SIGNED_IN`
   *     - Emitted each time a user session is confirmed or re-established, including on user sign in and when refocusing a tab.
   *     - Avoid making assumptions as to when this event is fired, this may occur even when the user is already signed in. Instead, check the user object attached to the event to see if a new user has signed in and update your application's UI.
   *     - This event can fire very frequently depending on the number of tabs open in your application.
   *   - `SIGNED_OUT`
   *     - Emitted when the user signs out. This can be after:
   *       - A call to `supabase.auth.signOut()`.
   *       - After the user's session has expired for any reason:
   *         - User has signed out on another device.
   *         - The session has reached its timebox limit or inactivity timeout.
   *         - User has signed in on another device with single session per user enabled.
   *         - Check the [User Sessions](/docs/guides/auth/sessions) docs for more information.
   *     - Use this to clean up any local storage your application has associated with the user.
   *   - `TOKEN_REFRESHED`
   *     - Emitted each time a new access and refresh token are fetched for the signed in user.
   *     - It's best practice and highly recommended to extract the access token (JWT) and store it in memory for further use in your application.
   *       - Avoid frequent calls to `supabase.auth.getSession()` for the same purpose.
   *     - There is a background process that keeps track of when the session should be refreshed so you will always receive valid tokens by listening to this event.
   *     - The frequency of this event is related to the JWT expiry limit configured on your project.
   *   - `USER_UPDATED`
   *     - Emitted each time the `supabase.auth.updateUser()` method finishes successfully. Listen to it to update your application's UI based on new profile information.
   *   - `PASSWORD_RECOVERY`
   *     - Emitted instead of the `SIGNED_IN` event when the user lands on a page that includes a password recovery link in the URL.
   *     - Use it to show a UI to the user where they can [reset their password](/docs/guides/auth/passwords#resetting-a-users-password-forgot-password).
   *
   * @example Listen to auth changes
   * ```js
   * const { data } = supabase.auth.onAuthStateChange((event, session) => {
   *   console.log(event, session)
   *
   *   if (event === 'INITIAL_SESSION') {
   *     // handle initial session
   *   } else if (event === 'SIGNED_IN') {
   *     // handle sign in event
   *   } else if (event === 'SIGNED_OUT') {
   *     // handle sign out event
   *   } else if (event === 'PASSWORD_RECOVERY') {
   *     // handle password recovery event
   *   } else if (event === 'TOKEN_REFRESHED') {
   *     // handle token refreshed event
   *   } else if (event === 'USER_UPDATED') {
   *     // handle user updated event
   *   }
   * })
   *
   * // call unsubscribe to remove the callback
   * data.subscription.unsubscribe()
   * ```
   *
   * @exampleDescription Listen to sign out
   * Make sure you clear out any local data, such as local and session storage, after the client library has detected the user's sign out.
   *
   * @example Listen to sign out
   * ```js
   * supabase.auth.onAuthStateChange((event, session) => {
   *   if (event === 'SIGNED_OUT') {
   *     console.log('SIGNED_OUT', session)
   *
   *     // clear local and session storage
   *     [
   *       window.localStorage,
   *       window.sessionStorage,
   *     ].forEach((storage) => {
   *       Object.entries(storage)
   *         .forEach(([key]) => {
   *           storage.removeItem(key)
   *         })
   *     })
   *   }
   * })
   * ```
   *
   * @exampleDescription Store OAuth provider tokens on sign in
   * When using [OAuth (Social Login)](/docs/guides/auth/social-login) you sometimes wish to get access to the provider's access token and refresh token, in order to call provider APIs in the name of the user.
   *
   * For example, if you are using [Sign in with Google](/docs/guides/auth/social-login/auth-google) you may want to use the provider token to call Google APIs on behalf of the user. Supabase Auth does not keep track of the provider access and refresh token, but does return them for you once, immediately after sign in. You can use the `onAuthStateChange` method to listen for the presence of the provider tokens and store them in local storage. You can further send them to your server's APIs for use on the backend.
   *
   * Finally, make sure you remove them from local storage on the `SIGNED_OUT` event. If the OAuth provider supports token revocation, make sure you call those APIs either from the frontend or schedule them to be called on the backend.
   *
   * @example Store OAuth provider tokens on sign in
   * ```js
   * // Register this immediately after calling createClient!
   * // Because signInWithOAuth causes a redirect, you need to fetch the
   * // provider tokens from the callback.
   * supabase.auth.onAuthStateChange((event, session) => {
   *   if (session && session.provider_token) {
   *     window.localStorage.setItem('oauth_provider_token', session.provider_token)
   *   }
   *
   *   if (session && session.provider_refresh_token) {
   *     window.localStorage.setItem('oauth_provider_refresh_token', session.provider_refresh_token)
   *   }
   *
   *   if (event === 'SIGNED_OUT') {
   *     window.localStorage.removeItem('oauth_provider_token')
   *     window.localStorage.removeItem('oauth_provider_refresh_token')
   *   }
   * })
   * ```
   *
   * @exampleDescription Use React Context for the User's session
   * Instead of relying on `supabase.auth.getSession()` within your React components, you can use a [React Context](https://react.dev/reference/react/createContext) to store the latest session information from the `onAuthStateChange` callback and access it that way.
   *
   * @example Use React Context for the User's session
   * ```js
   * const SessionContext = React.createContext(null)
   *
   * function main() {
   *   const [session, setSession] = React.useState(null)
   *
   *   React.useEffect(() => {
   *     const {data: { subscription }} = supabase.auth.onAuthStateChange(
   *       (event, session) => {
   *         if (event === 'SIGNED_OUT') {
   *           setSession(null)
   *         } else if (session) {
   *           setSession(session)
   *         }
   *       })
   *
   *     return () => {
   *       subscription.unsubscribe()
   *     }
   *   }, [])
   *
   *   return (
   *     <SessionContext.Provider value={session}>
   *       <App />
   *     </SessionContext.Provider>
   *   )
   * }
   * ```
   *
   * @example Listen to password recovery events
   * ```js
   * supabase.auth.onAuthStateChange((event, session) => {
   *   if (event === 'PASSWORD_RECOVERY') {
   *     console.log('PASSWORD_RECOVERY', session)
   *     // show screen to update user's password
   *     showPasswordResetScreen(true)
   *   }
   * })
   * ```
   *
   * @example Listen to sign in
   * ```js
   * supabase.auth.onAuthStateChange((event, session) => {
   *   if (event === 'SIGNED_IN') console.log('SIGNED_IN', session)
   * })
   * ```
   *
   * @example Listen to token refresh
   * ```js
   * supabase.auth.onAuthStateChange((event, session) => {
   *   if (event === 'TOKEN_REFRESHED') console.log('TOKEN_REFRESHED', session)
   * })
   * ```
   *
   * @example Listen to user updates
   * ```js
   * supabase.auth.onAuthStateChange((event, session) => {
   *   if (event === 'USER_UPDATED') console.log('USER_UPDATED', session)
   * })
   * ```
   */ onAuthStateChange(callback) {
        const id2 = $281a441cdcb2cf36$var$generateCallbackId();
        const subscription = {
            id: id2,
            callback: callback,
            unsubscribe: ()=>{
                this._debug("#unsubscribe()", "state change callback with id removed", id2);
                this.stateChangeEmitters.delete(id2);
            }
        };
        this._debug("#onAuthStateChange()", "registered callback with id", id2);
        this.stateChangeEmitters.set(id2, subscription);
        (async ()=>{
            await this.initializePromise;
            await this._acquireLock(this.lockAcquireTimeout, async ()=>{
                this._emitInitialSession(id2);
            });
        })();
        return {
            data: {
                subscription: subscription
            }
        };
    }
    async _emitInitialSession(id2) {
        return await this._useSession(async (result)=>{
            var _a2, _b;
            try {
                const { data: { session: session }, error: error } = result;
                if (error) throw error;
                await ((_a2 = this.stateChangeEmitters.get(id2)) === null || _a2 === void 0 ? void 0 : _a2.callback("INITIAL_SESSION", session));
                this._debug("INITIAL_SESSION", "callback id", id2, "session", session);
            } catch (err) {
                await ((_b = this.stateChangeEmitters.get(id2)) === null || _b === void 0 ? void 0 : _b.callback("INITIAL_SESSION", null));
                this._debug("INITIAL_SESSION", "callback id", id2, "error", err);
                if ($281a441cdcb2cf36$var$isAuthSessionMissingError(err)) console.warn(err);
                else console.error(err);
            }
        });
    }
    /**
   * Sends a password reset request to an email address. This method supports the PKCE flow.
   *
   * @param email The email address of the user.
   * @param options.redirectTo The URL to send the user to after they click the password reset link.
   * @param options.captchaToken Verification token received when the user completes the captcha on the site.
   *
   * @category Auth
   *
   * @remarks
   * - The password reset flow consist of 2 broad steps: (i) Allow the user to login via the password reset link; (ii) Update the user's password.
   * - The `resetPasswordForEmail()` only sends a password reset link to the user's email.
   * To update the user's password, see [`updateUser()`](/docs/reference/javascript/auth-updateuser).
   * - A `PASSWORD_RECOVERY` event will be emitted when the password recovery link is clicked.
   * You can use [`onAuthStateChange()`](/docs/reference/javascript/auth-onauthstatechange) to listen and invoke a callback function on these events.
   * - When the user clicks the reset link in the email they are redirected back to your application.
   * You can configure the URL that the user is redirected to with the `redirectTo` parameter.
   * See [redirect URLs and wildcards](/docs/guides/auth/redirect-urls#use-wildcards-in-redirect-urls) to add additional redirect URLs to your project.
   * - After the user has been redirected successfully, prompt them for a new password and call `updateUser()`:
   * ```js
   * const { data, error } = await supabase.auth.updateUser({
   *   password: new_password
   * })
   * ```
   *
   * @example Reset password
   * ```js
   * const { data, error } = await supabase.auth.resetPasswordForEmail(email, {
   *   redirectTo: 'https://example.com/update-password',
   * })
   * ```
   *
   * @exampleResponse Reset password
   * ```json
   * {
   *   data: {}
   *   error: null
   * }
   * ```
   *
   * @example Reset password (React)
   * ```js
   * /**
   *  * Step 1: Send the user an email to get a password reset token.
   *  * This email contains a link which sends the user back to your application.
   *  *\/
   * const { data, error } = await supabase.auth
   *   .resetPasswordForEmail('user@email.com')
   *
   * /**
   *  * Step 2: Once the user is redirected back to your application,
   *  * ask the user to reset their password.
   *  *\/
   *  useEffect(() => {
   *    supabase.auth.onAuthStateChange(async (event, session) => {
   *      if (event == "PASSWORD_RECOVERY") {
   *        const newPassword = prompt("What would you like your new password to be?");
   *        const { data, error } = await supabase.auth
   *          .updateUser({ password: newPassword })
   *
   *        if (data) alert("Password updated successfully!")
   *        if (error) alert("There was an error updating your password.")
   *      }
   *    })
   *  }, [])
   * ```
   */ async resetPasswordForEmail(email, options = {}) {
        let codeChallenge = null;
        let codeChallengeMethod = null;
        if (this.flowType === "pkce") [codeChallenge, codeChallengeMethod] = await $281a441cdcb2cf36$var$getCodeChallengeAndMethod(this.storage, this.storageKey, true);
        try {
            return await $281a441cdcb2cf36$var$_request(this.fetch, "POST", `${this.url}/recover`, {
                body: {
                    email: email,
                    code_challenge: codeChallenge,
                    code_challenge_method: codeChallengeMethod,
                    gotrue_meta_security: {
                        captcha_token: options.captchaToken
                    }
                },
                headers: this.headers,
                redirectTo: options.redirectTo
            });
        } catch (error) {
            await $281a441cdcb2cf36$var$removeItemAsync(this.storage, `${this.storageKey}-code-verifier`);
            if ($281a441cdcb2cf36$var$isAuthError(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
   * Gets all the identities linked to a user.
   *
   * @category Auth
   *
   * @remarks
   * - The user needs to be signed in to call `getUserIdentities()`.
   *
   * @example Returns a list of identities linked to the user
   * ```js
   * const { data, error } = await supabase.auth.getUserIdentities()
   * ```
   *
   * @exampleResponse Returns a list of identities linked to the user
   * ```json
   * {
   *   "data": {
   *     "identities": [
   *       {
   *         "identity_id": "22222222-2222-2222-2222-222222222222",
   *         "id": "2024-01-01T00:00:00Z",
   *         "user_id": "2024-01-01T00:00:00Z",
   *         "identity_data": {
   *           "email": "example@email.com",
   *           "email_verified": false,
   *           "phone_verified": false,
   *           "sub": "11111111-1111-1111-1111-111111111111"
   *         },
   *         "provider": "email",
   *         "last_sign_in_at": "2024-01-01T00:00:00Z",
   *         "created_at": "2024-01-01T00:00:00Z",
   *         "updated_at": "2024-01-01T00:00:00Z",
   *         "email": "example@email.com"
   *       }
   *     ]
   *   },
   *   "error": null
   * }
   * ```
   */ async getUserIdentities() {
        var _a2;
        try {
            const { data: data2, error: error } = await this.getUser();
            if (error) throw error;
            return this._returnResult({
                data: {
                    identities: (_a2 = data2.user.identities) !== null && _a2 !== void 0 ? _a2 : []
                },
                error: null
            });
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**  *
   * @category Auth
   *
   * @remarks
   * - The **Enable Manual Linking** option must be enabled from your [project's authentication settings](/dashboard/project/_/auth/providers).
   * - The user needs to be signed in to call `linkIdentity()`.
   * - If the candidate identity is already linked to the existing user or another user, `linkIdentity()` will fail.
   * - If `linkIdentity` is run in the browser, the user is automatically redirected to the returned URL. On the server, you should handle the redirect.
   *
   * @example Link an identity to a user
   * ```js
   * const { data, error } = await supabase.auth.linkIdentity({
   *   provider: 'github'
   * })
   * ```
   *
   * @exampleResponse Link an identity to a user
   * ```json
   * {
   *   data: {
   *     provider: 'github',
   *     url: <PROVIDER_URL_TO_REDIRECT_TO>
   *   },
   *   error: null
   * }
   * ```
   */ async linkIdentity(credentials) {
        if ("token" in credentials) return this.linkIdentityIdToken(credentials);
        return this.linkIdentityOAuth(credentials);
    }
    async linkIdentityOAuth(credentials) {
        var _a2;
        try {
            const { data: data2, error: error } = await this._useSession(async (result)=>{
                var _a3, _b, _c, _d, _e;
                const { data: data3, error: error2 } = result;
                if (error2) throw error2;
                const url2 = await this._getUrlForProvider(`${this.url}/user/identities/authorize`, credentials.provider, {
                    redirectTo: (_a3 = credentials.options) === null || _a3 === void 0 ? void 0 : _a3.redirectTo,
                    scopes: (_b = credentials.options) === null || _b === void 0 ? void 0 : _b.scopes,
                    queryParams: (_c = credentials.options) === null || _c === void 0 ? void 0 : _c.queryParams,
                    skipBrowserRedirect: true
                });
                return await $281a441cdcb2cf36$var$_request(this.fetch, "GET", url2, {
                    headers: this.headers,
                    jwt: (_e = (_d = data3.session) === null || _d === void 0 ? void 0 : _d.access_token) !== null && _e !== void 0 ? _e : void 0
                });
            });
            if (error) throw error;
            if ($281a441cdcb2cf36$var$isBrowser3() && !((_a2 = credentials.options) === null || _a2 === void 0 ? void 0 : _a2.skipBrowserRedirect)) window.location.assign(data2 === null || data2 === void 0 ? void 0 : data2.url);
            return this._returnResult({
                data: {
                    provider: credentials.provider,
                    url: data2 === null || data2 === void 0 ? void 0 : data2.url
                },
                error: null
            });
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return this._returnResult({
                data: {
                    provider: credentials.provider,
                    url: null
                },
                error: error
            });
            throw error;
        }
    }
    async linkIdentityIdToken(credentials) {
        return await this._useSession(async (result)=>{
            var _a2;
            try {
                const { error: sessionError, data: { session: session } } = result;
                if (sessionError) throw sessionError;
                const { options: options, provider: provider, token: token, access_token: access_token, nonce: nonce } = credentials;
                const res = await $281a441cdcb2cf36$var$_request(this.fetch, "POST", `${this.url}/token?grant_type=id_token`, {
                    headers: this.headers,
                    jwt: (_a2 = session === null || session === void 0 ? void 0 : session.access_token) !== null && _a2 !== void 0 ? _a2 : void 0,
                    body: {
                        provider: provider,
                        id_token: token,
                        access_token: access_token,
                        nonce: nonce,
                        link_identity: true,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: $281a441cdcb2cf36$var$_sessionResponse
                });
                const { data: data2, error: error } = res;
                if (error) return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
                else if (!data2 || !data2.session || !data2.user) return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: new $281a441cdcb2cf36$var$AuthInvalidTokenResponseError()
                });
                if (data2.session) {
                    await this._saveSession(data2.session);
                    await this._notifyAllSubscribers("USER_UPDATED", data2.session);
                }
                return this._returnResult({
                    data: data2,
                    error: error
                });
            } catch (error) {
                await $281a441cdcb2cf36$var$removeItemAsync(this.storage, `${this.storageKey}-code-verifier`);
                if ($281a441cdcb2cf36$var$isAuthError(error)) return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
                throw error;
            }
        });
    }
    /**
   * Unlinks an identity from a user by deleting it. The user will no longer be able to sign in with that identity once it's unlinked.
   *
   * @category Auth
   *
   * @remarks
   * - The **Enable Manual Linking** option must be enabled from your [project's authentication settings](/dashboard/project/_/auth/providers).
   * - The user needs to be signed in to call `unlinkIdentity()`.
   * - The user must have at least 2 identities in order to unlink an identity.
   * - The identity to be unlinked must belong to the user.
   *
   * @example Unlink an identity
   * ```js
   * // retrieve all identities linked to a user
   * const identities = await supabase.auth.getUserIdentities()
   *
   * // find the google identity
   * const googleIdentity = identities.find(
   *   identity => identity.provider === 'google'
   * )
   *
   * // unlink the google identity
   * const { error } = await supabase.auth.unlinkIdentity(googleIdentity)
   * ```
   */ async unlinkIdentity(identity) {
        try {
            return await this._useSession(async (result)=>{
                var _a2, _b;
                const { data: data2, error: error } = result;
                if (error) throw error;
                return await $281a441cdcb2cf36$var$_request(this.fetch, "DELETE", `${this.url}/user/identities/${identity.identity_id}`, {
                    headers: this.headers,
                    jwt: (_b = (_a2 = data2.session) === null || _a2 === void 0 ? void 0 : _a2.access_token) !== null && _b !== void 0 ? _b : void 0
                });
            });
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
   * Generates a new JWT.
   * @param refreshToken A valid refresh token that was returned on login.
   */ async _refreshAccessToken(refreshToken) {
        const debugName = `#_refreshAccessToken(${refreshToken.substring(0, 5)}...)`;
        this._debug(debugName, "begin");
        try {
            const startedAt = Date.now();
            return await $281a441cdcb2cf36$var$retryable(async (attempt)=>{
                if (attempt > 0) await $281a441cdcb2cf36$var$sleep2(200 * Math.pow(2, attempt - 1));
                this._debug(debugName, "refreshing attempt", attempt);
                return await $281a441cdcb2cf36$var$_request(this.fetch, "POST", `${this.url}/token?grant_type=refresh_token`, {
                    body: {
                        refresh_token: refreshToken
                    },
                    headers: this.headers,
                    xform: $281a441cdcb2cf36$var$_sessionResponse
                });
            }, (attempt, error)=>{
                const nextBackOffInterval = 200 * Math.pow(2, attempt);
                return error && $281a441cdcb2cf36$var$isAuthRetryableFetchError(error) && // retryable only if the request can be sent before the backoff overflows the tick duration
                Date.now() + nextBackOffInterval - startedAt < $281a441cdcb2cf36$var$AUTO_REFRESH_TICK_DURATION_MS;
            });
        } catch (error) {
            this._debug(debugName, "error", error);
            if ($281a441cdcb2cf36$var$isAuthError(error)) return this._returnResult({
                data: {
                    session: null,
                    user: null
                },
                error: error
            });
            throw error;
        } finally{
            this._debug(debugName, "end");
        }
    }
    _isValidSession(maybeSession) {
        const isValidSession = typeof maybeSession === "object" && maybeSession !== null && "access_token" in maybeSession && "refresh_token" in maybeSession && "expires_at" in maybeSession;
        return isValidSession;
    }
    async _handleProviderSignIn(provider, options) {
        const url2 = await this._getUrlForProvider(`${this.url}/authorize`, provider, {
            redirectTo: options.redirectTo,
            scopes: options.scopes,
            queryParams: options.queryParams
        });
        this._debug("#_handleProviderSignIn()", "provider", provider, "options", options, "url", url2);
        if ($281a441cdcb2cf36$var$isBrowser3() && !options.skipBrowserRedirect) window.location.assign(url2);
        return {
            data: {
                provider: provider,
                url: url2
            },
            error: null
        };
    }
    /**
   * Recovers the session from LocalStorage and refreshes the token
   * Note: this method is async to accommodate for AsyncStorage e.g. in React native.
   */ async _recoverAndRefresh() {
        var _a2, _b;
        const debugName = "#_recoverAndRefresh()";
        this._debug(debugName, "begin");
        try {
            const currentSession = await $281a441cdcb2cf36$var$getItemAsync(this.storage, this.storageKey);
            if (currentSession && this.userStorage) {
                let maybeUser = await $281a441cdcb2cf36$var$getItemAsync(this.userStorage, this.storageKey + "-user");
                if (!this.storage.isServer && Object.is(this.storage, this.userStorage) && !maybeUser) {
                    maybeUser = {
                        user: currentSession.user
                    };
                    await $281a441cdcb2cf36$var$setItemAsync(this.userStorage, this.storageKey + "-user", maybeUser);
                }
                currentSession.user = (_a2 = maybeUser === null || maybeUser === void 0 ? void 0 : maybeUser.user) !== null && _a2 !== void 0 ? _a2 : $281a441cdcb2cf36$var$userNotAvailableProxy();
            } else if (currentSession && !currentSession.user) {
                if (!currentSession.user) {
                    const separateUser = await $281a441cdcb2cf36$var$getItemAsync(this.storage, this.storageKey + "-user");
                    if (separateUser && (separateUser === null || separateUser === void 0 ? void 0 : separateUser.user)) {
                        currentSession.user = separateUser.user;
                        await $281a441cdcb2cf36$var$removeItemAsync(this.storage, this.storageKey + "-user");
                        await $281a441cdcb2cf36$var$setItemAsync(this.storage, this.storageKey, currentSession);
                    } else currentSession.user = $281a441cdcb2cf36$var$userNotAvailableProxy();
                }
            }
            this._debug(debugName, "session from storage", currentSession);
            if (!this._isValidSession(currentSession)) {
                this._debug(debugName, "session is not valid");
                if (currentSession !== null) await this._removeSession();
                return;
            }
            const expiresWithMargin = ((_b = currentSession.expires_at) !== null && _b !== void 0 ? _b : Infinity) * 1e3 - Date.now() < $281a441cdcb2cf36$var$EXPIRY_MARGIN_MS;
            this._debug(debugName, `session has${expiresWithMargin ? "" : " not"} expired with margin of ${$281a441cdcb2cf36$var$EXPIRY_MARGIN_MS}s`);
            if (expiresWithMargin) {
                if (this.autoRefreshToken && currentSession.refresh_token) {
                    const { error: error } = await this._callRefreshToken(currentSession.refresh_token);
                    if (error) {
                        console.error(error);
                        if (!$281a441cdcb2cf36$var$isAuthRetryableFetchError(error)) {
                            this._debug(debugName, "refresh failed with a non-retryable error, removing the session", error);
                            await this._removeSession();
                        }
                    }
                }
            } else if (currentSession.user && currentSession.user.__isUserNotAvailableProxy === true) try {
                const { data: data2, error: userError } = await this._getUser(currentSession.access_token);
                if (!userError && (data2 === null || data2 === void 0 ? void 0 : data2.user)) {
                    currentSession.user = data2.user;
                    await this._saveSession(currentSession);
                    await this._notifyAllSubscribers("SIGNED_IN", currentSession);
                } else this._debug(debugName, "could not get user data, skipping SIGNED_IN notification");
            } catch (getUserError) {
                console.error("Error getting user data:", getUserError);
                this._debug(debugName, "error getting user data, skipping SIGNED_IN notification", getUserError);
            }
            else await this._notifyAllSubscribers("SIGNED_IN", currentSession);
        } catch (err) {
            this._debug(debugName, "error", err);
            console.error(err);
            return;
        } finally{
            this._debug(debugName, "end");
        }
    }
    async _callRefreshToken(refreshToken) {
        var _a2, _b;
        if (!refreshToken) throw new $281a441cdcb2cf36$var$AuthSessionMissingError();
        if (this.refreshingDeferred) return this.refreshingDeferred.promise;
        const debugName = `#_callRefreshToken(${refreshToken.substring(0, 5)}...)`;
        this._debug(debugName, "begin");
        try {
            this.refreshingDeferred = new $281a441cdcb2cf36$var$Deferred2();
            const { data: data2, error: error } = await this._refreshAccessToken(refreshToken);
            if (error) throw error;
            if (!data2.session) throw new $281a441cdcb2cf36$var$AuthSessionMissingError();
            await this._saveSession(data2.session);
            await this._notifyAllSubscribers("TOKEN_REFRESHED", data2.session);
            const result = {
                data: data2.session,
                error: null
            };
            this.refreshingDeferred.resolve(result);
            return result;
        } catch (error) {
            this._debug(debugName, "error", error);
            if ($281a441cdcb2cf36$var$isAuthError(error)) {
                const result = {
                    data: null,
                    error: error
                };
                if (!$281a441cdcb2cf36$var$isAuthRetryableFetchError(error)) await this._removeSession();
                (_a2 = this.refreshingDeferred) === null || _a2 === void 0 || _a2.resolve(result);
                return result;
            }
            (_b = this.refreshingDeferred) === null || _b === void 0 || _b.reject(error);
            throw error;
        } finally{
            this.refreshingDeferred = null;
            this._debug(debugName, "end");
        }
    }
    async _notifyAllSubscribers(event, session, broadcast = true) {
        const debugName = `#_notifyAllSubscribers(${event})`;
        this._debug(debugName, "begin", session, `broadcast = ${broadcast}`);
        try {
            if (this.broadcastChannel && broadcast) this.broadcastChannel.postMessage({
                event: event,
                session: session
            });
            const errors = [];
            const promises = Array.from(this.stateChangeEmitters.values()).map(async (x3)=>{
                try {
                    await x3.callback(event, session);
                } catch (e4) {
                    errors.push(e4);
                }
            });
            await Promise.all(promises);
            if (errors.length > 0) {
                for(let i3 = 0; i3 < errors.length; i3 += 1)console.error(errors[i3]);
                throw errors[0];
            }
        } finally{
            this._debug(debugName, "end");
        }
    }
    /**
   * set currentSession and currentUser
   * process to _startAutoRefreshToken if possible
   */ async _saveSession(session) {
        this._debug("#_saveSession()", session);
        this.suppressGetSessionWarning = true;
        await $281a441cdcb2cf36$var$removeItemAsync(this.storage, `${this.storageKey}-code-verifier`);
        const sessionToProcess = Object.assign({}, session);
        const userIsProxy = sessionToProcess.user && sessionToProcess.user.__isUserNotAvailableProxy === true;
        if (this.userStorage) {
            if (!userIsProxy && sessionToProcess.user) await $281a441cdcb2cf36$var$setItemAsync(this.userStorage, this.storageKey + "-user", {
                user: sessionToProcess.user
            });
            else userIsProxy;
            const mainSessionData = Object.assign({}, sessionToProcess);
            delete mainSessionData.user;
            const clonedMainSessionData = $281a441cdcb2cf36$var$deepClone(mainSessionData);
            await $281a441cdcb2cf36$var$setItemAsync(this.storage, this.storageKey, clonedMainSessionData);
        } else {
            const clonedSession = $281a441cdcb2cf36$var$deepClone(sessionToProcess);
            await $281a441cdcb2cf36$var$setItemAsync(this.storage, this.storageKey, clonedSession);
        }
    }
    async _removeSession() {
        this._debug("#_removeSession()");
        this.suppressGetSessionWarning = false;
        await $281a441cdcb2cf36$var$removeItemAsync(this.storage, this.storageKey);
        await $281a441cdcb2cf36$var$removeItemAsync(this.storage, this.storageKey + "-code-verifier");
        await $281a441cdcb2cf36$var$removeItemAsync(this.storage, this.storageKey + "-user");
        if (this.userStorage) await $281a441cdcb2cf36$var$removeItemAsync(this.userStorage, this.storageKey + "-user");
        await this._notifyAllSubscribers("SIGNED_OUT", null);
    }
    /**
   * Removes any registered visibilitychange callback.
   *
   * {@see #startAutoRefresh}
   * {@see #stopAutoRefresh}
   */ _removeVisibilityChangedCallback() {
        this._debug("#_removeVisibilityChangedCallback()");
        const callback = this.visibilityChangedCallback;
        this.visibilityChangedCallback = null;
        try {
            if (callback && $281a441cdcb2cf36$var$isBrowser3() && (window === null || window === void 0 ? void 0 : window.removeEventListener)) window.removeEventListener("visibilitychange", callback);
        } catch (e4) {
            console.error("removing visibilitychange callback failed", e4);
        }
    }
    /**
   * This is the private implementation of {@link #startAutoRefresh}. Use this
   * within the library.
   */ async _startAutoRefresh() {
        await this._stopAutoRefresh();
        this._debug("#_startAutoRefresh()");
        const ticker = setInterval(()=>this._autoRefreshTokenTick(), $281a441cdcb2cf36$var$AUTO_REFRESH_TICK_DURATION_MS);
        this.autoRefreshTicker = ticker;
        if (ticker && typeof ticker === "object" && typeof ticker.unref === "function") ticker.unref();
        else if (typeof Deno !== "undefined" && typeof Deno.unrefTimer === "function") Deno.unrefTimer(ticker);
        const timeout = setTimeout(async ()=>{
            await this.initializePromise;
            await this._autoRefreshTokenTick();
        }, 0);
        this.autoRefreshTickTimeout = timeout;
        if (timeout && typeof timeout === "object" && typeof timeout.unref === "function") timeout.unref();
        else if (typeof Deno !== "undefined" && typeof Deno.unrefTimer === "function") Deno.unrefTimer(timeout);
    }
    /**
   * This is the private implementation of {@link #stopAutoRefresh}. Use this
   * within the library.
   */ async _stopAutoRefresh() {
        this._debug("#_stopAutoRefresh()");
        const ticker = this.autoRefreshTicker;
        this.autoRefreshTicker = null;
        if (ticker) clearInterval(ticker);
        const timeout = this.autoRefreshTickTimeout;
        this.autoRefreshTickTimeout = null;
        if (timeout) clearTimeout(timeout);
    }
    /**
   * Starts an auto-refresh process in the background. The session is checked
   * every few seconds. Close to the time of expiration a process is started to
   * refresh the session. If refreshing fails it will be retried for as long as
   * necessary.
   *
   * If you set the {@link GoTrueClientOptions#autoRefreshToken} you don't need
   * to call this function, it will be called for you.
   *
   * On browsers the refresh process works only when the tab/window is in the
   * foreground to conserve resources as well as prevent race conditions and
   * flooding auth with requests. If you call this method any managed
   * visibility change callback will be removed and you must manage visibility
   * changes on your own.
   *
   * On non-browser platforms the refresh process works *continuously* in the
   * background, which may not be desirable. You should hook into your
   * platform's foreground indication mechanism and call these methods
   * appropriately to conserve resources.
   *
   * {@see #stopAutoRefresh}
   *
   * @category Auth
   *
   * @remarks
   * - Only useful in non-browser environments such as React Native or Electron.
   * - The Supabase Auth library automatically starts and stops proactively refreshing the session when a tab is focused or not.
   * - On non-browser platforms, such as mobile or desktop apps built with web technologies, the library is not able to effectively determine whether the application is _focused_ or not.
   * - To give this hint to the application, you should be calling this method when the app is in focus and calling `supabase.auth.stopAutoRefresh()` when it's out of focus.
   *
   * @example Start and stop auto refresh in React Native
   * ```js
   * import { AppState } from 'react-native'
   *
   * // make sure you register this only once!
   * AppState.addEventListener('change', (state) => {
   *   if (state === 'active') {
   *     supabase.auth.startAutoRefresh()
   *   } else {
   *     supabase.auth.stopAutoRefresh()
   *   }
   * })
   * ```
   */ async startAutoRefresh() {
        this._removeVisibilityChangedCallback();
        await this._startAutoRefresh();
    }
    /**
   * Stops an active auto refresh process running in the background (if any).
   *
   * If you call this method any managed visibility change callback will be
   * removed and you must manage visibility changes on your own.
   *
   * See {@link #startAutoRefresh} for more details.
   *
   * @category Auth
   *
   * @remarks
   * - Only useful in non-browser environments such as React Native or Electron.
   * - The Supabase Auth library automatically starts and stops proactively refreshing the session when a tab is focused or not.
   * - On non-browser platforms, such as mobile or desktop apps built with web technologies, the library is not able to effectively determine whether the application is _focused_ or not.
   * - When your application goes in the background or out of focus, call this method to stop the proactive refreshing of the session.
   *
   * @example Start and stop auto refresh in React Native
   * ```js
   * import { AppState } from 'react-native'
   *
   * // make sure you register this only once!
   * AppState.addEventListener('change', (state) => {
   *   if (state === 'active') {
   *     supabase.auth.startAutoRefresh()
   *   } else {
   *     supabase.auth.stopAutoRefresh()
   *   }
   * })
   * ```
   */ async stopAutoRefresh() {
        this._removeVisibilityChangedCallback();
        await this._stopAutoRefresh();
    }
    /**
   * Runs the auto refresh token tick.
   */ async _autoRefreshTokenTick() {
        this._debug("#_autoRefreshTokenTick()", "begin");
        try {
            await this._acquireLock(0, async ()=>{
                try {
                    const now = Date.now();
                    try {
                        return await this._useSession(async (result)=>{
                            const { data: { session: session } } = result;
                            if (!session || !session.refresh_token || !session.expires_at) {
                                this._debug("#_autoRefreshTokenTick()", "no session");
                                return;
                            }
                            const expiresInTicks = Math.floor((session.expires_at * 1e3 - now) / $281a441cdcb2cf36$var$AUTO_REFRESH_TICK_DURATION_MS);
                            this._debug("#_autoRefreshTokenTick()", `access token expires in ${expiresInTicks} ticks, a tick lasts ${$281a441cdcb2cf36$var$AUTO_REFRESH_TICK_DURATION_MS}ms, refresh threshold is ${$281a441cdcb2cf36$var$AUTO_REFRESH_TICK_THRESHOLD} ticks`);
                            if (expiresInTicks <= $281a441cdcb2cf36$var$AUTO_REFRESH_TICK_THRESHOLD) await this._callRefreshToken(session.refresh_token);
                        });
                    } catch (e4) {
                        console.error("Auto refresh tick failed with error. This is likely a transient error.", e4);
                    }
                } finally{
                    this._debug("#_autoRefreshTokenTick()", "end");
                }
            });
        } catch (e4) {
            if (e4.isAcquireTimeout || e4 instanceof $281a441cdcb2cf36$var$LockAcquireTimeoutError) this._debug("auto refresh token tick lock not available");
            else throw e4;
        }
    }
    /**
   * Registers callbacks on the browser / platform, which in-turn run
   * algorithms when the browser window/tab are in foreground. On non-browser
   * platforms it assumes always foreground.
   */ async _handleVisibilityChange() {
        this._debug("#_handleVisibilityChange()");
        if (!$281a441cdcb2cf36$var$isBrowser3() || !(window === null || window === void 0 ? void 0 : window.addEventListener)) {
            if (this.autoRefreshToken) this.startAutoRefresh();
            return false;
        }
        try {
            this.visibilityChangedCallback = async ()=>{
                try {
                    await this._onVisibilityChanged(false);
                } catch (error) {
                    this._debug("#visibilityChangedCallback", "error", error);
                }
            };
            window === null || window === void 0 || window.addEventListener("visibilitychange", this.visibilityChangedCallback);
            await this._onVisibilityChanged(true);
        } catch (error) {
            console.error("_handleVisibilityChange", error);
        }
    }
    /**
   * Callback registered with `window.addEventListener('visibilitychange')`.
   */ async _onVisibilityChanged(calledFromInitialize) {
        const methodName = `#_onVisibilityChanged(${calledFromInitialize})`;
        this._debug(methodName, "visibilityState", document.visibilityState);
        if (document.visibilityState === "visible") {
            if (this.autoRefreshToken) this._startAutoRefresh();
            if (!calledFromInitialize) {
                await this.initializePromise;
                await this._acquireLock(this.lockAcquireTimeout, async ()=>{
                    if (document.visibilityState !== "visible") {
                        this._debug(methodName, "acquired the lock to recover the session, but the browser visibilityState is no longer visible, aborting");
                        return;
                    }
                    await this._recoverAndRefresh();
                });
            }
        } else if (document.visibilityState === "hidden") {
            if (this.autoRefreshToken) this._stopAutoRefresh();
        }
    }
    /**
   * Generates the relevant login URL for a third-party provider.
   * @param options.redirectTo A URL or mobile address to send the user to after they are confirmed.
   * @param options.scopes A space-separated list of scopes granted to the OAuth application.
   * @param options.queryParams An object of key-value pairs containing query parameters granted to the OAuth application.
   */ async _getUrlForProvider(url2, provider, options) {
        const urlParams = [
            `provider=${encodeURIComponent(provider)}`
        ];
        if (options === null || options === void 0 ? void 0 : options.redirectTo) urlParams.push(`redirect_to=${encodeURIComponent(options.redirectTo)}`);
        if (options === null || options === void 0 ? void 0 : options.scopes) urlParams.push(`scopes=${encodeURIComponent(options.scopes)}`);
        if (this.flowType === "pkce") {
            const [codeChallenge, codeChallengeMethod] = await $281a441cdcb2cf36$var$getCodeChallengeAndMethod(this.storage, this.storageKey);
            const flowParams = new URLSearchParams({
                code_challenge: `${encodeURIComponent(codeChallenge)}`,
                code_challenge_method: `${encodeURIComponent(codeChallengeMethod)}`
            });
            urlParams.push(flowParams.toString());
        }
        if (options === null || options === void 0 ? void 0 : options.queryParams) {
            const query = new URLSearchParams(options.queryParams);
            urlParams.push(query.toString());
        }
        if (options === null || options === void 0 ? void 0 : options.skipBrowserRedirect) urlParams.push(`skip_http_redirect=${options.skipBrowserRedirect}`);
        return `${url2}?${urlParams.join("&")}`;
    }
    async _unenroll(params2) {
        try {
            return await this._useSession(async (result)=>{
                var _a2;
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                return await $281a441cdcb2cf36$var$_request(this.fetch, "DELETE", `${this.url}/factors/${params2.factorId}`, {
                    headers: this.headers,
                    jwt: (_a2 = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a2 === void 0 ? void 0 : _a2.access_token
                });
            });
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    async _enroll(params2) {
        try {
            return await this._useSession(async (result)=>{
                var _a2, _b;
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                const body = Object.assign({
                    friendly_name: params2.friendlyName,
                    factor_type: params2.factorType
                }, params2.factorType === "phone" ? {
                    phone: params2.phone
                } : params2.factorType === "totp" ? {
                    issuer: params2.issuer
                } : {});
                const { data: data2, error: error } = await $281a441cdcb2cf36$var$_request(this.fetch, "POST", `${this.url}/factors`, {
                    body: body,
                    headers: this.headers,
                    jwt: (_a2 = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a2 === void 0 ? void 0 : _a2.access_token
                });
                if (error) return this._returnResult({
                    data: null,
                    error: error
                });
                if (params2.factorType === "totp" && data2.type === "totp" && ((_b = data2 === null || data2 === void 0 ? void 0 : data2.totp) === null || _b === void 0 ? void 0 : _b.qr_code)) data2.totp.qr_code = `data:image/svg+xml;utf-8,${data2.totp.qr_code}`;
                return this._returnResult({
                    data: data2,
                    error: null
                });
            });
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    async _verify(params2) {
        return this._acquireLock(this.lockAcquireTimeout, async ()=>{
            try {
                return await this._useSession(async (result)=>{
                    var _a2;
                    const { data: sessionData, error: sessionError } = result;
                    if (sessionError) return this._returnResult({
                        data: null,
                        error: sessionError
                    });
                    const body = Object.assign({
                        challenge_id: params2.challengeId
                    }, "webauthn" in params2 ? {
                        webauthn: Object.assign(Object.assign({}, params2.webauthn), {
                            credential_response: params2.webauthn.type === "create" ? $281a441cdcb2cf36$var$serializeCredentialCreationResponse(params2.webauthn.credential_response) : $281a441cdcb2cf36$var$serializeCredentialRequestResponse(params2.webauthn.credential_response)
                        })
                    } : {
                        code: params2.code
                    });
                    const { data: data2, error: error } = await $281a441cdcb2cf36$var$_request(this.fetch, "POST", `${this.url}/factors/${params2.factorId}/verify`, {
                        body: body,
                        headers: this.headers,
                        jwt: (_a2 = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a2 === void 0 ? void 0 : _a2.access_token
                    });
                    if (error) return this._returnResult({
                        data: null,
                        error: error
                    });
                    await this._saveSession(Object.assign({
                        expires_at: Math.round(Date.now() / 1e3) + data2.expires_in
                    }, data2));
                    await this._notifyAllSubscribers("MFA_CHALLENGE_VERIFIED", data2);
                    return this._returnResult({
                        data: data2,
                        error: error
                    });
                });
            } catch (error) {
                if ($281a441cdcb2cf36$var$isAuthError(error)) return this._returnResult({
                    data: null,
                    error: error
                });
                throw error;
            }
        });
    }
    async _challenge(params2) {
        return this._acquireLock(this.lockAcquireTimeout, async ()=>{
            try {
                return await this._useSession(async (result)=>{
                    var _a2;
                    const { data: sessionData, error: sessionError } = result;
                    if (sessionError) return this._returnResult({
                        data: null,
                        error: sessionError
                    });
                    const response = await $281a441cdcb2cf36$var$_request(this.fetch, "POST", `${this.url}/factors/${params2.factorId}/challenge`, {
                        body: params2,
                        headers: this.headers,
                        jwt: (_a2 = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a2 === void 0 ? void 0 : _a2.access_token
                    });
                    if (response.error) return response;
                    const { data: data2 } = response;
                    if (data2.type !== "webauthn") return {
                        data: data2,
                        error: null
                    };
                    switch(data2.webauthn.type){
                        case "create":
                            return {
                                data: Object.assign(Object.assign({}, data2), {
                                    webauthn: Object.assign(Object.assign({}, data2.webauthn), {
                                        credential_options: Object.assign(Object.assign({}, data2.webauthn.credential_options), {
                                            publicKey: $281a441cdcb2cf36$var$deserializeCredentialCreationOptions(data2.webauthn.credential_options.publicKey)
                                        })
                                    })
                                }),
                                error: null
                            };
                        case "request":
                            return {
                                data: Object.assign(Object.assign({}, data2), {
                                    webauthn: Object.assign(Object.assign({}, data2.webauthn), {
                                        credential_options: Object.assign(Object.assign({}, data2.webauthn.credential_options), {
                                            publicKey: $281a441cdcb2cf36$var$deserializeCredentialRequestOptions(data2.webauthn.credential_options.publicKey)
                                        })
                                    })
                                }),
                                error: null
                            };
                    }
                });
            } catch (error) {
                if ($281a441cdcb2cf36$var$isAuthError(error)) return this._returnResult({
                    data: null,
                    error: error
                });
                throw error;
            }
        });
    }
    /**
   * {@see GoTrueMFAApi#challengeAndVerify}
   */ async _challengeAndVerify(params2) {
        const { data: challengeData, error: challengeError } = await this._challenge({
            factorId: params2.factorId
        });
        if (challengeError) return this._returnResult({
            data: null,
            error: challengeError
        });
        return await this._verify({
            factorId: params2.factorId,
            challengeId: challengeData.id,
            code: params2.code
        });
    }
    /**
   * {@see GoTrueMFAApi#listFactors}
   */ async _listFactors() {
        var _a2;
        const { data: { user: user }, error: userError } = await this.getUser();
        if (userError) return {
            data: null,
            error: userError
        };
        const data2 = {
            all: [],
            phone: [],
            totp: [],
            webauthn: []
        };
        for (const factor of (_a2 = user === null || user === void 0 ? void 0 : user.factors) !== null && _a2 !== void 0 ? _a2 : []){
            data2.all.push(factor);
            if (factor.status === "verified") data2[factor.factor_type].push(factor);
        }
        return {
            data: data2,
            error: null
        };
    }
    /**
   * {@see GoTrueMFAApi#getAuthenticatorAssuranceLevel}
   */ async _getAuthenticatorAssuranceLevel(jwt) {
        var _a2, _b, _c, _d;
        if (jwt) try {
            const { payload: payload2 } = $281a441cdcb2cf36$var$decodeJWT(jwt);
            let currentLevel2 = null;
            if (payload2.aal) currentLevel2 = payload2.aal;
            let nextLevel2 = currentLevel2;
            const { data: { user: user }, error: userError } = await this.getUser(jwt);
            if (userError) return this._returnResult({
                data: null,
                error: userError
            });
            const verifiedFactors2 = (_b = (_a2 = user === null || user === void 0 ? void 0 : user.factors) === null || _a2 === void 0 ? void 0 : _a2.filter((factor)=>factor.status === "verified")) !== null && _b !== void 0 ? _b : [];
            if (verifiedFactors2.length > 0) nextLevel2 = "aal2";
            const currentAuthenticationMethods2 = payload2.amr || [];
            return {
                data: {
                    currentLevel: currentLevel2,
                    nextLevel: nextLevel2,
                    currentAuthenticationMethods: currentAuthenticationMethods2
                },
                error: null
            };
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
        const { data: { session: session }, error: sessionError } = await this.getSession();
        if (sessionError) return this._returnResult({
            data: null,
            error: sessionError
        });
        if (!session) return {
            data: {
                currentLevel: null,
                nextLevel: null,
                currentAuthenticationMethods: []
            },
            error: null
        };
        const { payload: payload } = $281a441cdcb2cf36$var$decodeJWT(session.access_token);
        let currentLevel = null;
        if (payload.aal) currentLevel = payload.aal;
        let nextLevel = currentLevel;
        const verifiedFactors = (_d = (_c = session.user.factors) === null || _c === void 0 ? void 0 : _c.filter((factor)=>factor.status === "verified")) !== null && _d !== void 0 ? _d : [];
        if (verifiedFactors.length > 0) nextLevel = "aal2";
        const currentAuthenticationMethods = payload.amr || [];
        return {
            data: {
                currentLevel: currentLevel,
                nextLevel: nextLevel,
                currentAuthenticationMethods: currentAuthenticationMethods
            },
            error: null
        };
    }
    /**
   * Retrieves details about an OAuth authorization request.
   * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
   *
   * Returns authorization details including client info, scopes, and user information.
   * If the response includes only a redirect_url field, it means consent was already given - the caller
   * should handle the redirect manually if needed.
   */ async _getAuthorizationDetails(authorizationId) {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                if (!session) return this._returnResult({
                    data: null,
                    error: new $281a441cdcb2cf36$var$AuthSessionMissingError()
                });
                return await $281a441cdcb2cf36$var$_request(this.fetch, "GET", `${this.url}/oauth/authorizations/${authorizationId}`, {
                    headers: this.headers,
                    jwt: session.access_token,
                    xform: (data2)=>({
                            data: data2,
                            error: null
                        })
                });
            });
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
   * Approves an OAuth authorization request.
   * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
   */ async _approveAuthorization(authorizationId, options) {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                if (!session) return this._returnResult({
                    data: null,
                    error: new $281a441cdcb2cf36$var$AuthSessionMissingError()
                });
                const response = await $281a441cdcb2cf36$var$_request(this.fetch, "POST", `${this.url}/oauth/authorizations/${authorizationId}/consent`, {
                    headers: this.headers,
                    jwt: session.access_token,
                    body: {
                        action: "approve"
                    },
                    xform: (data2)=>({
                            data: data2,
                            error: null
                        })
                });
                if (response.data && response.data.redirect_url) {
                    if ($281a441cdcb2cf36$var$isBrowser3() && !(options === null || options === void 0 ? void 0 : options.skipBrowserRedirect)) window.location.assign(response.data.redirect_url);
                }
                return response;
            });
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
   * Denies an OAuth authorization request.
   * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
   */ async _denyAuthorization(authorizationId, options) {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                if (!session) return this._returnResult({
                    data: null,
                    error: new $281a441cdcb2cf36$var$AuthSessionMissingError()
                });
                const response = await $281a441cdcb2cf36$var$_request(this.fetch, "POST", `${this.url}/oauth/authorizations/${authorizationId}/consent`, {
                    headers: this.headers,
                    jwt: session.access_token,
                    body: {
                        action: "deny"
                    },
                    xform: (data2)=>({
                            data: data2,
                            error: null
                        })
                });
                if (response.data && response.data.redirect_url) {
                    if ($281a441cdcb2cf36$var$isBrowser3() && !(options === null || options === void 0 ? void 0 : options.skipBrowserRedirect)) window.location.assign(response.data.redirect_url);
                }
                return response;
            });
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
   * Lists all OAuth grants that the authenticated user has authorized.
   * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
   */ async _listOAuthGrants() {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                if (!session) return this._returnResult({
                    data: null,
                    error: new $281a441cdcb2cf36$var$AuthSessionMissingError()
                });
                return await $281a441cdcb2cf36$var$_request(this.fetch, "GET", `${this.url}/user/oauth/grants`, {
                    headers: this.headers,
                    jwt: session.access_token,
                    xform: (data2)=>({
                            data: data2,
                            error: null
                        })
                });
            });
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
   * Revokes a user's OAuth grant for a specific client.
   * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
   */ async _revokeOAuthGrant(options) {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                if (!session) return this._returnResult({
                    data: null,
                    error: new $281a441cdcb2cf36$var$AuthSessionMissingError()
                });
                await $281a441cdcb2cf36$var$_request(this.fetch, "DELETE", `${this.url}/user/oauth/grants`, {
                    headers: this.headers,
                    jwt: session.access_token,
                    query: {
                        client_id: options.clientId
                    },
                    noResolveJson: true
                });
                return {
                    data: {},
                    error: null
                };
            });
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    async fetchJwk(kid, jwks = {
        keys: []
    }) {
        let jwk = jwks.keys.find((key)=>key.kid === kid);
        if (jwk) return jwk;
        const now = Date.now();
        jwk = this.jwks.keys.find((key)=>key.kid === kid);
        if (jwk && this.jwks_cached_at + $281a441cdcb2cf36$var$JWKS_TTL > now) return jwk;
        const { data: data2, error: error } = await $281a441cdcb2cf36$var$_request(this.fetch, "GET", `${this.url}/.well-known/jwks.json`, {
            headers: this.headers
        });
        if (error) throw error;
        if (!data2.keys || data2.keys.length === 0) return null;
        this.jwks = data2;
        this.jwks_cached_at = now;
        jwk = data2.keys.find((key)=>key.kid === kid);
        if (!jwk) return null;
        return jwk;
    }
    /**
   * Extracts the JWT claims present in the access token by first verifying the
   * JWT against the server's JSON Web Key Set endpoint
   * `/.well-known/jwks.json` which is often cached, resulting in significantly
   * faster responses. Prefer this method over {@link #getUser} which always
   * sends a request to the Auth server for each JWT.
   *
   * If the project is not using an asymmetric JWT signing key (like ECC or
   * RSA) it always sends a request to the Auth server (similar to {@link
   * #getUser}) to verify the JWT.
   *
   * @param jwt An optional specific JWT you wish to verify, not the one you
   *            can obtain from {@link #getSession}.
   * @param options Various additional options that allow you to customize the
   *                behavior of this method.
   *
   * @category Auth
   *
   * @remarks
   * - Parses the user's [access token](/docs/guides/auth/sessions#access-token-jwt-claims) as a [JSON Web Token (JWT)](/docs/guides/auth/jwts) and returns its components if valid and not expired.
   * - If your project is using asymmetric JWT signing keys, then the verification is done locally usually without a network request using the [WebCrypto API](https://developer.mozilla.org/en-US/docs/Web/API/Web_Crypto_API).
   * - A network request is sent to your project's JWT signing key discovery endpoint `https://project-id.supabase.co/auth/v1/.well-known/jwks.json`, which is cached locally. If your environment is ephemeral, such as a Lambda function that is destroyed after every request, a network request will be sent for each new invocation. Supabase provides a network-edge cache providing fast responses for these situations.
   * - If the user's access token is about to expire when calling this function, the user's session will first be refreshed before validating the JWT.
   * - If your project is using a symmetric secret to sign the JWT, it always sends a request similar to `getUser()` to validate the JWT at the server before returning the decoded token. This is also used if the WebCrypto API is not available in the environment. Make sure you polyfill it in such situations.
   * - The returned claims can be customized per project using the [Custom Access Token Hook](/docs/guides/auth/auth-hooks/custom-access-token-hook).
   *
   * @example Get JWT claims, header and signature
   * ```js
   * const { data, error } = await supabase.auth.getClaims()
   * ```
   *
   * @exampleResponse Get JWT claims, header and signature
   * ```json
   * {
   *   "data": {
   *     "claims": {
   *       "aal": "aal1",
   *       "amr": [{
   *         "method": "email",
   *         "timestamp": 1715766000
   *       }],
   *       "app_metadata": {},
   *       "aud": "authenticated",
   *       "email": "example@email.com",
   *       "exp": 1715769600,
   *       "iat": 1715766000,
   *       "is_anonymous": false,
   *       "iss": "https://project-id.supabase.co/auth/v1",
   *       "phone": "+13334445555",
   *       "role": "authenticated",
   *       "session_id": "11111111-1111-1111-1111-111111111111",
   *       "sub": "11111111-1111-1111-1111-111111111111",
   *       "user_metadata": {}
   *     },
   *     "header": {
   *       "alg": "RS256",
   *       "typ": "JWT",
   *       "kid": "11111111-1111-1111-1111-111111111111"
   *     },
   *     "signature": [/** Uint8Array *\/],
   *   },
   *   "error": null
   * }
   * ```
   */ async getClaims(jwt, options = {}) {
        try {
            let token = jwt;
            if (!token) {
                const { data: data2, error: error } = await this.getSession();
                if (error || !data2.session) return this._returnResult({
                    data: null,
                    error: error
                });
                token = data2.session.access_token;
            }
            const { header: header, payload: payload, signature: signature, raw: { header: rawHeader, payload: rawPayload } } = $281a441cdcb2cf36$var$decodeJWT(token);
            if (!(options === null || options === void 0 ? void 0 : options.allowExpired)) $281a441cdcb2cf36$var$validateExp(payload.exp);
            const signingKey = !header.alg || header.alg.startsWith("HS") || !header.kid || !("crypto" in globalThis && "subtle" in globalThis.crypto) ? null : await this.fetchJwk(header.kid, (options === null || options === void 0 ? void 0 : options.keys) ? {
                keys: options.keys
            } : options === null || options === void 0 ? void 0 : options.jwks);
            if (!signingKey) {
                const { error: error } = await this.getUser(token);
                if (error) throw error;
                return {
                    data: {
                        claims: payload,
                        header: header,
                        signature: signature
                    },
                    error: null
                };
            }
            const algorithm = $281a441cdcb2cf36$var$getAlgorithm(header.alg);
            const publicKey = await crypto.subtle.importKey("jwk", signingKey, algorithm, true, [
                "verify"
            ]);
            const isValid = await crypto.subtle.verify(algorithm, publicKey, signature, $281a441cdcb2cf36$var$stringToUint8Array(`${rawHeader}.${rawPayload}`));
            if (!isValid) throw new $281a441cdcb2cf36$var$AuthInvalidJwtError("Invalid JWT signature");
            return {
                data: {
                    claims: payload,
                    header: header,
                    signature: signature
                },
                error: null
            };
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    // --- Passkey Methods ---
    /**
   * Sign in with a passkey. Handles the full WebAuthn ceremony:
   * 1. Fetches authentication challenge from server
   * 2. Prompts user via navigator.credentials.get()
   * 3. Verifies credential with server and creates session
   *
   * Requires `auth.experimental.passkey: true`.
   */ async signInWithPasskey(credentials) {
        var _a2, _b, _c;
        $281a441cdcb2cf36$var$assertPasskeyExperimentalEnabled(this.experimental);
        try {
            if (!$281a441cdcb2cf36$var$browserSupportsWebAuthn()) return this._returnResult({
                data: null,
                error: new $281a441cdcb2cf36$var$AuthUnknownError("Browser does not support WebAuthn", null)
            });
            const { data: options, error: optionsError } = await this._startPasskeyAuthentication({
                options: {
                    captchaToken: (_a2 = credentials === null || credentials === void 0 ? void 0 : credentials.options) === null || _a2 === void 0 ? void 0 : _a2.captchaToken
                }
            });
            if (optionsError || !options) return this._returnResult({
                data: null,
                error: optionsError
            });
            const publicKeyOptions = $281a441cdcb2cf36$var$deserializeCredentialRequestOptions(options.options);
            const signal = (_c = (_b = credentials === null || credentials === void 0 ? void 0 : credentials.options) === null || _b === void 0 ? void 0 : _b.signal) !== null && _c !== void 0 ? _c : $281a441cdcb2cf36$var$webAuthnAbortService.createNewAbortSignal();
            const { data: credential, error: credentialError } = await $281a441cdcb2cf36$var$getCredential({
                publicKey: publicKeyOptions,
                signal: signal
            });
            if (credentialError || !credential) return this._returnResult({
                data: null,
                error: credentialError !== null && credentialError !== void 0 ? credentialError : new $281a441cdcb2cf36$var$AuthUnknownError("WebAuthn ceremony failed", null)
            });
            const serialized = $281a441cdcb2cf36$var$serializeCredentialRequestResponse(credential);
            return this._verifyPasskeyAuthentication({
                challengeId: options.challenge_id,
                credential: serialized
            });
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
   * Register a passkey for the current authenticated user. Handles the full WebAuthn ceremony:
   * 1. Fetches registration challenge from server
   * 2. Prompts user via navigator.credentials.create()
   * 3. Verifies credential with server
   *
   * Requires an active session. Requires `auth.experimental.passkey: true`.
   */ async registerPasskey(credentials) {
        var _a2, _b;
        $281a441cdcb2cf36$var$assertPasskeyExperimentalEnabled(this.experimental);
        try {
            if (!$281a441cdcb2cf36$var$browserSupportsWebAuthn()) return this._returnResult({
                data: null,
                error: new $281a441cdcb2cf36$var$AuthUnknownError("Browser does not support WebAuthn", null)
            });
            const { data: options, error: optionsError } = await this._startPasskeyRegistration();
            if (optionsError || !options) return this._returnResult({
                data: null,
                error: optionsError
            });
            const publicKeyOptions = $281a441cdcb2cf36$var$deserializeCredentialCreationOptions(options.options);
            const signal = (_b = (_a2 = credentials === null || credentials === void 0 ? void 0 : credentials.options) === null || _a2 === void 0 ? void 0 : _a2.signal) !== null && _b !== void 0 ? _b : $281a441cdcb2cf36$var$webAuthnAbortService.createNewAbortSignal();
            const { data: credential, error: credentialError } = await $281a441cdcb2cf36$var$createCredential({
                publicKey: publicKeyOptions,
                signal: signal
            });
            if (credentialError || !credential) return this._returnResult({
                data: null,
                error: credentialError !== null && credentialError !== void 0 ? credentialError : new $281a441cdcb2cf36$var$AuthUnknownError("WebAuthn ceremony failed", null)
            });
            const serialized = $281a441cdcb2cf36$var$serializeCredentialCreationResponse(credential);
            return this._verifyPasskeyRegistration({
                challengeId: options.challenge_id,
                credential: serialized
            });
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
   * Start passkey registration for the current authenticated user.
   * Returns WebAuthn credential creation options to pass to navigator.credentials.create().
   */ async _startPasskeyRegistration() {
        $281a441cdcb2cf36$var$assertPasskeyExperimentalEnabled(this.experimental);
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                if (!session) return this._returnResult({
                    data: null,
                    error: new $281a441cdcb2cf36$var$AuthSessionMissingError()
                });
                const { data: data2, error: error } = await $281a441cdcb2cf36$var$_request(this.fetch, "POST", `${this.url}/passkeys/registration/options`, {
                    headers: this.headers,
                    jwt: session.access_token,
                    body: {}
                });
                if (error) return this._returnResult({
                    data: null,
                    error: error
                });
                return this._returnResult({
                    data: data2,
                    error: null
                });
            });
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
   * Verify passkey registration with the credential response.
   * The credentialResponse should be the serialized output of navigator.credentials.create().
   */ async _verifyPasskeyRegistration(params2) {
        $281a441cdcb2cf36$var$assertPasskeyExperimentalEnabled(this.experimental);
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                if (!session) return this._returnResult({
                    data: null,
                    error: new $281a441cdcb2cf36$var$AuthSessionMissingError()
                });
                const { data: data2, error: error } = await $281a441cdcb2cf36$var$_request(this.fetch, "POST", `${this.url}/passkeys/registration/verify`, {
                    headers: this.headers,
                    jwt: session.access_token,
                    body: {
                        challenge_id: params2.challengeId,
                        credential: params2.credential
                    }
                });
                if (error) return this._returnResult({
                    data: null,
                    error: error
                });
                return this._returnResult({
                    data: data2,
                    error: null
                });
            });
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
   * Start passkey authentication.
   * Returns WebAuthn credential request options to pass to navigator.credentials.get().
   */ async _startPasskeyAuthentication(params2) {
        var _a2;
        $281a441cdcb2cf36$var$assertPasskeyExperimentalEnabled(this.experimental);
        try {
            const { data: data2, error: error } = await $281a441cdcb2cf36$var$_request(this.fetch, "POST", `${this.url}/passkeys/authentication/options`, {
                headers: this.headers,
                body: {
                    gotrue_meta_security: {
                        captcha_token: (_a2 = params2 === null || params2 === void 0 ? void 0 : params2.options) === null || _a2 === void 0 ? void 0 : _a2.captchaToken
                    }
                }
            });
            if (error) return this._returnResult({
                data: null,
                error: error
            });
            return this._returnResult({
                data: data2,
                error: null
            });
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
   * Verify passkey authentication and create a session.
   * The credential should be the serialized output of navigator.credentials.get().
   */ async _verifyPasskeyAuthentication(params2) {
        $281a441cdcb2cf36$var$assertPasskeyExperimentalEnabled(this.experimental);
        try {
            const { data: data2, error: error } = await $281a441cdcb2cf36$var$_request(this.fetch, "POST", `${this.url}/passkeys/authentication/verify`, {
                headers: this.headers,
                body: {
                    challenge_id: params2.challengeId,
                    credential: params2.credential
                },
                xform: $281a441cdcb2cf36$var$_sessionResponse
            });
            if (error) return this._returnResult({
                data: null,
                error: error
            });
            if (data2.session) {
                await this._saveSession(data2.session);
                await this._notifyAllSubscribers("SIGNED_IN", data2.session);
            }
            return this._returnResult({
                data: data2,
                error: null
            });
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
   * List all passkeys for the current user.
   */ async _listPasskeys() {
        $281a441cdcb2cf36$var$assertPasskeyExperimentalEnabled(this.experimental);
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                if (!session) return this._returnResult({
                    data: null,
                    error: new $281a441cdcb2cf36$var$AuthSessionMissingError()
                });
                const { data: data2, error: error } = await $281a441cdcb2cf36$var$_request(this.fetch, "GET", `${this.url}/passkeys`, {
                    headers: this.headers,
                    jwt: session.access_token,
                    xform: (data3)=>({
                            data: data3,
                            error: null
                        })
                });
                if (error) return this._returnResult({
                    data: null,
                    error: error
                });
                return this._returnResult({
                    data: data2,
                    error: null
                });
            });
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
   * Update a passkey.
   */ async _updatePasskey(params2) {
        $281a441cdcb2cf36$var$assertPasskeyExperimentalEnabled(this.experimental);
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                if (!session) return this._returnResult({
                    data: null,
                    error: new $281a441cdcb2cf36$var$AuthSessionMissingError()
                });
                const { data: data2, error: error } = await $281a441cdcb2cf36$var$_request(this.fetch, "PATCH", `${this.url}/passkeys/${params2.passkeyId}`, {
                    headers: this.headers,
                    jwt: session.access_token,
                    body: {
                        friendly_name: params2.friendlyName
                    }
                });
                if (error) return this._returnResult({
                    data: null,
                    error: error
                });
                return this._returnResult({
                    data: data2,
                    error: null
                });
            });
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
   * Delete a passkey.
   */ async _deletePasskey(params2) {
        $281a441cdcb2cf36$var$assertPasskeyExperimentalEnabled(this.experimental);
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                if (!session) return this._returnResult({
                    data: null,
                    error: new $281a441cdcb2cf36$var$AuthSessionMissingError()
                });
                const { error: error } = await $281a441cdcb2cf36$var$_request(this.fetch, "DELETE", `${this.url}/passkeys/${params2.passkeyId}`, {
                    headers: this.headers,
                    jwt: session.access_token,
                    noResolveJson: true
                });
                if (error) return this._returnResult({
                    data: null,
                    error: error
                });
                return this._returnResult({
                    data: null,
                    error: null
                });
            });
        } catch (error) {
            if ($281a441cdcb2cf36$var$isAuthError(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
};
$281a441cdcb2cf36$var$GoTrueClient.nextInstanceID = {};
var $281a441cdcb2cf36$var$GoTrueClient_default = $281a441cdcb2cf36$var$GoTrueClient;
// ../node_modules/@supabase/auth-js/dist/module/AuthClient.js
var $281a441cdcb2cf36$var$AuthClient = $281a441cdcb2cf36$var$GoTrueClient_default;
var $281a441cdcb2cf36$var$AuthClient_default = $281a441cdcb2cf36$var$AuthClient;
// ../node_modules/@supabase/supabase-js/dist/index.mjs
var $281a441cdcb2cf36$var$version5 = "2.105.1";
var $281a441cdcb2cf36$var$JS_ENV = "";
if (typeof Deno !== "undefined") $281a441cdcb2cf36$var$JS_ENV = "deno";
else if (typeof document !== "undefined") $281a441cdcb2cf36$var$JS_ENV = "web";
else if (typeof navigator !== "undefined" && navigator.product === "ReactNative") $281a441cdcb2cf36$var$JS_ENV = "react-native";
else $281a441cdcb2cf36$var$JS_ENV = "node";
var $281a441cdcb2cf36$var$DEFAULT_HEADERS3 = {
    "X-Client-Info": `supabase-js-${$281a441cdcb2cf36$var$JS_ENV}/${$281a441cdcb2cf36$var$version5}`
};
var $281a441cdcb2cf36$var$DEFAULT_GLOBAL_OPTIONS = {
    headers: $281a441cdcb2cf36$var$DEFAULT_HEADERS3
};
var $281a441cdcb2cf36$var$DEFAULT_DB_OPTIONS = {
    schema: "public"
};
var $281a441cdcb2cf36$var$DEFAULT_AUTH_OPTIONS = {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: "implicit"
};
var $281a441cdcb2cf36$var$DEFAULT_REALTIME_OPTIONS = {};
function $281a441cdcb2cf36$var$_typeof3(o3) {
    "@babel/helpers - typeof";
    return $281a441cdcb2cf36$var$_typeof3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o$1) {
        return typeof o$1;
    } : function(o$1) {
        return o$1 && "function" == typeof Symbol && o$1.constructor === Symbol && o$1 !== Symbol.prototype ? "symbol" : typeof o$1;
    }, $281a441cdcb2cf36$var$_typeof3(o3);
}
function $281a441cdcb2cf36$var$toPrimitive3(t4, r3) {
    if ("object" != $281a441cdcb2cf36$var$_typeof3(t4) || !t4) return t4;
    var e4 = t4[Symbol.toPrimitive];
    if (void 0 !== e4) {
        var i3 = e4.call(t4, r3 || "default");
        if ("object" != $281a441cdcb2cf36$var$_typeof3(i3)) return i3;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r3 ? String : Number)(t4);
}
function $281a441cdcb2cf36$var$toPropertyKey3(t4) {
    var i3 = $281a441cdcb2cf36$var$toPrimitive3(t4, "string");
    return "symbol" == $281a441cdcb2cf36$var$_typeof3(i3) ? i3 : i3 + "";
}
function $281a441cdcb2cf36$var$_defineProperty3(e4, r3, t4) {
    return (r3 = $281a441cdcb2cf36$var$toPropertyKey3(r3)) in e4 ? Object.defineProperty(e4, r3, {
        value: t4,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e4[r3] = t4, e4;
}
function $281a441cdcb2cf36$var$ownKeys3(e4, r3) {
    var t4 = Object.keys(e4);
    if (Object.getOwnPropertySymbols) {
        var o3 = Object.getOwnPropertySymbols(e4);
        r3 && (o3 = o3.filter(function(r$1) {
            return Object.getOwnPropertyDescriptor(e4, r$1).enumerable;
        })), t4.push.apply(t4, o3);
    }
    return t4;
}
function $281a441cdcb2cf36$var$_objectSpread23(e4) {
    for(var r3 = 1; r3 < arguments.length; r3++){
        var t4 = null != arguments[r3] ? arguments[r3] : {};
        r3 % 2 ? $281a441cdcb2cf36$var$ownKeys3(Object(t4), true).forEach(function(r$1) {
            $281a441cdcb2cf36$var$_defineProperty3(e4, r$1, t4[r$1]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(t4)) : $281a441cdcb2cf36$var$ownKeys3(Object(t4)).forEach(function(r$1) {
            Object.defineProperty(e4, r$1, Object.getOwnPropertyDescriptor(t4, r$1));
        });
    }
    return e4;
}
var $281a441cdcb2cf36$var$resolveFetch4 = (customFetch)=>{
    if (customFetch) return (...args2)=>customFetch(...args2);
    return (...args2)=>fetch(...args2);
};
var $281a441cdcb2cf36$var$resolveHeadersConstructor = ()=>{
    return Headers;
};
var $281a441cdcb2cf36$var$fetchWithAuth = (supabaseKey, getAccessToken, customFetch)=>{
    const fetch$1 = $281a441cdcb2cf36$var$resolveFetch4(customFetch);
    const HeadersConstructor = $281a441cdcb2cf36$var$resolveHeadersConstructor();
    return async (input, init)=>{
        var _await$getAccessToken;
        const accessToken = (_await$getAccessToken = await getAccessToken()) !== null && _await$getAccessToken !== void 0 ? _await$getAccessToken : supabaseKey;
        let headers = new HeadersConstructor(init === null || init === void 0 ? void 0 : init.headers);
        if (!headers.has("apikey")) headers.set("apikey", supabaseKey);
        if (!headers.has("Authorization")) headers.set("Authorization", `Bearer ${accessToken}`);
        return fetch$1(input, $281a441cdcb2cf36$var$_objectSpread23($281a441cdcb2cf36$var$_objectSpread23({}, init), {}, {
            headers: headers
        }));
    };
};
function $281a441cdcb2cf36$var$ensureTrailingSlash(url2) {
    return url2.endsWith("/") ? url2 : url2 + "/";
}
function $281a441cdcb2cf36$var$applySettingDefaults(options, defaults) {
    var _DEFAULT_GLOBAL_OPTIO, _globalOptions$header;
    const { db: dbOptions, auth: authOptions, realtime: realtimeOptions, global: globalOptions } = options;
    const { db: DEFAULT_DB_OPTIONS$1, auth: DEFAULT_AUTH_OPTIONS$1, realtime: DEFAULT_REALTIME_OPTIONS$1, global: DEFAULT_GLOBAL_OPTIONS$1 } = defaults;
    const result = {
        db: $281a441cdcb2cf36$var$_objectSpread23($281a441cdcb2cf36$var$_objectSpread23({}, DEFAULT_DB_OPTIONS$1), dbOptions),
        auth: $281a441cdcb2cf36$var$_objectSpread23($281a441cdcb2cf36$var$_objectSpread23({}, DEFAULT_AUTH_OPTIONS$1), authOptions),
        realtime: $281a441cdcb2cf36$var$_objectSpread23($281a441cdcb2cf36$var$_objectSpread23({}, DEFAULT_REALTIME_OPTIONS$1), realtimeOptions),
        storage: {},
        global: $281a441cdcb2cf36$var$_objectSpread23($281a441cdcb2cf36$var$_objectSpread23($281a441cdcb2cf36$var$_objectSpread23({}, DEFAULT_GLOBAL_OPTIONS$1), globalOptions), {}, {
            headers: $281a441cdcb2cf36$var$_objectSpread23($281a441cdcb2cf36$var$_objectSpread23({}, (_DEFAULT_GLOBAL_OPTIO = DEFAULT_GLOBAL_OPTIONS$1 === null || DEFAULT_GLOBAL_OPTIONS$1 === void 0 ? void 0 : DEFAULT_GLOBAL_OPTIONS$1.headers) !== null && _DEFAULT_GLOBAL_OPTIO !== void 0 ? _DEFAULT_GLOBAL_OPTIO : {}), (_globalOptions$header = globalOptions === null || globalOptions === void 0 ? void 0 : globalOptions.headers) !== null && _globalOptions$header !== void 0 ? _globalOptions$header : {})
        }),
        accessToken: async ()=>""
    };
    if (options.accessToken) result.accessToken = options.accessToken;
    else delete result.accessToken;
    return result;
}
function $281a441cdcb2cf36$var$validateSupabaseUrl(supabaseUrl) {
    const trimmedUrl = supabaseUrl === null || supabaseUrl === void 0 ? void 0 : supabaseUrl.trim();
    if (!trimmedUrl) throw new Error("supabaseUrl is required.");
    if (!trimmedUrl.match(/^https?:\/\//i)) throw new Error("Invalid supabaseUrl: Must be a valid HTTP or HTTPS URL.");
    try {
        return new URL($281a441cdcb2cf36$var$ensureTrailingSlash(trimmedUrl));
    } catch (_unused) {
        throw Error("Invalid supabaseUrl: Provided URL is malformed.");
    }
}
var $281a441cdcb2cf36$var$SupabaseAuthClient = class extends $281a441cdcb2cf36$var$AuthClient_default {
    constructor(options){
        super(options);
    }
};
var $281a441cdcb2cf36$var$SupabaseClient = class {
    /**
  * Create a new client for use in the browser.
  *
  * @category Initializing
  *
  * @param supabaseUrl The unique Supabase URL which is supplied when you create a new project in your project dashboard.
  * @param supabaseKey The unique Supabase Key which is supplied when you create a new project in your project dashboard.
  * @param options.db.schema You can switch in between schemas. The schema needs to be on the list of exposed schemas inside Supabase.
  * @param options.auth.autoRefreshToken Set to "true" if you want to automatically refresh the token before expiring.
  * @param options.auth.persistSession Set to "true" if you want to automatically save the user session into local storage.
  * @param options.auth.detectSessionInUrl Set to "true" if you want to automatically detects OAuth grants in the URL and signs in the user.
  * @param options.realtime Options passed along to realtime-js constructor.
  * @param options.storage Options passed along to the storage-js constructor.
  * @param options.global.fetch A custom fetch implementation.
  * @param options.global.headers Any additional headers to send with each network request.
  *
  * @example Creating a client
  * ```js
  * import { createClient } from '@supabase/supabase-js'
  *
  * // Create a single supabase client for interacting with your database
  * const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
  * ```
  *
  * @example With a custom domain
  * ```js
  * import { createClient } from '@supabase/supabase-js'
  *
  * // Use a custom domain as the supabase URL
  * const supabase = createClient('https://my-custom-domain.com', 'your-publishable-key')
  * ```
  *
  * @example With additional parameters
  * ```js
  * import { createClient } from '@supabase/supabase-js'
  *
  * const options = {
  *   db: {
  *     schema: 'public',
  *   },
  *   auth: {
  *     autoRefreshToken: true,
  *     persistSession: true,
  *     detectSessionInUrl: true
  *   },
  *   global: {
  *     headers: { 'x-my-custom-header': 'my-app-name' },
  *   },
  * }
  * const supabase = createClient("https://xyzcompany.supabase.co", "your-publishable-key", options)
  * ```
  *
  * @exampleDescription With custom schemas
  * By default the API server points to the `public` schema. You can enable other database schemas within the Dashboard.
  * Go to [Settings > API > Exposed schemas](/dashboard/project/_/settings/api) and add the schema which you want to expose to the API.
  *
  * Note: each client connection can only access a single schema, so the code above can access the `other_schema` schema but cannot access the `public` schema.
  *
  * @example With custom schemas
  * ```js
  * import { createClient } from '@supabase/supabase-js'
  *
  * const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key', {
  *   // Provide a custom schema. Defaults to "public".
  *   db: { schema: 'other_schema' }
  * })
  * ```
  *
  * @exampleDescription Custom fetch implementation
  * `supabase-js` uses the [`cross-fetch`](https://www.npmjs.com/package/cross-fetch) library to make HTTP requests,
  * but an alternative `fetch` implementation can be provided as an option.
  * This is most useful in environments where `cross-fetch` is not compatible (for instance Cloudflare Workers).
  *
  * @example Custom fetch implementation
  * ```js
  * import { createClient } from '@supabase/supabase-js'
  *
  * const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key', {
  *   global: { fetch: fetch.bind(globalThis) }
  * })
  * ```
  *
  * @exampleDescription React Native options with AsyncStorage
  * For React Native we recommend using `AsyncStorage` as the storage implementation for Supabase Auth.
  *
  * @example React Native options with AsyncStorage
  * ```js
  * import 'react-native-url-polyfill/auto'
  * import { createClient } from '@supabase/supabase-js'
  * import AsyncStorage from "@react-native-async-storage/async-storage";
  *
  * const supabase = createClient("https://xyzcompany.supabase.co", "your-publishable-key", {
  *   auth: {
  *     storage: AsyncStorage,
  *     autoRefreshToken: true,
  *     persistSession: true,
  *     detectSessionInUrl: false,
  *   },
  * });
  * ```
  *
  * @exampleDescription React Native options with Expo SecureStore
  * If you wish to encrypt the user's session information, you can use `aes-js` and store the encryption key in Expo SecureStore.
  * The `aes-js` library, a reputable JavaScript-only implementation of the AES encryption algorithm in CTR mode.
  * A new 256-bit encryption key is generated using the `react-native-get-random-values` library.
  * This key is stored inside Expo's SecureStore, while the value is encrypted and placed inside AsyncStorage.
  *
  * Please make sure that:
  * - You keep the `expo-secure-store`, `aes-js` and `react-native-get-random-values` libraries up-to-date.
  * - Choose the correct [`SecureStoreOptions`](https://docs.expo.dev/versions/latest/sdk/securestore/#securestoreoptions) for your app's needs.
  *   E.g. [`SecureStore.WHEN_UNLOCKED`](https://docs.expo.dev/versions/latest/sdk/securestore/#securestorewhen_unlocked) regulates when the data can be accessed.
  * - Carefully consider optimizations or other modifications to the above example, as those can lead to introducing subtle security vulnerabilities.
  *
  * @example React Native options with Expo SecureStore
  * ```ts
  * import 'react-native-url-polyfill/auto'
  * import { createClient } from '@supabase/supabase-js'
  * import AsyncStorage from '@react-native-async-storage/async-storage';
  * import * as SecureStore from 'expo-secure-store';
  * import * as aesjs from 'aes-js';
  * import 'react-native-get-random-values';
  *
  * // As Expo's SecureStore does not support values larger than 2048
  * // bytes, an AES-256 key is generated and stored in SecureStore, while
  * // it is used to encrypt/decrypt values stored in AsyncStorage.
  * class LargeSecureStore {
  *   private async _encrypt(key: string, value: string) {
  *     const encryptionKey = crypto.getRandomValues(new Uint8Array(256 / 8));
  *
  *     const cipher = new aesjs.ModeOfOperation.ctr(encryptionKey, new aesjs.Counter(1));
  *     const encryptedBytes = cipher.encrypt(aesjs.utils.utf8.toBytes(value));
  *
  *     await SecureStore.setItemAsync(key, aesjs.utils.hex.fromBytes(encryptionKey));
  *
  *     return aesjs.utils.hex.fromBytes(encryptedBytes);
  *   }
  *
  *   private async _decrypt(key: string, value: string) {
  *     const encryptionKeyHex = await SecureStore.getItemAsync(key);
  *     if (!encryptionKeyHex) {
  *       return encryptionKeyHex;
  *     }
  *
  *     const cipher = new aesjs.ModeOfOperation.ctr(aesjs.utils.hex.toBytes(encryptionKeyHex), new aesjs.Counter(1));
  *     const decryptedBytes = cipher.decrypt(aesjs.utils.hex.toBytes(value));
  *
  *     return aesjs.utils.utf8.fromBytes(decryptedBytes);
  *   }
  *
  *   async getItem(key: string) {
  *     const encrypted = await AsyncStorage.getItem(key);
  *     if (!encrypted) { return encrypted; }
  *
  *     return await this._decrypt(key, encrypted);
  *   }
  *
  *   async removeItem(key: string) {
  *     await AsyncStorage.removeItem(key);
  *     await SecureStore.deleteItemAsync(key);
  *   }
  *
  *   async setItem(key: string, value: string) {
  *     const encrypted = await this._encrypt(key, value);
  *
  *     await AsyncStorage.setItem(key, encrypted);
  *   }
  * }
  *
  * const supabase = createClient("https://xyzcompany.supabase.co", "your-publishable-key", {
  *   auth: {
  *     storage: new LargeSecureStore(),
  *     autoRefreshToken: true,
  *     persistSession: true,
  *     detectSessionInUrl: false,
  *   },
  * });
  * ```
  *
  * @example With a database query
  * ```ts
  * import { createClient } from '@supabase/supabase-js'
  *
  * const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
  *
  * const { data } = await supabase.from('profiles').select('*')
  * ```
  */ constructor(supabaseUrl, supabaseKey, options){
        var _settings$auth$storag, _settings$global$head;
        this.supabaseUrl = supabaseUrl;
        this.supabaseKey = supabaseKey;
        const baseUrl = $281a441cdcb2cf36$var$validateSupabaseUrl(supabaseUrl);
        if (!supabaseKey) throw new Error("supabaseKey is required.");
        this.realtimeUrl = new URL("realtime/v1", baseUrl);
        this.realtimeUrl.protocol = this.realtimeUrl.protocol.replace("http", "ws");
        this.authUrl = new URL("auth/v1", baseUrl);
        this.storageUrl = new URL("storage/v1", baseUrl);
        this.functionsUrl = new URL("functions/v1", baseUrl);
        const defaultStorageKey = `sb-${baseUrl.hostname.split(".")[0]}-auth-token`;
        const DEFAULTS = {
            db: $281a441cdcb2cf36$var$DEFAULT_DB_OPTIONS,
            realtime: $281a441cdcb2cf36$var$DEFAULT_REALTIME_OPTIONS,
            auth: $281a441cdcb2cf36$var$_objectSpread23($281a441cdcb2cf36$var$_objectSpread23({}, $281a441cdcb2cf36$var$DEFAULT_AUTH_OPTIONS), {}, {
                storageKey: defaultStorageKey
            }),
            global: $281a441cdcb2cf36$var$DEFAULT_GLOBAL_OPTIONS
        };
        const settings = $281a441cdcb2cf36$var$applySettingDefaults(options !== null && options !== void 0 ? options : {}, DEFAULTS);
        this.storageKey = (_settings$auth$storag = settings.auth.storageKey) !== null && _settings$auth$storag !== void 0 ? _settings$auth$storag : "";
        this.headers = (_settings$global$head = settings.global.headers) !== null && _settings$global$head !== void 0 ? _settings$global$head : {};
        if (!settings.accessToken) {
            var _settings$auth;
            this.auth = this._initSupabaseAuthClient((_settings$auth = settings.auth) !== null && _settings$auth !== void 0 ? _settings$auth : {}, this.headers, settings.global.fetch);
        } else {
            this.accessToken = settings.accessToken;
            this.auth = new Proxy({}, {
                get: (_3, prop)=>{
                    throw new Error(`@supabase/supabase-js: Supabase Client is configured with the accessToken option, accessing supabase.auth.${String(prop)} is not possible`);
                }
            });
        }
        this.fetch = $281a441cdcb2cf36$var$fetchWithAuth(supabaseKey, this._getAccessToken.bind(this), settings.global.fetch);
        this.realtime = this._initRealtimeClient($281a441cdcb2cf36$var$_objectSpread23({
            headers: this.headers,
            accessToken: this._getAccessToken.bind(this),
            fetch: this.fetch
        }, settings.realtime));
        if (this.accessToken) Promise.resolve(this.accessToken()).then((token)=>this.realtime.setAuth(token)).catch((e4)=>console.warn("Failed to set initial Realtime auth token:", e4));
        this.rest = new $281a441cdcb2cf36$var$PostgrestClient(new URL("rest/v1", baseUrl).href, {
            headers: this.headers,
            schema: settings.db.schema,
            fetch: this.fetch,
            timeout: settings.db.timeout,
            urlLengthLimit: settings.db.urlLengthLimit
        });
        this.storage = new $281a441cdcb2cf36$var$StorageClient(this.storageUrl.href, this.headers, this.fetch, options === null || options === void 0 ? void 0 : options.storage);
        if (!settings.accessToken) this._listenForAuthEvents();
    }
    /**
  * Supabase Functions allows you to deploy and invoke edge functions.
  */ get functions() {
        return new $281a441cdcb2cf36$var$FunctionsClient(this.functionsUrl.href, {
            headers: this.headers,
            customFetch: this.fetch
        });
    }
    /**
  * Perform a query on a table or a view.
  *
  * @param relation - The table or view name to query
  */ from(relation) {
        return this.rest.from(relation);
    }
    /**
  * Select a schema to query or perform an function (rpc) call.
  *
  * The schema needs to be on the list of exposed schemas inside Supabase.
  *
  * @param schema - The schema to query
  */ schema(schema) {
        return this.rest.schema(schema);
    }
    /**
  * Perform a function call.
  *
  * @param fn - The function name to call
  * @param args - The arguments to pass to the function call
  * @param options - Named parameters
  * @param options.head - When set to `true`, `data` will not be returned.
  * Useful if you only need the count.
  * @param options.get - When set to `true`, the function will be called with
  * read-only access mode.
  * @param options.count - Count algorithm to use to count rows returned by the
  * function. Only applicable for [set-returning
  * functions](https://www.postgresql.org/docs/current/functions-srf.html).
  *
  * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
  * hood.
  *
  * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
  * statistics under the hood.
  *
  * `"estimated"`: Uses exact count for low numbers and planned count for high
  * numbers.
  */ rpc(fn, args2 = {}, options = {
        head: false,
        get: false,
        count: void 0
    }) {
        return this.rest.rpc(fn, args2, options);
    }
    /**
  * Creates a Realtime channel with Broadcast, Presence, and Postgres Changes.
  *
  * @param {string} name - The name of the Realtime channel.
  * @param {Object} opts - The options to pass to the Realtime channel.
  *
  */ channel(name, opts = {
        config: {}
    }) {
        return this.realtime.channel(name, opts);
    }
    /**
  * Returns all Realtime channels.
  *
  * @category Initializing
  *
  * @example Get all channels
  * ```js
  * const channels = supabase.getChannels()
  * ```
  */ getChannels() {
        return this.realtime.getChannels();
    }
    /**
  * Unsubscribes and removes Realtime channel from Realtime client.
  *
  * @param {RealtimeChannel} channel - The name of the Realtime channel.
  *
  *
  * @category Initializing
  *
  * @remarks
  * - Removing a channel is a great way to maintain the performance of your project's Realtime service as well as your database if you're listening to Postgres changes. Supabase will automatically handle cleanup 30 seconds after a client is disconnected, but unused channels may cause degradation as more clients are simultaneously subscribed.
  *
  * @example Removes a channel
  * ```js
  * supabase.removeChannel(myChannel)
  * ```
  */ removeChannel(channel) {
        return this.realtime.removeChannel(channel);
    }
    /**
  * Unsubscribes and removes all Realtime channels from Realtime client.
  *
  * @category Initializing
  *
  * @remarks
  * - Removing channels is a great way to maintain the performance of your project's Realtime service as well as your database if you're listening to Postgres changes. Supabase will automatically handle cleanup 30 seconds after a client is disconnected, but unused channels may cause degradation as more clients are simultaneously subscribed.
  *
  * @example Remove all channels
  * ```js
  * supabase.removeAllChannels()
  * ```
  */ removeAllChannels() {
        return this.realtime.removeAllChannels();
    }
    async _getAccessToken() {
        var _this = this;
        var _data$session$access_, _data$session;
        if (_this.accessToken) return await _this.accessToken();
        const { data: data2 } = await _this.auth.getSession();
        return (_data$session$access_ = (_data$session = data2.session) === null || _data$session === void 0 ? void 0 : _data$session.access_token) !== null && _data$session$access_ !== void 0 ? _data$session$access_ : _this.supabaseKey;
    }
    _initSupabaseAuthClient({ autoRefreshToken: autoRefreshToken, persistSession: persistSession, detectSessionInUrl: detectSessionInUrl, storage: storage, userStorage: userStorage, storageKey: storageKey, flowType: flowType, lock: lock, debug: debug, throwOnError: throwOnError, experimental: experimental }, headers, fetch$1) {
        const authHeaders = {
            Authorization: `Bearer ${this.supabaseKey}`,
            apikey: `${this.supabaseKey}`
        };
        return new $281a441cdcb2cf36$var$SupabaseAuthClient({
            url: this.authUrl.href,
            headers: $281a441cdcb2cf36$var$_objectSpread23($281a441cdcb2cf36$var$_objectSpread23({}, authHeaders), headers),
            storageKey: storageKey,
            autoRefreshToken: autoRefreshToken,
            persistSession: persistSession,
            detectSessionInUrl: detectSessionInUrl,
            storage: storage,
            userStorage: userStorage,
            flowType: flowType,
            lock: lock,
            debug: debug,
            throwOnError: throwOnError,
            experimental: experimental,
            fetch: fetch$1,
            hasCustomAuthorizationHeader: Object.keys(this.headers).some((key)=>key.toLowerCase() === "authorization")
        });
    }
    _initRealtimeClient(options) {
        return new $281a441cdcb2cf36$var$RealtimeClient(this.realtimeUrl.href, $281a441cdcb2cf36$var$_objectSpread23($281a441cdcb2cf36$var$_objectSpread23({}, options), {}, {
            params: $281a441cdcb2cf36$var$_objectSpread23($281a441cdcb2cf36$var$_objectSpread23({}, {
                apikey: this.supabaseKey
            }), options === null || options === void 0 ? void 0 : options.params)
        }));
    }
    _listenForAuthEvents() {
        return this.auth.onAuthStateChange((event, session)=>{
            this._handleTokenChanged(event, "CLIENT", session === null || session === void 0 ? void 0 : session.access_token);
        });
    }
    _handleTokenChanged(event, source, token) {
        if ((event === "TOKEN_REFRESHED" || event === "SIGNED_IN") && this.changedAccessToken !== token) {
            this.changedAccessToken = token;
            this.realtime.setAuth(token);
        } else if (event === "SIGNED_OUT") {
            this.realtime.setAuth();
            if (source == "STORAGE") this.auth.signOut();
            this.changedAccessToken = void 0;
        }
    }
};
var $281a441cdcb2cf36$var$createClient = (supabaseUrl, supabaseKey, options)=>{
    return new $281a441cdcb2cf36$var$SupabaseClient(supabaseUrl, supabaseKey, options);
};
function $281a441cdcb2cf36$var$shouldShowDeprecationWarning() {
    if (typeof window !== "undefined") return false;
    const _process = globalThis["process"];
    if (!_process) return false;
    const processVersion = _process["version"];
    if (processVersion === void 0 || processVersion === null) return false;
    const versionMatch = processVersion.match(/^v(\d+)\./);
    if (!versionMatch) return false;
    return parseInt(versionMatch[1], 10) <= 18;
}
if ($281a441cdcb2cf36$var$shouldShowDeprecationWarning()) console.warn("\u26A0\uFE0F  Node.js 18 and below are deprecated and will no longer be supported in future versions of @supabase/supabase-js. Please upgrade to Node.js 20 or later. For more information, visit: https://github.com/orgs/supabase/discussions/37217");
// src/services/supabasePassthrough.js
var $281a441cdcb2cf36$var$_readToken = (storageKey)=>{
    var _a2;
    if (!storageKey || typeof window === "undefined") return null;
    try {
        const raw = window.localStorage.getItem(storageKey);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        return (parsed == null ? void 0 : parsed.access_token) || ((_a2 = parsed == null ? void 0 : parsed.currentSession) == null ? void 0 : _a2.access_token) || null;
    } catch  {
        return null;
    }
};
var $281a441cdcb2cf36$var$_supabaseStorageKey = (rawSupabaseUrl)=>{
    var _a2;
    const ref2 = (_a2 = rawSupabaseUrl == null ? void 0 : rawSupabaseUrl.split("//")[1]) == null ? void 0 : _a2.split(".")[0];
    return ref2 ? `sb-${ref2}-auth-token` : null;
};
var $281a441cdcb2cf36$export$6742174a7b4553dc = (rawSupabaseUrl)=>$281a441cdcb2cf36$var$_readToken($281a441cdcb2cf36$var$_supabaseStorageKey(rawSupabaseUrl));
var $281a441cdcb2cf36$var$_createAdapterClient = ({ url: url2, anonKey: anonKey, rawSupabaseUrl: rawSupabaseUrl, getRealtimeClient: getRealtimeClient })=>{
    const storageKey = $281a441cdcb2cf36$var$_supabaseStorageKey(rawSupabaseUrl);
    const client = $281a441cdcb2cf36$var$createClient(url2, anonKey, {
        auth: {
            persistSession: false,
            autoRefreshToken: false,
            detectSessionInUrl: false,
            // Unique storageKey so this REST-only adapter doesn't share the
            // session bucket with the raw client. supabase-js v2.103+ warns
            // "Multiple GoTrueClient instances detected" when two clients share
            // a storageKey — even with persistSession: false. We forward the
            // user's token via the global.fetch shim, so this bucket is unused.
            storageKey: "_sym_adapter_rest_only_noop"
        },
        realtime: {
            params: {
                eventsPerSecond: 20
            }
        },
        global: {
            // Strip `x-client-info` before sending: supabase-js auto-injects it
            // (sdk version + browser fingerprint) but the wrapper's CORS
            // allow-list doesn't include it, so the OPTIONS preflight fails
            // with "Request header field x-client-info is not allowed by
            // Access-Control-Allow-Headers" and the actual request never goes
            // out. supabase-js v2 always passes init.headers as a POJO, so a
            // shallow clone + delete is sufficient.
            fetch: (input, init = {})=>{
                const headers = {
                    ...init.headers || {}
                };
                const token = $281a441cdcb2cf36$var$_readToken(storageKey);
                if (token) headers.Authorization = `Bearer ${token}`;
                delete headers["x-client-info"];
                delete headers["X-Client-Info"];
                init.headers = headers;
                return fetch(input, init);
            }
        }
    });
    if (typeof getRealtimeClient === "function") try {
        const rawClient = getRealtimeClient();
        if (rawClient == null ? void 0 : rawClient.realtime) client.realtime = rawClient.realtime;
    } catch (err) {
        console.warn("[supabasePassthrough] could not bind raw realtime to adapter client:", err);
    }
    return client;
};
var $281a441cdcb2cf36$export$b4f6e555f7229881 = ({ apiBase: apiBase, rawSupabaseUrl: rawSupabaseUrl, anonKey: anonKey, getRealtimeClient: getRealtimeClient, retry: retry = {
    retry: "3",
    delay: "1000"
} })=>{
    const _resolveBase = ()=>typeof apiBase === "function" ? apiBase() : apiBase;
    const _passthroughUrl = ()=>`${$281a441cdcb2cf36$export$59dd0c3383896351(_resolveBase())}/sb`;
    return {
        adapter: "supabase",
        createClient: (clientUrl, clientKey)=>$281a441cdcb2cf36$var$_createAdapterClient({
                url: clientUrl || _passthroughUrl(),
                anonKey: clientKey || anonKey,
                rawSupabaseUrl: rawSupabaseUrl,
                getRealtimeClient: getRealtimeClient
            }),
        get url () {
            return _passthroughUrl();
        },
        key: anonKey,
        retry: retry
    };
};
var $281a441cdcb2cf36$export$f1b632eb4ee09df9 = (apiBase, name)=>`${$281a441cdcb2cf36$export$59dd0c3383896351(apiBase)}/sb/functions/v1/${name}`;
// src/services/KvService.js
var $281a441cdcb2cf36$var$KvService = class {
    constructor({ context: context2, options: options } = {}){
        this._context = context2 || {};
        this._options = options || {};
        this._kvUrl = null;
        this._ready = false;
    }
    init({ context: context2 }) {
        const ctx = context2 || this._context;
        this._kvUrl = ctx.kvUrl || this._options.kvUrl;
        this._ready = true;
    }
    updateContext(context2) {
        if (context2 && typeof context2 === "object") Object.assign(this._context, context2);
    }
    isReady() {
        return this._ready;
    }
    /**
   * Get a value by key
   * @param {string} key - KV key (e.g. 'luka/xmas')
   * @param {object} opts
   * @param {string} opts.env - Project env: 'development' | 'staging' | 'production'
   * @returns {Promise<{ key, value, metadata }>}
   */ async get(key, { env: env = "production" } = {}) {
        const url2 = `${this._kvUrl}/kv/${encodeURIComponent(key)}?env=${env}`;
        const res = await fetch(url2);
        if (!res.ok) {
            const err = await res.json().catch(()=>({
                    error: res.statusText
                }));
            throw new Error(err.error || `KV GET failed (${res.status})`);
        }
        return res.json();
    }
    /**
   * Set a value by key
   * @param {string} key - KV key
   * @param {*} value - Value to store
   * @param {object} opts
   * @param {string} opts.env - Project env
   * @param {number} opts.expirationTtl - TTL in seconds
   * @param {object} opts.metadata - Optional metadata
   * @returns {Promise<{ ok, key }>}
   */ async put(key, value2, { env: env = "production", expirationTtl: expirationTtl, metadata: metadata } = {}) {
        const url2 = `${this._kvUrl}/kv/${encodeURIComponent(key)}?env=${env}`;
        const body = {
            value: value2
        };
        if (expirationTtl) body.expirationTtl = expirationTtl;
        if (metadata) body.metadata = metadata;
        const res = await fetch(url2, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(body)
        });
        if (!res.ok) {
            const err = await res.json().catch(()=>({
                    error: res.statusText
                }));
            throw new Error(err.error || `KV PUT failed (${res.status})`);
        }
        return res.json();
    }
    /**
   * Delete a key
   * @param {string} key - KV key
   * @param {object} opts
   * @param {string} opts.env - Project env
   * @returns {Promise<{ ok, key }>}
   */ async delete(key, { env: env = "production" } = {}) {
        const url2 = `${this._kvUrl}/kv/${encodeURIComponent(key)}?env=${env}`;
        const res = await fetch(url2, {
            method: "DELETE"
        });
        if (!res.ok) {
            const err = await res.json().catch(()=>({
                    error: res.statusText
                }));
            throw new Error(err.error || `KV DELETE failed (${res.status})`);
        }
        return res.json();
    }
    /**
   * List keys
   * @param {object} opts
   * @param {string} opts.env - Project env
   * @param {string} opts.prefix - Key prefix filter
   * @param {number} opts.limit - Max results
   * @param {string} opts.cursor - Pagination cursor
   * @returns {Promise<{ keys, list_complete, cursor }>}
   */ async list({ env: env = "production", prefix: prefix, limit: limit, cursor: cursor } = {}) {
        const params2 = new URLSearchParams({
            env: env
        });
        if (prefix) params2.set("prefix", prefix);
        if (limit) params2.set("limit", String(limit));
        if (cursor) params2.set("cursor", cursor);
        const url2 = `${this._kvUrl}/kv?${params2}`;
        const res = await fetch(url2);
        if (!res.ok) {
            const err = await res.json().catch(()=>({
                    error: res.statusText
                }));
            throw new Error(err.error || `KV LIST failed (${res.status})`);
        }
        return res.json();
    }
    destroy() {
        this._ready = false;
    }
};
// src/services/AllocationRuleService.js
var $281a441cdcb2cf36$var$AllocationRuleService = class extends $281a441cdcb2cf36$var$BaseService {
    // ==================== ALLOCATION RULES ====================
    async listRules(orgId) {
        this._requireReady("listRules");
        const qs = orgId ? `?organizationId=${encodeURIComponent(orgId)}` : "";
        const response = await this._request(`/allocation-rules${qs}`, {
            method: "GET",
            methodName: "listRules"
        });
        if (response.success) return response.data;
        throw new Error(response.message);
    }
    async getRule(ruleId) {
        this._requireReady("getRule");
        if (!ruleId) throw new Error("ruleId is required");
        const response = await this._request(`/allocation-rules/${ruleId}`, {
            method: "GET",
            methodName: "getRule"
        });
        if (response.success) return response.data;
        throw new Error(response.message);
    }
    async createRule({ organizationId: organizationId, workspaceId: workspaceId, policy: policy, monthlyAllocation: monthlyAllocation, priority: priority }) {
        this._requireReady("createRule");
        if (!organizationId) throw new Error("organizationId is required");
        const response = await this._request("/allocation-rules", {
            method: "POST",
            body: JSON.stringify({
                organizationId: organizationId,
                workspaceId: workspaceId,
                policy: policy,
                monthlyAllocation: monthlyAllocation,
                priority: priority
            }),
            methodName: "createRule"
        });
        if (response.success) return response.data;
        throw new Error(response.message);
    }
    async updateRule(ruleId, patch) {
        this._requireReady("updateRule");
        if (!ruleId) throw new Error("ruleId is required");
        const response = await this._request(`/allocation-rules/${ruleId}`, {
            method: "PATCH",
            body: JSON.stringify(patch || {}),
            methodName: "updateRule"
        });
        if (response.success) return response.data;
        throw new Error(response.message);
    }
    async deleteRule(ruleId) {
        this._requireReady("deleteRule");
        if (!ruleId) throw new Error("ruleId is required");
        const response = await this._request(`/allocation-rules/${ruleId}`, {
            method: "DELETE",
            methodName: "deleteRule"
        });
        if (response.success) return response.data;
        throw new Error(response.message);
    }
};
// src/services/SharedAssetService.js
var $281a441cdcb2cf36$var$SharedAssetService = class extends $281a441cdcb2cf36$var$BaseService {
    // ==================== SHARED ASSETS ====================
    async createAsset(body) {
        this._requireReady("createAsset");
        if (!body || typeof body !== "object") throw new Error("Asset body is required");
        const response = await this._request("/shared-assets", {
            method: "POST",
            body: JSON.stringify(body),
            methodName: "createAsset"
        });
        if (response.success) return response.data;
        throw new Error(response.message);
    }
    async listAssets(query = {}) {
        this._requireReady("listAssets");
        const queryParams = new URLSearchParams();
        for (const [k3, v3] of Object.entries(query || {}))if (v3 !== void 0 && v3 !== null && v3 !== "") queryParams.append(k3, String(v3));
        const queryString = queryParams.toString();
        const response = queryString ? await this._request(`/shared-assets?${queryString}`, {
            method: "GET",
            methodName: "listAssets"
        }) : await this._request("/shared-assets", {
            method: "GET",
            methodName: "listAssets"
        });
        if (response.success) return response.data;
        throw new Error(response.message);
    }
    async getAsset(id2) {
        this._requireReady("getAsset");
        if (!id2) throw new Error("id is required");
        const response = await this._request(`/shared-assets/${id2}`, {
            method: "GET",
            methodName: "getAsset"
        });
        if (response.success) return response.data;
        throw new Error(response.message);
    }
    async updateAsset(id2, patch) {
        this._requireReady("updateAsset");
        if (!id2) throw new Error("id is required");
        const response = await this._request(`/shared-assets/${id2}`, {
            method: "PATCH",
            body: JSON.stringify(patch || {}),
            methodName: "updateAsset"
        });
        if (response.success) return response.data;
        throw new Error(response.message);
    }
    async deleteAsset(id2) {
        this._requireReady("deleteAsset");
        if (!id2) throw new Error("id is required");
        const response = await this._request(`/shared-assets/${id2}`, {
            method: "DELETE",
            methodName: "deleteAsset"
        });
        if (response.success) return response.data;
        throw new Error(response.message);
    }
};
// src/services/CreditsService.js
var $281a441cdcb2cf36$var$CreditsService = class extends $281a441cdcb2cf36$var$BaseService {
    /**
   * Public credit rate card. No auth required. Mirrors what the server
   * bills internally: retail USD per credit, topup pack size, tier
   * definitions, model multipliers, infra / comms / governance rates.
   * @returns {Promise<object>}
   */ async getRates() {
        return this._call("getRates", "/credits/rates");
    }
    /**
   * Current credit balance for a project. Includes tier + plan
   * metadata the server folds in from the workspace subscription.
   * Editor / admin / owner only on the server.
   * @param {string} projectId
   * @returns {Promise<{available: number, reserved?: number, tier: string, ...}>}
   */ async getProjectBalance(projectId) {
        if (!projectId) throw new Error("projectId is required");
        return this._call("getProjectBalance", `/projects/${projectId}/credits/balance`);
    }
    /**
   * Paginated credit ledger for a project. Use `cursor` (the last
   * ledger row's `_id`) to fetch the next page; `limit` caps at 500
   * server-side. Admin / owner only.
   * @param {string} projectId
   * @param {{limit?: number, cursor?: string, reason?: string}} [options]
   * @returns {Promise<{items: Array<object>, nextCursor?: string}>}
   */ async getProjectLedger(projectId, { limit: limit, cursor: cursor, reason: reason } = {}) {
        this._requireReady("getProjectLedger");
        if (!projectId) throw new Error("projectId is required");
        const qs = new URLSearchParams();
        if (limit != null) qs.append("limit", String(limit));
        if (cursor) qs.append("cursor", cursor);
        if (reason) qs.append("reason", reason);
        const queryString = qs.toString();
        const response = queryString ? await this._request(`/projects/${projectId}/credits/ledger?${queryString}`, {
            method: "GET",
            methodName: "getProjectLedger"
        }) : await this._request(`/projects/${projectId}/credits/ledger`, {
            method: "GET",
            methodName: "getProjectLedger"
        });
        if (response == null ? void 0 : response.success) return response.data;
        return {
            items: []
        };
    }
    /**
   * Read a project's spend-control config. Returns null if none set.
   * Admin / owner only.
   * @param {string} projectId
   * @returns {Promise<object | null>}
   */ async getProjectSpendControls(projectId) {
        if (!projectId) throw new Error("projectId is required");
        return this._call("getProjectSpendControls", `/projects/${projectId}/credits/controls`);
    }
    /**
   * Upsert a project's spend-control config. Pass only the fields that
   * should change — undefined fields are preserved server-side. Admin /
   * owner only.
   * @param {string} projectId
   * @param {{hardCap?: number, categoryCaps?: object, alerts?: object, autoRecharge?: object}} controls
   * @returns {Promise<object>}
   */ async updateProjectSpendControls(projectId, controls = {}) {
        if (!projectId) throw new Error("projectId is required");
        return this._call("updateProjectSpendControls", `/projects/${projectId}/credits/controls`, {
            method: "PUT",
            body: controls
        });
    }
    /**
   * Top up a project's credit balance via a Stripe checkout session.
   * Returns the checkout URL for the caller to redirect to. Admin /
   * owner only.
   * @param {string} projectId
   * @param {{packs?: number, returnUrl?: string}} [args] - packs defaults to 1
   * @returns {Promise<{checkoutUrl: string, sessionId: string}>}
   */ async topupProjectCredits(projectId, { packs: packs = 1, returnUrl: returnUrl } = {}) {
        if (!projectId) throw new Error("projectId is required");
        return this._call("topupProjectCredits", `/projects/${projectId}/credits/topup`, {
            method: "POST",
            body: {
                packs: packs,
                ...returnUrl ? {
                    returnUrl: returnUrl
                } : {}
            }
        });
    }
};
// src/services/index.js
var $281a441cdcb2cf36$var$createService = (ServiceClass, config)=>new ServiceClass(config);
var $281a441cdcb2cf36$export$8f30b9a05eb146a5 = (config)=>$281a441cdcb2cf36$var$createService($281a441cdcb2cf36$var$AuthService, config);
var $281a441cdcb2cf36$export$691774002b31f671 = (config)=>$281a441cdcb2cf36$var$createService($281a441cdcb2cf36$var$CollabService, config);
var $281a441cdcb2cf36$export$d2db3a7443ba9beb = (config)=>$281a441cdcb2cf36$var$createService($281a441cdcb2cf36$var$ProjectService, config);
var $281a441cdcb2cf36$export$f0b1369ebf33366b = (config)=>$281a441cdcb2cf36$var$createService($281a441cdcb2cf36$var$PlanService, config);
var $281a441cdcb2cf36$export$679dc0611cbaf435 = (config)=>$281a441cdcb2cf36$var$createService($281a441cdcb2cf36$var$SubscriptionService, config);
var $281a441cdcb2cf36$export$4064f974fd81a6bd = (config)=>$281a441cdcb2cf36$var$createService($281a441cdcb2cf36$var$FileService, config);
var $281a441cdcb2cf36$export$431e60f339189fc2 = (config)=>$281a441cdcb2cf36$var$createService($281a441cdcb2cf36$var$PaymentService, config);
var $281a441cdcb2cf36$export$e6d31e0575ba2870 = (config)=>$281a441cdcb2cf36$var$createService($281a441cdcb2cf36$var$DnsService, config);
var $281a441cdcb2cf36$export$8cd6113019ef923a = (config)=>$281a441cdcb2cf36$var$createService($281a441cdcb2cf36$var$BranchService, config);
var $281a441cdcb2cf36$export$7a55342272230f5c = (config)=>$281a441cdcb2cf36$var$createService($281a441cdcb2cf36$var$PullRequestService, config);
var $281a441cdcb2cf36$export$43743e06143bac7e = (config)=>$281a441cdcb2cf36$var$createService($281a441cdcb2cf36$var$AdminService, config);
var $281a441cdcb2cf36$var$createScreenshotService = (config)=>$281a441cdcb2cf36$var$createService($281a441cdcb2cf36$var$ScreenshotService, config);
var $281a441cdcb2cf36$export$e6575b0c70a26da5 = (config)=>$281a441cdcb2cf36$var$createService($281a441cdcb2cf36$var$TrackingService, config);
var $281a441cdcb2cf36$export$ead6d97b2fb25b5f = (config)=>$281a441cdcb2cf36$var$createService($281a441cdcb2cf36$var$WaitlistService, config);
var $281a441cdcb2cf36$export$3f15454bfb4240bb = (config)=>$281a441cdcb2cf36$var$createService($281a441cdcb2cf36$var$MetricsService, config);
var $281a441cdcb2cf36$export$6e7d2c03a2cb2554 = (config)=>$281a441cdcb2cf36$var$createService($281a441cdcb2cf36$var$IntegrationService, config);
var $281a441cdcb2cf36$export$bd53689910224e3 = (config)=>$281a441cdcb2cf36$var$createService($281a441cdcb2cf36$var$FeatureFlagService, config);
var $281a441cdcb2cf36$export$94bb759057b63067 = (config)=>$281a441cdcb2cf36$var$createService($281a441cdcb2cf36$var$OrganizationService, config);
var $281a441cdcb2cf36$export$bb7722ac44faca6f = (config)=>$281a441cdcb2cf36$var$createService($281a441cdcb2cf36$var$WorkspaceService, config);
var $281a441cdcb2cf36$export$fa3fda96a7de1da5 = (config)=>$281a441cdcb2cf36$var$createService($281a441cdcb2cf36$var$WorkspaceDataService, config);
var $281a441cdcb2cf36$export$d3d85d4bc39b8ae2 = (config)=>$281a441cdcb2cf36$var$createService($281a441cdcb2cf36$var$KvService, config);
var $281a441cdcb2cf36$export$8ff68545e204df5f = (config)=>$281a441cdcb2cf36$var$createService($281a441cdcb2cf36$var$AllocationRuleService, config);
var $281a441cdcb2cf36$export$545998207dbe2dbd = (config)=>$281a441cdcb2cf36$var$createService($281a441cdcb2cf36$var$SharedAssetService, config);
var $281a441cdcb2cf36$export$af05bc79f915caf2 = (config)=>$281a441cdcb2cf36$var$createService($281a441cdcb2cf36$var$CreditsService, config);
// src/utils/services.js
var $281a441cdcb2cf36$var$SERVICE_METHODS = {
    hasPermission: "auth",
    hasGlobalPermission: "auth",
    // Collab service methods
    connect: "collab",
    disconnect: "collab",
    isConnected: "collab",
    updateData: "collab",
    addItem: "collab",
    addMultipleItems: "collab",
    updateItem: "collab",
    deleteItem: "collab",
    undo: "collab",
    redo: "collab",
    checkpoint: "collab",
    // Realtime collaboration helper methods
    sendCursor: "collab",
    sendPresence: "collab",
    toggleLive: "collab",
    // Core service methods (new - replaces most based/auth functionality)
    // Auth methods
    getStoredAuthState: "auth",
    getAuthToken: "auth",
    register: "auth",
    login: "auth",
    logout: "auth",
    refreshToken: "auth",
    googleAuth: "auth",
    googleAuthCallback: "auth",
    githubAuth: "auth",
    requestPasswordReset: "auth",
    confirmPasswordReset: "auth",
    confirmRegistration: "auth",
    requestPasswordChange: "auth",
    confirmPasswordChange: "auth",
    getMe: "auth",
    updateMe: "auth",
    getPermissions: "auth",
    getSession: "auth",
    onAuthStateChange: "auth",
    getTokenDebugInfo: "auth",
    getMyProjectRoleByKey: "auth",
    getProjectRoleWithFallback: "auth",
    getProjectRoleByKeyWithFallback: "auth",
    // Cross-org notifications + projects + memberships (NEEDED_FOR_INTRANET §I8/§I9/§I10)
    getMyOrgNotifications: "auth",
    getMyFreebusy: "auth",
    getMyProjects: "auth",
    getMyTeams: "auth",
    getMyOrgMemberships: "auth",
    getOrgMemberRoles: "auth",
    resendVerification: "auth",
    verifyEmail: "auth",
    // User methods
    getUserProfile: "auth",
    updateUserProfile: "auth",
    getUserProjects: "auth",
    getUser: "auth",
    getUserByEmail: "auth",
    // Project methods (moved to project service)
    createProject: "project",
    getProjects: "project",
    getProject: "project",
    getProjectByKey: "project",
    getProjectDataByKey: "project",
    getPublicProjectDataByKey: "project",
    getPublicProject: "project",
    listPublicProjects: "project",
    listProjects: "project",
    updateProject: "project",
    updateProjectComponents: "project",
    updateProjectSettings: "project",
    updateProjectName: "project",
    updateProjectPackage: "project",
    duplicateProject: "project",
    removeProject: "project",
    transferProjectOwnership: "project",
    checkProjectKeyAvailability: "project",
    getProjectRolePermissionsConfig: "project",
    updateProjectRolePermissionsConfig: "project",
    listEnvironments: "project",
    upsertEnvironment: "project",
    updateEnvironment: "project",
    publishToEnvironment: "project",
    deleteEnvironment: "project",
    promoteEnvironment: "project",
    // Project member methods (moved to project service)
    getProjectMembers: "project",
    inviteMember: "project",
    acceptInvite: "project",
    createMagicInviteLink: "project",
    updateMemberRole: "project",
    removeMember: "project",
    // Project library methods (moved to project service)
    getAvailableLibraries: "project",
    getProjectLibraries: "project",
    addProjectLibraries: "project",
    removeProjectLibraries: "project",
    // Project data methods (moved to project service)
    applyProjectChanges: "project",
    getProjectData: "project",
    getProjectVersions: "project",
    restoreProjectVersion: "project",
    updateProjectItem: "project",
    deleteProjectItem: "project",
    setProjectValue: "project",
    addProjectItems: "project",
    getProjectItemByPath: "project",
    setProjectAccess: "project",
    setProjectVisibility: "project",
    // Favorite project methods (moved to project service)
    getFavoriteProjects: "project",
    addFavoriteProject: "project",
    removeFavoriteProject: "project",
    // Recent project methods (moved to project service)
    getRecentProjects: "project",
    // Plan methods (moved to plan service)
    getPlans: "plan",
    getPlan: "plan",
    getAdminPlans: "plan",
    createPlan: "plan",
    updatePlan: "plan",
    deletePlan: "plan",
    initializePlans: "plan",
    getPlansWithValidation: "plan",
    getPlanWithValidation: "plan",
    createPlanWithValidation: "plan",
    updatePlanWithValidation: "plan",
    getActivePlans: "plan",
    getPlansByPriceRange: "plan",
    getPlanByKey: "plan",
    getPlansWithPricing: "plan",
    // Subscription methods (moved to subscription service)
    createSubscription: "subscription",
    getProjectStatus: "subscription",
    getUsage: "subscription",
    cancelSubscription: "subscription",
    listInvoices: "subscription",
    getPortalUrl: "subscription",
    createSubscriptionWithValidation: "subscription",
    hasActiveSubscription: "subscription",
    getProjectSubscription: "subscription",
    getProjectUsage: "subscription",
    getInvoicesWithPagination: "subscription",
    isSubscriptionActive: "subscription",
    getSubscriptionLimits: "subscription",
    changeSubscription: "subscription",
    downgrade: "subscription",
    changeSubscriptionWithValidation: "subscription",
    downgradeWithValidation: "subscription",
    // File methods (moved to file service)
    uploadFile: "file",
    updateProjectIcon: "file",
    uploadFileWithValidation: "file",
    uploadImage: "file",
    uploadDocument: "file",
    getFileUrl: "file",
    validateFile: "file",
    createFileFormData: "file",
    uploadMultipleFiles: "file",
    // Payment methods (Use subscription service instead)
    checkout: "payment",
    getSubscriptionStatus: "payment",
    checkoutWithValidation: "payment",
    getSubscriptionStatusWithValidation: "payment",
    getSubscriptionDetails: "payment",
    checkoutForPlan: "payment",
    checkoutForTeam: "payment",
    validateSubscriptionStatus: "payment",
    formatSubscriptionAmount: "payment",
    getSubscriptionSummary: "payment",
    // DNS methods (moved to dns service)
    createDnsRecord: "dns",
    getDnsRecord: "dns",
    removeDnsRecord: "dns",
    getCustomHost: "dns",
    addProjectCustomDomains: "dns",
    validateDomain: "dns",
    createDnsRecordWithValidation: "dns",
    getDnsRecordWithValidation: "dns",
    removeDnsRecordWithValidation: "dns",
    addProjectCustomDomainsWithValidation: "dns",
    isDomainAvailable: "dns",
    getDomainStatus: "dns",
    verifyDomainOwnership: "dns",
    getProjectDomains: "dns",
    removeProjectCustomDomain: "dns",
    formatDomain: "dns",
    extractDomainFromUrl: "dns",
    // Branch Management methods (moved to branch service)
    listBranches: "branch",
    createBranch: "branch",
    deleteBranch: "branch",
    renameBranch: "branch",
    getBranchChanges: "branch",
    mergeBranch: "branch",
    resetBranch: "branch",
    publishVersion: "branch",
    createBranchWithValidation: "branch",
    branchExists: "branch",
    previewMerge: "branch",
    commitMerge: "branch",
    createFeatureBranch: "branch",
    createHotfixBranch: "branch",
    getBranchStatus: "branch",
    deleteBranchSafely: "branch",
    getBranchesWithStatus: "branch",
    validateBranchName: "branch",
    sanitizeBranchName: "branch",
    // Pull Request methods (moved to pullRequest service)
    createPullRequest: "pullRequest",
    listPullRequests: "pullRequest",
    getPullRequest: "pullRequest",
    reviewPullRequest: "pullRequest",
    addPullRequestComment: "pullRequest",
    mergePullRequest: "pullRequest",
    getPullRequestDiff: "pullRequest",
    createPullRequestWithValidation: "pullRequest",
    approvePullRequest: "pullRequest",
    requestPullRequestChanges: "pullRequest",
    getOpenPullRequests: "pullRequest",
    getClosedPullRequests: "pullRequest",
    getMergedPullRequests: "pullRequest",
    isPullRequestMergeable: "pullRequest",
    getPullRequestStatusSummary: "pullRequest",
    validatePullRequestData: "pullRequest",
    validateReviewData: "pullRequest",
    getPullRequestStats: "pullRequest",
    closePullRequest: "pullRequest",
    reopenPullRequest: "pullRequest",
    // Admin methods (moved to admin service)
    getAdminUsers: "admin",
    assignProjectsToUser: "admin",
    updateUser: "admin",
    searchAdminUsers: "admin",
    getAdminUsersByEmails: "admin",
    getAdminUsersByIds: "admin",
    assignSpecificProjectsToUser: "admin",
    assignAllProjectsToUser: "admin",
    validateUserData: "admin",
    updateUserWithValidation: "admin",
    getUserStats: "admin",
    bulkUpdateUsers: "admin",
    getUsersByRole: "admin",
    getUsersByStatus: "admin",
    activateUser: "admin",
    deactivateUser: "admin",
    suspendUser: "admin",
    promoteToAdmin: "admin",
    demoteFromAdmin: "admin",
    // Screenshot methods
    createScreenshotProject: "screenshot",
    getProjectScreenshots: "screenshot",
    reprocessProjectScreenshots: "screenshot",
    recreateProjectScreenshots: "screenshot",
    deleteProjectScreenshots: "screenshot",
    getThumbnailCandidate: "screenshot",
    updateProjectThumbnail: "screenshot",
    getPageScreenshot: "screenshot",
    getComponentScreenshot: "screenshot",
    getScreenshotByKey: "screenshot",
    getQueueStatistics: "screenshot",
    refreshThumbnail: "screenshot",
    // Tracking methods
    configureTracking: "tracking",
    trackEvent: "tracking",
    trackError: "tracking",
    captureException: "tracking",
    logMessage: "tracking",
    logDebug: "tracking",
    logInfo: "tracking",
    logWarning: "tracking",
    logWarn: "tracking",
    logErrorMessage: "tracking",
    logError: "tracking",
    addBreadcrumb: "tracking",
    trackMeasurement: "tracking",
    trackView: "tracking",
    setUser: "tracking",
    clearUser: "tracking",
    setSession: "tracking",
    clearSession: "tracking",
    setGlobalAttributes: "tracking",
    setGlobalAttribute: "tracking",
    removeGlobalAttribute: "tracking",
    flushQueue: "tracking",
    getClient: "tracking",
    isEnabled: "tracking",
    isInitialized: "tracking",
    // Waitlist methods
    joinWaitlist: "waitlist",
    listWaitlistEntries: "waitlist",
    updateWaitlistEntry: "waitlist",
    inviteWaitlistEntry: "waitlist",
    // Metrics methods
    getContributions: "metrics",
    // Integration methods
    integrationWhoami: "integration",
    listIntegrations: "integration",
    createIntegration: "integration",
    updateIntegration: "integration",
    createIntegrationApiKey: "integration",
    listIntegrationApiKeys: "integration",
    revokeIntegrationApiKey: "integration",
    createIntegrationWebhook: "integration",
    listIntegrationWebhooks: "integration",
    updateIntegrationWebhook: "integration",
    deleteIntegrationWebhook: "integration",
    listIntegrationWebhookDeliveries: "integration",
    replayIntegrationWebhookDelivery: "integration",
    listGitHubConnectors: "integration",
    createGitHubConnector: "integration",
    updateGitHubConnector: "integration",
    deleteGitHubConnector: "integration",
    // Feature flag methods (system-level + experiments)
    getFeatureFlags: "featureFlag",
    getFeatureFlag: "featureFlag",
    getAdminFeatureFlags: "featureFlag",
    createFeatureFlag: "featureFlag",
    updateFeatureFlag: "featureFlag",
    archiveFeatureFlag: "featureFlag",
    // Organization methods
    createOrganization: "organization",
    listOrganizations: "organization",
    checkOrganizationSlug: "organization",
    getOrganization: "organization",
    updateOrganization: "organization",
    transferOrgOwnership: "organization",
    deleteOrganization: "organization",
    listOrgMembers: "organization",
    addOrgMember: "organization",
    updateOrgMember: "organization",
    removeOrgMember: "organization",
    createTeam: "organization",
    listTeams: "organization",
    updateTeam: "organization",
    deleteTeam: "organization",
    listTeamMembers: "organization",
    addTeamMember: "organization",
    updateTeamMember: "organization",
    removeTeamMember: "organization",
    createOrgInvitation: "organization",
    listOrgInvitations: "organization",
    revokeOrgInvitation: "organization",
    acceptOrgInvitation: "organization",
    // Team-scoped invitations (Phase B). `inviteToTeam` aliases
    // `createTeamInvitation` so DOMQL call sites read clearly.
    listTeamInvitations: "organization",
    createTeamInvitation: "organization",
    inviteToTeam: "organization",
    revokeTeamInvitation: "organization",
    acceptTeamInvitation: "organization",
    getOrgProjectPermissions: "organization",
    updateOrgProjectPermissions: "organization",
    listTeamAccess: "organization",
    grantTeamAccess: "organization",
    updateTeamAccess: "organization",
    revokeTeamAccess: "organization",
    createOrgProject: "organization",
    adminListOrganizations: "organization",
    getCreditPool: "organization",
    updateCreditPool: "organization",
    getSso: "organization",
    updateSso: "organization",
    getScim: "organization",
    updateScim: "organization",
    createWorkspace: "workspace",
    listWorkspaces: "workspace",
    getWorkspace: "workspace",
    updateWorkspace: "workspace",
    deleteWorkspace: "workspace",
    listWorkspaceMembers: "workspace",
    addWorkspaceMember: "workspace",
    updateWorkspaceMemberRole: "workspace",
    removeWorkspaceMember: "workspace",
    grantWorkspaceTeamAccess: "workspace",
    revokeWorkspaceTeamAccess: "workspace",
    getBilling: "workspace",
    getCreditBalance: "workspace",
    getCreditLedger: "workspace",
    getSpendControls: "workspace",
    updateSpendControls: "workspace",
    setProjectSourceAccess: "project",
    // Project workspace transfer
    transferProjectToWorkspace: "project",
    // Admin rate-limit stats
    getRateLimitStats: "admin",
    // Allocation rules
    listRules: "allocationRule",
    getRule: "allocationRule",
    createRule: "allocationRule",
    updateRule: "allocationRule",
    deleteRule: "allocationRule",
    // Shared assets
    createAsset: "sharedAsset",
    listAssets: "sharedAsset",
    getAsset: "sharedAsset",
    updateAsset: "sharedAsset",
    deleteAsset: "sharedAsset"
};
// src/services/EntityDispatcher.js
var $281a441cdcb2cf36$var$argMaps = {
    // (filter, options) for list — splits the adapter's params/options bag.
    filterOptions: (a3)=>{
        var _a2;
        return [
            (_a2 = a3 == null ? void 0 : a3.filter) != null ? _a2 : a3 == null ? void 0 : a3.params,
            {
                single: a3 == null ? void 0 : a3.single,
                limit: a3 == null ? void 0 : a3.limit,
                offset: a3 == null ? void 0 : a3.offset,
                order: a3 == null ? void 0 : a3.order,
                ...(a3 == null ? void 0 : a3.options) || {}
            }
        ];
    },
    // (id) for get/remove — accepts id, number, or the bare arg.
    id: (a3)=>{
        var _a2, _b;
        return [
            (_b = (_a2 = a3 == null ? void 0 : a3.id) != null ? _a2 : a3 == null ? void 0 : a3.number) != null ? _b : a3
        ];
    },
    // (payload) for create — payload may live under .payload, .data, or be the bare arg.
    payload: (a3)=>{
        var _a2, _b;
        return [
            (_b = (_a2 = a3 == null ? void 0 : a3.payload) != null ? _a2 : a3 == null ? void 0 : a3.data) != null ? _b : a3
        ];
    },
    // (id, payload) for update — id pulled like .id helper, payload like .payload helper.
    idPayload: (a3)=>{
        var _a2, _b, _c;
        return [
            (_a2 = a3 == null ? void 0 : a3.id) != null ? _a2 : a3 == null ? void 0 : a3.number,
            (_c = (_b = a3 == null ? void 0 : a3.payload) != null ? _b : a3 == null ? void 0 : a3.data) != null ? _c : (()=>{
                const { id: id2, number: number, ...rest } = a3 || {};
                return rest;
            })()
        ];
    }
};
var $281a441cdcb2cf36$var$CRUD_ARG_MAP = {
    list: $281a441cdcb2cf36$var$argMaps.filterOptions,
    get: $281a441cdcb2cf36$var$argMaps.id,
    create: $281a441cdcb2cf36$var$argMaps.payload,
    update: $281a441cdcb2cf36$var$argMaps.idPayload,
    remove: $281a441cdcb2cf36$var$argMaps.id
};
var $281a441cdcb2cf36$var$ENTITY_ROUTES = {
    // ─── i18n (translations stream) ────────────────────────────────────────────
    // The TranslationWatcher in workspace/app.js subscribes to live translation
    // diffs. Backend i18n stream hasn't shipped — for now this route is a noop
    // subscribe that returns an unsub function so the fetch plugin doesn't
    // throw "Unknown entity". When the backend i18n service ships, swap the
    // body inside WorkspaceProjectService.i18n.subscribeTranslations to dispatch
    // through the live wire and consumers light up automatically.
    "i18n.translations": {
        service: "workspaceProject",
        methods: {
            subscribe: "i18n.subscribeTranslations"
        },
        argMap: {
            subscribe: (a3)=>{
                var _a2, _b, _c, _d;
                return [
                    {
                        lang: (_b = a3 == null ? void 0 : a3.lang) != null ? _b : (_a2 = a3 == null ? void 0 : a3.filter) == null ? void 0 : _a2.lang,
                        namespace: (_d = a3 == null ? void 0 : a3.namespace) != null ? _d : (_c = a3 == null ? void 0 : a3.filter) == null ? void 0 : _c.namespace
                    }
                ];
            }
        }
    },
    // ─── Auth + identity ───────────────────────────────────────────────────────
    "auth.session": {
        service: "auth",
        methods: {
            list: "getSession",
            subscribe: "onAuthStateChange"
        }
    },
    "auth.me": {
        service: "auth",
        methods: {
            list: "getMe",
            get: "getMe",
            update: "updateMe"
        }
    },
    "auth.permissions": {
        service: "auth",
        methods: {
            list: "getPermissions"
        }
    },
    // ─── Organization (top-level tenant) ──────────────────────────────────────
    "organization": {
        service: "organization",
        methods: {
            list: "list",
            get: "get",
            create: "create",
            update: "update",
            remove: "remove"
        }
    },
    "organization.members": {
        service: "organization",
        methods: {
            list: "listMembers",
            create: "inviteMember",
            remove: "removeMember"
        }
    },
    "organization.roles": {
        service: "organization",
        methods: {
            list: "listRoles"
        }
    },
    // ─── Workspace (build environment / pricing tier) ─────────────────────────
    "workspace": {
        service: "workspace",
        methods: {
            list: "listWorkspaces",
            get: "getWorkspace",
            create: "createWorkspace",
            update: "updateWorkspace",
            remove: "deleteWorkspace"
        }
    },
    "workspace.members": {
        service: "workspace",
        methods: {
            list: "listWorkspaceMembers",
            create: "addWorkspaceMember"
        }
    },
    // ─── Workspace Project (activity — tickets, chat, calendar, etc.) ─────────
    // Each workspaceProject service method takes positional args
    // (filter, options) / (id) / (id, payload) etc., so every route below
    // gets a CRUD argMap so sdk.execute() can fan adapter args out correctly.
    "workspaceProject.tickets": {
        service: "workspaceProject",
        methods: {
            list: "tickets.list",
            get: "tickets.get",
            create: "tickets.create",
            update: "tickets.update",
            remove: "tickets.remove",
            // tickets.assign(id, assigneeEmail) — separate op so callers can
            // route through sdk.execute('workspaceProject.tickets', 'assign',
            // { id, assignee }) instead of importing the service directly.
            assign: "tickets.assign",
            epicCounts: "tickets.epicCounts"
        },
        argMap: {
            ...$281a441cdcb2cf36$var$CRUD_ARG_MAP,
            assign: (a3)=>{
                var _a2, _b;
                return [
                    (_a2 = a3 == null ? void 0 : a3.id) != null ? _a2 : a3 == null ? void 0 : a3.number,
                    (_b = a3 == null ? void 0 : a3.assignee) != null ? _b : a3 == null ? void 0 : a3.email
                ];
            },
            epicCounts: ()=>[]
        }
    },
    "workspaceProject.chat": {
        service: "workspaceProject",
        methods: {
            list: "chat.listChannels",
            create: "chat.createChannel",
            update: "chat.updateChannel",
            remove: "chat.removeChannel"
        },
        argMap: {
            list: ()=>[],
            create: $281a441cdcb2cf36$var$argMaps.payload,
            update: $281a441cdcb2cf36$var$argMaps.idPayload,
            remove: $281a441cdcb2cf36$var$argMaps.id
        }
    },
    "workspaceProject.chat.members": {
        service: "workspaceProject",
        methods: {
            // listMembers(channelId?) — undefined channelId routes to bulk GET /chat/members
            list: "chat.listMembers",
            create: "chat.addMember",
            update: "chat.updateMember",
            remove: "chat.removeMember",
            markRead: "chat.markRead",
            mute: "chat.muteChannel"
        },
        argMap: {
            // Pass channelId (possibly undefined) — service routes to bulk or per-channel
            list: (a3)=>{
                var _a2, _b;
                return [
                    (_b = a3 == null ? void 0 : a3.channelId) != null ? _b : (_a2 = a3 == null ? void 0 : a3.filter) == null ? void 0 : _a2.channelId
                ];
            },
            create: (a3)=>{
                var _a2;
                return [
                    a3 == null ? void 0 : a3.channelId,
                    (_a2 = a3 == null ? void 0 : a3.payload) != null ? _a2 : {
                        user_id: a3 == null ? void 0 : a3.userId,
                        role: a3 == null ? void 0 : a3.role
                    }
                ];
            },
            update: (a3)=>{
                var _a2, _b;
                return [
                    a3 == null ? void 0 : a3.channelId,
                    a3 == null ? void 0 : a3.userId,
                    (_b = (_a2 = a3 == null ? void 0 : a3.payload) != null ? _a2 : a3 == null ? void 0 : a3.data) != null ? _b : a3
                ];
            },
            remove: (a3)=>[
                    a3 == null ? void 0 : a3.channelId,
                    a3 == null ? void 0 : a3.userId
                ],
            markRead: (a3)=>{
                var _a2;
                return [
                    a3 == null ? void 0 : a3.channelId,
                    a3 == null ? void 0 : a3.userId,
                    (_a2 = a3 == null ? void 0 : a3.lastReadAt) != null ? _a2 : /* @__PURE__ */ new Date().toISOString()
                ];
            },
            mute: (a3)=>[
                    a3 == null ? void 0 : a3.channelId,
                    a3 == null ? void 0 : a3.userId,
                    a3 == null ? void 0 : a3.muted
                ]
        }
    },
    "workspaceProject.chat.messages": {
        service: "workspaceProject",
        methods: {
            // listMessages(channelId?, options?) — undefined channelId routes to bulk GET /chat/messages
            list: "chat.listMessages",
            create: "chat.sendMessage",
            update: "chat.updateMessage",
            remove: "chat.removeMessage",
            react: "chat.toggleReaction"
        },
        argMap: {
            // Pass channelId (possibly undefined) — service routes to bulk or per-channel
            list: (a3)=>{
                var _a2, _b, _c, _d;
                return [
                    (_d = (_b = a3 == null ? void 0 : a3.channelId) != null ? _b : (_a2 = a3 == null ? void 0 : a3.filter) == null ? void 0 : _a2.channelId) != null ? _d : (_c = a3 == null ? void 0 : a3.params) == null ? void 0 : _c.channelId,
                    {
                        single: a3 == null ? void 0 : a3.single,
                        limit: a3 == null ? void 0 : a3.limit,
                        offset: a3 == null ? void 0 : a3.offset,
                        order: a3 == null ? void 0 : a3.order,
                        ...(a3 == null ? void 0 : a3.options) || {}
                    }
                ];
            },
            create: (a3)=>{
                var _a2, _b, _c, _d;
                return [
                    (_b = a3 == null ? void 0 : a3.channelId) != null ? _b : (_a2 = a3 == null ? void 0 : a3.filter) == null ? void 0 : _a2.channelId,
                    (_d = (_c = a3 == null ? void 0 : a3.payload) != null ? _c : a3 == null ? void 0 : a3.data) != null ? _d : (()=>{
                        const { channelId: channelId, filter: filter, options: options, ...rest } = a3 || {};
                        return rest;
                    })()
                ];
            },
            update: (a3)=>{
                var _a2, _b, _c;
                return [
                    (_a2 = a3 == null ? void 0 : a3.messageId) != null ? _a2 : a3 == null ? void 0 : a3.id,
                    (_c = (_b = a3 == null ? void 0 : a3.payload) != null ? _b : a3 == null ? void 0 : a3.data) != null ? _c : a3
                ];
            },
            remove: (a3)=>{
                var _a2;
                return [
                    (_a2 = a3 == null ? void 0 : a3.messageId) != null ? _a2 : a3 == null ? void 0 : a3.id
                ];
            },
            react: (a3)=>{
                var _a2;
                return [
                    (_a2 = a3 == null ? void 0 : a3.messageId) != null ? _a2 : a3 == null ? void 0 : a3.id,
                    a3 == null ? void 0 : a3.emoji,
                    a3 == null ? void 0 : a3.userId
                ];
            }
        }
    },
    "workspaceProject.chat.mentions": {
        service: "workspaceProject",
        methods: {
            list: "chat.listMentions",
            // markRead — chat.markMentionsRead(channelId, callerEmail). Bulk-clears
            // every chat_mention row for the caller in one channel.
            markRead: "chat.markMentionsRead"
        },
        argMap: {
            list: $281a441cdcb2cf36$var$argMaps.filterOptions,
            markRead: (a3)=>{
                var _a2, _b;
                return [
                    a3 == null ? void 0 : a3.channelId,
                    (_b = (_a2 = a3 == null ? void 0 : a3.callerEmail) != null ? _a2 : a3 == null ? void 0 : a3.userId) != null ? _b : a3 == null ? void 0 : a3.email
                ];
            }
        }
    },
    // Full-text search over chat messages — wraps chat_search_messages RPC.
    // Use sdk.execute('workspaceProject.chat.search', 'rpc', { q, callerEmail }).
    "workspaceProject.chat.search": {
        service: "workspaceProject",
        methods: {
            rpc: "chat.searchMessages"
        },
        argMap: {
            rpc: (a3)=>{
                var _a2, _b, _c;
                return [
                    (_a2 = a3 == null ? void 0 : a3.q) != null ? _a2 : a3 == null ? void 0 : a3.query,
                    (_c = (_b = a3 == null ? void 0 : a3.callerEmail) != null ? _b : a3 == null ? void 0 : a3.userId) != null ? _c : a3 == null ? void 0 : a3.email
                ];
            }
        }
    },
    "workspaceProject.calendar": {
        service: "workspaceProject",
        methods: {
            list: "calendar.listEvents",
            get: "calendar.getEvent",
            create: "calendar.createEvent",
            update: "calendar.updateEvent",
            remove: "calendar.deleteEvent"
        },
        argMap: {
            list: (a3)=>{
                var _a2;
                return [
                    (_a2 = a3 == null ? void 0 : a3.filter) != null ? _a2 : a3 == null ? void 0 : a3.params
                ];
            },
            get: $281a441cdcb2cf36$var$argMaps.id,
            create: $281a441cdcb2cf36$var$argMaps.payload,
            update: $281a441cdcb2cf36$var$argMaps.idPayload,
            remove: $281a441cdcb2cf36$var$argMaps.id
        }
    },
    "workspaceProject.documents": {
        service: "workspaceProject",
        methods: {
            list: "documents.list",
            get: "documents.get",
            create: "documents.create",
            update: "documents.update",
            remove: "documents.remove"
        },
        argMap: {
            list: ()=>[],
            get: $281a441cdcb2cf36$var$argMaps.id,
            create: $281a441cdcb2cf36$var$argMaps.payload,
            update: $281a441cdcb2cf36$var$argMaps.idPayload,
            remove: $281a441cdcb2cf36$var$argMaps.id
        }
    },
    "workspaceProject.documents.kb": {
        service: "workspaceProject",
        methods: {
            list: "documents.listKb",
            create: "documents.createKbArticle",
            update: "documents.updateKbArticle"
        },
        argMap: {
            list: ()=>[],
            create: $281a441cdcb2cf36$var$argMaps.payload,
            update: $281a441cdcb2cf36$var$argMaps.idPayload
        }
    },
    "workspaceProject.documents.notes": {
        service: "workspaceProject",
        methods: {
            list: "documents.listNotes",
            create: "documents.createNote"
        },
        argMap: {
            list: ()=>[],
            create: $281a441cdcb2cf36$var$argMaps.payload
        }
    },
    "workspaceProject.documents.userDocuments": {
        service: "workspaceProject",
        methods: {
            list: "documents.listUserDocuments",
            create: "documents.createUserDocument",
            update: "documents.updateUserDocument",
            remove: "documents.removeUserDocument"
        },
        argMap: {
            list: (a3)=>{
                var _a2, _b, _c, _d;
                return [
                    (_d = (_b = a3 == null ? void 0 : a3.userId) != null ? _b : (_a2 = a3 == null ? void 0 : a3.filter) == null ? void 0 : _a2.user_id) != null ? _d : (_c = a3 == null ? void 0 : a3.params) == null ? void 0 : _c.user_id
                ];
            },
            create: $281a441cdcb2cf36$var$argMaps.payload,
            update: $281a441cdcb2cf36$var$argMaps.idPayload,
            remove: $281a441cdcb2cf36$var$argMaps.id
        }
    },
    "workspaceProject.documents.resourceLinks": {
        service: "workspaceProject",
        methods: {
            list: "documents.listResourceLinks",
            create: "documents.addResourceLink",
            update: "documents.updateResourceLink",
            remove: "documents.removeResourceLink",
            // removeByPair — composite-key delete on (a_type, a_id, b_type, b_id)
            // for unlink paths that don't carry a row id.
            removeByPair: "documents.removeResourceLinkByPair"
        },
        argMap: {
            list: ()=>[],
            create: $281a441cdcb2cf36$var$argMaps.payload,
            update: $281a441cdcb2cf36$var$argMaps.idPayload,
            remove: $281a441cdcb2cf36$var$argMaps.id,
            removeByPair: (a3)=>{
                var _a2;
                return [
                    (_a2 = a3 == null ? void 0 : a3.filter) != null ? _a2 : a3
                ];
            }
        }
    },
    "workspaceProject.notifications": {
        service: "workspaceProject",
        methods: {
            list: "notifications.list",
            get: "notifications.unreadCount",
            // create — POSTs a single row through /notifications. Used by
            // shared/functions/notifications/createNotification.js. Bulk
            // (createNotifications) fans out via N create calls until the
            // wrapper exposes a /notifications/bulk endpoint.
            create: "notifications.create",
            update: "notifications.markRead",
            markAllRead: "notifications.markAllRead"
        },
        argMap: {
            list: ()=>[],
            get: ()=>[],
            create: $281a441cdcb2cf36$var$argMaps.payload,
            update: $281a441cdcb2cf36$var$argMaps.id,
            markAllRead: ()=>[]
        }
    },
    "workspaceProject.presence": {
        service: "workspaceProject",
        methods: {
            list: "presence.online",
            update: "presence.heartbeat"
        },
        argMap: {
            list: ()=>[],
            update: $281a441cdcb2cf36$var$argMaps.payload
        }
    },
    "workspaceProject.people": {
        service: "workspaceProject",
        methods: {
            list: "people.list",
            get: "people.get",
            me: "people.me"
        },
        argMap: {
            list: ()=>[],
            get: $281a441cdcb2cf36$var$argMaps.id,
            me: ()=>[]
        }
    },
    "workspaceProject.permissions": {
        service: "workspaceProject",
        methods: {
            list: "permissions.me",
            rpc: "permissions.check"
        },
        argMap: {
            list: ()=>[],
            rpc: (a3)=>[
                    a3 == null ? void 0 : a3.action,
                    a3 == null ? void 0 : a3.resource
                ]
        }
    },
    "workspaceProject.search": {
        service: "workspaceProject",
        methods: {
            rpc: "search"
        },
        argMap: {
            rpc: (a3)=>{
                var _a2, _b;
                return [
                    (_a2 = a3 == null ? void 0 : a3.q) != null ? _a2 : a3 == null ? void 0 : a3.query,
                    (_b = a3 == null ? void 0 : a3.options) != null ? _b : a3
                ];
            }
        }
    },
    "workspaceProject.activity": {
        service: "workspaceProject",
        methods: {
            list: "activity.listNotes",
            create: "activity.addNote",
            scoringConfig: "activity.scoringConfig",
            // Bulk PATCH activity_scoring_config rows (admin-only). Replaces the
            // direct sb().from('activity_scoring_config').update().eq() loop.
            updateScoringConfig: "activity.updateScoringConfig",
            // Heatmap RPC — POST /activity/heatmap with a date-range filter.
            // Returns aggregated counts grouped by occurred_on / activity_type.
            heatmap: "activity.heatmap",
            // Per-day events list for the heatmap detail drawer.
            listEvents: "activity.listEvents"
        },
        argMap: {
            list: ()=>[],
            create: $281a441cdcb2cf36$var$argMaps.payload,
            scoringConfig: ()=>[],
            updateScoringConfig: $281a441cdcb2cf36$var$argMaps.payload,
            heatmap: (a3)=>{
                var _a2, _b;
                return [
                    (_b = (_a2 = a3 == null ? void 0 : a3.filter) != null ? _a2 : a3 == null ? void 0 : a3.params) != null ? _b : a3
                ];
            },
            listEvents: (a3)=>{
                var _a2, _b;
                return [
                    (_b = (_a2 = a3 == null ? void 0 : a3.filter) != null ? _a2 : a3 == null ? void 0 : a3.params) != null ? _b : a3
                ];
            }
        }
    },
    // Sibling route so `fetch: { from: 'workspaceProject.activity.scoringConfig' }`
    // resolves cleanly for the admin scoring page (which expects a `list` op).
    "workspaceProject.activity.scoringConfig": {
        service: "workspaceProject",
        methods: {
            list: "activity.scoringConfig",
            update: "activity.updateScoringConfig"
        },
        argMap: {
            list: ()=>[],
            update: $281a441cdcb2cf36$var$argMaps.payload
        }
    },
    // ─── Standups (was sb().from('standup_activity')) ─────────────────────────
    // Daily standup rows keyed on (author, date). Replaces every direct
    // supabase query that used to read/write standup_activity.
    "workspaceProject.standups": {
        service: "workspaceProject",
        methods: {
            list: "standups.list",
            get: "standups.get",
            create: "standups.create",
            update: "standups.update",
            // upsert is a separate op so callers don't have to thread an
            // onConflict option through `create`. Maps to the dedicated
            // POST /standups/upsert endpoint server-side.
            upsert: "standups.upsert"
        },
        argMap: {
            list: (a3)=>{
                var _a2;
                return [
                    (_a2 = a3 == null ? void 0 : a3.filter) != null ? _a2 : a3 == null ? void 0 : a3.params,
                    {
                        order: a3 == null ? void 0 : a3.order,
                        limit: a3 == null ? void 0 : a3.limit,
                        ...(a3 == null ? void 0 : a3.options) || {}
                    }
                ];
            },
            get: $281a441cdcb2cf36$var$argMaps.id,
            create: $281a441cdcb2cf36$var$argMaps.payload,
            update: $281a441cdcb2cf36$var$argMaps.idPayload,
            upsert: $281a441cdcb2cf36$var$argMaps.payload
        }
    },
    // ─── System health / feature flags ────────────────────────────────────────
    // Replaces direct `_probeTable(sb, 'profiles')`-style admin probes from
    // /admin/status. `status` returns aggregated health info; `featureFlags`
    // returns the active flag map.
    "workspaceProject.system": {
        service: "workspaceProject",
        methods: {
            status: "system.status",
            featureFlags: "system.featureFlags"
        },
        argMap: {
            status: ()=>[],
            featureFlags: ()=>[]
        }
    },
    // ─── Audit log ────────────────────────────────────────────────────────────
    // Replaces direct sb().from('activity_events') admin reads. Backend wires
    // /workspace/audit-log to the activity_events RLS-scoped view.
    "workspaceProject.auditLog": {
        service: "workspaceProject",
        methods: {
            list: "auditLog.list"
        },
        argMap: {
            list: $281a441cdcb2cf36$var$argMaps.filterOptions
        }
    },
    // ─── Role permissions matrix (governance ACL) ─────────────────────────────
    // Replaces direct sb().from('role_permissions') reads from /admin/permissions.
    "workspaceProject.rolePermissions": {
        service: "workspaceProject",
        methods: {
            list: "rolePermissions.list"
        },
        argMap: {
            list: ()=>[]
        }
    },
    // ─── Workspace tables that don't yet have a dedicated service namespace.
    // These route through the generic _ws fall-through method on
    // WorkspaceProjectService once that method ships. For now the route is
    // reserved so callers (DOMQL fetch:, sdk.execute) compile against the
    // final entity name and we can flip the implementation under them.
    "workspaceProject.announcements": {
        service: "workspaceProject",
        methods: {
            list: "announcements.list",
            get: "announcements.get",
            create: "announcements.create",
            update: "announcements.update",
            remove: "announcements.remove"
        },
        argMap: $281a441cdcb2cf36$var$CRUD_ARG_MAP
    },
    "workspaceProject.birthdays": {
        service: "workspaceProject",
        methods: {
            list: "birthdays.list"
        },
        argMap: {
            list: ()=>[]
        }
    },
    "workspaceProject.stories": {
        service: "workspaceProject",
        methods: {
            list: "stories.list",
            get: "stories.get",
            create: "stories.create",
            update: "stories.update",
            remove: "stories.remove"
        },
        argMap: $281a441cdcb2cf36$var$CRUD_ARG_MAP
    },
    "workspaceProject.companyInfo": {
        service: "workspaceProject",
        methods: {
            list: "companyInfo.list",
            update: "companyInfo.upsert"
        },
        argMap: {
            list: ()=>[],
            update: $281a441cdcb2cf36$var$argMaps.payload
        }
    },
    "workspaceProject.companySettings": {
        service: "workspaceProject",
        methods: {
            get: "companySettings.get",
            update: "companySettings.update"
        },
        argMap: {
            get: ()=>[],
            update: $281a441cdcb2cf36$var$argMaps.payload
        }
    },
    "workspaceProject.userPreferences": {
        service: "workspaceProject",
        methods: {
            get: "userPreferences.get",
            update: "userPreferences.upsert"
        },
        argMap: {
            get: ()=>[],
            update: $281a441cdcb2cf36$var$argMaps.payload
        }
    },
    "workspaceProject.userGrants": {
        service: "workspaceProject",
        methods: {
            list: "userGrants.list",
            get: "userGrants.get",
            create: "userGrants.create",
            update: "userGrants.update",
            remove: "userGrants.remove"
        },
        argMap: $281a441cdcb2cf36$var$CRUD_ARG_MAP
    },
    "workspaceProject.valuations": {
        service: "workspaceProject",
        methods: {
            list: "valuations.list"
        },
        argMap: {
            list: ()=>[]
        }
    },
    "workspaceProject.userProfiles": {
        service: "workspaceProject",
        methods: {
            list: "userProfiles.list",
            get: "userProfiles.get",
            update: "userProfiles.update"
        },
        argMap: {
            list: ()=>[],
            get: $281a441cdcb2cf36$var$argMaps.id,
            update: $281a441cdcb2cf36$var$argMaps.idPayload
        }
    },
    "workspaceProject.ticketColumns": {
        service: "workspaceProject",
        methods: {
            list: "ticketColumns.list",
            update: "ticketColumns.update"
        },
        argMap: {
            list: ()=>[],
            update: $281a441cdcb2cf36$var$argMaps.idPayload
        }
    },
    "workspaceProject.ticketDependencies": {
        service: "workspaceProject",
        methods: {
            list: "ticketDependencies.list",
            create: "ticketDependencies.create",
            remove: "ticketDependencies.remove"
        },
        argMap: {
            list: (a3)=>{
                var _a2, _b, _c, _d;
                return [
                    (_d = (_b = a3 == null ? void 0 : a3.ticketId) != null ? _b : (_a2 = a3 == null ? void 0 : a3.filter) == null ? void 0 : _a2.ticket_id) != null ? _d : (_c = a3 == null ? void 0 : a3.params) == null ? void 0 : _c.ticket_id
                ];
            },
            create: $281a441cdcb2cf36$var$argMaps.payload,
            remove: $281a441cdcb2cf36$var$argMaps.id
        }
    },
    "workspaceProject.ticketComments": {
        service: "workspaceProject",
        methods: {
            list: "ticketComments.list",
            create: "ticketComments.create",
            update: "ticketComments.update",
            remove: "ticketComments.remove"
        },
        argMap: {
            list: (a3)=>{
                var _a2, _b, _c, _d;
                return [
                    (_d = (_b = a3 == null ? void 0 : a3.ticketId) != null ? _b : (_a2 = a3 == null ? void 0 : a3.filter) == null ? void 0 : _a2.ticket_id) != null ? _d : (_c = a3 == null ? void 0 : a3.params) == null ? void 0 : _c.ticket_id,
                    {
                        order: a3 == null ? void 0 : a3.order,
                        limit: a3 == null ? void 0 : a3.limit,
                        ...(a3 == null ? void 0 : a3.options) || {}
                    }
                ];
            },
            create: (a3)=>{
                var _a2, _b, _c, _d;
                return [
                    (_b = a3 == null ? void 0 : a3.ticketId) != null ? _b : (_a2 = a3 == null ? void 0 : a3.filter) == null ? void 0 : _a2.ticket_id,
                    (_d = (_c = a3 == null ? void 0 : a3.payload) != null ? _c : a3 == null ? void 0 : a3.data) != null ? _d : a3
                ];
            },
            update: $281a441cdcb2cf36$var$argMaps.idPayload,
            remove: $281a441cdcb2cf36$var$argMaps.id
        }
    },
    "workspaceProject.meet.rooms": {
        service: "workspaceProject",
        methods: {
            list: "meet.listRooms",
            get: "meet.getRoom",
            create: "meet.createRoom",
            update: "meet.updateRoom",
            // endRoom / reopenRoom — explicit ops so callers don't have to thread
            // ended_at through the generic update payload.
            end: "meet.endRoom",
            reopen: "meet.reopenRoom"
        },
        argMap: {
            list: ()=>[],
            get: $281a441cdcb2cf36$var$argMaps.id,
            create: $281a441cdcb2cf36$var$argMaps.payload,
            update: $281a441cdcb2cf36$var$argMaps.idPayload,
            end: $281a441cdcb2cf36$var$argMaps.id,
            reopen: $281a441cdcb2cf36$var$argMaps.id
        }
    },
    "workspaceProject.meet.transcripts": {
        service: "workspaceProject",
        methods: {
            list: "meet.listTranscripts"
        },
        argMap: {
            list: (a3)=>{
                var _a2, _b, _c;
                return [
                    (_c = (_b = a3 == null ? void 0 : a3.roomId) != null ? _b : (_a2 = a3 == null ? void 0 : a3.filter) == null ? void 0 : _a2.room_id) != null ? _c : a3
                ];
            }
        }
    },
    // Members of a single meet room. Read = list members; create =
    // sb.from('meet_room_members').insert() — the createRoom flow auto-adds
    // the creator as 'owner'. RLS gates inserts to user_id = auth.uid().
    "workspaceProject.meet.members": {
        service: "workspaceProject",
        methods: {
            list: "meet.listMembers",
            create: "meet.addMember"
        },
        argMap: {
            list: (a3)=>{
                var _a2, _b, _c;
                return [
                    (_c = (_b = a3 == null ? void 0 : a3.roomId) != null ? _b : (_a2 = a3 == null ? void 0 : a3.filter) == null ? void 0 : _a2.room_id) != null ? _c : a3
                ];
            },
            create: (a3)=>{
                var _a2, _b, _c, _d;
                return [
                    (_b = a3 == null ? void 0 : a3.roomId) != null ? _b : (_a2 = a3 == null ? void 0 : a3.filter) == null ? void 0 : _a2.room_id,
                    (_d = (_c = a3 == null ? void 0 : a3.payload) != null ? _c : a3 == null ? void 0 : a3.data) != null ? _d : (()=>{
                        const { roomId: roomId, filter: filter, options: options, ...rest } = a3 || {};
                        return rest;
                    })()
                ];
            }
        }
    },
    // Raw transcribed utterance rows — distinct from the higher-level
    // `meet.transcripts` analysis summaries.
    "workspaceProject.meet.utterances": {
        service: "workspaceProject",
        methods: {
            list: "meet.listUtterances"
        },
        argMap: {
            list: (a3)=>{
                var _a2, _b, _c;
                return [
                    (_c = (_b = a3 == null ? void 0 : a3.roomId) != null ? _b : (_a2 = a3 == null ? void 0 : a3.filter) == null ? void 0 : _a2.room_id) != null ? _c : a3
                ];
            }
        }
    },
    // Combined utterances + cached analysis view. Wraps the
    // get_meet_transcript_view(uuid) RPC so MeetTranscriptPage's `fetch:`
    // decl can replace the bare RPC handle with an entity route.
    "workspaceProject.meet.transcriptView": {
        service: "workspaceProject",
        methods: {
            rpc: "meet.getTranscriptView"
        },
        argMap: {
            rpc: (a3)=>{
                var _a2, _b, _c, _d, _e, _f;
                return [
                    (_f = (_e = (_c = (_a2 = a3 == null ? void 0 : a3.roomId) != null ? _a2 : a3 == null ? void 0 : a3.p_room_id) != null ? _c : (_b = a3 == null ? void 0 : a3.params) == null ? void 0 : _b.p_room_id) != null ? _e : (_d = a3 == null ? void 0 : a3.filter) == null ? void 0 : _d.room_id) != null ? _f : a3
                ];
            }
        }
    },
    // Patch applied_items on a meet_transcript_analyses row when the
    // user "applies" a suggestion (saves as note, creates ticket, etc).
    "workspaceProject.meet.analysisAppliedItems": {
        service: "workspaceProject",
        methods: {
            update: "meet.updateAnalysisAppliedItems"
        },
        argMap: {
            update: (a3)=>{
                var _a2, _b, _c, _d, _e, _f;
                return [
                    (_c = (_a2 = a3 == null ? void 0 : a3.roomId) != null ? _a2 : a3 == null ? void 0 : a3.id) != null ? _c : (_b = a3 == null ? void 0 : a3.filter) == null ? void 0 : _b.room_id,
                    (_f = (_e = (_d = a3 == null ? void 0 : a3.applied_items) != null ? _d : a3 == null ? void 0 : a3.appliedItems) != null ? _e : a3 == null ? void 0 : a3.payload) != null ? _f : a3 == null ? void 0 : a3.data
                ];
            }
        }
    },
    // Pending guest requests across rooms the host owns. Maps to
    // workspaceProject.meet.waitingRoom() — no args (server scopes by
    // host identity from the JWT). Admit/reject ops route to the dedicated
    // /meet/waiting-room/:id/(admit|reject) endpoints.
    "workspaceProject.meet.waitingRoom": {
        service: "workspaceProject",
        methods: {
            list: "meet.waitingRoom",
            admit: "meet.admitGuest",
            reject: "meet.rejectGuest"
        },
        argMap: {
            list: ()=>[],
            admit: $281a441cdcb2cf36$var$argMaps.id,
            reject: $281a441cdcb2cf36$var$argMaps.id
        }
    },
    "workspaceProject.aiChat": {
        service: "workspaceProject",
        methods: {
            rpc: "ai.chat"
        },
        argMap: {
            rpc: $281a441cdcb2cf36$var$argMaps.payload
        }
    },
    // Meet-analyze AI summarization. Mapped to the dedicated server-side
    // ai.meetAnalyze method so consumers don't need to thread `kind` through
    // the generic ai.chat payload. Replaces direct fetch('/functions/v1/meet-analyze').
    "workspaceProject.aiMeetAnalyze": {
        service: "workspaceProject",
        methods: {
            rpc: "ai.meetAnalyze"
        },
        argMap: {
            rpc: $281a441cdcb2cf36$var$argMaps.payload
        }
    },
    // LiveKit token issuance. Replaces direct fetch('/functions/v1/meet-token')
    // — auth threads through the workspace JWT just like every other meet route.
    "workspaceProject.meet.token": {
        service: "workspaceProject",
        methods: {
            rpc: "meet.issueToken"
        },
        argMap: {
            rpc: $281a441cdcb2cf36$var$argMaps.payload
        }
    },
    // ─── Workspace realtime subscriptions ─────────────────────────────────────
    // Each route exposes a single `subscribe` op so callers can use the
    // standard `sdk.execute(entity, 'subscribe', filter, cb)` dispatch.
    // Returns an unsubscribe function. Stubs today; backend wire protocol
    // lands later — call sites use the final shape now so migration is
    // a no-op for them when the protocol ships.
    "workspaceProject.realtime.messages": {
        service: "workspaceProject",
        methods: {
            subscribe: "realtime.subscribeMessages"
        },
        argMap: {
            subscribe: (a3)=>{
                var _a2, _b;
                return [
                    {
                        channelId: (_b = a3 == null ? void 0 : a3.channelId) != null ? _b : (_a2 = a3 == null ? void 0 : a3.filter) == null ? void 0 : _a2.channelId
                    }
                ];
            }
        }
    },
    "workspaceProject.realtime.channels": {
        service: "workspaceProject",
        methods: {
            subscribe: "realtime.subscribeChannels"
        },
        argMap: {
            subscribe: (a3)=>{
                var _a2, _b;
                return [
                    (_b = (_a2 = a3 == null ? void 0 : a3.filter) != null ? _a2 : a3) != null ? _b : {}
                ];
            }
        }
    },
    "workspaceProject.realtime.mentions": {
        service: "workspaceProject",
        methods: {
            subscribe: "realtime.subscribeMentions"
        },
        argMap: {
            subscribe: (a3)=>{
                var _a2, _b;
                return [
                    {
                        userEmail: (_b = a3 == null ? void 0 : a3.userEmail) != null ? _b : (_a2 = a3 == null ? void 0 : a3.filter) == null ? void 0 : _a2.userEmail
                    }
                ];
            }
        }
    },
    "workspaceProject.realtime.tickets": {
        service: "workspaceProject",
        methods: {
            subscribe: "realtime.subscribeTickets"
        },
        argMap: {
            subscribe: (a3)=>{
                var _a2, _b;
                return [
                    (_b = (_a2 = a3 == null ? void 0 : a3.filter) != null ? _a2 : a3) != null ? _b : {}
                ];
            }
        }
    },
    "workspaceProject.realtime.notifications": {
        service: "workspaceProject",
        methods: {
            subscribe: "realtime.subscribeNotifications"
        },
        argMap: {
            subscribe: (a3)=>{
                var _a2, _b;
                return [
                    {
                        userEmail: (_b = a3 == null ? void 0 : a3.userEmail) != null ? _b : (_a2 = a3 == null ? void 0 : a3.filter) == null ? void 0 : _a2.userEmail
                    }
                ];
            }
        }
    },
    "workspaceProject.realtime.presence": {
        service: "workspaceProject",
        methods: {
            subscribe: "realtime.subscribePresence"
        },
        argMap: {
            subscribe: (a3)=>{
                var _a2;
                return [
                    {
                        scope: (_a2 = a3 == null ? void 0 : a3.scope) != null ? _a2 : "workspace"
                    }
                ];
            }
        }
    },
    "workspaceProject.realtime.meet": {
        service: "workspaceProject",
        methods: {
            subscribe: "realtime.subscribeMeet"
        },
        argMap: {
            subscribe: (a3)=>{
                var _a2, _b;
                return [
                    {
                        roomId: (_b = a3 == null ? void 0 : a3.roomId) != null ? _b : (_a2 = a3 == null ? void 0 : a3.filter) == null ? void 0 : _a2.roomId
                    }
                ];
            }
        }
    },
    "workspaceProject.realtime.agentMessages": {
        service: "workspaceProject",
        methods: {
            subscribe: "realtime.subscribeAgentMessages"
        },
        argMap: {
            subscribe: (a3)=>{
                var _a2, _b;
                return [
                    {
                        toAgent: (_b = a3 == null ? void 0 : a3.toAgent) != null ? _b : (_a2 = a3 == null ? void 0 : a3.filter) == null ? void 0 : _a2.toAgent
                    }
                ];
            }
        }
    },
    // ─── Workspace storage (signed URLs + uploads for contracts, chat-attachments) ─
    // Replaces direct sb().storage.from(...) calls. Buckets are wrapper-scoped,
    // not exposed as public Supabase buckets — the wrapper enforces RLS and
    // hides the bucket service-role key from the browser.
    "workspaceProject.storage": {
        service: "workspaceProject",
        methods: {
            signedUrl: "storage.createSignedUrl",
            upload: "storage.upload",
            remove: "storage.remove",
            publicUrl: "storage.publicUrl"
        },
        argMap: {
            signedUrl: (a3)=>{
                var _a2;
                return [
                    a3 == null ? void 0 : a3.bucket,
                    a3 == null ? void 0 : a3.path,
                    (_a2 = a3 == null ? void 0 : a3.ttl) != null ? _a2 : 300
                ];
            },
            upload: (a3)=>{
                var _a2, _b;
                return [
                    a3 == null ? void 0 : a3.bucket,
                    (_a2 = a3 == null ? void 0 : a3.formData) != null ? _a2 : a3 == null ? void 0 : a3.payload,
                    (_b = a3 == null ? void 0 : a3.options) != null ? _b : {}
                ];
            },
            remove: (a3)=>[
                    a3 == null ? void 0 : a3.bucket,
                    a3 == null ? void 0 : a3.path
                ],
            publicUrl: (a3)=>[
                    a3 == null ? void 0 : a3.bucket,
                    a3 == null ? void 0 : a3.path
                ]
        }
    },
    // Walkie-talkie messages between ops agents (Simona/Chuvaka). The browser
    // path uses sdk.execute(); the node ops path keeps a service-role REST
    // fetch in shared/functions/agentMessages.js because there is no SDK
    // admin token issuance flow yet.
    "workspaceProject.agentMessages": {
        service: "workspaceProject",
        methods: {
            list: "agentMessages.list",
            create: "agentMessages.create",
            update: "agentMessages.update",
            subscribe: "agentMessages.subscribe"
        },
        argMap: {
            list: (a3)=>{
                var _a2;
                return [
                    (_a2 = a3 == null ? void 0 : a3.filter) != null ? _a2 : a3 == null ? void 0 : a3.params,
                    {
                        order: a3 == null ? void 0 : a3.order,
                        limit: a3 == null ? void 0 : a3.limit,
                        ...(a3 == null ? void 0 : a3.options) || {}
                    }
                ];
            },
            create: $281a441cdcb2cf36$var$argMaps.payload,
            update: $281a441cdcb2cf36$var$argMaps.idPayload,
            subscribe: (a3)=>{
                var _a2, _b, _c, _d;
                return [
                    (_d = (_b = a3 == null ? void 0 : a3.toAgent) != null ? _b : (_a2 = a3 == null ? void 0 : a3.filter) == null ? void 0 : _a2.to_agent) != null ? _d : (_c = a3 == null ? void 0 : a3.params) == null ? void 0 : _c.to_agent
                ];
            }
        }
    },
    // Backwards-compat alias — agentMessages.js currently calls
    // sdk.execute('agent_messages', ...). Keep the bare name routing to the
    // same service methods until consumers update to the dotted form.
    "agent_messages": {
        service: "workspaceProject",
        methods: {
            list: "agentMessages.list",
            create: "agentMessages.create",
            update: "agentMessages.update",
            subscribe: "agentMessages.subscribe"
        },
        argMap: {
            list: (a3)=>{
                var _a2;
                return [
                    (_a2 = a3 == null ? void 0 : a3.filter) != null ? _a2 : a3 == null ? void 0 : a3.params,
                    {
                        order: a3 == null ? void 0 : a3.order,
                        limit: a3 == null ? void 0 : a3.limit,
                        ...(a3 == null ? void 0 : a3.options) || {}
                    }
                ];
            },
            create: $281a441cdcb2cf36$var$argMaps.payload,
            update: $281a441cdcb2cf36$var$argMaps.idPayload,
            subscribe: (a3)=>{
                var _a2, _b, _c, _d;
                return [
                    (_d = (_b = a3 == null ? void 0 : a3.toAgent) != null ? _b : (_a2 = a3 == null ? void 0 : a3.filter) == null ? void 0 : _a2.to_agent) != null ? _d : (_c = a3 == null ? void 0 : a3.params) == null ? void 0 : _c.to_agent
                ];
            }
        }
    },
    // Generic escape-hatch for one-off RPCs that don't have a dedicated route.
    // sdk.execute('workspaceProject.query', 'rpc', { body }) calls
    // workspaceProject.query(body). Use sparingly — prefer adding a real route.
    "workspaceProject.query": {
        service: "workspaceProject",
        methods: {
            rpc: "query"
        },
        argMap: {
            rpc: $281a441cdcb2cf36$var$argMaps.payload
        }
    },
    // ─── Project (canvas build unit) ──────────────────────────────────────────
    "project": {
        service: "project",
        methods: {
            list: "listProjects",
            get: "getProject",
            create: "createProject",
            update: "updateProject",
            remove: "deleteProject"
        }
    },
    // ─── Branch / PullRequest ─────────────────────────────────────────────────
    "project.branch": {
        service: "branch",
        methods: {
            list: "listBranches",
            get: "getBranch",
            create: "createBranch",
            remove: "deleteBranch"
        }
    },
    "project.pullRequest": {
        service: "pullRequest",
        methods: {
            list: "list",
            get: "get",
            create: "create",
            update: "update",
            remove: "remove"
        }
    },
    // ─── Collab (canvas project realtime via socket.io) ──────────────────────
    "project.collab": {
        service: "collab",
        methods: {
            subscribe: "subscribe"
        }
    },
    // ─── Marketplace ──────────────────────────────────────────────────────────
    "marketplace.listings": {
        service: "marketplace",
        methods: {
            list: "list",
            get: "get"
        }
    },
    // ─── File / Screenshot / Misc ─────────────────────────────────────────────
    "file": {
        service: "file",
        methods: {
            list: "list",
            get: "get",
            create: "upload",
            remove: "remove"
        }
    },
    "screenshot": {
        service: "screenshot",
        methods: {
            get: "getScreenshotByKey"
        }
    }
};
var $281a441cdcb2cf36$var$resolveDottedMethod = (target, methodPath)=>{
    if (!target || !methodPath) return null;
    return methodPath.split(".").reduce((obj, key)=>obj == null ? void 0 : obj[key], target);
};
var $281a441cdcb2cf36$export$8afc2bf1b919cbde = (path, route)=>{
    if (typeof path !== "string") throw new Error("[registerEntity] path must be a string");
    if (!(route == null ? void 0 : route.service) || !(route == null ? void 0 : route.methods)) throw new Error("[registerEntity] route must have { service, methods }");
    $281a441cdcb2cf36$var$ENTITY_ROUTES[path] = route;
};
var $281a441cdcb2cf36$var$listEntities = ()=>Object.keys($281a441cdcb2cf36$var$ENTITY_ROUTES);
var $281a441cdcb2cf36$export$18d13f57a667a03d = (sdk)=>{
    const execute = (from2, op, args2, cb)=>{
        var _a2;
        const route = $281a441cdcb2cf36$var$ENTITY_ROUTES[from2];
        if (!route) throw new Error(`[sdk.execute] Unknown entity: '${from2}'. Known: ${Object.keys($281a441cdcb2cf36$var$ENTITY_ROUTES).join(", ")}`);
        const methodPath = route.methods[op];
        if (!methodPath) throw new Error(`[sdk.execute] Entity '${from2}' does not support op '${op}'. Supported ops: ${Object.keys(route.methods).join(", ")}`);
        let service;
        try {
            service = sdk.getService(route.service);
        } catch (err) {
            throw new Error(`[sdk.execute] Service '${route.service}' for entity '${from2}' is not available: ${err.message}`);
        }
        const fn = $281a441cdcb2cf36$var$resolveDottedMethod(service, methodPath);
        if (typeof fn !== "function") throw new Error(`[sdk.execute] Method '${methodPath}' not found on service '${route.service}' (entity '${from2}', op '${op}')`);
        const argMapper = (_a2 = route.argMap) == null ? void 0 : _a2[op];
        const callArgs = typeof argMapper === "function" ? argMapper(args2) : [
            args2
        ];
        if (op === "subscribe" && typeof cb === "function") return fn.call(service, ...callArgs, cb);
        return fn.call(service, ...callArgs);
    };
    execute.listEntities = $281a441cdcb2cf36$var$listEntities;
    execute.getRoute = (from2)=>$281a441cdcb2cf36$var$ENTITY_ROUTES[from2] || null;
    return execute;
};
// src/index.js
var $281a441cdcb2cf36$var$isBrowserEnvironment2 = ()=>typeof window !== "undefined";
var $281a441cdcb2cf36$export$ec8a6426516240fc = ()=>{
    if (!$281a441cdcb2cf36$var$isBrowserEnvironment2()) return false;
    const host = window.location && window.location.hostname;
    return host === "localhost" || (host == null ? void 0 : host.endsWith(".localhost")) || host === "127.0.0.1" || host === "::1" || host === "" || !host;
};
var $281a441cdcb2cf36$export$f7af2da260061f5e = class {
    constructor(options = {}){
        this._services = /* @__PURE__ */ new Map();
        this._context = {};
        this._options = this._validateOptions(options);
        if (this._options.apiUrl) this._context.apiUrl = this._options.apiUrl;
        $281a441cdcb2cf36$var$setDebug(this._options.debug);
        this.environment = $281a441cdcb2cf36$export$6bc7b24d4e862158;
        this.rootBus = $281a441cdcb2cf36$var$rootBus;
        this._createServiceProxies();
        this.execute = $281a441cdcb2cf36$export$18d13f57a667a03d(this);
    }
    // Initialize SDK with context
    async initialize(context2 = {}) {
        this._context = {
            ...this._context,
            ...context2
        };
        await Promise.all([
            this._initService("auth", $281a441cdcb2cf36$export$8f30b9a05eb146a5({
                context: this._context,
                options: this._options
            })),
            this._initService("collab", $281a441cdcb2cf36$export$691774002b31f671({
                context: this._context,
                options: this._options
            })),
            // Initialize new modular services
            this._initService("project", $281a441cdcb2cf36$export$d2db3a7443ba9beb({
                context: this._context,
                options: this._options
            })),
            this._initService("plan", $281a441cdcb2cf36$export$f0b1369ebf33366b({
                context: this._context,
                options: this._options
            })),
            this._initService("subscription", $281a441cdcb2cf36$export$679dc0611cbaf435({
                context: this._context,
                options: this._options
            })),
            this._initService("file", $281a441cdcb2cf36$export$4064f974fd81a6bd({
                context: this._context,
                options: this._options
            })),
            this._initService("payment", $281a441cdcb2cf36$export$431e60f339189fc2({
                context: this._context,
                options: this._options
            })),
            this._initService("dns", $281a441cdcb2cf36$export$e6d31e0575ba2870({
                context: this._context,
                options: this._options
            })),
            this._initService("branch", $281a441cdcb2cf36$export$8cd6113019ef923a({
                context: this._context,
                options: this._options
            })),
            this._initService("pullRequest", $281a441cdcb2cf36$export$7a55342272230f5c({
                context: this._context,
                options: this._options
            })),
            this._initService("admin", $281a441cdcb2cf36$export$43743e06143bac7e({
                context: this._context,
                options: this._options
            })),
            this._initService("screenshot", $281a441cdcb2cf36$var$createScreenshotService({
                context: this._context,
                options: this._options
            })),
            this._initService("tracking", $281a441cdcb2cf36$export$e6575b0c70a26da5({
                context: this._context,
                options: this._options
            })),
            this._initService("waitlist", $281a441cdcb2cf36$export$ead6d97b2fb25b5f({
                context: this._context,
                options: this._options
            })),
            this._initService("metrics", $281a441cdcb2cf36$export$3f15454bfb4240bb({
                context: this._context,
                options: this._options
            })),
            this._initService("integration", $281a441cdcb2cf36$export$6e7d2c03a2cb2554({
                context: this._context,
                options: this._options
            })),
            this._initService("featureFlag", $281a441cdcb2cf36$export$bd53689910224e3({
                context: this._context,
                options: this._options
            })),
            this._initService("organization", $281a441cdcb2cf36$export$94bb759057b63067({
                context: this._context,
                options: this._options
            })),
            this._initService("workspace", $281a441cdcb2cf36$export$bb7722ac44faca6f({
                context: this._context,
                options: this._options
            })),
            this._initService("workspaceProject", $281a441cdcb2cf36$export$fa3fda96a7de1da5({
                context: this._context,
                options: this._options
            })).then(()=>{
                const wp = this._services.get("workspaceProject");
                if (wp) {
                    this._services.set("workspaceData", wp);
                    this._context.services = {
                        ...this._context.services,
                        workspaceData: wp
                    };
                }
            }),
            this._initService("kv", $281a441cdcb2cf36$export$d3d85d4bc39b8ae2({
                context: this._context,
                options: this._options
            })),
            this._initService("allocationRule", $281a441cdcb2cf36$export$8ff68545e204df5f({
                context: this._context,
                options: this._options
            })),
            this._initService("sharedAsset", $281a441cdcb2cf36$export$545998207dbe2dbd({
                context: this._context,
                options: this._options
            })),
            this._initService("credits", $281a441cdcb2cf36$export$af05bc79f915caf2({
                context: this._context,
                options: this._options
            }))
        ]);
        return this;
    }
    // Private helper to initialize a service
    async _initService(name, service) {
        this._context.services = {
            ...this._context.services,
            [name]: service
        };
        await service.init({
            context: this._context,
            options: this._options
        });
        this._services.set(name, service);
    }
    _validateOptions(options) {
        const onLocalhost = $281a441cdcb2cf36$export$ec8a6426516240fc();
        const hasGrafanaUrl = Boolean($281a441cdcb2cf36$export$6bc7b24d4e862158.grafanaUrl);
        const defaults = {
            useNewServices: true,
            // Use new service implementations by default
            apiUrl: $281a441cdcb2cf36$export$6bc7b24d4e862158.apiUrl,
            socketUrl: $281a441cdcb2cf36$export$6bc7b24d4e862158.socketUrl,
            timeout: 3e4,
            retryAttempts: 3,
            debug: false,
            tracking: {
                // Faro/Grafana tracking globally disabled — the collector endpoint
                // rejects CORS from our preview domains, so every call spams the
                // console with preflight failures. Re-enable per-caller via
                // `options.tracking.enabled = true` when a valid origin is allowed.
                enabled: false
            }
        };
        const merged = {
            ...defaults,
            ...options,
            tracking: {
                ...defaults.tracking,
                ...options.tracking || {}
            }
        };
        if (onLocalhost || !hasGrafanaUrl) merged.tracking.enabled = false;
        return merged;
    }
    // Get service instance
    getService(name) {
        if (!this._services.has(name)) throw new Error(`Service '${name}' not found`);
        return this._services.get(name);
    }
    // Update context
    updateContext(newContext) {
        const { ...sanitized } = newContext || {};
        this._context = {
            ...this._context,
            ...sanitized
        };
        for (const service of this._services.values())service.updateContext(this._context);
    }
    // Switch the active organization. Resets internal SDK state that's scoped
    // to an org so the next call uses the new org's claims/clients/caches.
    //
    // Caller is responsible for telling each service ABOUT the new orgId via
    // updateContext({ activeOrgId }) — that's already part of this method. Any
    // org-scoped fetch caches in consumers (e.g. queryClient in the fetch
    // plugin) should be invalidated by the caller separately.
    //
    // What this method clears internally:
    //   - TokenManager: any cached claims that include the old orgId (the next
    //     refresh will mint with the new claim).
    //   - CollabService active subscriptions tied to projects in the old org.
    //   - WorkspaceProjectService cached prefix (recomputed lazily on next call).
    //   - Per-service cached state via service.switchOrg(newOrgId) when the
    //     service implements that hook (additive — services without the hook
    //     are skipped).
    async switchOrg(newOrgId) {
        var _a2, _b, _c;
        if (!newOrgId) throw new Error("[sdk.switchOrg] newOrgId is required");
        const previousOrgId = this._context.activeOrgId;
        if (previousOrgId === newOrgId) return {
            changed: false,
            orgId: newOrgId
        };
        this.updateContext({
            activeOrgId: newOrgId
        });
        if ((_a2 = this._tokenManager) == null ? void 0 : _a2.invalidateClaims) try {
            this._tokenManager.invalidateClaims();
        } catch  {}
        const switchPromises = [];
        for (const [name, service] of this._services.entries())if (typeof service.switchOrg === "function") switchPromises.push(Promise.resolve(service.switchOrg(newOrgId, previousOrgId)).catch((err)=>{
            $281a441cdcb2cf36$var$logger.error(`[sdk.switchOrg] Service '${name}' switchOrg failed:`, err);
        }));
        await Promise.all(switchPromises);
        (_c = (_b = this.rootBus) == null ? void 0 : _b.emit) == null || _c.call(_b, "sdk.orgSwitched", {
            previousOrgId: previousOrgId,
            newOrgId: newOrgId
        });
        return {
            changed: true,
            previousOrgId: previousOrgId,
            newOrgId: newOrgId
        };
    }
    // Switch the active workspace within the current org. The federation
    // layer (governance Supabase + symbols-auth-bridge edge fn) is what
    // actually re-mints the JWT with the new `active_workspace_id` claim;
    // this method orchestrates that via the optional
    // `context.federationSwitchWorkspace` callback registered at init time.
    //
    // Frontend contract:
    //   await sdk.switchWorkspace(workspaceId)
    // — single entry point. Federation, state cleanup, event emission, and
    // localStorage persistence are all SDK-internal.
    //
    // Returns the federation result so the caller can decide on UI feedback
    // (e.g. dismiss a transition overlay only on { ok: true }).
    async switchWorkspace(newWorkspaceId) {
        var _a2, _b, _c;
        if (!newWorkspaceId) throw new Error("[sdk.switchWorkspace] workspaceId is required");
        const previousWorkspaceId = this._context.activeWorkspaceId;
        if (previousWorkspaceId === newWorkspaceId) return {
            ok: true,
            changed: false,
            workspaceId: newWorkspaceId
        };
        let federationResult = {
            ok: true
        };
        const federationFn = this._context.federationSwitchWorkspace;
        if (typeof federationFn === "function") {
            federationResult = await federationFn(newWorkspaceId);
            if (!(federationResult == null ? void 0 : federationResult.ok)) return {
                ok: false,
                error: federationResult == null ? void 0 : federationResult.error,
                federation: federationResult
            };
        }
        this.updateContext({
            activeWorkspaceId: newWorkspaceId
        });
        if ((_a2 = this._tokenManager) == null ? void 0 : _a2.invalidateClaims) try {
            this._tokenManager.invalidateClaims();
        } catch  {}
        const switchPromises = [];
        for (const [name, service] of this._services.entries())if (typeof service.switchWorkspace === "function") switchPromises.push(Promise.resolve(service.switchWorkspace(newWorkspaceId, previousWorkspaceId)).catch((err)=>{
            $281a441cdcb2cf36$var$logger.error(`[sdk.switchWorkspace] Service '${name}' switchWorkspace failed:`, err);
        }));
        await Promise.all(switchPromises);
        if (typeof globalThis !== "undefined" && globalThis.localStorage) try {
            globalThis.localStorage.setItem("activeWorkspace", newWorkspaceId);
        } catch  {}
        (_c = (_b = this.rootBus) == null ? void 0 : _b.emit) == null || _c.call(_b, "sdk.workspaceSwitched", {
            previousWorkspaceId: previousWorkspaceId,
            newWorkspaceId: newWorkspaceId
        });
        return {
            ok: true,
            changed: true,
            previousWorkspaceId: previousWorkspaceId,
            newWorkspaceId: newWorkspaceId,
            federation: federationResult
        };
    }
    // Check if SDK is ready
    isReady() {
        const sdkServices = Array.from(this._services.values());
        return sdkServices.length > 0 && sdkServices.every((service)=>service.isReady());
    }
    // Get SDK status
    getStatus() {
        return {
            ready: this.isReady(),
            services: Array.from(this._services.entries()).map(([name, service])=>({
                    name: name,
                    ...service.getStatus()
                })),
            context: {
                ...this._context
            }
        };
    }
    // Create proxy methods for direct service access
    _createServiceProxies() {
        for (const [methodName, serviceName2] of Object.entries($281a441cdcb2cf36$var$SERVICE_METHODS))if (!this[methodName]) this[methodName] = (...args2)=>{
            const service = this.getService(serviceName2);
            if (!service[methodName]) throw new Error(`Method '${methodName}' not found on service '${serviceName2}'`);
            return service[methodName](...args2);
        };
    }
    /**
   * Destroys all services and cleans up resources
   * @returns {Promise<boolean>} Returns true when cleanup is complete
   */ async destroy() {
        try {
            const destroyPromises = Array.from(this._services.entries()).filter(([, service])=>typeof service.destroy === "function").map(async ([name, service])=>{
                await service.destroy();
                $281a441cdcb2cf36$var$logger.log(`Service ${name} destroyed successfully`);
            });
            await Promise.all(destroyPromises);
            this._services.clear();
            this._context = {};
            return true;
        } catch (error) {
            $281a441cdcb2cf36$var$logger.error("Error during SDK destruction:", error);
            throw error;
        }
    }
};
var $281a441cdcb2cf36$export$2e2bcd8739ae039 = $281a441cdcb2cf36$export$f7af2da260061f5e;
 // @preserve-env

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});

parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("3WCJD", function(module, exports) {

$parcel$export(module.exports, "currentChannel", () => $2df4d5d3c0a0ba16$export$e76fc4f1971356db);
$parcel$export(module.exports, "apiUrl", () => $2df4d5d3c0a0ba16$export$e9ddf1da8d18d6f);
$parcel$export(module.exports, "mermaidUrl", () => $2df4d5d3c0a0ba16$export$3f5943486608d618);
$parcel$export(module.exports, "isKnownChannel", () => $2df4d5d3c0a0ba16$export$954d715b7f626f);
// @symbo.ls/channels — single source of truth for Symbols-platform API/socket URLs.
// Consumed by sdk, smbls, server, editor, workspace, platform.
//
// Resolution order for apiUrl/socketUrl:
//   1. Explicit `name` arg
//   2. SYMBOLS_API_CHANNEL (explicit channel pin — highest-priority env signal)
//   3. SYMBOLS_APP_ENV (SDK-side convention)
//   4. NODE_ENV (the value our deploys pass — production/staging/development/
//      test/next/local all map 1:1 to a channel of the same name)
//   5. defaultChannel from channels.json
//
// NODE_ENV values that aren't channel names (e.g. `testing` — historical SDK
// alias) won't match channels.channels[env] and fall through to defaultChannel.
//
// Direct URL env-var overrides (SYMBOLS_API_URL / SYMBOLS_SOCKET_URL) take
// precedence over channel resolution — escape hatch for local proxies, ngrok,
// custom mirrors, etc.
//
// JSON load via standard import attribute — stable in Node 22+ and handled
// natively by every browser bundler (Parcel/esbuild/webpack/Vite). The older
// createRequire approach broke browser bundles because `module.createRequire`
// is Node-only.

var $iTpE3 = parcelRequire("iTpE3");
const $2df4d5d3c0a0ba16$export$fa22149e93fb7e8e = Object.keys((0, (/*@__PURE__*/$parcel$interopDefault($iTpE3))).channels);
const $2df4d5d3c0a0ba16$export$23106789b3d0c0e3 = (name)=>{
    if (name && (0, (/*@__PURE__*/$parcel$interopDefault($iTpE3))).channels[name]) return (0, (/*@__PURE__*/$parcel$interopDefault($iTpE3))).channels[name];
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTpE3))).channels[(0, (/*@__PURE__*/$parcel$interopDefault($iTpE3))).defaultChannel];
};
const $2df4d5d3c0a0ba16$export$e76fc4f1971356db = ()=>{
    const env = null;
    if (env && (0, (/*@__PURE__*/$parcel$interopDefault($iTpE3))).channels[env]) return env;
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTpE3))).defaultChannel;
};
const $2df4d5d3c0a0ba16$export$e9ddf1da8d18d6f = (name = $2df4d5d3c0a0ba16$export$e76fc4f1971356db())=>{
    return $2df4d5d3c0a0ba16$export$23106789b3d0c0e3(name).api;
};
const $2df4d5d3c0a0ba16$export$7ba24559de2e3800 = (name = $2df4d5d3c0a0ba16$export$e76fc4f1971356db())=>{
    return $2df4d5d3c0a0ba16$export$23106789b3d0c0e3(name).socket;
};
const $2df4d5d3c0a0ba16$export$fe7c4d79648da74 = (name = $2df4d5d3c0a0ba16$export$e76fc4f1971356db())=>$2df4d5d3c0a0ba16$export$23106789b3d0c0e3(name).shell || null;
const $2df4d5d3c0a0ba16$export$3239d996d035c0a2 = (name = $2df4d5d3c0a0ba16$export$e76fc4f1971356db())=>$2df4d5d3c0a0ba16$export$23106789b3d0c0e3(name).preview || null;
const $2df4d5d3c0a0ba16$export$3f5943486608d618 = ({ owner: owner, key: key, env: env = 'production' } = {}, name = $2df4d5d3c0a0ba16$export$e76fc4f1971356db())=>{
    const apex = $2df4d5d3c0a0ba16$export$23106789b3d0c0e3(name).mermaidApex;
    if (!apex || !owner || !key) return null;
    const userSuffix = env && env !== 'production' ? `--${encodeURIComponent(env)}` : '';
    const proto = apex.startsWith('localhost') ? 'http' : 'https';
    return `${proto}://${encodeURIComponent(key)}${userSuffix}.${encodeURIComponent(owner)}.${apex}`;
};
const $2df4d5d3c0a0ba16$export$dd4ee7b901274235 = (name = $2df4d5d3c0a0ba16$export$e76fc4f1971356db())=>$2df4d5d3c0a0ba16$export$23106789b3d0c0e3(name).deploy || {};
const $2df4d5d3c0a0ba16$export$954d715b7f626f = (name)=>Boolean(name && (0, (/*@__PURE__*/$parcel$interopDefault($iTpE3))).channels[name]);
const $2df4d5d3c0a0ba16$export$ce6c8d43e3ceca7a = (0, (/*@__PURE__*/$parcel$interopDefault($iTpE3))).defaultChannel;

});
parcelRegister("iTpE3", function(module, exports) {
module.exports = JSON.parse("{\"channels\":{\"local\":{\"api\":\"http://localhost:8080\",\"socket\":\"http://localhost:8080\",\"shell\":\"http://my.localhost:1355\",\"preview\":\"http://preview.localhost:1355\",\"mermaidApex\":\"localhost:1355\",\"deploy\":{}},\"localNext\":{\"api\":\"https://next.api.symbols.app\",\"socket\":\"https://next.api.symbols.app\",\"shell\":\"http://my.localhost:1355\",\"preview\":\"http://preview.localhost:1355\",\"mermaidApex\":\"localhost:1355\",\"deploy\":{}},\"development\":{\"api\":\"https://dev.api.symbols.app\",\"socket\":\"https://dev.api.symbols.app\",\"shell\":\"https://dev.my.symbols.app\",\"preview\":\"https://dev.preview.symbols.app\",\"mermaidApex\":\"dev.symbo.ls\",\"deploy\":{\"shellBucket\":\"smbls-my-dev\",\"previewWorker\":\"smbls-preview-dev\",\"mermaidWorker\":\"mermaid-dev\"}},\"next\":{\"api\":\"https://next.api.symbols.app\",\"socket\":\"https://next.api.symbols.app\",\"shell\":\"https://next.my.symbols.app\",\"preview\":\"https://next.preview.symbols.app\",\"mermaidApex\":\"next.symbo.ls\",\"deploy\":{\"shellBucket\":\"smbls-my-next\",\"previewWorker\":\"smbls-preview-next\",\"mermaidWorker\":\"mermaid-next\"}},\"test\":{\"api\":\"https://test.api.symbols.app\",\"socket\":\"https://test.api.symbols.app\",\"shell\":\"https://test.my.symbols.app\",\"preview\":\"https://test.preview.symbols.app\",\"mermaidApex\":\"test.symbo.ls\",\"deploy\":{\"shellBucket\":\"smbls-my-test\",\"previewWorker\":\"smbls-preview-test\",\"mermaidWorker\":\"mermaid-test\"}},\"upcoming\":{\"api\":\"https://upcoming.api.symbols.app\",\"socket\":\"https://upcoming.api.symbols.app\",\"shell\":\"https://upcoming.my.symbols.app\",\"preview\":\"https://upcoming.preview.symbols.app\",\"mermaidApex\":\"upcoming.symbo.ls\",\"deploy\":{\"shellBucket\":\"smbls-my-upcoming\",\"previewWorker\":\"smbls-preview-upcoming\",\"mermaidWorker\":\"mermaid-upcoming\"}},\"staging\":{\"api\":\"https://staging.api.symbols.app\",\"socket\":\"https://staging.api.symbols.app\",\"shell\":\"https://staging.my.symbols.app\",\"preview\":\"https://staging.preview.symbols.app\",\"mermaidApex\":\"staging.symbo.ls\",\"deploy\":{\"shellBucket\":\"smbls-my-staging\",\"previewWorker\":\"smbls-preview-staging\",\"mermaidWorker\":\"mermaid-staging\"}},\"production\":{\"api\":\"https://api.symbols.app\",\"socket\":\"https://api.symbols.app\",\"shell\":\"https://my.symbols.app\",\"preview\":\"https://preview.symbols.app\",\"mermaidApex\":\"symbo.ls\",\"deploy\":{\"shellBucket\":\"smbls-my-prod\",\"previewWorker\":\"smbls-preview\",\"mermaidWorker\":\"mermaid\"}}},\"defaultChannel\":\"next\"}");

});


parcelRegister("8RlGv", function(module, exports) {

$parcel$export(module.exports, "PROJECT_GOVERNANCE", () => $6734181058d61ce4$export$a54df3be54843d98);
$parcel$export(module.exports, "getClient", () => $6734181058d61ce4$export$6bb76d6eba7e258c);
$parcel$export(module.exports, "getClientAsync", () => $6734181058d61ce4$export$80567c6129dc5041);
$parcel$export(module.exports, "forEachClient", () => $6734181058d61ce4$export$f29328267663ba07);
$parcel$export(module.exports, "_resetClients", () => $6734181058d61ce4$export$a66dfc2c6da0bd3);
$parcel$export(module.exports, "getRegistry", () => $6734181058d61ce4$export$39d7fc5adc3c75a1);
$parcel$export(module.exports, "getProjectConfig", () => $6734181058d61ce4$export$bad43d745a81bbd5);
$parcel$export(module.exports, "listConfiguredProjects", () => $6734181058d61ce4$export$a44e0967006104d0);
$parcel$export(module.exports, "resetRegistry", () => $6734181058d61ce4$export$b668408ac8206d2f);
$parcel$export(module.exports, "configure", () => $6734181058d61ce4$export$8d21e34596265fa2);
$parcel$export(module.exports, "getAppConfig", () => $6734181058d61ce4$export$544aaded68bb6ae2);
$parcel$export(module.exports, "loginAll", () => $6734181058d61ce4$export$71d050677f938d04);
$parcel$export(module.exports, "logoutAll", () => $6734181058d61ce4$export$4d932ebd88db07ee);
$parcel$export(module.exports, "switchWorkspace", () => $6734181058d61ce4$export$c3cb4d92231617a0);
$parcel$export(module.exports, "refreshClaims", () => $6734181058d61ce4$export$fd23a70622d440f6);
$parcel$export(module.exports, "activateExtension", () => $6734181058d61ce4$export$b45be625a0b963d1);
$parcel$export(module.exports, "getSymbolsToken", () => $6734181058d61ce4$export$2e94b40918c1ba70);
$parcel$export(module.exports, "getSessionStatus", () => $6734181058d61ce4$export$6f5cc5586c0c38b3);
$parcel$export(module.exports, "getSupabase", () => $6734181058d61ce4$export$d90c31306ea565a5);
$parcel$export(module.exports, "getSupabaseAsync", () => $6734181058d61ce4$export$dd45a343b6ac2ea2);
$parcel$export(module.exports, "getRealtimeSupabase", () => $6734181058d61ce4$export$973cffe86a0bea52);
$parcel$export(module.exports, "TOKEN_KEYS", () => $6734181058d61ce4$export$332974f1fffb359a);
$parcel$export(module.exports, "SUPABASE_KEY_RE", () => $6734181058d61ce4$export$ef001aa7c423f822);
$parcel$export(module.exports, "hydrateAuthFromCookie", () => $6734181058d61ce4$export$a299b57594f93420);
$parcel$export(module.exports, "hydrateAuthFromIframeBridge", () => $6734181058d61ce4$export$45cb7059e7c59007);
$parcel$export(module.exports, "persistAuthToCookie", () => $6734181058d61ce4$export$d5d56450a6fb624);
$parcel$export(module.exports, "clearAuthCookie", () => $6734181058d61ce4$export$5d31187a0cdf795a);
$parcel$export(module.exports, "installAuthSync", () => $6734181058d61ce4$export$6c3ff1d8842f6efd);
$parcel$export(module.exports, "persistSupabaseSessionsToCookie", () => $6734181058d61ce4$export$b0e7e9532d134e9a);
$parcel$export(module.exports, "hydrateSupabaseSessionsFromCookie", () => $6734181058d61ce4$export$bd8aba6d048d19e4);
$parcel$export(module.exports, "collectSdkTokens", () => $6734181058d61ce4$export$2caf675105ee535);
$parcel$export(module.exports, "collectSupabaseSessions", () => $6734181058d61ce4$export$e7a829cfe6b87f06);
$parcel$export(module.exports, "installPlugin", () => $6734181058d61ce4$export$b9a931cef18d6e89);
$parcel$export(module.exports, "scaffoldFromTemplate", () => $6734181058d61ce4$export$22374d636991e1aa);
$parcel$export(module.exports, "saveMcpConnector", () => $6734181058d61ce4$export$9ca20373711d1316);
$parcel$export(module.exports, "attachLibrary", () => $6734181058d61ce4$export$99634018ea086848);
// Workspace-internal governance bridge. Wires the abstract sdk-bridge +
// sdk-supabase-bridge primitives into a project-specific federation for
// the governance Supabase project — the workspace shell's only auth
// boundary.
//
// FINANCIALS IS NOT WIRED HERE. The workspace bundle never touches the
// financials project. Apps that need financials (admin consoles, finance
// dashboards) wire their own bridge in their own module — see
// `governance/packages/finance-features/src/bridge.js`.
//
// What this module exposes (legacy surface preserved so the ~30
// consumer call sites don't have to change semantics):
//   getClient / getClientAsync / forEachClient
//   loginAll / logoutAll / switchWorkspace / refreshClaims /
//   activateExtension / getSymbolsToken / getSessionStatus
//   getSupabase / getSupabaseAsync / getRealtimeSupabase  (legacy aliases)
//   configure / getAppConfig / getRegistry / getProjectConfig /
//   listConfiguredProjects / resetRegistry
//   PROJECT_GOVERNANCE  (string constant)
//   hydrateAuthFromCookie / hydrateAuthFromIframeBridge /
//   persistAuthToCookie / clearAuthCookie / installAuthSync /
//   persistSupabaseSessionsToCookie / hydrateSupabaseSessionsFromCookie /
//   collectSdkTokens / collectSupabaseSessions / TOKEN_KEYS / SUPABASE_KEY_RE
parcelRequire("cVasv");
var $eEI3K = parcelRequire("eEI3K");
parcelRequire("e11aL");
var $qBiAs = parcelRequire("qBiAs");
var $9COKG = parcelRequire("9COKG");
var $jEfgr = parcelRequire("jEfgr");
var $cCMxT = parcelRequire("cCMxT");
const $6734181058d61ce4$export$a54df3be54843d98 = 'governance';
// Hardcoded fallback creds — the governance Supabase project the
// workspace has always pointed at. Kept so first-deploy boots without
// requiring SYMBOLS_APP_GOVERNANCE_SUPABASE_* env vars. Remove once
// every workspace build supplies env vars consistently.
const $6734181058d61ce4$var$GOVERNANCE_FALLBACK = {
    url: 'https://becrzpqaiovbvfmrosro.supabase.co',
    anonKey: 'sb_publishable_suMZ-1Crw-304sk_MY-VZA_8aU6ZFfa',
    anonJwt: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJlY3J6cHFhaW92YnZmbXJvc3JvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzU2MzE1NzAsImV4cCI6MjA5MTIwNzU3MH0.0vvvM-z9MJ2Zl2AhLBS-7gZ_eEci-GRDrFaFrdWD41U'
};
const $6734181058d61ce4$var$_descriptors = [
    {
        key: $6734181058d61ce4$export$a54df3be54843d98,
        opts: {
            required: true,
            fallback: $6734181058d61ce4$var$GOVERNANCE_FALLBACK,
            accessTokenTTL: 600,
            // Skip governance for users with only a personal org — landing on
            // a governance session with no team-org is pure cold-start waste.
            // Apps that want governance unconditionally pass
            // configure({ required: ['governance'] }) to bypass shouldActivate.
            shouldActivate: (claims)=>{
                const orgs = Array.isArray(claims?.orgs) ? claims.orgs : [];
                if (!orgs.length) return false;
                const hasType = orgs.some((o)=>o.type != null);
                if (!hasType) return true;
                return orgs.some((o)=>o.type === 'team');
            }
        }
    }
];
let $6734181058d61ce4$var$_registry = null;
let $6734181058d61ce4$var$_registryConfig = null;
let $6734181058d61ce4$var$_auth = null;
let $6734181058d61ce4$var$_appConfig = null;
const $6734181058d61ce4$var$_ensure = ()=>{
    if ($6734181058d61ce4$var$_registry) return;
    $6734181058d61ce4$var$_registryConfig = (0, $qBiAs.buildRegistryConfig)($6734181058d61ce4$var$_descriptors);
    $6734181058d61ce4$var$_registry = (0, $eEI3K.createRegistry)({
        projects: $6734181058d61ce4$var$_registryConfig,
        defaultKey: $6734181058d61ce4$export$a54df3be54843d98,
        buildClient: (0, $cCMxT.createSupabaseClient)
    });
    $6734181058d61ce4$var$_appConfig = (0, $qBiAs.createAppConfig)(()=>$6734181058d61ce4$var$_registryConfig);
    $6734181058d61ce4$var$_auth = (0, $9COKG.createAuthBridge)({
        registry: $6734181058d61ce4$var$_registry,
        appConfig: $6734181058d61ce4$var$_appConfig
    });
};
const $6734181058d61ce4$export$6bb76d6eba7e258c = (key = $6734181058d61ce4$export$a54df3be54843d98)=>{
    $6734181058d61ce4$var$_ensure();
    return $6734181058d61ce4$var$_registry.getClient(key);
};
const $6734181058d61ce4$export$80567c6129dc5041 = async (key)=>$6734181058d61ce4$export$6bb76d6eba7e258c(key);
const $6734181058d61ce4$export$f29328267663ba07 = (fn)=>{
    $6734181058d61ce4$var$_ensure();
    return $6734181058d61ce4$var$_registry.forEachClient(fn);
};
const $6734181058d61ce4$export$a66dfc2c6da0bd3 = ()=>{
    $6734181058d61ce4$var$_ensure();
    return $6734181058d61ce4$var$_registry.reset();
};
const $6734181058d61ce4$export$39d7fc5adc3c75a1 = ()=>{
    $6734181058d61ce4$var$_ensure();
    return $6734181058d61ce4$var$_registryConfig;
};
const $6734181058d61ce4$export$bad43d745a81bbd5 = (key)=>{
    $6734181058d61ce4$var$_ensure();
    const cfg = $6734181058d61ce4$var$_registryConfig[key];
    if (!cfg && key === $6734181058d61ce4$export$a54df3be54843d98) throw new Error('[governanceBridge] governance project not configured');
    return cfg || null;
};
const $6734181058d61ce4$export$a44e0967006104d0 = ()=>{
    $6734181058d61ce4$var$_ensure();
    return Object.keys($6734181058d61ce4$var$_registryConfig);
};
const $6734181058d61ce4$export$b668408ac8206d2f = ()=>{
    $6734181058d61ce4$var$_registry = null;
    $6734181058d61ce4$var$_registryConfig = null;
    $6734181058d61ce4$var$_auth = null;
    $6734181058d61ce4$var$_appConfig = null;
};
const $6734181058d61ce4$export$8d21e34596265fa2 = (opts)=>{
    $6734181058d61ce4$var$_ensure();
    $6734181058d61ce4$var$_appConfig.configure(opts);
};
const $6734181058d61ce4$export$544aaded68bb6ae2 = ()=>{
    $6734181058d61ce4$var$_ensure();
    return $6734181058d61ce4$var$_appConfig.get();
};
const $6734181058d61ce4$export$71d050677f938d04 = (args)=>{
    $6734181058d61ce4$var$_ensure();
    return $6734181058d61ce4$var$_auth.loginAll(args);
};
const $6734181058d61ce4$export$4d932ebd88db07ee = ()=>{
    $6734181058d61ce4$var$_ensure();
    return $6734181058d61ce4$var$_auth.logoutAll();
};
const $6734181058d61ce4$export$c3cb4d92231617a0 = (id)=>{
    $6734181058d61ce4$var$_ensure();
    return $6734181058d61ce4$var$_auth.switchWorkspace(id);
};
const $6734181058d61ce4$export$fd23a70622d440f6 = ()=>{
    $6734181058d61ce4$var$_ensure();
    return $6734181058d61ce4$var$_auth.refreshClaims();
};
const $6734181058d61ce4$export$b45be625a0b963d1 = (k, a)=>{
    $6734181058d61ce4$var$_ensure();
    return $6734181058d61ce4$var$_auth.activateExtension(k, a);
};
const $6734181058d61ce4$export$2e94b40918c1ba70 = ()=>{
    $6734181058d61ce4$var$_ensure();
    return $6734181058d61ce4$var$_auth.getSymbolsToken();
};
const $6734181058d61ce4$export$6f5cc5586c0c38b3 = ()=>{
    $6734181058d61ce4$var$_ensure();
    return $6734181058d61ce4$var$_auth.getSessionStatus();
};
const $6734181058d61ce4$export$d90c31306ea565a5 = ()=>$6734181058d61ce4$export$6bb76d6eba7e258c($6734181058d61ce4$export$a54df3be54843d98);
const $6734181058d61ce4$export$dd45a343b6ac2ea2 = async ()=>$6734181058d61ce4$export$6bb76d6eba7e258c($6734181058d61ce4$export$a54df3be54843d98);
const $6734181058d61ce4$export$973cffe86a0bea52 = $6734181058d61ce4$export$dd45a343b6ac2ea2;
// ── Cross-app auth (canvas ↔ workspace cookie + iframe sync) ─────────
// Peer resolution: cookies with domain=.localhost are silently dropped
// by Chrome, so the cookie strategy only works on prod .symbols.app.
// In dev we iframe the peer's `/_session-bridge` route.
function $6734181058d61ce4$var$peerOrigin() {
    if (typeof window === 'undefined') return null;
    const host = window.location.hostname;
    const isCanvas = host.startsWith('canvas.') || host === 'edit.symbols.app';
    const isWorkspace = host.startsWith('workspace.') || host.startsWith('system-governance-intranet.') || host.startsWith('governance-intranet.') || host === 'us-at.symbols.app';
    if (host.endsWith('.localhost') || host === 'localhost') {
        if (isCanvas) return 'http://workspace.localhost:1355';
        if (isWorkspace) return 'http://canvas.localhost:1355';
        return null;
    }
    if (host.endsWith('.symbols.app')) {
        if (isCanvas) return 'https://us-at.symbols.app';
        if (isWorkspace) return 'https://edit.symbols.app';
        return null;
    }
    return null;
}
const $6734181058d61ce4$var$_crossApp = (0, $jEfgr.createCrossAppAuth)({
    resolvePeerOrigin: $6734181058d61ce4$var$peerOrigin
});
const $6734181058d61ce4$export$332974f1fffb359a = $6734181058d61ce4$var$_crossApp.TOKEN_KEYS;
const $6734181058d61ce4$export$ef001aa7c423f822 = $6734181058d61ce4$var$_crossApp.SUPABASE_KEY_RE;
const $6734181058d61ce4$export$a299b57594f93420 = $6734181058d61ce4$var$_crossApp.hydrateAuthFromCookie;
const $6734181058d61ce4$export$45cb7059e7c59007 = $6734181058d61ce4$var$_crossApp.hydrateAuthFromIframeBridge;
const $6734181058d61ce4$export$d5d56450a6fb624 = $6734181058d61ce4$var$_crossApp.persistAuthToCookie;
const $6734181058d61ce4$export$5d31187a0cdf795a = $6734181058d61ce4$var$_crossApp.clearAuthCookie;
const $6734181058d61ce4$export$6c3ff1d8842f6efd = $6734181058d61ce4$var$_crossApp.installAuthSync;
const $6734181058d61ce4$export$b0e7e9532d134e9a = $6734181058d61ce4$var$_crossApp.persistSupabaseSessionsToCookie;
const $6734181058d61ce4$export$bd8aba6d048d19e4 = $6734181058d61ce4$var$_crossApp.hydrateSupabaseSessionsFromCookie;
const $6734181058d61ce4$export$2caf675105ee535 = $6734181058d61ce4$var$_crossApp.collectSdkTokens;
const $6734181058d61ce4$export$e7a829cfe6b87f06 = $6734181058d61ce4$var$_crossApp.collectSupabaseSessions;
const $6734181058d61ce4$export$b9a931cef18d6e89 = null;
const $6734181058d61ce4$export$22374d636991e1aa = null;
const $6734181058d61ce4$export$9ca20373711d1316 = null;
const $6734181058d61ce4$export$99634018ea086848 = null;

});
parcelRegister("cVasv", function(module, exports) {

$parcel$export(module.exports, "createRegistry", () => (parcelRequire("eEI3K")).createRegistry);
$parcel$export(module.exports, "readCookie", () => (parcelRequire("bOdwG")).readCookie);
$parcel$export(module.exports, "writeCookie", () => (parcelRequire("bOdwG")).writeCookie);
// @symbo.ls/sdk-bridge
// Abstract federation primitive — registry + client cache + storage.
// Knows nothing about Supabase or any specific backend; supply your own
// `buildClient(cfg)` to plug it in. For Supabase consumers see
// @symbo.ls/sdk-supabase-bridge.

var $eEI3K = parcelRequire("eEI3K");

var $bOdwG = parcelRequire("bOdwG");

var $5CYVz = parcelRequire("5CYVz");

});
parcelRegister("eEI3K", function(module, exports) {

$parcel$export(module.exports, "createRegistry", () => $aab6fa6b6535a073$export$b877d3ed23ba6b7a);
// Abstract project registry. Holds project configs (key + arbitrary
// metadata) and a generic client cache keyed by project. The registry
// itself does not know what a "client" is — it just memoizes whatever
// `buildClient(cfg)` returns. Backend-specific layers (e.g.
// @symbo.ls/sdk-supabase-bridge) supply the buildClient strategy.
function $aab6fa6b6535a073$export$b877d3ed23ba6b7a({ projects: projects = {}, defaultKey: defaultKey, buildClient: buildClient } = {}) {
    if (typeof buildClient !== 'function') throw new Error('createRegistry: buildClient(cfg) function required');
    const _registry = {
        ...projects
    };
    const _clients = new Map();
    const getProjectConfig = (key)=>_registry[key] || null;
    const listConfiguredProjects = ()=>Object.keys(_registry);
    const getClient = (key = defaultKey)=>{
        if (!key) return null;
        if (_clients.has(key)) return _clients.get(key);
        const cfg = _registry[key];
        if (!cfg) return null;
        const client = buildClient(cfg);
        _clients.set(key, client);
        return client;
    };
    const getClientAsync = async (key)=>getClient(key);
    const forEachClient = (fn)=>{
        for (const key of listConfiguredProjects()){
            const client = getClient(key);
            if (client) fn(client, key);
        }
    };
    const getDefaultClient = ()=>getClient(defaultKey);
    const addProject = (key, cfg)=>{
        _registry[key] = cfg;
        _clients.delete(key);
    };
    const removeProject = (key)=>{
        delete _registry[key];
        _clients.delete(key);
    };
    const reset = ()=>{
        _clients.clear();
    };
    return {
        getClient: getClient,
        getClientAsync: getClientAsync,
        getProjectConfig: getProjectConfig,
        listConfiguredProjects: listConfiguredProjects,
        forEachClient: forEachClient,
        getDefaultClient: getDefaultClient,
        addProject: addProject,
        removeProject: removeProject,
        reset: reset
    };
}

});

parcelRegister("bOdwG", function(module, exports) {

$parcel$export(module.exports, "readCookie", () => $898edb3e75d77132$export$bead674655ff515d);
$parcel$export(module.exports, "writeCookie", () => $898edb3e75d77132$export$a673831a9bd037e1);
// Parent-domain-scoped cookie helpers. Browser-only. Used by cross-app
// auth sync, shared user-prefs, and any cross-tab/cross-subdomain feature
// that needs a tabular handoff.
function $898edb3e75d77132$export$3b1f1e712ed06a51(hostname = typeof window !== 'undefined' ? window.location.hostname : '') {
    if (!hostname) return null;
    if (hostname === 'localhost' || hostname.endsWith('.localhost')) return '.localhost';
    if (hostname.endsWith('.symbols.app')) return '.symbols.app';
    return null;
}
function $898edb3e75d77132$export$bead674655ff515d(name) {
    if (typeof document === 'undefined') return null;
    const prefix = name + '=';
    for (const p of document.cookie.split(';')){
        const c = p.trim();
        if (!c.startsWith(prefix)) continue;
        try {
            return decodeURIComponent(c.slice(prefix.length));
        } catch  {
            return null;
        }
    }
    return null;
}
function $898edb3e75d77132$export$a673831a9bd037e1(name, value, maxAge) {
    if (typeof document === 'undefined') return;
    const domain = $898edb3e75d77132$export$3b1f1e712ed06a51(window.location.hostname);
    const encoded = value == null ? '' : encodeURIComponent(String(value));
    const age = value == null ? 0 : maxAge;
    const attrs = [
        `${name}=${encoded}`,
        'path=/',
        `max-age=${age}`,
        'SameSite=Lax'
    ];
    if (domain) attrs.push(`domain=${domain}`);
    if (window.location.protocol === 'https:') attrs.push('Secure');
    document.cookie = attrs.join('; ');
}

});

parcelRegister("5CYVz", function(module, exports) {
// Safe localStorage wrappers. Browser-only; no-op in SSR. Used by bridges
// to stash short-lived tokens, app-level prefs, and similar lightweight
// scalars without crashing on Node or in privacy-mode tabs.
function $418fc34b677c187e$export$a74ecae7a346dc64(key) {
    if (typeof window === 'undefined') return null;
    try {
        return window.localStorage.getItem(key);
    } catch  {
        return null;
    }
}
function $418fc34b677c187e$export$330a8aa32aa99ddb(key, value) {
    if (typeof window === 'undefined') return;
    try {
        if (value == null) window.localStorage.removeItem(key);
        else window.localStorage.setItem(key, String(value));
    } catch  {}
}
function $418fc34b677c187e$export$d7a0b846d036443e(key) {
    $418fc34b677c187e$export$330a8aa32aa99ddb(key, null);
}

});


parcelRegister("e11aL", function(module, exports) {

$parcel$export(module.exports, "createSupabaseClient", () => (parcelRequire("cCMxT")).createSupabaseClient);
$parcel$export(module.exports, "buildRegistryConfig", () => (parcelRequire("qBiAs")).buildRegistryConfig);
$parcel$export(module.exports, "createAppConfig", () => (parcelRequire("qBiAs")).createAppConfig);
$parcel$export(module.exports, "createAuthBridge", () => (parcelRequire("9COKG")).createAuthBridge);
$parcel$export(module.exports, "createCrossAppAuth", () => (parcelRequire("jEfgr")).createCrossAppAuth);
// @symbo.ls/sdk-supabase-bridge
//
// Supabase-flavoured federation bridge built on @symbo.ls/sdk-bridge.
// Multi-project auth, registry-driven Supabase client cache, edge-
// function login/logout/switch primitives. Consumer wires it once at
// boot — supply the project list, drive logins through the returned
// auth object.
//
//   import { createSupabaseBridge, readProject } from '@symbo.ls/sdk-supabase-bridge'
//
//   const bridge = createSupabaseBridge({
//     projects: [
//       { key: 'governance', opts: { required: true, fallback: { url, anonKey } } },
//       { key: 'financials', opts: { required: false, roleGate: ['admin'] } }
//     ],
//     defaultKey: 'governance',
//     appConfig: { required: ['governance'] }
//   })
//
//   await bridge.auth.loginAll({ email, password })
//   const client = bridge.registry.getClient('governance')
//
// Project-specific glue (PROJECT_GOVERNANCE/FINANCIALS constants,
// integrations catalog, MCP, prefs) lives in the consumer package.
parcelRequire("cVasv");
var $eEI3K = parcelRequire("eEI3K");

var $cCMxT = parcelRequire("cCMxT");

var $qBiAs = parcelRequire("qBiAs");

var $9COKG = parcelRequire("9COKG");

var $jEfgr = parcelRequire("jEfgr");
function $a342119088c882ba$export$70d0ce130d54313d({ projects: projects = [], defaultKey: defaultKey, appConfig: appConfigOverride = null, crossAppAuth: crossAppAuthOpts = null, authBridge: authBridgeOpts = {} } = {}) {
    const registryConfig = (0, $qBiAs.buildRegistryConfig)(projects);
    const registry = (0, $eEI3K.createRegistry)({
        projects: registryConfig,
        defaultKey: defaultKey,
        buildClient: (0, $cCMxT.createSupabaseClient)
    });
    const appConfig = (0, $qBiAs.createAppConfig)(()=>registryConfig);
    if (appConfigOverride) appConfig.configure(appConfigOverride);
    const auth = (0, $9COKG.createAuthBridge)({
        registry: registry,
        appConfig: appConfig,
        ...authBridgeOpts
    });
    const crossAppAuth = crossAppAuthOpts ? (0, $jEfgr.createCrossAppAuth)(crossAppAuthOpts) : null;
    return {
        registry: registry,
        appConfig: appConfig,
        auth: auth,
        crossAppAuth: crossAppAuth,
        registryConfig: registryConfig
    };
}

});
parcelRegister("cCMxT", function(module, exports) {

$parcel$export(module.exports, "createSupabaseClient", () => $930eb0c7e247b39b$export$b4be5d92eb7c243a);
// Supabase client builder. Factory consumed by createRegistry to mint a
// project-keyed cache. Identical wiring to a hand-rolled createClient
// call but keeps realtime token in sync with auth-js refreshes — without
// it, long-lived tabs hit InvalidJWTToken on realtime channels because
// the socket holds the initial token while auth-js rotates silently.

var $dNnfS = parcelRequire("dNnfS");
function $930eb0c7e247b39b$export$b4be5d92eb7c243a(cfg) {
    if (!cfg) throw new Error('createSupabaseClient: config required');
    if (!cfg.url) throw new Error('createSupabaseClient: url required');
    const apiKey = cfg.anonJwt || cfg.anonKey;
    if (!apiKey) throw new Error('createSupabaseClient: anonJwt or anonKey required');
    const client = (0, $dNnfS.createClient)(cfg.url, apiKey, {
        realtime: {
            params: {
                eventsPerSecond: 20
            }
        },
        auth: {
            persistSession: true,
            autoRefreshToken: true
        }
    });
    client.auth.onAuthStateChange((_event, session)=>{
        try {
            client.realtime.setAuth(session?.access_token || cfg.anonJwt || cfg.anonKey);
        } catch (err) {
            console.error(`[sdk-supabase-bridge] realtime.setAuth failed on ${cfg.key}:`, err);
        }
    });
    return client;
}

});
parcelRegister("dNnfS", function(module, exports) {

$parcel$export(module.exports, "createClient", () => $5e33485c08cd650a$export$5d730b7aed1a3eb0);

var $9A7Ck = parcelRequire("9A7Ck");

var $4yorG = parcelRequire("4yorG");
parcelRequire("izHZ4");
var $eWiay = parcelRequire("eWiay");

var $9Yl9w = parcelRequire("9Yl9w");
parcelRequire("lpqci");
var $aALRH = parcelRequire("aALRH");
//#region src/lib/version.ts
const $5e33485c08cd650a$var$version = "2.105.3";
//#endregion
//#region src/lib/constants.ts
let $5e33485c08cd650a$var$JS_ENV = "";
if (typeof Deno !== "undefined") $5e33485c08cd650a$var$JS_ENV = "deno";
else if (typeof document !== "undefined") $5e33485c08cd650a$var$JS_ENV = "web";
else if (typeof navigator !== "undefined" && navigator.product === "ReactNative") $5e33485c08cd650a$var$JS_ENV = "react-native";
else $5e33485c08cd650a$var$JS_ENV = "node";
const $5e33485c08cd650a$var$DEFAULT_HEADERS = {
    "X-Client-Info": `supabase-js-${$5e33485c08cd650a$var$JS_ENV}/${$5e33485c08cd650a$var$version}`
};
const $5e33485c08cd650a$var$DEFAULT_GLOBAL_OPTIONS = {
    headers: $5e33485c08cd650a$var$DEFAULT_HEADERS
};
const $5e33485c08cd650a$var$DEFAULT_DB_OPTIONS = {
    schema: "public"
};
const $5e33485c08cd650a$var$DEFAULT_AUTH_OPTIONS = {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: "implicit"
};
const $5e33485c08cd650a$var$DEFAULT_REALTIME_OPTIONS = {};
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/typeof.js
function $5e33485c08cd650a$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $5e33485c08cd650a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o$1) {
        return typeof o$1;
    } : function(o$1) {
        return o$1 && "function" == typeof Symbol && o$1.constructor === Symbol && o$1 !== Symbol.prototype ? "symbol" : typeof o$1;
    }, $5e33485c08cd650a$var$_typeof(o);
}
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/toPrimitive.js
function $5e33485c08cd650a$var$toPrimitive(t, r) {
    if ("object" != $5e33485c08cd650a$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $5e33485c08cd650a$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/toPropertyKey.js
function $5e33485c08cd650a$var$toPropertyKey(t) {
    var i = $5e33485c08cd650a$var$toPrimitive(t, "string");
    return "symbol" == $5e33485c08cd650a$var$_typeof(i) ? i : i + "";
}
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/defineProperty.js
function $5e33485c08cd650a$var$_defineProperty(e, r, t) {
    return (r = $5e33485c08cd650a$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/objectSpread2.js
function $5e33485c08cd650a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r$1) {
            return Object.getOwnPropertyDescriptor(e, r$1).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5e33485c08cd650a$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5e33485c08cd650a$var$ownKeys(Object(t), !0).forEach(function(r$1) {
            $5e33485c08cd650a$var$_defineProperty(e, r$1, t[r$1]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5e33485c08cd650a$var$ownKeys(Object(t)).forEach(function(r$1) {
            Object.defineProperty(e, r$1, Object.getOwnPropertyDescriptor(t, r$1));
        });
    }
    return e;
}
//#endregion
//#region src/lib/fetch.ts
const $5e33485c08cd650a$var$resolveFetch = (customFetch)=>{
    if (customFetch) return (...args)=>customFetch(...args);
    return (...args)=>fetch(...args);
};
const $5e33485c08cd650a$var$resolveHeadersConstructor = ()=>{
    return Headers;
};
const $5e33485c08cd650a$var$fetchWithAuth = (supabaseKey, getAccessToken, customFetch)=>{
    const fetch$1 = $5e33485c08cd650a$var$resolveFetch(customFetch);
    const HeadersConstructor = $5e33485c08cd650a$var$resolveHeadersConstructor();
    return async (input, init)=>{
        var _await$getAccessToken;
        const accessToken = (_await$getAccessToken = await getAccessToken()) !== null && _await$getAccessToken !== void 0 ? _await$getAccessToken : supabaseKey;
        let headers = new HeadersConstructor(init === null || init === void 0 ? void 0 : init.headers);
        if (!headers.has("apikey")) headers.set("apikey", supabaseKey);
        if (!headers.has("Authorization")) headers.set("Authorization", `Bearer ${accessToken}`);
        return fetch$1(input, $5e33485c08cd650a$var$_objectSpread2($5e33485c08cd650a$var$_objectSpread2({}, init), {}, {
            headers: headers
        }));
    };
};
//#endregion
//#region src/lib/helpers.ts
function $5e33485c08cd650a$var$ensureTrailingSlash(url) {
    return url.endsWith("/") ? url : url + "/";
}
function $5e33485c08cd650a$var$applySettingDefaults(options, defaults) {
    var _DEFAULT_GLOBAL_OPTIO, _globalOptions$header;
    const { db: dbOptions, auth: authOptions, realtime: realtimeOptions, global: globalOptions } = options;
    const { db: DEFAULT_DB_OPTIONS$1, auth: DEFAULT_AUTH_OPTIONS$1, realtime: DEFAULT_REALTIME_OPTIONS$1, global: DEFAULT_GLOBAL_OPTIONS$1 } = defaults;
    const result = {
        db: $5e33485c08cd650a$var$_objectSpread2($5e33485c08cd650a$var$_objectSpread2({}, DEFAULT_DB_OPTIONS$1), dbOptions),
        auth: $5e33485c08cd650a$var$_objectSpread2($5e33485c08cd650a$var$_objectSpread2({}, DEFAULT_AUTH_OPTIONS$1), authOptions),
        realtime: $5e33485c08cd650a$var$_objectSpread2($5e33485c08cd650a$var$_objectSpread2({}, DEFAULT_REALTIME_OPTIONS$1), realtimeOptions),
        storage: {},
        global: $5e33485c08cd650a$var$_objectSpread2($5e33485c08cd650a$var$_objectSpread2($5e33485c08cd650a$var$_objectSpread2({}, DEFAULT_GLOBAL_OPTIONS$1), globalOptions), {}, {
            headers: $5e33485c08cd650a$var$_objectSpread2($5e33485c08cd650a$var$_objectSpread2({}, (_DEFAULT_GLOBAL_OPTIO = DEFAULT_GLOBAL_OPTIONS$1 === null || DEFAULT_GLOBAL_OPTIONS$1 === void 0 ? void 0 : DEFAULT_GLOBAL_OPTIONS$1.headers) !== null && _DEFAULT_GLOBAL_OPTIO !== void 0 ? _DEFAULT_GLOBAL_OPTIO : {}), (_globalOptions$header = globalOptions === null || globalOptions === void 0 ? void 0 : globalOptions.headers) !== null && _globalOptions$header !== void 0 ? _globalOptions$header : {})
        }),
        accessToken: async ()=>""
    };
    if (options.accessToken) result.accessToken = options.accessToken;
    else delete result.accessToken;
    return result;
}
/**
* Validates a Supabase client URL
*
* @param {string} supabaseUrl - The Supabase client URL string.
* @returns {URL} - The validated base URL.
* @throws {Error}
*/ function $5e33485c08cd650a$var$validateSupabaseUrl(supabaseUrl) {
    const trimmedUrl = supabaseUrl === null || supabaseUrl === void 0 ? void 0 : supabaseUrl.trim();
    if (!trimmedUrl) throw new Error("supabaseUrl is required.");
    if (!trimmedUrl.match(/^https?:\/\//i)) throw new Error("Invalid supabaseUrl: Must be a valid HTTP or HTTPS URL.");
    try {
        return new URL($5e33485c08cd650a$var$ensureTrailingSlash(trimmedUrl));
    } catch (_unused) {
        throw Error("Invalid supabaseUrl: Provided URL is malformed.");
    }
}
//#endregion
//#region src/lib/SupabaseAuthClient.ts
var $5e33485c08cd650a$var$SupabaseAuthClient = class extends (0, $aALRH.default) {
    constructor(options){
        super(options);
    }
};
//#endregion
//#region src/SupabaseClient.ts
/**
* Supabase Client.
*
* An isomorphic Javascript client for interacting with Postgres.
*/ var $5e33485c08cd650a$export$1bfe63e045eb2ffa = class {
    /**
	* Create a new client for use in the browser.
	*
	* @category Initializing
	*
	* @param supabaseUrl The unique Supabase URL which is supplied when you create a new project in your project dashboard.
	* @param supabaseKey The unique Supabase Key which is supplied when you create a new project in your project dashboard.
	* @param options.db.schema You can switch in between schemas. The schema needs to be on the list of exposed schemas inside Supabase.
	* @param options.auth.autoRefreshToken Set to "true" if you want to automatically refresh the token before expiring.
	* @param options.auth.persistSession Set to "true" if you want to automatically save the user session into local storage.
	* @param options.auth.detectSessionInUrl Set to "true" if you want to automatically detects OAuth grants in the URL and signs in the user.
	* @param options.realtime Options passed along to realtime-js constructor.
	* @param options.storage Options passed along to the storage-js constructor.
	* @param options.global.fetch A custom fetch implementation.
	* @param options.global.headers Any additional headers to send with each network request.
	*
	* @example Creating a client
	* ```js
	* import { createClient } from '@supabase/supabase-js'
	*
	* // Create a single supabase client for interacting with your database
	* const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
	* ```
	*
	* @example With a custom domain
	* ```js
	* import { createClient } from '@supabase/supabase-js'
	*
	* // Use a custom domain as the supabase URL
	* const supabase = createClient('https://my-custom-domain.com', 'your-publishable-key')
	* ```
	*
	* @example With additional parameters
	* ```js
	* import { createClient } from '@supabase/supabase-js'
	*
	* const options = {
	*   db: {
	*     schema: 'public',
	*   },
	*   auth: {
	*     autoRefreshToken: true,
	*     persistSession: true,
	*     detectSessionInUrl: true
	*   },
	*   global: {
	*     headers: { 'x-my-custom-header': 'my-app-name' },
	*   },
	* }
	* const supabase = createClient("https://xyzcompany.supabase.co", "your-publishable-key", options)
	* ```
	*
	* @exampleDescription With custom schemas
	* By default the API server points to the `public` schema. You can enable other database schemas within the Dashboard.
	* Go to [Settings > API > Exposed schemas](/dashboard/project/_/settings/api) and add the schema which you want to expose to the API.
	*
	* Note: each client connection can only access a single schema, so the code above can access the `other_schema` schema but cannot access the `public` schema.
	*
	* @example With custom schemas
	* ```js
	* import { createClient } from '@supabase/supabase-js'
	*
	* const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key', {
	*   // Provide a custom schema. Defaults to "public".
	*   db: { schema: 'other_schema' }
	* })
	* ```
	*
	* @exampleDescription Custom fetch implementation
	* `supabase-js` uses the [`cross-fetch`](https://www.npmjs.com/package/cross-fetch) library to make HTTP requests,
	* but an alternative `fetch` implementation can be provided as an option.
	* This is most useful in environments where `cross-fetch` is not compatible (for instance Cloudflare Workers).
	*
	* @example Custom fetch implementation
	* ```js
	* import { createClient } from '@supabase/supabase-js'
	*
	* const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key', {
	*   global: { fetch: fetch.bind(globalThis) }
	* })
	* ```
	*
	* @exampleDescription React Native options with AsyncStorage
	* For React Native we recommend using `AsyncStorage` as the storage implementation for Supabase Auth.
	*
	* @example React Native options with AsyncStorage
	* ```js
	* import 'react-native-url-polyfill/auto'
	* import { createClient } from '@supabase/supabase-js'
	* import AsyncStorage from "@react-native-async-storage/async-storage";
	*
	* const supabase = createClient("https://xyzcompany.supabase.co", "your-publishable-key", {
	*   auth: {
	*     storage: AsyncStorage,
	*     autoRefreshToken: true,
	*     persistSession: true,
	*     detectSessionInUrl: false,
	*   },
	* });
	* ```
	*
	* @exampleDescription React Native options with Expo SecureStore
	* If you wish to encrypt the user's session information, you can use `aes-js` and store the encryption key in Expo SecureStore.
	* The `aes-js` library, a reputable JavaScript-only implementation of the AES encryption algorithm in CTR mode.
	* A new 256-bit encryption key is generated using the `react-native-get-random-values` library.
	* This key is stored inside Expo's SecureStore, while the value is encrypted and placed inside AsyncStorage.
	*
	* Please make sure that:
	* - You keep the `expo-secure-store`, `aes-js` and `react-native-get-random-values` libraries up-to-date.
	* - Choose the correct [`SecureStoreOptions`](https://docs.expo.dev/versions/latest/sdk/securestore/#securestoreoptions) for your app's needs.
	*   E.g. [`SecureStore.WHEN_UNLOCKED`](https://docs.expo.dev/versions/latest/sdk/securestore/#securestorewhen_unlocked) regulates when the data can be accessed.
	* - Carefully consider optimizations or other modifications to the above example, as those can lead to introducing subtle security vulnerabilities.
	*
	* @example React Native options with Expo SecureStore
	* ```ts
	* import 'react-native-url-polyfill/auto'
	* import { createClient } from '@supabase/supabase-js'
	* import AsyncStorage from '@react-native-async-storage/async-storage';
	* import * as SecureStore from 'expo-secure-store';
	* import * as aesjs from 'aes-js';
	* import 'react-native-get-random-values';
	*
	* // As Expo's SecureStore does not support values larger than 2048
	* // bytes, an AES-256 key is generated and stored in SecureStore, while
	* // it is used to encrypt/decrypt values stored in AsyncStorage.
	* class LargeSecureStore {
	*   private async _encrypt(key: string, value: string) {
	*     const encryptionKey = crypto.getRandomValues(new Uint8Array(256 / 8));
	*
	*     const cipher = new aesjs.ModeOfOperation.ctr(encryptionKey, new aesjs.Counter(1));
	*     const encryptedBytes = cipher.encrypt(aesjs.utils.utf8.toBytes(value));
	*
	*     await SecureStore.setItemAsync(key, aesjs.utils.hex.fromBytes(encryptionKey));
	*
	*     return aesjs.utils.hex.fromBytes(encryptedBytes);
	*   }
	*
	*   private async _decrypt(key: string, value: string) {
	*     const encryptionKeyHex = await SecureStore.getItemAsync(key);
	*     if (!encryptionKeyHex) {
	*       return encryptionKeyHex;
	*     }
	*
	*     const cipher = new aesjs.ModeOfOperation.ctr(aesjs.utils.hex.toBytes(encryptionKeyHex), new aesjs.Counter(1));
	*     const decryptedBytes = cipher.decrypt(aesjs.utils.hex.toBytes(value));
	*
	*     return aesjs.utils.utf8.fromBytes(decryptedBytes);
	*   }
	*
	*   async getItem(key: string) {
	*     const encrypted = await AsyncStorage.getItem(key);
	*     if (!encrypted) { return encrypted; }
	*
	*     return await this._decrypt(key, encrypted);
	*   }
	*
	*   async removeItem(key: string) {
	*     await AsyncStorage.removeItem(key);
	*     await SecureStore.deleteItemAsync(key);
	*   }
	*
	*   async setItem(key: string, value: string) {
	*     const encrypted = await this._encrypt(key, value);
	*
	*     await AsyncStorage.setItem(key, encrypted);
	*   }
	* }
	*
	* const supabase = createClient("https://xyzcompany.supabase.co", "your-publishable-key", {
	*   auth: {
	*     storage: new LargeSecureStore(),
	*     autoRefreshToken: true,
	*     persistSession: true,
	*     detectSessionInUrl: false,
	*   },
	* });
	* ```
	*
	* @example With a database query
	* ```ts
	* import { createClient } from '@supabase/supabase-js'
	*
	* const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
	*
	* const { data } = await supabase.from('profiles').select('*')
	* ```
	*/ constructor(supabaseUrl, supabaseKey, options){
        var _settings$auth$storag, _settings$global$head;
        this.supabaseUrl = supabaseUrl;
        this.supabaseKey = supabaseKey;
        const baseUrl = $5e33485c08cd650a$var$validateSupabaseUrl(supabaseUrl);
        if (!supabaseKey) throw new Error("supabaseKey is required.");
        this.realtimeUrl = new URL("realtime/v1", baseUrl);
        this.realtimeUrl.protocol = this.realtimeUrl.protocol.replace("http", "ws");
        this.authUrl = new URL("auth/v1", baseUrl);
        this.storageUrl = new URL("storage/v1", baseUrl);
        this.functionsUrl = new URL("functions/v1", baseUrl);
        const defaultStorageKey = `sb-${baseUrl.hostname.split(".")[0]}-auth-token`;
        const DEFAULTS = {
            db: $5e33485c08cd650a$var$DEFAULT_DB_OPTIONS,
            realtime: $5e33485c08cd650a$var$DEFAULT_REALTIME_OPTIONS,
            auth: $5e33485c08cd650a$var$_objectSpread2($5e33485c08cd650a$var$_objectSpread2({}, $5e33485c08cd650a$var$DEFAULT_AUTH_OPTIONS), {}, {
                storageKey: defaultStorageKey
            }),
            global: $5e33485c08cd650a$var$DEFAULT_GLOBAL_OPTIONS
        };
        const settings = $5e33485c08cd650a$var$applySettingDefaults(options !== null && options !== void 0 ? options : {}, DEFAULTS);
        this.storageKey = (_settings$auth$storag = settings.auth.storageKey) !== null && _settings$auth$storag !== void 0 ? _settings$auth$storag : "";
        this.headers = (_settings$global$head = settings.global.headers) !== null && _settings$global$head !== void 0 ? _settings$global$head : {};
        if (!settings.accessToken) {
            var _settings$auth;
            this.auth = this._initSupabaseAuthClient((_settings$auth = settings.auth) !== null && _settings$auth !== void 0 ? _settings$auth : {}, this.headers, settings.global.fetch);
        } else {
            this.accessToken = settings.accessToken;
            this.auth = new Proxy({}, {
                get: (_, prop)=>{
                    throw new Error(`@supabase/supabase-js: Supabase Client is configured with the accessToken option, accessing supabase.auth.${String(prop)} is not possible`);
                }
            });
        }
        this.fetch = $5e33485c08cd650a$var$fetchWithAuth(supabaseKey, this._getAccessToken.bind(this), settings.global.fetch);
        this.realtime = this._initRealtimeClient($5e33485c08cd650a$var$_objectSpread2({
            headers: this.headers,
            accessToken: this._getAccessToken.bind(this),
            fetch: this.fetch
        }, settings.realtime));
        if (this.accessToken) Promise.resolve(this.accessToken()).then((token)=>this.realtime.setAuth(token)).catch((e)=>console.warn("Failed to set initial Realtime auth token:", e));
        this.rest = new (0, $4yorG.PostgrestClient)(new URL("rest/v1", baseUrl).href, {
            headers: this.headers,
            schema: settings.db.schema,
            fetch: this.fetch,
            timeout: settings.db.timeout,
            urlLengthLimit: settings.db.urlLengthLimit
        });
        this.storage = new (0, $9Yl9w.StorageClient)(this.storageUrl.href, this.headers, this.fetch, options === null || options === void 0 ? void 0 : options.storage);
        if (!settings.accessToken) this._listenForAuthEvents();
    }
    /**
	* Supabase Functions allows you to deploy and invoke edge functions.
	*/ get functions() {
        return new (0, $9A7Ck.FunctionsClient)(this.functionsUrl.href, {
            headers: this.headers,
            customFetch: this.fetch
        });
    }
    /**
	* Perform a query on a table or a view.
	*
	* @param relation - The table or view name to query
	*/ from(relation) {
        return this.rest.from(relation);
    }
    /**
	* Select a schema to query or perform an function (rpc) call.
	*
	* The schema needs to be on the list of exposed schemas inside Supabase.
	*
	* @param schema - The schema to query
	*/ schema(schema) {
        return this.rest.schema(schema);
    }
    /**
	* Perform a function call.
	*
	* @param fn - The function name to call
	* @param args - The arguments to pass to the function call
	* @param options - Named parameters
	* @param options.head - When set to `true`, `data` will not be returned.
	* Useful if you only need the count.
	* @param options.get - When set to `true`, the function will be called with
	* read-only access mode.
	* @param options.count - Count algorithm to use to count rows returned by the
	* function. Only applicable for [set-returning
	* functions](https://www.postgresql.org/docs/current/functions-srf.html).
	*
	* `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
	* hood.
	*
	* `"planned"`: Approximated but fast count algorithm. Uses the Postgres
	* statistics under the hood.
	*
	* `"estimated"`: Uses exact count for low numbers and planned count for high
	* numbers.
	*/ rpc(fn, args = {}, options = {
        head: false,
        get: false,
        count: void 0
    }) {
        return this.rest.rpc(fn, args, options);
    }
    /**
	* Creates a Realtime channel with Broadcast, Presence, and Postgres Changes.
	*
	* @param {string} name - The name of the Realtime channel.
	* @param {Object} opts - The options to pass to the Realtime channel.
	*
	* @category Realtime
	*/ channel(name, opts = {
        config: {}
    }) {
        return this.realtime.channel(name, opts);
    }
    /**
	* Returns all Realtime channels.
	*
	* @category Realtime
	*
	* @example Get all channels
	* ```js
	* const channels = supabase.getChannels()
	* ```
	*/ getChannels() {
        return this.realtime.getChannels();
    }
    /**
	* Unsubscribes and removes Realtime channel from Realtime client.
	*
	* @param {RealtimeChannel} channel - The name of the Realtime channel.
	*
	*
	* @category Realtime
	*
	* @remarks
	* - Removing a channel is a great way to maintain the performance of your project's Realtime service as well as your database if you're listening to Postgres changes. Supabase will automatically handle cleanup 30 seconds after a client is disconnected, but unused channels may cause degradation as more clients are simultaneously subscribed.
	*
	* @example Removes a channel
	* ```js
	* supabase.removeChannel(myChannel)
	* ```
	*/ removeChannel(channel) {
        return this.realtime.removeChannel(channel);
    }
    /**
	* Unsubscribes and removes all Realtime channels from Realtime client.
	*
	* @category Realtime
	*
	* @remarks
	* - Removing channels is a great way to maintain the performance of your project's Realtime service as well as your database if you're listening to Postgres changes. Supabase will automatically handle cleanup 30 seconds after a client is disconnected, but unused channels may cause degradation as more clients are simultaneously subscribed.
	*
	* @example Remove all channels
	* ```js
	* supabase.removeAllChannels()
	* ```
	*/ removeAllChannels() {
        return this.realtime.removeAllChannels();
    }
    async _getAccessToken() {
        var _this = this;
        var _data$session$access_, _data$session;
        if (_this.accessToken) return await _this.accessToken();
        const { data: data } = await _this.auth.getSession();
        return (_data$session$access_ = (_data$session = data.session) === null || _data$session === void 0 ? void 0 : _data$session.access_token) !== null && _data$session$access_ !== void 0 ? _data$session$access_ : _this.supabaseKey;
    }
    _initSupabaseAuthClient({ autoRefreshToken: autoRefreshToken, persistSession: persistSession, detectSessionInUrl: detectSessionInUrl, storage: storage, userStorage: userStorage, storageKey: storageKey, flowType: flowType, lock: lock, debug: debug, throwOnError: throwOnError, experimental: experimental, lockAcquireTimeout: lockAcquireTimeout, skipAutoInitialize: skipAutoInitialize }, headers, fetch$1) {
        const authHeaders = {
            Authorization: `Bearer ${this.supabaseKey}`,
            apikey: `${this.supabaseKey}`
        };
        return new $5e33485c08cd650a$var$SupabaseAuthClient({
            url: this.authUrl.href,
            headers: $5e33485c08cd650a$var$_objectSpread2($5e33485c08cd650a$var$_objectSpread2({}, authHeaders), headers),
            storageKey: storageKey,
            autoRefreshToken: autoRefreshToken,
            persistSession: persistSession,
            detectSessionInUrl: detectSessionInUrl,
            storage: storage,
            userStorage: userStorage,
            flowType: flowType,
            lock: lock,
            debug: debug,
            throwOnError: throwOnError,
            experimental: experimental,
            fetch: fetch$1,
            lockAcquireTimeout: lockAcquireTimeout,
            skipAutoInitialize: skipAutoInitialize,
            hasCustomAuthorizationHeader: Object.keys(this.headers).some((key)=>key.toLowerCase() === "authorization")
        });
    }
    _initRealtimeClient(options) {
        return new (0, $eWiay.default)(this.realtimeUrl.href, $5e33485c08cd650a$var$_objectSpread2($5e33485c08cd650a$var$_objectSpread2({}, options), {}, {
            params: $5e33485c08cd650a$var$_objectSpread2($5e33485c08cd650a$var$_objectSpread2({}, {
                apikey: this.supabaseKey
            }), options === null || options === void 0 ? void 0 : options.params)
        }));
    }
    _listenForAuthEvents() {
        return this.auth.onAuthStateChange((event, session)=>{
            this._handleTokenChanged(event, "CLIENT", session === null || session === void 0 ? void 0 : session.access_token);
        });
    }
    _handleTokenChanged(event, source, token) {
        if ((event === "TOKEN_REFRESHED" || event === "SIGNED_IN") && this.changedAccessToken !== token) {
            this.changedAccessToken = token;
            this.realtime.setAuth(token);
        } else if (event === "SIGNED_OUT") {
            this.realtime.setAuth();
            if (source == "STORAGE") this.auth.signOut();
            this.changedAccessToken = void 0;
        }
    }
};
//#endregion
//#region src/index.ts
/**
* Creates a new Supabase Client.
*
* @example Creating a Supabase client
* ```ts
* import { createClient } from '@supabase/supabase-js'
*
* const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
* const { data, error } = await supabase.from('profiles').select('*')
* ```
*/ const $5e33485c08cd650a$export$5d730b7aed1a3eb0 = (supabaseUrl, supabaseKey, options)=>{
    return new $5e33485c08cd650a$export$1bfe63e045eb2ffa(supabaseUrl, supabaseKey, options);
};
function $5e33485c08cd650a$var$shouldShowDeprecationWarning() {
    if (typeof window !== "undefined") return false;
    const _process = globalThis["process"];
    if (!_process) return false;
    const processVersion = _process["version"];
    if (processVersion === void 0 || processVersion === null) return false;
    const versionMatch = processVersion.match(/^v(\d+)\./);
    if (!versionMatch) return false;
    return parseInt(versionMatch[1], 10) <= 18;
}
if ($5e33485c08cd650a$var$shouldShowDeprecationWarning()) console.warn("\u26A0\uFE0F  Node.js 18 and below are deprecated and will no longer be supported in future versions of @supabase/supabase-js. Please upgrade to Node.js 20 or later. For more information, visit: https://github.com/orgs/supabase/discussions/37217");

});
parcelRegister("9A7Ck", function(module, exports) {

$parcel$export(module.exports, "FunctionsClient", () => $6f9d627d4ebb0255$export$1d0b400bf8a0fa55);

var $7WQrb = parcelRequire("7WQrb");

var $ffULL = parcelRequire("ffULL");

var $1oqCS = parcelRequire("1oqCS");
class $6f9d627d4ebb0255$export$1d0b400bf8a0fa55 {
    /**
     * Creates a new Functions client bound to an Edge Functions URL.
     *
     * @example Using supabase-js (recommended)
     * ```ts
     * import { createClient } from '@supabase/supabase-js'
     *
     * const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
     * const { data, error } = await supabase.functions.invoke('hello-world')
     * ```
     *
     * @category Edge Functions
     *
     * @example Standalone import for bundle-sensitive environments
     * ```ts
     * import { FunctionsClient, FunctionRegion } from '@supabase/functions-js'
     *
     * const functions = new FunctionsClient('https://xyzcompany.supabase.co/functions/v1', {
     *   headers: { apikey: 'your-publishable-key' },
     *   region: FunctionRegion.UsEast1,
     * })
     * ```
     */ constructor(url, { headers: headers = {}, customFetch: customFetch, region: region = (0, $1oqCS.FunctionRegion).Any } = {}){
        this.url = url;
        this.headers = headers;
        this.region = region;
        this.fetch = (0, $ffULL.resolveFetch)(customFetch);
    }
    /**
     * Updates the authorization header
     * @param token - the new jwt token sent in the authorisation header
     *
     * @category Edge Functions
     *
     * @example Setting the authorization header
     * ```ts
     * functions.setAuth(session.access_token)
     * ```
     */ setAuth(token) {
        this.headers.Authorization = `Bearer ${token}`;
    }
    /**
     * Invokes a function
     * @param functionName - The name of the Function to invoke.
     * @param options - Options for invoking the Function.
     * @example
     * ```ts
     * const { data, error } = await functions.invoke('hello-world', {
     *   body: { name: 'Ada' },
     * })
     * ```
     *
     * @category Edge Functions
     *
     * @remarks
     * - Requires an Authorization header.
     * - Invoke params generally match the [Fetch API](https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API) spec.
     * - When you pass in a body to your function, we automatically attach the Content-Type header for `Blob`, `ArrayBuffer`, `File`, `FormData` and `String`. If it doesn't match any of these types we assume the payload is `json`, serialize it and attach the `Content-Type` header as `application/json`. You can override this behavior by passing in a `Content-Type` header of your own.
     * - Responses are automatically parsed as `json`, `blob` and `form-data` depending on the `Content-Type` header sent by your function. Responses are parsed as `text` by default.
     *
     * @example Basic invocation
     * ```js
     * const { data, error } = await supabase.functions.invoke('hello', {
     *   body: { foo: 'bar' }
     * })
     * ```
     *
     * @exampleDescription Error handling
     * A `FunctionsHttpError` error is returned if your function throws an error, `FunctionsRelayError` if the Supabase Relay has an error processing your function and `FunctionsFetchError` if there is a network error in calling your function.
     *
     * @example Error handling
     * ```js
     * import { FunctionsHttpError, FunctionsRelayError, FunctionsFetchError } from "@supabase/supabase-js";
     *
     * const { data, error } = await supabase.functions.invoke('hello', {
     *   headers: {
     *     "my-custom-header": 'my-custom-header-value'
     *   },
     *   body: { foo: 'bar' }
     * })
     *
     * if (error instanceof FunctionsHttpError) {
     *   const errorMessage = await error.context.json()
     *   console.log('Function returned an error', errorMessage)
     * } else if (error instanceof FunctionsRelayError) {
     *   console.log('Relay error:', error.message)
     * } else if (error instanceof FunctionsFetchError) {
     *   console.log('Fetch error:', error.message)
     * }
     * ```
     *
     * @exampleDescription Passing custom headers
     * You can pass custom headers to your function. Note: supabase-js automatically passes the `Authorization` header with the signed in user's JWT.
     *
     * @example Passing custom headers
     * ```js
     * const { data, error } = await supabase.functions.invoke('hello', {
     *   headers: {
     *     "my-custom-header": 'my-custom-header-value'
     *   },
     *   body: { foo: 'bar' }
     * })
     * ```
     *
     * @exampleDescription Calling with DELETE HTTP verb
     * You can also set the HTTP verb to `DELETE` when calling your Edge Function.
     *
     * @example Calling with DELETE HTTP verb
     * ```js
     * const { data, error } = await supabase.functions.invoke('hello', {
     *   headers: {
     *     "my-custom-header": 'my-custom-header-value'
     *   },
     *   body: { foo: 'bar' },
     *   method: 'DELETE'
     * })
     * ```
     *
     * @exampleDescription Invoking a Function in the UsEast1 region
     * Here are the available regions:
     * - `FunctionRegion.Any`
     * - `FunctionRegion.ApNortheast1`
     * - `FunctionRegion.ApNortheast2`
     * - `FunctionRegion.ApSouth1`
     * - `FunctionRegion.ApSoutheast1`
     * - `FunctionRegion.ApSoutheast2`
     * - `FunctionRegion.CaCentral1`
     * - `FunctionRegion.EuCentral1`
     * - `FunctionRegion.EuWest1`
     * - `FunctionRegion.EuWest2`
     * - `FunctionRegion.EuWest3`
     * - `FunctionRegion.SaEast1`
     * - `FunctionRegion.UsEast1`
     * - `FunctionRegion.UsWest1`
     * - `FunctionRegion.UsWest2`
     *
     * @example Invoking a Function in the UsEast1 region
     * ```js
     * import { createClient, FunctionRegion } from '@supabase/supabase-js'
     *
     * const { data, error } = await supabase.functions.invoke('hello', {
     *   body: { foo: 'bar' },
     *   region: FunctionRegion.UsEast1
     * })
     * ```
     *
     * @exampleDescription Calling with GET HTTP verb
     * You can also set the HTTP verb to `GET` when calling your Edge Function.
     *
     * @example Calling with GET HTTP verb
     * ```js
     * const { data, error } = await supabase.functions.invoke('hello', {
     *   headers: {
     *     "my-custom-header": 'my-custom-header-value'
     *   },
     *   method: 'GET'
     * })
     * ```
     *
     * @example Standalone client invoke
     * ```ts
     * const { data, error } = await functions.invoke('hello-world', {
     *   body: { name: 'Ada' },
     * })
     * ```
     */ invoke(functionName_1) {
        return (0, $7WQrb.__awaiter)(this, arguments, void 0, function*(functionName, options = {}) {
            var _a;
            let timeoutId;
            let timeoutController;
            try {
                const { headers: headers, method: method, body: functionArgs, signal: signal, timeout: timeout } = options;
                let _headers = {};
                let { region: region } = options;
                if (!region) region = this.region;
                // Add region as query parameter using URL API
                const url = new URL(`${this.url}/${functionName}`);
                if (region && region !== 'any') {
                    _headers['x-region'] = region;
                    url.searchParams.set('forceFunctionRegion', region);
                }
                let body;
                if (functionArgs && (headers && !Object.prototype.hasOwnProperty.call(headers, 'Content-Type') || !headers)) {
                    if (typeof Blob !== 'undefined' && functionArgs instanceof Blob || functionArgs instanceof ArrayBuffer) {
                        // will work for File as File inherits Blob
                        // also works for ArrayBuffer as it is the same underlying structure as a Blob
                        _headers['Content-Type'] = 'application/octet-stream';
                        body = functionArgs;
                    } else if (typeof functionArgs === 'string') {
                        // plain string
                        _headers['Content-Type'] = 'text/plain';
                        body = functionArgs;
                    } else if (typeof FormData !== 'undefined' && functionArgs instanceof FormData) // don't set content-type headers
                    // Request will automatically add the right boundary value
                    body = functionArgs;
                    else {
                        // default, assume this is JSON
                        _headers['Content-Type'] = 'application/json';
                        body = JSON.stringify(functionArgs);
                    }
                } else if (functionArgs && typeof functionArgs !== 'string' && !(typeof Blob !== 'undefined' && functionArgs instanceof Blob) && !(functionArgs instanceof ArrayBuffer) && !(typeof FormData !== 'undefined' && functionArgs instanceof FormData)) body = JSON.stringify(functionArgs);
                else body = functionArgs;
                // Handle timeout by creating an AbortController
                let effectiveSignal = signal;
                if (timeout) {
                    timeoutController = new AbortController();
                    timeoutId = setTimeout(()=>timeoutController.abort(), timeout);
                    // If user provided their own signal, we need to respect both
                    if (signal) {
                        effectiveSignal = timeoutController.signal;
                        // If the user's signal is aborted, abort our timeout controller too
                        signal.addEventListener('abort', ()=>timeoutController.abort());
                    } else effectiveSignal = timeoutController.signal;
                }
                const response = yield this.fetch(url.toString(), {
                    method: method || 'POST',
                    // headers priority is (high to low):
                    // 1. invoke-level headers
                    // 2. client-level headers
                    // 3. default Content-Type header
                    headers: Object.assign(Object.assign(Object.assign({}, _headers), this.headers), headers),
                    body: body,
                    signal: effectiveSignal
                }).catch((fetchError)=>{
                    throw new (0, $1oqCS.FunctionsFetchError)(fetchError);
                });
                const isRelayError = response.headers.get('x-relay-error');
                if (isRelayError && isRelayError === 'true') throw new (0, $1oqCS.FunctionsRelayError)(response);
                if (!response.ok) throw new (0, $1oqCS.FunctionsHttpError)(response);
                let responseType = ((_a = response.headers.get('Content-Type')) !== null && _a !== void 0 ? _a : 'text/plain').split(';')[0].trim();
                let data;
                if (responseType === 'application/json') data = yield response.json();
                else if (responseType === 'application/octet-stream' || responseType === 'application/pdf') data = yield response.blob();
                else if (responseType === 'text/event-stream') data = response;
                else if (responseType === 'multipart/form-data') data = yield response.formData();
                else // default to text
                data = yield response.text();
                return {
                    data: data,
                    error: null,
                    response: response
                };
            } catch (error) {
                return {
                    data: null,
                    error: error,
                    response: error instanceof (0, $1oqCS.FunctionsHttpError) || error instanceof (0, $1oqCS.FunctionsRelayError) ? error.context : undefined
                };
            } finally{
                // Clear the timeout if it was set
                if (timeoutId) clearTimeout(timeoutId);
            }
        });
    }
}

});
parcelRegister("7WQrb", function(module, exports) {

$parcel$export(module.exports, "__rest", () => $5c96a02c592fcff1$export$3c9a16f847548506);
$parcel$export(module.exports, "__awaiter", () => $5c96a02c592fcff1$export$1050f835b63b671e);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $5c96a02c592fcff1$var$ownKeys = function(o) {
    $5c96a02c592fcff1$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $5c96a02c592fcff1$var$ownKeys(o);
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $5c96a02c592fcff1$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $5c96a02c592fcff1$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __esDecorate: $5c96a02c592fcff1$export$3a84e1ae4e97e9b0,
    __runInitializers: $5c96a02c592fcff1$export$d831c04e792af3d,
    __propKey: $5c96a02c592fcff1$export$6a2a36740a146cb8,
    __setFunctionName: $5c96a02c592fcff1$export$d1a06452d3489bc7,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $5c96a02c592fcff1$export$889dfb5d17574b0b
};

});

parcelRegister("ffULL", function(module, exports) {

$parcel$export(module.exports, "resolveFetch", () => $b1b44af3c77a62f9$export$98d92b1aa79f8cc7);
const $b1b44af3c77a62f9$export$98d92b1aa79f8cc7 = (customFetch)=>{
    if (customFetch) return (...args)=>customFetch(...args);
    return (...args)=>fetch(...args);
};

});

parcelRegister("1oqCS", function(module, exports) {

$parcel$export(module.exports, "FunctionsFetchError", () => $103cafb5d5f4c571$export$14f2b6540d498ce);
$parcel$export(module.exports, "FunctionsRelayError", () => $103cafb5d5f4c571$export$d08a45df86040161);
$parcel$export(module.exports, "FunctionsHttpError", () => $103cafb5d5f4c571$export$761f8c0e0fa4624f);
$parcel$export(module.exports, "FunctionRegion", () => $103cafb5d5f4c571$export$9b19f1a5abf91e06);
/**
 * Base error for Supabase Edge Function invocations.
 *
 * @example
 * ```ts
 * import { FunctionsError } from '@supabase/functions-js'
 *
 * throw new FunctionsError('Unexpected error invoking function', 'FunctionsError', {
 *   requestId: 'abc123',
 * })
 * ```
 */ class $103cafb5d5f4c571$export$738689d52335bb3c extends Error {
    constructor(message, name = 'FunctionsError', context){
        super(message);
        this.name = name;
        this.context = context;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            context: this.context
        };
    }
}
class $103cafb5d5f4c571$export$14f2b6540d498ce extends $103cafb5d5f4c571$export$738689d52335bb3c {
    constructor(context){
        super('Failed to send a request to the Edge Function', 'FunctionsFetchError', context);
    }
}
class $103cafb5d5f4c571$export$d08a45df86040161 extends $103cafb5d5f4c571$export$738689d52335bb3c {
    constructor(context){
        super('Relay Error invoking the Edge Function', 'FunctionsRelayError', context);
    }
}
class $103cafb5d5f4c571$export$761f8c0e0fa4624f extends $103cafb5d5f4c571$export$738689d52335bb3c {
    constructor(context){
        super('Edge Function returned a non-2xx status code', 'FunctionsHttpError', context);
    }
}
var $103cafb5d5f4c571$export$9b19f1a5abf91e06;
(function(FunctionRegion) {
    FunctionRegion["Any"] = "any";
    FunctionRegion["ApNortheast1"] = "ap-northeast-1";
    FunctionRegion["ApNortheast2"] = "ap-northeast-2";
    FunctionRegion["ApSouth1"] = "ap-south-1";
    FunctionRegion["ApSoutheast1"] = "ap-southeast-1";
    FunctionRegion["ApSoutheast2"] = "ap-southeast-2";
    FunctionRegion["CaCentral1"] = "ca-central-1";
    FunctionRegion["EuCentral1"] = "eu-central-1";
    FunctionRegion["EuWest1"] = "eu-west-1";
    FunctionRegion["EuWest2"] = "eu-west-2";
    FunctionRegion["EuWest3"] = "eu-west-3";
    FunctionRegion["SaEast1"] = "sa-east-1";
    FunctionRegion["UsEast1"] = "us-east-1";
    FunctionRegion["UsWest1"] = "us-west-1";
    FunctionRegion["UsWest2"] = "us-west-2";
})($103cafb5d5f4c571$export$9b19f1a5abf91e06 || ($103cafb5d5f4c571$export$9b19f1a5abf91e06 = {}));

});


parcelRegister("4yorG", function(module, exports) {

$parcel$export(module.exports, "PostgrestClient", () => $cfc0ca97c19fecec$export$796f32e2ee984aaa);
//#region src/types/common/common.ts
/**
* Default number of retry attempts.
*/ const $cfc0ca97c19fecec$var$DEFAULT_MAX_RETRIES = 3;
/**
* Default exponential backoff delay function.
* Delays: 1s, 2s, 4s, 8s, ... (max 30s)
*
* @param attemptIndex - Zero-based index of the retry attempt
* @returns Delay in milliseconds before the next retry
*/ const $cfc0ca97c19fecec$var$getRetryDelay = (attemptIndex)=>Math.min(1e3 * 2 ** attemptIndex, 3e4);
/**
* Status codes that are safe to retry.
* 520 = Cloudflare timeout/connection errors (transient)
* 503 = PostgREST schema cache not yet loaded (transient, signals retry via Retry-After header)
*/ const $cfc0ca97c19fecec$var$RETRYABLE_STATUS_CODES = [
    520,
    503
];
/**
* HTTP methods that are safe to retry (idempotent operations).
*/ const $cfc0ca97c19fecec$var$RETRYABLE_METHODS = [
    "GET",
    "HEAD",
    "OPTIONS"
];
//#endregion
//#region src/PostgrestError.ts
/**
* Error format
*
* {@link https://postgrest.org/en/stable/api.html?highlight=options#errors-and-http-status-codes}
*/ var $cfc0ca97c19fecec$export$445b7e3a323f992f = class extends Error {
    /**
	* @example
	* ```ts
	* import PostgrestError from '@supabase/postgrest-js'
	*
	* throw new PostgrestError({
	*   message: 'Row level security prevented the request',
	*   details: 'RLS denied the insert',
	*   hint: 'Check your policies',
	*   code: 'PGRST301',
	* })
	* ```
	*/ constructor(context){
        super(context.message);
        this.name = "PostgrestError";
        this.details = context.details;
        this.hint = context.hint;
        this.code = context.code;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            details: this.details,
            hint: this.hint,
            code: this.code
        };
    }
};
//#endregion
//#region src/PostgrestBuilder.ts
/**
* Sleep for a given number of milliseconds.
* If an AbortSignal is provided, the sleep resolves early when the signal is aborted.
*/ function $cfc0ca97c19fecec$var$sleep(ms, signal) {
    return new Promise((resolve)=>{
        if (signal === null || signal === void 0 ? void 0 : signal.aborted) {
            resolve();
            return;
        }
        const id = setTimeout(()=>{
            signal === null || signal === void 0 || signal.removeEventListener("abort", onAbort);
            resolve();
        }, ms);
        function onAbort() {
            clearTimeout(id);
            resolve();
        }
        signal === null || signal === void 0 || signal.addEventListener("abort", onAbort);
    });
}
/**
* Check if a request should be retried based on method and status code.
*/ function $cfc0ca97c19fecec$var$shouldRetry(method, status, attemptCount, retryEnabled) {
    if (!retryEnabled || attemptCount >= $cfc0ca97c19fecec$var$DEFAULT_MAX_RETRIES) return false;
    if (!$cfc0ca97c19fecec$var$RETRYABLE_METHODS.includes(method)) return false;
    if (!$cfc0ca97c19fecec$var$RETRYABLE_STATUS_CODES.includes(status)) return false;
    return true;
}
var $cfc0ca97c19fecec$export$3106e21688a06353 = class {
    /**
	* Creates a builder configured for a specific PostgREST request.
	*
	* @example Using supabase-js (recommended)
	* ```ts
	* import { createClient } from '@supabase/supabase-js'
	*
	* const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
	* const { data, error } = await supabase.from('users').select('*')
	* ```
	*
	* @category Database
	*
	* @example Standalone import for bundle-sensitive environments
	* ```ts
	* import { PostgrestQueryBuilder } from '@supabase/postgrest-js'
	*
	* const builder = new PostgrestQueryBuilder(
	*   new URL('https://xyzcompany.supabase.co/rest/v1/users'),
	*   { headers: new Headers({ apikey: 'your-publishable-key' }) }
	* )
	* ```
	*/ constructor(builder){
        var _builder$shouldThrowO, _builder$isMaybeSingl, _builder$shouldStripN, _builder$urlLengthLim, _builder$retry;
        this.shouldThrowOnError = false;
        this.retryEnabled = true;
        this.method = builder.method;
        this.url = builder.url;
        this.headers = new Headers(builder.headers);
        this.schema = builder.schema;
        this.body = builder.body;
        this.shouldThrowOnError = (_builder$shouldThrowO = builder.shouldThrowOnError) !== null && _builder$shouldThrowO !== void 0 ? _builder$shouldThrowO : false;
        this.signal = builder.signal;
        this.isMaybeSingle = (_builder$isMaybeSingl = builder.isMaybeSingle) !== null && _builder$isMaybeSingl !== void 0 ? _builder$isMaybeSingl : false;
        this.shouldStripNulls = (_builder$shouldStripN = builder.shouldStripNulls) !== null && _builder$shouldStripN !== void 0 ? _builder$shouldStripN : false;
        this.urlLengthLimit = (_builder$urlLengthLim = builder.urlLengthLimit) !== null && _builder$urlLengthLim !== void 0 ? _builder$urlLengthLim : 8e3;
        this.retryEnabled = (_builder$retry = builder.retry) !== null && _builder$retry !== void 0 ? _builder$retry : true;
        if (builder.fetch) this.fetch = builder.fetch;
        else this.fetch = fetch;
    }
    /**
	* If there's an error with the query, throwOnError will reject the promise by
	* throwing the error instead of returning it as part of a successful response.
	*
	* {@link https://github.com/supabase/supabase-js/issues/92}
	*
	* @category Database
	*/ throwOnError() {
        this.shouldThrowOnError = true;
        return this;
    }
    /**
	* Strip null values from the response data. Properties with `null` values
	* will be omitted from the returned JSON objects.
	*
	* Requires PostgREST 11.2.0+.
	*
	* {@link https://docs.postgrest.org/en/stable/references/api/resource_representation.html#stripped-nulls}
	*
	* @category Database
	* @subcategory Using modifiers
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .stripNulls()
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text, bio text);
	*
	* insert into
	*   characters (id, name, bio)
	* values
	*   (1, 'Luke', null),
	*   (2, 'Leia', 'Princess of Alderaan');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Luke"
	*     },
	*     {
	*       "id": 2,
	*       "name": "Leia",
	*       "bio": "Princess of Alderaan"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ stripNulls() {
        if (this.headers.get("Accept") === "text/csv") throw new Error("stripNulls() cannot be used with csv()");
        this.shouldStripNulls = true;
        return this;
    }
    /**
	* Set an HTTP header for the request.
	*
	* @category Database
	*/ setHeader(name, value) {
        this.headers = new Headers(this.headers);
        this.headers.set(name, value);
        return this;
    }
    /**
	* @category Database
	*
	* Configure retry behavior for this request.
	*
	* By default, retries are enabled for idempotent requests (GET, HEAD, OPTIONS)
	* that fail with network errors or specific HTTP status codes (503, 520).
	* Retries use exponential backoff (1s, 2s, 4s) with a maximum of 3 attempts.
	*
	* @param enabled - Whether to enable retries for this request
	*
	* @example
	* ```ts
	* // Disable retries for a specific query
	* const { data, error } = await supabase
	*   .from('users')
	*   .select()
	*   .retry(false)
	* ```
	*/ retry(enabled) {
        this.retryEnabled = enabled;
        return this;
    }
    then(onfulfilled, onrejected) {
        var _this = this;
        if (this.schema === void 0) ;
        else if ([
            "GET",
            "HEAD"
        ].includes(this.method)) this.headers.set("Accept-Profile", this.schema);
        else this.headers.set("Content-Profile", this.schema);
        if (this.method !== "GET" && this.method !== "HEAD") this.headers.set("Content-Type", "application/json");
        if (this.shouldStripNulls) {
            const currentAccept = this.headers.get("Accept");
            if (currentAccept === "application/vnd.pgrst.object+json") this.headers.set("Accept", "application/vnd.pgrst.object+json;nulls=stripped");
            else if (!currentAccept || currentAccept === "application/json") this.headers.set("Accept", "application/vnd.pgrst.array+json;nulls=stripped");
        }
        const _fetch = this.fetch;
        const executeWithRetry = async ()=>{
            let attemptCount = 0;
            while(true){
                const requestHeaders = new Headers(_this.headers);
                if (attemptCount > 0) requestHeaders.set("X-Retry-Count", String(attemptCount));
                let res$1;
                try {
                    res$1 = await _fetch(_this.url.toString(), {
                        method: _this.method,
                        headers: requestHeaders,
                        body: JSON.stringify(_this.body, (_, value)=>typeof value === "bigint" ? value.toString() : value),
                        signal: _this.signal
                    });
                } catch (fetchError) {
                    if (fetchError instanceof Error && (fetchError.name === "AbortError" || "code" in fetchError && fetchError.code === "ABORT_ERR")) throw fetchError;
                    if (!$cfc0ca97c19fecec$var$RETRYABLE_METHODS.includes(_this.method)) throw fetchError;
                    if (_this.retryEnabled && attemptCount < $cfc0ca97c19fecec$var$DEFAULT_MAX_RETRIES) {
                        const delay = $cfc0ca97c19fecec$var$getRetryDelay(attemptCount);
                        attemptCount++;
                        await $cfc0ca97c19fecec$var$sleep(delay, _this.signal);
                        continue;
                    }
                    throw fetchError;
                }
                if ($cfc0ca97c19fecec$var$shouldRetry(_this.method, res$1.status, attemptCount, _this.retryEnabled)) {
                    var _res$headers$get, _res$headers;
                    const retryAfterHeader = (_res$headers$get = (_res$headers = res$1.headers) === null || _res$headers === void 0 ? void 0 : _res$headers.get("Retry-After")) !== null && _res$headers$get !== void 0 ? _res$headers$get : null;
                    const delay = retryAfterHeader !== null ? Math.max(0, parseInt(retryAfterHeader, 10) || 0) * 1e3 : $cfc0ca97c19fecec$var$getRetryDelay(attemptCount);
                    await res$1.text();
                    attemptCount++;
                    await $cfc0ca97c19fecec$var$sleep(delay, _this.signal);
                    continue;
                }
                return await _this.processResponse(res$1);
            }
        };
        let res = executeWithRetry();
        if (!this.shouldThrowOnError) res = res.catch((fetchError)=>{
            var _fetchError$name2;
            let errorDetails = "";
            let hint = "";
            let code = "";
            const cause = fetchError === null || fetchError === void 0 ? void 0 : fetchError.cause;
            if (cause) {
                var _cause$message, _cause$code, _fetchError$name, _cause$name;
                const causeMessage = (_cause$message = cause === null || cause === void 0 ? void 0 : cause.message) !== null && _cause$message !== void 0 ? _cause$message : "";
                const causeCode = (_cause$code = cause === null || cause === void 0 ? void 0 : cause.code) !== null && _cause$code !== void 0 ? _cause$code : "";
                errorDetails = `${(_fetchError$name = fetchError === null || fetchError === void 0 ? void 0 : fetchError.name) !== null && _fetchError$name !== void 0 ? _fetchError$name : "FetchError"}: ${fetchError === null || fetchError === void 0 ? void 0 : fetchError.message}`;
                errorDetails += `\n\nCaused by: ${(_cause$name = cause === null || cause === void 0 ? void 0 : cause.name) !== null && _cause$name !== void 0 ? _cause$name : "Error"}: ${causeMessage}`;
                if (causeCode) errorDetails += ` (${causeCode})`;
                if (cause === null || cause === void 0 ? void 0 : cause.stack) errorDetails += `\n${cause.stack}`;
            } else {
                var _fetchError$stack;
                errorDetails = (_fetchError$stack = fetchError === null || fetchError === void 0 ? void 0 : fetchError.stack) !== null && _fetchError$stack !== void 0 ? _fetchError$stack : "";
            }
            const urlLength = this.url.toString().length;
            if ((fetchError === null || fetchError === void 0 ? void 0 : fetchError.name) === "AbortError" || (fetchError === null || fetchError === void 0 ? void 0 : fetchError.code) === "ABORT_ERR") {
                code = "";
                hint = "Request was aborted (timeout or manual cancellation)";
                if (urlLength > this.urlLengthLimit) hint += `. Note: Your request URL is ${urlLength} characters, which may exceed server limits. If selecting many fields, consider using views. If filtering with large arrays (e.g., .in('id', [many IDs])), consider using an RPC function to pass values server-side.`;
            } else if ((cause === null || cause === void 0 ? void 0 : cause.name) === "HeadersOverflowError" || (cause === null || cause === void 0 ? void 0 : cause.code) === "UND_ERR_HEADERS_OVERFLOW") {
                code = "";
                hint = "HTTP headers exceeded server limits (typically 16KB)";
                if (urlLength > this.urlLengthLimit) hint += `. Your request URL is ${urlLength} characters. If selecting many fields, consider using views. If filtering with large arrays (e.g., .in('id', [200+ IDs])), consider using an RPC function instead.`;
            }
            return {
                success: false,
                error: {
                    message: `${(_fetchError$name2 = fetchError === null || fetchError === void 0 ? void 0 : fetchError.name) !== null && _fetchError$name2 !== void 0 ? _fetchError$name2 : "FetchError"}: ${fetchError === null || fetchError === void 0 ? void 0 : fetchError.message}`,
                    details: errorDetails,
                    hint: hint,
                    code: code
                },
                data: null,
                count: null,
                status: 0,
                statusText: ""
            };
        });
        return res.then(onfulfilled, onrejected);
    }
    /**
	* Process a fetch response and return the standardized postgrest response.
	*/ async processResponse(res) {
        var _this2 = this;
        let error = null;
        let data = null;
        let count = null;
        let status = res.status;
        let statusText = res.statusText;
        if (res.ok) {
            var _this$headers$get2, _res$headers$get2;
            if (_this2.method !== "HEAD") {
                var _this$headers$get;
                const body = await res.text();
                if (body === "") ;
                else if (_this2.headers.get("Accept") === "text/csv") data = body;
                else if (_this2.headers.get("Accept") && ((_this$headers$get = _this2.headers.get("Accept")) === null || _this$headers$get === void 0 ? void 0 : _this$headers$get.includes("application/vnd.pgrst.plan+text"))) data = body;
                else data = JSON.parse(body);
            }
            const countHeader = (_this$headers$get2 = _this2.headers.get("Prefer")) === null || _this$headers$get2 === void 0 ? void 0 : _this$headers$get2.match(/count=(exact|planned|estimated)/);
            const contentRange = (_res$headers$get2 = res.headers.get("content-range")) === null || _res$headers$get2 === void 0 ? void 0 : _res$headers$get2.split("/");
            if (countHeader && contentRange && contentRange.length > 1) count = parseInt(contentRange[1]);
            if (_this2.isMaybeSingle && Array.isArray(data)) {
                if (data.length > 1) {
                    error = {
                        code: "PGRST116",
                        details: `Results contain ${data.length} rows, application/vnd.pgrst.object+json requires 1 row`,
                        hint: null,
                        message: "JSON object requested, multiple (or no) rows returned"
                    };
                    data = null;
                    count = null;
                    status = 406;
                    statusText = "Not Acceptable";
                } else if (data.length === 1) data = data[0];
                else data = null;
            }
        } else {
            const body = await res.text();
            try {
                error = JSON.parse(body);
                if (Array.isArray(error) && res.status === 404) {
                    data = [];
                    error = null;
                    status = 200;
                    statusText = "OK";
                }
            } catch (_unused) {
                if (res.status === 404 && body === "") {
                    status = 204;
                    statusText = "No Content";
                } else error = {
                    message: body
                };
            }
            if (error && _this2.shouldThrowOnError) throw new $cfc0ca97c19fecec$export$445b7e3a323f992f(error);
        }
        return {
            success: error === null,
            error: error,
            data: data,
            count: count,
            status: status,
            statusText: statusText
        };
    }
    /**
	* Override the type of the returned `data`.
	*
	* @typeParam NewResult - The new result type to override with
	* @deprecated Use overrideTypes<yourType, { merge: false }>() method at the end of your call chain instead
	*
	* @category Database
	*/ returns() {
        /* istanbul ignore next */ return this;
    }
    /**
	* Override the type of the returned `data` field in the response.
	*
	* @typeParam NewResult - The new type to cast the response data to
	* @typeParam Options - Optional type configuration (defaults to { merge: true })
	* @typeParam Options.merge - When true, merges the new type with existing return type. When false, replaces the existing types entirely (defaults to true)
	* @example
	* ```typescript
	* // Merge with existing types (default behavior)
	* const query = supabase
	*   .from('users')
	*   .select()
	*   .overrideTypes<{ custom_field: string }>()
	*
	* // Replace existing types completely
	* const replaceQuery = supabase
	*   .from('users')
	*   .select()
	*   .overrideTypes<{ id: number; name: string }, { merge: false }>()
	* ```
	* @returns A PostgrestBuilder instance with the new type
	*
	* @category Database
	* @subcategory Using modifiers
	*
	* @example Complete Override type of successful response
	* ```ts
	* const { data } = await supabase
	*   .from('countries')
	*   .select()
	*   .overrideTypes<Array<MyType>, { merge: false }>()
	* ```
	*
	* @exampleResponse Complete Override type of successful response
	* ```ts
	* let x: typeof data // MyType[]
	* ```
	*
	* @example Complete Override type of object response
	* ```ts
	* const { data } = await supabase
	*   .from('countries')
	*   .select()
	*   .maybeSingle()
	*   .overrideTypes<MyType, { merge: false }>()
	* ```
	*
	* @exampleResponse Complete Override type of object response
	* ```ts
	* let x: typeof data // MyType | null
	* ```
	*
	* @example Partial Override type of successful response
	* ```ts
	* const { data } = await supabase
	*   .from('countries')
	*   .select()
	*   .overrideTypes<Array<{ status: "A" | "B" }>>()
	* ```
	*
	* @exampleResponse Partial Override type of successful response
	* ```ts
	* let x: typeof data // Array<CountryRowProperties & { status: "A" | "B" }>
	* ```
	*
	* @example Partial Override type of object response
	* ```ts
	* const { data } = await supabase
	*   .from('countries')
	*   .select()
	*   .maybeSingle()
	*   .overrideTypes<{ status: "A" | "B" }>()
	* ```
	*
	* @exampleResponse Partial Override type of object response
	* ```ts
	* let x: typeof data // CountryRowProperties & { status: "A" | "B" } | null
	* ```
	*
	* @example Merge vs replace existing types
	* ```typescript
	* // Merge with existing types (default behavior)
	* const query = supabase
	*   .from('users')
	*   .select()
	*   .overrideTypes<{ custom_field: string }>()
	*
	* // Replace existing types completely
	* const replaceQuery = supabase
	*   .from('users')
	*   .select()
	*   .overrideTypes<{ id: number; name: string }, { merge: false }>()
	* ```
	*/ overrideTypes() {
        return this;
    }
};
//#endregion
//#region src/PostgrestTransformBuilder.ts
var $cfc0ca97c19fecec$export$7b4361bb87e3030c = class extends $cfc0ca97c19fecec$export$3106e21688a06353 {
    /**
	* Perform a SELECT on the query result.
	*
	* By default, `.insert()`, `.update()`, `.upsert()`, and `.delete()` do not
	* return modified rows. By calling this method, modified rows are returned in
	* `data`.
	*
	* @param columns - The columns to retrieve, separated by commas
	*
	* @category Database
	* @subcategory Using modifiers
	*
	* @example With `upsert()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .upsert({ id: 1, name: 'Han Solo' })
	*   .select()
	* ```
	*
	* @exampleSql With `upsert()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Han');
	* ```
	*
	* @exampleResponse With `upsert()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Han Solo"
	*     }
	*   ],
	*   "status": 201,
	*   "statusText": "Created"
	* }
	* ```
	*/ select(columns) {
        let quoted = false;
        const cleanedColumns = (columns !== null && columns !== void 0 ? columns : "*").split("").map((c)=>{
            if (/\s/.test(c) && !quoted) return "";
            if (c === "\"") quoted = !quoted;
            return c;
        }).join("");
        this.url.searchParams.set("select", cleanedColumns);
        this.headers.append("Prefer", "return=representation");
        return this;
    }
    /**
	* Order the query result by `column`.
	*
	* You can call this method multiple times to order by multiple columns.
	*
	* You can order referenced tables, but it only affects the ordering of the
	* parent table if you use `!inner` in the query.
	*
	* @param column - The column to order by
	* @param options - Named parameters
	* @param options.ascending - If `true`, the result will be in ascending order
	* @param options.nullsFirst - If `true`, `null`s appear first. If `false`,
	* `null`s appear last.
	* @param options.referencedTable - Set this to order a referenced table by
	* its columns
	* @param options.foreignTable - Deprecated, use `options.referencedTable`
	* instead
	*
	* @category Database
	* @subcategory Using modifiers
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select('id, name')
	*   .order('id', { ascending: false })
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 3,
	*       "name": "Han"
	*     },
	*     {
	*       "id": 2,
	*       "name": "Leia"
	*     },
	*     {
	*       "id": 1,
	*       "name": "Luke"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription On a referenced table
	* Ordering with `referencedTable` doesn't affect the ordering of the
	* parent table.
	*
	* @example On a referenced table
	* ```ts
	*   const { data, error } = await supabase
	*     .from('orchestral_sections')
	*     .select(`
	*       name,
	*       instruments (
	*         name
	*       )
	*     `)
	*     .order('name', { referencedTable: 'instruments', ascending: false })
	*
	* ```
	*
	* @exampleSql On a referenced table
	* ```sql
	* create table
	*   orchestral_sections (id int8 primary key, name text);
	* create table
	*   instruments (
	*     id int8 primary key,
	*     section_id int8 not null references orchestral_sections,
	*     name text
	*   );
	*
	* insert into
	*   orchestral_sections (id, name)
	* values
	*   (1, 'strings'),
	*   (2, 'woodwinds');
	* insert into
	*   instruments (id, section_id, name)
	* values
	*   (1, 1, 'harp'),
	*   (2, 1, 'violin');
	* ```
	*
	* @exampleResponse On a referenced table
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "strings",
	*       "instruments": [
	*         {
	*           "name": "violin"
	*         },
	*         {
	*           "name": "harp"
	*         }
	*       ]
	*     },
	*     {
	*       "name": "woodwinds",
	*       "instruments": []
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Order parent table by a referenced table
	* Ordering with `referenced_table(col)` affects the ordering of the
	* parent table.
	*
	* @example Order parent table by a referenced table
	* ```ts
	*   const { data, error } = await supabase
	*     .from('instruments')
	*     .select(`
	*       name,
	*       section:orchestral_sections (
	*         name
	*       )
	*     `)
	*     .order('section(name)', { ascending: true })
	*
	* ```
	*
	* @exampleSql Order parent table by a referenced table
	* ```sql
	* create table
	*   orchestral_sections (id int8 primary key, name text);
	* create table
	*   instruments (
	*     id int8 primary key,
	*     section_id int8 not null references orchestral_sections,
	*     name text
	*   );
	*
	* insert into
	*   orchestral_sections (id, name)
	* values
	*   (1, 'strings'),
	*   (2, 'woodwinds');
	* insert into
	*   instruments (id, section_id, name)
	* values
	*   (1, 2, 'flute'),
	*   (2, 1, 'violin');
	* ```
	*
	* @exampleResponse Order parent table by a referenced table
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "violin",
	*       "orchestral_sections": {"name": "strings"}
	*     },
	*     {
	*       "name": "flute",
	*       "orchestral_sections": {"name": "woodwinds"}
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ order(column, { ascending: ascending = true, nullsFirst: nullsFirst, foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const key = referencedTable ? `${referencedTable}.order` : "order";
        const existingOrder = this.url.searchParams.get(key);
        this.url.searchParams.set(key, `${existingOrder ? `${existingOrder},` : ""}${column}.${ascending ? "asc" : "desc"}${nullsFirst === void 0 ? "" : nullsFirst ? ".nullsfirst" : ".nullslast"}`);
        return this;
    }
    /**
	* Limit the query result by `count`.
	*
	* @param count - The maximum number of rows to return
	* @param options - Named parameters
	* @param options.referencedTable - Set this to limit rows of referenced
	* tables instead of the parent table
	* @param options.foreignTable - Deprecated, use `options.referencedTable`
	* instead
	*
	* @category Database
	* @subcategory Using modifiers
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select('name')
	*   .limit(1)
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "Luke"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @example On a referenced table
	* ```ts
	* const { data, error } = await supabase
	*   .from('orchestral_sections')
	*   .select(`
	*     name,
	*     instruments (
	*       name
	*     )
	*   `)
	*   .limit(1, { referencedTable: 'instruments' })
	* ```
	*
	* @exampleSql On a referenced table
	* ```sql
	* create table
	*   orchestral_sections (id int8 primary key, name text);
	* create table
	*   instruments (
	*     id int8 primary key,
	*     section_id int8 not null references orchestral_sections,
	*     name text
	*   );
	*
	* insert into
	*   orchestral_sections (id, name)
	* values
	*   (1, 'strings');
	* insert into
	*   instruments (id, section_id, name)
	* values
	*   (1, 1, 'harp'),
	*   (2, 1, 'violin');
	* ```
	*
	* @exampleResponse On a referenced table
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "strings",
	*       "instruments": [
	*         {
	*           "name": "violin"
	*         }
	*       ]
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ limit(count, { foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const key = typeof referencedTable === "undefined" ? "limit" : `${referencedTable}.limit`;
        this.url.searchParams.set(key, `${count}`);
        return this;
    }
    /**
	* Limit the query result by starting at an offset `from` and ending at the offset `to`.
	* Only records within this range are returned.
	* This respects the query order and if there is no order clause the range could behave unexpectedly.
	* The `from` and `to` values are 0-based and inclusive: `range(1, 3)` will include the second, third
	* and fourth rows of the query.
	*
	* @param from - The starting index from which to limit the result
	* @param to - The last index to which to limit the result
	* @param options - Named parameters
	* @param options.referencedTable - Set this to limit rows of referenced
	* tables instead of the parent table
	* @param options.foreignTable - Deprecated, use `options.referencedTable`
	* instead
	*
	* @category Database
	* @subcategory Using modifiers
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select('name')
	*   .range(0, 1)
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "Luke"
	*     },
	*     {
	*       "name": "Leia"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ range(from, to, { foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const keyOffset = typeof referencedTable === "undefined" ? "offset" : `${referencedTable}.offset`;
        const keyLimit = typeof referencedTable === "undefined" ? "limit" : `${referencedTable}.limit`;
        this.url.searchParams.set(keyOffset, `${from}`);
        this.url.searchParams.set(keyLimit, `${to - from + 1}`);
        return this;
    }
    /**
	* Set the AbortSignal for the fetch request.
	*
	* @param signal - The AbortSignal to use for the fetch request
	*
	* @category Database
	* @subcategory Using modifiers
	*
	* @remarks
	* You can use this to set a timeout for the request.
	*
	* @exampleDescription Aborting requests in-flight
	* You can use an [`AbortController`](https://developer.mozilla.org/en-US/docs/Web/API/AbortController) to abort requests.
	* Note that `status` and `statusText` don't mean anything for aborted requests as the request wasn't fulfilled.
	*
	* @example Aborting requests in-flight
	* ```ts
	* const ac = new AbortController()
	*
	* const { data, error } = await supabase
	*   .from('very_big_table')
	*   .select()
	*   .abortSignal(ac.signal)
	*
	* // Abort the request after 100 ms
	* setTimeout(() => ac.abort(), 100)
	* ```
	*
	* @exampleResponse Aborting requests in-flight
	* ```json
	*   {
	*     "error": {
	*       "message": "AbortError: The user aborted a request.",
	*       "details": "",
	*       "hint": "The request was aborted locally via the provided AbortSignal.",
	*       "code": ""
	*     },
	*     "status": 0,
	*     "statusText": ""
	*   }
	*
	* ```
	*
	* @example Set a timeout
	* ```ts
	* const { data, error } = await supabase
	*   .from('very_big_table')
	*   .select()
	*   .abortSignal(AbortSignal.timeout(1000 /* ms *\/))
	* ```
	*
	* @exampleResponse Set a timeout
	* ```json
	*   {
	*     "error": {
	*       "message": "FetchError: The user aborted a request.",
	*       "details": "",
	*       "hint": "",
	*       "code": ""
	*     },
	*     "status": 400,
	*     "statusText": "Bad Request"
	*   }
	*
	* ```
	*/ abortSignal(signal) {
        this.signal = signal;
        return this;
    }
    /**
	* Return `data` as a single object instead of an array of objects.
	*
	* Query result must be one row (e.g. using `.limit(1)`), otherwise this
	* returns an error.
	*
	* @category Database
	* @subcategory Using modifiers
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select('name')
	*   .limit(1)
	*   .single()
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": {
	*     "name": "Luke"
	*   },
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ single() {
        this.headers.set("Accept", "application/vnd.pgrst.object+json");
        return this;
    }
    /**
	* Return `data` as a single object instead of an array of objects.
	*
	* Query result must be zero or one row (e.g. using `.limit(1)`), otherwise
	* this returns an error.
	*
	* @category Database
	* @subcategory Using modifiers
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .eq('name', 'Katniss')
	*   .maybeSingle()
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ maybeSingle() {
        this.isMaybeSingle = true;
        return this;
    }
    /**
	* Return `data` as a string in CSV format.
	*
	* @category Database
	* @subcategory Using modifiers
	*
	* @exampleDescription Return data as CSV
	* By default, the data is returned in JSON format, but can also be returned as Comma Separated Values.
	*
	* @example Return data as CSV
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .csv()
	* ```
	*
	* @exampleSql Return data as CSV
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse Return data as CSV
	* ```json
	* {
	*   "data": "id,name\n1,Luke\n2,Leia\n3,Han",
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ csv() {
        this.headers.set("Accept", "text/csv");
        return this;
    }
    /**
	* Return `data` as an object in [GeoJSON](https://geojson.org) format.
	*
	* @category Database
	*/ geojson() {
        this.headers.set("Accept", "application/geo+json");
        return this;
    }
    /**
	* Return `data` as the EXPLAIN plan for the query.
	*
	* You need to enable the
	* [db_plan_enabled](https://supabase.com/docs/guides/database/debugging-performance#enabling-explain)
	* setting before using this method.
	*
	* @param options - Named parameters
	*
	* @param options.analyze - If `true`, the query will be executed and the
	* actual run time will be returned
	*
	* @param options.verbose - If `true`, the query identifier will be returned
	* and `data` will include the output columns of the query
	*
	* @param options.settings - If `true`, include information on configuration
	* parameters that affect query planning
	*
	* @param options.buffers - If `true`, include information on buffer usage
	*
	* @param options.wal - If `true`, include information on WAL record generation
	*
	* @param options.format - The format of the output, can be `"text"` (default)
	* or `"json"`
	*
	* @category Database
	* @subcategory Using modifiers
	*
	* @exampleDescription Get the execution plan
	* By default, the data is returned in TEXT format, but can also be returned as JSON by using the `format` parameter.
	*
	* @example Get the execution plan
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .explain()
	* ```
	*
	* @exampleSql Get the execution plan
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse Get the execution plan
	* ```js
	* Aggregate  (cost=33.34..33.36 rows=1 width=112)
	*   ->  Limit  (cost=0.00..18.33 rows=1000 width=40)
	*         ->  Seq Scan on characters  (cost=0.00..22.00 rows=1200 width=40)
	* ```
	*
	* @exampleDescription Get the execution plan with analyze and verbose
	* By default, the data is returned in TEXT format, but can also be returned as JSON by using the `format` parameter.
	*
	* @example Get the execution plan with analyze and verbose
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .explain({analyze:true,verbose:true})
	* ```
	*
	* @exampleSql Get the execution plan with analyze and verbose
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse Get the execution plan with analyze and verbose
	* ```js
	* Aggregate  (cost=33.34..33.36 rows=1 width=112) (actual time=0.041..0.041 rows=1 loops=1)
	*   Output: NULL::bigint, count(ROW(characters.id, characters.name)), COALESCE(json_agg(ROW(characters.id, characters.name)), '[]'::json), NULLIF(current_setting('response.headers'::text, true), ''::text), NULLIF(current_setting('response.status'::text, true), ''::text)
	*   ->  Limit  (cost=0.00..18.33 rows=1000 width=40) (actual time=0.005..0.006 rows=3 loops=1)
	*         Output: characters.id, characters.name
	*         ->  Seq Scan on public.characters  (cost=0.00..22.00 rows=1200 width=40) (actual time=0.004..0.005 rows=3 loops=1)
	*               Output: characters.id, characters.name
	* Query Identifier: -4730654291623321173
	* Planning Time: 0.407 ms
	* Execution Time: 0.119 ms
	* ```
	*/ explain({ analyze: analyze = false, verbose: verbose = false, settings: settings = false, buffers: buffers = false, wal: wal = false, format: format = "text" } = {}) {
        var _this$headers$get;
        const options = [
            analyze ? "analyze" : null,
            verbose ? "verbose" : null,
            settings ? "settings" : null,
            buffers ? "buffers" : null,
            wal ? "wal" : null
        ].filter(Boolean).join("|");
        const forMediatype = (_this$headers$get = this.headers.get("Accept")) !== null && _this$headers$get !== void 0 ? _this$headers$get : "application/json";
        this.headers.set("Accept", `application/vnd.pgrst.plan+${format}; for="${forMediatype}"; options=${options};`);
        if (format === "json") return this;
        else return this;
    }
    /**
	* Rollback the query.
	*
	* `data` will still be returned, but the query is not committed.
	*
	* @category Database
	*/ rollback() {
        this.headers.append("Prefer", "tx=rollback");
        return this;
    }
    /**
	* Override the type of the returned `data`.
	*
	* @typeParam NewResult - The new result type to override with
	* @deprecated Use overrideTypes<yourType, { merge: false }>() method at the end of your call chain instead
	*
	* @category Database
	* @subcategory Using modifiers
	*
	* @remarks
	* - Deprecated: use overrideTypes method instead
	*
	* @example Override type of successful response
	* ```ts
	* const { data } = await supabase
	*   .from('countries')
	*   .select()
	*   .returns<Array<MyType>>()
	* ```
	*
	* @exampleResponse Override type of successful response
	* ```js
	* let x: typeof data // MyType[]
	* ```
	*
	* @example Override type of object response
	* ```ts
	* const { data } = await supabase
	*   .from('countries')
	*   .select()
	*   .maybeSingle()
	*   .returns<MyType>()
	* ```
	*
	* @exampleResponse Override type of object response
	* ```js
	* let x: typeof data // MyType | null
	* ```
	*/ returns() {
        return this;
    }
    /**
	* Set the maximum number of rows that can be affected by the query.
	* Only available in PostgREST v13+ and only works with PATCH and DELETE methods.
	*
	* @param value - The maximum number of rows that can be affected
	*
	* @category Database
	*/ maxAffected(value) {
        this.headers.append("Prefer", "handling=strict");
        this.headers.append("Prefer", `max-affected=${value}`);
        return this;
    }
};
//#endregion
//#region src/PostgrestFilterBuilder.ts
const $cfc0ca97c19fecec$var$PostgrestReservedCharsRegexp = /* @__PURE__ */ new RegExp("[,()]");
var $cfc0ca97c19fecec$export$3158317c13bdc93a = class extends $cfc0ca97c19fecec$export$7b4361bb87e3030c {
    /**
	* Match only rows where `column` is equal to `value`.
	*
	* To check if the value of `column` is NULL, you should use `.is()` instead.
	*
	* @param column - The column to filter on
	* @param value - The value to filter with
	*
	* @category Database
	* @subcategory Using filters
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .eq('name', 'Leia')
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 2,
	*       "name": "Leia"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ eq(column, value) {
        this.url.searchParams.append(column, `eq.${value}`);
        return this;
    }
    /**
	* Match only rows where `column` is not equal to `value`.
	*
	* @param column - The column to filter on
	* @param value - The value to filter with
	*
	* @category Database
	* @subcategory Using filters
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .neq('name', 'Leia')
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Luke"
	*     },
	*     {
	*       "id": 3,
	*       "name": "Han"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ neq(column, value) {
        this.url.searchParams.append(column, `neq.${value}`);
        return this;
    }
    /**
	* Match only rows where `column` is greater than `value`.
	*
	* @param column - The column to filter on
	* @param value - The value to filter with
	*
	* @category Database
	* @subcategory Using filters
	*
	* @exampleDescription With `select()`
	* When using [reserved words](https://www.postgresql.org/docs/current/sql-keywords-appendix.html) for column names you need
	* to add double quotes e.g. `.gt('"order"', 2)`
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .gt('id', 2)
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 3,
	*       "name": "Han"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ gt(column, value) {
        this.url.searchParams.append(column, `gt.${value}`);
        return this;
    }
    /**
	* Match only rows where `column` is greater than or equal to `value`.
	*
	* @param column - The column to filter on
	* @param value - The value to filter with
	*
	* @category Database
	* @subcategory Using filters
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .gte('id', 2)
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 2,
	*       "name": "Leia"
	*     },
	*     {
	*       "id": 3,
	*       "name": "Han"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ gte(column, value) {
        this.url.searchParams.append(column, `gte.${value}`);
        return this;
    }
    /**
	* Match only rows where `column` is less than `value`.
	*
	* @param column - The column to filter on
	* @param value - The value to filter with
	*
	* @category Database
	* @subcategory Using filters
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .lt('id', 2)
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Luke"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ lt(column, value) {
        this.url.searchParams.append(column, `lt.${value}`);
        return this;
    }
    /**
	* Match only rows where `column` is less than or equal to `value`.
	*
	* @param column - The column to filter on
	* @param value - The value to filter with
	*
	* @category Database
	* @subcategory Using filters
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .lte('id', 2)
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Luke"
	*     },
	*     {
	*       "id": 2,
	*       "name": "Leia"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ lte(column, value) {
        this.url.searchParams.append(column, `lte.${value}`);
        return this;
    }
    /**
	* Match only rows where `column` matches `pattern` case-sensitively.
	*
	* @param column - The column to filter on
	* @param pattern - The pattern to match with
	*
	* @category Database
	* @subcategory Using filters
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .like('name', '%Lu%')
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Luke"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ like(column, pattern) {
        this.url.searchParams.append(column, `like.${pattern}`);
        return this;
    }
    /**
	* Match only rows where `column` matches all of `patterns` case-sensitively.
	*
	* @param column - The column to filter on
	* @param patterns - The patterns to match with
	*
	* @category Database
	* @subcategory Using filters
	*/ likeAllOf(column, patterns) {
        this.url.searchParams.append(column, `like(all).{${patterns.join(",")}}`);
        return this;
    }
    /**
	* Match only rows where `column` matches any of `patterns` case-sensitively.
	*
	* @param column - The column to filter on
	* @param patterns - The patterns to match with
	*
	* @category Database
	* @subcategory Using filters
	*/ likeAnyOf(column, patterns) {
        this.url.searchParams.append(column, `like(any).{${patterns.join(",")}}`);
        return this;
    }
    /**
	* Match only rows where `column` matches `pattern` case-insensitively.
	*
	* @param column - The column to filter on
	* @param pattern - The pattern to match with
	*
	* @category Database
	* @subcategory Using filters
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .ilike('name', '%lu%')
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Luke"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ ilike(column, pattern) {
        this.url.searchParams.append(column, `ilike.${pattern}`);
        return this;
    }
    /**
	* Match only rows where `column` matches all of `patterns` case-insensitively.
	*
	* @param column - The column to filter on
	* @param patterns - The patterns to match with
	*
	* @category Database
	* @subcategory Using filters
	*/ ilikeAllOf(column, patterns) {
        this.url.searchParams.append(column, `ilike(all).{${patterns.join(",")}}`);
        return this;
    }
    /**
	* Match only rows where `column` matches any of `patterns` case-insensitively.
	*
	* @param column - The column to filter on
	* @param patterns - The patterns to match with
	*
	* @category Database
	* @subcategory Using filters
	*/ ilikeAnyOf(column, patterns) {
        this.url.searchParams.append(column, `ilike(any).{${patterns.join(",")}}`);
        return this;
    }
    /**
	* Match only rows where `column` matches the PostgreSQL regex `pattern`
	* case-sensitively (using the `~` operator).
	*
	* @param column - The column to filter on
	* @param pattern - The PostgreSQL regular expression pattern to match with
	*/ regexMatch(column, pattern) {
        this.url.searchParams.append(column, `match.${pattern}`);
        return this;
    }
    /**
	* Match only rows where `column` matches the PostgreSQL regex `pattern`
	* case-insensitively (using the `~*` operator).
	*
	* @param column - The column to filter on
	* @param pattern - The PostgreSQL regular expression pattern to match with
	*/ regexIMatch(column, pattern) {
        this.url.searchParams.append(column, `imatch.${pattern}`);
        return this;
    }
    /**
	* Match only rows where `column` IS `value`.
	*
	* For non-boolean columns, this is only relevant for checking if the value of
	* `column` is NULL by setting `value` to `null`.
	*
	* For boolean columns, you can also set `value` to `true` or `false` and it
	* will behave the same way as `.eq()`.
	*
	* @param column - The column to filter on
	* @param value - The value to filter with
	*
	* @category Database
	* @subcategory Using filters
	*
	* @exampleDescription Checking for nullness, true or false
	* Using the `eq()` filter doesn't work when filtering for `null`.
	*
	* Instead, you need to use `is()`.
	*
	* @example Checking for nullness, true or false
	* ```ts
	* const { data, error } = await supabase
	*   .from('countries')
	*   .select()
	*   .is('name', null)
	* ```
	*
	* @exampleSql Checking for nullness, true or false
	* ```sql
	* create table
	*   countries (id int8 primary key, name text);
	*
	* insert into
	*   countries (id, name)
	* values
	*   (1, 'null'),
	*   (2, null);
	* ```
	*
	* @exampleResponse Checking for nullness, true or false
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 2,
	*       "name": "null"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ is(column, value) {
        this.url.searchParams.append(column, `is.${value}`);
        return this;
    }
    /**
	* Match only rows where `column` IS DISTINCT FROM `value`.
	*
	* Unlike `.neq()`, this treats `NULL` as a comparable value. Two `NULL` values
	* are considered equal (not distinct), and comparing `NULL` with any non-NULL
	* value returns true (distinct).
	*
	* @param column - The column to filter on
	* @param value - The value to filter with
	*/ isDistinct(column, value) {
        this.url.searchParams.append(column, `isdistinct.${value}`);
        return this;
    }
    /**
	* Match only rows where `column` is included in the `values` array.
	*
	* @param column - The column to filter on
	* @param values - The values array to filter with
	*
	* @category Database
	* @subcategory Using filters
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .in('name', ['Leia', 'Han'])
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 2,
	*       "name": "Leia"
	*     },
	*     {
	*       "id": 3,
	*       "name": "Han"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ in(column, values) {
        const cleanedValues = Array.from(new Set(values)).map((s)=>{
            if (typeof s === "string" && $cfc0ca97c19fecec$var$PostgrestReservedCharsRegexp.test(s)) return `"${s}"`;
            else return `${s}`;
        }).join(",");
        this.url.searchParams.append(column, `in.(${cleanedValues})`);
        return this;
    }
    /**
	* Match only rows where `column` is NOT included in the `values` array.
	*
	* @param column - The column to filter on
	* @param values - The values array to filter with
	*/ notIn(column, values) {
        const cleanedValues = Array.from(new Set(values)).map((s)=>{
            if (typeof s === "string" && $cfc0ca97c19fecec$var$PostgrestReservedCharsRegexp.test(s)) return `"${s}"`;
            else return `${s}`;
        }).join(",");
        this.url.searchParams.append(column, `not.in.(${cleanedValues})`);
        return this;
    }
    /**
	* Only relevant for jsonb, array, and range columns. Match only rows where
	* `column` contains every element appearing in `value`.
	*
	* @param column - The jsonb, array, or range column to filter on
	* @param value - The jsonb, array, or range value to filter with
	*
	* @category Database
	* @subcategory Using filters
	*
	* @example On array columns
	* ```ts
	* const { data, error } = await supabase
	*   .from('issues')
	*   .select()
	*   .contains('tags', ['is:open', 'priority:low'])
	* ```
	*
	* @exampleSql On array columns
	* ```sql
	* create table
	*   issues (
	*     id int8 primary key,
	*     title text,
	*     tags text[]
	*   );
	*
	* insert into
	*   issues (id, title, tags)
	* values
	*   (1, 'Cache invalidation is not working', array['is:open', 'severity:high', 'priority:low']),
	*   (2, 'Use better names', array['is:open', 'severity:low', 'priority:medium']);
	* ```
	*
	* @exampleResponse On array columns
	* ```json
	* {
	*   "data": [
	*     {
	*       "title": "Cache invalidation is not working"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription On range columns
	* Postgres supports a number of [range
	* types](https://www.postgresql.org/docs/current/rangetypes.html). You
	* can filter on range columns using the string representation of range
	* values.
	*
	* @example On range columns
	* ```ts
	* const { data, error } = await supabase
	*   .from('reservations')
	*   .select()
	*   .contains('during', '[2000-01-01 13:00, 2000-01-01 13:30)')
	* ```
	*
	* @exampleSql On range columns
	* ```sql
	* create table
	*   reservations (
	*     id int8 primary key,
	*     room_name text,
	*     during tsrange
	*   );
	*
	* insert into
	*   reservations (id, room_name, during)
	* values
	*   (1, 'Emerald', '[2000-01-01 13:00, 2000-01-01 15:00)'),
	*   (2, 'Topaz', '[2000-01-02 09:00, 2000-01-02 10:00)');
	* ```
	*
	* @exampleResponse On range columns
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "room_name": "Emerald",
	*       "during": "[\"2000-01-01 13:00:00\",\"2000-01-01 15:00:00\")"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @example On `jsonb` columns
	* ```ts
	* const { data, error } = await supabase
	*   .from('users')
	*   .select('name')
	*   .contains('address', { postcode: 90210 })
	* ```
	*
	* @exampleSql On `jsonb` columns
	* ```sql
	* create table
	*   users (
	*     id int8 primary key,
	*     name text,
	*     address jsonb
	*   );
	*
	* insert into
	*   users (id, name, address)
	* values
	*   (1, 'Michael', '{ "postcode": 90210, "street": "Melrose Place" }'),
	*   (2, 'Jane', '{}');
	* ```
	*
	* @exampleResponse On `jsonb` columns
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "Michael"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ contains(column, value) {
        if (typeof value === "string") this.url.searchParams.append(column, `cs.${value}`);
        else if (Array.isArray(value)) this.url.searchParams.append(column, `cs.{${value.join(",")}}`);
        else this.url.searchParams.append(column, `cs.${JSON.stringify(value)}`);
        return this;
    }
    /**
	* Only relevant for jsonb, array, and range columns. Match only rows where
	* every element appearing in `column` is contained by `value`.
	*
	* @param column - The jsonb, array, or range column to filter on
	* @param value - The jsonb, array, or range value to filter with
	*
	* @category Database
	* @subcategory Using filters
	*
	* @example On array columns
	* ```ts
	* const { data, error } = await supabase
	*   .from('classes')
	*   .select('name')
	*   .containedBy('days', ['monday', 'tuesday', 'wednesday', 'friday'])
	* ```
	*
	* @exampleSql On array columns
	* ```sql
	* create table
	*   classes (
	*     id int8 primary key,
	*     name text,
	*     days text[]
	*   );
	*
	* insert into
	*   classes (id, name, days)
	* values
	*   (1, 'Chemistry', array['monday', 'friday']),
	*   (2, 'History', array['monday', 'wednesday', 'thursday']);
	* ```
	*
	* @exampleResponse On array columns
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "Chemistry"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription On range columns
	* Postgres supports a number of [range
	* types](https://www.postgresql.org/docs/current/rangetypes.html). You
	* can filter on range columns using the string representation of range
	* values.
	*
	* @example On range columns
	* ```ts
	* const { data, error } = await supabase
	*   .from('reservations')
	*   .select()
	*   .containedBy('during', '[2000-01-01 00:00, 2000-01-01 23:59)')
	* ```
	*
	* @exampleSql On range columns
	* ```sql
	* create table
	*   reservations (
	*     id int8 primary key,
	*     room_name text,
	*     during tsrange
	*   );
	*
	* insert into
	*   reservations (id, room_name, during)
	* values
	*   (1, 'Emerald', '[2000-01-01 13:00, 2000-01-01 15:00)'),
	*   (2, 'Topaz', '[2000-01-02 09:00, 2000-01-02 10:00)');
	* ```
	*
	* @exampleResponse On range columns
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "room_name": "Emerald",
	*       "during": "[\"2000-01-01 13:00:00\",\"2000-01-01 15:00:00\")"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @example On `jsonb` columns
	* ```ts
	* const { data, error } = await supabase
	*   .from('users')
	*   .select('name')
	*   .containedBy('address', {})
	* ```
	*
	* @exampleSql On `jsonb` columns
	* ```sql
	* create table
	*   users (
	*     id int8 primary key,
	*     name text,
	*     address jsonb
	*   );
	*
	* insert into
	*   users (id, name, address)
	* values
	*   (1, 'Michael', '{ "postcode": 90210, "street": "Melrose Place" }'),
	*   (2, 'Jane', '{}');
	* ```
	*
	* @exampleResponse On `jsonb` columns
	* ```json
	*   {
	*     "data": [
	*       {
	*         "name": "Jane"
	*       }
	*     ],
	*     "status": 200,
	*     "statusText": "OK"
	*   }
	*
	* ```
	*/ containedBy(column, value) {
        if (typeof value === "string") this.url.searchParams.append(column, `cd.${value}`);
        else if (Array.isArray(value)) this.url.searchParams.append(column, `cd.{${value.join(",")}}`);
        else this.url.searchParams.append(column, `cd.${JSON.stringify(value)}`);
        return this;
    }
    /**
	* Only relevant for range columns. Match only rows where every element in
	* `column` is greater than any element in `range`.
	*
	* @param column - The range column to filter on
	* @param range - The range to filter with
	*
	* @category Database
	* @subcategory Using filters
	*
	* @exampleDescription With `select()`
	* Postgres supports a number of [range
	* types](https://www.postgresql.org/docs/current/rangetypes.html). You
	* can filter on range columns using the string representation of range
	* values.
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('reservations')
	*   .select()
	*   .rangeGt('during', '[2000-01-02 08:00, 2000-01-02 09:00)')
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   reservations (
	*     id int8 primary key,
	*     room_name text,
	*     during tsrange
	*   );
	*
	* insert into
	*   reservations (id, room_name, during)
	* values
	*   (1, 'Emerald', '[2000-01-01 13:00, 2000-01-01 15:00)'),
	*   (2, 'Topaz', '[2000-01-02 09:00, 2000-01-02 10:00)');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	*   {
	*     "data": [
	*       {
	*         "id": 2,
	*         "room_name": "Topaz",
	*         "during": "[\"2000-01-02 09:00:00\",\"2000-01-02 10:00:00\")"
	*       }
	*     ],
	*     "status": 200,
	*     "statusText": "OK"
	*   }
	*
	* ```
	*/ rangeGt(column, range) {
        this.url.searchParams.append(column, `sr.${range}`);
        return this;
    }
    /**
	* Only relevant for range columns. Match only rows where every element in
	* `column` is either contained in `range` or greater than any element in
	* `range`.
	*
	* @param column - The range column to filter on
	* @param range - The range to filter with
	*
	* @category Database
	* @subcategory Using filters
	*
	* @exampleDescription With `select()`
	* Postgres supports a number of [range
	* types](https://www.postgresql.org/docs/current/rangetypes.html). You
	* can filter on range columns using the string representation of range
	* values.
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('reservations')
	*   .select()
	*   .rangeGte('during', '[2000-01-02 08:30, 2000-01-02 09:30)')
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   reservations (
	*     id int8 primary key,
	*     room_name text,
	*     during tsrange
	*   );
	*
	* insert into
	*   reservations (id, room_name, during)
	* values
	*   (1, 'Emerald', '[2000-01-01 13:00, 2000-01-01 15:00)'),
	*   (2, 'Topaz', '[2000-01-02 09:00, 2000-01-02 10:00)');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	*   {
	*     "data": [
	*       {
	*         "id": 2,
	*         "room_name": "Topaz",
	*         "during": "[\"2000-01-02 09:00:00\",\"2000-01-02 10:00:00\")"
	*       }
	*     ],
	*     "status": 200,
	*     "statusText": "OK"
	*   }
	*
	* ```
	*/ rangeGte(column, range) {
        this.url.searchParams.append(column, `nxl.${range}`);
        return this;
    }
    /**
	* Only relevant for range columns. Match only rows where every element in
	* `column` is less than any element in `range`.
	*
	* @param column - The range column to filter on
	* @param range - The range to filter with
	*
	* @category Database
	* @subcategory Using filters
	*
	* @exampleDescription With `select()`
	* Postgres supports a number of [range
	* types](https://www.postgresql.org/docs/current/rangetypes.html). You
	* can filter on range columns using the string representation of range
	* values.
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('reservations')
	*   .select()
	*   .rangeLt('during', '[2000-01-01 15:00, 2000-01-01 16:00)')
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   reservations (
	*     id int8 primary key,
	*     room_name text,
	*     during tsrange
	*   );
	*
	* insert into
	*   reservations (id, room_name, during)
	* values
	*   (1, 'Emerald', '[2000-01-01 13:00, 2000-01-01 15:00)'),
	*   (2, 'Topaz', '[2000-01-02 09:00, 2000-01-02 10:00)');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "room_name": "Emerald",
	*       "during": "[\"2000-01-01 13:00:00\",\"2000-01-01 15:00:00\")"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ rangeLt(column, range) {
        this.url.searchParams.append(column, `sl.${range}`);
        return this;
    }
    /**
	* Only relevant for range columns. Match only rows where every element in
	* `column` is either contained in `range` or less than any element in
	* `range`.
	*
	* @param column - The range column to filter on
	* @param range - The range to filter with
	*
	* @category Database
	* @subcategory Using filters
	*
	* @exampleDescription With `select()`
	* Postgres supports a number of [range
	* types](https://www.postgresql.org/docs/current/rangetypes.html). You
	* can filter on range columns using the string representation of range
	* values.
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('reservations')
	*   .select()
	*   .rangeLte('during', '[2000-01-01 14:00, 2000-01-01 16:00)')
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   reservations (
	*     id int8 primary key,
	*     room_name text,
	*     during tsrange
	*   );
	*
	* insert into
	*   reservations (id, room_name, during)
	* values
	*   (1, 'Emerald', '[2000-01-01 13:00, 2000-01-01 15:00)'),
	*   (2, 'Topaz', '[2000-01-02 09:00, 2000-01-02 10:00)');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	*   {
	*     "data": [
	*       {
	*         "id": 1,
	*         "room_name": "Emerald",
	*         "during": "[\"2000-01-01 13:00:00\",\"2000-01-01 15:00:00\")"
	*       }
	*     ],
	*     "status": 200,
	*     "statusText": "OK"
	*   }
	*
	* ```
	*/ rangeLte(column, range) {
        this.url.searchParams.append(column, `nxr.${range}`);
        return this;
    }
    /**
	* Only relevant for range columns. Match only rows where `column` is
	* mutually exclusive to `range` and there can be no element between the two
	* ranges.
	*
	* @param column - The range column to filter on
	* @param range - The range to filter with
	*
	* @category Database
	* @subcategory Using filters
	*
	* @exampleDescription With `select()`
	* Postgres supports a number of [range
	* types](https://www.postgresql.org/docs/current/rangetypes.html). You
	* can filter on range columns using the string representation of range
	* values.
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('reservations')
	*   .select()
	*   .rangeAdjacent('during', '[2000-01-01 12:00, 2000-01-01 13:00)')
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   reservations (
	*     id int8 primary key,
	*     room_name text,
	*     during tsrange
	*   );
	*
	* insert into
	*   reservations (id, room_name, during)
	* values
	*   (1, 'Emerald', '[2000-01-01 13:00, 2000-01-01 15:00)'),
	*   (2, 'Topaz', '[2000-01-02 09:00, 2000-01-02 10:00)');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "room_name": "Emerald",
	*       "during": "[\"2000-01-01 13:00:00\",\"2000-01-01 15:00:00\")"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ rangeAdjacent(column, range) {
        this.url.searchParams.append(column, `adj.${range}`);
        return this;
    }
    /**
	* Only relevant for array and range columns. Match only rows where
	* `column` and `value` have an element in common.
	*
	* @param column - The array or range column to filter on
	* @param value - The array or range value to filter with
	*
	* @category Database
	* @subcategory Using filters
	*
	* @example On array columns
	* ```ts
	* const { data, error } = await supabase
	*   .from('issues')
	*   .select('title')
	*   .overlaps('tags', ['is:closed', 'severity:high'])
	* ```
	*
	* @exampleSql On array columns
	* ```sql
	* create table
	*   issues (
	*     id int8 primary key,
	*     title text,
	*     tags text[]
	*   );
	*
	* insert into
	*   issues (id, title, tags)
	* values
	*   (1, 'Cache invalidation is not working', array['is:open', 'severity:high', 'priority:low']),
	*   (2, 'Use better names', array['is:open', 'severity:low', 'priority:medium']);
	* ```
	*
	* @exampleResponse On array columns
	* ```json
	* {
	*   "data": [
	*     {
	*       "title": "Cache invalidation is not working"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription On range columns
	* Postgres supports a number of [range
	* types](https://www.postgresql.org/docs/current/rangetypes.html). You
	* can filter on range columns using the string representation of range
	* values.
	*
	* @example On range columns
	* ```ts
	* const { data, error } = await supabase
	*   .from('reservations')
	*   .select()
	*   .overlaps('during', '[2000-01-01 12:45, 2000-01-01 13:15)')
	* ```
	*
	* @exampleSql On range columns
	* ```sql
	* create table
	*   reservations (
	*     id int8 primary key,
	*     room_name text,
	*     during tsrange
	*   );
	*
	* insert into
	*   reservations (id, room_name, during)
	* values
	*   (1, 'Emerald', '[2000-01-01 13:00, 2000-01-01 15:00)'),
	*   (2, 'Topaz', '[2000-01-02 09:00, 2000-01-02 10:00)');
	* ```
	*
	* @exampleResponse On range columns
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "room_name": "Emerald",
	*       "during": "[\"2000-01-01 13:00:00\",\"2000-01-01 15:00:00\")"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ overlaps(column, value) {
        if (typeof value === "string") this.url.searchParams.append(column, `ov.${value}`);
        else this.url.searchParams.append(column, `ov.{${value.join(",")}}`);
        return this;
    }
    /**
	* Only relevant for text and tsvector columns. Match only rows where
	* `column` matches the query string in `query`.
	*
	* @param column - The text or tsvector column to filter on
	* @param query - The query text to match with
	* @param options - Named parameters
	* @param options.config - The text search configuration to use
	* @param options.type - Change how the `query` text is interpreted
	*
	* @category Database
	* @subcategory Using filters
	*
	* @remarks
	* - For more information, see [Postgres full text search](/docs/guides/database/full-text-search).
	*
	* @example Text search
	* ```ts
	* const result = await supabase
	*   .from("texts")
	*   .select("content")
	*   .textSearch("content", `'eggs' & 'ham'`, {
	*     config: "english",
	*   });
	* ```
	*
	* @exampleSql Text search
	* ```sql
	* create table texts (
	*   id      bigint
	*           primary key
	*           generated always as identity,
	*   content text
	* );
	*
	* insert into texts (content) values
	*     ('Four score and seven years ago'),
	*     ('The road goes ever on and on'),
	*     ('Green eggs and ham')
	* ;
	* ```
	*
	* @exampleResponse Text search
	* ```json
	* {
	*   "data": [
	*     {
	*       "content": "Green eggs and ham"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Basic normalization
	* Uses PostgreSQL's `plainto_tsquery` function.
	*
	* @example Basic normalization
	* ```ts
	* const { data, error } = await supabase
	*   .from('quotes')
	*   .select('catchphrase')
	*   .textSearch('catchphrase', `'fat' & 'cat'`, {
	*     type: 'plain',
	*     config: 'english'
	*   })
	* ```
	*
	* @exampleDescription Full normalization
	* Uses PostgreSQL's `phraseto_tsquery` function.
	*
	* @example Full normalization
	* ```ts
	* const { data, error } = await supabase
	*   .from('quotes')
	*   .select('catchphrase')
	*   .textSearch('catchphrase', `'fat' & 'cat'`, {
	*     type: 'phrase',
	*     config: 'english'
	*   })
	* ```
	*
	* @exampleDescription Websearch
	* Uses PostgreSQL's `websearch_to_tsquery` function.
	* This function will never raise syntax errors, which makes it possible to use raw user-supplied input for search, and can be used
	* with advanced operators.
	*
	* - `unquoted text`: text not inside quote marks will be converted to terms separated by & operators, as if processed by plainto_tsquery.
	* - `"quoted text"`: text inside quote marks will be converted to terms separated by `<->` operators, as if processed by phraseto_tsquery.
	* - `OR`: the word “or” will be converted to the | operator.
	* - `-`: a dash will be converted to the ! operator.
	*
	* @example Websearch
	* ```ts
	* const { data, error } = await supabase
	*   .from('quotes')
	*   .select('catchphrase')
	*   .textSearch('catchphrase', `'fat or cat'`, {
	*     type: 'websearch',
	*     config: 'english'
	*   })
	* ```
	*/ textSearch(column, query, { config: config, type: type } = {}) {
        let typePart = "";
        if (type === "plain") typePart = "pl";
        else if (type === "phrase") typePart = "ph";
        else if (type === "websearch") typePart = "w";
        const configPart = config === void 0 ? "" : `(${config})`;
        this.url.searchParams.append(column, `${typePart}fts${configPart}.${query}`);
        return this;
    }
    /**
	* Match only rows where each column in `query` keys is equal to its
	* associated value. Shorthand for multiple `.eq()`s.
	*
	* @param query - The object to filter with, with column names as keys mapped
	* to their filter values
	*
	* @category Database
	* @subcategory Using filters
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select('name')
	*   .match({ id: 2, name: 'Leia' })
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "Leia"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ match(query) {
        Object.entries(query).filter(([_, value])=>value !== void 0).forEach(([column, value])=>{
            this.url.searchParams.append(column, `eq.${value}`);
        });
        return this;
    }
    /**
	* Match only rows which doesn't satisfy the filter.
	*
	* Unlike most filters, `opearator` and `value` are used as-is and need to
	* follow [PostgREST
	* syntax](https://postgrest.org/en/stable/api.html#operators). You also need
	* to make sure they are properly sanitized.
	*
	* @param column - The column to filter on
	* @param operator - The operator to be negated to filter with, following
	* PostgREST syntax
	* @param value - The value to filter with, following PostgREST syntax
	*
	* @category Database
	* @subcategory Using filters
	*
	* @remarks
	* not() expects you to use the raw PostgREST syntax for the filter values.
	*
	* ```ts
	* .not('id', 'in', '(5,6,7)')  // Use `()` for `in` filter
	* .not('arraycol', 'cs', '{"a","b"}')  // Use `cs` for `contains()`, `{}` for array values
	* ```
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('countries')
	*   .select()
	*   .not('name', 'is', null)
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   countries (id int8 primary key, name text);
	*
	* insert into
	*   countries (id, name)
	* values
	*   (1, 'null'),
	*   (2, null);
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	*   {
	*     "data": [
	*       {
	*         "id": 1,
	*         "name": "null"
	*       }
	*     ],
	*     "status": 200,
	*     "statusText": "OK"
	*   }
	*
	* ```
	*/ not(column, operator, value) {
        this.url.searchParams.append(column, `not.${operator}.${value}`);
        return this;
    }
    /**
	* Match only rows which satisfy at least one of the filters.
	*
	* Unlike most filters, `filters` is used as-is and needs to follow [PostgREST
	* syntax](https://postgrest.org/en/stable/api.html#operators). You also need
	* to make sure it's properly sanitized.
	*
	* It's currently not possible to do an `.or()` filter across multiple tables.
	*
	* @param filters - The filters to use, following PostgREST syntax
	* @param options - Named parameters
	* @param options.referencedTable - Set this to filter on referenced tables
	* instead of the parent table
	* @param options.foreignTable - Deprecated, use `referencedTable` instead
	*
	* @category Database
	* @subcategory Using filters
	*
	* @remarks
	* or() expects you to use the raw PostgREST syntax for the filter names and values.
	*
	* ```ts
	* .or('id.in.(5,6,7), arraycol.cs.{"a","b"}')  // Use `()` for `in` filter, `{}` for array values and `cs` for `contains()`.
	* .or('id.in.(5,6,7), arraycol.cd.{"a","b"}')  // Use `cd` for `containedBy()`
	* ```
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select('name')
	*   .or('id.eq.2,name.eq.Han')
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "Leia"
	*     },
	*     {
	*       "name": "Han"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @example Use `or` with `and`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select('name')
	*   .or('id.gt.3,and(id.eq.1,name.eq.Luke)')
	* ```
	*
	* @exampleSql Use `or` with `and`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse Use `or` with `and`
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "Luke"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @example Use `or` on referenced tables
	* ```ts
	* const { data, error } = await supabase
	*   .from('orchestral_sections')
	*   .select(`
	*     name,
	*     instruments!inner (
	*       name
	*     )
	*   `)
	*   .or('section_id.eq.1,name.eq.guzheng', { referencedTable: 'instruments' })
	* ```
	*
	* @exampleSql Use `or` on referenced tables
	* ```sql
	* create table
	*   orchestral_sections (id int8 primary key, name text);
	* create table
	*   instruments (
	*     id int8 primary key,
	*     section_id int8 not null references orchestral_sections,
	*     name text
	*   );
	*
	* insert into
	*   orchestral_sections (id, name)
	* values
	*   (1, 'strings'),
	*   (2, 'woodwinds');
	* insert into
	*   instruments (id, section_id, name)
	* values
	*   (1, 2, 'flute'),
	*   (2, 1, 'violin');
	* ```
	*
	* @exampleResponse Use `or` on referenced tables
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "strings",
	*       "instruments": [
	*         {
	*           "name": "violin"
	*         }
	*       ]
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ or(filters, { foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const key = referencedTable ? `${referencedTable}.or` : "or";
        this.url.searchParams.append(key, `(${filters})`);
        return this;
    }
    /**
	* Match only rows which satisfy the filter. This is an escape hatch - you
	* should use the specific filter methods wherever possible.
	*
	* Unlike most filters, `opearator` and `value` are used as-is and need to
	* follow [PostgREST
	* syntax](https://postgrest.org/en/stable/api.html#operators). You also need
	* to make sure they are properly sanitized.
	*
	* @param column - The column to filter on
	* @param operator - The operator to filter with, following PostgREST syntax
	* @param value - The value to filter with, following PostgREST syntax
	*
	* @category Database
	* @subcategory Using filters
	*
	* @remarks
	* filter() expects you to use the raw PostgREST syntax for the filter values.
	*
	* ```ts
	* .filter('id', 'in', '(5,6,7)')  // Use `()` for `in` filter
	* .filter('arraycol', 'cs', '{"a","b"}')  // Use `cs` for `contains()`, `{}` for array values
	* ```
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .filter('name', 'in', '("Han","Yoda")')
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 3,
	*       "name": "Han"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @example On a referenced table
	* ```ts
	* const { data, error } = await supabase
	*   .from('orchestral_sections')
	*   .select(`
	*     name,
	*     instruments!inner (
	*       name
	*     )
	*   `)
	*   .filter('instruments.name', 'eq', 'flute')
	* ```
	*
	* @exampleSql On a referenced table
	* ```sql
	* create table
	*   orchestral_sections (id int8 primary key, name text);
	* create table
	*    instruments (
	*     id int8 primary key,
	*     section_id int8 not null references orchestral_sections,
	*     name text
	*   );
	*
	* insert into
	*   orchestral_sections (id, name)
	* values
	*   (1, 'strings'),
	*   (2, 'woodwinds');
	* insert into
	*   instruments (id, section_id, name)
	* values
	*   (1, 2, 'flute'),
	*   (2, 1, 'violin');
	* ```
	*
	* @exampleResponse On a referenced table
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "woodwinds",
	*       "instruments": [
	*         {
	*           "name": "flute"
	*         }
	*       ]
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ filter(column, operator, value) {
        this.url.searchParams.append(column, `${operator}.${value}`);
        return this;
    }
};
//#endregion
//#region src/PostgrestQueryBuilder.ts
var $cfc0ca97c19fecec$export$a81993b50ca081ad = class {
    /**
	* Creates a query builder scoped to a Postgres table or view.
	*
	* @category Database
	*
	* @param url - The URL for the query
	* @param options - Named parameters
	* @param options.headers - Custom headers
	* @param options.schema - Postgres schema to use
	* @param options.fetch - Custom fetch implementation
	* @param options.urlLengthLimit - Maximum URL length before warning
	* @param options.retry - Enable automatic retries for transient errors (default: true)
	*
	* @example Using supabase-js (recommended)
	* ```ts
	* import { createClient } from '@supabase/supabase-js'
	*
	* const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
	* const { data, error } = await supabase.from('users').select('*')
	* ```
	*
	* @example Standalone import for bundle-sensitive environments
	* ```ts
	* import { PostgrestQueryBuilder } from '@supabase/postgrest-js'
	*
	* const query = new PostgrestQueryBuilder(
	*   new URL('https://xyzcompany.supabase.co/rest/v1/users'),
	*   { headers: { apikey: 'your-publishable-key' }, retry: true }
	* )
	* ```
	*/ constructor(url, { headers: headers = {}, schema: schema, fetch: fetch$1, urlLengthLimit: urlLengthLimit = 8e3, retry: retry }){
        this.url = url;
        this.headers = new Headers(headers);
        this.schema = schema;
        this.fetch = fetch$1;
        this.urlLengthLimit = urlLengthLimit;
        this.retry = retry;
    }
    /**
	* Clone URL and headers to prevent shared state between operations.
	*/ cloneRequestState() {
        return {
            url: new URL(this.url.toString()),
            headers: new Headers(this.headers)
        };
    }
    /**
	* Perform a SELECT query on the table or view.
	*
	* @param columns - The columns to retrieve, separated by commas. Columns can be renamed when returned with `customName:columnName`
	*
	* @param options - Named parameters
	*
	* @param options.head - When set to `true`, `data` will not be returned.
	* Useful if you only need the count.
	*
	* @param options.count - Count algorithm to use to count rows in the table or view.
	*
	* `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
	* hood.
	*
	* `"planned"`: Approximated but fast count algorithm. Uses the Postgres
	* statistics under the hood.
	*
	* `"estimated"`: Uses exact count for low numbers and planned count for high
	* numbers.
	*
	* @remarks
	* When using `count` with `.range()` or `.limit()`, the returned `count` is the total number of rows
	* that match your filters, not the number of rows in the current page. Use this to build pagination UI.
	
	* - By default, Supabase projects return a maximum of 1,000 rows. This setting can be changed in your project's [API settings](/dashboard/project/_/settings/api). It's recommended that you keep it low to limit the payload size of accidental or malicious requests. You can use `range()` queries to paginate through your data.
	* - `select()` can be combined with [Filters](/docs/reference/javascript/using-filters)
	* - `select()` can be combined with [Modifiers](/docs/reference/javascript/using-modifiers)
	* - `apikey` is a reserved keyword if you're using the [Supabase Platform](/docs/guides/platform) and [should be avoided as a column name](https://github.com/supabase/supabase/issues/5465). *
	* @category Database
	*
	* @example Getting your data
	* ```js
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	* ```
	*
	* @exampleSql Getting your data
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Harry'),
	*   (2, 'Frodo'),
	*   (3, 'Katniss');
	* ```
	*
	* @exampleResponse Getting your data
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Harry"
	*     },
	*     {
	*       "id": 2,
	*       "name": "Frodo"
	*     },
	*     {
	*       "id": 3,
	*       "name": "Katniss"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @example Selecting specific columns
	* ```js
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select('name')
	* ```
	*
	* @exampleSql Selecting specific columns
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Frodo'),
	*   (2, 'Harry'),
	*   (3, 'Katniss');
	* ```
	*
	* @exampleResponse Selecting specific columns
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "Frodo"
	*     },
	*     {
	*       "name": "Harry"
	*     },
	*     {
	*       "name": "Katniss"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Query referenced tables
	* If your database has foreign key relationships, you can query related tables too.
	*
	* @example Query referenced tables
	* ```js
	* const { data, error } = await supabase
	*   .from('orchestral_sections')
	*   .select(`
	*     name,
	*     instruments (
	*       name
	*     )
	*   `)
	* ```
	*
	* @exampleSql Query referenced tables
	* ```sql
	* create table
	*   orchestral_sections (id int8 primary key, name text);
	* create table
	*   instruments (
	*     id int8 primary key,
	*     section_id int8 not null references orchestral_sections,
	*     name text
	*   );
	*
	* insert into
	*   orchestral_sections (id, name)
	* values
	*   (1, 'strings'),
	*   (2, 'woodwinds');
	* insert into
	*   instruments (id, section_id, name)
	* values
	*   (1, 2, 'flute'),
	*   (2, 1, 'violin');
	* ```
	*
	* @exampleResponse Query referenced tables
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "strings",
	*       "instruments": [
	*         {
	*           "name": "violin"
	*         }
	*       ]
	*     },
	*     {
	*       "name": "woodwinds",
	*       "instruments": [
	*         {
	*           "name": "flute"
	*         }
	*       ]
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Query referenced tables with spaces in their names
	* If your table name contains spaces, you must use double quotes in the `select` statement to reference the table.
	*
	* @example Query referenced tables with spaces in their names
	* ```js
	* const { data, error } = await supabase
	*   .from('orchestral sections')
	*   .select(`
	*     name,
	*     "musical instruments" (
	*       name
	*     )
	*   `)
	* ```
	*
	* @exampleSql Query referenced tables with spaces in their names
	* ```sql
	* create table
	*   "orchestral sections" (id int8 primary key, name text);
	* create table
	*   "musical instruments" (
	*     id int8 primary key,
	*     section_id int8 not null references "orchestral sections",
	*     name text
	*   );
	*
	* insert into
	*   "orchestral sections" (id, name)
	* values
	*   (1, 'strings'),
	*   (2, 'woodwinds');
	* insert into
	*   "musical instruments" (id, section_id, name)
	* values
	*   (1, 2, 'flute'),
	*   (2, 1, 'violin');
	* ```
	*
	* @exampleResponse Query referenced tables with spaces in their names
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "strings",
	*       "musical instruments": [
	*         {
	*           "name": "violin"
	*         }
	*       ]
	*     },
	*     {
	*       "name": "woodwinds",
	*       "musical instruments": [
	*         {
	*           "name": "flute"
	*         }
	*       ]
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Query referenced tables through a join table
	* If you're in a situation where your tables are **NOT** directly
	* related, but instead are joined by a _join table_, you can still use
	* the `select()` method to query the related data. The join table needs
	* to have the foreign keys as part of its composite primary key.
	*
	* @example Query referenced tables through a join table
	* ```ts
	* const { data, error } = await supabase
	*   .from('users')
	*   .select(`
	*     name,
	*     teams (
	*       name
	*     )
	*   `)
	*   
	* ```
	*
	* @exampleSql Query referenced tables through a join table
	* ```sql
	* create table
	*   users (
	*     id int8 primary key,
	*     name text
	*   );
	* create table
	*   teams (
	*     id int8 primary key,
	*     name text
	*   );
	* -- join table
	* create table
	*   users_teams (
	*     user_id int8 not null references users,
	*     team_id int8 not null references teams,
	*     -- both foreign keys must be part of a composite primary key
	*     primary key (user_id, team_id)
	*   );
	*
	* insert into
	*   users (id, name)
	* values
	*   (1, 'Kiran'),
	*   (2, 'Evan');
	* insert into
	*   teams (id, name)
	* values
	*   (1, 'Green'),
	*   (2, 'Blue');
	* insert into
	*   users_teams (user_id, team_id)
	* values
	*   (1, 1),
	*   (1, 2),
	*   (2, 2);
	* ```
	*
	* @exampleResponse Query referenced tables through a join table
	* ```json
	*   {
	*     "data": [
	*       {
	*         "name": "Kiran",
	*         "teams": [
	*           {
	*             "name": "Green"
	*           },
	*           {
	*             "name": "Blue"
	*           }
	*         ]
	*       },
	*       {
	*         "name": "Evan",
	*         "teams": [
	*           {
	*             "name": "Blue"
	*           }
	*         ]
	*       }
	*     ],
	*     "status": 200,
	*     "statusText": "OK"
	*   }
	*   
	* ```
	*
	* @exampleDescription Query the same referenced table multiple times
	* If you need to query the same referenced table twice, use the name of the
	* joined column to identify which join to use. You can also give each
	* column an alias.
	*
	* @example Query the same referenced table multiple times
	* ```ts
	* const { data, error } = await supabase
	*   .from('messages')
	*   .select(`
	*     content,
	*     from:sender_id(name),
	*     to:receiver_id(name)
	*   `)
	*
	* // To infer types, use the name of the table (in this case `users`) and
	* // the name of the foreign key constraint.
	* const { data, error } = await supabase
	*   .from('messages')
	*   .select(`
	*     content,
	*     from:users!messages_sender_id_fkey(name),
	*     to:users!messages_receiver_id_fkey(name)
	*   `)
	* ```
	*
	* @exampleSql Query the same referenced table multiple times
	* ```sql
	*  create table
	*  users (id int8 primary key, name text);
	*
	*  create table
	*    messages (
	*      sender_id int8 not null references users,
	*      receiver_id int8 not null references users,
	*      content text
	*    );
	*
	*  insert into
	*    users (id, name)
	*  values
	*    (1, 'Kiran'),
	*    (2, 'Evan');
	*
	*  insert into
	*    messages (sender_id, receiver_id, content)
	*  values
	*    (1, 2, '👋');
	*  ```
	* ```
	*
	* @exampleResponse Query the same referenced table multiple times
	* ```json
	* {
	*   "data": [
	*     {
	*       "content": "👋",
	*       "from": {
	*         "name": "Kiran"
	*       },
	*       "to": {
	*         "name": "Evan"
	*       }
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Query nested foreign tables through a join table
	* You can use the result of a joined table to gather data in
	* another foreign table. With multiple references to the same foreign
	* table you must specify the column on which to conduct the join.
	*
	* @example Query nested foreign tables through a join table
	* ```ts
	*   const { data, error } = await supabase
	*     .from('games')
	*     .select(`
	*       game_id:id,
	*       away_team:teams!games_away_team_fkey (
	*         users (
	*           id,
	*           name
	*         )
	*       )
	*     `)
	*   
	* ```
	*
	* @exampleSql Query nested foreign tables through a join table
	* ```sql
	* ```sql
	* create table
	*   users (
	*     id int8 primary key,
	*     name text
	*   );
	* create table
	*   teams (
	*     id int8 primary key,
	*     name text
	*   );
	* -- join table
	* create table
	*   users_teams (
	*     user_id int8 not null references users,
	*     team_id int8 not null references teams,
	*
	*     primary key (user_id, team_id)
	*   );
	* create table
	*   games (
	*     id int8 primary key,
	*     home_team int8 not null references teams,
	*     away_team int8 not null references teams,
	*     name text
	*   );
	*
	* insert into users (id, name)
	* values
	*   (1, 'Kiran'),
	*   (2, 'Evan');
	* insert into
	*   teams (id, name)
	* values
	*   (1, 'Green'),
	*   (2, 'Blue');
	* insert into
	*   users_teams (user_id, team_id)
	* values
	*   (1, 1),
	*   (1, 2),
	*   (2, 2);
	* insert into
	*   games (id, home_team, away_team, name)
	* values
	*   (1, 1, 2, 'Green vs Blue'),
	*   (2, 2, 1, 'Blue vs Green');
	* ```
	*
	* @exampleResponse Query nested foreign tables through a join table
	* ```json
	*   {
	*     "data": [
	*       {
	*         "game_id": 1,
	*         "away_team": {
	*           "users": [
	*             {
	*               "id": 1,
	*               "name": "Kiran"
	*             },
	*             {
	*               "id": 2,
	*               "name": "Evan"
	*             }
	*           ]
	*         }
	*       },
	*       {
	*         "game_id": 2,
	*         "away_team": {
	*           "users": [
	*             {
	*               "id": 1,
	*               "name": "Kiran"
	*             }
	*           ]
	*         }
	*       }
	*     ],
	*     "status": 200,
	*     "statusText": "OK"
	*   }
	*   
	* ```
	*
	* @exampleDescription Filtering through referenced tables
	* If the filter on a referenced table's column is not satisfied, the referenced
	* table returns `[]` or `null` but the parent table is not filtered out.
	* If you want to filter out the parent table rows, use the `!inner` hint
	*
	* @example Filtering through referenced tables
	* ```ts
	* const { data, error } = await supabase
	*   .from('instruments')
	*   .select('name, orchestral_sections(*)')
	*   .eq('orchestral_sections.name', 'percussion')
	* ```
	*
	* @exampleSql Filtering through referenced tables
	* ```sql
	* create table
	*   orchestral_sections (id int8 primary key, name text);
	* create table
	*   instruments (
	*     id int8 primary key,
	*     section_id int8 not null references orchestral_sections,
	*     name text
	*   );
	*
	* insert into
	*   orchestral_sections (id, name)
	* values
	*   (1, 'strings'),
	*   (2, 'woodwinds');
	* insert into
	*   instruments (id, section_id, name)
	* values
	*   (1, 2, 'flute'),
	*   (2, 1, 'violin');
	* ```
	*
	* @exampleResponse Filtering through referenced tables
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "flute",
	*       "orchestral_sections": null
	*     },
	*     {
	*       "name": "violin",
	*       "orchestral_sections": null
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Querying referenced table with count
	* You can get the number of rows in a related table by using the
	* **count** property.
	*
	* @example Querying referenced table with count
	* ```ts
	* const { data, error } = await supabase
	*   .from('orchestral_sections')
	*   .select(`*, instruments(count)`)
	* ```
	*
	* @exampleSql Querying referenced table with count
	* ```sql
	* create table orchestral_sections (
	*   "id" "uuid" primary key default "extensions"."uuid_generate_v4"() not null,
	*   "name" text
	* );
	*
	* create table characters (
	*   "id" "uuid" primary key default "extensions"."uuid_generate_v4"() not null,
	*   "name" text,
	*   "section_id" "uuid" references public.orchestral_sections on delete cascade
	* );
	*
	* with section as (
	*   insert into orchestral_sections (name)
	*   values ('strings') returning id
	* )
	* insert into instruments (name, section_id) values
	* ('violin', (select id from section)),
	* ('viola', (select id from section)),
	* ('cello', (select id from section)),
	* ('double bass', (select id from section));
	* ```
	*
	* @exampleResponse Querying referenced table with count
	* ```json
	* [
	*   {
	*     "id": "693694e7-d993-4360-a6d7-6294e325d9b6",
	*     "name": "strings",
	*     "instruments": [
	*       {
	*         "count": 4
	*       }
	*     ]
	*   }
	* ]
	* ```
	*
	* @exampleDescription Querying with count option
	* You can get the number of rows by using the
	* [count](/docs/reference/javascript/select#parameters) option.
	*
	* @example Querying with count option
	* ```ts
	* const { count, error } = await supabase
	*   .from('characters')
	*   .select('*', { count: 'exact', head: true })
	* ```
	*
	* @exampleSql Querying with count option
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse Querying with count option
	* ```json
	* {
	*   "count": 3,
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Querying JSON data
	* You can select and filter data inside of
	* [JSON](/docs/guides/database/json) columns. Postgres offers some
	* [operators](/docs/guides/database/json#query-the-jsonb-data) for
	* querying JSON data.
	*
	* @example Querying JSON data
	* ```ts
	* const { data, error } = await supabase
	*   .from('users')
	*   .select(`
	*     id, name,
	*     address->city
	*   `)
	* ```
	*
	* @exampleSql Querying JSON data
	* ```sql
	* create table
	*   users (
	*     id int8 primary key,
	*     name text,
	*     address jsonb
	*   );
	*
	* insert into
	*   users (id, name, address)
	* values
	*   (1, 'Frodo', '{"city":"Hobbiton"}');
	* ```
	*
	* @exampleResponse Querying JSON data
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Frodo",
	*       "city": "Hobbiton"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Querying referenced table with inner join
	* If you don't want to return the referenced table contents, you can leave the parenthesis empty.
	* Like `.select('name, orchestral_sections!inner()')`.
	*
	* @example Querying referenced table with inner join
	* ```ts
	* const { data, error } = await supabase
	*   .from('instruments')
	*   .select('name, orchestral_sections!inner(name)')
	*   .eq('orchestral_sections.name', 'woodwinds')
	*   .limit(1)
	* ```
	*
	* @exampleSql Querying referenced table with inner join
	* ```sql
	* create table orchestral_sections (
	*   "id" "uuid" primary key default "extensions"."uuid_generate_v4"() not null,
	*   "name" text
	* );
	*
	* create table instruments (
	*   "id" "uuid" primary key default "extensions"."uuid_generate_v4"() not null,
	*   "name" text,
	*   "section_id" "uuid" references public.orchestral_sections on delete cascade
	* );
	*
	* with section as (
	*   insert into orchestral_sections (name)
	*   values ('woodwinds') returning id
	* )
	* insert into instruments (name, section_id) values
	* ('flute', (select id from section)),
	* ('clarinet', (select id from section)),
	* ('bassoon', (select id from section)),
	* ('piccolo', (select id from section));
	* ```
	*
	* @exampleResponse Querying referenced table with inner join
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "flute",
	*       "orchestral_sections": {"name": "woodwinds"}
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Switching schemas per query
	* In addition to setting the schema during initialization, you can also switch schemas on a per-query basis.
	* Make sure you've set up your [database privileges and API settings](/docs/guides/api/using-custom-schemas).
	*
	* @example Switching schemas per query
	* ```ts
	* const { data, error } = await supabase
	*   .schema('myschema')
	*   .from('mytable')
	*   .select()
	* ```
	*
	* @exampleSql Switching schemas per query
	* ```sql
	* create schema myschema;
	*
	* create table myschema.mytable (
	*   id uuid primary key default gen_random_uuid(),
	*   data text
	* );
	*
	* insert into myschema.mytable (data) values ('mydata');
	* ```
	*
	* @exampleResponse Switching schemas per query
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": "4162e008-27b0-4c0f-82dc-ccaeee9a624d",
	*       "data": "mydata"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ select(columns, options) {
        const { head: head = false, count: count } = options !== null && options !== void 0 ? options : {};
        const method = head ? "HEAD" : "GET";
        let quoted = false;
        const cleanedColumns = (columns !== null && columns !== void 0 ? columns : "*").split("").map((c)=>{
            if (/\s/.test(c) && !quoted) return "";
            if (c === "\"") quoted = !quoted;
            return c;
        }).join("");
        const { url: url, headers: headers } = this.cloneRequestState();
        url.searchParams.set("select", cleanedColumns);
        if (count) headers.append("Prefer", `count=${count}`);
        return new $cfc0ca97c19fecec$export$3158317c13bdc93a({
            method: method,
            url: url,
            headers: headers,
            schema: this.schema,
            fetch: this.fetch,
            urlLengthLimit: this.urlLengthLimit,
            retry: this.retry
        });
    }
    /**
	* Perform an INSERT into the table or view.
	*
	* By default, inserted rows are not returned. To return it, chain the call
	* with `.select()`.
	*
	* @param values - The values to insert. Pass an object to insert a single row
	* or an array to insert multiple rows.
	*
	* @param options - Named parameters
	*
	* @param options.count - Count algorithm to use to count inserted rows.
	*
	* `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
	* hood.
	*
	* `"planned"`: Approximated but fast count algorithm. Uses the Postgres
	* statistics under the hood.
	*
	* `"estimated"`: Uses exact count for low numbers and planned count for high
	* numbers.
	*
	* @param options.defaultToNull - Make missing fields default to `null`.
	* Otherwise, use the default value for the column. Only applies for bulk
	* inserts.
	*
	* @category Database
	*
	* @example Create a record
	* ```ts
	* const { error } = await supabase
	*   .from('countries')
	*   .insert({ id: 1, name: 'Mordor' })
	* ```
	*
	* @exampleSql Create a record
	* ```sql
	* create table
	*   countries (id int8 primary key, name text);
	* ```
	*
	* @exampleResponse Create a record
	* ```json
	* {
	*   "status": 201,
	*   "statusText": "Created"
	* }
	* ```
	*
	* @example Create a record and return it
	* ```ts
	* const { data, error } = await supabase
	*   .from('countries')
	*   .insert({ id: 1, name: 'Mordor' })
	*   .select()
	* ```
	*
	* @exampleSql Create a record and return it
	* ```sql
	* create table
	*   countries (id int8 primary key, name text);
	* ```
	*
	* @exampleResponse Create a record and return it
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Mordor"
	*     }
	*   ],
	*   "status": 201,
	*   "statusText": "Created"
	* }
	* ```
	*
	* @exampleDescription Bulk create
	* A bulk create operation is handled in a single transaction.
	* If any of the inserts fail, none of the rows are inserted.
	*
	* @example Bulk create
	* ```ts
	* const { error } = await supabase
	*   .from('countries')
	*   .insert([
	*     { id: 1, name: 'Mordor' },
	*     { id: 1, name: 'The Shire' },
	*   ])
	* ```
	*
	* @exampleSql Bulk create
	* ```sql
	* create table
	*   countries (id int8 primary key, name text);
	* ```
	*
	* @exampleResponse Bulk create
	* ```json
	* {
	*   "error": {
	*     "code": "23505",
	*     "details": "Key (id)=(1) already exists.",
	*     "hint": null,
	*     "message": "duplicate key value violates unique constraint \"countries_pkey\""
	*   },
	*   "status": 409,
	*   "statusText": "Conflict"
	* }
	* ```
	*/ insert(values, { count: count, defaultToNull: defaultToNull = true } = {}) {
        var _this$fetch;
        const method = "POST";
        const { url: url, headers: headers } = this.cloneRequestState();
        if (count) headers.append("Prefer", `count=${count}`);
        if (!defaultToNull) headers.append("Prefer", `missing=default`);
        if (Array.isArray(values)) {
            const columns = values.reduce((acc, x)=>acc.concat(Object.keys(x)), []);
            if (columns.length > 0) {
                const uniqueColumns = [
                    ...new Set(columns)
                ].map((column)=>`"${column}"`);
                url.searchParams.set("columns", uniqueColumns.join(","));
            }
        }
        return new $cfc0ca97c19fecec$export$3158317c13bdc93a({
            method: method,
            url: url,
            headers: headers,
            schema: this.schema,
            body: values,
            fetch: (_this$fetch = this.fetch) !== null && _this$fetch !== void 0 ? _this$fetch : fetch,
            urlLengthLimit: this.urlLengthLimit,
            retry: this.retry
        });
    }
    /**
	* Perform an UPSERT on the table or view. Depending on the column(s) passed
	* to `onConflict`, `.upsert()` allows you to perform the equivalent of
	* `.insert()` if a row with the corresponding `onConflict` columns doesn't
	* exist, or if it does exist, perform an alternative action depending on
	* `ignoreDuplicates`.
	*
	* By default, upserted rows are not returned. To return it, chain the call
	* with `.select()`.
	*
	* @param values - The values to upsert with. Pass an object to upsert a
	* single row or an array to upsert multiple rows.
	*
	* @param options - Named parameters
	*
	* @param options.onConflict - Comma-separated UNIQUE column(s) to specify how
	* duplicate rows are determined. Two rows are duplicates if all the
	* `onConflict` columns are equal.
	*
	* @param options.ignoreDuplicates - If `true`, duplicate rows are ignored. If
	* `false`, duplicate rows are merged with existing rows.
	*
	* @param options.count - Count algorithm to use to count upserted rows.
	*
	* `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
	* hood.
	*
	* `"planned"`: Approximated but fast count algorithm. Uses the Postgres
	* statistics under the hood.
	*
	* `"estimated"`: Uses exact count for low numbers and planned count for high
	* numbers.
	*
	* @param options.defaultToNull - Make missing fields default to `null`.
	* Otherwise, use the default value for the column. This only applies when
	* inserting new rows, not when merging with existing rows under
	* `ignoreDuplicates: false`. This also only applies when doing bulk upserts.
	*
	* @example Upsert a single row using a unique key
	* ```ts
	* // Upserting a single row, overwriting based on the 'username' unique column
	* const { data, error } = await supabase
	*   .from('users')
	*   .upsert({ username: 'supabot' }, { onConflict: 'username' })
	*
	* // Example response:
	* // {
	* //   data: [
	* //     { id: 4, message: 'bar', username: 'supabot' }
	* //   ],
	* //   error: null
	* // }
	* ```
	*
	* @example Upsert with conflict resolution and exact row counting
	* ```ts
	* // Upserting and returning exact count
	* const { data, error, count } = await supabase
	*   .from('users')
	*   .upsert(
	*     {
	*       id: 3,
	*       message: 'foo',
	*       username: 'supabot'
	*     },
	*     {
	*       onConflict: 'username',
	*       count: 'exact'
	*     }
	*   )
	*
	* // Example response:
	* // {
	* //   data: [
	* //     {
	* //       id: 42,
	* //       handle: "saoirse",
	* //       display_name: "Saoirse"
	* //     }
	* //   ],
	* //   count: 1,
	* //   error: null
	* // }
	* ```
	*
	* @category Database
	*
	* @remarks
	* - Primary keys must be included in `values` to use upsert.
	*
	* @example Upsert your data
	* ```ts
	* const { data, error } = await supabase
	*   .from('instruments')
	*   .upsert({ id: 1, name: 'piano' })
	*   .select()
	* ```
	*
	* @exampleSql Upsert your data
	* ```sql
	* create table
	*   instruments (id int8 primary key, name text);
	*
	* insert into
	*   instruments (id, name)
	* values
	*   (1, 'harpsichord');
	* ```
	*
	* @exampleResponse Upsert your data
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "piano"
	*     }
	*   ],
	*   "status": 201,
	*   "statusText": "Created"
	* }
	* ```
	*
	* @example Bulk Upsert your data
	* ```ts
	* const { data, error } = await supabase
	*   .from('instruments')
	*   .upsert([
	*     { id: 1, name: 'piano' },
	*     { id: 2, name: 'harp' },
	*   ])
	*   .select()
	* ```
	*
	* @exampleSql Bulk Upsert your data
	* ```sql
	* create table
	*   instruments (id int8 primary key, name text);
	*
	* insert into
	*   instruments (id, name)
	* values
	*   (1, 'harpsichord');
	* ```
	*
	* @exampleResponse Bulk Upsert your data
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "piano"
	*     },
	*     {
	*       "id": 2,
	*       "name": "harp"
	*     }
	*   ],
	*   "status": 201,
	*   "statusText": "Created"
	* }
	* ```
	*
	* @exampleDescription Upserting into tables with constraints
	* In the following query, `upsert()` implicitly uses the `id`
	* (primary key) column to determine conflicts. If there is no existing
	* row with the same `id`, `upsert()` inserts a new row, which
	* will fail in this case as there is already a row with `handle` `"saoirse"`.
	* Using the `onConflict` option, you can instruct `upsert()` to use
	* another column with a unique constraint to determine conflicts.
	*
	* @example Upserting into tables with constraints
	* ```ts
	* const { data, error } = await supabase
	*   .from('users')
	*   .upsert({ id: 42, handle: 'saoirse', display_name: 'Saoirse' })
	*   .select()
	* ```
	*
	* @exampleSql Upserting into tables with constraints
	* ```sql
	* create table
	*   users (
	*     id int8 generated by default as identity primary key,
	*     handle text not null unique,
	*     display_name text
	*   );
	*
	* insert into
	*   users (id, handle, display_name)
	* values
	*   (1, 'saoirse', null);
	* ```
	*
	* @exampleResponse Upserting into tables with constraints
	* ```json
	* {
	*   "error": {
	*     "code": "23505",
	*     "details": "Key (handle)=(saoirse) already exists.",
	*     "hint": null,
	*     "message": "duplicate key value violates unique constraint \"users_handle_key\""
	*   },
	*   "status": 409,
	*   "statusText": "Conflict"
	* }
	* ```
	*/ upsert(values, { onConflict: onConflict, ignoreDuplicates: ignoreDuplicates = false, count: count, defaultToNull: defaultToNull = true } = {}) {
        var _this$fetch2;
        const method = "POST";
        const { url: url, headers: headers } = this.cloneRequestState();
        headers.append("Prefer", `resolution=${ignoreDuplicates ? "ignore" : "merge"}-duplicates`);
        if (onConflict !== void 0) url.searchParams.set("on_conflict", onConflict);
        if (count) headers.append("Prefer", `count=${count}`);
        if (!defaultToNull) headers.append("Prefer", "missing=default");
        if (Array.isArray(values)) {
            const columns = values.reduce((acc, x)=>acc.concat(Object.keys(x)), []);
            if (columns.length > 0) {
                const uniqueColumns = [
                    ...new Set(columns)
                ].map((column)=>`"${column}"`);
                url.searchParams.set("columns", uniqueColumns.join(","));
            }
        }
        return new $cfc0ca97c19fecec$export$3158317c13bdc93a({
            method: method,
            url: url,
            headers: headers,
            schema: this.schema,
            body: values,
            fetch: (_this$fetch2 = this.fetch) !== null && _this$fetch2 !== void 0 ? _this$fetch2 : fetch,
            urlLengthLimit: this.urlLengthLimit,
            retry: this.retry
        });
    }
    /**
	* Perform an UPDATE on the table or view.
	*
	* By default, updated rows are not returned. To return it, chain the call
	* with `.select()` after filters.
	*
	* @param values - The values to update with
	*
	* @param options - Named parameters
	*
	* @param options.count - Count algorithm to use to count updated rows.
	*
	* `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
	* hood.
	*
	* `"planned"`: Approximated but fast count algorithm. Uses the Postgres
	* statistics under the hood.
	*
	* `"estimated"`: Uses exact count for low numbers and planned count for high
	* numbers.
	*
	* @category Database
	*
	* @remarks
	* - `update()` should always be combined with [Filters](/docs/reference/javascript/using-filters) to target the item(s) you wish to update.
	*
	* @example Updating your data
	* ```ts
	* const { error } = await supabase
	*   .from('instruments')
	*   .update({ name: 'piano' })
	*   .eq('id', 1)
	* ```
	*
	* @exampleSql Updating your data
	* ```sql
	* create table
	*   instruments (id int8 primary key, name text);
	*
	* insert into
	*   instruments (id, name)
	* values
	*   (1, 'harpsichord');
	* ```
	*
	* @exampleResponse Updating your data
	* ```json
	* {
	*   "status": 204,
	*   "statusText": "No Content"
	* }
	* ```
	*
	* @example Update a record and return it
	* ```ts
	* const { data, error } = await supabase
	*   .from('instruments')
	*   .update({ name: 'piano' })
	*   .eq('id', 1)
	*   .select()
	* ```
	*
	* @exampleSql Update a record and return it
	* ```sql
	* create table
	*   instruments (id int8 primary key, name text);
	*
	* insert into
	*   instruments (id, name)
	* values
	*   (1, 'harpsichord');
	* ```
	*
	* @exampleResponse Update a record and return it
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "piano"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Updating JSON data
	* Postgres offers some
	* [operators](/docs/guides/database/json#query-the-jsonb-data) for
	* working with JSON data. Currently, it is only possible to update the entire JSON document.
	*
	* @example Updating JSON data
	* ```ts
	* const { data, error } = await supabase
	*   .from('users')
	*   .update({
	*     address: {
	*       street: 'Melrose Place',
	*       postcode: 90210
	*     }
	*   })
	*   .eq('address->postcode', 90210)
	*   .select()
	* ```
	*
	* @exampleSql Updating JSON data
	* ```sql
	* create table
	*   users (
	*     id int8 primary key,
	*     name text,
	*     address jsonb
	*   );
	*
	* insert into
	*   users (id, name, address)
	* values
	*   (1, 'Michael', '{ "postcode": 90210 }');
	* ```
	*
	* @exampleResponse Updating JSON data
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Michael",
	*       "address": {
	*         "street": "Melrose Place",
	*         "postcode": 90210
	*       }
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ update(values, { count: count } = {}) {
        var _this$fetch3;
        const method = "PATCH";
        const { url: url, headers: headers } = this.cloneRequestState();
        if (count) headers.append("Prefer", `count=${count}`);
        return new $cfc0ca97c19fecec$export$3158317c13bdc93a({
            method: method,
            url: url,
            headers: headers,
            schema: this.schema,
            body: values,
            fetch: (_this$fetch3 = this.fetch) !== null && _this$fetch3 !== void 0 ? _this$fetch3 : fetch,
            urlLengthLimit: this.urlLengthLimit,
            retry: this.retry
        });
    }
    /**
	* Perform a DELETE on the table or view.
	*
	* By default, deleted rows are not returned. To return it, chain the call
	* with `.select()` after filters.
	*
	* @param options - Named parameters
	*
	* @param options.count - Count algorithm to use to count deleted rows.
	*
	* `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
	* hood.
	*
	* `"planned"`: Approximated but fast count algorithm. Uses the Postgres
	* statistics under the hood.
	*
	* `"estimated"`: Uses exact count for low numbers and planned count for high
	* numbers.
	*
	* @category Database
	*
	* @remarks
	* - `delete()` should always be combined with [filters](/docs/reference/javascript/using-filters) to target the item(s) you wish to delete.
	* - If you use `delete()` with filters and you have
	*   [RLS](/docs/learn/auth-deep-dive/auth-row-level-security) enabled, only
	*   rows visible through `SELECT` policies are deleted. Note that by default
	*   no rows are visible, so you need at least one `SELECT`/`ALL` policy that
	*   makes the rows visible.
	* - When using `delete().in()`, specify an array of values to target multiple rows with a single query. This is particularly useful for batch deleting entries that share common criteria, such as deleting users by their IDs. Ensure that the array you provide accurately represents all records you intend to delete to avoid unintended data removal.
	*
	* @example Delete a single record
	* ```ts
	* const response = await supabase
	*   .from('countries')
	*   .delete()
	*   .eq('id', 1)
	* ```
	*
	* @exampleSql Delete a single record
	* ```sql
	* create table
	*   countries (id int8 primary key, name text);
	*
	* insert into
	*   countries (id, name)
	* values
	*   (1, 'Mordor');
	* ```
	*
	* @exampleResponse Delete a single record
	* ```json
	* {
	*   "status": 204,
	*   "statusText": "No Content"
	* }
	* ```
	*
	* @example Delete a record and return it
	* ```ts
	* const { data, error } = await supabase
	*   .from('countries')
	*   .delete()
	*   .eq('id', 1)
	*   .select()
	* ```
	*
	* @exampleSql Delete a record and return it
	* ```sql
	* create table
	*   countries (id int8 primary key, name text);
	*
	* insert into
	*   countries (id, name)
	* values
	*   (1, 'Mordor');
	* ```
	*
	* @exampleResponse Delete a record and return it
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Mordor"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @example Delete multiple records
	* ```ts
	* const response = await supabase
	*   .from('countries')
	*   .delete()
	*   .in('id', [1, 2, 3])
	* ```
	*
	* @exampleSql Delete multiple records
	* ```sql
	* create table
	*   countries (id int8 primary key, name text);
	*
	* insert into
	*   countries (id, name)
	* values
	*   (1, 'Rohan'), (2, 'The Shire'), (3, 'Mordor');
	* ```
	*
	* @exampleResponse Delete multiple records
	* ```json
	* {
	*   "status": 204,
	*   "statusText": "No Content"
	* }
	* ```
	*/ delete({ count: count } = {}) {
        var _this$fetch4;
        const method = "DELETE";
        const { url: url, headers: headers } = this.cloneRequestState();
        if (count) headers.append("Prefer", `count=${count}`);
        return new $cfc0ca97c19fecec$export$3158317c13bdc93a({
            method: method,
            url: url,
            headers: headers,
            schema: this.schema,
            fetch: (_this$fetch4 = this.fetch) !== null && _this$fetch4 !== void 0 ? _this$fetch4 : fetch,
            urlLengthLimit: this.urlLengthLimit,
            retry: this.retry
        });
    }
};
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/typeof.js
function $cfc0ca97c19fecec$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $cfc0ca97c19fecec$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o$1) {
        return typeof o$1;
    } : function(o$1) {
        return o$1 && "function" == typeof Symbol && o$1.constructor === Symbol && o$1 !== Symbol.prototype ? "symbol" : typeof o$1;
    }, $cfc0ca97c19fecec$var$_typeof(o);
}
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/toPrimitive.js
function $cfc0ca97c19fecec$var$toPrimitive(t, r) {
    if ("object" != $cfc0ca97c19fecec$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $cfc0ca97c19fecec$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/toPropertyKey.js
function $cfc0ca97c19fecec$var$toPropertyKey(t) {
    var i = $cfc0ca97c19fecec$var$toPrimitive(t, "string");
    return "symbol" == $cfc0ca97c19fecec$var$_typeof(i) ? i : i + "";
}
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/defineProperty.js
function $cfc0ca97c19fecec$var$_defineProperty(e, r, t) {
    return (r = $cfc0ca97c19fecec$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/objectSpread2.js
function $cfc0ca97c19fecec$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r$1) {
            return Object.getOwnPropertyDescriptor(e, r$1).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cfc0ca97c19fecec$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cfc0ca97c19fecec$var$ownKeys(Object(t), !0).forEach(function(r$1) {
            $cfc0ca97c19fecec$var$_defineProperty(e, r$1, t[r$1]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cfc0ca97c19fecec$var$ownKeys(Object(t)).forEach(function(r$1) {
            Object.defineProperty(e, r$1, Object.getOwnPropertyDescriptor(t, r$1));
        });
    }
    return e;
}
//#endregion
//#region src/PostgrestClient.ts
/**
* PostgREST client.
*
* @typeParam Database - Types for the schema from the [type
* generator](https://supabase.com/docs/reference/javascript/next/typescript-support)
*
* @typeParam SchemaName - Postgres schema to switch to. Must be a string
* literal, the same one passed to the constructor. If the schema is not
* `"public"`, this must be supplied manually.
*/ var $cfc0ca97c19fecec$export$796f32e2ee984aaa = class PostgrestClient {
    /**
	* Creates a PostgREST client.
	*
	* @param url - URL of the PostgREST endpoint
	* @param options - Named parameters
	* @param options.headers - Custom headers
	* @param options.schema - Postgres schema to switch to
	* @param options.fetch - Custom fetch
	* @param options.timeout - Optional timeout in milliseconds for all requests. When set, requests will automatically abort after this duration to prevent indefinite hangs.
	* @param options.urlLengthLimit - Maximum URL length in characters before warnings/errors are triggered. Defaults to 8000.
	* @param options.retry - Enable or disable automatic retries for transient errors.
	*   When enabled, idempotent requests (GET, HEAD, OPTIONS) that fail with network
	*   errors or HTTP 503/520 responses will be automatically retried up to 3 times
	*   with exponential backoff (1s, 2s, 4s). Defaults to `true`.
	* @example Using supabase-js (recommended)
	* ```ts
	* import { createClient } from '@supabase/supabase-js'
	*
	* const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
	* const { data, error } = await supabase.from('profiles').select('*')
	* ```
	*
	* @category Database
	*
	* @remarks
	* - A `timeout` option (in milliseconds) can be set to automatically abort requests that take too long.
	* - A `urlLengthLimit` option (default: 8000) can be set to control when URL length warnings are included in error messages for aborted requests.
	*
	* @example Standalone import for bundle-sensitive environments
	* ```ts
	* import { PostgrestClient } from '@supabase/postgrest-js'
	*
	* const postgrest = new PostgrestClient('https://xyzcompany.supabase.co/rest/v1', {
	*   headers: { apikey: 'your-publishable-key' },
	*   schema: 'public',
	*   timeout: 30000, // 30 second timeout
	* })
	* ```
	*/ constructor(url, { headers: headers = {}, schema: schema, fetch: fetch$1, timeout: timeout, urlLengthLimit: urlLengthLimit = 8e3, retry: retry } = {}){
        this.url = url;
        this.headers = new Headers(headers);
        this.schemaName = schema;
        this.urlLengthLimit = urlLengthLimit;
        const originalFetch = fetch$1 !== null && fetch$1 !== void 0 ? fetch$1 : globalThis.fetch;
        if (timeout !== void 0 && timeout > 0) this.fetch = (input, init)=>{
            const controller = new AbortController();
            const timeoutId = setTimeout(()=>controller.abort(), timeout);
            const existingSignal = init === null || init === void 0 ? void 0 : init.signal;
            if (existingSignal) {
                if (existingSignal.aborted) {
                    clearTimeout(timeoutId);
                    return originalFetch(input, init);
                }
                const abortHandler = ()=>{
                    clearTimeout(timeoutId);
                    controller.abort();
                };
                existingSignal.addEventListener("abort", abortHandler, {
                    once: true
                });
                return originalFetch(input, $cfc0ca97c19fecec$var$_objectSpread2($cfc0ca97c19fecec$var$_objectSpread2({}, init), {}, {
                    signal: controller.signal
                })).finally(()=>{
                    clearTimeout(timeoutId);
                    existingSignal.removeEventListener("abort", abortHandler);
                });
            }
            return originalFetch(input, $cfc0ca97c19fecec$var$_objectSpread2($cfc0ca97c19fecec$var$_objectSpread2({}, init), {}, {
                signal: controller.signal
            })).finally(()=>clearTimeout(timeoutId));
        };
        else this.fetch = originalFetch;
        this.retry = retry;
    }
    /**
	* Perform a query on a table or a view.
	*
	* @param relation - The table or view name to query
	*
	* @category Database
	*/ from(relation) {
        if (!relation || typeof relation !== "string" || relation.trim() === "") throw new Error("Invalid relation name: relation must be a non-empty string.");
        return new $cfc0ca97c19fecec$export$a81993b50ca081ad(new URL(`${this.url}/${relation}`), {
            headers: new Headers(this.headers),
            schema: this.schemaName,
            fetch: this.fetch,
            urlLengthLimit: this.urlLengthLimit,
            retry: this.retry
        });
    }
    /**
	* Select a schema to query or perform an function (rpc) call.
	*
	* The schema needs to be on the list of exposed schemas inside Supabase.
	*
	* @param schema - The schema to query
	*
	* @category Database
	*/ schema(schema) {
        return new PostgrestClient(this.url, {
            headers: this.headers,
            schema: schema,
            fetch: this.fetch,
            urlLengthLimit: this.urlLengthLimit,
            retry: this.retry
        });
    }
    /**
	* Perform a function call.
	*
	* @param fn - The function name to call
	* @param args - The arguments to pass to the function call
	* @param options - Named parameters
	* @param options.head - When set to `true`, `data` will not be returned.
	* Useful if you only need the count.
	* @param options.get - When set to `true`, the function will be called with
	* read-only access mode.
	* @param options.count - Count algorithm to use to count rows returned by the
	* function. Only applicable for [set-returning
	* functions](https://www.postgresql.org/docs/current/functions-srf.html).
	*
	* `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
	* hood.
	*
	* `"planned"`: Approximated but fast count algorithm. Uses the Postgres
	* statistics under the hood.
	*
	* `"estimated"`: Uses exact count for low numbers and planned count for high
	* numbers.
	*
	* @example
	* ```ts
	* // For cross-schema functions where type inference fails, use overrideTypes:
	* const { data } = await supabase
	*   .schema('schema_b')
	*   .rpc('function_a', {})
	*   .overrideTypes<{ id: string; user_id: string }[]>()
	* ```
	*
	* @category Database
	*
	* @example Call a Postgres function without arguments
	* ```ts
	* const { data, error } = await supabase.rpc('hello_world')
	* ```
	*
	* @exampleSql Call a Postgres function without arguments
	* ```sql
	* create function hello_world() returns text as $$
	*   select 'Hello world';
	* $$ language sql;
	* ```
	*
	* @exampleResponse Call a Postgres function without arguments
	* ```json
	* {
	*   "data": "Hello world",
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @example Call a Postgres function with arguments
	* ```ts
	* const { data, error } = await supabase.rpc('echo', { say: '👋' })
	* ```
	*
	* @exampleSql Call a Postgres function with arguments
	* ```sql
	* create function echo(say text) returns text as $$
	*   select say;
	* $$ language sql;
	* ```
	*
	* @exampleResponse Call a Postgres function with arguments
	* ```json
	*   {
	*     "data": "👋",
	*     "status": 200,
	*     "statusText": "OK"
	*   }
	*
	* ```
	*
	* @exampleDescription Bulk processing
	* You can process large payloads by passing in an array as an argument.
	*
	* @example Bulk processing
	* ```ts
	* const { data, error } = await supabase.rpc('add_one_each', { arr: [1, 2, 3] })
	* ```
	*
	* @exampleSql Bulk processing
	* ```sql
	* create function add_one_each(arr int[]) returns int[] as $$
	*   select array_agg(n + 1) from unnest(arr) as n;
	* $$ language sql;
	* ```
	*
	* @exampleResponse Bulk processing
	* ```json
	* {
	*   "data": [
	*     2,
	*     3,
	*     4
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Call a Postgres function with filters
	* Postgres functions that return tables can also be combined with [Filters](/docs/reference/javascript/using-filters) and [Modifiers](/docs/reference/javascript/using-modifiers).
	*
	* @example Call a Postgres function with filters
	* ```ts
	* const { data, error } = await supabase
	*   .rpc('list_stored_countries')
	*   .eq('id', 1)
	*   .single()
	* ```
	*
	* @exampleSql Call a Postgres function with filters
	* ```sql
	* create table
	*   countries (id int8 primary key, name text);
	*
	* insert into
	*   countries (id, name)
	* values
	*   (1, 'Rohan'),
	*   (2, 'The Shire');
	*
	* create function list_stored_countries() returns setof countries as $$
	*   select * from countries;
	* $$ language sql;
	* ```
	*
	* @exampleResponse Call a Postgres function with filters
	* ```json
	* {
	*   "data": {
	*     "id": 1,
	*     "name": "Rohan"
	*   },
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @example Call a read-only Postgres function
	* ```ts
	* const { data, error } = await supabase.rpc('hello_world', undefined, { get: true })
	* ```
	*
	* @exampleSql Call a read-only Postgres function
	* ```sql
	* create function hello_world() returns text as $$
	*   select 'Hello world';
	* $$ language sql;
	* ```
	*
	* @exampleResponse Call a read-only Postgres function
	* ```json
	* {
	*   "data": "Hello world",
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ rpc(fn, args = {}, { head: head = false, get: get = false, count: count } = {}) {
        var _this$fetch;
        let method;
        const url = new URL(`${this.url}/rpc/${fn}`);
        let body;
        const _isObject = (v)=>v !== null && typeof v === "object" && (!Array.isArray(v) || v.some(_isObject));
        const _hasObjectArg = head && Object.values(args).some(_isObject);
        if (_hasObjectArg) {
            method = "POST";
            body = args;
        } else if (head || get) {
            method = head ? "HEAD" : "GET";
            Object.entries(args).filter(([_, value])=>value !== void 0).map(([name, value])=>[
                    name,
                    Array.isArray(value) ? `{${value.join(",")}}` : `${value}`
                ]).forEach(([name, value])=>{
                url.searchParams.append(name, value);
            });
        } else {
            method = "POST";
            body = args;
        }
        const headers = new Headers(this.headers);
        if (_hasObjectArg) headers.set("Prefer", count ? `count=${count},return=minimal` : "return=minimal");
        else if (count) headers.set("Prefer", `count=${count}`);
        return new $cfc0ca97c19fecec$export$3158317c13bdc93a({
            method: method,
            url: url,
            headers: headers,
            schema: this.schemaName,
            body: body,
            fetch: (_this$fetch = this.fetch) !== null && _this$fetch !== void 0 ? _this$fetch : fetch,
            urlLengthLimit: this.urlLengthLimit,
            retry: this.retry
        });
    }
};
//#endregion
//#region src/index.ts
var $cfc0ca97c19fecec$export$2e2bcd8739ae039 = {
    PostgrestClient: $cfc0ca97c19fecec$export$796f32e2ee984aaa,
    PostgrestQueryBuilder: $cfc0ca97c19fecec$export$a81993b50ca081ad,
    PostgrestFilterBuilder: $cfc0ca97c19fecec$export$3158317c13bdc93a,
    PostgrestTransformBuilder: $cfc0ca97c19fecec$export$7b4361bb87e3030c,
    PostgrestBuilder: $cfc0ca97c19fecec$export$3106e21688a06353,
    PostgrestError: $cfc0ca97c19fecec$export$445b7e3a323f992f
};

});

parcelRegister("izHZ4", function(module, exports) {

$parcel$export(module.exports, "RealtimeClient", () => (parcelRequire("eWiay")).default);

var $eWiay = parcelRequire("eWiay");

var $IhlL5 = parcelRequire("IhlL5");

var $6zp63 = parcelRequire("6zp63");

var $hnThW = parcelRequire("hnThW");

});
parcelRegister("eWiay", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae049384a7d1c7c8$export$2e2bcd8739ae039);

var $hnThW = parcelRequire("hnThW");

var $5gqEk = parcelRequire("5gqEk");

var $8VIf2 = parcelRequire("8VIf2");

var $5po7o = parcelRequire("5po7o");

var $IhlL5 = parcelRequire("IhlL5");

var $iCjex = parcelRequire("iCjex");
// Connection-related constants
const $ae049384a7d1c7c8$var$CONNECTION_TIMEOUTS = {
    HEARTBEAT_INTERVAL: 25000,
    RECONNECT_DELAY: 10,
    HEARTBEAT_TIMEOUT_FALLBACK: 100
};
const $ae049384a7d1c7c8$var$RECONNECT_INTERVALS = [
    1000,
    2000,
    5000,
    10000
];
const $ae049384a7d1c7c8$var$DEFAULT_RECONNECT_FALLBACK = 10000;
const $ae049384a7d1c7c8$var$WORKER_SCRIPT = `
  addEventListener("message", (e) => {
    if (e.data.event === "start") {
      setInterval(() => postMessage({ event: "keepAlive" }), e.data.interval);
    }
  });`;
class $ae049384a7d1c7c8$export$2e2bcd8739ae039 {
    get endPoint() {
        return this.socketAdapter.endPoint;
    }
    get timeout() {
        return this.socketAdapter.timeout;
    }
    get transport() {
        return this.socketAdapter.transport;
    }
    get heartbeatCallback() {
        return this.socketAdapter.heartbeatCallback;
    }
    get heartbeatIntervalMs() {
        return this.socketAdapter.heartbeatIntervalMs;
    }
    get heartbeatTimer() {
        if (this.worker) return this._workerHeartbeatTimer;
        return this.socketAdapter.heartbeatTimer;
    }
    get pendingHeartbeatRef() {
        if (this.worker) return this._pendingWorkerHeartbeatRef;
        return this.socketAdapter.pendingHeartbeatRef;
    }
    get reconnectTimer() {
        return this.socketAdapter.reconnectTimer;
    }
    get vsn() {
        return this.socketAdapter.vsn;
    }
    get encode() {
        return this.socketAdapter.encode;
    }
    get decode() {
        return this.socketAdapter.decode;
    }
    get reconnectAfterMs() {
        return this.socketAdapter.reconnectAfterMs;
    }
    get sendBuffer() {
        return this.socketAdapter.sendBuffer;
    }
    get stateChangeCallbacks() {
        return this.socketAdapter.stateChangeCallbacks;
    }
    /**
     * Initializes the Socket.
     *
     * @param endPoint The string WebSocket endpoint, ie, "ws://example.com/socket", "wss://example.com", "/socket" (inherited host & protocol)
     * @param httpEndpoint The string HTTP endpoint, ie, "https://example.com", "/" (inherited host & protocol)
     * @param options.transport The Websocket Transport, for example WebSocket. This can be a custom implementation
     * @param options.timeout The default timeout in milliseconds to trigger push timeouts.
     * @param options.params The optional params to pass when connecting.
     * @param options.headers Deprecated: headers cannot be set on websocket connections and this option will be removed in the future.
     * @param options.heartbeatIntervalMs The millisec interval to send a heartbeat message.
     * @param options.heartbeatCallback The optional function to handle heartbeat status and latency.
     * @param options.logger The optional function for specialized logging, ie: logger: (kind, msg, data) => { console.log(`${kind}: ${msg}`, data) }
     * @param options.logLevel Sets the log level for Realtime
     * @param options.encode The function to encode outgoing messages. Defaults to JSON: (payload, callback) => callback(JSON.stringify(payload))
     * @param options.decode The function to decode incoming messages. Defaults to Serializer's decode.
     * @param options.reconnectAfterMs he optional function that returns the millsec reconnect interval. Defaults to stepped backoff off.
     * @param options.worker Use Web Worker to set a side flow. Defaults to false.
     * @param options.workerUrl The URL of the worker script. Defaults to https://realtime.supabase.com/worker.js that includes a heartbeat event call to keep the connection alive.
     * @param options.vsn The protocol version to use when connecting. Supported versions are "1.0.0" and "2.0.0". Defaults to "2.0.0".
     *
     * @category Realtime
     *
     * @example Using supabase-js (recommended)
     * ```ts
     * import { createClient } from '@supabase/supabase-js'
     *
     * const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
     * const channel = supabase.channel('room1')
     * channel
     *   .on('broadcast', { event: 'cursor-pos' }, (payload) => console.log(payload))
     *   .subscribe()
     * ```
     *
     * @example Standalone import for bundle-sensitive environments
     * ```ts
     * import RealtimeClient from '@supabase/realtime-js'
     *
     * const client = new RealtimeClient('https://xyzcompany.supabase.co/realtime/v1', {
     *   params: { apikey: 'your-publishable-key' },
     * })
     * client.connect()
     * ```
     */ constructor(endPoint, options){
        var _a;
        this.channels = new Array();
        this.accessTokenValue = null;
        this.accessToken = null;
        this.apiKey = null;
        this.httpEndpoint = '';
        /** @deprecated headers cannot be set on websocket connections */ this.headers = {};
        this.params = {};
        this.ref = 0;
        this.serializer = new (0, $8VIf2.default)();
        this._manuallySetToken = false;
        this._authPromise = null;
        this._workerHeartbeatTimer = undefined;
        this._pendingWorkerHeartbeatRef = null;
        this._pendingDisconnectTimer = null;
        this._disconnectOnEmptyChannelsAfterMs = 0;
        /**
         * Use either custom fetch, if provided, or default fetch to make HTTP requests
         *
         * @internal
         */ this._resolveFetch = (customFetch)=>{
            if (customFetch) return (...args)=>customFetch(...args);
            return (...args)=>fetch(...args);
        };
        // Validate required parameters
        if (!((_a = options === null || options === void 0 ? void 0 : options.params) === null || _a === void 0 ? void 0 : _a.apikey)) throw new Error('API key is required to connect to Realtime');
        this.apiKey = options.params.apikey;
        const socketAdapterOptions = this._initializeOptions(options);
        this.socketAdapter = new (0, $iCjex.default)(endPoint, socketAdapterOptions);
        this.httpEndpoint = (0, $5po7o.httpEndpointURL)(endPoint);
        this.fetch = this._resolveFetch(options === null || options === void 0 ? void 0 : options.fetch);
    }
    /**
     * Connects the socket, unless already connected.
     *
     * @category Realtime
     */ connect() {
        // Skip if already connecting, disconnecting, or connected
        if (this.isConnecting() || this.isDisconnecting() || this.isConnected()) return;
        // Trigger auth if needed and not already in progress
        // This ensures auth is called for standalone RealtimeClient usage
        // while avoiding race conditions with SupabaseClient's immediate setAuth call
        if (this.accessToken && !this._authPromise) this._setAuthSafely('connect');
        this._setupConnectionHandlers();
        try {
            this.socketAdapter.connect();
        } catch (error) {
            const errorMessage = error.message;
            // Provide helpful error message based on environment
            if (errorMessage.includes('Node.js')) throw new Error(`${errorMessage}\n\n` + 'To use Realtime in Node.js, you need to provide a WebSocket implementation:\n\n' + 'Option 1: Use Node.js 22+ which has native WebSocket support\n' + 'Option 2: Install and provide the "ws" package:\n\n' + '  npm install ws\n\n' + '  import ws from "ws"\n' + '  const client = new RealtimeClient(url, {\n' + '    ...options,\n' + '    transport: ws\n' + '  })');
            throw new Error(`WebSocket not available: ${errorMessage}`);
        }
        this._handleNodeJsRaceCondition();
    }
    /**
     * Returns the URL of the websocket.
     * @returns string The URL of the websocket.
     *
     * @category Realtime
     */ endpointURL() {
        return this.socketAdapter.endPointURL();
    }
    /**
     * Disconnects the socket.
     *
     * @param code A numeric status code to send on disconnect.
     * @param reason A custom reason for the disconnect.
     *
     * @category Realtime
     */ async disconnect(code, reason) {
        this._cancelPendingDisconnect();
        if (this.isDisconnecting()) return 'ok';
        return await this.socketAdapter.disconnect(()=>{
            clearInterval(this._workerHeartbeatTimer);
            this._terminateWorker();
        }, code, reason);
    }
    /**
     * Returns all created channels
     *
     * @category Realtime
     */ getChannels() {
        return this.channels;
    }
    /**
     * Unsubscribes, removes and tears down a single channel
     * @param channel A RealtimeChannel instance
     *
     * @category Realtime
     */ async removeChannel(channel) {
        const status = await channel.unsubscribe();
        if (status === 'ok') channel.teardown();
        return status;
    }
    /**
     * Unsubscribes, removes and tears down all channels
     *
     * @category Realtime
     */ async removeAllChannels() {
        const promises = this.channels.map(async (channel)=>{
            const result = await channel.unsubscribe();
            channel.teardown();
            return result;
        });
        const result = await Promise.all(promises);
        await this.disconnect();
        return result;
    }
    /**
     * Logs the message.
     *
     * For customized logging, `this.logger` can be overridden in Client constructor.
     *
     * @category Realtime
     */ log(kind, msg, data) {
        this.socketAdapter.log(kind, msg, data);
    }
    /**
     * Returns the current state of the socket.
     *
     * @category Realtime
     */ connectionState() {
        return this.socketAdapter.connectionState() || (0, $5gqEk.CONNECTION_STATE).closed;
    }
    /**
     * Returns `true` is the connection is open.
     *
     * @category Realtime
     */ isConnected() {
        return this.socketAdapter.isConnected();
    }
    /**
     * Returns `true` if the connection is currently connecting.
     *
     * @category Realtime
     */ isConnecting() {
        return this.socketAdapter.isConnecting();
    }
    /**
     * Returns `true` if the connection is currently disconnecting.
     *
     * @category Realtime
     */ isDisconnecting() {
        return this.socketAdapter.isDisconnecting();
    }
    /**
     * Creates (or reuses) a {@link RealtimeChannel} for the provided topic.
     *
     * Topics are automatically prefixed with `realtime:` to match the Realtime service.
     * If a channel with the same topic already exists it will be returned instead of creating
     * a duplicate connection.
     *
     * @category Realtime
     */ channel(topic, params = {
        config: {}
    }) {
        const realtimeTopic = `realtime:${topic}`;
        const exists = this.getChannels().find((c)=>c.topic === realtimeTopic);
        if (!exists) {
            const chan = new (0, $IhlL5.default)(`realtime:${topic}`, params, this);
            this._cancelPendingDisconnect();
            this.channels.push(chan);
            return chan;
        } else return exists;
    }
    /**
     * Push out a message if the socket is connected.
     *
     * If the socket is not connected, the message gets enqueued within a local buffer, and sent out when a connection is next established.
     *
     * @category Realtime
     */ push(data) {
        this.socketAdapter.push(data);
    }
    /**
     * Sets the JWT access token used for channel subscription authorization and Realtime RLS.
     *
     * If param is null it will use the `accessToken` callback function or the token set on the client.
     *
     * On callback used, it will set the value of the token internal to the client.
     *
     * When a token is explicitly provided, it will be preserved across channel operations
     * (including removeChannel and resubscribe). The `accessToken` callback will not be
     * invoked until `setAuth()` is called without arguments.
     *
     * @param token A JWT string to override the token set on the client.
     *
     * @example Setting the authorization header
     * // Use a manual token (preserved across resubscribes, ignores accessToken callback)
     * client.realtime.setAuth('my-custom-jwt')
     *
     * // Switch back to using the accessToken callback
     * client.realtime.setAuth()
     *
     * @category Realtime
     */ async setAuth(token = null) {
        this._authPromise = this._performAuth(token);
        try {
            await this._authPromise;
        } finally{
            this._authPromise = null;
        }
    }
    /**
     * Returns true if the current access token was explicitly set via setAuth(token),
     * false if it was obtained via the accessToken callback.
     * @internal
     */ _isManualToken() {
        return this._manuallySetToken;
    }
    /**
     * Sends a heartbeat message if the socket is connected.
     *
     * @category Realtime
     */ async sendHeartbeat() {
        this.socketAdapter.sendHeartbeat();
    }
    /**
     * Sets a callback that receives lifecycle events for internal heartbeat messages.
     * Useful for instrumenting connection health (e.g. sent/ok/timeout/disconnected).
     *
     * @category Realtime
     */ onHeartbeat(callback) {
        this.socketAdapter.heartbeatCallback = this._wrapHeartbeatCallback(callback);
    }
    /**
     * Return the next message ref, accounting for overflows
     *
     * @internal
     */ _makeRef() {
        return this.socketAdapter.makeRef();
    }
    /**
     * Removes a channel from RealtimeClient
     *
     * @param channel An open subscription.
     *
     * @internal
     */ _remove(channel) {
        this.channels = this.channels.filter((c)=>c.topic !== channel.topic);
        if (this.channels.length === 0) {
            this.log('transport', 'no channels remaining, scheduling disconnect');
            this._schedulePendingDisconnect();
        }
    }
    /** @internal */ _schedulePendingDisconnect() {
        this._cancelPendingDisconnect();
        if (this._disconnectOnEmptyChannelsAfterMs === 0) {
            this.log('transport', 'disconnecting immediately - no channels');
            this.disconnect();
            return;
        }
        this._pendingDisconnectTimer = setTimeout(()=>{
            this._pendingDisconnectTimer = null;
            if (this.channels.length === 0) {
                this.log('transport', 'deferred disconnect fired - no channels, disconnecting');
                this.disconnect();
            }
        }, this._disconnectOnEmptyChannelsAfterMs);
        this.log('transport', `deferred disconnect scheduled in ${this._disconnectOnEmptyChannelsAfterMs}ms`);
    }
    /** @internal */ _cancelPendingDisconnect() {
        if (this._pendingDisconnectTimer !== null) {
            this.log('transport', 'pending disconnect cancelled - channel activity detected');
            clearTimeout(this._pendingDisconnectTimer);
            this._pendingDisconnectTimer = null;
        }
    }
    /**
     * Perform the actual auth operation
     * @internal
     */ async _performAuth(token = null) {
        let tokenToSend;
        let isManualToken = false;
        if (token) {
            tokenToSend = token;
            // Track if this is a manually-provided token
            isManualToken = true;
        } else if (this.accessToken) // Call the accessToken callback to get fresh token
        try {
            tokenToSend = await this.accessToken();
        } catch (e) {
            this.log('error', 'Error fetching access token from callback', e);
            // Fall back to cached value if callback fails
            tokenToSend = this.accessTokenValue;
        }
        else tokenToSend = this.accessTokenValue;
        // Track whether this token was manually set or fetched via callback
        if (isManualToken) this._manuallySetToken = true;
        else if (this.accessToken) // If we used the callback, clear the manual flag
        this._manuallySetToken = false;
        if (this.accessTokenValue != tokenToSend) {
            this.accessTokenValue = tokenToSend;
            this.channels.forEach((channel)=>{
                const payload = {
                    access_token: tokenToSend,
                    version: (0, $5gqEk.DEFAULT_VERSION)
                };
                tokenToSend && channel.updateJoinPayload(payload);
                if (channel.joinedOnce && channel.channelAdapter.isJoined()) channel.channelAdapter.push((0, $5gqEk.CHANNEL_EVENTS).access_token, {
                    access_token: tokenToSend
                });
            });
        }
    }
    /**
     * Wait for any in-flight auth operations to complete
     * @internal
     */ async _waitForAuthIfNeeded() {
        if (this._authPromise) await this._authPromise;
    }
    /**
     * Safely call setAuth with standardized error handling
     * @internal
     */ _setAuthSafely(context = 'general') {
        // Only refresh auth if using callback-based tokens
        if (!this._isManualToken()) this.setAuth().catch((e)=>{
            this.log('error', `Error setting auth in ${context}`, e);
        });
    }
    /** @internal */ _setupConnectionHandlers() {
        this.socketAdapter.onOpen(()=>{
            const authPromise = this._authPromise || (this.accessToken && !this.accessTokenValue ? this.setAuth() : Promise.resolve());
            authPromise.catch((e)=>{
                this.log('error', 'error waiting for auth on connect', e);
            });
            if (this.worker && !this.workerRef) this._startWorkerHeartbeat();
        });
        this.socketAdapter.onClose(()=>{
            if (this.worker && this.workerRef) this._terminateWorker();
        });
        this.socketAdapter.onMessage((message)=>{
            if (message.ref && message.ref === this._pendingWorkerHeartbeatRef) this._pendingWorkerHeartbeatRef = null;
        });
    }
    /** @internal */ _handleNodeJsRaceCondition() {
        if (this.socketAdapter.isConnected()) // hack: ensure onConnOpen is called
        this.socketAdapter.getSocket().onConnOpen();
    }
    /** @internal */ _wrapHeartbeatCallback(heartbeatCallback) {
        return (status, latency)=>{
            if (status == 'sent') this._setAuthSafely();
            if (heartbeatCallback) heartbeatCallback(status, latency);
        };
    }
    /** @internal */ _startWorkerHeartbeat() {
        if (this.workerUrl) this.log('worker', `starting worker for from ${this.workerUrl}`);
        else this.log('worker', `starting default worker`);
        const objectUrl = this._workerObjectUrl(this.workerUrl);
        this.workerRef = new Worker(objectUrl);
        this.workerRef.onerror = (error)=>{
            this.log('worker', 'worker error', error.message);
            this._terminateWorker();
            this.disconnect();
        };
        this.workerRef.onmessage = (event)=>{
            if (event.data.event === 'keepAlive') this.sendHeartbeat();
        };
        this.workerRef.postMessage({
            event: 'start',
            interval: this.heartbeatIntervalMs
        });
    }
    /**
     * Terminate the Web Worker and clear the reference
     * @internal
     */ _terminateWorker() {
        if (this.workerRef) {
            this.log('worker', 'terminating worker');
            this.workerRef.terminate();
            this.workerRef = undefined;
        }
    }
    /** @internal */ _workerObjectUrl(url) {
        let result_url;
        if (url) result_url = url;
        else {
            const blob = new Blob([
                $ae049384a7d1c7c8$var$WORKER_SCRIPT
            ], {
                type: 'application/javascript'
            });
            result_url = URL.createObjectURL(blob);
        }
        return result_url;
    }
    /**
     * Initialize socket options with defaults
     * @internal
     */ _initializeOptions(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        this.worker = (_a = options === null || options === void 0 ? void 0 : options.worker) !== null && _a !== void 0 ? _a : false;
        this.accessToken = (_b = options === null || options === void 0 ? void 0 : options.accessToken) !== null && _b !== void 0 ? _b : null;
        const result = {};
        result.timeout = (_c = options === null || options === void 0 ? void 0 : options.timeout) !== null && _c !== void 0 ? _c : (0, $5gqEk.DEFAULT_TIMEOUT);
        result.heartbeatIntervalMs = (_d = options === null || options === void 0 ? void 0 : options.heartbeatIntervalMs) !== null && _d !== void 0 ? _d : $ae049384a7d1c7c8$var$CONNECTION_TIMEOUTS.HEARTBEAT_INTERVAL;
        this._disconnectOnEmptyChannelsAfterMs = (_e = options === null || options === void 0 ? void 0 : options.disconnectOnEmptyChannelsAfterMs) !== null && _e !== void 0 ? _e : 2 * ((_f = options === null || options === void 0 ? void 0 : options.heartbeatIntervalMs) !== null && _f !== void 0 ? _f : $ae049384a7d1c7c8$var$CONNECTION_TIMEOUTS.HEARTBEAT_INTERVAL);
        // @ts-ignore - mismatch between phoenix and supabase
        result.transport = (_g = options === null || options === void 0 ? void 0 : options.transport) !== null && _g !== void 0 ? _g : (0, $hnThW.default).getWebSocketConstructor();
        result.params = options === null || options === void 0 ? void 0 : options.params;
        result.logger = options === null || options === void 0 ? void 0 : options.logger;
        result.heartbeatCallback = this._wrapHeartbeatCallback(options === null || options === void 0 ? void 0 : options.heartbeatCallback);
        result.reconnectAfterMs = (_h = options === null || options === void 0 ? void 0 : options.reconnectAfterMs) !== null && _h !== void 0 ? _h : (tries)=>{
            return $ae049384a7d1c7c8$var$RECONNECT_INTERVALS[tries - 1] || $ae049384a7d1c7c8$var$DEFAULT_RECONNECT_FALLBACK;
        };
        let defaultEncode;
        let defaultDecode;
        const vsn = (_j = options === null || options === void 0 ? void 0 : options.vsn) !== null && _j !== void 0 ? _j : (0, $5gqEk.DEFAULT_VSN);
        switch(vsn){
            case 0, $5gqEk.VSN_1_0_0:
                defaultEncode = (payload, callback)=>{
                    return callback(JSON.stringify(payload));
                };
                defaultDecode = (payload, callback)=>{
                    return callback(JSON.parse(payload));
                };
                break;
            case 0, $5gqEk.VSN_2_0_0:
                defaultEncode = this.serializer.encode.bind(this.serializer);
                defaultDecode = this.serializer.decode.bind(this.serializer);
                break;
            default:
                throw new Error(`Unsupported serializer version: ${result.vsn}`);
        }
        result.vsn = vsn;
        result.encode = (_k = options === null || options === void 0 ? void 0 : options.encode) !== null && _k !== void 0 ? _k : defaultEncode;
        result.decode = (_l = options === null || options === void 0 ? void 0 : options.decode) !== null && _l !== void 0 ? _l : defaultDecode;
        result.beforeReconnect = this._reconnectAuth.bind(this);
        if ((options === null || options === void 0 ? void 0 : options.logLevel) || (options === null || options === void 0 ? void 0 : options.log_level)) {
            this.logLevel = options.logLevel || options.log_level;
            result.params = Object.assign(Object.assign({}, result.params), {
                log_level: this.logLevel
            });
        }
        // Handle worker setup
        if (this.worker) {
            if (typeof window !== 'undefined' && !window.Worker) throw new Error('Web Worker is not supported');
            this.workerUrl = options === null || options === void 0 ? void 0 : options.workerUrl;
            result.autoSendHeartbeat = !this.worker;
        }
        return result;
    }
    /** @internal */ async _reconnectAuth() {
        await this._waitForAuthIfNeeded();
        if (!this.isConnected()) this.connect();
    }
}

});
parcelRegister("hnThW", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca7f78c8d4f60723$export$2e2bcd8739ae039);
/**
 * Utilities for creating WebSocket instances across runtimes.
 */ class $ca7f78c8d4f60723$export$67be75336dea7fb5 {
    /**
     * Static-only utility – prevent instantiation.
     */ constructor(){}
    static detectEnvironment() {
        var _a;
        if (typeof WebSocket !== 'undefined') return {
            type: 'native',
            wsConstructor: WebSocket
        };
        const gt = globalThis;
        if (typeof globalThis !== 'undefined' && typeof gt.WebSocket !== 'undefined') return {
            type: 'native',
            wsConstructor: gt.WebSocket
        };
        const gl = typeof $parcel$global !== 'undefined' ? $parcel$global : undefined;
        if (gl && typeof gl.WebSocket !== 'undefined') return {
            type: 'native',
            wsConstructor: gl.WebSocket
        };
        if (typeof globalThis !== 'undefined' && typeof gt.WebSocketPair !== 'undefined' && typeof globalThis.WebSocket === 'undefined') return {
            type: 'cloudflare',
            error: 'Cloudflare Workers detected. WebSocket clients are not supported in Cloudflare Workers.',
            workaround: 'Use Cloudflare Workers WebSocket API for server-side WebSocket handling, or deploy to a different runtime.'
        };
        if (typeof globalThis !== 'undefined' && gt.EdgeRuntime || typeof navigator !== 'undefined' && ((_a = navigator.userAgent) === null || _a === void 0 ? void 0 : _a.includes('Vercel-Edge'))) return {
            type: 'unsupported',
            error: 'Edge runtime detected (Vercel Edge/Netlify Edge). WebSockets are not supported in edge functions.',
            workaround: 'Use serverless functions or a different deployment target for WebSocket functionality.'
        };
        // Use dynamic property access to avoid Next.js Edge Runtime static analysis warnings
        const _process = globalThis['process'];
        if (_process) {
            const processVersions = _process['versions'];
            if (processVersions && processVersions['node']) {
                // Remove 'v' prefix if present and parse the major version
                const versionString = processVersions['node'];
                const nodeVersion = parseInt(versionString.replace(/^v/, '').split('.')[0]);
                // Node.js 22+ should have native WebSocket
                if (nodeVersion >= 22) {
                    // Check if native WebSocket is available (should be in Node.js 22+)
                    if (typeof globalThis.WebSocket !== 'undefined') return {
                        type: 'native',
                        wsConstructor: globalThis.WebSocket
                    };
                    // If not available, user needs to provide it
                    return {
                        type: 'unsupported',
                        error: `Node.js ${nodeVersion} detected but native WebSocket not found.`,
                        workaround: 'Provide a WebSocket implementation via the transport option.'
                    };
                }
                // Node.js < 22 doesn't have native WebSocket
                return {
                    type: 'unsupported',
                    error: `Node.js ${nodeVersion} detected without native WebSocket support.`,
                    workaround: 'For Node.js < 22, install "ws" package and provide it via the transport option:\nimport ws from "ws"\nnew RealtimeClient(url, { transport: ws })'
                };
            }
        }
        return {
            type: 'unsupported',
            error: 'Unknown JavaScript runtime without WebSocket support.',
            workaround: "Ensure you're running in a supported environment (browser, Node.js, Deno) or provide a custom WebSocket implementation."
        };
    }
    /**
     * Returns the best available WebSocket constructor for the current runtime.
     *
     * @category Realtime
     *
     * @example Example with error handling
     * ```ts
     * try {
     *   const WS = WebSocketFactory.getWebSocketConstructor()
     *   const socket = new WS('wss://example.com/socket')
     * } catch (error) {
     *   console.error('WebSocket not available in this environment.', error)
     * }
     * ```
     */ static getWebSocketConstructor() {
        const env = this.detectEnvironment();
        if (env.wsConstructor) return env.wsConstructor;
        let errorMessage = env.error || 'WebSocket not supported in this environment.';
        if (env.workaround) errorMessage += `\n\nSuggested solution: ${env.workaround}`;
        throw new Error(errorMessage);
    }
    /**
     * Detects whether the runtime can establish WebSocket connections.
     *
     * @category Realtime
     *
     * @example Example in a Node.js script
     * ```ts
     * if (!WebSocketFactory.isWebSocketSupported()) {
     *   console.error('WebSockets are required for this script.')
     *   process.exitCode = 1
     * }
     * ```
     */ static isWebSocketSupported() {
        try {
            const env = this.detectEnvironment();
            return env.type === 'native' || env.type === 'ws';
        } catch (_a) {
            return false;
        }
    }
}
var $ca7f78c8d4f60723$export$2e2bcd8739ae039 = $ca7f78c8d4f60723$export$67be75336dea7fb5;

});

parcelRegister("5gqEk", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_VERSION", () => $3d531e63e1ea7f53$export$363ebe89e6e7aeef);
$parcel$export(module.exports, "VSN_1_0_0", () => $3d531e63e1ea7f53$export$b8f6d7e635d6c56b);
$parcel$export(module.exports, "VSN_2_0_0", () => $3d531e63e1ea7f53$export$3f251ec2d5d5cd3a);
$parcel$export(module.exports, "DEFAULT_VSN", () => $3d531e63e1ea7f53$export$90c89f9664aa9117);
$parcel$export(module.exports, "DEFAULT_TIMEOUT", () => $3d531e63e1ea7f53$export$7bd623b29ec8e1eb);
$parcel$export(module.exports, "MAX_PUSH_BUFFER_SIZE", () => $3d531e63e1ea7f53$export$f227fe8351a81f4a);
$parcel$export(module.exports, "CHANNEL_STATES", () => $3d531e63e1ea7f53$export$b83816118db74fe7);
$parcel$export(module.exports, "CHANNEL_EVENTS", () => $3d531e63e1ea7f53$export$8db7548e65d6ea55);
$parcel$export(module.exports, "CONNECTION_STATE", () => $3d531e63e1ea7f53$export$deda39003d27273);

var $6BQLu = parcelRequire("6BQLu");
const $3d531e63e1ea7f53$export$363ebe89e6e7aeef = `realtime-js/${(0, $6BQLu.version)}`;
const $3d531e63e1ea7f53$export$b8f6d7e635d6c56b = '1.0.0';
const $3d531e63e1ea7f53$export$3f251ec2d5d5cd3a = '2.0.0';
const $3d531e63e1ea7f53$export$90c89f9664aa9117 = $3d531e63e1ea7f53$export$3f251ec2d5d5cd3a;
const $3d531e63e1ea7f53$export$a4ad2735b021c132 = (0, $6BQLu.version);
const $3d531e63e1ea7f53$export$7bd623b29ec8e1eb = 10000;
const $3d531e63e1ea7f53$export$5e80cf62e56a877b = 1000;
const $3d531e63e1ea7f53$export$f227fe8351a81f4a = 100;
const $3d531e63e1ea7f53$export$a6d0320a1563d49e = {
    connecting: 0,
    open: 1,
    closing: 2,
    closed: 3
};
const $3d531e63e1ea7f53$export$b83816118db74fe7 = {
    closed: 'closed',
    errored: 'errored',
    joined: 'joined',
    joining: 'joining',
    leaving: 'leaving'
};
const $3d531e63e1ea7f53$export$8db7548e65d6ea55 = {
    close: 'phx_close',
    error: 'phx_error',
    join: 'phx_join',
    reply: 'phx_reply',
    leave: 'phx_leave',
    access_token: 'access_token'
};
const $3d531e63e1ea7f53$export$b2688bfb999f5751 = {
    websocket: 'websocket'
};
const $3d531e63e1ea7f53$export$deda39003d27273 = {
    connecting: 'connecting',
    open: 'open',
    closing: 'closing',
    closed: 'closed'
};

});
parcelRegister("6BQLu", function(module, exports) {

$parcel$export(module.exports, "version", () => $4cff20d240de2de4$export$83d89fbfd8236492);
// Generated automatically during releases by scripts/update-version-files.ts
// This file provides runtime access to the package version for:
// - HTTP request headers (e.g., X-Client-Info header for API requests)
// - Debugging and support (identifying which version is running)
// - Telemetry and logging (version reporting in errors/analytics)
// - Ensuring build artifacts match the published package version
const $4cff20d240de2de4$export$83d89fbfd8236492 = '2.105.3';

});


parcelRegister("8VIf2", function(module, exports) {

$parcel$export(module.exports, "default", () => $6805f7080ae1d67f$export$2e2bcd8739ae039);
class $6805f7080ae1d67f$export$2e2bcd8739ae039 {
    constructor(allowedMetadataKeys){
        this.HEADER_LENGTH = 1;
        this.USER_BROADCAST_PUSH_META_LENGTH = 6;
        this.KINDS = {
            userBroadcastPush: 3,
            userBroadcast: 4
        };
        this.BINARY_ENCODING = 0;
        this.JSON_ENCODING = 1;
        this.BROADCAST_EVENT = 'broadcast';
        this.allowedMetadataKeys = [];
        this.allowedMetadataKeys = allowedMetadataKeys !== null && allowedMetadataKeys !== void 0 ? allowedMetadataKeys : [];
    }
    encode(msg, callback) {
        if (msg.event === this.BROADCAST_EVENT && !(msg.payload instanceof ArrayBuffer) && typeof msg.payload.event === 'string') return callback(this._binaryEncodeUserBroadcastPush(msg));
        let payload = [
            msg.join_ref,
            msg.ref,
            msg.topic,
            msg.event,
            msg.payload
        ];
        return callback(JSON.stringify(payload));
    }
    _binaryEncodeUserBroadcastPush(message) {
        var _a;
        if (this._isArrayBuffer((_a = message.payload) === null || _a === void 0 ? void 0 : _a.payload)) return this._encodeBinaryUserBroadcastPush(message);
        else return this._encodeJsonUserBroadcastPush(message);
    }
    _encodeBinaryUserBroadcastPush(message) {
        var _a, _b;
        const userPayload = (_b = (_a = message.payload) === null || _a === void 0 ? void 0 : _a.payload) !== null && _b !== void 0 ? _b : new ArrayBuffer(0);
        return this._encodeUserBroadcastPush(message, this.BINARY_ENCODING, userPayload);
    }
    _encodeJsonUserBroadcastPush(message) {
        var _a, _b;
        const userPayload = (_b = (_a = message.payload) === null || _a === void 0 ? void 0 : _a.payload) !== null && _b !== void 0 ? _b : {};
        const encoder = new TextEncoder();
        const encodedUserPayload = encoder.encode(JSON.stringify(userPayload)).buffer;
        return this._encodeUserBroadcastPush(message, this.JSON_ENCODING, encodedUserPayload);
    }
    _encodeUserBroadcastPush(message, encodingType, encodedPayload) {
        var _a, _b;
        const topic = message.topic;
        const ref = (_a = message.ref) !== null && _a !== void 0 ? _a : '';
        const joinRef = (_b = message.join_ref) !== null && _b !== void 0 ? _b : '';
        const userEvent = message.payload.event;
        // Filter metadata based on allowed keys
        const rest = this.allowedMetadataKeys ? this._pick(message.payload, this.allowedMetadataKeys) : {};
        const metadata = Object.keys(rest).length === 0 ? '' : JSON.stringify(rest);
        // Validate lengths don't exceed uint8 max value (255)
        if (joinRef.length > 255) throw new Error(`joinRef length ${joinRef.length} exceeds maximum of 255`);
        if (ref.length > 255) throw new Error(`ref length ${ref.length} exceeds maximum of 255`);
        if (topic.length > 255) throw new Error(`topic length ${topic.length} exceeds maximum of 255`);
        if (userEvent.length > 255) throw new Error(`userEvent length ${userEvent.length} exceeds maximum of 255`);
        if (metadata.length > 255) throw new Error(`metadata length ${metadata.length} exceeds maximum of 255`);
        const metaLength = this.USER_BROADCAST_PUSH_META_LENGTH + joinRef.length + ref.length + topic.length + userEvent.length + metadata.length;
        const header = new ArrayBuffer(this.HEADER_LENGTH + metaLength);
        let view = new DataView(header);
        let offset = 0;
        view.setUint8(offset++, this.KINDS.userBroadcastPush); // kind
        view.setUint8(offset++, joinRef.length);
        view.setUint8(offset++, ref.length);
        view.setUint8(offset++, topic.length);
        view.setUint8(offset++, userEvent.length);
        view.setUint8(offset++, metadata.length);
        view.setUint8(offset++, encodingType);
        Array.from(joinRef, (char)=>view.setUint8(offset++, char.charCodeAt(0)));
        Array.from(ref, (char)=>view.setUint8(offset++, char.charCodeAt(0)));
        Array.from(topic, (char)=>view.setUint8(offset++, char.charCodeAt(0)));
        Array.from(userEvent, (char)=>view.setUint8(offset++, char.charCodeAt(0)));
        Array.from(metadata, (char)=>view.setUint8(offset++, char.charCodeAt(0)));
        var combined = new Uint8Array(header.byteLength + encodedPayload.byteLength);
        combined.set(new Uint8Array(header), 0);
        combined.set(new Uint8Array(encodedPayload), header.byteLength);
        return combined.buffer;
    }
    decode(rawPayload, callback) {
        if (this._isArrayBuffer(rawPayload)) {
            let result = this._binaryDecode(rawPayload);
            return callback(result);
        }
        if (typeof rawPayload === 'string') {
            const jsonPayload = JSON.parse(rawPayload);
            const [join_ref, ref, topic, event, payload] = jsonPayload;
            return callback({
                join_ref: join_ref,
                ref: ref,
                topic: topic,
                event: event,
                payload: payload
            });
        }
        return callback({});
    }
    _binaryDecode(buffer) {
        const view = new DataView(buffer);
        const kind = view.getUint8(0);
        const decoder = new TextDecoder();
        switch(kind){
            case this.KINDS.userBroadcast:
                return this._decodeUserBroadcast(buffer, view, decoder);
        }
    }
    _decodeUserBroadcast(buffer, view, decoder) {
        const topicSize = view.getUint8(1);
        const userEventSize = view.getUint8(2);
        const metadataSize = view.getUint8(3);
        const payloadEncoding = view.getUint8(4);
        let offset = this.HEADER_LENGTH + 4;
        const topic = decoder.decode(buffer.slice(offset, offset + topicSize));
        offset = offset + topicSize;
        const userEvent = decoder.decode(buffer.slice(offset, offset + userEventSize));
        offset = offset + userEventSize;
        const metadata = decoder.decode(buffer.slice(offset, offset + metadataSize));
        offset = offset + metadataSize;
        const payload = buffer.slice(offset, buffer.byteLength);
        const parsedPayload = payloadEncoding === this.JSON_ENCODING ? JSON.parse(decoder.decode(payload)) : payload;
        const data = {
            type: this.BROADCAST_EVENT,
            event: userEvent,
            payload: parsedPayload
        };
        // Metadata is optional and always JSON encoded
        if (metadataSize > 0) data['meta'] = JSON.parse(metadata);
        return {
            join_ref: null,
            ref: null,
            topic: topic,
            event: this.BROADCAST_EVENT,
            payload: data
        };
    }
    _isArrayBuffer(buffer) {
        var _a;
        return buffer instanceof ArrayBuffer || ((_a = buffer === null || buffer === void 0 ? void 0 : buffer.constructor) === null || _a === void 0 ? void 0 : _a.name) === 'ArrayBuffer';
    }
    _pick(obj, keys) {
        if (!obj || typeof obj !== 'object') return {};
        return Object.fromEntries(Object.entries(obj).filter(([key])=>keys.includes(key)));
    }
}

});

parcelRegister("5po7o", function(module, exports) {

$parcel$export(module.exports, "convertChangeData", () => $3f01feefa94fd48b$export$20ce708a1f594c5e);
$parcel$export(module.exports, "httpEndpointURL", () => $3f01feefa94fd48b$export$976fda7151b30cae);
/**
 * Helpers to convert the change Payload into native JS types.
 */ // Adapted from epgsql (src/epgsql_binary.erl), this module licensed under
// 3-clause BSD found here: https://raw.githubusercontent.com/epgsql/epgsql/devel/LICENSE
var $3f01feefa94fd48b$export$4d213a7d364021dc;
(function(PostgresTypes) {
    PostgresTypes["abstime"] = "abstime";
    PostgresTypes["bool"] = "bool";
    PostgresTypes["date"] = "date";
    PostgresTypes["daterange"] = "daterange";
    PostgresTypes["float4"] = "float4";
    PostgresTypes["float8"] = "float8";
    PostgresTypes["int2"] = "int2";
    PostgresTypes["int4"] = "int4";
    PostgresTypes["int4range"] = "int4range";
    PostgresTypes["int8"] = "int8";
    PostgresTypes["int8range"] = "int8range";
    PostgresTypes["json"] = "json";
    PostgresTypes["jsonb"] = "jsonb";
    PostgresTypes["money"] = "money";
    PostgresTypes["numeric"] = "numeric";
    PostgresTypes["oid"] = "oid";
    PostgresTypes["reltime"] = "reltime";
    PostgresTypes["text"] = "text";
    PostgresTypes["time"] = "time";
    PostgresTypes["timestamp"] = "timestamp";
    PostgresTypes["timestamptz"] = "timestamptz";
    PostgresTypes["timetz"] = "timetz";
    PostgresTypes["tsrange"] = "tsrange";
    PostgresTypes["tstzrange"] = "tstzrange";
})($3f01feefa94fd48b$export$4d213a7d364021dc || ($3f01feefa94fd48b$export$4d213a7d364021dc = {}));
const $3f01feefa94fd48b$export$20ce708a1f594c5e = (columns, record, options = {})=>{
    var _a;
    const skipTypes = (_a = options.skipTypes) !== null && _a !== void 0 ? _a : [];
    if (!record) return {};
    return Object.keys(record).reduce((acc, rec_key)=>{
        acc[rec_key] = $3f01feefa94fd48b$export$c054edfec1afa88d(rec_key, columns, record, skipTypes);
        return acc;
    }, {});
};
const $3f01feefa94fd48b$export$c054edfec1afa88d = (columnName, columns, record, skipTypes)=>{
    const column = columns.find((x)=>x.name === columnName);
    const colType = column === null || column === void 0 ? void 0 : column.type;
    const value = record[columnName];
    if (colType && !skipTypes.includes(colType)) return $3f01feefa94fd48b$export$3df02a362b86a91(colType, value);
    return $3f01feefa94fd48b$var$noop(value);
};
const $3f01feefa94fd48b$export$3df02a362b86a91 = (type, value)=>{
    // if data type is an array
    if (type.charAt(0) === '_') {
        const dataType = type.slice(1, type.length);
        return $3f01feefa94fd48b$export$45b10814cc054894(value, dataType);
    }
    // If not null, convert to correct type.
    switch(type){
        case $3f01feefa94fd48b$export$4d213a7d364021dc.bool:
            return $3f01feefa94fd48b$export$3c2e6d1b7583eee6(value);
        case $3f01feefa94fd48b$export$4d213a7d364021dc.float4:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.float8:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.int2:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.int4:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.int8:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.numeric:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.oid:
            return $3f01feefa94fd48b$export$a0a81dc3380ce7d3(value);
        case $3f01feefa94fd48b$export$4d213a7d364021dc.json:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.jsonb:
            return $3f01feefa94fd48b$export$d5b7a8bf56ee1fe2(value);
        case $3f01feefa94fd48b$export$4d213a7d364021dc.timestamp:
            return $3f01feefa94fd48b$export$eccf8c5d91d19e3a(value); // Format to be consistent with PostgREST
        case $3f01feefa94fd48b$export$4d213a7d364021dc.abstime:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.date:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.daterange:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.int4range:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.int8range:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.money:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.reltime:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.text:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.time:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.timestamptz:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.timetz:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.tsrange:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.tstzrange:
            return $3f01feefa94fd48b$var$noop(value);
        default:
            // Return the value for remaining types
            return $3f01feefa94fd48b$var$noop(value);
    }
};
const $3f01feefa94fd48b$var$noop = (value)=>{
    return value;
};
const $3f01feefa94fd48b$export$3c2e6d1b7583eee6 = (value)=>{
    switch(value){
        case 't':
            return true;
        case 'f':
            return false;
        default:
            return value;
    }
};
const $3f01feefa94fd48b$export$a0a81dc3380ce7d3 = (value)=>{
    if (typeof value === 'string') {
        const parsedValue = parseFloat(value);
        if (!Number.isNaN(parsedValue)) return parsedValue;
    }
    return value;
};
const $3f01feefa94fd48b$export$d5b7a8bf56ee1fe2 = (value)=>{
    if (typeof value === 'string') try {
        return JSON.parse(value);
    } catch (_a) {
        return value;
    }
    return value;
};
const $3f01feefa94fd48b$export$45b10814cc054894 = (value, type)=>{
    if (typeof value !== 'string') return value;
    const lastIdx = value.length - 1;
    const closeBrace = value[lastIdx];
    const openBrace = value[0];
    // Confirm value is a Postgres array by checking curly brackets
    if (openBrace === '{' && closeBrace === '}') {
        let arr;
        const valTrim = value.slice(1, lastIdx);
        // TODO: find a better solution to separate Postgres array data
        try {
            arr = JSON.parse('[' + valTrim + ']');
        } catch (_) {
            // WARNING: splitting on comma does not cover all edge cases
            arr = valTrim ? valTrim.split(',') : [];
        }
        return arr.map((val)=>$3f01feefa94fd48b$export$3df02a362b86a91(type, val));
    }
    return value;
};
const $3f01feefa94fd48b$export$eccf8c5d91d19e3a = (value)=>{
    if (typeof value === 'string') return value.replace(' ', 'T');
    return value;
};
const $3f01feefa94fd48b$export$976fda7151b30cae = (socketUrl)=>{
    const wsUrl = new URL(socketUrl);
    wsUrl.protocol = wsUrl.protocol.replace(/^ws/i, 'http');
    wsUrl.pathname = wsUrl.pathname.replace(/\/+$/, '') // remove all trailing slashes
    .replace(/\/socket\/websocket$/i, '') // remove the socket/websocket path
    .replace(/\/socket$/i, '') // remove the socket path
    .replace(/\/websocket$/i, ''); // remove the websocket path
    if (wsUrl.pathname === '' || wsUrl.pathname === '/') wsUrl.pathname = '/api/broadcast';
    else wsUrl.pathname = wsUrl.pathname + '/api/broadcast';
    return wsUrl.href;
};

});

parcelRegister("IhlL5", function(module, exports) {

$parcel$export(module.exports, "default", () => $0851918337283a61$export$2e2bcd8739ae039);

var $5gqEk = parcelRequire("5gqEk");

var $6zp63 = parcelRequire("6zp63");

var $5po7o = parcelRequire("5po7o");

var $9y6d0 = parcelRequire("9y6d0");

var $7bMKy = parcelRequire("7bMKy");
var $0851918337283a61$export$bc171c571098b6c4;
(function(REALTIME_POSTGRES_CHANGES_LISTEN_EVENT) {
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["ALL"] = "*";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["INSERT"] = "INSERT";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["UPDATE"] = "UPDATE";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["DELETE"] = "DELETE";
})($0851918337283a61$export$bc171c571098b6c4 || ($0851918337283a61$export$bc171c571098b6c4 = {}));
var $0851918337283a61$export$9e3fe8e487ef792e;
(function(REALTIME_LISTEN_TYPES) {
    REALTIME_LISTEN_TYPES["BROADCAST"] = "broadcast";
    REALTIME_LISTEN_TYPES["PRESENCE"] = "presence";
    REALTIME_LISTEN_TYPES["POSTGRES_CHANGES"] = "postgres_changes";
    REALTIME_LISTEN_TYPES["SYSTEM"] = "system";
})($0851918337283a61$export$9e3fe8e487ef792e || ($0851918337283a61$export$9e3fe8e487ef792e = {}));
var $0851918337283a61$export$a6885b926af646a2;
(function(REALTIME_SUBSCRIBE_STATES) {
    REALTIME_SUBSCRIBE_STATES["SUBSCRIBED"] = "SUBSCRIBED";
    REALTIME_SUBSCRIBE_STATES["TIMED_OUT"] = "TIMED_OUT";
    REALTIME_SUBSCRIBE_STATES["CLOSED"] = "CLOSED";
    REALTIME_SUBSCRIBE_STATES["CHANNEL_ERROR"] = "CHANNEL_ERROR";
})($0851918337283a61$export$a6885b926af646a2 || ($0851918337283a61$export$a6885b926af646a2 = {}));
const $0851918337283a61$export$154db638d9c0559e = (0, $5gqEk.CHANNEL_STATES);
class $0851918337283a61$export$2e2bcd8739ae039 {
    get state() {
        return this.channelAdapter.state;
    }
    set state(state) {
        this.channelAdapter.state = state;
    }
    get joinedOnce() {
        return this.channelAdapter.joinedOnce;
    }
    get timeout() {
        return this.socket.timeout;
    }
    get joinPush() {
        return this.channelAdapter.joinPush;
    }
    get rejoinTimer() {
        return this.channelAdapter.rejoinTimer;
    }
    /**
     * Creates a channel that can broadcast messages, sync presence, and listen to Postgres changes.
     *
     * The topic determines which realtime stream you are subscribing to. Config options let you
     * enable acknowledgement for broadcasts, presence tracking, or private channels.
     *
     * @category Realtime
     *
     * @example Using supabase-js (recommended)
     * ```ts
     * import { createClient } from '@supabase/supabase-js'
     *
     * const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
     * const channel = supabase.channel('room1')
     * channel
     *   .on('broadcast', { event: 'cursor-pos' }, (payload) => console.log(payload))
     *   .subscribe()
     * ```
     *
     * @example Standalone import for bundle-sensitive environments
     * ```ts
     * import RealtimeClient from '@supabase/realtime-js'
     *
     * const client = new RealtimeClient('https://xyzcompany.supabase.co/realtime/v1', {
     *   params: { apikey: 'your-publishable-key' },
     * })
     * const channel = new RealtimeChannel('realtime:public:messages', { config: {} }, client)
     * ```
     */ constructor(/** Topic name can be any string. */ topic, params = {
        config: {}
    }, socket){
        var _a, _b;
        this.topic = topic;
        this.params = params;
        this.socket = socket;
        this.bindings = {};
        this.subTopic = topic.replace(/^realtime:/i, '');
        this.params.config = Object.assign({
            broadcast: {
                ack: false,
                self: false
            },
            presence: {
                key: '',
                enabled: false
            },
            private: false
        }, params.config);
        this.channelAdapter = new (0, $7bMKy.default)(this.socket.socketAdapter, topic, this.params);
        this.presence = new (0, $6zp63.default)(this);
        this._onClose(()=>{
            this.socket._remove(this);
        });
        this._updateFilterTransform();
        this.broadcastEndpointURL = (0, $5po7o.httpEndpointURL)(this.socket.socketAdapter.endPointURL());
        this.private = this.params.config.private || false;
        if (!this.private && ((_b = (_a = this.params.config) === null || _a === void 0 ? void 0 : _a.broadcast) === null || _b === void 0 ? void 0 : _b.replay)) throw new Error(`tried to use replay on public channel '${this.topic}'. It must be a private channel.`);
    }
    /**
     * Subscribe registers your client with the server
     * @category Realtime
     */ subscribe(callback, timeout = this.timeout) {
        var _a, _b, _c;
        if (!this.socket.isConnected()) this.socket.connect();
        if (this.channelAdapter.isClosed()) {
            const { config: { broadcast: broadcast, presence: presence, private: isPrivate } } = this.params;
            const postgres_changes = (_b = (_a = this.bindings.postgres_changes) === null || _a === void 0 ? void 0 : _a.map((r)=>r.filter)) !== null && _b !== void 0 ? _b : [];
            const presence_enabled = !!this.bindings[$0851918337283a61$export$9e3fe8e487ef792e.PRESENCE] && this.bindings[$0851918337283a61$export$9e3fe8e487ef792e.PRESENCE].length > 0 || ((_c = this.params.config.presence) === null || _c === void 0 ? void 0 : _c.enabled) === true;
            const accessTokenPayload = {};
            const config = {
                broadcast: broadcast,
                presence: Object.assign(Object.assign({}, presence), {
                    enabled: presence_enabled
                }),
                postgres_changes: postgres_changes,
                private: isPrivate
            };
            if (this.socket.accessTokenValue) accessTokenPayload.access_token = this.socket.accessTokenValue;
            this._onError((reason)=>{
                callback === null || callback === void 0 || callback($0851918337283a61$export$a6885b926af646a2.CHANNEL_ERROR, (0, $9y6d0.normalizeChannelError)(reason));
            });
            this._onClose(()=>callback === null || callback === void 0 ? void 0 : callback($0851918337283a61$export$a6885b926af646a2.CLOSED));
            this.updateJoinPayload(Object.assign({
                config: config
            }, accessTokenPayload));
            this._updateFilterMessage();
            this.channelAdapter.subscribe(timeout).receive('ok', async ({ postgres_changes: postgres_changes })=>{
                // Only refresh auth if using callback-based tokens
                if (!this.socket._isManualToken()) this.socket.setAuth();
                if (postgres_changes === undefined) {
                    callback === null || callback === void 0 || callback($0851918337283a61$export$a6885b926af646a2.SUBSCRIBED);
                    return;
                }
                this._updatePostgresBindings(postgres_changes, callback);
            }).receive('error', (error)=>{
                this.state = (0, $5gqEk.CHANNEL_STATES).errored;
                const message = Object.values(error).join(', ') || 'error';
                callback === null || callback === void 0 || callback($0851918337283a61$export$a6885b926af646a2.CHANNEL_ERROR, new Error(message, {
                    cause: error
                }));
            }).receive('timeout', ()=>{
                callback === null || callback === void 0 || callback($0851918337283a61$export$a6885b926af646a2.TIMED_OUT);
            });
        }
        return this;
    }
    _updatePostgresBindings(postgres_changes, callback) {
        var _a;
        const clientPostgresBindings = this.bindings.postgres_changes;
        const bindingsLen = (_a = clientPostgresBindings === null || clientPostgresBindings === void 0 ? void 0 : clientPostgresBindings.length) !== null && _a !== void 0 ? _a : 0;
        const newPostgresBindings = [];
        for(let i = 0; i < bindingsLen; i++){
            const clientPostgresBinding = clientPostgresBindings[i];
            const { filter: { event: event, schema: schema, table: table, filter: filter } } = clientPostgresBinding;
            const serverPostgresFilter = postgres_changes && postgres_changes[i];
            if (serverPostgresFilter && serverPostgresFilter.event === event && $0851918337283a61$export$2e2bcd8739ae039.isFilterValueEqual(serverPostgresFilter.schema, schema) && $0851918337283a61$export$2e2bcd8739ae039.isFilterValueEqual(serverPostgresFilter.table, table) && $0851918337283a61$export$2e2bcd8739ae039.isFilterValueEqual(serverPostgresFilter.filter, filter)) newPostgresBindings.push(Object.assign(Object.assign({}, clientPostgresBinding), {
                id: serverPostgresFilter.id
            }));
            else {
                this.unsubscribe();
                this.state = (0, $5gqEk.CHANNEL_STATES).errored;
                callback === null || callback === void 0 || callback($0851918337283a61$export$a6885b926af646a2.CHANNEL_ERROR, new Error('mismatch between server and client bindings for postgres changes'));
                return;
            }
        }
        this.bindings.postgres_changes = newPostgresBindings;
        if (this.state != (0, $5gqEk.CHANNEL_STATES).errored && callback) callback($0851918337283a61$export$a6885b926af646a2.SUBSCRIBED);
    }
    /**
     * Returns the current presence state for this channel.
     *
     * The shape is a map keyed by presence key (for example a user id) where each entry contains the
     * tracked metadata for that user.
     *
     * @category Realtime
     */ presenceState() {
        return this.presence.state;
    }
    /**
     * Sends the supplied payload to the presence tracker so other subscribers can see that this
     * client is online. Use `untrack` to stop broadcasting presence for the same key.
     *
     * @category Realtime
     */ async track(payload, opts = {}) {
        return await this.send({
            type: 'presence',
            event: 'track',
            payload: payload
        }, opts.timeout || this.timeout);
    }
    /**
     * Removes the current presence state for this client.
     *
     * @category Realtime
     */ async untrack(opts = {}) {
        return await this.send({
            type: 'presence',
            event: 'untrack'
        }, opts);
    }
    /**
     * Listen to realtime events on this channel.
     * @category Realtime
     *
     * @remarks
     * - By default, Broadcast and Presence are enabled for all projects.
     * - By default, listening to database changes is disabled for new projects due to database performance and security concerns. You can turn it on by managing Realtime's [replication](/docs/guides/api#realtime-api-overview).
     * - You can receive the "previous" data for updates and deletes by setting the table's `REPLICA IDENTITY` to `FULL` (e.g., `ALTER TABLE your_table REPLICA IDENTITY FULL;`).
     * - Row level security is not applied to delete statements. When RLS is enabled and replica identity is set to full, only the primary key is sent to clients.
     *
     * @example Listen to broadcast messages
     * ```js
     * const channel = supabase.channel("room1")
     *
     * channel.on("broadcast", { event: "cursor-pos" }, (payload) => {
     *   console.log("Cursor position received!", payload);
     * }).subscribe((status) => {
     *   if (status === "SUBSCRIBED") {
     *     channel.send({
     *       type: "broadcast",
     *       event: "cursor-pos",
     *       payload: { x: Math.random(), y: Math.random() },
     *     });
     *   }
     * });
     * ```
     *
     * @example Listen to presence sync
     * ```js
     * const channel = supabase.channel('room1')
     * channel
     *   .on('presence', { event: 'sync' }, () => {
     *     console.log('Synced presence state: ', channel.presenceState())
     *   })
     *   .subscribe(async (status) => {
     *     if (status === 'SUBSCRIBED') {
     *       await channel.track({ online_at: new Date().toISOString() })
     *     }
     *   })
     * ```
     *
     * @example Listen to presence join
     * ```js
     * const channel = supabase.channel('room1')
     * channel
     *   .on('presence', { event: 'join' }, ({ newPresences }) => {
     *     console.log('Newly joined presences: ', newPresences)
     *   })
     *   .subscribe(async (status) => {
     *     if (status === 'SUBSCRIBED') {
     *       await channel.track({ online_at: new Date().toISOString() })
     *     }
     *   })
     * ```
     *
     * @example Listen to presence leave
     * ```js
     * const channel = supabase.channel('room1')
     * channel
     *   .on('presence', { event: 'leave' }, ({ leftPresences }) => {
     *     console.log('Newly left presences: ', leftPresences)
     *   })
     *   .subscribe(async (status) => {
     *     if (status === 'SUBSCRIBED') {
     *       await channel.track({ online_at: new Date().toISOString() })
     *       await channel.untrack()
     *     }
     *   })
     * ```
     *
     * @example Listen to all database changes
     * ```js
     * supabase
     *   .channel('room1')
     *   .on('postgres_changes', { event: '*', schema: '*' }, payload => {
     *     console.log('Change received!', payload)
     *   })
     *   .subscribe()
     * ```
     *
     * @example Listen to a specific table
     * ```js
     * supabase
     *   .channel('room1')
     *   .on('postgres_changes', { event: '*', schema: 'public', table: 'countries' }, payload => {
     *     console.log('Change received!', payload)
     *   })
     *   .subscribe()
     * ```
     *
     * @example Listen to inserts
     * ```js
     * supabase
     *   .channel('room1')
     *   .on('postgres_changes', { event: 'INSERT', schema: 'public', table: 'countries' }, payload => {
     *     console.log('Change received!', payload)
     *   })
     *   .subscribe()
     * ```
     *
     * @exampleDescription Listen to updates
     * By default, Supabase will send only the updated record. If you want to receive the previous values as well you can
     * enable full replication for the table you are listening to:
     *
     * ```sql
     * alter table "your_table" replica identity full;
     * ```
     *
     * @example Listen to updates
     * ```js
     * supabase
     *   .channel('room1')
     *   .on('postgres_changes', { event: 'UPDATE', schema: 'public', table: 'countries' }, payload => {
     *     console.log('Change received!', payload)
     *   })
     *   .subscribe()
     * ```
     *
     * @exampleDescription Listen to deletes
     * By default, Supabase does not send deleted records. If you want to receive the deleted record you can
     * enable full replication for the table you are listening to:
     *
     * ```sql
     * alter table "your_table" replica identity full;
     * ```
     *
     * @example Listen to deletes
     * ```js
     * supabase
     *   .channel('room1')
     *   .on('postgres_changes', { event: 'DELETE', schema: 'public', table: 'countries' }, payload => {
     *     console.log('Change received!', payload)
     *   })
     *   .subscribe()
     * ```
     *
     * @exampleDescription Listen to multiple events
     * You can chain listeners if you want to listen to multiple events for each table.
     *
     * @example Listen to multiple events
     * ```js
     * supabase
     *   .channel('room1')
     *   .on('postgres_changes', { event: 'INSERT', schema: 'public', table: 'countries' }, handleRecordInserted)
     *   .on('postgres_changes', { event: 'DELETE', schema: 'public', table: 'countries' }, handleRecordDeleted)
     *   .subscribe()
     * ```
     *
     * @exampleDescription Listen to row level changes
     * You can listen to individual rows using the format `{table}:{col}=eq.{val}` - where `{col}` is the column name, and `{val}` is the value which you want to match.
     *
     * @example Listen to row level changes
     * ```js
     * supabase
     *   .channel('room1')
     *   .on('postgres_changes', { event: 'UPDATE', schema: 'public', table: 'countries', filter: 'id=eq.200' }, handleRecordUpdated)
     *   .subscribe()
     * ```
     */ on(type, filter, callback) {
        const stateCheck = this.channelAdapter.isJoined() || this.channelAdapter.isJoining();
        const typeCheck = type === $0851918337283a61$export$9e3fe8e487ef792e.PRESENCE || type === $0851918337283a61$export$9e3fe8e487ef792e.POSTGRES_CHANGES;
        if (stateCheck && typeCheck) {
            this.socket.log('channel', `cannot add \`${type}\` callbacks for ${this.topic} after \`subscribe()\`.`);
            throw new Error(`cannot add \`${type}\` callbacks for ${this.topic} after \`subscribe()\`.`);
        }
        return this._on(type, filter, callback);
    }
    /**
     * Sends a broadcast message explicitly via REST API.
     *
     * This method always uses the REST API endpoint regardless of WebSocket connection state.
     * Useful when you want to guarantee REST delivery or when gradually migrating from implicit REST fallback.
     *
     * @param event The name of the broadcast event
     * @param payload Payload to be sent (required)
     * @param opts Options including timeout
     * @returns Promise resolving to object with success status, and error details if failed
     *
     * @category Realtime
     */ async httpSend(event, payload, opts = {}) {
        var _a;
        if (payload === undefined || payload === null) return Promise.reject(new Error('Payload is required for httpSend()'));
        const headers = {
            apikey: this.socket.apiKey ? this.socket.apiKey : '',
            'Content-Type': 'application/json'
        };
        if (this.socket.accessTokenValue) headers['Authorization'] = `Bearer ${this.socket.accessTokenValue}`;
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
                messages: [
                    {
                        topic: this.subTopic,
                        event: event,
                        payload: payload,
                        private: this.private
                    }
                ]
            })
        };
        const response = await this._fetchWithTimeout(this.broadcastEndpointURL, options, (_a = opts.timeout) !== null && _a !== void 0 ? _a : this.timeout);
        if (response.status === 202) return {
            success: true
        };
        let errorMessage = response.statusText;
        try {
            const errorBody = await response.json();
            errorMessage = errorBody.error || errorBody.message || errorMessage;
        } catch (_b) {}
        return Promise.reject(new Error(errorMessage));
    }
    /**
     * Sends a message into the channel.
     *
     * @param args Arguments to send to channel
     * @param args.type The type of event to send
     * @param args.event The name of the event being sent
     * @param args.payload Payload to be sent
     * @param opts Options to be used during the send process
     *
     * @category Realtime
     *
     * @remarks
     * - When using REST you don't need to subscribe to the channel
     * - REST calls are only available from 2.37.0 onwards
     *
     * @example Send a message via websocket
     * ```js
     * const channel = supabase.channel('room1')
     *
     * channel.subscribe((status) => {
     *   if (status === 'SUBSCRIBED') {
     *     channel.send({
     *       type: 'broadcast',
     *       event: 'cursor-pos',
     *       payload: { x: Math.random(), y: Math.random() },
     *     })
     *   }
     * })
     * ```
     *
     * @exampleResponse Send a message via websocket
     * ```js
     * ok | timed out | error
     * ```
     *
     * @example Send a message via REST
     * ```js
     * supabase
     *   .channel('room1')
     *   .httpSend('cursor-pos', { x: Math.random(), y: Math.random() })
     * ```
     */ async send(args, opts = {}) {
        var _a, _b;
        if (!this.channelAdapter.canPush() && args.type === 'broadcast') {
            console.warn("Realtime send() is automatically falling back to REST API. This behavior will be deprecated in the future. Please use httpSend() explicitly for REST delivery.");
            const { event: event, payload: endpoint_payload } = args;
            const headers = {
                apikey: this.socket.apiKey ? this.socket.apiKey : '',
                'Content-Type': 'application/json'
            };
            if (this.socket.accessTokenValue) headers['Authorization'] = `Bearer ${this.socket.accessTokenValue}`;
            const options = {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({
                    messages: [
                        {
                            topic: this.subTopic,
                            event: event,
                            payload: endpoint_payload,
                            private: this.private
                        }
                    ]
                })
            };
            try {
                const response = await this._fetchWithTimeout(this.broadcastEndpointURL, options, (_a = opts.timeout) !== null && _a !== void 0 ? _a : this.timeout);
                await ((_b = response.body) === null || _b === void 0 ? void 0 : _b.cancel());
                return response.ok ? 'ok' : 'error';
            } catch (error) {
                if (error instanceof Error && error.name === 'AbortError') return 'timed out';
                else return 'error';
            }
        } else return new Promise((resolve)=>{
            var _a, _b, _c;
            const push = this.channelAdapter.push(args.type, args, opts.timeout || this.timeout);
            if (args.type === 'broadcast' && !((_c = (_b = (_a = this.params) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.broadcast) === null || _c === void 0 ? void 0 : _c.ack)) resolve('ok');
            push.receive('ok', ()=>resolve('ok'));
            push.receive('error', ()=>resolve('error'));
            push.receive('timeout', ()=>resolve('timed out'));
        });
    }
    /**
     * Updates the payload that will be sent the next time the channel joins (reconnects).
     * Useful for rotating access tokens or updating config without re-creating the channel.
     *
     * @category Realtime
     */ updateJoinPayload(payload) {
        this.channelAdapter.updateJoinPayload(payload);
    }
    /**
     * Leaves the channel.
     *
     * Unsubscribes from server events, and instructs channel to terminate on server.
     * Triggers onClose() hooks.
     *
     * To receive leave acknowledgements, use the a `receive` hook to bind to the server ack, ie:
     * channel.unsubscribe().receive("ok", () => alert("left!") )
     *
     * @category Realtime
     */ async unsubscribe(timeout = this.timeout) {
        return new Promise((resolve)=>{
            this.channelAdapter.unsubscribe(timeout).receive('ok', ()=>resolve('ok')).receive('timeout', ()=>resolve('timed out')).receive('error', ()=>resolve('error'));
        });
    }
    /**
     * Destroys and stops related timers.
     *
     * @category Realtime
     */ teardown() {
        this.channelAdapter.teardown();
    }
    /** @internal */ async _fetchWithTimeout(url, options, timeout) {
        const controller = new AbortController();
        const id = setTimeout(()=>controller.abort(), timeout);
        const response = await this.socket.fetch(url, Object.assign(Object.assign({}, options), {
            signal: controller.signal
        }));
        clearTimeout(id);
        return response;
    }
    /** @internal */ _on(type, filter, callback) {
        const typeLower = type.toLocaleLowerCase();
        const ref = this.channelAdapter.on(type, callback);
        const binding = {
            type: typeLower,
            filter: filter,
            callback: callback,
            ref: ref
        };
        if (this.bindings[typeLower]) this.bindings[typeLower].push(binding);
        else this.bindings[typeLower] = [
            binding
        ];
        this._updateFilterMessage();
        return this;
    }
    /**
     * Registers a callback that will be executed when the channel closes.
     *
     * @internal
     */ _onClose(callback) {
        this.channelAdapter.onClose(callback);
    }
    /**
     * Registers a callback that will be executed when the channel encounteres an error.
     *
     * @internal
     */ _onError(callback) {
        this.channelAdapter.onError(callback);
    }
    /** @internal */ _updateFilterMessage() {
        this.channelAdapter.updateFilterBindings((binding, payload, ref)=>{
            var _a, _b, _c, _d, _e, _f, _g;
            const typeLower = binding.event.toLocaleLowerCase();
            if (this._notThisChannelEvent(typeLower, ref)) return false;
            const bind = (_a = this.bindings[typeLower]) === null || _a === void 0 ? void 0 : _a.find((bind)=>bind.ref === binding.ref);
            if (!bind) return true;
            if ([
                'broadcast',
                'presence',
                'postgres_changes'
            ].includes(typeLower)) {
                if ('id' in bind) {
                    const bindId = bind.id;
                    const bindEvent = (_b = bind.filter) === null || _b === void 0 ? void 0 : _b.event;
                    return bindId && ((_c = payload.ids) === null || _c === void 0 ? void 0 : _c.includes(bindId)) && (bindEvent === '*' || (bindEvent === null || bindEvent === void 0 ? void 0 : bindEvent.toLocaleLowerCase()) === ((_d = payload.data) === null || _d === void 0 ? void 0 : _d.type.toLocaleLowerCase()));
                } else {
                    const bindEvent = (_f = (_e = bind === null || bind === void 0 ? void 0 : bind.filter) === null || _e === void 0 ? void 0 : _e.event) === null || _f === void 0 ? void 0 : _f.toLocaleLowerCase();
                    return bindEvent === '*' || bindEvent === ((_g = payload === null || payload === void 0 ? void 0 : payload.event) === null || _g === void 0 ? void 0 : _g.toLocaleLowerCase());
                }
            } else return bind.type.toLocaleLowerCase() === typeLower;
        });
    }
    /** @internal */ _notThisChannelEvent(event, ref) {
        const { close: close, error: error, leave: leave, join: join } = (0, $5gqEk.CHANNEL_EVENTS);
        const events = [
            close,
            error,
            leave,
            join
        ];
        return ref && events.includes(event) && ref !== this.joinPush.ref;
    }
    /** @internal */ _updateFilterTransform() {
        this.channelAdapter.updatePayloadTransform((event, payload, ref)=>{
            if (typeof payload === 'object' && 'ids' in payload) {
                const postgresChanges = payload.data;
                const { schema: schema, table: table, commit_timestamp: commit_timestamp, type: type, errors: errors } = postgresChanges;
                const enrichedPayload = {
                    schema: schema,
                    table: table,
                    commit_timestamp: commit_timestamp,
                    eventType: type,
                    new: {},
                    old: {},
                    errors: errors
                };
                return Object.assign(Object.assign({}, enrichedPayload), this._getPayloadRecords(postgresChanges));
            }
            return payload;
        });
    }
    copyBindings(other) {
        if (this.joinedOnce) throw new Error('cannot copy bindings into joined channel');
        for(const kind in other.bindings)for (const binding of other.bindings[kind])this._on(binding.type, binding.filter, binding.callback);
    }
    /**
     * Compares two optional filter values for equality.
     * Treats undefined, null, and empty string as equivalent empty values.
     * @internal
     */ static isFilterValueEqual(serverValue, clientValue) {
        const normalizedServer = serverValue !== null && serverValue !== void 0 ? serverValue : undefined;
        const normalizedClient = clientValue !== null && clientValue !== void 0 ? clientValue : undefined;
        return normalizedServer === normalizedClient;
    }
    /** @internal */ _getPayloadRecords(payload) {
        const records = {
            new: {},
            old: {}
        };
        if (payload.type === 'INSERT' || payload.type === 'UPDATE') records.new = $5po7o.convertChangeData(payload.columns, payload.record);
        if (payload.type === 'UPDATE' || payload.type === 'DELETE') records.old = $5po7o.convertChangeData(payload.columns, payload.old_record);
        return records;
    }
}

});
parcelRegister("6zp63", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c897aa496ab948f$export$2e2bcd8739ae039);
/*
  This file draws heavily from https://github.com/phoenixframework/phoenix/blob/d344ec0a732ab4ee204215b31de69cf4be72e3bf/assets/js/phoenix/presence.js
  License: https://github.com/phoenixframework/phoenix/blob/d344ec0a732ab4ee204215b31de69cf4be72e3bf/LICENSE.md
*/ 
var $4YKUg = parcelRequire("4YKUg");
var $4c897aa496ab948f$export$f1ce049df2794fb4;
(function(REALTIME_PRESENCE_LISTEN_EVENTS) {
    REALTIME_PRESENCE_LISTEN_EVENTS["SYNC"] = "sync";
    REALTIME_PRESENCE_LISTEN_EVENTS["JOIN"] = "join";
    REALTIME_PRESENCE_LISTEN_EVENTS["LEAVE"] = "leave";
})($4c897aa496ab948f$export$f1ce049df2794fb4 || ($4c897aa496ab948f$export$f1ce049df2794fb4 = {}));
class $4c897aa496ab948f$export$2e2bcd8739ae039 {
    get state() {
        return this.presenceAdapter.state;
    }
    /**
     * Creates a Presence helper that keeps the local presence state in sync with the server.
     *
     * @param channel - The realtime channel to bind to.
     * @param opts - Optional custom event names, e.g. `{ events: { state: 'state', diff: 'diff' } }`.
     *
     * @category Realtime
     *
     * @example Example for a presence channel
     * ```ts
     * const presence = new RealtimePresence(channel)
     *
     * channel.on('presence', ({ event, key }) => {
     *   console.log(`Presence ${event} on ${key}`)
     * })
     * ```
     */ constructor(channel, opts){
        this.channel = channel;
        this.presenceAdapter = new (0, $4YKUg.default)(this.channel.channelAdapter, opts);
    }
}

});
parcelRegister("4YKUg", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a0126ade0ecba43$export$2e2bcd8739ae039);

var $gS6ap = parcelRequire("gS6ap");
class $3a0126ade0ecba43$export$2e2bcd8739ae039 {
    constructor(channel, opts){
        const phoenixOptions = $3a0126ade0ecba43$var$phoenixPresenceOptions(opts);
        this.presence = new (0, $gS6ap.Presence)(channel.getChannel(), phoenixOptions);
        this.presence.onJoin((key, currentPresence, newPresence)=>{
            const onJoinPayload = $3a0126ade0ecba43$export$2e2bcd8739ae039.onJoinPayload(key, currentPresence, newPresence);
            channel.getChannel().trigger('presence', onJoinPayload);
        });
        this.presence.onLeave((key, currentPresence, leftPresence)=>{
            const onLeavePayload = $3a0126ade0ecba43$export$2e2bcd8739ae039.onLeavePayload(key, currentPresence, leftPresence);
            channel.getChannel().trigger('presence', onLeavePayload);
        });
        this.presence.onSync(()=>{
            channel.getChannel().trigger('presence', {
                event: 'sync'
            });
        });
    }
    get state() {
        return $3a0126ade0ecba43$export$2e2bcd8739ae039.transformState(this.presence.state);
    }
    /**
     * @private
     * Remove 'metas' key
     * Change 'phx_ref' to 'presence_ref'
     * Remove 'phx_ref' and 'phx_ref_prev'
     *
     * @example Transform state
     * // returns {
     *  abc123: [
     *    { presence_ref: '2', user_id: 1 },
     *    { presence_ref: '3', user_id: 2 }
     *  ]
     * }
     * RealtimePresence.transformState({
     *  abc123: {
     *    metas: [
     *      { phx_ref: '2', phx_ref_prev: '1' user_id: 1 },
     *      { phx_ref: '3', user_id: 2 }
     *    ]
     *  }
     * })
     *
     */ static transformState(state) {
        state = $3a0126ade0ecba43$var$cloneState(state);
        return Object.getOwnPropertyNames(state).reduce((newState, key)=>{
            const presences = state[key];
            newState[key] = $3a0126ade0ecba43$var$transformState(presences);
            return newState;
        }, {});
    }
    static onJoinPayload(key, currentPresence, newPresence) {
        const currentPresences = $3a0126ade0ecba43$var$parseCurrentPresences(currentPresence);
        const newPresences = $3a0126ade0ecba43$var$transformState(newPresence);
        return {
            event: 'join',
            key: key,
            currentPresences: currentPresences,
            newPresences: newPresences
        };
    }
    static onLeavePayload(key, currentPresence, leftPresence) {
        const currentPresences = $3a0126ade0ecba43$var$parseCurrentPresences(currentPresence);
        const leftPresences = $3a0126ade0ecba43$var$transformState(leftPresence);
        return {
            event: 'leave',
            key: key,
            currentPresences: currentPresences,
            leftPresences: leftPresences
        };
    }
}
function $3a0126ade0ecba43$var$transformState(presences) {
    return presences.metas.map((presence)=>{
        presence['presence_ref'] = presence['phx_ref'];
        delete presence['phx_ref'];
        delete presence['phx_ref_prev'];
        return presence;
    });
}
function $3a0126ade0ecba43$var$cloneState(state) {
    return JSON.parse(JSON.stringify(state));
}
function $3a0126ade0ecba43$var$phoenixPresenceOptions(opts) {
    return (opts === null || opts === void 0 ? void 0 : opts.events) && {
        events: opts.events
    };
}
function $3a0126ade0ecba43$var$parseCurrentPresences(currentPresences) {
    return (currentPresences === null || currentPresences === void 0 ? void 0 : currentPresences.metas) ? $3a0126ade0ecba43$var$transformState(currentPresences) : [];
}

});
parcelRegister("gS6ap", function(module, exports) {

$parcel$export(module.exports, "Presence", () => $af64141737efe14a$export$99c2b779aa4e8b8b);
$parcel$export(module.exports, "Socket", () => $af64141737efe14a$export$4798917dbf149b79);
// js/phoenix/utils.js
var $af64141737efe14a$var$closure = (value)=>{
    if (typeof value === "function") return /** @type {() => T} */ value;
    else {
        let closure2 = function() {
            return value;
        };
        return closure2;
    }
};
// js/phoenix/constants.js
var $af64141737efe14a$var$globalSelf = typeof self !== "undefined" ? self : null;
var $af64141737efe14a$var$phxWindow = typeof window !== "undefined" ? window : null;
var $af64141737efe14a$var$global = $af64141737efe14a$var$globalSelf || $af64141737efe14a$var$phxWindow || globalThis;
var $af64141737efe14a$var$DEFAULT_VSN = "2.0.0";
var $af64141737efe14a$var$DEFAULT_TIMEOUT = 1e4;
var $af64141737efe14a$var$WS_CLOSE_NORMAL = 1e3;
var $af64141737efe14a$var$SOCKET_STATES = /** @type {const} */ {
    connecting: 0,
    open: 1,
    closing: 2,
    closed: 3
};
var $af64141737efe14a$var$CHANNEL_STATES = /** @type {const} */ {
    closed: "closed",
    errored: "errored",
    joined: "joined",
    joining: "joining",
    leaving: "leaving"
};
var $af64141737efe14a$var$CHANNEL_EVENTS = /** @type {const} */ {
    close: "phx_close",
    error: "phx_error",
    join: "phx_join",
    reply: "phx_reply",
    leave: "phx_leave"
};
var $af64141737efe14a$var$TRANSPORTS = /** @type {const} */ {
    longpoll: "longpoll",
    websocket: "websocket"
};
var $af64141737efe14a$var$XHR_STATES = /** @type {const} */ {
    complete: 4
};
var $af64141737efe14a$var$AUTH_TOKEN_PREFIX = "base64url.bearer.phx.";
// js/phoenix/push.js
var $af64141737efe14a$export$fb87db22c6b0e2ba = class {
    /**
   * Initializes the Push
   * @param {Channel} channel - The Channel
   * @param {ChannelEvent} event - The event, for example `"phx_join"`
   * @param {() => Record<string, unknown>} payload - The payload, for example `{user_id: 123}`
   * @param {number} timeout - The push timeout in milliseconds
   */ constructor(channel, event, payload, timeout){
        this.channel = channel;
        this.event = event;
        this.payload = payload || function() {
            return {};
        };
        this.receivedResp = null;
        this.timeout = timeout;
        this.timeoutTimer = null;
        this.recHooks = [];
        this.sent = false;
        this.ref = void 0;
    }
    /**
   *
   * @param {number} timeout
   */ resend(timeout) {
        this.timeout = timeout;
        this.reset();
        this.send();
    }
    /**
   *
   */ send() {
        if (this.hasReceived("timeout")) return;
        this.startTimeout();
        this.sent = true;
        this.channel.socket.push({
            topic: this.channel.topic,
            event: this.event,
            payload: this.payload(),
            ref: this.ref,
            join_ref: this.channel.joinRef()
        });
    }
    /**
   *
   * @param {string} status
   * @param {(response: any) => void} callback
   */ receive(status, callback) {
        if (this.hasReceived(status)) callback(this.receivedResp.response);
        this.recHooks.push({
            status: status,
            callback: callback
        });
        return this;
    }
    reset() {
        this.cancelRefEvent();
        this.ref = null;
        this.refEvent = null;
        this.receivedResp = null;
        this.sent = false;
    }
    destroy() {
        this.cancelRefEvent();
        this.cancelTimeout();
    }
    /**
   * @private
   */ matchReceive({ status: status, response: response, _ref: _ref }) {
        this.recHooks.filter((h)=>h.status === status).forEach((h)=>h.callback(response));
    }
    /**
   * @private
   */ cancelRefEvent() {
        if (!this.refEvent) return;
        this.channel.off(this.refEvent);
    }
    cancelTimeout() {
        clearTimeout(this.timeoutTimer);
        this.timeoutTimer = null;
    }
    startTimeout() {
        if (this.timeoutTimer) this.cancelTimeout();
        this.ref = this.channel.socket.makeRef();
        this.refEvent = this.channel.replyEventName(this.ref);
        this.channel.on(this.refEvent, (payload)=>{
            this.cancelRefEvent();
            this.cancelTimeout();
            this.receivedResp = payload;
            this.matchReceive(payload);
        });
        this.timeoutTimer = setTimeout(()=>{
            this.trigger("timeout", {});
        }, this.timeout);
    }
    /**
   * @private
   */ hasReceived(status) {
        return this.receivedResp && this.receivedResp.status === status;
    }
    trigger(status, response) {
        this.channel.trigger(this.refEvent, {
            status: status,
            response: response
        });
    }
};
// js/phoenix/timer.js
var $af64141737efe14a$export$c57e9b2d8b9e4de = class {
    /**
  * @param {() => void} callback
  * @param {(tries: number) => number} timerCalc
  */ constructor(callback, timerCalc){
        this.callback = callback;
        this.timerCalc = timerCalc;
        this.timer = void 0;
        this.tries = 0;
    }
    reset() {
        this.tries = 0;
        clearTimeout(this.timer);
    }
    /**
   * Cancels any previous scheduleTimeout and schedules callback
   */ scheduleTimeout() {
        clearTimeout(this.timer);
        this.timer = setTimeout(()=>{
            this.tries = this.tries + 1;
            this.callback();
        }, this.timerCalc(this.tries + 1));
    }
};
// js/phoenix/channel.js
var $af64141737efe14a$export$cfdacaa37f9b4dd7 = class {
    /**
   * @param {string} topic
   * @param {Params | (() => Params)} params
   * @param {Socket} socket
   */ constructor(topic, params, socket){
        this.state = $af64141737efe14a$var$CHANNEL_STATES.closed;
        this.topic = topic;
        this.params = $af64141737efe14a$var$closure(params || {});
        this.socket = socket;
        this.bindings = [];
        this.bindingRef = 0;
        this.timeout = this.socket.timeout;
        this.joinedOnce = false;
        this.joinPush = new $af64141737efe14a$export$fb87db22c6b0e2ba(this, $af64141737efe14a$var$CHANNEL_EVENTS.join, this.params, this.timeout);
        this.pushBuffer = [];
        this.stateChangeRefs = [];
        this.rejoinTimer = new $af64141737efe14a$export$c57e9b2d8b9e4de(()=>{
            if (this.socket.isConnected()) this.rejoin();
        }, this.socket.rejoinAfterMs);
        this.stateChangeRefs.push(this.socket.onError(()=>this.rejoinTimer.reset()));
        this.stateChangeRefs.push(this.socket.onOpen(()=>{
            this.rejoinTimer.reset();
            if (this.isErrored()) this.rejoin();
        }));
        this.joinPush.receive("ok", ()=>{
            this.state = $af64141737efe14a$var$CHANNEL_STATES.joined;
            this.rejoinTimer.reset();
            this.pushBuffer.forEach((pushEvent)=>pushEvent.send());
            this.pushBuffer = [];
        });
        this.joinPush.receive("error", (reason)=>{
            this.state = $af64141737efe14a$var$CHANNEL_STATES.errored;
            if (this.socket.hasLogger()) this.socket.log("channel", `error ${this.topic}`, reason);
            if (this.socket.isConnected()) this.rejoinTimer.scheduleTimeout();
        });
        this.onClose(()=>{
            this.rejoinTimer.reset();
            if (this.socket.hasLogger()) this.socket.log("channel", `close ${this.topic}`);
            this.state = $af64141737efe14a$var$CHANNEL_STATES.closed;
            this.socket.remove(this);
        });
        this.onError((reason)=>{
            if (this.socket.hasLogger()) this.socket.log("channel", `error ${this.topic}`, reason);
            if (this.isJoining()) this.joinPush.reset();
            this.state = $af64141737efe14a$var$CHANNEL_STATES.errored;
            if (this.socket.isConnected()) this.rejoinTimer.scheduleTimeout();
        });
        this.joinPush.receive("timeout", ()=>{
            if (this.socket.hasLogger()) this.socket.log("channel", `timeout ${this.topic}`, this.joinPush.timeout);
            let leavePush = new $af64141737efe14a$export$fb87db22c6b0e2ba(this, $af64141737efe14a$var$CHANNEL_EVENTS.leave, $af64141737efe14a$var$closure({}), this.timeout);
            leavePush.send();
            this.state = $af64141737efe14a$var$CHANNEL_STATES.errored;
            this.joinPush.reset();
            if (this.socket.isConnected()) this.rejoinTimer.scheduleTimeout();
        });
        this.on($af64141737efe14a$var$CHANNEL_EVENTS.reply, (payload, ref)=>{
            this.trigger(this.replyEventName(ref), payload);
        });
    }
    /**
   * Join the channel
   * @param {number} timeout
   * @returns {Push}
   */ join(timeout = this.timeout) {
        if (this.joinedOnce) throw new Error("tried to join multiple times. 'join' can only be called a single time per channel instance");
        else {
            this.timeout = timeout;
            this.joinedOnce = true;
            this.rejoin();
            return this.joinPush;
        }
    }
    /**
   * Teardown the channel.
   *
   * Destroys and stops related timers.
   */ teardown() {
        this.pushBuffer.forEach((push)=>push.destroy());
        this.pushBuffer = [];
        this.rejoinTimer.reset();
        this.joinPush.destroy();
        this.state = $af64141737efe14a$var$CHANNEL_STATES.closed;
        this.bindings = [];
    }
    /**
   * Hook into channel close
   * @param {ChannelBindingCallback} callback
   */ onClose(callback) {
        this.on($af64141737efe14a$var$CHANNEL_EVENTS.close, callback);
    }
    /**
   * Hook into channel errors
   * @param {ChannelOnErrorCallback} callback
   * @return {number}
   */ onError(callback) {
        return this.on($af64141737efe14a$var$CHANNEL_EVENTS.error, (reason)=>callback(reason));
    }
    /**
   * Subscribes on channel events
   *
   * Subscription returns a ref counter, which can be used later to
   * unsubscribe the exact event listener
   *
   * @example
   * const ref1 = channel.on("event", do_stuff)
   * const ref2 = channel.on("event", do_other_stuff)
   * channel.off("event", ref1)
   * // Since unsubscription, do_stuff won't fire,
   * // while do_other_stuff will keep firing on the "event"
   *
   * @param {string} event
   * @param {ChannelBindingCallback} callback
   * @returns {number} ref
   */ on(event, callback) {
        let ref = this.bindingRef++;
        this.bindings.push({
            event: event,
            ref: ref,
            callback: callback
        });
        return ref;
    }
    /**
   * Unsubscribes off of channel events
   *
   * Use the ref returned from a channel.on() to unsubscribe one
   * handler, or pass nothing for the ref to unsubscribe all
   * handlers for the given event.
   *
   * @example
   * // Unsubscribe the do_stuff handler
   * const ref1 = channel.on("event", do_stuff)
   * channel.off("event", ref1)
   *
   * // Unsubscribe all handlers from event
   * channel.off("event")
   *
   * @param {string} event
   * @param {number} [ref]
   */ off(event, ref) {
        this.bindings = this.bindings.filter((bind)=>{
            return !(bind.event === event && (typeof ref === "undefined" || ref === bind.ref));
        });
    }
    /**
   * @private
   */ canPush() {
        return this.socket.isConnected() && this.isJoined();
    }
    /**
   * Sends a message `event` to phoenix with the payload `payload`.
   * Phoenix receives this in the `handle_in(event, payload, socket)`
   * function. if phoenix replies or it times out (default 10000ms),
   * then optionally the reply can be received.
   *
   * @example
   * channel.push("event")
   *   .receive("ok", payload => console.log("phoenix replied:", payload))
   *   .receive("error", err => console.log("phoenix errored", err))
   *   .receive("timeout", () => console.log("timed out pushing"))
   * @param {string} event
   * @param {Object} payload
   * @param {number} [timeout]
   * @returns {Push}
   */ push(event, payload, timeout = this.timeout) {
        payload = payload || {};
        if (!this.joinedOnce) throw new Error(`tried to push '${event}' to '${this.topic}' before joining. Use channel.join() before pushing events`);
        let pushEvent = new $af64141737efe14a$export$fb87db22c6b0e2ba(this, event, function() {
            return payload;
        }, timeout);
        if (this.canPush()) pushEvent.send();
        else {
            pushEvent.startTimeout();
            this.pushBuffer.push(pushEvent);
        }
        return pushEvent;
    }
    /** Leaves the channel
   *
   * Unsubscribes from server events, and
   * instructs channel to terminate on server
   *
   * Triggers onClose() hooks
   *
   * To receive leave acknowledgements, use the `receive`
   * hook to bind to the server ack, ie:
   *
   * @example
   * channel.leave().receive("ok", () => alert("left!") )
   *
   * @param {number} timeout
   * @returns {Push}
   */ leave(timeout = this.timeout) {
        this.rejoinTimer.reset();
        this.joinPush.cancelTimeout();
        this.state = $af64141737efe14a$var$CHANNEL_STATES.leaving;
        let onClose = ()=>{
            if (this.socket.hasLogger()) this.socket.log("channel", `leave ${this.topic}`);
            this.trigger($af64141737efe14a$var$CHANNEL_EVENTS.close, "leave");
        };
        let leavePush = new $af64141737efe14a$export$fb87db22c6b0e2ba(this, $af64141737efe14a$var$CHANNEL_EVENTS.leave, $af64141737efe14a$var$closure({}), timeout);
        leavePush.receive("ok", ()=>onClose()).receive("timeout", ()=>onClose());
        leavePush.send();
        if (!this.canPush()) leavePush.trigger("ok", {});
        return leavePush;
    }
    /**
   * Overridable message hook
   *
   * Receives all events for specialized message handling
   * before dispatching to the channel callbacks.
   *
   * Must return the payload, modified or unmodified
   * @type{ChannelOnMessage}
   */ onMessage(_event, payload, _ref) {
        return payload;
    }
    /**
   * Overridable filter hook
   *
   * If this function returns `true`, `binding`'s callback will be called.
   *
   * @type{ChannelFilterBindings}
   */ filterBindings(_binding, _payload, _ref) {
        return true;
    }
    isMember(topic, event, payload, joinRef) {
        if (this.topic !== topic) return false;
        if (joinRef && joinRef !== this.joinRef()) {
            if (this.socket.hasLogger()) this.socket.log("channel", "dropping outdated message", {
                topic: topic,
                event: event,
                payload: payload,
                joinRef: joinRef
            });
            return false;
        } else return true;
    }
    joinRef() {
        return this.joinPush.ref;
    }
    /**
   * @private
   */ rejoin(timeout = this.timeout) {
        if (this.isLeaving()) return;
        this.socket.leaveOpenTopic(this.topic);
        this.state = $af64141737efe14a$var$CHANNEL_STATES.joining;
        this.joinPush.resend(timeout);
    }
    /**
   * @param {string} event
   * @param {unknown} [payload]
   * @param {?string} [ref]
   * @param {?string} [joinRef]
   */ trigger(event, payload, ref, joinRef) {
        let handledPayload = this.onMessage(event, payload, ref, joinRef);
        if (payload && !handledPayload) throw new Error("channel onMessage callbacks must return the payload, modified or unmodified");
        let eventBindings = this.bindings.filter((bind)=>bind.event === event && this.filterBindings(bind, payload, ref));
        for(let i = 0; i < eventBindings.length; i++){
            let bind = eventBindings[i];
            bind.callback(handledPayload, ref, joinRef || this.joinRef());
        }
    }
    /**
  * @param {string} ref
  */ replyEventName(ref) {
        return `chan_reply_${ref}`;
    }
    isClosed() {
        return this.state === $af64141737efe14a$var$CHANNEL_STATES.closed;
    }
    isErrored() {
        return this.state === $af64141737efe14a$var$CHANNEL_STATES.errored;
    }
    isJoined() {
        return this.state === $af64141737efe14a$var$CHANNEL_STATES.joined;
    }
    isJoining() {
        return this.state === $af64141737efe14a$var$CHANNEL_STATES.joining;
    }
    isLeaving() {
        return this.state === $af64141737efe14a$var$CHANNEL_STATES.leaving;
    }
};
// js/phoenix/ajax.js
var $af64141737efe14a$var$Ajax = class {
    static request(method, endPoint, headers, body, timeout, ontimeout, callback) {
        if ($af64141737efe14a$var$global.XDomainRequest) {
            let req = new $af64141737efe14a$var$global.XDomainRequest();
            return this.xdomainRequest(req, method, endPoint, body, timeout, ontimeout, callback);
        } else if ($af64141737efe14a$var$global.XMLHttpRequest) {
            let req = new $af64141737efe14a$var$global.XMLHttpRequest();
            return this.xhrRequest(req, method, endPoint, headers, body, timeout, ontimeout, callback);
        } else if ($af64141737efe14a$var$global.fetch && $af64141737efe14a$var$global.AbortController) return this.fetchRequest(method, endPoint, headers, body, timeout, ontimeout, callback);
        else throw new Error("No suitable XMLHttpRequest implementation found");
    }
    static fetchRequest(method, endPoint, headers, body, timeout, ontimeout, callback) {
        let options = {
            method: method,
            headers: headers,
            body: body
        };
        let controller = null;
        if (timeout) {
            controller = new AbortController();
            const _timeoutId = setTimeout(()=>controller.abort(), timeout);
            options.signal = controller.signal;
        }
        $af64141737efe14a$var$global.fetch(endPoint, options).then((response)=>response.text()).then((data)=>this.parseJSON(data)).then((data)=>callback && callback(data)).catch((err)=>{
            if (err.name === "AbortError" && ontimeout) ontimeout();
            else callback && callback(null);
        });
        return controller;
    }
    static xdomainRequest(req, method, endPoint, body, timeout, ontimeout, callback) {
        req.timeout = timeout;
        req.open(method, endPoint);
        req.onload = ()=>{
            let response = this.parseJSON(req.responseText);
            callback && callback(response);
        };
        if (ontimeout) req.ontimeout = ontimeout;
        req.onprogress = ()=>{};
        req.send(body);
        return req;
    }
    static xhrRequest(req, method, endPoint, headers, body, timeout, ontimeout, callback) {
        req.open(method, endPoint, true);
        req.timeout = timeout;
        for (let [key, value] of Object.entries(headers))req.setRequestHeader(key, value);
        req.onerror = ()=>callback && callback(null);
        req.onreadystatechange = ()=>{
            if (req.readyState === $af64141737efe14a$var$XHR_STATES.complete && callback) {
                let response = this.parseJSON(req.responseText);
                callback(response);
            }
        };
        if (ontimeout) req.ontimeout = ontimeout;
        req.send(body);
        return req;
    }
    static parseJSON(resp) {
        if (!resp || resp === "") return null;
        try {
            return JSON.parse(resp);
        } catch  {
            console && console.log("failed to parse JSON response", resp);
            return null;
        }
    }
    static serialize(obj, parentKey) {
        let queryStr = [];
        for(var key in obj){
            if (!Object.prototype.hasOwnProperty.call(obj, key)) continue;
            let paramKey = parentKey ? `${parentKey}[${key}]` : key;
            let paramVal = obj[key];
            if (typeof paramVal === "object") queryStr.push(this.serialize(paramVal, paramKey));
            else queryStr.push(encodeURIComponent(paramKey) + "=" + encodeURIComponent(paramVal));
        }
        return queryStr.join("&");
    }
    static appendParams(url, params) {
        if (Object.keys(params).length === 0) return url;
        let prefix = url.match(/\?/) ? "&" : "?";
        return `${url}${prefix}${this.serialize(params)}`;
    }
};
// js/phoenix/longpoll.js
var $af64141737efe14a$var$arrayBufferToBase64 = (buffer)=>{
    let binary = "";
    let bytes = new Uint8Array(buffer);
    let len = bytes.byteLength;
    for(let i = 0; i < len; i++)binary += String.fromCharCode(bytes[i]);
    return btoa(binary);
};
var $af64141737efe14a$export$57a2cdf8ead4f893 = class {
    constructor(endPoint, protocols){
        if (protocols && protocols.length === 2 && protocols[1].startsWith($af64141737efe14a$var$AUTH_TOKEN_PREFIX)) this.authToken = atob(protocols[1].slice($af64141737efe14a$var$AUTH_TOKEN_PREFIX.length));
        this.endPoint = null;
        this.token = null;
        this.skipHeartbeat = true;
        this.reqs = /* @__PURE__ */ new Set();
        this.awaitingBatchAck = false;
        this.currentBatch = null;
        this.currentBatchTimer = null;
        this.batchBuffer = [];
        this.onopen = function() {};
        this.onerror = function() {};
        this.onmessage = function() {};
        this.onclose = function() {};
        this.pollEndpoint = this.normalizeEndpoint(endPoint);
        this.readyState = $af64141737efe14a$var$SOCKET_STATES.connecting;
        setTimeout(()=>this.poll(), 0);
    }
    normalizeEndpoint(endPoint) {
        return endPoint.replace("ws://", "http://").replace("wss://", "https://").replace(new RegExp("(.*)/" + $af64141737efe14a$var$TRANSPORTS.websocket), "$1/" + $af64141737efe14a$var$TRANSPORTS.longpoll);
    }
    endpointURL() {
        return $af64141737efe14a$var$Ajax.appendParams(this.pollEndpoint, {
            token: this.token
        });
    }
    closeAndRetry(code, reason, wasClean) {
        this.close(code, reason, wasClean);
        this.readyState = $af64141737efe14a$var$SOCKET_STATES.connecting;
    }
    ontimeout() {
        this.onerror("timeout");
        this.closeAndRetry(1005, "timeout", false);
    }
    isActive() {
        return this.readyState === $af64141737efe14a$var$SOCKET_STATES.open || this.readyState === $af64141737efe14a$var$SOCKET_STATES.connecting;
    }
    poll() {
        const headers = {
            "Accept": "application/json"
        };
        if (this.authToken) headers["X-Phoenix-AuthToken"] = this.authToken;
        this.ajax("GET", headers, null, ()=>this.ontimeout(), (resp)=>{
            if (resp) {
                var { status: status, token: token, messages: messages } = resp;
                if (status === 410 && this.token !== null) {
                    this.onerror(410);
                    this.closeAndRetry(3410, "session_gone", false);
                    return;
                }
                this.token = token;
            } else status = 0;
            switch(status){
                case 200:
                    messages.forEach((msg)=>{
                        setTimeout(()=>this.onmessage({
                                data: msg
                            }), 0);
                    });
                    this.poll();
                    break;
                case 204:
                    this.poll();
                    break;
                case 410:
                    this.readyState = $af64141737efe14a$var$SOCKET_STATES.open;
                    this.onopen({});
                    this.poll();
                    break;
                case 403:
                    this.onerror(403);
                    this.close(1008, "forbidden", false);
                    break;
                case 0:
                case 500:
                    this.onerror(500);
                    this.closeAndRetry(1011, "internal server error", 500);
                    break;
                default:
                    throw new Error(`unhandled poll status ${status}`);
            }
        });
    }
    // we collect all pushes within the current event loop by
    // setTimeout 0, which optimizes back-to-back procedural
    // pushes against an empty buffer
    send(body) {
        if (typeof body !== "string") body = $af64141737efe14a$var$arrayBufferToBase64(body);
        if (this.currentBatch) this.currentBatch.push(body);
        else if (this.awaitingBatchAck) this.batchBuffer.push(body);
        else {
            this.currentBatch = [
                body
            ];
            this.currentBatchTimer = setTimeout(()=>{
                this.batchSend(this.currentBatch);
                this.currentBatch = null;
            }, 0);
        }
    }
    batchSend(messages) {
        this.awaitingBatchAck = true;
        this.ajax("POST", {
            "Content-Type": "application/x-ndjson"
        }, messages.join("\n"), ()=>this.onerror("timeout"), (resp)=>{
            this.awaitingBatchAck = false;
            if (!resp || resp.status !== 200) {
                this.onerror(resp && resp.status);
                this.closeAndRetry(1011, "internal server error", false);
            } else if (this.batchBuffer.length > 0) {
                this.batchSend(this.batchBuffer);
                this.batchBuffer = [];
            }
        });
    }
    close(code, reason, wasClean) {
        for (let req of this.reqs)req.abort();
        this.readyState = $af64141737efe14a$var$SOCKET_STATES.closed;
        let opts = Object.assign({
            code: 1e3,
            reason: void 0,
            wasClean: true
        }, {
            code: code,
            reason: reason,
            wasClean: wasClean
        });
        this.batchBuffer = [];
        clearTimeout(this.currentBatchTimer);
        this.currentBatchTimer = null;
        if (typeof CloseEvent !== "undefined") this.onclose(new CloseEvent("close", opts));
        else this.onclose(opts);
    }
    ajax(method, headers, body, onCallerTimeout, callback) {
        let req;
        let ontimeout = ()=>{
            this.reqs.delete(req);
            onCallerTimeout();
        };
        req = $af64141737efe14a$var$Ajax.request(method, this.endpointURL(), headers, body, this.timeout, ontimeout, (resp)=>{
            this.reqs.delete(req);
            if (this.isActive()) callback(resp);
        });
        this.reqs.add(req);
    }
};
// js/phoenix/presence.js
var $af64141737efe14a$export$99c2b779aa4e8b8b = class _Presence {
    /**
   * Initializes the Presence
   * @param {Channel} channel - The Channel
   * @param {PresenceOptions} [opts] - The options, for example `{events: {state: "state", diff: "diff"}}`
   */ constructor(channel, opts = {}){
        let events = opts.events || /** @type {PresenceEvents} */ {
            state: "presence_state",
            diff: "presence_diff"
        };
        this.state = {};
        this.pendingDiffs = [];
        this.channel = channel;
        this.joinRef = null;
        this.caller = {
            onJoin: function() {},
            onLeave: function() {},
            onSync: function() {}
        };
        this.channel.on(events.state, (newState)=>{
            let { onJoin: onJoin, onLeave: onLeave, onSync: onSync } = this.caller;
            this.joinRef = this.channel.joinRef();
            this.state = _Presence.syncState(this.state, newState, onJoin, onLeave);
            this.pendingDiffs.forEach((diff)=>{
                this.state = _Presence.syncDiff(this.state, diff, onJoin, onLeave);
            });
            this.pendingDiffs = [];
            onSync();
        });
        this.channel.on(events.diff, (diff)=>{
            let { onJoin: onJoin, onLeave: onLeave, onSync: onSync } = this.caller;
            if (this.inPendingSyncState()) this.pendingDiffs.push(diff);
            else {
                this.state = _Presence.syncDiff(this.state, diff, onJoin, onLeave);
                onSync();
            }
        });
    }
    /**
   * @param {PresenceOnJoin} callback
   */ onJoin(callback) {
        this.caller.onJoin = callback;
    }
    /**
   * @param {PresenceOnLeave} callback
   */ onLeave(callback) {
        this.caller.onLeave = callback;
    }
    /**
   * @param {PresenceOnSync} callback
   */ onSync(callback) {
        this.caller.onSync = callback;
    }
    /**
   * Returns the array of presences, with selected metadata.
   *
   * @template [T=PresenceState]
   * @param {((key: string, obj: PresenceState) => T)} [by]
   *
   * @returns {T[]}
   */ list(by) {
        return _Presence.list(this.state, by);
    }
    inPendingSyncState() {
        return !this.joinRef || this.joinRef !== this.channel.joinRef();
    }
    // lower-level public static API
    /**
   * Used to sync the list of presences on the server
   * with the client's state. An optional `onJoin` and `onLeave` callback can
   * be provided to react to changes in the client's local presences across
   * disconnects and reconnects with the server.
   *
   * @param {Record<string, PresenceState>} currentState
   * @param {Record<string, PresenceState>} newState
   * @param {PresenceOnJoin} onJoin
   * @param {PresenceOnLeave} onLeave
   *
   * @returns {Record<string, PresenceState>}
   */ static syncState(currentState, newState, onJoin, onLeave) {
        let state = this.clone(currentState);
        let joins = {};
        let leaves = {};
        this.map(state, (key, presence)=>{
            if (!newState[key]) leaves[key] = presence;
        });
        this.map(newState, (key, newPresence)=>{
            let currentPresence = state[key];
            if (currentPresence) {
                let newRefs = newPresence.metas.map((m)=>m.phx_ref);
                let curRefs = currentPresence.metas.map((m)=>m.phx_ref);
                let joinedMetas = newPresence.metas.filter((m)=>curRefs.indexOf(m.phx_ref) < 0);
                let leftMetas = currentPresence.metas.filter((m)=>newRefs.indexOf(m.phx_ref) < 0);
                if (joinedMetas.length > 0) {
                    joins[key] = newPresence;
                    joins[key].metas = joinedMetas;
                }
                if (leftMetas.length > 0) {
                    leaves[key] = this.clone(currentPresence);
                    leaves[key].metas = leftMetas;
                }
            } else joins[key] = newPresence;
        });
        return this.syncDiff(state, {
            joins: joins,
            leaves: leaves
        }, onJoin, onLeave);
    }
    /**
   *
   * Used to sync a diff of presence join and leave
   * events from the server, as they happen. Like `syncState`, `syncDiff`
   * accepts optional `onJoin` and `onLeave` callbacks to react to a user
   * joining or leaving from a device.
   *
   * @param {Record<string, PresenceState>} state
   * @param {PresenceDiff} diff
   * @param {PresenceOnJoin} onJoin
   * @param {PresenceOnLeave} onLeave
   *
   * @returns {Record<string, PresenceState>}
   */ static syncDiff(state, diff, onJoin, onLeave) {
        let { joins: joins, leaves: leaves } = this.clone(diff);
        if (!onJoin) onJoin = function() {};
        if (!onLeave) onLeave = function() {};
        this.map(joins, (key, newPresence)=>{
            let currentPresence = state[key];
            state[key] = this.clone(newPresence);
            if (currentPresence) {
                let joinedRefs = state[key].metas.map((m)=>m.phx_ref);
                let curMetas = currentPresence.metas.filter((m)=>joinedRefs.indexOf(m.phx_ref) < 0);
                state[key].metas.unshift(...curMetas);
            }
            onJoin(key, currentPresence, newPresence);
        });
        this.map(leaves, (key, leftPresence)=>{
            let currentPresence = state[key];
            if (!currentPresence) return;
            let refsToRemove = leftPresence.metas.map((m)=>m.phx_ref);
            currentPresence.metas = currentPresence.metas.filter((p)=>{
                return refsToRemove.indexOf(p.phx_ref) < 0;
            });
            onLeave(key, currentPresence, leftPresence);
            if (currentPresence.metas.length === 0) delete state[key];
        });
        return state;
    }
    /**
   * Returns the array of presences, with selected metadata.
   *
   * @template [T=PresenceState]
   * @param {Record<string, PresenceState>} presences
   * @param {((key: string, obj: PresenceState) => T)} [chooser]
   *
   * @returns {T[]}
   */ static list(presences, chooser) {
        if (!chooser) chooser = function(key, pres) {
            return pres;
        };
        return this.map(presences, (key, presence)=>{
            return chooser(key, presence);
        });
    }
    // private
    /**
  * @template T
  * @param {Record<string, PresenceState>} obj
  * @param {(key: string, obj: PresenceState) => T} func
  */ static map(obj, func) {
        return Object.getOwnPropertyNames(obj).map((key)=>func(key, obj[key]));
    }
    /**
  * @template T
  * @param {T} obj
  * @returns {T}
  */ static clone(obj) {
        return JSON.parse(JSON.stringify(obj));
    }
};
// js/phoenix/serializer.js
var $af64141737efe14a$export$ef852775387a0be7 = {
    HEADER_LENGTH: 1,
    META_LENGTH: 4,
    KINDS: {
        push: 0,
        reply: 1,
        broadcast: 2
    },
    /**
  * @template T
  * @param {Message<Record<string, any>>} msg
  * @param {(msg: ArrayBuffer | string) => T} callback
  * @returns {T}
  */ encode (msg, callback) {
        if (msg.payload.constructor === ArrayBuffer) return callback(this.binaryEncode(msg));
        else {
            let payload = [
                msg.join_ref,
                msg.ref,
                msg.topic,
                msg.event,
                msg.payload
            ];
            return callback(JSON.stringify(payload));
        }
    },
    /**
  * @template T
  * @param {ArrayBuffer | string} rawPayload
  * @param {(msg: Message<unknown>) => T} callback
  * @returns {T}
  */ decode (rawPayload, callback) {
        if (rawPayload.constructor === ArrayBuffer) return callback(this.binaryDecode(rawPayload));
        else {
            let [join_ref, ref, topic, event, payload] = JSON.parse(rawPayload);
            return callback({
                join_ref: join_ref,
                ref: ref,
                topic: topic,
                event: event,
                payload: payload
            });
        }
    },
    /** @private */ binaryEncode (message) {
        let { join_ref: join_ref, ref: ref, event: event, topic: topic, payload: payload } = message;
        let metaLength = this.META_LENGTH + join_ref.length + ref.length + topic.length + event.length;
        let header = new ArrayBuffer(this.HEADER_LENGTH + metaLength);
        let view = new DataView(header);
        let offset = 0;
        view.setUint8(offset++, this.KINDS.push);
        view.setUint8(offset++, join_ref.length);
        view.setUint8(offset++, ref.length);
        view.setUint8(offset++, topic.length);
        view.setUint8(offset++, event.length);
        Array.from(join_ref, (char)=>view.setUint8(offset++, char.charCodeAt(0)));
        Array.from(ref, (char)=>view.setUint8(offset++, char.charCodeAt(0)));
        Array.from(topic, (char)=>view.setUint8(offset++, char.charCodeAt(0)));
        Array.from(event, (char)=>view.setUint8(offset++, char.charCodeAt(0)));
        var combined = new Uint8Array(header.byteLength + payload.byteLength);
        combined.set(new Uint8Array(header), 0);
        combined.set(new Uint8Array(payload), header.byteLength);
        return combined.buffer;
    },
    /**
  * @private
  */ binaryDecode (buffer) {
        let view = new DataView(buffer);
        let kind = view.getUint8(0);
        let decoder = new TextDecoder();
        switch(kind){
            case this.KINDS.push:
                return this.decodePush(buffer, view, decoder);
            case this.KINDS.reply:
                return this.decodeReply(buffer, view, decoder);
            case this.KINDS.broadcast:
                return this.decodeBroadcast(buffer, view, decoder);
        }
    },
    /** @private */ decodePush (buffer, view, decoder) {
        let joinRefSize = view.getUint8(1);
        let topicSize = view.getUint8(2);
        let eventSize = view.getUint8(3);
        let offset = this.HEADER_LENGTH + this.META_LENGTH - 1;
        let joinRef = decoder.decode(buffer.slice(offset, offset + joinRefSize));
        offset = offset + joinRefSize;
        let topic = decoder.decode(buffer.slice(offset, offset + topicSize));
        offset = offset + topicSize;
        let event = decoder.decode(buffer.slice(offset, offset + eventSize));
        offset = offset + eventSize;
        let data = buffer.slice(offset, buffer.byteLength);
        return {
            join_ref: joinRef,
            ref: null,
            topic: topic,
            event: event,
            payload: data
        };
    },
    /** @private */ decodeReply (buffer, view, decoder) {
        let joinRefSize = view.getUint8(1);
        let refSize = view.getUint8(2);
        let topicSize = view.getUint8(3);
        let eventSize = view.getUint8(4);
        let offset = this.HEADER_LENGTH + this.META_LENGTH;
        let joinRef = decoder.decode(buffer.slice(offset, offset + joinRefSize));
        offset = offset + joinRefSize;
        let ref = decoder.decode(buffer.slice(offset, offset + refSize));
        offset = offset + refSize;
        let topic = decoder.decode(buffer.slice(offset, offset + topicSize));
        offset = offset + topicSize;
        let event = decoder.decode(buffer.slice(offset, offset + eventSize));
        offset = offset + eventSize;
        let data = buffer.slice(offset, buffer.byteLength);
        let payload = {
            status: event,
            response: data
        };
        return {
            join_ref: joinRef,
            ref: ref,
            topic: topic,
            event: $af64141737efe14a$var$CHANNEL_EVENTS.reply,
            payload: payload
        };
    },
    /** @private */ decodeBroadcast (buffer, view, decoder) {
        let topicSize = view.getUint8(1);
        let eventSize = view.getUint8(2);
        let offset = this.HEADER_LENGTH + 2;
        let topic = decoder.decode(buffer.slice(offset, offset + topicSize));
        offset = offset + topicSize;
        let event = decoder.decode(buffer.slice(offset, offset + eventSize));
        offset = offset + eventSize;
        let data = buffer.slice(offset, buffer.byteLength);
        return {
            join_ref: null,
            ref: null,
            topic: topic,
            event: event,
            payload: data
        };
    }
};
// js/phoenix/socket.js
var $af64141737efe14a$export$4798917dbf149b79 = class {
    /** Initializes the Socket *
   *
   * For IE8 support use an ES5-shim (https://github.com/es-shims/es5-shim)
   *
   * @constructor
   * @param {string} endPoint - The string WebSocket endpoint, ie, `"ws://example.com/socket"`,
   *                                               `"wss://example.com"`
   *                                               `"/socket"` (inherited host & protocol)
   * @param {SocketOptions} [opts] - Optional configuration
   */ constructor(endPoint, opts = {}){
        this.stateChangeCallbacks = {
            open: [],
            close: [],
            error: [],
            message: []
        };
        this.channels = [];
        this.sendBuffer = [];
        this.ref = 0;
        this.fallbackRef = null;
        this.timeout = opts.timeout || $af64141737efe14a$var$DEFAULT_TIMEOUT;
        this.transport = opts.transport || $af64141737efe14a$var$global.WebSocket || $af64141737efe14a$export$57a2cdf8ead4f893;
        this.conn = void 0;
        this.primaryPassedHealthCheck = false;
        this.longPollFallbackMs = opts.longPollFallbackMs;
        this.fallbackTimer = null;
        this.sessionStore = opts.sessionStorage || $af64141737efe14a$var$global && $af64141737efe14a$var$global.sessionStorage;
        this.establishedConnections = 0;
        this.defaultEncoder = $af64141737efe14a$export$ef852775387a0be7.encode.bind($af64141737efe14a$export$ef852775387a0be7);
        this.defaultDecoder = $af64141737efe14a$export$ef852775387a0be7.decode.bind($af64141737efe14a$export$ef852775387a0be7);
        this.closeWasClean = true;
        this.disconnecting = false;
        this.binaryType = opts.binaryType || "arraybuffer";
        this.connectClock = 1;
        this.pageHidden = false;
        this.encode = void 0;
        this.decode = void 0;
        if (this.transport !== $af64141737efe14a$export$57a2cdf8ead4f893) {
            this.encode = opts.encode || this.defaultEncoder;
            this.decode = opts.decode || this.defaultDecoder;
        } else {
            this.encode = this.defaultEncoder;
            this.decode = this.defaultDecoder;
        }
        let awaitingConnectionOnPageShow = null;
        if ($af64141737efe14a$var$phxWindow && $af64141737efe14a$var$phxWindow.addEventListener) {
            $af64141737efe14a$var$phxWindow.addEventListener("pagehide", (_e)=>{
                if (this.conn) {
                    this.disconnect();
                    awaitingConnectionOnPageShow = this.connectClock;
                }
            });
            $af64141737efe14a$var$phxWindow.addEventListener("pageshow", (_e)=>{
                if (awaitingConnectionOnPageShow === this.connectClock) {
                    awaitingConnectionOnPageShow = null;
                    this.connect();
                }
            });
            $af64141737efe14a$var$phxWindow.addEventListener("visibilitychange", ()=>{
                if (document.visibilityState === "hidden") this.pageHidden = true;
                else {
                    this.pageHidden = false;
                    if (!this.isConnected() && !this.closeWasClean) this.teardown(()=>this.connect());
                }
            });
        }
        this.heartbeatIntervalMs = opts.heartbeatIntervalMs || 3e4;
        this.autoSendHeartbeat = opts.autoSendHeartbeat ?? true;
        this.heartbeatCallback = opts.heartbeatCallback ?? (()=>{});
        this.rejoinAfterMs = (tries)=>{
            if (opts.rejoinAfterMs) return opts.rejoinAfterMs(tries);
            else return [
                1e3,
                2e3,
                5e3
            ][tries - 1] || 1e4;
        };
        this.reconnectAfterMs = (tries)=>{
            if (opts.reconnectAfterMs) return opts.reconnectAfterMs(tries);
            else return [
                10,
                50,
                100,
                150,
                200,
                250,
                500,
                1e3,
                2e3
            ][tries - 1] || 5e3;
        };
        this.logger = opts.logger || null;
        if (!this.logger && opts.debug) this.logger = (kind, msg, data)=>{
            console.log(`${kind}: ${msg}`, data);
        };
        this.longpollerTimeout = opts.longpollerTimeout || 2e4;
        this.params = $af64141737efe14a$var$closure(opts.params || {});
        this.endPoint = `${endPoint}/${$af64141737efe14a$var$TRANSPORTS.websocket}`;
        this.vsn = opts.vsn || $af64141737efe14a$var$DEFAULT_VSN;
        this.heartbeatTimeoutTimer = null;
        this.heartbeatTimer = null;
        this.heartbeatSentAt = null;
        this.pendingHeartbeatRef = null;
        this.reconnectTimer = new $af64141737efe14a$export$c57e9b2d8b9e4de(()=>{
            if (this.pageHidden) {
                this.log("Not reconnecting as page is hidden!");
                this.teardown();
                return;
            }
            this.teardown(async ()=>{
                if (opts.beforeReconnect) await opts.beforeReconnect();
                this.connect();
            });
        }, this.reconnectAfterMs);
        this.authToken = opts.authToken;
    }
    /**
   * Returns the LongPoll transport reference
   */ getLongPollTransport() {
        return $af64141737efe14a$export$57a2cdf8ead4f893;
    }
    /**
   * Disconnects and replaces the active transport
   *
   * @param {SocketTransport} newTransport - The new transport class to instantiate
   *
   */ replaceTransport(newTransport) {
        this.connectClock++;
        this.closeWasClean = true;
        clearTimeout(this.fallbackTimer);
        this.reconnectTimer.reset();
        if (this.conn) {
            this.conn.close();
            this.conn = null;
        }
        this.transport = newTransport;
    }
    /**
   * Returns the socket protocol
   *
   * @returns {"wss" | "ws"}
   */ protocol() {
        return location.protocol.match(/^https/) ? "wss" : "ws";
    }
    /**
   * The fully qualified socket url
   *
   * @returns {string}
   */ endPointURL() {
        let uri = $af64141737efe14a$var$Ajax.appendParams($af64141737efe14a$var$Ajax.appendParams(this.endPoint, this.params()), {
            vsn: this.vsn
        });
        if (uri.charAt(0) !== "/") return uri;
        if (uri.charAt(1) === "/") return `${this.protocol()}:${uri}`;
        return `${this.protocol()}://${location.host}${uri}`;
    }
    /**
   * Disconnects the socket
   *
   * See https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent#Status_codes for valid status codes.
   *
   * @param {() => void} [callback] - Optional callback which is called after socket is disconnected.
   * @param {number} [code] - A status code for disconnection (Optional).
   * @param {string} [reason] - A textual description of the reason to disconnect. (Optional)
   */ disconnect(callback, code, reason) {
        this.connectClock++;
        this.disconnecting = true;
        this.closeWasClean = true;
        clearTimeout(this.fallbackTimer);
        this.reconnectTimer.reset();
        this.teardown(()=>{
            this.disconnecting = false;
            callback && callback();
        }, code, reason);
    }
    /**
   * @param {Params} [params] - [DEPRECATED] The params to send when connecting, for example `{user_id: userToken}`
   *
   * Passing params to connect is deprecated; pass them in the Socket constructor instead:
   * `new Socket("/socket", {params: {user_id: userToken}})`.
   */ connect(params) {
        if (params) {
            console && console.log("passing params to connect is deprecated. Instead pass :params to the Socket constructor");
            this.params = $af64141737efe14a$var$closure(params);
        }
        if (this.conn && !this.disconnecting) return;
        if (this.longPollFallbackMs && this.transport !== $af64141737efe14a$export$57a2cdf8ead4f893) this.connectWithFallback($af64141737efe14a$export$57a2cdf8ead4f893, this.longPollFallbackMs);
        else this.transportConnect();
    }
    /**
   * Logs the message. Override `this.logger` for specialized logging. noops by default
   * @param {string} kind
   * @param {string} msg
   * @param {Object} data
   */ log(kind, msg, data) {
        this.logger && this.logger(kind, msg, data);
    }
    /**
   * Returns true if a logger has been set on this socket.
   */ hasLogger() {
        return this.logger !== null;
    }
    /**
   * Registers callbacks for connection open events
   *
   * @example socket.onOpen(function(){ console.info("the socket was opened") })
   *
   * @param {SocketOnOpen} callback
   */ onOpen(callback) {
        let ref = this.makeRef();
        this.stateChangeCallbacks.open.push([
            ref,
            callback
        ]);
        return ref;
    }
    /**
   * Registers callbacks for connection close events
   * @param {SocketOnClose} callback
   * @returns {string}
   */ onClose(callback) {
        let ref = this.makeRef();
        this.stateChangeCallbacks.close.push([
            ref,
            callback
        ]);
        return ref;
    }
    /**
   * Registers callbacks for connection error events
   *
   * @example socket.onError(function(error){ alert("An error occurred") })
   *
   * @param {SocketOnError} callback
   * @returns {string}
   */ onError(callback) {
        let ref = this.makeRef();
        this.stateChangeCallbacks.error.push([
            ref,
            callback
        ]);
        return ref;
    }
    /**
   * Registers callbacks for connection message events
   * @param {SocketOnMessage} callback
   * @returns {string}
   */ onMessage(callback) {
        let ref = this.makeRef();
        this.stateChangeCallbacks.message.push([
            ref,
            callback
        ]);
        return ref;
    }
    /**
   * Sets a callback that receives lifecycle events for internal heartbeat messages.
   * Useful for instrumenting connection health (e.g. sent/ok/timeout/disconnected).
   * @param {HeartbeatCallback} callback
   */ onHeartbeat(callback) {
        this.heartbeatCallback = callback;
    }
    /**
   * Pings the server and invokes the callback with the RTT in milliseconds
   * @param {(timeDelta: number) => void} callback
   *
   * Returns true if the ping was pushed or false if unable to be pushed.
   */ ping(callback) {
        if (!this.isConnected()) return false;
        let ref = this.makeRef();
        let startTime = Date.now();
        this.push({
            topic: "phoenix",
            event: "heartbeat",
            payload: {},
            ref: ref
        });
        let onMsgRef = this.onMessage((msg)=>{
            if (msg.ref === ref) {
                this.off([
                    onMsgRef
                ]);
                callback(Date.now() - startTime);
            }
        });
        return true;
    }
    /**
   * @private
   *
   * @param {Function}
   */ transportName(transport) {
        switch(transport){
            case $af64141737efe14a$export$57a2cdf8ead4f893:
                return "LongPoll";
            default:
                return transport.name;
        }
    }
    /**
   * @private
   */ transportConnect() {
        this.connectClock++;
        this.closeWasClean = false;
        let protocols = void 0;
        if (this.authToken) protocols = [
            "phoenix",
            `${$af64141737efe14a$var$AUTH_TOKEN_PREFIX}${btoa(this.authToken).replace(/=/g, "")}`
        ];
        this.conn = new this.transport(this.endPointURL(), protocols);
        this.conn.binaryType = this.binaryType;
        this.conn.timeout = this.longpollerTimeout;
        this.conn.onopen = ()=>this.onConnOpen();
        this.conn.onerror = (error)=>this.onConnError(error);
        this.conn.onmessage = (event)=>this.onConnMessage(event);
        this.conn.onclose = (event)=>this.onConnClose(event);
    }
    getSession(key) {
        return this.sessionStore && this.sessionStore.getItem(key);
    }
    storeSession(key, val) {
        this.sessionStore && this.sessionStore.setItem(key, val);
    }
    connectWithFallback(fallbackTransport, fallbackThreshold = 2500) {
        clearTimeout(this.fallbackTimer);
        let established = false;
        let primaryTransport = true;
        let openRef, errorRef;
        let fallbackTransportName = this.transportName(fallbackTransport);
        let fallback = (reason)=>{
            this.log("transport", `falling back to ${fallbackTransportName}...`, reason);
            this.off([
                openRef,
                errorRef
            ]);
            primaryTransport = false;
            this.replaceTransport(fallbackTransport);
            this.transportConnect();
        };
        if (this.getSession(`phx:fallback:${fallbackTransportName}`)) return fallback("memorized");
        this.fallbackTimer = setTimeout(fallback, fallbackThreshold);
        errorRef = this.onError((reason)=>{
            this.log("transport", "error", reason);
            if (primaryTransport && !established) {
                clearTimeout(this.fallbackTimer);
                fallback(reason);
            }
        });
        if (this.fallbackRef) this.off([
            this.fallbackRef
        ]);
        this.fallbackRef = this.onOpen(()=>{
            established = true;
            if (!primaryTransport) {
                let fallbackTransportName2 = this.transportName(fallbackTransport);
                if (!this.primaryPassedHealthCheck) this.storeSession(`phx:fallback:${fallbackTransportName2}`, "true");
                return this.log("transport", `established ${fallbackTransportName2} fallback`);
            }
            clearTimeout(this.fallbackTimer);
            this.fallbackTimer = setTimeout(fallback, fallbackThreshold);
            this.ping((rtt)=>{
                this.log("transport", "connected to primary after", rtt);
                this.primaryPassedHealthCheck = true;
                clearTimeout(this.fallbackTimer);
            });
        });
        this.transportConnect();
    }
    clearHeartbeats() {
        clearTimeout(this.heartbeatTimer);
        clearTimeout(this.heartbeatTimeoutTimer);
    }
    onConnOpen() {
        if (this.hasLogger()) this.log("transport", `connected to ${this.endPointURL()}`);
        this.closeWasClean = false;
        this.disconnecting = false;
        this.establishedConnections++;
        this.flushSendBuffer();
        this.reconnectTimer.reset();
        if (this.autoSendHeartbeat) this.resetHeartbeat();
        this.triggerStateCallbacks("open");
    }
    /**
   * @private
   */ heartbeatTimeout() {
        if (this.pendingHeartbeatRef) {
            this.pendingHeartbeatRef = null;
            this.heartbeatSentAt = null;
            if (this.hasLogger()) this.log("transport", "heartbeat timeout. Attempting to re-establish connection");
            try {
                this.heartbeatCallback("timeout");
            } catch (e) {
                this.log("error", "error in heartbeat callback", e);
            }
            this.triggerChanError(new Error("heartbeat timeout"));
            this.closeWasClean = false;
            this.teardown(()=>this.reconnectTimer.scheduleTimeout(), $af64141737efe14a$var$WS_CLOSE_NORMAL, "heartbeat timeout");
        }
    }
    resetHeartbeat() {
        if (this.conn && this.conn.skipHeartbeat) return;
        this.pendingHeartbeatRef = null;
        this.clearHeartbeats();
        this.heartbeatTimer = setTimeout(()=>this.sendHeartbeat(), this.heartbeatIntervalMs);
    }
    teardown(callback, code, reason) {
        if (!this.conn) return callback && callback();
        const connToClose = this.conn;
        this.waitForBufferDone(connToClose, ()=>{
            if (code) connToClose.close(code, reason || "");
            else connToClose.close();
            this.waitForSocketClosed(connToClose, ()=>{
                if (this.conn === connToClose) {
                    this.conn.onopen = function() {};
                    this.conn.onerror = function() {};
                    this.conn.onmessage = function() {};
                    this.conn.onclose = function() {};
                    this.conn = null;
                }
                callback && callback();
            });
        });
    }
    waitForBufferDone(conn, callback, tries = 1) {
        if (tries === 5 || !conn.bufferedAmount) {
            callback();
            return;
        }
        setTimeout(()=>{
            this.waitForBufferDone(conn, callback, tries + 1);
        }, 150 * tries);
    }
    waitForSocketClosed(conn, callback, tries = 1) {
        if (tries === 5 || conn.readyState === $af64141737efe14a$var$SOCKET_STATES.closed) {
            callback();
            return;
        }
        setTimeout(()=>{
            this.waitForSocketClosed(conn, callback, tries + 1);
        }, 150 * tries);
    }
    /**
  * @param {CloseEvent} event
  */ onConnClose(event) {
        if (this.conn) this.conn.onclose = ()=>{};
        if (this.hasLogger()) this.log("transport", "close", event);
        this.triggerChanError(event);
        this.clearHeartbeats();
        if (!this.closeWasClean) this.reconnectTimer.scheduleTimeout();
        this.triggerStateCallbacks("close", event);
    }
    /**
   * @private
   * @param {Event} error
   */ onConnError(error) {
        if (this.hasLogger()) this.log("transport", "error", error);
        let transportBefore = this.transport;
        let establishedBefore = this.establishedConnections;
        this.triggerStateCallbacks("error", error, transportBefore, establishedBefore);
        if (transportBefore === this.transport || establishedBefore > 0) this.triggerChanError(error);
    }
    /**
   * @private
   * @param {unknown} [reason] underlying close/error event forwarded to channel error listeners
   */ triggerChanError(reason) {
        this.channels.forEach((channel)=>{
            if (!(channel.isErrored() || channel.isLeaving() || channel.isClosed())) channel.trigger($af64141737efe14a$var$CHANNEL_EVENTS.error, reason);
        });
    }
    /**
   * @returns {string}
   */ connectionState() {
        switch(this.conn && this.conn.readyState){
            case $af64141737efe14a$var$SOCKET_STATES.connecting:
                return "connecting";
            case $af64141737efe14a$var$SOCKET_STATES.open:
                return "open";
            case $af64141737efe14a$var$SOCKET_STATES.closing:
                return "closing";
            default:
                return "closed";
        }
    }
    /**
   * @returns {boolean}
   */ isConnected() {
        return this.connectionState() === "open";
    }
    /**
   *
   * @param {Channel} channel
   */ remove(channel) {
        this.off(channel.stateChangeRefs);
        this.channels = this.channels.filter((c)=>c !== channel);
    }
    /**
   * Removes `onOpen`, `onClose`, `onError,` and `onMessage` registrations.
   *
   * @param {string[]} refs - list of refs returned by calls to
   *                 `onOpen`, `onClose`, `onError,` and `onMessage`
   */ off(refs) {
        for(let key in this.stateChangeCallbacks)this.stateChangeCallbacks[key] = this.stateChangeCallbacks[key].filter(([ref])=>{
            return refs.indexOf(ref) === -1;
        });
    }
    /**
   * Initiates a new channel for the given topic
   *
   * @param {string} topic
   * @param {Params | (() => Params)} [chanParams]- Parameters for the channel
   * @returns {Channel}
   */ channel(topic, chanParams = {}) {
        let chan = new $af64141737efe14a$export$cfdacaa37f9b4dd7(topic, chanParams, this);
        this.channels.push(chan);
        return chan;
    }
    /**
   * @param {Message<Record<string, any>>} data
   */ push(data) {
        if (this.hasLogger()) {
            let { topic: topic, event: event, payload: payload, ref: ref, join_ref: join_ref } = data;
            this.log("push", `${topic} ${event} (${join_ref}, ${ref})`, payload);
        }
        if (this.isConnected()) this.encode(data, (result)=>this.conn.send(result));
        else this.sendBuffer.push(()=>this.encode(data, (result)=>this.conn.send(result)));
    }
    /**
   * Return the next message ref, accounting for overflows
   * @returns {string}
   */ makeRef() {
        let newRef = this.ref + 1;
        if (newRef === this.ref) this.ref = 0;
        else this.ref = newRef;
        return this.ref.toString();
    }
    sendHeartbeat() {
        if (!this.isConnected()) {
            try {
                this.heartbeatCallback("disconnected");
            } catch (e) {
                this.log("error", "error in heartbeat callback", e);
            }
            return;
        }
        if (this.pendingHeartbeatRef) {
            this.heartbeatTimeout();
            return;
        }
        this.pendingHeartbeatRef = this.makeRef();
        this.heartbeatSentAt = Date.now();
        this.push({
            topic: "phoenix",
            event: "heartbeat",
            payload: {},
            ref: this.pendingHeartbeatRef
        });
        try {
            this.heartbeatCallback("sent");
        } catch (e) {
            this.log("error", "error in heartbeat callback", e);
        }
        this.heartbeatTimeoutTimer = setTimeout(()=>this.heartbeatTimeout(), this.heartbeatIntervalMs);
    }
    flushSendBuffer() {
        if (this.isConnected() && this.sendBuffer.length > 0) {
            this.sendBuffer.forEach((callback)=>callback());
            this.sendBuffer = [];
        }
    }
    /**
  * @param {MessageEvent<any>} rawMessage
  */ onConnMessage(rawMessage) {
        this.decode(rawMessage.data, (msg)=>{
            let { topic: topic, event: event, payload: payload, ref: ref, join_ref: join_ref } = msg;
            if (ref && ref === this.pendingHeartbeatRef) {
                const latency = this.heartbeatSentAt ? Date.now() - this.heartbeatSentAt : void 0;
                this.clearHeartbeats();
                try {
                    this.heartbeatCallback(payload.status === "ok" ? "ok" : "error", latency);
                } catch (e) {
                    this.log("error", "error in heartbeat callback", e);
                }
                this.pendingHeartbeatRef = null;
                this.heartbeatSentAt = null;
                if (this.autoSendHeartbeat) this.heartbeatTimer = setTimeout(()=>this.sendHeartbeat(), this.heartbeatIntervalMs);
            }
            if (this.hasLogger()) this.log("receive", `${payload.status || ""} ${topic} ${event} ${ref && "(" + ref + ")" || ""}`.trim(), payload);
            for(let i = 0; i < this.channels.length; i++){
                const channel = this.channels[i];
                if (!channel.isMember(topic, event, payload, join_ref)) continue;
                channel.trigger(event, payload, ref, join_ref);
            }
            this.triggerStateCallbacks("message", msg);
        });
    }
    /**
   * @private
   * @template {keyof SocketStateChangeCallbacks} K
   * @param {K} event
   * @param {...Parameters<SocketStateChangeCallbacks[K][number][1]>} args
   * @returns {void}
   */ triggerStateCallbacks(event, ...args) {
        try {
            this.stateChangeCallbacks[event].forEach(([_, callback])=>{
                try {
                    callback(...args);
                } catch (e) {
                    this.log("error", `error in ${event} callback`, e);
                }
            });
        } catch (e) {
            this.log("error", `error triggering ${event} callbacks`, e);
        }
    }
    leaveOpenTopic(topic) {
        let dupChannel = this.channels.find((c)=>c.topic === topic && (c.isJoined() || c.isJoining()));
        if (dupChannel) {
            if (this.hasLogger()) this.log("transport", `leaving duplicate topic "${topic}"`);
            dupChannel.leave();
        }
    }
};

});



parcelRegister("9y6d0", function(module, exports) {

$parcel$export(module.exports, "normalizeChannelError", () => $6f3c1af111432fa9$export$3c9468938c65e4dc);
/**
 * Normalize the various shapes a channel error reason can take into a real `Error`.
 *
 * Transport-level channel errors arrive as a `CloseEvent`, a transport `Event`, an `Error`,
 * a string, or `undefined` depending on which path in the underlying socket fired. Server-reply
 * errors arrive as a payload object. This helper produces a consistent `Error` for every case
 * and preserves the original via `cause` so callers can still inspect the raw event.
 */ function $6f3c1af111432fa9$export$3c9468938c65e4dc(reason) {
    if (reason instanceof Error) return reason;
    if (typeof reason === 'string') return new Error(reason);
    if (reason && typeof reason === 'object') {
        const obj = reason;
        if (typeof obj.code === 'number') {
            const detail = typeof obj.reason === 'string' && obj.reason ? ` (${obj.reason})` : '';
            return new Error(`socket closed: ${obj.code}${detail}`, {
                cause: reason
            });
        }
        return new Error('channel error: transport failure', {
            cause: reason
        });
    }
    return new Error('channel error: connection lost');
}

});

parcelRegister("7bMKy", function(module, exports) {

$parcel$export(module.exports, "default", () => $53bf60346326a17f$export$2e2bcd8739ae039);

var $5gqEk = parcelRequire("5gqEk");
class $53bf60346326a17f$export$2e2bcd8739ae039 {
    constructor(socket, topic, params){
        const phoenixParams = $53bf60346326a17f$var$phoenixChannelParams(params);
        this.channel = socket.getSocket().channel(topic, phoenixParams);
        this.socket = socket;
    }
    get state() {
        return this.channel.state;
    }
    set state(state) {
        this.channel.state = state;
    }
    get joinedOnce() {
        return this.channel.joinedOnce;
    }
    get joinPush() {
        return this.channel.joinPush;
    }
    get rejoinTimer() {
        return this.channel.rejoinTimer;
    }
    on(event, callback) {
        return this.channel.on(event, callback);
    }
    off(event, refNumber) {
        this.channel.off(event, refNumber);
    }
    subscribe(timeout) {
        return this.channel.join(timeout);
    }
    unsubscribe(timeout) {
        return this.channel.leave(timeout);
    }
    teardown() {
        this.channel.teardown();
    }
    onClose(callback) {
        this.channel.onClose(callback);
    }
    onError(callback) {
        return this.channel.onError(callback);
    }
    push(event, payload, timeout) {
        let push;
        try {
            push = this.channel.push(event, payload, timeout);
        } catch (error) {
            throw new Error(`tried to push '${event}' to '${this.channel.topic}' before joining. Use channel.subscribe() before pushing events`);
        }
        if (this.channel.pushBuffer.length > (0, $5gqEk.MAX_PUSH_BUFFER_SIZE)) {
            const removedPush = this.channel.pushBuffer.shift();
            removedPush.cancelTimeout();
            this.socket.log('channel', `discarded push due to buffer overflow: ${removedPush.event}`, removedPush.payload());
        }
        return push;
    }
    updateJoinPayload(payload) {
        const oldPayload = this.channel.joinPush.payload();
        this.channel.joinPush.payload = ()=>Object.assign(Object.assign({}, oldPayload), payload);
    }
    canPush() {
        return this.socket.isConnected() && this.state === (0, $5gqEk.CHANNEL_STATES).joined;
    }
    isJoined() {
        return this.state === (0, $5gqEk.CHANNEL_STATES).joined;
    }
    isJoining() {
        return this.state === (0, $5gqEk.CHANNEL_STATES).joining;
    }
    isClosed() {
        return this.state === (0, $5gqEk.CHANNEL_STATES).closed;
    }
    isLeaving() {
        return this.state === (0, $5gqEk.CHANNEL_STATES).leaving;
    }
    updateFilterBindings(filterBindings) {
        this.channel.filterBindings = filterBindings;
    }
    updatePayloadTransform(callback) {
        this.channel.onMessage = callback;
    }
    /**
     * @internal
     */ getChannel() {
        return this.channel;
    }
}
function $53bf60346326a17f$var$phoenixChannelParams(options) {
    return {
        config: Object.assign({
            broadcast: {
                ack: false,
                self: false
            },
            presence: {
                key: '',
                enabled: false
            },
            private: false
        }, options.config)
    };
}

});


parcelRegister("iCjex", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8dab1f89bf5036d$export$2e2bcd8739ae039);

var $gS6ap = parcelRequire("gS6ap");

var $5gqEk = parcelRequire("5gqEk");
class $d8dab1f89bf5036d$export$2e2bcd8739ae039 {
    constructor(endPoint, options){
        this.socket = new (0, $gS6ap.Socket)(endPoint, options);
    }
    get timeout() {
        return this.socket.timeout;
    }
    get endPoint() {
        return this.socket.endPoint;
    }
    get transport() {
        return this.socket.transport;
    }
    get heartbeatIntervalMs() {
        return this.socket.heartbeatIntervalMs;
    }
    get heartbeatCallback() {
        return this.socket.heartbeatCallback;
    }
    set heartbeatCallback(callback) {
        this.socket.heartbeatCallback = callback;
    }
    get heartbeatTimer() {
        return this.socket.heartbeatTimer;
    }
    get pendingHeartbeatRef() {
        return this.socket.pendingHeartbeatRef;
    }
    get reconnectTimer() {
        return this.socket.reconnectTimer;
    }
    get vsn() {
        return this.socket.vsn;
    }
    get encode() {
        return this.socket.encode;
    }
    get decode() {
        return this.socket.decode;
    }
    get reconnectAfterMs() {
        return this.socket.reconnectAfterMs;
    }
    get sendBuffer() {
        return this.socket.sendBuffer;
    }
    get stateChangeCallbacks() {
        return this.socket.stateChangeCallbacks;
    }
    connect() {
        this.socket.connect();
    }
    disconnect(callback, code, reason, timeout = 10000) {
        return new Promise((resolve)=>{
            setTimeout(()=>resolve('timeout'), timeout);
            this.socket.disconnect(()=>{
                callback();
                resolve('ok');
            }, code, reason);
        });
    }
    push(data) {
        this.socket.push(data);
    }
    log(kind, msg, data) {
        this.socket.log(kind, msg, data);
    }
    makeRef() {
        return this.socket.makeRef();
    }
    onOpen(callback) {
        this.socket.onOpen(callback);
    }
    onClose(callback) {
        this.socket.onClose(callback);
    }
    onError(callback) {
        this.socket.onError(callback);
    }
    onMessage(callback) {
        this.socket.onMessage(callback);
    }
    isConnected() {
        return this.socket.isConnected();
    }
    isConnecting() {
        return this.socket.connectionState() == (0, $5gqEk.CONNECTION_STATE).connecting;
    }
    isDisconnecting() {
        return this.socket.connectionState() == (0, $5gqEk.CONNECTION_STATE).closing;
    }
    connectionState() {
        // @ts-ignore - requires better typing and exposing type in phoenix
        return this.socket.connectionState();
    }
    endPointURL() {
        return this.socket.endPointURL();
    }
    sendHeartbeat() {
        this.socket.sendHeartbeat();
    }
    /**
     * @internal
     */ getSocket() {
        return this.socket;
    }
}

});



parcelRegister("9Yl9w", function(module, exports) {

$parcel$export(module.exports, "StorageClient", () => $d3773c76b69f8b27$export$6c85f5032e75eff9);

var $b8Rhd = parcelRequire("b8Rhd");

var $6ZWSX = parcelRequire("6ZWSX");
var $d3773c76b69f8b27$require$Buffer = $6ZWSX.Buffer;
//#region \0@oxc-project+runtime@0.101.0/helpers/typeof.js
function $d3773c76b69f8b27$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d3773c76b69f8b27$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o$1) {
        return typeof o$1;
    } : function(o$1) {
        return o$1 && "function" == typeof Symbol && o$1.constructor === Symbol && o$1 !== Symbol.prototype ? "symbol" : typeof o$1;
    }, $d3773c76b69f8b27$var$_typeof(o);
}
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/toPrimitive.js
function $d3773c76b69f8b27$var$toPrimitive(t, r) {
    if ("object" != $d3773c76b69f8b27$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $d3773c76b69f8b27$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/toPropertyKey.js
function $d3773c76b69f8b27$var$toPropertyKey(t) {
    var i = $d3773c76b69f8b27$var$toPrimitive(t, "string");
    return "symbol" == $d3773c76b69f8b27$var$_typeof(i) ? i : i + "";
}
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/defineProperty.js
function $d3773c76b69f8b27$var$_defineProperty(e, r, t) {
    return (r = $d3773c76b69f8b27$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
//#endregion
//#region \0@oxc-project+runtime@0.101.0/helpers/objectSpread2.js
function $d3773c76b69f8b27$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r$1) {
            return Object.getOwnPropertyDescriptor(e, r$1).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d3773c76b69f8b27$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d3773c76b69f8b27$var$ownKeys(Object(t), !0).forEach(function(r$1) {
            $d3773c76b69f8b27$var$_defineProperty(e, r$1, t[r$1]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d3773c76b69f8b27$var$ownKeys(Object(t)).forEach(function(r$1) {
            Object.defineProperty(e, r$1, Object.getOwnPropertyDescriptor(t, r$1));
        });
    }
    return e;
}
//#endregion
//#region src/lib/common/errors.ts
/**
* Base error class for all Storage errors
* Supports both 'storage' and 'vectors' namespaces
*/ var $d3773c76b69f8b27$export$697502632950e9d3 = class extends Error {
    constructor(message, namespace = "storage", status, statusCode){
        super(message);
        this.__isStorageError = true;
        this.namespace = namespace;
        this.name = namespace === "vectors" ? "StorageVectorsError" : "StorageError";
        this.status = status;
        this.statusCode = statusCode;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status,
            statusCode: this.statusCode
        };
    }
};
/**
* Type guard to check if an error is a StorageError
* @param error - The error to check
* @returns True if the error is a StorageError
*/ function $d3773c76b69f8b27$export$5a322e77e5eb0561(error) {
    return typeof error === "object" && error !== null && "__isStorageError" in error;
}
/**
* API error returned from Storage service
* Includes HTTP status code and service-specific error code
*/ var $d3773c76b69f8b27$export$ca9ecfd959b3871c = class extends $d3773c76b69f8b27$export$697502632950e9d3 {
    constructor(message, status, statusCode, namespace = "storage"){
        super(message, namespace, status, statusCode);
        this.name = namespace === "vectors" ? "StorageVectorsApiError" : "StorageApiError";
        this.status = status;
        this.statusCode = statusCode;
    }
    toJSON() {
        return $d3773c76b69f8b27$var$_objectSpread2({}, super.toJSON());
    }
};
/**
* Unknown error that doesn't match expected error patterns
* Wraps the original error for debugging
*/ var $d3773c76b69f8b27$export$29127ca2e1a271d = class extends $d3773c76b69f8b27$export$697502632950e9d3 {
    constructor(message, originalError, namespace = "storage"){
        super(message, namespace);
        this.name = namespace === "vectors" ? "StorageVectorsUnknownError" : "StorageUnknownError";
        this.originalError = originalError;
    }
};
/**
* @deprecated Use StorageError with namespace='vectors' instead
* Alias for backward compatibility with existing vector storage code
*/ var $d3773c76b69f8b27$export$92ae90d5da46e8c0 = class extends $d3773c76b69f8b27$export$697502632950e9d3 {
    constructor(message){
        super(message, "vectors");
    }
};
/**
* Type guard to check if an error is a StorageVectorsError
* @param error - The error to check
* @returns True if the error is a StorageVectorsError
*/ function $d3773c76b69f8b27$export$95bc534aa9e6b2f1(error) {
    return $d3773c76b69f8b27$export$5a322e77e5eb0561(error) && error["namespace"] === "vectors";
}
/**
* @deprecated Use StorageApiError with namespace='vectors' instead
* Alias for backward compatibility with existing vector storage code
*/ var $d3773c76b69f8b27$export$22e4871ee01e8e3f = class extends $d3773c76b69f8b27$export$ca9ecfd959b3871c {
    constructor(message, status, statusCode){
        super(message, status, statusCode, "vectors");
    }
};
/**
* @deprecated Use StorageUnknownError with namespace='vectors' instead
* Alias for backward compatibility with existing vector storage code
*/ var $d3773c76b69f8b27$export$26d7e1f64f113285 = class extends $d3773c76b69f8b27$export$29127ca2e1a271d {
    constructor(message, originalError){
        super(message, originalError, "vectors");
    }
};
/**
* Error codes specific to S3 Vectors API
* Maps AWS service errors to application-friendly error codes
*/ let $d3773c76b69f8b27$export$2f60cecd2e35a5da = /* @__PURE__ */ function(StorageVectorsErrorCode$1) {
    /** Internal server fault (HTTP 500) */ StorageVectorsErrorCode$1["InternalError"] = "InternalError";
    /** Resource already exists / conflict (HTTP 409) */ StorageVectorsErrorCode$1["S3VectorConflictException"] = "S3VectorConflictException";
    /** Resource not found (HTTP 404) */ StorageVectorsErrorCode$1["S3VectorNotFoundException"] = "S3VectorNotFoundException";
    /** Delete bucket while not empty (HTTP 400) */ StorageVectorsErrorCode$1["S3VectorBucketNotEmpty"] = "S3VectorBucketNotEmpty";
    /** Exceeds bucket quota/limit (HTTP 400) */ StorageVectorsErrorCode$1["S3VectorMaxBucketsExceeded"] = "S3VectorMaxBucketsExceeded";
    /** Exceeds index quota/limit (HTTP 400) */ StorageVectorsErrorCode$1["S3VectorMaxIndexesExceeded"] = "S3VectorMaxIndexesExceeded";
    return StorageVectorsErrorCode$1;
}({});
//#endregion
//#region src/lib/common/headers.ts
/**
* Sets a header with case-insensitive deduplication.
* Removes any existing headers whose name matches (case-insensitive),
* then sets the value under the lowercase key. Does not mutate the input object.
*
* @param headers - Existing headers object
* @param name - Header name to set (stored as lowercase)
* @param value - Header value
* @returns New headers object with the header set
*/ function $d3773c76b69f8b27$var$setHeader(headers, name, value) {
    const result = $d3773c76b69f8b27$var$_objectSpread2({}, headers);
    const nameLower = name.toLowerCase();
    for (const key of Object.keys(result))if (key.toLowerCase() === nameLower) delete result[key];
    result[nameLower] = value;
    return result;
}
/**
* Normalizes all header keys to lowercase with case-insensitive deduplication.
* When duplicate keys exist (differing only in case), the last value wins.
* Does not mutate the input object.
*
* @param headers - Headers object to normalize
* @returns New headers object with all keys lowercased
*/ function $d3773c76b69f8b27$var$normalizeHeaders(headers) {
    const result = {};
    for (const [key, value] of Object.entries(headers))result[key.toLowerCase()] = value;
    return result;
}
//#endregion
//#region src/lib/common/helpers.ts
/**
* Resolves the fetch implementation to use
* Uses custom fetch if provided, otherwise uses native fetch
*
* @param customFetch - Optional custom fetch implementation
* @returns Resolved fetch function
*/ const $d3773c76b69f8b27$var$resolveFetch = (customFetch)=>{
    if (customFetch) return (...args)=>customFetch(...args);
    return (...args)=>fetch(...args);
};
/**
* Determine if input is a plain object
* An object is plain if it's created by either {}, new Object(), or Object.create(null)
*
* @param value - Value to check
* @returns True if value is a plain object
* @source https://github.com/sindresorhus/is-plain-obj
*/ const $d3773c76b69f8b27$var$isPlainObject = (value)=>{
    if (typeof value !== "object" || value === null) return false;
    const prototype = Object.getPrototypeOf(value);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
};
/**
* Recursively converts object keys from snake_case to camelCase
* Used for normalizing API responses
*
* @param item - Object to convert
* @returns Converted object with camelCase keys
*/ const $d3773c76b69f8b27$var$recursiveToCamel = (item)=>{
    if (Array.isArray(item)) return item.map((el)=>$d3773c76b69f8b27$var$recursiveToCamel(el));
    else if (typeof item === "function" || item !== Object(item)) return item;
    const result = {};
    Object.entries(item).forEach(([key, value])=>{
        const newKey = key.replace(/([-_][a-z])/gi, (c)=>c.toUpperCase().replace(/[-_]/g, ""));
        result[newKey] = $d3773c76b69f8b27$var$recursiveToCamel(value);
    });
    return result;
};
/**
* Validates if a given bucket name is valid according to Supabase Storage API rules
* Mirrors backend validation from: storage/src/storage/limits.ts:isValidBucketName()
*
* Rules:
* - Length: 1-100 characters
* - Allowed characters: alphanumeric (a-z, A-Z, 0-9), underscore (_), and safe special characters
* - Safe special characters: ! - . * ' ( ) space & $ @ = ; : + , ?
* - Forbidden: path separators (/, \), path traversal (..), leading/trailing whitespace
*
* AWS S3 Reference: https://docs.aws.amazon.com/AmazonS3/latest/userguide/object-keys.html
*
* @param bucketName - The bucket name to validate
* @returns true if valid, false otherwise
*/ const $d3773c76b69f8b27$var$isValidBucketName = (bucketName)=>{
    if (!bucketName || typeof bucketName !== "string") return false;
    if (bucketName.length === 0 || bucketName.length > 100) return false;
    if (bucketName.trim() !== bucketName) return false;
    if (bucketName.includes("/") || bucketName.includes("\\")) return false;
    return /^[\w!.\*'() &$@=;:+,?-]+$/.test(bucketName);
};
//#endregion
//#region src/lib/common/fetch.ts
/**
* Extracts error message from various error response formats
* @param err - Error object from API
* @returns Human-readable error message
*/ const $d3773c76b69f8b27$var$_getErrorMessage = (err)=>{
    if (typeof err === "object" && err !== null) {
        const e = err;
        if (typeof e.msg === "string") return e.msg;
        if (typeof e.message === "string") return e.message;
        if (typeof e.error_description === "string") return e.error_description;
        if (typeof e.error === "string") return e.error;
        if (typeof e.error === "object" && e.error !== null) {
            const nested = e.error;
            if (typeof nested.message === "string") return nested.message;
        }
    }
    return JSON.stringify(err);
};
/**
* Handles fetch errors and converts them to Storage error types
* @param error - The error caught from fetch
* @param reject - Promise rejection function
* @param options - Fetch options that may affect error handling
* @param namespace - Error namespace ('storage' or 'vectors')
*/ const $d3773c76b69f8b27$var$handleError = async (error, reject, options, namespace)=>{
    if (error !== null && typeof error === "object" && "json" in error && typeof error.json === "function") {
        const responseError = error;
        let status = parseInt(String(responseError.status), 10);
        if (!Number.isFinite(status)) status = 500;
        responseError.json().then((err)=>{
            const statusCode = (err === null || err === void 0 ? void 0 : err.statusCode) || (err === null || err === void 0 ? void 0 : err.code) || status + "";
            reject(new $d3773c76b69f8b27$export$ca9ecfd959b3871c($d3773c76b69f8b27$var$_getErrorMessage(err), status, statusCode, namespace));
        }).catch(()=>{
            const statusCode = status + "";
            reject(new $d3773c76b69f8b27$export$ca9ecfd959b3871c(responseError.statusText || `HTTP ${status} error`, status, statusCode, namespace));
        });
    } else reject(new $d3773c76b69f8b27$export$29127ca2e1a271d($d3773c76b69f8b27$var$_getErrorMessage(error), error, namespace));
};
/**
* Builds request parameters for fetch calls
* @param method - HTTP method
* @param options - Custom fetch options
* @param parameters - Additional fetch parameters like AbortSignal
* @param body - Request body (will be JSON stringified if plain object)
* @returns Complete fetch request parameters
*/ const $d3773c76b69f8b27$var$_getRequestParams = (method, options, parameters, body)=>{
    const params = {
        method: method,
        headers: (options === null || options === void 0 ? void 0 : options.headers) || {}
    };
    if (method === "GET" || method === "HEAD" || !body) return $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, params), parameters);
    if ($d3773c76b69f8b27$var$isPlainObject(body)) {
        var _contentType;
        const headers = (options === null || options === void 0 ? void 0 : options.headers) || {};
        let contentType;
        for (const [key, value] of Object.entries(headers))if (key.toLowerCase() === "content-type") contentType = value;
        params.headers = $d3773c76b69f8b27$var$setHeader(headers, "Content-Type", (_contentType = contentType) !== null && _contentType !== void 0 ? _contentType : "application/json");
        params.body = JSON.stringify(body);
    } else params.body = body;
    if (options === null || options === void 0 ? void 0 : options.duplex) params.duplex = options.duplex;
    return $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, params), parameters);
};
/**
* Internal request handler that wraps fetch with error handling
* @param fetcher - Fetch function to use
* @param method - HTTP method
* @param url - Request URL
* @param options - Custom fetch options
* @param parameters - Additional fetch parameters
* @param body - Request body
* @param namespace - Error namespace ('storage' or 'vectors')
* @returns Promise with parsed response or error
*/ async function $d3773c76b69f8b27$var$_handleRequest(fetcher, method, url, options, parameters, body, namespace) {
    return new Promise((resolve, reject)=>{
        fetcher(url, $d3773c76b69f8b27$var$_getRequestParams(method, options, parameters, body)).then((result)=>{
            if (!result.ok) throw result;
            if (options === null || options === void 0 ? void 0 : options.noResolveJson) return result;
            if (namespace === "vectors") {
                const contentType = result.headers.get("content-type");
                if (result.headers.get("content-length") === "0" || result.status === 204) return {};
                if (!contentType || !contentType.includes("application/json")) return {};
            }
            return result.json();
        }).then((data)=>resolve(data)).catch((error)=>$d3773c76b69f8b27$var$handleError(error, reject, options, namespace));
    });
}
/**
* Creates a fetch API with the specified namespace
* @param namespace - Error namespace ('storage' or 'vectors')
* @returns Object with HTTP method functions
*/ function $d3773c76b69f8b27$var$createFetchApi(namespace = "storage") {
    return {
        get: async (fetcher, url, options, parameters)=>{
            return $d3773c76b69f8b27$var$_handleRequest(fetcher, "GET", url, options, parameters, void 0, namespace);
        },
        post: async (fetcher, url, body, options, parameters)=>{
            return $d3773c76b69f8b27$var$_handleRequest(fetcher, "POST", url, options, parameters, body, namespace);
        },
        put: async (fetcher, url, body, options, parameters)=>{
            return $d3773c76b69f8b27$var$_handleRequest(fetcher, "PUT", url, options, parameters, body, namespace);
        },
        head: async (fetcher, url, options, parameters)=>{
            return $d3773c76b69f8b27$var$_handleRequest(fetcher, "HEAD", url, $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, options), {}, {
                noResolveJson: true
            }), parameters, void 0, namespace);
        },
        remove: async (fetcher, url, body, options, parameters)=>{
            return $d3773c76b69f8b27$var$_handleRequest(fetcher, "DELETE", url, options, parameters, body, namespace);
        }
    };
}
const $d3773c76b69f8b27$var$defaultApi = $d3773c76b69f8b27$var$createFetchApi("storage");
const { get: $d3773c76b69f8b27$var$get, post: $d3773c76b69f8b27$var$post, put: $d3773c76b69f8b27$var$put, head: $d3773c76b69f8b27$var$head, remove: $d3773c76b69f8b27$var$remove } = $d3773c76b69f8b27$var$defaultApi;
const $d3773c76b69f8b27$var$vectorsApi = $d3773c76b69f8b27$var$createFetchApi("vectors");
//#endregion
//#region src/lib/common/BaseApiClient.ts
/**
* @ignore
* Base API client class for all Storage API classes
* Provides common infrastructure for error handling and configuration
*
* @typeParam TError - The error type (StorageError or subclass)
*/ var $d3773c76b69f8b27$var$BaseApiClient = class {
    /**
	* Creates a new BaseApiClient instance
	* @param url - Base URL for API requests
	* @param headers - Default headers for API requests
	* @param fetch - Optional custom fetch implementation
	* @param namespace - Error namespace ('storage' or 'vectors')
	*/ constructor(url, headers = {}, fetch$1, namespace = "storage"){
        this.shouldThrowOnError = false;
        this.url = url;
        this.headers = $d3773c76b69f8b27$var$normalizeHeaders(headers);
        this.fetch = $d3773c76b69f8b27$var$resolveFetch(fetch$1);
        this.namespace = namespace;
    }
    /**
	* Enable throwing errors instead of returning them.
	* When enabled, errors are thrown instead of returned in { data, error } format.
	*
	* @returns this - For method chaining
	*/ throwOnError() {
        this.shouldThrowOnError = true;
        return this;
    }
    /**
	* Set an HTTP header for the request.
	* Creates a shallow copy of headers to avoid mutating shared state.
	*
	* @param name - Header name
	* @param value - Header value
	* @returns this - For method chaining
	*/ setHeader(name, value) {
        this.headers = $d3773c76b69f8b27$var$setHeader(this.headers, name, value);
        return this;
    }
    /**
	* Handles API operation with standardized error handling
	* Eliminates repetitive try-catch blocks across all API methods
	*
	* This wrapper:
	* 1. Executes the operation
	* 2. Returns { data, error: null } on success
	* 3. Returns { data: null, error } on failure (if shouldThrowOnError is false)
	* 4. Throws error on failure (if shouldThrowOnError is true)
	*
	* @typeParam T - The expected data type from the operation
	* @param operation - Async function that performs the API call
	* @returns Promise with { data, error } tuple
	*
	* @example Handling an operation
	* ```typescript
	* async listBuckets() {
	*   return this.handleOperation(async () => {
	*     return await get(this.fetch, `${this.url}/bucket`, {
	*       headers: this.headers,
	*     })
	*   })
	* }
	* ```
	*/ async handleOperation(operation) {
        var _this = this;
        try {
            return {
                data: await operation(),
                error: null
            };
        } catch (error) {
            if (_this.shouldThrowOnError) throw error;
            if ($d3773c76b69f8b27$export$5a322e77e5eb0561(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
};
//#endregion
//#region src/packages/StreamDownloadBuilder.ts
var $d3773c76b69f8b27$var$StreamDownloadBuilder = class {
    constructor(downloadFn, shouldThrowOnError){
        this.downloadFn = downloadFn;
        this.shouldThrowOnError = shouldThrowOnError;
    }
    then(onfulfilled, onrejected) {
        return this.execute().then(onfulfilled, onrejected);
    }
    async execute() {
        var _this = this;
        try {
            return {
                data: (await _this.downloadFn()).body,
                error: null
            };
        } catch (error) {
            if (_this.shouldThrowOnError) throw error;
            if ($d3773c76b69f8b27$export$5a322e77e5eb0561(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
};
//#endregion
//#region src/packages/BlobDownloadBuilder.ts
let $d3773c76b69f8b27$var$_Symbol$toStringTag;
$d3773c76b69f8b27$var$_Symbol$toStringTag = Symbol.toStringTag;
var $d3773c76b69f8b27$var$BlobDownloadBuilder = class {
    constructor(downloadFn, shouldThrowOnError){
        this.downloadFn = downloadFn;
        this.shouldThrowOnError = shouldThrowOnError;
        this[$d3773c76b69f8b27$var$_Symbol$toStringTag] = "BlobDownloadBuilder";
        this.promise = null;
    }
    asStream() {
        return new $d3773c76b69f8b27$var$StreamDownloadBuilder(this.downloadFn, this.shouldThrowOnError);
    }
    then(onfulfilled, onrejected) {
        return this.getPromise().then(onfulfilled, onrejected);
    }
    catch(onrejected) {
        return this.getPromise().catch(onrejected);
    }
    finally(onfinally) {
        return this.getPromise().finally(onfinally);
    }
    getPromise() {
        if (!this.promise) this.promise = this.execute();
        return this.promise;
    }
    async execute() {
        var _this = this;
        try {
            return {
                data: await (await _this.downloadFn()).blob(),
                error: null
            };
        } catch (error) {
            if (_this.shouldThrowOnError) throw error;
            if ($d3773c76b69f8b27$export$5a322e77e5eb0561(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
};
//#endregion
//#region src/packages/StorageFileApi.ts
const $d3773c76b69f8b27$var$DEFAULT_SEARCH_OPTIONS = {
    limit: 100,
    offset: 0,
    sortBy: {
        column: "name",
        order: "asc"
    }
};
const $d3773c76b69f8b27$var$DEFAULT_FILE_OPTIONS = {
    cacheControl: "3600",
    contentType: "text/plain;charset=UTF-8",
    upsert: false
};
var $d3773c76b69f8b27$var$StorageFileApi = class extends $d3773c76b69f8b27$var$BaseApiClient {
    constructor(url, headers = {}, bucketId, fetch$1){
        super(url, headers, fetch$1, "storage");
        this.bucketId = bucketId;
    }
    /**
	* Uploads a file to an existing bucket or replaces an existing file at the specified path with a new one.
	*
	* @param method HTTP method.
	* @param path The relative file path. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
	* @param fileBody The body of the file to be stored in the bucket.
	*/ async uploadOrUpdate(method, path, fileBody, fileOptions) {
        var _this = this;
        return _this.handleOperation(async ()=>{
            let body;
            const options = $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, $d3773c76b69f8b27$var$DEFAULT_FILE_OPTIONS), fileOptions);
            let headers = $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, _this.headers), method === "POST" && {
                "x-upsert": String(options.upsert)
            });
            const metadata = options.metadata;
            if (typeof Blob !== "undefined" && fileBody instanceof Blob) {
                body = new FormData();
                body.append("cacheControl", options.cacheControl);
                if (metadata) body.append("metadata", _this.encodeMetadata(metadata));
                body.append("", fileBody);
            } else if (typeof FormData !== "undefined" && fileBody instanceof FormData) {
                body = fileBody;
                if (!body.has("cacheControl")) body.append("cacheControl", options.cacheControl);
                if (metadata && !body.has("metadata")) body.append("metadata", _this.encodeMetadata(metadata));
            } else {
                body = fileBody;
                headers["cache-control"] = `max-age=${options.cacheControl}`;
                headers["content-type"] = options.contentType;
                if (metadata) headers["x-metadata"] = _this.toBase64(_this.encodeMetadata(metadata));
                if ((typeof ReadableStream !== "undefined" && body instanceof ReadableStream || body && typeof body === "object" && "pipe" in body && typeof body.pipe === "function") && !options.duplex) options.duplex = "half";
            }
            if (fileOptions === null || fileOptions === void 0 ? void 0 : fileOptions.headers) for (const [key, value] of Object.entries(fileOptions.headers))headers = $d3773c76b69f8b27$var$setHeader(headers, key, value);
            const cleanPath = _this._removeEmptyFolders(path);
            const _path = _this._getFinalPath(cleanPath);
            const data = await (method == "PUT" ? $d3773c76b69f8b27$var$put : $d3773c76b69f8b27$var$post)(_this.fetch, `${_this.url}/object/${_path}`, body, $d3773c76b69f8b27$var$_objectSpread2({
                headers: headers
            }, (options === null || options === void 0 ? void 0 : options.duplex) ? {
                duplex: options.duplex
            } : {}));
            return {
                path: cleanPath,
                id: data.Id,
                fullPath: data.Key
            };
        });
    }
    /**
	* Uploads a file to an existing bucket.
	*
	* @category Storage
	* @subcategory File Buckets
	* @param path The file path, including the file name. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
	* @param fileBody The body of the file to be stored in the bucket.
	* @param fileOptions Optional file upload options including cacheControl, contentType, upsert, and metadata.
	* @returns Promise with response containing file path, id, and fullPath or error
	*
	* @example Upload file
	* ```js
	* const avatarFile = event.target.files[0]
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .upload('public/avatar1.png', avatarFile, {
	*     cacheControl: '3600',
	*     upsert: false
	*   })
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "path": "public/avatar1.png",
	*     "fullPath": "avatars/public/avatar1.png"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @example Upload file using `ArrayBuffer` from base64 file data
	* ```js
	* import { decode } from 'base64-arraybuffer'
	*
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .upload('public/avatar1.png', decode('base64FileData'), {
	*     contentType: 'image/png'
	*   })
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: none
	*   - `objects` table permissions: only `insert` when you are uploading new files and `select`, `insert` and `update` when you are upserting files
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	* - For React Native, using either `Blob`, `File` or `FormData` does not work as intended. Upload file using `ArrayBuffer` from base64 file data instead, see example below.
	*/ async upload(path, fileBody, fileOptions) {
        return this.uploadOrUpdate("POST", path, fileBody, fileOptions);
    }
    /**
	* Upload a file with a token generated from `createSignedUploadUrl`.
	*
	* @category Storage
	* @subcategory File Buckets
	* @param path The file path, including the file name. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
	* @param token The token generated from `createSignedUploadUrl`
	* @param fileBody The body of the file to be stored in the bucket.
	* @param fileOptions HTTP headers (cacheControl, contentType, etc.).
	* **Note:** The `upsert` option has no effect here. To enable upsert behavior,
	* pass `{ upsert: true }` when calling `createSignedUploadUrl()` instead.
	* @returns Promise with response containing file path and fullPath or error
	*
	* @example Upload to a signed URL
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .uploadToSignedUrl('folder/cat.jpg', 'token-from-createSignedUploadUrl', file)
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "path": "folder/cat.jpg",
	*     "fullPath": "avatars/folder/cat.jpg"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: none
	*   - `objects` table permissions: none
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async uploadToSignedUrl(path, token, fileBody, fileOptions) {
        var _this3 = this;
        const cleanPath = _this3._removeEmptyFolders(path);
        const _path = _this3._getFinalPath(cleanPath);
        const url = new URL(_this3.url + `/object/upload/sign/${_path}`);
        url.searchParams.set("token", token);
        return _this3.handleOperation(async ()=>{
            let body;
            const options = $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, $d3773c76b69f8b27$var$DEFAULT_FILE_OPTIONS), fileOptions);
            let headers = $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, _this3.headers), {
                "x-upsert": String(options.upsert)
            });
            const metadata = options.metadata;
            if (typeof Blob !== "undefined" && fileBody instanceof Blob) {
                body = new FormData();
                body.append("cacheControl", options.cacheControl);
                if (metadata) body.append("metadata", _this3.encodeMetadata(metadata));
                body.append("", fileBody);
            } else if (typeof FormData !== "undefined" && fileBody instanceof FormData) {
                body = fileBody;
                if (!body.has("cacheControl")) body.append("cacheControl", options.cacheControl);
                if (metadata && !body.has("metadata")) body.append("metadata", _this3.encodeMetadata(metadata));
            } else {
                body = fileBody;
                headers["cache-control"] = `max-age=${options.cacheControl}`;
                headers["content-type"] = options.contentType;
                if (metadata) headers["x-metadata"] = _this3.toBase64(_this3.encodeMetadata(metadata));
                if ((typeof ReadableStream !== "undefined" && body instanceof ReadableStream || body && typeof body === "object" && "pipe" in body && typeof body.pipe === "function") && !options.duplex) options.duplex = "half";
            }
            if (fileOptions === null || fileOptions === void 0 ? void 0 : fileOptions.headers) for (const [key, value] of Object.entries(fileOptions.headers))headers = $d3773c76b69f8b27$var$setHeader(headers, key, value);
            return {
                path: cleanPath,
                fullPath: (await $d3773c76b69f8b27$var$put(_this3.fetch, url.toString(), body, $d3773c76b69f8b27$var$_objectSpread2({
                    headers: headers
                }, (options === null || options === void 0 ? void 0 : options.duplex) ? {
                    duplex: options.duplex
                } : {}))).Key
            };
        });
    }
    /**
	* Creates a signed upload URL.
	* Signed upload URLs can be used to upload files to the bucket without further authentication.
	* They are valid for 2 hours.
	*
	* @category Storage
	* @subcategory File Buckets
	* @param path The file path, including the current file name. For example `folder/image.png`.
	* @param options.upsert If set to true, allows the file to be overwritten if it already exists.
	* @returns Promise with response containing signed upload URL, token, and path or error
	*
	* @example Create Signed Upload URL
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .createSignedUploadUrl('folder/cat.jpg')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "signedUrl": "https://example.supabase.co/storage/v1/object/upload/sign/avatars/folder/cat.jpg?token=<TOKEN>",
	*     "path": "folder/cat.jpg",
	*     "token": "<TOKEN>"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: none
	*   - `objects` table permissions: `insert`
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async createSignedUploadUrl(path, options) {
        var _this4 = this;
        return _this4.handleOperation(async ()=>{
            let _path = _this4._getFinalPath(path);
            const headers = $d3773c76b69f8b27$var$_objectSpread2({}, _this4.headers);
            if (options === null || options === void 0 ? void 0 : options.upsert) headers["x-upsert"] = "true";
            const data = await $d3773c76b69f8b27$var$post(_this4.fetch, `${_this4.url}/object/upload/sign/${_path}`, {}, {
                headers: headers
            });
            const url = new URL(_this4.url + data.url);
            const token = url.searchParams.get("token");
            if (!token) throw new $d3773c76b69f8b27$export$697502632950e9d3("No token returned by API");
            return {
                signedUrl: url.toString(),
                path: path,
                token: token
            };
        });
    }
    /**
	* Replaces an existing file at the specified path with a new one.
	*
	* @category Storage
	* @subcategory File Buckets
	* @param path The relative file path. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to update.
	* @param fileBody The body of the file to be stored in the bucket.
	* @param fileOptions Optional file upload options including cacheControl, contentType, and metadata.
	* **Note:** The `upsert` option has no effect here. `update()` always replaces the
	* file at the given path, so the `x-upsert` header is not sent. To control upsert
	* behavior, use `upload()` instead.
	* @returns Promise with response containing file path, id, and fullPath or error
	*
	* @example Update file
	* ```js
	* const avatarFile = event.target.files[0]
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .update('public/avatar1.png', avatarFile, {
	*     cacheControl: '3600'
	*   })
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "path": "public/avatar1.png",
	*     "fullPath": "avatars/public/avatar1.png"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @example Update file using `ArrayBuffer` from base64 file data
	* ```js
	* import {decode} from 'base64-arraybuffer'
	*
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .update('public/avatar1.png', decode('base64FileData'), {
	*     contentType: 'image/png'
	*   })
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: none
	*   - `objects` table permissions: `update` and `select`
	* - `update()` always replaces the file at the given path regardless of the `upsert` option.
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	* - For React Native, using either `Blob`, `File` or `FormData` does not work as intended. Update file using `ArrayBuffer` from base64 file data instead, see example below.
	*/ async update(path, fileBody, fileOptions) {
        return this.uploadOrUpdate("PUT", path, fileBody, fileOptions);
    }
    /**
	* Moves an existing file to a new path in the same bucket.
	*
	* @category Storage
	* @subcategory File Buckets
	* @param fromPath The original file path, including the current file name. For example `folder/image.png`.
	* @param toPath The new file path, including the new file name. For example `folder/image-new.png`.
	* @param options The destination options.
	* @returns Promise with response containing success message or error
	*
	* @example Move file
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .move('public/avatar1.png', 'private/avatar2.png')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "message": "Successfully moved"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: none
	*   - `objects` table permissions: `update` and `select`
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async move(fromPath, toPath, options) {
        var _this6 = this;
        return _this6.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$post(_this6.fetch, `${_this6.url}/object/move`, {
                bucketId: _this6.bucketId,
                sourceKey: fromPath,
                destinationKey: toPath,
                destinationBucket: options === null || options === void 0 ? void 0 : options.destinationBucket
            }, {
                headers: _this6.headers
            });
        });
    }
    /**
	* Copies an existing file to a new path in the same bucket.
	*
	* @category Storage
	* @subcategory File Buckets
	* @param fromPath The original file path, including the current file name. For example `folder/image.png`.
	* @param toPath The new file path, including the new file name. For example `folder/image-copy.png`.
	* @param options The destination options.
	* @returns Promise with response containing copied file path or error
	*
	* @example Copy file
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .copy('public/avatar1.png', 'private/avatar2.png')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "path": "avatars/private/avatar2.png"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: none
	*   - `objects` table permissions: `insert` and `select`
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async copy(fromPath, toPath, options) {
        var _this7 = this;
        return _this7.handleOperation(async ()=>{
            return {
                path: (await $d3773c76b69f8b27$var$post(_this7.fetch, `${_this7.url}/object/copy`, {
                    bucketId: _this7.bucketId,
                    sourceKey: fromPath,
                    destinationKey: toPath,
                    destinationBucket: options === null || options === void 0 ? void 0 : options.destinationBucket
                }, {
                    headers: _this7.headers
                })).Key
            };
        });
    }
    /**
	* Creates a signed URL. Use a signed URL to share a file for a fixed amount of time.
	*
	* @category Storage
	* @subcategory File Buckets
	* @param path The file path, including the current file name. For example `folder/image.png`.
	* @param expiresIn The number of seconds until the signed URL expires. For example, `60` for a URL which is valid for one minute.
	* @param options.download triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
	* @param options.transform Transform the asset before serving it to the client.
	* @param options.cacheNonce Append a cache nonce parameter to the URL to invalidate the cache.
	* @returns Promise with response containing signed URL or error
	*
	* @example Create Signed URL
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .createSignedUrl('folder/avatar1.png', 60)
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "signedUrl": "https://example.supabase.co/storage/v1/object/sign/avatars/folder/avatar1.png?token=<TOKEN>"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @example Create a signed URL for an asset with transformations
	* ```js
	* const { data } = await supabase
	*   .storage
	*   .from('avatars')
	*   .createSignedUrl('folder/avatar1.png', 60, {
	*     transform: {
	*       width: 100,
	*       height: 100,
	*     }
	*   })
	* ```
	*
	* @example Create a signed URL which triggers the download of the asset
	* ```js
	* const { data } = await supabase
	*   .storage
	*   .from('avatars')
	*   .createSignedUrl('folder/avatar1.png', 60, {
	*     download: true,
	*   })
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: none
	*   - `objects` table permissions: `select`
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async createSignedUrl(path, expiresIn, options) {
        var _this8 = this;
        return _this8.handleOperation(async ()=>{
            let _path = _this8._getFinalPath(path);
            const hasTransform = typeof (options === null || options === void 0 ? void 0 : options.transform) === "object" && options.transform !== null && Object.keys(options.transform).length > 0;
            let data = await $d3773c76b69f8b27$var$post(_this8.fetch, `${_this8.url}/object/sign/${_path}`, $d3773c76b69f8b27$var$_objectSpread2({
                expiresIn: expiresIn
            }, hasTransform ? {
                transform: options.transform
            } : {}), {
                headers: _this8.headers
            });
            const query = new URLSearchParams();
            if (options === null || options === void 0 ? void 0 : options.download) query.set("download", options.download === true ? "" : options.download);
            if ((options === null || options === void 0 ? void 0 : options.cacheNonce) != null) query.set("cacheNonce", String(options.cacheNonce));
            const queryString = query.toString();
            return {
                signedUrl: encodeURI(`${_this8.url}${data.signedURL}${queryString ? `&${queryString}` : ""}`)
            };
        });
    }
    /**
	* Creates multiple signed URLs. Use a signed URL to share a file for a fixed amount of time.
	*
	* @category Storage
	* @subcategory File Buckets
	* @param paths The file paths to be downloaded, including the current file names. For example `['folder/image.png', 'folder2/image2.png']`.
	* @param expiresIn The number of seconds until the signed URLs expire. For example, `60` for URLs which are valid for one minute.
	* @param options.download triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
	* @param options.cacheNonce Append a cache nonce parameter to the URL to invalidate the cache.
	* @returns Promise with response containing array of objects with signedUrl, path, and error or error
	*
	* @example Create Signed URLs
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .createSignedUrls(['folder/avatar1.png', 'folder/avatar2.png'], 60)
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": [
	*     {
	*       "error": null,
	*       "path": "folder/avatar1.png",
	*       "signedURL": "/object/sign/avatars/folder/avatar1.png?token=<TOKEN>",
	*       "signedUrl": "https://example.supabase.co/storage/v1/object/sign/avatars/folder/avatar1.png?token=<TOKEN>"
	*     },
	*     {
	*       "error": null,
	*       "path": "folder/avatar2.png",
	*       "signedURL": "/object/sign/avatars/folder/avatar2.png?token=<TOKEN>",
	*       "signedUrl": "https://example.supabase.co/storage/v1/object/sign/avatars/folder/avatar2.png?token=<TOKEN>"
	*     }
	*   ],
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: none
	*   - `objects` table permissions: `select`
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async createSignedUrls(paths, expiresIn, options) {
        var _this9 = this;
        return _this9.handleOperation(async ()=>{
            const data = await $d3773c76b69f8b27$var$post(_this9.fetch, `${_this9.url}/object/sign/${_this9.bucketId}`, {
                expiresIn: expiresIn,
                paths: paths
            }, {
                headers: _this9.headers
            });
            const query = new URLSearchParams();
            if (options === null || options === void 0 ? void 0 : options.download) query.set("download", options.download === true ? "" : options.download);
            if ((options === null || options === void 0 ? void 0 : options.cacheNonce) != null) query.set("cacheNonce", String(options.cacheNonce));
            const queryString = query.toString();
            return data.map((datum)=>$d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, datum), {}, {
                    signedUrl: datum.signedURL ? encodeURI(`${_this9.url}${datum.signedURL}${queryString ? `&${queryString}` : ""}`) : null
                }));
        });
    }
    /**
	* Downloads a file from a private bucket. For public buckets, make a request to the URL returned from `getPublicUrl` instead.
	*
	* @category Storage
	* @subcategory File Buckets
	* @param path The full path and file name of the file to be downloaded. For example `folder/image.png`.
	* @param options.transform Transform the asset before serving it to the client.
	* @param options.cacheNonce Append a cache nonce parameter to the URL to invalidate the cache.
	* @param parameters Additional fetch parameters like signal for cancellation. Supports standard fetch options including cache control.
	* @returns BlobDownloadBuilder instance for downloading the file
	*
	* @example Download file
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .download('folder/avatar1.png')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": <BLOB>,
	*   "error": null
	* }
	* ```
	*
	* @example Download file with transformations
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .download('folder/avatar1.png', {
	*     transform: {
	*       width: 100,
	*       height: 100,
	*       quality: 80
	*     }
	*   })
	* ```
	*
	* @example Download with cache control (useful in Edge Functions)
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .download('folder/avatar1.png', {}, { cache: 'no-store' })
	* ```
	*
	* @example Download with abort signal
	* ```js
	* const controller = new AbortController()
	* setTimeout(() => controller.abort(), 5000)
	*
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .download('folder/avatar1.png', {}, { signal: controller.signal })
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: none
	*   - `objects` table permissions: `select`
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ download(path, options, parameters) {
        const renderPath = typeof (options === null || options === void 0 ? void 0 : options.transform) === "object" && options.transform !== null && Object.keys(options.transform).length > 0 ? "render/image/authenticated" : "object";
        const query = new URLSearchParams();
        if (options === null || options === void 0 ? void 0 : options.transform) this.applyTransformOptsToQuery(query, options.transform);
        if ((options === null || options === void 0 ? void 0 : options.cacheNonce) != null) query.set("cacheNonce", String(options.cacheNonce));
        const queryString = query.toString();
        const _path = this._getFinalPath(path);
        const downloadFn = ()=>$d3773c76b69f8b27$var$get(this.fetch, `${this.url}/${renderPath}/${_path}${queryString ? `?${queryString}` : ""}`, {
                headers: this.headers,
                noResolveJson: true
            }, parameters);
        return new $d3773c76b69f8b27$var$BlobDownloadBuilder(downloadFn, this.shouldThrowOnError);
    }
    /**
	* Retrieves the details of an existing file.
	*
	* Returns detailed file metadata including size, content type, and timestamps.
	* Note: The API returns `last_modified` field, not `updated_at`.
	*
	* @category Storage
	* @subcategory File Buckets
	* @param path The file path, including the file name. For example `folder/image.png`.
	* @returns Promise with response containing file metadata or error
	*
	* @example Get file info
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .info('folder/avatar1.png')
	*
	* if (data) {
	*   console.log('Last modified:', data.lastModified)
	*   console.log('Size:', data.size)
	* }
	* ```
	*/ async info(path) {
        var _this10 = this;
        const _path = _this10._getFinalPath(path);
        return _this10.handleOperation(async ()=>{
            return $d3773c76b69f8b27$var$recursiveToCamel(await $d3773c76b69f8b27$var$get(_this10.fetch, `${_this10.url}/object/info/${_path}`, {
                headers: _this10.headers
            }));
        });
    }
    /**
	* Checks the existence of a file.
	*
	* @category Storage
	* @subcategory File Buckets
	* @param path The file path, including the file name. For example `folder/image.png`.
	* @returns Promise with response containing boolean indicating file existence or error
	*
	* @example Check file existence
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .exists('folder/avatar1.png')
	* ```
	*/ async exists(path) {
        var _this11 = this;
        const _path = _this11._getFinalPath(path);
        try {
            await $d3773c76b69f8b27$var$head(_this11.fetch, `${_this11.url}/object/${_path}`, {
                headers: _this11.headers
            });
            return {
                data: true,
                error: null
            };
        } catch (error) {
            if (_this11.shouldThrowOnError) throw error;
            if ($d3773c76b69f8b27$export$5a322e77e5eb0561(error)) {
                var _error$originalError;
                const status = error instanceof $d3773c76b69f8b27$export$ca9ecfd959b3871c ? error.status : error instanceof $d3773c76b69f8b27$export$29127ca2e1a271d ? (_error$originalError = error.originalError) === null || _error$originalError === void 0 ? void 0 : _error$originalError.status : void 0;
                if (status !== void 0 && [
                    400,
                    404
                ].includes(status)) return {
                    data: false,
                    error: error
                };
            }
            throw error;
        }
    }
    /**
	* A simple convenience function to get the URL for an asset in a public bucket. If you do not want to use this function, you can construct the public URL by concatenating the bucket URL with the path to the asset.
	* This function does not verify if the bucket is public. If a public URL is created for a bucket which is not public, you will not be able to download the asset.
	*
	* @category Storage
	* @subcategory File Buckets
	* @param path The path and name of the file to generate the public URL for. For example `folder/image.png`.
	* @param options.download Triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
	* @param options.transform Transform the asset before serving it to the client.
	* @param options.cacheNonce Append a cache nonce parameter to the URL to invalidate the cache.
	* @returns Object with public URL
	*
	* @example Returns the URL for an asset in a public bucket
	* ```js
	* const { data } = supabase
	*   .storage
	*   .from('public-bucket')
	*   .getPublicUrl('folder/avatar1.png')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "publicUrl": "https://example.supabase.co/storage/v1/object/public/public-bucket/folder/avatar1.png"
	*   }
	* }
	* ```
	*
	* @example Returns the URL for an asset in a public bucket with transformations
	* ```js
	* const { data } = supabase
	*   .storage
	*   .from('public-bucket')
	*   .getPublicUrl('folder/avatar1.png', {
	*     transform: {
	*       width: 100,
	*       height: 100,
	*     }
	*   })
	* ```
	*
	* @example Returns the URL which triggers the download of an asset in a public bucket
	* ```js
	* const { data } = supabase
	*   .storage
	*   .from('public-bucket')
	*   .getPublicUrl('folder/avatar1.png', {
	*     download: true,
	*   })
	* ```
	*
	* @remarks
	* - The bucket needs to be set to public, either via [updateBucket()](/docs/reference/javascript/storage-updatebucket) or by going to Storage on [supabase.com/dashboard](https://supabase.com/dashboard), clicking the overflow menu on a bucket and choosing "Make public"
	* - RLS policy permissions required:
	*   - `buckets` table permissions: none
	*   - `objects` table permissions: none
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ getPublicUrl(path, options) {
        const _path = this._getFinalPath(path);
        const query = new URLSearchParams();
        if (options === null || options === void 0 ? void 0 : options.download) query.set("download", options.download === true ? "" : options.download);
        if (options === null || options === void 0 ? void 0 : options.transform) this.applyTransformOptsToQuery(query, options.transform);
        if ((options === null || options === void 0 ? void 0 : options.cacheNonce) != null) query.set("cacheNonce", String(options.cacheNonce));
        const queryString = query.toString();
        const renderPath = typeof (options === null || options === void 0 ? void 0 : options.transform) === "object" && options.transform !== null && Object.keys(options.transform).length > 0 ? "render/image" : "object";
        return {
            data: {
                publicUrl: encodeURI(`${this.url}/${renderPath}/public/${_path}`) + (queryString ? `?${queryString}` : "")
            }
        };
    }
    /**
	* Deletes files within the same bucket
	*
	* Returns an array of FileObject entries for the deleted files. Note that deprecated
	* fields like `bucket_id` may or may not be present in the response - do not rely on them.
	*
	* @category Storage
	* @subcategory File Buckets
	* @param paths An array of files to delete, including the path and file name. For example [`'folder/image.png'`].
	* @returns Promise with response containing array of deleted file objects or error
	*
	* @example Delete file
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .remove(['folder/avatar1.png'])
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": [],
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: none
	*   - `objects` table permissions: `delete` and `select`
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async remove(paths) {
        var _this12 = this;
        return _this12.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$remove(_this12.fetch, `${_this12.url}/object/${_this12.bucketId}`, {
                prefixes: paths
            }, {
                headers: _this12.headers
            });
        });
    }
    /**
	* Get file metadata
	* @param id the file id to retrieve metadata
	*/ /**
	* Update file metadata
	* @param id the file id to update metadata
	* @param meta the new file metadata
	*/ /**
	* Lists all the files and folders within a path of the bucket.
	*
	* **Important:** For folder entries, fields like `id`, `updated_at`, `created_at`,
	* `last_accessed_at`, and `metadata` will be `null`. Only files have these fields populated.
	* Additionally, deprecated fields like `bucket_id`, `owner`, and `buckets` are NOT returned
	* by this method.
	*
	* @category Storage
	* @subcategory File Buckets
	* @param path The folder path.
	* @param options Search options including limit (defaults to 100), offset, sortBy, and search
	* @param parameters Optional fetch parameters including signal for cancellation
	* @returns Promise with response containing array of files/folders or error
	*
	* @example List files in a bucket
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .list('folder', {
	*     limit: 100,
	*     offset: 0,
	*     sortBy: { column: 'name', order: 'asc' },
	*   })
	*
	* // Handle files vs folders
	* data?.forEach(item => {
	*   if (item.id !== null) {
	*     // It's a file
	*     console.log('File:', item.name, 'Size:', item.metadata?.size)
	*   } else {
	*     // It's a folder
	*     console.log('Folder:', item.name)
	*   }
	* })
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "avatar1.png",
	*       "id": "e668cf7f-821b-4a2f-9dce-7dfa5dd1cfd2",
	*       "updated_at": "2024-05-22T23:06:05.580Z",
	*       "created_at": "2024-05-22T23:04:34.443Z",
	*       "last_accessed_at": "2024-05-22T23:04:34.443Z",
	*       "metadata": {
	*         "eTag": "\"c5e8c553235d9af30ef4f6e280790b92\"",
	*         "size": 32175,
	*         "mimetype": "image/png",
	*         "cacheControl": "max-age=3600",
	*         "lastModified": "2024-05-22T23:06:05.574Z",
	*         "contentLength": 32175,
	*         "httpStatusCode": 200
	*       }
	*     }
	*   ],
	*   "error": null
	* }
	* ```
	*
	* @example Search files in a bucket
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .list('folder', {
	*     limit: 100,
	*     offset: 0,
	*     sortBy: { column: 'name', order: 'asc' },
	*     search: 'jon'
	*   })
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: none
	*   - `objects` table permissions: `select`
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async list(path, options, parameters) {
        var _this13 = this;
        return _this13.handleOperation(async ()=>{
            const body = $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, $d3773c76b69f8b27$var$DEFAULT_SEARCH_OPTIONS), options), {}, {
                prefix: path || ""
            });
            return await $d3773c76b69f8b27$var$post(_this13.fetch, `${_this13.url}/object/list/${_this13.bucketId}`, body, {
                headers: _this13.headers
            }, parameters);
        });
    }
    /**
	* Lists all the files and folders within a bucket using the V2 API with pagination support.
	*
	* **Important:** Folder entries in the `folders` array only contain `name` and optionally `key` —
	* they have no `id`, timestamps, or `metadata` fields. Full file metadata is only available
	* on entries in the `objects` array.
	*
	* @experimental this method signature might change in the future
	*
	* @category Storage
	* @subcategory File Buckets
	* @param options Search options including prefix, cursor for pagination, limit, with_delimiter
	* @param parameters Optional fetch parameters including signal for cancellation
	* @returns Promise with response containing folders/objects arrays with pagination info or error
	*
	* @example List files with pagination
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .listV2({
	*     prefix: 'folder/',
	*     limit: 100,
	*   })
	*
	* // Handle pagination
	* if (data?.hasNext) {
	*   const nextPage = await supabase
	*     .storage
	*     .from('avatars')
	*     .listV2({
	*       prefix: 'folder/',
	*       cursor: data.nextCursor,
	*     })
	* }
	*
	* // Handle files vs folders
	* data?.objects.forEach(file => {
	*   if (file.id !== null) {
	*     console.log('File:', file.name, 'Size:', file.metadata?.size)
	*   }
	* })
	* data?.folders.forEach(folder => {
	*   console.log('Folder:', folder.name)
	* })
	* ```
	*/ async listV2(options, parameters) {
        var _this14 = this;
        return _this14.handleOperation(async ()=>{
            const body = $d3773c76b69f8b27$var$_objectSpread2({}, options);
            return await $d3773c76b69f8b27$var$post(_this14.fetch, `${_this14.url}/object/list-v2/${_this14.bucketId}`, body, {
                headers: _this14.headers
            }, parameters);
        });
    }
    encodeMetadata(metadata) {
        return JSON.stringify(metadata);
    }
    toBase64(data) {
        if (typeof $d3773c76b69f8b27$require$Buffer !== "undefined") return $d3773c76b69f8b27$require$Buffer.from(data).toString("base64");
        return btoa(data);
    }
    _getFinalPath(path) {
        return `${this.bucketId}/${path.replace(/^\/+/, "")}`;
    }
    _removeEmptyFolders(path) {
        return path.replace(/^\/|\/$/g, "").replace(/\/+/g, "/");
    }
    /** Modifies the `query`, appending values the from `transform` */ applyTransformOptsToQuery(query, transform) {
        if (transform.width) query.set("width", transform.width.toString());
        if (transform.height) query.set("height", transform.height.toString());
        if (transform.resize) query.set("resize", transform.resize);
        if (transform.format) query.set("format", transform.format);
        if (transform.quality) query.set("quality", transform.quality.toString());
        return query;
    }
};
//#endregion
//#region src/lib/version.ts
const $d3773c76b69f8b27$var$version = "2.105.3";
//#endregion
//#region src/lib/constants.ts
const $d3773c76b69f8b27$var$DEFAULT_HEADERS = {
    "X-Client-Info": `storage-js/${$d3773c76b69f8b27$var$version}`
};
//#endregion
//#region src/packages/StorageBucketApi.ts
var $d3773c76b69f8b27$var$StorageBucketApi = class extends $d3773c76b69f8b27$var$BaseApiClient {
    constructor(url, headers = {}, fetch$1, opts){
        const baseUrl = new URL(url);
        if (opts === null || opts === void 0 ? void 0 : opts.useNewHostname) {
            if (/supabase\.(co|in|red)$/.test(baseUrl.hostname) && !baseUrl.hostname.includes("storage.supabase.")) baseUrl.hostname = baseUrl.hostname.replace("supabase.", "storage.supabase.");
        }
        const finalUrl = baseUrl.href.replace(/\/$/, "");
        const finalHeaders = $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, $d3773c76b69f8b27$var$DEFAULT_HEADERS), headers);
        super(finalUrl, finalHeaders, fetch$1, "storage");
    }
    /**
	* Retrieves the details of all Storage buckets within an existing project.
	*
	* @category Storage
	* @subcategory File Buckets
	* @param options Query parameters for listing buckets
	* @param options.limit Maximum number of buckets to return
	* @param options.offset Number of buckets to skip
	* @param options.sortColumn Column to sort by ('id', 'name', 'created_at', 'updated_at')
	* @param options.sortOrder Sort order ('asc' or 'desc')
	* @param options.search Search term to filter bucket names
	* @returns Promise with response containing array of buckets or error
	*
	* @example List buckets
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .listBuckets()
	* ```
	*
	* @example List buckets with options
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .listBuckets({
	*     limit: 10,
	*     offset: 0,
	*     sortColumn: 'created_at',
	*     sortOrder: 'desc',
	*     search: 'prod'
	*   })
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: `select`
	*   - `objects` table permissions: none
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async listBuckets(options) {
        var _this = this;
        return _this.handleOperation(async ()=>{
            const queryString = _this.listBucketOptionsToQueryString(options);
            return await $d3773c76b69f8b27$var$get(_this.fetch, `${_this.url}/bucket${queryString}`, {
                headers: _this.headers
            });
        });
    }
    /**
	* Retrieves the details of an existing Storage bucket.
	*
	* @category Storage
	* @subcategory File Buckets
	* @param id The unique identifier of the bucket you would like to retrieve.
	* @returns Promise with response containing bucket details or error
	*
	* @example Get bucket
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .getBucket('avatars')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "id": "avatars",
	*     "name": "avatars",
	*     "owner": "",
	*     "public": false,
	*     "file_size_limit": 1024,
	*     "allowed_mime_types": [
	*       "image/png"
	*     ],
	*     "created_at": "2024-05-22T22:26:05.100Z",
	*     "updated_at": "2024-05-22T22:26:05.100Z"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: `select`
	*   - `objects` table permissions: none
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async getBucket(id) {
        var _this2 = this;
        return _this2.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$get(_this2.fetch, `${_this2.url}/bucket/${id}`, {
                headers: _this2.headers
            });
        });
    }
    /**
	* Creates a new Storage bucket
	*
	* @category Storage
	* @subcategory File Buckets
	* @param id A unique identifier for the bucket you are creating.
	* @param options.public The visibility of the bucket. Public buckets don't require an authorization token to download objects, but still require a valid token for all other operations. By default, buckets are private.
	* @param options.fileSizeLimit specifies the max file size in bytes that can be uploaded to this bucket.
	* The global file size limit takes precedence over this value.
	* The default value is null, which doesn't set a per bucket file size limit.
	* @param options.allowedMimeTypes specifies the allowed mime types that this bucket can accept during upload.
	* The default value is null, which allows files with all mime types to be uploaded.
	* Each mime type specified can be a wildcard, e.g. image/*, or a specific mime type, e.g. image/png.
	* @param options.type (private-beta) specifies the bucket type. see `BucketType` for more details.
	*   - default bucket type is `STANDARD`
	* @returns Promise with response containing newly created bucket name or error
	*
	* @example Create bucket
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .createBucket('avatars', {
	*     public: false,
	*     allowedMimeTypes: ['image/png'],
	*     fileSizeLimit: 1024
	*   })
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "name": "avatars"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: `insert`
	*   - `objects` table permissions: none
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async createBucket(id, options = {
        public: false
    }) {
        var _this3 = this;
        return _this3.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$post(_this3.fetch, `${_this3.url}/bucket`, {
                id: id,
                name: id,
                type: options.type,
                public: options.public,
                file_size_limit: options.fileSizeLimit,
                allowed_mime_types: options.allowedMimeTypes
            }, {
                headers: _this3.headers
            });
        });
    }
    /**
	* Updates a Storage bucket
	*
	* @category Storage
	* @subcategory File Buckets
	* @param id A unique identifier for the bucket you are updating.
	* @param options.public The visibility of the bucket. Public buckets don't require an authorization token to download objects, but still require a valid token for all other operations.
	* @param options.fileSizeLimit specifies the max file size in bytes that can be uploaded to this bucket.
	* The global file size limit takes precedence over this value.
	* The default value is null, which doesn't set a per bucket file size limit.
	* @param options.allowedMimeTypes specifies the allowed mime types that this bucket can accept during upload.
	* The default value is null, which allows files with all mime types to be uploaded.
	* Each mime type specified can be a wildcard, e.g. image/*, or a specific mime type, e.g. image/png.
	* @returns Promise with response containing success message or error
	*
	* @example Update bucket
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .updateBucket('avatars', {
	*     public: false,
	*     allowedMimeTypes: ['image/png'],
	*     fileSizeLimit: 1024
	*   })
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "message": "Successfully updated"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: `select` and `update`
	*   - `objects` table permissions: none
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async updateBucket(id, options) {
        var _this4 = this;
        return _this4.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$put(_this4.fetch, `${_this4.url}/bucket/${id}`, {
                id: id,
                name: id,
                public: options.public,
                file_size_limit: options.fileSizeLimit,
                allowed_mime_types: options.allowedMimeTypes
            }, {
                headers: _this4.headers
            });
        });
    }
    /**
	* Removes all objects inside a single bucket.
	*
	* @category Storage
	* @subcategory File Buckets
	* @param id The unique identifier of the bucket you would like to empty.
	* @returns Promise with success message or error
	*
	* @example Empty bucket
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .emptyBucket('avatars')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "message": "Successfully emptied"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: `select`
	*   - `objects` table permissions: `select` and `delete`
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async emptyBucket(id) {
        var _this5 = this;
        return _this5.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$post(_this5.fetch, `${_this5.url}/bucket/${id}/empty`, {}, {
                headers: _this5.headers
            });
        });
    }
    /**
	* Deletes an existing bucket. A bucket can't be deleted with existing objects inside it.
	* You must first `empty()` the bucket.
	*
	* @category Storage
	* @subcategory File Buckets
	* @param id The unique identifier of the bucket you would like to delete.
	* @returns Promise with success message or error
	*
	* @example Delete bucket
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .deleteBucket('avatars')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "message": "Successfully deleted"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: `select` and `delete`
	*   - `objects` table permissions: none
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async deleteBucket(id) {
        var _this6 = this;
        return _this6.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$remove(_this6.fetch, `${_this6.url}/bucket/${id}`, {}, {
                headers: _this6.headers
            });
        });
    }
    listBucketOptionsToQueryString(options) {
        const params = {};
        if (options) {
            if ("limit" in options) params.limit = String(options.limit);
            if ("offset" in options) params.offset = String(options.offset);
            if (options.search) params.search = options.search;
            if (options.sortColumn) params.sortColumn = options.sortColumn;
            if (options.sortOrder) params.sortOrder = options.sortOrder;
        }
        return Object.keys(params).length > 0 ? "?" + new URLSearchParams(params).toString() : "";
    }
};
//#endregion
//#region src/packages/StorageAnalyticsClient.ts
/**
* Client class for managing Analytics Buckets using Iceberg tables
* Provides methods for creating, listing, and deleting analytics buckets
*/ var $d3773c76b69f8b27$export$6be1752cbca4e2bf = class extends $d3773c76b69f8b27$var$BaseApiClient {
    /**
	* @alpha
	*
	* Creates a new StorageAnalyticsClient instance
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Storage
	* @subcategory Analytics Buckets
	* @param url - The base URL for the storage API
	* @param headers - HTTP headers to include in requests
	* @param fetch - Optional custom fetch implementation
	*
	* @example Using supabase-js (recommended)
	* ```typescript
	* import { createClient } from '@supabase/supabase-js'
	*
	* const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
	* const { data, error } = await supabase.storage.analytics.listBuckets()
	* ```
	*
	* @example Standalone import for bundle-sensitive environments
	* ```typescript
	* import { StorageAnalyticsClient } from '@supabase/storage-js'
	*
	* const client = new StorageAnalyticsClient(url, headers)
	* ```
	*/ constructor(url, headers = {}, fetch$1){
        const finalUrl = url.replace(/\/$/, "");
        const finalHeaders = $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, $d3773c76b69f8b27$var$DEFAULT_HEADERS), headers);
        super(finalUrl, finalHeaders, fetch$1, "storage");
    }
    /**
	* @alpha
	*
	* Creates a new analytics bucket using Iceberg tables
	* Analytics buckets are optimized for analytical queries and data processing
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Storage
	* @subcategory Analytics Buckets
	* @param name A unique name for the bucket you are creating
	* @returns Promise with response containing newly created analytics bucket or error
	*
	* @example Create analytics bucket
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .analytics
	*   .createBucket('analytics-data')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "name": "analytics-data",
	*     "type": "ANALYTICS",
	*     "format": "iceberg",
	*     "created_at": "2024-05-22T22:26:05.100Z",
	*     "updated_at": "2024-05-22T22:26:05.100Z"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - Creates a new analytics bucket using Iceberg tables
	* - Analytics buckets are optimized for analytical queries and data processing
	*/ async createBucket(name) {
        var _this = this;
        return _this.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$post(_this.fetch, `${_this.url}/bucket`, {
                name: name
            }, {
                headers: _this.headers
            });
        });
    }
    /**
	* @alpha
	*
	* Retrieves the details of all Analytics Storage buckets within an existing project
	* Only returns buckets of type 'ANALYTICS'
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Storage
	* @subcategory Analytics Buckets
	* @param options Query parameters for listing buckets
	* @param options.limit Maximum number of buckets to return
	* @param options.offset Number of buckets to skip
	* @param options.sortColumn Column to sort by ('name', 'created_at', 'updated_at')
	* @param options.sortOrder Sort order ('asc' or 'desc')
	* @param options.search Search term to filter bucket names
	* @returns Promise with response containing array of analytics buckets or error
	*
	* @example List analytics buckets
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .analytics
	*   .listBuckets({
	*     limit: 10,
	*     offset: 0,
	*     sortColumn: 'created_at',
	*     sortOrder: 'desc'
	*   })
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "analytics-data",
	*       "type": "ANALYTICS",
	*       "format": "iceberg",
	*       "created_at": "2024-05-22T22:26:05.100Z",
	*       "updated_at": "2024-05-22T22:26:05.100Z"
	*     }
	*   ],
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - Retrieves the details of all Analytics Storage buckets within an existing project
	* - Only returns buckets of type 'ANALYTICS'
	*/ async listBuckets(options) {
        var _this2 = this;
        return _this2.handleOperation(async ()=>{
            const queryParams = new URLSearchParams();
            if ((options === null || options === void 0 ? void 0 : options.limit) !== void 0) queryParams.set("limit", options.limit.toString());
            if ((options === null || options === void 0 ? void 0 : options.offset) !== void 0) queryParams.set("offset", options.offset.toString());
            if (options === null || options === void 0 ? void 0 : options.sortColumn) queryParams.set("sortColumn", options.sortColumn);
            if (options === null || options === void 0 ? void 0 : options.sortOrder) queryParams.set("sortOrder", options.sortOrder);
            if (options === null || options === void 0 ? void 0 : options.search) queryParams.set("search", options.search);
            const queryString = queryParams.toString();
            const url = queryString ? `${_this2.url}/bucket?${queryString}` : `${_this2.url}/bucket`;
            return await $d3773c76b69f8b27$var$get(_this2.fetch, url, {
                headers: _this2.headers
            });
        });
    }
    /**
	* @alpha
	*
	* Deletes an existing analytics bucket
	* A bucket can't be deleted with existing objects inside it
	* You must first empty the bucket before deletion
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Storage
	* @subcategory Analytics Buckets
	* @param bucketName The unique identifier of the bucket you would like to delete
	* @returns Promise with response containing success message or error
	*
	* @example Delete analytics bucket
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .analytics
	*   .deleteBucket('analytics-data')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "message": "Successfully deleted"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - Deletes an analytics bucket
	*/ async deleteBucket(bucketName) {
        var _this3 = this;
        return _this3.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$remove(_this3.fetch, `${_this3.url}/bucket/${bucketName}`, {}, {
                headers: _this3.headers
            });
        });
    }
    /**
	* @alpha
	*
	* Get an Iceberg REST Catalog client configured for a specific analytics bucket
	* Use this to perform advanced table and namespace operations within the bucket
	* The returned client provides full access to the Apache Iceberg REST Catalog API
	* with the Supabase `{ data, error }` pattern for consistent error handling on all operations.
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Storage
	* @subcategory Analytics Buckets
	* @param bucketName - The name of the analytics bucket (warehouse) to connect to
	* @returns The wrapped Iceberg catalog client
	* @throws {StorageError} If the bucket name is invalid
	*
	* @example Get catalog and create table
	* ```js
	* // First, create an analytics bucket
	* const { data: bucket, error: bucketError } = await supabase
	*   .storage
	*   .analytics
	*   .createBucket('analytics-data')
	*
	* // Get the Iceberg catalog for that bucket
	* const catalog = supabase.storage.analytics.from('analytics-data')
	*
	* // Create a namespace
	* const { error: nsError } = await catalog.createNamespace({ namespace: ['default'] })
	*
	* // Create a table with schema
	* const { data: tableMetadata, error: tableError } = await catalog.createTable(
	*   { namespace: ['default'] },
	*   {
	*     name: 'events',
	*     schema: {
	*       type: 'struct',
	*       fields: [
	*         { id: 1, name: 'id', type: 'long', required: true },
	*         { id: 2, name: 'timestamp', type: 'timestamp', required: true },
	*         { id: 3, name: 'user_id', type: 'string', required: false }
	*       ],
	*       'schema-id': 0,
	*       'identifier-field-ids': [1]
	*     },
	*     'partition-spec': {
	*       'spec-id': 0,
	*       fields: []
	*     },
	*     'write-order': {
	*       'order-id': 0,
	*       fields: []
	*     },
	*     properties: {
	*       'write.format.default': 'parquet'
	*     }
	*   }
	* )
	* ```
	*
	* @example List tables in namespace
	* ```js
	* const catalog = supabase.storage.analytics.from('analytics-data')
	*
	* // List all tables in the default namespace
	* const { data: tables, error: listError } = await catalog.listTables({ namespace: ['default'] })
	* if (listError) {
	*   if (listError.isNotFound()) {
	*     console.log('Namespace not found')
	*   }
	*   return
	* }
	* console.log(tables) // [{ namespace: ['default'], name: 'events' }]
	* ```
	*
	* @example Working with namespaces
	* ```js
	* const catalog = supabase.storage.analytics.from('analytics-data')
	*
	* // List all namespaces
	* const { data: namespaces } = await catalog.listNamespaces()
	*
	* // Create namespace with properties
	* await catalog.createNamespace(
	*   { namespace: ['production'] },
	*   { properties: { owner: 'data-team', env: 'prod' } }
	* )
	* ```
	*
	* @example Cleanup operations
	* ```js
	* const catalog = supabase.storage.analytics.from('analytics-data')
	*
	* // Drop table with purge option (removes all data)
	* const { error: dropError } = await catalog.dropTable(
	*   { namespace: ['default'], name: 'events' },
	*   { purge: true }
	* )
	*
	* if (dropError?.isNotFound()) {
	*   console.log('Table does not exist')
	* }
	*
	* // Drop namespace (must be empty)
	* await catalog.dropNamespace({ namespace: ['default'] })
	* ```
	*
	* @remarks
	* This method provides a bridge between Supabase's bucket management and the standard
	* Apache Iceberg REST Catalog API. The bucket name maps to the Iceberg warehouse parameter.
	* All authentication and configuration is handled automatically using your Supabase credentials.
	*
	* **Error Handling**: Invalid bucket names throw immediately. All catalog
	* operations return `{ data, error }` where errors are `IcebergError` instances from iceberg-js.
	* Use helper methods like `error.isNotFound()` or check `error.status` for specific error handling.
	* Use `.throwOnError()` on the analytics client if you prefer exceptions for catalog operations.
	*
	* **Cleanup Operations**: When using `dropTable`, the `purge: true` option permanently
	* deletes all table data. Without it, the table is marked as deleted but data remains.
	*
	* **Library Dependency**: The returned catalog wraps `IcebergRestCatalog` from iceberg-js.
	* For complete API documentation and advanced usage, refer to the
	* [iceberg-js documentation](https://supabase.github.io/iceberg-js/).
	*/ from(bucketName) {
        var _this4 = this;
        if (!$d3773c76b69f8b27$var$isValidBucketName(bucketName)) throw new $d3773c76b69f8b27$export$697502632950e9d3("Invalid bucket name: File, folder, and bucket names must follow AWS object key naming guidelines and should avoid the use of any other characters.");
        const catalog = new (0, $b8Rhd.IcebergRestCatalog)({
            baseUrl: this.url,
            catalogName: bucketName,
            auth: {
                type: "custom",
                getHeaders: async ()=>_this4.headers
            },
            fetch: this.fetch
        });
        const shouldThrowOnError = this.shouldThrowOnError;
        return new Proxy(catalog, {
            get (target, prop) {
                const value = target[prop];
                if (typeof value !== "function") return value;
                return async (...args)=>{
                    try {
                        return {
                            data: await value.apply(target, args),
                            error: null
                        };
                    } catch (error) {
                        if (shouldThrowOnError) throw error;
                        return {
                            data: null,
                            error: error
                        };
                    }
                };
            }
        });
    }
};
//#endregion
//#region src/packages/VectorIndexApi.ts
/**
* @hidden
* Base implementation for vector index operations.
* Use {@link VectorBucketScope} via `supabase.storage.vectors.from('bucket')` instead.
*/ var $d3773c76b69f8b27$export$50097ff1e36420b1 = class extends $d3773c76b69f8b27$var$BaseApiClient {
    /** Creates a new VectorIndexApi instance */ constructor(url, headers = {}, fetch$1){
        const finalUrl = url.replace(/\/$/, "");
        const finalHeaders = $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, $d3773c76b69f8b27$var$DEFAULT_HEADERS), {}, {
            "Content-Type": "application/json"
        }, headers);
        super(finalUrl, finalHeaders, fetch$1, "vectors");
    }
    /** Creates a new vector index within a bucket */ async createIndex(options) {
        var _this = this;
        return _this.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$vectorsApi.post(_this.fetch, `${_this.url}/CreateIndex`, options, {
                headers: _this.headers
            }) || {};
        });
    }
    /** Retrieves metadata for a specific vector index */ async getIndex(vectorBucketName, indexName) {
        var _this2 = this;
        return _this2.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$vectorsApi.post(_this2.fetch, `${_this2.url}/GetIndex`, {
                vectorBucketName: vectorBucketName,
                indexName: indexName
            }, {
                headers: _this2.headers
            });
        });
    }
    /** Lists vector indexes within a bucket with optional filtering and pagination */ async listIndexes(options) {
        var _this3 = this;
        return _this3.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$vectorsApi.post(_this3.fetch, `${_this3.url}/ListIndexes`, options, {
                headers: _this3.headers
            });
        });
    }
    /** Deletes a vector index and all its data */ async deleteIndex(vectorBucketName, indexName) {
        var _this4 = this;
        return _this4.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$vectorsApi.post(_this4.fetch, `${_this4.url}/DeleteIndex`, {
                vectorBucketName: vectorBucketName,
                indexName: indexName
            }, {
                headers: _this4.headers
            }) || {};
        });
    }
};
//#endregion
//#region src/packages/VectorDataApi.ts
/**
* @hidden
* Base implementation for vector data operations.
* Use {@link VectorIndexScope} via `supabase.storage.vectors.from('bucket').index('idx')` instead.
*/ var $d3773c76b69f8b27$export$5f2a4b6b8397c039 = class extends $d3773c76b69f8b27$var$BaseApiClient {
    /** Creates a new VectorDataApi instance */ constructor(url, headers = {}, fetch$1){
        const finalUrl = url.replace(/\/$/, "");
        const finalHeaders = $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, $d3773c76b69f8b27$var$DEFAULT_HEADERS), {}, {
            "Content-Type": "application/json"
        }, headers);
        super(finalUrl, finalHeaders, fetch$1, "vectors");
    }
    /** Inserts or updates vectors in batch (1-500 per request) */ async putVectors(options) {
        var _this = this;
        if (options.vectors.length < 1 || options.vectors.length > 500) throw new Error("Vector batch size must be between 1 and 500 items");
        return _this.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$vectorsApi.post(_this.fetch, `${_this.url}/PutVectors`, options, {
                headers: _this.headers
            }) || {};
        });
    }
    /** Retrieves vectors by their keys in batch */ async getVectors(options) {
        var _this2 = this;
        return _this2.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$vectorsApi.post(_this2.fetch, `${_this2.url}/GetVectors`, options, {
                headers: _this2.headers
            });
        });
    }
    /** Lists vectors in an index with pagination */ async listVectors(options) {
        var _this3 = this;
        if (options.segmentCount !== void 0) {
            if (options.segmentCount < 1 || options.segmentCount > 16) throw new Error("segmentCount must be between 1 and 16");
            if (options.segmentIndex !== void 0) {
                if (options.segmentIndex < 0 || options.segmentIndex >= options.segmentCount) throw new Error(`segmentIndex must be between 0 and ${options.segmentCount - 1}`);
            }
        }
        return _this3.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$vectorsApi.post(_this3.fetch, `${_this3.url}/ListVectors`, options, {
                headers: _this3.headers
            });
        });
    }
    /** Queries for similar vectors using approximate nearest neighbor search */ async queryVectors(options) {
        var _this4 = this;
        return _this4.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$vectorsApi.post(_this4.fetch, `${_this4.url}/QueryVectors`, options, {
                headers: _this4.headers
            });
        });
    }
    /** Deletes vectors by their keys in batch (1-500 per request) */ async deleteVectors(options) {
        var _this5 = this;
        if (options.keys.length < 1 || options.keys.length > 500) throw new Error("Keys batch size must be between 1 and 500 items");
        return _this5.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$vectorsApi.post(_this5.fetch, `${_this5.url}/DeleteVectors`, options, {
                headers: _this5.headers
            }) || {};
        });
    }
};
//#endregion
//#region src/packages/VectorBucketApi.ts
/**
* @hidden
* Base implementation for vector bucket operations.
* Use {@link StorageVectorsClient} via `supabase.storage.vectors` instead.
*/ var $d3773c76b69f8b27$export$e8b640c07a633e69 = class extends $d3773c76b69f8b27$var$BaseApiClient {
    /** Creates a new VectorBucketApi instance */ constructor(url, headers = {}, fetch$1){
        const finalUrl = url.replace(/\/$/, "");
        const finalHeaders = $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, $d3773c76b69f8b27$var$DEFAULT_HEADERS), {}, {
            "Content-Type": "application/json"
        }, headers);
        super(finalUrl, finalHeaders, fetch$1, "vectors");
    }
    /** Creates a new vector bucket */ async createBucket(vectorBucketName) {
        var _this = this;
        return _this.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$vectorsApi.post(_this.fetch, `${_this.url}/CreateVectorBucket`, {
                vectorBucketName: vectorBucketName
            }, {
                headers: _this.headers
            }) || {};
        });
    }
    /** Retrieves metadata for a specific vector bucket */ async getBucket(vectorBucketName) {
        var _this2 = this;
        return _this2.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$vectorsApi.post(_this2.fetch, `${_this2.url}/GetVectorBucket`, {
                vectorBucketName: vectorBucketName
            }, {
                headers: _this2.headers
            });
        });
    }
    /** Lists vector buckets with optional filtering and pagination */ async listBuckets(options = {}) {
        var _this3 = this;
        return _this3.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$vectorsApi.post(_this3.fetch, `${_this3.url}/ListVectorBuckets`, options, {
                headers: _this3.headers
            });
        });
    }
    /** Deletes a vector bucket (must be empty first) */ async deleteBucket(vectorBucketName) {
        var _this4 = this;
        return _this4.handleOperation(async ()=>{
            return await $d3773c76b69f8b27$var$vectorsApi.post(_this4.fetch, `${_this4.url}/DeleteVectorBucket`, {
                vectorBucketName: vectorBucketName
            }, {
                headers: _this4.headers
            }) || {};
        });
    }
};
//#endregion
//#region src/packages/StorageVectorsClient.ts
/**
*
* @alpha
*
* Main client for interacting with S3 Vectors API
* Provides access to bucket, index, and vector data operations
*
* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
*
* **Usage Patterns:**
*
* ```typescript
* const { data, error } = await supabase
*  .storage
*  .vectors
*  .createBucket('embeddings-prod')
*
* // Access index operations via buckets
* const bucket = supabase.storage.vectors.from('embeddings-prod')
* await bucket.createIndex({
*   indexName: 'documents',
*   dataType: 'float32',
*   dimension: 1536,
*   distanceMetric: 'cosine'
* })
*
* // Access vector operations via index
* const index = bucket.index('documents')
* await index.putVectors({
*   vectors: [
*     { key: 'doc-1', data: { float32: [...] }, metadata: { title: 'Intro' } }
*   ]
* })
*
* // Query similar vectors
* const { data } = await index.queryVectors({
*   queryVector: { float32: [...] },
*   topK: 5,
*   returnDistance: true
* })
* ```
*/ var $d3773c76b69f8b27$export$f8cb34cab8a13f87 = class extends $d3773c76b69f8b27$export$e8b640c07a633e69 {
    /**
	* @alpha
	*
	* Creates a StorageVectorsClient that can manage buckets, indexes, and vectors.
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Storage
	* @subcategory Vector Buckets
	* @param url - Base URL of the Storage Vectors REST API.
	* @param options.headers - Optional headers (for example `Authorization`) applied to every request.
	* @param options.fetch - Optional custom `fetch` implementation for non-browser runtimes.
	*
	* @example Using supabase-js (recommended)
	* ```typescript
	* import { createClient } from '@supabase/supabase-js'
	*
	* const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
	* const bucket = supabase.storage.vectors.from('embeddings-prod')
	* ```
	*
	* @example Standalone import for bundle-sensitive environments
	* ```typescript
	* import { StorageVectorsClient } from '@supabase/storage-js'
	*
	* const client = new StorageVectorsClient(url, options)
	* ```
	*/ constructor(url, options = {}){
        super(url, options.headers || {}, options.fetch);
    }
    /**
	*
	* @alpha
	*
	* Access operations for a specific vector bucket
	* Returns a scoped client for index and vector operations within the bucket
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Storage
	* @subcategory Vector Buckets
	* @param vectorBucketName - Name of the vector bucket
	* @returns Bucket-scoped client with index and vector operations
	*
	* @example Accessing a vector bucket
	* ```typescript
	* const bucket = supabase.storage.vectors.from('embeddings-prod')
	* ```
	*/ from(vectorBucketName) {
        return new $d3773c76b69f8b27$export$5a6e64e51df41f53(this.url, this.headers, vectorBucketName, this.fetch);
    }
    /**
	*
	* @alpha
	*
	* Creates a new vector bucket
	* Vector buckets are containers for vector indexes and their data
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Storage
	* @subcategory Vector Buckets
	* @param vectorBucketName - Unique name for the vector bucket
	* @returns Promise with empty response on success or error
	*
	* @example Creating a vector bucket
	* ```typescript
	* const { data, error } = await supabase
	*   .storage
	*   .vectors
	*   .createBucket('embeddings-prod')
	* ```
	*/ async createBucket(vectorBucketName) {
        var _superprop_getCreateBucket = ()=>super.createBucket, _this = this;
        return _superprop_getCreateBucket().call(_this, vectorBucketName);
    }
    /**
	*
	* @alpha
	*
	* Retrieves metadata for a specific vector bucket
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Storage
	* @subcategory Vector Buckets
	* @param vectorBucketName - Name of the vector bucket
	* @returns Promise with bucket metadata or error
	*
	* @example Get bucket metadata
	* ```typescript
	* const { data, error } = await supabase
	*   .storage
	*   .vectors
	*   .getBucket('embeddings-prod')
	*
	* console.log('Bucket created:', data?.vectorBucket.creationTime)
	* ```
	*/ async getBucket(vectorBucketName) {
        var _superprop_getGetBucket = ()=>super.getBucket, _this2 = this;
        return _superprop_getGetBucket().call(_this2, vectorBucketName);
    }
    /**
	*
	* @alpha
	*
	* Lists all vector buckets with optional filtering and pagination
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Storage
	* @subcategory Vector Buckets
	* @param options - Optional filters (prefix, maxResults, nextToken)
	* @returns Promise with list of buckets or error
	*
	* @example List vector buckets
	* ```typescript
	* const { data, error } = await supabase
	*   .storage
	*   .vectors
	*   .listBuckets({ prefix: 'embeddings-' })
	*
	* data?.vectorBuckets.forEach(bucket => {
	*   console.log(bucket.vectorBucketName)
	* })
	* ```
	*/ async listBuckets(options = {}) {
        var _superprop_getListBuckets = ()=>super.listBuckets, _this3 = this;
        return _superprop_getListBuckets().call(_this3, options);
    }
    /**
	*
	* @alpha
	*
	* Deletes a vector bucket (bucket must be empty)
	* All indexes must be deleted before deleting the bucket
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Storage
	* @subcategory Vector Buckets
	* @param vectorBucketName - Name of the vector bucket to delete
	* @returns Promise with empty response on success or error
	*
	* @example Delete a vector bucket
	* ```typescript
	* const { data, error } = await supabase
	*   .storage
	*   .vectors
	*   .deleteBucket('embeddings-old')
	* ```
	*/ async deleteBucket(vectorBucketName) {
        var _superprop_getDeleteBucket = ()=>super.deleteBucket, _this4 = this;
        return _superprop_getDeleteBucket().call(_this4, vectorBucketName);
    }
};
/**
*
* @alpha
*
* Scoped client for operations within a specific vector bucket
* Provides index management and access to vector operations
*
* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
*/ var $d3773c76b69f8b27$export$5a6e64e51df41f53 = class extends $d3773c76b69f8b27$export$50097ff1e36420b1 {
    /**
	* @alpha
	*
	* Creates a helper that automatically scopes all index operations to the provided bucket.
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Storage
	* @subcategory Vector Buckets
	* @example Creating a vector bucket scope
	* ```typescript
	* const bucket = supabase.storage.vectors.from('embeddings-prod')
	* ```
	*/ constructor(url, headers, vectorBucketName, fetch$1){
        super(url, headers, fetch$1);
        this.vectorBucketName = vectorBucketName;
    }
    /**
	*
	* @alpha
	*
	* Creates a new vector index in this bucket
	* Convenience method that automatically includes the bucket name
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Storage
	* @subcategory Vector Buckets
	* @param options - Index configuration (vectorBucketName is automatically set)
	* @returns Promise with empty response on success or error
	*
	* @example Creating a vector index
	* ```typescript
	* const bucket = supabase.storage.vectors.from('embeddings-prod')
	* await bucket.createIndex({
	*   indexName: 'documents-openai',
	*   dataType: 'float32',
	*   dimension: 1536,
	*   distanceMetric: 'cosine',
	*   metadataConfiguration: {
	*     nonFilterableMetadataKeys: ['raw_text']
	*   }
	* })
	* ```
	*/ async createIndex(options) {
        var _superprop_getCreateIndex = ()=>super.createIndex, _this5 = this;
        return _superprop_getCreateIndex().call(_this5, $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, options), {}, {
            vectorBucketName: _this5.vectorBucketName
        }));
    }
    /**
	*
	* @alpha
	*
	* Lists indexes in this bucket
	* Convenience method that automatically includes the bucket name
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Storage
	* @subcategory Vector Buckets
	* @param options - Listing options (vectorBucketName is automatically set)
	* @returns Promise with response containing indexes array and pagination token or error
	*
	* @example List indexes
	* ```typescript
	* const bucket = supabase.storage.vectors.from('embeddings-prod')
	* const { data } = await bucket.listIndexes({ prefix: 'documents-' })
	* ```
	*/ async listIndexes(options = {}) {
        var _superprop_getListIndexes = ()=>super.listIndexes, _this6 = this;
        return _superprop_getListIndexes().call(_this6, $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, options), {}, {
            vectorBucketName: _this6.vectorBucketName
        }));
    }
    /**
	*
	* @alpha
	*
	* Retrieves metadata for a specific index in this bucket
	* Convenience method that automatically includes the bucket name
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Storage
	* @subcategory Vector Buckets
	* @param indexName - Name of the index to retrieve
	* @returns Promise with index metadata or error
	*
	* @example Get index metadata
	* ```typescript
	* const bucket = supabase.storage.vectors.from('embeddings-prod')
	* const { data } = await bucket.getIndex('documents-openai')
	* console.log('Dimension:', data?.index.dimension)
	* ```
	*/ async getIndex(indexName) {
        var _superprop_getGetIndex = ()=>super.getIndex, _this7 = this;
        return _superprop_getGetIndex().call(_this7, _this7.vectorBucketName, indexName);
    }
    /**
	*
	* @alpha
	*
	* Deletes an index from this bucket
	* Convenience method that automatically includes the bucket name
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Storage
	* @subcategory Vector Buckets
	* @param indexName - Name of the index to delete
	* @returns Promise with empty response on success or error
	*
	* @example Delete an index
	* ```typescript
	* const bucket = supabase.storage.vectors.from('embeddings-prod')
	* await bucket.deleteIndex('old-index')
	* ```
	*/ async deleteIndex(indexName) {
        var _superprop_getDeleteIndex = ()=>super.deleteIndex, _this8 = this;
        return _superprop_getDeleteIndex().call(_this8, _this8.vectorBucketName, indexName);
    }
    /**
	*
	* @alpha
	*
	* Access operations for a specific index within this bucket
	* Returns a scoped client for vector data operations
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Storage
	* @subcategory Vector Buckets
	* @param indexName - Name of the index
	* @returns Index-scoped client with vector data operations
	*
	* @example Accessing an index
	* ```typescript
	* const index = supabase.storage.vectors.from('embeddings-prod').index('documents-openai')
	*
	* // Insert vectors
	* await index.putVectors({
	*   vectors: [
	*     { key: 'doc-1', data: { float32: [...] }, metadata: { title: 'Intro' } }
	*   ]
	* })
	*
	* // Query similar vectors
	* const { data } = await index.queryVectors({
	*   queryVector: { float32: [...] },
	*   topK: 5
	* })
	* ```
	*/ index(indexName) {
        return new $d3773c76b69f8b27$export$bb92e54e27a7dace(this.url, this.headers, this.vectorBucketName, indexName, this.fetch);
    }
};
/**
*
* @alpha
*
* Scoped client for operations within a specific vector index
* Provides vector data operations (put, get, list, query, delete)
*
* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
*/ var $d3773c76b69f8b27$export$bb92e54e27a7dace = class extends $d3773c76b69f8b27$export$5f2a4b6b8397c039 {
    /**
	*
	* @alpha
	*
	* Creates a helper that automatically scopes all vector operations to the provided bucket/index names.
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Storage
	* @subcategory Vector Buckets
	* @example Creating a vector index scope
	* ```typescript
	* const index = supabase.storage.vectors.from('embeddings-prod').index('documents-openai')
	* ```
	*/ constructor(url, headers, vectorBucketName, indexName, fetch$1){
        super(url, headers, fetch$1);
        this.vectorBucketName = vectorBucketName;
        this.indexName = indexName;
    }
    /**
	*
	* @alpha
	*
	* Inserts or updates vectors in this index
	* Convenience method that automatically includes bucket and index names
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Storage
	* @subcategory Vector Buckets
	* @param options - Vector insertion options (bucket and index names automatically set)
	* @returns Promise with empty response on success or error
	*
	* @example Insert vectors into an index
	* ```typescript
	* const index = supabase.storage.vectors.from('embeddings-prod').index('documents-openai')
	* await index.putVectors({
	*   vectors: [
	*     {
	*       key: 'doc-1',
	*       data: { float32: [0.1, 0.2, ...] },
	*       metadata: { title: 'Introduction', page: 1 }
	*     }
	*   ]
	* })
	* ```
	*/ async putVectors(options) {
        var _superprop_getPutVectors = ()=>super.putVectors, _this9 = this;
        return _superprop_getPutVectors().call(_this9, $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, options), {}, {
            vectorBucketName: _this9.vectorBucketName,
            indexName: _this9.indexName
        }));
    }
    /**
	*
	* @alpha
	*
	* Retrieves vectors by keys from this index
	* Convenience method that automatically includes bucket and index names
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Storage
	* @subcategory Vector Buckets
	* @param options - Vector retrieval options (bucket and index names automatically set)
	* @returns Promise with response containing vectors array or error
	*
	* @example Get vectors by keys
	* ```typescript
	* const index = supabase.storage.vectors.from('embeddings-prod').index('documents-openai')
	* const { data } = await index.getVectors({
	*   keys: ['doc-1', 'doc-2'],
	*   returnMetadata: true
	* })
	* ```
	*/ async getVectors(options) {
        var _superprop_getGetVectors = ()=>super.getVectors, _this10 = this;
        return _superprop_getGetVectors().call(_this10, $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, options), {}, {
            vectorBucketName: _this10.vectorBucketName,
            indexName: _this10.indexName
        }));
    }
    /**
	*
	* @alpha
	*
	* Lists vectors in this index with pagination
	* Convenience method that automatically includes bucket and index names
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Storage
	* @subcategory Vector Buckets
	* @param options - Listing options (bucket and index names automatically set)
	* @returns Promise with response containing vectors array and pagination token or error
	*
	* @example List vectors with pagination
	* ```typescript
	* const index = supabase.storage.vectors.from('embeddings-prod').index('documents-openai')
	* const { data } = await index.listVectors({
	*   maxResults: 500,
	*   returnMetadata: true
	* })
	* ```
	*/ async listVectors(options = {}) {
        var _superprop_getListVectors = ()=>super.listVectors, _this11 = this;
        return _superprop_getListVectors().call(_this11, $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, options), {}, {
            vectorBucketName: _this11.vectorBucketName,
            indexName: _this11.indexName
        }));
    }
    /**
	*
	* @alpha
	*
	* Queries for similar vectors in this index
	* Convenience method that automatically includes bucket and index names
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Storage
	* @subcategory Vector Buckets
	* @param options - Query options (bucket and index names automatically set)
	* @returns Promise with response containing matches array of similar vectors ordered by distance or error
	*
	* @example Query similar vectors
	* ```typescript
	* const index = supabase.storage.vectors.from('embeddings-prod').index('documents-openai')
	* const { data } = await index.queryVectors({
	*   queryVector: { float32: [0.1, 0.2, ...] },
	*   topK: 5,
	*   filter: { category: 'technical' },
	*   returnDistance: true,
	*   returnMetadata: true
	* })
	* ```
	*/ async queryVectors(options) {
        var _superprop_getQueryVectors = ()=>super.queryVectors, _this12 = this;
        return _superprop_getQueryVectors().call(_this12, $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, options), {}, {
            vectorBucketName: _this12.vectorBucketName,
            indexName: _this12.indexName
        }));
    }
    /**
	*
	* @alpha
	*
	* Deletes vectors by keys from this index
	* Convenience method that automatically includes bucket and index names
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Storage
	* @subcategory Vector Buckets
	* @param options - Deletion options (bucket and index names automatically set)
	* @returns Promise with empty response on success or error
	*
	* @example Delete vectors by keys
	* ```typescript
	* const index = supabase.storage.vectors.from('embeddings-prod').index('documents-openai')
	* await index.deleteVectors({
	*   keys: ['doc-1', 'doc-2', 'doc-3']
	* })
	* ```
	*/ async deleteVectors(options) {
        var _superprop_getDeleteVectors = ()=>super.deleteVectors, _this13 = this;
        return _superprop_getDeleteVectors().call(_this13, $d3773c76b69f8b27$var$_objectSpread2($d3773c76b69f8b27$var$_objectSpread2({}, options), {}, {
            vectorBucketName: _this13.vectorBucketName,
            indexName: _this13.indexName
        }));
    }
};
//#endregion
//#region src/StorageClient.ts
var $d3773c76b69f8b27$export$6c85f5032e75eff9 = class extends $d3773c76b69f8b27$var$StorageBucketApi {
    /**
	* Creates a client for Storage buckets, files, analytics, and vectors.
	*
	* @category Storage
	* @subcategory File Buckets
	*
	* @example Using supabase-js (recommended)
	* ```ts
	* import { createClient } from '@supabase/supabase-js'
	*
	* const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
	* const avatars = supabase.storage.from('avatars')
	* ```
	*
	* @example Standalone import for bundle-sensitive environments
	* ```ts
	* import { StorageClient } from '@supabase/storage-js'
	*
	* const storage = new StorageClient('https://xyzcompany.supabase.co/storage/v1', {
	*   apikey: 'your-publishable-key',
	* })
	* const avatars = storage.from('avatars')
	* ```
	*/ constructor(url, headers = {}, fetch$1, opts){
        super(url, headers, fetch$1, opts);
    }
    /**
	* Perform file operation in a bucket.
	*
	* @category Storage
	* @subcategory File Buckets
	*
	* @param id The bucket id to operate on.
	*
	* @example Accessing a bucket
	* ```typescript
	* const avatars = supabase.storage.from('avatars')
	* ```
	*/ from(id) {
        return new $d3773c76b69f8b27$var$StorageFileApi(this.url, this.headers, id, this.fetch);
    }
    /**
	*
	* @alpha
	*
	* Access vector storage operations.
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Storage
	* @subcategory Vector Buckets
	*
	* @returns A StorageVectorsClient instance configured with the current storage settings.
	*/ get vectors() {
        return new $d3773c76b69f8b27$export$f8cb34cab8a13f87(this.url + "/vector", {
            headers: this.headers,
            fetch: this.fetch
        });
    }
    /**
	*
	* @alpha
	*
	* Access analytics storage operations using Iceberg tables.
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Storage
	* @subcategory Analytics Buckets
	*
	* @returns A StorageAnalyticsClient instance configured with the current storage settings.
	*/ get analytics() {
        return new $d3773c76b69f8b27$export$6be1752cbca4e2bf(this.url + "/iceberg", this.headers, this.fetch);
    }
};

});
parcelRegister("b8Rhd", function(module, exports) {

$parcel$export(module.exports, "IcebergRestCatalog", () => $9d579afbf8f344f3$export$1ccb0cb30480e317);
// src/errors/IcebergError.ts
var $9d579afbf8f344f3$export$5625de1fddd06f76 = class extends Error {
    constructor(message, opts){
        super(message);
        this.name = "IcebergError";
        this.status = opts.status;
        this.icebergType = opts.icebergType;
        this.icebergCode = opts.icebergCode;
        this.details = opts.details;
        this.isCommitStateUnknown = opts.icebergType === "CommitStateUnknownException" || [
            500,
            502,
            504
        ].includes(opts.status) && opts.icebergType?.includes("CommitState") === true;
    }
    /**
   * Returns true if the error is a 404 Not Found error.
   */ isNotFound() {
        return this.status === 404;
    }
    /**
   * Returns true if the error is a 409 Conflict error.
   */ isConflict() {
        return this.status === 409;
    }
    /**
   * Returns true if the error is a 419 Authentication Timeout error.
   */ isAuthenticationTimeout() {
        return this.status === 419;
    }
};
// src/utils/url.ts
function $9d579afbf8f344f3$var$buildUrl(baseUrl, path, query) {
    const url = new URL(path, baseUrl);
    if (query) {
        for (const [key, value] of Object.entries(query))if (value !== void 0) url.searchParams.set(key, value);
    }
    return url.toString();
}
// src/http/createFetchClient.ts
async function $9d579afbf8f344f3$var$buildAuthHeaders(auth) {
    if (!auth || auth.type === "none") return {};
    if (auth.type === "bearer") return {
        Authorization: `Bearer ${auth.token}`
    };
    if (auth.type === "header") return {
        [auth.name]: auth.value
    };
    if (auth.type === "custom") return await auth.getHeaders();
    return {};
}
function $9d579afbf8f344f3$var$createFetchClient(options) {
    const fetchFn = options.fetchImpl ?? globalThis.fetch;
    return {
        async request ({ method: method, path: path, query: query, body: body, headers: headers }) {
            const url = $9d579afbf8f344f3$var$buildUrl(options.baseUrl, path, query);
            const authHeaders = await $9d579afbf8f344f3$var$buildAuthHeaders(options.auth);
            const res = await fetchFn(url, {
                method: method,
                headers: {
                    ...body ? {
                        "Content-Type": "application/json"
                    } : {},
                    ...authHeaders,
                    ...headers
                },
                body: body ? JSON.stringify(body) : void 0
            });
            const text = await res.text();
            const isJson = (res.headers.get("content-type") || "").includes("application/json");
            const data = isJson && text ? JSON.parse(text) : text;
            if (!res.ok) {
                const errBody = isJson ? data : void 0;
                const errorDetail = errBody?.error;
                throw new $9d579afbf8f344f3$export$5625de1fddd06f76(errorDetail?.message ?? `Request failed with status ${res.status}`, {
                    status: res.status,
                    icebergType: errorDetail?.type,
                    icebergCode: errorDetail?.code,
                    details: errBody
                });
            }
            return {
                status: res.status,
                headers: res.headers,
                data: data
            };
        }
    };
}
// src/catalog/namespaces.ts
function $9d579afbf8f344f3$var$namespaceToPath(namespace) {
    return namespace.join("");
}
var $9d579afbf8f344f3$var$NamespaceOperations = class {
    constructor(client, prefix = ""){
        this.client = client;
        this.prefix = prefix;
    }
    async listNamespaces(parent) {
        const query = parent ? {
            parent: $9d579afbf8f344f3$var$namespaceToPath(parent.namespace)
        } : void 0;
        const response = await this.client.request({
            method: "GET",
            path: `${this.prefix}/namespaces`,
            query: query
        });
        return response.data.namespaces.map((ns)=>({
                namespace: ns
            }));
    }
    async createNamespace(id, metadata) {
        const request = {
            namespace: id.namespace,
            properties: metadata?.properties
        };
        const response = await this.client.request({
            method: "POST",
            path: `${this.prefix}/namespaces`,
            body: request
        });
        return response.data;
    }
    async dropNamespace(id) {
        await this.client.request({
            method: "DELETE",
            path: `${this.prefix}/namespaces/${$9d579afbf8f344f3$var$namespaceToPath(id.namespace)}`
        });
    }
    async loadNamespaceMetadata(id) {
        const response = await this.client.request({
            method: "GET",
            path: `${this.prefix}/namespaces/${$9d579afbf8f344f3$var$namespaceToPath(id.namespace)}`
        });
        return {
            properties: response.data.properties
        };
    }
    async namespaceExists(id) {
        try {
            await this.client.request({
                method: "HEAD",
                path: `${this.prefix}/namespaces/${$9d579afbf8f344f3$var$namespaceToPath(id.namespace)}`
            });
            return true;
        } catch (error) {
            if (error instanceof $9d579afbf8f344f3$export$5625de1fddd06f76 && error.status === 404) return false;
            throw error;
        }
    }
    async createNamespaceIfNotExists(id, metadata) {
        try {
            return await this.createNamespace(id, metadata);
        } catch (error) {
            if (error instanceof $9d579afbf8f344f3$export$5625de1fddd06f76 && error.status === 409) return;
            throw error;
        }
    }
};
// src/catalog/tables.ts
function $9d579afbf8f344f3$var$namespaceToPath2(namespace) {
    return namespace.join("");
}
var $9d579afbf8f344f3$var$TableOperations = class {
    constructor(client, prefix = "", accessDelegation){
        this.client = client;
        this.prefix = prefix;
        this.accessDelegation = accessDelegation;
    }
    async listTables(namespace) {
        const response = await this.client.request({
            method: "GET",
            path: `${this.prefix}/namespaces/${$9d579afbf8f344f3$var$namespaceToPath2(namespace.namespace)}/tables`
        });
        return response.data.identifiers;
    }
    async createTable(namespace, request) {
        const headers = {};
        if (this.accessDelegation) headers["X-Iceberg-Access-Delegation"] = this.accessDelegation;
        const response = await this.client.request({
            method: "POST",
            path: `${this.prefix}/namespaces/${$9d579afbf8f344f3$var$namespaceToPath2(namespace.namespace)}/tables`,
            body: request,
            headers: headers
        });
        return response.data.metadata;
    }
    async updateTable(id, request) {
        const response = await this.client.request({
            method: "POST",
            path: `${this.prefix}/namespaces/${$9d579afbf8f344f3$var$namespaceToPath2(id.namespace)}/tables/${id.name}`,
            body: request
        });
        return {
            "metadata-location": response.data["metadata-location"],
            metadata: response.data.metadata
        };
    }
    async dropTable(id, options) {
        await this.client.request({
            method: "DELETE",
            path: `${this.prefix}/namespaces/${$9d579afbf8f344f3$var$namespaceToPath2(id.namespace)}/tables/${id.name}`,
            query: {
                purgeRequested: String(options?.purge ?? false)
            }
        });
    }
    async loadTable(id) {
        const headers = {};
        if (this.accessDelegation) headers["X-Iceberg-Access-Delegation"] = this.accessDelegation;
        const response = await this.client.request({
            method: "GET",
            path: `${this.prefix}/namespaces/${$9d579afbf8f344f3$var$namespaceToPath2(id.namespace)}/tables/${id.name}`,
            headers: headers
        });
        return response.data.metadata;
    }
    async tableExists(id) {
        const headers = {};
        if (this.accessDelegation) headers["X-Iceberg-Access-Delegation"] = this.accessDelegation;
        try {
            await this.client.request({
                method: "HEAD",
                path: `${this.prefix}/namespaces/${$9d579afbf8f344f3$var$namespaceToPath2(id.namespace)}/tables/${id.name}`,
                headers: headers
            });
            return true;
        } catch (error) {
            if (error instanceof $9d579afbf8f344f3$export$5625de1fddd06f76 && error.status === 404) return false;
            throw error;
        }
    }
    async createTableIfNotExists(namespace, request) {
        try {
            return await this.createTable(namespace, request);
        } catch (error) {
            if (error instanceof $9d579afbf8f344f3$export$5625de1fddd06f76 && error.status === 409) return await this.loadTable({
                namespace: namespace.namespace,
                name: request.name
            });
            throw error;
        }
    }
};
// src/catalog/IcebergRestCatalog.ts
var $9d579afbf8f344f3$export$1ccb0cb30480e317 = class {
    /**
   * Creates a new Iceberg REST Catalog client.
   *
   * @param options - Configuration options for the catalog client
   */ constructor(options){
        let prefix = "v1";
        if (options.catalogName) prefix += `/${options.catalogName}`;
        const baseUrl = options.baseUrl.endsWith("/") ? options.baseUrl : `${options.baseUrl}/`;
        this.client = $9d579afbf8f344f3$var$createFetchClient({
            baseUrl: baseUrl,
            auth: options.auth,
            fetchImpl: options.fetch
        });
        this.accessDelegation = options.accessDelegation?.join(",");
        this.namespaceOps = new $9d579afbf8f344f3$var$NamespaceOperations(this.client, prefix);
        this.tableOps = new $9d579afbf8f344f3$var$TableOperations(this.client, prefix, this.accessDelegation);
    }
    /**
   * Lists all namespaces in the catalog.
   *
   * @param parent - Optional parent namespace to list children under
   * @returns Array of namespace identifiers
   *
   * @example
   * ```typescript
   * // List all top-level namespaces
   * const namespaces = await catalog.listNamespaces();
   *
   * // List namespaces under a parent
   * const children = await catalog.listNamespaces({ namespace: ['analytics'] });
   * ```
   */ async listNamespaces(parent) {
        return this.namespaceOps.listNamespaces(parent);
    }
    /**
   * Creates a new namespace in the catalog.
   *
   * @param id - Namespace identifier to create
   * @param metadata - Optional metadata properties for the namespace
   * @returns Response containing the created namespace and its properties
   *
   * @example
   * ```typescript
   * const response = await catalog.createNamespace(
   *   { namespace: ['analytics'] },
   *   { properties: { owner: 'data-team' } }
   * );
   * console.log(response.namespace); // ['analytics']
   * console.log(response.properties); // { owner: 'data-team', ... }
   * ```
   */ async createNamespace(id, metadata) {
        return this.namespaceOps.createNamespace(id, metadata);
    }
    /**
   * Drops a namespace from the catalog.
   *
   * The namespace must be empty (contain no tables) before it can be dropped.
   *
   * @param id - Namespace identifier to drop
   *
   * @example
   * ```typescript
   * await catalog.dropNamespace({ namespace: ['analytics'] });
   * ```
   */ async dropNamespace(id) {
        await this.namespaceOps.dropNamespace(id);
    }
    /**
   * Loads metadata for a namespace.
   *
   * @param id - Namespace identifier to load
   * @returns Namespace metadata including properties
   *
   * @example
   * ```typescript
   * const metadata = await catalog.loadNamespaceMetadata({ namespace: ['analytics'] });
   * console.log(metadata.properties);
   * ```
   */ async loadNamespaceMetadata(id) {
        return this.namespaceOps.loadNamespaceMetadata(id);
    }
    /**
   * Lists all tables in a namespace.
   *
   * @param namespace - Namespace identifier to list tables from
   * @returns Array of table identifiers
   *
   * @example
   * ```typescript
   * const tables = await catalog.listTables({ namespace: ['analytics'] });
   * console.log(tables); // [{ namespace: ['analytics'], name: 'events' }, ...]
   * ```
   */ async listTables(namespace) {
        return this.tableOps.listTables(namespace);
    }
    /**
   * Creates a new table in the catalog.
   *
   * @param namespace - Namespace to create the table in
   * @param request - Table creation request including name, schema, partition spec, etc.
   * @returns Table metadata for the created table
   *
   * @example
   * ```typescript
   * const metadata = await catalog.createTable(
   *   { namespace: ['analytics'] },
   *   {
   *     name: 'events',
   *     schema: {
   *       type: 'struct',
   *       fields: [
   *         { id: 1, name: 'id', type: 'long', required: true },
   *         { id: 2, name: 'timestamp', type: 'timestamp', required: true }
   *       ],
   *       'schema-id': 0
   *     },
   *     'partition-spec': {
   *       'spec-id': 0,
   *       fields: [
   *         { source_id: 2, field_id: 1000, name: 'ts_day', transform: 'day' }
   *       ]
   *     }
   *   }
   * );
   * ```
   */ async createTable(namespace, request) {
        return this.tableOps.createTable(namespace, request);
    }
    /**
   * Updates an existing table's metadata.
   *
   * Can update the schema, partition spec, or properties of a table.
   *
   * @param id - Table identifier to update
   * @param request - Update request with fields to modify
   * @returns Response containing the metadata location and updated table metadata
   *
   * @example
   * ```typescript
   * const response = await catalog.updateTable(
   *   { namespace: ['analytics'], name: 'events' },
   *   {
   *     properties: { 'read.split.target-size': '134217728' }
   *   }
   * );
   * console.log(response['metadata-location']); // s3://...
   * console.log(response.metadata); // TableMetadata object
   * ```
   */ async updateTable(id, request) {
        return this.tableOps.updateTable(id, request);
    }
    /**
   * Drops a table from the catalog.
   *
   * @param id - Table identifier to drop
   *
   * @example
   * ```typescript
   * await catalog.dropTable({ namespace: ['analytics'], name: 'events' });
   * ```
   */ async dropTable(id, options) {
        await this.tableOps.dropTable(id, options);
    }
    /**
   * Loads metadata for a table.
   *
   * @param id - Table identifier to load
   * @returns Table metadata including schema, partition spec, location, etc.
   *
   * @example
   * ```typescript
   * const metadata = await catalog.loadTable({ namespace: ['analytics'], name: 'events' });
   * console.log(metadata.schema);
   * console.log(metadata.location);
   * ```
   */ async loadTable(id) {
        return this.tableOps.loadTable(id);
    }
    /**
   * Checks if a namespace exists in the catalog.
   *
   * @param id - Namespace identifier to check
   * @returns True if the namespace exists, false otherwise
   *
   * @example
   * ```typescript
   * const exists = await catalog.namespaceExists({ namespace: ['analytics'] });
   * console.log(exists); // true or false
   * ```
   */ async namespaceExists(id) {
        return this.namespaceOps.namespaceExists(id);
    }
    /**
   * Checks if a table exists in the catalog.
   *
   * @param id - Table identifier to check
   * @returns True if the table exists, false otherwise
   *
   * @example
   * ```typescript
   * const exists = await catalog.tableExists({ namespace: ['analytics'], name: 'events' });
   * console.log(exists); // true or false
   * ```
   */ async tableExists(id) {
        return this.tableOps.tableExists(id);
    }
    /**
   * Creates a namespace if it does not exist.
   *
   * If the namespace already exists, returns void. If created, returns the response.
   *
   * @param id - Namespace identifier to create
   * @param metadata - Optional metadata properties for the namespace
   * @returns Response containing the created namespace and its properties, or void if it already exists
   *
   * @example
   * ```typescript
   * const response = await catalog.createNamespaceIfNotExists(
   *   { namespace: ['analytics'] },
   *   { properties: { owner: 'data-team' } }
   * );
   * if (response) {
   *   console.log('Created:', response.namespace);
   * } else {
   *   console.log('Already exists');
   * }
   * ```
   */ async createNamespaceIfNotExists(id, metadata) {
        return this.namespaceOps.createNamespaceIfNotExists(id, metadata);
    }
    /**
   * Creates a table if it does not exist.
   *
   * If the table already exists, returns its metadata instead.
   *
   * @param namespace - Namespace to create the table in
   * @param request - Table creation request including name, schema, partition spec, etc.
   * @returns Table metadata for the created or existing table
   *
   * @example
   * ```typescript
   * const metadata = await catalog.createTableIfNotExists(
   *   { namespace: ['analytics'] },
   *   {
   *     name: 'events',
   *     schema: {
   *       type: 'struct',
   *       fields: [
   *         { id: 1, name: 'id', type: 'long', required: true },
   *         { id: 2, name: 'timestamp', type: 'timestamp', required: true }
   *       ],
   *       'schema-id': 0
   *     }
   *   }
   * );
   * ```
   */ async createTableIfNotExists(namespace, request) {
        return this.tableOps.createTableIfNotExists(namespace, request);
    }
};
// src/catalog/types.ts
var $9d579afbf8f344f3$var$DECIMAL_REGEX = /^decimal\s*\(\s*(\d+)\s*,\s*(\d+)\s*\)$/;
var $9d579afbf8f344f3$var$FIXED_REGEX = /^fixed\s*\[\s*(\d+)\s*\]$/;
function $9d579afbf8f344f3$export$31eb975fa3e9c1f6(type) {
    const match = type.match($9d579afbf8f344f3$var$DECIMAL_REGEX);
    if (!match) return null;
    return {
        precision: parseInt(match[1], 10),
        scale: parseInt(match[2], 10)
    };
}
function $9d579afbf8f344f3$export$43d56cf6240a0c0e(type) {
    const match = type.match($9d579afbf8f344f3$var$FIXED_REGEX);
    if (!match) return null;
    return {
        length: parseInt(match[1], 10)
    };
}
function $9d579afbf8f344f3$export$ec8cf417183662a1(type) {
    return $9d579afbf8f344f3$var$DECIMAL_REGEX.test(type);
}
function $9d579afbf8f344f3$export$9fafc1fb79bd852e(type) {
    return $9d579afbf8f344f3$var$FIXED_REGEX.test(type);
}
function $9d579afbf8f344f3$export$84255940fed2ec86(a, b) {
    const decimalA = $9d579afbf8f344f3$export$31eb975fa3e9c1f6(a);
    const decimalB = $9d579afbf8f344f3$export$31eb975fa3e9c1f6(b);
    if (decimalA && decimalB) return decimalA.precision === decimalB.precision && decimalA.scale === decimalB.scale;
    const fixedA = $9d579afbf8f344f3$export$43d56cf6240a0c0e(a);
    const fixedB = $9d579afbf8f344f3$export$43d56cf6240a0c0e(b);
    if (fixedA && fixedB) return fixedA.length === fixedB.length;
    return a === b;
}
function $9d579afbf8f344f3$export$d26e6db8c278e564(metadata) {
    return metadata.schemas.find((s)=>s["schema-id"] === metadata["current-schema-id"]);
}
 //# sourceMappingURL=index.mjs.map

});


parcelRegister("lpqci", function(module, exports) {

$parcel$export(module.exports, "AuthClient", () => (parcelRequire("aALRH")).default);

var $f8esb = parcelRequire("f8esb");

var $b083j = parcelRequire("b083j");

var $fCilG = parcelRequire("fCilG");

var $aALRH = parcelRequire("aALRH");
parcelRequire("39QCi");
parcelRequire("fTIQY");

var $gn0EB = parcelRequire("gn0EB");

});
parcelRegister("f8esb", function(module, exports) {

$parcel$export(module.exports, "default", () => $b042d08e69f8c3c9$export$2e2bcd8739ae039);

var $7WQrb = parcelRequire("7WQrb");

var $doWUR = parcelRequire("doWUR");

var $98hXt = parcelRequire("98hXt");

var $39QCi = parcelRequire("39QCi");

var $fTIQY = parcelRequire("fTIQY");
class $b042d08e69f8c3c9$export$2e2bcd8739ae039 {
    /**
     * Creates an admin API client that can be used to manage users and OAuth clients.
     *
     * @example Using supabase-js (recommended)
     * ```ts
     * import { createClient } from '@supabase/supabase-js'
     *
     * const supabase = createClient('https://xyzcompany.supabase.co', 'your-secret-key')
     * const { data, error } = await supabase.auth.admin.listUsers()
     * ```
     *
     * @example Standalone import for bundle-sensitive environments
     * ```ts
     * import { GoTrueAdminApi } from '@supabase/auth-js'
     *
     * const admin = new GoTrueAdminApi({
     *   url: 'https://xyzcompany.supabase.co/auth/v1',
     *   headers: { Authorization: `Bearer ${process.env.SUPABASE_SECRET_KEY}` },
     * })
     * ```
     */ constructor({ url: url = '', headers: headers = {}, fetch: fetch, experimental: experimental }){
        this.url = url;
        this.headers = headers;
        this.fetch = (0, $98hXt.resolveFetch)(fetch);
        this.experimental = experimental !== null && experimental !== void 0 ? experimental : {};
        this.mfa = {
            listFactors: this._listFactors.bind(this),
            deleteFactor: this._deleteFactor.bind(this)
        };
        this.oauth = {
            listClients: this._listOAuthClients.bind(this),
            createClient: this._createOAuthClient.bind(this),
            getClient: this._getOAuthClient.bind(this),
            updateClient: this._updateOAuthClient.bind(this),
            deleteClient: this._deleteOAuthClient.bind(this),
            regenerateClientSecret: this._regenerateOAuthClientSecret.bind(this)
        };
        this.customProviders = {
            listProviders: this._listCustomProviders.bind(this),
            createProvider: this._createCustomProvider.bind(this),
            getProvider: this._getCustomProvider.bind(this),
            updateProvider: this._updateCustomProvider.bind(this),
            deleteProvider: this._deleteCustomProvider.bind(this)
        };
        this.passkey = {
            listPasskeys: this._adminListPasskeys.bind(this),
            deletePasskey: this._adminDeletePasskey.bind(this)
        };
    }
    /**
     * Removes a logged-in session.
     * @param jwt A valid, logged-in JWT.
     * @param scope The logout sope.
     *
     * @category Auth
     * @subcategory Auth Admin
     */ async signOut(jwt, scope = (0, $39QCi.SIGN_OUT_SCOPES)[0]) {
        if ((0, $39QCi.SIGN_OUT_SCOPES).indexOf(scope) < 0) throw new Error(`@supabase/auth-js: Parameter scope must be one of ${(0, $39QCi.SIGN_OUT_SCOPES).join(', ')}`);
        try {
            await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/logout?scope=${scope}`, {
                headers: this.headers,
                jwt: jwt,
                noResolveJson: true
            });
            return {
                data: null,
                error: null
            };
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Sends an invite link to an email address.
     * @param email The email address of the user.
     * @param options Additional options to be included when inviting.
     *
     * @category Auth
     * @subcategory Auth Admin
     *
     * @remarks
     * - Sends an invite link to the user's email address.
     * - The `inviteUserByEmail()` method is typically used by administrators to invite users to join the application.
     * - Note that PKCE is not supported when using `inviteUserByEmail`. This is because the browser initiating the invite is often different from the browser accepting the invite which makes it difficult to provide the security guarantees required of the PKCE flow.
     *
     * @example Invite a user
     * ```js
     * const { data, error } = await supabase.auth.admin.inviteUserByEmail('email@example.com')
     * ```
     *
     * @exampleResponse Invite a user
     * ```json
     * {
     *   "data": {
     *     "user": {
     *       "id": "11111111-1111-1111-1111-111111111111",
     *       "aud": "authenticated",
     *       "role": "authenticated",
     *       "email": "example@email.com",
     *       "invited_at": "2024-01-01T00:00:00Z",
     *       "phone": "",
     *       "confirmation_sent_at": "2024-01-01T00:00:00Z",
     *       "app_metadata": {
     *         "provider": "email",
     *         "providers": [
     *           "email"
     *         ]
     *       },
     *       "user_metadata": {},
     *       "identities": [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "11111111-1111-1111-1111-111111111111",
     *           "user_id": "11111111-1111-1111-1111-111111111111",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": false,
     *             "phone_verified": false,
     *             "sub": "11111111-1111-1111-1111-111111111111"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "example@email.com"
     *         }
     *       ],
     *       "created_at": "2024-01-01T00:00:00Z",
     *       "updated_at": "2024-01-01T00:00:00Z",
     *       "is_anonymous": false
     *     }
     *   },
     *   "error": null
     * }
     * ```
     */ async inviteUserByEmail(email, options = {}) {
        try {
            return await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/invite`, {
                body: {
                    email: email,
                    data: options.data
                },
                headers: this.headers,
                redirectTo: options.redirectTo,
                xform: (0, $doWUR._userResponse)
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Generates email links and OTPs to be sent via a custom email provider.
     * @param email The user's email.
     * @param options.password User password. For signup only.
     * @param options.data Optional user metadata. For signup only.
     * @param options.redirectTo The redirect url which should be appended to the generated link
     *
     * @category Auth
     * @subcategory Auth Admin
     *
     * @remarks
     * - The following types can be passed into `generateLink()`: `signup`, `magiclink`, `invite`, `recovery`, `email_change_current`, `email_change_new`, `phone_change`.
     * - `generateLink()` only generates the email link for `email_change_email` if the **Secure email change** is enabled in your project's [email auth provider settings](/dashboard/project/_/auth/providers).
     * - `generateLink()` handles the creation of the user for `signup`, `invite` and `magiclink`.
     *
     * @example Generate a signup link
     * ```js
     * const { data, error } = await supabase.auth.admin.generateLink({
     *   type: 'signup',
     *   email: 'email@example.com',
     *   password: 'secret'
     * })
     * ```
     *
     * @exampleResponse Generate a signup link
     * ```json
     * {
     *   "data": {
     *     "properties": {
     *       "action_link": "<LINK_TO_SEND_TO_USER>",
     *       "email_otp": "999999",
     *       "hashed_token": "<HASHED_TOKEN",
     *       "redirect_to": "<REDIRECT_URL>",
     *       "verification_type": "signup"
     *     },
     *     "user": {
     *       "id": "11111111-1111-1111-1111-111111111111",
     *       "aud": "authenticated",
     *       "role": "authenticated",
     *       "email": "email@example.com",
     *       "phone": "",
     *       "confirmation_sent_at": "2024-01-01T00:00:00Z",
     *       "app_metadata": {
     *         "provider": "email",
     *         "providers": [
     *           "email"
     *         ]
     *       },
     *       "user_metadata": {},
     *       "identities": [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "11111111-1111-1111-1111-111111111111",
     *           "user_id": "11111111-1111-1111-1111-111111111111",
     *           "identity_data": {
     *             "email": "email@example.com",
     *             "email_verified": false,
     *             "phone_verified": false,
     *             "sub": "11111111-1111-1111-1111-111111111111"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "email@example.com"
     *         }
     *       ],
     *       "created_at": "2024-01-01T00:00:00Z",
     *       "updated_at": "2024-01-01T00:00:00Z",
     *       "is_anonymous": false
     *     }
     *   },
     *   "error": null
     * }
     * ```
     *
     * @example Generate an invite link
     * ```js
     * const { data, error } = await supabase.auth.admin.generateLink({
     *   type: 'invite',
     *   email: 'email@example.com'
     * })
     * ```
     *
     * @example Generate a magic link
     * ```js
     * const { data, error } = await supabase.auth.admin.generateLink({
     *   type: 'magiclink',
     *   email: 'email@example.com'
     * })
     * ```
     *
     * @example Generate a recovery link
     * ```js
     * const { data, error } = await supabase.auth.admin.generateLink({
     *   type: 'recovery',
     *   email: 'email@example.com'
     * })
     * ```
     *
     * @example Generate links to change current email address
     * ```js
     * // generate an email change link to be sent to the current email address
     * const { data, error } = await supabase.auth.admin.generateLink({
     *   type: 'email_change_current',
     *   email: 'current.email@example.com',
     *   newEmail: 'new.email@example.com'
     * })
     *
     * // generate an email change link to be sent to the new email address
     * const { data, error } = await supabase.auth.admin.generateLink({
     *   type: 'email_change_new',
     *   email: 'current.email@example.com',
     *   newEmail: 'new.email@example.com'
     * })
     * ```
     */ async generateLink(params) {
        try {
            const { options: options } = params, rest = (0, $7WQrb.__rest)(params, [
                "options"
            ]);
            const body = Object.assign(Object.assign({}, rest), options);
            if ('newEmail' in rest) {
                // replace newEmail with new_email in request body
                body.new_email = rest === null || rest === void 0 ? void 0 : rest.newEmail;
                delete body['newEmail'];
            }
            return await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/admin/generate_link`, {
                body: body,
                headers: this.headers,
                xform: (0, $doWUR._generateLinkResponse),
                redirectTo: options === null || options === void 0 ? void 0 : options.redirectTo
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: {
                    properties: null,
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    // User Admin API
    /**
     * Creates a new user.
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     *
     * @category Auth
     * @subcategory Auth Admin
     *
     * @remarks
     * - To confirm the user's email address or phone number, set `email_confirm` or `phone_confirm` to true. Both arguments default to false.
     * - `createUser()` will not send a confirmation email to the user. You can use [`inviteUserByEmail()`](/docs/reference/javascript/auth-admin-inviteuserbyemail) if you want to send them an email invite instead.
     * - If you are sure that the created user's email or phone number is legitimate and verified, you can set the `email_confirm` or `phone_confirm` param to `true`.
     *
     * @example With custom user metadata
     * ```js
     * const { data, error } = await supabase.auth.admin.createUser({
     *   email: 'user@email.com',
     *   password: 'password',
     *   user_metadata: { name: 'Yoda' }
     * })
     * ```
     *
     * @exampleResponse With custom user metadata
     * ```json
     * {
     *   data: {
     *     user: {
     *       id: '1',
     *       aud: 'authenticated',
     *       role: 'authenticated',
     *       email: 'example@email.com',
     *       email_confirmed_at: '2024-01-01T00:00:00Z',
     *       phone: '',
     *       confirmation_sent_at: '2024-01-01T00:00:00Z',
     *       confirmed_at: '2024-01-01T00:00:00Z',
     *       last_sign_in_at: '2024-01-01T00:00:00Z',
     *       app_metadata: {},
     *       user_metadata: {},
     *       identities: [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "1",
     *           "user_id": "1",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": true,
     *             "phone_verified": false,
     *             "sub": "1"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "email@example.com"
     *         },
     *       ],
     *       created_at: '2024-01-01T00:00:00Z',
     *       updated_at: '2024-01-01T00:00:00Z',
     *       is_anonymous: false,
     *     }
     *   }
     *   error: null
     * }
     * ```
     *
     * @example Auto-confirm the user's email
     * ```js
     * const { data, error } = await supabase.auth.admin.createUser({
     *   email: 'user@email.com',
     *   email_confirm: true
     * })
     * ```
     *
     * @example Auto-confirm the user's phone number
     * ```js
     * const { data, error } = await supabase.auth.admin.createUser({
     *   phone: '1234567890',
     *   phone_confirm: true
     * })
     * ```
     */ async createUser(attributes) {
        try {
            return await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/admin/users`, {
                body: attributes,
                headers: this.headers,
                xform: (0, $doWUR._userResponse)
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Get a list of users.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     * @param params An object which supports `page` and `perPage` as numbers, to alter the paginated results.
     *
     * @category Auth
     * @subcategory Auth Admin
     *
     * @remarks
     * - Defaults to return 50 users per page.
     *
     * @example Get a page of users
     * ```js
     * const { data: { users }, error } = await supabase.auth.admin.listUsers()
     * ```
     *
     * @example Paginated list of users
     * ```js
     * const { data: { users }, error } = await supabase.auth.admin.listUsers({
     *   page: 1,
     *   perPage: 1000
     * })
     * ```
     */ async listUsers(params) {
        var _a, _b, _c, _d, _e, _f, _g;
        try {
            const pagination = {
                nextPage: null,
                lastPage: 0,
                total: 0
            };
            const response = await (0, $doWUR._request)(this.fetch, 'GET', `${this.url}/admin/users`, {
                headers: this.headers,
                noResolveJson: true,
                query: {
                    page: (_b = (_a = params === null || params === void 0 ? void 0 : params.page) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '',
                    per_page: (_d = (_c = params === null || params === void 0 ? void 0 : params.perPage) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : ''
                },
                xform: (0, $doWUR._noResolveJsonResponse)
            });
            if (response.error) throw response.error;
            const users = await response.json();
            const total = (_e = response.headers.get('x-total-count')) !== null && _e !== void 0 ? _e : 0;
            const links = (_g = (_f = response.headers.get('link')) === null || _f === void 0 ? void 0 : _f.split(',')) !== null && _g !== void 0 ? _g : [];
            if (links.length > 0) {
                links.forEach((link)=>{
                    const page = parseInt(link.split(';')[0].split('=')[1].substring(0, 1));
                    const rel = JSON.parse(link.split(';')[1].split('=')[1]);
                    pagination[`${rel}Page`] = page;
                });
                pagination.total = parseInt(total);
            }
            return {
                data: Object.assign(Object.assign({}, users), pagination),
                error: null
            };
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: {
                    users: []
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Get user by id.
     *
     * @param uid The user's unique identifier
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     *
     * @category Auth
     * @subcategory Auth Admin
     *
     * @remarks
     * - Fetches the user object from the database based on the user's id.
     * - The `getUserById()` method requires the user's id which maps to the `auth.users.id` column.
     *
     * @example Fetch the user object using the access_token jwt
     * ```js
     * const { data, error } = await supabase.auth.admin.getUserById(1)
     * ```
     *
     * @exampleResponse Fetch the user object using the access_token jwt
     * ```json
     * {
     *   data: {
     *     user: {
     *       id: '1',
     *       aud: 'authenticated',
     *       role: 'authenticated',
     *       email: 'example@email.com',
     *       email_confirmed_at: '2024-01-01T00:00:00Z',
     *       phone: '',
     *       confirmation_sent_at: '2024-01-01T00:00:00Z',
     *       confirmed_at: '2024-01-01T00:00:00Z',
     *       last_sign_in_at: '2024-01-01T00:00:00Z',
     *       app_metadata: {},
     *       user_metadata: {},
     *       identities: [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "1",
     *           "user_id": "1",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": true,
     *             "phone_verified": false,
     *             "sub": "1"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "email@example.com"
     *         },
     *       ],
     *       created_at: '2024-01-01T00:00:00Z',
     *       updated_at: '2024-01-01T00:00:00Z',
     *       is_anonymous: false,
     *     }
     *   }
     *   error: null
     * }
     * ```
     */ async getUserById(uid) {
        (0, $98hXt.validateUUID)(uid);
        try {
            return await (0, $doWUR._request)(this.fetch, 'GET', `${this.url}/admin/users/${uid}`, {
                headers: this.headers,
                xform: (0, $doWUR._userResponse)
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Updates the user data. Changes are applied directly without confirmation flows.
     *
     * @param uid The user's unique identifier
     * @param attributes The data you want to update.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     *
     * @remarks
     * **Important:** This is a server-side operation and does **not** trigger client-side
     * `onAuthStateChange` listeners. The admin API has no connection to client state.
     *
     * To sync changes to the client after calling this method:
     * 1. On the client, call `supabase.auth.refreshSession()` to fetch the updated user data
     * 2. This will trigger the `TOKEN_REFRESHED` event and notify all listeners
     *
     * @example
     * ```typescript
     * // Server-side (Edge Function)
     * const { data, error } = await supabase.auth.admin.updateUserById(
     *   userId,
     *   { user_metadata: { preferences: { theme: 'dark' } } }
     * )
     *
     * // Client-side (to sync the changes)
     * const { data, error } = await supabase.auth.refreshSession()
     * // onAuthStateChange listeners will now be notified with updated user
     * ```
     *
     * @see {@link GoTrueClient.refreshSession} for syncing admin changes to the client
     * @see {@link GoTrueClient.updateUser} for client-side user updates (triggers listeners automatically)
     *
     * @category Auth
     * @subcategory Auth Admin
     *
     * @example Updates a user's email
     * ```js
     * const { data: user, error } = await supabase.auth.admin.updateUserById(
     *   '11111111-1111-1111-1111-111111111111',
     *   { email: 'new@email.com' }
     * )
     * ```
     *
     * @exampleResponse Updates a user's email
     * ```json
     * {
     *   "data": {
     *     "user": {
     *       "id": "11111111-1111-1111-1111-111111111111",
     *       "aud": "authenticated",
     *       "role": "authenticated",
     *       "email": "new@email.com",
     *       "email_confirmed_at": "2024-01-01T00:00:00Z",
     *       "phone": "",
     *       "confirmed_at": "2024-01-01T00:00:00Z",
     *       "recovery_sent_at": "2024-01-01T00:00:00Z",
     *       "last_sign_in_at": "2024-01-01T00:00:00Z",
     *       "app_metadata": {
     *         "provider": "email",
     *         "providers": [
     *           "email"
     *         ]
     *       },
     *       "user_metadata": {
     *         "email": "example@email.com",
     *         "email_verified": false,
     *         "phone_verified": false,
     *         "sub": "11111111-1111-1111-1111-111111111111"
     *       },
     *       "identities": [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "11111111-1111-1111-1111-111111111111",
     *           "user_id": "11111111-1111-1111-1111-111111111111",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": false,
     *             "phone_verified": false,
     *             "sub": "11111111-1111-1111-1111-111111111111"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "example@email.com"
     *         }
     *       ],
     *       "created_at": "2024-01-01T00:00:00Z",
     *       "updated_at": "2024-01-01T00:00:00Z",
     *       "is_anonymous": false
     *     }
     *   },
     *   "error": null
     * }
     * ```
     *
     * @example Updates a user's password
     * ```js
     * const { data: user, error } = await supabase.auth.admin.updateUserById(
     *   '6aa5d0d4-2a9f-4483-b6c8-0cf4c6c98ac4',
     *   { password: 'new_password' }
     * )
     * ```
     *
     * @example Updates a user's metadata
     * ```js
     * const { data: user, error } = await supabase.auth.admin.updateUserById(
     *   '6aa5d0d4-2a9f-4483-b6c8-0cf4c6c98ac4',
     *   { user_metadata: { hello: 'world' } }
     * )
     * ```
     *
     * @example Updates a user's app_metadata
     * ```js
     * const { data: user, error } = await supabase.auth.admin.updateUserById(
     *   '6aa5d0d4-2a9f-4483-b6c8-0cf4c6c98ac4',
     *   { app_metadata: { plan: 'trial' } }
     * )
     * ```
     *
     * @example Confirms a user's email address
     * ```js
     * const { data: user, error } = await supabase.auth.admin.updateUserById(
     *   '6aa5d0d4-2a9f-4483-b6c8-0cf4c6c98ac4',
     *   { email_confirm: true }
     * )
     * ```
     *
     * @example Confirms a user's phone number
     * ```js
     * const { data: user, error } = await supabase.auth.admin.updateUserById(
     *   '6aa5d0d4-2a9f-4483-b6c8-0cf4c6c98ac4',
     *   { phone_confirm: true }
     * )
     * ```
     *
     * @example Ban a user for 100 years
     * ```js
     * const { data: user, error } = await supabase.auth.admin.updateUserById(
     *   '6aa5d0d4-2a9f-4483-b6c8-0cf4c6c98ac4',
     *   { ban_duration: '876000h' }
     * )
     * ```
     */ async updateUserById(uid, attributes) {
        (0, $98hXt.validateUUID)(uid);
        try {
            return await (0, $doWUR._request)(this.fetch, 'PUT', `${this.url}/admin/users/${uid}`, {
                body: attributes,
                headers: this.headers,
                xform: (0, $doWUR._userResponse)
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Delete a user. Requires a `service_role` key.
     *
     * @param id The user id you want to remove.
     * @param shouldSoftDelete If true, then the user will be soft-deleted from the auth schema. Soft deletion allows user identification from the hashed user ID but is not reversible.
     * Defaults to false for backward compatibility.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     *
     * @category Auth
     * @subcategory Auth Admin
     *
     * @remarks
     * - The `deleteUser()` method requires the user's ID, which maps to the `auth.users.id` column.
     *
     * @example Removes a user
     * ```js
     * const { data, error } = await supabase.auth.admin.deleteUser(
     *   '715ed5db-f090-4b8c-a067-640ecee36aa0'
     * )
     * ```
     *
     * @exampleResponse Removes a user
     * ```json
     * {
     *   "data": {
     *     "user": {}
     *   },
     *   "error": null
     * }
     * ```
     */ async deleteUser(id, shouldSoftDelete = false) {
        (0, $98hXt.validateUUID)(id);
        try {
            return await (0, $doWUR._request)(this.fetch, 'DELETE', `${this.url}/admin/users/${id}`, {
                headers: this.headers,
                body: {
                    should_soft_delete: shouldSoftDelete
                },
                xform: (0, $doWUR._userResponse)
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    async _listFactors(params) {
        (0, $98hXt.validateUUID)(params.userId);
        try {
            const { data: data, error: error } = await (0, $doWUR._request)(this.fetch, 'GET', `${this.url}/admin/users/${params.userId}/factors`, {
                headers: this.headers,
                xform: (factors)=>{
                    return {
                        data: {
                            factors: factors
                        },
                        error: null
                    };
                }
            });
            return {
                data: data,
                error: error
            };
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    async _deleteFactor(params) {
        (0, $98hXt.validateUUID)(params.userId);
        (0, $98hXt.validateUUID)(params.id);
        try {
            const data = await (0, $doWUR._request)(this.fetch, 'DELETE', `${this.url}/admin/users/${params.userId}/factors/${params.id}`, {
                headers: this.headers
            });
            return {
                data: data,
                error: null
            };
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Lists all OAuth clients with optional pagination.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _listOAuthClients(params) {
        var _a, _b, _c, _d, _e, _f, _g;
        try {
            const pagination = {
                nextPage: null,
                lastPage: 0,
                total: 0
            };
            const response = await (0, $doWUR._request)(this.fetch, 'GET', `${this.url}/admin/oauth/clients`, {
                headers: this.headers,
                noResolveJson: true,
                query: {
                    page: (_b = (_a = params === null || params === void 0 ? void 0 : params.page) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '',
                    per_page: (_d = (_c = params === null || params === void 0 ? void 0 : params.perPage) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : ''
                },
                xform: (0, $doWUR._noResolveJsonResponse)
            });
            if (response.error) throw response.error;
            const clients = await response.json();
            const total = (_e = response.headers.get('x-total-count')) !== null && _e !== void 0 ? _e : 0;
            const links = (_g = (_f = response.headers.get('link')) === null || _f === void 0 ? void 0 : _f.split(',')) !== null && _g !== void 0 ? _g : [];
            if (links.length > 0) {
                links.forEach((link)=>{
                    const page = parseInt(link.split(';')[0].split('=')[1].substring(0, 1));
                    const rel = JSON.parse(link.split(';')[1].split('=')[1]);
                    pagination[`${rel}Page`] = page;
                });
                pagination.total = parseInt(total);
            }
            return {
                data: Object.assign(Object.assign({}, clients), pagination),
                error: null
            };
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: {
                    clients: []
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Creates a new OAuth client.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _createOAuthClient(params) {
        try {
            return await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/admin/oauth/clients`, {
                body: params,
                headers: this.headers,
                xform: (client)=>{
                    return {
                        data: client,
                        error: null
                    };
                }
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Gets details of a specific OAuth client.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _getOAuthClient(clientId) {
        try {
            return await (0, $doWUR._request)(this.fetch, 'GET', `${this.url}/admin/oauth/clients/${clientId}`, {
                headers: this.headers,
                xform: (client)=>{
                    return {
                        data: client,
                        error: null
                    };
                }
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Updates an existing OAuth client.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _updateOAuthClient(clientId, params) {
        try {
            return await (0, $doWUR._request)(this.fetch, 'PUT', `${this.url}/admin/oauth/clients/${clientId}`, {
                body: params,
                headers: this.headers,
                xform: (client)=>{
                    return {
                        data: client,
                        error: null
                    };
                }
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Deletes an OAuth client.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _deleteOAuthClient(clientId) {
        try {
            await (0, $doWUR._request)(this.fetch, 'DELETE', `${this.url}/admin/oauth/clients/${clientId}`, {
                headers: this.headers,
                noResolveJson: true
            });
            return {
                data: null,
                error: null
            };
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Regenerates the secret for an OAuth client.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _regenerateOAuthClientSecret(clientId) {
        try {
            return await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/admin/oauth/clients/${clientId}/regenerate_secret`, {
                headers: this.headers,
                xform: (client)=>{
                    return {
                        data: client,
                        error: null
                    };
                }
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Lists all custom providers with optional type filter.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _listCustomProviders(params) {
        try {
            const query = {};
            if (params === null || params === void 0 ? void 0 : params.type) query.type = params.type;
            return await (0, $doWUR._request)(this.fetch, 'GET', `${this.url}/admin/custom-providers`, {
                headers: this.headers,
                query: query,
                xform: (data)=>{
                    var _a;
                    return {
                        data: {
                            providers: (_a = data === null || data === void 0 ? void 0 : data.providers) !== null && _a !== void 0 ? _a : []
                        },
                        error: null
                    };
                }
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: {
                    providers: []
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Creates a new custom OIDC/OAuth provider.
     *
     * For OIDC providers, the server fetches and validates the OpenID Connect discovery document
     * from the issuer's well-known endpoint (or the provided `discovery_url`) at creation time.
     * This may return a validation error (`error_code: "validation_failed"`) if the discovery
     * document is unreachable, not valid JSON, missing required fields, or if the issuer
     * in the document does not match the expected issuer.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _createCustomProvider(params) {
        try {
            return await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/admin/custom-providers`, {
                body: params,
                headers: this.headers,
                xform: (provider)=>{
                    return {
                        data: provider,
                        error: null
                    };
                }
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Gets details of a specific custom provider by identifier.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _getCustomProvider(identifier) {
        try {
            return await (0, $doWUR._request)(this.fetch, 'GET', `${this.url}/admin/custom-providers/${identifier}`, {
                headers: this.headers,
                xform: (provider)=>{
                    return {
                        data: provider,
                        error: null
                    };
                }
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Updates an existing custom provider.
     *
     * When `issuer` or `discovery_url` is changed on an OIDC provider, the server re-fetches and
     * validates the discovery document before persisting. This may return a validation error
     * (`error_code: "validation_failed"`) if the discovery document is unreachable, invalid, or
     * the issuer does not match.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _updateCustomProvider(identifier, params) {
        try {
            return await (0, $doWUR._request)(this.fetch, 'PUT', `${this.url}/admin/custom-providers/${identifier}`, {
                body: params,
                headers: this.headers,
                xform: (provider)=>{
                    return {
                        data: provider,
                        error: null
                    };
                }
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Deletes a custom provider.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _deleteCustomProvider(identifier) {
        try {
            await (0, $doWUR._request)(this.fetch, 'DELETE', `${this.url}/admin/custom-providers/${identifier}`, {
                headers: this.headers,
                noResolveJson: true
            });
            return {
                data: null,
                error: null
            };
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Lists all passkeys for a user.
     *
     * This function should only be called on a server. Never expose your secret key in the browser.
     *
     * Requires `auth.experimental.passkey: true`.
     */ async _adminListPasskeys(params) {
        (0, $98hXt.assertPasskeyExperimentalEnabled)(this.experimental);
        (0, $98hXt.validateUUID)(params.userId);
        try {
            return await (0, $doWUR._request)(this.fetch, 'GET', `${this.url}/admin/users/${params.userId}/passkeys`, {
                headers: this.headers,
                xform: (data)=>({
                        data: data,
                        error: null
                    })
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Deletes a user's passkey.
     *
     * This function should only be called on a server. Never expose your secret key in the browser.
     *
     * Requires `auth.experimental.passkey: true`.
     */ async _adminDeletePasskey(params) {
        (0, $98hXt.assertPasskeyExperimentalEnabled)(this.experimental);
        (0, $98hXt.validateUUID)(params.userId);
        (0, $98hXt.validateUUID)(params.passkeyId);
        try {
            await (0, $doWUR._request)(this.fetch, 'DELETE', `${this.url}/admin/users/${params.userId}/passkeys/${params.passkeyId}`, {
                headers: this.headers,
                noResolveJson: true
            });
            return {
                data: null,
                error: null
            };
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
}

});
parcelRegister("doWUR", function(module, exports) {

$parcel$export(module.exports, "_request", () => $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd);
$parcel$export(module.exports, "_sessionResponse", () => $9c1b37c8edd4ca2b$export$273fe4673a018c2e);
$parcel$export(module.exports, "_sessionResponsePassword", () => $9c1b37c8edd4ca2b$export$db83aade1c2922c7);
$parcel$export(module.exports, "_userResponse", () => $9c1b37c8edd4ca2b$export$e20f488897843593);
$parcel$export(module.exports, "_ssoResponse", () => $9c1b37c8edd4ca2b$export$b04785c46dcd8f8b);
$parcel$export(module.exports, "_generateLinkResponse", () => $9c1b37c8edd4ca2b$export$f5eaa950605b2146);
$parcel$export(module.exports, "_noResolveJsonResponse", () => $9c1b37c8edd4ca2b$export$7aed01df6e045e31);

var $7WQrb = parcelRequire("7WQrb");

var $44TzP = parcelRequire("44TzP");

var $98hXt = parcelRequire("98hXt");

var $fTIQY = parcelRequire("fTIQY");
const $9c1b37c8edd4ca2b$var$_getErrorMessage = (err)=>{
    if (typeof err === 'object' && err !== null) {
        const e = err;
        if (typeof e.msg === 'string') return e.msg;
        if (typeof e.message === 'string') return e.message;
        if (typeof e.error_description === 'string') return e.error_description;
        if (typeof e.error === 'string') return e.error;
    }
    return JSON.stringify(err);
};
// 502, 503, 504: Standard server/gateway errors
// 520-524, 530: Cloudflare-specific error codes (web server down, connection timed out, etc.)
// These are infrastructure errors and should not cause session invalidation.
const $9c1b37c8edd4ca2b$var$NETWORK_ERROR_CODES = [
    502,
    503,
    504,
    520,
    521,
    522,
    523,
    524,
    530
];
async function $9c1b37c8edd4ca2b$export$d3da1ecaf1206c58(error) {
    var _a;
    if (!(0, $98hXt.looksLikeFetchResponse)(error)) throw new (0, $fTIQY.AuthRetryableFetchError)($9c1b37c8edd4ca2b$var$_getErrorMessage(error), 0);
    if ($9c1b37c8edd4ca2b$var$NETWORK_ERROR_CODES.includes(error.status)) // status in 500...599 range - server had an error, request might be retryed.
    throw new (0, $fTIQY.AuthRetryableFetchError)($9c1b37c8edd4ca2b$var$_getErrorMessage(error), error.status);
    let data;
    try {
        data = await error.json();
    } catch (e) {
        throw new (0, $fTIQY.AuthUnknownError)($9c1b37c8edd4ca2b$var$_getErrorMessage(e), e);
    }
    let errorCode = undefined;
    const responseAPIVersion = (0, $98hXt.parseResponseAPIVersion)(error);
    if (responseAPIVersion && responseAPIVersion.getTime() >= (0, $44TzP.API_VERSIONS)['2024-01-01'].timestamp && typeof data === 'object' && data && typeof data.code === 'string') errorCode = data.code;
    else if (typeof data === 'object' && data && typeof data.error_code === 'string') errorCode = data.error_code;
    if (!errorCode) {
        // Legacy support for weak password errors, when there were no error codes
        if (typeof data === 'object' && data && typeof data.weak_password === 'object' && data.weak_password && Array.isArray(data.weak_password.reasons) && data.weak_password.reasons.length && data.weak_password.reasons.reduce((a, i)=>a && typeof i === 'string', true)) throw new (0, $fTIQY.AuthWeakPasswordError)($9c1b37c8edd4ca2b$var$_getErrorMessage(data), error.status, data.weak_password.reasons);
    } else if (errorCode === 'weak_password') throw new (0, $fTIQY.AuthWeakPasswordError)($9c1b37c8edd4ca2b$var$_getErrorMessage(data), error.status, ((_a = data.weak_password) === null || _a === void 0 ? void 0 : _a.reasons) || []);
    else if (errorCode === 'session_not_found') // The `session_id` inside the JWT does not correspond to a row in the
    // `sessions` table. This usually means the user has signed out, has been
    // deleted, or their session has somehow been terminated.
    throw new (0, $fTIQY.AuthSessionMissingError)();
    throw new (0, $fTIQY.AuthApiError)($9c1b37c8edd4ca2b$var$_getErrorMessage(data), error.status || 500, errorCode);
}
const $9c1b37c8edd4ca2b$var$_getRequestParams = (method, options, parameters, body)=>{
    const params = {
        method: method,
        headers: (options === null || options === void 0 ? void 0 : options.headers) || {}
    };
    if (method === 'GET') return params;
    params.headers = Object.assign({
        'Content-Type': 'application/json;charset=UTF-8'
    }, options === null || options === void 0 ? void 0 : options.headers);
    params.body = JSON.stringify(body);
    return Object.assign(Object.assign({}, params), parameters);
};
async function $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd(fetcher, method, url, options) {
    var _a;
    const headers = Object.assign({}, options === null || options === void 0 ? void 0 : options.headers);
    if (!headers[0, $44TzP.API_VERSION_HEADER_NAME]) headers[0, $44TzP.API_VERSION_HEADER_NAME] = (0, $44TzP.API_VERSIONS)['2024-01-01'].name;
    if (options === null || options === void 0 ? void 0 : options.jwt) headers['Authorization'] = `Bearer ${options.jwt}`;
    const qs = (_a = options === null || options === void 0 ? void 0 : options.query) !== null && _a !== void 0 ? _a : {};
    if (options === null || options === void 0 ? void 0 : options.redirectTo) qs['redirect_to'] = options.redirectTo;
    const queryString = Object.keys(qs).length ? '?' + new URLSearchParams(qs).toString() : '';
    const data = await $9c1b37c8edd4ca2b$var$_handleRequest(fetcher, method, url + queryString, {
        headers: headers,
        noResolveJson: options === null || options === void 0 ? void 0 : options.noResolveJson
    }, {}, options === null || options === void 0 ? void 0 : options.body);
    return (options === null || options === void 0 ? void 0 : options.xform) ? options === null || options === void 0 ? void 0 : options.xform(data) : {
        data: Object.assign({}, data),
        error: null
    };
}
async function $9c1b37c8edd4ca2b$var$_handleRequest(fetcher, method, url, options, parameters, body) {
    const requestParams = $9c1b37c8edd4ca2b$var$_getRequestParams(method, options, parameters, body);
    let result;
    try {
        result = await fetcher(url, Object.assign({}, requestParams));
    } catch (e) {
        console.error(e);
        // fetch failed, likely due to a network or CORS error
        throw new (0, $fTIQY.AuthRetryableFetchError)($9c1b37c8edd4ca2b$var$_getErrorMessage(e), 0);
    }
    if (!result.ok) await $9c1b37c8edd4ca2b$export$d3da1ecaf1206c58(result);
    if (options === null || options === void 0 ? void 0 : options.noResolveJson) return result;
    try {
        return await result.json();
    } catch (e) {
        await $9c1b37c8edd4ca2b$export$d3da1ecaf1206c58(e);
    }
}
function $9c1b37c8edd4ca2b$export$273fe4673a018c2e(data) {
    var _a;
    let session = null;
    if ($9c1b37c8edd4ca2b$var$hasSession(data)) {
        session = Object.assign({}, data);
        if (!data.expires_at) session.expires_at = (0, $98hXt.expiresAt)(data.expires_in);
    }
    const user = (_a = data.user) !== null && _a !== void 0 ? _a : data;
    return {
        data: {
            session: session,
            user: user
        },
        error: null
    };
}
function $9c1b37c8edd4ca2b$export$db83aade1c2922c7(data) {
    const response = $9c1b37c8edd4ca2b$export$273fe4673a018c2e(data);
    if (!response.error && data.weak_password && typeof data.weak_password === 'object' && Array.isArray(data.weak_password.reasons) && data.weak_password.reasons.length && data.weak_password.message && typeof data.weak_password.message === 'string' && data.weak_password.reasons.reduce((a, i)=>a && typeof i === 'string', true)) response.data.weak_password = data.weak_password;
    return response;
}
function $9c1b37c8edd4ca2b$export$e20f488897843593(data) {
    var _a;
    const user = (_a = data.user) !== null && _a !== void 0 ? _a : data;
    return {
        data: {
            user: user
        },
        error: null
    };
}
function $9c1b37c8edd4ca2b$export$b04785c46dcd8f8b(data) {
    return {
        data: data,
        error: null
    };
}
function $9c1b37c8edd4ca2b$export$f5eaa950605b2146(data) {
    const { action_link: action_link, email_otp: email_otp, hashed_token: hashed_token, redirect_to: redirect_to, verification_type: verification_type } = data, rest = (0, $7WQrb.__rest)(data, [
        "action_link",
        "email_otp",
        "hashed_token",
        "redirect_to",
        "verification_type"
    ]);
    const properties = {
        action_link: action_link,
        email_otp: email_otp,
        hashed_token: hashed_token,
        redirect_to: redirect_to,
        verification_type: verification_type
    };
    const user = Object.assign({}, rest);
    return {
        data: {
            properties: properties,
            user: user
        },
        error: null
    };
}
function $9c1b37c8edd4ca2b$export$7aed01df6e045e31(data) {
    return data;
}
/**
 * hasSession checks if the response object contains a valid session
 * @param data A response object
 * @returns true if a session is in the response
 */ function $9c1b37c8edd4ca2b$var$hasSession(data) {
    return !!data.access_token && !!data.refresh_token && !!data.expires_in;
}

});
parcelRegister("44TzP", function(module, exports) {

$parcel$export(module.exports, "AUTO_REFRESH_TICK_DURATION_MS", () => $2f82a590c21cea7a$export$a4558fee79d6c8ae);
$parcel$export(module.exports, "AUTO_REFRESH_TICK_THRESHOLD", () => $2f82a590c21cea7a$export$f20a97df8f5fe223);
$parcel$export(module.exports, "EXPIRY_MARGIN_MS", () => $2f82a590c21cea7a$export$a36ad0026e55ac00);
$parcel$export(module.exports, "GOTRUE_URL", () => $2f82a590c21cea7a$export$7fedf552187f0c3d);
$parcel$export(module.exports, "STORAGE_KEY", () => $2f82a590c21cea7a$export$86880b4b2e1a2384);
$parcel$export(module.exports, "DEFAULT_HEADERS", () => $2f82a590c21cea7a$export$88a84136db6a4b64);
$parcel$export(module.exports, "API_VERSION_HEADER_NAME", () => $2f82a590c21cea7a$export$e4f5507f88977535);
$parcel$export(module.exports, "API_VERSIONS", () => $2f82a590c21cea7a$export$1f9a66038489bdeb);
$parcel$export(module.exports, "BASE64URL_REGEX", () => $2f82a590c21cea7a$export$7a68c9e70b9d3911);
$parcel$export(module.exports, "JWKS_TTL", () => $2f82a590c21cea7a$export$5bd768495200f133);

var $iIHZ2 = parcelRequire("iIHZ2");
const $2f82a590c21cea7a$export$a4558fee79d6c8ae = 30000;
const $2f82a590c21cea7a$export$f20a97df8f5fe223 = 3;
const $2f82a590c21cea7a$export$a36ad0026e55ac00 = $2f82a590c21cea7a$export$f20a97df8f5fe223 * $2f82a590c21cea7a$export$a4558fee79d6c8ae;
const $2f82a590c21cea7a$export$7fedf552187f0c3d = 'http://localhost:9999';
const $2f82a590c21cea7a$export$86880b4b2e1a2384 = 'supabase.auth.token';
const $2f82a590c21cea7a$export$2f9161bad044dacb = '';
const $2f82a590c21cea7a$export$88a84136db6a4b64 = {
    'X-Client-Info': `gotrue-js/${(0, $iIHZ2.version)}`
};
const $2f82a590c21cea7a$export$5615c708618ee858 = {
    MAX_RETRIES: 10,
    RETRY_INTERVAL: 2
};
const $2f82a590c21cea7a$export$e4f5507f88977535 = 'X-Supabase-Api-Version';
const $2f82a590c21cea7a$export$1f9a66038489bdeb = {
    '2024-01-01': {
        timestamp: Date.parse('2024-01-01T00:00:00.0Z'),
        name: '2024-01-01'
    }
};
const $2f82a590c21cea7a$export$7a68c9e70b9d3911 = /^([a-z0-9_-]{4})*($|[a-z0-9_-]{3}$|[a-z0-9_-]{2}$)$/i;
const $2f82a590c21cea7a$export$5bd768495200f133 = 600000; // 10 minutes

});
parcelRegister("iIHZ2", function(module, exports) {

$parcel$export(module.exports, "version", () => $da0e74438356dc28$export$83d89fbfd8236492);
// Generated automatically during releases by scripts/update-version-files.ts
// This file provides runtime access to the package version for:
// - HTTP request headers (e.g., X-Client-Info header for API requests)
// - Debugging and support (identifying which version is running)
// - Telemetry and logging (version reporting in errors/analytics)
// - Ensuring build artifacts match the published package version
const $da0e74438356dc28$export$83d89fbfd8236492 = '2.105.3';

});


parcelRegister("98hXt", function(module, exports) {

$parcel$export(module.exports, "expiresAt", () => $6a62ca85cf697dd5$export$e02d0a488392f690);
$parcel$export(module.exports, "generateCallbackId", () => $6a62ca85cf697dd5$export$16db4ce6a8dfc285);
$parcel$export(module.exports, "isBrowser", () => $6a62ca85cf697dd5$export$4e09c449d6c407f7);
$parcel$export(module.exports, "supportsLocalStorage", () => $6a62ca85cf697dd5$export$9ec034ee80211814);
$parcel$export(module.exports, "parseParametersFromURL", () => $6a62ca85cf697dd5$export$7a29392fb778224c);
$parcel$export(module.exports, "resolveFetch", () => $6a62ca85cf697dd5$export$98d92b1aa79f8cc7);
$parcel$export(module.exports, "looksLikeFetchResponse", () => $6a62ca85cf697dd5$export$e8ad6599be1036a7);
$parcel$export(module.exports, "setItemAsync", () => $6a62ca85cf697dd5$export$e82c36d29078a87f);
$parcel$export(module.exports, "getItemAsync", () => $6a62ca85cf697dd5$export$ba6fcb7c333d32c0);
$parcel$export(module.exports, "removeItemAsync", () => $6a62ca85cf697dd5$export$d35c645d585317ec);
$parcel$export(module.exports, "Deferred", () => $6a62ca85cf697dd5$export$85f6557964517f1a);
$parcel$export(module.exports, "decodeJWT", () => $6a62ca85cf697dd5$export$9a62e6c0a30e00bc);
$parcel$export(module.exports, "sleep", () => $6a62ca85cf697dd5$export$e772c8ff12451969);
$parcel$export(module.exports, "retryable", () => $6a62ca85cf697dd5$export$9e1b8e833f44ff21);
$parcel$export(module.exports, "getCodeChallengeAndMethod", () => $6a62ca85cf697dd5$export$81b177cadfcf873c);
$parcel$export(module.exports, "parseResponseAPIVersion", () => $6a62ca85cf697dd5$export$5f69ecf1c14d56fd);
$parcel$export(module.exports, "validateExp", () => $6a62ca85cf697dd5$export$a5850868adeb9253);
$parcel$export(module.exports, "getAlgorithm", () => $6a62ca85cf697dd5$export$fa59f625ab60cb91);
$parcel$export(module.exports, "validateUUID", () => $6a62ca85cf697dd5$export$a4c72ae47296db0c);
$parcel$export(module.exports, "assertPasskeyExperimentalEnabled", () => $6a62ca85cf697dd5$export$1b3246f2022dfc02);
$parcel$export(module.exports, "userNotAvailableProxy", () => $6a62ca85cf697dd5$export$52c7f0d8a78626b);
$parcel$export(module.exports, "insecureUserWarningProxy", () => $6a62ca85cf697dd5$export$28f3a5de6111309a);
$parcel$export(module.exports, "deepClone", () => $6a62ca85cf697dd5$export$b7d58db314e0ac27);

var $44TzP = parcelRequire("44TzP");

var $fTIQY = parcelRequire("fTIQY");

var $iSR6L = parcelRequire("iSR6L");
function $6a62ca85cf697dd5$export$e02d0a488392f690(expiresIn) {
    const timeNow = Math.round(Date.now() / 1000);
    return timeNow + expiresIn;
}
function $6a62ca85cf697dd5$export$16db4ce6a8dfc285() {
    return Symbol('auth-callback');
}
const $6a62ca85cf697dd5$export$4e09c449d6c407f7 = ()=>typeof window !== 'undefined' && typeof document !== 'undefined';
const $6a62ca85cf697dd5$var$localStorageWriteTests = {
    tested: false,
    writable: false
};
const $6a62ca85cf697dd5$export$9ec034ee80211814 = ()=>{
    if (!$6a62ca85cf697dd5$export$4e09c449d6c407f7()) return false;
    try {
        if (typeof globalThis.localStorage !== 'object') return false;
    } catch (e) {
        // DOM exception when accessing `localStorage`
        return false;
    }
    if ($6a62ca85cf697dd5$var$localStorageWriteTests.tested) return $6a62ca85cf697dd5$var$localStorageWriteTests.writable;
    const randomKey = `lswt-${Math.random()}${Math.random()}`;
    try {
        globalThis.localStorage.setItem(randomKey, randomKey);
        globalThis.localStorage.removeItem(randomKey);
        $6a62ca85cf697dd5$var$localStorageWriteTests.tested = true;
        $6a62ca85cf697dd5$var$localStorageWriteTests.writable = true;
    } catch (e) {
        // localStorage can't be written to
        // https://www.chromium.org/for-testers/bug-reporting-guidelines/uncaught-securityerror-failed-to-read-the-localstorage-property-from-window-access-is-denied-for-this-document
        $6a62ca85cf697dd5$var$localStorageWriteTests.tested = true;
        $6a62ca85cf697dd5$var$localStorageWriteTests.writable = false;
    }
    return $6a62ca85cf697dd5$var$localStorageWriteTests.writable;
};
function $6a62ca85cf697dd5$export$7a29392fb778224c(href) {
    const result = {};
    const url = new URL(href);
    if (url.hash && url.hash[0] === '#') try {
        const hashSearchParams = new URLSearchParams(url.hash.substring(1));
        hashSearchParams.forEach((value, key)=>{
            result[key] = value;
        });
    } catch (_e) {
    // hash is not a query string
    }
    // search parameters take precedence over hash parameters
    url.searchParams.forEach((value, key)=>{
        result[key] = value;
    });
    return result;
}
const $6a62ca85cf697dd5$export$98d92b1aa79f8cc7 = (customFetch)=>{
    if (customFetch) return (...args)=>customFetch(...args);
    return (...args)=>fetch(...args);
};
const $6a62ca85cf697dd5$export$e8ad6599be1036a7 = (maybeResponse)=>{
    return typeof maybeResponse === 'object' && maybeResponse !== null && 'status' in maybeResponse && 'ok' in maybeResponse && 'json' in maybeResponse && typeof maybeResponse.json === 'function';
};
const $6a62ca85cf697dd5$export$e82c36d29078a87f = async (storage, key, data)=>{
    await storage.setItem(key, JSON.stringify(data));
};
const $6a62ca85cf697dd5$export$ba6fcb7c333d32c0 = async (storage, key)=>{
    const value = await storage.getItem(key);
    if (!value) return null;
    try {
        return JSON.parse(value);
    } catch (_a) {
        return value;
    }
};
const $6a62ca85cf697dd5$export$d35c645d585317ec = async (storage, key)=>{
    await storage.removeItem(key);
};
class $6a62ca85cf697dd5$export$85f6557964517f1a {
    constructor(){
        this.promise = new $6a62ca85cf697dd5$export$85f6557964517f1a.promiseConstructor((res, rej)=>{
            this.resolve = res;
            this.reject = rej;
        });
    }
}
$6a62ca85cf697dd5$export$85f6557964517f1a.promiseConstructor = Promise;
function $6a62ca85cf697dd5$export$9a62e6c0a30e00bc(token) {
    const parts = token.split('.');
    if (parts.length !== 3) throw new (0, $fTIQY.AuthInvalidJwtError)('Invalid JWT structure');
    // Regex checks for base64url format
    for(let i = 0; i < parts.length; i++){
        if (!(0, $44TzP.BASE64URL_REGEX).test(parts[i])) throw new (0, $fTIQY.AuthInvalidJwtError)('JWT not in base64url format');
    }
    const data = {
        // using base64url lib
        header: JSON.parse((0, $iSR6L.stringFromBase64URL)(parts[0])),
        payload: JSON.parse((0, $iSR6L.stringFromBase64URL)(parts[1])),
        signature: (0, $iSR6L.base64UrlToUint8Array)(parts[2]),
        raw: {
            header: parts[0],
            payload: parts[1]
        }
    };
    return data;
}
async function $6a62ca85cf697dd5$export$e772c8ff12451969(time) {
    return await new Promise((accept)=>{
        setTimeout(()=>accept(null), time);
    });
}
function $6a62ca85cf697dd5$export$9e1b8e833f44ff21(fn, isRetryable) {
    const promise = new Promise((accept, reject)=>{
        (async ()=>{
            for(let attempt = 0; attempt < Infinity; attempt++)try {
                const result = await fn(attempt);
                if (!isRetryable(attempt, null, result)) {
                    accept(result);
                    return;
                }
            } catch (e) {
                if (!isRetryable(attempt, e)) {
                    reject(e);
                    return;
                }
            }
        })();
    });
    return promise;
}
function $6a62ca85cf697dd5$var$dec2hex(dec) {
    return ('0' + dec.toString(16)).substr(-2);
}
function $6a62ca85cf697dd5$export$b6c3b8498f152f15() {
    const verifierLength = 56;
    const array = new Uint32Array(verifierLength);
    if (typeof crypto === 'undefined') {
        const charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
        const charSetLen = charSet.length;
        let verifier = '';
        for(let i = 0; i < verifierLength; i++)verifier += charSet.charAt(Math.floor(Math.random() * charSetLen));
        return verifier;
    }
    crypto.getRandomValues(array);
    return Array.from(array, $6a62ca85cf697dd5$var$dec2hex).join('');
}
async function $6a62ca85cf697dd5$var$sha256(randomString) {
    const encoder = new TextEncoder();
    const encodedData = encoder.encode(randomString);
    const hash = await crypto.subtle.digest('SHA-256', encodedData);
    const bytes = new Uint8Array(hash);
    return Array.from(bytes).map((c)=>String.fromCharCode(c)).join('');
}
async function $6a62ca85cf697dd5$export$eb79e16bb8189148(verifier) {
    const hasCryptoSupport = typeof crypto !== 'undefined' && typeof crypto.subtle !== 'undefined' && typeof TextEncoder !== 'undefined';
    if (!hasCryptoSupport) {
        console.warn('WebCrypto API is not supported. Code challenge method will default to use plain instead of sha256.');
        return verifier;
    }
    const hashed = await $6a62ca85cf697dd5$var$sha256(verifier);
    return btoa(hashed).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
async function $6a62ca85cf697dd5$export$81b177cadfcf873c(storage, storageKey, isPasswordRecovery = false) {
    const codeVerifier = $6a62ca85cf697dd5$export$b6c3b8498f152f15();
    let storedCodeVerifier = codeVerifier;
    if (isPasswordRecovery) storedCodeVerifier += '/recovery';
    await $6a62ca85cf697dd5$export$e82c36d29078a87f(storage, `${storageKey}-code-verifier`, storedCodeVerifier);
    const codeChallenge = await $6a62ca85cf697dd5$export$eb79e16bb8189148(codeVerifier);
    const codeChallengeMethod = codeVerifier === codeChallenge ? 'plain' : 's256';
    return [
        codeChallenge,
        codeChallengeMethod
    ];
}
/** Parses the API version which is 2YYY-MM-DD. */ const $6a62ca85cf697dd5$var$API_VERSION_REGEX = /^2[0-9]{3}-(0[1-9]|1[0-2])-(0[1-9]|1[0-9]|2[0-9]|3[0-1])$/i;
function $6a62ca85cf697dd5$export$5f69ecf1c14d56fd(response) {
    const apiVersion = response.headers.get((0, $44TzP.API_VERSION_HEADER_NAME));
    if (!apiVersion) return null;
    if (!apiVersion.match($6a62ca85cf697dd5$var$API_VERSION_REGEX)) return null;
    try {
        const date = new Date(`${apiVersion}T00:00:00.0Z`);
        return date;
    } catch (_e) {
        return null;
    }
}
function $6a62ca85cf697dd5$export$a5850868adeb9253(exp) {
    if (!exp) throw new Error('Missing exp claim');
    const timeNow = Math.floor(Date.now() / 1000);
    if (exp <= timeNow) throw new Error('JWT has expired');
}
function $6a62ca85cf697dd5$export$fa59f625ab60cb91(alg) {
    switch(alg){
        case 'RS256':
            return {
                name: 'RSASSA-PKCS1-v1_5',
                hash: {
                    name: 'SHA-256'
                }
            };
        case 'ES256':
            return {
                name: 'ECDSA',
                namedCurve: 'P-256',
                hash: {
                    name: 'SHA-256'
                }
            };
        default:
            throw new Error('Invalid alg claim');
    }
}
const $6a62ca85cf697dd5$var$UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;
function $6a62ca85cf697dd5$export$a4c72ae47296db0c(str) {
    if (!$6a62ca85cf697dd5$var$UUID_REGEX.test(str)) throw new Error('@supabase/auth-js: Expected parameter to be UUID but is not');
}
function $6a62ca85cf697dd5$export$1b3246f2022dfc02(experimental) {
    if (!experimental.passkey) throw new Error('@supabase/auth-js: the passkey API is experimental and disabled by default. Enable it by passing `auth: { experimental: { passkey: true } }` to createClient (or to the GoTrueClient constructor).');
}
function $6a62ca85cf697dd5$export$52c7f0d8a78626b() {
    const proxyTarget = {};
    return new Proxy(proxyTarget, {
        get: (target, prop)=>{
            if (prop === '__isUserNotAvailableProxy') return true;
            // Preventative check for common problematic symbols during cloning/inspection
            // These symbols might be accessed by structuredClone or other internal mechanisms.
            if (typeof prop === 'symbol') {
                const sProp = prop.toString();
                if (sProp === 'Symbol(Symbol.toPrimitive)' || sProp === 'Symbol(Symbol.toStringTag)' || sProp === 'Symbol(util.inspect.custom)') // Node.js util.inspect
                return undefined;
            }
            throw new Error(`@supabase/auth-js: client was created with userStorage option and there was no user stored in the user storage. Accessing the "${prop}" property of the session object is not supported. Please use getUser() instead.`);
        },
        set: (_target, prop)=>{
            throw new Error(`@supabase/auth-js: client was created with userStorage option and there was no user stored in the user storage. Setting the "${prop}" property of the session object is not supported. Please use getUser() to fetch a user object you can manipulate.`);
        },
        deleteProperty: (_target, prop)=>{
            throw new Error(`@supabase/auth-js: client was created with userStorage option and there was no user stored in the user storage. Deleting the "${prop}" property of the session object is not supported. Please use getUser() to fetch a user object you can manipulate.`);
        }
    });
}
function $6a62ca85cf697dd5$export$28f3a5de6111309a(user, suppressWarningRef) {
    return new Proxy(user, {
        get: (target, prop, receiver)=>{
            // Allow internal checks without warning
            if (prop === '__isInsecureUserWarningProxy') return true;
            // Preventative check for common problematic symbols during cloning/inspection
            // These symbols might be accessed by structuredClone or other internal mechanisms
            if (typeof prop === 'symbol') {
                const sProp = prop.toString();
                if (sProp === 'Symbol(Symbol.toPrimitive)' || sProp === 'Symbol(Symbol.toStringTag)' || sProp === 'Symbol(util.inspect.custom)' || sProp === 'Symbol(nodejs.util.inspect.custom)') // Return the actual value for these symbols to allow proper inspection
                return Reflect.get(target, prop, receiver);
            }
            // Emit warning on first property access
            if (!suppressWarningRef.value && typeof prop === 'string') {
                console.warn('Using the user object as returned from supabase.auth.getSession() or from some supabase.auth.onAuthStateChange() events could be insecure! This value comes directly from the storage medium (usually cookies on the server) and may not be authentic. Use supabase.auth.getUser() instead which authenticates the data by contacting the Supabase Auth server.');
                suppressWarningRef.value = true;
            }
            return Reflect.get(target, prop, receiver);
        }
    });
}
function $6a62ca85cf697dd5$export$b7d58db314e0ac27(obj) {
    return JSON.parse(JSON.stringify(obj));
}

});
parcelRegister("fTIQY", function(module, exports) {

$parcel$export(module.exports, "AuthError", () => $b92ec9013174409a$export$145273558d58e0ac);
$parcel$export(module.exports, "isAuthError", () => $b92ec9013174409a$export$cde1786a482f9a1c);
$parcel$export(module.exports, "AuthApiError", () => $b92ec9013174409a$export$45fde0b55b14f37b);
$parcel$export(module.exports, "isAuthApiError", () => $b92ec9013174409a$export$4fe744aeb810d543);
$parcel$export(module.exports, "AuthUnknownError", () => $b92ec9013174409a$export$f7559805d4a50078);
$parcel$export(module.exports, "AuthSessionMissingError", () => $b92ec9013174409a$export$403b3fc0d3ad5f0c);
$parcel$export(module.exports, "isAuthSessionMissingError", () => $b92ec9013174409a$export$3e849aa4db565c1d);
$parcel$export(module.exports, "AuthInvalidTokenResponseError", () => $b92ec9013174409a$export$7e277b620449c1b4);
$parcel$export(module.exports, "AuthInvalidCredentialsError", () => $b92ec9013174409a$export$9ef583f0381b4cc);
$parcel$export(module.exports, "AuthImplicitGrantRedirectError", () => $b92ec9013174409a$export$bf5df8e043856ef5);
$parcel$export(module.exports, "isAuthImplicitGrantRedirectError", () => $b92ec9013174409a$export$45edea3999507afd);
$parcel$export(module.exports, "AuthPKCEGrantCodeExchangeError", () => $b92ec9013174409a$export$39583657eb2a7027);
$parcel$export(module.exports, "AuthPKCECodeVerifierMissingError", () => $b92ec9013174409a$export$11e8e15400b7b336);
$parcel$export(module.exports, "AuthRetryableFetchError", () => $b92ec9013174409a$export$2423b763f68be1b4);
$parcel$export(module.exports, "isAuthRetryableFetchError", () => $b92ec9013174409a$export$a77af358da5fb874);
$parcel$export(module.exports, "AuthWeakPasswordError", () => $b92ec9013174409a$export$b034076aa04913a6);
$parcel$export(module.exports, "AuthInvalidJwtError", () => $b92ec9013174409a$export$d04cb18528f2043e);
/**
 * Base error thrown by Supabase Auth helpers.
 *
 * @example
 * ```ts
 * import { AuthError } from '@supabase/auth-js'
 *
 * throw new AuthError('Unexpected auth error', 500, 'unexpected')
 * ```
 */ class $b92ec9013174409a$export$145273558d58e0ac extends Error {
    constructor(message, status, code){
        super(message);
        this.__isAuthError = true;
        this.name = 'AuthError';
        this.status = status;
        this.code = code;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status,
            code: this.code
        };
    }
}
function $b92ec9013174409a$export$cde1786a482f9a1c(error) {
    return typeof error === 'object' && error !== null && '__isAuthError' in error;
}
class $b92ec9013174409a$export$45fde0b55b14f37b extends $b92ec9013174409a$export$145273558d58e0ac {
    constructor(message, status, code){
        super(message, status, code);
        this.name = 'AuthApiError';
        this.status = status;
        this.code = code;
    }
}
function $b92ec9013174409a$export$4fe744aeb810d543(error) {
    return $b92ec9013174409a$export$cde1786a482f9a1c(error) && error.name === 'AuthApiError';
}
class $b92ec9013174409a$export$f7559805d4a50078 extends $b92ec9013174409a$export$145273558d58e0ac {
    constructor(message, originalError){
        super(message);
        this.name = 'AuthUnknownError';
        this.originalError = originalError;
    }
}
class $b92ec9013174409a$export$823c745ae0673c5e extends $b92ec9013174409a$export$145273558d58e0ac {
    constructor(message, name, status, code){
        super(message, status, code);
        this.name = name;
        this.status = status;
    }
}
class $b92ec9013174409a$export$403b3fc0d3ad5f0c extends $b92ec9013174409a$export$823c745ae0673c5e {
    constructor(){
        super('Auth session missing!', 'AuthSessionMissingError', 400, undefined);
    }
}
function $b92ec9013174409a$export$3e849aa4db565c1d(error) {
    return $b92ec9013174409a$export$cde1786a482f9a1c(error) && error.name === 'AuthSessionMissingError';
}
class $b92ec9013174409a$export$7e277b620449c1b4 extends $b92ec9013174409a$export$823c745ae0673c5e {
    constructor(){
        super('Auth session or user missing', 'AuthInvalidTokenResponseError', 500, undefined);
    }
}
class $b92ec9013174409a$export$9ef583f0381b4cc extends $b92ec9013174409a$export$823c745ae0673c5e {
    constructor(message){
        super(message, 'AuthInvalidCredentialsError', 400, undefined);
    }
}
class $b92ec9013174409a$export$bf5df8e043856ef5 extends $b92ec9013174409a$export$823c745ae0673c5e {
    constructor(message, details = null){
        super(message, 'AuthImplicitGrantRedirectError', 500, undefined);
        this.details = null;
        this.details = details;
    }
    toJSON() {
        return Object.assign(Object.assign({}, super.toJSON()), {
            details: this.details
        });
    }
}
function $b92ec9013174409a$export$45edea3999507afd(error) {
    return $b92ec9013174409a$export$cde1786a482f9a1c(error) && error.name === 'AuthImplicitGrantRedirectError';
}
class $b92ec9013174409a$export$39583657eb2a7027 extends $b92ec9013174409a$export$823c745ae0673c5e {
    constructor(message, details = null){
        super(message, 'AuthPKCEGrantCodeExchangeError', 500, undefined);
        this.details = null;
        this.details = details;
    }
    toJSON() {
        return Object.assign(Object.assign({}, super.toJSON()), {
            details: this.details
        });
    }
}
class $b92ec9013174409a$export$11e8e15400b7b336 extends $b92ec9013174409a$export$823c745ae0673c5e {
    constructor(){
        super("PKCE code verifier not found in storage. This can happen if the auth flow was initiated in a different browser or device, or if the storage was cleared. For SSR frameworks (Next.js, SvelteKit, etc.), use @supabase/ssr on both the server and client to store the code verifier in cookies.", 'AuthPKCECodeVerifierMissingError', 400, 'pkce_code_verifier_not_found');
    }
}
function $b92ec9013174409a$export$398e1f2bb2c7a92(error) {
    return $b92ec9013174409a$export$cde1786a482f9a1c(error) && error.name === 'AuthPKCECodeVerifierMissingError';
}
class $b92ec9013174409a$export$2423b763f68be1b4 extends $b92ec9013174409a$export$823c745ae0673c5e {
    constructor(message, status){
        super(message, 'AuthRetryableFetchError', status, undefined);
    }
}
function $b92ec9013174409a$export$a77af358da5fb874(error) {
    return $b92ec9013174409a$export$cde1786a482f9a1c(error) && error.name === 'AuthRetryableFetchError';
}
class $b92ec9013174409a$export$b034076aa04913a6 extends $b92ec9013174409a$export$823c745ae0673c5e {
    constructor(message, status, reasons){
        super(message, 'AuthWeakPasswordError', status, 'weak_password');
        this.reasons = reasons;
    }
    toJSON() {
        return Object.assign(Object.assign({}, super.toJSON()), {
            reasons: this.reasons
        });
    }
}
function $b92ec9013174409a$export$dac36143fd8a46ef(error) {
    return $b92ec9013174409a$export$cde1786a482f9a1c(error) && error.name === 'AuthWeakPasswordError';
}
class $b92ec9013174409a$export$d04cb18528f2043e extends $b92ec9013174409a$export$823c745ae0673c5e {
    constructor(message){
        super(message, 'AuthInvalidJwtError', 400, 'invalid_jwt');
    }
}

});

parcelRegister("iSR6L", function(module, exports) {

$parcel$export(module.exports, "stringFromBase64URL", () => $dbf67752838ebc66$export$bd5d476f823ea024);
$parcel$export(module.exports, "base64UrlToUint8Array", () => $dbf67752838ebc66$export$9cae2cd6076b8fb6);
$parcel$export(module.exports, "stringToUint8Array", () => $dbf67752838ebc66$export$a098e7b533f96db3);
$parcel$export(module.exports, "bytesToBase64URL", () => $dbf67752838ebc66$export$3f156efe462a835e);
/**
 * Avoid modifying this file. It's part of
 * https://github.com/supabase-community/base64url-js.  Submit all fixes on
 * that repo!
 */ /**
 * An array of characters that encode 6 bits into a Base64-URL alphabet
 * character.
 */ const $dbf67752838ebc66$var$TO_BASE64URL = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_'.split('');
/**
 * An array of characters that can appear in a Base64-URL encoded string but
 * should be ignored.
 */ const $dbf67752838ebc66$var$IGNORE_BASE64URL = ' \t\n\r='.split('');
/**
 * An array of 128 numbers that map a Base64-URL character to 6 bits, or if -2
 * used to skip the character, or if -1 used to error out.
 */ const $dbf67752838ebc66$var$FROM_BASE64URL = (()=>{
    const charMap = new Array(128);
    for(let i = 0; i < charMap.length; i += 1)charMap[i] = -1;
    for(let i = 0; i < $dbf67752838ebc66$var$IGNORE_BASE64URL.length; i += 1)charMap[$dbf67752838ebc66$var$IGNORE_BASE64URL[i].charCodeAt(0)] = -2;
    for(let i = 0; i < $dbf67752838ebc66$var$TO_BASE64URL.length; i += 1)charMap[$dbf67752838ebc66$var$TO_BASE64URL[i].charCodeAt(0)] = i;
    return charMap;
})();
function $dbf67752838ebc66$export$744f452403189a3e(byte, state, emit) {
    if (byte !== null) {
        state.queue = state.queue << 8 | byte;
        state.queuedBits += 8;
        while(state.queuedBits >= 6){
            const pos = state.queue >> state.queuedBits - 6 & 63;
            emit($dbf67752838ebc66$var$TO_BASE64URL[pos]);
            state.queuedBits -= 6;
        }
    } else if (state.queuedBits > 0) {
        state.queue = state.queue << 6 - state.queuedBits;
        state.queuedBits = 6;
        while(state.queuedBits >= 6){
            const pos = state.queue >> state.queuedBits - 6 & 63;
            emit($dbf67752838ebc66$var$TO_BASE64URL[pos]);
            state.queuedBits -= 6;
        }
    }
}
function $dbf67752838ebc66$export$403e86c86002a137(charCode, state, emit) {
    const bits = $dbf67752838ebc66$var$FROM_BASE64URL[charCode];
    if (bits > -1) {
        // valid Base64-URL character
        state.queue = state.queue << 6 | bits;
        state.queuedBits += 6;
        while(state.queuedBits >= 8){
            emit(state.queue >> state.queuedBits - 8 & 0xff);
            state.queuedBits -= 8;
        }
    } else if (bits === -2) // ignore spaces, tabs, newlines, =
    return;
    else throw new Error(`Invalid Base64-URL character "${String.fromCharCode(charCode)}"`);
}
function $dbf67752838ebc66$export$abe65c864cc3fd34(str) {
    const base64 = [];
    const emitter = (char)=>{
        base64.push(char);
    };
    const state = {
        queue: 0,
        queuedBits: 0
    };
    $dbf67752838ebc66$export$caccae6095ceb6da(str, (byte)=>{
        $dbf67752838ebc66$export$744f452403189a3e(byte, state, emitter);
    });
    $dbf67752838ebc66$export$744f452403189a3e(null, state, emitter);
    return base64.join('');
}
function $dbf67752838ebc66$export$bd5d476f823ea024(str) {
    const conv = [];
    const utf8Emit = (codepoint)=>{
        conv.push(String.fromCodePoint(codepoint));
    };
    const utf8State = {
        utf8seq: 0,
        codepoint: 0
    };
    const b64State = {
        queue: 0,
        queuedBits: 0
    };
    const byteEmit = (byte)=>{
        $dbf67752838ebc66$export$719b4117b3270757(byte, utf8State, utf8Emit);
    };
    for(let i = 0; i < str.length; i += 1)$dbf67752838ebc66$export$403e86c86002a137(str.charCodeAt(i), b64State, byteEmit);
    return conv.join('');
}
function $dbf67752838ebc66$export$d203cd9136753332(codepoint, emit) {
    if (codepoint <= 0x7f) {
        emit(codepoint);
        return;
    } else if (codepoint <= 0x7ff) {
        emit(0xc0 | codepoint >> 6);
        emit(0x80 | codepoint & 0x3f);
        return;
    } else if (codepoint <= 0xffff) {
        emit(0xe0 | codepoint >> 12);
        emit(0x80 | codepoint >> 6 & 0x3f);
        emit(0x80 | codepoint & 0x3f);
        return;
    } else if (codepoint <= 0x10ffff) {
        emit(0xf0 | codepoint >> 18);
        emit(0x80 | codepoint >> 12 & 0x3f);
        emit(0x80 | codepoint >> 6 & 0x3f);
        emit(0x80 | codepoint & 0x3f);
        return;
    }
    throw new Error(`Unrecognized Unicode codepoint: ${codepoint.toString(16)}`);
}
function $dbf67752838ebc66$export$caccae6095ceb6da(str, emit) {
    for(let i = 0; i < str.length; i += 1){
        let codepoint = str.charCodeAt(i);
        if (codepoint > 0xd7ff && codepoint <= 0xdbff) {
            // most UTF-16 codepoints are Unicode codepoints, except values in this
            // range where the next UTF-16 codepoint needs to be combined with the
            // current one to get the Unicode codepoint
            const highSurrogate = (codepoint - 0xd800) * 0x400 & 0xffff;
            const lowSurrogate = str.charCodeAt(i + 1) - 0xdc00 & 0xffff;
            codepoint = (lowSurrogate | highSurrogate) + 0x10000;
            i += 1;
        }
        $dbf67752838ebc66$export$d203cd9136753332(codepoint, emit);
    }
}
function $dbf67752838ebc66$export$719b4117b3270757(byte, state, emit) {
    if (state.utf8seq === 0) {
        if (byte <= 0x7f) {
            emit(byte);
            return;
        }
        // count the number of 1 leading bits until you reach 0
        for(let leadingBit = 1; leadingBit < 6; leadingBit += 1)if ((byte >> 7 - leadingBit & 1) === 0) {
            state.utf8seq = leadingBit;
            break;
        }
        if (state.utf8seq === 2) state.codepoint = byte & 31;
        else if (state.utf8seq === 3) state.codepoint = byte & 15;
        else if (state.utf8seq === 4) state.codepoint = byte & 7;
        else throw new Error('Invalid UTF-8 sequence');
        state.utf8seq -= 1;
    } else if (state.utf8seq > 0) {
        if (byte <= 0x7f) throw new Error('Invalid UTF-8 sequence');
        state.codepoint = state.codepoint << 6 | byte & 63;
        state.utf8seq -= 1;
        if (state.utf8seq === 0) emit(state.codepoint);
    }
}
function $dbf67752838ebc66$export$9cae2cd6076b8fb6(str) {
    const result = [];
    const state = {
        queue: 0,
        queuedBits: 0
    };
    const onByte = (byte)=>{
        result.push(byte);
    };
    for(let i = 0; i < str.length; i += 1)$dbf67752838ebc66$export$403e86c86002a137(str.charCodeAt(i), state, onByte);
    return new Uint8Array(result);
}
function $dbf67752838ebc66$export$a098e7b533f96db3(str) {
    const result = [];
    $dbf67752838ebc66$export$caccae6095ceb6da(str, (byte)=>result.push(byte));
    return new Uint8Array(result);
}
function $dbf67752838ebc66$export$3f156efe462a835e(bytes) {
    const result = [];
    const state = {
        queue: 0,
        queuedBits: 0
    };
    const onChar = (char)=>{
        result.push(char);
    };
    bytes.forEach((byte)=>$dbf67752838ebc66$export$744f452403189a3e(byte, state, onChar));
    // always call with `null` after processing all bytes
    $dbf67752838ebc66$export$744f452403189a3e(null, state, onChar);
    return result.join('');
}

});



parcelRegister("39QCi", function(module, exports) {

$parcel$export(module.exports, "SIGN_OUT_SCOPES", () => $24cb06f66874b0a4$export$9a0f1d0c97ce73ca);
const $24cb06f66874b0a4$var$WeakPasswordReasons = [
    'length',
    'characters',
    'pwned'
];
const $24cb06f66874b0a4$var$AMRMethods = [
    'password',
    'otp',
    'oauth',
    'totp',
    'mfa/totp',
    'mfa/phone',
    'mfa/webauthn',
    'anonymous',
    'sso/saml',
    'magiclink',
    'web3',
    'oauth_provider/authorization_code'
];
const $24cb06f66874b0a4$var$FactorTypes = [
    'totp',
    'phone',
    'webauthn'
];
const $24cb06f66874b0a4$var$FactorVerificationStatuses = [
    'verified',
    'unverified'
];
const $24cb06f66874b0a4$var$MFATOTPChannels = [
    'sms',
    'whatsapp'
];
const $24cb06f66874b0a4$export$9a0f1d0c97ce73ca = [
    'global',
    'local',
    'others'
];

});


parcelRegister("b083j", function(module, exports) {

$parcel$export(module.exports, "default", () => $8025f0dcbc879582$export$2e2bcd8739ae039);

var $f8esb = parcelRequire("f8esb");

var $44TzP = parcelRequire("44TzP");

var $fTIQY = parcelRequire("fTIQY");

var $doWUR = parcelRequire("doWUR");

var $98hXt = parcelRequire("98hXt");

var $a7BAw = parcelRequire("a7BAw");

var $gn0EB = parcelRequire("gn0EB");

var $8WDEC = parcelRequire("8WDEC");

var $iIHZ2 = parcelRequire("iIHZ2");

var $iSR6L = parcelRequire("iSR6L");

var $baxuF = parcelRequire("baxuF");

var $2GmzD = parcelRequire("2GmzD");
(0, $8WDEC.polyfillGlobalThis)(); // Make "globalThis" available
const $8025f0dcbc879582$var$DEFAULT_OPTIONS = {
    url: (0, $44TzP.GOTRUE_URL),
    storageKey: (0, $44TzP.STORAGE_KEY),
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    headers: (0, $44TzP.DEFAULT_HEADERS),
    flowType: 'implicit',
    debug: false,
    hasCustomAuthorizationHeader: false,
    throwOnError: false,
    lockAcquireTimeout: 5000,
    skipAutoInitialize: false,
    experimental: {}
};
async function $8025f0dcbc879582$var$lockNoOp(name, acquireTimeout, fn) {
    return await fn();
}
/**
 * Caches JWKS values for all clients created in the same environment. This is
 * especially useful for shared-memory execution environments such as Vercel's
 * Fluid Compute, AWS Lambda or Supabase's Edge Functions. Regardless of how
 * many clients are created, if they share the same storage key they will use
 * the same JWKS cache, significantly speeding up getClaims() with asymmetric
 * JWTs.
 */ const $8025f0dcbc879582$var$GLOBAL_JWKS = {};
class $8025f0dcbc879582$var$GoTrueClient {
    /**
     * The JWKS used for verifying asymmetric JWTs
     */ get jwks() {
        var _a, _b;
        return (_b = (_a = $8025f0dcbc879582$var$GLOBAL_JWKS[this.storageKey]) === null || _a === void 0 ? void 0 : _a.jwks) !== null && _b !== void 0 ? _b : {
            keys: []
        };
    }
    set jwks(value) {
        $8025f0dcbc879582$var$GLOBAL_JWKS[this.storageKey] = Object.assign(Object.assign({}, $8025f0dcbc879582$var$GLOBAL_JWKS[this.storageKey]), {
            jwks: value
        });
    }
    get jwks_cached_at() {
        var _a, _b;
        return (_b = (_a = $8025f0dcbc879582$var$GLOBAL_JWKS[this.storageKey]) === null || _a === void 0 ? void 0 : _a.cachedAt) !== null && _b !== void 0 ? _b : Number.MIN_SAFE_INTEGER;
    }
    set jwks_cached_at(value) {
        $8025f0dcbc879582$var$GLOBAL_JWKS[this.storageKey] = Object.assign(Object.assign({}, $8025f0dcbc879582$var$GLOBAL_JWKS[this.storageKey]), {
            cachedAt: value
        });
    }
    /**
     * Create a new client for use in the browser.
     *
     * @example Using supabase-js (recommended)
     * ```ts
     * import { createClient } from '@supabase/supabase-js'
     *
     * const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
     * const { data, error } = await supabase.auth.getUser()
     * ```
     *
     * @example Standalone import for bundle-sensitive environments
     * ```ts
     * import { GoTrueClient } from '@supabase/auth-js'
     *
     * const auth = new GoTrueClient({
     *   url: 'https://xyzcompany.supabase.co/auth/v1',
     *   headers: { apikey: 'your-publishable-key' },
     *   storageKey: 'supabase-auth',
     * })
     * ```
     */ constructor(options){
        var _a, _b, _c, _d;
        /**
         * @experimental
         */ this.userStorage = null;
        this.memoryStorage = null;
        this.stateChangeEmitters = new Map();
        this.autoRefreshTicker = null;
        this.autoRefreshTickTimeout = null;
        this.visibilityChangedCallback = null;
        this.refreshingDeferred = null;
        /**
         * Keeps track of the async client initialization.
         * When null or not yet resolved the auth state is `unknown`
         * Once resolved the auth state is known and it's safe to call any further client methods.
         * Keep extra care to never reject or throw uncaught errors
         */ this.initializePromise = null;
        this.detectSessionInUrl = true;
        this.hasCustomAuthorizationHeader = false;
        this.suppressGetSessionWarning = false;
        this.lockAcquired = false;
        this.pendingInLock = [];
        /**
         * Used to broadcast state change events to other tabs listening.
         */ this.broadcastChannel = null;
        this.logger = console.log;
        const settings = Object.assign(Object.assign({}, $8025f0dcbc879582$var$DEFAULT_OPTIONS), options);
        this.storageKey = settings.storageKey;
        this.instanceID = (_a = $8025f0dcbc879582$var$GoTrueClient.nextInstanceID[this.storageKey]) !== null && _a !== void 0 ? _a : 0;
        $8025f0dcbc879582$var$GoTrueClient.nextInstanceID[this.storageKey] = this.instanceID + 1;
        this.logDebugMessages = !!settings.debug;
        if (typeof settings.debug === 'function') this.logger = settings.debug;
        if (this.instanceID > 0 && (0, $98hXt.isBrowser)()) {
            const message = `${this._logPrefix()} Multiple GoTrueClient instances detected in the same browser context. It is not an error, but this should be avoided as it may produce undefined behavior when used concurrently under the same storage key.`;
            console.warn(message);
            if (this.logDebugMessages) console.trace(message);
        }
        this.persistSession = settings.persistSession;
        this.autoRefreshToken = settings.autoRefreshToken;
        this.experimental = (_b = settings.experimental) !== null && _b !== void 0 ? _b : {};
        this.admin = new (0, $f8esb.default)({
            url: settings.url,
            headers: settings.headers,
            fetch: settings.fetch,
            experimental: this.experimental
        });
        this.url = settings.url;
        this.headers = settings.headers;
        this.fetch = (0, $98hXt.resolveFetch)(settings.fetch);
        this.lock = settings.lock || $8025f0dcbc879582$var$lockNoOp;
        this.detectSessionInUrl = settings.detectSessionInUrl;
        this.flowType = settings.flowType;
        this.hasCustomAuthorizationHeader = settings.hasCustomAuthorizationHeader;
        this.throwOnError = settings.throwOnError;
        this.lockAcquireTimeout = settings.lockAcquireTimeout;
        if (settings.lock) this.lock = settings.lock;
        else if (this.persistSession && (0, $98hXt.isBrowser)() && ((_c = globalThis === null || globalThis === void 0 ? void 0 : globalThis.navigator) === null || _c === void 0 ? void 0 : _c.locks)) this.lock = (0, $gn0EB.navigatorLock);
        else this.lock = $8025f0dcbc879582$var$lockNoOp;
        if (!this.jwks) {
            this.jwks = {
                keys: []
            };
            this.jwks_cached_at = Number.MIN_SAFE_INTEGER;
        }
        this.mfa = {
            verify: this._verify.bind(this),
            enroll: this._enroll.bind(this),
            unenroll: this._unenroll.bind(this),
            challenge: this._challenge.bind(this),
            listFactors: this._listFactors.bind(this),
            challengeAndVerify: this._challengeAndVerify.bind(this),
            getAuthenticatorAssuranceLevel: this._getAuthenticatorAssuranceLevel.bind(this),
            webauthn: new (0, $2GmzD.WebAuthnApi)(this)
        };
        this.oauth = {
            getAuthorizationDetails: this._getAuthorizationDetails.bind(this),
            approveAuthorization: this._approveAuthorization.bind(this),
            denyAuthorization: this._denyAuthorization.bind(this),
            listGrants: this._listOAuthGrants.bind(this),
            revokeGrant: this._revokeOAuthGrant.bind(this)
        };
        this.passkey = {
            startRegistration: this._startPasskeyRegistration.bind(this),
            verifyRegistration: this._verifyPasskeyRegistration.bind(this),
            startAuthentication: this._startPasskeyAuthentication.bind(this),
            verifyAuthentication: this._verifyPasskeyAuthentication.bind(this),
            list: this._listPasskeys.bind(this),
            update: this._updatePasskey.bind(this),
            delete: this._deletePasskey.bind(this)
        };
        if (this.persistSession) {
            if (settings.storage) this.storage = settings.storage;
            else if ((0, $98hXt.supportsLocalStorage)()) this.storage = globalThis.localStorage;
            else {
                this.memoryStorage = {};
                this.storage = (0, $a7BAw.memoryLocalStorageAdapter)(this.memoryStorage);
            }
            if (settings.userStorage) this.userStorage = settings.userStorage;
        } else {
            this.memoryStorage = {};
            this.storage = (0, $a7BAw.memoryLocalStorageAdapter)(this.memoryStorage);
        }
        if ((0, $98hXt.isBrowser)() && globalThis.BroadcastChannel && this.persistSession && this.storageKey) {
            try {
                this.broadcastChannel = new globalThis.BroadcastChannel(this.storageKey);
            } catch (e) {
                console.error('Failed to create a new BroadcastChannel, multi-tab state changes will not be available', e);
            }
            (_d = this.broadcastChannel) === null || _d === void 0 || _d.addEventListener('message', async (event)=>{
                this._debug('received broadcast notification from other tab or client', event);
                try {
                    await this._notifyAllSubscribers(event.data.event, event.data.session, false); // broadcast = false so we don't get an endless loop of messages
                } catch (error) {
                    this._debug('#broadcastChannel', 'error', error);
                }
            });
        }
        // Only auto-initialize if not explicitly disabled. Skipped in SSR contexts
        // where initialization timing must be controlled. All public methods have
        // lazy initialization, so the client remains fully functional.
        if (!settings.skipAutoInitialize) this.initialize().catch((error)=>{
            this._debug('#initialize()', 'error', error);
        });
    }
    /**
     * Returns whether error throwing mode is enabled for this client.
     */ isThrowOnErrorEnabled() {
        return this.throwOnError;
    }
    /**
     * Centralizes return handling with optional error throwing. When `throwOnError` is enabled
     * and the provided result contains a non-nullish error, the error is thrown instead of
     * being returned. This ensures consistent behavior across all public API methods.
     */ _returnResult(result) {
        if (this.throwOnError && result && result.error) throw result.error;
        return result;
    }
    _logPrefix() {
        return 'GoTrueClient@' + `${this.storageKey}:${this.instanceID} (${0, $iIHZ2.version}) ${new Date().toISOString()}`;
    }
    _debug(...args) {
        if (this.logDebugMessages) this.logger(this._logPrefix(), ...args);
        return this;
    }
    /**
     * Initializes the client session either from the url or from storage.
     * This method is automatically called when instantiating the client, but should also be called
     * manually when checking for an error from an auth redirect (oauth, magiclink, password recovery, etc).
     *
     * @category Auth
     */ async initialize() {
        if (this.initializePromise) return await this.initializePromise;
        this.initializePromise = (async ()=>{
            return await this._acquireLock(this.lockAcquireTimeout, async ()=>{
                return await this._initialize();
            });
        })();
        return await this.initializePromise;
    }
    /**
     * IMPORTANT:
     * 1. Never throw in this method, as it is called from the constructor
     * 2. Never return a session from this method as it would be cached over
     *    the whole lifetime of the client
     */ async _initialize() {
        var _a;
        try {
            let params = {};
            let callbackUrlType = 'none';
            if ((0, $98hXt.isBrowser)()) {
                params = (0, $98hXt.parseParametersFromURL)(window.location.href);
                if (this._isImplicitGrantCallback(params)) callbackUrlType = 'implicit';
                else if (await this._isPKCECallback(params)) callbackUrlType = 'pkce';
            }
            /**
             * Attempt to get the session from the URL only if these conditions are fulfilled
             *
             * Note: If the URL isn't one of the callback url types (implicit or pkce),
             * then there could be an existing session so we don't want to prematurely remove it
             */ if ((0, $98hXt.isBrowser)() && this.detectSessionInUrl && callbackUrlType !== 'none') {
                const { data: data, error: error } = await this._getSessionFromURL(params, callbackUrlType);
                if (error) {
                    this._debug('#_initialize()', 'error detecting session from URL', error);
                    if ((0, $fTIQY.isAuthImplicitGrantRedirectError)(error)) {
                        const errorCode = (_a = error.details) === null || _a === void 0 ? void 0 : _a.code;
                        if (errorCode === 'identity_already_exists' || errorCode === 'identity_not_found' || errorCode === 'single_identity_not_deletable') return {
                            error: error
                        };
                    }
                    // Don't remove existing session on URL login failure.
                    // A failed attempt (e.g. reused magic link) shouldn't invalidate a valid session.
                    return {
                        error: error
                    };
                }
                const { session: session, redirectType: redirectType } = data;
                this._debug('#_initialize()', 'detected session in URL', session, 'redirect type', redirectType);
                await this._saveSession(session);
                setTimeout(async ()=>{
                    if (redirectType === 'recovery') await this._notifyAllSubscribers('PASSWORD_RECOVERY', session);
                    else await this._notifyAllSubscribers('SIGNED_IN', session);
                }, 0);
                return {
                    error: null
                };
            }
            // no login attempt via callback url try to recover session from storage
            await this._recoverAndRefresh();
            return {
                error: null
            };
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                error: error
            });
            return this._returnResult({
                error: new (0, $fTIQY.AuthUnknownError)('Unexpected error during initialization', error)
            });
        } finally{
            await this._handleVisibilityChange();
            this._debug('#_initialize()', 'end');
        }
    }
    /**
     * Creates a new anonymous user.
     *
     * @returns A session where the is_anonymous claim in the access token JWT set to true
     *
     * @category Auth
     *
     * @remarks
     * - Returns an anonymous user
     * - It is recommended to set up captcha for anonymous sign-ins to prevent abuse. You can pass in the captcha token in the `options` param.
     *
     * @example Create an anonymous user
     * ```js
     * const { data, error } = await supabase.auth.signInAnonymously({
     *   options: {
     *     captchaToken
     *   }
     * });
     * ```
     *
     * @exampleResponse Create an anonymous user
     * ```json
     * {
     *   "data": {
     *     "user": {
     *       "id": "11111111-1111-1111-1111-111111111111",
     *       "aud": "authenticated",
     *       "role": "authenticated",
     *       "email": "",
     *       "phone": "",
     *       "last_sign_in_at": "2024-01-01T00:00:00Z",
     *       "app_metadata": {},
     *       "user_metadata": {},
     *       "identities": [],
     *       "created_at": "2024-01-01T00:00:00Z",
     *       "updated_at": "2024-01-01T00:00:00Z",
     *       "is_anonymous": true
     *     },
     *     "session": {
     *       "access_token": "<ACCESS_TOKEN>",
     *       "token_type": "bearer",
     *       "expires_in": 3600,
     *       "expires_at": 1700000000,
     *       "refresh_token": "<REFRESH_TOKEN>",
     *       "user": {
     *         "id": "11111111-1111-1111-1111-111111111111",
     *         "aud": "authenticated",
     *         "role": "authenticated",
     *         "email": "",
     *         "phone": "",
     *         "last_sign_in_at": "2024-01-01T00:00:00Z",
     *         "app_metadata": {},
     *         "user_metadata": {},
     *         "identities": [],
     *         "created_at": "2024-01-01T00:00:00Z",
     *         "updated_at": "2024-01-01T00:00:00Z",
     *         "is_anonymous": true
     *       }
     *     }
     *   },
     *   "error": null
     * }
     * ```
     *
     * @example Create an anonymous user with custom user metadata
     * ```js
     * const { data, error } = await supabase.auth.signInAnonymously({
     *   options: {
     *     data
     *   }
     * })
     * ```
     */ async signInAnonymously(credentials) {
        var _a, _b, _c;
        try {
            const res = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/signup`, {
                headers: this.headers,
                body: {
                    data: (_b = (_a = credentials === null || credentials === void 0 ? void 0 : credentials.options) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : {},
                    gotrue_meta_security: {
                        captcha_token: (_c = credentials === null || credentials === void 0 ? void 0 : credentials.options) === null || _c === void 0 ? void 0 : _c.captchaToken
                    }
                },
                xform: (0, $doWUR._sessionResponse)
            });
            const { data: data, error: error } = res;
            if (error || !data) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            const session = data.session;
            const user = data.user;
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', session);
            }
            return this._returnResult({
                data: {
                    user: user,
                    session: session
                },
                error: null
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Creates a new user.
     *
     * Be aware that if a user account exists in the system you may get back an
     * error message that attempts to hide this information from the user.
     * This method has support for PKCE via email signups. The PKCE flow cannot be used when autoconfirm is enabled.
     *
     * @returns A logged-in session if the server has "autoconfirm" ON
     * @returns A user if the server has "autoconfirm" OFF
     *
     * @category Auth
     *
     * @remarks
     * - By default, the user needs to verify their email address before logging in. To turn this off, disable **Confirm email** in [your project](/dashboard/project/_/auth/providers).
     * - **Confirm email** determines if users need to confirm their email address after signing up.
     *   - If **Confirm email** is enabled, a `user` is returned but `session` is null.
     *   - If **Confirm email** is disabled, both a `user` and a `session` are returned.
     * - When the user confirms their email address, they are redirected to the [`SITE_URL`](/docs/guides/auth/redirect-urls#use-wildcards-in-redirect-urls) by default. You can modify your `SITE_URL` or add additional redirect URLs in [your project](/dashboard/project/_/auth/url-configuration).
     * - If signUp() is called for an existing confirmed user:
     *   - When both **Confirm email** and **Confirm phone** (even when phone provider is disabled) are enabled in [your project](/dashboard/project/_/auth/providers), an obfuscated/fake user object is returned.
     *   - When either **Confirm email** or **Confirm phone** (even when phone provider is disabled) is disabled, the error message, `User already registered` is returned.
     * - To fetch the currently logged-in user, refer to [`getUser()`](/docs/reference/javascript/auth-getuser).
     *
     * @example Sign up with an email and password
     * ```js
     * const { data, error } = await supabase.auth.signUp({
     *   email: 'example@email.com',
     *   password: 'example-password',
     * })
     * ```
     *
     * @exampleResponse Sign up with an email and password
     * ```json
     * // Some fields may be null if "confirm email" is enabled.
     * {
     *   "data": {
     *     "user": {
     *       "id": "11111111-1111-1111-1111-111111111111",
     *       "aud": "authenticated",
     *       "role": "authenticated",
     *       "email": "example@email.com",
     *       "email_confirmed_at": "2024-01-01T00:00:00Z",
     *       "phone": "",
     *       "last_sign_in_at": "2024-01-01T00:00:00Z",
     *       "app_metadata": {
     *         "provider": "email",
     *         "providers": [
     *           "email"
     *         ]
     *       },
     *       "user_metadata": {},
     *       "identities": [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "11111111-1111-1111-1111-111111111111",
     *           "user_id": "11111111-1111-1111-1111-111111111111",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": false,
     *             "phone_verified": false,
     *             "sub": "11111111-1111-1111-1111-111111111111"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "example@email.com"
     *         }
     *       ],
     *       "created_at": "2024-01-01T00:00:00Z",
     *       "updated_at": "2024-01-01T00:00:00Z"
     *     },
     *     "session": {
     *       "access_token": "<ACCESS_TOKEN>",
     *       "token_type": "bearer",
     *       "expires_in": 3600,
     *       "expires_at": 1700000000,
     *       "refresh_token": "<REFRESH_TOKEN>",
     *       "user": {
     *         "id": "11111111-1111-1111-1111-111111111111",
     *         "aud": "authenticated",
     *         "role": "authenticated",
     *         "email": "example@email.com",
     *         "email_confirmed_at": "2024-01-01T00:00:00Z",
     *         "phone": "",
     *         "last_sign_in_at": "2024-01-01T00:00:00Z",
     *         "app_metadata": {
     *           "provider": "email",
     *           "providers": [
     *             "email"
     *           ]
     *         },
     *         "user_metadata": {},
     *         "identities": [
     *           {
     *             "identity_id": "22222222-2222-2222-2222-222222222222",
     *             "id": "11111111-1111-1111-1111-111111111111",
     *             "user_id": "11111111-1111-1111-1111-111111111111",
     *             "identity_data": {
     *               "email": "example@email.com",
     *               "email_verified": false,
     *               "phone_verified": false,
     *               "sub": "11111111-1111-1111-1111-111111111111"
     *             },
     *             "provider": "email",
     *             "last_sign_in_at": "2024-01-01T00:00:00Z",
     *             "created_at": "2024-01-01T00:00:00Z",
     *             "updated_at": "2024-01-01T00:00:00Z",
     *             "email": "example@email.com"
     *           }
     *         ],
     *         "created_at": "2024-01-01T00:00:00Z",
     *         "updated_at": "2024-01-01T00:00:00Z"
     *       }
     *     }
     *   },
     *   "error": null
     * }
     * ```
     *
     * @example Sign up with a phone number and password (SMS)
     * ```js
     * const { data, error } = await supabase.auth.signUp({
     *   phone: '123456789',
     *   password: 'example-password',
     *   options: {
     *     channel: 'sms'
     *   }
     * })
     * ```
     *
     * @exampleDescription Sign up with a phone number and password (whatsapp)
     * The user will be sent a WhatsApp message which contains a OTP. By default, a given user can only request a OTP once every 60 seconds. Note that a user will need to have a valid WhatsApp account that is linked to Twilio in order to use this feature.
     *
     * @example Sign up with a phone number and password (whatsapp)
     * ```js
     * const { data, error } = await supabase.auth.signUp({
     *   phone: '123456789',
     *   password: 'example-password',
     *   options: {
     *     channel: 'whatsapp'
     *   }
     * })
     * ```
     *
     * @example Sign up with additional user metadata
     * ```js
     * const { data, error } = await supabase.auth.signUp(
     *   {
     *     email: 'example@email.com',
     *     password: 'example-password',
     *     options: {
     *       data: {
     *         first_name: 'John',
     *         age: 27,
     *       }
     *     }
     *   }
     * )
     * ```
     *
     * @exampleDescription Sign up with a redirect URL
     * - See [redirect URLs and wildcards](/docs/guides/auth/redirect-urls#use-wildcards-in-redirect-urls) to add additional redirect URLs to your project.
     *
     * @example Sign up with a redirect URL
     * ```js
     * const { data, error } = await supabase.auth.signUp(
     *   {
     *     email: 'example@email.com',
     *     password: 'example-password',
     *     options: {
     *       emailRedirectTo: 'https://example.com/welcome'
     *     }
     *   }
     * )
     * ```
     */ async signUp(credentials) {
        var _a, _b, _c;
        try {
            let res;
            if ('email' in credentials) {
                const { email: email, password: password, options: options } = credentials;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, $98hXt.getCodeChallengeAndMethod)(this.storage, this.storageKey);
                res = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/signup`, {
                    headers: this.headers,
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo,
                    body: {
                        email: email,
                        password: password,
                        data: (_a = options === null || options === void 0 ? void 0 : options.data) !== null && _a !== void 0 ? _a : {},
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    },
                    xform: (0, $doWUR._sessionResponse)
                });
            } else if ('phone' in credentials) {
                const { phone: phone, password: password, options: options } = credentials;
                res = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/signup`, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        password: password,
                        data: (_b = options === null || options === void 0 ? void 0 : options.data) !== null && _b !== void 0 ? _b : {},
                        channel: (_c = options === null || options === void 0 ? void 0 : options.channel) !== null && _c !== void 0 ? _c : 'sms',
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, $doWUR._sessionResponse)
                });
            } else throw new (0, $fTIQY.AuthInvalidCredentialsError)('You must provide either an email or phone number and a password');
            const { data: data, error: error } = res;
            if (error || !data) {
                await (0, $98hXt.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
                return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
            }
            const session = data.session;
            const user = data.user;
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', session);
            }
            return this._returnResult({
                data: {
                    user: user,
                    session: session
                },
                error: null
            });
        } catch (error) {
            await (0, $98hXt.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Log in an existing user with an email and password or phone and password.
     *
     * Be aware that you may get back an error message that will not distinguish
     * between the cases where the account does not exist or that the
     * email/phone and password combination is wrong or that the account can only
     * be accessed via social login.
     *
     * @category Auth
     *
     * @remarks
     * - Requires either an email and password or a phone number and password.
     *
     * @example Sign in with email and password
     * ```js
     * const { data, error } = await supabase.auth.signInWithPassword({
     *   email: 'example@email.com',
     *   password: 'example-password',
     * })
     * ```
     *
     * @exampleResponse Sign in with email and password
     * ```json
     * {
     *   "data": {
     *     "user": {
     *       "id": "11111111-1111-1111-1111-111111111111",
     *       "aud": "authenticated",
     *       "role": "authenticated",
     *       "email": "example@email.com",
     *       "email_confirmed_at": "2024-01-01T00:00:00Z",
     *       "phone": "",
     *       "last_sign_in_at": "2024-01-01T00:00:00Z",
     *       "app_metadata": {
     *         "provider": "email",
     *         "providers": [
     *           "email"
     *         ]
     *       },
     *       "user_metadata": {},
     *       "identities": [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "11111111-1111-1111-1111-111111111111",
     *           "user_id": "11111111-1111-1111-1111-111111111111",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": false,
     *             "phone_verified": false,
     *             "sub": "11111111-1111-1111-1111-111111111111"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "example@email.com"
     *         }
     *       ],
     *       "created_at": "2024-01-01T00:00:00Z",
     *       "updated_at": "2024-01-01T00:00:00Z"
     *     },
     *     "session": {
     *       "access_token": "<ACCESS_TOKEN>",
     *       "token_type": "bearer",
     *       "expires_in": 3600,
     *       "expires_at": 1700000000,
     *       "refresh_token": "<REFRESH_TOKEN>",
     *       "user": {
     *         "id": "11111111-1111-1111-1111-111111111111",
     *         "aud": "authenticated",
     *         "role": "authenticated",
     *         "email": "example@email.com",
     *         "email_confirmed_at": "2024-01-01T00:00:00Z",
     *         "phone": "",
     *         "last_sign_in_at": "2024-01-01T00:00:00Z",
     *         "app_metadata": {
     *           "provider": "email",
     *           "providers": [
     *             "email"
     *           ]
     *         },
     *         "user_metadata": {},
     *         "identities": [
     *           {
     *             "identity_id": "22222222-2222-2222-2222-222222222222",
     *             "id": "11111111-1111-1111-1111-111111111111",
     *             "user_id": "11111111-1111-1111-1111-111111111111",
     *             "identity_data": {
     *               "email": "example@email.com",
     *               "email_verified": false,
     *               "phone_verified": false,
     *               "sub": "11111111-1111-1111-1111-111111111111"
     *             },
     *             "provider": "email",
     *             "last_sign_in_at": "2024-01-01T00:00:00Z",
     *             "created_at": "2024-01-01T00:00:00Z",
     *             "updated_at": "2024-01-01T00:00:00Z",
     *             "email": "example@email.com"
     *           }
     *         ],
     *         "created_at": "2024-01-01T00:00:00Z",
     *         "updated_at": "2024-01-01T00:00:00Z"
     *       }
     *     }
     *   },
     *   "error": null
     * }
     * ```
     *
     * @example Sign in with phone and password
     * ```js
     * const { data, error } = await supabase.auth.signInWithPassword({
     *   phone: '+13334445555',
     *   password: 'some-password',
     * })
     * ```
     */ async signInWithPassword(credentials) {
        try {
            let res;
            if ('email' in credentials) {
                const { email: email, password: password, options: options } = credentials;
                res = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/token?grant_type=password`, {
                    headers: this.headers,
                    body: {
                        email: email,
                        password: password,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, $doWUR._sessionResponsePassword)
                });
            } else if ('phone' in credentials) {
                const { phone: phone, password: password, options: options } = credentials;
                res = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/token?grant_type=password`, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        password: password,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, $doWUR._sessionResponsePassword)
                });
            } else throw new (0, $fTIQY.AuthInvalidCredentialsError)('You must provide either an email or phone number and a password');
            const { data: data, error: error } = res;
            if (error) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            else if (!data || !data.session || !data.user) {
                const invalidTokenError = new (0, $fTIQY.AuthInvalidTokenResponseError)();
                return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: invalidTokenError
                });
            }
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return this._returnResult({
                data: Object.assign({
                    user: data.user,
                    session: data.session
                }, data.weak_password ? {
                    weakPassword: data.weak_password
                } : null),
                error: error
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Log in an existing user via a third-party provider.
     * This method supports the PKCE flow.
     *
     * @category Auth
     *
     * @remarks
     * - This method is used for signing in using [Social Login (OAuth) providers](/docs/guides/auth#configure-third-party-providers).
     * - It works by redirecting your application to the provider's authorization screen, before bringing back the user to your app.
     *
     * @example Sign in using a third-party provider
     * ```js
     * const { data, error } = await supabase.auth.signInWithOAuth({
     *   provider: 'github'
     * })
     * ```
     *
     * @exampleResponse Sign in using a third-party provider
     * ```json
     * {
     *   data: {
     *     provider: 'github',
     *     url: <PROVIDER_URL_TO_REDIRECT_TO>
     *   },
     *   error: null
     * }
     * ```
     *
     * @exampleDescription Sign in using a third-party provider with redirect
     * - When the OAuth provider successfully authenticates the user, they are redirected to the URL specified in the `redirectTo` parameter. This parameter defaults to the [`SITE_URL`](/docs/guides/auth/redirect-urls#use-wildcards-in-redirect-urls). It does not redirect the user immediately after invoking this method.
     * - See [redirect URLs and wildcards](/docs/guides/auth/redirect-urls#use-wildcards-in-redirect-urls) to add additional redirect URLs to your project.
     *
     * @example Sign in using a third-party provider with redirect
     * ```js
     * const { data, error } = await supabase.auth.signInWithOAuth({
     *   provider: 'github',
     *   options: {
     *     redirectTo: 'https://example.com/welcome'
     *   }
     * })
     * ```
     *
     * @exampleDescription Sign in with scopes and access provider tokens
     * If you need additional access from an OAuth provider, in order to access provider specific APIs in the name of the user, you can do this by passing in the scopes the user should authorize for your application. Note that the `scopes` option takes in **a space-separated list** of scopes.
     *
     * Because OAuth sign-in often includes redirects, you should register an `onAuthStateChange` callback immediately after you create the Supabase client. This callback will listen for the presence of `provider_token` and `provider_refresh_token` properties on the `session` object and store them in local storage. The client library will emit these values **only once** immediately after the user signs in. You can then access them by looking them up in local storage, or send them to your backend servers for further processing.
     *
     * Finally, make sure you remove them from local storage on the `SIGNED_OUT` event. If the OAuth provider supports token revocation, make sure you call those APIs either from the frontend or schedule them to be called on the backend.
     *
     * @example Sign in with scopes and access provider tokens
     * ```js
     * // Register this immediately after calling createClient!
     * // Because signInWithOAuth causes a redirect, you need to fetch the
     * // provider tokens from the callback.
     * supabase.auth.onAuthStateChange((event, session) => {
     *   if (session && session.provider_token) {
     *     window.localStorage.setItem('oauth_provider_token', session.provider_token)
     *   }
     *
     *   if (session && session.provider_refresh_token) {
     *     window.localStorage.setItem('oauth_provider_refresh_token', session.provider_refresh_token)
     *   }
     *
     *   if (event === 'SIGNED_OUT') {
     *     window.localStorage.removeItem('oauth_provider_token')
     *     window.localStorage.removeItem('oauth_provider_refresh_token')
     *   }
     * })
     *
     * // Call this on your Sign in with GitHub button to initiate OAuth
     * // with GitHub with the requested elevated scopes.
     * await supabase.auth.signInWithOAuth({
     *   provider: 'github',
     *   options: {
     *     scopes: 'repo gist notifications'
     *   }
     * })
     * ```
     */ async signInWithOAuth(credentials) {
        var _a, _b, _c, _d;
        return await this._handleProviderSignIn(credentials.provider, {
            redirectTo: (_a = credentials.options) === null || _a === void 0 ? void 0 : _a.redirectTo,
            scopes: (_b = credentials.options) === null || _b === void 0 ? void 0 : _b.scopes,
            queryParams: (_c = credentials.options) === null || _c === void 0 ? void 0 : _c.queryParams,
            skipBrowserRedirect: (_d = credentials.options) === null || _d === void 0 ? void 0 : _d.skipBrowserRedirect
        });
    }
    /**
     * Log in an existing user by exchanging an Auth Code issued during the PKCE flow.
     *
     * @category Auth
     *
     * @remarks
     * - Used when `flowType` is set to `pkce` in client options.
     *
     * @example Exchange Auth Code
     * ```js
     * supabase.auth.exchangeCodeForSession('34e770dd-9ff9-416c-87fa-43b31d7ef225')
     * ```
     *
     * @exampleResponse Exchange Auth Code
     * ```json
     * {
     *   "data": {
     *     session: {
     *       access_token: '<ACCESS_TOKEN>',
     *       token_type: 'bearer',
     *       expires_in: 3600,
     *       expires_at: 1700000000,
     *       refresh_token: '<REFRESH_TOKEN>',
     *       user: {
     *         id: '11111111-1111-1111-1111-111111111111',
     *         aud: 'authenticated',
     *         role: 'authenticated',
     *         email: 'example@email.com'
     *         email_confirmed_at: '2024-01-01T00:00:00Z',
     *         phone: '',
     *         confirmation_sent_at: '2024-01-01T00:00:00Z',
     *         confirmed_at: '2024-01-01T00:00:00Z',
     *         last_sign_in_at: '2024-01-01T00:00:00Z',
     *         app_metadata: {
     *           "provider": "email",
     *           "providers": [
     *             "email",
     *             "<OTHER_PROVIDER>"
     *           ]
     *         },
     *         user_metadata: {
     *           email: 'email@email.com',
     *           email_verified: true,
     *           full_name: 'User Name',
     *           iss: '<ISS>',
     *           name: 'User Name',
     *           phone_verified: false,
     *           provider_id: '<PROVIDER_ID>',
     *           sub: '<SUB>'
     *         },
     *         identities: [
     *           {
     *             "identity_id": "22222222-2222-2222-2222-222222222222",
     *             "id": "11111111-1111-1111-1111-111111111111",
     *             "user_id": "11111111-1111-1111-1111-111111111111",
     *             "identity_data": {
     *               "email": "example@email.com",
     *               "email_verified": false,
     *               "phone_verified": false,
     *               "sub": "11111111-1111-1111-1111-111111111111"
     *             },
     *             "provider": "email",
     *             "last_sign_in_at": "2024-01-01T00:00:00Z",
     *             "created_at": "2024-01-01T00:00:00Z",
     *             "updated_at": "2024-01-01T00:00:00Z",
     *             "email": "email@example.com"
     *           },
     *           {
     *             "identity_id": "33333333-3333-3333-3333-333333333333",
     *             "id": "<ID>",
     *             "user_id": "<USER_ID>",
     *             "identity_data": {
     *               "email": "example@email.com",
     *               "email_verified": true,
     *               "full_name": "User Name",
     *               "iss": "<ISS>",
     *               "name": "User Name",
     *               "phone_verified": false,
     *               "provider_id": "<PROVIDER_ID>",
     *               "sub": "<SUB>"
     *             },
     *             "provider": "<PROVIDER>",
     *             "last_sign_in_at": "2024-01-01T00:00:00Z",
     *             "created_at": "2024-01-01T00:00:00Z",
     *             "updated_at": "2024-01-01T00:00:00Z",
     *             "email": "example@email.com"
     *           }
     *         ],
     *         created_at: '2024-01-01T00:00:00Z',
     *         updated_at: '2024-01-01T00:00:00Z',
     *         is_anonymous: false
     *       },
     *       provider_token: '<PROVIDER_TOKEN>',
     *       provider_refresh_token: '<PROVIDER_REFRESH_TOKEN>'
     *     },
     *     user: {
     *       id: '11111111-1111-1111-1111-111111111111',
     *       aud: 'authenticated',
     *       role: 'authenticated',
     *       email: 'example@email.com',
     *       email_confirmed_at: '2024-01-01T00:00:00Z',
     *       phone: '',
     *       confirmation_sent_at: '2024-01-01T00:00:00Z',
     *       confirmed_at: '2024-01-01T00:00:00Z',
     *       last_sign_in_at: '2024-01-01T00:00:00Z',
     *       app_metadata: {
     *         provider: 'email',
     *         providers: [
     *           "email",
     *           "<OTHER_PROVIDER>"
     *         ]
     *       },
     *       user_metadata: {
     *         email: 'email@email.com',
     *         email_verified: true,
     *         full_name: 'User Name',
     *         iss: '<ISS>',
     *         name: 'User Name',
     *         phone_verified: false,
     *         provider_id: '<PROVIDER_ID>',
     *         sub: '<SUB>'
     *       },
     *       identities: [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "11111111-1111-1111-1111-111111111111",
     *           "user_id": "11111111-1111-1111-1111-111111111111",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": false,
     *             "phone_verified": false,
     *             "sub": "11111111-1111-1111-1111-111111111111"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "email@example.com"
     *         },
     *         {
     *           "identity_id": "33333333-3333-3333-3333-333333333333",
     *           "id": "<ID>",
     *           "user_id": "<USER_ID>",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": true,
     *             "full_name": "User Name",
     *             "iss": "<ISS>",
     *             "name": "User Name",
     *             "phone_verified": false,
     *             "provider_id": "<PROVIDER_ID>",
     *             "sub": "<SUB>"
     *           },
     *           "provider": "<PROVIDER>",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "example@email.com"
     *         }
     *       ],
     *       created_at: '2024-01-01T00:00:00Z',
     *       updated_at: '2024-01-01T00:00:00Z',
     *       is_anonymous: false
     *     },
     *     redirectType: null
     *   },
     *   "error": null
     * }
     * ```
     */ async exchangeCodeForSession(authCode) {
        await this.initializePromise;
        return this._acquireLock(this.lockAcquireTimeout, async ()=>{
            return this._exchangeCodeForSession(authCode);
        });
    }
    /**
     * Signs in a user by verifying a message signed by the user's private key.
     * Supports Ethereum (via Sign-In-With-Ethereum) & Solana (Sign-In-With-Solana) standards,
     * both of which derive from the EIP-4361 standard
     * With slight variation on Solana's side.
     * @reference https://eips.ethereum.org/EIPS/eip-4361
     *
     * @category Auth
     *
     * @remarks
     * - Uses a Web3 (Ethereum, Solana) wallet to sign a user in.
     * - Read up on the [potential for abuse](/docs/guides/auth/auth-web3#potential-for-abuse) before using it.
     *
     * @example Sign in with Solana or Ethereum (Window API)
     * ```js
     *   // uses window.ethereum for the wallet
     *   const { data, error } = await supabase.auth.signInWithWeb3({
     *     chain: 'ethereum',
     *     statement: 'I accept the Terms of Service at https://example.com/tos'
     *   })
     *
     *   // uses window.solana for the wallet
     *   const { data, error } = await supabase.auth.signInWithWeb3({
     *     chain: 'solana',
     *     statement: 'I accept the Terms of Service at https://example.com/tos'
     *   })
     * ```
     *
     * @example Sign in with Ethereum (Message and Signature)
     * ```js
     *   const { data, error } = await supabase.auth.signInWithWeb3({
     *     chain: 'ethereum',
     *     message: '<sign in with ethereum message>',
     *     signature: '<hex of the ethereum signature over the message>',
     *   })
     * ```
     *
     * @example Sign in with Solana (Brave)
     * ```js
     *   const { data, error } = await supabase.auth.signInWithWeb3({
     *     chain: 'solana',
     *     statement: 'I accept the Terms of Service at https://example.com/tos',
     *     wallet: window.braveSolana
     *   })
     * ```
     *
     * @example Sign in with Solana (Wallet Adapter)
     * ```jsx
     *   function SignInButton() {
     *   const wallet = useWallet()
     *
     *   return (
     *     <>
     *       {wallet.connected ? (
     *         <button
     *           onClick={() => {
     *             supabase.auth.signInWithWeb3({
     *               chain: 'solana',
     *               statement: 'I accept the Terms of Service at https://example.com/tos',
     *               wallet,
     *             })
     *           }}
     *         >
     *           Sign in with Solana
     *         </button>
     *       ) : (
     *         <WalletMultiButton />
     *       )}
     *     </>
     *   )
     * }
     *
     * function App() {
     *   const endpoint = clusterApiUrl('devnet')
     *   const wallets = useMemo(() => [], [])
     *
     *   return (
     *     <ConnectionProvider endpoint={endpoint}>
     *       <WalletProvider wallets={wallets}>
     *         <WalletModalProvider>
     *           <SignInButton />
     *         </WalletModalProvider>
     *       </WalletProvider>
     *     </ConnectionProvider>
     *   )
     * }
     * ```
     */ async signInWithWeb3(credentials) {
        const { chain: chain } = credentials;
        switch(chain){
            case 'ethereum':
                return await this.signInWithEthereum(credentials);
            case 'solana':
                return await this.signInWithSolana(credentials);
            default:
                throw new Error(`@supabase/auth-js: Unsupported chain "${chain}"`);
        }
    }
    async signInWithEthereum(credentials) {
        var _a, _b, _c, _d, _f, _g, _h, _j, _k, _l, _m;
        // TODO: flatten type
        let message;
        let signature;
        if ('message' in credentials) {
            message = credentials.message;
            signature = credentials.signature;
        } else {
            const { chain: chain, wallet: wallet, statement: statement, options: options } = credentials;
            let resolvedWallet;
            if (!(0, $98hXt.isBrowser)()) {
                if (typeof wallet !== 'object' || !(options === null || options === void 0 ? void 0 : options.url)) throw new Error('@supabase/auth-js: Both wallet and url must be specified in non-browser environments.');
                resolvedWallet = wallet;
            } else if (typeof wallet === 'object') resolvedWallet = wallet;
            else {
                const windowAny = window;
                if ('ethereum' in windowAny && typeof windowAny.ethereum === 'object' && 'request' in windowAny.ethereum && typeof windowAny.ethereum.request === 'function') resolvedWallet = windowAny.ethereum;
                else throw new Error(`@supabase/auth-js: No compatible Ethereum wallet interface on the window object (window.ethereum) detected. Make sure the user already has a wallet installed and connected for this app. Prefer passing the wallet interface object directly to signInWithWeb3({ chain: 'ethereum', wallet: resolvedUserWallet }) instead.`);
            }
            const url = new URL((_a = options === null || options === void 0 ? void 0 : options.url) !== null && _a !== void 0 ? _a : window.location.href);
            const accounts = await resolvedWallet.request({
                method: 'eth_requestAccounts'
            }).then((accs)=>accs).catch(()=>{
                throw new Error(`@supabase/auth-js: Wallet method eth_requestAccounts is missing or invalid`);
            });
            if (!accounts || accounts.length === 0) throw new Error(`@supabase/auth-js: No accounts available. Please ensure the wallet is connected.`);
            const address = (0, $baxuF.getAddress)(accounts[0]);
            let chainId = (_b = options === null || options === void 0 ? void 0 : options.signInWithEthereum) === null || _b === void 0 ? void 0 : _b.chainId;
            if (!chainId) {
                const chainIdHex = await resolvedWallet.request({
                    method: 'eth_chainId'
                });
                chainId = (0, $baxuF.fromHex)(chainIdHex);
            }
            const siweMessage = {
                domain: url.host,
                address: address,
                statement: statement,
                uri: url.href,
                version: '1',
                chainId: chainId,
                nonce: (_c = options === null || options === void 0 ? void 0 : options.signInWithEthereum) === null || _c === void 0 ? void 0 : _c.nonce,
                issuedAt: (_f = (_d = options === null || options === void 0 ? void 0 : options.signInWithEthereum) === null || _d === void 0 ? void 0 : _d.issuedAt) !== null && _f !== void 0 ? _f : new Date(),
                expirationTime: (_g = options === null || options === void 0 ? void 0 : options.signInWithEthereum) === null || _g === void 0 ? void 0 : _g.expirationTime,
                notBefore: (_h = options === null || options === void 0 ? void 0 : options.signInWithEthereum) === null || _h === void 0 ? void 0 : _h.notBefore,
                requestId: (_j = options === null || options === void 0 ? void 0 : options.signInWithEthereum) === null || _j === void 0 ? void 0 : _j.requestId,
                resources: (_k = options === null || options === void 0 ? void 0 : options.signInWithEthereum) === null || _k === void 0 ? void 0 : _k.resources
            };
            message = (0, $baxuF.createSiweMessage)(siweMessage);
            // Sign message
            signature = await resolvedWallet.request({
                method: 'personal_sign',
                params: [
                    (0, $baxuF.toHex)(message),
                    address
                ]
            });
        }
        try {
            const { data: data, error: error } = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/token?grant_type=web3`, {
                headers: this.headers,
                body: Object.assign({
                    chain: 'ethereum',
                    message: message,
                    signature: signature
                }, ((_l = credentials.options) === null || _l === void 0 ? void 0 : _l.captchaToken) ? {
                    gotrue_meta_security: {
                        captcha_token: (_m = credentials.options) === null || _m === void 0 ? void 0 : _m.captchaToken
                    }
                } : null),
                xform: (0, $doWUR._sessionResponse)
            });
            if (error) throw error;
            if (!data || !data.session || !data.user) {
                const invalidTokenError = new (0, $fTIQY.AuthInvalidTokenResponseError)();
                return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: invalidTokenError
                });
            }
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return this._returnResult({
                data: Object.assign({}, data),
                error: error
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    async signInWithSolana(credentials) {
        var _a, _b, _c, _d, _f, _g, _h, _j, _k, _l, _m, _o;
        let message;
        let signature;
        if ('message' in credentials) {
            message = credentials.message;
            signature = credentials.signature;
        } else {
            const { chain: chain, wallet: wallet, statement: statement, options: options } = credentials;
            let resolvedWallet;
            if (!(0, $98hXt.isBrowser)()) {
                if (typeof wallet !== 'object' || !(options === null || options === void 0 ? void 0 : options.url)) throw new Error('@supabase/auth-js: Both wallet and url must be specified in non-browser environments.');
                resolvedWallet = wallet;
            } else if (typeof wallet === 'object') resolvedWallet = wallet;
            else {
                const windowAny = window;
                if ('solana' in windowAny && typeof windowAny.solana === 'object' && ('signIn' in windowAny.solana && typeof windowAny.solana.signIn === 'function' || 'signMessage' in windowAny.solana && typeof windowAny.solana.signMessage === 'function')) resolvedWallet = windowAny.solana;
                else throw new Error(`@supabase/auth-js: No compatible Solana wallet interface on the window object (window.solana) detected. Make sure the user already has a wallet installed and connected for this app. Prefer passing the wallet interface object directly to signInWithWeb3({ chain: 'solana', wallet: resolvedUserWallet }) instead.`);
            }
            const url = new URL((_a = options === null || options === void 0 ? void 0 : options.url) !== null && _a !== void 0 ? _a : window.location.href);
            if ('signIn' in resolvedWallet && resolvedWallet.signIn) {
                const output = await resolvedWallet.signIn(Object.assign(Object.assign(Object.assign({
                    issuedAt: new Date().toISOString()
                }, options === null || options === void 0 ? void 0 : options.signInWithSolana), {
                    // non-overridable properties
                    version: '1',
                    domain: url.host,
                    uri: url.href
                }), statement ? {
                    statement: statement
                } : null));
                let outputToProcess;
                if (Array.isArray(output) && output[0] && typeof output[0] === 'object') outputToProcess = output[0];
                else if (output && typeof output === 'object' && 'signedMessage' in output && 'signature' in output) outputToProcess = output;
                else throw new Error('@supabase/auth-js: Wallet method signIn() returned unrecognized value');
                if ('signedMessage' in outputToProcess && 'signature' in outputToProcess && (typeof outputToProcess.signedMessage === 'string' || outputToProcess.signedMessage instanceof Uint8Array) && outputToProcess.signature instanceof Uint8Array) {
                    message = typeof outputToProcess.signedMessage === 'string' ? outputToProcess.signedMessage : new TextDecoder().decode(outputToProcess.signedMessage);
                    signature = outputToProcess.signature;
                } else throw new Error('@supabase/auth-js: Wallet method signIn() API returned object without signedMessage and signature fields');
            } else {
                if (!('signMessage' in resolvedWallet) || typeof resolvedWallet.signMessage !== 'function' || !('publicKey' in resolvedWallet) || typeof resolvedWallet !== 'object' || !resolvedWallet.publicKey || !('toBase58' in resolvedWallet.publicKey) || typeof resolvedWallet.publicKey.toBase58 !== 'function') throw new Error('@supabase/auth-js: Wallet does not have a compatible signMessage() and publicKey.toBase58() API');
                message = [
                    `${url.host} wants you to sign in with your Solana account:`,
                    resolvedWallet.publicKey.toBase58(),
                    ...statement ? [
                        '',
                        statement,
                        ''
                    ] : [
                        ''
                    ],
                    'Version: 1',
                    `URI: ${url.href}`,
                    `Issued At: ${(_c = (_b = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _b === void 0 ? void 0 : _b.issuedAt) !== null && _c !== void 0 ? _c : new Date().toISOString()}`,
                    ...((_d = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _d === void 0 ? void 0 : _d.notBefore) ? [
                        `Not Before: ${options.signInWithSolana.notBefore}`
                    ] : [],
                    ...((_f = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _f === void 0 ? void 0 : _f.expirationTime) ? [
                        `Expiration Time: ${options.signInWithSolana.expirationTime}`
                    ] : [],
                    ...((_g = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _g === void 0 ? void 0 : _g.chainId) ? [
                        `Chain ID: ${options.signInWithSolana.chainId}`
                    ] : [],
                    ...((_h = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _h === void 0 ? void 0 : _h.nonce) ? [
                        `Nonce: ${options.signInWithSolana.nonce}`
                    ] : [],
                    ...((_j = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _j === void 0 ? void 0 : _j.requestId) ? [
                        `Request ID: ${options.signInWithSolana.requestId}`
                    ] : [],
                    ...((_l = (_k = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _k === void 0 ? void 0 : _k.resources) === null || _l === void 0 ? void 0 : _l.length) ? [
                        'Resources',
                        ...options.signInWithSolana.resources.map((resource)=>`- ${resource}`)
                    ] : []
                ].join('\n');
                const maybeSignature = await resolvedWallet.signMessage(new TextEncoder().encode(message), 'utf8');
                if (!maybeSignature || !(maybeSignature instanceof Uint8Array)) throw new Error('@supabase/auth-js: Wallet signMessage() API returned an recognized value');
                signature = maybeSignature;
            }
        }
        try {
            const { data: data, error: error } = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/token?grant_type=web3`, {
                headers: this.headers,
                body: Object.assign({
                    chain: 'solana',
                    message: message,
                    signature: (0, $iSR6L.bytesToBase64URL)(signature)
                }, ((_m = credentials.options) === null || _m === void 0 ? void 0 : _m.captchaToken) ? {
                    gotrue_meta_security: {
                        captcha_token: (_o = credentials.options) === null || _o === void 0 ? void 0 : _o.captchaToken
                    }
                } : null),
                xform: (0, $doWUR._sessionResponse)
            });
            if (error) throw error;
            if (!data || !data.session || !data.user) {
                const invalidTokenError = new (0, $fTIQY.AuthInvalidTokenResponseError)();
                return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: invalidTokenError
                });
            }
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return this._returnResult({
                data: Object.assign({}, data),
                error: error
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    async _exchangeCodeForSession(authCode) {
        const storageItem = await (0, $98hXt.getItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
        const [codeVerifier, redirectType] = (storageItem !== null && storageItem !== void 0 ? storageItem : '').split('/');
        try {
            if (!codeVerifier && this.flowType === 'pkce') throw new (0, $fTIQY.AuthPKCECodeVerifierMissingError)();
            const { data: data, error: error } = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/token?grant_type=pkce`, {
                headers: this.headers,
                body: {
                    auth_code: authCode,
                    code_verifier: codeVerifier
                },
                xform: (0, $doWUR._sessionResponse)
            });
            await (0, $98hXt.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
            if (error) throw error;
            if (!data || !data.session || !data.user) {
                const invalidTokenError = new (0, $fTIQY.AuthInvalidTokenResponseError)();
                return this._returnResult({
                    data: {
                        user: null,
                        session: null,
                        redirectType: null
                    },
                    error: invalidTokenError
                });
            }
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers(redirectType === 'recovery' ? 'PASSWORD_RECOVERY' : 'SIGNED_IN', data.session);
            }
            return this._returnResult({
                data: Object.assign(Object.assign({}, data), {
                    redirectType: redirectType !== null && redirectType !== void 0 ? redirectType : null
                }),
                error: error
            });
        } catch (error) {
            await (0, $98hXt.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null,
                    redirectType: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Allows signing in with an OIDC ID token. The authentication provider used
     * should be enabled and configured.
     *
     * @category Auth
     *
     * @remarks
     * - Use an ID token to sign in.
     * - Especially useful when implementing sign in using native platform dialogs in mobile or desktop apps using Sign in with Apple or Sign in with Google on iOS and Android.
     * - You can also use Google's [One Tap](https://developers.google.com/identity/gsi/web/guides/display-google-one-tap) and [Automatic sign-in](https://developers.google.com/identity/gsi/web/guides/automatic-sign-in-sign-out) via this API.
     *
     * @example Sign In using ID Token
     * ```js
     * const { data, error } = await supabase.auth.signInWithIdToken({
     *   provider: 'google',
     *   token: 'your-id-token'
     * })
     * ```
     *
     * @exampleResponse Sign In using ID Token
     * ```json
     * {
     *   "data": {
     *     "user": {
     *       "id": "11111111-1111-1111-1111-111111111111",
     *       "aud": "authenticated",
     *       "role": "authenticated",
     *       "last_sign_in_at": "2024-01-01T00:00:00Z",
     *       "app_metadata": {
     *         ...
     *       },
     *       "user_metadata": {
     *         ...
     *       },
     *       "identities": [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "provider": "google",
     *         }
     *       ],
     *       "created_at": "2024-01-01T00:00:00Z",
     *       "updated_at": "2024-01-01T00:00:00Z",
     *     },
     *     "session": {
     *       "access_token": "<ACCESS_TOKEN>",
     *       "token_type": "bearer",
     *       "expires_in": 3600,
     *       "expires_at": 1700000000,
     *       "refresh_token": "<REFRESH_TOKEN>",
     *       "user": {
     *         "id": "11111111-1111-1111-1111-111111111111",
     *         "aud": "authenticated",
     *         "role": "authenticated",
     *         "last_sign_in_at": "2024-01-01T00:00:00Z",
     *         "app_metadata": {
     *           ...
     *         },
     *         "user_metadata": {
     *           ...
     *         },
     *         "identities": [
     *           {
     *             "identity_id": "22222222-2222-2222-2222-222222222222",
     *             "provider": "google",
     *           }
     *         ],
     *         "created_at": "2024-01-01T00:00:00Z",
     *         "updated_at": "2024-01-01T00:00:00Z",
     *       }
     *     }
     *   },
     *   "error": null
     * }
     * ```
     */ async signInWithIdToken(credentials) {
        try {
            const { options: options, provider: provider, token: token, access_token: access_token, nonce: nonce } = credentials;
            const res = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/token?grant_type=id_token`, {
                headers: this.headers,
                body: {
                    provider: provider,
                    id_token: token,
                    access_token: access_token,
                    nonce: nonce,
                    gotrue_meta_security: {
                        captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                    }
                },
                xform: (0, $doWUR._sessionResponse)
            });
            const { data: data, error: error } = res;
            if (error) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            else if (!data || !data.session || !data.user) {
                const invalidTokenError = new (0, $fTIQY.AuthInvalidTokenResponseError)();
                return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: invalidTokenError
                });
            }
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return this._returnResult({
                data: data,
                error: error
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Log in a user using magiclink or a one-time password (OTP).
     *
     * If the `{{ .ConfirmationURL }}` variable is specified in the email template, a magiclink will be sent.
     * If the `{{ .Token }}` variable is specified in the email template, an OTP will be sent.
     * If you're using phone sign-ins, only an OTP will be sent. You won't be able to send a magiclink for phone sign-ins.
     *
     * Be aware that you may get back an error message that will not distinguish
     * between the cases where the account does not exist or, that the account
     * can only be accessed via social login.
     *
     * Do note that you will need to configure a Whatsapp sender on Twilio
     * if you are using phone sign in with the 'whatsapp' channel. The whatsapp
     * channel is not supported on other providers
     * at this time.
     * This method supports PKCE when an email is passed.
     *
     * @category Auth
     *
     * @remarks
     * - Requires either an email or phone number.
     * - This method is used for passwordless sign-ins where a OTP is sent to the user's email or phone number.
     * - If the user doesn't exist, `signInWithOtp()` will signup the user instead. To restrict this behavior, you can set `shouldCreateUser` in `SignInWithPasswordlessCredentials.options` to `false`.
     * - If you're using an email, you can configure whether you want the user to receive a magiclink or a OTP.
     * - If you're using phone, you can configure whether you want the user to receive a OTP.
     * - The magic link's destination URL is determined by the [`SITE_URL`](/docs/guides/auth/redirect-urls#use-wildcards-in-redirect-urls).
     * - See [redirect URLs and wildcards](/docs/guides/auth/redirect-urls#use-wildcards-in-redirect-urls) to add additional redirect URLs to your project.
     * - Magic links and OTPs share the same implementation. To send users a one-time code instead of a magic link, [modify the magic link email template](/dashboard/project/_/auth/templates) to include `{{ .Token }}` instead of `{{ .ConfirmationURL }}`.
     * - See our [Twilio Phone Auth Guide](/docs/guides/auth/phone-login?showSMSProvider=Twilio) for details about configuring WhatsApp sign in.
     *
     * @exampleDescription Sign in with email
     * The user will be sent an email which contains either a magiclink or a OTP or both. By default, a given user can only request a OTP once every 60 seconds.
     *
     * @example Sign in with email
     * ```js
     * const { data, error } = await supabase.auth.signInWithOtp({
     *   email: 'example@email.com',
     *   options: {
     *     emailRedirectTo: 'https://example.com/welcome'
     *   }
     * })
     * ```
     *
     * @exampleResponse Sign in with email
     * ```json
     * {
     *   "data": {
     *     "user": null,
     *     "session": null
     *   },
     *   "error": null
     * }
     * ```
     *
     * @exampleDescription Sign in with SMS OTP
     * The user will be sent a SMS which contains a OTP. By default, a given user can only request a OTP once every 60 seconds.
     *
     * @example Sign in with SMS OTP
     * ```js
     * const { data, error } = await supabase.auth.signInWithOtp({
     *   phone: '+13334445555',
     * })
     * ```
     *
     * @exampleDescription Sign in with WhatsApp OTP
     * The user will be sent a WhatsApp message which contains a OTP. By default, a given user can only request a OTP once every 60 seconds. Note that a user will need to have a valid WhatsApp account that is linked to Twilio in order to use this feature.
     *
     * @example Sign in with WhatsApp OTP
     * ```js
     * const { data, error } = await supabase.auth.signInWithOtp({
     *   phone: '+13334445555',
     *   options: {
     *     channel:'whatsapp',
     *   }
     * })
     * ```
     */ async signInWithOtp(credentials) {
        var _a, _b, _c, _d, _f;
        try {
            if ('email' in credentials) {
                const { email: email, options: options } = credentials;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, $98hXt.getCodeChallengeAndMethod)(this.storage, this.storageKey);
                const { error: error } = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/otp`, {
                    headers: this.headers,
                    body: {
                        email: email,
                        data: (_a = options === null || options === void 0 ? void 0 : options.data) !== null && _a !== void 0 ? _a : {},
                        create_user: (_b = options === null || options === void 0 ? void 0 : options.shouldCreateUser) !== null && _b !== void 0 ? _b : true,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    },
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo
                });
                return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
            }
            if ('phone' in credentials) {
                const { phone: phone, options: options } = credentials;
                const { data: data, error: error } = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/otp`, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        data: (_c = options === null || options === void 0 ? void 0 : options.data) !== null && _c !== void 0 ? _c : {},
                        create_user: (_d = options === null || options === void 0 ? void 0 : options.shouldCreateUser) !== null && _d !== void 0 ? _d : true,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        channel: (_f = options === null || options === void 0 ? void 0 : options.channel) !== null && _f !== void 0 ? _f : 'sms'
                    }
                });
                return this._returnResult({
                    data: {
                        user: null,
                        session: null,
                        messageId: data === null || data === void 0 ? void 0 : data.message_id
                    },
                    error: error
                });
            }
            throw new (0, $fTIQY.AuthInvalidCredentialsError)('You must provide either an email or phone number.');
        } catch (error) {
            await (0, $98hXt.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Log in a user given a User supplied OTP or TokenHash received through mobile or email.
     *
     * @category Auth
     *
     * @remarks
     * - The `verifyOtp` method takes in different verification types.
     * - If a phone number is used, the type can either be:
     *   1. `sms` – Used when verifying a one-time password (OTP) sent via SMS during sign-up or sign-in.
     *   2. `phone_change` – Used when verifying an OTP sent to a new phone number during a phone number update process.
     * - If an email address is used, the type can be one of the following (note: `signup` and `magiclink` types are deprecated):
     *   1. `email` – Used when verifying an OTP sent to the user's email during sign-up or sign-in.
     *   2. `recovery` – Used when verifying an OTP sent for account recovery, typically after a password reset request.
     *   3. `invite` – Used when verifying an OTP sent as part of an invitation to join a project or organization.
     *   4. `email_change` – Used when verifying an OTP sent to a new email address during an email update process.
     * - The verification type used should be determined based on the corresponding auth method called before `verifyOtp` to sign up / sign-in a user.
     * - The `TokenHash` is contained in the [email templates](/docs/guides/auth/auth-email-templates) and can be used to sign in.  You may wish to use the hash for the PKCE flow for Server Side Auth. Read [the Password-based Auth guide](/docs/guides/auth/passwords) for more details.
     *
     * @example Verify Signup One-Time Password (OTP)
     * ```js
     * const { data, error } = await supabase.auth.verifyOtp({ email, token, type: 'email'})
     * ```
     *
     * @exampleResponse Verify Signup One-Time Password (OTP)
     * ```json
     * {
     *   "data": {
     *     "user": {
     *       "id": "11111111-1111-1111-1111-111111111111",
     *       "aud": "authenticated",
     *       "role": "authenticated",
     *       "email": "example@email.com",
     *       "email_confirmed_at": "2024-01-01T00:00:00Z",
     *       "phone": "",
     *       "confirmed_at": "2024-01-01T00:00:00Z",
     *       "recovery_sent_at": "2024-01-01T00:00:00Z",
     *       "last_sign_in_at": "2024-01-01T00:00:00Z",
     *       "app_metadata": {
     *         "provider": "email",
     *         "providers": [
     *           "email"
     *         ]
     *       },
     *       "user_metadata": {
     *         "email": "example@email.com",
     *         "email_verified": false,
     *         "phone_verified": false,
     *         "sub": "11111111-1111-1111-1111-111111111111"
     *       },
     *       "identities": [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "11111111-1111-1111-1111-111111111111",
     *           "user_id": "11111111-1111-1111-1111-111111111111",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": false,
     *             "phone_verified": false,
     *             "sub": "11111111-1111-1111-1111-111111111111"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "example@email.com"
     *         }
     *       ],
     *       "created_at": "2024-01-01T00:00:00Z",
     *       "updated_at": "2024-01-01T00:00:00Z",
     *       "is_anonymous": false
     *     },
     *     "session": {
     *       "access_token": "<ACCESS_TOKEN>",
     *       "token_type": "bearer",
     *       "expires_in": 3600,
     *       "expires_at": 1700000000,
     *       "refresh_token": "<REFRESH_TOKEN>",
     *       "user": {
     *         "id": "11111111-1111-1111-1111-111111111111",
     *         "aud": "authenticated",
     *         "role": "authenticated",
     *         "email": "example@email.com",
     *         "email_confirmed_at": "2024-01-01T00:00:00Z",
     *         "phone": "",
     *         "confirmed_at": "2024-01-01T00:00:00Z",
     *         "recovery_sent_at": "2024-01-01T00:00:00Z",
     *         "last_sign_in_at": "2024-01-01T00:00:00Z",
     *         "app_metadata": {
     *           "provider": "email",
     *           "providers": [
     *             "email"
     *           ]
     *         },
     *         "user_metadata": {
     *           "email": "example@email.com",
     *           "email_verified": false,
     *           "phone_verified": false,
     *           "sub": "11111111-1111-1111-1111-111111111111"
     *         },
     *         "identities": [
     *           {
     *             "identity_id": "22222222-2222-2222-2222-222222222222",
     *             "id": "11111111-1111-1111-1111-111111111111",
     *             "user_id": "11111111-1111-1111-1111-111111111111",
     *             "identity_data": {
     *               "email": "example@email.com",
     *               "email_verified": false,
     *               "phone_verified": false,
     *               "sub": "11111111-1111-1111-1111-111111111111"
     *             },
     *             "provider": "email",
     *             "last_sign_in_at": "2024-01-01T00:00:00Z",
     *             "created_at": "2024-01-01T00:00:00Z",
     *             "updated_at": "2024-01-01T00:00:00Z",
     *             "email": "example@email.com"
     *           }
     *         ],
     *         "created_at": "2024-01-01T00:00:00Z",
     *         "updated_at": "2024-01-01T00:00:00Z",
     *         "is_anonymous": false
     *       }
     *     }
     *   },
     *   "error": null
     * }
     * ```
     *
     * @example Verify SMS One-Time Password (OTP)
     * ```js
     * const { data, error } = await supabase.auth.verifyOtp({ phone, token, type: 'sms'})
     * ```
     *
     * @example Verify Email Auth (Token Hash)
     * ```js
     * const { data, error } = await supabase.auth.verifyOtp({ token_hash: tokenHash, type: 'email'})
     * ```
     */ async verifyOtp(params) {
        var _a, _b;
        try {
            let redirectTo = undefined;
            let captchaToken = undefined;
            if ('options' in params) {
                redirectTo = (_a = params.options) === null || _a === void 0 ? void 0 : _a.redirectTo;
                captchaToken = (_b = params.options) === null || _b === void 0 ? void 0 : _b.captchaToken;
            }
            const { data: data, error: error } = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/verify`, {
                headers: this.headers,
                body: Object.assign(Object.assign({}, params), {
                    gotrue_meta_security: {
                        captcha_token: captchaToken
                    }
                }),
                redirectTo: redirectTo,
                xform: (0, $doWUR._sessionResponse)
            });
            if (error) throw error;
            if (!data) {
                const tokenVerificationError = new Error('An error occurred on token verification.');
                throw tokenVerificationError;
            }
            const session = data.session;
            const user = data.user;
            if (session === null || session === void 0 ? void 0 : session.access_token) {
                await this._saveSession(session);
                await this._notifyAllSubscribers(params.type == 'recovery' ? 'PASSWORD_RECOVERY' : 'SIGNED_IN', session);
            }
            return this._returnResult({
                data: {
                    user: user,
                    session: session
                },
                error: null
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Attempts a single-sign on using an enterprise Identity Provider. A
     * successful SSO attempt will redirect the current page to the identity
     * provider authorization page. The redirect URL is implementation and SSO
     * protocol specific.
     *
     * You can use it by providing a SSO domain. Typically you can extract this
     * domain by asking users for their email address. If this domain is
     * registered on the Auth instance the redirect will use that organization's
     * currently active SSO Identity Provider for the login.
     *
     * If you have built an organization-specific login page, you can use the
     * organization's SSO Identity Provider UUID directly instead.
     *
     * @category Auth
     *
     * @remarks
     * - Before you can call this method you need to [establish a connection](/docs/guides/auth/sso/auth-sso-saml#managing-saml-20-connections) to an identity provider. Use the [CLI commands](/docs/reference/cli/supabase-sso) to do this.
     * - If you've associated an email domain to the identity provider, you can use the `domain` property to start a sign-in flow.
     * - In case you need to use a different way to start the authentication flow with an identity provider, you can use the `providerId` property. For example:
     *     - Mapping specific user email addresses with an identity provider.
     *     - Using different hints to identity the identity provider to be used by the user, like a company-specific page, IP address or other tracking information.
     *
     * @example Sign in with email domain
     * ```js
     *   // You can extract the user's email domain and use it to trigger the
     *   // authentication flow with the correct identity provider.
     *
     *   const { data, error } = await supabase.auth.signInWithSSO({
     *     domain: 'company.com'
     *   })
     *
     *   if (data?.url) {
     *     // redirect the user to the identity provider's authentication flow
     *     window.location.href = data.url
     *   }
     * ```
     *
     * @example Sign in with provider UUID
     * ```js
     *   // Useful when you need to map a user's sign in request according
     *   // to different rules that can't use email domains.
     *
     *   const { data, error } = await supabase.auth.signInWithSSO({
     *     providerId: '21648a9d-8d5a-4555-a9d1-d6375dc14e92'
     *   })
     *
     *   if (data?.url) {
     *     // redirect the user to the identity provider's authentication flow
     *     window.location.href = data.url
     *   }
     * ```
     */ async signInWithSSO(params) {
        var _a, _b, _c, _d, _f;
        try {
            let codeChallenge = null;
            let codeChallengeMethod = null;
            if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, $98hXt.getCodeChallengeAndMethod)(this.storage, this.storageKey);
            const result = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/sso`, {
                body: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, 'providerId' in params ? {
                    provider_id: params.providerId
                } : null), 'domain' in params ? {
                    domain: params.domain
                } : null), {
                    redirect_to: (_b = (_a = params.options) === null || _a === void 0 ? void 0 : _a.redirectTo) !== null && _b !== void 0 ? _b : undefined
                }), ((_c = params === null || params === void 0 ? void 0 : params.options) === null || _c === void 0 ? void 0 : _c.captchaToken) ? {
                    gotrue_meta_security: {
                        captcha_token: params.options.captchaToken
                    }
                } : null), {
                    skip_http_redirect: true,
                    code_challenge: codeChallenge,
                    code_challenge_method: codeChallengeMethod
                }),
                headers: this.headers,
                xform: (0, $doWUR._ssoResponse)
            });
            // Automatically redirect in browser unless skipBrowserRedirect is true
            if (((_d = result.data) === null || _d === void 0 ? void 0 : _d.url) && (0, $98hXt.isBrowser)() && !((_f = params.options) === null || _f === void 0 ? void 0 : _f.skipBrowserRedirect)) window.location.assign(result.data.url);
            return this._returnResult(result);
        } catch (error) {
            await (0, $98hXt.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Sends a reauthentication OTP to the user's email or phone number.
     * Requires the user to be signed-in.
     *
     * @category Auth
     *
     * @remarks
     * - This method is used together with `updateUser()` when a user's password needs to be updated.
     * - If you require your user to reauthenticate before updating their password, you need to enable the **Secure password change** option in your [project's email provider settings](/dashboard/project/_/auth/providers).
     * - A user is only require to reauthenticate before updating their password if **Secure password change** is enabled and the user **hasn't recently signed in**. A user is deemed recently signed in if the session was created in the last 24 hours.
     * - This method will send a nonce to the user's email. If the user doesn't have a confirmed email address, the method will send the nonce to the user's confirmed phone number instead.
     * - After receiving the OTP, include it as the `nonce` in your `updateUser()` call to finalize the password change.
     *
     * @exampleDescription Send reauthentication nonce
     * Sends a reauthentication nonce to the user's email or phone number.
     *
     * @example Send reauthentication nonce
     * ```js
     * const { error } = await supabase.auth.reauthenticate()
     * ```
     */ async reauthenticate() {
        await this.initializePromise;
        return await this._acquireLock(this.lockAcquireTimeout, async ()=>{
            return await this._reauthenticate();
        });
    }
    async _reauthenticate() {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) throw sessionError;
                if (!session) throw new (0, $fTIQY.AuthSessionMissingError)();
                const { error: error } = await (0, $doWUR._request)(this.fetch, 'GET', `${this.url}/reauthenticate`, {
                    headers: this.headers,
                    jwt: session.access_token
                });
                return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Resends an existing signup confirmation email, email change email, SMS OTP or phone change OTP.
     *
     * @category Auth
     *
     * @remarks
     * - Resends a signup confirmation, email change or phone change email to the user.
     * - Passwordless sign-ins can be resent by calling the `signInWithOtp()` method again.
     * - Password recovery emails can be resent by calling the `resetPasswordForEmail()` method again.
     * - This method will only resend an email or phone OTP to the user if there was an initial signup, email change or phone change request being made(note: For existing users signing in with OTP, you should use `signInWithOtp()` again to resend the OTP).
     * - You can specify a redirect url when you resend an email link using the `emailRedirectTo` option.
     *
     * @exampleDescription Resend an email signup confirmation
     * Resends the email signup confirmation to the user
     *
     * @example Resend an email signup confirmation
     * ```js
     * const { error } = await supabase.auth.resend({
     *   type: 'signup',
     *   email: 'email@example.com',
     *   options: {
     *     emailRedirectTo: 'https://example.com/welcome'
     *   }
     * })
     * ```
     *
     * @exampleDescription Resend a phone signup confirmation
     * Resends the phone signup confirmation email to the user
     *
     * @example Resend a phone signup confirmation
     * ```js
     * const { error } = await supabase.auth.resend({
     *   type: 'sms',
     *   phone: '1234567890'
     * })
     * ```
     *
     * @exampleDescription Resend email change email
     * Resends the email change email to the user
     *
     * @example Resend email change email
     * ```js
     * const { error } = await supabase.auth.resend({
     *   type: 'email_change',
     *   email: 'email@example.com'
     * })
     * ```
     *
     * @exampleDescription Resend phone change OTP
     * Resends the phone change OTP to the user
     *
     * @example Resend phone change OTP
     * ```js
     * const { error } = await supabase.auth.resend({
     *   type: 'phone_change',
     *   phone: '1234567890'
     * })
     * ```
     */ async resend(credentials) {
        try {
            const endpoint = `${this.url}/resend`;
            if ('email' in credentials) {
                const { email: email, type: type, options: options } = credentials;
                const { error: error } = await (0, $doWUR._request)(this.fetch, 'POST', endpoint, {
                    headers: this.headers,
                    body: {
                        email: email,
                        type: type,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo
                });
                return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
            } else if ('phone' in credentials) {
                const { phone: phone, type: type, options: options } = credentials;
                const { data: data, error: error } = await (0, $doWUR._request)(this.fetch, 'POST', endpoint, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        type: type,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    }
                });
                return this._returnResult({
                    data: {
                        user: null,
                        session: null,
                        messageId: data === null || data === void 0 ? void 0 : data.message_id
                    },
                    error: error
                });
            }
            throw new (0, $fTIQY.AuthInvalidCredentialsError)('You must provide either an email or phone number and a type');
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Returns the session, refreshing it if necessary.
     *
     * The session returned can be null if the session is not detected which can happen in the event a user is not signed-in or has logged out.
     *
     * **IMPORTANT:** This method loads values directly from the storage attached
     * to the client. If that storage is based on request cookies for example,
     * the values in it may not be authentic and therefore it's strongly advised
     * against using this method and its results in such circumstances. A warning
     * will be emitted if this is detected. Use {@link #getUser()} instead.
     *
     * @category Auth
     *
     * @remarks
     * - Since the introduction of [asymmetric JWT signing keys](/docs/guides/auth/signing-keys), this method is considered low-level and we encourage you to use `getClaims()` or `getUser()` instead.
     * - Retrieves the current [user session](/docs/guides/auth/sessions) from the storage medium (local storage, cookies).
     * - The session contains an access token (signed JWT), a refresh token and the user object.
     * - If the session's access token is expired or is about to expire, this method will use the refresh token to refresh the session.
     * - When using in a browser, or you've called `startAutoRefresh()` in your environment (React Native, etc.) this function always returns a valid access token without refreshing the session itself, as this is done in the background. This function returns very fast.
     * - **IMPORTANT SECURITY NOTICE:** If using an insecure storage medium, such as cookies or request headers, the user object returned by this function **must not be trusted**. Always verify the JWT using `getClaims()` or your own JWT verification library to securely establish the user's identity and access. You can also use `getUser()` to fetch the user object directly from the Auth server for this purpose.
     * - When using in a browser, this function is synchronized across all tabs using the [LockManager](https://developer.mozilla.org/en-US/docs/Web/API/LockManager) API. In other environments make sure you've defined a proper `lock` property, if necessary, to make sure there are no race conditions while the session is being refreshed.
     *
     * @example Get the session data
     * ```js
     * const { data, error } = await supabase.auth.getSession()
     * ```
     *
     * @exampleResponse Get the session data
     * ```json
     * {
     *   "data": {
     *     "session": {
     *       "access_token": "<ACCESS_TOKEN>",
     *       "token_type": "bearer",
     *       "expires_in": 3600,
     *       "expires_at": 1700000000,
     *       "refresh_token": "<REFRESH_TOKEN>",
     *       "user": {
     *         "id": "11111111-1111-1111-1111-111111111111",
     *         "aud": "authenticated",
     *         "role": "authenticated",
     *         "email": "example@email.com",
     *         "email_confirmed_at": "2024-01-01T00:00:00Z",
     *         "phone": "",
     *         "last_sign_in_at": "2024-01-01T00:00:00Z",
     *         "app_metadata": {
     *           "provider": "email",
     *           "providers": [
     *             "email"
     *           ]
     *         },
     *         "user_metadata": {
     *           "email": "example@email.com",
     *           "email_verified": false,
     *           "phone_verified": false,
     *           "sub": "11111111-1111-1111-1111-111111111111"
     *         },
     *         "identities": [
     *           {
     *             "identity_id": "22222222-2222-2222-2222-222222222222",
     *             "id": "11111111-1111-1111-1111-111111111111",
     *             "user_id": "11111111-1111-1111-1111-111111111111",
     *             "identity_data": {
     *               "email": "example@email.com",
     *               "email_verified": false,
     *               "phone_verified": false,
     *               "sub": "11111111-1111-1111-1111-111111111111"
     *             },
     *             "provider": "email",
     *             "last_sign_in_at": "2024-01-01T00:00:00Z",
     *             "created_at": "2024-01-01T00:00:00Z",
     *             "updated_at": "2024-01-01T00:00:00Z",
     *             "email": "example@email.com"
     *           }
     *         ],
     *         "created_at": "2024-01-01T00:00:00Z",
     *         "updated_at": "2024-01-01T00:00:00Z",
     *         "is_anonymous": false
     *       }
     *     }
     *   },
     *   "error": null
     * }
     * ```
     */ async getSession() {
        await this.initializePromise;
        const result = await this._acquireLock(this.lockAcquireTimeout, async ()=>{
            return this._useSession(async (result)=>{
                return result;
            });
        });
        return result;
    }
    /**
     * Acquires a global lock based on the storage key.
     */ async _acquireLock(acquireTimeout, fn) {
        this._debug('#_acquireLock', 'begin', acquireTimeout);
        try {
            if (this.lockAcquired) {
                const last = this.pendingInLock.length ? this.pendingInLock[this.pendingInLock.length - 1] : Promise.resolve();
                const result = (async ()=>{
                    await last;
                    return await fn();
                })();
                this.pendingInLock.push((async ()=>{
                    try {
                        await result;
                    } catch (_e) {
                    // we just care if it finished
                    }
                })());
                return result;
            }
            return await this.lock(`lock:${this.storageKey}`, acquireTimeout, async ()=>{
                this._debug('#_acquireLock', 'lock acquired for storage key', this.storageKey);
                try {
                    this.lockAcquired = true;
                    const result = fn();
                    this.pendingInLock.push((async ()=>{
                        try {
                            await result;
                        } catch (e) {
                        // we just care if it finished
                        }
                    })());
                    await result;
                    // keep draining the queue until there's nothing to wait on
                    while(this.pendingInLock.length){
                        const waitOn = [
                            ...this.pendingInLock
                        ];
                        await Promise.all(waitOn);
                        this.pendingInLock.splice(0, waitOn.length);
                    }
                    return await result;
                } finally{
                    this._debug('#_acquireLock', 'lock released for storage key', this.storageKey);
                    this.lockAcquired = false;
                }
            });
        } finally{
            this._debug('#_acquireLock', 'end');
        }
    }
    /**
     * Use instead of {@link #getSession} inside the library. It is
     * semantically usually what you want, as getting a session involves some
     * processing afterwards that requires only one client operating on the
     * session at once across multiple tabs or processes.
     */ async _useSession(fn) {
        this._debug('#_useSession', 'begin');
        try {
            // the use of __loadSession here is the only correct use of the function!
            const result = await this.__loadSession();
            return await fn(result);
        } finally{
            this._debug('#_useSession', 'end');
        }
    }
    /**
     * NEVER USE DIRECTLY!
     *
     * Always use {@link #_useSession}.
     */ async __loadSession() {
        this._debug('#__loadSession()', 'begin');
        if (!this.lockAcquired) this._debug('#__loadSession()', 'used outside of an acquired lock!', new Error().stack);
        try {
            let currentSession = null;
            const maybeSession = await (0, $98hXt.getItemAsync)(this.storage, this.storageKey);
            this._debug('#getSession()', 'session from storage', maybeSession);
            if (maybeSession !== null) {
                if (this._isValidSession(maybeSession)) currentSession = maybeSession;
                else {
                    this._debug('#getSession()', 'session from storage is not valid');
                    await this._removeSession();
                }
            }
            if (!currentSession) return {
                data: {
                    session: null
                },
                error: null
            };
            // A session is considered expired before the access token _actually_
            // expires. When the autoRefreshToken option is off (or when the tab is
            // in the background), very eager users of getSession() -- like
            // realtime-js -- might send a valid JWT which will expire by the time it
            // reaches the server.
            const hasExpired = currentSession.expires_at ? currentSession.expires_at * 1000 - Date.now() < (0, $44TzP.EXPIRY_MARGIN_MS) : false;
            this._debug('#__loadSession()', `session has${hasExpired ? '' : ' not'} expired`, 'expires_at', currentSession.expires_at);
            if (!hasExpired) {
                if (this.userStorage) {
                    const maybeUser = await (0, $98hXt.getItemAsync)(this.userStorage, this.storageKey + '-user');
                    if (maybeUser === null || maybeUser === void 0 ? void 0 : maybeUser.user) currentSession.user = maybeUser.user;
                    else currentSession.user = (0, $98hXt.userNotAvailableProxy)();
                }
                // Wrap the user object with a warning proxy on the server
                // This warns when properties of the user are accessed, not when session.user itself is accessed
                if (this.storage.isServer && currentSession.user && !currentSession.user.__isUserNotAvailableProxy) {
                    const suppressWarningRef = {
                        value: this.suppressGetSessionWarning
                    };
                    currentSession.user = (0, $98hXt.insecureUserWarningProxy)(currentSession.user, suppressWarningRef);
                    // Update the client-level suppression flag when the proxy suppresses the warning
                    if (suppressWarningRef.value) this.suppressGetSessionWarning = true;
                }
                return {
                    data: {
                        session: currentSession
                    },
                    error: null
                };
            }
            const { data: session, error: error } = await this._callRefreshToken(currentSession.refresh_token);
            if (error) return this._returnResult({
                data: {
                    session: null
                },
                error: error
            });
            return this._returnResult({
                data: {
                    session: session
                },
                error: null
            });
        } finally{
            this._debug('#__loadSession()', 'end');
        }
    }
    /**
     * Gets the current user details if there is an existing session. This method
     * performs a network request to the Supabase Auth server, so the returned
     * value is authentic and can be used to base authorization rules on.
     *
     * @param jwt Takes in an optional access token JWT. If no JWT is provided, the JWT from the current session is used.
     *
     * @category Auth
     *
     * @remarks
     * - This method fetches the user object from the database instead of local session.
     * - This method is useful for checking if the user is authorized because it validates the user's access token JWT on the server.
     * - Should always be used when checking for user authorization on the server. On the client, you can instead use `getSession().session.user` for faster results. `getSession` is insecure on the server.
     *
     * @example Get the logged in user with the current existing session
     * ```js
     * const { data: { user } } = await supabase.auth.getUser()
     * ```
     *
     * @exampleResponse Get the logged in user with the current existing session
     * ```json
     * {
     *   "data": {
     *     "user": {
     *       "id": "11111111-1111-1111-1111-111111111111",
     *       "aud": "authenticated",
     *       "role": "authenticated",
     *       "email": "example@email.com",
     *       "email_confirmed_at": "2024-01-01T00:00:00Z",
     *       "phone": "",
     *       "confirmed_at": "2024-01-01T00:00:00Z",
     *       "last_sign_in_at": "2024-01-01T00:00:00Z",
     *       "app_metadata": {
     *         "provider": "email",
     *         "providers": [
     *           "email"
     *         ]
     *       },
     *       "user_metadata": {
     *         "email": "example@email.com",
     *         "email_verified": false,
     *         "phone_verified": false,
     *         "sub": "11111111-1111-1111-1111-111111111111"
     *       },
     *       "identities": [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "11111111-1111-1111-1111-111111111111",
     *           "user_id": "11111111-1111-1111-1111-111111111111",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": false,
     *             "phone_verified": false,
     *             "sub": "11111111-1111-1111-1111-111111111111"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "example@email.com"
     *         }
     *       ],
     *       "created_at": "2024-01-01T00:00:00Z",
     *       "updated_at": "2024-01-01T00:00:00Z",
     *       "is_anonymous": false
     *     }
     *   },
     *   "error": null
     * }
     * ```
     *
     * @example Get the logged in user with a custom access token jwt
     * ```js
     * const { data: { user } } = await supabase.auth.getUser(jwt)
     * ```
     */ async getUser(jwt) {
        if (jwt) return await this._getUser(jwt);
        await this.initializePromise;
        const result = await this._acquireLock(this.lockAcquireTimeout, async ()=>{
            return await this._getUser();
        });
        if (result.data.user) this.suppressGetSessionWarning = true;
        return result;
    }
    async _getUser(jwt) {
        try {
            if (jwt) return await (0, $doWUR._request)(this.fetch, 'GET', `${this.url}/user`, {
                headers: this.headers,
                jwt: jwt,
                xform: (0, $doWUR._userResponse)
            });
            return await this._useSession(async (result)=>{
                var _a, _b, _c;
                const { data: data, error: error } = result;
                if (error) throw error;
                // returns an error if there is no access_token or custom authorization header
                if (!((_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token) && !this.hasCustomAuthorizationHeader) return {
                    data: {
                        user: null
                    },
                    error: new (0, $fTIQY.AuthSessionMissingError)()
                };
                return await (0, $doWUR._request)(this.fetch, 'GET', `${this.url}/user`, {
                    headers: this.headers,
                    jwt: (_c = (_b = data.session) === null || _b === void 0 ? void 0 : _b.access_token) !== null && _c !== void 0 ? _c : undefined,
                    xform: (0, $doWUR._userResponse)
                });
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) {
                if ((0, $fTIQY.isAuthSessionMissingError)(error)) {
                    // JWT contains a `session_id` which does not correspond to an active
                    // session in the database, indicating the user is signed out.
                    await this._removeSession();
                    await (0, $98hXt.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
                }
                return this._returnResult({
                    data: {
                        user: null
                    },
                    error: error
                });
            }
            throw error;
        }
    }
    /**
     * Updates user data for a logged in user.
     *
     * @category Auth
     *
     * @remarks
     * - In order to use the `updateUser()` method, the user needs to be signed in first.
     * - By default, email updates sends a confirmation link to both the user's current and new email.
     * To only send a confirmation link to the user's new email, disable **Secure email change** in your project's [email auth provider settings](/dashboard/project/_/auth/providers).
     *
     * @exampleDescription Update the email for an authenticated user
     * Sends a "Confirm Email Change" email to the new address. If **Secure Email Change** is enabled (default), confirmation is also required from the **old email** before the change is applied. To skip dual confirmation and apply the change after only the new email is verified, disable **Secure Email Change** in the [Email Auth Provider settings](/dashboard/project/_/auth/providers?provider=Email).
     *
     * @example Update the email for an authenticated user
     * ```js
     * const { data, error } = await supabase.auth.updateUser({
     *   email: 'new@email.com'
     * })
     * ```
     *
     * @exampleResponse Update the email for an authenticated user
     * ```json
     * {
     *   "data": {
     *     "user": {
     *       "id": "11111111-1111-1111-1111-111111111111",
     *       "aud": "authenticated",
     *       "role": "authenticated",
     *       "email": "example@email.com",
     *       "email_confirmed_at": "2024-01-01T00:00:00Z",
     *       "phone": "",
     *       "confirmed_at": "2024-01-01T00:00:00Z",
     *       "new_email": "new@email.com",
     *       "email_change_sent_at": "2024-01-01T00:00:00Z",
     *       "last_sign_in_at": "2024-01-01T00:00:00Z",
     *       "app_metadata": {
     *         "provider": "email",
     *         "providers": [
     *           "email"
     *         ]
     *       },
     *       "user_metadata": {
     *         "email": "example@email.com",
     *         "email_verified": false,
     *         "phone_verified": false,
     *         "sub": "11111111-1111-1111-1111-111111111111"
     *       },
     *       "identities": [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "11111111-1111-1111-1111-111111111111",
     *           "user_id": "11111111-1111-1111-1111-111111111111",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": false,
     *             "phone_verified": false,
     *             "sub": "11111111-1111-1111-1111-111111111111"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "example@email.com"
     *         }
     *       ],
     *       "created_at": "2024-01-01T00:00:00Z",
     *       "updated_at": "2024-01-01T00:00:00Z",
     *       "is_anonymous": false
     *     }
     *   },
     *   "error": null
     * }
     * ```
     *
     * @exampleDescription Update the phone number for an authenticated user
     * Sends a one-time password (OTP) to the new phone number.
     *
     * @example Update the phone number for an authenticated user
     * ```js
     * const { data, error } = await supabase.auth.updateUser({
     *   phone: '123456789'
     * })
     * ```
     *
     * @example Update the password for an authenticated user
     * ```js
     * const { data, error } = await supabase.auth.updateUser({
     *   password: 'new password'
     * })
     * ```
     *
     * @exampleDescription Update the user's metadata
     * Updates the user's custom metadata.
     *
     * **Note**: The `data` field maps to the `auth.users.raw_user_meta_data` column in your Supabase database. When calling `getUser()`, the data will be available as `user.user_metadata`.
     *
     * @example Update the user's metadata
     * ```js
     * const { data, error } = await supabase.auth.updateUser({
     *   data: { hello: 'world' }
     * })
     * ```
     *
     * @exampleDescription Update the user's password with a nonce
     * If **Secure password change** is enabled in your [project's email provider settings](/dashboard/project/_/auth/providers), updating the user's password would require a nonce if the user **hasn't recently signed in**. The nonce is sent to the user's email or phone number. A user is deemed recently signed in if the session was created in the last 24 hours.
     *
     * @example Update the user's password with a nonce
     * ```js
     * const { data, error } = await supabase.auth.updateUser({
     *   password: 'new password',
     *   nonce: '123456'
     * })
     * ```
     */ async updateUser(attributes, options = {}) {
        await this.initializePromise;
        return await this._acquireLock(this.lockAcquireTimeout, async ()=>{
            return await this._updateUser(attributes, options);
        });
    }
    async _updateUser(attributes, options = {}) {
        try {
            return await this._useSession(async (result)=>{
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) throw sessionError;
                if (!sessionData.session) throw new (0, $fTIQY.AuthSessionMissingError)();
                const session = sessionData.session;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === 'pkce' && attributes.email != null) [codeChallenge, codeChallengeMethod] = await (0, $98hXt.getCodeChallengeAndMethod)(this.storage, this.storageKey);
                const { data: data, error: userError } = await (0, $doWUR._request)(this.fetch, 'PUT', `${this.url}/user`, {
                    headers: this.headers,
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo,
                    body: Object.assign(Object.assign({}, attributes), {
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    }),
                    jwt: session.access_token,
                    xform: (0, $doWUR._userResponse)
                });
                if (userError) throw userError;
                session.user = data.user;
                await this._saveSession(session);
                await this._notifyAllSubscribers('USER_UPDATED', session);
                return this._returnResult({
                    data: {
                        user: session.user
                    },
                    error: null
                });
            });
        } catch (error) {
            await (0, $98hXt.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Sets the session data from the current session. If the current session is expired, setSession will take care of refreshing it to obtain a new session.
     * If the refresh token or access token in the current session is invalid, an error will be thrown.
     * @param currentSession The current session that minimally contains an access token and refresh token.
     *
     * @category Auth
     *
     * @remarks
     * - This method sets the session using an `access_token` and `refresh_token`.
     * - If successful, a `SIGNED_IN` event is emitted.
     *
     * @exampleDescription Set the session
     * Sets the session data from an access_token and refresh_token, then returns an auth response or error.
     *
     * @example Set the session
     * ```js
     *   const { data, error } = await supabase.auth.setSession({
     *     access_token,
     *     refresh_token
     *   })
     * ```
     *
     * @exampleResponse Set the session
     * ```json
     * {
     *   "data": {
     *     "user": {
     *       "id": "11111111-1111-1111-1111-111111111111",
     *       "aud": "authenticated",
     *       "role": "authenticated",
     *       "email": "example@email.com",
     *       "email_confirmed_at": "2024-01-01T00:00:00Z",
     *       "phone": "",
     *       "confirmed_at": "2024-01-01T00:00:00Z",
     *       "last_sign_in_at": "2024-01-01T00:00:00Z",
     *       "app_metadata": {
     *         "provider": "email",
     *         "providers": [
     *           "email"
     *         ]
     *       },
     *       "user_metadata": {
     *         "email": "example@email.com",
     *         "email_verified": false,
     *         "phone_verified": false,
     *         "sub": "11111111-1111-1111-1111-111111111111"
     *       },
     *       "identities": [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "11111111-1111-1111-1111-111111111111",
     *           "user_id": "11111111-1111-1111-1111-111111111111",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": false,
     *             "phone_verified": false,
     *             "sub": "11111111-1111-1111-1111-111111111111"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "example@email.com"
     *         }
     *       ],
     *       "created_at": "2024-01-01T00:00:00Z",
     *       "updated_at": "2024-01-01T00:00:00Z",
     *       "is_anonymous": false
     *     },
     *     "session": {
     *       "access_token": "<ACCESS_TOKEN>",
     *       "refresh_token": "<REFRESH_TOKEN>",
     *       "user": {
     *         "id": "11111111-1111-1111-1111-111111111111",
     *         "aud": "authenticated",
     *         "role": "authenticated",
     *         "email": "example@email.com",
     *         "email_confirmed_at": "2024-01-01T00:00:00Z",
     *         "phone": "",
     *         "confirmed_at": "2024-01-01T00:00:00Z",
     *         "last_sign_in_at": "11111111-1111-1111-1111-111111111111",
     *         "app_metadata": {
     *           "provider": "email",
     *           "providers": [
     *             "email"
     *           ]
     *         },
     *         "user_metadata": {
     *           "email": "example@email.com",
     *           "email_verified": false,
     *           "phone_verified": false,
     *           "sub": "11111111-1111-1111-1111-111111111111"
     *         },
     *         "identities": [
     *           {
     *             "identity_id": "2024-01-01T00:00:00Z",
     *             "id": "11111111-1111-1111-1111-111111111111",
     *             "user_id": "11111111-1111-1111-1111-111111111111",
     *             "identity_data": {
     *               "email": "example@email.com",
     *               "email_verified": false,
     *               "phone_verified": false,
     *               "sub": "11111111-1111-1111-1111-111111111111"
     *             },
     *             "provider": "email",
     *             "last_sign_in_at": "2024-01-01T00:00:00Z",
     *             "created_at": "2024-01-01T00:00:00Z",
     *             "updated_at": "2024-01-01T00:00:00Z",
     *             "email": "example@email.com"
     *           }
     *         ],
     *         "created_at": "2024-01-01T00:00:00Z",
     *         "updated_at": "2024-01-01T00:00:00Z",
     *         "is_anonymous": false
     *       },
     *       "token_type": "bearer",
     *       "expires_in": 3500,
     *       "expires_at": 1700000000
     *     }
     *   },
     *   "error": null
     * }
     * ```
     */ async setSession(currentSession) {
        await this.initializePromise;
        return await this._acquireLock(this.lockAcquireTimeout, async ()=>{
            return await this._setSession(currentSession);
        });
    }
    async _setSession(currentSession) {
        try {
            if (!currentSession.access_token || !currentSession.refresh_token) throw new (0, $fTIQY.AuthSessionMissingError)();
            const timeNow = Date.now() / 1000;
            let expiresAt = timeNow;
            let hasExpired = true;
            let session = null;
            const { payload: payload } = (0, $98hXt.decodeJWT)(currentSession.access_token);
            if (payload.exp) {
                expiresAt = payload.exp;
                hasExpired = expiresAt <= timeNow;
            }
            if (hasExpired) {
                const { data: refreshedSession, error: error } = await this._callRefreshToken(currentSession.refresh_token);
                if (error) return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
                if (!refreshedSession) return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: null
                };
                session = refreshedSession;
            } else {
                const { data: data, error: error } = await this._getUser(currentSession.access_token);
                if (error) return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
                session = {
                    access_token: currentSession.access_token,
                    refresh_token: currentSession.refresh_token,
                    user: data.user,
                    token_type: 'bearer',
                    expires_in: expiresAt - timeNow,
                    expires_at: expiresAt
                };
                await this._saveSession(session);
                await this._notifyAllSubscribers('SIGNED_IN', session);
            }
            return this._returnResult({
                data: {
                    user: session.user,
                    session: session
                },
                error: null
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    session: null,
                    user: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Returns a new session, regardless of expiry status.
     * Takes in an optional current session. If not passed in, then refreshSession() will attempt to retrieve it from getSession().
     * If the current session's refresh token is invalid, an error will be thrown.
     * @param currentSession The current session. If passed in, it must contain a refresh token.
     *
     * @category Auth
     *
     * @remarks
     * - This method will refresh and return a new session whether the current one is expired or not.
     *
     * @example Refresh session using the current session
     * ```js
     * const { data, error } = await supabase.auth.refreshSession()
     * const { session, user } = data
     * ```
     *
     * @exampleResponse Refresh session using the current session
     * ```json
     * {
     *   "data": {
     *     "user": {
     *       "id": "11111111-1111-1111-1111-111111111111",
     *       "aud": "authenticated",
     *       "role": "authenticated",
     *       "email": "example@email.com",
     *       "email_confirmed_at": "2024-01-01T00:00:00Z",
     *       "phone": "",
     *       "confirmed_at": "2024-01-01T00:00:00Z",
     *       "last_sign_in_at": "2024-01-01T00:00:00Z",
     *       "app_metadata": {
     *         "provider": "email",
     *         "providers": [
     *           "email"
     *         ]
     *       },
     *       "user_metadata": {
     *         "email": "example@email.com",
     *         "email_verified": false,
     *         "phone_verified": false,
     *         "sub": "11111111-1111-1111-1111-111111111111"
     *       },
     *       "identities": [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "11111111-1111-1111-1111-111111111111",
     *           "user_id": "11111111-1111-1111-1111-111111111111",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": false,
     *             "phone_verified": false,
     *             "sub": "11111111-1111-1111-1111-111111111111"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "example@email.com"
     *         }
     *       ],
     *       "created_at": "2024-01-01T00:00:00Z",
     *       "updated_at": "2024-01-01T00:00:00Z",
     *       "is_anonymous": false
     *     },
     *     "session": {
     *       "access_token": "<ACCESS_TOKEN>",
     *       "token_type": "bearer",
     *       "expires_in": 3600,
     *       "expires_at": 1700000000,
     *       "refresh_token": "<REFRESH_TOKEN>",
     *       "user": {
     *         "id": "11111111-1111-1111-1111-111111111111",
     *         "aud": "authenticated",
     *         "role": "authenticated",
     *         "email": "example@email.com",
     *         "email_confirmed_at": "2024-01-01T00:00:00Z",
     *         "phone": "",
     *         "confirmed_at": "2024-01-01T00:00:00Z",
     *         "last_sign_in_at": "2024-01-01T00:00:00Z",
     *         "app_metadata": {
     *           "provider": "email",
     *           "providers": [
     *             "email"
     *           ]
     *         },
     *         "user_metadata": {
     *           "email": "example@email.com",
     *           "email_verified": false,
     *           "phone_verified": false,
     *           "sub": "11111111-1111-1111-1111-111111111111"
     *         },
     *         "identities": [
     *           {
     *             "identity_id": "22222222-2222-2222-2222-222222222222",
     *             "id": "11111111-1111-1111-1111-111111111111",
     *             "user_id": "11111111-1111-1111-1111-111111111111",
     *             "identity_data": {
     *               "email": "example@email.com",
     *               "email_verified": false,
     *               "phone_verified": false,
     *               "sub": "11111111-1111-1111-1111-111111111111"
     *             },
     *             "provider": "email",
     *             "last_sign_in_at": "2024-01-01T00:00:00Z",
     *             "created_at": "2024-01-01T00:00:00Z",
     *             "updated_at": "2024-01-01T00:00:00Z",
     *             "email": "example@email.com"
     *           }
     *         ],
     *         "created_at": "2024-01-01T00:00:00Z",
     *         "updated_at": "2024-01-01T00:00:00Z",
     *         "is_anonymous": false
     *       }
     *     }
     *   },
     *   "error": null
     * }
     * ```
     *
     * @example Refresh session using a refresh token
     * ```js
     * const { data, error } = await supabase.auth.refreshSession({ refresh_token })
     * const { session, user } = data
     * ```
     */ async refreshSession(currentSession) {
        await this.initializePromise;
        return await this._acquireLock(this.lockAcquireTimeout, async ()=>{
            return await this._refreshSession(currentSession);
        });
    }
    async _refreshSession(currentSession) {
        try {
            return await this._useSession(async (result)=>{
                var _a;
                if (!currentSession) {
                    const { data: data, error: error } = result;
                    if (error) throw error;
                    currentSession = (_a = data.session) !== null && _a !== void 0 ? _a : undefined;
                }
                if (!(currentSession === null || currentSession === void 0 ? void 0 : currentSession.refresh_token)) throw new (0, $fTIQY.AuthSessionMissingError)();
                const { data: session, error: error } = await this._callRefreshToken(currentSession.refresh_token);
                if (error) return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
                if (!session) return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: null
                });
                return this._returnResult({
                    data: {
                        user: session.user,
                        session: session
                    },
                    error: null
                });
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Gets the session data from a URL string
     */ async _getSessionFromURL(params, callbackUrlType) {
        var _a;
        try {
            if (!(0, $98hXt.isBrowser)()) throw new (0, $fTIQY.AuthImplicitGrantRedirectError)('No browser detected.');
            // If there's an error in the URL, it doesn't matter what flow it is, we just return the error.
            if (params.error || params.error_description || params.error_code) // The error class returned implies that the redirect is from an implicit grant flow
            // but it could also be from a redirect error from a PKCE flow.
            throw new (0, $fTIQY.AuthImplicitGrantRedirectError)(params.error_description || 'Error in URL with unspecified error_description', {
                error: params.error || 'unspecified_error',
                code: params.error_code || 'unspecified_code'
            });
            // Checks for mismatches between the flowType initialised in the client and the URL parameters
            switch(callbackUrlType){
                case 'implicit':
                    if (this.flowType === 'pkce') throw new (0, $fTIQY.AuthPKCEGrantCodeExchangeError)('Not a valid PKCE flow url.');
                    break;
                case 'pkce':
                    if (this.flowType === 'implicit') throw new (0, $fTIQY.AuthImplicitGrantRedirectError)('Not a valid implicit grant flow url.');
                    break;
                default:
            }
            // Since this is a redirect for PKCE, we attempt to retrieve the code from the URL for the code exchange
            if (callbackUrlType === 'pkce') {
                this._debug('#_initialize()', 'begin', 'is PKCE flow', true);
                if (!params.code) throw new (0, $fTIQY.AuthPKCEGrantCodeExchangeError)('No code detected.');
                const { data: data, error: error } = await this._exchangeCodeForSession(params.code);
                if (error) throw error;
                const url = new URL(window.location.href);
                url.searchParams.delete('code');
                window.history.replaceState(window.history.state, '', url.toString());
                return {
                    data: {
                        session: data.session,
                        redirectType: (_a = data.redirectType) !== null && _a !== void 0 ? _a : null
                    },
                    error: null
                };
            }
            const { provider_token: provider_token, provider_refresh_token: provider_refresh_token, access_token: access_token, refresh_token: refresh_token, expires_in: expires_in, expires_at: expires_at, token_type: token_type } = params;
            if (!access_token || !expires_in || !refresh_token || !token_type) throw new (0, $fTIQY.AuthImplicitGrantRedirectError)('No session defined in URL');
            const timeNow = Math.round(Date.now() / 1000);
            const expiresIn = parseInt(expires_in);
            let expiresAt = timeNow + expiresIn;
            if (expires_at) expiresAt = parseInt(expires_at);
            const actuallyExpiresIn = expiresAt - timeNow;
            if (actuallyExpiresIn * 1000 <= (0, $44TzP.AUTO_REFRESH_TICK_DURATION_MS)) console.warn(`@supabase/gotrue-js: Session as retrieved from URL expires in ${actuallyExpiresIn}s, should have been closer to ${expiresIn}s`);
            const issuedAt = expiresAt - expiresIn;
            if (timeNow - issuedAt >= 120) console.warn('@supabase/gotrue-js: Session as retrieved from URL was issued over 120s ago, URL could be stale', issuedAt, expiresAt, timeNow);
            else if (timeNow - issuedAt < 0) console.warn('@supabase/gotrue-js: Session as retrieved from URL was issued in the future? Check the device clock for skew', issuedAt, expiresAt, timeNow);
            const { data: data, error: error } = await this._getUser(access_token);
            if (error) throw error;
            const session = {
                provider_token: provider_token,
                provider_refresh_token: provider_refresh_token,
                access_token: access_token,
                expires_in: expiresIn,
                expires_at: expiresAt,
                refresh_token: refresh_token,
                token_type: token_type,
                user: data.user
            };
            // Remove tokens from URL
            window.location.hash = '';
            this._debug('#_getSessionFromURL()', 'clearing window.location.hash');
            return this._returnResult({
                data: {
                    session: session,
                    redirectType: params.type
                },
                error: null
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    session: null,
                    redirectType: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Checks if the current URL contains parameters given by an implicit oauth grant flow (https://www.rfc-editor.org/rfc/rfc6749.html#section-4.2)
     *
     * If `detectSessionInUrl` is a function, it will be called with the URL and params to determine
     * if the URL should be processed as a Supabase auth callback. This allows users to exclude
     * URLs from other OAuth providers (e.g., Facebook Login) that also return access_token in the fragment.
     */ _isImplicitGrantCallback(params) {
        if (typeof this.detectSessionInUrl === 'function') return this.detectSessionInUrl(new URL(window.location.href), params);
        return Boolean(params.access_token || params.error_description);
    }
    /**
     * Checks if the current URL and backing storage contain parameters given by a PKCE flow
     */ async _isPKCECallback(params) {
        const currentStorageContent = await (0, $98hXt.getItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
        return !!(params.code && currentStorageContent);
    }
    /**
     * Inside a browser context, `signOut()` will remove the logged in user from the browser session and log them out - removing all items from localstorage and then trigger a `"SIGNED_OUT"` event.
     *
     * For server-side management, you can revoke all refresh tokens for a user by passing a user's JWT through to `auth.api.signOut(JWT: string)`.
     * There is no way to revoke a user's access token jwt until it expires. It is recommended to set a shorter expiry on the jwt for this reason.
     *
     * If using `others` scope, no `SIGNED_OUT` event is fired!
     *
     * **Warning:** the default `scope` is `'global'`. This signs the user out of
     * **every device they are currently signed in on**, not just the current
     * tab/session. If you only want to sign the user out of the current session
     * (the behavior most other auth libraries default to), pass
     * `{ scope: 'local' }` explicitly.
     *
     * @category Auth
     *
     * @remarks
     * - In order to use the `signOut()` method, the user needs to be signed in first.
     * - By default, `signOut()` uses the **global** scope, which signs out the user
     *   on every device they are signed in on (not just the current one). Pass
     *   `{ scope: 'local' }` to only sign out the current session. This is
     *   usually what apps want on a "Sign out" button, especially when users
     *   sign in from multiple devices and do not expect signing out of one to
     *   terminate the others.
     * - Since Supabase Auth uses JWTs for authentication, the access token JWT will be valid until it's expired. When the user signs out, Supabase revokes the refresh token and deletes the JWT from the client-side. This does not revoke the JWT and it will still be valid until it expires.
     *
     * @example Sign out of every device (global – default)
     * ```js
     * const { error } = await supabase.auth.signOut()
     * ```
     *
     * @example Sign out only the current session (recommended for most apps)
     * ```js
     * const { error } = await supabase.auth.signOut({ scope: 'local' })
     * ```
     *
     * @example Sign out of all other sessions, keep the current one
     * ```js
     * const { error } = await supabase.auth.signOut({ scope: 'others' })
     * ```
     */ async signOut(options = {
        scope: 'global'
    }) {
        await this.initializePromise;
        return await this._acquireLock(this.lockAcquireTimeout, async ()=>{
            return await this._signOut(options);
        });
    }
    async _signOut({ scope: scope } = {
        scope: 'global'
    }) {
        return await this._useSession(async (result)=>{
            var _a;
            const { data: data, error: sessionError } = result;
            if (sessionError && !(0, $fTIQY.isAuthSessionMissingError)(sessionError)) return this._returnResult({
                error: sessionError
            });
            const accessToken = (_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token;
            if (accessToken) {
                const { error: error } = await this.admin.signOut(accessToken, scope);
                if (error) {
                    // ignore 404s since user might not exist anymore
                    // ignore 401s since an invalid or expired JWT should sign out the current session
                    if (!((0, $fTIQY.isAuthApiError)(error) && (error.status === 404 || error.status === 401 || error.status === 403) || (0, $fTIQY.isAuthSessionMissingError)(error))) return this._returnResult({
                        error: error
                    });
                }
            }
            if (scope !== 'others') {
                await this._removeSession();
                await (0, $98hXt.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
            }
            return this._returnResult({
                error: null
            });
        });
    }
    /**  *
     * @category Auth
     *
     * @remarks
     * - Subscribes to important events occurring on the user's session.
     * - Use on the frontend/client. It is less useful on the server.
     * - Events are emitted across tabs to keep your application's UI up-to-date. Some events can fire very frequently, based on the number of tabs open. Use a quick and efficient callback function, and defer or debounce as many operations as you can to be performed outside of the callback.
     * - **Important:** A callback can be an `async` function and it runs synchronously during the processing of the changes causing the event. You can easily create a dead-lock by using `await` on a call to another method of the Supabase library.
     *   - Avoid using `async` functions as callbacks.
     *   - Limit the number of `await` calls in `async` callbacks.
     *   - Do not use other Supabase functions in the callback function. If you must, dispatch the functions once the callback has finished executing. Use this as a quick way to achieve this:
     *     ```js
     *     supabase.auth.onAuthStateChange((event, session) => {
     *       setTimeout(async () => {
     *         // await on other Supabase function here
     *         // this runs right after the callback has finished
     *       }, 0)
     *     })
     *     ```
     * - Emitted events:
     *   - `INITIAL_SESSION`
     *     - Emitted right after the Supabase client is constructed and the initial session from storage is loaded.
     *   - `SIGNED_IN`
     *     - Emitted each time a user session is confirmed or re-established, including on user sign in and when refocusing a tab.
     *     - Avoid making assumptions as to when this event is fired, this may occur even when the user is already signed in. Instead, check the user object attached to the event to see if a new user has signed in and update your application's UI.
     *     - This event can fire very frequently depending on the number of tabs open in your application.
     *   - `SIGNED_OUT`
     *     - Emitted when the user signs out. This can be after:
     *       - A call to `supabase.auth.signOut()`.
     *       - After the user's session has expired for any reason:
     *         - User has signed out on another device.
     *         - The session has reached its timebox limit or inactivity timeout.
     *         - User has signed in on another device with single session per user enabled.
     *         - Check the [User Sessions](/docs/guides/auth/sessions) docs for more information.
     *     - Use this to clean up any local storage your application has associated with the user.
     *   - `TOKEN_REFRESHED`
     *     - Emitted each time a new access and refresh token are fetched for the signed in user.
     *     - It's best practice and highly recommended to extract the access token (JWT) and store it in memory for further use in your application.
     *       - Avoid frequent calls to `supabase.auth.getSession()` for the same purpose.
     *     - There is a background process that keeps track of when the session should be refreshed so you will always receive valid tokens by listening to this event.
     *     - The frequency of this event is related to the JWT expiry limit configured on your project.
     *   - `USER_UPDATED`
     *     - Emitted each time the `supabase.auth.updateUser()` method finishes successfully. Listen to it to update your application's UI based on new profile information.
     *   - `PASSWORD_RECOVERY`
     *     - Emitted instead of the `SIGNED_IN` event when the user lands on a page that includes a password recovery link in the URL.
     *     - Use it to show a UI to the user where they can [reset their password](/docs/guides/auth/passwords#resetting-a-users-password-forgot-password).
     *
     * @example Listen to auth changes
     * ```js
     * const { data } = supabase.auth.onAuthStateChange((event, session) => {
     *   console.log(event, session)
     *
     *   if (event === 'INITIAL_SESSION') {
     *     // handle initial session
     *   } else if (event === 'SIGNED_IN') {
     *     // handle sign in event
     *   } else if (event === 'SIGNED_OUT') {
     *     // handle sign out event
     *   } else if (event === 'PASSWORD_RECOVERY') {
     *     // handle password recovery event
     *   } else if (event === 'TOKEN_REFRESHED') {
     *     // handle token refreshed event
     *   } else if (event === 'USER_UPDATED') {
     *     // handle user updated event
     *   }
     * })
     *
     * // call unsubscribe to remove the callback
     * data.subscription.unsubscribe()
     * ```
     *
     * @exampleDescription Listen to sign out
     * Make sure you clear out any local data, such as local and session storage, after the client library has detected the user's sign out.
     *
     * @example Listen to sign out
     * ```js
     * supabase.auth.onAuthStateChange((event, session) => {
     *   if (event === 'SIGNED_OUT') {
     *     console.log('SIGNED_OUT', session)
     *
     *     // clear local and session storage
     *     [
     *       window.localStorage,
     *       window.sessionStorage,
     *     ].forEach((storage) => {
     *       Object.entries(storage)
     *         .forEach(([key]) => {
     *           storage.removeItem(key)
     *         })
     *     })
     *   }
     * })
     * ```
     *
     * @exampleDescription Store OAuth provider tokens on sign in
     * When using [OAuth (Social Login)](/docs/guides/auth/social-login) you sometimes wish to get access to the provider's access token and refresh token, in order to call provider APIs in the name of the user.
     *
     * For example, if you are using [Sign in with Google](/docs/guides/auth/social-login/auth-google) you may want to use the provider token to call Google APIs on behalf of the user. Supabase Auth does not keep track of the provider access and refresh token, but does return them for you once, immediately after sign in. You can use the `onAuthStateChange` method to listen for the presence of the provider tokens and store them in local storage. You can further send them to your server's APIs for use on the backend.
     *
     * Finally, make sure you remove them from local storage on the `SIGNED_OUT` event. If the OAuth provider supports token revocation, make sure you call those APIs either from the frontend or schedule them to be called on the backend.
     *
     * @example Store OAuth provider tokens on sign in
     * ```js
     * // Register this immediately after calling createClient!
     * // Because signInWithOAuth causes a redirect, you need to fetch the
     * // provider tokens from the callback.
     * supabase.auth.onAuthStateChange((event, session) => {
     *   if (session && session.provider_token) {
     *     window.localStorage.setItem('oauth_provider_token', session.provider_token)
     *   }
     *
     *   if (session && session.provider_refresh_token) {
     *     window.localStorage.setItem('oauth_provider_refresh_token', session.provider_refresh_token)
     *   }
     *
     *   if (event === 'SIGNED_OUT') {
     *     window.localStorage.removeItem('oauth_provider_token')
     *     window.localStorage.removeItem('oauth_provider_refresh_token')
     *   }
     * })
     * ```
     *
     * @exampleDescription Use React Context for the User's session
     * Instead of relying on `supabase.auth.getSession()` within your React components, you can use a [React Context](https://react.dev/reference/react/createContext) to store the latest session information from the `onAuthStateChange` callback and access it that way.
     *
     * @example Use React Context for the User's session
     * ```js
     * const SessionContext = React.createContext(null)
     *
     * function main() {
     *   const [session, setSession] = React.useState(null)
     *
     *   React.useEffect(() => {
     *     const {data: { subscription }} = supabase.auth.onAuthStateChange(
     *       (event, session) => {
     *         if (event === 'SIGNED_OUT') {
     *           setSession(null)
     *         } else if (session) {
     *           setSession(session)
     *         }
     *       })
     *
     *     return () => {
     *       subscription.unsubscribe()
     *     }
     *   }, [])
     *
     *   return (
     *     <SessionContext.Provider value={session}>
     *       <App />
     *     </SessionContext.Provider>
     *   )
     * }
     * ```
     *
     * @example Listen to password recovery events
     * ```js
     * supabase.auth.onAuthStateChange((event, session) => {
     *   if (event === 'PASSWORD_RECOVERY') {
     *     console.log('PASSWORD_RECOVERY', session)
     *     // show screen to update user's password
     *     showPasswordResetScreen(true)
     *   }
     * })
     * ```
     *
     * @example Listen to sign in
     * ```js
     * supabase.auth.onAuthStateChange((event, session) => {
     *   if (event === 'SIGNED_IN') console.log('SIGNED_IN', session)
     * })
     * ```
     *
     * @example Listen to token refresh
     * ```js
     * supabase.auth.onAuthStateChange((event, session) => {
     *   if (event === 'TOKEN_REFRESHED') console.log('TOKEN_REFRESHED', session)
     * })
     * ```
     *
     * @example Listen to user updates
     * ```js
     * supabase.auth.onAuthStateChange((event, session) => {
     *   if (event === 'USER_UPDATED') console.log('USER_UPDATED', session)
     * })
     * ```
     */ onAuthStateChange(callback) {
        const id = (0, $98hXt.generateCallbackId)();
        const subscription = {
            id: id,
            callback: callback,
            unsubscribe: ()=>{
                this._debug('#unsubscribe()', 'state change callback with id removed', id);
                this.stateChangeEmitters.delete(id);
            }
        };
        this._debug('#onAuthStateChange()', 'registered callback with id', id);
        this.stateChangeEmitters.set(id, subscription);
        (async ()=>{
            await this.initializePromise;
            await this._acquireLock(this.lockAcquireTimeout, async ()=>{
                this._emitInitialSession(id);
            });
        })();
        return {
            data: {
                subscription: subscription
            }
        };
    }
    async _emitInitialSession(id) {
        return await this._useSession(async (result)=>{
            var _a, _b;
            try {
                const { data: { session: session }, error: error } = result;
                if (error) throw error;
                await ((_a = this.stateChangeEmitters.get(id)) === null || _a === void 0 ? void 0 : _a.callback('INITIAL_SESSION', session));
                this._debug('INITIAL_SESSION', 'callback id', id, 'session', session);
            } catch (err) {
                await ((_b = this.stateChangeEmitters.get(id)) === null || _b === void 0 ? void 0 : _b.callback('INITIAL_SESSION', null));
                this._debug('INITIAL_SESSION', 'callback id', id, 'error', err);
                if ((0, $fTIQY.isAuthSessionMissingError)(err)) console.warn(err);
                else console.error(err);
            }
        });
    }
    /**
     * Sends a password reset request to an email address. This method supports the PKCE flow.
     *
     * @param email The email address of the user.
     * @param options.redirectTo The URL to send the user to after they click the password reset link.
     * @param options.captchaToken Verification token received when the user completes the captcha on the site.
     *
     * @category Auth
     *
     * @remarks
     * - The password reset flow consist of 2 broad steps: (i) Allow the user to login via the password reset link; (ii) Update the user's password.
     * - The `resetPasswordForEmail()` only sends a password reset link to the user's email.
     * To update the user's password, see [`updateUser()`](/docs/reference/javascript/auth-updateuser).
     * - A `PASSWORD_RECOVERY` event will be emitted when the password recovery link is clicked.
     * You can use [`onAuthStateChange()`](/docs/reference/javascript/auth-onauthstatechange) to listen and invoke a callback function on these events.
     * - When the user clicks the reset link in the email they are redirected back to your application.
     * You can configure the URL that the user is redirected to with the `redirectTo` parameter.
     * See [redirect URLs and wildcards](/docs/guides/auth/redirect-urls#use-wildcards-in-redirect-urls) to add additional redirect URLs to your project.
     * - After the user has been redirected successfully, prompt them for a new password and call `updateUser()`:
     * ```js
     * const { data, error } = await supabase.auth.updateUser({
     *   password: new_password
     * })
     * ```
     *
     * @example Reset password
     * ```js
     * const { data, error } = await supabase.auth.resetPasswordForEmail(email, {
     *   redirectTo: 'https://example.com/update-password',
     * })
     * ```
     *
     * @exampleResponse Reset password
     * ```json
     * {
     *   data: {}
     *   error: null
     * }
     * ```
     *
     * @example Reset password (React)
     * ```js
     * /**
     *  * Step 1: Send the user an email to get a password reset token.
     *  * This email contains a link which sends the user back to your application.
     *  *\/
     * const { data, error } = await supabase.auth
     *   .resetPasswordForEmail('user@email.com')
     *
     * /**
     *  * Step 2: Once the user is redirected back to your application,
     *  * ask the user to reset their password.
     *  *\/
     *  useEffect(() => {
     *    supabase.auth.onAuthStateChange(async (event, session) => {
     *      if (event == "PASSWORD_RECOVERY") {
     *        const newPassword = prompt("What would you like your new password to be?");
     *        const { data, error } = await supabase.auth
     *          .updateUser({ password: newPassword })
     *
     *        if (data) alert("Password updated successfully!")
     *        if (error) alert("There was an error updating your password.")
     *      }
     *    })
     *  }, [])
     * ```
     */ async resetPasswordForEmail(email, options = {}) {
        let codeChallenge = null;
        let codeChallengeMethod = null;
        if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, $98hXt.getCodeChallengeAndMethod)(this.storage, this.storageKey, true // isPasswordRecovery
        );
        try {
            return await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/recover`, {
                body: {
                    email: email,
                    code_challenge: codeChallenge,
                    code_challenge_method: codeChallengeMethod,
                    gotrue_meta_security: {
                        captcha_token: options.captchaToken
                    }
                },
                headers: this.headers,
                redirectTo: options.redirectTo
            });
        } catch (error) {
            await (0, $98hXt.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Gets all the identities linked to a user.
     *
     * @category Auth
     *
     * @remarks
     * - The user needs to be signed in to call `getUserIdentities()`.
     *
     * @example Returns a list of identities linked to the user
     * ```js
     * const { data, error } = await supabase.auth.getUserIdentities()
     * ```
     *
     * @exampleResponse Returns a list of identities linked to the user
     * ```json
     * {
     *   "data": {
     *     "identities": [
     *       {
     *         "identity_id": "22222222-2222-2222-2222-222222222222",
     *         "id": "2024-01-01T00:00:00Z",
     *         "user_id": "2024-01-01T00:00:00Z",
     *         "identity_data": {
     *           "email": "example@email.com",
     *           "email_verified": false,
     *           "phone_verified": false,
     *           "sub": "11111111-1111-1111-1111-111111111111"
     *         },
     *         "provider": "email",
     *         "last_sign_in_at": "2024-01-01T00:00:00Z",
     *         "created_at": "2024-01-01T00:00:00Z",
     *         "updated_at": "2024-01-01T00:00:00Z",
     *         "email": "example@email.com"
     *       }
     *     ]
     *   },
     *   "error": null
     * }
     * ```
     */ async getUserIdentities() {
        var _a;
        try {
            const { data: data, error: error } = await this.getUser();
            if (error) throw error;
            return this._returnResult({
                data: {
                    identities: (_a = data.user.identities) !== null && _a !== void 0 ? _a : []
                },
                error: null
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**  *
     * @category Auth
     *
     * @remarks
     * - The **Enable Manual Linking** option must be enabled from your [project's authentication settings](/dashboard/project/_/auth/providers).
     * - The user needs to be signed in to call `linkIdentity()`.
     * - If the candidate identity is already linked to the existing user or another user, `linkIdentity()` will fail.
     * - If `linkIdentity` is run in the browser, the user is automatically redirected to the returned URL. On the server, you should handle the redirect.
     *
     * @example Link an identity to a user
     * ```js
     * const { data, error } = await supabase.auth.linkIdentity({
     *   provider: 'github'
     * })
     * ```
     *
     * @exampleResponse Link an identity to a user
     * ```json
     * {
     *   data: {
     *     provider: 'github',
     *     url: <PROVIDER_URL_TO_REDIRECT_TO>
     *   },
     *   error: null
     * }
     * ```
     */ async linkIdentity(credentials) {
        if ('token' in credentials) return this.linkIdentityIdToken(credentials);
        return this.linkIdentityOAuth(credentials);
    }
    async linkIdentityOAuth(credentials) {
        var _a;
        try {
            const { data: data, error: error } = await this._useSession(async (result)=>{
                var _a, _b, _c, _d, _f;
                const { data: data, error: error } = result;
                if (error) throw error;
                const url = await this._getUrlForProvider(`${this.url}/user/identities/authorize`, credentials.provider, {
                    redirectTo: (_a = credentials.options) === null || _a === void 0 ? void 0 : _a.redirectTo,
                    scopes: (_b = credentials.options) === null || _b === void 0 ? void 0 : _b.scopes,
                    queryParams: (_c = credentials.options) === null || _c === void 0 ? void 0 : _c.queryParams,
                    skipBrowserRedirect: true
                });
                return await (0, $doWUR._request)(this.fetch, 'GET', url, {
                    headers: this.headers,
                    jwt: (_f = (_d = data.session) === null || _d === void 0 ? void 0 : _d.access_token) !== null && _f !== void 0 ? _f : undefined
                });
            });
            if (error) throw error;
            if ((0, $98hXt.isBrowser)() && !((_a = credentials.options) === null || _a === void 0 ? void 0 : _a.skipBrowserRedirect)) window.location.assign(data === null || data === void 0 ? void 0 : data.url);
            return this._returnResult({
                data: {
                    provider: credentials.provider,
                    url: data === null || data === void 0 ? void 0 : data.url
                },
                error: null
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    provider: credentials.provider,
                    url: null
                },
                error: error
            });
            throw error;
        }
    }
    async linkIdentityIdToken(credentials) {
        return await this._useSession(async (result)=>{
            var _a;
            try {
                const { error: sessionError, data: { session: session } } = result;
                if (sessionError) throw sessionError;
                const { options: options, provider: provider, token: token, access_token: access_token, nonce: nonce } = credentials;
                const res = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/token?grant_type=id_token`, {
                    headers: this.headers,
                    jwt: (_a = session === null || session === void 0 ? void 0 : session.access_token) !== null && _a !== void 0 ? _a : undefined,
                    body: {
                        provider: provider,
                        id_token: token,
                        access_token: access_token,
                        nonce: nonce,
                        link_identity: true,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, $doWUR._sessionResponse)
                });
                const { data: data, error: error } = res;
                if (error) return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
                else if (!data || !data.session || !data.user) return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: new (0, $fTIQY.AuthInvalidTokenResponseError)()
                });
                if (data.session) {
                    await this._saveSession(data.session);
                    await this._notifyAllSubscribers('USER_UPDATED', data.session);
                }
                return this._returnResult({
                    data: data,
                    error: error
                });
            } catch (error) {
                await (0, $98hXt.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
                if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
                throw error;
            }
        });
    }
    /**
     * Unlinks an identity from a user by deleting it. The user will no longer be able to sign in with that identity once it's unlinked.
     *
     * @category Auth
     *
     * @remarks
     * - The **Enable Manual Linking** option must be enabled from your [project's authentication settings](/dashboard/project/_/auth/providers).
     * - The user needs to be signed in to call `unlinkIdentity()`.
     * - The user must have at least 2 identities in order to unlink an identity.
     * - The identity to be unlinked must belong to the user.
     *
     * @example Unlink an identity
     * ```js
     * // retrieve all identities linked to a user
     * const identities = await supabase.auth.getUserIdentities()
     *
     * // find the google identity
     * const googleIdentity = identities.find(
     *   identity => identity.provider === 'google'
     * )
     *
     * // unlink the google identity
     * const { error } = await supabase.auth.unlinkIdentity(googleIdentity)
     * ```
     */ async unlinkIdentity(identity) {
        try {
            return await this._useSession(async (result)=>{
                var _a, _b;
                const { data: data, error: error } = result;
                if (error) throw error;
                return await (0, $doWUR._request)(this.fetch, 'DELETE', `${this.url}/user/identities/${identity.identity_id}`, {
                    headers: this.headers,
                    jwt: (_b = (_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token) !== null && _b !== void 0 ? _b : undefined
                });
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Generates a new JWT.
     * @param refreshToken A valid refresh token that was returned on login.
     */ async _refreshAccessToken(refreshToken) {
        const debugName = `#_refreshAccessToken(${refreshToken.substring(0, 5)}...)`;
        this._debug(debugName, 'begin');
        try {
            const startedAt = Date.now();
            // will attempt to refresh the token with exponential backoff
            return await (0, $98hXt.retryable)(async (attempt)=>{
                if (attempt > 0) await (0, $98hXt.sleep)(200 * Math.pow(2, attempt - 1)); // 200, 400, 800, ...
                this._debug(debugName, 'refreshing attempt', attempt);
                return await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/token?grant_type=refresh_token`, {
                    body: {
                        refresh_token: refreshToken
                    },
                    headers: this.headers,
                    xform: (0, $doWUR._sessionResponse)
                });
            }, (attempt, error)=>{
                const nextBackOffInterval = 200 * Math.pow(2, attempt);
                return error && (0, $fTIQY.isAuthRetryableFetchError)(error) && // retryable only if the request can be sent before the backoff overflows the tick duration
                Date.now() + nextBackOffInterval - startedAt < (0, $44TzP.AUTO_REFRESH_TICK_DURATION_MS);
            });
        } catch (error) {
            this._debug(debugName, 'error', error);
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: {
                    session: null,
                    user: null
                },
                error: error
            });
            throw error;
        } finally{
            this._debug(debugName, 'end');
        }
    }
    _isValidSession(maybeSession) {
        const isValidSession = typeof maybeSession === 'object' && maybeSession !== null && 'access_token' in maybeSession && 'refresh_token' in maybeSession && 'expires_at' in maybeSession;
        return isValidSession;
    }
    async _handleProviderSignIn(provider, options) {
        const url = await this._getUrlForProvider(`${this.url}/authorize`, provider, {
            redirectTo: options.redirectTo,
            scopes: options.scopes,
            queryParams: options.queryParams
        });
        this._debug('#_handleProviderSignIn()', 'provider', provider, 'options', options, 'url', url);
        // try to open on the browser
        if ((0, $98hXt.isBrowser)() && !options.skipBrowserRedirect) window.location.assign(url);
        return {
            data: {
                provider: provider,
                url: url
            },
            error: null
        };
    }
    /**
     * Recovers the session from LocalStorage and refreshes the token
     * Note: this method is async to accommodate for AsyncStorage e.g. in React native.
     */ async _recoverAndRefresh() {
        var _a, _b;
        const debugName = '#_recoverAndRefresh()';
        this._debug(debugName, 'begin');
        try {
            const currentSession = await (0, $98hXt.getItemAsync)(this.storage, this.storageKey);
            if (currentSession && this.userStorage) {
                let maybeUser = await (0, $98hXt.getItemAsync)(this.userStorage, this.storageKey + '-user');
                if (!this.storage.isServer && Object.is(this.storage, this.userStorage) && !maybeUser) {
                    // storage and userStorage are the same storage medium, for example
                    // window.localStorage if userStorage does not have the user from
                    // storage stored, store it first thereby migrating the user object
                    // from storage -> userStorage
                    maybeUser = {
                        user: currentSession.user
                    };
                    await (0, $98hXt.setItemAsync)(this.userStorage, this.storageKey + '-user', maybeUser);
                }
                currentSession.user = (_a = maybeUser === null || maybeUser === void 0 ? void 0 : maybeUser.user) !== null && _a !== void 0 ? _a : (0, $98hXt.userNotAvailableProxy)();
            } else if (currentSession && !currentSession.user) // user storage is not set, let's check if it was previously enabled so
            // we bring back the storage as it should be
            {
                if (!currentSession.user) {
                    // test if userStorage was previously enabled and the storage medium was the same, to move the user back under the same key
                    const separateUser = await (0, $98hXt.getItemAsync)(this.storage, this.storageKey + '-user');
                    if (separateUser && (separateUser === null || separateUser === void 0 ? void 0 : separateUser.user)) {
                        currentSession.user = separateUser.user;
                        await (0, $98hXt.removeItemAsync)(this.storage, this.storageKey + '-user');
                        await (0, $98hXt.setItemAsync)(this.storage, this.storageKey, currentSession);
                    } else currentSession.user = (0, $98hXt.userNotAvailableProxy)();
                }
            }
            this._debug(debugName, 'session from storage', currentSession);
            if (!this._isValidSession(currentSession)) {
                this._debug(debugName, 'session is not valid');
                if (currentSession !== null) await this._removeSession();
                return;
            }
            const expiresWithMargin = ((_b = currentSession.expires_at) !== null && _b !== void 0 ? _b : Infinity) * 1000 - Date.now() < (0, $44TzP.EXPIRY_MARGIN_MS);
            this._debug(debugName, `session has${expiresWithMargin ? '' : ' not'} expired with margin of ${(0, $44TzP.EXPIRY_MARGIN_MS)}s`);
            if (expiresWithMargin) {
                if (this.autoRefreshToken && currentSession.refresh_token) {
                    const { error: error } = await this._callRefreshToken(currentSession.refresh_token);
                    if (error) {
                        console.error(error);
                        if (!(0, $fTIQY.isAuthRetryableFetchError)(error)) {
                            this._debug(debugName, 'refresh failed with a non-retryable error, removing the session', error);
                            await this._removeSession();
                        }
                    }
                }
            } else if (currentSession.user && currentSession.user.__isUserNotAvailableProxy === true) // If we have a proxy user, try to get the real user data
            try {
                const { data: data, error: userError } = await this._getUser(currentSession.access_token);
                if (!userError && (data === null || data === void 0 ? void 0 : data.user)) {
                    currentSession.user = data.user;
                    await this._saveSession(currentSession);
                    await this._notifyAllSubscribers('SIGNED_IN', currentSession);
                } else this._debug(debugName, 'could not get user data, skipping SIGNED_IN notification');
            } catch (getUserError) {
                console.error('Error getting user data:', getUserError);
                this._debug(debugName, 'error getting user data, skipping SIGNED_IN notification', getUserError);
            }
            else // no need to persist currentSession again, as we just loaded it from
            // local storage; persisting it again may overwrite a value saved by
            // another client with access to the same local storage
            await this._notifyAllSubscribers('SIGNED_IN', currentSession);
        } catch (err) {
            this._debug(debugName, 'error', err);
            console.error(err);
            return;
        } finally{
            this._debug(debugName, 'end');
        }
    }
    async _callRefreshToken(refreshToken) {
        var _a, _b;
        if (!refreshToken) throw new (0, $fTIQY.AuthSessionMissingError)();
        // refreshing is already in progress
        if (this.refreshingDeferred) return this.refreshingDeferred.promise;
        const debugName = `#_callRefreshToken(${refreshToken.substring(0, 5)}...)`;
        this._debug(debugName, 'begin');
        try {
            this.refreshingDeferred = new (0, $98hXt.Deferred)();
            const { data: data, error: error } = await this._refreshAccessToken(refreshToken);
            if (error) throw error;
            if (!data.session) throw new (0, $fTIQY.AuthSessionMissingError)();
            await this._saveSession(data.session);
            await this._notifyAllSubscribers('TOKEN_REFRESHED', data.session);
            const result = {
                data: data.session,
                error: null
            };
            this.refreshingDeferred.resolve(result);
            return result;
        } catch (error) {
            this._debug(debugName, 'error', error);
            if ((0, $fTIQY.isAuthError)(error)) {
                const result = {
                    data: null,
                    error: error
                };
                if (!(0, $fTIQY.isAuthRetryableFetchError)(error)) await this._removeSession();
                (_a = this.refreshingDeferred) === null || _a === void 0 || _a.resolve(result);
                return result;
            }
            (_b = this.refreshingDeferred) === null || _b === void 0 || _b.reject(error);
            throw error;
        } finally{
            this.refreshingDeferred = null;
            this._debug(debugName, 'end');
        }
    }
    async _notifyAllSubscribers(event, session, broadcast = true) {
        const debugName = `#_notifyAllSubscribers(${event})`;
        this._debug(debugName, 'begin', session, `broadcast = ${broadcast}`);
        try {
            if (this.broadcastChannel && broadcast) this.broadcastChannel.postMessage({
                event: event,
                session: session
            });
            const errors = [];
            const promises = Array.from(this.stateChangeEmitters.values()).map(async (x)=>{
                try {
                    await x.callback(event, session);
                } catch (e) {
                    errors.push(e);
                }
            });
            await Promise.all(promises);
            if (errors.length > 0) {
                for(let i = 0; i < errors.length; i += 1)console.error(errors[i]);
                throw errors[0];
            }
        } finally{
            this._debug(debugName, 'end');
        }
    }
    /**
     * set currentSession and currentUser
     * process to _startAutoRefreshToken if possible
     */ async _saveSession(session) {
        this._debug('#_saveSession()', session);
        // _saveSession is always called whenever a new session has been acquired
        // so we can safely suppress the warning returned by future getSession calls
        this.suppressGetSessionWarning = true;
        await (0, $98hXt.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
        // Create a shallow copy to work with, to avoid mutating the original session object if it's used elsewhere
        const sessionToProcess = Object.assign({}, session);
        const userIsProxy = sessionToProcess.user && sessionToProcess.user.__isUserNotAvailableProxy === true;
        if (this.userStorage) {
            if (!userIsProxy && sessionToProcess.user) // If it's a real user object, save it to userStorage.
            await (0, $98hXt.setItemAsync)(this.userStorage, this.storageKey + '-user', {
                user: sessionToProcess.user
            });
            else userIsProxy;
            // Prepare the main session data for primary storage: remove the user property before cloning
            // This is important because the original session.user might be the proxy
            const mainSessionData = Object.assign({}, sessionToProcess);
            delete mainSessionData.user; // Remove user (real or proxy) before cloning for main storage
            const clonedMainSessionData = (0, $98hXt.deepClone)(mainSessionData);
            await (0, $98hXt.setItemAsync)(this.storage, this.storageKey, clonedMainSessionData);
        } else {
            // No userStorage is configured.
            // In this case, session.user should ideally not be a proxy.
            // If it were, structuredClone would fail. This implies an issue elsewhere if user is a proxy here
            const clonedSession = (0, $98hXt.deepClone)(sessionToProcess); // sessionToProcess still has its original user property
            await (0, $98hXt.setItemAsync)(this.storage, this.storageKey, clonedSession);
        }
    }
    async _removeSession() {
        this._debug('#_removeSession()');
        this.suppressGetSessionWarning = false;
        await (0, $98hXt.removeItemAsync)(this.storage, this.storageKey);
        await (0, $98hXt.removeItemAsync)(this.storage, this.storageKey + '-code-verifier');
        await (0, $98hXt.removeItemAsync)(this.storage, this.storageKey + '-user');
        if (this.userStorage) await (0, $98hXt.removeItemAsync)(this.userStorage, this.storageKey + '-user');
        await this._notifyAllSubscribers('SIGNED_OUT', null);
    }
    /**
     * Removes any registered visibilitychange callback.
     *
     * {@see #startAutoRefresh}
     * {@see #stopAutoRefresh}
     */ _removeVisibilityChangedCallback() {
        this._debug('#_removeVisibilityChangedCallback()');
        const callback = this.visibilityChangedCallback;
        this.visibilityChangedCallback = null;
        try {
            if (callback && (0, $98hXt.isBrowser)() && (window === null || window === void 0 ? void 0 : window.removeEventListener)) window.removeEventListener('visibilitychange', callback);
        } catch (e) {
            console.error('removing visibilitychange callback failed', e);
        }
    }
    /**
     * This is the private implementation of {@link #startAutoRefresh}. Use this
     * within the library.
     */ async _startAutoRefresh() {
        await this._stopAutoRefresh();
        this._debug('#_startAutoRefresh()');
        const ticker = setInterval(()=>this._autoRefreshTokenTick(), (0, $44TzP.AUTO_REFRESH_TICK_DURATION_MS));
        this.autoRefreshTicker = ticker;
        if (ticker && typeof ticker === 'object' && typeof ticker.unref === 'function') // ticker is a NodeJS Timeout object that has an `unref` method
        // https://nodejs.org/api/timers.html#timeoutunref
        // When auto refresh is used in NodeJS (like for testing) the
        // `setInterval` is preventing the process from being marked as
        // finished and tests run endlessly. This can be prevented by calling
        // `unref()` on the returned object.
        ticker.unref();
        else if (typeof Deno !== 'undefined' && typeof Deno.unrefTimer === 'function') // similar like for NodeJS, but with the Deno API
        // https://deno.land/api@latest?unstable&s=Deno.unrefTimer
        // @ts-expect-error TS has no context of Deno
        Deno.unrefTimer(ticker);
        // run the tick immediately, but in the next pass of the event loop so that
        // #_initialize can be allowed to complete without recursively waiting on
        // itself
        const timeout = setTimeout(async ()=>{
            await this.initializePromise;
            await this._autoRefreshTokenTick();
        }, 0);
        this.autoRefreshTickTimeout = timeout;
        if (timeout && typeof timeout === 'object' && typeof timeout.unref === 'function') timeout.unref();
        else if (typeof Deno !== 'undefined' && typeof Deno.unrefTimer === 'function') // @ts-expect-error TS has no context of Deno
        Deno.unrefTimer(timeout);
    }
    /**
     * This is the private implementation of {@link #stopAutoRefresh}. Use this
     * within the library.
     */ async _stopAutoRefresh() {
        this._debug('#_stopAutoRefresh()');
        const ticker = this.autoRefreshTicker;
        this.autoRefreshTicker = null;
        if (ticker) clearInterval(ticker);
        const timeout = this.autoRefreshTickTimeout;
        this.autoRefreshTickTimeout = null;
        if (timeout) clearTimeout(timeout);
    }
    /**
     * Starts an auto-refresh process in the background. The session is checked
     * every few seconds. Close to the time of expiration a process is started to
     * refresh the session. If refreshing fails it will be retried for as long as
     * necessary.
     *
     * If you set the {@link GoTrueClientOptions#autoRefreshToken} you don't need
     * to call this function, it will be called for you.
     *
     * On browsers the refresh process works only when the tab/window is in the
     * foreground to conserve resources as well as prevent race conditions and
     * flooding auth with requests. If you call this method any managed
     * visibility change callback will be removed and you must manage visibility
     * changes on your own.
     *
     * On non-browser platforms the refresh process works *continuously* in the
     * background, which may not be desirable. You should hook into your
     * platform's foreground indication mechanism and call these methods
     * appropriately to conserve resources.
     *
     * {@see #stopAutoRefresh}
     *
     * @category Auth
     *
     * @remarks
     * - Only useful in non-browser environments such as React Native or Electron.
     * - The Supabase Auth library automatically starts and stops proactively refreshing the session when a tab is focused or not.
     * - On non-browser platforms, such as mobile or desktop apps built with web technologies, the library is not able to effectively determine whether the application is _focused_ or not.
     * - To give this hint to the application, you should be calling this method when the app is in focus and calling `supabase.auth.stopAutoRefresh()` when it's out of focus.
     *
     * @example Start and stop auto refresh in React Native
     * ```js
     * import { AppState } from 'react-native'
     *
     * // make sure you register this only once!
     * AppState.addEventListener('change', (state) => {
     *   if (state === 'active') {
     *     supabase.auth.startAutoRefresh()
     *   } else {
     *     supabase.auth.stopAutoRefresh()
     *   }
     * })
     * ```
     */ async startAutoRefresh() {
        this._removeVisibilityChangedCallback();
        await this._startAutoRefresh();
    }
    /**
     * Stops an active auto refresh process running in the background (if any).
     *
     * If you call this method any managed visibility change callback will be
     * removed and you must manage visibility changes on your own.
     *
     * See {@link #startAutoRefresh} for more details.
     *
     * @category Auth
     *
     * @remarks
     * - Only useful in non-browser environments such as React Native or Electron.
     * - The Supabase Auth library automatically starts and stops proactively refreshing the session when a tab is focused or not.
     * - On non-browser platforms, such as mobile or desktop apps built with web technologies, the library is not able to effectively determine whether the application is _focused_ or not.
     * - When your application goes in the background or out of focus, call this method to stop the proactive refreshing of the session.
     *
     * @example Start and stop auto refresh in React Native
     * ```js
     * import { AppState } from 'react-native'
     *
     * // make sure you register this only once!
     * AppState.addEventListener('change', (state) => {
     *   if (state === 'active') {
     *     supabase.auth.startAutoRefresh()
     *   } else {
     *     supabase.auth.stopAutoRefresh()
     *   }
     * })
     * ```
     */ async stopAutoRefresh() {
        this._removeVisibilityChangedCallback();
        await this._stopAutoRefresh();
    }
    /**
     * Runs the auto refresh token tick.
     */ async _autoRefreshTokenTick() {
        this._debug('#_autoRefreshTokenTick()', 'begin');
        try {
            await this._acquireLock(0, async ()=>{
                try {
                    const now = Date.now();
                    try {
                        return await this._useSession(async (result)=>{
                            const { data: { session: session } } = result;
                            if (!session || !session.refresh_token || !session.expires_at) {
                                this._debug('#_autoRefreshTokenTick()', 'no session');
                                return;
                            }
                            // session will expire in this many ticks (or has already expired if <= 0)
                            const expiresInTicks = Math.floor((session.expires_at * 1000 - now) / (0, $44TzP.AUTO_REFRESH_TICK_DURATION_MS));
                            this._debug('#_autoRefreshTokenTick()', `access token expires in ${expiresInTicks} ticks, a tick lasts ${(0, $44TzP.AUTO_REFRESH_TICK_DURATION_MS)}ms, refresh threshold is ${(0, $44TzP.AUTO_REFRESH_TICK_THRESHOLD)} ticks`);
                            if (expiresInTicks <= (0, $44TzP.AUTO_REFRESH_TICK_THRESHOLD)) await this._callRefreshToken(session.refresh_token);
                        });
                    } catch (e) {
                        console.error('Auto refresh tick failed with error. This is likely a transient error.', e);
                    }
                } finally{
                    this._debug('#_autoRefreshTokenTick()', 'end');
                }
            });
        } catch (e) {
            if (e instanceof (0, $gn0EB.LockAcquireTimeoutError)) this._debug('auto refresh token tick lock not available');
            else throw e;
        }
    }
    /**
     * Registers callbacks on the browser / platform, which in-turn run
     * algorithms when the browser window/tab are in foreground. On non-browser
     * platforms it assumes always foreground.
     */ async _handleVisibilityChange() {
        this._debug('#_handleVisibilityChange()');
        if (!(0, $98hXt.isBrowser)() || !(window === null || window === void 0 ? void 0 : window.addEventListener)) {
            if (this.autoRefreshToken) // in non-browser environments the refresh token ticker runs always
            this.startAutoRefresh();
            return false;
        }
        try {
            this.visibilityChangedCallback = async ()=>{
                try {
                    await this._onVisibilityChanged(false);
                } catch (error) {
                    this._debug('#visibilityChangedCallback', 'error', error);
                }
            };
            window === null || window === void 0 || window.addEventListener('visibilitychange', this.visibilityChangedCallback);
            // now immediately call the visbility changed callback to setup with the
            // current visbility state
            await this._onVisibilityChanged(true); // initial call
        } catch (error) {
            console.error('_handleVisibilityChange', error);
        }
    }
    /**
     * Callback registered with `window.addEventListener('visibilitychange')`.
     */ async _onVisibilityChanged(calledFromInitialize) {
        const methodName = `#_onVisibilityChanged(${calledFromInitialize})`;
        this._debug(methodName, 'visibilityState', document.visibilityState);
        if (document.visibilityState === 'visible') {
            if (this.autoRefreshToken) // in browser environments the refresh token ticker runs only on focused tabs
            // which prevents race conditions
            this._startAutoRefresh();
            if (!calledFromInitialize) {
                // called when the visibility has changed, i.e. the browser
                // transitioned from hidden -> visible so we need to see if the session
                // should be recovered immediately... but to do that we need to acquire
                // the lock first asynchronously
                await this.initializePromise;
                await this._acquireLock(this.lockAcquireTimeout, async ()=>{
                    if (document.visibilityState !== 'visible') {
                        this._debug(methodName, 'acquired the lock to recover the session, but the browser visibilityState is no longer visible, aborting');
                        // visibility has changed while waiting for the lock, abort
                        return;
                    }
                    // recover the session
                    await this._recoverAndRefresh();
                });
            }
        } else if (document.visibilityState === 'hidden') {
            if (this.autoRefreshToken) this._stopAutoRefresh();
        }
    }
    /**
     * Generates the relevant login URL for a third-party provider.
     * @param options.redirectTo A URL or mobile address to send the user to after they are confirmed.
     * @param options.scopes A space-separated list of scopes granted to the OAuth application.
     * @param options.queryParams An object of key-value pairs containing query parameters granted to the OAuth application.
     */ async _getUrlForProvider(url, provider, options) {
        const urlParams = [
            `provider=${encodeURIComponent(provider)}`
        ];
        if (options === null || options === void 0 ? void 0 : options.redirectTo) urlParams.push(`redirect_to=${encodeURIComponent(options.redirectTo)}`);
        if (options === null || options === void 0 ? void 0 : options.scopes) urlParams.push(`scopes=${encodeURIComponent(options.scopes)}`);
        if (this.flowType === 'pkce') {
            const [codeChallenge, codeChallengeMethod] = await (0, $98hXt.getCodeChallengeAndMethod)(this.storage, this.storageKey);
            const flowParams = new URLSearchParams({
                code_challenge: `${encodeURIComponent(codeChallenge)}`,
                code_challenge_method: `${encodeURIComponent(codeChallengeMethod)}`
            });
            urlParams.push(flowParams.toString());
        }
        if (options === null || options === void 0 ? void 0 : options.queryParams) {
            const query = new URLSearchParams(options.queryParams);
            urlParams.push(query.toString());
        }
        if (options === null || options === void 0 ? void 0 : options.skipBrowserRedirect) urlParams.push(`skip_http_redirect=${options.skipBrowserRedirect}`);
        return `${url}?${urlParams.join('&')}`;
    }
    async _unenroll(params) {
        try {
            return await this._useSession(async (result)=>{
                var _a;
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                return await (0, $doWUR._request)(this.fetch, 'DELETE', `${this.url}/factors/${params.factorId}`, {
                    headers: this.headers,
                    jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                });
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    async _enroll(params) {
        try {
            return await this._useSession(async (result)=>{
                var _a, _b;
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                const body = Object.assign({
                    friendly_name: params.friendlyName,
                    factor_type: params.factorType
                }, params.factorType === 'phone' ? {
                    phone: params.phone
                } : params.factorType === 'totp' ? {
                    issuer: params.issuer
                } : {});
                const { data: data, error: error } = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/factors`, {
                    body: body,
                    headers: this.headers,
                    jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                });
                if (error) return this._returnResult({
                    data: null,
                    error: error
                });
                if (params.factorType === 'totp' && data.type === 'totp' && ((_b = data === null || data === void 0 ? void 0 : data.totp) === null || _b === void 0 ? void 0 : _b.qr_code)) data.totp.qr_code = `data:image/svg+xml;utf-8,${data.totp.qr_code}`;
                return this._returnResult({
                    data: data,
                    error: null
                });
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    async _verify(params) {
        return this._acquireLock(this.lockAcquireTimeout, async ()=>{
            try {
                return await this._useSession(async (result)=>{
                    var _a;
                    const { data: sessionData, error: sessionError } = result;
                    if (sessionError) return this._returnResult({
                        data: null,
                        error: sessionError
                    });
                    const body = Object.assign({
                        challenge_id: params.challengeId
                    }, 'webauthn' in params ? {
                        webauthn: Object.assign(Object.assign({}, params.webauthn), {
                            credential_response: params.webauthn.type === 'create' ? (0, $2GmzD.serializeCredentialCreationResponse)(params.webauthn.credential_response) : (0, $2GmzD.serializeCredentialRequestResponse)(params.webauthn.credential_response)
                        })
                    } : {
                        code: params.code
                    });
                    const { data: data, error: error } = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/factors/${params.factorId}/verify`, {
                        body: body,
                        headers: this.headers,
                        jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                    });
                    if (error) return this._returnResult({
                        data: null,
                        error: error
                    });
                    await this._saveSession(Object.assign({
                        expires_at: Math.round(Date.now() / 1000) + data.expires_in
                    }, data));
                    await this._notifyAllSubscribers('MFA_CHALLENGE_VERIFIED', data);
                    return this._returnResult({
                        data: data,
                        error: error
                    });
                });
            } catch (error) {
                if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                    data: null,
                    error: error
                });
                throw error;
            }
        });
    }
    async _challenge(params) {
        return this._acquireLock(this.lockAcquireTimeout, async ()=>{
            try {
                return await this._useSession(async (result)=>{
                    var _a;
                    const { data: sessionData, error: sessionError } = result;
                    if (sessionError) return this._returnResult({
                        data: null,
                        error: sessionError
                    });
                    const response = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/factors/${params.factorId}/challenge`, {
                        body: params,
                        headers: this.headers,
                        jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                    });
                    if (response.error) return response;
                    const { data: data } = response;
                    if (data.type !== 'webauthn') return {
                        data: data,
                        error: null
                    };
                    switch(data.webauthn.type){
                        case 'create':
                            return {
                                data: Object.assign(Object.assign({}, data), {
                                    webauthn: Object.assign(Object.assign({}, data.webauthn), {
                                        credential_options: Object.assign(Object.assign({}, data.webauthn.credential_options), {
                                            publicKey: (0, $2GmzD.deserializeCredentialCreationOptions)(data.webauthn.credential_options.publicKey)
                                        })
                                    })
                                }),
                                error: null
                            };
                        case 'request':
                            return {
                                data: Object.assign(Object.assign({}, data), {
                                    webauthn: Object.assign(Object.assign({}, data.webauthn), {
                                        credential_options: Object.assign(Object.assign({}, data.webauthn.credential_options), {
                                            publicKey: (0, $2GmzD.deserializeCredentialRequestOptions)(data.webauthn.credential_options.publicKey)
                                        })
                                    })
                                }),
                                error: null
                            };
                    }
                });
            } catch (error) {
                if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                    data: null,
                    error: error
                });
                throw error;
            }
        });
    }
    /**
     * {@see GoTrueMFAApi#challengeAndVerify}
     */ async _challengeAndVerify(params) {
        // both _challenge and _verify independently acquire the lock, so no need
        // to acquire it here
        const { data: challengeData, error: challengeError } = await this._challenge({
            factorId: params.factorId
        });
        if (challengeError) return this._returnResult({
            data: null,
            error: challengeError
        });
        return await this._verify({
            factorId: params.factorId,
            challengeId: challengeData.id,
            code: params.code
        });
    }
    /**
     * {@see GoTrueMFAApi#listFactors}
     */ async _listFactors() {
        var _a;
        // use #getUser instead of #_getUser as the former acquires a lock
        const { data: { user: user }, error: userError } = await this.getUser();
        if (userError) return {
            data: null,
            error: userError
        };
        const data = {
            all: [],
            phone: [],
            totp: [],
            webauthn: []
        };
        // loop over the factors ONCE
        for (const factor of (_a = user === null || user === void 0 ? void 0 : user.factors) !== null && _a !== void 0 ? _a : []){
            data.all.push(factor);
            if (factor.status === 'verified') data[factor.factor_type].push(factor);
        }
        return {
            data: data,
            error: null
        };
    }
    /**
     * {@see GoTrueMFAApi#getAuthenticatorAssuranceLevel}
     */ async _getAuthenticatorAssuranceLevel(jwt) {
        var _a, _b, _c, _d;
        if (jwt) try {
            const { payload: payload } = (0, $98hXt.decodeJWT)(jwt);
            let currentLevel = null;
            if (payload.aal) currentLevel = payload.aal;
            let nextLevel = currentLevel;
            const { data: { user: user }, error: userError } = await this.getUser(jwt);
            if (userError) return this._returnResult({
                data: null,
                error: userError
            });
            const verifiedFactors = (_b = (_a = user === null || user === void 0 ? void 0 : user.factors) === null || _a === void 0 ? void 0 : _a.filter((factor)=>factor.status === 'verified')) !== null && _b !== void 0 ? _b : [];
            if (verifiedFactors.length > 0) nextLevel = 'aal2';
            const currentAuthenticationMethods = payload.amr || [];
            return {
                data: {
                    currentLevel: currentLevel,
                    nextLevel: nextLevel,
                    currentAuthenticationMethods: currentAuthenticationMethods
                },
                error: null
            };
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
        const { data: { session: session }, error: sessionError } = await this.getSession();
        if (sessionError) return this._returnResult({
            data: null,
            error: sessionError
        });
        if (!session) return {
            data: {
                currentLevel: null,
                nextLevel: null,
                currentAuthenticationMethods: []
            },
            error: null
        };
        const { payload: payload } = (0, $98hXt.decodeJWT)(session.access_token);
        let currentLevel = null;
        if (payload.aal) currentLevel = payload.aal;
        let nextLevel = currentLevel;
        const verifiedFactors = (_d = (_c = session.user.factors) === null || _c === void 0 ? void 0 : _c.filter((factor)=>factor.status === 'verified')) !== null && _d !== void 0 ? _d : [];
        if (verifiedFactors.length > 0) nextLevel = 'aal2';
        const currentAuthenticationMethods = payload.amr || [];
        return {
            data: {
                currentLevel: currentLevel,
                nextLevel: nextLevel,
                currentAuthenticationMethods: currentAuthenticationMethods
            },
            error: null
        };
    }
    /**
     * Retrieves details about an OAuth authorization request.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     *
     * Returns authorization details including client info, scopes, and user information.
     * If the response includes only a redirect_url field, it means consent was already given - the caller
     * should handle the redirect manually if needed.
     */ async _getAuthorizationDetails(authorizationId) {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                if (!session) return this._returnResult({
                    data: null,
                    error: new (0, $fTIQY.AuthSessionMissingError)()
                });
                return await (0, $doWUR._request)(this.fetch, 'GET', `${this.url}/oauth/authorizations/${authorizationId}`, {
                    headers: this.headers,
                    jwt: session.access_token,
                    xform: (data)=>({
                            data: data,
                            error: null
                        })
                });
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Approves an OAuth authorization request.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     */ async _approveAuthorization(authorizationId, options) {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                if (!session) return this._returnResult({
                    data: null,
                    error: new (0, $fTIQY.AuthSessionMissingError)()
                });
                const response = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/oauth/authorizations/${authorizationId}/consent`, {
                    headers: this.headers,
                    jwt: session.access_token,
                    body: {
                        action: 'approve'
                    },
                    xform: (data)=>({
                            data: data,
                            error: null
                        })
                });
                if (response.data && response.data.redirect_url) // Automatically redirect in browser unless skipBrowserRedirect is true
                {
                    if ((0, $98hXt.isBrowser)() && !(options === null || options === void 0 ? void 0 : options.skipBrowserRedirect)) window.location.assign(response.data.redirect_url);
                }
                return response;
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Denies an OAuth authorization request.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     */ async _denyAuthorization(authorizationId, options) {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                if (!session) return this._returnResult({
                    data: null,
                    error: new (0, $fTIQY.AuthSessionMissingError)()
                });
                const response = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/oauth/authorizations/${authorizationId}/consent`, {
                    headers: this.headers,
                    jwt: session.access_token,
                    body: {
                        action: 'deny'
                    },
                    xform: (data)=>({
                            data: data,
                            error: null
                        })
                });
                if (response.data && response.data.redirect_url) // Automatically redirect in browser unless skipBrowserRedirect is true
                {
                    if ((0, $98hXt.isBrowser)() && !(options === null || options === void 0 ? void 0 : options.skipBrowserRedirect)) window.location.assign(response.data.redirect_url);
                }
                return response;
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Lists all OAuth grants that the authenticated user has authorized.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     */ async _listOAuthGrants() {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                if (!session) return this._returnResult({
                    data: null,
                    error: new (0, $fTIQY.AuthSessionMissingError)()
                });
                return await (0, $doWUR._request)(this.fetch, 'GET', `${this.url}/user/oauth/grants`, {
                    headers: this.headers,
                    jwt: session.access_token,
                    xform: (data)=>({
                            data: data,
                            error: null
                        })
                });
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Revokes a user's OAuth grant for a specific client.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     */ async _revokeOAuthGrant(options) {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                if (!session) return this._returnResult({
                    data: null,
                    error: new (0, $fTIQY.AuthSessionMissingError)()
                });
                await (0, $doWUR._request)(this.fetch, 'DELETE', `${this.url}/user/oauth/grants`, {
                    headers: this.headers,
                    jwt: session.access_token,
                    query: {
                        client_id: options.clientId
                    },
                    noResolveJson: true
                });
                return {
                    data: {},
                    error: null
                };
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    async fetchJwk(kid, jwks = {
        keys: []
    }) {
        // try fetching from the supplied jwks
        let jwk = jwks.keys.find((key)=>key.kid === kid);
        if (jwk) return jwk;
        const now = Date.now();
        // try fetching from cache
        jwk = this.jwks.keys.find((key)=>key.kid === kid);
        // jwk exists and jwks isn't stale
        if (jwk && this.jwks_cached_at + (0, $44TzP.JWKS_TTL) > now) return jwk;
        // jwk isn't cached in memory so we need to fetch it from the well-known endpoint
        const { data: data, error: error } = await (0, $doWUR._request)(this.fetch, 'GET', `${this.url}/.well-known/jwks.json`, {
            headers: this.headers
        });
        if (error) throw error;
        if (!data.keys || data.keys.length === 0) return null;
        this.jwks = data;
        this.jwks_cached_at = now;
        // Find the signing key
        jwk = data.keys.find((key)=>key.kid === kid);
        if (!jwk) return null;
        return jwk;
    }
    /**
     * Extracts the JWT claims present in the access token by first verifying the
     * JWT against the server's JSON Web Key Set endpoint
     * `/.well-known/jwks.json` which is often cached, resulting in significantly
     * faster responses. Prefer this method over {@link #getUser} which always
     * sends a request to the Auth server for each JWT.
     *
     * If the project is not using an asymmetric JWT signing key (like ECC or
     * RSA) it always sends a request to the Auth server (similar to {@link
     * #getUser}) to verify the JWT.
     *
     * @param jwt An optional specific JWT you wish to verify, not the one you
     *            can obtain from {@link #getSession}.
     * @param options Various additional options that allow you to customize the
     *                behavior of this method.
     *
     * @category Auth
     *
     * @remarks
     * - Parses the user's [access token](/docs/guides/auth/sessions#access-token-jwt-claims) as a [JSON Web Token (JWT)](/docs/guides/auth/jwts) and returns its components if valid and not expired.
     * - If your project is using asymmetric JWT signing keys, then the verification is done locally usually without a network request using the [WebCrypto API](https://developer.mozilla.org/en-US/docs/Web/API/Web_Crypto_API).
     * - A network request is sent to your project's JWT signing key discovery endpoint `https://project-id.supabase.co/auth/v1/.well-known/jwks.json`, which is cached locally. If your environment is ephemeral, such as a Lambda function that is destroyed after every request, a network request will be sent for each new invocation. Supabase provides a network-edge cache providing fast responses for these situations.
     * - If the user's access token is about to expire when calling this function, the user's session will first be refreshed before validating the JWT.
     * - If your project is using a symmetric secret to sign the JWT, it always sends a request similar to `getUser()` to validate the JWT at the server before returning the decoded token. This is also used if the WebCrypto API is not available in the environment. Make sure you polyfill it in such situations.
     * - The returned claims can be customized per project using the [Custom Access Token Hook](/docs/guides/auth/auth-hooks/custom-access-token-hook).
     *
     * @example Get JWT claims, header and signature
     * ```js
     * const { data, error } = await supabase.auth.getClaims()
     * ```
     *
     * @exampleResponse Get JWT claims, header and signature
     * ```json
     * {
     *   "data": {
     *     "claims": {
     *       "aal": "aal1",
     *       "amr": [{
     *         "method": "email",
     *         "timestamp": 1715766000
     *       }],
     *       "app_metadata": {},
     *       "aud": "authenticated",
     *       "email": "example@email.com",
     *       "exp": 1715769600,
     *       "iat": 1715766000,
     *       "is_anonymous": false,
     *       "iss": "https://project-id.supabase.co/auth/v1",
     *       "phone": "+13334445555",
     *       "role": "authenticated",
     *       "session_id": "11111111-1111-1111-1111-111111111111",
     *       "sub": "11111111-1111-1111-1111-111111111111",
     *       "user_metadata": {}
     *     },
     *     "header": {
     *       "alg": "RS256",
     *       "typ": "JWT",
     *       "kid": "11111111-1111-1111-1111-111111111111"
     *     },
     *     "signature": [/** Uint8Array *\/],
     *   },
     *   "error": null
     * }
     * ```
     */ async getClaims(jwt, options = {}) {
        try {
            let token = jwt;
            if (!token) {
                const { data: data, error: error } = await this.getSession();
                if (error || !data.session) return this._returnResult({
                    data: null,
                    error: error
                });
                token = data.session.access_token;
            }
            const { header: header, payload: payload, signature: signature, raw: { header: rawHeader, payload: rawPayload } } = (0, $98hXt.decodeJWT)(token);
            if (!(options === null || options === void 0 ? void 0 : options.allowExpired)) // Reject expired JWTs should only happen if jwt argument was passed
            (0, $98hXt.validateExp)(payload.exp);
            const signingKey = !header.alg || header.alg.startsWith('HS') || !header.kid || !('crypto' in globalThis && 'subtle' in globalThis.crypto) ? null : await this.fetchJwk(header.kid, (options === null || options === void 0 ? void 0 : options.keys) ? {
                keys: options.keys
            } : options === null || options === void 0 ? void 0 : options.jwks);
            // If symmetric algorithm or WebCrypto API is unavailable, fallback to getUser()
            if (!signingKey) {
                const { error: error } = await this.getUser(token);
                if (error) throw error;
                // getUser succeeds so the claims in the JWT can be trusted
                return {
                    data: {
                        claims: payload,
                        header: header,
                        signature: signature
                    },
                    error: null
                };
            }
            const algorithm = (0, $98hXt.getAlgorithm)(header.alg);
            // Convert JWK to CryptoKey
            const publicKey = await crypto.subtle.importKey('jwk', signingKey, algorithm, true, [
                'verify'
            ]);
            // Verify the signature
            const isValid = await crypto.subtle.verify(algorithm, publicKey, signature, (0, $iSR6L.stringToUint8Array)(`${rawHeader}.${rawPayload}`));
            if (!isValid) throw new (0, $fTIQY.AuthInvalidJwtError)('Invalid JWT signature');
            // If verification succeeds, decode and return claims
            return {
                data: {
                    claims: payload,
                    header: header,
                    signature: signature
                },
                error: null
            };
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    // --- Passkey Methods ---
    /**
     * Sign in with a passkey. Handles the full WebAuthn ceremony:
     * 1. Fetches authentication challenge from server
     * 2. Prompts user via navigator.credentials.get()
     * 3. Verifies credential with server and creates session
     *
     * Requires `auth.experimental.passkey: true`.
     *
     * @category Auth
     */ async signInWithPasskey(credentials) {
        var _a, _b, _c;
        (0, $98hXt.assertPasskeyExperimentalEnabled)(this.experimental);
        try {
            if (!(0, $2GmzD.browserSupportsWebAuthn)()) return this._returnResult({
                data: null,
                error: new (0, $fTIQY.AuthUnknownError)('Browser does not support WebAuthn', null)
            });
            // 1. Get challenge options from server
            const { data: options, error: optionsError } = await this._startPasskeyAuthentication({
                options: {
                    captchaToken: (_a = credentials === null || credentials === void 0 ? void 0 : credentials.options) === null || _a === void 0 ? void 0 : _a.captchaToken
                }
            });
            if (optionsError || !options) return this._returnResult({
                data: null,
                error: optionsError
            });
            // 2. Deserialize and prompt user via browser WebAuthn API
            const publicKeyOptions = (0, $2GmzD.deserializeCredentialRequestOptions)(options.options);
            const signal = (_c = (_b = credentials === null || credentials === void 0 ? void 0 : credentials.options) === null || _b === void 0 ? void 0 : _b.signal) !== null && _c !== void 0 ? _c : (0, $2GmzD.webAuthnAbortService).createNewAbortSignal();
            const { data: credential, error: credentialError } = await (0, $2GmzD.getCredential)({
                publicKey: publicKeyOptions,
                signal: signal
            });
            if (credentialError || !credential) return this._returnResult({
                data: null,
                error: credentialError !== null && credentialError !== void 0 ? credentialError : new (0, $fTIQY.AuthUnknownError)('WebAuthn ceremony failed', null)
            });
            // 3. Serialize and verify with server
            const serialized = (0, $2GmzD.serializeCredentialRequestResponse)(credential);
            return this._verifyPasskeyAuthentication({
                challengeId: options.challenge_id,
                credential: serialized
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Register a passkey for the current authenticated user. Handles the full WebAuthn ceremony:
     * 1. Fetches registration challenge from server
     * 2. Prompts user via navigator.credentials.create()
     * 3. Verifies credential with server
     *
     * Requires an active session. Requires `auth.experimental.passkey: true`.
     *
     * @category Auth
     */ async registerPasskey(credentials) {
        var _a, _b;
        (0, $98hXt.assertPasskeyExperimentalEnabled)(this.experimental);
        try {
            if (!(0, $2GmzD.browserSupportsWebAuthn)()) return this._returnResult({
                data: null,
                error: new (0, $fTIQY.AuthUnknownError)('Browser does not support WebAuthn', null)
            });
            // 1. Get challenge options from server
            const { data: options, error: optionsError } = await this._startPasskeyRegistration();
            if (optionsError || !options) return this._returnResult({
                data: null,
                error: optionsError
            });
            // 2. Deserialize and prompt user via browser WebAuthn API
            const publicKeyOptions = (0, $2GmzD.deserializeCredentialCreationOptions)(options.options);
            const signal = (_b = (_a = credentials === null || credentials === void 0 ? void 0 : credentials.options) === null || _a === void 0 ? void 0 : _a.signal) !== null && _b !== void 0 ? _b : (0, $2GmzD.webAuthnAbortService).createNewAbortSignal();
            const { data: credential, error: credentialError } = await (0, $2GmzD.createCredential)({
                publicKey: publicKeyOptions,
                signal: signal
            });
            if (credentialError || !credential) return this._returnResult({
                data: null,
                error: credentialError !== null && credentialError !== void 0 ? credentialError : new (0, $fTIQY.AuthUnknownError)('WebAuthn ceremony failed', null)
            });
            // 3. Serialize and verify with server
            const serialized = (0, $2GmzD.serializeCredentialCreationResponse)(credential);
            return this._verifyPasskeyRegistration({
                challengeId: options.challenge_id,
                credential: serialized
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Start passkey registration for the current authenticated user.
     * Returns WebAuthn credential creation options to pass to navigator.credentials.create().
     */ async _startPasskeyRegistration() {
        (0, $98hXt.assertPasskeyExperimentalEnabled)(this.experimental);
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                if (!session) return this._returnResult({
                    data: null,
                    error: new (0, $fTIQY.AuthSessionMissingError)()
                });
                const { data: data, error: error } = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/passkeys/registration/options`, {
                    headers: this.headers,
                    jwt: session.access_token,
                    body: {}
                });
                if (error) return this._returnResult({
                    data: null,
                    error: error
                });
                return this._returnResult({
                    data: data,
                    error: null
                });
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Verify passkey registration with the credential response.
     * The credentialResponse should be the serialized output of navigator.credentials.create().
     */ async _verifyPasskeyRegistration(params) {
        (0, $98hXt.assertPasskeyExperimentalEnabled)(this.experimental);
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                if (!session) return this._returnResult({
                    data: null,
                    error: new (0, $fTIQY.AuthSessionMissingError)()
                });
                const { data: data, error: error } = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/passkeys/registration/verify`, {
                    headers: this.headers,
                    jwt: session.access_token,
                    body: {
                        challenge_id: params.challengeId,
                        credential: params.credential
                    }
                });
                if (error) return this._returnResult({
                    data: null,
                    error: error
                });
                return this._returnResult({
                    data: data,
                    error: null
                });
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Start passkey authentication.
     * Returns WebAuthn credential request options to pass to navigator.credentials.get().
     */ async _startPasskeyAuthentication(params) {
        var _a;
        (0, $98hXt.assertPasskeyExperimentalEnabled)(this.experimental);
        try {
            const { data: data, error: error } = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/passkeys/authentication/options`, {
                headers: this.headers,
                body: {
                    gotrue_meta_security: {
                        captcha_token: (_a = params === null || params === void 0 ? void 0 : params.options) === null || _a === void 0 ? void 0 : _a.captchaToken
                    }
                }
            });
            if (error) return this._returnResult({
                data: null,
                error: error
            });
            return this._returnResult({
                data: data,
                error: null
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Verify passkey authentication and create a session.
     * The credential should be the serialized output of navigator.credentials.get().
     */ async _verifyPasskeyAuthentication(params) {
        (0, $98hXt.assertPasskeyExperimentalEnabled)(this.experimental);
        try {
            const { data: data, error: error } = await (0, $doWUR._request)(this.fetch, 'POST', `${this.url}/passkeys/authentication/verify`, {
                headers: this.headers,
                body: {
                    challenge_id: params.challengeId,
                    credential: params.credential
                },
                xform: (0, $doWUR._sessionResponse)
            });
            if (error) return this._returnResult({
                data: null,
                error: error
            });
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return this._returnResult({
                data: data,
                error: null
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * List all passkeys for the current user.
     */ async _listPasskeys() {
        (0, $98hXt.assertPasskeyExperimentalEnabled)(this.experimental);
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                if (!session) return this._returnResult({
                    data: null,
                    error: new (0, $fTIQY.AuthSessionMissingError)()
                });
                const { data: data, error: error } = await (0, $doWUR._request)(this.fetch, 'GET', `${this.url}/passkeys`, {
                    headers: this.headers,
                    jwt: session.access_token,
                    xform: (data)=>({
                            data: data,
                            error: null
                        })
                });
                if (error) return this._returnResult({
                    data: null,
                    error: error
                });
                return this._returnResult({
                    data: data,
                    error: null
                });
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Update a passkey.
     */ async _updatePasskey(params) {
        (0, $98hXt.assertPasskeyExperimentalEnabled)(this.experimental);
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                if (!session) return this._returnResult({
                    data: null,
                    error: new (0, $fTIQY.AuthSessionMissingError)()
                });
                const { data: data, error: error } = await (0, $doWUR._request)(this.fetch, 'PATCH', `${this.url}/passkeys/${params.passkeyId}`, {
                    headers: this.headers,
                    jwt: session.access_token,
                    body: {
                        friendly_name: params.friendlyName
                    }
                });
                if (error) return this._returnResult({
                    data: null,
                    error: error
                });
                return this._returnResult({
                    data: data,
                    error: null
                });
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Delete a passkey.
     */ async _deletePasskey(params) {
        (0, $98hXt.assertPasskeyExperimentalEnabled)(this.experimental);
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                if (!session) return this._returnResult({
                    data: null,
                    error: new (0, $fTIQY.AuthSessionMissingError)()
                });
                const { error: error } = await (0, $doWUR._request)(this.fetch, 'DELETE', `${this.url}/passkeys/${params.passkeyId}`, {
                    headers: this.headers,
                    jwt: session.access_token,
                    noResolveJson: true
                });
                if (error) return this._returnResult({
                    data: null,
                    error: error
                });
                return this._returnResult({
                    data: null,
                    error: null
                });
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
}
$8025f0dcbc879582$var$GoTrueClient.nextInstanceID = {};
var $8025f0dcbc879582$export$2e2bcd8739ae039 = $8025f0dcbc879582$var$GoTrueClient;

});
parcelRegister("a7BAw", function(module, exports) {

$parcel$export(module.exports, "memoryLocalStorageAdapter", () => $75e7b709645121aa$export$d791f66d7e5710cf);
/**
 * Returns a localStorage-like object that stores the key-value pairs in
 * memory.
 */ function $75e7b709645121aa$export$d791f66d7e5710cf(store = {}) {
    return {
        getItem: (key)=>{
            return store[key] || null;
        },
        setItem: (key, value)=>{
            store[key] = value;
        },
        removeItem: (key)=>{
            delete store[key];
        }
    };
}

});

parcelRegister("gn0EB", function(module, exports) {

$parcel$export(module.exports, "LockAcquireTimeoutError", () => $031357f45f79c67e$export$23e9464cc010dff9);
$parcel$export(module.exports, "navigatorLock", () => $031357f45f79c67e$export$f4ff21938fb7af3c);

var $98hXt = parcelRequire("98hXt");
const $031357f45f79c67e$export$e368aba7747330f2 = {
    /**
     * @experimental
     */ debug: !!(globalThis && (0, $98hXt.supportsLocalStorage)() && globalThis.localStorage && globalThis.localStorage.getItem('supabase.gotrue-js.locks.debug') === 'true')
};
class $031357f45f79c67e$export$23e9464cc010dff9 extends Error {
    constructor(message){
        super(message);
        this.isAcquireTimeout = true;
    }
}
class $031357f45f79c67e$export$4aa56776043a4631 extends $031357f45f79c67e$export$23e9464cc010dff9 {
}
class $031357f45f79c67e$export$4b982ee840d3d915 extends $031357f45f79c67e$export$23e9464cc010dff9 {
}
async function $031357f45f79c67e$export$f4ff21938fb7af3c(name, acquireTimeout, fn) {
    if ($031357f45f79c67e$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: acquire lock', name, acquireTimeout);
    const abortController = new globalThis.AbortController();
    let acquireTimeoutTimer;
    if (acquireTimeout > 0) acquireTimeoutTimer = setTimeout(()=>{
        abortController.abort();
        if ($031357f45f79c67e$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock acquire timed out', name);
    }, acquireTimeout);
    // MDN article: https://developer.mozilla.org/en-US/docs/Web/API/LockManager/request
    // Wrapping navigator.locks.request() with a plain Promise is done as some
    // libraries like zone.js patch the Promise object to track the execution
    // context. However, it appears that most browsers use an internal promise
    // implementation when using the navigator.locks.request() API causing them
    // to lose context and emit confusing log messages or break certain features.
    // This wrapping is believed to help zone.js track the execution context
    // better.
    await Promise.resolve();
    try {
        return await globalThis.navigator.locks.request(name, acquireTimeout === 0 ? {
            mode: 'exclusive',
            ifAvailable: true
        } : {
            mode: 'exclusive',
            signal: abortController.signal
        }, async (lock)=>{
            if (lock) {
                // Lock acquired — cancel the acquire-timeout timer so it cannot fire
                // while fn() is running. Without this, a delayed timeout abort would
                // set signal.aborted = true even though we already hold the lock,
                // causing a subsequent steal to be misclassified as "our timeout
                // fired" and triggering a spurious steal-back cascade.
                clearTimeout(acquireTimeoutTimer);
                if ($031357f45f79c67e$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: acquired', name, lock.name);
                try {
                    return await fn();
                } finally{
                    if ($031357f45f79c67e$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: released', name, lock.name);
                }
            } else if (acquireTimeout === 0) {
                if ($031357f45f79c67e$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: not immediately available', name);
                throw new $031357f45f79c67e$export$4aa56776043a4631(`Acquiring an exclusive Navigator LockManager lock "${name}" immediately failed`);
            } else {
                if ($031357f45f79c67e$export$e368aba7747330f2.debug) try {
                    const result = await globalThis.navigator.locks.query();
                    console.log('@supabase/gotrue-js: Navigator LockManager state', JSON.stringify(result, null, '  '));
                } catch (e) {
                    console.warn('@supabase/gotrue-js: Error when querying Navigator LockManager state', e);
                }
                // Browser is not following the Navigator LockManager spec, it
                // returned a null lock when we didn't use ifAvailable. So we can
                // pretend the lock is acquired in the name of backward compatibility
                // and user experience and just run the function.
                console.warn('@supabase/gotrue-js: Navigator LockManager returned a null lock when using #request without ifAvailable set to true, it appears this browser is not following the LockManager spec https://developer.mozilla.org/en-US/docs/Web/API/LockManager/request');
                clearTimeout(acquireTimeoutTimer);
                return await fn();
            }
        });
    } catch (e) {
        // Always clear the acquire timeout once the request settles, so it cannot
        // fire later and incorrectly abort/log after a rejection.
        if (acquireTimeout > 0) clearTimeout(acquireTimeoutTimer);
        // DOMException does not extend Error in Node.js, so use structural check
        if (e !== null && typeof e === 'object' && 'name' in e && e.name === 'AbortError' && acquireTimeout > 0) {
            if (abortController.signal.aborted) {
                // OUR timeout fired — the lock is genuinely orphaned. Steal it.
                //
                // The lock acquisition was aborted because the timeout fired while the
                // request was still pending. This typically means another lock holder is
                // not releasing the lock, possibly due to React Strict Mode's
                // double-mount/unmount behavior or a component unmounting mid-operation,
                // leaving an orphaned lock.
                //
                // Recovery: use { steal: true } to forcefully acquire the lock. Per the
                // Web Locks API spec, this releases any currently held lock with the same
                // name and grants the request immediately, preempting any queued requests.
                // The previous holder's callback continues running to completion but no
                // longer holds the lock for exclusion purposes.
                //
                // See: https://github.com/supabase/supabase/issues/42505
                if ($031357f45f79c67e$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: acquire timeout, recovering by stealing lock', name);
                console.warn(`@supabase/gotrue-js: Lock "${name}" was not released within ${acquireTimeout}ms. ` + 'This may indicate an orphaned lock from a component unmount (e.g., React Strict Mode). ' + 'Forcefully acquiring the lock to recover.');
                return await Promise.resolve().then(()=>globalThis.navigator.locks.request(name, {
                        mode: 'exclusive',
                        steal: true
                    }, async (lock)=>{
                        if (lock) {
                            if ($031357f45f79c67e$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: recovered (stolen)', name, lock.name);
                            try {
                                return await fn();
                            } finally{
                                if ($031357f45f79c67e$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: released (stolen)', name, lock.name);
                            }
                        } else {
                            // This should not happen with steal: true, but handle gracefully.
                            console.warn('@supabase/gotrue-js: Navigator LockManager returned null lock even with steal: true');
                            return await fn();
                        }
                    }));
            } else {
                // We HELD the lock but another request stole it from us.
                // Per the Web Locks spec, our fn() callback is still running as an
                // orphaned background task — do NOT steal back. Stealing back would
                // cause a cascade (A steals B, B steals A, ...) and run fn() a second
                // time concurrently, corrupting auth state.
                // Convert to a typed error so callers (e.g. _autoRefreshTokenTick)
                // can handle/filter it without it leaking to Sentry as a raw AbortError.
                if ($031357f45f79c67e$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: lock was stolen by another request', name);
                throw new $031357f45f79c67e$export$4aa56776043a4631(`Lock "${name}" was released because another request stole it`);
            }
        }
        throw e;
    }
}
const $031357f45f79c67e$var$PROCESS_LOCKS = {};
async function $031357f45f79c67e$export$b21ec9b2268372c7(name, acquireTimeout, fn) {
    var _a;
    const previousOperation = (_a = $031357f45f79c67e$var$PROCESS_LOCKS[name]) !== null && _a !== void 0 ? _a : Promise.resolve();
    // Wrap previousOperation to handle errors without using .catch()
    // This avoids Firefox content script security errors
    const previousOperationHandled = (async ()=>{
        try {
            await previousOperation;
            return null;
        } catch (e) {
            // ignore error of previous operation that we're waiting to finish
            return null;
        }
    })();
    const currentOperation = (async ()=>{
        let timeoutId = null;
        try {
            // Wait for either previous operation or timeout
            const timeoutPromise = acquireTimeout >= 0 ? new Promise((_, reject)=>{
                timeoutId = setTimeout(()=>{
                    console.warn(`@supabase/gotrue-js: Lock "${name}" acquisition timed out after ${acquireTimeout}ms. ` + 'This may be caused by another operation holding the lock. ' + 'Consider increasing lockAcquireTimeout or checking for stuck operations.');
                    reject(new $031357f45f79c67e$export$4b982ee840d3d915(`Acquiring process lock with name "${name}" timed out`));
                }, acquireTimeout);
            }) : null;
            await Promise.race([
                previousOperationHandled,
                timeoutPromise
            ].filter((x)=>x));
            // If we reach here, previousOperationHandled won the race
            // Clear the timeout to prevent false warnings
            if (timeoutId !== null) clearTimeout(timeoutId);
        } catch (e) {
            // Clear the timeout on error path as well
            if (timeoutId !== null) clearTimeout(timeoutId);
            // Re-throw timeout errors, ignore others
            if (e instanceof $031357f45f79c67e$export$23e9464cc010dff9) throw e;
        // Fall through to run fn() - previous operation finished with error
        }
        // Previous operations finished and we didn't get a race on the acquire
        // timeout, so the current operation can finally start
        return await fn();
    })();
    $031357f45f79c67e$var$PROCESS_LOCKS[name] = (async ()=>{
        try {
            return await currentOperation;
        } catch (e) {
            if (e instanceof $031357f45f79c67e$export$23e9464cc010dff9) {
                // if the current operation timed out, it doesn't mean that the previous
                // operation finished, so we need continue waiting for it to finish
                try {
                    await previousOperation;
                } catch (prevError) {
                // Ignore previous operation errors
                }
                return null;
            }
            throw e;
        }
    })();
    // finally wait for the current operation to finish successfully, with an
    // error or with an acquire timeout error
    return await currentOperation;
}

});

parcelRegister("8WDEC", function(module, exports) {

$parcel$export(module.exports, "polyfillGlobalThis", () => $68327ffe4e2befb5$export$ad067ce270531206);
/**
 * https://mathiasbynens.be/notes/globalthis
 */ function $68327ffe4e2befb5$export$ad067ce270531206() {
    if (typeof globalThis === 'object') return;
    try {
        Object.defineProperty(Object.prototype, '__magic__', {
            get: function() {
                return this;
            },
            configurable: true
        });
        // @ts-expect-error 'Allow access to magic'
        __magic__.globalThis = __magic__;
        // @ts-expect-error 'Allow access to magic'
        delete Object.prototype.__magic__;
    } catch (e) {
        if (typeof self !== 'undefined') // @ts-expect-error 'Allow access to globals'
        self.globalThis = self;
    }
}

});

parcelRegister("baxuF", function(module, exports) {

$parcel$export(module.exports, "getAddress", () => $821a9c05c0953df2$export$88411125f012957a);
$parcel$export(module.exports, "fromHex", () => $821a9c05c0953df2$export$1a8ceedbd5845648);
$parcel$export(module.exports, "toHex", () => $821a9c05c0953df2$export$7ea66e3774a60b67);
$parcel$export(module.exports, "createSiweMessage", () => $821a9c05c0953df2$export$7ee2e5fde403d4c8);
// types and functions copied over from viem so this library doesn't depend on it
function $821a9c05c0953df2$export$88411125f012957a(address) {
    if (!/^0x[a-fA-F0-9]{40}$/.test(address)) throw new Error(`@supabase/auth-js: Address "${address}" is invalid.`);
    return address.toLowerCase();
}
function $821a9c05c0953df2$export$1a8ceedbd5845648(hex) {
    return parseInt(hex, 16);
}
function $821a9c05c0953df2$export$7ea66e3774a60b67(value) {
    const bytes = new TextEncoder().encode(value);
    const hex = Array.from(bytes, (byte)=>byte.toString(16).padStart(2, '0')).join('');
    return '0x' + hex;
}
function $821a9c05c0953df2$export$7ee2e5fde403d4c8(parameters) {
    var _a;
    const { chainId: chainId, domain: domain, expirationTime: expirationTime, issuedAt: issuedAt = new Date(), nonce: nonce, notBefore: notBefore, requestId: requestId, resources: resources, scheme: scheme, uri: uri, version: version } = parameters;
    if (!Number.isInteger(chainId)) throw new Error(`@supabase/auth-js: Invalid SIWE message field "chainId". Chain ID must be a EIP-155 chain ID. Provided value: ${chainId}`);
    if (!domain) throw new Error(`@supabase/auth-js: Invalid SIWE message field "domain". Domain must be provided.`);
    if (nonce && nonce.length < 8) throw new Error(`@supabase/auth-js: Invalid SIWE message field "nonce". Nonce must be at least 8 characters. Provided value: ${nonce}`);
    if (!uri) throw new Error(`@supabase/auth-js: Invalid SIWE message field "uri". URI must be provided.`);
    if (version !== '1') throw new Error(`@supabase/auth-js: Invalid SIWE message field "version". Version must be '1'. Provided value: ${version}`);
    if ((_a = parameters.statement) === null || _a === void 0 ? void 0 : _a.includes('\n')) throw new Error(`@supabase/auth-js: Invalid SIWE message field "statement". Statement must not include '\\n'. Provided value: ${parameters.statement}`);
    // Construct message
    const address = $821a9c05c0953df2$export$88411125f012957a(parameters.address);
    const origin = scheme ? `${scheme}://${domain}` : domain;
    const statement = parameters.statement ? `${parameters.statement}\n` : '';
    const prefix = `${origin} wants you to sign in with your Ethereum account:\n${address}\n\n${statement}`;
    let suffix = `URI: ${uri}\nVersion: ${version}\nChain ID: ${chainId}${nonce ? `\nNonce: ${nonce}` : ''}\nIssued At: ${issuedAt.toISOString()}`;
    if (expirationTime) suffix += `\nExpiration Time: ${expirationTime.toISOString()}`;
    if (notBefore) suffix += `\nNot Before: ${notBefore.toISOString()}`;
    if (requestId) suffix += `\nRequest ID: ${requestId}`;
    if (resources) {
        let content = '\nResources:';
        for (const resource of resources){
            if (!resource || typeof resource !== 'string') throw new Error(`@supabase/auth-js: Invalid SIWE message field "resources". Every resource must be a valid string. Provided value: ${resource}`);
            content += `\n- ${resource}`;
        }
        suffix += content;
    }
    return `${prefix}\n${suffix}`;
}

});

parcelRegister("2GmzD", function(module, exports) {

$parcel$export(module.exports, "webAuthnAbortService", () => $1f4103b2c99735be$export$4109de07ec7c8bef);
$parcel$export(module.exports, "deserializeCredentialCreationOptions", () => $1f4103b2c99735be$export$d02e6c69c68605f0);
$parcel$export(module.exports, "deserializeCredentialRequestOptions", () => $1f4103b2c99735be$export$943ff00a541d1017);
$parcel$export(module.exports, "serializeCredentialCreationResponse", () => $1f4103b2c99735be$export$4b534f6222f6d585);
$parcel$export(module.exports, "serializeCredentialRequestResponse", () => $1f4103b2c99735be$export$b3350da6d3acaa5a);
$parcel$export(module.exports, "isValidDomain", () => $1f4103b2c99735be$export$59e759560deddc3c);
$parcel$export(module.exports, "browserSupportsWebAuthn", () => $1f4103b2c99735be$export$21f8045e1be8a25d);
$parcel$export(module.exports, "createCredential", () => $1f4103b2c99735be$export$e4658562cd85d5e4);
$parcel$export(module.exports, "getCredential", () => $1f4103b2c99735be$export$298c59008c641b3e);
$parcel$export(module.exports, "WebAuthnApi", () => $1f4103b2c99735be$export$23264e48ebb7dee0);

var $7WQrb = parcelRequire("7WQrb");

var $iSR6L = parcelRequire("iSR6L");

var $fTIQY = parcelRequire("fTIQY");

var $98hXt = parcelRequire("98hXt");

var $3SAvc = parcelRequire("3SAvc");
class $1f4103b2c99735be$export$442ada5d34ca6e87 {
    /**
     * Create an abort signal for a new WebAuthn operation.
     * Automatically cancels any existing operation.
     *
     * @returns {AbortSignal} Signal to pass to navigator.credentials.create() or .get()
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/AbortSignal MDN - AbortSignal}
     */ createNewAbortSignal() {
        // Abort any existing calls to navigator.credentials.create() or navigator.credentials.get()
        if (this.controller) {
            const abortError = new Error('Cancelling existing WebAuthn API call for new one');
            abortError.name = 'AbortError';
            this.controller.abort(abortError);
        }
        const newController = new AbortController();
        this.controller = newController;
        return newController.signal;
    }
    /**
     * Manually cancel the current WebAuthn operation.
     * Useful for cleaning up when user cancels or navigates away.
     *
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/AbortController/abort MDN - AbortController.abort}
     */ cancelCeremony() {
        if (this.controller) {
            const abortError = new Error('Manually cancelling existing WebAuthn API call');
            abortError.name = 'AbortError';
            this.controller.abort(abortError);
            this.controller = undefined;
        }
    }
}
const $1f4103b2c99735be$export$4109de07ec7c8bef = new $1f4103b2c99735be$export$442ada5d34ca6e87();
function $1f4103b2c99735be$export$d02e6c69c68605f0(options) {
    if (!options) throw new Error('Credential creation options are required');
    // Check if the native parseCreationOptionsFromJSON method is available
    if (typeof PublicKeyCredential !== 'undefined' && 'parseCreationOptionsFromJSON' in PublicKeyCredential && typeof PublicKeyCredential.parseCreationOptionsFromJSON === 'function') // Use the native WebAuthn Level 3 method
    return PublicKeyCredential.parseCreationOptionsFromJSON(/** we assert the options here as typescript still doesn't know about future webauthn types */ options);
    // Fallback to manual parsing for browsers that don't support the native method
    // Destructure to separate fields that need transformation
    const { challenge: challengeStr, user: userOpts, excludeCredentials: excludeCredentials } = options, restOptions = (0, $7WQrb.__rest)(options, [
        "challenge",
        "user",
        "excludeCredentials"
    ]);
    // Convert challenge from base64url to ArrayBuffer
    const challenge = (0, $iSR6L.base64UrlToUint8Array)(challengeStr).buffer;
    // Convert user.id from base64url to ArrayBuffer
    const user = Object.assign(Object.assign({}, userOpts), {
        id: (0, $iSR6L.base64UrlToUint8Array)(userOpts.id).buffer
    });
    // Build the result object
    const result = Object.assign(Object.assign({}, restOptions), {
        challenge: challenge,
        user: user
    });
    // Only add excludeCredentials if it exists
    if (excludeCredentials && excludeCredentials.length > 0) {
        result.excludeCredentials = new Array(excludeCredentials.length);
        for(let i = 0; i < excludeCredentials.length; i++){
            const cred = excludeCredentials[i];
            result.excludeCredentials[i] = Object.assign(Object.assign({}, cred), {
                id: (0, $iSR6L.base64UrlToUint8Array)(cred.id).buffer,
                type: cred.type || 'public-key',
                // Cast transports to handle future transport types like "cable"
                transports: cred.transports
            });
        }
    }
    return result;
}
function $1f4103b2c99735be$export$943ff00a541d1017(options) {
    if (!options) throw new Error('Credential request options are required');
    // Check if the native parseRequestOptionsFromJSON method is available
    if (typeof PublicKeyCredential !== 'undefined' && 'parseRequestOptionsFromJSON' in PublicKeyCredential && typeof PublicKeyCredential.parseRequestOptionsFromJSON === 'function') // Use the native WebAuthn Level 3 method
    return PublicKeyCredential.parseRequestOptionsFromJSON(options);
    // Fallback to manual parsing for browsers that don't support the native method
    // Destructure to separate fields that need transformation
    const { challenge: challengeStr, allowCredentials: allowCredentials } = options, restOptions = (0, $7WQrb.__rest)(options, [
        "challenge",
        "allowCredentials"
    ]);
    // Convert challenge from base64url to ArrayBuffer
    const challenge = (0, $iSR6L.base64UrlToUint8Array)(challengeStr).buffer;
    // Build the result object
    const result = Object.assign(Object.assign({}, restOptions), {
        challenge: challenge
    });
    // Only add allowCredentials if it exists
    if (allowCredentials && allowCredentials.length > 0) {
        result.allowCredentials = new Array(allowCredentials.length);
        for(let i = 0; i < allowCredentials.length; i++){
            const cred = allowCredentials[i];
            result.allowCredentials[i] = Object.assign(Object.assign({}, cred), {
                id: (0, $iSR6L.base64UrlToUint8Array)(cred.id).buffer,
                type: cred.type || 'public-key',
                // Cast transports to handle future transport types like "cable"
                transports: cred.transports
            });
        }
    }
    return result;
}
function $1f4103b2c99735be$export$4b534f6222f6d585(credential) {
    var _a;
    // Check if the credential instance has the toJSON method
    if ('toJSON' in credential && typeof credential.toJSON === 'function') // Use the native WebAuthn Level 3 method
    return credential.toJSON();
    const credentialWithAttachment = credential;
    return {
        id: credential.id,
        rawId: credential.id,
        response: {
            attestationObject: (0, $iSR6L.bytesToBase64URL)(new Uint8Array(credential.response.attestationObject)),
            clientDataJSON: (0, $iSR6L.bytesToBase64URL)(new Uint8Array(credential.response.clientDataJSON))
        },
        type: 'public-key',
        clientExtensionResults: credential.getClientExtensionResults(),
        // Convert null to undefined and cast to AuthenticatorAttachment type
        authenticatorAttachment: (_a = credentialWithAttachment.authenticatorAttachment) !== null && _a !== void 0 ? _a : undefined
    };
}
function $1f4103b2c99735be$export$b3350da6d3acaa5a(credential) {
    var _a;
    // Check if the credential instance has the toJSON method
    if ('toJSON' in credential && typeof credential.toJSON === 'function') // Use the native WebAuthn Level 3 method
    return credential.toJSON();
    // Fallback to manual conversion for browsers that don't support toJSON
    // Access authenticatorAttachment via type assertion to handle TypeScript version differences
    // @simplewebauthn/types includes this property but base TypeScript 4.7.4 doesn't
    const credentialWithAttachment = credential;
    const clientExtensionResults = credential.getClientExtensionResults();
    const assertionResponse = credential.response;
    return {
        id: credential.id,
        rawId: credential.id,
        response: {
            authenticatorData: (0, $iSR6L.bytesToBase64URL)(new Uint8Array(assertionResponse.authenticatorData)),
            clientDataJSON: (0, $iSR6L.bytesToBase64URL)(new Uint8Array(assertionResponse.clientDataJSON)),
            signature: (0, $iSR6L.bytesToBase64URL)(new Uint8Array(assertionResponse.signature)),
            userHandle: assertionResponse.userHandle ? (0, $iSR6L.bytesToBase64URL)(new Uint8Array(assertionResponse.userHandle)) : undefined
        },
        type: 'public-key',
        clientExtensionResults: clientExtensionResults,
        // Convert null to undefined and cast to AuthenticatorAttachment type
        authenticatorAttachment: (_a = credentialWithAttachment.authenticatorAttachment) !== null && _a !== void 0 ? _a : undefined
    };
}
function $1f4103b2c99735be$export$59e759560deddc3c(hostname) {
    return(// Consider localhost valid as well since it's okay wrt Secure Contexts
    hostname === 'localhost' || /^([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,}$/i.test(hostname));
}
function $1f4103b2c99735be$export$21f8045e1be8a25d() {
    var _a, _b;
    return !!((0, $98hXt.isBrowser)() && 'PublicKeyCredential' in window && window.PublicKeyCredential && 'credentials' in navigator && typeof ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.credentials) === null || _a === void 0 ? void 0 : _a.create) === 'function' && typeof ((_b = navigator === null || navigator === void 0 ? void 0 : navigator.credentials) === null || _b === void 0 ? void 0 : _b.get) === 'function');
}
async function $1f4103b2c99735be$export$e4658562cd85d5e4(options) {
    try {
        const response = await navigator.credentials.create(/** we assert the type here until typescript types are updated */ options);
        if (!response) return {
            data: null,
            error: new (0, $3SAvc.WebAuthnUnknownError)('Empty credential response', response)
        };
        if (!(response instanceof PublicKeyCredential)) return {
            data: null,
            error: new (0, $3SAvc.WebAuthnUnknownError)('Browser returned unexpected credential type', response)
        };
        return {
            data: response,
            error: null
        };
    } catch (err) {
        return {
            data: null,
            error: (0, $3SAvc.identifyRegistrationError)({
                error: err,
                options: options
            })
        };
    }
}
async function $1f4103b2c99735be$export$298c59008c641b3e(options) {
    try {
        const response = await navigator.credentials.get(/** we assert the type here until typescript types are updated */ options);
        if (!response) return {
            data: null,
            error: new (0, $3SAvc.WebAuthnUnknownError)('Empty credential response', response)
        };
        if (!(response instanceof PublicKeyCredential)) return {
            data: null,
            error: new (0, $3SAvc.WebAuthnUnknownError)('Browser returned unexpected credential type', response)
        };
        return {
            data: response,
            error: null
        };
    } catch (err) {
        return {
            data: null,
            error: (0, $3SAvc.identifyAuthenticationError)({
                error: err,
                options: options
            })
        };
    }
}
const $1f4103b2c99735be$export$315ccaead2259c48 = {
    hints: [
        'security-key'
    ],
    authenticatorSelection: {
        authenticatorAttachment: 'cross-platform',
        requireResidentKey: false,
        /** set to preferred because older yubikeys don't have PIN/Biometric */ userVerification: 'preferred',
        residentKey: 'discouraged'
    },
    attestation: 'direct'
};
const $1f4103b2c99735be$export$26eadd1e9f10eb21 = {
    /** set to preferred because older yubikeys don't have PIN/Biometric */ userVerification: 'preferred',
    hints: [
        'security-key'
    ],
    attestation: 'direct'
};
function $1f4103b2c99735be$var$deepMerge(...sources) {
    const isObject = (val)=>val !== null && typeof val === 'object' && !Array.isArray(val);
    const isArrayBufferLike = (val)=>val instanceof ArrayBuffer || ArrayBuffer.isView(val);
    const result = {};
    for (const source of sources){
        if (!source) continue;
        for(const key in source){
            const value = source[key];
            if (value === undefined) continue;
            if (Array.isArray(value)) // preserve array reference, including unions like AuthenticatorTransport[]
            result[key] = value;
            else if (isArrayBufferLike(value)) result[key] = value;
            else if (isObject(value)) {
                const existing = result[key];
                if (isObject(existing)) result[key] = $1f4103b2c99735be$var$deepMerge(existing, value);
                else result[key] = $1f4103b2c99735be$var$deepMerge(value);
            } else result[key] = value;
        }
    }
    return result;
}
function $1f4103b2c99735be$export$3be75f4dca600793(baseOptions, overrides) {
    return $1f4103b2c99735be$var$deepMerge($1f4103b2c99735be$export$315ccaead2259c48, baseOptions, overrides || {});
}
function $1f4103b2c99735be$export$dd12a9ca29190b76(baseOptions, overrides) {
    return $1f4103b2c99735be$var$deepMerge($1f4103b2c99735be$export$26eadd1e9f10eb21, baseOptions, overrides || {});
}
class $1f4103b2c99735be$export$23264e48ebb7dee0 {
    constructor(client){
        this.client = client;
        // Bind all methods so they can be destructured
        this.enroll = this._enroll.bind(this);
        this.challenge = this._challenge.bind(this);
        this.verify = this._verify.bind(this);
        this.authenticate = this._authenticate.bind(this);
        this.register = this._register.bind(this);
    }
    /**
     * Enroll a new WebAuthn factor.
     * Creates an unverified WebAuthn factor that must be verified with a credential.
     *
     * @experimental This method is experimental and may change in future releases
     * @param {Omit<MFAEnrollWebauthnParams, 'factorType'>} params - Enrollment parameters (friendlyName required)
     * @returns {Promise<AuthMFAEnrollWebauthnResponse>} Enrolled factor details or error
     * @see {@link https://w3c.github.io/webauthn/#sctn-registering-a-new-credential W3C WebAuthn Spec - Registering a New Credential}
     */ async _enroll(params) {
        return this.client.mfa.enroll(Object.assign(Object.assign({}, params), {
            factorType: 'webauthn'
        }));
    }
    /**
     * Challenge for WebAuthn credential creation or authentication.
     * Combines server challenge with browser credential operations.
     * Handles both registration (create) and authentication (request) flows.
     *
     * @experimental This method is experimental and may change in future releases
     * @param {MFAChallengeWebauthnParams & { friendlyName?: string; signal?: AbortSignal }} params - Challenge parameters including factorId
     * @param {Object} overrides - Allows you to override the parameters passed to navigator.credentials
     * @param {PublicKeyCredentialCreationOptionsFuture} overrides.create - Override options for credential creation
     * @param {PublicKeyCredentialRequestOptionsFuture} overrides.request - Override options for credential request
     * @returns {Promise<RequestResult>} Challenge response with credential or error
     * @see {@link https://w3c.github.io/webauthn/#sctn-credential-creation W3C WebAuthn Spec - Credential Creation}
     * @see {@link https://w3c.github.io/webauthn/#sctn-verifying-assertion W3C WebAuthn Spec - Verifying Assertion}
     */ async _challenge({ factorId: factorId, webauthn: webauthn, friendlyName: friendlyName, signal: signal }, overrides) {
        var _a;
        try {
            // Get challenge from server using the client's MFA methods
            const { data: challengeResponse, error: challengeError } = await this.client.mfa.challenge({
                factorId: factorId,
                webauthn: webauthn
            });
            if (!challengeResponse) return {
                data: null,
                error: challengeError
            };
            const abortSignal = signal !== null && signal !== void 0 ? signal : $1f4103b2c99735be$export$4109de07ec7c8bef.createNewAbortSignal();
            /** webauthn will fail if either of the name/displayname are blank */ if (challengeResponse.webauthn.type === 'create') {
                const { user: user } = challengeResponse.webauthn.credential_options.publicKey;
                if (!user.name) {
                    // Preserve original format: use friendlyName if provided, otherwise fetch fallback
                    // This maintains backward compatibility with the ${user.id}:${name} format
                    const nameToUse = friendlyName;
                    if (!nameToUse) {
                        // Only fetch user data if friendlyName is not provided (bug fix for null friendlyName)
                        const currentUser = await this.client.getUser();
                        const userData = currentUser.data.user;
                        const fallbackName = ((_a = userData === null || userData === void 0 ? void 0 : userData.user_metadata) === null || _a === void 0 ? void 0 : _a.name) || (userData === null || userData === void 0 ? void 0 : userData.email) || (userData === null || userData === void 0 ? void 0 : userData.id) || 'User';
                        user.name = `${user.id}:${fallbackName}`;
                    } else user.name = `${user.id}:${nameToUse}`;
                }
                if (!user.displayName) user.displayName = user.name;
            }
            switch(challengeResponse.webauthn.type){
                case 'create':
                    {
                        const options = $1f4103b2c99735be$export$3be75f4dca600793(challengeResponse.webauthn.credential_options.publicKey, overrides === null || overrides === void 0 ? void 0 : overrides.create);
                        const { data: data, error: error } = await $1f4103b2c99735be$export$e4658562cd85d5e4({
                            publicKey: options,
                            signal: abortSignal
                        });
                        if (data) return {
                            data: {
                                factorId: factorId,
                                challengeId: challengeResponse.id,
                                webauthn: {
                                    type: challengeResponse.webauthn.type,
                                    credential_response: data
                                }
                            },
                            error: null
                        };
                        return {
                            data: null,
                            error: error
                        };
                    }
                case 'request':
                    {
                        const options = $1f4103b2c99735be$export$dd12a9ca29190b76(challengeResponse.webauthn.credential_options.publicKey, overrides === null || overrides === void 0 ? void 0 : overrides.request);
                        const { data: data, error: error } = await $1f4103b2c99735be$export$298c59008c641b3e(Object.assign(Object.assign({}, challengeResponse.webauthn.credential_options), {
                            publicKey: options,
                            signal: abortSignal
                        }));
                        if (data) return {
                            data: {
                                factorId: factorId,
                                challengeId: challengeResponse.id,
                                webauthn: {
                                    type: challengeResponse.webauthn.type,
                                    credential_response: data
                                }
                            },
                            error: null
                        };
                        return {
                            data: null,
                            error: error
                        };
                    }
            }
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: null,
                error: error
            };
            return {
                data: null,
                error: new (0, $fTIQY.AuthUnknownError)('Unexpected error in challenge', error)
            };
        }
    }
    /**
     * Verify a WebAuthn credential with the server.
     * Completes the WebAuthn ceremony by sending the credential to the server for verification.
     *
     * @experimental This method is experimental and may change in future releases
     * @param {Object} params - Verification parameters
     * @param {string} params.challengeId - ID of the challenge being verified
     * @param {string} params.factorId - ID of the WebAuthn factor
     * @param {MFAVerifyWebauthnParams<T>['webauthn']} params.webauthn - WebAuthn credential response
     * @returns {Promise<AuthMFAVerifyResponse>} Verification result with session or error
     * @see {@link https://w3c.github.io/webauthn/#sctn-verifying-assertion W3C WebAuthn Spec - Verifying an Authentication Assertion}
     * */ async _verify({ challengeId: challengeId, factorId: factorId, webauthn: webauthn }) {
        return this.client.mfa.verify({
            factorId: factorId,
            challengeId: challengeId,
            webauthn: webauthn
        });
    }
    /**
     * Complete WebAuthn authentication flow.
     * Performs challenge and verification in a single operation for existing credentials.
     *
     * @experimental This method is experimental and may change in future releases
     * @param {Object} params - Authentication parameters
     * @param {string} params.factorId - ID of the WebAuthn factor to authenticate with
     * @param {Object} params.webauthn - WebAuthn configuration
     * @param {string} params.webauthn.rpId - Relying Party ID (defaults to current hostname)
     * @param {string[]} params.webauthn.rpOrigins - Allowed origins (defaults to current origin)
     * @param {AbortSignal} params.webauthn.signal - Optional abort signal
     * @param {PublicKeyCredentialRequestOptionsFuture} overrides - Override options for navigator.credentials.get
     * @returns {Promise<RequestResult<AuthMFAVerifyResponseData, WebAuthnError | AuthError>>} Authentication result
     * @see {@link https://w3c.github.io/webauthn/#sctn-authentication W3C WebAuthn Spec - Authentication Ceremony}
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/PublicKeyCredentialRequestOptions MDN - PublicKeyCredentialRequestOptions}
     */ async _authenticate({ factorId: factorId, webauthn: { rpId: rpId = typeof window !== 'undefined' ? window.location.hostname : undefined, rpOrigins: rpOrigins = typeof window !== 'undefined' ? [
        window.location.origin
    ] : undefined, signal: signal } = {} }, overrides) {
        if (!rpId) return {
            data: null,
            error: new (0, $fTIQY.AuthError)('rpId is required for WebAuthn authentication')
        };
        try {
            if (!$1f4103b2c99735be$export$21f8045e1be8a25d()) return {
                data: null,
                error: new (0, $fTIQY.AuthUnknownError)('Browser does not support WebAuthn', null)
            };
            // Get challenge and credential
            const { data: challengeResponse, error: challengeError } = await this.challenge({
                factorId: factorId,
                webauthn: {
                    rpId: rpId,
                    rpOrigins: rpOrigins
                },
                signal: signal
            }, {
                request: overrides
            });
            if (!challengeResponse) return {
                data: null,
                error: challengeError
            };
            const { webauthn: webauthn } = challengeResponse;
            // Verify credential
            return this._verify({
                factorId: factorId,
                challengeId: challengeResponse.challengeId,
                webauthn: {
                    type: webauthn.type,
                    rpId: rpId,
                    rpOrigins: rpOrigins,
                    credential_response: webauthn.credential_response
                }
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: null,
                error: error
            };
            return {
                data: null,
                error: new (0, $fTIQY.AuthUnknownError)('Unexpected error in authenticate', error)
            };
        }
    }
    /**
     * Complete WebAuthn registration flow.
     * Performs enrollment, challenge, and verification in a single operation for new credentials.
     *
     * @experimental This method is experimental and may change in future releases
     * @param {Object} params - Registration parameters
     * @param {string} params.friendlyName - User-friendly name for the credential
     * @param {string} params.rpId - Relying Party ID (defaults to current hostname)
     * @param {string[]} params.rpOrigins - Allowed origins (defaults to current origin)
     * @param {AbortSignal} params.signal - Optional abort signal
     * @param {PublicKeyCredentialCreationOptionsFuture} overrides - Override options for navigator.credentials.create
     * @returns {Promise<RequestResult<AuthMFAVerifyResponseData, WebAuthnError | AuthError>>} Registration result
     * @see {@link https://w3c.github.io/webauthn/#sctn-registering-a-new-credential W3C WebAuthn Spec - Registration Ceremony}
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/PublicKeyCredentialCreationOptions MDN - PublicKeyCredentialCreationOptions}
     */ async _register({ friendlyName: friendlyName, webauthn: { rpId: rpId = typeof window !== 'undefined' ? window.location.hostname : undefined, rpOrigins: rpOrigins = typeof window !== 'undefined' ? [
        window.location.origin
    ] : undefined, signal: signal } = {} }, overrides) {
        if (!rpId) return {
            data: null,
            error: new (0, $fTIQY.AuthError)('rpId is required for WebAuthn registration')
        };
        try {
            if (!$1f4103b2c99735be$export$21f8045e1be8a25d()) return {
                data: null,
                error: new (0, $fTIQY.AuthUnknownError)('Browser does not support WebAuthn', null)
            };
            // Enroll factor
            const { data: factor, error: enrollError } = await this._enroll({
                friendlyName: friendlyName
            });
            if (!factor) {
                await this.client.mfa.listFactors().then((factors)=>{
                    var _a;
                    return (_a = factors.data) === null || _a === void 0 ? void 0 : _a.all.find((v)=>v.factor_type === 'webauthn' && v.friendly_name === friendlyName && v.status !== 'unverified');
                }).then((factor)=>factor ? this.client.mfa.unenroll({
                        factorId: factor === null || factor === void 0 ? void 0 : factor.id
                    }) : void 0);
                return {
                    data: null,
                    error: enrollError
                };
            }
            // Get challenge and create credential
            const { data: challengeResponse, error: challengeError } = await this._challenge({
                factorId: factor.id,
                friendlyName: factor.friendly_name,
                webauthn: {
                    rpId: rpId,
                    rpOrigins: rpOrigins
                },
                signal: signal
            }, {
                create: overrides
            });
            if (!challengeResponse) return {
                data: null,
                error: challengeError
            };
            return this._verify({
                factorId: factor.id,
                challengeId: challengeResponse.challengeId,
                webauthn: {
                    rpId: rpId,
                    rpOrigins: rpOrigins,
                    type: challengeResponse.webauthn.type,
                    credential_response: challengeResponse.webauthn.credential_response
                }
            });
        } catch (error) {
            if ((0, $fTIQY.isAuthError)(error)) return {
                data: null,
                error: error
            };
            return {
                data: null,
                error: new (0, $fTIQY.AuthUnknownError)('Unexpected error in register', error)
            };
        }
    }
}

});
parcelRegister("3SAvc", function(module, exports) {

$parcel$export(module.exports, "WebAuthnUnknownError", () => $2d32bad54faaeecf$export$2799e3b911935b0d);
$parcel$export(module.exports, "identifyRegistrationError", () => $2d32bad54faaeecf$export$1c18a773f8a28a92);
$parcel$export(module.exports, "identifyAuthenticationError", () => $2d32bad54faaeecf$export$9b62fd498befe529);
/* eslint-disable @typescript-eslint/ban-ts-comment */ 
var $2GmzD = parcelRequire("2GmzD");
class $2d32bad54faaeecf$export$90f0c14a652de832 extends Error {
    constructor({ message: message, code: code, cause: cause, name: name }){
        var _a;
        // @ts-ignore: help Rollup understand that `cause` is okay to set
        super(message, {
            cause: cause
        });
        this.__isWebAuthnError = true;
        this.name = (_a = name !== null && name !== void 0 ? name : cause instanceof Error ? cause.name : undefined) !== null && _a !== void 0 ? _a : 'Unknown Error';
        this.code = code;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            code: this.code
        };
    }
}
class $2d32bad54faaeecf$export$2799e3b911935b0d extends $2d32bad54faaeecf$export$90f0c14a652de832 {
    constructor(message, originalError){
        super({
            code: 'ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY',
            cause: originalError,
            message: message
        });
        this.name = 'WebAuthnUnknownError';
        this.originalError = originalError;
    }
}
function $2d32bad54faaeecf$export$8596540875e19045(error) {
    return typeof error === 'object' && error !== null && '__isWebAuthnError' in error;
}
function $2d32bad54faaeecf$export$1c18a773f8a28a92({ error: error, options: options }) {
    var _a, _b, _c;
    const { publicKey: publicKey } = options;
    if (!publicKey) throw Error('options was missing required publicKey property');
    if (error.name === 'AbortError') {
        if (options.signal instanceof AbortSignal) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 16)
        return new $2d32bad54faaeecf$export$90f0c14a652de832({
            message: 'Registration ceremony was sent an abort signal',
            code: 'ERROR_CEREMONY_ABORTED',
            cause: error
        });
    } else if (error.name === 'ConstraintError') {
        if (((_a = publicKey.authenticatorSelection) === null || _a === void 0 ? void 0 : _a.requireResidentKey) === true) // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 4)
        return new $2d32bad54faaeecf$export$90f0c14a652de832({
            message: 'Discoverable credentials were required but no available authenticator supported it',
            code: 'ERROR_AUTHENTICATOR_MISSING_DISCOVERABLE_CREDENTIAL_SUPPORT',
            cause: error
        });
        else if (// @ts-ignore: `mediation` doesn't yet exist on CredentialCreationOptions but it's possible as of Sept 2024
        options.mediation === 'conditional' && ((_b = publicKey.authenticatorSelection) === null || _b === void 0 ? void 0 : _b.userVerification) === 'required') // https://w3c.github.io/webauthn/#sctn-createCredential (Step 22.4)
        return new $2d32bad54faaeecf$export$90f0c14a652de832({
            message: 'User verification was required during automatic registration but it could not be performed',
            code: 'ERROR_AUTO_REGISTER_USER_VERIFICATION_FAILURE',
            cause: error
        });
        else if (((_c = publicKey.authenticatorSelection) === null || _c === void 0 ? void 0 : _c.userVerification) === 'required') // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 5)
        return new $2d32bad54faaeecf$export$90f0c14a652de832({
            message: 'User verification was required but no available authenticator supported it',
            code: 'ERROR_AUTHENTICATOR_MISSING_USER_VERIFICATION_SUPPORT',
            cause: error
        });
    } else if (error.name === 'InvalidStateError') // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 20)
    // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 3)
    return new $2d32bad54faaeecf$export$90f0c14a652de832({
        message: 'The authenticator was previously registered',
        code: 'ERROR_AUTHENTICATOR_PREVIOUSLY_REGISTERED',
        cause: error
    });
    else if (error.name === 'NotAllowedError') /**
         * Pass the error directly through. Platforms are overloading this error beyond what the spec
         * defines and we don't want to overwrite potentially useful error messages.
         */ return new $2d32bad54faaeecf$export$90f0c14a652de832({
        message: error.message,
        code: 'ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY',
        cause: error
    });
    else if (error.name === 'NotSupportedError') {
        const validPubKeyCredParams = publicKey.pubKeyCredParams.filter((param)=>param.type === 'public-key');
        if (validPubKeyCredParams.length === 0) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 10)
        return new $2d32bad54faaeecf$export$90f0c14a652de832({
            message: 'No entry in pubKeyCredParams was of type "public-key"',
            code: 'ERROR_MALFORMED_PUBKEYCREDPARAMS',
            cause: error
        });
        // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 2)
        return new $2d32bad54faaeecf$export$90f0c14a652de832({
            message: 'No available authenticator supported any of the specified pubKeyCredParams algorithms',
            code: 'ERROR_AUTHENTICATOR_NO_SUPPORTED_PUBKEYCREDPARAMS_ALG',
            cause: error
        });
    } else if (error.name === 'SecurityError') {
        const effectiveDomain = window.location.hostname;
        if (!(0, $2GmzD.isValidDomain)(effectiveDomain)) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 7)
        return new $2d32bad54faaeecf$export$90f0c14a652de832({
            message: `${window.location.hostname} is an invalid domain`,
            code: 'ERROR_INVALID_DOMAIN',
            cause: error
        });
        else if (publicKey.rp.id !== effectiveDomain) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 8)
        return new $2d32bad54faaeecf$export$90f0c14a652de832({
            message: `The RP ID "${publicKey.rp.id}" is invalid for this domain`,
            code: 'ERROR_INVALID_RP_ID',
            cause: error
        });
    } else if (error.name === 'TypeError') {
        if (publicKey.user.id.byteLength < 1 || publicKey.user.id.byteLength > 64) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 5)
        return new $2d32bad54faaeecf$export$90f0c14a652de832({
            message: 'User ID was not between 1 and 64 characters',
            code: 'ERROR_INVALID_USER_ID_LENGTH',
            cause: error
        });
    } else if (error.name === 'UnknownError') // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 1)
    // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 8)
    return new $2d32bad54faaeecf$export$90f0c14a652de832({
        message: 'The authenticator was unable to process the specified options, or could not create a new credential',
        code: 'ERROR_AUTHENTICATOR_GENERAL_ERROR',
        cause: error
    });
    return new $2d32bad54faaeecf$export$90f0c14a652de832({
        message: 'a Non-Webauthn related error has occurred',
        code: 'ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY',
        cause: error
    });
}
function $2d32bad54faaeecf$export$9b62fd498befe529({ error: error, options: options }) {
    const { publicKey: publicKey } = options;
    if (!publicKey) throw Error('options was missing required publicKey property');
    if (error.name === 'AbortError') {
        if (options.signal instanceof AbortSignal) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 16)
        return new $2d32bad54faaeecf$export$90f0c14a652de832({
            message: 'Authentication ceremony was sent an abort signal',
            code: 'ERROR_CEREMONY_ABORTED',
            cause: error
        });
    } else if (error.name === 'NotAllowedError') /**
         * Pass the error directly through. Platforms are overloading this error beyond what the spec
         * defines and we don't want to overwrite potentially useful error messages.
         */ return new $2d32bad54faaeecf$export$90f0c14a652de832({
        message: error.message,
        code: 'ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY',
        cause: error
    });
    else if (error.name === 'SecurityError') {
        const effectiveDomain = window.location.hostname;
        if (!(0, $2GmzD.isValidDomain)(effectiveDomain)) // https://www.w3.org/TR/webauthn-2/#sctn-discover-from-external-source (Step 5)
        return new $2d32bad54faaeecf$export$90f0c14a652de832({
            message: `${window.location.hostname} is an invalid domain`,
            code: 'ERROR_INVALID_DOMAIN',
            cause: error
        });
        else if (publicKey.rpId !== effectiveDomain) // https://www.w3.org/TR/webauthn-2/#sctn-discover-from-external-source (Step 6)
        return new $2d32bad54faaeecf$export$90f0c14a652de832({
            message: `The RP ID "${publicKey.rpId}" is invalid for this domain`,
            code: 'ERROR_INVALID_RP_ID',
            cause: error
        });
    } else if (error.name === 'UnknownError') // https://www.w3.org/TR/webauthn-2/#sctn-op-get-assertion (Step 1)
    // https://www.w3.org/TR/webauthn-2/#sctn-op-get-assertion (Step 12)
    return new $2d32bad54faaeecf$export$90f0c14a652de832({
        message: 'The authenticator was unable to process the specified options, or could not create a new assertion signature',
        code: 'ERROR_AUTHENTICATOR_GENERAL_ERROR',
        cause: error
    });
    return new $2d32bad54faaeecf$export$90f0c14a652de832({
        message: 'a Non-Webauthn related error has occurred',
        code: 'ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY',
        cause: error
    });
}

});



parcelRegister("fCilG", function(module, exports) {

var $f8esb = parcelRequire("f8esb");
const $b5e8a3473c3df521$var$AuthAdminApi = (0, $f8esb.default);
var $b5e8a3473c3df521$export$2e2bcd8739ae039 = $b5e8a3473c3df521$var$AuthAdminApi;

});

parcelRegister("aALRH", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b62653534e595bb$export$2e2bcd8739ae039);

var $b083j = parcelRequire("b083j");
const $7b62653534e595bb$var$AuthClient = (0, $b083j.default);
var $7b62653534e595bb$export$2e2bcd8739ae039 = $7b62653534e595bb$var$AuthClient;

});




parcelRegister("qBiAs", function(module, exports) {

$parcel$export(module.exports, "buildRegistryConfig", () => $04ff5c95d8a31c8d$export$70d30fa16d465160);
$parcel$export(module.exports, "createAppConfig", () => $04ff5c95d8a31c8d$export$d9426a7c8974f43f);
// Project-config helpers + registry factory. Project-specific
// (governance, financials) defaults live in the consumer app —
// @symbo.ls/sdk-bridge-governance for the Symbols intranet, your own
// package for any other deployment. This module only handles the shape:
// take a list of project descriptors with optional fallbacks, read env
// vars by convention, return the populated registry.
const $04ff5c95d8a31c8d$var$env = (key)=>{
    try {
        return '';
    } catch  {
        return '';
    }
};
function $04ff5c95d8a31c8d$export$2660bed806005c66(key, opts = {}) {
    const envPrefix = opts.envPrefix || 'SYMBOLS_APP';
    const prefix = `${envPrefix}_${key.toUpperCase()}_SUPABASE`;
    const url = $04ff5c95d8a31c8d$var$env(`${prefix}_URL`) || opts.fallback?.url || '';
    const anonKey = $04ff5c95d8a31c8d$var$env(`${prefix}_ANON_KEY`) || opts.fallback?.anonKey || '';
    const anonJwt = $04ff5c95d8a31c8d$var$env(`${prefix}_ANON_JWT`) || opts.fallback?.anonJwt || anonKey;
    const bridgeUrl = $04ff5c95d8a31c8d$var$env(`${prefix}_BRIDGE_URL`) || (url ? `${url}/functions/v1/symbols-auth-bridge` : '');
    if (!url || !anonKey) return null;
    return {
        key: key,
        url: url,
        anonKey: anonKey,
        anonJwt: anonJwt,
        bridgeUrl: bridgeUrl,
        required: opts.required,
        accessTokenTTL: opts.accessTokenTTL ?? 600,
        refreshTokenTTL: opts.refreshTokenTTL ?? 86400,
        roleGate: opts.roleGate || null,
        // Predicate — evaluated AFTER required projects finish. If returns
        // false, this extension's bridge is never called. Default true.
        shouldActivate: opts.shouldActivate || (()=>true)
    };
}
function $04ff5c95d8a31c8d$export$70d30fa16d465160(descriptors = []) {
    const out = {};
    for (const d of descriptors){
        if (!d || !d.key) continue;
        const cfg = $04ff5c95d8a31c8d$export$2660bed806005c66(d.key, d.opts || {});
        if (cfg) out[d.key] = cfg;
    }
    return out;
}
function $04ff5c95d8a31c8d$export$d9426a7c8974f43f(registryGetter) {
    let _override = null;
    const configure = ({ required: required, optional: optional } = {})=>{
        _override = {
            required: Array.isArray(required) ? [
                ...required
            ] : null,
            optional: Array.isArray(optional) ? [
                ...optional
            ] : null
        };
    };
    const get = ()=>{
        if (_override) return _override;
        const reg = registryGetter();
        const required = [];
        const optional = [];
        for (const [key, cfg] of Object.entries(reg))if (cfg.required) required.push(key);
        else optional.push(key);
        return {
            required: required,
            optional: optional
        };
    };
    return {
        configure: configure,
        get: get
    };
}

});

parcelRegister("9COKG", function(module, exports) {

$parcel$export(module.exports, "createAuthBridge", () => $701f07ef2f6fbcf0$export$1885dd75350c811e);
// Supabase auth federation: one user credentials → N Supabase sessions.
// Each project's symbols-auth-bridge edge function independently verifies
// credentials against the Symbols server and mints its own session.
// The client calls every enabled bridge in parallel.
//
// Two-phase login:
//   Phase 1 — required projects. All run in parallel; all must succeed.
//             Returns merged claims.
//   Phase 2 — optional extensions. Each extension's shouldActivate(claims)
//             predicate decides whether to fire its bridge. Skipped
//             extensions are reported with status:'not-applicable' so
//             the UI can distinguish "didn't try" from "failed".
const $701f07ef2f6fbcf0$var$BRIDGE_TIMEOUT_MS = 15000;
const $701f07ef2f6fbcf0$var$projectResult = (key, status, data = null, error = null)=>({
        key: key,
        status: status,
        data: data,
        error: error
    });
const $701f07ef2f6fbcf0$var$callBridge = async (cfg, body, signal)=>{
    const res = await fetch(cfg.bridgeUrl, {
        method: 'POST',
        signal: signal,
        headers: {
            'Content-Type': 'application/json',
            apikey: cfg.anonKey,
            Authorization: `Bearer ${cfg.anonKey}`
        },
        body: JSON.stringify(body)
    });
    const json = await res.json().catch(()=>null);
    if (!res.ok || !json?.supabase?.accessToken) {
        const message = json?.error || `bridge ${cfg.key} returned ${res.status}`;
        const err = new Error(message);
        err.status = res.status;
        throw err;
    }
    return json;
};
function $701f07ef2f6fbcf0$export$1885dd75350c811e({ registry: registry, appConfig: appConfig, tokenStorageKey: tokenStorageKey = 'symbols_bridge_access_token', tokenExpiryKey: tokenExpiryKey = 'symbols_bridge_expires_at', fallbackTokenKey: fallbackTokenKey = 'symbols_access_token', bridgeTimeoutMs: bridgeTimeoutMs = $701f07ef2f6fbcf0$var$BRIDGE_TIMEOUT_MS } = {}) {
    if (!registry) throw new Error('createAuthBridge: registry required');
    if (!appConfig) throw new Error('createAuthBridge: appConfig required');
    const _setSession = async (r)=>{
        const client = registry.getClient(r.key);
        const s = r.data?.supabase;
        if (!client || !s) return;
        try {
            await client.auth.setSession({
                access_token: s.accessToken,
                refresh_token: s.refreshToken
            });
        } catch (err) {
            console.error(`[sdk-supabase-bridge] setSession failed on ${r.key}:`, err);
            r.status = 'error';
            r.error = err;
        }
        const symbolsToken = r.data?.symbols?.tokens?.accessToken;
        if (symbolsToken && typeof window !== 'undefined') try {
            window.localStorage.setItem(tokenStorageKey, symbolsToken);
            const exp = r.data?.symbols?.tokens?.expiresAt;
            if (exp) window.localStorage.setItem(tokenExpiryKey, String(exp));
        } catch  {}
    };
    const loginAll = async ({ email: email, password: password, claimsHint: claimsHint } = {})=>{
        const keys = registry.listConfiguredProjects();
        const app = appConfig.get();
        const requiredSet = new Set(app.required != null ? app.required.filter((k)=>keys.includes(k)) : keys.filter((k)=>registry.getProjectConfig(k)?.required));
        const requiredKeys = keys.filter((k)=>requiredSet.has(k));
        const extensionKeys = keys.filter((k)=>!requiredSet.has(k));
        const ac = new AbortController();
        const timer = setTimeout(()=>ac.abort(), bridgeTimeoutMs);
        const requiredSettled = await Promise.allSettled(requiredKeys.map(async (key)=>{
            const cfg = registry.getProjectConfig(key);
            try {
                const data = await $701f07ef2f6fbcf0$var$callBridge(cfg, {
                    email: email,
                    password: password
                }, ac.signal);
                return $701f07ef2f6fbcf0$var$projectResult(key, 'ok', data);
            } catch (err) {
                return $701f07ef2f6fbcf0$var$projectResult(key, 'error', null, err);
            }
        }));
        const requiredResults = requiredSettled.map((s, i)=>s.status === 'fulfilled' ? s.value : $701f07ef2f6fbcf0$var$projectResult(requiredKeys[i], 'error', null, s.reason));
        for (const r of requiredResults)if (r.status !== 'ok') {
            clearTimeout(timer);
            return {
                ok: false,
                results: requiredResults,
                error: r.error || new Error(`required project ${r.key} failed`)
            };
        }
        const mergedClaims = requiredResults.reduce((acc, r)=>({
                ...acc,
                ...r.data?.claims || {}
            }), claimsHint ? {
            ...claimsHint
        } : {});
        await Promise.all(requiredResults.map((r)=>_setSession(r)));
        const optionalFilter = app.optional != null ? new Set(app.optional) : null;
        const extensionResults = await Promise.all(extensionKeys.map(async (key)=>{
            if (optionalFilter && !optionalFilter.has(key)) return $701f07ef2f6fbcf0$var$projectResult(key, 'not-configured');
            const cfg = registry.getProjectConfig(key);
            let applicable = true;
            try {
                applicable = !!cfg.shouldActivate(mergedClaims);
            } catch  {
                applicable = false;
            }
            if (!applicable) return $701f07ef2f6fbcf0$var$projectResult(key, 'not-applicable');
            try {
                const data = await $701f07ef2f6fbcf0$var$callBridge(cfg, {
                    email: email,
                    password: password
                }, ac.signal);
                const r = $701f07ef2f6fbcf0$var$projectResult(key, 'ok', data);
                await _setSession(r);
                return r;
            } catch (err) {
                const skip = cfg.roleGate && err.status === 403;
                return $701f07ef2f6fbcf0$var$projectResult(key, skip ? 'skipped' : 'error', null, err);
            }
        }));
        clearTimeout(timer);
        return {
            ok: true,
            results: [
                ...requiredResults,
                ...extensionResults
            ],
            claims: mergedClaims
        };
    };
    const activateExtension = async (projectKey, { email: email, password: password })=>{
        const cfg = registry.getProjectConfig(projectKey);
        if (!cfg) return {
            ok: false,
            error: new Error(`unknown project ${projectKey}`)
        };
        if (cfg.required) return {
            ok: false,
            error: new Error(`${projectKey} is required, not an extension`)
        };
        const ac = new AbortController();
        const timer = setTimeout(()=>ac.abort(), bridgeTimeoutMs);
        try {
            const data = await $701f07ef2f6fbcf0$var$callBridge(cfg, {
                email: email,
                password: password
            }, ac.signal);
            const r = $701f07ef2f6fbcf0$var$projectResult(projectKey, 'ok', data);
            await _setSession(r);
            return {
                ok: true,
                result: r
            };
        } catch (err) {
            return {
                ok: false,
                error: err
            };
        } finally{
            clearTimeout(timer);
        }
    };
    const logoutAll = async ()=>{
        const promises = [];
        registry.forEachClient((client)=>promises.push(client.auth.signOut().catch(()=>null)));
        await Promise.all(promises);
        if (typeof window !== 'undefined') try {
            window.localStorage.removeItem(tokenStorageKey);
            window.localStorage.removeItem(tokenExpiryKey);
        } catch  {}
    };
    const postRefreshClaims = async (cfg, client, body)=>{
        const { data: sess } = await client.auth.getSession();
        const jwt = sess?.session?.access_token;
        if (!jwt) return {
            ok: false,
            error: new Error('no session')
        };
        const url = `${cfg.url}/functions/v1/symbols-refresh-claims`;
        const res = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                apikey: cfg.anonKey,
                Authorization: `Bearer ${jwt}`
            },
            body: JSON.stringify(body || {})
        });
        const json = await res.json().catch(()=>null);
        if (!res.ok) return {
            ok: false,
            error: new Error(json?.error || `refresh-claims ${res.status}`)
        };
        return {
            ok: true,
            data: json
        };
    };
    const switchWorkspace = async (workspaceId)=>{
        if (!workspaceId) throw new Error('workspaceId required');
        const keys = registry.listConfiguredProjects();
        const symbolsToken = getSymbolsToken();
        const body = symbolsToken ? {
            active_workspace_id: workspaceId,
            symbols_access_token: symbolsToken
        } : {
            active_workspace_id: workspaceId
        };
        const results = await Promise.all(keys.map(async (key)=>{
            const cfg = registry.getProjectConfig(key);
            const client = registry.getClient(key);
            if (!client) return {
                key: key,
                status: 'skipped'
            };
            const resp = await postRefreshClaims(cfg, client, body);
            if (!resp.ok) {
                if (!cfg.required) return {
                    key: key,
                    status: 'skipped',
                    error: resp.error
                };
                return {
                    key: key,
                    status: 'error',
                    error: resp.error
                };
            }
            try {
                await client.auth.refreshSession();
            } catch (err) {
                return {
                    key: key,
                    status: 'error',
                    error: err
                };
            }
            return {
                key: key,
                status: 'ok',
                data: resp.data
            };
        }));
        const failed = results.find((r)=>r.status === 'error');
        if (failed) return {
            ok: false,
            results: results,
            error: failed.error
        };
        return {
            ok: true,
            results: results
        };
    };
    const refreshClaims = async ()=>{
        const keys = registry.listConfiguredProjects();
        const symbolsToken = getSymbolsToken();
        const body = symbolsToken ? {
            symbols_access_token: symbolsToken
        } : {};
        await Promise.all(keys.map(async (key)=>{
            const cfg = registry.getProjectConfig(key);
            const client = registry.getClient(key);
            if (!client) return;
            await postRefreshClaims(cfg, client, body).catch(()=>null);
            try {
                await client.auth.refreshSession();
            } catch  {}
        }));
    };
    const getSymbolsToken = ()=>{
        if (typeof window === 'undefined') return null;
        try {
            return window.localStorage.getItem(tokenStorageKey) || window.localStorage.getItem(fallbackTokenKey) || null;
        } catch  {
            return null;
        }
    };
    const getSessionStatus = async ()=>{
        const out = {};
        for (const key of registry.listConfiguredProjects()){
            const client = registry.getClient(key);
            if (!client) {
                out[key] = {
                    signedIn: false
                };
                continue;
            }
            const { data: data } = await client.auth.getSession();
            out[key] = {
                signedIn: !!data?.session,
                email: data?.session?.user?.email || null,
                userId: data?.session?.user?.id || null
            };
        }
        return out;
    };
    return {
        loginAll: loginAll,
        logoutAll: logoutAll,
        activateExtension: activateExtension,
        switchWorkspace: switchWorkspace,
        refreshClaims: refreshClaims,
        getSymbolsToken: getSymbolsToken,
        getSessionStatus: getSessionStatus
    };
}

});

parcelRegister("jEfgr", function(module, exports) {

$parcel$export(module.exports, "createCrossAppAuth", () => $e4dd97e1983aba95$export$d1ee6aa85d937b48);
// Cross-app auth sync — mirror Supabase + SDK tokens into a parent-domain
// cookie so peer subdomains share a single signed-in session even though
// their localStorages are origin-isolated.
//
// `sb-<ref>-auth-token` (and chunked `.0`/`.1` siblings) contain the
// Supabase auth-js session. Mirroring them via a domain cookie lets a
// peer subdomain's Supabase client read RLS-gated rows on first paint
// without an explicit `setSession()` round-trip.
//
// SDK token keys (`symbols_*` family by default, override via `tokenKeys`)
// carry the Symbols Mongo-server access token. They're mirrored alongside.
//
// Trade-off: a cookie on `.symbols.app` is readable by every subdomain.
// Keep user-code rendering subdomains off the parent domain (use a
// separate apex like `.symbo.ls` for preview/mermaid) — otherwise
// untrusted code can read the cookie.
parcelRequire("cVasv");
var $bOdwG = parcelRequire("bOdwG");
const $e4dd97e1983aba95$export$e8c8aeb3e952a983 = [
    'symbols_access_token',
    'symbols_refresh_token',
    'symbols_expires_at',
    'symbols_expires_in',
    'symbols_bridge_access_token',
    'symbols_bridge_expires_at'
];
const $e4dd97e1983aba95$export$ef001aa7c423f822 = /^sb-[a-z0-9]+-auth-token(?:\.\d+)?$/;
const $e4dd97e1983aba95$var$COOKIE_MAX_AGE = 2592000 // 30 days
;
function $e4dd97e1983aba95$export$d1ee6aa85d937b48({ tokenKeys: tokenKeys = $e4dd97e1983aba95$export$e8c8aeb3e952a983, sessionCookieName: sessionCookieName = 'smbls_session', supabaseCookieName: supabaseCookieName = 'smbls_sb_sessions', resolvePeerOrigin: resolvePeerOrigin = null, bridgeIframePath: bridgeIframePath = '/_session-bridge' } = {}) {
    function collectLocalSession() {
        if (typeof localStorage === 'undefined') return null;
        const out = {};
        let hasAny = false;
        for (const k of tokenKeys){
            const v = localStorage.getItem(k);
            if (v != null) {
                out[k] = v;
                hasAny = true;
            }
        }
        return hasAny ? out : null;
    }
    function isFresh(session) {
        if (!session) return false;
        const exp = Number(session.symbols_expires_at || session.symbols_bridge_expires_at || 0);
        if (!exp) return true;
        return exp > Date.now();
    }
    function collectSupabaseSessions() {
        if (typeof localStorage === 'undefined') return null;
        const out = {};
        let hasAny = false;
        for (const k of Object.keys(localStorage)){
            if (!$e4dd97e1983aba95$export$ef001aa7c423f822.test(k)) continue;
            const v = localStorage.getItem(k);
            if (v != null) {
                out[k] = v;
                hasAny = true;
            }
        }
        return hasAny ? out : null;
    }
    function collectSdkTokens() {
        if (typeof localStorage === 'undefined') return null;
        const out = {};
        let hasAny = false;
        for (const k of tokenKeys){
            const v = localStorage.getItem(k);
            if (v != null) {
                out[k] = v;
                hasAny = true;
            }
        }
        return hasAny ? out : null;
    }
    function isSupabaseSessionFresh(parsed) {
        const exp = Number(parsed?.expires_at || 0);
        if (!exp) return true;
        return exp * 1000 > Date.now();
    }
    function persistSupabaseSessionsToCookie({ clearIfEmpty: clearIfEmpty = false } = {}) {
        const sessions = collectSupabaseSessions();
        if (!sessions) {
            if (clearIfEmpty) (0, $bOdwG.writeCookie)(supabaseCookieName, null, 0);
            return;
        }
        (0, $bOdwG.writeCookie)(supabaseCookieName, JSON.stringify(sessions), $e4dd97e1983aba95$var$COOKIE_MAX_AGE);
    }
    function hydrateSupabaseSessionsFromCookie() {
        if (typeof localStorage === 'undefined') return false;
        const raw = (0, $bOdwG.readCookie)(supabaseCookieName);
        if (!raw) return false;
        let parsed;
        try {
            parsed = JSON.parse(raw);
        } catch  {
            return false;
        }
        let wrote = false;
        for (const [k, v] of Object.entries(parsed || {})){
            if (!$e4dd97e1983aba95$export$ef001aa7c423f822.test(k)) continue;
            const existing = localStorage.getItem(k);
            if (existing) try {
                const local = JSON.parse(existing);
                const cookieParsed = JSON.parse(v);
                const localExp = Number(local?.expires_at || 0);
                const cookieExp = Number(cookieParsed?.expires_at || 0);
                if (localExp >= cookieExp) continue;
                if (!isSupabaseSessionFresh(cookieParsed)) continue;
            } catch  {}
            else try {
                const cookieParsed = JSON.parse(v);
                if (!isSupabaseSessionFresh(cookieParsed)) continue;
            } catch  {
                continue;
            }
            localStorage.setItem(k, v);
            wrote = true;
        }
        return wrote;
    }
    function hydrateAuthFromCookie() {
        hydrateSupabaseSessionsFromCookie();
        if (typeof localStorage === 'undefined') return false;
        const local = collectLocalSession();
        if (isFresh(local)) return false;
        const raw = (0, $bOdwG.readCookie)(sessionCookieName);
        if (!raw) return false;
        let cookieSession;
        try {
            cookieSession = JSON.parse(raw);
        } catch  {
            return false;
        }
        if (!isFresh(cookieSession)) return false;
        for (const k of tokenKeys){
            const v = cookieSession[k];
            if (v != null) localStorage.setItem(k, String(v));
        }
        if (!cookieSession.symbols_access_token && cookieSession.symbols_bridge_access_token) {
            localStorage.setItem('symbols_access_token', String(cookieSession.symbols_bridge_access_token));
            if (cookieSession.symbols_bridge_expires_at) localStorage.setItem('symbols_expires_at', String(cookieSession.symbols_bridge_expires_at));
        }
        if (!cookieSession.symbols_bridge_access_token && cookieSession.symbols_access_token) {
            localStorage.setItem('symbols_bridge_access_token', String(cookieSession.symbols_access_token));
            if (cookieSession.symbols_expires_at) localStorage.setItem('symbols_bridge_expires_at', String(cookieSession.symbols_expires_at));
        }
        return true;
    }
    function persistAuthToCookie() {
        const session = collectLocalSession();
        if (!session) {
            (0, $bOdwG.writeCookie)(sessionCookieName, null, 0);
            return;
        }
        (0, $bOdwG.writeCookie)(sessionCookieName, JSON.stringify(session), $e4dd97e1983aba95$var$COOKIE_MAX_AGE);
    }
    function clearAuthCookie() {
        (0, $bOdwG.writeCookie)(sessionCookieName, null, 0);
    }
    function hydrateAuthFromIframeBridge() {
        return new Promise((resolve)=>{
            if (typeof window === 'undefined' || typeof document === 'undefined') {
                resolve(false);
                return;
            }
            const local = collectLocalSession();
            if (isFresh(local) && collectSupabaseSessions()) {
                resolve(false);
                return;
            }
            if (typeof resolvePeerOrigin !== 'function') {
                resolve(false);
                return;
            }
            const origin = resolvePeerOrigin();
            if (!origin) {
                resolve(false);
                return;
            }
            if (window.location.origin === origin) {
                resolve(false);
                return;
            }
            const iframe = document.createElement('iframe');
            iframe.style.cssText = 'position:absolute;width:0;height:0;border:0;visibility:hidden';
            iframe.src = `${origin}${bridgeIframePath}`;
            let settled = false;
            const cleanup = (val)=>{
                if (settled) return;
                settled = true;
                window.removeEventListener('message', onMessage);
                try {
                    iframe.remove();
                } catch  {}
                resolve(val);
            };
            const onMessage = (ev)=>{
                if (ev.origin !== origin) return;
                const t = ev.data?.type;
                if (t === 'symbols-session-ready') {
                    try {
                        iframe.contentWindow?.postMessage({
                            type: 'symbols-session-request'
                        }, origin);
                    } catch  {}
                    return;
                }
                if (t !== 'symbols-session-response') return;
                if (!ev.data.ok) {
                    cleanup(false);
                    return;
                }
                const tokens = ev.data.sdkTokens || {};
                let wrote = false;
                for (const [k, v] of Object.entries(tokens))if (v != null) {
                    localStorage.setItem(k, String(v));
                    wrote = true;
                }
                if (!tokens.symbols_access_token && tokens.symbols_bridge_access_token) {
                    localStorage.setItem('symbols_access_token', String(tokens.symbols_bridge_access_token));
                    if (tokens.symbols_bridge_expires_at) localStorage.setItem('symbols_expires_at', String(tokens.symbols_bridge_expires_at));
                    wrote = true;
                }
                const sbSessions = ev.data.supabaseSessions || {};
                for (const [k, v] of Object.entries(sbSessions))if (v != null && !localStorage.getItem(k)) {
                    localStorage.setItem(k, String(v));
                    wrote = true;
                }
                cleanup(wrote);
            };
            window.addEventListener('message', onMessage);
            iframe.addEventListener('load', ()=>{
                try {
                    iframe.contentWindow?.postMessage({
                        type: 'symbols-session-request'
                    }, origin);
                } catch  {}
            });
            document.body.appendChild(iframe);
            setTimeout(()=>cleanup(false), 4000);
        });
    }
    let _installed = false;
    function installAuthSync() {
        if (_installed || typeof window === 'undefined') return;
        _installed = true;
        const origSet = localStorage.setItem.bind(localStorage);
        const origRemove = localStorage.removeItem.bind(localStorage);
        const origClear = localStorage.clear.bind(localStorage);
        let persistAuthTimer = null;
        const schedulePersistAuth = ()=>{
            if (persistAuthTimer) return;
            persistAuthTimer = setTimeout(()=>{
                persistAuthTimer = null;
                persistAuthToCookie();
            }, 200);
        };
        let persistSbTimer = null;
        const schedulePersistSupabase = (opts)=>{
            if (persistSbTimer) return;
            persistSbTimer = setTimeout(()=>{
                persistSbTimer = null;
                persistSupabaseSessionsToCookie(opts);
            }, 200);
        };
        const removeAllTokenMirrors = (keptKey)=>{
            for (const k of tokenKeys)if (k !== keptKey) origRemove(k);
        };
        localStorage.setItem = function(key, value) {
            origSet(key, value);
            if (tokenKeys.includes(key)) schedulePersistAuth();
            else if ($e4dd97e1983aba95$export$ef001aa7c423f822.test(key)) schedulePersistSupabase();
        };
        localStorage.removeItem = function(key) {
            origRemove(key);
            if ($e4dd97e1983aba95$export$ef001aa7c423f822.test(key)) schedulePersistSupabase({
                clearIfEmpty: true
            });
            else if (tokenKeys.includes(key)) {
                if (key === 'symbols_access_token' || key === 'symbols_bridge_access_token') removeAllTokenMirrors(key);
                const stillHasAny = tokenKeys.some((k)=>localStorage.getItem(k));
                if (!stillHasAny) clearAuthCookie();
                else schedulePersistAuth();
            }
        };
        localStorage.clear = function() {
            origClear();
            clearAuthCookie();
        };
        window.addEventListener('storage', (e)=>{
            if (!e.key) return;
            if (tokenKeys.includes(e.key)) schedulePersistAuth();
            else if ($e4dd97e1983aba95$export$ef001aa7c423f822.test(e.key)) schedulePersistSupabase();
        });
        document.addEventListener('visibilitychange', ()=>{
            if (document.visibilityState !== 'visible') return;
            hydrateAuthFromCookie();
            hydrateSupabaseSessionsFromCookie();
        });
        persistAuthToCookie();
        persistSupabaseSessionsToCookie();
    }
    return {
        TOKEN_KEYS: tokenKeys,
        SUPABASE_KEY_RE: $e4dd97e1983aba95$export$ef001aa7c423f822,
        collectLocalSession: collectLocalSession,
        collectSupabaseSessions: collectSupabaseSessions,
        collectSdkTokens: collectSdkTokens,
        hydrateAuthFromCookie: hydrateAuthFromCookie,
        hydrateAuthFromIframeBridge: hydrateAuthFromIframeBridge,
        persistAuthToCookie: persistAuthToCookie,
        clearAuthCookie: clearAuthCookie,
        persistSupabaseSessionsToCookie: persistSupabaseSessionsToCookie,
        hydrateSupabaseSessionsFromCookie: hydrateSupabaseSessionsFromCookie,
        installAuthSync: installAuthSync
    };
}

});



parcelRegister("ccUH0", function(module, exports) {

$parcel$export(module.exports, "workspaceApiBase", () => $024b236f956cedbb$export$703338d600e57242);
// Single source of truth for the workspace API base URL.
//
// Wraps `@symbo.ls/channels` — the canonical platform-wide channel
// registry — so every consumer that hits `/workspace/*` (SDK init in
// sdk.js, the raw Supabase passthrough in supabaseConfig.js, the
// workspace-project SDK adapter in envs.js) resolves to the same URL
// derived from a single channel name. Channels (`local`, `localNext`,
// `next`, `staging`, `upcoming`, `production`, ...) are defined in
// `server/packages/channels/channels.json`.
//
// Hostname → channel autodetection ties each deployed env to its
// matching API channel without per-bundle config:
//
//   my.localhost                  → upcoming   (active dev tier)
//   *.localhost                   → upcoming
//   dev.my.symbols.app            → development
//   next.my.symbols.app           → next
//   upcoming.my.symbols.app       → upcoming
//   test.my.symbols.app           → test
//   staging.my.symbols.app        → staging
//   my.symbols.app                → production
//
// The same prefix → channel rule applies to canvas.symbols.app,
// workspace.symbols.app, and any other shell host using the same DNS
// pattern, so env subdomains stay in lockstep across the platform.
//
// Precedence (first non-null wins):
//   1. `window.__SYMBOLS_ENV.WORKSPACE_API_URL`  — explicit URL override,
//      escape hatch for ngrok / mirrors / staging proxies.
//   2. `window.__SYMBOLS_ENV.NODE_ENV`          — channel name override.
//   3. `localStorage.symbols_workspace_api`     — explicit URL, persists.
//   4. `localStorage.symbols_api_channel`       — channel name, persists.
//   5. Hostname autodetect (table above).
//   6. `apiUrl()` from `@symbo.ls/channels`     — registry's own
//      resolution (NODE_ENV → defaultChannel).
//
// Runtime override via URL — for testing how a server PR-preview deploy
// affects the live UI without rebuilding the frontend:
//   ?apiUrl=https://pr-xyz.api.symbols.app  → store + use
//   ?apiUrl=clear                           → drop the override
// On first call we capture the param into `localStorage.symbols_workspace_api`
// so subsequent navigations keep using it without re-passing the param.
// PROD HOSTS (my.symbols.app / edit.symbols.app / preview.symbols.app)
// hard-ignore this param so a malicious link can't repoint a logged-in
// user's shell at a foreign API origin.

var $3WCJD = parcelRequire("3WCJD");
// Maps a hostname's leading subdomain to its API channel. Returns null
// when no env prefix matches → caller falls through to the channel
// registry's default (= `production`).
//
// Recognizes:
//   1. `<env>.my.symbols.app`         (apex shell host: dev/next/upcoming/test/staging)
//   2. `<env>.<other>.symbols.app`    (canvas, workspace, … — same prefix rule)
//   3. `*.localhost` / `localhost`    → `upcoming`
//
// Why `upcoming` for `*.localhost`: the legacy `localNext` channel was
// never registered in `channels.json`, so `channelApiUrl('localNext')`
// fell back to `defaultChannel` (= `production`) — every local-dev
// browser tab pointed at `api.symbols.app`, which 1) doesn't allow CORS
// from `*.localhost`, and 2) doesn't host the active dev project data.
// `upcoming.api.symbols.app` is the canonical dev tier this branch
// targets, so localhost shells now hit the correct API by default.
// Devs can still override per-tab via
// `localStorage.symbols_api_channel = 'next'` etc.
const $024b236f956cedbb$var$_hostToChannel = (host)=>{
    if (!host) return null;
    if (host === 'localhost' || host.endsWith('.localhost')) return 'upcoming';
    const labels = host.split('.');
    if (labels.length < 4) return null // bare apex `my.symbols.app`
    ;
    const prefix = labels[0];
    // `dev` channel is named `development` in the registry — alias it.
    if (prefix === 'dev') return 'development';
    if (prefix && (0, $3WCJD.isKnownChannel)(prefix)) return prefix;
    return null;
};
// Production hosts that MUST NEVER honor a runtime ?apiUrl override —
// safety guard so a malicious link can't repoint a logged-in user's
// shell at a different API origin and exfiltrate tokens.
const $024b236f956cedbb$var$_PROD_HOSTS = new Set([
    'my.symbols.app',
    'edit.symbols.app',
    'preview.symbols.app'
]);
const $024b236f956cedbb$var$_isProdHost = (host)=>$024b236f956cedbb$var$_PROD_HOSTS.has(host || '');
// Apply a `?apiUrl=...` query-param override into localStorage so the
// rest of the precedence chain (and every subsequent page load) honors
// it. Designed for testing how a server PR-preview deploy
// (e.g. https://pr-xyz.api.symbols.app) affects the live UI without
// rebuilding the frontend.
//
// Behavior:
//   ?apiUrl=https://pr-xyz.api.symbols.app  → store + use
//   ?apiUrl=clear  (or  ?apiUrl=  blank)    → remove the override
// Non-prod hosts only — prod is hard-locked.
//
// Idempotent: only applies once per page load (URL param is the trigger,
// after which the localStorage key carries the override across navs).
let $024b236f956cedbb$var$_queryApplied = false;
const $024b236f956cedbb$var$_applyQueryApiOverride = ()=>{
    if ($024b236f956cedbb$var$_queryApplied) return;
    $024b236f956cedbb$var$_queryApplied = true;
    if (typeof window === 'undefined') return;
    if ($024b236f956cedbb$var$_isProdHost(window.location.hostname)) return;
    let raw;
    try {
        raw = new URLSearchParams(window.location.search).get('apiUrl');
    } catch (_) {
        return;
    }
    if (raw == null) return;
    const trimmed = raw.trim();
    try {
        if (trimmed === '' || trimmed.toLowerCase() === 'clear') {
            window.localStorage.removeItem('symbols_workspace_api');
            return;
        }
        // Reject anything that doesn't look like an http(s) URL — guard
        // against `?apiUrl=javascript:...` or relative path injection.
        const u = new URL(trimmed);
        if (u.protocol !== 'http:' && u.protocol !== 'https:') return;
        window.localStorage.setItem('symbols_workspace_api', u.origin);
    } catch (_) {}
};
function $024b236f956cedbb$export$703338d600e57242() {
    if (typeof window === 'undefined') return (0, $3WCJD.apiUrl)();
    // First-call only — capture the ?apiUrl=... query param into LS so
    // every subsequent resolution (this call + any navigation) reads it
    // through the lsUrl branch below.
    $024b236f956cedbb$var$_applyQueryApiOverride();
    // Explicit URL override (highest precedence — direct URL beats channel).
    const runtimeUrl = window.__SYMBOLS_ENV?.WORKSPACE_API_URL;
    if (runtimeUrl) return runtimeUrl;
    // Channel name override at runtime.
    const runtimeChannel = window.__SYMBOLS_ENV?.NODE_ENV;
    if (runtimeChannel) return (0, $3WCJD.apiUrl)(runtimeChannel);
    // localStorage — explicit URL flag survives reloads.
    try {
        const lsUrl = window.localStorage.getItem('symbols_workspace_api');
        if (lsUrl) return lsUrl;
        const lsChannel = window.localStorage.getItem('symbols_api_channel');
        if (lsChannel) return (0, $3WCJD.apiUrl)(lsChannel);
    } catch (_) {}
    // Hostname autodetect — `<env>.my.symbols.app` → matching channel.
    const matched = $024b236f956cedbb$var$_hostToChannel(window.location.hostname);
    if (matched) return (0, $3WCJD.apiUrl)(matched);
    // Channel registry's own resolution — falls through to NODE_ENV →
    // defaultChannel from the channels package.
    return (0, $3WCJD.apiUrl)();
}

});

parcelRegister("ghHor", function(module, exports) {

$parcel$export(module.exports, "RAW_SUPABASE_URL", () => $bdafe4d734f7f426$export$1775ba02587be4fd);
$parcel$export(module.exports, "SUPABASE_URL", () => $bdafe4d734f7f426$export$721045acb0bbe132);
$parcel$export(module.exports, "edgeFunctionUrl", () => $bdafe4d734f7f426$export$3d498589b229a041);
$parcel$export(module.exports, "edgeFunctionHeaders", () => $bdafe4d734f7f426$export$8c55b17466d99fbd);
$parcel$export(module.exports, "governanceSessionAccessToken", () => $bdafe4d734f7f426$export$6742174a7b4553dc);
$parcel$export(module.exports, "restHeaders", () => $bdafe4d734f7f426$export$a39ea5fce0e1ecd4);
$parcel$export(module.exports, "supabaseFetchConfig", () => $bdafe4d734f7f426$export$99a473aa837010a9);
$parcel$export(module.exports, "getSupabaseRealtimeClient", () => $bdafe4d734f7f426$export$742bf6d31cf89042);
$parcel$export(module.exports, "SUPABASE_KEY", () => (parcelRequire("82gA2")).SUPABASE_KEY);
$parcel$export(module.exports, "SUPABASE_ANON_KEY", () => (parcelRequire("82gA2")).SUPABASE_ANON_KEY);
// Workspace Supabase passthrough config — thin wrapper around the
// SDK-owned helpers. Frontend code goes through `sdk.execute(entity, op,
// args)` and never sees the wrapper URL or the Supabase-vs-Mongo split.
// URL composition and the REST/realtime split live in
// `@symbo.ls/sdk/services/supabasePassthrough`.

var $3rsQg = parcelRequire("3rsQg");
parcelRequire("82gA2");
var $8RlGv = parcelRequire("8RlGv");
var $82gA2 = parcelRequire("82gA2");

var $ccUH0 = parcelRequire("ccUH0");
const $bdafe4d734f7f426$export$1775ba02587be4fd = (0, $82gA2.RAW_URL);
const $bdafe4d734f7f426$export$721045acb0bbe132 = `${(0, $ccUH0.workspaceApiBase)()}/workspace-project/sb`;
const $bdafe4d734f7f426$export$3d498589b229a041 = (name)=>(0, $3rsQg.workspaceProjectEdgeFunctionUrl)((0, $ccUH0.workspaceApiBase)(), name);
const $bdafe4d734f7f426$export$8c55b17466d99fbd = ()=>({
        Authorization: `Bearer ${0, $82gA2.SUPABASE_ANON_KEY}`
    });
const $bdafe4d734f7f426$export$6742174a7b4553dc = ()=>(0, $3rsQg.governanceSessionAccessToken)((0, $82gA2.RAW_URL));
const $bdafe4d734f7f426$export$a39ea5fce0e1ecd4 = ()=>{
    const token = $bdafe4d734f7f426$export$6742174a7b4553dc() || (0, $82gA2.SUPABASE_ANON_KEY);
    return {
        apikey: (0, $82gA2.SUPABASE_ANON_KEY),
        Authorization: `Bearer ${token}`
    };
};
const $bdafe4d734f7f426$export$99a473aa837010a9 = (0, $3rsQg.createSupabasePassthroughConfig)({
    apiBase: (0, $ccUH0.workspaceApiBase),
    rawSupabaseUrl: (0, $82gA2.RAW_URL),
    anonKey: (0, $82gA2.SUPABASE_ANON_KEY),
    getRealtimeClient: ()=>{
        if (typeof window === 'undefined') return null;
        try {
            return (0, $8RlGv.getSupabase)();
        } catch (_) {
            return null;
        }
    }
});
const $bdafe4d734f7f426$export$742bf6d31cf89042 = ()=>{
    if (typeof window === 'undefined') return null;
    try {
        return (0, $8RlGv.getSupabase)();
    } catch (_) {
        return null;
    }
};

});
parcelRegister("82gA2", function(module, exports) {

$parcel$export(module.exports, "RAW_URL", () => $5d9b5f1b563b470d$export$633927de1c6436f9);
$parcel$export(module.exports, "SUPABASE_KEY", () => $5d9b5f1b563b470d$export$e4b5702c9c6bb38c);
$parcel$export(module.exports, "SUPABASE_ANON_KEY", () => $5d9b5f1b563b470d$export$b77c07a50a90ca85);
$parcel$export(module.exports, "getSupabase", () => (parcelRequire("8RlGv")).getSupabase);
$parcel$export(module.exports, "getSupabaseAsync", () => (parcelRequire("8RlGv")).getSupabaseAsync);
$parcel$export(module.exports, "getRealtimeSupabase", () => (parcelRequire("8RlGv")).getRealtimeSupabase);
$parcel$export(module.exports, "createClient", () => (parcelRequire("dNnfS")).createClient);
// Shim over @symbo.ls/sdk-bridge. This module used to own the Supabase
// client directly; it now re-exports from the federation layer so
// every existing import (getSupabase / getSupabaseAsync / SUPABASE_URL /
// SUPABASE_ANON_KEY) keeps working unchanged while the underlying
// client, session state, and new federation APIs live in sdk-bridge.
//
// New code should import from '../governanceBridge.js' directly — or, for
// governance-specific work, use `getClient(PROJECT_GOVERNANCE)`.

var $8RlGv = parcelRequire("8RlGv");

var $dNnfS = parcelRequire("dNnfS");
const $5d9b5f1b563b470d$var$_cfg = (0, $8RlGv.getProjectConfig)((0, $8RlGv.PROJECT_GOVERNANCE));
const $5d9b5f1b563b470d$export$633927de1c6436f9 = $5d9b5f1b563b470d$var$_cfg.url;
const $5d9b5f1b563b470d$export$e4b5702c9c6bb38c = $5d9b5f1b563b470d$var$_cfg.anonKey;
const $5d9b5f1b563b470d$export$b77c07a50a90ca85 = $5d9b5f1b563b470d$var$_cfg.anonJwt;

});



parcelRegister("8augU", function(module, exports) {

$parcel$export(module.exports, "update", () => (parcelRequire("exslg")).update);
$parcel$export(module.exports, "dispose", () => (parcelRequire("gXM9X")).dispose);
$parcel$export(module.exports, "remove", () => (parcelRequire("gXM9X")).remove);
$parcel$export(module.exports, "REGISTRY", () => (parcelRequire("5utcL")).REGISTRY);
$parcel$export(module.exports, "LIFECYCLE_EVENTS", () => (parcelRequire("5utcL")).LIFECYCLE_EVENTS);
$parcel$export(module.exports, "DELEGATED_EVENTS", () => (parcelRequire("5utcL")).DELEGATED_EVENTS);
$parcel$export(module.exports, "MIXINS", () => (parcelRequire("5utcL")).MIXINS);
$parcel$export(module.exports, "addDelegatedEvent", () => (parcelRequire("5Or4i")).addDelegatedEvent);
$parcel$export(module.exports, "removeDelegatedEvent", () => (parcelRequire("5Or4i")).removeDelegatedEvent);
$parcel$export(module.exports, "registerEvent", () => (parcelRequire("5Or4i")).registerEvent);
$parcel$export(module.exports, "cacheNode", () => (parcelRequire("hlMjd")).cacheNode);
$parcel$export(module.exports, "detectTag", () => (parcelRequire("hlMjd")).detectTag);
$parcel$export(module.exports, "createHTMLNode", () => (parcelRequire("hlMjd")).createHTMLNode);
$parcel$export(module.exports, "isValidTag", () => (parcelRequire("hlMjd")).isValidTag);
$parcel$export(module.exports, "isSvgTag", () => (parcelRequire("hlMjd")).isSvgTag);
$parcel$export(module.exports, "SVG_TAGS", () => (parcelRequire("hlMjd")).SVG_TAGS);
$parcel$export(module.exports, "applyExtends", () => (parcelRequire("3QQ54")).applyExtends);
$parcel$export(module.exports, "addMethods", () => (parcelRequire("1P3uZ")).addMethods);
$parcel$export(module.exports, "loadWasm", () => (parcelRequire("kF6lW")).loadWasm);
$parcel$export(module.exports, "isWasmLoaded", () => (parcelRequire("kF6lW")).isWasmLoaded);
$parcel$export(module.exports, "setCssEngineHook", () => (parcelRequire("kF6lW")).setCssEngineHook);

var $flu9Q = parcelRequire("flu9Q");
parcelRequire("2Eo8m");
var $bd7kG = parcelRequire("bd7kG");
var $2Eo8m = parcelRequire("2Eo8m");

var $2oe0q = parcelRequire("2oe0q");
parcelRequire("cm1sg");
var $5Or4i = parcelRequire("5Or4i");
var $1P3uZ = parcelRequire("1P3uZ");
var $3QQ54 = parcelRequire("3QQ54");
var $hlMjd = parcelRequire("hlMjd");
var $5utcL = parcelRequire("5utcL");
var $gXM9X = parcelRequire("gXM9X");
var $exslg = parcelRequire("exslg");

var $bxxg4 = parcelRequire("bxxg4");

var $inO1F = parcelRequire("inO1F");

var $6g1vM = parcelRequire("6g1vM");

var $aTPvW = parcelRequire("aTPvW");

var $9Ri24 = parcelRequire("9Ri24");
parcelRequire("fcdWE");
var $kF6lW = parcelRequire("kF6lW");

var $6T8Dr = parcelRequire("6T8Dr");
'use strict';
(0, $kF6lW.setCssEngineHook)((0, $bd7kG.setWasmEngine));
$parcel$exportWildcard(module.exports, $flu9Q);
$parcel$exportWildcard(module.exports, $2Eo8m);
$parcel$exportWildcard(module.exports, $2oe0q);
$parcel$exportWildcard(module.exports, $bxxg4);
$parcel$exportWildcard(module.exports, $inO1F);
$parcel$exportWildcard(module.exports, $6g1vM);
$parcel$exportWildcard(module.exports, $aTPvW);
$parcel$exportWildcard(module.exports, $9Ri24);
$parcel$exportWildcard(module.exports, $6T8Dr);

});
parcelRegister("flu9Q", function(module, exports) {

var $dGEWX = parcelRequire("dGEWX");
$parcel$exportWildcard(module.exports, $dGEWX);

});
parcelRegister("dGEWX", function(module, exports) {

$parcel$export(module.exports, "createSignal", () => (parcelRequire("hBrLD")).createSignal);
$parcel$export(module.exports, "createComputed", () => (parcelRequire("hBrLD")).createComputed);
$parcel$export(module.exports, "createEffect", () => (parcelRequire("hBrLD")).createEffect);
$parcel$export(module.exports, "batch", () => (parcelRequire("hBrLD")).batch);
$parcel$export(module.exports, "getObserver", () => (parcelRequire("hBrLD")).getObserver);
$parcel$export(module.exports, "setObserver", () => (parcelRequire("hBrLD")).setObserver);
$parcel$export(module.exports, "createStore", () => (parcelRequire("lQ86u")).createStore);
$parcel$export(module.exports, "isStore", () => (parcelRequire("lQ86u")).isStore);
$parcel$export(module.exports, "getSignals", () => (parcelRequire("lQ86u")).getSignals);

var $hBrLD = parcelRequire("hBrLD");

var $lQ86u = parcelRequire("lQ86u");

});
parcelRegister("hBrLD", function(module, exports) {

$parcel$export(module.exports, "getObserver", () => $cd0b6e624789d9d0$export$619cdeadfd90f3e4);
$parcel$export(module.exports, "setObserver", () => $cd0b6e624789d9d0$export$e1c3d8e1a0880d23);
$parcel$export(module.exports, "createSignal", () => $cd0b6e624789d9d0$export$c1e1e1ecbbe76a5);
$parcel$export(module.exports, "createComputed", () => $cd0b6e624789d9d0$export$234a23cdc77e6a3d);
$parcel$export(module.exports, "createEffect", () => $cd0b6e624789d9d0$export$7ea7134f704deda4);
$parcel$export(module.exports, "batch", () => $cd0b6e624789d9d0$export$712ea50be43a7858);
// @symbo.ls/signal - Fine-grained reactive primitives
// Inspired by Solid.js, adapted for DOMQL's runtime component model
let $cd0b6e624789d9d0$var$OBSERVER = null;
let $cd0b6e624789d9d0$var$BATCH_DEPTH = 0;
const $cd0b6e624789d9d0$var$PENDING_EFFECTS = [];
const $cd0b6e624789d9d0$export$619cdeadfd90f3e4 = ()=>$cd0b6e624789d9d0$var$OBSERVER;
const $cd0b6e624789d9d0$export$e1c3d8e1a0880d23 = (o)=>{
    $cd0b6e624789d9d0$var$OBSERVER = o;
};
function $cd0b6e624789d9d0$export$c1e1e1ecbbe76a5(value) {
    const subscribers = new Set();
    function get() {
        if ($cd0b6e624789d9d0$var$OBSERVER) {
            subscribers.add($cd0b6e624789d9d0$var$OBSERVER);
            $cd0b6e624789d9d0$var$OBSERVER._sources.add(signal);
        }
        return value;
    }
    function set(next) {
        if (next === value) return;
        value = next;
        $cd0b6e624789d9d0$var$notify(subscribers);
    }
    function peek() {
        return value;
    }
    const signal = {
        get: get,
        set: set,
        peek: peek,
        _subscribers: subscribers,
        _type: 'signal'
    };
    return signal;
}
function $cd0b6e624789d9d0$export$234a23cdc77e6a3d(fn) {
    let value;
    let dirty = true;
    const subscribers = new Set();
    const computation = {
        _sources: new Set(),
        _type: 'computed',
        _subscribers: subscribers,
        _execute () {
            $cd0b6e624789d9d0$var$cleanupSources(computation);
            const prev = $cd0b6e624789d9d0$var$OBSERVER;
            $cd0b6e624789d9d0$var$OBSERVER = computation;
            try {
                const next = fn();
                if (next !== value) {
                    value = next;
                    dirty = false;
                    $cd0b6e624789d9d0$var$notify(subscribers);
                } else dirty = false;
            } finally{
                $cd0b6e624789d9d0$var$OBSERVER = prev;
            }
        },
        _notify () {
            dirty = true;
            // If we have subscribers, eagerly recompute
            if (subscribers.size > 0) computation._execute();
        },
        get () {
            if ($cd0b6e624789d9d0$var$OBSERVER) {
                subscribers.add($cd0b6e624789d9d0$var$OBSERVER);
                $cd0b6e624789d9d0$var$OBSERVER._sources.add(computation);
            }
            if (dirty) computation._execute();
            return value;
        },
        peek () {
            if (dirty) computation._execute();
            return value;
        }
    };
    // Initial computation
    computation._execute();
    return computation;
}
// --- Effect ---
let $cd0b6e624789d9d0$var$effectQueue = new Set();
let $cd0b6e624789d9d0$var$flushScheduled = false;
function $cd0b6e624789d9d0$export$7ea7134f704deda4(fn, options) {
    const depth = options?.depth ?? 0;
    const effect = {
        _sources: new Set(),
        _type: 'effect',
        _depth: depth,
        _disposed: false,
        _subscribers: new Set(),
        _execute () {
            if (effect._disposed) return;
            $cd0b6e624789d9d0$var$cleanupSources(effect);
            const prev = $cd0b6e624789d9d0$var$OBSERVER;
            $cd0b6e624789d9d0$var$OBSERVER = effect;
            try {
                fn();
            } catch (err) {
                console.error('[smbls] effect error:', err);
            } finally{
                $cd0b6e624789d9d0$var$OBSERVER = prev;
            }
        },
        _notify () {
            if (effect._disposed) return;
            if ($cd0b6e624789d9d0$var$BATCH_DEPTH > 0) $cd0b6e624789d9d0$var$PENDING_EFFECTS.push(effect);
            else $cd0b6e624789d9d0$var$scheduleEffect(effect);
        },
        dispose () {
            effect._disposed = true;
            $cd0b6e624789d9d0$var$cleanupSources(effect);
        }
    };
    // Run immediately to track dependencies
    effect._execute();
    return effect;
}
function $cd0b6e624789d9d0$export$712ea50be43a7858(fn) {
    $cd0b6e624789d9d0$var$BATCH_DEPTH++;
    try {
        fn();
    } finally{
        $cd0b6e624789d9d0$var$BATCH_DEPTH--;
        if ($cd0b6e624789d9d0$var$BATCH_DEPTH === 0) $cd0b6e624789d9d0$var$flushPendingEffects();
    }
}
// --- Scheduler ---
function $cd0b6e624789d9d0$var$scheduleEffect(effect) {
    $cd0b6e624789d9d0$var$effectQueue.add(effect);
    if (!$cd0b6e624789d9d0$var$flushScheduled) {
        $cd0b6e624789d9d0$var$flushScheduled = true;
        queueMicrotask($cd0b6e624789d9d0$var$flushEffects);
    }
}
function $cd0b6e624789d9d0$var$flushEffects() {
    $cd0b6e624789d9d0$var$flushScheduled = false;
    // Sort by depth (parent before child)
    const sorted = Array.from($cd0b6e624789d9d0$var$effectQueue).sort((a, b)=>a._depth - b._depth);
    $cd0b6e624789d9d0$var$effectQueue = new Set();
    for(let i = 0; i < sorted.length; i++){
        const effect = sorted[i];
        if (!effect._disposed) effect._execute();
    }
}
function $cd0b6e624789d9d0$var$flushPendingEffects() {
    // Deduplicate and schedule all pending effects
    for(let i = 0; i < $cd0b6e624789d9d0$var$PENDING_EFFECTS.length; i++)$cd0b6e624789d9d0$var$scheduleEffect($cd0b6e624789d9d0$var$PENDING_EFFECTS[i]);
    $cd0b6e624789d9d0$var$PENDING_EFFECTS.length = 0;
}
// --- Notify subscribers ---
function $cd0b6e624789d9d0$var$notify(subscribers) {
    // Snapshot to avoid issues with subscriber modification during iteration
    const subs = Array.from(subscribers);
    for(let i = 0; i < subs.length; i++)subs[i]._notify();
}
// --- Cleanup ---
function $cd0b6e624789d9d0$var$cleanupSources(observer) {
    for (const source of observer._sources)source._subscribers.delete(observer);
    observer._sources.clear();
}

});

parcelRegister("lQ86u", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $fe64bd8a9c42aa4e$export$f51a9068ac82ea43);
$parcel$export(module.exports, "isStore", () => $fe64bd8a9c42aa4e$export$9abf972af34a1547);
$parcel$export(module.exports, "getSignals", () => $fe64bd8a9c42aa4e$export$c50078d4faa171f0);
// Reactive Store - wraps a plain object so each property is backed by a Signal
// This bridges DOMQL's `state: { count: 0 }` to the signal system

var $hBrLD = parcelRequire("hBrLD");
const $fe64bd8a9c42aa4e$var$STORE = Symbol('store');
const $fe64bd8a9c42aa4e$var$SIGNALS = Symbol('signals');
// Check if a value should be stored as-is (not wrapped in a nested store)
const $fe64bd8a9c42aa4e$var$isLeafValue = (val)=>!val || typeof val !== 'object' || Array.isArray(val) || val[$fe64bd8a9c42aa4e$var$STORE] || Object.isFrozen(val) || typeof Node !== 'undefined' && val instanceof Node || val.__ref || val.nodeType || val.nodeName;
function $fe64bd8a9c42aa4e$export$f51a9068ac82ea43(initial, options, _depth) {
    if (_depth === undefined) _depth = 0;
    const signals = {};
    const raw = {};
    // Initialize signals from initial values. Cap nesting depth to prevent
    // stack overflow on large state objects with many nested plain objects.
    const maxDepth = options && options.maxDepth || 8;
    if (initial && typeof initial === 'object') for(const key in initial){
        const val = initial[key];
        if (_depth < maxDepth && val && typeof val === 'object' && !$fe64bd8a9c42aa4e$var$isLeafValue(val)) {
            raw[key] = val;
            signals[key] = (0, $hBrLD.createSignal)($fe64bd8a9c42aa4e$export$f51a9068ac82ea43(val, options, _depth + 1));
        } else {
            raw[key] = val;
            signals[key] = (0, $hBrLD.createSignal)(val);
        }
    }
    const proxy = new Proxy(raw, {
        get (target, prop) {
            if (prop === $fe64bd8a9c42aa4e$var$STORE) return true;
            if (prop === $fe64bd8a9c42aa4e$var$SIGNALS) return signals;
            if (prop === '__raw') return target;
            // Store methods
            if (prop === 'update') return storeUpdate;
            if (prop === 'parse') return storeParse;
            if (prop === 'clean') return storeClean;
            if (prop === 'keys') return storeKeys;
            if (prop === 'values') return storeValues;
            if (prop === 'replace') return storeReplace;
            if (prop === 'add') return storeAdd;
            if (prop === 'remove') return storeRemove;
            if (prop === 'destroy') return storeDestroy;
            if (prop === 'quietUpdate') return storeQuietUpdate;
            // Meta
            if (prop === '__element') return target.__element;
            if (prop === 'parent') return target.parent;
            if (prop === 'root') return target.root;
            // Signal read - auto-tracks (own properties only, skip Object.prototype)
            if (Object.prototype.hasOwnProperty.call(signals, prop)) return signals[prop].get();
            if (target[prop] !== undefined) return target[prop];
            // Delegate to root state for keys not found locally
            if (prop !== 'root' && target.root && target.root !== proxy) return target.root[prop];
            // Lazy signal creation: if a reactive effect is currently observing
            // and reads a property that doesn't yet exist, create an empty signal
            // so the effect can subscribe to it. When the property is later set
            // via the proxy's `set` handler, the existing signal will fire and
            // the effect will re-run with the new value. Without this, you cannot
            // subscribe to "future" properties — a common issue when initial state
            // omits a key that gets populated by an async fetch later.
            if (typeof prop === 'string' && !prop.startsWith('__') && prop !== 'then' && prop !== 'constructor' && (0, $hBrLD.getObserver)() != null) {
                signals[prop] = (0, $hBrLD.createSignal)(undefined);
                return signals[prop].get();
            }
        },
        set (target, prop, value) {
            if (prop === '__element' || prop === 'parent' || prop === 'root') {
                target[prop] = value;
                return true;
            }
            if (Object.prototype.hasOwnProperty.call(signals, prop)) {
                target[prop] = value;
                if (value && typeof value === 'object' && !$fe64bd8a9c42aa4e$var$isLeafValue(value)) signals[prop].set($fe64bd8a9c42aa4e$export$f51a9068ac82ea43(value, options, _depth + 1));
                else signals[prop].set(value);
            } else {
                // New property
                target[prop] = value;
                if (value && typeof value === 'object' && !$fe64bd8a9c42aa4e$var$isLeafValue(value)) signals[prop] = (0, $hBrLD.createSignal)($fe64bd8a9c42aa4e$export$f51a9068ac82ea43(value, options, _depth + 1));
                else signals[prop] = (0, $hBrLD.createSignal)(value);
            }
            return true;
        },
        has (target, prop) {
            return prop in signals || prop in target;
        },
        ownKeys (target) {
            return Object.keys(signals);
        },
        getOwnPropertyDescriptor (target, prop) {
            if (prop in signals) return {
                enumerable: true,
                configurable: true,
                value: signals[prop].peek()
            };
            return Object.getOwnPropertyDescriptor(target, prop);
        },
        deleteProperty (target, prop) {
            if (signals[prop]) {
                signals[prop].set(undefined);
                delete signals[prop];
            }
            delete target[prop];
            return true;
        }
    });
    // --- Store methods (bound to this proxy) ---
    function storeUpdate(updates, opts) {
        (0, $hBrLD.batch)(()=>{
            for(const key in updates)proxy[key] = updates[key];
        });
        // Fire onUpdate callback if element is attached
        const el = raw.__element;
        if (el && el.onUpdate && !opts?.quiet) el.onUpdate(el, proxy, el.context);
        return proxy;
    }
    function storeQuietUpdate(updates) {
        return storeUpdate(updates, {
            quiet: true
        });
    }
    function storeParse(seen) {
        if (!seen) seen = new Set();
        if (seen.has(proxy)) return '[Circular]';
        seen.add(proxy);
        const result = {};
        for(const key in signals){
            if (key === 'parent' || key === 'root' || key.startsWith('__')) continue;
            const val = signals[key].peek();
            if (val && val[$fe64bd8a9c42aa4e$var$STORE]) result[key] = val.parse(seen);
            else result[key] = val;
        }
        return result;
    }
    function storeClean() {
        (0, $hBrLD.batch)(()=>{
            for(const key in signals)delete proxy[key];
        });
        return proxy;
    }
    function storeKeys() {
        return Object.keys(signals);
    }
    function storeValues() {
        return Object.keys(signals).map((k)=>signals[k].peek());
    }
    function storeReplace(newState) {
        (0, $hBrLD.batch)(()=>{
            // Remove keys not in newState
            for(const key in signals)if (!(key in newState)) delete proxy[key];
            // Set new values
            for(const key in newState)proxy[key] = newState[key];
        });
        return proxy;
    }
    function storeAdd(key, value) {
        proxy[key] = value;
        return proxy;
    }
    function storeRemove(key) {
        delete proxy[key];
        return proxy;
    }
    function storeDestroy() {
        storeClean();
        raw.__element = null;
        raw.parent = null;
    }
    return proxy;
}
function $fe64bd8a9c42aa4e$export$9abf972af34a1547(obj) {
    return obj && obj[$fe64bd8a9c42aa4e$var$STORE] === true;
}
function $fe64bd8a9c42aa4e$export$c50078d4faa171f0(store) {
    return store[$fe64bd8a9c42aa4e$var$SIGNALS];
}

});



parcelRegister("2Eo8m", function(module, exports) {

var $hwjog = parcelRequire("hwjog");
$parcel$exportWildcard(module.exports, $hwjog);

});
parcelRegister("hwjog", function(module, exports) {

$parcel$export(module.exports, "css", () => (parcelRequire("bd7kG")).css);
$parcel$export(module.exports, "injectGlobal", () => (parcelRequire("bd7kG")).injectGlobal);
$parcel$export(module.exports, "keyframes", () => (parcelRequire("bd7kG")).keyframes);
$parcel$export(module.exports, "reset", () => (parcelRequire("bd7kG")).reset);
$parcel$export(module.exports, "getCacheSize", () => (parcelRequire("bd7kG")).getCacheSize);
$parcel$export(module.exports, "setActiveDocument", () => (parcelRequire("bd7kG")).setActiveDocument);
$parcel$export(module.exports, "getActiveDocument", () => (parcelRequire("bd7kG")).getActiveDocument);
$parcel$export(module.exports, "setWasmEngine", () => (parcelRequire("bd7kG")).setWasmEngine);

var $bd7kG = parcelRequire("bd7kG");

});
parcelRegister("bd7kG", function(module, exports) {

$parcel$export(module.exports, "setWasmEngine", () => $829698b0c1d7ffe4$export$8c5e2ec1e153591);
$parcel$export(module.exports, "setActiveDocument", () => $829698b0c1d7ffe4$export$149520325e406055);
$parcel$export(module.exports, "getActiveDocument", () => $829698b0c1d7ffe4$export$b95447fc6bac8667);
$parcel$export(module.exports, "css", () => $829698b0c1d7ffe4$export$dbf350e5966cf602);
$parcel$export(module.exports, "injectGlobal", () => $829698b0c1d7ffe4$export$efb9f5caaa2ca0c7);
$parcel$export(module.exports, "keyframes", () => $829698b0c1d7ffe4$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "reset", () => $829698b0c1d7ffe4$export$aad8462122ac592b);
$parcel$export(module.exports, "getCacheSize", () => $829698b0c1d7ffe4$export$91630538791620d6);
// Atomic CSS Engine - generates one class per CSS property-value pair
// Replaces Emotion with a purpose-built lightweight engine
// Supports optional WASM acceleration for batch CSS generation
parcelRequire("aTPvW");
var $7KiQp = parcelRequire("7KiQp");
const $829698b0c1d7ffe4$var$classCache = new Map();
let $829698b0c1d7ffe4$var$sheet = null;
// WASM acceleration — set by setWasmEngine()
let $829698b0c1d7ffe4$var$_wasmBatchAtomicCss = null;
let $829698b0c1d7ffe4$var$_wasmCompoundCssClass = null;
function $829698b0c1d7ffe4$export$8c5e2ec1e153591(wasmFns) {
    if (wasmFns.batchAtomicCss) $829698b0c1d7ffe4$var$_wasmBatchAtomicCss = wasmFns.batchAtomicCss;
    if (wasmFns.compoundCssClass) $829698b0c1d7ffe4$var$_wasmCompoundCssClass = wasmFns.compoundCssClass;
}
// Active document for CSS operations — derived from the scratch config stack.
// During element creation pushConfig(context.designSystem) is active and the
// config carries `document`, so CSS goes to the right doc automatically.
// Outside any scope falls back to globalThis.document (backward compatible).
const $829698b0c1d7ffe4$var$_registeredDocs = new Set();
function $829698b0c1d7ffe4$export$149520325e406055(doc) {
    // Backward-compat shim: store on the currently active scratch config so
    // getActiveDocument() picks it up via the config stack. If no config is
    // active this is a no-op (the caller should use pushConfig instead).
    try {
        const config = (0, $7KiQp.getActiveConfig)();
        if (config) config.document = doc;
    } catch (e) {}
    if (doc) $829698b0c1d7ffe4$var$_registeredDocs.add(doc);
}
function $829698b0c1d7ffe4$export$b95447fc6bac8667() {
    // Prefer the scratch config stack (properly scoped per-app)
    try {
        const config = (0, $7KiQp.getActiveConfig)();
        if (config?.document) return config.document;
    } catch (e) {}
    // Fallback to global document
    return typeof document !== 'undefined' ? document : null;
}
function $829698b0c1d7ffe4$export$469ebc401c7f18f8() {
    return $829698b0c1d7ffe4$var$_registeredDocs;
}
// Short property name mapping for class name generation
const $829698b0c1d7ffe4$var$PROP_ABBREV = {
    display: 'd',
    position: 'pos',
    padding: 'p',
    paddingTop: 'pt',
    paddingRight: 'pr',
    paddingBottom: 'pb',
    paddingLeft: 'pl',
    margin: 'm',
    marginTop: 'mt',
    marginRight: 'mr',
    marginBottom: 'mb',
    marginLeft: 'ml',
    width: 'w',
    height: 'h',
    minWidth: 'mnw',
    minHeight: 'mnh',
    maxWidth: 'mxw',
    maxHeight: 'mxh',
    top: 't',
    right: 'r',
    bottom: 'b',
    left: 'l',
    flex: 'fx',
    flexDirection: 'fxd',
    flexWrap: 'fxw',
    flexGrow: 'fxg',
    flexShrink: 'fxs',
    flexBasis: 'fxb',
    justifyContent: 'jc',
    alignItems: 'ai',
    alignSelf: 'as',
    alignContent: 'ac',
    gap: 'g',
    rowGap: 'rg',
    columnGap: 'cg',
    gridTemplateColumns: 'gtc',
    gridTemplateRows: 'gtr',
    gridColumn: 'gc',
    gridRow: 'gr',
    overflow: 'of',
    overflowX: 'ofx',
    overflowY: 'ofy',
    fontSize: 'fs',
    fontWeight: 'fw',
    fontFamily: 'ff',
    fontStyle: 'fst',
    lineHeight: 'lh',
    letterSpacing: 'ls',
    textAlign: 'ta',
    textDecoration: 'td',
    textTransform: 'tt',
    color: 'c',
    background: 'bg',
    backgroundColor: 'bgc',
    backgroundImage: 'bgi',
    border: 'bd',
    borderRadius: 'br',
    borderColor: 'bdc',
    borderWidth: 'bdw',
    borderStyle: 'bds',
    boxShadow: 'bxsh',
    opacity: 'op',
    zIndex: 'z',
    cursor: 'cur',
    transition: 'tr',
    transform: 'tf',
    animation: 'an',
    visibility: 'vis',
    whiteSpace: 'ws',
    wordBreak: 'wb',
    objectFit: 'obj',
    pointerEvents: 'pe',
    userSelect: 'us',
    boxSizing: 'bxz',
    outline: 'ol',
    listStyle: 'lis',
    textOverflow: 'txo',
    verticalAlign: 'va',
    float: 'fl',
    clear: 'cl',
    content: 'cnt',
    backdropFilter: 'bdf',
    filter: 'flt',
    resize: 'rsz',
    appearance: 'apr',
    fill: 'fil',
    stroke: 'stk'
};
// Convert camelCase to kebab-case for CSS
function $829698b0c1d7ffe4$var$toKebab(str) {
    return str.replace(/[A-Z]/g, (m)=>'-' + m.toLowerCase());
}
// Generate a short hash for values that would make class names too long
function $829698b0c1d7ffe4$var$shortHash(str) {
    let h = 0x811c9dc5;
    for(let i = 0; i < str.length; i++){
        h ^= str.charCodeAt(i);
        h = h * 0x01000193 >>> 0;
    }
    return h.toString(36);
}
// Sanitize value for use in class name
function $829698b0c1d7ffe4$var$sanitizeValue(value) {
    const str = String(value);
    // Short values can be used directly (sanitized)
    if (str.length <= 20) return str.replace(/\s+/g, '_').replace(/[^a-zA-Z0-9_-]/g, '').toLowerCase();
    // Long values get hashed
    return $829698b0c1d7ffe4$var$shortHash(str);
}
// Get or create atomic class for a single CSS property-value pair
function $829698b0c1d7ffe4$var$atomicClass(prop, value, prefix) {
    const cacheKey = (prefix ? prefix + '\x01' : '') + prop + ':' + value;
    let className = $829698b0c1d7ffe4$var$classCache.get(cacheKey);
    // Build the CSS rule
    const cssProp = className ? null : $829698b0c1d7ffe4$var$toKebab(prop);
    if (!className) {
        const abbrev = $829698b0c1d7ffe4$var$PROP_ABBREV[prop] || $829698b0c1d7ffe4$var$shortHash(prop);
        const valStr = $829698b0c1d7ffe4$var$sanitizeValue(value);
        className = prefix ? `_${prefix}_${abbrev}-${valStr}` : `_${abbrev}-${valStr}`;
        $829698b0c1d7ffe4$var$classCache.set(cacheKey, className);
    }
    // Always insert into the current active document's sheet
    // (the class may be cached but missing from a new iframe document)
    const rule = `.${className}{${cssProp || $829698b0c1d7ffe4$var$toKebab(prop)}:${value}}`;
    $829698b0c1d7ffe4$var$insertRule(rule);
    return className;
}
// Track which rules have been inserted per document
const $829698b0c1d7ffe4$var$_insertedRules = new WeakMap();
// Insert a CSS rule into a document's stylesheet.
// When `targetDoc` is given, the rule lands in that document's sheet.
function $829698b0c1d7ffe4$var$insertRule(rule, targetDoc) {
    const s = $829698b0c1d7ffe4$var$getSheet(targetDoc);
    if (!s) return;
    // Track per-sheet to avoid duplicate insertions
    let ruleSet = $829698b0c1d7ffe4$var$_insertedRules.get(s);
    if (!ruleSet) {
        ruleSet = new Set();
        $829698b0c1d7ffe4$var$_insertedRules.set(s, ruleSet);
    }
    if (ruleSet.has(rule)) return;
    ruleSet.add(rule);
    try {
        s.insertRule(rule, s.cssRules.length);
    } catch (e) {
    // Invalid CSS rule - skip silently
    }
}
// Per-document sheet cache so multiple documents (main + iframe) each get
// their own <style data-smbls> element and CSSStyleSheet.
const $829698b0c1d7ffe4$var$_sheetCache = new WeakMap();
// Get or create the shared stylesheet for a given document.
// When `targetDoc` is provided, it takes priority over the global active doc.
function $829698b0c1d7ffe4$var$getSheet(targetDoc) {
    const doc = targetDoc || $829698b0c1d7ffe4$export$b95447fc6bac8667();
    if (!doc || !doc.head) return null;
    // Return cached sheet if it's still attached
    const cached = $829698b0c1d7ffe4$var$_sheetCache.get(doc);
    if (cached && cached.ownerNode && cached.ownerNode.parentNode === doc.head) return cached;
    let style = doc.head.querySelector('style[data-smbls]');
    if (!style) {
        style = doc.createElement('style');
        style.setAttribute('data-smbls', '');
        doc.head.appendChild(style);
    }
    const s = style.sheet;
    $829698b0c1d7ffe4$var$_sheetCache.set(doc, s);
    // Keep legacy singleton in sync for code that reads `sheet` directly
    $829698b0c1d7ffe4$var$sheet = s;
    return s;
}
// --- Public API ---
// Minimum number of flat (non-object) properties to trigger WASM batch path.
// Below this threshold, per-property JS is faster due to WASM call overhead.
const $829698b0c1d7ffe4$var$WASM_BATCH_THRESHOLD = 8;
function $829698b0c1d7ffe4$export$dbf350e5966cf602(styles, targetDoc, prefix) {
    if (!styles || typeof styles !== 'object') return '';
    // Separate flat props from compound (object-valued) props
    // WASM batch path handles flat props; compound props always use JS
    let flatParts = null;
    let flatCount = 0;
    const classes = [];
    for(const prop in styles){
        const value = styles[prop];
        if (value == null || value === false || value === '') continue;
        if (typeof value === 'object') classes.push($829698b0c1d7ffe4$var$compoundClass(prop, value, prefix));
        else if ($829698b0c1d7ffe4$var$_wasmBatchAtomicCss) {
            // Collect flat props for potential WASM batch
            if (!flatParts) flatParts = [];
            flatParts.push(prop, String(value));
            flatCount++;
        } else classes.push($829698b0c1d7ffe4$var$atomicClass(prop, String(value), prefix));
    }
    // Use WASM batch path if we have enough flat props
    if (flatParts && flatCount >= $829698b0c1d7ffe4$var$WASM_BATCH_THRESHOLD) {
        const input = flatParts.join('\x00');
        const result = $829698b0c1d7ffe4$var$_wasmBatchAtomicCss(input);
        const sepIdx = result.indexOf('\x00');
        const batchClasses = result.substring(0, sepIdx);
        const batchRules = result.substring(sepIdx + 1);
        // Insert rules into stylesheet
        if (batchRules) {
            const rules = batchRules.split('\n');
            for(let i = 0; i < rules.length; i++)if (rules[i]) $829698b0c1d7ffe4$var$insertRule(rules[i]);
        }
        if (classes.length > 0) classes.push(batchClasses);
        else return batchClasses;
    } else if (flatParts) // Below threshold — use per-property JS path
    for(let i = 0; i < flatParts.length; i += 2)classes.push($829698b0c1d7ffe4$var$atomicClass(flatParts[i], flatParts[i + 1], prefix));
    return classes.join(' ');
}
// Store all CSS rules generated for a compound class, keyed by className.
// Used to re-insert rules when the stylesheet is recreated (e.g. after Parcel
// hot-reload or SPA navigation creates a new <style> tag). Without this,
// compoundClass returns from classCache on the second render and never calls
// insertRule — the class is applied to DOM nodes but the matching CSS rule is
// absent from every stylesheet.
const $829698b0c1d7ffe4$var$_compoundRuleCache = new Map();
// Handle compound styles (pseudo-classes, media queries)
function $829698b0c1d7ffe4$var$compoundClass(selector, styles, prefix) {
    const cacheKey = (prefix ? prefix + '\x01' : '') + selector + JSON.stringify(styles);
    let className = $829698b0c1d7ffe4$var$classCache.get(cacheKey);
    if (className) {
        // Re-insert rules on every call so they survive stylesheet recreation
        // (mirrors the atomicClass pattern which always calls insertRule).
        const cachedRules = $829698b0c1d7ffe4$var$_compoundRuleCache.get(className);
        if (cachedRules) for(let i = 0; i < cachedRules.length; i++)$829698b0c1d7ffe4$var$insertRule(cachedRules[i]);
        return className;
    }
    className = prefix ? `_${prefix}_c${$829698b0c1d7ffe4$var$shortHash(cacheKey)}` : `_c${$829698b0c1d7ffe4$var$shortHash(cacheKey)}`;
    let body = '';
    const nestedRules = [];
    for(const prop in styles){
        const value = styles[prop];
        if (value == null) continue;
        if (typeof value === 'object') {
            // Nested selector (e.g. '> h1': { textShadow: '...' })
            let nestedBody = '';
            for(const nestedProp in value){
                const nestedVal = value[nestedProp];
                if (nestedVal == null) continue;
                nestedBody += `${$829698b0c1d7ffe4$var$toKebab(nestedProp)}:${nestedVal};`;
            }
            if (nestedBody) nestedRules.push({
                selector: prop,
                body: nestedBody
            });
        } else body += `${$829698b0c1d7ffe4$var$toKebab(prop)}:${value};`;
    }
    // Collect generated rules for this class so they can be re-inserted on
    // subsequent calls (when classCache has a hit but the sheet was recreated).
    const generatedRules = [];
    // Build the base selector prefix for this class
    if (selector.startsWith('@media') || selector.startsWith('@supports')) {
        if (body) {
            const rule = `${selector}{.${className}{${body}}}`;
            generatedRules.push(rule);
            $829698b0c1d7ffe4$var$insertRule(rule);
        }
        for (const nested of nestedRules){
            // Resolve `&` the same way non-@media selectors do: `&` substitutes
            // the class name, leading `:` attaches directly, everything else is a
            // descendant. Without this, a nested key like `:root:not([data-theme]) &`
            // would be inserted verbatim and browsers turn the whole media block
            // into `@media not all` (silently dead CSS) — callers get no styling
            // and have no way to know why.
            const resolvedNested = nested.selector.includes('&') ? nested.selector.replace(/&/g, `.${className}`) : nested.selector.startsWith(':') ? `.${className}${nested.selector}` : `.${className} ${nested.selector}`;
            const rule = `${selector}{${resolvedNested}{${nested.body}}}`;
            generatedRules.push(rule);
            $829698b0c1d7ffe4$var$insertRule(rule);
        }
        $829698b0c1d7ffe4$var$_compoundRuleCache.set(className, generatedRules);
        $829698b0c1d7ffe4$var$classCache.set(cacheKey, className);
        return className;
    }
    // Resolve selector — handle comma-separated selectors
    const resolveSelector = (sel)=>{
        return sel.split(',').map((part)=>{
            part = part.trim();
            if (part.includes('&')) return part.replace(/&/g, `.${className}`);
            if (part.startsWith(':')) return `.${className}${part}`;
            return `.${className} ${part}`;
        }).join(', ');
    };
    const baseSelector = resolveSelector(selector);
    if (body) {
        const rule = `${baseSelector}{${body}}`;
        generatedRules.push(rule);
        $829698b0c1d7ffe4$var$insertRule(rule);
    }
    for (const nested of nestedRules){
        // For nested selectors, append to each resolved part
        // Pseudo-selectors (:hover, :nth-child, etc.) attach directly (no space)
        // Combinators (> h1, + div, ~ span) and element selectors need a space
        const sep = nested.selector.startsWith(':') ? '' : ' ';
        const resolved = resolveSelector(selector);
        const parts = resolved.split(', ');
        const nestedFullSelector = parts.map((s)=>`${s}${sep}${nested.selector}`).join(', ');
        const rule = `${nestedFullSelector}{${nested.body}}`;
        generatedRules.push(rule);
        $829698b0c1d7ffe4$var$insertRule(rule);
    }
    $829698b0c1d7ffe4$var$_compoundRuleCache.set(className, generatedRules);
    $829698b0c1d7ffe4$var$classCache.set(cacheKey, className);
    return className;
}
function $829698b0c1d7ffe4$export$efb9f5caaa2ca0c7(styles) {
    $829698b0c1d7ffe4$var$getSheet();
    if (typeof styles === 'string') {
        $829698b0c1d7ffe4$var$insertRule(styles);
        return;
    }
    // Sort selectors: non-media first, then @media by max-width descending
    // so smaller breakpoints come last and override larger ones
    const selectors = Object.keys(styles);
    const getMaxWidth = (s)=>{
        const m = s.match(/max-width:\s*(\d+)/);
        return m ? parseInt(m[1]) : 0;
    };
    selectors.sort((a, b)=>{
        const aMedia = a.startsWith('@media');
        const bMedia = b.startsWith('@media');
        if (!aMedia && !bMedia) return 0;
        if (!aMedia) return -1;
        if (!bMedia) return 1;
        return getMaxWidth(b) - getMaxWidth(a);
    });
    for (const selector of selectors){
        const props = styles[selector];
        if (selector.startsWith('@media') || selector.startsWith('@supports')) // Media/supports queries: recurse into nested selectors
        for(const innerSelector in props){
            const innerProps = props[innerSelector];
            if (typeof innerProps === 'object' && innerProps !== null) {
                let body = '';
                for(const prop in innerProps){
                    const cssProp = prop.startsWith('--') ? prop : $829698b0c1d7ffe4$var$toKebab(prop);
                    body += `${cssProp}:${innerProps[prop]};`;
                }
                $829698b0c1d7ffe4$var$insertRule(`${selector}{${innerSelector}{${body}}}`);
            } else {
                const cssProp = innerSelector.startsWith('--') ? innerSelector : $829698b0c1d7ffe4$var$toKebab(innerSelector);
                $829698b0c1d7ffe4$var$insertRule(`${selector}{${cssProp}:${innerProps};}`);
            }
        }
        else {
            let body = '';
            let hasNested = false;
            for(const prop in props){
                const value = props[prop];
                if (typeof value === 'object' && value !== null) hasNested = true;
                else {
                    const cssProp = prop.startsWith('--') ? prop : $829698b0c1d7ffe4$var$toKebab(prop);
                    body += `${cssProp}:${value};`;
                }
            }
            if (body) $829698b0c1d7ffe4$var$insertRule(`${selector}{${body}}`);
            if (hasNested) {
                // Collect @media keys and sort by max-width descending (largest first)
                // so smaller breakpoints override larger ones
                const mediaKeys = [];
                const otherKeys = [];
                for(const prop in props)if (typeof props[prop] === 'object' && props[prop] !== null) {
                    if (prop.startsWith('@media') || prop.startsWith('@supports')) mediaKeys.push(prop);
                    else otherKeys.push(prop);
                }
                // Sort media queries: larger max-width first, smaller last (so smaller wins)
                mediaKeys.sort((a, b)=>{
                    const getWidth = (s)=>{
                        const m = s.match(/max-width:\s*(\d+)/);
                        return m ? parseInt(m[1]) : 0;
                    };
                    return getWidth(b) - getWidth(a);
                });
                for (const prop of otherKeys)$829698b0c1d7ffe4$export$efb9f5caaa2ca0c7({
                    [`${selector} ${prop}`]: props[prop]
                });
                for (const prop of mediaKeys)$829698b0c1d7ffe4$export$efb9f5caaa2ca0c7({
                    [prop]: {
                        [selector]: props[prop]
                    }
                });
            }
        }
    }
}
function $829698b0c1d7ffe4$export$d25ddfdf17c3ad3e(name, frames) {
    let body = '';
    for(const key in frames){
        let props = '';
        for(const prop in frames[key])props += `${$829698b0c1d7ffe4$var$toKebab(prop)}:${frames[key][prop]};`;
        body += `${key}{${props}}`;
    }
    $829698b0c1d7ffe4$var$insertRule(`@keyframes ${name}{${body}}`);
    return name;
}
function $829698b0c1d7ffe4$export$aad8462122ac592b() {
    $829698b0c1d7ffe4$var$classCache.clear();
    $829698b0c1d7ffe4$var$sheet = null;
}
function $829698b0c1d7ffe4$export$91630538791620d6() {
    return $829698b0c1d7ffe4$var$classCache.size;
}

});
parcelRegister("aTPvW", function(module, exports) {

var $8q1sk = parcelRequire("8q1sk");
$parcel$exportWildcard(module.exports, $8q1sk);

});
parcelRegister("8q1sk", function(module, exports) {

$parcel$export(module.exports, "scratchUtils", () => (parcelRequire("g1w0p")));
$parcel$export(module.exports, "scratchSystem", () => (parcelRequire("g1w0p")));
$parcel$export(module.exports, "scratchDefaultConfig", () => (parcelRequire("g1w0p")));

var $a7QGr = parcelRequire("a7QGr");

var $4bxaE = parcelRequire("4bxaE");

var $dx3dW = parcelRequire("dx3dW");

var $7KiQp = parcelRequire("7KiQp");

var $4nA98 = parcelRequire("4nA98");

var $g1w0p = parcelRequire("g1w0p");
'use strict';
$parcel$exportWildcard(module.exports, $a7QGr);
$parcel$exportWildcard(module.exports, $4bxaE);
$parcel$exportWildcard(module.exports, $dx3dW);
$parcel$exportWildcard(module.exports, $7KiQp);
$parcel$exportWildcard(module.exports, $4nA98);
$parcel$exportWildcard(module.exports, $g1w0p);

});
parcelRegister("a7QGr", function(module, exports) {

var $28k11 = parcelRequire("28k11");

var $2ESw5 = parcelRequire("2ESw5");

var $LzSdR = parcelRequire("LzSdR");

var $ePlkR = parcelRequire("ePlkR");

var $4FtMQ = parcelRequire("4FtMQ");

var $4e8M6 = parcelRequire("4e8M6");

var $iIypr = parcelRequire("iIypr");
'use strict';
$parcel$exportWildcard(module.exports, $28k11);
$parcel$exportWildcard(module.exports, $2ESw5);
$parcel$exportWildcard(module.exports, $LzSdR);
$parcel$exportWildcard(module.exports, $ePlkR);
$parcel$exportWildcard(module.exports, $4FtMQ);
$parcel$exportWildcard(module.exports, $4e8M6);
$parcel$exportWildcard(module.exports, $iIypr);

});
parcelRegister("28k11", function(module, exports) {

$parcel$export(module.exports, "isScalingUnit", () => $18dbdacc7a38df0d$export$6a836bb704f10b75);
$parcel$export(module.exports, "CSS_UNITS", () => $18dbdacc7a38df0d$export$7263016d8c64b932);
'use strict';
const $18dbdacc7a38df0d$export$6a836bb704f10b75 = (unit)=>{
    return unit === 'em' || unit === 'rem' || unit === 'vw' || unit === 'vh' || unit === 'vmax' || unit === 'vmin';
};
const $18dbdacc7a38df0d$export$7263016d8c64b932 = [
    // Absolute
    'px',
    'cm',
    'mm',
    'in',
    'pt',
    'pc',
    // Font-relative
    'em',
    'rem',
    'ex',
    'cap',
    'ch',
    'ic',
    'lh',
    'rlh',
    // Viewport-relative
    '%',
    'vw',
    'vh',
    'vmin',
    'vmax',
    'svw',
    'svh',
    'lvw',
    'lvh',
    'dvw',
    'dvh',
    // Container query units
    'cqw',
    'cqh',
    'cqi',
    'cqb',
    'cqmin',
    'cqmax',
    // Angle
    'deg',
    'rad',
    'grad',
    'turn',
    // Time
    's',
    'ms',
    // Resolution
    'dpi',
    'dpcm',
    'dppx',
    // Grid fractional
    'fr',
    'auto'
];

});

parcelRegister("2ESw5", function(module, exports) {

$parcel$export(module.exports, "colorStringToRgbaArray", () => $1ef99b0b26632769$export$fa32e9c99a43479e);
$parcel$export(module.exports, "mixTwoColors", () => $1ef99b0b26632769$export$fc81362b978df912);
$parcel$export(module.exports, "mixTwoRgba", () => $1ef99b0b26632769$export$7aaa71d8fa03e6fa);
$parcel$export(module.exports, "hexToRgb", () => $1ef99b0b26632769$export$5a544e13ad4e1fa5);
$parcel$export(module.exports, "hexToRgbArray", () => $1ef99b0b26632769$export$fc66327a54d8eee6);
$parcel$export(module.exports, "rgbToHex", () => $1ef99b0b26632769$export$34d09c4a771c46ef);
$parcel$export(module.exports, "rgbArrayToHex", () => $1ef99b0b26632769$export$becee3e8de1b8d23);
$parcel$export(module.exports, "hexToRgba", () => $1ef99b0b26632769$export$9665a07d9187b414);
$parcel$export(module.exports, "mixTwoRgb", () => $1ef99b0b26632769$export$7d1bd62512294b2f);
$parcel$export(module.exports, "changeLightness", () => $1ef99b0b26632769$export$784aaa753604ca97);
$parcel$export(module.exports, "rgbToHSL", () => $1ef99b0b26632769$export$ac60e367bcb68b);
$parcel$export(module.exports, "hslToRgb", () => $1ef99b0b26632769$export$29fb7152bd3f781a);
$parcel$export(module.exports, "getColorShade", () => $1ef99b0b26632769$export$e1d0a0f5f1f4ce36);
$parcel$export(module.exports, "opacify", () => $1ef99b0b26632769$export$f4f50e3877dd0530);
$parcel$export(module.exports, "isCSSVar", () => $1ef99b0b26632769$export$c9f584638d388483);
$parcel$export(module.exports, "CSS_NATIVE_COLOR_REGEX", () => $1ef99b0b26632769$export$cc26ca941513e971);
$parcel$export(module.exports, "parseColorToken", () => $1ef99b0b26632769$export$4ea2ee5b33c12815);
$parcel$export(module.exports, "isResolvedColor", () => $1ef99b0b26632769$export$962b4432982d3252);
$parcel$export(module.exports, "splitTopLevelCommas", () => $1ef99b0b26632769$export$ef7a598b406793c);
$parcel$export(module.exports, "getRgbTone", () => $1ef99b0b26632769$export$2d78fefdcfb7f222);
parcelRequire("2oe0q");
var $erBZm = parcelRequire("erBZm");
var $kt4aQ = parcelRequire("kt4aQ");
var $fX7ii = parcelRequire("fX7ii");
'use strict';
const $1ef99b0b26632769$export$fa32e9c99a43479e = (color)=>{
    if (color === '') return [
        0,
        0,
        0,
        0
    ];
    if (color.toLowerCase() === 'transparent') return [
        0,
        0,
        0,
        0
    ];
    // convert #RGB and #RGBA to #RRGGBB and #RRGGBBAA
    if (color[0] === '#') {
        if (color.length < 7) color = '#' + color[1] + color[1] + color[2] + color[2] + color[3] + color[3] + (color.length > 4 ? color[4] + color[4] : '');
        return [
            parseInt(color.substr(1, 2), 16),
            parseInt(color.substr(3, 2), 16),
            parseInt(color.substr(5, 2), 16),
            color.length > 7 ? parseInt(color.substr(7, 2), 16) / 255 : 1
        ];
    }
    // convert named colors
    if (color.indexOf('rgb') === -1) {
        if ((0, $erBZm.document) && (0, $erBZm.window)) {
            // intentionally use unknown tag to lower chances of css rule override with !important
            const elem = (0, $erBZm.document).body.appendChild((0, $erBZm.document).createElement('fictum'));
            // this flag tested on chrome 59, ff 53, ie9, ie10, ie11, edge 14
            const flag = 'rgb(1, 2, 3)';
            elem.style.color = flag;
            // color set failed - some monstrous css rule is probably taking over the color of our object
            if (elem.style.color !== flag) {
                (0, $erBZm.document).body.removeChild(elem);
                return;
            }
            elem.style.color = color;
            if (elem.style.color === flag || elem.style.color === '') {
                (0, $erBZm.document).body.removeChild(elem);
                return [
                    0,
                    0,
                    0,
                    0
                ] // color parse failed
                ;
            }
            color = (0, $erBZm.window).getComputedStyle(elem).color;
            (0, $erBZm.document).body.removeChild(elem);
        }
    }
    // convert 'rgb(R,G,B)' to 'rgb(R,G,B,A)' which looks awful but will pass the regxep below
    if (color.indexOf('rgb') === 0) {
        if (color.indexOf('rgba') === -1) color = `${color}, 1`;
        return color.match(/[\.\d]+/g).map((a)=>+a) // eslint-disable-line
        ;
    }
    return [
        0,
        0,
        0,
        0
    ];
};
const $1ef99b0b26632769$export$fc81362b978df912 = (colorA, colorB, range = 0.5)=>{
    colorA = $1ef99b0b26632769$export$fa32e9c99a43479e(colorA);
    colorB = $1ef99b0b26632769$export$fa32e9c99a43479e(colorB);
    return $1ef99b0b26632769$export$7aaa71d8fa03e6fa(colorA, colorB, range);
};
const $1ef99b0b26632769$export$5a544e13ad4e1fa5 = (hex, alpha = 1)=>{
    const [r, g, b] = hex.match(/\w\w/g).map((x)=>parseInt(x, 16));
    return `rgb(${r},${g},${b})`;
};
const $1ef99b0b26632769$export$fc66327a54d8eee6 = (hex, alpha = 1)=>{
    const [r, g, b] = hex.match(/\w\w/g).map((x)=>parseInt(x, 16));
    return [
        r,
        g,
        b
    ];
};
const $1ef99b0b26632769$export$34d09c4a771c46ef = (r, g, b)=>{
    return '#' + (16777216 | r << 16 | g << 8 | b).toString(16).slice(1);
};
const $1ef99b0b26632769$export$becee3e8de1b8d23 = ([r, g, b])=>{
    return (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
};
const $1ef99b0b26632769$export$9665a07d9187b414 = (hex, alpha = 1)=>{
    const [r, g, b] = hex.match(/\w\w/g).map((x)=>parseInt(x, 16));
    return `rgba(${r},${g},${b},${alpha})`;
};
const $1ef99b0b26632769$export$7d1bd62512294b2f = (colorA, colorB, range = 0.5)=>{
    const arr = [];
    for(let i = 0; i < 3; i++)arr[i] = ~~(colorA[i] + (colorB[i] - colorA[i]) * range);
    return `rgb(${arr})`;
};
const $1ef99b0b26632769$export$784aaa753604ca97 = (delta, hsl)=>{
    const [hue, saturation, lightness] = hsl;
    const newLightness = Math.max(0, Math.min(100, lightness + parseFloat(delta)));
    return [
        hue,
        saturation,
        newLightness
    ];
};
const $1ef99b0b26632769$export$ac60e367bcb68b = (r, g, b)=>{
    const a = Math.max(r, g, b);
    const n = a - Math.min(r, g, b);
    const f = 1 - Math.abs(a + a - n - 1);
    const h = n && (a == r ? (g - b) / n : a == g ? 2 + (b - r) / n : 4 + (r - g) / n //eslint-disable-line
    );
    return [
        60 * (h < 0 ? h + 6 : h),
        f ? n / f : 0,
        (a + a - n) / 2
    ];
};
const $1ef99b0b26632769$export$29fb7152bd3f781a = (h, s, l, a = s * Math.min(l, 1 - l), f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1))=>[
        f(0),
        f(8),
        f(4)
    ];
const $1ef99b0b26632769$export$e1d0a0f5f1f4ce36 = (col, amt)=>{
    const num = parseInt(col, 16);
    let r = (num >> 16) + amt;
    if (r > 255) r = 255;
    else if (r < 0) r = 0;
    let b = (num >> 8 & 0x00ff) + amt;
    if (b > 255) b = 255;
    else if (b < 0) b = 0;
    let g = (num & 0x0000ff) + amt;
    if (g > 255) g = 255;
    else if (g < 0) g = 0;
    return ((g | b << 8 | r << 16) + 0x1000000).toString(16).slice(1);
};
const $1ef99b0b26632769$export$7aaa71d8fa03e6fa = (colorA, colorB, range = 0.5)=>{
    const arr = [];
    for(let i = 0; i < 4; i++){
        const round = i === 3 ? (x)=>x : Math.round;
        arr[i] = round(colorA[i] + (colorB[i] - colorA[i]) * range);
    }
    return `rgba(${arr})`;
};
const $1ef99b0b26632769$export$f4f50e3877dd0530 = (color, opacity)=>{
    const arr = $1ef99b0b26632769$export$fa32e9c99a43479e(color);
    if (!arr) {
        if ((0, $kt4aQ.isNotProduction)()) console.warn(color + ' color is not rgba');
        return;
    }
    arr[3] = opacity;
    return `rgba(${arr})`;
};
const $1ef99b0b26632769$export$c9f584638d388483 = (v)=>v.charCodeAt(0) === 45 && v.charCodeAt(1) === 45;
const $1ef99b0b26632769$export$cc26ca941513e971 = /(?:rgba?\(|hsla?\(|#[0-9a-fA-F]{3,8}\b)/;
// Regex for Symbols color token: colorName[.opacity][+/-/=tone]
// Supports hyphenated names like 'highlight-reversed', 'canvas-card', 'line-highlight'
// +N or -N = relative shade, =N = absolute lightness percentage
const $1ef99b0b26632769$var$COLOR_TOKEN_REGEX = /^([a-zA-Z]\w*)(?:\.(\d+))?(?:([+-]\d+|=\d+))?$/;
const $1ef99b0b26632769$export$4ea2ee5b33c12815 = (value)=>{
    if (!(0, $fX7ii.isString)(value)) return null;
    // CSS native color passthrough
    if ($1ef99b0b26632769$export$cc26ca941513e971.test(value)) return {
        passthrough: value
    };
    // CSS var passthrough
    if ($1ef99b0b26632769$export$c9f584638d388483(value)) return {
        cssVar: value
    };
    const match = value.match($1ef99b0b26632769$var$COLOR_TOKEN_REGEX);
    if (!match) return null;
    const [, name, alphaDigits, rawTone] = match;
    const alpha = alphaDigits !== undefined ? `0.${alphaDigits}` : undefined;
    // Strip '=' prefix for absolute tones — getRgbTone handles unsigned values as absolute
    const tone = rawTone && rawTone[0] === '=' ? rawTone.slice(1) : rawTone;
    return {
        name: name,
        alpha: alpha,
        tone: tone
    };
};
const $1ef99b0b26632769$export$962b4432982d3252 = (result)=>{
    return (0, $fX7ii.isString)(result) && (result.includes('rgb') || result.includes('var(') || result.includes('#'));
};
const $1ef99b0b26632769$export$ef7a598b406793c = (value)=>{
    const result = [];
    let current = '';
    let depth = 0;
    for (const char of value){
        if (char === '(') depth += 1;
        else if (char === ')' && depth > 0) depth -= 1;
        if (char === ',' && depth === 0) {
            result.push(current);
            current = '';
            continue;
        }
        current += char;
    }
    if (current.length || !result.length) result.push(current);
    return result;
};
const $1ef99b0b26632769$export$2d78fefdcfb7f222 = (rgb, tone)=>{
    if ((0, $fX7ii.isString)(rgb) && rgb.includes('rgb')) rgb = $1ef99b0b26632769$export$fa32e9c99a43479e(rgb).join(', ');
    if ((0, $fX7ii.isString)(rgb)) rgb = rgb.split(',').map((v)=>parseFloat(v.trim()));
    if ((0, $fX7ii.isNumber)(tone)) tone += '';
    const toHex = $1ef99b0b26632769$export$becee3e8de1b8d23(rgb);
    const abs = tone.slice(0, 1);
    if (abs === '-' || abs === '+') {
        const colorShade = $1ef99b0b26632769$export$e1d0a0f5f1f4ce36(toHex, parseFloat(tone));
        return $1ef99b0b26632769$export$fc66327a54d8eee6(colorShade).join(', ');
    } else {
        const [r, g, b] = rgb;
        const hsl = $1ef99b0b26632769$export$ac60e367bcb68b(r, g, b);
        const [h, s, l] = hsl // eslint-disable-line
        ;
        const newRgb = $1ef99b0b26632769$export$29fb7152bd3f781a(h, s, parseFloat(tone) / 100 * 255);
        return newRgb;
    }
};

});

parcelRegister("LzSdR", function(module, exports) {

$parcel$export(module.exports, "returnSubThemeOrDefault", () => $08f037a4512e32ac$export$b653d4648867fe18);
'use strict';
const $08f037a4512e32ac$export$b653d4648867fe18 = (orig, theme)=>{
    if (!orig) return;
    if (orig.themes && orig.themes[theme]) return orig.themes[theme];
    if (orig[theme]) return [
        orig,
        orig[theme]
    ];
    return orig;
};

});

parcelRegister("ePlkR", function(module, exports) {

$parcel$export(module.exports, "resolveFileUrl", () => $acb660e77bec9cb5$export$61174294d0ed0cf1);
$parcel$export(module.exports, "getDefaultOrFirstKey", () => $acb660e77bec9cb5$export$73aa7d12a2d2fb83);
$parcel$export(module.exports, "getFontFormat", () => $acb660e77bec9cb5$export$6c7bbed5530e9474);
$parcel$export(module.exports, "isGoogleFontsUrl", () => $acb660e77bec9cb5$export$460f73444f66199c);
$parcel$export(module.exports, "setFontImport", () => $acb660e77bec9cb5$export$3a1ea4c2338850e0);
$parcel$export(module.exports, "setInCustomFontMedia", () => $acb660e77bec9cb5$export$e84fe2812840a337);
$parcel$export(module.exports, "setCustomFont", () => $acb660e77bec9cb5$export$27bb82ae7d3ac02b);
$parcel$export(module.exports, "setCustomFontMedia", () => $acb660e77bec9cb5$export$2593ac3417be5ed7);
$parcel$export(module.exports, "getFontFaceEach", () => $acb660e77bec9cb5$export$198e04e3616f042a);
$parcel$export(module.exports, "getFontFace", () => $acb660e77bec9cb5$export$e9d70cd3a9044b8e);
$parcel$export(module.exports, "getFontFaceEachString", () => $acb660e77bec9cb5$export$c26ef91aac8931ec);
$parcel$export(module.exports, "getFontFaceString", () => $acb660e77bec9cb5$export$8b73d71a1d936bc);
'use strict';
const $acb660e77bec9cb5$export$61174294d0ed0cf1 = (url, files)=>{
    if (!url || !files) return null;
    try {
        new URL(url);
        return null;
    } catch (e) {} // expected: src is not an absolute URL, treating as relative path
    const file = files[url];
    if (file) return file.content && file.content.src;
    return null;
};
const $acb660e77bec9cb5$export$73aa7d12a2d2fb83 = (LIBRARY, key)=>{
    if (LIBRARY[key]) return LIBRARY[key].value;
    if (LIBRARY.default) return LIBRARY[LIBRARY.default].value;
    const hasValue = Object.keys(LIBRARY)[0];
    return hasValue && LIBRARY[hasValue] && LIBRARY[hasValue].value;
};
const $acb660e77bec9cb5$export$6c7bbed5530e9474 = (url)=>{
    // Tolerate missing urls — a font weight entry without a `url` should produce
    // no `format(...)` hint rather than crashing the entire CSS pipeline.
    if (typeof url !== 'string' || !url) return null;
    const ext = url.split(/[#?]/)[0].split('.').pop().trim();
    if ([
        'woff2',
        'woff',
        'ttf',
        'otf',
        'eot'
    ].includes(ext)) return ext;
    return null;
};
const $acb660e77bec9cb5$export$460f73444f66199c = (url)=>url && (url.includes('fonts.googleapis.com') || url.includes('fonts.gstatic.com'));
const $acb660e77bec9cb5$export$3a1ea4c2338850e0 = (url)=>`@import url('${url}');`;
const $acb660e77bec9cb5$export$e84fe2812840a337 = (str)=>`@font-face { ${str} }`;
const $acb660e77bec9cb5$export$27bb82ae7d3ac02b = (name, url, weight, options = {})=>{
    // Filter out undefined / empty entries so a missing weight URL doesn't
    // emit a broken `url('undefined')` rule or crash on .split downstream.
    const rawUrls = Array.isArray(url) ? url : [
        url
    ];
    const urls = rawUrls.filter((u)=>typeof u === 'string' && u);
    const srcList = urls.map((u)=>{
        const format = $acb660e77bec9cb5$export$6c7bbed5530e9474(u);
        const formatStr = format ? ` format('${format}')` : '';
        return `url('${u}')${formatStr}`;
    }).join(',\n       ');
    return `
  font-family: '${name}';
  font-style: ${options.fontStyle || 'normal'};${weight ? `
  font-weight: ${weight};` : ''}${options.fontStretch ? `
  font-stretch: ${options.fontStretch};` : ''}${options.fontDisplay ? `
  font-display: ${options.fontDisplay};` : ''}
  src: ${srcList};`;
};
const $acb660e77bec9cb5$export$2593ac3417be5ed7 = (name, url, weight, options)=>`@font-face {${$acb660e77bec9cb5$export$27bb82ae7d3ac02b(name, url, weight, options)}
}`;
const $acb660e77bec9cb5$export$198e04e3616f042a = (name, weights, files)=>{
    const keys = Object.keys(weights);
    return keys.map((key)=>{
        const { url: url, fontWeight: fontWeight, fontStyle: fontStyle, fontDisplay: fontDisplay, fontStretch: fontStretch } = weights[key];
        const resolvedUrl = Array.isArray(url) ? url.map((u)=>$acb660e77bec9cb5$export$61174294d0ed0cf1(u, files) || u) : $acb660e77bec9cb5$export$61174294d0ed0cf1(url, files) || url;
        return $acb660e77bec9cb5$export$27bb82ae7d3ac02b(name, resolvedUrl, fontWeight, {
            fontStyle: fontStyle,
            fontDisplay: fontDisplay,
            fontStretch: fontStretch
        });
    });
};
const $acb660e77bec9cb5$export$e9d70cd3a9044b8e = (LIBRARY)=>{
    const keys = Object.keys(LIBRARY);
    return keys.map((key)=>$acb660e77bec9cb5$export$198e04e3616f042a(key, LIBRARY[key].value));
};
const $acb660e77bec9cb5$export$c26ef91aac8931ec = (name, weights, files)=>{
    if (weights && weights.isVariable) {
        const url = $acb660e77bec9cb5$export$61174294d0ed0cf1(weights.url, files) || weights.url;
        if ($acb660e77bec9cb5$export$460f73444f66199c(url)) return $acb660e77bec9cb5$export$3a1ea4c2338850e0(url);
        return $acb660e77bec9cb5$export$2593ac3417be5ed7(name, url, weights.fontWeight, {
            fontStretch: weights.fontStretch,
            fontDisplay: weights.fontDisplay || 'swap'
        });
    }
    const isArr = weights[0];
    if (isArr) return $acb660e77bec9cb5$export$198e04e3616f042a(name, weights, files).map($acb660e77bec9cb5$export$e84fe2812840a337);
    const url = Array.isArray(weights.url) ? weights.url.map((u)=>$acb660e77bec9cb5$export$61174294d0ed0cf1(u, files) || u) : $acb660e77bec9cb5$export$61174294d0ed0cf1(weights.url, files) || weights.url;
    return $acb660e77bec9cb5$export$2593ac3417be5ed7(name, url, weights.fontWeight, {
        fontStyle: weights.fontStyle,
        fontDisplay: weights.fontDisplay,
        fontStretch: weights.fontStretch
    });
};
const $acb660e77bec9cb5$export$8b73d71a1d936bc = (LIBRARY, files)=>{
    const keys = Object.keys(LIBRARY);
    return keys.map((key)=>$acb660e77bec9cb5$export$c26ef91aac8931ec(key, LIBRARY[key].value, files));
};

});

parcelRegister("4FtMQ", function(module, exports) {

$parcel$export(module.exports, "numToLetterMap", () => $366218d35fdab076$export$81ab9dc24d52c4ba);
$parcel$export(module.exports, "getFnPrefixAndValue", () => $366218d35fdab076$export$30fba622059784de);
$parcel$export(module.exports, "setScalingVar", () => $366218d35fdab076$export$68dfa61d698afbde);
$parcel$export(module.exports, "setSubScalingVar", () => $366218d35fdab076$export$c9d5ef57eeb83fa);
$parcel$export(module.exports, "getSubratioDifference", () => $366218d35fdab076$export$12adf55fdaa50348);
$parcel$export(module.exports, "getSubratio", () => $366218d35fdab076$export$50db87b17b1557b4);
$parcel$export(module.exports, "generateSubSequence", () => $366218d35fdab076$export$622ae6209895c34e);
$parcel$export(module.exports, "generateSequence", () => $366218d35fdab076$export$29708af739d9b0fc);
$parcel$export(module.exports, "generateSequencePosition", () => $366218d35fdab076$export$7b7c0090b74e1e64);
$parcel$export(module.exports, "getSequenceValue", () => $366218d35fdab076$export$efde09b5692f9bd0);
$parcel$export(module.exports, "getSequenceValueBySymbols", () => $366218d35fdab076$export$69f332a3be1b2f36);
$parcel$export(module.exports, "getSequenceValuePropertyPair", () => $366218d35fdab076$export$86c0052f25dacc45);
$parcel$export(module.exports, "findHeadingLetter", () => $366218d35fdab076$export$14c834a042d41297);
$parcel$export(module.exports, "findHeadings", () => $366218d35fdab076$export$8dc77c00fe04c40a);
parcelRequire("2oe0q");
var $fX7ii = parcelRequire("fX7ii");
var $fuahe = parcelRequire("fuahe");

var $7KiQp = parcelRequire("7KiQp");

var $28k11 = parcelRequire("28k11");

var $2ESw5 = parcelRequire("2ESw5");
'use strict';
const $366218d35fdab076$export$81ab9dc24d52c4ba = {
    '-6': 'U',
    '-5': 'V',
    '-4': 'W',
    '-3': 'X',
    '-2': 'Y',
    '-1': 'Z',
    0: 'A',
    1: 'B',
    2: 'C',
    3: 'D',
    4: 'E',
    5: 'F',
    6: 'G',
    7: 'H',
    8: 'I',
    9: 'J',
    10: 'K',
    11: 'L',
    12: 'M',
    13: 'N',
    14: 'O',
    15: 'P',
    16: 'Q',
    17: 'R',
    18: 'S',
    19: 'T'
};
const $366218d35fdab076$var$setSequenceValue = (props, sequenceProps)=>{
    const { key: key, variable: variable, value: value, scaling: scaling, index: index, scalingVariable: scalingVariable } = props;
    sequenceProps.sequence[key] = {
        key: key,
        decimal: ~~(value * 100) / 100,
        val: ~~value,
        scaling: scaling,
        index: index,
        scalingVariable: scalingVariable,
        variable: variable
    };
    sequenceProps.scales[key] = scaling;
    const varUnit = $366218d35fdab076$var$VIEWPORT_UNITS.has(sequenceProps.unit) ? 'rem' : sequenceProps.unit;
    sequenceProps.vars[variable] = scaling + varUnit;
};
const $366218d35fdab076$export$30fba622059784de = (val)=>{
    if (!val.includes('(')) return val;
    const prefix = val.split('(')[0];
    const value = val.slice(val.indexOf('(') + 1, val.lastIndexOf(')'));
    return [
        prefix,
        value
    ];
};
const $366218d35fdab076$var$VIEWPORT_UNITS = new Set([
    'vw',
    'vh',
    'vmin',
    'vmax',
    'svw',
    'svh',
    'lvw',
    'lvh',
    'dvw',
    'dvh'
]);
const $366218d35fdab076$export$68dfa61d698afbde = (key, sequenceProps)=>{
    const { base: base, type: type, unit: rawUnit } = sequenceProps;
    const unit = $366218d35fdab076$var$VIEWPORT_UNITS.has(rawUnit) ? 'rem' : rawUnit;
    const defaultVal = ((0, $28k11.isScalingUnit)(unit) ? 1 : base) + unit;
    if (key === 0) return defaultVal;
    const vp = sequenceProps.varPrefix ? sequenceProps.varPrefix + '-' : '';
    const prefix = '--' + vp + (type && type.replace('.', '-'));
    const ratioVar = `${prefix}-ratio`;
    if (key > 0) {
        const prevLetterKey = $366218d35fdab076$export$81ab9dc24d52c4ba[key - 1];
        return `calc(var(${prefix}-${prevLetterKey}) * var(${ratioVar}))`;
    }
    if (key < 0) {
        const nextLetterKey = $366218d35fdab076$export$81ab9dc24d52c4ba[key + 1];
        const absKey = Math.abs(key);
        const phiPow = Math.pow($366218d35fdab076$var$PHI, 2 * absKey);
        const prevAscKey = $366218d35fdab076$export$81ab9dc24d52c4ba[absKey];
        // Clamp: max(current / ratio, normalized * ratio^n / phi^2n)
        // current chain: A / ratio^n
        // normalized: A * ratio^n / phi^(2n) = ASC mirror / phi^(2n)
        if (prevAscKey) return `max(calc(var(${prefix}-${nextLetterKey}) / var(${ratioVar})), calc(var(${prefix}-${prevAscKey}) / ${phiPow.toFixed(4)}))`;
        return `calc(var(${prefix}-${nextLetterKey}) / var(${ratioVar}))`;
    }
};
const $366218d35fdab076$export$c9d5ef57eeb83fa = (index, arr, variable, sequenceProps)=>{
    const { type: type } = sequenceProps;
    const skipMiddle = index === 2 && arr.length === 2;
    const indexMapWithLength = skipMiddle ? index + 1 : index;
    const vp = sequenceProps.varPrefix ? sequenceProps.varPrefix + '-' : '';
    const prefix = '--' + vp + (type && type.replace('.', '-'));
    const subRatioVarPrefix = `${prefix}-sub-ratio-`;
    return `calc(var(${variable}) * var(${subRatioVarPrefix + indexMapWithLength}))`;
};
const $366218d35fdab076$export$12adf55fdaa50348 = (base, ratio)=>{
    const diff = base * ratio - base;
    const subRatio = diff / 1.618;
    const first = base * ratio - subRatio;
    const second = base + subRatio;
    const middle = (first + second) / 2;
    return [
        first,
        middle,
        second
    ];
};
const $366218d35fdab076$export$50db87b17b1557b4 = (base, ratio)=>{
    return $366218d35fdab076$export$12adf55fdaa50348(base, ratio).map((v)=>v / base);
};
const $366218d35fdab076$export$622ae6209895c34e = (props, sequenceProps)=>{
    const { key: key, base: base, value: value, ratio: ratio, variable: variable, index: index } = props;
    const next = value * ratio;
    const diffRounded = ~~next - ~~value;
    let arr;
    const [first, middle, second] = $366218d35fdab076$export$12adf55fdaa50348(value, ratio);
    if (diffRounded > 16) arr = [
        first,
        middle,
        second
    ];
    else arr = [
        first,
        second
    ];
    arr.forEach((v, k)=>{
        const scaling = ~~(v / base * 1000) / 1000;
        const newVar = variable + (k + 1);
        const newIndex = index + (k + 1) / 10;
        const scalingVariable = $366218d35fdab076$export$c9d5ef57eeb83fa(k + 1, arr, variable, sequenceProps);
        const props = {
            key: key + (k + 1),
            variable: newVar,
            value: v,
            scaling: scaling,
            scalingVariable: scalingVariable,
            index: newIndex
        };
        $366218d35fdab076$var$setSequenceValue(props, sequenceProps);
    });
};
const $366218d35fdab076$var$PHI = 1.618;
const $366218d35fdab076$var$switchSequenceOnNegative = (key, base, ratio)=>{
    if (key >= 0) return base * Math.pow(ratio, key);
    // DESC: clamp between current and normalized to preserve proportions
    // Below golden ratio: use current (1/ratio^n) — nothing changes
    // Above golden ratio: use normalized (ratio^n / phi^2n) — proportion stays constant
    const absKey = Math.abs(key);
    const current = base * Math.pow(ratio, key) // base / ratio^n
    ;
    const normalized = base * Math.pow(ratio, absKey) / Math.pow($366218d35fdab076$var$PHI, 2 * absKey) // base * ratio^n / phi^(2n)
    ;
    return Math.max(current, normalized);
};
const $366218d35fdab076$export$29708af739d9b0fc = (sequenceProps)=>{
    const { type: type, base: base, ratio: ratio, range: range, subSequence: subSequence } = sequenceProps;
    const n = Math.abs(range[0]) + Math.abs(range[1]);
    const vp = sequenceProps.varPrefix ? sequenceProps.varPrefix + '-' : '';
    const prefix = '--' + vp + (type && type.replace('.', '-')) + '-';
    for(let i = 0; i <= n; i++){
        const key = range[1] - i;
        const letterKey = $366218d35fdab076$export$81ab9dc24d52c4ba[key];
        const value = $366218d35fdab076$var$switchSequenceOnNegative(key, base, ratio);
        const scaling = ~~(value / base * 100) / 100;
        const variable = prefix + letterKey;
        const scalingVariable = $366218d35fdab076$export$68dfa61d698afbde(key, sequenceProps);
        const props = {
            key: letterKey,
            variable: variable,
            value: value,
            base: base,
            scaling: scaling,
            scalingVariable: scalingVariable,
            ratio: ratio,
            index: key
        };
        $366218d35fdab076$var$setSequenceValue(props, sequenceProps);
        if (subSequence) $366218d35fdab076$export$622ae6209895c34e(props, sequenceProps);
    }
    return sequenceProps;
};
const $366218d35fdab076$export$7b7c0090b74e1e64 = (sequenceProps, position = 0)=>{
    const { type: type, base: base, ratio: ratio, subSequence: subSequence } = sequenceProps;
    const letterKey = (0, $fX7ii.isString)(position) ? position : $366218d35fdab076$export$81ab9dc24d52c4ba[position];
    const index = (0, $fX7ii.isString)(position) ? Object.entries($366218d35fdab076$export$81ab9dc24d52c4ba).find(([, value])=>value === position)?.[0] : position;
    if (!letterKey) {
        console.warn(`Position ${position} is out of range in numToLetterMap`);
        return null;
    }
    const result = {
        sequence: {},
        scales: {},
        vars: {},
        ...sequenceProps
    };
    const value = base * Math.pow(ratio, index);
    const scaling = ~~(value / base * 100) / 100;
    const vp = sequenceProps.varPrefix ? sequenceProps.varPrefix + '-' : '';
    const prefix = '--' + vp + (type && type.replace('.', '-')) + '-';
    const variable = prefix + letterKey;
    const scalingVariable = $366218d35fdab076$export$68dfa61d698afbde(index, sequenceProps);
    const props = {
        key: letterKey,
        variable: variable,
        value: value,
        base: base,
        scaling: scaling,
        scalingVariable: scalingVariable,
        ratio: ratio,
        index: index
    };
    $366218d35fdab076$var$setSequenceValue(props, result);
    if (subSequence) $366218d35fdab076$export$622ae6209895c34e(props, result);
    return result;
};
const $366218d35fdab076$export$efde09b5692f9bd0 = (value = 'A', sequenceProps)=>{
    const CONFIG = (0, $7KiQp.getActiveConfig)();
    const { unit: UNIT } = CONFIG;
    if ((0, $fX7ii.isString)(value) && (0, $2ESw5.isCSSVar)(value)) return `var(${value})`;
    const { sequence: sequence, unit: unit = UNIT.default, useVariable: useVariable } = sequenceProps;
    const startsWithDashOrLetterRegex = /^-?[a-zA-Z]/i;
    const startsWithDashOrLetter = startsWithDashOrLetterRegex.test(value);
    const hasUnits = (0, $28k11.CSS_UNITS).some((unit)=>value.includes(unit));
    if (hasUnits || !startsWithDashOrLetter) return value;
    const skipArr = [
        'none',
        'auto',
        'max-content',
        'min-content',
        'fit-content',
        'inherit',
        'initial',
        'unset',
        'revert',
        'revert-layer'
    ];
    if (skipArr.includes(value)) return value;
    const vp = sequenceProps.varPrefix ? sequenceProps.varPrefix + '-' : '';
    const prefix = `--${vp}${(0, $fuahe.toDashCase)(sequenceProps.type.replace('.', '-'))}-`;
    const letterVal = value.toUpperCase();
    const isNegative = letterVal.slice(0, 1) === '-' ? '-' : '';
    let absValue = isNegative ? letterVal.slice(1) : letterVal;
    let mediaName = '';
    if (absValue.includes('_')) {
        mediaName = '_' + absValue.split('_')[1].toLowerCase();
        absValue = absValue.split('_')[0];
    }
    const varValue = (v)=>startsWithDashOrLetterRegex.test(v) ? `var(${prefix}${v}${mediaName})` : v;
    if (absValue.includes('+')) {
        const [first, second] = absValue.split('+');
        const joint = `${varValue(first)} + ${varValue(second)}`;
        return isNegative ? `calc((${joint}) * -1)` : `calc(${joint})`;
    } else if (absValue.includes('*')) {
        const [first, second] = absValue.split('*');
        const joint = `${varValue(first)} * ${varValue(second)}`;
        return isNegative ? `calc((${joint}) * -1)` : `calc(${joint})`;
    } else if (absValue.includes('-')) {
        // TODO: check this
        // check for the first char
        const [first, second] = absValue.split('-');
        const joint = `${varValue(first)} - ${varValue(second)}`;
        return isNegative ? `calc((${joint}) * -1)` : `calc(${joint})`;
    }
    // if subsequence is not set but value is applied
    if (!sequence[absValue] && absValue.length === 2) {
        if (CONFIG.verbose) console.warn(absValue, '- value is not found because `subSequence` is set to false');
        absValue = absValue.slice(0, 1);
    }
    if (useVariable || CONFIG.useVariable) {
        const varValue = `var(${prefix}${absValue}${mediaName})`;
        return isNegative ? `calc(${varValue} * -1)` : varValue;
    }
    const sequenceItem = sequence ? sequence[absValue] : null;
    if (!sequenceItem) return console.warn("can't find", sequence, absValue);
    if (unit === 'ms' || unit === 's') return isNegative + sequenceItem.val + unit;
    return isNegative + sequenceItem.scaling + unit;
};
const $366218d35fdab076$export$69f332a3be1b2f36 = (value, sequenceProps)=>{
    const mathArr = [
        '+',
        '-',
        '*',
        '/',
        ','
    ].filter((v)=>value.includes(v + ' '));
    if (!mathArr.length) return value;
    // Tokenize the expression preserving all operators, then resolve each token
    const symbolRegex = /(\s*[+\-*/,]\s*)/;
    const tokens = value.split(symbolRegex);
    return tokens.map((token)=>{
        const trimmed = token.trim();
        if (!trimmed || [
            '+',
            '-',
            '*',
            '/',
            ','
        ].includes(trimmed)) return token;
        return $366218d35fdab076$export$efde09b5692f9bd0(trimmed, sequenceProps);
    }).join('');
};
const $366218d35fdab076$export$86c0052f25dacc45 = (value, propertyName, sequenceProps, fnPrefix)=>{
    if (typeof value !== 'string') {
        const CONFIG = (0, $7KiQp.getActiveConfig)();
        if (CONFIG.verbose) console.warn(propertyName, value, 'is not a string');
        return {
            [propertyName]: value
        };
    }
    if (value === '-' || value === '') return {};
    if (!fnPrefix && value.includes('(')) {
        const fnArr = $366218d35fdab076$export$30fba622059784de(value);
        fnPrefix = fnArr[0];
        value = fnArr[1];
    }
    const mathArr = [
        '+',
        '-',
        '*',
        '/',
        ','
    ].filter((v)=>value.includes(v + ' '));
    if (mathArr.length) value = $366218d35fdab076$export$69f332a3be1b2f36(value, sequenceProps);
    else value = $366218d35fdab076$export$efde09b5692f9bd0(value, sequenceProps);
    return {
        [propertyName]: fnPrefix ? `${fnPrefix}(${value})` : value
    };
};
const $366218d35fdab076$export$14c834a042d41297 = (h1Matches, index)=>$366218d35fdab076$export$81ab9dc24d52c4ba[h1Matches - index];
const $366218d35fdab076$export$8dc77c00fe04c40a = (propertyNames)=>{
    const { h1Matches: h1Matches, sequence: sequence } = propertyNames;
    return new Array(6).fill(null).map((_, i)=>{
        const findLetter = $366218d35fdab076$export$14c834a042d41297(h1Matches, i);
        return sequence[findLetter];
    });
};

});
parcelRegister("7KiQp", function(module, exports) {

$parcel$export(module.exports, "cssVars", () => $5a3b725cdb25b0eb$export$fd62969fb0b7081c);
$parcel$export(module.exports, "cssMediaVars", () => $5a3b725cdb25b0eb$export$e926ee1e7e0eae93);
$parcel$export(module.exports, "toCamel", () => $5a3b725cdb25b0eb$export$bc7802f0bef8d7aa);
$parcel$export(module.exports, "CONFIG", () => $5a3b725cdb25b0eb$export$1630b5343357e8b5);
$parcel$export(module.exports, "FACTORY", () => $5a3b725cdb25b0eb$export$ee513c29aad6cc62);
$parcel$export(module.exports, "activateConfig", () => $5a3b725cdb25b0eb$export$8a278b801d0668ff);
$parcel$export(module.exports, "pushConfig", () => $5a3b725cdb25b0eb$export$5d5568bf009ee2a6);
$parcel$export(module.exports, "popConfig", () => $5a3b725cdb25b0eb$export$5f6e6c1471f1916c);
$parcel$export(module.exports, "getActiveConfig", () => $5a3b725cdb25b0eb$export$e23c3d522afb24cd);
$parcel$export(module.exports, "setActiveConfig", () => $5a3b725cdb25b0eb$export$5e61d1b6fff0c794);
$parcel$export(module.exports, "createConfig", () => $5a3b725cdb25b0eb$export$45a69314cf48a3eb);
parcelRequire("2oe0q");
var $bmfNh = parcelRequire("bmfNh");
var $fX7ii = parcelRequire("fX7ii");

var $dx3dW = parcelRequire("dx3dW");
'use strict';
const $5a3b725cdb25b0eb$export$fd62969fb0b7081c = {};
const $5a3b725cdb25b0eb$export$e926ee1e7e0eae93 = {};
// Build CONFIG with lowercase/camelCase keys as canonical
const $5a3b725cdb25b0eb$var$_CONF = $dx3dW;
const $5a3b725cdb25b0eb$var$_confLower = {};
const $5a3b725cdb25b0eb$export$bc7802f0bef8d7aa = (s)=>s.replace(/_([a-z])/g, (_, c)=>c.toUpperCase());
for(const key in $5a3b725cdb25b0eb$var$_CONF){
    const lower = key.toLowerCase();
    $5a3b725cdb25b0eb$var$_confLower[lower] = $5a3b725cdb25b0eb$var$_CONF[key];
    // camelCase alias (e.g. font_family -> fontFamily, semanticIcons -> semanticIcons)
    const camel = $5a3b725cdb25b0eb$export$bc7802f0bef8d7aa(lower);
    if (camel !== lower) $5a3b725cdb25b0eb$var$_confLower[camel] = $5a3b725cdb25b0eb$var$_CONF[key];
    // keep original key if different from lower
    if (lower !== key) $5a3b725cdb25b0eb$var$_confLower[key] = $5a3b725cdb25b0eb$var$_CONF[key];
}
const $5a3b725cdb25b0eb$export$1630b5343357e8b5 = {
    verbose: false,
    useVariable: true,
    useReset: true,
    globalTheme: 'auto',
    cssVars: $5a3b725cdb25b0eb$export$fd62969fb0b7081c,
    cssMediaVars: $5a3b725cdb25b0eb$export$e926ee1e7e0eae93,
    CSS_VARS: $5a3b725cdb25b0eb$export$fd62969fb0b7081c,
    CSS_MEDIA_VARS: $5a3b725cdb25b0eb$export$e926ee1e7e0eae93,
    _scratchConfig: true,
    ...$5a3b725cdb25b0eb$var$_confLower
};
const $5a3b725cdb25b0eb$var$cachedConfig = (0, $bmfNh.deepClone)($5a3b725cdb25b0eb$export$1630b5343357e8b5);
const $5a3b725cdb25b0eb$export$ee513c29aad6cc62 = {
    active: '0',
    0: $5a3b725cdb25b0eb$export$1630b5343357e8b5
};
const $5a3b725cdb25b0eb$export$8a278b801d0668ff = (def)=>{
    if ((0, $fX7ii.isDefined)(def)) $5a3b725cdb25b0eb$export$ee513c29aad6cc62.active = def;
    return $5a3b725cdb25b0eb$export$ee513c29aad6cc62[def || $5a3b725cdb25b0eb$export$ee513c29aad6cc62.active];
};
// Config stack for context-local resolution
// When processing an element, its context.designSystem is pushed
// so all getActiveConfig() calls resolve to the right config
const $5a3b725cdb25b0eb$var$configStack = [];
const $5a3b725cdb25b0eb$export$5d5568bf009ee2a6 = (config)=>{
    if (config && config._scratchConfig) $5a3b725cdb25b0eb$var$configStack.push(config);
};
const $5a3b725cdb25b0eb$export$5f6e6c1471f1916c = ()=>{
    $5a3b725cdb25b0eb$var$configStack.pop();
};
const $5a3b725cdb25b0eb$export$e23c3d522afb24cd = (def)=>{
    if ($5a3b725cdb25b0eb$var$configStack.length) return $5a3b725cdb25b0eb$var$configStack[$5a3b725cdb25b0eb$var$configStack.length - 1];
    return $5a3b725cdb25b0eb$export$ee513c29aad6cc62[def || $5a3b725cdb25b0eb$export$ee513c29aad6cc62.active] || $5a3b725cdb25b0eb$export$1630b5343357e8b5;
};
const $5a3b725cdb25b0eb$export$5e61d1b6fff0c794 = (newConfig)=>{
    if (!(0, $fX7ii.isObject)(newConfig)) return;
    $5a3b725cdb25b0eb$export$ee513c29aad6cc62.active = '1';
    $5a3b725cdb25b0eb$export$ee513c29aad6cc62['1'] = (0, $bmfNh.deepMerge)(newConfig, (0, $bmfNh.deepClone)($5a3b725cdb25b0eb$var$cachedConfig));
    return newConfig;
};
// App-level flags that should NOT be inherited by isolated configs
const $5a3b725cdb25b0eb$var$APP_FLAGS = [
    'useReset',
    'useVariable',
    'useFontImport',
    'useIconSprite',
    'useSvgSprite',
    'useDocumentTheme',
    'useDefaultIcons',
    'useDefaultConfig',
    'verbose',
    'globalTheme'
];
// Keep case-variant aliases pointing to the same object. `factory.js`
// bootstrap wires these as shared refs, but `deepClone` in `createConfig`
// breaks the sharing and a later `deepMerge` only writes into one spelling
// — downstream code that destructures a different spelling then reads
// stale data (e.g. `applyDocument` reads `fontFamily` while `setValue`
// writes to `fontfamily`, leaving `DOCUMENT.fontFamily` unset).
const $5a3b725cdb25b0eb$var$ALIAS_GROUPS = [
    [
        'fontfamily',
        'fontFamily',
        'font_family'
    ],
    [
        'fontfamilytypes',
        'fontFamilyTypes'
    ],
    [
        'semanticicons',
        'semanticIcons'
    ],
    [
        'svgdata',
        'svgData'
    ]
];
const $5a3b725cdb25b0eb$var$aliasCaseVariants = (cfg)=>{
    for (const vs of $5a3b725cdb25b0eb$var$ALIAS_GROUPS){
        let merged;
        for (const v of vs){
            const val = cfg[v];
            if (!(0, $fX7ii.isObject)(val)) continue;
            merged = merged ? (0, $bmfNh.deepMerge)(val, merged) : val;
        }
        if (!merged) continue;
        for (const v of vs)if ((0, $fX7ii.isObject)(cfg[v])) cfg[v] = merged;
    }
};
const $5a3b725cdb25b0eb$export$45a69314cf48a3eb = (name, overrides, { cleanBase: cleanBase = false } = {})=>{
    // Secondary apps inheriting the primary app's processed config used to
    // drag primary-specific tokens (e.g. an editor's brand themes like
    // `sepia`, `canvas-card`) into the secondary's design system — breaking
    // iframe isolation. When `cleanBase: true` is passed, clone the initial
    // framework cache instead so the secondary starts from the same blank
    // slate as the primary did. Legacy callers (no option) keep the old
    // active-inherit behavior for backward compatibility.
    const activeBase = cleanBase ? null : $5a3b725cdb25b0eb$export$e23c3d522afb24cd();
    const base = (0, $bmfNh.deepClone)(!cleanBase && activeBase && activeBase._scratchConfig ? activeBase : $5a3b725cdb25b0eb$var$cachedConfig);
    // Remove app-level flags — they must come from overrides explicitly
    for (const flag of $5a3b725cdb25b0eb$var$APP_FLAGS)delete base[flag];
    const cfg = (0, $bmfNh.deepMerge)(overrides || {}, base);
    cfg.cssVars = {};
    cfg.cssMediaVars = {};
    cfg.CSS_VARS = cfg.cssVars;
    cfg.CSS_MEDIA_VARS = cfg.cssMediaVars;
    cfg._scratchConfig = true;
    $5a3b725cdb25b0eb$var$aliasCaseVariants(cfg);
    if (name) $5a3b725cdb25b0eb$export$ee513c29aad6cc62[name] = cfg;
    return cfg;
};

});
parcelRegister("dx3dW", function(module, exports) {

$parcel$export(module.exports, "reset", () => $9da0db98e0c07b6d$export$aad8462122ac592b);
$parcel$export(module.exports, "vars", () => $9da0db98e0c07b6d$export$3cb96c9f6c8d16a4);

var $i6rEE = parcelRequire("i6rEE");

var $dhO7E = parcelRequire("dhO7E");

var $hwmcO = parcelRequire("hwmcO");

var $2KMxp = parcelRequire("2KMxp");

var $b6icL = parcelRequire("b6icL");

var $2yign = parcelRequire("2yign");

var $cNnDl = parcelRequire("cNnDl");

var $bLCJu = parcelRequire("bLCJu");

var $iaF9Y = parcelRequire("iaF9Y");

var $c0cpj = parcelRequire("c0cpj");

var $8kg0Z = parcelRequire("8kg0Z");

var $15W2d = parcelRequire("15W2d");

var $5NAyZ = parcelRequire("5NAyZ");

var $7qo9w = parcelRequire("7qo9w");

var $lDtqZ = parcelRequire("lDtqZ");

var $l24oH = parcelRequire("l24oH");

var $dQfyz = parcelRequire("dQfyz");

var $1I6EG = parcelRequire("1I6EG");

var $hwM7t = parcelRequire("hwM7t");
'use strict';
const $9da0db98e0c07b6d$export$aad8462122ac592b = {};
const $9da0db98e0c07b6d$export$3cb96c9f6c8d16a4 = {};
$parcel$exportWildcard(module.exports, $i6rEE);
$parcel$exportWildcard(module.exports, $dhO7E);
$parcel$exportWildcard(module.exports, $hwmcO);
$parcel$exportWildcard(module.exports, $2KMxp);
$parcel$exportWildcard(module.exports, $b6icL);
$parcel$exportWildcard(module.exports, $2yign);
$parcel$exportWildcard(module.exports, $cNnDl);
$parcel$exportWildcard(module.exports, $bLCJu);
$parcel$exportWildcard(module.exports, $iaF9Y);
$parcel$exportWildcard(module.exports, $c0cpj);
$parcel$exportWildcard(module.exports, $8kg0Z);
$parcel$exportWildcard(module.exports, $15W2d);
$parcel$exportWildcard(module.exports, $5NAyZ);
$parcel$exportWildcard(module.exports, $7qo9w);
$parcel$exportWildcard(module.exports, $lDtqZ);
$parcel$exportWildcard(module.exports, $l24oH);
$parcel$exportWildcard(module.exports, $dQfyz);
$parcel$exportWildcard(module.exports, $1I6EG);
$parcel$exportWildcard(module.exports, $hwM7t);

});
parcelRegister("i6rEE", function(module, exports) {

$parcel$export(module.exports, "sequence", () => $d2de3d327c0c6201$export$49bb65c2ea163039);
'use strict';
const $d2de3d327c0c6201$export$49bb65c2ea163039 = {
    'minor-second': 1.067,
    'major-second': 1.125,
    'minor-third': 1.2,
    'major-third': 1.25,
    'perfect-fourth': 1.333,
    'augmented-fourth': 1.414,
    'perfect-fifth': 1.5,
    'minor-sixth': 1.6,
    phi: 1.618,
    'major-sixth': 1.667,
    'square-root-3': 1.732,
    'minor-seventh': 1.778,
    'major-seventh': 1.875,
    octave: 2,
    'square-root-5': 2.23,
    'major-tenth': 2.5,
    'major-eleventh': 2.667,
    'major-twelfth': 3,
    pi: 3.14,
    'double-octave': 4
};

});

parcelRegister("dhO7E", function(module, exports) {

$parcel$export(module.exports, "unit", () => $9ac3be22fd3c73fc$export$523c0b569236b342);
'use strict';
const $9ac3be22fd3c73fc$export$523c0b569236b342 = {
    default: 'em'
};

});

parcelRegister("hwmcO", function(module, exports) {

$parcel$export(module.exports, "typography", () => $cc16a6638a049274$export$d846a084e680d8e);

var $i6rEE = parcelRequire("i6rEE");
'use strict';
const $cc16a6638a049274$var$defaultProps = {
    browserDefault: 16,
    base: 16,
    type: 'font-size',
    ratio: (0, $i6rEE.sequence)['minor-third'],
    range: [
        -3,
        12
    ],
    h1Matches: 6,
    lineHeight: 1.5,
    subSequence: true,
    mediaRegenerate: false,
    unit: 'em',
    templates: {},
    sequence: {},
    scales: {},
    vars: {}
};
const $cc16a6638a049274$export$d846a084e680d8e = $cc16a6638a049274$var$defaultProps;

});

parcelRegister("2KMxp", function(module, exports) {

$parcel$export(module.exports, "font", () => $2015873c4c2cfb72$export$a74e2025f5286b02);
'use strict';
var $2015873c4c2cfb72$var$defFont = {
    name: '',
    url: '',
    fontStyle: '',
    fontWeight: 500,
    fontStretch: 'normal',
    fontOpticalSizing: 'auto'
};
const $2015873c4c2cfb72$export$a74e2025f5286b02 = {};

});

parcelRegister("b6icL", function(module, exports) {

$parcel$export(module.exports, "fontFamily", () => $814e605b31851b50$export$a5975749f0374264);
$parcel$export(module.exports, "fontFamilyTypes", () => $814e605b31851b50$export$963356d15a6daac);
$parcel$export(module.exports, "fontFace", () => $814e605b31851b50$export$566c6c2ff0443c7);
'use strict';
var $814e605b31851b50$var$defaultFont = {
    name: '',
    family: '',
    type: ''
};
const $814e605b31851b50$export$a5975749f0374264 = {};
const $814e605b31851b50$export$963356d15a6daac = {
    'sans-serif': 'Helvetica, Arial, sans-serif, --system-default',
    serif: 'Times New Roman, Georgia, serif, --system-default',
    monospace: 'Courier New, monospace, --system-default'
};
const $814e605b31851b50$export$566c6c2ff0443c7 = {};

});

parcelRegister("2yign", function(module, exports) {

$parcel$export(module.exports, "media", () => $1dbcec70a81fc9be$export$987d49ffe1b0900f);
'use strict';
const $1dbcec70a81fc9be$export$987d49ffe1b0900f = {
    tv: '(min-width: 2780px)',
    light: '(prefers-color-scheme: light)',
    dark: '(prefers-color-scheme: dark)',
    print: 'print'
};

});

parcelRegister("cNnDl", function(module, exports) {

$parcel$export(module.exports, "spacing", () => $950c64c959f06041$export$5458b64234d1333c);

var $i6rEE = parcelRequire("i6rEE");

var $hwmcO = parcelRequire("hwmcO");
'use strict';
const $950c64c959f06041$var$defaultProps = {
    base: (0, $hwmcO.typography).base,
    type: 'spacing',
    ratio: (0, $i6rEE.sequence).phi,
    range: [
        -5,
        15
    ],
    subSequence: true,
    mediaRegenerate: false,
    unit: 'em',
    sequence: {},
    scales: {},
    vars: {}
};
const $950c64c959f06041$export$5458b64234d1333c = $950c64c959f06041$var$defaultProps;

});

parcelRegister("bLCJu", function(module, exports) {

$parcel$export(module.exports, "color", () => $891220fdda3d21a2$export$35e9368ef982300f);
$parcel$export(module.exports, "gradient", () => $891220fdda3d21a2$export$f7d09cddc76f277f);
'use strict';
var $891220fdda3d21a2$var$proto = {
    name: '',
    value: ''
};
const $891220fdda3d21a2$export$35e9368ef982300f = {};
const $891220fdda3d21a2$export$f7d09cddc76f277f = {};

});

parcelRegister("iaF9Y", function(module, exports) {

$parcel$export(module.exports, "theme", () => $d3a916a1fb7d8435$export$bca14c5b3b88a9c9);
'use strict';
const $d3a916a1fb7d8435$var$themeA = {
    text: 'blue',
    background: 'white',
    border: 'black',
    active: {},
    helpers: [],
    themes: {},
    inverse: {} // schemeAInverse
};
const $d3a916a1fb7d8435$export$bca14c5b3b88a9c9 = {};

});

parcelRegister("c0cpj", function(module, exports) {

$parcel$export(module.exports, "shadow", () => $8bcf1bed1aa8dad9$export$b8972b998723d602);
'use strict';
const $8bcf1bed1aa8dad9$export$b8972b998723d602 = {};

});

parcelRegister("8kg0Z", function(module, exports) {

$parcel$export(module.exports, "icons", () => $60fc9d3d8a249143$export$df03f54e09e486fa);
$parcel$export(module.exports, "semanticIcons", () => $60fc9d3d8a249143$export$76fb3c2f696fe0ef);
'use strict';
const $60fc9d3d8a249143$export$df03f54e09e486fa = {};
const $60fc9d3d8a249143$export$76fb3c2f696fe0ef = {};

});

parcelRegister("15W2d", function(module, exports) {

$parcel$export(module.exports, "timing", () => $0cc3469566cd77c9$export$edfe6c349c815521);

var $i6rEE = parcelRequire("i6rEE");
'use strict';
const $0cc3469566cd77c9$var$defaultProps = {
    default: 150,
    base: 150,
    type: 'timing',
    ratio: (0, $i6rEE.sequence)['perfect-fourth'],
    range: [
        -3,
        12
    ],
    mediaRegenerate: false,
    unit: 'ms',
    sequence: {},
    scales: {},
    vars: {}
};
const $0cc3469566cd77c9$export$edfe6c349c815521 = $0cc3469566cd77c9$var$defaultProps;

});

parcelRegister("5NAyZ", function(module, exports) {

$parcel$export(module.exports, "document", () => $438de410da63932f$export$5a7bfc01df82fcd1);
'use strict';
const $438de410da63932f$export$5a7bfc01df82fcd1 = {};

});

parcelRegister("7qo9w", function(module, exports) {

$parcel$export(module.exports, "breakpoints", () => $567db250b885dfb6$export$d07517a676ce386f);
$parcel$export(module.exports, "devices", () => $567db250b885dfb6$export$2b1363e3b7173105);
'use strict';
const $567db250b885dfb6$export$d07517a676ce386f = {
    screenL: 1920,
    screenM: 1680,
    screenS: 1440,
    tabletL: 1366,
    tabletM: 1280,
    tabletS: 1024,
    mobileL: 768,
    mobileM: 560,
    mobileS: 480,
    mobileXS: 375
};
const $567db250b885dfb6$export$2b1363e3b7173105 = {
    screenXXL: [
        2560,
        1440
    ],
    screenXL: [
        2240,
        1260
    ],
    screenL: [
        1920,
        1024
    ],
    screenM: [
        1680,
        1024
    ],
    screenS: [
        1440,
        720
    ],
    tabletL: [
        1366,
        926
    ],
    tabletM: [
        1280,
        768
    ],
    tabletS: [
        1024,
        768
    ],
    mobileL: [
        768,
        375
    ],
    mobileM: [
        560,
        768
    ],
    mobileS: [
        480,
        768
    ],
    mobileXS: [
        375,
        768
    ]
};

});

parcelRegister("lDtqZ", function(module, exports) {

$parcel$export(module.exports, "animation", () => $fc04128916812e44$export$ecad260a8a5fef4f);
'use strict';
const $fc04128916812e44$export$ecad260a8a5fef4f = {};

});

parcelRegister("l24oH", function(module, exports) {

$parcel$export(module.exports, "svg", () => $f4fd3215e1191093$export$7ed1367e7fa1ad68);
$parcel$export(module.exports, "svgData", () => $f4fd3215e1191093$export$61fab8dd8fc131ea);
'use strict';
const $f4fd3215e1191093$export$7ed1367e7fa1ad68 = {};
const $f4fd3215e1191093$export$61fab8dd8fc131ea = {};

});

parcelRegister("dQfyz", function(module, exports) {

$parcel$export(module.exports, "templates", () => $a13c32e8633d5002$export$a8fc3402335b0b04);
'use strict';
const $a13c32e8633d5002$export$a8fc3402335b0b04 = {};

});

parcelRegister("1I6EG", function(module, exports) {

$parcel$export(module.exports, "grid", () => $13ef10175c6bbe24$export$85fc379452d91af0);
'use strict';
const $13ef10175c6bbe24$var$defaultProps = {};
const $13ef10175c6bbe24$export$85fc379452d91af0 = $13ef10175c6bbe24$var$defaultProps;

});

parcelRegister("hwM7t", function(module, exports) {

$parcel$export(module.exports, "class", () => $cc2ac05ddcef8e7b$export$4aaf3ce7c927d34c);
'use strict';
const $cc2ac05ddcef8e7b$export$4aaf3ce7c927d34c = {};

});




parcelRegister("4e8M6", function(module, exports) {

$parcel$export(module.exports, "setVariables", () => $313f46bb97bb8cbe$export$7c38483ff47439d8);
$parcel$export(module.exports, "applySequenceGlobalVars", () => $313f46bb97bb8cbe$export$eba6b21fdce78bcd);
$parcel$export(module.exports, "applySequenceVars", () => $313f46bb97bb8cbe$export$97ab4e7d8ade5018);
$parcel$export(module.exports, "applyMediaSequenceVars", () => $313f46bb97bb8cbe$export$768e417cbfe71417);
parcelRequire("2oe0q");
var $fX7ii = parcelRequire("fX7ii");

var $7KiQp = parcelRequire("7KiQp");

var $4FtMQ = parcelRequire("4FtMQ");

var $28k11 = parcelRequire("28k11");
'use strict';
const $313f46bb97bb8cbe$export$7c38483ff47439d8 = (result, key)=>{
    const CONFIG = (0, $7KiQp.getActiveConfig)();
    const { cssVars: CSS_VARS } = CONFIG;
    if ((0, $fX7ii.isObjectLike)(result.value)) ;
    else CSS_VARS[result.var] = result.value;
};
const $313f46bb97bb8cbe$export$eba6b21fdce78bcd = (vars, obj, options)=>{
    const CONFIG = (0, $7KiQp.getActiveConfig)();
    const { unit: UNIT } = CONFIG;
    const unit = obj.unit || UNIT.default;
    const { base: base, ratio: ratio, type: type } = obj;
    const vp = obj.varPrefix ? obj.varPrefix + '-' : '';
    const prefix = '--' + vp + (type && type.replace('.', '-'));
    vars[`${prefix}-base`] = base;
    vars[`${prefix}-unit`] = unit;
    const ratioVar = `${prefix}-ratio`;
    vars[ratioVar] = ratio;
    const [first, middle, second] = (0, $4FtMQ.getSubratio)(base, ratio);
    vars[`${prefix}-sub-ratio-1`] = `calc(var(${prefix}-ratio) * ${first / ratio})`;
    vars[`${prefix}-sub-ratio-2`] = `calc(var(${prefix}-ratio) * ${middle / ratio})`;
    vars[`${prefix}-sub-ratio-3`] = `calc(var(${prefix}-ratio) * ${second / ratio})`;
// vars[`${prefix}-sub-ratio-1`] = first
// vars[`${prefix}-sub-ratio-2`] = middle
// vars[`${prefix}-sub-ratio-3`] = second
};
// Viewport units are applied to root fontSize only; tokens use 'rem' instead
const $313f46bb97bb8cbe$var$VIEWPORT_UNITS = new Set([
    'vw',
    'vh',
    'vmin',
    'vmax',
    'svw',
    'svh',
    'lvw',
    'lvh',
    'dvw',
    'dvh'
]);
const $313f46bb97bb8cbe$export$97ab4e7d8ade5018 = (FACTORY, options = {})=>{
    const CONFIG = (0, $7KiQp.getActiveConfig)();
    const { unit: UNIT, timing: TIMING, cssVars: CSS_VARS } = CONFIG;
    const rawUnit = FACTORY.unit || UNIT.default;
    const unit = $313f46bb97bb8cbe$var$VIEWPORT_UNITS.has(rawUnit) ? 'rem' : rawUnit;
    const { mediaRegenerate: mediaRegenerate, sequence: sequence, scales: scales } = FACTORY;
    if (!mediaRegenerate) $313f46bb97bb8cbe$export$eba6b21fdce78bcd(CSS_VARS, FACTORY, options);
    for(const key in sequence){
        const item = sequence[key];
        const value = (FACTORY.type === TIMING.type ? sequence[key].val : scales[key]) + unit;
        if (!mediaRegenerate) {
            CSS_VARS[item.variable + '_default'] = value;
            CSS_VARS[item.variable] = item.scalingVariable;
            continue;
        }
        if (options.useDefault === false) CSS_VARS[item.variable] = value;
        else {
            CSS_VARS[item.variable + '_default'] = value;
            CSS_VARS[item.variable] = `var(${item.variable + '_default'})`;
        }
    }
};
const $313f46bb97bb8cbe$export$768e417cbfe71417 = (FACTORY, media, options = {})=>{
    const CONFIG = (0, $7KiQp.getActiveConfig)();
    const { unit: UNIT, media: MEDIA, cssVars: CSS_VARS } = CONFIG;
    const mediaName = media.slice(1);
    const mediaConfig = FACTORY[media];
    const rawMediaUnit = mediaConfig.unit || FACTORY.unit || UNIT.default;
    const unit = $313f46bb97bb8cbe$var$VIEWPORT_UNITS.has(rawMediaUnit) ? 'rem' : rawMediaUnit;
    const { mediaRegenerate: mediaRegenerate } = FACTORY;
    const { sequence: sequence, scales: scales } = mediaConfig;
    const query = MEDIA[mediaName];
    if (!query && CONFIG.verbose) console.warn('Can\'t find media query ', query);
    // if mediaRegenerate is not applied ratio and and sequence sizes
    // will be applied using CSS vars
    if (!mediaRegenerate) {
        let underMediaQuery = CSS_VARS[`@media ${query}`];
        if (!underMediaQuery) underMediaQuery = CSS_VARS[`@media ${query}`] = {};
        $313f46bb97bb8cbe$export$eba6b21fdce78bcd(underMediaQuery, mediaConfig, options);
        // If unit changed, override token vars with new unit values
        const parentUnit = FACTORY.unit || UNIT.default;
        if (unit !== parentUnit && sequence) for(const key in sequence){
            const item = sequence[key];
            const value = scales[key] + unit;
            underMediaQuery[item.variable + '_default'] = value;
            underMediaQuery[item.variable] = value;
        }
        return;
    }
    for(const key in sequence){
        const item = sequence[key];
        const value = ((0, $28k11.isScalingUnit)(unit) ? scales[key] : sequence[key].val) + unit;
        if (!query && CONFIG.verbose) console.warn('Can\'t find query ', query);
        let underMediaQuery = CSS_VARS[`@media ${query}`];
        if (!underMediaQuery) underMediaQuery = CSS_VARS[`@media ${query}`] = {};
        underMediaQuery[item.variable] = `var(${item.variable + '_' + mediaName})`;
        CSS_VARS[item.variable + '_' + mediaName] = value;
    }
};

});

parcelRegister("iIypr", function(module, exports) {

$parcel$export(module.exports, "generateSprite", () => $da07070d258f49a5$export$121b8d85aca89bf6);
$parcel$export(module.exports, "convertSvgToSymbol", () => $da07070d258f49a5$export$510fb280711ea968);
parcelRequire("2oe0q");
var $fX7ii = parcelRequire("fX7ii");
var $kt4aQ = parcelRequire("kt4aQ");

var $7KiQp = parcelRequire("7KiQp");
'use strict';
const $da07070d258f49a5$var$isDev = (0, $kt4aQ.isNotProduction)();
const $da07070d258f49a5$export$121b8d85aca89bf6 = (icons)=>{
    const CONFIG = (0, $7KiQp.getActiveConfig)();
    let sprite = '';
    for(const key in icons){
        if (CONFIG.__svgCache[key]) continue;
        else CONFIG.__svgCache[key] = true;
        sprite += icons[key];
    }
    return sprite;
};
const $da07070d258f49a5$var$parseRootAttributes = (htmlString)=>{
    const val = htmlString.default || htmlString;
    if (!(0, $fX7ii.isString)(val)) {
        if ($da07070d258f49a5$var$isDev) console.warn('parseRootAttributes:', val, 'is not a string');
        return;
    }
    const match = val.match(/<svg\s+(.*?)>/);
    if (!match || !match[1]) return {};
    const attrString = match[1];
    const attrs = attrString.match(/(\S+)=["']?((?:.(?!["']?\s+(?:\S+)=|\s*\/?[>"']))+.)["']?/gm);
    return attrs.reduce((acc, attr)=>{
        const [key, value] = attr.split('=');
        acc[key] = value.replace(/['"]/g, '');
        return acc;
    }, {});
};
const $da07070d258f49a5$var$replaceIdsAndUrls = (code, key)=>{
    const idRegex = /id="([^"]*)"/;
    const urlRegex = /url\(#([^)]*)\)/g;
    const matches = code.match(/id="([^"]*)"/g);
    let replacedCode = code;
    if ((0, $fX7ii.isArray)(matches)) matches.forEach(()=>{
        const randomKey = Math.floor(Math.random() * 100000);
        replacedCode = code.replace(idRegex, `id="${key}-${randomKey}"`).replace(urlRegex, `url(#${key}-${randomKey})`);
    });
    return replacedCode;
};
const $da07070d258f49a5$export$510fb280711ea968 = (key, code)=>{
    const extractAttrs = $da07070d258f49a5$var$parseRootAttributes(code);
    const { width: width, height: height } = extractAttrs;
    const viewBox = extractAttrs.viewBox || `0 0 ${width || 24} ${height || 24}`;
    const xmlns = 'http://www.w3.org/2000/svg';
    const replacedCode = $da07070d258f49a5$var$replaceIdsAndUrls(code, key);
    let symbol = replacedCode.replace('<svg', `<symbol id="${key}" xmlns="${xmlns}" viewBox="${viewBox}"`);
    symbol = symbol.replace(/width="[^"]*"/, '');
    symbol = symbol.replace(/height="[^"]*"/, '');
    symbol = symbol.replace('</svg', '</symbol');
    symbol = $da07070d258f49a5$var$expandSvgSelfClosing(symbol);
    return symbol;
};
// SVG elements that are void in SVG but not in HTML.
// HTML parser treats <line .../> as <line ...> (ignores /), nesting siblings.
// Fix: expand self-closing tags to explicit open+close for HTML parser compat.
const $da07070d258f49a5$var$SVG_VOID_TAGS = 'line|circle|ellipse|rect|polyline|polygon|path|stop|use|image';
const $da07070d258f49a5$var$SVG_SELF_CLOSING_RE = new RegExp(`<(${$da07070d258f49a5$var$SVG_VOID_TAGS})\\b([^>]*?)\\s*/>`, 'g');
const $da07070d258f49a5$var$expandSvgSelfClosing = (str)=>str.replace($da07070d258f49a5$var$SVG_SELF_CLOSING_RE, '<$1$2></$1>');

});


parcelRegister("4bxaE", function(module, exports) {

var $h2nZH = parcelRequire("h2nZH");

var $6VLzn = parcelRequire("6VLzn");

var $kmFEN = parcelRequire("kmFEN");

var $3o9uT = parcelRequire("3o9uT");

var $awIHJ = parcelRequire("awIHJ");

var $6oyfS = parcelRequire("6oyfS");

var $2KAeE = parcelRequire("2KAeE");

var $lWTYl = parcelRequire("lWTYl");

var $nKbE9 = parcelRequire("nKbE9");

var $iKB0v = parcelRequire("iKB0v");
'use strict';
$parcel$exportWildcard(module.exports, $h2nZH);
$parcel$exportWildcard(module.exports, $6VLzn);
$parcel$exportWildcard(module.exports, $kmFEN);
$parcel$exportWildcard(module.exports, $3o9uT);
$parcel$exportWildcard(module.exports, $awIHJ);
$parcel$exportWildcard(module.exports, $6oyfS);
$parcel$exportWildcard(module.exports, $2KAeE);
$parcel$exportWildcard(module.exports, $lWTYl);
$parcel$exportWildcard(module.exports, $nKbE9);
$parcel$exportWildcard(module.exports, $iKB0v);

});
parcelRegister("h2nZH", function(module, exports) {

$parcel$export(module.exports, "getColor", () => $c6753c52b98cd54e$export$5551a2d24ff40153);
$parcel$export(module.exports, "getMediaColor", () => $c6753c52b98cd54e$export$dd72f6d9deea7207);
$parcel$export(module.exports, "setColor", () => $c6753c52b98cd54e$export$130a5dc1bc9cd8e1);
$parcel$export(module.exports, "setGradient", () => $c6753c52b98cd54e$export$afaa8352c6a43a44);
parcelRequire("2oe0q");
var $fX7ii = parcelRequire("fX7ii");

var $7KiQp = parcelRequire("7KiQp");
parcelRequire("a7QGr");
var $2ESw5 = parcelRequire("2ESw5");
'use strict';
const $c6753c52b98cd54e$export$5551a2d24ff40153 = (value, key, config)=>{
    const CONFIG = config || (0, $7KiQp.getActiveConfig)();
    if (!(0, $fX7ii.isString)(value)) {
        if (CONFIG.verbose) console.warn(value, '- type for color is not valid');
        return;
    }
    if ((0, $2ESw5.isCSSVar)(value)) return `var(${value})`;
    if (key && value[key]) value = value[key];
    let name, alpha, tone;
    if ((0, $fX7ii.isArray)(value)) [name, alpha, tone] = value;
    else {
        const parsed = (0, $2ESw5.parseColorToken)(value);
        if (!parsed) {
            // Direct lookup for hyphenated names (e.g. 'gradient-light', 'gradient-dark-active')
            const { color: COLOR, gradient: GRADIENT } = CONFIG;
            const directVal = GRADIENT[value] || COLOR[value];
            if (directVal) return CONFIG.useVariable ? `var(${directVal.var})` : directVal.value;
            return value;
        }
        if (parsed.passthrough) return parsed.passthrough;
        if (parsed.cssVar) return `var(${parsed.cssVar})`;
        name = parsed.name;
        alpha = parsed.alpha;
        tone = parsed.tone;
    }
    const { color: COLOR, gradient: GRADIENT } = CONFIG;
    let val = COLOR[name] || GRADIENT[name];
    if (!val) {
        if (CONFIG.verbose) console.warn('Can\'t find color ', name);
        return value;
    }
    if (key) {
        if (val[key]) val = val[key];
        else if (CONFIG.verbose) console.warn(value, ' - does not have ', key);
    }
    // TODO: support variables
    // if (alpha) return `rgba(var(${val[shade || ''].var}), ${modifier})`
    let rgb = val.rgb;
    if (!rgb) return CONFIG.useVariable ? `var(${val.var})` : val.value;
    if (tone && !val[tone]) {
        rgb = (0, $2ESw5.getRgbTone)(rgb, tone);
        val[tone] = {
            rgb: rgb,
            var: `${val.var}-${tone}`
        };
    }
    if (val[tone]) rgb = val[tone].rgb;
    if (alpha) return `rgba(${rgb}, ${alpha})`;
    if (tone) return `rgba(${rgb}, 1)`;
    return CONFIG.useVariable ? `var(${val.var})` : `rgb(${rgb})`;
};
const $c6753c52b98cd54e$export$dd72f6d9deea7207 = (value, globalTheme, config)=>{
    const CONFIG = config || (0, $7KiQp.getActiveConfig)();
    if (!globalTheme) globalTheme = CONFIG.globalTheme === 'auto' ? null : CONFIG.globalTheme;
    if (!(0, $fX7ii.isString)(value)) {
        if (CONFIG.verbose) console.warn(value, '- type for color is not valid');
        return;
    }
    if ((0, $2ESw5.isCSSVar)(value)) return `var(${value})`;
    let name;
    if ((0, $fX7ii.isArray)(value)) name = value[0];
    else {
        const parsed = (0, $2ESw5.parseColorToken)(value);
        if (!parsed) return value;
        if (parsed.passthrough) return parsed.passthrough;
        if (parsed.cssVar) return `var(${parsed.cssVar})`;
        name = parsed.name;
    }
    const { color: COLOR, gradient: GRADIENT } = CONFIG;
    const val = COLOR[name] || GRADIENT[name];
    const isObj = (0, $fX7ii.isObject)(val);
    if (isObj && val.value) return $c6753c52b98cd54e$export$5551a2d24ff40153(value, `@${globalTheme}`, config);
    else if (isObj) {
        // Prefer the adaptive var (--color-NAME) when available so runtime theme
        // switches via [data-theme] actually take effect. Without this, setting
        // `globalTheme: 'dark'` in config would lock every color to the dark
        // scheme-specific var (--color-NAME-dark), which never responds to
        // runtime theme toggles.
        if (CONFIG.useVariable && val.var) return `var(${val.var})`;
        if (globalTheme) return $c6753c52b98cd54e$export$5551a2d24ff40153(value, `@${globalTheme}`, config);
        else {
            // Legacy fallback when adaptive var is unavailable (useVariable: false).
            // Only @-prefixed keys are scheme variants — skip metadata like `var`.
            const obj = {};
            for(const mediaName in val){
                if (mediaName.charCodeAt(0) !== 64 /* @ */ ) continue;
                const query = CONFIG.media[mediaName.slice(1)];
                if (!query) continue;
                const media = '@media ' + (query === 'print' ? `${query}` : `screen and ${query}`);
                obj[media] = $c6753c52b98cd54e$export$5551a2d24ff40153(value, mediaName, config);
            }
            return obj;
        }
    } else {
        if (CONFIG.verbose) console.warn('Can\'t find color', value);
        return value;
    }
};
const $c6753c52b98cd54e$export$130a5dc1bc9cd8e1 = (val, key, suffix)=>{
    const CONFIG = (0, $7KiQp.getActiveConfig)();
    if ((0, $fX7ii.isString)(val) && (0, $2ESw5.isCSSVar)(val)) {
        const rawRef = val.slice(2);
        val = $c6753c52b98cd54e$export$5551a2d24ff40153(rawRef);
        if (!(val.includes('rgb') || val.includes('var') || val.includes('#'))) {
            // Handle space-separated format: '--colorName alpha' (e.g. '--gray1 1')
            const parts = rawRef.split(' ');
            let refColor = CONFIG.color[parts[0]];
            // Lazy resolution: composite colors (arrays/objects) often reference
            // primitives by name. If iteration order processed the composite first,
            // the primitive is still its raw input — process it now so this
            // dereference works regardless of key order in CONFIG.color. setEach()
            // also pre-sorts so primitives go first, but this is a safety net.
            if (refColor && !refColor.value && !refColor.rgb && ((0, $fX7ii.isString)(refColor) || (0, $fX7ii.isArray)(refColor) || (0, $fX7ii.isObject)(refColor))) {
                CONFIG.color[parts[0]] = $c6753c52b98cd54e$export$130a5dc1bc9cd8e1(refColor, parts[0]);
                refColor = CONFIG.color[parts[0]];
            }
            if (refColor && refColor.value) {
                let rgb = refColor.rgb;
                const alpha = parts[1] !== undefined ? parts[1] : '1';
                const tone = parts[2];
                if (tone) rgb = (0, $2ESw5.getRgbTone)(rgb, tone);
                val = `rgba(${rgb}, ${alpha})`;
            } else {
                // Try to resolve as CSS keyword color with tone modifier
                const tone = parts[2];
                const alpha = parts[1] !== undefined ? parts[1] : '1';
                if (tone) try {
                    const rgb = (0, $2ESw5.colorStringToRgbaArray)(parts[0]);
                    if (rgb && rgb.length >= 3) {
                        const tonedRgb = (0, $2ESw5.getRgbTone)(rgb.slice(0, 3).join(', '), tone);
                        val = `rgba(${tonedRgb}, ${alpha})`;
                    } else val = parts[0];
                } catch (e) {
                    val = parts[0];
                }
                else val = parts[0];
            }
        }
    }
    // Normalize array shorthand `[lightVal, darkVal]` to scheme-keyed object
    // so the multi-scheme branch below handles both cases uniformly.
    if ((0, $fX7ii.isArray)(val)) val = {
        '@light': val[0],
        '@dark': val[1]
    };
    if ((0, $fX7ii.isObject)(val)) {
        const obj = {};
        for(const variant in val)obj[variant] = $c6753c52b98cd54e$export$130a5dc1bc9cd8e1(val[variant], key, variant.slice(0, 1) === '@' ? variant.slice(1) : variant);
        // Generate a single adaptive `--color-${key}` CSS var so consumers can
        // write `border-color: var(--color-${key})` and have it switch via
        // `@media (prefers-color-scheme)` and `[data-theme]` automatically.
        // Scheme-agnostic: works for @light/@dark plus arbitrary custom schemes
        // (@ocean, @sunset, etc). Mirrors generateAutoVars() in system/theme.js.
        //
        // Without this, getMediaColor() falls into the @media-keyed-object branch
        // (when globalTheme === 'auto'), which the CSS engine cannot serialize as
        // a single CSS property value — emitting broken rules like
        // `.classname borderrightcolor { }`.
        if (CONFIG.useVariable) {
            const vp = CONFIG.varPrefix ? CONFIG.varPrefix + '-' : '';
            const adaptiveVar = `--${vp}color-${key}`;
            let fallbackValue;
            const schemeValues = {};
            for(const variant in obj){
                if (variant.charCodeAt(0) !== 64 /* @ */ ) continue;
                const scheme = variant.slice(1);
                const entry = obj[variant];
                const value = entry && (entry.value || entry);
                if (!value || typeof value !== 'string') continue;
                schemeValues[scheme] = value;
                // Prefer 'light' as the :root fallback; otherwise first resolved scheme.
                if (scheme === 'light' || fallbackValue === undefined) fallbackValue = value;
            }
            if (fallbackValue !== undefined) {
                CONFIG.cssVars[adaptiveVar] = fallbackValue;
                if (!CONFIG.cssMediaVars) CONFIG.cssMediaVars = {};
                for(const scheme in schemeValues){
                    // [data-theme] selector — works for ANY scheme (including custom ones)
                    const sel = `[data-theme="${scheme}"]`;
                    if (!CONFIG.cssMediaVars[sel]) CONFIG.cssMediaVars[sel] = {};
                    CONFIG.cssMediaVars[sel][adaptiveVar] = schemeValues[scheme];
                    // prefers-color-scheme media query — only browsers know light/dark
                    if (scheme === 'light' || scheme === 'dark') {
                        const mq = `@media (prefers-color-scheme: ${scheme})`;
                        if (!CONFIG.cssMediaVars[mq]) CONFIG.cssMediaVars[mq] = {};
                        CONFIG.cssMediaVars[mq][adaptiveVar] = schemeValues[scheme];
                    }
                }
                // Expose the adaptive var on the wrapper so getColor() returns it
                // directly when called without an explicit @scheme key.
                obj.var = adaptiveVar;
            }
        }
        return obj;
    }
    const vp = CONFIG.varPrefix ? CONFIG.varPrefix + '-' : '';
    const CSSVar = `--${vp}color-${key}` + (suffix ? `-${suffix}` : '');
    // Resolve dot notation: 'green.08' → take green color at 8% opacity
    let resolvedVal = val.value || val;
    if ((0, $fX7ii.isString)(resolvedVal) && resolvedVal.includes('.') && !resolvedVal.includes('(')) {
        const [colorRef, alphaStr] = resolvedVal.split('.');
        const refColor = CONFIG.color[colorRef];
        if (refColor && refColor.rgb) resolvedVal = `rgba(${refColor.rgb}, ${parseFloat('0.' + alphaStr) || 1})`;
    }
    // Resolve token notation: 'gray-168' / 'gray+50' / 'gray=90' → apply tone to base
    if ((0, $fX7ii.isString)(resolvedVal) && !resolvedVal.includes('(') && !resolvedVal.startsWith('#')) {
        const parsed = (0, $2ESw5.parseColorToken)(resolvedVal);
        if (parsed && parsed.name && !parsed.passthrough && !parsed.cssVar) {
            const refColor = CONFIG.color[parsed.name];
            if (refColor && !refColor.value && !refColor.rgb && ((0, $fX7ii.isString)(refColor) || (0, $fX7ii.isArray)(refColor) || (0, $fX7ii.isObject)(refColor))) CONFIG.color[parsed.name] = $c6753c52b98cd54e$export$130a5dc1bc9cd8e1(refColor, parsed.name);
            const baseColor = CONFIG.color[parsed.name];
            if (baseColor && baseColor.rgb) {
                let rgb = baseColor.rgb;
                if (parsed.tone) rgb = (0, $2ESw5.getRgbTone)(rgb, parsed.tone);
                const alphaVal = parsed.alpha ? parseFloat(parsed.alpha) : 1;
                resolvedVal = `rgba(${rgb}, ${alphaVal})`;
            }
        }
    }
    const colorArr = (0, $2ESw5.colorStringToRgbaArray)(resolvedVal);
    const [r, g, b, a = 1] = colorArr;
    const alpha = parseFloat(a.toFixed(2));
    const rgb = `${r}, ${g}, ${b}`;
    const value = `rgba(${rgb}, ${alpha})`;
    if (CONFIG.useVariable) CONFIG.cssVars[CSSVar] = value;
    return {
        var: CSSVar,
        rgb: rgb,
        alpha: alpha,
        value: value
    };
};
const $c6753c52b98cd54e$export$afaa8352c6a43a44 = (val, key, suffix)=>{
    const CONFIG = (0, $7KiQp.getActiveConfig)();
    if ((0, $fX7ii.isString)(val) && (0, $2ESw5.isCSSVar)(val)) val = $c6753c52b98cd54e$export$5551a2d24ff40153(val.slice(2));
    if ((0, $fX7ii.isArray)(val)) return {
        '@light': $c6753c52b98cd54e$export$afaa8352c6a43a44(val[0], key, 'light'),
        '@dark': $c6753c52b98cd54e$export$afaa8352c6a43a44(val[0], key, 'dark')
    };
    if ((0, $fX7ii.isObject)(val)) {
        const obj = {};
        for(const variant in val)obj[variant] = $c6753c52b98cd54e$export$afaa8352c6a43a44(val[variant], key, variant.slice(0, 1) === '@' ? variant.slice(1) : variant);
        return obj;
    }
    const vp = CONFIG.varPrefix ? CONFIG.varPrefix + '-' : '';
    const CSSVar = `--${vp}gradient-${key}` + (suffix ? `-${suffix}` : '');
    if (CONFIG.useVariable) CONFIG.cssVars[CSSVar] = val.value || val;
    return {
        var: CSSVar,
        value: val.value || val
    };
};

});

parcelRegister("6VLzn", function(module, exports) {

$parcel$export(module.exports, "getTheme", () => $50bcf74814855f89$export$89cbf1a0881c8b9c);
$parcel$export(module.exports, "getMediaTheme", () => $50bcf74814855f89$export$b3cf7317de2f2233);
$parcel$export(module.exports, "setTheme", () => $50bcf74814855f89$export$2e49b867b7a0847c);
$parcel$export(module.exports, "setMediaTheme", () => $50bcf74814855f89$export$c57b11cd015ce162);

var $h2nZH = parcelRequire("h2nZH");

var $7KiQp = parcelRequire("7KiQp");

var $2ESw5 = parcelRequire("2ESw5");
parcelRequire("2oe0q");
var $fX7ii = parcelRequire("fX7ii");
'use strict';
// Common CSS named colors — used to distinguish valid CSS color names
// from unresolved design-system tokens (e.g. 'blackRussian', 'grayMid')
const $50bcf74814855f89$var$CSS_NAMED_COLORS = new Set([
    'black',
    'white',
    'red',
    'green',
    'blue',
    'yellow',
    'orange',
    'purple',
    'pink',
    'brown',
    'gray',
    'grey',
    'cyan',
    'magenta',
    'lime',
    'olive',
    'navy',
    'teal',
    'aqua',
    'maroon',
    'silver',
    'fuchsia',
    'transparent',
    'currentColor',
    'currentcolor',
    'inherit',
    'initial',
    'unset',
    'none',
    'aliceblue',
    'antiquewhite',
    'aquamarine',
    'azure',
    'beige',
    'bisque',
    'blanchedalmond',
    'blueviolet',
    'burlywood',
    'cadetblue',
    'chartreuse',
    'chocolate',
    'coral',
    'cornflowerblue',
    'cornsilk',
    'crimson',
    'darkblue',
    'darkcyan',
    'darkgoldenrod',
    'darkgray',
    'darkgreen',
    'darkgrey',
    'darkkhaki',
    'darkmagenta',
    'darkolivegreen',
    'darkorange',
    'darkorchid',
    'darkred',
    'darksalmon',
    'darkseagreen',
    'darkslateblue',
    'darkslategray',
    'darkslategrey',
    'darkturquoise',
    'darkviolet',
    'deeppink',
    'deepskyblue',
    'dimgray',
    'dimgrey',
    'dodgerblue',
    'firebrick',
    'floralwhite',
    'forestgreen',
    'gainsboro',
    'ghostwhite',
    'gold',
    'goldenrod',
    'greenyellow',
    'honeydew',
    'hotpink',
    'indianred',
    'indigo',
    'ivory',
    'khaki',
    'lavender',
    'lavenderblush',
    'lawngreen',
    'lemonchiffon',
    'lightblue',
    'lightcoral',
    'lightcyan',
    'lightgoldenrodyellow',
    'lightgray',
    'lightgreen',
    'lightgrey',
    'lightpink',
    'lightsalmon',
    'lightseagreen',
    'lightskyblue',
    'lightslategray',
    'lightslategrey',
    'lightsteelblue',
    'lightyellow',
    'limegreen',
    'linen',
    'mediumaquamarine',
    'mediumblue',
    'mediumorchid',
    'mediumpurple',
    'mediumseagreen',
    'mediumslateblue',
    'mediumspringgreen',
    'mediumturquoise',
    'mediumvioletred',
    'midnightblue',
    'mintcream',
    'mistyrose',
    'moccasin',
    'navajowhite',
    'oldlace',
    'olivedrab',
    'orangered',
    'orchid',
    'palegoldenrod',
    'palegreen',
    'paleturquoise',
    'palevioletred',
    'papayawhip',
    'peachpuff',
    'peru',
    'plum',
    'powderblue',
    'rosybrown',
    'royalblue',
    'saddlebrown',
    'salmon',
    'sandybrown',
    'seagreen',
    'seashell',
    'sienna',
    'skyblue',
    'slateblue',
    'slategray',
    'slategrey',
    'snow',
    'springgreen',
    'steelblue',
    'tan',
    'thistle',
    'tomato',
    'turquoise',
    'violet',
    'wheat',
    'whitesmoke',
    'yellowgreen',
    'rebeccapurple'
]);
// A theme param is treated as a color-producing property when its name
// contains one of these substrings. Mirrors the check in `setThemeValue`
// so the broken-scheme pre-scan skips non-color props like `borderStyle`,
// `boxShadow`, `backdropFilter`, `cursor`, etc. that would otherwise trip
// the `/^[a-z][a-zA-Z]+$/` heuristic with values like 'solid' or 'pointer'.
const $50bcf74814855f89$var$COLOR_PARAM_TOKENS = [
    'color',
    'Color',
    'background',
    'Background',
    'fill',
    'Fill',
    'stroke',
    'Stroke'
];
const $50bcf74814855f89$var$isColorParam = (param)=>{
    for(let i = 0; i < $50bcf74814855f89$var$COLOR_PARAM_TOKENS.length; i++){
        if (param.includes($50bcf74814855f89$var$COLOR_PARAM_TOKENS[i])) return true;
    }
    return false;
};
const $50bcf74814855f89$var$setThemeValue = (theme)=>{
    const value = {};
    const { state: state, media: media, helpers: helpers, ...rest } = theme;
    const keys = Object.keys(rest);
    keys.map((key)=>{
        const conditions = [
            'color',
            'Color',
            'background',
            'border'
        ];
        const isColor = conditions.some((k)=>key.includes(k));
        return value[key] = isColor ? (0, $h2nZH.getColor)(theme[key]) : theme[key];
    });
    return value;
};
const $50bcf74814855f89$var$getThemeValue = (theme)=>{
    if (theme.value) return theme.value;
    theme.value = $50bcf74814855f89$var$setThemeValue(theme);
    return theme.value;
};
const $50bcf74814855f89$export$89cbf1a0881c8b9c = (value, modifier)=>{
    const CONFIG = (0, $7KiQp.getActiveConfig)();
    if (CONFIG.useVariable) return $50bcf74814855f89$export$b3cf7317de2f2233(value, modifier);
    const THEME = CONFIG.theme;
    if ((0, $fX7ii.isString)(value)) {
        const [theme, subtheme] = value.split(' ');
        const isOurTheme = THEME[theme];
        if (isOurTheme) {
            if (!subtheme && !modifier) return $50bcf74814855f89$var$getThemeValue(isOurTheme);
            value = [
                theme,
                subtheme || modifier
            ];
        }
    }
    if ((0, $fX7ii.isObjectLike)(value) && value[1]) {
        const themeName = value[0];
        const subThemeName = value[1];
        const { helpers: helpers, media: media, state: state } = THEME[themeName];
        if (media && media[subThemeName]) return $50bcf74814855f89$var$getThemeValue(media[subThemeName]);
        if (helpers && helpers[subThemeName]) return $50bcf74814855f89$var$getThemeValue(helpers[subThemeName]);
        if (state && state[subThemeName]) return $50bcf74814855f89$var$getThemeValue(state[subThemeName]);
    } else if ((0, $fX7ii.isObject)(value)) return $50bcf74814855f89$var$setThemeValue(value);
};
const $50bcf74814855f89$var$setInverseTheme = (theme, variant, value)=>{
    if ((0, $fX7ii.isObject)(variant)) theme.variants.inverse.value = $50bcf74814855f89$var$setThemeValue(variant);
    else if (variant === true) {
        const { color: color, background: background } = value;
        theme.variants.inverse = {
            value: {
                color: background,
                background: color
            }
        };
    }
};
const $50bcf74814855f89$var$setPseudo = (theme, key, variant, themeValue)=>{
    const result = $50bcf74814855f89$export$89cbf1a0881c8b9c(variant);
    themeValue[`&:${key}`] = result;
    if ((0, $fX7ii.isObject)(variant) && !variant.value) variant.value = result;
};
const $50bcf74814855f89$var$setSelectors = (theme, value)=>{
    const { state: state } = theme;
    if (!state) return;
    const keys = Object.keys(state);
    keys.map((key)=>{
        const variant = state[key];
        $50bcf74814855f89$var$setPseudo(theme, key, variant, value);
        return theme;
    });
    return theme;
};
const $50bcf74814855f89$var$setPrefersScheme = (theme, key, variant, themeValue)=>{
    const result = $50bcf74814855f89$export$89cbf1a0881c8b9c(variant);
    themeValue[`@media (prefers-color-scheme: ${key})`] = result;
    if ((0, $fX7ii.isObject)(variant) && !variant.value) variant.value = result;
};
const $50bcf74814855f89$var$setMedia = (theme, value)=>{
    const { media: media } = theme;
    if (!media) return;
    const keys = Object.keys(media);
    keys.map((key)=>{
        const variant = media[key];
        if (key === 'dark' || key === 'light') $50bcf74814855f89$var$setPrefersScheme(theme, key, variant, value);
        if (key === 'inverse') $50bcf74814855f89$var$setInverseTheme(theme, variant, value);
        return theme;
    });
    return theme;
};
const $50bcf74814855f89$var$setHelpers = (theme, value)=>{
    const CONFIG = (0, $7KiQp.getActiveConfig)();
    const { helpers: helpers } = theme;
    if (!helpers) return;
    const keys = Object.keys(helpers);
    keys.map((key)=>{
        const helper = helpers[key];
        if ((0, $fX7ii.isString)(helper)) helpers[key] = CONFIG.theme[helper];
        else $50bcf74814855f89$var$getThemeValue(helpers[key]);
        return theme;
    });
    return theme;
};
const $50bcf74814855f89$export$2e49b867b7a0847c = (val, key)=>{
    const CONFIG = (0, $7KiQp.getActiveConfig)();
    if (CONFIG.useVariable) return $50bcf74814855f89$export$c57b11cd015ce162(val, key);
    const { state: state, media: media, helpers: helpers } = val;
    const value = $50bcf74814855f89$var$setThemeValue(val, key);
    const vp = CONFIG.varPrefix ? CONFIG.varPrefix + '-' : '';
    const CSSvar = `--${vp}theme-${key}`;
    $50bcf74814855f89$var$setSelectors(val, value);
    $50bcf74814855f89$var$setMedia(val, value);
    $50bcf74814855f89$var$setHelpers(val, value);
    return {
        var: CSSvar,
        value: value,
        state: state,
        media: media,
        helpers: helpers
    };
};
const $50bcf74814855f89$var$keySetters = {
    '@': (theme, value)=>$50bcf74814855f89$var$setMedia(theme, value),
    ':': (theme, value)=>$50bcf74814855f89$var$setSelectors(theme, value),
    '.': (theme, value)=>$50bcf74814855f89$var$setHelpers(theme, value)
};
/**
 * Recursively generates auto-switching CSS vars from all @-scheme content.
 * - @dark/@light: uses prefers-color-scheme media queries + [data-theme] selectors
 * - Custom @schemes (@ocean, @sunset, etc.): uses [data-theme] selectors only
 * - globalTheme forced: sets non-suffixed vars directly in CSS_VARS
 *
 * @param {Object} schemes - { dark: {...}, light: {...}, ocean: {...} }
 * @param {string} varPrefix - var name prefix (e.g. 'document', 'primary-child')
 * @param {Object} CONFIG - active config
 */ const $50bcf74814855f89$var$generateAutoVars = (schemes, varPrefix, CONFIG)=>{
    const { cssVars: CSS_VARS } = CONFIG;
    if (!CONFIG.cssMediaVars) CONFIG.cssMediaVars = {};
    const MEDIA_VARS = CONFIG.cssMediaVars;
    const globalTheme = CONFIG.globalTheme !== undefined ? CONFIG.globalTheme : 'auto';
    const result = {};
    // Collect union of all keys across all schemes
    const allKeys = new Set();
    for(const scheme in schemes){
        if (schemes[scheme]) for (const k of Object.keys(schemes[scheme]))allKeys.add(k);
    }
    // Pre-scan: detect schemes with unresolvable color values. If any color in
    // a scheme fails to resolve, skip the ENTIRE scheme to avoid partial theme
    // application (e.g. white text without a dark background). Runs regardless
    // of `globalTheme` because every scheme is always emitted now.
    //
    // Only check params whose names indicate colors — otherwise legitimate
    // non-color values like `borderStyle: 'solid'` or `cursor: 'pointer'`
    // match the `/^[a-z][a-zA-Z]+$/` heuristic and falsely break the scheme,
    // which would silently drop the entire theme's CSS vars.
    const brokenSchemes = new Set();
    for (const param of allKeys){
        const symb = param.slice(0, 1);
        if (symb === '@' || symb === '.' || symb === ':') continue;
        if (!$50bcf74814855f89$var$isColorParam(param)) continue;
        for(const scheme in schemes){
            if (brokenSchemes.has(scheme)) continue;
            const val = schemes[scheme]?.[param];
            if (val === undefined) continue;
            const color = (0, $h2nZH.getColor)(val, `@${scheme}`);
            if (color === undefined) continue;
            if ((0, $fX7ii.isString)(color) && /^[a-z][a-zA-Z]+$/.test(color) && !$50bcf74814855f89$var$CSS_NAMED_COLORS.has(color)) brokenSchemes.add(scheme);
        }
    }
    for (const param of allKeys){
        const symb = param.slice(0, 1);
        // Check if any scheme has an object value for this param
        const hasObject = Object.values(schemes).some((s)=>(0, $fX7ii.isObjectLike)(s?.[param]));
        if (symb === '.' && hasObject) {
            // Dot helper (.color-only, .child, etc.) — recurse
            const helperName = param.slice(1);
            const subSchemes = {};
            for(const scheme in schemes)if ((0, $fX7ii.isObjectLike)(schemes[scheme]?.[param])) subSchemes[scheme] = schemes[scheme][param];
            result[param] = $50bcf74814855f89$var$generateAutoVars(subSchemes, `${varPrefix}-${helperName}`, CONFIG);
        } else if (symb === ':' && hasObject) {
            // Pseudo selector (:hover, ::placeholder) — recurse
            const pseudoName = param.replace(/^:+/, '');
            const subSchemes = {};
            for(const scheme in schemes)if ((0, $fX7ii.isObjectLike)(schemes[scheme]?.[param])) subSchemes[scheme] = schemes[scheme][param];
            result[param] = $50bcf74814855f89$var$generateAutoVars(subSchemes, `${varPrefix}-${pseudoName}`, CONFIG);
        } else if (symb !== '@' && symb !== '.' && symb !== ':') {
            // Regular CSS param — generate auto-switching var.
            //
            // We always emit the FULL switch table — `:root` fallback + one
            // rule per scheme on `[data-theme="X"]` + `@media
            // (prefers-color-scheme: dark|light)` — regardless of whether the
            // user provided an initial `globalTheme`. A forced initial theme
            // only decides which value lands in the `:root` fallback; runtime
            // switching (via `changeGlobalTheme` → `data-theme` attribute)
            // must always work, and OS preference must still drive auto mode.
            const vp = CONFIG.varPrefix ? CONFIG.varPrefix + '-' : '';
            const autoVar = `--${vp}theme-${varPrefix}-${param}`;
            const forced = globalTheme && globalTheme !== 'auto' ? String(globalTheme).replace(/^'|'$/g, '') : null;
            let fallbackColor;
            for(const scheme in schemes){
                if (brokenSchemes.has(scheme)) continue;
                const val = schemes[scheme]?.[param];
                if (val === undefined) continue;
                const color = (0, $h2nZH.getColor)(val, `@${scheme}`);
                if (color === undefined) continue;
                // Pick the `:root` fallback: prefer the user's forced scheme if
                // any, else `light`, else the first resolved scheme.
                if (forced && scheme === forced || !forced && (scheme === 'light' || fallbackColor === undefined)) fallbackColor = color;
                // `[data-theme="X"]` selector — works for any scheme incl. custom.
                const selector = `[data-theme="${scheme}"]`;
                if (!MEDIA_VARS[selector]) MEDIA_VARS[selector] = {};
                MEDIA_VARS[selector][autoVar] = color;
                // `prefers-color-scheme` media query only for standard light/dark.
                if (scheme === 'dark' || scheme === 'light') {
                    const mq = `@media (prefers-color-scheme: ${scheme})`;
                    if (!MEDIA_VARS[mq]) MEDIA_VARS[mq] = {};
                    MEDIA_VARS[mq][autoVar] = color;
                }
            }
            if (fallbackColor !== undefined) CSS_VARS[autoVar] = fallbackColor;
            result[param] = `var(${autoVar})`;
            result[`.${param}`] = {
                [param]: result[param]
            };
        }
    }
    if (result.background || result.color || result.backgroundColor) result['.inversed'] = {
        color: result.background || result.backgroundColor,
        background: result.color
    };
    return result;
};
const $50bcf74814855f89$export$c57b11cd015ce162 = (val, key, suffix, prefers)=>{
    const CONFIG = (0, $7KiQp.getActiveConfig)();
    const { cssVars: CSS_VARS } = CONFIG;
    const theme = {
        value: val
    };
    const isTopLevel = !suffix && !prefers;
    if ((0, $fX7ii.isObjectLike)(val)) {
        // At top level: collect all @-schemes and generate auto-switching vars
        if (isTopLevel && CONFIG.useVariable) {
            const schemes = {};
            for(const param in val)if (param.startsWith('@') && (0, $fX7ii.isObjectLike)(val[param])) schemes[param.slice(1)] = val[param];
            if (Object.keys(schemes).length) {
                const autoResult = $50bcf74814855f89$var$generateAutoVars(schemes, key, CONFIG);
                Object.assign(theme, autoResult);
            }
        }
        for(const param in val){
            const symb = param.slice(0, 1);
            const value = val[param];
            if (symb === '@' || symb === ':' || symb === '.') {
                const hasPrefers = symb === '@' && param;
                theme[param] = $50bcf74814855f89$export$c57b11cd015ce162(value, key, param, prefers || hasPrefers);
            } else if (!isTopLevel) {
                const color = (0, $h2nZH.getColor)(value, prefers);
                const metaSuffixes = [
                    ...new Set([
                        prefers,
                        suffix
                    ].filter((v)=>v).map((v)=>v.slice(1)))
                ];
                const varmetaSuffixName = metaSuffixes.length ? '-' + metaSuffixes.join('-') : '';
                const vp = CONFIG.varPrefix ? CONFIG.varPrefix + '-' : '';
                const CSSVar = `--${vp}theme-${key}${varmetaSuffixName}-${param}`;
                if (CONFIG.useVariable) {
                    // Suffixed vars (--theme-key-dark-param) only when opted in
                    if (CONFIG.useThemeSuffixedVars) CSS_VARS[CSSVar] = color;
                    theme[param] = `var(${CSSVar})`;
                } else theme[param] = color;
                theme[`.${param}`] = {
                    [param]: theme[param]
                };
            }
        }
        // Only add .inversed if not already set by generateAutoVars
        if (!theme['.inversed'] && (theme.background || theme.color || theme.backgroundColor)) theme['.inversed'] = {
            color: theme.background || theme.backgroundColor,
            background: theme.color
        };
    }
    if ((0, $fX7ii.isString)(val) && (0, $2ESw5.isCSSVar)(val)) {
        const THEME = CONFIG.theme;
        const value = THEME[val.slice(2)];
        const getReferenced = $50bcf74814855f89$export$b3cf7317de2f2233(value, prefers);
        return getReferenced;
    }
    return theme;
};
const $50bcf74814855f89$var$recursiveTheme = (val)=>{
    const CONFIG = (0, $7KiQp.getActiveConfig)();
    const obj = {};
    for(const param in val){
        const symb = param.slice(0, 1);
        if ((0, $fX7ii.isObjectLike)(val[param])) {
            if (symb === '@') continue;
            else if (symb === ':') obj[`&${param}`] = $50bcf74814855f89$var$recursiveTheme(val[param]);
            else if (symb === '.') obj[`&${param}`] = $50bcf74814855f89$var$recursiveTheme(val[param]);
        } else obj[param] = val[param];
    }
    return obj;
};
const $50bcf74814855f89$var$findModifierFromArray = (val, modifierArray)=>{
    const currentMod = modifierArray.shift();
    if (val[currentMod]) return $50bcf74814855f89$var$findModifierFromArray(val[currentMod], modifierArray);
    return val;
};
const $50bcf74814855f89$var$findModifier = (val, modifier)=>{
    if ((0, $fX7ii.isArray)(modifier)) return $50bcf74814855f89$var$findModifierFromArray(val, modifier);
    else if ((0, $fX7ii.isString)(modifier) && val[modifier]) return val[modifier];
    else return val;
};
const $50bcf74814855f89$var$checkForReference = (val, callback)=>{
    if ((0, $fX7ii.isString)(val) && (0, $2ESw5.isCSSVar)(val)) return $50bcf74814855f89$export$b3cf7317de2f2233(val.slice(2));
    return val;
};
const $50bcf74814855f89$var$checkThemeReference = (val)=>$50bcf74814855f89$var$checkForReference(val, $50bcf74814855f89$var$checkThemeReference) // eslint-disable-line
;
const $50bcf74814855f89$export$b3cf7317de2f2233 = (value, modifier)=>{
    const activeConfig = (0, $7KiQp.getActiveConfig)();
    if ((0, $fX7ii.isString)(value) && (0, $2ESw5.isCSSVar)(value)) value = $50bcf74814855f89$export$b3cf7317de2f2233(value.slice(2));
    if (!value || !(0, $fX7ii.isString)(value)) {
        if (activeConfig.verbose) console.warn(`${value} - Theme is not a string`);
        return;
    }
    const [themeName, ...themeModifiers] = (0, $fX7ii.isArray)(value) ? value : value.split(' ');
    let themeValue = activeConfig.theme[themeName];
    if (themeValue && themeModifiers.length) themeValue = $50bcf74814855f89$var$findModifier(themeValue, themeModifiers);
    else if (themeValue && modifier) themeValue = $50bcf74814855f89$var$findModifier(themeValue, modifier);
    const resolvedTheme = $50bcf74814855f89$var$recursiveTheme(themeValue);
    return resolvedTheme;
};

});

parcelRegister("kmFEN", function(module, exports) {

$parcel$export(module.exports, "setFont", () => $ed362cf167c3740b$export$69e9bdef456a9c46);
$parcel$export(module.exports, "getFontFamily", () => $ed362cf167c3740b$export$c4930fc256cef44f);
$parcel$export(module.exports, "setFontFamily", () => $ed362cf167c3740b$export$5fae120d779aafec);
parcelRequire("2oe0q");
var $fuahe = parcelRequire("fuahe");
var $fX7ii = parcelRequire("fX7ii");

var $7KiQp = parcelRequire("7KiQp");
parcelRequire("a7QGr");
var $ePlkR = parcelRequire("ePlkR");
'use strict';
const $ed362cf167c3740b$export$69e9bdef456a9c46 = (val, key)=>{
    const CONFIG = (0, $7KiQp.getActiveConfig)();
    const CSSvar = `--font-${key}`;
    if (!val || (0, $fX7ii.isArray)(val) && !val[0]) return;
    let fontFace;
    if (val.isVariable) {
        const url = (0, $ePlkR.resolveFileUrl)(val.url, CONFIG.files) || val.url;
        if ((0, $ePlkR.isGoogleFontsUrl)(url)) fontFace = (0, $ePlkR.setFontImport)(url);
        else fontFace = (0, $ePlkR.setCustomFontMedia)(key, url, val.fontWeight, {
            fontStretch: val.fontStretch,
            fontDisplay: val.fontDisplay || 'swap'
        });
    } else if (val[0]) fontFace = (0, $ePlkR.getFontFaceEach)(key, val, CONFIG.files);
    else {
        const url = Array.isArray(val.url) ? val.url.map((u)=>(0, $ePlkR.resolveFileUrl)(u, CONFIG.files) || u) : (0, $ePlkR.resolveFileUrl)(val.url, CONFIG.files) || val.url;
        fontFace = (0, $ePlkR.setCustomFontMedia)(key, url, val.fontWeight, {
            fontStyle: val.fontStyle,
            fontDisplay: val.fontDisplay,
            fontStretch: val.fontStretch
        });
    }
    return {
        var: CSSvar,
        value: val,
        fontFace: fontFace
    };
};
const $ed362cf167c3740b$export$c4930fc256cef44f = (key, factory)=>{
    const CONFIG = (0, $7KiQp.getActiveConfig)();
    const { fontFamily: FONT_FAMILY } = CONFIG;
    return (0, $ePlkR.getDefaultOrFirstKey)(factory || FONT_FAMILY, key);
};
const $ed362cf167c3740b$export$5fae120d779aafec = (val, key)=>{
    const CONFIG = (0, $7KiQp.getActiveConfig)();
    const { fontFamily: FONT_FAMILY, fontFamilyTypes: FONT_FAMILY_TYPES } = CONFIG;
    let { value: value, type: type } = val;
    if (val.isDefault) FONT_FAMILY.default = key;
    if ((0, $fX7ii.isObject)(value)) value = (0, $fuahe.arrayzeValue)(value);
    const CSSvar = `--font-family-${key}`;
    const str = `${value.join(', ')}, ${FONT_FAMILY_TYPES[type]}`;
    return {
        var: CSSvar,
        value: str,
        arr: value,
        type: type
    };
};

});

parcelRegister("3o9uT", function(module, exports) {

$parcel$export(module.exports, "runThroughMedia", () => $277afaefb2791215$export$ee622839cb6e2b5d);
$parcel$export(module.exports, "applyHeadings", () => $277afaefb2791215$export$7fc39a69c6299a60);
$parcel$export(module.exports, "applyTypographySequence", () => $277afaefb2791215$export$7c7d7b0d076fe8b5);
$parcel$export(module.exports, "getFontSizeByKey", () => $277afaefb2791215$export$ea9b2cd64205746b);
parcelRequire("2oe0q");
var $bmfNh = parcelRequire("bmfNh");

var $7KiQp = parcelRequire("7KiQp");
parcelRequire("a7QGr");
var $4e8M6 = parcelRequire("4e8M6");
var $4FtMQ = parcelRequire("4FtMQ");
'use strict';
const $277afaefb2791215$export$ee622839cb6e2b5d = (FACTORY)=>{
    const CONFIG = (0, $7KiQp.getActiveConfig)();
    const { typography: TYPOGRAPHY, media: MEDIA } = CONFIG;
    for(const prop in FACTORY){
        const isPropMedia = prop.slice(0, 1) === '@';
        const mediaValue = FACTORY[prop];
        if (!isPropMedia) continue;
        const { mediaRegenerate: mediaRegenerate } = FACTORY;
        const mediaName = prop.slice(1);
        const { type: type, base: base, ratio: ratio, range: range, subSequence: subSequence, h1Matches: h1Matches, unit: unit } = FACTORY;
        (0, $bmfNh.merge)(mediaValue, {
            type: type,
            base: base,
            ratio: ratio,
            range: range,
            subSequence: subSequence,
            h1Matches: h1Matches,
            unit: unit
        });
        const VIEWPORT_UNITS = new Set([
            'vw',
            'vh',
            'vmin',
            'vmax',
            'svw',
            'svh',
            'lvw',
            'lvh',
            'dvw',
            'dvh'
        ]);
        const inheritedUnit = mediaValue.unit || unit;
        const mediaUnit = !mediaValue.unit && VIEWPORT_UNITS.has(unit) ? 'rem' : inheritedUnit;
        const query = MEDIA[mediaName];
        const media = '@media ' + (query === 'print' ? `${query}` : `screen and ${query}`);
        TYPOGRAPHY.templates[media] = {
            fontSize: mediaValue.base / TYPOGRAPHY.browserDefault + mediaUnit
        };
        if (!mediaRegenerate) {
            (0, $bmfNh.merge)(mediaValue, {
                sequence: {},
                scales: {},
                vars: {}
            });
            (0, $4FtMQ.generateSequence)(mediaValue);
            (0, $4e8M6.applyMediaSequenceVars)(FACTORY, prop);
            continue;
        }
        (0, $bmfNh.merge)(mediaValue, {
            sequence: {},
            scales: {},
            templates: {},
            vars: {}
        });
        (0, $4FtMQ.generateSequence)(mediaValue);
        (0, $4e8M6.applyMediaSequenceVars)(FACTORY, prop);
    }
};
const $277afaefb2791215$export$7fc39a69c6299a60 = (props)=>{
    const CONFIG = (0, $7KiQp.getActiveConfig)();
    if (props.h1Matches) {
        const unit = props.unit;
        const HEADINGS = (0, $4FtMQ.findHeadings)(props);
        const { templates: templates } = props;
        for(const k in HEADINGS){
            const headerName = `h${parseInt(k) + 1}`;
            const headerStyle = templates[headerName];
            templates[headerName] = {
                fontSize: CONFIG.useVariable ? `var(${HEADINGS[k]?.variable})` : `${HEADINGS[k]?.scaling}${unit}`,
                margin: headerStyle ? headerStyle.margin : 0,
                lineHeight: headerStyle ? headerStyle.lineHeight : props.lineHeight,
                letterSpacing: headerStyle ? headerStyle.letterSpacing : props.letterSpacing,
                fontWeight: headerStyle ? headerStyle.fontWeight : 900 - k * 100
            };
        }
    }
};
const $277afaefb2791215$export$7c7d7b0d076fe8b5 = ()=>{
    const CONFIG = (0, $7KiQp.getActiveConfig)();
    const { typography: TYPOGRAPHY } = CONFIG;
    (0, $4FtMQ.generateSequence)(TYPOGRAPHY);
    $277afaefb2791215$export$7fc39a69c6299a60(TYPOGRAPHY);
    (0, $4e8M6.applySequenceVars)(TYPOGRAPHY);
    $277afaefb2791215$export$ee622839cb6e2b5d(TYPOGRAPHY);
};
const $277afaefb2791215$export$ea9b2cd64205746b = (value)=>{
    const CONFIG = (0, $7KiQp.getActiveConfig)();
    const { typography: TYPOGRAPHY } = CONFIG;
    return (0, $4FtMQ.getSequenceValuePropertyPair)(value, 'fontSize', TYPOGRAPHY);
};

});

parcelRegister("awIHJ", function(module, exports) {

$parcel$export(module.exports, "checkIfBoxSize", () => $7a9f91e2b97567cc$export$80eafc63c0bb6c49);
$parcel$export(module.exports, "applySpacingSequence", () => $7a9f91e2b97567cc$export$9bfe8384addafa7c);
$parcel$export(module.exports, "getSpacingByKey", () => $7a9f91e2b97567cc$export$4f949d23b5dbefe6);
$parcel$export(module.exports, "getSpacingBasedOnRatio", () => $7a9f91e2b97567cc$export$94679ba49f16fc2e);
$parcel$export(module.exports, "splitSpacedValue", () => $7a9f91e2b97567cc$export$b5c85645d77180b6);
parcelRequire("2oe0q");
var $fuahe = parcelRequire("fuahe");
var $fX7ii = parcelRequire("fX7ii");
var $bmfNh = parcelRequire("bmfNh");

var $7KiQp = parcelRequire("7KiQp");
parcelRequire("a7QGr");
var $4e8M6 = parcelRequire("4e8M6");
var $28k11 = parcelRequire("28k11");
var $4FtMQ = parcelRequire("4FtMQ");
'use strict';
const $7a9f91e2b97567cc$var$runThroughMedia = (FACTORY)=>{
    for(const prop in FACTORY){
        const mediaProps = FACTORY[prop];
        const isMediaName = prop.slice(0, 1) === '@';
        if (!isMediaName) continue;
        const { type: type, base: base, ratio: ratio, range: range, subSequence: subSequence, h1Matches: h1Matches, unit: unit } = FACTORY;
        (0, $bmfNh.merge)(mediaProps, {
            type: type,
            base: base,
            ratio: ratio,
            range: range,
            subSequence: subSequence,
            h1Matches: h1Matches,
            unit: unit,
            sequence: {},
            scales: {},
            templates: {},
            vars: {}
        });
        (0, $4FtMQ.generateSequence)(mediaProps);
        (0, $4e8M6.applyMediaSequenceVars)(FACTORY, prop);
    }
};
const $7a9f91e2b97567cc$export$80eafc63c0bb6c49 = (propertyName)=>{
    const prop = propertyName.toLowerCase();
    const includesWidth = prop.includes('width') || prop.includes('height');
    const includesBorder = prop.includes('border') || prop.includes('outline');
    return includesWidth && !includesBorder;
};
const $7a9f91e2b97567cc$export$9bfe8384addafa7c = ()=>{
    const CONFIG = (0, $7KiQp.getActiveConfig)();
    const { spacing: SPACING } = CONFIG;
    (0, $4FtMQ.generateSequence)(SPACING);
    (0, $4e8M6.applySequenceVars)(SPACING);
    $7a9f91e2b97567cc$var$runThroughMedia(SPACING);
};
const $7a9f91e2b97567cc$var$getSequence = (sequenceProps)=>{
    const CONFIG = (0, $7KiQp.getActiveConfig)();
    const { spacing: SPACING } = CONFIG;
    if (!sequenceProps || !sequenceProps.sequence) return SPACING;
    const hasGenerated = Object.keys(sequenceProps.sequence).length > 0;
    return hasGenerated ? sequenceProps : (0, $4FtMQ.generateSequence)(sequenceProps);
};
const $7a9f91e2b97567cc$export$4f949d23b5dbefe6 = (value, propertyName = 'padding', sequenceProps, fnPrefix)=>{
    const sequence = $7a9f91e2b97567cc$var$getSequence(sequenceProps);
    if ((0, $fX7ii.isString)(value)) {
        if (!fnPrefix && value.includes('(')) {
            const fnArray = (0, $4FtMQ.getFnPrefixAndValue)(value);
            fnPrefix = fnArray[0];
            value = fnArray[1];
        }
    }
    const stack = fnPrefix ? [
        value
    ] : (0, $fuahe.arrayzeValue)(value);
    if (!(0, $fX7ii.isArray)(stack)) return;
    if (stack.length > 1) {
        let suffix = '';
        if (propertyName === 'borderWidth') {
            propertyName = 'border';
            suffix = 'Width';
        }
        const directions = {
            2: [
                'Block',
                'Inline'
            ],
            3: [
                'BlockStart',
                'Inline',
                'BlockEnd'
            ],
            4: [
                'BlockStart',
                'InlineEnd',
                'BlockEnd',
                'InlineStart'
            ]
        };
        const wrapSequenceValueByDirection = (direction, i)=>(0, $4FtMQ.getSequenceValuePropertyPair)(stack[i], propertyName + direction + suffix, sequence, fnPrefix);
        return directions[stack.length].map((dir, key)=>wrapSequenceValueByDirection(dir, key));
    }
    return (0, $4FtMQ.getSequenceValuePropertyPair)(value, propertyName, sequence, fnPrefix);
};
const $7a9f91e2b97567cc$export$94679ba49f16fc2e = (props, propertyName, val, fnPrefix)=>{
    const CONFIG = (0, $7KiQp.getActiveConfig)();
    const { spacing: SPACING } = CONFIG;
    let value = val || props[propertyName];
    if (!fnPrefix && (0, $fX7ii.isString)(value) && value.includes('(')) {
        const fnArr = (0, $4FtMQ.getFnPrefixAndValue)(value);
        fnPrefix = fnArr[0];
        value = fnArr[1];
    }
    if (props.spacingRatio) {
        const sequenceProps = applyCustomSequence(props);
        return $7a9f91e2b97567cc$export$4f949d23b5dbefe6(value, propertyName, sequenceProps, fnPrefix);
    }
    return $7a9f91e2b97567cc$export$4f949d23b5dbefe6(value, propertyName, SPACING, fnPrefix);
};
const $7a9f91e2b97567cc$export$b5c85645d77180b6 = (val)=>{
    const addDefault = (v)=>{
        const isSymbol = [
            '+',
            '-',
            '*',
            '/'
        ].includes(v);
        const hasUnits = (0, $28k11.CSS_UNITS).some((unit)=>val.includes(unit));
        if (isSymbol || hasUnits) return v;
        const isSingleLetter = v.length < 3 && /[A-Z]/.test(v);
        if (isSingleLetter) return v + '_default';
        return v;
    };
    return val.split(',').map((v)=>v.trim()).map(addDefault).join(',').split(' ').map(addDefault).join(' ');
};

});

parcelRegister("6oyfS", function(module, exports) {

$parcel$export(module.exports, "setShadow", () => $4a7f8e4f20ce09e5$export$9cd3672191b5a46f);
$parcel$export(module.exports, "getShadow", () => $4a7f8e4f20ce09e5$export$db93b77dbb14f011);

var $7KiQp = parcelRequire("7KiQp");

var $h2nZH = parcelRequire("h2nZH");

var $awIHJ = parcelRequire("awIHJ");

var $2ESw5 = parcelRequire("2ESw5");
parcelRequire("2oe0q");
var $fX7ii = parcelRequire("fX7ii");
'use strict';
const $4a7f8e4f20ce09e5$export$9cd3672191b5a46f = (value, key, suffix, prefers)=>{
    const CONFIG = (0, $7KiQp.getActiveConfig)();
    if ((0, $fX7ii.isArray)(value)) return {
        '@light': $4a7f8e4f20ce09e5$export$9cd3672191b5a46f(value[0], key, 'light'),
        '@dark': $4a7f8e4f20ce09e5$export$9cd3672191b5a46f(value[1], key, 'dark')
    };
    if ((0, $fX7ii.isObject)(value)) {
        const obj = {};
        for(const variant in value)obj[variant] = $4a7f8e4f20ce09e5$export$9cd3672191b5a46f(value[variant], key, variant.startsWith('@') ? variant.slice(1) : variant);
        return obj;
    }
    if ((0, $fX7ii.isString)(value) && !(0, $2ESw5.CSS_NATIVE_COLOR_REGEX).test(value)) // Split multiple shadows by commas (CSS standard), respecting parentheses
    value = (0, $2ESw5.splitTopLevelCommas)(value).map((shadow)=>{
        shadow = shadow.trim();
        // Each shadow: space-separated tokens
        return shadow.split(/\s+/).map((v)=>{
            v = v.trim();
            if (!v) return '';
            if (v.startsWith('--')) return `var(${v})`;
            const color = (0, $h2nZH.getColor)(v);
            if ((0, $2ESw5.isResolvedColor)(color)) return color;
            if (/^\d/.test(v) || v === '0' || v.includes('px') || v.slice(-2) === 'em') return v;
            if (v === 'inset' || v === 'none') return v;
            const spacing = (0, $awIHJ.getSpacingByKey)(v, 'shadow');
            if (spacing && spacing.shadow) return spacing.shadow;
            return v;
        }).join(' ');
    }).join(', ');
    const vp = CONFIG.varPrefix ? CONFIG.varPrefix + '-' : '';
    const CSSVar = `--${vp}shadow-${key}` + (suffix ? `-${suffix}` : '');
    if (CONFIG.useVariable) CONFIG.cssVars[CSSVar] = value;
    return {
        var: CSSVar,
        value: value
    };
};
const $4a7f8e4f20ce09e5$export$db93b77dbb14f011 = (value, globalTheme)=>{
    const CONFIG = (0, $7KiQp.getActiveConfig)();
    if (!globalTheme) globalTheme = CONFIG.globalTheme;
    if (!(0, $fX7ii.isString)(value)) {
        if (CONFIG.verbose) console.warn(value, '- type for color is not valid');
        return;
    }
    if ((0, $2ESw5.isCSSVar)(value)) return `var(${value})`;
    const [name] = (0, $fX7ii.isArray)(value) ? value : value.split(' ');
    const SHADOW = CONFIG.shadow;
    const val = SHADOW[name];
    const isObj = (0, $fX7ii.isObject)(val);
    if (!val) {
        if (CONFIG.verbose) console.warn('Can\'t find color ', name);
        return value;
    }
    if (globalTheme) {
        if (val[globalTheme]) return val[globalTheme].value;
        else if (CONFIG.verbose) console.warn(value, ' - does not have ', globalTheme);
    }
    if (isObj && val.value) return val.value;
    if (isObj) {
        const obj = {};
        for(const mediaName in val){
            const query = CONFIG.media[mediaName.slice(1)];
            const media = '@media ' + (query === 'print' ? `${query}` : `screen and ${query}`);
            obj[media] = val.value;
        }
        return obj;
    }
    if (CONFIG.verbose) console.warn('Can\'t find color', value);
    return value;
};

});

parcelRegister("2KAeE", function(module, exports) {

$parcel$export(module.exports, "applyTimingSequence", () => $200bfc3872a6d81d$export$a5be618f63a441ac);
$parcel$export(module.exports, "getTimingFunction", () => $200bfc3872a6d81d$export$23ba66c7c3e2e613);
$parcel$export(module.exports, "getTimingByKey", () => $200bfc3872a6d81d$export$3fa311edc5edd22f);
parcelRequire("2oe0q");
var $fuahe = parcelRequire("fuahe");

var $7KiQp = parcelRequire("7KiQp");
parcelRequire("a7QGr");
var $4e8M6 = parcelRequire("4e8M6");
var $4FtMQ = parcelRequire("4FtMQ");
'use strict';
const $200bfc3872a6d81d$export$a5be618f63a441ac = ()=>{
    const CONFIG = (0, $7KiQp.getActiveConfig)();
    const { timing: TIMING } = CONFIG;
    (0, $4FtMQ.generateSequence)(TIMING);
    (0, $4e8M6.applySequenceVars)(TIMING);
};
const $200bfc3872a6d81d$export$23ba66c7c3e2e613 = (value)=>{
    const CONFIG = (0, $7KiQp.getActiveConfig)();
    const { timing: TIMING } = CONFIG;
    return TIMING[value] || TIMING[(0, $fuahe.toCamelCase)(value)] || value;
};
const $200bfc3872a6d81d$export$3fa311edc5edd22f = (value, property = 'timing')=>{
    const CONFIG = (0, $7KiQp.getActiveConfig)();
    const { timing: TIMING } = CONFIG;
    return (0, $4FtMQ.getSequenceValuePropertyPair)(value, property, TIMING);
};

});

parcelRegister("lWTYl", function(module, exports) {

$parcel$export(module.exports, "applyDocument", () => $ffaa6eb4db8ddc52$export$25b333cdc54cc186);
parcelRequire("2oe0q");
var $bmfNh = parcelRequire("bmfNh");

var $7KiQp = parcelRequire("7KiQp");
parcelRequire("a7QGr");
var $ePlkR = parcelRequire("ePlkR");
'use strict';
const $ffaa6eb4db8ddc52$export$25b333cdc54cc186 = ()=>{
    const CONFIG = (0, $7KiQp.getActiveConfig)();
    const { document: DOCUMENT, fontFamily: FONT_FAMILY, theme: THEME, typography: TYPOGRAPHY } = CONFIG;
    return (0, $bmfNh.merge)(DOCUMENT, {
        theme: THEME.document,
        fontFamily: (0, $ePlkR.getDefaultOrFirstKey)(FONT_FAMILY),
        fontSize: TYPOGRAPHY.base,
        lineHeight: TYPOGRAPHY.lineHeight
    });
};

});

parcelRegister("nKbE9", function(module, exports) {

$parcel$export(module.exports, "setSVG", () => $0475f9d7e694cab2$export$694c6c574069ebf2);
$parcel$export(module.exports, "appendSVGSprite", () => $0475f9d7e694cab2$export$2c4662f4a995c568);
$parcel$export(module.exports, "setSvgIcon", () => $0475f9d7e694cab2$export$46739718ff556447);
$parcel$export(module.exports, "appendSvgIconsSprite", () => $0475f9d7e694cab2$export$6892263c3fbefa8c);
parcelRequire("2oe0q");
var $erBZm = parcelRequire("erBZm");
parcelRequire("a7QGr");
var $iIypr = parcelRequire("iIypr");

var $7KiQp = parcelRequire("7KiQp");
'use strict';
const $0475f9d7e694cab2$var$DEF_OPTIONS = {
    document: $erBZm.document
};
const $0475f9d7e694cab2$export$694c6c574069ebf2 = (val, key)=>{
    const CONFIG = (0, $7KiQp.getActiveConfig)();
    if (!val) {
        if (CONFIG.verbose) console.warn('setSVG: val is not defined', key);
        return;
    }
    if (CONFIG.useSvgSprite) return (0, $iIypr.convertSvgToSymbol)(key, val);
    return val;
};
const $0475f9d7e694cab2$export$2c4662f4a995c568 = (LIBRARY, options = $0475f9d7e694cab2$var$DEF_OPTIONS)=>{
    const CONFIG = (0, $7KiQp.getActiveConfig)();
    const lib = Object.keys(LIBRARY).length ? {} : CONFIG.svg;
    for(const key in LIBRARY)lib[key] = LIBRARY[key];
    $0475f9d7e694cab2$var$appendSVG(lib, options);
};
const $0475f9d7e694cab2$export$46739718ff556447 = (val, key)=>{
    const CONFIG = (0, $7KiQp.getActiveConfig)();
    if (CONFIG.useIconSprite && !CONFIG.semanticIcons?.[key]) return $0475f9d7e694cab2$export$694c6c574069ebf2(val, key);
    return val;
};
const $0475f9d7e694cab2$export$6892263c3fbefa8c = (LIBRARY, options = $0475f9d7e694cab2$var$DEF_OPTIONS)=>{
    const CONFIG = (0, $7KiQp.getActiveConfig)();
    const lib = Object.keys(LIBRARY).length ? {} : CONFIG.icons;
    for(const key in LIBRARY)lib[key] = LIBRARY[key];
    $0475f9d7e694cab2$var$appendSVG(lib, options);
};
const $0475f9d7e694cab2$var$createSVGSpriteElement = (doc, options = {
    isRoot: true
})=>{
    if (!doc || !doc.createElementNS) return;
    const svgElem = doc.createElementNS('http://www.w3.org/2000/svg', 'svg');
    if (options.isRoot) {
        svgElem.setAttribute('aria-hidden', 'true');
        svgElem.setAttribute('width', '0');
        svgElem.setAttribute('height', '0');
        svgElem.setAttribute('style', 'position:absolute');
        svgElem.setAttribute('id', 'svgSprite');
    }
    return svgElem;
};
// Parse SVG sprite string using XML parser to correctly handle self-closing tags.
// HTML parser treats <line .../> as <line ...> (ignores /), nesting siblings.
const $0475f9d7e694cab2$var$parseSVGSprite = (doc, svgString)=>{
    const DOMParserCtor = typeof DOMParser !== 'undefined' ? DOMParser : null;
    if (DOMParserCtor) {
        const wrapped = `<svg xmlns="http://www.w3.org/2000/svg">${svgString}</svg>`;
        const parser = new DOMParserCtor();
        const parsed = parser.parseFromString(wrapped, 'image/svg+xml');
        // Check for parse errors — if the SVG is malformed, fall back to innerHTML
        if (parsed.querySelector('parsererror')) return null;
        return parsed.documentElement;
    }
    return null;
};
// Move all children from a parsed SVG element into a target element.
// Uses importNode to cross document boundaries, then removes the source child
// so the loop terminates.
const $0475f9d7e694cab2$var$moveChildren = (doc, from, to)=>{
    while(from.firstChild){
        const child = from.firstChild;
        to.appendChild(doc.importNode(child, true));
        child.remove();
    }
};
const $0475f9d7e694cab2$var$appendSVG = (lib, options = $0475f9d7e694cab2$var$DEF_OPTIONS)=>{
    const CONFIG = (0, $7KiQp.getActiveConfig)();
    const doc = options.document || (0, $erBZm.document);
    if (!doc || !doc.documentElement) {
        if (CONFIG.verbose) console.warn('To append SVG sprites it should be run in browser environment');
        return (0, $iIypr.generateSprite)(lib);
    }
    const exists = doc.querySelector('#svgSprite');
    const SVGsprite = (0, $iIypr.generateSprite)(lib);
    const spriteHtml = `<svg aria-hidden="true" width="0" height="0" style="position:absolute" id="svgSprite">${SVGsprite}</svg>`;
    const parsed = $0475f9d7e694cab2$var$parseSVGSprite(doc, SVGsprite);
    if (exists) {
        if (parsed) $0475f9d7e694cab2$var$moveChildren(doc, parsed, exists);
        else if (doc.body.insertAdjacentHTML) exists.insertAdjacentHTML('beforeend', SVGsprite);
        else {
            const tempSVG = $0475f9d7e694cab2$var$createSVGSpriteElement(doc, {
                isRoot: false
            });
            tempSVG.innerHTML = SVGsprite;
            exists.append(...tempSVG.children);
        }
    } else {
        if (parsed) {
            const svgSpriteDOM = $0475f9d7e694cab2$var$createSVGSpriteElement(doc);
            if (svgSpriteDOM && svgSpriteDOM.nodeType) {
                $0475f9d7e694cab2$var$moveChildren(doc, parsed, svgSpriteDOM);
                doc.body.prepend(svgSpriteDOM);
            }
        } else if (doc.body.insertAdjacentHTML) doc.body.insertAdjacentHTML('afterbegin', spriteHtml);
        else {
            const svgSpriteDOM = $0475f9d7e694cab2$var$createSVGSpriteElement(doc);
            if (svgSpriteDOM && svgSpriteDOM.nodeType) {
                svgSpriteDOM.innerHTML = SVGsprite;
                doc.body.prepend(svgSpriteDOM);
            }
        }
    }
};

});

parcelRegister("iKB0v", function(module, exports) {

$parcel$export(module.exports, "applyReset", () => $da693abe5a891559$export$984fb5f73961424e);
parcelRequire("2oe0q");
var $bmfNh = parcelRequire("bmfNh");

var $7KiQp = parcelRequire("7KiQp");

var $6VLzn = parcelRequire("6VLzn");
'use strict';
const $da693abe5a891559$export$984fb5f73961424e = (reset = {})=>{
    const CONFIG = (0, $7KiQp.getActiveConfig)();
    const { reset: RESET, typography: TYPOGRAPHY, document: DOCUMENT } = CONFIG;
    if (RESET) {
        if (RESET[':root']) {
            const configReset = RESET;
            const configTemplates = TYPOGRAPHY.templates;
            configReset.body = {
                ...CONFIG.useDocumentTheme ? (0, $6VLzn.getMediaTheme)('document') : {},
                ...configTemplates.body
            };
            configReset.h1 = configTemplates.h1;
            configReset.h2 = configTemplates.h2;
            configReset.h3 = configTemplates.h3;
            configReset.h4 = configTemplates.h4;
            configReset.h5 = configTemplates.h5;
            configReset.h6 = configTemplates.h6;
        }
        const { body: body, ...templates } = TYPOGRAPHY.templates;
        const globalTheme = CONFIG.useDocumentTheme ? (0, $6VLzn.getMediaTheme)('document') : {};
        if (RESET.html) (0, $bmfNh.overwriteDeep)(RESET.html, globalTheme);
        // Generate html fontSize overrides for typography media breakpoints
        if (TYPOGRAPHY.unit) {
            const { media: MEDIA } = CONFIG;
            for(const key in TYPOGRAPHY){
                if (key.charAt(0) !== '@') continue;
                const mediaTypo = TYPOGRAPHY[key];
                if (!mediaTypo) continue;
                // Only override html fontSize if this media explicitly changes the unit
                if (mediaTypo.unit === TYPOGRAPHY.unit || !mediaTypo.unit) continue;
                const mediaUnit = mediaTypo.unit;
                const mediaBase = mediaTypo.base || TYPOGRAPHY.base;
                const mediaBrowserDefault = mediaTypo.browserDefault || TYPOGRAPHY.browserDefault;
                const mediaName = key.slice(1);
                const query = MEDIA[mediaName];
                if (!query) continue;
                const mediaKey = '@media ' + (query === 'print' ? query : 'screen and ' + query);
                if (!RESET[mediaKey]) RESET[mediaKey] = {};
                if (!RESET[mediaKey].html) RESET[mediaKey].html = {};
                RESET[mediaKey].html.fontSize = mediaBase / mediaBrowserDefault + mediaUnit;
            }
        }
        return (0, $bmfNh.deepMerge)((0, $bmfNh.merge)(RESET, reset), {
            html: {
                position: 'absolute',
                width: '100%',
                height: '100%',
                top: '0',
                left: '0',
                margin: '0',
                WebkitFontSmoothing: 'subpixel-antialiased',
                scrollBehavior: 'smooth',
                ...globalTheme,
                fontSize: TYPOGRAPHY.unit ? TYPOGRAPHY.base / TYPOGRAPHY.browserDefault + TYPOGRAPHY.unit : TYPOGRAPHY.browserDefault + 'px',
                fontFamily: DOCUMENT.fontFamily,
                lineHeight: DOCUMENT.lineHeight
            },
            body: {
                boxSizing: 'border-box',
                height: '100%',
                margin: 0,
                fontFamily: DOCUMENT.fontFamily,
                fontSize: TYPOGRAPHY.base / TYPOGRAPHY.browserDefault + CONFIG.unit.default,
                ...templates,
                ...body
            },
            a: {
                color: 'currentColor'
            },
            button: {
                color: 'inherit',
                font: 'inherit',
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                appearance: 'none',
                WebkitAppearance: 'none'
            },
            'input, select, textarea': {
                color: 'inherit',
                font: 'inherit'
            },
            fieldset: {
                border: 0,
                padding: 0,
                margin: 0
            }
        });
    }
};

});


parcelRegister("4nA98", function(module, exports) {

$parcel$export(module.exports, "transformBorder", () => $33055954907944f0$export$ca4ef6ca6dc743f2);
$parcel$export(module.exports, "transformTextStroke", () => $33055954907944f0$export$8bcd50b221b13db);
$parcel$export(module.exports, "transformShadow", () => $33055954907944f0$export$837e4beeff9ff924);
$parcel$export(module.exports, "transformBoxShadow", () => $33055954907944f0$export$9c296746f296a70);
$parcel$export(module.exports, "resolveColorsInGradient", () => $33055954907944f0$export$74ec263a34bf386a);
$parcel$export(module.exports, "transformBackgroundImage", () => $33055954907944f0$export$15f2b9b64835b137);
$parcel$export(module.exports, "transfromGap", () => $33055954907944f0$export$1e420ad2d0d06436);
$parcel$export(module.exports, "transformTransition", () => $33055954907944f0$export$df2b736a06860be7);
$parcel$export(module.exports, "transformDuration", () => $33055954907944f0$export$d87c1c5f4a8ec3d9);
$parcel$export(module.exports, "splitTransition", () => $33055954907944f0$export$d9f7ff0c2b32d4b5);
$parcel$export(module.exports, "transformSize", () => $33055954907944f0$export$f09d9444954afeda);
$parcel$export(module.exports, "transformSizeRatio", () => $33055954907944f0$export$b6e34d20a288a08c);
$parcel$export(module.exports, "transformBorderRadius", () => $33055954907944f0$export$7150732276d3a7a2);
parcelRequire("2oe0q");
var $bmfNh = parcelRequire("bmfNh");
var $fX7ii = parcelRequire("fX7ii");

var $7KiQp = parcelRequire("7KiQp");
parcelRequire("4bxaE");
var $awIHJ = parcelRequire("awIHJ");
var $h2nZH = parcelRequire("h2nZH");
var $6oyfS = parcelRequire("6oyfS");
var $2KAeE = parcelRequire("2KAeE");
parcelRequire("a7QGr");
var $2ESw5 = parcelRequire("2ESw5");
var $4FtMQ = parcelRequire("4FtMQ");
'use strict';
const $33055954907944f0$var$BORDER_STYLES = new Set([
    'none',
    'hidden',
    'dotted',
    'dashed',
    'solid',
    'double',
    'groove',
    'ridge',
    'inset',
    'outset',
    'initial'
]);
const $33055954907944f0$var$GRADIENT_KEYWORDS = new Set([
    'to',
    'top',
    'bottom',
    'left',
    'right',
    'center',
    'at',
    'circle',
    'ellipse',
    'closest-side',
    'farthest-side',
    'closest-corner',
    'farthest-corner'
]);
const $33055954907944f0$var$isBorderStyle = (str)=>$33055954907944f0$var$BORDER_STYLES.has(str);
const $33055954907944f0$export$ca4ef6ca6dc743f2 = (border)=>{
    const str = border + '';
    // CSS passthrough: native CSS color syntax
    if ((0, $2ESw5.CSS_NATIVE_COLOR_REGEX).test(str)) return str;
    // Simple CSS keywords
    const trimmed = str.trim();
    if (trimmed === 'none' || trimmed === '0' || trimmed === 'initial' || trimmed === 'inherit' || trimmed === 'unset') return str;
    // Space-separated tokens (CSS-like syntax)
    const tokens = str.split(/\s+/);
    return tokens.map((v)=>{
        v = v.trim();
        if (!v) return '';
        if ((0, $2ESw5.isCSSVar)(v)) return `var(${v})`;
        if ($33055954907944f0$var$isBorderStyle(v)) return v;
        if (/^\d/.test(v) || v === '0') return v;
        // Try color resolution
        const color = (0, $h2nZH.getColor)(v);
        if ((0, $2ESw5.isResolvedColor)(color)) return color;
        // Try spacing key
        const spacing = (0, $awIHJ.getSpacingByKey)(v, 'border');
        if (spacing && spacing.border) return spacing.border;
        return v;
    }).join(' ');
};
const $33055954907944f0$export$8bcd50b221b13db = (stroke)=>{
    // CSS passthrough
    if ((0, $2ESw5.CSS_NATIVE_COLOR_REGEX).test(stroke)) return stroke;
    return stroke.split(/\s+/).map((v)=>{
        v = v.trim();
        if (!v) return '';
        if ((0, $2ESw5.isCSSVar)(v)) return `var(${v})`;
        if (/^\d/.test(v) || v.includes('px') || v === '0') return v;
        const color = (0, $h2nZH.getColor)(v);
        if ((0, $2ESw5.isResolvedColor)(color)) return color;
        return v;
    }).join(' ');
};
const $33055954907944f0$export$837e4beeff9ff924 = (sh, globalTheme)=>(0, $6oyfS.getShadow)(sh, globalTheme);
const $33055954907944f0$export$9c296746f296a70 = (shadows, globalTheme)=>{
    // CSS passthrough: native CSS color syntax
    if ((0, $2ESw5.CSS_NATIVE_COLOR_REGEX).test(shadows)) return shadows;
    // Split multiple shadows by commas (CSS standard), respecting parentheses
    return (0, $2ESw5.splitTopLevelCommas)(shadows).map((shadow)=>{
        shadow = shadow.trim();
        if (!shadow) return '';
        // Each shadow: space-separated tokens
        return shadow.split(/\s+/).map((v)=>{
            v = v.trim();
            if (!v) return '';
            if ((0, $2ESw5.isCSSVar)(v)) return `var(${v})`;
            if (v === 'inset' || v === 'none') return v;
            // Try color resolution
            const color = (0, $h2nZH.getColor)(v);
            if ((0, $2ESw5.isResolvedColor)(color)) {
                const mediaColor = (0, $h2nZH.getMediaColor)(v, globalTheme);
                if ((0, $fX7ii.isObject)(mediaColor)) return Object.values(mediaColor).filter((c)=>c.includes(': ' + globalTheme))[0];
                return mediaColor;
            }
            // CSS unit values
            if (/^\d/.test(v) || v === '0' || v.includes('px') || v.slice(-2) === 'em') return v;
            // Spacing key
            const spacing = (0, $awIHJ.getSpacingByKey)(v, 'shadow');
            if (spacing && spacing.shadow) return spacing.shadow;
            return v;
        }).join(' ');
    }).join(', ');
};
const $33055954907944f0$export$74ec263a34bf386a = (gradient, globalTheme)=>{
    // Find the opening paren after the gradient type
    const parenStart = gradient.indexOf('(');
    if (parenStart === -1) return gradient;
    const prefix = gradient.slice(0, parenStart + 1);
    const inner = gradient.slice(parenStart + 1, gradient.lastIndexOf(')'));
    const suffix = ')';
    // Split by top-level commas (respects nested rgba() etc.)
    const segments = (0, $2ESw5.splitTopLevelCommas)(inner);
    const resolved = segments.map((segment)=>{
        segment = segment.trim();
        // Split segment into space-separated tokens
        const tokens = segment.split(/\s+/);
        return tokens.map((token)=>{
            if (!token) return token;
            // Skip CSS values: percentages, degrees, direction keywords, native colors
            if (/^\d/.test(token) || token === '0') return token;
            if ($33055954907944f0$var$GRADIENT_KEYWORDS.has(token)) return token;
            if (token === 'transparent') return token;
            if ((0, $2ESw5.CSS_NATIVE_COLOR_REGEX).test(token)) return token;
            // Try to resolve as a Symbols color token
            const color = (0, $h2nZH.getColor)(token);
            if ((0, $2ESw5.isResolvedColor)(color)) return color;
            return token;
        }).join(' ');
    });
    return prefix + resolved.join(', ') + suffix;
};
const $33055954907944f0$export$15f2b9b64835b137 = (backgroundImage, globalTheme)=>{
    const CONFIG = (0, $7KiQp.getActiveConfig)();
    return backgroundImage.split(', ').map((v)=>{
        if ((0, $2ESw5.isCSSVar)(v)) return `var(${v})`;
        if (v.includes('url')) return v;
        if (v.includes('gradient')) return $33055954907944f0$export$74ec263a34bf386a(v, globalTheme);
        else if (CONFIG.gradient[backgroundImage]) return {
            backgroundImage: (0, $h2nZH.getMediaColor)(backgroundImage, globalTheme || CONFIG.globalTheme)
        };
        else if (v.includes('/') || v.startsWith('http') || v.includes('.') && !(0, $2ESw5.parseColorToken)(v)) return `url(${v})`;
        return v;
    }).join(' ');
};
const $33055954907944f0$export$1e420ad2d0d06436 = (gap)=>(0, $fX7ii.isString)(gap) && gap.split(' ').map((v)=>(0, $awIHJ.getSpacingByKey)(v, 'gap').gap).join(' ');
const $33055954907944f0$export$df2b736a06860be7 = (transition)=>{
    const arr = transition.split(' ');
    if (!arr.length) return transition;
    return arr.map((v)=>{
        if ((0, $2ESw5.isCSSVar)(v)) return `var(${v})`;
        if (v.length < 3 || v.includes('ms')) {
            const mapWithSequence = (0, $2KAeE.getTimingByKey)(v);
            return mapWithSequence.timing || v;
        }
        if ((0, $2KAeE.getTimingFunction)(v)) return (0, $2KAeE.getTimingFunction)(v);
        return v;
    }).join(' ');
};
const $33055954907944f0$export$d87c1c5f4a8ec3d9 = (duration, props, propertyName)=>{
    if (!(0, $fX7ii.isString)(duration)) return;
    return duration.split(',').map((v)=>(0, $2KAeE.getTimingByKey)(v).timing || v).join(',');
};
const $33055954907944f0$export$d9f7ff0c2b32d4b5 = (transition)=>{
    const arr = transition.split(',');
    if (!arr.length) return;
    return arr.map($33055954907944f0$export$df2b736a06860be7).join(',');
};
function $33055954907944f0$export$f09d9444954afeda(propertyName, val, props = {}, opts = {}) {
    let value = (0, $bmfNh.exec).call(this, val || props[propertyName]);
    if (value === undefined || value === null) return;
    let fnPrefix;
    if ((0, $fX7ii.isString)(value)) {
        // has function prefix
        if (value.includes('(')) {
            const fnArr = (0, $4FtMQ.getFnPrefixAndValue)(value);
            fnPrefix = fnArr[0];
            value = fnArr[1];
        }
        const shouldScaleBoxSize = props.scaleBoxSize;
        const isBoxSize = (0, $awIHJ.checkIfBoxSize)(propertyName);
        if (!shouldScaleBoxSize && isBoxSize && !opts.ratio) value = (0, $awIHJ.splitSpacedValue)(value);
    }
    return opts.ratio ? (0, $awIHJ.getSpacingBasedOnRatio)(props, propertyName, value, fnPrefix) : (0, $awIHJ.getSpacingByKey)(value, propertyName, undefined, fnPrefix);
}
const $33055954907944f0$export$b6e34d20a288a08c = (propertyName, val = null, props)=>{
    return $33055954907944f0$export$f09d9444954afeda(propertyName, val, props, {
        ratio: true
    });
};
const $33055954907944f0$export$7150732276d3a7a2 = (radius, props, propertyName)=>{
    if (!(0, $fX7ii.isString)(radius)) return;
    return {
        borderRadius: radius.split(' ').map((v, k)=>(0, $awIHJ.getSpacingBasedOnRatio)(props, propertyName, v)[propertyName]).join(' ')
    };
};

});

parcelRegister("g1w0p", function(module, exports) {

$parcel$export(module.exports, "VALUE_TRANSFORMERS", () => $baa590feaf6cb6da$export$9ae1d0dd64d4a382);
$parcel$export(module.exports, "setValue", () => $baa590feaf6cb6da$export$80746c6bc6142fc8);
$parcel$export(module.exports, "setEach", () => $baa590feaf6cb6da$export$943920cf7e6d5f23);
$parcel$export(module.exports, "changeGlobalTheme", () => $baa590feaf6cb6da$export$204c4d227c4ac61c);
$parcel$export(module.exports, "set", () => $baa590feaf6cb6da$export$adaa4cf7ef1b65be);

var $7KiQp = parcelRequire("7KiQp");
parcelRequire("4bxaE");
var $lWTYl = parcelRequire("lWTYl");
var $iKB0v = parcelRequire("iKB0v");
var $awIHJ = parcelRequire("awIHJ");
var $2KAeE = parcelRequire("2KAeE");
var $3o9uT = parcelRequire("3o9uT");
var $h2nZH = parcelRequire("h2nZH");
var $kmFEN = parcelRequire("kmFEN");
var $6oyfS = parcelRequire("6oyfS");
var $nKbE9 = parcelRequire("nKbE9");
var $6VLzn = parcelRequire("6VLzn");
parcelRequire("2oe0q");
var $bmfNh = parcelRequire("bmfNh");
var $fX7ii = parcelRequire("fX7ii");
'use strict';
const $baa590feaf6cb6da$var$setVars = (val, key)=>{
    const CONFIG = (0, $7KiQp.getActiveConfig)();
    const { cssVars: cssVars } = CONFIG;
    const varName = key.startsWith('--') ? key : `--${key}`;
    cssVars[varName] = val;
    return val;
};
const $baa590feaf6cb6da$var$asIs = (val)=>val;
const $baa590feaf6cb6da$export$9ae1d0dd64d4a382 = {
    color: (0, $h2nZH.setColor),
    gradient: (0, $h2nZH.setGradient),
    font: (0, $kmFEN.setFont),
    fontFamily: (0, $kmFEN.setFontFamily),
    fontfamily: (0, $kmFEN.setFontFamily),
    theme: (0, $6VLzn.setTheme),
    icons: (0, $nKbE9.setSvgIcon),
    semanticIcons: $baa590feaf6cb6da$var$asIs,
    semanticicons: $baa590feaf6cb6da$var$asIs,
    svg: (0, $nKbE9.setSVG),
    svgData: $baa590feaf6cb6da$var$asIs,
    typography: $baa590feaf6cb6da$var$asIs,
    shadow: (0, $6oyfS.setShadow),
    spacing: $baa590feaf6cb6da$var$asIs,
    media: $baa590feaf6cb6da$var$asIs,
    grid: $baa590feaf6cb6da$var$asIs,
    class: $baa590feaf6cb6da$var$asIs,
    timing: $baa590feaf6cb6da$var$asIs,
    reset: $baa590feaf6cb6da$var$asIs,
    unit: $baa590feaf6cb6da$var$asIs,
    animation: $baa590feaf6cb6da$var$asIs,
    vars: $baa590feaf6cb6da$var$setVars
};
const $baa590feaf6cb6da$export$80746c6bc6142fc8 = (factoryName, value, key)=>{
    const CONFIG = (0, $7KiQp.getActiveConfig)();
    const camelName = (0, $7KiQp.toCamel)(factoryName);
    const lowerName = camelName.toLowerCase();
    const FACTORY = CONFIG[camelName] || CONFIG[lowerName] || CONFIG[factoryName];
    const transformer = $baa590feaf6cb6da$export$9ae1d0dd64d4a382[camelName] || $baa590feaf6cb6da$export$9ae1d0dd64d4a382[lowerName];
    if (transformer) try {
        const result = transformer(value, key);
        if (FACTORY) FACTORY[key] = result;
        return FACTORY;
    } catch (error) {
        if (CONFIG.verbose) console.warn('Error setting', lowerName, 'value', value, key, error);
    }
    if (CONFIG.verbose) console.warn('Can not find', lowerName, 'method in scratch');
};
const $baa590feaf6cb6da$export$943920cf7e6d5f23 = (factoryName, props)=>{
    const CONFIG = (0, $7KiQp.getActiveConfig)();
    const lowerName = factoryName.toLowerCase();
    // Process primitive (string/number) values before composite (array/object)
    // ones so composite values can dereference primitives by name. Without this
    // ordering, a color like `selectedDay: ['--blue .12', '--blue .18']` could
    // be processed before `blue` itself was registered in CONFIG.color, leaving
    // refColor undefined and falling back to CSS keyword resolution.
    const keys = Object.keys(props).sort((a, b)=>{
        const aComposite = (0, $fX7ii.isObject)(props[a]) || (0, $fX7ii.isArray)(props[a]) ? 1 : 0;
        const bComposite = (0, $fX7ii.isObject)(props[b]) || (0, $fX7ii.isArray)(props[b]) ? 1 : 0;
        return aComposite - bComposite;
    });
    keys.forEach((key)=>{
        try {
            return $baa590feaf6cb6da$export$80746c6bc6142fc8(lowerName, props[key], key);
        } catch (error) {
            if (CONFIG.verbose) console.warn('Error setting', lowerName, 'value', props[key], key, error);
        }
    });
    return CONFIG[lowerName] || CONFIG[factoryName];
};
const $baa590feaf6cb6da$export$204c4d227c4ac61c = (newTheme, targetConfig)=>{
    // Accept an explicit config so scoped code (inside pushConfig) can
    // target the right app's theme without relying on the stack timing.
    const CONFIG = targetConfig || (0, $7KiQp.getActiveConfig)();
    CONFIG.globalTheme = newTheme;
    // Apply the theme on the scope root. For a single-design-system page we
    // write to `<html>`; multiple design systems on the same page each carry
    // their own root element (set by the caller on CONFIG.themeRoot), so the
    // attribute is applied there and leaves the rest of the document alone.
    //
    // `'auto'` switches to OS-driven mode: we resolve the current
    // `prefers-color-scheme` and register (once) a listener so later OS
    // changes flip the attribute live.
    // Resolve the target document from the config, not the global `document`.
    // In a multi-app setup the CONFIG belongs to an iframe — its themeRoot is
    // inside iframe doc, and its stylesheets live in iframe doc. Reading
    // global `document` here flips the parent's data-theme attribute instead.
    // `CONFIG.document` is also a factory bucket (font/theme defaults consumed
    // by `applyDocument`); only treat it as a DOM document override if it
    // actually looks like one.
    const configDoc = CONFIG.document && CONFIG.document.documentElement ? CONFIG.document : null;
    const targetDoc = configDoc || (typeof document !== 'undefined' ? document : null);
    const targetWin = targetDoc && targetDoc.defaultView || (typeof window !== 'undefined' ? window : null);
    if (targetDoc) {
        const root = CONFIG.themeRoot || targetDoc.documentElement;
        const forced = newTheme && newTheme !== 'auto';
        if (forced) {
            root.setAttribute('data-theme', newTheme);
            // Mirror `data-theme` into CSS `color-scheme` so Chrome stops
            // forcibly re-rendering form controls (buttons, inputs, selects) in
            // the opposite scheme of the design system. Only the standard
            // `dark`/`light` schemes map to a UA color-scheme; custom schemes
            // (sepia etc.) fall back to `light dark` so the browser picks by OS.
            if (newTheme === 'dark' || newTheme === 'light') root.style.colorScheme = newTheme;
            else root.style.colorScheme = 'light dark';
        } else if (targetWin && targetWin.matchMedia) {
            const apply = (mq)=>{
                root.setAttribute('data-theme', mq.matches ? 'dark' : 'light');
            };
            const mq = targetWin.matchMedia('(prefers-color-scheme: dark)');
            apply(mq);
            root.style.colorScheme = 'light dark';
            if (!CONFIG.__prefersListener) {
                CONFIG.__prefersListener = apply;
                try {
                    mq.addEventListener('change', apply);
                } catch (e) {
                    mq.addListener(apply);
                }
            }
        } else {
            root.setAttribute('data-theme', 'light');
            root.style.colorScheme = 'light';
        }
    }
    // Clear theme-related CSS vars (with or without varPrefix)
    const themeVarPrefix = CONFIG.varPrefix ? `--${CONFIG.varPrefix}-theme-` : '--theme-';
    for(const key in CONFIG.cssVars)if (key.startsWith(themeVarPrefix)) delete CONFIG.cssVars[key];
    // Clear all cssMediaVars (media queries + data-theme selectors)
    for(const key in CONFIG.cssMediaVars)delete CONFIG.cssMediaVars[key];
    // Apply updated CSS vars to the config's scoped stylesheet rule
    // (`:root` for the primary app, `[data-smbls-app="<key>"]` for secondary apps).
    if (targetDoc && CONFIG.cssVars) {
        const targetSelector = CONFIG.scopeSelector || ':root';
        const sheets = targetDoc.styleSheets;
        for(let i = 0; i < sheets.length; i++)try {
            const rules = sheets[i].cssRules;
            for(let j = 0; j < rules.length; j++)if (rules[j].selectorText === targetSelector) {
                for(const key in CONFIG.cssVars)rules[j].style.setProperty(key, CONFIG.cssVars[key]);
                return CONFIG;
            }
        } catch (e) {
        /* cross-origin stylesheet */ }
    }
    return CONFIG;
};
const $baa590feaf6cb6da$var$SET_OPTIONS = {};
const $baa590feaf6cb6da$export$adaa4cf7ef1b65be = (recivedConfig, options = $baa590feaf6cb6da$var$SET_OPTIONS)=>{
    // Accept an explicit config instance via options.config so callers
    // (e.g. renderProject for an embedded app) can operate on an isolated
    // config without touching the global singleton.
    let CONFIG = options.config || (0, $7KiQp.getActiveConfig)();
    const { version: version, verbose: verbose, useVariable: useVariable, useReset: useReset, useSvgSprite: useSvgSprite, useFontImport: useFontImport, useIconSprite: useIconSprite, globalTheme: globalTheme, themeRoot: themeRoot, useDocumentTheme: useDocumentTheme, useDefaultConfig: useDefaultConfig, semanticIcons: semanticIcons, files: files, assets: assets, ...config } = recivedConfig;
    if (options.newConfig) CONFIG = (0, $7KiQp.setActiveConfig)(options.newConfig);
    if (files !== undefined) CONFIG.files = files;
    if (assets !== undefined) CONFIG.assets = assets;
    if (verbose !== undefined) CONFIG.verbose = verbose;
    if (useVariable !== undefined) CONFIG.useVariable = useVariable;
    if (useReset !== undefined) CONFIG.useReset = useReset;
    if (useFontImport !== undefined) CONFIG.useFontImport = useFontImport;
    if (useSvgSprite !== undefined) CONFIG.useSvgSprite = useSvgSprite;
    if (useIconSprite !== undefined) CONFIG.useIconSprite = useIconSprite;
    if (useDocumentTheme !== undefined) CONFIG.useDocumentTheme = useDocumentTheme;
    if (globalTheme !== undefined) CONFIG.globalTheme = globalTheme;
    if (themeRoot !== undefined) CONFIG.themeRoot = themeRoot;
    if (recivedConfig.useThemeSuffixedVars !== undefined) CONFIG.useThemeSuffixedVars = recivedConfig.useThemeSuffixedVars;
    if (useDefaultConfig !== undefined) CONFIG.useDefaultConfig = useDefaultConfig;
    if (semanticIcons !== undefined) CONFIG.semanticIcons = semanticIcons;
    if (CONFIG.verbose) console.log(CONFIG);
    // Apply `data-theme` to the scope root so CSS selectors resolve correctly.
    // `auto` means "follow the OS": we read `prefers-color-scheme` and install
    // a one-time listener so a later OS toggle flips `data-theme` live without
    // reloading the page. Forced themes (`'dark'`, `'light'`, or any custom
    // scheme name like `'ocean'`) stick until the user calls
    // `changeGlobalTheme(...)` again.
    // `CONFIG.document` is also a factory bucket (font/theme defaults consumed
    // by `applyDocument`); only treat it as a DOM document override if it
    // actually looks like one.
    const setConfigDoc = CONFIG.document && CONFIG.document.documentElement ? CONFIG.document : null;
    const setTargetDoc = setConfigDoc || (typeof document !== 'undefined' ? document : null);
    const setTargetWin = setTargetDoc && setTargetDoc.defaultView || (typeof window !== 'undefined' ? window : null);
    const setRoot = setTargetDoc && (CONFIG.themeRoot || setTargetDoc.documentElement);
    if (setRoot && typeof setRoot.setAttribute === 'function') {
        const forced = CONFIG.globalTheme && CONFIG.globalTheme !== 'auto';
        if (forced) {
            setRoot.setAttribute('data-theme', CONFIG.globalTheme);
            if (CONFIG.globalTheme === 'dark' || CONFIG.globalTheme === 'light') setRoot.style.colorScheme = CONFIG.globalTheme;
            else setRoot.style.colorScheme = 'light dark';
        } else if (setTargetWin && setTargetWin.matchMedia) {
            const apply = (mq)=>{
                setRoot.setAttribute('data-theme', mq.matches ? 'dark' : 'light');
            };
            const mq = setTargetWin.matchMedia('(prefers-color-scheme: dark)');
            apply(mq);
            setRoot.style.colorScheme = 'light dark';
            if (!CONFIG.__prefersListener) {
                CONFIG.__prefersListener = apply;
                try {
                    mq.addEventListener('change', apply);
                } catch (e) {
                    mq.addListener(apply);
                }
            }
        } else {
            setRoot.setAttribute('data-theme', 'light');
            setRoot.style.colorScheme = 'light';
        }
    }
    if (!CONFIG.__svgCache) CONFIG.__svgCache = {};
    const keys = Object.keys(config);
    const keySet = new Set(keys);
    // Pre-merge: fold UPPERCASE default keys into lowercase project keys
    keys.forEach((key)=>{
        const lower = key.toLowerCase();
        if (lower !== key && keySet.has(lower)) (0, $bmfNh.deepMerge)(config[lower], config[key]);
    });
    // Process only lowercase keys (skip UPPERCASE when lowercase equivalent exists)
    keys.map((key)=>{
        const lower = key.toLowerCase();
        if (lower !== key && keySet.has(lower)) return;
        return $baa590feaf6cb6da$export$943920cf7e6d5f23(key, config[key]);
    });
    // Propagate varPrefix to sequence sub-configs for CSS variable name isolation
    if (CONFIG.varPrefix) {
        if (CONFIG.typography) CONFIG.typography.varPrefix = CONFIG.varPrefix;
        if (CONFIG.spacing) CONFIG.spacing.varPrefix = CONFIG.varPrefix;
        if (CONFIG.timing) CONFIG.timing.varPrefix = CONFIG.varPrefix;
    }
    // apply generic configs
    if (config.typography) try {
        (0, $3o9uT.applyTypographySequence)();
    } catch (e) {
        if (CONFIG.verbose) console.warn('Error applying typography sequence', e);
    }
    if (config.spacing) try {
        (0, $awIHJ.applySpacingSequence)();
    } catch (e) {
        if (CONFIG.verbose) console.warn('Error applying spacing sequence', e);
    }
    if (config.timing) try {
        (0, $2KAeE.applyTimingSequence)();
    } catch (e) {
        if (CONFIG.verbose) console.warn('Error applying timing sequence', e);
    }
    (0, $lWTYl.applyDocument)();
    // Capture so init.js injects the full html/body reset (with default
    // font-family); dropping the return leaves CONFIG.reset as the bare seed.
    const computedReset = (0, $iKB0v.applyReset)();
    if (computedReset) CONFIG.reset = computedReset;
    return CONFIG;
};

});






parcelRegister("cm1sg", function(module, exports) {
$parcel$export(module.exports, "addDelegatedEvent", () => (parcelRequire("5Or4i")).addDelegatedEvent);
$parcel$export(module.exports, "addMethods", () => (parcelRequire("1P3uZ")).addMethods);
$parcel$export(module.exports, "applyExtends", () => (parcelRequire("3QQ54")).applyExtends);
$parcel$export(module.exports, "cacheNode", () => (parcelRequire("hlMjd")).cacheNode);
$parcel$export(module.exports, "create", () => (parcelRequire("fQWe4")).create);
$parcel$export(module.exports, "createHTMLNode", () => (parcelRequire("hlMjd")).createHTMLNode);
$parcel$export(module.exports, "DELEGATED_EVENTS", () => (parcelRequire("5utcL")).DELEGATED_EVENTS);
$parcel$export(module.exports, "detectTag", () => (parcelRequire("hlMjd")).detectTag);
$parcel$export(module.exports, "dispose", () => (parcelRequire("gXM9X")).dispose);
$parcel$export(module.exports, "isSvgTag", () => (parcelRequire("hlMjd")).isSvgTag);
$parcel$export(module.exports, "isValidTag", () => (parcelRequire("hlMjd")).isValidTag);
$parcel$export(module.exports, "LIFECYCLE_EVENTS", () => (parcelRequire("5utcL")).LIFECYCLE_EVENTS);
$parcel$export(module.exports, "MIXINS", () => (parcelRequire("5utcL")).MIXINS);
$parcel$export(module.exports, "registerEvent", () => (parcelRequire("5Or4i")).registerEvent);
$parcel$export(module.exports, "REGISTRY", () => (parcelRequire("5utcL")).REGISTRY);
$parcel$export(module.exports, "remove", () => (parcelRequire("gXM9X")).remove);
$parcel$export(module.exports, "removeDelegatedEvent", () => (parcelRequire("5Or4i")).removeDelegatedEvent);
$parcel$export(module.exports, "SVG_TAGS", () => (parcelRequire("hlMjd")).SVG_TAGS);
$parcel$export(module.exports, "update", () => (parcelRequire("exslg")).update);
parcelRequire("4LyzS");

});
parcelRegister("4LyzS", function(module, exports) {

$parcel$export(module.exports, "create", () => (parcelRequire("fQWe4")).create);
$parcel$export(module.exports, "update", () => (parcelRequire("exslg")).update);
$parcel$export(module.exports, "dispose", () => (parcelRequire("gXM9X")).dispose);
$parcel$export(module.exports, "remove", () => (parcelRequire("gXM9X")).remove);
$parcel$export(module.exports, "REGISTRY", () => (parcelRequire("5utcL")).REGISTRY);
$parcel$export(module.exports, "LIFECYCLE_EVENTS", () => (parcelRequire("5utcL")).LIFECYCLE_EVENTS);
$parcel$export(module.exports, "DELEGATED_EVENTS", () => (parcelRequire("5utcL")).DELEGATED_EVENTS);
$parcel$export(module.exports, "MIXINS", () => (parcelRequire("5utcL")).MIXINS);
$parcel$export(module.exports, "addDelegatedEvent", () => (parcelRequire("5Or4i")).addDelegatedEvent);
$parcel$export(module.exports, "removeDelegatedEvent", () => (parcelRequire("5Or4i")).removeDelegatedEvent);
$parcel$export(module.exports, "registerEvent", () => (parcelRequire("5Or4i")).registerEvent);
$parcel$export(module.exports, "cacheNode", () => (parcelRequire("hlMjd")).cacheNode);
$parcel$export(module.exports, "detectTag", () => (parcelRequire("hlMjd")).detectTag);
$parcel$export(module.exports, "createHTMLNode", () => (parcelRequire("hlMjd")).createHTMLNode);
$parcel$export(module.exports, "isValidTag", () => (parcelRequire("hlMjd")).isValidTag);
$parcel$export(module.exports, "isSvgTag", () => (parcelRequire("hlMjd")).isSvgTag);
$parcel$export(module.exports, "SVG_TAGS", () => (parcelRequire("hlMjd")).SVG_TAGS);
$parcel$export(module.exports, "applyExtends", () => (parcelRequire("3QQ54")).applyExtends);
$parcel$export(module.exports, "addMethods", () => (parcelRequire("1P3uZ")).addMethods);

var $fQWe4 = parcelRequire("fQWe4");

var $exslg = parcelRequire("exslg");

var $gXM9X = parcelRequire("gXM9X");

var $5utcL = parcelRequire("5utcL");

var $5Or4i = parcelRequire("5Or4i");

var $hlMjd = parcelRequire("hlMjd");

var $3QQ54 = parcelRequire("3QQ54");

var $1P3uZ = parcelRequire("1P3uZ");

});
parcelRegister("fQWe4", function(module, exports) {

$parcel$export(module.exports, "create", () => $b8a8e0d131ddbeb6$export$185802fd694ee1f5);
parcelRequire("flu9Q");
var $hBrLD = parcelRequire("hBrLD");
var $lQ86u = parcelRequire("lQ86u");

var $hlMjd = parcelRequire("hlMjd");

var $5utcL = parcelRequire("5utcL");

var $5Or4i = parcelRequire("5Or4i");

var $3QQ54 = parcelRequire("3QQ54");

var $1P3uZ = parcelRequire("1P3uZ");
parcelRequire("gXM9X");
parcelRequire("2oe0q");
var $1zeno = parcelRequire("1zeno");

var $aQqva = parcelRequire("aQqva");
parcelRequire("bxxg4");
var $gfplm = parcelRequire("gfplm");

var $dXl0a = parcelRequire("dXl0a");

var $cThmB = parcelRequire("cThmB");
parcelRequire("2Eo8m");
var $bd7kG = parcelRequire("bd7kG");
parcelRequire("aTPvW");
var $7KiQp = parcelRequire("7KiQp");

var $inO1F = parcelRequire("inO1F");
'use strict';
let $b8a8e0d131ddbeb6$var$_uniqId = 1;
// Detect onXxx event handler pattern
function $b8a8e0d131ddbeb6$var$isEventHandler(key) {
    return key.length > 2 && key.charCodeAt(0) === 111 && // 'o'
    key.charCodeAt(1) === 110 && // 'n'
    key.charCodeAt(2) >= 65 && key.charCodeAt(2) <= 90 // A-Z
    ;
}
// Extract event name from onXxx key (onClick -> click, onMouseDown -> mouseDown)
function $b8a8e0d131ddbeb6$var$eventNameFrom(key) {
    return key.charAt(2).toLowerCase() + key.slice(3);
}
// Convert camelCase event name to lowercase DOM event (mouseDown -> mousedown)
function $b8a8e0d131ddbeb6$var$toDomEventName(name) {
    return name.toLowerCase();
}
// Deep merge for child component definitions — override wins, but nested objects are recursively merged
function $b8a8e0d131ddbeb6$var$deepMergeChild(base, override) {
    const result = {
        ...base
    };
    for(const key in override){
        const baseVal = result[key];
        const overVal = override[key];
        if (baseVal && overVal && typeof baseVal === 'object' && typeof overVal === 'object' && !Array.isArray(baseVal) && !Array.isArray(overVal) && typeof baseVal !== 'function' && typeof overVal !== 'function') result[key] = $b8a8e0d131ddbeb6$var$deepMergeChild(baseVal, overVal);
        else result[key] = overVal;
    }
    return result;
}
function $b8a8e0d131ddbeb6$export$185802fd694ee1f5(definition, parent, key, options = {}, attachOptions) {
    // Normalize definition
    if (definition == null || definition === false) return null;
    if (typeof definition === 'string' || typeof definition === 'number') definition = {
        text: definition
    };
    const element = Object.create(null);
    element.key = key || definition.key || `_${$b8a8e0d131ddbeb6$var$_uniqId++}`;
    element.parent = parent || null;
    element.context = definition.context || parent?.context || options.context || {};
    if (!element.context.__create) element.context.__create = $b8a8e0d131ddbeb6$export$185802fd694ee1f5;
    // Internal ref
    const ref = element.__ref = {
        __if: true,
        __children: [],
        __exec: {},
        __effects: [],
        __eventCleanup: [],
        root: parent?.__ref?.root || element,
        path: parent?.__ref?.path ? [
            ...parent.__ref.path,
            element.key
        ] : [
            element.key
        ]
    };
    // Auto-extend from key name: Key_suffix -> extends Key component
    if (key && !definition.extends && !definition.extend) {
        const underscoreIdx = key.indexOf('_');
        if (underscoreIdx > 0) {
            const baseName = key.substring(0, underscoreIdx);
            const components = element.context?.components;
            if (components && (components[baseName] || components['smbls.' + baseName])) definition = {
                extends: baseName,
                ...definition
            };
        }
    }
    // Merge extends chain
    (0, $3QQ54.applyExtends)(element, definition, options);
    // Copy properties from definition — deep merge child overrides, shallow merge known keys, override rest
    const MERGE_KEYS = new Set([
        'childProps',
        'attr',
        'style',
        'scope',
        'data'
    ]);
    // Capture props set by the extends chain before they get merged flat
    const inheritedProps = element.props && typeof element.props === 'object' ? element.props : null;
    for(const prop in definition){
        if (prop === 'parent' || prop === 'node' || prop === '__ref' || prop === 'extends' || prop === 'context' || prop === 'props') continue;
        const val = definition[prop];
        const existing = element[prop];
        const bothObjects = existing && val && typeof existing === 'object' && typeof val === 'object' && !Array.isArray(existing) && !Array.isArray(val) && typeof existing !== 'function' && typeof val !== 'function';
        if (bothObjects && prop.charCodeAt(0) >= 65 && prop.charCodeAt(0) <= 90) // Deep merge for uppercase child component overrides (definition wins)
        element[prop] = $b8a8e0d131ddbeb6$var$deepMergeChild(existing, val);
        else if (bothObjects && MERGE_KEYS.has(prop)) element[prop] = {
            ...existing,
            ...val
        };
        else element[prop] = val;
    }
    // Helper to merge a props-like object onto element directly
    function mergePropsOntoElement(propsObj) {
        for(const prop in propsObj){
            const val = propsObj[prop];
            const existing = element[prop];
            const bothObjects = existing && val && typeof existing === 'object' && typeof val === 'object' && !Array.isArray(existing) && !Array.isArray(val) && typeof existing !== 'function' && typeof val !== 'function';
            if (bothObjects && prop.charCodeAt(0) >= 65 && prop.charCodeAt(0) <= 90) element[prop] = $b8a8e0d131ddbeb6$var$deepMergeChild(existing, val);
            else if (bothObjects && MERGE_KEYS.has(prop)) element[prop] = {
                ...existing,
                ...val
            };
            else element[prop] = val;
        }
    }
    // Merge inherited props from extends chain flat onto element
    if (inheritedProps) mergePropsOntoElement(inheritedProps);
    // Merge definition.props flat onto element (definition overrides inherited)
    if (definition.props && typeof definition.props === 'object') mergePropsOntoElement(definition.props);
    if (definition.data !== undefined) element.data = definition.data;
    if (definition.classlist !== undefined) element.classlist = definition.classlist;
    if (definition.text !== undefined) element.text = definition.text;
    if (definition.html !== undefined) element.html = definition.html;
    // The scope chain at any element resolves keys in this order:
    //   own (definition.scope) → parent.scope → … → root.scope → context.globalScope
    // Direct reads like `el.scope.LANG_META` walk the prototype chain, so a
    // component that doesn't declare its own scope still sees parent scopes
    // and the project's globalScope as fallbacks. Without `globalScope` at the
    // bottom of the chain, every project pattern that puts shared constants
    // in `globalScope.js` and reads them via `el.scope.X` was silently broken
    // — the user's reactive function got `undefined` and either threw or
    // rendered nothing. The frank-rewriter's `__scope` helper already chains
    // through globalScope; this brings the runtime `el.scope` to parity.
    const ancestorScope = parent?.scope;
    const globalScope = element.context && typeof element.context.globalScope === 'object' && element.context.globalScope || null;
    const baseScope = ancestorScope || (globalScope ? Object.create(globalScope) : null);
    if (definition.scope !== undefined) element.scope = baseScope ? Object.assign(Object.create(baseScope), definition.scope) : definition.scope;
    else if (baseScope) element.scope = Object.create(baseScope);
    if (definition.if !== undefined) element.if = definition.if;
    // Add methods
    (0, $1P3uZ.addMethods)(element);
    // Create state (reactive store)
    $b8a8e0d131ddbeb6$var$createElementState(element, parent, definition);
    // Evaluate `if` condition
    if (element.if != null) {
        const ifResult = typeof element.if === 'function' ? element.if(element, element.state, element.context) : element.if;
        ref.__if = !!ifResult;
    }
    if (!ref.__if) {
        if (parent) parent[element.key] = element;
        // Register only the `if` effect so the element can appear later when the
        // condition becomes true. Other effects will be registered inside the
        // effect's first-time activation branch.
        if (typeof definition.if === 'function') $b8a8e0d131ddbeb6$var$registerEffects(element, {
            if: definition.if
        });
        return element;
    } else if (typeof definition.if === 'function') // Element starts visible — mark as initialized so the `if` effect's
    // re-activation branch (false→true) doesn't re-run full creation.
    ref.__ifInitialized = true;
    // Detect tag
    if (!element.tag) element.tag = (0, $hlMjd.detectTag)(element);
    // Fire onInit
    $b8a8e0d131ddbeb6$var$triggerLifecycle('Init', element, options);
    // Create DOM node
    const node = element.node = (0, $hlMjd.cacheNode)(element);
    if (!node) return element;
    $b8a8e0d131ddbeb6$var$triggerLifecycle('AttachNode', element, options);
    // Set key as data attribute for dev debugging
    if (node.setAttribute && element.key) node.setAttribute('data-key', element.key);
    // Stamp data-smbls-app on the app's root node so its design-system CSS
    // variables (scoped to `[data-smbls-app="<key>"]`) cascade through its
    // subtree without leaking to sibling apps in the same document.
    if (node.setAttribute && element.context?.scopeSelector && element.context.scopeSelector !== ':root' && element.context.key && element.key === element.context.key) node.setAttribute('data-smbls-app', element.context.key);
    // Apply id attribute
    if (element.id && node.setAttribute) node.id = element.id;
    // Register reactive effects for dynamic properties
    $b8a8e0d131ddbeb6$var$registerEffects(element, definition);
    // Apply static mixins (text, html, style, attr, data, classlist)
    $b8a8e0d131ddbeb6$var$applyStaticMixins(element);
    // Apply attrs-in-props (src, href, etc. from element properties)
    $b8a8e0d131ddbeb6$var$applyAttrsInProps(element);
    // Register events (onXxx handlers directly on element)
    $b8a8e0d131ddbeb6$var$registerEvents(element, options);
    // FB-render-runtime: previously a thrown error inside createChildren()
    // would silently abort the element-mount walk, leaving the page with a
    // 0-child root div and no console output. Wrap with try/catch + log so
    // operators can see what crashed.
    try {
        $b8a8e0d131ddbeb6$var$createChildren(element, options);
    } catch (childErr) {
        if (typeof console !== 'undefined' && console.error) {
            const elPath = element.__ref?.path?.join('.') || element.key || '<root>';
            console.error(`[smbls] createChildren failed at ${elPath}:`, childErr?.message || childErr, childErr?.stack ? '\n' + childErr.stack.split('\n').slice(0, 6).join('\n') : '');
        }
    }
    // Assign node to DOM
    $b8a8e0d131ddbeb6$var$assignNode(element, parent, attachOptions);
    // Track in parent
    if (parent) {
        parent[element.key] = element;
        if (parent.__ref?.__children) {
            if (!parent.__ref.__children.includes(element.key)) parent.__ref.__children.push(element.key);
        }
    }
    // Evaluate extends-inherited html functions (e.g. Svg component).
    // Guard: if the function returns a function (e.g. an extended component
    // forwards `value` which itself is a function getter), skip setting
    // innerHTML — otherwise we'd serialize the function source into the DOM
    // (visible as `(el, s) => …` text inside textareas / inputs).
    if (typeof element.html === 'function' && element.node && !element.node.innerHTML) try {
        const val = element.html(element, element.state, element.context);
        if (val != null && typeof val !== 'function') element.node.innerHTML = val;
    } catch (e) {}
    $b8a8e0d131ddbeb6$var$triggerLifecycle('Create', element, options);
    $b8a8e0d131ddbeb6$var$triggerLifecycle('Complete', element, options);
    $b8a8e0d131ddbeb6$var$triggerLifecycle('Render', element, options);
    $b8a8e0d131ddbeb6$var$triggerLifecycle('RenderRouter', element, options);
    // Start onFrame loop if defined
    if (typeof element.onFrame === 'function') {
        const frameHandler = element.onFrame;
        const frameDsConfig = element.context?.designSystem;
        const tick = ()=>{
            if (!element.node || !element.node.isConnected) return;
            if (frameDsConfig) (0, $7KiQp.pushConfig)(frameDsConfig);
            try {
                frameHandler(element, element.state, element.context);
            } catch (e) {
                console.error('[DOMQL] onFrame error:', e);
            } finally{
                if (frameDsConfig) (0, $7KiQp.popConfig)();
            }
            requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
    }
    return element;
}
// --- State Creation ---
function $b8a8e0d131ddbeb6$var$createElementState(element, parent, definition) {
    // Prefer the local definition's `state`, but fall back to anything that
    // applyExtends already merged onto element.state from the extends chain.
    // Without this fallback, a component like `{ extends: 'Dashboard' }` where
    // Dashboard defines `state: { useJson: true }` would lose its state because
    // the local definition has no `state` field, and we'd silently inherit
    // parent state instead.
    // Treat an empty plain-object `state: {}` declaration as "not provided"
    // when this is the root element AND context.state has content. Without
    // this, scaffolded `app.js` files that ship with `state: {}` boilerplate
    // would silently override context.state (loaded from `state.js`) and
    // leave the root state empty at runtime — see chatbot template where
    // `s.root.navTabs` resolved undefined despite a populated state.js.
    // Explicit non-empty objects + non-root elements bypass this rewrite.
    const isRootCandidate = !parent;
    const isEmptyObjectState = definition.state && typeof definition.state === 'object' && !Array.isArray(definition.state) && Object.keys(definition.state).length === 0;
    const useContextStateFallback = isRootCandidate && isEmptyObjectState && element.context?.state;
    const stateDef = definition.state !== undefined && !useContextStateFallback ? definition.state : element.state && !(0, $lQ86u.isStore)(element.state) ? element.state : undefined;
    if (stateDef === undefined || stateDef === null) {
        if (parent?.state) {
            element.state = parent.state;
            (0, $gfplm.applyStateMethods)(element, element.state);
        } else if (element.context?.state) {
            // Root element: use prepared state from context
            const ctxState = element.context.state;
            const stateData = {
                ...ctxState
            };
            // Merge polyglot translations for active language into root state
            const poly = element.context?.polyglot;
            if (poly?.translations) {
                const lang = ctxState.lang || poly.defaultLang || 'en';
                const langT = poly.translations[lang];
                if (langT && typeof langT === 'object') {
                    for(const k in langT)if (stateData[k] === undefined) stateData[k] = langT[k];
                }
                // Also merge top-level translation keys (skip language code keys)
                const langs = new Set(poly.languages || []);
                for(const k in poly.translations)if (!langs.has(k) && stateData[k] === undefined) stateData[k] = poly.translations[k];
            }
            element.state = (0, $lQ86u.isStore)(stateData) ? stateData : (0, $lQ86u.createStore)(stateData);
            element.state.__element = element;
            element.state.root = element.state;
            (0, $gfplm.applyStateMethods)(element, element.state);
        } else {
            element.state = {};
            // Self-reference root so consumer code can rely on `s.root` always
            // being defined, matching the root-element branch above. Non-enumerable
            // so Object.keys / for…in / JSON.stringify skip it (this is a plain
            // object — unlike a store proxy, which hides root from ownKeys via
            // the proxy trap).
            Object.defineProperty(element.state, 'root', {
                value: element.state,
                enumerable: false,
                configurable: true,
                writable: true
            });
            (0, $gfplm.applyStateMethods)(element, element.state);
        }
        return;
    }
    if (typeof stateDef === 'string') {
        element.state = $b8a8e0d131ddbeb6$var$resolveStatePath(stateDef, parent);
        // Propagate root reference to plain sub-state objects (v3 compat: s.root).
        // Final fallback to self-ref keeps `s.root` defined even for orphan
        // string-bound state (no parent, or parent has no state).
        if (element.state && typeof element.state === 'object' && !(0, $lQ86u.isStore)(element.state)) {
            const rootRef = parent?.state?.root || parent?.state || element.state;
            Object.defineProperty(element.state, 'root', {
                value: rootRef,
                enumerable: false,
                configurable: true,
                writable: true
            });
        }
        (0, $gfplm.applyStateMethods)(element, element.state);
        return;
    }
    if (typeof stateDef === 'function') {
        const resolved = stateDef(element, parent?.state);
        element.state = (0, $lQ86u.createStore)(resolved || {});
    } else element.state = (0, $lQ86u.createStore)({
        ...stateDef
    });
    element.state.__element = element;
    if (parent?.state) {
        element.state.parent = parent.state;
        // Inherit root reference from parent chain
        element.state.root = parent.state.root || parent.state;
    } else // Root element: self-reference for v3 compat (state.root === state)
    element.state.root = element.state;
    (0, $gfplm.applyStateMethods)(element, element.state);
}
function $b8a8e0d131ddbeb6$var$resolvePath(obj, path) {
    if (!path) return obj;
    const parts = path.split('/');
    let result = obj;
    for (const part of parts){
        if (result === undefined || result === null) return {};
        result = result[part];
    }
    return result ?? {};
}
function $b8a8e0d131ddbeb6$var$resolveStatePath(path, parent) {
    if (!parent) return {};
    if (path === '.') return parent.state || {};
    if (path.startsWith('../')) {
        const key = path.slice(3);
        return key ? $b8a8e0d131ddbeb6$var$resolvePath(parent.state, key) : parent.state ?? {};
    }
    if (path.startsWith('~/')) {
        const rootState = parent.state?.root || parent.state;
        const key = path.slice(2);
        return key ? $b8a8e0d131ddbeb6$var$resolvePath(rootState, key) : rootState ?? {};
    }
    // Check parent state first (supports nested paths like 'product/0')
    if (parent.state?.[path] !== undefined) return parent.state[path];
    const nested = $b8a8e0d131ddbeb6$var$resolvePath(parent.state, path);
    if (nested !== undefined && nested !== null && Object.keys(nested).length > 0) return nested;
    // Fall back to polyglot translations for current language
    const poly = parent.context?.polyglot;
    if (poly?.translations) {
        const lang = parent.state?.root?.lang || poly.defaultLang || 'en';
        const langTranslations = poly.translations[lang];
        if (langTranslations?.[path] !== undefined) return langTranslations[path];
        // Check top-level translations
        if (poly.translations[path] !== undefined) return poly.translations[path];
    }
    return {};
}
// --- Reactive Effects ---
function $b8a8e0d131ddbeb6$var$registerEffects(element, definition) {
    const ref = element.__ref;
    // Text effect
    if (typeof element.text === 'function') {
        const fn = element.text;
        const effect = (0, $hBrLD.createEffect)(()=>{
            try {
                let val = fn(element, element.state, element.context);
                if (element.node && val != null && typeof val !== 'function' && typeof val !== 'object') {
                    // Resolve {{ }} templates in function return values
                    if (typeof val === 'string' && val.includes('{{')) val = (0, $1zeno.replaceLiteralsWithObjectFields).call(element, val, element.state);
                    if (element.tag === 'string') element.node.nodeValue = val;
                    else element.node.textContent = val;
                }
            } catch (e) {}
        }, {
            depth: ref.path.length
        });
        ref.__effects.push(effect);
        ref.__exec.text = fn;
    } else if (typeof element.text === 'string' && element.text.includes('{{')) {
        const template = element.text;
        const effect = (0, $hBrLD.createEffect)(()=>{
            const val = (0, $1zeno.replaceLiteralsWithObjectFields).call(element, template, element.state);
            if (val != null) element.text = val // Update element.text with resolved value
            ;
            if (element.node) {
                if (element.tag === 'string') element.node.nodeValue = val ?? '';
                else element.node.textContent = val ?? '';
            }
        }, {
            depth: ref.path.length
        });
        ref.__effects.push(effect);
        ref.__exec.text = template;
    }
    // Reactive effects for function-valued CSS properties (CSS_PROPS_REGISTRY and DEFAULT_CSS)
    for(const prop in element){
        if (!Object.prototype.hasOwnProperty.call(element, prop)) continue;
        if (typeof element[prop] !== 'function') continue;
        if ((0, $5utcL.REGISTRY).has(prop)) continue;
        if ($b8a8e0d131ddbeb6$var$isEventHandler(prop)) continue;
        if (ref.__exec[prop]) continue;
        if ((0, $dXl0a.CSS_PROPS_REGISTRY)[prop]) {
            const fn = element[prop];
            const cssProp = prop;
            const effect = (0, $hBrLD.createEffect)(()=>{
                // Push this element's design system config so CSS_PROPS_REGISTRY
                // handlers (which internally call getActiveConfig() for token resolution)
                // see the right config in multi-app setups (canvas editor vs. iframe project).
                // The document is on the config, so getActiveDocument() resolves it too.
                const ds = element.context?.designSystem;
                if (ds) (0, $7KiQp.pushConfig)(ds);
                try {
                    const val = fn(element, element.state, element.context);
                    const cssResult = (0, $dXl0a.CSS_PROPS_REGISTRY)[cssProp](val, element, element.state, element.context);
                    if (cssResult && element.node) $b8a8e0d131ddbeb6$var$applyStyles(element.node, cssResult);
                    else if (element.node && (cssProp === 'show' || cssProp === 'hide')) element.node.style.display = '';
                } finally{
                    if (ds) (0, $7KiQp.popConfig)();
                }
            }, {
                depth: ref.path.length
            });
            ref.__effects.push(effect);
            ref.__exec[prop] = fn;
        } else if ((0, $cThmB.DEFAULT_CSS_PROPERTIES_LIST) && (0, $cThmB.DEFAULT_CSS_PROPERTIES_LIST).has(prop)) {
            const fn = element[prop];
            const cssProp = prop;
            const effect = (0, $hBrLD.createEffect)(()=>{
                const ds = element.context?.designSystem;
                if (ds) (0, $7KiQp.pushConfig)(ds);
                try {
                    const val = fn(element, element.state, element.context);
                    if (element.node) {
                        if (val != null) $b8a8e0d131ddbeb6$var$applyStyles(element.node, {
                            [cssProp]: val
                        });
                        else element.node.style[cssProp] = '';
                    }
                } finally{
                    if (ds) (0, $7KiQp.popConfig)();
                }
            }, {
                depth: ref.path.length
            });
            ref.__effects.push(effect);
            ref.__exec[prop] = fn;
        }
    }
    // HTML effect.
    // Guard: skip when the html function returns a function (forwarded reactive
    // getter from an extended component). Avoids serializing the function source
    // into innerHTML — see same guard in the eager-pass block above.
    if (typeof definition.html === 'function') {
        const fn = definition.html;
        const effect = (0, $hBrLD.createEffect)(()=>{
            const val = fn(element, element.state, element.context);
            if (element.node && val != null && typeof val !== 'function') element.node.innerHTML = val;
        }, {
            depth: ref.path.length
        });
        ref.__effects.push(effect);
        ref.__exec.html = fn;
    }
    // Value effect — reactively set node.value on input/textarea/select.
    // Preserves cursor position for the currently focused input so a re-render
    // mid-typing does not yank the caret to the end.
    if (typeof definition.value === 'function') {
        const fn = definition.value;
        const effect = (0, $hBrLD.createEffect)(()=>{
            try {
                const val = fn(element, element.state, element.context);
                if (!element.node || !('value' in element.node)) return;
                const next = val == null ? '' : String(val);
                if (element.node.value === next) return;
                const focused = typeof document !== 'undefined' && document.activeElement === element.node;
                const selStart = focused && typeof element.node.selectionStart === 'number' ? element.node.selectionStart : null;
                const selEnd = focused && typeof element.node.selectionEnd === 'number' ? element.node.selectionEnd : null;
                element.node.value = next;
                if (focused && selStart != null && selEnd != null) try {
                    element.node.setSelectionRange(selStart, selEnd);
                } catch (e) {}
            } catch (e) {}
        }, {
            depth: ref.path.length
        });
        ref.__effects.push(effect);
        ref.__exec.value = fn;
    }
    // Style effect
    if (typeof definition.style === 'function') {
        const fn = definition.style;
        const effect = (0, $hBrLD.createEffect)(()=>{
            const styles = fn(element, element.state, element.context);
            $b8a8e0d131ddbeb6$var$applyStyles(element.node, styles);
        }, {
            depth: ref.path.length
        });
        ref.__effects.push(effect);
        ref.__exec.style = fn;
    } else if (element.style && typeof element.style === 'object') // Nested-object style: function values per-key get individual effects.
    // Static keys go through applyStaticMixins → applyStyles at mount.
    // Without this branch, `style: { color: (el, s) => s.theme }` runs
    // once at mount and never re-evaluates, while flat top-level
    // `color: fn` IS reactive — surprising parity gap (FA-L23).
    for(const styleKey in element.style){
        const styleFn = element.style[styleKey];
        if (typeof styleFn !== 'function') continue;
        const effect = (0, $hBrLD.createEffect)(()=>{
            try {
                const val = styleFn(element, element.state, element.context);
                if (element.node) $b8a8e0d131ddbeb6$var$applyStyles(element.node, {
                    [styleKey]: val
                });
            } catch (e) {}
        }, {
            depth: ref.path.length
        });
        ref.__effects.push(effect);
    }
    // Attribute effects for function-valued attrs (check element.attr which includes extends)
    if (element.attr && typeof element.attr === 'object') {
        for(const attrName in element.attr)if (typeof element.attr[attrName] === 'function') {
            const fn = element.attr[attrName];
            const name = attrName;
            const effect = (0, $hBrLD.createEffect)(()=>{
                try {
                    const val = fn(element, element.state, element.context);
                    if (element.node?.setAttribute) {
                        if (val == null || val === false) element.node.removeAttribute(name);
                        else if (typeof val !== 'function' && typeof val !== 'object') element.node.setAttribute(name, val === true ? '' : val);
                    }
                } catch (e) {
                // Attr function may fail if element properties aren't ready yet
                }
            }, {
                depth: ref.path.length
            });
            ref.__effects.push(effect);
        }
    }
    // Reactive nested aria.X — `aria: { label: (el, s) => s.title }` re-runs
    // on every state change. Static aria.X values are flattened to top-level
    // attrs by `filterAttributesByTagName` (attrs-in-props/index.js), so we
    // only wire effects for function values here.
    if (element.aria && typeof element.aria === 'object') for(const ariaKey in element.aria){
        const ariaFn = element.aria[ariaKey];
        if (typeof ariaFn !== 'function') continue;
        const attrName = 'aria-' + ariaKey.replace(/[A-Z]/g, (m)=>'-' + m.toLowerCase());
        const effect = (0, $hBrLD.createEffect)(()=>{
            try {
                const val = ariaFn(element, element.state, element.context);
                if (!element.node?.setAttribute) return;
                if (val == null || val === false) element.node.removeAttribute(attrName);
                else if (typeof val !== 'function' && typeof val !== 'object') element.node.setAttribute(attrName, val === true ? '' : val);
            } catch (e) {}
        }, {
            depth: ref.path.length
        });
        ref.__effects.push(effect);
    }
    // Reactive nested data.X — same shape as aria, kebab-cases the key.
    if (element.data && typeof element.data === 'object') for(const dataKey in element.data){
        const dataFn = element.data[dataKey];
        if (typeof dataFn !== 'function') continue;
        const kebab = dataKey.replace(/[A-Z]/g, (m)=>'-' + m.toLowerCase());
        const attrName = 'data-' + kebab;
        const effect = (0, $hBrLD.createEffect)(()=>{
            try {
                const val = dataFn(element, element.state, element.context);
                if (!element.node?.setAttribute) return;
                if (val == null || val === false) element.node.removeAttribute(attrName);
                else if (typeof val !== 'function' && typeof val !== 'object') element.node.setAttribute(attrName, val === true ? '' : val);
            } catch (e) {}
        }, {
            depth: ref.path.length
        });
        ref.__effects.push(effect);
    }
    // Reactive classlist / class — `class: { active: (el, s) => s.isOpen }`
    // toggles on state change. Static keys are applied at mount by
    // applyStaticMixins; only function-valued keys need effects here.
    const classObj = element.classlist && typeof element.classlist === 'object' && !Array.isArray(element.classlist) ? element.classlist : element.class && typeof element.class === 'object' && !Array.isArray(element.class) ? element.class : null;
    if (classObj) for(const className in classObj){
        const classFn = classObj[className];
        if (typeof classFn !== 'function') continue;
        const effect = (0, $hBrLD.createEffect)(()=>{
            try {
                const val = classFn(element, element.state, element.context);
                if (!element.node?.classList) return;
                // Mirror the static-path logic: `val: 'custom-name'` → toggle that
                // string class on; falsy → toggle base key off; truthy non-string →
                // toggle base key on.
                if (typeof val === 'string') element.node.classList.add(val);
                else if (val) element.node.classList.add(className);
                else element.node.classList.remove(className);
            } catch (e) {}
        }, {
            depth: ref.path.length
        });
        ref.__effects.push(effect);
    }
    // If condition effect
    if (typeof definition.if === 'function') {
        const fn = definition.if;
        const effect = (0, $hBrLD.createEffect)(()=>{
            const ifResult = fn(element, element.state, element.context);
            const wasVisible = ref.__if;
            ref.__if = !!ifResult;
            if (wasVisible && !ref.__if && element.node) element.node.remove();
            else if (!wasVisible && ref.__if) {
                // First-time activation: run the full creation steps that were skipped
                // when initial `if` was false. This builds the element's node, children,
                // attrs, and events the first time the condition becomes true.
                if (!ref.__ifInitialized) {
                    ref.__ifInitialized = true;
                    if (!element.tag) element.tag = (0, $hlMjd.detectTag)(element);
                    $b8a8e0d131ddbeb6$var$triggerLifecycle('Init', element, {});
                    if (!element.node) element.node = (0, $hlMjd.cacheNode)(element);
                    if (!element.node) return;
                    $b8a8e0d131ddbeb6$var$triggerLifecycle('AttachNode', element, {});
                    if (element.node.setAttribute && element.key) element.node.setAttribute('data-key', element.key);
                    if (element.id && element.node.setAttribute) element.node.id = element.id;
                    // Register reactive effects for dynamic props (excluding `if` to avoid recursion)
                    const prevIf = definition.if;
                    delete definition.if;
                    try {
                        $b8a8e0d131ddbeb6$var$registerEffects(element, definition);
                    } finally{
                        definition.if = prevIf;
                    }
                    $b8a8e0d131ddbeb6$var$applyStaticMixins(element);
                    $b8a8e0d131ddbeb6$var$applyAttrsInProps(element);
                    $b8a8e0d131ddbeb6$var$registerEvents(element, {});
                    $b8a8e0d131ddbeb6$var$createChildren(element, {});
                    $b8a8e0d131ddbeb6$var$assignNode(element, element.parent);
                } else {
                    // Subsequent re-activations: just re-attach existing node
                    if (!element.node) element.node = (0, $hlMjd.cacheNode)(element);
                    // Find the next sibling in DOMQL tree that has a node, to insert before it
                    const parent = element.parent;
                    const parentNode = parent?.node;
                    if (parentNode && element.node) {
                        let nextSibNode = null;
                        const keys = Object.keys(parent);
                        const myIdx = keys.indexOf(element.key);
                        for(let i = myIdx + 1; i < keys.length; i++){
                            const sib = parent[keys[i]];
                            if (sib?.node?.parentNode === parentNode) {
                                nextSibNode = sib.node;
                                break;
                            }
                        }
                        if (nextSibNode) parentNode.insertBefore(element.node, nextSibNode);
                        else parentNode.appendChild(element.node);
                    } else $b8a8e0d131ddbeb6$var$assignNode(element, element.parent);
                    $b8a8e0d131ddbeb6$var$applyStaticMixins(element);
                }
            }
        }, {
            depth: ref.path.length
        });
        ref.__effects.push(effect);
    }
    // CSS-in-props effects (dynamic CSS properties as functions)
    for(const prop in element){
        if (!Object.prototype.hasOwnProperty.call(element, prop)) continue;
        if ((0, $5utcL.REGISTRY).has(prop)) continue;
        if (typeof element[prop] !== 'function') continue;
        // Skip child components (Uppercase)
        const firstChar = prop.charCodeAt(0);
        if (firstChar >= 65 && firstChar <= 90) continue;
        // Skip onXxx event handlers
        if ($b8a8e0d131ddbeb6$var$isEventHandler(prop)) continue;
        const fn = element[prop];
        ref.__exec[prop] = fn;
        // Reactive effects for function-valued HTML attributes (src, href, etc.)
        // Skip props already handled as CSS properties
        const tag = element.tag || 'div';
        if ((0, $inO1F.checkAttributeByTagName)(tag, prop) && !(0, $dXl0a.CSS_PROPS_REGISTRY)[prop] && !((0, $cThmB.DEFAULT_CSS_PROPERTIES_LIST) && (0, $cThmB.DEFAULT_CSS_PROPERTIES_LIST).has(prop))) {
            const attrName = prop;
            const effect = (0, $hBrLD.createEffect)(()=>{
                try {
                    const val = fn(element, element.state, element.context);
                    if (element.node?.setAttribute) {
                        if (val == null || val === false) element.node.removeAttribute(attrName);
                        else if (typeof val !== 'function' && typeof val !== 'object') {
                            // Use property setter for src on iframes/media to trigger navigation
                            if (attrName === 'src' && 'src' in element.node) element.node.src = val;
                            else element.node.setAttribute(attrName, val === true ? '' : val);
                        }
                    }
                } catch (e) {}
            }, {
                depth: ref.path.length
            });
            ref.__effects.push(effect);
        }
    }
    // Reactive conditionals (.prop / !prop blocks)
    $b8a8e0d131ddbeb6$var$registerConditionalEffects(element);
}
// --- Static Mixin Application ---
function $b8a8e0d131ddbeb6$var$applyStaticMixins(element) {
    const { node: node } = element;
    if (!node) return;
    // Text (skip template literals — handled by reactive effect)
    if (typeof element.text === 'string' && !element.text.includes('{{')) {
        if (element.tag === 'string') node.nodeValue = element.text;
        else node.textContent = element.text;
    } else if (typeof element.text === 'number') node.textContent = element.text;
    // CSS-in-props static transforms (show, hide, padding, flexAlign, etc.)
    // Conditionals (.prop / !prop) are handled reactively in registerConditionalEffects
    $b8a8e0d131ddbeb6$var$applyCssInProps(element);
    // HTML
    if (typeof element.html === 'string') node.innerHTML = element.html;
    // Static value for input/textarea/select. The reactive effect path
    // (see registerEffects) handles function-valued `value:` props.
    if (element.value != null && typeof element.value !== 'function' && 'value' in node) {
        const next = String(element.value);
        if (node.value !== next) node.value = next;
    }
    // Style
    if (element.style && typeof element.style === 'object') $b8a8e0d131ddbeb6$var$applyStyles(node, element.style);
    // Attributes
    if (element.attr && typeof element.attr === 'object') for(const key in element.attr){
        const val = element.attr[key];
        if (typeof val === 'function' || typeof val === 'object') continue;
        if (val == null || val === false) continue;
        if (node.setAttribute) node.setAttribute(key, val === true ? '' : val);
    }
    // Data attributes — same guard shape as the attr loop above. Function-
    // valued data.X is handled by the reactive-data effect in registerEffects;
    // writing the function reference into `dataset` here would render as a
    // stringified function literal in the DOM until something else overwrote
    // it. Skip null/false/object values too.
    if (element.data && typeof element.data === 'object') for(const key in element.data){
        const val = element.data[key];
        if (typeof val === 'function' || typeof val === 'object') continue;
        if (val == null || val === false) continue;
        if (node.dataset) node.dataset[key] = val === true ? '' : val;
    }
    // Classlist
    if (element.classlist || element.class) {
        const cls = element.classlist || element.class;
        if (typeof cls === 'string') cls.split(' ').forEach((c)=>c && node.classList.add(c));
        else if (typeof cls === 'object') for(const name in cls){
            const val = typeof cls[name] === 'function' ? cls[name](element, element.state, element.context) : cls[name];
            if (val) node.classList.add(typeof val === 'string' ? val : name);
        }
    }
}
function $b8a8e0d131ddbeb6$var$applyStyles(node, styles) {
    if (!node || !styles || !node.style) return;
    let cssRules = null;
    for(const prop in styles){
        const val = styles[prop];
        if (val == null) continue;
        // Handle &: selectors — generate CSS rules
        if (prop.charAt(0) === '&' && typeof val === 'object') {
            if (!cssRules) cssRules = {};
            cssRules[prop] = val;
            continue;
        }
        try {
            const str = String(val);
            // Reactive writes go through `setProperty` as plain inline (no
            // priority). Inline already beats class-rule selectors in the cascade
            // — the smbls atomic CSS engine never emits `!important`, so a plain
            // inline value wins on its own. The previous `'important'` priority
            // was a cargo-culted band-aid for an apparent stale-getComputedStyle
            // observation; in practice it caused CSS transitions on the same
            // element to leave stuck `Animation` objects (currentTime:0,
            // fill:'backwards') because Chrome's transition state machine
            // mishandles a mid-transition switch to/from `!important`.
            // If a value carries an explicit `!important` suffix from upstream
            // (rare — design tokens etc.), honor it.
            const cssProp = prop.replace(/[A-Z]/g, (m)=>'-' + m.toLowerCase());
            const trimmed = str.trim();
            const isImportant = /\s*!important\s*$/.test(trimmed);
            const cleanVal = trimmed.replace(/\s*!important\s*$/, '');
            node.style.setProperty(cssProp, cleanVal, isImportant ? 'important' : '');
        } catch (e) {
        // Invalid style value
        }
    }
    // Inject CSS rules for &: selectors
    if (cssRules) $b8a8e0d131ddbeb6$var$injectScopedCSS(node, cssRules);
}
let $b8a8e0d131ddbeb6$var$_scopedStyleId = 0;
function $b8a8e0d131ddbeb6$var$injectScopedCSS(node, rules) {
    const id = `_ds${$b8a8e0d131ddbeb6$var$_scopedStyleId++}`;
    node.classList.add(id);
    const doc = node.ownerDocument;
    let styleEl = doc.querySelector('style[data-smbls-scoped]');
    if (!styleEl) {
        styleEl = doc.createElement('style');
        styleEl.setAttribute('data-smbls-scoped', '');
        doc.head.appendChild(styleEl);
    }
    let css = '';
    for(const selector in rules){
        // Replace & with scoped class, and auto-scope unscoped comma-separated parts
        const scopedClass = '.' + id;
        const resolvedSelector = selector.replace(/&/g, scopedClass).split(',').map((s)=>{
            const t = s.trim();
            return t.includes(scopedClass) ? t : scopedClass + t;
        }).join(', ');
        const val = rules[selector];
        if (typeof val === 'object') {
            // Check for nested selectors (e.g. '& [dropdown]' inside '&:focus-within')
            let props = '';
            let nested = '';
            for(const k in val){
                const v = val[k];
                if (typeof v === 'object') {
                    const nestedSelector = k.replace(/&/g, '.' + id);
                    const nestedSuffix = ' ' + nestedSelector.replace('.' + id, '');
                    const fullSelector = resolvedSelector.split(', ').map((s)=>s + nestedSuffix).join(', ');
                    let nestedProps = '';
                    for(const nk in v)nestedProps += `${nk.replace(/[A-Z]/g, (m)=>'-' + m.toLowerCase())}: ${v[nk]};`;
                    nested += `${fullSelector} { ${nestedProps} }\n`;
                } else props += `${k.replace(/[A-Z]/g, (m)=>'-' + m.toLowerCase())}: ${v};`;
            }
            if (props) css += `${resolvedSelector} { ${props} }\n`;
            if (nested) css += nested;
        }
    }
    if (css) styleEl.textContent += css;
}
// --- Conditionals ---
// Reactive `.propName` (truthy) and `!propName` (falsy) blocks.
//
// Each conditional becomes its own `createEffect` so signal-driven predicates
// (state reads inside a function-valued prop) re-fire it. Block values are
// applied via inline styles (with CSS_PROPS_REGISTRY token resolution) and
// reverted by clearing the inline keys when the predicate flips off — the
// static class never bakes in the conditional values, so there is nothing to
// unmerge on revert.
//
// Imperative updates to a non-signal predicate (e.g. `element.update({ isActive })`
// where `isActive` is a plain element prop, not in state) re-run via
// `__conditionalRunners`, which `update.js` invokes after applying the prop.
function $b8a8e0d131ddbeb6$var$registerConditionalEffects(element) {
    const ref = element.__ref;
    ref.__conditionalRunners = [];
    for(const key in element){
        if (!Object.prototype.hasOwnProperty.call(element, key)) continue;
        const c0 = key.charAt(0);
        if (c0 !== '.' && c0 !== '!') continue;
        const propName = key.slice(1);
        if (!propName) continue;
        const block = element[key];
        if (!block || typeof block !== 'object') continue;
        const negate = c0 === '!';
        const local = {
            lastMatch: false,
            appliedKeys: null
        };
        const evaluate = ()=>{
            if (!element.node) return;
            // Resolution order matches css-in-props transformer
            // (`applyConditionalCaseProps`): element prop → state → context.cases.
            // Reading `element.state[propName]` inside the effect subscribes to the
            // signal so state-only predicates re-fire on `state.update`.
            let resolved;
            const propVal = element[propName];
            if (propVal === undefined) {
                if (element.state && propName in element.state) resolved = element.state[propName];
                else {
                    const caseFn = element.context?.cases?.[propName];
                    if (caseFn === undefined) return;
                    resolved = typeof caseFn === 'function' ? caseFn.call(element, element) : caseFn;
                }
            } else if (typeof propVal === 'function') resolved = propVal(element, element.state, element.context);
            else resolved = propVal;
            const match = negate ? !resolved : !!resolved;
            if (match === local.lastMatch) return;
            local.lastMatch = match;
            const ds = element.context?.designSystem;
            if (ds) (0, $7KiQp.pushConfig)(ds);
            try {
                if (match) {
                    const styles = {};
                    for(const prop in block){
                        if (!Object.prototype.hasOwnProperty.call(block, prop)) continue;
                        const raw = typeof block[prop] === 'function' ? block[prop](element, element.state, element.context) : block[prop];
                        if (raw == null) continue;
                        if ((0, $dXl0a.CSS_PROPS_REGISTRY)[prop]) {
                            const r = (0, $dXl0a.CSS_PROPS_REGISTRY)[prop](raw, element, element.state, element.context);
                            if (r) {
                                const arr = Array.isArray(r) ? r : [
                                    r
                                ];
                                for (const o of arr)if (o) Object.assign(styles, o);
                            }
                        } else if ((0, $cThmB.DEFAULT_CSS_PROPERTIES_LIST) && (0, $cThmB.DEFAULT_CSS_PROPERTIES_LIST).has(prop)) styles[prop] = raw;
                    }
                    const keys = Object.keys(styles);
                    if (keys.length) {
                        $b8a8e0d131ddbeb6$var$applyStyles(element.node, styles);
                        local.appliedKeys = keys;
                    } else local.appliedKeys = null;
                } else if (local.appliedKeys) {
                    for (const k of local.appliedKeys)element.node.style[k] = '';
                    local.appliedKeys = null;
                }
            } finally{
                if (ds) (0, $7KiQp.popConfig)();
            }
        };
        ref.__conditionalRunners.push(evaluate);
        const effect = (0, $hBrLD.createEffect)(evaluate, {
            depth: ref.path.length
        });
        ref.__effects.push(effect);
    }
}
// --- CSS-in-props ---
// Processes element properties through CSS_PROPS_REGISTRY transforms
const $b8a8e0d131ddbeb6$var$__APPLY_CSS_STACK = new WeakSet();
function $b8a8e0d131ddbeb6$var$applyCssInProps(element) {
    const { node: node } = element;
    if (!node) return;
    if ($b8a8e0d131ddbeb6$var$__APPLY_CSS_STACK.has(element)) {
        console.error('[applyCssInProps] re-entry detected for element', element.key, 'prop path:', element.__ref?.path);
        return;
    }
    $b8a8e0d131ddbeb6$var$__APPLY_CSS_STACK.add(element);
    const ds = element.context?.designSystem;
    if (ds) (0, $7KiQp.pushConfig)(ds);
    try {
        const cssStyles = {};
        let hasStyles = false;
        for(const prop in element){
            if (!Object.prototype.hasOwnProperty.call(element, prop)) continue;
            if (typeof element[prop] === 'function') continue;
            if ((0, $5utcL.REGISTRY).has(prop)) continue;
            const firstChar = prop.charCodeAt(0);
            if (firstChar >= 65 && firstChar <= 90) continue;
            if ($b8a8e0d131ddbeb6$var$isEventHandler(prop)) continue;
            if ((0, $dXl0a.CSS_PROPS_REGISTRY)[prop]) {
                const val = element[prop];
                const cssResult = (0, $dXl0a.CSS_PROPS_REGISTRY)[prop](val, element, element.state, element.context);
                if (cssResult) {
                    if (Array.isArray(cssResult)) {
                        for (const r of cssResult)if (r) Object.assign(cssStyles, r);
                    } else Object.assign(cssStyles, cssResult);
                    hasStyles = true;
                }
            } else if ((0, $cThmB.DEFAULT_CSS_PROPERTIES_LIST) && (0, $cThmB.DEFAULT_CSS_PROPERTIES_LIST).has(prop)) {
                const val = element[prop];
                if (val != null && typeof val !== 'object') {
                    cssStyles[prop] = val;
                    hasStyles = true;
                }
            } else if (prop.charCodeAt(0) === 45 && prop.charCodeAt(1) === 45) {
                // CSS custom properties (--var-name): apply as inline style
                const val = element[prop];
                if (val != null && typeof val !== 'object') {
                    cssStyles[prop] = val;
                    hasStyles = true;
                }
            } else if (prop.charAt(0) === '@' || prop.charAt(0) === ':') {
                // Selector-based CSS: @dark, @media, :hover
                const val = element[prop];
                if (val && typeof val === 'object') {
                    const resolved = {};
                    for(const k in val){
                        let v = val[k];
                        // Evaluate function-valued CSS within selector blocks (e.g. @dark background)
                        if (typeof v === 'function') v = v(element, element.state, element.context);
                        if (v == null || typeof v === 'function') continue;
                        if ((0, $dXl0a.CSS_PROPS_REGISTRY)[k]) {
                            const result = (0, $dXl0a.CSS_PROPS_REGISTRY)[k](v, element, element.state, element.context);
                            if (result) {
                                if (Array.isArray(result)) {
                                    for (const r of result)if (r) Object.assign(resolved, r);
                                } else Object.assign(resolved, result);
                            }
                        } else resolved[k] = v;
                    }
                    if (Object.keys(resolved).length) {
                        // Per-element theme selectors (`@dark`, `@light`, or any custom
                        // scheme `@name`) all compile to a single
                        //   `[data-theme="<scheme>"] &`
                        // rule. The !important marker ensures the themed value wins over
                        // the default (the unconditional property on the same element —
                        // e.g. `background: 'neutral100'`).
                        //
                        // `globalTheme: 'auto'` is handled outside the CSS: `scratch.set`
                        // watches `prefers-color-scheme` and writes `data-theme` on the
                        // scope root to follow OS changes live. That keeps a single CSS
                        // selector pattern — no `@media` duplicates to parse — and lets
                        // custom themes like `@ocean` use the same mechanism.
                        //
                        // We intentionally treat `@dark`/`@light` as theme selectors even
                        // if `designSystem.media.dark` / `.light` is defined — projects
                        // historically mapped them to `[data-theme="…"]` there, and
                        // routing through the media-shortcut branch would emit invalid
                        // `@media [data-theme="…"]` rules.
                        const isThemeSelector = prop.length > 1 && prop.charAt(0) === '@' && !prop.startsWith('@media') && !prop.startsWith('@keyframes') && !prop.startsWith('@supports') && (prop === '@dark' || prop === '@light' || !element.context?.designSystem?.media?.[prop.slice(1)]);
                        if (isThemeSelector) {
                            const important = {};
                            for(const rk in resolved){
                                const rv = resolved[rk];
                                important[rk] = typeof rv === 'string' && !rv.includes('!important') ? rv + ' !important' : rv;
                            }
                            const scheme = prop.slice(1);
                            cssStyles[`[data-theme="${scheme}"] &`] = important;
                        } else {
                            // Resolve design system media shortcuts (@mobileL -> @media (max-width: 768px))
                            let cssProp = prop;
                            if (prop.charAt(0) === '@' && !prop.startsWith('@media') && !prop.startsWith('@keyframes')) {
                                const mediaKey = prop.slice(1);
                                const mediaVal = element.context?.designSystem?.media?.[mediaKey] || element.context?.designSystem?.media?.[mediaKey];
                                if (mediaVal) cssProp = `@media ${mediaVal}`;
                            }
                            // Separate flat CSS props from nested selector objects
                            const flat = {};
                            for(const rk in resolved){
                                const rv = resolved[rk];
                                if (rv && typeof rv === 'object' && !Array.isArray(rv)) {
                                    // Nested selector (e.g. '> hgroup > h6': { color: 'blue' })
                                    // Resolve CSS tokens in nested values
                                    const nestedResolved = {};
                                    for(const nk in rv)if ((0, $dXl0a.CSS_PROPS_REGISTRY)[nk]) {
                                        const nr = (0, $dXl0a.CSS_PROPS_REGISTRY)[nk](rv[nk], element, element.state, element.context);
                                        if (nr) {
                                            if (Array.isArray(nr)) {
                                                for (const r of nr)if (r) Object.assign(nestedResolved, r);
                                            } else Object.assign(nestedResolved, nr);
                                        }
                                    } else nestedResolved[nk] = rv[nk];
                                    // Pseudo-selectors attach directly, combinators need space
                                    const sep = rk.startsWith(':') ? '' : ' ';
                                    // Distribute nested selector across comma-separated parts
                                    if (cssProp.includes(',')) {
                                        const distributed = cssProp.split(',').map((s)=>`${s.trim()}${sep}${rk}`).join(', ');
                                        cssStyles[distributed] = nestedResolved;
                                    } else cssStyles[`${cssProp}${sep}${rk}`] = nestedResolved;
                                } else flat[rk] = rv;
                            }
                            if (Object.keys(flat).length) cssStyles[cssProp] = flat;
                        }
                        hasStyles = true;
                    }
                    hasStyles = true;
                }
            }
        }
        if (hasStyles) {
            // Document already set by the outer push at the top of applyCssInProps
            // Apply display:none !important as inline style (for show/hide to work reliably)
            if (cssStyles.display && String(cssStyles.display).includes('!important')) {
                node.style.setProperty('display', String(cssStyles.display).replace(/\s*!important\s*$/, ''), 'important');
                delete cssStyles.display;
            }
            const className = (0, $bd7kG.css)(cssStyles, null, element.context?.cssPrefix);
            if (className && node.classList) className.split(' ').forEach((c)=>c && node.classList.add(c));
            // Enforce explicit display when it conflicts with generated display from flow/align
            // Also handle hide:true / show:false (which set display:none via CSS_PROPS_REGISTRY)
            const effectiveDisplay = element.display != null && typeof element.display !== 'function' ? element.display : element.hide === true || element.show === false ? 'none' : null;
            if (effectiveDisplay != null) {
                const generatedDisplay = cssStyles.display;
                if (generatedDisplay && generatedDisplay !== effectiveDisplay) {
                    if (effectiveDisplay === 'none') {
                        // For display:none, remove conflicting atomic display classes instead of inline style
                        // (inline style would block conditional show/hide from updating later)
                        const toRemove = [];
                        for (const cls of node.classList)if (cls.startsWith('_d-') && cls !== '_d-none') toRemove.push(cls);
                        for (const cls of toRemove)node.classList.remove(cls);
                        node.classList.add('_d-none');
                    } else // For grid/block/inline, inline style is safe
                    node.style.display = element.display;
                }
            }
        }
    } finally{
        if (ds) (0, $7KiQp.popConfig)();
        $b8a8e0d131ddbeb6$var$__APPLY_CSS_STACK.delete(element);
    }
}
// --- Attrs-in-props ---
// Applies HTML attributes from element properties based on tag
function $b8a8e0d131ddbeb6$var$applyAttrsInProps(element) {
    const { node: node } = element;
    if (!node || !node.setAttribute) return;
    // Apply STATIC nested aria.X / data.X values at mount. Function values
    // are owned by the reactive aria/data effects in registerEffects — those
    // re-run on state changes. Without this loop, aria/data static values
    // declared as nested objects (`aria: { label: 'Search' }`) silently
    // dropped — `applyStaticMixins` already promoted top-level data.X to
    // dataset and the parallel aria branch had no equivalent.
    if (element.aria && typeof element.aria === 'object') for(const ariaKey in element.aria){
        const v = element.aria[ariaKey];
        if (typeof v === 'function' || typeof v === 'object') continue;
        if (v == null || v === false) continue;
        const attrName = 'aria-' + ariaKey.replace(/[A-Z]/g, (m)=>'-' + m.toLowerCase());
        node.setAttribute(attrName, v === true ? '' : v);
    }
    // Apply attribute transforms (src, href, poster, etc. with file/template resolution)
    const transformed = (0, $inO1F.applyAttrTransforms)(element);
    for(const attr in transformed){
        const val = transformed[attr];
        if (val != null && val !== false && typeof val !== 'function' && typeof val !== 'object') node.setAttribute(attr, val === true ? '' : val);
    }
    const tag = element.tag || 'div';
    for(const prop in element){
        if (!Object.prototype.hasOwnProperty.call(element, prop)) continue;
        if (typeof element[prop] === 'function') continue;
        if ((0, $5utcL.REGISTRY).has(prop)) continue;
        if (prop === 'on') continue;
        if (transformed[prop] !== undefined) continue;
        const firstChar = prop.charCodeAt(0);
        if (firstChar >= 65 && firstChar <= 90) continue;
        if ($b8a8e0d131ddbeb6$var$isEventHandler(prop)) continue;
        // Skip CSS properties — already handled by applyCssInProps via CSS.
        // Setting design system tokens (e.g. 'A') as SVG/HTML attributes causes browser errors.
        if ((0, $dXl0a.CSS_PROPS_REGISTRY)[prop] || (0, $cThmB.DEFAULT_CSS_PROPERTIES_LIST) && (0, $cThmB.DEFAULT_CSS_PROPERTIES_LIST).has(prop)) continue;
        // Check if this prop is a valid HTML attribute for this tag.
        // Note: do NOT pre-guard with `HTML_ATTRIBUTES[prop]` — that map is keyed
        // by tag name, not attribute name, so the guard would only ever pass for
        // props whose name happens to also be a tag (e.g. `a`, `div`). The proper
        // check is checkAttributeByTagName, which inspects the tag's attribute list.
        if ((0, $inO1F.checkAttributeByTagName)(tag, prop)) {
            let val = element[prop];
            if (val == null || val === false) continue;
            // Resolve {{ }} template literals
            if (typeof val === 'string' && val.includes('{{')) {
                val = (0, $1zeno.replaceLiteralsWithObjectFields)(val, element, element.state, element.context);
                element[prop] = val;
            }
            if (val == null || val === false || typeof val === 'function' || typeof val === 'object') continue;
            node.setAttribute(prop, val === true ? '' : val);
        }
    }
}
// --- Events ---
// v3 syntax: onXxx handlers directly on the component (no `on: {}` wrapper)
function $b8a8e0d131ddbeb6$var$registerEvents(element, options) {
    for(const key in element){
        if (!Object.prototype.hasOwnProperty.call(element, key)) continue;
        if (!$b8a8e0d131ddbeb6$var$isEventHandler(key)) continue;
        let handler = element[key];
        // String shortcut: onClick: 'fnName' → el.call('fnName', ev).
        // Only valid JS identifiers — arbitrary strings like 'not a function' fall
        // through to the typeof-function check below and are skipped.
        if (typeof handler === 'string' && /^[A-Za-z_$][\w$]*$/.test(handler)) {
            const fnName = handler;
            handler = function stringHandlerShortcut(ev) {
                return element.call(fnName, ev);
            };
        }
        if (typeof handler !== 'function') continue;
        const eventName = $b8a8e0d131ddbeb6$var$eventNameFrom(key);
        if ((0, $5utcL.LIFECYCLE_EVENTS).has(eventName)) continue;
        (0, $5Or4i.registerEvent)($b8a8e0d131ddbeb6$var$toDomEventName(eventName), element, handler);
    }
}
// --- Children ---
// Deep merge childProps with childDef — nested objects are merged, not replaced
function $b8a8e0d131ddbeb6$var$deepMergeChildProps(base, override) {
    const result = {
        ...base
    };
    for(const key in override){
        const bVal = result[key];
        const oVal = override[key];
        if (bVal && oVal && typeof bVal === 'object' && typeof oVal === 'object' && !Array.isArray(bVal) && !Array.isArray(oVal) && typeof bVal !== 'function' && typeof oVal !== 'function') result[key] = $b8a8e0d131ddbeb6$var$deepMergeChildProps(bVal, oVal);
        else result[key] = oVal;
    }
    return result;
}
// Renders resolved children (array, object, or string state ref) into the element's DOM
function $b8a8e0d131ddbeb6$var$renderChildren(element, children, options) {
    if (!children || !element.node) return;
    const childExtends = element.childExtends;
    if (Array.isArray(children)) {
        const doc = element.context?.document || globalThis.document;
        const fragment = doc?.createDocumentFragment();
        if (!fragment) return;
        const childPropsRaw = element.childProps;
        const childrenAs = element.childrenAs;
        for(let i = 0; i < children.length; i++){
            let childDef = children[i];
            const rawChild = childDef;
            if (typeof childDef === 'string' || typeof childDef === 'number') childDef = {
                text: childDef
            };
            // Resolve function-valued childProps per child
            let childProps = childPropsRaw;
            if (typeof childPropsRaw === 'function') try {
                childProps = childPropsRaw(element, childDef);
            } catch (e) {
                childProps = null;
            }
            if (childrenAs === 'state') {
                // For string/number children, create state with both value and text for v3 compat
                let stateVal = rawChild;
                if (typeof rawChild === 'string' || typeof rawChild === 'number') stateVal = {
                    value: rawChild,
                    text: rawChild
                };
                childDef = childProps ? {
                    ...childProps,
                    state: stateVal
                } : {
                    state: stateVal
                };
            } else if (childProps) childDef = $b8a8e0d131ddbeb6$var$deepMergeChildProps(childProps, childDef);
            if (childExtends && !childDef.ignoreChildExtends) {
                if (childDef.extends) {
                    const own = Array.isArray(childDef.extends) ? childDef.extends : [
                        childDef.extends
                    ];
                    const parent = Array.isArray(childExtends) ? childExtends : [
                        childExtends
                    ];
                    childDef = {
                        ...childDef,
                        extends: [
                            ...parent,
                            ...own
                        ]
                    };
                } else childDef = {
                    extends: childExtends,
                    ...childDef
                };
            }
            const childKey = childDef?.key || `${i}`;
            const child = $b8a8e0d131ddbeb6$export$185802fd694ee1f5(childDef, element, childKey, options);
            if (child?.node) fragment.appendChild(child.node);
        }
        element.node.appendChild(fragment);
        return;
    }
    if (typeof children === 'string') {
        const stateVal = $b8a8e0d131ddbeb6$var$resolveStatePath(children, element);
        if (Array.isArray(stateVal)) {
            $b8a8e0d131ddbeb6$var$renderChildren(element, stateVal, options);
            return;
        }
    }
    if (typeof children === 'object') for(const childKey in children){
        if ((0, $5utcL.REGISTRY).has(childKey)) continue;
        let childDef = children[childKey];
        if (childDef == null || childDef === false) continue;
        if (typeof childDef === 'string' || typeof childDef === 'number') childDef = {
            text: childDef
        };
        if (element.childProps) childDef = $b8a8e0d131ddbeb6$var$deepMergeChildProps(element.childProps, childDef);
        if (childExtends && !childDef.ignoreChildExtends) {
            if (childDef.extends) {
                const own = Array.isArray(childDef.extends) ? childDef.extends : [
                    childDef.extends
                ];
                const parent = Array.isArray(childExtends) ? childExtends : [
                    childExtends
                ];
                childDef = {
                    ...childDef,
                    extends: [
                        ...parent,
                        ...own
                    ]
                };
            } else childDef = {
                extends: childExtends,
                ...childDef
            };
        }
        $b8a8e0d131ddbeb6$export$185802fd694ee1f5(childDef, element, childKey, options);
    }
}
function $b8a8e0d131ddbeb6$var$createChildren(element, options) {
    let { children: children, content: content } = element;
    const childExtends = element.childExtends;
    // Resolve function-valued children with reactive tracking
    if (typeof children === 'function') {
        const childrenFn = children;
        children = childrenFn(element, element.state, element.context);
        element.children = children;
        // Reactive effect: keyed reconciliation on update.
        //
        // Previously we wiped every child and rebuilt from scratch whenever
        // the children factory produced a new result. That destroyed any
        // DOM state inside the subtree — most visibly, an `<input>` being
        // typed into would lose focus after every keystroke because its
        // node was detached and replaced.
        //
        // Now we diff the incoming array against `ref.__children`:
        //   • keys still present   → update the child's reactive state in
        //                            place so its subscribers re-render,
        //                            but the DOM node (and its focus /
        //                            selection state) is preserved.
        //   • keys gone            → remove + delete.
        //   • new keys             → create and append.
        //
        // Non-array results and non-`childrenAs: 'state'` children still
        // fall through to the full rebuild path since we can't safely
        // update their internals in place.
        const ref = element.__ref;
        let initialized = false;
        const effect = (0, $hBrLD.createEffect)(()=>{
            const result = childrenFn(element, element.state, element.context);
            if (!initialized) {
                initialized = true;
                return;
            }
            if (result === element.children) return;
            element.children = result;
            // Fast path: keyed reconciliation for array children + childrenAs=state.
            // This is the only case where we can safely update in place, because
            // each child owns a reactive store whose fields we can patch.
            const isArr = Array.isArray(result);
            const canReconcile = isArr && element.childrenAs === 'state';
            if (canReconcile) {
                // Compute the new key order. Key resolution mirrors renderChildren:
                // a `childProps` factory can lift `key` to the top level of the
                // synthesized childDef; otherwise fall back to `rawChild.key`,
                // finally falling back to the positional index.
                const childPropsRaw = element.childProps;
                const newOrder = [];
                const itemByKey = new Map();
                for(let i = 0; i < result.length; i++){
                    const rawChild = result[i];
                    let childProps = childPropsRaw;
                    if (typeof childPropsRaw === 'function') try {
                        childProps = childPropsRaw(element, rawChild);
                    } catch  {
                        childProps = null;
                    }
                    const key = childProps && childProps.key || rawChild && rawChild.key || `${i}`;
                    newOrder.push(key);
                    itemByKey.set(key, {
                        rawChild: rawChild,
                        childProps: childProps
                    });
                }
                const newKeySet = new Set(newOrder);
                // Remove children whose keys are no longer present.
                for(let i = ref.__children.length - 1; i >= 0; i--){
                    const k = ref.__children[i];
                    if (!newKeySet.has(k)) {
                        const child = element[k];
                        if (child?.remove) child.remove();
                        delete element[k];
                        ref.__children.splice(i, 1);
                    }
                }
                // Upsert children in order. Existing keys reuse their node and
                // patch their state; new keys are created and appended.
                const childExtends = element.childExtends;
                const doc = element.context?.document || globalThis.document;
                const fragment = doc?.createDocumentFragment();
                for (const key of newOrder){
                    const entry = itemByKey.get(key);
                    const rawChild = entry.rawChild;
                    const existing = element[key];
                    if (existing && existing.state) {
                        // Patch the existing store with the new item's fields via
                        // `state.replace(obj)` — unlike `update` (which only merges
                        // new keys) `replace` also REMOVES any prior keys that
                        // aren't on the new object. Critical for list reconcilers:
                        // without replace semantics, a row that went from parent
                        // summary → sub-row would inherit the old `_isParent: true`
                        // flag and render both roles simultaneously.
                        //
                        // Signals fire for added / changed / removed keys, so the
                        // child's `text` / `hide` / `style` gates re-evaluate and
                        // the DOM node (+ any focused input inside) stays untouched.
                        if (rawChild && typeof rawChild === 'object') {
                            const st = existing.state;
                            if (typeof st.replace === 'function') st.replace(rawChild);
                            else if (typeof st.update === 'function') {
                                // Fallback for stores without replace(): emulate it by
                                // nulling keys not in the new object, then update().
                                for(const k2 in st){
                                    if (k2 === '__element' || k2 === 'root' || k2 === 'parent' || k2 === 'update') continue;
                                    if (!Object.prototype.hasOwnProperty.call(rawChild, k2)) try {
                                        st[k2] = undefined;
                                    } catch  {}
                                }
                                st.update(rawChild);
                            } else for(const k2 in rawChild)st[k2] = rawChild[k2];
                        }
                        continue;
                    }
                    // New child — build the childDef the same way renderChildren does,
                    // then create + append.
                    let stateVal = rawChild;
                    if (typeof rawChild === 'string' || typeof rawChild === 'number') stateVal = {
                        value: rawChild,
                        text: rawChild
                    };
                    const childProps = entry.childProps;
                    let childDef = childProps ? {
                        ...childProps,
                        state: stateVal
                    } : {
                        state: stateVal
                    };
                    if (childExtends && !childDef.ignoreChildExtends) {
                        if (childDef.extends) {
                            const own = Array.isArray(childDef.extends) ? childDef.extends : [
                                childDef.extends
                            ];
                            const parent = Array.isArray(childExtends) ? childExtends : [
                                childExtends
                            ];
                            childDef = {
                                ...childDef,
                                extends: [
                                    ...parent,
                                    ...own
                                ]
                            };
                        } else childDef = {
                            extends: childExtends,
                            ...childDef
                        };
                    }
                    const child = $b8a8e0d131ddbeb6$export$185802fd694ee1f5(childDef, element, key, options);
                    if (child?.node && fragment) fragment.appendChild(child.node);
                }
                if (fragment && fragment.childNodes.length && element.node) element.node.appendChild(fragment);
                // Keep __children in the new order for stable future reconciliations.
                ref.__children = newOrder;
                return;
            }
            // Fallback: full rebuild (non-array results, or childrenAs not set).
            for (const key of [
                ...ref.__children
            ]){
                const child = element[key];
                if (child?.remove) child.remove();
                delete element[key];
            }
            ref.__children = [];
            $b8a8e0d131ddbeb6$var$renderChildren(element, result, options);
        }, {
            depth: ref.path.length
        });
        ref.__effects.push(effect);
    }
    $b8a8e0d131ddbeb6$var$renderChildren(element, children || content, options);
    if (children || content) return;
    // Iterate element properties for child components (Uppercase keys)
    const components = element.context?.components || {};
    // v3 compat: resolve XxxExtends shorthand
    // Pattern: StarIconExtends: 'Icon', name: 'star', fontSize: 'X2'
    // Becomes: StarIcon: { extends: 'Icon', name: 'star', fontSize: 'X2' }
    {
        const keys = Object.keys(element);
        for(let i = 0; i < keys.length; i++){
            const prop = keys[i];
            if (!prop.endsWith('Extends') || typeof element[prop] !== 'string') continue;
            const childName = prop.slice(0, -7);
            if (!childName || childName.charCodeAt(0) < 65 || childName.charCodeAt(0) > 90) continue;
            const childDef = {
                extends: element[prop]
            };
            delete element[prop];
            // Collect subsequent lowercase properties until next Uppercase key or end
            for(let j = i + 1; j < keys.length; j++){
                const nextKey = keys[j];
                const fc = nextKey.charCodeAt(0);
                if (fc >= 65 && fc <= 90) break; // Stop at next child/component key
                if ((0, $5utcL.REGISTRY).has(nextKey)) break; // Stop at framework keys
                if (typeof element[nextKey] === 'function' && (nextKey.startsWith('on') || nextKey.startsWith('.'))) break;
                const val = element[nextKey];
                if (val !== undefined) {
                    childDef[nextKey] = val;
                    delete element[nextKey];
                }
            }
            // Merge with existing child def if present
            if (element[childName] && typeof element[childName] === 'object') element[childName] = {
                ...childDef,
                ...element[childName]
            };
            else element[childName] = childDef;
        }
    }
    for(const prop in element){
        if (!Object.prototype.hasOwnProperty.call(element, prop)) continue;
        if ((0, $5utcL.REGISTRY).has(prop)) continue;
        if (typeof element[prop] !== 'object' || element[prop] === null) continue;
        const firstChar = prop.charCodeAt(0);
        if (firstChar < 65 || firstChar > 90) continue;
        let childDef = element[prop];
        if (childDef.__ref) continue; // Already created
        // Auto-extend from context component if key matches and no extends set
        if (!childDef.extends && !childDef.extend) {
            const comp = components[prop] || components[`smbls.${prop}`];
            if (comp) childDef = {
                extends: comp,
                ...childDef
            };
        }
        // Apply childProps (e.g. fontSize, padding from parent's childProps)
        if (element.childProps) childDef = {
            ...element.childProps,
            ...childDef
        };
        if (childExtends && !childDef.ignoreChildExtends) {
            if (childDef.extends) {
                const own = Array.isArray(childDef.extends) ? childDef.extends : [
                    childDef.extends
                ];
                const parent = Array.isArray(childExtends) ? childExtends : [
                    childExtends
                ];
                childDef = {
                    ...childDef,
                    extends: [
                        ...parent,
                        ...own
                    ]
                };
            } else childDef = {
                extends: childExtends,
                ...childDef
            };
        }
        $b8a8e0d131ddbeb6$export$185802fd694ee1f5(childDef, element, prop, options);
    }
}
// --- DOM Assignment ---
function $b8a8e0d131ddbeb6$var$assignNode(element, parent, attachOptions) {
    const { node: node } = element;
    if (!node) return;
    node.ref = element;
    // Support both DOMQL elements (.node) and raw DOM nodes (root case)
    const parentNode = parent?.node || (parent?.nodeType ? parent : null);
    if (!parentNode) return;
    if (attachOptions?.position === 'before' && attachOptions.node) parentNode.insertBefore(node, attachOptions.node);
    else if (attachOptions?.position === 'after' && attachOptions.node) {
        const nextSib = attachOptions.node.nextSibling;
        if (nextSib) parentNode.insertBefore(node, nextSib);
        else parentNode.appendChild(node);
    } else parentNode.appendChild(node);
}
function $b8a8e0d131ddbeb6$var$triggerLifecycle(eventSuffix, element, options) {
    const hookName = eventSuffix.charAt(0).toLowerCase() + eventSuffix.slice(1);
    if (element.context?.plugins?.length) (0, $aQqva.runPluginHook)(hookName, element, options);
    const key = 'on' + eventSuffix;
    const handler = element[key];
    if (typeof handler === 'function') {
        // Scope config to this element's context so lifecycle handlers that
        // inject CSS or resolve tokens use the right app. The document is
        // stored on the config, so getActiveDocument() resolves it too.
        const ds = element.context?.designSystem;
        if (ds) (0, $7KiQp.pushConfig)(ds);
        try {
            const result = handler(element, element.state, element.context, options);
            if (result === false) return false;
        } catch (err) {
            // Route the error through the plugin error hook so observers
            // (e.g. the analyze plugin) see it with full element context.
            // Falls back to console.error when no plugin captures it.
            const handled = element.context?.plugins?.length && (0, $aQqva.runPluginHook)('error', element, {
                hook: key,
                error: err
            });
            if (!handled) console.error(`[DOMQL] Lifecycle "${key}" error:`, err);
            if (element.context?.strictMode) throw err;
        } finally{
            if (ds) (0, $7KiQp.popConfig)();
        }
    }
    return true;
}
var $b8a8e0d131ddbeb6$export$2e2bcd8739ae039 = $b8a8e0d131ddbeb6$export$185802fd694ee1f5;

});
parcelRegister("hlMjd", function(module, exports) {

$parcel$export(module.exports, "SVG_TAGS", () => $ca19def97274dd80$export$23d5ae6d2560d158);
$parcel$export(module.exports, "isValidTag", () => $ca19def97274dd80$export$77ee750ed81149c6);
$parcel$export(module.exports, "isSvgTag", () => $ca19def97274dd80$export$ac48d93d50510706);
$parcel$export(module.exports, "detectTag", () => $ca19def97274dd80$export$5075bd4eae016d2c);
$parcel$export(module.exports, "createHTMLNode", () => $ca19def97274dd80$export$39fdcd81e0c5d80b);
$parcel$export(module.exports, "cacheNode", () => $ca19def97274dd80$export$257247f9c0329159);
'use strict';
// Node caching - cloneNode from cached prototypes instead of createElement
// This is already a v3 optimization that works well -- preserved in v3.14
const $ca19def97274dd80$export$276d1de0bc02ff5b = 'http://www.w3.org/2000/svg';
const $ca19def97274dd80$export$23d5ae6d2560d158 = new Set([
    'svg',
    'path',
    'circle',
    'ellipse',
    'line',
    'polyline',
    'polygon',
    'rect',
    'g',
    'defs',
    'use',
    'symbol',
    'clipPath',
    'mask',
    'pattern',
    'image',
    'text',
    'tspan',
    'textPath',
    'marker',
    'linearGradient',
    'radialGradient',
    'stop',
    'filter',
    'feBlend',
    'feColorMatrix',
    'feComponentTransfer',
    'feComposite',
    'feConvolveMatrix',
    'feDiffuseLighting',
    'feDisplacementMap',
    'feFlood',
    'feGaussianBlur',
    'feImage',
    'feMerge',
    'feMergeNode',
    'feMorphology',
    'feOffset',
    'feSpecularLighting',
    'feTile',
    'feTurbulence',
    'animate',
    'animateMotion',
    'animateTransform',
    'set',
    'foreignObject',
    'desc',
    'title',
    'metadata'
]);
const $ca19def97274dd80$var$VALID_HTML_TAGS = new Set([
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'menu',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'search',
    'section',
    'select',
    'slot',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'template',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    // special
    'string',
    'fragment',
    'shadow'
]);
function $ca19def97274dd80$export$77ee750ed81149c6(tag) {
    return $ca19def97274dd80$var$VALID_HTML_TAGS.has(tag) || $ca19def97274dd80$export$23d5ae6d2560d158.has(tag);
}
function $ca19def97274dd80$export$ac48d93d50510706(tag) {
    return $ca19def97274dd80$export$23d5ae6d2560d158.has(tag);
}
function $ca19def97274dd80$export$5075bd4eae016d2c(element) {
    let { tag: tag, key: key } = element;
    if (typeof tag === 'function') tag = tag(element);
    if (tag === true) tag = key;
    if (typeof tag === 'string' && $ca19def97274dd80$export$77ee750ed81149c6(tag)) return tag;
    if (!key || typeof key !== 'string') return 'div';
    // Tags that should never be auto-detected from key names
    const STRUCTURAL_TAGS = new Set([
        'html',
        'head',
        'body',
        'meta',
        'link',
        'script',
        'style',
        'title',
        'base',
        'noscript',
        'template'
    ]);
    // Try key as tag
    let keyAsTag = key.toLowerCase();
    if (keyAsTag.includes('.')) keyAsTag = keyAsTag.split('.')[0];
    if (keyAsTag.includes('_')) keyAsTag = keyAsTag.split('_')[0];
    if ($ca19def97274dd80$export$77ee750ed81149c6(keyAsTag) && !STRUCTURAL_TAGS.has(keyAsTag)) return keyAsTag;
    return 'div';
}
const $ca19def97274dd80$var$nodeCaches = {};
function $ca19def97274dd80$export$39fdcd81e0c5d80b(tag, element) {
    const doc = element?.context?.document || globalThis.document;
    if (!doc) return null;
    if (tag === 'string') return doc.createTextNode(element?.text || '');
    if (tag === 'fragment') return doc.createDocumentFragment();
    if ($ca19def97274dd80$export$ac48d93d50510706(tag)) {
        const parent = element?.parent;
        const inSvgContext = tag === 'svg' || parent?.node?.namespaceURI === $ca19def97274dd80$export$276d1de0bc02ff5b;
        if (inSvgContext) return doc.createElementNS($ca19def97274dd80$export$276d1de0bc02ff5b, tag);
        // SVG child tags outside <svg> context — fall back to div
        if (tag !== 'svg') return doc.createElement('div');
    }
    return doc.createElement(tag);
}
function $ca19def97274dd80$export$257247f9c0329159(element) {
    const tag = element.tag = $ca19def97274dd80$export$5075bd4eae016d2c(element);
    const isSvgContext = $ca19def97274dd80$export$ac48d93d50510706(tag) && (tag === 'svg' || element.parent?.node?.namespaceURI === $ca19def97274dd80$export$276d1de0bc02ff5b);
    const cacheKey = isSvgContext ? 'svg:' + tag : tag;
    const targetDoc = element?.context?.document || globalThis.document;
    let cached = $ca19def97274dd80$var$nodeCaches[cacheKey];
    if (!cached) cached = $ca19def97274dd80$var$nodeCaches[cacheKey] = $ca19def97274dd80$export$39fdcd81e0c5d80b(tag, element);
    if (!cached) return null;
    // If target document differs from cached node's document (e.g. iframe),
    // create a fresh node instead of cloning to ensure correct ownerDocument
    const cloned = targetDoc && cached.ownerDocument !== targetDoc ? $ca19def97274dd80$export$39fdcd81e0c5d80b(tag, element) : cached.cloneNode(true);
    if (tag === 'string') cloned.nodeValue = element.text || '';
    return cloned;
}

});

parcelRegister("5utcL", function(module, exports) {

$parcel$export(module.exports, "REGISTRY", () => $3ff66892235bfa9e$export$21cc2ed387caee94);
$parcel$export(module.exports, "MIXINS", () => $3ff66892235bfa9e$export$4548702dd438fdb5);
$parcel$export(module.exports, "LIFECYCLE_EVENTS", () => $3ff66892235bfa9e$export$1b96fccf01613a9);
$parcel$export(module.exports, "PASSIVE_EVENTS", () => $3ff66892235bfa9e$export$e58a6cc0822ad4ca);
$parcel$export(module.exports, "DELEGATED_EVENTS", () => $3ff66892235bfa9e$export$2edd40343a7ba9df);
'use strict';
const $3ff66892235bfa9e$export$21cc2ed387caee94 = new Set([
    // Extends/Inheritance
    'extends',
    // Children/Content
    'children',
    'content',
    'childExtends',
    'childExtendsRecursive',
    'childProps',
    'inheritParentProps',
    // State
    'state',
    'if',
    // Define
    'define',
    'deps',
    // DOM
    'tag',
    'attr',
    'style',
    'text',
    'html',
    'value',
    'data',
    'classlist',
    'class',
    // Scope/Context
    'scope',
    'root',
    'context',
    // Routing/Fetching
    '$router',
    'routes',
    'fetch',
    // Meta
    'variables',
    'query',
    'key',
    'component',
    'preventContentUpdate',
    'preventContentRecreate',
    // Internal
    '__name',
    '__ref',
    '__hash',
    '__text',
    'parent',
    'node'
]);
const $3ff66892235bfa9e$export$4548702dd438fdb5 = {
    text: 'text',
    html: 'html',
    style: 'style',
    attr: 'attr',
    data: 'data',
    classlist: 'classlist',
    state: 'state',
    scope: 'scope'
};
const $3ff66892235bfa9e$export$1b96fccf01613a9 = new Set([
    'start',
    'init',
    'complete',
    'attachNode',
    'stateInit',
    'stateCreated',
    'beforeUpdate',
    'update',
    'afterUpdate',
    'beforeClassAssign',
    'lazyLoad',
    'render',
    'renderRouter',
    'done',
    'create',
    'frame',
    'startUpdate',
    'stateUpdate',
    'beforeStateUpdate',
    'initInspect',
    'initSync',
    'error',
    'beforeRemove',
    'remove'
]);
const $3ff66892235bfa9e$export$e58a6cc0822ad4ca = new Set([
    'wheel',
    'mousewheel',
    'touchstart',
    'touchmove',
    'touchend',
    'touchcancel'
]);
const $3ff66892235bfa9e$export$2edd40343a7ba9df = new Set([
    'click',
    'dblclick',
    'mousedown',
    'mouseup',
    'mousemove',
    'mouseenter',
    'mouseleave',
    'mouseover',
    'mouseout',
    'pointerdown',
    'pointerup',
    'pointermove',
    'pointerenter',
    'pointerleave',
    'pointerover',
    'pointerout',
    'touchstart',
    'touchend',
    'touchmove',
    'keydown',
    'keyup',
    'keypress',
    'input',
    'change',
    'submit',
    'reset',
    'focus',
    'blur',
    'focusin',
    'focusout',
    'scroll',
    'wheel',
    'contextmenu',
    'drag',
    'dragstart',
    'dragend',
    'dragenter',
    'dragleave',
    'dragover',
    'drop'
]);

});

parcelRegister("5Or4i", function(module, exports) {

$parcel$export(module.exports, "addDelegatedEvent", () => $43b69e78dabda646$export$da585c536ffe97a0);
$parcel$export(module.exports, "removeDelegatedEvent", () => $43b69e78dabda646$export$a6391ca54aead708);
$parcel$export(module.exports, "registerEvent", () => $43b69e78dabda646$export$bd50bc4cd3c601ee);

var $5utcL = parcelRequire("5utcL");
parcelRequire("aTPvW");
var $7KiQp = parcelRequire("7KiQp");
'use strict';
const $43b69e78dabda646$var$delegateRoots = new WeakMap();
// Reused listener-option objects — browsers treat `{ passive: true }` as
// read-only metadata, so a single shared instance per shape is safe and
// avoids a per-listener allocation.
const $43b69e78dabda646$var$PASSIVE_BUBBLE = {
    passive: true
};
const $43b69e78dabda646$var$PASSIVE_CAPTURE = {
    passive: true,
    capture: true
};
const $43b69e78dabda646$var$listenerOptions = (eventName, useCapture)=>{
    if ((0, $5utcL.PASSIVE_EVENTS).has(eventName)) return useCapture ? $43b69e78dabda646$var$PASSIVE_CAPTURE : $43b69e78dabda646$var$PASSIVE_BUBBLE;
    return useCapture || false;
};
function $43b69e78dabda646$var$getDelegateRoot(rootNode) {
    let root = $43b69e78dabda646$var$delegateRoots.get(rootNode);
    if (!root) {
        root = {
            handlers: new Map(),
            installed: new Set()
        };
        $43b69e78dabda646$var$delegateRoots.set(rootNode, root);
    }
    return root;
}
function $43b69e78dabda646$var$installDelegatedEvent(eventName, rootNode) {
    const root = $43b69e78dabda646$var$getDelegateRoot(rootNode);
    if (root.installed.has(eventName)) return;
    root.installed.add(eventName);
    // Use capture for non-bubbling events (focus/blur, mouseenter/mouseleave)
    const useCapture = eventName === 'focus' || eventName === 'blur' || eventName === 'focusin' || eventName === 'focusout' || eventName === 'mouseenter' || eventName === 'mouseleave';
    const isEnterLeave = eventName === 'mouseenter' || eventName === 'mouseleave';
    rootNode.addEventListener(eventName, (event)=>{
        let target = event.target;
        while(target && target !== rootNode){
            const handlerMap = root.handlers.get(eventName);
            if (handlerMap) {
                const handler = handlerMap.get(target);
                if (handler) {
                    // For mouseenter/mouseleave: only fire if relatedTarget is outside this node
                    // (prevents firing when moving between children inside the element)
                    if (isEnterLeave && event.relatedTarget && target.contains(event.relatedTarget)) {
                        target = target.parentNode;
                        continue;
                    }
                    handler(event);
                    if (event.cancelBubble) return;
                }
            }
            target = target.parentNode;
        }
    }, $43b69e78dabda646$var$listenerOptions(eventName, useCapture));
}
function $43b69e78dabda646$export$da585c536ffe97a0(eventName, node, handler, rootNode) {
    if (!rootNode) rootNode = node.ownerDocument?.documentElement || node.getRootNode();
    const root = $43b69e78dabda646$var$getDelegateRoot(rootNode);
    // Ensure the root listener is installed
    $43b69e78dabda646$var$installDelegatedEvent(eventName, rootNode);
    // Get or create the handler map for this event
    if (!root.handlers.has(eventName)) root.handlers.set(eventName, new WeakMap());
    root.handlers.get(eventName).set(node, handler);
}
function $43b69e78dabda646$export$a6391ca54aead708(eventName, node, rootNode) {
    if (!rootNode) rootNode = node.ownerDocument?.documentElement || node.getRootNode();
    const root = $43b69e78dabda646$var$delegateRoots.get(rootNode);
    if (!root) return;
    const handlerMap = root.handlers.get(eventName);
    if (handlerMap) handlerMap.delete(node);
}
function $43b69e78dabda646$export$2144169e939890ff(eventName) {
    return (0, $5utcL.DELEGATED_EVENTS).has(eventName) && !(0, $5utcL.LIFECYCLE_EVENTS).has(eventName);
}
function $43b69e78dabda646$export$bd50bc4cd3c601ee(eventName, element, handler) {
    const { node: node, context: context } = element;
    if (!node) return;
    // Capture config reference at registration time so it remains
    // stable across async boundaries. The document is stored on the
    // config, so getActiveDocument() resolves it via the config stack.
    const ds = context?.designSystem;
    const wrappedHandler = (event)=>{
        // Push the element's design system config so runtime CSS injections
        // and token resolution use the correct app scope. The document is
        // stored on the config, so getActiveDocument() resolves it too.
        if (ds) (0, $7KiQp.pushConfig)(ds);
        try {
            const result = handler.call(element, event, element, element.state, context);
            if (result && typeof result.then === 'function') {
                // For async handlers, re-scope config around the promise
                // resolution so continuations see the right config.
                result.catch((err)=>{
                    element.error = err;
                    console.error('[DOMQL] Async event error:', err);
                }).finally(()=>{
                    if (ds) (0, $7KiQp.popConfig)();
                });
                // Don't pop in the outer finally — the promise chain owns it
                return;
            }
        } catch (err) {
            element.error = err;
            console.error('[DOMQL] Event error:', err);
            if (context?.strictMode) throw err;
        }
        // Sync path — pop immediately
        if (ds) (0, $7KiQp.popConfig)();
    };
    if ($43b69e78dabda646$export$2144169e939890ff(eventName)) {
        // Find root node for delegation
        const rootNode = context?.rootNode || node.ownerDocument?.documentElement;
        $43b69e78dabda646$export$da585c536ffe97a0(eventName, node, wrappedHandler, rootNode);
    } else // Non-delegatable events (e.g., transitionend, animationend, resize)
    node.addEventListener(eventName, wrappedHandler, $43b69e78dabda646$var$listenerOptions(eventName, false));
    // Track for cleanup
    if (!element.__ref.__eventCleanup) element.__ref.__eventCleanup = [];
    element.__ref.__eventCleanup.push(()=>{
        if ($43b69e78dabda646$export$2144169e939890ff(eventName)) {
            const rootNode = context?.rootNode || node.ownerDocument?.documentElement;
            $43b69e78dabda646$export$a6391ca54aead708(eventName, node, rootNode);
        } else node.removeEventListener(eventName, wrappedHandler, $43b69e78dabda646$var$listenerOptions(eventName, false));
    });
}

});

parcelRegister("3QQ54", function(module, exports) {

$parcel$export(module.exports, "applyExtends", () => $2cdea0916d325145$export$1ac92e2b1d1a0b6d);
'use strict';
// Extends resolution - merges component inheritance chains
// Uses structural sharing where possible (no deepClone)
const $2cdea0916d325145$var$extendsCache = new WeakMap();
function $2cdea0916d325145$export$1ac92e2b1d1a0b6d(element, definition, options) {
    let ext = definition.extends || definition.extend;
    if (!ext) return;
    const context = element.context || options?.context || {};
    const components = context.components || {};
    // Normalize to array
    if (!Array.isArray(ext)) ext = [
        ext
    ];
    // Resolve extends chain
    for(let i = 0; i < ext.length; i++){
        const base = $2cdea0916d325145$var$resolveExtend(ext[i], components);
        // Skip self-references (component extends itself by same name)
        if (base && base !== definition) $2cdea0916d325145$var$mergeBase(element, base, options, new Set([
            definition
        ]));
    }
}
function $2cdea0916d325145$var$resolveExtend(ext, components) {
    if (typeof ext === 'string') {
        // Support nested child access: 'Component > Child > SubChild'
        if (ext.includes('>')) {
            const parts = ext.split('>').map((s)=>s.trim());
            let resolved = components[parts[0]] || components[`smbls.${parts[0]}`];
            for(let i = 1; i < parts.length && resolved; i++)resolved = resolved[parts[i]];
            return resolved || null;
        }
        return components[ext] || components[`smbls.${ext}`] || null;
    }
    if (typeof ext === 'object' && ext !== null) return ext;
    return null;
}
function $2cdea0916d325145$var$mergeBase(element, base, options, visited = new Set()) {
    if (visited.has(base)) return;
    visited.add(base);
    // Recursively resolve base's own extends first (support both 'extends' and 'extend')
    const baseExtends = base.extends || base.extend;
    if (baseExtends) {
        const context = element.context || options?.context || {};
        const components = context.components || {};
        let baseExt = baseExtends;
        if (!Array.isArray(baseExt)) baseExt = [
            baseExt
        ];
        for(let i = 0; i < baseExt.length; i++){
            const ancestor = $2cdea0916d325145$var$resolveExtend(baseExt[i], components);
            if (ancestor) $2cdea0916d325145$var$mergeBase(element, ancestor, options, visited);
        }
    }
    // Merge properties from base onto element (later extends override earlier)
    for(const key in base){
        if (key === 'extends' || key === 'extend') continue;
        const val = base[key];
        if (element[key] === undefined) {
            if (val && typeof val === 'object' && !Array.isArray(val) && typeof val !== 'function') element[key] = {
                ...val
            };
            else element[key] = val;
        } else if (typeof element[key] === 'object' && typeof val === 'object' && !Array.isArray(element[key]) && !Array.isArray(val) && element[key] !== null && val !== null) // Deep merge objects — element (child) values override base values
        // element[key] is already set from a previous extends; val is the newer/more-specific definition
        // The newer definition (val) should override the older ancestor (element[key])
        element[key] = $2cdea0916d325145$var$deepMergeChild(element[key], val);
        else // Later extends override earlier for primitives/functions
        element[key] = val;
    }
}
// Deep merge where override wins over base at every level
function $2cdea0916d325145$var$deepMergeChild(base, override) {
    const result = {
        ...base
    };
    for(const key in override){
        const baseVal = result[key];
        const overVal = override[key];
        if (baseVal && overVal && typeof baseVal === 'object' && typeof overVal === 'object' && !Array.isArray(baseVal) && !Array.isArray(overVal) && typeof baseVal !== 'function' && typeof overVal !== 'function') result[key] = $2cdea0916d325145$var$deepMergeChild(baseVal, overVal);
        else result[key] = overVal;
    }
    return result;
}

});

parcelRegister("1P3uZ", function(module, exports) {

$parcel$export(module.exports, "addMethods", () => $153d44aafd030948$export$626ce79af72fc3d3);

var $exslg = parcelRequire("exslg");

var $gXM9X = parcelRequire("gXM9X");


var $c5dHw = parcelRequire("c5dHw");
'use strict';
// Forward warnings + errors to the analyze plugin (when present) so they
// appear in the audit log alongside lifecycle events. Falls through to the
// original env-gated console.warn / throw.
function $153d44aafd030948$var$emitToAnalyze(element, level, params) {
    const a = element?.context?.analyze;
    if (!a || !a.emit) return;
    if (level === 'warn' && !a.shouldCapture('warnings')) return;
    if (level === 'error' && !a.shouldCapture('errors')) return;
    const msg = params.map((p)=>p?.message || (typeof p === 'string' ? p : null)).filter(Boolean).join(' ');
    a.emit({
        id: `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 6)}`,
        ts: Date.now(),
        type: level === 'error' ? 'error' : 'warning',
        level: level,
        hook: level === 'error' ? 'el.error' : 'el.warn',
        element: {
            key: element.key != null ? String(element.key) : null,
            name: element.__name || null,
            tag: element.tag || null
        },
        message: msg || null,
        args: params
    });
}
function $153d44aafd030948$var$elWarn(...params) {
    $153d44aafd030948$var$emitToAnalyze(this, 'warn', params);
    return (0, $c5dHw.warn).apply(this, params);
}
function $153d44aafd030948$var$elError(...params) {
    $153d44aafd030948$var$emitToAnalyze(this, 'error', params);
    return (0, $c5dHw.error).apply(this, params);
}
// Shared prototype for all elements — methods are defined once, shared by all instances
const $153d44aafd030948$export$474e10c2e087cf28 = {
    update: $exslg.update,
    remove: $gXM9X.remove,
    getDB: $c5dHw.getDB,
    getQuery: $c5dHw.getQuery,
    getRootData: $c5dHw.getRootData,
    getChildren: $c5dHw.getChildren,
    getPath: $c5dHw.getPath,
    nextElement: $c5dHw.nextElement,
    previousElement: $c5dHw.previousElement,
    verbose: (0, $c5dHw.verbose),
    warn: $153d44aafd030948$var$elWarn,
    error: $153d44aafd030948$var$elError,
    variables: (0, $c5dHw.variables),
    spotByPath: $c5dHw.spotByPath,
    set (content, options) {
        this.removeContent();
        if (content != null) {
            const createFn = this.context?.__create;
            if (createFn) createFn(content, this, 'content', options);
        }
    },
    reset (options) {
        const createFn = this.context?.__create;
        if (!createFn) return this;
        const parent = this.parent;
        const key = this.key;
        const def = this.parse();
        this.remove();
        return createFn(def, parent, key, options);
    },
    lookup (predicate) {
        let current = this.parent;
        while(current){
            if (typeof predicate === 'function') {
                if (predicate(current)) return current;
            } else if (typeof predicate === 'string') {
                if (current.key === predicate) return current;
                if (current[predicate] && current[predicate].__ref) return current[predicate];
            }
            current = current.parent;
        }
        return null;
    },
    lookdown (predicate) {
        const ref = this.__ref;
        if (!ref?.__children) return null;
        for (const key of ref.__children){
            const child = this[key];
            if (!child) continue;
            if (typeof predicate === 'function') {
                if (predicate(child)) return child;
            } else if (typeof predicate === 'string') {
                if (child.key === predicate) return child;
            }
            const found = child.lookdown?.(predicate);
            if (found) return found;
        }
        return null;
    },
    lookdownAll (predicate, results = []) {
        const ref = this.__ref;
        if (!ref?.__children) return results;
        for (const key of ref.__children){
            const child = this[key];
            if (!child) continue;
            if (typeof predicate === 'function') {
                if (predicate(child)) results.push(child);
            } else if (typeof predicate === 'string') {
                if (child.key === predicate) results.push(child);
            }
            child.lookdownAll?.(predicate, results);
        }
        return results;
    },
    getRef () {
        return this.__ref;
    },
    getRoot: (0, $c5dHw.getRoot),
    getRootState: (0, $c5dHw.getRootState),
    getRootContext: (0, $c5dHw.getRootContext),
    getContext: (0, $c5dHw.getContext),
    parse (exclude) {
        const result = {};
        const excludeSet = exclude ? new Set(exclude) : null;
        for(const key in this){
            if (key === 'parent' || key === 'node' || key === '__ref') continue;
            if (typeof this[key] === 'function') continue;
            if (excludeSet?.has(key)) continue;
            result[key] = this[key];
        }
        return result;
    },
    parseDeep (exclude) {
        const result = this.parse(exclude);
        const ref = this.__ref;
        if (ref?.__children) {
            for (const key of ref.__children)if (this[key]?.parseDeep) result[key] = this[key].parseDeep(exclude);
        }
        return result;
    },
    keys () {
        return Object.keys(this);
    },
    log (...keys) {
        if (keys.length) {
            const data = {};
            for (const k of keys)data[k] = this[k];
            console.log(data);
        } else console.log(this);
    },
    setProps (props, options) {
        return this.update(props, options);
    },
    setNodeStyles (styles) {
        if (!this.node?.style) return;
        for(const prop in styles){
            const val = styles[prop];
            if (val == null) continue;
            const cssProp = prop.replace(/[A-Z]/g, (m)=>'-' + m.toLowerCase());
            const str = String(val).replace(/\s*!important\s*$/, '');
            this.node.style.setProperty(cssProp, str, 'important');
        }
    },
    call (methodName, ...args) {
        const ctx = this.context;
        const method = ctx?.methods?.[methodName] || ctx?.functions?.[methodName] || ctx?.utils?.[methodName] || this[methodName];
        if (typeof method === 'function') return method.call(this, ...args);
    },
    removeContent () {
        const ref = this.__ref;
        if (!ref?.__children) return;
        const contentChild = this.content;
        if (contentChild?.remove) {
            contentChild.remove();
            delete this.content;
            const idx = ref.__children.indexOf('content');
            if (idx !== -1) ref.__children.splice(idx, 1);
        }
        if (contentChild?.node?.parentNode) contentChild.node.parentNode.removeChild(contentChild.node);
    }
};
// Cache per-context prototypes so we don't recreate them for every element
const $153d44aafd030948$var$contextProtoCache = new WeakMap();
function $153d44aafd030948$var$getContextProto(ctx) {
    if (!ctx) return $153d44aafd030948$export$474e10c2e087cf28;
    let proto = $153d44aafd030948$var$contextProtoCache.get(ctx);
    if (proto) return proto;
    // Create a context-specific prototype that chains from elementProto
    proto = Object.create($153d44aafd030948$export$474e10c2e087cf28);
    const methods = ctx.methods;
    if (methods) for(const k in methods)// Functions become prototype methods; non-function values (e.g. an SDK
    // instance) are exposed as shared properties so `el.sdk.x` keeps working.
    proto[k] = methods[k];
    $153d44aafd030948$var$contextProtoCache.set(ctx, proto);
    return proto;
}
function $153d44aafd030948$export$626ce79af72fc3d3(element) {
    const proto = $153d44aafd030948$var$getContextProto(element.context);
    Object.setPrototypeOf(element, proto);
}

});
parcelRegister("exslg", function(module, exports) {

$parcel$export(module.exports, "update", () => $a95a21e77c77d2c0$export$722fbec263ad908a);
parcelRequire("flu9Q");
var $hBrLD = parcelRequire("hBrLD");
var $lQ86u = parcelRequire("lQ86u");

var $5utcL = parcelRequire("5utcL");

var $fQWe4 = parcelRequire("fQWe4");

var $aQqva = parcelRequire("aQqva");
'use strict';
function $a95a21e77c77d2c0$export$722fbec263ad908a(params = {}, opts = {}) {
    const element = this;
    const ref = element.__ref;
    if (!ref) return;
    // Normalize string/number shorthand
    if (typeof params === 'string' || typeof params === 'number') params = {
        text: params
    };
    // Fire onBeforeUpdate (v3 syntax — directly on element)
    if (!opts.preventListeners && typeof element.onBeforeUpdate === 'function') {
        const result = element.onBeforeUpdate(element, element.state, element.context, opts);
        if (result === false) return element;
    }
    (0, $hBrLD.batch)(()=>{
        // Update state if provided
        if (params.state && (0, $lQ86u.isStore)(element.state)) element.state.update(params.state);
        // Update text
        if (params.text !== undefined) {
            element.text = params.text;
            if (!ref.__exec.text && element.node) {
                if (element.tag === 'string') element.node.nodeValue = params.text ?? '';
                else element.node.textContent = params.text ?? '';
            }
        }
        // Update html
        if (params.html !== undefined) {
            element.html = params.html;
            if (!ref.__exec.html && element.node) element.node.innerHTML = params.html;
        }
        // Update style — mirrors applyStyles in create.js: write via setProperty
        // with `important` priority so cascade resolves to the inline value
        // even when the element carries atomic CSS classes for sibling static
        // props. Plain `node.style[prop] = val` writes don't invalidate the
        // cached cascade when the first-paint resolved to a different value.
        if (params.style && element.node?.style) {
            if (!ref.__exec.style) for(const prop in params.style){
                const val = params.style[prop];
                if (val == null) continue;
                const cssProp = prop.replace(/[A-Z]/g, (m)=>'-' + m.toLowerCase());
                const str = String(val).replace(/\s*!important\s*$/, '');
                element.node.style.setProperty(cssProp, str, 'important');
            }
            if (!element.style) element.style = {};
            Object.assign(element.style, params.style);
        }
        if (params.attr && element.node?.setAttribute) {
            for(const key in params.attr){
                const val = params.attr[key];
                if (val == null || val === false) element.node.removeAttribute(key);
                else if (typeof val !== 'function' && typeof val !== 'object') element.node.setAttribute(key, val === true ? '' : val);
            }
            if (!element.attr) element.attr = {};
            Object.assign(element.attr, params.attr);
        }
        if (params.data && element.node?.dataset) {
            for(const key in params.data)element.node.dataset[key] = params.data[key];
            if (!element.data) element.data = {};
            Object.assign(element.data, params.data);
        }
        // Handle child element updates and property changes
        for(const param in params){
            if ((0, $5utcL.REGISTRY).has(param)) continue;
            if (param === 'state') continue;
            const childParams = params[param];
            const child = element[param];
            if (child && child.__ref && typeof child.update === 'function') // Existing child element — recursive update
            child.update(childParams, opts);
            else if (typeof childParams === 'object' && childParams !== null) {
                const firstChar = param.charCodeAt(0);
                if (firstChar >= 65 && firstChar <= 90) // Uppercase key with object value — create new child element
                (0, $fQWe4.create)(childParams, element, param, opts);
            } else if (param !== 'text' && param !== 'html' && param !== 'style' && param !== 'attr' && param !== 'data') // Primitive property update (e.g. name, icon, value)
            // Set the property — if it has a reactive effect, the effect will re-run
            element[param] = childParams;
        }
    });
    // Re-evaluate conditionals (.prop / !prop). Signal-driven predicates already
    // re-fired via createEffect; this catches imperative updates to non-signal
    // predicates (e.g. element.update({ isActive: true }) where isActive is a
    // plain element prop, not a state field).
    if (element.node && ref.__conditionalRunners) for (const run of ref.__conditionalRunners)run();
    (0, $aQqva.runPluginHook)('update', element);
    if (!opts.preventListeners && typeof element.onUpdate === 'function') element.onUpdate(element, element.state, element.context, opts);
    return element;
}
var $a95a21e77c77d2c0$export$2e2bcd8739ae039 = $a95a21e77c77d2c0$export$722fbec263ad908a;

});

parcelRegister("gXM9X", function(module, exports) {

$parcel$export(module.exports, "dispose", () => $c597838a78f1938e$export$fcfbbcec2cb820d5);
$parcel$export(module.exports, "remove", () => $c597838a78f1938e$export$cd7f480d6b8286c3);
'use strict';
function $c597838a78f1938e$export$fcfbbcec2cb820d5(element) {
    if (!element) return;
    const ref = element.__ref;
    if (!ref) return;
    // User-defined cleanup hooks fire BEFORE we tear refs/state/effects down,
    // so handlers can still read state and call methods on the element.
    // `onBeforeRemove` is for last-chance cleanup (close sockets, cancel
    // in-flight requests); `onRemove` is the canonical post-unmount hook.
    try {
        if (typeof element.onBeforeRemove === 'function') element.onBeforeRemove(element, element.state, element.context);
    } catch (e) {
        console.error('[smbls] onBeforeRemove error:', e);
    }
    // Dispose all reactive effects
    if (ref.__effects) {
        for(let i = 0; i < ref.__effects.length; i++)ref.__effects[i].dispose();
        ref.__effects.length = 0;
    }
    // Cleanup event listeners
    if (ref.__eventCleanup) {
        for(let i = 0; i < ref.__eventCleanup.length; i++)ref.__eventCleanup[i]();
        ref.__eventCleanup.length = 0;
    }
    // Recursively dispose children
    if (ref.__children) {
        for(let i = 0; i < ref.__children.length; i++){
            const childKey = ref.__children[i];
            const child = element[childKey];
            if (child && child.__ref) $c597838a78f1938e$export$fcfbbcec2cb820d5(child);
        }
        ref.__children.length = 0;
    }
    // Remove DOM node
    if (element.node?.parentNode) element.node.remove();
    // Destroy state if owned
    if (element.state?.destroy && element.state.__element === element) element.state.destroy();
    // Remove from parent's tracking
    if (element.parent?.__ref?.__children) {
        const idx = element.parent.__ref.__children.indexOf(element.key);
        if (idx !== -1) element.parent.__ref.__children.splice(idx, 1);
        delete element.parent[element.key];
    }
    // Fire onRemove AFTER DOM detach + state.destroy but BEFORE clearing refs,
    // so the hook can still read element.key / element.parent for logging.
    try {
        if (typeof element.onRemove === 'function') element.onRemove(element);
    } catch (e) {
        console.error('[smbls] onRemove error:', e);
    }
    // Clear references
    element.node = null;
    element.parent = null;
    element.__ref = null;
}
function $c597838a78f1938e$export$cd7f480d6b8286c3() {
    $c597838a78f1938e$export$fcfbbcec2cb820d5(this);
}

});


parcelRegister("bxxg4", function(module, exports) {

var $6HdC7 = parcelRequire("6HdC7");
$parcel$exportWildcard(module.exports, $6HdC7);

});
parcelRegister("6HdC7", function(module, exports) {

$parcel$export(module.exports, "createState", () => (parcelRequire("jZGSz")).createState);
$parcel$export(module.exports, "applyInitialState", () => (parcelRequire("jZGSz")).applyInitialState);
$parcel$export(module.exports, "applyStateMethods", () => (parcelRequire("gfplm")).applyStateMethods);
$parcel$export(module.exports, "STATE_METHODS", () => (parcelRequire("gfplm")).STATE_METHODS);

var $jZGSz = parcelRequire("jZGSz");

var $gfplm = parcelRequire("gfplm");

});
parcelRegister("jZGSz", function(module, exports) {

$parcel$export(module.exports, "createState", () => $e8e4f9be337caf42$export$e6a0daad8304de);
$parcel$export(module.exports, "applyInitialState", () => $e8e4f9be337caf42$export$6e8a0938c76079c7);
parcelRequire("flu9Q");
var $lQ86u = parcelRequire("lQ86u");

var $gfplm = parcelRequire("gfplm");
'use strict';
const $e8e4f9be337caf42$export$e6a0daad8304de = function(element, parent, options) {
    element.state = $e8e4f9be337caf42$export$6e8a0938c76079c7(element, parent, options);
    return element.state;
};
const $e8e4f9be337caf42$export$6e8a0938c76079c7 = function(element, parent, options) {
    const { __ref: ref } = element;
    let stateDef = element.state;
    // No state defined - inherit parent's state
    if (stateDef === undefined || stateDef === null || stateDef === false) {
        const inherited = parent?.state || {};
        // Ensure v3 state API (update/set/toggle/etc.) exists on inherited states,
        // otherwise event handlers like `(ev, el, s) => s.toggle(...)` throw.
        (0, $gfplm.applyStateMethods)(element, inherited);
        return inherited;
    }
    // String state - inherited state path
    if (typeof stateDef === 'string') {
        if (ref) ref.__state = stateDef;
        ref.__stateType = 'string';
        return $e8e4f9be337caf42$var$resolveStatePath(stateDef, element, parent);
    }
    // Number/boolean state
    if (typeof stateDef === 'number' || typeof stateDef === 'boolean') {
        if (ref) {
            ref.__state = stateDef;
            ref.__stateType = typeof stateDef;
            ref.__hasRootState = true;
        }
        const store = (0, $lQ86u.createStore)({
            value: stateDef
        });
        store.__element = element;
        if (parent?.state) store.parent = parent.state;
        (0, $gfplm.applyStateMethods)(element, store);
        return store;
    }
    // Function state - compute initial state
    if (typeof stateDef === 'function') {
        const computed = stateDef(element, parent?.state);
        stateDef = computed || {};
    }
    // Object state - create reactive store
    if (typeof stateDef === 'object' && !(0, $lQ86u.isStore)(stateDef)) {
        if (ref) ref.__hasRootState = true;
        // Check if state indicates it's the root state
        if (stateDef.isRootState) {
            if (ref) ref.__hasRootState = true;
        }
        const store = (0, $lQ86u.createStore)({
            ...stateDef
        });
        store.__element = element;
        // v3 compat: attach root reference so (el, s) => s.root.x works
        // for child states created via childrenAs: 'state' or inline state objects.
        // Root state's `root` points to itself (self-reference).
        if (!Object.getOwnPropertyDescriptor(store, 'root')) {
            const rootRef = parent?.state?.root || parent?.state || store;
            Object.defineProperty(store, 'root', {
                get: ()=>rootRef,
                enumerable: false,
                configurable: true
            });
        }
        if (parent?.state) {
            store.parent = parent.state;
            if (parent.state.__children) parent.state.__children[element.key] = store;
        }
        (0, $gfplm.applyStateMethods)(element, store);
        // Trigger onStateCreated (v3 syntax — directly on element)
        if (typeof element.onStateCreated === 'function') element.onStateCreated(element, store, element.context, options);
        return store;
    }
    // Already a store - just attach
    if ((0, $lQ86u.isStore)(stateDef)) {
        stateDef.__element = element;
        return stateDef;
    }
    return parent?.state || {};
};
function $e8e4f9be337caf42$var$resolvePath(obj, path) {
    if (!path) return obj;
    const parts = path.split('/');
    let result = obj;
    for (const part of parts){
        if (result === undefined || result === null) return {};
        result = result[part];
    }
    return result ?? {};
}
function $e8e4f9be337caf42$var$resolveStatePath(path, element, parent) {
    if (!parent?.state) return {};
    // '.' - same as parent state
    if (path === '.') return parent.state;
    // '../key' - parent's parent state
    if (path.startsWith('../')) {
        const key = path.slice(3);
        const grandParent = parent.state?.parent;
        if (key && grandParent) return $e8e4f9be337caf42$var$resolvePath(grandParent, key);
        return grandParent ?? parent.state ?? {};
    }
    // '~/' - root state (walk parent chain to find actual root)
    if (path.startsWith('~/')) {
        let rootState = parent.state;
        while(rootState?.parent)rootState = rootState.parent;
        const key = path.slice(2);
        return key ? $e8e4f9be337caf42$var$resolvePath(rootState, key) : rootState ?? {};
    }
    // Direct key - look in parent state (supports nested paths like 'product/0')
    const result = $e8e4f9be337caf42$var$resolvePath(parent.state, path);
    // v3 compat: attach a root getter to plain sub-state objects so that
    // (el, s) => s.root.x still works when state is a string path
    if (result && typeof result === 'object' && !(0, $lQ86u.isStore)(result) && !Object.getOwnPropertyDescriptor(result, 'root')) {
        const root = parent.state?.root || parent.state;
        Object.defineProperty(result, 'root', {
            get: ()=>root,
            enumerable: false,
            configurable: true
        });
    }
    return result;
}

});
parcelRegister("gfplm", function(module, exports) {

$parcel$export(module.exports, "STATE_METHODS", () => $bd41b4c578fdf92e$export$76c843b7166304af);
$parcel$export(module.exports, "applyStateMethods", () => $bd41b4c578fdf92e$export$4100ab4dd77a48b9);
parcelRequire("flu9Q");
var $lQ86u = parcelRequire("lQ86u");
'use strict';
/**
 * State methods for v4.
 * v3 compatibility: all methods (parse, clean, update, add, toggle, etc.)
 * are preserved. Internally they use the signal-based store.
 */ // State method names - used to filter them out of parse()
const $bd41b4c578fdf92e$export$76c843b7166304af = new Set([
    'update',
    'parse',
    'clean',
    'destroy',
    'create',
    'add',
    'toggle',
    'remove',
    'set',
    'replace',
    'setByPath',
    'setPathCollection',
    'removeByPath',
    'removePathCollection',
    'getByPath',
    'reset',
    'apply',
    'applyReplace',
    'applyFunction',
    'quietUpdate',
    'quietReplace',
    'rootUpdate',
    'parentUpdate',
    'keys',
    'values',
    '__element',
    '__children',
    'parent',
    'root'
]);
const $bd41b4c578fdf92e$var$defineMethod = (target, name, fn)=>{
    Object.defineProperty(target, name, {
        value: fn,
        enumerable: false,
        configurable: true,
        writable: true
    });
};
const $bd41b4c578fdf92e$export$4100ab4dd77a48b9 = (element, state)=>{
    // If state is already a signal store, it has update/parse/clean/etc.
    // We just need to add the v3-specific methods that aren't in the store
    if ((0, $lQ86u.isStore)(state)) {
        // Store already has: update, parse, clean, keys, values, replace, add, remove, destroy, quietUpdate
        // We need to add: toggle, set, setByPath, reset, apply, applyFunction, rootUpdate, parentUpdate, etc.
        // These are added as non-enumerable properties on the proxy's raw object
        const raw = state.__raw || state;
        // toggle
        if (!state.toggle) Object.defineProperty(raw, 'toggle', {
            value: function(key, options = {}) {
                state[key] = !state[key];
            },
            enumerable: false,
            configurable: true
        });
        // set (replace all state with new value)
        if (!state.set) Object.defineProperty(raw, 'set', {
            value: function(val, options = {}) {
                state.clean({
                    preventStateUpdate: true
                });
                if (typeof val === 'object' && val !== null) state.update(val, options);
                return state;
            },
            enumerable: false,
            configurable: true
        });
        // setByPath
        Object.defineProperty(raw, 'setByPath', {
            value: function(path, val, options = {}) {
                const parts = path.split('.');
                let current = state;
                for(let i = 0; i < parts.length - 1; i++){
                    if (current[parts[i]] === undefined) current[parts[i]] = {};
                    current = current[parts[i]];
                }
                current[parts[parts.length - 1]] = val;
                return state;
            },
            enumerable: false,
            configurable: true,
            writable: true
        });
        // getByPath
        Object.defineProperty(raw, 'getByPath', {
            value: function(path) {
                const parts = path.split('.');
                let current = state;
                for(let i = 0; i < parts.length; i++){
                    if (current == null) return undefined;
                    current = current[parts[i]];
                }
                return current;
            },
            enumerable: false,
            configurable: true,
            writable: true
        });
        // removeByPath
        Object.defineProperty(raw, 'removeByPath', {
            value: function(path, options = {}) {
                const parts = path.split('.');
                let current = state;
                for(let i = 0; i < parts.length - 1; i++){
                    if (current == null) return state;
                    current = current[parts[i]];
                }
                if (current) delete current[parts[parts.length - 1]];
                return state;
            },
            enumerable: false,
            configurable: true,
            writable: true
        });
        // reset
        Object.defineProperty(raw, 'reset', {
            value: function(options = {}) {
                const parsed = state.parse();
                return state.set(parsed, options);
            },
            enumerable: false,
            configurable: true,
            writable: true
        });
        // apply
        Object.defineProperty(raw, 'apply', {
            value: function(func, options = {}) {
                if (typeof func === 'function') {
                    const value = func(state);
                    return state.update(value, options);
                }
            },
            enumerable: false,
            configurable: true,
            writable: true
        });
        // applyFunction
        Object.defineProperty(raw, 'applyFunction', {
            value: function(func, options = {}) {
                if (typeof func === 'function') {
                    func(state);
                    return state.update(state.parse(), options);
                }
            },
            enumerable: false,
            configurable: true,
            writable: true
        });
        // rootUpdate
        Object.defineProperty(raw, 'rootUpdate', {
            value: function(obj, options = {}) {
                let rootState = state;
                while(rootState?.parent && (0, $lQ86u.isStore)(rootState.parent))rootState = rootState.parent;
                return rootState.update(obj, options);
            },
            enumerable: false,
            configurable: true,
            writable: true
        });
        // parentUpdate
        Object.defineProperty(raw, 'parentUpdate', {
            value: function(obj, options = {}) {
                if (state.parent) return state.parent.update(obj, options);
            },
            enumerable: false,
            configurable: true,
            writable: true
        });
        // quietReplace
        Object.defineProperty(raw, 'quietReplace', {
            value: function(obj, options = {}) {
                return state.replace(obj, {
                    quiet: true,
                    ...options
                });
            },
            enumerable: false,
            configurable: true,
            writable: true
        });
        // root — v3 compat: walk up the parent chain to the root state
        if (!Object.getOwnPropertyDescriptor(raw, 'root')) Object.defineProperty(raw, 'root', {
            get: function() {
                let s = state;
                while(s?.parent && (0, $lQ86u.isStore)(s.parent))s = s.parent;
                return s;
            },
            enumerable: false,
            configurable: true
        });
        return;
    }
    // Fallback for non-store state objects (inherited states).
    // They inherit reactivity via their parent, but v3 consumers still expect
    // the helper methods — without these, shared components that call
    // `s.apply(...)`, `s.update(...)`, etc. throw "is not a function".
    if (!state || typeof state !== 'object') return;
    const clearOwn = ()=>{
        for(const k in state)if (Object.prototype.hasOwnProperty.call(state, k)) delete state[k];
    };
    const fallbackMethods = {
        update (obj) {
            if (!obj || typeof obj !== 'object') return state;
            for(const k in obj)state[k] = obj[k];
            return state;
        },
        apply (fn) {
            if (typeof fn !== 'function') return state;
            const value = fn(state);
            return value ? state.update(value) : state;
        },
        parse () {
            return {
                ...state
            };
        },
        toggle (key) {
            state[key] = !state[key];
            return state;
        },
        set (val) {
            if (!val || typeof val !== 'object') return state;
            clearOwn();
            for(const k in val)state[k] = val[k];
            return state;
        },
        replace (val) {
            return state.set(val);
        },
        clean () {
            clearOwn();
            return state;
        }
    };
    for(const name in fallbackMethods)if (typeof state[name] !== 'function') $bd41b4c578fdf92e$var$defineMethod(state, name, fallbackMethods[name]);
};

});




parcelRegister("dXl0a", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "CSS_PROPS_REGISTRY", () => $a291138c47ac21b4$export$b474245a861fc144);
$parcel$export(module.exports, "default", () => $a291138c47ac21b4$export$2e2bcd8739ae039);

var $5ZxZ7 = parcelRequire("5ZxZ7");

var $hclJR = parcelRequire("hclJR");

var $70wcR = parcelRequire("70wcR");

var $2DUZN = parcelRequire("2DUZN");

var $iZazC = parcelRequire("iZazC");

var $gEXSl = parcelRequire("gEXSl");

var $4Yzct = parcelRequire("4Yzct");

var $b1Fvr = parcelRequire("b1Fvr");

var $6Dulq = parcelRequire("6Dulq");
'use strict';
const $a291138c47ac21b4$export$b474245a861fc144 = {
    ...(0, $5ZxZ7.ANIMATION_PROPS),
    ...(0, $hclJR.BLOCK_PROPS),
    ...(0, $70wcR.FONT_PROPS),
    ...(0, $2DUZN.MISC_PROPS),
    ...(0, $iZazC.POSITION_PROPS),
    ...(0, $gEXSl.THEME_PROPS),
    ...(0, $4Yzct.TIMING_PROPS),
    ...(0, $b1Fvr.FLEX_PROPS),
    ...(0, $6Dulq.GRID_PROPS)
};
var $a291138c47ac21b4$export$2e2bcd8739ae039 = $a291138c47ac21b4$export$b474245a861fc144;
$parcel$exportWildcard(module.exports, $5ZxZ7);
$parcel$exportWildcard(module.exports, $hclJR);
$parcel$exportWildcard(module.exports, $70wcR);
$parcel$exportWildcard(module.exports, $2DUZN);
$parcel$exportWildcard(module.exports, $iZazC);
$parcel$exportWildcard(module.exports, $gEXSl);
$parcel$exportWildcard(module.exports, $4Yzct);
$parcel$exportWildcard(module.exports, $b1Fvr);
$parcel$exportWildcard(module.exports, $6Dulq);

});
parcelRegister("5ZxZ7", function(module, exports) {

$parcel$export(module.exports, "ANIMATION_PROPS", () => $45cd02eecb649c43$export$29173f57c6f2005);
parcelRequire("2oe0q");
var $fX7ii = parcelRequire("fX7ii");
parcelRequire("2Eo8m");
var $bd7kG = parcelRequire("bd7kG");
parcelRequire("aTPvW");
var $2KAeE = parcelRequire("2KAeE");
'use strict';
const $45cd02eecb649c43$var$TIMING_FUNCTIONS = [
    'ease',
    'linear',
    'ease-in',
    'ease-out',
    'ease-in-out',
    'step-start',
    'step-end'
];
const $45cd02eecb649c43$var$FILL_MODES = [
    'none',
    'forwards',
    'backwards',
    'both'
];
const $45cd02eecb649c43$var$DIRECTIONS = [
    'normal',
    'reverse',
    'alternate',
    'alternate-reverse'
];
const $45cd02eecb649c43$var$PLAY_STATES = [
    'running',
    'paused'
];
const $45cd02eecb649c43$var$isDuration = (v)=>/^[\d.]+m?s$/.test(v);
let $45cd02eecb649c43$var$_animCounter = 0;
const $45cd02eecb649c43$var$applyAnimationProps = (animation, element)=>{
    const { animation: ANIMATION } = element.context && element.context.designSystem || {};
    if ((0, $fX7ii.isObject)(animation)) {
        const name = `smbls-anim-${$45cd02eecb649c43$var$_animCounter++}`;
        return {
            animationName: (0, $bd7kG.keyframes)(name, animation)
        };
    }
    const record = ANIMATION && ANIMATION[animation];
    if ((0, $fX7ii.isObject)(record)) return (0, $bd7kG.keyframes)(animation, record);
    return animation;
};
/**
 * Parse CSS animation shorthand string into individual properties.
 * Identifies the animation name by looking it up in the ANIMATION registry.
 * Other tokens are classified by type: duration, timing-function, iteration-count, etc.
 */ const $45cd02eecb649c43$var$parseAnimationShorthand = (val, el)=>{
    const { animation: ANIMATION } = el.context && el.context.designSystem || {};
    const tokens = val.split(/\s+/);
    let name = null;
    const durations = [];
    let timingFunction = null;
    let iterationCount = null;
    let direction = null;
    let fillMode = null;
    let playState = null;
    for (const token of tokens){
        if (ANIMATION && ANIMATION[token]) name = token;
        else if ($45cd02eecb649c43$var$isDuration(token)) durations.push(token);
        else if ($45cd02eecb649c43$var$TIMING_FUNCTIONS.includes(token) || token.startsWith('cubic-bezier') || token.startsWith('steps(')) timingFunction = token;
        else if (token === 'infinite' || /^\d+$/.test(token)) iterationCount = token === 'infinite' ? token : Number(token);
        else if ($45cd02eecb649c43$var$DIRECTIONS.includes(token)) direction = token;
        else if ($45cd02eecb649c43$var$FILL_MODES.includes(token)) fillMode = token;
        else if ($45cd02eecb649c43$var$PLAY_STATES.includes(token)) playState = token;
        else if (!name) // Fallback: treat unknown token as animation name
        name = token;
    }
    return {
        name: name,
        durations: durations,
        timingFunction: timingFunction,
        iterationCount: iterationCount,
        direction: direction,
        fillMode: fillMode,
        playState: playState
    };
};
const $45cd02eecb649c43$export$29173f57c6f2005 = {
    animation: (val, el)=>{
        // Support CSS shorthand: 'animationName 2s linear infinite'
        if ((0, $fX7ii.isString)(val) && val.includes(' ')) {
            const parsed = $45cd02eecb649c43$var$parseAnimationShorthand(val, el);
            return {
                animationName: $45cd02eecb649c43$var$applyAnimationProps(parsed.name || val, el),
                animationDuration: parsed.durations[0] || (0, $2KAeE.getTimingByKey)(el.animationDuration || 'A').timing,
                animationDelay: parsed.durations[1] || (0, $2KAeE.getTimingByKey)(el.animationDelay || '0s').timing,
                animationTimingFunction: parsed.timingFunction || (0, $2KAeE.getTimingFunction)(el.animationTimingFunction || 'ease'),
                animationFillMode: parsed.fillMode || el.animationFillMode || 'both',
                animationIterationCount: parsed.iterationCount != null ? parsed.iterationCount : el.animationIterationCount || 1,
                animationPlayState: parsed.playState || el.animationPlayState,
                animationDirection: parsed.direction || el.animationDirection
            };
        }
        // Single name (no spaces) — original behavior
        return {
            animationName: $45cd02eecb649c43$var$applyAnimationProps(val, el),
            animationDuration: (0, $2KAeE.getTimingByKey)(el.animationDuration || 'A').timing,
            animationDelay: (0, $2KAeE.getTimingByKey)(el.animationDelay || '0s').timing,
            animationTimingFunction: (0, $2KAeE.getTimingFunction)(el.animationTimingFunction || 'ease'),
            animationFillMode: el.animationFillMode || 'both',
            animationIterationCount: el.animationIterationCount || 1,
            animationPlayState: el.animationPlayState,
            animationDirection: el.animationDirection
        };
    },
    animationName: (val, el)=>({
            animationName: $45cd02eecb649c43$var$applyAnimationProps(val, el)
        }),
    animationDuration: (val)=>({
            animationDuration: (0, $2KAeE.getTimingByKey)(val).timing
        }),
    animationDelay: (val)=>({
            animationDelay: (0, $2KAeE.getTimingByKey)(val).timing
        }),
    animationTimingFunction: (val)=>({
            animationTimingFunction: (0, $2KAeE.getTimingFunction)(val)
        }),
    animationIterationCount: (val)=>({
            animationIterationCount: val
        }),
    animationFillMode: (val)=>({
            animationFillMode: val
        }),
    animationPlayState: (val)=>({
            animationPlayState: val
        }),
    animationDirection: (val)=>({
            animationDirection: val
        })
};

});

parcelRegister("hclJR", function(module, exports) {

$parcel$export(module.exports, "BLOCK_PROPS", () => $c8546b8815e9ba6b$export$d8a4821b5338da9d);
parcelRequire("2oe0q");
var $fX7ii = parcelRequire("fX7ii");
parcelRequire("aTPvW");
var $awIHJ = parcelRequire("awIHJ");
var $4nA98 = parcelRequire("4nA98");
'use strict';
const $c8546b8815e9ba6b$export$d8a4821b5338da9d = {
    show: (val)=>!val ? {
            display: 'none !important'
        } : undefined,
    hide: (val)=>val ? {
            display: 'none !important'
        } : undefined,
    height: (val, el)=>(0, $4nA98.transformSizeRatio)('height', val, el),
    width: (val, el)=>(0, $4nA98.transformSizeRatio)('width', val, el),
    boxSizing: (val)=>!(0, $fX7ii.isUndefined)(val) ? {
            boxSizing: val
        } : {
            boxSizing: 'border-box'
        },
    boxSize: (val)=>{
        if (!(0, $fX7ii.isString)(val)) return;
        const [height, width] = val.split(' ');
        return {
            ...(0, $4nA98.transformSize)('height', height),
            ...(0, $4nA98.transformSize)('width', width || height)
        };
    },
    inlineSize: (val, el)=>(0, $4nA98.transformSizeRatio)('inlineSize', val, el),
    blockSize: (val, el)=>(0, $4nA98.transformSizeRatio)('blockSize', val, el),
    minWidth: (val, el)=>(0, $4nA98.transformSizeRatio)('minWidth', val, el),
    maxWidth: (val, el)=>(0, $4nA98.transformSizeRatio)('maxWidth', val, el),
    widthRange: (val)=>{
        if (!(0, $fX7ii.isString)(val)) return;
        const [minWidth, maxWidth] = val.split(' ');
        return {
            ...(0, $4nA98.transformSize)('minWidth', minWidth),
            ...(0, $4nA98.transformSize)('maxWidth', maxWidth || minWidth)
        };
    },
    minHeight: (val, el)=>(0, $4nA98.transformSizeRatio)('minHeight', val, el),
    maxHeight: (val, el)=>(0, $4nA98.transformSizeRatio)('maxHeight', val, el),
    heightRange: (val)=>{
        if (!(0, $fX7ii.isString)(val)) return;
        const [minHeight, maxHeight] = val.split(' ');
        return {
            ...(0, $4nA98.transformSize)('minHeight', minHeight),
            ...(0, $4nA98.transformSize)('maxHeight', maxHeight || minHeight)
        };
    },
    size: (val)=>{
        if (!(0, $fX7ii.isString)(val)) return;
        const [inlineSize, blockSize] = val.split(' ');
        return {
            ...(0, $4nA98.transformSizeRatio)('inlineSize', inlineSize),
            ...(0, $4nA98.transformSizeRatio)('blockSize', blockSize || inlineSize)
        };
    },
    minBlockSize: (val, el)=>(0, $4nA98.transformSizeRatio)('minBlockSize', val, el),
    minInlineSize: (val, el)=>(0, $4nA98.transformSizeRatio)('minInlineSize', val, el),
    maxBlockSize: (val, el)=>(0, $4nA98.transformSizeRatio)('maxBlockSize', val, el),
    maxInlineSize: (val, el)=>(0, $4nA98.transformSizeRatio)('maxInlineSize', val, el),
    minSize: (val)=>{
        if (!(0, $fX7ii.isString)(val)) return;
        const [minInlineSize, minBlockSize] = val.split(' ');
        return {
            ...(0, $4nA98.transformSize)('minInlineSize', minInlineSize),
            ...(0, $4nA98.transformSize)('minBlockSize', minBlockSize || minInlineSize)
        };
    },
    maxSize: (val)=>{
        if (!(0, $fX7ii.isString)(val)) return;
        const [maxInlineSize, maxBlockSize] = val.split(' ');
        return {
            ...(0, $4nA98.transformSize)('maxInlineSize', maxInlineSize),
            ...(0, $4nA98.transformSize)('maxBlockSize', maxBlockSize || maxInlineSize)
        };
    },
    borderWidth: (val, el)=>(0, $4nA98.transformSizeRatio)('borderWidth', val, el),
    padding: (val, el)=>(0, $4nA98.transformSizeRatio)('padding', val, el),
    scrollPadding: (val, el)=>(0, $4nA98.transformSizeRatio)('scrollPadding', val, el),
    paddingInline: (val)=>{
        if (!(0, $fX7ii.isString)(val)) return;
        const [paddingInlineStart, paddingInlineEnd] = val.split(' ');
        return {
            ...(0, $4nA98.transformSize)('paddingInlineStart', paddingInlineStart),
            ...(0, $4nA98.transformSize)('paddingInlineEnd', paddingInlineEnd || paddingInlineStart)
        };
    },
    paddingBlock: (val)=>{
        if (!(0, $fX7ii.isString)(val)) return;
        const [paddingBlockStart, paddingBlockEnd] = val.split(' ');
        return {
            ...(0, $4nA98.transformSize)('paddingBlockStart', paddingBlockStart),
            ...(0, $4nA98.transformSize)('paddingBlockEnd', paddingBlockEnd || paddingBlockStart)
        };
    },
    paddingTop: (val, el)=>(0, $4nA98.transformSizeRatio)('paddingBlockStart', val, el),
    paddingBottom: (val, el)=>(0, $4nA98.transformSizeRatio)('paddingBlockEnd', val, el),
    paddingLeft: (val, el)=>(0, $4nA98.transformSizeRatio)('paddingInlineStart', val, el),
    paddingRight: (val, el)=>(0, $4nA98.transformSizeRatio)('paddingInlineEnd', val, el),
    paddingBlockStart: (val, el)=>(0, $4nA98.transformSizeRatio)('paddingBlockStart', val, el),
    paddingBlockEnd: (val, el)=>(0, $4nA98.transformSizeRatio)('paddingBlockEnd', val, el),
    paddingInlineStart: (val, el)=>(0, $4nA98.transformSizeRatio)('paddingInlineStart', val, el),
    paddingInlineEnd: (val, el)=>(0, $4nA98.transformSizeRatio)('paddingInlineEnd', val, el),
    margin: (val, el)=>(0, $4nA98.transformSizeRatio)('margin', val, el),
    marginInline: (val)=>{
        if (!(0, $fX7ii.isString)(val)) return;
        const [marginInlineStart, marginInlineEnd] = val.split(' ');
        return {
            ...(0, $4nA98.transformSize)('marginInlineStart', marginInlineStart),
            ...(0, $4nA98.transformSize)('marginInlineEnd', marginInlineEnd || marginInlineStart)
        };
    },
    marginBlock: (val, el)=>{
        if (!(0, $fX7ii.isString)(el.marginBlock)) return;
        const [marginBlockStart, marginBlockEnd] = el.marginBlock.split(' ');
        return {
            ...(0, $4nA98.transformSize)('marginBlockStart', marginBlockStart),
            ...(0, $4nA98.transformSize)('marginBlockEnd', marginBlockEnd || marginBlockStart)
        };
    },
    marginTop: (val, el)=>(0, $4nA98.transformSizeRatio)('marginBlockStart', val, el),
    marginBottom: (val, el)=>(0, $4nA98.transformSizeRatio)('marginBlockEnd', val, el),
    marginLeft: (val, el)=>(0, $4nA98.transformSizeRatio)('marginInlineStart', val, el),
    marginRight: (val, el)=>(0, $4nA98.transformSizeRatio)('marginInlineEnd', val, el),
    marginInlineStart: (val, el)=>(0, $4nA98.transformSizeRatio)('marginInlineStart', val, el),
    marginInlineEnd: (val, el)=>(0, $4nA98.transformSizeRatio)('marginInlineEnd', val, el),
    marginBlockStart: (val, el)=>(0, $4nA98.transformSizeRatio)('marginBlockStart', val, el),
    marginBlockEnd: (val, el)=>(0, $4nA98.transformSizeRatio)('marginBlockEnd', val, el),
    gap: (val)=>({
            gap: (0, $4nA98.transfromGap)(val)
        }),
    columnGap: (val, el)=>(0, $awIHJ.getSpacingBasedOnRatio)(el, 'columnGap', val),
    rowGap: (val, el)=>(0, $awIHJ.getSpacingBasedOnRatio)(el, 'rowGap', val),
    flexWrap: (val)=>({
            display: 'flex',
            flexWrap: val
        }),
    flexFlow: (val, el)=>{
        const reverse = el.reverse;
        if (!(0, $fX7ii.isString)(val)) return;
        let [direction, wrap] = (val || 'row').split(' ');
        if (val.startsWith('x') || val === 'row') direction = 'row';
        if (val.startsWith('y') || val === 'column') direction = 'column';
        return {
            display: 'flex',
            flexFlow: (direction || '') + (!direction.includes('-reverse') && reverse ? '-reverse' : '') + ' ' + (wrap || '')
        };
    },
    flexAlign: (val)=>{
        if (!(0, $fX7ii.isString)(val)) return;
        const [alignItems, justifyContent] = val.split(' ');
        return {
            display: 'flex',
            alignItems: alignItems,
            justifyContent: justifyContent
        };
    },
    round: (val, el)=>(0, $4nA98.transformBorderRadius)(val ?? el.borderRadius, el, 'round'),
    borderRadius: (val, el)=>(0, $4nA98.transformBorderRadius)(val ?? el.round, el, 'borderRadius')
};

});

parcelRegister("70wcR", function(module, exports) {

$parcel$export(module.exports, "FONT_PROPS", () => $51a1840afadb9e23$export$e6c8c930b1cd765);
parcelRequire("aTPvW");
var $kmFEN = parcelRequire("kmFEN");
var $3o9uT = parcelRequire("3o9uT");
'use strict';
const $51a1840afadb9e23$export$e6c8c930b1cd765 = {
    fontSize: (value)=>{
        return (0, $3o9uT.getFontSizeByKey)(value) || value;
    },
    fontFamily: (value)=>({
            fontFamily: (0, $kmFEN.getFontFamily)(value) || value
        }),
    fontWeight: (value)=>({
            fontWeight: value,
            fontVariationSettings: '"wght" ' + value
        })
};

});

parcelRegister("2DUZN", function(module, exports) {

$parcel$export(module.exports, "MISC_PROPS", () => $1ecb6f6de1b9b12c$export$24dfac4a0da20903);
'use strict';
const $1ecb6f6de1b9b12c$export$24dfac4a0da20903 = {
    overflow: (value)=>({
            overflow: value,
            scrollBehavior: 'smooth'
        }),
    cursor: (value, el, s, ctx)=>{
        if (!value) return;
        const asset = ctx.assets && ctx.assets[value];
        if (asset && asset.content) value = `url(${asset.content.src})`;
        else {
            const file = ctx.files && ctx.files[value];
            if (file && file.content) value = `url(${file.content.src})`;
        }
        return {
            cursor: value
        };
    },
    opacity: (value)=>value != null ? {
            opacity: String(value)
        } : undefined,
    visibility: (value)=>value != null ? {
            visibility: value
        } : undefined,
    pointerEvents: (value)=>value != null ? {
            pointerEvents: value
        } : undefined
};

});

parcelRegister("iZazC", function(module, exports) {

$parcel$export(module.exports, "POSITION_PROPS", () => $dd262031a14f28fd$export$c0036cbb5416e2bc);
parcelRequire("aTPvW");
var $awIHJ = parcelRequire("awIHJ");
'use strict';
const $dd262031a14f28fd$export$c0036cbb5416e2bc = {
    inset: (val, el)=>{
        if (el.call('isNumber', val)) return {
            inset: val
        };
        if (!el.call('isString', val)) return;
        return {
            inset: val.split(' ').map((v)=>(0, $awIHJ.getSpacingByKey)(v, 'k').k).join(' ')
        };
    },
    left: (val)=>(0, $awIHJ.getSpacingByKey)(val, 'left'),
    top: (val)=>(0, $awIHJ.getSpacingByKey)(val, 'top'),
    right: (val)=>(0, $awIHJ.getSpacingByKey)(val, 'right'),
    bottom: (val)=>(0, $awIHJ.getSpacingByKey)(val, 'bottom'),
    verticalInset: (val)=>{
        if (typeof val !== 'string') return;
        const vi = val.split(' ').map((v)=>(0, $awIHJ.getSpacingByKey)(v, 'k').k);
        return {
            top: vi[0],
            bottom: vi[1] || vi[0]
        };
    },
    horizontalInset: (val)=>{
        if (typeof val !== 'string') return;
        const vi = val.split(' ').map((v)=>(0, $awIHJ.getSpacingByKey)(v, 'k').k);
        return {
            left: vi[0],
            right: vi[1] || vi[0]
        };
    }
};

});

parcelRegister("gEXSl", function(module, exports) {

$parcel$export(module.exports, "getSystemGlobalTheme", () => $c20ed3ccc46ab540$export$f12bbb197a836138);
$parcel$export(module.exports, "THEME_PROPS", () => $c20ed3ccc46ab540$export$11ce017e3ee09814);
parcelRequire("aTPvW");
var $h2nZH = parcelRequire("h2nZH");
var $6VLzn = parcelRequire("6VLzn");
var $4nA98 = parcelRequire("4nA98");
parcelRequire("2oe0q");
var $fX7ii = parcelRequire("fX7ii");
'use strict';
const $c20ed3ccc46ab540$export$f12bbb197a836138 = ({ context: context, state: state })=>{
    const theme = state?.root?.globalTheme || context.designSystem?.globalTheme;
    return theme === 'auto' ? null : theme;
};
const $c20ed3ccc46ab540$export$11ce017e3ee09814 = {
    theme: (val, element)=>{
        if (!val) return;
        // themeModifier explicitly forces a scheme on this component
        if (element.themeModifier) return (0, $6VLzn.getMediaTheme)(val, `@${element.themeModifier}`);
        // CSS vars handle dark/light switching — no modifier needed, no DOMQL re-render
        return (0, $6VLzn.getMediaTheme)(val);
    },
    color: (val, element)=>{
        const globalTheme = $c20ed3ccc46ab540$export$f12bbb197a836138(element);
        if (!val) return;
        return {
            color: (0, $h2nZH.getMediaColor)(val, globalTheme)
        };
    },
    background: (val, element)=>{
        const globalTheme = $c20ed3ccc46ab540$export$f12bbb197a836138(element);
        if (!val) return;
        if ((0, $fX7ii.isString)(val) && val.includes('gradient')) return {
            background: (0, $4nA98.resolveColorsInGradient)(val, globalTheme)
        };
        return {
            background: (0, $h2nZH.getMediaColor)(val, globalTheme)
        };
    },
    backgroundColor: (val, element)=>{
        const globalTheme = $c20ed3ccc46ab540$export$f12bbb197a836138(element);
        if (!val) return;
        return {
            backgroundColor: (0, $h2nZH.getMediaColor)(val, globalTheme)
        };
    },
    backgroundImage: (val, element, s, ctx)=>{
        const globalTheme = $c20ed3ccc46ab540$export$f12bbb197a836138(element);
        if (!val) return;
        const asset = ctx.assets && ctx.assets[val];
        if (asset && asset.content) val = asset.content.src;
        else {
            const file = ctx.files && ctx.files[val];
            if (file && file.content) val = file.content.src;
        }
        return {
            backgroundImage: (0, $4nA98.transformBackgroundImage)(val, globalTheme)
        };
    },
    textStroke: (val)=>({
            WebkitTextStroke: (0, $4nA98.transformTextStroke)(val)
        }),
    outline: (val)=>({
            outline: (0, $4nA98.transformBorder)(val)
        }),
    outlineOffset: (val, el)=>(0, $4nA98.transformSizeRatio)('outlineOffset', val, el),
    border: (val)=>({
            border: (0, $4nA98.transformBorder)(val)
        }),
    borderColor: (val, element)=>{
        const globalTheme = $c20ed3ccc46ab540$export$f12bbb197a836138(element);
        if (!val) return;
        return {
            borderColor: (0, $h2nZH.getMediaColor)(val, globalTheme)
        };
    },
    borderTopColor: (val, element)=>{
        const globalTheme = $c20ed3ccc46ab540$export$f12bbb197a836138(element);
        if (!val) return;
        return {
            borderTopColor: (0, $h2nZH.getMediaColor)(val, globalTheme)
        };
    },
    borderBottomColor: (val, element)=>{
        const globalTheme = $c20ed3ccc46ab540$export$f12bbb197a836138(element);
        if (!val) return;
        return {
            borderBottomColor: (0, $h2nZH.getMediaColor)(val, globalTheme)
        };
    },
    borderLeftColor: (val, element)=>{
        const globalTheme = $c20ed3ccc46ab540$export$f12bbb197a836138(element);
        if (!val) return;
        return {
            borderLeftColor: (0, $h2nZH.getMediaColor)(val, globalTheme)
        };
    },
    borderRightColor: (val, element)=>{
        const globalTheme = $c20ed3ccc46ab540$export$f12bbb197a836138(element);
        if (!val) return;
        return {
            borderRightColor: (0, $h2nZH.getMediaColor)(val, globalTheme)
        };
    },
    borderLeft: (val)=>({
            borderLeft: (0, $4nA98.transformBorder)(val)
        }),
    borderTop: (val)=>({
            borderTop: (0, $4nA98.transformBorder)(val)
        }),
    borderRight: (val)=>({
            borderRight: (0, $4nA98.transformBorder)(val)
        }),
    borderBottom: (val)=>({
            borderBottom: (0, $4nA98.transformBorder)(val)
        }),
    shadow: (val, element)=>{
        const globalTheme = $c20ed3ccc46ab540$export$f12bbb197a836138(element);
        if (!val) return;
        return {
            boxShadow: (0, $4nA98.transformShadow)(val, globalTheme)
        };
    },
    boxShadow: (val, element)=>{
        if (!(0, $fX7ii.isString)(val)) return;
        const [value, hasImportant] = val.split('!importan');
        const globalTheme = $c20ed3ccc46ab540$export$f12bbb197a836138(element);
        const important = hasImportant ? ' !important' : '';
        return {
            boxShadow: (0, $4nA98.transformBoxShadow)(value.trim(), globalTheme) + important
        };
    },
    textShadow: (val, { context: context })=>({
            textShadow: (0, $4nA98.transformBoxShadow)(val, context.designSystem.globalTheme)
        }),
    columnRule: (val)=>({
            columnRule: (0, $4nA98.transformBorder)(val)
        })
};

});

parcelRegister("4Yzct", function(module, exports) {

$parcel$export(module.exports, "TIMING_PROPS", () => $39f812117129238d$export$801d104720a35e80);
parcelRequire("aTPvW");
var $2KAeE = parcelRequire("2KAeE");
var $4nA98 = parcelRequire("4nA98");
'use strict';
const $39f812117129238d$export$801d104720a35e80 = {
    transition: (val)=>({
            transition: (0, $4nA98.splitTransition)(val)
        }),
    transitionDuration: (val)=>({
            transitionDuration: (0, $4nA98.transformDuration)(val)
        }),
    transitionDelay: (val)=>({
            transitionDelay: (0, $4nA98.transformDuration)(val)
        }),
    transitionTimingFunction: (val)=>({
            transitionTimingFunction: (0, $2KAeE.getTimingFunction)(val)
        }),
    transitionProperty: (val)=>({
            transitionProperty: val,
            willChange: val
        })
};

});

parcelRegister("b1Fvr", function(module, exports) {

$parcel$export(module.exports, "FLEX_PROPS", () => $806ffbefeb36c70d$export$736b75ae6a344b36);
parcelRequire("2oe0q");
var $fX7ii = parcelRequire("fX7ii");
'use strict';
const $806ffbefeb36c70d$export$736b75ae6a344b36 = {
    flow: (value, el)=>{
        const reverse = el.reverse;
        if (!(0, $fX7ii.isString)(value)) return;
        let [direction, wrap] = (value || 'row').split(' ');
        if (value.startsWith('x') || value === 'row') direction = 'row';
        if (value.startsWith('y') || value === 'column') direction = 'column';
        return {
            display: 'flex',
            flexFlow: (direction || '') + (!direction.includes('-reverse') && reverse ? '-reverse' : '') + ' ' + (wrap || '')
        };
    },
    wrap: (value, el)=>{
        return {
            display: 'flex',
            flexWrap: value
        };
    },
    align: (value, el)=>{
        const [alignItems, justifyContent] = value.split(' ');
        return {
            display: 'flex',
            alignItems: alignItems,
            justifyContent: justifyContent
        };
    }
};

});

parcelRegister("6Dulq", function(module, exports) {

$parcel$export(module.exports, "GRID_PROPS", () => $4d4dec6b5eeac7dd$export$e33f615210a2138f);
'use strict';
const $4d4dec6b5eeac7dd$export$e33f615210a2138f = {
    area: (value)=>({
            gridArea: value
        }),
    template: (value)=>({
            gridTemplate: value
        }),
    templateAreas: (value)=>({
            gridTemplateAreas: value
        }),
    column: (value)=>({
            gridColumn: value
        }),
    columns: (value)=>({
            gridTemplateColumns: value
        }),
    templateColumns: (value)=>({
            gridTemplateColumns: value
        }),
    autoColumns: (value)=>({
            gridAutoColumns: value
        }),
    columnStart: (value)=>({
            gridColumnStart: value
        }),
    row: (value)=>({
            gridRow: value
        }),
    rows: (value)=>({
            gridTemplateRows: value
        }),
    templateRows: (value)=>({
            gridTemplateRows: value
        }),
    autoRows: (value)=>({
            gridAutoRows: value
        }),
    rowStart: (value)=>({
            gridRowStart: value
        }),
    autoFlow: (value)=>({
            gridAutoFlow: value
        })
};

});


parcelRegister("cThmB", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_CSS_PROPERTIES_LIST", () => $96281721cef2f8de$export$33f20e95f48422c);
const $96281721cef2f8de$export$33f20e95f48422c = new Set([
    'accentColor',
    'alignContent',
    'alignItems',
    'alignSelf',
    'alignmentBaseline',
    'all',
    'animation',
    'animationDelay',
    'animationDirection',
    'animationDuration',
    'animationFillMode',
    'animationIterationCount',
    'animationName',
    'animationPlayState',
    'animationTimingFunction',
    'appearance',
    'aspectRatio',
    'backdropFilter',
    'backfaceVisibility',
    'background',
    'backgroundAttachment',
    'backgroundBlendMode',
    'backgroundClip',
    'backgroundColor',
    'backgroundImage',
    'backgroundOrigin',
    'backgroundPosition',
    'backgroundPositionX',
    'backgroundPositionY',
    'backgroundRepeat',
    'backgroundRepeatX',
    'backgroundRepeatY',
    'backgroundSize',
    'baselineShift',
    'blockSize',
    'border',
    'borderBlock',
    'borderBlockColor',
    'borderBlockEnd',
    'borderBlockEndColor',
    'borderBlockEndStyle',
    'borderBlockEndWidth',
    'borderBlockStart',
    'borderBlockStartColor',
    'borderBlockStartStyle',
    'borderBlockStartWidth',
    'borderBlockStyle',
    'borderBlockWidth',
    'borderBottom',
    'borderBottomColor',
    'borderBottomLeftRadius',
    'borderBottomRightRadius',
    'borderBottomStyle',
    'borderBottomWidth',
    'borderCollapse',
    'borderColor',
    'borderImage',
    'borderImageOutset',
    'borderImageRepeat',
    'borderImageSlice',
    'borderImageSource',
    'borderImageWidth',
    'borderLeft',
    'borderLeftColor',
    'borderLeftStyle',
    'borderLeftWidth',
    'borderRadius',
    'borderRight',
    'borderRightColor',
    'borderRightStyle',
    'borderRightWidth',
    'borderSpacing',
    'borderStyle',
    'borderTop',
    'borderTopColor',
    'borderTopLeftRadius',
    'borderTopRightRadius',
    'borderTopStyle',
    'borderTopWidth',
    'borderWidth',
    'bottom',
    'boxDecorationBreak',
    'boxShadow',
    'boxSizing',
    'breakAfter',
    'breakBefore',
    'breakInside',
    'captionSide',
    'caretColor',
    'clear',
    'clip',
    'clipPath',
    'color',
    'colorAdjust',
    'colorInterpolation',
    'colorInterpolationFilters',
    'colorRendering',
    'columnCount',
    'columnFill',
    'columnGap',
    'columnRule',
    'columnRuleColor',
    'columnRuleStyle',
    'columnRuleWidth',
    'columnSpan',
    'columnWidth',
    'columns',
    'contain',
    'content',
    'counterIncrement',
    'counterReset',
    'cursor',
    'direction',
    'display',
    'emptyCells',
    'filter',
    'flex',
    'flexBasis',
    'flexDirection',
    'flexFlow',
    'flexGrow',
    'flexShrink',
    'flexWrap',
    'float',
    'font',
    'fontFamily',
    'fontFeatureSettings',
    'fontKerning',
    'fontLanguageOverride',
    'fontSize',
    'fontSizeAdjust',
    'fontStretch',
    'fontStyle',
    'fontVariant',
    'fontVariantAlternates',
    'fontVariantCaps',
    'fontVariantEastAsian',
    'fontVariantNumeric',
    'fontVariantPosition',
    'fontWeight',
    'fontVariationSettings',
    'fontSynthesis',
    'forcedColorAdjust',
    'gap',
    'grid',
    'gridArea',
    'gridAutoColumns',
    'gridAutoFlow',
    'gridAutoRows',
    'gridColumn',
    'gridColumnEnd',
    'gridColumnGap',
    'gridColumnStart',
    'gridGap',
    'gridRow',
    'gridRowEnd',
    'gridRowGap',
    'gridRowStart',
    'gridTemplate',
    'gridTemplateAreas',
    'gridTemplateColumns',
    'gridTemplateRows',
    'height',
    'hyphens',
    'imageOrientation',
    'imageRendering',
    'imeMode',
    'inset',
    'insetBlock',
    'insetBlockEnd',
    'insetBlockStart',
    'insetInline',
    'insetInlineEnd',
    'insetInlineStart',
    'initialLetter',
    'isolation',
    'justifyContent',
    'justifyItems',
    'justifySelf',
    'left',
    'letterSpacing',
    'lineBreak',
    'lineClamp',
    'lineHeight',
    'listStyle',
    'listStyleImage',
    'listStylePosition',
    'listStyleType',
    'margin',
    'marginBottom',
    'marginLeft',
    'marginRight',
    'marginTop',
    'marginBlock',
    'marginBlockEnd',
    'marginBlockStart',
    'marginInline',
    'marginInlineEnd',
    'marginInlineStart',
    'mask',
    'maskBorder',
    'maskBorderImage',
    'maskBorderOutset',
    'maskBorderRepeat',
    'maskBorderSlice',
    'maskBorderSource',
    'maskBorderWidth',
    'maskClip',
    'maskComposite',
    'maskImage',
    'maskOrigin',
    'maskPosition',
    'maskRepeat',
    'maskSize',
    'maskType',
    'maxBlockSize',
    'maxHeight',
    'maxInlineSize',
    'maxWidth',
    'minBlockSize',
    'minHeight',
    'minInlineSize',
    'minWidth',
    'mixBlendMode',
    'objectFit',
    'objectPosition',
    'objectViewBox',
    'offset',
    'offsetDistance',
    'offsetPath',
    'offsetRotate',
    'opacity',
    'order',
    'orientation',
    'outline',
    'outlineColor',
    'outlineOffset',
    'outlineStyle',
    'outlineWidth',
    'overflow',
    'overflowAnchor',
    'overflowClip',
    'overflowScrolling',
    'overflowWrap',
    'overflowX',
    'overflowY',
    'padding',
    'paddingBottom',
    'paddingLeft',
    'paddingRight',
    'paddingTop',
    'pageBreakAfter',
    'pageBreakBefore',
    'pageBreakInside',
    'paintOrder',
    'perspective',
    'perspectiveOrigin',
    'placeContent',
    'placeItems',
    'placeSelf',
    'pointerEvents',
    'position',
    'resize',
    'right',
    'rotate',
    'rowGap',
    'scrollBehavior',
    'scrollPadding',
    'scrollSnapAlign',
    'scrollSnapType',
    'scrollbarColor',
    'scrollbarWidth',
    'shapeImageThreshold',
    'shapeMargin',
    'shapeOutside',
    'tabSize',
    'tableLayout',
    'textAlign',
    'textAlignLast',
    'textDecoration',
    'textDecorationColor',
    'textDecorationLine',
    'textDecorationSkipInk',
    'textDecorationStyle',
    'textDecorationThickness',
    'textIndent',
    'textOverflow',
    'textShadow',
    'textTransform',
    'textUnderlineOffset',
    'top',
    'transform',
    'transformOrigin',
    'transformStyle',
    'transition',
    'transitionDelay',
    'transitionDuration',
    'transitionProperty',
    'transitionTimingFunction',
    'translate',
    'translateX',
    'translateY',
    'translateZ',
    'unicodeBidi',
    'userSelect',
    'verticalAlign',
    'visibility',
    'whiteSpace',
    'widows',
    'width',
    'willChange',
    'wordBreak',
    'wordSpacing',
    'wordWrap',
    'writingMode',
    'zIndex'
]);

});

parcelRegister("inO1F", function(module, exports) {

$parcel$export(module.exports, "ARIA_ROLES", () => $d6212e11970c8083$export$147ca7d289c2f7de);
$parcel$export(module.exports, "HTML_ATTRIBUTES", () => $d6212e11970c8083$export$a073516cf3506ae6);
$parcel$export(module.exports, "DOM_EVENTS", () => $d6212e11970c8083$export$f552dbb36ef6b3dd);
$parcel$export(module.exports, "checkAttributeByTagName", () => $d6212e11970c8083$export$3c670b34323f5417);
$parcel$export(module.exports, "checkEventFunctions", () => $d6212e11970c8083$export$12ab4f1a89970119);
$parcel$export(module.exports, "filterAttributesByTagName", () => $d6212e11970c8083$export$a3d5d5e1a17535c6);
$parcel$export(module.exports, "executeAttr", () => $d6212e11970c8083$export$a420285f97b772db);
$parcel$export(module.exports, "resolvePropValue", () => $d6212e11970c8083$export$ba06f8f07b4aa3a7);
$parcel$export(module.exports, "resolveFileSource", () => $d6212e11970c8083$export$23bb89b45c65692a);
$parcel$export(module.exports, "ATTR_TRANSFORMS", () => $d6212e11970c8083$export$a73e91daa9bedc56);
$parcel$export(module.exports, "applyAttrTransforms", () => $d6212e11970c8083$export$5ff0ab856938124a);
$parcel$export(module.exports, "extractConditionalAttrs", () => $d6212e11970c8083$export$b4ae0fde1522e964);
parcelRequire("2oe0q");
var $fX7ii = parcelRequire("fX7ii");
'use strict';
const $d6212e11970c8083$export$147ca7d289c2f7de = [
    'alert',
    'alertdialog',
    'application',
    'article',
    'banner',
    'button',
    'cell',
    'checkbox',
    'columnheader',
    'combobox',
    'complementary',
    'contentinfo',
    'definition',
    'dialog',
    'directory',
    'document',
    'feed',
    'figure',
    'form',
    'grid',
    'gridcell',
    'group',
    'heading',
    'img',
    'link',
    'list',
    'listbox',
    'listitem',
    'log',
    'main',
    'marquee',
    'math',
    'menu',
    'menubar',
    'menuitem',
    'menuitemcheckbox',
    'menuitemradio',
    'navigation',
    'none',
    'note',
    'option',
    'presentation',
    'progressbar',
    'radio',
    'radiogroup',
    'region',
    'row',
    'rowgroup',
    'rowheader',
    'scrollbar',
    'search',
    'searchbox',
    'separator',
    'slider',
    'spinbutton',
    'status',
    'switch',
    'tab',
    'table',
    'tablist',
    'tabpanel',
    'term',
    'textbox',
    'timer',
    'toolbar',
    'tooltip',
    'tree',
    'treegrid',
    'treeitem'
];
const $d6212e11970c8083$export$a073516cf3506ae6 = {
    default: [
        'accesskey',
        'autofocus',
        'class',
        'contenteditable',
        'contextmenu',
        'dir',
        'draggable',
        'hidden',
        'id',
        'lang',
        'part',
        'placeholder',
        'slot',
        'spellcheck',
        'style',
        'tabindex',
        'title',
        'translate',
        'inert',
        'radiogroup',
        'role',
        'about',
        'datatype',
        'inlist',
        'prefix',
        'property',
        'resource',
        'typeof',
        'vocab',
        'autocapitalize',
        'autocorrect',
        'autosave',
        'color',
        'itemprop',
        'itemscope',
        'itemtype',
        'itemid',
        'itemref',
        'results',
        'security',
        'unselectable',
        'is'
    ],
    a: [
        'accesskey',
        'charset',
        'coords',
        'download',
        'href',
        'hreflang',
        'name',
        'rel',
        'rev',
        'shape',
        'target',
        'type'
    ],
    aria: [
        'aria-activedescendant',
        'aria-atomic',
        'aria-autocomplete',
        'aria-checked',
        'aria-colcount',
        'aria-colindex',
        'aria-colspan',
        'aria-controls',
        'aria-current',
        'aria-describedby',
        'aria-details',
        'aria-dropeffect',
        'aria-errormessage',
        'aria-expanded',
        'aria-flowto',
        'aria-grabbed',
        'aria-haspopup',
        'aria-hidden',
        'aria-invalid',
        'aria-keyshortcuts',
        'aria-label',
        'aria-labelledby',
        'aria-level',
        'aria-live',
        'aria-modal',
        'aria-multiline',
        'aria-multiselectable',
        'aria-orientation',
        'aria-owns',
        'aria-placeholder',
        'aria-posinset',
        'aria-pressed',
        'aria-readonly',
        'aria-relevant',
        'aria-required',
        'aria-roledescription',
        'aria-rowcount',
        'aria-rowindex',
        'aria-rowspan',
        'aria-selected',
        'aria-setsize',
        'aria-sort',
        'aria-valuemax',
        'aria-valuemin',
        'aria-valuenow',
        'aria-valuetext'
    ],
    anchor: [
        'download',
        'href',
        'hreflang',
        'media',
        'ping',
        'rel',
        'target',
        'type',
        'referrerpolicy'
    ],
    audio: [
        'autoplay',
        'controls',
        'crossorigin',
        'loop',
        'muted',
        'preload',
        'src'
    ],
    area: [
        'alt',
        'coords',
        'download',
        'href',
        'hreflang',
        'media',
        'referrerpolicy',
        'rel',
        'shape',
        'target',
        'ping'
    ],
    base: [
        'href',
        'target'
    ],
    blockquote: [
        'cite'
    ],
    button: [
        'disabled',
        'form',
        'formaction',
        'formenctype',
        'formmethod',
        'formnovalidate',
        'formtarget',
        'name',
        'type',
        'value'
    ],
    canvas: [
        'height',
        'width'
    ],
    col: [
        'span',
        'width'
    ],
    colgroup: [
        'span'
    ],
    data: [
        'value'
    ],
    details: [
        'open'
    ],
    del: [
        'cite',
        'datetime'
    ],
    dialog: [
        'open'
    ],
    embed: [
        'height',
        'src',
        'type',
        'width'
    ],
    fieldset: [
        'disabled',
        'form',
        'name'
    ],
    form: [
        'acceptcharset',
        'action',
        'autocomplete',
        'enctype',
        'method',
        'name',
        'novalidate',
        'target',
        'rel'
    ],
    html: [
        'manifest'
    ],
    iframe: [
        'allow',
        'allowfullscreen',
        'allowtransparency',
        'frameborder',
        'height',
        'loading',
        'marginheight',
        'marginwidth',
        'mozallowfullscreen',
        'name',
        'referrerpolicy',
        'sandbox',
        'scrolling',
        'seamless',
        'src',
        'srcdoc',
        'webkitallowfullscreen',
        'width'
    ],
    img: [
        'alt',
        'crossorigin',
        'decoding',
        'height',
        'ismap',
        'loading',
        'referrerpolicy',
        'sizes',
        'src',
        'srcset',
        'usemap',
        'width'
    ],
    ins: [
        'cite',
        'datetime'
    ],
    input: [
        'accept',
        'alt',
        'autocomplete',
        'capture',
        'checked',
        'crossorigin',
        'disabled',
        'form',
        'formaction',
        'formenctype',
        'formmethod',
        'formnovalidate',
        'formtarget',
        'height',
        'indeterminate',
        'list',
        'max',
        'maxlength',
        'min',
        'minlength',
        'multiple',
        'name',
        'pattern',
        'placeholder',
        'readonly',
        'required',
        'size',
        'src',
        'step',
        'type',
        'value',
        'width'
    ],
    keygen: [
        'challenge',
        'disabled',
        'form',
        'keytype',
        'keyparams',
        'name'
    ],
    label: [
        'form',
        'for'
    ],
    li: [
        'value'
    ],
    link: [
        'as',
        'crossorigin',
        'href',
        'hreflang',
        'integrity',
        'media',
        'imagesrcset',
        'imagesizes',
        'referrerpolicy',
        'rel',
        'sizes',
        'type',
        'charset'
    ],
    map: [
        'name'
    ],
    menu: [
        'type'
    ],
    media: [
        'autoplay',
        'controls',
        'currenttime',
        'defaultmuted',
        'defaultplaybackrate',
        'loop',
        'mediagroup',
        'muted',
        'playsinline',
        'preload',
        'src',
        'volume'
    ],
    meta: [
        'charset',
        'content',
        'http-equiv',
        'name',
        'media'
    ],
    meter: [
        'form',
        'high',
        'low',
        'max',
        'min',
        'optimum',
        'value'
    ],
    quote: [
        'cite'
    ],
    object: [
        'classid',
        'data',
        'form',
        'height',
        'name',
        'type',
        'usemap',
        'width',
        'wmode'
    ],
    ol: [
        'reversed',
        'start',
        'type'
    ],
    optgroup: [
        'disabled',
        'label'
    ],
    option: [
        'disabled',
        'label',
        'selected',
        'value'
    ],
    output: [
        'form',
        'for',
        'name'
    ],
    param: [
        'name',
        'value'
    ],
    progress: [
        'max',
        'value'
    ],
    slot: [
        'name'
    ],
    script: [
        'async',
        'charset',
        'crossorigin',
        'defer',
        'integrity',
        'nomodule',
        'nonce',
        'referrerpolicy',
        'src',
        'type'
    ],
    select: [
        'autocomplete',
        'disabled',
        'form',
        'multiple',
        'name',
        'required',
        'size',
        'value',
        'onchange'
    ],
    source: [
        'height',
        'media',
        'sizes',
        'src',
        'srcset',
        'type',
        'width'
    ],
    style: [
        'media',
        'nonce',
        'scoped',
        'type'
    ],
    table: [
        'align',
        'bgcolor',
        'border',
        'cellpadding',
        'cellspacing',
        'frame',
        'rules',
        'summary',
        'width'
    ],
    textarea: [
        'autocomplete',
        'cols',
        'dirname',
        'disabled',
        'form',
        'maxlength',
        'minlength',
        'name',
        'placeholder',
        'readonly',
        'required',
        'rows',
        'value',
        'wrap'
    ],
    td: [
        'align',
        'colspan',
        'headers',
        'rowspan',
        'scope',
        'abbr',
        'height',
        'width',
        'valign'
    ],
    th: [
        'align',
        'colspan',
        'headers',
        'rowspan',
        'scope',
        'abbr'
    ],
    time: [
        'datetime'
    ],
    track: [
        'default',
        'kind',
        'label',
        'src',
        'srclang'
    ],
    video: [
        'autoplay',
        'controls',
        'crossorigin',
        'disablepictureinpicture',
        'disableremoteplayback',
        'height',
        'loop',
        'muted',
        'playsinline',
        'poster',
        'preload',
        'src',
        'width'
    ],
    svg: [
        'className',
        'class',
        'color',
        'height',
        'id',
        'lang',
        'max',
        'media',
        'method',
        'min',
        'name',
        'style',
        'target',
        'type',
        'width',
        // Other HTML properties supported by SVG elements in browsers
        'role',
        'tabindex',
        'crossorigin',
        // SVG Specific attributes
        'accent-height',
        'accumulate',
        'additive',
        'alignment-baseline',
        'allowReorder',
        'alphabetic',
        'amplitude',
        'arabic-form',
        'ascent',
        'attributeName',
        'attributeType',
        'autoReverse',
        'azimuth',
        'baseFrequency',
        'baseline-shift',
        'baseProfile',
        'bbox',
        'begin',
        'bias',
        'by',
        'calcMode',
        'cap-height',
        'clip',
        'clip-path',
        'clipPathUnits',
        'clip-rule',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'contentScriptType',
        'contentStyleType',
        'cursor',
        'cx',
        'cy',
        'd',
        'decelerate',
        'descent',
        'diffuseConstant',
        'direction',
        'display',
        'divisor',
        'dominant-baseline',
        'dur',
        'dx',
        'dy',
        'edgeMode',
        'elevation',
        'enable-background',
        'end',
        'exponent',
        'externalResourcesRequired',
        'fill',
        'fill-opacity',
        'fill-rule',
        'filter',
        'filterRes',
        'filterUnits',
        'flood-color',
        'flood-opacity',
        'focusable',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'format',
        'from',
        'fx',
        'fy',
        'g1',
        'g2',
        'glyph-name',
        'glyph-orientation-horizontal',
        'glyph-orientation-vertical',
        'glyphRef',
        'gradientTransform',
        'gradientUnits',
        'hanging',
        'href',
        'horiz-adv-x',
        'horiz-origin-x',
        'ideographic',
        'image-rendering',
        'in2',
        'in',
        'intercept',
        'k1',
        'k2',
        'k3',
        'k4',
        'k',
        'kernelMatrix',
        'kernelUnitLength',
        'kerning',
        'keyPoints',
        'keySplines',
        'keyTimes',
        'lengthAdjust',
        'letter-spacing',
        'lighting-color',
        'limitingConeAngle',
        'local',
        'marker-end',
        'markerHeight',
        'marker-mid',
        'marker-start',
        'markerUnits',
        'markerWidth',
        'mask',
        'maskContentUnits',
        'maskUnits',
        'mathematical',
        'mode',
        'numOctaves',
        'offset',
        'opacity',
        'operator',
        'order',
        'orient',
        'orientation',
        'origin',
        'overflow',
        'overline-position',
        'overline-thickness',
        'paint-order',
        'panose-1',
        'path',
        'pathLength',
        'patternContentUnits',
        'patternTransform',
        'patternUnits',
        'pointer-events',
        'points',
        'pointsAtX',
        'pointsAtY',
        'pointsAtZ',
        'preserveAlpha',
        'preserveAspectRatio',
        'primitiveUnits',
        'r',
        'radius',
        'refX',
        'refY',
        'rendering-intent',
        'repeatCount',
        'repeatDur',
        'requiredExtensions',
        'requiredFeatures',
        'restart',
        'result',
        'rotate',
        'rx',
        'ry',
        'scale',
        'seed',
        'shape-rendering',
        'slope',
        'spacing',
        'specularConstant',
        'specularExponent',
        'speed',
        'spreadMethod',
        'startOffset',
        'stdDeviation',
        'stemh',
        'stemv',
        'stitchTiles',
        'stop-color',
        'stop-opacity',
        'strikethrough-position',
        'strikethrough-thickness',
        'string',
        'stroke',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke-width',
        'surfaceScale',
        'systemLanguage',
        'tableValues',
        'targetX',
        'targetY',
        'text-anchor',
        'text-decoration',
        'textLength',
        'text-rendering',
        'to',
        'transform',
        'u1',
        'u2',
        'underline-position',
        'underline-thickness',
        'unicode',
        'unicode-bidi',
        'unicode-range',
        'units-per-em',
        'v-alphabetic',
        'values',
        'vector-effect',
        'version',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'v-hanging',
        'v-ideographic',
        'viewBox',
        'viewTarget',
        'visibility',
        'v-mathematical',
        'widths',
        'word-spacing',
        'writing-mode',
        'x1',
        'x2',
        'x',
        'xChannelSelector',
        'x-height',
        'xlink:actuate',
        'xlink:arcrole',
        'xlink:href',
        'xlink:role',
        'xlink:show',
        'xlink:title',
        'xlink:type',
        'xml:base',
        'xml:lang',
        'xmlns',
        'xmlns:xlink',
        'xml:space',
        'y1',
        'y2',
        'y',
        'yChannelSelector',
        'z',
        'zoomAndPan'
    ]
};
const $d6212e11970c8083$export$f552dbb36ef6b3dd = [
    // Clipboard Events
    'oncopy',
    'oncut',
    'onpaste',
    // Composition Events
    'oncompositionend',
    'oncompositionstart',
    'oncompositionupdate',
    // Focus Events
    'onfocus',
    'onfocusin',
    'onfocusout',
    'onblur',
    // Form Events
    'onchange',
    'onbeforeinput',
    'oninput',
    'onreset',
    'onsubmit',
    'oninvalid',
    'onformdata',
    // Image Events
    'onload',
    'onerror',
    // Detail Events
    'ontoggle',
    // Keyboard Events
    'onkeydown',
    'onkeypress',
    'onkeyup',
    // Media Events
    'onabort',
    'oncanplay',
    'oncanplaythrough',
    'oncuechange',
    'ondurationchange',
    'onemptied',
    'onencrypted',
    'onended',
    'onloadeddata',
    'onloadedmetadata',
    'onloadstart',
    'onpause',
    'onplay',
    'onplaying',
    'onprogress',
    'onratechange',
    'onseeked',
    'onseeking',
    'onstalled',
    'onsuspend',
    'ontimeupdate',
    'onvolumechange',
    'onwaiting',
    // MouseEvents
    'onauxclick',
    'onclick',
    'oncontextmenu',
    'ondblclick',
    'ondrag',
    'ondragend',
    'ondragenter',
    'ondragexit',
    'ondragleave',
    'ondragover',
    'ondragstart',
    'ondrop',
    'onmousedown',
    'onmouseenter',
    'onmouseleave',
    'onmousemove',
    'onmouseout',
    'onmouseover',
    'onmouseup',
    // Selection Events
    'onselect',
    'onselectionchange',
    'onselectstart',
    // Touch Events
    'ontouchcancel',
    'ontouchend',
    'ontouchmove',
    'ontouchstart',
    // Pointer Events
    'ongotpointercapture',
    'onpointercancel',
    'onpointerdown',
    'onpointerenter',
    'onpointerleave',
    'onpointermove',
    'onpointerout',
    'onpointerover',
    'onpointerup',
    'onlostpointercapture',
    // UI Events
    'onscroll',
    'onresize',
    // Wheel Events
    'onwheel',
    // Animation Events
    'onanimationstart',
    'onanimationend',
    'onanimationiteration',
    // Transition Events
    'ontransitionstart',
    'ontransitionrun',
    'ontransitionend',
    'ontransitioncancel',
    // Svelte Transition Events
    'onoutrostart',
    'onoutroend',
    'onintrostart',
    'onintroend',
    // Message Events
    'onmessage',
    'onmessageerror',
    // Document Events
    'onvisibilitychange',
    // Global Events
    'oncancel',
    'onclose',
    'onfullscreenchange',
    'onfullscreenerror'
];
// Convert camelCase aria/data attrs to kebab-case: ariaLabel → aria-label, dataTestId → data-test-id
const $d6212e11970c8083$var$camelToAttr = (key)=>{
    if (key.startsWith('aria') && key.length > 4 && key.charCodeAt(4) >= 65 && key.charCodeAt(4) <= 90) return 'aria-' + key.charAt(4).toLowerCase() + key.slice(5).replace(/([A-Z])/g, (m)=>'-' + m.toLowerCase());
    if (key.startsWith('data') && key.length > 4 && key.charCodeAt(4) >= 65 && key.charCodeAt(4) <= 90) return 'data-' + key.charAt(4).toLowerCase() + key.slice(5).replace(/([A-Z])/g, (m)=>'-' + m.toLowerCase());
    return null;
};
const $d6212e11970c8083$export$3c670b34323f5417 = (tag, attribute)=>{
    // aria-* and data-* are valid on all elements
    if (attribute.startsWith('aria-') || attribute.startsWith('data-')) return true;
    // camelCase aria/data attrs
    if ($d6212e11970c8083$var$camelToAttr(attribute)) return true;
    if (Object.prototype.hasOwnProperty.call($d6212e11970c8083$export$a073516cf3506ae6, tag)) {
        const attributes = $d6212e11970c8083$export$a073516cf3506ae6[tag];
        return attributes.includes(attribute) || attributes.includes('default');
    } else {
        const defaultAttributes = $d6212e11970c8083$export$a073516cf3506ae6.default;
        return defaultAttributes.includes(attribute);
    }
};
const $d6212e11970c8083$export$12ab4f1a89970119 = (key)=>{
    if (!(0, $fX7ii.isString)(key)) return false;
    const normalizedKey = key.toLowerCase();
    return $d6212e11970c8083$export$f552dbb36ef6b3dd.includes(normalizedKey);
};
const $d6212e11970c8083$export$a3d5d5e1a17535c6 = (tag, props, cssProps)=>{
    const filteredObject = {};
    for(const key in props)if (Object.prototype.hasOwnProperty.call(props, key)) {
        if (cssProps && key in cssProps) continue;
        // aria: { label: 'foo', expanded: true } → aria-label, aria-expanded
        if (key === 'aria' && props[key] && typeof props[key] === 'object') {
            for(const ariaKey in props[key])if ((0, $fX7ii.isDefined)(props[key][ariaKey])) filteredObject['aria-' + ariaKey] = props[key][ariaKey];
            continue;
        }
        // data: { testId: 'foo' } → data-test-id
        if (key === 'data' && props[key] && typeof props[key] === 'object') {
            for(const dataKey in props[key])if ((0, $fX7ii.isDefined)(props[key][dataKey])) {
                const kebab = dataKey.replace(/([A-Z])/g, (m)=>'-' + m.toLowerCase());
                filteredObject['data-' + kebab] = props[key][dataKey];
            }
            continue;
        }
        const isAttribute = $d6212e11970c8083$export$3c670b34323f5417(tag, key);
        const isEvent = $d6212e11970c8083$export$12ab4f1a89970119(key);
        if ((0, $fX7ii.isDefined)(props[key]) && (isAttribute || isEvent)) {
            const attrName = $d6212e11970c8083$var$camelToAttr(key) || key;
            filteredObject[attrName] = props[key];
        }
    }
    return filteredObject;
};
const $d6212e11970c8083$export$a420285f97b772db = (elem, element)=>{
    const attrObj = {};
    if (elem.attr) for(const attrProp in elem.attr)attrObj[attrProp] = elem.attr[attrProp](element, element.state, element.context);
    return attrObj;
};
const $d6212e11970c8083$export$ba06f8f07b4aa3a7 = (el, value)=>{
    let resolved = el.call('exec', value, el);
    if (!resolved) return;
    if ((0, $fX7ii.isString)(resolved) && resolved.includes('{{')) resolved = el.call('replaceLiteralsWithObjectFields', resolved);
    return resolved;
};
const $d6212e11970c8083$export$23bb89b45c65692a = (el, value)=>{
    let src = (el.preSrc || '') + ($d6212e11970c8083$export$ba06f8f07b4aa3a7(el, value) || '');
    if (!src) return;
    try {
        new URL(src);
        return src;
    } catch (e) {} // absolute URL — passthrough
    const { context: context } = el;
    if (!context.files && !context.assets) return src;
    if (src.startsWith('/assets/')) {
        const key = src.slice(8);
        const asset = context.assets && (context.assets[src] || context.assets[key]);
        if (asset && asset.content) return asset.content.src;
        return src;
    }
    if (src.startsWith('/files/')) {
        const key = src.slice(7);
        const file = context.files && (context.files[src] || context.files[key]);
        if (file && file.content) return file.content.src;
        return src;
    }
    // Unprefixed: try assets first (newer system), then files.
    if (context.assets) {
        const asset = context.assets[src];
        if (asset && asset.content) return asset.content.src;
    }
    if (context.files) {
        const file = context.files[src];
        if (file && file.content) return file.content.src;
    }
    return src;
};
const $d6212e11970c8083$export$a73e91daa9bedc56 = {
    src: (el)=>$d6212e11970c8083$export$23bb89b45c65692a(el, el.src),
    href: (el)=>$d6212e11970c8083$export$ba06f8f07b4aa3a7(el, el.href),
    action: (el)=>$d6212e11970c8083$export$ba06f8f07b4aa3a7(el, el.action),
    poster: (el)=>$d6212e11970c8083$export$23bb89b45c65692a(el, el.poster),
    data: (el)=>$d6212e11970c8083$export$ba06f8f07b4aa3a7(el, el.data)
};
const $d6212e11970c8083$export$5ff0ab856938124a = (element)=>{
    const tag = element.tag || 'div';
    const result = {};
    for(const attr in $d6212e11970c8083$export$a73e91daa9bedc56)if (element[attr] !== undefined && $d6212e11970c8083$export$3c670b34323f5417(tag, attr)) {
        const val = $d6212e11970c8083$export$a73e91daa9bedc56[attr](element);
        if (val !== undefined) result[attr] = val;
    }
    return result;
};
/**
 * Resolve a case value from context.cases.
 * Returns true/false, or undefined if case is not defined.
 */ const $d6212e11970c8083$var$resolveCase = (caseKey, element)=>{
    const caseFn = element.context?.cases?.[caseKey];
    if (caseFn === undefined) return undefined;
    if ((0, $fX7ii.isFunction)(caseFn)) return caseFn.call(element, element);
    return !!caseFn;
};
/**
 * Evaluate whether a conditional prefix key is active.
 * Supports $ (global cases), . (truthy), ! (falsy) prefixes.
 */ const $d6212e11970c8083$var$evaluateCondition = (prefix, caseKey, element)=>{
    if (prefix === '$') {
        let result = $d6212e11970c8083$var$resolveCase(caseKey, element);
        if (result === undefined) result = !!element[caseKey];
        return result;
    }
    // . and ! prefixes: check element/state first, then context.cases
    let isTruthy = element[caseKey] === true || element.state[caseKey];
    if (!isTruthy) {
        const caseResult = $d6212e11970c8083$var$resolveCase(caseKey, element);
        if (caseResult !== undefined) isTruthy = caseResult;
    }
    return prefix === '.' ? !!isTruthy : !isTruthy;
};
const $d6212e11970c8083$var$CONDITIONAL_PREFIXES = new Set([
    '$',
    '.',
    '!'
]);
const $d6212e11970c8083$export$b4ae0fde1522e964 = (props, tag, cssProps)=>{
    const result = {};
    const addConditionalAttr = (attrName, attrVal, prefix, caseKey)=>{
        const capturedVal = attrVal;
        result[attrName] = (el)=>{
            if (!$d6212e11970c8083$var$evaluateCondition(prefix, caseKey, el)) return undefined;
            return (0, $fX7ii.isFunction)(capturedVal) ? capturedVal(el) : capturedVal;
        };
    };
    for(const key in props){
        const prefix = key.charAt(0);
        if (!$d6212e11970c8083$var$CONDITIONAL_PREFIXES.has(prefix)) continue;
        const block = props[key];
        if (!block || typeof block !== 'object') continue;
        const caseKey = key.slice(1);
        for(const attrKey in block){
            if (cssProps && attrKey in cssProps) continue;
            // aria: { label: 'foo' } inside conditional block
            if (attrKey === 'aria' && block[attrKey] && typeof block[attrKey] === 'object') {
                for(const ariaKey in block[attrKey])addConditionalAttr('aria-' + ariaKey, block[attrKey][ariaKey], prefix, caseKey);
                continue;
            }
            // data: { testId: 'foo' } inside conditional block
            if (attrKey === 'data' && block[attrKey] && typeof block[attrKey] === 'object') {
                for(const dataKey in block[attrKey]){
                    const kebab = dataKey.replace(/([A-Z])/g, (m)=>'-' + m.toLowerCase());
                    addConditionalAttr('data-' + kebab, block[attrKey][dataKey], prefix, caseKey);
                }
                continue;
            }
            const isAttribute = $d6212e11970c8083$export$3c670b34323f5417(tag, attrKey);
            const isEvent = $d6212e11970c8083$export$12ab4f1a89970119(attrKey);
            if (!isAttribute && !isEvent) continue;
            const attrName = $d6212e11970c8083$var$camelToAttr(attrKey) || attrKey;
            addConditionalAttr(attrName, block[attrKey], prefix, caseKey);
        }
    }
    return result;
};

});




parcelRegister("6g1vM", function(module, exports) {

var $goSkE = parcelRequire("goSkE");
$parcel$exportWildcard(module.exports, $goSkE);

});
parcelRegister("goSkE", function(module, exports) {

var $807O1 = parcelRequire("807O1");

var $dOoZ4 = parcelRequire("dOoZ4");

var $dXl0a = parcelRequire("dXl0a");

var $cThmB = parcelRequire("cThmB");
'use strict';
$parcel$exportWildcard(module.exports, $807O1);
$parcel$exportWildcard(module.exports, $dOoZ4);
$parcel$exportWildcard(module.exports, $dXl0a);
$parcel$exportWildcard(module.exports, $cThmB);

});
parcelRegister("807O1", function(module, exports) {

var $8zqnY = parcelRequire("8zqnY");

var $aPvU2 = parcelRequire("aPvU2");
'use strict';
$parcel$exportWildcard(module.exports, $8zqnY);
$parcel$exportWildcard(module.exports, $aPvU2);

});
parcelRegister("8zqnY", function(module, exports) {

$parcel$export(module.exports, "usePropsAsCSS", () => $63d60f3ddb4ddbf7$export$e3ea26d70189bf39);
$parcel$export(module.exports, "useSelectorsAsCSS", () => $63d60f3ddb4ddbf7$export$274ca54883f83b56);
$parcel$export(module.exports, "useCssInProps", () => $63d60f3ddb4ddbf7$export$42e1543b9cdeac7c);
$parcel$export(module.exports, "exetuteClassPerComponent", () => $63d60f3ddb4ddbf7$export$2d3867789701917d);
parcelRequire("2oe0q");
var $bmfNh = parcelRequire("bmfNh");
var $fX7ii = parcelRequire("fX7ii");
var $kt4aQ = parcelRequire("kt4aQ");
parcelRequire("aTPvW");
var $7KiQp = parcelRequire("7KiQp");

var $dXl0a = parcelRequire("dXl0a");

var $cThmB = parcelRequire("cThmB");

var $aPvU2 = parcelRequire("aPvU2");
'use strict';
/**
 * CLASS ASSIGNMENT
 * Main handlers for processing and assigning classes
 */ const $63d60f3ddb4ddbf7$var$isProd = (0, $kt4aQ.isProduction)();
const $63d60f3ddb4ddbf7$export$e3ea26d70189bf39 = (sourceObj, element, opts)=>{
    const ds = element?.context?.designSystem;
    if (ds) (0, $7KiQp.pushConfig)(ds);
    try {
        let obj = {};
        const rest = {};
        const setToObj = (key, val)=>{
            if (opts.unpack) {
                obj = {
                    ...obj,
                    ...val
                };
                return;
            }
            obj[key] = val;
        };
        for(const key in sourceObj){
            const value = sourceObj[key];
            if (key === 'class' && element.call('isString', sourceObj.class)) {
                const val = value.split(' ');
                if (val.length) {
                    const CLASS = element.context.designSystem.class;
                    const result = val.reduce((acc, curr)=>(0, $bmfNh.merge)(acc, CLASS[curr]), {});
                    obj.designSystemClass = result;
                }
            } else if (key === 'true') {
                const val = (0, $bmfNh.exec)(value, element);
                (0, $bmfNh.merge)(obj, (0, $aPvU2.applyTrueProps)(val, element));
            } else if (element.classlist[key]) {
                const originalFromClass = element.classlist[key];
                const result = (0, $fX7ii.isFunction)(originalFromClass) ? originalFromClass(element, element.state, element.context) : originalFromClass;
                if (result) setToObj(key, result);
                if (!$63d60f3ddb4ddbf7$var$isProd && (0, $fX7ii.isObject)(obj[key])) obj[key].label = key;
            } else if ((0, $dXl0a.CSS_PROPS_REGISTRY)[key]) {
                let val = (0, $bmfNh.exec)(value, element);
                if ((0, $fX7ii.isArray)(val)) val = val.reduce((a, c)=>(0, $bmfNh.merge)(a, c), {});
                let result = (0, $dXl0a.CSS_PROPS_REGISTRY)[key](val, element, element.state, element.context);
                if ((0, $fX7ii.isArray)(result)) result = result.reduce((a, c)=>(0, $bmfNh.merge)(a, c), {});
                if (result) setToObj(key, result);
                if (!$63d60f3ddb4ddbf7$var$isProd && (0, $fX7ii.isObject)(obj[key])) obj[key].label = key;
            } else if ((0, $cThmB.DEFAULT_CSS_PROPERTIES_LIST).has(key)) {
                // they can be grouped
                let result = (0, $bmfNh.exec)(value, element);
                if (typeof result === 'string' && result.charCodeAt(0) === 45 && result.charCodeAt(1) === 45) result = `var(${result})`;
                setToObj(key, {
                    [key]: result
                });
                if (!$63d60f3ddb4ddbf7$var$isProd && (0, $fX7ii.isObject)(obj[key])) obj[key].label = key;
            } else rest[key] = value;
        }
        return [
            obj,
            rest
        ];
    } finally{
        if (ds) (0, $7KiQp.popConfig)();
    }
};
const $63d60f3ddb4ddbf7$export$274ca54883f83b56 = (sourceObj, element)=>{
    const obj = {};
    for(const key in sourceObj){
        const selectroSetter = (0, $aPvU2.transformersByPrefix)[key.slice(0, 1)];
        if (selectroSetter) {
            const result = selectroSetter(key, sourceObj[key], element);
            if (result) {
                for(const k in result)if (Object.prototype.hasOwnProperty.call(result, k)) {
                    if (obj[k] && typeof obj[k] === 'object' && typeof result[k] === 'object') (0, $bmfNh.overwriteDeep)(obj[k], result[k]);
                    else obj[k] = result[k];
                }
            }
        }
    }
    return obj;
};
const $63d60f3ddb4ddbf7$export$42e1543b9cdeac7c = (selectorProps, element, opts = {
    unpack: true
})=>{
    const [cssObj, restProps] = $63d60f3ddb4ddbf7$export$e3ea26d70189bf39(selectorProps, element, opts);
    const selectorsObj = $63d60f3ddb4ddbf7$export$274ca54883f83b56(restProps, element);
    let hasSelectors = false;
    for(const _k in selectorsObj){
        hasSelectors = true;
        break;
    } // eslint-disable-line
    if (hasSelectors) {
        if (opts.unpack) return (0, $bmfNh.overwrite)(cssObj, selectorsObj);
        cssObj._selectors = selectorsObj;
    }
    return cssObj;
};
const $63d60f3ddb4ddbf7$export$2d3867789701917d = (component, element)=>{
    const classObj = {};
    if (component.class) for(const classProp in component.class)classObj[classProp] = component.class[classProp](element);
    return classObj;
};

});
parcelRegister("aPvU2", function(module, exports) {

$parcel$export(module.exports, "applyTrueProps", () => $7e276a0cde742f82$export$c25acf0b55f6ed94);
$parcel$export(module.exports, "transformersByPrefix", () => $7e276a0cde742f82$export$f635b795713db31b);
parcelRequire("2oe0q");
var $fX7ii = parcelRequire("fX7ii");

var $8zqnY = parcelRequire("8zqnY");
'use strict';
/**
 * PROP APPLICATORS
 * Functions that handle different types of property applications
 */ // Match `[data-theme="dark"]` / `[data-theme='light']` with either quote
// style, grabbing the scheme name (`dark` / `light` / custom) for pairing
// with `prefers-color-scheme`.
const $7e276a0cde742f82$var$DATA_THEME_RE = /^\[data-theme=(?:"([^"]+)"|'([^']+)')\]$/;
// Media query handler
const $7e276a0cde742f82$var$applyMediaProps = (key, selectorProps, element)=>{
    const { context: context } = element;
    if (!context.designSystem?.media) return;
    const schemeKey = key.slice(1);
    const mediaValue = context.designSystem.media[schemeKey];
    const generatedClass = (0, $8zqnY.useCssInProps)(selectorProps, element);
    if (!mediaValue) return {
        [key]: generatedClass
    };
    if (mediaValue === 'print') return {
        '@media print': generatedClass
    };
    if (mediaValue[0] === '(') return {
        [`@media screen and ${mediaValue}`]: generatedClass
    };
    // CSS selector (e.g. `[data-theme="dark"]`). Always emit the selector
    // rule so explicit `data-theme="dark"` wins. For the standard `dark` /
    // `light` schemes, ALSO emit a `@media (prefers-color-scheme: X)`
    // fallback so the component adopts the OS scheme when `data-theme` is
    // absent (i.e. `globalTheme: 'auto'`). Guard the fallback with
    // `:not([data-theme])` on the app scope root so an explicit
    // `data-theme="light"` (stamped on the app root) forces light even when
    // the OS prefers dark. Other schemes (`sepia`, custom) are opt-in only.
    const match = mediaValue.match($7e276a0cde742f82$var$DATA_THEME_RE);
    const scheme = match ? match[1] || match[2] : schemeKey;
    const result = {
        [`${mediaValue} &`]: generatedClass
    };
    if (scheme === 'dark' || scheme === 'light') {
        const scopeSelector = context.designSystem?.scopeSelector || ':root';
        const guard = scopeSelector === ':root' ? ':root:not([data-theme])' : `${scopeSelector}:not([data-theme])`;
        result[`@media (prefers-color-scheme: ${scheme})`] = {
            [`${guard} &`]: generatedClass
        };
    }
    return result;
};
// Simple applicators
const $7e276a0cde742f82$var$applyAndProps = (key, selectorProps, element)=>{
    return {
        [key]: (0, $8zqnY.useCssInProps)(selectorProps, element)
    };
};
const $7e276a0cde742f82$var$applySelectorProps = (key, selectorProps, element)=>{
    const selectorKey = `&${key}`;
    const resolved = (0, $8zqnY.useCssInProps)(selectorProps, element);
    // When the selector has commas and the resolved value contains nested selectors
    // (e.g. '> h1'), distribute each nested selector across all comma parts
    if (key.includes(',') && resolved) {
        const flat = {};
        const nested = {};
        for(const k in resolved)if (typeof resolved[k] === 'object' && resolved[k] !== null) nested[k] = resolved[k];
        else flat[k] = resolved[k];
        if (Object.keys(nested).length) {
            const parts = selectorKey.split(',').map((p)=>p.trim());
            const result = {};
            // Flat styles apply to the combined selector
            if (Object.keys(flat).length) result[selectorKey] = flat;
            // Each nested selector is distributed across all comma parts
            for(const nestedKey in nested){
                const distributed = parts.map((p)=>`${p} ${nestedKey}`).join(', ');
                result[distributed] = nested[nestedKey];
            }
            return result;
        }
    }
    return {
        [selectorKey]: resolved
    };
};
// Resolve a case value from context.cases
const $7e276a0cde742f82$var$resolveCase = (caseKey, element)=>{
    const caseFn = element.context?.cases?.[caseKey];
    if (caseFn === undefined) return undefined;
    if ((0, $fX7ii.isFunction)(caseFn)) return caseFn.call(element, element);
    return !!caseFn;
};
// $ prefix: Global cases from context.cases
const $7e276a0cde742f82$var$applyCaseProps = (key, selectorProps, element)=>{
    const caseKey = key.slice(1);
    let isCaseTrue = $7e276a0cde742f82$var$resolveCase(caseKey, element);
    if (isCaseTrue === undefined) isCaseTrue = !!element[caseKey];
    if (!isCaseTrue) return;
    return (0, $8zqnY.useCssInProps)(selectorProps, element);
};
const $7e276a0cde742f82$var$applyVariableProps = (key, selectorVal, element)=>{
    return {
        [key]: selectorVal
    };
};
// . prefix: Truthy conditional (element/state first, then context.cases)
const $7e276a0cde742f82$var$applyConditionalCaseProps = (key, selectorProps, element)=>{
    const caseKey = key.slice(1);
    let isCaseTrue = element[caseKey] === true || element.state?.[caseKey];
    if (!isCaseTrue) {
        if (typeof element[caseKey] === 'function') try {
            isCaseTrue = element[caseKey](element, element.state, element.context);
        } catch (e) {}
        else {
            const caseResult = $7e276a0cde742f82$var$resolveCase(caseKey, element);
            if (caseResult !== undefined) isCaseTrue = caseResult;
        }
    }
    if (!isCaseTrue) return;
    return (0, $8zqnY.useCssInProps)(selectorProps, element);
};
// ! prefix: Falsy conditional (element/state first, then context.cases)
const $7e276a0cde742f82$var$applyConditionalFalsyProps = (key, selectorProps, element)=>{
    const caseKey = key.slice(1);
    let isCaseTrue = element[caseKey] === true || element.state?.[caseKey];
    if (!isCaseTrue) {
        if (typeof element[caseKey] === 'function') try {
            isCaseTrue = element[caseKey](element, element.state, element.context);
        } catch (e) {}
        else {
            const caseResult = $7e276a0cde742f82$var$resolveCase(caseKey, element);
            if (caseResult !== undefined) isCaseTrue = caseResult;
        }
    }
    if (isCaseTrue) return;
    return (0, $8zqnY.useCssInProps)(selectorProps, element);
};
const $7e276a0cde742f82$export$c25acf0b55f6ed94 = (selectorProps, element)=>{
    return (0, $8zqnY.useCssInProps)(selectorProps, element);
};
const $7e276a0cde742f82$export$f635b795713db31b = {
    '@': $7e276a0cde742f82$var$applyMediaProps,
    // Selector handlers
    ':': $7e276a0cde742f82$var$applySelectorProps,
    '[': $7e276a0cde742f82$var$applySelectorProps,
    '*': $7e276a0cde742f82$var$applySelectorProps,
    '+': $7e276a0cde742f82$var$applySelectorProps,
    '~': $7e276a0cde742f82$var$applySelectorProps,
    '&': $7e276a0cde742f82$var$applyAndProps,
    '>': $7e276a0cde742f82$var$applyAndProps,
    // Conditional and variable handlers
    $: $7e276a0cde742f82$var$applyCaseProps,
    '-': $7e276a0cde742f82$var$applyVariableProps,
    '.': $7e276a0cde742f82$var$applyConditionalCaseProps,
    '!': $7e276a0cde742f82$var$applyConditionalFalsyProps
};

});



parcelRegister("dOoZ4", function(module, exports) {

$parcel$export(module.exports, "transformClassname", () => $a0e3532c8709a809$export$2b5b252eb866c647);
$parcel$export(module.exports, "setClassname", () => $a0e3532c8709a809$export$6241622f59b2c037);
parcelRequire("2oe0q");
var $fX7ii = parcelRequire("fX7ii");

var $8zqnY = parcelRequire("8zqnY");
parcelRequire("2Eo8m");
var $bd7kG = parcelRequire("bd7kG");
'use strict';
const $a0e3532c8709a809$export$2b5b252eb866c647 = (element)=>{
    if (!(0, $fX7ii.isObject)(element)) return;
    return (0, $8zqnY.useCssInProps)(element, element);
};
const $a0e3532c8709a809$export$6241622f59b2c037 = (props, cssEngine)=>{
    const transform = $a0e3532c8709a809$export$2b5b252eb866c647(props);
    if (typeof cssEngine === 'function') return cssEngine(transform);
    return (0, $bd7kG.css)(transform);
};

});



parcelRegister("9Ri24", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "DEFAULT_CONFIG", () => $72d70d264f1ca449$export$c2f8e0cc249a8d8f);
$parcel$export(module.exports, "default", () => $72d70d264f1ca449$export$2e2bcd8739ae039);

var $iHumr = parcelRequire("iHumr");

var $ghg1D = parcelRequire("ghg1D");

var $crow1 = parcelRequire("crow1");

var $dSazo = parcelRequire("dSazo");

var $3zv73 = parcelRequire("3zv73");

var $bFT1z = parcelRequire("bFT1z");

var $6iNFR = parcelRequire("6iNFR");
'use strict';
const $72d70d264f1ca449$export$c2f8e0cc249a8d8f = {
    version: '0.0.1',
    color: $iHumr.color,
    gradient: $iHumr.gradient,
    theme: $ghg1D.theme,
    typography: $crow1.typography,
    spacing: $dSazo.spacing,
    font: $3zv73.font,
    fontFamily: $3zv73.fontFamily,
    timing: $6iNFR.timing,
    media: $bFT1z.media,
    reset: {
        html: {},
        body: {}
    },
    animation: {
        fadeIn: {
            from: {
                opacity: 0
            },
            to: {
                opacity: 1
            }
        }
    },
    devices: {},
    class: {},
    svg: {},
    grid: {},
    shape: {}
};
var $72d70d264f1ca449$export$2e2bcd8739ae039 = $72d70d264f1ca449$export$c2f8e0cc249a8d8f;

});
parcelRegister("iHumr", function(module, exports) {

$parcel$export(module.exports, "color", () => $d9d3cb30dba31610$export$35e9368ef982300f);
$parcel$export(module.exports, "gradient", () => $d9d3cb30dba31610$export$f7d09cddc76f277f);
'use strict';
const $d9d3cb30dba31610$export$35e9368ef982300f = {
    transparent: 'rgba(0, 0, 0, 0)',
    black: 'black',
    white: 'white',
    title: [
        '--gray 1 -168',
        '--gray 1 +168'
    ],
    caption: [
        '--gray 1 -68',
        '--gray 1 +68'
    ],
    paragraph: [
        '--gray 1 -42',
        '--gray 1 +42'
    ],
    disabled: [
        '--gray 1 -26',
        '--gray 1 +26'
    ],
    line: [
        '--gray 1 -16',
        '--gray 1 +16'
    ]
};
const $d9d3cb30dba31610$export$f7d09cddc76f277f = {};

});

parcelRegister("ghg1D", function(module, exports) {

$parcel$export(module.exports, "theme", () => $bd9aaa3080f586ac$export$bca14c5b3b88a9c9);
'use strict';
const $bd9aaa3080f586ac$var$PRIORITIES = {
    primary: {
        '@dark': {
            color: 'white',
            background: 'blue'
        },
        '@light': {
            color: 'white',
            background: 'gradient-blue'
        }
    },
    secondary: {
        '@dark': {
            color: 'white',
            background: 'gray'
        },
        '@light': {
            color: 'white',
            background: 'gray'
        }
    },
    tertiary: {
        '@dark': {
            color: 'white',
            background: 'gray.92+8'
        },
        '@light': {
            background: 'gray.1'
        }
    },
    quaternary: {
        '@light': {
            color: 'white',
            background: 'gradient-light'
        },
        '@dark': {
            color: 'white',
            background: 'gradient-dark-active'
        }
    },
    quinary: {
        '@dark': {
            color: 'gray=90',
            background: 'gradient-light'
        },
        '@light': {
            color: 'gray3',
            background: 'gradient-dark'
        }
    }
};
const $bd9aaa3080f586ac$var$STATES = {
    alert: {
        '@dark': {
            color: 'white',
            background: 'red'
        }
    },
    warning: {
        '@dark': {
            color: 'black',
            background: 'yellow'
        }
    },
    success: {
        '@dark': {
            color: 'black',
            background: 'green'
        }
    }
};
const $bd9aaa3080f586ac$var$UI = {
    field: {
        '@light': {
            color: 'black',
            background: 'gray.975+144',
            borderColor: 'gray.975+144',
            '::placeholder': {
                color: 'gray-68'
            }
        },
        '@dark': {
            color: 'white',
            background: 'gray.975-52',
            borderColor: 'gray.975-52',
            '::placeholder': {
                color: 'gray+68'
            }
        }
    },
    label: {
        '@dark': {
            color: 'white',
            background: 'gray.92+8'
        },
        '@light': {
            background: 'gray.1'
        }
    },
    dialog: {
        '@dark': {
            color: 'white',
            background: 'gray.92'
        },
        '@light': {
            color: 'currentColor',
            background: 'gray.1'
        }
    }
};
const $bd9aaa3080f586ac$export$bca14c5b3b88a9c9 = {
    document: {
        '@light': {
            color: 'black',
            background: 'white'
        },
        '@dark': {
            color: 'white',
            background: 'black'
        }
    },
    ...$bd9aaa3080f586ac$var$PRIORITIES,
    ...$bd9aaa3080f586ac$var$STATES,
    ...$bd9aaa3080f586ac$var$UI,
    none: {
        color: 'none',
        background: 'none'
    },
    transparent: {
        color: 'currentColor',
        background: 'transparent'
    }
};

});

parcelRegister("crow1", function(module, exports) {

$parcel$export(module.exports, "typography", () => $90eb05e4d92ec449$export$d846a084e680d8e);
'use strict';
const $90eb05e4d92ec449$export$d846a084e680d8e = {
    base: 16,
    ratio: 1.25,
    subSequence: true,
    templates: {}
};

});

parcelRegister("dSazo", function(module, exports) {

$parcel$export(module.exports, "spacing", () => $a1988478e112e2f0$export$5458b64234d1333c);
'use strict';
const $a1988478e112e2f0$export$5458b64234d1333c = {
    ratio: 1.618,
    subSequence: true
};

});

parcelRegister("3zv73", function(module, exports) {

$parcel$export(module.exports, "font", () => $299cc65848d03d49$export$a74e2025f5286b02);
$parcel$export(module.exports, "fontFamily", () => $299cc65848d03d49$export$a5975749f0374264);
'use strict';
const $299cc65848d03d49$export$a74e2025f5286b02 = {};
const $299cc65848d03d49$export$a5975749f0374264 = {
    system: {
        value: [
            '"Helvetica Neue"',
            'Helvetica',
            'Arial'
        ],
        type: 'sans-serif'
    }
};

});

parcelRegister("bFT1z", function(module, exports) {

$parcel$export(module.exports, "media", () => $87fe34b74ee20786$export$987d49ffe1b0900f);
'use strict';
const $87fe34b74ee20786$export$987d49ffe1b0900f = {
    tv: '(min-width: 2780px)',
    screenL: '(max-width: 1920px)',
    'screenL<': '(min-width: 1920px)',
    screenM: '(max-width: 1680px)',
    'screenM<': '(min-width: 1680px)',
    screenS: '(max-width: 1440px)',
    'screenS<': '(min-width: 1440px)',
    tabletL: '(max-width: 1366px)',
    'tabletL<': '(min-width: 1366px)',
    tabletM: '(max-width: 1280px)',
    'tabletM<': '(min-width: 1280px)',
    tabletS: '(max-width: 1024px)',
    'tabletS<': '(min-width: 1024px)',
    mobileL: '(max-width: 768px)',
    'mobileL<': '(min-width: 768px)',
    mobileM: '(max-width: 560px)',
    'mobileM<': '(min-width: 560px)',
    mobileS: '(max-width: 480px)',
    'mobileS<': '(min-width: 480px)',
    mobileXS: '(max-width: 375px)',
    'mobileXS<': '(min-width: 375px)',
    light: '(prefers-color-scheme: light)',
    dark: '(prefers-color-scheme: dark)',
    print: 'print'
};

});

parcelRegister("6iNFR", function(module, exports) {

$parcel$export(module.exports, "timing", () => $496af4c86e8e4209$export$edfe6c349c815521);
'use strict';
const $496af4c86e8e4209$export$edfe6c349c815521 = {
    base: 150,
    ratio: 1.333,
    unit: 'ms',
    subSequence: true
};

});


parcelRegister("fcdWE", function(module, exports) {
$parcel$export(module.exports, "isWasmLoaded", () => (parcelRequire("kF6lW")).isWasmLoaded);
$parcel$export(module.exports, "loadWasm", () => (parcelRequire("kF6lW")).loadWasm);
$parcel$export(module.exports, "setCssEngineHook", () => (parcelRequire("kF6lW")).setCssEngineHook);
parcelRequire("kF6lW");
parcelRequire("3nfM9");
parcelRequire("3ZAor");
parcelRequire("iovyq");
parcelRequire("ldX3j");

});
parcelRegister("kF6lW", function(module, exports) {

$parcel$export(module.exports, "setCssEngineHook", () => $f0ac9083b81bcd7a$export$34b8418913b04af8);
$parcel$export(module.exports, "loadWasm", () => $f0ac9083b81bcd7a$export$2fb43d49c8cdf2b1);
$parcel$export(module.exports, "isWasmLoaded", () => $f0ac9083b81bcd7a$export$2b68e69003a59c2);
// WASM Bridge - lazy loads WASM module, falls back to JS implementations
// Framework starts instantly with JS, hot-swaps to WASM once loaded

var $3nfM9 = parcelRequire("3nfM9");

var $3ZAor = parcelRequire("3ZAor");

var $iovyq = parcelRequire("iovyq");

var $ldX3j = parcelRequire("ldX3j");
// Optional CSS engine integration — wired when both packages are present
let $f0ac9083b81bcd7a$var$_setWasmEngine = null;
function $f0ac9083b81bcd7a$export$34b8418913b04af8(fn) {
    $f0ac9083b81bcd7a$var$_setWasmEngine = fn;
}
let $f0ac9083b81bcd7a$var$impl = {
    // Original diff/merge (kept for large-object scenarios)
    structuralHash: $3nfM9.structuralHash,
    deepEqual: $3nfM9.deepEqual,
    mergeStructural: $3ZAor.mergeStructural,
    overwriteDeep: $3ZAor.overwriteDeep,
    // String operations (high-frequency, pure string→string)
    shortHash: $iovyq.shortHash,
    toKebab: $iovyq.toKebab,
    sanitizeValue: $iovyq.sanitizeValue,
    batchShortHash: $iovyq.batchShortHash,
    // CSS engine (batched string pipeline — main WASM win)
    atomicCssClass: $ldX3j.atomicCssClass,
    batchAtomicCss: $ldX3j.batchAtomicCss,
    compoundCssClass: $ldX3j.compoundCssClass
};
let $f0ac9083b81bcd7a$var$wasmLoaded = false;
let $f0ac9083b81bcd7a$var$wasmLoadPromise = null;
function $f0ac9083b81bcd7a$export$2fb43d49c8cdf2b1(wasmUrl) {
    if ($f0ac9083b81bcd7a$var$wasmLoadPromise) return $f0ac9083b81bcd7a$var$wasmLoadPromise;
    $f0ac9083b81bcd7a$var$wasmLoadPromise = import(wasmUrl || '@symbo.ls/wasm/pkg').then((wasm)=>{
        // Hot-swap implementations — only replace what WASM exports
        if (wasm.structuralHash) $f0ac9083b81bcd7a$var$impl.structuralHash = wasm.structuralHash;
        if (wasm.deepEqual) $f0ac9083b81bcd7a$var$impl.deepEqual = wasm.deepEqual;
        if (wasm.mergeStructural) $f0ac9083b81bcd7a$var$impl.mergeStructural = wasm.mergeStructural;
        if (wasm.overwriteDeep) $f0ac9083b81bcd7a$var$impl.overwriteDeep = wasm.overwriteDeep;
        // String ops
        if (wasm.shortHash) $f0ac9083b81bcd7a$var$impl.shortHash = wasm.shortHash;
        if (wasm.toKebab) $f0ac9083b81bcd7a$var$impl.toKebab = wasm.toKebab;
        if (wasm.sanitizeValue) $f0ac9083b81bcd7a$var$impl.sanitizeValue = wasm.sanitizeValue;
        if (wasm.batchShortHash) $f0ac9083b81bcd7a$var$impl.batchShortHash = wasm.batchShortHash;
        // CSS engine
        if (wasm.atomicCssClass) $f0ac9083b81bcd7a$var$impl.atomicCssClass = wasm.atomicCssClass;
        if (wasm.batchAtomicCss) $f0ac9083b81bcd7a$var$impl.batchAtomicCss = wasm.batchAtomicCss;
        if (wasm.compoundCssClass) $f0ac9083b81bcd7a$var$impl.compoundCssClass = wasm.compoundCssClass;
        $f0ac9083b81bcd7a$var$wasmLoaded = true;
        // Wire WASM CSS engine into @symbo.ls/css if hook is set
        if ($f0ac9083b81bcd7a$var$_setWasmEngine && wasm.batchAtomicCss) $f0ac9083b81bcd7a$var$_setWasmEngine({
            batchAtomicCss: wasm.batchAtomicCss,
            compoundCssClass: wasm.compoundCssClass
        });
        return true;
    }).catch((err)=>{
        // WASM unavailable - continue with JS fallbacks (zero degradation)
        console.debug('[smbls] WASM not available, using JS fallbacks:', err.message);
        return false;
    });
    return $f0ac9083b81bcd7a$var$wasmLoadPromise;
}
const $f0ac9083b81bcd7a$export$2e619f11ca48bee4 = (...args)=>$f0ac9083b81bcd7a$var$impl.structuralHash(...args);
const $f0ac9083b81bcd7a$export$9cb4719e2e525b7a = (...args)=>$f0ac9083b81bcd7a$var$impl.deepEqual(...args);
const $f0ac9083b81bcd7a$export$e05f86d7fc5cf7d8 = (...args)=>$f0ac9083b81bcd7a$var$impl.mergeStructural(...args);
const $f0ac9083b81bcd7a$export$f0b277b530b4fffd = (...args)=>$f0ac9083b81bcd7a$var$impl.overwriteDeep(...args);
const $f0ac9083b81bcd7a$export$243e7ec9385096f0 = (...args)=>$f0ac9083b81bcd7a$var$impl.shortHash(...args);
const $f0ac9083b81bcd7a$export$99fa6f5488976c53 = (...args)=>$f0ac9083b81bcd7a$var$impl.toKebab(...args);
const $f0ac9083b81bcd7a$export$c9336bd12880d863 = (...args)=>$f0ac9083b81bcd7a$var$impl.sanitizeValue(...args);
const $f0ac9083b81bcd7a$export$5d37d486a05a5ea4 = (...args)=>$f0ac9083b81bcd7a$var$impl.batchShortHash(...args);
const $f0ac9083b81bcd7a$export$5b8c88f058976c24 = (...args)=>$f0ac9083b81bcd7a$var$impl.atomicCssClass(...args);
const $f0ac9083b81bcd7a$export$fb9ca925350ab5b7 = (...args)=>$f0ac9083b81bcd7a$var$impl.batchAtomicCss(...args);
const $f0ac9083b81bcd7a$export$776d8134a31a47ab = (...args)=>$f0ac9083b81bcd7a$var$impl.compoundCssClass(...args);
function $f0ac9083b81bcd7a$export$2b68e69003a59c2() {
    return $f0ac9083b81bcd7a$var$wasmLoaded;
}

});
parcelRegister("3nfM9", function(module, exports) {

$parcel$export(module.exports, "structuralHash", () => $274fc1d05ee802aa$export$2e619f11ca48bee4);
$parcel$export(module.exports, "deepEqual", () => $274fc1d05ee802aa$export$9cb4719e2e525b7a);
// JS fallback for structural diffing
// Will be replaced by Rust/WASM when loaded
// Structural hash for fast inequality detection
function $274fc1d05ee802aa$export$2e619f11ca48bee4(obj) {
    if (obj === null || obj === undefined) return 0;
    if (typeof obj !== 'object') return $274fc1d05ee802aa$var$simpleHash(String(obj));
    let h = 0x811c9dc5;
    if (Array.isArray(obj)) {
        h = (h ^ 0x5b) * 0x01000193 // '['
        ;
        for(let i = 0; i < obj.length; i++)h = (h ^ $274fc1d05ee802aa$export$2e619f11ca48bee4(obj[i])) * 0x01000193;
        return h >>> 0;
    }
    const keys = Object.keys(obj).sort();
    for(let i = 0; i < keys.length; i++){
        h = (h ^ $274fc1d05ee802aa$var$simpleHash(keys[i])) * 0x01000193;
        h = (h ^ $274fc1d05ee802aa$export$2e619f11ca48bee4(obj[keys[i]])) * 0x01000193;
    }
    return h >>> 0;
}
function $274fc1d05ee802aa$var$simpleHash(str) {
    let h = 0x811c9dc5;
    for(let i = 0; i < str.length; i++){
        h ^= str.charCodeAt(i);
        h = h * 0x01000193 >>> 0;
    }
    return h;
}
function $274fc1d05ee802aa$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    if (a === null || b === null) return false;
    if (typeof a !== typeof b) return false;
    if (typeof a !== 'object') return false;
    if (Array.isArray(a)) {
        if (!Array.isArray(b) || a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (!$274fc1d05ee802aa$export$9cb4719e2e525b7a(a[i], b[i])) return false;
        }
        return true;
    }
    const keysA = Object.keys(a);
    const keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        const key = keysA[i];
        if (!Object.prototype.hasOwnProperty.call(b, key)) return false;
        if (!$274fc1d05ee802aa$export$9cb4719e2e525b7a(a[key], b[key])) return false;
    }
    return true;
}

});

parcelRegister("3ZAor", function(module, exports) {

$parcel$export(module.exports, "mergeStructural", () => $2e834c8aee975450$export$e05f86d7fc5cf7d8);
$parcel$export(module.exports, "overwriteDeep", () => $2e834c8aee975450$export$f0b277b530b4fffd);
// JS fallback for deep merge operations
// Will be replaced by Rust/WASM when loaded
// Structural merge with copy-on-write
// Returns new object only for changed paths, shares unchanged subtrees
function $2e834c8aee975450$export$e05f86d7fc5cf7d8(target, source) {
    if (source === undefined) return target;
    if (target === undefined) return source;
    if (source === null) return null;
    if (typeof source !== 'object' || Array.isArray(source)) return source;
    if (typeof target !== 'object' || Array.isArray(target)) return {
        ...source
    };
    let changed = false;
    const result = {};
    // Copy target properties, overwrite with source where present
    for(const key in target)if (key in source) {
        const merged = $2e834c8aee975450$export$e05f86d7fc5cf7d8(target[key], source[key]);
        result[key] = merged;
        if (merged !== target[key]) changed = true;
    } else result[key] = target[key];
    // Add new properties from source
    for(const key in source)if (!(key in target)) {
        result[key] = source[key];
        changed = true;
    }
    // Return same reference if nothing changed (structural sharing)
    return changed ? result : target;
}
function $2e834c8aee975450$export$f0b277b530b4fffd(target, source, visited) {
    if (!source || typeof source !== 'object') return target;
    if (!target || typeof target !== 'object') return source;
    if (!visited) visited = new WeakSet();
    if (visited.has(source)) return target;
    visited.add(source);
    for(const key in source){
        const val = source[key];
        if (val && typeof val === 'object' && !Array.isArray(val) && target[key] && typeof target[key] === 'object' && !Array.isArray(target[key])) $2e834c8aee975450$export$f0b277b530b4fffd(target[key], val, visited);
        else target[key] = val;
    }
    return target;
}

});

parcelRegister("iovyq", function(module, exports) {

$parcel$export(module.exports, "shortHash", () => $d642f1e884152f9b$export$243e7ec9385096f0);
$parcel$export(module.exports, "toKebab", () => $d642f1e884152f9b$export$99fa6f5488976c53);
$parcel$export(module.exports, "sanitizeValue", () => $d642f1e884152f9b$export$c9336bd12880d863);
$parcel$export(module.exports, "batchShortHash", () => $d642f1e884152f9b$export$5d37d486a05a5ea4);
// JS fallback for string operations
// Will be replaced by Rust/WASM when loaded
const $d642f1e884152f9b$var$FNV_OFFSET = 0x811c9dc5;
const $d642f1e884152f9b$var$FNV_PRIME = 0x01000193;
function $d642f1e884152f9b$export$243e7ec9385096f0(str) {
    let h = $d642f1e884152f9b$var$FNV_OFFSET;
    for(let i = 0; i < str.length; i++){
        h ^= str.charCodeAt(i);
        h = h * $d642f1e884152f9b$var$FNV_PRIME >>> 0;
    }
    return h.toString(36);
}
function $d642f1e884152f9b$export$99fa6f5488976c53(str) {
    return str.replace(/[A-Z]/g, (m)=>'-' + m.toLowerCase());
}
function $d642f1e884152f9b$export$c9336bd12880d863(value) {
    const str = String(value);
    if (str.length <= 20) return str.replace(/\s+/g, '_').replace(/[^a-zA-Z0-9_-]/g, '').toLowerCase();
    return $d642f1e884152f9b$export$243e7ec9385096f0(str);
}
function $d642f1e884152f9b$export$5d37d486a05a5ea4(input) {
    return input.split('\n').map($d642f1e884152f9b$export$243e7ec9385096f0).join('\n');
}

});

parcelRegister("ldX3j", function(module, exports) {

$parcel$export(module.exports, "atomicCssClass", () => $f7389e7780c99284$export$5b8c88f058976c24);
$parcel$export(module.exports, "batchAtomicCss", () => $f7389e7780c99284$export$fb9ca925350ab5b7);
$parcel$export(module.exports, "compoundCssClass", () => $f7389e7780c99284$export$776d8134a31a47ab);
// JS fallback for CSS engine WASM functions
// Will be replaced by Rust/WASM when loaded

var $iovyq = parcelRequire("iovyq");
const $f7389e7780c99284$var$PROP_ABBREV = {
    display: 'd',
    position: 'pos',
    padding: 'p',
    paddingTop: 'pt',
    paddingRight: 'pr',
    paddingBottom: 'pb',
    paddingLeft: 'pl',
    paddingBlock: 'pbl',
    paddingInline: 'pin',
    margin: 'm',
    marginTop: 'mt',
    marginRight: 'mr',
    marginBottom: 'mb',
    marginLeft: 'ml',
    marginBlock: 'mbl',
    marginInline: 'min',
    width: 'w',
    height: 'h',
    minWidth: 'mnw',
    minHeight: 'mnh',
    maxWidth: 'mxw',
    maxHeight: 'mxh',
    top: 't',
    right: 'r',
    bottom: 'b',
    left: 'l',
    flex: 'fx',
    flexDirection: 'fxd',
    flexWrap: 'fxw',
    flexGrow: 'fxg',
    flexShrink: 'fxs',
    flexBasis: 'fxb',
    justifyContent: 'jc',
    alignItems: 'ai',
    alignSelf: 'as',
    alignContent: 'ac',
    gap: 'g',
    rowGap: 'rg',
    columnGap: 'cg',
    gridTemplateColumns: 'gtc',
    gridTemplateRows: 'gtr',
    gridColumn: 'gc',
    gridRow: 'gr',
    overflow: 'of',
    overflowX: 'ofx',
    overflowY: 'ofy',
    fontSize: 'fs',
    fontWeight: 'fw',
    fontFamily: 'ff',
    fontStyle: 'fst',
    lineHeight: 'lh',
    letterSpacing: 'ls',
    textAlign: 'ta',
    textDecoration: 'td',
    textTransform: 'tt',
    color: 'c',
    background: 'bg',
    backgroundColor: 'bgc',
    backgroundImage: 'bgi',
    border: 'bd',
    borderRadius: 'br',
    borderColor: 'bdc',
    borderWidth: 'bdw',
    borderStyle: 'bds',
    boxShadow: 'bxsh',
    opacity: 'op',
    zIndex: 'z',
    cursor: 'cur',
    transition: 'tr',
    transform: 'tf',
    animation: 'an',
    visibility: 'vis',
    whiteSpace: 'ws',
    wordBreak: 'wb',
    objectFit: 'obj',
    pointerEvents: 'pe',
    userSelect: 'us',
    boxSizing: 'bxz',
    outline: 'ol',
    listStyle: 'lis',
    textOverflow: 'txo',
    verticalAlign: 'va',
    float: 'fl',
    clear: 'cl',
    content: 'cnt',
    backdropFilter: 'bdf',
    filter: 'flt',
    resize: 'rsz',
    appearance: 'apr',
    fill: 'fil',
    stroke: 'stk',
    scrollBehavior: 'sb',
    inset: 'ins'
};
function $f7389e7780c99284$export$5b8c88f058976c24(prop, value) {
    const abbrev = $f7389e7780c99284$var$PROP_ABBREV[prop] || (0, $iovyq.shortHash)(prop);
    const valStr = (0, $iovyq.sanitizeValue)(value);
    const className = `_${abbrev}-${valStr}`;
    const cssProp = (0, $iovyq.toKebab)(prop);
    const rule = `.${className}{${cssProp}: ${value}}`;
    return `${className}\n${rule}`;
}
function $f7389e7780c99284$export$fb9ca925350ab5b7(input) {
    const parts = input.split('\0');
    const classes = [];
    const rules = [];
    for(let i = 0; i + 1 < parts.length; i += 2){
        const prop = parts[i];
        const value = parts[i + 1];
        if (!value) continue;
        const abbrev = $f7389e7780c99284$var$PROP_ABBREV[prop] || (0, $iovyq.shortHash)(prop);
        const valStr = (0, $iovyq.sanitizeValue)(value);
        const className = `_${abbrev}-${valStr}`;
        const cssProp = (0, $iovyq.toKebab)(prop);
        classes.push(className);
        rules.push(`.${className}{${cssProp}:${value}}`);
    }
    return classes.join(' ') + '\0' + rules.join('\n');
}
function $f7389e7780c99284$export$776d8134a31a47ab(selector, stylesInput) {
    const hashInput = selector + stylesInput;
    const className = `_c${(0, $iovyq.shortHash)(hashInput)}`;
    const parts = stylesInput.split('\0');
    let body = '';
    for(let i = 0; i + 1 < parts.length; i += 2){
        const prop = parts[i];
        const value = parts[i + 1];
        if (!value) continue;
        body += `${(0, $iovyq.toKebab)(prop)}:${value};`;
    }
    let rule;
    if (selector.startsWith('@media')) rule = `${selector}{.${className}{${body}}}`;
    else if (selector.startsWith(':') || selector.startsWith('&')) {
        const sel = selector.startsWith('&') ? selector.slice(1) : selector;
        rule = `.${className}${sel}{${body}}`;
    } else if (selector.includes('&')) rule = `${selector.replace('&', `.${className}`)}{${body}}`;
    else rule = `.${className} ${selector}{${body}}`;
    return `${className}\n${rule}`;
}

});



parcelRegister("6T8Dr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "create", () => $503e93e3e3151178$export$185802fd694ee1f5);
$parcel$export(module.exports, "createAsync", () => $503e93e3e3151178$export$fa0abf86dcc47d66);
$parcel$export(module.exports, "createSync", () => $503e93e3e3151178$export$df2a74307fafca3b);
$parcel$export(module.exports, "createSkeleton", () => $503e93e3e3151178$export$9cb2e3fca5d0556e);
$parcel$export(module.exports, "default", () => $503e93e3e3151178$export$2e2bcd8739ae039);
$parcel$export(module.exports, "destroy", () => (parcelRequire("3lge9")).destroy);
$parcel$export(module.exports, "DEFAULT_CONTEXT", () => (parcelRequire("F0UG9")).DEFAULT_CONTEXT);
$parcel$export(module.exports, "DESIGN_SYSTEM_OPTIONS", () => (parcelRequire("F0UG9")).DESIGN_SYSTEM_OPTIONS);
$parcel$export(module.exports, "ROUTER_OPTIONS", () => (parcelRequire("F0UG9")).ROUTER_OPTIONS);
$parcel$export(module.exports, "defaultDefine", () => (parcelRequire("kzEwp")).defaultDefine);
$parcel$export(module.exports, "createDefine", () => (parcelRequire("kzEwp")).createDefine);
$parcel$export(module.exports, "polyglotPlugin", () => (parcelRequire("d9FvG")).polyglotPlugin);
$parcel$export(module.exports, "translate", () => (parcelRequire("d9FvG")).translate);
$parcel$export(module.exports, "setLang", () => (parcelRequire("d9FvG")).setLang);
$parcel$export(module.exports, "getActiveLang", () => (parcelRequire("d9FvG")).getActiveLang);
$parcel$export(module.exports, "getLanguages", () => (parcelRequire("d9FvG")).getLanguages);
$parcel$export(module.exports, "loadTranslations", () => (parcelRequire("d9FvG")).loadTranslations);
$parcel$export(module.exports, "upsertTranslation", () => (parcelRequire("d9FvG")).upsertTranslation);
$parcel$export(module.exports, "initPolyglot", () => (parcelRequire("d9FvG")).initPolyglot);
$parcel$export(module.exports, "getLocalStateLang", () => (parcelRequire("d9FvG")).getLocalStateLang);
$parcel$export(module.exports, "polyglotFunctions", () => (parcelRequire("hurDj")).polyglotFunctions);
parcelRequire("2oe0q");
var $bmfNh = parcelRequire("bmfNh");
var $fX7ii = parcelRequire("fX7ii");

var $egeBc = parcelRequire("egeBc");

var $qLhL5 = parcelRequire("qLhL5");

var $7MKBo = parcelRequire("7MKBo");

var $3lge9 = parcelRequire("3lge9");

var $F0UG9 = parcelRequire("F0UG9");

var $aShRn = parcelRequire("aShRn");

var $5SInI = parcelRequire("5SInI");

var $kzEwp = parcelRequire("kzEwp");

var $d9FvG = parcelRequire("d9FvG");

var $hurDj = parcelRequire("hurDj");
'use strict';
const $503e93e3e3151178$var$mergeWithLocalFile = (options, optionsExternalFile)=>(0, $bmfNh.deepMerge)(options, (0, $fX7ii.isObject)(optionsExternalFile) ? optionsExternalFile : {});
// Sync theme resolver. Order of precedence:
//   1. `?globalTheme=<name>` URL parameter  — used by embedded iframes to
//      push a theme into the child app.
//   2. `options.themeStorageKey` via `localStorage` — previously remembered
//      user choice. Supply `themeStorageKey: false` to opt out entirely.
//   3. `options.globalTheme` — the value configured in the project.
// The resolved value lands on `options.globalTheme` (for downstream
// `scratch.set`) and on `options.themeRoot.setAttribute('data-theme', …)`
// for the first paint. `'auto'` follows `prefers-color-scheme` and writes
// either 'dark' or 'light' onto the attribute so per-element
// `[data-theme="…"] &` rules can resolve without any @media wrapper.
// Scratch.set then takes over and registers a live `prefers-color-scheme`
// listener so later OS changes flip the attribute automatically.
const $503e93e3e3151178$var$resolveAndApplyTheme = (options)=>{
    if (typeof document === 'undefined') return;
    const scopeRoot = options.themeRoot || options.document && options.document.documentElement || document.documentElement;
    if (!scopeRoot || typeof scopeRoot.setAttribute !== 'function') return;
    let theme = options.globalTheme || 'auto';
    // URL override — preview/editor-style iframe integration. Forces a theme.
    try {
        if (typeof window !== 'undefined' && window.location) {
            const urlTheme = new URLSearchParams(window.location.search).get('globalTheme');
            if (urlTheme) theme = urlTheme;
        }
    } catch (e) {} // jsdom / sandboxed windows can throw
    // Persisted user choice — only consulted when no explicit config/URL
    // value is forcing a different one.
    const storageKey = options.themeStorageKey;
    if (theme === 'auto' && storageKey && typeof localStorage !== 'undefined') try {
        const stored = localStorage.getItem(storageKey);
        if (stored) theme = stored;
    } catch (e) {}
    // Early-paint attribute: we always need a concrete `data-theme` so the
    // single CSS selector pattern `[data-theme="<scheme>"]` resolves. For
    // `auto`, resolve once from `prefers-color-scheme` — scratch.set will
    // install a listener later so subsequent OS changes update the attr
    // live.
    const resolvedForAttr = theme === 'auto' ? (()=>{
        try {
            return typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
        } catch (e) {
            return 'light';
        }
    })() : theme;
    scopeRoot.setAttribute('data-theme', resolvedForAttr);
    // Keep `options.globalTheme` semantic: only overwrite if we resolved to
    // a forced value (URL / localStorage). Leaving it as `'auto'` tells
    // scratch.set to register the `prefers-color-scheme` listener.
    options.globalTheme = theme;
    options.themeRoot = scopeRoot;
};
const $503e93e3e3151178$export$185802fd694ee1f5 = (App, options = (0, $F0UG9.default), optionsExternalFile)=>{
    const redefinedOptions = {
        ...(0, $F0UG9.default),
        ...$503e93e3e3151178$var$mergeWithLocalFile(options, optionsExternalFile)
    };
    // Resolve the active theme synchronously, before the async init chain,
    // and write `data-theme` to the scope's root element. This gives the
    // first paint the correct theme — no project-side setAttribute hack,
    // no flash of the wrong OS theme. The resolved value is written back
    // into options so the downstream scratch.set() uses the same value
    // (instead of re-resolving from its own defaults).
    $503e93e3e3151178$var$resolveAndApplyTheme(redefinedOptions);
    const domqlApp = (0, $aShRn.createDomqlElement)(App, redefinedOptions).then((app)=>{
        (0, $qLhL5.onpopstateRouter)(app, redefinedOptions);
        // Ergonomic shortcut so callers can `app.destroy()` instead of importing.
        app.destroy = ()=>(0, $3lge9.destroy)(app);
        if (app.onCreate) app.onCreate(app, app.state, app.context, redefinedOptions);
        // Hydration gate: flip the analyze plugin from dormant → active.
        // Browser/network listeners attach here; pre-ready error buffer is drained.
        if (app.context?.analyze?.activate) try {
            app.context.analyze.activate(app.context);
        } catch (err) {
            console.error('[analyze] activate error:', err);
        }
        return app;
    }).catch((err)=>{
        console.error('[smbls] create error:', err);
        throw err;
    });
    return domqlApp;
};
const $503e93e3e3151178$export$fa0abf86dcc47d66 = (App, options = (0, $F0UG9.default), optionsExternalFile)=>{
    const domqlApp = $503e93e3e3151178$export$185802fd694ee1f5(App, options, optionsExternalFile);
    const redefinedOptions = {
        ...(0, $F0UG9.default),
        ...$503e93e3e3151178$var$mergeWithLocalFile(options, optionsExternalFile)
    };
    const key = redefinedOptions.key;
    (0, $7MKBo.fetchAsync)(domqlApp, key, {
        utils: $egeBc,
        ...redefinedOptions
    });
    return domqlApp;
};
const $503e93e3e3151178$export$df2a74307fafca3b = async (App, options = (0, $F0UG9.default), optionsExternalFile)=>{
    const redefinedOptions = {
        ...(0, $F0UG9.default),
        ...$503e93e3e3151178$var$mergeWithLocalFile(options, optionsExternalFile)
    };
    // const SYMBOLS_KEY = process.env.SYMBOLS_KEY
    const key = options.key;
    await (0, $7MKBo.fetchSync)(key, redefinedOptions);
    const domqlApp = await (0, $aShRn.createDomqlElement)(App, redefinedOptions);
    (0, $qLhL5.onpopstateRouter)(domqlApp, redefinedOptions);
    domqlApp.destroy = ()=>(0, $3lge9.destroy)(domqlApp);
    if (redefinedOptions.onCreate) await redefinedOptions.onCreate(domqlApp, domqlApp.state, domqlApp.context, redefinedOptions);
    return domqlApp;
};
const $503e93e3e3151178$export$9cb2e3fca5d0556e = (App = {}, options = (0, $F0UG9.default), optionsExternalFile)=>{
    return $503e93e3e3151178$export$185802fd694ee1f5({
        deps: {
            isUndefined: $fX7ii.isUndefined
        },
        ...App
    }, (0, $bmfNh.deepMerge)({
        domqlOptions: {
            onlyResolveExtends: true
        }
    }, options), optionsExternalFile);
};
var $503e93e3e3151178$export$2e2bcd8739ae039 = $503e93e3e3151178$export$185802fd694ee1f5;
$parcel$exportWildcard(module.exports, $5SInI);

});
parcelRegister("egeBc", function(module, exports) {

$parcel$export(module.exports, "scratchUtils", () => (parcelRequire("g1w0p")));
$parcel$export(module.exports, "scratchSystem", () => (parcelRequire("g1w0p")));
$parcel$export(module.exports, "set", () => (parcelRequire("g1w0p")).set);
$parcel$export(module.exports, "init", () => (parcelRequire("5SInI")).init);
$parcel$export(module.exports, "reinit", () => (parcelRequire("5SInI")).reinit);
$parcel$export(module.exports, "applyCSS", () => (parcelRequire("5SInI")).applyCSS);
parcelRequire("aTPvW");
var $g1w0p = parcelRequire("g1w0p");

var $2oe0q = parcelRequire("2oe0q");

var $5SInI = parcelRequire("5SInI");

var $cAYSb = parcelRequire("cAYSb");
'use strict';
$parcel$exportWildcard(module.exports, $2oe0q);
$parcel$exportWildcard(module.exports, $cAYSb);

});
parcelRegister("5SInI", function(module, exports) {

$parcel$export(module.exports, "init", () => $44846c222685cb73$export$2cd8252107eb640b);
$parcel$export(module.exports, "reinit", () => $44846c222685cb73$export$b545ad0f2df0be16);
$parcel$export(module.exports, "applyCSS", () => $44846c222685cb73$export$3a26aa64e59aeaff);
$parcel$export(module.exports, "updateVars", () => $44846c222685cb73$export$ed2c61d2d8a098be);
$parcel$export(module.exports, "changeGlobalTheme", () => $44846c222685cb73$export$204c4d227c4ac61c);
$parcel$export(module.exports, "setClass", () => $44846c222685cb73$export$2796c4ce44e61efa);
parcelRequire("aTPvW");
var $nKbE9 = parcelRequire("nKbE9");
var $g1w0p = parcelRequire("g1w0p");
var $7KiQp = parcelRequire("7KiQp");
var $ePlkR = parcelRequire("ePlkR");
parcelRequire("2oe0q");
var $bmfNh = parcelRequire("bmfNh");
var $fX7ii = parcelRequire("fX7ii");
parcelRequire("2Eo8m");
var $bd7kG = parcelRequire("bd7kG");
'use strict';
const $44846c222685cb73$var$CONFIG = (0, $7KiQp.getActiveConfig)();
const $44846c222685cb73$var$mergeWithLocalFile = (config = $44846c222685cb73$var$CONFIG, options)=>{
    const rcfile = (0, $fX7ii.isObject)(options.localFile) ? options.localFile : {};
    const clonedFile = (0, $bmfNh.deepClone)(rcfile.designSystem || {});
    return (0, $bmfNh.deepMerge)(config, clonedFile);
};
const $44846c222685cb73$var$SET_OPTIONS = {
    useVariable: true,
    useReset: true,
    useFontImport: true,
    useIconSprite: true,
    useDocumentTheme: true,
    useSvgSprite: true
};
const $44846c222685cb73$export$2cd8252107eb640b = (config, options = $44846c222685cb73$var$SET_OPTIONS)=>{
    const resultConfig = $44846c222685cb73$var$mergeWithLocalFile(config || {}, options);
    const scope = options.scopeSelector || ':root';
    const themeScope = scope === ':root' ? ':root:not([data-theme])' : `${scope}:not([data-theme])`;
    // Allow URL param to override globalTheme (used by preview iframe)
    let globalTheme = options.globalTheme;
    if (typeof window !== 'undefined' && window.location) {
        const urlTheme = new URLSearchParams(window.location.search).get('globalTheme');
        if (urlTheme) globalTheme = urlTheme;
    }
    const conf = (0, $g1w0p.set)({
        verbose: options.verbose,
        useReset: options.useReset,
        useFontImport: options.useFontImport,
        useVariable: options.useVariable,
        useSvgSprite: options.useSvgSprite,
        useDocumentTheme: options.useDocumentTheme,
        useIconSprite: options.useIconSprite,
        useDefaultConfig: options.useDefaultConfig,
        globalTheme: globalTheme,
        themeRoot: options.themeRoot,
        files: options.files,
        assets: options.assets,
        ...resultConfig
    }, {
        newConfig: options.newConfig,
        config: options.config
    });
    // Remember the scope selector on the config so downstream consumers
    // (e.g. set.js live updates) can target the right CSS rule.
    if (conf) conf.scopeSelector = scope;
    const FontFace = (0, $ePlkR.getFontFaceString)(conf.font, conf.files);
    const useReset = conf.useReset;
    const useVariable = conf.useVariable;
    const useFontImport = conf.useFontImport;
    const useSvgSprite = conf.useSvgSprite;
    const hasSvgs = config.svg;
    const useIconSprite = conf.useIconSprite;
    const hasIcons = config.icons;
    if (useFontImport) (0, $bd7kG.injectGlobal)(FontFace);
    if (useVariable) {
        (0, $bd7kG.injectGlobal)({
            [scope]: conf.CSS_VARS
        });
        // Inject theme-switching CSS vars (media queries + data-theme selectors)
        if (conf.CSS_MEDIA_VARS) {
            const themeStyles = {};
            for(const key in conf.CSS_MEDIA_VARS)if (key.startsWith('@media')) // Media query — only apply when no data-theme forces a theme
            themeStyles[key] = {
                [themeScope]: conf.CSS_MEDIA_VARS[key]
            };
            else // Selector ([data-theme="..."]) — apply directly
            themeStyles[key] = conf.CSS_MEDIA_VARS[key];
            (0, $bd7kG.injectGlobal)(themeStyles);
        }
    }
    if (useReset) (0, $bd7kG.injectGlobal)(conf.reset);
    // Register all ANIMATION entries as global @keyframes
    const animations = conf.animation;
    if (animations) {
        const keyframesCSS = {};
        for(const name in animations)keyframesCSS[`@keyframes ${name}`] = animations[name];
        (0, $bd7kG.injectGlobal)(keyframesCSS);
    }
    if (hasSvgs || useSvgSprite) (0, $nKbE9.appendSVGSprite)(conf.svg, {
        document: options.document
    });
    if (hasIcons || useIconSprite) (0, $nKbE9.appendSvgIconsSprite)(conf.icons, {
        document: options.document
    });
    return conf;
};
const $44846c222685cb73$var$UPDATE_OPTIONS = {};
const $44846c222685cb73$export$b545ad0f2df0be16 = (config, options = $44846c222685cb73$var$UPDATE_OPTIONS)=>{
    const resultConfig = $44846c222685cb73$var$mergeWithLocalFile(config || {}, options);
    const scope = options.scopeSelector || ':root';
    const themeScope = scope === ':root' ? ':root:not([data-theme])' : `${scope}:not([data-theme])`;
    const conf = (0, $g1w0p.set)({
        verbose: false,
        ...resultConfig
    });
    if (!options.preventInject) {
        (0, $bd7kG.injectGlobal)({
            [scope]: conf.CSS_VARS
        });
        if (conf.CSS_MEDIA_VARS) {
            const themeStyles = {};
            for(const key in conf.CSS_MEDIA_VARS)if (key.startsWith('@media')) themeStyles[key] = {
                [themeScope]: conf.CSS_MEDIA_VARS[key]
            };
            else themeStyles[key] = conf.CSS_MEDIA_VARS[key];
            (0, $bd7kG.injectGlobal)(themeStyles);
        }
        (0, $bd7kG.injectGlobal)(conf.reset);
    }
    return conf;
};
const $44846c222685cb73$export$3a26aa64e59aeaff = (styles, options = $44846c222685cb73$var$UPDATE_OPTIONS)=>{
    (0, $bd7kG.injectGlobal)(styles);
};
const $44846c222685cb73$export$ed2c61d2d8a098be = (config, options = $44846c222685cb73$var$UPDATE_OPTIONS)=>{
    const scope = options.scopeSelector || ':root';
    const themeScope = scope === ':root' ? ':root:not([data-theme])' : `${scope}:not([data-theme])`;
    (0, $bd7kG.injectGlobal)({
        [scope]: config.CSS_VARS
    });
    if (config.CSS_MEDIA_VARS) {
        const themeStyles = {};
        for(const key in config.CSS_MEDIA_VARS)if (key.startsWith('@media')) themeStyles[key] = {
            [themeScope]: config.CSS_MEDIA_VARS[key]
        };
        else themeStyles[key] = config.CSS_MEDIA_VARS[key];
        (0, $bd7kG.injectGlobal)(themeStyles);
    }
};
const $44846c222685cb73$export$204c4d227c4ac61c = (newTheme, targetConfig)=>{
    return (0, $g1w0p.changeGlobalTheme)(newTheme, targetConfig);
};
const $44846c222685cb73$export$2796c4ce44e61efa = (props, options = $44846c222685cb73$var$UPDATE_OPTIONS)=>{} // setClassname(props, css)
;

});

parcelRegister("cAYSb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "parseRoutePattern", () => $92b810e5fc222e9a$export$c1d2f753e345bfd);
$parcel$export(module.exports, "matchRoute", () => $92b810e5fc222e9a$export$b4ee0d6794375c82);
$parcel$export(module.exports, "parseQuery", () => $92b810e5fc222e9a$export$1e8473eaf75b0d10);
$parcel$export(module.exports, "runGuards", () => $92b810e5fc222e9a$export$6b398ed5c45e580b);
$parcel$export(module.exports, "getActiveRoute", () => $92b810e5fc222e9a$export$e7a685f330e7752);
$parcel$export(module.exports, "lastPathname", () => $92b810e5fc222e9a$export$7a9e7a91cdf4fce1);
$parcel$export(module.exports, "lastLevel", () => $92b810e5fc222e9a$export$ed098f724085d263);
$parcel$export(module.exports, "router", () => $92b810e5fc222e9a$export$5375cda95f0b0eb4);
$parcel$export(module.exports, "default", () => $92b810e5fc222e9a$export$2e2bcd8739ae039);
parcelRequire("2oe0q");
var $erBZm = parcelRequire("erBZm");
var $9VZBt = parcelRequire("9VZBt");
'use strict';
// --- Route matching utilities ---
const $92b810e5fc222e9a$var$paramPattern = /^:(.+)/;
const $92b810e5fc222e9a$var$wildcardPattern = /^\*$/;
const $92b810e5fc222e9a$var$routeCache = new Map();
const $92b810e5fc222e9a$export$c1d2f753e345bfd = (pattern)=>{
    const cached = $92b810e5fc222e9a$var$routeCache.get(pattern);
    if (cached) return cached;
    const segments = pattern.replace(/^\//, '').split('/');
    const params = [];
    let hasWildcard = false;
    for(let i = 0; i < segments.length; i++){
        const match = segments[i].match($92b810e5fc222e9a$var$paramPattern);
        if (match) params.push({
            index: i,
            name: match[1]
        });
        else if ($92b810e5fc222e9a$var$wildcardPattern.test(segments[i])) hasWildcard = true;
    }
    const result = {
        segments: segments,
        params: params,
        hasWildcard: hasWildcard,
        pattern: pattern
    };
    $92b810e5fc222e9a$var$routeCache.set(pattern, result);
    return result;
};
const $92b810e5fc222e9a$export$b4ee0d6794375c82 = (pathname, routes, level = 0)=>{
    const pathSegments = pathname.replace(/^\//, '').split('/').filter(Boolean);
    const relevantSegments = pathSegments.slice(level);
    const routePath = '/' + (relevantSegments[0] || '');
    let bestMatch = null;
    let bestScore = -1;
    let matchedParams = {};
    for(const key in routes){
        if (key === '/*') continue;
        const parsed = $92b810e5fc222e9a$export$c1d2f753e345bfd(key);
        const score = $92b810e5fc222e9a$var$scoreMatch(relevantSegments, parsed);
        if (score > bestScore) {
            bestScore = score;
            bestMatch = key;
            matchedParams = $92b810e5fc222e9a$var$extractParams(relevantSegments, parsed);
        }
    }
    if (!bestMatch && routes['/*']) bestMatch = '/*';
    return {
        key: bestMatch,
        content: bestMatch ? routes[bestMatch] : null,
        params: matchedParams,
        routePath: routePath
    };
};
const $92b810e5fc222e9a$var$scoreMatch = (pathSegments, parsed)=>{
    const { segments: segments, hasWildcard: hasWildcard } = parsed;
    if (!hasWildcard && segments.length !== pathSegments.length && segments.length !== 1) {
        // For single-segment patterns, match just the first segment
        if (segments.length > pathSegments.length) return -1;
    }
    let score = 0;
    const len = Math.min(segments.length, pathSegments.length);
    for(let i = 0; i < len; i++){
        if (segments[i] === pathSegments[i]) score += 3 // exact match
        ;
        else if ($92b810e5fc222e9a$var$paramPattern.test(segments[i])) score += 1 // param match
        ;
        else if ($92b810e5fc222e9a$var$wildcardPattern.test(segments[i])) score += 0.5;
        else return -1 // no match
        ;
    }
    return score;
};
const $92b810e5fc222e9a$var$extractParams = (pathSegments, parsed)=>{
    const params = {};
    for (const { index: index, name: name } of parsed.params)if (pathSegments[index]) params[name] = decodeURIComponent(pathSegments[index]);
    return params;
};
const $92b810e5fc222e9a$export$1e8473eaf75b0d10 = (search)=>{
    if (!search || search === '?') return {};
    const params = {};
    const searchParams = new URLSearchParams(search);
    searchParams.forEach((value, key)=>{
        if (params[key] !== undefined) {
            if (!Array.isArray(params[key])) params[key] = [
                params[key]
            ];
            params[key].push(value);
        } else params[key] = value;
    });
    return params;
};
const $92b810e5fc222e9a$export$6b398ed5c45e580b = async (guards, context)=>{
    if (!guards || !guards.length) return true;
    for (const guard of guards){
        const result = await guard(context);
        if (result === false) return false;
        if (typeof result === 'string') return result // redirect path
        ;
    }
    return true;
};
const $92b810e5fc222e9a$export$e7a685f330e7752 = (level = 0, route)=>{
    if (!route) route = typeof (0, $erBZm.window) !== 'undefined' ? (0, $erBZm.window).location.pathname : '/';
    const routeArray = route.split('/');
    const activeRoute = routeArray[level + 1];
    if (activeRoute) return `/${activeRoute}`;
};
let $92b810e5fc222e9a$export$7a9e7a91cdf4fce1;
let $92b810e5fc222e9a$export$ed098f724085d263 = 0;
const $92b810e5fc222e9a$var$normalizePath = (p)=>!p || p === 'srcdoc' || p === 'about:srcdoc' ? '/' : p;
const $92b810e5fc222e9a$var$defaultOptions = {
    level: $92b810e5fc222e9a$export$ed098f724085d263,
    pushState: true,
    initialRender: false,
    scrollToTop: true,
    scrollToNode: false,
    scrollNode: (0, $erBZm.document) && (0, $erBZm.document).documentElement,
    scrollBody: false,
    useFragment: false,
    updateState: true,
    scrollToOffset: 0,
    contentElementKey: 'content',
    scrollToOptions: {
        behavior: 'smooth'
    },
    useParamsMatching: true
};
const $92b810e5fc222e9a$export$5375cda95f0b0eb4 = async (path, el, state = {}, options = {})=>{
    const element = el || undefined;
    const win = element?.context?.window || (0, $erBZm.window);
    const doc = element?.context?.document || (0, $erBZm.document);
    const opts = {
        ...$92b810e5fc222e9a$var$defaultOptions,
        ...element.context.routerOptions,
        ...options
    };
    $92b810e5fc222e9a$export$ed098f724085d263 = opts.lastLevel;
    const ref = element.__ref;
    if (opts.contentElementKey !== 'content' && opts.contentElementKey !== ref.contentElementKey || !ref.contentElementKey) ref.contentElementKey = opts.contentElementKey || 'content';
    const contentElementKey = ref.contentElementKey || opts.contentElementKey || 'content';
    const origin = win.location.origin !== 'null' ? win.location.origin : 'http://localhost';
    path = $92b810e5fc222e9a$var$normalizePath(path);
    const urlObj = new win.URL(origin + path);
    const { pathname: pathname, search: search, hash: hash } = urlObj;
    const query = $92b810e5fc222e9a$export$1e8473eaf75b0d10(search);
    const rootNode = element.node;
    const hashChanged = hash && hash !== win.location.hash.slice(1);
    const pathChanged = pathname !== $92b810e5fc222e9a$export$7a9e7a91cdf4fce1;
    $92b810e5fc222e9a$export$7a9e7a91cdf4fce1 = pathname;
    // Route matching - support both simple and param-based
    let route, content, params;
    if (opts.useParamsMatching) {
        const match = $92b810e5fc222e9a$export$b4ee0d6794375c82(pathname, element.routes, opts.level);
        route = match.routePath;
        content = match.content;
        params = match.params;
    } else {
        route = $92b810e5fc222e9a$export$e7a685f330e7752(opts.level, pathname);
        content = element.routes[route || '/'] || element.routes['/*'];
        params = {};
    }
    const scrollNode = opts.scrollToNode ? rootNode : opts.scrollNode;
    if (element.state?.root?.debugging) {
        element.state.root.debugging = false;
        return;
    }
    if (!content) {
        if (opts.onNotFound) opts.onNotFound({
            pathname: pathname,
            route: route,
            element: element
        });
        else if (!opts.silent) console.warn('[smbls/router] no content matched for path', pathname, "\u2014 available routes:", Object.keys(element.routes || {}));
        return;
    }
    // Run guards
    if (opts.guards && opts.guards.length) {
        const guardContext = {
            pathname: pathname,
            route: route,
            params: params,
            query: query,
            hash: hash,
            element: element,
            state: state
        };
        const guardResult = await $92b810e5fc222e9a$export$6b398ed5c45e580b(opts.guards, guardContext);
        if (guardResult === false) return;
        if (typeof guardResult === 'string') // Redirect
        return $92b810e5fc222e9a$export$5375cda95f0b0eb4(guardResult, el, state, {
            ...options,
            guards: []
        });
    }
    // pushState always fires before render so the URL bar stays in sync even
    // if the content-render step below no-ops due to an extends/ref mismatch.
    if (opts.pushState) try {
        win.history.pushState(state, null, pathname + (search || '') + (hash || ''));
    } catch (e) {} // expected in sandboxed iframes (e.g. about:srcdoc) where pushState is restricted
    if (pathChanged || !hashChanged) {
        const stateUpdate = {
            route: route,
            hash: hash,
            debugging: false
        };
        if (Object.keys(params).length) stateUpdate.params = params;
        if (Object.keys(query).length) stateUpdate.query = query;
        if (opts.updateState) element.state.update(stateUpdate, {
            preventContentUpdate: true
        });
        if (contentElementKey && opts.removeOldElement) element[contentElementKey].remove();
        // Merge parent's original content definition (styles like overflow, maxHeight)
        // with the route's content component
        const originContent = element.__ref?.origin?.content;
        const contentStyles = {};
        if (originContent) for(const k in originContent){
            const v = originContent[k];
            if (k === '__ref' || k === 'props' || k === 'node' || k === 'parent' || k === 'key') continue;
            if (typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || typeof v === 'object' && v !== null && !v.node && !v.__ref) contentStyles[k] = v;
        }
        const nextContent = {
            ...contentStyles,
            ...typeof content === 'object' ? content : {
                extends: content
            }
        };
        if (opts.useFragment) nextContent.tag = 'fragment';
        try {
            element.set(nextContent, {
                contentElementKey: contentElementKey
            });
        } catch (err) {
            console.error('[smbls/router] failed to render route content', pathname, err);
        }
    }
    if (opts.scrollToTop && scrollNode?.scrollTo) scrollNode.scrollTo({
        ...opts.scrollToOptions || {},
        top: 0,
        left: 0
    });
    if (opts.scrollToNode && content[contentElementKey]?.node?.scrollTo) content[contentElementKey].node.scrollTo({
        ...opts.scrollToOptions || {},
        top: 0,
        left: 0
    });
    if (hash) {
        const activeNode = doc.getElementById(hash);
        if (activeNode && scrollNode?.scrollTo) {
            const top = activeNode.getBoundingClientRect().top + rootNode.scrollTop - (opts.scrollToOffset || 0);
            scrollNode.scrollTo({
                ...opts.scrollToOptions || {},
                top: top,
                left: 0
            });
        }
    }
    // trigger `on.routeChanged`
    (0, $9VZBt.triggerEventOn)('routeChanged', element, opts);
};
var $92b810e5fc222e9a$export$2e2bcd8739ae039 = $92b810e5fc222e9a$export$5375cda95f0b0eb4;

});


parcelRegister("qLhL5", function(module, exports) {

$parcel$export(module.exports, "initRouter", () => $05071bb91c9ddf69$export$cf7ee87ede64229c);
$parcel$export(module.exports, "onpopstateRouter", () => $05071bb91c9ddf69$export$7fe20beff2421d2d);
parcelRequire("2oe0q");
var $bmfNh = parcelRequire("bmfNh");
var $fX7ii = parcelRequire("fX7ii");
var $erBZm = parcelRequire("erBZm");

var $cAYSb = parcelRequire("cAYSb");
'use strict';
const $05071bb91c9ddf69$var$normalizePath = (p)=>!p || p === 'srcdoc' || p === 'about:srcdoc' || p === 'blank' || p === 'about:blank' ? '/' : p;
const $05071bb91c9ddf69$var$DEFAULT_ROUTING_OPTIONS = {
    initRouter: true,
    injectRouterInLinkComponent: true,
    popState: true
};
const $05071bb91c9ddf69$export$147046761d9d45df = (root, path)=>{
    if (!path) return root;
    const parts = Array.isArray(path) ? path : path.split('.');
    let el = root;
    for (const part of parts){
        if (!el || !el[part]) return null;
        el = el[part];
    }
    return el;
};
const $05071bb91c9ddf69$export$cf7ee87ede64229c = (element, context)=>{
    if (context.router === false) return;
    else if (context.router === true) context.router = $05071bb91c9ddf69$var$DEFAULT_ROUTING_OPTIONS;
    else context.router = (0, $bmfNh.merge)(context.router || {}, $05071bb91c9ddf69$var$DEFAULT_ROUTING_OPTIONS);
    const routerOptions = context.router;
    const onRouterRenderDefault = async (el, s)=>{
        const win = el.context?.window || (0, $erBZm.window);
        if (!win.location) return;
        let { pathname: pathname, search: search, hash: hash } = win.location;
        pathname = $05071bb91c9ddf69$var$normalizePath(pathname);
        const url = pathname + search + hash;
        let targetEl = el;
        if (routerOptions.customRouterElement) {
            const resolved = $05071bb91c9ddf69$export$147046761d9d45df(el, routerOptions.customRouterElement);
            if (resolved) {
                targetEl = resolved;
                if (el.routes) targetEl.routes = el.routes;
            }
        }
        if (targetEl.routes) await (0, $cAYSb.router)(url, targetEl, {}, {
            initialRender: true,
            pushState: false
        });
    };
    const hasRenderRouter = !(0, $fX7ii.isUndefined)(element.onRenderRouter);
    if (routerOptions && routerOptions.initRouter && !hasRenderRouter) element.onRenderRouter = onRouterRenderDefault;
    $05071bb91c9ddf69$export$54b760094ac80b64(context, routerOptions);
    return routerOptions;
};
const $05071bb91c9ddf69$export$7fe20beff2421d2d = (element, context)=>{
    if (context.router === false) return;
    const routerOptions = context.router || $05071bb91c9ddf69$var$DEFAULT_ROUTING_OPTIONS;
    if (!routerOptions.popState) return;
    const router = context.utils && context.utils.router ? context.utils.router : (0, $cAYSb.router);
    const win = context.window || (0, $erBZm.window);
    // addEventListener (not onpopstate=) so multiple apps in the same realm
    // don't clobber each other's handlers. The teardown is queued on
    // context.__teardowns so destroy(app) can remove it cleanly.
    const handler = async (e)=>{
        let { pathname: pathname, search: search, hash: hash } = win.location;
        pathname = $05071bb91c9ddf69$var$normalizePath(pathname);
        const url = pathname + search + hash;
        let targetEl = element;
        if (routerOptions.customRouterElement) {
            const resolved = $05071bb91c9ddf69$export$147046761d9d45df(element, routerOptions.customRouterElement);
            if (resolved) {
                targetEl = resolved;
                if (element.routes) targetEl.routes = element.routes;
            }
        }
        await targetEl.call('router', url, targetEl, {}, {
            pushState: false,
            scrollToTop: false,
            level: 0,
            event: e
        });
    };
    win.addEventListener('popstate', handler);
    context.__teardowns = context.__teardowns || [];
    context.__teardowns.push(()=>win.removeEventListener('popstate', handler));
};
const $05071bb91c9ddf69$export$54b760094ac80b64 = (context, routerOptions)=>{
    const { components: components } = context;
    if (routerOptions && routerOptions.injectRouterInLinkComponent) return (0, $bmfNh.deepMerge)(components['Link'] || components['smbls.Link'], components['RouterLink'] || components['smbls.RouterLink']);
};

});

parcelRegister("7MKBo", function(module, exports) {

$parcel$export(module.exports, "fetchSync", () => $5ab12a4c1440e02c$export$8946d631417d8ced);
$parcel$export(module.exports, "fetchAsync", () => $5ab12a4c1440e02c$export$beca342e15b450be);
parcelRequire("2oe0q");
var $bmfNh = parcelRequire("bmfNh");
var $fX7ii = parcelRequire("fX7ii");
var $kt4aQ = parcelRequire("kt4aQ");
var $erBZm = parcelRequire("erBZm");
'use strict';
const $5ab12a4c1440e02c$var$IS_DEVELOPMENT = (0, $erBZm.window) && (0, $erBZm.window).location ? (0, $erBZm.window).location.host.includes('dev.') : (0, $kt4aQ.isDevelopment)();
const $5ab12a4c1440e02c$var$SERVER_URL = $5ab12a4c1440e02c$var$IS_DEVELOPMENT ? 'http://localhost:8080/get' : 'https://api.symbols.app/get';
const $5ab12a4c1440e02c$var$defaultOptions = {
    endpoint: $5ab12a4c1440e02c$var$SERVER_URL
};
const $5ab12a4c1440e02c$var$fetchRemote = async (key, options = $5ab12a4c1440e02c$var$defaultOptions)=>{
    const baseUrl = options.endpoint || $5ab12a4c1440e02c$var$SERVER_URL;
    const route = options.serviceRoute ? (0, $fX7ii.isArray)(options.serviceRoute) ? options.serviceRoute.map((v)=>v.toLowerCase() + '=true').join('&') : options.serviceRoute : '';
    let response;
    try {
        response = await globalThis.fetch(baseUrl + '/' + '?' + route, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'X-AppKey': key,
                'X-Metadata': options.metadata
            }
        });
        return await response.json();
    } catch (e) {
        if ((0, $fX7ii.isFunction)(options.onError)) return options.onError(e);
        else console.error(e);
    }
};
const $5ab12a4c1440e02c$var$fetchProject = async (key, options)=>{
    const { editor: editor } = options;
    if (editor && editor.remote) {
        const data = await $5ab12a4c1440e02c$var$fetchRemote(key, editor);
        const evalData = $5ab12a4c1440e02c$var$IS_DEVELOPMENT || options.isDevelopment ? (0, $bmfNh.deepDestringifyFunctions)(data) : (0, $bmfNh.deepDestringifyFunctions)(data.releases[0]);
        if (editor.serviceRoute) {
            if ((0, $fX7ii.isArray)(editor.serviceRoute)) editor.serviceRoute.forEach((route)=>{
                (0, $bmfNh.overwriteDeep)(options[route], evalData[route.toLowerCase()]);
            });
            else (0, $bmfNh.overwriteDeep)(options[editor.serviceRoute], evalData);
        } else [
            'state',
            'designSystem',
            'components',
            'snippets',
            'pages',
            'utils',
            'files',
            'assets',
            'packages',
            'functions',
            'globalScope'
        ].forEach((key)=>{
            (0, $bmfNh.overwriteDeep)(options[key], evalData[key.toLowerCase()]);
        });
    }
    return options;
};
const $5ab12a4c1440e02c$var$fetchProjectAsync = async (key, options, callback)=>{
    const { editor: editor } = options;
    if (editor && editor.remote) {
        const data = await $5ab12a4c1440e02c$var$fetchRemote(key, editor);
        const evalData = $5ab12a4c1440e02c$var$IS_DEVELOPMENT || options.isDevelopment ? (0, $bmfNh.deepDestringifyFunctions)(data) : (0, $bmfNh.deepDestringifyFunctions)(data.releases[0]);
        callback(evalData);
    }
};
const $5ab12a4c1440e02c$export$8946d631417d8ced = async (key, options)=>{
    if (key && options.editor) try {
        if (!options.editor.async) await $5ab12a4c1440e02c$var$fetchProject(key, options);
    } catch (e) {
        console.error(e);
    }
};
const $5ab12a4c1440e02c$export$beca342e15b450be = (app, key, options, callback)=>{
    if (key && options.editor) try {
        if (options.editor.async) $5ab12a4c1440e02c$var$fetchProjectAsync(key, options, callback || ((data)=>{
            const designSystem = data.designSystem;
            if ((0, $fX7ii.isObject)(designSystem)) options.utils.init(designSystem);
            if ((0, $fX7ii.isObject)(data.state)) app.state.set(data.state);
        }));
    } catch (e) {
        console.error(e);
    }
};

});

parcelRegister("3lge9", function(module, exports) {

$parcel$export(module.exports, "destroy", () => $26efeba6e96963ca$export$b1fb4cac938035f7);
parcelRequire("cm1sg");
var $gXM9X = parcelRequire("gXM9X");
'use strict';
const $26efeba6e96963ca$export$b1fb4cac938035f7 = (app)=>{
    if (!app || app.__destroyed) return false;
    const ctx = app.context;
    if (!ctx) {
        app.__destroyed = true;
        return false;
    }
    // 1. App-level teardowns (popstate listener etc.). Run before disposing
    //    elements so cleanup callbacks can still read context state.
    if (Array.isArray(ctx.__teardowns)) {
        for (const fn of ctx.__teardowns)try {
            fn();
        } catch (e) {
            console.error('[smbls] destroy teardown error:', e);
        }
        ctx.__teardowns.length = 0;
    }
    // 2. Recursive element disposal — fires onBeforeRemove / onRemove hooks,
    //    cancels reactive effects, removes event listeners, detaches DOM, and
    //    destroys state. Handles the entire subtree.
    try {
        (0, $gXM9X.dispose)(app);
    } catch (e) {
        console.error('[smbls] dispose error:', e);
    }
    // 3. Clear memoized adapter caches so a re-create starts fresh.
    if (ctx.fetch && ctx.fetch.__resolved) delete ctx.fetch.__resolved;
    if (ctx.fetch && ctx.fetch.__resolving) delete ctx.fetch.__resolving;
    if (ctx.db && ctx.db.__resolved) delete ctx.db.__resolved;
    if (ctx.db && ctx.db.__resolving) delete ctx.db.__resolving;
    // 4. Tear down analyze listeners (browser, network, console proxy).
    if (ctx.analyze?.destroy) try {
        ctx.analyze.destroy();
    } catch (e) {
        console.error('[analyze] destroy error:', e);
    }
    app.__destroyed = true;
    return true;
};
var $26efeba6e96963ca$export$2e2bcd8739ae039 = $26efeba6e96963ca$export$b1fb4cac938035f7;

});

parcelRegister("F0UG9", function(module, exports) {

$parcel$export(module.exports, "DESIGN_SYSTEM_OPTIONS", () => $07b489c9a6cbc9d4$export$882cd4124a942c79);
$parcel$export(module.exports, "ROUTER_OPTIONS", () => $07b489c9a6cbc9d4$export$47bde86d5ec3fc9c);
$parcel$export(module.exports, "DEFAULT_CONTEXT", () => $07b489c9a6cbc9d4$export$9c542858adf7dcd0);
$parcel$export(module.exports, "default", () => $07b489c9a6cbc9d4$export$2e2bcd8739ae039);

var $kzEwp = parcelRequire("kzEwp");
'use strict';
const $07b489c9a6cbc9d4$export$882cd4124a942c79 = {
    useReset: true,
    useVariable: true,
    useIconSprite: true,
    useSvgSprite: true,
    useDocumentTheme: true,
    useDefaultIcons: true,
    useFontImport: true,
    useDefaultConfig: true
};
const $07b489c9a6cbc9d4$export$47bde86d5ec3fc9c = {
    initRouter: true,
    popState: true,
    injectRouterInLinkComponent: true
};
const $07b489c9a6cbc9d4$export$9c542858adf7dcd0 = {
    ...$07b489c9a6cbc9d4$export$882cd4124a942c79,
    router: $07b489c9a6cbc9d4$export$47bde86d5ec3fc9c
};
const $07b489c9a6cbc9d4$export$7f202753e6a32b2b = {
    state: {},
    pages: {},
    components: {},
    router: $07b489c9a6cbc9d4$export$47bde86d5ec3fc9c,
    define: (0, $kzEwp.defaultDefine)
};
var $07b489c9a6cbc9d4$export$2e2bcd8739ae039 = $07b489c9a6cbc9d4$export$7f202753e6a32b2b;

});
parcelRegister("kzEwp", function(module, exports) {

$parcel$export(module.exports, "defaultDefine", () => $efa68247d5355cfe$export$6588fc50c67b09a2);
$parcel$export(module.exports, "createDefine", () => $efa68247d5355cfe$export$7769a5ae7ef35542);

var $bpKUI = parcelRequire("bpKUI");

var $fLrnc = parcelRequire("fLrnc");
'use strict';
const $efa68247d5355cfe$var$fetchHandler = (param, el, state, context)=>{
    if (!param) return;
    (0, $fLrnc.executeFetch)(param, el, state, context);
};
const $efa68247d5355cfe$var$metadataHandler = (param, el, state)=>{
    if (!param) return;
    const doc = el.context?.document || typeof document !== 'undefined' && document;
    if (!doc) return;
    const resolved = (0, $bpKUI.resolveMetadata)(param, el, state);
    (0, $bpKUI.applyMetadata)(resolved, doc);
};
const $efa68247d5355cfe$var$routerHandler = async (param, el)=>{
    if (!param) return;
    const obj = {
        tag: 'fragment',
        ...param
    };
    const set = async ()=>{
        await el.set(obj, {
            preventDefineUpdate: '$router'
        });
    };
    if (el.lazyLoad) window.requestAnimationFrame(set);
    else await set();
    return obj;
};
const $efa68247d5355cfe$export$6588fc50c67b09a2 = {
    routes: (param)=>param,
    metadata: $efa68247d5355cfe$var$metadataHandler,
    fetch: $efa68247d5355cfe$var$fetchHandler,
    $router: $efa68247d5355cfe$var$routerHandler
};
const $efa68247d5355cfe$export$7769a5ae7ef35542 = (opts = {})=>{
    const define = {
        routes: (param)=>param
    };
    if (opts.metadata !== false) define.metadata = $efa68247d5355cfe$var$metadataHandler;
    if (opts.fetch !== false) define.fetch = $efa68247d5355cfe$var$fetchHandler;
    if (opts.router !== false) define.$router = $efa68247d5355cfe$var$routerHandler;
    return define;
};

});
parcelRegister("bpKUI", function(module, exports) {

$parcel$export(module.exports, "resolveMetadata", () => $84f66b9cc4cc43c7$export$d2032d3864484f3);
$parcel$export(module.exports, "applyMetadata", () => $84f66b9cc4cc43c7$export$961d8bb4ed050676);
$parcel$export(module.exports, "helmetPlugin", () => $84f66b9cc4cc43c7$export$4f83b73c16715677);
parcelRequire("2oe0q");
var $bmfNh = parcelRequire("bmfNh");
var $fX7ii = parcelRequire("fX7ii");
'use strict';
// ── Meta tag registry ──────────────────────────────────────────────────────
const $84f66b9cc4cc43c7$var$META_TAGS = {
    title: {
        tag: 'title'
    },
    description: {
        tag: 'meta',
        attr: 'name',
        key: 'description'
    },
    keywords: {
        tag: 'meta',
        attr: 'name',
        key: 'keywords'
    },
    robots: {
        tag: 'meta',
        attr: 'name',
        key: 'robots'
    },
    author: {
        tag: 'meta',
        attr: 'name',
        key: 'author'
    },
    canonical: {
        tag: 'link',
        attr: 'rel',
        key: 'canonical',
        valueAttr: 'href'
    },
    image: {
        tag: 'meta',
        attr: 'property',
        key: 'og:image'
    },
    url: {
        tag: 'meta',
        attr: 'property',
        key: 'og:url'
    },
    siteName: {
        tag: 'meta',
        attr: 'property',
        key: 'og:site_name'
    },
    type: {
        tag: 'meta',
        attr: 'property',
        key: 'og:type'
    },
    locale: {
        tag: 'meta',
        attr: 'property',
        key: 'og:locale'
    },
    'og:title': {
        tag: 'meta',
        attr: 'property',
        key: 'og:title'
    },
    'og:description': {
        tag: 'meta',
        attr: 'property',
        key: 'og:description'
    },
    'og:image': {
        tag: 'meta',
        attr: 'property',
        key: 'og:image'
    },
    'og:url': {
        tag: 'meta',
        attr: 'property',
        key: 'og:url'
    },
    'og:type': {
        tag: 'meta',
        attr: 'property',
        key: 'og:type'
    },
    'og:site_name': {
        tag: 'meta',
        attr: 'property',
        key: 'og:site_name'
    },
    'og:locale': {
        tag: 'meta',
        attr: 'property',
        key: 'og:locale'
    },
    'twitter:card': {
        tag: 'meta',
        attr: 'name',
        key: 'twitter:card'
    },
    'twitter:title': {
        tag: 'meta',
        attr: 'name',
        key: 'twitter:title'
    },
    'twitter:description': {
        tag: 'meta',
        attr: 'name',
        key: 'twitter:description'
    },
    'twitter:image': {
        tag: 'meta',
        attr: 'name',
        key: 'twitter:image'
    },
    'twitter:site': {
        tag: 'meta',
        attr: 'name',
        key: 'twitter:site'
    },
    'theme-color': {
        tag: 'meta',
        attr: 'name',
        key: 'theme-color'
    }
};
// ── Shared utilities ────────────────────────────────────────────────────────
const $84f66b9cc4cc43c7$var$createQuery = (obj)=>{
    if (obj.tag === 'link') return `link[${obj.attr}="${obj.key}"]`;
    if (obj.tag && !obj.attr && !obj.key) return obj.tag;
    if (obj.tag && obj.attr && obj.key) return `${obj.tag}[${obj.attr}="${obj.key}"]`;
};
const $84f66b9cc4cc43c7$export$d2032d3864484f3 = (metadata, element, state)=>{
    if (!metadata) return {};
    const resolved = (0, $fX7ii.isFunction)(metadata) ? (0, $bmfNh.exec)(metadata, element, state) : {
        ...metadata
    };
    if (!(0, $fX7ii.isObject)(resolved)) return {};
    for(const key in resolved){
        let val = resolved[key];
        if ((0, $fX7ii.isFunction)(val)) val = (0, $bmfNh.exec)(val, element, state);
        if ((0, $fX7ii.isString)(val) && val.includes('{{') && element?.call) val = element.call('replaceLiteralsWithObjectFields', val, state);
        resolved[key] = val;
    }
    return resolved;
};
const $84f66b9cc4cc43c7$export$ff8c3ec904fd95bb = (data, route = '/', element, state)=>{
    const pages = data.pages || {};
    const page = pages[route];
    let metadata = {};
    if (data.integrations?.seo) metadata = {
        ...data.integrations.seo
    };
    if (data.app?.metadata) {
        const appMeta = $84f66b9cc4cc43c7$export$d2032d3864484f3(data.app.metadata, element, state);
        metadata = {
            ...metadata,
            ...appMeta
        };
    }
    // Track which OG keys the page explicitly sets
    const pageExplicitKeys = new Set();
    if (page) {
        const pageMeta = page.metadata || page.helmet || {};
        const resolved = $84f66b9cc4cc43c7$export$d2032d3864484f3(pageMeta, element, state);
        for(const key in resolved)pageExplicitKeys.add(key);
        metadata = {
            ...metadata,
            ...resolved
        };
        if (!metadata.title && page.state?.title) {
            metadata.title = page.state.title;
            pageExplicitKeys.add('title');
        }
        if (!metadata.description && page.state?.description) {
            metadata.description = page.state.description;
            pageExplicitKeys.add('description');
        }
    }
    if (!metadata.title) metadata.title = data.name || 'Symbols';
    // Auto-cascade page-level title/description to OG/Twitter tags
    // when the page overrides title but doesn't explicitly set og:title
    if (metadata.title && (pageExplicitKeys.has('title') || !metadata['og:title'])) {
        if (!pageExplicitKeys.has('og:title')) metadata['og:title'] = metadata.title;
    }
    if (metadata.description && (pageExplicitKeys.has('description') || !metadata['og:description'])) {
        if (!pageExplicitKeys.has('og:description')) metadata['og:description'] = metadata.description;
    }
    if (metadata.title && !metadata['twitter:title']) metadata['twitter:title'] = metadata.title;
    if (metadata.description && !metadata['twitter:description']) metadata['twitter:description'] = metadata.description;
    // Make og:url route-aware — append the route path to the base URL
    if (metadata['og:url'] || metadata.url) {
        const baseUrl = (metadata['og:url'] || metadata.url || '').replace(/\/$/, '');
        if (baseUrl && route && route !== '/') {
            const cleanRoute = route.startsWith('/') ? route : '/' + route;
            metadata['og:url'] = baseUrl + cleanRoute;
        }
    }
    // Resolve bare filenames
    if (data.files) for(const key in metadata){
        const val = metadata[key];
        if (typeof val === 'string' && val.length > 0 && !val.startsWith('/') && !val.startsWith('http')) {
            const fileEntry = data.files[val];
            if (fileEntry?.src) metadata[key] = fileEntry.src;
        }
    }
    return metadata;
};
// ── DOM runtime (browser) ───────────────────────────────────────────────────
const $84f66b9cc4cc43c7$var$createMetaElement = (metaObj, doc)=>{
    const domElement = doc.createElement(metaObj.tag);
    if (metaObj.attr) domElement.setAttribute(metaObj.attr, metaObj.key);
    const head = doc.head || doc.querySelector('head');
    head.appendChild(domElement);
    return domElement;
};
const $84f66b9cc4cc43c7$export$961d8bb4ed050676 = (metadata, doc)=>{
    if (!(0, $fX7ii.isObject)(metadata) || !doc) return;
    for(const key in metadata){
        const value = metadata[key];
        if (value === undefined || value === null) continue;
        const metaObj = $84f66b9cc4cc43c7$var$META_TAGS[key];
        if (!metaObj) continue;
        const query = $84f66b9cc4cc43c7$var$createQuery(metaObj);
        const domElement = doc.querySelector(query) || $84f66b9cc4cc43c7$var$createMetaElement(metaObj, doc);
        if (!domElement) continue;
        if (key === 'title') domElement.textContent = value;
        else if (metaObj.valueAttr) domElement.setAttribute(metaObj.valueAttr, value);
        else domElement.setAttribute('content', value);
    }
};
// ── SSR (brender) ───────────────────────────────────────────────────────────
const $84f66b9cc4cc43c7$var$esc = (text)=>{
    if (text === null || text === undefined) return '';
    const map = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
    };
    return text.toString().replace(/[&<>"']/g, (m)=>map[m]);
};
const $84f66b9cc4cc43c7$export$ebea745cf9b6b083 = (metadata)=>{
    const tags = [
        '<meta charset="UTF-8">'
    ];
    // Track which keys we've already handled via the hardcoded tags above
    const SKIP_KEYS = new Set([
        'charset'
    ]);
    let hasViewport = false;
    for (const [key, value] of Object.entries(metadata)){
        if (!value && value !== 0 && value !== false) continue;
        if (SKIP_KEYS.has(key)) continue;
        if (key === 'title') {
            tags.push(`<title>${$84f66b9cc4cc43c7$var$esc(value)}</title>`);
            continue;
        }
        // Viewport — emit once, prefer metadata value over default
        if (key === 'viewport') {
            if (!hasViewport) {
                tags.push(`<meta name="viewport" content="${$84f66b9cc4cc43c7$var$esc(value)}">`);
                hasViewport = true;
            }
            continue;
        }
        if (key === 'canonical') {
            tags.push(`<link rel="canonical" href="${$84f66b9cc4cc43c7$var$esc(value)}">`);
            continue;
        }
        // Icon / favicon → <link rel="icon">
        if (key === 'icon' || key === 'favicon') {
            const href = $84f66b9cc4cc43c7$var$esc(value);
            const type = href.endsWith('.svg') ? ' type="image/svg+xml"' : href.endsWith('.png') ? ' type="image/png"' : '';
            tags.push(`<link rel="icon" href="${href}"${type}>`);
            continue;
        }
        // Multiple favicons (different sizes)
        if (key === 'favicons' && Array.isArray(value)) {
            value.forEach((fav)=>{
                if (typeof fav === 'object') {
                    const attrs = Object.entries(fav).map(([k, v])=>`${k}="${$84f66b9cc4cc43c7$var$esc(v)}"`).join(' ');
                    tags.push(`<link rel="icon" ${attrs}>`);
                } else if (typeof fav === 'string') tags.push(`<link rel="icon" href="${$84f66b9cc4cc43c7$var$esc(fav)}">`);
            });
            continue;
        }
        if (key === 'alternate' && Array.isArray(value)) {
            value.forEach((alt)=>{
                if (typeof alt === 'object') {
                    const attrs = Object.entries(alt).map(([k, v])=>`${k}="${$84f66b9cc4cc43c7$var$esc(v)}"`).join(' ');
                    tags.push(`<link rel="alternate" ${attrs}>`);
                }
            });
            continue;
        }
        const propertyPrefixes = [
            'og:',
            'article:',
            'product:',
            'fb:',
            'profile:',
            'book:',
            'business:',
            'music:',
            'video:'
        ];
        const namePrefixes = [
            'twitter:',
            'DC:',
            'DCTERMS:'
        ];
        const isProperty = propertyPrefixes.some((p)=>key.startsWith(p));
        const isName = namePrefixes.some((p)=>key.startsWith(p));
        if (key.startsWith('http-equiv:')) {
            const httpKey = key.replace('http-equiv:', '');
            tags.push(`<meta http-equiv="${$84f66b9cc4cc43c7$var$esc(httpKey)}" content="${$84f66b9cc4cc43c7$var$esc(value)}">`);
        } else if (key.startsWith('itemprop:')) {
            const itemKey = key.replace('itemprop:', '');
            tags.push(`<meta itemprop="${$84f66b9cc4cc43c7$var$esc(itemKey)}" content="${$84f66b9cc4cc43c7$var$esc(value)}">`);
        } else if (isProperty) {
            if (Array.isArray(value)) value.forEach((v)=>tags.push(`<meta property="${$84f66b9cc4cc43c7$var$esc(key)}" content="${$84f66b9cc4cc43c7$var$esc(v)}">`));
            else tags.push(`<meta property="${$84f66b9cc4cc43c7$var$esc(key)}" content="${$84f66b9cc4cc43c7$var$esc(value)}">`);
        } else if (isName) tags.push(`<meta name="${$84f66b9cc4cc43c7$var$esc(key)}" content="${$84f66b9cc4cc43c7$var$esc(value)}">`);
        else {
            if (Array.isArray(value)) value.forEach((v)=>tags.push(`<meta name="${$84f66b9cc4cc43c7$var$esc(key)}" content="${$84f66b9cc4cc43c7$var$esc(v)}">`));
            else if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') tags.push(`<meta name="${$84f66b9cc4cc43c7$var$esc(key)}" content="${$84f66b9cc4cc43c7$var$esc(value)}">`);
        }
    }
    // Ensure viewport is always present
    if (!hasViewport) tags.splice(1, 0, '<meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1, user-scalable=no">');
    return tags.join('\n');
};
const $84f66b9cc4cc43c7$export$dcef8f9bb9a41431 = {
    define: {
        metadata: (param, el, state)=>{
            const doc = el.context?.document || typeof document !== 'undefined' && document;
            if (!doc) return;
            const resolved = $84f66b9cc4cc43c7$export$d2032d3864484f3(param, el, state);
            $84f66b9cc4cc43c7$export$961d8bb4ed050676(resolved, doc);
            // Store on root state for interop
            const rootState = el.state?.root;
            if ((0, $fX7ii.isObject)(rootState)) rootState.$helmet = resolved;
        }
    }
};
const $84f66b9cc4cc43c7$export$4f83b73c16715677 = {
    name: 'helmet',
    create (element) {
        const param = element.metadata;
        if (!param) return;
        const doc = element.context?.document || typeof document !== 'undefined' && document;
        if (!doc) return;
        const resolved = $84f66b9cc4cc43c7$export$d2032d3864484f3(param, element, element.state);
        $84f66b9cc4cc43c7$export$961d8bb4ed050676(resolved, doc);
    },
    update (element) {
        const param = element.metadata;
        if (!param) return;
        const doc = element.context?.document || typeof document !== 'undefined' && document;
        if (!doc) return;
        const resolved = $84f66b9cc4cc43c7$export$d2032d3864484f3(param, element, element.state);
        $84f66b9cc4cc43c7$export$961d8bb4ed050676(resolved, doc);
    }
};
var $84f66b9cc4cc43c7$export$2e2bcd8739ae039 = $84f66b9cc4cc43c7$export$dcef8f9bb9a41431;

});



parcelRegister("aShRn", function(module, exports) {

$parcel$export(module.exports, "createDomqlElement", () => $7eaccd26feb36f24$export$b5b313bfdabf2fb4);
parcelRequire("cm1sg");
var $fQWe4 = parcelRequire("fQWe4");
parcelRequire("dcsWo");
var $bfrry = parcelRequire("bfrry");

var $dXl0a = parcelRequire("dXl0a");
parcelRequire("2oe0q");
var $bmfNh = parcelRequire("bmfNh");
var $elDKY = parcelRequire("elDKY");
var $fX7ii = parcelRequire("fX7ii");

var $kzEwp = parcelRequire("kzEwp");

var $qLhL5 = parcelRequire("qLhL5");

var $ilkkj = parcelRequire("ilkkj");
parcelRequire("k17B8");
var $bbZ29 = parcelRequire("bbZ29");
var $k17B8 = parcelRequire("k17B8");

var $d9FvG = parcelRequire("d9FvG");

var $hurDj = parcelRequire("hurDj");

var $bpKUI = parcelRequire("bpKUI");

var $fLrnc = parcelRequire("fLrnc");

var $ibNFW = parcelRequire("ibNFW");

var $lYcxN = parcelRequire("lYcxN");
parcelRequire("llcnc");
var $aNrRl = parcelRequire("aNrRl");
var $2Bw3N = parcelRequire("2Bw3N");
'use strict';

const $7eaccd26feb36f24$export$9c634076e0a91d1f = async (app, context = {})=>{
    // Identifier the runner uses to look up an app for teardown / instrumentation.
    // Prefer `{owner}--{key}` from symbols.json when both are present so two apps
    // with the same key but different owners stay distinguishable in shared realms.
    const cfg = context.symbolsConfig;
    const symbolsKey = cfg?.owner && cfg?.key ? `${cfg.owner}--${cfg.key}` : cfg?.key;
    const key = context.key = context.key || symbolsKey || ((0, $fX7ii.isString)(app) ? app : 'smblsapp');
    context.define = context.define || (0, $kzEwp.defaultDefine);
    context.cssPropsRegistry = (0, $dXl0a.CSS_PROPS_REGISTRY);
    context.window = (0, $k17B8.prepareWindow)(context);
    if (context.sharedLibraries && context.sharedLibraries.length) {
        // Resolve string entries (e.g. 'system/default') by fetching from KV/API
        const hasStrings = context.sharedLibraries.some((lib)=>typeof lib === 'string');
        if (hasStrings) {
            const { resolveSharedLibraries: resolveSharedLibraries } = await Promise.resolve((parcelRequire("2oe0q")));
            context.sharedLibraries = await resolveSharedLibraries(context.sharedLibraries);
        }
        (0, $k17B8.prepareSharedLibs)(context);
    }
    const [scratcDesignSystem, registry] = (0, $k17B8.prepareDesignSystem)(key, context);
    context.designSystem = scratcDesignSystem;
    context.registry = registry;
    // Set up context.cases from context-level cases (defined in symbols/cases.js)
    if (!context.cases) context.cases = {};
    // Expand shorthand data early, before components/pages are merged with uikit
    if (context.shorthand) (0, $lYcxN.shorthandPlugin).prepareContext(context);
    const state = (0, $k17B8.prepareState)(app, context);
    context.state = state;
    context.pages = (0, $k17B8.preparePages)(app, context);
    context.components = (0, $k17B8.prepareComponents)(context);
    context.utils = (0, $k17B8.prepareUtils)(context);
    if ((0, $bbZ29.PACKAGE_MANAGER_TO_CDN)[context.packageManager]) context.dependencies = await (0, $k17B8.prepareDependencies)(context);
    context.methods = (0, $k17B8.prepareMethods)(context);
    context.routerOptions = (0, $qLhL5.initRouter)(app, context);
    context.defaultExtends = [
        $bfrry.Box
    ];
    context.snippets = context.snippets || {};
    context.functions = context.functions || {};
    context.plugins = context.plugins || [];
    // Destringify globalScope: function strings → executable functions.
    // Functions are eval'd in a closure where all globalScope values are available,
    // so helpers can reference constants and other helpers naturally.
    if (context.globalScope && (0, $fX7ii.isObject)(context.globalScope)) context.globalScope = (0, $bmfNh.destringifyGlobalScope)(context.globalScope);
    // Rehydrate function-strings throughout the project tree. When frank
    // serializes a project for the platform it `.toString()`s every function
    // value (onClick, onRender, hide, transform, text-as-fn, etc.) into JSON.
    // Without this pass, the runtime would treat those strings as their
    // nominal type — invalid CSS for `transform`, dead listeners for
    // `onClick`, raw source code shown for `text`, etc. — which is the root
    // cause of every "works on dev / dead on remote" divergence we've ever
    // seen for v4 published projects. Walks the same buckets prepareContext
    // populated above, mutating each into a tree where every detectable
    // function-string has been `eval`'d back to a real function.
    // ESM-namespace-shaped buckets (`import * as functions from ...`) have
    // getter-only own properties — Object.assign throws on them. Some bundlers
    // (Parcel) emit such objects while keeping them extensible, so isExtensible
    // isn't reliable; use try/catch and reassign when mutation fails.
    const rehydrate = (target, key)=>{
        const value = key ? target[key] : target;
        if (!(0, $fX7ii.isObject)(value)) return;
        const destringified = (0, $bmfNh.deepDestringifyFunctions)(value);
        try {
            Object.assign(value, destringified);
        } catch (e) {
            if (key) target[key] = destringified;
            else throw e;
        }
    };
    rehydrate(app);
    rehydrate(context, 'components');
    rehydrate(context, 'pages');
    rehydrate(context, 'functions');
    rehydrate(context, 'methods');
    rehydrate(context, 'snippets');
    rehydrate(context, 'app');
    // Clear adapter cache to ensure fresh resolution with current config
    if (context.fetch && context.fetch.__resolved) delete context.fetch.__resolved;
    if (context.db && context.db.__resolved) delete context.db.__resolved;
    // Auto-register plugins based on context config
    const hasPlugin = (name)=>context.plugins.some((p)=>p.name === name);
    if (context.polyglot && !hasPlugin('polyglot')) {
        context.plugins.push((0, $d9FvG.polyglotPlugin));
        for(const k in 0, $hurDj.polyglotFunctions)if (!(k in context.functions)) context.functions[k] = (0, $hurDj.polyglotFunctions)[k];
    }
    if (!hasPlugin('helmet')) context.plugins.push((0, $bpKUI.helmetPlugin));
    if (context.fetch && !hasPlugin('fetch')) context.plugins.push((0, $fLrnc.fetchPlugin));
    if (context.designSystem?.typography?.useCapsize !== false && !hasPlugin('capsize')) {
        context.plugins.push((0, $ibNFW.capsizePlugin));
        context.cssPropsRegistry.useCapsize = (0, $ibNFW.capsizeHandler);
    }
    if (context.shorthand && !hasPlugin('shorthand')) context.plugins.push((0, $lYcxN.shorthandPlugin));
    // Analyze plugin — runtime audit logger. Opt-in via `analyze: true` or
    // `analyze: { ... }`. Errors and warnings captured by default; everything
    // else off until explicitly enabled.
    if (context.analyze && !hasPlugin('analyze')) {
        const analyzeConfig = context.analyze === true ? {} : context.analyze;
        context.analyze = (0, $2Bw3N.createAnalyzeState)(analyzeConfig);
        context.plugins.push((0, $aNrRl.analyzePlugin));
    }
    return context;
};
const $7eaccd26feb36f24$export$b5b313bfdabf2fb4 = async (app, ctx)=>{
    if (!(0, $fX7ii.isObject)(ctx)) ctx = {};
    if ((0, $elDKY.isNode)(app)) {
        app = {};
        ctx.parent = app;
    } else if ((0, $fX7ii.isString)(app)) {
        app = {};
        ctx.key = app;
    } else if (!(0, $fX7ii.isObject)(app)) app = {};
    // Detect brender BEFORE prepareContext so we can snapshot SSR styles.
    const win = ctx.window || (typeof window !== 'undefined' ? window : null);
    const isBrendered = win?.__BRENDER__;
    // Snapshot SSR style tags BEFORE prepareContext creates CSS styles.
    // fallbackRender will only remove these — not the fresh CSS engine tag.
    let ssrStyles = null;
    if (isBrendered) {
        const d = ctx.document || (typeof document !== 'undefined' ? document : null);
        if (d) ssrStyles = Array.from(d.head.querySelectorAll('style'));
    }
    await $7eaccd26feb36f24$export$9c634076e0a91d1f(app, ctx);
    // Inject CSS reset after design system init
    if (ctx.useReset !== false) {
        const doc = ctx.document || (typeof document !== 'undefined' ? document : null);
        if (doc) {
            let style = doc.head.querySelector('style[data-smbls]');
            if (!style) {
                style = doc.createElement('style');
                style.setAttribute('data-smbls', '');
                doc.head.appendChild(style);
            }
            const s = style.sheet;
            if (s) {
                try {
                    s.insertRule('*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }', 0);
                } catch (e) {}
                try {
                    s.insertRule('h1, h2, h3, h4, h5, h6 { font-size: inherit; font-weight: inherit; }', 1);
                } catch (e) {}
            }
        }
    }
    // Merge context.app (from app.js) onto root element definition
    if (ctx.app && (0, $fX7ii.isObject)(ctx.app)) {
        for(const k in ctx.app)if (app[k] === undefined) app[k] = ctx.app[k];
    }
    app.extends = (0, $ilkkj.initializeExtend)(app, ctx);
    if (ctx.router !== false) app.routes = ctx.pages;
    app.state = ctx.state;
    app.context = ctx;
    app.data = app.data || {};
    if (!ctx.skipDesignSystemInit) await (0, $k17B8.prepareRequire)({
        functions: ctx.functions,
        utils: ctx.utils,
        snippets: ctx.snippets,
        ...ctx.files
    }, ctx);
    (0, $ilkkj.initializeSync)(app, ctx);
    (0, $ilkkj.initializeNotifications)(app, ctx);
    const doc = ctx.document;
    if (!doc || !doc.createElement) return app;
    const parentNode = ctx.parent || doc.body;
    if (isBrendered) return $7eaccd26feb36f24$var$fallbackRender((0, $fQWe4.create), app, parentNode, ctx, win, ssrStyles);
    // v4: use @symbo.ls/element create directly
    const smblsApp = (0, $fQWe4.create)(app, parentNode, ctx.key, {
        verbose: ctx.verbose,
        context: ctx,
        ...ctx.domqlOptions
    });
    // Keep activeDocument set to iframe doc so late-rendering elements
    // (lifecycle hooks, async children) inject CSS into the correct document.
    // The next create() call will set it to its own document.
    // Expose root element for debugging
    if (typeof window !== 'undefined' && !ctx.document) window.__smblsApp = smblsApp;
    return smblsApp;
};
/**
 * Legacy fallback: remove brender content and re-create DOMQL normally.
 * CSS stays in <style> tags so re-render is fast (no FOUC for styles).
 */ const $7eaccd26feb36f24$var$fallbackRender = async (createFn, app, parentNode, ctx, win, ssrStyles)=>{
    const doc = parentNode.ownerDocument || document;
    // Remove only the SSR style tags that existed before prepareContext.
    // This preserves the fresh <style> tag created by prepareDesignSystem.
    if (ssrStyles) ssrStyles.forEach((s)=>{
        if (s.parentNode) s.remove();
    });
    // Remove brender content but keep framework-injected elements:
    // <script>, <link>, <style> (page infrastructure)
    // <svg> with id (SVG/icon sprites injected by initDesignSystem)
    const toRemove = [];
    for (const child of parentNode.childNodes){
        if (child.nodeType === 1) {
            const tag = child.tagName.toLowerCase();
            if (tag === 'script' || tag === 'link' || tag === 'style') continue;
            if (tag === 'svg' && child.id) continue; // SVG sprite containers
        }
        toRemove.push(child);
    }
    toRemove.forEach((n)=>n.remove());
    // Also remove stale data-br attributes from any remaining elements
    doc.querySelectorAll('[data-br]').forEach((el)=>el.removeAttribute('data-br'));
    const smblsApp = createFn(app, parentNode, ctx.key, {
        verbose: ctx.verbose,
        context: ctx,
        ...ctx.domqlOptions
    });
    $7eaccd26feb36f24$var$cleanup(win);
    return smblsApp;
};
const $7eaccd26feb36f24$var$cleanup = (win)=>{
    if (!win) return;
    delete win.__BRENDER__;
    delete win.__BR_REGISTRY__;
};

});
parcelRegister("dcsWo", function(module, exports) {

var $3kR9H = parcelRequire("3kR9H");

var $hY3wI = parcelRequire("hY3wI");

var $hoPNQ = parcelRequire("hoPNQ");

var $cvVd0 = parcelRequire("cvVd0");

var $jF4vp = parcelRequire("jF4vp");

var $1nFdY = parcelRequire("1nFdY");

var $8VmFN = parcelRequire("8VmFN");

var $j0bHI = parcelRequire("j0bHI");

var $bpa5t = parcelRequire("bpa5t");

var $9btdB = parcelRequire("9btdB");

var $ii8kW = parcelRequire("ii8kW");

var $bfrry = parcelRequire("bfrry");

var $gHawJ = parcelRequire("gHawJ");

var $juqT0 = parcelRequire("juqT0");

var $2hoIt = parcelRequire("2hoIt");

var $bBcty = parcelRequire("bBcty");

var $3Gz7s = parcelRequire("3Gz7s");

var $hYecS = parcelRequire("hYecS");

var $j10Zl = parcelRequire("j10Zl");

var $gecpK = parcelRequire("gecpK");

var $i7vYK = parcelRequire("i7vYK");

var $83rqz = parcelRequire("83rqz");

var $aWQsI = parcelRequire("aWQsI");

var $b2KzY = parcelRequire("b2KzY");

var $2lRdd = parcelRequire("2lRdd");

var $5sr83 = parcelRequire("5sr83");

var $dYaic = parcelRequire("dYaic");

var $4YNkk = parcelRequire("4YNkk");

var $VkIr2 = parcelRequire("VkIr2");
'use strict';
$parcel$exportWildcard(module.exports, $3kR9H);
$parcel$exportWildcard(module.exports, $hY3wI);
$parcel$exportWildcard(module.exports, $hoPNQ);
$parcel$exportWildcard(module.exports, $cvVd0);
$parcel$exportWildcard(module.exports, $jF4vp);
$parcel$exportWildcard(module.exports, $1nFdY);
$parcel$exportWildcard(module.exports, $8VmFN);
$parcel$exportWildcard(module.exports, $j0bHI);
$parcel$exportWildcard(module.exports, $bpa5t);
$parcel$exportWildcard(module.exports, $9btdB);
$parcel$exportWildcard(module.exports, $ii8kW);
$parcel$exportWildcard(module.exports, $bfrry);
$parcel$exportWildcard(module.exports, $gHawJ);
$parcel$exportWildcard(module.exports, $juqT0);
$parcel$exportWildcard(module.exports, $2hoIt);
$parcel$exportWildcard(module.exports, $bBcty);
$parcel$exportWildcard(module.exports, $3Gz7s);
$parcel$exportWildcard(module.exports, $hYecS);
$parcel$exportWildcard(module.exports, $j10Zl);
$parcel$exportWildcard(module.exports, $gecpK);
$parcel$exportWildcard(module.exports, $i7vYK);
$parcel$exportWildcard(module.exports, $83rqz);
$parcel$exportWildcard(module.exports, $aWQsI);
$parcel$exportWildcard(module.exports, $b2KzY);
$parcel$exportWildcard(module.exports, $2lRdd);
$parcel$exportWildcard(module.exports, $5sr83);
$parcel$exportWildcard(module.exports, $dYaic);
$parcel$exportWildcard(module.exports, $4YNkk);
$parcel$exportWildcard(module.exports, $VkIr2);

});
parcelRegister("3kR9H", function(module, exports) {

$parcel$export(module.exports, "Block", () => $26dc78e699a9d202$export$d96a8827a60d6b69);
$parcel$export(module.exports, "Inline", () => $26dc78e699a9d202$export$fbae5b5ffd8af05e);
$parcel$export(module.exports, "Flex", () => $26dc78e699a9d202$export$f51f4c4ede09e011);
$parcel$export(module.exports, "InlineFlex", () => $26dc78e699a9d202$export$5d643ad162c021dc);
$parcel$export(module.exports, "Grid", () => $26dc78e699a9d202$export$ef2184bd89960b14);
$parcel$export(module.exports, "InlineGrid", () => $26dc78e699a9d202$export$1e7ecf8382e655ff);
$parcel$export(module.exports, "Gutter", () => $26dc78e699a9d202$export$b710539649c46ff);
'use strict';
const $26dc78e699a9d202$export$d96a8827a60d6b69 = {
    display: 'block'
};
const $26dc78e699a9d202$export$fbae5b5ffd8af05e = {
    display: 'inline'
};
const $26dc78e699a9d202$export$f51f4c4ede09e011 = {
    display: 'flex'
};
const $26dc78e699a9d202$export$5d643ad162c021dc = {
    display: 'inline-flex'
};
const $26dc78e699a9d202$export$ef2184bd89960b14 = {
    display: 'grid'
};
const $26dc78e699a9d202$export$1e7ecf8382e655ff = {
    display: 'inline-grid'
};
const $26dc78e699a9d202$export$b710539649c46ff = {
    boxSize: 'C1'
};

});

parcelRegister("hY3wI", function(module, exports) {

$parcel$export(module.exports, "Img", () => $d14ac69752a6f882$export$cc7b5f925acc71d3);
'use strict';
const $d14ac69752a6f882$export$cc7b5f925acc71d3 = {
    tag: 'img',
    attr: {
        title: (el)=>el.title || el.alt
    }
};

});

parcelRegister("hoPNQ", function(module, exports) {

$parcel$export(module.exports, "Form", () => $caacdc8fe8810186$export$a7fed597f4b8afd8);
'use strict';
const $caacdc8fe8810186$export$a7fed597f4b8afd8 = {
    tag: 'form'
};

});

parcelRegister("cvVd0", function(module, exports) {

$parcel$export(module.exports, "Iframe", () => $91c4c1c7a2754b8a$export$5137ec99f248330b);
'use strict';
const $91c4c1c7a2754b8a$export$5137ec99f248330b = {
    tag: 'iframe',
    position: 'relative',
    minWidth: 'H',
    minHeight: 'H'
};

});

parcelRegister("jF4vp", function(module, exports) {

$parcel$export(module.exports, "Hoverable", () => $e5055761a6c521aa$export$8cf654b375a16d2d);
$parcel$export(module.exports, "Clickable", () => $e5055761a6c521aa$export$2f51d37476d4c437);
$parcel$export(module.exports, "Focusable", () => $e5055761a6c521aa$export$35a3bebf7ef2d934);
$parcel$export(module.exports, "FocusableComponent", () => $e5055761a6c521aa$export$b177f82f5511f000);
'use strict';
const $e5055761a6c521aa$var$style = {
    appearance: 'none',
    cursor: 'pointer',
    fontFamily: 'inherit'
};
const $e5055761a6c521aa$export$8cf654b375a16d2d = {
    transition: 'C defaultBezier',
    transitionProperty: 'opacity, transform',
    opacity: 0.85,
    ':hover': {
        opacity: 0.9,
        transform: 'scale(1.015)'
    },
    ':active': {
        opacity: 1,
        transform: 'scale(1.015)'
    },
    '.active': {
        opacity: 1,
        transform: 'scale(1.015)',
        ':hover': {
            opacity: 1
        }
    }
};
const $e5055761a6c521aa$export$2f51d37476d4c437 = {
    extends: 'Hoverable',
    ':active': {
        opacity: 1,
        transform: 'scale(1.015)'
    },
    '.active': {
        opacity: 1
    }
};
const $e5055761a6c521aa$export$35a3bebf7ef2d934 = {
    border: 'none',
    outline: 'solid 0 blue.3',
    ':focus-visible': {
        opacity: 1,
        outline: 'solid X blue.3'
    },
    attr: {
        tabIndex: (el)=>el.tabIndex
    }
};
const $e5055761a6c521aa$export$b177f82f5511f000 = {
    extends: 'Focusable',
    tag: 'button',
    fontSize: 'A',
    type: 'button',
    border: 'none',
    textDecoration: 'none',
    lineHeight: '1',
    whiteSpace: 'nowrap',
    fontFamily: 'inherit',
    style: $e5055761a6c521aa$var$style
};

});

parcelRegister("1nFdY", function(module, exports) {

$parcel$export(module.exports, "Picture", () => $1017eabb027173c8$export$f0d5dc2ce3e4cb5f);

var $9btdB = parcelRequire("9btdB");
'use strict';
const $1017eabb027173c8$export$f0d5dc2ce3e4cb5f = {
    deps: {
        getSystemGlobalTheme: $9btdB.getSystemGlobalTheme
    },
    tag: 'picture',
    childExtends: {
        deps: {
            getSystemGlobalTheme: $9btdB.getSystemGlobalTheme
        },
        tag: 'source',
        attr: {
            media: (element)=>{
                const { key: key, context: context, deps: deps } = element;
                const { media: media } = context.designSystem;
                const globalTheme = deps.getSystemGlobalTheme(element);
                const mediaName = (element.media || key).slice(1);
                if (mediaName === globalTheme) return '(min-width: 0px)';
                else if (mediaName === 'dark' || mediaName === 'light') return '(max-width: 0px)';
                return media[mediaName];
            }
        }
    },
    Img: {
        width: 'inherit',
        ignoreChildExtends: true,
        height: 'inherit',
        src: (element, state)=>element.parent?.src || state.src
    }
};

});
parcelRegister("9btdB", function(module, exports) {

$parcel$export(module.exports, "getSystemGlobalTheme", () => $6afbce4a2e1bc509$export$f12bbb197a836138);
$parcel$export(module.exports, "Theme", () => $6afbce4a2e1bc509$export$14faa19a0f3bbeb2);

var $j0bHI = parcelRequire("j0bHI");
parcelRequire("2oe0q");
var $fX7ii = parcelRequire("fX7ii");
'use strict';
const $6afbce4a2e1bc509$export$f12bbb197a836138 = ({ context: context, state: state })=>{
    const rootState = state && state.root;
    const theme = rootState && rootState.globalTheme || context.designSystem && context.designSystem.globalTheme;
    return theme === 'auto' ? null : theme;
};
const $6afbce4a2e1bc509$export$14faa19a0f3bbeb2 = {
    deps: {
        depth: $j0bHI.depth
    },
    classlist: {
        depth: (el)=>!(0, $fX7ii.isUndefined)(el.depth) && el.deps.depth[el.depth]
    }
};

});
parcelRegister("j0bHI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "depth", () => $dd57189c68eaada0$export$b202ba015b5882cd);
$parcel$export(module.exports, "SHAPES", () => $dd57189c68eaada0$export$511e1d54a4a8684e);
$parcel$export(module.exports, "Shape", () => $dd57189c68eaada0$export$6428a7f2611ef1fa);
$parcel$export(module.exports, "Circle", () => $dd57189c68eaada0$export$c89a927ffc67e6fa);
$parcel$export(module.exports, "default", () => $dd57189c68eaada0$export$2e2bcd8739ae039);
parcelRequire("2oe0q");
var $bmfNh = parcelRequire("bmfNh");
parcelRequire("aTPvW");
var $7KiQp = parcelRequire("7KiQp");
var $h2nZH = parcelRequire("h2nZH");
var $awIHJ = parcelRequire("awIHJ");

var $4Yzct = parcelRequire("4Yzct");
'use strict';
const $dd57189c68eaada0$var$CONFIG = (0, $7KiQp.getActiveConfig)();
const $dd57189c68eaada0$export$b202ba015b5882cd = {
    4: {
        boxShadow: `rgba(0,0,0,.10) 0 2${$dd57189c68eaada0$var$CONFIG.unit.default} 4${$dd57189c68eaada0$var$CONFIG.unit.default}`
    },
    6: {
        boxShadow: `rgba(0,0,0,.10) 0 3${$dd57189c68eaada0$var$CONFIG.unit.default} 6${$dd57189c68eaada0$var$CONFIG.unit.default}`
    },
    10: {
        boxShadow: `rgba(0,0,0,.10) 0 4${$dd57189c68eaada0$var$CONFIG.unit.default} 10${$dd57189c68eaada0$var$CONFIG.unit.default}`
    },
    16: {
        boxShadow: `rgba(0,0,0,.10) 0 8${$dd57189c68eaada0$var$CONFIG.unit.default} 16${$dd57189c68eaada0$var$CONFIG.unit.default}`
    },
    26: {
        boxShadow: `rgba(0,0,0,.10) 0 14${$dd57189c68eaada0$var$CONFIG.unit.default} 26${$dd57189c68eaada0$var$CONFIG.unit.default}`
    },
    42: {
        boxShadow: `rgba(0,0,0,.10) 0 20${$dd57189c68eaada0$var$CONFIG.unit.default} 42${$dd57189c68eaada0$var$CONFIG.unit.default}`
    }
};
const $dd57189c68eaada0$var$getComputedBackgroundColor = (el)=>{
    return (0, $h2nZH.getColor)(el.shapeDirectionColor) || (0, $h2nZH.getColor)(el.borderColor) || (0, $h2nZH.getColor)(el.backgroundColor) || (0, $h2nZH.getColor)(el.background);
};
const $dd57189c68eaada0$var$inheritTransition = (el)=>{
    const result = (0, $4Yzct.TIMING_PROPS).transition(el.transition, el);
    return result && result.transition;
};
const $dd57189c68eaada0$export$511e1d54a4a8684e = {
    rectangle: {},
    circle: {
        borderRadius: '100%'
    },
    bubble: {},
    tv: {
        borderRadius: '1.15em/2.5em'
    },
    tooltip: (el)=>({
            position: el.position || 'relative',
            '&:before': {
                content: '""',
                display: 'block',
                width: '0px',
                height: '0px',
                border: '.35em solid',
                borderColor: $dd57189c68eaada0$var$getComputedBackgroundColor(el),
                transition: $dd57189c68eaada0$var$inheritTransition(el),
                transitionProperty: 'border-color',
                position: 'absolute',
                borderRadius: '.15em'
            }
        }),
    tooltipDirection: {
        top: {
            '&:before': {
                top: '0',
                left: '50%',
                transform: 'translate(-50%, -50%) rotate(45deg)'
            }
        },
        right: {
            '&:before': {
                top: '50%',
                right: '0',
                transform: 'translate(50%, -50%) rotate(45deg)'
            }
        },
        bottom: {
            '&:before': {
                bottom: '0',
                left: '50%',
                transform: 'translate(-50%, 50%) rotate(45deg)'
            }
        },
        left: {
            '&:before': {
                top: '50%',
                left: '0',
                transform: 'translate(-50%, -50%) rotate(45deg)'
            }
        }
    },
    tag: (el)=>({
            position: 'relative',
            '&:before': {
                content: '""',
                display: 'block',
                background: $dd57189c68eaada0$var$getComputedBackgroundColor(el),
                transition: $dd57189c68eaada0$var$inheritTransition(el),
                transitionProperty: 'background',
                borderRadius: '.25em',
                position: 'absolute',
                zIndex: '-1',
                aspectRatio: '1/1',
                top: '50%',
                transformOrigin: '50% 50%',
                height: '73%'
            }
        }),
    tagDirection: {
        top: {
            '&:before': {
                bottom: '100%',
                left: '50%',
                transform: 'translate(-50%, 50%) rotate(45deg)'
            }
        },
        right: {
            '&:before': {
                top: '50%',
                left: '100%',
                transform: 'translate(-50%, -50%) rotate(45deg)'
            }
        },
        bottom: {
            '&:before': {
                top: '100%',
                left: '50%',
                transform: 'translate(-50%, -50%) rotate(45deg)'
            }
        },
        left: {
            '&:before': {
                top: '50%',
                right: '100%',
                transform: 'translate(50%, -50%) rotate(45deg)'
            }
        }
    },
    hexagon: (el)=>({
            position: 'relative',
            '&:before, &:after': {
                content: '""',
                display: 'block',
                position: 'absolute',
                zIndex: '-1',
                borderRadius: '.25em',
                aspectRatio: '1/1',
                top: '50%',
                transformOrigin: '50% 50%',
                height: '73%',
                background: $dd57189c68eaada0$var$getComputedBackgroundColor(el),
                transition: $dd57189c68eaada0$var$inheritTransition(el),
                transitionProperty: 'background'
            },
            '&:before': {
                left: '0',
                transform: 'translate3d(-50%, -50%, 1px) rotate(45deg)'
            },
            '&:after': {
                left: '100%',
                transform: 'translate3d(-50%, -50%, 1px) rotate(45deg)'
            }
        }),
    chevron: (el)=>({
            position: 'relative',
            '&:before, &:after': {
                content: '""',
                display: 'block',
                position: 'absolute',
                zIndex: '-1',
                aspectRatio: '1/1',
                top: '50%',
                transformOrigin: '50% 50%',
                transition: $dd57189c68eaada0$var$inheritTransition(el),
                transitionProperty: 'background'
            },
            '&:before': {
                background: `linear-gradient(225deg, ${$dd57189c68eaada0$var$getComputedBackgroundColor(el)} 25%, transparent 25%), linear-gradient(315deg, ${$dd57189c68eaada0$var$getComputedBackgroundColor(el)} 25%, transparent 25%)`
            },
            '&:after': {
                background: $dd57189c68eaada0$var$getComputedBackgroundColor(el),
                borderRadius: '.25em'
            }
        }),
    chevronDirection: {
        left: {
            '&:before': {
                height: '100%',
                left: '100%',
                transform: 'translate3d(-1%, -50%, 1px) scale(-1, 1)'
            },
            '&:after': {
                height: '73%',
                left: '0',
                transform: 'translate3d(-50%, -50%, 1px) rotate(45deg)'
            }
        },
        right: {
            '&:before': {
                height: '100%',
                left: '0',
                transform: 'translate3d(-99%, -50%, 1px)'
            },
            '&:after': {
                height: '73%',
                left: '100%',
                transform: 'translate3d(-50%, -50%, 1px) rotate(45deg)'
            }
        }
    }
};
const $dd57189c68eaada0$export$6428a7f2611ef1fa = {
    deps: {
        exec: $bmfNh.exec,
        getSpacingBasedOnRatio: $awIHJ.getSpacingBasedOnRatio,
        getMediaColor: $h2nZH.getMediaColor
    },
    classlist: {
        shape: (el)=>{
            return el.deps.exec($dd57189c68eaada0$export$511e1d54a4a8684e[el.shape], el);
        },
        shapeDirection: (el)=>{
            if (!el.shape || !el.shapeDirection) return;
            const shapeDir = $dd57189c68eaada0$export$511e1d54a4a8684e[el.shape + 'Direction'];
            return el.shape && shapeDir ? shapeDir[el.shapeDirection || 'left'] : null;
        },
        shapeDirectionColor: (el)=>{
            const borderColor = {
                borderColor: el.deps.getMediaColor(el.background || el.backgroundColor)
            };
            return el.shapeDirection ? borderColor : null;
        }
    }
};
const $dd57189c68eaada0$export$c89a927ffc67e6fa = {
    round: '100%'
};
var $dd57189c68eaada0$export$2e2bcd8739ae039 = $dd57189c68eaada0$export$6428a7f2611ef1fa;

});



parcelRegister("8VmFN", function(module, exports) {

$parcel$export(module.exports, "Svg", () => $67f53c06ee264d72$export$e17b9c1182212c96);
'use strict';
const $67f53c06ee264d72$export$e17b9c1182212c96 = {
    tag: 'svg',
    attr: {
        xmlns: 'http://www.w3.org/2000/svg',
        'xmlns:xlink': 'http://www.w3.org/1999/xlink'
    },
    html: (el)=>{
        const { context: context } = el;
        if (el.semanticIcons) return;
        if (el.html && typeof el.html !== 'function') return el.call('exec', el.html, el);
        const { designSystem: designSystem, utils: utils } = context;
        const SVG = designSystem && designSystem.svg;
        const useSvgSprite = el.spriteId || designSystem && designSystem.useSvgSprite;
        const src = el.call('exec', el.src, el);
        if (!useSvgSprite && src) return src;
        const useSVGSymbol = (icon)=>`<use xlink:href="#${icon}" />`;
        const spriteId = el.spriteId;
        if (spriteId) return useSVGSymbol(spriteId);
        if (SVG && SVG[src]) return useSVGSymbol(src);
        const symbolId = Symbol.for(src);
        let SVGKey = SVG[symbolId];
        if (SVGKey && SVG[SVGKey]) return useSVGSymbol(SVGKey);
        SVGKey = SVG[symbolId] = Math.random();
        if (src) utils.init({
            svg: {
                [SVGKey]: src
            }
        }, {
            document: context.document,
            emotion: context.emotion
        });
        return useSVGSymbol(SVGKey);
    }
};

});

parcelRegister("bpa5t", function(module, exports) {

$parcel$export(module.exports, "Video", () => $84d9daa2129e06c1$export$ae01dedf5c052bb);
'use strict';
const $84d9daa2129e06c1$export$ae01dedf5c052bb = {
    tag: 'video',
    controls: true,
    childExtends: {
        tag: 'source'
    }
};

});

parcelRegister("ii8kW", function(module, exports) {

$parcel$export(module.exports, "Text", () => $d5105ff192689666$export$5f1af8db9871e1d6);
$parcel$export(module.exports, "H1", () => $d5105ff192689666$export$5523b16adee8048);
$parcel$export(module.exports, "H2", () => $d5105ff192689666$export$cb94397127ac9363);
$parcel$export(module.exports, "H3", () => $d5105ff192689666$export$746be9e3a3dfff1f);
$parcel$export(module.exports, "H4", () => $d5105ff192689666$export$cc5e069d64fda823);
$parcel$export(module.exports, "H5", () => $d5105ff192689666$export$88ef9fdaf11f7a1f);
$parcel$export(module.exports, "H6", () => $d5105ff192689666$export$a559fb8039b06400);
$parcel$export(module.exports, "P", () => $d5105ff192689666$export$56c0d5a1e737357d);
$parcel$export(module.exports, "Caption", () => $d5105ff192689666$export$32fbfacc5d962e0c);
$parcel$export(module.exports, "Strong", () => $d5105ff192689666$export$f301627d437cff88);
$parcel$export(module.exports, "U", () => $d5105ff192689666$export$3a6d5c9ae78a2c08);
$parcel$export(module.exports, "Underline", () => $d5105ff192689666$export$741ee5bff4f2bc22);
$parcel$export(module.exports, "Italic", () => $d5105ff192689666$export$1cfcf4275506b1c6);
$parcel$export(module.exports, "Title", () => $d5105ff192689666$export$f99233281efd08a0);
$parcel$export(module.exports, "Headline", () => $d5105ff192689666$export$e1faab0803786bcf);
$parcel$export(module.exports, "Subhead", () => $d5105ff192689666$export$17e07beff4cf82a6);
$parcel$export(module.exports, "Footnote", () => $d5105ff192689666$export$54539b446c9863da);
$parcel$export(module.exports, "B", () => $d5105ff192689666$export$ef35774e6d314e91);
$parcel$export(module.exports, "I", () => $d5105ff192689666$export$9bb611d729802a56);
$parcel$export(module.exports, "Data", () => $d5105ff192689666$export$2d0294657ab35f1b);
'use strict';
const $d5105ff192689666$export$5f1af8db9871e1d6 = {};
const $d5105ff192689666$export$5523b16adee8048 = {
    tag: 'h1'
};
const $d5105ff192689666$export$cb94397127ac9363 = {
    tag: 'h2'
};
const $d5105ff192689666$export$746be9e3a3dfff1f = {
    tag: 'h3'
};
const $d5105ff192689666$export$cc5e069d64fda823 = {
    tag: 'h4'
};
const $d5105ff192689666$export$88ef9fdaf11f7a1f = {
    tag: 'h5'
};
const $d5105ff192689666$export$a559fb8039b06400 = {
    tag: 'h6'
};
const $d5105ff192689666$export$56c0d5a1e737357d = {
    tag: 'p'
};
const $d5105ff192689666$export$32fbfacc5d962e0c = {
    tag: 'caption'
};
const $d5105ff192689666$export$f301627d437cff88 = {
    tag: 'strong',
    fontWeight: '700'
};
const $d5105ff192689666$export$3a6d5c9ae78a2c08 = {
    tag: 'u'
};
const $d5105ff192689666$export$741ee5bff4f2bc22 = {
    tag: 'u'
};
const $d5105ff192689666$export$1cfcf4275506b1c6 = {
    tag: 'i'
};
const $d5105ff192689666$export$f99233281efd08a0 = {};
const $d5105ff192689666$export$e1faab0803786bcf = {
    tag: 'h6',
    fontSize: 'B',
    fontWeight: 500
};
const $d5105ff192689666$export$17e07beff4cf82a6 = {
    tag: 'span',
    fontSize: 'Z1'
};
const $d5105ff192689666$export$54539b446c9863da = {
    tag: 'span',
    fontSize: 'Z'
};
const $d5105ff192689666$export$ef35774e6d314e91 = {
    tag: 'b'
};
const $d5105ff192689666$export$9bb611d729802a56 = {
    tag: 'i'
};
const $d5105ff192689666$export$2d0294657ab35f1b = {
    tag: 'data'
};

});

parcelRegister("bfrry", function(module, exports) {

$parcel$export(module.exports, "Box", () => $830662189c160f6e$export$e71c4d32a2263218);
$parcel$export(module.exports, "Hr", () => $830662189c160f6e$export$c65504044f62f430);
$parcel$export(module.exports, "Br", () => $830662189c160f6e$export$9130f216d904f5ea);
$parcel$export(module.exports, "Li", () => $830662189c160f6e$export$4de39c9f3329bb96);
$parcel$export(module.exports, "Ul", () => $830662189c160f6e$export$d4f99c77eeffeaea);
$parcel$export(module.exports, "Ol", () => $830662189c160f6e$export$60180a808b215c38);

var $8zqnY = parcelRequire("8zqnY");
'use strict';
// Main class assignment handler
const $830662189c160f6e$var$onBeforeClassAssign = (element)=>{
    if (!element.context) return;
    const { props: props, __ref: ref } = element;
    const result = (0, $8zqnY.useCssInProps)(props, element, {
        unpack: false
    });
    ref.__class = result;
};
const $830662189c160f6e$export$e71c4d32a2263218 = {
    extends: [
        'Shape',
        'Theme'
    ],
    boxSizing: 'border-box',
    onBeforeClassAssign: $830662189c160f6e$var$onBeforeClassAssign
};
const $830662189c160f6e$export$c65504044f62f430 = {
    tag: 'hr',
    margin: 'C1 0'
};
const $830662189c160f6e$export$9130f216d904f5ea = {
    tag: 'br'
};
const $830662189c160f6e$export$4de39c9f3329bb96 = {
    tag: 'li'
};
const $830662189c160f6e$export$d4f99c77eeffeaea = {
    tag: 'ul',
    childExtends: {
        extends: 'Li'
    }
};
const $830662189c160f6e$export$60180a808b215c38 = {
    tag: 'ol',
    childExtends: {
        extends: 'Li'
    }
};

});

parcelRegister("gHawJ", function(module, exports) {

$parcel$export(module.exports, "Hgroup", () => $c278d3eff9148232$export$bd5b3f7ef3b94a4a);
$parcel$export(module.exports, "HgroupRows", () => $c278d3eff9148232$export$4c6ac4526c395f50);
$parcel$export(module.exports, "HgroupButton", () => $c278d3eff9148232$export$7fa5389f12735f1f);
'use strict';
const $c278d3eff9148232$export$bd5b3f7ef3b94a4a = {
    display: 'flex',
    tag: 'hgroup',
    flow: 'y',
    gap: 'Y2',
    H: {
        color: 'title',
        tag: 'h3',
        lineHeight: '1em',
        margin: '0'
    },
    P: {
        margin: '0',
        color: 'paragraph'
    }
};
const $c278d3eff9148232$export$4c6ac4526c395f50 = {
    extends: 'Hgroup',
    H: {
        display: 'flex',
        color: 'title',
        align: 'center space-between'
    },
    P: {
        color: 'paragraph',
        align: 'center space-between'
    }
};
const $c278d3eff9148232$export$7fa5389f12735f1f = {
    extends: 'HgroupRows',
    H: {
        justifyContent: 'space-between',
        Span: {},
        Button: {
            background: 'transparent',
            color: 'currentColor',
            padding: '0',
            Icon: {
                name: 'x',
                fontSize: 'C'
            }
        }
    },
    P: {}
};

});

parcelRegister("juqT0", function(module, exports) {

$parcel$export(module.exports, "Input", () => $e305acb44bda6e7a$export$f5b8910cec6cf069);
'use strict';
const $e305acb44bda6e7a$export$f5b8910cec6cf069 = {
    extends: [
        'Focusable'
    ],
    tag: 'input',
    border: 'none',
    type: 'input',
    theme: 'field',
    fontSize: 'A',
    round: 'C',
    lineHeight: '1',
    padding: 'Z2 B',
    attr: {
        pattern: (el)=>el.pattern,
        minLength: (el)=>el.minlength,
        maxLength: (el)=>el.maxlength,
        name: (el)=>el.name,
        autocomplete: (el)=>el.autocomplete,
        placeholder: (el)=>el.placeholder,
        value: (el)=>{
            if (!el.value) return;
            const val = el.call('exec', el.value, el);
            if (el.call('isString', val) && val.includes('{{')) return el.call('replaceLiteralsWithObjectFields', val);
            return val;
        },
        checked: (el)=>el.call('exec', el.checked, el),
        disabled: (el)=>el.disabled || null,
        readonly: (el)=>el.readonly,
        required: (el)=>el.required,
        type: (el)=>el.type
    }
};

});

parcelRegister("2hoIt", function(module, exports) {

$parcel$export(module.exports, "NumberInput", () => $1a90577059624c69$export$6bf0cd3a219bbade);
'use strict';
const $1a90577059624c69$export$6bf0cd3a219bbade = {
    extends: [
        'Flex',
        'Input'
    ],
    type: 'number',
    boxSize: 'C+X',
    align: 'center center',
    textAlign: 'center',
    round: 'Y1',
    theme: 'transparent',
    border: 'solid gray3',
    borderWidth: '1px',
    placeholder: '0',
    fontWeight: '400',
    '::-webkit-inner-spin-button': {
        appearance: 'none'
    },
    attr: {
        step: (el)=>el.step,
        min: (el)=>el.min,
        max: (el)=>el.max
    }
};

});

parcelRegister("bBcty", function(module, exports) {

$parcel$export(module.exports, "Checkbox", () => $871cd3cbaeca3765$export$48513f6b9f8ce62d);
$parcel$export(module.exports, "CheckboxHgroup", () => $871cd3cbaeca3765$export$8d7a3c6c6de62e1f);
'use strict';
const $871cd3cbaeca3765$export$48513f6b9f8ce62d = {
    extends: 'Focusable',
    tag: 'label',
    boxSize: 'fit-content fit-content',
    cursor: 'pointer',
    round: 'Y',
    Input: {
        type: 'checkbox',
        display: 'none',
        ':checked + div': {
            theme: 'primary'
        },
        ':checked + div > svg': {
            transform: 'none',
            opacity: '1'
        },
        attr: {
            checked: (el)=>el.call('exec', el.parent.checked)
        }
    },
    Flex: {
        align: 'center center',
        fontSize: 'B1',
        padding: 'V',
        theme: 'field',
        round: 'X2',
        transition: 'background A defaultBezier',
        Icon: {
            icon: 'check',
            opacity: '0',
            transform: 'scale(0.9) rotate(-15deg)',
            transition: 'opacity B defaultBezier'
        }
    }
};
const $871cd3cbaeca3765$export$8d7a3c6c6de62e1f = {
    display: 'flex',
    tag: 'label',
    boxSize: 'fit-content',
    align: 'flex-start flex-start',
    gap: 'A',
    Checkbox: {
        tag: 'div'
    },
    HgroupRows: {
        gap: 'Z1',
        margin: 'Y - - -'
    }
};

});

parcelRegister("3Gz7s", function(module, exports) {

$parcel$export(module.exports, "Radio", () => $2af08947ffa35c7d$export$d7b12c4107be0d61);
$parcel$export(module.exports, "RadioHgroup", () => $2af08947ffa35c7d$export$4a51391209c6c8b9);
'use strict';
const $2af08947ffa35c7d$export$d7b12c4107be0d61 = {
    extends: 'Checkbox',
    Input: {
        type: 'radio',
        ':checked + div:after': {
            opacity: '1'
        }
    },
    Flex: {
        round: '100%',
        padding: 'Y',
        ':after': {
            content: '""',
            display: 'block',
            boxSize: 'X+W1',
            round: '100%',
            background: 'white',
            opacity: '0',
            transition: 'opacity .15s ease-in-out'
        },
        Icon: null
    }
};
const $2af08947ffa35c7d$export$4a51391209c6c8b9 = {
    extends: 'CheckboxHgroup',
    Checkbox: null,
    Radio: {}
};

});

parcelRegister("hYecS", function(module, exports) {

$parcel$export(module.exports, "Toggle", () => $d1530f68eb3e4172$export$bea8ebba691c5813);
$parcel$export(module.exports, "ToggleHgroup", () => $d1530f68eb3e4172$export$9c397544fb27ca65);
'use strict';
const $d1530f68eb3e4172$export$bea8ebba691c5813 = {
    extends: 'Checkbox',
    Input: {
        ':checked + div': {
            background: 'green2+8',
            justifyContent: 'flex-end'
        }
    },
    Flex: {
        boxSize: 'A1 B1',
        padding: '- W_default',
        round: 'D',
        align: 'center flex-start',
        theme: 'field',
        border: 'none',
        transition: 'opacity .15s ease',
        ':after': {
            content: '""',
            boxSize: 'A A',
            round: '100%',
            background: 'white',
            boxShadow: 'gray.2 1px 1px Z'
        },
        Icon: null
    }
};
const $d1530f68eb3e4172$export$9c397544fb27ca65 = {
    extends: 'CheckboxHgroup',
    Checkbox: null,
    Toggle: {}
};

});

parcelRegister("j10Zl", function(module, exports) {

$parcel$export(module.exports, "Textarea", () => $dd7ee09b86f10cf5$export$379139ebc1c2b235);
$parcel$export(module.exports, "TextareaWithButton", () => $dd7ee09b86f10cf5$export$b70f05b5c6092f02);
'use strict';
const $dd7ee09b86f10cf5$export$379139ebc1c2b235 = {
    tag: 'textarea',
    extends: [
        'Input',
        'Flex'
    ],
    fontfamily: 'Avenir',
    placeholder: 'Leave us a message...',
    padding: 'A',
    theme: 'field',
    border: 'none',
    minHeight: 'E_default',
    width: '100%',
    height: 'E1_default',
    fontFamily: 'inherit',
    round: 'Z2',
    lineHeight: 1.4,
    '.outlined': {
        borderWidth: '1px',
        borderStyle: 'solid'
    }
};
const $dd7ee09b86f10cf5$export$b70f05b5c6092f02 = {
    display: 'flex',
    gap: 'Y2',
    Textarea: {
        height: 'C2+W',
        minWidth: 'H',
        padding: 'A',
        fontSize: 'Z1',
        round: 'Z2',
        minHeight: 'fit-content'
    },
    SquareButton: {
        background: 'blue',
        Icon: {
            name: 'send'
        }
    }
};

});

parcelRegister("gecpK", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $bd07955ca0a45930$export$f04a61298a47a40f);
$parcel$export(module.exports, "IconText", () => $bd07955ca0a45930$export$fe7c634bfc18e397);
$parcel$export(module.exports, "FileIcon", () => $bd07955ca0a45930$export$8c1a3d13e85d78b7);
'use strict';
const $bd07955ca0a45930$var$inheritFromIsActive = (el)=>{
    const propsActive = el['.isActive'];
    if (!propsActive) return;
    return el.call('exec', propsActive.name || propsActive.icon);
};
const $bd07955ca0a45930$var$getIconName = (el, s)=>{
    const { key: key } = el;
    let icon = el.call('exec', el.name || el.icon || key, el);
    if (el.call('isString', icon) && icon.includes('{{')) icon = el.call('replaceLiteralsWithObjectFields', icon);
    return el.call('isString', icon) ? icon : key;
};
const $bd07955ca0a45930$export$f04a61298a47a40f = {
    extends: 'Svg',
    width: 'A',
    height: 'A',
    display: 'inline-block',
    style: {
        fill: 'currentColor',
        '*': {
            fill: 'currentColor'
        }
    },
    onInit: (el, s, ctx)=>{
        const { parent: parent } = el;
        const { icons: icons, useIconSprite: useIconSprite, verbose: verbose } = ctx && ctx.designSystem;
        const { toCamelCase: toCamelCase } = ctx && ctx.utils;
        const inheritFromIsActive = (el)=>{
            const propsActive = el['.isActive'];
            if (!propsActive) return;
            return el.call('exec', propsActive.name || propsActive.icon);
        };
        const getSemanticIcon = (el, s, ctx)=>{
            const { semanticIcons: semanticIcons } = ctx && ctx.designSystem;
            const { toCamelCase: toCamelCase } = ctx && ctx.utils;
            let iconName = getIconName(el, s);
            const camelCase = toCamelCase(iconName);
            const isArray = camelCase.split(/([a-z])([A-Z])/g);
            const semanticIconRootName = isArray[1] ? isArray[0] : iconName.split('.')[0].split(' ')[0];
            const semanticIcon = semanticIcons && semanticIcons[semanticIconRootName];
            if (semanticIcon) {
                const iconKey = iconName.includes('.') ? 'sfsymbols.' + iconName.split('.').slice(1).join('.') : 'sfsymbols';
                iconName = semanticIcon[iconKey] || semanticIcon[iconName.split('.')[0].split(' ')[0]];
                return {
                    tag: 'span',
                    semanticIcons: true,
                    width: 'A',
                    height: 'A',
                    lineHeight: '1em',
                    ':after': {
                        fontSize: 'Z',
                        fontWeight: '300',
                        content: `"${iconName}"`,
                        textAlign: 'center',
                        display: 'inline-block',
                        style: {
                            color: 'currentColor',
                            fontFamily: "'SF Pro Icons', 'SF Pro', 'SF Symbols', 'Segoe UI'"
                        }
                    }
                };
            }
        };
        const getIconName = (el, s)=>{
            const { key: key } = el;
            let icon = el.call('exec', el.name || el.icon || key, el);
            if (el.call('isString', icon) && icon.includes('{{')) icon = el.call('replaceLiteralsWithObjectFields', icon);
            return el.call('isString', icon) ? icon : key;
        };
        let iconName = getIconName(el, s);
        // Handle variant suffixes (e.g. 'deviceBigScreen outline' -> 'deviceBigScreenOutline')
        if (iconName.includes(' ')) {
            const parts = iconName.split(' ');
            iconName = parts[0] + parts.slice(1).map((p)=>p.charAt(0).toUpperCase() + p.slice(1)).join('');
        }
        const camelCase = toCamelCase(iconName);
        const isArray = camelCase.split(/([a-z])([A-Z])/g);
        const semanticIcon = getSemanticIcon(el, s, ctx);
        if (semanticIcon) {
            Object.assign(el, semanticIcon);
            return;
        }
        let activeIconName;
        if (el.isActive) activeIconName = inheritFromIsActive(el);
        const parentPropsActive = parent['.isActive'];
        if (parent && parent.isActive && parentPropsActive && parentPropsActive.icon) activeIconName = el.call('exec', parentPropsActive.icon || parentPropsActive.Icon.name || parentPropsActive.Icon.icon, el);
        if (el.call('isString', activeIconName) && activeIconName.includes('{{')) activeIconName = el.call('replaceLiteralsWithObjectFields', activeIconName);
        let iconInContext;
        if (icons[activeIconName]) iconInContext = activeIconName;
        if (icons[camelCase]) iconInContext = camelCase;
        else if (icons[isArray[0] + isArray[1]]) iconInContext = isArray[0] + isArray[1];
        else if (icons[isArray[0]]) iconInContext = isArray[0];
        else if (verbose) el.warn("Can't find icon:", iconName, iconInContext);
        const iconFromLibrary = icons[iconInContext];
        const directSrc = parent && parent.src || el.src;
        Object.assign(el, {
            spriteId: useIconSprite && iconInContext,
            src: iconFromLibrary || directSrc || icons.noIcon
        });
    },
    attr: {
        viewBox: '0 0 24 24'
    }
};
const $bd07955ca0a45930$export$fe7c634bfc18e397 = {
    display: 'flex',
    align: 'center center',
    lineHeight: 1,
    '.reversed': {
        flow: 'row-reverse'
    },
    '.vertical': {
        flow: 'column'
    },
    Icon: {
        if: (el)=>{
            const { parent: parent } = el;
            return el.call('exec', parent.icon || el.name || el.sfSymbols || parent.sfSymbols, el);
        },
        icon: (el)=>el.call('exec', el.parent.icon, el.parent)
    },
    text: (el)=>el.text
};
const $bd07955ca0a45930$export$8c1a3d13e85d78b7 = {
    display: 'flex',
    theme: 'tertiary',
    boxSize: 'C1',
    align: 'center center',
    round: 'Z2',
    Icon: {
        fontSize: 'B',
        margin: 'auto',
        icon: 'file'
    }
};
const $bd07955ca0a45930$var$getSemanticIcon = (el, s, ctx)=>{
    const { semanticIcons: semanticIcons } = ctx && ctx.designSystem;
    const { toCamelCase: toCamelCase } = ctx && ctx.utils;
    let iconName = $bd07955ca0a45930$var$getIconName(el, s);
    const camelCase = toCamelCase(iconName);
    const isArray = camelCase.split(/([a-z])([A-Z])/g);
    const semanticIconRootName = isArray[1] ? isArray[0] : iconName.split('.')[0].split(' ')[0];
    const semanticIcon = semanticIcons && semanticIcons[semanticIconRootName];
    if (semanticIcon) {
        const iconKey = iconName.includes('.') ? 'sfsymbols.' + iconName.split('.').slice(1).join('.') : 'sfsymbols';
        iconName = semanticIcon[iconKey] || semanticIcon[iconName.split('.')[0].split(' ')[0]];
        return {
            tag: 'span',
            semanticIcons: true,
            width: 'A',
            height: 'A',
            lineHeight: '1em',
            ':after': {
                fontSize: 'Z',
                fontWeight: '300',
                content: `"${iconName}"`,
                textAlign: 'center',
                display: 'inline-block',
                style: {
                    color: 'currentColor',
                    fontFamily: "'SF Pro Icons', 'SF Pro', 'SF Symbols', 'Segoe UI'"
                }
            }
        };
    }
};

});

parcelRegister("i7vYK", function(module, exports) {

$parcel$export(module.exports, "Link", () => $d311afc0d2b1ca5f$export$a6c7ac8248d6e38a);
$parcel$export(module.exports, "A", () => $d311afc0d2b1ca5f$export$ebd11618f299a286);
$parcel$export(module.exports, "RouterLink", () => $d311afc0d2b1ca5f$export$fce709ebdac448ed);
$parcel$export(module.exports, "RouteLink", () => $d311afc0d2b1ca5f$export$9a6dc2d0fce7da79);

var $cAYSb = parcelRequire("cAYSb");

var $inO1F = parcelRequire("inO1F");
'use strict';
// SPA-by-default click handler. `Link` mixes this in below so internal hrefs
// route through the smbls router instead of triggering a full page reload.
// External schemes (http(s), mailto:, tel:, etc.) fall through to the browser.
const $d311afc0d2b1ca5f$var$routerOnClick = (event, el, s)=>{
    const { context: ctx } = el;
    const { href: h, scrollToTop: scrollToTop, stopPropagation: stopPropagation } = el;
    let href = el.call('exec', h, el);
    if (el.call('isString', href) && href.includes('{{')) href = el.call('replaceLiteralsWithObjectFields', href);
    if (stopPropagation) event.stopPropagation();
    if (!href) return;
    const { utils: utils, snippets: snippets, functions: functions, routerOptions: routerOptions } = ctx;
    const root = el.__ref.root;
    const linkIsExternal = href.startsWith('http://') || href.startsWith('https://') || href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('sketch:') || href.startsWith('whatsapp:') || href.startsWith('sms:') || href.startsWith('skype:') || href.startsWith('viber:') || href.startsWith('callto:') || href.startsWith('facetime:') || href.startsWith('facetime-audio:') || href.startsWith('geo:') || href.startsWith('maps:');
    if (href && !linkIsExternal) {
        event.preventDefault();
        try {
            let targetEl = root;
            if (routerOptions && routerOptions.customRouterElement) {
                const parts = Array.isArray(routerOptions.customRouterElement) ? routerOptions.customRouterElement : routerOptions.customRouterElement.split('.');
                let resolved = root;
                for (const part of parts){
                    if (!resolved || !resolved[part]) {
                        resolved = null;
                        break;
                    }
                    resolved = resolved[part];
                }
                if (resolved) {
                    targetEl = resolved;
                    if (root.routes) targetEl.routes = root.routes;
                }
            }
            (functions.router || snippets.router || utils.router || (0, $cAYSb.router))(href, targetEl, {}, {
                scrollToOptions: {
                    behaviour: 'instant'
                },
                scrollToTop: el.call('isDefined', scrollToTop) ? scrollToTop : true,
                ...routerOptions,
                ...el.routerOptions
            });
        } catch (e) {
            console.warn(e);
        }
    }
};
const $d311afc0d2b1ca5f$export$a6c7ac8248d6e38a = {
    extends: 'Focusable',
    tag: 'a',
    aria: {},
    fontWeight: 'bold',
    textDecoration: 'none',
    color: 'currentColor',
    draggable: false,
    attr: {
        href: (el)=>{
            return (0, $inO1F.resolvePropValue)(el, el.href) || (0, $inO1F.resolvePropValue)(el, el.call('exec', el, el).href);
        },
        'aria-label': (el)=>el.aria ? el.aria.label : el.text
    },
    onClick: $d311afc0d2b1ca5f$var$routerOnClick
};
const $d311afc0d2b1ca5f$export$ebd11618f299a286 = {
    extends: 'Link'
};
const $d311afc0d2b1ca5f$export$fce709ebdac448ed = {
    onClick: (event, el, s)=>{
        const { context: ctx } = el;
        const { href: h, scrollToTop: scrollToTop, stopPropagation: stopPropagation } = el;
        let href = el.call('exec', h, el);
        if (el.call('isString', href) && href.includes('{{')) href = el.call('replaceLiteralsWithObjectFields', href);
        if (stopPropagation) event.stopPropagation();
        if (!href) return;
        const { utils: utils, snippets: snippets, functions: functions, routerOptions: routerOptions } = ctx;
        const root = el.__ref.root;
        const linkIsExternal = href.startsWith('http://') || href.startsWith('https://') || href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('sketch:') || href.startsWith('whatsapp:') || href.startsWith('sms:') || href.startsWith('skype:') || href.startsWith('viber:') || href.startsWith('callto:') || href.startsWith('facetime:') || href.startsWith('facetime-audio:') || href.startsWith('geo:') || href.startsWith('maps:');
        if (href && !linkIsExternal) {
            event.preventDefault();
            try {
                let targetEl = root;
                if (routerOptions && routerOptions.customRouterElement) {
                    const parts = Array.isArray(routerOptions.customRouterElement) ? routerOptions.customRouterElement : routerOptions.customRouterElement.split('.');
                    let resolved = root;
                    for (const part of parts){
                        if (!resolved || !resolved[part]) {
                            resolved = null;
                            break;
                        }
                        resolved = resolved[part];
                    }
                    if (resolved) {
                        targetEl = resolved;
                        if (root.routes) targetEl.routes = root.routes;
                    }
                }
                (functions.router || snippets.router || utils.router || (0, $cAYSb.router))(href, targetEl, {}, {
                    scrollToOptions: {
                        behaviour: 'instant'
                    },
                    scrollToTop: el.call('isDefined', scrollToTop) ? scrollToTop : true,
                    ...routerOptions,
                    ...el.routerOptions
                });
            } catch (e) {
                console.warn(e);
            }
        }
    }
};
const $d311afc0d2b1ca5f$export$9a6dc2d0fce7da79 = {
    extends: [
        $d311afc0d2b1ca5f$export$a6c7ac8248d6e38a,
        $d311afc0d2b1ca5f$export$fce709ebdac448ed
    ]
};

});

parcelRegister("83rqz", function(module, exports) {

$parcel$export(module.exports, "Select", () => $5dd3e113103c993a$export$ef9b1a59e592288f);
'use strict';
const $5dd3e113103c993a$export$ef9b1a59e592288f = {
    extends: 'Focusable',
    tag: 'select',
    fontSize: 'A',
    border: 'none',
    boxSizing: 'border-box',
    theme: 'field',
    cursor: 'pointer',
    childProps: {
        tag: 'option',
        attr: {
            value: (el)=>el.value,
            selected: (el)=>el.selected,
            disabled: (el)=>el.disabled
        }
    },
    attr: {
        name: (el)=>el.name,
        disabled: (el)=>el.disabled,
        value: (el)=>{
            if (!el.value) return;
            const val = el.call('exec', el.value, el);
            if (el.call('isString', val) && val.includes('{{')) return el.call('replaceLiteralsWithObjectFields', val);
            return val;
        }
    }
};

});

parcelRegister("aWQsI", function(module, exports) {

$parcel$export(module.exports, "Button", () => $020e94b5d7c88fbc$export$353f5b6fc5456de1);
$parcel$export(module.exports, "SquareButton", () => $020e94b5d7c88fbc$export$51cd5c72b5e560c6);
$parcel$export(module.exports, "CircleButton", () => $020e94b5d7c88fbc$export$235c11ae4b685dbd);
$parcel$export(module.exports, "KangorooButton", () => $020e94b5d7c88fbc$export$6fbe98cd572b6a70);
$parcel$export(module.exports, "ButtonSet", () => $020e94b5d7c88fbc$export$87e672a75327e04b);
$parcel$export(module.exports, "IconButton", () => $020e94b5d7c88fbc$export$c25acd513dcc8062);
'use strict';
const $020e94b5d7c88fbc$export$353f5b6fc5456de1 = {
    extends: [
        'IconText',
        'FocusableComponent'
    ],
    tag: 'button',
    fontSize: 'A',
    type: 'button',
    borderStyle: 'none',
    display: 'inline-flex',
    align: 'center center',
    textDecoration: 'none',
    lineHeight: '1',
    whiteSpace: 'nowrap',
    padding: 'Z B2',
    fontWeight: '500',
    fontFamily: 'inherit',
    round: 'C2',
    disabled: (el)=>el.call('exec', el.disabled)
};
const $020e94b5d7c88fbc$export$51cd5c72b5e560c6 = {
    extends: 'Button',
    fontSize: 'A',
    width: 'A',
    padding: 'Z',
    aspectRatio: '1 / 1',
    icon: 'smile',
    boxSize: 'fit-content fit-content',
    justifyContent: 'center',
    round: 'Z2',
    boxSizing: 'content-box'
};
const $020e94b5d7c88fbc$export$235c11ae4b685dbd = {
    extends: 'SquareButton',
    round: 'C'
};
const $020e94b5d7c88fbc$export$6fbe98cd572b6a70 = {
    extends: 'Button',
    childExtends: 'IconText'
};
const $020e94b5d7c88fbc$export$87e672a75327e04b = {
    tag: 'nav',
    display: 'flex',
    childExtends: 'SquareButton'
};
const $020e94b5d7c88fbc$export$c25acd513dcc8062 = {
    extends: [
        'SquareButton',
        'ClickableItem'
    ],
    round: 'Z'
};

});

parcelRegister("b2KzY", function(module, exports) {

$parcel$export(module.exports, "Dialog", () => $80a4034bb92ce6f8$export$3ddf2d174ce01153);
$parcel$export(module.exports, "DialogHeader", () => $80a4034bb92ce6f8$export$742513523b177e3b);
$parcel$export(module.exports, "DialogFooter", () => $80a4034bb92ce6f8$export$7bbfb2d443473050);
'use strict';
const $80a4034bb92ce6f8$export$3ddf2d174ce01153 = {
    display: 'flex',
    tag: 'dialog',
    flow: 'column',
    border: '0',
    theme: 'dialog',
    round: 'Z2'
};
const $80a4034bb92ce6f8$export$742513523b177e3b = {
    extends: 'Hgroup',
    minWidth: '100%',
    gap: 'A',
    Title: {
        align: 'center space-between',
        Text: {
            text: 'Title'
        },
        SquareButton: {
            icon: 'x',
            theme: 'transparent'
        }
    },
    Paragraph: {
        color: 'caption'
    }
};
const $80a4034bb92ce6f8$export$7bbfb2d443473050 = {
    display: 'flex',
    align: 'center flex-end',
    gap: 'X2',
    margin: 'auto - -',
    padding: 'Y2 X2',
    childExtends: {
        extends: 'Button',
        textTransform: 'uppercase',
        background: 'transparent',
        '@dark': {
            theme: 'primary @dark .color-only'
        },
        '@light': {
            theme: 'primary @light .color-only'
        },
        '&': {
            padding: 'Z A'
        },
        ':hover': {
            theme: 'tertiary'
        },
        ':active': {
            background: 'white.1'
        }
    },
    Cancel: {
        text: 'cancel'
    },
    Ok: {
        text: 'ok'
    }
};

});

parcelRegister("2lRdd", function(module, exports) {

$parcel$export(module.exports, "Tooltip", () => $1b66d1c0c7f9561f$export$28c660c63b792dea);
$parcel$export(module.exports, "TooltipHidden", () => $1b66d1c0c7f9561f$export$92ba62bde414cbb2);
$parcel$export(module.exports, "TooltipParent", () => $1b66d1c0c7f9561f$export$1d54d90a050b9c15);
parcelRequire("2oe0q");
var $fX7ii = parcelRequire("fX7ii");
'use strict';
const $1b66d1c0c7f9561f$export$28c660c63b792dea = {
    display: 'flex',
    theme: 'dialog',
    background: 'black',
    flow: 'column',
    shape: 'tooltip',
    shapeDirection: 'left',
    padding: 'Z1 A',
    round: 'Y2',
    width: 'fit-content',
    minWidth: 'D2',
    maxWidth: 'F2',
    gap: 'X',
    textAlign: 'center',
    attr: {
        tooltip: true
    },
    Title: {
        if: ({ parent: parent })=>(0, $fX7ii.isDefined)(parent.title) || parent.title,
        width: 'fit-content',
        fontWeight: 500,
        color: 'gray12',
        text: ({ parent: parent })=>parent.title
    },
    P: {
        if: (el, s)=>el.call('isDefined', el.call('exec', el.parent.description, el)) || el.text,
        width: 'fit-content',
        fontSize: 'Z2',
        margin: '0',
        color: 'gray6',
        fontWeight: '400',
        text: (el, s)=>el.call('exec', el.parent.description, el)
    }
};
const $1b66d1c0c7f9561f$export$92ba62bde414cbb2 = {
    extends: 'Tooltip',
    position: 'absolute',
    pointerEvents: 'none',
    opacity: '0',
    visibility: 'hidden',
    transition: 'C defaultBezier opacity, C defaultBezier visibility, B defaultBezier transform',
    onInit: (el)=>{
        const result = !el.shapeDirection || el.shapeDirection === 'top' ? {
            top: '112%',
            left: '50%',
            transform: 'translate3d(-50%,10%,0)',
            '.isActive': {
                transform: 'translate3d(-50%,0,0)',
                opacity: 1,
                visibility: 'visible'
            }
        } : el.shapeDirection === 'right' ? {
            transform: 'translate3d(10%,-50%,0)',
            left: '112%',
            top: '50%',
            '.isActive': {
                transform: 'translate3d(0%,-50%,0)',
                opacity: 1,
                visibility: 'visible'
            }
        } : el.shapeDirection === 'bottom' ? {
            transform: 'translate3d(-50%,-10%,0)',
            bottom: '112%',
            left: '50%',
            '.isActive': {
                transform: 'translate3d(-50%,0,0)',
                opacity: 1,
                visibility: 'visible'
            }
        } : el.shapeDirection === 'left' ? {
            transform: 'translate3d(10%,-50%,0)',
            right: '112%',
            top: '50%',
            '.isActive': {
                transform: 'translate3d(0%,-50%,0)',
                opacity: 1,
                visibility: 'visible'
            }
        } : {};
        Object.assign(el, result);
    }
};
const $1b66d1c0c7f9561f$export$1d54d90a050b9c15 = {
    position: 'relative',
    zIndex: 999,
    onInit: (el)=>{
        const { Tooltip: Tooltip, TooltipHidden: TooltipHidden } = el;
        const TooltipElem = Tooltip || TooltipHidden;
        if (!TooltipElem) return;
        const TooltipActive = TooltipElem && TooltipElem['.isActive'];
        Object.assign(el, {
            ':hover, &:focus-visible': {
                zIndex: 1000,
                '& [tooltip]': TooltipActive || {
                    transform: 'translate3d(-50%, 0, 0)',
                    opacity: 1,
                    visibility: 'visible'
                }
            }
        });
    }
};

});

parcelRegister("5sr83", function(module, exports) {

$parcel$export(module.exports, "Avatar", () => $3f949c8933b8a669$export$e2255cf6045e8d47);
'use strict';
const $3f949c8933b8a669$export$e2255cf6045e8d47 = {
    extends: 'Img',
    display: 'block',
    avatarType: 'adventurer-neutral',
    borderRadius: '100%',
    boxSize: 'C+X C+X',
    src: (el)=>`https://api.dicebear.com/7.x/${el.avatarType || 'initials'}/svg?seed=${el.key || 'no-avatar'}`
};

});

parcelRegister("dYaic", function(module, exports) {

$parcel$export(module.exports, "Range", () => $a2b8dcd48b12aa94$export$9a58ef0d7ad3278c);
parcelRequire("aTPvW");
var $2ESw5 = parcelRequire("2ESw5");
'use strict';
const $a2b8dcd48b12aa94$export$9a58ef0d7ad3278c = {
    tag: 'input',
    appearance: 'none',
    width: '100%',
    height: '2px',
    outline: 'none',
    flex: 1,
    onInput: (ev, el, s)=>{
        if (el.call('isFunction', el.onInput)) el.onInput(ev, el, s);
        else s.update({
            value: parseFloat(el.node.value)
        });
    },
    onChange: (ev, el, s)=>{
        if (el.call('isFunction', el.onChange)) el.onChange(ev, el, s);
        else s.update({
            value: parseFloat(el.node.value)
        });
    },
    '::-webkit-slider-thumb': {
        boxSizing: 'content-box',
        width: '8px',
        height: '8px',
        borderWidth: '2px',
        borderStyle: 'solid',
        borderRadius: '100%',
        opacity: '.8',
        appearance: 'none'
    },
    '::-webkit-slider-runnable-track': {},
    '@dark': {
        background: 'white.2',
        '::-webkit-slider-thumb': {
            background: '#232526',
            borderColor: (0, $2ESw5.opacify)('#454646', 0.75)
        },
        ':hover': {
            '::-webkit-slider-thumb': {
                borderColor: (0, $2ESw5.opacify)('#fff', 0.35)
            }
        },
        ':focus': {
            '::-webkit-slider-thumb': {
                borderColor: '#3C6AC0'
            }
        }
    },
    '@light': {
        background: 'gray9',
        '::-webkit-slider-thumb': {
            background: 'white',
            borderColor: 'gray9'
        },
        ':hover': {
            '::-webkit-slider-thumb': {
                borderColor: 'gray7'
            }
        },
        ':focus': {
            '::-webkit-slider-thumb': {
                borderColor: 'blue'
            }
        }
    },
    deps: {
        returnPropertyValue: (el, property, def)=>{
            const val = el.call('exec', el[property], el);
            const r = el.call('isFunction', val) ? val(el, el.state) : val !== undefined ? val : def !== undefined ? def : 0;
            return r + '';
        }
    },
    attr: {
        type: 'range',
        value: (el, s)=>el.call('exec', s.value || el.value || el.defaultValue, el),
        min: (el, s)=>el.deps.returnPropertyValue(el, 'min', 0),
        max: (el, s)=>el.deps.returnPropertyValue(el, 'max', 100),
        step: (el, s)=>el.deps.returnPropertyValue(el, 'step', 1)
    }
};

});

parcelRegister("4YNkk", function(module, exports) {

$parcel$export(module.exports, "Dropdown", () => $3a03074d3d454585$export$931cbfb6bfb85fc);
$parcel$export(module.exports, "DropdownList", () => $3a03074d3d454585$export$e40cc1c58d22b809);
$parcel$export(module.exports, "DropdownParent", () => $3a03074d3d454585$export$b162207c9836937);
$parcel$export(module.exports, "DropdownParentFocus", () => $3a03074d3d454585$export$89c2e92edc22fd8f);
$parcel$export(module.exports, "DropdownSiblingFocus", () => $3a03074d3d454585$export$60701cc380f56748);
'use strict';
const $3a03074d3d454585$export$931cbfb6bfb85fc = {
    attr: {
        dropdown: true
    },
    position: 'absolute',
    top: '100%',
    left: '0',
    zIndex: 1000,
    theme: 'quaternary',
    padding: 'Y',
    round: 'Z2',
    flow: 'column',
    gap: 'X',
    transition: 'B defaultBezier',
    transitionProperty: 'transform, opacity, visibility',
    transform: 'translate3d(0,10%,0)',
    opacity: 0,
    visibility: 'hidden'
};
const $3a03074d3d454585$export$e40cc1c58d22b809 = {
    display: 'flex',
    attr: {
        dropdown: true
    },
    padding: '0 Y',
    maxHeight: 'G',
    flow: 'column',
    theme: 'quaternary',
    overflow: 'hidden auto',
    style: {
        listStyleType: 'none'
    },
    transition: 'B defaultBezier',
    transitionProperty: 'transform, opacity, visibility',
    children: (el)=>el.options || [],
    childrenAs: 'props',
    '.hidden': {
        transform: 'translate3d(0,10%,0)',
        opacity: 0,
        visibility: 'hidden'
    },
    childExtends: {
        extends: 'Button',
        state: {},
        isActive: ({ key: key, state: state })=>state.active === key,
        position: 'relative',
        round: '0',
        align: 'center flex-end',
        flow: 'row-reverse',
        padding: 'Z2 C Z2 Y2',
        margin: '0',
        gap: 'Y2',
        theme: 'quaternary .child',
        ':hover': {
            style: {
                svg: {
                    opacity: '0.5'
                }
            }
        },
        Icon: {
            isActive: ({ key: key, state: state })=>state.active === key,
            name: 'checkmark',
            opacity: '0.1',
            '.active': {
                opacity: '1'
            }
        },
        ':not(:first-child)': {
            '@dark': {
                border: 'solid gray4.65'
            },
            '@light': {
                border: 'solid gray11'
            },
            borderWidth: '1px 0 0'
        }
    }
};
const $3a03074d3d454585$export$b162207c9836937 = {
    position: 'relative',
    zIndex: 999,
    style: {
        '&:hover': {
            zIndex: 1000,
            '& [dropdown]': {
                transform: 'translate3d(0,0,0)',
                opacity: 1,
                visibility: 'visible'
            }
        }
    }
};
const $3a03074d3d454585$export$89c2e92edc22fd8f = {
    position: 'relative',
    tabindex: '0',
    style: {
        '&:focus-within': {
            zIndex: 1000,
            '& [dropdown]': {
                transform: 'translate3d(0,0,0)',
                opacity: 1,
                visibility: 'visible'
            }
        }
    },
    Input_trigger: {
        type: 'checkbox',
        opacity: '0',
        position: 'absolute',
        inset: '0',
        width: '100%',
        height: '100%',
        cursor: 'pointer',
        onClick: (ev, el)=>{
            if (el.node === document.activeElement) el.node.blur();
        }
    },
    Dropdown: {
        onClick: ()=>{
            document.activeElement?.blur();
        }
    }
};
const $3a03074d3d454585$export$60701cc380f56748 = {
    position: 'relative',
    tabindex: '0',
    style: {
        '&:focus-within': {
            zIndex: 1000,
            '& ~ [dropdown]': {
                transform: 'translate3d(0,0,0)',
                opacity: 1,
                visibility: 'visible'
            }
        }
    },
    Input_trigger: {
        type: 'checkbox',
        opacity: '0',
        position: 'absolute',
        inset: '0',
        width: '100%',
        height: '100%',
        cursor: 'pointer',
        onClick: (ev, el)=>{
            if (el.node === document.activeElement) el.node.blur();
        }
    }
};

});

parcelRegister("VkIr2", function(module, exports) {

$parcel$export(module.exports, "Notification", () => $0ac564b119f5da14$export$14834abbfce3b8cd);
'use strict';
const $0ac564b119f5da14$export$14834abbfce3b8cd = {
    display: 'flex',
    theme: 'alert',
    padding: 'Z1 B Z A',
    round: 'A A A Y2',
    gap: 'X2',
    cursor: 'pointer',
    align: 'flex-start center',
    IconText: {
        Icon: {
            name: 'info outline'
        },
        Text: {
            ':empty': {
                hide: true
            }
        }
    },
    Hgroup: {
        extends: [
            'Flex',
            'Hgroup'
        ],
        flow: 'y',
        align: 'flex-start',
        gap: 'X2',
        H: {
            tag: 'h6',
            margin: '0',
            fontWeight: '600',
            lineHeight: '1em',
            text: 'Notification',
            ':empty': {
                hide: true
            }
        },
        P: {
            fontSize: 'Z',
            margin: '0',
            text: 'is not always a distraction',
            ':empty': {
                hide: true
            }
        }
    }
};

});


parcelRegister("ilkkj", function(module, exports) {

$parcel$export(module.exports, "initializeExtend", () => $d5a9f4950f84c42d$export$c8d1988b2aeaf8a9);
$parcel$export(module.exports, "initializeSync", () => $d5a9f4950f84c42d$export$f04cca198b6322f4);
$parcel$export(module.exports, "initializeNotifications", () => $d5a9f4950f84c42d$export$cf84b69175b2f78a);
parcelRequire("2oe0q");
var $fX7ii = parcelRequire("fX7ii");
var $kt4aQ = parcelRequire("kt4aQ");
parcelRequire("e3zs4");
var $istPf = parcelRequire("istPf");
var $jr3GA = parcelRequire("jr3GA");
var $e3zs4 = parcelRequire("e3zs4");
'use strict';
const $d5a9f4950f84c42d$export$c8d1988b2aeaf8a9 = (app, ctx)=>{
    return (0, $fX7ii.isObjectLike)(app.extends) ? app.extends : [];
};
const $d5a9f4950f84c42d$export$f04cca198b6322f4 = (app, ctx)=>{
    const { editor: editor } = ctx;
    if (!editor) return;
    const liveSync = (0, $fX7ii.isUndefined)(editor.liveSync) ? (0, $kt4aQ.isDevelopment)() : editor.liveSync;
    if (liveSync) {
        if ((0, $fX7ii.isArray)(app.extends)) app.extends.push((0, $e3zs4.SyncComponent));
        else if (app.extends) app.extends = [
            app.extends,
            (0, $e3zs4.SyncComponent)
        ];
        else app.extends = [
            (0, $e3zs4.SyncComponent)
        ];
    }
};
const $d5a9f4950f84c42d$export$6919748479ac6c4f = (app, ctx)=>{
    const { editor: editor } = ctx;
    if (!editor) return;
    const inspect = (0, $fX7ii.isUndefined)(editor.inspect) ? (0, $kt4aQ.isDevelopment)() : editor.inspect;
    if (inspect) {
        if ((0, $fX7ii.isArray)(app.extends)) app.extends.push((0, $istPf.Inspect));
        else if (app.extends) app.extends = [
            app.extends,
            (0, $istPf.Inspect)
        ];
        else app.extends = [
            (0, $istPf.Inspect)
        ];
    }
};
const $d5a9f4950f84c42d$export$cf84b69175b2f78a = (app, ctx)=>{
    const { editor: editor } = ctx;
    if (!editor) return;
    const verbose = (0, $fX7ii.isUndefined)(editor.verbose) ? (0, $kt4aQ.isDevelopment)() || ctx.verbose : editor.verbose;
    if (verbose) {
        if ((0, $fX7ii.isArray)(app.extends)) app.extends.push((0, $jr3GA.Notifications));
        else if (app.extends) app.extends = [
            app.extends,
            (0, $jr3GA.Notifications)
        ];
        else app.extends = [
            (0, $jr3GA.Notifications)
        ];
    }
};

});
parcelRegister("e3zs4", function(module, exports) {

$parcel$export(module.exports, "SyncComponent", () => $a3bcd877efa191fa$export$a8792fa004fc1e59);
$parcel$export(module.exports, "Inspect", () => (parcelRequire("istPf")).Inspect);
$parcel$export(module.exports, "Notifications", () => (parcelRequire("jr3GA")).Notifications);


var $5SInI = parcelRequire("5SInI");

var $73MNt = parcelRequire("73MNt");
parcelRequire("2oe0q");
var $bmfNh = parcelRequire("bmfNh");
var $erBZm = parcelRequire("erBZm");

var $jr3GA = parcelRequire("jr3GA");

var $istPf = parcelRequire("istPf");
const $a3bcd877efa191fa$var$isLocal = false;
// ---------------------------------------------
// Utility helpers to apply ops
const $a3bcd877efa191fa$var$deletePath = (obj, path)=>{
    if (!obj || !Array.isArray(path)) return;
    path.reduce((acc, v, i, arr)=>{
        if (acc && v in acc) {
            if (i !== arr.length - 1) return acc[v];
            delete acc[v];
        }
        return void 0;
    }, obj);
};
const $a3bcd877efa191fa$var$setPath = (obj, path, value, createNestedObjects = false)=>{
    if (!obj || !Array.isArray(path)) return;
    path.reduce((acc, v, i, arr)=>{
        if (!acc) return void 0;
        if (i !== arr.length - 1) {
            if (!acc[v] && createNestedObjects) acc[v] = {};
            return acc[v];
        }
        acc[v] = value;
        return void 0;
    }, obj);
};
const $a3bcd877efa191fa$var$applyOpsToCtx = (ctx, changes)=>{
    const topLevelChanged = new Set();
    if (!Array.isArray(changes)) return topLevelChanged;
    for (const [action, path, change] of changes){
        if (!Array.isArray(path) || !path.length) continue;
        topLevelChanged.add(path[0]);
        switch(action){
            case 'delete':
                $a3bcd877efa191fa$var$deletePath(ctx, path);
                break;
            case 'update':
            case 'set':
                $a3bcd877efa191fa$var$setPath(ctx, path, change, true);
                break;
            default:
                break;
        }
    }
    return topLevelChanged;
};
// ---------------------------------------------
const $a3bcd877efa191fa$var$fetchServiceToken = async ()=>{
    try {
        const urlBase = $a3bcd877efa191fa$var$isLocal ? 'http://localhost:8080' : 'https://api.symbols.app';
        const res = await (0, $erBZm.window).fetch(`${urlBase}/service-token`, {
            method: 'GET'
        });
        // Attempt to parse JSON first – recent versions return `{ token: "..." }`
        // Fall back to treating the response as raw text for backward-compatibility.
        let txt;
        try {
            const json = await res.clone().json();
            if (json && typeof json.token === 'string') return json.token.trim();
            // If json parsing succeeds but no token field, fall back to text below.
            txt = await res.text();
        } catch  {
            // Response is not JSON – treat as plain text token.
            txt = await res.text();
        }
        return (txt || '').replace(/\s+/gu, '') || void 0;
    } catch (e) {
        console.error('[sync] Failed to fetch service-token', e);
    }
};
const $a3bcd877efa191fa$var$onSnapshot = (el, s, ctx)=>(payload = {})=>{
        let { data: data } = payload;
        const { schema: schema } = payload;
        if (!data) return;
        data = el.call('deepDestringifyFunctions', data, Array.isArray(data) ? [] : {});
        // Overwrite high-level objects shallowly so references are preserved
        Object.entries(data).forEach(([key, val])=>{
            if (ctx[key] && typeof ctx[key] === 'object') {
                if (key === 'designSystem') (0, $5SInI.init)(val);
                else (0, $bmfNh.overwriteShallow)(ctx[key], val);
            } else ctx[key] = val;
        });
        // Optionally make schema available on ctx
        if (schema) ctx.schema = schema;
    };
const $a3bcd877efa191fa$var$onOps = (el, s, ctx)=>(payload = {})=>{
        let { changes: changes } = payload;
        if (!changes || !Array.isArray(changes) || !changes.length) return;
        changes = el.call('deepDestringifyFunctions', changes, Array.isArray(changes) ? [] : {});
        const changed = $a3bcd877efa191fa$var$applyOpsToCtx(ctx, changes);
        // React to specific top-level changes
        if (changed.has('state')) {
            const route = ctx.state?.route;
            if (route) el.call('router', route.replace('/state', '') || '/', el.__ref.root, {}, {
                scrollToTop: false
            });
            else s.update(ctx.state);
        }
        if ([
            'pages',
            'components',
            'snippets',
            'functions'
        ].some((k)=>changed.has(k))) {
            const { pathname: pathname, search: search, hash: hash } = ctx.window.location;
            el.call('router', pathname + search + hash, el.__ref.root, {}, {
                scrollToTop: false
            });
        }
        if (changed.has('designSystem')) (0, $5SInI.init)(ctx.designSystem);
    };
const $a3bcd877efa191fa$export$c57211ae658b2a31 = async (el, s, ctx)=>{
    const token = await $a3bcd877efa191fa$var$fetchServiceToken();
    if (!token) {
        console.warn("[sync] No service token \u2013 live collaboration disabled");
        return null;
    }
    const projectKey = ctx.key;
    if (!projectKey) {
        console.warn("[sync] ctx.key missing \u2013 cannot establish collaborative connection");
        return null;
    }
    const socketBaseUrl = $a3bcd877efa191fa$var$isLocal ? 'http://localhost:8080' : 'https://api.symbols.app';
    const socket = (0, $73MNt.io)(socketBaseUrl, {
        path: '/collab-socket',
        transports: [
            'websocket'
        ],
        auth: {
            token: token,
            projectKey: projectKey,
            branch: 'main',
            live: true,
            clientType: 'platform'
        },
        reconnectionAttempts: Infinity,
        reconnectionDelayMax: 4000
    });
    socket.on('connect', ()=>{
        if (ctx.editor?.verbose) console.info('[sync] Connected to collab socket');
    });
    socket.on('snapshot', $a3bcd877efa191fa$var$onSnapshot(el, s, ctx));
    socket.on('ops', $a3bcd877efa191fa$var$onOps(el, s, ctx));
    socket.on('clients', (data)=>{
        if (ctx.editor?.verbose) (0, $jr3GA.connectedToSymbols)(data, el, s);
    });
    socket.on('disconnect', (reason)=>{
        if (ctx.editor?.verbose) console.info('[sync] Disconnected from collab socket', reason);
    });
    return socket;
};
const $a3bcd877efa191fa$export$a8792fa004fc1e59 = {
    onInitSync: $a3bcd877efa191fa$export$c57211ae658b2a31
};
const $a3bcd877efa191fa$export$d05f3dc416482df7 = {
    extends: [
        $a3bcd877efa191fa$export$a8792fa004fc1e59,
        (0, $istPf.Inspect),
        (0, $jr3GA.Notifications)
    ]
};

});
parcelRegister("73MNt", function(module, exports) {

$parcel$export(module.exports, "io", () => $523eaa49d3f99bf8$export$841407ceb083bd74);
$parcel$export(module.exports, "default", () => $523eaa49d3f99bf8$export$841407ceb083bd74);

var $kATNo = parcelRequire("kATNo");

var $fL4YY = parcelRequire("fL4YY");

var $lGX0c = parcelRequire("lGX0c");

var $2BjQv = parcelRequire("2BjQv");
parcelRequire("1XKMK");
var $i3KZp = parcelRequire("i3KZp");
var $3W81j = parcelRequire("3W81j");
var $dhyBt = parcelRequire("dhyBt");
var $hJTtX = parcelRequire("hJTtX");
/**
 * Managers cache.
 */ const $523eaa49d3f99bf8$var$cache = {};
function $523eaa49d3f99bf8$export$841407ceb083bd74(uri, opts) {
    if (typeof uri === "object") {
        opts = uri;
        uri = undefined;
    }
    opts = opts || {};
    const parsed = (0, $kATNo.url)(uri, opts.path || "/socket.io");
    const source = parsed.source;
    const id = parsed.id;
    const path = parsed.path;
    const sameNamespace = $523eaa49d3f99bf8$var$cache[id] && path in $523eaa49d3f99bf8$var$cache[id]["nsps"];
    const newConnection = opts.forceNew || opts["force new connection"] || false === opts.multiplex || sameNamespace;
    let io;
    if (newConnection) io = new (0, $fL4YY.Manager)(source, opts);
    else {
        if (!$523eaa49d3f99bf8$var$cache[id]) $523eaa49d3f99bf8$var$cache[id] = new (0, $fL4YY.Manager)(source, opts);
        io = $523eaa49d3f99bf8$var$cache[id];
    }
    if (parsed.query && !opts.query) opts.query = parsed.queryKey;
    return io.socket(parsed.path, opts);
}
// so that "lookup" can be used both as a function (e.g. `io(...)`) and as a
// namespace (e.g. `io.connect(...)`), for backward compatibility
Object.assign($523eaa49d3f99bf8$export$841407ceb083bd74, {
    Manager: $fL4YY.Manager,
    Socket: $lGX0c.Socket,
    io: $523eaa49d3f99bf8$export$841407ceb083bd74,
    connect: $523eaa49d3f99bf8$export$841407ceb083bd74
});

});
parcelRegister("kATNo", function(module, exports) {

$parcel$export(module.exports, "url", () => $efe27346e00da8a8$export$128fa18b7194ef);
parcelRequire("1XKMK");
var $l7wSz = parcelRequire("l7wSz");
function $efe27346e00da8a8$export$128fa18b7194ef(uri, path = "", loc) {
    let obj = uri;
    // default to window.location
    loc = loc || typeof location !== "undefined" && location;
    if (null == uri) uri = loc.protocol + "//" + loc.host;
    // relative path support
    if (typeof uri === "string") {
        if ("/" === uri.charAt(0)) {
            if ("/" === uri.charAt(1)) uri = loc.protocol + uri;
            else uri = loc.host + uri;
        }
        if (!/^(https?|wss?):\/\//.test(uri)) {
            if ("undefined" !== typeof loc) uri = loc.protocol + "//" + uri;
            else uri = "https://" + uri;
        }
        // parse
        obj = (0, $l7wSz.parse)(uri);
    }
    // make sure we treat `localhost:80` and `localhost` equally
    if (!obj.port) {
        if (/^(http|ws)$/.test(obj.protocol)) obj.port = "80";
        else if (/^(http|ws)s$/.test(obj.protocol)) obj.port = "443";
    }
    obj.path = obj.path || "/";
    const ipv6 = obj.host.indexOf(":") !== -1;
    const host = ipv6 ? "[" + obj.host + "]" : obj.host;
    // define unique id
    obj.id = obj.protocol + "://" + host + ":" + obj.port + path;
    // define href
    obj.href = obj.protocol + "://" + host + (loc && loc.port === obj.port ? "" : ":" + obj.port);
    return obj;
}

});
parcelRegister("1XKMK", function(module, exports) {

$parcel$export(module.exports, "Socket", () => (parcelRequire("al9N3")).Socket);
$parcel$export(module.exports, "installTimerFunctions", () => (parcelRequire("5vwdc")).installTimerFunctions);
$parcel$export(module.exports, "parse", () => (parcelRequire("l7wSz")).parse);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("bN72v")).nextTick);

var $al9N3 = parcelRequire("al9N3");

var $6opKi = parcelRequire("6opKi");

var $gEtm1 = parcelRequire("gEtm1");

var $5vwdc = parcelRequire("5vwdc");

var $l7wSz = parcelRequire("l7wSz");

var $bN72v = parcelRequire("bN72v");

var $i3KZp = parcelRequire("i3KZp");

var $3W81j = parcelRequire("3W81j");

var $3W81j = parcelRequire("3W81j");

var $dhyBt = parcelRequire("dhyBt");

var $dhyBt = parcelRequire("dhyBt");

var $hJTtX = parcelRequire("hJTtX");
const $16df97babd1aadf1$export$a51d6b395ff4c65a = (0, $al9N3.Socket).protocol;

});
parcelRegister("al9N3", function(module, exports) {

$parcel$export(module.exports, "Socket", () => $787375aed2c43820$export$4798917dbf149b79);

var $gEtm1 = parcelRequire("gEtm1");

var $5vwdc = parcelRequire("5vwdc");

var $2buxl = parcelRequire("2buxl");

var $l7wSz = parcelRequire("l7wSz");

var $5hHAH = parcelRequire("5hHAH");

var $CnWUo = parcelRequire("CnWUo");

var $bN72v = parcelRequire("bN72v");
const $787375aed2c43820$var$withEventListeners = typeof addEventListener === "function" && typeof removeEventListener === "function";
const $787375aed2c43820$var$OFFLINE_EVENT_LISTENERS = [];
if ($787375aed2c43820$var$withEventListeners) // within a ServiceWorker, any event handler for the 'offline' event must be added on the initial evaluation of the
// script, so we create one single event listener here which will forward the event to the socket instances
addEventListener("offline", ()=>{
    $787375aed2c43820$var$OFFLINE_EVENT_LISTENERS.forEach((listener)=>listener());
}, false);
class $787375aed2c43820$export$3874118029a0ee0d extends (0, $5hHAH.Emitter) {
    /**
     * Socket constructor.
     *
     * @param {String|Object} uri - uri or options
     * @param {Object} opts - options
     */ constructor(uri, opts){
        super();
        this.binaryType = (0, $bN72v.defaultBinaryType);
        this.writeBuffer = [];
        this._prevBufferLen = 0;
        this._pingInterval = -1;
        this._pingTimeout = -1;
        this._maxPayload = -1;
        /**
         * The expiration timestamp of the {@link _pingTimeoutTimer} object is tracked, in case the timer is throttled and the
         * callback is not fired on time. This can happen for example when a laptop is suspended or when a phone is locked.
         */ this._pingTimeoutTime = Infinity;
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = null;
        }
        if (uri) {
            const parsedUri = (0, $l7wSz.parse)(uri);
            opts.hostname = parsedUri.host;
            opts.secure = parsedUri.protocol === "https" || parsedUri.protocol === "wss";
            opts.port = parsedUri.port;
            if (parsedUri.query) opts.query = parsedUri.query;
        } else if (opts.host) opts.hostname = (0, $l7wSz.parse)(opts.host).host;
        (0, $5vwdc.installTimerFunctions)(this, opts);
        this.secure = null != opts.secure ? opts.secure : typeof location !== "undefined" && "https:" === location.protocol;
        if (opts.hostname && !opts.port) // if no port is specified manually, use the protocol default
        opts.port = this.secure ? "443" : "80";
        this.hostname = opts.hostname || (typeof location !== "undefined" ? location.hostname : "localhost");
        this.port = opts.port || (typeof location !== "undefined" && location.port ? location.port : this.secure ? "443" : "80");
        this.transports = [];
        this._transportsByName = {};
        opts.transports.forEach((t)=>{
            const transportName = t.prototype.name;
            this.transports.push(transportName);
            this._transportsByName[transportName] = t;
        });
        this.opts = Object.assign({
            path: "/engine.io",
            agent: false,
            withCredentials: false,
            upgrade: true,
            timestampParam: "t",
            rememberUpgrade: false,
            addTrailingSlash: true,
            rejectUnauthorized: true,
            perMessageDeflate: {
                threshold: 1024
            },
            transportOptions: {},
            closeOnBeforeunload: false
        }, opts);
        this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : "");
        if (typeof this.opts.query === "string") this.opts.query = (0, $2buxl.decode)(this.opts.query);
        if ($787375aed2c43820$var$withEventListeners) {
            if (this.opts.closeOnBeforeunload) {
                // Firefox closes the connection when the "beforeunload" event is emitted but not Chrome. This event listener
                // ensures every browser behaves the same (no "disconnect" event at the Socket.IO level when the page is
                // closed/reloaded)
                this._beforeunloadEventListener = ()=>{
                    if (this.transport) {
                        // silently close the transport
                        this.transport.removeAllListeners();
                        this.transport.close();
                    }
                };
                addEventListener("beforeunload", this._beforeunloadEventListener, false);
            }
            if (this.hostname !== "localhost") {
                this._offlineEventListener = ()=>{
                    this._onClose("transport close", {
                        description: "network connection lost"
                    });
                };
                $787375aed2c43820$var$OFFLINE_EVENT_LISTENERS.push(this._offlineEventListener);
            }
        }
        if (this.opts.withCredentials) this._cookieJar = (0, $bN72v.createCookieJar)();
        this._open();
    }
    /**
     * Creates transport of the given type.
     *
     * @param {String} name - transport name
     * @return {Transport}
     * @private
     */ createTransport(name) {
        const query = Object.assign({}, this.opts.query);
        // append engine.io protocol identifier
        query.EIO = (0, $CnWUo.protocol);
        // transport name
        query.transport = name;
        // session id if we already have one
        if (this.id) query.sid = this.id;
        const opts = Object.assign({}, this.opts, {
            query: query,
            socket: this,
            hostname: this.hostname,
            secure: this.secure,
            port: this.port
        }, this.opts.transportOptions[name]);
        return new this._transportsByName[name](opts);
    }
    /**
     * Initializes transport to use and starts probe.
     *
     * @private
     */ _open() {
        if (this.transports.length === 0) {
            // Emit error on next tick so it can be listened to
            this.setTimeoutFn(()=>{
                this.emitReserved("error", "No transports available");
            }, 0);
            return;
        }
        const transportName = this.opts.rememberUpgrade && $787375aed2c43820$export$3874118029a0ee0d.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1 ? "websocket" : this.transports[0];
        this.readyState = "opening";
        const transport = this.createTransport(transportName);
        transport.open();
        this.setTransport(transport);
    }
    /**
     * Sets the current transport. Disables the existing one (if any).
     *
     * @private
     */ setTransport(transport) {
        if (this.transport) this.transport.removeAllListeners();
        // set up transport
        this.transport = transport;
        // set up transport listeners
        transport.on("drain", this._onDrain.bind(this)).on("packet", this._onPacket.bind(this)).on("error", this._onError.bind(this)).on("close", (reason)=>this._onClose("transport close", reason));
    }
    /**
     * Called when connection is deemed open.
     *
     * @private
     */ onOpen() {
        this.readyState = "open";
        $787375aed2c43820$export$3874118029a0ee0d.priorWebsocketSuccess = "websocket" === this.transport.name;
        this.emitReserved("open");
        this.flush();
    }
    /**
     * Handles a packet.
     *
     * @private
     */ _onPacket(packet) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            this.emitReserved("packet", packet);
            // Socket is live - any packet counts
            this.emitReserved("heartbeat");
            switch(packet.type){
                case "open":
                    this.onHandshake(JSON.parse(packet.data));
                    break;
                case "ping":
                    this._sendPacket("pong");
                    this.emitReserved("ping");
                    this.emitReserved("pong");
                    this._resetPingTimeout();
                    break;
                case "error":
                    const err = new Error("server error");
                    // @ts-ignore
                    err.code = packet.data;
                    this._onError(err);
                    break;
                case "message":
                    this.emitReserved("data", packet.data);
                    this.emitReserved("message", packet.data);
                    break;
            }
        }
    }
    /**
     * Called upon handshake completion.
     *
     * @param {Object} data - handshake obj
     * @private
     */ onHandshake(data) {
        this.emitReserved("handshake", data);
        this.id = data.sid;
        this.transport.query.sid = data.sid;
        this._pingInterval = data.pingInterval;
        this._pingTimeout = data.pingTimeout;
        this._maxPayload = data.maxPayload;
        this.onOpen();
        // In case open handler closes socket
        if ("closed" === this.readyState) return;
        this._resetPingTimeout();
    }
    /**
     * Sets and resets ping timeout timer based on server pings.
     *
     * @private
     */ _resetPingTimeout() {
        this.clearTimeoutFn(this._pingTimeoutTimer);
        const delay = this._pingInterval + this._pingTimeout;
        this._pingTimeoutTime = Date.now() + delay;
        this._pingTimeoutTimer = this.setTimeoutFn(()=>{
            this._onClose("ping timeout");
        }, delay);
        if (this.opts.autoUnref) this._pingTimeoutTimer.unref();
    }
    /**
     * Called on `drain` event
     *
     * @private
     */ _onDrain() {
        this.writeBuffer.splice(0, this._prevBufferLen);
        // setting prevBufferLen = 0 is very important
        // for example, when upgrading, upgrade packet is sent over,
        // and a nonzero prevBufferLen could cause problems on `drain`
        this._prevBufferLen = 0;
        if (0 === this.writeBuffer.length) this.emitReserved("drain");
        else this.flush();
    }
    /**
     * Flush write buffers.
     *
     * @private
     */ flush() {
        if ("closed" !== this.readyState && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
            const packets = this._getWritablePackets();
            this.transport.send(packets);
            // keep track of current length of writeBuffer
            // splice writeBuffer and callbackBuffer on `drain`
            this._prevBufferLen = packets.length;
            this.emitReserved("flush");
        }
    }
    /**
     * Ensure the encoded size of the writeBuffer is below the maxPayload value sent by the server (only for HTTP
     * long-polling)
     *
     * @private
     */ _getWritablePackets() {
        const shouldCheckPayloadSize = this._maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1;
        if (!shouldCheckPayloadSize) return this.writeBuffer;
        let payloadSize = 1; // first packet type
        for(let i = 0; i < this.writeBuffer.length; i++){
            const data = this.writeBuffer[i].data;
            if (data) payloadSize += (0, $5vwdc.byteLength)(data);
            if (i > 0 && payloadSize > this._maxPayload) return this.writeBuffer.slice(0, i);
            payloadSize += 2; // separator + packet type
        }
        return this.writeBuffer;
    }
    /**
     * Checks whether the heartbeat timer has expired but the socket has not yet been notified.
     *
     * Note: this method is private for now because it does not really fit the WebSocket API, but if we put it in the
     * `write()` method then the message would not be buffered by the Socket.IO client.
     *
     * @return {boolean}
     * @private
     */ /* private */ _hasPingExpired() {
        if (!this._pingTimeoutTime) return true;
        const hasExpired = Date.now() > this._pingTimeoutTime;
        if (hasExpired) {
            this._pingTimeoutTime = 0;
            (0, $bN72v.nextTick)(()=>{
                this._onClose("ping timeout");
            }, this.setTimeoutFn);
        }
        return hasExpired;
    }
    /**
     * Sends a message.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @return {Socket} for chaining.
     */ write(msg, options, fn) {
        this._sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a message. Alias of {@link Socket#write}.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @return {Socket} for chaining.
     */ send(msg, options, fn) {
        this._sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a packet.
     *
     * @param {String} type: packet type.
     * @param {String} data.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @private
     */ _sendPacket(type, data, options, fn) {
        if ("function" === typeof data) {
            fn = data;
            data = undefined;
        }
        if ("function" === typeof options) {
            fn = options;
            options = null;
        }
        if ("closing" === this.readyState || "closed" === this.readyState) return;
        options = options || {};
        options.compress = false !== options.compress;
        const packet = {
            type: type,
            data: data,
            options: options
        };
        this.emitReserved("packetCreate", packet);
        this.writeBuffer.push(packet);
        if (fn) this.once("flush", fn);
        this.flush();
    }
    /**
     * Closes the connection.
     */ close() {
        const close = ()=>{
            this._onClose("forced close");
            this.transport.close();
        };
        const cleanupAndClose = ()=>{
            this.off("upgrade", cleanupAndClose);
            this.off("upgradeError", cleanupAndClose);
            close();
        };
        const waitForUpgrade = ()=>{
            // wait for upgrade to finish since we can't send packets while pausing a transport
            this.once("upgrade", cleanupAndClose);
            this.once("upgradeError", cleanupAndClose);
        };
        if ("opening" === this.readyState || "open" === this.readyState) {
            this.readyState = "closing";
            if (this.writeBuffer.length) this.once("drain", ()=>{
                if (this.upgrading) waitForUpgrade();
                else close();
            });
            else if (this.upgrading) waitForUpgrade();
            else close();
        }
        return this;
    }
    /**
     * Called upon transport error
     *
     * @private
     */ _onError(err) {
        $787375aed2c43820$export$3874118029a0ee0d.priorWebsocketSuccess = false;
        if (this.opts.tryAllTransports && this.transports.length > 1 && this.readyState === "opening") {
            this.transports.shift();
            return this._open();
        }
        this.emitReserved("error", err);
        this._onClose("transport error", err);
    }
    /**
     * Called upon transport close.
     *
     * @private
     */ _onClose(reason, description) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            // clear timers
            this.clearTimeoutFn(this._pingTimeoutTimer);
            // stop event from firing again for transport
            this.transport.removeAllListeners("close");
            // ensure transport won't stay open
            this.transport.close();
            // ignore further transport communication
            this.transport.removeAllListeners();
            if ($787375aed2c43820$var$withEventListeners) {
                if (this._beforeunloadEventListener) removeEventListener("beforeunload", this._beforeunloadEventListener, false);
                if (this._offlineEventListener) {
                    const i = $787375aed2c43820$var$OFFLINE_EVENT_LISTENERS.indexOf(this._offlineEventListener);
                    if (i !== -1) $787375aed2c43820$var$OFFLINE_EVENT_LISTENERS.splice(i, 1);
                }
            }
            // set ready state
            this.readyState = "closed";
            // clear session id
            this.id = null;
            // emit close event
            this.emitReserved("close", reason, description);
            // clean buffers after, so users can still
            // grab the buffers on `close` event
            this.writeBuffer = [];
            this._prevBufferLen = 0;
        }
    }
}
$787375aed2c43820$export$3874118029a0ee0d.protocol = (0, $CnWUo.protocol);
class $787375aed2c43820$export$cc521fcb1004e85c extends $787375aed2c43820$export$3874118029a0ee0d {
    constructor(){
        super(...arguments);
        this._upgrades = [];
    }
    onOpen() {
        super.onOpen();
        if ("open" === this.readyState && this.opts.upgrade) for(let i = 0; i < this._upgrades.length; i++)this._probe(this._upgrades[i]);
    }
    /**
     * Probes a transport.
     *
     * @param {String} name - transport name
     * @private
     */ _probe(name) {
        let transport = this.createTransport(name);
        let failed = false;
        $787375aed2c43820$export$3874118029a0ee0d.priorWebsocketSuccess = false;
        const onTransportOpen = ()=>{
            if (failed) return;
            transport.send([
                {
                    type: "ping",
                    data: "probe"
                }
            ]);
            transport.once("packet", (msg)=>{
                if (failed) return;
                if ("pong" === msg.type && "probe" === msg.data) {
                    this.upgrading = true;
                    this.emitReserved("upgrading", transport);
                    if (!transport) return;
                    $787375aed2c43820$export$3874118029a0ee0d.priorWebsocketSuccess = "websocket" === transport.name;
                    this.transport.pause(()=>{
                        if (failed) return;
                        if ("closed" === this.readyState) return;
                        cleanup();
                        this.setTransport(transport);
                        transport.send([
                            {
                                type: "upgrade"
                            }
                        ]);
                        this.emitReserved("upgrade", transport);
                        transport = null;
                        this.upgrading = false;
                        this.flush();
                    });
                } else {
                    const err = new Error("probe error");
                    // @ts-ignore
                    err.transport = transport.name;
                    this.emitReserved("upgradeError", err);
                }
            });
        };
        function freezeTransport() {
            if (failed) return;
            // Any callback called by transport should be ignored since now
            failed = true;
            cleanup();
            transport.close();
            transport = null;
        }
        // Handle any error that happens while probing
        const onerror = (err)=>{
            const error = new Error("probe error: " + err);
            // @ts-ignore
            error.transport = transport.name;
            freezeTransport();
            this.emitReserved("upgradeError", error);
        };
        function onTransportClose() {
            onerror("transport closed");
        }
        // When the socket is closed while we're probing
        function onclose() {
            onerror("socket closed");
        }
        // When the socket is upgraded while we're probing
        function onupgrade(to) {
            if (transport && to.name !== transport.name) freezeTransport();
        }
        // Remove all listeners on the transport and on self
        const cleanup = ()=>{
            transport.removeListener("open", onTransportOpen);
            transport.removeListener("error", onerror);
            transport.removeListener("close", onTransportClose);
            this.off("close", onclose);
            this.off("upgrading", onupgrade);
        };
        transport.once("open", onTransportOpen);
        transport.once("error", onerror);
        transport.once("close", onTransportClose);
        this.once("close", onclose);
        this.once("upgrading", onupgrade);
        if (this._upgrades.indexOf("webtransport") !== -1 && name !== "webtransport") // favor WebTransport
        this.setTimeoutFn(()=>{
            if (!failed) transport.open();
        }, 200);
        else transport.open();
    }
    onHandshake(data) {
        this._upgrades = this._filterUpgrades(data.upgrades);
        super.onHandshake(data);
    }
    /**
     * Filters upgrades, returning only those matching client transports.
     *
     * @param {Array} upgrades - server upgrades
     * @private
     */ _filterUpgrades(upgrades) {
        const filteredUpgrades = [];
        for(let i = 0; i < upgrades.length; i++)if (~this.transports.indexOf(upgrades[i])) filteredUpgrades.push(upgrades[i]);
        return filteredUpgrades;
    }
}
class $787375aed2c43820$export$4798917dbf149b79 extends $787375aed2c43820$export$cc521fcb1004e85c {
    constructor(uri, opts = {}){
        const o = typeof uri === "object" ? uri : opts;
        if (!o.transports || o.transports && typeof o.transports[0] === "string") o.transports = (o.transports || [
            "polling",
            "websocket",
            "webtransport"
        ]).map((transportName)=>(0, $gEtm1.transports)[transportName]).filter((t)=>!!t);
        super(uri, o);
    }
}

});
parcelRegister("gEtm1", function(module, exports) {

$parcel$export(module.exports, "transports", () => $c1f726e793763466$export$46dec00755c1153b);

var $3W81j = parcelRequire("3W81j");

var $dhyBt = parcelRequire("dhyBt");

var $hJTtX = parcelRequire("hJTtX");
const $c1f726e793763466$export$46dec00755c1153b = {
    websocket: (0, $dhyBt.WS),
    webtransport: (0, $hJTtX.WT),
    polling: (0, $3W81j.XHR)
};

});
parcelRegister("3W81j", function(module, exports) {

$parcel$export(module.exports, "XHR", () => $2ddd02863faa1587$export$a2d42eb087c10497);

var $7pvuz = parcelRequire("7pvuz");

var $5hHAH = parcelRequire("5hHAH");

var $5vwdc = parcelRequire("5vwdc");

var $bN72v = parcelRequire("bN72v");

var $kxvpX = parcelRequire("kxvpX");
function $2ddd02863faa1587$var$empty() {}
class $2ddd02863faa1587$export$c959f2344155d309 extends (0, $7pvuz.Polling) {
    /**
     * XHR Polling constructor.
     *
     * @param {Object} opts
     * @package
     */ constructor(opts){
        super(opts);
        if (typeof location !== "undefined") {
            const isSSL = "https:" === location.protocol;
            let port = location.port;
            // some user agents have empty `location.port`
            if (!port) port = isSSL ? "443" : "80";
            this.xd = typeof location !== "undefined" && opts.hostname !== location.hostname || port !== opts.port;
        }
    }
    /**
     * Sends data.
     *
     * @param {String} data to send.
     * @param {Function} called upon flush.
     * @private
     */ doWrite(data, fn) {
        const req = this.request({
            method: "POST",
            data: data
        });
        req.on("success", fn);
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr post error", xhrStatus, context);
        });
    }
    /**
     * Starts a poll cycle.
     *
     * @private
     */ doPoll() {
        const req = this.request();
        req.on("data", this.onData.bind(this));
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr poll error", xhrStatus, context);
        });
        this.pollXhr = req;
    }
}
class $2ddd02863faa1587$export$7fa6c5b6f8193917 extends (0, $5hHAH.Emitter) {
    /**
     * Request constructor
     *
     * @param {Object} options
     * @package
     */ constructor(createRequest, uri, opts){
        super();
        this.createRequest = createRequest;
        (0, $5vwdc.installTimerFunctions)(this, opts);
        this._opts = opts;
        this._method = opts.method || "GET";
        this._uri = uri;
        this._data = undefined !== opts.data ? opts.data : null;
        this._create();
    }
    /**
     * Creates the XHR object and sends the request.
     *
     * @private
     */ _create() {
        var _a;
        const opts = (0, $5vwdc.pick)(this._opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
        opts.xdomain = !!this._opts.xd;
        const xhr = this._xhr = this.createRequest(opts);
        try {
            xhr.open(this._method, this._uri, true);
            try {
                if (this._opts.extraHeaders) {
                    // @ts-ignore
                    xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
                    for(let i in this._opts.extraHeaders)if (this._opts.extraHeaders.hasOwnProperty(i)) xhr.setRequestHeader(i, this._opts.extraHeaders[i]);
                }
            } catch (e) {}
            if ("POST" === this._method) try {
                xhr.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
            } catch (e) {}
            try {
                xhr.setRequestHeader("Accept", "*/*");
            } catch (e) {}
            (_a = this._opts.cookieJar) === null || _a === void 0 || _a.addCookies(xhr);
            // ie6 check
            if ("withCredentials" in xhr) xhr.withCredentials = this._opts.withCredentials;
            if (this._opts.requestTimeout) xhr.timeout = this._opts.requestTimeout;
            xhr.onreadystatechange = ()=>{
                var _a;
                if (xhr.readyState === 3) (_a = this._opts.cookieJar) === null || _a === void 0 || _a.parseCookies(// @ts-ignore
                xhr.getResponseHeader("set-cookie"));
                if (4 !== xhr.readyState) return;
                if (200 === xhr.status || 1223 === xhr.status) this._onLoad();
                else // make sure the `error` event handler that's user-set
                // does not throw in the same tick and gets caught here
                this.setTimeoutFn(()=>{
                    this._onError(typeof xhr.status === "number" ? xhr.status : 0);
                }, 0);
            };
            xhr.send(this._data);
        } catch (e) {
            // Need to defer since .create() is called directly from the constructor
            // and thus the 'error' event can only be only bound *after* this exception
            // occurs.  Therefore, also, we cannot throw here at all.
            this.setTimeoutFn(()=>{
                this._onError(e);
            }, 0);
            return;
        }
        if (typeof document !== "undefined") {
            this._index = $2ddd02863faa1587$export$7fa6c5b6f8193917.requestsCount++;
            $2ddd02863faa1587$export$7fa6c5b6f8193917.requests[this._index] = this;
        }
    }
    /**
     * Called upon error.
     *
     * @private
     */ _onError(err) {
        this.emitReserved("error", err, this._xhr);
        this._cleanup(true);
    }
    /**
     * Cleans up house.
     *
     * @private
     */ _cleanup(fromError) {
        if ("undefined" === typeof this._xhr || null === this._xhr) return;
        this._xhr.onreadystatechange = $2ddd02863faa1587$var$empty;
        if (fromError) try {
            this._xhr.abort();
        } catch (e) {}
        if (typeof document !== "undefined") delete $2ddd02863faa1587$export$7fa6c5b6f8193917.requests[this._index];
        this._xhr = null;
    }
    /**
     * Called upon load.
     *
     * @private
     */ _onLoad() {
        const data = this._xhr.responseText;
        if (data !== null) {
            this.emitReserved("data", data);
            this.emitReserved("success");
            this._cleanup();
        }
    }
    /**
     * Aborts the request.
     *
     * @package
     */ abort() {
        this._cleanup();
    }
}
$2ddd02863faa1587$export$7fa6c5b6f8193917.requestsCount = 0;
$2ddd02863faa1587$export$7fa6c5b6f8193917.requests = {};
/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */ if (typeof document !== "undefined") {
    // @ts-ignore
    if (typeof attachEvent === "function") // @ts-ignore
    attachEvent("onunload", $2ddd02863faa1587$var$unloadHandler);
    else if (typeof addEventListener === "function") {
        const terminationEvent = "onpagehide" in (0, $bN72v.globalThisShim) ? "pagehide" : "unload";
        addEventListener(terminationEvent, $2ddd02863faa1587$var$unloadHandler, false);
    }
}
function $2ddd02863faa1587$var$unloadHandler() {
    for(let i in $2ddd02863faa1587$export$7fa6c5b6f8193917.requests)if ($2ddd02863faa1587$export$7fa6c5b6f8193917.requests.hasOwnProperty(i)) $2ddd02863faa1587$export$7fa6c5b6f8193917.requests[i].abort();
}
const $2ddd02863faa1587$var$hasXHR2 = function() {
    const xhr = $2ddd02863faa1587$var$newRequest({
        xdomain: false
    });
    return xhr && xhr.responseType !== null;
}();
class $2ddd02863faa1587$export$a2d42eb087c10497 extends $2ddd02863faa1587$export$c959f2344155d309 {
    constructor(opts){
        super(opts);
        const forceBase64 = opts && opts.forceBase64;
        this.supportsBinary = $2ddd02863faa1587$var$hasXHR2 && !forceBase64;
    }
    request(opts = {}) {
        Object.assign(opts, {
            xd: this.xd
        }, this.opts);
        return new $2ddd02863faa1587$export$7fa6c5b6f8193917($2ddd02863faa1587$var$newRequest, this.uri(), opts);
    }
}
function $2ddd02863faa1587$var$newRequest(opts) {
    const xdomain = opts.xdomain;
    // XMLHttpRequest can be disabled on IE
    try {
        if ("undefined" !== typeof XMLHttpRequest && (!xdomain || (0, $kxvpX.hasCORS))) return new XMLHttpRequest();
    } catch (e) {}
    if (!xdomain) try {
        return new (0, $bN72v.globalThisShim)[[
            "Active"
        ].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch (e) {}
}

});
parcelRegister("7pvuz", function(module, exports) {

$parcel$export(module.exports, "Polling", () => $56534be56e5aa809$export$265ee5eefd4c309b);

var $6opKi = parcelRequire("6opKi");

var $5vwdc = parcelRequire("5vwdc");

var $CnWUo = parcelRequire("CnWUo");
class $56534be56e5aa809$export$265ee5eefd4c309b extends (0, $6opKi.Transport) {
    constructor(){
        super(...arguments);
        this._polling = false;
    }
    get name() {
        return "polling";
    }
    /**
     * Opens the socket (triggers polling). We write a PING message to determine
     * when the transport is open.
     *
     * @protected
     */ doOpen() {
        this._poll();
    }
    /**
     * Pauses polling.
     *
     * @param {Function} onPause - callback upon buffers are flushed and transport is paused
     * @package
     */ pause(onPause) {
        this.readyState = "pausing";
        const pause = ()=>{
            this.readyState = "paused";
            onPause();
        };
        if (this._polling || !this.writable) {
            let total = 0;
            if (this._polling) {
                total++;
                this.once("pollComplete", function() {
                    --total || pause();
                });
            }
            if (!this.writable) {
                total++;
                this.once("drain", function() {
                    --total || pause();
                });
            }
        } else pause();
    }
    /**
     * Starts polling cycle.
     *
     * @private
     */ _poll() {
        this._polling = true;
        this.doPoll();
        this.emitReserved("poll");
    }
    /**
     * Overloads onData to detect payloads.
     *
     * @protected
     */ onData(data) {
        const callback = (packet)=>{
            // if its the first message we consider the transport open
            if ("opening" === this.readyState && packet.type === "open") this.onOpen();
            // if its a close packet, we close the ongoing requests
            if ("close" === packet.type) {
                this.onClose({
                    description: "transport closed by the server"
                });
                return false;
            }
            // otherwise bypass onData and handle the message
            this.onPacket(packet);
        };
        // decode payload
        (0, $CnWUo.decodePayload)(data, this.socket.binaryType).forEach(callback);
        // if an event did not trigger closing
        if ("closed" !== this.readyState) {
            // if we got data we're not polling
            this._polling = false;
            this.emitReserved("pollComplete");
            if ("open" === this.readyState) this._poll();
        }
    }
    /**
     * For polling, send a close packet.
     *
     * @protected
     */ doClose() {
        const close = ()=>{
            this.write([
                {
                    type: "close"
                }
            ]);
        };
        if ("open" === this.readyState) close();
        else // in case we're trying to close while
        // handshaking is in progress (GH-164)
        this.once("open", close);
    }
    /**
     * Writes a packets payload.
     *
     * @param {Array} packets - data packets
     * @protected
     */ write(packets) {
        this.writable = false;
        (0, $CnWUo.encodePayload)(packets, (data)=>{
            this.doWrite(data, ()=>{
                this.writable = true;
                this.emitReserved("drain");
            });
        });
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "https" : "http";
        const query = this.query || {};
        // cache busting is forced
        if (false !== this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $5vwdc.randomString)();
        if (!this.supportsBinary && !query.sid) query.b64 = 1;
        return this.createUri(schema, query);
    }
}

});
parcelRegister("6opKi", function(module, exports) {

$parcel$export(module.exports, "Transport", () => $4a78f487f5bb98d8$export$86495b081fef8e52);
parcelRequire("CnWUo");
var $ezyGD = parcelRequire("ezyGD");

var $5hHAH = parcelRequire("5hHAH");

var $5vwdc = parcelRequire("5vwdc");

var $2buxl = parcelRequire("2buxl");
class $4a78f487f5bb98d8$export$8e68de6fb26f2236 extends Error {
    constructor(reason, description, context){
        super(reason);
        this.description = description;
        this.context = context;
        this.type = "TransportError";
    }
}
class $4a78f487f5bb98d8$export$86495b081fef8e52 extends (0, $5hHAH.Emitter) {
    /**
     * Transport abstract constructor.
     *
     * @param {Object} opts - options
     * @protected
     */ constructor(opts){
        super();
        this.writable = false;
        (0, $5vwdc.installTimerFunctions)(this, opts);
        this.opts = opts;
        this.query = opts.query;
        this.socket = opts.socket;
        this.supportsBinary = !opts.forceBase64;
    }
    /**
     * Emits an error.
     *
     * @param {String} reason
     * @param description
     * @param context - the error context
     * @return {Transport} for chaining
     * @protected
     */ onError(reason, description, context) {
        super.emitReserved("error", new $4a78f487f5bb98d8$export$8e68de6fb26f2236(reason, description, context));
        return this;
    }
    /**
     * Opens the transport.
     */ open() {
        this.readyState = "opening";
        this.doOpen();
        return this;
    }
    /**
     * Closes the transport.
     */ close() {
        if (this.readyState === "opening" || this.readyState === "open") {
            this.doClose();
            this.onClose();
        }
        return this;
    }
    /**
     * Sends multiple packets.
     *
     * @param {Array} packets
     */ send(packets) {
        if (this.readyState === "open") this.write(packets);
    }
    /**
     * Called upon open
     *
     * @protected
     */ onOpen() {
        this.readyState = "open";
        this.writable = true;
        super.emitReserved("open");
    }
    /**
     * Called with data.
     *
     * @param {String} data
     * @protected
     */ onData(data) {
        const packet = (0, $ezyGD.decodePacket)(data, this.socket.binaryType);
        this.onPacket(packet);
    }
    /**
     * Called with a decoded packet.
     *
     * @protected
     */ onPacket(packet) {
        super.emitReserved("packet", packet);
    }
    /**
     * Called upon close.
     *
     * @protected
     */ onClose(details) {
        this.readyState = "closed";
        super.emitReserved("close", details);
    }
    /**
     * Pauses the transport, in order not to lose packets during an upgrade.
     *
     * @param onPause
     */ pause(onPause) {}
    createUri(schema, query = {}) {
        return schema + "://" + this._hostname() + this._port() + this.opts.path + this._query(query);
    }
    _hostname() {
        const hostname = this.opts.hostname;
        return hostname.indexOf(":") === -1 ? hostname : "[" + hostname + "]";
    }
    _port() {
        if (this.opts.port && (this.opts.secure && Number(this.opts.port) !== 443 || !this.opts.secure && Number(this.opts.port) !== 80)) return ":" + this.opts.port;
        else return "";
    }
    _query(query) {
        const encodedQuery = (0, $2buxl.encode)(query);
        return encodedQuery.length ? "?" + encodedQuery : "";
    }
}

});
parcelRegister("CnWUo", function(module, exports) {

$parcel$export(module.exports, "encodePayload", () => $0736208648dc8bae$export$144d64fe58dad441);
$parcel$export(module.exports, "decodePayload", () => $0736208648dc8bae$export$d10cc2e7f7566a2d);
$parcel$export(module.exports, "createPacketEncoderStream", () => $0736208648dc8bae$export$a525fb718e9c623a);
$parcel$export(module.exports, "createPacketDecoderStream", () => $0736208648dc8bae$export$552d20aac7500f47);
$parcel$export(module.exports, "protocol", () => $0736208648dc8bae$export$a51d6b395ff4c65a);
$parcel$export(module.exports, "encodePacket", () => (parcelRequire("bRHuL")).encodePacket);
$parcel$export(module.exports, "decodePacket", () => (parcelRequire("ezyGD")).decodePacket);

var $bRHuL = parcelRequire("bRHuL");

var $ezyGD = parcelRequire("ezyGD");

var $fsDlh = parcelRequire("fsDlh");
const $0736208648dc8bae$var$SEPARATOR = String.fromCharCode(30); // see https://en.wikipedia.org/wiki/Delimiter#ASCII_delimited_text
const $0736208648dc8bae$export$144d64fe58dad441 = (packets, callback)=>{
    // some packets may be added to the array while encoding, so the initial length must be saved
    const length = packets.length;
    const encodedPackets = new Array(length);
    let count = 0;
    packets.forEach((packet, i)=>{
        // force base64 encoding for binary packets
        (0, $bRHuL.encodePacket)(packet, false, (encodedPacket)=>{
            encodedPackets[i] = encodedPacket;
            if (++count === length) callback(encodedPackets.join($0736208648dc8bae$var$SEPARATOR));
        });
    });
};
const $0736208648dc8bae$export$d10cc2e7f7566a2d = (encodedPayload, binaryType)=>{
    const encodedPackets = encodedPayload.split($0736208648dc8bae$var$SEPARATOR);
    const packets = [];
    for(let i = 0; i < encodedPackets.length; i++){
        const decodedPacket = (0, $ezyGD.decodePacket)(encodedPackets[i], binaryType);
        packets.push(decodedPacket);
        if (decodedPacket.type === "error") break;
    }
    return packets;
};
function $0736208648dc8bae$export$a525fb718e9c623a() {
    return new TransformStream({
        transform (packet, controller) {
            (0, $bRHuL.encodePacketToBinary)(packet, (encodedPacket)=>{
                const payloadLength = encodedPacket.length;
                let header;
                // inspired by the WebSocket format: https://developer.mozilla.org/en-US/docs/Web/API/WebSockets_API/Writing_WebSocket_servers#decoding_payload_length
                if (payloadLength < 126) {
                    header = new Uint8Array(1);
                    new DataView(header.buffer).setUint8(0, payloadLength);
                } else if (payloadLength < 65536) {
                    header = new Uint8Array(3);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 126);
                    view.setUint16(1, payloadLength);
                } else {
                    header = new Uint8Array(9);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 127);
                    view.setBigUint64(1, BigInt(payloadLength));
                }
                // first bit indicates whether the payload is plain text (0) or binary (1)
                if (packet.data && typeof packet.data !== "string") header[0] |= 0x80;
                controller.enqueue(header);
                controller.enqueue(encodedPacket);
            });
        }
    });
}
let $0736208648dc8bae$var$TEXT_DECODER;
function $0736208648dc8bae$var$totalLength(chunks) {
    return chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
}
function $0736208648dc8bae$var$concatChunks(chunks, size) {
    if (chunks[0].length === size) return chunks.shift();
    const buffer = new Uint8Array(size);
    let j = 0;
    for(let i = 0; i < size; i++){
        buffer[i] = chunks[0][j++];
        if (j === chunks[0].length) {
            chunks.shift();
            j = 0;
        }
    }
    if (chunks.length && j < chunks[0].length) chunks[0] = chunks[0].slice(j);
    return buffer;
}
function $0736208648dc8bae$export$552d20aac7500f47(maxPayload, binaryType) {
    if (!$0736208648dc8bae$var$TEXT_DECODER) $0736208648dc8bae$var$TEXT_DECODER = new TextDecoder();
    const chunks = [];
    let state = 0 /* State.READ_HEADER */ ;
    let expectedLength = -1;
    let isBinary = false;
    return new TransformStream({
        transform (chunk, controller) {
            chunks.push(chunk);
            while(true){
                if (state === 0 /* State.READ_HEADER */ ) {
                    if ($0736208648dc8bae$var$totalLength(chunks) < 1) break;
                    const header = $0736208648dc8bae$var$concatChunks(chunks, 1);
                    isBinary = (header[0] & 0x80) === 0x80;
                    expectedLength = header[0] & 0x7f;
                    if (expectedLength < 126) state = 3 /* State.READ_PAYLOAD */ ;
                    else if (expectedLength === 126) state = 1 /* State.READ_EXTENDED_LENGTH_16 */ ;
                    else state = 2 /* State.READ_EXTENDED_LENGTH_64 */ ;
                } else if (state === 1 /* State.READ_EXTENDED_LENGTH_16 */ ) {
                    if ($0736208648dc8bae$var$totalLength(chunks) < 2) break;
                    const headerArray = $0736208648dc8bae$var$concatChunks(chunks, 2);
                    expectedLength = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length).getUint16(0);
                    state = 3 /* State.READ_PAYLOAD */ ;
                } else if (state === 2 /* State.READ_EXTENDED_LENGTH_64 */ ) {
                    if ($0736208648dc8bae$var$totalLength(chunks) < 8) break;
                    const headerArray = $0736208648dc8bae$var$concatChunks(chunks, 8);
                    const view = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length);
                    const n = view.getUint32(0);
                    if (n > Math.pow(2, 21) - 1) {
                        // the maximum safe integer in JavaScript is 2^53 - 1
                        controller.enqueue((0, $fsDlh.ERROR_PACKET));
                        break;
                    }
                    expectedLength = n * Math.pow(2, 32) + view.getUint32(4);
                    state = 3 /* State.READ_PAYLOAD */ ;
                } else {
                    if ($0736208648dc8bae$var$totalLength(chunks) < expectedLength) break;
                    const data = $0736208648dc8bae$var$concatChunks(chunks, expectedLength);
                    controller.enqueue((0, $ezyGD.decodePacket)(isBinary ? data : $0736208648dc8bae$var$TEXT_DECODER.decode(data), binaryType));
                    state = 0 /* State.READ_HEADER */ ;
                }
                if (expectedLength === 0 || expectedLength > maxPayload) {
                    controller.enqueue((0, $fsDlh.ERROR_PACKET));
                    break;
                }
            }
        }
    });
}
const $0736208648dc8bae$export$a51d6b395ff4c65a = 4;

});
parcelRegister("bRHuL", function(module, exports) {

$parcel$export(module.exports, "encodePacket", () => $8a3662315a48cdbd$export$57852049361a8e62);
$parcel$export(module.exports, "encodePacketToBinary", () => $8a3662315a48cdbd$export$ec0c9b9013ee0ef5);

var $fsDlh = parcelRequire("fsDlh");
const $8a3662315a48cdbd$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]";
const $8a3662315a48cdbd$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
// ArrayBuffer.isView method is not defined in IE10
const $8a3662315a48cdbd$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj && obj.buffer instanceof ArrayBuffer;
};
const $8a3662315a48cdbd$export$57852049361a8e62 = ({ type: type, data: data }, supportsBinary, callback)=>{
    if ($8a3662315a48cdbd$var$withNativeBlob && data instanceof Blob) {
        if (supportsBinary) return callback(data);
        else return $8a3662315a48cdbd$var$encodeBlobAsBase64(data, callback);
    } else if ($8a3662315a48cdbd$var$withNativeArrayBuffer && (data instanceof ArrayBuffer || $8a3662315a48cdbd$var$isView(data))) {
        if (supportsBinary) return callback(data);
        else return $8a3662315a48cdbd$var$encodeBlobAsBase64(new Blob([
            data
        ]), callback);
    }
    // plain string
    return callback((0, $fsDlh.PACKET_TYPES)[type] + (data || ""));
};
const $8a3662315a48cdbd$var$encodeBlobAsBase64 = (data, callback)=>{
    const fileReader = new FileReader();
    fileReader.onload = function() {
        const content = fileReader.result.split(",")[1];
        callback("b" + (content || ""));
    };
    return fileReader.readAsDataURL(data);
};
function $8a3662315a48cdbd$var$toArray(data) {
    if (data instanceof Uint8Array) return data;
    else if (data instanceof ArrayBuffer) return new Uint8Array(data);
    else return new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
}
let $8a3662315a48cdbd$var$TEXT_ENCODER;
function $8a3662315a48cdbd$export$ec0c9b9013ee0ef5(packet, callback) {
    if ($8a3662315a48cdbd$var$withNativeBlob && packet.data instanceof Blob) return packet.data.arrayBuffer().then($8a3662315a48cdbd$var$toArray).then(callback);
    else if ($8a3662315a48cdbd$var$withNativeArrayBuffer && (packet.data instanceof ArrayBuffer || $8a3662315a48cdbd$var$isView(packet.data))) return callback($8a3662315a48cdbd$var$toArray(packet.data));
    $8a3662315a48cdbd$export$57852049361a8e62(packet, false, (encoded)=>{
        if (!$8a3662315a48cdbd$var$TEXT_ENCODER) $8a3662315a48cdbd$var$TEXT_ENCODER = new TextEncoder();
        callback($8a3662315a48cdbd$var$TEXT_ENCODER.encode(encoded));
    });
}

});
parcelRegister("fsDlh", function(module, exports) {

$parcel$export(module.exports, "PACKET_TYPES", () => $b417fd17fc84e4e3$export$c169aefb7330cccb);
$parcel$export(module.exports, "PACKET_TYPES_REVERSE", () => $b417fd17fc84e4e3$export$47791e8004edd485);
$parcel$export(module.exports, "ERROR_PACKET", () => $b417fd17fc84e4e3$export$c718b5840781f8a7);
const $b417fd17fc84e4e3$export$c169aefb7330cccb = Object.create(null); // no Map = no polyfill
$b417fd17fc84e4e3$export$c169aefb7330cccb["open"] = "0";
$b417fd17fc84e4e3$export$c169aefb7330cccb["close"] = "1";
$b417fd17fc84e4e3$export$c169aefb7330cccb["ping"] = "2";
$b417fd17fc84e4e3$export$c169aefb7330cccb["pong"] = "3";
$b417fd17fc84e4e3$export$c169aefb7330cccb["message"] = "4";
$b417fd17fc84e4e3$export$c169aefb7330cccb["upgrade"] = "5";
$b417fd17fc84e4e3$export$c169aefb7330cccb["noop"] = "6";
const $b417fd17fc84e4e3$export$47791e8004edd485 = Object.create(null);
Object.keys($b417fd17fc84e4e3$export$c169aefb7330cccb).forEach((key)=>{
    $b417fd17fc84e4e3$export$47791e8004edd485[$b417fd17fc84e4e3$export$c169aefb7330cccb[key]] = key;
});
const $b417fd17fc84e4e3$export$c718b5840781f8a7 = {
    type: "error",
    data: "parser error"
};

});


parcelRegister("ezyGD", function(module, exports) {

$parcel$export(module.exports, "decodePacket", () => $a9bf3da28855a34f$export$4647901878f33f31);

var $fsDlh = parcelRequire("fsDlh");

var $aVEkU = parcelRequire("aVEkU");
const $a9bf3da28855a34f$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $a9bf3da28855a34f$export$4647901878f33f31 = (encodedPacket, binaryType)=>{
    if (typeof encodedPacket !== "string") return {
        type: "message",
        data: $a9bf3da28855a34f$var$mapBinary(encodedPacket, binaryType)
    };
    const type = encodedPacket.charAt(0);
    if (type === "b") return {
        type: "message",
        data: $a9bf3da28855a34f$var$decodeBase64Packet(encodedPacket.substring(1), binaryType)
    };
    const packetType = (0, $fsDlh.PACKET_TYPES_REVERSE)[type];
    if (!packetType) return 0, $fsDlh.ERROR_PACKET;
    return encodedPacket.length > 1 ? {
        type: (0, $fsDlh.PACKET_TYPES_REVERSE)[type],
        data: encodedPacket.substring(1)
    } : {
        type: (0, $fsDlh.PACKET_TYPES_REVERSE)[type]
    };
};
const $a9bf3da28855a34f$var$decodeBase64Packet = (data, binaryType)=>{
    if ($a9bf3da28855a34f$var$withNativeArrayBuffer) {
        const decoded = (0, $aVEkU.decode)(data);
        return $a9bf3da28855a34f$var$mapBinary(decoded, binaryType);
    } else return {
        base64: true,
        data: data
    }; // fallback for old browsers
};
const $a9bf3da28855a34f$var$mapBinary = (data, binaryType)=>{
    switch(binaryType){
        case "blob":
            if (data instanceof Blob) // from WebSocket + binaryType "blob"
            return data;
            else // from HTTP long-polling or WebTransport
            return new Blob([
                data
            ]);
        case "arraybuffer":
        default:
            if (data instanceof ArrayBuffer) // from HTTP long-polling (base64) or WebSocket + binaryType "arraybuffer"
            return data;
            else // from WebTransport (Uint8Array)
            return data.buffer;
    }
};

});
parcelRegister("aVEkU", function(module, exports) {

$parcel$export(module.exports, "decode", () => $7f4e842ae29bcbc5$export$2f872c0f2117be69);
// imported from https://github.com/socketio/base64-arraybuffer
const $7f4e842ae29bcbc5$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
const $7f4e842ae29bcbc5$var$lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
for(let i = 0; i < $7f4e842ae29bcbc5$var$chars.length; i++)$7f4e842ae29bcbc5$var$lookup[$7f4e842ae29bcbc5$var$chars.charCodeAt(i)] = i;
const $7f4e842ae29bcbc5$export$c564cdbbe6da493 = (arraybuffer)=>{
    let bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = '';
    for(i = 0; i < len; i += 3){
        base64 += $7f4e842ae29bcbc5$var$chars[bytes[i] >> 2];
        base64 += $7f4e842ae29bcbc5$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $7f4e842ae29bcbc5$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $7f4e842ae29bcbc5$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + '=';
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + '==';
    return base64;
};
const $7f4e842ae29bcbc5$export$2f872c0f2117be69 = (base64)=>{
    let bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
    if (base64[base64.length - 1] === '=') {
        bufferLength--;
        if (base64[base64.length - 2] === '=') bufferLength--;
    }
    const arraybuffer = new ArrayBuffer(bufferLength), bytes = new Uint8Array(arraybuffer);
    for(i = 0; i < len; i += 4){
        encoded1 = $7f4e842ae29bcbc5$var$lookup[base64.charCodeAt(i)];
        encoded2 = $7f4e842ae29bcbc5$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $7f4e842ae29bcbc5$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $7f4e842ae29bcbc5$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return arraybuffer;
};

});



parcelRegister("5hHAH", function(module, exports) {

$parcel$export(module.exports, "Emitter", () => $3d905a8ca243a015$export$4293555f241ae35a);
/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */ function $3d905a8ca243a015$export$4293555f241ae35a(obj) {
    if (obj) return $3d905a8ca243a015$var$mixin(obj);
}
/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */ function $3d905a8ca243a015$var$mixin(obj) {
    for(var key in $3d905a8ca243a015$export$4293555f241ae35a.prototype)obj[key] = $3d905a8ca243a015$export$4293555f241ae35a.prototype[key];
    return obj;
}
/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $3d905a8ca243a015$export$4293555f241ae35a.prototype.on = $3d905a8ca243a015$export$4293555f241ae35a.prototype.addEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    (this._callbacks['$' + event] = this._callbacks['$' + event] || []).push(fn);
    return this;
};
/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $3d905a8ca243a015$export$4293555f241ae35a.prototype.once = function(event, fn) {
    function on() {
        this.off(event, on);
        fn.apply(this, arguments);
    }
    on.fn = fn;
    this.on(event, on);
    return this;
};
/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $3d905a8ca243a015$export$4293555f241ae35a.prototype.off = $3d905a8ca243a015$export$4293555f241ae35a.prototype.removeListener = $3d905a8ca243a015$export$4293555f241ae35a.prototype.removeAllListeners = $3d905a8ca243a015$export$4293555f241ae35a.prototype.removeEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    // all
    if (0 == arguments.length) {
        this._callbacks = {};
        return this;
    }
    // specific event
    var callbacks = this._callbacks['$' + event];
    if (!callbacks) return this;
    // remove all handlers
    if (1 == arguments.length) {
        delete this._callbacks['$' + event];
        return this;
    }
    // remove specific handler
    var cb;
    for(var i = 0; i < callbacks.length; i++){
        cb = callbacks[i];
        if (cb === fn || cb.fn === fn) {
            callbacks.splice(i, 1);
            break;
        }
    }
    // Remove event specific arrays for event types that no
    // one is subscribed for to avoid memory leak.
    if (callbacks.length === 0) delete this._callbacks['$' + event];
    return this;
};
/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */ $3d905a8ca243a015$export$4293555f241ae35a.prototype.emit = function(event) {
    this._callbacks = this._callbacks || {};
    var args = new Array(arguments.length - 1), callbacks = this._callbacks['$' + event];
    for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    if (callbacks) {
        callbacks = callbacks.slice(0);
        for(var i = 0, len = callbacks.length; i < len; ++i)callbacks[i].apply(this, args);
    }
    return this;
};
// alias used for reserved events (protected method)
$3d905a8ca243a015$export$4293555f241ae35a.prototype.emitReserved = $3d905a8ca243a015$export$4293555f241ae35a.prototype.emit;
/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */ $3d905a8ca243a015$export$4293555f241ae35a.prototype.listeners = function(event) {
    this._callbacks = this._callbacks || {};
    return this._callbacks['$' + event] || [];
};
/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */ $3d905a8ca243a015$export$4293555f241ae35a.prototype.hasListeners = function(event) {
    return !!this.listeners(event).length;
};

});

parcelRegister("5vwdc", function(module, exports) {

$parcel$export(module.exports, "pick", () => $4028d5a20a4526d1$export$357523c63a2253b9);
$parcel$export(module.exports, "installTimerFunctions", () => $4028d5a20a4526d1$export$2f67576668b97183);
$parcel$export(module.exports, "byteLength", () => $4028d5a20a4526d1$export$a48f0734ac7c2329);
$parcel$export(module.exports, "randomString", () => $4028d5a20a4526d1$export$7fa8378418b4411e);

var $bN72v = parcelRequire("bN72v");
function $4028d5a20a4526d1$export$357523c63a2253b9(obj, ...attr) {
    return attr.reduce((acc, k)=>{
        if (obj.hasOwnProperty(k)) acc[k] = obj[k];
        return acc;
    }, {});
}
// Keep a reference to the real timeout functions so they can be used when overridden
const $4028d5a20a4526d1$var$NATIVE_SET_TIMEOUT = (0, $bN72v.globalThisShim).setTimeout;
const $4028d5a20a4526d1$var$NATIVE_CLEAR_TIMEOUT = (0, $bN72v.globalThisShim).clearTimeout;
function $4028d5a20a4526d1$export$2f67576668b97183(obj, opts) {
    if (opts.useNativeTimers) {
        obj.setTimeoutFn = $4028d5a20a4526d1$var$NATIVE_SET_TIMEOUT.bind((0, $bN72v.globalThisShim));
        obj.clearTimeoutFn = $4028d5a20a4526d1$var$NATIVE_CLEAR_TIMEOUT.bind((0, $bN72v.globalThisShim));
    } else {
        obj.setTimeoutFn = (0, $bN72v.globalThisShim).setTimeout.bind((0, $bN72v.globalThisShim));
        obj.clearTimeoutFn = (0, $bN72v.globalThisShim).clearTimeout.bind((0, $bN72v.globalThisShim));
    }
}
// base64 encoded buffers are about 33% bigger (https://en.wikipedia.org/wiki/Base64)
const $4028d5a20a4526d1$var$BASE64_OVERHEAD = 1.33;
function $4028d5a20a4526d1$export$a48f0734ac7c2329(obj) {
    if (typeof obj === "string") return $4028d5a20a4526d1$var$utf8Length(obj);
    // arraybuffer or blob
    return Math.ceil((obj.byteLength || obj.size) * $4028d5a20a4526d1$var$BASE64_OVERHEAD);
}
function $4028d5a20a4526d1$var$utf8Length(str) {
    let c = 0, length = 0;
    for(let i = 0, l = str.length; i < l; i++){
        c = str.charCodeAt(i);
        if (c < 0x80) length += 1;
        else if (c < 0x800) length += 2;
        else if (c < 0xd800 || c >= 0xe000) length += 3;
        else {
            i++;
            length += 4;
        }
    }
    return length;
}
function $4028d5a20a4526d1$export$7fa8378418b4411e() {
    return Date.now().toString(36).substring(3) + Math.random().toString(36).substring(2, 5);
}

});
parcelRegister("bN72v", function(module, exports) {

$parcel$export(module.exports, "nextTick", () => $8959bb304e43f43f$export$bdd553fddd433dcb);
$parcel$export(module.exports, "globalThisShim", () => $8959bb304e43f43f$export$394f9358f6231289);
$parcel$export(module.exports, "defaultBinaryType", () => $8959bb304e43f43f$export$790dcbc41e2d75d5);
$parcel$export(module.exports, "createCookieJar", () => $8959bb304e43f43f$export$19413efcf2fac759);
const $8959bb304e43f43f$export$bdd553fddd433dcb = (()=>{
    const isPromiseAvailable = typeof Promise === "function" && typeof Promise.resolve === "function";
    if (isPromiseAvailable) return (cb)=>Promise.resolve().then(cb);
    else return (cb, setTimeoutFn)=>setTimeoutFn(cb, 0);
})();
const $8959bb304e43f43f$export$394f9358f6231289 = (()=>{
    if (typeof self !== "undefined") return self;
    else if (typeof window !== "undefined") return window;
    else return Function("return this")();
})();
const $8959bb304e43f43f$export$790dcbc41e2d75d5 = "arraybuffer";
function $8959bb304e43f43f$export$19413efcf2fac759() {}

});


parcelRegister("2buxl", function(module, exports) {

$parcel$export(module.exports, "encode", () => $19744bce3c183d10$export$c564cdbbe6da493);
$parcel$export(module.exports, "decode", () => $19744bce3c183d10$export$2f872c0f2117be69);
// imported from https://github.com/galkn/querystring
/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */ function $19744bce3c183d10$export$c564cdbbe6da493(obj) {
    let str = '';
    for(let i in obj)if (obj.hasOwnProperty(i)) {
        if (str.length) str += '&';
        str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
    }
    return str;
}
function $19744bce3c183d10$export$2f872c0f2117be69(qs) {
    let qry = {};
    let pairs = qs.split('&');
    for(let i = 0, l = pairs.length; i < l; i++){
        let pair = pairs[i].split('=');
        qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }
    return qry;
}

});



parcelRegister("kxvpX", function(module, exports) {

$parcel$export(module.exports, "hasCORS", () => $ef3f42a25dd224af$export$5235bbd4a1ef06e);
// imported from https://github.com/component/has-cors
let $ef3f42a25dd224af$var$value = false;
try {
    $ef3f42a25dd224af$var$value = typeof XMLHttpRequest !== 'undefined' && 'withCredentials' in new XMLHttpRequest();
} catch (err) {
// if XMLHttp support is disabled in IE then it will throw
// when trying to create
}
const $ef3f42a25dd224af$export$5235bbd4a1ef06e = $ef3f42a25dd224af$var$value;

});


parcelRegister("dhyBt", function(module, exports) {

$parcel$export(module.exports, "WS", () => $9ab7b46a38551fa4$export$911baa0677ac404c);

var $6opKi = parcelRequire("6opKi");

var $5vwdc = parcelRequire("5vwdc");
parcelRequire("CnWUo");
var $bRHuL = parcelRequire("bRHuL");

var $bN72v = parcelRequire("bN72v");
// detect ReactNative environment
const $9ab7b46a38551fa4$var$isReactNative = typeof navigator !== "undefined" && typeof navigator.product === "string" && navigator.product.toLowerCase() === "reactnative";
class $9ab7b46a38551fa4$export$570bf71d2367e261 extends (0, $6opKi.Transport) {
    get name() {
        return "websocket";
    }
    doOpen() {
        const uri = this.uri();
        const protocols = this.opts.protocols;
        // React Native only supports the 'headers' option, and will print a warning if anything else is passed
        const opts = $9ab7b46a38551fa4$var$isReactNative ? {} : (0, $5vwdc.pick)(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
        if (this.opts.extraHeaders) opts.headers = this.opts.extraHeaders;
        try {
            this.ws = this.createSocket(uri, protocols, opts);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this.ws.binaryType = this.socket.binaryType;
        this.addEventListeners();
    }
    /**
     * Adds event listeners to the socket
     *
     * @private
     */ addEventListeners() {
        this.ws.onopen = ()=>{
            if (this.opts.autoUnref) this.ws._socket.unref();
            this.onOpen();
        };
        this.ws.onclose = (closeEvent)=>this.onClose({
                description: "websocket connection closed",
                context: closeEvent
            });
        this.ws.onmessage = (ev)=>this.onData(ev.data);
        this.ws.onerror = (e)=>this.onError("websocket error", e);
    }
    write(packets) {
        this.writable = false;
        // encodePacket efficient as it uses WS framing
        // no need for encodePayload
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            (0, $bRHuL.encodePacket)(packet, this.supportsBinary, (data)=>{
                // Sometimes the websocket has already been closed but the browser didn't
                // have a chance of informing us about it yet, in that case send will
                // throw an error
                try {
                    this.doWrite(packet, data);
                } catch (e) {}
                if (lastPacket) // fake drain
                // defer to next tick to allow Socket to clear writeBuffer
                (0, $bN72v.nextTick)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        if (typeof this.ws !== "undefined") {
            this.ws.onerror = ()=>{};
            this.ws.close();
            this.ws = null;
        }
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "wss" : "ws";
        const query = this.query || {};
        // append timestamp to URI
        if (this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $5vwdc.randomString)();
        // communicate binary support capabilities
        if (!this.supportsBinary) query.b64 = 1;
        return this.createUri(schema, query);
    }
}
const $9ab7b46a38551fa4$var$WebSocketCtor = (0, $bN72v.globalThisShim).WebSocket || (0, $bN72v.globalThisShim).MozWebSocket;
class $9ab7b46a38551fa4$export$911baa0677ac404c extends $9ab7b46a38551fa4$export$570bf71d2367e261 {
    createSocket(uri, protocols, opts) {
        return !$9ab7b46a38551fa4$var$isReactNative ? protocols ? new $9ab7b46a38551fa4$var$WebSocketCtor(uri, protocols) : new $9ab7b46a38551fa4$var$WebSocketCtor(uri) : new $9ab7b46a38551fa4$var$WebSocketCtor(uri, protocols, opts);
    }
    doWrite(_packet, data) {
        this.ws.send(data);
    }
}

});

parcelRegister("hJTtX", function(module, exports) {

$parcel$export(module.exports, "WT", () => $cea1ad415a07b478$export$961c930859384407);

var $6opKi = parcelRequire("6opKi");

var $bN72v = parcelRequire("bN72v");

var $CnWUo = parcelRequire("CnWUo");
class $cea1ad415a07b478$export$961c930859384407 extends (0, $6opKi.Transport) {
    get name() {
        return "webtransport";
    }
    doOpen() {
        try {
            // @ts-ignore
            this._transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this._transport.closed.then(()=>{
            this.onClose();
        }).catch((err)=>{
            this.onError("webtransport error", err);
        });
        // note: we could have used async/await, but that would require some additional polyfills
        this._transport.ready.then(()=>{
            this._transport.createBidirectionalStream().then((stream)=>{
                const decoderStream = (0, $CnWUo.createPacketDecoderStream)(Number.MAX_SAFE_INTEGER, this.socket.binaryType);
                const reader = stream.readable.pipeThrough(decoderStream).getReader();
                const encoderStream = (0, $CnWUo.createPacketEncoderStream)();
                encoderStream.readable.pipeTo(stream.writable);
                this._writer = encoderStream.writable.getWriter();
                const read = ()=>{
                    reader.read().then(({ done: done, value: value })=>{
                        if (done) return;
                        this.onPacket(value);
                        read();
                    }).catch((err)=>{});
                };
                read();
                const packet = {
                    type: "open"
                };
                if (this.query.sid) packet.data = `{"sid":"${this.query.sid}"}`;
                this._writer.write(packet).then(()=>this.onOpen());
            });
        });
    }
    write(packets) {
        this.writable = false;
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            this._writer.write(packet).then(()=>{
                if (lastPacket) (0, $bN72v.nextTick)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        var _a;
        (_a = this._transport) === null || _a === void 0 || _a.close();
    }
}

});


parcelRegister("l7wSz", function(module, exports) {

$parcel$export(module.exports, "parse", () => $f603c1892ffe9e8b$export$98e6a39c04603d36);
// imported from https://github.com/galkn/parseuri
/**
 * Parses a URI
 *
 * Note: we could also have used the built-in URL object, but it isn't supported on all platforms.
 *
 * See:
 * - https://developer.mozilla.org/en-US/docs/Web/API/URL
 * - https://caniuse.com/url
 * - https://www.rfc-editor.org/rfc/rfc3986#appendix-B
 *
 * History of the parse() method:
 * - first commit: https://github.com/socketio/socket.io-client/commit/4ee1d5d94b3906a9c052b459f1a818b15f38f91c
 * - export into its own module: https://github.com/socketio/engine.io-client/commit/de2c561e4564efeb78f1bdb1ba39ef81b2822cb3
 * - reimport: https://github.com/socketio/engine.io-client/commit/df32277c3f6d622eec5ed09f493cae3f3391d242
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */ const $f603c1892ffe9e8b$var$re = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
const $f603c1892ffe9e8b$var$parts = [
    'source',
    'protocol',
    'authority',
    'userInfo',
    'user',
    'password',
    'host',
    'port',
    'relative',
    'path',
    'directory',
    'file',
    'query',
    'anchor'
];
function $f603c1892ffe9e8b$export$98e6a39c04603d36(str) {
    if (str.length > 8000) throw "URI too long";
    const src = str, b = str.indexOf('['), e = str.indexOf(']');
    if (b != -1 && e != -1) str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
    let m = $f603c1892ffe9e8b$var$re.exec(str || ''), uri = {}, i = 14;
    while(i--)uri[$f603c1892ffe9e8b$var$parts[i]] = m[i] || '';
    if (b != -1 && e != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
        uri.ipv6uri = true;
    }
    uri.pathNames = $f603c1892ffe9e8b$var$pathNames(uri, uri['path']);
    uri.queryKey = $f603c1892ffe9e8b$var$queryKey(uri, uri['query']);
    return uri;
}
function $f603c1892ffe9e8b$var$pathNames(obj, path) {
    const regx = /\/{2,9}/g, names = path.replace(regx, "/").split("/");
    if (path.slice(0, 1) == '/' || path.length === 0) names.splice(0, 1);
    if (path.slice(-1) == '/') names.splice(names.length - 1, 1);
    return names;
}
function $f603c1892ffe9e8b$var$queryKey(uri, query) {
    const data = {};
    query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function($0, $1, $2) {
        if ($1) data[$1] = $2;
    });
    return data;
}

});


parcelRegister("i3KZp", function(module, exports) {

var $7pvuz = parcelRequire("7pvuz");
class $d25cf4f3df002b9c$export$1e7deca84b429035 extends (0, $7pvuz.Polling) {
    doPoll() {
        this._fetch().then((res)=>{
            if (!res.ok) return this.onError("fetch read error", res.status, res);
            res.text().then((data)=>this.onData(data));
        }).catch((err)=>{
            this.onError("fetch read error", err);
        });
    }
    doWrite(data, callback) {
        this._fetch(data).then((res)=>{
            if (!res.ok) return this.onError("fetch write error", res.status, res);
            callback();
        }).catch((err)=>{
            this.onError("fetch write error", err);
        });
    }
    _fetch(data) {
        var _a;
        const isPost = data !== undefined;
        const headers = new Headers(this.opts.extraHeaders);
        if (isPost) headers.set("content-type", "text/plain;charset=UTF-8");
        (_a = this.socket._cookieJar) === null || _a === void 0 || _a.appendCookies(headers);
        return fetch(this.uri(), {
            method: isPost ? "POST" : "GET",
            body: isPost ? data : null,
            headers: headers,
            credentials: this.opts.withCredentials ? "include" : "omit"
        }).then((res)=>{
            var _a;
            // @ts-ignore getSetCookie() was added in Node.js v19.7.0
            (_a = this.socket._cookieJar) === null || _a === void 0 || _a.parseCookies(res.headers.getSetCookie());
            return res;
        });
    }
}

});



parcelRegister("fL4YY", function(module, exports) {

$parcel$export(module.exports, "Manager", () => $b78f1c3cb524f77d$export$d0d38e7dec7a1a61);
parcelRequire("1XKMK");
var $5vwdc = parcelRequire("5vwdc");
var $bN72v = parcelRequire("bN72v");
var $al9N3 = parcelRequire("al9N3");

var $lGX0c = parcelRequire("lGX0c");

var $2BjQv = parcelRequire("2BjQv");

var $vPX8d = parcelRequire("vPX8d");

var $5pEXn = parcelRequire("5pEXn");

var $5hHAH = parcelRequire("5hHAH");
class $b78f1c3cb524f77d$export$d0d38e7dec7a1a61 extends (0, $5hHAH.Emitter) {
    constructor(uri, opts){
        var _a;
        super();
        this.nsps = {};
        this.subs = [];
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = undefined;
        }
        opts = opts || {};
        opts.path = opts.path || "/socket.io";
        this.opts = opts;
        (0, $5vwdc.installTimerFunctions)(this, opts);
        this.reconnection(opts.reconnection !== false);
        this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
        this.reconnectionDelay(opts.reconnectionDelay || 1000);
        this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
        this.randomizationFactor((_a = opts.randomizationFactor) !== null && _a !== void 0 ? _a : 0.5);
        this.backoff = new (0, $5pEXn.Backoff)({
            min: this.reconnectionDelay(),
            max: this.reconnectionDelayMax(),
            jitter: this.randomizationFactor()
        });
        this.timeout(null == opts.timeout ? 20000 : opts.timeout);
        this._readyState = "closed";
        this.uri = uri;
        const _parser = opts.parser || $2BjQv;
        this.encoder = new _parser.Encoder();
        this.decoder = new _parser.Decoder();
        this._autoConnect = opts.autoConnect !== false;
        if (this._autoConnect) this.open();
    }
    reconnection(v) {
        if (!arguments.length) return this._reconnection;
        this._reconnection = !!v;
        if (!v) this.skipReconnect = true;
        return this;
    }
    reconnectionAttempts(v) {
        if (v === undefined) return this._reconnectionAttempts;
        this._reconnectionAttempts = v;
        return this;
    }
    reconnectionDelay(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelay;
        this._reconnectionDelay = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMin(v);
        return this;
    }
    randomizationFactor(v) {
        var _a;
        if (v === undefined) return this._randomizationFactor;
        this._randomizationFactor = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setJitter(v);
        return this;
    }
    reconnectionDelayMax(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelayMax;
        this._reconnectionDelayMax = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMax(v);
        return this;
    }
    timeout(v) {
        if (!arguments.length) return this._timeout;
        this._timeout = v;
        return this;
    }
    /**
     * Starts trying to reconnect if reconnection is enabled and we have not
     * started reconnecting yet
     *
     * @private
     */ maybeReconnectOnOpen() {
        // Only try to reconnect if it's the first time we're connecting
        if (!this._reconnecting && this._reconnection && this.backoff.attempts === 0) // keeps reconnection from firing twice for the same reconnection loop
        this.reconnect();
    }
    /**
     * Sets the current transport `socket`.
     *
     * @param {Function} fn - optional, callback
     * @return self
     * @public
     */ open(fn) {
        if (~this._readyState.indexOf("open")) return this;
        this.engine = new (0, $al9N3.Socket)(this.uri, this.opts);
        const socket = this.engine;
        const self = this;
        this._readyState = "opening";
        this.skipReconnect = false;
        // emit `open`
        const openSubDestroy = (0, $vPX8d.on)(socket, "open", function() {
            self.onopen();
            fn && fn();
        });
        const onError = (err)=>{
            this.cleanup();
            this._readyState = "closed";
            this.emitReserved("error", err);
            if (fn) fn(err);
            else // Only do this if there is no fn to handle the error
            this.maybeReconnectOnOpen();
        };
        // emit `error`
        const errorSub = (0, $vPX8d.on)(socket, "error", onError);
        if (false !== this._timeout) {
            const timeout = this._timeout;
            // set timer
            const timer = this.setTimeoutFn(()=>{
                openSubDestroy();
                onError(new Error("timeout"));
                socket.close();
            }, timeout);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
        this.subs.push(openSubDestroy);
        this.subs.push(errorSub);
        return this;
    }
    /**
     * Alias for open()
     *
     * @return self
     * @public
     */ connect(fn) {
        return this.open(fn);
    }
    /**
     * Called upon transport open.
     *
     * @private
     */ onopen() {
        // clear old subs
        this.cleanup();
        // mark as open
        this._readyState = "open";
        this.emitReserved("open");
        // add new subs
        const socket = this.engine;
        this.subs.push((0, $vPX8d.on)(socket, "ping", this.onping.bind(this)), (0, $vPX8d.on)(socket, "data", this.ondata.bind(this)), (0, $vPX8d.on)(socket, "error", this.onerror.bind(this)), (0, $vPX8d.on)(socket, "close", this.onclose.bind(this)), // @ts-ignore
        (0, $vPX8d.on)(this.decoder, "decoded", this.ondecoded.bind(this)));
    }
    /**
     * Called upon a ping.
     *
     * @private
     */ onping() {
        this.emitReserved("ping");
    }
    /**
     * Called with data.
     *
     * @private
     */ ondata(data) {
        try {
            this.decoder.add(data);
        } catch (e) {
            this.onclose("parse error", e);
        }
    }
    /**
     * Called when parser fully decodes a packet.
     *
     * @private
     */ ondecoded(packet) {
        // the nextTick call prevents an exception in a user-provided event listener from triggering a disconnection due to a "parse error"
        (0, $bN72v.nextTick)(()=>{
            this.emitReserved("packet", packet);
        }, this.setTimeoutFn);
    }
    /**
     * Called upon socket error.
     *
     * @private
     */ onerror(err) {
        this.emitReserved("error", err);
    }
    /**
     * Creates a new socket for the given `nsp`.
     *
     * @return {Socket}
     * @public
     */ socket(nsp, opts) {
        let socket = this.nsps[nsp];
        if (!socket) {
            socket = new (0, $lGX0c.Socket)(this, nsp, opts);
            this.nsps[nsp] = socket;
        } else if (this._autoConnect && !socket.active) socket.connect();
        return socket;
    }
    /**
     * Called upon a socket close.
     *
     * @param socket
     * @private
     */ _destroy(socket) {
        const nsps = Object.keys(this.nsps);
        for (const nsp of nsps){
            const socket = this.nsps[nsp];
            if (socket.active) return;
        }
        this._close();
    }
    /**
     * Writes a packet.
     *
     * @param packet
     * @private
     */ _packet(packet) {
        const encodedPackets = this.encoder.encode(packet);
        for(let i = 0; i < encodedPackets.length; i++)this.engine.write(encodedPackets[i], packet.options);
    }
    /**
     * Clean up transport subscriptions and packet buffer.
     *
     * @private
     */ cleanup() {
        this.subs.forEach((subDestroy)=>subDestroy());
        this.subs.length = 0;
        this.decoder.destroy();
    }
    /**
     * Close the current socket.
     *
     * @private
     */ _close() {
        this.skipReconnect = true;
        this._reconnecting = false;
        this.onclose("forced close");
    }
    /**
     * Alias for close()
     *
     * @private
     */ disconnect() {
        return this._close();
    }
    /**
     * Called when:
     *
     * - the low-level engine is closed
     * - the parser encountered a badly formatted packet
     * - all sockets are disconnected
     *
     * @private
     */ onclose(reason, description) {
        var _a;
        this.cleanup();
        (_a = this.engine) === null || _a === void 0 || _a.close();
        this.backoff.reset();
        this._readyState = "closed";
        this.emitReserved("close", reason, description);
        if (this._reconnection && !this.skipReconnect) this.reconnect();
    }
    /**
     * Attempt a reconnection.
     *
     * @private
     */ reconnect() {
        if (this._reconnecting || this.skipReconnect) return this;
        const self = this;
        if (this.backoff.attempts >= this._reconnectionAttempts) {
            this.backoff.reset();
            this.emitReserved("reconnect_failed");
            this._reconnecting = false;
        } else {
            const delay = this.backoff.duration();
            this._reconnecting = true;
            const timer = this.setTimeoutFn(()=>{
                if (self.skipReconnect) return;
                this.emitReserved("reconnect_attempt", self.backoff.attempts);
                // check again for the case socket closed in above events
                if (self.skipReconnect) return;
                self.open((err)=>{
                    if (err) {
                        self._reconnecting = false;
                        self.reconnect();
                        this.emitReserved("reconnect_error", err);
                    } else self.onreconnect();
                });
            }, delay);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
    }
    /**
     * Called upon successful reconnect.
     *
     * @private
     */ onreconnect() {
        const attempt = this.backoff.attempts;
        this._reconnecting = false;
        this.backoff.reset();
        this.emitReserved("reconnect", attempt);
    }
}

});
parcelRegister("lGX0c", function(module, exports) {

$parcel$export(module.exports, "Socket", () => $fcab49da21a6222a$export$4798917dbf149b79);

var $2BjQv = parcelRequire("2BjQv");

var $vPX8d = parcelRequire("vPX8d");

var $5hHAH = parcelRequire("5hHAH");
/**
 * Internal events.
 * These events can't be emitted by the user.
 */ const $fcab49da21a6222a$var$RESERVED_EVENTS = Object.freeze({
    connect: 1,
    connect_error: 1,
    disconnect: 1,
    disconnecting: 1,
    // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
    newListener: 1,
    removeListener: 1
});
class $fcab49da21a6222a$export$4798917dbf149b79 extends (0, $5hHAH.Emitter) {
    /**
     * `Socket` constructor.
     */ constructor(io, nsp, opts){
        super();
        /**
         * Whether the socket is currently connected to the server.
         *
         * @example
         * const socket = io();
         *
         * socket.on("connect", () => {
         *   console.log(socket.connected); // true
         * });
         *
         * socket.on("disconnect", () => {
         *   console.log(socket.connected); // false
         * });
         */ this.connected = false;
        /**
         * Whether the connection state was recovered after a temporary disconnection. In that case, any missed packets will
         * be transmitted by the server.
         */ this.recovered = false;
        /**
         * Buffer for packets received before the CONNECT packet
         */ this.receiveBuffer = [];
        /**
         * Buffer for packets that will be sent once the socket is connected
         */ this.sendBuffer = [];
        /**
         * The queue of packets to be sent with retry in case of failure.
         *
         * Packets are sent one by one, each waiting for the server acknowledgement, in order to guarantee the delivery order.
         * @private
         */ this._queue = [];
        /**
         * A sequence to generate the ID of the {@link QueuedPacket}.
         * @private
         */ this._queueSeq = 0;
        this.ids = 0;
        /**
         * A map containing acknowledgement handlers.
         *
         * The `withError` attribute is used to differentiate handlers that accept an error as first argument:
         *
         * - `socket.emit("test", (err, value) => { ... })` with `ackTimeout` option
         * - `socket.timeout(5000).emit("test", (err, value) => { ... })`
         * - `const value = await socket.emitWithAck("test")`
         *
         * From those that don't:
         *
         * - `socket.emit("test", (value) => { ... });`
         *
         * In the first case, the handlers will be called with an error when:
         *
         * - the timeout is reached
         * - the socket gets disconnected
         *
         * In the second case, the handlers will be simply discarded upon disconnection, since the client will never receive
         * an acknowledgement from the server.
         *
         * @private
         */ this.acks = {};
        this.flags = {};
        this.io = io;
        this.nsp = nsp;
        if (opts && opts.auth) this.auth = opts.auth;
        this._opts = Object.assign({}, opts);
        if (this.io._autoConnect) this.open();
    }
    /**
     * Whether the socket is currently disconnected
     *
     * @example
     * const socket = io();
     *
     * socket.on("connect", () => {
     *   console.log(socket.disconnected); // false
     * });
     *
     * socket.on("disconnect", () => {
     *   console.log(socket.disconnected); // true
     * });
     */ get disconnected() {
        return !this.connected;
    }
    /**
     * Subscribe to open, close and packet events
     *
     * @private
     */ subEvents() {
        if (this.subs) return;
        const io = this.io;
        this.subs = [
            (0, $vPX8d.on)(io, "open", this.onopen.bind(this)),
            (0, $vPX8d.on)(io, "packet", this.onpacket.bind(this)),
            (0, $vPX8d.on)(io, "error", this.onerror.bind(this)),
            (0, $vPX8d.on)(io, "close", this.onclose.bind(this))
        ];
    }
    /**
     * Whether the Socket will try to reconnect when its Manager connects or reconnects.
     *
     * @example
     * const socket = io();
     *
     * console.log(socket.active); // true
     *
     * socket.on("disconnect", (reason) => {
     *   if (reason === "io server disconnect") {
     *     // the disconnection was initiated by the server, you need to manually reconnect
     *     console.log(socket.active); // false
     *   }
     *   // else the socket will automatically try to reconnect
     *   console.log(socket.active); // true
     * });
     */ get active() {
        return !!this.subs;
    }
    /**
     * "Opens" the socket.
     *
     * @example
     * const socket = io({
     *   autoConnect: false
     * });
     *
     * socket.connect();
     */ connect() {
        if (this.connected) return this;
        this.subEvents();
        if (!this.io["_reconnecting"]) this.io.open(); // ensure open
        if ("open" === this.io._readyState) this.onopen();
        return this;
    }
    /**
     * Alias for {@link connect()}.
     */ open() {
        return this.connect();
    }
    /**
     * Sends a `message` event.
     *
     * This method mimics the WebSocket.send() method.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send
     *
     * @example
     * socket.send("hello");
     *
     * // this is equivalent to
     * socket.emit("message", "hello");
     *
     * @return self
     */ send(...args) {
        args.unshift("message");
        this.emit.apply(this, args);
        return this;
    }
    /**
     * Override `emit`.
     * If the event is in `events`, it's emitted normally.
     *
     * @example
     * socket.emit("hello", "world");
     *
     * // all serializable datastructures are supported (no need to call JSON.stringify)
     * socket.emit("hello", 1, "2", { 3: ["4"], 5: Uint8Array.from([6]) });
     *
     * // with an acknowledgement from the server
     * socket.emit("hello", "world", (val) => {
     *   // ...
     * });
     *
     * @return self
     */ emit(ev, ...args) {
        var _a, _b, _c;
        if ($fcab49da21a6222a$var$RESERVED_EVENTS.hasOwnProperty(ev)) throw new Error('"' + ev.toString() + '" is a reserved event name');
        args.unshift(ev);
        if (this._opts.retries && !this.flags.fromQueue && !this.flags.volatile) {
            this._addToQueue(args);
            return this;
        }
        const packet = {
            type: (0, $2BjQv.PacketType).EVENT,
            data: args
        };
        packet.options = {};
        packet.options.compress = this.flags.compress !== false;
        // event ack callback
        if ("function" === typeof args[args.length - 1]) {
            const id = this.ids++;
            const ack = args.pop();
            this._registerAckCallback(id, ack);
            packet.id = id;
        }
        const isTransportWritable = (_b = (_a = this.io.engine) === null || _a === void 0 ? void 0 : _a.transport) === null || _b === void 0 ? void 0 : _b.writable;
        const isConnected = this.connected && !((_c = this.io.engine) === null || _c === void 0 ? void 0 : _c._hasPingExpired());
        const discardPacket = this.flags.volatile && !isTransportWritable;
        if (discardPacket) ;
        else if (isConnected) {
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        } else this.sendBuffer.push(packet);
        this.flags = {};
        return this;
    }
    /**
     * @private
     */ _registerAckCallback(id, ack) {
        var _a;
        const timeout = (_a = this.flags.timeout) !== null && _a !== void 0 ? _a : this._opts.ackTimeout;
        if (timeout === undefined) {
            this.acks[id] = ack;
            return;
        }
        // @ts-ignore
        const timer = this.io.setTimeoutFn(()=>{
            delete this.acks[id];
            for(let i = 0; i < this.sendBuffer.length; i++)if (this.sendBuffer[i].id === id) this.sendBuffer.splice(i, 1);
            ack.call(this, new Error("operation has timed out"));
        }, timeout);
        const fn = (...args)=>{
            // @ts-ignore
            this.io.clearTimeoutFn(timer);
            ack.apply(this, args);
        };
        fn.withError = true;
        this.acks[id] = fn;
    }
    /**
     * Emits an event and waits for an acknowledgement
     *
     * @example
     * // without timeout
     * const response = await socket.emitWithAck("hello", "world");
     *
     * // with a specific timeout
     * try {
     *   const response = await socket.timeout(1000).emitWithAck("hello", "world");
     * } catch (err) {
     *   // the server did not acknowledge the event in the given delay
     * }
     *
     * @return a Promise that will be fulfilled when the server acknowledges the event
     */ emitWithAck(ev, ...args) {
        return new Promise((resolve, reject)=>{
            const fn = (arg1, arg2)=>{
                return arg1 ? reject(arg1) : resolve(arg2);
            };
            fn.withError = true;
            args.push(fn);
            this.emit(ev, ...args);
        });
    }
    /**
     * Add the packet to the queue.
     * @param args
     * @private
     */ _addToQueue(args) {
        let ack;
        if (typeof args[args.length - 1] === "function") ack = args.pop();
        const packet = {
            id: this._queueSeq++,
            tryCount: 0,
            pending: false,
            args: args,
            flags: Object.assign({
                fromQueue: true
            }, this.flags)
        };
        args.push((err, ...responseArgs)=>{
            this._queue[0];
            const hasError = err !== null;
            if (hasError) {
                if (packet.tryCount > this._opts.retries) {
                    this._queue.shift();
                    if (ack) ack(err);
                }
            } else {
                this._queue.shift();
                if (ack) ack(null, ...responseArgs);
            }
            packet.pending = false;
            return this._drainQueue();
        });
        this._queue.push(packet);
        this._drainQueue();
    }
    /**
     * Send the first packet of the queue, and wait for an acknowledgement from the server.
     * @param force - whether to resend a packet that has not been acknowledged yet
     *
     * @private
     */ _drainQueue(force = false) {
        if (!this.connected || this._queue.length === 0) return;
        const packet = this._queue[0];
        if (packet.pending && !force) return;
        packet.pending = true;
        packet.tryCount++;
        this.flags = packet.flags;
        this.emit.apply(this, packet.args);
    }
    /**
     * Sends a packet.
     *
     * @param packet
     * @private
     */ packet(packet) {
        packet.nsp = this.nsp;
        this.io._packet(packet);
    }
    /**
     * Called upon engine `open`.
     *
     * @private
     */ onopen() {
        if (typeof this.auth == "function") this.auth((data)=>{
            this._sendConnectPacket(data);
        });
        else this._sendConnectPacket(this.auth);
    }
    /**
     * Sends a CONNECT packet to initiate the Socket.IO session.
     *
     * @param data
     * @private
     */ _sendConnectPacket(data) {
        this.packet({
            type: (0, $2BjQv.PacketType).CONNECT,
            data: this._pid ? Object.assign({
                pid: this._pid,
                offset: this._lastOffset
            }, data) : data
        });
    }
    /**
     * Called upon engine or manager `error`.
     *
     * @param err
     * @private
     */ onerror(err) {
        if (!this.connected) this.emitReserved("connect_error", err);
    }
    /**
     * Called upon engine `close`.
     *
     * @param reason
     * @param description
     * @private
     */ onclose(reason, description) {
        this.connected = false;
        delete this.id;
        this.emitReserved("disconnect", reason, description);
        this._clearAcks();
    }
    /**
     * Clears the acknowledgement handlers upon disconnection, since the client will never receive an acknowledgement from
     * the server.
     *
     * @private
     */ _clearAcks() {
        Object.keys(this.acks).forEach((id)=>{
            const isBuffered = this.sendBuffer.some((packet)=>String(packet.id) === id);
            if (!isBuffered) {
                // note: handlers that do not accept an error as first argument are ignored here
                const ack = this.acks[id];
                delete this.acks[id];
                if (ack.withError) ack.call(this, new Error("socket has been disconnected"));
            }
        });
    }
    /**
     * Called with socket packet.
     *
     * @param packet
     * @private
     */ onpacket(packet) {
        const sameNamespace = packet.nsp === this.nsp;
        if (!sameNamespace) return;
        switch(packet.type){
            case (0, $2BjQv.PacketType).CONNECT:
                if (packet.data && packet.data.sid) this.onconnect(packet.data.sid, packet.data.pid);
                else this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
                break;
            case (0, $2BjQv.PacketType).EVENT:
            case (0, $2BjQv.PacketType).BINARY_EVENT:
                this.onevent(packet);
                break;
            case (0, $2BjQv.PacketType).ACK:
            case (0, $2BjQv.PacketType).BINARY_ACK:
                this.onack(packet);
                break;
            case (0, $2BjQv.PacketType).DISCONNECT:
                this.ondisconnect();
                break;
            case (0, $2BjQv.PacketType).CONNECT_ERROR:
                this.destroy();
                const err = new Error(packet.data.message);
                // @ts-ignore
                err.data = packet.data.data;
                this.emitReserved("connect_error", err);
                break;
        }
    }
    /**
     * Called upon a server event.
     *
     * @param packet
     * @private
     */ onevent(packet) {
        const args = packet.data || [];
        if (null != packet.id) args.push(this.ack(packet.id));
        if (this.connected) this.emitEvent(args);
        else this.receiveBuffer.push(Object.freeze(args));
    }
    emitEvent(args) {
        if (this._anyListeners && this._anyListeners.length) {
            const listeners = this._anyListeners.slice();
            for (const listener of listeners)listener.apply(this, args);
        }
        super.emit.apply(this, args);
        if (this._pid && args.length && typeof args[args.length - 1] === "string") this._lastOffset = args[args.length - 1];
    }
    /**
     * Produces an ack callback to emit with an event.
     *
     * @private
     */ ack(id) {
        const self = this;
        let sent = false;
        return function(...args) {
            // prevent double callbacks
            if (sent) return;
            sent = true;
            self.packet({
                type: (0, $2BjQv.PacketType).ACK,
                id: id,
                data: args
            });
        };
    }
    /**
     * Called upon a server acknowledgement.
     *
     * @param packet
     * @private
     */ onack(packet) {
        const ack = this.acks[packet.id];
        if (typeof ack !== "function") return;
        delete this.acks[packet.id];
        // @ts-ignore FIXME ack is incorrectly inferred as 'never'
        if (ack.withError) packet.data.unshift(null);
        // @ts-ignore
        ack.apply(this, packet.data);
    }
    /**
     * Called upon server connect.
     *
     * @private
     */ onconnect(id, pid) {
        this.id = id;
        this.recovered = pid && this._pid === pid;
        this._pid = pid; // defined only if connection state recovery is enabled
        this.connected = true;
        this.emitBuffered();
        this._drainQueue(true);
        this.emitReserved("connect");
    }
    /**
     * Emit buffered events (received and emitted).
     *
     * @private
     */ emitBuffered() {
        this.receiveBuffer.forEach((args)=>this.emitEvent(args));
        this.receiveBuffer = [];
        this.sendBuffer.forEach((packet)=>{
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        });
        this.sendBuffer = [];
    }
    /**
     * Called upon server disconnect.
     *
     * @private
     */ ondisconnect() {
        this.destroy();
        this.onclose("io server disconnect");
    }
    /**
     * Called upon forced client/server side disconnections,
     * this method ensures the manager stops tracking us and
     * that reconnections don't get triggered for this.
     *
     * @private
     */ destroy() {
        if (this.subs) {
            // clean subscriptions to avoid reconnections
            this.subs.forEach((subDestroy)=>subDestroy());
            this.subs = undefined;
        }
        this.io["_destroy"](this);
    }
    /**
     * Disconnects the socket manually. In that case, the socket will not try to reconnect.
     *
     * If this is the last active Socket instance of the {@link Manager}, the low-level connection will be closed.
     *
     * @example
     * const socket = io();
     *
     * socket.on("disconnect", (reason) => {
     *   // console.log(reason); prints "io client disconnect"
     * });
     *
     * socket.disconnect();
     *
     * @return self
     */ disconnect() {
        if (this.connected) this.packet({
            type: (0, $2BjQv.PacketType).DISCONNECT
        });
        // remove socket from pool
        this.destroy();
        if (this.connected) // fire events
        this.onclose("io client disconnect");
        return this;
    }
    /**
     * Alias for {@link disconnect()}.
     *
     * @return self
     */ close() {
        return this.disconnect();
    }
    /**
     * Sets the compress flag.
     *
     * @example
     * socket.compress(false).emit("hello");
     *
     * @param compress - if `true`, compresses the sending data
     * @return self
     */ compress(compress) {
        this.flags.compress = compress;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
     * ready to send messages.
     *
     * @example
     * socket.volatile.emit("hello"); // the server may or may not receive it
     *
     * @returns self
     */ get volatile() {
        this.flags.volatile = true;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
     * given number of milliseconds have elapsed without an acknowledgement from the server:
     *
     * @example
     * socket.timeout(5000).emit("my-event", (err) => {
     *   if (err) {
     *     // the server did not acknowledge the event in the given delay
     *   }
     * });
     *
     * @returns self
     */ timeout(timeout) {
        this.flags.timeout = timeout;
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * @example
     * socket.onAny((event, ...args) => {
     *   console.log(`got ${event}`);
     * });
     *
     * @param listener
     */ onAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * @example
     * socket.prependAny((event, ...args) => {
     *   console.log(`got event ${event}`);
     * });
     *
     * @param listener
     */ prependAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`got event ${event}`);
     * }
     *
     * socket.onAny(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAny(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAny();
     *
     * @param listener
     */ offAny(listener) {
        if (!this._anyListeners) return this;
        if (listener) {
            const listeners = this._anyListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAny() {
        return this._anyListeners || [];
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.onAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ onAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.prependAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ prependAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`sent event ${event}`);
     * }
     *
     * socket.onAnyOutgoing(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAnyOutgoing(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAnyOutgoing();
     *
     * @param [listener] - the catch-all listener (optional)
     */ offAnyOutgoing(listener) {
        if (!this._anyOutgoingListeners) return this;
        if (listener) {
            const listeners = this._anyOutgoingListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyOutgoingListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAnyOutgoing() {
        return this._anyOutgoingListeners || [];
    }
    /**
     * Notify the listeners for each packet sent
     *
     * @param packet
     *
     * @private
     */ notifyOutgoingListeners(packet) {
        if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
            const listeners = this._anyOutgoingListeners.slice();
            for (const listener of listeners)listener.apply(this, packet.data);
        }
    }
}

});
parcelRegister("2BjQv", function(module, exports) {

$parcel$export(module.exports, "protocol", () => $1e4e6e6cc3958162$export$a51d6b395ff4c65a);
$parcel$export(module.exports, "PacketType", () => $1e4e6e6cc3958162$export$84d4095e16c6fc19);
$parcel$export(module.exports, "Encoder", () => $1e4e6e6cc3958162$export$a50aceb0e02a00aa);
$parcel$export(module.exports, "Decoder", () => $1e4e6e6cc3958162$export$f9de6ca0bc043724);
$parcel$export(module.exports, "isPacketValid", () => $1e4e6e6cc3958162$export$1a38ed17dcb5458e);

var $5hHAH = parcelRequire("5hHAH");

var $8URBv = parcelRequire("8URBv");

var $eGKCF = parcelRequire("eGKCF");
/**
 * These strings must not be used as event names, as they have a special meaning.
 */ const $1e4e6e6cc3958162$var$RESERVED_EVENTS = [
    "connect",
    "connect_error",
    "disconnect",
    "disconnecting",
    "newListener",
    "removeListener"
];
const $1e4e6e6cc3958162$export$a51d6b395ff4c65a = 5;
var $1e4e6e6cc3958162$export$84d4095e16c6fc19;
(function(PacketType) {
    PacketType[PacketType["CONNECT"] = 0] = "CONNECT";
    PacketType[PacketType["DISCONNECT"] = 1] = "DISCONNECT";
    PacketType[PacketType["EVENT"] = 2] = "EVENT";
    PacketType[PacketType["ACK"] = 3] = "ACK";
    PacketType[PacketType["CONNECT_ERROR"] = 4] = "CONNECT_ERROR";
    PacketType[PacketType["BINARY_EVENT"] = 5] = "BINARY_EVENT";
    PacketType[PacketType["BINARY_ACK"] = 6] = "BINARY_ACK";
})($1e4e6e6cc3958162$export$84d4095e16c6fc19 || ($1e4e6e6cc3958162$export$84d4095e16c6fc19 = {}));
class $1e4e6e6cc3958162$export$a50aceb0e02a00aa {
    /**
     * Encoder constructor
     *
     * @param {function} replacer - custom replacer to pass down to JSON.parse
     */ constructor(replacer){
        this.replacer = replacer;
    }
    /**
     * Encode a packet as a single string if non-binary, or as a
     * buffer sequence, depending on packet type.
     *
     * @param {Object} obj - packet object
     */ encode(obj) {
        if (obj.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.EVENT || obj.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.ACK) {
            if ((0, $eGKCF.hasBinary)(obj)) return this.encodeAsBinary({
                type: obj.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.EVENT ? $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_EVENT : $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_ACK,
                nsp: obj.nsp,
                data: obj.data,
                id: obj.id
            });
        }
        return [
            this.encodeAsString(obj)
        ];
    }
    /**
     * Encode packet as string.
     */ encodeAsString(obj) {
        // first is type
        let str = "" + obj.type;
        // attachments if we have them
        if (obj.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_EVENT || obj.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_ACK) str += obj.attachments + "-";
        // if we have a namespace other than `/`
        // we append it followed by a comma `,`
        if (obj.nsp && "/" !== obj.nsp) str += obj.nsp + ",";
        // immediately followed by the id
        if (null != obj.id) str += obj.id;
        // json data
        if (null != obj.data) str += JSON.stringify(obj.data, this.replacer);
        return str;
    }
    /**
     * Encode packet as 'buffer sequence' by removing blobs, and
     * deconstructing packet into object with placeholders and
     * a list of buffers.
     */ encodeAsBinary(obj) {
        const deconstruction = (0, $8URBv.deconstructPacket)(obj);
        const pack = this.encodeAsString(deconstruction.packet);
        const buffers = deconstruction.buffers;
        buffers.unshift(pack); // add packet info to beginning of data list
        return buffers; // write all the buffers
    }
}
class $1e4e6e6cc3958162$export$f9de6ca0bc043724 extends (0, $5hHAH.Emitter) {
    /**
     * Decoder constructor
     *
     * @param {function} reviver - custom reviver to pass down to JSON.stringify
     */ constructor(reviver){
        super();
        this.reviver = reviver;
    }
    /**
     * Decodes an encoded packet string into packet JSON.
     *
     * @param {String} obj - encoded packet
     */ add(obj) {
        let packet;
        if (typeof obj === "string") {
            if (this.reconstructor) throw new Error("got plaintext data when reconstructing a packet");
            packet = this.decodeString(obj);
            const isBinaryEvent = packet.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_EVENT;
            if (isBinaryEvent || packet.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_ACK) {
                packet.type = isBinaryEvent ? $1e4e6e6cc3958162$export$84d4095e16c6fc19.EVENT : $1e4e6e6cc3958162$export$84d4095e16c6fc19.ACK;
                // binary packet's json
                this.reconstructor = new $1e4e6e6cc3958162$var$BinaryReconstructor(packet);
                // no attachments, labeled binary but no binary data to follow
                if (packet.attachments === 0) super.emitReserved("decoded", packet);
            } else // non-binary full packet
            super.emitReserved("decoded", packet);
        } else if ((0, $eGKCF.isBinary)(obj) || obj.base64) {
            // raw binary data
            if (!this.reconstructor) throw new Error("got binary data when not reconstructing a packet");
            else {
                packet = this.reconstructor.takeBinaryData(obj);
                if (packet) {
                    // received final buffer
                    this.reconstructor = null;
                    super.emitReserved("decoded", packet);
                }
            }
        } else throw new Error("Unknown type: " + obj);
    }
    /**
     * Decode a packet String (JSON data)
     *
     * @param {String} str
     * @return {Object} packet
     */ decodeString(str) {
        let i = 0;
        // look up type
        const p = {
            type: Number(str.charAt(0))
        };
        if ($1e4e6e6cc3958162$export$84d4095e16c6fc19[p.type] === undefined) throw new Error("unknown packet type " + p.type);
        // look up attachments if type binary
        if (p.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_EVENT || p.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_ACK) {
            const start = i + 1;
            while(str.charAt(++i) !== "-" && i != str.length);
            const buf = str.substring(start, i);
            if (buf != Number(buf) || str.charAt(i) !== "-") throw new Error("Illegal attachments");
            p.attachments = Number(buf);
        }
        // look up namespace (if any)
        if ("/" === str.charAt(i + 1)) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if ("," === c) break;
                if (i === str.length) break;
            }
            p.nsp = str.substring(start, i);
        } else p.nsp = "/";
        // look up id
        const next = str.charAt(i + 1);
        if ("" !== next && Number(next) == next) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if (null == c || Number(c) != c) {
                    --i;
                    break;
                }
                if (i === str.length) break;
            }
            p.id = Number(str.substring(start, i + 1));
        }
        // look up json data
        if (str.charAt(++i)) {
            const payload = this.tryParse(str.substr(i));
            if ($1e4e6e6cc3958162$export$f9de6ca0bc043724.isPayloadValid(p.type, payload)) p.data = payload;
            else throw new Error("invalid payload");
        }
        return p;
    }
    tryParse(str) {
        try {
            return JSON.parse(str, this.reviver);
        } catch (e) {
            return false;
        }
    }
    static isPayloadValid(type, payload) {
        switch(type){
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.CONNECT:
                return $1e4e6e6cc3958162$var$isObject(payload);
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.DISCONNECT:
                return payload === undefined;
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.CONNECT_ERROR:
                return typeof payload === "string" || $1e4e6e6cc3958162$var$isObject(payload);
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.EVENT:
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_EVENT:
                return Array.isArray(payload) && (typeof payload[0] === "number" || typeof payload[0] === "string" && $1e4e6e6cc3958162$var$RESERVED_EVENTS.indexOf(payload[0]) === -1);
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.ACK:
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_ACK:
                return Array.isArray(payload);
        }
    }
    /**
     * Deallocates a parser's resources
     */ destroy() {
        if (this.reconstructor) {
            this.reconstructor.finishedReconstruction();
            this.reconstructor = null;
        }
    }
}
/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 */ class $1e4e6e6cc3958162$var$BinaryReconstructor {
    constructor(packet){
        this.packet = packet;
        this.buffers = [];
        this.reconPack = packet;
    }
    /**
     * Method to be called when binary data received from connection
     * after a BINARY_EVENT packet.
     *
     * @param {Buffer | ArrayBuffer} binData - the raw binary data received
     * @return {null | Object} returns null if more binary data is expected or
     *   a reconstructed packet object if all buffers have been received.
     */ takeBinaryData(binData) {
        this.buffers.push(binData);
        if (this.buffers.length === this.reconPack.attachments) {
            // done with buffer list
            const packet = (0, $8URBv.reconstructPacket)(this.reconPack, this.buffers);
            this.finishedReconstruction();
            return packet;
        }
        return null;
    }
    /**
     * Cleans up binary packet reconstruction variables.
     */ finishedReconstruction() {
        this.reconPack = null;
        this.buffers = [];
    }
}
function $1e4e6e6cc3958162$var$isNamespaceValid(nsp) {
    return typeof nsp === "string";
}
// see https://caniuse.com/mdn-javascript_builtins_number_isinteger
const $1e4e6e6cc3958162$var$isInteger = Number.isInteger || function(value) {
    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
};
function $1e4e6e6cc3958162$var$isAckIdValid(id) {
    return id === undefined || $1e4e6e6cc3958162$var$isInteger(id);
}
// see https://stackoverflow.com/questions/8511281/check-if-a-value-is-an-object-in-javascript
function $1e4e6e6cc3958162$var$isObject(value) {
    return Object.prototype.toString.call(value) === "[object Object]";
}
function $1e4e6e6cc3958162$var$isDataValid(type, payload) {
    switch(type){
        case $1e4e6e6cc3958162$export$84d4095e16c6fc19.CONNECT:
            return payload === undefined || $1e4e6e6cc3958162$var$isObject(payload);
        case $1e4e6e6cc3958162$export$84d4095e16c6fc19.DISCONNECT:
            return payload === undefined;
        case $1e4e6e6cc3958162$export$84d4095e16c6fc19.EVENT:
            return Array.isArray(payload) && (typeof payload[0] === "number" || typeof payload[0] === "string" && $1e4e6e6cc3958162$var$RESERVED_EVENTS.indexOf(payload[0]) === -1);
        case $1e4e6e6cc3958162$export$84d4095e16c6fc19.ACK:
            return Array.isArray(payload);
        case $1e4e6e6cc3958162$export$84d4095e16c6fc19.CONNECT_ERROR:
            return typeof payload === "string" || $1e4e6e6cc3958162$var$isObject(payload);
        default:
            return false;
    }
}
function $1e4e6e6cc3958162$export$1a38ed17dcb5458e(packet) {
    return $1e4e6e6cc3958162$var$isNamespaceValid(packet.nsp) && $1e4e6e6cc3958162$var$isAckIdValid(packet.id) && $1e4e6e6cc3958162$var$isDataValid(packet.type, packet.data);
}

});
parcelRegister("8URBv", function(module, exports) {

$parcel$export(module.exports, "deconstructPacket", () => $67dd224d5a131c9e$export$ac2edb9eb7af56f6);
$parcel$export(module.exports, "reconstructPacket", () => $67dd224d5a131c9e$export$a00da3b1ec037a04);

var $eGKCF = parcelRequire("eGKCF");
function $67dd224d5a131c9e$export$ac2edb9eb7af56f6(packet) {
    const buffers = [];
    const packetData = packet.data;
    const pack = packet;
    pack.data = $67dd224d5a131c9e$var$_deconstructPacket(packetData, buffers);
    pack.attachments = buffers.length; // number of binary 'attachments'
    return {
        packet: pack,
        buffers: buffers
    };
}
function $67dd224d5a131c9e$var$_deconstructPacket(data, buffers) {
    if (!data) return data;
    if ((0, $eGKCF.isBinary)(data)) {
        const placeholder = {
            _placeholder: true,
            num: buffers.length
        };
        buffers.push(data);
        return placeholder;
    } else if (Array.isArray(data)) {
        const newData = new Array(data.length);
        for(let i = 0; i < data.length; i++)newData[i] = $67dd224d5a131c9e$var$_deconstructPacket(data[i], buffers);
        return newData;
    } else if (typeof data === "object" && !(data instanceof Date)) {
        const newData = {};
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) newData[key] = $67dd224d5a131c9e$var$_deconstructPacket(data[key], buffers);
        return newData;
    }
    return data;
}
function $67dd224d5a131c9e$export$a00da3b1ec037a04(packet, buffers) {
    packet.data = $67dd224d5a131c9e$var$_reconstructPacket(packet.data, buffers);
    delete packet.attachments; // no longer useful
    return packet;
}
function $67dd224d5a131c9e$var$_reconstructPacket(data, buffers) {
    if (!data) return data;
    if (data && data._placeholder === true) {
        const isIndexValid = typeof data.num === "number" && data.num >= 0 && data.num < buffers.length;
        if (isIndexValid) return buffers[data.num]; // appropriate buffer (should be natural order anyway)
        else throw new Error("illegal attachments");
    } else if (Array.isArray(data)) for(let i = 0; i < data.length; i++)data[i] = $67dd224d5a131c9e$var$_reconstructPacket(data[i], buffers);
    else if (typeof data === "object") {
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) data[key] = $67dd224d5a131c9e$var$_reconstructPacket(data[key], buffers);
    }
    return data;
}

});
parcelRegister("eGKCF", function(module, exports) {

$parcel$export(module.exports, "isBinary", () => $ab192732c3780e48$export$37488ff1135b1696);
$parcel$export(module.exports, "hasBinary", () => $ab192732c3780e48$export$5234c529abdb5610);
const $ab192732c3780e48$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $ab192732c3780e48$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj.buffer instanceof ArrayBuffer;
};
const $ab192732c3780e48$var$toString = Object.prototype.toString;
const $ab192732c3780e48$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && $ab192732c3780e48$var$toString.call(Blob) === "[object BlobConstructor]";
const $ab192732c3780e48$var$withNativeFile = typeof File === "function" || typeof File !== "undefined" && $ab192732c3780e48$var$toString.call(File) === "[object FileConstructor]";
function $ab192732c3780e48$export$37488ff1135b1696(obj) {
    return $ab192732c3780e48$var$withNativeArrayBuffer && (obj instanceof ArrayBuffer || $ab192732c3780e48$var$isView(obj)) || $ab192732c3780e48$var$withNativeBlob && obj instanceof Blob || $ab192732c3780e48$var$withNativeFile && obj instanceof File;
}
function $ab192732c3780e48$export$5234c529abdb5610(obj, toJSON) {
    if (!obj || typeof obj !== "object") return false;
    if (Array.isArray(obj)) {
        for(let i = 0, l = obj.length; i < l; i++){
            if ($ab192732c3780e48$export$5234c529abdb5610(obj[i])) return true;
        }
        return false;
    }
    if ($ab192732c3780e48$export$37488ff1135b1696(obj)) return true;
    if (obj.toJSON && typeof obj.toJSON === "function" && arguments.length === 1) return $ab192732c3780e48$export$5234c529abdb5610(obj.toJSON(), true);
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key) && $ab192732c3780e48$export$5234c529abdb5610(obj[key])) return true;
    }
    return false;
}

});



parcelRegister("vPX8d", function(module, exports) {

$parcel$export(module.exports, "on", () => $05fb321879039179$export$af631764ddc44097);
function $05fb321879039179$export$af631764ddc44097(obj, ev, fn) {
    obj.on(ev, fn);
    return function subDestroy() {
        obj.off(ev, fn);
    };
}

});


parcelRegister("5pEXn", function(module, exports) {

$parcel$export(module.exports, "Backoff", () => $3f0f0eae169725b6$export$2d38012449449c89);
/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */ function $3f0f0eae169725b6$export$2d38012449449c89(opts) {
    opts = opts || {};
    this.ms = opts.min || 100;
    this.max = opts.max || 10000;
    this.factor = opts.factor || 2;
    this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
    this.attempts = 0;
}
/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */ $3f0f0eae169725b6$export$2d38012449449c89.prototype.duration = function() {
    var ms = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
        var rand = Math.random();
        var deviation = Math.floor(rand * this.jitter * ms);
        ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
    }
    return Math.min(ms, this.max) | 0;
};
/**
 * Reset the number of attempts.
 *
 * @api public
 */ $3f0f0eae169725b6$export$2d38012449449c89.prototype.reset = function() {
    this.attempts = 0;
};
/**
 * Set the minimum duration
 *
 * @api public
 */ $3f0f0eae169725b6$export$2d38012449449c89.prototype.setMin = function(min) {
    this.ms = min;
};
/**
 * Set the maximum duration
 *
 * @api public
 */ $3f0f0eae169725b6$export$2d38012449449c89.prototype.setMax = function(max) {
    this.max = max;
};
/**
 * Set the jitter
 *
 * @api public
 */ $3f0f0eae169725b6$export$2d38012449449c89.prototype.setJitter = function(jitter) {
    this.jitter = jitter;
};

});



parcelRegister("jr3GA", function(module, exports) {

$parcel$export(module.exports, "connectedToSymbols", () => $e26365dd1fe7f8fa$export$f34bb2007ac88e4d);
$parcel$export(module.exports, "Notifications", () => $e26365dd1fe7f8fa$export$36ba2f559d49a8f6);
'use strict';
// const ANIMATION = {
//   fadeInUp: {
//     from: {
//       transform: 'translate3d(0, 12.5%, 1px)',
//       opacity: 0
//     },
//     to: {
//       transform: 'translate3d(0, 0, 1px)',
//       opacity: 1
//     }
//   },
//   fadeOutDown: {
//     from: {
//       transform: 'translate3d(0, 0, 1px)',
//       opacity: 1
//     },
//     to: {
//       transform: 'translate3d(0, 12.5%, 1px)',
//       opacity: 0
//     }
//   }
// }
// const COLOR = {
//   black: '#000000',
//   blue: '#3686F7'
// }
// set({
//   COLOR,
//   ANIMATION
// })
const $e26365dd1fe7f8fa$var$NOTIF_COLORS = {
    success: 'green',
    error: 'red',
    warning: 'yellow'
};
const $e26365dd1fe7f8fa$export$f34bb2007ac88e4d = (clients, element, state)=>{
    if (clients.symbols) {
        if (!state.connected) {
            state.notifications.connected = {
                title: 'Connected',
                message: 'to the Symbols live server'
            };
            state.update({
                connected: true
            });
            const t = setTimeout(()=>{
                delete state.notifications.connected;
                element.notifications.content.connected.update({
                    animation: 'fadeOutDown'
                });
                state.update({
                    connected: true
                });
                clearTimeout(t);
            }, 3000);
        }
    } else if (state.connected) {
        state.notifications.connected = {
            title: 'Disconnected',
            type: 'error'
        };
        state.update({
            connected: false
        });
        const t = setTimeout(()=>{
            delete state.notifications.connected;
            if (element.notifications.content.connected) element.notifications.content.connected.update({
                animation: 'fadeOutDown'
            });
            state.update({
                connected: true
            });
            clearTimeout(t);
        }, 3000);
    }
};
const $e26365dd1fe7f8fa$export$36ba2f559d49a8f6 = {
    state: {
        notifications: []
    },
    Notifications: {
        position: 'fixed',
        left: 'A2',
        bottom: 'Z2',
        zIndex: '999',
        childExtends: 'Notification',
        childProps: ({ state: state })=>({
                animationDuration: 'C',
                background: $e26365dd1fe7f8fa$var$NOTIF_COLORS[state.type || 'success'],
                icon: null,
                Flex: {
                    Title: {
                        text: '{{ title }}'
                    },
                    P: {
                        text: '{{ title }}'
                    }
                },
                onRender: (e, el, s)=>{
                    el.update({
                        animation: 'fadeInUp'
                    });
                },
                onClick: (e, el, s)=>{
                    delete s.notifications[el.key];
                    el.update({
                        animation: 'fadeOutDown'
                    });
                    if (s.onClose) s.onClose(e, el, s);
                }
            }),
        IconText: null,
        childrenAs: 'state',
        children: ({ state: state })=>state.notifications
    }
};

});

parcelRegister("istPf", function(module, exports) {

$parcel$export(module.exports, "Inspect", () => $d701fa452bb83497$export$d1a121333e17a5bb);

var $dcsWo = parcelRequire("dcsWo");
parcelRequire("2oe0q");
var $fX7ii = parcelRequire("fX7ii");

var $jpDdU = parcelRequire("jpDdU");
'use strict';
function $d701fa452bb83497$var$returnStringExtend(_extends) {
    return (0, $fX7ii.isString)(_extends) ? _extends : (0, $fX7ii.isArray)(_extends) ? _extends.find((extItem)=>(0, $fX7ii.isString)(extItem)) : '';
}
function $d701fa452bb83497$var$getComponentKey(el) {
    if (!el) return;
    const __componentKey = el.__ref.__componentKey;
    const extendsStr = el.extends && $d701fa452bb83497$var$returnStringExtend(el.extends);
    const parentChildExtendStr = el.parent && el.parent.childExtends && $d701fa452bb83497$var$returnStringExtend(el.parent.childExtends);
    return (__componentKey || extendsStr || parentChildExtendStr || '').split('_')[0].split('.')[0].split('+')[0];
}
function $d701fa452bb83497$var$findComponent(el) {
    if (!el || !el.__ref) return;
    const { components: components, pages: pages, editor: editor } = el.context;
    const componentKey = $d701fa452bb83497$var$getComponentKey(el);
    if (editor && editor.onInitInspect) {
        const initInspectReturns = editor.onInitInspect(componentKey, el, el.state);
        if (!initInspectReturns) return $d701fa452bb83497$var$findComponent(el.parent);
    }
    if (componentKey && (components[componentKey] || pages[componentKey])) return el;
    return $d701fa452bb83497$var$findComponent(el.parent);
}
const $d701fa452bb83497$var$onInspect = (app, state, ctx)=>{
    const windowOpts = ctx.window || window;
    windowOpts.onkeydown = (ev)=>{
        if (ev.altKey && ev.shiftKey) app.state.update({
            debugging: true,
            preventSelect: true
        }, {
            preventUpdate: true,
            preventContentUpdate: true,
            preventRecursive: true
        });
    };
    windowOpts.onkeyup = (ev)=>{
        if (app.state.preventSelect && (!ev.altKey || !ev.shiftKey)) {
            app.state.replace({
                debugging: false,
                preventSelect: false
            }, {
                preventUpdate: true,
                preventContentUpdate: true,
                preventRecursive: true
            });
            app.Inspector.state.update({
                area: false
            });
        }
    };
};
const $d701fa452bb83497$export$d1a121333e17a5bb = {
    '.preventSelect': {
        userSelect: 'none'
    },
    '!preventSelect': {
        userSelect: 'auto'
    },
    onInspect: $d701fa452bb83497$var$onInspect,
    onMousemove: (ev, e, state)=>{
        const el = ev.target.ref;
        const component = $d701fa452bb83497$var$findComponent(el);
        const focusState = e.Inspector.state;
        if (!component || !state.debugging || !component.__ref) return focusState.update({
            area: false
        });
        const componentKey = $d701fa452bb83497$var$getComponentKey(component);
        const updateValue = (area)=>{
            focusState.update({
                area: area,
                focusKey: componentKey
            });
        };
        const update = ()=>{
            if (ev.altKey && ev.shiftKey) {
                const { x: x, y: y, width: width, height: height } = component.node.getBoundingClientRect();
                const area = {
                    x: x,
                    y: y,
                    width: width,
                    height: height
                };
                if (!focusState.area) return updateValue(area);
                if (focusState.area.x !== area.x) updateValue(area);
            } else if (focusState.area) focusState.update({
                area: false
            });
        };
        window.requestAnimationFrame(()=>{
            update();
            window.requestAnimationFrame(update);
        });
    },
    onMousedown: (ev, elem, state)=>{
        if (!state.debugging) return;
        const el = ev.target.ref;
        const component = $d701fa452bb83497$var$findComponent(el);
        if (!component) return;
        const componentKey = $d701fa452bb83497$var$getComponentKey(component);
        if (!componentKey) return;
        const editor = el.context.editor;
        if (editor && editor.onInspect) return editor.onInspect(componentKey, el, el.state, {
            allowRouterWhileInspect: true
        });
        const data = JSON.stringify({
            componentKey: `${componentKey}`
        });
        (0, $jpDdU.send).call(el.context.socket, 'route', data);
        ev.preventDefault();
        ev.stopPropagation();
        return false;
    },
    Inspector: {
        state: {},
        transition: 'all, defaultBezier, X',
        position: 'fixed',
        hide: (el, s)=>!(s.area && s.parent.debugging),
        style: {
            boxShadow: '0 0 10px #3686F733, 0 0 0 3px #3686F766, 0 0 100vmax 100vmax #000A',
            zIndex: '9999999',
            borderRadius: '10px',
            pointerEvents: 'none'
        },
        Span: {
            position: 'absolute',
            margin: 'A2 0',
            fontSize: 'Z',
            color: 'text',
            // color: 'blue',
            zIndex: '99999999',
            transition: 'all, defaultBezier, X',
            textDecoration: 'underline',
            fontWeight: '500',
            top: '100%',
            style: {
                boxShadow: '0 25px 10px 35px black',
                textShadow: '0 0 10px black'
            },
            text: '{{ focusKey }}'
        },
        onInit: ({ context: context })=>{
            const { components: components } = context;
            if ((0, $fX7ii.isObject)(components)) {
                const { Content: Content, ...rest } = components;
                for(const key in rest){
                    if ($dcsWo[key]) continue;
                    if (!rest[key].__ref) rest[key].__ref = {};
                    if (!rest[key].__ref.__componentKey) rest[key].__ref.__componentKey = key;
                }
            }
        },
        onBeforeUpdate: (ch, el, s)=>{
            const { area: area } = s;
            const isDebugging = s.area && s.parent.debugging;
            let style;
            if (!isDebugging) style = 'display: none !important';
            else if (area) {
                const { x: x, y: y, width: width, height: height } = area;
                // el.node.style = Object.stringify({
                //   top: y - 6 + 'px',
                //   left: x - 6 + 'px',
                //   width: width + 12 + 'px',
                //   height: height + 12 + 'px'
                // })
                style = `
            display: block !important;
            top: ${y - 6}px;
            left: ${x - 6}px;
            width: ${width + 12}px;
            height: ${height + 12}px;
          `;
            }
            el.node.style = style;
            el.Span.node.innerText = s.focusKey;
            return false;
        }
    }
};

});
parcelRegister("jpDdU", function(module, exports) {

$parcel$export(module.exports, "send", () => send);
parcelRequire("2oe0q");
var $fX7ii = parcelRequire("fX7ii");
var $erBZm = parcelRequire("erBZm");

var $73MNt = parcelRequire("73MNt");
const defautlOpts = {};
let CONNECT_ATTEPT = 0;
const CONNECT_ATTEPT_MAX_ALLOWED = 1;
const getIsDev = (options)=>{
    return options.development || (0, $erBZm.window) && (0, $erBZm.window).location && (0, $erBZm.window).location.host.includes('local') || ENV === 'testing' || ENV === 'development';
};
const getSocketUrl = (options, isDev)=>{
    const SOCKET_BACKEND_URL = isDev ? 'http://localhost:8080/' : 'https://api.symbols.app/';
    const socketUrls = (0, $fX7ii.isArray)(options.socketUrl) ? options.socketUrl : [
        options.socketUrl || SOCKET_BACKEND_URL
    ];
    const primaryUrl = socketUrls[0];
    const secondaryUrl = socketUrls[1] || 'api.symbols.app';
    return {
        primaryUrl: primaryUrl || SOCKET_BACKEND_URL,
        secondaryUrl: secondaryUrl
    };
};
const connect = (key, options = {})=>{
    const isDev = getIsDev(options);
    const { primaryUrl, secondaryUrl } = getSocketUrl(options, isDev);
    const socket = (0, $73MNt.default)(primaryUrl || secondaryUrl, {
    });
    socket.on('connect', ()=>{
        if (isDev) console.warn(`Connected to %c${primaryUrl} %c${key} %c${socket.id}`, 'font-weight: bold; color: green;', 'font-weight: bold;', '');
        socket.emit('initConnect', {
            key: key,
            ...options
        });
        try {
            if ((0, $fX7ii.isFunction)(options.onConnect)) options.onConnect(socket.id, socket);
        } catch (e) {
            console.error(e);
        }
    });
    socket.on('connect_error', (err)=>{
        console.log(`event: connect_error | reason: ${err.message}`);
        try {
            if ((0, $fX7ii.isFunction)(options.onError)) options.onError(err, socket);
            if (CONNECT_ATTEPT < CONNECT_ATTEPT_MAX_ALLOWED) {
                CONNECT_ATTEPT++;
                socket.disconnect();
                if (utils.isNotProduction()) console.log(`Could not connect to %c${primaryUrl}%c, reconnecting to %c${secondaryUrl}`, 'font-weight: bold; color: red;', '', 'font-weight: bold; color: green;');
                connect(key, {
                    ...options,
                    socketUrl: secondaryUrl
                });
            }
        } catch (e) {
            console.error(e);
        }
    });
    socket.on('disconnect', (reason)=>{
        console.log(`event: disconnect | reason: ${reason}`);
        try {
            if ((0, $fX7ii.isFunction)(options.onDisconnect)) options.onDisconnect(reason, socket);
        } catch (e) {
            console.error(e);
        }
    });
    socket.onAny((event, ...args)=>{
        if (event === 'connect') return;
        try {
            if ((0, $fX7ii.isFunction)(options.onChange)) options.onChange(event, args[0], socket);
        } catch (e) {
            console.error(e);
        }
    });
    return socket;
};
function send(event = 'change', changes, options) {
    this.emit(event, changes, {
        ...options,
        ...defautlOpts
    });
}
function disconnect() {
    this.disconnect();
}

});




parcelRegister("k17B8", function(module, exports) {

$parcel$export(module.exports, "prepareWindow", () => $e929cb719afab5dd$export$c3727843bfb8bb3b);
$parcel$export(module.exports, "prepareComponents", () => $e929cb719afab5dd$export$4f2633f1ff10978c);
$parcel$export(module.exports, "prepareUtils", () => $e929cb719afab5dd$export$348dc3ccba7d17b1);
$parcel$export(module.exports, "prepareMethods", () => $e929cb719afab5dd$export$bb03004b651040c);
$parcel$export(module.exports, "prepareDependencies", () => $e929cb719afab5dd$export$c40391394e7726ed);
$parcel$export(module.exports, "prepareRequire", () => $e929cb719afab5dd$export$52302ef84805a6f8);
$parcel$export(module.exports, "prepareDesignSystem", () => $e929cb719afab5dd$export$d54de307475be07a);
$parcel$export(module.exports, "prepareState", () => $e929cb719afab5dd$export$beb986ec1c64324);
$parcel$export(module.exports, "preparePages", () => $e929cb719afab5dd$export$b2f7e94520d001d1);
$parcel$export(module.exports, "prepareSharedLibs", () => $e929cb719afab5dd$export$2068a53156b77a95);
$parcel$export(module.exports, "PACKAGE_MANAGER_TO_CDN", () => (parcelRequire("bbZ29")).PACKAGE_MANAGER_TO_CDN);
parcelRequire("2oe0q");
var $bmfNh = parcelRequire("bmfNh");
var $bbZ29 = parcelRequire("bbZ29");
var $kt4aQ = parcelRequire("kt4aQ");
var $fX7ii = parcelRequire("fX7ii");
var $FzLlj = parcelRequire("FzLlj");
var $bSS0n = parcelRequire("bSS0n");
parcelRequire("2Eo8m");
var $bd7kG = parcelRequire("bd7kG");

var $9Ri24 = parcelRequire("9Ri24");

var $5SInI = parcelRequire("5SInI");
parcelRequire("aTPvW");
var $7KiQp = parcelRequire("7KiQp");

var $F0UG9 = parcelRequire("F0UG9");

var $dcsWo = parcelRequire("dcsWo");

var $egeBc = parcelRequire("egeBc");

var $cAYSb = parcelRequire("cAYSb");
'use strict';
const $e929cb719afab5dd$export$c3727843bfb8bb3b = (context)=>{
    const win = typeof window !== 'undefined' ? window : globalThis || {};
    if (!win.document) win.document = {
        body: {}
    };
    const doc = typeof document !== 'undefined' ? document : win.document;
    context.document = context.document || doc;
    context.window = context.window || win;
    return context.window;
};
const $e929cb719afab5dd$var$UIkitWithPrefix = (prefix = 'smbls')=>{
    const newObj = {};
    for(const key in $dcsWo)if (Object.prototype.hasOwnProperty.call($dcsWo, key)) {
        if ((0, $FzLlj.matchesComponentNaming)(key)) newObj[`smbls.${key}`] = $dcsWo[key];
        else newObj[key] = $dcsWo[key];
    }
    return newObj;
};
const $e929cb719afab5dd$export$4f2633f1ff10978c = (context)=>{
    return context.components ? {
        ...$e929cb719afab5dd$var$UIkitWithPrefix(),
        ...context.components
    } : $e929cb719afab5dd$var$UIkitWithPrefix();
};
const $e929cb719afab5dd$export$348dc3ccba7d17b1 = (context)=>{
    return {
        ...$egeBc,
        ...$cAYSb,
        ...$egeBc.scratchUtils,
        ...context.utils,
        ...context.snippets,
        ...context.functions
    };
};
const $e929cb719afab5dd$export$bb03004b651040c = (context)=>{
    return {
        ...context.methods || {},
        require: context.utils.require,
        requireOnDemand: context.utils.requireOnDemand,
        router: context.utils.router
    };
};
const $e929cb719afab5dd$var$cachedDeps = {};
const $e929cb719afab5dd$export$c40391394e7726ed = async ({ dependencies: dependencies, dependenciesOnDemand: dependenciesOnDemand, document: document1, preventCaching: preventCaching = false, cdnProvider: cdnProvider, packageManager: packageManager, symbolsConfig: symbolsConfig })=>{
    // Derive provider from packageManager or symbolsConfig when not explicitly passed
    if (!cdnProvider) cdnProvider = (0, $bbZ29.PACKAGE_MANAGER_TO_CDN)[packageManager] || (0, $bbZ29.getCdnProviderFromConfig)(symbolsConfig) || 'esmsh';
    if (!dependencies) return null;
    let hasAny = false;
    for(const _k in dependencies){
        hasAny = true;
        break;
    } // eslint-disable-line
    if (!hasAny) return null;
    for(const dependency in dependencies){
        const version = dependencies[dependency];
        if (dependenciesOnDemand && dependenciesOnDemand[dependency]) continue;
        const random = (0, $kt4aQ.isDevelopment)() && preventCaching ? `?${Math.random()}` : '';
        const url = (0, $bbZ29.getCDNUrl)(dependency, version, cdnProvider) + random;
        try {
            if ($e929cb719afab5dd$var$cachedDeps[dependency]) continue;
            $e929cb719afab5dd$var$cachedDeps[dependency] = true;
            await Promise.race([
                $egeBc.loadRemoteScript(url, {
                    document: document1,
                    type: 'module'
                }),
                new Promise((_, r)=>setTimeout(()=>r(new Error(`Timeout loading ${dependency}`)), 10000))
            ]);
        } catch (e) {
            console.error(`Failed to load ${dependency} from ${cdnProvider}:`, e);
            if (cdnProvider !== 'symbols') try {
                const fallbackUrl = (0, $bbZ29.getCDNUrl)(dependency, version, 'symbols') + random;
                await Promise.race([
                    $egeBc.loadRemoteScript(fallbackUrl, {
                        document: document1
                    }),
                    new Promise((_, r)=>setTimeout(()=>r(new Error(`Timeout fallback ${dependency}`)), 10000))
                ]);
                console.log(`Successfully loaded ${dependency} from fallback (symbols.ls)`);
            } catch (fallbackError) {
                console.error(`Failed to load ${dependency} from fallback:`, fallbackError);
            }
        }
    }
    return dependencies;
};
const $e929cb719afab5dd$export$52302ef84805a6f8 = async (packages, ctx)=>{
    const windowOpts = ctx.window || window;
    const defaultProvider = ctx.cdnProvider || (0, $bbZ29.getCdnProviderFromConfig)(ctx.symbolsConfig) || 'esmsh';
    const initRequire = async (ctx)=>async (key, provider)=>{
            const windowOpts = ctx.window || window;
            const pkg = windowOpts.packages[key];
            if (typeof pkg === 'function') return pkg();
            return pkg;
        };
    const initRequireOnDemand = async (ctx)=>async (key, provider = defaultProvider)=>{
            const { dependenciesOnDemand: dependenciesOnDemand } = ctx;
            const documentOpts = ctx.document || document;
            const windowOpts = ctx.window || window;
            if (!windowOpts.packages[key]) {
                const random = (0, $kt4aQ.isDevelopment)() ? `?${Math.random()}` : '';
                if (dependenciesOnDemand && dependenciesOnDemand[key]) {
                    const version = dependenciesOnDemand[key];
                    const url = (0, $bbZ29.getCDNUrl)(key, version, provider) + random;
                    try {
                        await ctx.utils.loadRemoteScript(url, {
                            window: windowOpts,
                            document: documentOpts
                        });
                    } catch (e) {
                        console.error(`Failed to load ${key} from ${provider}:`, e);
                        // Fallback to symbo if not already using it
                        if (provider !== 'symbols') {
                            const fallbackUrl = (0, $bbZ29.getCDNUrl)(key, version, 'symbols') + random;
                            await ctx.utils.loadRemoteScript(fallbackUrl, {
                                window: windowOpts,
                                document: documentOpts
                            });
                        }
                    }
                } else {
                    const url = (0, $bbZ29.getCDNUrl)(key, 'latest', provider) + random;
                    try {
                        await ctx.utils.loadRemoteScript(url, {
                            window: windowOpts,
                            document: documentOpts
                        });
                    } catch (e) {
                        console.error(`Failed to load ${key} from ${provider}:`, e);
                        // Fallback to symbo if not already using it
                        if (provider !== 'symbols') {
                            const fallbackUrl = (0, $bbZ29.getCDNUrl)(key, 'latest', 'symbols') + random;
                            await ctx.utils.loadRemoteScript(fallbackUrl, {
                                window: windowOpts,
                                document: documentOpts
                            });
                        }
                    }
                    windowOpts.packages[key] = 'loadedOnDeman';
                }
            }
            return await windowOpts.require(key, provider);
        };
    if (windowOpts.packages) windowOpts.packages = (0, $bmfNh.merge)(windowOpts.packages, packages);
    else windowOpts.packages = packages;
    if (!windowOpts.require) {
        ctx.utils.require = await initRequire(ctx);
        windowOpts.require = ctx.utils.require;
    }
    if (!windowOpts.requireOnDemand) {
        ctx.utils.requireOnDemand = await initRequireOnDemand(ctx);
        windowOpts.requireOnDemand = ctx.utils.requireOnDemand;
    }
};
// --- CSS classlist/style transform handlers ---
const $e929cb719afab5dd$var$RE_MULTI_SPACE = /\s+/g;
const $e929cb719afab5dd$var$execParam = (param, element)=>{
    if (typeof param === 'function') return param(element, element?.state, element?.context);
    return param;
};
const $e929cb719afab5dd$var$classify = (obj, element)=>{
    let className = '';
    for(const item in obj){
        const param = obj[item];
        if (typeof param === 'boolean' && param) className += ` ${item}`;
        else if (typeof param === 'string') className += ` ${param}`;
        else if (typeof param === 'function') className += ` ${$e929cb719afab5dd$var$execParam(param, element)}`;
    }
    return className;
};
const $e929cb719afab5dd$var$applyClassListOnNode = (params, element, node)=>{
    if (!params) return;
    const { key: key } = element;
    if (params === true) params = element.classlist = {
        key: key
    };
    if (typeof params === 'string') params = element.classlist = {
        default: params
    };
    if (params !== null && typeof params === 'object' && !Array.isArray(params)) params = $e929cb719afab5dd$var$classify(params, element);
    const className = params.replace($e929cb719afab5dd$var$RE_MULTI_SPACE, ' ').trim();
    if (node && typeof node.setAttribute === 'function') node.setAttribute('class', className);
    else if (node) try {
        node.className = className;
    } catch (e) {}
    return className;
};
const $e929cb719afab5dd$var$transformCssStyle = ()=>{
    return (params, element, state)=>{
        const execParams = $e929cb719afab5dd$var$execParam(params, element);
        if (params) {
            const { __ref: ref } = element;
            ref.__class.style = execParams;
        }
        $e929cb719afab5dd$var$transformCssClass()(element.classlist, element, element.state, true);
    };
};
const $e929cb719afab5dd$var$transformCssClass = ()=>{
    return (params, element, state, flag)=>{
        if (element.style && !flag) return;
        const { __ref: __ref } = element;
        const { __class: __class, __classNames: __classNames } = __ref;
        if (params === null || typeof params !== 'object' || Array.isArray(params)) return;
        if (element.class) __classNames.classProps = element.class;
        if (element.attr?.class) __classNames.class = element.attr.class;
        for(const key in __class){
            const prop = __class[key];
            if (!prop) {
                delete __classNames[key];
                continue;
            }
            let className;
            if (typeof prop === 'string' || typeof prop === 'number') className = prop;
            else if (typeof prop === 'boolean') className = element.key;
            else className = (0, $bd7kG.css)(prop);
            __classNames[key] = className;
        }
        // Remove stale classNames that no longer exist in __class
        for(const key in __classNames){
            if (key === 'classProps' || key === 'class') continue;
            if (__class[key] === undefined) delete __classNames[key];
        }
        if (element.node) $e929cb719afab5dd$var$applyClassListOnNode(__classNames, element, element.node);
    };
};
const $e929cb719afab5dd$var$createCssRegistry = ()=>{
    return {
        style: $e929cb719afab5dd$var$transformCssStyle(),
        classlist: $e929cb719afab5dd$var$transformCssClass()
    };
};
// --- Design system preparation ---
const $e929cb719afab5dd$var$OPTION_KEYS = [
    'useReset',
    'useVariable',
    'useFontImport',
    'useIconSprite',
    'useSvgSprite',
    'useDocumentTheme',
    'useDefaultIcons',
    'useDefaultConfig',
    'verbose',
    'globalTheme'
];
let $e929cb719afab5dd$var$_designSystemInitialized = false;
const $e929cb719afab5dd$export$d54de307475be07a = (key, context)=>{
    const doc = context.document || (context.parent && context.parent.documentElement ? context.parent : null) || document;
    const initOptions = context.initOptions || {};
    const registry = context.registry || $e929cb719afab5dd$var$createCssRegistry();
    const designSystem = context.designSystem ? (0, $bmfNh.deepMerge)((0, $bmfNh.deepClone)(context.designSystem), (0, $9Ri24.DEFAULT_CONFIG)) : (0, $bmfNh.deepClone)((0, $9Ri24.DEFAULT_CONFIG));
    // Pick context-level overrides (from user's config.js spread into context)
    const contextOverrides = {};
    for (const k of $e929cb719afab5dd$var$OPTION_KEYS)if (context[k] !== undefined) contextOverrides[k] = context[k];
    let scratchSystem;
    const isSecondary = $e929cb719afab5dd$var$_designSystemInitialized && !context.skipDesignSystemInit;
    const scopeSelector = isSecondary ? `[data-smbls-app="${key}"]` : ':root';
    // Expose for downstream consumers (element create.js stamps the attr)
    context.scopeSelector = scopeSelector;
    const themeScope = scopeSelector === ':root' ? ':root:not([data-theme])' : `${scopeSelector}:not([data-theme])`;
    if (context.skipDesignSystemInit) {
        // Reuse existing config (e.g. iframe context where init() already ran on parent)
        scratchSystem = (0, $7KiQp.getActiveConfig)(key) || (0, $7KiQp.getActiveConfig)();
        // Store the target document on the config so getActiveDocument()
        // resolves it from the config stack.
        if (scratchSystem) scratchSystem.document = doc;
        // Re-inject CSS vars into the target document via active document
        if (scratchSystem?.CSS_VARS) {
            (0, $7KiQp.pushConfig)(scratchSystem);
            try {
                (0, $bd7kG.injectGlobal)({
                    [scopeSelector]: scratchSystem.CSS_VARS
                });
                if (scratchSystem.CSS_MEDIA_VARS) {
                    const themeStyles = {};
                    for(const key in scratchSystem.CSS_MEDIA_VARS)if (key.startsWith('@media')) themeStyles[key] = {
                        [themeScope]: scratchSystem.CSS_MEDIA_VARS[key]
                    };
                    else themeStyles[key] = scratchSystem.CSS_MEDIA_VARS[key];
                    (0, $bd7kG.injectGlobal)(themeStyles);
                }
            } finally{
                (0, $7KiQp.popConfig)();
            }
        }
    } else if (isSecondary) {
        // Secondary app (same-document embedding OR iframe-embedded) — scope
        // cssVars to `[data-smbls-app="<key>"]` so the project DS does NOT leak
        // into the primary app's subtree, AND pass `cleanBase: true` so the
        // isolated config does not inherit the primary's processed tokens
        // (e.g. editor brand themes leaking into project iframe).
        const isolatedConfig = (0, $7KiQp.createConfig)(key, designSystem, {
            cleanBase: true
        });
        for(const k in contextOverrides)isolatedConfig[k] = contextOverrides[k];
        // Store the target document on the config so getActiveDocument()
        // resolves it from the config stack (no global singleton needed).
        isolatedConfig.document = doc;
        // Derive CSS prefix for multi-app class name isolation
        const cssPrefix = key.replace(/[^a-zA-Z0-9]/g, '').substring(0, 6);
        context.cssPrefix = cssPrefix;
        isolatedConfig.varPrefix = cssPrefix;
        (0, $7KiQp.pushConfig)(isolatedConfig);
        try {
            scratchSystem = (0, $5SInI.init)(isolatedConfig, {
                key: key,
                document: doc,
                files: context.files,
                assets: context.assets,
                scopeSelector: scopeSelector,
                ...(0, $F0UG9.DEFAULT_CONTEXT),
                ...contextOverrides,
                ...initOptions
            });
        } finally{
            (0, $7KiQp.popConfig)();
        }
    } else {
        // Primary app — use global config path (`:root`)
        // Store the target document on the global config before init() so
        // getActiveDocument() resolves it during injectGlobal() calls.
        const globalConfig = (0, $7KiQp.getActiveConfig)();
        if (globalConfig) globalConfig.document = doc;
        scratchSystem = (0, $5SInI.init)(designSystem, {
            key: key,
            document: doc,
            files: context.files,
            assets: context.assets,
            scopeSelector: scopeSelector,
            ...(0, $F0UG9.DEFAULT_CONTEXT),
            ...contextOverrides,
            ...initOptions
        });
        // Ensure the returned config also carries the document reference
        if (scratchSystem && scratchSystem !== globalConfig) scratchSystem.document = doc;
        $e929cb719afab5dd$var$_designSystemInitialized = true;
    }
    // CSS reset is injected in createDomql.js after sheet is guaranteed to exist
    // Scoped inside pushConfig so getActiveDocument() resolves to this app's
    // doc (the iframe's for secondary apps); otherwise @font-face rules land
    // in the parent sheet and the iframe never sees them.
    const activeConfig = scratchSystem?.CONFIG || scratchSystem;
    const fontConfig = activeConfig?.font;
    if (fontConfig) {
        (0, $7KiQp.pushConfig)(activeConfig);
        try {
            for(const fontKey in fontConfig){
                const fontData = fontConfig[fontKey];
                if (!fontData?.fontFace) continue;
                const faces = Array.isArray(fontData.fontFace) ? fontData.fontFace : [
                    fontData.fontFace
                ];
                for (const face of faces)if (typeof face === 'string' && face.includes('font-family')) (0, $bd7kG.injectGlobal)(`@font-face { ${face} }`);
            }
        } finally{
            (0, $7KiQp.popConfig)();
        }
    }
    return [
        scratchSystem,
        registry
    ];
};
const $e929cb719afab5dd$export$beb986ec1c64324 = (app, context)=>{
    const state = {};
    if (context.state) $egeBc.deepMerge(state, context.state);
    if (app && app.state) (0, $bmfNh.deepMerge)(state, app.state);
    // Merge polyglot translations for active language into state
    const poly = context.polyglot;
    if (poly?.translations) {
        // Check localStorage for persisted language preference
        const storedLang = typeof localStorage !== 'undefined' ? localStorage.getItem(poly.storageLangKey || 'smbls_lang') || localStorage.getItem('lang') : null;
        const lang = storedLang || state.lang || poly.defaultLang || 'en';
        if (storedLang && storedLang !== state.lang) state.lang = storedLang;
        const langT = poly.translations[lang];
        if (langT && typeof langT === 'object') for(const k in langT)state[k] = langT[k] // Override with active language translations
        ;
        // Also merge top-level translation keys (skip language code keys)
        const langs = new Set(poly.languages || []);
        for(const k in poly.translations)if (!langs.has(k) && state[k] === undefined) state[k] = poly.translations[k];
    }
    state.isRootState = true;
    return (0, $bmfNh.deepClone)(state);
};
const $e929cb719afab5dd$export$b2f7e94520d001d1 = (app, context)=>{
    if ((0, $fX7ii.isObject)(app.routes) && (0, $fX7ii.isObject)(context.pages)) (0, $bmfNh.merge)(app.routes, context.pages);
    const pages = app.routes || context.pages || {};
    for(const v in pages){
        if (v.charCodeAt(0) === 47) continue; // '/'
        const index = v === 'index' ? '' : v;
        pages['/' + index] = pages[v];
        delete pages[v];
    }
    return pages;
};
const $e929cb719afab5dd$export$2068a53156b77a95 = (context)=>{
    (0, $bSS0n.mergeSharedLibraries)(context, context.sharedLibraries);
};

});

parcelRegister("d9FvG", function(module, exports) {

$parcel$export(module.exports, "getActiveLang", () => $993c50a7f4aa2ceb$export$82dddd606bec38d4);
$parcel$export(module.exports, "getLanguages", () => $993c50a7f4aa2ceb$export$329ccd9862d07caf);
$parcel$export(module.exports, "translate", () => $993c50a7f4aa2ceb$export$d73ee8ef04f5226a);
$parcel$export(module.exports, "loadTranslations", () => $993c50a7f4aa2ceb$export$d0a0663b151c7564);
$parcel$export(module.exports, "setLang", () => $993c50a7f4aa2ceb$export$a3665b844fbc095d);
$parcel$export(module.exports, "upsertTranslation", () => $993c50a7f4aa2ceb$export$a3aa77cd454aa87f);
$parcel$export(module.exports, "initPolyglot", () => $993c50a7f4aa2ceb$export$cc83474b38354f0a);
$parcel$export(module.exports, "getLocalStateLang", () => $993c50a7f4aa2ceb$export$467e5dad2827db96);
$parcel$export(module.exports, "polyglotPlugin", () => $993c50a7f4aa2ceb$export$585c1bfea7680056);
parcelRequire("2oe0q");
var $fX7ii = parcelRequire("fX7ii");
'use strict';
// --- Storage helpers ---
const $993c50a7f4aa2ceb$var$STORAGE_KEY_LANG = 'smbls_lang';
const $993c50a7f4aa2ceb$var$STORAGE_KEY_TRANSLATIONS = 'smbls_t_';
const $993c50a7f4aa2ceb$var$STORAGE_KEY_VERSION = 'smbls_tv_';
const $993c50a7f4aa2ceb$var$storage = {
    get (key) {
        try {
            return window?.localStorage.getItem(key);
        } catch (e) {
            return null;
        }
    },
    set (key, val) {
        try {
            window?.localStorage.setItem(key, val);
        } catch (e) {
            console.warn('[polyglot] localStorage unavailable:', e.message);
        }
    },
    remove (key) {
        try {
            window?.localStorage.removeItem(key);
        } catch (e) {
            console.warn('[polyglot] localStorage unavailable:', e.message);
        }
    }
};
// --- In-flight deduplication ---
const $993c50a7f4aa2ceb$var$loading = {};
function $993c50a7f4aa2ceb$export$82dddd606bec38d4() {
    const ctx = this?.context;
    const poly = ctx?.polyglot;
    const root = this?.state?.root || ctx?.state?.root;
    return root?.lang || poly?.defaultLang || 'en';
}
function $993c50a7f4aa2ceb$export$329ccd9862d07caf() {
    const poly = this?.context?.polyglot;
    if (!poly) return [];
    if (poly.languages) return poly.languages;
    // Derive from static translations keys
    if (poly.translations) return Object.keys(poly.translations);
    return [];
}
/**
 * Resolve a value from an object by key.
 * Supports direct lookup and dot-path resolution (e.g. 'nav.about').
 */ const $993c50a7f4aa2ceb$var$resolve = (obj, key)=>{
    if (!obj || !key) return undefined;
    // Direct lookup first (fast path)
    if (obj[key] !== undefined) return obj[key];
    // Dot-path resolution (e.g. 'nav.about' → obj.nav.about)
    if (key.indexOf('.') === -1) return undefined;
    const parts = key.split('.');
    let result = obj;
    for(let i = 0; i < parts.length; i++){
        if (result == null) return undefined;
        result = result[parts[i]];
    }
    return result;
};
/**
 * Resolve a language-suffixed field from state.
 * e.g. resolveSuffixed(state, 'item.title', 'ka') → state.item.title_ka
 */ const $993c50a7f4aa2ceb$var$resolveSuffixed = (obj, key, lang)=>{
    const dotIdx = key.lastIndexOf('.');
    if (dotIdx === -1) return obj[key + '_' + lang];
    const parent = $993c50a7f4aa2ceb$var$resolve(obj, key.substring(0, dotIdx));
    if (parent == null) return undefined;
    return parent[key.substring(dotIdx + 1) + '_' + lang];
};
function $993c50a7f4aa2ceb$export$d73ee8ef04f5226a(key, lang) {
    if (!key) return '';
    const ctx = this?.context;
    const poly = ctx?.polyglot;
    const activeLang = lang || this.call('getActiveLang');
    const state = this?.state;
    // 1. Language-suffixed fields in element state (e.g. title_ka, item.description_en)
    if (state) {
        const val = $993c50a7f4aa2ceb$var$resolveSuffixed(state, key, activeLang);
        if (val !== undefined) return val;
    }
    // 2. Static translations from context
    if (poly?.translations) {
        const langMap = poly.translations[activeLang];
        if (langMap) {
            const val = $993c50a7f4aa2ceb$var$resolve(langMap, key);
            if (val !== undefined) return val;
        }
    }
    // 3. Server-loaded translations in root state
    const root = state?.root || ctx?.state?.root;
    const serverTranslations = root?.translations;
    if (serverTranslations) {
        const langMap = serverTranslations[activeLang];
        if (langMap) {
            const val = $993c50a7f4aa2ceb$var$resolve(langMap, key);
            if (val !== undefined) return val;
        }
    }
    // 4. Fallback: defaultLang state > defaultLang static > key itself
    const defaultLang = poly?.defaultLang || 'en';
    if (state) {
        const val = $993c50a7f4aa2ceb$var$resolveSuffixed(state, key, defaultLang);
        if (val !== undefined) return val;
    }
    if (poly?.translations) {
        const fallback = poly.translations[defaultLang];
        if (fallback) {
            const val = $993c50a7f4aa2ceb$var$resolve(fallback, key);
            if (val !== undefined) return val;
        }
    }
    return key;
}
async function $993c50a7f4aa2ceb$export$d0a0663b151c7564(lang) {
    const ctx = this?.context;
    const poly = ctx?.polyglot;
    const root = this?.state?.root || ctx?.state?.root;
    if (!poly || !root) return;
    const prefix = poly.storagePrefix || $993c50a7f4aa2ceb$var$STORAGE_KEY_TRANSLATIONS;
    const versionPrefix = poly.storageVersionPrefix || (poly.storagePrefix ? poly.storagePrefix.replace(/_$/, 'v_') : $993c50a7f4aa2ceb$var$STORAGE_KEY_VERSION);
    // Static translations — already in poly.translations, nothing to load
    if (poly.translations && poly.translations[lang] && !poly.fetch) return;
    // No server fetch configured — nothing to do
    if (!poly.fetch) return;
    // Skip if a previous fetch for this lang already failed (e.g. missing RPC)
    if (poly._fetchFailed?.[lang]) return;
    // 1. Serve cached immediately (localStorage > state)
    if (!root.translations?.[lang]) {
        const raw = $993c50a7f4aa2ceb$var$storage.get(prefix + lang);
        if (raw) try {
            const cached = JSON.parse(raw);
            const patch = {
                translations: {
                    ...root.translations || {}
                }
            };
            patch.translations[lang] = cached;
            if (root.update) root.update(patch);
        } catch (e) {
            console.warn('[polyglot] Failed to apply language update:', e.message);
        }
    }
    // 2. Deduplicate in-flight requests
    const loadingKey = (poly.storagePrefix || 'smbls') + ':' + lang;
    if ($993c50a7f4aa2ceb$var$loading[loadingKey]) return $993c50a7f4aa2ceb$var$loading[loadingKey];
    const self = this;
    // 3. Background revalidation
    $993c50a7f4aa2ceb$var$loading[loadingKey] = (async ()=>{
        try {
            const fetchConfig = poly.fetch;
            const cachedVersion = parseInt($993c50a7f4aa2ceb$var$storage.get(versionPrefix + lang), 10) || 0;
            let translations, version, changed;
            if ((0, $fX7ii.isFunction)(fetchConfig)) {
                // Custom fetch function: (lang, cachedVersion, element) => { translations, version, changed }
                const result = await fetchConfig(lang, cachedVersion, self);
                if (!result || result.changed === false) return;
                translations = result.translations || result.data || result;
                version = result.version || 0;
                changed = true;
            } else if ((0, $fX7ii.isObject)(fetchConfig)) {
                // RPC-style fetch via db adapter (xma pattern)
                const getDB = self.getDB || (()=>ctx.fetch);
                const db = (0, $fX7ii.isFunction)(getDB) ? await getDB.call(self) : ctx.fetch;
                if (!db) return;
                const rpcName = fetchConfig.rpc || fetchConfig.from || 'get_translations_if_changed';
                const params = {
                    p_lang: lang,
                    p_cached_version: cachedVersion,
                    ...fetchConfig.params || {}
                };
                const res = await db.rpc({
                    from: rpcName,
                    params: params
                });
                if (res.error) {
                    // Mark as failed to avoid repeated calls for missing RPCs
                    if (!poly._fetchFailed) poly._fetchFailed = {};
                    poly._fetchFailed[lang] = true;
                    throw res.error;
                }
                const result = res.data;
                if (!result || !result.changed) return;
                translations = result.translations || {};
                version = result.version || 0;
                changed = true;
            } else return;
            if (!changed || !translations) return;
            // Persist to localStorage
            $993c50a7f4aa2ceb$var$storage.set(prefix + lang, JSON.stringify(translations));
            if (version) $993c50a7f4aa2ceb$var$storage.set(versionPrefix + lang, String(version));
            // Update state
            const patch = {
                translations: {
                    ...root.translations || {}
                }
            };
            patch.translations[lang] = translations;
            if (root.update) root.update(patch);
        } catch (err) {
            if (poly.verbose !== false) {
                const msg = err?.message || err?.details || (typeof err === 'object' ? JSON.stringify(err) : String(err));
                console.warn('[polyglot] Failed to load translations for', lang, '-', msg);
            }
        } finally{
            delete $993c50a7f4aa2ceb$var$loading[loadingKey];
        }
    })();
    return $993c50a7f4aa2ceb$var$loading[loadingKey];
}
async function $993c50a7f4aa2ceb$export$a3665b844fbc095d(lang) {
    const ctx = this?.context;
    const poly = ctx?.polyglot;
    const root = this?.state?.root || ctx?.state?.root;
    if (!root) return;
    if (this.call('getActiveLang') === lang) return;
    // Persist to localStorage
    const storageKey = poly?.storageLangKey || $993c50a7f4aa2ceb$var$STORAGE_KEY_LANG;
    $993c50a7f4aa2ceb$var$storage.set(storageKey, lang);
    // Load server translations if needed
    if (poly?.fetch) await this.call('loadTranslations', lang);
    // Update context.state.lang so polyglot resolver uses the new language
    if (ctx?.state) ctx.state.lang = lang;
    // Collect all translation changes and apply them together with the lang update
    // so reactive effects see both the new lang AND the new translated data
    const langT = poly?.translations?.[lang];
    const updates = {
        lang: lang
    };
    if (langT && typeof langT === 'object') for(const key in langT){
        const val = langT[key];
        if (Array.isArray(val)) // Replace arrays (e.g. investTypes, purpose, projects) so children functions re-evaluate
        updates[key] = val;
        else if (typeof val === 'string' || typeof val === 'number') updates[key] = val;
    }
    // Apply all updates in a single batch
    if (root.update) root.update(updates);
    // Merge nested objects in place — preserves references held by child elements
    if (langT && typeof langT === 'object') for(const key in langT){
        const val = langT[key];
        if (val && typeof val === 'object' && !Array.isArray(val) && root[key] && typeof root[key] === 'object' && !Array.isArray(root[key])) for(const k in val)root[key][k] = val[k];
    }
    // Update element states and re-render all text templates
    const doc = this?.context?.document || globalThis.document;
    if (doc && langT) {
        const allElements = doc.querySelectorAll('[data-key]');
        for (const node of allElements){
            const el = node.ref;
            if (!el) continue;
            const template = el.__ref?.__exec?.text;
            if (typeof template === 'string' && template.includes('{{')) try {
                const resolved = el.call('replaceLiteralsWithObjectFields', template, el.state);
                if (resolved != null && node.textContent !== resolved) node.textContent = resolved;
            } catch (e) {}
        }
    }
}
async function $993c50a7f4aa2ceb$export$a3aa77cd454aa87f(key, lang, text) {
    const ctx = this?.context;
    const poly = ctx?.polyglot;
    const root = this?.state?.root || ctx?.state?.root;
    // Update local state immediately (optimistic)
    if (root?.translations?.[lang]) root.translations[lang][key] = text;
    // Also update static translations if present
    if (poly?.translations?.[lang]) poly.translations[lang][key] = text;
    // Persist to server if fetch is configured
    if (poly?.fetch && (0, $fX7ii.isObject)(poly.fetch)) {
        const getDB = this.getDB || (()=>ctx.fetch);
        const db = (0, $fX7ii.isFunction)(getDB) ? await getDB.call(this) : ctx.fetch;
        if (!db) return;
        const table = poly.fetch.table || 'translations';
        const result = await db.upsert({
            from: table,
            data: {
                key: key,
                lang: lang,
                text: text
            }
        });
        if (result?.error) throw result.error;
        return result.data;
    }
}
async function $993c50a7f4aa2ceb$export$cc83474b38354f0a() {
    const ctx = this?.context;
    const poly = ctx?.polyglot;
    if (!poly) return;
    const root = this?.state?.root || ctx?.state?.root;
    if (!root) return;
    // Read persisted language
    const storageKey = poly.storageLangKey || $993c50a7f4aa2ceb$var$STORAGE_KEY_LANG;
    const persisted = $993c50a7f4aa2ceb$var$storage.get(storageKey);
    const lang = persisted || poly.defaultLang || root.lang || 'en';
    // Set active language in root state
    if (root.update && root.lang !== lang) root.update({
        lang: lang
    });
    // Load translations — skip if already injected (e.g. SSR prefetch)
    if (poly.fetch && !(poly.translations && poly.translations[lang])) await this.call('loadTranslations', lang);
}
function $993c50a7f4aa2ceb$export$467e5dad2827db96(key) {
    try {
        const poly = this?.context?.polyglot;
        const root = this?.state?.root || this?.context?.state?.root;
        const lang = root?.lang || poly?.defaultLang || 'en';
        const state = this?.state;
        if (!state) return '';
        const dotIdx = key.lastIndexOf('.');
        if (dotIdx === -1) return state[key + lang] ?? '';
        const parts = key.substring(0, dotIdx).split('.');
        let obj = state;
        for(let i = 0; i < parts.length; i++){
            if (obj == null) return '';
            obj = obj[parts[i]];
        }
        if (obj == null) return '';
        return obj[key.substring(dotIdx + 1) + lang] ?? '';
    } catch (e) {
        return '';
    }
}
const $993c50a7f4aa2ceb$export$585c1bfea7680056 = {
    name: 'polyglot',
    // Initialize on app render — load persisted language + translations
    render (element) {
        // Only init once on the root element
        if (element.parent && element.parent.parent) return;
        if (element.__polyglotInitialized) return;
        element.__polyglotInitialized = true;
        $993c50a7f4aa2ceb$export$cc83474b38354f0a.call(element);
    }
};
var $993c50a7f4aa2ceb$export$2e2bcd8739ae039 = $993c50a7f4aa2ceb$export$585c1bfea7680056;

});

parcelRegister("hurDj", function(module, exports) {

$parcel$export(module.exports, "polyglotFunctions", () => $cbbaac5a5ebe523b$export$d71e84fe8abd833f);

var $d9FvG = parcelRequire("d9FvG");
'use strict';
const $cbbaac5a5ebe523b$export$d71e84fe8abd833f = {
    polyglot: (0, $d9FvG.translate),
    getLocalStateLang: $d9FvG.getLocalStateLang,
    getActiveLang: $d9FvG.getActiveLang,
    getLang: (0, $d9FvG.getActiveLang),
    setLang: $d9FvG.setLang,
    getLanguages: $d9FvG.getLanguages,
    loadTranslations: $d9FvG.loadTranslations,
    upsertTranslation: $d9FvG.upsertTranslation
};
var $cbbaac5a5ebe523b$export$2e2bcd8739ae039 = $cbbaac5a5ebe523b$export$d71e84fe8abd833f;

});

parcelRegister("ibNFW", function(module, exports) {

$parcel$export(module.exports, "capsizeHandler", () => $d3dfc994d314f8b0$export$fa3125fef51b8f27);
$parcel$export(module.exports, "capsizePlugin", () => $d3dfc994d314f8b0$export$ad80c2b380baba5);
'use strict';
const $d3dfc994d314f8b0$export$e6ae8216715a8e71 = {
    arial: {
        capHeight: 716,
        ascent: 1854,
        descent: -434,
        lineGap: 67,
        unitsPerEm: 2048
    },
    helvetica: {
        capHeight: 714,
        ascent: 770,
        descent: -230,
        lineGap: 0,
        unitsPerEm: 1000
    },
    'helvetica neue': {
        capHeight: 714,
        ascent: 952,
        descent: -213,
        lineGap: 28,
        unitsPerEm: 1000
    },
    georgia: {
        capHeight: 1419,
        ascent: 1878,
        descent: -449,
        lineGap: 0,
        unitsPerEm: 2048
    },
    'times new roman': {
        capHeight: 1356,
        ascent: 1825,
        descent: -443,
        lineGap: 87,
        unitsPerEm: 2048
    },
    'courier new': {
        capHeight: 1170,
        ascent: 1705,
        descent: -615,
        lineGap: 0,
        unitsPerEm: 2048
    },
    verdana: {
        capHeight: 1489,
        ascent: 2059,
        descent: -430,
        lineGap: 0,
        unitsPerEm: 2048
    },
    roboto: {
        capHeight: 1456,
        ascent: 1900,
        descent: -500,
        lineGap: 0,
        unitsPerEm: 2048
    },
    'open sans': {
        capHeight: 1462,
        ascent: 2189,
        descent: -600,
        lineGap: 0,
        unitsPerEm: 2048
    },
    inter: {
        capHeight: 1490,
        ascent: 2048,
        descent: -512,
        lineGap: 0,
        unitsPerEm: 2048
    },
    lato: {
        capHeight: 1434,
        ascent: 1974,
        descent: -426,
        lineGap: 0,
        unitsPerEm: 2000
    },
    'source sans': {
        capHeight: 660,
        ascent: 984,
        descent: -273,
        lineGap: 0,
        unitsPerEm: 1000
    },
    'source sans pro': {
        capHeight: 660,
        ascent: 984,
        descent: -273,
        lineGap: 0,
        unitsPerEm: 1000
    },
    'source sans 3': {
        capHeight: 660,
        ascent: 984,
        descent: -273,
        lineGap: 0,
        unitsPerEm: 1000
    },
    montserrat: {
        capHeight: 700,
        ascent: 968,
        descent: -251,
        lineGap: 0,
        unitsPerEm: 1000
    },
    poppins: {
        capHeight: 700,
        ascent: 1050,
        descent: -350,
        lineGap: 100,
        unitsPerEm: 1000
    },
    raleway: {
        capHeight: 710,
        ascent: 1000,
        descent: -250,
        lineGap: 0,
        unitsPerEm: 1000
    },
    'dm sans': {
        capHeight: 700,
        ascent: 992,
        descent: -312,
        lineGap: 0,
        unitsPerEm: 1000
    },
    nunito: {
        capHeight: 705,
        ascent: 1011,
        descent: -353,
        lineGap: 0,
        unitsPerEm: 1000
    },
    'work sans': {
        capHeight: 684,
        ascent: 930,
        descent: -243,
        lineGap: 0,
        unitsPerEm: 1000
    },
    manrope: {
        capHeight: 708,
        ascent: 980,
        descent: -300,
        lineGap: 0,
        unitsPerEm: 1000
    },
    'ibm plex sans': {
        capHeight: 698,
        ascent: 1025,
        descent: -275,
        lineGap: 0,
        unitsPerEm: 1000
    },
    'plus jakarta sans': {
        capHeight: 720,
        ascent: 1060,
        descent: -300,
        lineGap: 0,
        unitsPerEm: 1000
    }
};
// ── Core capsize computation ───────────────────────────────────────────────
const $d3dfc994d314f8b0$var$round = (v)=>parseFloat(v.toFixed(4));
const $d3dfc994d314f8b0$export$18aa279422fe4f3c = (fontSize, fontMetrics, leading)=>{
    const { ascent: ascent, descent: descent, lineGap: lineGap, unitsPerEm: unitsPerEm, capHeight: capHeight } = fontMetrics;
    const absoluteDescent = Math.abs(descent);
    const contentArea = ascent + absoluteDescent + lineGap;
    const lineHeight = leading !== undefined ? leading : contentArea / unitsPerEm * fontSize;
    const lineHeightScale = lineHeight / fontSize;
    const contentAreaScale = contentArea / unitsPerEm;
    const trimTop = (ascent - capHeight + lineGap / 2) / unitsPerEm - (lineHeightScale - contentAreaScale) / 2;
    const trimBottom = (absoluteDescent + lineGap / 2) / unitsPerEm - (lineHeightScale - contentAreaScale) / 2;
    return {
        fontSize: `${$d3dfc994d314f8b0$var$round(fontSize / 16)}rem`,
        lineHeight: `${$d3dfc994d314f8b0$var$round(lineHeight)}px`,
        capHeightTrim: `${$d3dfc994d314f8b0$var$round(-trimTop)}em`,
        baselineTrim: `${$d3dfc994d314f8b0$var$round(-trimBottom)}em`
    };
};
const $d3dfc994d314f8b0$export$462ec7612e3496f9 = (value, context)=>{
    if (typeof value === 'number') return value;
    const config = context?.designSystem;
    if (!config) return null;
    const { typography: typography } = config;
    if (typography?.sequence) {
        const key = String(value).toUpperCase();
        const seq = typography.sequence[key];
        if (seq) return seq.decimal || seq.val;
    }
    const num = parseFloat(value);
    if (!isNaN(num)) {
        if (typeof value === 'string' && value.endsWith('rem')) return num * (config.typography?.browserDefault || 16);
        return num;
    }
    return null;
};
const $d3dfc994d314f8b0$export$35ac023e49c92ba3 = (fontFamily, context)=>{
    const config = context?.designSystem;
    const families = config?.font_family || {};
    // Check explicit metrics on font_family config entry
    if (fontFamily) {
        const fam = families[fontFamily];
        if (fam?.metrics) return fam.metrics;
        // Try matching by normalized name in SYSTEM_METRICS
        const normalized = String(fontFamily).toLowerCase().replace(/['"]/g, '').trim();
        if ($d3dfc994d314f8b0$export$e6ae8216715a8e71[normalized]) return $d3dfc994d314f8b0$export$e6ae8216715a8e71[normalized];
    }
    // Fallback: try default font family
    const defaultKey = families.default || Object.keys(families)[0];
    if (defaultKey) {
        const fam = families[defaultKey];
        if (fam?.metrics) return fam.metrics;
        // Try matching value array against SYSTEM_METRICS
        if (fam?.value && Array.isArray(fam.value)) for (const name of fam.value){
            const normalized = name.toLowerCase().replace(/['"]/g, '').trim();
            if ($d3dfc994d314f8b0$export$e6ae8216715a8e71[normalized]) return $d3dfc994d314f8b0$export$e6ae8216715a8e71[normalized];
        }
    }
    return null;
};
const $d3dfc994d314f8b0$export$fa3125fef51b8f27 = (value, element, state, context)=>{
    if (!value) return;
    const fontSize = $d3dfc994d314f8b0$export$462ec7612e3496f9(element.fontSize, context);
    if (!fontSize) return;
    const metrics = $d3dfc994d314f8b0$export$35ac023e49c92ba3(element.fontFamily, context);
    if (!metrics) return;
    const leading = element.lineHeight ? parseFloat(element.lineHeight) : undefined;
    const { lineHeight: lineHeight, capHeightTrim: capHeightTrim, baselineTrim: baselineTrim } = $d3dfc994d314f8b0$export$18aa279422fe4f3c(fontSize, metrics, leading);
    const result = {};
    if (!element.lineHeight) result.lineHeight = lineHeight;
    result['::before'] = {
        content: '""',
        marginBottom: capHeightTrim,
        display: 'table'
    };
    result['::after'] = {
        content: '""',
        marginTop: baselineTrim,
        display: 'table'
    };
    return result;
};
const $d3dfc994d314f8b0$export$ad80c2b380baba5 = {
    name: 'capsize',
    init (element) {
        if (element.useCapsize !== undefined) return;
        if (!element.fontSize) return;
        element.useCapsize = true;
    }
};
var $d3dfc994d314f8b0$export$2e2bcd8739ae039 = $d3dfc994d314f8b0$export$ad80c2b380baba5;

});

parcelRegister("lYcxN", function(module, exports) {

$parcel$export(module.exports, "shorthandPlugin", () => $ffe8ee8f36f53db8$export$7de1996cf44b9246);

var $5Wl1B = parcelRequire("5Wl1B");

var $erJi9 = parcelRequire("erJi9");
'use strict';
const $ffe8ee8f36f53db8$var$EXPAND_MODES = {
    shorten: (0, $5Wl1B.expand),
    stringify: (0, $5Wl1B.parse),
    stringifyFurther: (0, $erJi9.parseFurther)
};
/**
 * Expand shorthand keys/values on a section of the context.
 * Walks every top-level entry and applies the decoder.
 */ function $ffe8ee8f36f53db8$var$expandSection(section, decoder) {
    if (!section || typeof section !== 'object') return section;
    if (Array.isArray(section)) return section.map((item)=>decoder(item));
    const out = {};
    for(const key in section){
        const val = section[key];
        out[key] = val && typeof val === 'object' ? decoder(val) : val;
    }
    return out;
}
/**
 * Sections of the context that contain component-like objects
 * and should be expanded at runtime.
 */ const $ffe8ee8f36f53db8$var$EXPANDABLE_SECTIONS = [
    'components',
    'pages',
    'snippets'
];
const $ffe8ee8f36f53db8$export$7de1996cf44b9246 = {
    name: 'shorthand',
    /**
   * Called during prepareContext to expand shorthand data in-place.
   * This is not a standard lifecycle hook — it's invoked explicitly
   * by createDomql's prepareContext.
   */ prepareContext (context) {
        const mode = context.shorthand;
        if (!mode) return;
        const decoderKey = mode === true ? 'shorten' : mode;
        const decoder = $ffe8ee8f36f53db8$var$EXPAND_MODES[decoderKey];
        if (!decoder) return;
        for (const section of $ffe8ee8f36f53db8$var$EXPANDABLE_SECTIONS)if (context[section]) context[section] = $ffe8ee8f36f53db8$var$expandSection(context[section], decoder);
        // Expand app-level element if present
        if (context.app && typeof context.app === 'object') context.app = decoder(context.app);
    }
};

});
parcelRegister("5Wl1B", function(module, exports) {

$parcel$export(module.exports, "expand", () => $4532ad9ebdb9ce5d$export$9f77e0932fb78f72);
$parcel$export(module.exports, "parse", () => $4532ad9ebdb9ce5d$export$98e6a39c04603d36);

var $gDHpn = parcelRequire("gDHpn");
'use strict';
function $4532ad9ebdb9ce5d$export$2f872c0f2117be69(str) {
    if (!str || typeof str !== 'string') return {};
    const obj = {};
    const tokens = $4532ad9ebdb9ce5d$var$tokenize(str);
    for (const token of tokens){
        // Boolean false: !abbr
        if (token.startsWith('!')) {
            const abbr = token.slice(1);
            const prop = (0, $gDHpn.abbrToProp)[abbr] || abbr;
            obj[prop] = false;
            continue;
        }
        const colonIdx = token.indexOf(':');
        // Boolean true: bare abbreviation
        if (colonIdx === -1) {
            const prop = (0, $gDHpn.abbrToProp)[token] || token;
            obj[prop] = true;
            continue;
        }
        const abbr = token.slice(0, colonIdx);
        const rawVal = token.slice(colonIdx + 1);
        const prop = (0, $gDHpn.abbrToProp)[abbr] || abbr;
        // Array value: comma-separated
        if (rawVal.includes(',')) {
            obj[prop] = rawVal.split(',').map($4532ad9ebdb9ce5d$var$decodeValue);
            continue;
        }
        obj[prop] = $4532ad9ebdb9ce5d$var$decodeValue(rawVal);
    }
    return obj;
}
/**
 * Tokenize a shorthand string by splitting on spaces,
 * respecting that underscores represent spaces within values.
 */ function $4532ad9ebdb9ce5d$var$tokenize(str) {
    return str.trim().split(/\s+/).filter(Boolean);
}
/**
 * Decode a single value: underscores → spaces, parse numbers and booleans.
 */ function $4532ad9ebdb9ce5d$var$decodeValue(val) {
    const str = val.replace(/_/g, ' ');
    // Try parsing as number
    if (/^-?\d+(\.\d+)?$/.test(str)) return Number(str);
    return str;
}
/**
 * Decode inline `in` string values preserving string types.
 * Unlike decodeValue, this does NOT convert numeric strings to numbers,
 * since CSS values like '0', '1', '.5' must stay as strings.
 */ function $4532ad9ebdb9ce5d$var$decodeInlineValue(val) {
    return val.replace(/_/g, ' ');
}
/**
 * Decode an `in` string (from stringify) back to key-value pairs.
 * Uses string-preserving value decode to avoid lossy type coercion.
 */ function $4532ad9ebdb9ce5d$var$decodeInline(str) {
    if (!str || typeof str !== 'string') return {};
    const obj = {};
    const tokens = $4532ad9ebdb9ce5d$var$tokenize(str);
    for (const token of tokens){
        if (token.startsWith('!')) {
            const abbr = token.slice(1);
            const prop = (0, $gDHpn.abbrToProp)[abbr] || abbr;
            obj[prop] = false;
            continue;
        }
        const colonIdx = token.indexOf(':');
        if (colonIdx === -1) {
            const prop = (0, $gDHpn.abbrToProp)[token] || token;
            obj[prop] = true;
            continue;
        }
        const abbr = token.slice(0, colonIdx);
        const rawVal = token.slice(colonIdx + 1);
        const prop = (0, $gDHpn.abbrToProp)[abbr] || abbr;
        // Array value: comma-separated
        if (rawVal.includes(',')) {
            obj[prop] = rawVal.split(',').map($4532ad9ebdb9ce5d$var$decodeInlineValue);
            continue;
        }
        obj[prop] = $4532ad9ebdb9ce5d$var$decodeInlineValue(rawVal);
    }
    return obj;
}
function $4532ad9ebdb9ce5d$export$9f77e0932fb78f72(obj) {
    if (!obj || typeof obj !== 'object') return obj;
    if (Array.isArray(obj)) return obj.map(function(item) {
        if (item !== null && typeof item === 'object') return $4532ad9ebdb9ce5d$export$9f77e0932fb78f72(item);
        return item;
    });
    const result = {};
    for(const key in obj){
        const val = obj[key];
        // PascalCase = child component → keep key, recurse value
        if ((0, $gDHpn.isComponentKey)(key)) {
            result[key] = $4532ad9ebdb9ce5d$var$expandVal(val);
            continue;
        }
        // Try to resolve abbreviation first
        const fullKey = (0, $gDHpn.abbrToProp)[key] || key;
        // Selector/media/case key that is NOT an event abbreviation → keep key, recurse
        if ((0, $gDHpn.isSelectorKey)(key) && fullKey === key) {
            result[key] = $4532ad9ebdb9ce5d$var$expandVal(val);
            continue;
        }
        // Preserved keys: value NOT recursed
        if ((0, $gDHpn.PRESERVE_VALUE_KEYS).has(fullKey) || (0, $gDHpn.PRESERVE_VALUE_KEYS).has(key)) {
            result[fullKey] = val;
            continue;
        }
        result[fullKey] = $4532ad9ebdb9ce5d$var$expandVal(val);
    }
    return result;
}
function $4532ad9ebdb9ce5d$var$expandVal(val) {
    if (val === null || val === undefined) return val;
    if (typeof val === 'function') return val;
    if (Array.isArray(val)) return val.map(function(item) {
        if (item !== null && typeof item === 'object') return $4532ad9ebdb9ce5d$export$9f77e0932fb78f72(item);
        return item;
    });
    if (typeof val === 'object') return $4532ad9ebdb9ce5d$export$9f77e0932fb78f72(val);
    return val;
}
function $4532ad9ebdb9ce5d$export$98e6a39c04603d36(obj) {
    if (!obj || typeof obj !== 'object') return obj;
    if (Array.isArray(obj)) return obj.map(function(item) {
        if (item !== null && typeof item === 'object') return $4532ad9ebdb9ce5d$export$98e6a39c04603d36(item);
        return item;
    });
    const result = {};
    // Decode the `in` string first so its props come first in key order
    if (typeof obj.in === 'string') {
        const decoded = $4532ad9ebdb9ce5d$var$decodeInline(obj.in);
        for(const prop in decoded)result[prop] = decoded[prop];
    }
    for(const key in obj){
        if (key === 'in') continue;
        const val = obj[key];
        // PascalCase = child component → keep key, recurse value
        if ((0, $gDHpn.isComponentKey)(key)) {
            result[key] = $4532ad9ebdb9ce5d$var$parseVal(val);
            continue;
        }
        // Try to resolve abbreviation
        const fullKey = (0, $gDHpn.abbrToProp)[key] || key;
        // Selector/media/case key that is NOT an event abbreviation → keep key, recurse
        if ((0, $gDHpn.isSelectorKey)(key) && fullKey === key) {
            result[key] = $4532ad9ebdb9ce5d$var$parseVal(val);
            continue;
        }
        // Preserved keys: value NOT recursed
        if ((0, $gDHpn.PRESERVE_VALUE_KEYS).has(fullKey) || (0, $gDHpn.PRESERVE_VALUE_KEYS).has(key)) {
            result[fullKey] = val;
            continue;
        }
        result[fullKey] = $4532ad9ebdb9ce5d$var$parseVal(val);
    }
    return result;
}
function $4532ad9ebdb9ce5d$var$parseVal(val) {
    if (val === null || val === undefined) return val;
    if (typeof val === 'function') return val;
    if (Array.isArray(val)) return val.map(function(item) {
        if (item !== null && typeof item === 'object') return $4532ad9ebdb9ce5d$export$98e6a39c04603d36(item);
        return item;
    });
    if (typeof val === 'object') return $4532ad9ebdb9ce5d$export$98e6a39c04603d36(val);
    return val;
}

});
parcelRegister("gDHpn", function(module, exports) {

$parcel$export(module.exports, "propToAbbr", () => $03204a289031a296$export$312c961b6236cdd9);
$parcel$export(module.exports, "abbrToProp", () => $03204a289031a296$export$606c1437693b4e99);
$parcel$export(module.exports, "PRESERVE_VALUE_KEYS", () => $03204a289031a296$export$1f0e8d7ac46e80f0);
$parcel$export(module.exports, "SKIP_INLINE_KEYS", () => $03204a289031a296$export$ed735b84e3086c1d);
$parcel$export(module.exports, "isComponentKey", () => $03204a289031a296$export$6c9f97f8b1b3890a);
$parcel$export(module.exports, "isSelectorKey", () => $03204a289031a296$export$5b3d4710c3e6d4d9);
'use strict';
/**
 * Bidirectional registry mapping property names to shorthand abbreviations.
 *
 * propToAbbr: { propertyName → abbreviation }
 * abbrToProp: { abbreviation → propertyName }
 */ const $03204a289031a296$export$312c961b6236cdd9 = {
    // ── Core DOMQL Properties ──
    attr: 'at',
    childExtends: 'cex',
    childExtendsRecursive: 'cexr',
    childProps: 'cp',
    children: 'ch',
    childrenAs: 'cha',
    class: 'cl',
    content: 'cnt',
    context: 'ctx',
    data: 'dt',
    extends: 'ext',
    hide: 'hd',
    html: 'htm',
    if: 'if',
    ignoreChildExtends: 'icex',
    key: 'ky',
    query: 'qy',
    routes: 'rt',
    scope: 'scp',
    show: 'shw',
    state: 'st',
    style: 'sy',
    tag: 'tg',
    text: 'tx',
    // ── Symbols Shorthand Props ──
    align: 'aln',
    boxSize: 'bsz',
    flow: 'fl',
    heightRange: 'hr',
    horizontalInset: 'hi',
    round: 'rnd',
    shadow: 'shd',
    size: 'sz',
    templateColumns: 'tcol',
    verticalInset: 'vi',
    widthRange: 'wr',
    wrap: 'wrp',
    // ── Box / Sizing ──
    aspectRatio: 'ar',
    blockSize: 'bks',
    boxSizing: 'bxs',
    height: 'h',
    inlineSize: 'ins',
    margin: 'm',
    marginBottom: 'mb',
    marginLeft: 'ml',
    marginRight: 'mr',
    marginTop: 'mt',
    maxBlockSize: 'mxbs',
    maxHeight: 'mxh',
    maxInlineSize: 'mxis',
    maxWidth: 'mxw',
    minBlockSize: 'mnbs',
    minHeight: 'mnh',
    minInlineSize: 'mnis',
    minWidth: 'mnw',
    padding: 'p',
    paddingBottom: 'pb',
    paddingInline: 'pil',
    paddingLeft: 'pl',
    paddingRight: 'pr',
    paddingTop: 'pt',
    width: 'w',
    // ── Flexbox ──
    alignContent: 'ac',
    alignItems: 'ai',
    alignSelf: 'as',
    flex: 'fx',
    flexBasis: 'fxb',
    flexDirection: 'fxd',
    flexFlow: 'fxf',
    flexGrow: 'fxg',
    flexShrink: 'fxs',
    flexWrap: 'fxw',
    gap: 'g',
    justifyContent: 'jc',
    justifyItems: 'ji',
    justifySelf: 'js',
    order: 'od',
    placeContent: 'pcn',
    placeItems: 'pit',
    placeSelf: 'psl',
    rowGap: 'rg',
    // ── Grid ──
    columnGap: 'cg',
    gridArea: 'ga',
    gridAutoColumns: 'gac',
    gridAutoFlow: 'gaf',
    gridAutoRows: 'gar',
    gridColumn: 'gc',
    gridColumnEnd: 'gce',
    gridColumnStart: 'gcs',
    gridRow: 'gr',
    gridRowEnd: 'gre',
    gridRowStart: 'grs',
    gridTemplateAreas: 'gta',
    gridTemplateColumns: 'gtc',
    gridTemplateRows: 'gtr',
    // ── Position ──
    bottom: 'bot',
    float: 'flt',
    inset: 'ist',
    left: 'lft',
    position: 'pos',
    right: 'rgt',
    top: 'tp',
    zIndex: 'zi',
    // ── Display / Visibility ──
    clear: 'clr',
    contain: 'ctn',
    cursor: 'cur',
    display: 'd',
    opacity: 'op',
    overflow: 'ov',
    overflowX: 'ovx',
    overflowY: 'ovy',
    pointerEvents: 'pe',
    resize: 'rsz',
    userSelect: 'us',
    visibility: 'vis',
    // ── Color / Theme ──
    background: 'bg',
    backgroundAttachment: 'bga',
    backgroundBlendMode: 'bgbm',
    backgroundClip: 'bgcl',
    backgroundColor: 'bgc',
    backgroundImage: 'bgi',
    backgroundOrigin: 'bgo',
    backgroundPosition: 'bgp',
    backgroundPositionX: 'bgpx',
    backgroundPositionY: 'bgpy',
    backgroundRepeat: 'bgr',
    backgroundRepeatX: 'bgrx',
    backgroundRepeatY: 'bgry',
    backgroundSize: 'bgs',
    color: 'c',
    theme: 'thm',
    themeModifier: 'thmm',
    // ── Border ──
    border: 'bd',
    borderBottom: 'bdb',
    borderBottomLeftRadius: 'bdblr',
    borderBottomRightRadius: 'bdbrr',
    borderCollapse: 'bdcl',
    borderColor: 'bdc',
    borderImage: 'bdi',
    borderImageOutset: 'bdio',
    borderImageRepeat: 'bdir',
    borderImageSlice: 'bdis',
    borderImageSource: 'bdisrc',
    borderImageWidth: 'bdiw',
    borderLeft: 'bdl',
    borderRadius: 'bdr',
    borderRight: 'bdrg',
    borderSpacing: 'bdsp',
    borderStyle: 'bdst',
    borderTop: 'bdt',
    borderTopLeftRadius: 'bdtlr',
    borderTopRightRadius: 'bdtrr',
    borderWidth: 'bdw',
    // ── Outline ──
    outline: 'ol',
    outlineColor: 'olc',
    outlineOffset: 'olo',
    outlineStyle: 'ols',
    outlineWidth: 'olw',
    // ── Shadow ──
    boxShadow: 'bxsh',
    textShadow: 'txsh',
    // ── Typography ──
    direction: 'dir',
    fontDisplay: 'fdi',
    fontFamily: 'ff',
    fontFeatureSettings: 'ffs',
    fontKerning: 'fk',
    fontOpticalSizing: 'fos',
    fontPalette: 'fpl',
    fontSize: 'fs',
    fontSizeAdjust: 'fsa',
    fontSmooth: 'fsm',
    fontStretch: 'fsr',
    fontStyle: 'fsy',
    fontSynthesis: 'fsyn',
    fontVariant: 'fv',
    fontVariationSettings: 'fvs',
    fontWeight: 'fw',
    hyphens: 'hyp',
    letterSpacing: 'ls',
    lineHeight: 'lh',
    tabSize: 'tsz',
    textAlign: 'ta',
    textDecoration: 'td',
    textDecorationColor: 'tdc',
    textDecorationLine: 'tdl',
    textDecorationStyle: 'tds',
    textIndent: 'ti',
    textOverflow: 'tov',
    textStroke: 'tsk',
    textTransform: 'tt',
    unicodeBidi: 'ub',
    verticalAlign: 'va',
    whiteSpace: 'ws',
    wordBreak: 'wbr',
    wordSpacing: 'wsp',
    wordWrap: 'wwr',
    writingMode: 'wm',
    // ── List / Table ──
    captionSide: 'cps',
    counterIncrement: 'ci',
    counterReset: 'cr',
    emptyCells: 'ec',
    listStyle: 'lst',
    listStyleImage: 'lsi',
    listStylePosition: 'lsp',
    listStyleType: 'lsty',
    quotes: 'qt',
    tableLayout: 'tl',
    // ── Column ──
    columnCount: 'cc',
    columnFill: 'cf',
    columnRule: 'crl',
    columnRuleColor: 'crlc',
    columnRuleStyle: 'crls',
    columnRuleWidth: 'crlw',
    columnSpan: 'cspn',
    columnWidth: 'cwi',
    columns: 'col',
    // ── Filter / Effects ──
    backdropFilter: 'bdf',
    boxDecorationBreak: 'bxdb',
    clipPath: 'cpth',
    filter: 'fil',
    isolation: 'iso',
    mixBlendMode: 'mbm',
    objectFit: 'obf',
    objectPosition: 'obp',
    perspective: 'prs',
    perspectiveOrigin: 'prso',
    willChange: 'wc',
    // ── Transform ──
    transform: 'tf',
    transformOrigin: 'tfo',
    transformStyle: 'tfs',
    // ── Transition ──
    transition: 'trn',
    transitionDelay: 'trnd',
    transitionDuration: 'trndr',
    transitionProperty: 'trnp',
    transitionTimingFunction: 'trntf',
    // ── Animation ──
    animation: 'an',
    animationDelay: 'and',
    animationDirection: 'andr',
    animationDuration: 'andur',
    animationFillMode: 'anfm',
    animationIterationCount: 'anic',
    animationName: 'ann',
    animationPlayState: 'anps',
    animationTimingFunction: 'antf',
    // ── Scroll ──
    scrollBehavior: 'sb',
    scrollMargin: 'smr',
    scrollMarginBottom: 'smrb',
    scrollMarginLeft: 'smrl',
    scrollMarginRight: 'smrr',
    scrollMarginTop: 'smrt',
    scrollPadding: 'spd',
    scrollPaddingBottom: 'spdb',
    scrollPaddingLeft: 'spdl',
    scrollPaddingRight: 'spdr',
    scrollPaddingTop: 'spdt',
    scrollSnapAlign: 'ssa',
    scrollSnapStop: 'sss',
    scrollSnapType: 'sst',
    // ── Page Break ──
    breakAfter: 'bka',
    breakBefore: 'bkb',
    breakInside: 'bki',
    pageBreakAfter: 'pbka',
    pageBreakBefore: 'pbkb',
    pageBreakInside: 'pbki',
    // ── HTML Attributes: Global ──
    accessKey: 'ack',
    className: 'cn',
    contentEditable: 'ced',
    contextMenu: 'cmu',
    draggable: 'drg',
    hidden: 'hid',
    id: 'id',
    is: 'is',
    lang: 'lng',
    nonce: 'nnc',
    spellCheck: 'spc',
    tabIndex: 'tbi',
    title: 'ttl',
    translate: 'trl',
    // ── HTML Attributes: Form ──
    accept: 'acp',
    acceptCharset: 'accs',
    action: 'act',
    autoComplete: 'atc',
    autoFocus: 'atf',
    capture: 'cap',
    challenge: 'chg',
    checked: 'chk',
    cols: 'cls',
    colSpan: 'csn',
    controls: 'ctl',
    default: 'def',
    defer: 'dfr',
    disabled: 'dis',
    encType: 'ect',
    form: 'frm',
    formAction: 'fac',
    formEncType: 'fect',
    formMethod: 'fme',
    formNoValidate: 'fnv',
    formTarget: 'ftg',
    high: 'hgh',
    inputMode: 'imd',
    kind: 'knd',
    label: 'lbl',
    list: 'lis',
    loop: 'lp',
    low: 'lw',
    max: 'mx',
    maxLength: 'mxl',
    method: 'mtd',
    min: 'mn',
    minLength: 'mnl',
    multiple: 'mul',
    muted: 'mut',
    name: 'nm',
    open: 'opn',
    optimum: 'opt',
    pattern: 'ptn',
    placeholder: 'phd',
    readOnly: 'ro',
    required: 'req',
    reversed: 'rev',
    rows: 'rws',
    rowSpan: 'rsn',
    selected: 'sel',
    span: 'spn',
    start: 'srt',
    step: 'stp',
    type: 'typ',
    value: 'val',
    // ── HTML Attributes: Link / Navigation ──
    download: 'dl',
    href: 'hrf',
    hrefLang: 'hrl',
    ping: 'png',
    referrerPolicy: 'rfp',
    rel: 'rl',
    target: 'tgt',
    // ── HTML Attributes: Media ──
    allow: 'alw',
    allowFullScreen: 'afs',
    allowPaymentRequest: 'apr',
    alt: 'alt',
    cellPadding: 'cpg',
    cellSpacing: 'csg',
    cite: 'cit',
    coords: 'crd',
    crossOrigin: 'cor',
    dateTime: 'dtm',
    fetchPriority: 'fpr',
    headers: 'hds',
    httpEquiv: 'hte',
    integrity: 'itg',
    isMap: 'ism',
    keyType: 'kty',
    loading: 'ldg',
    manifest: 'mft',
    media: 'mda',
    poster: 'pst',
    preload: 'prl',
    radioGroup: 'rdg',
    sandbox: 'sbx',
    scoped: 'scod',
    seamless: 'sml',
    shape: 'shp',
    sizes: 'szs',
    src: 'src',
    srcDoc: 'srd',
    srcLang: 'srl',
    srcSet: 'srs',
    useMap: 'ump',
    // ── HTML Attributes: ARIA ──
    ariaActiveDescendant: 'aad',
    ariaAtomic: 'aat',
    ariaBusy: 'abu',
    ariaChecked: 'achk',
    ariaControls: 'acl',
    ariaCurrent: 'acr',
    ariaDescribedBy: 'adb',
    ariaDetails: 'adt',
    ariaDisabled: 'adis',
    ariaDropEffect: 'ade',
    ariaErrorMessage: 'aem',
    ariaExpanded: 'aexp',
    ariaGrabbed: 'agr',
    ariaHasPopup: 'ahp',
    ariaHidden: 'ahid',
    ariaInvalid: 'ainv',
    ariaLabel: 'alb',
    ariaLabelledBy: 'alby',
    ariaLive: 'alv',
    ariaModal: 'amod',
    ariaMultiSelectable: 'ams',
    ariaOrientation: 'aor',
    ariaOwns: 'aow',
    ariaPosInSet: 'apis',
    ariaPressed: 'aprs',
    ariaReadOnly: 'aro',
    ariaRelevant: 'arl',
    ariaRequired: 'areq',
    ariaSelected: 'asel',
    ariaSetSize: 'assz',
    ariaValueMax: 'avmx',
    ariaValueMin: 'avmn',
    ariaValueNow: 'avn',
    role: 'role',
    // ── Events: Lifecycle ──
    onInit: '@in',
    onRender: '@rn',
    onUpdate: '@up',
    onStateChange: '@sc',
    onStateUpdate: '@su',
    // ── Events: Mouse ──
    onClick: '@ck',
    onContextMenu: '@cm',
    onDblClick: '@dc',
    onMouseDown: '@md',
    onMouseEnter: '@me',
    onMouseLeave: '@ml',
    onMouseMove: '@mm',
    onMouseOut: '@mo',
    onMouseOver: '@mv',
    onMouseUp: '@mu',
    // ── Events: Keyboard ──
    onKeyDown: '@kd',
    onKeyPress: '@kp',
    onKeyUp: '@ku',
    // ── Events: Focus ──
    onBlur: '@bl',
    onFocus: '@fc',
    onFocusIn: '@fi',
    onFocusOut: '@fo',
    // ── Events: Form ──
    onBeforeInput: '@bi',
    onChange: '@cg',
    onFormData: '@fd',
    onInput: '@ip',
    onInvalid: '@iv',
    onReset: '@rs',
    onSearch: '@sr',
    onSelect: '@sl',
    onSubmit: '@sm',
    // ── Events: Touch ──
    onTouchCancel: '@tc',
    onTouchEnd: '@te',
    onTouchMove: '@tm',
    onTouchStart: '@ts',
    // ── Events: Pointer ──
    onPointerCancel: '@pc',
    onPointerDown: '@pd',
    onPointerEnter: '@pe',
    onPointerLeave: '@ple',
    onPointerMove: '@pm',
    onPointerOut: '@po',
    onPointerOver: '@pov',
    onPointerUp: '@pu',
    // ── Events: Drag ──
    onDrag: '@dg',
    onDragEnd: '@dge',
    onDragEnter: '@dgn',
    onDragLeave: '@dgl',
    onDragOver: '@dgo',
    onDragStart: '@dgs',
    onDrop: '@dp',
    // ── Events: Scroll / Resize ──
    onResize: '@rz',
    onScroll: '@scl',
    onWheel: '@wh',
    // ── Events: Clipboard ──
    onCopy: '@cy',
    onCut: '@ct',
    onPaste: '@pt',
    // ── Events: Composition ──
    onCompositionEnd: '@cpe',
    onCompositionStart: '@cps',
    onCompositionUpdate: '@cpu',
    // ── Events: Animation / Transition ──
    onAnimationEnd: '@ae',
    onAnimationIteration: '@ai',
    onAnimationStart: '@as',
    onTransitionEnd: '@tre',
    onTransitionStart: '@trs',
    // ── Events: Media ──
    onAbort: '@ab',
    onCanPlay: '@cap',
    onCanPlayThrough: '@cpt',
    onDurationChange: '@duc',
    onEmptied: '@em',
    onEncrypted: '@enc',
    onEnded: '@end',
    onError: '@er',
    onLoad: '@ld',
    onLoadedData: '@ldd',
    onLoadedMetadata: '@ldm',
    onPause: '@pa',
    onPlay: '@pl',
    onPlaying: '@plg',
    onProgress: '@prg',
    onRateChange: '@rc',
    onSeeked: '@sk',
    onSeeking: '@skg',
    onStalled: '@stl',
    onSuspend: '@ssp',
    onTimeUpdate: '@tu',
    onVolumeChange: '@vc',
    onWaiting: '@wt',
    // ── Special / Advanced ──
    icon: 'ico',
    iconText: 'ict',
    lookup: 'lkp',
    router: 'rtr',
    shapeModifier: 'shpm'
};
// Build the reverse map
const $03204a289031a296$export$606c1437693b4e99 = Object.create(null);
for(const prop in $03204a289031a296$export$312c961b6236cdd9)$03204a289031a296$export$606c1437693b4e99[$03204a289031a296$export$312c961b6236cdd9[prop]] = prop;
// Validate uniqueness at load time
const $03204a289031a296$var$seen = Object.create(null);
for(const prop in $03204a289031a296$export$312c961b6236cdd9){
    const abbr = $03204a289031a296$export$312c961b6236cdd9[prop];
    if ($03204a289031a296$var$seen[abbr]) throw new Error(`Duplicate abbreviation "${abbr}" for "${prop}" \u{2014} already used by "${$03204a289031a296$var$seen[abbr]}"`);
    $03204a289031a296$var$seen[abbr] = prop;
}
/**
 * Keys whose object values must NOT be recursively shortened/expanded.
 * These contain user-defined keys (state data, scope function names, etc.)
 * that would break if accidentally matched against the abbreviation registry.
 */ const $03204a289031a296$export$1f0e8d7ac46e80f0 = new Set([
    'state',
    'st',
    'scope',
    'scp',
    'attr',
    'at',
    'style',
    'sy',
    'data',
    'dt',
    'context',
    'ctx',
    'query',
    'qy',
    'class',
    'cl'
]);
const $03204a289031a296$export$ed735b84e3086c1d = new Set([
    'text',
    'tx',
    'html',
    'htm',
    'content',
    'cnt',
    'placeholder',
    'phd',
    'src',
    'href',
    'hrf'
]);
/**
 * Returns true if the key is a PascalCase component name (starts with uppercase).
 */ function $03204a289031a296$export$6c9f97f8b1b3890a(key) {
    return /^[A-Z]/.test(key);
}
/**
 * Returns true if the key is a CSS selector, media query, or case prefix.
 */ function $03204a289031a296$export$5b3d4710c3e6d4d9(key) {
    return /^[:@.!$>&]/.test(key) || key.startsWith('> ');
}

});


parcelRegister("erJi9", function(module, exports) {

$parcel$export(module.exports, "parseFurther", () => $a846b848fed32999$export$27bff3137ba4e8f5);

var $gDHpn = parcelRequire("gDHpn");
'use strict';
// ── Value encoding ──
/**
 * Escape a value for the further-inlined `in` string.
 *
 * Handles characters that conflict with the token format:
 *   \  →  \\    (literal backslash)
 *   _  →  \_    (literal underscore, since _ normally means space)
 *   ,  →  \,    (literal comma, since , normally means array separator)
 *   ' ' →  _    (space encoded as underscore)
 */ function $a846b848fed32999$var$escapeValue(val) {
    const str = String(val);
    return str.replace(/\\/g, '\\\\').replace(/_/g, '\\_').replace(/,/g, '\\,').replace(/ /g, '_');
}
/**
 * Unescape a value from the further-inlined `in` string.
 * Processes character-by-character to handle escape sequences.
 */ function $a846b848fed32999$var$unescapeValue(val) {
    let result = '';
    let i = 0;
    while(i < val.length){
        if (val[i] === '\\' && i + 1 < val.length) {
            const next = val[i + 1];
            if (next === ',' || next === '_' || next === '\\') {
                result += next;
                i += 2;
                continue;
            }
        }
        if (val[i] === '_') result += ' ';
        else result += val[i];
        i++;
    }
    return result;
}
/**
 * Split a string on commas that are NOT escaped with backslash.
 */ function $a846b848fed32999$var$splitOnUnescapedCommas(str) {
    const parts = [];
    let current = '';
    let i = 0;
    while(i < str.length){
        if (str[i] === '\\' && i + 1 < str.length) {
            current += str[i] + str[i + 1];
            i += 2;
            continue;
        }
        if (str[i] === ',') {
            parts.push(current);
            current = '';
            i++;
            continue;
        }
        current += str[i];
        i++;
    }
    parts.push(current);
    return parts;
}
// ── Encode ──
/**
 * Returns true if a recursed value can be collapsed from { in: '...' } to a bare string.
 */ function $a846b848fed32999$var$canCollapse(val) {
    if (val === null || val === undefined) return false;
    if (typeof val !== 'object' || Array.isArray(val)) return false;
    const keys = Object.keys(val);
    return keys.length === 1 && keys[0] === 'in' && typeof val.in === 'string';
}
function $a846b848fed32999$export$f13b3eb769d27b69(obj) {
    if (!obj || typeof obj !== 'object') return obj;
    if (Array.isArray(obj)) return obj.map(function(item) {
        if (item !== null && typeof item === 'object') return $a846b848fed32999$export$f13b3eb769d27b69(item);
        return item;
    });
    const result = {};
    const tokens = [];
    for(const key in obj){
        const val = obj[key];
        // PascalCase child → recurse, possibly collapse
        if ((0, $gDHpn.isComponentKey)(key)) {
            const child = $a846b848fed32999$var$stringifyFurtherVal(val);
            result[key] = $a846b848fed32999$var$canCollapse(child) ? child.in : child;
            continue;
        }
        // Selector/media/case → recurse, possibly collapse
        if ((0, $gDHpn.isSelectorKey)(key)) {
            const child = $a846b848fed32999$var$stringifyFurtherVal(val);
            result[key] = $a846b848fed32999$var$canCollapse(child) ? child.in : child;
            continue;
        }
        const shortKey = (0, $gDHpn.propToAbbr)[key] || key;
        // Preserved keys (state, scope, attr, style, etc.) → keep as-is
        if ((0, $gDHpn.PRESERVE_VALUE_KEYS).has(key) || (0, $gDHpn.PRESERVE_VALUE_KEYS).has(shortKey)) {
            result[shortKey] = val;
            continue;
        }
        // Functions → keep
        if (typeof val === 'function') {
            result[shortKey] = val;
            continue;
        }
        // null/undefined → keep
        if (val === null || val === undefined) {
            result[shortKey] = val;
            continue;
        }
        // Skip-inline keys (text, html, content, placeholder, src, href) → keep
        if ((0, $gDHpn.SKIP_INLINE_KEYS).has(key) || (0, $gDHpn.SKIP_INLINE_KEYS).has(shortKey)) {
            result[shortKey] = val;
            continue;
        }
        // Arrays
        if (Array.isArray(val)) {
            const hasObjects = val.some(function(item) {
                return item !== null && typeof item === 'object';
            });
            if (hasObjects) {
                result[shortKey] = val.map(function(item) {
                    if (item !== null && typeof item === 'object') return $a846b848fed32999$export$f13b3eb769d27b69(item);
                    return item;
                });
                continue;
            }
            // Single-element arrays can't round-trip (decoded as scalar)
            if (val.length <= 1) {
                result[shortKey] = val;
                continue;
            }
            tokens.push(shortKey + ':' + val.map($a846b848fed32999$var$escapeValue).join(','));
            continue;
        }
        // Objects → recurse
        if (typeof val === 'object') {
            result[shortKey] = $a846b848fed32999$export$f13b3eb769d27b69(val);
            continue;
        }
        // Booleans
        if (val === true) {
            tokens.push(shortKey);
            continue;
        }
        if (val === false) {
            tokens.push('!' + shortKey);
            continue;
        }
        // Numbers → inline with # prefix for lossless round-trip
        if (typeof val === 'number') {
            tokens.push(shortKey + ':#' + val);
            continue;
        }
        // Strings → inline with escape sequences
        tokens.push(shortKey + ':' + $a846b848fed32999$var$escapeValue(val));
    }
    if (tokens.length) result.in = tokens.join(' ');
    return result;
}
function $a846b848fed32999$var$stringifyFurtherVal(val) {
    if (val === null || val === undefined) return val;
    if (typeof val === 'function') return val;
    if (Array.isArray(val)) return val.map(function(item) {
        if (item !== null && typeof item === 'object') return $a846b848fed32999$export$f13b3eb769d27b69(item);
        return item;
    });
    if (typeof val === 'object') return $a846b848fed32999$export$f13b3eb769d27b69(val);
    return val;
}
// ── Decode ──
/**
 * Decode a single further-inline value.
 * Handles # prefix for numbers and escape sequences.
 * Only treats # as a number marker when followed by a strict decimal number
 * (avoids conflict with CSS hex colors like #1E2397).
 */ function $a846b848fed32999$var$decodeFurtherValue(val) {
    if (val.startsWith('#') && /^#-?\d+(\.\d+)?$/.test(val)) return Number(val.slice(1));
    return $a846b848fed32999$var$unescapeValue(val);
}
/**
 * Decode a further `in` string into key-value pairs with full property names.
 */ function $a846b848fed32999$var$decodeFurtherInline(str) {
    if (!str || typeof str !== 'string') return {};
    const obj = {};
    const tokens = str.trim().split(/\s+/).filter(Boolean);
    for (const token of tokens){
        if (token.startsWith('!')) {
            const abbr = token.slice(1);
            const prop = (0, $gDHpn.abbrToProp)[abbr] || abbr;
            obj[prop] = false;
            continue;
        }
        const colonIdx = token.indexOf(':');
        if (colonIdx === -1) {
            const prop = (0, $gDHpn.abbrToProp)[token] || token;
            obj[prop] = true;
            continue;
        }
        const abbr = token.slice(0, colonIdx);
        const rawVal = token.slice(colonIdx + 1);
        const prop = (0, $gDHpn.abbrToProp)[abbr] || abbr;
        const parts = $a846b848fed32999$var$splitOnUnescapedCommas(rawVal);
        if (parts.length > 1) {
            obj[prop] = parts.map($a846b848fed32999$var$decodeFurtherValue);
            continue;
        }
        obj[prop] = $a846b848fed32999$var$decodeFurtherValue(rawVal);
    }
    return obj;
}
function $a846b848fed32999$export$27bff3137ba4e8f5(obj) {
    if (!obj || typeof obj !== 'object') return obj;
    if (Array.isArray(obj)) return obj.map(function(item) {
        if (item !== null && typeof item === 'object') return $a846b848fed32999$export$27bff3137ba4e8f5(item);
        return item;
    });
    const result = {};
    // Decode `in` string first so its props come first
    if (typeof obj.in === 'string') {
        const decoded = $a846b848fed32999$var$decodeFurtherInline(obj.in);
        for(const prop in decoded)result[prop] = decoded[prop];
    }
    for(const key in obj){
        if (key === 'in') continue;
        const val = obj[key];
        // PascalCase child
        if ((0, $gDHpn.isComponentKey)(key)) {
            if (typeof val === 'string') result[key] = $a846b848fed32999$var$decodeFurtherInline(val);
            else result[key] = $a846b848fed32999$var$parseFurtherVal(val);
            continue;
        }
        // Resolve abbreviation
        const fullKey = (0, $gDHpn.abbrToProp)[key] || key;
        // Selector/media/case key (NOT an event abbreviation)
        if ((0, $gDHpn.isSelectorKey)(key) && fullKey === key) {
            if (typeof val === 'string') result[key] = $a846b848fed32999$var$decodeFurtherInline(val);
            else result[key] = $a846b848fed32999$var$parseFurtherVal(val);
            continue;
        }
        // Preserved keys (state, scope, etc.) → keep value as-is
        if ((0, $gDHpn.PRESERVE_VALUE_KEYS).has(fullKey) || (0, $gDHpn.PRESERVE_VALUE_KEYS).has(key)) {
            result[fullKey] = val;
            continue;
        }
        result[fullKey] = $a846b848fed32999$var$parseFurtherVal(val);
    }
    return result;
}
function $a846b848fed32999$var$parseFurtherVal(val) {
    if (val === null || val === undefined) return val;
    if (typeof val === 'function') return val;
    if (Array.isArray(val)) return val.map(function(item) {
        if (item !== null && typeof item === 'object') return $a846b848fed32999$export$27bff3137ba4e8f5(item);
        return item;
    });
    if (typeof val === 'object') return $a846b848fed32999$export$27bff3137ba4e8f5(val);
    return val;
}

});


parcelRegister("llcnc", function(module, exports) {
$parcel$export(module.exports, "analyzePlugin", () => (parcelRequire("aNrRl")).analyzePlugin);
$parcel$export(module.exports, "createAnalyzeState", () => (parcelRequire("2Bw3N")).createAnalyzeState);
parcelRequire("1k6zV");

var $aNrRl = parcelRequire("aNrRl");
'use strict';

});
parcelRegister("1k6zV", function(module, exports) {

$parcel$export(module.exports, "analyzePlugin", () => (parcelRequire("aNrRl")).analyzePlugin);
$parcel$export(module.exports, "createAnalyzeState", () => (parcelRequire("2Bw3N")).createAnalyzeState);

var $aNrRl = parcelRequire("aNrRl");

var $2Bw3N = parcelRequire("2Bw3N");

var $jkaj0 = parcelRequire("jkaj0");

var $hdUfh = parcelRequire("hdUfh");

var $1hhcm = parcelRequire("1hhcm");

var $cR6tk = parcelRequire("cR6tk");

var $8Gb2U = parcelRequire("8Gb2U");

var $kxqek = parcelRequire("kxqek");

var $5g5qm = parcelRequire("5g5qm");
'use strict';

});
parcelRegister("aNrRl", function(module, exports) {

$parcel$export(module.exports, "analyzePlugin", () => $7dc41747fff72a29$export$65b03b22c0c0d80);

var $jkaj0 = parcelRequire("jkaj0");
'use strict';
const $7dc41747fff72a29$var$getState = (element)=>element?.context?.analyze;
// Map of lifecycle hook → { category, type, level } for the simple "tap-and-emit"
// hooks. The error and stateful hooks below are special-cased.
const $7dc41747fff72a29$var$LIFECYCLE_TAPS = {
    init: {
        category: 'lifecycle',
        type: 'lifecycle',
        level: 'debug'
    },
    create: {
        category: 'lifecycle',
        type: 'lifecycle',
        level: 'debug'
    },
    render: {
        category: 'lifecycle',
        type: 'lifecycle',
        level: 'debug'
    },
    beforeRemove: {
        category: 'lifecycle',
        type: 'lifecycle',
        level: 'debug'
    },
    remove: {
        category: 'lifecycle',
        type: 'lifecycle',
        level: 'debug'
    }
};
const $7dc41747fff72a29$var$makeTap = (hook, { category: category, type: type, level: level })=>(element)=>{
        const state = $7dc41747fff72a29$var$getState(element);
        if (!state || !state.shouldCapture(category)) return;
        state.emit((0, $jkaj0.makeEvent)(type, level, {
            hook: hook,
            element: (0, $jkaj0.summarizeElement)(element)
        }));
    };
const $7dc41747fff72a29$var$stateTap = (hook)=>(element, options)=>{
        const state = $7dc41747fff72a29$var$getState(element);
        if (!state || !state.shouldCapture('state')) return;
        state.emit((0, $jkaj0.makeEvent)('state', 'debug', {
            hook: hook,
            element: (0, $jkaj0.summarizeElement)(element),
            changedKeys: options?.changedKeys || null
        }));
    };
const $7dc41747fff72a29$export$65b03b22c0c0d80 = {
    name: 'analyze',
    // Routed from triggerLifecycle('error') — covers lifecycle handler throws
    // and explicit el.error() calls.
    error (element, options) {
        const state = $7dc41747fff72a29$var$getState(element);
        if (!state || state.config.enabled === false) return;
        if (!state.shouldCapture('errors')) return;
        const err = options?.error || options?.err || (options instanceof Error ? options : null);
        state.emit((0, $jkaj0.makeEvent)('error', 'error', {
            hook: options?.hook || 'error',
            element: (0, $jkaj0.summarizeElement)(element),
            error: err,
            message: err?.message || (typeof options?.message === 'string' ? options.message : null)
        }));
    },
    renderRouter (element) {
        const state = $7dc41747fff72a29$var$getState(element);
        if (!state) return;
        if (!state.shouldCapture('navigation') && !state.shouldCapture('lifecycle')) return;
        state.emit((0, $jkaj0.makeEvent)('navigation', 'info', {
            hook: 'renderRouter',
            route: element.context?.routerOptions?.currentRoute || null
        }));
    },
    beforeUpdate (element) {
        const state = $7dc41747fff72a29$var$getState(element);
        if (!state || !state.shouldCapture('updates')) return;
        if (element.__ref) element.__ref.__analyzeUpdateStart = typeof performance !== 'undefined' ? performance.now() : Date.now();
    },
    update (element) {
        const state = $7dc41747fff72a29$var$getState(element);
        if (!state || !state.shouldCapture('updates')) return;
        let durationMs = null;
        if (element.__ref?.__analyzeUpdateStart != null) {
            const now = typeof performance !== 'undefined' ? performance.now() : Date.now();
            durationMs = now - element.__ref.__analyzeUpdateStart;
            element.__ref.__analyzeUpdateStart = null;
        }
        state.emit((0, $jkaj0.makeEvent)('update', 'debug', {
            hook: 'update',
            element: (0, $jkaj0.summarizeElement)(element),
            durationMs: durationMs
        }));
    },
    beforeStateUpdate: $7dc41747fff72a29$var$stateTap('beforeStateUpdate'),
    stateUpdate: $7dc41747fff72a29$var$stateTap('stateUpdate')
};
for (const [hook, cfg] of Object.entries($7dc41747fff72a29$var$LIFECYCLE_TAPS))$7dc41747fff72a29$export$65b03b22c0c0d80[hook] = $7dc41747fff72a29$var$makeTap(hook, cfg);

});
parcelRegister("jkaj0", function(module, exports) {

$parcel$export(module.exports, "makeEvent", () => $e117e109e0222be8$export$2f7b310570bee07a);
$parcel$export(module.exports, "summarizeElement", () => $e117e109e0222be8$export$d997b4c8227425c);
'use strict';
let $e117e109e0222be8$var$_id = 0;
const $e117e109e0222be8$var$nextId = ()=>`${Date.now().toString(36)}-${($e117e109e0222be8$var$_id++).toString(36)}`;
const $e117e109e0222be8$export$2f7b310570bee07a = (type, level, data = {})=>{
    return {
        id: $e117e109e0222be8$var$nextId(),
        ts: Date.now(),
        type: type,
        level: level,
        ...data
    };
};
const $e117e109e0222be8$var$safeKeyPath = (element)=>{
    const path = [];
    let el = element;
    let depth = 0;
    while(el && depth < 32){
        if (el.key != null) path.unshift(String(el.key));
        el = el.parent;
        depth++;
    }
    return path.join(' > ');
};
const $e117e109e0222be8$export$d997b4c8227425c = (element)=>{
    if (!element) return null;
    return {
        key: element.key != null ? String(element.key) : null,
        name: element.__name || element.name || null,
        path: $e117e109e0222be8$var$safeKeyPath(element),
        tag: element.tag || null,
        component: element.component || null,
        route: element.context?.routerOptions?.currentRoute || null
    };
};

});


parcelRegister("2Bw3N", function(module, exports) {

$parcel$export(module.exports, "createAnalyzeState", () => $1e57e7f7100808d5$export$64b3291aa8b05fac);
parcelRequire("2oe0q");
var $erBZm = parcelRequire("erBZm");

var $hdUfh = parcelRequire("hdUfh");

var $1hhcm = parcelRequire("1hhcm");

var $8Gb2U = parcelRequire("8Gb2U");

var $kxqek = parcelRequire("kxqek");

var $5g5qm = parcelRequire("5g5qm");
'use strict';
const $1e57e7f7100808d5$var$DEFAULT_CAPTURE = {
    errors: true,
    warnings: true,
    pointer: false,
    keyboard: false,
    forms: false,
    scroll: false,
    viewport: false,
    network: false,
    performance: false,
    navigation: false,
    console: false,
    lifecycle: false,
    state: false,
    updates: false,
    replay: false,
    telemetry: false
};
const $1e57e7f7100808d5$var$REPLAY_CAPTURE = {
    errors: true,
    warnings: true,
    pointer: true,
    keyboard: true,
    forms: true,
    scroll: true,
    viewport: true,
    navigation: true,
    state: true
};
const $1e57e7f7100808d5$var$TELEMETRY_CAPTURE = {
    errors: true,
    warnings: true,
    pointer: true,
    navigation: true,
    performance: true,
    viewport: true
};
const $1e57e7f7100808d5$var$expandPresets = (capture)=>{
    const out = {
        ...$1e57e7f7100808d5$var$DEFAULT_CAPTURE,
        ...capture
    };
    if (out.replay) Object.assign(out, $1e57e7f7100808d5$var$REPLAY_CAPTURE);
    if (out.telemetry) Object.assign(out, $1e57e7f7100808d5$var$TELEMETRY_CAPTURE);
    return out;
};
const $1e57e7f7100808d5$var$PRE_BUFFER_MAX = 64;
/**
 * Read ?analyze=<level> from URL and apply as level/debug override.
 */ const $1e57e7f7100808d5$var$readUrlOverride = ()=>{
    if (typeof (0, $erBZm.window) === 'undefined' || !(0, $erBZm.window).location) return null;
    try {
        const params = new URLSearchParams((0, $erBZm.window).location.search);
        const v = params.get('analyze');
        if (!v) return null;
        return v;
    } catch (_) {
        return null;
    }
};
const $1e57e7f7100808d5$export$64b3291aa8b05fac = (rawConfig = {})=>{
    const config = rawConfig === true ? {} : {
        ...rawConfig
    };
    config.capture = $1e57e7f7100808d5$var$expandPresets(config.capture || {});
    // URL override: ?analyze=debug → level=debug + debug=true
    const urlOverride = $1e57e7f7100808d5$var$readUrlOverride();
    if (urlOverride === 'debug' || config.debug) {
        config.level = 'debug';
        config.debug = true;
        // Debug expands to most categories on
        config.capture = {
            ...config.capture,
            lifecycle: true,
            state: true,
            updates: true,
            console: true
        };
    }
    if (urlOverride === 'off') config.enabled = false;
    config.level = (0, $hdUfh.normalizeLevel)(config.level || 'warn');
    config.cache = {
        max: 500,
        dedupeWindowMs: 1000,
        ...config.cache || {}
    };
    config.throttle = {
        pointermove: 80,
        mousemove: 80,
        scroll: 100,
        resize: 200,
        ...config.throttle || {}
    };
    if (config.maskFormValues == null) config.maskFormValues = true;
    if (!config.maskStrategy) config.maskStrategy = 'mask';
    // Default sink list — memory is always installed so context.analyze.query()
    // works out of the box for cached errors. Opt out via `sinks: ['console']`
    // explicitly excluding memory.
    if (!Array.isArray(config.sinks)) config.sinks = [
        'console',
        'memory'
    ];
    if (!Array.isArray(config.transformers)) config.transformers = [
        'enrich',
        'summarize'
    ];
    const state = {
        config: config,
        context: null,
        __ready: false,
        __paused: false,
        __preBuffer: [],
        __teardown: [],
        __pipeline: null,
        __sinks: null,
        __memory: null,
        __initialSnapshot: null
    };
    // Pipeline + sinks are lazy: not built until the first event flows through.
    // Saves work when `?analyze=off` or `enabled: false` is set — the state
    // object is constructed during prepareContext but never actually emits.
    const ensureRuntime = ()=>{
        if (state.__pipeline) return;
        state.__pipeline = (0, $1hhcm.createPipeline)(state);
        state.__sinks = (0, $8Gb2U.resolveSinks)(state);
    };
    state.shouldCapture = (category)=>{
        if (state.config.enabled === false) return false;
        return !!state.config.capture[category];
    };
    state.emit = (event)=>{
        if (!event) return;
        if (state.config.enabled === false) return;
        if (state.__paused) return;
        if (!(0, $hdUfh.meetsLevel)(event.level, state.config.level)) return;
        if (!state.__ready) {
            // Pre-ready: only buffer error-level events. Drop the rest.
            if (event.level !== 'error' && !state.config.captureDuringHydration) return;
            if (state.__preBuffer.length < $1e57e7f7100808d5$var$PRE_BUFFER_MAX) state.__preBuffer.push(event);
            return;
        }
        ensureRuntime();
        $1e57e7f7100808d5$var$deliver(state, event);
    };
    state.activate = (context)=>{
        if (state.context == null) state.context = context || null;
        if (state.__ready) return;
        state.__ready = true;
        // Drain pre-ready buffer
        const buf = state.__preBuffer;
        state.__preBuffer = [];
        if (buf.length) {
            ensureRuntime();
            for (const ev of buf)$1e57e7f7100808d5$var$deliver(state, ev);
        }
        // Attach browser-level event listeners and network interception.
        // Each is internally guarded by its own capture flag.
        try {
            (0, $kxqek.attachBrowserListeners)(state);
        } catch (e) {
            console.error('[analyze] browser attach error:', e);
        }
        try {
            (0, $5g5qm.attachNetworkListeners)(state);
        } catch (e) {
            console.error('[analyze] network attach error:', e);
        }
        // Notify external subscribers
        for (const fn of state.__onActivate || [])try {
            fn(state);
        } catch (e) {
            console.error('[analyze] onActivate error:', e);
        }
    };
    state.pause = ()=>{
        state.__paused = true;
    };
    state.resume = ()=>{
        state.__paused = false;
    };
    state.setLevel = (level)=>{
        state.config.level = (0, $hdUfh.normalizeLevel)(level);
    };
    state.setCapture = (category, enabled)=>{
        state.config.capture[category] = !!enabled;
    };
    state.query = (filter)=>state.__memory ? state.__memory.query(filter) : [];
    state.snapshot = ()=>state.__memory ? state.__memory.snapshot() : [];
    /**
   * Helper for plugin chaining (e.g. @symbo.ls/fetch).
   * Builds a network event without the caller having to import event.js.
   * No-op when network capture is disabled — cheap call when analyze is off.
   */ state.emitNetwork = (data)=>{
        if (!state.shouldCapture('network')) return;
        const phase = data?.phase;
        const level = phase === 'error' ? 'error' : phase === 'success' && data.ok === false ? 'warn' : 'info';
        state.emit({
            id: `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 6)}`,
            ts: Date.now(),
            type: 'network',
            level: level,
            hook: `fetch.${phase || 'unknown'}`,
            ...data
        });
    };
    state.flush = ()=>{
        if (!state.__sinks) return;
        for (const sink of state.__sinks)if (typeof sink.flush === 'function') sink.flush();
    };
    state.replay = ()=>{
        return {
            initialSnapshot: state.__initialSnapshot,
            events: state.snapshot()
        };
    };
    state.destroy = ()=>{
        for (const fn of state.__teardown)try {
            fn();
        } catch (_) {}
        state.__teardown = [];
        state.__ready = false;
        state.__paused = true;
    };
    state.__onActivate = [];
    state.onActivate = (fn)=>{
        state.__onActivate.push(fn);
    };
    return state;
};
const $1e57e7f7100808d5$var$deliver = (state, event)=>{
    const out = state.__pipeline(event);
    if (out == null) return;
    const list = Array.isArray(out) ? out : [
        out
    ];
    for (const ev of list){
        if (typeof state.config.onEvent === 'function') try {
            state.config.onEvent(ev);
        } catch (_) {}
        for (const sink of state.__sinks)try {
            sink(ev);
        } catch (e) {
            console.error('[analyze] sink error:', e);
        }
    }
};

});
parcelRegister("hdUfh", function(module, exports) {

$parcel$export(module.exports, "meetsLevel", () => $c89f47b87963c028$export$4363cb978945f701);
$parcel$export(module.exports, "normalizeLevel", () => $c89f47b87963c028$export$c321aca3a5b2a397);
'use strict';
const $c89f47b87963c028$export$834c2ad6e999b78f = {
    error: 0,
    warn: 1,
    info: 2,
    debug: 3,
    trace: 4
};
const $c89f47b87963c028$export$d42500118831797d = [
    'error',
    'warn',
    'info',
    'debug',
    'trace'
];
const $c89f47b87963c028$export$4363cb978945f701 = (eventLevel, configLevel)=>{
    const e = $c89f47b87963c028$export$834c2ad6e999b78f[eventLevel];
    const c = $c89f47b87963c028$export$834c2ad6e999b78f[configLevel];
    if (e == null || c == null) return true;
    return e <= c;
};
const $c89f47b87963c028$export$c321aca3a5b2a397 = (level)=>{
    return $c89f47b87963c028$export$834c2ad6e999b78f[level] != null ? level : 'warn';
};

});

parcelRegister("1hhcm", function(module, exports) {

$parcel$export(module.exports, "createPipeline", () => $0ee4b83ba4a9031c$export$4f1c956984599798);
parcelRequire("2oe0q");
var $erBZm = parcelRequire("erBZm");

var $cR6tk = parcelRequire("cR6tk");
'use strict';
const $0ee4b83ba4a9031c$export$2c4c34ec006c735a = (state)=>{
    const session = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
    const ua = typeof navigator !== 'undefined' ? navigator.userAgent : null;
    const buildHash = state.config.buildHash || null;
    const appId = state.config.appId || null;
    return (event)=>{
        if (!event) return event;
        const route = state.context?.routerOptions?.currentRoute || null;
        const win = (0, $erBZm.window);
        const viewport = win && win.innerWidth ? {
            w: win.innerWidth,
            h: win.innerHeight
        } : null;
        return {
            ...event,
            session: session,
            app: {
                id: appId,
                build: buildHash,
                route: route
            },
            meta: {
                ua: ua,
                viewport: viewport
            }
        };
    };
};
const $0ee4b83ba4a9031c$export$1f33c5e666a5fc46 = ()=>{
    return (event)=>{
        if (!event) return event;
        if (event.element && typeof event.element === 'object') {
            const el = event.element;
            if (el.node || el.parent || el.__ref) event = {
                ...event,
                element: {
                    key: el.key != null ? String(el.key) : null,
                    name: el.__name || el.name || null,
                    tag: el.tag || null,
                    component: el.component || null
                }
            };
        }
        if (event.error instanceof Error) event = {
            ...event,
            error: {
                name: event.error.name,
                message: event.error.message,
                stack: event.error.stack
            }
        };
        return event;
    };
};
const $0ee4b83ba4a9031c$export$557372cf05b38475 = (windowMs = 1000, max = 500)=>{
    const seen = new Map();
    return (event)=>{
        if (!event) return event;
        const key = `${event.type}:${event.level}:${event.message || ''}:${event.error?.message || ''}`;
        const last = seen.get(key);
        const now = event.ts || Date.now();
        if (last && now - last < windowMs) return null;
        seen.set(key, now);
        // Bounded eviction: when full, drop oldest 10% of entries (insertion order).
        if (seen.size > max) {
            const drop = Math.ceil(max / 10);
            let i = 0;
            for (const k of seen.keys()){
                if (i++ >= drop) break;
                seen.delete(k);
            }
        }
        return event;
    };
};
const $0ee4b83ba4a9031c$export$5465d4b043904462 = (rates)=>{
    return (event)=>{
        if (!event) return event;
        const rate = rates[event.type];
        if (rate == null || rate >= 1) return event;
        if (Math.random() > rate) return null;
        return event;
    };
};
const $0ee4b83ba4a9031c$var$BUILTINS = {
    redact: (state)=>(0, $cR6tk.createRedact)(state.config.redact || [], state.config.maskStrategy),
    enrich: (state)=>$0ee4b83ba4a9031c$export$2c4c34ec006c735a(state),
    summarize: ()=>$0ee4b83ba4a9031c$export$1f33c5e666a5fc46(),
    dedupe: (state)=>$0ee4b83ba4a9031c$export$557372cf05b38475(state.config.cache?.dedupeWindowMs || 1000),
    sample: (state)=>$0ee4b83ba4a9031c$export$5465d4b043904462(state.config.sample || {})
};
/**
 * Resolve a transformer entry to a function.
 * Strings → built-in factories. Functions → passthrough. Anything else → null.
 */ const $0ee4b83ba4a9031c$var$resolveTransformer = (entry, state)=>{
    if (typeof entry === 'function') return entry;
    if (typeof entry === 'string') {
        const factory = $0ee4b83ba4a9031c$var$BUILTINS[entry];
        return factory ? factory(state) : null;
    }
    return null;
};
const $0ee4b83ba4a9031c$export$4f1c956984599798 = (state)=>{
    const cfg = state.config;
    const userList = Array.isArray(cfg.transformers) ? cfg.transformers.slice() : [];
    // Pull out any user reference to redact and put it first.
    const userRedactIdx = userList.findIndex((t)=>t === 'redact');
    if (userRedactIdx >= 0) userList.splice(userRedactIdx, 1);
    const list = [];
    if (cfg.redact !== false) list.push($0ee4b83ba4a9031c$var$BUILTINS.redact(state));
    for (const entry of userList){
        const fn = $0ee4b83ba4a9031c$var$resolveTransformer(entry, state);
        if (fn) list.push(fn);
    }
    return (event)=>{
        let current = event;
        for (const fn of list){
            if (current == null) return null;
            const out = fn(current);
            if (out == null) return null;
            if (Array.isArray(out)) {
                // Fan-out: re-run remaining transformers per-item, flatten.
                const remaining = list.slice(list.indexOf(fn) + 1);
                const results = [];
                for (const item of out){
                    let cur = item;
                    let dropped = false;
                    for (const next of remaining){
                        cur = next(cur);
                        if (cur == null) {
                            dropped = true;
                            break;
                        }
                    }
                    if (!dropped && cur != null) results.push(cur);
                }
                return results;
            }
            current = out;
        }
        return current;
    };
};

});
parcelRegister("cR6tk", function(module, exports) {

$parcel$export(module.exports, "SENSITIVE_NAME_RE", () => $95bf747899938d4c$export$f6173f2add9eca7c);
$parcel$export(module.exports, "createRedact", () => $95bf747899938d4c$export$a3cfe66c000f2134);
'use strict';
const $95bf747899938d4c$export$f6173f2add9eca7c = /password|token|secret|ssn|card|cvv|pin|apikey|api_key|auth|email|otp/i;
const $95bf747899938d4c$var$MAX_DEPTH = 6;
const $95bf747899938d4c$var$matchPattern = (key, patterns)=>{
    for (const p of patterns){
        if (p instanceof RegExp) {
            if (p.test(key)) return true;
        } else if (typeof p === 'string') {
            if (key.toLowerCase().includes(p.toLowerCase())) return true;
        }
    }
    return false;
};
const $95bf747899938d4c$var$maskValue = (val, strategy)=>{
    if (strategy === 'redact') return undefined;
    if (strategy === 'hash') {
        let h = 0;
        const s = String(val);
        for(let i = 0; i < s.length; i++)h = (h << 5) - h + s.charCodeAt(i) | 0;
        return `#${(h >>> 0).toString(36)}`;
    }
    return '***';
};
const $95bf747899938d4c$var$walk = (val, patterns, strategy, depth)=>{
    if (depth > $95bf747899938d4c$var$MAX_DEPTH) return val;
    if (val == null) return val;
    if (typeof val !== 'object') return val;
    if (Array.isArray(val)) return val.map((v)=>$95bf747899938d4c$var$walk(v, patterns, strategy, depth + 1));
    const out = {};
    for (const k of Object.keys(val)){
        const isSensitive = $95bf747899938d4c$var$matchPattern(k, patterns) || $95bf747899938d4c$export$f6173f2add9eca7c.test(k);
        if (isSensitive) {
            const masked = $95bf747899938d4c$var$maskValue(val[k], strategy);
            if (masked !== undefined) out[k] = masked;
        } else out[k] = $95bf747899938d4c$var$walk(val[k], patterns, strategy, depth + 1);
    }
    return out;
};
const $95bf747899938d4c$export$a3cfe66c000f2134 = (patterns = [], strategy = 'mask')=>{
    const list = Array.isArray(patterns) ? patterns : [
        patterns
    ];
    return (event)=>{
        if (!event) return event;
        const { id: id, ts: ts, type: type, level: level, hook: hook, error: error, message: message, durationMs: durationMs, element: element, target: target, ...rest } = event;
        const cleaned = $95bf747899938d4c$var$walk(rest, list, strategy, 0);
        return {
            id: id,
            ts: ts,
            type: type,
            level: level,
            hook: hook,
            error: error,
            message: message,
            durationMs: durationMs,
            element: element,
            target: target,
            ...cleaned
        };
    };
};

});


parcelRegister("8Gb2U", function(module, exports) {

$parcel$export(module.exports, "resolveSinks", () => $651ad07a94024b9d$export$bf3a65adc5a2fd08);
parcelRequire("2oe0q");
var $erBZm = parcelRequire("erBZm");
'use strict';
const $651ad07a94024b9d$var$COLORS = {
    error: '[31m',
    warn: '[33m',
    info: '[36m',
    debug: '[90m',
    trace: '[90m'
};
const $651ad07a94024b9d$var$RESET = '[0m';
const $651ad07a94024b9d$var$inBrowser = typeof (0, $erBZm.window) !== 'undefined' && typeof (0, $erBZm.window).document !== 'undefined';
const $651ad07a94024b9d$export$5c6be558c03a29e5 = (opts = {})=>{
    const minLevel = opts.minLevel || null;
    // Capture originals at construction time so the sink doesn't loop when the
    // browser-listener path patches console.* for `console: true` capture.
    // Sinks are built during createAnalyzeState() — well before activate()
    // installs the proxy — so these refs are guaranteed to be the real ones.
    const _error = console.error.bind(console);
    const _warn = console.warn.bind(console);
    const _log = console.log.bind(console);
    return (event)=>{
        if (!event) return;
        const fn = event.level === 'error' ? _error : event.level === 'warn' ? _warn : _log;
        const tag = `[analyze:${event.type}]`;
        if ($651ad07a94024b9d$var$inBrowser) fn(tag, event);
        else {
            const color = $651ad07a94024b9d$var$COLORS[event.level] || '';
            fn(`${color}${tag}${$651ad07a94024b9d$var$RESET}`, event);
        }
    };
};
const $651ad07a94024b9d$export$d3ccd521f897c931 = (state, opts = {})=>{
    const max = opts.max || state.config.cache?.max || 500;
    const buf = new Array(max);
    let head = 0;
    let len = 0;
    const push = (event)=>{
        buf[head] = event;
        head = (head + 1) % max;
        if (len < max) len++;
    };
    state.__memory = {
        push: push,
        snapshot: ()=>{
            const out = new Array(len);
            const start = (head - len + max) % max;
            for(let i = 0; i < len; i++)out[i] = buf[(start + i) % max];
            return out;
        },
        query: (filter = {})=>{
            const all = state.__memory.snapshot();
            const sinceMs = filter.sinceMs ? Date.now() - filter.sinceMs : 0;
            return all.filter((ev)=>{
                if (!ev) return false;
                if (filter.level && ev.level !== filter.level) return false;
                if (filter.type && ev.type !== filter.type) return false;
                if (sinceMs && ev.ts < sinceMs) return false;
                return true;
            });
        },
        clear: ()=>{
            head = 0;
            len = 0;
        }
    };
    return push;
};
const $651ad07a94024b9d$export$eec1893444946817 = (opts = {})=>{
    const url = opts.url;
    const batchMs = opts.batchMs != null ? opts.batchMs : 5000;
    const maxBatch = opts.maxBatch || 50;
    if (!url) return ()=>{};
    let queue = [];
    let timer = null;
    const send = ()=>{
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        if (!queue.length) return;
        const payload = JSON.stringify({
            events: queue
        });
        queue = [];
        const blob = $651ad07a94024b9d$var$inBrowser ? new (0, $erBZm.window).Blob([
            payload
        ], {
            type: 'application/json'
        }) : payload;
        if ($651ad07a94024b9d$var$inBrowser && navigator.sendBeacon) try {
            navigator.sendBeacon(url, blob);
            return;
        } catch (_) {}
        if (typeof fetch !== 'undefined') // best-effort; explicitly mark so analyze's own fetch wrapper can ignore us
        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Analyze-Beacon': '1'
            },
            body: payload,
            keepalive: true
        }).catch(()=>{});
    };
    if ($651ad07a94024b9d$var$inBrowser) {
        (0, $erBZm.window).addEventListener('pagehide', send, {
            passive: true
        });
        (0, $erBZm.window).addEventListener('beforeunload', send, {
            passive: true
        });
    }
    const push = (event)=>{
        if (!event) return;
        queue.push(event);
        if (queue.length >= maxBatch) send();
        else if (!timer) timer = setTimeout(send, batchMs);
    };
    push.flush = send;
    return push;
};
const $651ad07a94024b9d$var$BUILTINS = {
    console: $651ad07a94024b9d$export$5c6be558c03a29e5,
    memory: $651ad07a94024b9d$export$d3ccd521f897c931,
    beacon: $651ad07a94024b9d$export$eec1893444946817
};
const $651ad07a94024b9d$export$bf3a65adc5a2fd08 = (state)=>{
    const list = Array.isArray(state.config.sinks) ? state.config.sinks : [
        'console'
    ];
    const out = [];
    for (const entry of list){
        if (typeof entry === 'function') out.push(entry);
        else if (typeof entry === 'string') {
            const factory = $651ad07a94024b9d$var$BUILTINS[entry];
            if (!factory) continue;
            out.push(entry === 'memory' ? factory(state, {}) : factory({}));
        } else if (entry && typeof entry === 'object' && entry.type) {
            const factory = $651ad07a94024b9d$var$BUILTINS[entry.type];
            if (!factory) continue;
            out.push(entry.type === 'memory' ? factory(state, entry) : factory(entry));
        }
    }
    return out;
};

});

parcelRegister("kxqek", function(module, exports) {

$parcel$export(module.exports, "attachBrowserListeners", () => $ef3b3c75d6cf3f86$export$979193b008bd28b6);
parcelRequire("2oe0q");
var $aQqva = parcelRequire("aQqva");
var $erBZm = parcelRequire("erBZm");

var $jkaj0 = parcelRequire("jkaj0");

var $cR6tk = parcelRequire("cR6tk");
'use strict';
const $ef3b3c75d6cf3f86$var$inBrowser = typeof (0, $erBZm.window) !== 'undefined' && typeof (0, $erBZm.window).document !== 'undefined';
const $ef3b3c75d6cf3f86$var$SENSITIVE_INPUT_TYPES = new Set([
    'password',
    'hidden'
]);
const $ef3b3c75d6cf3f86$var$throttle = (fn, ms)=>{
    let last = 0;
    let timer = null;
    let pending = null;
    return (...args)=>{
        const now = Date.now();
        if (now - last >= ms) {
            last = now;
            fn(...args);
        } else {
            pending = args;
            if (!timer) timer = setTimeout(()=>{
                last = Date.now();
                timer = null;
                if (pending) {
                    fn(...pending);
                    pending = null;
                }
            }, ms - (now - last));
        }
    };
};
// data-key attributes are stable for the life of a DOMQL element, so the
// computed key path can be memoized on the node itself.
const $ef3b3c75d6cf3f86$var$KEY_PATH_CACHE = '__analyzeKeyPath';
const $ef3b3c75d6cf3f86$var$targetFromDomEvent = (e)=>{
    const node = e.target;
    if (!node) return {
        selector: null,
        key: null,
        path: null
    };
    if (node[$ef3b3c75d6cf3f86$var$KEY_PATH_CACHE]) return node[$ef3b3c75d6cf3f86$var$KEY_PATH_CACHE];
    const path = [];
    let cur = node;
    let depth = 0;
    let leafKey = null;
    while(cur && depth < 64){
        if (cur.getAttribute) {
            const k = cur.getAttribute('data-key');
            if (k) {
                if (leafKey == null) leafKey = k;
                path.unshift(k);
            }
        }
        cur = cur.parentNode;
        depth++;
    }
    let result;
    if (path.length) result = {
        selector: null,
        key: leafKey,
        path: path.join(' > '),
        tag: node.tagName?.toLowerCase() || null
    };
    else {
        const tag = (node.tagName || 'unknown').toLowerCase();
        const id = node.id ? `#${node.id}` : '';
        const cls = node.className && typeof node.className === 'string' ? '.' + node.className.trim().split(/\s+/).slice(0, 2).join('.') : '';
        result = {
            selector: `${tag}${id}${cls}`,
            key: null,
            path: null
        };
    }
    try {
        node[$ef3b3c75d6cf3f86$var$KEY_PATH_CACHE] = result;
    } catch (_) {}
    return result;
};
const $ef3b3c75d6cf3f86$var$maskFormValue = (input, strategy)=>{
    if (strategy === 'mask') return '***';
    if (strategy === 'redact') return undefined;
    if (strategy === 'hash') {
        let h = 0;
        const s = String(input || '');
        for(let i = 0; i < s.length; i++)h = (h << 5) - h + s.charCodeAt(i) | 0;
        return `#${(h >>> 0).toString(36)}`;
    }
    return '***';
};
const $ef3b3c75d6cf3f86$var$isSensitiveField = (node)=>{
    if (!node) return true;
    if (node.tagName === 'INPUT' && $ef3b3c75d6cf3f86$var$SENSITIVE_INPUT_TYPES.has(node.type)) return true;
    if ((0, $cR6tk.SENSITIVE_NAME_RE).test(node.name || '')) return true;
    if ((0, $cR6tk.SENSITIVE_NAME_RE).test(node.id || '')) return true;
    if (node.dataset?.analyze === 'skip') return true;
    return false;
};
const $ef3b3c75d6cf3f86$export$979193b008bd28b6 = (state)=>{
    if (!$ef3b3c75d6cf3f86$var$inBrowser) return;
    const cap = state.config.capture;
    const throttles = state.config.throttle;
    const teardown = state.__teardown;
    const on = (target, type, handler, opts)=>{
        target.addEventListener(type, handler, opts);
        teardown.push(()=>target.removeEventListener(type, handler, opts));
    };
    // Errors — always-on if 'errors' capture is on (default true)
    if (cap.errors) {
        on((0, $erBZm.window), 'error', (e)=>{
            state.emit((0, $jkaj0.makeEvent)('error', 'error', {
                hook: 'window.onerror',
                message: e.message || null,
                error: e.error || null,
                source: e.filename || null,
                line: e.lineno || null,
                col: e.colno || null
            }));
        });
        on((0, $erBZm.window), 'unhandledrejection', (e)=>{
            const reason = e.reason;
            const err = reason instanceof Error ? reason : null;
            state.emit((0, $jkaj0.makeEvent)('error', 'error', {
                hook: 'unhandledrejection',
                message: err?.message || (typeof reason === 'string' ? reason : 'Unhandled promise rejection'),
                error: err
            }));
        });
    }
    if (cap.pointer) {
        on((0, $erBZm.window), 'click', (e)=>{
            state.emit((0, $jkaj0.makeEvent)('pointer', 'info', {
                hook: 'click',
                target: $ef3b3c75d6cf3f86$var$targetFromDomEvent(e),
                button: e.button,
                x: e.clientX,
                y: e.clientY,
                modifiers: $ef3b3c75d6cf3f86$var$pickModifiers(e)
            }));
        }, {
            passive: true,
            capture: true
        });
        on((0, $erBZm.window), 'dblclick', (e)=>{
            state.emit((0, $jkaj0.makeEvent)('pointer', 'info', {
                hook: 'dblclick',
                target: $ef3b3c75d6cf3f86$var$targetFromDomEvent(e),
                x: e.clientX,
                y: e.clientY
            }));
        }, {
            passive: true,
            capture: true
        });
        on((0, $erBZm.window), 'contextmenu', (e)=>{
            state.emit((0, $jkaj0.makeEvent)('pointer', 'info', {
                hook: 'contextmenu',
                target: $ef3b3c75d6cf3f86$var$targetFromDomEvent(e),
                x: e.clientX,
                y: e.clientY
            }));
        }, {
            passive: true,
            capture: true
        });
        const moveHandler = $ef3b3c75d6cf3f86$var$throttle((e)=>{
            state.emit((0, $jkaj0.makeEvent)('pointer', 'trace', {
                hook: 'pointermove',
                x: e.clientX,
                y: e.clientY
            }));
        }, throttles.pointermove);
        on((0, $erBZm.window), 'pointermove', moveHandler, {
            passive: true
        });
    }
    if (cap.keyboard) on((0, $erBZm.window), 'keydown', (e)=>{
        state.emit((0, $jkaj0.makeEvent)('keyboard', 'info', {
            hook: 'keydown',
            code: e.code,
            key: e.key && e.key.length === 1 ? "\xb7" : e.key,
            modifiers: $ef3b3c75d6cf3f86$var$pickModifiers(e),
            target: $ef3b3c75d6cf3f86$var$targetFromDomEvent(e)
        }));
    }, {
        passive: true,
        capture: true
    });
    if (cap.forms) {
        const inputHandler = (e)=>{
            const node = e.target;
            if (!node || !node.tagName) return;
            const isFormEl = [
                'INPUT',
                'TEXTAREA',
                'SELECT'
            ].includes(node.tagName);
            if (!isFormEl) return;
            const sensitive = $ef3b3c75d6cf3f86$var$isSensitiveField(node);
            const tracked = node.dataset?.analyze === 'track';
            let value = null;
            if (tracked && !sensitive) value = node.value;
            else if (state.config.maskFormValues !== false) value = $ef3b3c75d6cf3f86$var$maskFormValue(node.value, state.config.maskStrategy);
            state.emit((0, $jkaj0.makeEvent)('forms', 'info', {
                hook: e.type,
                target: $ef3b3c75d6cf3f86$var$targetFromDomEvent(e),
                field: {
                    name: node.name || null,
                    type: node.type || node.tagName.toLowerCase()
                },
                value: value
            }));
        };
        on((0, $erBZm.window), 'input', inputHandler, {
            passive: true,
            capture: true
        });
        on((0, $erBZm.window), 'change', inputHandler, {
            passive: true,
            capture: true
        });
        on((0, $erBZm.window), 'submit', (e)=>{
            state.emit((0, $jkaj0.makeEvent)('forms', 'info', {
                hook: 'submit',
                target: $ef3b3c75d6cf3f86$var$targetFromDomEvent(e)
            }));
        }, {
            passive: true,
            capture: true
        });
    }
    if (cap.scroll) {
        const scrollHandler = $ef3b3c75d6cf3f86$var$throttle(()=>{
            state.emit((0, $jkaj0.makeEvent)('scroll', 'trace', {
                hook: 'scroll',
                x: (0, $erBZm.window).scrollX,
                y: (0, $erBZm.window).scrollY
            }));
        }, throttles.scroll);
        on((0, $erBZm.window), 'scroll', scrollHandler, {
            passive: true,
            capture: true
        });
    }
    if (cap.viewport) {
        const resizeHandler = (0, $aQqva.debounce)(()=>{
            state.emit((0, $jkaj0.makeEvent)('viewport', 'info', {
                hook: 'resize',
                w: (0, $erBZm.window).innerWidth,
                h: (0, $erBZm.window).innerHeight,
                dpr: (0, $erBZm.window).devicePixelRatio || 1
            }));
        }, throttles.resize);
        on((0, $erBZm.window), 'resize', resizeHandler, {
            passive: true
        });
        on((0, $erBZm.window), 'orientationchange', ()=>{
            state.emit((0, $jkaj0.makeEvent)('viewport', 'info', {
                hook: 'orientationchange',
                orientation: typeof screen !== 'undefined' && screen.orientation ? screen.orientation.type : null
            }));
        }, {
            passive: true
        });
        on((0, $erBZm.window).document, 'visibilitychange', ()=>{
            state.emit((0, $jkaj0.makeEvent)('viewport', 'info', {
                hook: 'visibilitychange',
                hidden: (0, $erBZm.window).document.hidden
            }));
        }, {
            passive: true
        });
        // Initial viewport snapshot once at activation
        state.emit((0, $jkaj0.makeEvent)('viewport', 'info', {
            hook: 'initial',
            w: (0, $erBZm.window).innerWidth,
            h: (0, $erBZm.window).innerHeight,
            dpr: (0, $erBZm.window).devicePixelRatio || 1
        }));
    }
    if (cap.console) for (const m of [
        'log',
        'warn',
        'error',
        'debug'
    ]){
        const orig = console[m];
        console[m] = function(...args) {
            try {
                state.emit((0, $jkaj0.makeEvent)('console', m === 'error' ? 'error' : m === 'warn' ? 'warn' : 'debug', {
                    hook: `console.${m}`,
                    args: args.map($ef3b3c75d6cf3f86$var$safeStringify)
                }));
            } catch (_) {}
            return orig.apply(console, args);
        };
        teardown.push(()=>{
            console[m] = orig;
        });
    }
    if (cap.performance && typeof PerformanceObserver !== 'undefined') try {
        const obs = new PerformanceObserver((list)=>{
            for (const entry of list.getEntries())state.emit((0, $jkaj0.makeEvent)('performance', 'info', {
                hook: entry.entryType,
                name: entry.name,
                startTime: entry.startTime,
                duration: entry.duration,
                value: entry.value != null ? entry.value : null
            }));
        });
        const types = [
            'largest-contentful-paint',
            'layout-shift',
            'longtask',
            'paint',
            'first-input',
            'event'
        ];
        for (const t of types)try {
            obs.observe({
                type: t,
                buffered: true
            });
        } catch (_) {}
        teardown.push(()=>obs.disconnect());
    } catch (_) {}
};
const $ef3b3c75d6cf3f86$var$pickModifiers = (e)=>({
        shift: !!e.shiftKey,
        ctrl: !!e.ctrlKey,
        alt: !!e.altKey,
        meta: !!e.metaKey
    });
const $ef3b3c75d6cf3f86$var$safeStringify = (v)=>{
    if (v == null) return v;
    if (typeof v === 'object') try {
        return JSON.parse(JSON.stringify(v));
    } catch (_) {
        return String(v);
    }
    return v;
};

});

parcelRegister("5g5qm", function(module, exports) {

$parcel$export(module.exports, "attachNetworkListeners", () => $3d42a782ebea32e0$export$4e57191faf66e249);
parcelRequire("2oe0q");
var $erBZm = parcelRequire("erBZm");

var $jkaj0 = parcelRequire("jkaj0");
'use strict';
const $3d42a782ebea32e0$var$inBrowser = typeof (0, $erBZm.window) !== 'undefined' && typeof (0, $erBZm.window).document !== 'undefined';
const $3d42a782ebea32e0$export$b72d415da8fb0c0 = (context, data)=>{
    const state = context?.analyze;
    if (!state) return;
    if (!state.shouldCapture('network')) return;
    const level = data.phase === 'error' ? 'error' : 'info';
    state.emit((0, $jkaj0.makeEvent)('network', level, {
        hook: `fetch.${data.phase}`,
        source: 'symbo-fetch',
        ...data
    }));
};
const $3d42a782ebea32e0$export$4e57191faf66e249 = (state)=>{
    if (!$3d42a782ebea32e0$var$inBrowser) return;
    if (!state.config.capture.network) return;
    // ── window.fetch ──
    if (typeof (0, $erBZm.window).fetch === 'function') {
        const origFetch = (0, $erBZm.window).fetch.bind((0, $erBZm.window));
        const wrapped = function(input, init) {
            // Skip our own beacon traffic
            if (init?.headers?.['X-Analyze-Beacon']) return origFetch(input, init);
            const url = typeof input === 'string' ? input : input && input.url || '';
            const method = (init?.method || typeof input === 'object' && input?.method || 'GET').toUpperCase();
            const start = typeof performance !== 'undefined' ? performance.now() : Date.now();
            state.emit((0, $jkaj0.makeEvent)('network', 'info', {
                hook: 'fetch.start',
                source: 'window.fetch',
                url: url,
                method: method
            }));
            return origFetch(input, init).then((res)=>{
                const durationMs = (typeof performance !== 'undefined' ? performance.now() : Date.now()) - start;
                state.emit((0, $jkaj0.makeEvent)('network', res.ok ? 'info' : 'warn', {
                    hook: 'fetch.success',
                    source: 'window.fetch',
                    url: url,
                    method: method,
                    status: res.status,
                    ok: res.ok,
                    durationMs: durationMs
                }));
                return res;
            }).catch((err)=>{
                const durationMs = (typeof performance !== 'undefined' ? performance.now() : Date.now()) - start;
                state.emit((0, $jkaj0.makeEvent)('network', 'error', {
                    hook: 'fetch.error',
                    source: 'window.fetch',
                    url: url,
                    method: method,
                    error: err,
                    durationMs: durationMs
                }));
                throw err;
            });
        };
        (0, $erBZm.window).fetch = wrapped;
        state.__teardown.push(()=>{
            (0, $erBZm.window).fetch = origFetch;
        });
    }
    // ── XMLHttpRequest ──
    if (typeof (0, $erBZm.window).XMLHttpRequest === 'function') {
        const XHR = (0, $erBZm.window).XMLHttpRequest;
        const origOpen = XHR.prototype.open;
        const origSend = XHR.prototype.send;
        XHR.prototype.open = function(method, url) {
            this.__analyze = {
                method: String(method).toUpperCase(),
                url: String(url)
            };
            return origOpen.apply(this, arguments);
        };
        XHR.prototype.send = function(body) {
            const meta = this.__analyze;
            if (!meta) return origSend.apply(this, arguments);
            const start = typeof performance !== 'undefined' ? performance.now() : Date.now();
            state.emit((0, $jkaj0.makeEvent)('network', 'info', {
                hook: 'xhr.start',
                source: 'xhr',
                url: meta.url,
                method: meta.method
            }));
            const onDone = ()=>{
                const durationMs = (typeof performance !== 'undefined' ? performance.now() : Date.now()) - start;
                const ok = this.status >= 200 && this.status < 400;
                state.emit((0, $jkaj0.makeEvent)('network', ok ? 'info' : 'warn', {
                    hook: 'xhr.success',
                    source: 'xhr',
                    url: meta.url,
                    method: meta.method,
                    status: this.status,
                    ok: ok,
                    durationMs: durationMs
                }));
            };
            const onError = ()=>{
                const durationMs = (typeof performance !== 'undefined' ? performance.now() : Date.now()) - start;
                state.emit((0, $jkaj0.makeEvent)('network', 'error', {
                    hook: 'xhr.error',
                    source: 'xhr',
                    url: meta.url,
                    method: meta.method,
                    status: this.status,
                    durationMs: durationMs
                }));
            };
            this.addEventListener('loadend', onDone);
            this.addEventListener('error', onError);
            return origSend.apply(this, arguments);
        };
        state.__teardown.push(()=>{
            XHR.prototype.open = origOpen;
            XHR.prototype.send = origSend;
        });
    }
};

});







parcelRegister("2qyIL", function(module, exports) {
module.exports = import("hRiQn").then(()=>parcelRequire('424eo'));

});

parcelRegister("1YTED", function(module, exports) {
module.exports = import("4ubg4").then(()=>parcelRequire('9dWGM'));

});

parcelRegister("kIp89", function(module, exports) {
module.exports = import("dUX7Y").then(()=>parcelRequire('4oumI'));

});

parcelRegister("2Wz2s", function(module, exports) {
module.exports = import("fR31M").then(()=>parcelRequire('gS7wD'));

});

parcelRegister("e2TcQ", function(module, exports) {
module.exports = import("fnqWG").then(()=>parcelRequire('hcihk'));

});

parcelRegister("jyJ3a", function(module, exports) {
module.exports = import("lvX6U").then(()=>parcelRequire('cpac6'));

});

parcelRegister("hN8C9", function(module, exports) {

$parcel$export(module.exports, "switchWorkspace", () => $cf3db1eaa9a053a3$export$c3cb4d92231617a0);
/**
 * switchWorkspace — clears workspace + project state, invalidates all
 * fetch cache queries (stale on next read), loads the new workspace.
 */ const $cf3db1eaa9a053a3$var$WORKSPACE_KEYS = new Set([
    'workspace',
    'workspaceMembers',
    'workspaceIntegrations',
    'workspaceBilling'
]);
const $cf3db1eaa9a053a3$var$PROJECT_KEYS = new Set([
    'project',
    'projectComponents',
    'projectPages',
    'projectState'
]);
const $cf3db1eaa9a053a3$export$c3cb4d92231617a0 = async (state, sdk, queryClient, newWorkspaceId)=>{
    for (const k of $cf3db1eaa9a053a3$var$WORKSPACE_KEYS)state[k] = null;
    for (const k of $cf3db1eaa9a053a3$var$PROJECT_KEYS)state[k] = null;
    // Invalidate all workspace-scoped fetch cache entries.
    // Cache keys include workspace ids in params; nuking by 'workspace' prefix
    // would over-evict, so we use queryClient.invalidateQueries() to mark all
    // queries stale — they'll refetch on next read.
    queryClient.invalidateQueries();
    state.workspace = await sdk.workspace.getWorkspace(newWorkspaceId);
    localStorage.setItem('activeWorkspace', newWorkspaceId);
};

});

parcelRegister("iP3Sw", function(module, exports) {

$parcel$export(module.exports, "default", () => $db3fff9a2049a712$export$2e2bcd8739ae039);

var $3TMOj = parcelRequire("3TMOj");

var $a7M1S = parcelRequire("a7M1S");

var $k45iu = parcelRequire("k45iu");

var $b3xtO = parcelRequire("b3xtO");

var $j4BM8 = parcelRequire("j4BM8");

var $e6rXy = parcelRequire("e6rXy");

var $7wcvP = parcelRequire("7wcvP");

var $aCEE2 = parcelRequire("aCEE2");

var $3XRHS = parcelRequire("3XRHS");

var $iKfA6 = parcelRequire("iKfA6");

var $bRd5h = parcelRequire("bRd5h");

var $81tCi = parcelRequire("81tCi");
var $db3fff9a2049a712$export$2e2bcd8739ae039 = {
    ...(0, $bRd5h.default),
    state: $3TMOj.default,
    dependencies: $a7M1S.default,
    components: $k45iu,
    snippets: $b3xtO,
    pages: $j4BM8.default,
    functions: $e6rXy,
    methods: $7wcvP,
    designSystem: $aCEE2.default,
    files: $3XRHS.default,
    sharedLibraries: $iKfA6.default,
    envs: $81tCi.default
};

});
parcelRegister("3TMOj", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d6c5ee002906f0f$export$2e2bcd8739ae039);
var $2d6c5ee002906f0f$export$2e2bcd8739ae039 = {};

});

parcelRegister("a7M1S", function(module, exports) {

$parcel$export(module.exports, "default", () => $75efd072cb051394$export$2e2bcd8739ae039);
var $75efd072cb051394$export$2e2bcd8739ae039 = {
    'js-beautify': '1.15.4',
    'lottie-web': '5.13.0',
    prismjs: '1.30.0'
};

});

parcelRegister("k45iu", function(module, exports) {

var $jqZTc = parcelRequire("jqZTc");

var $lgdDU = parcelRequire("lgdDU");

var $MeejR = parcelRequire("MeejR");

var $kqvzy = parcelRequire("kqvzy");

var $9631n = parcelRequire("9631n");

var $2aSXl = parcelRequire("2aSXl");

var $2Zt4q = parcelRequire("2Zt4q");

var $5FZhg = parcelRequire("5FZhg");

var $eQTvc = parcelRequire("eQTvc");

var $5y1za = parcelRequire("5y1za");

var $9EF76 = parcelRequire("9EF76");

var $h2csN = parcelRequire("h2csN");

var $jWEs3 = parcelRequire("jWEs3");

var $jnWC7 = parcelRequire("jnWC7");

var $2Is45 = parcelRequire("2Is45");

var $4CXLV = parcelRequire("4CXLV");

var $cnwJG = parcelRequire("cnwJG");

var $c2jzz = parcelRequire("c2jzz");

var $5wYiY = parcelRequire("5wYiY");

var $3gknS = parcelRequire("3gknS");

var $aJ4S6 = parcelRequire("aJ4S6");

var $bz3WX = parcelRequire("bz3WX");

var $8taE7 = parcelRequire("8taE7");

var $jjQAm = parcelRequire("jjQAm");

var $aroHQ = parcelRequire("aroHQ");

var $99fWR = parcelRequire("99fWR");

var $abbxS = parcelRequire("abbxS");

var $b6gA9 = parcelRequire("b6gA9");

var $HwolS = parcelRequire("HwolS");

var $9UFJm = parcelRequire("9UFJm");

var $dfBCl = parcelRequire("dfBCl");

var $28BFV = parcelRequire("28BFV");

var $6mtnW = parcelRequire("6mtnW");

var $lBblp = parcelRequire("lBblp");

var $fm4cV = parcelRequire("fm4cV");

var $a0xrw = parcelRequire("a0xrw");

var $8pBXS = parcelRequire("8pBXS");

var $boq5v = parcelRequire("boq5v");

var $6petV = parcelRequire("6petV");

var $dDsgT = parcelRequire("dDsgT");

var $fl5oG = parcelRequire("fl5oG");

var $h9CCw = parcelRequire("h9CCw");

var $53qI7 = parcelRequire("53qI7");

var $8BpRf = parcelRequire("8BpRf");

var $3HrME = parcelRequire("3HrME");

var $hi0cH = parcelRequire("hi0cH");

var $QkEdX = parcelRequire("QkEdX");

var $ku4XL = parcelRequire("ku4XL");

var $U4pQL = parcelRequire("U4pQL");

var $scw1T = parcelRequire("scw1T");

var $lxIKl = parcelRequire("lxIKl");

var $eR6ol = parcelRequire("eR6ol");

var $29k5Z = parcelRequire("29k5Z");

var $bYCE2 = parcelRequire("bYCE2");

var $3YGeE = parcelRequire("3YGeE");

var $bPL12 = parcelRequire("bPL12");

var $gwbSH = parcelRequire("gwbSH");

var $aF5MQ = parcelRequire("aF5MQ");

var $gXyLr = parcelRequire("gXyLr");

var $kjIQ3 = parcelRequire("kjIQ3");

var $YBCA4 = parcelRequire("YBCA4");

var $ffzvn = parcelRequire("ffzvn");

var $4qy3y = parcelRequire("4qy3y");

var $f7Yn0 = parcelRequire("f7Yn0");

var $aCpWl = parcelRequire("aCpWl");

var $1OWjn = parcelRequire("1OWjn");

var $e9agx = parcelRequire("e9agx");

var $bmYet = parcelRequire("bmYet");

var $1mIHv = parcelRequire("1mIHv");

var $gvmVa = parcelRequire("gvmVa");

var $a8Ks7 = parcelRequire("a8Ks7");

var $4VFTK = parcelRequire("4VFTK");

var $9SkP4 = parcelRequire("9SkP4");

var $1kkUF = parcelRequire("1kkUF");

var $dF8TG = parcelRequire("dF8TG");

var $aTHR6 = parcelRequire("aTHR6");

var $fLqEx = parcelRequire("fLqEx");

var $9lpdD = parcelRequire("9lpdD");

var $5WD61 = parcelRequire("5WD61");

var $3PQeI = parcelRequire("3PQeI");

var $l86iw = parcelRequire("l86iw");

var $jGDET = parcelRequire("jGDET");

var $iXQIQ = parcelRequire("iXQIQ");

var $cxY4b = parcelRequire("cxY4b");

var $jLLgb = parcelRequire("jLLgb");

var $jL1PP = parcelRequire("jL1PP");

var $97Skx = parcelRequire("97Skx");

var $5Scc8 = parcelRequire("5Scc8");

var $03B9U = parcelRequire("03B9U");

var $a0Rti = parcelRequire("a0Rti");

var $b7o9M = parcelRequire("b7o9M");

var $3ZzEG = parcelRequire("3ZzEG");

var $929VG = parcelRequire("929VG");

var $eVuWq = parcelRequire("eVuWq");

var $kDniw = parcelRequire("kDniw");

var $34P8p = parcelRequire("34P8p");

var $fF7X5 = parcelRequire("fF7X5");

var $2U3gr = parcelRequire("2U3gr");

var $6kfhQ = parcelRequire("6kfhQ");

var $c5Jj3 = parcelRequire("c5Jj3");

var $c36nN = parcelRequire("c36nN");

var $kgWRy = parcelRequire("kgWRy");

var $esg1s = parcelRequire("esg1s");

var $3HVEt = parcelRequire("3HVEt");

var $02R23 = parcelRequire("02R23");

var $ieisA = parcelRequire("ieisA");

var $3SxY4 = parcelRequire("3SxY4");

var $eoZKt = parcelRequire("eoZKt");

var $ibtX7 = parcelRequire("ibtX7");

var $aYOGQ = parcelRequire("aYOGQ");

var $deePH = parcelRequire("deePH");

var $6hgok = parcelRequire("6hgok");

var $4C8gQ = parcelRequire("4C8gQ");

var $6XAQm = parcelRequire("6XAQm");

var $ficK4 = parcelRequire("ficK4");

var $ePRwS = parcelRequire("ePRwS");

var $8UnYs = parcelRequire("8UnYs");

var $1NVyN = parcelRequire("1NVyN");

var $ik0dP = parcelRequire("ik0dP");

var $4OeYg = parcelRequire("4OeYg");

var $4I6B8 = parcelRequire("4I6B8");

var $2QB9L = parcelRequire("2QB9L");

var $diVRI = parcelRequire("diVRI");

var $4EltV = parcelRequire("4EltV");

var $6q5VZ = parcelRequire("6q5VZ");

var $gJdLc = parcelRequire("gJdLc");

var $eYtLW = parcelRequire("eYtLW");

var $j8xcc = parcelRequire("j8xcc");

var $ar9ji = parcelRequire("ar9ji");

var $d6PxP = parcelRequire("d6PxP");

var $csq3J = parcelRequire("csq3J");

var $3Zgsu = parcelRequire("3Zgsu");

var $7zA8I = parcelRequire("7zA8I");

var $8838b = parcelRequire("8838b");

var $SQip8 = parcelRequire("SQip8");

var $jGj5M = parcelRequire("jGj5M");

var $d5rrN = parcelRequire("d5rrN");

var $bhpco = parcelRequire("bhpco");

var $hLO8r = parcelRequire("hLO8r");

var $8OXF9 = parcelRequire("8OXF9");

var $ex8uL = parcelRequire("ex8uL");

var $6DZIs = parcelRequire("6DZIs");

var $6BEjr = parcelRequire("6BEjr");

var $ksUFH = parcelRequire("ksUFH");

var $3Eyhr = parcelRequire("3Eyhr");

var $2liSf = parcelRequire("2liSf");

var $4Ry3I = parcelRequire("4Ry3I");

var $7VzGT = parcelRequire("7VzGT");

var $9aTZM = parcelRequire("9aTZM");

var $fvi5X = parcelRequire("fvi5X");

var $59ExR = parcelRequire("59ExR");

var $bsxjR = parcelRequire("bsxjR");

var $3Gcd8 = parcelRequire("3Gcd8");

var $cmpdZ = parcelRequire("cmpdZ");

var $bGqNX = parcelRequire("bGqNX");

var $unArz = parcelRequire("unArz");

var $ahdUq = parcelRequire("ahdUq");

var $1PeD7 = parcelRequire("1PeD7");

var $hsIgN = parcelRequire("hsIgN");

var $g1o16 = parcelRequire("g1o16");

var $fiZOa = parcelRequire("fiZOa");

var $8cEzu = parcelRequire("8cEzu");

var $5wPSG = parcelRequire("5wPSG");

var $goQJ5 = parcelRequire("goQJ5");

var $hVePq = parcelRequire("hVePq");

var $1wIqF = parcelRequire("1wIqF");

var $lWvHE = parcelRequire("lWvHE");

var $fCmA9 = parcelRequire("fCmA9");

var $fmcJS = parcelRequire("fmcJS");

var $6eq6s = parcelRequire("6eq6s");

var $e0mx5 = parcelRequire("e0mx5");

var $2Llt2 = parcelRequire("2Llt2");

var $jgmam = parcelRequire("jgmam");

var $6vpNv = parcelRequire("6vpNv");
$parcel$exportWildcard(module.exports, $jqZTc);
$parcel$exportWildcard(module.exports, $lgdDU);
$parcel$exportWildcard(module.exports, $MeejR);
$parcel$exportWildcard(module.exports, $kqvzy);
$parcel$exportWildcard(module.exports, $9631n);
$parcel$exportWildcard(module.exports, $2aSXl);
$parcel$exportWildcard(module.exports, $2Zt4q);
$parcel$exportWildcard(module.exports, $5FZhg);
$parcel$exportWildcard(module.exports, $eQTvc);
$parcel$exportWildcard(module.exports, $5y1za);
$parcel$exportWildcard(module.exports, $9EF76);
$parcel$exportWildcard(module.exports, $h2csN);
$parcel$exportWildcard(module.exports, $jWEs3);
$parcel$exportWildcard(module.exports, $jnWC7);
$parcel$exportWildcard(module.exports, $2Is45);
$parcel$exportWildcard(module.exports, $4CXLV);
$parcel$exportWildcard(module.exports, $cnwJG);
$parcel$exportWildcard(module.exports, $c2jzz);
$parcel$exportWildcard(module.exports, $5wYiY);
$parcel$exportWildcard(module.exports, $3gknS);
$parcel$exportWildcard(module.exports, $aJ4S6);
$parcel$exportWildcard(module.exports, $bz3WX);
$parcel$exportWildcard(module.exports, $8taE7);
$parcel$exportWildcard(module.exports, $jjQAm);
$parcel$exportWildcard(module.exports, $aroHQ);
$parcel$exportWildcard(module.exports, $99fWR);
$parcel$exportWildcard(module.exports, $abbxS);
$parcel$exportWildcard(module.exports, $b6gA9);
$parcel$exportWildcard(module.exports, $HwolS);
$parcel$exportWildcard(module.exports, $9UFJm);
$parcel$exportWildcard(module.exports, $dfBCl);
$parcel$exportWildcard(module.exports, $28BFV);
$parcel$exportWildcard(module.exports, $6mtnW);
$parcel$exportWildcard(module.exports, $lBblp);
$parcel$exportWildcard(module.exports, $fm4cV);
$parcel$exportWildcard(module.exports, $a0xrw);
$parcel$exportWildcard(module.exports, $8pBXS);
$parcel$exportWildcard(module.exports, $boq5v);
$parcel$exportWildcard(module.exports, $6petV);
$parcel$exportWildcard(module.exports, $dDsgT);
$parcel$exportWildcard(module.exports, $fl5oG);
$parcel$exportWildcard(module.exports, $h9CCw);
$parcel$exportWildcard(module.exports, $53qI7);
$parcel$exportWildcard(module.exports, $8BpRf);
$parcel$exportWildcard(module.exports, $3HrME);
$parcel$exportWildcard(module.exports, $hi0cH);
$parcel$exportWildcard(module.exports, $QkEdX);
$parcel$exportWildcard(module.exports, $ku4XL);
$parcel$exportWildcard(module.exports, $U4pQL);
$parcel$exportWildcard(module.exports, $scw1T);
$parcel$exportWildcard(module.exports, $lxIKl);
$parcel$exportWildcard(module.exports, $eR6ol);
$parcel$exportWildcard(module.exports, $29k5Z);
$parcel$exportWildcard(module.exports, $bYCE2);
$parcel$exportWildcard(module.exports, $3YGeE);
$parcel$exportWildcard(module.exports, $bPL12);
$parcel$exportWildcard(module.exports, $gwbSH);
$parcel$exportWildcard(module.exports, $aF5MQ);
$parcel$exportWildcard(module.exports, $gXyLr);
$parcel$exportWildcard(module.exports, $kjIQ3);
$parcel$exportWildcard(module.exports, $YBCA4);
$parcel$exportWildcard(module.exports, $ffzvn);
$parcel$exportWildcard(module.exports, $4qy3y);
$parcel$exportWildcard(module.exports, $f7Yn0);
$parcel$exportWildcard(module.exports, $aCpWl);
$parcel$exportWildcard(module.exports, $1OWjn);
$parcel$exportWildcard(module.exports, $e9agx);
$parcel$exportWildcard(module.exports, $bmYet);
$parcel$exportWildcard(module.exports, $1mIHv);
$parcel$exportWildcard(module.exports, $gvmVa);
$parcel$exportWildcard(module.exports, $a8Ks7);
$parcel$exportWildcard(module.exports, $4VFTK);
$parcel$exportWildcard(module.exports, $9SkP4);
$parcel$exportWildcard(module.exports, $1kkUF);
$parcel$exportWildcard(module.exports, $dF8TG);
$parcel$exportWildcard(module.exports, $aTHR6);
$parcel$exportWildcard(module.exports, $fLqEx);
$parcel$exportWildcard(module.exports, $9lpdD);
$parcel$exportWildcard(module.exports, $5WD61);
$parcel$exportWildcard(module.exports, $3PQeI);
$parcel$exportWildcard(module.exports, $l86iw);
$parcel$exportWildcard(module.exports, $jGDET);
$parcel$exportWildcard(module.exports, $iXQIQ);
$parcel$exportWildcard(module.exports, $cxY4b);
$parcel$exportWildcard(module.exports, $jLLgb);
$parcel$exportWildcard(module.exports, $jL1PP);
$parcel$exportWildcard(module.exports, $97Skx);
$parcel$exportWildcard(module.exports, $5Scc8);
$parcel$exportWildcard(module.exports, $03B9U);
$parcel$exportWildcard(module.exports, $a0Rti);
$parcel$exportWildcard(module.exports, $b7o9M);
$parcel$exportWildcard(module.exports, $3ZzEG);
$parcel$exportWildcard(module.exports, $929VG);
$parcel$exportWildcard(module.exports, $eVuWq);
$parcel$exportWildcard(module.exports, $kDniw);
$parcel$exportWildcard(module.exports, $34P8p);
$parcel$exportWildcard(module.exports, $fF7X5);
$parcel$exportWildcard(module.exports, $2U3gr);
$parcel$exportWildcard(module.exports, $6kfhQ);
$parcel$exportWildcard(module.exports, $c5Jj3);
$parcel$exportWildcard(module.exports, $c36nN);
$parcel$exportWildcard(module.exports, $kgWRy);
$parcel$exportWildcard(module.exports, $esg1s);
$parcel$exportWildcard(module.exports, $3HVEt);
$parcel$exportWildcard(module.exports, $02R23);
$parcel$exportWildcard(module.exports, $ieisA);
$parcel$exportWildcard(module.exports, $3SxY4);
$parcel$exportWildcard(module.exports, $eoZKt);
$parcel$exportWildcard(module.exports, $ibtX7);
$parcel$exportWildcard(module.exports, $aYOGQ);
$parcel$exportWildcard(module.exports, $deePH);
$parcel$exportWildcard(module.exports, $6hgok);
$parcel$exportWildcard(module.exports, $4C8gQ);
$parcel$exportWildcard(module.exports, $6XAQm);
$parcel$exportWildcard(module.exports, $ficK4);
$parcel$exportWildcard(module.exports, $ePRwS);
$parcel$exportWildcard(module.exports, $8UnYs);
$parcel$exportWildcard(module.exports, $1NVyN);
$parcel$exportWildcard(module.exports, $ik0dP);
$parcel$exportWildcard(module.exports, $4OeYg);
$parcel$exportWildcard(module.exports, $4I6B8);
$parcel$exportWildcard(module.exports, $2QB9L);
$parcel$exportWildcard(module.exports, $diVRI);
$parcel$exportWildcard(module.exports, $4EltV);
$parcel$exportWildcard(module.exports, $6q5VZ);
$parcel$exportWildcard(module.exports, $gJdLc);
$parcel$exportWildcard(module.exports, $eYtLW);
$parcel$exportWildcard(module.exports, $j8xcc);
$parcel$exportWildcard(module.exports, $ar9ji);
$parcel$exportWildcard(module.exports, $d6PxP);
$parcel$exportWildcard(module.exports, $csq3J);
$parcel$exportWildcard(module.exports, $3Zgsu);
$parcel$exportWildcard(module.exports, $7zA8I);
$parcel$exportWildcard(module.exports, $8838b);
$parcel$exportWildcard(module.exports, $SQip8);
$parcel$exportWildcard(module.exports, $jGj5M);
$parcel$exportWildcard(module.exports, $d5rrN);
$parcel$exportWildcard(module.exports, $bhpco);
$parcel$exportWildcard(module.exports, $hLO8r);
$parcel$exportWildcard(module.exports, $8OXF9);
$parcel$exportWildcard(module.exports, $ex8uL);
$parcel$exportWildcard(module.exports, $6DZIs);
$parcel$exportWildcard(module.exports, $6BEjr);
$parcel$exportWildcard(module.exports, $ksUFH);
$parcel$exportWildcard(module.exports, $3Eyhr);
$parcel$exportWildcard(module.exports, $2liSf);
$parcel$exportWildcard(module.exports, $4Ry3I);
$parcel$exportWildcard(module.exports, $7VzGT);
$parcel$exportWildcard(module.exports, $9aTZM);
$parcel$exportWildcard(module.exports, $fvi5X);
$parcel$exportWildcard(module.exports, $59ExR);
$parcel$exportWildcard(module.exports, $bsxjR);
$parcel$exportWildcard(module.exports, $3Gcd8);
$parcel$exportWildcard(module.exports, $cmpdZ);
$parcel$exportWildcard(module.exports, $bGqNX);
$parcel$exportWildcard(module.exports, $unArz);
$parcel$exportWildcard(module.exports, $ahdUq);
$parcel$exportWildcard(module.exports, $1PeD7);
$parcel$exportWildcard(module.exports, $hsIgN);
$parcel$exportWildcard(module.exports, $g1o16);
$parcel$exportWildcard(module.exports, $fiZOa);
$parcel$exportWildcard(module.exports, $8cEzu);
$parcel$exportWildcard(module.exports, $5wPSG);
$parcel$exportWildcard(module.exports, $goQJ5);
$parcel$exportWildcard(module.exports, $hVePq);
$parcel$exportWildcard(module.exports, $1wIqF);
$parcel$exportWildcard(module.exports, $lWvHE);
$parcel$exportWildcard(module.exports, $fCmA9);
$parcel$exportWildcard(module.exports, $fmcJS);
$parcel$exportWildcard(module.exports, $6eq6s);
$parcel$exportWildcard(module.exports, $e0mx5);
$parcel$exportWildcard(module.exports, $2Llt2);
$parcel$exportWildcard(module.exports, $jgmam);
$parcel$exportWildcard(module.exports, $6vpNv);

});
parcelRegister("jqZTc", function(module, exports) {

$parcel$export(module.exports, "AccessCodeField", () => $e26073f8a517964f$export$588db2de64f3ad6d);
const $e26073f8a517964f$export$588db2de64f3ad6d = {
    extends: 'GroupField',
    Title: {
        text: 'Invitation code'
    },
    Grid: {
        position: 'relative',
        columns: 'repeat(6, 1fr)',
        width: '100%',
        height: 'C',
        gap: 'X2',
        state: {
            value: [
                null,
                null,
                null,
                null,
                null,
                null
            ]
        },
        childExtends: 'Input',
        childProps: {
            boxSize: 'C',
            required: true,
            round: 'Y2',
            minlength: 1,
            maxlength: 1,
            fontFamily: 'Code',
            value: (el, s)=>s.value[el.key] || '',
            onKeyup: (event, element, state)=>{
                const { target: target, keyCode: keyCode } = event;
                const { value: value } = target;
                const next = element.nextElement();
                const previous = element.previousElement();
                const isNumber = keyCode >= 48 && keyCode <= 57 || keyCode >= 96 && keyCode <= 105;
                const isBackspace = event.keyCode === 8 || event.keyCode === 46;
                target.select();
                if (isNumber && value.length && next) next.node.focus();
                if ((!value.length || isBackspace) && previous) previous.node.focus();
                state.value[element.key] = value;
                element.lookup('Input').update({
                    value: Object.values(state.value).join('')
                });
            },
            onPaste: (event, element, state)=>{
                event.preventDefault();
                const paste = (event.clipboardData || window.clipboardData).getData('text');
                if (!paste) return;
                const value = paste.split('');
                state.value = value;
                state.update();
            }
        },
        children: [
            {},
            {},
            {},
            {},
            {},
            {}
        ],
        Input: {
            ignoreChildExtends: true,
            type: 'hidden',
            required: true,
            placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022",
            pattern: '[0-9]*',
            minlength: 6,
            maxlength: 6,
            round: 'Y2',
            position: 'absolute',
            inset: '0'
        }
    }
};

});

parcelRegister("lgdDU", function(module, exports) {

$parcel$export(module.exports, "AddItemButton", () => $f7a5acbe0950744d$export$6cb731ac7be1981a);
const $f7a5acbe0950744d$export$6cb731ac7be1981a = {
    extends: 'ButtonTitle',
    IconButton: {
        tabIndex: '-1',
        align: 'center center',
        round: 'Y1',
        icon: 'plus',
        color: 'lightBlue'
    },
    Caption: {
        text: 'Add item'
    }
};

});

parcelRegister("MeejR", function(module, exports) {

$parcel$export(module.exports, "AccessibilityCheck", () => $090f859525daa22a$export$1400955c2696b584);
const $090f859525daa22a$export$1400955c2696b584 = {
    extends: 'Group',
    flow: 'y',
    align: 'flex-start flex-start',
    gap: 'A',
    Title: {
        text: 'WCAG accessibility checks'
    },
    Flex: {
        flow: 'row wrap',
        align: 'center flex-start',
        gap: 'A2 B',
        childExtends: {
            extends: 'IconText',
            gap: 'Y',
            icon: 'checkmark',
            Icon: {
                color: 'grassgreen'
            }
        },
        children: [
            {
                text: 'Normal AAA'
            },
            {
                text: 'Large AAA'
            },
            {
                text: 'Large AA'
            },
            {
                text: 'UI Components'
            }
        ]
    }
};

});

parcelRegister("kqvzy", function(module, exports) {

$parcel$export(module.exports, "ArticleHeader", () => $edeeb9fff13cc045$export$c0731e8c4d214bed);
const $edeeb9fff13cc045$export$c0731e8c4d214bed = {
    flow: 'column',
    gap: 'X',
    color: 'title',
    Title: {
        color: 'title',
        fontWeight: '500',
        margin: '0'
    },
    P: {
        lineHeight: '1.5em',
        margin: '0',
        fontWeight: '400',
        maxWidth: 'I_default',
        color: 'paragraph'
    }
};

});

parcelRegister("9631n", function(module, exports) {

$parcel$export(module.exports, "AddRemoveButtons", () => $69f7048fd333a9d0$export$10285b88153ac363);
const $69f7048fd333a9d0$export$10285b88153ac363 = {
    childExtends: 'IconButton',
    gap: 'Z',
    Remove: {
        icon: 'minus'
    },
    Add: {
        icon: 'plus'
    }
};

});

parcelRegister("2aSXl", function(module, exports) {

$parcel$export(module.exports, "ArrowButton", () => $19572512d9d13797$export$15d663f77d176497);
const $19572512d9d13797$export$15d663f77d176497 = {
    extends: 'SquareButton',
    round: '100%',
    theme: 'transparent',
    background: 'white.15'
};

});

parcelRegister("2Zt4q", function(module, exports) {

$parcel$export(module.exports, "AddButton", () => $22d7d40ce5a938d6$export$6d88ebe453be59d7);
const $22d7d40ce5a938d6$export$6d88ebe453be59d7 = {
    extends: [
        'Link',
        'MenuItem'
    ],
    ignoreChildExtends: true,
    icon: 'plus'
};

});

parcelRegister("5FZhg", function(module, exports) {

$parcel$export(module.exports, "ArticleLink", () => $4220508313777a21$export$59b71bdbac9390a6);
const $4220508313777a21$export$59b71bdbac9390a6 = {
    extends: [
        'Link',
        'ClickableButton'
    ],
    padding: 'Z1',
    round: 'Z2',
    flow: 'y',
    align: 'flex-start flex-start',
    borderWidth: '1px',
    '@dark': {
        theme: null,
        color: 'gray11',
        border: 'solid gray2'
    },
    '@light': {
        theme: null,
        color: 'gray11',
        border: 'solid gray11'
    },
    Caption: {
        fontSize: 'Y',
        color: 'gray7',
        fontWeight: '500',
        textTransform: 'uppercase'
    },
    Title: {
        margin: '0',
        fontWeight: '500',
        '@dark': {
            color: 'gray11'
        },
        '@light': {
            color: 'gray3'
        }
    }
};

});

parcelRegister("eQTvc", function(module, exports) {

$parcel$export(module.exports, "ArticleBig", () => $ad00f99971b671fa$export$534e4d733a51b09b);
const $ad00f99971b671fa$export$534e4d733a51b09b = {
    extends: 'Article',
    Title: {
        tag: 'h1',
        fontSize: 'E',
        fontWeight: '700'
    }
};

});

parcelRegister("5y1za", function(module, exports) {

$parcel$export(module.exports, "Breadcrumb", () => $40a157c205ed9f81$export$dabcc1ec9dd9d1cc);
const $40a157c205ed9f81$export$dabcc1ec9dd9d1cc = {
    tag: 'nav',
    childExtends: 'Link',
    display: 'flex',
    align: 'center',
    childProps: {
        fontWeight: '400',
        textDecoration: 'none',
        scrollToTop: false,
        color: 'line',
        '&[href]': {
            color: 'title',
            '&:hover': {
                textDecoration: 'underline'
            }
        },
        '&:not([href])': {
            cursor: 'default'
        },
        '&:not(:first-child):before': {
            content: '""',
            display: 'inline-block',
            width: 'V',
            height: 'V',
            round: '100%',
            background: 'white',
            verticalAlign: '0.2em',
            marginInline: '.65em',
            opacity: '.5'
        }
    },
    children: (el, s, ctx2)=>{
        const routeArr = (el.call('sameOriginTop')?.location?.pathname || window.location.pathname).split("/").slice(1);
        return routeArr.map((text, i)=>text === "page" ? {
                href: "/pages",
                text: "Page"
            } : el.getData("pages")?.[`/${text}`] ? {
                href: `/${routeArr.slice(0, i + 1).join("/")}`,
                text: `/${text}`
            } : {
                href: `/${routeArr.slice(0, i + 1).join("/")}`,
                text: i === 0 ? el.call("toTitleCase", text) : text
            }).filter((_, k)=>{
            const v = routeArr[k];
            return !v.includes("-") && !v.includes("editor") && !v.includes("preview");
        });
    }
};

});

parcelRegister("9EF76", function(module, exports) {

$parcel$export(module.exports, "ArticleTiny", () => $7077bdc1e347e877$export$408af9d99e452260);
const $7077bdc1e347e877$export$408af9d99e452260 = {
    extends: 'Article',
    gap: '0',
    Title: {},
    P: {
        fontSize: 'Z'
    }
};

});

parcelRegister("h2csN", function(module, exports) {

$parcel$export(module.exports, "ArticleXS", () => $c66c4a8a24767b81$export$194d2f78c954be33);
const $c66c4a8a24767b81$export$194d2f78c954be33 = {
    extends: 'Article',
    gap: 'X',
    Title: {
        tag: 'h5',
        fontSize: 'Z1'
    },
    P: {
        fontSize: 'Z1'
    }
};

});

parcelRegister("jWEs3", function(module, exports) {

$parcel$export(module.exports, "ButtonTitle", () => $e852cfee097b5a50$export$c72d460b11e49d5c);
const $e852cfee097b5a50$export$c72d460b11e49d5c = {
    extends: 'Button',
    fontSize: 'A',
    padding: '0',
    background: 'transparent',
    color: 'gray7',
    gap: 'Z',
    width: 'fit-content',
    ':hover > div': {
        background: 'gray2',
        color: 'white'
    },
    IconButton: {
        padding: 'X2',
        round: 'Z2'
    },
    Caption: {
        fontSize: 'Z'
    }
};

});

parcelRegister("jnWC7", function(module, exports) {

$parcel$export(module.exports, "ArticleMedium", () => $e1cda1cba69de46a$export$5be88be36b215324);
const $e1cda1cba69de46a$export$5be88be36b215324 = {
    extends: 'Article',
    gap: 'X',
    Title: {
        tag: 'h2',
        fontSize: 'B'
    }
};

});

parcelRegister("2Is45", function(module, exports) {

$parcel$export(module.exports, "ArticleSmall", () => $1fa575f343249cea$export$1333c742efbe0d63);
const $1fa575f343249cea$export$1333c742efbe0d63 = {
    extends: 'Article',
    gap: 'X',
    Title: {
        fontSize: 'A',
        tag: 'h4'
    }
};

});

parcelRegister("4CXLV", function(module, exports) {

$parcel$export(module.exports, "CanvasEmbed", () => $35e913832b1769db$export$f5fbc0b4b0d1945c);
const $35e913832b1769db$export$f5fbc0b4b0d1945c = {
    extends: 'Iframe',
    minWidth: 'none',
    minHeight: 'none',
    border: 'none',
    width: '100%',
    height: 'H2',
    project: '/nikoloza/default',
    src: (el)=>"https://symbols.app/embed" + el.project,
    round: 'Z2'
};

});

parcelRegister("cnwJG", function(module, exports) {

$parcel$export(module.exports, "CancelButton", () => $903106b134194afb$export$488fee190faedb43);
const $903106b134194afb$export$488fee190faedb43 = {
    extends: [
        'Link',
        'Button'
    ],
    round: 'D',
    padding: 'Z1 D1',
    fontWeight: '600',
    theme: 'secondary',
    color: 'white',
    whiteSpace: 'nowrap',
    text: 'Read the docs'
};

});

parcelRegister("c2jzz", function(module, exports) {

$parcel$export(module.exports, "CaptionTitle", () => $8c34daaf8050d5e9$export$bb64f969ca4371a9);
const $8c34daaf8050d5e9$export$bb64f969ca4371a9 = {
    margin: 'W auto - -',
    color: 'disabled',
    fontSize: 'Y1',
    textTransform: 'uppercase',
    align: 'center',
    Text: {
        text: 'Active Project'
    }
};

});

parcelRegister("5wYiY", function(module, exports) {

$parcel$export(module.exports, "CanvasEmbed.ClickToLoad", () => $406eb83cf975a38a$export$f847d78308099bb3);
const $406eb83cf975a38a$export$f847d78308099bb3 = {
    position: 'relative',
    border: '1px solid line',
    round: 'Z2',
    overflow: 'hidden',
    onClick: (e, el)=>{
        el.LoaderRatio.update({
            animation: 'scaleInOut',
            animationDelay: 'F',
            pointerEvents: 'none'
        });
        el.CanvasEmbed.update({
            hide: false,
            show: true
        });
    },
    minHeight: 'G',
    LoaderRatio: {
        align: 'center center',
        position: 'absolute',
        pointerEvents: 'auto',
        Button: {
            position: 'relative',
            zIndex: 3,
            gap: 'X2',
            transform: 'none',
            icon: 'play',
            theme: 'quaternary',
            text: 'Click to preview'
        }
    },
    CanvasEmbed: {
        minWidth: 'auto',
        minHeight: 'auto',
        border: 'none',
        width: '100%',
        height: '100%',
        inset: '0',
        project: '/nikoloza/default',
        src: (el)=>'https://symbols.app/embed' + (el.parent.project || el.project),
        round: 'Z2'
    }
};

});

parcelRegister("3gknS", function(module, exports) {

$parcel$export(module.exports, "CanvasButton", () => $2602ad91442a7d73$export$a498b2f163437f5f);
const $2602ad91442a7d73$export$a498b2f163437f5f = {
    theme: 'navbarButton'
};

});

parcelRegister("aJ4S6", function(module, exports) {

$parcel$export(module.exports, "CheckParagraph", () => $7cf1e2be73db7a55$export$e6eb09306d3c871e);
const $7cf1e2be73db7a55$export$e6eb09306d3c871e = {
    extends: 'IconText',
    text: (el, s)=>s.value || s.text,
    gap: 'Y',
    color: 'title',
    width: 'fit-content',
    icon: 'checkmark',
    Icon: {
        order: '-1',
        color: 'paragraph'
    }
};

});

parcelRegister("bz3WX", function(module, exports) {

$parcel$export(module.exports, "AccordionItem", () => $86b606f3ae3cc3ff$export$d99097c13d4dac9f);
const $86b606f3ae3cc3ff$export$d99097c13d4dac9f = {
    state: {
        isActive: false
    },
    flow: 'y',
    position: 'relative',
    align: 'flex-start',
    overflow: 'hidden',
    padding: 'Z1 W',
    width: '100%',
    maxWidth: 'H1',
    transition: 'A defaultBezier padding',
    borderStyle: 'solid',
    borderWidth: '1px 0 0 0',
    '@dark': {
        borderColor: 'gray3'
    },
    '@light': {
        borderColor: 'gray13'
    },
    '.isActive': {
        paddingBlockEnd: (el)=>{
            const Section = el.Section.node;
            const height = Section?.getBoundingClientRect?.().height || 0;
            return `calc(${height}px + 1em)`;
        }
    },
    Flex: {
        minWidth: '100%',
        align: 'center space-between',
        cursor: 'pointer',
        userSelect: 'none',
        onClick: (event, element, state)=>{
            state.toggle('isActive');
        },
        P: {
            padding: 'X2 -',
            margin: '0',
            text: 'Question text one here',
            color: 'title'
        },
        Icon: {
            icon: 'arrowAngleDown',
            textDecoration: 'none',
            fontSize: 'B',
            '.isActive': {
                transform: 'rotate(180deg)'
            }
        }
    },
    Section: {
        text: 'Use a checkbox when users can select one option, multiple options, or no option from a list of a possible options.',
        position: 'absolute',
        padding: 'Z2 0 W',
        color: 'paragraph',
        cursor: 'default',
        top: 'C',
        transition: 'A defaultBezier',
        transitionProperty: 'margin, opacity',
        '.isActive': {
            opacity: '1'
        },
        '!isActive': {
            opacity: '0'
        }
    }
};

});

parcelRegister("8taE7", function(module, exports) {

$parcel$export(module.exports, "CanvasEmbed2", () => $62a94a452c5391b5$export$e2097b38d266dd01);
const $62a94a452c5391b5$export$e2097b38d266dd01 = {
    Flex: {
        align: 'center center',
        position: 'absolute',
        inset: '0',
        onClick: (e, el)=>{
            el.update({
                animation: 'scaleInOut',
                animationDuration: 'F',
                pointerEvents: 'none'
            });
            el.nextElement().update({
                hide: false,
                show: true
            });
        },
        LoaderRatio: {
            position: 'absolute',
            pointerEvents: 'auto',
            opacity: '0.9',
            zIndex: 2
        },
        Button: {
            position: 'relative',
            zIndex: 3,
            gap: 'X2',
            transform: 'none',
            icon: 'play',
            theme: 'quaternary',
            text: 'Click to Preview'
        }
    },
    CanvasEmbed: {
        minWidth: 'none',
        minHeight: 'none',
        border: 'none',
        width: '100%',
        height: 'H2',
        project: '/nikoloza/default',
        src: (el)=>'https://symbols.app/embed' + (el.parent.project || el.project),
        round: 'Z2'
    },
    position: 'relative',
    minWidth: 'H3',
    round: 'Z2',
    overflow: 'hidden'
};

});

parcelRegister("jjQAm", function(module, exports) {

$parcel$export(module.exports, "ClickableItem", () => $e108950ff9ab1598$export$7e5e4c134d7e54da);
const $e108950ff9ab1598$export$7e5e4c134d7e54da = {
    transition: 'B defaultBezier',
    transitionProperty: 'opacity, transform',
    theme: 'secondary',
    opacity: 0.85,
    userSelect: 'none',
    draggable: false,
    ':hover': {
        opacity: 0.9,
        transform: 'scale(1.005)'
    },
    ':active': {
        opacity: 1,
        transform: 'scale(1.005)'
    },
    ':focus': {
        opacity: 1
    },
    '.isActive': {
        opacity: 1,
        theme: ({ state: state })=>'secondary @' + (state.root.globalTheme || 'dark.active')
    }
};

});

parcelRegister("aroHQ", function(module, exports) {

$parcel$export(module.exports, "ColumnParagraphs", () => $799f972128da95ac$export$a0e67292cc68ffe7);
const $799f972128da95ac$export$a0e67292cc68ffe7 = {
    extends: 'Grid',
    childExtends: 'P',
    width: '100%',
    gap: 'C',
    columns: '4fr 7fr 7fr',
    '@mobileM': {
        display: 'flex',
        flow: 'y'
    },
    childProps: {
        maxWidth: 'G+C',
        color: 'paragraph'
    }
};

});

parcelRegister("99fWR", function(module, exports) {

$parcel$export(module.exports, "ConnectionLabel", () => $6a9153554dccc1db$export$36fb156e37af9d72);
const $6a9153554dccc1db$export$36fb156e37af9d72 = {
    gap: 'Z',
    align: 'center',
    color: 'paragraph',
    isActive: true,
    '.isActive': {
        color: 'caption'
    },
    Circle: {
        round: 'A',
        boxSize: 'Z',
        isActive: (el)=>el.parent.isActive,
        '.isActive': {
            background: 'green'
        },
        '!isActive': {
            background: 'shadow'
        }
    },
    Text: {
        text: (el)=>el.parent.isActive ? "Connected" : "Not connected"
    },
    CopyButton: {
        hide: (el)=>!el.parent.isActive,
        value: (el)=>`https://${el.getAppKey()}/`,
        icon: 'copy outline',
        background: 'transparent'
    }
};

});

parcelRegister("abbxS", function(module, exports) {

$parcel$export(module.exports, "CheckButton", () => $7693e32649f179be$export$c767f14fef25f1ed);
const $7693e32649f179be$export$c767f14fef25f1ed = {
    extends: [
        'Button',
        'ClickableItem'
    ],
    icon: 'checkmark',
    text: 'Okay',
    padding: 'Z1 B1 Z1 B',
    round: 'B',
    align: 'center center',
    theme: 'quaternary',
    gap: 'X2',
    ':disabled': {
        opacity: '.35',
        theme: 'secondary'
    }
};

});

parcelRegister("b6gA9", function(module, exports) {

$parcel$export(module.exports, "CheckboxField", () => $814d1e1f4b5e7f83$export$94195a47b94ed396);
const $814d1e1f4b5e7f83$export$94195a47b94ed396 = {
    flow: 'x',
    tag: 'label',
    gap: 'Y',
    align: 'center',
    Input: {
        type: 'checkbox',
        checked: (el, s)=>el.parent.checked,
        display: 'none',
        ':checked': {
            '~ span': {
                opacity: '.85'
            },
            '~ svg': {
                color: 'title'
            }
        }
    },
    Icon: {
        name: 'checkmark',
        round: 'X',
        fontSize: 'A',
        padding: 'W',
        boxSizing: 'content-box',
        cursor: 'pointer',
        background: 'line',
        color: 'disabled.35'
    },
    Span: {
        userSelect: 'none',
        text: 'This is variable font',
        opacity: '.5',
        cursor: 'pointer'
    }
};

});

parcelRegister("HwolS", function(module, exports) {

$parcel$export(module.exports, "ContinueButton", () => $082d24991784451c$export$16aabeb6d5633c80);
const $082d24991784451c$export$16aabeb6d5633c80 = {
    extends: [
        'Link',
        'Button'
    ],
    round: 'D',
    padding: 'Z1 D1',
    fontWeight: '600',
    theme: 'primary',
    color: 'title',
    whiteSpace: 'nowrap',
    text: 'Read the docs'
};

});

parcelRegister("9UFJm", function(module, exports) {

$parcel$export(module.exports, "ComingSoon", () => $7379b6d4d965701b$export$d92bac9ccf8f112f);
const $7379b6d4d965701b$export$d92bac9ccf8f112f = {
    position: 'relative',
    overflow: 'hidden',
    pointerEvents: 'none',
    minWidth: '10ch',
    minHeight: '5ch',
    ':before': {
        pointerEvents: 'auto',
        content: '""',
        position: 'absolute',
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        zIndex: 999999,
        background: 'document 0.9'
    },
    Span: {
        flow: 'y',
        position: 'absolute',
        transform: 'translate3d(-50%, -50%, 1px)',
        top: '50%',
        left: '50%',
        zIndex: '999999 + 1',
        whiteSpace: 'nowrap',
        lineHeight: 1.1,
        fontWeight: 'bold',
        color: 'disabled',
        textTransform: 'uppercase',
        fontSize: 'X2',
        align: 'center center',
        Strong: {
            flow: 'x',
            align: 'center',
            text: 'Branching'
        },
        Span: {
            fontWeight: 'normal',
            text: 'Coming soon'
        }
    }
};

});

parcelRegister("dfBCl", function(module, exports) {

$parcel$export(module.exports, "CommonFieldLike", () => $9a59db249085c603$export$d16d31b2f42ff96);
const $9a59db249085c603$export$d16d31b2f42ff96 = {
    tag: 'label',
    flow: 'column',
    align: 'flex-start',
    gap: 'Y1',
    minWidth: 'F',
    Title: {
        text: '',
        color: 'caption',
        userSelect: 'none',
        whiteSpace: 'nowrap'
    },
    element: {
        width: '100%'
    }
};

});

parcelRegister("28BFV", function(module, exports) {

$parcel$export(module.exports, "Contributors", () => $18e98da24a1b3458$export$5360f064464e9211);
const $18e98da24a1b3458$export$5360f064464e9211 = {
    flow: 'column',
    align: 'center flex-start',
    gap: 'D',
    position: 'relative',
    maxWidth: 'J1',
    Hgroup: {
        gap: 'B',
        textAlign: 'center',
        width: 'fit-content',
        color: 'white',
        padding: '- B',
        H: {
            text: 'Meet the creators',
            fontWeight: '100',
            fontSize: 'E1',
            margin: '0',
            '@mobileL': {
                lineHeight: 1,
                margin: '- - W'
            }
        },
        P: {
            margin: '0',
            color: 'title',
            text: 'Read our case studies how you can bootstrap, grow and scale your product with Symbols',
            fontSize: 'B',
            maxWidth: 'G2+B2',
            fontWeight: '100'
        }
    },
    Flex: {
        gap: 'A2',
        align: 'center center',
        flow: 'x wrap',
        padding: '- B1',
        '@mobileS': {
            padding: '- Z'
        },
        childProps: {
            boxSize: 'C',
            cursor: 'default',
            opacity: '.65',
            transition: 'opacity defaultBezier A',
            ':hover': {
                opacity: '1'
            }
        },
        childExtends: 'Avatar',
        children: [
            {
                alt: 'nikoloza',
                src: 'https://avatars.githubusercontent.com/u/962224?s=120&v=4'
            },
            {
                alt: 'svinchy',
                src: 'https://avatars.githubusercontent.com/u/36074573?s=120&v=4'
            },
            {
                alt: 'tokoyoung',
                src: 'https://avatars.githubusercontent.com/u/33081308?s=120&v=4'
            },
            {
                alt: 'gugakatsi',
                src: 'https://avatars.githubusercontent.com/u/9134169?s=120&v=4'
            },
            {
                alt: 'nikaoto',
                src: 'https://avatars.githubusercontent.com/u/21026339?s=120&v=4'
            },
            {
                alt: 'AlexTogonidze',
                src: 'https://avatars.githubusercontent.com/u/15612347?s=120&v=4'
            },
            {
                alt: 'denismemphis',
                src: 'https://avatars.githubusercontent.com/u/126146345?v=4'
            },
            {
                alt: 'MariamZedginidze',
                src: 'https://avatars.githubusercontent.com/u/66626385?v=4'
            },
            {
                alt: 'rezicosta',
                src: 'https://avatars.githubusercontent.com/u/26996528?v=4'
            },
            {
                alt: 'lberia',
                src: 'https://avatars.githubusercontent.com/u/17147261?v=4'
            },
            {
                alt: 'irakliberidze',
                src: 'https://avatars.githubusercontent.com/u/60253579?v=4'
            },
            {
                alt: 'burdulixda',
                src: 'https://avatars.githubusercontent.com/u/46271505?v=4'
            },
            {
                alt: 'joshSymbols',
                src: 'https://avatars.githubusercontent.com/u/145069451?v=4'
            },
            {
                alt: 'julianbraha',
                src: 'https://avatars.githubusercontent.com/u/11775551?v=4'
            },
            {
                alt: 'Thomas-sls',
                src: 'https://avatars.githubusercontent.com/u/190420750?v=4'
            },
            {
                alt: 'gustavo-mvp',
                src: 'https://avatars.githubusercontent.com/u/155124851?v=4'
            },
            {
                alt: 'AlexanderOttenhoff',
                src: 'https://avatars.githubusercontent.com/u/4759404?v=4'
            },
            {
                alt: 'zajim',
                src: 'https://avatars.githubusercontent.com/u/13951819?v=4'
            },
            {
                alt: 'elanor',
                src: 'https://avatars.githubusercontent.com/u/1854525?v=4'
            },
            {
                alt: 'sarmaakondi',
                src: 'https://avatars.githubusercontent.com/u/125581326?v=4'
            },
            {
                alt: 'franciso-smbl',
                src: 'https://avatars.githubusercontent.com/u/194151767?v=4'
            },
            {
                alt: 'frank0170',
                src: 'https://avatars.githubusercontent.com/u/75906369?v=4'
            },
            {
                alt: 'moises921',
                src: 'https://avatars.githubusercontent.com/u/189148078?v=4'
            },
            {
                alt: 'JerrayChen',
                src: 'https://avatars.githubusercontent.com/u/18450060?v=4'
            },
            {
                alt: 'lekyatummala11',
                src: 'https://avatars.githubusercontent.com/u/198639204?v=4'
            },
            {
                alt: 'ventura-v',
                src: 'https://avatars.githubusercontent.com/u/42718816?v=4'
            },
            {
                alt: 'baronsilver',
                src: 'https://avatars.githubusercontent.com/u/9947568?v=4'
            },
            {
                alt: 'Adeapt-Admin',
                src: 'https://avatars.githubusercontent.com/u/186253875?v=4'
            },
            {
                alt: 'allenbrokeit',
                src: 'https://avatars.githubusercontent.com/u/7524514?s=96&v=4'
            },
            {
                alt: 'Rafael-symbols',
                src: 'https://avatars.githubusercontent.com/u/200677621?s=96&v=4'
            },
            {
                alt: 'imadyaici',
                src: 'https://avatars.githubusercontent.com/u/7004223?s=96&v=4'
            },
            {
                alt: 'Manju134-hub',
                src: 'https://avatars.githubusercontent.com/u/202998880?s=96&v=4'
            },
            {
                alt: 'locngy',
                src: 'https://avatars.githubusercontent.com/u/18193324?s=96&v=4'
            },
            {
                alt: 'Marina-UX-UI',
                src: 'https://avatars.githubusercontent.com/u/198088652?s=96&v=4'
            },
            {
                alt: 'saisanjivani07',
                src: 'https://avatars.githubusercontent.com/u/203023761?s=96&v=4'
            },
            {
                alt: 'lekyatummala11',
                src: 'https://avatars.githubusercontent.com/u/198639204?s=96&v=4'
            },
            {
                alt: 'Lathika9Symbols',
                src: 'https://avatars.githubusercontent.com/u/202271754?s=96&v=4'
            },
            {
                alt: 'sluther',
                src: 'https://avatars.githubusercontent.com/u/38088?s=60&v=4'
            },
            {
                alt: 'zacharybetzen',
                src: 'https://avatars.githubusercontent.com/u/208991695?s=96&v=4'
            },
            {
                alt: 'trevor-ratliff',
                src: 'https://avatars.githubusercontent.com/u/4975372?s=96&v=4'
            },
            {
                alt: 'felgluz',
                src: 'https://avatars.githubusercontent.com/u/6673718?s=60&v=4'
            },
            {
                alt: 'leticia-chijo',
                src: 'https://avatars.githubusercontent.com/u/41638060?v=4'
            },
            {
                alt: 'meGusztav',
                src: 'https://avatars.githubusercontent.com/u/29795175?s=96&v=4'
            },
            {
                alt: 'Aimenle',
                src: 'https://avatars.githubusercontent.com/u/36975334?s=96&v=4'
            },
            {
                alt: 'ju-Skinner',
                src: 'https://avatars.githubusercontent.com/u/1633290?s=96&v=4'
            },
            {
                alt: 'JosephMassie',
                src: 'https://avatars.githubusercontent.com/u/2282073?s=96&v=4'
            },
            {
                alt: 'RuslanLabza',
                src: 'https://avatars.githubusercontent.com/u/64849926?s=96&v=4'
            }
        ]
    }
};

});

parcelRegister("6mtnW", function(module, exports) {

$parcel$export(module.exports, "DesignComponent", () => $4a1b976a9216285f$export$3544240ca2fd0e90);
const $4a1b976a9216285f$export$3544240ca2fd0e90 = {
    flow: 'column',
    minWidth: 'F1',
    maxWidth: 'F2',
    round: 'A',
    height: 'fit-content',
    theme: 'common-card-interactive',
    overflow: 'hidden',
    userSelect: 'none',
    DesignComponentHeader: {},
    DesignComponentProperties: {}
};

});

parcelRegister("lBblp", function(module, exports) {

$parcel$export(module.exports, "DesignComponentHeader", () => $fb95da65e1252e38$export$2988b5c0fe8e74eb);
const $fb95da65e1252e38$export$2988b5c0fe8e74eb = {
    tag: 'header',
    extends: [
        'DesignElement'
    ],
    minWidth: '100%',
    padding: 'Z1 Z2 Z1',
    flow: 'row',
    round: '0',
    align: 'flex-start',
    pointerEvents: 'none',
    '@dark': {
        background: 'gray3.5'
    },
    '@light': {
        borderBottom: '1px solid gray14'
    },
    WiderButton: {
        padding: 'Y2',
        icon: ({ state: state })=>state.icon,
        theme: ({ state: state })=>state.iconTheme
    },
    Hgroup: {
        H: {
            text: ({ state: state })=>state.title,
            fontWeight: '400',
            textTransform: 'capitalize'
        },
        P: {
            text: ({ state: state })=>state.paragraph,
            fontSize: 'Z1',
            maxWidth: 'F1'
        }
    }
};

});

parcelRegister("fm4cV", function(module, exports) {

$parcel$export(module.exports, "DescriptionField", () => $b2dc2c946d4d67d7$export$336230c809f2ec53);
const $b2dc2c946d4d67d7$export$336230c809f2ec53 = {
    extends: 'GroupField',
    Title: {
        text: 'Description'
    },
    Textarea: {
        round: 'Y',
        '@tabletS': {
            maxWidth: '100%'
        }
    }
};

});

parcelRegister("a0xrw", function(module, exports) {

$parcel$export(module.exports, "ContributorsCopy", () => $7493d88ca3485765$export$59043a8163a40b49);
const $7493d88ca3485765$export$59043a8163a40b49 = {
    flow: 'column',
    align: 'center flex-start',
    padding: '- A D',
    gap: 'B2',
    maxWidth: '920ypx',
    position: 'relative',
    Hgroup: {
        gap: '0',
        textAlign: 'center',
        width: 'fit-content',
        color: 'white',
        H: {
            text: 'Contributors',
            fontWeight: '700',
            '@mobileL': {
                lineHeight: 1,
                margin: '- - W'
            }
        },
        P: {
            color: 'gray9',
            text: 'Thanks these folks for the Github contribution'
        }
    },
    Flex: {
        gap: 'A2',
        align: 'center center',
        flow: 'x wrap',
        childProps: {
            boxSize: 'C',
            cursor: 'default',
            opacity: '.65',
            transition: 'opacity defaultBezier A',
            ':hover': {
                opacity: '1'
            }
        },
        childExtends: 'Avatar',
        children: [
            {
                alt: 'nikoloza',
                src: 'https://avatars.githubusercontent.com/u/962224?s=120&v=4'
            },
            {
                alt: 'svinchy',
                src: 'https://avatars.githubusercontent.com/u/36074573?s=120&v=4'
            },
            {
                alt: 'tokoyoung',
                src: 'https://avatars.githubusercontent.com/u/33081308?s=120&v=4'
            },
            {
                alt: 'gugakatsi',
                src: 'https://avatars.githubusercontent.com/u/9134169?s=120&v=4'
            },
            {
                alt: 'nikaoto',
                src: 'https://avatars.githubusercontent.com/u/21026339?s=120&v=4'
            },
            {
                alt: 'AlexTogonidze',
                src: 'https://avatars.githubusercontent.com/u/15612347?s=120&v=4'
            },
            {
                alt: 'denismemphis',
                src: 'https://avatars.githubusercontent.com/u/126146345?v=4'
            },
            {
                alt: 'MariamZedginidze',
                src: 'https://avatars.githubusercontent.com/u/66626385?v=4'
            },
            {
                alt: 'rezicosta',
                src: 'https://avatars.githubusercontent.com/u/26996528?v=4'
            },
            {
                alt: 'lberia',
                src: 'https://avatars.githubusercontent.com/u/17147261?v=4'
            },
            {
                alt: 'irakliberidze',
                src: 'https://avatars.githubusercontent.com/u/60253579?v=4'
            },
            {
                alt: 'burdulixda',
                src: 'https://avatars.githubusercontent.com/u/46271505?v=4'
            },
            {
                alt: 'joshSymbols',
                src: 'https://avatars.githubusercontent.com/u/145069451?v=4'
            },
            {
                alt: 'julianbraha',
                src: 'https://avatars.githubusercontent.com/u/11775551?v=4'
            },
            {
                alt: 'Thomas-sls',
                src: 'https://avatars.githubusercontent.com/u/190420750?v=4'
            },
            {
                alt: 'gustavo-mvp',
                src: 'https://avatars.githubusercontent.com/u/155124851?v=4'
            },
            {
                alt: 'AlexanderOttenhoff',
                src: 'https://avatars.githubusercontent.com/u/4759404?v=4'
            },
            {
                alt: 'zajim',
                src: 'https://avatars.githubusercontent.com/u/13951819?v=4'
            },
            {
                alt: 'elanor',
                src: 'https://avatars.githubusercontent.com/u/1854525?v=4'
            },
            {
                alt: 'sarmaakondi',
                src: 'https://avatars.githubusercontent.com/u/125581326?v=4'
            },
            {
                alt: 'franciso-smbl',
                src: 'https://avatars.githubusercontent.com/u/194151767?v=4'
            },
            {
                alt: 'frank0170',
                src: 'https://avatars.githubusercontent.com/u/75906369?v=4'
            },
            {
                alt: 'moises921',
                src: 'https://avatars.githubusercontent.com/u/189148078?v=4'
            },
            {
                alt: 'JerrayChen',
                src: 'https://avatars.githubusercontent.com/u/18450060?v=4'
            },
            {
                alt: 'lekyatummala11',
                src: 'https://avatars.githubusercontent.com/u/198639204?v=4'
            },
            {
                alt: 'ventura-v',
                src: 'https://avatars.githubusercontent.com/u/42718816?v=4'
            },
            {
                alt: 'baronsilver',
                src: 'https://avatars.githubusercontent.com/u/9947568?v=4'
            },
            {
                alt: 'Adeapt-Admin',
                src: 'https://avatars.githubusercontent.com/u/186253875?v=4'
            },
            {
                alt: 'allenbrokeit',
                src: 'https://avatars.githubusercontent.com/u/7524514?s=96&v=4'
            },
            {
                alt: 'Rafael-symbols',
                src: 'https://avatars.githubusercontent.com/u/200677621?s=96&v=4'
            },
            {
                alt: 'imadyaici',
                src: 'https://avatars.githubusercontent.com/u/7004223?s=96&v=4'
            },
            {
                alt: 'Manju134-hub',
                src: 'https://avatars.githubusercontent.com/u/202998880?s=96&v=4'
            },
            {
                alt: 'locngy',
                src: 'https://avatars.githubusercontent.com/u/18193324?s=96&v=4'
            },
            {
                alt: 'Marina-UX-UI',
                src: 'https://avatars.githubusercontent.com/u/198088652?s=96&v=4'
            },
            {
                alt: 'saisanjivani07',
                src: 'https://avatars.githubusercontent.com/u/203023761?s=96&v=4'
            },
            {
                alt: 'lekyatummala11',
                src: 'https://avatars.githubusercontent.com/u/198639204?s=96&v=4'
            },
            {
                alt: 'Lathika9Symbols',
                src: 'https://avatars.githubusercontent.com/u/202271754?s=96&v=4'
            },
            {
                alt: 'sluther',
                src: 'https://avatars.githubusercontent.com/u/38088?s=60&v=4'
            },
            {
                alt: 'zacharybetzen',
                src: 'https://avatars.githubusercontent.com/u/208991695?s=96&v=4'
            },
            {
                alt: 'trevor-ratliff',
                src: 'https://avatars.githubusercontent.com/u/4975372?s=96&v=4'
            },
            {
                alt: 'felgluz',
                src: 'https://avatars.githubusercontent.com/u/6673718?s=60&v=4'
            },
            {
                alt: 'leticia-chijo',
                src: 'https://avatars.githubusercontent.com/u/41638060?v=4'
            },
            {
                alt: 'greg',
                src: ''
            },
            {
                alt: 'elvin',
                src: ''
            },
            {
                alt: 'meGusztav',
                src: 'https://avatars.githubusercontent.com/u/29795175?s=96&v=4'
            },
            {
                alt: 'ju-Skinner',
                src: 'https://avatars.githubusercontent.com/u/1633290?s=96&v=4'
            },
            {
                alt: 'JosephMassie',
                src: 'https://avatars.githubusercontent.com/u/2282073?s=96&v=4'
            },
            {
                alt: 'RuslanLabza',
                src: 'https://avatars.githubusercontent.com/u/64849926?s=96&v=4'
            }
        ]
    }
};

});

parcelRegister("8pBXS", function(module, exports) {

$parcel$export(module.exports, "DocsHgroup", () => $61fe1b8d8d13dd45$export$d0bd6a6d5a38dd21);
const $61fe1b8d8d13dd45$export$d0bd6a6d5a38dd21 = {
    extends: [
        'Hgroup'
    ],
    flow: 'y',
    gap: 'Z',
    H: {},
    P: {
        maxWidth: '50%'
    }
};

});

parcelRegister("boq5v", function(module, exports) {

$parcel$export(module.exports, "DesignComponentProperties", () => $84b62c1922fcf5e0$export$4edbeb6fb8bbc9f9);
const $84b62c1922fcf5e0$export$4edbeb6fb8bbc9f9 = {
    padding: 'Z2 A',
    flow: 'column',
    gap: 'Z2',
    theme: 'common-box',
    children: (el, s)=>s.properties,
    childrenAs: 'state',
    childExtends: 'Flex',
    childProps: {
        gap: 'B',
        PropertyKey: {
            text: '{{ property }}',
            flex: 1,
            color: 'gray7'
        },
        Value: {
            text: '{{ value }}',
            flex: 1,
            fontWeight: '500'
        }
    }
};

});

parcelRegister("6petV", function(module, exports) {

$parcel$export(module.exports, "CopyButton", () => $4aa04f9dc411b051$export$4f2558dd25106ae2);
const $4aa04f9dc411b051$export$4f2558dd25106ae2 = {
    extends: 'IconButton',
    icon: 'copy outline',
    background: 'transparent',
    color: 'currentColor',
    isActive: false,
    padding: 'Y1',
    fontSize: 'Z',
    '--spacing-ratio': 1.2,
    onClick: (ev, el, s)=>{
        ev.preventDefault();
        ev.stopPropagation();
        el.update({
            Icon: {
                name: 'checkmark outline'
            }
        });
        const t = setTimeout(()=>{
            el.update({
                Icon: {
                    name: 'copy outline'
                }
            });
            clearTimeout(t);
        }, 1e3);
        el.call('copyStringToClipboard', el.call('exec', el.value || s.value, el, s));
    }
};

});

parcelRegister("dDsgT", function(module, exports) {

$parcel$export(module.exports, "DesignElement", () => $9ed4d903d573eebe$export$364f375b900ae8f8);
const $9ed4d903d573eebe$export$364f375b900ae8f8 = {
    extends: [
        'Link'
    ],
    width: '100%',
    flow: 'column',
    href: '/design-system',
    gap: 'Z2',
    padding: 'Z2 A',
    maxWidth: 'F1_default',
    round: 'Z2',
    transition: 'background 250ms',
    ':hover': {
        '@dark': {
            background: 'white.05'
        },
        '@light': {
            background: 'black.05'
        }
    },
    WiderButton: {
        align: 'center center',
        round: 'Z2',
        theme: 'default',
        tabIndex: '-1'
    },
    Hgroup: {
        fontWeight: '400',
        gap: 'X2',
        H: {
            fontSize: 'A',
            color: 'title'
        }
    }
};

});

parcelRegister("fl5oG", function(module, exports) {

$parcel$export(module.exports, "DocsLink", () => $b2ad00f5043af906$export$e816d7af81d48a79);
const $b2ad00f5043af906$export$e816d7af81d48a79 = {
    extends: 'Link',
    tag: 'a',
    fontWeight: 500,
    color: 'title',
    whiteSpace: 'nowrap',
    ':hover': {
        textDecoration: 'underline'
    },
    onClick: 'navigateDocs'
};

});

parcelRegister("h9CCw", function(module, exports) {

$parcel$export(module.exports, "DocsSocialLinks", () => $c7d13c1cf7f49d3f$export$524559a3e061ed0f);
const $c7d13c1cf7f49d3f$export$524559a3e061ed0f = {
    extends: 'ArticleSmall',
    maxWidth: 'G2',
    padding: '0 E1 0 0',
    H6: {
        text: 'Discussions'
    },
    P: {
        color: 'paragraph',
        margin: '0 0 A',
        text: 'Join our discussion boards at Github and Discord'
    },
    Flex: {
        tag: 'nav',
        childExtends: 'MenuItem',
        display: 'flex',
        gap: 'Z',
        Discord: {
            target: '_blank',
            href: 'https://discord.com/invite/crdFSkapFY',
            icon: 'discord'
        },
        Github: {
            target: '_blank',
            href: 'https://github.com/symbo-ls/',
            icon: 'github'
        },
        X: {
            target: '_blank',
            href: 'https://twitter.com/symbo_ls',
            icon: 'twitter'
        }
    }
};

});

parcelRegister("53qI7", function(module, exports) {

$parcel$export(module.exports, "DocsDesignElement", () => $3ae1f3c0a43aa966$export$e03e381bf0ac3ad);
const $3ae1f3c0a43aa966$export$e03e381bf0ac3ad = {
    flow: 'y',
    gap: 'Y2',
    WiderButton: {
        icon: 'space',
        theme: 'space'
    },
    ExplanatoryParagraph: {
        fontSize: 'Z',
        color: 'white.6',
        maxWidth: 'F1_default',
        lineHeight: 1.4285714285714286,
        margin: '0',
        padding: '0 0 0 V',
        children: [
            'Property of ',
            {
                color: 'white.85',
                text: 'shape'
            }
        ]
    }
};

});

parcelRegister("8BpRf", function(module, exports) {

$parcel$export(module.exports, "DocsSupportLinks", () => $6435d643d0dd9229$export$993b3998c249a588);
const $6435d643d0dd9229$export$993b3998c249a588 = {
    maxWidth: 'G2',
    margin: '- - - auto',
    H6: {
        tag: 'h6',
        text: 'Support'
    },
    P: {
        margin: '0',
        color: 'paragraph',
        childProps: {
            display: 'inline-block',
            margin: '0 X2 0 0'
        },
        children: [
            'Feel free to reach out to us at ',
            {
                DocsLink: {
                    fontWeight: 400,
                    text: 'Discord,',
                    href: 'https://discord.com/invite/crdFSkapFY'
                }
            },
            {
                DocsLink: {
                    fontWeight: 400,
                    text: 'Twitter,',
                    href: 'https://twitter.com/symbo_ls'
                }
            },
            ' or ',
            {
                DocsLink: {
                    fontWeight: 400,
                    text: 'hello@symbo.ls',
                    href: 'mailto:hello@symbo.ls'
                }
            }
        ]
    }
};

});

parcelRegister("3HrME", function(module, exports) {

$parcel$export(module.exports, "DotCaption", () => $2b1af0885a33d64f$export$481188a1fb26512f);
const $2b1af0885a33d64f$export$481188a1fb26512f = {
    tag: 'section',
    align: 'center flex-start',
    Dot: {
        width: 'A1',
        text: "\u2022",
        textDecoration: 'none',
        opacity: '0.35',
        color: 'paragraph'
    },
    Text: {
        ':hover': {
            textDecoration: 'underline'
        }
    }
};

});

parcelRegister("hi0cH", function(module, exports) {

$parcel$export(module.exports, "DragNdropUser", () => $c96446929ff3dcf7$export$26843ad08c732b7b);
const $c96446929ff3dcf7$export$26843ad08c732b7b = {
    flow: 'column',
    align: 'center center',
    gap: 'A',
    round: 'A',
    Avatar: {
        boxSize: 'C C',
        src: '{{ src }}'
    },
    Flex: {
        gap: 'Y',
        childProps: {
            padding: '0',
            boxSize: 'B B',
            background: 'gray4',
            round: 'Y1',
            color: 'gray7'
        },
        childExtends: 'IconButton',
        childrenAs: 'props',
        children: [
            {
                icon: 'reload'
            },
            {
                icon: 'trash'
            }
        ]
    }
};

});

parcelRegister("QkEdX", function(module, exports) {

$parcel$export(module.exports, "DotCaptionArticle", () => $09d4dfa94aa23bdb$export$5d88ac086568f080);
const $09d4dfa94aa23bdb$export$5d88ac086568f080 = {
    extends: 'Hgroup',
    gap: 'W1',
    H: {
        extends: [
            'Link',
            'DotCaption'
        ],
        tag: 'strong'
    },
    P: {
        padding: '0 0 0 A1'
    }
};

});

parcelRegister("ku4XL", function(module, exports) {

$parcel$export(module.exports, "DraggableRow", () => $ee9a7584a0f917ac$export$8f9583e8843556a2);
const $ee9a7584a0f917ac$export$8f9583e8843556a2 = {
    transition: 'A defaultBezier',
    transitionProperty: 'transform, opacity',
    minWidth: 'G',
    dragstart: {
        transform: 'scale(0.97)',
        opacity: '0',
        isDragging: true
    },
    onDragstart: (e, el, s)=>{
        e.stopPropagation();
        if (!el.parent.data) el.parent.data = {};
        el.update(el.dragstart);
        el.parent.data.fromIndex = el.key;
        el.parent.data.state = s.parent;
    },
    dragenter: {
        transform: 'scale(0.97)',
        opacity: '0.9'
    },
    onDragenter: (e, el, s)=>{
        e.preventDefault();
        e.stopPropagation();
        if (!el.parent.data) return;
        const isSame = el.parent.data.fromIndex === el.key;
        const isSameGroup = el.parent.data.state === s.parent;
        const isRootNode = e.target === el.node;
        if (isSame || !isSameGroup || isRootNode) return;
        el.parent.data.active = el.key;
        el.update(el.dragenter);
    },
    onDragover: (e, el, s)=>{
        e.stopPropagation();
        e.preventDefault();
        if (!el.parent.data) return;
        return false;
    },
    dragleave: {
        opacity: '1',
        transform: 'none'
    },
    onDragleave: (e, el, s)=>{
        e.preventDefault();
        e.stopPropagation();
        if (!el.parent.data) return;
        const isSame = el.parent.data.fromIndex === el.key;
        const isSameGroup = el.parent.data.state === s.parent;
        const isRootNode = e.target === el.node;
        if (isSame || !isSameGroup || isRootNode) return;
        el.parent.data.active = el.key;
        el.update(el.dragenter);
    },
    drop: {
        opacity: '1',
        transform: 'none'
    },
    onDrop: (e, el, s, ctx2)=>{
        if (!el.parent.data) return;
        const isSame = el.parent.data.fromIndex === el.key;
        const isSameGroup = el.parent.data.state === s.parent;
        if (isSame || !isSameGroup) return;
        if (e.stopPropagation) e.stopPropagation();
        const toIndex = el.key;
        s.parent.apply((state)=>ctx2.utils.swapItemsInArray(state, el.parent.data.fromIndex, toIndex));
        el.update(el.drop);
    },
    dragend: {
        opacity: '1',
        transform: 'none',
        isDragging: false
    },
    onDragend: (e, el, s)=>{
        el.update(el.dragend);
    },
    ':not(:hover) > footer': {
        pointerEvents: 'none',
        opacity: '0'
    },
    ':hover > footer, &:focus-within > footer': {
        pointerEvents: 'auto',
        opacity: '1'
    },
    draggable: true,
    IteratorFooter: {}
};

});

parcelRegister("U4pQL", function(module, exports) {

$parcel$export(module.exports, "DropdownArrow", () => $0a88a7fd728ef2fe$export$3d6d548c35afaaed);
const $0a88a7fd728ef2fe$export$3d6d548c35afaaed = {
    extends: 'Icon',
    fontSize: 'Y1',
    icon: 'arrowAngleDown',
    color: 'disabled'
};

});

parcelRegister("scw1T", function(module, exports) {

$parcel$export(module.exports, "DropdownField", () => $054c52fa6ef41589$export$9845fd3a57ad4be7);
const $054c52fa6ef41589$export$9845fd3a57ad4be7 = {
    extends: [
        'FocusableComponent'
    ],
    tag: 'button',
    theme: 'field',
    align: 'center space-between',
    padding: 'Y Y Y A',
    minWidth: 'F1',
    round: 'Z2',
    gap: 'Y',
    tabindex: '-1',
    StartButtons: {
        flow: 'x',
        gap: 'X1',
        align: 'center',
        childExtends: 'IconButton',
        childProps: {
            tabindex: '-1',
            theme: 'field-highlight',
            round: 'Y1',
            padding: 'Y1'
        }
    },
    Value: {
        flow: 'x',
        align: 'center flex-start',
        padding: '0 B 0 0',
        gap: 'Y2',
        Text: {
            text: (el, s)=>s.value || s.defaultValue || 'default'
        },
        Suffix: null
    },
    Buttons: {
        flow: 'x',
        gap: 'X1',
        align: 'center',
        childExtends: 'IconButton',
        childProps: {
            tabindex: '-1',
            theme: 'field-highlight',
            round: 'Y1',
            padding: 'Y1'
        },
        Arrow: {
            icon: 'arrow angle mirroring vertical'
        }
    },
    Dropdown: {
        top: '110%',
        left: '0'
    }
};

});

parcelRegister("lxIKl", function(module, exports) {

$parcel$export(module.exports, "DropdownHeader", () => $faef63c71b92abba$export$19b44e77c853705e);
const $faef63c71b92abba$export$19b44e77c853705e = {
    position: 'sticky',
    top: '0',
    align: 'center flex-start',
    fontSize: 'Z',
    padding: 'Z1 A1',
    zIndex: '1',
    theme: 'field-static',
    backdropFilter: 'blur(3px)',
    text: 'Dropdown title'
};

});

parcelRegister("eR6ol", function(module, exports) {

$parcel$export(module.exports, "Dropdown", () => $ad0af928ea821ce6$export$931cbfb6bfb85fc);
const $ad0af928ea821ce6$export$931cbfb6bfb85fc = {
    tag: 'section',
    attr: {
        dropdown: true
    },
    isDropdownRoot: true,
    theme: 'common-box',
    round: 'Z2',
    minWidth: 'F',
    maxHeight: 'H',
    transition: 'A defaultBezier',
    transitionProperty: 'visibility, transform, opacity',
    overflow: 'hidden auto',
    boxSizing: 'border-box',
    zIndex: 1000,
    borderColor: 'line',
    borderWidth: '1px',
    borderStyle: 'solid',
    left: '50%',
    transform: 'translate3d(0, -Z, 0)',
    position: 'absolute',
    opacity: '0',
    visibility: 'hidden',
    forcedVisible: false,
    '.preventAbsolute': {
        position: 'static'
    },
    '.forcedVisible': {
        opacity: '1',
        visibility: 'visible'
    },
    '@dark': {
        boxShadow: 'black.2 0 W Z W'
    },
    '@light': {
        boxShadow: 'gray5.2 0 W Z W'
    },
    onRender: (el)=>{
        var _a;
        const dropdown = el.node;
        const dropdownParentNode = (_a = el.parent) == null ? void 0 : _a.node;
        if (!dropdown || !dropdownParentNode) return;
        const yOffset = el.yOffset || '115%';
        const calculateDirection = ()=>{
            const dropdownParentRect = dropdownParentNode.getBoundingClientRect();
            const dropdownRect = dropdown.getBoundingClientRect();
            const dropdownHeight = dropdownRect.height;
            const spaceBelow = window.innerHeight - dropdownParentRect.bottom;
            const spaceAbove = dropdownParentRect.top;
            const shouldOpenUp = spaceBelow < dropdownHeight && spaceAbove > dropdownHeight;
            if (shouldOpenUp && el.bottom !== yOffset) el.update({
                top: '',
                bottom: yOffset
            });
            else if (!shouldOpenUp && el.top !== yOffset) el.update({
                bottom: '',
                top: yOffset
            });
        };
        dropdownParentNode.addEventListener('mouseenter', calculateDirection);
        return ()=>{
            dropdownParentNode.removeEventListener('mouseenter', calculateDirection);
        };
    },
    preventAbsolute: false
};

});

parcelRegister("29k5Z", function(module, exports) {

$parcel$export(module.exports, "DropdownItem", () => $190c0295b8aa4656$export$6648d5fa18559e7f);
const $190c0295b8aa4656$export$6648d5fa18559e7f = {
    boxShadow: 'none',
    round: '0',
    background: 'transparent 0',
    opacity: 0.75,
    transition: 'A',
    transitionProperty: 'visibility, color, background, opacity',
    onClick: async (ev, el, s, ctx2)=>await el.call('dropdownClick', ev, el, s, ctx2),
    '@dark': {
        color: 'gray13'
    },
    '@light': {
        background: 'gray15',
        color: 'gray4'
    },
    ':hover': {
        opacity: 1,
        '& svg': {
            opacity: 0.15
        },
        '@dark': {
            background: 'gray6.05'
        },
        '@light': {
            background: 'white.5'
        }
    },
    '.isActive': {
        fontWeight: '500',
        opacity: 1,
        '@dark': {
            background: 'gray6.15'
        },
        '@light': {
            background: 'white'
        },
        '& svg': {
            opacity: 0.5
        },
        ':hover': {
            '& svg': {
                opacity: 0.65
            },
            '@dark': {
                background: 'gray6.15'
            },
            '@light': {
                background: 'white'
            }
        }
    }
};

});

parcelRegister("bYCE2", function(module, exports) {

$parcel$export(module.exports, "ExplanatoryParagraph", () => $8b8346603e362248$export$86867ef7df4224fc);
const $8b8346603e362248$export$86867ef7df4224fc = {
    tag: 'p',
    color: 'paragraph',
    margin: 'A 0',
    gap: 'X',
    childProps: {
        tag: 'span'
    }
};

});

parcelRegister("3YGeE", function(module, exports) {

$parcel$export(module.exports, "DropdownCopy", () => $2e57bcbf4651d053$export$76d20b6109009999);
const $2e57bcbf4651d053$export$76d20b6109009999 = {};

});

parcelRegister("bPL12", function(module, exports) {

$parcel$export(module.exports, "FooteLite", () => $89d8ed79bb47fb08$export$92c3986a12472dc5);
const $89d8ed79bb47fb08$export$92c3986a12472dc5 = {
    tag: 'footer',
    align: 'center space-between',
    padding: 'B 0 0',
    width: '100%',
    margin: '- auto',
    gap: 'B',
    '@tabletL': {
        flow: 'column',
        gap: 'C1'
    },
    childProps: {
        '@tabletL': {
            width: '100%',
            padding: '0'
        }
    },
    Copy: {
        display: 'flex',
        gap: 'X2',
        lineHeight: '1',
        '@dark': {
            color: 'gray8'
        },
        '@light': {
            color: 'gray5'
        },
        DocsLink: {
            target: '_blank',
            href: 'https://symbols.app',
            text: 'Symbols'
        },
        Year: {
            text: " \xa9 2026"
        },
        DocsLink_version: {
            text: (el, s, ctx2)=>!ctx2.version ? "" : `TODO: smbls@^${ctx2.version}`,
            href: 'https://www.npmjs.com/smbls',
            target: '_blank',
            margin: '- - - A2',
            '@dark': {
                color: 'gray9'
            },
            '@light': {
                color: 'gray6'
            }
        }
    },
    DocsSocialLinks: {
        textAlign: 'end',
        H6: null,
        P: null,
        onRender: ()=>{}
    }
};

});

parcelRegister("gwbSH", function(module, exports) {

$parcel$export(module.exports, "Draggable", () => $c068d9dbe8e083b4$export$f2a139e5d18b9882);
const $c068d9dbe8e083b4$export$f2a139e5d18b9882 = {
    position: 'relative',
    transition: 'A defaultBezier',
    transitionProperty: 'transform, opacity',
    minWidth: 'G',
    ':not(:hover) > footer': {
        pointerEvents: 'none',
        height: 'A2',
        opacity: '0'
    },
    ':hover': {
        zIndex: 3
    },
    ':hover > footer, &:focus-within > footer': {
        pointerEvents: 'auto',
        height: 'B2',
        opacity: '1'
    },
    onDragstart: (e, el, s)=>{
        e.stopPropagation();
        if (!el.parent.data) el.parent.data = {};
        el.update({
            transform: 'scale(0.97)',
            opacity: '0',
            isDragging: true
        });
        el.parent.data.fromIndex = el.key;
        el.parent.data.state = s.parent;
    },
    onDragover: (e, el, s)=>{
        e.stopPropagation();
        e.preventDefault();
        if (!el.parent.data) return;
        return false;
    },
    onDragenter: (e, el, s)=>{
        e.preventDefault();
        e.stopPropagation();
        if (!el.parent.data) return;
        const isSame = el.parent.data.fromIndex === el.key;
        const isSameGroup = el.parent.data.state === s.parent;
        const isRootNode = e.target === el.node;
        if (isSame || !isSameGroup || isRootNode) return;
        el.parent.data.active = el.key;
        el.update({
            transform: `scale(0.97)`,
            opacity: '0.9'
        });
    },
    onDragleave: (e, el, s)=>{
        e.preventDefault();
        e.stopPropagation();
        if (!el.parent.data) return;
        const isSame = el.parent.data.fromIndex === el.key;
        const isSameGroup = el.parent.data.state === s.parent;
        const isRootNode = e.target === el.node;
        if (isSame || !isSameGroup || isRootNode) return;
        el.parent.data.active = el.key;
        el.update({
            opacity: '1',
            transform: 'none'
        });
    },
    onDrop: (e, el, s, ctx2)=>{
        if (!el.parent.data) return;
        const isSame = el.parent.data.fromIndex === el.key;
        const isSameGroup = el.parent.data.state === s.parent;
        if (isSame || !isSameGroup) return;
        if (e.stopPropagation) e.stopPropagation();
        const toIndex = el.key;
        s.parent.apply((state)=>ctx2.utils.swapItemsInArray(state, el.parent.data.fromIndex, toIndex));
        el.update({
            opacity: '1',
            transform: 'none'
        });
    },
    onDragend: (e, el, s)=>{
        el.update({
            opacity: '1',
            transform: 'none',
            isDragging: false
        });
    },
    draggable: true,
    IteratorFooter: {}
};

});

parcelRegister("aF5MQ", function(module, exports) {

$parcel$export(module.exports, "Group", () => $7c3238d94ef5b70d$export$eb2fcfdbd7ba97d4);
const $7c3238d94ef5b70d$export$eb2fcfdbd7ba97d4 = {
    flow: 'y',
    align: 'flex-start',
    gap: 'Y1',
    minWidth: 'F',
    childProps: {
        width: '100%'
    },
    Title: {
        text: 'Field Title',
        color: 'caption',
        userSelect: 'none',
        whiteSpace: 'nowrap'
    }
};

});

parcelRegister("gXyLr", function(module, exports) {

$parcel$export(module.exports, "GridInDropdown", () => $c58d1f7aeac4b9da$export$5b6caed92d26031);
const $c58d1f7aeac4b9da$export$5b6caed92d26031 = {
    extends: 'Grid',
    tag: 'nav',
    gridTemplateRows: 'repeat(1fr, 6)',
    autoColumns: 'auto',
    padding: 'X2',
    gap: 'Z2',
    children: (el)=>el.call('exec', el.parent.options, el.parent),
    childrenAs: 'state',
    content: {
        ignoreChildProps: true,
        ignoreChildExtends: true
    },
    childExtends: [
        'GridItem'
    ]
};

});

parcelRegister("kjIQ3", function(module, exports) {

$parcel$export(module.exports, "GridItem", () => $eca85cfcacb4f561$export$9eb849b9b922d396);
const $eca85cfcacb4f561$export$9eb849b9b922d396 = {
    extends: [
        'DropdownItem',
        'SquareButton'
    ],
    padding: 'Z2',
    Icon: {
        name: (el, s)=>s.key || el.key
    },
    text: null
};

});

parcelRegister("YBCA4", function(module, exports) {

$parcel$export(module.exports, "H1", () => $0b62c983254ca873$export$5523b16adee8048);
const $0b62c983254ca873$export$5523b16adee8048 = {
    extends: 'smbls.H1',
    color: 'title'
};

});

parcelRegister("ffzvn", function(module, exports) {

$parcel$export(module.exports, "GetEarlyAccess", () => $b1a3cc52d25c08df$export$776c5f5eb4ae3a34);
const $b1a3cc52d25c08df$export$776c5f5eb4ae3a34 = {
    flow: 'y',
    align: 'start start',
    gap: 'B2',
    padding: '0 A2 0 C2',
    width: 'G2',
    borderColor: 'line',
    borderStyle: 'solid',
    borderWidth: '0 0 0 1px',
    margin: '0',
    Hgroup: {
        H: {
            tag: 'strong',
            text: 'Get early access'
        },
        P: {
            text: `We're kicking off invite-only. Get early signup to make it to the top.`
        }
    },
    Link: {
        extends: [
            'Link',
            'Button'
        ],
        margin: '0 0 0 -X',
        theme: 'quaternary',
        fontWeight: '500',
        text: 'Join up',
        href: '/signup'
    }
};

});

parcelRegister("4qy3y", function(module, exports) {

$parcel$export(module.exports, "H4", () => $339402087c97e644$export$cc5e069d64fda823);
const $339402087c97e644$export$cc5e069d64fda823 = {
    extends: 'smbls.H4',
    color: 'title'
};

});

parcelRegister("f7Yn0", function(module, exports) {

$parcel$export(module.exports, "H5", () => $b03656ac97bb7665$export$88ef9fdaf11f7a1f);
const $b03656ac97bb7665$export$88ef9fdaf11f7a1f = {
    extends: 'smbls.H5',
    color: 'title'
};

});

parcelRegister("aCpWl", function(module, exports) {

$parcel$export(module.exports, "GroupField", () => $7bb19323c105b85b$export$8e163d09e82461a2);
const $7bb19323c105b85b$export$8e163d09e82461a2 = {
    extends: 'Group',
    tag: 'label'
};

});

parcelRegister("1OWjn", function(module, exports) {

$parcel$export(module.exports, "H2", () => $1537b16412f90698$export$cb94397127ac9363);
const $1537b16412f90698$export$cb94397127ac9363 = {
    extends: 'smbls.H2',
    color: 'title'
};

});

parcelRegister("e9agx", function(module, exports) {

$parcel$export(module.exports, "H3", () => $a4c9de7f3362e8d2$export$746be9e3a3dfff1f);
const $a4c9de7f3362e8d2$export$746be9e3a3dfff1f = {
    extends: 'smbls.H3',
    color: 'title'
};

});

parcelRegister("bmYet", function(module, exports) {

$parcel$export(module.exports, "FooterFull", () => $847078ab327f25d6$export$1f8e959b4ef8ee11);
const $847078ab327f25d6$export$1f8e959b4ef8ee11 = {
    flow: 'y',
    align: 'flex-start flex-start',
    width: '100%',
    padding: '- B2',
    gap: 'C',
    borderStyle: 'solid',
    borderColor: 'line',
    borderWidth: '1px 0 0 0',
    '@mobileL': {
        padding: '- A'
    },
    childProps: {
        minWidth: '100%',
        maxWidth: '100%'
    },
    Flex: {
        align: 'flex-start flex-start',
        padding: 'B1 A - Y',
        '@tabletS': {
            flow: 'y',
            gap: 'B2'
        },
        LinkSet: {
            flow: 'y',
            gap: 'C',
            align: 'flex-start flex-start',
            flex: '1',
            '@tabletS': {
                flow: 'x',
                align: 'center space-between',
                minWidth: '100%',
                maxWidth: '100%'
            },
            '@mobileL': {
                gap: 'B',
                wrap: 'wrap'
            },
            '@mobileM': {
                align: 'center flex-start'
            },
            childExtends: [
                'DocsLink',
                'IconText'
            ],
            childProps: {
                gap: 'X2',
                color: 'title',
                Icon: {
                    name: 'arrowUpRight'
                }
            },
            children: [
                {
                    text: 'Get started',
                    href: '/signup'
                },
                {
                    text: 'Go to dashboard',
                    href: '/signin'
                },
                {
                    text: 'Schedule a demo',
                    href: 'https://cal.com/symbols-josh/early-access',
                    target: '_blank'
                }
            ]
        },
        Product: {
            flow: 'y',
            align: 'flex-start flex-start',
            gap: 'A1',
            flex: '1',
            '@tabletS': {
                gap: 'Z',
                padding: 'A1 - - -'
            },
            Caption: {
                text: 'Product',
                fontWeight: '700',
                lineHeight: '1em',
                color: 'title'
            },
            Flex: {
                flow: 'y',
                align: 'flex-start flex-start',
                gap: 'A1',
                '@tabletS': {
                    flow: 'x',
                    wrap: 'wrap'
                },
                childProps: {
                    cursor: 'pointer',
                    fontWeight: '300',
                    color: 'caption'
                },
                childExtends: 'DocsLink',
                children: [
                    {
                        text: 'Explore (TBA)',
                        href: '/explore'
                    },
                    {
                        text: 'Library (TBA)',
                        href: '/library'
                    },
                    {
                        text: 'Experts (TBA)',
                        href: '/experts'
                    },
                    {
                        text: 'Pricing',
                        href: '/pricing'
                    }
                ]
            }
        },
        Developers: {
            flex: '1',
            flow: 'y',
            align: 'flex-start flex-start',
            gap: 'A1',
            '@tabletS': {
                gap: 'Z',
                padding: '- - A1 -'
            },
            Caption: {
                text: 'Developers',
                fontWeight: '700',
                lineHeight: '1em',
                color: 'title'
            },
            Flex: {
                flow: 'y',
                align: 'flex-start flex-start',
                gap: 'A1',
                '@tabletS': {
                    flow: 'x',
                    wrap: 'wrap'
                },
                '@mobileM': {
                    gap: '0'
                },
                childProps: {
                    cursor: 'pointer',
                    fontWeight: '300',
                    color: 'caption',
                    '@mobileM': {
                        padding: '- A1 X2 -'
                    }
                },
                childExtends: 'DocsLink',
                children: [
                    {
                        text: 'Onboarding',
                        href: '/docs/intro'
                    },
                    {
                        text: 'Building in Symbols',
                        href: '/docs/building-in-symbols'
                    },
                    {
                        text: 'Framework',
                        href: '/docs/framework'
                    },
                    {
                        text: 'SDK',
                        href: '/docs/sdk'
                    },
                    {
                        text: 'CLI',
                        href: '/docs/cli'
                    }
                ]
            }
        },
        Resources: {
            flow: 'y',
            align: 'flex-start flex-start',
            gap: 'A1',
            flex: '1',
            '@tabletS': {
                gap: 'Z',
                padding: 'A1 - - -'
            },
            Caption: {
                text: 'Resources',
                fontWeight: '700',
                lineHeight: '1em',
                color: 'title'
            },
            Flex: {
                flow: 'y',
                align: 'flex-start flex-start',
                gap: 'A1',
                '@tabletS': {
                    flow: 'x',
                    wrap: 'wrap'
                },
                childProps: {
                    cursor: 'pointer',
                    fontWeight: '300',
                    color: 'caption'
                },
                childExtends: 'DocsLink',
                children: [
                    {
                        text: 'Investors',
                        target: '_blank',
                        href: 'https://invest.symbo.ls'
                    },
                    {
                        text: 'Blog',
                        target: '_blank',
                        href: 'https://medium.com/symbolsapp'
                    },
                    {
                        text: 'Contact',
                        target: '_blank',
                        href: 'https://cal.com/symbols-josh/early-access'
                    }
                ]
            }
        },
        Companies: {
            flow: 'x',
            flex: '1',
            align: 'center flex-end',
            gap: 'A',
            '@mobileS': {
                minWidth: '100%',
                maxWidth: '100%',
                align: 'center space-between'
            },
            childProps: {
                target: '_blank'
            },
            childExtends: [
                'Link',
                'IconButton'
            ],
            children: [
                {
                    icon: 'twitter',
                    href: 'https://x.com/symbo_ls'
                },
                {
                    icon: 'medium',
                    href: 'https://medium.com/symbolsapp'
                },
                {
                    icon: 'github',
                    href: 'https://github.com/symbo-ls/'
                },
                {
                    icon: 'discord',
                    href: 'https://discord.com/invite/crdFSkapFY'
                },
                {
                    icon: 'npm',
                    href: 'https://www.npmjs.com/package/smbls'
                }
            ]
        }
    },
    Flex_2: {
        align: 'center flex-start',
        padding: '- Y',
        '@mobileM': {
            display: 'grid',
            columns: 'repeat(2, 1fr)',
            rowGap: 'A'
        },
        childProps: {
            fontWeight: '300',
            color: 'caption'
        },
        DocsLink: {
            text: 'Terms and conditions',
            margin: '- D - -',
            cursor: 'pointer',
            href: '/terms',
            '@mobileM': {
                margin: '- 0 - -',
                whiteSpace: 'nowrap'
            }
        },
        DocsLink_2: {
            text: 'Privacy terms',
            cursor: 'pointer',
            href: '/privacy',
            '@mobileM': {
                whiteSpace: 'nowrap',
                textAlign: 'right'
            }
        },
        P: {
            text: "Symbols \xa9 2020-2026",
            margin: '- - - auto',
            '@mobileM': {
                gridColumn: 'span 2',
                textAlign: 'left',
                margin: '- - - 0'
            }
        }
    }
};

});

parcelRegister("1mIHv", function(module, exports) {

$parcel$export(module.exports, "HeaderBreadcrumb", () => $0fea8523a16ccadb$export$f836de4f99592497);
const $0fea8523a16ccadb$export$f836de4f99592497 = {
    padding: '0',
    fontSize: 'Z2',
    Button_page: {
        extends: [
            'Button',
            'DropdownParentFocus'
        ],
        theme: 'tertiary',
        gap: 'Z',
        flow: 'row-reverse',
        padding: 'Y2 Z2',
        icon: 'arrow angle down',
        color: 'title',
        fontWeight: '400',
        text: (el)=>{
            const path = window.location.pathname.split("/")[1];
            if ([
                "dashboard",
                "governance",
                "tutorials"
            ].includes(path)) return el.call("capitalize", path);
            else if ([
                "docs",
                "developers",
                "api",
                "index",
                "framework"
            ].includes(path)) return "Documentation";
            else return "Canvas";
        },
        Icon: {
            minWidth: 'A'
        },
        Dropdown: {
            ListInDropdown: {
                children: (el)=>[
                        {
                            if: (el2, s)=>el2.isAuthorised(),
                            text: "Dashboard",
                            href: "/dashboard"
                        },
                        {
                            if: (el2, s)=>el2.isAuthorised(),
                            text: "Canvas",
                            href: el.getCanvasPathnameAnyway()
                        },
                        {
                            hide: (el2)=>!el2.getRootState("email")?.endsWith("@symbols.app"),
                            text: "Governance",
                            href: "/governance"
                        },
                        {
                            text: "Documentation",
                            href: "/developers"
                        },
                        {
                            hide: true,
                            text: "Tutorials",
                            href: "/tutorials"
                        },
                        {
                            text: "Examples",
                            href: "/docs/examples"
                        },
                        {
                            text: "Resources",
                            href: "/docs/resources"
                        }
                    ],
                childProps: {
                    textAlign: 'start',
                    padding: 'Z1 A',
                    color: 'inactive',
                    round: 'C1',
                    theme: null,
                    fontWeight: '400',
                    align: 'center start',
                    Text: null,
                    Caption: null,
                    Icon: {
                        order: 2,
                        margin: '- - - auto'
                    },
                    ':hover': {
                        theme: 'field'
                    },
                    '.isActive': {
                        theme: 'field'
                    }
                },
                childrenAs: 'props',
                childExtends: [
                    'Link',
                    'Button'
                ]
            },
            childrenAs: 'state',
            left: '0',
            align: 'start'
        }
    },
    Button_username: {
        extends: [
            'Button',
            'Link'
        ],
        hide: true,
        theme: 'transparent',
        ':hover': {
            theme: 'tertiary'
        },
        gap: 'X2',
        href: (el)=>"/" + el.getRootState("username"),
        flow: 'row-reverse',
        padding: 'Y2 Z2',
        text: (el)=>el.getRootState("username")
    },
    Button_project: {
        if: (el, s)=>el.isAuthorised(),
        extends: [
            'Button',
            'DropdownParentFocus'
        ],
        hide: (el)=>!el.getRootState("appKey") || !el.getRootState("appKey").split(".").length,
        theme: 'tertiary',
        gap: 'Z',
        flow: 'row-reverse',
        padding: 'Y2 Z2',
        icon: 'arrow angle down',
        href: (el, s)=>el.getCanvasPathname(),
        color: 'title',
        fontWeight: '500',
        maxWidth: 'F3',
        Text: {
            color: 'title',
            text: (el)=>{
                var _a;
                return (_a = el.getRootState("appKey")) == null ? void 0 : _a.split(".")[0];
            },
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            fontWeight: 'bold',
            lineHeight: '1.15',
            padding: '- - - X',
            maxWidth: '100%'
        },
        Icon: {
            minWidth: 'A'
        },
        Dropdown: {
            childrenAs: 'state',
            left: '0',
            align: 'start',
            onChoose: async (ev, el, s, ctx2, callee)=>{
                if (callee.href && !callee.isCanvas) await el.call("openModal", "/settings", {
                    key: callee.href
                });
            },
            ListInDropdown: {
                childProps: {
                    textAlign: 'start',
                    padding: 'Z1 A',
                    color: 'inactive',
                    round: 'C1',
                    theme: null,
                    fontWeight: '400',
                    align: 'center start',
                    Text: null,
                    Caption: null,
                    Icon: {
                        order: 2,
                        margin: '- - - auto'
                    },
                    ':hover': {
                        theme: 'field'
                    },
                    '.isActive': {
                        theme: 'field'
                    }
                },
                childrenAs: 'props',
                children: (el)=>[
                        {
                            extends: [
                                "Link",
                                "Button"
                            ],
                            text: "Go to Canvas",
                            hide: (el2)=>el2.isCanvas(),
                            href: el.getCanvasPathnameAnyway(),
                            isCanvas: true
                        },
                        {
                            text: "Open as URL",
                            onClick: "openInNewTab"
                        },
                        {
                            if: (el2)=>el2.isAdmin(),
                            text: "Project account",
                            href: "/project-account"
                        },
                        {
                            if: (el2)=>el2.isAdmin(),
                            text: "Invite member",
                            href: "/invite"
                        },
                        {
                            if: (el2)=>el2.isEditMode(),
                            text: "Project data",
                            href: "/project-data"
                        },
                        {
                            if: (el2)=>el2.isAdmin(),
                            text: "Connect",
                            href: "/connect"
                        },
                        {
                            text: "Install",
                            href: "/install"
                        },
                        {
                            if: (el2)=>el2.isEditMode(),
                            text: "Shared libraries",
                            href: "/shared-libs"
                        },
                        {
                            if: (el2)=>el2.isOwner(),
                            text: "Pricing",
                            href: "/pricing"
                        },
                        {
                            text: "Settings",
                            href: "/settings"
                        }
                    ]
            }
        }
    }
};

});

parcelRegister("gvmVa", function(module, exports) {

$parcel$export(module.exports, "H6", () => $c041523c5f7f677e$export$a559fb8039b06400);
const $c041523c5f7f677e$export$a559fb8039b06400 = {
    extends: 'smbls.H6',
    color: 'title'
};

});

parcelRegister("a8Ks7", function(module, exports) {

$parcel$export(module.exports, "HeaderHeading", () => $761eaf3b5026c260$export$206822ae6602dbd6);
const $761eaf3b5026c260$export$206822ae6602dbd6 = {
    tag: 'header',
    margin: '- - C2 -',
    Caption: {
        text: `Let's get started`,
        whiteSpace: 'nowrap',
        margin: '0',
        color: 'caption'
    },
    H1: {
        color: 'title',
        text: 'Create a Project',
        fontSize: 'H2',
        fontWeight: '700',
        margin: '0',
        height: 'fit-content'
    }
};

});

parcelRegister("4VFTK", function(module, exports) {

$parcel$export(module.exports, "HelloUser", () => $396cfc637b02eb0a$export$ef68763f7b656582);
const $396cfc637b02eb0a$export$ef68763f7b656582 = {
    margin: '- auto - -',
    color: 'title',
    text: (el)=>`Welcome ${el.getRootProjects().length > 0 ? " back, " : "to Symbols, "}${el.getRootState("username")} \u{1F44B} `
};

});

parcelRegister("9SkP4", function(module, exports) {

$parcel$export(module.exports, "IconLinkWithPath", () => $73094f257de7ae6f$export$45e3a50a8db50109);
const $73094f257de7ae6f$export$45e3a50a8db50109 = {
    extends: 'Article',
    gap: 'W',
    padding: '0 0 0 A1',
    IconCaption: {
        extends: [
            'IconCaption',
            'DocsLink'
        ],
        href: '{{ href }}',
        margin: '0 0 0 -A1',
        target: '_blank',
        gap: 'X1',
        Icon: {
            icon: 'github'
        },
        Text: {
            text: '{{ title }}',
            color: 'title'
        }
    },
    P: {
        color: 'paragraph',
        margin: '0',
        text: '{{ description }}'
    },
    DocsLink: {
        text: '{{ href }}',
        href: '{{ href }}',
        target: '_blank',
        color: 'grassgreen.85',
        fontWeight: '400'
    }
};

});

parcelRegister("1kkUF", function(module, exports) {

$parcel$export(module.exports, "IconCaption", () => $0f77e19b9872bac1$export$ccdbc3d0432988b9);
const $0f77e19b9872bac1$export$ccdbc3d0432988b9 = {
    align: 'center flex-start',
    gap: 'Y',
    color: 'caption',
    Icon: {
        icon: 'github',
        color: 'paragraph'
    },
    Text: {}
};

});

parcelRegister("dF8TG", function(module, exports) {

$parcel$export(module.exports, "Headline", () => $9f2601793129ddb3$export$e1faab0803786bcf);
const $9f2601793129ddb3$export$e1faab0803786bcf = {
    extends: 'smbls.Headline',
    color: 'subtitle'
};

});

parcelRegister("aTHR6", function(module, exports) {

$parcel$export(module.exports, "InputField", () => $7ef10f3a23af0824$export$dd2171e2b7d3bc5b);
const $7ef10f3a23af0824$export$dd2171e2b7d3bc5b = {
    extends: 'GroupField',
    Title: {},
    Input: {
        boxSizing: 'border-box',
        theme: 'field',
        display: 'block',
        widthRange: '0 100%',
        padding: 'Z1 A',
        round: 'Z2'
    }
};

});

parcelRegister("fLqEx", function(module, exports) {

$parcel$export(module.exports, "ItemAlt", () => $b79feb86b92d7b08$export$5bb46e2f94a2fbf6);
const $b79feb86b92d7b08$export$5bb46e2f94a2fbf6 = {
    flex: 1,
    gap: 'A2',
    flow: 'column',
    align: 'flex-start space-between',
    padding: 'A2 B B',
    '@mobileL': {
        flow: 'row'
    },
    Flex_header: {
        gap: 'A2',
        align: 'center flex-start',
        Icon: {
            fontSize: 'B2',
            name: 'tree'
        }
    },
    Img: {
        round: 'A',
        margin: '- - - -Z',
        aspectRatio: '16 / 9',
        height: '12em',
        src: 'https://p194.p3.n0.cdn.zight.com/items/rRuDJBlD/7f15d948-1604-4c5f-ad1f-d9aebe607f52.png?v=499b93d980e92921c72e5dc02b7e5ce2'
    },
    Flex_footer: {
        minWidth: 'auto',
        align: 'flex-end space-between',
        gap: 'E',
        ArticleMedium: {
            align: 'flex-start',
            width: '100%',
            maxWidth: 'F1',
            title: {
                text: 'What is Symbols?'
            },
            p: {
                text: 'A minute video explaining how to get started with Symbols'
            }
        }
    }
};

});

parcelRegister("9lpdD", function(module, exports) {

$parcel$export(module.exports, "ImageParagraph", () => $6cd9a32799968a07$export$3a4f115ceb1f5bf1);
const $6cd9a32799968a07$export$3a4f115ceb1f5bf1 = {
    color: 'white.8',
    align: 'center flex-start',
    gap: 'A',
    Svg: {
        boxSize: 'B1_default C2_default',
        color: 'gray6',
        fill: 'currentColor'
    },
    Paragraph: {
        maxWidth: 'E2_default',
        padding: 'Z 0 0 0'
    }
};

});

parcelRegister("5WD61", function(module, exports) {

$parcel$export(module.exports, "Hgroup", () => $4540b23a586fcdb7$export$bd5b3f7ef3b94a4a);
const $4540b23a586fcdb7$export$bd5b3f7ef3b94a4a = {
    tag: 'hgroup',
    flow: 'y',
    gap: 'Z',
    H: {
        tag: 'h3',
        text: 'Heading',
        lineHeight: '1em',
        color: 'title',
        margin: '0'
    },
    P: {
        text: 'Paragraph',
        margin: '0',
        color: 'paragraph'
    }
};

});

parcelRegister("3PQeI", function(module, exports) {

$parcel$export(module.exports, "ItemHighlight", () => $2caea78db3b56f16$export$2c1470bef49f6ff);
const $2caea78db3b56f16$export$2c1470bef49f6ff = {
    extends: 'Item',
    padding: 'B B1 A2 B1',
    round: 'Z2',
    flow: 'y',
    align: 'flex-start space-between',
    '@dark': {
        background: 'lightBlue.065',
        ':hover': {
            background: 'lightBlue.1'
        }
    },
    '@light': {
        theme: 'common-card'
    }
};

});

parcelRegister("l86iw", function(module, exports) {

$parcel$export(module.exports, "ItemHighlightAlt", () => $f61f3af25d9c4158$export$48f4043b750ac5e8);
const $f61f3af25d9c4158$export$48f4043b750ac5e8 = {
    extends: [
        'ItemHighlight'
    ],
    round: 'Z2',
    flow: 'y',
    align: 'flex-start space-between',
    margin: '- - - auto',
    width: '100%',
    padding: 'B B A',
    available: true,
    '@dark': null,
    '@light': null,
    '@screenM': {
        padding: 'B A A A1'
    },
    '@screenS': {
        gap: 'E1',
        padding: 'B B A'
    },
    '.available': {
        theme: 'common-card-interactive'
    },
    '!available': {
        order: 3,
        borderWidth: '1px',
        borderStyle: 'solid',
        background: 'none',
        theme: 'common-card-outline-interactive'
    },
    Icon: {},
    Hgroup: {
        P: {
            height: 'auto'
        }
    }
};

});

parcelRegister("jGDET", function(module, exports) {

$parcel$export(module.exports, "LabelTag", () => $e550b3e84b260f27$export$9dacaafb9baa8abc);
const $e550b3e84b260f27$export$9dacaafb9baa8abc = {
    extends: 'smbls.LabelTag',
    tag: 'label',
    round: 'Y1',
    theme: 'tertiary',
    text: '-2.902',
    padding: 'X Y',
    lineHeight: '1em'
};

});

parcelRegister("iXQIQ", function(module, exports) {

$parcel$export(module.exports, "IteratorFooter", () => $dce6a24184c21e3e$export$7144a1e5551709a2);
const $dce6a24184c21e3e$export$7144a1e5551709a2 = {
    tag: 'footer',
    width: '100%',
    align: 'center space-between',
    transition: 'B defaultBezier',
    transitionProperty: 'height, opacity',
    overflow: 'hidden',
    position: 'absolute',
    theme: 'header',
    bottom: 'calc(100% - var(--spacing-X))',
    left: '0',
    padding: 'X',
    gap: 'X',
    '@dark': {
        boxShadow: '--theme-document-dark-background.65 0 Z A -X'
    },
    '@light': {
        boxShadow: '--theme-document-light-background.65 0 Z A -X'
    },
    childProps: {
        theme: 'field'
    },
    SquareButton_moveUp: {
        isFirst: (el, s)=>parseInt(s.__element.__ref.__state) === 0,
        icon: 'arrowAngleUp',
        padding: '0',
        boxSize: 'B B',
        round: 'Y1',
        '.isFirst': {
            opacity: '.35',
            pointerEvents: 'none'
        },
        onClick: (ev, el, s)=>{
            const key = parseInt(s.__element.__ref.__state);
            s.parent.apply((state)=>ctx.utils.swapItemsInArray(state, key, key - 1));
        }
    },
    SquareButton_moveDown: {
        icon: 'arrowAngleDown',
        padding: '0',
        boxSize: 'B B',
        round: 'Y1',
        onClick: (ev, el, s)=>{
            const key = parseInt(s.__element.__ref.__state);
            s.parent.apply((state)=>ctx.utils.swapItemsInArray(state, key, key + 1));
        }
    },
    SquareButton_drag: {
        icon: 'drag outline',
        padding: '0',
        boxSize: 'B B',
        round: 'Y1'
    },
    SquareButton_plus: {
        margin: '0 0 0 auto',
        icon: 'plus',
        padding: '0',
        boxSize: 'B B',
        round: 'Y1',
        onClick: (ev, el, s)=>{
            const key = parseInt(s.__element.__ref.__state);
            s.parent.apply((state)=>state.splice(key + 1, 0, {}));
        }
    },
    SquareButton_trash: {
        icon: 'trash',
        padding: '0',
        boxSize: 'B B',
        round: 'Y1',
        onClick: (ev, el, s)=>{
            const key = s.__element.key;
            if (window.confirm("Do you want to remove item?")) s.parent.remove(key);
        }
    },
    SquareButton_copy: {
        icon: 'copy outline',
        padding: '0',
        boxSize: 'B B',
        round: 'Y1',
        onClick: (ev, el, s)=>{
            const key = parseInt(s.__element.__ref.__state);
            const value = ctx.utils.deepClone(s.parse());
            s.parent.apply((state)=>state.splice(key + 1, 0, value));
        }
    }
};

});

parcelRegister("cxY4b", function(module, exports) {

$parcel$export(module.exports, "LabeledLight", () => $92272907a62f06e4$export$b1da5946f36bbf07);
const $92272907a62f06e4$export$b1da5946f36bbf07 = {
    extends: 'Labeled',
    padding: 'U V',
    '@dark': {
        border: '1px solid gray6.1',
        background: 'gray3.65'
    },
    '@light': {
        border: '1px solid gray10.15',
        background: 'white'
    },
    color: 'paragraph'
};

});

parcelRegister("jLLgb", function(module, exports) {

$parcel$export(module.exports, "Item", () => $e64710f5e52564b0$export$6d08773d2e66f8f2);
const $e64710f5e52564b0$export$6d08773d2e66f8f2 = {
    extends: [
        'Link'
    ],
    width: '100%',
    padding: 'B B1 A2 B1',
    gap: 'D',
    round: 'Z2',
    flow: 'y',
    align: 'flex-start space-between',
    fontWeight: '400',
    href: '{{ href }}',
    '@tabletL': {
        padding: 'B',
        width: '100%',
        maxWidth: 'none'
    },
    state: {
        icon: 'tree outline',
        title: 'Design System',
        p: 'Organized brand tokens into design and code'
    },
    Icon: {
        fontSize: 'B2',
        icon: '{{ icon }}'
    },
    Hgroup: {
        H: {
            tag: 'h6',
            fontSize: 'A1',
            text: '{{ title }}'
        },
        P: {
            height: 'C1',
            text: '{{ p }}'
        },
        '@screenL': {
            maxWidth: 'F1'
        }
    }
};

});

parcelRegister("jL1PP", function(module, exports) {

$parcel$export(module.exports, "LandingFooterLite", () => $e623d4819ff46457$export$bf0a8887fa2f2b23);
const $e623d4819ff46457$export$bf0a8887fa2f2b23 = {
    width: '100%',
    padding: 'A B2',
    gap: 'A',
    align: 'center space-between',
    '@mobileL': {
        flow: 'column'
    },
    Flex_nav: {
        gap: 'B',
        childProps: {
            color: 'gray8',
            fontWeight: 'normal',
            ':hover': {
                textDecoration: 'underline'
            }
        },
        Link_access: {
            href: '/signin',
            text: 'Access'
        },
        Link_privacy: {
            href: '/privacy',
            text: 'Privacy'
        },
        Link: {
            href: 'mailto:hello@symbo.ls',
            text: 'Contact'
        }
    },
    Span_copyright: {
        flex: 1,
        textAlign: 'center',
        color: 'gray6',
        text: "2020-2026 \xa9 Symbols.app",
        '@mobileL': {
            order: 3
        }
    },
    Flex_icons: {
        gap: 'Z2',
        childProps: {
            color: 'gray8',
            theme: null,
            background: 'transparent',
            target: '_blank',
            fontSize: 'A2',
            ':hover': {
                color: 'gray8'
            }
        },
        childExtends: [
            'Link',
            'IconButton'
        ],
        children: [
            {
                icon: 'medium',
                href: 'https://symbols.blog/'
            },
            {
                icon: 'discord',
                href: 'https://discord.com/invite/crdFSkapFY'
            },
            {
                icon: 'github',
                href: 'https://github.com/symbo-ls/'
            }
        ],
        childrenAs: 'props'
    }
};

});

parcelRegister("97Skx", function(module, exports) {

$parcel$export(module.exports, "LayerSimple", () => $6a4ee961f24abe9c$export$9d44363f0944a5c);
const $6a4ee961f24abe9c$export$9d44363f0944a5c = {
    extends: 'Group',
    padding: 'Z A A A',
    margin: 'C -',
    round: 'Z2',
    gap: 'A',
    width: 'F1',
    background: 'gray4',
    Title: {
        text: 'Button'
    },
    Flex: {
        flow: 'y',
        gap: 'A',
        childProps: {
            gap: 'X',
            align: 'center'
        },
        childExtends: {
            Icon: {
                color: 'inactive',
                gap: 'Y1'
            },
            Span: {
                color: 'white',
                padding: '- - - X2'
            }
        },
        children: ()=>[
                {
                    Icon: {
                        icon: 'typography',
                        color: 'purple'
                    },
                    Span: {
                        text: 'Go Dark'
                    }
                },
                {
                    Icon: {
                        icon: 'shapeOutline',
                        color: 'indigo'
                    },
                    Span: {
                        text: 'moon'
                    }
                }
            ]
    }
};

});

parcelRegister("5Scc8", function(module, exports) {

$parcel$export(module.exports, "LibrariesRow", () => $446b74880185c891$export$ca484f140c50fdca);
const $446b74880185c891$export$ca484f140c50fdca = {
    extends: 'TemplatesRow',
    Caption: {
        text: 'Explore our libraries'
    },
    Scrollable: {
        childExtends: 'LibrariesRowItem',
        children: ()=>[
                {
                    poster: "https://api.symbols.app/core/files/public/68b667ce424350c909ec03f9/download",
                    projectPath: "nikoloza/default",
                    amount: 206,
                    title: "Default"
                },
                {
                    poster: "https://api.symbols.app/core/files/public/68b667c8424350c909ec03d4/download",
                    projectPath: "nikoloza/ecommerce",
                    amount: 271,
                    title: "Ecommerce"
                },
                {
                    poster: "https://api.symbols.app/core/files/public/68b667ac424350c909ec034e/download",
                    projectPath: "nikoloza/forms",
                    amount: 248,
                    title: "Forms"
                },
                {
                    poster: "https://api.symbols.app/core/files/public/68b667c2424350c909ec03a6/download",
                    projectPath: "nikoloza/ai",
                    amount: 213,
                    title: "AI"
                },
                {
                    poster: "https://api.symbols.app/core/files/public/68b667d6424350c909ec0421/download",
                    projectPath: "nikoloza/web3",
                    amount: 85,
                    title: "Web3"
                },
                {
                    poster: "https://api.symbols.app/core/files/public/68b667db424350c909ec044f/download",
                    projectPath: "nikoloza/content-and-marketing",
                    amount: 275,
                    title: "Content & Marketing"
                },
                {
                    poster: "https://api.symbols.app/core/files/public/68b66c9b424350c909ec1f66/download",
                    projectPath: "nikoloza/docs",
                    amount: 598,
                    title: "Docs"
                },
                {
                    poster: "https://api.symbols.app/core/files/public/68b671ef424350c909ec5342/download",
                    projectPath: "nikoloza/charts",
                    amount: 0,
                    title: "Charts"
                },
                {
                    poster: "https://api.symbols.app/core/files/public/68b66bfb424350c909ec1eb4/download",
                    projectPath: "nikoloza/ui",
                    amount: 0,
                    title: "No-code"
                },
                {
                    poster: "https://api.symbols.app/core/files/public/68b672ad424350c909ec544b/download",
                    projectPath: "nikoloza/cms",
                    amount: 0,
                    title: "CMS"
                },
                {
                    poster: "https://api.symbols.app/core/files/public/68b66c19424350c909ec1f0c/download",
                    projectPath: "nikoloza/code",
                    amount: 0,
                    title: "Code"
                },
                {
                    poster: "https://api.symbols.app/core/files/public/68b63fae424350c909ea336e/download",
                    projectPath: "nikoloza/miscellaneous",
                    amount: 0,
                    title: "Miscellaneous"
                }
            ]
    }
};

});

parcelRegister("03B9U", function(module, exports) {

$parcel$export(module.exports, "KeyValueColumnFields", () => $00ad1ae69bf2c7a3$export$cf9d2c7f5d1a7230);
const $00ad1ae69bf2c7a3$export$cf9d2c7f5d1a7230 = {
    extends: [
        'DropdownItem',
        'Button'
    ],
    textAlign: 'start',
    align: 'center flex-start',
    padding: 'A',
    fontSize: 'Z1',
    href: '{{ href }}',
    onClick: async (ev, el, s, ctx2)=>await el.call("dropdownClick", ev, el, s, ctx2),
    Icon: {
        name: 'checkmark',
        opacity: '0',
        transition: 'A opacity',
        margin: '- Y1 - W1'
    },
    Text: {
        color: 'title',
        text: (el, s)=>s.text || s.value || s.key || ""
    },
    Caption: {
        marginLeft: 'Z2',
        textTransform: 'capitalize',
        color: 'caption',
        whiteSpace: 'nowrap',
        text: ''
    }
};

});

parcelRegister("a0Rti", function(module, exports) {

$parcel$export(module.exports, "LibrariesRowItem", () => $74a361cd9583901d$export$88e8d99c799a782c);
const $74a361cd9583901d$export$88e8d99c799a782c = {
    extends: [
        'TemplatesRowItem'
    ],
    poster: 'https://api.symbols.app/core/files/public/68b667ce424350c909ec03f9/download',
    projectPath: 'nikoloza/default',
    amount: 206,
    title: 'Default',
    previewUrl: null,
    Box: {},
    Span: {
        Span: {
            if: (el, s)=>!!s.amount,
            margin: '- - - A',
            fontWeight: '100',
            fontSize: 'Z2',
            text: ' ({{ amount }} resources)',
            color: 'paragraph'
        }
    }
};

});

parcelRegister("b7o9M", function(module, exports) {

$parcel$export(module.exports, "IconButton", () => $8183162b83389dfd$export$c25acd513dcc8062);
const $8183162b83389dfd$export$c25acd513dcc8062 = {
    extends: [
        'SquareButton'
    ],
    theme: 'tertiary',
    position: 'relative',
    round: 'Z2',
    draggable: false
};

});

parcelRegister("3ZzEG", function(module, exports) {

$parcel$export(module.exports, "ItemOutline", () => $2e82b9f641946a74$export$e215a18fe07277cc);
const $2e82b9f641946a74$export$e215a18fe07277cc = {
    extends: [
        'Item',
        'ClickableItem'
    ],
    hasHref: null,
    padding: 'A B',
    theme: 'common-card-outline-interactive',
    borderWidth: '1px',
    borderStyle: 'solid',
    '!hasHref': {
        pointerEvents: 'none',
        opacity: 0.35
    }
};

});

parcelRegister("929VG", function(module, exports) {

$parcel$export(module.exports, "Labeled", () => $693c00b968b47573$export$fd4dc8aaf4bd92f);
const $693c00b968b47573$export$fd4dc8aaf4bd92f = {
    tag: 'span',
    whiteSpace: 'nowrap',
    color: 'caption',
    lineHeight: '1',
    padding: '0 W1',
    round: 'X2',
    '@dark': {
        border: '1px solid gray6.15',
        background: 'gray3'
    },
    '@light': {
        border: '1px solid gray10.15',
        background: 'white.5'
    }
};

});

parcelRegister("eVuWq", function(module, exports) {

$parcel$export(module.exports, "LabeledHighlight", () => $adde63e05f5a048b$export$894c907407a93b5f);
const $adde63e05f5a048b$export$894c907407a93b5f = {
    extends: 'Labeled',
    padding: 'U V',
    '@dark': {
        border: '1px solid gray6.1',
        background: 'gray3.65'
    },
    '@light': {
        border: '1px solid gray10.15',
        background: 'white'
    },
    color: 'title'
};

});

parcelRegister("kDniw", function(module, exports) {

$parcel$export(module.exports, "LoadingGif", () => $f05985a18b706751$export$6111cf07b0d59153);
const $f05985a18b706751$export$6111cf07b0d59153 = {
    extends: 'Img',
    src: 'https://assets.symbo.ls/loading.gif',
    width: '3.2em',
    pointerEvents: 'none',
    opacity: '.35',
    zIndex: '-1',
    inCenter: true,
    '.inCenter': {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate3d(-50%, -50%, 0)'
    }
};

});

parcelRegister("34P8p", function(module, exports) {

$parcel$export(module.exports, "Line", () => $23d9691d909fe150$export$17d680238e50603e);
$parcel$export(module.exports, "Hr", () => $23d9691d909fe150$export$c65504044f62f430);
const $23d9691d909fe150$export$17d680238e50603e = {
    margin: 'D 0',
    padding: '0',
    theme: 'line',
    background: 'line',
    heightRange: '1px'
};
const $23d9691d909fe150$export$c65504044f62f430 = {
    margin: 'D 0',
    padding: '0',
    theme: 'line',
    background: 'line',
    heightRange: '1px'
};

});

parcelRegister("fF7X5", function(module, exports) {

$parcel$export(module.exports, "LoadingGifSection", () => $b670da73fc64fb03$export$ba2a7fab645f3ee0);
const $b670da73fc64fb03$export$ba2a7fab645f3ee0 = {
    position: 'relative',
    LoadingGif: {}
};

});

parcelRegister("2U3gr", function(module, exports) {

$parcel$export(module.exports, "Logo", () => $21d357ebbc85b314$export$e6ff31bff12b7ff4);
const $21d357ebbc85b314$export$e6ff31bff12b7ff4 = {
    extends: [
        'SquareButton'
    ],
    icon: 'logov2',
    boxSize: '1.25em',
    aspectRatio: '1 / 1',
    transition: 'B defaultBezier',
    transitionProperty: 'background, color',
    background: 'transparent 0',
    margin: 'U',
    padding: 'X',
    round: '100%',
    color: 'title',
    zIndex: 9999999,
    position: 'fixed',
    top: 'X2',
    left: 'Y',
    ':focus-within': {
        zIndex: 9990100
    },
    '@dark': {
        color: 'white'
    },
    '@light': {
        color: 'black'
    },
    ':hover': {
        '@dark': {
            color: 'gray15',
            background: 'gray3'
        },
        '@light': {
            color: 'black',
            background: 'white'
        }
    },
    '.isActive': {
        '@dark': {
            color: 'gray15',
            background: 'gray3'
        },
        '@light': {
            color: 'black',
            background: 'white'
        }
    },
    onClick: (ev, el)=>{
        ev.preventDefault();
        if (el.isEmbed()) return;
        if (el.isDocs()) {
            el.node.blur();
            return el.router('/developers', el.getRoot());
        }
        if (!el.isDashboard()) {
            el.node.blur();
            return el.router('/', el.getRoot());
        }
    },
    Link: {
        if: (el)=>el.call('isEmbed'),
        position: 'absolute',
        inset: '0',
        zIndex: 9,
        href: `'https://symbols.app' + window.location.pathname.split('/embed')[1]`,
        target: '_blank'
    },
    Icon: {
        fontSize: '1.26em'
    },
    Span: {
        animation: 'slideInOut',
        animationDelay: 'B',
        animationDuration: 'K',
        animationTimingFunction: 'defaultBezier',
        position: 'absolute',
        top: '50%',
        left: '95%',
        color: 'orange',
        fontWeight: '500',
        fontSize: 'X',
        text: 'BETA',
        transform: 'translate3d(0, 50%, 0)',
        opacity: '0'
    }
};

});

parcelRegister("6kfhQ", function(module, exports) {

$parcel$export(module.exports, "LogoCopy", () => $49b077fe74181c0c$export$7dde25639b6e0270);
const $49b077fe74181c0c$export$7dde25639b6e0270 = {
    extends: [
        'Link',
        'SquareButton'
    ],
    icon: 'logo',
    isActive: ()=>window.location.pathname === "/dashboard",
    fontSize: 'C',
    text: null,
    href: '/',
    position: 'relative',
    color: 'gray13',
    transition: 'B defaultBezier',
    transitionProperty: 'background, color',
    background: 'transparent 0',
    margin: 'W',
    padding: 'Y',
    round: '100%',
    '@dark': {
        color: 'white'
    },
    '@light': {
        color: 'black'
    },
    ':hover': {
        '@dark': {
            color: 'gray15',
            background: 'gray3'
        },
        '@light': {
            color: 'black',
            background: 'white'
        }
    },
    '.isActive': {
        '@dark': {
            color: 'gray15',
            background: 'gray3'
        },
        '@light': {
            color: 'black',
            background: 'white'
        }
    },
    Span: {
        animation: 'slideInOut',
        animationDelay: 'B',
        animationDuration: 'K',
        animationTimingFunction: 'defaultBezier',
        position: 'absolute',
        top: '50%',
        left: '85%',
        color: 'orange',
        fontSize: '.45em',
        fontWeight: '500',
        text: 'BETA',
        transform: 'translate3d(0, 50%, 0)',
        opacity: '0'
    }
};

});

parcelRegister("c5Jj3", function(module, exports) {

$parcel$export(module.exports, "MadeOnSymbols", () => $8cd918927c059d8f$export$6fd487ae10a7b02b);
const $8cd918927c059d8f$export$6fd487ae10a7b02b = {
    extends: 'TemplatesRow',
    Caption: {
        text: '#madeonsymbols'
    },
    Scrollable: {
        childProps: {
            href: '{{ href }}'
        },
        children: [
            {
                poster: 'https://api.symbols.app/core/files/public/68b43aac424350c909e4f047/download',
                href: 'https://tech-dash.symbo.ls',
                title: 'TechBrother',
                previewUrl: null
            },
            {
                poster: 'https://api.symbols.app/core/files/public/68b43e2b424350c909e4fa6f/download',
                href: 'https://mankanet.symbo.ls',
                title: 'Mankanet',
                previewUrl: null
            },
            {
                poster: 'https://api.symbols.app/core/files/public/68b446dd424350c909e50d4e/download',
                href: 'https://nocost.symbo.ls',
                title: 'NoCost',
                previewUrl: null
            },
            {
                poster: 'https://api.symbols.app/core/files/public/68b65ee1424350c909ebc8a1/download',
                href: 'https://fresh.symbo.ls',
                title: 'FreshCo',
                previewUrl: null
            },
            {
                poster: 'https://api.symbols.app/core/files/public/68b66083424350c909ebd66a/download',
                href: 'https://bessi.symbo.ls',
                title: 'Christmas Shop',
                previewUrl: null
            },
            {
                poster: 'https://api.symbols.app/core/files/public/68b6749b424350c909ec6fcf/download',
                href: 'https://qartool.symbo.ls',
                title: 'Qartool',
                previewUrl: null
            },
            {
                poster: 'https://api.symbols.app/core/files/public/68b67552424350c909ec7534/download',
                href: 'https://moll.symbo.ls',
                title: 'Mollie',
                previewUrl: null
            }
        ]
    }
};

});

parcelRegister("c36nN", function(module, exports) {

$parcel$export(module.exports, "LogoLoader", () => $8c5ab751ba32e329$export$aad50578967112e3);
const $8c5ab751ba32e329$export$aad50578967112e3 = {
    '& svg': {
        opacity: '.35',
        boxSize: '2.2em',
        transitionDuration: '1.5s, 1.5s, 1s, 1s',
        transitionDelay: '0s, 0s, 1.5s, 1.5s',
        transitionProperty: 'stroke-dashoffset, stroke-dasharray, fill, opacity',
        fill: 'transparent',
        stroke: 'currentColor',
        strokeWidth: '.5px',
        strokeDasharray: '242',
        strokeDashoffset: '242'
    },
    '& path': {},
    onBeforeUpdate: (ch, el, s, ctx2, opts)=>{
        if (opts.updateByState) return false;
    },
    onRender: (el)=>{
        window.setTimeout(()=>{
            el.update({
                '& svg': {
                    opacity: '1',
                    strokeDasharray: '242',
                    strokeDashoffset: '0',
                    fill: 'currentColor'
                }
            });
        }, 500);
    },
    html: '<svg xmlns="http://www.w3.org/2000/svg" width="41" height="42" viewBox="0 0 41 42"><path fill-rule="evenodd" d="M26.6448969,0.699064106 C31.4862479,1.83000067 35.6718819,4.48073656 38.3104478,8.91022511 C40.5212645,12.5974948 41.4936378,17.0951724 40.5085112,21.3679841 C39.7174644,25.0315254 37.8558379,27.853625 34.8002871,29.8369535 C31.9792925,31.7073227 27.90737,32.069064 24.6776501,31.3213124 C23.2887047,30.9944607 20.6411869,29.9775216 19.044333,28.0178349 C17.5928447,26.2365433 17.1250067,23.5192397 17.0461096,22.8419583 C16.9044422,21.6258334 17.1065683,20.249997 17.3800113,19.0276209 C17.9614095,16.4655592 18.9984397,14.7924534 21.1401118,13.3818866 C22.95018,12.1750388 24.6834696,11.8738651 26.7601335,12.3496124 C28.1855093,12.6880929 29.4520072,13.526716 30.3514025,14.7276098 C30.6271426,15.093878 30.8260324,15.4389318 31.059655,15.8362933 L30.9598079,15.7715366 C29.6377659,14.9422902 28.1654404,14.6590001 26.6448969,15.0752526 C25.2996601,15.4486698 24.1453463,16.3687006 23.4390969,17.6304467 C22.6973258,18.9448239 22.4839364,20.5087166 22.8465467,21.9733145 C23.2152637,23.4394215 24.1276197,24.6832715 25.381967,25.429977 C26.7647836,26.2608222 28.5893081,26.47537 30.1320438,26.0161118 C32.0344739,25.4497656 33.5958796,24.1165457 34.5824098,22.3233381 C35.8078311,20.0959926 36.0316242,17.5753145 35.4197363,15.1376991 C34.8712232,12.9726344 33.491011,11.1258939 31.7578503,9.86101942 C28.3978494,7.40873928 23.8145474,6.88014849 19.8961329,8.1555193 C16.9596954,9.11146975 14.399202,11.0657028 12.6221782,13.707146 C10.5375814,16.8894059 9.73736372,20.794518 10.3986926,24.5579956 C10.9302311,27.7327705 12.5716868,31.0242929 14.8485647,33.1339502 C15.5517576,33.7855358 16.0056239,34.2996296 16.8186608,34.9238068 C16.1252729,35.6670587 15.729719,36.1210912 15.0276006,36.8553491 L10.5425168,41.6144377 C8.59431563,40.2572487 6.84060794,38.6181461 5.33246714,36.7448351 C1.65619854,32.1632109 -0.0655234106,26.1858125 0.562658817,20.1851649 C1.1000136,14.4158268 3.81414269,9.08050481 8.0996615,5.36924966 C12.3107417,1.69300072 17.6911238,0.0107792851 23.1108097,0.299129816 C25.006381,0.458182488 26.18441,0.591493918 26.6448969,0.699064106 Z"/></svg>'
};

});

parcelRegister("kgWRy", function(module, exports) {

$parcel$export(module.exports, "MainLoader", () => $ec22f6369dcb9cb7$export$d330003798a27f99);
const $ec22f6369dcb9cb7$export$d330003798a27f99 = {
    attr: {
        id: 'main-loader'
    },
    position: 'fixed',
    boxSize: '100% 100%',
    inset: '0 0 0 0',
    zIndex: 9990099,
    pointerEvents: 'none',
    theme: 'document',
    overflow: 'hidden',
    animation: 'scaleOutIn',
    animationDuration: 'E',
    LoaderRatio: {
        position: 'absolute',
        zIndex: 1
    },
    LogoLoader: {
        zIndex: 2,
        position: 'absolute',
        top: '50%',
        left: '50%',
        fontSize: '1em',
        transform: 'translate3d(-50%, -50%, 0)'
    }
};

});

parcelRegister("esg1s", function(module, exports) {

$parcel$export(module.exports, "ListInDropdown", () => $a8601bf2209ca114$export$2e1382a2571ac79c);
const $a8601bf2209ca114$export$2e1382a2571ac79c = {
    tag: 'nav',
    flow: 'y',
    gap: 'W',
    align: 'stretch flex-start',
    children: (el)=>el.call('exec', el.parent.options, el.parent),
    childrenAs: 'state',
    content: {
        ignoreChildProps: true,
        ignoreChildExtends: true
    },
    childExtends: [
        'KeyValueColumnFields'
    ]
};

});

parcelRegister("3HVEt", function(module, exports) {

$parcel$export(module.exports, "LoaderRatio", () => $2b321badfac273c4$export$519dfb4ed033765e);
const $2b321badfac273c4$export$519dfb4ed033765e = {
    position: 'fixed',
    boxSize: '100% 100%',
    inset: '0 0 0 0',
    zIndex: 9990099,
    pointerEvents: 'none',
    theme: 'document',
    overflow: 'hidden',
    animationDuration: 'E',
    color: 'dim',
    ':after': {
        content: '""',
        position: 'absolute',
        width: '100%',
        height: '100%',
        top: '50%',
        left: '50%',
        transform: 'translate3d(-50%, -50%, 0)',
        round: '100%',
        '@dark': {
            background: `radial-gradient(
          circle,
          rgba(5, 5, 5, 0.98) 6.5%,
          rgba(5, 5, 5, 0) 75%
        )`
        },
        '@light': {
            background: `radial-gradient(
          circle,
          rgba(241, 241, 243, 0.98) 6.5%,
          rgba(241, 241, 243, 0) 75%
        )`
        }
    },
    Spinner: {
        opacity: '0.275',
        position: 'absolute',
        boxSize: '100%',
        inset: 0,
        display: 'flex',
        align: 'center center',
        '& > svg': {
            tranformOrigin: '50% 50%',
            position: 'absolute',
            animation: 'rotate',
            animationDuration: '10.818s',
            animationTimingFunction: 'linear',
            animationIterationCount: 'infinite'
        },
        html: '<svg xmlns="http://www.w3.org/2000/svg" width="2684" height="2685"><g fill="none" fill-rule="evenodd" stroke="currentColor"><path d="M2 1660.694C2 1026.356 516.319 512.123 1150.763 512.123M1861.137 1222.378c0-392.263-318.045-710.255-710.374-710.255M1422.748 1660.694c242.116 0 438.39-196.24 438.39-438.316M1150.763 1389.902c0 149.554 121.258 270.792 270.838 270.792M1150.763 1389.902c0-92.52 75.016-167.524 167.552-167.524M1421.6 1325.646a103.26 103.26 0 0 0-30.251-73.021 103.294 103.294 0 0 0-73.034-30.247M1421.6 1325.646a64.25 64.25 0 0 1-18.823 45.436 64.272 64.272 0 0 1-45.443 18.82"/><path d="M1318.315 1349.742a40.156 40.156 0 0 0 11.765 28.397 40.17 40.17 0 0 0 28.402 11.763M1318.315 1349.742c0-13.308 10.79-24.096 24.1-24.096M1358.482 1341.71c0-8.872-7.194-16.064-16.067-16.064M1358.482 1341.71a8.031 8.031 0 0 1-8.034 8.032M1342.415 1341.71a8.031 8.031 0 0 0 8.033 8.032M1026.488 2c634.338 0 1148.571 514.319 1148.571 1148.763M1464.804 1861.137c392.263 0 710.255-318.045 710.255-710.374M1026.488 1422.748c0 242.116 196.24 438.39 438.316 438.39M1297.28 1150.763c-149.555 0-270.792 121.258-270.792 270.838M1297.28 1150.763c92.52 0 167.524 75.016 167.524 167.552M1361.535 1421.6a103.26 103.26 0 0 0 73.022-30.251 103.294 103.294 0 0 0 30.247-73.034M1361.535 1421.6a64.25 64.25 0 0 1-45.435-18.823 64.272 64.272 0 0 1-18.82-45.443"/><path d="M1337.44 1318.315a40.156 40.156 0 0 0-28.398 11.765 40.17 40.17 0 0 0-11.762 28.402M1337.44 1318.315c13.307 0 24.095 10.79 24.095 24.1M1345.471 1358.482c8.872 0 16.064-7.193 16.064-16.067"/><path d="M1345.472 1358.482a8.031 8.031 0 0 1-8.032-8.034M1345.472 1342.415a8.031 8.031 0 0 0-8.032 8.033M1659.634 2683.06c-634.339 0-1148.572-514.318-1148.572-1148.763M1221.318 823.923c-392.264 0-710.256 318.045-710.256 710.374"/><path d="M1659.633 1262.312c0-242.115-196.24-438.389-438.316-438.389M1388.841 1534.297c149.555 0 270.793-121.258 270.793-270.837M1388.841 1534.297c-92.52 0-167.523-75.015-167.523-167.552M1324.586 1263.46a103.26 103.26 0 0 0-73.022 30.252 103.294 103.294 0 0 0-30.246 73.033M1324.586 1263.46a64.25 64.25 0 0 1 45.435 18.823 64.272 64.272 0 0 1 18.82 45.443"/><path d="M1348.682 1366.745a40.156 40.156 0 0 0 28.397-11.764 40.17 40.17 0 0 0 11.762-28.402M1348.682 1366.745c-13.308 0-24.096-10.79-24.096-24.1M1340.65 1326.579c-8.872 0-16.064 7.193-16.064 16.066M1340.65 1326.579a8.031 8.031 0 0 1 8.032 8.033M1340.65 1342.645a8.031 8.031 0 0 0 8.032-8.033M2682 1024.367c0 634.338-514.319 1148.571-1148.763 1148.571M822.863 1462.683c0 392.263 318.045 710.255 710.374 710.255M1261.252 1024.367c-242.116 0-438.39 196.24-438.39 438.316M1533.237 1295.159c0-149.555-121.258-270.792-270.838-270.792M1533.237 1295.159c0 92.52-75.016 167.524-167.552 167.524M1262.4 1359.414a103.26 103.26 0 0 0 30.251 73.022 103.294 103.294 0 0 0 73.034 30.247M1262.4 1359.414a64.25 64.25 0 0 1 18.823-45.435 64.272 64.272 0 0 1 45.443-18.82"/><path d="M1365.685 1335.319a40.156 40.156 0 0 0-11.765-28.398 40.17 40.17 0 0 0-28.402-11.762"/><path d="M1365.685 1335.318c0 13.308-10.79 24.096-24.1 24.096M1325.518 1343.35c0 8.872 7.193 16.064 16.067 16.064M1325.518 1343.35a8.031 8.031 0 0 1 8.034-8.031M1341.585 1343.35a8.031 8.031 0 0 0-8.033-8.031"/></g></svg>'
    }
};

});

parcelRegister("02R23", function(module, exports) {

$parcel$export(module.exports, "ModalHeader", () => $00895314def4f31d$export$f50a68e3694789ee);
const $00895314def4f31d$export$f50a68e3694789ee = {
    align: 'start space-between',
    flow: 'x',
    gap: 'A',
    Hgroup: {
        flex: 1,
        H: {
            tag: 'h6',
            fontWeight: '600'
        },
        P: {
            lineHeight: '1.5em',
            margin: 'X - -',
            fontWeight: '400',
            maxWidth: 'I_default',
            color: 'paragraph'
        }
    },
    Icons: {
        extends: 'NavbarButtonSet',
        padding: '0',
        margin: '-Y2 -Z1 - auto',
        Close: {
            order: 10,
            Icon: {
                icon: 'x'
            },
            onClick: (e, el)=>{
                e.stopPropagation();
                el.call('closeModal');
            }
        }
    }
};

});

parcelRegister("ieisA", function(module, exports) {

$parcel$export(module.exports, "ModalFooter", () => $d457da9ac1fabe1a$export$519437715052e656);
const $d457da9ac1fabe1a$export$519437715052e656 = {
    margin: '0 -X',
    order: 2,
    align: 'center space-between'
};

});

parcelRegister("3SxY4", function(module, exports) {

$parcel$export(module.exports, "MenuItem", () => $2d30c39227c5763b$export$2ce376c2cc3355c8);
const $2d30c39227c5763b$export$2ce376c2cc3355c8 = {
    extends: [
        'Link',
        'IconButton'
    ],
    round: 'Z2',
    fontSize: 'A',
    isActive: (el, s)=>{
        const { href: href } = el;
        if (href) {
            const activePage = el.getRootState().activePage;
            const hrefKey = el.call('isString', href) && href.slice(1);
            return activePage === hrefKey;
        }
    }
};

});

parcelRegister("eoZKt", function(module, exports) {

$parcel$export(module.exports, "ModalWindow", () => $a7c3348ea55a4506$export$bb6ccfada3e7d0f7);
const $a7c3348ea55a4506$export$bb6ccfada3e7d0f7 = {
    tag: 'section',
    state: {},
    theme: 'modal',
    padding: 'A B',
    round: 'A',
    gap: 'C',
    flow: 'column',
    overflow: 'auto',
    width: 'fit-content',
    height: 'fit-content',
    animationDuration: 'C',
    position: 'relative',
    ModalHeader: {}
};

});

parcelRegister("ibtX7", function(module, exports) {

$parcel$export(module.exports, "MultipleSelect", () => $d3d07d05cb68933d$export$f9938396555c8942);
const $d3d07d05cb68933d$export$f9938396555c8942 = {
    childExtends: 'IconText',
    theme: 'field',
    width: 'F2',
    flow: 'y',
    align: 'flex-start center',
    round: 'Z2',
    padding: 'Y X',
    overflow: 'auto',
    '& svg': {
        opacity: 0
    },
    childProps: {
        width: '100%',
        gap: 'Z',
        padding: 'Z',
        cursor: 'pointer',
        Icon: {
            name: 'checkmark',
            opacity: '0'
        },
        ':hover': {
            '& svg': {
                opacity: '1'
            }
        }
    }
};

});

parcelRegister("aYOGQ", function(module, exports) {

$parcel$export(module.exports, "ModalVideo", () => $7fe6d3fbda9bdf1c$export$f728d2d975de966f);
const $7fe6d3fbda9bdf1c$export$f728d2d975de966f = {
    state: {},
    boxSize: '100% 100%',
    zIndex: '10',
    position: 'fixed',
    backdropFilter: 'blur(15px)',
    '!activeVideo': {
        display: 'none'
    },
    ':after': {
        content: '""',
        position: 'absolute',
        inset: '0',
        zIndex: 1,
        theme: 'document',
        opacity: '.65'
    },
    onClick: (event, el, state)=>{
        el.call("closeModalVideo");
    },
    IconButton: {
        theme: 'transparent',
        position: 'absolute',
        top: 'A',
        right: 'A',
        padding: 'Z',
        round: '100%',
        zIndex: 2,
        onClick: (event, el, state)=>{
            el.call("closeModalVideo");
        },
        ':hover': {
            theme: 'field'
        },
        Icon: {
            name: 'x',
            fontSize: 'D'
        }
    },
    Iframe: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        objectFit: 'fill',
        aspectRatio: '11 / 7',
        height: '65%',
        border: 'none',
        round: 'A',
        zIndex: 2,
        src: (el, s)=>{
            const withAutoplay = (url)=>{
                if (!url) return url;
                const join = url.includes("?") ? "&" : "?";
                return url + join + "autoplay=1&playsinline=1&controls=1&rel=0";
            };
            return withAutoplay(s.activeVideo);
        },
        allow: 'autoplay; fullscreen; picture-in-picture',
        allowFullscreen: true,
        '@tabletS': {
            minWidth: '90%',
            maxWidth: '90%'
        }
    }
};

});

parcelRegister("deePH", function(module, exports) {

$parcel$export(module.exports, "Navbar", () => $9a1816aac9f5d21b$export$42cfbb80f7861e77);
const $9a1816aac9f5d21b$export$42cfbb80f7861e77 = {
    position: 'sticky',
    top: '0',
    flow: 'x',
    zIndex: 9,
    align: 'center space-between',
    padding: 'Y X2',
    theme: 'canvas-card-glass',
    tag: 'aside',
    fontSize: 'Z',
    NavbarTooltip: {}
};

});

parcelRegister("6hgok", function(module, exports) {

$parcel$export(module.exports, "NavbarTooltip", () => $49210b95809a2d08$export$ee8c193ddbcd5287);
const $49210b95809a2d08$export$ee8c193ddbcd5287 = {
    extends: 'TooltipHidden',
    top: '0',
    left: '0',
    theme: 'navbar',
    pointerEvents: 'none',
    tooltipPosition: 'bottom',
    shapeDirection: 'top',
    padding: 'Y Z2',
    fontSize: 'Z2',
    whiteSpace: 'nowrap',
    textAlign: 'center',
    minWidth: 'fit-content',
    lineHeight: 1,
    description: '',
    background: 'highlight-reversed',
    ':before': {
        color: 'highlight-reversed'
    },
    pointerEvents: 'none',
    Title: null,
    P: {
        color: 'highlight',
        fontSize: 'Z2'
    }
};

});

parcelRegister("4C8gQ", function(module, exports) {

$parcel$export(module.exports, "NavbarButtonSet", () => $35c120682324e069$export$6da660d5a2525971);
const $35c120682324e069$export$6da660d5a2525971 = {
    childExtends: [
        'NavbarButton'
    ],
    gap: 'Y1',
    padding: '- Y1',
    width: 'fit-content',
    flow: 'row',
    align: 'center space-between'
};

});

parcelRegister("6XAQm", function(module, exports) {

$parcel$export(module.exports, "NavbarButton", () => $5114d5191d6f029b$export$7510fa6729d59c24);
const $5114d5191d6f029b$export$7510fa6729d59c24 = {
    extends: 'CircleButton',
    theme: 'navbarButton',
    position: 'relative',
    padding: 'Y2',
    round: 'C1',
    attr: {
        tilte: null
    },
    onMouseover: (ev, el, s)=>{
        if (!s.hover) {
            s.hover = true;
            el.call('setNavbarTooltipPosition', {
                visible: true
            });
        }
    },
    onMouseleave: (ev, el, s)=>{
        if (s.hover) {
            s.hover = false;
            const Tooltip = el.lookup('NavbarTooltip');
            if (Tooltip) Tooltip.update({
                opacity: '0',
                visibility: 'hidden'
            });
        }
    }
};

});

parcelRegister("ficK4", function(module, exports) {

$parcel$export(module.exports, "NativeSelect", () => $b2226bc187c76dbe$export$907fa30a18334a59);
const $b2226bc187c76dbe$export$907fa30a18334a59 = {
    tag: 'select',
    background: 'black',
    color: 'white',
    width: 'F3',
    padding: 'Y B2 Y A',
    border: 'none',
    outline: 'none',
    children: [
        {
            text: 'about'
        },
        {
            text: 'contact'
        },
        {
            text: 'market research'
        },
        {
            text: 'Recruiting Partner'
        },
        {
            text: 'Recruiting'
        },
        {
            text: 'Recruiting'
        },
        {
            text: 'Refer a Friend'
        }
    ],
    childExtends: {
        tag: 'option'
    }
};

});

parcelRegister("ePRwS", function(module, exports) {

$parcel$export(module.exports, "NumbCaptionArticleSmall", () => $accf59eaef58c50f$export$5e3237e2d9664dcc);
const $accf59eaef58c50f$export$5e3237e2d9664dcc = {
    extends: 'Hgroup',
    gap: 'X',
    H: {
        extends: 'NumbCaption',
        tag: 'strong',
        margin: '0',
        gap: '0',
        text: null,
        Numb: {
            width: 'A2'
        }
    },
    P: {
        margin: '0 - 0 A2'
    }
};

});

parcelRegister("8UnYs", function(module, exports) {

$parcel$export(module.exports, "NavigationArrows", () => $67c626736a857d9b$export$e7e09ea052ba52d);
const $67c626736a857d9b$export$e7e09ea052ba52d = {
    gap: 'Z',
    childProps: {
        round: '100%',
        theme: 'dialog'
    },
    childExtends: 'IconButton',
    children: [
        {
            Icon: {
                name: 'chevronLeft'
            }
        },
        {
            Icon: {
                name: 'chevronRight'
            }
        }
    ]
};

});

parcelRegister("1NVyN", function(module, exports) {

$parcel$export(module.exports, "NumbCaptionArticleBig", () => $1507044e7af92409$export$c63c869ef496b44c);
const $1507044e7af92409$export$c63c869ef496b44c = {
    extends: 'Hgroup',
    gap: 'X2',
    H: {
        extends: 'NumbCaption',
        tag: 'strong',
        text: null
    },
    P: {
        padding: '0 0 0 A2'
    }
};

});

parcelRegister("ik0dP", function(module, exports) {

$parcel$export(module.exports, "NumericBulletin", () => $d56a445c7e4ba00c$export$ced53f051015807c);
const $d56a445c7e4ba00c$export$ced53f051015807c = {
    extends: 'NumbCaption',
    align: 'flex-start',
    Numb: {
        color: 'currentColor',
        opacity: '0.5'
    },
    Text: {
        fontWeight: '400'
    }
};

});

parcelRegister("4OeYg", function(module, exports) {

$parcel$export(module.exports, "OptionToggle", () => $380771dc45e5650d$export$7d3ab7529747f512);
const $380771dc45e5650d$export$7d3ab7529747f512 = {
    extends: 'SwitchFieldWithCaption',
    borderWidth: '1px 0 0 0',
    borderStyle: 'solid',
    padding: 'B1 - -',
    cursor: 'pointer',
    '@dark': {
        borderColor: '--color-line-dark'
    },
    '@light': {
        borderColor: '--color-line-light'
    },
    onChange: (ev, el)=>{
        const { key: key } = el;
        const val = ev.target.checked;
        el.setUserSettings(key, val, {
            message: `Set ${key} settings to ${val}`
        });
    },
    Input: {
        checked: (el)=>el.getUserSettings(el.parent.key)
    },
    Caption: {},
    QuestionMarkTooltip: {
        margin: 'X auto - X',
        Icon: {},
        TooltipHidden: {
            description: ({ parent: parent })=>parent.tip
        }
    },
    SwitchField: {}
};

});

parcelRegister("4I6B8", function(module, exports) {

$parcel$export(module.exports, "NumericTip", () => $36e063b942255242$export$82837ec4103f0600);
const $36e063b942255242$export$82837ec4103f0600 = {
    extends: 'QuickTip',
    gap: 'Z',
    tag: 'nav',
    IconText: {
        icon: 'magicstar'
    },
    Flex: {
        flow: 'y',
        gap: 'X',
        Title: null,
        P: null,
        childrenExtends: 'NumericBulletin'
    }
};

});

parcelRegister("2QB9L", function(module, exports) {

$parcel$export(module.exports, "PasswordField", () => $212d429babe25a06$export$65ed9482db2257fa);
const $212d429babe25a06$export$65ed9482db2257fa = {
    extends: 'InputField',
    position: 'relative',
    Title: {
        text: 'Password'
    },
    Input: {
        placeholder: 'Enter password',
        type: 'password'
    },
    IconButton: {
        position: 'absolute',
        bottom: 'Z',
        right: 'A2',
        icon: 'eyeOpen',
        padding: '0',
        boxSize: 'B B',
        theme: null,
        color: 'dim',
        background: 'transparent'
    }
};

});

parcelRegister("diVRI", function(module, exports) {

$parcel$export(module.exports, "ProjectTab", () => $9af9d7a3e9db4030$export$bad920a8c2e755c0);
const $9af9d7a3e9db4030$export$bad920a8c2e755c0 = {
    extends: [
        'Link'
    ],
    gap: 'Z',
    position: 'relative',
    align: 'center center',
    redirect: true,
    fallbackRoute: '/dashboard',
    Avatar: {
        extends: [
            'Avatar',
            'Clickable'
        ],
        src: (el, s)=>{
            var _a;
            return s.icon && ((_a = s.icon) == null ? void 0 : _a.src) || "https://assets.symbo.ls/logo-colorful.png";
        },
        text: '{{ title }}',
        fontSize: 'A',
        round: 'Z2',
        boxSize: 'D2'
    },
    Text: {
        fontWeight: '400',
        color: 'title',
        fontSize: 'A',
        width: '175%',
        top: '110%',
        left: '50%',
        textAlign: 'center',
        transform: 'translate3d(-50%, 0, 1px)',
        overflow: 'hidden',
        position: 'absolute',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        text: '{{ title }}'
    }
};

});

parcelRegister("4EltV", function(module, exports) {

$parcel$export(module.exports, "NumbCaption", () => $362b8fa6ff765365$export$238749d86ff415c);
const $362b8fa6ff765365$export$238749d86ff415c = {
    align: 'center flex-start',
    gap: 'Z',
    Numb: {
        fontWeight: '400',
        opacity: '0.65',
        color: 'paragraph'
    },
    Text: {
        fontWeight: '500'
    }
};

});

parcelRegister("6q5VZ", function(module, exports) {

$parcel$export(module.exports, "PackageFeatureItem", () => $4ac9c63395005ccb$export$b705323d4bb53148);
const $4ac9c63395005ccb$export$b705323d4bb53148 = {
    tag: 'label',
    flex: 0.24,
    cursor: 'pointer',
    Input: {
        display: 'none',
        type: 'checkbox',
        ':checked + hgroup': {
            outline: '1.5px solid electricBlue'
        }
    },
    Hgroup: {
        width: '100%',
        padding: 'A1',
        round: 'A1',
        outline: '1.5px solid line',
        Icon: {
            order: '-1',
            margin: '- - A2',
            name: 'logo'
        }
    }
};

});

parcelRegister("gJdLc", function(module, exports) {

$parcel$export(module.exports, "PathnameBreadcrumb", () => $c2db85ccc5fe21dc$export$88a2e5f39c946767);
const $c2db85ccc5fe21dc$export$88a2e5f39c946767 = {
    tag: 'nav',
    childExtends: 'Link',
    align: 'center',
    childProps: {
        fontWeight: '400',
        textDecoration: 'none',
        scrollToTop: false,
        color: 'line',
        '&[href]': {
            color: 'title',
            '&:hover': {
                textDecoration: 'underline'
            }
        },
        '&:not([href])': {
            cursor: 'default'
        },
        '&:not(:first-child):before': {
            content: '""',
            display: 'inline-block',
            width: 'V',
            height: 'V',
            round: '100%',
            background: 'white',
            verticalAlign: '0.2em',
            marginInline: '.65em',
            opacity: '.5'
        }
    },
    children: (el, s, ctx2)=>{
        const routeArr = (el.call('sameOriginTop')?.location?.pathname || window.location.pathname).split("/").slice(1);
        return routeArr.map((text, i)=>text === "page" ? {
                href: "/pages",
                text: "Page"
            } : el.getData("pages")[`/${text}`] ? {
                href: `/${routeArr.slice(0, i + 1).join("/")}`,
                text: `/${text}`
            } : {
                href: `/${routeArr.slice(0, i + 1).join("/")}`,
                text: i === 0 ? el.call("toTitleCase", text) : text
            }).filter((_, k)=>{
            const v = routeArr[k];
            return !v.includes("-") && !v.includes("editor") && !v.includes("preview");
        });
    }
};

});

parcelRegister("eYtLW", function(module, exports) {

$parcel$export(module.exports, "Partner", () => $ae6dc373710bcc25$export$7f6c1cc9c842c5ab);
const $ae6dc373710bcc25$export$7f6c1cc9c842c5ab = {
    extends: 'Picture',
    height: '1em',
    transition: 'opacity B, filter B',
    align: 'center center',
    '@mobileL': {
        margin: '0'
    },
    '@dark': {
        filter: 'grayscale(100%)',
        ':hover': {
            filter: 'grayscale(0%)',
            opacity: '1'
        }
    },
    '@light': {
        filter: 'grayscale(100%)',
        ':hover': {
            filter: 'grayscale(0%)',
            opacity: '.9'
        }
    },
    margin: '0',
    Img: null,
    Div: {
        align: 'center center',
        height: '1em',
        '& svg': {
            minHeight: '1em'
        },
        html: (el)=>el.parent?.src
    }
};

});

parcelRegister("j8xcc", function(module, exports) {

$parcel$export(module.exports, "QuickTip", () => $dee883a7ff0066cf$export$51e46e7d69cf7de7);
const $dee883a7ff0066cf$export$51e46e7d69cf7de7 = {
    extends: [
        'Notification'
    ],
    display: 'inline-flex',
    cursor: 'default',
    theme: null,
    background: 'yellow.1',
    color: 'yellow 1 -35',
    align: 'flex-start',
    margin: '0 -X2',
    alignSelf: 'flex-start',
    minWidth: 'G',
    IconText: {
        opacity: '0.65',
        order: '-1',
        margin: 'W',
        icon: 'questionMark'
    },
    Hgroup: {
        H: {
            text: 'Spread across document'
        },
        P: {
            text: 'Explanation simply deeply'
        }
    }
};

});

parcelRegister("ar9ji", function(module, exports) {

$parcel$export(module.exports, "PromptTextarea", () => $7993a5d4de90e2b3$export$a21bf8a7580d70aa);
const $7993a5d4de90e2b3$export$a21bf8a7580d70aa = {
    boxSize: 'E2 I1+C',
    maxWidth: '100%',
    minHeight: 'E2',
    overflow: 'hidden',
    position: 'relative',
    theme: 'field',
    round: 'B',
    '@tabletM': {
        boxSize: 'E2 I'
    },
    '@tabletS': {
        boxSize: 'E2 100%'
    },
    transition: 'B background defaultBezier',
    '@mobileL': {
        boxSize: 'F1 100%'
    },
    Textarea: {
        minWidth: '100%',
        minHeight: '100%',
        maxHeight: '100%',
        theme: 'transparent',
        placeholder: '"How can I create single sign on?"',
        fontSize: 'A1',
        padding: 'A2 A2 - B',
        border: 'none',
        borderWidth: '0',
        borderStyle: 'none',
        '@mobileL': {
            padding: 'B B - B'
        },
        '@mobileM': {
            padding: 'D B - B',
            textAlign: 'center',
            lineHeight: '1.3em'
        }
    },
    Flex: {
        position: 'absolute',
        top: 'A1',
        right: 'B1',
        gap: 'B',
        '@mobileL': {
            right: 'B',
            gap: 'A2'
        },
        '@mobileM': {
            right: 'A1',
            top: 'A'
        },
        childExtends: 'IconButton',
        childProps: {
            padding: 'X',
            theme: 'transparent'
        },
        children: [
            {
                Icon: {
                    name: 'upload'
                }
            },
            {
                Icon: {
                    name: 'chevronUp'
                }
            }
        ]
    },
    Button: {
        text: 'Create a feature',
        position: 'absolute',
        padding: 'Z2 C+X1',
        right: 'A1',
        bottom: 'A1',
        flow: 'row-reverse',
        gap: 'Y2',
        theme: 'blackWhite',
        fontWeight: '600',
        '@mobileM': {
            minWidth: '90%',
            maxWidth: '90%',
            right: '50%',
            transform: 'translate(50%, 0)'
        },
        Icon: {
            name: 'chevronUp',
            fontSize: 'B',
            transform: 'rotate(45deg)',
            margin: '-W - - -'
        }
    }
};

});

parcelRegister("d6PxP", function(module, exports) {

$parcel$export(module.exports, "QuickStartNumber", () => $98b3d194dd7ea412$export$4368d004ab7c4966);
const $98b3d194dd7ea412$export$4368d004ab7c4966 = {
    width: '1ch',
    text: '1',
    fontSize: 'I1_default',
    lineHeight: '1',
    color: 'black.0',
    display: 'inline',
    fontWeight: '900',
    margin: '0',
    textStroke: '1px gray6',
    userSelect: 'none',
    '@tabletL': {
        margin: 'W 0 0 0'
    },
    '@light': {
        textStroke: '1px gray11'
    }
};

});

parcelRegister("csq3J", function(module, exports) {

$parcel$export(module.exports, "RangeFieldWithTitle", () => $911c505e7f228f7d$export$2e692472ecf7c282);
const $911c505e7f228f7d$export$2e692472ecf7c282 = {
    extends: 'GroupField',
    Title: {},
    RangeField: {
        padding: 'X2 0'
    }
};

});

parcelRegister("3Zgsu", function(module, exports) {

$parcel$export(module.exports, "RangeFieldWithTitleAndIcon", () => $2e73d5ec7807258d$export$a8cca174f32b21c4);
const $2e73d5ec7807258d$export$a8cca174f32b21c4 = {
    extends: 'GroupField',
    tag: 'section',
    Title: {},
    RangeFieldWithIcon: {}
};

});

parcelRegister("7zA8I", function(module, exports) {

$parcel$export(module.exports, "RangeField", () => $5837d5d7c766d28e$export$b322c47b2525bd34);
const $5837d5d7c766d28e$export$b322c47b2525bd34 = {
    extends: 'RangeWithButtons',
    align: 'center space-between',
    padding: 'X2',
    round: 'Y2',
    gap: 'Y',
    SquareButton_minus: {
        round: 'Y1',
        padding: '0.3125em'
    },
    Value: {
        tag: 'span',
        fontSize: 'Z'
    },
    Range: {
        ':hover': {
            '::-webkit-slider-thumb': {
                borderColor: 'cerulean'
            }
        },
        '::-webkit-slider-thumb': {
            borderColor: 'blue'
        }
    },
    SquareButton_plus: {
        round: 'Y1',
        padding: '0.3125em'
    }
};

});

parcelRegister("8838b", function(module, exports) {

$parcel$export(module.exports, "Scrollable", () => $5eb17fd3807ab4cc$export$fcc7818a78919c8c);
const $5eb17fd3807ab4cc$export$fcc7818a78919c8c = {
    flow: 'x',
    gap: 'C',
    maxWidth: '100%',
    overflowY: 'auto',
    '::-webkit-scrollbar': {
        display: 'none'
    },
    '@mobileL': {
        padding: 'A B B B',
        scrollSnapType: 'x mandatory',
        scrollPadding: 'B'
    }
};

});

parcelRegister("SQip8", function(module, exports) {

$parcel$export(module.exports, "SearchField", () => $0a4d9c204217cd23$export$b94867ecbd698f21);
const $0a4d9c204217cd23$export$b94867ecbd698f21 = {
    tag: 'label',
    align: 'center flex-start',
    gap: 'X',
    theme: 'quaternary',
    round: 'Y',
    padding: '0 0 0 Z1',
    cursor: 'pointer',
    width: '12.8125em',
    height: '2.25em',
    Icon: {
        name: 'search outline'
    },
    Input: {
        border: 'none',
        flex: 1,
        background: 'transparent',
        color: 'white.85',
        padding: '0',
        outline: 'none'
    }
};

});

parcelRegister("jGj5M", function(module, exports) {

$parcel$export(module.exports, "RangeWithButtons", () => $e540bfddbe81ba94$export$94c40b3709c521a9);
const $e540bfddbe81ba94$export$94c40b3709c521a9 = {
    align: 'center',
    gap: 'Y',
    deps: {
        returnPropertyValue: (el, property, def)=>{
            const val = el[property] ?? (el.state && el.state[property]);
            if (el.call("isFunction", val)) return val(el, el.state);
            if (val === void 0 || val == null) return def ?? 0;
            return val;
        }
    },
    SquareButton_minus: {
        icon: 'minus',
        theme: 'field',
        onClick: (ev, el, s)=>{
            if (el.call("isFunction", el.parent.onDecrease)) el.parent.onDecrease(ev, el.parent, s);
            else {
                const value = parseFloat(s.value);
                const min = el.parent.deps.returnPropertyValue(el.parent, "min", 1);
                const step = el.parent.deps.returnPropertyValue(el.parent, "step", 1);
                if (value > min) {
                    const decimalPlaces = (step.toString().split(".")[1] || "").length;
                    const newValue = Number((value - step).toFixed(decimalPlaces));
                    el.lookup("Range").node.value = newValue;
                    s.update({
                        value: newValue
                    });
                }
            }
        }
    },
    Value: {
        tag: 'span',
        minWidth: '4ch',
        text: (el, s)=>{
            const unit = el.parent.deps.returnPropertyValue(el.parent, "unit", "");
            return `${s.value ?? s.defaultValue ?? 0}${unit}`;
        }
    },
    Range: {
        attr: {
            value: (el, s)=>parseFloat(s.value ?? s.defaultValue),
            min: (el)=>el.parent.deps.returnPropertyValue(el.parent, "min", 0),
            max: (el)=>el.parent.deps.returnPropertyValue(el.parent, "max", 100),
            step: (el)=>el.parent.deps.returnPropertyValue(el.parent, "step", 1),
            disabled: (el)=>el.parent.deps.returnPropertyValue(el.parent, "disabled", false)
        },
        onInput: (ev, el, s)=>{
            if (el.call("isFunction", el.parent.onInput)) el.parent.onInput(ev, el, s);
            else s.update({
                value: parseFloat(el.node.value)
            });
        },
        onChange: (ev, el, s)=>{
            if (el.call("isFunction", el.parent.onChange)) el.parent.onChange(ev, el, s);
            else s.update({
                value: parseFloat(el.node.value)
            });
        }
    },
    SquareButton_plus: {
        theme: 'field',
        icon: 'plus',
        onClick: (ev, el, s)=>{
            if (el.call("isFunction", el.parent.onIncrease)) el.parent.onIncrease(ev, el.parent, s);
            else {
                const value = parseFloat(s.value);
                const max = el.parent.deps.returnPropertyValue(el.parent, "max", 100);
                const step = el.parent.deps.returnPropertyValue(el.parent, "step", 1);
                if (value < max) {
                    const decimalPlaces = (step.toString().split(".")[1] || "").length;
                    const newValue = Number((value + step).toFixed(decimalPlaces));
                    el.lookup("Range").node.value = newValue;
                    s.update({
                        value: newValue
                    });
                }
            }
        }
    }
};

});

parcelRegister("d5rrN", function(module, exports) {

$parcel$export(module.exports, "SectionAddButton", () => $98710879d07bddc9$export$7d8ce3aad1b54570);
const $98710879d07bddc9$export$7d8ce3aad1b54570 = {
    extends: [
        'Link',
        'MenuItem'
    ],
    ignoreChildExtends: true,
    icon: 'plus'
};

});

parcelRegister("bhpco", function(module, exports) {

$parcel$export(module.exports, "Scrollbar.scrollable", () => $8364d43d4b5fcf07$export$1d0e64c2af7fee0b);
const $8364d43d4b5fcf07$export$1d0e64c2af7fee0b = {
    extends: 'Scrollbar',
    minWidth: '100%',
    maxWidth: '100%',
    TrackContainer: {
        Track: {
            background: 'gray3',
            onFrame: (el)=>{
                const scrollable = el.lookup('Scrollable');
                if (!scrollable?.node) return;
                const node = scrollable.node;
                const { clientWidth: clientWidth, scrollWidth: scrollWidth, scrollLeft: scrollLeft } = node;
                if (!clientWidth || !scrollWidth) return;
                const ratio = clientWidth / scrollWidth;
                const maxScroll = scrollWidth - clientWidth;
                const scrollOffset = maxScroll > 0 ? scrollLeft / maxScroll * (100 - ratio * 100) : 0;
                el.setNodeStyles({
                    width: `${ratio * 100}%`,
                    transform: `translateX(${scrollOffset}%)`
                });
                const scrollBar = el.lookup('Scrollbar');
                if (scrollBar?.node) scrollBar.node.style.display = clientWidth >= scrollWidth ? 'none' : '';
            }
        }
    },
    NavigationArrows: {
        childProps: {
            theme: 'field',
            onClick: (ev, el)=>{
                const node = el.lookup('Scrollable')?.node;
                if (!node) return;
                const isLeft = el.key === '0';
                node.scrollBy({
                    left: isLeft ? -(node.clientWidth * 0.65) : node.clientWidth * 0.65,
                    behavior: 'smooth'
                });
            },
            Icon: {}
        }
    }
};

});

parcelRegister("hLO8r", function(module, exports) {

$parcel$export(module.exports, "SelectDropdown", () => $cefdb73d618fb2ec$export$124e49603add0284);
const $cefdb73d618fb2ec$export$124e49603add0284 = {
    extends: [
        'DropdownField',
        'DropdownParent'
    ],
    Dropdown: {
        minWidth: 'F3',
        left: '0',
        width: '100%',
        top: '110%',
        DropdownHeader: {},
        ListInDropdown: {
            childProps: {
                align: 'center flex-start',
                text: '{{ key }}'
            },
            children: (el, s)=>el.parent.options || s.list,
            childrenAs: 'state'
        }
    }
};

});

parcelRegister("8OXF9", function(module, exports) {

$parcel$export(module.exports, "SectionHeader", () => $66c14602fcea5f32$export$8adb256d999cd5a0);
const $66c14602fcea5f32$export$8adb256d999cd5a0 = {
    tag: 'header',
    gap: 'B',
    align: 'start space-between',
    flow: 'y',
    margin: '0 0 B1',
    Article: {
        extends: 'ArticleSmall',
        flow: 'column',
        flex: 1,
        Title: {
            fontWeight: '600',
            show: ({ parent: parent })=>parent.parent.title,
            text: ({ parent: parent, state: state })=>parent.parent.title || state.title
        },
        P: {
            lineHeight: '1.5em',
            margin: 'X - -',
            fontWeight: '400',
            maxWidth: 'I_default',
            color: 'paragraph',
            show: ({ parent: parent })=>parent.parent.p,
            text: ({ parent: parent, state: state })=>parent.parent.p || state.p
        }
    },
    Nav: {
        flow: 'row-reverse',
        fontSize: 'A2',
        gap: 'A',
        childProps: {
            scrollToTop: false
        },
        childExtends: [
            'MenuItem'
        ],
        children: ({ state: state })=>state.nav,
        Toggle: {
            if: ({ state: state })=>// eslint-disable-next-line no-undefined
                state[state.__element.key] || state.toggleShow !== void 0,
            isActive: ({ state: state })=>!state.toggleShow,
            Icon: {
                name: ({ state: state })=>`arrowAngle${state.toggleShow ? 'Up' : 'Down'}`
            },
            onClick: (event, element, state)=>{
                state.update({
                    toggleShow: !state.toggleShow
                });
            }
        }
    }
};

});

parcelRegister("ex8uL", function(module, exports) {

$parcel$export(module.exports, "QuestionMarkTooltip", () => $a94abcbc4195a396$export$c3a1d7b797848fed);
const $a94abcbc4195a396$export$c3a1d7b797848fed = {
    extends: 'TooltipParent',
    margin: 'X auto - X',
    Icon: {
        color: 'gray7',
        opacity: '.35',
        name: 'questionMark fill'
    },
    TooltipHidden: {
        padding: 'Z A',
        shapeDirection: 'bottom',
        title: null,
        minWidth: 'F1'
    }
};

});

parcelRegister("6DZIs", function(module, exports) {

$parcel$export(module.exports, "SelectField", () => $4d6642226601fc99$export$d55b50a564d0b931);
const $4d6642226601fc99$export$d55b50a564d0b931 = {
    extends: 'DropdownField',
    minWidth: 'E3',
    round: 'C1',
    padding: '0',
    position: 'relative',
    Dropdown: null,
    Value: null,
    Buttons: {
        position: 'absolute',
        right: 'Z',
        pointerEvents: 'none',
        Arrow: {
            theme: 'transparent',
            color: 'dim',
            icon: 'arrow angle down'
        }
    },
    Select: {
        outline: 'none',
        border: 'none',
        background: 'transparent',
        color: 'currentColor',
        padding: 'Z1 A2',
        round: 'C1',
        width: '100%',
        appearance: 'none',
        name: 'user',
        id: 'user',
        onChange: (ev, el, s, ctx2)=>{
            if (el.parent.onChange) {
                ev.stopPropagation();
                return el.parent.onChange(ev, el, s, ctx2);
            }
        },
        children: (el)=>el.call("exec", el.parent.options, el),
        childrenAs: 'props',
        childProps: {
            tag: 'option',
            attr: {
                selected: (el, s)=>el.node.value === s.visibility
            }
        }
    }
};

});

parcelRegister("6BEjr", function(module, exports) {

$parcel$export(module.exports, "SectionHeaderWithNav", () => $4cf57800a0fa1877$export$9c92103a71b9ac77);
const $4cf57800a0fa1877$export$9c92103a71b9ac77 = {
    extends: 'SectionHeader',
    Article: {},
    Nav: {
        flow: 'row-reverse',
        fontSize: 'A2',
        gap: 'A',
        childExtends: 'MenuItem',
        children: (el, s)=>s.nav,
        Toggle: {
            if: (el, s)=>s[s.__element.key] || s.toggleShow !== void 0,
            isActive: (el, s)=>!s.toggleShow,
            Icon: {
                name: (el, s)=>"arrowAngle" + (s.toggleShow ? "Up" : "Down")
            },
            onClick: (event, el, s)=>{
                s.update({
                    toggleShow: !s.toggleShow
                });
            }
        },
        childProps: {
            scrollToTop: false
        }
    }
};

});

parcelRegister("ksUFH", function(module, exports) {

$parcel$export(module.exports, "SectionTitle", () => $ee6261f44d5e9256$export$69bc41ee738923ec);
const $ee6261f44d5e9256$export$69bc41ee738923ec = {
    tag: 'p',
    fontWeight: '500',
    color: 'title'
};

});

parcelRegister("3Eyhr", function(module, exports) {

$parcel$export(module.exports, "SimpleOverlay", () => $2a8fb2dd48e0bd17$export$9f2eee387f4e49f);
const $2a8fb2dd48e0bd17$export$9f2eee387f4e49f = {
    position: 'absolute',
    inset: '0 0 0 0'
};

});

parcelRegister("2liSf", function(module, exports) {

$parcel$export(module.exports, "SelectDropdownWithTitle", () => $1b4c2ee870115e94$export$b2091a6e5b06d936);
const $1b4c2ee870115e94$export$b2091a6e5b06d936 = {
    extends: 'GroupField',
    minWidth: 'F1',
    Title: {},
    SelectDropdown: {
        width: '100%'
    }
};

});

parcelRegister("4Ry3I", function(module, exports) {

$parcel$export(module.exports, "SizeUnits", () => $38a6880e8b94ba6a$export$8ab0a267496de8e9);
const $38a6880e8b94ba6a$export$8ab0a267496de8e9 = {
    childExtends: 'Input',
    flow: 'y',
    align: 'center flex-start',
    gap: 'V',
    childProps: {
        outline: 'none',
        border: 'none',
        width: 'A+C',
        round: 'none',
        textAlign: 'center',
        padding: 'W',
        round: 'W',
        backgroundColor: 'inherit',
        cursor: 'pointer'
    },
    NumberValue: {
        color: 'title',
        fontSize: 'Z1'
    },
    LetterValue: {
        color: 'green',
        fontSize: 'Y',
        fontWeight: '500',
        textTransform: 'uppercase'
    }
};

});

parcelRegister("7VzGT", function(module, exports) {

$parcel$export(module.exports, "SuggestionAction", () => $5c598abb6e6017d1$export$ebe243338d39c3b8);
const $5c598abb6e6017d1$export$ebe243338d39c3b8 = {
    extends: 'Link',
    position: 'relative',
    padding: 'D E3 D3',
    textAlign: 'center',
    fontWeight: 'regular',
    round: 'B1',
    scrollToTop: false,
    maxWidth: 'I',
    border: '1px solid gray2 1 +10',
    cursor: 'pointer',
    ':hover': {
        borderColor: 'gray2 1 +4',
        background: 'gray2.1'
    },
    text: 'Add a page',
    href: ()=>`${window.location.pathname}/add-page`,
    onClick: async (ev, el)=>{
        ev.preventDefault();
        const href = el.call("resolveHref", el.href);
        await el.call("openModal", href == null ? void 0 : href.replace(window.location.pathname, ""));
    },
    IconText: {
        left: '0',
        textAlign: 'center',
        width: '100%',
        gap: 'X2',
        icon: 'click outline',
        position: 'absolute',
        color: 'dim',
        bottom: 'A1',
        text: 'Click and fill the required fields'
    }
};

});

parcelRegister("9aTZM", function(module, exports) {

$parcel$export(module.exports, "Strong", () => $6ae07bc10f981c85$export$f301627d437cff88);
const $6ae07bc10f981c85$export$f301627d437cff88 = {
    extends: 'smbls.Strong',
    color: 'subtitle'
};

});

parcelRegister("fvi5X", function(module, exports) {

$parcel$export(module.exports, "Subhead", () => $b497c995c42fe6e0$export$17e07beff4cf82a6);
const $b497c995c42fe6e0$export$17e07beff4cf82a6 = {
    extends: 'smbls.Subhead',
    color: 'subtitle'
};

});

parcelRegister("59ExR", function(module, exports) {

$parcel$export(module.exports, "SwitchField", () => $3c0d3e6949578369$export$208c2e617baf9fc3);
const $3c0d3e6949578369$export$208c2e617baf9fc3 = {
    tag: 'label',
    boxSize: 'A2 B2',
    position: 'relative',
    Input: {
        type: 'checkbox',
        display: 'none',
        ':checked + span': {
            background: 'white.2',
            ':before': {
                left: '68%',
                background: 'white.85'
            }
        },
        onChange: (ev, el, s)=>{
            ev.stopPropagation();
            el.parent.onChange(ev, el.parent, s);
        }
    },
    Pseudo: {
        tag: 'span',
        boxSize: 'A2 B2',
        position: 'absolute',
        cursor: 'pointer',
        inset: '0 0 0 0',
        background: 'white.06',
        round: 'C',
        transition: 'B',
        ':before': {
            content: '""',
            position: 'absolute',
            height: 'A',
            width: 'A',
            round: 'C',
            top: '50%',
            left: '32%',
            transform: 'translate3d(-50%, -50%, 0)',
            bottom: 'W',
            backgroundColor: 'white.1',
            transition: 'B'
        }
    }
};

});

parcelRegister("bsxjR", function(module, exports) {

$parcel$export(module.exports, "StateDesignElement", () => $857c27c6b6a34ed4$export$7549216c76ea904c);
const $857c27c6b6a34ed4$export$7549216c76ea904c = {
    extends: 'DesignElement',
    href: '/docs/{{ categoryType }}',
    margin: 'B -Z2 -Z2',
    gap: 'Y2',
    maxWidth: 'F_default',
    cursor: 'alias',
    WiderButton: (el, s)=>{
        const COLOR_MAPING = {
            animation: "default",
            selector: "default",
            media: "default"
        };
        const ICON_MAPING = {
            animation: "animationsAlt",
            selector: "click",
            media: "deviceMobile"
        };
        return {
            theme: COLOR_MAPING[s.categoryType] || s.categoryType,
            icon: (ICON_MAPING[s.categoryType] || s.categoryType) + "Outline"
        };
    },
    Hgroup: {
        H: null,
        P: {
            text: null,
            childProps: {
                tag: 'span'
            },
            children: [
                'Property of ',
                {
                    text: '{{ category }}',
                    '@dark': {
                        color: 'white'
                    },
                    '@light': {
                        color: 'black'
                    }
                }
            ]
        }
    }
};

});

parcelRegister("3Gcd8", function(module, exports) {

$parcel$export(module.exports, "TabSet", () => $2adec42e5867016b$export$fe445cdbdc2880b4);
const $2adec42e5867016b$export$fe445cdbdc2880b4 = {
    padding: 'V2+V2',
    flow: 'x',
    round: 'D',
    background: 'gray1.1',
    width: 'fit-content',
    childExtends: 'Button',
    children: [
        {
            text: 'build',
            isActive: true,
            theme: 'dialog-elevated'
        },
        {
            text: 'test'
        }
    ],
    childProps: {
        Icon: null,
        round: 'D',
        fontWeight: '400',
        padding: 'Z B1',
        textTransform: 'capitalize',
        '.isActive': {
            theme: 'document'
        },
        theme: 'transparent'
    }
};

});

parcelRegister("cmpdZ", function(module, exports) {

$parcel$export(module.exports, "Tag", () => $8ffb1b39511503d0$export$3288d34c523a1192);
const $8ffb1b39511503d0$export$3288d34c523a1192 = {
    extends: 'LabelTag',
    round: 'A',
    text: 'Tag',
    theme: 'field-static',
    order: (el, s)=>-s.frequency,
    isActive: (el, s)=>{
        var _a;
        return ((_a = s.parent) == null ? void 0 : _a.tags.indexOf(s.value)) > -1;
    },
    '.isActive': {
        theme: 'space'
    },
    onClick: (ev, el, s, ctx)=>{
        var _a, _b;
        const tags = ((_a = s.parent) == null ? void 0 : _a.tags) || [];
        if (tags.indexOf(s.value) > -1) ctx.utils.removeValueFromArray(tags, s.value);
        else tags.push(s.value);
        (_b = s.parent) == null || _b.replace({
            tags: tags
        });
    }
};

});

parcelRegister("bGqNX", function(module, exports) {

$parcel$export(module.exports, "SummaryComponent", () => $881868ccbaffe3bc$export$4c31ebe31b6ce6ba);
const $881868ccbaffe3bc$export$4c31ebe31b6ce6ba = {
    extends: [
        'Link',
        'ClickableItem',
        'DesignComponent'
    ],
    state: true,
    maxWidth: 'none',
    width: '100%',
    margin: '- - B1',
    fontWeight: '400',
    href: '{{ href }}'
};

});

parcelRegister("unArz", function(module, exports) {

$parcel$export(module.exports, "TabsLinkSwitcher", () => $05b5194ddf9b96e0$export$ed4804da580f004a);
const $05b5194ddf9b96e0$export$ed4804da580f004a = {
    margin: '- E - -',
    flow: 'x',
    gap: 'Z',
    childExtends: [
        'TabsLink'
    ]
};

});

parcelRegister("ahdUq", function(module, exports) {

$parcel$export(module.exports, "SwitchFieldWithCaption", () => $77b647f61149886d$export$ed66b65f3525dec0);
const $77b647f61149886d$export$ed66b65f3525dec0 = {
    tag: 'label',
    align: 'center space-between',
    gap: 'Y',
    userSelect: 'none',
    ':hover > caption': {
        color: 'gray12',
        opacity: 1
    },
    Input: {
        type: 'checkbox',
        display: 'none',
        ':checked ~ caption': {
            opacity: 1
        },
        ':checked ~ span > span': {
            background: 'dim',
            ':before': {
                left: '68%',
                background: 'caption'
            }
        },
        onChange: (ev, el, s, ctx2)=>{
            ev.stopPropagation();
            const hasChange = el.parent.onChange;
            if (hasChange) hasChange(ev, el.parent, s, ctx2);
        }
    },
    SwitchField: {
        tag: 'span',
        Input: null
    },
    Caption: {
        padding: '0',
        opacity: '.65',
        color: 'gray7',
        text: 'Disable this style',
        transition: 'B defaultBezier',
        transitionProperty: 'color, opacity'
    }
};

});

parcelRegister("1PeD7", function(module, exports) {

$parcel$export(module.exports, "UploadField", () => $1545e714e1dfd78f$export$d61c19f03375c53e);
const $1545e714e1dfd78f$export$d61c19f03375c53e = {
    extends: 'GroupField',
    Title: {
        padding: '- - - X2',
        text: 'Project icon'
    },
    UploadIcon: {
        position: 'relative',
        padding: 'B1 B',
        gap: 'X2',
        boxSize: 'fit-content',
        border: 'none',
        theme: 'field-placeholder',
        Icon: {
            name: 'upload',
            fontSize: 'C1',
            opacity: '1'
        },
        P: {
            text: 'Drag and drop or click',
            maxWidth: 'E',
            textAlign: 'center',
            opacity: '1',
            fontSize: 'Z1',
            Span: null
        },
        Input: {
            type: 'file',
            position: 'absolute',
            inset: '0 0 0 0',
            opacity: '0',
            visibility: 'hidden'
        }
    }
};

});

parcelRegister("hsIgN", function(module, exports) {

$parcel$export(module.exports, "TabsLink", () => $cb676441d444a1f0$export$a258a2358b9c65f7);
const $cb676441d444a1f0$export$a258a2358b9c65f7 = {
    extends: 'Button',
    theme: null,
    background: 'transparent',
    color: 'paragraph',
    padding: 'Z1 A',
    margin: '0 0 -1px',
    transition: 'A, defaultBezier',
    transitionProperty: 'color, border-color, font-weight',
    round: '0',
    borderWidth: '0 0 1px',
    borderColor: 'line',
    borderStyle: 'solid',
    ':hover': {
        color: 'title',
        '@dark': {
            borderColor: 'gray4'
        }
    },
    '.isActive': {
        fontWeight: '600',
        color: 'title',
        position: 'relative',
        zIndex: 2,
        '@dark': {
            borderColor: 'gray5'
        }
    },
    onClick: (ev, el, s, ctx2)=>{
        if (el.parent.onChoose) return el.parent.onChoose(ev, el, s, ctx2);
    }
};

});

parcelRegister("g1o16", function(module, exports) {

$parcel$export(module.exports, "TemplatesRow", () => $ba9f5e9467f32f21$export$35f229c51eef48ec);
const $ba9f5e9467f32f21$export$35f229c51eef48ec = {
    flow: 'y',
    gap: 'Z2',
    align: 'flex-start flex-start',
    minWidth: '100%',
    maxWidth: '100%',
    overflow: 'hidden',
    minHeight: 'fit-content',
    Caption: {
        text: 'Templates'
    },
    Scrollable: {
        flow: 'x',
        childExtends: 'TemplatesRowItem',
        childrenAs: 'state',
        childProps: {
            onInit: (el, s)=>{
                if (s.length === 0) {
                    el.set({
                        opacity: "0.35"
                    });
                    el.set({
                        pointerEvents: "none"
                    });
                }
            },
            '@mobileL': {
                minWidth: '100%',
                maxWidth: '100%',
                scrollSnapAlign: 'start'
            },
            Img: {
                '@mobileL': {
                    boxSize: 'auto 100%'
                }
            },
            Span: {}
        },
        children: [
            {
                poster: 'https://api.symbols.app/core/files/public/68b43aac424350c909e4f047/download',
                projectPath: 'nikoloza/tech-dash',
                previewUrl: 'https://tech-dash.symbo.ls',
                title: 'TechDashboard'
            },
            {
                poster: 'https://api.symbols.app/core/files/public/68b43e2b424350c909e4fa6f/download',
                projectPath: 'nikoloza/mankanet',
                previewUrl: 'https://mankanet.symbo.ls',
                title: 'Mankanet'
            },
            {
                poster: 'https://api.symbols.app/core/files/public/68b446dd424350c909e50d4e/download',
                projectPath: 'nikoloza/nocost',
                previewUrl: 'https://nocost.symbo.ls',
                title: 'NoCost'
            },
            {
                poster: 'https://api.symbols.app/core/files/public/68b65ee1424350c909ebc8a1/download',
                projectPath: 'nikoloza/fresh',
                previewUrl: 'https://fresh.symbo.ls',
                title: 'FreshCo'
            },
            {
                poster: 'https://api.symbols.app/core/files/public/68b66083424350c909ebd66a/download',
                projectPath: 'nikoloza/bessi',
                previewUrl: 'https://bessi.symbo.ls',
                title: 'Christmas Shop'
            },
            {
                poster: 'https://api.symbols.app/core/files/public/68b6749b424350c909ec6fcf/download',
                projectPath: 'nikoloza/qartool',
                previewUrl: 'https://qartool.symbo.ls',
                title: 'Qartool'
            },
            {
                poster: 'https://api.symbols.app/core/files/public/68b67552424350c909ec7534/download',
                projectPath: 'nikoloza/moll',
                previewUrl: 'https://moll.symbo.ls',
                title: 'Mollie'
            }
        ]
    },
    Scrollbar: {
        extends: 'Scrollbar.scrollable'
    }
};

});

parcelRegister("fiZOa", function(module, exports) {

$parcel$export(module.exports, "TestText", () => $b2487b3ffa8e85fb$export$da2556a0dd4c5e79);
const $b2487b3ffa8e85fb$export$da2556a0dd4c5e79 = {
    extends: 'InputField',
    minWidth: 'G2',
    align: 'stretch',
    Title: {
        text: 'Test text:'
    },
    Input: {
        onInput: (ev, el)=>{
            el.getRootState().update({
                sampleText: el.node.value
            }, {
                preventUpdate: [
                    "Canvas",
                    "Modal"
                ]
            });
        },
        theme: 'quaternary',
        padding: 'Z A',
        round: 'Y',
        placeholder: 'Today is a last day of the year',
        value: (el)=>el.getRootState()?.sampleText
    }
};

});

parcelRegister("8cEzu", function(module, exports) {

$parcel$export(module.exports, "TemplatesRowItem", () => $5f8eea58f3b561b3$export$5423b81ac907e56b);
const $5f8eea58f3b561b3$export$5423b81ac907e56b = {
    extends: [
        'Link'
    ],
    padding: '0',
    gap: 'Y1',
    flow: 'y',
    widthRange: 'G1',
    round: '0',
    overflow: 'visible',
    ':after': null,
    cursor: 'pointer',
    href: 'https://symbols.app/{{ projectPath }}',
    target: '_blank',
    opacity: '0.75',
    transition: 'A defaultBezier all',
    ':hover': {
        opacity: '1',
        '& .arrow': {
            transform: 'none',
            opacity: '1'
        }
    },
    state: {
        poster: 'https://api.symbols.app/core/files/public/68b43aac424350c909e4f047/download',
        projectPath: 'nikoloza/tech-dash',
        previewUrl: 'https://tech-dash.symbo.ls',
        title: 'TechBrother'
    },
    Box: {
        position: 'relative',
        Flex: {
            extends: 'Link',
            flow: 'x',
            if: (el, s)=>!!s.previewUrl,
            transition: 'A defaultBezier all',
            transform: 'translate3d(A, -A, 0)',
            opacity: '0',
            class: 'arrow',
            position: 'absolute',
            top: 'X2',
            right: 'X2',
            zIndex: '2',
            padding: 'Y1',
            background: 'black',
            round: 'Z2',
            href: '{{ previewUrl }}',
            onClick: (ev, el, s)=>{
                ev.stopPropagation();
                ev.preventDefault();
                window.open(s.previewUrl, "_blank");
            },
            Icon: {
                fontSize: 'B',
                icon: 'eye'
            }
        },
        Img: {
            round: 'A',
            position: 'relative',
            width: '100%',
            src: '{{ poster }}'
        }
    },
    Span: {
        text: '{{ title }}',
        fontWeight: '400',
        padding: '- - - X2'
    }
};

});

parcelRegister("5wPSG", function(module, exports) {

$parcel$export(module.exports, "TextareaField", () => $40682f6b2c7dfde9$export$c2bf0ac0dd87f3cb);
const $40682f6b2c7dfde9$export$c2bf0ac0dd87f3cb = {
    position: 'relative',
    maxWidth: 'G3',
    maxHeight: 'E3',
    boxSize: '100%',
    boxSizing: 'border-box',
    ':after, &:before': {
        content: '""',
        position: 'absolute',
        zIndex: '10',
        boxSize: 'B 100%',
        pointerEvents: 'none'
    },
    ':before': {
        bottom: '-Z',
        left: '50%',
        transform: 'translate3d(-50%, -20%, 0)',
        background: `linear-gradient(
        to top,
        var(--quaternary-dark-background) 0%,
        var(--quaternary-dark-background) 100%
      )`
    },
    ':after': {
        top: '0',
        left: '0',
        background: `linear-gradient(
        to bottom,
        var(--quaternary-dark-background) 0%,
        var(--quaternary-dark-background) 100%
      )`
    },
    Textarea: {
        variant: 'simple',
        width: '100%',
        height: '100%',
        theme: 'field',
        padding: 'A B A A1',
        fontFamily: 'smbls',
        round: 'A',
        position: 'relative',
        overflow: 'hidden auto',
        resize: 'none',
        scrollBehavior: 'smooth',
        '@mobileXS': {
            fontSize: 'Z2'
        },
        '::-webkit-scrollbar': {
            display: 'none'
        },
        '.simple': {
            theme: 'field'
        }
    }
};

});

parcelRegister("goQJ5", function(module, exports) {

$parcel$export(module.exports, "UploadIcon", () => $bf07c98a588e4bce$export$8df90684a752ef81);
const $bf07c98a588e4bce$export$8df90684a752ef81 = {
    extends: [
        'Focusable'
    ],
    tag: 'label',
    position: 'relative',
    theme: 'field',
    flow: 'column',
    align: 'center center',
    round: 'A',
    cursor: 'pointer',
    border: '1.6px dashed line.1',
    padding: 'B B2',
    Input: {
        type: 'file',
        position: 'absolute',
        inset: '0 0 0 0',
        opacity: '0',
        visibility: 'hidden'
    },
    Icon: {
        name: 'upload',
        fontSize: 'B',
        opacity: '.2'
    },
    P: {
        text: ' or click and upload from your computer',
        flow: 'column-reverse',
        align: 'center center',
        opacity: '.22',
        margin: '0',
        Span: {
            text: 'Drag and drop your font file',
            display: 'block'
        }
    }
};

});

parcelRegister("hVePq", function(module, exports) {

$parcel$export(module.exports, "RangeFieldWithIcon", () => $d0c3432d132be5c8$export$f27060fef6238b1b);
const $d0c3432d132be5c8$export$f27060fef6238b1b = {
    gap: 'Y',
    align: 'center flex-start',
    Icon: {
        display: 'block',
        color: 'caption'
    },
    RangeField: {}
};

});

parcelRegister("1wIqF", function(module, exports) {

$parcel$export(module.exports, "Scrollbar", () => $11cb3e4c1c42ef3d$export$9a4e88b92edfce6b);
const $11cb3e4c1c42ef3d$export$9a4e88b92edfce6b = {
    minWidth: 'I',
    display: 'flex',
    TrackContainer: {
        opacity: 1,
        transition: 'A defaultBezier opacity',
        flex: '1',
        margin: '- C1 - -',
        position: 'relative',
        background: 'red',
        height: 'fit-content',
        align: 'center',
        Track: {
            position: 'absolute',
            theme: 'field',
            round: 'A',
            height: 'V',
            background: 'gray13.5',
            left: '0',
            transformOrigin: 'left'
        }
    },
    NavigationArrows: {
        childProps: {
            padding: 'Z',
            Icon: {
                display: 'block',
                fontSize: 'B1'
            }
        }
    }
};

});

parcelRegister("lWvHE", function(module, exports) {

$parcel$export(module.exports, "UploadAvatar", () => $ff979b5722e13ff9$export$c654e0224365d6b5);
const $ff979b5722e13ff9$export$c654e0224365d6b5 = {
    extends: [
        'GroupField'
    ],
    Title: {
        text: 'Pick the avatar'
    },
    UploadIcon: {}
};

});

parcelRegister("fCmA9", function(module, exports) {

$parcel$export(module.exports, "TutorialBanner", () => $b5ebebfb40bf9029$export$e8f6c4f4c0db666);
const $b5ebebfb40bf9029$export$e8f6c4f4c0db666 = {
    extends: [
        'Link',
        'ArticleMedium',
        'Hoverable'
    ],
    ':before': {
        theme: (el, s)=>s.theme,
        backgroundImage: (el, s)=>`url(${s.background})`
    },
    flow: 'column',
    round: 'A',
    height: 'E2',
    padding: 'A A2',
    href: '{{ href }}',
    gap: '0',
    overflow: 'hidden',
    position: 'relative',
    flex: 1,
    transitionProperty: 'transform, opacity, padding, color, background',
    scrollToTop: false,
    maxWidth: 'H',
    theme: 'common-card-interactive',
    userSelect: 'none',
    '& h2, & p': {
        zIndex: 2
    },
    ':after, &:before': {
        content: '""',
        position: 'absolute',
        zIndex: 0,
        inset: '-W -W -W -W'
    },
    ':before': {
        transition: 'B defaultBezier, A defaultBezier, A defaultBezier',
        transitionProperty: 'opacity, color, background',
        backgroundSize: 'cover',
        '@dark': {
            opacity: '0.5'
        },
        '@light': {
            opacity: '1'
        }
    },
    '.withShadow': {
        ':after': {
            transition: 'B defaultBezier, A defaultBezier, A defaultBezier',
            transitionProperty: 'opacity, color, background',
            background: 'shadow-overlay',
            '@dark': {
                opacity: '0.69'
            },
            '@light': {
                display: 'none'
            }
        }
    },
    ':hover': {
        padding: '- C1 - -',
        ':before': {
            opacity: '1'
        },
        ':after': {
            opacity: '1'
        }
    },
    Icon: {
        opacity: '0.5',
        fontSize: 'A2',
        margin: 'X - - -',
        name: 'play outline'
    },
    Title: {
        margin: 'auto 0 0',
        text: '{{ title }}'
    },
    P: {
        text: '{{ p }}'
    }
};

});

parcelRegister("fmcJS", function(module, exports) {

$parcel$export(module.exports, "UploadImage", () => $b2e2cac258186b2e$export$eaa555e7f7268368);
const $b2e2cac258186b2e$export$eaa555e7f7268368 = {
    extends: 'IconButton',
    boxSize: 'fit-content',
    round: 'Z2',
    Icon: {
        name: 'upload'
    }
};

});

parcelRegister("6eq6s", function(module, exports) {

$parcel$export(module.exports, "VerticalLine", () => $48984c6fd75c211d$export$ceb1bc6d1dff5ae8);
$parcel$export(module.exports, "Vr", () => $48984c6fd75c211d$export$7181d682076581e5);
const $48984c6fd75c211d$export$ceb1bc6d1dff5ae8 = {
    margin: '0 D',
    padding: '0',
    theme: 'line',
    widthRange: '1px'
};
const $48984c6fd75c211d$export$7181d682076581e5 = {
    margin: '0 D',
    padding: '0',
    theme: 'line',
    widthRange: '1px'
};

});

parcelRegister("e0mx5", function(module, exports) {

$parcel$export(module.exports, "VideoWrapper", () => $a3228b4b9ee6b6dc$export$9ec05c6a635ff130);
const $a3228b4b9ee6b6dc$export$9ec05c6a635ff130 = {
    overflow: 'hidden',
    position: 'relative',
    paddingBlockStart: '56.25%',
    width: '100%',
    round: 'A',
    childProps: {
        position: 'absolute',
        inset: '0',
        width: '100%',
        height: '100%'
    },
    onClick: (e, el)=>{
        el.Picture.update({
            hide: true
        });
        el.Iframe.update({
            hide: false,
            show: true
        });
    },
    Picture: {
        overflow: 'hidden',
        round: 'A',
        objectFit: 'cover',
        cursor: 'pointer',
        src: 'https://img.youtube.com/vi/{{code}}/maxresdefault.jpg',
        opacity: '0.65',
        transition: 'opacity defaultBezier A',
        ':hover': {
            opacity: 1
        },
        Button: {
            text: 'Watch the Video',
            theme: 'document',
            pointerEvents: 'none',
            gap: 'Y',
            fontWeight: '500',
            color: 'title',
            transition: 'letter-spacing B defaultBezier',
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
            opacity: '.65',
            zIndex: 1,
            padding: 'Y2 Z2',
            Icon: {
                name: 'playOutline',
                fontSize: 'B'
            }
        }
    },
    Iframe: {
        minWidth: 'none',
        minHeight: 'none',
        border: 'none',
        round: 'A',
        hide: true,
        src: 'https://www.youtube.com/embed/{{code}}?autoplay=1',
        allowfullscreen: true
    }
};

});

parcelRegister("2Llt2", function(module, exports) {

$parcel$export(module.exports, "LabeledCopy", () => $20309f80df0ba721$export$560d4c01c6d80887);
const $20309f80df0ba721$export$560d4c01c6d80887 = {};

});

parcelRegister("jgmam", function(module, exports) {

$parcel$export(module.exports, "WatchVideo", () => $e060b4ab01991195$export$c50dda5dcc7bdbae);
const $e060b4ab01991195$export$c50dda5dcc7bdbae = {
    align: 'center flex-start',
    gap: 'B1',
    round: 'A2',
    padding: 'X2 D X2 X1',
    maxWidth: 'fit-content',
    transition: 'transform B defaultBezier',
    cursor: 'pointer',
    borderColor: 'line',
    borderWidth: '1px',
    borderStyle: 'solid',
    '@mobileL': {
        flow: 'y',
        align: 'center center',
        padding: 'A A B1 A',
        gap: 'C1',
        round: 'B2'
    },
    ':hover': {
        transform: 'scale(1.0085)',
        '& img': {
            transform: 'scale(1.0085)'
        },
        '& button': {
            letterSpacing: 'X'
        }
    },
    onClick: (event, el, s)=>{
        el.call("openModalVideo", `https://www.youtube.com/embed/ko1TXI9pejg?autoplay=1`);
    },
    Img: {
        src: 'video.png',
        boxSize: 'E F',
        transition: 'transform, B, defaultBezier',
        '@mobileL': {
            boxSize: 'F 100%'
        }
    },
    Flex: {
        flow: 'y',
        align: 'flex-start flex-start',
        gap: 'A2',
        P: {
            text: `6 minutes video demonstrating
      11 unique features of Symbols`,
            maxWidth: 'F+C2',
            fontWeight: '300',
            margin: '0'
        },
        Button: {
            text: 'Watch the Video',
            theme: 'transparent',
            padding: '0',
            gap: 'Y',
            fontWeight: '500',
            color: 'title',
            transition: 'letter-spacing B defaultBezier',
            Icon: {
                name: 'playOutline',
                fontSize: 'B'
            }
        },
        '@mobileL': {
            align: 'center flex-start',
            textAlign: 'center'
        }
    }
};

});

parcelRegister("6vpNv", function(module, exports) {

$parcel$export(module.exports, "WiderButton", () => $4bc9a631e142a272$export$ba47c6c0f99b8a45);
const $4bc9a631e142a272$export$ba47c6c0f99b8a45 = {
    extends: 'SquareButton',
    theme: 'quinary',
    padding: 'Z Z2',
    align: 'center center',
    round: 'Z2'
};

});


parcelRegister("b3xtO", function(module, exports) {

var $3LQvr = parcelRequire("3LQvr");
$parcel$exportWildcard(module.exports, $3LQvr);

});
parcelRegister("3LQvr", function(module, exports) {

$parcel$export(module.exports, "TEMPLATES_DATA", () => $2bee7d811b161c1c$export$6ead1896ec010550);
const $2bee7d811b161c1c$export$6ead1896ec010550 = {
    0: {
        poster: 'https://api.symbols.app/core/files/public/68b667ce424350c909ec03f9/download',
        projectPath: 'nikoloza/default',
        amount: 206,
        title: 'Default'
    },
    1: {
        poster: 'https://api.symbols.app/core/files/public/68b667c8424350c909ec03d4/download',
        projectPath: 'nikoloza/ecommerce',
        amount: 271,
        title: 'Ecommerce'
    },
    2: {
        poster: 'https://api.symbols.app/core/files/public/68b667ac424350c909ec034e/download',
        projectPath: 'nikoloza/forms',
        amount: 248,
        title: 'Forms'
    },
    3: {
        poster: 'https://api.symbols.app/core/files/public/68b667c2424350c909ec03a6/download',
        projectPath: 'nikoloza/ai',
        amount: 213,
        title: 'AI'
    },
    4: {
        poster: 'https://api.symbols.app/core/files/public/68b667d6424350c909ec0421/download',
        projectPath: 'nikoloza/web3',
        amount: 85,
        title: 'Web3'
    },
    5: {
        poster: 'https://api.symbols.app/core/files/public/68b667db424350c909ec044f/download',
        projectPath: 'nikoloza/content-and-marketing',
        amount: 275,
        title: 'Content & Marketing'
    },
    6: {
        poster: 'https://api.symbols.app/core/files/public/68b66c9b424350c909ec1f66/download',
        projectPath: 'nikoloza/docs',
        amount: 598,
        title: 'Docs'
    },
    7: {
        poster: 'https://api.symbols.app/core/files/public/68b671ef424350c909ec5342/download',
        projectPath: 'nikoloza/charts',
        amount: 0,
        title: 'Charts'
    },
    8: {
        poster: 'https://api.symbols.app/core/files/public/68b66bfb424350c909ec1eb4/download',
        projectPath: 'nikoloza/ui',
        amount: 0,
        title: 'No-code'
    },
    9: {
        poster: 'https://api.symbols.app/core/files/public/68b672ad424350c909ec544b/download',
        projectPath: 'nikoloza/cms',
        amount: 0,
        title: 'CMS'
    },
    10: {
        poster: 'https://api.symbols.app/core/files/public/68b66c19424350c909ec1f0c/download',
        projectPath: 'nikoloza/code',
        amount: 0,
        title: 'Code'
    },
    11: {
        poster: 'https://api.symbols.app/core/files/public/68b63fae424350c909ea336e/download',
        projectPath: 'nikoloza/miscellaneous',
        amount: 0,
        title: 'Miscellaneous'
    }
};

});


parcelRegister("j4BM8", function(module, exports) {

$parcel$export(module.exports, "default", () => $de2bb1721b844ffc$export$2e2bcd8739ae039);
var $de2bb1721b844ffc$export$2e2bcd8739ae039 = {};

});

parcelRegister("e6rXy", function(module, exports) {

var $9tFYR = parcelRequire("9tFYR");

var $kW9r1 = parcelRequire("kW9r1");

var $4ImS9 = parcelRequire("4ImS9");

var $j569M = parcelRequire("j569M");

var $gZ1p9 = parcelRequire("gZ1p9");

var $e11pF = parcelRequire("e11pF");

var $1uobJ = parcelRequire("1uobJ");

var $6iFZW = parcelRequire("6iFZW");

var $9vcnA = parcelRequire("9vcnA");
$parcel$exportWildcard(module.exports, $9tFYR);
$parcel$exportWildcard(module.exports, $kW9r1);
$parcel$exportWildcard(module.exports, $4ImS9);
$parcel$exportWildcard(module.exports, $j569M);
$parcel$exportWildcard(module.exports, $gZ1p9);
$parcel$exportWildcard(module.exports, $e11pF);
$parcel$exportWildcard(module.exports, $1uobJ);
$parcel$exportWildcard(module.exports, $6iFZW);
$parcel$exportWildcard(module.exports, $9vcnA);

});
parcelRegister("9tFYR", function(module, exports) {

$parcel$export(module.exports, "closeModalVideo", () => $6e6762f8202aaae4$export$5687b430cd0199ec);
const $6e6762f8202aaae4$export$5687b430cd0199ec = function closeModalVideo2() {
    this.getRoot("ModalVideo").state.update({
        activeVideo: false
    });
};

});

parcelRegister("kW9r1", function(module, exports) {

$parcel$export(module.exports, "goToDocsPage", () => $f3e08afe01cdde73$export$a6d6f0714bb51bb);
const $f3e08afe01cdde73$export$a6d6f0714bb51bb = function goToDocsPage2(href) {
    if (!this.call("isString", href)) return this.warn("Href to docs link is not defined");
    const isInternal = href.startsWith("/");
    if ((this.isCanvas() || this.isEmbed()) && isInternal) return this.setWindow("docs", href.replace("/docs", ""));
    this.router(href, this.getRoot());
};

});

parcelRegister("4ImS9", function(module, exports) {

$parcel$export(module.exports, "isDocsContextPlatform", () => $36ed03746b9e5f98$export$416485bdd3cb86bc);
const $36ed03746b9e5f98$export$416485bdd3cb86bc = function isDocsContextPlatform2() {
    return this.getRootState("docsContext") === "Platform";
};

});

parcelRegister("j569M", function(module, exports) {

$parcel$export(module.exports, "openModalVideo", () => $de43428cdc61b45a$export$29869b8a2d1d9afd);
const $de43428cdc61b45a$export$29869b8a2d1d9afd = function openModalVideo2(url) {
    this.getRoot("ModalVideo").state.update({
        activeVideo: url
    });
};

});

parcelRegister("gZ1p9", function(module, exports) {

$parcel$export(module.exports, "navigateDocs", () => $c5d36ec32a6e34b0$export$f1b8f34232a3d56c);
const $c5d36ec32a6e34b0$export$f1b8f34232a3d56c = function navigateDocs2(ev) {
    ev.preventDefault();
    const href = this.call("resolveHref", this.href);
    this.call("goToDocsPage", href);
};

});

parcelRegister("e11pF", function(module, exports) {

$parcel$export(module.exports, "dropdownClick", () => $a342414716a0c6d0$export$2407ca004622027f);
const $a342414716a0c6d0$export$2407ca004622027f = async function dropdownClick2(event) {
    var _a, _b;
    const element = this;
    const { state: state, context: context } = element;
    if (state.subdropdown) {
        event.stopPropagation();
        const Dropdown3 = element.lookup("Dropdown");
        const SubDropdown = element.lookup("SubDropdown");
        const { top: dropdownTop, left: dropdownLeft } = Dropdown3.node.getBoundingClientRect();
        const { width: width, height: height } = SubDropdown.node.getBoundingClientRect();
        const { top: top, left: left } = element.node.getBoundingClientRect();
        const { innerWidth: innerWidth, innerHeight: innerHeight } = window;
        const topPos = top - dropdownTop;
        const leftPos = left - dropdownLeft;
        const diffX = left + width * 2 > innerWidth ? width * 2 : 0;
        const diffY = top + height > innerHeight ? Math.abs(innerHeight - top - height - 16) : 8;
        SubDropdown.setNodeStyles({
            transform: `translate3d(${leftPos - diffX}px, ${topPos - diffY}px, 1px)`,
            pointerEvents: "auto",
            visibility: "visible",
            opacity: "1"
        });
        return;
    }
    if (state.onClick) return await state.onClick(event, element, state, context);
    const Dropdown2 = element.lookup((el)=>el.isDropdownRoot);
    if (!Dropdown2) return;
    await ((_b = (_a = Dropdown2).onChoose) == null ? void 0 : _b.call(_a, event, Dropdown2, Dropdown2.state, Dropdown2.context, element));
};

});

parcelRegister("1uobJ", function(module, exports) {

$parcel$export(module.exports, "isDocsContextLocal", () => $115b5b156e9b7f79$export$1daf862776050ffe);
const $115b5b156e9b7f79$export$1daf862776050ffe = function isDocsContextLocal2() {
    return this.getRootState("docsContext") === "Local";
};

});

parcelRegister("6iFZW", function(module, exports) {

$parcel$export(module.exports, "isValidHTMLTag", () => $496500736686bb4d$export$47415734c66f337d);
const $496500736686bb4d$export$47415734c66f337d = function isValidHTMLTag2(v) {
    const HTML_TAGS = this.context.utils.HTML_TAGS;
    return HTML_TAGS.root.indexOf(v) > -1 || HTML_TAGS.body.indexOf(v) > -1;
};

});

parcelRegister("9vcnA", function(module, exports) {

$parcel$export(module.exports, "resolveHref", () => $6eb09c9b636763e3$export$e98df7762080a54d);
const $6eb09c9b636763e3$export$e98df7762080a54d = function resolveHref2(href) {
    var _b;
    const execHref = this.call("exec", href || this.href || ((_b = this.state) == null ? void 0 : _b.href));
    if (this.call("isString", href)) {
        if (href.includes("{{")) return this.call("replaceLiteralsWithObjectFields", execHref);
        return execHref;
    } else return this.warn("Href to docs link is not defined");
};

});


parcelRegister("7wcvP", function(module, exports) {

});

parcelRegister("aCEE2", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bbcfb331710bba2$export$2e2bcd8739ae039);

var $4tP58 = parcelRequire("4tP58");

var $k0gX7 = parcelRequire("k0gX7");

var $cgzAX = parcelRequire("cgzAX");

var $j4Pps = parcelRequire("j4Pps");

var $iSaTn = parcelRequire("iSaTn");

var $cTANi = parcelRequire("cTANi");

var $i7Ojk = parcelRequire("i7Ojk");

var $6NN1A = parcelRequire("6NN1A");

var $bLVnJ = parcelRequire("bLVnJ");

var $gh1Z9 = parcelRequire("gh1Z9");

var $99rxv = parcelRequire("99rxv");

var $e3EsD = parcelRequire("e3EsD");

var $bwsBv = parcelRequire("bwsBv");

var $kQ1hZ = parcelRequire("kQ1hZ");

var $1OYaQ = parcelRequire("1OYaQ");

var $972Bb = parcelRequire("972Bb");

var $hVlzD = parcelRequire("hVlzD");
var $7bbcfb331710bba2$export$2e2bcd8739ae039 = {
    color: $4tP58.default,
    gradient: $k0gX7.default,
    theme: $cgzAX.default,
    font: $j4Pps.default,
    font_family: $iSaTn.default,
    typography: $cTANi.default,
    spacing: $i7Ojk.default,
    timing: $6NN1A.default,
    class: (0, $bLVnJ.default),
    grid: $gh1Z9.default,
    icons: $99rxv.default,
    shape: $e3EsD.default,
    reset: $bwsBv.default,
    animation: $kQ1hZ.default,
    media: $1OYaQ.default,
    cases: $972Bb.default,
    a11y: $hVlzD.default
};

});
parcelRegister("4tP58", function(module, exports) {

$parcel$export(module.exports, "default", () => $34317ea665538bb7$export$2e2bcd8739ae039);
var $34317ea665538bb7$export$2e2bcd8739ae039 = {
    transparent: 'transparent',
    black: 'black',
    white: 'white',
    blue: '#0085FF',
    electricBlue: '#0009FE',
    cerulean: '#00BCFF',
    indigo: '#50E1FF',
    green: '#59AC56',
    red: '#EB6650',
    yellow: '#E8CC56',
    orange: '#E98232',
    brown: '#7D6755',
    pink: '#EE90BD',
    cyan: '#00FFFF',
    magenta: '#FF00FF',
    purple: '#7345AF',
    phosphorus: '#BCD835',
    indigoblue: '#55B7D8',
    milk: '#D8D8D8',
    grassgreen: '#6A9A55',
    gray: '#57575c',
    gray1: '#040404',
    gray2: '#141416',
    gray3: '#242428',
    gray4: '#34343a',
    gray5: '#45454b',
    gray6: '#55555d',
    gray7: '#65656f',
    gray8: '#757581',
    gray9: '#878791',
    gray10: '#9898a2',
    gray11: '#aaaab2',
    gray12: '#bcbcc2',
    gray13: '#ceced2',
    gray14: '#e0e0e2',
    gray15: '#f1f1f3',
    gray16: '#fafafb',
    color: '--pink.25',
    typography: '--indigoblue.25',
    space: '--blue.25',
    shape: '--purple.3',
    icons: '--brown.2',
    css: '--yellow.25',
    html: '--green.25',
    padding: '#C5D08A',
    margin: '#FACD9F',
    sizing: '#EAAC46',
    gap: '#CA3CE6',
    border: '#FEDC9B',
    document: [
        '--gray15 1',
        '--gray1 1 +4'
    ],
    'canvas-card': [
        '--gray16 0.95 +6',
        '--gray1 0.85'
    ],
    highlight: [
        '--black 1',
        '--white 1'
    ],
    'highlight-reversed': [
        '--white 1',
        '--black 1'
    ],
    title: [
        '--gray1 1',
        '--gray15 1'
    ],
    'title-reversed': [
        '--gray15 1',
        '--gray1 1'
    ],
    subtitle: [
        '--gray2 1',
        '--gray14 1'
    ],
    caption: [
        '--gray3 1',
        '--gray13 1'
    ],
    code: [
        '--gray2 1',
        '--gray14 1'
    ],
    paragraph: [
        '--gray4 1',
        '--gray12 1'
    ],
    placeholder: [
        '--gray4 1',
        '--gray12 1'
    ],
    inactive: [
        '--gray6 1',
        '--gray10 1'
    ],
    disabled: [
        '--gray7 1',
        '--gray9 1'
    ],
    dim: [
        '--gray9 1',
        '--gray7 1'
    ],
    shadow: [
        '--gray14 1',
        '--gray3 1'
    ],
    overlay: [
        '--gray14 .05',
        '--gray2 .05'
    ],
    overlayStrong: [
        '--gray14 .95',
        '--gray2 .98'
    ],
    'document-background': [
        '--gray15 1',
        '--gray1 1 +4'
    ],
    line: [
        '--gray13 1',
        '--gray2 1 +12'
    ],
    'line-faded': [
        '--gray15 1',
        '--gray1 1 +26'
    ],
    'line-highlight': [
        '--gray13 1 +4',
        '--gray2 1 +16'
    ],
    blue2: '#4676EC',
    lightBlue: '#6899D1'
};

});

parcelRegister("k0gX7", function(module, exports) {

$parcel$export(module.exports, "default", () => $e900f52df5795622$export$2e2bcd8739ae039);
var $e900f52df5795622$export$2e2bcd8739ae039 = {
    dotsDark: 'radial-gradient(#252527 6%, transparent 6%)',
    dotsMid: 'radial-gradient(#43434b 6%, transparent 6%)',
    dotsLight: 'radial-gradient(#d9d9db 6%, transparent 6%)',
    radialGrad: 'radial-gradient(#08080E00 0%, #0A0A0B 100%)',
    transparentBg: 'linear-gradient(45deg, #1c1c1f 25%, transparent 25%), linear-gradient(-45deg, #1c1c1f 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #1c1c1f 75%), linear-gradient(-45deg, transparent 75%, #1c1c1f 75%)',
    'shadow-overlay': {
        '@dark': 'linear-gradient(0deg, var(--theme-document-dark-background) 0%, transparent 100%)',
        '@light': 'linear-gradient(0deg, var(--theme-document-light-background) 0%, transparent 100%)'
    },
    'shadow-overlay-reversed': {
        '@dark': 'linear-gradient(180deg, var(--theme-document-dark-background) 0%, transparent 100%)',
        '@light': 'linear-gradient(180deg, var(--theme-document-light-background) 0%, transparent 100%)'
    },
    'panel-overlay': {
        '@dark': 'linear-gradient(to top, rgba(8, 8, 8, 1) 0%, rgba(8, 8, 8, .85) 45%, rgba(8, 8, 8, .65) 65%, rgba(8, 8, 8, 0) 100%)',
        '@light': 'linear-gradient(to top, rgba(241, 241, 243, 1) 0%, rgba(241, 241, 243, 0.85) 65%, rgba(241, 241, 243, 0.65) 40%, rgba(241, 241, 243, 0) 100%)'
    },
    'button-gradient': 'linear-gradient(to top, rgba(50, 114, 184, .2), rgba(0, 121, 253, .27), rgba(0, 121, 253, .27))',
    'button-gradient-active': 'linear-gradient(to top, rgba(50, 114, 184, .25), rgba(0, 121, 253, .32), rgba(0, 121, 253, .32))',
    theme: 'conic-gradient(rgba(91,194,229,0.3), rgba(109,71,169,0.3), rgba(238,144,189,0.3), rgba(52,119,244,0.3), rgba(91,194,229,0.3))',
    themeDark: 'conic-gradient(rgba(91,194,229,0.65), rgba(109,71,169,0.65), rgba(238,144,189,0.65), rgba(52,119,244,0.65), rgba(91,194,229,0.65))',
    'gradient-dark': `linear-gradient(0deg,
    rgba(0,0,0,0.06) 0%,
    rgba(0,0,0,0.07) 100%
  )`,
    'gradient-dark-active': `linear-gradient(0deg,
    rgba(0,0,0,0.1) 0%,
    rgba(0,0,0,0.11) 100%
  )`,
    'gradient-light': `linear-gradient(
    0deg,
    rgba(255,255,255,0.05) 0%,
    rgba(255,255,255,0.06) 100%
  )`,
    'gradient-light-active': `linear-gradient(
    0deg,
    rgba(255,255,255,0.09) 0%,
    rgba(255,255,255,0.10) 100%
  )`,
    'gradient-colorful': `linear-gradient(60deg,
    #0E1766 0%,
    #2127A7 65%,
    #1A1F8E 100%
  )`,
    'gradient-colorful-active': `linear-gradient(60deg,
    #00A2E7 0%,
    #185DF3 25%,
    #1E54F0 32%,
    #8B4CCA 75%,
    #C66894 100%
  )`
};

});

parcelRegister("cgzAX", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ee29715b29eeb89$export$2e2bcd8739ae039);
var $8ee29715b29eeb89$export$2e2bcd8739ae039 = {
    transparent: {
        '@dark': {
            background: 'transparent',
            color: 'white.65'
        },
        '@light': {
            background: 'transparent',
            color: 'black.65'
        }
    },
    text: {
        background: 'transparent.0',
        '@dark': {
            color: 'gray10'
        },
        '@light': {
            color: 'gray4'
        }
    },
    document: {
        '@dark': {
            color: 'gray12',
            background: 'gray1+4'
        },
        '@light': {
            background: 'gray15',
            color: 'gray1'
        }
    },
    primary: {
        '@dark': {
            color: 'white',
            background: 'electricBlue'
        },
        '@light': {
            color: 'white',
            background: 'gray1'
        }
    },
    secondary: {
        '@dark': {
            color: 'gray14',
            background: 'gray2.85',
            ':hover': {
                color: 'gray15',
                background: 'gray2+6'
            },
            ':active': {
                color: 'gray16',
                background: 'gray2+10'
            },
            '.isActive': {
                color: 'gray16',
                background: 'gray2+10'
            }
        },
        '@light': {
            color: 'gray4',
            background: 'gradient-dark',
            ':hover': {
                color: 'gray2',
                background: 'gradient-dark-active'
            },
            ':active': {
                color: 'gray2',
                background: 'gradient-dark-active'
            },
            '.isActive': {
                color: 'gray2',
                background: 'gradient-dark-active'
            }
        }
    },
    'secondary-highlight': {
        '@dark': {
            color: 'gray14',
            background: 'gray2.85+16',
            ':hover': {
                color: 'gray15',
                background: 'gray2+20'
            },
            ':active': {
                color: 'gray16',
                background: 'gray2+26'
            },
            '.isActive': {
                color: 'gray16',
                background: 'gray2+26'
            }
        },
        '@light': {
            color: 'gray3',
            background: 'gray15',
            ':hover': {
                color: 'gray2',
                background: 'white'
            },
            ':active': {
                color: 'gray2',
                background: 'white'
            },
            '.isActive': {
                color: 'gray2',
                background: 'white'
            }
        }
    },
    tertiary: {
        '@dark': {
            color: 'gray10',
            background: 'transparent',
            ':hover': {
                color: 'gray15',
                background: 'gray2+6'
            },
            ':active': {
                color: 'gray16',
                background: 'gray2+10'
            },
            '.isActive': {
                color: 'gray16',
                background: 'gray2+10'
            }
        },
        '@light': {
            color: 'gray6',
            background: 'transparent',
            ':hover': {
                color: 'gray2',
                background: 'gradient-dark-active'
            },
            ':active': {
                color: 'gray2',
                background: 'gradient-dark-active'
            },
            '.isActive': {
                color: 'gray2',
                background: 'gradient-dark-active'
            }
        }
    },
    quaternary: {
        '@dark': {
            color: 'gray10',
            background: 'gray3.95',
            ':hover': {
                color: 'gray15',
                background: 'gray3'
            },
            ':active': {
                color: 'gray15',
                background: 'gray3'
            },
            '.isActive': {
                color: 'gray15',
                background: 'gray3'
            }
        },
        '@light': {
            color: 'gray2',
            background: 'gray15.95',
            ':hover': {
                color: 'gray15',
                background: 'gray4'
            },
            ':active': {
                color: 'gray15',
                background: 'gray4'
            },
            '.isActive': {
                color: 'gray15',
                background: 'gray4'
            }
        }
    },
    quinary: {
        '@dark': {
            color: 'gray10',
            background: 'gradient-light',
            ':hover': {
                color: 'gray15',
                background: 'gradient-light-active'
            },
            ':active': {
                color: 'gray15',
                background: 'gradient-light-active'
            },
            '.isActive': {
                color: 'gray15',
                background: 'gradient-light-active'
            }
        },
        '@light': {
            color: 'gray4',
            background: 'gradient-dark',
            ':hover': {
                color: 'gray2',
                background: 'gradient-dark-active'
            },
            ':active': {
                color: 'gray2',
                background: 'gradient-dark-active'
            },
            '.isActive': {
                color: 'gray2',
                background: 'gradient-dark-active'
            }
        },
        '.child': '--quaternary'
    },
    default: {
        '@dark': {
            color: 'gray11',
            background: 'gray6.35'
        },
        '@light': {
            background: 'gray7.15',
            color: 'gray6=32'
        }
    },
    property: {
        '@dark': {
            color: '--theme-default-dark-color',
            background: '--theme-default-dark-background'
        },
        '@light': {
            background: '--theme-default-light-background',
            color: '--theme-default-light-color'
        }
    },
    color: {
        '@dark': {
            color: 'white',
            background: 'color.25'
        },
        '@light': {
            background: 'color.25',
            color: 'color=32'
        }
    },
    theme: {
        '@dark': {
            color: 'white',
            background: 'theme'
        },
        '@light': {
            color: 'gray4.75',
            background: 'theme'
        }
    },
    typography: {
        '@dark': {
            color: 'white',
            background: 'typography.25'
        },
        '@light': {
            background: 'typography.25',
            color: 'typography=32'
        }
    },
    space: {
        '@dark': {
            color: 'white',
            background: 'space.25'
        },
        '@light': {
            background: 'space.25',
            color: 'space=32'
        }
    },
    shape: {
        '@dark': {
            color: 'white',
            background: 'shape.3'
        },
        '@light': {
            background: 'shape.3',
            color: 'shape=32'
        }
    },
    icons: {
        '@dark': {
            color: 'white',
            background: 'icons.25'
        },
        '@light': {
            background: 'icons.25',
            color: 'icons=32'
        }
    },
    css: {
        '@dark': {
            color: 'white',
            background: 'css.25'
        },
        '@light': {
            background: 'css.25',
            color: 'css=32'
        }
    },
    html: {
        '@dark': {
            color: 'white',
            background: 'html.28'
        },
        '@light': {
            background: 'html.28',
            color: 'html=32'
        }
    },
    alert: {
        background: 'yellow',
        color: 'black'
    },
    warning: {
        '@dark': {
            background: 'yellow.85',
            color: 'gray1'
        },
        '@light': {
            color: 'gray16',
            background: 'yellow'
        }
    },
    error: {
        '@dark': {
            background: 'red.85',
            color: 'gray1'
        },
        '@light': {
            background: 'red',
            color: 'gray16'
        }
    },
    success: {
        '@dark': {
            background: 'green.85',
            color: 'gray1'
        },
        '@light': {
            background: 'green',
            color: 'gray16'
        }
    },
    info: '--common-card-outline-interactive',
    header: {
        '@dark': {
            color: 'white',
            background: 'gray1.85',
            borderColor: 'white.01'
        },
        '@light': {
            color: 'black',
            background: 'gray15.9',
            borderColor: 'black.01'
        }
    },
    navbar: {
        '@dark': {
            color: 'white',
            backdropFilter: 'blur(3px)',
            background: 'gray1.9+6'
        },
        '@light': {
            color: 'black',
            backdropFilter: 'blur(3px)',
            background: 'gray15.95'
        }
    },
    navbarButton: {
        '@dark': {
            color: 'gray14',
            background: 'transparent.0',
            ':hover': {
                color: 'white',
                background: 'gray4.9'
            },
            ':active': {
                color: 'white',
                background: 'gray5.9'
            }
        },
        '@light': {
            color: 'gray3',
            background: 'transparent.0',
            ':hover': {
                color: 'black',
                background: 'gray13.95'
            },
            ':active': {
                color: 'black',
                background: 'gray12.95'
            }
        }
    },
    'navbarButton-active': {
        '@dark': {
            color: 'white',
            background: 'gray5',
            ':hover': {
                background: 'gray5.9'
            }
        },
        '@light': {
            color: 'black',
            background: 'gray11',
            ':hover': {
                background: 'gray12.95'
            }
        }
    },
    'navbar-button': {
        '@dark': {
            color: 'gray14',
            backgroundColor: 'transparent.0'
        },
        '@light': {
            color: 'gray3',
            backgroundColor: 'transparent.0'
        },
        ':hover': {
            '@dark': {
                color: 'white',
                backgroundColor: 'gray5.9'
            },
            '@light': {
                color: 'black',
                backgroundColor: 'gray12.95'
            }
        },
        ':active': {
            '@dark': {
                color: 'white',
                backgroundColor: 'gray5.9'
            },
            '@light': {
                color: 'black',
                backgroundColor: 'gray12.95'
            }
        }
    },
    'navbar-button-active': {
        '@dark': {
            color: 'white',
            backgroundColor: 'gray5'
        },
        '@light': {
            color: 'black',
            backgroundColor: 'gray11'
        },
        ':hover': {
            '@dark': {
                backgroundColor: 'gray5.9'
            },
            '@light': {
                backgroundColor: 'gray12.95'
            }
        }
    },
    stroke: {
        '@dark': {
            color: 'transparent',
            '-webkit-text-stroke': '.5px white'
        },
        '@light': {
            color: 'transparent',
            '-webkit-text-stroke': '.5px black'
        }
    },
    'common-card': {
        '@dark': {
            color: 'gray12',
            background: 'gray2.65'
        },
        '@light': {
            color: 'gray2',
            background: 'gray16+6'
        }
    },
    'common-card-interactive': {
        '@dark': {
            color: 'gray13',
            background: 'gray2.65',
            ':hover': {
                background: 'gray2'
            },
            ':focus': {
                background: 'gray2+6'
            },
            ':active': {
                background: 'gray2+6'
            }
        },
        '@light': {
            color: 'gray3',
            background: 'gray16+6',
            ':hover': {
                background: 'gray16+16'
            },
            ':focus': {
                background: 'gray16+26'
            },
            ':active': {
                background: 'gray16+26'
            }
        }
    },
    'common-card-outline': {
        '@dark': {
            color: 'gray12',
            borderColor: 'gray3.65'
        },
        '@light': {
            color: 'gray2',
            borderColor: 'gray14'
        }
    },
    'common-card-outline-interactive': {
        '@dark': {
            color: 'gray12',
            borderColor: 'gray3.65',
            ':hover': {
                background: 'gray2.65'
            },
            ':focus': {
                background: 'gray2'
            },
            ':active': {
                background: 'gray2'
            }
        },
        '@light': {
            color: 'gray2',
            borderColor: 'gray14',
            ':hover': {
                background: 'gray16.65'
            },
            ':focus': {
                background: 'gray16'
            },
            ':active': {
                background: 'gray16'
            }
        }
    },
    'common-card-child': {
        '@dark': {
            color: 'gray12',
            background: 'gray2-10'
        },
        '@light': {
            color: 'gray2',
            background: 'gray16+16'
        }
    },
    'common-box': {
        '@dark': {
            background: 'gray2'
        },
        '@light': {
            background: 'white.75'
        }
    },
    'common-box-secondary': {
        '@dark': {
            background: 'gray3'
        },
        '@light': {
            background: 'white.65'
        }
    },
    'canvas-card': {
        '@dark': {
            borderWidth: '1px',
            borderColor: 'line',
            borderStyle: 'solid',
            boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',
            color: 'gray12',
            background: 'gray1.97'
        },
        '@light': {
            color: 'gray2',
            background: 'gray16+6'
        }
    },
    'canvas-card-glass': {
        '@dark': {
            borderWidth: '1px',
            borderColor: 'line',
            borderStyle: 'solid',
            boxShadow: '0 6px 16px -6px rgb(79 79 79 / 10%) inset, 0 4px 32px rgba(0, 0, 0, 0.25)',
            backdropFilter: 'blur(35px)',
            background: 'gray1.85',
            color: 'gray12'
        },
        '@light': {
            color: 'gray2',
            background: 'gray16.95+6',
            backdropFilter: 'blur(35px)',
            boxShadow: '0 6px 16px -6px rgb(255 255 255 / 26%) inset, 0 10px 16px rgba(0, 0, 0, 0.01)'
        }
    },
    'canvas-card-glass-reversed': {
        '@dark': {
            borderWidth: '1px',
            borderColor: 'line',
            borderStyle: 'solid',
            boxShadow: '0 6px 16px -6px rgb(255 255 255 / 26%) inset, 0 10px 16px rgba(0, 0, 0, 0.01)',
            backdropFilter: 'blur(35px)',
            background: 'gray16.95+6',
            color: 'gray2'
        },
        '@light': {
            color: 'gray12',
            background: 'gray1.85',
            backdropFilter: 'blur(35px)',
            boxShadow: '0 6px 16px -6px rgb(79 79 79 / 10%) inset, 0 4px 32px rgba(0, 0, 0, 0.25)'
        }
    },
    'dialog-elevated': {
        '@dark': {
            color: 'title',
            background: 'gray3.95-16'
        },
        '@light': {
            color: 'title',
            background: 'gray14.98'
        }
    },
    field: {
        '@dark': {
            color: 'gray14',
            background: 'gray3.5',
            ':hover': {
                color: 'gray15',
                background: 'gray3.65+2'
            },
            ':focus': {
                color: 'gray16',
                background: 'gray3.65+6'
            }
        },
        '@light': {
            color: 'gray3',
            background: 'white.95',
            ':hover': {
                color: 'gray2',
                background: 'white'
            },
            ':focus': {
                color: 'gray2',
                background: 'white'
            }
        }
    },
    'field-placeholder': {
        '@dark': {
            color: 'gray12',
            background: 'gray3.5',
            ':hover': {
                color: 'gray15',
                background: 'gray3.65+2'
            },
            ':focus': {
                color: 'gray16',
                background: 'gray3.65+6'
            }
        },
        '@light': {
            color: 'gray5',
            background: 'white.85',
            ':hover': {
                color: 'gray2',
                background: 'white'
            },
            ':focus': {
                color: 'gray2',
                background: 'white'
            }
        }
    },
    'field-static': {
        '@dark': {
            color: 'gray14',
            background: 'gray3.5'
        },
        '@light': {
            color: 'gray3',
            background: 'white.95'
        }
    },
    'field-highlight': {
        '@dark': {
            color: 'gray14',
            background: 'gray3.65+6',
            ':hover': {
                color: 'gray15',
                background: 'gray3.85+10'
            },
            ':focus': {
                color: 'gray16',
                background: 'gray3.85+10'
            }
        },
        '@light': {
            color: 'gray3',
            background: 'white.95',
            ':hover': {
                color: 'gray2',
                background: 'white'
            },
            ':focus': {
                color: 'gray2',
                background: 'white'
            }
        }
    },
    scene: {
        '@dark': {
            color: 'gray14',
            background: 'gray2.85'
        },
        '@light': {
            color: 'gray4',
            background: 'gradient-dark'
        }
    },
    'scene-preview-interactive': {
        '@dark': {
            color: 'gray13',
            background: 'gray2.5',
            ':hover': {
                background: 'gray2.85'
            },
            ':active': {
                background: 'gray2+1'
            }
        },
        '@light': {
            color: 'gray3',
            background: 'gray16+6',
            ':hover': {
                background: 'gray16+16'
            },
            ':active': {
                background: 'gray16+26'
            }
        }
    },
    headerCaptions: {
        '@dark': {
            color: 'white',
            backdropFilter: 'blur(3px)',
            backgroundColor: 'gray2.95-6'
        },
        '@light': {
            color: 'black',
            backdropFilter: 'blur(3px)',
            backgroundColor: 'gray13.89'
        }
    },
    headerSidebar: {
        '@dark': {
            color: 'white',
            background: 'gray1.95',
            borderColor: 'white.01'
        },
        '@light': {
            color: 'black',
            background: 'gray16.95+10',
            borderColor: 'black.01'
        }
    },
    layer: {
        '@dark': {
            background: 'gray7.1'
        },
        '@light': {
            background: 'gray15.1'
        }
    },
    transparentPattern: {
        '@dark': {
            background: 'transparentBg',
            backgroundColor: 'document',
            backgroundSize: '20px 20px',
            backgroundPosition: '0 0, 0 10px, 10px -10px, -10px 0px'
        }
    },
    dots: {
        backgroundPosition: 'top',
        backgroundRepeat: 'repeat',
        backgroundSize: '20px 20px',
        '@dark': {
            backgroundImage: 'dotsDark',
            backgroundPosition: 'top',
            backgroundRepeat: 'repeat',
            backgroundSize: '20px 20px'
        },
        '@light': {
            backgroundImage: 'dotsLight',
            backgroundPosition: 'top',
            backgroundRepeat: 'repeat',
            backgroundSize: '20px 20px'
        }
    },
    line: {
        '@dark': {
            background: '--color-line-dark'
        },
        '@light': {
            background: '--color-line-light'
        }
    },
    modalFade: {
        '@dark': {
            color: 'white',
            backdropFilter: 'blur(3px)',
            backgroundColor: 'gray1.75+6'
        },
        '@light': {
            color: 'black',
            backdropFilter: 'blur(3px)',
            backgroundColor: 'gray13.75'
        }
    },
    modal: {
        '@dark': {
            color: 'white',
            background: 'gray2'
        },
        '@light': {
            color: 'gray5',
            background: 'gray16'
        }
    },
    modalPreview: {
        '@dark': {
            color: 'white',
            background: 'gray3.98-16'
        },
        '@light': {
            color: 'gray5',
            background: 'gray16'
        }
    },
    sepia: {
        ':hover': {
            opacity: '.65'
        },
        ':active': {
            opacity: '1'
        },
        '@dark': {
            color: 'yellow',
            background: 'transparent.0',
            ':hover': {
                background: 'yellow.15=85'
            },
            ':active': {
                background: 'yellow.15=85'
            }
        },
        '@light': {
            color: 'yellow-25',
            background: 'transparent.0',
            ':hover': {
                background: 'yellow.2'
            },
            ':active': {
                background: 'yellow.2'
            }
        }
    },
    'sepia-active': {
        color: 'yellow',
        background: 'yellow.15=85',
        borderColor: 'yellow.15=85'
    }
};

});

parcelRegister("j4Pps", function(module, exports) {

$parcel$export(module.exports, "default", () => $de3644ef912b6540$export$2e2bcd8739ae039);
var $de3644ef912b6540$export$2e2bcd8739ae039 = {
    smbls: [
        {
            url: 'https://assets.symbo.ls/fonts/49c5f3e1-5867-4b1d-a843-2d07fa60d85d.woff2',
            fontWeight: 300
        },
        {
            url: 'https://assets.symbo.ls/fonts/2cd55546-ec00-4af9-aeca-4a3cd186da53.woff2',
            fontWeight: 400
        },
        {
            url: 'https://assets.symbo.ls/fonts/627fbb5a-3bae-4cd9-b617-2f923e29d55e.woff2',
            fontWeight: 500
        },
        {
            url: 'https://assets.symbo.ls/fonts/6afe4676-059a-4aa8-b891-29856bbcba22.woff2',
            fontWeight: 600
        },
        {
            url: 'https://assets.symbo.ls/fonts/14c73713-e4df-4dba-933b-057feeac8dd1.woff2',
            fontWeight: 700
        },
        {
            url: 'https://assets.symbo.ls/fonts/5c57b2e2-f641-421e-a95f-65fcb47e409a.woff2',
            fontWeight: 900
        }
    ],
    DmSansVariable: {
        url: 'https://fonts.gstatic.com/s/dmsans/v17/rP2Hp2ywxg089UriCZOIHTWEBlw.woff2',
        variable: true
    },
    smblsVariable: {
        url: 'https://assets.symbo.ls/fonts/AvenirNext_Variable.ttf',
        variable: true
    }
};

});

parcelRegister("iSaTn", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbd5b817d57aa56e$export$2e2bcd8739ae039);
var $dbd5b817d57aa56e$export$2e2bcd8739ae039 = {
    smbls: {
        isDefault: true,
        value: [
            '"smblsVariable"',
            '"smbls"',
            '"Helvetica Neue"',
            '"Helvetica"',
            '"DmSansVariable"'
        ],
        type: 'serif'
    },
    Code: {
        value: [
            '"Droid Sans Mono for Powerline"'
        ],
        type: 'monospace'
    }
};

});

parcelRegister("cTANi", function(module, exports) {

$parcel$export(module.exports, "default", () => $963729a82d3ec735$export$2e2bcd8739ae039);
var $963729a82d3ec735$export$2e2bcd8739ae039 = {
    base: 17,
    ratio: 1.2,
    subSequence: true,
    '@screenS': {
        base: 16,
        ratio: 1.15
    },
    '@tabletS': {
        base: 15,
        ratio: 1.1
    }
};

});

parcelRegister("i7Ojk", function(module, exports) {

$parcel$export(module.exports, "default", () => $d31fe81f234a569c$export$2e2bcd8739ae039);
var $d31fe81f234a569c$export$2e2bcd8739ae039 = {
    base: 17,
    ratio: 1.618,
    range: [
        '-6',
        12
    ],
    subSequence: true
};

});

parcelRegister("6NN1A", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f3d58f5c2e58291$export$2e2bcd8739ae039);
var $4f3d58f5c2e58291$export$2e2bcd8739ae039 = {
    default: 150,
    base: 150,
    subSequence: true,
    defaultBezier: 'cubic-bezier(.29, .67, .51, .97)'
};

});

parcelRegister("bLVnJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $892098543a46d778$export$2e2bcd8739ae039);
var $892098543a46d778$export$2e2bcd8739ae039 = {};

});

parcelRegister("gh1Z9", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd8fc61d8d38f81d$export$2e2bcd8739ae039);
var $bd8fc61d8d38f81d$export$2e2bcd8739ae039 = {};

});

parcelRegister("99rxv", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a9a51114d97fa1c$export$2e2bcd8739ae039);
var $6a9a51114d97fa1c$export$2e2bcd8739ae039 = {
    return: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M8.05064658,21.553253 C7.76773351,21.553253 7.51729885,21.4475567 7.29934261,21.236164 L1.33151755,15.3674717 C1.22242626,15.264944 1.13990052,15.1480443 1.08394031,15.0167726 C1.0279801,14.885501 1,14.7477223 1,14.6034366 C1,14.4656014 1.0279801,14.3292373 1.08394031,14.1943443 C1.13990052,14.0594514 1.22242626,13.9410805 1.33151755,13.8392318 L7.29934261,7.97155798 C7.51729885,7.76016532 7.76773351,7.654469 8.05064658,7.654469 C8.35653221,7.654469 8.60057303,7.7491883 8.78276905,7.93862689 C8.96496507,8.12806549 9.05606308,8.36712704 9.05606308,8.65581155 C9.05606308,8.80507649 9.03178914,8.9384983 8.98324126,9.05607697 C8.93469337,9.17365565 8.8617018,9.27788083 8.76426653,9.36875251 L5.9792136,12.0896408 L3.42349002,14.2583392 L3.16632203,13.7183713 L6.49422857,13.5796874 L19.4415759,13.5796874 C19.9715287,13.5796874 20.3561207,13.4584025 20.595352,13.2158328 C20.8345833,12.9732632 20.9541989,12.5804949 20.9541989,12.0375282 L20.9541989,6.01877874 C20.9541989,5.48893913 20.8345833,5.10437538 20.595352,4.8650875 C20.3561207,4.62579962 19.9715287,4.50615567 19.4415759,4.50615567 L13.7371995,4.50615567 C13.4254293,4.50615567 13.1732405,4.40495767 12.9806333,4.20256165 C12.7880261,4.00016563 12.6917225,3.76011389 12.6917225,3.48240641 C12.6917225,3.19813535 12.7880261,2.95499985 12.9806333,2.75299991 C13.1732405,2.55099997 13.4254293,2.45 13.7371995,2.45 L19.4666986,2.45 C20.7078948,2.45 21.6070775,2.72838647 22.1642465,3.28515941 C22.7214155,3.84193235 23,4.74091695 23,5.98211321 L23,12.0741937 C23,13.2883435 22.7214155,14.1840463 22.1642465,14.7613021 C21.6070775,15.338558 20.7078948,15.6271859 19.4666986,15.6271859 L6.49422857,15.6271859 L3.16632203,15.4883322 L3.42349002,14.948534 L5.9792136,17.1160443 L8.76426653,19.8389695 C8.8617018,19.9291622 8.93469337,20.0330478 8.98324126,20.1506265 C9.03178914,20.2682052 9.05606308,20.401627 9.05606308,20.5508919 C9.05606308,20.84614 8.96496507,21.0870122 8.78276905,21.2735085 C8.60057303,21.4600048 8.35653221,21.553253 8.05064658,21.553253 Z"/></svg>',
    googleLogoNormal: '<svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 48 48" width="48px" height="48px"><path fill="#FFC107" d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"/><path fill="#FF3D00" d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"/><path fill="#4CAF50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"/><path fill="#1976D2" d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"/></svg>',
    facebook: '<svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 48 48" width="48px" height="48px"><linearGradient id="Ld6sqrtcxMyckEl6xeDdMa" x1="9.993" x2="40.615" y1="9.993" y2="40.615" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#2aa4f4"/><stop offset="1" stop-color="#007ad9"/></linearGradient><path fill="url(#Ld6sqrtcxMyckEl6xeDdMa)" d="M24,4C12.954,4,4,12.954,4,24s8.954,20,20,20s20-8.954,20-20S35.046,4,24,4z"/><path fill="#fff" d="M26.707,29.301h5.176l0.813-5.258h-5.989v-2.874c0-2.184,0.714-4.121,2.757-4.121h3.283V12.46 c-0.577-0.078-1.797-0.248-4.102-0.248c-4.814,0-7.636,2.542-7.636,8.334v3.498H16.06v5.258h4.948v14.452 C21.988,43.9,22.981,44,24,44c0.921,0,1.82-0.084,2.707-0.204V29.301z"/></svg>',
    accessibility: '<svg height="24" width="24"><path d="M19.368 6.848c-1.752 1.034-3.11 1.805-4.315 2.305a.496.496 0 00-.303.46V20.5c0 .275-.225.5-.5.5h-1a.5.5 0 01-.5-.5v-5h-1.5v5c0 .275-.225.5-.5.5h-.998a.5.5 0 01-.5-.5V9.613c0-.2-.118-.383-.303-.46-1.206-.5-2.564-1.27-4.317-2.305a.5.5 0 01-.177-.686l.424-.717a.5.5 0 01.685-.176C8.794 7.172 10.44 7.972 12 8c1.56-.027 3.206-.827 6.436-2.73a.5.5 0 01.685.176l.424.717a.5.5 0 01-.177.686M12 3c1.008 0 1.833.825 1.833 1.832s-.825 1.833-1.833 1.833c-1.007 0-1.832-.825-1.832-1.833S10.992 3 11.999 3m0-2C5.924 1 1 5.925 1 12s4.925 11 11 11c6.076 0 11-4.925 11-11S18.075 1 12 1" fill-rule="evenodd"/></svg>',
    accessibilityOutline: '<svg height="24" width="24"><path d="M19.06 4.457a.5.5 0 01.685.176l.51.86a.5.5 0 01-.177.686c-1.94 1.144-3.437 1.996-4.764 2.545a.503.503 0 00-.315.464v12.27c0 .275-.224.5-.5.5h-1a.5.5 0 01-.5-.5V16h-2v5.458c0 .275-.224.5-.5.5h-.997a.5.5 0 01-.5-.5V9.188a.504.504 0 00-.314-.464c-1.328-.549-2.826-1.4-4.766-2.545a.5.5 0 01-.177-.685l.51-.861a.5.5 0 01.684-.176C8.49 6.55 10.292 7.428 12 7.46l.172-.006c1.659-.085 3.458-.973 6.89-2.996zM12 2.017c1.099 0 1.998.9 1.998 2 0 1.099-.9 1.999-1.999 1.999-1.099 0-1.999-.9-1.999-2 0-1.099.9-1.998 2-1.998z" fill-rule="evenodd"/></svg>',
    colorContrast: '<svg height="24" width="24"><path d="M12 5c5.58 0 8.83 4.917 9.737 6.509a.992.992 0 010 .983C20.83 14.084 17.58 19 12 19c-5.58 0-8.83-4.916-9.737-6.508a.992.992 0 010-.983C3.169 9.917 6.42 5 12 5zm3.882 3.118L14.12 9.88A2.99 2.99 0 0012 9c-1.654 0-3 1.346-3 3 0 .827.336 1.577.88 2.12l-1.762 1.762C9.214 16.542 10.51 17 12 17c4.04 0 6.664-3.366 7.7-5-.654-1.031-1.942-2.752-3.818-3.882zM14.12 9.88A2.99 2.99 0 0115 12c0 1.654-1.346 3-3 3a2.99 2.99 0 01-2.12-.88z" fill-rule="evenodd"/></svg>',
    colorContrastAlt: '<svg height="24" width="24"><path d="M12 16.001v-8c2.207 0 4 1.794 4 4 0 2.203-1.793 4-4 4m9.737-4.492C20.83 9.916 17.58 5 12 5 6.42 5 3.17 9.916 2.263 11.51a.991.991 0 000 .982c.907 1.593 4.158 6.51 9.737 6.51 5.58 0 8.83-4.917 9.737-6.51a.991.991 0 000-.982" fill-rule="evenodd"/></svg>',
    colorContrastAltOutline: '<svg height="24" width="24"><path d="M12 5c5.58 0 8.83 4.917 9.737 6.509a.993.993 0 010 .983C20.831 14.084 17.58 19 12 19s-8.83-4.916-9.737-6.508a.992.992 0 010-.983C3.17 9.917 6.421 5 12 5zm0 2c-4.04 0-6.664 3.366-7.699 5 1.035 1.634 3.659 5 7.7 5 4.04 0 6.663-3.366 7.698-5C18.664 10.366 16.04 7 12 7zm0 2.001c1.655 0 3 1.345 3 3 0 1.653-1.345 3-3 3z" fill-rule="evenodd"/></svg>',
    eyeClosed: '<svg height="24" width="24"><path d="M19.71 3.16c.2-.2.51-.2.71 0l.71.71c.2.2.2.51 0 .71L4.35 21.37c-.2.2-.51.2-.71 0l-.71-.71c-.2-.2-.2-.51 0-.71l3.09-3.09c-1.99-1.54-3.25-3.47-3.76-4.37-.17-.3-.17-.67 0-.98C3.17 9.92 6.42 5 12 5c1.79 0 3.33.51 4.63 1.24zm.05 5.62a16.42 16.42 0 011.98 2.73c.17.3.17.68 0 .98C20.83 14.08 17.58 19 12 19c-.78 0-1.51-.1-2.19-.27l1.75-1.75c.14.01.29.02.44.02 4.04 0 6.67-3.37 7.7-5-.31-.49-.77-1.14-1.36-1.8zM12 7c-4.04 0-6.67 3.37-7.7 5 .57.9 1.64 2.33 3.15 3.43l2.32-2.32c-.17-.33-.27-.71-.27-1.11A2.5 2.5 0 0112 9.5c.4 0 .78.1 1.11.27l2.04-2.04C14.22 7.29 13.17 7 12 7z" fill-rule="evenodd"/></svg>',
    eyeOpen: '<svg height="24" width="24"><path d="M12 5c5.58 0 8.83 4.92 9.74 6.51.17.3.17.67 0 .98C20.83 14.08 17.58 19 12 19s-8.83-4.92-9.74-6.51c-.17-.3-.17-.67 0-.98C3.17 9.92 6.42 5 12 5zm0 2c-4.04 0-6.66 3.37-7.7 5 1.04 1.63 3.66 5 7.7 5s6.67-3.37 7.7-5c-1.04-1.63-3.66-5-7.7-5zm0 2.5a2.5 2.5 0 010 5 2.5 2.5 0 010-5z" fill-rule="evenodd"/></svg>',
    voiceover: '<svg height="24" width="24"><path d="M6.002 13.499c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5m12 0c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5m0-6.5a5 5 0 00-5 5c0 1.127.378 2.164 1.007 3H9.995a4.971 4.971 0 001.007-3 5 5 0 10-5 5h12a5 5 0 000-10" fill-rule="evenodd"/></svg>',
    voiceoverOutline: '<svg height="24" width="24"><path d="M18 7a5 5 0 110 10H6a5 5 0 115-5 4.971 4.971 0 01-1.007 3h4.014A4.971 4.971 0 0113 12a5 5 0 015-5zM6 9c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zm12 0c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zM6 10.75a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm12 0a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5z" fill-rule="evenodd"/></svg>',
    borderRadius: '<svg height="24" width="24"><path d="M17 3.5v.94c-4.69.8-9.05 4.29-11.25 8.65V7.37c1.1-.35 1.87-1.42 1.73-2.66a2.517 2.517 0 00-2.19-2.2A2.51 2.51 0 002.5 5c0 1.12.74 2.05 1.75 2.37V17H3.5c-.28 0-.5.22-.5.5v3c0 .28.22.5.5.5h3c.28 0 .5-.22.5-.5v-3c0-.28-.22-.5-.5-.5h-.53C7 11.81 11.81 7 17 5.97v.53c0 .28.22.5.5.5h3c.28 0 .5-.22.5-.5v-3c0-.28-.22-.5-.5-.5h-3c-.28 0-.5.22-.5.5z" fill-rule="evenodd"/></svg>',
    borderRadiusEndEnd: '<svg width="24" height="24"><path fill-rule="evenodd" d="M17.236 12.639l-.055.081-.146.21c-.124.178-.253.353-.384.525l-.324.409c-2.38 2.923-5.758 5.09-9.327 5.698v.94c0 .28-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v.53c1.734-.344 3.426-1.11 4.949-2.172 3.033-2.117 5.395-5.404 6.081-8.86h-.53c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5h-.94c-.305 1.785-.999 3.522-1.983 5.11l-.34.529z"/></svg>',
    borderRadiusEndStart: '<svg width="24" height="24"><path fill-rule="evenodd" d="M6.764 11.363l.055-.081.146-.21c.124-.178.253-.353.384-.525l.324-.409c2.38-2.923 5.758-5.09 9.327-5.698V3.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5v-.53c-1.734.344-3.426 1.11-4.949 2.172-3.033 2.117-5.395 5.404-6.081 8.86h.53c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5h.94c.305-1.785.999-3.522 1.983-5.11l.34-.529z"/></svg>',
    borderRadiusStartEnd: '<svg width="24" height="24"><path fill-rule="evenodd" d="M12.638 6.765l.081.055.21.146c.178.124.353.253.525.384l.409.324c2.923 2.38 5.09 5.758 5.698 9.327h.94c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5h.53c-.344-1.734-1.11-3.426-2.172-4.949-2.117-3.033-5.404-5.395-8.86-6.081v.53c0 .28-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v.94c1.785.305 3.522.999 5.11 1.983l.529.34z"/></svg>',
    borderRadiusStartStart: '<svg width="24" height="24"><path fill-rule="evenodd" d="M11.362 17.237l-.081-.055-.21-.146a16.777 16.777 0 01-.525-.384l-.409-.324C7.214 13.948 5.047 10.57 4.439 7h-.94c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5h-.53c.344 1.734 1.11 3.426 2.172 4.949 2.117 3.033 5.404 5.395 8.86 6.081v-.53c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5v-.94c-1.785-.305-3.522-.999-5.11-1.983l-.529-.34z"/></svg>',
    borderWidth: '<svg height="24" width="24"><path d="M20.5 3a.5.5 0 01.5.5v17a.5.5 0 01-.41.492L20.5 21a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5zm-3.668 0a.5.5 0 01.5.5v17a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5zm-4.667 0a.5.5 0 01.5.5v17a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5zM6.497 3a.5.5 0 01.5.5v17a.5.5 0 01-.5.5H3.503a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    dimensions: '<svg width="24" height="24"><path fill-rule="evenodd" d="M21.5 2a.5.5 0 01.5.5v19a.5.5 0 01-.5.5h-19a.5.5 0 01-.5-.5v-19a.5.5 0 01.5-.5h19zM20 4H4v16h16V4zm-9.166 2.5c.334 0 .501.404.265.64L9.827 8.412l5.76 5.761 1.273-1.272a.375.375 0 01.64.265V17a.5.5 0 01-.5.5h-3.834a.375.375 0 01-.265-.64l1.272-1.273-5.76-5.76-1.273 1.272a.375.375 0 01-.64-.265V7a.5.5 0 01.5-.5z"/></svg>',
    dimensionsAlt: '<svg width="24" height="24"><path fill-rule="evenodd" d="M16.86 12.901l-1.272 1.272-5.761-5.76 1.272-1.273a.375.375 0 00-.265-.64H7a.5.5 0 00-.5.5v3.834c0 .334.404.501.64.265l1.272-1.272 5.761 5.76-1.272 1.273a.375.375 0 00.265.64H17a.5.5 0 00.5-.5v-3.834a.375.375 0 00-.64-.265M18 2.501v1a.5.5 0 00.5.5H20v1.5a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5h-3a.5.5 0 00-.5.5M18 21.5v-1a.5.5 0 01.5-.5H20v-1.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5M20.5 10h1a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5m-18 0h1a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5M6 2.5v1a.5.5 0 01-.5.5H4v1.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5h3a.5.5 0 01.5.5m0 19v-1a.5.5 0 00-.5-.5H4v-1.5a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5v3a.5.5 0 00.5.5h3a.5.5 0 00.5-.5m8-19v1a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h3a.5.5 0 01.5.5m0 18v1a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h3a.5.5 0 01.5.5"/></svg>',
    dimensionsAltColored: '<svg width="24" height="24"><g fill-rule="evenodd"><path d="M16.86 12.9l-1.272 1.273-5.761-5.76 1.272-1.273a.375.375 0 00-.265-.64H7a.5.5 0 00-.5.5v3.833c0 .334.404.502.64.266l1.272-1.273 5.761 5.761-1.272 1.272a.375.375 0 00.265.64H17a.5.5 0 00.5-.5v-3.833a.375.375 0 00-.64-.265"/><path d="M18 2.5v1a.5.5 0 00.5.5H20v1.5a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5h-3a.5.5 0 00-.5.5m0 19v-1a.5.5 0 01.5-.5H20v-1.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5M20.5 10h1a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5m-18 0h1a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5M6 2.5v1a.5.5 0 01-.5.5H4v1.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5h3a.5.5 0 01.5.5m0 19v-1a.5.5 0 00-.5-.5H4v-1.5a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5v3a.5.5 0 00.5.5h3a.5.5 0 00.5-.5m8-19v1a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h3a.5.5 0 01.5.5m0 18v1a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h3a.5.5 0 01.5.5" opacity=".35"/></g></svg>',
    dimensionsColored: '<svg width="24" height="24"><g fill-rule="evenodd"><path d="M4 20h16V4H4v16zm17.5 2h-19a.5.5 0 01-.5-.5v-19a.5.5 0 01.5-.5h19a.5.5 0 01.5.5v19a.5.5 0 01-.5.5z" opacity=".35"/><path d="M16.86 12.9l-1.273 1.273-5.76-5.76 1.272-1.273a.375.375 0 00-.265-.64H7a.5.5 0 00-.5.5v3.834c0 .334.404.501.64.265l1.272-1.272 5.761 5.76-1.272 1.273a.375.375 0 00.265.64H17a.5.5 0 00.5-.5v-3.834a.375.375 0 00-.64-.265"/></g></svg>',
    gap: '<svg width="24" height="24"><g fill-rule="evenodd"><path d="M18.851 11.646l-2.711-2.71a.375.375 0 00-.64.265V11h-7V9.2a.375.375 0 00-.64-.265l-2.711 2.711a.5.5 0 000 .708l2.71 2.71c.237.237.641.07.641-.265V13h7v1.8c0 .333.404.5.64.264l2.711-2.71a.5.5 0 000-.708"/><path d="M21.5 18h-1a.5.5 0 01-.5-.5v-11a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v11a.5.5 0 01-.5.5m-18 0h-1a.5.5 0 01-.5-.5v-11a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v11a.5.5 0 01-.5.5" opacity=".35"/></g></svg>',
    gapVertical: '<svg width="24" height="24"><g fill-rule="evenodd"><path d="M14.8 15.5H13v-7h1.8a.375.375 0 00.265-.64l-2.711-2.711a.5.5 0 00-.707 0l-2.711 2.71A.375.375 0 009.2 8.5H11v7H9.2a.375.375 0 00-.265.64l2.71 2.711a.5.5 0 00.708 0l2.71-2.71a.375.375 0 00-.265-.641"/><path d="M17.5 4h-11a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h11a.5.5 0 01.5.5v1a.5.5 0 01-.5.5m0 18h-11a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h11a.5.5 0 01.5.5v1a.5.5 0 01-.5.5" opacity=".35"/></g></svg>',
    height: '<svg width="24" height="24"><path fill-rule="evenodd" d="M14.8 15.5H13v-7h1.8a.375.375 0 00.264-.64l-2.71-2.711a.5.5 0 00-.708 0l-2.71 2.71A.375.375 0 009.2 8.5H11v7H9.2a.375.375 0 00-.265.64l2.711 2.711a.5.5 0 00.707 0l2.711-2.71a.375.375 0 00-.265-.641M17.5 4h-11a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h11a.5.5 0 01.5.5v1a.5.5 0 01-.5.5m0 18h-11a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h11a.5.5 0 01.5.5v1a.5.5 0 01-.5.5"/></svg>',
    heightColored: '<svg width="24" height="24"><g fill-rule="evenodd"><path d="M14.8 15.5H13v-7h1.8a.375.375 0 00.265-.64l-2.711-2.711a.5.5 0 00-.707 0l-2.711 2.71A.375.375 0 009.2 8.5H11v7H9.2a.375.375 0 00-.265.64l2.71 2.711a.5.5 0 00.708 0l2.71-2.71a.375.375 0 00-.265-.641" opacity=".35"/><path d="M17.5 4h-11a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h11a.5.5 0 01.5.5v1a.5.5 0 01-.5.5m0 18h-11a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h11a.5.5 0 01.5.5v1a.5.5 0 01-.5.5"/></g></svg>',
    margin: '<svg width="24" height="24"><g fill-rule="evenodd"><path d="M11 21h-1a.5.5 0 01-.5-.5V10a.5.5 0 01.5-.5h10.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-9v9a.5.5 0 01-.5.5"/><path d="M4.5 21h-1a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5h17a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H5v15.5a.5.5 0 01-.5.5" opacity=".35"/></g></svg>',
    marginAlt: '<svg width="24" height="24"><path fill-rule="evenodd" d="M8.824 7.423l-2.55-2.458L7.599 3.64A.375.375 0 007.334 3H3.5a.5.5 0 00-.5.5v3.834c0 .334.404.501.64.265L4.86 6.38l2.577 2.483a.5.5 0 00.707-.013l.693-.72a.5.5 0 00-.013-.707M11 21h-1a.5.5 0 01-.5-.5V10a.5.5 0 01.5-.5h10.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-9v9a.5.5 0 01-.5.5"/></svg>',
    marginColored: '<svg width="24" height="24"><g fill-rule="evenodd"><path d="M8.824 7.423l-2.55-2.458L7.599 3.64A.375.375 0 007.334 3H3.5a.5.5 0 00-.5.5v3.834c0 .334.404.501.64.265l1.22-1.22 2.576 2.484a.5.5 0 00.707-.013l.694-.72a.5.5 0 00-.013-.707"/><path d="M11 21h-1a.5.5 0 01-.5-.5V10a.5.5 0 01.5-.5h10.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-9v9a.5.5 0 01-.5.5" opacity=".35"/></g></svg>',
    padding: '<svg width="24" height="24"><g fill-rule="evenodd"><path d="M11 21h-1a.5.5 0 01-.5-.5V10a.5.5 0 01.5-.5h10.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-9v9a.5.5 0 01-.5.5" opacity=".35"/><path d="M4.5 21h-1a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5h17a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H5v15.5a.5.5 0 01-.5.5"/></g></svg>',
    paddingAlt: '<svg width="24" height="24"><path fill-rule="evenodd" d="M20.5 3a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H5v15.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5h17zM7.847 7.14a.5.5 0 01.707-.013l2.577 2.484 1.22-1.22a.375.375 0 01.64.266v3.833a.5.5 0 01-.5.5H8.657a.375.375 0 01-.265-.64l1.325-1.325-2.55-2.458a.5.5 0 01-.014-.707z"/></svg>',
    paddingBlockEnd: '<svg width="24" height="24"><g fill-rule="evenodd"><path d="M16.5 17h-9a.5.5 0 01-.5-.5v-4a.5.5 0 01.5-.5h9a.5.5 0 01.5.5v4a.5.5 0 01-.5.5"/><path d="M5 19h14V5H5v14zm15.5 2h-17a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5h17a.5.5 0 01.5.5v17a.5.5 0 01-.5.5z" opacity=".5"/></g></svg>',
    paddingBlockStart: '<svg width="24" height="24"><g fill-rule="evenodd"><path d="M16.5 12h-9a.5.5 0 01-.5-.5v-4a.5.5 0 01.5-.5h9a.5.5 0 01.5.5v4a.5.5 0 01-.5.5"/><path d="M5 19h14V5H5v14zm15.5 2h-17a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5h17a.5.5 0 01.5.5v17a.5.5 0 01-.5.5z" opacity=".5"/></g></svg>',
    paddingBottom: '<svg height="24" width="24"><path d="M3.002 3.5a.5.5 0 01.41-.492L3.503 3h17a.5.5 0 01.492.41l.008.09v17a.5.5 0 01-.41.492l-.09.008h-17a.5.5 0 01-.492-.41l-.008-.09zm2 2.502v7a1 1 0 00.884.993l.116.007h12a1 1 0 00.994-.883l.006-.117v-7a1 1 0 00-.883-.993l-.117-.007h-12a1 1 0 00-.993.884z" fill-rule="evenodd"/></svg>',
    paddingColored: '<svg width="24" height="24"><g fill-rule="evenodd"><path d="M12.35 8.391l-1.219 1.22-2.577-2.484a.5.5 0 00-.707.013l-.694.72a.5.5 0 00.013.707l2.55 2.458-1.325 1.325a.375.375 0 00.265.64h3.834a.5.5 0 00.5-.5V8.657a.375.375 0 00-.64-.266"/><path d="M4.5 21h-1a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5h17a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H5v15.5a.5.5 0 01-.5.5" opacity=".35"/></g></svg>',
    paddingInlineEnd: '<svg width="24" height="24"><g fill-rule="evenodd"><path d="M12 16.5v-9a.5.5 0 01.5-.5h4a.5.5 0 01.5.5v9a.5.5 0 01-.5.5h-4a.5.5 0 01-.5-.5"/><path d="M5 19h14V5H5v14zm15.5 2h-17a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5h17a.5.5 0 01.5.5v17a.5.5 0 01-.5.5z" opacity=".5"/></g></svg>',
    paddingInlineStart: '<svg width="24" height="24"><g fill-rule="evenodd"><path d="M12 7.5v9a.5.5 0 01-.5.5h-4a.5.5 0 01-.5-.5v-9a.5.5 0 01.5-.5h4a.5.5 0 01.5.5"/><path d="M5 19h14V5H5v14zm15.5 2h-17a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5h17a.5.5 0 01.5.5v17a.5.5 0 01-.5.5z" opacity=".5"/></g></svg>',
    paddingLeft: '<svg height="24" width="24"><path d="M20.502 3a.5.5 0 01.5.5v17a.5.5 0 01-.5.5h-17a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5zM18 5h-7a1 1 0 00-1 1v12a1 1 0 001 1h7a1 1 0 001-1V6a1 1 0 00-1-1z" fill-rule="evenodd"/></svg>',
    paddingRight: '<svg height="24" width="24"><path d="M3.502 21a.5.5 0 01-.492-.41l-.008-.09v-17a.5.5 0 01.41-.492L3.503 3h17a.5.5 0 01.492.41l.008.09v17a.5.5 0 01-.41.492l-.09.008zm2.503-2h7a1 1 0 00.993-.884l.007-.116V6a1 1 0 00-.884-.993L13.005 5h-7a1 1 0 00-.994.883L5.005 6v12a1 1 0 00.883.993z" fill-rule="evenodd"/></svg>',
    paddingTop: '<svg height="24" width="24"><path d="M21.002 20.5a.5.5 0 01-.41.492l-.09.008h-17a.5.5 0 01-.492-.41l-.008-.09v-17a.5.5 0 01.41-.492L3.502 3h17a.5.5 0 01.492.41l.008.09zm-2-2.502v-7a1 1 0 00-.883-.994l-.117-.006h-12a1 1 0 00-.993.883l-.007.117v7a1 1 0 00.884.993l.116.007h12a1 1 0 00.993-.884z" fill-rule="evenodd"/></svg>',
    proportion: '<svg width="24" height="24"><path fill-rule="evenodd" d="M21.5 2a.5.5 0 01.5.5v19a.5.5 0 01-.5.5h-19a.5.5 0 01-.5-.5v-19a.5.5 0 01.5-.5h19zM20 4H4v16h16V4zM7.14 12.901l3.96 3.959a.375.375 0 01-.266.64H7a.5.5 0 01-.5-.5v-3.834c0-.334.404-.501.64-.265zM17 6.5a.5.5 0 01.5.5v3.834a.375.375 0 01-.64.265L12.9 7.14a.375.375 0 01.265-.64z"/></svg>',
    proportionAlt: '<svg width="24" height="24"><path fill-rule="evenodd" d="M21.5 2a.5.5 0 01.5.5v19a.5.5 0 01-.5.5h-19a.5.5 0 01-.5-.5v-19a.5.5 0 01.5-.5h19zM20 4H4v16h16V4zM7.5 13a.5.5 0 01.5.5V16h2.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-4a.5.5 0 01-.5-.5v-4a.5.5 0 01.5-.5h1zm10-7a.5.5 0 01.5.5v4a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V8h-2.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h4z"/></svg>',
    proportionAltColored: '<svg width="24" height="24"><g fill-rule="evenodd"><path d="M7.14 12.9a.375.375 0 00-.64.266V17a.5.5 0 00.5.5h3.834a.375.375 0 00.265-.64L7.14 12.9zm9.72-1.801c.236.236.64.069.64-.265V7a.5.5 0 00-.5-.5h-3.834a.375.375 0 00-.265.64L16.86 11.1z"/><path d="M4 20h16V4H4v16zm17.5 2h-19a.5.5 0 01-.5-.5v-19a.5.5 0 01.5-.5h19a.5.5 0 01.5.5v19a.5.5 0 01-.5.5z" opacity=".5"/></g></svg>',
    proportionColored: '<svg width="24" height="24"><g fill-rule="evenodd"><path d="M17.5 11h-1a.5.5 0 01-.5-.5V8h-2.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h4a.5.5 0 01.5.5v4a.5.5 0 01-.5.5m-7 7h-4a.5.5 0 01-.5-.5v-4a.5.5 0 01.5-.5h1a.5.5 0 01.5.5V16h2.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5"/><path d="M4 20h16V4H4v16zm17.5 2h-19a.5.5 0 01-.5-.5v-19a.5.5 0 01.5-.5h19a.5.5 0 01.5.5v19a.5.5 0 01-.5.5z" opacity=".5"/></g></svg>',
    round: '<svg height="24" width="24"><path d="M17 3.5v.94c-4.69.8-9.05 4.29-11.25 8.65V7.37c1.1-.35 1.87-1.42 1.73-2.66a2.517 2.517 0 00-2.19-2.2A2.51 2.51 0 002.5 5c0 1.12.74 2.05 1.75 2.37V17H3.5c-.28 0-.5.22-.5.5v3c0 .28.22.5.5.5h3c.28 0 .5-.22.5-.5v-3c0-.28-.22-.5-.5-.5h-.53C7 11.81 11.81 7 17 5.97v.53c0 .28.22.5.5.5h3c.28 0 .5-.22.5-.5v-3c0-.28-.22-.5-.5-.5h-3c-.28 0-.5.22-.5.5z" fill-rule="evenodd"/></svg>',
    roundEndEnd: '<svg width="24" height="24"><path fill-rule="evenodd" d="M17.236 12.639l-.055.081-.146.21c-.124.178-.253.353-.384.525l-.324.409c-2.38 2.923-5.758 5.09-9.327 5.698v.94c0 .28-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v.53c1.734-.344 3.426-1.11 4.949-2.172 3.033-2.117 5.395-5.404 6.081-8.86h-.53c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5h-.94c-.305 1.785-.999 3.522-1.983 5.11l-.34.529z"/></svg>',
    roundEndStart: '<svg width="24" height="24"><path fill-rule="evenodd" d="M6.764 11.363l.055-.081.146-.21c.124-.178.253-.353.384-.525l.324-.409c2.38-2.923 5.758-5.09 9.327-5.698V3.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5v-.53c-1.734.344-3.426 1.11-4.949 2.172-3.033 2.117-5.395 5.404-6.081 8.86h.53c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5h.94c.305-1.785.999-3.522 1.983-5.11l.34-.529z"/></svg>',
    roundStartEnd: '<svg width="24" height="24"><path fill-rule="evenodd" d="M12.638 6.765l.081.055.21.146c.178.124.353.253.525.384l.409.324c2.923 2.38 5.09 5.758 5.698 9.327h.94c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5h.53c-.344-1.734-1.11-3.426-2.172-4.949-2.117-3.033-5.404-5.395-8.86-6.081v.53c0 .28-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v.94c1.785.305 3.522.999 5.11 1.983l.529.34z"/></svg>',
    roundStartStart: '<svg width="24" height="24"><path fill-rule="evenodd" d="M11.362 17.237l-.081-.055-.21-.146a16.777 16.777 0 01-.525-.384l-.409-.324C7.214 13.948 5.047 10.57 4.439 7h-.94c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5h-.53c.344 1.734 1.11 3.426 2.172 4.949 2.117 3.033 5.404 5.395 8.86 6.081v-.53c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5v-.94c-1.785-.305-3.522-.999-5.11-1.983l-.529-.34z"/></svg>',
    sequence: '<svg width="24" height="24"><defs><clipPath id="a"><path d="M19.2 12v2.4H0V12h19.2zM9.81 8v2.4H.01V8h9.8zM5.222 4v2.4H.011V4h5.21zm-3-4v2.4H.011V0h2.21z"/></clipPath></defs><g clip-path="url(#a)" transform="translate(2.4 4.8)"><path d="M0 0h19.2v14.4H0V0z"/></g></svg>',
    sequenceAlt: '<svg width="24" height="24"><defs><clipPath id="a"><path d="M19.2 4v2.4H0V4h19.2zM8.421 0v2.4h-5.21V0h5.21zm-6.21 0v2.4H0V0h2.21zm17.01 0v2.4h-9.8V0h9.8z"/></clipPath></defs><g clip-path="url(#a)" transform="translate(2.39 8.8)"><path d="M0 0h19.221v6.4H0V0z"/></g></svg>',
    sequenceColored: '<svg width="24" height="24"><defs><clipPath id="a"><path d="M5.21 0v2H0V0h5.21z"/></clipPath><clipPath id="b"><path d="M2.21 0v2H0V0h2.21z"/></clipPath><clipPath id="c"><path d="M9.8 0v2H0V0h9.8z"/></clipPath><clipPath id="d"><path d="M19.2 0v2H0V0h19.2z"/></clipPath></defs><g clip-path="url(#a)" transform="translate(2.41 8.8)"><path opacity="85%" d="M0 0h5.211v2H0V0z"/></g><g clip-path="url(#b)" transform="translate(2.41 4.8)"><path d="M0 0h2.211v2H0V0z"/></g><g clip-path="url(#c)" transform="translate(2.41 12.8)"><path opacity="70%" d="M0 0h9.8v2H0V0z"/></g><g clip-path="url(#d)" transform="translate(2.4 16.8)"><path opacity="55%" d="M0 0h19.2v2H0V0z"/></g></svg>',
    space: '<svg height="24" width="24"><path d="M13.29 5.25C6.88 5.25 2 10.05 1.76 16.5c-.01.27.2.5.47.5h1.53c.27 0 .49-.21.5-.47.22-5.04 4.03-8.78 9.03-8.78 3.68 0 6.46 2.3 6.46 5.34 0 1.8-1.29 3.15-3.01 3.16-.88 0-1.49-.52-1.49-1.25 0-.3.24-.75.75-.75h.21c.19 0 .35-.16.35-.35v-1.77a.38.38 0 00-.38-.38h-.11c-1.82 0-3.35 1.49-3.32 3.31.03 2.09 1.71 3.67 3.94 3.69h.08c3.08-.03 5.48-2.5 5.48-5.66 0-4.4-3.93-7.84-8.96-7.84z" fill-rule="evenodd"/></svg>',
    spaceOutline: '<svg height="24" width="24"><path d="M16.75 18.9h-.05c-2.06-.02-3.6-1.48-3.6-3.4 0-1.28 1-2.65 2.62-2.79.15-.01.28.1.28.25v1.21c0 .17-.11.32-.28.36-.56.13-.82.62-.82.97 0 .93.77 1.6 1.84 1.6 1.92-.01 3.36-1.51 3.36-3.51 0-3.25-2.93-5.69-6.81-5.69-5.23 0-9.21 3.94-9.39 9.23-.01.2-.17.37-.37.37H2.46c-.2 0-.36-.16-.35-.36C2.28 10.82 7.03 6.1 13.29 6.1c4.83 0 8.61 3.29 8.61 7.49 0 2.96-2.25 5.28-5.13 5.31h-.02z" fill-rule="evenodd"/></svg>',
    width: '<svg width="24" height="24"><path fill-rule="evenodd" d="M21.5 6a.5.5 0 01.5.5v11a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-11a.5.5 0 01.5-.5h1zm-18 0a.5.5 0 01.5.5v11a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-11a.5.5 0 01.5-.5h1zm12 3.2c0-.308.344-.474.583-.312l.057.047 2.711 2.711a.5.5 0 01.058.638l-.058.07-2.71 2.71a.375.375 0 01-.634-.19l-.007-.075V13h-7v1.8a.375.375 0 01-.583.312l-.057-.048-2.711-2.71a.5.5 0 01-.058-.638l.058-.07 2.71-2.71a.375.375 0 01.634.19l.007.075V11h7V9.2z"/></svg>',
    widthColored: '<svg width="24" height="24"><g fill-rule="evenodd"><path d="M18.851 11.646l-2.711-2.71a.375.375 0 00-.64.265V11h-7V9.2a.375.375 0 00-.64-.265l-2.711 2.711a.5.5 0 000 .708l2.71 2.71c.237.237.641.07.641-.265V13h7v1.8c0 .333.404.5.64.264l2.711-2.71a.5.5 0 000-.708" opacity=".35"/><path d="M21.5 18h-1a.5.5 0 01-.5-.5v-11a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v11a.5.5 0 01-.5.5m-18 0h-1a.5.5 0 01-.5-.5v-11a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v11a.5.5 0 01-.5.5"/></g></svg>',
    brightness: '<svg height="24" width="24"><path d="M12.44 20a.5.5 0 01.5.5V22a.5.5 0 01-.5.5h-1.5a.5.5 0 01-.5-.5v-1.5a.5.5 0 01.5-.5zm6.277-2.954l.962.962a.5.5 0 010 .707l-.962.961a.5.5 0 01-.707 0l-.961-.961a.5.5 0 010-.707l.961-.962a.5.5 0 01.707 0zm-12.732 0l.962.962a.5.5 0 010 .707l-.962.961a.5.5 0 01-.707 0l-.961-.961a.5.5 0 010-.707l.961-.962a.5.5 0 01.707 0zm6.013-11.044A6.006 6.006 0 0118 12a6.005 6.005 0 01-5.998 5.998c-3.31-.004-5.998-2.695-5.998-5.998a6.008 6.008 0 015.994-5.998zm0 2.5A3.504 3.504 0 008.505 12a3.504 3.504 0 003.495 3.498zm10.007 2.247a.5.5 0 01.5.5v1.504a.5.5 0 01-.5.5H20.5a.5.5 0 01-.5-.5V11.25a.5.5 0 01.5-.5zm-18.505 0a.5.5 0 01.5.5v1.504a.5.5 0 01-.5.5H1.995a.5.5 0 01-.5-.5V11.25a.5.5 0 01.5-.5zm15.217-6.427l.962.961a.5.5 0 010 .707l-.962.962a.5.5 0 01-.707 0l-.961-.962a.5.5 0 010-.707l.961-.961a.5.5 0 01.707 0zm-12.726 0l.961.961a.5.5 0 010 .707l-.961.962a.5.5 0 01-.707 0l-.962-.962a.5.5 0 010-.707l.962-.961a.5.5 0 01.707 0zM12.75 1.5a.5.5 0 01.5.5v1.5a.5.5 0 01-.5.5h-1.5a.5.5 0 01-.5-.5V2a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    columns: '<svg width="24" height="24"><path fill-rule="evenodd" d="M16 19.5v-15a.5.5 0 01.5-.5h3a.5.5 0 01.5.5v15a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5zm-6 0v-15a.5.5 0 01.5-.5h3a.5.5 0 01.5.5v15a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5zm-6 0v-15a.5.5 0 01.5-.5h3a.5.5 0 01.5.5v15a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5z"/></svg>',
    columnsAlt: '<svg width="24" height="24"><path fill-rule="evenodd" d="M13 19.5v-15a.5.5 0 01.5-.5h6a.5.5 0 01.5.5v15a.5.5 0 01-.5.5h-6a.5.5 0 01-.5-.5zm-9 0v-15a.5.5 0 01.5-.5h6a.5.5 0 01.5.5v15a.5.5 0 01-.5.5h-6a.5.5 0 01-.5-.5z"/></svg>',
    columnsAltOutline: '<svg width="24" height="24"><path fill-rule="evenodd" d="M13 5v14h6V5h-6zM5 5v14h6V5H5zm16 15.5v-17a.5.5 0 00-.5-.5h-17a.5.5 0 00-.5.5v17a.5.5 0 00.5.5h17a.5.5 0 00.492-.41L21 20.5z"/></svg>',
    columnsOutline: '<svg width="24" height="24"><path fill-rule="evenodd" d="M4.5 4.5v15h4v-15h-4zm5.5 0v15h4v-15h-4zm5.5 0v15h4v-15h-4zm5.5 16v-17a.5.5 0 00-.5-.5h-17a.5.5 0 00-.5.5v17a.5.5 0 00.5.5h17a.5.5 0 00.492-.41L21 20.5z"/></svg>',
    deviceBigScreen: '<svg height="24" width="24"><path d="M22 16.5v-13a.5.5 0 00-.5-.5h-19a.5.5 0 00-.5.5v13a.5.5 0 00.5.5H11v2H8.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h7a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5H13v-2h8.5a.5.5 0 00.5-.5" fill-rule="evenodd"/></svg>',
    deviceBigScreenHalfFill: '<svg height="24" width="24"><path d="M4 13h16V5H4zm18 3.5v-13a.5.5 0 00-.5-.5h-19a.5.5 0 00-.5.5v13a.5.5 0 00.5.5H11v2H8.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h7a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5H13v-2h8.5a.5.5 0 00.5-.5z" fill-rule="evenodd"/></svg>',
    deviceBigScreenOutline: '<svg height="24" width="24"><path d="M4 15h16V5H4zm18 1.5v-13a.5.5 0 00-.5-.5h-19a.5.5 0 00-.5.5v13a.5.5 0 00.5.5H11v2H8.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h7a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5H13v-2h8.5a.5.5 0 00.5-.5z" fill-rule="evenodd"/></svg>',
    deviceMobile: '<svg height="24" width="24"><path d="M12 19.25a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5M18 2H6a.5.5 0 00-.5.5v19a.5.5 0 00.5.5h12a.5.5 0 00.5-.5v-19A.5.5 0 0018 2" fill-rule="evenodd"/></svg>',
    deviceMobileHalfFill: '<svg height="24" width="24"><path d="M7.5 18h9V4h-9zm4.5 3.25a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zM18 2H6a.5.5 0 00-.5.5v19a.5.5 0 00.5.5h12a.5.5 0 00.5-.5v-19A.5.5 0 0018 2z" fill-rule="evenodd"/></svg>',
    deviceMobileOutline: '<svg height="24" width="24"><path d="M18 2a.5.5 0 01.5.5v19a.5.5 0 01-.5.5H6a.5.5 0 01-.5-.5v-19A.5.5 0 016 2zm-1.5 2h-9v16h9zM12 15.75a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5z" fill-rule="evenodd"/></svg>',
    deviceSmallScreen: '<svg height="24" width="24"><path d="M22 18a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H2a.5.5 0 01-.5-.5v-1A.5.5 0 012 18zM20.5 4a.5.5 0 01.5.5v11a.5.5 0 01-.5.5h-17a.5.5 0 01-.5-.5v-11a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    deviceSmallScreenHalfFill: '<svg height="24" width="24"><path d="M5 15h14V6H5zm4 3h6v-1.5H9zm13 0h-1V4.5a.5.5 0 00-.5-.5h-17a.5.5 0 00-.5.5V18H2a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h20a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5z" fill-rule="evenodd"/></svg>',
    deviceSmallScreenOutline: '<svg height="24" width="24"><path d="M22 18a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H2a.5.5 0 01-.5-.5v-1A.5.5 0 012 18zM20.5 4a.5.5 0 01.5.5v11a.5.5 0 01-.5.5h-17a.5.5 0 01-.5-.5v-11a.5.5 0 01.5-.5zM19 6H5v8h14z" fill-rule="evenodd"/></svg>',
    deviceTabletLandscape: '<svg height="24" width="24"><path d="M6 13.25a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5M21.5 4h-19a.5.5 0 00-.5.5v15a.5.5 0 00.5.5h19a.5.5 0 00.5-.5v-15a.5.5 0 00-.5-.5" fill-rule="evenodd"/></svg>',
    deviceTabletLandscapeHalfFill: '<svg height="24" width="24"><path d="M6 18h14V6H6zm-2-4.75a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zM21.5 4h-19a.5.5 0 00-.5.5v15a.5.5 0 00.5.5h19a.5.5 0 00.5-.5v-15a.5.5 0 00-.5-.5z" fill-rule="evenodd"/></svg>',
    deviceTabletLandscapeOutline: '<svg height="24" width="24"><path d="M21.5 4a.5.5 0 01.5.5v15a.5.5 0 01-.5.5h-19a.5.5 0 01-.5-.5v-15a.5.5 0 01.5-.5zM20 6H4v12h16zM7 10.75a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5z" fill-rule="evenodd"/></svg>',
    deviceTabletPortrait: '<svg height="24" width="24"><path d="M12 19.25a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5M19.5 2h-15a.5.5 0 00-.5.5v19a.5.5 0 00.5.5h15a.5.5 0 00.5-.5v-19a.5.5 0 00-.5-.5" fill-rule="evenodd"/></svg>',
    deviceTabletPortraitHalfFill: '<svg height="24" width="24"><path d="M6 18h12V4H6zm6 3.25a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zM19.5 2h-15a.5.5 0 00-.5.5v19a.5.5 0 00.5.5h15a.5.5 0 00.5-.5v-19a.5.5 0 00-.5-.5z" fill-rule="evenodd"/></svg>',
    deviceTabletPortraitOutline: '<svg height="24" width="24"><path d="M19.5 2a.5.5 0 01.5.5v19a.5.5 0 01-.5.5h-15a.5.5 0 01-.5-.5v-19a.5.5 0 01.5-.5zM18 4H6v16h12zm-6 11.75a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5z" fill-rule="evenodd"/></svg>',
    displayPreferences: '<svg height="24" width="24"><path d="M11 4a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H4v12h16v-3a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v4.5a.5.5 0 01-.5.5h-19a.5.5 0 01-.5-.5v-15a.5.5 0 01.5-.5zm.506 4A6.5 6.5 0 0018 14.5v1a.5.5 0 01-.5.5h-11a.5.5 0 01-.5-.5v-7a.5.5 0 01.5-.5zm7.1-5a.5.5 0 01.487.382l.308 1.274c.284.12.547.276.79.46l1.262-.371a.5.5 0 01.574.23l.606 1.05a.5.5 0 01-.088.613l-.952.906c.019.15.032.301.032.456 0 .155-.013.306-.032.456l.952.907a.5.5 0 01.088.612l-.606 1.05a.5.5 0 01-.574.23l-1.263-.371c-.242.184-.505.34-.789.46l-.308 1.274a.5.5 0 01-.486.382h-1.214a.5.5 0 01-.486-.382l-.308-1.274a3.623 3.623 0 01-.79-.46l-1.262.371a.5.5 0 01-.574-.23l-.607-1.05a.5.5 0 01.088-.612l.953-.907A3.655 3.655 0 0114.375 8c0-.155.013-.306.032-.455l-.953-.907a.5.5 0 01-.088-.612l.607-1.051a.5.5 0 01.574-.23l1.262.371c.242-.184.506-.34.79-.46l.308-1.274A.5.5 0 0117.393 3zM18 5.75a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5z" fill-rule="evenodd"/></svg>',
    displayPreferencesOutline: '<svg height="24" width="24"><path d="M11 4a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H4v11.999h16v-3.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v5a.5.5 0 01-.5.5h-19a.5.5 0 01-.5-.5v-15a.5.5 0 01.5-.5zm7.607-1a.5.5 0 01.486.381l.308 1.274c.284.12.547.276.79.46l1.262-.371a.5.5 0 01.574.23l.606 1.05a.5.5 0 01-.088.613l-.952.906c.019.15.032.301.032.456 0 .155-.013.306-.032.456l.952.907a.5.5 0 01.088.612l-.606 1.05a.5.5 0 01-.574.23l-1.263-.371c-.242.184-.505.34-.79.46l-.307 1.274a.5.5 0 01-.486.382h-1.214a.5.5 0 01-.486-.382l-.308-1.274a3.623 3.623 0 01-.79-.46l-1.262.371a.5.5 0 01-.574-.23l-.607-1.05a.5.5 0 01.088-.612l.953-.907a3.6 3.6 0 01-.032-.456c0-.155.013-.306.031-.455l-.952-.907a.5.5 0 01-.088-.612l.607-1.051a.5.5 0 01.574-.23l1.263.372c.241-.185.505-.341.789-.46l.308-1.275A.5.5 0 0117.393 3zM18 5.75a2.25 2.25 0 100 4.499 2.25 2.25 0 000-4.5z" fill-rule="evenodd"/></svg>',
    grid: '<svg height="24" width="24"><path d="M7.5 16a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5zm6 0a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5zm6 0a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5zm-12-6a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5zm6 0a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5zm6 0a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5zm-12-6a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5zm6 0a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5zm6 0a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    gridAlt: '<svg height="24" width="24"><path d="M19.5 13a.5.5 0 01.5.5v6a.5.5 0 01-.5.5h-6a.5.5 0 01-.5-.5v-6a.5.5 0 01.5-.5zm-9 0a.5.5 0 01.5.5v6a.5.5 0 01-.5.5h-6a.5.5 0 01-.5-.5v-6a.5.5 0 01.5-.5zm9-9a.5.5 0 01.5.5v6a.5.5 0 01-.5.5h-6a.5.5 0 01-.5-.5v-6a.5.5 0 01.5-.5zm-9 0a.5.5 0 01.5.5v6a.5.5 0 01-.5.5h-6a.5.5 0 01-.5-.5v-6a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    gridAltOutline: '<svg height="24" width="24"><path d="M13 11h6V5h-6zm0 8h6v-6h-6zm-8 0h6v-6H5zm0-8h6V5H5zm15.5-8h-17a.5.5 0 00-.5.5v17a.5.5 0 00.5.5h17a.5.5 0 00.5-.5v-17a.5.5 0 00-.5-.5z" fill-rule="evenodd"/></svg>',
    gridOutline: '<svg height="24" width="24"><path d="M15.5 19.5h4v-4h-4zm-11 0h4v-4h-4zm0-11h4v-4h-4zm11 5.5h4v-4h-4zM10 8.5h4v-4h-4zM4.5 14h4v-4h-4zm5.5 5.5h4v-4h-4zm0-5.5h4v-4h-4zm5.5-5.5h4v-4h-4zm5-5.5h-17a.5.5 0 00-.5.5v17a.5.5 0 00.5.5h17a.5.5 0 00.5-.5v-17a.5.5 0 00-.5-.5z" fill-rule="evenodd"/></svg>',
    layout: '<svg height="24" width="24"><path d="M12.5 15a.5.5 0 01.5.5v4a.5.5 0 01-.5.5h-10a.5.5 0 01-.5-.5v-4a.5.5 0 01.5-.5zm9-4a.5.5 0 01.5.5v8a.5.5 0 01-.5.5h-6a.5.5 0 01-.5-.5v-8a.5.5 0 01.5-.5zm-9-7a.5.5 0 01.5.5v8a.5.5 0 01-.5.5h-10a.5.5 0 01-.5-.5v-8a.5.5 0 01.5-.5zm9 0a.5.5 0 01.5.5v4a.5.5 0 01-.5.5h-6a.5.5 0 01-.5-.5v-4a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    layoutOutline: '<svg height="24" width="24"><path d="M15 19h6v-8h-6zM3 19h10v-4H3zm0-6h10V5H3zm12-4h6V5h-6zM1 3.5v17a.5.5 0 00.5.5h21a.5.5 0 00.5-.5v-17a.5.5 0 00-.5-.5h-21a.5.5 0 00-.5.5z" fill-rule="evenodd"/></svg>',
    list: '<svg height="24" width="24"><path d="M4.355 16.078l1.569 1.568a.5.5 0 010 .708l-1.57 1.568a.5.5 0 01-.706 0l-1.569-1.568a.5.5 0 010-.708l1.569-1.568a.5.5 0 01.707 0zM21.5 16.5a.5.5 0 01.5.5v2a.5.5 0 01-.5.5h-13A.5.5 0 018 19v-2a.5.5 0 01.5-.5zM4.355 10.078l1.569 1.568a.5.5 0 010 .708l-1.57 1.568a.5.5 0 01-.706 0l-1.569-1.568a.5.5 0 010-.708l1.569-1.568a.5.5 0 01.707 0zM21.5 10.5a.5.5 0 01.5.5v2a.5.5 0 01-.5.5h-13A.5.5 0 018 13v-2a.5.5 0 01.5-.5zM4.355 4.075l1.569 1.568a.5.5 0 010 .708l-1.57 1.568a.5.5 0 01-.706 0L2.079 6.351a.5.5 0 010-.708l1.569-1.568a.5.5 0 01.707 0zM21.5 4.5a.5.5 0 01.5.5v2a.5.5 0 01-.5.5h-13A.5.5 0 018 7V5a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    listOutline: '<svg height="24" width="24"><path d="M4.355 16.666l1.002 1.002a.5.5 0 010 .707l-1.002 1.003a.5.5 0 01-.707 0l-1.003-1.003a.5.5 0 010-.707l1.003-1.002a.5.5 0 01.707 0zM21.5 17a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-13a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zM4.355 10.653l1.002 1.003a.5.5 0 010 .707l-1.002 1.002a.5.5 0 01-.707 0l-1.003-1.002a.5.5 0 010-.707l1.003-1.003a.5.5 0 01.707 0zM21.5 11a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-13a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zM4.355 4.64l1.002 1.003a.5.5 0 010 .707L4.355 7.353a.5.5 0 01-.707 0L2.645 6.35a.5.5 0 010-.707l1.003-1.002a.5.5 0 01.707 0zM21.5 5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-13a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    moon: '<svg height="24" width="24"><path d="M8.875 3.568a.5.5 0 01.622.693 7.643 7.643 0 0010.242 10.243c.405-.202.852.191.696.616a8.994 8.994 0 01-15.221 2.781c-2.972-3.403-2.92-8.583.114-11.931a8.963 8.963 0 013.547-2.402zm7.822 1.556a.428.428 0 01.606 0l1.573 1.573a.427.427 0 010 .605l-1.573 1.574a.428.428 0 01-.606 0l-1.573-1.574a.428.428 0 010-.605z" fill-rule="evenodd"/></svg>',
    moonOutline: '<svg height="24" width="24"><path d="M9.053 3.535c.35 0 .617.376.444.726a7.644 7.644 0 0010.242 10.243.5.5 0 01.696.616 8.95 8.95 0 01-2.076 3.239A8.965 8.965 0 0112 20.993 8.972 8.972 0 015.214 17.9c-2.972-3.403-2.92-8.583.115-11.931a8.96 8.96 0 013.546-2.402.51.51 0 01.178-.033zM6.702 7.436c-2.23 2.586-2.233 6.572.018 9.15A7.012 7.012 0 0012 18.993a6.94 6.94 0 004.568-1.698 9.576 9.576 0 01-7.042-2.82 9.634 9.634 0 01-2.824-7.039zm9.996-2.312a.428.428 0 01.605 0l1.573 1.573a.427.427 0 010 .605l-1.573 1.574a.428.428 0 01-.605 0l-1.574-1.574a.428.428 0 010-.605z" fill-rule="evenodd"/></svg>',
    print: '<svg height="24" width="24"><path d="M17 16v5.5a.5.5 0 01-.5.5h-9a.5.5 0 01-.5-.5V16zm2-9a3 3 0 013 3v7.5a.5.5 0 01-.5.5H19v-4H5v4H2.5a.5.5 0 01-.5-.5V10a3 3 0 013-3zm-.646 2.229a.5.5 0 00-.708 0l-.917.917a.5.5 0 000 .707l.917.918a.5.5 0 00.708 0l.917-.918a.5.5 0 000-.707zM17.5 2a.5.5 0 01.5.5V5H6V2.5a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    printOutline: '<svg height="24" width="24"><path d="M17.5 2a.5.5 0 01.5.5V7h1c1.654 0 3 1.346 3 3v8h-4v3.5a.5.5 0 01-.5.5h-11a.5.5 0 01-.5-.5V18H2v-8c0-1.654 1.346-3 3-3h1V2.5a.5.5 0 01.5-.5zM16 16H8v4h8zm3-7H5c-.551 0-1 .449-1 1v6h2v-1.5a.5.5 0 01.5-.5h11a.5.5 0 01.5.5V16h2v-6c0-.551-.448-1-1-1zm-2.354 1.506a.5.5 0 01.707 0l.641.64a.5.5 0 010 .707l-.64.641a.5.5 0 01-.708 0l-.64-.64a.5.5 0 010-.708zM16 4H8v3h8z" fill-rule="evenodd"/></svg>',
    rows: '<svg height="24" width="24"><path d="M19.5 16a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-15a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5zm0-6a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-15a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5zm0-6a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-15a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    rowsAlt: '<svg height="24" width="24"><path d="M19.5 13a.5.5 0 01.5.5v6a.5.5 0 01-.5.5h-15a.5.5 0 01-.5-.5v-6a.5.5 0 01.5-.5zm0-9a.5.5 0 01.5.5v6a.5.5 0 01-.5.5h-15a.5.5 0 01-.5-.5v-6a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    rowsAltOutline: '<svg height="24" width="24"><path d="M5 11h14V5H5zm0 8h14v-6H5zM20.5 3h-17a.5.5 0 00-.5.5v17a.5.5 0 00.5.5h17a.5.5 0 00.5-.5v-17a.5.5 0 00-.5-.5z" fill-rule="evenodd"/></svg>',
    rowsOutline: '<svg height="24" width="24"><path d="M4.5 19.5h15v-4h-15zm0-5.5h15v-4h-15zm0-5.5h15v-4h-15zm16-5.5h-17a.5.5 0 00-.5.5v17a.5.5 0 00.5.5h17a.5.5 0 00.5-.5v-17a.5.5 0 00-.5-.5z" fill-rule="evenodd"/></svg>',
    sun: '<svg height="24" width="24"><path d="M12.491 19.864c.272 0 .492.22.492.491v1.966c0 .271-.22.491-.492.491h-.982a.492.492 0 01-.492-.491v-1.966c0-.271.22-.491.492-.491zm-7.094-1.956l.695.695a.492.492 0 010 .695l-.695.695a.491.491 0 01-.695 0l-.695-.695a.491.491 0 010-.695l.695-.695a.491.491 0 01.695 0zm13.901 0l.695.695a.49.49 0 010 .695l-.695.695a.492.492 0 01-.695 0l-.695-.695a.491.491 0 010-.695l.695-.695a.491.491 0 01.695 0zM12 7.085A4.92 4.92 0 0116.915 12 4.92 4.92 0 0112 16.915 4.92 4.92 0 017.085 12 4.92 4.92 0 0112 7.085zm-8.355 3.932c.271 0 .491.22.491.492v.982c0 .272-.22.492-.491.492H1.679a.492.492 0 01-.492-.492v-.982c0-.272.22-.492.492-.492zm18.676 0c.271 0 .491.22.491.492v.982c0 .272-.22.492-.491.492h-1.966a.492.492 0 01-.491-.492v-.982c0-.272.22-.492.491-.492zM5.397 4.007l.695.695a.491.491 0 010 .695l-.695.695a.491.491 0 01-.695 0l-.695-.695a.49.49 0 010-.695l.695-.695a.492.492 0 01.695 0zm13.901 0l.695.695a.491.491 0 010 .695l-.695.695a.491.491 0 01-.695 0l-.695-.695a.492.492 0 010-.695l.695-.695a.491.491 0 01.695 0zm-6.807-2.82c.272 0 .492.22.492.492v1.966c0 .271-.22.491-.492.491h-.982a.492.492 0 01-.492-.491V1.679c0-.271.22-.491.492-.491z" fill-rule="evenodd"/></svg>',
    sunOutline: '<svg height="24" width="24"><path d="M12.455 19.273c.25 0 .454.203.454.454v1.818c0 .251-.204.455-.454.455h-.91a.455.455 0 01-.454-.455v-1.818c0-.25.204-.454.454-.454zm-6.562-1.809l.643.643a.454.454 0 010 .643l-.643.642a.454.454 0 01-.643 0l-.643-.642a.454.454 0 010-.643l.643-.643a.454.454 0 01.643 0zm12.857 0l.643.643a.454.454 0 010 .643l-.643.643a.455.455 0 01-.643 0l-.643-.643a.454.454 0 010-.643l.643-.643a.455.455 0 01.643 0zM12 7.454A4.55 4.55 0 0116.546 12 4.55 4.55 0 0112 16.545 4.55 4.55 0 017.455 12 4.55 4.55 0 0112 7.455zm0 1.819A2.73 2.73 0 009.273 12 2.73 2.73 0 0012 14.727 2.73 2.73 0 0014.727 12 2.73 2.73 0 0012 9.273zM4.273 11.09c.25 0 .454.204.454.454v.91c0 .25-.203.454-.454.454H2.455A.455.455 0 012 12.455v-.91c0-.25.204-.454.455-.454zm17.272 0c.251 0 .455.204.455.454v.91c0 .25-.204.454-.455.454h-1.818a.455.455 0 01-.454-.454v-.91c0-.25.203-.454.454-.454zM5.893 4.607l.643.643a.454.454 0 010 .643l-.643.643a.454.454 0 01-.643 0l-.642-.643a.454.454 0 010-.643l.642-.643a.455.455 0 01.643 0zm12.857 0l.643.643a.454.454 0 010 .643l-.643.643a.455.455 0 01-.643 0l-.643-.643a.454.454 0 010-.643l.643-.643a.455.455 0 01.643 0zM12.455 2c.25 0 .454.204.454.455v1.818c0 .25-.204.454-.454.454h-.91a.455.455 0 01-.454-.454V2.455c0-.251.204-.455.454-.455z" fill-rule="evenodd"/></svg>',
    zoomIn: '<svg height="24" width="24"><path d="M2.065 11.038c-.658-5.22 3.746-9.628 8.963-8.973 3.545.445 6.398 3.266 6.892 6.805a7.957 7.957 0 01-1.566 5.974l5.49 5.492a.533.533 0 010 .754l-.754.754a.533.533 0 01-.753 0l-5.489-5.49a7.95 7.95 0 01-5.973 1.574c-3.54-.49-6.363-3.343-6.81-6.89zM10 4.133a5.876 5.876 0 00-5.867 5.87 5.876 5.876 0 005.867 5.87 5.876 5.876 0 005.868-5.87 5.876 5.876 0 00-5.868-5.87zm.4 2.666c.294 0 .533.24.533.533v1.733h1.732c.295 0 .533.24.533.534v.8a.533.533 0 01-.533.533h-1.732v1.733a.533.533 0 01-.533.533h-.8a.533.533 0 01-.532-.533v-1.733H7.334a.533.533 0 01-.533-.533v-.8c0-.295.239-.534.533-.534h1.733V7.332c0-.294.238-.533.533-.533z" fill-rule="evenodd"/></svg>',
    zoomOut: '<svg height="24" width="24"><path d="M2.065 11.038c-.658-5.22 3.747-9.628 8.963-8.973 3.545.445 6.398 3.266 6.892 6.805a7.959 7.959 0 01-1.566 5.974l5.49 5.492a.533.533 0 010 .754l-.754.754a.534.534 0 01-.754 0l-5.488-5.49a7.95 7.95 0 01-5.973 1.574c-3.54-.49-6.362-3.343-6.81-6.89zM10 4.133a5.875 5.875 0 00-5.868 5.87A5.875 5.875 0 0010 15.873a5.876 5.876 0 005.867-5.87A5.876 5.876 0 0010 4.133zm2.665 4.932c.294 0 .533.24.533.534v.8a.533.533 0 01-.533.533h-5.33a.533.533 0 01-.534-.533v-.8c0-.295.24-.534.533-.534z" fill-rule="evenodd"/></svg>',
    zoomReset: '<svg height="24" width="24"><path d="M2.065 11.038c-.658-5.22 3.747-9.628 8.963-8.973 3.545.445 6.398 3.266 6.892 6.805a7.959 7.959 0 01-1.566 5.974l5.49 5.492a.533.533 0 010 .754l-.754.754a.533.533 0 01-.753 0l-5.489-5.49a7.95 7.95 0 01-5.973 1.574c-3.54-.49-6.362-3.343-6.81-6.89zM10 4.133a5.876 5.876 0 00-5.868 5.87A5.876 5.876 0 0010 15.873a5.876 5.876 0 005.867-5.87A5.876 5.876 0 0010 4.133zm1.225 3.32a.533.533 0 01.753 0l.566.566a.534.534 0 010 .754l-3.77 3.77a.533.533 0 01-.753 0l-.566-.565a.534.534 0 010-.754z" fill-rule="evenodd"/></svg>',
    choose: '<svg height="24" width="24"><path d="M10.5 7a.5.5 0 01.5.5v9a.5.5 0 01-.5.5h-9a.5.5 0 01-.5-.5v-9a.5.5 0 01.5-.5zm11.998 0a.5.5 0 01.5.5v9a.5.5 0 01-.5.5h-9a.5.5 0 01-.5-.5v-9a.5.5 0 01.5-.5zm-1.547 2.423a.5.5 0 00-.707.001l-3.271 3.281-1.217-1.216a.5.5 0 00-.707 0l-.703.703a.5.5 0 000 .707l2.282 2.281a.5.5 0 00.708 0l4.32-4.347a.5.5 0 00-.001-.706z" fill-rule="evenodd"/></svg>',
    chooseOutline: '<svg height="24" width="24"><path d="M10.5 7a.5.5 0 01.5.5v9a.5.5 0 01-.5.5h-9a.5.5 0 01-.5-.5v-9a.5.5 0 01.5-.5zm11.998 0a.5.5 0 01.5.5v9a.5.5 0 01-.5.5h-9a.5.5 0 01-.5-.5v-9a.5.5 0 01.5-.5zm-1.546 2.424a.5.5 0 00-.708 0l-3.271 3.281-1.217-1.216a.5.5 0 00-.707 0l-.703.703a.5.5 0 000 .707l2.282 2.282a.5.5 0 00.708-.001l4.32-4.347a.5.5 0 00-.001-.706zM9 9H3v6h6z" fill-rule="evenodd"/></svg>',
    click: '<svg height="24" width="24"><path d="M11.038 5c.82.025 1.453.741 1.453 1.562V12h.762c.158 0 .314.037.455.11l4.722 2.412a1.5 1.5 0 01.806 1.522l-.58 4.639a1.5 1.5 0 01-1.481 1.314l-2.531.014.014.013h-4.115a3.56 3.56 0 01-2.979-1.612L5.12 16.688a.892.892 0 01.253-1.233 2.625 2.625 0 012.005-.376c.61.133 1.14.507 1.517 1.004l.598.616v-10.2a1.5 1.5 0 011.545-1.498zm-.046-3c2.481 0 4.5 2.018 4.5 4.5 0 1.556-.796 2.93-2 3.738V6.499c0-1.378-1.122-2.499-2.5-2.499a2.502 2.502 0 00-2.499 2.5h-.002v3.737a4.498 4.498 0 01-1.998-3.738C6.493 4.02 8.511 2 10.993 2z" fill-rule="evenodd"/></svg>',
    clickOutline: '<svg height="24" width="24"><path d="M17.577 20.557a.502.502 0 01-.496.439l-2.53.015-1.219.015h-2.876a2.561 2.561 0 01-2.144-1.161l-2.381-3.633c.348-.2.917-.304 1.316-.217.348.075.566.3.9.547L10.09 18h.317V6.998c0-.267.104-.518.293-.707a1 1 0 011.705.706v5.616l5.483 2.797a.506.506 0 01.27.51zM7.279 7a4.13 4.13 0 014.125-4.125A4.13 4.13 0 0115.53 7a4.124 4.124 0 01-1.125 2.829V6.998a3.003 3.003 0 00-2.997-2.999h-.002c-.8 0-1.553.312-2.12.878a2.979 2.979 0 00-.879 2.121v2.835A4.118 4.118 0 017.28 7zm11.52 6.63l-3.837-1.957A5.874 5.874 0 0017.28 7a5.882 5.882 0 00-5.875-5.875A5.882 5.882 0 005.53 7a5.864 5.864 0 002.877 5.052v2.387a3.337 3.337 0 00-.9-.335 3.626 3.626 0 00-2.77.516 1.891 1.891 0 00-.538 2.616l2.443 3.726a4.554 4.554 0 003.815 2.064h4.116l2.427-.015-.015-.015h.106a2.507 2.507 0 002.471-2.189l.58-4.64v-.001a2.514 2.514 0 00-1.343-2.536z" fill-rule="evenodd"/></svg>',
    cursor: '<svg height="24" width="24"><path d="M17.345 13a.5.5 0 00.317-.886l-10.845-8.9A.5.5 0 006 3.6v14.026c0 .47.59.68.887.317l3.352-4.1 3.43 7.256a.5.5 0 00.666.238l.905-.428a.5.5 0 00.238-.666L12.048 13z" fill-rule="evenodd"/></svg>',
    cursorOutline: '<svg height="24" width="24"><path d="M11.821 19.952l2.064-1.014-2.757-5.616 4.376-.867L5.7 4.885l.002 12.386 3.362-2.935zm3.89-.017l-4.217 2.072a.5.5 0 01-.67-.228l-2.31-4.706-3.683 3.214a.5.5 0 01-.83-.376V2.442a.5.5 0 01.805-.395l13.826 10.676a.5.5 0 01-.208.886l-4.795.95 2.311 4.707a.5.5 0 01-.228.669z" fill-rule="evenodd"/></svg>',
    cursorPointer: '<svg height="24" width="24"><path d="M17.5 14.063a5.443 5.443 0 01-5.437 5.437 5.402 5.402 0 01-3.845-1.592l-3.702-3.703a2.735 2.735 0 013.221.395L9 15.784V5a.5.5 0 011 0V12h1.5V8.999a.5.5 0 011 0V12H14V9.999a.5.5 0 011 0V12h1.5v-1.001a.5.5 0 011 0zM17 8.999c-.247 0-.483.047-.702.13a1.987 1.987 0 00-2.5-1A2 2 0 0012 6.998a2 2 0 00-.5.065V5c0-1.103-.897-2-2-2s-2 .897-2 2v7.684a4.23 4.23 0 00-4.648.92l-.53.53 4.836 4.835A6.892 6.892 0 0012.063 21 6.945 6.945 0 0019 14.063v-3.064c0-1.103-.897-2-2-2z" fill-rule="evenodd"/></svg>',
    drag: '<svg height="24" width="24"><path d="M19.646 12.354l-2.22 2.22a.25.25 0 01-.426-.177v-1.646h-4.25V17h1.646a.25.25 0 01.177.427l-2.22 2.22a.5.5 0 01-.707 0l-2.22-2.22A.25.25 0 019.604 17h1.647v-4.25H7v1.646a.25.25 0 01-.427.177l-2.22-2.22a.5.5 0 010-.707l2.22-2.22A.25.25 0 017 9.605v1.647h4.25V7H9.603a.25.25 0 01-.176-.427l2.22-2.22a.5.5 0 01.706 0l2.22 2.22a.25.25 0 01-.177.427H12.75v4.25H17V9.604a.25.25 0 01.427-.176l2.22 2.22a.5.5 0 010 .706M3 3.501v17a.5.5 0 00.5.5h17a.5.5 0 00.5-.5v-17a.5.5 0 00-.5-.5h-17a.5.5 0 00-.5.5" fill-rule="evenodd"/></svg>',
    dragOutline: '<svg height="24" width="24"><path d="M20.647 11.647L17.89 8.89a.25.25 0 00-.426.177v2.182H12.75V6.536h2.182a.25.25 0 00.177-.427l-2.755-2.755a.5.5 0 00-.707 0L8.89 6.109a.25.25 0 00.177.427h2.182v4.714H6.536V9.068a.25.25 0 00-.427-.177l-2.755 2.756a.5.5 0 000 .707l2.755 2.755a.25.25 0 00.427-.177V12.75h4.714v4.715H9.068a.25.25 0 00-.177.426l2.756 2.756a.5.5 0 00.707 0l2.755-2.756a.25.25 0 00-.177-.426H12.75V12.75h4.715v2.182c0 .223.269.334.426.177l2.756-2.755a.5.5 0 000-.707" fill-rule="evenodd"/></svg>',
    focus: '<svg height="24" width="24"><path d="M1.5 15a.5.5 0 01.5.5V19h3.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-5a.5.5 0 01-.5-.5v-5a.5.5 0 01.5-.5zm22 0a.5.5 0 01.5.5v5a.5.5 0 01-.5.5h-5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5H22v-3.5a.5.5 0 01.5-.5zM16 7c2.757 0 5 2.243 5 5s-2.243 5-5 5H8c-2.757 0-5-2.243-5-5s2.243-5 5-5zM5.5 3a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H2v3.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-5A.5.5 0 01.5 3zm18 0a.5.5 0 01.5.5v5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V5h-3.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    focusOutline: '<svg height="24" width="24"><path d="M1.5 15a.5.5 0 01.5.5V19h3.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-5a.5.5 0 01-.5-.5v-5a.5.5 0 01.5-.5zm22 0a.5.5 0 01.5.5v5a.5.5 0 01-.5.5h-5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5H22v-3.5a.5.5 0 01.5-.5zM16 7c2.757 0 5 2.243 5 5s-2.243 5-5 5H8c-2.757 0-5-2.243-5-5s2.243-5 5-5zm0 2H8c-1.654 0-3 1.346-3 3s1.346 3 3 3h8c1.655 0 3-1.346 3-3s-1.345-3-3-3zM5.5 3a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H2v3.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-5A.5.5 0 01.5 3zm18 0a.5.5 0 01.5.5v5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V5h-3.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    hover: '<svg height="24" width="24"><path d="M15.822 6.993l-5.045 1.633a.997.997 0 00-.399.245l-.538.538-3.845-3.845c-.58-.58-1.534-.64-2.132-.076A1.5 1.5 0 003.83 7.64l7.213 7.212-.86-.013c-.617-.084-1.256.026-1.78.363a2.626 2.626 0 00-1.153 1.683c-.099.48.213.95.693 1.051l4.361.905a3.562 3.562 0 003.247-.966l1.05-1.049.019-.02 1.84-1.84h-.02l1.78-1.8a1.5 1.5 0 00.118-1.975l-2.87-3.692a1.5 1.5 0 00-1.646-.506" fill-rule="evenodd"/></svg>',
    hoverOutline: '<svg height="24" width="24"><path d="M8.154 17.306l4.253.885a2.562 2.562 0 002.337-.695l2.033-2.033.851-.872 1.779-1.8a.502.502 0 00.04-.661L16.58 8.44a.506.506 0 00-.552-.17l-5.854 1.899L6.202 6.2a1 1 0 00-1.412-.001.993.993 0 00-.293.706c0 .267.104.518.292.707l7.78 7.78-.224.224-2.39.356c-.411.061-.724.057-1.023.25-.345.221-.673.697-.778 1.084zM19.068 16l-2.91 2.91a4.555 4.555 0 01-4.157 1.24l-4.362-.908a1.891 1.891 0 01-1.47-2.23 3.627 3.627 0 011.595-2.324 3.33 3.33 0 01.873-.4L3.375 9.026a2.98 2.98 0 01-.878-2.121 2.98 2.98 0 01.88-2.121 3.003 3.003 0 014.24.001L10.72 7.89l4.692-1.522c.998-.32 2.1.02 2.743.844v.001l2.871 3.691a2.507 2.507 0 01-.2 3.295l-.074.076h.02z" fill-rule="evenodd"/></svg>',
    input: '<svg height="24" width="24"><path d="M21.502 4a.5.5 0 01.5.5v15a.5.5 0 01-.5.5H2.498a.5.5 0 01-.5-.5v-15a.5.5 0 01.5-.5zm-1.5 2H3.998v12h16.004zM17.5 8a.5.5 0 01.5.5v7a.5.5 0 01-.5.5h-11a.5.5 0 01-.5-.5v-7a.5.5 0 01.5-.5zm-8 1H8a.5.5 0 00-.5.5v.5a.5.5 0 00.5.5h.5v4a.5.5 0 00.5.5h.5a.5.5 0 00.5-.5v-5a.5.5 0 00-.5-.5zm3.213 4.428a.5.5 0 00-.707 0l-.36.36a.5.5 0 000 .707l.36.36a.5.5 0 00.707 0l.36-.36a.5.5 0 000-.707zm3.25 0a.5.5 0 00-.707 0l-.36.36a.5.5 0 000 .707l.36.36a.5.5 0 00.707 0l.36-.36a.5.5 0 000-.707z" fill-rule="evenodd"/></svg>',
    inputOutline: '<svg height="24" width="24"><path d="M21.502 4a.5.5 0 01.5.5v15a.5.5 0 01-.5.5H2.498a.5.5 0 01-.5-.5v-15a.5.5 0 01.5-.5zm-1.5 2H3.998v12h16.004zM9.5 9a.5.5 0 01.5.5v5a.5.5 0 01-.5.5H9a.5.5 0 01-.5-.5v-4H8a.5.5 0 01-.5-.5v-.5A.5.5 0 018 9zm3.213 4.428l.36.359a.5.5 0 010 .707l-.36.36a.5.5 0 01-.707 0l-.36-.36a.5.5 0 010-.707l.36-.36a.5.5 0 01.707 0zm3.25 0l.36.359a.5.5 0 010 .707l-.36.36a.5.5 0 01-.707 0l-.36-.36a.5.5 0 010-.707l.36-.36a.5.5 0 01.707 0z" fill-rule="evenodd"/></svg>',
    keyboard: '<svg height="24" width="24"><path d="M21.312 5.187a.5.5 0 01.5.5v12.625a.5.5 0 01-.5.5H2.687a.5.5 0 01-.5-.5V5.687a.5.5 0 01.5-.5zm-1.125 1.625H3.812v10.375h16.375zm-4.688 7.44a.25.25 0 01.25.25v.997a.25.25 0 01-.25.25H8.502a.25.25 0 01-.25-.25v-.997a.25.25 0 01.25-.25zm3-3a.25.25 0 01.25.25v.997a.25.25 0 01-.25.25h-.997a.25.25 0 01-.25-.25v-.997a.25.25 0 01.25-.25zm-12 0a.25.25 0 01.25.25v.997a.25.25 0 01-.25.25h-.997a.25.25 0 01-.25-.25v-.997a.25.25 0 01.25-.25zm3 0a.25.25 0 01.25.25v.997a.25.25 0 01-.25.25h-.997a.25.25 0 01-.25-.25v-.997a.25.25 0 01.25-.25zm3 0a.25.25 0 01.25.25v.997a.25.25 0 01-.25.25h-.997a.25.25 0 01-.25-.25v-.997a.25.25 0 01.25-.25zm3 0a.25.25 0 01.25.25v.997a.25.25 0 01-.25.25h-.997a.25.25 0 01-.25-.25v-.997a.25.25 0 01.25-.25zm3-3a.25.25 0 01.25.25v.997a.25.25 0 01-.25.25h-.997a.25.25 0 01-.25-.25v-.997a.25.25 0 01.25-.25zm-12 0a.25.25 0 01.25.25v.997a.25.25 0 01-.25.25h-.997a.25.25 0 01-.25-.25v-.997a.25.25 0 01.25-.25zm3 0a.25.25 0 01.25.25v.997a.25.25 0 01-.25.25h-.997a.25.25 0 01-.25-.25v-.997a.25.25 0 01.25-.25zm3 0a.25.25 0 01.25.25v.997a.25.25 0 01-.25.25h-.997a.25.25 0 01-.25-.25v-.997a.25.25 0 01.25-.25zm3 0a.25.25 0 01.25.25v.997a.25.25 0 01-.25.25h-.997a.25.25 0 01-.25-.25v-.997a.25.25 0 01.25-.25z" fill-rule="evenodd"/></svg>',
    mouse: '<svg height="24" width="24"><path d="M12 2c3.86 0 7 3.14 7 7v6c0 3.86-3.14 7-7 7s-7-3.14-7-7V9c0-3.86 3.14-7 7-7zm0 2C9.243 4 7 6.243 7 9v6c0 2.757 2.243 5 5 5s5-2.243 5-5V9c0-2.757-2.243-5-5-5zm.5 4a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    notAllowed: '<svg width="24" height="24"><path fill-rule="evenodd" d="M15 8c3.86 0 7 3.14 7 7s-3.14 7-7 7-7-3.14-7-7 3.14-7 7-7zm-4.169 4.246a4.968 4.968 0 00-.83 2.754c0 2.757 2.242 5 4.999 5a4.97 4.97 0 002.754-.83zM15 10a4.97 4.97 0 00-2.755.832l6.923 6.923c.525-.79.832-1.737.832-2.755 0-2.757-2.243-5-5-5zM2.003 2.542c0-.403.476-.617.778-.35l6.38 5.65c.329.292.11.836-.33.818l-3.675-.15-2.323 2.85a.468.468 0 01-.83-.296z"/></svg>',
    selection: '<svg height="24" width="24"><path d="M20.5 17a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5H19v-1.5a.5.5 0 01.5-.5zm-16 0a.5.5 0 01.5.5V19h1.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5zm9 2a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm7-9a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5zm-16 0a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5zm16-7a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V5h-1.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm-14 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H5v1.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5zm7 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    selectionAlt: '<svg height="24" width="24"><path d="M8.5 19a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm4 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm4 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm4 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm-16 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm16-4a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm-16 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm16-4a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm-16 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm16-4a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm-16 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm12-4a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm4 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm-8 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm-4 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm-4 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    switching: '<svg height="24" width="24"><path d="M17 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5M17 6H7a6 6 0 100 12h10a6 6 0 100-12" fill-rule="evenodd"/></svg>',
    switchingOutline: '<svg height="24" width="24"><path d="M17 5c3.86 0 7 3.14 7 7s-3.14 7-7 7H7c-3.86 0-7-3.14-7-7s3.14-7 7-7zm0 2H7c-2.757 0-5 2.243-5 5s2.243 5 5 5h10c2.757 0 5-2.243 5-5s-2.243-5-5-5zm0 2a3 3 0 110 6 3 3 0 010-6z" fill-rule="evenodd"/></svg>',
    switchingOutlineOff: '<svg height="24" width="24"><path d="M17 5c3.86 0 7 3.14 7 7s-3.14 7-7 7H7c-3.86 0-7-3.14-7-7s3.14-7 7-7zm0 2H7c-2.757 0-5 2.243-5 5s2.243 5 5 5h10c2.757 0 5-2.243 5-5s-2.243-5-5-5zm-10 2a3 3 0 110 6 3 3 0 010-6z" fill-rule="evenodd"/></svg>',
    angular: '<svg width="24" height="24"><path fill-rule="evenodd" d="M17.629 18h-1.363a.5.5 0 01-.46-.303l-.99-2.309H9.184l-.99 2.31a.5.5 0 01-.46.302H6.379a.25.25 0 01-.23-.349l5.625-13.115a.25.25 0 01.46 0l5.624 13.115a.25.25 0 01-.23.349M21.13 5.363l-8.784-3.236a1 1 0 00-.692 0L2.871 5.363a.5.5 0 00-.324.53l1.405 11.706a.75.75 0 00.41.582l7.19 3.595a1 1 0 00.894 0l7.193-3.593a.75.75 0 00.41-.581l1.404-11.71a.5.5 0 00-.324-.529M9.934 13.64h4.132L12 8.822l-2.066 4.817z"/></svg>',
    discord: '<svg height="24" width="24"><path d="M19.277 5.326a17.323 17.323 0 00-4.274-1.325.065.065 0 00-.069.033c-.184.328-.389.756-.532 1.092a15.994 15.994 0 00-4.801 0 11.057 11.057 0 00-.54-1.092A.067.067 0 008.99 4c-1.5.258-2.934.71-4.274 1.325a.061.061 0 00-.028.024c-2.722 4.066-3.468 8.032-3.102 11.948.001.02.012.038.027.05a17.417 17.417 0 005.244 2.65.068.068 0 00.074-.025 12.44 12.44 0 001.072-1.744.066.066 0 00-.036-.093 11.47 11.47 0 01-1.638-.78.067.067 0 01-.007-.112c.11-.082.22-.168.325-.255a.065.065 0 01.068-.009c3.437 1.569 7.158 1.569 10.554 0a.065.065 0 01.069.008c.105.087.215.174.326.256a.067.067 0 01-.006.112c-.523.305-1.067.564-1.639.78a.067.067 0 00-.035.093c.315.61.675 1.192 1.072 1.743a.067.067 0 00.073.025 17.36 17.36 0 005.252-2.65.067.067 0 00.028-.048c.437-4.528-.734-8.461-3.105-11.948a.053.053 0 00-.028-.025zm-10.76 9.588c-1.034 0-1.887-.95-1.887-2.116 0-1.166.836-2.116 1.888-2.116 1.059 0 1.903.958 1.887 2.116 0 1.166-.836 2.116-1.887 2.116zm6.978 0c-1.034 0-1.887-.95-1.887-2.116 0-1.166.836-2.116 1.887-2.116 1.06 0 1.904.958 1.888 2.116 0 1.166-.828 2.116-1.888 2.116z"/></svg>',
    domql: '<svg width="24" height="24"><path d="M30 17.147c-7.276 1.661-12.936.896-16.98-2.295.318-.213.634-.433.952-.659l.909-.655c.317-.227.628-.445.931-.655 4.585 3.642 8.39 4.158 14.188 4.264zm-17.057-6.143C19.47 6.437 25 4.984 29.524 6.696l.476.18c-6.334-.852-10.24.72-16.539 5.126l-.898.635C6.04 17.187.012 18.85-5.509 17.595L-6 17.483c5.3.791 12.002-1.512 18.507-6.17zm-1.566-1.896l-.355.25a41.27 41.27 0 01-2.49 1.605C4.452 7.94.897 7.313-6 6.317c7.525-.873 13.317.057 17.377 2.79z"/></svg>',
    elm: '<svg width="24" height="24"><path fill-rule="evenodd" d="M11.995 12.605L20.39 21H3.6l8.395-8.395zM3 3.61l8.395 8.395L3 20.4V3.61zm17.99 8.995V20.4l-3.898-3.897 3.898-3.898zm-4.498-4.498l3.898 3.898-3.898 3.898-3.897-3.898 3.897-3.898zm-.6-.6l-3.897 3.898-3.898-3.897h7.796zM21 3v8.396L12.604 3H21zm-9.605.01l3.658 3.658H7.258L3.6 3.01h7.795z"/></svg>',
    figma: '<svg width="24" height="24"><path fill-rule="evenodd" d="M15.583 7.667H12.75V2h2.833a2.833 2.833 0 010 5.667m-4.333 0H8.417a2.833 2.833 0 110-5.667h2.833v5.667zm4.333 7.167a2.833 2.833 0 110-5.667 2.833 2.833 0 010 5.667m-4.333 0H8.417a2.833 2.833 0 110-5.667h2.833v5.667zM8.417 22a2.833 2.833 0 010-5.666h2.833v2.833A2.833 2.833 0 018.417 22"/></svg>',
    github: '<svg width="24" height="24"><path fill-rule="evenodd" d="M11.293 2.025c-4.957.341-8.962 4.375-9.27 9.334A10.004 10.004 0 008.67 21.43a.25.25 0 00.33-.238V19.5h-.375c-2.25 0-2.098-3-3.25-3H5.25a.25.25 0 110-.5h.625c1.03 0 1.5 2 2.5 2H9c0-.82.33-1.56.861-2.102C7.604 15.238 6 13.563 6 11.6c0-1.042.452-2.002 1.214-2.773a4.971 4.971 0 01-.123-2.378.5.5 0 01.565-.398c.911.146 1.78.543 2.495 1.172A7.682 7.682 0 0112 7c.645 0 1.267.079 1.849.223a4.963 4.963 0 012.495-1.172.5.5 0 01.565.398c.15.782.113 1.599-.122 2.378C17.548 9.598 18 10.558 18 11.6c0 1.963-1.604 3.637-3.861 4.298.532.541.861 1.283.861 2.102v3.194a.25.25 0 00.33.238c3.886-1.371 6.672-5.076 6.672-9.432 0-5.758-4.866-10.378-10.709-9.975"/></svg>',
    githubOutline: '<svg height="16" width="16"><path d="M8 0C3.589 0 0 3.589 0 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zm0 1.2A6.79 6.79 0 0114.8 8a6.79 6.79 0 01-4.8 6.5v-2.045c0-.764-.44-1.42-1.077-1.746 1.256-.24 2.289-.95 2.775-1.906s.366-2.042-.323-2.915c.177-.546.376-1.504-.095-2.258-.908 0-1.494.623-1.774 1.01a4.882 4.882 0 00-3.014-.003C6.212 4.25 5.626 3.63 4.72 3.63c-.54.866-.206 1.796-.027 2.175-.736.87-.892 1.973-.417 2.952.475.98 1.52 1.71 2.797 1.955-.523.269-.914.758-1.034 1.35h-.526c-.519 0-.72-.21-1-.566-.277-.356-.575-.594-.933-.694-.192-.02-.322.127-.154.257.567.386.607 1.018.834 1.432.207.373.632.709 1.112.709H6v1.3A6.79 6.79 0 011.2 8 6.79 6.79 0 018 1.2z" fill-rule="evenodd"/></svg>',
    sfRefreshFill: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M11.9570312,22.9140625 C18.0048828,22.9140625 22.9140625,18.0048828 22.9140625,11.9570312 C22.9140625,5.91992188 18.0048828,1 11.9570312,1 C5.91992188,1 1,5.91992188 1,11.9570312 C1,18.0048828 5.91992188,22.9140625 11.9570312,22.9140625 Z M11.9570312,17.4570312 C9.21777344,17.4570312 7.015625,15.2333984 7.015625,12.4619141 C7.015625,9.74414062 9.25,7.60644531 11.7421875,7.60644531 C11.8388672,7.60644531 11.9355469,7.60644531 12.0537109,7.6171875 L11.2802734,6.86523438 C11.1621094,6.73632812 11.0654297,6.55371094 11.0654297,6.33886719 C11.0654297,5.95214844 11.3769531,5.65136719 11.7744141,5.65136719 C11.9570312,5.65136719 12.171875,5.76953125 12.2578125,5.85546875 L14.40625,8.00390625 C14.5458984,8.1328125 14.6103516,8.32617188 14.6103516,8.49804688 C14.6103516,8.69140625 14.5458984,8.87402344 14.40625,9.01367188 L12.2578125,11.1621094 C12.1611328,11.2587891 11.9570312,11.3554688 11.7744141,11.3554688 C11.3769531,11.3554688 11.0654297,11.0546875 11.0654297,10.6679688 C11.0654297,10.453125 11.1513672,10.2919922 11.2802734,10.1416016 L12.3222656,9.12109375 C12.2363281,9.09960938 12.1074219,9.08886719 11.9570312,9.08886719 C10.0664062,9.08886719 8.55175781,10.6035156 8.55175781,12.5048828 C8.55175781,14.40625 10.0664062,15.9316406 11.9570312,15.9316406 C13.8476562,15.9316406 15.3623047,14.40625 15.3623047,12.5048828 C15.3623047,12.0859375 15.7167969,11.7421875 16.1357422,11.7421875 C16.5439453,11.7421875 16.8984375,12.0859375 16.8984375,12.5048828 C16.8984375,15.2333984 14.6962891,17.4570312 11.9570312,17.4570312 Z"/></svg>',
    playOvalDotted: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12.9999758,22.9633119 C13.553625,22.9633119 14.0121806,23.423961 14.0121806,23.9829305 C14.0121806,24.5392295 13.553625,25 12.9999758,25 C12.4437536,25 11.9877952,24.5392295 11.9877952,23.9829305 C11.9877952,23.423961 12.4437536,22.9633119 12.9999758,22.9633119 Z M16.3767138,22.4061632 C16.9303388,22.4061632 17.3888945,22.8669337 17.3888945,23.4259032 C17.3888945,23.9822022 16.9303388,24.4429727 16.3767138,24.4429727 C15.8204313,24.4429727 15.3645332,23.9822022 15.3645332,23.4259032 C15.3645332,22.8669337 15.8204313,22.4061632 16.3767138,22.4061632 Z M9.62329823,22.4061632 C10.1795325,22.4061632 10.6479937,22.8669337 10.6479937,23.4259032 C10.6479937,23.9822022 10.1795325,24.4429727 9.62329823,24.4429727 C9.06707604,24.4429727 8.6111176,23.9822022 8.6111176,23.4259032 C8.6111176,22.8669337 9.06707604,22.4061632 9.62329823,22.4061632 Z M19.4472005,20.8534298 C20.0008255,20.8534298 20.4593811,21.3140789 20.4593811,21.8730484 C20.4593811,22.4293474 20.0008255,22.8901179 19.4472005,22.8901179 C18.8909179,22.8901179 18.4199199,22.4293474 18.4199199,21.8730484 C18.4199199,21.3140789 18.8909179,20.8534298 19.4472005,20.8534298 Z M6.56527814,20.8534298 C7.12151241,20.8534298 7.57747086,21.3140789 7.57747086,21.8730484 C7.57747086,22.4293474 7.12151241,22.8901179 6.56527814,22.8901179 C6.00905595,22.8901179 5.55309751,22.4293474 5.55309751,21.8730484 C5.55309751,21.3140789 6.00905595,20.8534298 6.56527814,20.8534298 Z M21.8605368,18.4184836 C22.4141618,18.4184836 22.8851598,18.8892075 22.8851598,19.4480556 C22.8851598,20.004476 22.4141618,20.4651251 21.8605368,20.4651251 C21.3042542,20.4651251 20.8456985,20.004476 20.8456985,19.4480556 C20.8456985,18.8892075 21.3042542,18.4184836 21.8605368,18.4184836 Z M4.13947533,18.4184836 C4.6957096,18.4184836 5.15166804,18.8892075 5.15166804,19.4480556 C5.15166804,20.004476 4.6957096,20.4651251 4.13947533,20.4651251 C3.58580201,20.4651251 3.12729469,20.004476 3.12729469,19.4480556 C3.12729469,18.8892075 3.58580201,18.4184836 4.13947533,18.4184836 Z M9.91699219,9.51660156 C9.91699219,8.99023438 10.5292969,8.78613281 10.9912109,9.0546875 L17.1035156,12.6748047 C17.5439453,12.9433594 17.5546875,13.5664063 17.1035156,13.8242188 L10.9912109,17.4443359 C10.4863281,17.7451172 9.91699219,17.4980469 9.91699219,16.9824219 Z M23.4058064,15.3885172 C23.9595522,15.3885172 24.4179871,15.8466172 24.4179871,16.4055867 C24.4179871,16.9644347 23.9595522,17.4226562 23.4058064,17.4226562 C22.8496446,17.4226562 22.391089,16.9644347 22.391089,16.4055867 C22.391089,15.8466172 22.8496446,15.3885172 23.4058064,15.3885172 Z M2.59414524,15.3885172 C3.15036743,15.3885172 3.60632588,15.8466172 3.60632588,16.4055867 C3.60632588,16.9644347 3.15036743,17.4226562 2.59414524,17.4226562 C2.04046468,17.4226562 1.58195977,16.9644347 1.58195977,16.4055867 C1.58195977,15.8466172 2.04046468,15.3885172 2.59414524,15.3885172 Z M23.9852826,11.9829305 C24.5414444,11.9829305 25,12.4410912 25,13 C25,13.5589088 24.5414444,14.0171302 23.9852826,14.0171302 C23.4315368,14.0171302 22.9731019,13.5589088 22.9731019,13 C22.9731019,12.4410912 23.4315368,11.9829305 23.9852826,11.9829305 Z M2.01218184,11.9829305 C2.56841491,11.9829305 3.02691015,12.4410912 3.02691015,13 C3.02691015,13.5589088 2.56841491,14.0171302 2.01218184,14.0171302 C1.4585049,14.0171302 1,13.5589088 1,13 C1,12.4410912 1.4585049,11.9829305 2.01218184,11.9829305 Z M23.4058064,8.57738025 C23.9595522,8.57738025 24.4179871,9.03810217 24.4179871,9.59444975 C24.4179871,10.1533585 23.9595522,10.6115193 23.4058064,10.6115193 C22.8496446,10.6115193 22.391089,10.1533585 22.391089,9.59444975 C22.391089,9.03810217 22.8496446,8.57738025 23.4058064,8.57738025 Z M2.59414524,8.57738025 C3.15036743,8.57738025 3.60632588,9.03810217 3.60632588,9.59444975 C3.60632588,10.1533585 3.15036743,10.6115193 2.59414524,10.6115193 C2.04046468,10.6115193 1.58195977,10.1533585 1.58195977,9.59444975 C1.58195977,9.03810217 2.04046468,8.57738025 2.59414524,8.57738025 Z M21.8605368,5.53483848 C22.4141618,5.53483848 22.8851598,6.00812357 22.8851598,6.56447115 C22.8851598,7.12339205 22.4141618,7.58154066 21.8605368,7.58154066 C21.3042542,7.58154066 20.8456985,7.12339205 20.8456985,6.56447115 C20.8456985,6.00812357 21.3042542,5.53483848 21.8605368,5.53483848 Z M4.13947533,5.53483848 C4.6957096,5.53483848 5.15166804,6.00812357 5.15166804,6.56447115 C5.15166804,7.12339205 4.6957096,7.58154066 4.13947533,7.58154066 C3.58580201,7.58154066 3.12729469,7.12339205 3.12729469,6.56447115 C3.12729469,6.00812357 3.58580201,5.53483848 4.13947533,5.53483848 Z M19.4472005,3.10988211 C20.0008255,3.10988211 20.4593811,3.57060403 20.4593811,4.12695161 C20.4593811,4.68587252 20.0008255,5.14658231 19.4472005,5.14658231 C18.8909179,5.14658231 18.4199199,4.68587252 18.4199199,4.12695161 C18.4199199,3.57060403 18.8909179,3.10988211 19.4472005,3.10988211 Z M6.56527814,3.10988211 C7.12151241,3.10988211 7.57747086,3.57060403 7.57747086,4.12695161 C7.57747086,4.68587252 7.12151241,5.14658231 6.56527814,5.14658231 C6.00905595,5.14658231 5.55309751,4.68587252 5.55309751,4.12695161 C5.55309751,3.57060403 6.00905595,3.10988211 6.56527814,3.10988211 Z M16.3767138,1.55708073 C16.9303388,1.55708073 17.3888945,2.01780023 17.3888945,2.57415752 C17.3888945,3.13306629 16.9303388,3.59378822 16.3767138,3.59378822 C15.8204313,3.59378822 15.3645332,3.13306629 15.3645332,2.57415752 C15.3645332,2.01780023 15.8204313,1.55708073 16.3767138,1.55708073 Z M9.62329823,1.55708073 C10.1795325,1.55708073 10.6479937,2.01780023 10.6479937,2.57415752 C10.6479937,3.13306629 10.1795325,3.59378822 9.62329823,3.59378822 C9.06707604,3.59378822 8.6111176,3.13306629 8.6111176,2.57415752 C8.6111176,2.01780023 9.06707604,1.55708073 9.62329823,1.55708073 Z M12.9999758,1 C13.553625,1 14.0121806,1.4607195 14.0121806,2.01707072 C14.0121806,2.57599041 13.553625,3.0367002 12.9999758,3.0367002 C12.4437536,3.0367002 11.9877952,2.57599041 11.9877952,2.01707072 C11.9877952,1.4607195 12.4437536,1 12.9999758,1 Z" transform="translate(-1 -1)"/></svg>',
    linkedin: `<svg  width="32" height="32" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
<path d="M28.778 1.004h-25.56c-0.008-0-0.017-0-0.027-0-1.199 0-2.172 0.964-2.186 2.159v25.672c0.014 1.196 0.987 2.161 2.186 2.161 0.010 0 0.019-0 0.029-0h25.555c0.008 0 0.018 0 0.028 0 1.2 0 2.175-0.963 2.194-2.159l0-0.002v-25.67c-0.019-1.197-0.994-2.161-2.195-2.161-0.010 0-0.019 0-0.029 0h0.001zM9.9 26.562h-4.454v-14.311h4.454zM7.674 10.293c-1.425 0-2.579-1.155-2.579-2.579s1.155-2.579 2.579-2.579c1.424 0 2.579 1.154 2.579 2.578v0c0 0.001 0 0.002 0 0.004 0 1.423-1.154 2.577-2.577 2.577-0.001 0-0.002 0-0.003 0h0zM26.556 26.562h-4.441v-6.959c0-1.66-0.034-3.795-2.314-3.795-2.316 0-2.669 1.806-2.669 3.673v7.082h-4.441v-14.311h4.266v1.951h0.058c0.828-1.395 2.326-2.315 4.039-2.315 0.061 0 0.121 0.001 0.181 0.003l-0.009-0c4.5 0 5.332 2.962 5.332 6.817v7.855z"></path>
</svg>`,
    logov2: '<svg xmlns="http://www.w3.org/2000/svg" width="41" height="42" viewBox="0 0 41 42"><path fill-rule="evenodd" d="M26.6448969,0.699064106 C31.4862479,1.83000067 35.6718819,4.48073656 38.3104478,8.91022511 C40.5212645,12.5974948 41.4936378,17.0951724 40.5085112,21.3679841 C39.7174644,25.0315254 37.8558379,27.853625 34.8002871,29.8369535 C31.9792925,31.7073227 27.90737,32.069064 24.6776501,31.3213124 C23.2887047,30.9944607 20.6411869,29.9775216 19.044333,28.0178349 C17.5928447,26.2365433 17.1250067,23.5192397 17.0461096,22.8419583 C16.9044422,21.6258334 17.1065683,20.249997 17.3800113,19.0276209 C17.9614095,16.4655592 18.9984397,14.7924534 21.1401118,13.3818866 C22.95018,12.1750388 24.6834696,11.8738651 26.7601335,12.3496124 C28.1855093,12.6880929 29.4520072,13.526716 30.3514025,14.7276098 C30.6271426,15.093878 30.8260324,15.4389318 31.059655,15.8362933 L30.9598079,15.7715366 C29.6377659,14.9422902 28.1654404,14.6590001 26.6448969,15.0752526 C25.2996601,15.4486698 24.1453463,16.3687006 23.4390969,17.6304467 C22.6973258,18.9448239 22.4839364,20.5087166 22.8465467,21.9733145 C23.2152637,23.4394215 24.1276197,24.6832715 25.381967,25.429977 C26.7647836,26.2608222 28.5893081,26.47537 30.1320438,26.0161118 C32.0344739,25.4497656 33.5958796,24.1165457 34.5824098,22.3233381 C35.8078311,20.0959926 36.0316242,17.5753145 35.4197363,15.1376991 C34.8712232,12.9726344 33.491011,11.1258939 31.7578503,9.86101942 C28.3978494,7.40873928 23.8145474,6.88014849 19.8961329,8.1555193 C16.9596954,9.11146975 14.399202,11.0657028 12.6221782,13.707146 C10.5375814,16.8894059 9.73736372,20.794518 10.3986926,24.5579956 C10.9302311,27.7327705 12.5716868,31.0242929 14.8485647,33.1339502 C15.5517576,33.7855358 16.0056239,34.2996296 16.8186608,34.9238068 C16.1252729,35.6670587 15.729719,36.1210912 15.0276006,36.8553491 L10.5425168,41.6144377 C8.59431563,40.2572487 6.84060794,38.6181461 5.33246714,36.7448351 C1.65619854,32.1632109 -0.0655234106,26.1858125 0.562658817,20.1851649 C1.1000136,14.4158268 3.81414269,9.08050481 8.0996615,5.36924966 C12.3107417,1.69300072 17.6911238,0.0107792851 23.1108097,0.299129816 C25.006381,0.458182488 26.18441,0.591493918 26.6448969,0.699064106 Z"/></svg>',
    html: '<svg width="24" height="24"><path fill-rule="evenodd" d="M22.503 15.253a.25.25 0 01-.25.25H19.25a.25.25 0 01-.25-.25V8.747a.25.25 0 01.25-.25h1.002a.25.25 0 01.25.25V14h1.751a.25.25 0 01.25.25v1.003zm-4.628 0a.25.25 0 01-.25.25h-1.002a.25.25 0 01-.25-.25V11l-.927 1.217a.25.25 0 01-.397 0L14.122 11v4.253a.25.25 0 01-.25.25H12.87a.25.25 0 01-.25-.25V8.747a.25.25 0 01.25-.25h1.004a.5.5 0 01.398.197l.976 1.28.975-1.28a.5.5 0 01.398-.197h1.004a.25.25 0 01.25.25v6.506zm-6.248-5.505a.25.25 0 01-.25.25h-.751v5.255a.25.25 0 01-.25.25H9.374a.25.25 0 01-.25-.25V9.998h-.75a.25.25 0 01-.25-.25V8.747a.25.25 0 01.25-.25h3.003a.25.25 0 01.25.25v1.001zm-4.752 5.505a.25.25 0 01-.25.25H5.623a.25.25 0 01-.25-.25v-2.565H3.998v2.565a.25.25 0 01-.25.25H2.746a.25.25 0 01-.25-.25V8.747a.25.25 0 01.25-.25h1.002a.25.25 0 01.25.25v2.565h1.375V8.747a.25.25 0 01.25-.25h1.002a.25.25 0 01.25.25v6.506zM23.5 5H.5a.5.5 0 00-.5.5v13a.5.5 0 00.5.5h23a.5.5 0 00.5-.5v-13a.5.5 0 00-.5-.5z"/></svg>',
    jquery: '<svg width="24" height="24"><path d="M14.21 2.004a.522.522 0 00-.142.043c-.391.193-.835.768-.92.882a4.075 4.075 0 00-.696 2.248c-.005.6.112 1.195.35 1.768.554 1.33 1.704 2.43 3.073 2.946l.17.06a.965.965 0 00.086.027l.05.018c.07.023.143.046.214.06.36.073.712.114 1.042.124l.17.002c2.492 0 3.458-1.758 3.779-2.344.032-.057.055-.103.076-.131l.002-.004a.454.454 0 10-.751-.511h-.002c-.664.978-1.8 1.275-3.375.884a3.242 3.242 0 01-.358-.115 4.344 4.344 0 01-.437-.183 4.635 4.635 0 01-.769-.481c-1.385-1.074-1.926-3.31-1.117-4.6a.455.455 0 00-.445-.693zm-4.027.905a.445.445 0 00-.293.104c-.687.559-1.39 1.475-1.42 1.512a.12.12 0 01-.013.02c-1.243 1.809-1.337 4.383-.238 6.558.172.345.368.673.575.975l.063.089c.175.257.372.549.624.776.087.1.182.195.274.287l.044.047.038.037c.094.09.19.183.289.272h.002c.007.01.018.017.026.026.112.1.226.194.377.313l.04.03a7.566 7.566 0 00.397.296c.042.029.085.055.127.086l.043.028.05.032c.09.06.179.115.305.188.082.05.169.1.226.128l.113.062.139.073.046.021c.09.046.185.09.279.133l.143.064c.095.041.19.08.308.125l.053.02a11.099 11.099 0 00.31.11l.2.065c.099.034.214.073.34.094.62.103 1.222.156 1.792.156l.2-.002a6.645 6.645 0 006.335-4.415.455.455 0 00-.811-.384c-1.271 1.857-3.675 2.642-6.124 1.996a5.261 5.261 0 01-.44-.133 4.133 4.133 0 01-.247-.085l-.126-.048a5.594 5.594 0 01-.234-.096l-.059-.027c-.108-.046-.213-.098-.307-.144l-.26-.135c-.058-.028-.11-.06-.19-.108l-.044-.025-.044-.026a2.946 2.946 0 01-.192-.123l-.042-.027a.628.628 0 01-.043-.03c-.053-.033-.105-.067-.154-.1a8.34 8.34 0 01-.345-.258l-.05-.041c-1.171-.936-2.038-2.186-2.444-3.526-.379-1.23-.098-2.841.75-4.308a.452.452 0 00-.388-.682zM5.18 4.273a.458.458 0 00-.305.117c-.868.78-1.518 1.79-1.59 1.905C1.43 9 1.789 13.202 3.064 15.771c.025.053.052.105.078.156l.018.029c.023.051.05.105.059.115a.44.44 0 00.044.082c.021.044.043.083.082.15l.145.251c.022.034.043.07.05.082l.089.142.07.114a.985.985 0 00.058.081c.07.11.142.22.22.325l.01.013.029.039c.064.092.13.18.188.253l.26.329a.683.683 0 01.033.04l.037.043c.078.096.162.192.245.284l.038.041.246.265.082.078a4.506 4.506 0 00.24.24l.07.065a5.531 5.531 0 00.315.284c.083.075.167.146.252.215l.435.345.233.168c.028.022.058.043.088.063l.036.026.327.219c.119.078.238.15.383.237l.078.045c.09.053.183.106.27.153l.147.076c.063.034.13.07.233.12.009.006.082.041.09.045.104.051.208.1.34.158 0 .002.042.021.042.021a19.162 19.162 0 00.448.185c.11.043.225.085.32.119l.065.027a16.864 16.864 0 00.469.15l.09.029c.11.034.22.07.34.092.845.155 1.67.235 2.451.235h.002c6.51 0 8.585-5.24 8.606-5.293a.455.455 0 00-.788-.437c-1.671 2.2-4.823 3.017-8.43 2.187a4.829 4.829 0 01-.263-.072l-.17-.052a9.68 9.68 0 01-.343-.113l-.054-.02c-.099-.034-.198-.073-.285-.106l-.1-.04c-.11-.044-.22-.09-.327-.138l-.062-.027c-.096-.044-.188-.087-.28-.133a6.773 6.773 0 01-.297-.15l-.37-.2a1.272 1.272 0 00-.114-.067c-.112-.07-.228-.139-.341-.211-.027-.016-.05-.034-.094-.064a7.2 7.2 0 01-.267-.18l-.044-.032c-.076-.053-.151-.11-.213-.156-.04-.028-.078-.06-.142-.108-.057-.044-.114-.087-.167-.13l-.1-.081c-.083-.068-.161-.139-.243-.208a.231.231 0 00-.032-.027c-.09-.083-.183-.167-.293-.271l-.321-.32a9.505 9.505 0 01-.51-.565l-.191-.234a1.214 1.214 0 00-.078-.103c-.066-.089-.132-.176-.198-.268-1.768-2.436-2.23-7.521-.852-9.383a.454.454 0 00-.364-.725z"/></svg>',
    js: '<svg width="24" height="24"><path fill-rule="evenodd" d="M16.837 19c-1.463 0-2.418-.684-2.899-1.587a.064.064 0 01.025-.085l1.204-.697a.062.062 0 01.083.02c.34.537.785.926 1.553.926.665 0 1.09-.333 1.09-.792 0-.551-.436-.746-1.17-1.068l-.402-.172c-1.16-.493-1.929-1.113-1.929-2.422 0-1.205.919-2.123 2.353-2.123 1.002 0 1.728.342 2.253 1.232a.065.065 0 01-.02.086l-1.146.736a.063.063 0 01-.087-.022c-.266-.452-.559-.632-1-.632-.47 0-.769.299-.769.689 0 .482.299.677.987.976l.402.172c1.366.585 2.135 1.182 2.135 2.525 0 1.446-1.136 2.238-2.663 2.238zm-4.23-2.422c0 1.664-.976 2.422-2.4 2.422-1.256 0-1.998-.637-2.384-1.417a.064.064 0 01.024-.082l1.204-.729a.063.063 0 01.087.023c.24.423.474.77 1.001.77.528 0 .86-.206.86-1.01v-5.4c0-.035.03-.063.063-.063h1.482c.035 0 .063.028.063.062v5.424zM20.5 3h-17a.5.5 0 00-.5.5v17a.5.5 0 00.5.5h17a.5.5 0 00.5-.5v-17a.5.5 0 00-.5-.5z"/></svg>',
    jsOutline: '<svg width="24" height="24"><path fill-rule="evenodd" d="M3.5 20.5h17v-17h-17v17zM21.5 2h-19a.5.5 0 00-.5.5v19a.5.5 0 00.5.5h19a.5.5 0 00.5-.5v-19a.5.5 0 00-.5-.5zM9.708 18.5c1.423 0 2.399-.757 2.399-2.422v-5.423a.063.063 0 00-.063-.063h-1.482a.062.062 0 00-.062.063v5.4c0 .804-.333 1.01-.86 1.01-.529 0-.761-.347-1.002-.77a.063.063 0 00-.087-.023l-1.203.729a.064.064 0 00-.025.082c.386.78 1.128 1.417 2.385 1.417m6.595-1.423c-.768 0-1.212-.389-1.553-.925a.062.062 0 00-.083-.02l-1.257.727c.471.93 1.435 1.64 2.927 1.64 1.527 0 2.663-.79 2.663-2.237 0-1.343-.769-1.94-2.135-2.525l-.402-.172c-.688-.299-.987-.494-.987-.976 0-.39.299-.689.77-.689.44 0 .733.18 1 .632.017.03.057.041.086.022l1.146-.735a.065.065 0 00.02-.087c-.525-.89-1.251-1.232-2.253-1.232-1.434 0-2.353.918-2.353 2.124 0 1.308.77 1.928 1.929 2.421l.401.173c.735.32 1.171.516 1.171 1.067 0 .459-.425.792-1.09.792"/></svg>',
    medium: '<svg height="24" width="24"><path d="M13.435 12.025c0 3.416-2.75 6.185-6.142 6.185-3.393 0-6.143-2.769-6.143-6.185 0-3.415 2.75-6.184 6.143-6.184 3.392 0 6.142 2.769 6.142 6.184m6.738 0c0 3.216-1.375 5.822-3.071 5.822-1.696 0-3.071-2.606-3.071-5.822 0-3.215 1.375-5.821 3.07-5.821 1.697 0 3.072 2.606 3.072 5.821m2.756 0c0 2.881-.483 5.216-1.08 5.216-.596 0-1.08-2.335-1.08-5.216 0-2.88.484-5.215 1.08-5.215.597 0 1.08 2.335 1.08 5.215" fill-rule="evenodd"/></svg>',
    openSource: '<svg height="24" width="24"><path d="M11.289 2.025c-4.94.341-8.936 4.35-9.266 9.29a10 10 0 006.582 10.09.25.25 0 00.324-.165L11 14.292h.003a2.5 2.5 0 01-1.478-2.647 2.51 2.51 0 012.19-2.13 2.5 2.5 0 011.282 4.777H13l2.072 6.948a.25.25 0 00.323.166C19.246 20.016 22 16.33 22 12c0-5.758-4.866-10.38-10.711-9.975" fill-rule="evenodd"/></svg>',
    pdf: '<svg width="24" height="24"><path fill-rule="evenodd" d="M17.746 13.411c-1.217 0-2.343.167-2.794.22-1.405-1.35-2.698-3.542-2.698-3.542s.9-2.627.9-4.665c0-1.572-.488-2.924-2.093-2.924-.633 0-1.757.424-1.757 2.5 0 1.201.362 2.712 1.04 4.245-.62 1.743-1.181 3.429-2.755 6.408 0 0-5.37 1.899-5.37 4.347 0 .84.843 1.5 1.781 1.5 2.08 0 4.207-2.867 5.613-5.284 1.18-.393 3.035-.956 4.89-1.292 2.192 1.91 4.103 2.191 5.116 2.191 1.559 0 2.163-.84 2.163-1.638 0-1.18-1.226-2.066-4.036-2.066m2.227 1.873c0 .393-.369.715-.975.715-.92 0-2.551-.845-3.371-1.525 0 0 1.029-.165 2.246-.165 1.53 0 2.1.423 2.1.975m-8.95-11.772c.498 0 .613.806.613 1.312 0 1.286-.242 2.174-.636 3.298C10.583 7.01 10.34 5.964 10.34 5c0-.935.282-1.488.684-1.488m-.567 11.186c.45-.899 1.068-2.473 1.292-3.148.506.843 1.35 1.855 1.8 2.305 0 .056-1.744.394-3.092.843m-3.317 2.25c-1.293 2.135-2.642 3.485-3.372 3.485-.274 0-.527-.189-.527-.446 0-.88 1.789-2.177 3.9-3.04"/></svg>',
    react: '<svg width="24" height="24"><path fill-rule="evenodd" d="M18.619 14.968a19.68 19.68 0 00-1.026-2.972 19.677 19.677 0 001.026-2.971c2.135.779 3.38 1.896 3.38 2.971 0 1.075-1.245 2.192-3.38 2.972m-1.62 5.688c-.844.488-2.208.109-3.743-1.04a12.08 12.08 0 01-.513-.408c.697-.68 1.39-1.474 2.053-2.369a19.615 19.615 0 003.087-.597c.392 2.24.048 3.877-.883 4.414m-10 0c-.931-.537-1.275-2.175-.883-4.414.94.266 1.977.47 3.09.598a19.81 19.81 0 002.056 2.375C9.52 20.673 7.93 21.194 7 20.656m-5-8.66c0-1.075 1.246-2.192 3.381-2.971.24.946.582 1.945 1.027 2.971a19.654 19.654 0 00-1.027 2.972C3.246 14.188 2 13.07 2 11.996m5-8.66c.93-.538 2.521-.017 4.264 1.442-.7.68-1.394 1.477-2.06 2.375a19.604 19.604 0 00-3.087.597C5.725 5.51 6.07 3.874 7 3.336m9.33 6.16a25.336 25.336 0 00-.762-1.234c.76.119 1.464.274 2.107.458-.163.649-.38 1.336-.657 2.053-.213-.424-.442-.85-.688-1.277M12 5.443c.48.465.967.997 1.45 1.596a25.228 25.228 0 00-2.9 0c.482-.599.97-1.13 1.45-1.596m-5.018 5.33a17.585 17.585 0 01-.657-2.053 17.611 17.611 0 012.107-.458 25.143 25.143 0 00-1.45 2.51m1.45 4.958a17.611 17.611 0 01-2.107-.457c.163-.65.38-1.336.657-2.054a25.266 25.266 0 001.45 2.511m3.573 2.814a17.805 17.805 0 01-1.447-1.59 25.184 25.184 0 002.892 0 17.595 17.595 0 01-1.445 1.59m5.013-5.325c.277.718.494 1.405.657 2.054-.643.183-1.346.338-2.105.457a25.238 25.238 0 001.448-2.51m-1.554.776c-.393.68-.8 1.313-1.214 1.897-.713.067-1.464.103-2.25.103a24.25 24.25 0 01-2.246-.102A24.428 24.428 0 017.5 11.997c.3-.652.643-1.32 1.036-2.001.392-.68.8-1.312 1.213-1.897a24.354 24.354 0 014.5 0c.415.585.822 1.217 1.215 1.897.393.68.737 1.349 1.036 2-.3.651-.643 1.32-1.036 2m.692-10.867c.32 0 .604.068.844.207.931.538 1.275 2.175.883 4.414a19.647 19.647 0 00-3.087-.597 19.62 19.62 0 00-2.06-2.375c1.293-1.082 2.502-1.65 3.42-1.65M23 11.997c0-1.62-1.616-3.036-4.168-3.944.49-2.665.071-4.772-1.332-5.582-1.403-.81-3.438-.12-5.5 1.638C9.937 2.35 7.903 1.66 6.5 2.47c-1.403.81-1.822 2.917-1.332 5.582C2.616 8.96 1 10.376 1 11.996s1.616 3.037 4.168 3.945c-.49 2.664-.071 4.771 1.332 5.581.395.229.84.338 1.322.338 1.229 0 2.695-.711 4.176-1.972.22.188.439.365.66.53 1.28.958 2.48 1.448 3.501 1.448a2.64 2.64 0 001.34-.344c1.404-.81 1.823-2.917 1.333-5.581C21.384 15.033 23 13.616 23 11.996M14.004 12a2 2 0 11-4 0 2 2 0 014 0"/></svg>',
    sketch: '<svg width="24" height="24"><path fill-rule="evenodd" d="M17.1 4H6.9c-.25 0-.48.13-.62.33L2.82 9.52c-.19.28-.16.65.06.91l8.56 9.91c.3.35.84.35 1.14 0l8.56-9.91c.22-.26.24-.63.06-.91l-3.46-5.19A.83.83 0 0017.1 4zm-5.1.47L18 9H6l6-4.53zM12 20l-5.5-9h11L12 20z"/></svg>',
    stackoverflow: '<svg width="24" height="24"><path fill-rule="evenodd" d="M5.125 13.77c.207 0 .375.167.375.375v6.375h11v-6.375c0-.208.168-.375.375-.375h.75c.207 0 .375.167.375.375v7.5a.375.375 0 01-.375.375H4.375A.375.375 0 014 21.645v-7.5c0-.208.168-.375.375-.375h.75zm9.5 3.75c.207 0 .375.168.375.375v.75a.375.375 0 01-.375.375H7.352a.375.375 0 01-.375-.375v-.75c0-.207.168-.375.375-.375h7.273zm-7.02-2.978l7.243.668c.206.02.357.202.338.408l-.068.747a.375.375 0 01-.408.339l-7.243-.668a.375.375 0 01-.339-.408l.07-.747a.375.375 0 01.407-.339zm.7-3.474l7.024 1.889c.2.053.319.26.265.459l-.195.724a.375.375 0 01-.46.265l-7.023-1.888a.375.375 0 01-.265-.46l.195-.724c.054-.2.26-.318.46-.265zm1.736-3.803l6.265 3.695a.375.375 0 01.133.514l-.381.646a.375.375 0 01-.514.132L9.28 8.557a.375.375 0 01-.132-.513l.381-.646a.375.375 0 01.513-.133zM13.96 3.58l4.097 6.01a.375.375 0 01-.098.52l-.62.423a.375.375 0 01-.52-.099l-4.099-6.01a.375.375 0 01.099-.52l.62-.423a.375.375 0 01.52.099zm4.972-1.623l1.244 7.166a.375.375 0 01-.306.433l-.739.129a.375.375 0 01-.433-.306l-1.244-7.166a.375.375 0 01.306-.433l.739-.129a.375.375 0 01.433.306z"/></svg>',
    svelte: '<svg width="24" height="24"><path fill-rule="evenodd" d="M17.894 9.072a5.506 5.506 0 00-2.21-1.172 1 1 0 00-1.47-1.213L9.18 9.955a1 1 0 101.09 1.677l2.097-1.361a3.504 3.504 0 014.841 1.029 3.504 3.504 0 01-1.029 4.842l-5.032 3.267a3.48 3.48 0 01-2.634.489 3.478 3.478 0 01-2.208-1.518 3.528 3.528 0 01-.201-3.449 5.501 5.501 0 002.21 1.173.998.998 0 001.471 1.209l5.032-3.268a1 1 0 10-1.089-1.677l-2.097 1.361A3.504 3.504 0 016.791 12.7a3.504 3.504 0 011.03-4.842l5.031-3.267a3.477 3.477 0 012.634-.489 3.478 3.478 0 012.208 1.518 3.53 3.53 0 01.2 3.452M19.37 4.53a5.464 5.464 0 00-3.47-2.384 5.464 5.464 0 00-4.138.767L6.73 6.181a5.506 5.506 0 00-1.93 7.052 5.463 5.463 0 00-.172 6.236 5.465 5.465 0 003.47 2.385 5.462 5.462 0 004.14-.767l5.03-3.268a5.507 5.507 0 001.93-7.053 5.463 5.463 0 00.172-6.236"/></svg>',
    ts: '<svg width="24" height="24"><path fill-rule="evenodd" d="M16.837 19c-1.463 0-2.418-.684-2.899-1.587a.064.064 0 01.025-.085l1.204-.697a.062.062 0 01.083.021c.34.537.785.925 1.553.925.665 0 1.09-.333 1.09-.792 0-.551-.436-.746-1.17-1.067l-.402-.173c-1.16-.493-1.929-1.113-1.929-2.421 0-1.206.919-2.124 2.353-2.124 1.002 0 1.728.342 2.253 1.232a.065.065 0 01-.02.087l-1.146.735a.063.063 0 01-.087-.022c-.266-.452-.559-.631-1-.631-.47 0-.769.298-.769.688 0 .482.299.677.987.976l.402.172c1.366.585 2.135 1.182 2.135 2.525 0 1.446-1.136 2.238-2.663 2.238m-3.4-6.51H11.28v6.356a.062.062 0 01-.062.062H9.782a.063.063 0 01-.062-.062V12.49H7.562a.063.063 0 01-.062-.063v-1.272c0-.035.028-.063.062-.063h5.875c.035 0 .063.028.063.063v1.272a.062.062 0 01-.063.063M20.5 3h-17a.5.5 0 00-.5.5v17a.5.5 0 00.5.5h17a.5.5 0 00.5-.5v-17a.5.5 0 00-.5-.5"/></svg>',
    tsOutline: '<svg width="24" height="24"><path fill-rule="evenodd" d="M3.5 20.5h17v-17h-17v17zM21.5 2h-19a.5.5 0 00-.5.5v19a.5.5 0 00.5.5h19a.5.5 0 00.5-.5v-19a.5.5 0 00-.5-.5zm-5.197 15.077c-.768 0-1.212-.389-1.552-.925a.062.062 0 00-.084-.02l-1.204.696a.064.064 0 00-.024.085c.48.903 1.435 1.587 2.898 1.587 1.527 0 2.663-.792 2.663-2.238 0-1.343-.769-1.94-2.135-2.525l-.401-.172c-.69-.299-.988-.494-.988-.976 0-.39.299-.689.77-.689.44 0 .733.18 1 .632.017.03.057.041.087.022l1.145-.735a.065.065 0 00.02-.087c-.525-.89-1.251-1.232-2.252-1.232-1.435 0-2.354.918-2.354 2.124 0 1.308.77 1.928 1.929 2.421l.402.173c.734.32 1.17.516 1.17 1.067 0 .459-.424.792-1.09.792m-7.02 1.33h1.435a.062.062 0 00.062-.062V11.99h2.157a.063.063 0 00.063-.063v-1.273a.063.063 0 00-.063-.062H7.063a.062.062 0 00-.063.062v1.273c0 .035.028.063.063.063H9.22v6.355c0 .035.028.063.062.063"/></svg>',
    twitter: '<svg height="24" width="24"><path d="M22 5.923a8.208 8.208 0 01-2.358.647 4.114 4.114 0 001.805-2.27 8.24 8.24 0 01-2.607.995 4.103 4.103 0 00-6.99 3.742A11.65 11.65 0 013.392 4.75a4.087 4.087 0 00-.555 2.063c0 1.424.723 2.68 1.825 3.417a4.1 4.1 0 01-1.86-.514v.051a4.109 4.109 0 003.291 4.025 4.106 4.106 0 01-1.853.068 4.113 4.113 0 003.833 2.851 8.225 8.225 0 01-5.096 1.756c-.332 0-.657-.02-.977-.058a11.593 11.593 0 006.29 1.844c7.547 0 11.674-6.252 11.674-11.673 0-.178-.004-.357-.01-.532A8.341 8.341 0 0022 5.923z"/></svg>',
    vscode: '<svg width="24" height="24"><path fill-rule="evenodd" d="M10.574 12l6.39-4.968v9.938L10.574 12zM16.256 1.73L7.67 9.743 3.849 6.77a.5.5 0 00-.661.041L1.866 8.134a.5.5 0 00.012.72L5.251 12l-3.373 3.147a.5.5 0 00-.012.719l1.322 1.322a.5.5 0 00.66.041L7.67 14.26l8.586 8.013a.5.5 0 00.548.09l4.903-2.229a.5.5 0 00.293-.455V4.323a.5.5 0 00-.293-.455L16.804 1.64a.5.5 0 00-.548.089z"/></svg>',
    vue: '<svg width="24" height="24"><path fill-rule="evenodd" d="M14.08 3.257L12 7 9.92 3.257A.5.5 0 009.484 3H2.425a.25.25 0 00-.219.371l9.576 17.236a.25.25 0 00.437 0L21.796 3.37A.25.25 0 0021.577 3h-7.06a.5.5 0 00-.437.257"/></svg>',
    webComponents: '<svg width="24" height="24"><path fill-rule="evenodd" d="M18.655 4h-3.38a.5.5 0 00-.422.232L6.93 16.734 3.93 12l4.826-7.616A.25.25 0 008.546 4H5.344a.5.5 0 00-.422.232l-4.752 7.5a.499.499 0 000 .535l4.752 7.5a.5.5 0 00.422.233h3.38a.5.5 0 00.423-.233L17.07 7.266l3 4.734-4.826 7.616a.25.25 0 00.211.384h3.201a.5.5 0 00.423-.233l4.752-7.5a.5.5 0 000-.535l-4.752-7.5A.5.5 0 0018.655 4"/></svg>',
    wordpress: '<svg width="24" height="24"><path d="M12 2C6.478 2 2 6.478 2 12c0 5.523 4.478 10 10 10 5.523 0 10-4.477 10-10 0-5.522-4.477-10-10-10zm7.57 6.536c.003.08.015.148.015.232 0 .869-.163 1.847-.652 3.072l-2.49 7.198a8.27 8.27 0 01-1.695.82l-2.596-7.11-2.493 7.244a8.314 8.314 0 01-1.527-.619L4.289 8.851c.226-.551.508-1.072.84-1.557.085.002.181.004.256.004.897 0 2.286-.109 2.286-.109.463-.026.516.653.055.708 0 0-.465.054-.982.081l3.123 9.293 1.877-5.631-1.335-3.663c-.463-.026-.9-.08-.9-.08-.463-.028-.407-.735.054-.708 0 0 1.417.11 2.259.11.896 0 2.286-.11 2.286-.11.463-.026.516.653.054.708 0 0-.465.054-.981.081l3.1 9.222.857-2.862c.434-1.114.652-2.036.652-2.772 0-1.06-.38-1.794-.707-2.365-.435-.708-.844-1.305-.844-2.013 0-.707.483-1.366 1.193-1.495a8.38 8.38 0 012.138 2.843z"/></svg>',
    xd: '<svg width="24" height="24"><path fill-rule="evenodd" d="M18.707 15.575c0 .05-.028.094-.074.114-.253.111-1.138.456-2.378.456-1.741 0-3.201-.936-3.201-3.145 0-1.661 1.24-3.201 3.558-3.201.136 0 .268.005.396.015V7.391c0-.034.028-.062.063-.062h1.574c.034 0 .062.028.062.062v8.184zM12.056 16h-1.91a.125.125 0 01-.11-.066L8.475 13h-.017L6.9 15.934a.125.125 0 01-.11.066H5.063a.062.062 0 01-.054-.095L7.381 12 5.074 8.094A.063.063 0 015.128 8h1.808c.046 0 .089.026.11.067L8.6 11h.01l1.553-2.933a.125.125 0 01.11-.067h1.63c.049 0 .08.053.054.095l-2.293 3.784 2.445 4.026a.062.062 0 01-.053.095zm5.452-13h-11a3.5 3.5 0 00-3.5 3.5v11a3.5 3.5 0 003.5 3.5h11a3.5 3.5 0 003.5-3.5v-11a3.5 3.5 0 00-3.5-3.5zM14.79 13c0 .986.56 1.675 1.624 1.675.202 0 .403-.014.594-.07V11.27a1.851 1.851 0 00-.446-.054c-.776 0-1.772.437-1.772 1.784"/></svg>',
    arrowAngleDiagonalLeft: '<svg width="24" height="24"><path fill-rule="evenodd" d="M5.5 12a.5.5 0 01.5.5V18h5.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-7a.5.5 0 01-.5-.5v-7a.5.5 0 01.5-.5h1zm14-8a.5.5 0 01.5.5v7a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V6h-5.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h7z"/></svg>',
    arrowAngleDiagonalRight: '<svg width="24" height="24"><path fill-rule="evenodd" d="M18.5 12a.5.5 0 00-.5.5V18h-5.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h7a.5.5 0 00.5-.5v-7a.5.5 0 00-.5-.5h-1zm-14-8a.5.5 0 00-.5.5v7a.5.5 0 00.5.5h1a.5.5 0 00.5-.5V6h5.5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-7z"/></svg>',
    arrowAngleDown: '<svg height="24" width="24"><path d="M5.99 8.11l-.707.707a.5.5 0 000 .707l6.363 6.365a.5.5 0 00.707 0l6.364-6.364a.5.5 0 000-.707l-.707-.707a.5.5 0 00-.707 0L12 13.414 6.697 8.11a.5.5 0 00-.707 0" fill-rule="evenodd"/></svg>',
    arrowAngleDownLeft: '<svg width="24" height="24"><path fill-rule="evenodd" d="M8.5 7h-1a.5.5 0 00-.5.5v9a.5.5 0 00.5.5h9a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5H9V7.5a.5.5 0 00-.5-.5"/></svg>',
    arrowAngleDownRight: '<svg width="24" height="24"><path fill-rule="evenodd" d="M7 15.5v1a.5.5 0 00.5.5h9a.5.5 0 00.5-.5v-9a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5V15H7.5a.5.5 0 00-.5.5"/></svg>',
    arrowAngleLeft: '<svg height="24" width="24"><path d="M15.89 5.99l-.707-.707a.5.5 0 00-.707 0L8.11 11.646a.5.5 0 000 .707l6.364 6.364a.5.5 0 00.707 0l.707-.707a.5.5 0 000-.707L10.586 12l5.304-5.303a.5.5 0 000-.707" fill-rule="evenodd"/></svg>',
    arrowAngleMirroringHorizontal: '<svg height="24" width="24"><path d="M7.854 6.147a.5.5 0 01.707 0l.707.707a.5.5 0 010 .707L4.828 12l4.439 4.438a.5.5 0 010 .708l-.707.706a.5.5 0 01-.707 0l-5.5-5.499a.5.5 0 010-.707zm7.585 0a.5.5 0 01.707 0l5.5 5.5a.5.5 0 010 .707l-5.5 5.5a.5.5 0 01-.706 0l-.707-.707a.5.5 0 010-.708l4.439-4.438-4.44-4.44a.5.5 0 010-.708z" fill-rule="evenodd"/></svg>',
    arrowAngleMirroringVertical: '<svg height="24" width="24"><path d="M6.853 14.732a.5.5 0 01.708 0l4.44 4.44 4.438-4.439a.5.5 0 01.707 0l.707.707a.5.5 0 010 .707l-5.499 5.5a.5.5 0 01-.707 0l-5.5-5.5a.5.5 0 010-.708zm4.794-12.378a.5.5 0 01.707 0l5.5 5.5a.5.5 0 010 .707l-.707.707a.5.5 0 01-.708 0l-4.438-4.44-4.44 4.44a.5.5 0 01-.707 0l-.707-.706a.5.5 0 010-.707z" fill-rule="evenodd"/></svg>',
    arrowAngleRight: '<svg height="24" width="24"><path d="M8.11 18.01l.707.707a.5.5 0 00.707 0l6.365-6.363a.5.5 0 000-.707L9.525 5.283a.5.5 0 00-.707 0l-.707.707a.5.5 0 000 .707L13.414 12 8.11 17.303a.5.5 0 000 .707" fill-rule="evenodd"/></svg>',
    arrowAngleUp: '<svg height="24" width="24"><path d="M18.01 15.89l.707-.707a.5.5 0 000-.707L12.354 8.11a.5.5 0 00-.707 0l-6.364 6.364a.5.5 0 000 .707l.707.707a.5.5 0 00.707 0L12 10.586l5.303 5.304a.5.5 0 00.707 0" fill-rule="evenodd"/></svg>',
    arrowAngleUpLeft: '<svg width="24" height="24"><path fill-rule="evenodd" d="M17 8.5v-1a.5.5 0 00-.5-.5h-9a.5.5 0 00-.5.5v9a.5.5 0 00.5.5h1a.5.5 0 00.5-.5V9h7.5a.5.5 0 00.5-.5"/></svg>',
    arrowAngleUpRight: '<svg width="24" height="24"><path fill-rule="evenodd" d="M15.5 17h1a.5.5 0 00.5-.5v-9a.5.5 0 00-.5-.5h-9a.5.5 0 00-.5.5v1a.5.5 0 00.5.5H15v7.5a.5.5 0 00.5.5"/></svg>',
    arrowDown: '<svg height="24" width="24"><path d="M6.146 14.958l5.5 5.5a.5.5 0 00.707 0l5.5-5.501a.5.5 0 000-.707l-.707-.707a.5.5 0 00-.707 0L13 16.983V4.5a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5v12.484l-3.439-3.44a.5.5 0 00-.707 0l-.707.707a.5.5 0 000 .707" fill-rule="evenodd"/></svg>',
    arrowDownLeft: '<svg width="24" height="24"><path fill-rule="evenodd" d="M5.983 10.04v7.778a.5.5 0 00.5.5h7.779a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5H9.397l8.827-8.826a.5.5 0 000-.707l-.707-.707a.5.5 0 00-.707 0l-8.828 8.827v-4.864a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5"/></svg>',
    arrowDownRight: '<svg width="24" height="24"><path fill-rule="evenodd" d="M10.04 18.017h7.778a.5.5 0 00.5-.5V9.738a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5v4.865L7.493 5.776a.5.5 0 00-.707 0l-.707.707a.5.5 0 000 .707l8.827 8.828h-4.864a.5.5 0 00-.5.5v1a.5.5 0 00.5.5"/></svg>',
    arrowLeft: '<svg height="24" width="24"><path d="M9.042 6.146l-5.5 5.5a.5.5 0 000 .707l5.501 5.5a.5.5 0 00.707 0l.707-.707a.5.5 0 000-.707L7.017 13H19.5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5H7.016l3.44-3.439a.5.5 0 000-.707l-.707-.707a.5.5 0 00-.707 0" fill-rule="evenodd"/></svg>',
    arrowMirroringHorizontal: '<svg height="24" width="24"><path d="M8.56 16.65a.5.5 0 000-.707L5.62 13h12.76l-2.941 2.943a.5.5 0 000 .707l.708.707a.5.5 0 00.707 0l5-5.005a.5.5 0 000-.707l-5-5.002a.5.5 0 00-.707 0l-.707.707a.5.5 0 000 .707L18.382 11H5.62l2.94-2.943a.5.5 0 000-.708l-.707-.706a.5.5 0 00-.707 0l-5 5.005a.5.5 0 000 .706l5 5.003a.5.5 0 00.707 0z" fill-rule="evenodd"/></svg>',
    arrowMirroringVertical: '<svg height="24" width="24"><path d="M16.65 15.44a.5.5 0 00-.707 0L13 18.38V5.621l2.943 2.94a.5.5 0 00.707 0l.707-.708a.5.5 0 000-.707l-5.005-5a.5.5 0 00-.707 0l-5.002 5a.5.5 0 000 .707l.707.707a.5.5 0 00.707 0L11 5.618V18.38l-2.943-2.941a.5.5 0 00-.708 0l-.706.708a.5.5 0 000 .707l5.005 5a.5.5 0 00.707 0l5.002-5a.5.5 0 000-.707z" fill-rule="evenodd"/></svg>',
    arrowRight: '<svg height="24" width="24"><path d="M14.958 17.854l5.5-5.5a.5.5 0 000-.707l-5.501-5.5a.5.5 0 00-.707 0l-.707.707a.5.5 0 000 .707l3.44 3.44H4.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h12.484l-3.44 3.439a.5.5 0 000 .707l.707.707a.5.5 0 00.707 0" fill-rule="evenodd"/></svg>',
    arrowSwitchDiagonalLeft: '<svg width="24" height="24"><path fill-rule="evenodd" d="M2.353 16.076A1.033 1.033 0 003.416 17.1a1.138 1.138 0 001.104-1.067l.07-3.516 8.705 8.706c.415.415 1.102.401 1.533-.03.432-.432.446-1.119.03-1.534l-8.705-8.705 3.516-.07a1.138 1.138 0 001.067-1.104 1.033 1.033 0 00-1.024-1.063L3.58 8.84a1.137 1.137 0 00-1.105 1.105l-.122 6.132zm11.973-.831a1.04 1.04 0 01-.96-.512 1.082 1.082 0 01.02-1.104c.208-.343.582-.552.977-.545l3.507-.061-8.705-8.706c-.415-.415-.404-1.1.026-1.529.43-.43 1.114-.441 1.53-.026l8.705 8.705.06-3.507a1.128 1.128 0 011.1-1.061 1.037 1.037 0 011.062 1.024l-.106 6.117a1.128 1.128 0 01-1.1 1.099l-6.116.106z"/></svg>',
    arrowSwitchDiagonalRight: '<svg width="24" height="24"><path fill-rule="evenodd" d="M7.924 2.353A1.033 1.033 0 006.9 3.416 1.138 1.138 0 007.967 4.52l3.516.07-8.706 8.705c-.415.415-.401 1.102.03 1.533.432.432 1.119.446 1.534.03l8.705-8.705.07 3.516c.032.584.52 1.056 1.104 1.067a1.033 1.033 0 001.063-1.024L15.16 3.58a1.137 1.137 0 00-1.105-1.105l-6.132-.122zm.831 11.973a1.04 1.04 0 01.512-.96c.337-.195.76-.188 1.104.02.343.208.552.582.545.977l.061 3.507 8.706-8.705c.415-.415 1.1-.404 1.529.026.43.43.441 1.114.026 1.53l-8.705 8.705 3.507.06c.582.031 1.051.517 1.061 1.1a1.037 1.037 0 01-1.024 1.062l-6.117-.106a1.128 1.128 0 01-1.099-1.1l-.106-6.116z"/></svg>',
    arrowSwitchHorizontal: '<svg width="24" height="24"><path fill-rule="evenodd" d="M8.061 21.703a1.033 1.033 0 001.476-.027c.404-.42.416-1.1.026-1.535l-2.437-2.535h12.311c.587 0 1.063-.495 1.063-1.106 0-.61-.476-1.106-1.063-1.106H7.126l2.437-2.535a1.138 1.138 0 00-.026-1.535 1.033 1.033 0 00-1.476-.027l-4.25 4.422a1.137 1.137 0 000 1.562l4.25 4.422zm7.878-9.053a1.04 1.04 0 01-1.04.316c-.377-.1-.67-.404-.767-.794-.096-.39.021-.803.305-1.077l2.437-2.522H4.563c-.587 0-1.063-.493-1.063-1.1 0-.608.476-1.1 1.063-1.1h12.311L14.437 3.85a1.128 1.128 0 01.026-1.528 1.037 1.037 0 011.476-.027l4.25 4.4c.415.43.415 1.125 0 1.555l-4.25 4.4z"/></svg>',
    arrowSwitchVertical: '<svg width="24" height="24"><path fill-rule="evenodd" d="M2.297 8.061a1.033 1.033 0 00.027 1.476c.42.404 1.1.416 1.535.026l2.535-2.437v12.311c0 .587.495 1.063 1.106 1.063.61 0 1.106-.476 1.106-1.063V7.126l2.535 2.437c.435.39 1.114.378 1.535-.026a1.033 1.033 0 00.027-1.476l-4.422-4.25a1.137 1.137 0 00-1.562 0L2.297 8.06zm9.053 7.878a1.04 1.04 0 01-.316-1.04c.1-.377.404-.67.794-.767.39-.096.803.021 1.077.305l2.522 2.437V4.563c0-.587.493-1.063 1.1-1.063.608 0 1.1.476 1.1 1.063v12.311l2.523-2.437a1.128 1.128 0 011.528.026c.419.405.43 1.057.027 1.476l-4.4 4.25a1.128 1.128 0 01-1.555 0l-4.4-4.25z"/></svg>',
    arrowTriangleDown: '<svg height="24" width="24"><path d="M17.293 9H6.707a.5.5 0 00-.353.853l5.292 5.293a.5.5 0 00.708 0l5.292-5.293A.5.5 0 0017.293 9" fill-rule="evenodd"/></svg>',
    arrowTriangleDownLeft: '<svg width="24" height="24"><path fill-rule="evenodd" d="M16.339 15.633L8.853 8.148A.5.5 0 008 8.5v7.485a.5.5 0 00.5.5h7.485a.5.5 0 00.354-.853"/></svg>',
    arrowTriangleDownRight: '<svg width="24" height="24"><path fill-rule="evenodd" d="M15.633 8.147l-7.485 7.486a.5.5 0 00.353.853h7.485a.5.5 0 00.5-.5V8.501a.5.5 0 00-.853-.354"/></svg>',
    arrowTriangleLeft: '<svg height="24" width="24"><path d="M15 17.293V6.707a.5.5 0 00-.853-.353l-5.293 5.292a.5.5 0 000 .708l5.293 5.292a.5.5 0 00.853-.353" fill-rule="evenodd"/></svg>',
    arrowTriangleMirroringDiagonalLeft: '<svg width="24" height="24"><path fill-rule="evenodd" d="M6.843 14.329l7.485-7.486a.5.5 0 00-.353-.853H6.49a.5.5 0 00-.5.5v7.485a.5.5 0 00.853.354zm10.314-4.657l-7.485 7.485a.5.5 0 00.353.854h7.485a.5.5 0 00.5-.5v-7.486a.5.5 0 00-.853-.353z"/></svg>',
    arrowTriangleMirroringDiagonalRight: '<svg width="24" height="24"><path fill-rule="evenodd" d="M14.329 17.157L6.843 9.672a.5.5 0 00-.853.353v7.485a.5.5 0 00.5.5h7.485a.5.5 0 00.354-.853zM9.672 6.843l7.485 7.485a.5.5 0 00.853-.353V6.49a.5.5 0 00-.5-.5h-7.485a.5.5 0 00-.353.853z"/></svg>',
    arrowTriangleMirroringHorizontal: '<svg height="24" width="24"><path d="M9.147 6.354a.5.5 0 01.853.353v10.586a.5.5 0 01-.853.353l-5.293-5.292a.5.5 0 010-.707zM14 6.707a.5.5 0 01.854-.353l5.293 5.293a.5.5 0 010 .707l-5.293 5.293a.5.5 0 01-.854-.354z" fill-rule="evenodd"/></svg>',
    arrowTriangleMirroringVertical: '<svg height="24" width="24"><path d="M17.293 14a.5.5 0 01.354.854l-5.293 5.293a.5.5 0 01-.707 0l-5.293-5.293A.5.5 0 016.707 14zM11.646 3.854a.5.5 0 01.708 0l5.292 5.293a.5.5 0 01-.353.853H6.707a.5.5 0 01-.353-.853z" fill-rule="evenodd"/></svg>',
    arrowTriangleRight: '<svg height="24" width="24"><path d="M9 6.707v10.586a.5.5 0 00.853.353l5.293-5.292a.5.5 0 000-.708L9.853 6.354A.5.5 0 009 6.707" fill-rule="evenodd"/></svg>',
    arrowTriangleUp: '<svg width="24" height="24"><path fill-rule="evenodd" d="M21.5 7h-13a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h13a.5.5 0 01.5.5v1a.5.5 0 01-.5.5m0 6h-13a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h13a.5.5 0 01.5.5v1a.5.5 0 01-.5.5m0 6h-13a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h13a.5.5 0 01.5.5v1a.5.5 0 01-.5.5m-18.755-.814V5.808a.5.5 0 01.098-.297l.642-.87c.144-.195.377-.195.521 0l.642.87a.5.5 0 01.097.297v12.378a.5.5 0 01-.097.297l-.642.87c-.144.195-.377.195-.521 0l-.642-.87a.5.5 0 01-.098-.297z"/></svg>',
    arrowTriangleUpLeft: '<svg width="24" height="24"><path fill-rule="evenodd" d="M8.853 16.339l7.486-7.486A.5.5 0 0015.985 8H8.5a.5.5 0 00-.5.5v7.485a.5.5 0 00.853.354"/></svg>',
    arrowTriangleUpRight: '<svg width="24" height="24"><path fill-rule="evenodd" d="M8.147 8.853l7.486 7.486a.5.5 0 00.853-.354V8.5a.5.5 0 00-.5-.5H8.501a.5.5 0 00-.354.853"/></svg>',
    arrowUp: '<svg height="24" width="24"><path d="M17.854 9.042l-5.5-5.5a.5.5 0 00-.707 0l-5.5 5.501a.5.5 0 000 .707l.707.707a.5.5 0 00.707 0L11 7.017V19.5a.5.5 0 00.5.5h1a.5.5 0 00.5-.5V7.016l3.439 3.44a.5.5 0 00.707 0l.707-.707a.5.5 0 000-.707" fill-rule="evenodd"/></svg>',
    arrowUpLeft: '<svg width="24" height="24"><path fill-rule="evenodd" d="M13.96 5.983H6.181a.5.5 0 00-.5.5v7.779a.5.5 0 00.5.5h1a.5.5 0 00.5-.5V9.397l8.826 8.827a.5.5 0 00.707 0l.707-.707a.5.5 0 000-.707L9.095 7.982h4.864a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5"/></svg>',
    arrowUpRight: '<svg width="24" height="24"><path fill-rule="evenodd" d="M18.017 13.96V6.181a.5.5 0 00-.5-.5H9.738a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h4.865l-8.827 8.826a.5.5 0 000 .707l.707.707a.5.5 0 00.707 0l8.828-8.827v4.864a.5.5 0 00.5.5h1a.5.5 0 00.5-.5"/></svg>',
    checkmark: '<svg height="24" width="24"><path d="M9 16.17l-4.228-3.85a.5.5 0 00-.69.015l-.713.709a.5.5 0 00.011.72l5.258 4.899a.5.5 0 00.703-.02l11.322-11.88a.5.5 0 00-.008-.698l-.702-.702a.5.5 0 00-.716.01z" fill-rule="evenodd"/></svg>',
    crossmark: '<svg height="24" width="24"><path d="M18.718 5.99c.173.173.167.467 0 .695l-.071.082L13.415 12l5.232 5.233c.21.211.257.515.123.715l-.052.063-.707.707c-.174.174-.468.168-.696 0l-.082-.07-5.234-5.234-5.232 5.234c-.21.21-.514.257-.714.122l-.063-.052-.707-.707c-.174-.173-.168-.468 0-.696l.07-.082 5.233-5.234-5.233-5.23c-.21-.212-.257-.515-.122-.716l.052-.063.707-.707c.173-.173.468-.167.696 0l.082.071L12 10.584l5.233-5.231c.21-.21.514-.257.715-.122l.062.051z" fill-rule="evenodd"/></svg>',
    info: '<svg height="24" width="24"><path d="M12.5 10c.28 0 .5.22.5.5V19h2.5c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5h-7c-.28 0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5H11v-7H8.5c-.28 0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5zm-1-7a1.75 1.75 0 110 3.5 1.75 1.75 0 010-3.5z" fill-rule="evenodd"/></svg>',
    infoOval: '<svg width="24" height="24"><path fill-rule="evenodd" d="M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11C5.923 23 .998 18.075.998 12s4.925-11 11-11zm.749 8.811H8.971a.468.468 0 00-.472.472v.945c0 .264.208.472.472.472h2.361v6.611h-2.36a.468.468 0 00-.473.472v.945c0 .264.208.472.472.472h6.611a.468.468 0 00.473-.472v-.945a.468.468 0 00-.473-.472h-2.36v-8.028a.468.468 0 00-.473-.472zM11.805 3.2a1.653 1.653 0 100 3.305 1.653 1.653 0 000-3.305z"/></svg>',
    logout: '<svg width="24" height="24"><path fill-rule="evenodd" d="M12 1C9.043 1 6.34 2.145 4.358 4.06a1.1 1.1 0 101.53 1.58C7.466 4.115 9.607 3.2 12 3.2c4.873 0 8.8 3.927 8.8 8.8 0 4.873-3.927 8.8-8.8 8.8a8.843 8.843 0 01-6.115-2.446 1.1 1.1 0 10-1.521 1.59A11.045 11.045 0 0012 23c6.062 0 11-4.938 11-11S18.062 1 12 1zM5.418 8c-.288.01-.562.13-.763.34l-3.33 3.365a1.13 1.13 0 000 1.586l3.33 3.364c.278.293.692.411 1.08.309.39-.103.693-.41.795-.803a1.13 1.13 0 00-.306-1.092L4.79 13.62h10.085c.4.006.773-.207.975-.556.201-.35.201-.781 0-1.13a1.108 1.108 0 00-.975-.557H4.79l1.435-1.45a1.13 1.13 0 00.249-1.242A1.11 1.11 0 005.418 8z"/></svg>',
    logoutNew: '<svg width="24px" height="24px" viewBox="0 0 24 24"><g stroke="none" stroke-width="1" fill-rule="evenodd"><path d="M5.18421053,1 C3.43592026,1 2,2.43592026 2,4.18421053 L2,19.8157895 C2,21.5640797 3.43592026,23 5.18421053,23 L12.1315789,23 C13.8798692,23 15.3157895,21.5640797 15.3157895,19.8157895 L15.3157895,14.3157895 L13.5789474,14.3157895 L13.5789474,19.8157895 C13.5789474,20.6252887 12.9410782,21.2631579 12.1315789,21.2631579 L5.18421053,21.2631579 C4.37471126,21.2631579 3.73684211,20.6252887 3.73684211,19.8157895 L3.73684211,4.18421053 C3.73684211,3.37471132 4.37471126,2.73684211 5.18421053,2.73684211 L12.1315789,2.73684211 C12.9410782,2.73684211 13.5789474,3.37471132 13.5789474,4.18421053 L13.5789474,9.68421053 L15.3157895,9.68421053 L15.3157895,4.18421053 C15.3157895,2.43592026 13.8798692,1 12.1315789,1 L5.18421053,1 Z M17.9120066,7.06990132 C17.5584752,7.06990132 17.2402766,7.28435667 17.1073954,7.61196468 C16.9745142,7.93957269 17.0534721,8.31503261 17.3070517,8.56136932 L19.8772614,11.1315789 L6.92105263,11.1315789 C6.60786881,11.1271497 6.31656092,11.2916943 6.15867645,11.5622054 C6.00079198,11.8327164 6.00079198,12.1672836 6.15867645,12.4377946 C6.31656092,12.7083057 6.60786881,12.8728503 6.92105263,12.8684211 L19.8772614,12.8684211 L17.3070517,15.4386307 C17.0801932,15.656447 16.9888117,15.9798867 17.068149,16.2842127 C17.1474863,16.5885387 17.3851455,16.8261979 17.6894715,16.9055352 C17.9937975,16.9848726 18.3172372,16.893491 18.5350535,16.6666325 L22.5876851,12.6140009 C22.9266893,12.2748565 22.9266893,11.7251435 22.5876851,11.3859991 L18.5350535,7.33336753 C18.3715131,7.16495103 18.1467609,7.06990132 17.9120066,7.06990132 Z"></path></g></svg>',
    minus: '<svg height="24" width="24"><path d="M5.5 11h13a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-13a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5" fill-rule="evenodd"/></svg>',
    play: '<svg width="24" height="24"><path fill-rule="evenodd" d="M5 4.764v14.472a1.7 1.7 0 002.62 1.43l11.37-7.32a1.6 1.6 0 000-2.691L7.62 3.335A1.7 1.7 0 005 4.765z"/></svg>',
    playOutline: '<svg width="24" height="24"><path fill-rule="evenodd" d="M5 4.764v14.472a1.7 1.7 0 002.62 1.43l11.37-7.32a1.6 1.6 0 000-2.691L7.62 3.335A1.7 1.7 0 005 4.765zm2.723.804l9.433 5.931a.7.7 0 01-.011 1.192l-9.433 5.691a.7.7 0 01-1.061-.6V6.162a.7.7 0 011.072-.593z"/></svg>',
    plus: '<svg height="24" width="24"><path d="M18.5 11H13V5.5a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5V11H5.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5H11v5.5a.5.5 0 00.5.5h1a.5.5 0 00.5-.5V13h5.5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5" fill-rule="evenodd"/></svg>',
    questionMark: '<svg height="24" width="24"><path d="M13 17a.5.5 0 01.5.5v2a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-2a.5.5 0 01.5-.5zm-.775-13c2.602 0 4.38 1.639 4.38 4.138 0 1.454-.41 2.274-1.864 3.462-1.318 1.054-1.684 1.797-1.734 3.055a.358.358 0 01-.357.345h-1.292a.358.358 0 01-.358-.358c0-1.106.123-1.69.41-2.285.266-.614.696-1.147 1.331-1.638 1.291-1.024 1.516-1.557 1.516-2.5 0-1.413-1.192-2.273-2.134-2.273-1.431 0-2.309.865-2.44 2.581a.503.503 0 01-.5.471h-1.35a.5.5 0 01-.5-.539C7.566 5.72 9.434 4 12.226 4z" fill-rule="evenodd"/></svg>',
    questionMarkFill: '<svg width="24" height="24"><path fill-rule="evenodd" d="M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11C5.923 23 .998 18.075.998 12s4.925-11 11-11zm1 16h-2a.5.5 0 00-.5.5v2a.5.5 0 00.5.5h2a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5zm-.775-13c-2.791 0-4.66 1.719-4.891 4.46a.5.5 0 00.5.538h1.35a.503.503 0 00.498-.47c.132-1.717 1.01-2.582 2.441-2.582.942 0 2.134.86 2.134 2.274 0 .942-.225 1.475-1.516 2.499-.635.491-1.065 1.024-1.33 1.638-.288.595-.41 1.179-.41 2.285 0 .198.16.358.357.358h1.292a.358.358 0 00.357-.345c.05-1.258.416-2.001 1.734-3.055 1.455-1.188 1.865-2.008 1.865-3.462 0-2.5-1.78-4.138-4.38-4.138z"/></svg>',
    refresh: '<svg height="24" width="24"><path d="M17.82 7.517a.234.234 0 00-.334-.003L16.402 8.6a.233.233 0 00-.003.324c1.46 1.574 2.088 3.93 1.175 6.363a5.643 5.643 0 01-3.287 3.288c-5.034 1.889-9.747-2.821-7.863-7.855a5.652 5.652 0 013.309-3.3 6.384 6.384 0 012.73-.4l-1.527 1.387a.5.5 0 000 .707l.707.708a.5.5 0 00.707 0l3.536-3.536a.5.5 0 000-.707L12.35 2.042a.5.5 0 00-.707 0l-.69.69a.5.5 0 000 .707l1.754 1.593a8.443 8.443 0 00-3.551.464 7.662 7.662 0 00-4.726 4.851 8.042 8.042 0 0010.235 10.22 7.685 7.685 0 004.902-4.904c1.022-3.13.154-6.13-1.747-8.146" fill-rule="evenodd"/></svg>',
    reload: '<svg height="24" width="24"><path d="M19.48 12c.29 0 .52.245.502.533a7.977 7.977 0 01-2.955 5.695c-2.847 2.312-6.98 2.368-9.885.129a8.154 8.154 0 01-1.279-1.227l.114 2.377a.5.5 0 01-.5.5h-.975a.5.5 0 01-.5-.5v-5a.5.5 0 01.5-.5h5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5l-2.048-.097c.192.222.4.436.63.635 2.22 1.92 5.575 1.933 7.806.027a5.979 5.979 0 002.093-4.111.498.498 0 01.496-.461zm.019-8a.5.5 0 01.5.5v5a.5.5 0 01-.5.5h-5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5l2.058.099a6.076 6.076 0 00-.632-.64c-2.22-1.923-5.579-1.936-7.811-.027a5.98 5.98 0 00-2.091 4.116.498.498 0 01-.497.462H4.525a.501.501 0 01-.501-.533 7.974 7.974 0 012.938-5.689c2.843-2.321 6.982-2.387 9.892-.15.484.372.911.784 1.282 1.227L18.023 4.5a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    reset: '<svg width="24" height="24"><path fill-rule="evenodd" d="M11.999 1C5.941 1 1 5.94 1 11.999c0 6.061 4.941 10.999 10.999 10.999 5.546 0 10.153-4.135 10.893-9.492a1.268 1.268 0 10-2.512-.344A8.456 8.456 0 0112 20.46a8.441 8.441 0 01-8.46-8.461 8.443 8.443 0 018.46-8.46 8.465 8.465 0 016.716 3.304L17.208 8.35a.505.505 0 00-.106.503c.05.171.192.28.37.317 2.28.45 4.915.251 5.024.238a.518.518 0 00.29-.159c.077-.076.143-.152.16-.264.012-.11.21-2.767-.239-5.05a.468.468 0 00-.317-.37.511.511 0 00-.502.105l-1.375 1.375A11 11 0 0011.999 1z"/></svg>',
    shuffle: '<svg width="24" height="24"><path fill-rule="evenodd" d="M14.822 13.422L18 16.599V14a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v5.513a.5.5 0 01-.5.5H14a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h2.584l-3.177-3.177 1.415-1.414zM19.5 4a.5.5 0 01.5.5V10a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V7.416L5.742 19.672a.5.5 0 01-.707 0l-.707-.708a.5.5 0 010-.707L16.588 6H14a.5.5 0 01-.5-.5v-1A.5.5 0 0114 4h5.5zm-13.758.34L10.58 9.18l-1.414 1.414-4.837-4.838a.5.5 0 010-.707l.707-.707a.5.5 0 01.707 0z"/></svg>',
    shuffleAlt: '<svg width="24" height="24"><path fill-rule="evenodd" d="M18.318 13.111a.5.5 0 00-.707 0l-.707.707a.5.5 0 000 .707L18.379 16l-2.426.003A2.752 2.752 0 0113.7 14.83l-1.98-2.828 1.98-2.829A2.752 2.752 0 0115.953 8l2.426.003-1.475 1.475a.5.5 0 000 .707l.707.707a.5.5 0 00.707 0l3.536-3.535a.5.5 0 000-.707l-3.536-3.536a.5.5 0 00-.707 0l-.707.707a.5.5 0 000 .707L18.376 6h-2.423a4.753 4.753 0 00-3.892 2.027l-1.56 2.23-1.562-2.23A4.753 4.753 0 005.047 6H2v2h3.047c.897 0 1.74.439 2.253 1.173l1.98 2.829L7.3 14.83a2.753 2.753 0 01-2.253 1.173H2v2h3.047a4.753 4.753 0 003.892-2.027l1.561-2.23 1.561 2.23a4.753 4.753 0 003.892 2.027h2.423l-1.472 1.472a.5.5 0 000 .707l.707.707a.5.5 0 00.707 0l3.536-3.535a.5.5 0 000-.707l-3.536-3.536z"/></svg>',
    shuffleAlt2: '<svg width="24" height="24"><path fill-rule="evenodd" d="M18.201 13.027a.494.494 0 01.117.084l3.536 3.536a.5.5 0 010 .707l-3.536 3.535a.5.5 0 01-.707 0l-.707-.707a.5.5 0 010-.707l1.472-1.472h-2.423a4.753 4.753 0 01-3.892-2.027l-.34-.486 1.22-1.744.759 1.084a2.752 2.752 0 002.253 1.173L18.379 16l-1.475-1.475a.5.5 0 010-.707l.707-.707a.495.495 0 01.116-.084 2.567 2.567 0 00.474 0zm-.59-9.913a.5.5 0 01.707 0l3.536 3.536a.5.5 0 010 .707l-3.536 3.535a.5.5 0 01-.707 0l-.707-.707a.5.5 0 010-.707l1.475-1.475L15.953 8c-.897 0-1.74.439-2.253 1.173l-4.76 6.803a4.753 4.753 0 01-3.893 2.027H2v-2h3.047c.897 0 1.74-.439 2.253-1.173l4.761-6.803A4.754 4.754 0 0115.953 6h2.423l-1.472-1.471a.5.5 0 010-.708zM5.047 6c1.55 0 3.004.758 3.892 2.027l.34.486-1.22 1.745L7.3 9.173A2.752 2.752 0 005.047 8H2V6z"/></svg>',
    borderOpacity: '<svg height="24" width="24"><g fill="currentColor"><path d="M20.5 21a.5.5 0 01-.5-.5v-17a.5.5 0 011 0v17a.5.5 0 01-.5.5" opacity=".25"/><path d="M16.832 21h-1a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v17a.5.5 0 01-.5.5" opacity=".4"/><path d="M12.164 21h-2a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5h2a.5.5 0 01.5.5v17a.5.5 0 01-.5.5" opacity=".75"/><path d="M6.497 21H3.503a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5h2.994a.5.5 0 01.5.5v17a.5.5 0 01-.5.5"/></g></svg>',
    borderProps: '<svg height="24" width="24"><path d="M20.5 3c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5H5v15.5c0 .28-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5v-17c0-.28.22-.5.5-.5zm-12 16c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5zm4 0c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5zm4 0c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5zm4 0c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5zm0-4c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5zm0-4c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5zm0-4c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5z" fill-rule="evenodd"/></svg>',
    color: '<svg height="24" width="24"><path d="M12.7 15.24l3.11 5.38c.15.27.03.61-.25.72-1.1.43-2.3.66-3.56.66s-2.47-.24-3.57-.66a.507.507 0 01-.26-.72l3.11-5.38c.1-.17.29-.26.48-.25.08.01.16.01.24.01.07 0 .15 0 .22-.01.2-.02.38.08.48.25zm8.69-2.23c.3-.01.53.26.49.57a9.977 9.977 0 01-3.58 6.19c-.24.19-.6.13-.75-.14l-3.11-5.39c-.1-.17-.09-.37.02-.53.09-.13.18-.28.25-.42a.5.5 0 01.45-.28zM8.85 13c.19 0 .37.11.45.29.07.14.15.28.24.41.11.16.12.36.02.53l-3.11 5.39c-.15.27-.51.33-.75.14-.27-.22-.52-.45-.76-.69a9.98 9.98 0 01-2.81-5.49c-.05-.31.18-.58.49-.58zM6.44 4.38l3.11 5.39c.1.17.09.37-.02.53-.09.13-.17.27-.24.41-.08.18-.25.29-.44.29H2.62a.51.51 0 01-.5-.58 9.915 9.915 0 012.81-5.49c.24-.24.5-.47.76-.69.24-.19.6-.12.75.14zm11.86-.14c.27.22.52.45.76.69a9.98 9.98 0 012.81 5.49c.05.3-.19.58-.5.58h-6.23c-.18 0-.35-.11-.44-.28-.07-.15-.15-.29-.24-.42a.506.506 0 01-.02-.53l3.11-5.39c.15-.27.51-.33.75-.14zM12 2c1.26 0 2.47.24 3.57.66.29.11.41.46.26.72l-3.11 5.38c-.1.17-.29.26-.48.25C12.16 9 12.08 9 12 9s-.16 0-.25.01a.504.504 0 01-.48-.25l-3.1-5.38a.507.507 0 01.26-.72C9.53 2.24 10.74 2 12 2z" fill-rule="evenodd"/></svg>',
    colorAlt: '<svg height="24" width="24"><path d="M20.5 16l.027.04.194.29c.521.793 1.779 2.798 1.779 3.67 0 1.1-.9 2-2 2s-2-.9-2-2c0-.872 1.258-2.877 1.779-3.67l.194-.29.027-.04zM9.72 2.45c.2-.2.51-.2.71 0l10.32 10.32c.23.24.06.64-.27.64h-1.92l-7.07 7.07c-.78.78-2.05.78-2.83 0l-7.07-7.07c-.78-.78-.78-2.05 0-2.83zm.35 2.48L3 12h14.14z" fill-rule="evenodd"/></svg>',
    colorColored: '<svg height="24" width="24"><g fill="currentColor"><path d="M2.62 13h6.23c.19 0 .37.11.45.29.07.14.15.28.24.41.11.16.12.36.02.53l-3.11 5.39c-.15.27-.51.33-.75.14-.27-.22-.52-.45-.76-.69a9.98 9.98 0 01-2.81-5.49c-.05-.31.18-.58.49-.58z" opacity=".53"/><path d="M6.44 4.38l3.11 5.39c.1.17.09.37-.02.53-.09.13-.17.27-.24.41-.08.18-.25.29-.44.29H2.62a.51.51 0 01-.5-.58 9.915 9.915 0 012.81-5.49c.24-.24.5-.47.76-.69.24-.19.6-.12.75.14z" opacity=".422"/><path d="M21.88 13.58a9.977 9.977 0 01-3.58 6.19c-.24.19-.6.13-.75-.14l-3.11-5.39c-.1-.17-.09-.37.02-.53.09-.13.18-.28.25-.42a.5.5 0 01.45-.28h6.23c.3-.01.53.26.49.57z" opacity=".77"/><path d="M14.7 10.72c-.07-.15-.15-.29-.24-.42a.506.506 0 01-.02-.53l3.11-5.39c.15-.27.51-.33.75-.14.27.22.52.45.76.69a9.98 9.98 0 012.81 5.49c.05.3-.19.58-.5.58h-6.23c-.18 0-.35-.11-.44-.28z" opacity=".88"/><path d="M15.83 3.38l-3.11 5.38c-.1.17-.29.26-.48.25C12.16 9 12.08 9 12 9s-.16 0-.25.01a.504.504 0 01-.48-.25l-3.1-5.38a.507.507 0 01.26-.72C9.53 2.24 10.74 2 12 2c1.26 0 2.47.24 3.57.66.29.11.41.46.26.72z"/><path d="M8.17 20.62l3.11-5.38c.1-.17.29-.26.48-.25.08.01.16.01.24.01.07 0 .15 0 .22-.01.2-.02.38.08.48.25l3.11 5.38c.15.27.03.61-.25.72-1.1.43-2.3.66-3.56.66-1.26 0-2.47-.24-3.57-.66a.507.507 0 01-.26-.72z" opacity=".65"/></g></svg>',
    colorInvert: '<svg height="24" width="24"><path d="M12 2l.28.004C17.664 2.152 22 6.58 22 12c0 5.514-4.486 10-10 10S2 17.514 2 12 6.486 2 12 2zm0 1.991l.001 16.017c4.415 0 8.007-3.593 8.007-8.008 0-4.416-3.592-8.008-8.008-8.008z" fill-rule="evenodd"/></svg>',
    colorOpacity: '<svg width="24" height="24"><g fill-rule="evenodd" transform="translate(2 2)"><circle cx="6" cy="6" r="6" opacity=".25"/><circle cx="10" cy="10" r="6" opacity=".5"/><circle cx="14" cy="14" r="6"/></g></svg>',
    colorOutline: '<svg width="24" height="24"><defs><clipPath id="a"><path d="M17.24 13.41l1.91.62c-1.42 3.22-4.5 5.56-8.15 5.92v-2.01c2.77-.34 5.09-2.1 6.24-4.53zm-14.48 0A8.053 8.053 0 009 17.94v2.01c-3.65-.36-6.73-2.7-8.15-5.92zM16.65 2.55A9.938 9.938 0 0120 10.01c0 .73-.08 1.44-.23 2.12l-1.91-.62c.09-.49.14-.99.14-1.5 0-2.3-.97-4.37-2.53-5.83zm-13.3 0l1.18 1.63A7.955 7.955 0 002 10.01c0 .51.05 1.01.14 1.5l-1.91.62C.08 11.45 0 10.74 0 10.01c0-2.97 1.29-5.63 3.35-7.46zM9.99 0c1.84 0 3.56.5 5.04 1.37L13.85 3A7.929 7.929 0 0010 2.01c-1.4 0-2.71.36-3.85.99l-1.2-1.63C6.43.5 8.15 0 9.99 0z"/></clipPath></defs><g clip-path="url(#a)" transform="translate(2 2.02)"><path d="M0 0h20v19.95H0V0z"/></g></svg>',
    colorOutlineColored: '<svg width="24" height="24"><path d="M19.24 15.43c-1.15 2.43-3.47 4.19-6.24 4.53v2.01c3.65-.36 6.73-2.7 8.15-5.92l-1.91-.62z" opacity=".7"/><path d="M11 19.96a8.053 8.053 0 01-6.24-4.53l-1.91.62c1.42 3.22 4.5 5.56 8.15 5.92v-2.01z" opacity=".5"/><path d="M8.15 5.02c1.14-.63 2.45-.99 3.85-.99s2.71.36 3.85.99l1.18-1.63a9.908 9.908 0 00-5.04-1.37c-1.84 0-3.56.5-5.04 1.37l1.2 1.63z"/><path d="M18.65 4.57L17.47 6.2A7.955 7.955 0 0120 12.03c0 .51-.05 1.01-.14 1.5l1.91.62c.15-.68.23-1.39.23-2.12 0-2.97-1.29-5.63-3.35-7.46z" opacity=".85"/><path d="M4.14 13.53c-.09-.49-.14-.99-.14-1.5 0-2.3.97-4.37 2.53-5.83L5.35 4.57A9.938 9.938 0 002 12.03c0 .73.08 1.44.23 2.12l1.91-.62z" opacity=".42"/></svg>',
    colorShades: '<svg height="24" width="24"><g fill="currentColor"><path d="M7.983 5.084v13.83A8.002 8.002 0 014.001 12a8.002 8.002 0 013.982-6.915"/><path d="M11.978 4v16a7.964 7.964 0 01-3.995-1.086V5.084A7.964 7.964 0 0111.978 4" opacity=".75"/><path d="M15.97 5.057v13.885A7.94 7.94 0 0112 19.999h-.022V4h.023c1.445 0 2.8.385 3.97 1.058" opacity=".5"/><path d="M4 12c0 4.411 3.589 8 8 8s8-3.589 8-8-3.589-8-8-8-8 3.589-8 8zm-2 0C2 6.486 6.486 2 12 2s10 4.486 10 10-4.486 10-10 10S2 17.514 2 12z"/></g></svg>',
    alignCenter: '<svg height="24" width="24"><g fill-rule="evenodd"><path d="M3.502 7h17a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-17a.5.5 0 00-.5.5v1a.5.5 0 00.5.5"/><path d="M7.502 11h13a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-13a.5.5 0 00-.5.5v1a.5.5 0 00.5.5" opacity=".7"/><path d="M7.502 19h13a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-13a.5.5 0 00-.5.5v1a.5.5 0 00.5.5" opacity=".3"/><path d="M3.502 15h17a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-17a.5.5 0 00-.5.5v1a.5.5 0 00.5.5" opacity=".5"/></g></svg>',
    alignJustify: '<svg height="24" width="24"><g fill-rule="evenodd"><path d="M3.502 7h17a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-17a.5.5 0 00-.5.5v1a.5.5 0 00.5.5"/><path d="M5.5 11h13a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-13a.5.5 0 00-.5.5v1a.5.5 0 00.5.5" opacity=".7"/><path d="M5.5 19h13a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-13a.5.5 0 00-.5.5v1a.5.5 0 00.5.5" opacity=".3"/><path d="M3.502 15h17a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-17a.5.5 0 00-.5.5v1a.5.5 0 00.5.5" opacity=".5"/></g></svg>',
    alignLeft: '<svg height="24" width="24"><g fill-rule="evenodd"><path d="M20.5 7h-17a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h17a.5.5 0 01.5.5v1a.5.5 0 01-.5.5"/><path d="M16.5 11h-13a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h13a.5.5 0 01.5.5v1a.5.5 0 01-.5.5" opacity=".7"/><path d="M16.5 19h-13a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h13a.5.5 0 01.5.5v1a.5.5 0 01-.5.5" opacity=".3"/><path d="M20.5 15h-17a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h17a.5.5 0 01.5.5v1a.5.5 0 01-.5.5" opacity=".5"/></g></svg>',
    alignRight: '<svg height="24" width="24"><g fill-rule="evenodd"><path d="M3.5 7h17a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-17a.5.5 0 00-.5.5v1a.5.5 0 00.5.5"/><path d="M3.5 11h17a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-17a.5.5 0 00-.5.5v1a.5.5 0 00.5.5" opacity=".7"/><path d="M3.5 19h17a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-17a.5.5 0 00-.5.5v1a.5.5 0 00.5.5" opacity=".3"/><path d="M3.5 15h17a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-17a.5.5 0 00-.5.5v1a.5.5 0 00.5.5" opacity=".5"/></g></svg>',
    analytics: '<svg width="24" height="24"><path fill-rule="evenodd" d="M21 7a2 2 0 00-1.97 2.34l-3.343 2.785A2 2 0 0015 12a2 2 0 00-1.102.332l-2.904-1.453A2 2 0 007 11a2 2 0 00.006.129l-3.121 2.08a2 2 0 101.11 1.664l3.12-2.082A2 2 0 009 13a2 2 0 001.102-.332l2.904 1.453a2 2 0 103.965-.46l3.341-2.786A2 2 0 0021 11a2 2 0 100-4z"/></svg>',
    animations: '<svg height="24" width="24"><path d="M12.5 11a.5.5 0 01.5.5v9a.5.5 0 01-.5.5h-9a.5.5 0 01-.5-.5v-9a.5.5 0 01.5-.5zm4-4a.5.5 0 01.5.5v9a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V9H7.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm4 4a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm0-4a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm-4-4a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm4 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm-8 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    animationsAlt: '<svg height="24" width="24"><path d="M8 10a6.007 6.007 0 015.996 5.775L14 16c0 3.309-2.692 6-6 6-3.309 0-6-2.691-6-6 0-3.308 2.691-6 6-6zm4-4c3.308 0 6 2.692 6 6l-.006.263a5.998 5.998 0 01-2.551 4.647c.036-.299.057-.602.057-.91l-.009-.357a7.526 7.526 0 00-.196-1.38A3.974 3.974 0 0016 12c0-2.205-1.794-4-4-4-.84 0-1.62.261-2.263.705a7.49 7.49 0 00-2.647-.148A5.995 5.995 0 0112 6zm7.536 4.121l1.06 1.06a.5.5 0 010 .708l-1.06 1.06zM21.5 7a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm-1.61-3.596l.706.707a.5.5 0 010 .707l-.707.707a.5.5 0 01-.707 0l-.707-.707a.5.5 0 010-.707l.707-.707a.5.5 0 01.707 0zm-7.072 0l1.06 1.06H11.05l1.06-1.06a.5.5 0 01.708 0zM16.5 2a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    animationsAltOutline: '<svg height="24" width="24"><path d="M8 10c3.308 0 6 2.692 6 6 0 3.309-2.692 6-6 6s-6-2.691-6-6c0-3.308 2.692-6 6-6zm0 2c-2.206 0-4 1.795-4 4 0 2.206 1.794 4 4 4s4-1.794 4-4c0-2.205-1.794-4-4-4zm4-6c3.308 0 6 2.692 6 6a5.996 5.996 0 01-2.557 4.91 7.49 7.49 0 00-.148-2.646A3.975 3.975 0 0016 12c0-2.205-1.794-4-4-4-.84 0-1.62.262-2.263.705a7.494 7.494 0 00-2.647-.148A5.996 5.996 0 0112 6zm7.536 4.121l1.06 1.06a.5.5 0 010 .708l-1.06 1.06zM21.5 7a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm-1.61-3.596l.706.707a.5.5 0 010 .707l-.707.707a.5.5 0 01-.707 0l-.707-.707a.5.5 0 010-.707l.707-.707a.5.5 0 01.707 0zm-7.072 0l1.06 1.06H11.05l1.061-1.06a.5.5 0 01.707 0zM16.5 2a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    animationsOutline: '<svg height="24" width="24"><path d="M12.5 11a.5.5 0 01.5.5v9a.5.5 0 01-.5.5h-9a.5.5 0 01-.5-.5v-9a.5.5 0 01.5-.5zM11 13H5v6h6zm5.5-6a.5.5 0 01.5.5v9a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V9H7.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm4 4a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm0-4a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm-4-4a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm4 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm-8 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    blocks: '<svg width="24" height="24"><path d="M3.25 5.1c-.967 0-1.75.766-1.75 1.713v10.274c0 .947.783 1.713 1.75 1.713h17.5c.967 0 1.75-.766 1.75-1.713V6.813c0-.947-.783-1.713-1.75-1.713H3.25zm1.9 2.1h5.3a.5.5 0 01.5.5v3.2a.5.5 0 01-.5.5h-5.3a.5.5 0 01-.5-.5V7.7a.5.5 0 01.5-.5zm8.4 0h5.3a.5.5 0 01.5.5v3.2a.5.5 0 01-.5.5h-5.3a.5.5 0 01-.5-.5V7.7a.5.5 0 01.5-.5zm-8.4 5.25h5.3a.5.5 0 01.5.5v3.2a.5.5 0 01-.5.5h-5.3a.5.5 0 01-.5-.5v-3.2a.5.5 0 01.5-.5zm8.4 0h5.3a.5.5 0 01.5.5v3.2a.5.5 0 01-.5.5h-5.3a.5.5 0 01-.5-.5v-3.2a.5.5 0 01.5-.5z"/></svg>',
    blocksAlt: '<svg width="24" height="24"><path d="M3.25 3.5c-.967 0-1.75.766-1.75 1.713v10.274c0 .947.783 1.713 1.75 1.713h17.5c.967 0 1.75-.766 1.75-1.712V5.213c0-.947-.783-1.713-1.75-1.713H3.25zm1.4 2.1h6.3v4.2h-6.3V5.6zm8.4 0h6.3v4.2h-6.3V5.6zm-8.4 5.25h6.3v4.2h-6.3v-4.2zm8.4 0h6.3v4.2h-6.3v-4.2zM7.885 18.4c-.314-.005-.607.194-.766.52a1.236 1.236 0 000 1.06c.159.326.452.525.766.52h8.73c.314.005.607-.194.766-.52a1.236 1.236 0 000-1.06c-.159-.326-.452-.525-.766-.52h-8.73z"/></svg>',
    blocksAltOutline: '<svg width="24" height="24"><path d="M4 4c-1.097 0-2 .886-2 1.962v10.461c0 1.076.903 1.962 2 1.962h16c1.097 0 2-.886 2-1.962V5.962C22 4.886 21.097 4 20 4H4zm0 1.308h16c.375 0 .667.285.667.654v10.461a.652.652 0 01-.667.654H4a.652.652 0 01-.667-.654V5.962c0-.369.292-.654.667-.654zm1.333 1.307a.66.66 0 00-.666.654v2.616a.66.66 0 00.666.653h5.334a.66.66 0 00.666-.653V7.269a.66.66 0 00-.666-.654H5.333zm8 0a.66.66 0 00-.666.654v2.616a.66.66 0 00.666.653h5.334a.66.66 0 00.666-.653V7.269a.66.66 0 00-.666-.654h-5.334zM6 7.923h4v1.308H6V7.923zm8 0h4v1.308h-4V7.923zm-8.667 3.923a.66.66 0 00-.666.654v2.615a.66.66 0 00.666.654h5.334a.66.66 0 00.666-.654V12.5a.66.66 0 00-.666-.654H5.333zm8 0a.66.66 0 00-.666.654v2.615a.66.66 0 00.666.654h5.334a.66.66 0 00.666-.654V12.5a.66.66 0 00-.666-.654h-5.334zM6 13.154h4v1.308H6v-1.308zm8 0h4v1.308h-4v-1.308zm-6.667 6.538V21h9.334v-1.308H7.333z"/></svg>',
    blocksHalfOutline: '<svg width="24" height="24"><path d="M20 4.8c1.097 0 2 .886 2 1.962v10.461c0 1.076-.903 1.962-2 1.962H4c-1.097 0-2-.886-2-1.962V6.762C2 5.686 2.903 4.8 4 4.8zm0 1.308H4a.652.652 0 00-.667.654v10.461c0 .368.292.654.667.654h16a.652.652 0 00.667-.654V6.762A.652.652 0 0020 6.108zm-9.473 6.738c.335 0 .606.263.606.587v2.35a.597.597 0 01-.606.586H5.673a.597.597 0 01-.606-.587v-2.349c0-.324.271-.587.606-.587zm7.8 0c.335 0 .606.263.606.587v2.35a.597.597 0 01-.606.586h-4.854a.597.597 0 01-.606-.587v-2.349c0-.324.271-.587.606-.587zm-7.8-5.23c.335 0 .606.262.606.587v2.348a.597.597 0 01-.606.587H5.673a.597.597 0 01-.606-.587V8.203c0-.325.271-.588.606-.588zm7.8 0c.335 0 .606.262.606.587v2.348a.597.597 0 01-.606.587h-4.854a.597.597 0 01-.606-.587V8.203c0-.325.271-.588.606-.588z"/></svg>',
    blocksOutline: '<svg width="24" height="24"><path d="M20 4.8c1.097 0 2 .886 2 1.962v10.461c0 1.076-.903 1.962-2 1.962H4c-1.097 0-2-.886-2-1.962V6.762C2 5.686 2.903 4.8 4 4.8zm0 1.308H4a.652.652 0 00-.667.654v10.461c0 .368.292.654.667.654h16a.652.652 0 00.667-.654V6.762A.652.652 0 0020 6.108zm-9.333 6.538a.66.66 0 01.666.654v2.615a.66.66 0 01-.666.654H5.333a.66.66 0 01-.666-.654V13.3a.66.66 0 01.666-.654zm8 0a.66.66 0 01.666.654v2.615a.66.66 0 01-.666.654h-5.334a.66.66 0 01-.666-.654V13.3a.66.66 0 01.666-.654zM10 13.954H6v1.308h4v-1.308zm8 0h-4v1.308h4v-1.308zm-7.333-6.539a.66.66 0 01.666.654v2.616a.66.66 0 01-.666.653H5.333a.66.66 0 01-.666-.653V8.069a.66.66 0 01.666-.654zm8 0a.66.66 0 01.666.654v2.616a.66.66 0 01-.666.653h-5.334a.66.66 0 01-.666-.653V8.069a.66.66 0 01.666-.654zM10 8.723H6v1.308h4V8.723zm8 0h-4v1.308h4V8.723z"/></svg>',
    burgerMenu: '<svg height="24" width="24"><path d="M20.5 17c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5h-17c-.28 0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5zm0-6c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5h-17c-.28 0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5zm0-6c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5h-17c-.28 0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5z" fill-rule="evenodd"/></svg>',
    clock: '<svg height="24" width="24"><path d="M12.523 19.983c-4.823.309-8.815-3.684-8.506-8.507.254-3.97 3.471-7.195 7.441-7.458 2.403-.16 4.6.75 6.165 2.298L12 11.94 9.383 9.322a.5.5 0 00-.707 0l-.354.354a.5.5 0 000 .707l3.324 3.324a.5.5 0 00.707 0l6.237-6.236a7.965 7.965 0 011.386 5.155c-.302 3.937-3.512 7.105-7.453 7.357M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2m-.499 3.003h.994a.5.5 0 01.5.5v.994a.5.5 0 01-.5.5H11.5a.5.5 0 01-.5-.5v-.994a.5.5 0 01.5-.5m-.5 13.496v-.994a.5.5 0 01.5-.5h.994a.5.5 0 01.5.5v.994a.5.5 0 01-.5.5H11.5a.5.5 0 01-.5-.5m-6-6v-.995a.5.5 0 01.5-.5h.993a.5.5 0 01.5.5v.994a.5.5 0 01-.5.5H5.5a.5.5 0 01-.5-.5m13.496.5h-.994a.5.5 0 01-.5-.5v-.994a.5.5 0 01.5-.5h.994a.5.5 0 01.5.5v.994a.5.5 0 01-.5.5" fill-rule="evenodd"/></svg>',
    clockColored: '<svg width="24" height="24"><g fill-rule="evenodd"><path d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm5.623 4.316a7.975 7.975 0 00-6.165-2.298c-3.97.263-7.187 3.487-7.441 7.458-.31 4.823 3.683 8.816 8.506 8.507 3.94-.252 7.15-3.42 7.453-7.357a7.965 7.965 0 00-1.387-5.155z" opacity=".4"/><path d="M11.5 5.003h.995a.5.5 0 01.5.5v.994a.5.5 0 01-.5.5H11.5a.5.5 0 01-.5-.5v-.994a.5.5 0 01.5-.5M11 18.5v-.994a.5.5 0 01.5-.5h.994a.5.5 0 01.5.5v.994a.5.5 0 01-.5.5H11.5a.5.5 0 01-.5-.5M5 12.5v-.995a.5.5 0 01.5-.5h.994a.5.5 0 01.5.5v.994a.5.5 0 01-.5.5H5.5a.5.5 0 01-.5-.5m13.496.5h-.994a.5.5 0 01-.5-.5v-.994a.5.5 0 01.5-.5h.994a.5.5 0 01.5.5v.994a.5.5 0 01-.5.5" opacity=".55"/><path d="M17.623 6.316L12 11.94 9.382 9.322a.5.5 0 00-.707 0l-.353.354a.5.5 0 000 .707l3.324 3.324a.5.5 0 00.707 0l6.236-6.236-.966-1.155z"/></g></svg>',
    clockOutline: '<svg height="24" width="24"><path d="M12.998 19.936V18.5a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5v1.435A8.013 8.013 0 014.065 13h1.433a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5H4.065a8.013 8.013 0 016.933-6.935V5.5a.5.5 0 00.5.5h1a.5.5 0 00.5-.5V4.065a7.98 7.98 0 014.625 2.251L12 11.94 9.383 9.322a.5.5 0 00-.707 0l-.354.354a.5.5 0 000 .707l3.324 3.324a.5.5 0 00.707 0l6.237-6.236a7.949 7.949 0 011.345 3.53h-1.437a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1.437a8.013 8.013 0 01-6.937 6.935M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2" fill-rule="evenodd"/></svg>',
    clockOutlineColored: '<svg width="24" height="24"><g fill-rule="evenodd"><path d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm5.623 4.316a7.975 7.975 0 00-6.165-2.298c-3.97.263-7.187 3.487-7.441 7.458-.31 4.823 3.683 8.816 8.506 8.507 3.94-.252 7.15-3.42 7.453-7.357a7.965 7.965 0 00-1.387-5.155l-6.236 6.236a.5.5 0 01-.707 0l-3.324-3.324a.5.5 0 010-.707l.353-.354a.5.5 0 01.707 0L12 11.94z"/><path d="M11.5 5.003h.995a.5.5 0 01.5.5v.994a.5.5 0 01-.5.5H11.5a.5.5 0 01-.5-.5v-.994a.5.5 0 01.5-.5M11 18.5v-.994a.5.5 0 01.5-.5h.994a.5.5 0 01.5.5v.994a.5.5 0 01-.5.5H11.5a.5.5 0 01-.5-.5M5 12.5v-.995a.5.5 0 01.5-.5h.994a.5.5 0 01.5.5v.994a.5.5 0 01-.5.5H5.5a.5.5 0 01-.5-.5m13.496.5h-.994a.5.5 0 01-.5-.5v-.994a.5.5 0 01.5-.5h.994a.5.5 0 01.5.5v.994a.5.5 0 01-.5.5" opacity=".65"/></g></svg>',
    cloud: '<svg height="24" width="24"><path d="M18.393 8.5h-.417A5.998 5.998 0 0012 3a5.996 5.996 0 00-5.45 3.504c-.017 0-.033-.004-.05-.004a5.5 5.5 0 00-5.496 5.7c.105 2.981 2.645 5.3 5.628 5.3H18.5a4.5 4.5 0 004.497-4.664c-.087-2.439-2.165-4.336-4.605-4.336" fill-rule="evenodd"/></svg>',
    cloudOutline: '<svg height="24" width="24"><path d="M6.46 9a4.463 4.463 0 00-3.199 1.376 4.468 4.468 0 00-1.258 3.29C2.088 16.055 4.164 18 6.632 18H18.5c.958 0 1.853-.38 2.518-1.07a3.476 3.476 0 00.98-2.559c-.066-1.858-1.684-3.37-3.606-3.37h-1.338l-.076-.918C16.765 7.513 14.58 5.5 12 5.5a5.014 5.014 0 00-4.542 2.92l-.272.593zM18.5 20H6.632C3.1 20 .127 17.19.004 13.736a6.452 6.452 0 011.818-4.75A6.44 6.44 0 015.93 7.026 7.02 7.02 0 0112 3.5c3.304 0 6.149 2.36 6.837 5.518 2.787.221 5.06 2.506 5.16 5.283a5.46 5.46 0 01-1.54 4.018A5.454 5.454 0 0118.5 20z" fill-rule="evenodd"/></svg>',
    comments: '<svg height="24" width="24"><path d="M21.499 4a.5.5 0 01.5.5v15a.5.5 0 01-.5.5h-6.086l-3.06 2.854a.5.5 0 01-.708 0L8.585 20H2.5a.5.5 0 01-.5-.5v-15a.5.5 0 01.5-.5zm-1.5 2H4.001v12h5.412L12 20.38 14.585 18h5.414zm-3.5 7a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-9a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm-3-4a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-6a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    content: '<svg width="24" height="24"><path fill-rule="evenodd" d="M3 4v12h18V4H3zm4 3h10v2H7V7zm0 4h7v2H7v-2zm-5 7v2h20v-2H2z"/></svg>',
    copy: '<svg height="24" width="24"><path d="M4.5 9c.28 0 .5.22.5.5V19h9.5c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5h-11c-.28 0-.5-.22-.5-.5v-11c0-.28.22-.5.5-.5zm16-6c.28 0 .5.22.5.5v13c0 .28-.22.5-.5.5h-13c-.28 0-.5-.22-.5-.5v-13c0-.28.22-.5.5-.5z" fill-rule="evenodd"/></svg>',
    copyOutline: '<svg height="24" width="24"><path d="M4.5 9c.28 0 .5.22.5.5V19h9.5c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5h-11c-.28 0-.5-.22-.5-.5v-11c0-.28.22-.5.5-.5zm16-6c.28 0 .5.22.5.5v13c0 .28-.22.5-.5.5h-13c-.28 0-.5-.22-.5-.5v-13c0-.28.22-.5.5-.5zM19 5H9v10h10z" fill-rule="evenodd"/></svg>',
    copywriting: '<svg width="24" height="24"><path fill-rule="evenodd" d="M5.4 1c-1.21 0-2.2.99-2.2 2.2v17.6c0 1.21.99 2.2 2.2 2.2h13.2c1.21 0 2.2-.99 2.2-2.2V7.6L14.2 1H5.4zm7.7 1.65l6.05 6.05H13.1V2.65zm-2.802 8.263c.645 0 1.292.251 1.79.76.717.732 1.026 1.808 1.012 2.548-.019 1.01-.572 2.13-1.463 3.094.185.118.356.185.5.185.423 0 .706-.298 1.208-.928.452-.567 1.016-1.272 1.955-1.272.488 0 .92.323 1.057.793.132.438.605 1.407 1.143 1.407v2.2c-1.18 0-2.036-.741-2.587-1.568-.556.685-1.379 1.568-2.776 1.568-.785 0-1.567-.38-2.255-.973-1.01.595-2.174.973-3.382.973v-2.2c.678 0 1.354-.2 1.966-.513-.51-.884-.834-1.863-.864-2.748-.026-.753.204-1.824.933-2.578a2.445 2.445 0 011.763-.748zm.005 2.187c-.053 0-.107.007-.187.09-.19.197-.33.623-.318.971.017.48.177.984.412 1.45.424-.5.682-1.018.69-1.432.004-.231-.13-.708-.382-.965-.113-.115-.182-.114-.215-.114z"/></svg>',
    copywritingOutline: '<svg width="24" height="24"><path fill-rule="evenodd" d="M5.4 1c-1.204 0-2.2.996-2.2 2.2v17.6c0 1.204.996 2.2 2.2 2.2h13.2c1.204 0 2.2-.996 2.2-2.2V7.6L14.2 1H5.4zm0 2.2h7.7v5.5h5.5v12.1H5.4V3.2zm4.903 6.6c-.992 0-1.784.64-2.18 1.302a3.677 3.677 0 00-.523 2.037c.035.992.43 1.912.935 2.758-.326.152-.685.503-.935.503v2.2c.92 0 1.727-.368 2.47-.85.59.48 1.249.85 2.067.85 1.128 0 1.872-.633 2.398-1.199.079.161.067.315.2.47.371.435 1.017.729 1.665.729v-3.294-.006a1.1 1.1 0 00-1.1-1.1c-.66 0-1.139.37-1.435.668-.297.297-.501.589-.703.834-.403.49-.617.698-1.025.698-.039 0-.246-.211-.337-.251.719-.899 1.279-1.902 1.3-3.028v-.002c.012-.67-.171-1.342-.582-1.998-.411-.655-1.19-1.321-2.215-1.321zm0 2.2c.117 0 .194.042.35.29.156.248.25.675.247.79-.005.266-.387.741-.612 1.165-.176-.42-.476-.853-.488-1.184-.008-.217.079-.613.208-.829.13-.216.155-.232.295-.232z"/></svg>',
    customize: '<svg height="24" width="24"><path d="M15.515 21.827l2.323-2.851 3.675.151a.468.468 0 00.33-.818l-6.38-5.65a.468.468 0 00-.778.35v8.522c0 .44.552.637.83.296M2.499 9h1.634A4.003 4.003 0 008 12a4.003 4.003 0 003.868-3h9.632a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5H11.87a4.003 4.003 0 00-3.868-3 4.003 4.003 0 00-3.868 3H2.499a.5.5 0 00-.5.5v1a.5.5 0 00.5.5" fill-rule="evenodd"/></svg>',
    customizeOutline: '<svg height="24" width="24"><path d="M8.001 6c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2M2.5 9h1.634A4.004 4.004 0 008 12a4.003 4.003 0 003.868-3h9.632a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5H11.87c-.445-1.723-2.008-3-3.868-3S4.58 5.277 4.133 7H2.499a.5.5 0 00-.5.5v1a.5.5 0 00.5.5m13.016 12.827l2.323-2.851 3.675.151a.468.468 0 00.33-.818l-6.38-5.65a.468.468 0 00-.778.35v8.522c0 .44.552.637.83.296" fill-rule="evenodd"/></svg>',
    database: '<svg width="24" height="24"><path fill-rule="evenodd" d="M20.767 15.65c.625.329.933.709.933 1.147l.002.514c-1.842 1.06-5.35 2.35-9.702 2.35-4.427 0-7.985-1.12-9.8-2.189l.1.057v-.732c0-.422.285-.79.865-1.11l.066-.036c1.552.81 4.74 1.84 8.767 1.84 3.991 0 7.161-1.013 8.728-1.82zm-.025-5.655c.641.332.958.715.958 1.16l.001.2c-1.835 1.065-5.146 2.5-9.7 2.5-4.635 0-7.986-1.27-9.8-2.338l.098.056.001-.418c0-.415.275-.775.831-1.091l.124-.067c1.561.726 4.738 1.61 8.745 1.61 3.99 0 7.16-.878 8.726-1.603zM12 3.1c1.678 0 4.102.13 6.107.497 2.005.372 3.589.986 3.593 1.956l.002.17C19.86 6.778 16.355 7.9 12 7.9c-4.431 0-7.985-.946-9.8-2.015l.1.056v-.388c.004-1.901 6.094-2.432 9.495-2.452z"/></svg>',
    databaseOutline: '<svg width="24" height="24"><path fill-rule="evenodd" d="M21.254 15.969c.299.25.446.525.446.828l.002.514c-1.842 1.06-5.35 2.35-9.702 2.35-4.427 0-7.985-1.12-9.8-2.189l.1.057v-.732c0-.303.147-.578.444-.827 1.283.828 4.742 2.12 9.254 2.12 4.46 0 7.896-1.264 9.213-2.093zm-.146-5.755c.396.279.592.59.592.941l.001.2c-1.835 1.061-5.146 2.4-9.7 2.4-4.635 0-7.986-1.17-9.8-2.238l.098.056.001-.418c0-.35.196-.662.591-.94 1.391.751 4.762 1.792 9.11 1.792 4.342 0 7.712-1.04 9.102-1.79zM12 3.1c1.678 0 4.102.13 6.107.497 1.73.321 3.147.822 3.505 1.577C19.747 6.213 16.285 7.3 12 7.3c-4.431 0-7.985-.946-9.8-2.015l.123.07C2.743 3.578 8.763 3.1 12 3.1z"/></svg>',
    disabled: '<svg height="24" width="24"><path d="M4.002 12c0-1.845.63-3.545 1.683-4.9l11.218 11.217a7.96 7.96 0 01-4.9 1.683c-4.412 0-8-3.588-8-8m16 0c0 1.847-.631 3.547-1.686 4.903L7.1 5.685A7.958 7.958 0 0112.002 4c4.411 0 8 3.589 8 8m-8-10c-5.514 0-10 4.486-10 10s4.486 10 10 10 10-4.486 10-10-4.486-10-10-10" fill-rule="evenodd"/></svg>',
    discussion: '<svg height="24" width="24"><path d="M21.498 7a.5.5 0 01.5.5v13.54a.5.5 0 01-.812.391l-2.9-2.321a.5.5 0 00-.313-.11H7.5a.5.5 0 01-.5-.5V16h2v1h9.851l1.147.918V9H19V7zM16.5 2a.5.5 0 01.5.5v11a.5.5 0 01-.5.5H5.85l-3.036 2.431a.5.5 0 01-.812-.39V2.5a.5.5 0 01.5-.5zM15 4H4.002v8.919L5.149 12h9.85zm-2.677 3.184a.25.25 0 01.354 0l.64.64a.25.25 0 010 .354l-.638.638a.25.25 0 01-.354 0l-.64-.64a.25.25 0 010-.354zm-6.002 0a.25.25 0 01.354 0l.64.64a.25.25 0 010 .354l-.638.638a.25.25 0 01-.354 0l-.64-.64a.25.25 0 010-.354zm3.002 0a.25.25 0 01.354 0l.64.64a.25.25 0 010 .354l-.638.638a.25.25 0 01-.354 0l-.64-.64a.25.25 0 010-.354z" fill-rule="evenodd"/></svg>',
    discussionAlt: '<svg height="24" width="24"><path d="M21.498 9a.5.5 0 01.5.5v11.422a.5.5 0 01-.776.416L17.696 19H9.498a.5.5 0 01-.5-.5v-4.505h2V17H18.3l1.698 1.127V11h-2.99V9zm-7-7a.5.5 0 01.5.5v9a.5.5 0 01-.5.5H6.509l-3.748 2.323a.5.5 0 01-.763-.425V2.5a.5.5 0 01.5-.5zm-1.5 2h-9v7.204L5.94 10h7.058z" fill-rule="evenodd"/></svg>',
    document: '<svg height="24" width="24"><path d="M14.207 2a.5.5 0 01.353.146l5.295 5.293a.5.5 0 01.147.354V21.5a.5.5 0 01-.5.5H4.5a.5.5 0 01-.5-.5v-19a.5.5 0 01.5-.5zm-2.208 2H6v16h12.002V10h-5.503a.5.5 0 01-.5-.5zm3.5 12a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H8.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm-2-4a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H8.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm.5-7.587V8h3.588z"/></svg>',
    download: '<svg height="24" width="24"><path d="M13 6.5v-3c0-.28-.22-.5-.5-.5h-1c-.28 0-.5.22-.5.5v3zM12 21c3.14 0 5.72-2.42 5.97-5.5h.42c2.44 0 4.52-1.9 4.61-4.34a4.5 4.5 0 00-4.5-4.66H13v6.59l2.17-2.19c.2-.2.51-.2.71 0l.71.71c.2.2.2.51 0 .71l-4.24 4.24c-.2.2-.51.2-.71 0L7.4 12.32c-.2-.2-.2-.51 0-.71l.71-.71c.2-.2.51-.2.71 0L11 13.09V6.5H6.63C3.65 6.5 1.11 8.82 1 11.8c-.11 3.13 2.4 5.7 5.5 5.7h.05C7.5 19.56 9.58 21 12 21z" fill-rule="evenodd"/></svg>',
    downloadOutline: '<svg height="24" width="24"><path d="M8.5 5.501a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H6.624c-2.38 0-4.403 1.796-4.605 4.088a4.468 4.468 0 001.162 3.45A4.511 4.511 0 006.459 16.5l.73-.009.27.588a5.003 5.003 0 005.759 2.77c2.101-.526 3.592-2.4 3.77-4.558l.066-.79h1.344c1.855 0 3.43-1.397 3.587-3.18a3.477 3.477 0 00-.934-2.718c-.683-.727-1.662-1.103-2.66-1.103H15.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h2.883c1.537 0 3.035.59 4.095 1.703a5.456 5.456 0 011.5 4.294c-.235 2.662-2.454 4.777-5.141 4.986-.689 3.157-3.533 5.517-6.837 5.517a7.02 7.02 0 01-6.07-3.525 6.52 6.52 0 01-4.225-2.086 6.447 6.447 0 01-1.679-4.977C.32 8.098 3.217 5.501 6.624 5.501zM12.5 3a.5.5 0 01.5.5v8.878l2.182-2.182a.5.5 0 01.707 0l.707.707a.5.5 0 010 .707l-4.242 4.243a.5.5 0 01-.708 0L7.404 11.61a.5.5 0 010-.707l.707-.707a.5.5 0 01.707 0L11 12.38v-8.88a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    edit: '<svg height="24" width="24"><path d="M16.008 3.998A1 1 0 0117.42 4l2.595 2.599a1 1 0 01-.001 1.413L8.162 19.85a.5.5 0 01-.354.146l-3.303-.003a.5.5 0 01-.5-.5l.003-3.303a.5.5 0 01.146-.353zm-2.477 4.84l-7.85 7.838v1.643l1.642.001 7.85-7.839zm3.182-3.178l-1.998 1.995 1.642 1.644 1.998-1.995z" fill-rule="evenodd"/></svg>',
    editor: '<svg width="24" height="24"><path fill-rule="evenodd" d="M12.813 8.25h-2.625a.438.438 0 01-.438-.438V5.187c0-.241.196-.437.438-.437h2.625c.241 0 .437.196.437.437v2.625a.438.438 0 01-.437.438m8.312-2.75h-2.25a.375.375 0 01-.375-.375v-2.25c0-.207.168-.375.375-.375h2.25c.207 0 .375.168.375.375v2.25a.375.375 0 01-.375.375m-2.312 8.75h-2.625a.438.438 0 01-.438-.438v-2.625c0-.241.196-.437.438-.437h2.625c.241 0 .437.196.437.437v2.625a.438.438 0 01-.437.438M5.5 10h-3a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5h3a.5.5 0 01.5.5v3a.5.5 0 01-.5.5m0 6h-3a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5h3a.5.5 0 01.5.5v3a.5.5 0 01-.5.5m6 0h-3a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5h3a.5.5 0 01.5.5v3a.5.5 0 01-.5.5m-6 6h-3a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5h3a.5.5 0 01.5.5v3a.5.5 0 01-.5.5m6 0h-3a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5h3a.5.5 0 01.5.5v3a.5.5 0 01-.5.5m6 0h-3a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5h3a.5.5 0 01.5.5v3a.5.5 0 01-.5.5"/></svg>',
    editorOutline: '<svg width="24" height="24"><path fill-rule="evenodd" d="M6 8.5a.5.5 0 01.5.5v4h4a.5.5 0 01.5.5v4h4a.5.5 0 01.5.5v5a.5.5 0 01-.5.5H1a.5.5 0 01-.5-.5V9a.5.5 0 01.5-.5h5zM14 19h-3v3h3v-3zm-4.5 0h-3v3h3v-3zM5 19H2v3h3v-3zm0-4.5H2v3h3v-3zm4.5 0h-3v3h3v-3zm10.188-4.125c.241 0 .437.196.437.437v4.375a.437.437 0 01-.437.438h-4.375a.437.437 0 01-.438-.438v-4.375c0-.241.196-.437.438-.437h4.375zm-.875 1.312h-2.625v2.625h2.625v-2.625zM5 10H2v3h3v-3zm8.188-6.125c.241 0 .437.196.437.437v4.375a.437.437 0 01-.437.438H8.813a.437.437 0 01-.438-.438V4.312c0-.241.196-.437.438-.437h4.375zm-.875 1.312H9.688v2.625h2.625V5.187zM22.375 1.25c.207 0 .375.168.375.375v3.75a.375.375 0 01-.375.375h-3.75a.375.375 0 01-.375-.375v-3.75c0-.207.168-.375.375-.375zm-.75 1.125h-2.25v2.25h2.25v-2.25z"/></svg>',
    exclMark: '<svg height="24" width="24"><path d="M13 17a.5.5 0 01.5.5v2a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-2a.5.5 0 01.5-.5zm0-12.984a.5.5 0 01.5.5v3.952a.5.5 0 01-.002.048l-.578 6.032a.5.5 0 01-.497.452h-.833a.5.5 0 01-.498-.462l-.463-6.027-.001-.019V4.516a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    filter: '<svg height="24" width="24"><path d="M9 21.01v-8.24L2.92 3.93c-.23-.33.01-.78.41-.78H20.6a.5.5 0 01.43.75L16 12.73v6.02c0 .21-.13.39-.32.47l-6 2.26a.504.504 0 01-.68-.47zM5.62 4.85l5.08 7.39v7.04l3.6-1.36v-5.64l4.24-7.42H5.62z" fill-rule="evenodd"/></svg>',
    flow: '<svg width="24" height="24"><path fill-rule="evenodd" d="M6 3C4.355 3 3 4.355 3 6c0 1.293.843 2.395 2 2.813V13h2V8.812C8.157 8.396 9 7.293 9 6c0-1.645-1.355-3-3-3zm12 0a3 3 0 00-2.824 2H11v2h4.174A3 3 0 1018 3zM6 5c.564 0 1 .436 1 1 0 .564-.436 1-1 1-.564 0-1-.436-1-1 0-.564.436-1 1-1zm10.524 6v4.156l-2.239 2.383a1.088 1.088 0 000 1.47l2.525 2.686a.934.934 0 001.38 0l2.524-2.687a1.086 1.086 0 000-1.47l-2.238-2.382V11h-1.952zM4 15a1 1 0 00-1 1v4a1 1 0 001 1h4a1 1 0 001-1v-4a1 1 0 00-1-1H4z"/></svg>',
    fn: '<svg height="24" width="24"><path d="M18.677 18.757a.493.493 0 01-.43.243h-.781a.248.248 0 01-.219-.368c.63-1.15 1.003-2.58 1.003-4.131 0-1.551-.374-2.982-1.004-4.132a.248.248 0 01.22-.368h.781c.176 0 .342.09.43.242.672 1.171 1.073 2.65 1.073 4.258 0 1.607-.401 3.086-1.073 4.256zm-1.806-3.196a.5.5 0 010 .708l-.353.353a.5.5 0 01-.707 0l-1.061-1.06-1.06 1.06a.5.5 0 01-.708 0l-.353-.353a.5.5 0 010-.708l1.06-1.06-1.06-1.06a.5.5 0 010-.708l.353-.354a.5.5 0 01.707 0l1.061 1.061 1.06-1.06a.5.5 0 01.708 0l.353.353a.5.5 0 010 .707l-1.06 1.06zm-4.618 3.071a.248.248 0 01-.218.368h-.924a.25.25 0 01-.216-.12c-.715-1.19-1.145-2.715-1.145-4.38 0-1.607.401-3.086 1.074-4.257a.493.493 0 01.43-.242h.781c.19 0 .31.201.219.368-.63 1.15-1.004 2.58-1.004 4.132 0 1.55.373 2.981 1.003 4.131zM9.75 6.001a.5.5 0 01-.5.5H8.5a.75.75 0 00-.75.75V10h1a.5.5 0 01.5.5v.5a.5.5 0 01-.5.5h-1v5.25A2.25 2.25 0 015.5 19h-.75a.5.5 0 01-.5-.5V18a.5.5 0 01.5-.5h.75a.75.75 0 00.75-.75V11.5h-1a.5.5 0 01-.5-.5v-.5a.5.5 0 01.5-.5h1V7.25A2.25 2.25 0 018.5 5h.75a.5.5 0 01.5.5zM20.5 3h-17a.5.5 0 00-.5.5v17a.5.5 0 00.5.5h17a.5.5 0 00.5-.5v-17a.5.5 0 00-.5-.5z" fill-rule="evenodd"/></svg>',
    fnOutline: '<svg height="24" width="24"><path d="M8.5 4a.5.5 0 01.5.5V5a.5.5 0 01-.5.5h-1a.75.75 0 00-.75.75V10H8a.5.5 0 01.5.5v.5a.5.5 0 01-.5.5H6.75v6.25A2.25 2.25 0 014.5 20h-1a.5.5 0 01-.5-.5V19a.5.5 0 01.5-.5h1a.75.75 0 00.75-.75V11.5H4a.5.5 0 01-.5-.5v-.5A.5.5 0 014 10h1.25V6.25A2.25 2.25 0 017.5 4zm3.305 6c.185 0 .307.193.224.359C11.384 11.645 11 13.255 11 15c0 1.745.384 3.354 1.029 4.64a.248.248 0 01-.224.359h-.787a.495.495 0 01-.44-.262C9.903 18.436 9.5 16.79 9.5 15.001c0-1.79.403-3.436 1.078-4.739a.494.494 0 01.44-.262zm7.678 0c.183 0 .356.099.44.262C20.598 11.564 21 13.21 21 15c0 1.79-.403 3.436-1.077 4.738a.495.495 0 01-.44.262h-.787a.248.248 0 01-.224-.358C19.117 18.355 19.5 16.746 19.5 15c0-1.746-.383-3.355-1.028-4.641a.249.249 0 01.224-.359zm-6.177 2.702a.5.5 0 01.707 0l1.237 1.237 1.238-1.237a.5.5 0 01.707 0l.354.353a.5.5 0 010 .708L16.31 15l1.238 1.238a.5.5 0 010 .707l-.354.353a.5.5 0 01-.707 0l-1.238-1.237-1.237 1.237a.5.5 0 01-.707 0l-.354-.353a.5.5 0 010-.707L14.19 15l-1.238-1.237a.5.5 0 010-.708z" fill-rule="evenodd"/></svg>',
    folder: '<svg width="24" height="24"><path fill-rule="evenodd" d="M22.8 5.46H12L9.84 3.3H1.2v17.28h21.6z"/></svg>',
    folderOutline: '<svg width="24" height="24"><path fill-rule="evenodd" d="M22.8 5.46H12L9.84 3.3H1.2v17.28h21.6V5.46zm-2.16 12.96H3.36V7.62h17.28v10.8z"/></svg>',
    fullscreen: '<svg width="24" height="24"><path fill-rule="evenodd" d="M2.5 2.5v6.333h2.111V4.611h4.222V2.5H2.5zm12.667 0v2.111h4.222v4.222H21.5V2.5h-6.333zM2.5 15.167V21.5h6.333v-2.111H4.611v-4.222H2.5zm16.889 0v4.222h-4.222V21.5H21.5v-6.333h-2.111z"/></svg>',
    fullscreenExit: '<svg width="24" height="24"><path fill-rule="evenodd" d="M9.5 14.35l.15.15V22l-.15.15H7.833l-.15-.15v-5.684H2l-.15-.15V14.5l.15-.15h7.5zm12.5 0l.15.15v1.667l-.15.15-5.684-.001V22l-.15.15H14.5l-.15-.15v-7.5l.15-.15H22zM9.5 1.85l.15.15v7.5l-.15.15H2l-.15-.15V7.833l.15-.15h5.683V2l.15-.15H9.5zm6.667 0l.15.15-.001 5.683H22l.15.15V9.5l-.15.15h-7.5l-.15-.15V2l.15-.15h1.667z"/></svg>',
    fuse: '<svg width="24" height="24"><path fill-rule="evenodd" d="M11 1v2.205c-.49.164-.934.403-1.248.756A3.05 3.05 0 009 6c0 .435.272.82.453 1.229C8.101 7.518 7 8.568 7 10c0 1.645 1.355 3 3 3h4c.565 0 1 .435 1 1s-.435 1-1 1h-2c-.917 0-1.731.38-2.248.96A3.05 3.05 0 009 18c0 .722.235 1.458.752 2.04.314.352.758.59 1.248.755V23h2v-2.205c.49-.164.934-.403 1.248-.756A3.05 3.05 0 0015 18c0-.435-.272-.82-.453-1.229C15.899 16.482 17 15.432 17 14c0-1.645-1.355-3-3-3h-4c-.565 0-1-.435-1-1s.435-1 1-1h2c.917 0 1.731-.38 2.248-.96A3.05 3.05 0 0015 6a3.05 3.05 0 00-.752-2.04c-.314-.352-.758-.59-1.248-.755V1h-2zm1 4c.417 0 .602.12.752.29.15.168.248.432.248.71 0 .278-.098.542-.248.71-.15.17-.335.29-.752.29s-.602-.12-.752-.29A1.095 1.095 0 0111 6c0-.278.098-.542.248-.71.15-.17.335-.29.752-.29zm0 12c.417 0 .602.12.752.29.15.168.248.432.248.71 0 .278-.098.542-.248.71-.15.17-.335.29-.752.29s-.602-.12-.752-.29A1.095 1.095 0 0111 18c0-.278.098-.542.248-.71.15-.17.335-.29.752-.29z"/></svg>',
    globeOutline: '<svg width="24" height="24"><path fill-rule="evenodd" d="M12 1C5.938 1 1 5.938 1 12s4.938 11 11 11 11-4.938 11-11S18.062 1 12 1zm0 2.2c.273 0 .572.112.954.475.381.363.796.971 1.151 1.772.271.61.493 1.354.684 2.153H9.21c.19-.799.413-1.543.684-2.153.355-.8.77-1.41 1.151-1.772.382-.363.68-.475.954-.475zm-3.904.917c-.071.144-.145.285-.212.437-.398.895-.707 1.93-.94 3.046H4.38a8.79 8.79 0 013.717-3.483zm7.808 0A8.79 8.79 0 0119.62 7.6h-2.566c-.232-1.115-.54-2.151-.939-3.046-.067-.152-.14-.293-.212-.437zM3.488 9.8h3.12A23.256 23.256 0 006.5 12c0 .755.04 1.488.107 2.2h-3.12A8.83 8.83 0 013.2 12c0-.762.107-1.496.288-2.2zm5.34 0h6.343c.077.707.129 1.437.129 2.2 0 .763-.052 1.493-.129 2.2H8.83A20.318 20.318 0 018.7 12c0-.763.052-1.493.129-2.2zm8.565 0h3.12A8.83 8.83 0 0120.8 12a8.83 8.83 0 01-.288 2.2h-3.12c.068-.712.108-1.445.108-2.2 0-.755-.04-1.488-.107-2.2zM4.379 16.4h2.566c.232 1.115.54 2.151.939 3.046.067.152.14.293.212.437A8.79 8.79 0 014.38 16.4zm4.832 0h5.578c-.19.799-.413 1.543-.684 2.153-.355.8-.77 1.41-1.151 1.772-.382.363-.68.475-.954.475-.273 0-.572-.112-.954-.475-.381-.363-.796-.971-1.151-1.772-.271-.61-.493-1.354-.684-2.153zm7.844 0h2.566a8.79 8.79 0 01-3.717 3.483c.071-.144.145-.285.212-.437.398-.895.707-1.93.94-3.046z"/></svg>',
    icons: '<svg height="24" width="24"><path d="M14.58 11.12c.2-.29.64-.29.83 0l6.07 9.1c.22.33-.02.78-.42.78H2.93a.5.5 0 01-.41-.78l3.57-5.35c.2-.3.63-.3.83 0l2.58 3.88zM6.5 3.5a3 3 0 110 6 3 3 0 010-6z" fill-rule="evenodd"/></svg>',
    iconsBold: '<svg height="24" width="24"><path d="M14.58 11.12c.2-.29.64-.29.83 0l6.07 9.1c.22.33-.02.78-.42.78H2.93a.5.5 0 01-.41-.78l3.57-5.35c.2-.3.63-.3.83 0l2.58 3.88zM6.75 3.5a3.25 3.25 0 110 6.5 3.25 3.25 0 010-6.5z" fill-rule="evenodd"/></svg>',
    iconsColored: '<svg height="24" width="24"><g fill="currentColor" transform="translate(2.435 3.5)"><path d="M12.145 7.62l-5.08 7.63-2.58-3.88c-.2-.3-.63-.3-.83 0l-3.57 5.35a.5.5 0 00.41.78h18.13c.4 0 .64-.45.42-.78l-6.07-9.1a.505.505 0 00-.83 0z" opacity=".4"/><circle cx="4.065" cy="3" r="3"/></g></svg>',
    iconsOutline: '<svg height="24" width="24"><path d="M14.39 9.76l7.49 10.16a.67.67 0 01-.53 1.08H2.64c-.56 0-.88-.64-.54-1.09l5.49-7.14c.2-.26.59-.26.79 0l1.52 1.98 3.68-4.99c.2-.27.61-.27.81 0zM14 12.08l-3.66 4.96c-.2.27-.6.27-.8.01L8 15.04 4.73 19.3h14.59zM7 2.75c2.07 0 3.75 1.68 3.75 3.75S9.07 10.25 7 10.25 3.25 8.57 3.25 6.5 4.93 2.75 7 2.75zM7 4.5c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" fill-rule="evenodd"/></svg>',
    iconsOutlineColored: '<svg width="24" height="24"><path d="M7 4.5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0-1.75c-2.07 0-3.75 1.68-3.75 3.75 0 2.07 1.68 3.75 3.75 3.75 2.07 0 3.75-1.68 3.75-3.75 0-2.07-1.68-3.75-3.75-3.75z" opacity=".9"/><path d="M21.35 21H2.64c-.56 0-.88-.64-.54-1.09l5.49-7.14c.2-.26.59-.26.79 0l1.52 1.98 3.68-4.99c.2-.27.61-.27.81 0l7.49 10.16a.67.67 0 01-.53 1.08zM4.73 19.3h14.59L14 12.08l-3.66 4.96c-.2.27-.6.27-.8.01L8 15.04 4.73 19.3z" opacity=".5"/></svg>',
    images: '<svg height="16" width="16"><path d="M10.067 7.3a.4.4 0 01.666 0l4.852 7.278a.4.4 0 01-.332.622H.747a.4.4 0 01-.332-.622L3.267 10.3a.4.4 0 01.666 0L6 13.4zM3.6 1.2a2.4 2.4 0 110 4.8 2.4 2.4 0 010-4.8z" fill-rule="evenodd"/></svg>',
    install: '<svg width="24" height="24"><path fill-rule="evenodd" d="M13 4.5v7.88l2.182-2.184a.5.5 0 01.707 0l.707.707a.5.5 0 010 .707l-4.243 4.243a.5.5 0 01-.707 0L7.404 11.61a.5.5 0 010-.707l.707-.707a.5.5 0 01.707 0L11 12.38V4.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5M20.502 20H3.499a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h17.003a.5.5 0 01.5.5v1a.5.5 0 01-.5.5"/></svg>',
    installAlt: '<svg width="24" height="24"><path fill-rule="evenodd" d="M5.533 15a.5.5 0 01.5.5V18H18v-2.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v4a.5.5 0 01-.5.5H4.533a.5.5 0 01-.5-.5v-4a.5.5 0 01.5-.5h1zM12.5 4a.5.5 0 01.5.5v7.88l2.182-2.184a.5.5 0 01.707 0l.707.707a.5.5 0 010 .707l-4.242 4.243a.5.5 0 01-.708 0L7.404 11.61a.5.5 0 010-.707l.707-.707a.5.5 0 01.707 0L11 12.38V4.5a.5.5 0 01.5-.5h1z"/></svg>',
    key: '<svg width="24" height="24"><path fill-rule="evenodd" d="M7.417 6a6.417 6.417 0 106.148 8.25H17.5V17h3.667v-2.75H23v-3.667h-9.435A6.417 6.417 0 007.417 6zm0 3.667a2.75 2.75 0 110 5.5 2.75 2.75 0 010-5.5z"/></svg>',
    keyOutline: '<svg width="24" height="24"><path fill-rule="evenodd" d="M7.417 6C3.892 6 1 8.892 1 12.417s2.892 6.416 6.417 6.416c2.543 0 4.665-1.545 5.749-3.666h2.5v2.75h5.5v-2.75H23v-5.5h-9.82C12.158 7.536 10.02 6 7.417 6zm0 1.833c2.09 0 3.751 1.303 4.36 3.051l.212.616h9.178v1.833h-1.834v2.75H17.5v-2.75h-5.484l-.227.582C11.093 15.695 9.4 17 7.417 17a4.591 4.591 0 01-4.584-4.583 4.591 4.591 0 014.584-4.584zm0 1.834a2.764 2.764 0 00-2.75 2.75 2.764 2.764 0 002.75 2.75 2.764 2.764 0 002.75-2.75 2.764 2.764 0 00-2.75-2.75zm0 1.833c.517 0 .916.4.916.917s-.4.916-.916.916a.903.903 0 01-.917-.916c0-.517.4-.917.917-.917z"/></svg>',
    layers: '<svg height="24" width="24"><path d="M12.103 19.821l.017.005a.785.785 0 01.231.073l1.03.511c.378.188.39.722.02.926l-1.021.565a.785.785 0 01-.117.053l.092-.044a.75.75 0 01-.727 0l-1.038-.574a.523.523 0 01.02-.926l1.046-.52a.75.75 0 01.447-.069zm4.774-2.295l.91.505a.5.5 0 010 .875l-.91.504a.75.75 0 01-.727 0l-.91-.504a.5.5 0 010-.875l.91-.505a.75.75 0 01.727 0zm-9.035 0l.91.505a.5.5 0 010 .875l-.91.504a.75.75 0 01-.728 0l-.91-.504a.5.5 0 010-.875l.91-.505a.75.75 0 01.728 0zm-5.217-6.482a.75.75 0 01.728 0L12 15.846l8.648-4.8a.75.75 0 01.728 0l1.11.616a.375.375 0 010 .656L12.365 17.93a.75.75 0 01-.728 0L1.513 12.317a.375.375 0 010-.656zm18.76 3.98l.911.504a.5.5 0 010 .875l-.91.504a.75.75 0 01-.728 0l-.91-.504a.5.5 0 010-.875l.91-.505a.75.75 0 01.728 0zm-18.052 0l.91.504a.5.5 0 010 .875l-.91.504a.75.75 0 01-.727 0l-.91-.504a.5.5 0 010-.875l.91-.505a.75.75 0 01.727 0zm9.03-12.93l9.927 5.505a.5.5 0 010 .874l-9.926 5.505a.75.75 0 01-.728 0L1.71 8.473a.5.5 0 010-.874l9.926-5.505a.75.75 0 01.728 0z" fill-rule="evenodd"/></svg>',
    layersOutline: '<svg height="24" width="24"><path d="M12.28 19.821l.016.005a.786.786 0 01.231.072l1.03.512c.378.188.39.722.02.926l-1.02.565a.786.786 0 01-.118.053l.092-.044a.75.75 0 01-.726 0l-1.039-.574a.523.523 0 01.02-.926l1.046-.52c.14-.069.297-.092.448-.069zm4.774-2.295l.91.505a.5.5 0 010 .874l-.91.505a.75.75 0 01-.728 0l-.91-.505a.5.5 0 010-.874l.91-.505a.75.75 0 01.728 0zm-9.036 0l.91.505a.5.5 0 010 .874l-.91.505a.75.75 0 01-.727 0l-.91-.505a.5.5 0 010-.874l.91-.505a.75.75 0 01.727 0zm-5.217-6.482a.75.75 0 01.728 0l8.647 4.801 8.649-4.8a.75.75 0 01.727 0l1.111.616a.375.375 0 010 .656L12.54 17.93a.75.75 0 01-.727 0L1.69 12.317a.375.375 0 010-.656zm18.761 3.98l.91.504a.5.5 0 010 .874l-.91.505a.75.75 0 01-.727 0l-.91-.505a.5.5 0 010-.874l.91-.505a.75.75 0 01.727 0zm-18.053 0l.91.504a.5.5 0 010 .874l-.91.505a.75.75 0 01-.727 0l-.91-.505a.5.5 0 010-.874l.91-.505a.75.75 0 01.727 0zm9.03-12.93l9.927 5.505a.5.5 0 010 .874l-9.926 5.505a.75.75 0 01-.728 0L1.887 8.473a.5.5 0 010-.874l9.925-5.505a.75.75 0 01.728 0zm-.363 2.085L5.222 8.036l6.954 3.856 6.955-3.856z" fill-rule="evenodd"/></svg>',
    library: '<svg height="24" width="24"><path d="M20.168 12c.28 0 .46.29.34.54l-3.52 7.04c-.14.26-.4.42-.68.42h-9.08a.76.76 0 01-.67-.41l-3.52-7.04c-.12-.26.06-.55.34-.55zm-1-4c.28 0 .46.29.34.54l-.52 1.04c-.14.26-.4.42-.68.42H5.228a.76.76 0 01-.67-.41l-.52-1.05c-.12-.25.06-.54.34-.54zm-1-4c.28 0 .46.29.34.54l-.52 1.04c-.14.26-.4.42-.68.42H6.228a.76.76 0 01-.67-.41l-.52-1.05c-.12-.25.06-.54.34-.54z" fill-rule="evenodd"/></svg>',
    lock: '<svg height="24" width="24"><path d="M15 10H9V7c0-1.654 1.346-3 3-3s3 1.346 3 3zm-1.055 6.53l-1.414 1.414a.75.75 0 01-1.061 0l-1.414-1.414a.75.75 0 010-1.06l1.414-1.415a.75.75 0 011.06 0l1.415 1.414a.75.75 0 010 1.061zM19.5 10H17V7.122c0-2.707-2.101-5.016-4.807-5.118A5.005 5.005 0 007 7v3H4.5a.5.5 0 00-.5.5v11a.5.5 0 00.5.5h15a.5.5 0 00.5-.5v-11a.5.5 0 00-.5-.5z" fill-rule="evenodd"/></svg>',
    lockOutline: '<svg height="24" width="24"><path d="M6 20h12v-8H6zM9 7c0-1.654 1.346-3 3-3s3 1.346 3 3v3H9zm8 3V7.123c0-2.708-2.101-5.017-4.807-5.12A5.005 5.005 0 007 7v3H4.5a.5.5 0 00-.5.5v11a.5.5 0 00.5.5h15a.5.5 0 00.5-.5v-11a.5.5 0 00-.5-.5zm-4.558 7.68l1.237-1.238a.625.625 0 000-.884l-1.237-1.238a.625.625 0 00-.884 0l-1.237 1.238a.625.625 0 000 .884l1.237 1.237c.244.244.64.244.884 0" fill-rule="evenodd"/></svg>',
    logo: '<svg height="24" width="24"><path d="M13.843 2.7C19.063 2.7 23 6.366 23 11.228c0 3.754-2.862 6.584-6.658 6.584-3.287 0-5.007-2.318-5.007-4.609 0-2.395 1.923-4.344 4.287-4.344.566 0 1.023.12 1.309.223a.212.212 0 01.137.229l-.016.058-.514 1.18a.223.223 0 01-.245.13 2.965 2.965 0 00-.506-.046c-1.245 0-2.258 1.027-2.258 2.288 0 1.33 1.165 2.373 2.651 2.373 2.195 0 3.913-1.777 3.913-4.046 0-3.024-2.294-5.135-5.58-5.135-4.076 0-7.393 3.36-7.393 7.491a7.519 7.519 0 002.871 5.924l-4.96 3.18A12.042 12.042 0 012 14.7c0-6.617 5.313-12 11.843-12z" fill-rule="evenodd"/></svg>',
    magic: '<svg width="24" height="24"><path d="M3.76.9a.854.854 0 00-.84.866v.853h-.854a.854.854 0 100 1.707h.853v.854a.854.854 0 101.707 0v-.854h.853a.854.854 0 100-1.707h-.853v-.853A.854.854 0 003.759.9zm13.655 2.276a.854.854 0 00-.84.866v.853h-.854a.854.854 0 100 1.707h.854v.854a.854.854 0 101.706 0v-.854h.854a.854.854 0 100-1.707h-.854v-.853a.854.854 0 00-.866-.866zM8.348 6.061c-.657 0-1.315.248-1.812.744a2.574 2.574 0 000 3.622l1.326 1.325.003.004c.054.075.12.14.195.195l10.375 10.374a2.574 2.574 0 003.62 0 2.574 2.574 0 000-3.622L11.656 8.305a.854.854 0 00-.198-.199l-1.3-1.3a2.552 2.552 0 00-1.81-.745zm0 1.697a.85.85 0 01.603.255l.8.8-1.191 1.223-.816-.816a.84.84 0 010-1.207.85.85 0 01.604-.255zm2.61 2.262l9.89 9.89a.84.84 0 010 1.208.842.842 0 01-1.206 0h-.001l-9.874-9.875 1.191-1.223zm-4.923 5.105a.854.854 0 00-.84.865v.854h-.853a.854.854 0 100 1.707h.853v.853a.854.854 0 101.707 0v-.853h.853a.854.854 0 100-1.707h-.853v-.854a.854.854 0 00-.867-.865z"/></svg>',
    magicstar: '<svg width="24" height="24"><path d="M15.354 13.762l-1.293.323-.323 1.315 7.177 7.177a1.143 1.143 0 001.639 0 1.143 1.143 0 000-1.638l-7.2-7.177zM6.007 15.7l-1.892 1.916a.962.962 0 000 1.384.91.91 0 00.692.3A1 1 0 005.5 19l1.915-1.915a.962.962 0 000-1.385.989.989 0 00-1.408 0zm6.716-7.892l-1.5 1.246a.464.464 0 01-.485.07l-1.777-.74a.477.477 0 00-.623.624l.739 1.777a.464.464 0 01-.07.484l-1.246 1.477c-.277.323-.023.808.439.762l1.915-.139c.185 0 .347.092.439.23l1.015 1.64c.208.346.762.276.854-.139l.462-1.87a.52.52 0 01.346-.345l1.869-.462c.415-.092.485-.623.138-.854L13.6 10.554a.435.435 0 01-.231-.439l.138-1.915c.024-.415-.461-.67-.784-.392zM1.969 10.577a.98.98 0 00-.97.992c0 .554.44.992.993.992h2.7a.985.985 0 00.992-.992.985.985 0 00-.992-.992zm15.623-6.485l-1.915 1.916a.962.962 0 000 1.384.91.91 0 00.692.3 1 1 0 00.692-.3L19 5.477a.962.962 0 000-1.385.989.989 0 00-1.408 0zm-13.523 0a.962.962 0 000 1.385l1.915 1.915a.91.91 0 00.693.3.996.996 0 00.715-.3.962.962 0 000-1.384L5.477 4.092a.989.989 0 00-1.408 0zM11.499 1a.985.985 0 00-.991.992v2.7c0 .554.438.993.992.993a.985.985 0 00.992-.993v-2.7A.985.985 0 0011.5 1z"/></svg>',
    magicstarOutline: '<svg width="24" height="24"><path fill-rule="evenodd" d="M15.354 13.762l-1.293.323-.323 1.315 7.177 7.177c.198.198.443.311.694.34l.126.006c.294 0 .588-.115.819-.346a1.143 1.143 0 000-1.638l-7.2-7.177zM6.007 15.7l-1.892 1.916a.962.962 0 000 1.384.896.896 0 00.584.295l.108.005A1 1 0 005.5 19l1.915-1.915a.962.962 0 000-1.385.993.993 0 00-.645-.292h-.117a.993.993 0 00-.646.292zm6.716-7.892l-1.5 1.246a.461.461 0 01-.318.108l-.084-.012a.486.486 0 01-.083-.027l-1.777-.738-.078-.026-.077-.01a.478.478 0 00-.468.659l.739 1.777a.464.464 0 01-.07.484l-1.246 1.477a.458.458 0 00.266.753l.084.01.044.001 1.96-.14c.185 0 .347.091.439.23l1.015 1.638a.452.452 0 00.319.216l.076.006a.457.457 0 00.46-.36l.46-1.87a.52.52 0 01.347-.345l1.869-.462c.415-.092.485-.623.138-.854L13.6 10.554a.435.435 0 01-.231-.439l.138-1.915a.48.48 0 00-.432-.506l-.072-.002a.467.467 0 00-.28.116zm-.65 2.229l-.006.07c-.023.607.27 1.16.73 1.477l.079.049a1.83 1.83 0 00-1.202 1.13l-.038.116-.089-.122c-.311-.391-.78-.64-1.35-.679l-.169-.006.078-.103a1.76 1.76 0 00.228-1.532l-.034-.092.08.03c.52.169 1.088.09 1.541-.221l.152-.117zm-10.104.54a.98.98 0 00-.97.992c0 .554.44.992.993.992h2.7a.985.985 0 00.992-.992.985.985 0 00-.992-.992H1.97zm15.623-6.485l-1.915 1.916a.962.962 0 000 1.384.896.896 0 00.584.295l.108.005a1 1 0 00.692-.3L19 5.477a.962.962 0 000-1.385.993.993 0 00-.645-.292h-.118a.993.993 0 00-.645.292zm-13.523 0a.962.962 0 000 1.385l1.915 1.915a.896.896 0 00.584.295l.109.005a.996.996 0 00.715-.3.962.962 0 000-1.384L5.477 4.092A.993.993 0 004.83 3.8h-.117a.993.993 0 00-.645.292zM11.499 1a.985.985 0 00-.991.992v2.7c0 .515.378.93.875.986l.117.007a.985.985 0 00.992-.993v-2.7a.984.984 0 00-.875-.985L11.5 1z"/></svg>',
    menu: '<svg height="24" width="24"><g fill="currentColor"><path d="M7.5 8h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5zM13.5 8h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5zM19.5 8h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5zM7.5 14h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5zM13.5 14h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5zM19.5 14h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5zM7.5 20h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5zM13.5 20h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5zM19.5 20h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5z"/><path d="M7.5 16c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5zm6 0c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5zm6 0c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5zm-12-6c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5zm6 0c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5zm6 0c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5zm-12-6c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5zm6 0c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5zm6 0c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5z"/></g></svg>',
    menuAlt: '<svg height="24" width="24"><path d="M12.293 16.245l1.586 1.587a.414.414 0 010 .585l-1.586 1.587a.414.414 0 01-.586 0l-1.586-1.587a.414.414 0 010-.585l1.586-1.587a.414.414 0 01.586 0zm3.221-3.077l1.443 1.442a.362.362 0 010 .512l-1.443 1.443a.362.362 0 01-.512 0l-1.443-1.443a.362.362 0 010-.512l1.443-1.442a.362.362 0 01.512 0zm-6.516 0l1.443 1.442a.362.362 0 010 .512l-1.443 1.443a.362.362 0 01-.512 0l-1.443-1.443a.362.362 0 010-.512l1.443-1.442a.362.362 0 01.512 0zm9.737-3.078l1.3 1.299a.31.31 0 010 .439l-1.3 1.299a.31.31 0 01-.439 0l-1.298-1.299a.31.31 0 010-.439l1.298-1.299a.31.31 0 01.44 0zm-6.516 0l1.3 1.299a.31.31 0 010 .439l-1.3 1.299a.31.31 0 01-.438 0l-1.3-1.299a.31.31 0 010-.439l1.3-1.299a.31.31 0 01.438 0zm-6.515 0l1.298 1.299a.31.31 0 010 .439l-1.298 1.299a.31.31 0 01-.44 0l-1.298-1.299a.31.31 0 010-.439l1.299-1.299a.31.31 0 01.439 0zm9.737-3.077l1.155 1.154c.1.102.1.265 0 .366L15.44 9.688c-.101.101-.265.101-.366 0L13.92 8.533c-.1-.1-.1-.264 0-.366l1.155-1.154c.101-.101.265-.101.366 0zm-6.516 0l1.155 1.154c.1.102.1.265 0 .366L8.925 9.688c-.101.101-.265.101-.366 0L7.404 8.533c-.1-.1-.1-.264 0-.366L8.56 7.013c.101-.101.265-.101.366 0zm3.221-3.078l1.011 1.011c.08.08.08.212 0 .293l-1.01 1.01a.207.207 0 01-.293 0l-1.011-1.01a.207.207 0 010-.293l1.01-1.01c.082-.081.212-.081.293 0z" fill-rule="evenodd"/></svg>',
    mic: '<svg width="24" height="24"><path fill-rule="evenodd" d="M12 1a3.47 3.47 0 00-3.468 3.474v6.947A3.47 3.47 0 0012 14.895a3.47 3.47 0 003.468-3.474V4.474A3.47 3.47 0 0012 1zM5.166 11.421c-.7 0-1.265.623-1.151 1.316a8.099 8.099 0 006.83 6.699v2.406c0 .64.517 1.158 1.155 1.158s1.156-.519 1.156-1.158v-2.406a8.099 8.099 0 006.83-6.699c.113-.693-.451-1.316-1.152-1.316-.571 0-1.042.421-1.138.986A5.786 5.786 0 0112 17.211a5.786 5.786 0 01-5.696-4.804c-.096-.565-.566-.986-1.138-.986z"/></svg>',
    micOutline: '<svg width="24" height="24"><path d="M18.834 10.321c1.2 0 2.133 1.07 1.941 2.245a8.902 8.902 0 01-6.68 7.203l-.14.03.001 1.743a1.96 1.96 0 01-1.65 1.933l-.15.019L12 23.5a1.957 1.957 0 01-1.956-1.958V19.8l-.15-.034a8.906 8.906 0 01-6.56-6.644l-.06-.283-.049-.273c-.192-1.175.742-2.245 1.941-2.245a1.96 1.96 0 011.926 1.65A4.986 4.986 0 0012 16.112a4.985 4.985 0 004.908-4.138 1.962 1.962 0 011.926-1.652zm0 1.6c-.17 0-.317.13-.35.321A6.586 6.586 0 0112 17.711a6.586 6.586 0 01-6.485-5.47c-.032-.191-.178-.32-.349-.32-.22 0-.393.194-.362.388a7.299 7.299 0 006.154 6.035l.429.062.257.037v3.1c0 .197.16.357.356.357.196 0 .356-.16.356-.358v-3.1l.257-.036.43-.062a7.299 7.299 0 006.153-6.036c.032-.193-.141-.387-.362-.387zM12 1a3.77 3.77 0 013.768 3.774v6.947A3.77 3.77 0 0112 15.495a3.77 3.77 0 01-3.768-3.774V4.774A3.77 3.77 0 0112 1zm0 1.7a2.07 2.07 0 00-2.068 2.074v6.947A2.07 2.07 0 0012 13.795a2.07 2.07 0 002.068-2.074V4.774A2.07 2.07 0 0012 2.7z"/></svg>',
    noIcon: '<svg height="24" width="24"><path d="M20.75 3a.25.25 0 01.25.25v.955a.5.5 0 01-.147.354L4.56 20.854a.5.5 0 01-.354.146H3.25a.25.25 0 01-.25-.25v-.96a.5.5 0 01.147-.353l16.29-16.29A.5.5 0 0119.791 3zm.037 6.578a.125.125 0 01.213.088v2.32a.5.5 0 01-.147.353l-8.514 8.515a.5.5 0 01-.354.146h-2.32a.125.125 0 01-.088-.213zm0 7.778a.125.125 0 01.213.088v3.306a.25.25 0 01-.25.25h-3.306a.125.125 0 01-.089-.213zM14.334 3c.112 0 .167.135.089.214L3.213 14.423A.125.125 0 013 14.335v-2.32a.5.5 0 01.146-.354l8.515-8.514A.5.5 0 0112.015 3zM6.556 3c.111 0 .167.135.089.214l-3.431 3.43A.125.125 0 013 6.557V3.25A.25.25 0 013.25 3z" fill-rule="evenodd"/></svg>',
    pages: '<svg width="24" height="24"><path fill-rule="evenodd" d="M9.857 9.143c1.182 0 2.143.961 2.143 2.143v8.571A2.145 2.145 0 019.857 22H4.143A2.145 2.145 0 012 19.857v-8.571c0-1.182.961-2.143 2.143-2.143zm4.5-3.6c1.182 0 2.143.961 2.143 2.143v8.571a2.145 2.145 0 01-2.143 2.143l-1.434-.001v-7.985a2.145 2.145 0 00-2.142-2.143H6.5v-.585c0-1.13.88-2.06 1.99-2.138l.153-.005zm-9.262 7.886h3.81a.715.715 0 010 1.428h-3.81a.715.715 0 010-1.428zm3.81 2.857a.715.715 0 010 1.428h-3.81a.715.715 0 010-1.428h3.81zM19.857 2C21.04 2 22 2.961 22 4.143v8.571a2.145 2.145 0 01-2.143 2.143h-2.38v-4.286h1.428a.715.715 0 000-1.428h-1.429V7.714h1.429a.715.715 0 000-1.428h-1.78a3.098 3.098 0 00-2.744-1.667H12v-.476C12 2.96 12.961 2 14.143 2z"/></svg>',
    pagesHalfOutline: '<svg width="24" height="24"><path fill-rule="evenodd" d="M14.143 2A2.145 2.145 0 0012 4.143v.476h2.381c1.191 0 2.226.678 2.744 1.667h1.78a.715.715 0 010 1.428h-1.429v1.429h1.429a.715.715 0 010 1.428h-1.429v4.286h2.381A2.145 2.145 0 0022 12.714V4.143A2.145 2.145 0 0019.857 2h-5.714zM8.667 5.571a2.145 2.145 0 00-2.143 2.143v.476h1.428v-.476c0-.394.32-.714.715-.714h5.714c.394 0 .714.32.714.714v8.572c0 .394-.32.714-.714.714h-1.429v1.429h1.429a2.145 2.145 0 002.143-2.143V7.714a2.145 2.145 0 00-2.143-2.143H8.667zM4.143 9.143A2.145 2.145 0 002 11.286v8.571C2 21.04 2.961 22 4.143 22h5.714A2.145 2.145 0 0012 19.857v-8.571a2.145 2.145 0 00-2.143-2.143H4.143zm.952 4.286h3.81a.715.715 0 010 1.428h-3.81a.715.715 0 010-1.428zm0 2.857h3.81a.715.715 0 010 1.428h-3.81a.715.715 0 010-1.428z"/></svg>',
    pagesOutline: '<svg width="24" height="24"><path fill-rule="evenodd" d="M14.143 2A2.145 2.145 0 0012 4.143v.476h1.429v-.476c0-.394.32-.714.714-.714h5.714c.394 0 .714.32.714.714v8.571c0 .394-.32.715-.714.715h-2.38v1.428h2.38A2.145 2.145 0 0022 12.714V4.143A2.145 2.145 0 0019.857 2h-5.714zM8.667 5.571a2.145 2.145 0 00-2.143 2.143v.476h1.428v-.476c0-.394.32-.714.715-.714h5.714c.394 0 .714.32.714.714v8.572c0 .394-.32.714-.714.714h-1.429v1.429h1.429a2.145 2.145 0 002.143-2.143V10.57h2.38a.714.714 0 100-1.428h-2.38V7.714h2.38a.714.714 0 100-1.428h-2.856a.714.714 0 00-.08.003 2.13 2.13 0 00-1.587-.718H8.667zM4.143 9.143A2.154 2.154 0 002 11.286v8.571C2 21.032 2.968 22 4.143 22h5.714A2.154 2.154 0 0012 19.857v-8.571a2.154 2.154 0 00-2.143-2.143H4.143zm0 1.428h5.714c.403 0 .714.312.714.715v8.571a.704.704 0 01-.714.714H4.143a.704.704 0 01-.714-.714v-8.571c0-.403.31-.715.714-.715zm.952 2.858a.714.714 0 100 1.428h3.81a.714.714 0 100-1.428h-3.81zm0 2.857a.714.714 0 100 1.428h3.81a.714.714 0 100-1.428h-3.81z"/></svg>',
    pin: '<svg width="24" height="24"><path fill-rule="evenodd" d="M13.72 2.02c-.128.434.048.901.43 1.14.084.054.144.104.278.221l.072.063.022.018-4.633 4.436a.064.064 0 01-.04.018h-.025a11.047 11.047 0 00-1.581-.152l-.334.005a8.115 8.115 0 00-3.955 1.153c-1.159.702-1.343 2.348-.385 3.305l3.393 3.393-5.353 5.352a1.007 1.007 0 00-.3.863l.023.118a1.007 1.007 0 001.699.447l5.355-5.356 3.393 3.393c.92.92 2.473.787 3.216-.25l.089-.134c.762-1.26 1.165-2.728 1.158-4.29a14.697 14.697 0 00-.108-1.628l.001.001c-.003-.022-.002-.035.004-.046l.011-.016 1.928-2.013.462-.483 1.968-2.056.064-.067.036.05c.117.162.166.233.22.323a1.008 1.008 0 101.729-1.036c-1.696-2.825-4.141-5.271-7.311-7.323a1.009 1.009 0 00-1.525.551z"/></svg>',
    pinOutline: '<svg width="24" height="24"><path fill-rule="evenodd" d="M13.72 2.02c-.128.434.048.901.43 1.14.084.054.144.104.278.221l.072.063.022.018-4.633 4.436a.064.064 0 01-.04.018h-.025a11.047 11.047 0 00-1.581-.152l-.334.005a8.115 8.115 0 00-3.955 1.153c-1.159.702-1.343 2.348-.385 3.305l3.393 3.393-5.353 5.352a1.007 1.007 0 00-.3.863l.023.118a1.007 1.007 0 001.699.447l5.355-5.356 3.393 3.393c.92.92 2.473.787 3.216-.25l.089-.134c.762-1.26 1.165-2.728 1.158-4.29a14.697 14.697 0 00-.108-1.628l.001.001c-.003-.022-.002-.035.004-.046l.011-.016 1.928-2.013.462-.483 1.968-2.056.064-.067.036.05c.117.162.166.233.22.323a1.008 1.008 0 101.729-1.036c-1.696-2.825-4.141-5.271-7.311-7.323a1.009 1.009 0 00-1.525.551zm2.392 2.709l.19.152c1.482 1.187 2.426 2.065 3.195 3.034l-.11-.136-.133.14-1.78 1.86-.638.666-.231.24-1.91 1.996a2.076 2.076 0 00-.561 1.676l.001.026c.055.443.09.999.092 1.39.006 1.199-.293 2.29-.866 3.236-.035.057-.099.063-.158.004l-8.21-8.21c-.059-.06-.053-.123.004-.157.948-.574 2.037-.873 3.237-.867l.137.003c.299.013.738.06 1.144.123l-.132-.021.132.022c.584.09 1.179-.07 1.635-.437l.132-.117 4.83-4.623z"/></svg>',
    playground: '<svg height="24" width="24"><path d="M4.2 11.707c0-.223.166-.413.386-.44 1.102-.136 1.807-.923 1.562-2.807-.073-.567-.16-1.111-.16-1.678 0-1.486.956-2.59 2.242-2.582.306.002 1.94 0 2.525 0 .246 0 .445.177.445.423V5.73a.46.46 0 01-.442.462c-.358.002-1.27 0-1.392 0-.974 0-1.463.071-1.463.982 0 .464.08.733.142 1.22.08.504.155 1.017.155 1.563 0 1.293-.508 1.959-1.372 2.199l-.1.022v.044l.1.022c.864.24 1.372.905 1.372 2.199 0 .546-.075 1.059-.155 1.563-.062.487-.142.756-.142 1.22 0 .911.489.981 1.463.981h1.392a.46.46 0 01.442.463v1.107c0 .246-.199.423-.445.423-.586 0-2.219-.002-2.525 0-1.286.009-2.242-1.096-2.242-2.582 0-.567.087-1.111.16-1.678.245-1.884-.46-2.672-1.562-2.807a.442.442 0 01-.386-.44zm11.061 6.346l-.707-.706a.5.5 0 010-.708l4.439-4.438-4.44-4.44a.5.5 0 010-.707l.707-.707a.5.5 0 01.707 0l5.5 5.5a.5.5 0 010 .707l-5.499 5.5a.5.5 0 01-.707 0" fill-rule="evenodd"/></svg>',
    preferences: '<svg height="24" width="24"><path d="M16 12.5a3.502 3.502 0 013.355 2.5h2.147a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-2.147a3.502 3.502 0 01-6.71 0H2.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h10.145A3.502 3.502 0 0116 12.5zm-8-8A3.502 3.502 0 0111.355 7h10.147a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H11.355a3.502 3.502 0 01-6.71 0H2.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h2.145A3.502 3.502 0 018 4.5z" fill-rule="evenodd"/></svg>',
    preferencesOutline: '<svg height="24" width="24"><path d="M16 12a4.003 4.003 0 013.869 3h1.633a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H19.87c-.446 1.722-2.009 3-3.869 3s-3.422-1.278-3.868-3H2.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h9.632A4.003 4.003 0 0116 12zm0 2c-1.102 0-2 .896-2 2 0 1.102.898 2 2 2 1.103 0 2-.898 2-2 0-1.104-.897-2-2-2zM8 4a4.003 4.003 0 013.869 3h9.633a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H11.87A4.004 4.004 0 018 12a4.004 4.004 0 01-3.868-3H2.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1.632A4.003 4.003 0 018 4zm0 2c-1.102 0-2 .896-2 2 0 1.102.898 2 2 2 1.103 0 2-.898 2-2 0-1.104-.897-2-2-2z" fill-rule="evenodd"/></svg>',
    priceTag: '<svg height="24" width="24"><path d="M11.485 2a1 1 0 01.708.293l10.252 10.253a.5.5 0 010 .707l-9.192 9.193a.5.5 0 01-.707 0L2.293 12.192A1 1 0 012 11.485V2.5a.5.5 0 01.5-.5zm-.414 2h-7.07v7.071l8.899 8.9 7.07-7.071zM8.354 6.554l1.092 1.093a.5.5 0 010 .707L8.354 9.446a.5.5 0 01-.707 0L6.554 8.354a.5.5 0 010-.707l1.093-1.093a.5.5 0 01.707 0z" fill-rule="evenodd"/></svg>',
    qr: '<svg width="24" height="24"><path fill-rule="evenodd" d="M18 22v-2h-2v2h-4v-2h-2v2H8v-2H6v2H2v-6h2v-2H2v-4h2V8H2V6h2V4H2V2v20h16zM4 4h2V2H4v2zm2 0v2h2v2h2V6h4V4h-4V2H8v2H6zm8 0h2V2h-2v2zm2 0v2h2v2h2V6h2V4h-6zm4 4v4h2V8h-2zm0 4h-2V8h-2v6h4v-2zm0 2v2h2v-2h-2zm0 2h-4v2h4v-2zm0 2v2h2v-2h-2zm-4 0h-2v2h2v-2zm-2 0v-2h-2v2h2zm0-2h2v-2h-2v2zm2-8V6h-2v2h2zm-2 0h-4v2h2v2h2V8zm-2 4h-2v2h2v-2zm-2 2H8v2H6v2h2v2h2v-6zm-4 4H4v2h2v-2zm4-6v-2H8v2h2zm-2-2V8H6v2h2zm-2 0H4v4h2v-4zm0-2V6H4v2h2z"/></svg>',
    ratingFrame: '<svg height="24" width="24"><path d="M20.502 3a.5.5 0 01.5.5v17.002a.5.5 0 01-.5.5H3.5a.5.5 0 01-.5-.5V3.5a.5.5 0 01.5-.5zm-1.5 2H5v14.002h14.002zm-6.687 3.198l.97 2.008 2.209.302a.35.35 0 01.195.599l-1.61 1.542.396 2.195a.35.35 0 01-.51.37L12 14.16l-1.965 1.054a.35.35 0 01-.51-.37l.397-2.195-1.61-1.542a.35.35 0 01.194-.6l2.21-.3.969-2.01a.35.35 0 01.63 0z" fill-rule="evenodd"/></svg>',
    ratingPointer: '<svg height="24" width="24"><path d="M11.33 12.056c.457-.324 1.094-.194 1.431.252l2.232 2.955.414-.312a.682.682 0 01.292-.128l3.557-.627c.423-.074.848.124 1.062.497l1.589 2.76c.256.444.142 1.01-.266 1.321l-3.592 2.737a2.426 2.426 0 01-2.281.346l-2.857-1.02a.608.608 0 01-.369-.775c.167-.47.512-.83.936-1.027a1.793 1.793 0 011.236-.077l.578.09-4.186-5.544a1.02 1.02 0 01.225-1.448zm-.743-9.375a.51.51 0 01.92 0l2.472 5.121 5.634.769c.424.058.593.58.285.875l-3.87 3.708-1.19-1.512 1.633-1.566-3.77-.515-1.654-3.427-1.655 3.427-3.77.515 2.747 2.632-.675 3.745 2.19-1.176 1.177 1.558-5.025 2.682a.511.511 0 01-.744-.54l1.01-5.597-4.107-3.934a.511.511 0 01.285-.875l5.634-.769z" fill-rule="evenodd"/></svg>',
    ratingStar: '<svg height="24" width="24"><path d="M14.677 12.833l.676 3.745-3.353-1.8-3.353 1.8.676-3.745-2.748-2.632 3.77-.515L12 6.26l1.654 3.427 3.771.515zm5.89-4.137l-5.634-.769-2.473-5.12a.51.51 0 00-.92 0l-2.473 5.12-5.634.77a.511.511 0 00-.284.874l4.106 3.934-1.01 5.596a.51.51 0 00.745.541L12 16.968l5.01 2.674a.51.51 0 00.745-.54l-1.01-5.597 4.106-3.934a.511.511 0 00-.284-.875z" fill-rule="evenodd"/></svg>',
    report: '<svg height="24" width="24"><path d="M16.222 3a.5.5 0 01.354.146l5.277 5.276a.5.5 0 01.147.353V20.5a.5.5 0 01-.5.5h-18a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5zM15 5H5v14h15.002v-9H15.5a.5.5 0 01-.5-.5zm2.5 10a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-10a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm-5-4a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zM8.354 6.94l.707.706a.5.5 0 010 .708l-.707.707a.5.5 0 01-.708 0l-.707-.707a.5.5 0 010-.708l.707-.707a.5.5 0 01.708 0z" fill-rule="evenodd"/></svg>',
    reportAlt: '<svg height="24" width="24"><path d="M16.222 3a.5.5 0 01.353.146l5.278 5.276a.5.5 0 01.146.353V20.5a.5.5 0 01-.5.5H3.5a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5zM15 5H5v14h15.002v-9H15.5a.5.5 0 01-.5-.5zM8.5 7.053a.5.5 0 01.5.5V16.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V7.553a.5.5 0 01.5-.5zM12.502 10a.5.5 0 01.5.5v6a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-6a.5.5 0 01.5-.5zm4.344 3.626l1.02 1.02a.5.5 0 010 .708l-1.02 1.02a.5.5 0 01-.708 0l-1.02-1.02a.5.5 0 010-.708l1.02-1.02a.5.5 0 01.708 0z" fill-rule="evenodd"/></svg>',
    saveAlt: '<svg width="24" height="24"><path fill-rule="evenodd" d="M17.556 2H4.222C2.99 2 2 3 2 4.222v15.556C2 21 2.989 22 4.222 22h15.556C21 22 22 21 22 19.778V6.444L17.556 2zM12 19.778a3.329 3.329 0 01-3.333-3.334A3.329 3.329 0 0112 13.111a3.329 3.329 0 013.333 3.333A3.329 3.329 0 0112 19.778zm3.333-11.111H4.223V4.222h11.11v4.445z"/></svg>',
    saveAltOutline: '<svg width="24" height="24"><path fill-rule="evenodd" d="M4.222 2A2.237 2.237 0 002 4.222v15.556A2.237 2.237 0 004.222 22h15.556A2.237 2.237 0 0022 19.778V6.444L17.556 2H4.222zm0 2.222h12.413l3.143 3.143v12.413H4.222V4.222zm2.222 2.222v3.334h8.89V6.444h-8.89zm5 5.556a2.778 2.778 0 100 5.556 2.778 2.778 0 000-5.556z"/></svg>',
    saveColored: '<svg width="24" height="24"><g fill-rule="evenodd"><path d="M7.3 14.2a2.5 2.5 0 000 5 2.5 2.5 0 000-5z" opacity=".65"/><path d="M19.293 3.545a.795.795 0 011.138-.015l.414.413c.305.305.31.798.013 1.11l-6.67 6.998a.795.795 0 01-1.116.033L9.974 9.198a.794.794 0 01-.018-1.145l.42-.418a.794.794 0 011.095-.023L13.6 9.55l5.694-6.005z"/></g></svg>',
    searchOutline: '<svg height="24" width="24"><path d="M20.61 19.19l-5.15-5.15a7.485 7.485 0 001.47-5.6c-.46-3.32-3.14-5.96-6.46-6.38-4.89-.61-9.02 3.52-8.41 8.41.42 3.33 3.07 6 6.39 6.46 2.12.29 4.08-.31 5.6-1.48l5.15 5.15c.2.2.51.2.71 0l.71-.71c.18-.19.18-.5-.01-.7zM3.99 9.5C3.99 6.47 6.46 4 9.5 4S15 6.47 15 9.5 12.53 15 9.5 15s-5.51-2.46-5.51-5.5z" fill-rule="evenodd"/></svg>',
    settings: '<svg height="24" width="24"><path d="M22 12.72v-1.44c0-.23-.16-.43-.38-.49l-2.64-.64c-.17-.63-.42-1.23-.74-1.79l1.42-2.32c.12-.2.09-.45-.07-.61l-1.02-1.01a.5.5 0 00-.61-.07l-2.32 1.42a7.26 7.26 0 00-1.79-.74l-.65-2.65a.493.493 0 00-.48-.38h-1.44c-.23 0-.43.16-.49.38l-.64 2.64c-.63.17-1.23.42-1.78.74L6.05 4.35a.497.497 0 00-.61.07L4.42 5.44c-.16.16-.19.41-.07.61l1.42 2.32a7.26 7.26 0 00-.74 1.79l-2.65.64c-.22.05-.38.25-.38.48v1.44c0 .23.16.43.38.49l2.64.64c.17.63.42 1.23.74 1.79l-1.42 2.32c-.12.2-.09.45.07.61l1.01 1.01a.5.5 0 00.61.07l2.32-1.42c.55.32 1.15.57 1.79.74l.64 2.64c.05.22.26.38.49.38h1.44c.23 0 .43-.16.49-.38l.64-2.64c.63-.17 1.23-.42 1.79-.74l2.32 1.42c.2.12.45.09.61-.07l1.02-1.01a.5.5 0 00.07-.61l-1.42-2.32c.32-.55.57-1.15.74-1.79l2.64-.64a.51.51 0 00.39-.49zm-10 3.72c-2.45 0-4.44-1.99-4.44-4.44S9.55 7.56 12 7.56s4.44 1.99 4.44 4.44-1.99 4.44-4.44 4.44z" fill-rule="evenodd"/></svg>',
    shape: '<svg height="24" width="24"><path d="M14.57 12.64l6.29 6.29c.2.2.2.51 0 .71l-.71.71c-.2.2-.52.2-.71 0l-6.29-6.29c-.2-.2-.2-.51 0-.71l.71-.71c.2-.2.51-.2.71 0zM9.5 13c.28 0 .5.22.5.5v6c0 .28-.23.5-.5.5h-6c-.28 0-.5-.22-.5-.5v-6c0-.28.22-.5.5-.5zm-3-10.55a4 4 0 110 8 4 4 0 010-8zm10.91.67l4.07 6.1c.22.33-.02.78-.42.78h-8.13c-.4 0-.64-.45-.42-.78l4.07-6.1c.2-.3.63-.3.83 0z" fill-rule="evenodd"/></svg>',
    shapeColored: '<svg height="24" width="24"><g fill="currentColor" transform="translate(2.5 2.45)"><path d="M18.56 7.55h-8.13c-.4 0-.64-.45-.42-.78l4.07-6.1c.2-.3.63-.3.83 0l4.07 6.1c.22.33-.02.78-.42.78z" fill="#313233" opacity=".8"/><path d="M7 17.55H1c-.28 0-.5-.22-.5-.5v-6c0-.28.22-.5.5-.5h6c.28 0 .5.22.5.5v6c0 .28-.23.5-.5.5z" fill="#626365" opacity=".6"/><circle cx="4" cy="4" r="4"/><path d="M16.94 17.9l-6.29-6.29c-.2-.2-.2-.51 0-.71l.71-.71c.2-.2.51-.2.71 0l6.29 6.29c.2.2.2.51 0 .71l-.71.71c-.2.2-.52.2-.71 0z" fill="#939598" opacity=".4"/></g></svg>',
    shapeOutline: '<svg height="24" width="24"><path d="M14.27 13.05l6.68 6.68c.2.2.2.51 0 .71l-.5.5c-.2.19-.52.19-.71 0l-6.68-6.68c-.2-.2-.2-.51 0-.71l.5-.5c.2-.2.51-.2.71 0zm-4.42.1c.28 0 .5.22.5.5v6.7c0 .28-.22.5-.5.5h-6.7c-.28 0-.5-.22-.5-.5v-6.7c0-.28.22-.5.5-.5zm-1.2 1.7h-4.3v4.3h4.3zM6.5 2.15c2.4 0 4.35 1.95 4.35 4.35S8.9 10.85 6.5 10.85 2.15 8.9 2.15 6.5 4.1 2.15 6.5 2.15zm11.33.66L21.9 9.1c.45.66-.03 1.55-.83 1.55h-8.14c-.8 0-1.28-.89-.83-1.55l4.07-6.29a1 1 0 011.66 0zM6.5 3.85c-1.46 0-2.65 1.19-2.65 2.65S5.04 9.15 6.5 9.15 9.15 7.96 9.15 6.5 7.96 3.85 6.5 3.85zm10.5.69l-2.84 4.45h5.68z" fill-rule="evenodd"/></svg>',
    shapeOutlineColored: '<svg width="24" height="24"><g fill-rule="evenodd"><path fill-rule="nonzero" d="M9.85 20.85h-6.7c-.28 0-.5-.22-.5-.5v-6.7c0-.28.22-.5.5-.5h6.7c.28 0 .5.22.5.5v6.7c0 .28-.22.5-.5.5zm-5.5-1.7h4.3v-4.3h-4.3v4.3z" opacity=".85"/><path fill-rule="nonzero" d="M6.5 10.85c-2.4 0-4.35-1.95-4.35-4.35 0-2.4 1.95-4.35 4.35-4.35 2.4 0 4.35 1.95 4.35 4.35 0 2.4-1.95 4.35-4.35 4.35zm0-7c-1.46 0-2.65 1.19-2.65 2.65S5.04 9.15 6.5 9.15 9.15 7.96 9.15 6.5 7.96 3.85 6.5 3.85z" opacity=".55"/><path d="M19.74 20.94l-6.68-6.68c-.2-.2-.2-.51 0-.71l.5-.5c.2-.2.51-.2.71 0l6.68 6.68c.2.2.2.51 0 .71l-.5.5c-.2.19-.52.19-.71 0z"/><path fill-rule="nonzero" d="M21.07 10.65h-8.14c-.8 0-1.28-.89-.83-1.55l4.07-6.29a1 1 0 011.66 0L21.9 9.1c.45.66-.03 1.55-.83 1.55zm-6.91-1.66h5.68L17 4.54l-2.84 4.45z" opacity=".7"/></g></svg>',
    share: '<svg height="24" width="24"><path d="M8.1 11.74l8.44-3.96 1.54.89c.23.13.52.13.75 0l1.8-1.04c.23-.13.37-.38.37-.65V4.9c0-.27-.14-.52-.37-.65l-1.8-1.04a.77.77 0 00-.75 0l-1.8 1.04c-.24.14-.38.39-.38.65v1.3l-8.44 3.96-1.54-.89a.77.77 0 00-.75 0l-1.8 1.04c-.23.14-.37.38-.37.65v2.08c0 .27.14.52.38.65l1.8 1.04c.23.13.52.13.75 0l1.54-.89 8.44 3.96v1.3c0 .27.14.52.38.65l1.8 1.04c.23.13.52.13.75 0l1.8-1.04c.22-.14.36-.39.36-.65v-2.08c0-.27-.14-.52-.38-.65l-1.8-1.04a.77.77 0 00-.75 0l-1.54.89-8.43-3.96z" fill-rule="evenodd"/></svg>',
    shootingstaHalfOutline: '<svg width="24" height="24"><path fill-rule="evenodd" d="M6.5 1c.396 0 .786.225.978.661l1.03 2.327 2.513.265c.43.043.797.343.926.74.132.407.013.853-.291 1.137l-.503.45C20.461 8.798 23 17.977 23 17.977l-2.644-1.719s1.13 2.763.608 6.77l-3.226-5.078s-.486 2.764-1.508 3.914c0 0-1.328-9.05-6.082-12.243l.133.74c.089.42-.08.86-.424 1.11a1.052 1.052 0 01-.634.186.963.963 0 01-.53-.132L6.5 10.229l-2.195 1.296a1.07 1.07 0 01-1.163-.053l-.027-.027a1.094 1.094 0 01-.396-1.084L3.22 7.85 1.343 6.13a1.058 1.058 0 01-.291-1.11v-.027c.125-.387.489-.658.899-.714.006 0-.007-.026 0-.026h.026l2.512-.265 1.032-2.327c.191-.436.581-.661.978-.661zm0 2.618l-.662 1.507-.212.45-2.141.238 1.242 1.11.37.344-.105.45-.344 1.666 1.428-.847.423-.238.423.238 1.428.847-.344-1.666-.105-.45.37-.344 1.243-1.11-2.142-.238-.212-.45-.66-1.507z"/></svg>',
    shootingstar: '<svg width="24" height="24"><path fill-rule="evenodd" d="M6.75 1c.486 0 .923.27 1.139.706l1.087 2.188 2.432.351c.484.07.877.402 1.027.865.15.463.027.96-.323 1.299l-1.758 1.703.415 2.403a1.272 1.272 0 01-1.843 1.338l-2.177-1.137-2.176 1.136c-.432.226-.945.19-1.34-.098a1.26 1.26 0 01-.503-1.24l.414-2.402-1.758-1.703a1.257 1.257 0 01-.323-1.299c.15-.463.543-.795 1.027-.865l2.433-.352 1.086-2.188A1.264 1.264 0 016.75 1zm6.406 5.692c7.946 2.167 9.807 10.31 9.826 10.4a.75.75 0 01-1.214.733c-.01-.008-.744-.615-1.85-1.214.28 1.233.58 3.137.58 5.638a.75.75 0 01-1.472.198c-.006-.022-.576-2.02-2.294-3.91-.365.777-.891 1.85-1.34 2.598a.75.75 0 01-1.39-.44c.003-.055.298-4.828-2.626-8.667.338-.481.483-1.08.379-1.683l-.325-1.882 1.379-1.335c.136-.133.25-.28.347-.436z"/></svg>',
    shootingstarOutline: '<svg width="24" height="24"><path fill-rule="evenodd" d="M9.518 12c.264 0 .525-.083.749-.245a1.26 1.26 0 00.503-1.24l-.414-2.403 1.758-1.703c.35-.338.473-.836.323-1.299a1.262 1.262 0 00-1.027-.865l-2.433-.35L7.89 1.705A1.265 1.265 0 006.75 1c-.487 0-.924.27-1.14.705L4.523 3.894l-2.431.35c-.484.07-.878.402-1.028.866-.15.462-.026.96.323 1.299l1.758 1.703-.414 2.403c-.083.478.11.953.503 1.24.395.286.909.324 1.341.098l2.175-1.137 2.177 1.137c.187.098.39.147.591.147zm1.207-6.336L9.123 7.215c-.24.232-.35.567-.293.896l.38 2.196-1.99-1.04a1.016 1.016 0 00-.94 0l-1.989 1.04.38-2.196a1.006 1.006 0 00-.293-.896l-1.601-1.55 2.217-.32c.33-.048.615-.255.762-.553l.994-2.004.996 2.004c.147.297.431.504.761.551l2.218.32zm.652 6.364a2.248 2.248 0 00.38-1.683l-.041-.234c2.423 2.554 3.318 5.641 3.634 7.843.272-.575.46-1 .465-1.01a.75.75 0 011.187-.252 12.248 12.248 0 011.763 1.977c-.278-2.023-.705-3.126-.71-3.14a.75.75 0 01.959-.981c.662.248 1.27.547 1.795.84-1.078-2.445-3.593-6.363-8.848-7.438l.849-.822c.136-.133.25-.28.347-.436 7.946 2.167 9.807 10.31 9.826 10.4a.75.75 0 01-1.213.734 12.55 12.55 0 00-1.85-1.215c.28 1.233.58 3.137.58 5.639a.75.75 0 01-1.473.198c-.006-.022-.576-2.02-2.294-3.91-.365.777-.89 1.849-1.34 2.597a.751.751 0 01-1.391-.44c.004-.055.299-4.828-2.625-8.667z"/></svg>',
    signal: '<svg width="24" height="24"><path fill-rule="evenodd" d="M18.4 2.4l-1 2-9 3h-4c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h2v5h2v-5l9 3 1 2h2v-7.277a1.99 1.99 0 001-1.723 1.99 1.99 0 00-1-1.723V2.4h-2zm0 3.775v10.45l-.367-.123-7.633-2.543V8.84l7.633-2.543.367-.123zM4.4 9.4h4v4h-4v-4z"/></svg>',
    star: '<svg height="24" width="24"><path d="M8.79 8.64l-6.28.86c-.41.06-.58.57-.28.86l4.58 4.39-1.13 6.24c-.07.41.36.73.73.53l5.59-3 5.59 3c.37.2.8-.12.73-.53l-1.13-6.24 4.58-4.39c.3-.29.14-.8-.28-.86l-6.28-.86-2.76-5.71a.498.498 0 00-.9 0z" fill-rule="evenodd"/></svg>',
    starOutline: '<svg height="24" width="24"><path d="M12 6.6l1.41 2.91.47.97 1.06.15 3.2.44-2.33 2.24-.78.74.19 1.06.57 3.18-2.85-1.53-.94-.52-.95.51-2.85 1.53.57-3.18.19-1.06-.77-.74-2.33-2.24 3.2-.44 1.06-.15.47-.97zM8.79 8.64l-6.28.86c-.41.06-.58.57-.28.86l4.58 4.39-1.13 6.24c-.07.41.36.73.73.53l5.59-3 5.59 3c.37.2.8-.12.73-.53l-1.13-6.24 4.58-4.39c.3-.29.14-.8-.28-.86l-6.28-.86-2.76-5.71a.498.498 0 00-.9 0z" fill-rule="evenodd"/></svg>',
    symbols: '<svg height="24" width="24"><path d="M13.843 2.7C19.063 2.7 23 6.366 23 11.228c0 3.754-2.862 6.584-6.658 6.584-3.287 0-5.007-2.318-5.007-4.609 0-2.395 1.923-4.344 4.287-4.344.566 0 1.023.12 1.309.223a.212.212 0 01.137.229l-.016.058-.514 1.18a.223.223 0 01-.245.13 2.965 2.965 0 00-.506-.046c-1.245 0-2.258 1.027-2.258 2.288 0 1.33 1.165 2.373 2.651 2.373 2.195 0 3.913-1.777 3.913-4.046 0-3.024-2.294-5.135-5.58-5.135-4.076 0-7.393 3.36-7.393 7.491a7.519 7.519 0 002.871 5.924l-4.96 3.18A12.042 12.042 0 012 14.7c0-6.617 5.313-12 11.843-12z" fill-rule="evenodd"/></svg>',
    sync: '<svg width="24" height="24"><path fill-rule="evenodd" d="M12 3a6.44 6.44 0 00-5.264 2.754A5.966 5.966 0 001 11.708c0 3.13 2.428 5.7 5.5 5.935v-1.856c-2.057-.232-3.667-1.96-3.667-4.077a4.131 4.131 0 014.125-4.127l.788.043.283-.488A4.596 4.596 0 0112 4.833a4.557 4.557 0 014.52 3.864l.139.88 1.008-.132c.096-.013.191-.028.291-.028 1.77 0 3.209 1.439 3.209 3.208 0 1.77-1.44 3.208-3.209 3.208H17.5v1.834h.458A5.048 5.048 0 0023 12.625c0-2.717-2.16-4.94-4.854-5.038A6.378 6.378 0 0012 3zm-2.75 8.25L6.5 14h1.833v7.333h1.834V14H12l-2.75-2.75zm4.583.917V19.5H12l2.75 2.75 2.75-2.75h-1.833v-7.333h-1.834z"/></svg>',
    theme: '<svg height="24" width="24"><path d="M10 13v4.5a3.5 3.5 0 01-7 0V13zm10.5 1a.5.5 0 01.5.5v6a.5.5 0 01-.5.5H10.071l7-7zm-14 1.707a.498.498 0 00-.354.147l-.793.792a.5.5 0 000 .708l.793.792a.498.498 0 00.707 0l.793-.792a.5.5 0 000-.708l-.793-.792a.498.498 0 00-.353-.147zM14.278 4.98c.128 0 .256.049.354.146l4.243 4.243a.5.5 0 010 .707L11.5 17.45v-9.9l2.425-2.425a.5.5 0 01.353-.146zM10 8.01v3.49H3V8.01zM9.5 3a.5.5 0 01.5.5v3.009H3V3.5a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    themeOutline: '<svg height="24" width="24"><path d="M10.5 3a.5.5 0 01.5.5v3.843l2.717-2.718a.499.499 0 01.707 0l4.95 4.95a.5.5 0 010 .707L16.664 13H20.5a.5.5 0 01.5.5v7a.5.5 0 01-.5.5H7a4 4 0 01-4-4V3.5a.5.5 0 01.5-.5zm9 11.5h-4.332l-4.986 5H19.5zM9.5 13h-5v4c0 1.378 1.121 2.5 2.5 2.5 1.378 0 2.5-1.122 2.5-2.5zm-2.146 3.11l.535.536a.5.5 0 010 .707l-.535.536a.5.5 0 01-.707 0l-.536-.536a.5.5 0 010-.707l.536-.535a.5.5 0 01.707 0zm6.717-9.717L11 9.464v7.072l6.607-6.607zM9.5 8.76h-5V11.5h5zm0-4.259h-5v2.759h5z" fill-rule="evenodd"/></svg>',
    threeDots: '<svg height="24" width="24"><path d="M18 10a2 2 0 110 4 2 2 0 010-4zm-6 0a2 2 0 110 4 2 2 0 010-4zm-6 0a2 2 0 110 4 2 2 0 010-4z" fill-rule="evenodd"/></svg>',
    threeDotsVertical: '<svg width="24" height="24"><path fill-rule="evenodd" d="M14 18a2 2 0 11-4 0 2 2 0 014 0zm0-6a2 2 0 11-4 0 2 2 0 014 0zm0-6a2 2 0 11-4 0 2 2 0 014 0z"/></svg>',
    touchscreen: '<svg height="24" width="24"><path d="M12.518 8.652c.547.017.969.494.969 1.041v3.625h.507c.106 0 .21.025.303.073l3.148 1.608a1 1 0 01.537 1.014l-.387 3.093a1 1 0 01-.987.875l-1.687.01.01.009H12.187c-.8 0-1.547-.404-1.986-1.075l-1.629-2.482a.595.595 0 01.169-.822 1.75 1.75 0 011.336-.25c.407.088.76.337 1.011.668l.399.411V9.651a1 1 0 011.03-.999zM21.492 4a.5.5 0 01.5.5v15a.5.5 0 01-.5.5h-2.07a2.96 2.96 0 00.158-.646l.387-3.092a3 3 0 00-1.612-3.044l-2.868-1.466V9.693c0-1.628-1.305-2.992-2.91-3.04l-.09-.001c-.828 0-1.605.333-2.177.936-.547.577-.822 1.36-.822 2.154v3.595a3.741 3.741 0 00-1.847.614 2.6 2.6 0 00-.741 3.587L8.516 20H2.492a.5.5 0 01-.5-.5v-15a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    touchscreenOutline: '<svg height="24" width="24"><path d="M12.528 8.652c.547.017.969.494.969 1.04v3.625h.507c.105 0 .21.026.303.073L17.455 15a1 1 0 01.537 1.014l-.387 3.093a1 1 0 01-.987.875l-1.687.01.01.009H12.196c-.8 0-1.546-.404-1.985-1.075l-1.629-2.483a.595.595 0 01.169-.822c.407-.268.89-.346 1.336-.25.406.089.76.338 1.011.669l.399.411V9.651a1 1 0 011.03-.999zM21.502 4a.5.5 0 01.5.5v11.022a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V6h-16v12H6.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H2.502a.5.5 0 01-.5-.5v-15a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    trash: '<svg height="24" width="24"><path d="M15.5 3a.5.5 0 01.5.5v1.625h3.502a.5.5 0 01.5.5v.75a.5.5 0 01-.5.5h-.627v13.5a.5.5 0 01-.5.5H5.625a.5.5 0 01-.5-.5v-13.5h-.584a.5.5 0 01-.5-.5v-.75a.5.5 0 01.5-.5h3.502V3.5a.5.5 0 01.5-.5zm1.625 3.875H6.875v12.25h10.25zM10.375 9a.5.5 0 01.5.5v7a.5.5 0 01-.5.5h-.75a.5.5 0 01-.5-.5v-7a.5.5 0 01.5-.5zm4 0a.5.5 0 01.5.5v7a.5.5 0 01-.5.5h-.75a.5.5 0 01-.5-.5v-7a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    trashAlt: '<svg height="24" width="24"><path d="M16.38 2.125a.5.5 0 01.5.5v3.5h4.122a.5.5 0 01.5.5v.75a.5.5 0 01-.5.5h-1.687l-.967 13.536a.5.5 0 01-.499.464H6.151a.5.5 0 01-.499-.464L4.683 7.875h-1.68a.5.5 0 01-.5-.5v-.75a.5.5 0 01.5-.5h4.12v-3.5a.5.5 0 01.5-.5zm1.18 5.75H6.438l.877 12.25h9.37zm-2.43-4H8.873v2.25h6.257z" fill-rule="evenodd"/></svg>',
    tree: '<svg width="24" height="24"><defs><clipPath id="a"><path d="M9.361 0a2 2 0 11-1.23 3.576L3.98 5.973a2 2 0 010 .553l4.154 2.399A2 2 0 019.36 8.5a2 2 0 011.23.424l4.152-2.397a2 2 0 11.75 1.3l-4.152 2.396a2 2 0 01-1.23 2.13v4.795a2 2 0 01.48.276l4.152-2.397a2 2 0 11.75 1.3l-4.152 2.396A2 2 0 019.36 21a2 2 0 01-1.978-2.276l-4.154-2.399a2 2 0 11.751-1.299l4.153 2.399a2 2 0 01.478-.278v-4.795a2 2 0 01-1.228-2.128L3.229 7.825a2 2 0 11.001-3.151l4.152-2.397A2 2 0 019.362 0z"/></clipPath></defs><g clip-path="url(#a)" transform="translate(2.8 1.7)"><path d="M0 0h18.723v21H0V0z"/></g></svg>',
    tutorial: '<svg width="24" height="24"><path d="M11.619 4.2l.115.008c.077.01.154.027.228.052l9.607 3.206c.416.073.757.364.896.752l.044.155.02.125.006.117v5.751l.09.067c.41.336.674.823.718 1.361l.007.163c0 .388-.207.928-.572 1.621-.089.168-.186.342-.29.522-.121.208-.248.417-.376.621l-.373.575-.369.536-.368-.536a21.853 21.853 0 01-1.039-1.718c-.366-.693-.572-1.233-.572-1.621 0-.602.273-1.154.725-1.524l.089-.067v-4.125l-8.243 2.747a1.165 1.165 0 01-.592.039l-.145-.039L1.448 9.73a1.165 1.165 0 010-2.211l9.777-3.26c.127-.042.26-.062.394-.059zm6.028 8.372v3.193l-.077.096c-.197.245-.622.585-1.33.913-1.143.532-2.675.848-4.647.848-1.972 0-3.504-.316-4.647-.848-.707-.328-1.132-.668-1.329-.913l-.077-.096v-3.193l5.39 1.797a2.114 2.114 0 001.326 0l5.39-1.797z"/></svg>',
    tutorialAlt: '<svg width="24" height="24"><path fill-rule="evenodd" d="M11.61 2a.815.815 0 00-.275.042L1.558 5.3a.815.815 0 10.516 1.546l9.52-3.173 9.519 3.173a.815.815 0 10.515-1.546l-9.777-3.26a.815.815 0 00-.24-.04zm0 5.704a.815.815 0 00-.275.04l-9.777 3.26a.815.815 0 000 1.547l9.777 3.259a.815.815 0 00.516 0l8.705-2.901v4.798a1.621 1.621 0 00-.815 1.403c0 .9 1.63 3.26 1.63 3.26S23 20.01 23 19.11c0-.602-.33-1.121-.815-1.403v-5.888a.815.815 0 00-.003-.108v-.015a.815.815 0 00-.02-.12.815.815 0 00-.653-.612l-9.658-3.22a.815.815 0 00-.24-.04zM5.89 15.71v2.584s1.308 1.63 5.703 1.63c4.395 0 5.704-1.63 5.704-1.63v-2.584l-4.93 1.644a2.464 2.464 0 01-1.547 0l-4.93-1.644z"/></svg>',
    tutorialOutline: '<svg width="24" height="24"><path fill-rule="evenodd" d="M11.625 3.754l.145.01c.097.012.193.033.287.064l9.564 3.196c.575.1 1.036.533 1.17 1.093l.018.08.02.14.006.124v5.611l.088.077c.414.384.676.91.72 1.487l.007.174c0 .453-.219 1.026-.607 1.761-.09.172-.19.35-.296.533-.122.211-.25.423-.38.63l-.462.705-.535.774-.67-.976a23.849 23.849 0 01-.707-1.133c-.105-.183-.204-.36-.295-.533-.389-.735-.607-1.308-.607-1.76 0-.645.272-1.24.727-1.662l.087-.077V10.51l-7.848 2.616c-.251.084-.519.098-.775.042l-.152-.042-9.776-3.258a1.465 1.465 0 01-.001-2.78l9.777-3.26c.16-.053.327-.078.495-.074zm-.027 1.3c-.02-.001-.04.002-.057.008L1.763 8.32a.165.165 0 000 .313l9.778 3.26c.034.01.07.01.105 0l9.56-3.187v6.074l-.324.188a.971.971 0 00-.491.841c0 .17.166.604.457 1.154.082.156.172.319.27.487l.176.297.076.122.077-.122.176-.297c.098-.168.188-.33.27-.487.29-.55.457-.985.457-1.154a.971.971 0 00-.491-.841l-.324-.188-.002-6.338-.004-.015c-.015-.063-.067-.112-.226-.147l-9.657-3.22a.168.168 0 00-.048-.008zm6.349 6.955v3.715l-.144.178c-.224.28-.686.65-1.436.998-1.184.55-2.76.875-4.774.875-2.014 0-3.589-.325-4.773-.875-.75-.349-1.212-.717-1.437-.998l-.143-.178V12.01l5.784 1.929a1.814 1.814 0 001.137 0l5.786-1.929zm-1.301 1.803l-4.075 1.36a3.114 3.114 0 01-1.957 0l-4.074-1.36v1.416c.142.116.358.26.666.415l.161.078c1.007.468 2.395.754 4.226.754s3.22-.286 4.226-.754c.395-.184.663-.358.823-.49l.004-1.419z"/></svg>',
    unlock: '<svg height="24" width="24"><path d="M17.808 2.004A5.005 5.005 0 0123 7v2.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V7a3.003 3.003 0 00-3.289-2.986c-1.554.146-2.71 1.512-2.71 3.074V10h2.5a.5.5 0 01.5.5v11a.5.5 0 01-.5.5h-15a.5.5 0 01-.5-.5v-11a.5.5 0 01.5-.5H13V7.123c0-2.708 2.1-5.017 4.807-5.12zM16 12H4v8h12zm-6.442 2.32a.625.625 0 01.884 0l1.238 1.238a.625.625 0 010 .884l-1.238 1.237a.625.625 0 01-.884 0l-1.237-1.237a.625.625 0 010-.884z" fill-rule="evenodd"/></svg>',
    unlockAlt: '<svg height="24" width="24"><path d="M13.945 16.53l-1.414 1.415a.75.75 0 01-1.06 0l-1.415-1.414a.75.75 0 010-1.061l1.414-1.414a.75.75 0 011.06 0l1.415 1.414a.75.75 0 010 1.06M19.501 10H9V7.088c0-1.561 1.156-2.928 2.71-3.074a3.004 3.004 0 013.259 2.558.486.486 0 00.477.428h1.162a.377.377 0 00.375-.405 5.006 5.006 0 00-5.176-4.591C9.102 2.106 7 4.415 7 7.123V10H4.5a.5.5 0 00-.5.5v11a.5.5 0 00.5.5h15a.5.5 0 00.5-.5v-11a.5.5 0 00-.5-.5" fill-rule="evenodd"/></svg>',
    unlockAltOutline: '<svg height="24" width="24"><path d="M11.807 2.004a5.006 5.006 0 015.177 4.59.377.377 0 01-.376.406h-1.161a.487.487 0 01-.477-.428 3.004 3.004 0 00-3.259-2.558c-1.496.14-2.71 1.571-2.71 3.074V10h10.5a.5.5 0 01.5.5v11a.5.5 0 01-.5.5h-15a.5.5 0 01-.5-.5v-11a.5.5 0 01.5-.5H7V7.123c0-2.649 2.16-5.019 4.806-5.12zM18 12H6v8h12zm-6.442 2.32a.625.625 0 01.884 0l1.238 1.238a.625.625 0 010 .884l-1.238 1.237a.625.625 0 01-.884 0l-1.237-1.237a.625.625 0 010-.884z" fill-rule="evenodd"/></svg>',
    unlockOutline: '<svg height="24" width="24"><path d="M11.945 16.53l-1.414 1.415a.75.75 0 01-1.06 0L8.055 16.53a.75.75 0 010-1.061l1.414-1.414a.75.75 0 011.06 0l1.415 1.414a.75.75 0 010 1.06m5.863-14.526C15.102 2.106 13 4.415 13 7.123V10H2.5a.5.5 0 00-.5.5v11a.5.5 0 00.5.5h15a.5.5 0 00.5-.5v-11a.5.5 0 00-.5-.5H15V7.088c0-1.562 1.156-2.928 2.71-3.074A3.003 3.003 0 0121.001 7v2.5a.5.5 0 00.5.5h1a.5.5 0 00.5-.5V7a5.005 5.005 0 00-5.193-4.996" fill-rule="evenodd"/></svg>',
    unsaveColored: '<svg width="24" height="24"><path fill-rule="evenodd" d="M12.5 10a2.5 2.5 0 000 5 2.5 2.5 0 000-5z" opacity=".65"/></svg>',
    upload: '<svg height="24" width="24"><path d="M13 17.5v3c0 .28-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5v-3zM12 3c3.14 0 5.72 2.42 5.97 5.5h.42c2.44 0 4.52 1.9 4.61 4.34a4.5 4.5 0 01-4.5 4.66H13v-6.59l2.17 2.19c.2.2.51.2.71 0l.71-.71c.2-.2.2-.51 0-.71l-4.24-4.24c-.2-.2-.51-.2-.71 0L7.4 11.68c-.2.2-.2.51 0 .71l.71.71c.2.2.51.2.71 0L11 10.91v6.59H6.63c-2.98 0-5.52-2.32-5.63-5.3-.11-3.13 2.4-5.7 5.5-5.7h.05C7.5 4.44 9.58 3 12 3z"/></svg>',
    uploadOutline: '<svg height="24" width="24"><path d="M12.354 8.147l4.243 4.243a.5.5 0 010 .707l-.707.707a.5.5 0 01-.707 0L13 11.62V20.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-8.88l-2.183 2.184a.5.5 0 01-.707 0l-.707-.707a.5.5 0 010-.707l4.243-4.243a.5.5 0 01.707 0zM12 1.999c3.304 0 6.149 2.36 6.837 5.517 2.688.21 4.907 2.324 5.141 4.986a5.456 5.456 0 01-1.499 4.294c-1.06 1.113-2.558 1.702-4.095 1.702H15.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h2.892c.997 0 1.976-.376 2.66-1.102a3.477 3.477 0 00.934-2.718c-.157-1.783-1.733-3.18-3.587-3.18h-1.344l-.066-.79c-.179-2.159-1.67-4.032-3.771-4.558a5.003 5.003 0 00-5.76 2.77l-.27.587L6.46 7.5A4.513 4.513 0 003.18 8.96a4.468 4.468 0 00-1.161 3.45c.202 2.292 2.225 4.087 4.605 4.087H8.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H6.624c-3.407 0-6.305-2.596-6.598-5.912a6.446 6.446 0 011.68-4.976 6.52 6.52 0 014.223-2.086A7.02 7.02 0 0112 1.999z" fill-rule="evenodd"/></svg>',
    url: '<svg height="24" width="24"><path d="M15.58 7.22c.2-.2.51-.2.71 0l4.34 4.34c1.8 1.8 1.8 4.74 0 6.54-.9.9-2.09 1.35-3.27 1.35s-2.37-.45-3.27-1.35l-4.34-4.34c-.2-.2-.2-.51 0-.71l.72-.72c.2-.2.51-.2.71 0l4.34 4.34c.5.49 1.15.76 1.85.76s1.36-.27 1.85-.76a2.607 2.607 0 000-3.69l-4.34-4.34c-.2-.2-.2-.51 0-.71zM6.62 4.56c1.18 0 2.37.45 3.27 1.35l4.35 4.33c.2.2.2.51 0 .71l-.72.72c-.2.2-.51.2-.71 0L8.47 7.33c-.5-.49-1.15-.76-1.85-.76s-1.36.27-1.85.76a2.607 2.607 0 000 3.69l4.34 4.34c.2.2.2.51 0 .71l-.71.72c-.2.2-.51.2-.71 0l-4.34-4.34c-1.8-1.8-1.8-4.74 0-6.54.9-.9 2.09-1.35 3.27-1.35z" fill-rule="evenodd"/></svg>',
    user: '<svg width="24" height="24"><path fill-rule="evenodd" d="M12 2.3a5.142 5.142 0 00-5.143 5.147c0 2.844 2.3 5.146 5.143 5.146a5.142 5.142 0 005.143-5.146c0-2.845-2.3-5.147-5.143-5.147zm0 2.573a2.57 2.57 0 012.571 2.574 2.57 2.57 0 11-5.142 0A2.57 2.57 0 0112 4.873zm0 9.007c-6.835 0-9 5.147-9 5.147V21.6h18v-2.573s-2.165-5.147-9-5.147zm0 2.573c4.415 0 5.826 2.574 5.826 2.574H6.174S7.641 16.453 12 16.453z"/></svg>',
    wave: '<svg width="24" height="24"><path fill-rule="evenodd" d="M7.29 1.5a1.044 1.044 0 00-1.03 1.058v9.391a1.044 1.044 0 102.088 0V2.558A1.044 1.044 0 007.289 1.5zM4.158 5.674A1.044 1.044 0 003.13 6.732v5.217a1.044 1.044 0 102.086 0V6.732A1.044 1.044 0 004.16 5.674zm6.26.522a1.044 1.044 0 00-1.028 1.058v4.695a1.044 1.044 0 102.087 0V7.254a1.044 1.044 0 00-1.058-1.058zM1.03 8.283A1.044 1.044 0 000 9.34v2.608a1.044 1.044 0 102.087 0V9.341a1.044 1.044 0 00-1.059-1.058zm12.52 2.608a1.044 1.044 0 00-1.027 1.058v4.696a1.044 1.044 0 102.087 0v-4.696a1.044 1.044 0 00-1.06-1.058zm3.131 0a1.044 1.044 0 00-1.028 1.058v9.391a1.044 1.044 0 102.087 0v-9.39a1.044 1.044 0 00-1.059-1.059zm3.13 0a1.044 1.044 0 00-1.027 1.058v5.218a1.044 1.044 0 102.086 0v-5.218a1.044 1.044 0 00-1.058-1.058zm3.131 0a1.044 1.044 0 00-1.028 1.058v2.609a1.044 1.044 0 102.087 0v-2.609a1.044 1.044 0 00-1.059-1.058z"/></svg>',
    waveOutline: '<svg width="24" height="24"><path fill-rule="evenodd" d="M7.188 1.85a.8.8 0 00-.788.812v9.6a.8.8 0 101.6 0v-9.6a.8.8 0 00-.812-.812zm-3.2 4.267a.8.8 0 00-.788.811v5.334a.8.8 0 101.6 0V6.928a.8.8 0 00-.812-.811zm6.4.533a.8.8 0 00-.788.812v4.8a.8.8 0 101.6 0v-4.8a.8.8 0 00-.812-.812zm-9.6 2.133A.8.8 0 000 9.595v2.667a.8.8 0 101.6 0V9.595a.8.8 0 00-.812-.812zm12.8 2.134a.8.8 0 00-.788.811v4.8a.8.8 0 101.6 0v-4.8a.8.8 0 00-.813-.811zm3.2 0a.8.8 0 00-.788.811v9.6a.8.8 0 101.6 0v-9.6a.8.8 0 00-.813-.811zm3.2 0a.8.8 0 00-.788.811v5.334a.8.8 0 101.6 0v-5.334a.8.8 0 00-.813-.811zm3.2 0a.8.8 0 00-.788.811v2.667a.8.8 0 101.6 0v-2.667a.8.8 0 00-.813-.811z"/></svg>',
    api: '<svg width="24" height="24"><defs><clipPath id="a"><path d="M20.308 0C21.243 0 22 .757 22 1.692v13.539c0 .935-.757 1.692-1.692 1.692H1.692A1.692 1.692 0 010 15.231V1.692C0 .757.757 0 1.692 0zM6.55 5.077H4.444l-2.27 6.77h1.708l.436-1.488h2.21l.423 1.487h1.876L6.55 5.076zm6.568 0h-2.965v6.77h1.72V9.86h1.142c1.506 0 2.542-.941 2.542-2.381 0-1.455-.985-2.403-2.44-2.403zm6.37 0h-1.72v6.77h1.72v-6.77zM5.478 6.602l.727 2.519H4.646l.742-2.519h.089zm7.187-.203c.727 0 1.153.37 1.154 1.084 0 .703-.432 1.08-1.164 1.08h-.778V6.398z"/></clipPath></defs><g clip-path="url(#a)" transform="translate(1 4)"><path d="M0 0h22v16.923H0V0z"/></g></svg>',
    apiOutline: '<svg width="24" height="24"><path fill-rule="evenodd" d="M4.606 8h2.419l2.611 7.77H7.484l-.486-1.708H4.462l-.5 1.707H2L4.606 8zm6.554 0h3.402c1.67 0 2.8 1.089 2.8 2.758 0 1.653-1.19 2.733-2.917 2.733h-1.31v2.278H11.16V8zm8.74 0h1.975v7.77H19.9V8zm-6.764 1.517V12h.893c.84 0 1.336-.431 1.336-1.238-.001-.819-.49-1.245-1.324-1.245h-.905zm-7.447.234l-.851 2.89h1.788l-.834-2.89h-.103z"/></svg>',
    array: '<svg height="24" width="24"><path d="M18.502 19h-4a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h2.5V7h-2.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h4a.5.5 0 01.5.5v13a.5.5 0 01-.5.5m-9-12h-2.5v10h2.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-4a.5.5 0 01-.5-.5v-13a.5.5 0 01.5-.5h4a.5.5 0 01.5.5v1a.5.5 0 01-.5.5m-6.5-3.5v17a.5.5 0 00.5.5h17a.5.5 0 00.5-.5v-17a.5.5 0 00-.5-.5h-17a.5.5 0 00-.5.5" fill-rule="evenodd"/></svg>',
    arrayOutline: '<svg height="24" width="24"><path d="M9 4a.5.5 0 01.5.5v1A.5.5 0 019 6H6v12h3a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H4.5a.5.5 0 01-.5-.5v-15a.5.5 0 01.5-.5zm10.5 0a.5.5 0 01.5.5v15a.5.5 0 01-.5.5H15a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h3V6h-3a.5.5 0 01-.5-.5v-1A.5.5 0 0115 4z" fill-rule="evenodd"/></svg>',
    boolean: '<svg height="24" width="24"><path d="M20.5 3a.5.5 0 01.5.5v17a.5.5 0 01-.5.5h-17a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5zM7.85 7.42c-.86 0-1.603.256-2.231.782-.629.526-.988 1.18-1.078 1.962-.026.27-.038.898-.038 1.86v.236c.002.841.015 1.39.038 1.636.09.783.45 1.437 1.078 1.963.628.525 1.372.782 2.231.782.86 0 1.59-.257 2.219-.782.628-.526 1-1.18 1.09-1.963.026-.269.038-.897.038-1.872v-.233c-.002-.831-.014-1.38-.038-1.627-.09-.782-.462-1.436-1.09-1.962-.629-.526-1.36-.782-2.219-.782zm10.65.074h-2.284a.5.5 0 00-.5.5v.795a.5.5 0 00.5.5h.809v6.644a.5.5 0 00.5.5h.975a.5.5 0 00.5-.5V7.994a.5.5 0 00-.5-.5zM7.85 9.215c.705 0 1.257.513 1.347 1.219.012.205.025.73.025 1.59v.217c-.002.77-.015 1.25-.038 1.437-.064.68-.629 1.167-1.334 1.167-.705 0-1.27-.487-1.334-1.167-.025-.205-.038-.756-.038-1.654v-.208c.002-.737.014-1.194.025-1.382.09-.706.642-1.219 1.347-1.219zM13.5 12.5a1 1 0 100 2 1 1 0 000-2zm0-3a1 1 0 100 2 1 1 0 000-2z" fill-rule="evenodd"/></svg>',
    booleanOutline: '<svg height="24" width="24"><path d="M7.06 6.881c.927 0 1.71.285 2.38.87a3.304 3.304 0 011.155 2.18c.026.29.04.907.042 1.852v.243c0 1.098-.014 1.796-.042 2.11-.1.869-.485 1.596-1.154 2.18-.67.584-1.454.87-2.38.87-.927 0-1.725-.286-2.395-.87a3.287 3.287 0 01-1.14-2.18c-.026-.29-.04-.907-.043-1.864v-.246c0-1.083.015-1.781.043-2.095.1-.87.47-1.596 1.14-2.18.67-.585 1.468-.87 2.394-.87zM19.502 7a.5.5 0 01.5.5v8.933a.5.5 0 01-.5.5h-.782a.5.5 0 01-.5-.5V8.61h-.91a.5.5 0 01-.5-.5V7.5a.5.5 0 01.5-.5zM7.06 8.506c-.47 0-.869.157-1.225.47-.342.3-.542.699-.585 1.17-.014.241-.028.868-.028 1.88 0 1.04.014 1.682.043 1.924.071.926.84 1.61 1.795 1.61s1.725-.684 1.796-1.61c.027-.223.04-.787.043-1.69v-.234a41.25 41.25 0 00-.029-1.88 1.676 1.676 0 00-.598-1.17 1.726 1.726 0 00-1.212-.47zm6.69 4.244a1 1 0 110 2 1 1 0 010-2zm0-3.5a1 1 0 110 2 1 1 0 010-2z" fill-rule="evenodd"/></svg>',
    bug: '<svg width="24" height="24"><path fill-rule="evenodd" d="M7.855 3.146a.5.5 0 01.707 0l1.793 1.794c.072.071.117.16.136.253a5.997 5.997 0 013.02 0 .498.498 0 01.135-.253l1.794-1.794a.5.5 0 01.707 0l.707.707a.5.5 0 010 .707l-1.48 1.481a6.038 6.038 0 012.077 2.457l1.579-1.05a.5.5 0 01.693.139l.554.832a.5.5 0 01-.14.693l-2.156 1.436c.011.15.019.3.019.452v1h2.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H18v1c0 .152-.008.303-.019.453l2.158 1.438a.5.5 0 01.138.693l-.554.832a.5.5 0 01-.694.139l-1.578-1.052A6.007 6.007 0 0112 21a6.007 6.007 0 01-5.451-3.497l-1.576 1.051a.5.5 0 01-.694-.138l-.555-.832a.5.5 0 01.139-.693l2.156-1.438C6.007 15.303 6 15.153 6 15v-1H3.502a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5H6v-1c0-.154.008-.306.02-.457L3.862 9.104a.5.5 0 01-.139-.693l.555-.832a.5.5 0 01.694-.139l1.578 1.053A6.038 6.038 0 018.628 6.04l-1.48-1.48a.5.5 0 010-.707zM12 7c-2.206 0-4 1.795-4 4v4c0 2.206 1.794 4 4 4 2.205 0 4-1.794 4-4v-4c0-2.205-1.795-4-4-4zm.354 3.44l.707.707a.5.5 0 010 .707l-.707.707a.5.5 0 01-.708 0l-.707-.707a.5.5 0 010-.707l.707-.707a.5.5 0 01.708 0z"/></svg>',
    bugAlt: '<svg width="24" height="24"><path fill-rule="evenodd" d="M7.855 3.146a.5.5 0 01.707 0l1.794 1.794c.072.071.117.16.135.253a5.997 5.997 0 013.02 0 .498.498 0 01.136-.253l1.793-1.794a.5.5 0 01.707 0l.707.707a.5.5 0 010 .707l-1.48 1.481a6.038 6.038 0 012.078 2.457l1.578-1.05a.5.5 0 01.693.139l.554.832a.5.5 0 01-.139.693l-2.157 1.436c.012.15.019.3.019.452v1h2.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H18v1c0 .152-.007.303-.019.453l2.158 1.438a.5.5 0 01.138.693l-.554.832a.5.5 0 01-.694.139l-1.578-1.052A6.007 6.007 0 0112 21a6.007 6.007 0 01-5.45-3.497l-1.577 1.051a.5.5 0 01-.693-.138l-.555-.832a.5.5 0 01.138-.693l2.156-1.438C6.008 15.303 6 15.153 6 15v-1H3.502a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5H6v-1c0-.154.008-.306.02-.457L3.862 9.104a.5.5 0 01-.138-.693l.555-.832a.5.5 0 01.693-.139l1.578 1.053A6.038 6.038 0 018.628 6.04l-1.48-1.48a.5.5 0 010-.707zM12 7c-2.205 0-4 1.795-4 4v4c0 2.206 1.795 4 4 4 2.206 0 4-1.794 4-4v-4c0-2.205-1.794-4-4-4zm.5 4a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5z"/></svg>',
    bugAlt2: '<svg width="24" height="24"><path fill-rule="evenodd" d="M8.354 2.646a.5.5 0 01.707 0l1.68 1.682c.38-.21.812-.326 1.26-.326.446 0 .877.116 1.257.326l1.681-1.682a.5.5 0 01.707 0l.708.707a.5.5 0 010 .707l-1.755 1.756c.492.78.988 1.69 1.402 2.692l2.079-1.143a.5.5 0 01.679.197l.482.876a.5.5 0 01-.197.68l-2.4 1.32c.208.82.337 1.68.351 2.562H19.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-2.518a.49.49 0 01-.143-.023c-.135.77-.347 1.505-.607 2.197l2.855 1.711a.5.5 0 01.17.686l-.515.857a.5.5 0 01-.686.172l-2.662-1.596c-.416.77-.866 1.457-1.291 2.036-.496.677-1.263.96-2.103.96-.84 0-1.607-.283-2.103-.96A17.618 17.618 0 018.604 19l-2.66 1.6a.5.5 0 01-.686-.172l-.516-.857a.5.5 0 01.171-.686l2.853-1.715a12.27 12.27 0 01-.605-2.193.49.49 0 01-.143.023H4.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h2.505c.014-.882.143-1.741.35-2.563l-2.399-1.32a.5.5 0 01-.197-.68l.482-.875a.5.5 0 01.68-.197l2.078 1.143a17.93 17.93 0 011.403-2.692L7.646 4.06a.5.5 0 010-.707zM12 6.002a.601.601 0 00-.5.26C10.36 7.92 9 10.464 9 13.164c0 2.703 1.365 5.027 2.51 6.588A.604.604 0 0012 20a.605.605 0 00.49-.248c1.145-1.561 2.51-3.885 2.51-6.588 0-2.7-1.36-5.244-2.501-6.902a.6.6 0 00-.499-.26zm.354 3.437l.707.707a.5.5 0 010 .708l-.707.707a.5.5 0 01-.708 0l-.707-.707a.5.5 0 010-.708l.707-.707a.5.5 0 01.708 0z"/></svg>',
    bugAlt3: '<svg width="24" height="24"><path fill-rule="evenodd" d="M12.49 19.752A.604.604 0 0112 20a.604.604 0 01-.49-.248C10.365 18.191 9 15.867 9 13.164c0-2.7 1.36-5.244 2.5-6.902a.601.601 0 01.5-.26.6.6 0 01.5.26c1.14 1.658 2.5 4.202 2.5 6.902 0 2.703-1.365 5.027-2.51 6.588M19.5 13h-2.505a11.214 11.214 0 00-.35-2.563l2.399-1.32a.5.5 0 00.197-.68l-.482-.875a.5.5 0 00-.68-.197l-2.078 1.143A17.954 17.954 0 0014.6 5.816l1.755-1.756a.5.5 0 000-.707l-.708-.707a.5.5 0 00-.707 0l-1.68 1.682c-.38-.21-.812-.326-1.259-.326-.447 0-.878.116-1.258.326L9.06 2.646a.5.5 0 00-.707 0l-.708.707a.5.5 0 000 .707l1.756 1.756a17.93 17.93 0 00-1.403 2.692L5.92 7.365a.5.5 0 00-.679.197l-.482.876a.5.5 0 00.197.68l2.4 1.32c-.208.82-.337 1.68-.351 2.562H4.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h2.518a.49.49 0 00.143-.023c.135.768.346 1.502.605 2.193l-2.853 1.715a.5.5 0 00-.17.686l.515.857a.5.5 0 00.686.172l2.66-1.6c.417.773.868 1.46 1.293 2.04.496.677 1.263.96 2.103.96.84 0 1.607-.283 2.103-.96.425-.579.875-1.265 1.291-2.036l2.662 1.596a.5.5 0 00.686-.172l.516-.857a.5.5 0 00-.171-.686l-2.855-1.71c.26-.693.472-1.429.607-2.198a.49.49 0 00.143.023H19.5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5"/></svg>',
    cdn: '<svg width="24" height="24"><path fill-rule="evenodd" d="M21.308 4C22.243 4 23 4.757 23 5.692v13.539c0 .935-.757 1.692-1.692 1.692H2.692A1.692 1.692 0 011 19.231V5.692C1 4.757 1.757 4 2.692 4zM5.022 8.971c-.5 0-.952.089-1.355.267a2.918 2.918 0 00-1.021.74 3.28 3.28 0 00-.635 1.099c-.146.417-.219.868-.219 1.352 0 .474.073.916.22 1.328a3.2 3.2 0 00.635 1.08c.277.31.618.552 1.02.727.404.175.855.262 1.355.262.403 0 .775-.061 1.113-.184a2.611 2.611 0 001.507-1.394c.153-.332.248-.703.285-1.112l-.096-.109-1.383-.053-.101.079c-.1.454-.237.76-.447.987-.207.226-.497.339-.878.339-.286 0-.525-.054-.718-.162a1.359 1.359 0 01-.475-.431 1.927 1.927 0 01-.273-.624 3.042 3.042 0 01-.088-.733c0-.263.03-.518.088-.764.057-.24.148-.454.273-.641.121-.182.28-.327.475-.435.193-.107.432-.162.718-.162a1.284 1.284 0 011.085.593c.071.114.117.24.137.378l.082.102 1.4.025.1-.099a2.074 2.074 0 00-.269-1.089 2.497 2.497 0 00-.64-.75 2.798 2.798 0 00-.87-.46 3.307 3.307 0 00-1.025-.156zm6.985.15H9.303l-.12.077-.029 6.34.099.1 2.752.048c.503 0 .94-.085 1.315-.255.374-.17.687-.404.938-.702a2.93 2.93 0 00.56-1.054c.122-.4.182-.836.182-1.307 0-.538-.074-1.009-.224-1.413a2.823 2.823 0 00-.63-1.018 2.597 2.597 0 00-.96-.614 3.376 3.376 0 00-1.179-.203zm8.393 0l-.103.098-.045 3.809-2.362-3.837-1.495-.07-.12.077-.03 6.34.096.099 1.34.049.103-.099.043-3.802 2.355 3.83 1.504.07.101-.098.049-6.317-.096-.1-1.34-.05zm-9.57 1.412l.83.043c.325 0 .592.046.803.134.208.087.373.21.498.37.127.165.219.364.275.599.059.242.088.516.088.82 0 .33-.04.605-.122.827-.081.221-.187.398-.318.531-.13.133-.277.227-.442.284l-.134.04-.129.027a1.648 1.648 0 01-.268.022l-1.081-.002v-3.695z"/></svg>',
    cdnOutline: '<svg width="24" height="24"><path fill-rule="evenodd" d="M4.354 8.3c.391 0 .762.057 1.112.17.35.113.666.28.945.498.28.22.511.491.693.814.2.356.299.733.292 1.182l-.109.106-1.518-.026-.089-.111a1.06 1.06 0 00-.149-.41 1.342 1.342 0 00-.703-.562 1.393 1.393 0 00-.474-.081c-.31 0-.57.059-.779.175a1.457 1.457 0 00-.515.472 2.134 2.134 0 00-.296.696 3.56 3.56 0 00-.096.829c0 .272.032.537.095.794.062.252.161.477.296.677.132.195.303.35.516.468.21.117.469.175.78.175.413 0 .727-.122.952-.367.227-.246.376-.579.484-1.071l.11-.085 1.5.057.104.118c-.04.444-.143.846-.31 1.206-.167.362-.389.671-.665.927s-.6.451-.968.586c-.368.133-.77.2-1.208.2a3.647 3.647 0 01-1.469-.285 3.171 3.171 0 01-1.108-.788 3.47 3.47 0 01-.69-1.173 4.268 4.268 0 01-.237-1.44c0-.525.08-1.014.238-1.467.159-.454.388-.852.688-1.191.301-.342.671-.61 1.108-.803.437-.193.927-.29 1.47-.29zm7.578.162c.456 0 .883.073 1.28.22.399.147.746.37 1.039.666.293.296.52.665.684 1.105.163.438.243.948.243 1.532 0 .51-.065.984-.197 1.418-.133.44-.336.821-.607 1.143a2.861 2.861 0 01-1.019.762c-.406.185-.88.276-1.425.276l-2.987-.053-.106-.108.032-6.876.13-.085h2.933zm9.105 0l1.452.053.105.11-.053 6.852-.11.107-1.63-.076-2.556-4.155-.047 4.124-.112.107-1.453-.053-.104-.108.031-6.876.132-.085 1.621.076 2.563 4.163.048-4.132.113-.107zM10.655 9.994v4.009l1.172.001c.099 0 .196-.007.29-.023l.14-.03.146-.042c.179-.062.339-.164.48-.308.142-.145.257-.337.345-.576.088-.242.133-.54.133-.897 0-.33-.032-.628-.096-.89a1.692 1.692 0 00-.3-.65 1.296 1.296 0 00-.539-.402c-.23-.096-.518-.144-.872-.144l-.9-.048z"/></svg>',
    code: '<svg height="24" width="24"><path d="M15.44 6.15c.2-.2.51-.2.71 0l5.5 5.5c.2.2.2.51 0 .71l-5.5 5.5c-.2.2-.51.2-.71 0l-.71-.71c-.2-.2-.2-.51 0-.71L19.17 12l-4.44-4.43c-.2-.2-.2-.51 0-.71zm-7.59 0c.2-.2.51-.2.71 0l.71.7c.19.2.19.52 0 .71L4.83 12l4.44 4.44c.2.2.2.51 0 .71l-.71.71c-.2.2-.51.2-.71 0l-5.5-5.5c-.2-.2-.2-.51 0-.71z" fill-rule="evenodd"/></svg>',
    date: '<svg height="24" width="24"><path d="M11.346 10.355l-1.997 1.997a.5.5 0 01-.707 0l-1.997-1.997a.5.5 0 010-.707L8.642 7.65a.5.5 0 01.707 0l1.997 1.997a.5.5 0 010 .707M20.502 4h-3.504V2.5a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5V4h-6V2.5a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5V4H3.496a.5.5 0 00-.5.5v16a.5.5 0 00.5.5h17.005a.5.5 0 00.5-.5v-16a.5.5 0 00-.5-.5" fill-rule="evenodd"/></svg>',
    dateOutline: '<svg height="24" width="24"><path d="M8.497 2a.5.5 0 01.5.5V4h6V2.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5V4h3.505a.5.5 0 01.5.5v16a.5.5 0 01-.5.5H3.497a.5.5 0 01-.5-.5v-16a.5.5 0 01.5-.5h3.5V2.5a.5.5 0 01.5-.5zm10.505 4H4.997v13h14.005zM9.35 8.144l1.504 1.504a.5.5 0 010 .707l-1.504 1.503a.5.5 0 01-.707 0l-1.503-1.503a.5.5 0 010-.707l1.503-1.504a.5.5 0 01.707 0z" fill-rule="evenodd"/></svg>',
    fork: '<svg width="24" height="24"><path fill-rule="evenodd" d="M16.536 3a2.893 2.893 0 01.964 5.62v1.13a2.893 2.893 0 01-2.893 2.892H12.68v2.736a2.894 2.894 0 11-1.929 0v-2.736H8.822a2.893 2.893 0 01-2.893-2.893V8.62a2.893 2.893 0 111.928 0v1.13a.964.964 0 00.965.963h5.785a.964.964 0 00.965-.964V8.62A2.893 2.893 0 0116.536 3zm-4.822 14.142a.964.964 0 100 1.928.964.964 0 000-1.928zM6.894 4.928a.964.964 0 100 1.928.964.964 0 000-1.928zm9.642 0a.964.964 0 100 1.928.964.964 0 000-1.928z"/></svg>',
    int: '<svg height="24" width="24"><path d="M19.165 15.663c-.628.603-1.475.898-2.526.898-1.382 0-2.553-.575-3.207-1.52a.253.253 0 01.068-.358l1.12-.719a.247.247 0 01.335.063c.355.496.904.739 1.645.739.91 0 1.59-.526 1.59-1.296 0-.718-.68-1.257-1.718-1.257-.288 0-.55.025-.788.074a.25.25 0 01-.268-.11l-.424-.694a.25.25 0 01.049-.319l2.15-1.875h-2.855a.25.25 0 01-.25-.25V7.744a.25.25 0 01.25-.25h5.182a.25.25 0 01.25.25v.94a.5.5 0 01-.164.37l-1.901 1.723h.013c1.5.167 2.41 1.244 2.41 2.642 0 .898-.32 1.642-.96 2.244zm-6.368.837c0 .99-.805 1.795-1.795 1.795v-.897a.899.899 0 00.898-.898h-.898v-1.796h1.795zm-2.54-.25a.25.25 0 01-.25.25H4.12a.25.25 0 01-.25-.25v-.837a.5.5 0 01.148-.355l3.79-3.752c.346-.36.512-.731.512-1.103 0-.616-.513-1.09-1.141-1.09-.601 0-1.098.458-1.19 1.084a.247.247 0 01-.246.211H4.464a.253.253 0 01-.25-.278c.06-.714.35-1.326.862-1.838a2.846 2.846 0 012.116-.885c.808 0 1.487.27 2.052.82.577.552.859 1.206.859 1.976 0 .808-.385 1.59-1.141 2.321l-2.194 2.18h3.239a.25.25 0 01.25.25zM3.002 3.5v17a.5.5 0 00.5.5h17a.5.5 0 00.5-.5v-17a.5.5 0 00-.5-.5h-17a.5.5 0 00-.5.5z" fill-rule="evenodd"/></svg>',
    intOutline: '<svg height="24" width="24"><path d="M12.813 15.375V17l-.006.14a1.627 1.627 0 01-1.62 1.485v-.813A.813.813 0 0012 17h-.812v-1.625zm7.937-8.376a.25.25 0 01.25.25v.77a.5.5 0 01-.162.37l-2.475 2.273c.043-.014.1-.014.171-.014.813.043 1.497.356 2.038.94.542.57.813 1.27.813 2.081 0 .998-.343 1.825-1.041 2.466-.698.641-1.596.969-2.708.969-1.589 0-2.903-.663-3.578-1.767a.253.253 0 01.084-.352l.983-.575a.247.247 0 01.333.078c.422.66 1.138.991 2.15.991 1.183 0 2.052-.727 2.052-1.767 0-1.012-.84-1.739-2.195-1.739-.317 0-.625.04-.915.109a.252.252 0 01-.278-.114l-.383-.645a.25.25 0 01.047-.313l2.67-2.4h-3.527a.25.25 0 01-.25-.25V7.25a.25.25 0 01.25-.25zM6.565 6.881c.84 0 1.567.3 2.166.884.613.584.912 1.283.912 2.109 0 .84-.385 1.682-1.169 2.494L5.596 15.39h3.996a.25.25 0 01.25.25v1.11a.25.25 0 01-.25.25h-6.34a.25.25 0 01-.25-.25v-.704a.5.5 0 01.138-.345l4.265-4.473c.41-.437.609-.874.613-1.339.007-.768-.638-1.41-1.405-1.439-.592-.022-1.07.27-1.434.836-.095.147-.116.323-.126.498a.248.248 0 01-.247.233h-1.13a.252.252 0 01-.25-.273c.056-.75.354-1.389.901-1.936a3.067 3.067 0 012.238-.927z" fill-rule="evenodd"/></svg>',
    npm: '<svg width="24" height="24"><path fill-rule="evenodd" d="M0 7v8.25h6.75v1.5H12v-1.5h12V7H0zm1.333 1.333h5.335v5.751H5.333V9.667H4v4.417H1.333V8.333zm6.668 0h5.333v5.75h-2.667v1.334H8.001V8.333zm6.666 0h8.001v5.751h-1.334V9.667h-1.333v4.417h-1.333V9.667h-1.335v4.417h-2.666V8.333zm-4 1.334v3.084H12V9.667h-1.333z"/></svg>',
    npmOutline: '<svg width="24" height="24"><path fill-rule="evenodd" d="M1.733 8.333h5.335v5.751H5.733V9.667H4.4v4.417H1.733V8.333zm6.268 0h5.333v5.75h-2.667v1.334H8.001V8.333zm6.266 0h8.001v5.751h-1.334V9.667h-1.333v4.417h-1.333V9.667h-1.335v4.417h-2.666V8.333zm-3.6 1.334v3.084H12V9.667h-1.333z"/></svg>',
    object: '<svg height="24" width="24"><path d="M20 12.432c0 .195-.145.36-.338.385-.964.118-1.581.808-1.367 2.456.064.495.14.972.14 1.468 0 1.3-.836 2.267-1.962 2.259H14.39c-.215 0-.389-.155-.389-.37v-1.225c0-.214.173-.404.387-.405h1.093c.852 0 1.28-.061 1.28-.858 0-.407-.26-1.355-.26-2.18 0-1.131.445-1.713 1.2-1.923l.087-.02v-.038l-.086-.02c-.756-.21-1.201-.792-1.201-1.923 0-.825.26-1.773.26-2.18 0-.796-.428-.858-1.28-.858h-1.093c-.214-.001-.387-.19-.387-.405V5.37c0-.215.174-.37.39-.37.512 0 1.816.002 2.083 0 1.126-.008 1.962.959 1.962 2.26 0 .495-.076.972-.14 1.468-.214 1.648.403 2.337 1.367 2.456.193.024.338.19.338.384zM10 6.595C10 6.81 9.828 7 9.613 7H8.521c-.853 0-1.28.062-1.28.859 0 .406.26 1.354.26 2.179 0 1.131-.445 1.713-1.201 1.923l-.087.02v.038l.087.02c.756.21 1.2.792 1.2 1.924 0 .824-.26 1.772-.26 2.179 0 .797.428.858 1.28.858h1.093c.215.001.387.19.387.405v1.225c0 .215-.174.37-.39.37H7.528c-1.126.008-1.962-.959-1.962-2.26 0-.495.076-.972.14-1.467.214-1.648-.403-2.338-1.366-2.456A.388.388 0 014 12.432v-.864c0-.195.145-.36.339-.384.963-.119 1.58-.808 1.366-2.456-.064-.496-.14-.973-.14-1.468 0-1.301.836-2.268 1.962-2.26.268.002 1.571 0 2.084 0 .215 0 .39.155.39.37zM20.5 3h-17a.5.5 0 00-.5.5v17a.5.5 0 00.5.5h17a.5.5 0 00.5-.5v-17a.5.5 0 00-.5-.5z" fill-rule="evenodd"/></svg>',
    objectOutline: '<svg height="24" width="24"><path d="M17.97 4c1.286-.009 2.241 1.096 2.241 2.582 0 .567-.086 1.111-.16 1.678-.244 1.884.461 2.671 1.562 2.807a.443.443 0 01.387.44v.986a.442.442 0 01-.387.44c-1.101.135-1.806.923-1.561 2.807.073.567.16 1.111.16 1.678 0 1.486-.956 2.59-2.243 2.582h-2.524c-.246 0-.445-.177-.445-.423V18.47a.46.46 0 01.442-.463h1.392c.974 0 1.463-.07 1.463-.98 0-.465-.08-.734-.143-1.22-.08-.505-.154-1.018-.154-1.564 0-1.294.508-1.959 1.372-2.199l.1-.022v-.044l-.1-.022C18.508 11.716 18 11.05 18 9.757c0-.546.074-1.059.154-1.563.063-.487.143-.756.143-1.22 0-.91-.489-.982-1.463-.982h-.467l-.14.001h-.785C15.197 5.99 15 5.774 15 5.53V4.423c0-.246.2-.423.445-.423zM8.554 4c.246 0 .445.177.445.423V5.53a.46.46 0 01-.442.462l-.219.001H7.166c-.974 0-1.463.07-1.463.98 0 .465.08.734.143 1.22.08.505.154 1.018.154 1.564 0 1.293-.508 1.959-1.372 2.199l-.099.022v.044l.1.022c.863.24 1.371.905 1.371 2.199 0 .546-.074 1.059-.154 1.563-.063.487-.143.756-.143 1.22 0 .911.49.981 1.463.981H8.56A.46.46 0 019 18.47v1.107c0 .246-.199.423-.445.423H6.031c-1.287.009-2.242-1.096-2.242-2.582 0-.567.086-1.111.16-1.678.244-1.884-.46-2.672-1.562-2.807a.442.442 0 01-.387-.44v-.986c0-.223.166-.413.387-.44 1.101-.136 1.806-.923 1.562-2.807-.074-.567-.16-1.111-.16-1.678 0-1.486.955-2.59 2.242-2.582z" fill-rule="evenodd"/></svg>',
    pnpm: '<svg width="24" height="24"><path fill-rule="evenodd" d="M22 8h-6V2h6v6zm-7 0H9V2h6v6zM8 8H2V2h6v6zm14 7h-6V9h6v6zm-7 0H9V9h6v6zm0 7H9v-6h6v6zm7 0h-6v-6h6v6zM8 22H2v-6h6v6z"/></svg>',
    pnpmOutline: '<svg width="24" height="24"><path fill-rule="evenodd" d="M15 16v6H9v-6h6zm7 0v6h-6v-6h6zM8 16v6H2v-6h6zm13 1h-4v4h4v-4zm-7 0h-4v4h4v-4zm-7 0H3v4h4v-4zm15-8v6h-6V9h6zm-7 0v6H9V9h6zm6 1h-4v4h4v-4zm-7 0h-4v4h4v-4zm8-8v6h-6V2h6zm-7 0v6H9V2h6zM8 2v6H2V2h6zm13 1h-4v4h4V3zm-7 0h-4v4h4V3zM7 3H3v4h4V3z"/></svg>',
    properties: '<svg width="24" height="24"><path fill-rule="evenodd" d="M21.5 7h-13a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h13a.5.5 0 01.5.5v1a.5.5 0 01-.5.5m0 6h-13a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h13a.5.5 0 01.5.5v1a.5.5 0 01-.5.5m0 6h-13a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h13a.5.5 0 01.5.5v1a.5.5 0 01-.5.5m-18.755-.814V5.808a.5.5 0 01.098-.297l.642-.87c.144-.195.377-.195.521 0l.642.87a.5.5 0 01.097.297v12.378a.5.5 0 01-.097.297l-.642.87c-.144.195-.377.195-.521 0l-.642-.87a.5.5 0 01-.098-.297z"/></svg>',
    state: '<svg height="24" width="24"><path d="M2.53 10.97l.94-.94c.29-.29.77-.29 1.06 0l.94.94c.29.29.29.77 0 1.06l-.94.94c-.29.29-.77.29-1.06 0l-.94-.94a.754.754 0 010-1.06zm9-1.71l1.71 1.71c.29.29.29.77 0 1.06l-1.71 1.71c-.29.29-.77.29-1.06 0l-1.71-1.71a.754.754 0 010-1.06l1.71-1.71c.29-.29.77-.29 1.06 0zm5 2.77l1.94 1.94c.29.29.77.29 1.06 0l1.94-1.94c.29-.29.29-.77 0-1.06l-1.94-1.94a.754.754 0 00-1.06 0l-1.94 1.94c-.29.29-.29.77 0 1.06z"/></svg>',
    stateColored: '<svg height="24" width="24"><g fill-rule="nonzero" fill="currentColor"><path d="M2.53 10.97l.94-.94c.29-.29.77-.29 1.06 0l.94.94c.29.29.29.77 0 1.06l-.94.94c-.29.29-.77.29-1.06 0l-.94-.94a.754.754 0 010-1.06z" opacity=".45"/><path d="M11.535 9.26l1.71 1.71c.29.29.29.77 0 1.06l-1.71 1.71c-.29.29-.77.29-1.06 0l-1.71-1.71a.754.754 0 010-1.06l1.71-1.71c.29-.29.77-.29 1.06 0z" opacity=".65"/><path d="M16.54 12.03l1.94 1.94c.29.29.77.29 1.06 0l1.94-1.94c.29-.29.29-.77 0-1.06l-1.94-1.94a.754.754 0 00-1.06 0l-1.94 1.94c-.29.29-.29.77 0 1.06z"/></g></svg>',
    stateOutline: '<svg height="24" width="24"><path d="M1.605 12l1.394 1.394L4.393 12l-1.394-1.394zm1.022 2.844L.154 12.371a.525.525 0 010-.742l2.473-2.473a.526.526 0 01.743 0l2.473 2.473a.525.525 0 010 .742L3.37 14.844a.525.525 0 01-.743 0zM9.285 12l1.708 1.708L12.701 12l-1.708-1.708zm1.355 3.475l-3.121-3.122a.5.5 0 010-.706l3.12-3.122a.5.5 0 01.707 0l3.122 3.122a.5.5 0 010 .706l-3.122 3.122a.5.5 0 01-.706 0zM17.976 12l2.011 2.012L22 12l-2.012-2.012zm1.644 3.845l-3.478-3.478a.519.519 0 010-.734l3.478-3.479a.519.519 0 01.734 0l3.479 3.48a.519.519 0 010 .733l-3.48 3.478a.519.519 0 01-.733 0z"/></svg>',
    string: '<svg height="24" width="24"><path d="M20.5 3a.5.5 0 01.5.5v17a.5.5 0 01-.5.5h-17a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5zm-8.322 5.613c-.914 0-1.689.17-2.323.508a4.978 4.978 0 00-1.43 1.139.248.248 0 00.05.373l.842.535a.293.293 0 00.365-.037c.348-.344 1.24-1.094 2.381-1.094 1.552 0 2.352.701 2.352 1.915v.338h-2.463c-1.226 0-2.191.245-2.895.734C8.352 13.514 8 14.21 8 15.113c0 .355.065.685.194.992.129.306.322.578.58.814.259.237.581.423.968.557.387.134.839.201 1.355.201.752 0 1.446-.15 2.08-.451a3.893 3.893 0 001.25-.898v.877c0 .163.132.295.295.295h.983a.295.295 0 00.295-.295v-5.253c0-.495-.083-.946-.25-1.355a2.902 2.902 0 00-.734-1.057 3.33 3.33 0 00-1.193-.685c-.474-.161-1.022-.242-1.645-.242zm2.237 5.037v.832c-.226.44-1.232 1.739-3.076 1.739-1.09 0-1.689-.428-1.689-1.205 0-.587.245-1.366 2.367-1.366zM19 6.5h-2v2h1c0 .552-.448 1-1 1v1c1.103 0 2-.897 2-2zm-12 0c-1.102 0-2 .897-2 2v2h2v-2H6c0-.551.449-1 1-1z" fill-rule="evenodd"/></svg>',
    stringOutline: '<svg height="24" width="24"><path d="M12.184 8.002c.702 0 1.319.09 1.851.272.532.182.98.439 1.343.772.363.332.638.729.825 1.188a4 4 0 01.282 1.524v5.91a.332.332 0 01-.332.332h-1.107a.332.332 0 01-.332-.332v-.986c-.326.339-.69.671-1.405 1.01a5.397 5.397 0 01-2.34.508c-.58 0-1.09-.076-1.525-.227a3.081 3.081 0 01-1.088-.626 2.605 2.605 0 01-.654-.916 2.85 2.85 0 01-.217-1.116c0-1.017.396-1.8 1.188-2.35.792-.55 1.878-.826 3.257-.826h2.771v-.381c0-1.365-.9-2.154-2.645-2.154-1.284 0-2.287.844-2.68 1.23a.33.33 0 01-.41.043l-.946-.602a.279.279 0 01-.057-.42c.455-.524.99-.952 1.608-1.281.714-.381 1.585-.572 2.613-.572zm2.517 5.667h-2.698c-2.386 0-2.662.877-2.662 1.537 0 .874.675 1.355 1.9 1.355 2.074 0 3.206-1.461 3.46-1.956zM20.001 6v2l-.006.15A2.003 2.003 0 0118 10V9c.551 0 1-.448 1-1h-1V6zM6 6v1c-.551 0-1 .449-1 1h1v2H4V8l.006-.149A2.003 2.003 0 016 6z" fill-rule="evenodd"/></svg>',
    terminal: '<svg height="24" width="24"><path d="M21.499 4a.5.5 0 01.5.5v15a.5.5 0 01-.5.5H2.5a.5.5 0 01-.5-.5v-15a.5.5 0 01.5-.5zm-1.5 2H4v12h16zm-3 7.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-4a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zM7.56 8.147l3 3a.5.5 0 010 .707l-3 3a.5.5 0 01-.707 0l-.707-.708a.5.5 0 010-.707l1.94-1.939-1.94-1.94a.5.5 0 010-.706l.707-.707a.5.5 0 01.707 0z" fill-rule="evenodd"/></svg>',
    version: '<svg width="24" height="24"><path d="M11 3c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h8c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2h-8zM7 4a1 1 0 00-1 1v14a1 1 0 002 0V5a1 1 0 00-1-1zM4 6a1 1 0 00-1 1v10a1 1 0 002 0V7a1 1 0 00-1-1z"/></svg>',
    versionOutline: '<svg width="24" height="24"><path d="M11 3c-1.093 0-2 .907-2 2v14c0 1.093.907 2 2 2h8c1.093 0 2-.907 2-2V5c0-1.093-.907-2-2-2h-8zM8 4c-1.093 0-2 .907-2 2v12c0 1.093.907 2 2 2V4zm3 1h8v14h-8V5zM5 6c-1.093 0-2 .907-2 2v8c0 1.093.907 2 2 2V6z"/></svg>',
    yarn: '<svg width="24" height="24"><path fill-rule="evenodd" d="M12.188 2.005c-.65.11-1.312 2.085-1.312 2.085s-1.736-.286-3.18 1.147c-.29.287-.577.428-1.01.57-.145.144-.29.146-.579 1.006-.578 1.29.866 2.865.866 2.865-3.033 2.15-2.89 5.015-2.745 5.732-1.878 1.576-1.156 3.582-.722 4.155.289.43.577.286.722.286 0 .143-.722 1.003 0 1.29.722.43 1.88.573 2.458 0 .433-.43.577-1.291.722-1.721.144-.143.144.287.722.573 0 0-1.012.43-.578 1.433.144.287.578.574 1.444.574.29 0 3.755-.144 4.622-.431.578-.143.723-.428.723-.428 3.756-1.003 4.479-2.58 7.079-3.154.867-.143.867-1.576-.722-1.433-1.156 0-2.167.574-3.034 1.148-1.444.86-2.454 1.002-2.454.859-.145-.144.575-1.862-.147-3.725-.722-2.006-2.02-2.58-1.876-2.723.433-.717 1.443-1.862 1.876-3.868.144-1.29.146-3.438-.432-4.44-.144-.287-1.013.285-1.013.285s-.865-1.864-1.154-2.007a.34.34 0 00-.276-.078z"/></svg>',
    yarnOutline: '<svg width="24" height="24"><path fill-rule="evenodd" d="M21.987 16.611c-.107-.834-.822-1.409-1.74-1.397-1.37.017-2.52.716-3.284 1.18a7.178 7.178 0 01-.774.417 6.147 6.147 0 00-.352-2.554c-.435-1.174-1.019-1.896-1.436-2.313.483-.693 1.144-1.702 1.454-3.264.268-1.332.185-3.405-.43-4.567a.946.946 0 00-.595-.475c-.107-.03-.31-.088-.71.023-.601-1.227-.81-1.356-.97-1.462a1.23 1.23 0 00-1.097-.123c-.495.176-.918.646-1.317 1.48-.06.123-.113.24-.161.357a4.423 4.423 0 00-2.956 1.398c-.125.135-.37.234-.626.328H7c-.524.182-.762.605-1.054 1.368-.406 1.069.012 2.12.423 2.8-.56.493-1.305 1.28-1.699 2.202-.488 1.139-.542 2.254-.524 2.859-.417.434-1.06 1.25-1.132 2.166-.096 1.28.375 2.148.584 2.465.06.094.125.17.196.247-.024.158-.03.329.006.505.078.41.34.745.74.957.786.41 1.882.587 2.729.17.303.317.858.622 1.865.622h.06c.256 0 3.51-.17 4.457-.4.423-.099.715-.275.906-.434.608-.187 2.288-.751 3.873-1.76 1.12-.717 1.508-.87 2.342-1.07.81-.193 1.317-.92 1.216-1.725zm-1.418.863c-.954.223-1.436.429-2.616 1.186-1.842 1.174-3.856 1.72-3.856 1.72s-.167.246-.65.358c-.834.2-3.974.37-4.26.376-.77.005-1.24-.194-1.371-.505-.4-.94.572-1.35.572-1.35s-.215-.13-.34-.247c-.113-.112-.232-.335-.268-.252-.149.358-.226 1.232-.626 1.626-.548.546-1.585.364-2.199.047-.673-.353.048-1.18.048-1.18s-.364.211-.656-.223c-.262-.4-.506-1.08-.44-1.92.071-.957 1.156-1.884 1.156-1.884s-.191-1.415.435-2.865c.566-1.32 2.091-2.383 2.091-2.383S6.31 8.58 6.785 7.324c.31-.822.435-.816.536-.851.358-.135.703-.282.96-.558 1.28-1.362 2.914-1.103 2.914-1.103s.774-2.32 1.49-1.867c.22.14 1.013 1.878 1.013 1.878s.846-.487.941-.305c.513.98.572 2.853.346 3.992-.381 1.878-1.335 2.888-1.716 3.522-.09.147 1.025.61 1.728 2.53.65 1.756.071 3.229.173 3.393.018.03.023.041.023.041s.745.06 2.241-.85c.799-.488 1.746-1.034 2.825-1.046 1.043-.017 1.096 1.186.31 1.374z"/></svg>',
    cmd: '<svg width="24" height="24"><path fill-rule="evenodd" d="M4 20h16V4H4v16zm16.5 1h-17a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5h17a.5.5 0 01.5.5v17a.5.5 0 01-.5.5zm-4-9a.5.5 0 01-.5-.5V11l.5-.001a.5.5 0 010 1zm-2.512-1.993v-1L15 9.004v1l-1.012.003zm-1 1.505a.5.5 0 11-.5-.5v-.003l.5.001v.502zm-.5-3.5a.5.5 0 11.5-.5v.498l-.5.002zM16 7.5a.5.5 0 11.5.5V8H16V7.5zm.5 2.5L16 10v-1L16.5 9A1.502 1.502 0 0018 7.5c0-.827-.673-1.5-1.5-1.5S15 6.673 15 7.5v.504l-1.012.003v-.495c0-.827-.673-1.5-1.5-1.5s-1.5.673-1.5 1.5.673 1.5 1.5 1.5l.5-.002v1l-.502.002a1.502 1.502 0 00-1.498 1.5c0 .827.673 1.5 1.5 1.5s1.5-.673 1.5-1.5v-.505L15 11.004v.496c0 .827.673 1.5 1.5 1.5s1.5-.673 1.5-1.5-.673-1.5-1.5-1.5z"/></svg>',
    cmdAlt: '<svg width="24" height="24"><path fill-rule="evenodd" d="M4 20h16V4H4v16zm16.5 1h-17a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5h17a.5.5 0 01.5.5v17a.5.5 0 01-.5.5zM15 16c-.552 0-1-.449-1-1v-1h1a1.001 1.001 0 010 2zm-4-3h2v-2h-2v2zm-1 2a1.001 1.001 0 01-2 0c0-.552.448-1 1-1h1v1zm-1-5a1.001 1.001 0 010-2c.551 0 1 .448 1 1v1H9zm5-1a1.001 1.001 0 012 0c0 .551-.449 1-1 1h-1V9zm1 4h-1v-2h1c1.103 0 2-.897 2-2s-.897-2-2-2-2 .897-2 2v1h-2V9c0-1.103-.897-2-2-2s-2 .897-2 2 .897 2 2 2h1v2H9c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2v-1h2v1c0 1.103.897 2 2 2s2-.897 2-2-.897-2-2-2z"/></svg>',
    ctrlMac: '<svg width="24" height="24"><path fill-rule="evenodd" d="M4 20h16V4H4v16zm16.5 1h-17a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5h17a.5.5 0 01.5.5v17a.5.5 0 01-.5.5zm-3.348-10.323L14.5 8.025l-2.652 2.652a.25.25 0 01-.353 0l-.354-.354a.25.25 0 010-.353l3.182-3.183a.25.25 0 01.354 0l3.182 3.183a.25.25 0 010 .353l-.354.354a.25.25 0 01-.353 0"/></svg>',
    ctrlMacAlt: '<svg width="24" height="24"><path fill-rule="evenodd" d="M20.5 3a.5.5 0 01.5.5v17a.5.5 0 01-.5.5h-17a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5h17zM20 4H4v16h16V4zm-7.735 4.808l4.526 4.526a.25.25 0 010 .353l-.354.354a.25.25 0 01-.353 0L12 9.957l-4.084 4.084a.25.25 0 01-.353 0l-.354-.354a.25.25 0 010-.353l4.526-4.526a.376.376 0 01.53 0z"/></svg>',
    ctrlWin: '<svg width="24" height="24"><path fill-rule="evenodd" d="M4 20h16V4H4v16zm16.5 1h-17a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5h17a.5.5 0 01.5.5v17a.5.5 0 01-.5.5zM8.307 10.208c0-1.071.7-1.897 1.792-1.897.9 0 1.466.504 1.617 1.24a.064.064 0 01-.063.076h-.806a.061.061 0 01-.06-.047.654.654 0 00-.646-.506c-.574 0-.868.441-.868 1.134 0 .679.273 1.134.854 1.134.368 0 .634-.186.712-.558a.062.062 0 01.06-.051h.795c.037 0 .068.033.063.07-.093.73-.68 1.302-1.61 1.302-1.133 0-1.84-.826-1.84-1.897m3.756-1.8h.427V7.352c0-.034.028-.062.062-.062h.806c.035 0 .063.028.063.062V8.41h.553c.035 0 .063.028.063.062v.505a.063.063 0 01-.063.063h-.553v1.904c0 .266.147.357.357.357h.217c.035 0 .063.028.063.062v.572c0 .033-.025.06-.059.062-.088.004-.273.01-.536.01-.462 0-.973-.181-.973-.86V9.039h-.427A.063.063 0 0112 8.976v-.505c0-.034.028-.062.063-.062m3.406.574h.02c.218-.406.463-.616.883-.616.076 0 .13.004.176.014a.062.062 0 01.048.06v.72c0 .036-.031.064-.067.062-.59-.034-1.025.298-1.025 1.027v1.687a.062.062 0 01-.063.063h-.827a.062.062 0 01-.062-.063V8.471c0-.034.028-.062.062-.062h.792c.035 0 .063.028.063.062v.512zM17.11 7h.827c.035 0 .063.028.063.063v4.874a.062.062 0 01-.063.063h-.827a.062.062 0 01-.062-.063V7.063c0-.035.028-.063.062-.063"/></svg>',
    ctrlWinAlt: '<svg width="24" height="24"><path fill-rule="evenodd" d="M4 20h16V4H4v16zm16.5 1h-17a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5h17a.5.5 0 01.5.5v17a.5.5 0 01-.5.5zM6 12.834c0-1.295.696-2.293 2.016-2.293 1.065 0 1.609.583 1.794 1.442a.125.125 0 01-.124.149H8.96a.126.126 0 01-.12-.094c-.103-.34-.384-.625-.772-.625-.694 0-1.05.583-1.05 1.421 0 .82.33 1.42 1.033 1.42.433 0 .748-.255.852-.685a.127.127 0 01.122-.1h.715c.075 0 .136.066.125.14-.12.855-.689 1.518-1.789 1.518-1.37 0-2.075-.998-2.075-2.293m4.625-2.175h.476V9.431c0-.069.056-.125.125-.125h.725c.07 0 .125.056.125.125v1.228h.62c.069 0 .125.057.125.125v.462a.125.125 0 01-.125.125h-.62v2.351c0 .322.178.432.432.432.067 0 .146-.002.21-.004a.125.125 0 01.128.125v.6a.124.124 0 01-.119.125 9.479 9.479 0 01-.45.008c-.558 0-1.176-.22-1.176-1.04V11.37h-.476a.125.125 0 01-.125-.125v-.462c0-.068.056-.125.125-.125m4.121.694h.026c.262-.49.558-.744 1.066-.744.067 0 .12.002.165.008a.124.124 0 01.105.124v.725c0 .07-.056.127-.126.125-.69-.021-1.194.382-1.194 1.244v2.04a.125.125 0 01-.125.125h-.75a.125.125 0 01-.125-.125v-4.09c0-.07.056-.125.125-.125h.708c.07 0 .125.056.125.125v.568zM17.124 9h.751c.069 0 .125.056.125.125v5.75a.125.125 0 01-.125.125h-.75a.125.125 0 01-.126-.125v-5.75c0-.069.056-.125.125-.125"/></svg>',
    ctrlWinAlt2: '<svg width="24" height="24"><path fill-rule="evenodd" d="M4 20h16V4H4v16zm16.5 1h-17a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5h17a.5.5 0 01.5.5v17a.5.5 0 01-.5.5zM7.057 12.208c0-1.071.7-1.897 1.792-1.897.9 0 1.467.504 1.617 1.24a.065.065 0 01-.063.076h-.806a.062.062 0 01-.059-.048.654.654 0 00-.647-.505c-.574 0-.868.44-.868 1.134 0 .679.273 1.134.854 1.134.368 0 .634-.186.712-.558a.062.062 0 01.06-.051h.795c.037 0 .068.033.063.07-.093.73-.68 1.302-1.609 1.302-1.134 0-1.841-.826-1.841-1.897m3.756-1.8h.427V9.353c0-.035.028-.063.062-.063h.807c.034 0 .062.028.062.063v1.057h.553c.035 0 .063.028.063.062v.506a.063.063 0 01-.063.062h-.553v1.904c0 .266.147.357.357.357h.217c.035 0 .063.028.063.062v.572a.062.062 0 01-.059.062c-.088.004-.273.01-.536.01-.462 0-.973-.181-.973-.86v-2.107h-.427a.063.063 0 01-.063-.062v-.506c0-.034.028-.062.063-.062m3.406.574h.02c.218-.406.463-.616.883-.616.076 0 .13.004.176.014a.062.062 0 01.048.06v.72c0 .036-.03.064-.067.062-.59-.034-1.025.298-1.025 1.027v1.687a.063.063 0 01-.063.063h-.827a.063.063 0 01-.062-.063v-3.466c0-.034.028-.062.062-.062h.792c.035 0 .063.028.063.062v.512zM15.86 9h.827c.035 0 .063.028.063.062v4.875a.063.063 0 01-.063.063h-.827a.063.063 0 01-.062-.063V9.062c0-.034.028-.062.062-.062"/></svg>',
    option: '<svg width="24" height="24"><path fill-rule="evenodd" d="M4 20h16V4H4v16zm16.5 1h-17a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5h17a.5.5 0 01.5.5v17a.5.5 0 01-.5.5zM17.75 8h-3.5a.25.25 0 01-.25-.25v-.5a.25.25 0 01.25-.25h3.5a.25.25 0 01.25.25v.5a.25.25 0 01-.25.25m0 4H14a.5.5 0 01-.433-.25L11.402 8H9.25A.25.25 0 019 7.75v-.5A.25.25 0 019.25 7h2.44a.5.5 0 01.433.25L14.288 11h3.462a.25.25 0 01.25.25v.5a.25.25 0 01-.25.25"/></svg>',
    optionAlt: '<svg width="24" height="24"><path fill-rule="evenodd" d="M4 20h16V4H4v16zm16.5 1h-17a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5h17a.5.5 0 01.5.5v17a.5.5 0 01-.5.5zM16.75 8h-3.5a.25.25 0 01-.25-.25v-.5a.25.25 0 01.25-.25h3.5a.25.25 0 01.25.25v.5a.25.25 0 01-.25.25m0 9h-3.522a.25.25 0 01-.239-.175L10.221 8H7.25A.25.25 0 017 7.75v-.5A.25.25 0 017.25 7h3.522c.11 0 .206.07.239.175L13.779 16h2.97a.25.25 0 01.25.25v.5a.25.25 0 01-.25.25"/></svg>',
    shift: '<svg width="24" height="24"><path fill-rule="evenodd" d="M9 17h2v-3h.975L10 12.025 8.025 14H9v3zM20.5 3a.5.5 0 01.5.5v17a.5.5 0 01-.5.5h-17a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5h17zM20 4H4v16h16V4zm-9.735 6.876l3.697 3.697a.25.25 0 01-.176.427H12v2.75a.25.25 0 01-.25.25h-3.5a.25.25 0 01-.25-.25V15H6.214a.25.25 0 01-.176-.427l3.697-3.697a.375.375 0 01.53 0z"/></svg>',
    shiftAlt: '<svg width="24" height="24"><path fill-rule="evenodd" d="M13.5 13.026h2v-3h.975L14.5 8.05l-1.975 1.975h.975v3zM20.5 3a.5.5 0 01.5.5v17a.5.5 0 01-.5.5h-17a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5h17zM20 4H4v16h16V4zm-5.235 2.902l3.697 3.697a.25.25 0 01-.176.427H16.5v2.75a.25.25 0 01-.25.25h-3.5a.25.25 0 01-.25-.25v-2.75h-1.786a.25.25 0 01-.176-.427l3.697-3.697a.375.375 0 01.53 0z"/></svg>',
    shiftAlt2: '<svg width="24" height="24"><path fill-rule="evenodd" d="M10.5 16h3v-4.368h1.907L12 8.225l-3.407 3.407H10.5V16zm10-13a.5.5 0 01.5.5v17a.5.5 0 01-.5.5h-17a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5h17zM20 4H4v16h16V4zm-7.735 3.076l4.916 4.916a.375.375 0 01-.265.64H14.5v3.993a.375.375 0 01-.375.375h-4.25a.375.375 0 01-.375-.375v-3.993H7.084a.375.375 0 01-.265-.64l4.916-4.916a.376.376 0 01.53 0z"/></svg>',
    fontFace: '<svg width="24" height="24"><defs><clipPath id="a"><path d="M14.793 0l.112.12V5.3l.055.016c.33-.35.69-.614 1.08-.79.391-.174.775-.262 1.153-.262.967 0 1.775.382 2.423 1.148.648.765.972 1.761.972 2.99 0 1.179-.372 2.17-1.116 2.973-.744.802-1.607 1.203-2.59 1.203-.43 0-.855-.066-1.272-.199a5.41 5.41 0 01-1.176-.534l-.59.917-.494-.112c.027-.393.045-.866.056-1.419.01-.553.016-1.087.016-1.602V1.85c0-.181-.041-.362-.124-.543a.865.865 0 00-.314-.39c-.101-.07-.27-.121-.507-.156a8.47 8.47 0 00-.57-.067v-.51L14.793 0zM6.03.134c.134 0 .242.074.292.2l4.698 11.87a.31.31 0 01-.292.424h-1.05a.426.426 0 01-.391-.266l-.883-2.233H2.631l-.875 2.233a.425.425 0 01-.391.266H.315a.31.31 0 01-.292-.425L4.721.333a.298.298 0 01.292-.2zM16.635 5.15c-.372 0-.698.073-.977.219-.279.146-.53.344-.753.594v4.576c.032.127.094.276.187.446.093.17.22.332.379.486.16.149.34.27.542.363.202.093.449.14.741.14.648 0 1.172-.314 1.57-.941.4-.627.598-1.486.598-2.575 0-.393-.042-.795-.127-1.204a3.435 3.435 0 00-.399-1.068 2.23 2.23 0 00-.71-.75c-.292-.19-.642-.286-1.051-.286zM5.52 2.833L3.29 8.463h4.464l-2.232-5.63z"/></clipPath></defs><g clip-path="url(#a)" transform="translate(1.8 5.374)"><path d="M0 0h20.588v12.763H0V0z"/></g></svg>',
    fontFaceColored: '<svg width="24" height="24"><defs><clipPath id="a"><path d="M6.03 0c.133 0 .24.075.29.2l4.699 11.87a.31.31 0 01-.292.424h-1.05a.426.426 0 01-.391-.266l-.883-2.232H2.631l-.875 2.232a.425.425 0 01-.391.266H.315a.31.31 0 01-.292-.424L4.721.2a.298.298 0 01.292-.2zM5.52 2.699L3.29 8.329h4.464L5.521 2.7z"/></clipPath><clipPath id="b"><path d="M2.886 0l.111.12V5.3l.056.016c.33-.35.69-.614 1.08-.79.39-.174.775-.262 1.152-.262.967 0 1.775.382 2.424 1.148.648.765.972 1.761.972 2.99 0 1.179-.372 2.17-1.116 2.973-.744.802-1.608 1.203-2.59 1.203-.431 0-.855-.066-1.272-.199a5.41 5.41 0 01-1.176-.534l-.59.917-.494-.112c.026-.393.045-.866.056-1.419.01-.553.016-1.087.016-1.602V1.85c0-.181-.042-.362-.124-.543a.865.865 0 00-.315-.39C.976.847.806.796.57.76A8.47 8.47 0 000 .694v-.51L2.886 0zm1.841 5.15c-.372 0-.697.073-.976.219-.28.146-.53.344-.754.594v4.576c.032.127.095.276.188.446.093.17.219.332.378.486.16.149.34.27.542.363.202.093.45.14.742.14.648 0 1.172-.314 1.57-.941.399-.627.598-1.486.598-2.575 0-.393-.042-.795-.128-1.204a3.435 3.435 0 00-.398-1.068 2.23 2.23 0 00-.71-.75c-.292-.19-.643-.286-1.052-.286z"/></clipPath></defs><g clip-path="url(#a)" transform="translate(1.8 5.508)"><path opacity="55%" d="M0 0h11.042v12.494H0V0z"/></g><g clip-path="url(#b)" transform="translate(13.707 5.374)"><path opacity="85%" d="M0 0h8.681v12.763H0V0z"/></g></svg>',
    fontOpacity: '<svg height="24" width="24"><g fill="currentColor"><path d="M7.983 5.084v13.83A8.002 8.002 0 014.001 12a8.002 8.002 0 013.982-6.915"/><path d="M11.978 4v16a7.964 7.964 0 01-3.995-1.086V5.084A7.964 7.964 0 0111.978 4" opacity=".75"/><path d="M15.97 5.057v13.885A7.94 7.94 0 0112 19.999h-.022V4h.023c1.445 0 2.8.385 3.97 1.058" fill="#4d4d4d" opacity=".5"/><path d="M4 12c0 4.411 3.589 8 8 8s8-3.589 8-8-3.589-8-8-8-8 3.589-8 8zm-2 0C2 6.486 6.486 2 12 2s10 4.486 10 10-4.486 10-10 10S2 17.514 2 12z"/></g></svg>',
    fontOpacityAlt: '<svg height="24" width="24"><g fill="currentColor"><path d="M14.5 12h7a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-7a.5.5 0 00-.5.5v1a.5.5 0 00.5.5" fill="#ccc" opacity=".75"/><path d="M12.5 16h9a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-9a.5.5 0 00-.5.5v1a.5.5 0 00.5.5" opacity=".6"/><path d="M12.5 20h9a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-9a.5.5 0 00-.5.5v1a.5.5 0 00.5.5" opacity=".25"/><path d="M13.5 4h-11a.5.5 0 00-.5.5v1a.5.5 0 00.5.5H7v13.5a.5.5 0 00.5.5h1a.5.5 0 00.5-.5V6h4.5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5"/></g></svg>',
    fontSize: '<svg height="24" width="24"><path d="M19.377 8.704c.792 0 1.49.103 2.091.308.601.205 1.107.496 1.517.871.41.376.72.824.933 1.343.212.52.318 1.094.318 1.722v6.677a.375.375 0 01-.375.375h-1.25a.375.375 0 01-.375-.375v-1.114c-.37.383-.782.758-1.588 1.14a6.093 6.093 0 01-2.644.574c-.656 0-1.23-.085-1.722-.256a3.482 3.482 0 01-1.23-.707 2.946 2.946 0 01-.738-1.035 3.217 3.217 0 01-.246-1.261c0-1.148.447-2.033 1.342-2.655.895-.621 2.122-.933 3.68-.933h3.13v-.43c0-1.542-1.016-2.434-2.988-2.434-1.451 0-2.584.954-3.027 1.39a.373.373 0 01-.464.049l-1.069-.681a.315.315 0 01-.064-.474 6.322 6.322 0 011.817-1.448c.806-.43 1.79-.646 2.952-.646zM7.042 5c.154 0 .292.094.349.237l5.641 14.25a.375.375 0 01-.348.513h-1.265a.5.5 0 01-.465-.317L9.896 17H2.963l-1.058 2.683A.5.5 0 011.44 20H.175a.375.375 0 01-.348-.513l5.641-14.25A.375.375 0 015.817 5zm15.179 10.106h-3.049c-2.696 0-3.007.991-3.007 1.737 0 .987.762 1.531 2.146 1.531 2.344 0 3.623-1.65 3.91-2.21zM6.43 8.241L3.754 15h5.351z" fill-rule="evenodd"/></svg>',
    fontSizeMinus: '<svg height="24" width="24"><path d="M10.19 5c.2 0 .38.12.46.3l6.05 14c.14.33-.1.7-.46.7h-1.6a.76.76 0 01-.69-.47L12.91 17H6.09l-1.04 2.53c-.11.29-.39.47-.69.47h-1.6c-.36 0-.6-.37-.46-.7l6.05-14c.08-.18.26-.3.46-.3zM9.5 7.7l-2.55 6.85h5.1zm13-2.7c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5h-7c-.28 0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5z" fill-rule="evenodd"/></svg>',
    fontSizePlus: '<svg height="24" width="24"><path d="M10.19 5c.2 0 .38.12.46.3l6.05 14c.14.33-.1.7-.46.7h-1.6a.76.76 0 01-.69-.47L12.91 17H6.09l-1.04 2.53c-.11.29-.39.47-.69.47h-1.6c-.36 0-.6-.37-.46-.7l6.05-14c.08-.18.26-.3.46-.3zM9.5 7.7l-2.55 6.85h5.1zm10-5.7c.28 0 .5.22.5.5V5h2.5c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5H20v2.5c0 .28-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5V7h-2.5c-.28 0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5H18V2.5c0-.28.22-.5.5-.5z" fill-rule="evenodd"/></svg>',
    fontStyleItalic: '<svg height="24" width="24"><path d="M18 5.5v-1a.5.5 0 00-.5-.5h-7a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h2.217l-2.486 12H7.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h7a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-2.208l2.486-12H17.5a.5.5 0 00.5-.5" fill-rule="evenodd"/></svg>',
    fontStyleUnderline: '<svg height="24" width="24"><path d="M18.5 18a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-13a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zM8 4a.5.5 0 01.5.5v5.898c0 1.883 1.444 3.505 3.324 3.598A3.504 3.504 0 0015.5 10.5v-6A.5.5 0 0116 4h1a.5.5 0 01.5.5v6a5.506 5.506 0 01-5.712 5.496c-2.976-.113-5.288-2.653-5.288-5.63V4.5A.5.5 0 017 4z" fill-rule="evenodd"/></svg>',
    fontStyleUnderlineColored: '<svg height="24" width="24"><g fill-rule="evenodd"><path d="M18.5 20h-13a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h13a.5.5 0 01.5.5v1a.5.5 0 01-.5.5"/><path d="M11.788 15.996C8.812 15.883 6.5 13.343 6.5 10.365V4.5A.5.5 0 017 4h1a.5.5 0 01.5.5v5.898c0 1.883 1.444 3.505 3.324 3.597A3.504 3.504 0 0015.5 10.5v-6A.5.5 0 0116 4h1a.5.5 0 01.5.5v6a5.506 5.506 0 01-5.712 5.496" opacity=".5"/></g></svg>',
    fontVariable: '<svg height="24" width="24"><path d="M15 16.123A2.86 2.86 0 0117.683 18H20.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-2.834A2.86 2.86 0 0115 21.835 2.86 2.86 0 0112.334 20L3.5 20a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h8.817A2.86 2.86 0 0115 16.123zm0 1.7c-.637 0-1.155.518-1.155 1.155s.518 1.156 1.155 1.156a1.157 1.157 0 000-2.311zm2.693-14.475c4.137 0 4.299 3.257 4.307 3.782v5.553a.317.317 0 01-.318.317h-1.539a.317.317 0 01-.317-.317V12c-.664.842-2.09 1.444-3.274 1.444-.84 0-3.532-.31-3.532-2.974 0-1.47.849-3.232 4.432-3.232h2.365V7.13c0-1.008-.608-1.769-2.249-1.769-1.207 0-1.931.678-2.298 1.044-.1.1-.258.117-.383.042l-1.296-.819a.258.258 0 01-.05-.392A5.527 5.527 0 0115.077 4a5.834 5.834 0 012.616-.652zm-10.75.33c.658 0 1.242.091 1.741.257s.925.409 1.266.725c.342.308.6.683.775 1.116.175.433.267.908.275 1.433v5.475a.316.316 0 01-.317.316h-1.04a.316.316 0 01-.317-.316v-.915c-.309.317-.65.633-1.325.95-.666.316-1.4.475-2.199.475a4.39 4.39 0 01-1.433-.217 2.933 2.933 0 01-1.024-.592 2.472 2.472 0 01-.616-.866 2.593 2.593 0 01-.209-1.05c0-.949.367-1.61 1.116-2.127.75-.517 1.766-.775 3.066-.775h2.607V7.21c0-1.283-.85-2.024-2.49-2.024-1.208 0-2.158.791-2.524 1.158-.1.1-.259.116-.384.041l-.89-.566a.258.258 0 01-.05-.392A5.34 5.34 0 014.485 4.22c.667-.358 1.491-.542 2.457-.542zM9.317 9h-2.54c-2.25 0-2.507.745-2.507 1.37 0 .824.641 1.274 1.79 1.274 1.95 0 3.016-1.374 3.257-1.84zm10.5.17h-2.29c-1.682 0-2.257.575-2.257 1.2 0 .824 1.13 1.024 1.54 1.024 1.95 0 2.766-1.124 3.007-1.59z" fill-rule="evenodd"/></svg>',
    fontVariableColored: '<svg height="24" width="24"><g fill-rule="evenodd"><path d="M9.317 9.804c-.242.466-1.308 1.84-3.257 1.84-1.15 0-1.79-.45-1.79-1.274 0-.625.257-1.37 2.506-1.37h2.541zm1.408-4.027A2.997 2.997 0 009.95 4.66a3.433 3.433 0 00-1.266-.724 5.513 5.513 0 00-1.741-.259c-.966 0-1.79.184-2.457.542A5.34 5.34 0 002.97 5.427a.258.258 0 00.05.391l.891.567a.313.313 0 00.383-.042c.367-.367 1.316-1.158 2.524-1.158 1.641 0 2.49.741 2.49 2.024v.359H6.702c-1.299 0-2.315.258-3.065.774-.75.517-1.116 1.178-1.116 2.128 0 .375.066.724.208 1.05.133.324.342.608.616.866.275.25.617.45 1.025.591a4.39 4.39 0 001.433.217c.8 0 1.532-.158 2.199-.475a4.104 4.104 0 001.324-.95v.915c0 .175.142.316.317.316h1.041a.316.316 0 00.316-.316V7.209c-.008-.525-.1-1-.274-1.432z"/><path d="M19.817 9.804c-.242.466-1.058 1.59-3.007 1.59-.41 0-1.54-.2-1.54-1.024 0-.625.574-1.2 2.256-1.2h2.291zm-2.124-6.456c-.966 0-1.95.294-2.617.652a5.527 5.527 0 00-1.535 1.237.258.258 0 00.05.391l1.296.82a.313.313 0 00.383-.042c.366-.367 1.09-1.044 2.298-1.044 1.641 0 2.249.76 2.249 1.768v.108h-2.366c-3.583 0-4.431 1.762-4.431 3.232 0 2.665 2.691 2.974 3.532 2.974 1.183 0 2.61-.602 3.273-1.444v.683c0 .175.142.317.318.317h1.539a.317.317 0 00.317-.317V7.13c-.008-.525-.17-3.782-4.306-3.782zM13 18H3.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5H13zm7.5 0H17v2h3.5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5" opacity=".5"/><path d="M15 17.823c-.637 0-1.156.518-1.156 1.155A1.157 1.157 0 1015 17.823m0 4.011a2.859 2.859 0 01-2.855-2.856A2.858 2.858 0 0115 16.123a2.859 2.859 0 012.855 2.855A2.859 2.859 0 0115 21.834"/></g></svg>',
    fontWeight: '<svg height="24" width="24"><path d="M17.693 8.348c4.137 0 4.299 3.257 4.307 3.782v5.553a.317.317 0 01-.318.317h-1.539a.317.317 0 01-.317-.317V17c-.664.842-2.09 1.444-3.274 1.444-.84 0-3.532-.31-3.532-2.974 0-1.47.849-3.232 4.432-3.232h2.365v-.108c0-1.008-.608-1.769-2.249-1.769-1.207 0-1.931.678-2.298 1.044-.1.1-.258.117-.383.042l-1.296-.819a.258.258 0 01-.05-.392A5.527 5.527 0 0115.077 9a5.834 5.834 0 012.616-.652zm-10.75.33c.659 0 1.242.091 1.741.257.5.167.925.409 1.266.725.342.308.6.683.775 1.116.175.434.267.908.275 1.433v5.475a.316.316 0 01-.317.316h-1.04a.316.316 0 01-.317-.316v-.915c-.308.317-.65.633-1.325.95-.666.316-1.4.475-2.199.475a4.386 4.386 0 01-1.432-.217 2.932 2.932 0 01-1.025-.592 2.472 2.472 0 01-.616-.866 2.596 2.596 0 01-.209-1.05c0-.949.367-1.61 1.117-2.127.75-.516 1.765-.775 3.065-.775h2.607v-.358c0-1.283-.85-2.024-2.49-2.024-1.208 0-2.158.791-2.524 1.158-.1.1-.259.116-.384.041l-.89-.566a.258.258 0 01-.05-.392A5.34 5.34 0 014.485 9.22c.667-.358 1.491-.542 2.457-.542zM9.317 14h-2.54c-2.25 0-2.507.745-2.507 1.37 0 .824.641 1.274 1.79 1.274 1.95 0 3.016-1.374 3.257-1.84zm10.5.17h-2.29c-1.682 0-2.257.575-2.257 1.2 0 .824 1.13 1.024 1.54 1.024 1.95 0 2.766-1.124 3.007-1.59z" fill-rule="evenodd"/></svg>',
    fontWeightColored: '<svg height="24" width="24"><g fill="currentColor"><path d="M9.317 14.804c-.242.466-1.308 1.84-3.257 1.84-1.15 0-1.79-.45-1.79-1.274 0-.625.257-1.37 2.506-1.37h2.541zm1.408-4.027A2.991 2.991 0 009.95 9.66a3.431 3.431 0 00-1.266-.725 5.512 5.512 0 00-1.741-.258c-.966 0-1.79.183-2.457.541a5.34 5.34 0 00-1.516 1.208.258.258 0 00.05.391l.891.567a.313.313 0 00.383-.042c.367-.367 1.316-1.158 2.524-1.158 1.641 0 2.49.742 2.49 2.024v.359H6.702c-1.299 0-2.315.258-3.065.774-.75.517-1.116 1.178-1.116 2.128 0 .375.067.725.208 1.05.133.324.342.608.616.866.275.25.617.45 1.025.591.408.142.891.217 1.433.217.8 0 1.532-.158 2.199-.475a4.106 4.106 0 001.324-.95v.915c0 .175.142.316.317.316h1.041a.316.316 0 00.316-.316v-5.475c-.008-.525-.1-.999-.274-1.432z"/><path d="M19.817 14.804c-.242.466-1.058 1.59-3.007 1.59-.41 0-1.54-.2-1.54-1.024 0-.625.574-1.2 2.256-1.2h2.291zm-2.124-6.456c-.966 0-1.95.294-2.617.652a5.527 5.527 0 00-1.535 1.237.258.258 0 00.05.391l1.296.82a.313.313 0 00.383-.042c.366-.367 1.09-1.044 2.298-1.044 1.641 0 2.249.76 2.249 1.768v.108h-2.366c-3.583 0-4.431 1.762-4.431 3.232 0 2.665 2.691 2.974 3.532 2.974 1.183 0 2.61-.602 3.273-1.444v.683c0 .175.142.317.318.317h1.539a.317.317 0 00.317-.317V12.13c-.008-.525-.17-3.782-4.306-3.782z" opacity=".5"/></g></svg>',
    language: '<svg height="24" width="24"><path d="M15.167 16.67a.076.076 0 01-.03-.01v.01zm1.553-2.566a1.79 1.79 0 00-.496.063 1.062 1.062 0 00-.379.192v-.01a.755.755 0 00-.201.275.892.892 0 00-.074.364c0 .322.115.534.344.64.223.117.705.183 1.445.196v1.248c-.046 0-.103-.003-.172-.01a4.54 4.54 0 00-.202-.014 14.544 14.544 0 01-.284-.015c-.905 0-1.357.318-1.357.953 0 .348.111.616.334.806.256.243.606.364 1.052.364.406 0 .75-.138 1.032-.413.125-.11.223-.254.295-.427.072-.174.124-.385.157-.634h1.337c-.033.42-.12.79-.26 1.11a2.52 2.52 0 01-.546.807c-.269.255-.58.449-.934.58a3.4 3.4 0 01-1.19.196c-.38 0-.73-.06-1.051-.177a2.74 2.74 0 01-.865-.511 2.532 2.532 0 01-.56-.762 2.085 2.085 0 01-.197-.9c0-.438.079-.799.236-1.08.138-.223.334-.417.59-.58-.413-.387-.62-.823-.62-1.308 0-.649.227-1.173.679-1.573.445-.406 1.114-.61 1.887-.61h.64v1.23zM5.837 7.917L6.99 5.012l1.152 2.905zm4.732 2.345l-2.632-6.65a.171.171 0 00-.163-.112h-1.57a.167.167 0 00-.163.112l-2.632 6.65a.174.174 0 00.163.238H4.66c.098 0 .182-.06.22-.15l.49-1.25h3.234l.494 1.25c.038.09.122.15.22.15h1.088c.126 0 .21-.126.163-.238zm-2.112 5.76l-.48-.48a.5.5 0 00-.706 0l-.48.48a.5.5 0 000 .707l.48.479a.5.5 0 00.707 0l.48-.48a.5.5 0 000-.707m2.916-2.916l-.48-.48a.5.5 0 00-.706 0l-.48.48a.5.5 0 000 .707l.48.48a.5.5 0 00.707 0l.48-.48a.5.5 0 000-.707m2.916-2.917l-.48-.48a.5.5 0 00-.707 0l-.479.48a.5.5 0 000 .707l.48.48a.5.5 0 00.707 0l.479-.48a.5.5 0 000-.707m2.917-2.917l-.48-.48a.5.5 0 00-.707 0l-.48.48a.5.5 0 000 .707l.48.48a.5.5 0 00.707 0l.48-.48a.5.5 0 000-.707" fill-rule="evenodd"/></svg>',
    languageAlt: '<svg height="24" width="24"><g fill-rule="evenodd"><path d="M15.167 16.67a.076.076 0 01-.029-.01v.01zm1.553-2.566a1.79 1.79 0 00-.496.063 1.062 1.062 0 00-.378.192v-.01a.755.755 0 00-.202.275.892.892 0 00-.074.364c0 .322.115.534.344.64.223.117.705.183 1.445.196v1.248c-.046 0-.103-.003-.172-.01a4.54 4.54 0 00-.201-.014 14.544 14.544 0 01-.285-.015c-.904 0-1.357.318-1.357.953 0 .348.112.616.334.806.256.243.607.364 1.052.364.407 0 .75-.138 1.032-.413.125-.11.223-.254.295-.427.072-.174.125-.385.157-.634h1.337c-.032.42-.119.79-.26 1.11a2.52 2.52 0 01-.545.807c-.27.255-.58.449-.935.58a3.4 3.4 0 01-1.189.196c-.38 0-.73-.06-1.052-.177a2.74 2.74 0 01-.865-.511 2.532 2.532 0 01-.56-.762 2.085 2.085 0 01-.197-.9c0-.438.079-.799.236-1.08.138-.223.335-.417.59-.58-.413-.387-.619-.823-.619-1.308 0-.649.226-1.173.678-1.573.446-.406 1.114-.61 1.887-.61h.64v1.23zM5.838 7.917l1.151-2.905 1.152 2.905zm4.732 2.345l-2.633-6.65a.171.171 0 00-.163-.112h-1.57a.167.167 0 00-.163.112l-2.632 6.65a.174.174 0 00.164.238H4.66c.098 0 .182-.06.22-.15l.49-1.25h3.233l.495 1.25c.037.09.121.15.22.15h1.087c.126 0 .21-.126.164-.238z"/><path d="M3.75 1.5C2.51 1.5 1.5 2.51 1.5 3.75v12.5c0 1.24 1.01 2.25 2.25 2.25H5.5v1.75c0 1.24 1.01 2.25 2.25 2.25h12.5c1.24 0 2.25-1.01 2.25-2.25V7.75c0-1.24-1.01-2.25-2.25-2.25H18.5V3.75c0-1.24-1.01-2.25-2.25-2.25zM20.25 24H7.75A3.754 3.754 0 014 20.25V20h-.25A3.754 3.754 0 010 16.25V3.75A3.754 3.754 0 013.75 0h12.5A3.754 3.754 0 0120 3.75V4h.25A3.754 3.754 0 0124 7.75v12.5A3.754 3.754 0 0120.25 24z" opacity=".5"/><path d="M8.458 16.021l-.48-.479a.5.5 0 00-.707 0l-.48.48a.5.5 0 000 .707l.48.479a.5.5 0 00.707 0l.48-.48a.5.5 0 000-.707m2.917-2.916l-.48-.48a.5.5 0 00-.707 0l-.48.48a.5.5 0 000 .707l.48.48a.5.5 0 00.707 0l.48-.48a.5.5 0 000-.707m2.916-2.917l-.479-.48a.5.5 0 00-.707 0l-.48.48a.5.5 0 000 .707l.48.48a.5.5 0 00.707 0l.48-.48a.5.5 0 000-.707m2.916-2.917l-.48-.48a.5.5 0 00-.706 0l-.48.48a.5.5 0 000 .707l.48.48a.5.5 0 00.707 0l.479-.48a.5.5 0 000-.707"/></g></svg>',
    languageColored: '<svg height="24" width="24"><g fill="currentColor"><path d="M14.995 17.278l1.723-4.58 1.717 4.58zm6.72 4.074l-4.126-11a.5.5 0 00-.468-.324h-.807a.5.5 0 00-.468.324l-4.125 11a.5.5 0 00.468.676h.682a.5.5 0 00.468-.325l.999-2.675h4.75l1.008 2.676a.5.5 0 00.468.324h.682a.5.5 0 00.468-.676z" opacity=".5"/><path d="M11.884 15.93l.357-.953a.5.5 0 00-.114-.529l-2.195-2.195c2.125-2.275 2.99-3.842 3.13-6.344h3.676a.5.5 0 00.5-.5v-.75a.5.5 0 00-.5-.5H9.093V2.5a.5.5 0 00-.5-.5h-.75a.5.5 0 00-.5.5v1.66h-4.59a.5.5 0 00-.5.5v.75a.5.5 0 00.5.5h8.56c-.111 1.866-.703 3.048-2.6 5.086C7.728 9.94 7.096 9.114 6.7 8.303a.495.495 0 00-.445-.275H5.44a.501.501 0 00-.46.698c.489 1.148 1.294 2.22 2.513 3.527l-3.746 3.746a.5.5 0 00-.115.529l.358.953a.375.375 0 00.616.134l4.106-4.107 2.556 2.556c.193.193.52.121.616-.134"/></g></svg>',
    languageDirection: '<svg height="24" width="24"><g fill-rule="evenodd"><path d="M14.5 7.497h2.258v1.547c0 .222.27.334.427.176L19.405 7a.5.5 0 000-.706l-2.22-2.22a.25.25 0 00-.427.177v1.546H14.5a.5.5 0 00-.5.5v.7a.5.5 0 00.5.5m-5.45 9.006H6.793v-1.547a.25.25 0 00-.426-.176L4.146 17a.5.5 0 000 .706l2.22 2.22a.25.25 0 00.426-.177v-1.546h2.259a.5.5 0 00.5-.5v-.7a.5.5 0 00-.5-.5"/><path d="M15.167 16.294a.076.076 0 01-.03-.01v.01zm1.553-2.565a1.79 1.79 0 00-.496.063 1.062 1.062 0 00-.379.192v-.01a.753.753 0 00-.201.275.896.896 0 00-.074.364c0 .322.115.534.344.64.223.117.705.183 1.445.196v1.248c-.046 0-.103-.003-.172-.01-.069-.006-.136-.011-.202-.014a10.338 10.338 0 01-.285-.015c-.904 0-1.356.318-1.356.953 0 .348.111.616.334.806.256.243.606.364 1.052.364.406 0 .75-.138 1.032-.413.124-.11.223-.254.295-.427.072-.174.124-.385.157-.634h1.337c-.033.42-.12.79-.26 1.11-.141.321-.323.59-.546.807-.269.255-.58.449-.934.58a3.4 3.4 0 01-1.19.196c-.38 0-.73-.06-1.051-.177a2.74 2.74 0 01-.865-.511 2.532 2.532 0 01-.56-.762 2.085 2.085 0 01-.197-.9c0-.438.079-.799.236-1.08.138-.223.334-.417.59-.58-.413-.387-.62-.823-.62-1.308 0-.649.227-1.173.679-1.573.445-.406 1.114-.61 1.887-.61h.64v1.23z" opacity=".5"/><path d="M5.837 8.417L6.99 5.512l1.152 2.905zm4.732 2.345l-2.632-6.65A.171.171 0 007.774 4h-1.57a.167.167 0 00-.163.112l-2.632 6.65a.174.174 0 00.163.238H4.66c.098 0 .182-.06.22-.15l.49-1.25h3.234l.494 1.25c.038.09.122.15.22.15h1.088c.126 0 .21-.126.163-.238z" opacity=".7"/></g></svg>',
    languageDirectionAlt: '<svg height="24" width="24"><g fill-rule="evenodd"><path d="M19.5 4h-3.14a.25.25 0 00-.176.427l1.093 1.093L5.52 17.278l-1.094-1.094a.25.25 0 00-.426.177V19.5a.5.5 0 00.5.5h3.139a.25.25 0 00.177-.427L6.722 18.48 18.48 6.723l1.094 1.093A.25.25 0 0020 7.639V4.5a.5.5 0 00-.5-.5"/><path d="M15.167 16.294a.076.076 0 01-.03-.01v.01zm1.553-2.565a1.79 1.79 0 00-.496.063 1.063 1.063 0 00-.379.192v-.01a.754.754 0 00-.201.276.89.89 0 00-.074.363c0 .322.115.534.344.64.223.117.705.183 1.445.196v1.248c-.046 0-.103-.003-.172-.01a4.186 4.186 0 00-.202-.014 21.487 21.487 0 01-.284-.015c-.905 0-1.357.318-1.357.953 0 .348.111.616.334.806.256.243.606.364 1.052.364.406 0 .75-.138 1.032-.413a1.16 1.16 0 00.295-.427c.072-.174.124-.385.157-.634h1.337c-.033.42-.12.79-.26 1.11a2.52 2.52 0 01-.546.807c-.269.255-.58.449-.934.58a3.4 3.4 0 01-1.19.196c-.38 0-.73-.06-1.051-.177a2.74 2.74 0 01-.865-.511 2.53 2.53 0 01-.56-.762 2.085 2.085 0 01-.197-.9c0-.438.079-.799.236-1.08.138-.223.334-.417.59-.58-.413-.387-.62-.823-.62-1.308 0-.649.227-1.173.679-1.573.445-.406 1.114-.61 1.887-.61h.64v1.23z" opacity=".5"/><path d="M5.837 8.417L6.99 5.512l1.152 2.905zm4.732 2.345l-2.632-6.65A.171.171 0 007.774 4h-1.57a.167.167 0 00-.163.112l-2.632 6.65a.174.174 0 00.163.238H4.66c.098 0 .182-.06.22-.15l.49-1.25h3.234l.494 1.25c.038.09.122.15.22.15h1.088c.126 0 .21-.126.163-.238z" opacity=".7"/></g></svg>',
    textAlignCenter: '<svg height="24" width="24"><g fill="currentColor"><path d="M3.502 7h17a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-17a.5.5 0 00-.5.5v1a.5.5 0 00.5.5"/><path d="M7.502 11h13a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-13a.5.5 0 00-.5.5v1a.5.5 0 00.5.5" opacity=".7"/><path d="M7.502 19h13a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-13a.5.5 0 00-.5.5v1a.5.5 0 00.5.5" opacity=".3"/><path d="M3.502 15h17a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-17a.5.5 0 00-.5.5v1a.5.5 0 00.5.5" opacity=".5"/></g></svg>',
    textAlignJustify: '<svg height="24" width="24"><g fill="currentColor"><path d="M3.502 7h17a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-17a.5.5 0 00-.5.5v1a.5.5 0 00.5.5"/><path d="M5.5 11h13a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-13a.5.5 0 00-.5.5v1a.5.5 0 00.5.5" opacity=".7"/><path d="M5.5 19h13a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-13a.5.5 0 00-.5.5v1a.5.5 0 00.5.5" opacity=".3"/><path d="M3.502 15h17a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-17a.5.5 0 00-.5.5v1a.5.5 0 00.5.5" opacity=".5"/></g></svg>',
    textAlignLeft: '<svg height="24" width="24"><g fill="currentColor"><path d="M20.5 7h-17a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h17a.5.5 0 01.5.5v1a.5.5 0 01-.5.5"/><path d="M16.5 11h-13a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h13a.5.5 0 01.5.5v1a.5.5 0 01-.5.5" opacity=".7"/><path d="M16.5 19h-13a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h13a.5.5 0 01.5.5v1a.5.5 0 01-.5.5" opacity=".3"/><path d="M20.5 15h-17a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h17a.5.5 0 01.5.5v1a.5.5 0 01-.5.5" opacity=".5"/></g></svg>',
    textAlignRight: '<svg height="24" width="24"><g fill="currentColor"><path d="M3.5 7h17a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-17a.5.5 0 00-.5.5v1a.5.5 0 00.5.5"/><path d="M3.5 11h17a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-17a.5.5 0 00-.5.5v1a.5.5 0 00.5.5" opacity=".7"/><path d="M3.5 19h17a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-17a.5.5 0 00-.5.5v1a.5.5 0 00.5.5" opacity=".3"/><path d="M3.5 15h17a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-17a.5.5 0 00-.5.5v1a.5.5 0 00.5.5" opacity=".5"/></g></svg>',
    textCaseCapital: '<svg height="24" width="24"><g fill-rule="evenodd"><path d="M3.289 13.837L5.52 8.206l2.232 5.63zm7.73 3.74L6.32 5.707a.305.305 0 00-.292-.2H5.013a.298.298 0 00-.292.2L.023 17.577A.31.31 0 00.315 18h1.05a.426.426 0 00.391-.266l.875-2.232h5.772l.883 2.232a.425.425 0 00.392.266h1.049a.31.31 0 00.292-.424z"/><path d="M16.288 13.837l2.233-5.631 2.232 5.63zm7.73 3.74L19.32 5.707a.305.305 0 00-.291-.2h-1.016a.298.298 0 00-.292.2l-4.698 11.87a.31.31 0 00.292.424h1.05a.425.425 0 00.39-.266l.875-2.232h5.773l.883 2.232a.426.426 0 00.391.266h1.05a.31.31 0 00.291-.424z" opacity=".5"/></g></svg>',
    textCaseLower: '<svg height="24" width="24"><g fill-rule="evenodd"><path d="M9.393 14.803c-.242.466-1.308 1.84-3.257 1.84-1.15 0-1.79-.449-1.79-1.274 0-.624.257-1.37 2.506-1.37h2.541zm1.408-4.027a2.992 2.992 0 00-.775-1.116 3.43 3.43 0 00-1.266-.725 5.505 5.505 0 00-1.741-.258c-.966 0-1.79.183-2.457.541a5.336 5.336 0 00-1.516 1.208.258.258 0 00.05.392l.891.566a.313.313 0 00.383-.042c.367-.366 1.316-1.158 2.524-1.158 1.641 0 2.49.742 2.49 2.025v.358H6.778c-1.299 0-2.315.258-3.065.774-.75.517-1.116 1.179-1.116 2.128 0 .375.066.725.208 1.05.133.325.342.608.616.866.275.25.617.45 1.025.591.408.142.891.217 1.433.217.8 0 1.532-.158 2.199-.475a4.1 4.1 0 001.324-.95v.915c0 .175.142.317.317.317h1.041a.316.316 0 00.316-.317V12.21c-.008-.525-.1-1-.274-1.433z"/><path d="M19.873 14.803c-.242.466-1.308 1.84-3.257 1.84-1.15 0-1.791-.449-1.791-1.274 0-.624.258-1.37 2.507-1.37h2.54zm1.407-4.027a2.998 2.998 0 00-.774-1.116 3.43 3.43 0 00-1.266-.725 5.507 5.507 0 00-1.741-.258c-.967 0-1.791.183-2.458.541a5.338 5.338 0 00-1.516 1.208.258.258 0 00.05.392l.892.566a.313.313 0 00.383-.042c.366-.366 1.316-1.158 2.524-1.158 1.64 0 2.49.742 2.49 2.025v.358h-2.607c-1.3 0-2.316.258-3.065.774-.75.517-1.116 1.179-1.116 2.128 0 .375.066.725.208 1.05.133.325.341.608.616.866.275.25.616.45 1.025.591.408.142.89.217 1.432.217.8 0 1.533-.158 2.2-.475a4.106 4.106 0 001.324-.95v.915c0 .175.142.317.316.317h1.042a.316.316 0 00.316-.317V12.21c-.008-.525-.1-1-.275-1.433z" opacity=".5"/></g></svg>',
    textCaseTitle: '<svg height="24" width="24"><g fill-rule="evenodd"><path d="M4.806 13.837l2.232-5.631 2.232 5.63zm7.73 3.74L7.838 5.707a.305.305 0 00-.292-.2H6.53a.298.298 0 00-.292.2L1.54 17.577a.31.31 0 00.292.424h1.05a.425.425 0 00.391-.266l.875-2.232H9.92l.883 2.232a.426.426 0 00.392.266h1.05a.31.31 0 00.29-.424z"/><path d="M21.037 14.803c-.241.467-1.307 1.84-3.256 1.84-1.15 0-1.791-.449-1.791-1.273 0-.625.258-1.37 2.507-1.37h2.54zm1.408-4.027a2.992 2.992 0 00-.775-1.116 3.425 3.425 0 00-1.266-.725 5.504 5.504 0 00-1.74-.258c-.967 0-1.791.183-2.458.542a5.334 5.334 0 00-1.516 1.207.258.258 0 00.05.392l.891.566a.313.313 0 00.384-.041c.366-.367 1.316-1.158 2.524-1.158 1.64 0 2.49.741 2.49 2.024v.358h-2.607c-1.3 0-2.316.258-3.065.775-.75.516-1.116 1.178-1.116 2.128 0 .374.066.724.208 1.049.133.325.341.608.616.866.275.25.616.45 1.025.592.408.141.89.216 1.432.216.8 0 1.533-.158 2.2-.474a4.106 4.106 0 001.324-.95v.914c0 .175.142.317.316.317h1.042a.316.316 0 00.316-.317V12.21c-.008-.525-.1-1-.275-1.433z" opacity=".5"/></g></svg>',
    textLetterSpacing: '<svg height="24" width="24"><g fill="currentColor"><path d="M4.977 10.65l1.884-4.817 1.86 4.817zm7.188 3.926L7.701 3.21A.321.321 0 007.395 3H6.328a.313.313 0 00-.306.21L1.524 14.576c-.087.21.07.446.306.446h1.102a.447.447 0 00.411-.28l.943-2.343h5.117l.943 2.343c.07.166.228.28.411.28h1.102a.325.325 0 00.306-.446z" opacity=".3"/><path d="M21.647 18.647l-2.22-2.22a.25.25 0 00-.427.177v1.546H5v-1.546a.25.25 0 00-.426-.177l-2.22 2.22a.5.5 0 000 .707l2.22 2.22A.25.25 0 005 21.396V19.85h14v1.547c0 .222.27.334.427.176l2.22-2.22a.5.5 0 000-.706"/><path d="M11.835 3.446L16.3 14.812c.052.13.166.21.306.21h1.066c.14 0 .263-.08.306-.21l4.498-11.366A.325.325 0 0022.17 3h-1.102a.447.447 0 00-.411.28l-3.518 8.91-3.485-8.91a.447.447 0 00-.411-.28H12.14a.325.325 0 00-.306.446" opacity=".5"/></g></svg>',
    textLetterWidth: '<svg height="24" width="24"><g fill="currentColor"><path d="M21.646 18.646l-2.22-2.22a.25.25 0 00-.426.177v1.547H5v-1.547a.25.25 0 00-.427-.176l-2.22 2.22a.5.5 0 000 .706l2.22 2.22A.25.25 0 005 21.396V19.85h14v1.546c0 .223.269.335.426.177l2.22-2.22a.5.5 0 000-.707"/><path d="M17.5 3h-11a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h4.502v9.5a.5.5 0 00.5.5h1a.5.5 0 00.5-.5V5H17.5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5" opacity=".5"/></g></svg>',
    textLineHeight: '<svg height="24" width="24"><g fill="currentColor" fill-rule="evenodd"><path d="M7.043 17H5.497V7h1.546a.25.25 0 00.177-.427L5 4.353a.5.5 0 00-.707 0l-2.22 2.22A.25.25 0 002.25 7h1.547v10H2.25a.25.25 0 00-.176.427l2.22 2.22a.5.5 0 00.706 0l2.22-2.22A.25.25 0 007.043 17"/><path d="M21.5 19h-11a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h11a.5.5 0 01.5.5v1a.5.5 0 01-.5.5" opacity=".7"/><path d="M21.5 13h-11a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h11a.5.5 0 01.5.5v1a.5.5 0 01-.5.5" opacity=".5"/><path d="M21.5 7h-11a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h11a.5.5 0 01.5.5v1a.5.5 0 01-.5.5" opacity=".3"/></g></svg>',
    typography: '<svg height="24" width="24"><path d="M5 4.5v4c0 .28.22.5.5.5H7c.28 0 .5-.22.5-.5v-2h3.25v11H9c-.28 0-.5.22-.5.5v1.5c0 .28.22.5.5.5h6c.28 0 .5-.22.5-.5V18c0-.28-.22-.5-.5-.5h-1.75v-11h3.25v2c0 .28.22.5.5.5h1.5c.28 0 .5-.22.5-.5v-4c0-.28-.22-.5-.5-.5h-13c-.28 0-.5.22-.5.5z" fill-rule="evenodd"/></svg>',
    typographyOutline: '<svg height="24" width="24"><path d="M5 4.5V8c0 .28.22.5.5.5h1c.28 0 .5-.22.5-.5V6h4v12H9c-.28 0-.5.22-.5.5v1c0 .28.22.5.5.5h6c.28 0 .5-.22.5-.5v-1c0-.28-.22-.5-.5-.5h-2V6h4v2c0 .28.22.5.5.5h1c.28 0 .5-.22.5-.5V4.5c0-.28-.22-.5-.5-.5h-13c-.28 0-.5.22-.5.5z" fill-rule="evenodd"/></svg>',
    arrowDownCircle: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-down-circle"><circle cx="12" cy="12" r="10"/><path d="M8 12l4 4 4-4M12 8v8"/></svg>',
    arrowLeftCircle: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-left-circle"><circle cx="12" cy="12" r="10"/><path d="M12 8l-4 4 4 4M16 12H8"/></svg>',
    arrowRightCircle: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right-circle"><circle cx="12" cy="12" r="10"/><path d="M12 16l4-4-4-4M8 12h8"/></svg>',
    arrowUpCircle: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-up-circle"><circle cx="12" cy="12" r="10"/><path d="M16 12l-4-4-4 4M12 16V8"/></svg>',
    checkCircle: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check-circle"><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><path d="M22 4L12 14.01l-3-3"/></svg>',
    chevronDown: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-down"><path d="M6 9l6 6 6-6"/></svg>',
    chevronLeft: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><path d="M15 18l-6-6 6-6"/></svg>',
    chevronRight: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><path d="M9 18l6-6-6-6"/></svg>',
    chevronUp: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-up"><path d="M18 15l-6-6-6 6"/></svg>',
    eyeOff: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-eye-off"><path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24M1 1l22 22"/></svg>',
    eye: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-eye"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>',
    moreHorizontal: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-more-horizontal"><circle cx="12" cy="12" r="1"/><circle cx="19" cy="12" r="1"/><circle cx="5" cy="12" r="1"/></svg>',
    moreVertical: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-more-vertical"><circle cx="12" cy="12" r="1"/><circle cx="12" cy="5" r="1"/><circle cx="12" cy="19" r="1"/></svg>',
    send: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-send"><path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z"/></svg>',
    smile: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-smile"><circle cx="12" cy="12" r="10"/><path d="M8 14s1.5 2 4 2 4-2 4-2M9 9h.01M15 9h.01"/></svg>',
    search: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>',
    video: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-video"><path d="M23 7l-7 5 7 5V7z"/><rect x="1" y="5" width="15" height="14" rx="2" ry="2"/></svg>',
    email: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.57143 4C1.70355 4 1 4.56554 1 5.26316V18.7368C1 19.4345 1.70355 20 2.57143 20H21.4286C22.2964 20 23 19.4345 23 18.7368V5.26316C23 4.56553 22.2964 4 21.4286 4H2.57143ZM3.09524 6.34082V18.3158H20.9048V6.98746L12.876 12.6076C12.3368 12.9851 11.6145 12.9669 11.0949 12.5628L3.09524 6.34082ZM19.279 5.68421H5.50867L12.0314 10.7575L19.279 5.68421Z" fill="currentColor"/></svg>',
    inspect: '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="m12.385 11.077 10 4.166c.85.354.81 1.573-.063 1.87l-2.833.961 2.218 2.219a1 1 0 0 1-1.414 1.414l-2.219-2.218-.961 2.833c-.283.833-1.407.908-1.817.173l-.053-.11-4.166-10c-.343-.825.483-1.651 1.308-1.308ZM17 1a3 3 0 0 1 3 3v7a1 1 0 0 1-2 0V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h7a1 1 0 0 1 0 2H4a3 3 0 0 1-3-3V4a3 3 0 0 1 3-3h13Zm-3.144 12.856 2.215 5.315.628-1.848a1 1 0 0 1 .518-.581l.107-.044 1.847-.627-5.315-2.215Z"/></svg>',
    symbolsFromHere: '<>',
    arrowUpRightRect: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M6.48486328,23.1376953 L19.5151367,23.1376953 C21.7709961,23.1376953 22.8881836,22.03125 22.8881836,19.8183594 L22.8881836,6.69140625 C22.8881836,4.47851562 21.7709961,3.36132812 19.5151367,3.36132812 L6.48486328,3.36132812 C4.23974609,3.36132812 3.11181641,4.47851562 3.11181641,6.69140625 L3.11181641,19.8183594 C3.11181641,22.03125 4.23974609,23.1376953 6.48486328,23.1376953 Z M6.50634766,21.4082031 C5.43212891,21.4082031 4.84130859,20.8388672 4.84130859,19.7216797 L4.84130859,6.78808594 C4.84130859,5.67089844 5.43212891,5.09082031 6.50634766,5.09082031 L19.4936523,5.09082031 C20.5571289,5.09082031 21.1586914,5.67089844 21.1586914,6.78808594 L21.1586914,19.7216797 C21.1586914,20.8388672 20.5571289,21.4082031 19.4936523,21.4082031 L6.50634766,21.4082031 Z M15.5942383,13.2119141 L15.5942383,15.0703125 C15.5942383,15.5751953 15.9057617,15.9082031 16.3891602,15.9082031 C16.8618164,15.9082031 17.1733398,15.5429688 17.1733398,15.0488281 L17.1733398,9.97851562 C17.1733398,9.34472656 16.8295898,9.09765625 16.2817383,9.09765625 L11.1791992,9.09765625 C10.6743164,9.09765625 10.3520508,9.40917969 10.3520508,9.88183594 C10.3520508,10.3544922 10.6850586,10.6660156 11.2006836,10.6660156 L13.1557617,10.6660156 L14.7670898,10.4833984 L13.0698242,12.0517578 L9.11669922,16.015625 C8.96630859,16.1660156 8.85888672,16.3808594 8.85888672,16.5957031 C8.85888672,17.0791016 9.17041016,17.390625 9.64306641,17.390625 C9.91162109,17.390625 10.1049805,17.2939453 10.2553711,17.1435547 L14.2084961,13.1904297 L15.7768555,11.5146484 L15.5942383,13.2119141 Z" transform="translate(-1 -1)"/></svg>',
    arrowUpRightRectFill: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M6.48486328,23.1376953 L19.5151367,23.1376953 C21.7709961,23.1376953 22.8881836,22.03125 22.8881836,19.8183594 L22.8881836,6.69140625 C22.8881836,4.47851562 21.7709961,3.36132812 19.5151367,3.36132812 L6.48486328,3.36132812 C4.23974609,3.36132812 3.11181641,4.47851562 3.11181641,6.69140625 L3.11181641,19.8183594 C3.11181641,22.03125 4.23974609,23.1376953 6.48486328,23.1376953 Z M16.4750977,15.9941406 C15.980957,15.9941406 15.6586914,15.6503906 15.6586914,15.1240234 L15.6586914,13.2226562 L15.8198242,11.4931641 L14.2192383,13.2011719 L10.1694336,17.2617188 C10.0083008,17.4228516 9.79345703,17.5195312 9.52490234,17.5195312 C9.04150391,17.5195312 8.71923828,17.1972656 8.71923828,16.6923828 C8.71923828,16.4775391 8.81591797,16.2519531 8.97705078,16.0908203 L13.0483398,12.0302734 L14.777832,10.4189453 L13.1342773,10.5908203 L11.1362305,10.5908203 C10.5991211,10.5908203 10.2553711,10.2685547 10.2553711,9.78515625 C10.2553711,9.29101562 10.5883789,8.96875 11.1147461,8.96875 L16.3569336,8.96875 C16.9262695,8.96875 17.2915039,9.2265625 17.2915039,9.88183594 L17.2915039,15.1025391 C17.2915039,15.6181641 16.9584961,15.9941406 16.4750977,15.9941406 Z" transform="translate(-1 -1)"/></svg>',
    back: '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24"><path d="M12.4262695,23.0947266 C13.1567383,23.0947266 13.6831055,22.5576172 13.6831055,21.8378906 L13.6831055,17.734375 L13.9946289,17.734375 C18.1625977,17.734375 20.7836914,18.7871094 22.6635742,22.2998047 C23.0395508,22.9873047 23.5336914,23.0947266 23.9848633,23.0947266 C24.5541992,23.0947266 25.0913086,22.5791016 25.0913086,21.6552734 C25.0913086,13.7167969 21.7290039,8.76464844 13.9946289,8.76464844 L13.6831055,8.76464844 L13.6831055,4.70410156 C13.6831055,3.984375 13.1567383,3.39355469 12.4047852,3.39355469 C11.878418,3.39355469 11.5239258,3.61914062 10.9545898,4.15625 L2.47900391,12.0839844 C2.06005859,12.4814453 1.93115234,12.8789062 1.93115234,13.2441406 C1.93115234,13.5986328 2.07080078,14.0068359 2.47900391,14.3935547 L10.9545898,22.3964844 C11.4702148,22.8798828 11.8999023,23.0947266 12.4262695,23.0947266 Z M11.8139648,20.7851562 C11.7495117,20.7851562 11.6850586,20.7529297 11.6313477,20.6884766 L3.97216797,13.4482422 C3.88623047,13.3623047 3.85400391,13.3085938 3.85400391,13.2441406 C3.85400391,13.1796875 3.88623047,13.1152344 3.97216797,13.0400391 L11.6206055,5.703125 C11.6743164,5.66015625 11.7387695,5.6171875 11.8032227,5.6171875 C11.8999023,5.6171875 11.9536133,5.68164062 11.9536133,5.76757812 L11.9536133,10.0322266 C11.9536133,10.2792969 12.0717773,10.3867188 12.3188477,10.3867188 L13.7583008,10.3867188 C21.1274414,10.3867188 23.3510742,15.5 23.565918,20.5703125 C23.565918,20.65625 23.5336914,20.6884766 23.4799805,20.6884766 C23.4370117,20.6884766 23.4155273,20.65625 23.3833008,20.5810547 C22.1157227,17.8847656 18.8608398,16.1123047 13.7583008,16.1123047 L12.3188477,16.1123047 C12.0717773,16.1123047 11.9536133,16.2197266 11.9536133,16.4667969 L11.9536133,20.6240234 C11.9536133,20.7207031 11.8999023,20.7851562 11.8139648,20.7851562 Z" transform="translate(-1 -1)"/></svg>',
    billing: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12.8798828,24.2011719 C18.9277344,24.2011719 23.8369141,19.2919922 23.8369141,13.2441406 C23.8369141,7.19628906 18.9277344,2.28710938 12.8798828,2.28710938 C6.83203125,2.28710938 1.92285156,7.19628906 1.92285156,13.2441406 C1.92285156,19.2919922 6.83203125,24.2011719 12.8798828,24.2011719 Z M12.8798828,22.375 C7.83105469,22.375 3.74902344,18.2929688 3.74902344,13.2441406 C3.74902344,8.1953125 7.83105469,4.11328125 12.8798828,4.11328125 C17.9287109,4.11328125 22.0107422,8.1953125 22.0107422,13.2441406 C22.0107422,18.2929688 17.9287109,22.375 12.8798828,22.375 Z M12.8691406,19.2167969 C13.0625,19.2167969 13.2236328,19.0556641 13.2236328,18.8623047 L13.2236328,17.9277344 C14.8994141,17.8310547 16.3173828,16.9824219 16.3173828,15.2421875 C16.3173828,13.6308594 15.0175781,13.0078125 13.5566406,12.6640625 L13.2236328,12.5888672 L13.2236328,9.47363281 C14.1044922,9.55957031 14.7167969,10.0107422 14.9746094,10.8164062 C15.0820312,11.1386719 15.2861328,11.2998047 15.5761719,11.2998047 C15.8447266,11.2998047 16.15625,11.1279297 16.15625,10.7519531 C16.15625,9.47363281 14.6523438,8.54980469 13.2236328,8.41015625 L13.2236328,7.49707031 C13.2236328,7.30371094 13.0625,7.14257812 12.8691406,7.14257812 C12.6757812,7.14257812 12.5146484,7.30371094 12.5146484,7.49707031 L12.5146484,8.41015625 C10.9355469,8.5390625 9.59277344,9.484375 9.59277344,11.0205078 C9.59277344,12.6210938 10.9355469,13.2333984 12.2568359,13.5449219 L12.5146484,13.609375 L12.5146484,16.8642578 C11.5800781,16.7890625 10.9355469,16.3916016 10.5917969,15.4785156 C10.4628906,15.15625 10.2802734,15.0166016 9.99023438,15.0166016 C9.67871094,15.0166016 9.42089844,15.2314453 9.42089844,15.5751953 C9.42089844,15.6826172 9.44238281,15.7900391 9.48535156,15.9189453 C9.86132812,17.2080078 11.2148438,17.8310547 12.5146484,17.9277344 L12.5146484,18.8623047 C12.5146484,19.0556641 12.6757812,19.2167969 12.8691406,19.2167969 Z M10.7958984,10.9345703 C10.7958984,10.0429688 11.6337891,9.58105469 12.5146484,9.47363281 L12.5146484,12.4169922 C11.5908203,12.2021484 10.7958984,11.8046875 10.7958984,10.9345703 Z M13.2880859,13.7919922 C14.2441406,14.0175781 15.125,14.3613281 15.125,15.3388672 C15.125,16.4023438 14.2119141,16.7998047 13.2236328,16.875 L13.2236328,13.7705078 L13.2880859,13.7919922 Z" transform="translate(-1 -1)"/></svg>',
    bookmark: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M5.8984375,24.7490234 C6.42480469,24.7490234 6.73632812,24.4482422 7.703125,23.5136719 L11.9033203,19.3779297 C11.9570312,19.3242188 12.0537109,19.3242188 12.0966797,19.3779297 L16.296875,23.5136719 C17.2636719,24.4482422 17.5751953,24.7490234 18.1015625,24.7490234 C18.8212891,24.7490234 19.2402344,24.2763672 19.2402344,23.4384766 L19.2402344,4.79003906 C19.2402344,2.74902344 18.2197266,1.70703125 16.2001953,1.70703125 L7.79980469,1.70703125 C5.78027344,1.70703125 4.75976562,2.74902344 4.75976562,4.79003906 L4.75976562,23.4384766 C4.75976562,24.2763672 5.17871094,24.7490234 5.8984375,24.7490234 Z M6.77929688,21.8486328 C6.62890625,21.9990234 6.45703125,21.9560547 6.45703125,21.7412109 L6.45703125,4.81152344 C6.45703125,3.88769531 6.94042969,3.40429688 7.88574219,3.40429688 L16.125,3.40429688 C17.0595703,3.40429688 17.5429688,3.88769531 17.5429688,4.81152344 L17.5429688,21.7412109 C17.5429688,21.9560547 17.3818359,21.9990234 17.2207031,21.8486328 L12.5693359,17.3369141 C12.2255859,17.0039062 11.7744141,17.0039062 11.4306641,17.3369141 L6.77929688,21.8486328 Z" transform="translate(0 -1)"/></svg>',
    chat: '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="24" viewBox="0 0 26 24"><path d="M15,22.9121094 C22.21875,22.9121094 27.4931641,18.5078125 27.4931641,12.4492188 C27.4931641,6.36914062 22.2080078,1.99707031 15,1.99707031 C7.78125,1.99707031 2.50683594,6.36914062 2.50683594,12.4492188 C2.50683594,14.4580078 3.09765625,16.3271484 4.12890625,17.8417969 C4.63378906,18.59375 4.81640625,19.1201172 4.81640625,19.5605469 C4.81640625,20.1298828 4.64453125,20.5917969 4.15039062,21.0214844 C3.30175781,21.7412109 3.7421875,22.9121094 4.859375,22.9121094 C6.20214844,22.9121094 7.6953125,22.4501953 8.80175781,21.6875 C10.6171875,22.4824219 12.7333984,22.9121094 15,22.9121094 Z M15,21.1826172 C12.9482422,21.1826172 11.1113281,20.7958984 9.55371094,20.0976562 C8.86621094,19.796875 8.37207031,19.8828125 7.71679688,20.2695312 C7.25488281,20.5595703 6.71777344,20.8066406 6.16992188,20.9248047 C6.39550781,20.5488281 6.54589844,20.1191406 6.54589844,19.5605469 C6.54589844,18.765625 6.25585938,17.8955078 5.56835938,16.8642578 C4.70898438,15.6181641 4.23632812,14.1035156 4.23632812,12.4492188 C4.23632812,7.41113281 8.68359375,3.7265625 15,3.7265625 C21.3164062,3.7265625 25.7636719,7.41113281 25.7636719,12.4492188 C25.7636719,17.4873047 21.3164062,21.1826172 15,21.1826172 Z M9.98339844,13.9960938 C10.8427734,13.9960938 11.5410156,13.2978516 11.5410156,12.4384766 C11.5410156,11.5791016 10.8320312,10.8808594 9.98339844,10.8808594 C9.12402344,10.8808594 8.42578125,11.5791016 8.42578125,12.4384766 C8.42578125,13.2978516 9.12402344,13.9960938 9.98339844,13.9960938 Z M15,13.9960938 C15.8486328,13.9960938 16.546875,13.2978516 16.546875,12.4384766 C16.546875,11.5791016 15.8486328,10.8808594 15,10.8808594 C14.140625,10.8808594 13.4423828,11.5791016 13.4423828,12.4384766 C13.4423828,13.2978516 14.140625,13.9960938 15,13.9960938 Z M20.0058594,13.9960938 C20.8652344,13.9960938 21.5634766,13.2978516 21.5634766,12.4384766 C21.5634766,11.5791016 20.8652344,10.8808594 20.0058594,10.8808594 C19.1464844,10.8808594 18.4482422,11.5791016 18.4482422,12.4384766 C18.4482422,13.2978516 19.1464844,13.9960938 20.0058594,13.9960938 Z" transform="translate(-2 -1)"/></svg>',
    check: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M9.74951172,22.7294922 C10.2114258,22.7294922 10.5766602,22.5253906 10.8344727,22.1279297 L20.9858398,6.14355469 C21.1791992,5.83203125 21.2543945,5.59570312 21.2543945,5.34863281 C21.2543945,4.7578125 20.8676758,4.37109375 20.2768555,4.37109375 C19.847168,4.37109375 19.6108398,4.51074219 19.3530273,4.91894531 L9.70654297,20.2910156 L4.70068359,13.7382812 C4.43212891,13.3623047 4.16357422,13.2119141 3.77685547,13.2119141 C3.16455078,13.2119141 2.74560547,13.6308594 2.74560547,14.2216797 C2.74560547,14.46875 2.85302734,14.7480469 3.05712891,15.0058594 L8.63232422,22.1064453 C8.95458984,22.5253906 9.28759766,22.7294922 9.74951172,22.7294922 Z" transform="translate(0 -1)"/></svg>',
    checkOval: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M13,24.2011719 C19.0478516,24.2011719 23.9570312,19.2919922 23.9570312,13.2441406 C23.9570312,7.19628906 19.0478516,2.28710938 13,2.28710938 C6.95214844,2.28710938 2.04296875,7.19628906 2.04296875,13.2441406 C2.04296875,19.2919922 6.95214844,24.2011719 13,24.2011719 Z M13,22.375 C7.95117188,22.375 3.86914062,18.2929688 3.86914062,13.2441406 C3.86914062,8.1953125 7.95117188,4.11328125 13,4.11328125 C18.0488281,4.11328125 22.1308594,8.1953125 22.1308594,13.2441406 C22.1308594,18.2929688 18.0488281,22.375 13,22.375 Z M11.8183594,18.3466797 C12.1728516,18.3466797 12.4736328,18.1748047 12.6884766,17.8417969 L17.5976562,10.1181641 C17.7158203,9.90332031 17.8554688,9.66699219 17.8554688,9.43066406 C17.8554688,8.94726562 17.4257812,8.63574219 16.9746094,8.63574219 C16.7060547,8.63574219 16.4375,8.80761719 16.2333984,9.11914062 L11.7753906,16.2734375 L9.65917969,13.5341797 C9.40136719,13.1904297 9.16503906,13.1044922 8.86425781,13.1044922 C8.40234375,13.1044922 8.03710938,13.4804688 8.03710938,13.953125 C8.03710938,14.1894531 8.13378906,14.4150391 8.28417969,14.6191406 L10.9052734,17.8417969 C11.1738281,18.1962891 11.4638672,18.3466797 11.8183594,18.3466797 Z" transform="translate(-1 -1)"/></svg>',
    checkOvalFill: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M13,24.2011719 C19.0478516,24.2011719 23.9570312,19.28125 23.9570312,13.2441406 C23.9570312,7.19628906 19.0478516,2.28710938 13,2.28710938 C6.96289062,2.28710938 2.04296875,7.19628906 2.04296875,13.2441406 C2.04296875,19.28125 6.96289062,24.2011719 13,24.2011719 Z M11.796875,18.4970703 C11.4316406,18.4970703 11.1308594,18.3466797 10.8515625,17.9707031 L8.15527344,14.6621094 C7.99414062,14.4472656 7.89746094,14.2109375 7.89746094,13.9638672 C7.89746094,13.4804688 8.2734375,13.0830078 8.75683594,13.0830078 C9.06835938,13.0830078 9.3046875,13.1796875 9.57324219,13.5341797 L11.7539062,16.3486328 L16.3408203,8.97949219 C16.5449219,8.65722656 16.8242188,8.48535156 17.1035156,8.48535156 C17.5761719,8.48535156 18.0166016,8.80761719 18.0166016,9.3125 C18.0166016,9.54882812 17.8769531,9.79589844 17.7480469,10.0214844 L12.6992188,17.9707031 C12.4736328,18.3251953 12.1621094,18.4970703 11.796875,18.4970703 Z" transform="translate(-1 -1)"/></svg>',
    forward: '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24"><path d="M15.5737305,23.0947266 C16.1000977,23.0947266 16.5297852,22.8798828 17.0454102,22.3964844 L25.5209961,14.3935547 C25.9291992,14.0068359 26.0688477,13.5986328 26.0688477,13.2441406 C26.0688477,12.8789062 25.9399414,12.4814453 25.5209961,12.0839844 L17.0454102,4.15625 C16.4760742,3.61914062 16.121582,3.39355469 15.5952148,3.39355469 C14.8432617,3.39355469 14.3061523,3.984375 14.3061523,4.70410156 L14.3061523,8.76464844 L13.9946289,8.76464844 C6.27099609,8.76464844 2.90869141,13.7167969 2.90869141,21.6552734 C2.90869141,22.5791016 3.43505859,23.0947266 4.01513672,23.0947266 C4.46630859,23.0947266 4.96044922,22.9873047 5.33642578,22.2998047 C7.20556641,18.7871094 9.83740234,17.734375 13.9946289,17.734375 L14.3061523,17.734375 L14.3061523,21.8378906 C14.3061523,22.5576172 14.8432617,23.0947266 15.5737305,23.0947266 Z M16.1860352,20.7851562 C16.1000977,20.7851562 16.0356445,20.7207031 16.0356445,20.6240234 L16.0356445,16.4667969 C16.0356445,16.2197266 15.9282227,16.1123047 15.6811523,16.1123047 L14.2416992,16.1123047 C9.13916016,16.1123047 5.88427734,17.8847656 4.61669922,20.5810547 C4.58447266,20.65625 4.56298828,20.6884766 4.50927734,20.6884766 C4.46630859,20.6884766 4.43408203,20.65625 4.43408203,20.5703125 C4.64892578,15.5 6.86181641,10.3867188 14.2416992,10.3867188 L15.6811523,10.3867188 C15.9282227,10.3867188 16.0356445,10.2792969 16.0356445,10.0322266 L16.0356445,5.76757812 C16.0356445,5.68164062 16.1000977,5.6171875 16.1967773,5.6171875 C16.2612305,5.6171875 16.3256836,5.66015625 16.3793945,5.703125 L24.027832,13.0400391 C24.1030273,13.1152344 24.1352539,13.1796875 24.1352539,13.2441406 C24.1352539,13.3085938 24.1137695,13.3623047 24.027832,13.4482422 L16.3686523,20.6884766 C16.3149414,20.7529297 16.2504883,20.7851562 16.1860352,20.7851562 Z" transform="translate(-2 -1)"/></svg>',
    minimize: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M22.5454102,12.2128906 C23.1147461,12.2128906 23.5551758,11.7939453 23.5551758,11.2246094 C23.5444336,10.6445312 23.1147461,10.2470703 22.5454102,10.2470703 L21.6430664,10.2470703 L17.8833008,10.4619141 L20.8588867,7.63671875 L24.1782227,4.328125 C24.371582,4.13476562 24.4682617,3.86621094 24.4682617,3.58691406 C24.4682617,2.98535156 24.0170898,2.57714844 23.4155273,2.57714844 C23.1469727,2.57714844 22.9106445,2.67382812 22.7280273,2.8671875 L19.4301758,6.19726562 L16.5942383,9.17285156 L16.809082,5.42382812 L16.809082,4.52148438 C16.809082,3.95214844 16.4008789,3.52246094 15.8422852,3.52246094 C15.262207,3.52246094 14.8432617,3.96289062 14.8432617,4.52148438 L14.8432617,10.4726562 C14.8432617,11.5683594 15.4770508,12.2128906 16.5727539,12.2128906 L22.5454102,12.2128906 Z M12.2329102,23.1162109 C12.8129883,23.1162109 13.2319336,22.6865234 13.2319336,22.1171875 L13.2319336,16.0478516 C13.2319336,14.9521484 12.5981445,14.3183594 11.5024414,14.3183594 L5.41162109,14.3183594 C4.84228516,14.3183594 4.40185547,14.7265625 4.40185547,15.3066406 C4.41259766,15.8759766 4.84228516,16.2734375 5.41162109,16.2734375 L6.43212891,16.2734375 L10.1918945,16.0585938 L7.21630859,18.8837891 L3.83251953,22.2675781 C3.63916016,22.4609375 3.53173828,22.7294922 3.53173828,23.0087891 C3.53173828,23.6103516 3.98291016,24.0185547 4.59521484,24.0185547 C4.85302734,24.0185547 5.10009766,23.921875 5.28271484,23.7285156 L8.64501953,20.3339844 L11.480957,17.3583984 L11.2661133,21.0966797 L11.2661133,22.1171875 C11.2661133,22.6972656 11.6743164,23.1162109 12.2329102,23.1162109 Z" transform="translate(-2 -1)"/></svg>',
    expand: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M22.2382812,11.6865234 C22.8183594,11.6865234 23.2373047,11.2460938 23.2373047,10.6875 L23.2373047,4.72558594 C23.2373047,3.62988281 22.5927734,2.99609375 21.4970703,2.99609375 L15.5351562,2.99609375 C14.9658203,2.99609375 14.5253906,3.40429688 14.5253906,3.984375 C14.5253906,4.56445312 14.9658203,4.96191406 15.5351562,4.96191406 L16.4375,4.96191406 L20.1972656,4.74707031 L17.2109375,7.57226562 L13.9023438,10.8808594 C13.7089844,11.0742188 13.6015625,11.3320312 13.6015625,11.6220703 C13.6015625,12.2236328 14.0634766,12.6210938 14.6650391,12.6210938 C14.9228516,12.6210938 15.1699219,12.5351562 15.3525391,12.3417969 L18.6503906,9.01171875 L21.4863281,6.03613281 L21.2607422,9.78515625 L21.2607422,10.6875 C21.2607422,11.2568359 21.6796875,11.6865234 22.2382812,11.6865234 Z M10.4541016,23.4921875 C11.0341797,23.4921875 11.4638672,23.0839844 11.4638672,22.5039062 C11.4638672,21.9238281 11.0234375,21.5263672 10.4541016,21.5263672 L9.5625,21.5263672 L5.80273438,21.7412109 L8.77832031,18.9160156 L12.0976562,15.6074219 C12.2910156,15.4140625 12.3876953,15.15625 12.3876953,14.8662109 C12.3876953,14.2646484 11.9365234,13.8671875 11.3242188,13.8671875 C11.0664062,13.8671875 10.8300781,13.953125 10.6474609,14.1464844 L7.33886719,17.4765625 L4.51367188,20.4521484 L4.72851562,16.703125 L4.72851562,15.8007812 C4.72851562,15.2314453 4.3203125,14.8017578 3.75097656,14.8017578 C3.18164062,14.8017578 2.76269531,15.2421875 2.76269531,15.8007812 L2.76269531,21.7626953 C2.76269531,22.8583984 3.39648438,23.4921875 4.4921875,23.4921875 L10.4541016,23.4921875 Z" transform="translate(-1 -1)"/></svg>',
    globe: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M13,24.2011719 C19.0478516,24.2011719 23.9570312,19.2919922 23.9570312,13.2441406 C23.9570312,7.19628906 19.0478516,2.28710938 13,2.28710938 C6.95214844,2.28710938 2.04296875,7.19628906 2.04296875,13.2441406 C2.04296875,19.2919922 6.95214844,24.2011719 13,24.2011719 Z M13,22.7402344 C7.7578125,22.7402344 3.50390625,18.4863281 3.50390625,13.2441406 C3.50390625,9.55957031 5.609375,6.35839844 8.67089844,4.79003906 C8.63867188,4.91894531 8.6171875,5.05859375 8.6171875,5.1875 C8.6171875,6.59472656 7.46777344,6.91699219 7.46777344,7.765625 C7.46777344,8.30273438 7.84375,8.65722656 8.42382812,8.65722656 C9.66992188,8.65722656 9.65917969,7.30371094 10.2929688,7.30371094 C10.765625,7.31445312 11.2060547,8.0234375 11.9902344,8.0234375 C12.3447266,8.0234375 12.5166016,7.79785156 12.5380859,7.47558594 C12.5595703,7.3359375 12.6240234,7.27148438 12.7529297,7.27148438 C13.4404297,7.27148438 14.203125,8.04492188 14.203125,8.51757812 C14.203125,8.96875 14.03125,9.3125 13.7519531,9.3125 C13.2685547,9.3125 12.0654297,8.74316406 10.9912109,8.74316406 C8.58496094,8.74316406 6.57617188,10.4511719 6.57617188,12.4921875 C6.57617188,14.2646484 7.61816406,15.2958984 9.44433594,15.2958984 C10.5507812,15.2958984 11.3671875,16.0478516 11.3671875,17.0683594 C11.3671875,18.6582031 11.1953125,21.3974609 13.4511719,21.3974609 C15.4277344,21.3974609 17.1142578,18.3359375 17.5546875,17.6054688 C18.1025391,16.7246094 17.8447266,15.84375 17.8447266,15.2958984 C17.8447266,14.9091797 18.9833984,14.0927734 18.9833984,13.1582031 C18.9833984,12.2128906 16.78125,11.4609375 16.78125,10.9238281 C16.78125,10.5800781 17.0390625,10.2792969 17.3183594,10.2792969 C17.7910156,10.2792969 18.9511719,11.7724609 19.6064453,11.7724609 C20.0361328,11.7724609 20.0683594,11.3964844 20.3046875,11.3964844 C20.8203125,11.3964844 20.9277344,14.1035156 22.3242188,15.0488281 C21.4863281,19.4316406 17.6298828,22.7402344 13,22.7402344 Z M16.1582031,6.76660156 C15.7607422,6.76660156 15.5996094,6.97070312 15.2558594,6.97070312 C14.9228516,6.97070312 14.6757812,6.734375 14.6757812,6.40136719 C14.6757812,5.88574219 15.1914062,5.59570312 16.0722656,5.59570312 C16.8242188,5.59570312 17.3935547,5.98242188 17.3935547,6.48730469 C17.3935547,6.76660156 17.2109375,6.9921875 16.9746094,6.9921875 C16.5878906,6.9921875 16.3837891,6.76660156 16.1582031,6.76660156 Z" transform="translate(-1 -1)"/></svg>',
    helpcenter: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M2.96582031,21.3974609 C2.96582031,23.6425781 4.07226562,24.7597656 6.29589844,24.7597656 L17.7041016,24.7597656 C19.9277344,24.7597656 21.0341797,23.6425781 21.0341797,21.3974609 L21.0341797,5.1015625 C21.0341797,2.8671875 19.9277344,1.72851562 17.7041016,1.72851562 L6.29589844,1.72851562 C4.07226562,1.72851562 2.96582031,2.8671875 2.96582031,5.1015625 L2.96582031,21.3974609 Z M11.7529297,11.3427734 C11.2910156,11.3427734 11.0224609,11.0957031 11.0224609,10.6230469 L11.0224609,10.5048828 C11.0224609,9.63476562 11.4951172,9.16210938 12.1181641,8.72167969 C12.8701172,8.20605469 13.2138672,7.92675781 13.2138672,7.37890625 C13.2138672,6.74511719 12.7412109,6.32617188 11.9570312,6.32617188 C11.3769531,6.32617188 10.9472656,6.61621094 10.6679688,7.12109375 L10.5175781,7.31445312 C10.3564453,7.54003906 10.1738281,7.6796875 9.8515625,7.6796875 C9.55078125,7.6796875 9.21777344,7.45410156 9.21777344,7.04589844 C9.21777344,6.91699219 9.22851562,6.79882812 9.26074219,6.68066406 C9.49707031,5.703125 10.7431641,5.06933594 12.0214844,5.06933594 C13.4931641,5.06933594 14.7929688,5.86425781 14.7929688,7.31445312 C14.7929688,8.35644531 14.1806641,8.89355469 13.3427734,9.44140625 C12.7519531,9.83886719 12.4941406,10.1181641 12.4941406,10.5693359 L12.4941406,10.6875 C12.4941406,11.0527344 12.2041016,11.3427734 11.7529297,11.3427734 Z M11.7421875,13.8994141 C11.2050781,13.8994141 10.7539062,13.4697266 10.7539062,12.9648438 C10.7539062,12.4384766 11.1943359,12.0087891 11.7421875,12.0087891 C12.2685547,12.0087891 12.7089844,12.4277344 12.7089844,12.9648438 C12.7089844,13.4804688 12.2470703,13.8994141 11.7421875,13.8994141 Z M7.90722656,16.6816406 C7.52050781,16.6816406 7.23046875,16.3808594 7.23046875,16.0048828 C7.23046875,15.6396484 7.52050781,15.3603516 7.90722656,15.3603516 L16.1142578,15.3603516 C16.5009766,15.3603516 16.7802734,15.6396484 16.7802734,16.0048828 C16.7802734,16.3808594 16.5009766,16.6816406 16.1142578,16.6816406 L7.90722656,16.6816406 Z M7.90722656,19.9042969 C7.52050781,19.9042969 7.23046875,19.625 7.23046875,19.2597656 C7.23046875,18.8837891 7.52050781,18.5830078 7.90722656,18.5830078 L11.7851562,18.5830078 C12.171875,18.5830078 12.4511719,18.8837891 12.4511719,19.2597656 C12.4511719,19.625 12.171875,19.9042969 11.7851562,19.9042969 L7.90722656,19.9042969 Z" transform="translate(0 -1)"/></svg>',
    learn: '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="28" viewBox="0 0 30 28"><path d="M7.58544922,17.8525391 C7.58544922,19.3671875 8.48779297,20.7744141 10.1098633,21.8271484 L10.1098633,23.2880859 C9.58349609,23.4707031 9.26123047,23.9433594 9.26123047,24.5878906 L9.26123047,27.4130859 C9.26123047,28.2617188 9.80908203,28.8095703 10.6577148,28.8095703 L10.9477539,28.8095703 C11.7963867,28.8095703 12.3442383,28.2617188 12.3442383,27.4130859 L12.3442383,24.5878906 C12.3442383,23.9433594 12.0219727,23.4814453 11.5063477,23.2880859 L11.5063477,22.5791016 C13.2143555,23.3310547 15.4165039,23.7822266 17.9946289,23.7822266 C24.3325195,23.7822266 28.4145508,21.0644531 28.4145508,17.8525391 L28.4145508,12.8037109 L31.5512695,11.3642578 C32.2495117,11.0419922 32.6040039,10.4189453 32.6040039,9.77441406 C32.6040039,9.140625 32.2495117,8.51757812 31.5512695,8.1953125 L20.9702148,3.36132812 C19.831543,2.84570312 18.918457,2.609375 17.9946289,2.62011719 C17.081543,2.609375 16.168457,2.84570312 15.019043,3.36132812 L4.44873047,8.1953125 C3.75048828,8.51757812 3.39599609,9.140625 3.39599609,9.77441406 C3.39599609,10.4189453 3.75048828,11.0419922 4.44873047,11.3642578 L7.58544922,12.8037109 L7.58544922,17.8525391 Z M17.9946289,15.2421875 C17.2856445,15.2421875 16.5874023,15.0595703 15.6743164,14.640625 L12.6235352,13.2441406 L17.0922852,10.8808594 C17.3930664,10.9560547 17.715332,10.9990234 18.0375977,10.9990234 C19.1977539,10.9990234 20.3149414,10.4726562 20.3149414,9.77441406 C20.3149414,9.09765625 19.1977539,8.58203125 18.0375977,8.58203125 C16.8881836,8.58203125 15.7495117,9.09765625 15.7495117,9.77441406 C15.7495117,9.89257812 15.7817383,10 15.8461914,10.1074219 L11.1303711,12.5673828 L5.78076172,10.1396484 C5.58740234,10.0537109 5.50146484,9.92480469 5.50146484,9.77441406 C5.50146484,9.63476562 5.58740234,9.50585938 5.78076172,9.41992188 L15.6743164,4.91894531 C16.5874023,4.5 17.2856445,4.31738281 17.9946289,4.31738281 C18.7143555,4.31738281 19.4018555,4.5 20.3256836,4.91894531 L30.2192383,9.41992188 C30.4018555,9.50585938 30.4985352,9.63476562 30.4985352,9.77441406 C30.4985352,9.92480469 30.4018555,10.0537109 30.2192383,10.1396484 L20.3256836,14.640625 C19.4018555,15.0595703 18.7143555,15.2421875 17.9946289,15.2421875 Z M9.31494141,17.8525391 L9.31494141,13.5878906 L10.1098633,13.953125 L10.1098633,19.6894531 C9.59423828,19.1201172 9.31494141,18.4863281 9.31494141,17.8525391 Z M17.9946289,16.9394531 C18.918457,16.9501953 19.831543,16.7138672 20.9702148,16.1982422 L26.6850586,13.5878906 L26.6850586,17.8525391 C26.6850586,20.0976562 23.2905273,22.1601562 17.9946289,22.1601562 C15.2553711,22.1601562 13.0209961,21.6015625 11.5063477,20.7529297 L11.5063477,14.5869141 L15.019043,16.1982422 C16.168457,16.7138672 17.081543,16.9501953 17.9946289,16.9394531 Z" transform="translate(-3 -1)"/></svg>',
    learnFill: '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="28" viewBox="0 0 30 28"><path d="M31.3901367,8.3671875 L20.8735352,3.5546875 C19.777832,3.06054688 18.8862305,2.82421875 17.9946289,2.84570312 C17.1137695,2.82421875 16.222168,3.06054688 15.1157227,3.5546875 L4.60986328,8.3671875 C3.92236328,8.67871094 3.58935547,9.2265625 3.58935547,9.77441406 C3.58935547,10.3222656 3.92236328,10.859375 4.60986328,11.1816406 L9.03564453,13.2011719 L15.8354492,10.0107422 C15.7709961,9.93554688 15.7495117,9.84960938 15.7495117,9.77441406 C15.7495117,9.09765625 16.8881836,8.58203125 18.0375977,8.58203125 C19.1977539,8.58203125 20.3149414,9.09765625 20.3149414,9.77441406 C20.3149414,10.4726562 19.1977539,10.9990234 18.0375977,10.9990234 C17.6831055,10.9990234 17.3286133,10.9453125 17.0170898,10.859375 L10.5288086,13.8994141 L15.1157227,16.0048828 C16.222168,16.5097656 17.1137695,16.7246094 17.9946289,16.7138672 C18.8862305,16.7246094 19.777832,16.5097656 20.8735352,16.0048828 L31.3901367,11.1816406 C32.0776367,10.859375 32.4106445,10.3222656 32.4106445,9.77441406 C32.4106445,9.2265625 32.0776367,8.67871094 31.3901367,8.3671875 Z M10.4858398,15.4892578 L10.4858398,22.0205078 C12.2905273,23.1162109 14.8686523,23.7822266 17.9946289,23.7822266 C24.3325195,23.7822266 28.4145508,21.0644531 28.4145508,17.8525391 L28.4145508,14.1572266 L21.4858398,17.3261719 C20.2290039,17.90625 19.090332,18.1962891 17.9946289,18.1855469 C16.909668,18.1962891 15.7602539,17.90625 14.503418,17.3261719 L10.4858398,15.4892578 Z M7.58544922,14.1572266 L7.58544922,17.8525391 C7.58544922,18.7871094 8.12255859,19.9472656 9.08935547,20.9355469 L9.08935547,14.8554688 L7.58544922,14.1572266 Z M8.24072266,24.5878906 L8.24072266,27.4130859 C8.24072266,28.2617188 8.78857422,28.8095703 9.63720703,28.8095703 L9.92724609,28.8095703 C10.7758789,28.8095703 11.3237305,28.2617188 11.3237305,27.4130859 L11.3237305,24.5878906 C11.3237305,23.9433594 11.0014648,23.4814453 10.4858398,23.2880859 L10.4858398,22.0205078 C9.94873047,21.6982422 9.47607422,21.3330078 9.08935547,20.9355469 L9.08935547,23.2880859 C8.56298828,23.4707031 8.24072266,23.9433594 8.24072266,24.5878906 Z" transform="translate(-3 -1)"/></svg>',
    network: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M13,24.2011719 C19.0478516,24.2011719 23.9570312,19.2919922 23.9570312,13.2441406 C23.9570312,7.19628906 19.0478516,2.28710938 13,2.28710938 C6.95214844,2.28710938 2.04296875,7.19628906 2.04296875,13.2441406 C2.04296875,19.2919922 6.95214844,24.2011719 13,24.2011719 Z M10.0029297,11.1708984 C9.95996094,10.7519531 9.77734375,10.3759766 9.48730469,10.1074219 C10.4326172,7.71191406 11.9365234,5.54199219 13.9023438,3.79101562 C14.0527344,3.80175781 14.203125,3.82324219 14.3535156,3.84472656 C12.9462891,6.21875 12.0976562,8.8828125 11.8935547,11.6435547 C11.2490234,11.5361328 10.6152344,11.375 10.0029297,11.1708984 Z M5.02929688,8.07714844 C6.56542969,5.72460938 9.10058594,4.09179688 12.0332031,3.79101562 C10.4003906,5.49902344 9.1328125,7.48632812 8.2734375,9.64550781 C7.97265625,9.64550781 7.65039062,9.75292969 7.37109375,9.93554688 C6.53320312,9.41992188 5.73828125,8.78613281 5.02929688,8.07714844 Z M15.0087891,8.21679688 C15.0195312,9.19433594 15.1376953,10.1611328 15.3632812,11.0957031 C15.1699219,11.2890625 15.0302734,11.5361328 14.9550781,11.8046875 C14.6865234,11.8261719 14.4179688,11.8369141 14.1386719,11.8369141 C13.8164062,11.8369141 13.4941406,11.8261719 13.1826172,11.8046875 C13.3652344,9.17285156 14.1708984,6.65917969 15.5136719,4.43554688 C15.1591797,5.64941406 14.9980469,6.91699219 15.0087891,8.21679688 Z M16.3085938,8.20605469 C16.2978516,6.95996094 16.4697266,5.72460938 16.8349609,4.55371094 C18.9619141,5.49902344 20.6806641,7.19628906 21.6474609,9.3125 C20.5087891,10.171875 19.2304688,10.8271484 17.8769531,11.2568359 C17.5869141,10.859375 17.1142578,10.6015625 16.5771484,10.5908203 C16.4160156,9.81738281 16.3193359,9.02246094 16.3085938,8.20605469 Z M3.50390625,13.2441406 C3.50390625,11.8261719 3.81542969,10.4833984 4.36328125,9.28027344 C5.07226562,9.94628906 5.84570312,10.5371094 6.67285156,11.0419922 C6.65136719,11.1279297 6.65136719,11.2246094 6.65136719,11.3212891 C6.65136719,11.890625 6.93066406,12.3955078 7.37109375,12.7070312 C7.14550781,13.8242188 7.02734375,14.984375 7.02734375,16.1552734 C5.79199219,15.5537109 4.61035156,14.7910156 3.52539062,13.8779297 C3.51464844,13.6630859 3.50390625,13.4589844 3.50390625,13.2441406 Z M22.4960938,13.2441406 C22.4960938,14.1679688 22.3671875,15.0703125 22.1201172,15.9082031 C21.4863281,16.2519531 20.8310547,16.5419922 20.1650391,16.7890625 C19.1337891,15.8544922 18.2744141,14.7373047 17.6298828,13.5019531 C17.9199219,13.2548828 18.1132812,12.9111328 18.1884766,12.5244141 C19.5849609,12.0947266 20.9169922,11.4394531 22.1201172,10.5908203 C22.3671875,11.4287109 22.4960938,12.3203125 22.4960938,13.2441406 Z M11.8398438,13.0185547 C11.8398438,14.4150391 12.0009766,15.7900391 12.3125,17.1328125 C12.1298828,17.2724609 11.9794922,17.4550781 11.8720703,17.6591797 C10.6689453,17.4765625 9.4765625,17.1650391 8.32714844,16.7246094 C8.29492188,15.4462891 8.39160156,14.1894531 8.63867188,12.9755859 C9.02539062,12.9003906 9.35839844,12.6962891 9.60546875,12.40625 C10.3251953,12.6533203 11.0771484,12.8359375 11.8398438,12.9541016 C11.8398438,12.9755859 11.8398438,12.9970703 11.8398438,13.0185547 Z M14.1386719,13.1367188 C14.4824219,13.1367188 14.8154297,13.1259766 15.1376953,13.09375 C15.3955078,13.5234375 15.8466797,13.8242188 16.3730469,13.8886719 C16.9853516,15.1240234 17.8017578,16.2626953 18.7792969,17.2402344 C17.5117188,17.5947266 16.2226562,17.7880859 14.9228516,17.8310547 C14.6972656,17.2617188 14.1816406,16.8535156 13.5585938,16.7783203 C13.2900391,15.5859375 13.1396484,14.3505859 13.1396484,13.1044922 C13.4726562,13.1259766 13.8056641,13.1367188 14.1386719,13.1367188 Z M3.84765625,15.7792969 C4.86816406,16.5097656 5.94238281,17.1113281 7.0703125,17.6054688 C7.11328125,18.765625 7.29589844,19.9150391 7.59667969,21.0537109 C5.79199219,19.796875 4.44921875,17.9492188 3.84765625,15.7792969 Z M13,22.7402344 C11.6679688,22.7402344 10.4111328,22.4609375 9.26171875,21.9775391 C8.79980469,20.7314453 8.50976562,19.4423828 8.40234375,18.1318359 C9.49804688,18.5078125 10.6152344,18.7871094 11.7646484,18.9482422 C11.96875,19.6035156 12.5703125,20.0761719 13.2900391,20.1083984 C13.6552734,20.9677734 14.0957031,21.8056641 14.6005859,22.6005859 C14.0742188,22.6972656 13.5478516,22.7402344 13,22.7402344 Z M14.5146484,19.6572266 C14.6650391,19.5068359 14.7939453,19.3242188 14.8798828,19.1308594 C16.5771484,19.0771484 18.2744141,18.7978516 19.9072266,18.2607422 C20.1542969,18.4648438 20.4121094,18.6474609 20.6806641,18.8300781 C19.5097656,20.4306641 17.8554688,21.6552734 15.9326172,22.2783203 C15.3847656,21.4404297 14.9013672,20.5703125 14.5146484,19.6572266 Z" transform="translate(-1 -1)"/></svg>',
    playOval: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M13,24.2011719 C19.0478516,24.2011719 23.9570312,19.2919922 23.9570312,13.2441406 C23.9570312,7.19628906 19.0478516,2.28710938 13,2.28710938 C6.95214844,2.28710938 2.04296875,7.19628906 2.04296875,13.2441406 C2.04296875,19.2919922 6.95214844,24.2011719 13,24.2011719 Z M13,22.375 C7.95117188,22.375 3.86914062,18.2929688 3.86914062,13.2441406 C3.86914062,8.1953125 7.95117188,4.11328125 13,4.11328125 C18.0488281,4.11328125 22.1308594,8.1953125 22.1308594,13.2441406 C22.1308594,18.2929688 18.0488281,22.375 13,22.375 Z M10.9912109,17.4443359 L17.1035156,13.8242188 C17.5546875,13.5664062 17.5439453,12.9433594 17.1035156,12.6748047 L10.9912109,9.0546875 C10.5292969,8.78613281 9.91699219,8.99023438 9.91699219,9.51660156 L9.91699219,16.9824219 C9.91699219,17.4980469 10.4863281,17.7451172 10.9912109,17.4443359 Z" transform="translate(-1 -1)"/></svg>',
    playOvalFill: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M13,24.2011719 C19.0478516,24.2011719 23.9570312,19.28125 23.9570312,13.2441406 C23.9570312,7.19628906 19.0478516,2.28710938 13,2.28710938 C6.96289062,2.28710938 2.04296875,7.19628906 2.04296875,13.2441406 C2.04296875,19.28125 6.96289062,24.2011719 13,24.2011719 Z M10.9589844,17.5732422 C10.4433594,17.8847656 9.85253906,17.6376953 9.85253906,17.1005859 L9.85253906,9.3984375 C9.85253906,8.87207031 10.4863281,8.64648438 10.9589844,8.92578125 L17.2646484,12.6640625 C17.7158203,12.9326172 17.7265625,13.5771484 17.2646484,13.8564453 L10.9589844,17.5732422 Z" transform="translate(-1 -1)"/></svg>',
    plusOval: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12.8798828,24.2011719 C18.9277344,24.2011719 23.8369141,19.2919922 23.8369141,13.2441406 C23.8369141,7.19628906 18.9277344,2.28710938 12.8798828,2.28710938 C6.83203125,2.28710938 1.92285156,7.19628906 1.92285156,13.2441406 C1.92285156,19.2919922 6.83203125,24.2011719 12.8798828,24.2011719 Z M12.8798828,22.375 C7.83105469,22.375 3.74902344,18.2929688 3.74902344,13.2441406 C3.74902344,8.1953125 7.83105469,4.11328125 12.8798828,4.11328125 C17.9287109,4.11328125 22.0107422,8.1953125 22.0107422,13.2441406 C22.0107422,18.2929688 17.9287109,22.375 12.8798828,22.375 Z M8.80859375,14.125 L11.9667969,14.125 L11.9667969,17.2939453 C11.9667969,17.8310547 12.3320312,18.2070312 12.8583984,18.2070312 C13.3955078,18.2070312 13.7714844,17.8417969 13.7714844,17.2939453 L13.7714844,14.125 L16.9404297,14.125 C17.4775391,14.125 17.8535156,13.7705078 17.8535156,13.2441406 C17.8535156,12.7070312 17.4775391,12.3310547 16.9404297,12.3310547 L13.7714844,12.3310547 L13.7714844,9.17285156 C13.7714844,8.625 13.3955078,8.24902344 12.8583984,8.24902344 C12.3320312,8.24902344 11.9667969,8.625 11.9667969,9.17285156 L11.9667969,12.3310547 L8.80859375,12.3310547 C8.26074219,12.3310547 7.89550781,12.7070312 7.89550781,13.2441406 C7.89550781,13.7705078 8.26074219,14.125 8.80859375,14.125 Z" transform="translate(-1 -1)"/></svg>',
    plusOvalFill: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12.8798828,24.2011719 C18.9277344,24.2011719 23.8369141,19.28125 23.8369141,13.2441406 C23.8369141,7.19628906 18.9277344,2.28710938 12.8798828,2.28710938 C6.84277344,2.28710938 1.92285156,7.19628906 1.92285156,13.2441406 C1.92285156,19.28125 6.84277344,24.2011719 12.8798828,24.2011719 Z M12.8691406,18.3681641 C12.3212891,18.3681641 11.9453125,17.9707031 11.9453125,17.4228516 L11.9453125,14.1572266 L8.69042969,14.1572266 C8.13183594,14.1572266 7.74511719,13.7919922 7.74511719,13.2441406 C7.74511719,12.6855469 8.13183594,12.2988281 8.69042969,12.2988281 L11.9453125,12.2988281 L11.9453125,9.04394531 C11.9453125,8.48535156 12.3212891,8.08789062 12.8691406,8.08789062 C13.4277344,8.08789062 13.8144531,8.48535156 13.8144531,9.04394531 L13.8144531,12.2988281 L17.0800781,12.2988281 C17.6279297,12.2988281 18.0253906,12.6855469 18.0253906,13.2441406 C18.0253906,13.7919922 17.6279297,14.1572266 17.0800781,14.1572266 L13.8144531,14.1572266 L13.8144531,17.4228516 C13.8144531,17.9814453 13.4277344,18.3681641 12.8691406,18.3681641 Z" transform="translate(-1 -1)"/></svg>',
    plusRectDotted: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M3.59863281,9.58105469 C4.16796875,9.58105469 4.46875,9.25878906 4.46875,8.70019531 L4.46875,6.16503906 C4.46875,5.04785156 5.05957031,4.47851562 6.13378906,4.47851562 L8.73339844,4.47851562 C9.30273438,4.47851562 9.61425781,4.16699219 9.61425781,3.60839844 C9.61425781,3.04980469 9.30273438,2.74902344 8.73339844,2.74902344 L6.11230469,2.74902344 C3.8671875,2.74902344 2.73925781,3.85546875 2.73925781,6.06835938 L2.73925781,8.70019531 C2.73925781,9.25878906 3.05078125,9.58105469 3.59863281,9.58105469 Z M22.9023438,9.58105469 C23.4716797,9.58105469 23.7724609,9.25878906 23.7724609,8.70019531 L23.7724609,6.06835938 C23.7724609,3.85546875 22.6445312,2.74902344 20.3994141,2.74902344 L17.7675781,2.74902344 C17.2089844,2.74902344 16.8974609,3.04980469 16.8974609,3.60839844 C16.8974609,4.16699219 17.2089844,4.47851562 17.7675781,4.47851562 L20.3671875,4.47851562 C21.4306641,4.47851562 22.0429688,5.04785156 22.0429688,6.16503906 L22.0429688,8.70019531 C22.0429688,9.25878906 22.3544922,9.58105469 22.9023438,9.58105469 Z M9.20605469,14.125 L12.3642578,14.125 L12.3642578,17.2939453 C12.3642578,17.8310547 12.71875,18.2070312 13.2451172,18.2070312 C13.7929688,18.2070312 14.1582031,17.8417969 14.1582031,17.2939453 L14.1582031,14.125 L17.3271484,14.125 C17.8642578,14.125 18.2402344,13.7705078 18.2402344,13.2441406 C18.2402344,12.7070312 17.875,12.3310547 17.3271484,12.3310547 L14.1582031,12.3310547 L14.1582031,9.17285156 C14.1582031,8.625 13.7929688,8.24902344 13.2451172,8.24902344 C12.71875,8.24902344 12.3642578,8.625 12.3642578,9.17285156 L12.3642578,12.3310547 L9.20605469,12.3310547 C8.64746094,12.3310547 8.28222656,12.7070312 8.28222656,13.2441406 C8.28222656,13.7705078 8.65820312,14.125 9.20605469,14.125 Z M6.11230469,23.7714844 L8.73339844,23.7714844 C9.30273438,23.7714844 9.61425781,23.4599609 9.61425781,22.9121094 C9.61425781,22.3535156 9.30273438,22.0419922 8.73339844,22.0419922 L6.13378906,22.0419922 C5.05957031,22.0419922 4.46875,21.4726562 4.46875,20.3554688 L4.46875,17.8203125 C4.46875,17.2509766 4.15722656,16.9394531 3.59863281,16.9394531 C3.04003906,16.9394531 2.73925781,17.2509766 2.73925781,17.8203125 L2.73925781,20.4414062 C2.73925781,22.6650391 3.8671875,23.7714844 6.11230469,23.7714844 Z M17.7675781,23.7714844 L20.3994141,23.7714844 C22.6445312,23.7714844 23.7724609,22.6542969 23.7724609,20.4414062 L23.7724609,17.8203125 C23.7724609,17.2509766 23.4609375,16.9394531 22.9023438,16.9394531 C22.34375,16.9394531 22.0429688,17.2509766 22.0429688,17.8203125 L22.0429688,20.3554688 C22.0429688,21.4726562 21.4306641,22.0419922 20.3671875,22.0419922 L17.7675781,22.0419922 C17.2089844,22.0419922 16.8974609,22.3535156 16.8974609,22.9121094 C16.8974609,23.4599609 17.2089844,23.7714844 17.7675781,23.7714844 Z" transform="translate(-1 -1)"/></svg>',
    redo: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M13.8164062,22.3212891 C13.8164062,21.7949219 13.4296875,21.3652344 12.8388672,21.3652344 L10.3681641,21.3652344 C6.70507812,21.3652344 4.76074219,19.2167969 4.76074219,16.3164062 C4.76074219,13.4267578 6.70507812,11.4072266 10.3681641,11.4072266 L17.7373047,11.4072266 L20.2724609,11.2890625 L18.2207031,13.0400391 L15.1269531,16.0585938 C14.9550781,16.2304688 14.8691406,16.4345703 14.8691406,16.7138672 C14.8691406,17.2724609 15.2451172,17.6591797 15.8144531,17.6591797 C16.0507812,17.6591797 16.3300781,17.5517578 16.5126953,17.3583984 L22.8291016,11.1601562 C23.0439453,10.9560547 23.1513672,10.7089844 23.1513672,10.4511719 C23.1513672,10.1826172 23.0439453,9.93554688 22.8291016,9.73144531 L16.5126953,3.53320312 C16.3300781,3.33984375 16.0507812,3.23242188 15.8144531,3.23242188 C15.2451172,3.23242188 14.8691406,3.61914062 14.8691406,4.17773438 C14.8691406,4.45703125 14.9550781,4.66113281 15.1269531,4.83300781 L18.2207031,7.8515625 L20.2724609,9.60253906 L17.7373047,9.484375 L10.5292969,9.484375 C5.62011719,9.484375 2.84863281,12.3203125 2.84863281,16.4238281 C2.84863281,20.5380859 5.54492188,23.2773438 10.3574219,23.2773438 L12.8388672,23.2773438 C13.4296875,23.2773438 13.8164062,22.8476562 13.8164062,22.3212891 Z" transform="translate(-1 -1)"/></svg>',
    searchOvalDotted: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M11.9999758,2.0367002 C12.553625,2.0367002 13.0121806,1.57599041 13.0121806,1.01707072 C13.0121806,0.460719499 12.553625,1.66533454e-16 11.9999758,1.66533454e-16 C11.4437536,1.66533454e-16 10.9877952,0.460719499 10.9877952,1.01707072 C10.9877952,1.57599041 11.4437536,2.0367002 11.9999758,2.0367002 Z M15.3767138,2.59378822 C15.9303388,2.59378822 16.3888945,2.13306629 16.3888945,1.57415752 C16.3888945,1.01780023 15.9303388,0.557080735 15.3767138,0.557080735 C14.8204313,0.557080735 14.3645332,1.01780023 14.3645332,1.57415752 C14.3645332,2.13306629 14.8204313,2.59378822 15.3767138,2.59378822 Z M18.4472005,4.14658231 C19.0008255,4.14658231 19.4593811,3.68587252 19.4593811,3.12695161 C19.4593811,2.57060403 19.0008255,2.10988211 18.4472005,2.10988211 C17.8909179,2.10988211 17.4199199,2.57060403 17.4199199,3.12695161 C17.4199199,3.68587252 17.8909179,4.14658231 18.4472005,4.14658231 Z M20.8605368,6.58154066 C21.4141618,6.58154066 21.8851598,6.12339205 21.8851598,5.56447115 C21.8851598,5.00812357 21.4141618,4.53483848 20.8605368,4.53483848 C20.3042542,4.53483848 19.8456985,5.00812357 19.8456985,5.56447115 C19.8456985,6.12339205 20.3042542,6.58154066 20.8605368,6.58154066 Z M22.4058064,9.61151926 C22.9595522,9.61151926 23.4179871,9.15335852 23.4179871,8.59444975 C23.4179871,8.03810217 22.9595522,7.57738025 22.4058064,7.57738025 C21.8496446,7.57738025 21.391089,8.03810217 21.391089,8.59444975 C21.391089,9.15335852 21.8496446,9.61151926 22.4058064,9.61151926 Z M22.9852826,13.0171302 C23.5414444,13.0171302 24,12.5589088 24,12 C24,11.4410912 23.5414444,10.9829305 22.9852826,10.9829305 C22.4315368,10.9829305 21.9731019,11.4410912 21.9731019,12 C21.9731019,12.5589088 22.4315368,13.0171302 22.9852826,13.0171302 Z M22.4058064,16.4226562 C22.9595522,16.4226562 23.4179871,15.9644347 23.4179871,15.4055867 C23.4179871,14.8466172 22.9595522,14.3885172 22.4058064,14.3885172 C21.8496446,14.3885172 21.391089,14.8466172 21.391089,15.4055867 C21.391089,15.9644347 21.8496446,16.4226562 22.4058064,16.4226562 Z M20.8605368,19.4651251 C21.4141618,19.4651251 21.8851598,19.004476 21.8851598,18.4480556 C21.8851598,17.8892075 21.4141618,17.4184836 20.8605368,17.4184836 C20.3042542,17.4184836 19.8456985,17.8892075 19.8456985,18.4480556 C19.8456985,19.004476 20.3042542,19.4651251 20.8605368,19.4651251 Z M18.4472005,21.8901179 C19.0008255,21.8901179 19.4593811,21.4293474 19.4593811,20.8730484 C19.4593811,20.3140789 19.0008255,19.8534298 18.4472005,19.8534298 C17.8909179,19.8534298 17.4199199,20.3140789 17.4199199,20.8730484 C17.4199199,21.4293474 17.8909179,21.8901179 18.4472005,21.8901179 Z M15.3767138,23.4429727 C15.9303388,23.4429727 16.3888945,22.9822022 16.3888945,22.4259032 C16.3888945,21.8669337 15.9303388,21.4061632 15.3767138,21.4061632 C14.8204313,21.4061632 14.3645332,21.8669337 14.3645332,22.4259032 C14.3645332,22.9822022 14.8204313,23.4429727 15.3767138,23.4429727 Z M11.9999758,24 C12.553625,24 13.0121806,23.5392295 13.0121806,22.9829305 C13.0121806,22.423961 12.553625,21.9633119 11.9999758,21.9633119 C11.4437536,21.9633119 10.9877952,22.423961 10.9877952,22.9829305 C10.9877952,23.5392295 11.4437536,24 11.9999758,24 Z M8.62329823,23.4429727 C9.17953251,23.4429727 9.64799372,22.9822022 9.64799372,22.4259032 C9.64799372,21.8669337 9.17953251,21.4061632 8.62329823,21.4061632 C8.06707604,21.4061632 7.6111176,21.8669337 7.6111176,22.4259032 C7.6111176,22.9822022 8.06707604,23.4429727 8.62329823,23.4429727 Z M5.56527814,21.8901179 C6.12151241,21.8901179 6.57747086,21.4293474 6.57747086,20.8730484 C6.57747086,20.3140789 6.12151241,19.8534298 5.56527814,19.8534298 C5.00905595,19.8534298 4.55309751,20.3140789 4.55309751,20.8730484 C4.55309751,21.4293474 5.00905595,21.8901179 5.56527814,21.8901179 Z M3.13947533,19.4651251 C3.6957096,19.4651251 4.15166804,19.004476 4.15166804,18.4480556 C4.15166804,17.8892075 3.6957096,17.4184836 3.13947533,17.4184836 C2.58580201,17.4184836 2.12729469,17.8892075 2.12729469,18.4480556 C2.12729469,19.004476 2.58580201,19.4651251 3.13947533,19.4651251 Z M1.59414524,16.4226562 C2.15036743,16.4226562 2.60632588,15.9644347 2.60632588,15.4055867 C2.60632588,14.8466172 2.15036743,14.3885172 1.59414524,14.3885172 C1.04046468,14.3885172 0.581959774,14.8466172 0.581959774,15.4055867 C0.581959774,15.9644347 1.04046468,16.4226562 1.59414524,16.4226562 Z M1.01218184,13.0171302 C1.56841491,13.0171302 2.02691015,12.5589088 2.02691015,12 C2.02691015,11.4410912 1.56841491,10.9829305 1.01218184,10.9829305 C0.458504902,10.9829305 -1.38777878e-17,11.4410912 -1.38777878e-17,12 C-1.38777878e-17,12.5589088 0.458504902,13.0171302 1.01218184,13.0171302 Z M1.59414524,9.61151926 C2.15036743,9.61151926 2.60632588,9.15335852 2.60632588,8.59444975 C2.60632588,8.03810217 2.15036743,7.57738025 1.59414524,7.57738025 C1.04046468,7.57738025 0.581959774,8.03810217 0.581959774,8.59444975 C0.581959774,9.15335852 1.04046468,9.61151926 1.59414524,9.61151926 Z M3.13947533,6.58154066 C3.6957096,6.58154066 4.15166804,6.12339205 4.15166804,5.56447115 C4.15166804,5.00812357 3.6957096,4.53483848 3.13947533,4.53483848 C2.58580201,4.53483848 2.12729469,5.00812357 2.12729469,5.56447115 C2.12729469,6.12339205 2.58580201,6.58154066 3.13947533,6.58154066 Z M5.56527814,4.14658231 C6.12151241,4.14658231 6.57747086,3.68587252 6.57747086,3.12695161 C6.57747086,2.57060403 6.12151241,2.10988211 5.56527814,2.10988211 C5.00905595,2.10988211 4.55309751,2.57060403 4.55309751,3.12695161 C4.55309751,3.68587252 5.00905595,4.14658231 5.56527814,4.14658231 Z M8.62329823,2.59378822 C9.17953251,2.59378822 9.64799372,2.13306629 9.64799372,1.57415752 C9.64799372,1.01780023 9.17953251,0.557080735 8.62329823,0.557080735 C8.06707604,0.557080735 7.6111176,1.01780023 7.6111176,1.57415752 C7.6111176,2.13306629 8.06707604,2.59378822 8.62329823,2.59378822 Z M6,10.9807531 C6,13.7316153 8.24974062,15.9578651 11.0244672,15.9578651 C11.9569867,15.9578651 12.820778,15.6985021 13.5586207,15.2506549 L15.9948358,17.670365 C16.2232769,17.8931963 16.5271304,18 16.8386966,18 C17.5045546,18 18,17.4951099 18,16.8400878 C18,16.5341195 17.8878607,16.243565 17.6688461,16.0178208 L15.2533205,13.618986 C15.7550094,12.8625004 16.0444171,11.9577883 16.0444171,10.9807531 C16.0444171,8.23035207 13.7988143,6 11.0244672,6 C8.24974062,6 6,8.23035207 6,10.9807531 Z M7.60168291,10.9807531 C7.60168291,9.10769573 9.13469882,7.5878794 11.0244672,7.5878794 C12.91284,7.5878794 14.4467986,9.10769573 14.4467986,10.9807531 C14.4467986,12.8501209 12.91284,14.3740152 11.0244672,14.3740152 C9.13469882,14.3740152 7.60168291,12.8501209 7.60168291,10.9807531 Z"/></svg>',
    sfArrowDownSquare: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M6.48486328,23.1376953 L19.5151367,23.1376953 C21.7709961,23.1376953 22.8881836,22.03125 22.8881836,19.8183594 L22.8881836,6.69140625 C22.8881836,4.47851562 21.7709961,3.36132812 19.5151367,3.36132812 L6.48486328,3.36132812 C4.23974609,3.36132812 3.11181641,4.47851562 3.11181641,6.69140625 L3.11181641,19.8183594 C3.11181641,22.03125 4.23974609,23.1376953 6.48486328,23.1376953 Z M6.50634766,21.4082031 C5.43212891,21.4082031 4.84130859,20.8388672 4.84130859,19.7216797 L4.84130859,6.78808594 C4.84130859,5.67089844 5.43212891,5.09082031 6.50634766,5.09082031 L19.4936523,5.09082031 C20.5571289,5.09082031 21.1586914,5.67089844 21.1586914,6.78808594 L21.1586914,19.7216797 C21.1586914,20.8388672 20.5571289,21.4082031 19.4936523,21.4082031 L6.50634766,21.4082031 Z M13.0161133,18.6582031 C13.2416992,18.6582031 13.4243164,18.59375 13.6391602,18.3789062 L17.184082,14.9628906 C17.3452148,14.8017578 17.4311523,14.6298828 17.4311523,14.3935547 C17.4311523,13.953125 17.0981445,13.6416016 16.6469727,13.6416016 C16.4428711,13.6416016 16.2172852,13.7275391 16.0668945,13.8994141 L14.434082,15.6396484 L13.8217773,16.2949219 L13.8754883,14.6943359 L13.8754883,8.65722656 C13.8754883,8.20605469 13.4780273,7.83007812 13.0161133,7.83007812 C12.5541992,7.83007812 12.1674805,8.20605469 12.1674805,8.65722656 L12.1674805,14.6943359 L12.2211914,16.2949219 L11.5981445,15.6396484 L9.96533203,13.8994141 C9.81494141,13.7275391 9.57861328,13.6416016 9.37451172,13.6416016 C8.92333984,13.6416016 8.60107422,13.953125 8.60107422,14.3935547 C8.60107422,14.6298828 8.68701172,14.8017578 8.85888672,14.9628906 L12.3930664,18.3789062 C12.6079102,18.59375 12.8012695,18.6582031 13.0161133,18.6582031 Z" transform="translate(-1 -1)"/></svg>',
    sfArrowUpRight: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M3.36230469,20.8818359 C3.75976562,21.2685547 4.30761719,21.2900391 4.71582031,20.8818359 L15.6191406,9.98925781 L17.1875,8.30273438 L16.9833984,13.2548828 L16.9833984,17.21875 C16.9833984,17.734375 17.4345703,18.1962891 17.9609375,18.1962891 C18.4765625,18.1962891 18.9384766,17.7666016 18.9384766,17.1757812 L18.9277344,6.37988281 C18.9277344,5.75683594 18.5195312,5.33789062 17.8857422,5.33789062 L7.07910156,5.33789062 C6.47753906,5.33789062 6.06933594,5.7890625 6.06933594,6.3046875 C6.06933594,6.8203125 6.53125,7.26074219 7.03613281,7.26074219 L10.7744141,7.26074219 L15.8984375,7.09960938 L14.2548828,8.625 L3.36230469,19.5283203 C2.95410156,19.9365234 2.96484375,20.484375 3.36230469,20.8818359 Z" transform="translate(1 -1)"/></svg>',
    sfAssets: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25"><path d="M7.22705078,2.72753906 L20.7836914,2.72753906 C20.7192383,1.81445312 20.2036133,1.34179688 19.2045898,1.34179688 L8.79541016,1.34179688 C7.80712891,1.34179688 7.29150391,1.81445312 7.22705078,2.72753906 Z M5.01416016,5.703125 L22.996582,5.703125 C22.8354492,4.72558594 22.3735352,4.18847656 21.2993164,4.18847656 L6.71142578,4.18847656 C5.63720703,4.18847656 5.17529297,4.72558594 5.01416016,5.703125 Z M6.12060547,25.125 L21.8793945,25.125 C24.1137695,25.125 25.2524414,24.0078125 25.2524414,21.7949219 L25.2524414,10.7626953 C25.2524414,8.54980469 24.1137695,7.43261719 21.8793945,7.43261719 L6.12060547,7.43261719 C3.86474609,7.43261719 2.74755859,8.54980469 2.74755859,10.7626953 L2.74755859,21.7949219 C2.74755859,24.0078125 3.86474609,25.125 6.12060547,25.125 Z M4.47705078,10.859375 C4.47705078,9.7421875 5.06787109,9.16210938 6.14208984,9.16210938 L21.847168,9.16210938 C22.9106445,9.16210938 23.5229492,9.7421875 23.5229492,10.859375 L23.5229492,19.7861328 L19.4731445,15.9619141 C19.0219727,15.5429688 18.4633789,15.3388672 17.9047852,15.3388672 C17.3354492,15.3388672 16.8305664,15.5214844 16.347168,15.9511719 L11.6743164,20.0761719 L9.80517578,18.4111328 C9.36474609,18.0136719 8.90283203,17.8095703 8.40869141,17.8095703 C7.94677734,17.8095703 7.51708984,18.0244141 7.07666016,18.4003906 L4.47705078,20.65625 L4.47705078,10.859375 Z M10.8364258,16.2197266 C12.1899414,16.2197266 13.2963867,15.0917969 13.2963867,13.7490234 C13.2963867,12.40625 12.1899414,11.2998047 10.8364258,11.2998047 C9.48291016,11.2998047 8.38720703,12.40625 8.38720703,13.7490234 C8.38720703,15.0917969 9.48291016,16.2197266 10.8364258,16.2197266 Z" transform="translate(-2 -1)"/></svg>',
    sfComment: '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="24" viewBox="0 0 26 24"><path d="M23.8837891,9.01171875 C25.9140625,9.01171875 27.6113281,7.3359375 27.6113281,5.29492188 C27.6113281,3.24316406 25.9140625,1.56738281 23.8837891,1.56738281 C21.8427734,1.56738281 20.15625,3.24316406 20.15625,5.29492188 C20.15625,7.3359375 21.8427734,9.01171875 23.8837891,9.01171875 Z M15,22.9121094 C22.21875,22.9121094 27.4931641,18.5078125 27.4931641,12.4492188 C27.4931641,11.375 27.3212891,10.3544922 27.0097656,9.40917969 C26.5478516,9.76367188 26.0214844,10.0214844 25.4306641,10.1933594 C25.6455078,10.9023438 25.7636719,11.6542969 25.7636719,12.4492188 C25.7636719,17.4873047 21.3164062,21.1826172 15,21.1826172 C12.9482422,21.1826172 11.1113281,20.7958984 9.55371094,20.0976562 C8.86621094,19.796875 8.37207031,19.8828125 7.71679688,20.2695312 C7.25488281,20.5595703 6.71777344,20.8066406 6.16992188,20.9248047 C6.39550781,20.5488281 6.54589844,20.1191406 6.54589844,19.5605469 C6.54589844,18.765625 6.25585938,17.8955078 5.56835938,16.8642578 C4.70898438,15.6181641 4.23632812,14.1035156 4.23632812,12.4492188 C4.23632812,7.41113281 8.68359375,3.7265625 15,3.7265625 C16.375,3.7265625 17.6640625,3.90917969 18.8349609,4.23144531 C18.9423828,3.65136719 19.1572266,3.10351562 19.4472656,2.609375 C18.0830078,2.20117188 16.5791016,1.99707031 15,1.99707031 C7.78125,1.99707031 2.50683594,6.36914062 2.50683594,12.4492188 C2.50683594,14.4580078 3.09765625,16.3271484 4.12890625,17.8417969 C4.63378906,18.59375 4.81640625,19.1201172 4.81640625,19.5605469 C4.81640625,20.1298828 4.64453125,20.5917969 4.15039062,21.0214844 C3.30175781,21.7412109 3.7421875,22.9121094 4.859375,22.9121094 C6.20214844,22.9121094 7.6953125,22.4501953 8.80175781,21.6875 C10.6171875,22.4824219 12.7333984,22.9121094 15,22.9121094 Z" transform="translate(-2 -1)"/></svg>',
    sfCommentFill: '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="24" viewBox="0 0 26 24"><path d="M24.2275391,9.01171875 C26.2578125,9.01171875 27.9550781,7.3359375 27.9550781,5.29492188 C27.9550781,3.24316406 26.2578125,1.56738281 24.2275391,1.56738281 C22.1865234,1.56738281 20.5,3.24316406 20.5,5.29492188 C20.5,7.3359375 22.1865234,9.01171875 24.2275391,9.01171875 Z M15,22.7294922 C22.2080078,22.7294922 27.4287109,18.3789062 27.4287109,12.3955078 C27.4287109,11.4179688 27.2890625,10.4941406 27.03125,9.62402344 C26.2148438,10.1611328 25.2373047,10.4833984 24.1953125,10.4833984 C21.3486328,10.4833984 19.0068359,8.14160156 19.0068359,5.29492188 C19.0068359,4.36035156 19.2539062,3.49023438 19.6835938,2.73828125 C18.265625,2.28710938 16.6865234,2.06152344 15,2.06152344 C7.80273438,2.06152344 2.58203125,6.40136719 2.58203125,12.3955078 C2.58203125,16.703125 4.9453125,17.8632812 4.9453125,19.7861328 C4.9453125,20.6240234 4.67675781,21.171875 4.03222656,21.7734375 C3.54882812,22.203125 3.80664062,22.7294922 4.515625,22.7294922 C5.99804688,22.7294922 7.51269531,22.2460938 8.61914062,21.4404297 C10.4775391,22.2890625 12.6367188,22.7294922 15,22.7294922 Z" transform="translate(-2 -1)"/></svg>',
    sfComponents: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M5.32568359,9.00097656 L7.69970703,9.00097656 C8.87060547,9.00097656 9.55810547,8.31347656 9.55810547,7.09960938 L9.55810547,4.81152344 C9.55810547,3.59765625 8.87060547,2.91015625 7.69970703,2.91015625 L5.32568359,2.91015625 C4.15478516,2.91015625 3.46728516,3.59765625 3.46728516,4.81152344 L3.46728516,7.09960938 C3.46728516,8.31347656 4.15478516,9.00097656 5.32568359,9.00097656 Z M12.8022461,9.00097656 L15.1870117,9.00097656 C16.3579102,9.00097656 17.034668,8.31347656 17.034668,7.09960938 L17.034668,4.81152344 C17.034668,3.59765625 16.3579102,2.91015625 15.1870117,2.91015625 L12.8022461,2.91015625 C11.6313477,2.91015625 10.9545898,3.59765625 10.9545898,4.81152344 L10.9545898,7.09960938 C10.9545898,8.31347656 11.6313477,9.00097656 12.8022461,9.00097656 Z M20.300293,9.00097656 L22.6743164,9.00097656 C23.8452148,9.00097656 24.5327148,8.31347656 24.5327148,7.09960938 L24.5327148,4.81152344 C24.5327148,3.59765625 23.8452148,2.91015625 22.6743164,2.91015625 L20.300293,2.91015625 C19.1293945,2.91015625 18.4418945,3.59765625 18.4418945,4.81152344 L18.4418945,7.09960938 C18.4418945,8.31347656 19.1293945,9.00097656 20.300293,9.00097656 Z M13.0063477,7.52929688 C12.6196289,7.52929688 12.4262695,7.32519531 12.4262695,6.91699219 L12.4262695,4.99414062 C12.4262695,4.59667969 12.6196289,4.39257812 13.0063477,4.39257812 L14.9829102,4.39257812 C15.3588867,4.39257812 15.5629883,4.59667969 15.5629883,4.99414062 L15.5629883,6.91699219 C15.5629883,7.32519531 15.3588867,7.52929688 14.9829102,7.52929688 L13.0063477,7.52929688 Z M20.5043945,7.52929688 C20.1176758,7.52929688 19.9135742,7.32519531 19.9135742,6.91699219 L19.9135742,4.99414062 C19.9135742,4.59667969 20.1176758,4.39257812 20.5043945,4.39257812 L22.4702148,4.39257812 C22.8461914,4.39257812 23.050293,4.59667969 23.050293,4.99414062 L23.050293,6.91699219 C23.050293,7.32519531 22.8461914,7.52929688 22.4702148,7.52929688 L20.5043945,7.52929688 Z M5.32568359,16.2734375 L7.69970703,16.2734375 C8.87060547,16.2734375 9.55810547,15.5966797 9.55810547,14.3828125 L9.55810547,12.0839844 C9.55810547,10.8701172 8.87060547,10.1826172 7.69970703,10.1826172 L5.32568359,10.1826172 C4.15478516,10.1826172 3.46728516,10.8701172 3.46728516,12.0839844 L3.46728516,14.3828125 C3.46728516,15.5966797 4.15478516,16.2734375 5.32568359,16.2734375 Z M12.8022461,16.2734375 L15.1870117,16.2734375 C16.3579102,16.2734375 17.034668,15.5966797 17.034668,14.3828125 L17.034668,12.0839844 C17.034668,10.8701172 16.3579102,10.1826172 15.1870117,10.1826172 L12.8022461,10.1826172 C11.6313477,10.1826172 10.9545898,10.8701172 10.9545898,12.0839844 L10.9545898,14.3828125 C10.9545898,15.5966797 11.6313477,16.2734375 12.8022461,16.2734375 Z M20.300293,16.2734375 L22.6743164,16.2734375 C23.8452148,16.2734375 24.5327148,15.5966797 24.5327148,14.3828125 L24.5327148,12.0839844 C24.5327148,10.8701172 23.8452148,10.1826172 22.6743164,10.1826172 L20.300293,10.1826172 C19.1293945,10.1826172 18.4418945,10.8701172 18.4418945,12.0839844 L18.4418945,14.3828125 C18.4418945,15.5966797 19.1293945,16.2734375 20.300293,16.2734375 Z M5.52978516,14.8017578 C5.14306641,14.8017578 4.94970703,14.5976562 4.94970703,14.1894531 L4.94970703,12.2558594 C4.94970703,11.8583984 5.14306641,11.6542969 5.52978516,11.6542969 L7.49560547,11.6542969 C7.87158203,11.6542969 8.08642578,11.8583984 8.08642578,12.2558594 L8.08642578,14.1894531 C8.08642578,14.5976562 7.87158203,14.8017578 7.49560547,14.8017578 L5.52978516,14.8017578 Z M13.0063477,14.8017578 C12.6196289,14.8017578 12.4262695,14.5976562 12.4262695,14.1894531 L12.4262695,12.2558594 C12.4262695,11.8583984 12.6196289,11.6542969 13.0063477,11.6542969 L14.9829102,11.6542969 C15.3588867,11.6542969 15.5629883,11.8583984 15.5629883,12.2558594 L15.5629883,14.1894531 C15.5629883,14.5976562 15.3588867,14.8017578 14.9829102,14.8017578 L13.0063477,14.8017578 Z M20.5043945,14.8017578 C20.1176758,14.8017578 19.9135742,14.5976562 19.9135742,14.1894531 L19.9135742,12.2558594 C19.9135742,11.8583984 20.1176758,11.6542969 20.5043945,11.6542969 L22.4702148,11.6542969 C22.8461914,11.6542969 23.050293,11.8583984 23.050293,12.2558594 L23.050293,14.1894531 C23.050293,14.5976562 22.8461914,14.8017578 22.4702148,14.8017578 L20.5043945,14.8017578 Z M5.32568359,23.5458984 L7.69970703,23.5458984 C8.87060547,23.5458984 9.55810547,22.8583984 9.55810547,21.6445312 L9.55810547,19.3564453 C9.55810547,18.1425781 8.87060547,17.4550781 7.69970703,17.4550781 L5.32568359,17.4550781 C4.15478516,17.4550781 3.46728516,18.1425781 3.46728516,19.3564453 L3.46728516,21.6445312 C3.46728516,22.8583984 4.15478516,23.5458984 5.32568359,23.5458984 Z M12.8022461,23.5458984 L15.1870117,23.5458984 C16.3579102,23.5458984 17.034668,22.8583984 17.034668,21.6445312 L17.034668,19.3564453 C17.034668,18.1425781 16.3579102,17.4550781 15.1870117,17.4550781 L12.8022461,17.4550781 C11.6313477,17.4550781 10.9545898,18.1425781 10.9545898,19.3564453 L10.9545898,21.6445312 C10.9545898,22.8583984 11.6313477,23.5458984 12.8022461,23.5458984 Z M20.300293,23.5458984 L22.6743164,23.5458984 C23.8452148,23.5458984 24.5327148,22.8583984 24.5327148,21.6445312 L24.5327148,19.3564453 C24.5327148,18.1425781 23.8452148,17.4550781 22.6743164,17.4550781 L20.300293,17.4550781 C19.1293945,17.4550781 18.4418945,18.1425781 18.4418945,19.3564453 L18.4418945,21.6445312 C18.4418945,22.8583984 19.1293945,23.5458984 20.300293,23.5458984 Z M5.52978516,22.0634766 C5.14306641,22.0634766 4.94970703,21.859375 4.94970703,21.4619141 L4.94970703,19.5390625 C4.94970703,19.1308594 5.14306641,18.9267578 5.52978516,18.9267578 L7.49560547,18.9267578 C7.87158203,18.9267578 8.08642578,19.1308594 8.08642578,19.5390625 L8.08642578,21.4619141 C8.08642578,21.859375 7.87158203,22.0634766 7.49560547,22.0634766 L5.52978516,22.0634766 Z M13.0063477,22.0634766 C12.6196289,22.0634766 12.4262695,21.859375 12.4262695,21.4619141 L12.4262695,19.5390625 C12.4262695,19.1308594 12.6196289,18.9267578 13.0063477,18.9267578 L14.9829102,18.9267578 C15.3588867,18.9267578 15.5629883,19.1308594 15.5629883,19.5390625 L15.5629883,21.4619141 C15.5629883,21.859375 15.3588867,22.0634766 14.9829102,22.0634766 L13.0063477,22.0634766 Z M20.5043945,22.0634766 C20.1176758,22.0634766 19.9135742,21.859375 19.9135742,21.4619141 L19.9135742,19.5390625 C19.9135742,19.1308594 20.1176758,18.9267578 20.5043945,18.9267578 L22.4702148,18.9267578 C22.8461914,18.9267578 23.050293,19.1308594 23.050293,19.5390625 L23.050293,21.4619141 C23.050293,21.859375 22.8461914,22.0634766 22.4702148,22.0634766 L20.5043945,22.0634766 Z" transform="translate(-2 -1)"/></svg>',
    sfCopy: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="28" viewBox="0 0 24 28"><path d="M3.01611328,23.6542969 C3.01611328,25.8994141 4.12255859,27.0273438 6.34619141,27.0273438 L16.4438477,27.0273438 C18.6674805,27.0273438 19.7739258,25.8886719 19.7739258,23.6542969 L19.7739258,21.6669922 L21.6538086,21.6669922 C23.8666992,21.6669922 24.9838867,20.5283203 24.9838867,18.2939453 L24.9838867,9.57128906 C24.9838867,8.25 24.715332,7.41210938 23.909668,6.58496094 L18.4848633,1.07421875 C17.722168,0.290039062 16.8198242,0 15.6704102,0 L11.5561523,0 C9.34326172,0 8.22607422,1.13867188 8.22607422,3.37304688 L8.22607422,5.36035156 L6.34619141,5.36035156 C4.13330078,5.36035156 3.01611328,6.48828125 3.01611328,8.73339844 L3.01611328,23.6542969 Z M18.753418,12.4072266 L12.8344727,6.38085938 C12.0180664,5.54296875 11.3413086,5.36035156 10.1381836,5.36035156 L9.95556641,5.36035156 L9.95556641,3.40527344 C9.95556641,2.34179688 10.5249023,1.72949219 11.6420898,1.72949219 L16.3901367,1.72949219 L16.3901367,7.24023438 C16.3901367,8.48632812 16.9916992,9.07714844 18.2270508,9.07714844 L23.2543945,9.07714844 L23.2543945,18.2617188 C23.2543945,19.3359375 22.6743164,19.9375 21.5571289,19.9375 L19.7739258,19.9375 L19.7739258,15.2646484 C19.7739258,13.8896484 19.612793,13.2880859 18.753418,12.4072266 Z M17.9477539,6.98242188 L17.9477539,2.578125 L22.8032227,7.51953125 L18.4741211,7.51953125 C18.0981445,7.51953125 17.9477539,7.35839844 17.9477539,6.98242188 Z M4.74560547,23.6220703 L4.74560547,8.75488281 C4.74560547,7.70214844 5.31494141,7.08984375 6.43212891,7.08984375 L9.95556641,7.08984375 L9.95556641,13.3203125 C9.95556641,14.6738281 10.6430664,15.3505859 11.9750977,15.3505859 L18.0444336,15.3505859 L18.0444336,23.6220703 C18.0444336,24.6962891 17.4643555,25.2978516 16.3579102,25.2978516 L6.42138672,25.2978516 C5.31494141,25.2978516 4.74560547,24.6962891 4.74560547,23.6220703 Z M12.1791992,13.7285156 C11.7495117,13.7285156 11.5776367,13.5566406 11.5776367,13.1269531 L11.5776367,7.48730469 L17.7114258,13.7285156 L12.1791992,13.7285156 Z" transform="translate(-2 .72)"/></svg>',
    sfCopyFill: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="28" viewBox="0 0 24 28"><path d="M21.2348633,21.6669922 L21.6538086,21.6669922 C23.855957,21.6669922 24.9838867,20.5283203 24.9838867,18.2939453 L24.9838867,8.09960938 L19.043457,8.09960938 C17.9155273,8.09960938 17.2817383,7.46582031 17.2817383,6.34863281 L17.2817383,0 L11.5561523,0 C9.37548828,0 8.22607422,1.13867188 8.22607422,3.28710938 L8.22607422,3.89941406 L9.78369141,3.89941406 C11.2875977,3.89941406 12.5014648,4.24316406 13.7045898,5.44628906 L19.8061523,11.5371094 C21.0092773,12.7509766 21.2348633,13.9970703 21.2348633,15.4580078 L21.2348633,21.6669922 Z M19.2475586,6.75683594 L24.8549805,6.75683594 C24.8012695,6.41308594 24.5649414,6.11230469 24.1889648,5.73632812 L19.6450195,1.10644531 C19.2797852,0.719726562 18.9682617,0.483398438 18.6352539,0.440429688 L18.6459961,6.13378906 C18.6459961,6.57421875 18.8071289,6.75683594 19.2475586,6.75683594 Z M6.34619141,27.0273438 L16.4438477,27.0273438 C18.6674805,27.0273438 19.7739258,25.8886719 19.7739258,23.6542969 L19.7739258,15.1679688 L12.2758789,15.1679688 C10.8901367,15.1679688 10.2456055,14.5126953 10.2456055,13.1376953 L10.2456055,5.36035156 L6.34619141,5.36035156 C4.13330078,5.36035156 3.01611328,6.48828125 3.01611328,8.73339844 L3.01611328,23.6542969 C3.01611328,25.8994141 4.12255859,27.0273438 6.34619141,27.0273438 Z M12.2651367,13.6962891 L19.5805664,13.6962891 C19.4731445,13.2773438 19.2260742,12.890625 18.7426758,12.3964844 L13.0063477,6.55273438 C12.5336914,6.06933594 12.1254883,5.74707031 11.706543,5.62890625 L11.706543,13.1484375 C11.706543,13.5136719 11.8999023,13.6962891 12.2651367,13.6962891 Z" transform="translate(-2 .72)"/></svg>',
    sfCursor: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12.1367188,23.8574219 C12.953125,23.5351562 13.3505859,22.6113281 13.0068359,21.7841797 L9.92382812,14.5009766 L14.3710938,14.7480469 C15.0908203,14.7910156 15.4345703,14.0175781 14.9189453,13.4912109 L4.28417969,2.62011719 C3.81152344,2.13671875 3.08105469,2.40527344 3.0703125,3.08203125 L2.8983339,18.2070312 C2.88769531,18.9482422 3.71484375,19.2490234 4.19824219,18.7011719 L7.03417969,15.5644531 L10.0419922,22.9980469 C10.3857422,23.8037109 11.3095703,24.2011719 12.1367188,23.8574219 Z" transform="translate(3 -1)"/></svg>',
    sfCursorFill: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12.1367188,23.8574219 C12.953125,23.5351562 13.3505859,22.6113281 13.0068359,21.7841797 L9.92382812,14.5009766 L14.3710938,14.7480469 C15.0908203,14.7910156 15.4345703,14.0175781 14.9189453,13.4912109 L4.28417969,2.62011719 C3.81152344,2.13671875 3.08105469,2.40527344 3.0703125,3.08203125 L2.8983339,18.2070312 C2.88769531,18.9482422 3.71484375,19.2490234 4.19824219,18.7011719 L7.03417969,15.5644531 L10.0419922,22.9980469 C10.3857422,23.8037109 11.3095703,24.2011719 12.1367188,23.8574219 Z" transform="translate(3 -1)"/></svg>',
    sfDocument: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M6.29589844,24.7597656 L17.7041016,24.7597656 C19.9277344,24.7597656 21.0341797,23.6318359 21.0341797,21.3974609 L21.0341797,11.6435547 C21.0341797,10.2578125 20.8730469,9.65625 20.0136719,8.77539062 L14.0947266,2.74902344 C13.2783203,1.91113281 12.6015625,1.72851562 11.3984375,1.72851562 L6.29589844,1.72851562 C4.08300781,1.72851562 2.96582031,2.8671875 2.96582031,5.1015625 L2.96582031,21.3974609 C2.96582031,23.6425781 4.07226562,24.7597656 6.29589844,24.7597656 Z M6.37109375,23.0302734 C5.26464844,23.0302734 4.6953125,22.4394531 4.6953125,21.3652344 L4.6953125,5.13378906 C4.6953125,4.0703125 5.26464844,3.45800781 6.38183594,3.45800781 L11.1621094,3.45800781 L11.1621094,9.69921875 C11.1621094,11.0527344 11.8388672,11.71875 13.1816406,11.71875 L19.3046875,11.71875 L19.3046875,21.3652344 C19.3046875,22.4394531 18.7353516,23.0302734 17.6181641,23.0302734 L6.37109375,23.0302734 Z M13.375,10.0966797 C12.9453125,10.0966797 12.7841797,9.92480469 12.7841797,9.49511719 L12.7841797,3.79101562 L18.9716797,10.0966797 L13.375,10.0966797 Z M15.953125,14.6835938 L7.79980469,14.6835938 C7.41308594,14.6835938 7.12304688,14.9736328 7.12304688,15.3388672 C7.12304688,15.7148438 7.41308594,16.0048828 7.79980469,16.0048828 L15.953125,16.0048828 C16.3291016,16.0048828 16.6083984,15.7148438 16.6083984,15.3388672 C16.6083984,14.9736328 16.3291016,14.6835938 15.953125,14.6835938 Z M15.953125,18.4326172 L7.79980469,18.4326172 C7.41308594,18.4326172 7.12304688,18.7333984 7.12304688,19.109375 C7.12304688,19.4746094 7.41308594,19.7539062 7.79980469,19.7539062 L15.953125,19.7539062 C16.3291016,19.7539062 16.6083984,19.4746094 16.6083984,19.109375 C16.6083984,18.7333984 16.3291016,18.4326172 15.953125,18.4326172 Z" transform="translate(0 -1)"/></svg>',
    sfDownload: '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="26" viewBox="0 0 28 26"><path d="M18.921875,18.0136719 L18.921875,19.7431641 L24.2285156,19.7431641 C27.5263672,19.7431641 29.5029297,17.7558594 29.5029297,15.15625 C29.5029297,12.9863281 28.203125,11.203125 26.1083984,10.3544922 C26.1298828,5.56347656 22.6816406,2.10449219 18.2880859,2.10449219 C15.3769531,2.10449219 13.3037109,3.66210938 12.0146484,5.54199219 C9.57617188,4.88671875 6.49316406,6.77734375 6.43945312,9.79589844 C4.01171875,10.171875 2.49707031,12.1591797 2.49707031,14.6943359 C2.49707031,17.4873047 4.59179688,19.7431641 8.11523438,19.7431641 L13.1748047,19.7431641 L13.1748047,18.0136719 L8.10449219,18.0136719 C5.55859375,18.0136719 4.2265625,16.5419922 4.2265625,14.6943359 C4.2265625,12.6425781 5.52636719,11.1171875 7.80371094,11.1171875 C7.95410156,11.1171875 8.0078125,11.03125 8.0078125,10.8916016 C8.0078125,7.59375 10.3818359,6.68066406 12.5947266,7.32519531 C12.7236328,7.36816406 12.7988281,7.34667969 12.8632812,7.22851562 C13.9052734,5.37011719 15.5058594,3.83398438 18.2880859,3.83398438 C21.8115234,3.83398438 24.25,6.62695312 24.4326172,9.828125 C24.4648438,10.3115234 24.4326172,10.8916016 24.3896484,11.3964844 C24.3789062,11.5361328 24.4326172,11.6220703 24.5615234,11.6435547 C26.5166016,12.0732422 27.7734375,13.2978516 27.7734375,15.15625 C27.7734375,16.8105469 26.5703125,18.0136719 24.2177734,18.0136719 L18.921875,18.0136719 Z M12.4013672,21.1074219 C11.9501953,21.1074219 11.6279297,21.4189453 11.6279297,21.859375 C11.6279297,22.0849609 11.7246094,22.2568359 11.8857422,22.4179688 L15.4306641,25.8339844 C15.6455078,26.0488281 15.828125,26.1240234 16.0537109,26.1240234 C16.2685547,26.1240234 16.4511719,26.0488281 16.6660156,25.8339844 L20.2109375,22.4179688 C20.3720703,22.2568359 20.46875,22.0849609 20.46875,21.859375 C20.46875,21.4189453 20.125,21.1074219 19.6845703,21.1074219 C19.4697266,21.1074219 19.2548828,21.1826172 19.09375,21.3544922 L17.4394531,23.1269531 L16.8271484,23.7822266 L16.9023438,22.1601562 L16.9023438,12.9326172 C16.9023438,12.4814453 16.515625,12.1054688 16.0537109,12.1054688 C15.5917969,12.1054688 15.1943359,12.4814453 15.1943359,12.9326172 L15.1943359,22.1601562 L15.2695312,23.7822266 L14.6572266,23.1269531 L12.9921875,21.3544922 C12.8417969,21.1826172 12.6162109,21.1074219 12.4013672,21.1074219 Z" transform="translate(-2 -1)"/></svg>',
    sfEye: '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="24" viewBox="0 0 30 24"><path d="M17.0053711,22.4609375 C25.6850586,22.4609375 31.6791992,15.4462891 31.6791992,13.2548828 C31.6791992,11.0527344 25.6743164,4.04882812 17.0053711,4.04882812 C8.44384766,4.04882812 2.32080078,11.0527344 2.32080078,13.2548828 C2.32080078,15.4462891 8.43310547,22.4609375 17.0053711,22.4609375 Z M17.0053711,20.7636719 C9.92626953,20.7636719 4.20068359,14.7695312 4.20068359,13.2548828 C4.20068359,11.9765625 9.92626953,5.74609375 17.0053711,5.74609375 C24.0522461,5.74609375 29.7993164,11.9765625 29.7993164,13.2548828 C29.7993164,14.7695312 24.0522461,20.7636719 17.0053711,20.7636719 Z M17.0053711,19.2597656 C20.3354492,19.2597656 23.0317383,16.5634766 23.0317383,13.2333984 C23.0317383,9.90332031 20.3354492,7.20703125 17.0053711,7.20703125 C13.675293,7.20703125 10.9682617,9.90332031 10.9682617,13.2333984 C10.9682617,16.5634766 13.675293,19.2597656 17.0053711,19.2597656 Z M17.0053711,15.2421875 C15.8989258,15.2421875 15.0073242,14.3505859 15.0073242,13.2441406 C15.0073242,12.1376953 15.8989258,11.2460938 17.0053711,11.2460938 C18.1118164,11.2460938 19.003418,12.1376953 19.003418,13.2441406 C19.003418,14.3505859 18.1118164,15.2421875 17.0053711,15.2421875 Z" transform="translate(-2 -1)"/></svg>',
    sfEyeFill: '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="24" viewBox="0 0 30 24"><path d="M17.0053711,22.375 C25.6098633,22.375 31.5610352,15.4140625 31.5610352,13.2441406 C31.5610352,11.0634766 25.5991211,4.11328125 17.0053711,4.11328125 C8.50830078,4.11328125 2.43896484,11.0634766 2.43896484,13.2441406 C2.43896484,15.4140625 8.50830078,22.375 17.0053711,22.375 Z M17.0053711,19.2490234 C13.6860352,19.2490234 11.0004883,16.5527344 11.0004883,13.2441406 C11.0004883,9.92480469 13.6860352,7.23925781 17.0053711,7.23925781 C20.3139648,7.23925781 23.0102539,9.92480469 23.0102539,13.2441406 C23.0102539,16.5527344 20.3139648,19.2490234 17.0053711,19.2490234 Z M17.0053711,15.4355469 C18.2192383,15.4355469 19.1967773,14.4580078 19.1967773,13.2441406 C19.1967773,12.0302734 18.2192383,11.0527344 17.0053711,11.0527344 C15.7915039,11.0527344 14.8139648,12.0302734 14.8139648,13.2441406 C14.8139648,14.4580078 15.7915039,15.4355469 17.0053711,15.4355469 Z" transform="translate(-2 -1)"/></svg>',
    sfEyes: '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="24" viewBox="0 0 26 24"><path d="M8.32910156,23.0410156 C11.5947266,23.0410156 14.2050781,19.0664062 14.2050781,13.2441406 C14.2050781,7.41113281 11.5947266,3.45800781 8.32910156,3.45800781 C5.05273438,3.45800781 2.44238281,7.41113281 2.44238281,13.2441406 C2.44238281,19.0664062 5.05273438,23.0410156 8.32910156,23.0410156 Z M21.6708984,23.0410156 C24.9472656,23.0410156 27.5576172,19.0664062 27.5576172,13.2441406 C27.5576172,7.41113281 24.9472656,3.45800781 21.6708984,3.45800781 C18.4052734,3.45800781 15.7949219,7.41113281 15.7949219,13.2441406 C15.7949219,19.0664062 18.4052734,23.0410156 21.6708984,23.0410156 Z M6.00878906,17.0361328 C7.80273438,17.0361328 8.99511719,15.7900391 8.99511719,13.8994141 C8.99511719,12.0410156 7.80273438,10.7841797 6.00878906,10.7841797 C5.23535156,10.7841797 4.58007812,11.0097656 4.0859375,11.4179688 C4.50488281,7.54003906 6.27734375,4.99414063 8.32910156,4.97263058 C10.703125,4.96191406 12.6904297,8.32421875 12.6904297,13.2441406 C12.6904297,18.1318359 10.703125,21.5048828 8.32910156,21.5263672 C6.55664062,21.5263672 4.98828125,19.625 4.32226562,16.5742188 C4.78417969,16.875 5.35351562,17.0361328 6.00878906,17.0361328 Z M19.3398438,17.0361328 C21.1337891,17.0361328 22.3476562,15.7900391 22.3476562,13.8994141 C22.3476562,12.0410156 21.1337891,10.7841797 19.3398438,10.7841797 C18.5771484,10.7841797 17.9111328,11.0097656 17.40625,11.4179688 C17.8359375,7.54003906 19.6083984,4.99414062 21.6708984,4.98339844 C24.0234375,4.98339844 26.0214844,8.34570312 26.0214844,13.2441406 C26.0214844,18.1425781 24.0234375,21.5048828 21.6708984,21.515625 C19.8876953,21.515625 18.3193359,19.6035156 17.6533203,16.5742188 C18.1152344,16.8642578 18.6953125,17.0361328 19.3398438,17.0361328 Z M5.16015625,13.5341797 C4.7734375,13.4804688 4.53710938,13.0185547 4.62304688,12.5458984 C4.71972656,12.0839844 5.08496094,11.7402344 5.45019531,11.8154297 C5.83691406,11.890625 6.07324219,12.3310547 5.9765625,12.7929688 C5.890625,13.265625 5.53613281,13.5986328 5.16015625,13.5341797 Z M18.4912109,13.5341797 C18.1152344,13.4697266 17.8681641,13.0185547 17.9648438,12.5458984 C18.0615234,12.0839844 18.4160156,11.7402344 18.7919922,11.8154297 C19.1787109,11.8798828 19.4042969,12.3310547 19.3076172,12.7929688 C19.2216797,13.265625 18.8671875,13.5986328 18.4912109,13.5341797 Z" transform="translate(-2 -1)"/></svg>',
    sfEyesFill: '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="24" viewBox="0 0 26 24"><path d="M8.28613281,22.890625 C11.5087891,22.890625 14.0761719,18.9804688 14.0761719,13.2441406 C14.0761719,7.5078125 11.5087891,3.60839844 8.28613281,3.60839844 C5.26757812,3.60839844 2.81835938,7.05664062 2.52832031,12.234375 C3.03320312,11.2460938 4,10.6552734 5.26757812,10.6552734 C7.13671875,10.6552734 8.37207031,11.9658203 8.37207031,13.8994141 C8.37207031,15.8652344 7.13671875,17.1650391 5.26757812,17.1650391 C4.12890625,17.1650391 3.2265625,16.6923828 2.68945312,15.8759766 C3.34472656,20.140625 5.58984375,22.890625 8.28613281,22.890625 Z M21.6816406,22.890625 C24.9042969,22.890625 27.4716797,18.9804688 27.4716797,13.2441406 C27.4716797,7.5078125 24.9042969,3.60839844 21.6816406,3.60839844 C18.6630859,3.60839844 16.2138672,7.05664062 15.9238281,12.234375 C16.4287109,11.2460938 17.3955078,10.6552734 18.6523438,10.6552734 C20.5322266,10.6552734 21.7675781,11.9658203 21.7675781,13.8994141 C21.7675781,15.8652344 20.5322266,17.1650391 18.6523438,17.1650391 C17.5244141,17.1650391 16.6220703,16.6923828 16.0849609,15.8759766 C16.7402344,20.140625 18.9853516,22.890625 21.6816406,22.890625 Z M4.38671875,13.5126953 C4.7734375,13.5878906 5.12792969,13.2333984 5.23535156,12.75 C5.33203125,12.2666016 5.09570312,11.8046875 4.6875,11.7294922 C4.31152344,11.6542969 3.9140625,12.0087891 3.828125,12.4921875 C3.7421875,12.9863281 4,13.4482422 4.38671875,13.5126953 Z M17.7822266,13.5126953 C18.1582031,13.5878906 18.5341797,13.2333984 18.6308594,12.75 C18.7167969,12.2666016 18.4804688,11.7939453 18.0830078,11.7294922 C17.7070312,11.6542969 17.3095703,12.0087891 17.2236328,12.4921875 C17.1376953,12.9863281 17.3847656,13.4375 17.7822266,13.5126953 Z" transform="translate(-2 -1)"/></svg>',
    sfHistory: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M13,24.2011719 C19.0478516,24.2011719 23.9570312,19.2919922 23.9570312,13.2441406 C23.9570312,7.19628906 19.0478516,2.28710938 13,2.28710938 C6.95214844,2.28710938 2.04296875,7.19628906 2.04296875,13.2441406 C2.04296875,19.2919922 6.95214844,24.2011719 13,24.2011719 Z M13,22.375 C7.95117188,22.375 3.86914062,18.2929688 3.86914062,13.2441406 C3.86914062,8.1953125 7.95117188,4.11328125 13,4.11328125 C18.0488281,4.11328125 22.1308594,8.1953125 22.1308594,13.2441406 C22.1308594,18.2929688 18.0488281,22.375 13,22.375 Z M7.38183594,14.4042969 L12.9892578,14.4042969 C13.4082031,14.4042969 13.7412109,14.0820312 13.7412109,13.6523438 L13.7412109,6.41210938 C13.7412109,5.99316406 13.4082031,5.67089844 12.9892578,5.67089844 C12.5703125,5.67089844 12.2480469,5.99316406 12.2480469,6.41210938 L12.2480469,12.9111328 L7.38183594,12.9111328 C6.95214844,12.9111328 6.62988281,13.2333984 6.62988281,13.6523438 C6.62988281,14.0820312 6.95214844,14.4042969 7.38183594,14.4042969 Z" transform="translate(-1 -1)"/></svg>',
    'sfInfo Copy': '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="24" viewBox="0 0 26 24"><path d="M2.73925781,21.515625 C2.73925781,23.6533203 3.80273438,24.7597656 5.98339844,24.7597656 L23.7939453,24.7597656 C26.0498047,24.7597656 27.1669922,23.6533203 27.1669922,21.4404297 L27.1669922,5.05859375 C27.1669922,2.84570312 26.0498047,1.72851562 23.7939453,1.72851562 L10.8496094,1.72851562 C8.60449219,1.72851562 7.4765625,2.84570312 7.4765625,5.05859375 L7.4765625,10.1826172 L4.90917969,10.1826172 C3.54492188,10.1826172 2.73925781,10.9238281 2.73925781,12.2021484 L2.73925781,21.515625 Z M8.84082031,23.0302734 C9.07714844,22.5683594 9.20605469,22.03125 9.20605469,21.4082031 L9.20605469,5.15527344 C9.20605469,4.03808594 9.80761719,3.45800781 10.8818359,3.45800781 L23.7617188,3.45800781 C24.8359375,3.45800781 25.4375,4.03808594 25.4375,5.15527344 L25.4375,21.34375 C25.4375,22.4609375 24.8359375,23.0302734 23.7617188,23.0302734 L8.84082031,23.0302734 Z M11.9990234,8.13085938 L22.6660156,8.13085938 C23.0419922,8.13085938 23.3320312,7.83007812 23.3320312,7.45410156 C23.3320312,7.08886719 23.0419922,6.80957031 22.6660156,6.80957031 L11.9990234,6.80957031 C11.6123047,6.80957031 11.3222656,7.08886719 11.3222656,7.45410156 C11.3222656,7.83007812 11.6123047,8.13085938 11.9990234,8.13085938 Z M11.9990234,11.9121094 L22.6660156,11.9121094 C23.0419922,11.9121094 23.3320312,11.6220703 23.3320312,11.2568359 C23.3320312,10.8808594 23.0419922,10.5908203 22.6660156,10.5908203 L11.9990234,10.5908203 C11.6123047,10.5908203 11.3222656,10.8808594 11.3222656,11.2568359 C11.3222656,11.6220703 11.6123047,11.9121094 11.9990234,11.9121094 Z M4.46875,21.515625 L4.46875,12.5351562 C4.46875,12.1376953 4.70507812,11.9121094 5.10253906,11.9121094 L7.4765625,11.9121094 L7.4765625,21.515625 C7.4765625,22.4072266 6.82128906,23.0302734 5.98339844,23.0302734 C5.13476562,23.0302734 4.46875,22.375 4.46875,21.515625 Z M12.6328125,19.5712891 L15.4150391,19.5712891 C16.2314453,19.5712891 16.7255859,19.0771484 16.7255859,18.2607422 L16.7255859,15.7041016 C16.7255859,14.8769531 16.2314453,14.3828125 15.4150391,14.3828125 L12.6328125,14.3828125 C11.8056641,14.3828125 11.3115234,14.8769531 11.3115234,15.7041016 L11.3115234,18.2607422 C11.3115234,19.0771484 11.8056641,19.5712891 12.6328125,19.5712891 Z M18.6591797,15.7041016 L22.6552734,15.7041016 C23.0419922,15.7041016 23.3212891,15.4248047 23.3212891,15.0595703 C23.3212891,14.6728516 23.0419922,14.3828125 22.6552734,14.3828125 L18.6591797,14.3828125 C18.2724609,14.3828125 17.9931641,14.6728516 17.9931641,15.0595703 C17.9931641,15.4248047 18.2724609,15.7041016 18.6591797,15.7041016 Z M18.6591797,19.5712891 L22.6552734,19.5712891 C23.0419922,19.5712891 23.3212891,19.2919922 23.3212891,18.9267578 C23.3212891,18.5507812 23.0419922,18.25 22.6552734,18.25 L18.6591797,18.25 C18.2724609,18.25 17.9931641,18.5507812 17.9931641,18.9267578 C17.9931641,19.2919922 18.2724609,19.5712891 18.6591797,19.5712891 Z" transform="translate(-2 -1)"/></svg>',
    sfInfo: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M8.12109375,5.60644531 C9.06640625,5.60644531 9.82910156,4.84375 9.82910156,3.88769531 C9.82910156,2.94238281 9.06640625,2.1796875 8.12109375,2.1796875 C7.17578125,2.1796875 6.41308594,2.94238281 6.41308594,3.88769531 C6.41308594,4.84375 7.17578125,5.60644531 8.12109375,5.60644531 Z M3.01855469,22.0527344 C3.01855469,22.5253906 3.42675781,22.9121094 3.953125,22.9121094 L12.6435547,22.9121094 C13.1591797,22.9121094 13.578125,22.5253906 13.578125,22.0527344 C13.578125,21.5800781 13.1591797,21.2148438 12.6435547,21.2148438 L9.61425781,21.2148438 L9.61425781,10.4619141 C9.61425781,9.92480469 9.1953125,9.49511719 8.6796875,9.49511719 L4.35058594,9.49511719 C3.81347656,9.49511719 3.39453125,9.86035156 3.39453125,10.3222656 C3.39453125,10.8164062 3.81347656,11.1923828 4.35058594,11.1923828 L7.61621094,11.1923828 L7.61621094,21.2148438 L3.953125,21.2148438 C3.42675781,21.2148438 3.01855469,21.5800781 3.01855469,22.0527344 Z" transform="translate(3 -1)"/></svg>',
    sfInfoOval: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12.8798828,24.2011719 C18.9277344,24.2011719 23.8369141,19.2919922 23.8369141,13.2441406 C23.8369141,7.19628906 18.9277344,2.28710938 12.8798828,2.28710938 C6.83203125,2.28710938 1.92285156,7.19628906 1.92285156,13.2441406 C1.92285156,19.2919922 6.83203125,24.2011719 12.8798828,24.2011719 Z M12.8798828,22.375 C7.83105469,22.375 3.74902344,18.2929688 3.74902344,13.2441406 C3.74902344,8.1953125 7.83105469,4.11328125 12.8798828,4.11328125 C17.9287109,4.11328125 22.0107422,8.1953125 22.0107422,13.2441406 C22.0107422,18.2929688 17.9287109,22.375 12.8798828,22.375 Z M12.7832031,9.52734375 C13.5673828,9.52734375 14.1796875,8.90429688 14.1796875,8.12011719 C14.1796875,7.3359375 13.5673828,6.71289062 12.7832031,6.71289062 C12.0097656,6.71289062 11.3867188,7.3359375 11.3867188,8.12011719 C11.3867188,8.90429688 12.0097656,9.52734375 12.7832031,9.52734375 Z M11,19.2597656 L15.3720703,19.2597656 C15.8125,19.2597656 16.15625,18.9375 16.15625,18.4970703 C16.15625,18.078125 15.8125,17.7451172 15.3720703,17.7451172 L14.0400391,17.7451172 L14.0400391,12.2773438 C14.0400391,11.6972656 13.75,11.3105469 13.2021484,11.3105469 L11.1826172,11.3105469 C10.7421875,11.3105469 10.3984375,11.6435547 10.3984375,12.0625 C10.3984375,12.5029297 10.7421875,12.8251953 11.1826172,12.8251953 L12.3320312,12.8251953 L12.3320312,17.7451172 L11,17.7451172 C10.5595703,17.7451172 10.2158203,18.078125 10.2158203,18.4970703 C10.2158203,18.9375 10.5595703,19.2597656 11,19.2597656 Z" transform="translate(-1 -1)"/></svg>',
    sfInfoOvalFill: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12.8798828,24.2011719 C18.9277344,24.2011719 23.8369141,19.28125 23.8369141,13.2441406 C23.8369141,7.19628906 18.9277344,2.28710938 12.8798828,2.28710938 C6.84277344,2.28710938 1.92285156,7.19628906 1.92285156,13.2441406 C1.92285156,19.28125 6.84277344,24.2011719 12.8798828,24.2011719 Z M12.7832031,9.43066406 C11.9775391,9.43066406 11.3330078,8.78613281 11.3330078,7.96972656 C11.3330078,7.15332031 11.9775391,6.50878906 12.7832031,6.50878906 C13.5888672,6.50878906 14.2226562,7.15332031 14.2226562,7.96972656 C14.2226562,8.78613281 13.5888672,9.43066406 12.7832031,9.43066406 Z M10.9462891,19.4638672 C10.484375,19.4638672 10.1298828,19.1308594 10.1298828,18.6689453 C10.1298828,18.2392578 10.484375,17.8847656 10.9462891,17.8847656 L12.3105469,17.8847656 L12.3105469,12.8359375 L11.1289062,12.8359375 C10.6777344,12.8359375 10.3232422,12.5029297 10.3232422,12.0410156 C10.3232422,11.6113281 10.6777344,11.2568359 11.1289062,11.2568359 L13.2128906,11.2568359 C13.7822266,11.2568359 14.0830078,11.6650391 14.0830078,12.2666016 L14.0830078,17.8847656 L15.4472656,17.8847656 C15.9091797,17.8847656 16.2636719,18.2392578 16.2636719,18.6689453 C16.2636719,19.1308594 15.9091797,19.4638672 15.4472656,19.4638672 L10.9462891,19.4638672 Z" transform="translate(-1 -1)"/></svg>',
    sfInfoTriangle: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M5.12402344,23.3955078 L21.7744141,23.3955078 C23.6005859,23.3955078 24.7070312,22.1279297 24.7070312,20.484375 C24.7070312,19.9794922 24.5566406,19.453125 24.2880859,18.9804688 L15.9521484,4.45703125 C15.3935547,3.47949219 14.4375,2.98535156 13.4492188,2.98535156 C12.4609375,2.98535156 11.4941406,3.47949219 10.9462891,4.45703125 L2.61035156,18.9804688 C2.3203125,19.4638672 2.19140625,19.9794922 2.19140625,20.484375 C2.19140625,22.1279297 3.29785156,23.3955078 5.12402344,23.3955078 Z M5.13476562,21.7089844 C4.3828125,21.7089844 3.93164062,21.1289062 3.93164062,20.4736328 C3.93164062,20.2695312 3.97460938,20.0117188 4.09277344,19.7861328 L12.4179688,5.2734375 C12.6435547,4.87597656 13.0517578,4.70410156 13.4492188,4.70410156 C13.8466797,4.70410156 14.2441406,4.87597656 14.4697266,5.2734375 L22.7949219,19.796875 C22.9130859,20.0224609 22.9667969,20.2695312 22.9667969,20.4736328 C22.9667969,21.1289062 22.4941406,21.7089844 21.7529297,21.7089844 L5.13476562,21.7089844 Z M13.3740234,10.8701172 C14.0830078,10.8701172 14.6308594,10.3115234 14.6308594,9.61328125 C14.6308594,8.90429688 14.0830078,8.34570312 13.3740234,8.34570312 C12.6757812,8.34570312 12.1171875,8.90429688 12.1171875,9.61328125 C12.1171875,10.3115234 12.6757812,10.8701172 13.3740234,10.8701172 Z M11.7734375,19.6357422 L15.7050781,19.6357422 C16.1025391,19.6357422 16.4140625,19.3457031 16.4140625,18.9482422 C16.4140625,18.5722656 16.1025391,18.2714844 15.7050781,18.2714844 L14.5019531,18.2714844 L14.5019531,13.3515625 C14.5019531,12.8251953 14.2441406,12.4814453 13.75,12.4814453 L11.9345703,12.4814453 C11.5371094,12.4814453 11.2255859,12.7822266 11.2255859,13.1582031 C11.2255859,13.5556641 11.5371094,13.8349609 11.9345703,13.8349609 L12.9658203,13.8349609 L12.9658203,18.2714844 L11.7734375,18.2714844 C11.3759766,18.2714844 11.0644531,18.5722656 11.0644531,18.9482422 C11.0644531,19.3457031 11.3759766,19.6357422 11.7734375,19.6357422 Z" transform="translate(-1 -1)"/></svg>',
    sfInfoTriangleFill: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M5.12402344,23.3955078 L21.7744141,23.3955078 C23.6005859,23.3955078 24.7070312,22.1279297 24.7070312,20.484375 C24.7070312,19.9794922 24.5566406,19.453125 24.2880859,18.9804688 L15.9521484,4.45703125 C15.3935547,3.47949219 14.4375,2.98535156 13.4492188,2.98535156 C12.4609375,2.98535156 11.4941406,3.47949219 10.9462891,4.45703125 L2.61035156,18.9804688 C2.3203125,19.4638672 2.19140625,19.9794922 2.19140625,20.484375 C2.19140625,22.1279297 3.29785156,23.3955078 5.12402344,23.3955078 Z M13.3632812,10.7841797 C12.6435547,10.7841797 12.0634766,10.2041016 12.0634766,9.47363281 C12.0634766,8.73242188 12.6435547,8.15234375 13.3632812,8.15234375 C14.09375,8.15234375 14.6630859,8.73242188 14.6630859,9.47363281 C14.6630859,10.2041016 14.09375,10.7841797 13.3632812,10.7841797 Z M11.7089844,19.8183594 C11.3007812,19.8183594 10.9785156,19.5175781 10.9785156,19.0986328 C10.9785156,18.7119141 11.3007812,18.4003906 11.7089844,18.4003906 L12.9443359,18.4003906 L12.9443359,13.8457031 L11.8808594,13.8457031 C11.4726562,13.8457031 11.1503906,13.5556641 11.1503906,13.1367188 C11.1503906,12.75 11.4726562,12.4277344 11.8808594,12.4277344 L13.7607422,12.4277344 C14.265625,12.4277344 14.5341797,12.7929688 14.5341797,13.3408203 L14.5341797,18.4003906 L15.7695312,18.4003906 C16.1777344,18.4003906 16.5,18.7119141 16.5,19.0986328 C16.5,19.5175781 16.1777344,19.8183594 15.7695312,19.8183594 L11.7089844,19.8183594 Z" transform="translate(-1 -1)"/></svg>',
    sfInspect: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M6.48486328,23.1376953 L19.5151367,23.1376953 C21.7709961,23.1376953 22.8881836,22.03125 22.8881836,19.8183594 L22.8881836,6.69140625 C22.8881836,4.47851562 21.7709961,3.36132812 19.5151367,3.36132812 L6.48486328,3.36132812 C4.23974609,3.36132812 3.11181641,4.47851562 3.11181641,6.69140625 L3.11181641,19.8183594 C3.11181641,22.03125 4.23974609,23.1376953 6.48486328,23.1376953 Z M6.50634766,21.4082031 C5.43212891,21.4082031 4.84130859,20.8388672 4.84130859,19.7216797 L4.84130859,6.78808594 C4.84130859,5.67089844 5.43212891,5.09082031 6.50634766,5.09082031 L19.4936523,5.09082031 C20.5571289,5.09082031 21.1586914,5.67089844 21.1586914,6.78808594 L21.1586914,19.7216797 C21.1586914,20.8388672 20.5571289,21.4082031 19.4936523,21.4082031 L6.50634766,21.4082031 Z M13.5854492,16.4560547 L17.409668,16.4560547 C18.3979492,16.4560547 18.7954102,15.5537109 18.215332,14.9628906 L10.878418,7.63671875 C10.2338867,6.9921875 9.25634766,7.3359375 9.25634766,8.27050781 L9.25634766,18.6689453 C9.25634766,19.5068359 10.1694336,19.8505859 10.878418,19.1523438 L13.5854492,16.4560547 Z" transform="translate(-1 -1)"/></svg>',
    sfInspectFill: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M6.48486328,23.1376953 L19.5151367,23.1376953 C21.7709961,23.1376953 22.8881836,22.03125 22.8881836,19.8183594 L22.8881836,6.69140625 C22.8881836,4.47851562 21.7709961,3.36132812 19.5151367,3.36132812 L6.48486328,3.36132812 C4.23974609,3.36132812 3.11181641,4.47851562 3.11181641,6.69140625 L3.11181641,19.8183594 C3.11181641,22.03125 4.23974609,23.1376953 6.48486328,23.1376953 Z M13.574707,16.5527344 L10.7817383,19.3349609 C10.0512695,20.0546875 9.10595703,19.7001953 9.10595703,18.8300781 L9.10595703,8.109375 C9.10595703,7.14257812 10.1157227,6.78808594 10.7817383,7.45410156 L18.3442383,15.0058594 C18.9458008,15.6181641 18.5375977,16.5527344 17.5063477,16.5527344 L13.574707,16.5527344 Z" transform="translate(-1 -1)"/></svg>',
    sfKeyboard: '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="24" viewBox="0 0 28 24"><path d="M6.11230469,21.7304688 L26.4042969,21.7304688 C28.6386719,21.7304688 29.7773438,20.6132812 29.7773438,18.4003906 L29.7773438,8.07714844 C29.7773438,5.875 28.6386719,4.7578125 26.4042969,4.7578125 L6.11230469,4.7578125 C3.85644531,4.7578125 2.73925781,5.86425781 2.73925781,8.07714844 L2.73925781,18.4003906 C2.73925781,20.6132812 3.85644531,21.7304688 6.11230469,21.7304688 Z M6.13378906,20.0009766 C5.05957031,20.0009766 4.46875,19.4208984 4.46875,18.3037109 L4.46875,8.17382812 C4.46875,7.05664062 5.05957031,6.48730469 6.13378906,6.48730469 L26.3720703,6.48730469 C27.4355469,6.48730469 28.0478516,7.05664062 28.0478516,8.17382812 L28.0478516,18.3037109 C28.0478516,19.4208984 27.4355469,20.0009766 26.3720703,20.0009766 L6.13378906,20.0009766 Z M7.10058594,10.7412109 L8.08886719,10.7412109 C8.38964844,10.7412109 8.57226562,10.5585938 8.57226562,10.2685547 L8.57226562,9.28027344 C8.57226562,8.97949219 8.38964844,8.796875 8.08886719,8.796875 L7.10058594,8.796875 C6.81054688,8.796875 6.62792969,8.97949219 6.62792969,9.28027344 L6.62792969,10.2685547 C6.62792969,10.5585938 6.81054688,10.7412109 7.10058594,10.7412109 Z M10.5595703,10.7412109 L11.5478516,10.7412109 C11.8378906,10.7412109 12.0205078,10.5585938 12.0205078,10.2685547 L12.0205078,9.28027344 C12.0205078,8.97949219 11.8378906,8.796875 11.5478516,8.796875 L10.5595703,8.796875 C10.2587891,8.796875 10.0761719,8.97949219 10.0761719,9.28027344 L10.0761719,10.2685547 C10.0761719,10.5585938 10.2587891,10.7412109 10.5595703,10.7412109 Z M14.0185547,10.7412109 L14.9960938,10.7412109 C15.296875,10.7412109 15.4794922,10.5585938 15.4794922,10.2685547 L15.4794922,9.28027344 C15.4794922,8.97949219 15.296875,8.796875 14.9960938,8.796875 L14.0185547,8.796875 C13.7177734,8.796875 13.5351562,8.97949219 13.5351562,9.28027344 L13.5351562,10.2685547 C13.5351562,10.5585938 13.7177734,10.7412109 14.0185547,10.7412109 Z M17.4667969,10.7412109 L18.4550781,10.7412109 C18.7558594,10.7412109 18.9384766,10.5585938 18.9384766,10.2685547 L18.9384766,9.28027344 C18.9384766,8.97949219 18.7558594,8.796875 18.4550781,8.796875 L17.4667969,8.796875 C17.1767578,8.796875 16.9941406,8.97949219 16.9941406,9.28027344 L16.9941406,10.2685547 C16.9941406,10.5585938 17.1767578,10.7412109 17.4667969,10.7412109 Z M20.9257812,10.7412109 L21.9140625,10.7412109 C22.2041016,10.7412109 22.3867188,10.5585938 22.3867188,10.2685547 L22.3867188,9.28027344 C22.3867188,8.97949219 22.2041016,8.796875 21.9140625,8.796875 L20.9257812,8.796875 C20.625,8.796875 20.4423828,8.97949219 20.4423828,9.28027344 L20.4423828,10.2685547 C20.4423828,10.5585938 20.625,10.7412109 20.9257812,10.7412109 Z M24.3847656,10.7412109 L25.3623047,10.7412109 C25.6630859,10.7412109 25.8457031,10.5585938 25.8457031,10.2685547 L25.8457031,9.28027344 C25.8457031,8.97949219 25.6630859,8.796875 25.3623047,8.796875 L24.3847656,8.796875 C24.0839844,8.796875 23.9013672,8.97949219 23.9013672,9.28027344 L23.9013672,10.2685547 C23.9013672,10.5585938 24.0839844,10.7412109 24.3847656,10.7412109 Z M7.10058594,14.2001953 L8.08886719,14.2001953 C8.38964844,14.2001953 8.57226562,14.0175781 8.57226562,13.7167969 L8.57226562,12.7392578 C8.57226562,12.4384766 8.38964844,12.2558594 8.08886719,12.2558594 L7.10058594,12.2558594 C6.81054688,12.2558594 6.62792969,12.4384766 6.62792969,12.7392578 L6.62792969,13.7167969 C6.62792969,14.0175781 6.81054688,14.2001953 7.10058594,14.2001953 Z M10.5595703,14.2001953 L11.5478516,14.2001953 C11.8378906,14.2001953 12.0205078,14.0175781 12.0205078,13.7167969 L12.0205078,12.7392578 C12.0205078,12.4384766 11.8378906,12.2558594 11.5478516,12.2558594 L10.5595703,12.2558594 C10.2587891,12.2558594 10.0761719,12.4384766 10.0761719,12.7392578 L10.0761719,13.7167969 C10.0761719,14.0175781 10.2587891,14.2001953 10.5595703,14.2001953 Z M14.0185547,14.2001953 L14.9960938,14.2001953 C15.296875,14.2001953 15.4794922,14.0175781 15.4794922,13.7167969 L15.4794922,12.7392578 C15.4794922,12.4384766 15.296875,12.2558594 14.9960938,12.2558594 L14.0185547,12.2558594 C13.7177734,12.2558594 13.5351562,12.4384766 13.5351562,12.7392578 L13.5351562,13.7167969 C13.5351562,14.0175781 13.7177734,14.2001953 14.0185547,14.2001953 Z M17.4667969,14.2001953 L18.4550781,14.2001953 C18.7558594,14.2001953 18.9384766,14.0175781 18.9384766,13.7167969 L18.9384766,12.7392578 C18.9384766,12.4384766 18.7558594,12.2558594 18.4550781,12.2558594 L17.4667969,12.2558594 C17.1767578,12.2558594 16.9941406,12.4384766 16.9941406,12.7392578 L16.9941406,13.7167969 C16.9941406,14.0175781 17.1767578,14.2001953 17.4667969,14.2001953 Z M20.9257812,14.2001953 L21.9140625,14.2001953 C22.2041016,14.2001953 22.3867188,14.0175781 22.3867188,13.7167969 L22.3867188,12.7392578 C22.3867188,12.4384766 22.2041016,12.2558594 21.9140625,12.2558594 L20.9257812,12.2558594 C20.625,12.2558594 20.4423828,12.4384766 20.4423828,12.7392578 L20.4423828,13.7167969 C20.4423828,14.0175781 20.625,14.2001953 20.9257812,14.2001953 Z M24.3847656,14.2001953 L25.3623047,14.2001953 C25.6630859,14.2001953 25.8457031,14.0175781 25.8457031,13.7167969 L25.8457031,12.7392578 C25.8457031,12.4384766 25.6630859,12.2558594 25.3623047,12.2558594 L24.3847656,12.2558594 C24.0839844,12.2558594 23.9013672,12.4384766 23.9013672,12.7392578 L23.9013672,13.7167969 C23.9013672,14.0175781 24.0839844,14.2001953 24.3847656,14.2001953 Z M7.10058594,17.6591797 L8.08886719,17.6591797 C8.38964844,17.6591797 8.57226562,17.4765625 8.57226562,17.1757812 L8.57226562,16.1875 C8.57226562,15.8974609 8.38964844,15.7148438 8.08886719,15.7148438 L7.10058594,15.7148438 C6.81054688,15.7148438 6.62792969,15.8974609 6.62792969,16.1875 L6.62792969,17.1757812 C6.62792969,17.4765625 6.81054688,17.6591797 7.10058594,17.6591797 Z M10.6669922,17.6591797 L21.8066406,17.6591797 C22.171875,17.6591797 22.3867188,17.4443359 22.3867188,17.0683594 L22.3867188,16.2949219 C22.3867188,15.9296875 22.171875,15.7148438 21.8066406,15.7148438 L10.6669922,15.7148438 C10.2910156,15.7148438 10.0761719,15.9296875 10.0761719,16.2949219 L10.0761719,17.0683594 C10.0761719,17.4443359 10.2910156,17.6591797 10.6669922,17.6591797 Z M24.3847656,17.6591797 L25.3623047,17.6591797 C25.6630859,17.6591797 25.8457031,17.4765625 25.8457031,17.1757812 L25.8457031,16.1875 C25.8457031,15.8974609 25.6630859,15.7148438 25.3623047,15.7148438 L24.3847656,15.7148438 C24.0839844,15.7148438 23.9013672,15.8974609 23.9013672,16.1875 L23.9013672,17.1757812 C23.9013672,17.4765625 24.0839844,17.6591797 24.3847656,17.6591797 Z" transform="translate(-2 -1)"/></svg>',
    sfMessage: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M13,24.2011719 C19.0478516,24.2011719 23.9570312,19.2919922 23.9570312,13.2441406 C23.9570312,7.19628906 19.0478516,2.28710938 13,2.28710938 C6.95214844,2.28710938 2.04296875,7.19628906 2.04296875,13.2441406 C2.04296875,19.2919922 6.95214844,24.2011719 13,24.2011719 Z M13,22.375 C7.95117188,22.375 3.86914062,18.2929688 3.86914062,13.2441406 C3.86914062,8.1953125 7.95117188,4.11328125 13,4.11328125 C18.0488281,4.11328125 22.1308594,8.1953125 22.1308594,13.2441406 C22.1308594,18.2929688 18.0488281,22.375 13,22.375 Z M12.9785156,18.1855469 C16.4160156,18.1855469 18.9189453,16.1015625 18.9189453,13.2441406 C18.9189453,10.3759766 16.4160156,8.31347656 12.9785156,8.31347656 C9.55175781,8.31347656 7.04882812,10.3759766 7.04882812,13.2441406 C7.04882812,15.3066406 8.1875,15.8544922 8.1875,16.7783203 C8.1875,17.1757812 8.05859375,17.4443359 7.73632812,17.7236328 C7.52148438,17.9384766 7.63964844,18.1855469 7.97265625,18.1855469 C8.67089844,18.1855469 9.40136719,17.9384766 9.92773438,17.5517578 C10.8193359,17.9707031 11.8505859,18.1855469 12.9785156,18.1855469 Z" transform="translate(-1 -1)"/></svg>',
    sfMessageFill: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M13,24.2119141 C19.0478516,24.2119141 23.9570312,19.3027344 23.9570312,13.2548828 C23.9570312,7.21777344 19.0478516,2.29785156 13,2.29785156 C6.96289062,2.29785156 2.04296875,7.21777344 2.04296875,13.2548828 C2.04296875,19.3027344 6.96289062,24.2119141 13,24.2119141 Z M12.9892578,18.3466797 C11.8291016,18.3466797 10.765625,18.1318359 9.84179688,17.7021484 C9.3046875,18.1103516 8.55273438,18.3466797 7.83300781,18.3466797 C7.48925781,18.3466797 7.36035156,18.0996094 7.5859375,17.8740234 C7.91894531,17.5947266 8.04785156,17.3046875 8.04785156,16.9072266 C8.04785156,15.9511719 6.87695312,15.3818359 6.87695312,13.2548828 C6.87695312,10.3007812 9.45507812,8.17382812 12.9892578,8.17382812 C16.5341797,8.17382812 19.1123047,10.3007812 19.1123047,13.2548828 C19.1123047,16.2089844 16.5341797,18.3466797 12.9892578,18.3466797 Z" transform="translate(-1 -1)"/></svg>',
    sfMove: '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26"><path d="M8.08203125,16.4775391 L8.08203125,14.1894531 L14.0439453,14.1894531 L14.0439453,20.1835938 L11.7558594,20.1835938 C10.8320312,20.1835938 10.2841797,21.1289062 10.9716797,21.8486328 L14.2265625,25.2861328 C14.6884766,25.7695312 15.34375,25.7480469 15.7841797,25.2753906 L19.0283203,21.8486328 C19.7265625,21.1289062 19.1787109,20.1835938 18.2441406,20.1835938 L15.9667969,20.1835938 L15.9667969,14.1894531 L21.9179688,14.1894531 L21.9179688,16.4775391 C21.9179688,17.4121094 22.8632812,17.9599609 23.59375,17.2617188 L27.0205078,14.0175781 C27.4824219,13.5664062 27.5039062,12.921875 27.03125,12.4599609 L23.59375,9.20507812 C22.8632812,8.51757812 21.9179688,9.06542969 21.9179688,9.98925781 L21.9179688,12.2666016 L15.9667969,12.2666016 L15.9667969,6.28320312 L18.2441406,6.28320312 C19.1787109,6.28320312 19.7265625,5.33789062 19.0283203,4.61816406 L15.7734375,1.18066406 C15.3222656,0.697265625 14.6669922,0.71875 14.2158203,1.19140625 L10.9716797,4.61816406 C10.2841797,5.33789062 10.8320312,6.28320312 11.7558594,6.28320312 L14.0439453,6.28320312 L14.0439453,12.2666016 L8.08203125,12.2666016 L8.08203125,9.98925781 C8.08203125,9.06542969 7.12597656,8.51757812 6.40625,9.20507812 L2.97949219,12.4492188 C2.51757812,12.9003906 2.49609375,13.5449219 2.96875,14.0068359 L6.40625,17.2617188 C7.12597656,17.9599609 8.08203125,17.4121094 8.08203125,16.4775391 Z" transform="translate(-2)"/></svg>',
    sfMoveFill: '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26"><path d="M8.08203125,16.4775391 L8.08203125,14.1894531 L14.0439453,14.1894531 L14.0439453,20.1835938 L11.7558594,20.1835938 C10.8320312,20.1835938 10.2841797,21.1289062 10.9716797,21.8486328 L14.2265625,25.2861328 C14.6884766,25.7695312 15.34375,25.7480469 15.7841797,25.2753906 L19.0283203,21.8486328 C19.7265625,21.1289062 19.1787109,20.1835938 18.2441406,20.1835938 L15.9667969,20.1835938 L15.9667969,14.1894531 L21.9179688,14.1894531 L21.9179688,16.4775391 C21.9179688,17.4121094 22.8632812,17.9599609 23.59375,17.2617188 L27.0205078,14.0175781 C27.4824219,13.5664062 27.5039062,12.921875 27.03125,12.4599609 L23.59375,9.20507812 C22.8632812,8.51757812 21.9179688,9.06542969 21.9179688,9.98925781 L21.9179688,12.2666016 L15.9667969,12.2666016 L15.9667969,6.28320312 L18.2441406,6.28320312 C19.1787109,6.28320312 19.7265625,5.33789062 19.0283203,4.61816406 L15.7734375,1.18066406 C15.3222656,0.697265625 14.6669922,0.71875 14.2158203,1.19140625 L10.9716797,4.61816406 C10.2841797,5.33789062 10.8320312,6.28320312 11.7558594,6.28320312 L14.0439453,6.28320312 L14.0439453,12.2666016 L8.08203125,12.2666016 L8.08203125,9.98925781 C8.08203125,9.06542969 7.12597656,8.51757812 6.40625,9.20507812 L2.97949219,12.4492188 C2.51757812,12.9003906 2.49609375,13.5449219 2.96875,14.0068359 L6.40625,17.2617188 C7.12597656,17.9599609 8.08203125,17.4121094 8.08203125,16.4775391 Z" transform="translate(-2)"/></svg>',
    sfPage: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M2.96582031,21.3974609 C2.96582031,23.6425781 4.07226562,24.7597656 6.29589844,24.7597656 L17.7041016,24.7597656 C19.9277344,24.7597656 21.0341797,23.6425781 21.0341797,21.3974609 L21.0341797,5.1015625 C21.0341797,2.8671875 19.9277344,1.72851562 17.7041016,1.72851562 L6.29589844,1.72851562 C4.07226562,1.72851562 2.96582031,2.8671875 2.96582031,5.1015625 L2.96582031,21.3974609 Z M4.6953125,21.3652344 L4.6953125,5.13378906 C4.6953125,4.05957031 5.26464844,3.45800781 6.38183594,3.45800781 L17.6181641,3.45800781 C18.7353516,3.45800781 19.3046875,4.05957031 19.3046875,5.13378906 L19.3046875,21.3652344 C19.3046875,22.4394531 18.7353516,23.0302734 17.6181641,23.0302734 L6.38183594,23.0302734 C5.26464844,23.0302734 4.6953125,22.4394531 4.6953125,21.3652344 Z M7.15527344,11.9873047 C7.4453125,11.9873047 7.62792969,11.8369141 7.72460938,11.4716797 L8.08984375,10.4082031 L10.109375,10.4082031 L10.4960938,11.4716797 C10.5927734,11.8261719 10.7753906,11.9873047 11.0546875,11.9873047 C11.4199219,11.9873047 11.6240234,11.7832031 11.6240234,11.4394531 C11.6240234,11.3642578 11.6025391,11.2246094 11.5595703,11.0849609 L9.98046875,6.71289062 C9.81933594,6.26171875 9.55078125,6.046875 9.08886719,6.046875 C8.65917969,6.046875 8.40136719,6.26171875 8.24023438,6.71289062 L6.66113281,11.0849609 C6.60742188,11.2138672 6.5859375,11.3642578 6.5859375,11.4394531 C6.5859375,11.7832031 6.80078125,11.9873047 7.15527344,11.9873047 Z M13.4931641,7.90527344 L16.7695312,7.90527344 C17.1455078,7.90527344 17.4355469,7.61523438 17.4355469,7.23925781 C17.4355469,6.87402344 17.1455078,6.58398438 16.7695312,6.58398438 L13.4931641,6.58398438 C13.0957031,6.58398438 12.8164062,6.87402344 12.8164062,7.23925781 C12.8164062,7.61523438 13.0957031,7.90527344 13.4931641,7.90527344 Z M8.33691406,9.51660156 L9.06738281,7.26074219 L9.13183594,7.26074219 L9.87304688,9.51660156 L8.33691406,9.51660156 Z M13.4931641,11.6542969 L16.7695312,11.6542969 C17.1455078,11.6542969 17.4355469,11.3642578 17.4355469,10.9882812 C17.4355469,10.6230469 17.1455078,10.3330078 16.7695312,10.3330078 L13.4931641,10.3330078 C13.0957031,10.3330078 12.8164062,10.6230469 12.8164062,10.9882812 C12.8164062,11.3642578 13.0957031,11.6542969 13.4931641,11.6542969 Z M6.53222656,20.5380859 L7.28417969,20.5380859 L8.70214844,19.109375 C8.90625,18.9160156 9.12109375,18.8408203 9.3359375,18.8408203 C9.55078125,18.8408203 9.78710938,18.9267578 9.99121094,19.109375 L10.8720703,19.9150391 L13.0742188,17.9599609 C13.3212891,17.7451172 13.5791016,17.6484375 13.8261719,17.6484375 C14.0947266,17.6484375 14.3740234,17.734375 14.5673828,17.9599609 L16.7158203,20.4306641 L17.4677734,20.4306641 L17.4677734,15.2958984 C17.4677734,14.3505859 16.9736328,13.8671875 16.0283203,13.8671875 L7.98242188,13.8671875 C7.06933594,13.8671875 6.53222656,14.3505859 6.53222656,15.2958984 L6.53222656,20.5380859 Z M10.0771484,17.9599609 C9.43261719,17.9599609 8.91699219,17.4228516 8.91699219,16.7998047 C8.91699219,16.1552734 9.43261719,15.6181641 10.0771484,15.6396484 C10.7109375,15.6611328 11.2373047,16.1552734 11.2373047,16.7998047 C11.2373047,17.4228516 10.7109375,17.9599609 10.0771484,17.9599609 Z" transform="translate(0 -1)"/></svg>',
    sfPallete: '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26"><path d="M5.99804688,25.640625 L10.0585938,25.640625 C11.2939453,25.640625 12.1425781,25.2431641 12.6044922,24.4697266 L25.484375,17.046875 C27.1279297,16.0908203 27.4824219,14.7158203 26.515625,13.0400391 L24.4853516,9.52734375 C23.8515625,8.42089844 23.0566406,7.84082031 22.1435547,7.83007812 C22.6484375,6.4765625 22.1650391,5.359375 20.7255859,4.53222656 L17.2021484,2.49121094 C15.4619141,1.48144531 14.0761719,1.81445312 13.1201172,3.46875 L13.0126953,3.66210938 C12.9804688,1.80371094 11.9814453,0.84765625 10.0585938,0.84765625 L5.99804688,0.84765625 C3.98925781,0.84765625 2.94726562,1.82519531 2.94726562,3.73730469 L2.94726562,22.7402344 C2.94726562,24.6523438 3.98925781,25.640625 5.99804688,25.640625 Z M4.67675781,3.82324219 C4.67675781,3.10351562 5.25683594,2.57714844 6.01953125,2.57714844 L10.0371094,2.57714844 C10.7568359,2.57714844 11.2832031,3.10351562 11.2832031,3.82324219 L11.2832031,8.5390625 L4.67675781,8.5390625 L4.67675781,3.82324219 Z M14.5703125,4.40332031 C14.9248047,3.78027344 15.6982422,3.60839844 16.3642578,3.99511719 L19.8447266,6.00390625 C20.4570312,6.35839844 20.6396484,7.078125 20.2851562,7.71191406 L17.9326172,11.7832031 L13.0126953,8.94726562 L13.0126953,7.09960938 L14.5703125,4.40332031 Z M21.2412109,9.87109375 C21.8642578,9.50585938 22.6162109,9.7421875 23.0029297,10.4082031 L25.0117188,13.8779297 C25.3662109,14.5009766 25.1621094,15.2314453 24.5498047,15.5859375 L20.4677734,17.9384766 L18.4267578,14.3935547 L20.9296875,10.0537109 L21.2412109,9.87109375 Z M4.67675781,16.2197266 L4.67675781,10.2685547 L11.2832031,10.2685547 L11.2832031,16.2197266 L4.67675781,16.2197266 Z M13.0126953,17.8095703 L13.0126953,10.9345703 L17.0625,13.2871094 L14.0976562,18.4433594 L13.0126953,17.8095703 Z M17.4277344,16.1230469 L18.9638672,18.8085938 L14.3339844,21.4833984 L17.4277344,16.1230469 Z M6.01953125,23.9111328 C5.25683594,23.9111328 4.67675781,23.3740234 4.67675781,22.6542969 L4.67675781,17.9492188 L11.2832031,17.9492188 L11.2832031,22.6542969 C11.2832031,23.3740234 10.7568359,23.9111328 10.0371094,23.9111328 L6.01953125,23.9111328 Z M13.0126953,19.8076172 L13.2275391,19.9365234 L13.0126953,20.3232422 L13.0126953,19.8076172 Z" transform="translate(-2)"/></svg>',
    sfPencil: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M19.0361328,8.17382812 L20.1210938,7.11035156 C20.6689453,6.5625 20.7011719,5.97167969 20.2070312,5.47753906 L19.8417969,5.11230469 C19.3583984,4.62890625 18.7675781,4.671875 18.2197266,5.20898438 L17.1347656,6.28320312 L19.0361328,8.17382812 Z M6.37109375,20.8066406 L18.0908203,9.09765625 L16.2109375,7.20703125 L4.48046875,18.9160156 L3.45996094,21.3115234 C3.35253906,21.5693359 3.63183594,21.8701172 3.88964844,21.7626953 L6.37109375,20.8066406 Z" transform="translate(0 -1)"/></svg>',
    sfPlay: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M3.11962891,20.6992188 C3.11962891,21.7626953 3.73193359,22.2675781 4.46240234,22.2675781 C4.78466797,22.2675781 5.11767578,22.1601562 5.45068359,21.9882812 L17.965332,14.6728516 C18.8569336,14.1572266 19.1577148,13.8027344 19.1577148,13.2441406 C19.1577148,12.6748047 18.8569336,12.3310547 17.965332,11.8154297 L5.45068359,4.5 C5.11767578,4.31738281 4.78466797,4.22070312 4.46240234,4.22070312 C3.73193359,4.22070312 3.11962891,4.72558594 3.11962891,5.7890625 L3.11962891,20.6992188 Z M4.84912109,19.9365234 L4.84912109,6.55175781 C4.84912109,6.35839844 5.02099609,6.27246094 5.18212891,6.36914062 L16.6655273,13.0722656 C16.7407227,13.1044922 16.7836914,13.1796875 16.7836914,13.2441406 C16.7836914,13.3085938 16.7407227,13.3730469 16.6655273,13.4160156 L5.18212891,20.1191406 C5.02099609,20.2158203 4.84912109,20.1298828 4.84912109,19.9365234 Z" transform="translate(2 -1)"/></svg>',
    sfPlayFill: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M3.11962891,20.6992188 C3.11962891,21.7626953 3.73193359,22.2675781 4.46240234,22.2675781 C4.78466797,22.2675781 5.11767578,22.1601562 5.45068359,21.9882812 L17.965332,14.6728516 C18.8569336,14.1572266 19.1577148,13.8027344 19.1577148,13.2441406 C19.1577148,12.6748047 18.8569336,12.3310547 17.965332,11.8154297 L5.45068359,4.5 C5.11767578,4.31738281 4.78466797,4.22070312 4.46240234,4.22070312 C3.73193359,4.22070312 3.11962891,4.72558594 3.11962891,5.7890625 L3.11962891,20.6992188 Z" transform="translate(2 -1)"/></svg>',
    sfPlugin: '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="24" viewBox="0 0 26 24"><path d="M6.70800781,22.4609375 L25.2919922,22.4609375 C27.5478516,22.4609375 28.6650391,21.34375 28.6650391,19.1308594 L28.6650391,10.1181641 C28.6650391,7.91601562 27.5478516,6.79882812 25.2919922,6.79882812 L24.0996094,6.79882812 L24.0996094,5.359375 C24.0996094,4.54296875 23.6269531,4.04882812 22.7998047,4.04882812 L20.6513672,4.04882812 C19.8349609,4.04882812 19.3623047,4.54296875 19.3623047,5.359375 L19.3623047,6.79882812 L12.6484375,6.79882812 L12.6484375,5.359375 C12.6484375,4.54296875 12.1757812,4.04882812 11.3486328,4.04882812 L9.20019531,4.04882812 C8.37304688,4.04882812 7.90039062,4.54296875 7.90039062,5.359375 L7.90039062,6.79882812 L6.70800781,6.79882812 C4.46289062,6.79882812 3.33496094,7.90527344 3.33496094,10.1181641 L3.33496094,19.1308594 C3.33496094,21.3544922 4.46289062,22.4609375 6.70800781,22.4609375 Z M5.06445312,19.0449219 L5.06445312,10.2148438 C5.06445312,9.09765625 5.65527344,8.52832031 6.72949219,8.52832031 L25.2705078,8.52832031 C26.3339844,8.52832031 26.9355469,9.09765625 26.9355469,10.2148438 L26.9355469,19.0449219 C26.9355469,20.1513672 26.3339844,20.7314453 25.2705078,20.7314453 L6.72949219,20.7314453 C5.65527344,20.7314453 5.06445312,20.1513672 5.06445312,19.0449219 Z" transform="translate(-3 -1)"/></svg>',
    sfQuestion: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M8.05664062,17.6591797 C8.80859375,17.6591797 9.15234375,17.1435547 9.15234375,16.4560547 L9.15234375,16.0908203 C9.17382812,14.6728516 9.67871094,14.0820312 11.3974609,12.9003906 C13.2451172,11.6542969 14.4160156,10.2148438 14.4160156,8.14160156 C14.4160156,4.91894531 11.7949219,3.07128906 8.52929688,3.07128906 C6.1015625,3.07128906 3.97460938,4.22070312 3.06152344,6.29394531 C2.8359375,6.79882812 2.73925781,7.29296875 2.73925781,7.70117188 C2.73925781,8.31347656 3.09375,8.74316406 3.74902344,8.74316406 C4.296875,8.74316406 4.66210938,8.42089844 4.82324219,7.89453125 C5.37109375,5.85351562 6.72460938,5.08007812 8.45410156,5.08007812 C10.5488281,5.08007812 12.1923828,6.26171875 12.1923828,8.13085938 C12.1923828,9.66699219 11.2363281,10.5263672 9.86132812,11.4931641 C8.17480469,12.6640625 6.93945312,13.9208984 6.93945312,15.8115234 L6.93945312,16.4882812 C6.93945312,17.1757812 7.31542969,17.6591797 8.05664062,17.6591797 Z M8.05664062,23.5351562 C8.91601562,23.5351562 9.59277344,22.8476562 9.59277344,22.0097656 C9.59277344,21.1611328 8.91601562,20.484375 8.05664062,20.484375 C7.21875,20.484375 6.53125,21.1611328 6.53125,22.0097656 C6.53125,22.8476562 7.21875,23.5351562 8.05664062,23.5351562 Z" transform="translate(3 -1)"/></svg>',
    sfQuestionOval: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12.8798828,24.2011719 C18.9277344,24.2011719 23.8369141,19.2919922 23.8369141,13.2441406 C23.8369141,7.19628906 18.9277344,2.28710938 12.8798828,2.28710938 C6.83203125,2.28710938 1.92285156,7.19628906 1.92285156,13.2441406 C1.92285156,19.2919922 6.83203125,24.2011719 12.8798828,24.2011719 Z M12.8798828,22.375 C7.83105469,22.375 3.74902344,18.2929688 3.74902344,13.2441406 C3.74902344,8.1953125 7.83105469,4.11328125 12.8798828,4.11328125 C17.9287109,4.11328125 22.0107422,8.1953125 22.0107422,13.2441406 C22.0107422,18.2929688 17.9287109,22.375 12.8798828,22.375 Z M12.6542969,15.4677734 C13.1914062,15.4677734 13.5244141,15.1240234 13.5244141,14.7050781 L13.5244141,14.5761719 C13.5244141,13.9746094 13.8681641,13.5878906 14.6201172,13.09375 C15.6621094,12.40625 16.4033203,11.7832031 16.4033203,10.4941406 C16.4033203,8.7109375 14.8134766,7.74414062 12.9873047,7.74414062 C11.1396484,7.74414062 9.92578125,8.625 9.63574219,9.61328125 C9.58203125,9.78515625 9.54980469,9.95703125 9.54980469,10.1396484 C9.54980469,10.6230469 9.92578125,10.8808594 10.2802734,10.8808594 C10.6455078,10.8808594 10.8818359,10.7089844 11.0751953,10.4511719 L11.2685547,10.1933594 C11.6445312,9.5703125 12.203125,9.20507812 12.9228516,9.20507812 C13.9003906,9.20507812 14.5341797,9.76367188 14.5341797,10.5800781 C14.5341797,11.3105469 14.0830078,11.6650391 13.1484375,12.3203125 C12.375,12.8574219 11.7949219,13.4267578 11.7949219,14.4794922 L11.7949219,14.6191406 C11.7949219,15.1777344 12.1064453,15.4677734 12.6542969,15.4677734 Z M12.6328125,18.6689453 C13.2558594,18.6689453 13.7929688,18.1748047 13.7929688,17.5517578 C13.7929688,16.9287109 13.2666016,16.4345703 12.6328125,16.4345703 C11.9990234,16.4345703 11.4726562,16.9394531 11.4726562,17.5517578 C11.4726562,18.1640625 12.0097656,18.6689453 12.6328125,18.6689453 Z" transform="translate(-1 -1)"/></svg>',
    sfQuestionOvalFill: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12.8798828,24.2011719 C18.9277344,24.2011719 23.8369141,19.28125 23.8369141,13.2441406 C23.8369141,7.19628906 18.9277344,2.28710938 12.8798828,2.28710938 C6.84277344,2.28710938 1.92285156,7.19628906 1.92285156,13.2441406 C1.92285156,19.28125 6.84277344,24.2011719 12.8798828,24.2011719 Z M12.6542969,15.5429688 C12.0849609,15.5429688 11.7626953,15.2421875 11.7626953,14.6621094 L11.7626953,14.5224609 C11.7626953,13.4267578 12.3642578,12.8466797 13.1591797,12.2880859 C14.1259766,11.6113281 14.5878906,11.2460938 14.5878906,10.4941406 C14.5878906,9.65625 13.9326172,9.08691406 12.9335938,9.08691406 C12.1923828,9.08691406 11.6230469,9.45214844 11.2255859,10.0966797 L11.0322266,10.3652344 C10.828125,10.6230469 10.5810547,10.8056641 10.2050781,10.8056641 C9.83984375,10.8056641 9.44238281,10.5371094 9.44238281,10.0429688 C9.44238281,9.84960938 9.48535156,9.66699219 9.5390625,9.49511719 C9.83984375,8.47460938 11.0859375,7.58300781 12.9980469,7.58300781 C14.8886719,7.58300781 16.5322266,8.56054688 16.5322266,10.4082031 C16.5322266,11.7402344 15.7587891,12.3847656 14.6845703,13.09375 C13.9111328,13.5986328 13.5566406,13.9960938 13.5566406,14.6191406 L13.5566406,14.7480469 C13.5566406,15.1884766 13.2128906,15.5429688 12.6542969,15.5429688 Z M12.6328125,18.8408203 C11.9882812,18.8408203 11.4296875,18.3251953 11.4296875,17.6914062 C11.4296875,17.0576172 11.9775391,16.53125 12.6328125,16.53125 C13.2880859,16.53125 13.8359375,17.046875 13.8359375,17.6914062 C13.8359375,18.3359375 13.2773438,18.8408203 12.6328125,18.8408203 Z" transform="translate(-1 -1)"/></svg>',
    sfReplace: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M13,24.2011719 C19.0478516,24.2011719 23.9570312,19.2919922 23.9570312,13.2441406 C23.9570312,7.19628906 19.0478516,2.28710938 13,2.28710938 C6.95214844,2.28710938 2.04296875,7.19628906 2.04296875,13.2441406 C2.04296875,19.2919922 6.95214844,24.2011719 13,24.2011719 Z M13,22.375 C7.95117188,22.375 3.86914062,18.2929688 3.86914062,13.2441406 C3.86914062,8.1953125 7.95117188,4.11328125 13,4.11328125 C18.0488281,4.11328125 22.1308594,8.1953125 22.1308594,13.2441406 C22.1308594,18.2929688 18.0488281,22.375 13,22.375 Z M11.796875,14.640625 C12.0869141,14.3613281 12.0976562,13.9638672 11.8076172,13.6738281 C11.6894531,13.5341797 11.5175781,13.4697266 11.3242188,13.4697266 L9.734375,13.4912109 L9.10058594,13.5341797 L9.48730469,13.1796875 L14.4287109,8.23828125 C14.7080078,7.95898438 14.6972656,7.54003906 14.4179688,7.26074219 C14.1386719,6.98144531 13.7197266,6.97070312 13.4404297,7.26074219 L8.50976562,12.1806641 L8.14453125,12.5673828 L8.19824219,11.9658203 L8.21972656,10.3652344 C8.23046875,10.1933594 8.15527344,10.0107422 8.015625,9.88183594 C7.73632812,9.59179688 7.33886719,9.59179688 7.04882812,9.88183594 C6.91992187,10 6.85546875,10.2041016 6.85546875,10.3867188 L6.80175781,14.1572266 C6.79101562,14.5546875 7.13476562,14.8984375 7.53222656,14.8876953 L11.3134766,14.8554688 C11.4960938,14.8554688 11.6894531,14.7587891 11.796875,14.640625 Z M11.5390625,19.2275391 C11.8183594,19.5175781 12.2373047,19.5175781 12.5166016,19.2382812 L17.4580078,14.3076172 L17.8232422,13.9208984 L17.7802734,14.5439453 L17.7480469,16.1337891 C17.7480469,16.3164062 17.8232422,16.4882812 17.9521484,16.6279297 C18.2421875,16.9072266 18.6396484,16.9072266 18.9296875,16.6171875 C19.0371094,16.5097656 19.1445312,16.3164062 19.1445312,16.1230469 L19.1767578,12.3417969 C19.1875,11.9550781 18.8330078,11.6113281 18.4462891,11.6113281 L14.6865234,11.6542969 C14.4931641,11.6542969 14.2890625,11.7402344 14.1708984,11.8583984 C13.8808594,12.1376953 13.8808594,12.5458984 14.1708984,12.8359375 C14.2998047,12.9541016 14.4824219,13.0400391 14.6650391,13.0292969 L16.2441406,13.0078125 L16.8349609,12.9648438 L16.4589844,13.3193359 L11.5390625,18.25 C11.2490234,18.5400391 11.2597656,18.9482422 11.5390625,19.2275391 Z" transform="translate(-1 -1)"/></svg>',
    sfResponsive: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="27" viewBox="0 0 24 27"><path d="M3.39746094,4.53222656 L5.01953125,4.53222656 L5.01953125,3.0390625 C5.01953125,2.36230469 5.45996094,1.94335938 6.15820312,1.94335938 L10.4228516,1.94335938 L10.4228516,0.310546875 L5.98632812,0.310546875 C4.41796875,0.310546875 3.39746094,1.29882812 3.39746094,2.80273437 L3.39746094,4.53222656 Z M17.0722656,4.12402344 L18.7050781,4.12402344 L18.7050781,2.80273438 C18.7050781,1.29882812 17.6738281,0.310546875 16.1054688,0.310546875 L11.6796875,0.310546875 L11.6796875,1.94335938 L15.9228516,1.94335938 C16.6318359,1.94335938 17.0722656,2.36230469 17.0722656,3.0390625 L17.0722656,4.12402344 Z M11.8837891,26.1777344 L22.0029297,26.1777344 C23.5712891,26.1777344 24.6025391,25.2001953 24.6025391,23.6962891 L24.6025391,8.08789062 C24.6025391,6.58398438 23.5712891,5.59570312 22.0029297,5.59570312 L11.8837891,5.59570312 C10.3154297,5.59570312 9.29492188,6.58398438 9.29492188,8.08789062 L9.29492188,23.6962891 C9.29492188,25.2001953 10.3154297,26.1777344 11.8837891,26.1777344 Z M3.39746094,9.95703125 L5.01953125,9.95703125 L5.01953125,5.7890625 L3.39746094,5.7890625 L3.39746094,9.95703125 Z M12.0556641,24.5556641 C11.3574219,24.5556641 10.9169922,24.1367188 10.9169922,23.4707031 L10.9169922,8.33496094 C10.9169922,7.64746094 11.3574219,7.22851562 12.0556641,7.22851562 L21.8095703,7.22851562 C22.5292969,7.22851562 22.9697266,7.64746094 22.9697266,8.33496094 L22.9697266,23.4707031 C22.9697266,24.1367188 22.5292969,24.5556641 21.8095703,24.5556641 L12.0556641,24.5556641 Z M12.8935547,10.4296875 L13.6669922,10.4296875 C13.9033203,10.4296875 14.0859375,10.2578125 14.0859375,10.0429688 L14.0859375,9.23730469 C14.0859375,9.01171875 13.9033203,8.85058594 13.6669922,8.85058594 L12.8935547,8.85058594 C12.6894531,8.85058594 12.5068359,9.01171875 12.5068359,9.23730469 L12.5068359,10.0429688 C12.5068359,10.2470703 12.6894531,10.4296875 12.8935547,10.4296875 Z M15.3427734,10.4296875 L16.1269531,10.4296875 C16.3740234,10.4296875 16.5351562,10.2578125 16.5351562,10.0429688 L16.5351562,9.23730469 C16.5351562,9.01171875 16.3740234,8.85058594 16.1269531,8.85058594 L15.3427734,8.85058594 C15.1386719,8.85058594 14.9775391,9.01171875 14.9775391,9.23730469 L14.9775391,10.0429688 C14.9775391,10.2470703 15.1386719,10.4296875 15.3427734,10.4296875 Z M17.7919922,10.4296875 L18.5869141,10.4296875 C18.8017578,10.4296875 18.9736328,10.2578125 18.9736328,10.0429688 L18.9736328,9.23730469 C18.9736328,9.01171875 18.8017578,8.85058594 18.5869141,8.85058594 L17.7919922,8.85058594 C17.5771484,8.85058594 17.4160156,9.01171875 17.4160156,9.23730469 L17.4160156,10.0429688 C17.4160156,10.2470703 17.5771484,10.4296875 17.7919922,10.4296875 Z M20.2412109,10.4296875 L21.0253906,10.4296875 C21.2724609,10.4296875 21.4335938,10.2578125 21.4335938,10.0429688 L21.4335938,9.23730469 C21.4335938,9.01171875 21.2724609,8.85058594 21.0253906,8.85058594 L20.2412109,8.85058594 C20.0371094,8.85058594 19.8652344,9.01171875 19.8652344,9.23730469 L19.8652344,10.0429688 C19.8652344,10.2470703 20.0371094,10.4296875 20.2412109,10.4296875 Z M3.39746094,15.3818359 L5.01953125,15.3818359 L5.01953125,11.2138672 L3.39746094,11.2138672 L3.39746094,15.3818359 Z M12.8935547,12.8251953 L13.6669922,12.8251953 C13.9033203,12.8251953 14.0859375,12.6640625 14.0859375,12.4492188 L14.0859375,11.6328125 C14.0859375,11.4179688 13.9033203,11.2675781 13.6669922,11.2675781 L12.8935547,11.2675781 C12.6894531,11.2675781 12.5068359,11.4287109 12.5068359,11.6328125 L12.5068359,12.4492188 C12.5068359,12.6640625 12.6894531,12.8251953 12.8935547,12.8251953 Z M15.3427734,12.8251953 L16.1269531,12.8251953 C16.3740234,12.8251953 16.5351562,12.6640625 16.5351562,12.4492188 L16.5351562,11.6328125 C16.5351562,11.4179688 16.3740234,11.2675781 16.1269531,11.2675781 L15.3427734,11.2675781 C15.1386719,11.2675781 14.9560547,11.4287109 14.9560547,11.6328125 L14.9560547,12.4492188 C14.9560547,12.6640625 15.1386719,12.8251953 15.3427734,12.8251953 Z M17.7919922,12.8251953 L18.5869141,12.8251953 C18.8017578,12.8251953 18.9736328,12.6640625 18.9736328,12.4599609 L18.9736328,11.6328125 C18.9736328,11.4179688 18.8017578,11.2675781 18.5869141,11.2675781 L17.7919922,11.2675781 C17.5771484,11.2675781 17.4160156,11.4287109 17.4160156,11.6328125 L17.4160156,12.4599609 C17.4160156,12.6640625 17.5771484,12.8251953 17.7919922,12.8251953 Z M20.2412109,12.8251953 L21.0253906,12.8251953 C21.2724609,12.8251953 21.4335938,12.6640625 21.4335938,12.4599609 L21.4335938,11.6328125 C21.4335938,11.4179688 21.2724609,11.2675781 21.0253906,11.2675781 L20.2412109,11.2675781 C20.0371094,11.2675781 19.8652344,11.4287109 19.8652344,11.6328125 L19.8652344,12.4599609 C19.8652344,12.6640625 20.0371094,12.8251953 20.2412109,12.8251953 Z M12.8935547,15.2421875 L13.6669922,15.2421875 C13.9033203,15.2421875 14.0859375,15.0810547 14.0859375,14.8662109 L14.0859375,14.0605469 C14.0859375,13.8457031 13.9033203,13.6630859 13.6669922,13.6630859 L12.8935547,13.6630859 C12.6894531,13.6630859 12.5068359,13.8457031 12.5068359,14.0605469 L12.5068359,14.8662109 C12.5068359,15.0810547 12.6894531,15.2421875 12.8935547,15.2421875 Z M15.3427734,15.2421875 L16.1269531,15.2421875 C16.3740234,15.2421875 16.5351562,15.0810547 16.5351562,14.8662109 L16.5351562,14.0605469 C16.5351562,13.8457031 16.3740234,13.6630859 16.1269531,13.6630859 L15.3427734,13.6630859 C15.1386719,13.6630859 14.9560547,13.8457031 14.9560547,14.0605469 L14.9560547,14.8662109 C14.9560547,15.0810547 15.1386719,15.2421875 15.3427734,15.2421875 Z M5.98632812,20.8925781 L7.82324219,20.8925781 L7.82324219,19.2705078 L6.15820312,19.2705078 C5.45996094,19.2705078 5.01953125,18.8515625 5.01953125,18.1748047 L5.01953125,16.6386719 L3.39746094,16.6386719 L3.39746094,18.4111328 C3.39746094,19.9150391 4.41796875,20.8925781 5.98632812,20.8925781 Z M12.8935547,22.9335938 L13.6669922,22.9335938 C13.9033203,22.9335938 14.0859375,22.7724609 14.0859375,22.546875 L14.0859375,21.7412109 C14.0859375,21.5263672 13.9033203,21.3652344 13.6669922,21.3652344 L12.8935547,21.3652344 C12.6894531,21.3652344 12.5068359,21.5371094 12.5068359,21.7412109 L12.5068359,22.546875 C12.5068359,22.7724609 12.6894531,22.9335938 12.8935547,22.9335938 Z M15.3427734,22.9335938 L16.1269531,22.9335938 C16.3740234,22.9335938 16.5351562,22.7724609 16.5351562,22.546875 L16.5351562,21.7412109 C16.5351562,21.5263672 16.3740234,21.3652344 16.1269531,21.3652344 L15.3427734,21.3652344 C15.1386719,21.3652344 14.9560547,21.5371094 14.9560547,21.7412109 L14.9560547,22.546875 C14.9560547,22.7724609 15.1386719,22.9335938 15.3427734,22.9335938 Z M17.7919922,22.9335938 L18.5869141,22.9335938 C18.8017578,22.9335938 18.9736328,22.7724609 18.9736328,22.546875 L18.9736328,21.7412109 C18.9736328,21.5263672 18.8017578,21.3652344 18.5869141,21.3652344 L17.7919922,21.3652344 C17.5771484,21.3652344 17.4160156,21.5371094 17.4160156,21.7412109 L17.4160156,22.546875 C17.4160156,22.7724609 17.5771484,22.9335938 17.7919922,22.9335938 Z M20.2412109,22.9335938 L21.0253906,22.9335938 C21.2724609,22.9335938 21.4335938,22.7724609 21.4335938,22.546875 L21.4335938,21.7412109 C21.4335938,21.5263672 21.2724609,21.3652344 21.0253906,21.3652344 L20.2412109,21.3652344 C20.0371094,21.3652344 19.8759766,21.5371094 19.8759766,21.7412109 L19.8759766,22.546875 C19.8759766,22.7724609 20.0371094,22.9335938 20.2412109,22.9335938 Z" transform="translate(-2)"/></svg>',
    sfSearch: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M2.50488281,11.2246094 C2.50488281,15.9511719 6.35058594,19.796875 11.0771484,19.796875 C12.9462891,19.796875 14.6542969,19.1953125 16.0615234,18.1855469 L21.3466797,23.4814453 C21.59375,23.7285156 21.9160156,23.8466797 22.2597656,23.8466797 C22.9902344,23.8466797 23.4951172,23.2988281 23.4951172,22.5791016 C23.4951172,22.2353516 23.3662109,21.9238281 23.140625,21.6982422 L17.8876953,16.4130859 C18.9941406,14.9736328 19.6494141,13.1796875 19.6494141,11.2246094 C19.6494141,6.49804688 15.8037109,2.65234375 11.0771484,2.65234375 C6.35058594,2.65234375 2.50488281,6.49804688 2.50488281,11.2246094 Z M4.34179688,11.2246094 C4.34179688,7.5078125 7.36035156,4.48925781 11.0771484,4.48925781 C14.7939453,4.48925781 17.8125,7.5078125 17.8125,11.2246094 C17.8125,14.9414062 14.7939453,17.9599609 11.0771484,17.9599609 C7.36035156,17.9599609 4.34179688,14.9414062 4.34179688,11.2246094 Z" transform="translate(-1 -1)"/></svg>',
    sfSendFill: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25"><path d="M15.6435547,25.0175781 C16.4169922,25.0175781 16.9648438,24.3515625 17.3623047,23.3203125 L24.3984375,4.94042969 C24.5917969,4.44628906 24.6992188,4.00585938 24.6992188,3.640625 C24.6992188,2.94238281 24.2695312,2.51269531 23.5712891,2.51269531 C23.2060547,2.51269531 22.765625,2.62011719 22.2714844,2.81347656 L3.79492188,9.89257812 C2.89257812,10.2363281 2.19433594,10.7841797 2.19433594,11.5683594 C2.19433594,12.5566406 2.94628906,12.8896484 3.97753906,13.2011719 L9.77832031,14.9628906 C10.4658203,15.1777344 10.8525391,15.15625 11.3144531,14.7265625 L23.0986328,3.71582031 C23.2382812,3.58691406 23.3994141,3.60839844 23.5068359,3.70507812 C23.6142578,3.8125 23.625,3.97363281 23.4960938,4.11328125 L12.5283203,15.9404297 C12.109375,16.3808594 12.0771484,16.7460938 12.28125,17.4658203 L13.9892578,23.1376953 C14.3115234,24.2226562 14.6445312,25.0175781 15.6435547,25.0175781 Z" transform="translate(-2 -1)"/></svg>',
    sfSettings: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12.3320312,24.7275391 L14.5019531,24.7275391 C15.3291016,24.7275391 15.9736328,24.2226562 16.15625,23.4277344 L16.6181641,21.4189453 L16.9619141,21.3007812 L18.7128906,22.375 C19.4111328,22.8046875 20.2167969,22.7080078 20.8076172,22.1171875 L22.3115234,20.6240234 C22.9023438,20.0332031 22.9990234,19.2167969 22.5693359,18.5292969 L21.4736328,16.7890625 L21.6025391,16.4667969 L23.6113281,15.9941406 C24.3955078,15.8115234 24.9111328,15.15625 24.9111328,14.3398438 L24.9111328,12.2128906 C24.9111328,11.3964844 24.40625,10.7519531 23.6113281,10.5585938 L21.6240234,10.0751953 L21.484375,9.73144531 L22.5800781,7.99121094 C23.0097656,7.30371094 22.9238281,6.49804688 22.3222656,5.89648438 L20.8183594,4.39257812 C20.2382812,3.8125 19.4326172,3.70507812 18.734375,4.13476562 L16.9833984,5.20898438 L16.6181641,5.06933594 L16.15625,3.06054688 C15.9736328,2.265625 15.3291016,1.76074219 14.5019531,1.76074219 L12.3320312,1.76074219 C11.5048828,1.76074219 10.8603516,2.265625 10.6777344,3.06054688 L10.2050781,5.06933594 L9.83984375,5.20898438 L8.09960938,4.13476562 C7.40136719,3.70507812 6.58496094,3.8125 6.00488281,4.39257812 L4.51171875,5.89648438 C3.91015625,6.49804688 3.81347656,7.30371094 4.25390625,7.99121094 L5.33886719,9.73144531 L5.20996094,10.0751953 L3.22265625,10.5585938 C2.42773438,10.7519531 1.92285156,11.3964844 1.92285156,12.2128906 L1.92285156,14.3398438 C1.92285156,15.15625 2.43847656,15.8115234 3.22265625,15.9941406 L5.23144531,16.4667969 L5.34960938,16.7890625 L4.26464844,18.5292969 C3.82421875,19.2167969 3.93164062,20.0332031 4.52246094,20.6240234 L6.015625,22.1171875 C6.60644531,22.7080078 7.42285156,22.8046875 8.12109375,22.375 L9.86132812,21.3007812 L10.2050781,21.4189453 L10.6777344,23.4277344 C10.8603516,24.2226562 11.5048828,24.7275391 12.3320312,24.7275391 Z M12.5039062,23.0517578 C12.3212891,23.0517578 12.2246094,22.9765625 12.1923828,22.8046875 L11.5478516,20.140625 C10.8925781,19.9794922 10.2802734,19.7216797 9.81835938,19.4316406 L7.4765625,20.8710938 C7.34765625,20.9677734 7.19726562,20.9570312 7.07910156,20.8173828 L5.81152344,19.5498047 C5.69335938,19.4316406 5.68261719,19.3027344 5.76855469,19.1523438 L7.20800781,16.8320312 C6.9609375,16.3808594 6.68164062,15.7685547 6.50976562,15.1132813 L3.84570312,14.4794922 C3.67382812,14.4472656 3.59863281,14.3505859 3.59863281,14.1679688 L3.59863281,12.3740234 C3.59863281,12.1806641 3.66308594,12.0947266 3.84570312,12.0625 L6.49902344,11.4179688 C6.67089844,10.7197266 6.99316406,10.0859375 7.18652344,9.68847656 L5.7578125,7.36816406 C5.66113281,7.20703125 5.671875,7.078125 5.79003906,6.94921875 L7.06835938,5.703125 C7.19726562,5.57421875 7.31542969,5.56347656 7.4765625,5.64941406 L9.796875,7.05664062 C10.2587891,6.79882812 10.9140625,6.53027344 11.5585938,6.34765625 L12.1923828,3.68359375 C12.2246094,3.51171875 12.3212891,3.43652344 12.5039062,3.43652344 L14.3300781,3.43652344 C14.5126953,3.43652344 14.609375,3.51171875 14.6308594,3.68359375 L15.2861328,6.36914062 C15.9521484,6.54101562 16.5322266,6.80957031 17.015625,7.06738281 L19.3466797,5.64941406 C19.5185547,5.56347656 19.6259766,5.57421875 19.765625,5.703125 L21.0332031,6.94921875 C21.1621094,7.078125 21.1621094,7.20703125 21.0654297,7.36816406 L19.6367188,9.68847656 C19.8408203,10.0859375 20.1523438,10.7197266 20.3242188,11.4179688 L22.9882812,12.0625 C23.1601562,12.0947266 23.2353516,12.1806641 23.2353516,12.3740234 L23.2353516,14.1679688 C23.2353516,14.3505859 23.1494141,14.4472656 22.9882812,14.4794922 L20.3134766,15.1132813 C20.1416016,15.7685547 19.8730469,16.3808594 19.6152344,16.8320312 L21.0546875,19.1523438 C21.140625,19.3027344 21.140625,19.4316406 21.0117188,19.5498047 L19.7548828,20.8173828 C19.6259766,20.9570312 19.4863281,20.9677734 19.3466797,20.8710938 L17.0048828,19.4316406 C16.5429688,19.7216797 15.9414062,19.9794922 15.2861328,20.140625 L14.6308594,22.8046875 C14.609375,22.9765625 14.5126953,23.0517578 14.3300781,23.0517578 L12.5039062,23.0517578 Z M13.4169922,17.3369141 C15.6835938,17.3369141 17.5097656,15.5107422 17.5097656,13.2441406 C17.5097656,10.9775391 15.6835938,9.15136719 13.4169922,9.15136719 C11.1503906,9.15136719 9.32421875,10.9775391 9.32421875,13.2441406 C9.32421875,15.5107422 11.1503906,17.3369141 13.4169922,17.3369141 Z M13.4169922,15.671875 C12.0742188,15.671875 10.9892578,14.5869141 10.9892578,13.2441406 C10.9892578,11.9013672 12.0742188,10.8164062 13.4169922,10.8164062 C14.7597656,10.8164062 15.8447266,11.9013672 15.8447266,13.2441406 C15.8447266,14.5869141 14.7597656,15.671875 13.4169922,15.671875 Z" transform="translate(-1 -1)"/></svg>',
    sfSettingsFill: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12.1601562,24.4697266 L14.1367188,24.4697266 C14.6953125,24.4697266 15.0927734,24.1367188 15.2216797,23.5888672 L15.7802734,21.2255859 C16.1992188,21.0859375 16.6074219,20.9248047 16.9619141,20.7529297 L19.0351562,22.0205078 C19.4970703,22.3105469 20.0234375,22.2675781 20.4101562,21.8808594 L21.7958984,20.5058594 C22.1826172,20.1191406 22.2363281,19.5605469 21.9248047,19.0986328 L20.6572266,17.046875 C20.8398438,16.6708984 21.0009766,16.2841797 21.1191406,15.8974609 L23.5039062,15.328125 C24.0517578,15.1992188 24.3740234,14.8017578 24.3740234,14.2431641 L24.3740234,12.2988281 C24.3740234,11.7509766 24.0517578,11.3535156 23.5039062,11.2246094 L21.140625,10.6552734 C21.0009766,10.2148438 20.8291016,9.81738281 20.6787109,9.484375 L21.9462891,7.40039062 C22.2363281,6.92773438 22.2148438,6.42285156 21.8173828,6.02539062 L20.4101562,4.63964844 C20.0126953,4.27441406 19.5292969,4.18847656 19.0673828,4.47851562 L16.9619141,5.77832031 C16.6181641,5.59570312 16.2207031,5.43457031 15.7802734,5.29492188 L15.2216797,2.89941406 C15.0927734,2.3515625 14.6953125,2.01855469 14.1367188,2.01855469 L12.1601562,2.01855469 C11.6015625,2.01855469 11.2041016,2.3515625 11.0644531,2.89941406 L10.5058594,5.2734375 C10.0869141,5.41308594 9.67871094,5.57421875 9.31347656,5.76757812 L7.22949219,4.47851562 C6.76757812,4.18847656 6.26269531,4.25292969 5.87597656,4.63964844 L4.47949219,6.02539062 C4.08203125,6.42285156 4.04980469,6.92773438 4.35058594,7.40039062 L5.60742188,9.484375 C5.46777344,9.81738281 5.29589844,10.2148438 5.15625,10.6552734 L2.79296875,11.2246094 C2.24511719,11.3535156 1.92285156,11.7509766 1.92285156,12.2988281 L1.92285156,14.2431641 C1.92285156,14.8017578 2.24511719,15.1992188 2.79296875,15.328125 L5.17773438,15.8974609 C5.29589844,16.2841797 5.45703125,16.6708984 5.62890625,17.046875 L4.37207031,19.0986328 C4.04980469,19.5605469 4.11425781,20.1191406 4.50097656,20.5058594 L5.87597656,21.8808594 C6.26269531,22.2675781 6.79980469,22.3105469 7.26171875,22.0205078 L9.32421875,20.7529297 C9.68945312,20.9248047 10.0869141,21.0859375 10.5058594,21.2255859 L11.0644531,23.5888672 C11.2041016,24.1367188 11.6015625,24.4697266 12.1601562,24.4697266 Z M13.1484375,17.0361328 C11.0537109,17.0361328 9.35644531,15.3388672 9.35644531,13.2441406 C9.35644531,11.1494141 11.0537109,9.45214844 13.1484375,9.45214844 C15.2431641,9.45214844 16.9404297,11.1494141 16.9404297,13.2441406 C16.9404297,15.3388672 15.2431641,17.0361328 13.1484375,17.0361328 Z" transform="translate(-1 -1)"/></svg>',
    sfShare: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25"><path d="M12.9946289,16.3486328 C13.456543,16.3486328 13.8540039,15.9726562 13.8540039,15.5214844 L13.8540039,4.5859375 L13.7788086,2.97460938 L14.3911133,3.61914062 L16.0454102,5.39160156 C16.1958008,5.56347656 16.4213867,5.64941406 16.6254883,5.64941406 C17.0766602,5.64941406 17.409668,5.32714844 17.409668,4.89746094 C17.409668,4.66113281 17.3237305,4.48925781 17.1625977,4.328125 L13.6176758,0.912109375 C13.402832,0.697265625 13.2202148,0.6328125 12.9946289,0.6328125 C12.7797852,0.6328125 12.597168,0.697265625 12.371582,0.912109375 L8.83740234,4.328125 C8.67626953,4.48925781 8.57958984,4.66113281 8.57958984,4.89746094 C8.57958984,5.32714844 8.90185547,5.64941406 9.35302734,5.64941406 C9.55712891,5.64941406 9.79345703,5.56347656 9.94384766,5.39160156 L11.6088867,3.61914062 L12.2211914,2.96386719 L12.1459961,4.5859375 L12.1459961,15.5214844 C12.1459961,15.9726562 12.5327148,16.3486328 12.9946289,16.3486328 Z M7.95654297,24.7597656 L18.0327148,24.7597656 C20.9223633,24.7597656 22.5336914,23.1484375 22.5336914,20.2695312 L22.5336914,11.9980469 C22.5336914,9.10839844 20.9223633,7.5078125 18.0327148,7.5078125 L15.862793,7.5078125 L15.862793,9.23730469 L18.0327148,9.23730469 C19.8051758,9.23730469 20.8041992,10.2255859 20.8041992,11.9980469 L20.8041992,20.2695312 C20.8041992,22.0419922 19.8051758,23.0302734 18.0327148,23.0302734 L7.95654297,23.0302734 C6.19482422,23.0302734 5.19580078,22.0419922 5.19580078,20.2695312 L5.19580078,11.9980469 C5.19580078,10.2255859 6.19482422,9.23730469 7.95654297,9.23730469 L10.1264648,9.23730469 L10.1264648,7.5078125 L7.95654297,7.5078125 C5.06689453,7.5078125 3.46630859,9.10839844 3.46630859,11.9980469 L3.46630859,20.2695312 C3.46630859,23.1484375 5.06689453,24.7597656 7.95654297,24.7597656 Z" transform="translate(-1)"/></svg>',
    sfUpload: '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="25" viewBox="0 0 28 25"><path d="M18.8574219,18.0136719 L18.8574219,19.7431641 L24.2285156,19.7431641 C27.5263672,19.7431641 29.5029297,17.7558594 29.5029297,15.15625 C29.5029297,12.9863281 28.203125,11.203125 26.1083984,10.3544922 C26.1298828,5.56347656 22.6816406,2.10449219 18.2880859,2.10449219 C15.3769531,2.10449219 13.3037109,3.66210938 12.0146484,5.54199219 C9.57617188,4.88671875 6.49316406,6.77734375 6.43945312,9.79589844 C4.01171875,10.171875 2.49707031,12.1591797 2.49707031,14.6943359 C2.49707031,17.4873047 4.59179688,19.7431641 8.11523438,19.7431641 L13.2392578,19.7431641 L13.2392578,18.0136719 L8.10449219,18.0136719 C5.55859375,18.0136719 4.2265625,16.5419922 4.2265625,14.6943359 C4.2265625,12.6425781 5.52636719,11.1171875 7.80371094,11.1171875 C7.95410156,11.1171875 8.0078125,11.03125 8.0078125,10.8916016 C8.0078125,7.59375 10.3818359,6.68066406 12.5947266,7.32519531 C12.7236328,7.36816406 12.7988281,7.34667969 12.8632812,7.22851562 C13.9052734,5.37011719 15.5058594,3.83398438 18.2880859,3.83398438 C21.8115234,3.83398438 24.25,6.62695312 24.4326172,9.828125 C24.4648438,10.3115234 24.4326172,10.8916016 24.3896484,11.3964844 C24.3789062,11.5361328 24.4326172,11.6220703 24.5615234,11.6435547 C26.5166016,12.0732422 27.7734375,13.2978516 27.7734375,15.15625 C27.7734375,16.8105469 26.5703125,18.0136719 24.2177734,18.0136719 L18.8574219,18.0136719 Z M12.4013672,15.0166016 C12.6162109,15.0166016 12.8417969,14.9306641 12.9921875,14.7587891 L14.6572266,12.9863281 L15.2695312,12.3417969 L15.1943359,13.953125 L15.1943359,24.5019531 C15.1943359,24.953125 15.5917969,25.3291016 16.0537109,25.3291016 C16.515625,25.3291016 16.9023438,24.953125 16.9023438,24.5019531 L16.9023438,13.953125 L16.8271484,12.3417969 L17.4394531,12.9863281 L19.09375,14.7587891 C19.2548828,14.9306641 19.4697266,15.0166016 19.6845703,15.0166016 C20.125,15.0166016 20.46875,14.6943359 20.46875,14.2646484 C20.46875,14.0283203 20.3720703,13.8564453 20.2109375,13.6953125 L16.6660156,10.2792969 C16.4511719,10.0644531 16.2685547,10 16.0537109,10 C15.828125,10 15.6455078,10.0644531 15.4306641,10.2792969 L11.8857422,13.6953125 C11.7246094,13.8564453 11.6279297,14.0283203 11.6279297,14.2646484 C11.6279297,14.6943359 11.9501953,15.0166016 12.4013672,15.0166016 Z" transform="translate(-2 -1)"/></svg>',
    sfZoomIn: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M2.47070312,11.2246094 C2.47070312,15.9511719 6.31640625,19.796875 11.0429688,19.796875 C12.9121094,19.796875 14.6201172,19.1953125 16.0273438,18.1855469 L21.3125,23.4814453 C21.5595703,23.7285156 21.8818359,23.8466797 22.2255859,23.8466797 C22.9560547,23.8466797 23.4609375,23.2988281 23.4609375,22.5791016 C23.4609375,22.2353516 23.3320312,21.9238281 23.1064453,21.6982422 L17.8535156,16.4130859 C18.9599609,14.9736328 19.6152344,13.1796875 19.6152344,11.2246094 C19.6152344,6.49804688 15.7695312,2.65234375 11.0429688,2.65234375 C6.31640625,2.65234375 2.47070312,6.49804688 2.47070312,11.2246094 Z M4.30761719,11.2246094 C4.30761719,7.5078125 7.32617188,4.48925781 11.0429688,4.48925781 C14.7597656,4.48925781 17.7783203,7.5078125 17.7783203,11.2246094 C17.7783203,14.9414062 14.7597656,17.9599609 11.0429688,17.9599609 C7.32617188,17.9599609 4.30761719,14.9414062 4.30761719,11.2246094 Z M8.28222656,12.0087891 L10.2587891,12.0087891 L10.2587891,13.9853516 C10.2587891,14.4257812 10.6025391,14.7695312 11.0429688,14.7695312 C11.4833984,14.7695312 11.8378906,14.4257812 11.8378906,13.9853516 L11.8378906,12.0087891 L13.8037109,12.0087891 C14.2441406,12.0087891 14.5878906,11.6650391 14.5878906,11.2246094 C14.5878906,10.7841797 14.2441406,10.4296875 13.8037109,10.4296875 L11.8378906,10.4296875 L11.8378906,8.46386719 C11.8378906,8.0234375 11.4833984,7.6796875 11.0429688,7.6796875 C10.6025391,7.6796875 10.2587891,8.0234375 10.2587891,8.46386719 L10.2587891,10.4296875 L8.28222656,10.4296875 C7.84179688,10.4296875 7.49804688,10.7841797 7.49804688,11.2246094 C7.49804688,11.6650391 7.84179688,12.0087891 8.28222656,12.0087891 Z" transform="translate(-1 -1)"/></svg>',
    sfZoomOut: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M2.47070312,11.2246094 C2.47070312,15.9511719 6.31640625,19.796875 11.0429688,19.796875 C12.9121094,19.796875 14.6201172,19.1953125 16.0273438,18.1855469 L21.3125,23.4814453 C21.5595703,23.7285156 21.8818359,23.8466797 22.2255859,23.8466797 C22.9560547,23.8466797 23.4609375,23.2988281 23.4609375,22.5791016 C23.4609375,22.2353516 23.3320312,21.9238281 23.1064453,21.6982422 L17.8535156,16.4130859 C18.9599609,14.9736328 19.6152344,13.1796875 19.6152344,11.2246094 C19.6152344,6.49804688 15.7695312,2.65234375 11.0429688,2.65234375 C6.31640625,2.65234375 2.47070312,6.49804688 2.47070312,11.2246094 Z M4.30761719,11.2246094 C4.30761719,7.5078125 7.32617188,4.48925781 11.0429688,4.48925781 C14.7597656,4.48925781 17.7783203,7.5078125 17.7783203,11.2246094 C17.7783203,14.9414062 14.7597656,17.9599609 11.0429688,17.9599609 C7.32617188,17.9599609 4.30761719,14.9414062 4.30761719,11.2246094 Z M8.28222656,12.0087891 L13.8037109,12.0087891 C14.2333984,12.0087891 14.5878906,11.6542969 14.5878906,11.2246094 C14.5878906,10.7949219 14.2333984,10.4296875 13.8037109,10.4296875 L8.28222656,10.4296875 C7.85253906,10.4296875 7.48730469,10.7949219 7.48730469,11.2246094 C7.48730469,11.6542969 7.85253906,12.0087891 8.28222656,12.0087891 Z" transform="translate(-1 -1)"/></svg>',
    support: '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="24" viewBox="0 0 26 24"><path d="M15,22.9121094 C22.21875,22.9121094 27.4931641,18.5078125 27.4931641,12.4492188 C27.4931641,6.36914062 22.2080078,1.99707031 15,1.99707031 C7.78125,1.99707031 2.50683594,6.36914062 2.50683594,12.4492188 C2.50683594,14.4580078 3.09765625,16.3271484 4.12890625,17.8417969 C4.63378906,18.59375 4.81640625,19.1201172 4.81640625,19.5605469 C4.81640625,20.1298828 4.64453125,20.5917969 4.15039062,21.0214844 C3.30175781,21.7412109 3.7421875,22.9121094 4.859375,22.9121094 C6.20214844,22.9121094 7.6953125,22.4501953 8.80175781,21.6875 C10.6171875,22.4824219 12.7333984,22.9121094 15,22.9121094 Z M15,21.1826172 C12.9482422,21.1826172 11.1113281,20.7958984 9.55371094,20.0976562 C8.86621094,19.796875 8.37207031,19.8828125 7.71679688,20.2695312 C7.25488281,20.5595703 6.71777344,20.8066406 6.16992188,20.9248047 C6.39550781,20.5488281 6.54589844,20.1191406 6.54589844,19.5605469 C6.54589844,18.765625 6.25585938,17.8955078 5.56835938,16.8642578 C4.70898438,15.6181641 4.23632812,14.1035156 4.23632812,12.4492188 C4.23632812,7.41113281 8.68359375,3.7265625 15,3.7265625 C21.3164062,3.7265625 25.7636719,7.41113281 25.7636719,12.4492188 C25.7636719,17.4873047 21.3164062,21.1826172 15,21.1826172 Z M14.7851562,14.6728516 C15.3222656,14.6728516 15.6445312,14.3291016 15.6445312,13.9101562 L15.6445312,13.78125 C15.6445312,13.1689453 15.9990234,12.7929688 16.7509766,12.2988281 C17.7929688,11.6113281 18.5341797,10.9775391 18.5341797,9.69921875 C18.5341797,7.91601562 16.9443359,6.94921875 15.1181641,6.94921875 C13.2705078,6.94921875 12.0566406,7.83007812 11.7558594,8.81835938 C11.7021484,8.99023438 11.6699219,9.16210938 11.6699219,9.34472656 C11.6699219,9.828125 12.0458984,10.0859375 12.4111328,10.0859375 C12.7763672,10.0859375 13.0019531,9.9140625 13.1953125,9.65625 L13.3886719,9.3984375 C13.7646484,8.77539062 14.3339844,8.41015625 15.0429688,8.41015625 C16.03125,8.41015625 16.6650391,8.96875 16.6650391,9.78515625 C16.6650391,10.515625 16.2138672,10.8701172 15.2685547,11.5253906 C14.5058594,12.0625 13.9257812,12.6318359 13.9257812,13.6845703 L13.9257812,13.8242188 C13.9257812,14.3828125 14.2265625,14.6728516 14.7851562,14.6728516 Z M14.7529297,17.8740234 C15.3759766,17.8740234 15.9130859,17.3798828 15.9130859,16.7568359 C15.9130859,16.1337891 15.3867188,15.6396484 14.7529297,15.6396484 C14.1298828,15.6396484 13.6035156,16.1445312 13.6035156,16.7568359 C13.6035156,17.3691406 14.140625,17.8740234 14.7529297,17.8740234 Z" transform="translate(-2 -1)"/></svg>',
    syncOvalFill: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12.8798828,24.2011719 C18.9277344,24.2011719 23.8369141,19.2919922 23.8369141,13.2441406 C23.8369141,7.20703125 18.9277344,2.28710938 12.8798828,2.28710938 C6.84277344,2.28710938 1.92285156,7.20703125 1.92285156,13.2441406 C1.92285156,19.2919922 6.84277344,24.2011719 12.8798828,24.2011719 Z M20.2490234,12.2558594 C20.7646484,12.2558594 20.8720703,12.75 20.5927734,13.1474609 L18.8203125,15.6396484 C18.4980469,16.0908203 17.9824219,16.0478516 17.6923828,15.6396484 L15.8876953,13.1474609 C15.6083984,12.75 15.7265625,12.2558594 16.2314453,12.2558594 L17.2197266,12.2558594 C16.7792969,10.2578125 15.0068359,8.78613281 12.8798828,8.78613281 C11.8164062,8.78613281 10.8925781,9.16210938 10.1513672,9.73144531 C9.59277344,10.1289062 9.07714844,10.0107422 8.83007812,9.67773438 C8.55078125,9.33398438 8.57226562,8.74316406 9.12011719,8.32421875 C10.0761719,7.55078125 11.4189453,7.03515625 12.8798828,7.03515625 C15.9736328,7.03515625 18.5410156,9.30175781 19.0029297,12.2558594 L20.2490234,12.2558594 Z M5.51074219,14.2431641 C5.00585937,14.2431641 4.88769531,13.7382812 5.16699219,13.3515625 L6.93945312,10.8486328 C7.26171875,10.3974609 7.77734375,10.4404297 8.06738281,10.8486328 L9.87207031,13.3515625 C10.1513672,13.7382812 10.0332031,14.2431641 9.52832031,14.2431641 L8.54003906,14.2431641 C8.98046875,16.2304688 10.7529297,17.7021484 12.8798828,17.7021484 C13.9433594,17.7021484 14.8671875,17.3369141 15.6083984,16.7568359 C16.1669922,16.3701172 16.6826172,16.4882812 16.9296875,16.8105469 C17.2089844,17.1650391 17.1875,17.7451172 16.6396484,18.1748047 C15.6835938,18.9375 14.3408203,19.453125 12.8798828,19.453125 C9.78613281,19.453125 7.21875,17.1865234 6.75683594,14.2431641 L5.51074219,14.2431641 Z" transform="translate(-1 -1)"/></svg>',
    target: '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="27" viewBox="0 0 28 27"><path d="M2.7109375,14.0283203 L4.89160156,14.0283203 C5.26757812,19.0019531 9.25292969,22.9765625 14.2373047,23.3525391 L14.2373047,25.5439453 C14.2373047,25.9736328 14.5703125,26.3173828 15,26.3173828 C15.4404297,26.3173828 15.7734375,25.9736328 15.7734375,25.5439453 L15.7734375,23.3525391 C20.7470703,22.9765625 24.7324219,19.0019531 25.1191406,14.0283203 L27.2890625,14.0283203 C27.71875,14.0283203 28.0625,13.6845703 28.0625,13.2548828 C28.0625,12.8251953 27.71875,12.4921875 27.2890625,12.4921875 L25.1191406,12.4921875 C24.7539062,7.49707031 20.7685547,3.49023438 15.7734375,3.11425781 L15.7734375,0.965820312 C15.7734375,0.536132812 15.4404297,0.192382812 15,0.192382812 C14.5703125,0.192382812 14.2373047,0.536132812 14.2373047,0.965820312 L14.2373047,3.11425781 C9.2421875,3.49023438 5.24609375,7.49707031 4.88085938,12.4921875 L2.7109375,12.4921875 C2.28125,12.4921875 1.9375,12.8251953 1.9375,13.2548828 C1.9375,13.6845703 2.28125,14.0283203 2.7109375,14.0283203 Z M15,9.01171875 C15.4404297,9.01171875 15.7734375,8.66796875 15.7734375,8.23828125 L15.7734375,4.86523438 C19.8125,5.23046875 23.0244141,8.453125 23.3789062,12.4921875 L20.0166016,12.4921875 C19.5869141,12.4921875 19.2431641,12.8251953 19.2431641,13.2548828 C19.2431641,13.6845703 19.5869141,14.0283203 20.0166016,14.0283203 L23.3681641,14.0283203 C23.0029297,18.0458984 19.7910156,21.2470703 15.7734375,21.6015625 L15.7734375,18.2714844 C15.7734375,17.8417969 15.4404297,17.5087891 15,17.5087891 C14.5703125,17.5087891 14.2373047,17.8417969 14.2373047,18.2714844 L14.2373047,21.6015625 C10.2089844,21.2470703 7.0078125,18.0458984 6.63183594,14.0283203 L9.98339844,14.0283203 C10.4130859,14.0283203 10.7568359,13.6845703 10.7568359,13.2548828 C10.7568359,12.8251953 10.4130859,12.4921875 9.98339844,12.4921875 L6.63183594,12.4921875 C6.98632812,8.453125 10.1982422,5.23046875 14.2373047,4.86523438 L14.2373047,8.23828125 C14.2373047,8.66796875 14.5703125,9.01171875 15,9.01171875 Z" transform="translate(-1)"/></svg>',
    undo: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M2.84863281,10.4511719 C2.84863281,10.7089844 2.95605469,10.9560547 3.17089844,11.1601562 L9.48730469,17.3583984 C9.66992188,17.5517578 9.94921875,17.6591797 10.1748047,17.6591797 C10.7548828,17.6591797 11.1308594,17.2724609 11.1308594,16.7138672 C11.1308594,16.4345703 11.0341797,16.2304688 10.8730469,16.0585938 L7.76855469,13.0400391 L5.72753906,11.2890625 L8.25195312,11.4072266 L15.6318359,11.4072266 C19.2949219,11.4072266 21.2285156,13.4267578 21.2285156,16.3164062 C21.2285156,19.2167969 19.2949219,21.3652344 15.6318359,21.3652344 L13.1611328,21.3652344 C12.5703125,21.3652344 12.1835938,21.7949219 12.1835938,22.3212891 C12.1835938,22.8476562 12.5703125,23.2773438 13.1611328,23.2773438 L15.6425781,23.2773438 C20.4443359,23.2773438 23.1513672,20.5380859 23.1513672,16.4238281 C23.1513672,12.3203125 20.3691406,9.484375 15.4707031,9.484375 L8.25195312,9.484375 L5.72753906,9.60253906 L7.76855469,7.8515625 L10.8730469,4.83300781 C11.0341797,4.66113281 11.1308594,4.45703125 11.1308594,4.17773438 C11.1308594,3.61914062 10.7548828,3.23242188 10.1748047,3.23242188 C9.94921875,3.23242188 9.66992188,3.33984375 9.48730469,3.53320312 L3.17089844,9.73144531 C2.95605469,9.93554688 2.84863281,10.1826172 2.84863281,10.4511719 Z" transform="translate(-1 -1)"/></svg>',
    upgrade: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12.8798828,24.2011719 C18.9277344,24.2011719 23.8369141,19.2919922 23.8369141,13.2441406 C23.8369141,7.19628906 18.9277344,2.28710938 12.8798828,2.28710938 C6.83203125,2.28710938 1.92285156,7.19628906 1.92285156,13.2441406 C1.92285156,19.2919922 6.83203125,24.2011719 12.8798828,24.2011719 Z M12.8798828,22.375 C7.83105469,22.375 3.74902344,18.2929688 3.74902344,13.2441406 C3.74902344,8.1953125 7.83105469,4.11328125 12.8798828,4.11328125 C17.9287109,4.11328125 22.0107422,8.1953125 22.0107422,13.2441406 C22.0107422,18.2929688 17.9287109,22.375 12.8798828,22.375 Z M8.20703125,13.0615234 L10.5810547,13.0615234 L10.5810547,17.9169922 C10.5810547,18.7763672 11.0644531,19.2705078 11.8916016,19.2705078 L13.8789062,19.2705078 C14.7060547,19.2705078 15.1894531,18.7763672 15.1894531,17.9169922 L15.1894531,13.0615234 L17.53125,13.0615234 C17.9179688,13.0615234 18.2294922,12.7714844 18.2294922,12.3632812 C18.2294922,12.0839844 18.1113281,11.890625 17.8212891,11.5898438 L13.5136719,6.97070312 C13.2988281,6.74511719 13.0732422,6.66992188 12.8798828,6.66992188 C12.6972656,6.66992188 12.4609375,6.74511719 12.2568359,6.97070312 L7.89550781,11.5898438 C7.6484375,11.8583984 7.53027344,12.0947266 7.53027344,12.3847656 C7.53027344,12.7714844 7.80957031,13.0615234 8.20703125,13.0615234 Z" transform="translate(-1 -1)"/></svg>',
    upgradeFill: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12.8798828,24.2119141 C18.9277344,24.2119141 23.8369141,19.3027344 23.8369141,13.2548828 C23.8369141,7.21777344 18.9277344,2.29785156 12.8798828,2.29785156 C6.84277344,2.29785156 1.92285156,7.21777344 1.92285156,13.2548828 C1.92285156,19.3027344 6.84277344,24.2119141 12.8798828,24.2119141 Z M12.8798828,6.48730469 C13.0839844,6.48730469 13.3095703,6.5625 13.5351562,6.79882812 L17.9716797,11.5576172 C18.2724609,11.8798828 18.4013672,12.0625 18.4013672,12.3525391 C18.4013672,12.7822266 18.0683594,13.0830078 17.6708984,13.0830078 L15.2646484,13.0830078 L15.2646484,18.0888672 C15.2646484,18.9697266 14.7597656,19.4746094 13.9111328,19.4746094 L11.859375,19.4746094 C11.0107422,19.4746094 10.5058594,18.9697266 10.5058594,18.0888672 L10.5058594,13.0830078 L8.06738281,13.0830078 C7.6484375,13.0830078 7.35839844,12.7822266 7.35839844,12.3740234 C7.35839844,12.0732422 7.48730469,11.8476562 7.74511719,11.5576172 L12.2353516,6.79882812 C12.4501953,6.5625 12.6865234,6.48730469 12.8798828,6.48730469 Z" transform="translate(-1 -1)"/></svg>',
    x: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M20.2392578,20.140625 L13.3642578,13.2548828 L20.2392578,6.37988281 C20.6044922,6.01464844 20.6152344,5.39160156 20.2392578,5.02636719 C19.8632812,4.65039062 19.2509766,4.63964844 18.875,5.02636719 L12,11.9013672 L5.125,5.02636719 C4.75976562,4.65039062 4.12597656,4.63964844 3.76074219,5.02636719 C3.39550781,5.40234375 3.39550781,6.01464844 3.76074219,6.37988281 L10.6357422,13.2548828 L3.76074219,20.140625 C3.39550781,20.5058594 3.38476562,21.1289062 3.76074219,21.4941406 C4.13671875,21.859375 4.75976562,21.859375 5.125,21.4941406 L12,14.6191406 L18.875,21.4941406 C19.2402344,21.859375 19.8740234,21.8701172 20.2392578,21.4941406 C20.6044922,21.1181641 20.6044922,20.5058594 20.2392578,20.140625 Z" transform="translate(0 -1)"/></svg>',
    xCircle: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M13,24.2011719 C19.0478516,24.2011719 23.9570312,19.2919922 23.9570312,13.2441406 C23.9570312,7.19628906 19.0478516,2.28710938 13,2.28710938 C6.95214844,2.28710938 2.04296875,7.19628906 2.04296875,13.2441406 C2.04296875,19.2919922 6.95214844,24.2011719 13,24.2011719 Z M13,22.375 C7.95117188,22.375 3.86914062,18.2929688 3.86914062,13.2441406 C3.86914062,8.1953125 7.95117188,4.11328125 13,4.11328125 C18.0488281,4.11328125 22.1308594,8.1953125 22.1308594,13.2441406 C22.1308594,18.2929688 18.0488281,22.375 13,22.375 Z M9.94921875,17.5195312 L13,14.46875 L16.0507812,17.5195312 C16.2119141,17.6806641 16.4160156,17.7880859 16.6630859,17.7880859 C17.1357422,17.7880859 17.5224609,17.4013672 17.5224609,16.9179688 C17.5224609,16.6708984 17.4365234,16.4775391 17.2646484,16.3056641 L14.203125,13.2548828 L17.2646484,10.1933594 C17.4365234,10.0322266 17.5224609,9.828125 17.5224609,9.59179688 C17.5224609,9.11914062 17.1357422,8.74316406 16.6630859,8.74316406 C16.4267578,8.74316406 16.2333984,8.82910156 16.0722656,9.00097656 L13,12.0625 L9.92773438,9.00097656 C9.76660156,8.82910156 9.5625,8.74316406 9.32617188,8.74316406 C8.85351562,8.74316406 8.46679688,9.11914062 8.46679688,9.59179688 C8.46679688,9.828125 8.56347656,10.0322266 8.72460938,10.1933594 L11.7861328,13.2548828 L8.72460938,16.3056641 C8.56347656,16.4775391 8.46679688,16.6708984 8.46679688,16.9179688 C8.46679688,17.4013672 8.85351562,17.7880859 9.32617188,17.7880859 C9.58398438,17.7880859 9.78808594,17.6806641 9.94921875,17.5195312 Z" transform="translate(-1 -1)"/></svg>',
    xCircleFill: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M13,24.2011719 C19.0478516,24.2011719 23.9570312,19.28125 23.9570312,13.2441406 C23.9570312,7.19628906 19.0478516,2.28710938 13,2.28710938 C6.96289062,2.28710938 2.04296875,7.19628906 2.04296875,13.2441406 C2.04296875,19.28125 6.96289062,24.2011719 13,24.2011719 Z M9.390625,17.7558594 C8.89648438,17.7558594 8.50976562,17.3583984 8.50976562,16.8642578 C8.50976562,16.6279297 8.59570312,16.4023438 8.76757812,16.2412109 L11.7431641,13.2548828 L8.76757812,10.2792969 C8.59570312,10.1074219 8.50976562,9.89257812 8.50976562,9.65625 C8.50976562,9.15136719 8.89648438,8.77539062 9.390625,8.77539062 C9.63769531,8.77539062 9.83105469,8.86132812 10.0029297,9.02246094 L13,12.0087891 L16.0185547,9.01171875 C16.2011719,8.82910156 16.3945312,8.75390625 16.6308594,8.75390625 C17.125,8.75390625 17.5224609,9.140625 17.5224609,9.63476562 C17.5224609,9.88183594 17.4472656,10.0751953 17.2539062,10.2685547 L14.2675781,13.2548828 L17.2431641,16.2304688 C17.4257812,16.3916016 17.5117188,16.6171875 17.5117188,16.8642578 C17.5117188,17.3583984 17.1142578,17.7558594 16.609375,17.7558594 C16.3623047,17.7558594 16.1367188,17.6699219 15.9755859,17.4980469 L13,14.5117188 L10.0351562,17.4980469 C9.86328125,17.6699219 9.63769531,17.7558594 9.390625,17.7558594 Z" transform="translate(-1 -1)"/></svg>',
    xRect: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M6.48486328,23.1376953 L19.5151367,23.1376953 C21.7709961,23.1376953 22.8881836,22.03125 22.8881836,19.8183594 L22.8881836,6.69140625 C22.8881836,4.47851562 21.7709961,3.36132812 19.5151367,3.36132812 L6.48486328,3.36132812 C4.23974609,3.36132812 3.11181641,4.47851562 3.11181641,6.69140625 L3.11181641,19.8183594 C3.11181641,22.03125 4.23974609,23.1376953 6.48486328,23.1376953 Z M6.50634766,21.4082031 C5.43212891,21.4082031 4.84130859,20.8388672 4.84130859,19.7216797 L4.84130859,6.78808594 C4.84130859,5.67089844 5.43212891,5.09082031 6.50634766,5.09082031 L19.4936523,5.09082031 C20.5571289,5.09082031 21.1586914,5.67089844 21.1586914,6.78808594 L21.1586914,19.7216797 C21.1586914,20.8388672 20.5571289,21.4082031 19.4936523,21.4082031 L6.50634766,21.4082031 Z M9.96533203,17.5195312 L13.0161133,14.46875 L16.0668945,17.5195312 C16.2280273,17.6806641 16.4321289,17.7880859 16.6791992,17.7880859 C17.1625977,17.7880859 17.5385742,17.4013672 17.5385742,16.9179688 C17.5385742,16.6708984 17.4526367,16.4775391 17.2807617,16.3056641 L14.2192383,13.2548828 L17.2807617,10.1933594 C17.4526367,10.0322266 17.5385742,9.828125 17.5385742,9.59179688 C17.5385742,9.11914062 17.1625977,8.74316406 16.6791992,8.74316406 C16.4428711,8.74316406 16.2495117,8.82910156 16.0883789,9.00097656 L13.0161133,12.0625 L9.94384766,9.00097656 C9.78271484,8.82910156 9.57861328,8.74316406 9.34228516,8.74316406 C8.86962891,8.74316406 8.48291016,9.11914062 8.48291016,9.59179688 C8.48291016,9.828125 8.57958984,10.0322266 8.74072266,10.1933594 L11.8022461,13.2548828 L8.74072266,16.3056641 C8.57958984,16.4775391 8.48291016,16.6708984 8.48291016,16.9179688 C8.48291016,17.4013672 8.86962891,17.7880859 9.34228516,17.7880859 C9.60009766,17.7880859 9.80419922,17.6806641 9.96533203,17.5195312 Z" transform="translate(-1 -1)"/></svg>',
    xRectFill: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M6.48486328,23.1376953 L19.5151367,23.1376953 C21.7709961,23.1376953 22.8881836,22.03125 22.8881836,19.8183594 L22.8881836,6.69140625 C22.8881836,4.47851562 21.7709961,3.36132812 19.5151367,3.36132812 L6.48486328,3.36132812 C4.23974609,3.36132812 3.11181641,4.47851562 3.11181641,6.69140625 L3.11181641,19.8183594 C3.11181641,22.03125 4.23974609,23.1376953 6.48486328,23.1376953 Z M9.39599609,17.7558594 C8.90185547,17.7558594 8.51513672,17.3583984 8.51513672,16.8642578 C8.51513672,16.6279297 8.60107422,16.4023438 8.77294922,16.2412109 L11.7485352,13.2548828 L8.77294922,10.2792969 C8.60107422,10.1074219 8.51513672,9.89257812 8.51513672,9.65625 C8.51513672,9.15136719 8.90185547,8.77539062 9.39599609,8.77539062 C9.64306641,8.77539062 9.83642578,8.86132812 10.0083008,9.02246094 L13.0053711,12.0087891 L16.0239258,9.01171875 C16.206543,8.82910156 16.4106445,8.75390625 16.6362305,8.75390625 C17.1303711,8.75390625 17.527832,9.140625 17.527832,9.63476562 C17.527832,9.88183594 17.4526367,10.0751953 17.2700195,10.2685547 L14.2729492,13.2548828 L17.2592773,16.2304688 C17.4311523,16.3916016 17.5170898,16.6171875 17.5170898,16.8642578 C17.5170898,17.3583984 17.1196289,17.7558594 16.6147461,17.7558594 C16.378418,17.7558594 16.1420898,17.6699219 15.980957,17.4980469 L13.0053711,14.5117188 L10.0405273,17.4980469 C9.86865234,17.6699219 9.64306641,17.7558594 9.39599609,17.7558594 Z" transform="translate(-1 -1)"/></svg>',
    news: '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="24" viewBox="0 0 26 24"><path d="M2.73925781,21.515625 C2.73925781,23.6533203 3.80273438,24.7597656 5.98339844,24.7597656 L23.7939453,24.7597656 C26.0498047,24.7597656 27.1669922,23.6533203 27.1669922,21.4404297 L27.1669922,5.05859375 C27.1669922,2.84570313 26.0498047,1.72851562 23.7939453,1.72851562 L10.8496094,1.72851562 C8.60449219,1.72851562 7.4765625,2.84570313 7.4765625,5.05859375 L7.4765625,10.1826172 L4.90917969,10.1826172 C3.54492187,10.1826172 2.73925781,10.9238281 2.73925781,12.2021484 L2.73925781,21.515625 Z M8.84082031,23.0302734 C9.07714844,22.5683594 9.20605469,22.03125 9.20605469,21.4082031 L9.20605469,5.15527344 C9.20605469,4.03808594 9.80761719,3.45800781 10.8818359,3.45800781 L23.7617187,3.45800781 C24.8359375,3.45800781 25.4375,4.03808594 25.4375,5.15527344 L25.4375,21.34375 C25.4375,22.4609375 24.8359375,23.0302734 23.7617187,23.0302734 L8.84082031,23.0302734 Z M11.9990234,8.13085938 L22.6660156,8.13085938 C23.0419922,8.13085938 23.3320312,7.83007812 23.3320312,7.45410156 C23.3320312,7.08886719 23.0419922,6.80957031 22.6660156,6.80957031 L11.9990234,6.80957031 C11.6123047,6.80957031 11.3222656,7.08886719 11.3222656,7.45410156 C11.3222656,7.83007812 11.6123047,8.13085938 11.9990234,8.13085938 Z M11.9990234,11.9121094 L22.6660156,11.9121094 C23.0419922,11.9121094 23.3320312,11.6220703 23.3320312,11.2568359 C23.3320312,10.8808594 23.0419922,10.5908203 22.6660156,10.5908203 L11.9990234,10.5908203 C11.6123047,10.5908203 11.3222656,10.8808594 11.3222656,11.2568359 C11.3222656,11.6220703 11.6123047,11.9121094 11.9990234,11.9121094 Z M4.46875,21.515625 L4.46875,12.5351562 C4.46875,12.1376953 4.70507812,11.9121094 5.10253906,11.9121094 L7.4765625,11.9121094 L7.4765625,21.515625 C7.4765625,22.4072266 6.82128906,23.0302734 5.98339844,23.0302734 C5.13476562,23.0302734 4.46875,22.375 4.46875,21.515625 Z M12.6328125,19.5712891 L15.4150391,19.5712891 C16.2314453,19.5712891 16.7255859,19.0771484 16.7255859,18.2607422 L16.7255859,15.7041016 C16.7255859,14.8769531 16.2314453,14.3828125 15.4150391,14.3828125 L12.6328125,14.3828125 C11.8056641,14.3828125 11.3115234,14.8769531 11.3115234,15.7041016 L11.3115234,18.2607422 C11.3115234,19.0771484 11.8056641,19.5712891 12.6328125,19.5712891 Z M18.6591797,15.7041016 L22.6552734,15.7041016 C23.0419922,15.7041016 23.3212891,15.4248047 23.3212891,15.0595703 C23.3212891,14.6728516 23.0419922,14.3828125 22.6552734,14.3828125 L18.6591797,14.3828125 C18.2724609,14.3828125 17.9931641,14.6728516 17.9931641,15.0595703 C17.9931641,15.4248047 18.2724609,15.7041016 18.6591797,15.7041016 Z M18.6591797,19.5712891 L22.6552734,19.5712891 C23.0419922,19.5712891 23.3212891,19.2919922 23.3212891,18.9267578 C23.3212891,18.5507812 23.0419922,18.25 22.6552734,18.25 L18.6591797,18.25 C18.2724609,18.25 17.9931641,18.5507812 17.9931641,18.9267578 C17.9931641,19.2919922 18.2724609,19.5712891 18.6591797,19.5712891 Z" transform="translate(-2 -1)"/></svg>',
    arrowsDiagonal: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M9.60758414,13.4331784 L6.83365836,13.4795651 L4.44938102,13.665112 L6.13785758,12.1992917 L14.9049474,3.42292451 C15.2389318,3.08894014 15.2482091,2.59724092 14.9049474,2.2539792 C14.5616857,1.91071748 14.0607091,1.91999482 13.7267248,2.2539792 L4.95963493,11.021069 L3.49381461,12.6817136 L3.67936149,10.3159909 L3.72574821,7.53278779 C3.72574821,7.31940889 3.65152946,7.13386201 3.48453727,6.96686982 C3.14127555,6.6236081 2.66813102,6.6236081 2.31559196,6.96686982 C2.16715446,7.11530732 2.07438102,7.35651826 2.07438102,7.57917451 L2.00016227,14.2774167 C1.99088493,14.7876706 2.38053336,15.1680417 2.88150993,15.1587644 L9.57047477,15.0752683 C9.80240836,15.0752683 10.0436193,14.9824948 10.1920568,14.8433347 C10.5353185,14.4815183 10.5353185,14.0176511 10.1920568,13.6743894 C10.0250646,13.4981198 9.83951774,13.4331784 9.60758414,13.4331784 Z M21.0558263,17.255444 C21.0558263,17.4781003 21.1300451,17.6543698 21.2970373,17.8306394 C21.640299,18.1739011 22.1134435,18.1739011 22.4659826,17.8306394 C22.6051427,17.6822019 22.6979162,17.4409909 22.6979162,17.2090573 L22.7814123,10.5200925 C22.7906896,10.0098386 22.4195959,9.62946748 21.9000646,9.63874482 L15.2110998,9.71296357 C14.9791662,9.71296357 14.7379552,9.80573701 14.5895177,9.95417451 C14.246256,10.3067136 14.246256,10.7798581 14.5895177,11.1231198 C14.7565099,11.290112 14.9420568,11.3643308 15.1739904,11.3643308 L17.9386388,11.317944 L20.3136388,11.1231198 L18.643717,12.5982175 L9.87662711,21.3653073 C9.54264274,21.6992917 9.53336539,22.2002683 9.87662711,22.54353 C10.2198888,22.8775144 10.7208654,22.8775144 11.0548498,22.54353 L19.8219396,13.7764401 L21.2877599,12.0879636 L21.1022131,14.4722409 L21.0558263,17.255444 Z"/></svg>',
    sfPlus: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M3.95605469,12.8183594 L10.90625,12.8183594 L10.90625,19.7685547 C10.90625,20.2841797 11.3359375,20.7246094 11.8623047,20.7246094 C12.3886719,20.7246094 12.8291016,20.2841797 12.8291016,19.7685547 L12.8291016,12.8183594 L19.7685547,12.8183594 C20.2841797,12.8183594 20.7246094,12.3886719 20.7246094,11.8623047 C20.7246094,11.3359375 20.2841797,10.8955078 19.7685547,10.8955078 L12.8291016,10.8955078 L12.8291016,3.95605469 C12.8291016,3.44042969 12.3886719,3 11.8623047,3 C11.3359375,3 10.90625,3.44042969 10.90625,3.95605469 L10.90625,10.8955078 L3.95605469,10.8955078 C3.44042969,10.8955078 3,11.3359375 3,11.8623047 C3,12.3886719 3.44042969,12.8183594 3.95605469,12.8183594 Z"/></svg>',
    sfRefresh: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12.4853516,23.0742188 C17.7275391,23.0742188 21.9707031,18.8310547 21.9707031,13.578125 C21.9707031,13.1054688 21.5839844,12.71875 21.1113281,12.71875 C20.6386719,12.71875 20.2412109,13.1054688 20.2412109,13.578125 C20.2412109,17.8642578 16.7714844,21.3339844 12.4853516,21.3339844 C8.19921875,21.3339844 4.72949219,17.8642578 4.72949219,13.578125 C4.72949219,9.29199219 8.19921875,5.82226562 12.4853516,5.82226562 C13.2373047,5.82226562 13.9677734,5.9296875 14.6552734,6.13378906 L11.4970703,9.27050781 C11.3144531,9.43164062 11.25,9.64648438 11.25,9.87207031 C11.25,10.3662109 11.6152344,10.7421875 12.0878906,10.7421875 C12.3564453,10.7421875 12.5498047,10.6455078 12.7109375,10.4951172 L17.1367188,6.04785156 C17.3300781,5.85449219 17.4160156,5.63964844 17.4160156,5.40332031 C17.4160156,5.16699219 17.3193359,4.93066406 17.1367188,4.75878906 L12.7216797,0.268554688 C12.5498047,0.107421875 12.3564453,0 12.0878906,0 C11.6152344,0 11.25,0.397460938 11.25,0.880859375 C11.25,1.10644531 11.3144531,1.34277344 11.4863281,1.50390625 L14.2792969,4.27539062 C13.6992188,4.16796875 13.0976562,4.10351562 12.4853516,4.10351562 C7.24316406,4.10351562 3,8.34667969 3,13.5888672 C3,18.8310547 7.24316406,23.0742188 12.4853516,23.0742188 Z"/></svg>',
    sfRefreshCircle: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M11.9570312,22.9140625 C18.0048828,22.9140625 22.9140625,18.0048828 22.9140625,11.9570312 C22.9140625,5.90917969 18.0048828,1 11.9570312,1 C5.90917969,1 1,5.90917969 1,11.9570312 C1,18.0048828 5.90917969,22.9140625 11.9570312,22.9140625 Z M11.9570312,21.0878906 C6.90820312,21.0878906 2.82617188,17.0058594 2.82617188,11.9570312 C2.82617188,6.90820312 6.90820312,2.82617188 11.9570312,2.82617188 C17.0058594,2.82617188 21.0878906,6.90820312 21.0878906,11.9570312 C21.0878906,17.0058594 17.0058594,21.0878906 11.9570312,21.0878906 Z M11.9462891,17.2851562 C14.5996094,17.2851562 16.7373047,15.1367188 16.7373047,12.4833984 C16.7373047,12.0859375 16.3935547,11.7529297 15.9960938,11.7529297 C15.5986328,11.7529297 15.2548828,12.0859375 15.2548828,12.4833984 C15.2548828,14.3203125 13.7832031,15.8027344 11.9462891,15.8027344 C10.109375,15.8027344 8.63769531,14.3310547 8.63769531,12.4833984 C8.63769531,10.6464844 10.109375,9.17480469 11.9462891,9.17480469 C12.0859375,9.17480469 12.2148438,9.17480469 12.34375,9.17480469 L11.2910156,10.2060547 C11.1621094,10.3349609 11.0869141,10.5068359 11.0869141,10.7001953 C11.0869141,11.0761719 11.3876953,11.3769531 11.7636719,11.3769531 C11.9462891,11.3769531 12.1289062,11.2910156 12.2363281,11.1728516 L14.3203125,9.08886719 C14.4492188,8.97070312 14.5136719,8.78808594 14.5136719,8.60546875 C14.5136719,8.42285156 14.4492188,8.24023438 14.3203125,8.12207031 L12.2363281,6.03808594 C12.1396484,5.93066406 11.9462891,5.83398438 11.7636719,5.83398438 C11.3876953,5.83398438 11.0869141,6.13476562 11.0869141,6.51074219 C11.0869141,6.70410156 11.1621094,6.87597656 11.2910156,7.00488281 L12.0429688,7.74609375 C11.9462891,7.73535156 11.8388672,7.73535156 11.7421875,7.73535156 C9.32519531,7.73535156 7.15527344,9.80859375 7.15527344,12.4511719 C7.15527344,15.1367188 9.29296875,17.2851562 11.9462891,17.2851562 Z"/></svg>',
    sfRefreshCircleFill: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M11.9570312,22.9140625 C18.0048828,22.9140625 22.9140625,18.0048828 22.9140625,11.9570312 C22.9140625,5.91992188 18.0048828,1 11.9570312,1 C5.91992188,1 1,5.91992188 1,11.9570312 C1,18.0048828 5.91992188,22.9140625 11.9570312,22.9140625 Z M11.9570312,17.4570312 C9.21777344,17.4570312 7.015625,15.2333984 7.015625,12.4619141 C7.015625,9.74414062 9.25,7.60644531 11.7421875,7.60644531 C11.8388672,7.60644531 11.9355469,7.60644531 12.0537109,7.6171875 L11.2802734,6.86523438 C11.1621094,6.73632812 11.0654297,6.55371094 11.0654297,6.33886719 C11.0654297,5.95214844 11.3769531,5.65136719 11.7744141,5.65136719 C11.9570312,5.65136719 12.171875,5.76953125 12.2578125,5.85546875 L14.40625,8.00390625 C14.5458984,8.1328125 14.6103516,8.32617188 14.6103516,8.49804688 C14.6103516,8.69140625 14.5458984,8.87402344 14.40625,9.01367188 L12.2578125,11.1621094 C12.1611328,11.2587891 11.9570312,11.3554688 11.7744141,11.3554688 C11.3769531,11.3554688 11.0654297,11.0546875 11.0654297,10.6679688 C11.0654297,10.453125 11.1513672,10.2919922 11.2802734,10.1416016 L12.3222656,9.12109375 C12.2363281,9.09960938 12.1074219,9.08886719 11.9570312,9.08886719 C10.0664062,9.08886719 8.55175781,10.6035156 8.55175781,12.5048828 C8.55175781,14.40625 10.0664062,15.9316406 11.9570312,15.9316406 C13.8476562,15.9316406 15.3623047,14.40625 15.3623047,12.5048828 C15.3623047,12.0859375 15.7167969,11.7421875 16.1357422,11.7421875 C16.5439453,11.7421875 16.8984375,12.0859375 16.8984375,12.5048828 C16.8984375,15.2333984 14.6962891,17.4570312 11.9570312,17.4570312 Z"/></svg>',
    sfRefreshRect: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M5.37304688,21.7763672 L18.4033203,21.7763672 C20.6591797,21.7763672 21.7763672,20.6699219 21.7763672,18.4570312 L21.7763672,5.33007812 C21.7763672,3.1171875 20.6591797,2 18.4033203,2 L5.37304688,2 C3.12792969,2 2,3.1171875 2,5.33007812 L2,18.4570312 C2,20.6699219 3.12792969,21.7763672 5.37304688,21.7763672 Z M5.39453125,20.046875 C4.3203125,20.046875 3.72949219,19.4775391 3.72949219,18.3603516 L3.72949219,5.42675781 C3.72949219,4.30957031 4.3203125,3.72949219 5.39453125,3.72949219 L18.3818359,3.72949219 C19.4453125,3.72949219 20.046875,4.30957031 20.046875,5.42675781 L20.046875,18.3603516 C20.046875,19.4775391 19.4453125,20.046875 18.3818359,20.046875 L5.39453125,20.046875 Z M11.8935547,17.2109375 C14.546875,17.2109375 16.6845703,15.0625 16.6845703,12.4091797 C16.6845703,12.0117188 16.3408203,11.6787109 15.9433594,11.6787109 C15.5458984,11.6787109 15.2021484,12.0117188 15.2021484,12.4091797 C15.2021484,14.2460938 13.7304688,15.7285156 11.8935547,15.7285156 C10.0566406,15.7285156 8.58496094,14.2568359 8.58496094,12.4091797 C8.58496094,10.5722656 10.0566406,9.10058594 11.8935547,9.10058594 C12.0332031,9.10058594 12.1621094,9.10058594 12.2910156,9.10058594 L11.2382812,10.1318359 C11.109375,10.2607422 11.0341797,10.4326172 11.0341797,10.6259766 C11.0341797,11.0019531 11.3349609,11.3027344 11.7109375,11.3027344 C11.8935547,11.3027344 12.0761719,11.2167969 12.1835938,11.0986328 L14.2675781,9.01464844 C14.4072266,8.89648438 14.4609375,8.71386719 14.4609375,8.53125 C14.4609375,8.34863281 14.4072266,8.16601562 14.2675781,8.04785156 L12.1835938,5.96386719 C12.0869141,5.85644531 11.8935547,5.75976562 11.7109375,5.75976562 C11.3349609,5.75976562 11.0341797,6.06054688 11.0341797,6.43652344 C11.0341797,6.62988281 11.109375,6.80175781 11.2382812,6.93066406 L11.9902344,7.671875 C11.8935547,7.66113281 11.796875,7.66113281 11.6894531,7.66113281 C9.27246094,7.66113281 7.10253906,9.734375 7.10253906,12.3769531 C7.10253906,15.0625 9.24023438,17.2109375 11.8935547,17.2109375 Z"/></svg>',
    sfRefreshRectFill: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M5.37304688,21.7763672 L18.4033203,21.7763672 C20.6591797,21.7763672 21.7763672,20.6699219 21.7763672,18.4570312 L21.7763672,5.33007812 C21.7763672,3.1171875 20.6591797,2 18.4033203,2 L5.37304688,2 C3.12792969,2 2,3.1171875 2,5.33007812 L2,18.4570312 C2,20.6699219 3.12792969,21.7763672 5.37304688,21.7763672 Z M11.8935547,17.3828125 C9.15429688,17.3828125 6.95214844,15.1591797 6.95214844,12.3876953 C6.95214844,9.66992188 9.18652344,7.52148438 11.6787109,7.52148438 C11.7753906,7.52148438 11.8720703,7.53222656 11.9902344,7.54296875 L11.2167969,6.78027344 C11.0986328,6.66210938 11.0019531,6.46875 11.0019531,6.26464844 C11.0019531,5.87792969 11.3134766,5.56640625 11.7109375,5.56640625 C11.8935547,5.56640625 12.1083984,5.68457031 12.1943359,5.78125 L14.3427734,7.9296875 C14.4931641,8.04785156 14.546875,8.24121094 14.546875,8.42382812 C14.546875,8.6171875 14.4931641,8.79980469 14.3427734,8.92871094 L12.1943359,11.0771484 C12.0976562,11.1845703 11.8935547,11.28125 11.7109375,11.28125 C11.3134766,11.28125 11.0019531,10.9697266 11.0019531,10.5830078 C11.0019531,10.3789062 11.0878906,10.2070312 11.2167969,10.0673828 L12.2587891,9.046875 C12.1728516,9.02539062 12.0439453,9.01464844 11.8935547,9.01464844 C10.0029297,9.01464844 8.48828125,10.5292969 8.48828125,12.4306641 C8.48828125,14.3320312 10.0029297,15.8466797 11.8935547,15.8466797 C13.7841797,15.8466797 15.2988281,14.3212891 15.2988281,12.4306641 C15.2988281,12.0117188 15.6533203,11.6679688 16.0722656,11.6679688 C16.4804688,11.6679688 16.8349609,12.0117188 16.8349609,12.4306641 C16.8349609,15.1591797 14.6328125,17.3828125 11.8935547,17.3828125 Z"/></svg>',
    arrowCompactLeft: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12.6391602,21.1064453 C12.800293,21.5253906 13.1655273,21.7939453 13.5522461,21.7939453 C14.1860352,21.7939453 14.6694336,21.3320312 14.6694336,20.6982422 C14.6694336,20.3759766 14.4868164,19.9570312 14.3793945,19.6777344 L11.4467773,12.2119141 L14.3793945,4.74609375 C14.4868164,4.46679688 14.6694336,4.03710938 14.6694336,3.72558594 C14.6694336,3.10253906 14.1860352,2.640625 13.5522461,2.640625 C13.1655273,2.640625 12.800293,2.8984375 12.6391602,3.31738281 L9.76025391,10.6435547 C9.56689453,11.1376953 9.33056641,11.7392578 9.33056641,12.2119141 C9.33056641,12.6845703 9.56689453,13.2861328 9.76025391,13.7802734 L12.6391602,21.1064453 Z"/></svg>',
    arrowCompactRight: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M11.3608398,21.1064453 L14.2397461,13.7802734 C14.4331055,13.2861328 14.6694336,12.6845703 14.6694336,12.2119141 C14.6694336,11.7392578 14.4331055,11.1376953 14.2397461,10.6435547 L11.3608398,3.31738281 C11.199707,2.8984375 10.8344727,2.640625 10.4370117,2.640625 C9.80322266,2.640625 9.33056641,3.10253906 9.33056641,3.72558594 C9.33056641,4.03710938 9.51318359,4.46679688 9.60986328,4.74609375 L12.5424805,12.2119141 L9.60986328,19.6777344 C9.51318359,19.9570312 9.33056641,20.3759766 9.33056641,20.6982422 C9.33056641,21.3320312 9.80322266,21.7939453 10.4370117,21.7939453 C10.8344727,21.7939453 11.199707,21.5253906 11.3608398,21.1064453 Z"/></svg>',
    boxFilledLeft: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M5.48486328,22.1376953 L18.5151367,22.1376953 C20.7709961,22.1376953 21.8881836,21.03125 21.8881836,18.8183594 L21.8881836,5.69140625 C21.8881836,3.47851562 20.7709961,2.36132812 18.5151367,2.36132812 L5.48486328,2.36132812 C3.23974609,2.36132812 2.11181641,3.47851562 2.11181641,5.69140625 L2.11181641,18.8183594 C2.11181641,21.03125 3.23974609,22.1376953 5.48486328,22.1376953 Z M5.50634766,20.4082031 C4.43212891,20.4082031 3.84130859,19.8388672 3.84130859,18.7216797 L3.84130859,5.78808594 C3.84130859,4.67089844 4.43212891,4.09082031 5.50634766,4.09082031 L18.4936523,4.09082031 C19.5571289,4.09082031 20.1586914,4.67089844 20.1586914,5.78808594 L20.1586914,18.7216797 C20.1586914,19.8388672 19.5571289,20.4082031 18.4936523,20.4082031 L5.50634766,20.4082031 Z M15.3891602,18.9472656 L17.730957,18.9472656 C18.418457,18.9472656 18.6977539,18.6787109 18.6977539,18.0126953 L18.6977539,6.5078125 C18.6977539,5.83105469 18.418457,5.5625 17.730957,5.5625 L15.3891602,5.5625 C14.7016602,5.5625 14.4223633,5.83105469 14.4223633,6.5078125 L14.4223633,18.0126953 C14.4223633,18.6787109 14.7016602,18.9472656 15.3891602,18.9472656 Z" transform="matrix(-1 0 0 1 24 0)"/></svg>',
    boxFilledRight: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M5.48486328,22.1376953 L18.5151367,22.1376953 C20.7709961,22.1376953 21.8881836,21.03125 21.8881836,18.8183594 L21.8881836,5.69140625 C21.8881836,3.47851562 20.7709961,2.36132812 18.5151367,2.36132812 L5.48486328,2.36132812 C3.23974609,2.36132812 2.11181641,3.47851562 2.11181641,5.69140625 L2.11181641,18.8183594 C2.11181641,21.03125 3.23974609,22.1376953 5.48486328,22.1376953 Z M5.50634766,20.4082031 C4.43212891,20.4082031 3.84130859,19.8388672 3.84130859,18.7216797 L3.84130859,5.78808594 C3.84130859,4.67089844 4.43212891,4.09082031 5.50634766,4.09082031 L18.4936523,4.09082031 C19.5571289,4.09082031 20.1586914,4.67089844 20.1586914,5.78808594 L20.1586914,18.7216797 C20.1586914,19.8388672 19.5571289,20.4082031 18.4936523,20.4082031 L5.50634766,20.4082031 Z M15.3891602,18.9472656 L17.730957,18.9472656 C18.418457,18.9472656 18.6977539,18.6787109 18.6977539,18.0126953 L18.6977539,6.5078125 C18.6977539,5.83105469 18.418457,5.5625 17.730957,5.5625 L15.3891602,5.5625 C14.7016602,5.5625 14.4223633,5.83105469 14.4223633,6.5078125 L14.4223633,18.0126953 C14.4223633,18.6787109 14.7016602,18.9472656 15.3891602,18.9472656 Z"/></svg>',
    boxHalfFilledLeft: '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="24" viewBox="0 0 26 24"><path d="M2.70800781,22.1376953 L21.2919922,22.1376953 C23.5478516,22.1376953 24.6650391,21.03125 24.6650391,18.8183594 L24.6650391,5.69140625 C24.6650391,3.47851562 23.5478516,2.36132812 21.2919922,2.36132812 L2.70800781,2.36132812 C0.462890625,2.36132812 -0.665039062,3.47851562 -0.665039062,5.69140625 L-0.665039062,18.8183594 C-0.665039062,21.03125 0.462890625,22.1376953 2.70800781,22.1376953 Z M2.72949219,20.4082031 C1.65527344,20.4082031 1.06445312,19.8388672 1.06445312,18.7216797 L1.06445312,5.78808594 C1.06445312,4.67089844 1.65527344,4.09082031 2.72949219,4.09082031 L21.2705078,4.09082031 C22.3339844,4.09082031 22.9355469,4.67089844 22.9355469,5.78808594 L22.9355469,18.7216797 C22.9355469,19.8388672 22.3339844,20.4082031 21.2705078,20.4082031 L2.72949219,20.4082031 Z M12.9238281,18.9472656 L20.5292969,18.9472656 C21.2060547,18.9472656 21.4746094,18.6679688 21.4746094,17.9804688 L21.4746094,6.52929688 C21.4746094,5.84179688 21.2060547,5.5625 20.5292969,5.5625 L12.9238281,5.5625 C12.2470703,5.5625 11.9785156,5.84179688 11.9785156,6.52929688 L11.9785156,17.9804688 C11.9785156,18.6679688 12.2470703,18.9472656 12.9238281,18.9472656 Z" transform="matrix(-1 0 0 1 25 0)"/></svg>',
    sidebarRightFill: '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="24" viewBox="0 0 26 24"><path d="M20.4003906,2.36132812 C23.1074219,2.36132812 24.6650391,4.00488281 24.6650391,6.90527344 L24.6650391,17.6044922 C24.6650391,20.5048828 23.1074219,22.1376953 20.4003906,22.1376953 L3.86816406,22.1376953 C0.978515625,22.1376953 -0.665039062,20.5048828 -0.665039062,17.6044922 L-0.665039062,6.90527344 C-0.665039062,4.00488281 0.978515625,2.36132812 3.86816406,2.36132812 Z M20.1210938,4.09082031 L9.20703125,4.09082031 L9.20703125,20.4082031 L20.1210938,20.4082031 C21.9042969,20.4082031 22.9355469,19.3876953 22.9355469,17.6044922 L22.9355469,6.90527344 C22.9355469,5.12207031 21.9042969,4.09082031 20.1210938,4.09082031 Z M5.91113281,12.4482422 L2.6015625,12.4482422 C2.27929688,12.4482422 2,12.7275391 2,13.0498047 C2,13.3720703 2.27929688,13.640625 2.6015625,13.640625 L5.91113281,13.640625 C6.23339844,13.640625 6.5234375,13.3720703 6.5234375,13.0498047 C6.5234375,12.7275391 6.23339844,12.4482422 5.91113281,12.4482422 Z M5.91113281,9.66601562 L2.6015625,9.66601562 C2.27929688,9.66601562 2,9.93457031 2,10.2568359 C2,10.5791016 2.27929688,10.8691406 2.6015625,10.8691406 L5.91113281,10.8691406 C6.23339844,10.8691406 6.5234375,10.5791016 6.5234375,10.2568359 C6.5234375,9.93457031 6.23339844,9.66601562 5.91113281,9.66601562 Z M5.91113281,6.88378906 L2.6015625,6.88378906 C2.27929688,6.88378906 2,7.16308594 2,7.48535156 C2,7.796875 2.27929688,8.08691406 2.6015625,8.08691406 L5.91113281,8.08691406 C6.23339844,8.08691406 6.5234375,7.796875 6.5234375,7.48535156 C6.5234375,7.16308594 6.23339844,6.88378906 5.91113281,6.88378906 Z" transform="matrix(-1 0 0 1 25 0)"/></svg>',
    sidebarLeft: '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="24" viewBox="0 0 26 24"><path d="M3.86816406,22.1376953 L20.4003906,22.1376953 C23.1074219,22.1376953 24.6650391,20.5048828 24.6650391,17.6044922 L24.6650391,6.90527344 C24.6650391,4.00488281 23.1074219,2.36132812 20.4003906,2.36132812 L3.86816406,2.36132812 C0.978515625,2.36132812 -0.665039062,4.00488281 -0.665039062,6.90527344 L-0.665039062,17.6044922 C-0.665039062,20.5048828 0.978515625,22.1376953 3.86816406,22.1376953 Z M3.87890625,20.4082031 C2.09570313,20.4082031 1.06445312,19.3876953 1.06445312,17.6044922 L1.06445312,6.90527344 C1.06445312,5.12207031 2.09570313,4.09082031 3.87890625,4.09082031 L7.52050781,4.09082031 L7.52050781,20.4082031 L3.87890625,20.4082031 Z M20.1210938,4.09082031 C21.9042969,4.09082031 22.9355469,5.12207031 22.9355469,6.90527344 L22.9355469,17.6044922 C22.9355469,19.3876953 21.9042969,20.4082031 20.1210938,20.4082031 L9.20703125,20.4082031 L9.20703125,4.09082031 L20.1210938,4.09082031 Z M5.45800781,8.08691406 C5.78027344,8.08691406 6.0703125,7.796875 6.0703125,7.48535156 C6.0703125,7.16308594 5.78027344,6.88378906 5.45800781,6.88378906 L3.1484375,6.88378906 C2.82617188,6.88378906 2.546875,7.16308594 2.546875,7.48535156 C2.546875,7.796875 2.82617188,8.08691406 3.1484375,8.08691406 L5.45800781,8.08691406 Z M5.45800781,10.8691406 C5.78027344,10.8691406 6.0703125,10.5791016 6.0703125,10.2568359 C6.0703125,9.93457031 5.78027344,9.66601562 5.45800781,9.66601562 L3.1484375,9.66601562 C2.82617188,9.66601562 2.546875,9.93457031 2.546875,10.2568359 C2.546875,10.5791016 2.82617188,10.8691406 3.1484375,10.8691406 L5.45800781,10.8691406 Z M5.45800781,13.640625 C5.78027344,13.640625 6.0703125,13.3720703 6.0703125,13.0498047 C6.0703125,12.7275391 5.78027344,12.4482422 5.45800781,12.4482422 L3.1484375,12.4482422 C2.82617188,12.4482422 2.546875,12.7275391 2.546875,13.0498047 C2.546875,13.3720703 2.82617188,13.640625 3.1484375,13.640625 L5.45800781,13.640625 Z" transform="translate(1)"/></svg>',
    sidebarLeftFill: '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="24" viewBox="0 0 26 24"><path d="M20.4003906,2.36132812 C23.1074219,2.36132812 24.6650391,4.00488281 24.6650391,6.90527344 L24.6650391,17.6044922 C24.6650391,20.5048828 23.1074219,22.1376953 20.4003906,22.1376953 L3.86816406,22.1376953 C0.978515625,22.1376953 -0.665039062,20.5048828 -0.665039062,17.6044922 L-0.665039062,6.90527344 C-0.665039062,4.00488281 0.978515625,2.36132812 3.86816406,2.36132812 Z M20.1210938,4.09082031 L9.20703125,4.09082031 L9.20703125,20.4082031 L20.1210938,20.4082031 C21.9042969,20.4082031 22.9355469,19.3876953 22.9355469,17.6044922 L22.9355469,6.90527344 C22.9355469,5.12207031 21.9042969,4.09082031 20.1210938,4.09082031 Z M5.81113281,12.4482422 L2.5015625,12.4482422 C2.17929687,12.4482422 1.9,12.7275391 1.9,13.0498047 C1.9,13.3720703 2.17929687,13.640625 2.5015625,13.640625 L5.81113281,13.640625 C6.13339844,13.640625 6.4234375,13.3720703 6.4234375,13.0498047 C6.4234375,12.7275391 6.13339844,12.4482422 5.81113281,12.4482422 Z M5.81113281,9.66601562 L2.5015625,9.66601562 C2.17929687,9.66601562 1.9,9.93457031 1.9,10.2568359 C1.9,10.5791016 2.17929687,10.8691406 2.5015625,10.8691406 L5.81113281,10.8691406 C6.13339844,10.8691406 6.4234375,10.5791016 6.4234375,10.2568359 C6.4234375,9.93457031 6.13339844,9.66601562 5.81113281,9.66601562 Z M5.81113281,6.88378906 L2.5015625,6.88378906 C2.17929687,6.88378906 1.9,7.16308594 1.9,7.48535156 C1.9,7.796875 2.17929687,8.08691406 2.5015625,8.08691406 L5.81113281,8.08691406 C6.13339844,8.08691406 6.4234375,7.796875 6.4234375,7.48535156 C6.4234375,7.16308594 6.13339844,6.88378906 5.81113281,6.88378906 Z" transform="translate(1)"/></svg>',
    xcom: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" id="Twitter-X--Streamline-Bootstrap" height="16" width="16">
  <path d="M12.6 0.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867 -5.07 -4.425 5.07H0.316l5.733 -6.57L0 0.75h5.063l3.495 4.633L12.601 0.75Zm-0.86 13.028h1.36L4.323 2.145H2.865z" stroke-width="1"></path>
</svg>`,
    bell: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>'
};

});

parcelRegister("e3EsD", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3c0bb31906dfa1a$export$2e2bcd8739ae039);
var $a3c0bb31906dfa1a$export$2e2bcd8739ae039 = {};

});

parcelRegister("bwsBv", function(module, exports) {

$parcel$export(module.exports, "default", () => $8638df07d5bbace9$export$2e2bcd8739ae039);
var $8638df07d5bbace9$export$2e2bcd8739ae039 = {
    html: {
        overflow: 'hidden',
        maxWidth: '100dvw',
        minWidth: '320px',
        minHeight: '100dvh',
        height: 'auto',
        transform: 'none',
        overscrollBehavior: 'none'
    },
    body: {
        transform: 'none',
        overscrollBehavior: 'none',
        minHeight: '100dvh'
    }
};

});

parcelRegister("kQ1hZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2b9a9fff31d509c$export$2e2bcd8739ae039);
var $f2b9a9fff31d509c$export$2e2bcd8739ae039 = {
    dropdownOpen: {
        from: {
            transform: 'translate3d(0, 10%, 0)',
            opacity: 0
        },
        to: {
            transform: 'translate3d(0, 0, 0)',
            opacity: 1
        }
    },
    modalIn: {
        from: {
            transform: 'scale(0.95)',
            opacity: 0
        },
        to: {
            transform: '',
            opacity: 1
        }
    },
    modalInUp: {
        from: {
            transform: 'translate3d(0, 6.5%, 0)',
            opacity: 0
        },
        to: {
            transform: '',
            opacity: 1
        }
    },
    modalInDown: {
        from: {
            transform: 'translate3d(0, -6.5%, 0)',
            opacity: 0
        },
        to: {
            transform: '',
            opacity: 1
        }
    },
    modalOut: {
        to: {
            transform: 'scale(0.95)',
            opacity: 0
        }
    },
    modalOutDown: {
        from: {
            transform: '',
            opacity: 1
        },
        to: {
            transform: 'translate3d(0, 6.5%, 0)',
            opacity: 0
        }
    },
    fadeIn: {
        from: {
            opacity: 0
        },
        to: {
            opacity: 1
        }
    },
    fadeInSlowly: {
        '0%': {
            opacity: 0
        },
        '35%': {
            opacity: 0
        },
        '100%': {
            opacity: 1
        }
    },
    fadeInUp: {
        from: {
            transform: 'translate3d(0, 12.5%, 0)',
            opacity: 0
        },
        to: {
            transform: 'translate3d(0, 0, 0)',
            opacity: 1
        }
    },
    fadeInUpShort: {
        from: {
            transform: 'translate3d(0, 6.5%, 0)',
            opacity: 0
        },
        to: {
            transform: 'translate3d(0, 0, 0)',
            opacity: 1
        }
    },
    fadeInUpLong: {
        from: {
            transform: 'translate3d(0, 45%, 0)',
            opacity: 0
        },
        to: {
            transform: 'translate3d(0, 0, 0)',
            opacity: 1
        }
    },
    fadeInDown: {
        from: {
            transform: 'translate3d(0, -12.5%, 0)',
            opacity: 0
        },
        to: {
            transform: 'translate3d(0, 0, 0)',
            opacity: 1
        }
    },
    fadeInLeft: {
        from: {
            transform: 'translate3d(12.5%, 0, 0)',
            opacity: 0
        },
        to: {
            transform: 'translate3d(0, 0, 0)',
            opacity: 1
        }
    },
    fadeInDownLong: {
        from: {
            transform: 'translate3d(0, -45%, 0)',
            opacity: 0
        },
        to: {
            transform: 'translate3d(0, 0, 0)',
            opacity: 1
        }
    },
    fadeOut: {
        from: {
            opacity: 1
        },
        to: {
            opacity: 0
        }
    },
    fadeOutSlowly: {
        '0%': {
            opacity: 1
        },
        '75%': {
            opacity: 0.75
        },
        '100%': {
            opacity: 0
        }
    },
    fadeOutUp: {
        from: {
            transform: 'translate3d(0, 0, 0)',
            opacity: 1
        },
        to: {
            transform: 'translate3d(0, -12.5%, 0)',
            opacity: 0
        }
    },
    fadeOutUpLong: {
        from: {
            transform: 'translate3d(0, 0, 0)',
            opacity: 1
        },
        to: {
            transform: 'translate3d(0, -45%, 0)',
            opacity: 0
        }
    },
    fadeOutDown: {
        from: {
            transform: 'translate3d(0, 0, 0)',
            opacity: 1
        },
        to: {
            transform: 'translate3d(0, 12.5%, 0)',
            opacity: 0
        }
    },
    slideInOut: {
        '0%': {
            transform: 'translate3d(0, 50%, 0)',
            opacity: 0
        },
        '15%': {
            transform: 'translate3d(0, -50%, 0)',
            opacity: 1
        },
        '85%': {
            transform: 'translate3d(0, -50%, 0)',
            opacity: 1
        },
        '100%': {
            transform: 'translate3d(0, -150%, 0)',
            opacity: 0
        }
    },
    scaleOutIn: {
        from: {
            transform: 'scale(1.2)',
            opacity: '0'
        },
        to: {
            transform: 'scale(1)',
            opacity: '1'
        }
    },
    scaleInOut: {
        from: {
            transform: 'scale(1)',
            opacity: '1'
        },
        to: {
            transform: 'scale(1.2)',
            opacity: '0'
        }
    },
    overflowVisibleSlowly: {
        '0%': {
            overflow: 'hidden'
        },
        '35%': {
            overflow: 'hidden'
        },
        '100%': {
            overflow: 'visible'
        }
    },
    overflowHiddenSlowly: {
        '0%': {
            overflow: 'visible'
        },
        '75%': {
            overflow: 'hidden'
        },
        '100%': {
            overflow: 'hidden'
        }
    },
    rotate: {
        from: {
            transform: 'rotate(0deg)'
        },
        to: {
            transform: 'rotate(360deg)'
        }
    },
    blinking: {
        '0%': {
            opacity: 1
        },
        '50%': {
            opacity: 0
        },
        '100%': {
            opacity: 1
        }
    }
};

});

parcelRegister("1OYaQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $153923441e98d397$export$2e2bcd8739ae039);
var $153923441e98d397$export$2e2bcd8739ae039 = {
    tv: '(min-width: 2780px)',
    screenL: '(max-width: 1920px)',
    'screenL<': '(min-width: 1920px)',
    screenM: '(max-width: 1680px)',
    'screenM<': '(min-width: 1680px)',
    screenS: '(max-width: 1440px)',
    'screenS<': '(min-width: 1440px)',
    tabletL: '(max-width: 1366px)',
    'tabletL<': '(min-width: 1366px)',
    tabletM: '(max-width: 1280px)',
    'tabletM<': '(min-width: 1280px)',
    tabletS: '(max-width: 1024px)',
    'tabletS<': '(min-width: 1024px)',
    mobileL: '(max-width: 768px)',
    'mobileL<': '(min-width: 768px)',
    mobileM: '(max-width: 560px)',
    'mobileM<': '(min-width: 560px)',
    mobileS: '(max-width: 480px)',
    'mobileS<': '(min-width: 480px)',
    mobileXS: '(max-width: 375px)',
    'mobileXS<': '(min-width: 375px)',
    light: '(prefers-color-scheme: light)',
    dark: '(prefers-color-scheme: dark)',
    print: 'print',
    heightXXL: '(max-height: 1440px)',
    heightXL: '(max-height: 1280px)',
    heightL: '(max-height: 1024px)',
    heightM: '(max-height: 900px)',
    heightS: '(max-height: 768px)',
    heightXS: '(max-height: 480px)'
};

});

parcelRegister("972Bb", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a26c8940531a332$export$2e2bcd8739ae039);
var $6a26c8940531a332$export$2e2bcd8739ae039 = {};

});

parcelRegister("hVlzD", function(module, exports) {

$parcel$export(module.exports, "filters", () => $d0c87ea0ddd5024a$export$82462a21aead86ed);
$parcel$export(module.exports, "svgDefs", () => $d0c87ea0ddd5024a$export$53d8590270d12c2d);
$parcel$export(module.exports, "options", () => $d0c87ea0ddd5024a$export$41c562ebe57d11e2);
$parcel$export(module.exports, "default", () => $d0c87ea0ddd5024a$export$2e2bcd8739ae039);
const $d0c87ea0ddd5024a$export$82462a21aead86ed = {
    protanopia: 'url(#a11y-protanopia)',
    deuteranopia: 'url(#a11y-deuteranopia)',
    tritanopia: 'url(#a11y-tritanopia)',
    achromatopsia: 'grayscale(100%)',
    'low-contrast': 'contrast(0.5)',
    'high-contrast': 'contrast(1.75)',
    'low-vision': 'blur(1.5px)',
    inverted: 'invert(100%) hue-rotate(180deg)'
};
const $d0c87ea0ddd5024a$export$53d8590270d12c2d = `
  <defs>
    <filter id="a11y-protanopia">
      <feColorMatrix type="matrix" values="0.567 0.433 0 0 0  0.558 0.442 0 0 0  0 0.242 0.758 0 0  0 0 0 1 0"/>
    </filter>
    <filter id="a11y-deuteranopia">
      <feColorMatrix type="matrix" values="0.625 0.375 0 0 0  0.7 0.3 0 0 0  0 0.3 0.7 0 0  0 0 0 1 0"/>
    </filter>
    <filter id="a11y-tritanopia">
      <feColorMatrix type="matrix" values="0.95 0.05 0 0 0  0 0.433 0.567 0 0  0 0.475 0.525 0 0  0 0 0 1 0"/>
    </filter>
  </defs>
`;
const $d0c87ea0ddd5024a$export$41c562ebe57d11e2 = [
    {
        key: 'none',
        label: 'No filter'
    },
    {
        key: 'protanopia',
        label: 'Protanopia'
    },
    {
        key: 'deuteranopia',
        label: 'Deuteranopia'
    },
    {
        key: 'tritanopia',
        label: 'Tritanopia'
    },
    {
        key: 'achromatopsia',
        label: 'Achromatopsia'
    },
    {
        key: 'low-contrast',
        label: 'Low contrast'
    },
    {
        key: 'high-contrast',
        label: 'High contrast'
    },
    {
        key: 'low-vision',
        label: 'Low vision'
    },
    {
        key: 'inverted',
        label: 'Inverted'
    }
];
var $d0c87ea0ddd5024a$export$2e2bcd8739ae039 = {
    filters: $d0c87ea0ddd5024a$export$82462a21aead86ed,
    svgDefs: $d0c87ea0ddd5024a$export$53d8590270d12c2d,
    options: $d0c87ea0ddd5024a$export$41c562ebe57d11e2
};

});


parcelRegister("3XRHS", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e308ad3d7a86b91$export$2e2bcd8739ae039);

var $hkIA7 = parcelRequire("hkIA7");

var $4MTTQ = parcelRequire("4MTTQ");

var $31DGv = parcelRequire("31DGv");

var $ipMYc = parcelRequire("ipMYc");

var $5lRg5 = parcelRequire("5lRg5");

var $h1WxK = parcelRequire("h1WxK");

var $bFhSA = parcelRequire("bFhSA");

var $8uKKU = parcelRequire("8uKKU");

var $4GHbX = parcelRequire("4GHbX");

var $diDG0 = parcelRequire("diDG0");

var $2JkpO = parcelRequire("2JkpO");

var $fpPqN = parcelRequire("fpPqN");

var $joY3t = parcelRequire("joY3t");

var $fV6Wg = parcelRequire("fV6Wg");

var $kYzvj = parcelRequire("kYzvj");

var $2SiZn = parcelRequire("2SiZn");

var $2UB7S = parcelRequire("2UB7S");

var $ekoeq = parcelRequire("ekoeq");

var $aVztA = parcelRequire("aVztA");

var $VIpIX = parcelRequire("VIpIX");

var $cPFdC = parcelRequire("cPFdC");

var $57Jtk = parcelRequire("57Jtk");

var $6UNea = parcelRequire("6UNea");

var $aI9qX = parcelRequire("aI9qX");

var $7uVvl = parcelRequire("7uVvl");

var $2iKNL = parcelRequire("2iKNL");

var $hWTk4 = parcelRequire("hWTk4");

var $3Czoa = parcelRequire("3Czoa");

var $iqvDi = parcelRequire("iqvDi");
var $2e308ad3d7a86b91$export$2e2bcd8739ae039 = {
    "48x48.png": (0, $hkIA7.default),
    "72x72.png": (0, $4MTTQ.default),
    "96x96.png": (0, $31DGv.default),
    "192x192.png": (0, $ipMYc.default),
    "144x144.png": (0, $5lRg5.default),
    "512x512.png": (0, $h1WxK.default),
    "350.png": (0, $bFhSA.default),
    "630.png": (0, $8uKKU.default),
    "350x350.png": (0, $4GHbX.default),
    "apple-touch-icon.png": (0, $diDG0.default),
    "favicon-16x16.png": (0, $2JkpO.default),
    "favicon-32x32.png": (0, $fpPqN.default),
    "favicon.ico": (0, $joY3t.default),
    "chrome-ext.png": (0, $fV6Wg.default),
    "shadow.png": (0, $kYzvj.default),
    "main.gif": (0, $2SiZn.default),
    "cms.png": (0, $2UB7S.default),
    "dashboard.png": (0, $ekoeq.default),
    "android-chrome-192x192.png": (0, $aVztA.default),
    "google.svg": (0, $VIpIX.default),
    "github.svg": (0, $cPFdC.default),
    "loading.gif": (0, $57Jtk.default),
    "1200.png": (0, $6UNea.default),
    "google.png": (0, $aI9qX.default),
    "chrome-ext-icon.png": (0, $7uVvl.default),
    "intro.gif": (0, $2iKNL.default),
    "code-preview.gif": (0, $hWTk4.default),
    "library-reuse.gif": (0, $3Czoa.default),
    "video.png": (0, $iqvDi.default)
};

});
parcelRegister("hkIA7", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9e6e2e71f2d5e94$export$2e2bcd8739ae039);
var $c9e6e2e71f2d5e94$export$2e2bcd8739ae039 = {
    content: {
        id: 'fi1080402f',
        src: 'https://files-production-symbols-platform-development-en-d5-u3-p7x0.based.dev/fi1080402f/5b06e162-ac04-4aae-af30-7369cd410648-193bb588-b8b6-48e4-b9e1-b42a43913e42-8fed7d55-67c5-4c2d-be3c-0a4bc76f7c24.png'
    },
    code: '',
    key: '48x48.png',
    type: 'file',
    format: 'png'
};

});

parcelRegister("4MTTQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $37c701a8dbe4e37e$export$2e2bcd8739ae039);
var $37c701a8dbe4e37e$export$2e2bcd8739ae039 = {
    content: {
        id: 'fi89094157',
        src: 'https://files-production-symbols-platform-development-en-d5-u3-p7x0.based.dev/fi89094157/c09d780d-40c9-4170-8c4c-f299f4e0854c-c23e19d6-dab9-4c0a-9304-7ba202991e7d-9a881902-13a3-4f6b-87d4-5a171b635f18.png'
    },
    code: '',
    key: '72x72.png',
    type: 'file',
    format: 'png'
};

});

parcelRegister("31DGv", function(module, exports) {

$parcel$export(module.exports, "default", () => $23403fa0fbaaf2bb$export$2e2bcd8739ae039);
var $23403fa0fbaaf2bb$export$2e2bcd8739ae039 = {
    content: {
        id: 'fiae8a1c19',
        src: 'https://files-production-symbols-platform-development-en-d5-u3-p7x0.based.dev/fiae8a1c19/b428cc45-079c-4285-a8b3-e4963caccd6f-a8e3a1eb-2008-4002-b347-52101fa3dbe2-15f441ae-c587-47b5-bf0a-11ecf213bc91.png'
    },
    code: '',
    key: '96x96.png',
    type: 'file',
    format: 'png'
};

});

parcelRegister("ipMYc", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6808c33a34f919d$export$2e2bcd8739ae039);
var $d6808c33a34f919d$export$2e2bcd8739ae039 = {
    content: {
        id: 'fi86422674',
        src: 'https://files-production-symbols-platform-development-en-d5-u3-p7x0.based.dev/fi86422674/5d238c57-d259-4931-be3f-5fe29933a0d7-06e10eec-a965-4f06-b72a-6e5cbeeb2133-aacd5a83-e5db-4ee6-8a08-63d3bb0e2561.png'
    },
    code: '',
    key: '192x192.png',
    type: 'file',
    format: 'png'
};

});

parcelRegister("5lRg5", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e5839f24d466f21$export$2e2bcd8739ae039);
var $3e5839f24d466f21$export$2e2bcd8739ae039 = {
    content: {
        id: 'fie71cbc0e',
        src: 'https://files-production-symbols-platform-development-en-d5-u3-p7x0.based.dev/fie71cbc0e/50ae3fe1-abd5-4e1f-8a01-3a73c70d57ce-4dd6b89f-8e34-45c9-b5ab-36adcfd92e1a-827fc055-446b-4328-95d4-3bbbe941aa0d.png'
    },
    code: '',
    key: '144x144.png',
    type: 'file',
    format: 'png'
};

});

parcelRegister("h1WxK", function(module, exports) {

$parcel$export(module.exports, "default", () => $c65ff12b4321c8e5$export$2e2bcd8739ae039);
var $c65ff12b4321c8e5$export$2e2bcd8739ae039 = {
    content: {
        id: 'ficfd1ea60',
        src: 'https://files-production-symbols-platform-development-en-d5-u3-p7x0.based.dev/ficfd1ea60/696085cf-1e40-4f01-b6ab-e6e2537de428-b28654b1-2db8-4065-a054-9f23ce8d57fd-b3d04bc7-7166-4370-b9d3-cb12938dcddd.png'
    },
    code: '',
    key: '512x512.png',
    type: 'file',
    format: 'png'
};

});

parcelRegister("bFhSA", function(module, exports) {

$parcel$export(module.exports, "default", () => $87e16482aff2dc43$export$2e2bcd8739ae039);
var $87e16482aff2dc43$export$2e2bcd8739ae039 = {
    content: {
        id: 'fie4a1e7e8',
        src: 'https://files-production-symbols-platform-development-en-d5-u3-p7x0.based.dev/fie4a1e7e8/497bc08a-0643-4356-9b90-fc4aaf26b7e3-34b6d8f1-6c01-44fc-967c-5080ac724970-3385d666-4cae-4542-8413-715156a04f2d.png'
    },
    code: '',
    key: '350.png',
    type: 'file',
    format: 'png'
};

});

parcelRegister("8uKKU", function(module, exports) {

$parcel$export(module.exports, "default", () => $62f564bdf185c6e6$export$2e2bcd8739ae039);
var $62f564bdf185c6e6$export$2e2bcd8739ae039 = {
    content: {
        id: 'fid9b07c82',
        src: 'https://files-production-symbols-platform-development-en-d5-u3-p7x0.based.dev/fid9b07c82/e49a0e8f-ded3-446d-98b4-3dcf9e70e57f-29f92d45-9e62-4adc-8518-49f87cae3813-6d0f72f4-a866-49c0-9599-0bf227895aeb.png'
    },
    code: '',
    key: '630.png',
    type: 'file',
    format: 'png'
};

});

parcelRegister("4GHbX", function(module, exports) {

$parcel$export(module.exports, "default", () => $369c96aa7ebe0d2e$export$2e2bcd8739ae039);
var $369c96aa7ebe0d2e$export$2e2bcd8739ae039 = {
    content: {
        id: 'fie4a1e7e8',
        src: 'https://files-production-symbols-platform-development-en-d5-u3-p7x0.based.dev/fie4a1e7e8/497bc08a-0643-4356-9b90-fc4aaf26b7e3-34b6d8f1-6c01-44fc-967c-5080ac724970-3385d666-4cae-4542-8413-715156a04f2d.png'
    },
    code: '',
    key: '350x350.png',
    type: 'file',
    format: 'png'
};

});

parcelRegister("diDG0", function(module, exports) {

$parcel$export(module.exports, "default", () => $9aebbbc187d576a9$export$2e2bcd8739ae039);
var $9aebbbc187d576a9$export$2e2bcd8739ae039 = {
    content: {
        id: 'fi815d0402',
        src: 'https://files-production-symbols-platform-development-en-d5-u3-p7x0.based.dev/fi815d0402/5333a30d-404f-4c27-81a2-0569bd39d944-00ef18d0-a0c8-422a-8f51-1461c29d1af5-ce40ea51-0aef-4c71-86c8-e527413fb3c2.png'
    },
    code: '',
    key: 'apple-touch-icon.png',
    type: 'file',
    format: 'png'
};

});

parcelRegister("2JkpO", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fcf9ed256d49aa7$export$2e2bcd8739ae039);
var $1fcf9ed256d49aa7$export$2e2bcd8739ae039 = {
    content: {
        id: 'fif449d8a3',
        src: 'https://files-production-symbols-platform-development-en-d5-u3-p7x0.based.dev/fif449d8a3/3b3e08cf-211a-4784-b1ca-315329254a04-2a6ca888-73ed-484e-a743-4c93164e15bc-594cbf73-a0e5-42ef-9922-bd6d984faf68.png'
    },
    code: '',
    key: 'favicon-16x16.png',
    type: 'file',
    format: 'png'
};

});

parcelRegister("fpPqN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b39115f7395ba43f$export$2e2bcd8739ae039);
var $b39115f7395ba43f$export$2e2bcd8739ae039 = {
    content: {
        id: 'fi334fb3b7',
        src: 'https://files-production-symbols-platform-development-en-d5-u3-p7x0.based.dev/fi334fb3b7/10b72641-cd8b-4fd8-99d4-229dbc0463f7-087e0278-c6b6-43e8-800a-1add1fe8ae68-a0d918bd-63b6-4531-9d19-75d6ab95897b.png'
    },
    code: '',
    key: 'favicon-32x32.png',
    type: 'file',
    format: 'png'
};

});

parcelRegister("joY3t", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1fed7e551066cc0$export$2e2bcd8739ae039);
var $e1fed7e551066cc0$export$2e2bcd8739ae039 = {
    content: {
        id: 'fieb061b3e',
        src: 'https://files-production-symbols-platform-development-en-d5-u3-p7x0.based.dev/fieb061b3e/3a24e758-34fc-4292-ada4-b4adb7727a21-e6d993f4-3aeb-4a0c-b20c-37517eed1d37-68b183e8-baa7-4faf-8910-9e3acacf3948.ico'
    },
    code: '',
    key: 'favicon.ico',
    type: 'file',
    format: 'ico'
};

});

parcelRegister("fV6Wg", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9718fcbb0685879$export$2e2bcd8739ae039);
var $b9718fcbb0685879$export$2e2bcd8739ae039 = {
    content: {
        id: 'fia7629f73',
        src: 'https://files-production-symbols-platform-development-en-d5-u3-p7x0.based.dev/fia7629f73/53fd9c2e-7410-4bcf-9cda-7e293b861397-1f059ea9-1d7e-4cf1-9ce1-2589babc3877-21a6efbb-1dcc-47e1-bed0-5aa497320923.png'
    },
    code: '',
    key: 'chrome-ext.png',
    type: 'file',
    format: 'png'
};

});

parcelRegister("kYzvj", function(module, exports) {

$parcel$export(module.exports, "default", () => $f454f39cfa4ce71f$export$2e2bcd8739ae039);
var $f454f39cfa4ce71f$export$2e2bcd8739ae039 = {
    content: {
        id: 'fid07be81e',
        src: 'https://files-production-symbols-platform-development-en-d5-u3-p7x0.based.dev/fid07be81e/2c49b7ad-f9e7-4774-acd3-a5bff53bdf42-ef87d6f1-38d3-4416-9aeb-c75a47b1c45e-5433c0e1-9802-4eec-b54f-37c00c4320f0.png'
    },
    code: '',
    key: 'shadow.png',
    type: 'file',
    format: 'png'
};

});

parcelRegister("2SiZn", function(module, exports) {

$parcel$export(module.exports, "default", () => $217f5ab8a6289e35$export$2e2bcd8739ae039);
var $217f5ab8a6289e35$export$2e2bcd8739ae039 = {
    content: {
        id: 'fi6984bff2',
        src: 'https://files-production-symbols-platform-development-en-d5-u3-p7x0.based.dev/fi6984bff2/cae4759f-4bc8-4ccc-b8ba-81921ca11eb4-2ee9f411-b1ce-4dce-8d82-23d99e70f786-809bd216-3c2c-4a2b-a91d-b284f3525dc2.gif'
    },
    code: '',
    key: 'main.gif',
    type: 'file',
    format: 'gif'
};

});

parcelRegister("2UB7S", function(module, exports) {

$parcel$export(module.exports, "default", () => $21ed9c2df95f4def$export$2e2bcd8739ae039);
var $21ed9c2df95f4def$export$2e2bcd8739ae039 = {
    content: {
        id: 'fibcd354d0',
        src: 'https://files-production-symbols-platform-development-en-d5-u3-p7x0.based.dev/fibcd354d0/1485f03e-f0d5-4131-9840-22e89a2679e6-eb30dc49-eec5-43b6-b6ed-0f7700edcc7d-7845386c-19f5-405f-9d80-a65b94c4a15f.png'
    },
    code: '',
    key: 'cms.png',
    type: 'file',
    format: 'png'
};

});

parcelRegister("ekoeq", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6e5bad90983a65b$export$2e2bcd8739ae039);
var $a6e5bad90983a65b$export$2e2bcd8739ae039 = {
    content: {
        id: 'fiad9e2d35',
        src: 'https://files-production-symbols-platform-development-en-d5-u3-p7x0.based.dev/fiad9e2d35/356fc5d8-b3a4-4b00-bb59-fe5515cd946f-81856351-d4f8-4b21-97cf-7eb6769bc428-f4efe810-f4a7-40b6-b64d-cb355a3e8ef4.png'
    },
    code: '',
    key: 'dashboard.png',
    type: 'file',
    format: 'png'
};

});

parcelRegister("aVztA", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f4abf10a94eee25$export$2e2bcd8739ae039);
var $7f4abf10a94eee25$export$2e2bcd8739ae039 = {
    content: {
        id: 'fifa83064f',
        src: 'https://files-production-symbols-platform-development-en-d5-u3-p7x0.based.dev/fifa83064f/ee9ef7e0-7d91-422c-a892-48b65c304798-f6e59b42-1d6e-4f98-ba65-09b110c8c392-c758752d-477d-4463-ade2-9fea8a06e35d.png'
    },
    code: '',
    key: 'android-chrome-192x192.png',
    type: 'file',
    format: 'png'
};

});

parcelRegister("VIpIX", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ad7c6a98523374e$export$2e2bcd8739ae039);
var $0ad7c6a98523374e$export$2e2bcd8739ae039 = {
    content: {
        id: 'fi0b25de4d',
        src: 'https://files-production-symbols-platform-development-en-d5-u3-p7x0.based.dev/fi0b25de4d/97d8ce4c-7c26-49e4-bbfd-6b937c3db1f2-f8088ae6-e636-4b8d-afee-b03e42e84140-4dd4e676-0263-46fc-8398-bc17d8b85c5b.svg'
    },
    code: '',
    key: 'google.svg',
    type: 'file',
    format: 'svg'
};

});

parcelRegister("cPFdC", function(module, exports) {

$parcel$export(module.exports, "default", () => $957a389fe6c1d9b6$export$2e2bcd8739ae039);
var $957a389fe6c1d9b6$export$2e2bcd8739ae039 = {
    content: {
        id: 'fi3c14c364',
        src: 'https://files-production-symbols-platform-development-en-d5-u3-p7x0.based.dev/fi3c14c364/1ff78062-4d73-45eb-92d9-2f1fe4a6bd8c-b7e9ebb8-ea7a-402a-8ca0-5c0ecbcfd312-9da1c690-b7bc-49eb-8ee3-739da887602d.svg'
    },
    code: '',
    key: 'github.svg',
    type: 'file',
    format: 'svg'
};

});

parcelRegister("57Jtk", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bb0e0ff3f80a934$export$2e2bcd8739ae039);
var $3bb0e0ff3f80a934$export$2e2bcd8739ae039 = {
    content: {
        id: 'fie4b0ff4e',
        src: 'https://files-production-symbols-platform-development-en-d5-u3-p7x0.based.dev/fie4b0ff4e/d137f849-df29-4956-b104-4128b109423b-3855d996-cbf3-427a-a9d5-766782d93239-69eeab1c-aea5-4a13-89d8-2020987030cb.gif'
    },
    code: '',
    key: 'loading.gif',
    type: 'file',
    format: 'gif'
};

});

parcelRegister("6UNea", function(module, exports) {

$parcel$export(module.exports, "default", () => $508e289d099faf03$export$2e2bcd8739ae039);
var $508e289d099faf03$export$2e2bcd8739ae039 = {
    content: {
        id: 'fifaa10738',
        src: 'https://files-production-symbols-platform-development-en-d5-u3-p7x0.based.dev/fifaa10738/035be3c5-35ca-4547-a68d-246e88dd97ce-cb47651f-8dab-420b-9ad0-5179d2adc81e-f74224ce-03ee-40c1-94ea-5c9d64fc48c6.png'
    },
    code: '',
    key: '1200.png',
    type: 'file',
    format: 'png'
};

});

parcelRegister("aI9qX", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cc554d1e39134c3$export$2e2bcd8739ae039);
var $7cc554d1e39134c3$export$2e2bcd8739ae039 = {
    content: {
        id: 'fi162656d4',
        src: 'https://files-production-symbols-platform-development-en-d5-u3-p7x0.based.dev/fi162656d4/d2f1667e-4a23-46fc-aae3-7f43aeea7e7e-cfc9f555-1e21-4eea-8700-e9bd66247d16-6e347fa9-01dd-490c-98ef-0d22a3215782.png'
    },
    code: '',
    key: 'google.png',
    type: 'file',
    format: 'png'
};

});

parcelRegister("7uVvl", function(module, exports) {

$parcel$export(module.exports, "default", () => $5757f0f4d8bb1231$export$2e2bcd8739ae039);
var $5757f0f4d8bb1231$export$2e2bcd8739ae039 = {
    content: {
        filename: 'MRpDgK94HecveGH5pWmBr.png',
        originalName: 'chrome-ext-icon.png',
        mimeType: 'image/png',
        size: 3859,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/MRpDgK94HecveGH5pWmBr.png',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '692d973ad181acc7ae7643df',
        previousVersions: [],
        createdAt: '2025-12-01T13:25:14.028Z',
        updatedAt: '2025-12-01T13:25:14.028Z',
        __v: 0,
        extension: 'png',
        humanSize: '3.77 KB',
        age: 61,
        id: '692d973ad181acc7ae7643df',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/692d973ad181acc7ae7643df',
                download: '/core/files/public/692d973ad181acc7ae7643df/download',
                publicDownload: '/core/files/public/692d973ad181acc7ae7643df/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/692d973ad181acc7ae7643df',
                download: 'https://api.symbols.app/core/files/public/692d973ad181acc7ae7643df/download',
                publicDownload: 'https://api.symbols.app/core/files/public/692d973ad181acc7ae7643df/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/MRpDgK94HecveGH5pWmBr.png'
        },
        src: 'https://api.symbols.app/core/files/public/692d973ad181acc7ae7643df/download'
    },
    code: '',
    key: 'chrome-ext-icon.png',
    type: 'files',
    format: 'png'
};

});

parcelRegister("2iKNL", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ad1910bd87645e7$export$2e2bcd8739ae039);
var $1ad1910bd87645e7$export$2e2bcd8739ae039 = {
    content: {
        filename: 'sZSxgx8FHB9Ji0btF9RzH.gif',
        originalName: 'CleanShot 2025-12-09 at 19.15.52.gif',
        mimeType: 'image/gif',
        size: 19653178,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/sZSxgx8FHB9Ji0btF9RzH.gif',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '69383d9b3ecb53e4de021350',
        previousVersions: [],
        createdAt: '2025-12-09T15:17:47.711Z',
        updatedAt: '2025-12-09T15:17:47.711Z',
        __v: 0,
        extension: 'gif',
        humanSize: '18.74 MB',
        age: 74,
        id: '69383d9b3ecb53e4de021350',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/69383d9b3ecb53e4de021350',
                download: '/core/files/public/69383d9b3ecb53e4de021350/download',
                publicDownload: '/core/files/public/69383d9b3ecb53e4de021350/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/69383d9b3ecb53e4de021350',
                download: 'https://api.symbols.app/core/files/public/69383d9b3ecb53e4de021350/download',
                publicDownload: 'https://api.symbols.app/core/files/public/69383d9b3ecb53e4de021350/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/sZSxgx8FHB9Ji0btF9RzH.gif'
        },
        src: 'https://api.symbols.app/core/files/public/69383d9b3ecb53e4de021350/download'
    },
    code: '',
    key: 'intro.gif',
    type: 'files',
    format: 'gif'
};

});

parcelRegister("hWTk4", function(module, exports) {

$parcel$export(module.exports, "default", () => $d112c46700999279$export$2e2bcd8739ae039);
var $d112c46700999279$export$2e2bcd8739ae039 = {
    content: {
        filename: 'hvJXWqY4XAo1LJxmRc2Ir.gif',
        originalName: 'codePreview.gif',
        mimeType: 'image/gif',
        size: 2593793,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/hvJXWqY4XAo1LJxmRc2Ir.gif',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '6931d31e6ed27368449c2dc0',
        previousVersions: [],
        createdAt: '2025-12-04T18:29:50.715Z',
        updatedAt: '2025-12-04T18:29:50.715Z',
        __v: 0,
        extension: 'gif',
        humanSize: '2.47 MB',
        age: 44,
        id: '6931d31e6ed27368449c2dc0',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/6931d31e6ed27368449c2dc0',
                download: '/core/files/public/6931d31e6ed27368449c2dc0/download',
                publicDownload: '/core/files/public/6931d31e6ed27368449c2dc0/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/6931d31e6ed27368449c2dc0',
                download: 'https://api.symbols.app/core/files/public/6931d31e6ed27368449c2dc0/download',
                publicDownload: 'https://api.symbols.app/core/files/public/6931d31e6ed27368449c2dc0/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/hvJXWqY4XAo1LJxmRc2Ir.gif'
        },
        src: 'https://api.symbols.app/core/files/public/6931d31e6ed27368449c2dc0/download'
    },
    code: '',
    key: 'code-preview.gif',
    type: 'files',
    format: 'gif'
};

});

parcelRegister("3Czoa", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a305f2ed24139c5$export$2e2bcd8739ae039);
var $2a305f2ed24139c5$export$2e2bcd8739ae039 = {
    content: {
        src: 'https://api.symbols.app/core/files/public/69383fda3ecb53e4de02199f/download'
    },
    code: '',
    key: 'library-reuse.gif',
    type: 'files',
    format: 'gif'
};

});

parcelRegister("iqvDi", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6a33153a5c46e70$export$2e2bcd8739ae039);
var $d6a33153a5c46e70$export$2e2bcd8739ae039 = {
    content: {
        filename: 'QtlEndzsotxaaAMwACfHb.png',
        originalName: 'video.png',
        mimeType: 'image/png',
        size: 14131,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/QtlEndzsotxaaAMwACfHb.png',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '6944ea6b4c0341ca0850df63',
        previousVersions: [],
        createdAt: '2025-12-19T06:02:19.751Z',
        updatedAt: '2025-12-19T06:02:19.751Z',
        __v: 0,
        extension: 'png',
        humanSize: '13.8 KB',
        age: 77,
        id: '6944ea6b4c0341ca0850df63',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/6944ea6b4c0341ca0850df63',
                download: '/core/files/public/6944ea6b4c0341ca0850df63/download',
                publicDownload: '/core/files/public/6944ea6b4c0341ca0850df63/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/6944ea6b4c0341ca0850df63',
                download: 'https://api.symbols.app/core/files/public/6944ea6b4c0341ca0850df63/download',
                publicDownload: 'https://api.symbols.app/core/files/public/6944ea6b4c0341ca0850df63/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/QtlEndzsotxaaAMwACfHb.png'
        },
        src: 'https://api.symbols.app/core/files/public/6944ea6b4c0341ca0850df63/download'
    },
    code: '',
    key: 'video.png',
    type: 'files',
    format: 'png'
};

});


parcelRegister("iKfA6", function(module, exports) {

$parcel$export(module.exports, "default", () => $da589bffe87f56f3$export$2e2bcd8739ae039);
var $da589bffe87f56f3$export$2e2bcd8739ae039 = [];

});

parcelRegister("bRd5h", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a1ecb369490f585$export$2e2bcd8739ae039);
var $8a1ecb369490f585$export$2e2bcd8739ae039 = {
    useReset: true,
    useVariable: true,
    useFontImport: true,
    useIconSprite: true,
    useSvgSprite: true,
    useDefaultConfig: true,
    useDocumentTheme: true,
    verbose: false,
    globalTheme: 'auto'
};

});

parcelRegister("81tCi", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d756401c2925942$export$2e2bcd8739ae039);
var $5d756401c2925942$export$2e2bcd8739ae039 = {};

});


parcelRegister("hmqhZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca38e239d2424d1b$export$2e2bcd8739ae039);

var $7YCHq = parcelRequire("7YCHq");

var $iYOcw = parcelRequire("iYOcw");

var $bZxx9 = parcelRequire("bZxx9");

var $lq26P = parcelRequire("lq26P");
var $ca38e239d2424d1b$export$2e2bcd8739ae039 = {
    components: $7YCHq,
    functions: $iYOcw,
    methods: $bZxx9,
    state: $lq26P
};

});
parcelRegister("7YCHq", function(module, exports) {

var $8f98e = parcelRequire("8f98e");

var $dqRQD = parcelRequire("dqRQD");

var $hYzzJ = parcelRequire("hYzzJ");

var $8wnar = parcelRequire("8wnar");

var $3K57D = parcelRequire("3K57D");

var $lgx1I = parcelRequire("lgx1I");

var $zMrNZ = parcelRequire("zMrNZ");

var $dwZLd = parcelRequire("dwZLd");

var $ks3O5 = parcelRequire("ks3O5");

var $k3RTe = parcelRequire("k3RTe");

var $1RWbR = parcelRequire("1RWbR");

var $7eSZV = parcelRequire("7eSZV");

var $iPhq6 = parcelRequire("iPhq6");

var $cKrKj = parcelRequire("cKrKj");

var $12Rgm = parcelRequire("12Rgm");

var $hJnvQ = parcelRequire("hJnvQ");

var $iAMfN = parcelRequire("iAMfN");

var $9KgHl = parcelRequire("9KgHl");

var $h8XPI = parcelRequire("h8XPI");

var $aGZxL = parcelRequire("aGZxL");

var $e7LpO = parcelRequire("e7LpO");

var $8XRPH = parcelRequire("8XRPH");

var $b2Fiq = parcelRequire("b2Fiq");

var $dQ71H = parcelRequire("dQ71H");

var $khCIe = parcelRequire("khCIe");

var $1Kzry = parcelRequire("1Kzry");

var $fJGMk = parcelRequire("fJGMk");

var $kbLH1 = parcelRequire("kbLH1");

var $lRUZr = parcelRequire("lRUZr");

var $iCwLt = parcelRequire("iCwLt");

var $1ho0F = parcelRequire("1ho0F");

var $5zfDj = parcelRequire("5zfDj");

var $7FNoC = parcelRequire("7FNoC");

var $k12Rm = parcelRequire("k12Rm");

var $lUnXR = parcelRequire("lUnXR");

var $4YD8Q = parcelRequire("4YD8Q");

var $4PMgf = parcelRequire("4PMgf");

var $iSMVI = parcelRequire("iSMVI");

var $12gDp = parcelRequire("12gDp");

var $eV3EV = parcelRequire("eV3EV");

var $f0FW6 = parcelRequire("f0FW6");

var $ervS9 = parcelRequire("ervS9");

var $2waml = parcelRequire("2waml");

var $9dnpP = parcelRequire("9dnpP");

var $6Kmii = parcelRequire("6Kmii");

var $2YyYb = parcelRequire("2YyYb");

var $5OiBB = parcelRequire("5OiBB");

var $kH7Ae = parcelRequire("kH7Ae");

var $clc6Q = parcelRequire("clc6Q");

var $f2JSf = parcelRequire("f2JSf");

var $eJLmi = parcelRequire("eJLmi");

var $3ODVu = parcelRequire("3ODVu");

var $7p6X6 = parcelRequire("7p6X6");

var $3dUjC = parcelRequire("3dUjC");

var $l1XOK = parcelRequire("l1XOK");

var $jAIMf = parcelRequire("jAIMf");

var $77wfO = parcelRequire("77wfO");

var $6Jezj = parcelRequire("6Jezj");

var $9TDMg = parcelRequire("9TDMg");

var $lUkki = parcelRequire("lUkki");

var $f90ed = parcelRequire("f90ed");

var $l4XWj = parcelRequire("l4XWj");

var $kx5it = parcelRequire("kx5it");

var $7VcWh = parcelRequire("7VcWh");

var $agkFM = parcelRequire("agkFM");

var $hAIXV = parcelRequire("hAIXV");

var $dRmWs = parcelRequire("dRmWs");

var $iVQkc = parcelRequire("iVQkc");

var $dZej3 = parcelRequire("dZej3");

var $frXBE = parcelRequire("frXBE");

var $6hqC5 = parcelRequire("6hqC5");

var $lgjzd = parcelRequire("lgjzd");

var $2PA50 = parcelRequire("2PA50");

var $joj5B = parcelRequire("joj5B");

var $6QS0R = parcelRequire("6QS0R");

var $ffGda = parcelRequire("ffGda");

var $fRzoq = parcelRequire("fRzoq");

var $4eZAR = parcelRequire("4eZAR");

var $eFhjb = parcelRequire("eFhjb");

var $grGZQ = parcelRequire("grGZQ");

var $lGpzv = parcelRequire("lGpzv");

var $1Wvl9 = parcelRequire("1Wvl9");

var $bWmjE = parcelRequire("bWmjE");

var $aoSJJ = parcelRequire("aoSJJ");

var $gjDQP = parcelRequire("gjDQP");

var $2H44R = parcelRequire("2H44R");

var $88CLS = parcelRequire("88CLS");

var $lbhEm = parcelRequire("lbhEm");

var $1LZgU = parcelRequire("1LZgU");

var $eJqVp = parcelRequire("eJqVp");

var $3w4DM = parcelRequire("3w4DM");

var $Lg9Kk = parcelRequire("Lg9Kk");

var $hfDV1 = parcelRequire("hfDV1");

var $8z6qC = parcelRequire("8z6qC");

var $7t0eg = parcelRequire("7t0eg");

var $kk6co = parcelRequire("kk6co");

var $b0mhK = parcelRequire("b0mhK");

var $1X8C6 = parcelRequire("1X8C6");

var $fdkWt = parcelRequire("fdkWt");

var $atXcv = parcelRequire("atXcv");

var $a6vU4 = parcelRequire("a6vU4");

var $dHdls = parcelRequire("dHdls");

var $1heju = parcelRequire("1heju");

var $ejg9w = parcelRequire("ejg9w");

var $9pNaw = parcelRequire("9pNaw");

var $dCDnM = parcelRequire("dCDnM");

var $jnFf1 = parcelRequire("jnFf1");

var $jU81a = parcelRequire("jU81a");

var $idQdM = parcelRequire("idQdM");

var $fqN8s = parcelRequire("fqN8s");

var $224Ar = parcelRequire("224Ar");

var $dt2bX = parcelRequire("dt2bX");

var $2Fpg4 = parcelRequire("2Fpg4");

var $5PKnX = parcelRequire("5PKnX");

var $1uyoM = parcelRequire("1uyoM");

var $kCGwW = parcelRequire("kCGwW");

var $czd7Z = parcelRequire("czd7Z");

var $anYOu = parcelRequire("anYOu");

var $fvvzd = parcelRequire("fvvzd");

var $9L7Qi = parcelRequire("9L7Qi");

var $1de1n = parcelRequire("1de1n");

var $lOZjK = parcelRequire("lOZjK");

var $in2VU = parcelRequire("in2VU");

var $8KuMX = parcelRequire("8KuMX");

var $2XANd = parcelRequire("2XANd");

var $86Rwz = parcelRequire("86Rwz");

var $QEDx0 = parcelRequire("QEDx0");

var $67kpU = parcelRequire("67kpU");

var $ermhX = parcelRequire("ermhX");

var $d5AWx = parcelRequire("d5AWx");

var $4KRnU = parcelRequire("4KRnU");

var $DZnyP = parcelRequire("DZnyP");

var $Cb24h = parcelRequire("Cb24h");

var $96D0F = parcelRequire("96D0F");

var $fm7eR = parcelRequire("fm7eR");

var $1aTYz = parcelRequire("1aTYz");

var $lFkcY = parcelRequire("lFkcY");

var $gE3gP = parcelRequire("gE3gP");

var $dNoQ6 = parcelRequire("dNoQ6");

var $fe3zF = parcelRequire("fe3zF");

var $jWIUp = parcelRequire("jWIUp");

var $4HTKo = parcelRequire("4HTKo");

var $bCvwy = parcelRequire("bCvwy");

var $1IvMf = parcelRequire("1IvMf");

var $crs58 = parcelRequire("crs58");

var $bIWcj = parcelRequire("bIWcj");

var $jnjX4 = parcelRequire("jnjX4");

var $4JY2m = parcelRequire("4JY2m");

var $9Jl2D = parcelRequire("9Jl2D");

var $iaYUM = parcelRequire("iaYUM");

var $5tB60 = parcelRequire("5tB60");

var $46S8T = parcelRequire("46S8T");

var $3hgoo = parcelRequire("3hgoo");

var $itXLY = parcelRequire("itXLY");

var $gJh1a = parcelRequire("gJh1a");

var $efVsG = parcelRequire("efVsG");

var $hvbtR = parcelRequire("hvbtR");

var $6XBBr = parcelRequire("6XBBr");

var $7k3pW = parcelRequire("7k3pW");

var $cGKkd = parcelRequire("cGKkd");

var $5mMZ1 = parcelRequire("5mMZ1");

var $87BOT = parcelRequire("87BOT");

var $9ovw5 = parcelRequire("9ovw5");

var $9tbLW = parcelRequire("9tbLW");

var $ilkYs = parcelRequire("ilkYs");

var $d1iag = parcelRequire("d1iag");

var $kgDNL = parcelRequire("kgDNL");

var $fcmwl = parcelRequire("fcmwl");

var $4r5iq = parcelRequire("4r5iq");

var $lsqCC = parcelRequire("lsqCC");

var $35xyN = parcelRequire("35xyN");

var $2BrES = parcelRequire("2BrES");

var $fd4ub = parcelRequire("fd4ub");

var $wwOVT = parcelRequire("wwOVT");

var $72Jy5 = parcelRequire("72Jy5");

var $j5OLG = parcelRequire("j5OLG");

var $861fo = parcelRequire("861fo");

var $55lFJ = parcelRequire("55lFJ");

var $klNm3 = parcelRequire("klNm3");

var $fFWcD = parcelRequire("fFWcD");

var $32mwN = parcelRequire("32mwN");

var $3rVEH = parcelRequire("3rVEH");

var $L7ky0 = parcelRequire("L7ky0");

var $jqSKN = parcelRequire("jqSKN");

var $gWBsP = parcelRequire("gWBsP");

var $cPK7A = parcelRequire("cPK7A");

var $bcH7l = parcelRequire("bcH7l");

var $8DYXu = parcelRequire("8DYXu");

var $ljCpr = parcelRequire("ljCpr");

var $3045l = parcelRequire("3045l");

var $8aUQh = parcelRequire("8aUQh");

var $3pSDo = parcelRequire("3pSDo");

var $6eXSl = parcelRequire("6eXSl");

var $9Fbsm = parcelRequire("9Fbsm");

var $81u68 = parcelRequire("81u68");

var $kMHQ7 = parcelRequire("kMHQ7");

var $02Izr = parcelRequire("02Izr");

var $2Zkcw = parcelRequire("2Zkcw");

var $dmC3K = parcelRequire("dmC3K");

var $g9DKZ = parcelRequire("g9DKZ");

var $dOgZa = parcelRequire("dOgZa");

var $j7Idj = parcelRequire("j7Idj");

var $7XRyk = parcelRequire("7XRyk");

var $4Qggm = parcelRequire("4Qggm");

var $8ywuD = parcelRequire("8ywuD");

var $74dHH = parcelRequire("74dHH");

var $i5pTl = parcelRequire("i5pTl");

var $5TPxd = parcelRequire("5TPxd");

var $i4AUN = parcelRequire("i4AUN");

var $hqDAY = parcelRequire("hqDAY");

var $An42e = parcelRequire("An42e");

var $2InCc = parcelRequire("2InCc");

var $dQ0Mx = parcelRequire("dQ0Mx");

var $5ImE2 = parcelRequire("5ImE2");

var $hUYpv = parcelRequire("hUYpv");

var $3Rfs1 = parcelRequire("3Rfs1");

var $af8VL = parcelRequire("af8VL");

var $5FLUI = parcelRequire("5FLUI");

var $4z65O = parcelRequire("4z65O");

var $jjRPV = parcelRequire("jjRPV");

var $8K2wS = parcelRequire("8K2wS");

var $gVBtc = parcelRequire("gVBtc");

var $4Pd98 = parcelRequire("4Pd98");

var $cjF7x = parcelRequire("cjF7x");

var $cb5vV = parcelRequire("cb5vV");

var $dXaex = parcelRequire("dXaex");

var $eT5im = parcelRequire("eT5im");

var $2Ditr = parcelRequire("2Ditr");

var $6hQiz = parcelRequire("6hQiz");

var $hQB5t = parcelRequire("hQB5t");

var $fCqyG = parcelRequire("fCqyG");

var $AgV21 = parcelRequire("AgV21");

var $19ak9 = parcelRequire("19ak9");

var $3lF3g = parcelRequire("3lF3g");

var $k216J = parcelRequire("k216J");

var $42QGH = parcelRequire("42QGH");

var $jUups = parcelRequire("jUups");

var $4LhuZ = parcelRequire("4LhuZ");

var $7MJvY = parcelRequire("7MJvY");

var $9oqUN = parcelRequire("9oqUN");

var $ekuwz = parcelRequire("ekuwz");

var $jlDkL = parcelRequire("jlDkL");

var $gBYsy = parcelRequire("gBYsy");

var $5pzX6 = parcelRequire("5pzX6");

var $28WTj = parcelRequire("28WTj");

var $lUMqC = parcelRequire("lUMqC");

var $akZSB = parcelRequire("akZSB");

var $3woMp = parcelRequire("3woMp");

var $2TbuY = parcelRequire("2TbuY");

var $fIdC9 = parcelRequire("fIdC9");

var $lJCNv = parcelRequire("lJCNv");

var $lenBB = parcelRequire("lenBB");

var $fcpAL = parcelRequire("fcpAL");

var $i2MvJ = parcelRequire("i2MvJ");

var $9SajF = parcelRequire("9SajF");

var $2CNCe = parcelRequire("2CNCe");

var $1xLYr = parcelRequire("1xLYr");

var $fyhXe = parcelRequire("fyhXe");

var $cJaYC = parcelRequire("cJaYC");

var $7jUEZ = parcelRequire("7jUEZ");

var $e9Nub = parcelRequire("e9Nub");

var $chPUZ = parcelRequire("chPUZ");

var $i6dQ8 = parcelRequire("i6dQ8");

var $1hUNq = parcelRequire("1hUNq");

var $5wmft = parcelRequire("5wmft");

var $hvuwl = parcelRequire("hvuwl");
$parcel$exportWildcard(module.exports, $8f98e);
$parcel$exportWildcard(module.exports, $dqRQD);
$parcel$exportWildcard(module.exports, $hYzzJ);
$parcel$exportWildcard(module.exports, $8wnar);
$parcel$exportWildcard(module.exports, $3K57D);
$parcel$exportWildcard(module.exports, $lgx1I);
$parcel$exportWildcard(module.exports, $zMrNZ);
$parcel$exportWildcard(module.exports, $dwZLd);
$parcel$exportWildcard(module.exports, $ks3O5);
$parcel$exportWildcard(module.exports, $k3RTe);
$parcel$exportWildcard(module.exports, $1RWbR);
$parcel$exportWildcard(module.exports, $7eSZV);
$parcel$exportWildcard(module.exports, $iPhq6);
$parcel$exportWildcard(module.exports, $cKrKj);
$parcel$exportWildcard(module.exports, $12Rgm);
$parcel$exportWildcard(module.exports, $hJnvQ);
$parcel$exportWildcard(module.exports, $iAMfN);
$parcel$exportWildcard(module.exports, $9KgHl);
$parcel$exportWildcard(module.exports, $h8XPI);
$parcel$exportWildcard(module.exports, $aGZxL);
$parcel$exportWildcard(module.exports, $e7LpO);
$parcel$exportWildcard(module.exports, $8XRPH);
$parcel$exportWildcard(module.exports, $b2Fiq);
$parcel$exportWildcard(module.exports, $dQ71H);
$parcel$exportWildcard(module.exports, $khCIe);
$parcel$exportWildcard(module.exports, $1Kzry);
$parcel$exportWildcard(module.exports, $fJGMk);
$parcel$exportWildcard(module.exports, $kbLH1);
$parcel$exportWildcard(module.exports, $lRUZr);
$parcel$exportWildcard(module.exports, $iCwLt);
$parcel$exportWildcard(module.exports, $1ho0F);
$parcel$exportWildcard(module.exports, $5zfDj);
$parcel$exportWildcard(module.exports, $7FNoC);
$parcel$exportWildcard(module.exports, $k12Rm);
$parcel$exportWildcard(module.exports, $lUnXR);
$parcel$exportWildcard(module.exports, $4YD8Q);
$parcel$exportWildcard(module.exports, $4PMgf);
$parcel$exportWildcard(module.exports, $iSMVI);
$parcel$exportWildcard(module.exports, $12gDp);
$parcel$exportWildcard(module.exports, $eV3EV);
$parcel$exportWildcard(module.exports, $f0FW6);
$parcel$exportWildcard(module.exports, $ervS9);
$parcel$exportWildcard(module.exports, $2waml);
$parcel$exportWildcard(module.exports, $9dnpP);
$parcel$exportWildcard(module.exports, $6Kmii);
$parcel$exportWildcard(module.exports, $2YyYb);
$parcel$exportWildcard(module.exports, $5OiBB);
$parcel$exportWildcard(module.exports, $kH7Ae);
$parcel$exportWildcard(module.exports, $clc6Q);
$parcel$exportWildcard(module.exports, $f2JSf);
$parcel$exportWildcard(module.exports, $eJLmi);
$parcel$exportWildcard(module.exports, $3ODVu);
$parcel$exportWildcard(module.exports, $7p6X6);
$parcel$exportWildcard(module.exports, $3dUjC);
$parcel$exportWildcard(module.exports, $l1XOK);
$parcel$exportWildcard(module.exports, $jAIMf);
$parcel$exportWildcard(module.exports, $77wfO);
$parcel$exportWildcard(module.exports, $6Jezj);
$parcel$exportWildcard(module.exports, $9TDMg);
$parcel$exportWildcard(module.exports, $lUkki);
$parcel$exportWildcard(module.exports, $f90ed);
$parcel$exportWildcard(module.exports, $l4XWj);
$parcel$exportWildcard(module.exports, $kx5it);
$parcel$exportWildcard(module.exports, $7VcWh);
$parcel$exportWildcard(module.exports, $agkFM);
$parcel$exportWildcard(module.exports, $hAIXV);
$parcel$exportWildcard(module.exports, $dRmWs);
$parcel$exportWildcard(module.exports, $iVQkc);
$parcel$exportWildcard(module.exports, $dZej3);
$parcel$exportWildcard(module.exports, $frXBE);
$parcel$exportWildcard(module.exports, $6hqC5);
$parcel$exportWildcard(module.exports, $lgjzd);
$parcel$exportWildcard(module.exports, $2PA50);
$parcel$exportWildcard(module.exports, $joj5B);
$parcel$exportWildcard(module.exports, $6QS0R);
$parcel$exportWildcard(module.exports, $ffGda);
$parcel$exportWildcard(module.exports, $fRzoq);
$parcel$exportWildcard(module.exports, $4eZAR);
$parcel$exportWildcard(module.exports, $eFhjb);
$parcel$exportWildcard(module.exports, $grGZQ);
$parcel$exportWildcard(module.exports, $lGpzv);
$parcel$exportWildcard(module.exports, $1Wvl9);
$parcel$exportWildcard(module.exports, $bWmjE);
$parcel$exportWildcard(module.exports, $aoSJJ);
$parcel$exportWildcard(module.exports, $gjDQP);
$parcel$exportWildcard(module.exports, $2H44R);
$parcel$exportWildcard(module.exports, $88CLS);
$parcel$exportWildcard(module.exports, $lbhEm);
$parcel$exportWildcard(module.exports, $1LZgU);
$parcel$exportWildcard(module.exports, $eJqVp);
$parcel$exportWildcard(module.exports, $3w4DM);
$parcel$exportWildcard(module.exports, $Lg9Kk);
$parcel$exportWildcard(module.exports, $hfDV1);
$parcel$exportWildcard(module.exports, $8z6qC);
$parcel$exportWildcard(module.exports, $7t0eg);
$parcel$exportWildcard(module.exports, $kk6co);
$parcel$exportWildcard(module.exports, $b0mhK);
$parcel$exportWildcard(module.exports, $1X8C6);
$parcel$exportWildcard(module.exports, $fdkWt);
$parcel$exportWildcard(module.exports, $atXcv);
$parcel$exportWildcard(module.exports, $a6vU4);
$parcel$exportWildcard(module.exports, $dHdls);
$parcel$exportWildcard(module.exports, $1heju);
$parcel$exportWildcard(module.exports, $ejg9w);
$parcel$exportWildcard(module.exports, $9pNaw);
$parcel$exportWildcard(module.exports, $dCDnM);
$parcel$exportWildcard(module.exports, $jnFf1);
$parcel$exportWildcard(module.exports, $jU81a);
$parcel$exportWildcard(module.exports, $idQdM);
$parcel$exportWildcard(module.exports, $fqN8s);
$parcel$exportWildcard(module.exports, $224Ar);
$parcel$exportWildcard(module.exports, $dt2bX);
$parcel$exportWildcard(module.exports, $2Fpg4);
$parcel$exportWildcard(module.exports, $5PKnX);
$parcel$exportWildcard(module.exports, $1uyoM);
$parcel$exportWildcard(module.exports, $kCGwW);
$parcel$exportWildcard(module.exports, $czd7Z);
$parcel$exportWildcard(module.exports, $anYOu);
$parcel$exportWildcard(module.exports, $fvvzd);
$parcel$exportWildcard(module.exports, $9L7Qi);
$parcel$exportWildcard(module.exports, $1de1n);
$parcel$exportWildcard(module.exports, $lOZjK);
$parcel$exportWildcard(module.exports, $in2VU);
$parcel$exportWildcard(module.exports, $8KuMX);
$parcel$exportWildcard(module.exports, $2XANd);
$parcel$exportWildcard(module.exports, $86Rwz);
$parcel$exportWildcard(module.exports, $QEDx0);
$parcel$exportWildcard(module.exports, $67kpU);
$parcel$exportWildcard(module.exports, $ermhX);
$parcel$exportWildcard(module.exports, $d5AWx);
$parcel$exportWildcard(module.exports, $4KRnU);
$parcel$exportWildcard(module.exports, $DZnyP);
$parcel$exportWildcard(module.exports, $Cb24h);
$parcel$exportWildcard(module.exports, $96D0F);
$parcel$exportWildcard(module.exports, $fm7eR);
$parcel$exportWildcard(module.exports, $1aTYz);
$parcel$exportWildcard(module.exports, $lFkcY);
$parcel$exportWildcard(module.exports, $gE3gP);
$parcel$exportWildcard(module.exports, $dNoQ6);
$parcel$exportWildcard(module.exports, $fe3zF);
$parcel$exportWildcard(module.exports, $jWIUp);
$parcel$exportWildcard(module.exports, $4HTKo);
$parcel$exportWildcard(module.exports, $bCvwy);
$parcel$exportWildcard(module.exports, $1IvMf);
$parcel$exportWildcard(module.exports, $crs58);
$parcel$exportWildcard(module.exports, $bIWcj);
$parcel$exportWildcard(module.exports, $jnjX4);
$parcel$exportWildcard(module.exports, $4JY2m);
$parcel$exportWildcard(module.exports, $9Jl2D);
$parcel$exportWildcard(module.exports, $iaYUM);
$parcel$exportWildcard(module.exports, $5tB60);
$parcel$exportWildcard(module.exports, $46S8T);
$parcel$exportWildcard(module.exports, $3hgoo);
$parcel$exportWildcard(module.exports, $itXLY);
$parcel$exportWildcard(module.exports, $gJh1a);
$parcel$exportWildcard(module.exports, $efVsG);
$parcel$exportWildcard(module.exports, $hvbtR);
$parcel$exportWildcard(module.exports, $6XBBr);
$parcel$exportWildcard(module.exports, $7k3pW);
$parcel$exportWildcard(module.exports, $cGKkd);
$parcel$exportWildcard(module.exports, $5mMZ1);
$parcel$exportWildcard(module.exports, $87BOT);
$parcel$exportWildcard(module.exports, $9ovw5);
$parcel$exportWildcard(module.exports, $9tbLW);
$parcel$exportWildcard(module.exports, $ilkYs);
$parcel$exportWildcard(module.exports, $d1iag);
$parcel$exportWildcard(module.exports, $kgDNL);
$parcel$exportWildcard(module.exports, $fcmwl);
$parcel$exportWildcard(module.exports, $4r5iq);
$parcel$exportWildcard(module.exports, $lsqCC);
$parcel$exportWildcard(module.exports, $35xyN);
$parcel$exportWildcard(module.exports, $2BrES);
$parcel$exportWildcard(module.exports, $fd4ub);
$parcel$exportWildcard(module.exports, $wwOVT);
$parcel$exportWildcard(module.exports, $72Jy5);
$parcel$exportWildcard(module.exports, $j5OLG);
$parcel$exportWildcard(module.exports, $861fo);
$parcel$exportWildcard(module.exports, $55lFJ);
$parcel$exportWildcard(module.exports, $klNm3);
$parcel$exportWildcard(module.exports, $fFWcD);
$parcel$exportWildcard(module.exports, $32mwN);
$parcel$exportWildcard(module.exports, $3rVEH);
$parcel$exportWildcard(module.exports, $L7ky0);
$parcel$exportWildcard(module.exports, $jqSKN);
$parcel$exportWildcard(module.exports, $gWBsP);
$parcel$exportWildcard(module.exports, $cPK7A);
$parcel$exportWildcard(module.exports, $bcH7l);
$parcel$exportWildcard(module.exports, $8DYXu);
$parcel$exportWildcard(module.exports, $ljCpr);
$parcel$exportWildcard(module.exports, $3045l);
$parcel$exportWildcard(module.exports, $8aUQh);
$parcel$exportWildcard(module.exports, $3pSDo);
$parcel$exportWildcard(module.exports, $6eXSl);
$parcel$exportWildcard(module.exports, $9Fbsm);
$parcel$exportWildcard(module.exports, $81u68);
$parcel$exportWildcard(module.exports, $kMHQ7);
$parcel$exportWildcard(module.exports, $02Izr);
$parcel$exportWildcard(module.exports, $2Zkcw);
$parcel$exportWildcard(module.exports, $dmC3K);
$parcel$exportWildcard(module.exports, $g9DKZ);
$parcel$exportWildcard(module.exports, $dOgZa);
$parcel$exportWildcard(module.exports, $j7Idj);
$parcel$exportWildcard(module.exports, $7XRyk);
$parcel$exportWildcard(module.exports, $4Qggm);
$parcel$exportWildcard(module.exports, $8ywuD);
$parcel$exportWildcard(module.exports, $74dHH);
$parcel$exportWildcard(module.exports, $i5pTl);
$parcel$exportWildcard(module.exports, $5TPxd);
$parcel$exportWildcard(module.exports, $i4AUN);
$parcel$exportWildcard(module.exports, $hqDAY);
$parcel$exportWildcard(module.exports, $An42e);
$parcel$exportWildcard(module.exports, $2InCc);
$parcel$exportWildcard(module.exports, $dQ0Mx);
$parcel$exportWildcard(module.exports, $5ImE2);
$parcel$exportWildcard(module.exports, $hUYpv);
$parcel$exportWildcard(module.exports, $3Rfs1);
$parcel$exportWildcard(module.exports, $af8VL);
$parcel$exportWildcard(module.exports, $5FLUI);
$parcel$exportWildcard(module.exports, $4z65O);
$parcel$exportWildcard(module.exports, $jjRPV);
$parcel$exportWildcard(module.exports, $8K2wS);
$parcel$exportWildcard(module.exports, $gVBtc);
$parcel$exportWildcard(module.exports, $4Pd98);
$parcel$exportWildcard(module.exports, $cjF7x);
$parcel$exportWildcard(module.exports, $cb5vV);
$parcel$exportWildcard(module.exports, $dXaex);
$parcel$exportWildcard(module.exports, $eT5im);
$parcel$exportWildcard(module.exports, $2Ditr);
$parcel$exportWildcard(module.exports, $6hQiz);
$parcel$exportWildcard(module.exports, $hQB5t);
$parcel$exportWildcard(module.exports, $fCqyG);
$parcel$exportWildcard(module.exports, $AgV21);
$parcel$exportWildcard(module.exports, $19ak9);
$parcel$exportWildcard(module.exports, $3lF3g);
$parcel$exportWildcard(module.exports, $k216J);
$parcel$exportWildcard(module.exports, $42QGH);
$parcel$exportWildcard(module.exports, $jUups);
$parcel$exportWildcard(module.exports, $4LhuZ);
$parcel$exportWildcard(module.exports, $7MJvY);
$parcel$exportWildcard(module.exports, $9oqUN);
$parcel$exportWildcard(module.exports, $ekuwz);
$parcel$exportWildcard(module.exports, $jlDkL);
$parcel$exportWildcard(module.exports, $gBYsy);
$parcel$exportWildcard(module.exports, $5pzX6);
$parcel$exportWildcard(module.exports, $28WTj);
$parcel$exportWildcard(module.exports, $lUMqC);
$parcel$exportWildcard(module.exports, $akZSB);
$parcel$exportWildcard(module.exports, $3woMp);
$parcel$exportWildcard(module.exports, $2TbuY);
$parcel$exportWildcard(module.exports, $fIdC9);
$parcel$exportWildcard(module.exports, $lJCNv);
$parcel$exportWildcard(module.exports, $lenBB);
$parcel$exportWildcard(module.exports, $fcpAL);
$parcel$exportWildcard(module.exports, $i2MvJ);
$parcel$exportWildcard(module.exports, $9SajF);
$parcel$exportWildcard(module.exports, $2CNCe);
$parcel$exportWildcard(module.exports, $1xLYr);
$parcel$exportWildcard(module.exports, $fyhXe);
$parcel$exportWildcard(module.exports, $cJaYC);
$parcel$exportWildcard(module.exports, $7jUEZ);
$parcel$exportWildcard(module.exports, $e9Nub);
$parcel$exportWildcard(module.exports, $chPUZ);
$parcel$exportWildcard(module.exports, $i6dQ8);
$parcel$exportWildcard(module.exports, $1hUNq);
$parcel$exportWildcard(module.exports, $5wmft);
$parcel$exportWildcard(module.exports, $hvuwl);

});
parcelRegister("8f98e", function(module, exports) {

$parcel$export(module.exports, "applyMarkdownToElement", () => $6006ced7bea40667$export$1daceb1e81e67587);
$parcel$export(module.exports, "MarkdownPreview", () => $6006ced7bea40667$export$e52fbcfb1760e90c);
// Single unified markdown previewer for the workspace.
//
// Workspace-project pages (tickets, docs, knowledge-base) own their page-level
// H1/H2 chrome, so user-supplied markdown must never claim those heading slots.
// When `demoteHeadings` is true (default): h1→H4, h2→H5, h3-h6→H6.
// When false: native H1-H6 are used (useful for stand-alone surfaces where the
// markdown IS the primary content).
//
// Props:
//   text           — the markdown source string
//   withMentions   — default false; when true applies @mention / #channel highlighting
//   demoteHeadings — default true; h1→H4, h2→H5, h3-h6→H6
//
// Internal rendering delegates to transformMarkdown from symbolize-markdown.
// Caches on el._lastMd to skip unchanged updates.
//
// Chat-specific highlights (##ticket, @@event, +reference) are always applied
// when the body contains the respective patterns — they only fire when the regex
// matches so they are safe for non-chat surfaces (tickets, docs).

var $XQgMo = parcelRequire("XQgMo");

var $hRl3P = parcelRequire("hRl3P");

var $bfqVY = parcelRequire("bfqVY");
// Component maps — built once, reused on every render call.
const $6006ced7bea40667$var$_DEMOTE_COMPONENTS = {
    em: 'Em',
    h1: 'H4',
    h2: 'H5',
    h3: 'H6',
    h4: 'H6',
    h5: 'H6',
    h6: 'H6',
    hr: 'Hr',
    li: 'LI',
    ol: 'OL',
    ul: 'UL',
    del: 'Del',
    img: 'Img',
    pre: 'Pre',
    code: 'InlineCode',
    link: 'Link',
    strong: 'Strong',
    codeBlock: 'CodeBlock',
    paragraph: 'P',
    blockquote: 'Blockquote'
};
const $6006ced7bea40667$var$_NATIVE_COMPONENTS = {
    em: 'Em',
    h1: 'H1',
    h2: 'H2',
    h3: 'H3',
    h4: 'H4',
    h5: 'H5',
    h6: 'H6',
    hr: 'Hr',
    li: 'LI',
    ol: 'OL',
    ul: 'UL',
    del: 'Del',
    img: 'Img',
    pre: 'Pre',
    code: 'InlineCode',
    link: 'Link',
    strong: 'Strong',
    codeBlock: 'CodeBlock',
    paragraph: 'P',
    blockquote: 'Blockquote'
};
// ── Reference-card helpers (shared with renderMarkdown.js) ─────────────────
const $6006ced7bea40667$var$_CARD_BASE = 'display:inline-flex;align-items:center;gap:6px;padding:3px 8px;border-radius:6px;font-size:13px;font-weight:600;cursor:pointer;vertical-align:middle;text-decoration:none;';
const $6006ced7bea40667$var$_CARD_STYLES = {
    ticket: $6006ced7bea40667$var$_CARD_BASE + 'color:var(--color-orange,#f59e0b);background:rgba(245,158,11,0.1);',
    event: $6006ced7bea40667$var$_CARD_BASE + 'color:var(--color-blue,#6366f1);background:rgba(99,102,241,0.1);',
    reference: $6006ced7bea40667$var$_CARD_BASE + 'color:var(--color-green,#22c55e);background:rgba(34,197,94,0.1);'
};
const $6006ced7bea40667$var$_CARD_ICONS = {
    ticket: "\u25A0",
    event: "\u25CB",
    reference: "\u25C6"
};
const $6006ced7bea40667$var$_replaceTextNodes = (el, regex, makeSpan)=>{
    if (!el || !el.node) return [];
    const walker = document.createTreeWalker(el.node, NodeFilter.SHOW_TEXT);
    const replacements = [];
    let textNode;
    while(textNode = walker.nextNode()){
        regex.lastIndex = 0;
        if (!regex.test(textNode.textContent)) continue;
        replacements.push(textNode);
    }
    const spans = [];
    for (const node of replacements){
        if (!node.parentNode) continue;
        const frag = document.createDocumentFragment();
        let last = 0;
        regex.lastIndex = 0;
        let match;
        while((match = regex.exec(node.textContent)) !== null){
            if (match.index > last) frag.appendChild(document.createTextNode(node.textContent.slice(last, match.index)));
            const span = makeSpan(match);
            spans.push(span);
            frag.appendChild(span);
            last = match.index + match[0].length;
        }
        if (last < node.textContent.length) frag.appendChild(document.createTextNode(node.textContent.slice(last)));
        node.parentNode.replaceChild(frag, node);
    }
    return spans;
};
const $6006ced7bea40667$var$_TICKET_RE = /##(\d+)/g;
const $6006ced7bea40667$var$_highlightTickets = (el)=>{
    const spans = $6006ced7bea40667$var$_replaceTextNodes(el, $6006ced7bea40667$var$_TICKET_RE, (match)=>{
        const num = parseInt(match[1], 10);
        const span = document.createElement('span');
        span.style.cssText = $6006ced7bea40667$var$_CARD_STYLES.ticket;
        span.setAttribute('data-ref-ticket', String(num));
        span.innerHTML = `<span>${$6006ced7bea40667$var$_CARD_ICONS.ticket}</span> #${num}`;
        return span;
    });
    if (!spans.length) return;
    const numbers = spans.map((s)=>parseInt(s.getAttribute('data-ref-ticket'), 10));
    // migrated 2026-04-27 to SDK route workspaceProject.tickets/list
    (0, $bfqVY.getSDK)().execute('workspaceProject.tickets', 'list', {
        filter: {
            deleted: false,
            number_in: [
                ...new Set(numbers)
            ]
        },
        options: {
            columns: 'id, number, title, state, column_key'
        }
    }).then((res)=>{
        const data = Array.isArray(res) ? res : res?.data || res?.rows || [];
        const map = {};
        for (const t of data || [])map[t.number] = t;
        for (const span of spans){
            const num = parseInt(span.getAttribute('data-ref-ticket'), 10);
            const ticket = map[num];
            if (ticket) span.innerHTML = `<span>${$6006ced7bea40667$var$_CARD_ICONS.ticket}</span> #${num} \xb7 ${(ticket.title || '').slice(0, 40)}`;
        }
    }).catch(()=>{});
};
const $6006ced7bea40667$var$_EVENT_RE = /@@([a-zA-Z0-9._\- ]+)/g;
const $6006ced7bea40667$var$_highlightEvents = (el)=>{
    const spans = $6006ced7bea40667$var$_replaceTextNodes(el, $6006ced7bea40667$var$_EVENT_RE, (match)=>{
        const title = match[1].trim();
        const span = document.createElement('span');
        span.style.cssText = $6006ced7bea40667$var$_CARD_STYLES.event;
        span.setAttribute('data-ref-event', title);
        span.innerHTML = `<span>${$6006ced7bea40667$var$_CARD_ICONS.event}</span> ${title}`;
        return span;
    });
    if (!spans.length) return;
    const titles = [
        ...new Set(spans.map((s)=>s.getAttribute('data-ref-event')))
    ];
    // migrated 2026-04-27 to SDK route workspaceProject.calendar/list
    (0, $bfqVY.getSDK)().execute('workspaceProject.calendar', 'list', {
        filter: {
            title_in: titles
        }
    }).then((res)=>{
        const data = Array.isArray(res) ? res : res?.data || res?.events || res?.rows || [];
        const map = {};
        for (const ev of data || [])if (ev?.title) map[ev.title.toLowerCase()] = ev;
        for (const span of spans){
            const title = span.getAttribute('data-ref-event');
            const ev = map[title.toLowerCase()];
            if (ev && ev.date) span.innerHTML = `<span>${$6006ced7bea40667$var$_CARD_ICONS.event}</span> ${title} \xb7 ${ev.date}`;
        }
    }).catch(()=>{});
};
const $6006ced7bea40667$var$_REF_RE = /\+([a-zA-Z0-9._\- ]+)/g;
const $6006ced7bea40667$var$_highlightReferences = (el)=>{
    const spans = $6006ced7bea40667$var$_replaceTextNodes(el, $6006ced7bea40667$var$_REF_RE, (match)=>{
        const title = match[1].trim();
        const span = document.createElement('span');
        span.style.cssText = $6006ced7bea40667$var$_CARD_STYLES.reference;
        span.setAttribute('data-ref-doc', title);
        span.innerHTML = `<span>${$6006ced7bea40667$var$_CARD_ICONS.reference}</span> ${title}`;
        return span;
    });
    if (!spans.length) return;
    const titles = [
        ...new Set(spans.map((s)=>s.getAttribute('data-ref-doc')))
    ];
    // migrated 2026-04-27 to SDK routes workspaceProject.documents.notes / .documents.kb
    Promise.all([
        (0, $bfqVY.getSDK)().execute('workspaceProject.documents.notes', 'list', {
            filter: {
                title_in: titles
            }
        }),
        (0, $bfqVY.getSDK)().execute('workspaceProject.documents.kb', 'list', {
            filter: {
                title_in: titles
            }
        })
    ]).then(([notesRes, kbRes])=>{
        const notesData = Array.isArray(notesRes) ? notesRes : notesRes?.data || notesRes?.notes || notesRes?.rows || [];
        const kbData = Array.isArray(kbRes) ? kbRes : kbRes?.data || kbRes?.articles || kbRes?.rows || [];
        const map = {};
        for (const n of notesData || [])if (n?.title) map[n.title.toLowerCase()] = 'Note';
        for (const a of kbData || [])if (a?.title) map[a.title.toLowerCase()] = 'KB';
        for (const span of spans){
            const title = span.getAttribute('data-ref-doc');
            const type = map[title.toLowerCase()];
            if (type) span.innerHTML = `<span>${$6006ced7bea40667$var$_CARD_ICONS.reference}</span> ${title} \xb7 ${type}`;
        }
    }).catch(()=>{});
};
const $6006ced7bea40667$export$1daceb1e81e67587 = (el, body, emptyNode, options = {})=>{
    const { withMentions: withMentions = false, demoteHeadings: demoteHeadings = true, people: people, channels: channels, components: customComponents } = options;
    if (!el || typeof el.set !== 'function') return;
    if (el._lastMd === body) return;
    el._lastMd = body;
    if (!body) {
        el.set(emptyNode || {
            tag: 'span',
            text: ''
        });
        return;
    }
    const components = customComponents || (demoteHeadings ? $6006ced7bea40667$var$_DEMOTE_COMPONENTS : $6006ced7bea40667$var$_NATIVE_COMPONENTS);
    try {
        el.set((0, $XQgMo.transformMarkdown)(body, {
            components: components
        }));
    } catch (_) {
        el.set({
            tag: 'span',
            text: body
        });
    }
    requestAnimationFrame(()=>{
        // Run longer-prefix patterns FIRST (## before #, @@ before @).
        $6006ced7bea40667$var$_TICKET_RE.lastIndex = 0;
        if ($6006ced7bea40667$var$_TICKET_RE.test(body)) $6006ced7bea40667$var$_highlightTickets(el);
        $6006ced7bea40667$var$_EVENT_RE.lastIndex = 0;
        if ($6006ced7bea40667$var$_EVENT_RE.test(body)) $6006ced7bea40667$var$_highlightEvents(el);
        $6006ced7bea40667$var$_REF_RE.lastIndex = 0;
        if ($6006ced7bea40667$var$_REF_RE.test(body)) $6006ced7bea40667$var$_highlightReferences(el);
        if (withMentions) {
            const _MENTION_RE = /@([a-zA-Z0-9._-]+)/g;
            _MENTION_RE.lastIndex = 0;
            if (_MENTION_RE.test(body)) (0, $hRl3P.highlightMentions)(el, people);
            const _CHANNEL_RE = /#([a-zA-Z0-9._-]+)/g;
            _CHANNEL_RE.lastIndex = 0;
            if (_CHANNEL_RE.test(body)) (0, $hRl3P.highlightChannels)(el, channels);
        }
    });
};
// ── DOMQL v3.14 component ─────────────────────────────────────────────────────
// Props:
//   text           — markdown source
//   withMentions   — boolean (default false)
//   demoteHeadings — boolean (default true)
//
// The component relies on state to pass people/channels for mention highlighting.
// In chat contexts state carries s.root.people / s.root.channels automatically.
// In non-chat contexts those are simply absent and withMentions stays false.
const $6006ced7bea40667$var$_render = (el, s)=>{
    // el.text is the resolved markdown source string (v3.14 flat prop access).
    // withMentions / demoteHeadings are booleans set by the consumer.
    const body = el.text;
    const withMentions = !!el.withMentions;
    const demoteHeadings = el.demoteHeadings !== false;
    const people = s && s.root && s.root.people;
    const channels = s && s.root && s.root.channels;
    $6006ced7bea40667$export$1daceb1e81e67587(el, body || '', null, {
        withMentions: withMentions,
        demoteHeadings: demoteHeadings,
        people: people,
        channels: channels
    });
};
const $6006ced7bea40667$export$e52fbcfb1760e90c = {
    tag: 'div',
    onCreate: $6006ced7bea40667$var$_render,
    onUpdate: $6006ced7bea40667$var$_render
};

});
parcelRegister("XQgMo", function(module, exports) {

$parcel$export(module.exports, "transformMarkdown", () => $0b3e0e76e5ebf27d$export$be0664469ff86e63);
parcelRequire("3YaVL");
var $l5F2G = parcelRequire("l5F2G");
var $1wHA0 = parcelRequire("1wHA0");
const $0b3e0e76e5ebf27d$export$71abc632aa29e6fe = {
    h1: 'H1',
    h2: 'H2',
    h3: 'H3',
    h4: 'H4',
    h5: 'H5',
    h6: 'H6',
    paragraph: 'P',
    pre: 'Pre',
    code: 'Code',
    codeBlock: 'Code',
    blockquote: 'Blockquote',
    ul: 'UL',
    ol: 'OL',
    li: 'LI',
    hr: 'Hr',
    table: 'Table',
    thead: 'Thead',
    tbody: 'Tbody',
    tr: 'Tr',
    th: 'Th',
    td: 'Td',
    span: 'Span',
    strong: 'Strong',
    em: 'Em',
    del: 'Del',
    link: 'Link',
    img: 'Img',
    input: 'Input'
};
let $0b3e0e76e5ebf27d$var$currentComponents = $0b3e0e76e5ebf27d$export$71abc632aa29e6fe;
function $0b3e0e76e5ebf27d$var$c(key) {
    return $0b3e0e76e5ebf27d$var$currentComponents[key] || $0b3e0e76e5ebf27d$export$71abc632aa29e6fe[key];
}
function $0b3e0e76e5ebf27d$export$be0664469ff86e63(markdown, options = {}) {
    $0b3e0e76e5ebf27d$var$currentComponents = options.components ? {
        ...$0b3e0e76e5ebf27d$export$71abc632aa29e6fe,
        ...options.components
    } : $0b3e0e76e5ebf27d$export$71abc632aa29e6fe;
    const { content: content, meta: meta } = $0b3e0e76e5ebf27d$var$parseFrontmatter(markdown);
    const tokens = $0b3e0e76e5ebf27d$var$tokenize(content);
    const hasSymbolsBlocks = tokens.some((t)=>t.type === 'symbols_block');
    if (!hasSymbolsBlocks && !meta) {
        const irNodes = $0b3e0e76e5ebf27d$var$tokensToIR(tokens);
        return (0, $1wHA0.toSymbols)(irNodes);
    }
    // When symbols blocks or meta are present, assemble manually
    // to preserve ordering of markdown and raw symbols blocks
    const result = {};
    if (meta) result.__meta = meta;
    const typeCounts = {};
    function addKey(key, value) {
        if (result[key] !== undefined) {
            typeCounts[key] = (typeCounts[key] || 0) + 1;
            key = `${key}_${typeCounts[key]}`;
        }
        result[key] = value;
    }
    let rawIndex = 0;
    for (const token of tokens){
        if (token.type === 'symbols_block') {
            result[`__raw_${rawIndex++}`] = token.content.trim();
            continue;
        }
        const ir = $0b3e0e76e5ebf27d$var$tokenToIR(token);
        if (!ir) continue;
        addKey(ir.type, (0, $1wHA0.toSymbols)([
            ir
        ]));
    }
    const keys = Object.keys(result);
    // Only unwrap single-entry results for regular (non-raw, non-meta) keys
    if (keys.length === 1 && !keys[0].startsWith('__')) return result[keys[0]];
    return result;
}
// ── Frontmatter ─────────────────────────────────────────────────────
/**
 * Parse optional frontmatter delimited by --- at the top of the file.
 * Supports import statements: import { X, Y } from './path'
 */ function $0b3e0e76e5ebf27d$var$parseFrontmatter(markdown) {
    const trimmed = markdown.trimStart();
    if (!trimmed.startsWith('---')) return {
        content: markdown,
        meta: null
    };
    const end = trimmed.indexOf('\n---', 3);
    if (end === -1) return {
        content: markdown,
        meta: null
    };
    const frontmatterContent = trimmed.substring(3, end).trim();
    const content = trimmed.substring(end + 4).trimStart();
    const imports = [];
    for (const line of frontmatterContent.split('\n')){
        const importMatch = line.trim().match(/^import\s*\{([^}]+)\}\s*from\s*['"]([^'"]+)['"]$/);
        if (importMatch) {
            const names = importMatch[1].split(',').map((s)=>s.trim()).filter(Boolean);
            imports.push({
                names: names,
                from: importMatch[2]
            });
        }
    }
    const meta = imports.length ? {
        imports: imports
    } : null;
    return {
        content: content,
        meta: meta
    };
}
// ── Tokenizer ──────────────────────────────────────────────────────
/**
 * Tokenize markdown into block-level tokens.
 * Each token: { type, ...data }
 */ function $0b3e0e76e5ebf27d$var$tokenize(md) {
    const lines = md.split('\n');
    const tokens = [];
    let i = 0;
    while(i < lines.length){
        const line = lines[i];
        const trimmed = line.trim();
        // Empty line
        if (!trimmed) {
            i++;
            continue;
        }
        // Fenced code block ```
        if (trimmed.startsWith('```')) {
            const lang = trimmed.slice(3).trim() || null;
            const codeLines = [];
            i++;
            while(i < lines.length && !lines[i].trim().startsWith('```')){
                codeLines.push(lines[i]);
                i++;
            }
            i++ // skip closing ```
            ;
            tokens.push({
                type: 'code_block',
                lang: lang,
                content: codeLines.join('\n')
            });
            continue;
        }
        // Symbols block {{ }}
        if (trimmed === '{{') {
            const blockLines = [];
            i++;
            while(i < lines.length && lines[i].trim() !== '}}'){
                blockLines.push(lines[i]);
                i++;
            }
            i++ // skip closing }}
            ;
            tokens.push({
                type: 'symbols_block',
                content: blockLines.join('\n')
            });
            continue;
        }
        // Heading (ATX style)
        const headingMatch = trimmed.match(/^(#{1,6})\s+(.+)$/);
        if (headingMatch) {
            tokens.push({
                type: 'heading',
                level: headingMatch[1].length,
                content: headingMatch[2].replace(/\s+#+\s*$/, '') // strip trailing #
            });
            i++;
            continue;
        }
        // Horizontal rule
        if (/^([-*_])\1{2,}\s*$/.test(trimmed)) {
            tokens.push({
                type: 'hr'
            });
            i++;
            continue;
        }
        // Table (line starts with |)
        if (trimmed.startsWith('|') && i + 1 < lines.length && /^\|[\s:-]+\|/.test(lines[i + 1].trim())) {
            const tableLines = [];
            while(i < lines.length && lines[i].trim().startsWith('|')){
                tableLines.push(lines[i].trim());
                i++;
            }
            tokens.push({
                type: 'table',
                lines: tableLines
            });
            continue;
        }
        // Blockquote
        if (trimmed.startsWith('>')) {
            const quoteLines = [];
            while(i < lines.length){
                const ql = lines[i];
                const qt = ql.trim();
                if (qt.startsWith('>')) quoteLines.push(qt.replace(/^>\s?/, ''));
                else if (qt === '') {
                    // Check if next line is still a quote
                    if (i + 1 < lines.length && lines[i + 1].trim().startsWith('>')) quoteLines.push('');
                    else break;
                } else break;
                i++;
            }
            tokens.push({
                type: 'blockquote',
                content: quoteLines.join('\n')
            });
            continue;
        }
        // List item (unordered: - * +, ordered: 1.)
        const listMatch = trimmed.match(/^([-*+]|\d+\.)\s/);
        if (listMatch) {
            const items = [];
            const isOrdered = /^\d+\./.test(listMatch[1]);
            while(i < lines.length){
                const ll = lines[i];
                const lt = ll.trim();
                if (!lt) {
                    // blank line might separate list items or end the list
                    if (i + 1 < lines.length) {
                        const nextTrimmed = lines[i + 1].trim();
                        if (nextTrimmed.match(/^([-*+]|\d+\.)\s/) || lines[i + 1].startsWith('  ')) {
                            i++;
                            continue;
                        }
                    }
                    break;
                }
                const itemMatch = lt.match(/^([-*+]|\d+\.)\s(.*)$/);
                if (itemMatch) {
                    // Task list check
                    const taskMatch = itemMatch[2].match(/^\[([ xX])\]\s(.*)$/);
                    if (taskMatch) items.push({
                        text: taskMatch[2],
                        checked: taskMatch[1] !== ' ',
                        children: []
                    });
                    else items.push({
                        text: itemMatch[2],
                        children: []
                    });
                    i++;
                    // Collect continuation / nested content
                    while(i < lines.length){
                        const contLine = lines[i];
                        if (contLine.trim() === '') break;
                        // Indented continuation (nested list or continuation)
                        if (contLine.startsWith('  ') || contLine.startsWith('\t')) {
                            const nested = contLine.replace(/^(?:  |\t)/, '');
                            const nestedItem = nested.trim().match(/^([-*+]|\d+\.)\s(.*)$/);
                            if (nestedItem) items[items.length - 1].children.push(nestedItem[2]);
                            else // continuation text
                            items[items.length - 1].text += ' ' + nested.trim();
                            i++;
                        } else if (contLine.trim().match(/^([-*+]|\d+\.)\s/)) break; // next top-level item
                        else break;
                    }
                } else break;
            }
            tokens.push({
                type: 'list',
                ordered: isOrdered,
                items: items
            });
            continue;
        }
        // Paragraph (collect consecutive non-empty, non-special lines)
        const paraLines = [];
        while(i < lines.length){
            const pl = lines[i].trim();
            if (!pl) break;
            // Stop if next line is a block element.
            // NOTE: only treat `#` as a heading boundary when it matches the ATX
            // heading pattern (one or more `#` followed by a space).  Lines like
            // `#4549 (directive)` do NOT have a space after `#` and must be kept as
            // plain paragraph text — breaking on them without advancing `i` would
            // cause an infinite loop because the heading handler rejects them too.
            if (/^#{1,6}\s/.test(pl) || pl.startsWith('```') || pl.startsWith('>') || pl.match(/^([-*_])\1{2,}\s*$/) || pl.match(/^([-*+]|\d+\.)\s/) || pl.startsWith('|') || pl === '{{') break;
            paraLines.push(pl);
            i++;
        }
        if (paraLines.length) tokens.push({
            type: 'paragraph',
            content: paraLines.join(' ')
        });
    }
    return tokens;
}
// ── Token → IR ─────────────────────────────────────────────────────
function $0b3e0e76e5ebf27d$var$tokensToIR(tokens) {
    return tokens.map($0b3e0e76e5ebf27d$var$tokenToIR).filter(Boolean);
}
function $0b3e0e76e5ebf27d$var$tokenToIR(token) {
    switch(token.type){
        case 'heading':
            return $0b3e0e76e5ebf27d$var$headingToIR(token);
        case 'paragraph':
            return $0b3e0e76e5ebf27d$var$paragraphToIR(token);
        case 'code_block':
            return $0b3e0e76e5ebf27d$var$codeBlockToIR(token);
        case 'blockquote':
            return $0b3e0e76e5ebf27d$var$blockquoteToIR(token);
        case 'list':
            return $0b3e0e76e5ebf27d$var$listToIR(token);
        case 'hr':
            return (0, $l5F2G.createIRNode)($0b3e0e76e5ebf27d$var$c('hr'), {
                tag: 'hr'
            });
        case 'table':
            return $0b3e0e76e5ebf27d$var$tableToIR(token);
        default:
            return null;
    }
}
function $0b3e0e76e5ebf27d$var$headingToIR(token) {
    const type = $0b3e0e76e5ebf27d$var$c(`h${token.level}`);
    const inlineChildren = $0b3e0e76e5ebf27d$var$parseInline(token.content);
    if (inlineChildren.length === 1 && typeof inlineChildren[0] === 'string') return (0, $l5F2G.createIRNode)(type, {
        tag: `h${token.level}`,
        text: inlineChildren[0]
    });
    return (0, $l5F2G.createIRNode)(type, {
        tag: `h${token.level}`,
        children: $0b3e0e76e5ebf27d$var$inlineToIR(inlineChildren)
    });
}
function $0b3e0e76e5ebf27d$var$paragraphToIR(token) {
    const inlineChildren = $0b3e0e76e5ebf27d$var$parseInline(token.content);
    if (inlineChildren.length === 1 && typeof inlineChildren[0] === 'string') return (0, $l5F2G.createIRNode)($0b3e0e76e5ebf27d$var$c('paragraph'), {
        tag: 'p',
        text: inlineChildren[0]
    });
    return (0, $l5F2G.createIRNode)($0b3e0e76e5ebf27d$var$c('paragraph'), {
        tag: 'p',
        children: $0b3e0e76e5ebf27d$var$inlineToIR(inlineChildren)
    });
}
function $0b3e0e76e5ebf27d$var$codeBlockToIR(token) {
    const codeNode = (0, $l5F2G.createIRNode)($0b3e0e76e5ebf27d$var$c('codeBlock'), {
        tag: 'code',
        text: token.content
    });
    const props = {};
    if (token.lang) props['data-language'] = token.lang;
    return (0, $l5F2G.createIRNode)($0b3e0e76e5ebf27d$var$c('pre'), {
        tag: 'pre',
        props: Object.keys(props).length ? props : undefined,
        children: [
            codeNode
        ]
    });
}
function $0b3e0e76e5ebf27d$var$blockquoteToIR(token) {
    // Recursively parse blockquote content (supports nested blockquotes)
    const innerTokens = $0b3e0e76e5ebf27d$var$tokenize(token.content);
    const children = $0b3e0e76e5ebf27d$var$tokensToIR(innerTokens);
    return (0, $l5F2G.createIRNode)($0b3e0e76e5ebf27d$var$c('blockquote'), {
        tag: 'blockquote',
        children: children.length ? children : undefined,
        text: !children.length ? token.content : undefined
    });
}
function $0b3e0e76e5ebf27d$var$listToIR(token) {
    const tag = token.ordered ? 'ol' : 'ul';
    const type = token.ordered ? $0b3e0e76e5ebf27d$var$c('ol') : $0b3e0e76e5ebf27d$var$c('ul');
    const liType = $0b3e0e76e5ebf27d$var$c('li');
    const children = token.items.map((item)=>{
        const inlineChildren = $0b3e0e76e5ebf27d$var$parseInline(item.text);
        const liNode = {
            type: liType,
            tag: 'li'
        };
        // Task list item
        if (item.checked !== undefined) {
            const checkbox = (0, $l5F2G.createIRNode)($0b3e0e76e5ebf27d$var$c('input'), {
                tag: 'input',
                props: {
                    type: 'checkbox',
                    checked: item.checked,
                    disabled: true
                }
            });
            const textNodes = $0b3e0e76e5ebf27d$var$inlineToIR(inlineChildren);
            liNode.children = [
                checkbox,
                ...textNodes
            ];
        } else if (inlineChildren.length === 1 && typeof inlineChildren[0] === 'string') liNode.text = inlineChildren[0];
        else liNode.children = $0b3e0e76e5ebf27d$var$inlineToIR(inlineChildren);
        // Nested list items (simplified — flat children)
        if (item.children && item.children.length) {
            const nestedItems = item.children.map((text)=>{
                const parsed = $0b3e0e76e5ebf27d$var$parseInline(text);
                if (parsed.length === 1 && typeof parsed[0] === 'string') return {
                    type: liType,
                    tag: 'li',
                    text: parsed[0]
                };
                return {
                    type: liType,
                    tag: 'li',
                    children: $0b3e0e76e5ebf27d$var$inlineToIR(parsed)
                };
            });
            const nestedList = (0, $l5F2G.createIRNode)(type, {
                tag: tag,
                children: nestedItems.map((n)=>(0, $l5F2G.createIRNode)(n.type, n))
            });
            if (!liNode.children) liNode.children = [];
            liNode.children.push(nestedList);
        }
        return (0, $l5F2G.createIRNode)(liType, {
            tag: 'li',
            text: liNode.text,
            children: liNode.children
        });
    });
    return (0, $l5F2G.createIRNode)(type, {
        tag: tag,
        children: children
    });
}
function $0b3e0e76e5ebf27d$var$tableToIR(token) {
    const rows = token.lines.filter((line)=>!/^\|[\s:-]+\|$/.test(line)) // skip separator row
    .map((line)=>line.replace(/^\|/, '').replace(/\|$/, '').split('|').map((cell)=>cell.trim()));
    if (!rows.length) return null;
    const headerCells = rows[0];
    const bodyRows = rows.slice(1);
    const theadChildren = headerCells.map((cell)=>{
        const parsed = $0b3e0e76e5ebf27d$var$parseInline(cell);
        if (parsed.length === 1 && typeof parsed[0] === 'string') return (0, $l5F2G.createIRNode)($0b3e0e76e5ebf27d$var$c('th'), {
            tag: 'th',
            text: parsed[0]
        });
        return (0, $l5F2G.createIRNode)($0b3e0e76e5ebf27d$var$c('th'), {
            tag: 'th',
            children: $0b3e0e76e5ebf27d$var$inlineToIR(parsed)
        });
    });
    const thead = (0, $l5F2G.createIRNode)($0b3e0e76e5ebf27d$var$c('thead'), {
        tag: 'thead',
        children: [
            (0, $l5F2G.createIRNode)($0b3e0e76e5ebf27d$var$c('tr'), {
                tag: 'tr',
                children: theadChildren
            })
        ]
    });
    const tbodyChildren = bodyRows.map((row)=>{
        const cells = row.map((cell)=>{
            const parsed = $0b3e0e76e5ebf27d$var$parseInline(cell);
            if (parsed.length === 1 && typeof parsed[0] === 'string') return (0, $l5F2G.createIRNode)($0b3e0e76e5ebf27d$var$c('td'), {
                tag: 'td',
                text: parsed[0]
            });
            return (0, $l5F2G.createIRNode)($0b3e0e76e5ebf27d$var$c('td'), {
                tag: 'td',
                children: $0b3e0e76e5ebf27d$var$inlineToIR(parsed)
            });
        });
        return (0, $l5F2G.createIRNode)($0b3e0e76e5ebf27d$var$c('tr'), {
            tag: 'tr',
            children: cells
        });
    });
    const tbody = (0, $l5F2G.createIRNode)($0b3e0e76e5ebf27d$var$c('tbody'), {
        tag: 'tbody',
        children: tbodyChildren
    });
    return (0, $l5F2G.createIRNode)($0b3e0e76e5ebf27d$var$c('table'), {
        tag: 'table',
        children: [
            thead,
            tbody
        ]
    });
}
// ── Inline parsing ─────────────────────────────────────────────────
/**
 * Parse inline markdown elements.
 * Returns array of strings and inline token objects.
 */ function $0b3e0e76e5ebf27d$var$parseInline(text) {
    const result = [];
    let current = '';
    let i = 0;
    while(i < text.length){
        // Image ![alt](src)
        if (text[i] === '!' && text[i + 1] === '[') {
            const altEnd = text.indexOf(']', i + 2);
            if (altEnd !== -1 && text[altEnd + 1] === '(') {
                const srcEnd = text.indexOf(')', altEnd + 2);
                if (srcEnd !== -1) {
                    if (current) {
                        result.push(current);
                        current = '';
                    }
                    result.push({
                        type: 'img',
                        alt: text.substring(i + 2, altEnd),
                        src: text.substring(altEnd + 2, srcEnd)
                    });
                    i = srcEnd + 1;
                    continue;
                }
            }
        }
        // Link [text](url)
        if (text[i] === '[') {
            const textEnd = text.indexOf(']', i + 1);
            if (textEnd !== -1 && text[textEnd + 1] === '(') {
                const urlEnd = text.indexOf(')', textEnd + 2);
                if (urlEnd !== -1) {
                    if (current) {
                        result.push(current);
                        current = '';
                    }
                    result.push({
                        type: 'link',
                        text: text.substring(i + 1, textEnd),
                        href: text.substring(textEnd + 2, urlEnd)
                    });
                    i = urlEnd + 1;
                    continue;
                }
            }
        }
        // Inline code `code` (must check before bold/italic)
        if (text[i] === '`') {
            const end = text.indexOf('`', i + 1);
            if (end !== -1) {
                if (current) {
                    result.push(current);
                    current = '';
                }
                result.push({
                    type: 'code',
                    text: text.substring(i + 1, end)
                });
                i = end + 1;
                continue;
            }
        }
        // Strikethrough ~~text~~
        if (text[i] === '~' && text[i + 1] === '~') {
            const end = text.indexOf('~~', i + 2);
            if (end !== -1) {
                if (current) {
                    result.push(current);
                    current = '';
                }
                result.push({
                    type: 'strikethrough',
                    text: text.substring(i + 2, end)
                });
                i = end + 2;
                continue;
            }
        }
        // Bold **text** or __text__
        if (text[i] === '*' && text[i + 1] === '*' || text[i] === '_' && text[i + 1] === '_') {
            const marker = text.substring(i, i + 2);
            const end = text.indexOf(marker, i + 2);
            if (end !== -1) {
                if (current) {
                    result.push(current);
                    current = '';
                }
                result.push({
                    type: 'bold',
                    text: text.substring(i + 2, end)
                });
                i = end + 2;
                continue;
            }
        }
        // Italic *text* or _text_ (single marker, not at word boundary for _)
        if (text[i] === '*' && text[i + 1] !== '*') {
            const end = text.indexOf('*', i + 1);
            if (end !== -1 && end > i + 1) {
                if (current) {
                    result.push(current);
                    current = '';
                }
                result.push({
                    type: 'italic',
                    text: text.substring(i + 1, end)
                });
                i = end + 1;
                continue;
            }
        }
        if (text[i] === '_' && text[i + 1] !== '_') {
            const end = text.indexOf('_', i + 1);
            if (end !== -1 && end > i + 1) {
                if (current) {
                    result.push(current);
                    current = '';
                }
                result.push({
                    type: 'italic',
                    text: text.substring(i + 1, end)
                });
                i = end + 1;
                continue;
            }
        }
        current += text[i];
        i++;
    }
    if (current) result.push(current);
    return result;
}
/**
 * Convert inline parse results to IR nodes.
 */ function $0b3e0e76e5ebf27d$var$inlineToIR(inlineTokens) {
    return inlineTokens.map((token)=>{
        if (typeof token === 'string') return (0, $l5F2G.createIRNode)($0b3e0e76e5ebf27d$var$c('span'), {
            tag: 'span',
            text: token
        });
        switch(token.type){
            case 'bold':
                return (0, $l5F2G.createIRNode)($0b3e0e76e5ebf27d$var$c('strong'), {
                    tag: 'strong',
                    text: token.text
                });
            case 'italic':
                return (0, $l5F2G.createIRNode)($0b3e0e76e5ebf27d$var$c('em'), {
                    tag: 'em',
                    text: token.text
                });
            case 'strikethrough':
                return (0, $l5F2G.createIRNode)($0b3e0e76e5ebf27d$var$c('del'), {
                    tag: 'del',
                    text: token.text
                });
            case 'code':
                return (0, $l5F2G.createIRNode)($0b3e0e76e5ebf27d$var$c('code'), {
                    tag: 'code',
                    text: token.text
                });
            case 'link':
                return (0, $l5F2G.createIRNode)($0b3e0e76e5ebf27d$var$c('link'), {
                    tag: 'a',
                    text: token.text,
                    props: {
                        href: token.href
                    }
                });
            case 'img':
                return (0, $l5F2G.createIRNode)($0b3e0e76e5ebf27d$var$c('img'), {
                    tag: 'img',
                    props: {
                        src: token.src,
                        alt: token.alt
                    }
                });
            default:
                return (0, $l5F2G.createIRNode)($0b3e0e76e5ebf27d$var$c('span'), {
                    tag: 'span',
                    text: String(token)
                });
        }
    });
}

});
parcelRegister("3YaVL", function(module, exports) {

$parcel$export(module.exports, "createIRNode", () => (parcelRequire("l5F2G")).createIRNode);
$parcel$export(module.exports, "toSymbols", () => (parcelRequire("1wHA0")).toSymbols);

var $l5F2G = parcelRequire("l5F2G");

var $1wHA0 = parcelRequire("1wHA0");

var $i2qkx = parcelRequire("i2qkx");

});
parcelRegister("l5F2G", function(module, exports) {

$parcel$export(module.exports, "createIRNode", () => $f5a9e6c1bcb7ca7a$export$cc2911221c4d056f);
/**
 * Intermediate Representation (IR) node.
 * All transpilers produce IR nodes, which are then converted to DOMQL v3.
 *
 * @typedef {object} IRNode
 * @property {string} type - PascalCase component name or tag
 * @property {string} [tag] - HTML tag override (omit for implicit div)
 * @property {object} [props] - Props to pass through
 * @property {string} [text] - Text content
 * @property {object} [style] - Inline style object
 * @property {string[]} [classes] - CSS class names (for lookup, not output)
 * @property {object} [events] - Event handlers { onClick: fn, ... }
 * @property {IRNode[]} [children] - Child IR nodes
 */ /**
 * Create an IR node.
 *
 * @param {string} type
 * @param {object} [options]
 * @returns {IRNode}
 */ function $f5a9e6c1bcb7ca7a$export$cc2911221c4d056f(type, options = {}) {
    const node = {
        type: type
    };
    if (options.tag) node.tag = options.tag;
    if (options.props && Object.keys(options.props).length) node.props = options.props;
    if (options.text) node.text = options.text;
    if (options.style && Object.keys(options.style).length) node.style = options.style;
    if (options.classes && options.classes.length) node.classes = options.classes;
    if (options.events && Object.keys(options.events).length) node.events = options.events;
    if (options.children && options.children.length) node.children = options.children;
    return node;
}

});

parcelRegister("1wHA0", function(module, exports) {

$parcel$export(module.exports, "toSymbols", () => $11ca959e2d34fe5e$export$96506f577486e763);

var $i2qkx = parcelRequire("i2qkx");
function $11ca959e2d34fe5e$var$capitalizeFirst(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
/**
 * CSS property to Symbols prop mapping.
 */ const $11ca959e2d34fe5e$var$CSS_TO_PROPS = {
    display: 'display',
    'flex-direction': 'flow',
    'align-items': 'align',
    'justify-content': 'align',
    gap: 'gap',
    padding: 'padding',
    'padding-top': 'paddingTop',
    'padding-bottom': 'paddingBottom',
    'padding-left': 'paddingLeft',
    'padding-right': 'paddingRight',
    margin: 'margin',
    'margin-top': 'marginTop',
    'margin-bottom': 'marginBottom',
    'margin-left': 'marginLeft',
    'margin-right': 'marginRight',
    width: 'width',
    height: 'height',
    'min-width': 'minWidth',
    'min-height': 'minHeight',
    'max-width': 'maxWidth',
    'max-height': 'maxHeight',
    'font-size': 'fontSize',
    'font-weight': 'fontWeight',
    'line-height': 'lineHeight',
    'letter-spacing': 'letterSpacing',
    'text-align': 'textAlign',
    'text-decoration': 'textDecoration',
    'text-transform': 'textTransform',
    color: 'color',
    'background-color': 'background',
    background: 'background',
    'border-radius': 'round',
    border: 'border',
    'box-shadow': 'boxShadow',
    opacity: 'opacity',
    overflow: 'overflow',
    position: 'position',
    top: 'top',
    bottom: 'bottom',
    left: 'left',
    right: 'right',
    'z-index': 'zIndex',
    cursor: 'cursor',
    transition: 'transition',
    transform: 'transform'
};
/**
 * Media query breakpoint mapping.
 */ const $11ca959e2d34fe5e$var$MEDIA_BREAKPOINTS = {
    480: '@mobileL',
    768: '@tabletS',
    1024: '@screenS',
    1280: '@screenM',
    1440: '@screenL'
};
function $11ca959e2d34fe5e$export$56b4cbf46bcbeec1(styles) {
    const props = {};
    for (const [key, value] of Object.entries(styles)){
        // Preserve CSS custom properties (--*) as-is
        if (key.startsWith('--')) {
            props[key] = value;
            continue;
        }
        const kebab = key.replace(/([A-Z])/g, '-$1').toLowerCase();
        const prop = $11ca959e2d34fe5e$var$CSS_TO_PROPS[kebab] || (0, $i2qkx.toCamelCase)(kebab);
        // Handle flex alignment merge
        if (kebab === 'align-items' || kebab === 'justify-content') {
            if (props.align) props.align = `${props.align} ${value}`;
            else props.align = value;
            continue;
        }
        // Handle flex display → flow
        if (kebab === 'display' && value === 'flex') {
            props.flow = 'column';
            continue;
        }
        if (kebab === 'display' && value === 'grid') {
            props.display = 'grid';
            continue;
        }
        if (kebab === 'flex-direction') {
            props.flow = value;
            continue;
        }
        // Try spacing token for spacing/sizing props
        if ([
            'padding',
            'paddingTop',
            'paddingBottom',
            'paddingLeft',
            'paddingRight',
            'margin',
            'marginTop',
            'marginBottom',
            'marginLeft',
            'marginRight',
            'gap'
        ].includes(prop)) {
            props[prop] = (0, $i2qkx.pxToSpacingToken)(value);
            continue;
        }
        props[prop] = value;
    }
    return props;
}
function $11ca959e2d34fe5e$export$96506f577486e763(irNodes) {
    if (!irNodes || !irNodes.length) return {};
    if (irNodes.length === 1) return $11ca959e2d34fe5e$var$irNodeToSymbols(irNodes[0]);
    const result = {};
    for(let i = 0; i < irNodes.length; i++){
        const node = irNodes[i];
        let key = $11ca959e2d34fe5e$var$capitalizeFirst(node.type || `child${i}`);
        // Deduplicate keys
        if (result[key] !== undefined) key = `${key}_${i}`;
        result[key] = $11ca959e2d34fe5e$var$irNodeToSymbols(node);
    }
    return result;
}
/**
 * Convert a single IR node to a DOMQL v3 component.
 * @param {import('./ir.js').IRNode} node
 * @returns {object}
 */ function $11ca959e2d34fe5e$var$irNodeToSymbols(node) {
    const component = {};
    // extends — only for known semantic components
    if (node.type && node.type !== 'div' && node.type !== 'span') component.extends = node.type;
    // tag override
    if (node.tag) component.tag = node.tag;
    // Text content
    if (node.text) component.text = node.text;
    // Props from style
    if (node.style && Object.keys(node.style).length) Object.assign(component, $11ca959e2d34fe5e$export$56b4cbf46bcbeec1(node.style));
    // Direct props
    if (node.props) for (const [k, v] of Object.entries(node.props)){
        if (k === 'className' || k === 'class') continue;
        component[k] = v;
    }
    // Events (v3 style: onClick at root, not on: { click })
    if (node.events) Object.assign(component, node.events);
    // Children
    if (node.children && node.children.length) for(let i = 0; i < node.children.length; i++){
        const child = node.children[i];
        const key = $11ca959e2d34fe5e$var$capitalizeFirst(child.type || `child${i}`);
        // Deduplicate keys
        const finalKey = component[key] !== undefined ? `${key}_${i}` : key;
        component[finalKey] = $11ca959e2d34fe5e$var$irNodeToSymbols(child);
    }
    return component;
}

});
parcelRegister("i2qkx", function(module, exports) {

$parcel$export(module.exports, "toCamelCase", () => $d21cd6888b4d8a52$export$86f54f62aa7a7514);
$parcel$export(module.exports, "pxToSpacingToken", () => $d21cd6888b4d8a52$export$fb0bbfa60c752983);
/**
 * Sanitize a string into a valid PascalCase component name.
 * @param {string} name
 * @returns {string}
 */ function $d21cd6888b4d8a52$export$6fb43ff9addf7357(name) {
    return name.replace(/[^a-zA-Z0-9]+(.)/g, (_, c)=>c.toUpperCase()).replace(/^./, (c)=>c.toUpperCase());
}
function $d21cd6888b4d8a52$export$86f54f62aa7a7514(str) {
    return str.replace(/-([a-z])/g, (_, c)=>c.toUpperCase());
}
/**
 * Map px value to Symbols spacing token.
 * A=16, B=26, C=42, D=68, E=110, etc. (golden-ratio-ish scale)
 * Falls through to raw value if no close match.
 *
 * @param {string|number} value
 * @returns {string|number}
 */ const $d21cd6888b4d8a52$var$SPACING_SCALE = {
    0: '-',
    2: 'W2',
    4: 'W1',
    6: 'X2',
    8: 'X1',
    10: 'Z2',
    12: 'Z1',
    14: 'Y2',
    16: 'A',
    18: 'A1',
    20: 'A2',
    22: 'B1',
    26: 'B',
    30: 'B2',
    34: 'C1',
    42: 'C',
    50: 'C2',
    58: 'D1',
    68: 'D',
    84: 'D2',
    110: 'E',
    142: 'F',
    184: 'G',
    240: 'H'
};
function $d21cd6888b4d8a52$export$fb0bbfa60c752983(value) {
    const num = typeof value === 'string' ? parseInt(value, 10) : value;
    if (isNaN(num)) return value;
    if ($d21cd6888b4d8a52$var$SPACING_SCALE[num] !== undefined) return $d21cd6888b4d8a52$var$SPACING_SCALE[num];
    // Find closest match within 2px tolerance
    for (const [px, token] of Object.entries($d21cd6888b4d8a52$var$SPACING_SCALE)){
        if (Math.abs(num - Number(px)) <= 2) return token;
    }
    return `${num}px`;
}
/**
 * Map a CSS border-radius value to a Symbols round token.
 * @param {string|number} value
 * @returns {string|number}
 */ const $d21cd6888b4d8a52$var$ROUND_SCALE = {
    0: 0,
    2: 'W2',
    4: 'W1',
    6: 'X2',
    8: 'X1',
    10: 'Z2',
    12: 'Z1',
    16: 'A',
    9999: '100%'
};
function $d21cd6888b4d8a52$export$efad67f9c03d3708(value) {
    const num = typeof value === 'string' ? parseInt(value, 10) : value;
    if (isNaN(num)) return value;
    if (num >= 9999 || value === '50%' || value === '100%') return '100%';
    if ($d21cd6888b4d8a52$var$ROUND_SCALE[num] !== undefined) return $d21cd6888b4d8a52$var$ROUND_SCALE[num];
    return `${num}px`;
}
/**
 * Map HTML tag to Symbols semantic component name.
 * @param {string} tag
 * @returns {string}
 */ const $d21cd6888b4d8a52$var$TAG_MAP = {
    div: null,
    span: null,
    p: 'P',
    h1: 'H1',
    h2: 'H2',
    h3: 'H3',
    h4: 'H4',
    h5: 'H5',
    h6: 'H6',
    button: 'Button',
    a: 'Link',
    img: 'Img',
    nav: 'Nav',
    header: 'Header',
    main: 'Main',
    section: 'Section',
    article: 'Article',
    aside: 'Aside',
    footer: 'Footer',
    input: 'Input',
    select: 'Select',
    textarea: 'Textarea',
    form: 'Form',
    label: 'Label',
    video: 'Video',
    iframe: 'Iframe',
    ul: 'UL',
    ol: 'OL',
    li: 'LI'
};
function $d21cd6888b4d8a52$export$f27b9a4be72f580f(tag) {
    const lower = tag.toLowerCase();
    if (lower in $d21cd6888b4d8a52$var$TAG_MAP) return $d21cd6888b4d8a52$var$TAG_MAP[lower];
    return $d21cd6888b4d8a52$export$6fb43ff9addf7357(lower);
}
function $d21cd6888b4d8a52$export$daa248218ce067a5(classes) {
    return classes.flatMap((c)=>c.trim().split(/\s+/)).filter(Boolean);
}

});




parcelRegister("hRl3P", function(module, exports) {

$parcel$export(module.exports, "highlightMentions", () => $d007b9282446a2b9$export$879717283fb7d95e);
$parcel$export(module.exports, "highlightChannels", () => $d007b9282446a2b9$export$18f62f0e8314634e);
// Chat-specific @mention and #channel text-node highlighters.
// Extracted from renderMarkdown so the logic is testable in isolation.
// MarkdownPreview calls these when `withMentions: true`.
const $d007b9282446a2b9$var$_MENTION_RE = /@([a-zA-Z0-9._-]+)/g;
const $d007b9282446a2b9$var$_CHANNEL_RE = /#([a-zA-Z0-9._-]+)/g;
const $d007b9282446a2b9$export$879717283fb7d95e = (el, people)=>{
    if (!el || !el.node) return;
    const walker = document.createTreeWalker(el.node, NodeFilter.SHOW_TEXT);
    const replacements = [];
    let textNode;
    while(textNode = walker.nextNode()){
        $d007b9282446a2b9$var$_MENTION_RE.lastIndex = 0;
        if (!$d007b9282446a2b9$var$_MENTION_RE.test(textNode.textContent)) continue;
        replacements.push(textNode);
    }
    for (const node of replacements){
        if (!node.parentNode) continue;
        const frag = document.createDocumentFragment();
        let last = 0;
        $d007b9282446a2b9$var$_MENTION_RE.lastIndex = 0;
        let match;
        while((match = $d007b9282446a2b9$var$_MENTION_RE.exec(node.textContent)) !== null){
            if (match.index > last) frag.appendChild(document.createTextNode(node.textContent.slice(last, match.index)));
            const local = match[1];
            const person = (people || []).find((p)=>p.email && p.email.split('@')[0].toLowerCase() === local.toLowerCase());
            if (!person) frag.appendChild(document.createTextNode(match[0]));
            else {
                const span = document.createElement('span');
                span.textContent = '@' + person.name;
                span.style.cssText = 'color:var(--color-cyan,#66b2ff);font-weight:600;cursor:pointer;background:var(--color-cyan-a10,rgba(100,180,255,0.1));padding:1px 4px;border-radius:4px;';
                span.setAttribute('data-personrow', 'true');
                span.setAttribute('data-email', person.email);
                frag.appendChild(span);
            }
            last = match.index + match[0].length;
        }
        if (last < node.textContent.length) frag.appendChild(document.createTextNode(node.textContent.slice(last)));
        node.parentNode.replaceChild(frag, node);
    }
};
const $d007b9282446a2b9$export$18f62f0e8314634e = (el, channels)=>{
    if (!el || !el.node) return;
    const walker = document.createTreeWalker(el.node, NodeFilter.SHOW_TEXT);
    const replacements = [];
    let textNode;
    while(textNode = walker.nextNode()){
        $d007b9282446a2b9$var$_CHANNEL_RE.lastIndex = 0;
        if (!$d007b9282446a2b9$var$_CHANNEL_RE.test(textNode.textContent)) continue;
        replacements.push(textNode);
    }
    for (const node of replacements){
        if (!node.parentNode) continue;
        const frag = document.createDocumentFragment();
        let last = 0;
        $d007b9282446a2b9$var$_CHANNEL_RE.lastIndex = 0;
        let match;
        while((match = $d007b9282446a2b9$var$_CHANNEL_RE.exec(node.textContent)) !== null){
            if (match.index > last) frag.appendChild(document.createTextNode(node.textContent.slice(last, match.index)));
            const name = match[1];
            const channel = (channels || []).find((c)=>c.name && c.name.toLowerCase() === name.toLowerCase());
            if (!channel) frag.appendChild(document.createTextNode(match[0]));
            else {
                const span = document.createElement('span');
                span.textContent = '#' + channel.name;
                span.style.cssText = 'color:var(--color-cyan,#66b2ff);font-weight:600;cursor:pointer;background:var(--color-cyan-a10,rgba(100,180,255,0.1));padding:1px 4px;border-radius:4px;';
                span.setAttribute('data-channel-link', channel.id);
                frag.appendChild(span);
            }
            last = match.index + match[0].length;
        }
        if (last < node.textContent.length) frag.appendChild(document.createTextNode(node.textContent.slice(last)));
        node.parentNode.replaceChild(frag, node);
    }
};

});


parcelRegister("dqRQD", function(module, exports) {

$parcel$export(module.exports, "UploadProgress", () => $9c7779220f1baefe$export$98a3886347b629fb);
const $9c7779220f1baefe$export$98a3886347b629fb = {
    flow: 'x',
    theme: 'field',
    padding: 'Z1 Z1+V Z1 Z1',
    round: 'A2',
    position: 'relative',
    align: 'center flex-start',
    gap: 'Z',
    '@mobileS': {
        fontSize: 'Z2'
    },
    Icon: {
        theme: 'bordered',
        icon: 'copy',
        boxSizing: 'content-box',
        padding: 'Y2',
        fontSize: 'C',
        round: 'Z2'
    },
    XBtn: {
        position: 'absolute',
        top: 'Y',
        right: 'Y1',
        padding: 'Y',
        $isSafari: {
            top: '0',
            right: 'Y'
        }
    },
    Flex: {
        flow: 'y',
        gap: 'X',
        flex: '1',
        H6: {
            text: 'Image.jpg',
            alignSelf: 'flex-start',
            fontWeight: '700'
        },
        ProgressLineValue: {
            ProgressLine: {},
            UnitValue: {}
        }
    }
};

});

parcelRegister("hYzzJ", function(module, exports) {

$parcel$export(module.exports, "EmptyState", () => $d163a2c9dadda2ea$export$fddf379e22a74b00);
// Generic empty-state component for list / grid / dashboard views.
// Drop into any container with `extends: 'EmptyState'` and override
// the `icon`, `title`, `hint`, `action` props as needed.
//
// Pattern:
//   MyEmptyState: {
//     extends: 'EmptyState',
//     icon: 'people',
//     title: 'No team members yet',
//     hint: 'Invite teammates to start collaborating.',
//     action: { text: 'Invite member', onClick: (e, el, s) => ... }
//   }
//
// All strings render through `polyglot` translation when wrapped at the
// call site — empty-state copy is user-facing.
const $d163a2c9dadda2ea$export$fddf379e22a74b00 = {
    flow: 'y',
    align: 'center center',
    gap: 'A',
    padding: 'C A',
    width: '100%',
    textAlign: 'center',
    // Default props — consumers override.
    icon: null,
    title: '',
    hint: '',
    action: null,
    // Decorative icon — falls back to nothing if no icon prop.
    IconWrap: {
        if: (el)=>!!el.parent?.icon,
        flow: 'y',
        align: 'center center',
        width: 'C',
        height: 'C',
        round: '50%',
        background: 'overlay',
        color: 'caption',
        Icon: {
            icon: (el)=>el.parent.parent.icon,
            boxSize: 'A1'
        }
    },
    Title: {
        tag: 'h3',
        fontSize: 'A1',
        fontWeight: '700',
        color: 'title',
        margin: '0',
        text: (el)=>el.parent.title || ''
    },
    Hint: {
        if: (el)=>!!el.parent?.hint,
        tag: 'p',
        fontSize: 'Z2',
        color: 'caption',
        margin: '0',
        maxWidth: 'J',
        text: (el)=>el.parent.hint || ''
    },
    ActionBtn: {
        if: (el)=>!!el.parent?.action,
        tag: 'button',
        type: 'button',
        padding: 'V A',
        round: 'Z',
        background: 'blue',
        color: 'white',
        fontSize: 'Z2',
        fontWeight: '600',
        border: 'none',
        cursor: 'pointer',
        marginTop: 'V',
        text: (el)=>el.parent?.action?.text || '',
        onClick: (e, el, s)=>{
            const action = el.parent?.action;
            if (typeof action?.onClick === 'function') action.onClick(e, el, s);
        }
    }
};

});

parcelRegister("8wnar", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $6343487827d05995$export$8f31e4c4a37b8e9c);
$parcel$export(module.exports, "SkeletonRow", () => $6343487827d05995$export$8bbcb87f63697989);
$parcel$export(module.exports, "SkeletonCircle", () => $6343487827d05995$export$7d2444dbb58007d7);
$parcel$export(module.exports, "SkeletonCard", () => $6343487827d05995$export$5956eb8f2ff4afde);
// Generic skeleton placeholder. Use while async data is loading so the
// page reserves its final layout instead of flashing "Loading…" text.
//
// Usage:
//   ListLoading: {
//     extends: 'Skeleton',
//     width: '100%', height: 'A',  // override size to match final content
//     round: 'Y'
//   }
//
//   Plus the SkeletonRow / SkeletonCircle helpers for common shapes.
//
// Animation: subtle shimmer using the `pulse` keyframe defined in
// brand. Respects `prefers-reduced-motion: reduce` automatically via
// the framework's media-query handling.
const $6343487827d05995$export$8f31e4c4a37b8e9c = {
    display: 'block',
    width: '100%',
    height: 'V',
    round: 'V',
    background: 'overlay',
    // shimmer animation — gentle 1.5s loop
    animation: 'pulse 1.5s ease-in-out infinite',
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        opacity: '0.6'
    }
};
const $6343487827d05995$export$8bbcb87f63697989 = {
    extends: 'Skeleton',
    height: 'V'
};
const $6343487827d05995$export$7d2444dbb58007d7 = {
    extends: 'Skeleton',
    width: 'B',
    height: 'B',
    round: '50%'
};
const $6343487827d05995$export$5956eb8f2ff4afde = {
    flow: 'y',
    gap: 'V',
    padding: 'A',
    round: 'Z',
    background: 'overlay',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'line',
    Title: {
        extends: 'SkeletonRow',
        width: '60%',
        height: 'V1'
    },
    Line_1: {
        extends: 'SkeletonRow',
        width: '100%'
    },
    Line_2: {
        extends: 'SkeletonRow',
        width: '80%'
    }
};

});

parcelRegister("3K57D", function(module, exports) {

$parcel$export(module.exports, "ErrorState", () => $2b99a41b64c08ce4$export$c1ed4f415b9e7023);
// Generic error / access-denied state for pages that fail to load or
// gate the user. Distinct from EmptyState (which is "no data yet") —
// this is for "something is wrong" or "you don't have permission."
//
// Usage:
//   PageBody: {
//     ErrorState: {
//       kind: 'forbidden',          // 'forbidden' | 'notFound' | 'serverError' | 'offline'
//       title: 'You don't have access',
//       hint: 'Ask an admin to grant the `admin.pages.read` permission.',
//       action: { text: 'Back to home', onClick: ... }
//     }
//   }
//
// `kind` selects the icon + default copy; `title` / `hint` / `action`
// override individual fields.
const $2b99a41b64c08ce4$var$_kindDefaults = {
    forbidden: {
        icon: 'lock',
        title: 'You don\'t have access',
        hint: 'Ask an admin to grant the right permission.'
    },
    notFound: {
        icon: 'search',
        title: 'Not found',
        hint: 'The page you\'re looking for doesn\'t exist.'
    },
    serverError: {
        icon: 'warning',
        title: 'Something went wrong',
        hint: 'A server error broke the page. Try again in a moment.'
    },
    offline: {
        icon: 'wifi',
        title: 'You\'re offline',
        hint: 'Reconnect to the internet to load this page.'
    },
    generic: {
        icon: 'warning',
        title: 'Couldn\'t load',
        hint: 'Refresh the page to try again.'
    }
};
const $2b99a41b64c08ce4$var$_resolve = (el, key)=>{
    const defaults = $2b99a41b64c08ce4$var$_kindDefaults[el.kind || 'generic'] || $2b99a41b64c08ce4$var$_kindDefaults.generic;
    return el[key] != null ? el[key] : defaults[key];
};
const $2b99a41b64c08ce4$export$c1ed4f415b9e7023 = {
    flow: 'y',
    align: 'center center',
    gap: 'A',
    padding: 'C A',
    width: '100%',
    textAlign: 'center',
    // Live region so screen readers announce the error when the page
    // swaps in. role=alert for high priority.
    attr: {
        role: 'alert',
        'aria-live': 'assertive'
    },
    // Default props — consumers override.
    kind: 'generic',
    title: null,
    hint: null,
    action: null,
    IconWrap: {
        flow: 'y',
        align: 'center center',
        width: 'C',
        height: 'C',
        round: '50%',
        background: 'overlay',
        color: 'red',
        Icon: {
            icon: (el)=>$2b99a41b64c08ce4$var$_resolve(el.parent.parent, 'icon'),
            boxSize: 'A1'
        }
    },
    Title: {
        tag: 'h2',
        fontSize: 'A2',
        fontWeight: '700',
        color: 'title',
        margin: '0',
        text: (el)=>$2b99a41b64c08ce4$var$_resolve(el.parent, 'title')
    },
    Hint: {
        tag: 'p',
        fontSize: 'Z2',
        color: 'caption',
        margin: '0',
        maxWidth: 'J',
        text: (el)=>$2b99a41b64c08ce4$var$_resolve(el.parent, 'hint')
    },
    ActionBtn: {
        if: (el)=>!!el.parent?.action,
        tag: 'button',
        type: 'button',
        padding: 'V A',
        round: 'Z',
        background: 'blue',
        color: 'white',
        fontSize: 'Z2',
        fontWeight: '600',
        border: 'none',
        cursor: 'pointer',
        marginTop: 'V',
        text: (el)=>el.parent?.action?.text || '',
        onClick: (e, el, s)=>{
            const action = el.parent?.action;
            if (typeof action?.onClick === 'function') action.onClick(e, el, s);
        }
    }
};

});

parcelRegister("lgx1I", function(module, exports) {

$parcel$export(module.exports, "AppLoginCard", () => $f7b4b6050c316a3d$export$cd6e459637a32325);

var $8RlGv = parcelRequire("8RlGv");
// Mirrors shared/pages/auth/signin.js — fan out to Supabase federation
// after Symbols SDK login. Best-effort, non-blocking.
const $f7b4b6050c316a3d$var$_fanOutBridgeLogin = async (email, password)=>{
    // Workspace login is the governance entry point — governance MUST mint
    // its session at login time, otherwise every /workspace/* call 401s.
    // Re-assert the workspace-project app config at the call site because
    // shared/pages/auth/signin.js (loaded as part of the identity bundle)
    // also calls configureSdkBridge with `required: []` at module-top —
    // whichever module loads last wins, and on /login the editor's
    // signin.js wins, leaving governance optional + skipped (its
    // shouldActivate(claims) predicate returns false on empty claims).
    (0, $8RlGv.configure)({
        required: [
            (0, $8RlGv.PROJECT_GOVERNANCE)
        ]
    });
    try {
        const result = await (0, $8RlGv.loginAll)({
            email: email,
            password: password
        });
        if (!result.ok) console.warn('[AppLoginCard] bridge login error:', result.error?.message);
        else {
            const failed = result.results.filter((r)=>r.status === 'error');
            if (failed.length) for (const r of failed)console.warn(`[AppLoginCard] bridge ${r.key} failed:`, r.error?.message);
        }
    } catch (err) {
        console.warn('[AppLoginCard] bridge login threw:', err?.message || err);
    }
};
const $f7b4b6050c316a3d$var$_input = {
    tag: 'input',
    width: '100%',
    padding: 'A B',
    round: 'C',
    background: 'overlayStrong',
    border: 'none',
    outline: 'none',
    color: 'title',
    fontSize: 'A',
    boxSizing: 'border-box',
    // Visible focus ring for keyboard users — WCAG 2.4.7. The default
    // `outline: none` above strips the UA ring; restore it via box-shadow
    // on `:focus-visible` so mouse focus still gets a clean border-only
    // state.
    ':focus-visible': {
        boxShadow: '0 0 0 2px var(--color-blue)',
        outline: 'none'
    }
};
const $f7b4b6050c316a3d$export$cd6e459637a32325 = {
    flow: 'y',
    gap: 'C',
    padding: 'D',
    width: '100%',
    maxWidth: 'I',
    round: 'C',
    background: 'overlay',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'line',
    boxShadow: '0 24px 60px -24px var(--color-shadow)',
    eyebrow: 'Sign in',
    title: 'Welcome back',
    sub: 'Sign in to your workspace with your email and password.',
    redirectTo: '/',
    Head: {
        flow: 'y',
        gap: 'A',
        Eyebrow: {
            tag: 'span',
            fontSize: 'Z2',
            fontWeight: '700',
            letterSpacing: '0.12em',
            textTransform: 'uppercase',
            color: 'blue',
            text: (el)=>el.parent.parent.eyebrow || ''
        },
        Title: {
            // h1 — primary page heading. The login page is its own page, so a
            // single h1 here lands at the top of the document outline, which
            // every screen reader announces on landing.
            tag: 'h1',
            id: 'login-title',
            fontSize: 'D',
            fontWeight: '800',
            color: 'title',
            letterSpacing: '-0.02em',
            text: (el)=>el.parent.parent.title || ''
        },
        Sub: {
            tag: 'p',
            id: 'login-sub',
            color: 'caption',
            fontSize: 'A',
            text: (el)=>el.parent.parent.sub || ''
        }
    },
    Form: {
        tag: 'form',
        flow: 'y',
        gap: 'A',
        // The form's accessible name is the page title; its description is
        // the sub-line. Together they tell a screen reader user what the
        // form does + what credentials it expects.
        'aria-labelledby': 'login-title',
        'aria-describedby': 'login-sub login-error',
        onSubmit: async (ev, el, s)=>{
            ev.preventDefault();
            const root = el.node;
            const email = (root.querySelector('input[name="email"]')?.value || '').trim().toLowerCase();
            const password = root.querySelector('input[name="password"]')?.value || '';
            const errBox = root.querySelector('[data-lg-err]');
            if (errBox) errBox.textContent = '';
            if (!email || !password) {
                if (errBox) errBox.textContent = 'Email and password are required.';
                return;
            }
            s.root.update({
                _loginLoading: true
            });
            try {
                // Symbols SDK + sdk-bridge federation + token persistence (matches signin.js).
                // signInWithPassword (Supabase direct) was removed — single auth flow.
                const data = await el.sdk.login(email, password);
                const resolvedEmail = data?.user?.email || email;
                // Await federation BEFORE the redirect — otherwise the page
                // navigates away mid-flight and the governance Supabase JWT
                // never gets persisted, leaving the workspace 401-ing on
                // every API call. _fanOutBridgeLogin swallows its own errors.
                await $f7b4b6050c316a3d$var$_fanOutBridgeLogin(resolvedEmail, password);
                await el.call('initializeUserSession', {
                    loginData: data
                });
                s.root.update({
                    signedIn: true,
                    currentUserEmail: resolvedEmail,
                    currentUserId: data?.user?.id || null
                });
                if (typeof window !== 'undefined') {
                    const target = el.parent && el.parent.redirectTo || '/';
                    window.location.replace(target);
                }
            } catch (e) {
                s.root.update({
                    _loginLoading: false
                });
                if (errBox) errBox.textContent = e.message || 'Sign-in failed.';
            }
        },
        // Email field — explicit labels + input. Use unique key names to
        // avoid clashing with any registered `Email` / `Password` /
        // `Label` brand components via smbls auto-extend.
        EmailLabel: {
            tag: 'label',
            attr: {
                for: 'login-email'
            },
            fontSize: 'Z2',
            fontWeight: '600',
            color: 'caption',
            text: 'Email'
        },
        EmailInput: {
            ...$f7b4b6050c316a3d$var$_input,
            id: 'login-email',
            type: 'email',
            name: 'email',
            placeholder: 'name@symbols.app',
            required: 'true',
            autocomplete: 'email',
            'aria-required': 'true',
            'aria-describedby': 'login-error'
        },
        PasswordRow: {
            flow: 'x',
            align: 'space-between center',
            gap: 'A',
            marginTop: 'V',
            PasswordLabel: {
                tag: 'label',
                attr: {
                    for: 'login-password'
                },
                fontSize: 'Z2',
                fontWeight: '600',
                color: 'caption',
                text: 'Password'
            },
            ForgotLink: {
                tag: 'a',
                href: '/reset-password',
                fontSize: 'Z2',
                color: 'blue',
                textDecoration: 'none',
                ':hover': {
                    textDecoration: 'underline'
                },
                text: 'Forgot password?'
            }
        },
        PasswordInput: {
            ...$f7b4b6050c316a3d$var$_input,
            id: 'login-password',
            type: 'password',
            name: 'password',
            placeholder: 'Password',
            required: 'true',
            autocomplete: 'current-password',
            'aria-required': 'true',
            'aria-describedby': 'login-error'
        },
        // Error span: aria-live=polite so screen readers announce the
        // message when it appears, role=status as a graceful fallback for
        // older AT. data-lg-err kept for the imperative writer above.
        Error: {
            tag: 'span',
            id: 'login-error',
            attr: {
                'data-lg-err': 'true',
                role: 'status',
                'aria-live': 'polite'
            },
            fontSize: 'Z2',
            color: 'red',
            minHeight: 'A'
        },
        Submit: {
            tag: 'button',
            type: 'submit',
            width: '100%',
            padding: 'A B',
            round: 'C',
            background: 'blue',
            color: 'white',
            fontSize: 'A',
            fontWeight: '700',
            border: 'none',
            marginTop: 'V',
            cursor: (el, s)=>s.root?._loginLoading ? 'wait' : 'pointer',
            opacity: (el, s)=>s.root?._loginLoading ? '0.7' : '1',
            pointerEvents: (el, s)=>s.root?._loginLoading ? 'none' : 'auto',
            disabled: (el, s)=>s.root?._loginLoading ? 'true' : null,
            text: (el, s)=>s.root?._loginLoading ? "Signing in\u2026" : 'Sign in',
            ':hover': {
                background: 'blue.7'
            },
            ':focus-visible': {
                outline: 'none',
                boxShadow: '0 0 0 3px var(--color-blue), 0 0 0 5px var(--color-overlay)'
            }
        }
    },
    Footer: {
        tag: 'span',
        fontSize: 'Z2',
        color: 'caption',
        align: 'center',
        text: 'No account? Ask an admin to create one for you.'
    }
};

});

parcelRegister("zMrNZ", function(module, exports) {

$parcel$export(module.exports, "TicketsCanvas", () => $06b8d9a87002eff9$export$89bed3eb7cd8c3b3);
// B-110 — shared DOMQL v3.14 wrapper around cytoscape.js.
//
// Uses local cytoscape + cytoscape-dagre packages (both in package.json)
// instead of CDN dynamic imports. CDN dynamic imports caused two issues:
// (1) Parcel did not always pick up CDN URL changes and served stale bundles
// that fell back to the synchronous `cose` layout, which blocks the main
// thread for several seconds with 200+ nodes (B-122/B-124 perceived hang).
// (2) Network-gated CDN calls added variable startup latency.
// The workspace has cytoscape@^3.33 + cytoscape-dagre@^2.5 in its deps so
// the local import path is safe.
//
// Consumer contract:
//   TicketsCanvas: {
//     nodes: [{ id, label, kind, status, parent? }],
//     edges: [{ source, target, kind }],
//     onNodeClick: (nodeData) => void
//   }
//
// Status → color mapping mirrors the ops-dashboard palette
// (/tmp/progress-dashboard.html). These values are library-internal
// (fed to cytoscape's style DSL, not DOMQL) so raw hex is the correct
// idiom here despite CLAUDE.md's "no raw hex" rule — cytoscape can't
// read CSS custom properties from its JS config.

var $lsJox = parcelRequire("lsJox");

var $cTjUK = parcelRequire("cTjUK");
// Register once — cytoscape-dagre.register() is idempotent.
try {
    (0, (/*@__PURE__*/$parcel$interopDefault($cTjUK)))((0, $lsJox.default));
} catch (_) {}
const $06b8d9a87002eff9$var$STATUS_COLORS = {
    'shipped': '#4ade80',
    'in-progress': '#fbbf24',
    'blocked': '#f87171',
    'paused': '#8b8b8b',
    'not-started': '#60a5fa' // info
};
const $06b8d9a87002eff9$var$KIND_SHAPES = {
    'epic': 'hexagon',
    'story': 'round-rectangle',
    'task': 'ellipse',
    'bug': 'diamond',
    'decision': 'tag'
};
const $06b8d9a87002eff9$export$89bed3eb7cd8c3b3 = {
    tag: 'div',
    width: '100%',
    // 2026-04-24: 85vh explicit height + flexShrink:0 so flex-column
    // parents (CanvasMain.Body uses flow:'y') can't stretch it. Dropped
    // `minHeight: 'L+L+L'` — --spacing-L resolves to ~3072px (11 powers
    // of 1.618 from 1em) so 2×L = ~6144px forced the container to
    // 6730px tall. 85vh alone is authoritative now.
    height: '85vh',
    flexShrink: '0',
    background: 'overlay',
    round: 'A',
    borderWidth: 'V',
    borderStyle: 'solid',
    borderColor: 'line',
    position: 'relative',
    overflow: 'hidden',
    onCreate: async (el, s)=>{
        if (typeof window === 'undefined' || !el.node) return;
        try {
            // cytoscape + cytoscape-dagre are bundled locally (see imports at top).
            // No CDN round-trip — registration already happened at module load.
            // DOMQL v3.14 stores arbitrary element-level props as-given. Factory
            // callbacks are NOT auto-resolved for custom prop names (only
            // built-in style/layout props are). Call the factory if we got
            // one; pass through arrays + undefined falls back to empty.
            const _resolve = (prop)=>{
                if (typeof prop === 'function') try {
                    return prop(el, el.state || {
                        root: {}
                    });
                } catch  {
                    return [];
                }
                return prop;
            };
            // Cytoscape mounts ONCE in onCreate + doesn't observe later state
            // updates. Consumer pages typically populate nodes/edges in an
            // async onCreate that resolves AFTER this mount fires → we see
            // an empty array at first. Wait up to 5s for the factory to
            // return real data before mounting with whatever we have.
            let rawNodes = _resolve(el.nodes) || [];
            let rawEdges = _resolve(el.edges) || [];
            if (!rawNodes.length) {
                const start = Date.now();
                while(!rawNodes.length && Date.now() - start < 5000){
                    await new Promise((r)=>setTimeout(r, 50));
                    rawNodes = _resolve(el.nodes) || [];
                    rawEdges = _resolve(el.edges) || [];
                }
            }
            // If consumer passes node.position, use cytoscape `preset` layout
            // for deterministic grid placement. Otherwise fall back to cose.
            const hasPositions = rawNodes.some((n)=>n && n.position && Number.isFinite(n.position.x) && Number.isFinite(n.position.y));
            const elements = [
                ...rawNodes.map((n)=>({
                        data: {
                            id: n.id,
                            label: n.blocked ? `\u{1F512} ${n.label || n.id}` : n.label || n.id,
                            kind: n.kind || 'task',
                            status: n.status || 'not-started',
                            parent: n.parent || undefined,
                            blocked: n.blocked ? 1 : 0,
                            _statusColor: $06b8d9a87002eff9$var$STATUS_COLORS[n.status] || $06b8d9a87002eff9$var$STATUS_COLORS['not-started'],
                            _shape: $06b8d9a87002eff9$var$KIND_SHAPES[n.kind] || 'ellipse'
                        },
                        // Cytoscape ignores `position` on compound parents (they
                        // auto-size to contain children) but accepts it on leaves +
                        // un-parented nodes. Pass through when present.
                        ...hasPositions && n.position ? {
                            position: {
                                x: n.position.x,
                                y: n.position.y
                            }
                        } : {}
                    })),
                ...rawEdges.map((e)=>({
                        data: {
                            id: `${e.source}->${e.target}`,
                            source: e.source,
                            target: e.target,
                            kind: e.kind || 'hierarchy'
                        }
                    }))
            ];
            const cy = (0, $lsJox.default)({
                container: el.node,
                elements: elements,
                style: [
                    // Leaf nodes (tasks + bugs — no children).
                    {
                        selector: 'node',
                        style: {
                            'background-color': 'data(_statusColor)',
                            'shape': 'data(_shape)',
                            'label': 'data(label)',
                            'color': '#ededed',
                            'font-size': '10px',
                            'font-weight': '600',
                            'text-valign': 'center',
                            'text-halign': 'center',
                            'text-wrap': 'wrap',
                            'text-max-width': '110px',
                            'width': 70,
                            'height': 70,
                            'border-width': 1,
                            'border-color': '#2a2a30'
                        }
                    },
                    // Compound parents (epics + stories) — render as boxes that
                    // visually contain their children so the 3-level nesting is
                    // legible (B-120 fix).
                    {
                        selector: ':parent',
                        style: {
                            'background-color': 'data(_statusColor)',
                            'background-opacity': 0.12,
                            'border-width': 2,
                            'border-color': 'data(_statusColor)',
                            'border-opacity': 0.6,
                            'label': 'data(label)',
                            'color': '#ededed',
                            'font-size': '13px',
                            'font-weight': '700',
                            'text-valign': 'top',
                            'text-halign': 'center',
                            'text-margin-y': -8,
                            'padding': 20,
                            'shape': 'round-rectangle',
                            'text-wrap': 'wrap',
                            'text-max-width': '240px'
                        }
                    },
                    // Epics — larger node + thicker border so they read as roots
                    // in the hierarchy tree.
                    {
                        selector: 'node[kind="epic"]',
                        style: {
                            'width': 110,
                            'height': 110,
                            'font-size': '14px',
                            'border-width': 3,
                            'text-max-width': '150px'
                        }
                    },
                    // Stories — medium-sized, distinct shape (round-rectangle).
                    {
                        selector: 'node[kind="story"]',
                        style: {
                            'width': 90,
                            'height': 60,
                            'font-size': '11px',
                            'text-max-width': '130px'
                        }
                    },
                    // Hierarchy edges — parent-child arrows generated from parent_ticket_id.
                    // Rendered as subtle solid lines so they don't compete with dep arrows.
                    {
                        selector: 'edge[kind="hierarchy"]',
                        style: {
                            'line-color': '#6b7280',
                            'target-arrow-color': '#6b7280',
                            'target-arrow-shape': 'triangle',
                            'curve-style': 'straight',
                            'width': 1,
                            'opacity': 0.35
                        }
                    },
                    {
                        selector: 'edge[kind="dependency"]',
                        style: {
                            'line-color': '#5eead4',
                            'target-arrow-color': '#5eead4',
                            'target-arrow-shape': 'triangle',
                            'curve-style': 'bezier',
                            'line-style': 'dashed',
                            'width': 2,
                            'opacity': 0.7
                        }
                    },
                    // MIGRATION Phase 2.1 — ticket_dependencies edges (red for blocked_by/
                    // waits_on_ship, teal for related).
                    {
                        selector: 'edge[kind="dep"]',
                        style: {
                            'line-color': '#f87171',
                            'target-arrow-color': '#f87171',
                            'target-arrow-shape': 'triangle',
                            'curve-style': 'bezier',
                            'line-style': 'dashed',
                            'width': 2,
                            'opacity': 0.8
                        }
                    },
                    {
                        selector: 'edge[kind="related"]',
                        style: {
                            'line-color': '#5eead4',
                            'target-arrow-shape': 'none',
                            'curve-style': 'bezier',
                            'line-style': 'dotted',
                            'width': 1,
                            'opacity': 0.5
                        }
                    },
                    // 🔒 overlay for nodes whose blocked_by deps aren't shipped.
                    {
                        selector: 'node[?blocked]',
                        style: {
                            'border-color': '#f87171',
                            'border-width': 3,
                            'border-style': 'dashed'
                        }
                    }
                ],
                // Layout selection:
                //   - `preset` when the consumer precomputed positions
                //   - `dagre` when hierarchy edges are present (Epic → Story → Task/Bug)
                //     Renders a proper top-down DAG tree. dagre is bundled locally
                //     (cytoscape-dagre in package.json) so no CDN latency.
                //   - `cose` as a last-resort force-directed fallback (graphs with
                //     no hierarchy edges and no preset positions)
                layout: hasPositions ? {
                    name: 'preset',
                    fit: true,
                    padding: 40,
                    animate: false
                } : rawEdges.some((e)=>e && e.kind === 'hierarchy') ? {
                    // Dagre top-down tree: epic roots at top, stories below,
                    // tasks + bugs at the leaves. Independent epic subtrees
                    // stack side-by-side automatically because dagre builds
                    // each connected component into its own column.
                    name: 'dagre',
                    rankDir: 'TB',
                    nodeSep: 18,
                    rankSep: 60,
                    edgeSep: 10,
                    ranker: 'tight-tree',
                    padding: 40,
                    animate: false,
                    fit: true
                } : {
                    name: 'cose',
                    animate: false,
                    randomize: false,
                    componentSpacing: 40,
                    nodeOverlap: 8,
                    idealEdgeLength: 60,
                    edgeElasticity: 100,
                    numIter: 600,
                    initialTemp: 150,
                    coolingFactor: 0.95,
                    nestingFactor: 1.2,
                    gravity: 80
                },
                wheelSensitivity: 0.2
            });
            // Fit the graph to the container after the cose layout stops.
            // Without this, cose can leave the viewport panned off-screen —
            // a 12-node / 85vh container otherwise renders as a black panel.
            cy.one('layoutstop', ()=>{
                try {
                    cy.fit(undefined, 32);
                } catch  {}
            });
            // Click handling: write to root state under `el.selectedKey` (default
            // 'selectedCanvasNode') so the consumer can render a selected-node
            // info panel / deep-link without passing an onNodeClick closure.
            // Also invokes `el.onNodeClick(data)` if the consumer supplied one
            // (legacy callback path — kept for flexibility).
            const selectedKey = el.selectedKey || 'selectedCanvasNode';
            cy.on('tap', 'node', (evt)=>{
                const data = evt.target.data();
                const root = el.state?.root;
                if (root && typeof root.update === 'function') root.update({
                    [selectedKey]: data
                });
                if (typeof el.onNodeClick === 'function') try {
                    el.onNodeClick(data);
                } catch  {}
            });
            el._cytoscape = cy;
        } catch (err) {
            if (el.node) el.node.innerHTML = `<div style="padding:24px;color:#8b8b8b;text-align:center;">` + `<strong style="color:#f87171">TicketsCanvas load failed</strong><br>` + `<small>${err && err.message || 'unknown error'}</small></div>`;
            console.error('[TicketsCanvas] load failed', err?.message || err);
        }
    },
    onRemove: (el)=>{
        if (el._cytoscape) {
            try {
                el._cytoscape.destroy();
            } catch  {}
            el._cytoscape = null;
        }
    }
};

});
parcelRegister("lsJox", function(module, exports) {

$parcel$export(module.exports, "default", () => $e815fda779bc047b$export$2e2bcd8739ae039);
/**
 * Copyright (c) 2016-2026, The Cytoscape Consortium.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the “Software”), to deal in
 * the Software without restriction, including without limitation the rights to
 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies
 * of the Software, and to permit persons to whom the Software is furnished to do
 * so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED “AS IS”, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ function $e815fda779bc047b$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $e815fda779bc047b$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $e815fda779bc047b$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $e815fda779bc047b$var$_arrayLikeToArray(r);
}
function $e815fda779bc047b$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $e815fda779bc047b$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, $e815fda779bc047b$var$_toPropertyKey(o.key), o);
    }
}
function $e815fda779bc047b$var$_createClass(e, r, t) {
    return r && $e815fda779bc047b$var$_defineProperties(e.prototype, r), Object.defineProperty(e, "prototype", {
        writable: false
    }), e;
}
function $e815fda779bc047b$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $e815fda779bc047b$var$_unsupportedIterableToArray(r)) || e) {
            t && (r = t);
            var n = 0, F = function() {};
            return {
                s: F,
                n: function() {
                    return n >= r.length ? {
                        done: true
                    } : {
                        done: false,
                        value: r[n++]
                    };
                },
                e: function(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = true, u = false;
    return {
        s: function() {
            t = t.call(r);
        },
        n: function() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function(r) {
            u = true, o = r;
        },
        f: function() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $e815fda779bc047b$var$_defineProperty$1(e, r, t) {
    return (r = $e815fda779bc047b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function $e815fda779bc047b$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $e815fda779bc047b$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = true, o = false;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = true, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $e815fda779bc047b$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e815fda779bc047b$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e815fda779bc047b$var$_slicedToArray(r, e) {
    return $e815fda779bc047b$var$_arrayWithHoles(r) || $e815fda779bc047b$var$_iterableToArrayLimit(r, e) || $e815fda779bc047b$var$_unsupportedIterableToArray(r, e) || $e815fda779bc047b$var$_nonIterableRest();
}
function $e815fda779bc047b$var$_toConsumableArray(r) {
    return $e815fda779bc047b$var$_arrayWithoutHoles(r) || $e815fda779bc047b$var$_iterableToArray(r) || $e815fda779bc047b$var$_unsupportedIterableToArray(r) || $e815fda779bc047b$var$_nonIterableSpread();
}
function $e815fda779bc047b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (undefined !== e) {
        var i = e.call(t, r);
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(t);
}
function $e815fda779bc047b$var$_toPropertyKey(t) {
    var i = $e815fda779bc047b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $e815fda779bc047b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e815fda779bc047b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e815fda779bc047b$var$_typeof(o);
}
function $e815fda779bc047b$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $e815fda779bc047b$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $e815fda779bc047b$var$_arrayLikeToArray(r, a) : undefined;
    }
}
var $e815fda779bc047b$var$_window = typeof window === 'undefined' ? null : window; // eslint-disable-line no-undef
var $e815fda779bc047b$var$navigator = $e815fda779bc047b$var$_window ? $e815fda779bc047b$var$_window.navigator : null;
$e815fda779bc047b$var$_window && $e815fda779bc047b$var$_window.document;
var $e815fda779bc047b$var$typeofstr = $e815fda779bc047b$var$_typeof('');
var $e815fda779bc047b$var$typeofobj = $e815fda779bc047b$var$_typeof({});
var $e815fda779bc047b$var$typeoffn = $e815fda779bc047b$var$_typeof(function() {});
var $e815fda779bc047b$var$typeofhtmlele = typeof HTMLElement === "undefined" ? "undefined" : $e815fda779bc047b$var$_typeof(HTMLElement);
var $e815fda779bc047b$var$instanceStr = function instanceStr(obj) {
    return obj && obj.instanceString && $e815fda779bc047b$var$fn$6(obj.instanceString) ? obj.instanceString() : null;
};
var $e815fda779bc047b$var$string = function string(obj) {
    return obj != null && $e815fda779bc047b$var$_typeof(obj) == $e815fda779bc047b$var$typeofstr;
};
var $e815fda779bc047b$var$fn$6 = function fn(obj) {
    return obj != null && $e815fda779bc047b$var$_typeof(obj) === $e815fda779bc047b$var$typeoffn;
};
var $e815fda779bc047b$var$array = function array(obj) {
    return !$e815fda779bc047b$var$elementOrCollection(obj) && (Array.isArray ? Array.isArray(obj) : obj != null && obj instanceof Array);
};
var $e815fda779bc047b$var$plainObject = function plainObject(obj) {
    return obj != null && $e815fda779bc047b$var$_typeof(obj) === $e815fda779bc047b$var$typeofobj && !$e815fda779bc047b$var$array(obj) && obj.constructor === Object;
};
var $e815fda779bc047b$var$object = function object(obj) {
    return obj != null && $e815fda779bc047b$var$_typeof(obj) === $e815fda779bc047b$var$typeofobj;
};
var $e815fda779bc047b$var$number$1 = function number(obj) {
    return obj != null && $e815fda779bc047b$var$_typeof(obj) === $e815fda779bc047b$var$_typeof(1) && !isNaN(obj);
};
var $e815fda779bc047b$var$integer = function integer(obj) {
    return $e815fda779bc047b$var$number$1(obj) && Math.floor(obj) === obj;
};
var $e815fda779bc047b$var$htmlElement = function htmlElement(obj) {
    if ('undefined' === $e815fda779bc047b$var$typeofhtmlele) return undefined;
    else return null != obj && obj instanceof HTMLElement;
};
var $e815fda779bc047b$var$elementOrCollection = function elementOrCollection(obj) {
    return $e815fda779bc047b$var$element(obj) || $e815fda779bc047b$var$collection(obj);
};
var $e815fda779bc047b$var$element = function element(obj) {
    return $e815fda779bc047b$var$instanceStr(obj) === 'collection' && obj._private.single;
};
var $e815fda779bc047b$var$collection = function collection(obj) {
    return $e815fda779bc047b$var$instanceStr(obj) === 'collection' && !obj._private.single;
};
var $e815fda779bc047b$var$core = function core(obj) {
    return $e815fda779bc047b$var$instanceStr(obj) === 'core';
};
var $e815fda779bc047b$var$stylesheet = function stylesheet(obj) {
    return $e815fda779bc047b$var$instanceStr(obj) === 'stylesheet';
};
var $e815fda779bc047b$var$event = function event(obj) {
    return $e815fda779bc047b$var$instanceStr(obj) === 'event';
};
var $e815fda779bc047b$var$emptyString = function emptyString(obj) {
    if (obj === undefined || obj === null) // null is empty
    return true;
    else if (obj === '' || obj.match(/^\s+$/)) return true; // empty string is empty
    return false; // otherwise, we don't know what we've got
};
var $e815fda779bc047b$var$domElement = function domElement(obj) {
    if (typeof HTMLElement === 'undefined') return false; // we're not in a browser so it doesn't matter
    else return obj instanceof HTMLElement;
};
var $e815fda779bc047b$var$boundingBox = function boundingBox(obj) {
    return $e815fda779bc047b$var$plainObject(obj) && $e815fda779bc047b$var$number$1(obj.x1) && $e815fda779bc047b$var$number$1(obj.x2) && $e815fda779bc047b$var$number$1(obj.y1) && $e815fda779bc047b$var$number$1(obj.y2);
};
var $e815fda779bc047b$var$promise = function promise(obj) {
    return $e815fda779bc047b$var$object(obj) && $e815fda779bc047b$var$fn$6(obj.then);
};
var $e815fda779bc047b$var$ms = function ms() {
    return $e815fda779bc047b$var$navigator && $e815fda779bc047b$var$navigator.userAgent.match(/msie|trident|edge/i);
}; // probably a better way to detect this...
var $e815fda779bc047b$var$memoize = function memoize(fn, keyFn) {
    if (!keyFn) keyFn = function keyFn() {
        if (arguments.length === 1) return arguments[0];
        else if (arguments.length === 0) return 'undefined';
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        return args.join('$');
    };
    var _memoizedFn = function memoizedFn() {
        var self1 = this;
        var args = arguments;
        var ret;
        var k = keyFn.apply(self1, args);
        var cache = _memoizedFn.cache;
        if (!(ret = cache[k])) ret = cache[k] = fn.apply(self1, args);
        return ret;
    };
    _memoizedFn.cache = {};
    return _memoizedFn;
};
var $e815fda779bc047b$var$camel2dash = $e815fda779bc047b$var$memoize(function(str) {
    return str.replace(/([A-Z])/g, function(v) {
        return '-' + v.toLowerCase();
    });
});
var $e815fda779bc047b$var$dash2camel = $e815fda779bc047b$var$memoize(function(str) {
    return str.replace(/(-\w)/g, function(v) {
        return v[1].toUpperCase();
    });
});
var $e815fda779bc047b$var$prependCamel = $e815fda779bc047b$var$memoize(function(prefix, str) {
    return prefix + str[0].toUpperCase() + str.substring(1);
}, function(prefix, str) {
    return prefix + '$' + str;
});
var $e815fda779bc047b$var$capitalize = function capitalize(str) {
    if ($e815fda779bc047b$var$emptyString(str)) return str;
    return str.charAt(0).toUpperCase() + str.substring(1);
};
var $e815fda779bc047b$var$endsWith = function endsWith(string, suffix) {
    return string.slice(-1 * suffix.length) === suffix;
};
var $e815fda779bc047b$var$number = '(?:[-+]?(?:(?:\\d+|\\d*\\.\\d+)(?:[Ee][+-]?\\d+)?))';
var $e815fda779bc047b$var$rgba = 'rgb[a]?\\((' + $e815fda779bc047b$var$number + '[%]?)\\s*,\\s*(' + $e815fda779bc047b$var$number + '[%]?)\\s*,\\s*(' + $e815fda779bc047b$var$number + '[%]?)(?:\\s*,\\s*(' + $e815fda779bc047b$var$number + '))?\\)';
var $e815fda779bc047b$var$rgbaNoBackRefs = 'rgb[a]?\\((?:' + $e815fda779bc047b$var$number + '[%]?)\\s*,\\s*(?:' + $e815fda779bc047b$var$number + '[%]?)\\s*,\\s*(?:' + $e815fda779bc047b$var$number + '[%]?)(?:\\s*,\\s*(?:' + $e815fda779bc047b$var$number + '))?\\)';
var $e815fda779bc047b$var$hsla = 'hsl[a]?\\((' + $e815fda779bc047b$var$number + ')\\s*,\\s*(' + $e815fda779bc047b$var$number + '[%])\\s*,\\s*(' + $e815fda779bc047b$var$number + '[%])(?:\\s*,\\s*(' + $e815fda779bc047b$var$number + '))?\\)';
var $e815fda779bc047b$var$hslaNoBackRefs = 'hsl[a]?\\((?:' + $e815fda779bc047b$var$number + ')\\s*,\\s*(?:' + $e815fda779bc047b$var$number + '[%])\\s*,\\s*(?:' + $e815fda779bc047b$var$number + '[%])(?:\\s*,\\s*(?:' + $e815fda779bc047b$var$number + '))?\\)';
var $e815fda779bc047b$var$hex3 = '\\#[0-9a-fA-F]{3}';
var $e815fda779bc047b$var$hex6 = '\\#[0-9a-fA-F]{6}';
var $e815fda779bc047b$var$ascending = function ascending(a, b) {
    if (a < b) return -1;
    else if (a > b) return 1;
    else return 0;
};
var $e815fda779bc047b$var$descending = function descending(a, b) {
    return -1 * $e815fda779bc047b$var$ascending(a, b);
};
var $e815fda779bc047b$var$extend = Object.assign != null ? Object.assign.bind(Object) : function(tgt) {
    var args = arguments;
    for(var i = 1; i < args.length; i++){
        var obj = args[i];
        if (obj == null) continue;
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; j++){
            var k = keys[j];
            tgt[k] = obj[k];
        }
    }
    return tgt;
};
// get [r, g, b] from #abc or #aabbcc
var $e815fda779bc047b$var$hex2tuple = function hex2tuple(hex) {
    if (!(hex.length === 4 || hex.length === 7) || hex[0] !== '#') return;
    var shortHex = hex.length === 4;
    var r, g, b;
    var base = 16;
    if (shortHex) {
        r = parseInt(hex[1] + hex[1], base);
        g = parseInt(hex[2] + hex[2], base);
        b = parseInt(hex[3] + hex[3], base);
    } else {
        r = parseInt(hex[1] + hex[2], base);
        g = parseInt(hex[3] + hex[4], base);
        b = parseInt(hex[5] + hex[6], base);
    }
    return [
        r,
        g,
        b
    ];
};
// get [r, g, b, a] from hsl(0, 0, 0) or hsla(0, 0, 0, 0)
var $e815fda779bc047b$var$hsl2tuple = function hsl2tuple(hsl) {
    var ret;
    var h, s, l, a, r, g, b;
    function hue2rgb(p, q, t) {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 0.5) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
    }
    var m1 = new RegExp('^' + $e815fda779bc047b$var$hsla + '$').exec(hsl);
    if (m1) {
        // get hue
        h = parseInt(m1[1]);
        if (h < 0) h = (360 - -1 * h % 360) % 360;
        else if (h > 360) h = h % 360;
        h /= 360; // normalise on [0, 1]
        s = parseFloat(m1[2]);
        if (s < 0 || s > 100) return;
         // saturation is [0, 100]
        s = s / 100; // normalise on [0, 1]
        l = parseFloat(m1[3]);
        if (l < 0 || l > 100) return;
         // lightness is [0, 100]
        l = l / 100; // normalise on [0, 1]
        a = m1[4];
        if (a !== undefined) {
            a = parseFloat(a);
            if (a < 0 || a > 1) return;
             // alpha is [0, 1]
        }
        // now, convert to rgb
        // code from http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript
        if (s === 0) r = g = b = Math.round(l * 255); // achromatic
        else {
            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var p = 2 * l - q;
            r = Math.round(255 * hue2rgb(p, q, h + 1 / 3));
            g = Math.round(255 * hue2rgb(p, q, h));
            b = Math.round(255 * hue2rgb(p, q, h - 1 / 3));
        }
        ret = [
            r,
            g,
            b,
            a
        ];
    }
    return ret;
};
// get [r, g, b, a] from rgb(0, 0, 0) or rgba(0, 0, 0, 0)
var $e815fda779bc047b$var$rgb2tuple = function rgb2tuple(rgb) {
    var ret;
    var m1 = new RegExp('^' + $e815fda779bc047b$var$rgba + '$').exec(rgb);
    if (m1) {
        ret = [];
        var isPct = [];
        for(var i = 1; i <= 3; i++){
            var channel = m1[i];
            if (channel[channel.length - 1] === '%') isPct[i] = true;
            channel = parseFloat(channel);
            if (isPct[i]) channel = channel / 100 * 255; // normalise to [0, 255]
            if (channel < 0 || channel > 255) return;
             // invalid channel value
            ret.push(Math.floor(channel));
        }
        var atLeastOneIsPct = isPct[1] || isPct[2] || isPct[3];
        var allArePct = isPct[1] && isPct[2] && isPct[3];
        if (atLeastOneIsPct && !allArePct) return;
         // must all be percent values if one is
        var alpha = m1[4];
        if (alpha !== undefined) {
            alpha = parseFloat(alpha);
            if (alpha < 0 || alpha > 1) return;
             // invalid alpha value
            ret.push(alpha);
        }
    }
    return ret;
};
var $e815fda779bc047b$var$colorname2tuple = function colorname2tuple(color) {
    return $e815fda779bc047b$var$colors[color.toLowerCase()];
};
var $e815fda779bc047b$var$color2tuple = function color2tuple(color) {
    return ($e815fda779bc047b$var$array(color) ? color : null) || $e815fda779bc047b$var$colorname2tuple(color) || $e815fda779bc047b$var$hex2tuple(color) || $e815fda779bc047b$var$rgb2tuple(color) || $e815fda779bc047b$var$hsl2tuple(color);
};
var $e815fda779bc047b$var$colors = {
    // special colour names
    transparent: [
        0,
        0,
        0,
        0
    ],
    // NB alpha === 0
    // regular colours
    aliceblue: [
        240,
        248,
        255
    ],
    antiquewhite: [
        250,
        235,
        215
    ],
    aqua: [
        0,
        255,
        255
    ],
    aquamarine: [
        127,
        255,
        212
    ],
    azure: [
        240,
        255,
        255
    ],
    beige: [
        245,
        245,
        220
    ],
    bisque: [
        255,
        228,
        196
    ],
    black: [
        0,
        0,
        0
    ],
    blanchedalmond: [
        255,
        235,
        205
    ],
    blue: [
        0,
        0,
        255
    ],
    blueviolet: [
        138,
        43,
        226
    ],
    brown: [
        165,
        42,
        42
    ],
    burlywood: [
        222,
        184,
        135
    ],
    cadetblue: [
        95,
        158,
        160
    ],
    chartreuse: [
        127,
        255,
        0
    ],
    chocolate: [
        210,
        105,
        30
    ],
    coral: [
        255,
        127,
        80
    ],
    cornflowerblue: [
        100,
        149,
        237
    ],
    cornsilk: [
        255,
        248,
        220
    ],
    crimson: [
        220,
        20,
        60
    ],
    cyan: [
        0,
        255,
        255
    ],
    darkblue: [
        0,
        0,
        139
    ],
    darkcyan: [
        0,
        139,
        139
    ],
    darkgoldenrod: [
        184,
        134,
        11
    ],
    darkgray: [
        169,
        169,
        169
    ],
    darkgreen: [
        0,
        100,
        0
    ],
    darkgrey: [
        169,
        169,
        169
    ],
    darkkhaki: [
        189,
        183,
        107
    ],
    darkmagenta: [
        139,
        0,
        139
    ],
    darkolivegreen: [
        85,
        107,
        47
    ],
    darkorange: [
        255,
        140,
        0
    ],
    darkorchid: [
        153,
        50,
        204
    ],
    darkred: [
        139,
        0,
        0
    ],
    darksalmon: [
        233,
        150,
        122
    ],
    darkseagreen: [
        143,
        188,
        143
    ],
    darkslateblue: [
        72,
        61,
        139
    ],
    darkslategray: [
        47,
        79,
        79
    ],
    darkslategrey: [
        47,
        79,
        79
    ],
    darkturquoise: [
        0,
        206,
        209
    ],
    darkviolet: [
        148,
        0,
        211
    ],
    deeppink: [
        255,
        20,
        147
    ],
    deepskyblue: [
        0,
        191,
        255
    ],
    dimgray: [
        105,
        105,
        105
    ],
    dimgrey: [
        105,
        105,
        105
    ],
    dodgerblue: [
        30,
        144,
        255
    ],
    firebrick: [
        178,
        34,
        34
    ],
    floralwhite: [
        255,
        250,
        240
    ],
    forestgreen: [
        34,
        139,
        34
    ],
    fuchsia: [
        255,
        0,
        255
    ],
    gainsboro: [
        220,
        220,
        220
    ],
    ghostwhite: [
        248,
        248,
        255
    ],
    gold: [
        255,
        215,
        0
    ],
    goldenrod: [
        218,
        165,
        32
    ],
    gray: [
        128,
        128,
        128
    ],
    grey: [
        128,
        128,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    greenyellow: [
        173,
        255,
        47
    ],
    honeydew: [
        240,
        255,
        240
    ],
    hotpink: [
        255,
        105,
        180
    ],
    indianred: [
        205,
        92,
        92
    ],
    indigo: [
        75,
        0,
        130
    ],
    ivory: [
        255,
        255,
        240
    ],
    khaki: [
        240,
        230,
        140
    ],
    lavender: [
        230,
        230,
        250
    ],
    lavenderblush: [
        255,
        240,
        245
    ],
    lawngreen: [
        124,
        252,
        0
    ],
    lemonchiffon: [
        255,
        250,
        205
    ],
    lightblue: [
        173,
        216,
        230
    ],
    lightcoral: [
        240,
        128,
        128
    ],
    lightcyan: [
        224,
        255,
        255
    ],
    lightgoldenrodyellow: [
        250,
        250,
        210
    ],
    lightgray: [
        211,
        211,
        211
    ],
    lightgreen: [
        144,
        238,
        144
    ],
    lightgrey: [
        211,
        211,
        211
    ],
    lightpink: [
        255,
        182,
        193
    ],
    lightsalmon: [
        255,
        160,
        122
    ],
    lightseagreen: [
        32,
        178,
        170
    ],
    lightskyblue: [
        135,
        206,
        250
    ],
    lightslategray: [
        119,
        136,
        153
    ],
    lightslategrey: [
        119,
        136,
        153
    ],
    lightsteelblue: [
        176,
        196,
        222
    ],
    lightyellow: [
        255,
        255,
        224
    ],
    lime: [
        0,
        255,
        0
    ],
    limegreen: [
        50,
        205,
        50
    ],
    linen: [
        250,
        240,
        230
    ],
    magenta: [
        255,
        0,
        255
    ],
    maroon: [
        128,
        0,
        0
    ],
    mediumaquamarine: [
        102,
        205,
        170
    ],
    mediumblue: [
        0,
        0,
        205
    ],
    mediumorchid: [
        186,
        85,
        211
    ],
    mediumpurple: [
        147,
        112,
        219
    ],
    mediumseagreen: [
        60,
        179,
        113
    ],
    mediumslateblue: [
        123,
        104,
        238
    ],
    mediumspringgreen: [
        0,
        250,
        154
    ],
    mediumturquoise: [
        72,
        209,
        204
    ],
    mediumvioletred: [
        199,
        21,
        133
    ],
    midnightblue: [
        25,
        25,
        112
    ],
    mintcream: [
        245,
        255,
        250
    ],
    mistyrose: [
        255,
        228,
        225
    ],
    moccasin: [
        255,
        228,
        181
    ],
    navajowhite: [
        255,
        222,
        173
    ],
    navy: [
        0,
        0,
        128
    ],
    oldlace: [
        253,
        245,
        230
    ],
    olive: [
        128,
        128,
        0
    ],
    olivedrab: [
        107,
        142,
        35
    ],
    orange: [
        255,
        165,
        0
    ],
    orangered: [
        255,
        69,
        0
    ],
    orchid: [
        218,
        112,
        214
    ],
    palegoldenrod: [
        238,
        232,
        170
    ],
    palegreen: [
        152,
        251,
        152
    ],
    paleturquoise: [
        175,
        238,
        238
    ],
    palevioletred: [
        219,
        112,
        147
    ],
    papayawhip: [
        255,
        239,
        213
    ],
    peachpuff: [
        255,
        218,
        185
    ],
    peru: [
        205,
        133,
        63
    ],
    pink: [
        255,
        192,
        203
    ],
    plum: [
        221,
        160,
        221
    ],
    powderblue: [
        176,
        224,
        230
    ],
    purple: [
        128,
        0,
        128
    ],
    red: [
        255,
        0,
        0
    ],
    rosybrown: [
        188,
        143,
        143
    ],
    royalblue: [
        65,
        105,
        225
    ],
    saddlebrown: [
        139,
        69,
        19
    ],
    salmon: [
        250,
        128,
        114
    ],
    sandybrown: [
        244,
        164,
        96
    ],
    seagreen: [
        46,
        139,
        87
    ],
    seashell: [
        255,
        245,
        238
    ],
    sienna: [
        160,
        82,
        45
    ],
    silver: [
        192,
        192,
        192
    ],
    skyblue: [
        135,
        206,
        235
    ],
    slateblue: [
        106,
        90,
        205
    ],
    slategray: [
        112,
        128,
        144
    ],
    slategrey: [
        112,
        128,
        144
    ],
    snow: [
        255,
        250,
        250
    ],
    springgreen: [
        0,
        255,
        127
    ],
    steelblue: [
        70,
        130,
        180
    ],
    tan: [
        210,
        180,
        140
    ],
    teal: [
        0,
        128,
        128
    ],
    thistle: [
        216,
        191,
        216
    ],
    tomato: [
        255,
        99,
        71
    ],
    turquoise: [
        64,
        224,
        208
    ],
    violet: [
        238,
        130,
        238
    ],
    wheat: [
        245,
        222,
        179
    ],
    white: [
        255,
        255,
        255
    ],
    whitesmoke: [
        245,
        245,
        245
    ],
    yellow: [
        255,
        255,
        0
    ],
    yellowgreen: [
        154,
        205,
        50
    ]
};
// sets the value in a map (map may not be built)
var $e815fda779bc047b$var$setMap = function setMap(options) {
    var obj = options.map;
    var keys = options.keys;
    var l = keys.length;
    for(var i = 0; i < l; i++){
        var key = keys[i];
        if ($e815fda779bc047b$var$plainObject(key)) throw Error('Tried to set map with object key');
        if (i < keys.length - 1) {
            // extend the map if necessary
            if (obj[key] == null) obj[key] = {};
            obj = obj[key];
        } else // set the value
        obj[key] = options.value;
    }
};
// gets the value in a map even if it's not built in places
var $e815fda779bc047b$var$getMap = function getMap(options) {
    var obj = options.map;
    var keys = options.keys;
    var l = keys.length;
    for(var i = 0; i < l; i++){
        var key = keys[i];
        if ($e815fda779bc047b$var$plainObject(key)) throw Error('Tried to get map with object key');
        obj = obj[key];
        if (obj == null) return obj;
    }
    return obj;
};
var $e815fda779bc047b$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
function $e815fda779bc047b$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ var $e815fda779bc047b$var$isObject_1;
var $e815fda779bc047b$var$hasRequiredIsObject;
function $e815fda779bc047b$var$requireIsObject() {
    if ($e815fda779bc047b$var$hasRequiredIsObject) return $e815fda779bc047b$var$isObject_1;
    $e815fda779bc047b$var$hasRequiredIsObject = 1;
    function isObject(value) {
        var type = typeof value;
        return value != null && (type == 'object' || type == 'function');
    }
    $e815fda779bc047b$var$isObject_1 = isObject;
    return $e815fda779bc047b$var$isObject_1;
}
/** Detect free variable `global` from Node.js. */ var $e815fda779bc047b$var$_freeGlobal;
var $e815fda779bc047b$var$hasRequired_freeGlobal;
function $e815fda779bc047b$var$require_freeGlobal() {
    if ($e815fda779bc047b$var$hasRequired_freeGlobal) return $e815fda779bc047b$var$_freeGlobal;
    $e815fda779bc047b$var$hasRequired_freeGlobal = 1;
    var freeGlobal = typeof $e815fda779bc047b$var$commonjsGlobal == 'object' && $e815fda779bc047b$var$commonjsGlobal && $e815fda779bc047b$var$commonjsGlobal.Object === Object && $e815fda779bc047b$var$commonjsGlobal;
    $e815fda779bc047b$var$_freeGlobal = freeGlobal;
    return $e815fda779bc047b$var$_freeGlobal;
}
var $e815fda779bc047b$var$_root;
var $e815fda779bc047b$var$hasRequired_root;
function $e815fda779bc047b$var$require_root() {
    if ($e815fda779bc047b$var$hasRequired_root) return $e815fda779bc047b$var$_root;
    $e815fda779bc047b$var$hasRequired_root = 1;
    var freeGlobal = $e815fda779bc047b$var$require_freeGlobal();
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    $e815fda779bc047b$var$_root = root;
    return $e815fda779bc047b$var$_root;
}
var $e815fda779bc047b$var$now_1;
var $e815fda779bc047b$var$hasRequiredNow;
function $e815fda779bc047b$var$requireNow() {
    if ($e815fda779bc047b$var$hasRequiredNow) return $e815fda779bc047b$var$now_1;
    $e815fda779bc047b$var$hasRequiredNow = 1;
    var root = $e815fda779bc047b$var$require_root();
    /**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */ var now = function() {
        return root.Date.now();
    };
    $e815fda779bc047b$var$now_1 = now;
    return $e815fda779bc047b$var$now_1;
}
/** Used to match a single whitespace character. */ var $e815fda779bc047b$var$_trimmedEndIndex;
var $e815fda779bc047b$var$hasRequired_trimmedEndIndex;
function $e815fda779bc047b$var$require_trimmedEndIndex() {
    if ($e815fda779bc047b$var$hasRequired_trimmedEndIndex) return $e815fda779bc047b$var$_trimmedEndIndex;
    $e815fda779bc047b$var$hasRequired_trimmedEndIndex = 1;
    var reWhitespace = /\s/;
    /**
	 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	 * character of `string`.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {number} Returns the index of the last non-whitespace character.
	 */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    $e815fda779bc047b$var$_trimmedEndIndex = trimmedEndIndex;
    return $e815fda779bc047b$var$_trimmedEndIndex;
}
var $e815fda779bc047b$var$_baseTrim;
var $e815fda779bc047b$var$hasRequired_baseTrim;
function $e815fda779bc047b$var$require_baseTrim() {
    if ($e815fda779bc047b$var$hasRequired_baseTrim) return $e815fda779bc047b$var$_baseTrim;
    $e815fda779bc047b$var$hasRequired_baseTrim = 1;
    var trimmedEndIndex = $e815fda779bc047b$var$require_trimmedEndIndex();
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /**
	 * The base implementation of `_.trim`.
	 *
	 * @private
	 * @param {string} string The string to trim.
	 * @returns {string} Returns the trimmed string.
	 */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    $e815fda779bc047b$var$_baseTrim = baseTrim;
    return $e815fda779bc047b$var$_baseTrim;
}
var $e815fda779bc047b$var$_Symbol;
var $e815fda779bc047b$var$hasRequired_Symbol;
function $e815fda779bc047b$var$require_Symbol() {
    if ($e815fda779bc047b$var$hasRequired_Symbol) return $e815fda779bc047b$var$_Symbol;
    $e815fda779bc047b$var$hasRequired_Symbol = 1;
    var root = $e815fda779bc047b$var$require_root();
    /** Built-in value references. */ var Symbol1 = root.Symbol;
    $e815fda779bc047b$var$_Symbol = Symbol1;
    return $e815fda779bc047b$var$_Symbol;
}
var $e815fda779bc047b$var$_getRawTag;
var $e815fda779bc047b$var$hasRequired_getRawTag;
function $e815fda779bc047b$var$require_getRawTag() {
    if ($e815fda779bc047b$var$hasRequired_getRawTag) return $e815fda779bc047b$var$_getRawTag;
    $e815fda779bc047b$var$hasRequired_getRawTag = 1;
    var Symbol1 = $e815fda779bc047b$var$require_Symbol();
    /** Used for built-in method references. */ var objectProto = Object.prototype;
    /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
    /**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */ var nativeObjectToString = objectProto.toString;
    /** Built-in value references. */ var symToStringTag = Symbol1 ? Symbol1.toStringTag : undefined;
    /**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */ function getRawTag(value) {
        var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
        try {
            value[symToStringTag] = undefined;
            var unmasked = true;
        } catch (e) {}
        var result = nativeObjectToString.call(value);
        if (unmasked) {
            if (isOwn) value[symToStringTag] = tag;
            else delete value[symToStringTag];
        }
        return result;
    }
    $e815fda779bc047b$var$_getRawTag = getRawTag;
    return $e815fda779bc047b$var$_getRawTag;
}
/** Used for built-in method references. */ var $e815fda779bc047b$var$_objectToString;
var $e815fda779bc047b$var$hasRequired_objectToString;
function $e815fda779bc047b$var$require_objectToString() {
    if ($e815fda779bc047b$var$hasRequired_objectToString) return $e815fda779bc047b$var$_objectToString;
    $e815fda779bc047b$var$hasRequired_objectToString = 1;
    var objectProto = Object.prototype;
    /**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */ var nativeObjectToString = objectProto.toString;
    /**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */ function objectToString(value) {
        return nativeObjectToString.call(value);
    }
    $e815fda779bc047b$var$_objectToString = objectToString;
    return $e815fda779bc047b$var$_objectToString;
}
var $e815fda779bc047b$var$_baseGetTag;
var $e815fda779bc047b$var$hasRequired_baseGetTag;
function $e815fda779bc047b$var$require_baseGetTag() {
    if ($e815fda779bc047b$var$hasRequired_baseGetTag) return $e815fda779bc047b$var$_baseGetTag;
    $e815fda779bc047b$var$hasRequired_baseGetTag = 1;
    var Symbol1 = $e815fda779bc047b$var$require_Symbol(), getRawTag = $e815fda779bc047b$var$require_getRawTag(), objectToString = $e815fda779bc047b$var$require_objectToString();
    /** `Object#toString` result references. */ var nullTag = '[object Null]', undefinedTag = '[object Undefined]';
    /** Built-in value references. */ var symToStringTag = Symbol1 ? Symbol1.toStringTag : undefined;
    /**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */ function baseGetTag(value) {
        if (value == null) return value === undefined ? undefinedTag : nullTag;
        return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
    }
    $e815fda779bc047b$var$_baseGetTag = baseGetTag;
    return $e815fda779bc047b$var$_baseGetTag;
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ var $e815fda779bc047b$var$isObjectLike_1;
var $e815fda779bc047b$var$hasRequiredIsObjectLike;
function $e815fda779bc047b$var$requireIsObjectLike() {
    if ($e815fda779bc047b$var$hasRequiredIsObjectLike) return $e815fda779bc047b$var$isObjectLike_1;
    $e815fda779bc047b$var$hasRequiredIsObjectLike = 1;
    function isObjectLike(value) {
        return value != null && typeof value == 'object';
    }
    $e815fda779bc047b$var$isObjectLike_1 = isObjectLike;
    return $e815fda779bc047b$var$isObjectLike_1;
}
var $e815fda779bc047b$var$isSymbol_1;
var $e815fda779bc047b$var$hasRequiredIsSymbol;
function $e815fda779bc047b$var$requireIsSymbol() {
    if ($e815fda779bc047b$var$hasRequiredIsSymbol) return $e815fda779bc047b$var$isSymbol_1;
    $e815fda779bc047b$var$hasRequiredIsSymbol = 1;
    var baseGetTag = $e815fda779bc047b$var$require_baseGetTag(), isObjectLike = $e815fda779bc047b$var$requireIsObjectLike();
    /** `Object#toString` result references. */ var symbolTag = '[object Symbol]';
    /**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */ function isSymbol(value) {
        return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
    }
    $e815fda779bc047b$var$isSymbol_1 = isSymbol;
    return $e815fda779bc047b$var$isSymbol_1;
}
var $e815fda779bc047b$var$toNumber_1;
var $e815fda779bc047b$var$hasRequiredToNumber;
function $e815fda779bc047b$var$requireToNumber() {
    if ($e815fda779bc047b$var$hasRequiredToNumber) return $e815fda779bc047b$var$toNumber_1;
    $e815fda779bc047b$var$hasRequiredToNumber = 1;
    var baseTrim = $e815fda779bc047b$var$require_baseTrim(), isObject = $e815fda779bc047b$var$requireIsObject(), isSymbol = $e815fda779bc047b$var$requireIsSymbol();
    /** Used as references for various `Number` constants. */ var NAN = 0 / 0;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Built-in method references without a dependency on `root`. */ var freeParseInt = parseInt;
    /**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */ function toNumber(value) {
        if (typeof value == 'number') return value;
        if (isSymbol(value)) return NAN;
        if (isObject(value)) {
            var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
            value = isObject(other) ? other + '' : other;
        }
        if (typeof value != 'string') return value === 0 ? value : +value;
        value = baseTrim(value);
        var isBinary = reIsBinary.test(value);
        return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
    }
    $e815fda779bc047b$var$toNumber_1 = toNumber;
    return $e815fda779bc047b$var$toNumber_1;
}
var $e815fda779bc047b$var$debounce_1;
var $e815fda779bc047b$var$hasRequiredDebounce;
function $e815fda779bc047b$var$requireDebounce() {
    if ($e815fda779bc047b$var$hasRequiredDebounce) return $e815fda779bc047b$var$debounce_1;
    $e815fda779bc047b$var$hasRequiredDebounce = 1;
    var isObject = $e815fda779bc047b$var$requireIsObject(), now = $e815fda779bc047b$var$requireNow(), toNumber = $e815fda779bc047b$var$requireToNumber();
    /** Error message constants. */ var FUNC_ERROR_TEXT = 'Expected a function';
    /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max, nativeMin = Math.min;
    /**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */ function debounce(func, wait, options) {
        var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
        if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
        wait = toNumber(wait) || 0;
        if (isObject(options)) {
            leading = !!options.leading;
            maxing = 'maxWait' in options;
            maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
            trailing = 'trailing' in options ? !!options.trailing : trailing;
        }
        function invokeFunc(time) {
            var args = lastArgs, thisArg = lastThis;
            lastArgs = lastThis = undefined;
            lastInvokeTime = time;
            result = func.apply(thisArg, args);
            return result;
        }
        function leadingEdge(time) {
            // Reset any `maxWait` timer.
            lastInvokeTime = time;
            // Start the timer for the trailing edge.
            timerId = setTimeout(timerExpired, wait);
            // Invoke the leading edge.
            return leading ? invokeFunc(time) : result;
        }
        function remainingWait(time) {
            var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
            return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
        }
        function shouldInvoke(time) {
            var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
            // Either this is the first call, activity has stopped and we're at the
            // trailing edge, the system time has gone backwards and we're treating
            // it as the trailing edge, or we've hit the `maxWait` limit.
            return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
        }
        function timerExpired() {
            var time = now();
            if (shouldInvoke(time)) return trailingEdge(time);
            // Restart the timer.
            timerId = setTimeout(timerExpired, remainingWait(time));
        }
        function trailingEdge(time) {
            timerId = undefined;
            // Only invoke if we have `lastArgs` which means `func` has been
            // debounced at least once.
            if (trailing && lastArgs) return invokeFunc(time);
            lastArgs = lastThis = undefined;
            return result;
        }
        function cancel() {
            if (timerId !== undefined) clearTimeout(timerId);
            lastInvokeTime = 0;
            lastArgs = lastCallTime = lastThis = timerId = undefined;
        }
        function flush() {
            return timerId === undefined ? result : trailingEdge(now());
        }
        function debounced() {
            var time = now(), isInvoking = shouldInvoke(time);
            lastArgs = arguments;
            lastThis = this;
            lastCallTime = time;
            if (isInvoking) {
                if (timerId === undefined) return leadingEdge(lastCallTime);
                if (maxing) {
                    // Handle invocations in a tight loop.
                    clearTimeout(timerId);
                    timerId = setTimeout(timerExpired, wait);
                    return invokeFunc(lastCallTime);
                }
            }
            if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
            return result;
        }
        debounced.cancel = cancel;
        debounced.flush = flush;
        return debounced;
    }
    $e815fda779bc047b$var$debounce_1 = debounce;
    return $e815fda779bc047b$var$debounce_1;
}
var $e815fda779bc047b$var$debounceExports = $e815fda779bc047b$var$requireDebounce();
var $e815fda779bc047b$var$debounce = /*@__PURE__*/ $e815fda779bc047b$var$getDefaultExportFromCjs($e815fda779bc047b$var$debounceExports);
var $e815fda779bc047b$var$performance$1 = $e815fda779bc047b$var$_window ? $e815fda779bc047b$var$_window.performance : null;
var $e815fda779bc047b$var$pnow = $e815fda779bc047b$var$performance$1 && $e815fda779bc047b$var$performance$1.now ? function() {
    return $e815fda779bc047b$var$performance$1.now();
} : function() {
    return Date.now();
};
var $e815fda779bc047b$var$raf = function() {
    if ($e815fda779bc047b$var$_window) {
        if ($e815fda779bc047b$var$_window.requestAnimationFrame) return function(fn) {
            $e815fda779bc047b$var$_window.requestAnimationFrame(fn);
        };
        else if ($e815fda779bc047b$var$_window.mozRequestAnimationFrame) return function(fn) {
            $e815fda779bc047b$var$_window.mozRequestAnimationFrame(fn);
        };
        else if ($e815fda779bc047b$var$_window.webkitRequestAnimationFrame) return function(fn) {
            $e815fda779bc047b$var$_window.webkitRequestAnimationFrame(fn);
        };
        else if ($e815fda779bc047b$var$_window.msRequestAnimationFrame) return function(fn) {
            $e815fda779bc047b$var$_window.msRequestAnimationFrame(fn);
        };
    }
    return function(fn) {
        if (fn) setTimeout(function() {
            fn($e815fda779bc047b$var$pnow());
        }, 1000 / 60);
    };
}();
var $e815fda779bc047b$var$requestAnimationFrame = function requestAnimationFrame(fn) {
    return $e815fda779bc047b$var$raf(fn);
};
var $e815fda779bc047b$var$performanceNow = $e815fda779bc047b$var$pnow;
var $e815fda779bc047b$var$DEFAULT_HASH_SEED = 9261;
var $e815fda779bc047b$var$K = 65599; // 37 also works pretty well
var $e815fda779bc047b$var$DEFAULT_HASH_SEED_ALT = 5381;
var $e815fda779bc047b$var$hashIterableInts = function hashIterableInts(iterator) {
    var seed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $e815fda779bc047b$var$DEFAULT_HASH_SEED;
    // sdbm/string-hash
    var hash = seed;
    var entry;
    for(;;){
        entry = iterator.next();
        if (entry.done) break;
        hash = hash * $e815fda779bc047b$var$K + entry.value | 0;
    }
    return hash;
};
var $e815fda779bc047b$var$hashInt = function hashInt(num) {
    var seed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $e815fda779bc047b$var$DEFAULT_HASH_SEED;
    // sdbm/string-hash
    return seed * $e815fda779bc047b$var$K + num | 0;
};
var $e815fda779bc047b$var$hashIntAlt = function hashIntAlt(num) {
    var seed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $e815fda779bc047b$var$DEFAULT_HASH_SEED_ALT;
    // djb2/string-hash
    return (seed << 5) + seed + num | 0;
};
var $e815fda779bc047b$var$combineHashes = function combineHashes(hash1, hash2) {
    return hash1 * 0x200000 + hash2;
};
var $e815fda779bc047b$var$combineHashesArray = function combineHashesArray(hashes) {
    return hashes[0] * 0x200000 + hashes[1];
};
var $e815fda779bc047b$var$hashArrays = function hashArrays(hashes1, hashes2) {
    return [
        $e815fda779bc047b$var$hashInt(hashes1[0], hashes2[0]),
        $e815fda779bc047b$var$hashIntAlt(hashes1[1], hashes2[1])
    ];
};
var $e815fda779bc047b$var$hashIntsArray = function hashIntsArray(ints, seed) {
    var entry = {
        value: 0,
        done: false
    };
    var i = 0;
    var length = ints.length;
    var iterator = {
        next: function next() {
            if (i < length) entry.value = ints[i++];
            else entry.done = true;
            return entry;
        }
    };
    return $e815fda779bc047b$var$hashIterableInts(iterator, seed);
};
var $e815fda779bc047b$var$hashString = function hashString(str, seed) {
    var entry = {
        value: 0,
        done: false
    };
    var i = 0;
    var length = str.length;
    var iterator = {
        next: function next() {
            if (i < length) entry.value = str.charCodeAt(i++);
            else entry.done = true;
            return entry;
        }
    };
    return $e815fda779bc047b$var$hashIterableInts(iterator, seed);
};
var $e815fda779bc047b$var$hashStrings = function hashStrings() {
    return $e815fda779bc047b$var$hashStringsArray(arguments);
};
var $e815fda779bc047b$var$hashStringsArray = function hashStringsArray(strs) {
    var hash;
    for(var i = 0; i < strs.length; i++){
        var str = strs[i];
        if (i === 0) hash = $e815fda779bc047b$var$hashString(str);
        else hash = $e815fda779bc047b$var$hashString(str, hash);
    }
    return hash;
};
function $e815fda779bc047b$var$rotatePoint(x, y, centerX, centerY, angleDegrees) {
    var angleRadians = angleDegrees * Math.PI / 180;
    var rotatedX = Math.cos(angleRadians) * (x - centerX) - Math.sin(angleRadians) * (y - centerY) + centerX;
    var rotatedY = Math.sin(angleRadians) * (x - centerX) + Math.cos(angleRadians) * (y - centerY) + centerY;
    return {
        x: rotatedX,
        y: rotatedY
    };
}
var $e815fda779bc047b$var$movePointByBoxAspect = function movePointByBoxAspect(x, y, boxX, boxY, skewX, skewY) {
    return {
        x: (x - boxX) * skewX + boxX,
        y: (y - boxY) * skewY + boxY
    };
};
function $e815fda779bc047b$var$rotatePosAndSkewByBox(pos, box, angleDegrees) {
    if (angleDegrees === 0) return pos;
    var centerX = (box.x1 + box.x2) / 2;
    var centerY = (box.y1 + box.y2) / 2;
    var skewX = box.w / box.h;
    var skewY = 1 / skewX;
    var rotated = $e815fda779bc047b$var$rotatePoint(pos.x, pos.y, centerX, centerY, angleDegrees);
    var skewed = $e815fda779bc047b$var$movePointByBoxAspect(rotated.x, rotated.y, centerX, centerY, skewX, skewY);
    return {
        x: skewed.x,
        y: skewed.y
    };
}
var $e815fda779bc047b$var$warningsEnabled = true;
var $e815fda779bc047b$var$warnSupported = console.warn != null;
var $e815fda779bc047b$var$traceSupported = console.trace != null;
var $e815fda779bc047b$var$MAX_INT$1 = Number.MAX_SAFE_INTEGER || 9007199254740991;
var $e815fda779bc047b$var$trueify = function trueify() {
    return true;
};
var $e815fda779bc047b$var$falsify = function falsify() {
    return false;
};
var $e815fda779bc047b$var$zeroify = function zeroify() {
    return 0;
};
var $e815fda779bc047b$var$noop$1 = function noop() {};
var $e815fda779bc047b$var$error = function error(msg) {
    throw new Error(msg);
};
var $e815fda779bc047b$var$warnings = function warnings(enabled) {
    if (enabled !== undefined) $e815fda779bc047b$var$warningsEnabled = !!enabled;
    else return $e815fda779bc047b$var$warningsEnabled;
};
var $e815fda779bc047b$var$warn = function warn(msg) {
    if (!$e815fda779bc047b$var$warnings()) return;
    if ($e815fda779bc047b$var$warnSupported) console.warn(msg);
    else {
        console.log(msg);
        if ($e815fda779bc047b$var$traceSupported) console.trace();
    }
};
var $e815fda779bc047b$var$clone = function clone(obj) {
    return $e815fda779bc047b$var$extend({}, obj);
};
// gets a shallow copy of the argument
var $e815fda779bc047b$var$copy = function copy(obj) {
    if (obj == null) return obj;
    if ($e815fda779bc047b$var$array(obj)) return obj.slice();
    else if ($e815fda779bc047b$var$plainObject(obj)) return $e815fda779bc047b$var$clone(obj);
    else return obj;
};
var $e815fda779bc047b$var$copyArray = function copyArray(arr) {
    return arr.slice();
};
var $e815fda779bc047b$var$uuid = function uuid(a, b /* placeholders */ ) {
    for(// loop :)
    b = a = ''; // b - result , a - numeric letiable
    a++ < 36; //
    b += a * 51 & 52 // if "a" is not 9 or 14 or 19 or 24
     ? //  return a random number or 4
    (a ^ 15 // if "a" is not 15
     ? // generate a random number from 0 to 15
    8 ^ Math.random() * (a ^ 20 ? 16 : 4 // unless "a" is 20, in which case a random number from 8 to 11
    ) : 4 //  otherwise 4
    ).toString(16) : '-' //  in other cases (if "a" is 9,14,19,24) insert "-"
    );
    return b;
};
var $e815fda779bc047b$var$_staticEmptyObject = {};
var $e815fda779bc047b$var$staticEmptyObject = function staticEmptyObject() {
    return $e815fda779bc047b$var$_staticEmptyObject;
};
var $e815fda779bc047b$var$defaults$g = function defaults(_defaults) {
    var keys = Object.keys(_defaults);
    return function(opts) {
        var filledOpts = {};
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            var optVal = opts == null ? undefined : opts[key];
            filledOpts[key] = optVal === undefined ? _defaults[key] : optVal;
        }
        return filledOpts;
    };
};
var $e815fda779bc047b$var$removeFromArray = function removeFromArray(arr, ele, oneCopy) {
    for(var i = arr.length - 1; i >= 0; i--)if (arr[i] === ele) arr.splice(i, 1);
};
var $e815fda779bc047b$var$clearArray = function clearArray(arr) {
    arr.splice(0, arr.length);
};
var $e815fda779bc047b$var$push = function push(arr, otherArr) {
    for(var i = 0; i < otherArr.length; i++){
        var el = otherArr[i];
        arr.push(el);
    }
};
var $e815fda779bc047b$var$getPrefixedProperty = function getPrefixedProperty(obj, propName, prefix) {
    if (prefix) propName = $e815fda779bc047b$var$prependCamel(prefix, propName); // e.g. (labelWidth, source) => sourceLabelWidth
    return obj[propName];
};
var $e815fda779bc047b$var$setPrefixedProperty = function setPrefixedProperty(obj, propName, prefix, value) {
    if (prefix) propName = $e815fda779bc047b$var$prependCamel(prefix, propName); // e.g. (labelWidth, source) => sourceLabelWidth
    obj[propName] = value;
};
/* global Map */ var $e815fda779bc047b$var$ObjectMap = /*#__PURE__*/ function() {
    function ObjectMap() {
        $e815fda779bc047b$var$_classCallCheck(this, ObjectMap);
        this._obj = {};
    }
    return $e815fda779bc047b$var$_createClass(ObjectMap, [
        {
            key: "set",
            value: function set(key, val) {
                this._obj[key] = val;
                return this;
            }
        },
        {
            key: "delete",
            value: function _delete(key) {
                this._obj[key] = undefined;
                return this;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this._obj = {};
            }
        },
        {
            key: "has",
            value: function has(key) {
                return this._obj[key] !== undefined;
            }
        },
        {
            key: "get",
            value: function get(key) {
                return this._obj[key];
            }
        }
    ]);
}();
var $e815fda779bc047b$var$Map$1 = typeof Map !== 'undefined' ? Map : $e815fda779bc047b$var$ObjectMap;
/* global Set */ var $e815fda779bc047b$var$undef = "undefined";
var $e815fda779bc047b$var$ObjectSet = /*#__PURE__*/ function() {
    function ObjectSet(arrayOrObjectSet) {
        $e815fda779bc047b$var$_classCallCheck(this, ObjectSet);
        this._obj = Object.create(null);
        this.size = 0;
        if (arrayOrObjectSet != null) {
            var arr;
            if (arrayOrObjectSet.instanceString != null && arrayOrObjectSet.instanceString() === this.instanceString()) arr = arrayOrObjectSet.toArray();
            else arr = arrayOrObjectSet;
            for(var i = 0; i < arr.length; i++)this.add(arr[i]);
        }
    }
    return $e815fda779bc047b$var$_createClass(ObjectSet, [
        {
            key: "instanceString",
            value: function instanceString() {
                return 'set';
            }
        },
        {
            key: "add",
            value: function add(val) {
                var o = this._obj;
                if (o[val] !== 1) {
                    o[val] = 1;
                    this.size++;
                }
            }
        },
        {
            key: "delete",
            value: function _delete(val) {
                var o = this._obj;
                if (o[val] === 1) {
                    o[val] = 0;
                    this.size--;
                }
            }
        },
        {
            key: "clear",
            value: function clear() {
                this._obj = Object.create(null);
            }
        },
        {
            key: "has",
            value: function has(val) {
                return this._obj[val] === 1;
            }
        },
        {
            key: "toArray",
            value: function toArray() {
                var _this = this;
                return Object.keys(this._obj).filter(function(key) {
                    return _this.has(key);
                });
            }
        },
        {
            key: "forEach",
            value: function forEach(callback, thisArg) {
                return this.toArray().forEach(callback, thisArg);
            }
        }
    ]);
}();
var $e815fda779bc047b$var$Set$1 = (typeof Set === "undefined" ? "undefined" : $e815fda779bc047b$var$_typeof(Set)) !== $e815fda779bc047b$var$undef ? Set : $e815fda779bc047b$var$ObjectSet;
// represents a node or an edge
var $e815fda779bc047b$var$Element = function Element(cy, params) {
    var restore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (cy === undefined || params === undefined || !$e815fda779bc047b$var$core(cy)) {
        $e815fda779bc047b$var$error('An element must have a core reference and parameters set');
        return;
    }
    var group = params.group;
    // try to automatically infer the group if unspecified
    if (group == null) {
        if (params.data && params.data.source != null && params.data.target != null) group = 'edges';
        else group = 'nodes';
    }
    // validate group
    if (group !== 'nodes' && group !== 'edges') {
        $e815fda779bc047b$var$error('An element must be of type `nodes` or `edges`; you specified `' + group + '`');
        return;
    }
    // make the element array-like, just like a collection
    this.length = 1;
    this[0] = this;
    // NOTE: when something is added here, add also to ele.json()
    var _p = this._private = {
        cy: cy,
        single: true,
        // indicates this is an element
        data: params.data || {},
        // data object
        position: params.position || {
            x: 0,
            y: 0
        },
        // (x, y) position pair
        autoWidth: undefined,
        // width and height of nodes calculated by the renderer when set to special 'auto' value
        autoHeight: undefined,
        autoPadding: undefined,
        compoundBoundsClean: false,
        // whether the compound dimensions need to be recalculated the next time dimensions are read
        listeners: [],
        // array of bound listeners
        group: group,
        // string; 'nodes' or 'edges'
        style: {},
        // properties as set by the style
        rstyle: {},
        // properties for style sent from the renderer to the core
        styleCxts: [],
        // applied style contexts from the styler
        styleKeys: {},
        // per-group keys of style property values
        removed: true,
        // whether it's inside the vis; true if removed (set true here since we call restore)
        selected: params.selected ? true : false,
        // whether it's selected
        selectable: params.selectable === undefined ? true : params.selectable ? true : false,
        // whether it's selectable
        locked: params.locked ? true : false,
        // whether the element is locked (cannot be moved)
        grabbed: false,
        // whether the element is grabbed by the mouse; renderer sets this privately
        grabbable: params.grabbable === undefined ? true : params.grabbable ? true : false,
        // whether the element can be grabbed
        pannable: params.pannable === undefined ? group === 'edges' ? true : false : params.pannable ? true : false,
        // whether the element has passthrough panning enabled
        active: false,
        // whether the element is active from user interaction
        classes: new $e815fda779bc047b$var$Set$1(),
        // map ( className => true )
        animation: {
            // object for currently-running animations
            current: [],
            queue: []
        },
        rscratch: {},
        // object in which the renderer can store information
        scratch: params.scratch || {},
        // scratch objects
        edges: [],
        // array of connected edges
        children: [],
        // array of children
        parent: params.parent && params.parent.isNode() ? params.parent : null,
        // parent ref
        traversalCache: {},
        // cache of output of traversal functions
        backgrounding: false,
        // whether background images are loading
        bbCache: null,
        // cache of the current bounding box
        bbCacheShift: {
            x: 0,
            y: 0
        },
        // shift applied to cached bb to be applied on next get
        bodyBounds: null,
        // bounds cache of element body, w/o overlay
        overlayBounds: null,
        // bounds cache of element body, including overlay
        labelBounds: {
            // bounds cache of labels
            all: null,
            source: null,
            target: null,
            main: null
        },
        arrowBounds: {
            // bounds cache of edge arrows
            source: null,
            target: null,
            'mid-source': null,
            'mid-target': null
        }
    };
    if (_p.position.x == null) _p.position.x = 0;
    if (_p.position.y == null) _p.position.y = 0;
    // renderedPosition overrides if specified
    if (params.renderedPosition) {
        var rpos = params.renderedPosition;
        var pan = cy.pan();
        var zoom = cy.zoom();
        _p.position = {
            x: (rpos.x - pan.x) / zoom,
            y: (rpos.y - pan.y) / zoom
        };
    }
    var classes = [];
    if ($e815fda779bc047b$var$array(params.classes)) classes = params.classes;
    else if ($e815fda779bc047b$var$string(params.classes)) classes = params.classes.split(/\s+/);
    for(var i = 0, l = classes.length; i < l; i++){
        var cls = classes[i];
        if (!cls || cls === '') continue;
        _p.classes.add(cls);
    }
    this.createEmitter();
    if (restore === undefined || restore) this.restore();
    var bypass = params.style || params.css;
    if (bypass) {
        $e815fda779bc047b$var$warn('Setting a `style` bypass at element creation should be done only when absolutely necessary.  Try to use the stylesheet instead.');
        this.style(bypass);
    }
};
var $e815fda779bc047b$var$defineSearch = function defineSearch(params) {
    params = {
        bfs: params.bfs || !params.dfs,
        dfs: params.dfs || !params.bfs
    };
    // from pseudocode on wikipedia
    return function searchFn(roots, fn, directed) {
        var options;
        if ($e815fda779bc047b$var$plainObject(roots) && !$e815fda779bc047b$var$elementOrCollection(roots)) {
            options = roots;
            roots = options.roots || options.root;
            fn = options.visit;
            directed = options.directed;
        }
        directed = arguments.length === 2 && !$e815fda779bc047b$var$fn$6(fn) ? fn : directed;
        fn = $e815fda779bc047b$var$fn$6(fn) ? fn : function() {};
        var cy = this._private.cy;
        var v = roots = $e815fda779bc047b$var$string(roots) ? this.filter(roots) : roots;
        var Q = [];
        var connectedNodes = [];
        var connectedBy = {};
        var id2depth = {};
        var V = {};
        var j = 0;
        var found;
        var _this$byGroup = this.byGroup(), nodes = _this$byGroup.nodes, edges = _this$byGroup.edges;
        // enqueue v
        for(var i = 0; i < v.length; i++){
            var vi = v[i];
            var viId = vi.id();
            if (vi.isNode()) {
                Q.unshift(vi);
                if (params.bfs) {
                    V[viId] = true;
                    connectedNodes.push(vi);
                }
                id2depth[viId] = 0;
            }
        }
        var _loop = function _loop() {
            var v = params.bfs ? Q.shift() : Q.pop();
            var vId = v.id();
            if (params.dfs) {
                if (V[vId]) return 0; // continue
                V[vId] = true;
                connectedNodes.push(v);
            }
            var depth = id2depth[vId];
            var prevEdge = connectedBy[vId];
            var src = prevEdge != null ? prevEdge.source() : null;
            var tgt = prevEdge != null ? prevEdge.target() : null;
            var prevNode = prevEdge == null ? undefined : v.same(src) ? tgt[0] : src[0];
            var ret;
            ret = fn(v, prevEdge, prevNode, j++, depth);
            if (ret === true) {
                found = v;
                return 1; // break
            }
            if (ret === false) return 1; // break
            var vwEdges = v.connectedEdges().filter(function(e) {
                return (!directed || e.source().same(v)) && edges.has(e);
            });
            for(var _i2 = 0; _i2 < vwEdges.length; _i2++){
                var e = vwEdges[_i2];
                var w = e.connectedNodes().filter(function(n) {
                    return !n.same(v) && nodes.has(n);
                });
                var wId = w.id();
                if (w.length !== 0 && !V[wId]) {
                    w = w[0];
                    Q.push(w);
                    if (params.bfs) {
                        V[wId] = true;
                        connectedNodes.push(w);
                    }
                    connectedBy[wId] = e;
                    id2depth[wId] = id2depth[vId] + 1;
                }
            }
        }, _ret;
        while(Q.length !== 0){
            _ret = _loop();
            if (_ret === 0) continue;
            if (_ret === 1) break;
        }
        var connectedEles = cy.collection();
        for(var _i = 0; _i < connectedNodes.length; _i++){
            var node = connectedNodes[_i];
            var edge = connectedBy[node.id()];
            if (edge != null) connectedEles.push(edge);
            connectedEles.push(node);
        }
        return {
            path: cy.collection(connectedEles),
            found: cy.collection(found)
        };
    };
};
// search, spanning trees, etc
var $e815fda779bc047b$var$elesfn$v = {
    breadthFirstSearch: $e815fda779bc047b$var$defineSearch({
        bfs: true
    }),
    depthFirstSearch: $e815fda779bc047b$var$defineSearch({
        dfs: true
    })
};
// nice, short mathematical alias
$e815fda779bc047b$var$elesfn$v.bfs = $e815fda779bc047b$var$elesfn$v.breadthFirstSearch;
$e815fda779bc047b$var$elesfn$v.dfs = $e815fda779bc047b$var$elesfn$v.depthFirstSearch;
var $e815fda779bc047b$var$heap$2 = {
    exports: {}
};
var $e815fda779bc047b$var$heap$1 = $e815fda779bc047b$var$heap$2.exports;
var $e815fda779bc047b$var$hasRequiredHeap$1;
function $e815fda779bc047b$var$requireHeap$1() {
    if ($e815fda779bc047b$var$hasRequiredHeap$1) return $e815fda779bc047b$var$heap$2.exports;
    $e815fda779bc047b$var$hasRequiredHeap$1 = 1;
    (function(module, exports) {
        // Generated by CoffeeScript 1.8.0
        (function() {
            var Heap, defaultCmp, floor, heapify, heappop, heappush, heappushpop, heapreplace, insort, min, nlargest, nsmallest, updateItem, _siftdown, _siftup;
            floor = Math.floor, min = Math.min;
            /*
		  Default comparison function to be used
		   */ defaultCmp = function(x, y) {
                if (x < y) return -1;
                if (x > y) return 1;
                return 0;
            };
            /*
		  Insert item x in list a, and keep it sorted assuming a is sorted.
		  
		  If x is already in a, insert it to the right of the rightmost x.
		  
		  Optional args lo (default 0) and hi (default a.length) bound the slice
		  of a to be searched.
		   */ insort = function(a, x, lo, hi, cmp) {
                var mid;
                if (lo == null) lo = 0;
                if (cmp == null) cmp = defaultCmp;
                if (lo < 0) throw new Error('lo must be non-negative');
                if (hi == null) hi = a.length;
                while(lo < hi){
                    mid = floor((lo + hi) / 2);
                    if (cmp(x, a[mid]) < 0) hi = mid;
                    else lo = mid + 1;
                }
                return [].splice.apply(a, [
                    lo,
                    lo - lo
                ].concat(x)), x;
            };
            /*
		  Push item onto heap, maintaining the heap invariant.
		   */ heappush = function(array, item, cmp) {
                if (cmp == null) cmp = defaultCmp;
                array.push(item);
                return _siftdown(array, 0, array.length - 1, cmp);
            };
            /*
		  Pop the smallest item off the heap, maintaining the heap invariant.
		   */ heappop = function(array, cmp) {
                var lastelt, returnitem;
                if (cmp == null) cmp = defaultCmp;
                lastelt = array.pop();
                if (array.length) {
                    returnitem = array[0];
                    array[0] = lastelt;
                    _siftup(array, 0, cmp);
                } else returnitem = lastelt;
                return returnitem;
            };
            /*
		  Pop and return the current smallest value, and add the new item.
		  
		  This is more efficient than heappop() followed by heappush(), and can be
		  more appropriate when using a fixed size heap. Note that the value
		  returned may be larger than item! That constrains reasonable use of
		  this routine unless written as part of a conditional replacement:
		      if item > array[0]
		        item = heapreplace(array, item)
		   */ heapreplace = function(array, item, cmp) {
                var returnitem;
                if (cmp == null) cmp = defaultCmp;
                returnitem = array[0];
                array[0] = item;
                _siftup(array, 0, cmp);
                return returnitem;
            };
            /*
		  Fast version of a heappush followed by a heappop.
		   */ heappushpop = function(array, item, cmp) {
                var _ref;
                if (cmp == null) cmp = defaultCmp;
                if (array.length && cmp(array[0], item) < 0) {
                    _ref = [
                        array[0],
                        item
                    ], item = _ref[0], array[0] = _ref[1];
                    _siftup(array, 0, cmp);
                }
                return item;
            };
            /*
		  Transform list into a heap, in-place, in O(array.length) time.
		   */ heapify = function(array, cmp) {
                var i, _i, _len, _ref1, _results, _results1;
                if (cmp == null) cmp = defaultCmp;
                _ref1 = (function() {
                    _results1 = [];
                    for(var _j = 0, _ref = floor(array.length / 2); 0 <= _ref ? _j < _ref : _j > _ref; 0 <= _ref ? _j++ : _j--)_results1.push(_j);
                    return _results1;
                }).apply(this).reverse();
                _results = [];
                for(_i = 0, _len = _ref1.length; _i < _len; _i++){
                    i = _ref1[_i];
                    _results.push(_siftup(array, i, cmp));
                }
                return _results;
            };
            /*
		  Update the position of the given item in the heap.
		  This function should be called every time the item is being modified.
		   */ updateItem = function(array, item, cmp) {
                var pos;
                if (cmp == null) cmp = defaultCmp;
                pos = array.indexOf(item);
                if (pos === -1) return;
                _siftdown(array, 0, pos, cmp);
                return _siftup(array, pos, cmp);
            };
            /*
		  Find the n largest elements in a dataset.
		   */ nlargest = function(array, n, cmp) {
                var elem, result, _i, _len, _ref;
                if (cmp == null) cmp = defaultCmp;
                result = array.slice(0, n);
                if (!result.length) return result;
                heapify(result, cmp);
                _ref = array.slice(n);
                for(_i = 0, _len = _ref.length; _i < _len; _i++){
                    elem = _ref[_i];
                    heappushpop(result, elem, cmp);
                }
                return result.sort(cmp).reverse();
            };
            /*
		  Find the n smallest elements in a dataset.
		   */ nsmallest = function(array, n, cmp) {
                var elem, los, result, _i, _j, _len, _ref, _ref1, _results;
                if (cmp == null) cmp = defaultCmp;
                if (n * 10 <= array.length) {
                    result = array.slice(0, n).sort(cmp);
                    if (!result.length) return result;
                    los = result[result.length - 1];
                    _ref = array.slice(n);
                    for(_i = 0, _len = _ref.length; _i < _len; _i++){
                        elem = _ref[_i];
                        if (cmp(elem, los) < 0) {
                            insort(result, elem, 0, null, cmp);
                            result.pop();
                            los = result[result.length - 1];
                        }
                    }
                    return result;
                }
                heapify(array, cmp);
                _results = [];
                for(_j = 0, _ref1 = min(n, array.length); 0 <= _ref1 ? _j < _ref1 : _j > _ref1; 0 <= _ref1 ? ++_j : --_j)_results.push(heappop(array, cmp));
                return _results;
            };
            _siftdown = function(array, startpos, pos, cmp) {
                var newitem, parent, parentpos;
                if (cmp == null) cmp = defaultCmp;
                newitem = array[pos];
                while(pos > startpos){
                    parentpos = pos - 1 >> 1;
                    parent = array[parentpos];
                    if (cmp(newitem, parent) < 0) {
                        array[pos] = parent;
                        pos = parentpos;
                        continue;
                    }
                    break;
                }
                return array[pos] = newitem;
            };
            _siftup = function(array, pos, cmp) {
                var childpos, endpos, newitem, rightpos, startpos;
                if (cmp == null) cmp = defaultCmp;
                endpos = array.length;
                startpos = pos;
                newitem = array[pos];
                childpos = 2 * pos + 1;
                while(childpos < endpos){
                    rightpos = childpos + 1;
                    if (rightpos < endpos && !(cmp(array[childpos], array[rightpos]) < 0)) childpos = rightpos;
                    array[pos] = array[childpos];
                    pos = childpos;
                    childpos = 2 * pos + 1;
                }
                array[pos] = newitem;
                return _siftdown(array, startpos, pos, cmp);
            };
            Heap = function() {
                Heap.push = heappush;
                Heap.pop = heappop;
                Heap.replace = heapreplace;
                Heap.pushpop = heappushpop;
                Heap.heapify = heapify;
                Heap.updateItem = updateItem;
                Heap.nlargest = nlargest;
                Heap.nsmallest = nsmallest;
                function Heap(cmp) {
                    this.cmp = cmp != null ? cmp : defaultCmp;
                    this.nodes = [];
                }
                Heap.prototype.push = function(x) {
                    return heappush(this.nodes, x, this.cmp);
                };
                Heap.prototype.pop = function() {
                    return heappop(this.nodes, this.cmp);
                };
                Heap.prototype.peek = function() {
                    return this.nodes[0];
                };
                Heap.prototype.contains = function(x) {
                    return this.nodes.indexOf(x) !== -1;
                };
                Heap.prototype.replace = function(x) {
                    return heapreplace(this.nodes, x, this.cmp);
                };
                Heap.prototype.pushpop = function(x) {
                    return heappushpop(this.nodes, x, this.cmp);
                };
                Heap.prototype.heapify = function() {
                    return heapify(this.nodes, this.cmp);
                };
                Heap.prototype.updateItem = function(x) {
                    return updateItem(this.nodes, x, this.cmp);
                };
                Heap.prototype.clear = function() {
                    return this.nodes = [];
                };
                Heap.prototype.empty = function() {
                    return this.nodes.length === 0;
                };
                Heap.prototype.size = function() {
                    return this.nodes.length;
                };
                Heap.prototype.clone = function() {
                    var heap;
                    heap = new Heap();
                    heap.nodes = this.nodes.slice(0);
                    return heap;
                };
                Heap.prototype.toArray = function() {
                    return this.nodes.slice(0);
                };
                Heap.prototype.insert = Heap.prototype.push;
                Heap.prototype.top = Heap.prototype.peek;
                Heap.prototype.front = Heap.prototype.peek;
                Heap.prototype.has = Heap.prototype.contains;
                Heap.prototype.copy = Heap.prototype.clone;
                return Heap;
            }();
            (function(root, factory) {
                return module.exports = factory();
            })(this, function() {
                return Heap;
            });
        }).call($e815fda779bc047b$var$heap$1);
    })($e815fda779bc047b$var$heap$2);
    return $e815fda779bc047b$var$heap$2.exports;
}
var $e815fda779bc047b$var$heap;
var $e815fda779bc047b$var$hasRequiredHeap;
function $e815fda779bc047b$var$requireHeap() {
    if ($e815fda779bc047b$var$hasRequiredHeap) return $e815fda779bc047b$var$heap;
    $e815fda779bc047b$var$hasRequiredHeap = 1;
    $e815fda779bc047b$var$heap = $e815fda779bc047b$var$requireHeap$1();
    return $e815fda779bc047b$var$heap;
}
var $e815fda779bc047b$var$heapExports = $e815fda779bc047b$var$requireHeap();
var $e815fda779bc047b$var$Heap = /*@__PURE__*/ $e815fda779bc047b$var$getDefaultExportFromCjs($e815fda779bc047b$var$heapExports);
var $e815fda779bc047b$var$dijkstraDefaults = $e815fda779bc047b$var$defaults$g({
    root: null,
    weight: function weight(edge) {
        return 1;
    },
    directed: false
});
var $e815fda779bc047b$var$elesfn$u = {
    dijkstra: function dijkstra(options) {
        if (!$e815fda779bc047b$var$plainObject(options)) {
            var args = arguments;
            options = {
                root: args[0],
                weight: args[1],
                directed: args[2]
            };
        }
        var _dijkstraDefaults = $e815fda779bc047b$var$dijkstraDefaults(options), root = _dijkstraDefaults.root, weight = _dijkstraDefaults.weight, directed = _dijkstraDefaults.directed;
        var eles = this;
        var weightFn = weight;
        var source = $e815fda779bc047b$var$string(root) ? this.filter(root)[0] : root[0];
        var dist = {};
        var prev = {};
        var knownDist = {};
        var _this$byGroup = this.byGroup(), nodes = _this$byGroup.nodes, edges = _this$byGroup.edges;
        edges.unmergeBy(function(ele) {
            return ele.isLoop();
        });
        var getDist = function getDist(node) {
            return dist[node.id()];
        };
        var setDist = function setDist(node, d) {
            dist[node.id()] = d;
            Q.updateItem(node);
        };
        var Q = new $e815fda779bc047b$var$Heap(function(a, b) {
            return getDist(a) - getDist(b);
        });
        for(var i = 0; i < nodes.length; i++){
            var node = nodes[i];
            dist[node.id()] = node.same(source) ? 0 : Infinity;
            Q.push(node);
        }
        var distBetween = function distBetween(u, v) {
            var uvs = (directed ? u.edgesTo(v) : u.edgesWith(v)).intersect(edges);
            var smallestDistance = Infinity;
            var smallestEdge;
            for(var _i = 0; _i < uvs.length; _i++){
                var edge = uvs[_i];
                var _weight = weightFn(edge);
                if (_weight < smallestDistance || !smallestEdge) {
                    smallestDistance = _weight;
                    smallestEdge = edge;
                }
            }
            return {
                edge: smallestEdge,
                dist: smallestDistance
            };
        };
        while(Q.size() > 0){
            var u = Q.pop();
            var smalletsDist = getDist(u);
            var uid = u.id();
            knownDist[uid] = smalletsDist;
            if (smalletsDist === Infinity) continue;
            var neighbors = u.neighborhood().intersect(nodes);
            for(var _i2 = 0; _i2 < neighbors.length; _i2++){
                var v = neighbors[_i2];
                var vid = v.id();
                var vDist = distBetween(u, v);
                var alt = smalletsDist + vDist.dist;
                if (alt < getDist(v)) {
                    setDist(v, alt);
                    prev[vid] = {
                        node: u,
                        edge: vDist.edge
                    };
                }
            } // for
        } // while
        return {
            distanceTo: function distanceTo(node) {
                var target = $e815fda779bc047b$var$string(node) ? nodes.filter(node)[0] : node[0];
                return knownDist[target.id()];
            },
            pathTo: function pathTo(node) {
                var target = $e815fda779bc047b$var$string(node) ? nodes.filter(node)[0] : node[0];
                var S = [];
                var u = target;
                var uid = u.id();
                if (target.length > 0) {
                    S.unshift(target);
                    while(prev[uid]){
                        var p = prev[uid];
                        S.unshift(p.edge);
                        S.unshift(p.node);
                        u = p.node;
                        uid = u.id();
                    }
                }
                return eles.spawn(S);
            }
        };
    }
};
var $e815fda779bc047b$var$elesfn$t = {
    // kruskal's algorithm (finds min spanning tree, assuming undirected graph)
    // implemented from pseudocode from wikipedia
    kruskal: function kruskal(weightFn) {
        weightFn = weightFn || function(edge) {
            return 1;
        };
        var _this$byGroup = this.byGroup(), nodes = _this$byGroup.nodes, edges = _this$byGroup.edges;
        var numNodes = nodes.length;
        var forest = new Array(numNodes);
        var A = nodes; // assumes byGroup() creates new collections that can be safely mutated
        var findSetIndex = function findSetIndex(ele) {
            for(var i = 0; i < forest.length; i++){
                var eles = forest[i];
                if (eles.has(ele)) return i;
            }
        };
        // start with one forest per node
        for(var i = 0; i < numNodes; i++)forest[i] = this.spawn(nodes[i]);
        var S = edges.sort(function(a, b) {
            return weightFn(a) - weightFn(b);
        });
        for(var _i = 0; _i < S.length; _i++){
            var edge = S[_i];
            var u = edge.source()[0];
            var v = edge.target()[0];
            var setUIndex = findSetIndex(u);
            var setVIndex = findSetIndex(v);
            var setU = forest[setUIndex];
            var setV = forest[setVIndex];
            if (setUIndex !== setVIndex) {
                A.merge(edge);
                // combine forests for u and v
                setU.merge(setV);
                forest.splice(setVIndex, 1);
            }
        }
        return A;
    }
};
var $e815fda779bc047b$var$aStarDefaults = $e815fda779bc047b$var$defaults$g({
    root: null,
    goal: null,
    weight: function weight(edge) {
        return 1;
    },
    heuristic: function heuristic(edge) {
        return 0;
    },
    directed: false
});
var $e815fda779bc047b$var$elesfn$s = {
    // Implemented from pseudocode from wikipedia
    aStar: function aStar(options) {
        var cy = this.cy();
        var _aStarDefaults = $e815fda779bc047b$var$aStarDefaults(options), root = _aStarDefaults.root, goal = _aStarDefaults.goal, heuristic = _aStarDefaults.heuristic, directed = _aStarDefaults.directed, weight = _aStarDefaults.weight;
        root = cy.collection(root)[0];
        goal = cy.collection(goal)[0];
        var sid = root.id();
        var tid = goal.id();
        var gScore = {};
        var fScore = {};
        var closedSetIds = {};
        var openSet = new $e815fda779bc047b$var$Heap(function(a, b) {
            return fScore[a.id()] - fScore[b.id()];
        });
        var openSetIds = new $e815fda779bc047b$var$Set$1();
        var cameFrom = {};
        var cameFromEdge = {};
        var addToOpenSet = function addToOpenSet(ele, id) {
            openSet.push(ele);
            openSetIds.add(id);
        };
        var cMin, cMinId;
        var popFromOpenSet = function popFromOpenSet() {
            cMin = openSet.pop();
            cMinId = cMin.id();
            openSetIds["delete"](cMinId);
        };
        var isInOpenSet = function isInOpenSet(id) {
            return openSetIds.has(id);
        };
        addToOpenSet(root, sid);
        gScore[sid] = 0;
        fScore[sid] = heuristic(root);
        // Counter
        var steps = 0;
        // Main loop
        while(openSet.size() > 0){
            popFromOpenSet();
            steps++;
            // If we've found our goal, then we are done
            if (cMinId === tid) {
                var path = [];
                var pathNode = goal;
                var pathNodeId = tid;
                var pathEdge = cameFromEdge[pathNodeId];
                for(;;){
                    path.unshift(pathNode);
                    if (pathEdge != null) path.unshift(pathEdge);
                    pathNode = cameFrom[pathNodeId];
                    if (pathNode == null) break;
                    pathNodeId = pathNode.id();
                    pathEdge = cameFromEdge[pathNodeId];
                }
                return {
                    found: true,
                    distance: gScore[cMinId],
                    path: this.spawn(path),
                    steps: steps
                };
            }
            // Add cMin to processed nodes
            closedSetIds[cMinId] = true;
            // Update scores for neighbors of cMin
            // Take into account if graph is directed or not
            var vwEdges = cMin._private.edges;
            for(var i = 0; i < vwEdges.length; i++){
                var e = vwEdges[i];
                // edge must be in set of calling eles
                if (!this.hasElementWithId(e.id())) continue;
                // cMin must be the source of edge if directed
                if (directed && e.data('source') !== cMinId) continue;
                var wSrc = e.source();
                var wTgt = e.target();
                var w = wSrc.id() !== cMinId ? wSrc : wTgt;
                var wid = w.id();
                // node must be in set of calling eles
                if (!this.hasElementWithId(wid)) continue;
                // if node is in closedSet, ignore it
                if (closedSetIds[wid]) continue;
                // New tentative score for node w
                var tempScore = gScore[cMinId] + weight(e);
                // Update gScore for node w if:
                //   w not present in openSet
                // OR
                //   tentative gScore is less than previous value
                // w not in openSet
                if (!isInOpenSet(wid)) {
                    gScore[wid] = tempScore;
                    fScore[wid] = tempScore + heuristic(w);
                    addToOpenSet(w, wid);
                    cameFrom[wid] = cMin;
                    cameFromEdge[wid] = e;
                    continue;
                }
                // w already in openSet, but with greater gScore
                if (tempScore < gScore[wid]) {
                    gScore[wid] = tempScore;
                    fScore[wid] = tempScore + heuristic(w);
                    cameFrom[wid] = cMin;
                    cameFromEdge[wid] = e;
                }
            } // End of neighbors update
        } // End of main loop
        // If we've reached here, then we've not reached our goal
        return {
            found: false,
            distance: undefined,
            path: undefined,
            steps: steps
        };
    }
}; // elesfn
var $e815fda779bc047b$var$floydWarshallDefaults = $e815fda779bc047b$var$defaults$g({
    weight: function weight(edge) {
        return 1;
    },
    directed: false
});
var $e815fda779bc047b$var$elesfn$r = {
    // Implemented from pseudocode from wikipedia
    floydWarshall: function floydWarshall(options) {
        var cy = this.cy();
        var _floydWarshallDefault = $e815fda779bc047b$var$floydWarshallDefaults(options), weight = _floydWarshallDefault.weight, directed = _floydWarshallDefault.directed;
        var weightFn = weight;
        var _this$byGroup = this.byGroup(), nodes = _this$byGroup.nodes, edges = _this$byGroup.edges;
        var N = nodes.length;
        var Nsq = N * N;
        var indexOf = function indexOf(node) {
            return nodes.indexOf(node);
        };
        var atIndex = function atIndex(i) {
            return nodes[i];
        };
        // Initialize distance matrix
        var dist = new Array(Nsq);
        for(var n = 0; n < Nsq; n++){
            var j = n % N;
            var i = (n - j) / N;
            if (i === j) dist[n] = 0;
            else dist[n] = Infinity;
        }
        // Initialize matrix used for path reconstruction
        // Initialize distance matrix
        var next = new Array(Nsq);
        var edgeNext = new Array(Nsq);
        // Process edges
        for(var _i = 0; _i < edges.length; _i++){
            var edge = edges[_i];
            var src = edge.source()[0];
            var tgt = edge.target()[0];
            if (src === tgt) continue;
             // exclude loops
            var s = indexOf(src);
            var t = indexOf(tgt);
            var st = s * N + t; // source to target index
            var _weight = weightFn(edge);
            // Check if already process another edge between same 2 nodes
            if (dist[st] > _weight) {
                dist[st] = _weight;
                next[st] = t;
                edgeNext[st] = edge;
            }
            // If undirected graph, process 'reversed' edge
            if (!directed) {
                var ts = t * N + s; // target to source index
                if (!directed && dist[ts] > _weight) {
                    dist[ts] = _weight;
                    next[ts] = s;
                    edgeNext[ts] = edge;
                }
            }
        }
        // Main loop
        for(var k = 0; k < N; k++)for(var _i2 = 0; _i2 < N; _i2++){
            var ik = _i2 * N + k;
            for(var _j = 0; _j < N; _j++){
                var ij = _i2 * N + _j;
                var kj = k * N + _j;
                if (dist[ik] + dist[kj] < dist[ij]) {
                    dist[ij] = dist[ik] + dist[kj];
                    next[ij] = next[ik];
                }
            }
        }
        var getArgEle = function getArgEle(ele) {
            return ($e815fda779bc047b$var$string(ele) ? cy.filter(ele) : ele)[0];
        };
        var indexOfArgEle = function indexOfArgEle(ele) {
            return indexOf(getArgEle(ele));
        };
        var res = {
            distance: function distance(from, to) {
                var i = indexOfArgEle(from);
                var j = indexOfArgEle(to);
                return dist[i * N + j];
            },
            path: function path(from, to) {
                var i = indexOfArgEle(from);
                var j = indexOfArgEle(to);
                var fromNode = atIndex(i);
                if (i === j) return fromNode.collection();
                if (next[i * N + j] == null) return cy.collection();
                var path = cy.collection();
                var prev = i;
                var edge;
                path.merge(fromNode);
                while(i !== j){
                    prev = i;
                    i = next[i * N + j];
                    edge = edgeNext[prev * N + i];
                    path.merge(edge);
                    path.merge(atIndex(i));
                }
                return path;
            }
        };
        return res;
    } // floydWarshall
}; // elesfn
var $e815fda779bc047b$var$bellmanFordDefaults = $e815fda779bc047b$var$defaults$g({
    weight: function weight(edge) {
        return 1;
    },
    directed: false,
    root: null
});
var $e815fda779bc047b$var$elesfn$q = {
    // Implemented from pseudocode from wikipedia
    bellmanFord: function bellmanFord(options) {
        var _this = this;
        var _bellmanFordDefaults = $e815fda779bc047b$var$bellmanFordDefaults(options), weight = _bellmanFordDefaults.weight, directed = _bellmanFordDefaults.directed, root = _bellmanFordDefaults.root;
        var weightFn = weight;
        var eles = this;
        var cy = this.cy();
        var _this$byGroup = this.byGroup(), edges = _this$byGroup.edges, nodes = _this$byGroup.nodes;
        var numNodes = nodes.length;
        var infoMap = new $e815fda779bc047b$var$Map$1();
        var hasNegativeWeightCycle = false;
        var negativeWeightCycles = [];
        root = cy.collection(root)[0]; // in case selector passed
        edges.unmergeBy(function(edge) {
            return edge.isLoop();
        });
        var numEdges = edges.length;
        var getInfo = function getInfo(node) {
            var obj = infoMap.get(node.id());
            if (!obj) {
                obj = {};
                infoMap.set(node.id(), obj);
            }
            return obj;
        };
        var getNodeFromTo = function getNodeFromTo(to) {
            return ($e815fda779bc047b$var$string(to) ? cy.$(to) : to)[0];
        };
        var distanceTo = function distanceTo(to) {
            return getInfo(getNodeFromTo(to)).dist;
        };
        var pathTo = function pathTo(to) {
            var thisStart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : root;
            var end = getNodeFromTo(to);
            var path = [];
            var node = end;
            for(;;){
                if (node == null) return _this.spawn();
                var _getInfo = getInfo(node), edge = _getInfo.edge, pred = _getInfo.pred;
                path.unshift(node[0]);
                if (node.same(thisStart) && path.length > 0) break;
                if (edge != null) path.unshift(edge);
                node = pred;
            }
            return eles.spawn(path);
        };
        // Initializations { dist, pred, edge }
        for(var i = 0; i < numNodes; i++){
            var node = nodes[i];
            var info = getInfo(node);
            if (node.same(root)) info.dist = 0;
            else info.dist = Infinity;
            info.pred = null;
            info.edge = null;
        }
        // Edges relaxation
        var replacedEdge = false;
        var checkForEdgeReplacement = function checkForEdgeReplacement(node1, node2, edge, info1, info2, weight) {
            var dist = info1.dist + weight;
            if (dist < info2.dist && !edge.same(info1.edge)) {
                info2.dist = dist;
                info2.pred = node1;
                info2.edge = edge;
                replacedEdge = true;
            }
        };
        for(var _i = 1; _i < numNodes; _i++){
            replacedEdge = false;
            for(var e = 0; e < numEdges; e++){
                var edge = edges[e];
                var src = edge.source();
                var tgt = edge.target();
                var _weight = weightFn(edge);
                var srcInfo = getInfo(src);
                var tgtInfo = getInfo(tgt);
                checkForEdgeReplacement(src, tgt, edge, srcInfo, tgtInfo, _weight);
                // If undirected graph, we need to take into account the 'reverse' edge
                if (!directed) checkForEdgeReplacement(tgt, src, edge, tgtInfo, srcInfo, _weight);
            }
            if (!replacedEdge) break;
        }
        if (replacedEdge) {
            // Check for negative weight cycles
            var negativeWeightCycleIds = [];
            for(var _e = 0; _e < numEdges; _e++){
                var _edge = edges[_e];
                var _src = _edge.source();
                var _tgt = _edge.target();
                var _weight2 = weightFn(_edge);
                var srcDist = getInfo(_src).dist;
                var tgtDist = getInfo(_tgt).dist;
                if (srcDist + _weight2 < tgtDist || !directed && tgtDist + _weight2 < srcDist) {
                    if (!hasNegativeWeightCycle) {
                        $e815fda779bc047b$var$warn('Graph contains a negative weight cycle for Bellman-Ford');
                        hasNegativeWeightCycle = true;
                    }
                    if (options.findNegativeWeightCycles !== false) {
                        var negativeNodes = [];
                        if (srcDist + _weight2 < tgtDist) negativeNodes.push(_src);
                        if (!directed && tgtDist + _weight2 < srcDist) negativeNodes.push(_tgt);
                        var numNegativeNodes = negativeNodes.length;
                        for(var n = 0; n < numNegativeNodes; n++){
                            var start = negativeNodes[n];
                            var cycle = [
                                start
                            ];
                            cycle.push(getInfo(start).edge);
                            var _node = getInfo(start).pred;
                            while(cycle.indexOf(_node) === -1){
                                cycle.push(_node);
                                cycle.push(getInfo(_node).edge);
                                _node = getInfo(_node).pred;
                            }
                            cycle = cycle.slice(cycle.indexOf(_node));
                            var smallestId = cycle[0].id();
                            var smallestIndex = 0;
                            for(var c = 2; c < cycle.length; c += 2)if (cycle[c].id() < smallestId) {
                                smallestId = cycle[c].id();
                                smallestIndex = c;
                            }
                            cycle = cycle.slice(smallestIndex).concat(cycle.slice(0, smallestIndex));
                            cycle.push(cycle[0]);
                            var cycleId = cycle.map(function(el) {
                                return el.id();
                            }).join(",");
                            if (negativeWeightCycleIds.indexOf(cycleId) === -1) {
                                negativeWeightCycles.push(eles.spawn(cycle));
                                negativeWeightCycleIds.push(cycleId);
                            }
                        }
                    } else break;
                }
            }
        }
        return {
            distanceTo: distanceTo,
            pathTo: pathTo,
            hasNegativeWeightCycle: hasNegativeWeightCycle,
            negativeWeightCycles: negativeWeightCycles
        };
    } // bellmanFord
}; // elesfn
var $e815fda779bc047b$var$sqrt2 = Math.sqrt(2);
// Function which colapses 2 (meta) nodes into one
// Updates the remaining edge lists
// Receives as a paramater the edge which causes the collapse
var $e815fda779bc047b$var$collapse = function collapse(edgeIndex, nodeMap, remainingEdges) {
    if (remainingEdges.length === 0) $e815fda779bc047b$var$error("Karger-Stein must be run on a connected (sub)graph");
    var edgeInfo = remainingEdges[edgeIndex];
    var sourceIn = edgeInfo[1];
    var targetIn = edgeInfo[2];
    var partition1 = nodeMap[sourceIn];
    var partition2 = nodeMap[targetIn];
    var newEdges = remainingEdges; // re-use array
    // Delete all edges between partition1 and partition2
    for(var i = newEdges.length - 1; i >= 0; i--){
        var edge = newEdges[i];
        var src = edge[1];
        var tgt = edge[2];
        if (nodeMap[src] === partition1 && nodeMap[tgt] === partition2 || nodeMap[src] === partition2 && nodeMap[tgt] === partition1) newEdges.splice(i, 1);
    }
    // All edges pointing to partition2 should now point to partition1
    for(var _i = 0; _i < newEdges.length; _i++){
        var _edge = newEdges[_i];
        if (_edge[1] === partition2) {
            // Check source
            newEdges[_i] = _edge.slice(); // copy
            newEdges[_i][1] = partition1;
        } else if (_edge[2] === partition2) {
            // Check target
            newEdges[_i] = _edge.slice(); // copy
            newEdges[_i][2] = partition1;
        }
    }
    // Move all nodes from partition2 to partition1
    for(var _i2 = 0; _i2 < nodeMap.length; _i2++)if (nodeMap[_i2] === partition2) nodeMap[_i2] = partition1;
    return newEdges;
};
// Contracts a graph until we reach a certain number of meta nodes
var $e815fda779bc047b$var$contractUntil = function contractUntil(metaNodeMap, remainingEdges, size, sizeLimit) {
    while(size > sizeLimit){
        // Choose an edge randomly
        var edgeIndex = Math.floor(Math.random() * remainingEdges.length);
        // Collapse graph based on edge
        remainingEdges = $e815fda779bc047b$var$collapse(edgeIndex, metaNodeMap, remainingEdges);
        size--;
    }
    return remainingEdges;
};
var $e815fda779bc047b$var$elesfn$p = {
    // Computes the minimum cut of an undirected graph
    // Returns the correct answer with high probability
    kargerStein: function kargerStein() {
        var _this = this;
        var _this$byGroup = this.byGroup(), nodes = _this$byGroup.nodes, edges = _this$byGroup.edges;
        edges.unmergeBy(function(edge) {
            return edge.isLoop();
        });
        var numNodes = nodes.length;
        var numEdges = edges.length;
        var numIter = Math.ceil(Math.pow(Math.log(numNodes) / Math.LN2, 2));
        var stopSize = Math.floor(numNodes / $e815fda779bc047b$var$sqrt2);
        if (numNodes < 2) {
            $e815fda779bc047b$var$error('At least 2 nodes are required for Karger-Stein algorithm');
            return undefined;
        }
        // Now store edge destination as indexes
        // Format for each edge (edge index, source node index, target node index)
        var edgeIndexes = [];
        for(var i = 0; i < numEdges; i++){
            var e = edges[i];
            edgeIndexes.push([
                i,
                nodes.indexOf(e.source()),
                nodes.indexOf(e.target())
            ]);
        }
        // We will store the best cut found here
        var minCutSize = Infinity;
        var minCutEdgeIndexes = [];
        var minCutNodeMap = new Array(numNodes);
        // Initial meta node partition
        var metaNodeMap = new Array(numNodes);
        var metaNodeMap2 = new Array(numNodes);
        var copyNodesMap = function copyNodesMap(from, to) {
            for(var _i3 = 0; _i3 < numNodes; _i3++)to[_i3] = from[_i3];
        };
        // Main loop
        for(var iter = 0; iter <= numIter; iter++){
            // Reset meta node partition
            for(var _i4 = 0; _i4 < numNodes; _i4++)metaNodeMap[_i4] = _i4;
            // Contract until stop point (stopSize nodes)
            var edgesState = $e815fda779bc047b$var$contractUntil(metaNodeMap, edgeIndexes.slice(), numNodes, stopSize);
            var edgesState2 = edgesState.slice(); // copy
            // Create a copy of the colapsed nodes state
            copyNodesMap(metaNodeMap, metaNodeMap2);
            // Run 2 iterations starting in the stop state
            var res1 = $e815fda779bc047b$var$contractUntil(metaNodeMap, edgesState, stopSize, 2);
            var res2 = $e815fda779bc047b$var$contractUntil(metaNodeMap2, edgesState2, stopSize, 2);
            // Is any of the 2 results the best cut so far?
            if (res1.length <= res2.length && res1.length < minCutSize) {
                minCutSize = res1.length;
                minCutEdgeIndexes = res1;
                copyNodesMap(metaNodeMap, minCutNodeMap);
            } else if (res2.length <= res1.length && res2.length < minCutSize) {
                minCutSize = res2.length;
                minCutEdgeIndexes = res2;
                copyNodesMap(metaNodeMap2, minCutNodeMap);
            }
        } // end of main loop
        // Construct result
        var cut = this.spawn(minCutEdgeIndexes.map(function(e) {
            return edges[e[0]];
        }));
        var partition1 = this.spawn();
        var partition2 = this.spawn();
        // traverse metaNodeMap for best cut
        var witnessNodePartition = minCutNodeMap[0];
        for(var _i5 = 0; _i5 < minCutNodeMap.length; _i5++){
            var partitionId = minCutNodeMap[_i5];
            var node = nodes[_i5];
            if (partitionId === witnessNodePartition) partition1.merge(node);
            else partition2.merge(node);
        }
        // construct components corresponding to each disjoint subset of nodes
        var constructComponent = function constructComponent(subset) {
            var component = _this.spawn();
            subset.forEach(function(node) {
                component.merge(node);
                node.connectedEdges().forEach(function(edge) {
                    // ensure edge is within calling collection and edge is not in cut
                    if (_this.contains(edge) && !cut.contains(edge)) component.merge(edge);
                });
            });
            return component;
        };
        var components = [
            constructComponent(partition1),
            constructComponent(partition2)
        ];
        var ret = {
            cut: cut,
            components: components,
            // n.b. partitions are included to be compatible with the old api spec
            // (could be removed in a future major version)
            partition1: partition1,
            partition2: partition2
        };
        return ret;
    }
}; // elesfn
var $e815fda779bc047b$var$_Math$hypot;
var $e815fda779bc047b$var$copyPosition = function copyPosition(p) {
    return {
        x: p.x,
        y: p.y
    };
};
var $e815fda779bc047b$var$modelToRenderedPosition$1 = function modelToRenderedPosition(p, zoom, pan) {
    return {
        x: p.x * zoom + pan.x,
        y: p.y * zoom + pan.y
    };
};
var $e815fda779bc047b$var$renderedToModelPosition = function renderedToModelPosition(p, zoom, pan) {
    return {
        x: (p.x - pan.x) / zoom,
        y: (p.y - pan.y) / zoom
    };
};
var $e815fda779bc047b$var$array2point = function array2point(arr) {
    return {
        x: arr[0],
        y: arr[1]
    };
};
var $e815fda779bc047b$var$min = function min(arr) {
    var begin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : arr.length;
    var min = Infinity;
    for(var i = begin; i < end; i++){
        var val = arr[i];
        if (isFinite(val)) min = Math.min(val, min);
    }
    return min;
};
var $e815fda779bc047b$var$max = function max(arr) {
    var begin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : arr.length;
    var max = -Infinity;
    for(var i = begin; i < end; i++){
        var val = arr[i];
        if (isFinite(val)) max = Math.max(val, max);
    }
    return max;
};
var $e815fda779bc047b$var$mean = function mean(arr) {
    var begin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : arr.length;
    var total = 0;
    var n = 0;
    for(var i = begin; i < end; i++){
        var val = arr[i];
        if (isFinite(val)) {
            total += val;
            n++;
        }
    }
    return total / n;
};
var $e815fda779bc047b$var$median = function median(arr) {
    var begin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : arr.length;
    var copy = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var sort = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    var includeHoles = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
    if (copy) arr = arr.slice(begin, end);
    else {
        if (end < arr.length) arr.splice(end, arr.length - end);
        if (begin > 0) arr.splice(0, begin);
    }
    // all non finite (e.g. Infinity, NaN) elements must be -Infinity so they go to the start
    var off = 0; // offset from non-finite values
    for(var i = arr.length - 1; i >= 0; i--){
        var v = arr[i];
        if (includeHoles) {
            if (!isFinite(v)) {
                arr[i] = -Infinity;
                off++;
            }
        } else // just remove it if we don't want to consider holes
        arr.splice(i, 1);
    }
    if (sort) arr.sort(function(a, b) {
        return a - b;
    }); // requires copy = true if you don't want to change the orig
    var len = arr.length;
    var mid = Math.floor(len / 2);
    if (len % 2 !== 0) return arr[mid + 1 + off];
    else return (arr[mid - 1 + off] + arr[mid + off]) / 2;
};
var $e815fda779bc047b$var$deg2rad = function deg2rad(deg) {
    return Math.PI * deg / 180;
};
var $e815fda779bc047b$var$getAngleFromDisp = function getAngleFromDisp(dispX, dispY) {
    return Math.atan2(dispY, dispX) - Math.PI / 2;
};
var $e815fda779bc047b$var$log2 = Math.log2 || function(n) {
    return Math.log(n) / Math.log(2);
};
var $e815fda779bc047b$var$signum = function signum(x) {
    if (x > 0) return 1;
    else if (x < 0) return -1;
    else return 0;
};
var $e815fda779bc047b$var$dist = function dist(p1, p2) {
    return Math.sqrt($e815fda779bc047b$var$sqdist(p1, p2));
};
var $e815fda779bc047b$var$sqdist = function sqdist(p1, p2) {
    var dx = p2.x - p1.x;
    var dy = p2.y - p1.y;
    return dx * dx + dy * dy;
};
var $e815fda779bc047b$var$inPlaceSumNormalize = function inPlaceSumNormalize(v) {
    var length = v.length;
    // First, get sum of all elements
    var total = 0;
    for(var i = 0; i < length; i++)total += v[i];
    // Now, divide each by the sum of all elements
    for(var _i = 0; _i < length; _i++)v[_i] = v[_i] / total;
    return v;
};
// from http://en.wikipedia.org/wiki/Bézier_curve#Quadratic_curves
var $e815fda779bc047b$var$qbezierAt = function qbezierAt(p0, p1, p2, t) {
    return (1 - t) * (1 - t) * p0 + 2 * (1 - t) * t * p1 + t * t * p2;
};
var $e815fda779bc047b$var$qbezierPtAt = function qbezierPtAt(p0, p1, p2, t) {
    return {
        x: $e815fda779bc047b$var$qbezierAt(p0.x, p1.x, p2.x, t),
        y: $e815fda779bc047b$var$qbezierAt(p0.y, p1.y, p2.y, t)
    };
};
var $e815fda779bc047b$var$lineAt = function lineAt(p0, p1, t, d) {
    var vec = {
        x: p1.x - p0.x,
        y: p1.y - p0.y
    };
    var vecDist = $e815fda779bc047b$var$dist(p0, p1);
    var normVec = {
        x: vec.x / vecDist,
        y: vec.y / vecDist
    };
    t = t == null ? 0 : t;
    d = d != null ? d : t * vecDist;
    return {
        x: p0.x + normVec.x * d,
        y: p0.y + normVec.y * d
    };
};
var $e815fda779bc047b$var$bound = function bound(min, val, max) {
    return Math.max(min, Math.min(max, val));
};
// makes a full bb (x1, y1, x2, y2, w, h) from implicit params
var $e815fda779bc047b$var$makeBoundingBox = function makeBoundingBox(bb) {
    if (bb == null) return {
        x1: Infinity,
        y1: Infinity,
        x2: -Infinity,
        y2: -Infinity,
        w: 0,
        h: 0
    };
    else if (bb.x1 != null && bb.y1 != null) {
        if (bb.x2 != null && bb.y2 != null && bb.x2 >= bb.x1 && bb.y2 >= bb.y1) return {
            x1: bb.x1,
            y1: bb.y1,
            x2: bb.x2,
            y2: bb.y2,
            w: bb.x2 - bb.x1,
            h: bb.y2 - bb.y1
        };
        else if (bb.w != null && bb.h != null && bb.w >= 0 && bb.h >= 0) return {
            x1: bb.x1,
            y1: bb.y1,
            x2: bb.x1 + bb.w,
            y2: bb.y1 + bb.h,
            w: bb.w,
            h: bb.h
        };
    }
};
var $e815fda779bc047b$var$copyBoundingBox = function copyBoundingBox(bb) {
    return {
        x1: bb.x1,
        x2: bb.x2,
        w: bb.w,
        y1: bb.y1,
        y2: bb.y2,
        h: bb.h
    };
};
var $e815fda779bc047b$var$clearBoundingBox = function clearBoundingBox(bb) {
    bb.x1 = Infinity;
    bb.y1 = Infinity;
    bb.x2 = -Infinity;
    bb.y2 = -Infinity;
    bb.w = 0;
    bb.h = 0;
};
var $e815fda779bc047b$var$updateBoundingBox = function updateBoundingBox(bb1, bb2) {
    // update bb1 with bb2 bounds
    bb1.x1 = Math.min(bb1.x1, bb2.x1);
    bb1.x2 = Math.max(bb1.x2, bb2.x2);
    bb1.w = bb1.x2 - bb1.x1;
    bb1.y1 = Math.min(bb1.y1, bb2.y1);
    bb1.y2 = Math.max(bb1.y2, bb2.y2);
    bb1.h = bb1.y2 - bb1.y1;
};
var $e815fda779bc047b$var$expandBoundingBoxByPoint = function expandBoundingBoxByPoint(bb, x, y) {
    bb.x1 = Math.min(bb.x1, x);
    bb.x2 = Math.max(bb.x2, x);
    bb.w = bb.x2 - bb.x1;
    bb.y1 = Math.min(bb.y1, y);
    bb.y2 = Math.max(bb.y2, y);
    bb.h = bb.y2 - bb.y1;
};
var $e815fda779bc047b$var$expandBoundingBox = function expandBoundingBox(bb) {
    var padding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    bb.x1 -= padding;
    bb.x2 += padding;
    bb.y1 -= padding;
    bb.y2 += padding;
    bb.w = bb.x2 - bb.x1;
    bb.h = bb.y2 - bb.y1;
    return bb;
};
var $e815fda779bc047b$var$expandBoundingBoxSides = function expandBoundingBoxSides(bb) {
    var padding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [
        0
    ];
    var top, right, bottom, left;
    if (padding.length === 1) top = right = bottom = left = padding[0];
    else if (padding.length === 2) {
        top = bottom = padding[0];
        left = right = padding[1];
    } else if (padding.length === 4) {
        var _padding = $e815fda779bc047b$var$_slicedToArray(padding, 4);
        top = _padding[0];
        right = _padding[1];
        bottom = _padding[2];
        left = _padding[3];
    }
    bb.x1 -= left;
    bb.x2 += right;
    bb.y1 -= top;
    bb.y2 += bottom;
    bb.w = bb.x2 - bb.x1;
    bb.h = bb.y2 - bb.y1;
    return bb;
};
// assign the values of bb2 into bb1
var $e815fda779bc047b$var$assignBoundingBox = function assignBoundingBox(bb1, bb2) {
    bb1.x1 = bb2.x1;
    bb1.y1 = bb2.y1;
    bb1.x2 = bb2.x2;
    bb1.y2 = bb2.y2;
    bb1.w = bb1.x2 - bb1.x1;
    bb1.h = bb1.y2 - bb1.y1;
};
var $e815fda779bc047b$var$boundingBoxesIntersect = function boundingBoxesIntersect(bb1, bb2) {
    // case: one bb to right of other
    if (bb1.x1 > bb2.x2) return false;
    if (bb2.x1 > bb1.x2) return false;
    // case: one bb to left of other
    if (bb1.x2 < bb2.x1) return false;
    if (bb2.x2 < bb1.x1) return false;
    // case: one bb above other
    if (bb1.y2 < bb2.y1) return false;
    if (bb2.y2 < bb1.y1) return false;
    // case: one bb below other
    if (bb1.y1 > bb2.y2) return false;
    if (bb2.y1 > bb1.y2) return false;
    // otherwise, must have some overlap
    return true;
};
var $e815fda779bc047b$var$inBoundingBox = function inBoundingBox(bb, x, y) {
    return bb.x1 <= x && x <= bb.x2 && bb.y1 <= y && y <= bb.y2;
};
var $e815fda779bc047b$var$pointInBoundingBox = function pointInBoundingBox(bb, pt) {
    return $e815fda779bc047b$var$inBoundingBox(bb, pt.x, pt.y);
};
var $e815fda779bc047b$var$boundingBoxInBoundingBox = function boundingBoxInBoundingBox(bb1, bb2) {
    return $e815fda779bc047b$var$inBoundingBox(bb1, bb2.x1, bb2.y1) && $e815fda779bc047b$var$inBoundingBox(bb1, bb2.x2, bb2.y2);
};
var $e815fda779bc047b$var$hypot = ($e815fda779bc047b$var$_Math$hypot = Math.hypot) !== null && $e815fda779bc047b$var$_Math$hypot !== undefined ? $e815fda779bc047b$var$_Math$hypot : function(x, y) {
    return Math.sqrt(x * x + y * y);
};
function $e815fda779bc047b$var$inflatePolygon(polygon, d) {
    if (polygon.length < 3) throw new Error('Need at least 3 vertices');
    // Helpers
    var add = function add(a, b) {
        return {
            x: a.x + b.x,
            y: a.y + b.y
        };
    };
    var sub = function sub(a, b) {
        return {
            x: a.x - b.x,
            y: a.y - b.y
        };
    };
    var scale = function scale(v, s) {
        return {
            x: v.x * s,
            y: v.y * s
        };
    };
    var cross = function cross(u, v) {
        return u.x * v.y - u.y * v.x;
    };
    var normalize = function normalize(v) {
        var len = $e815fda779bc047b$var$hypot(v.x, v.y);
        return len === 0 ? {
            x: 0,
            y: 0
        } : {
            x: v.x / len,
            y: v.y / len
        };
    };
    // Signed area (positive = CCW)
    var signedArea = function signedArea(pts) {
        var A = 0;
        for(var i = 0; i < pts.length; i++){
            var p = pts[i], q = pts[(i + 1) % pts.length];
            A += p.x * q.y - q.x * p.y;
        }
        return A / 2;
    };
    // Line–line intersection (infinite lines)
    var intersectLines = function intersectLines(p1, p2, p3, p4) {
        var r = sub(p2, p1);
        var s = sub(p4, p3);
        var denom = cross(r, s);
        if (Math.abs(denom) < 1e-9) // Parallel or nearly so — fallback to midpoint
        return add(p1, scale(r, 0.5));
        var t = cross(sub(p3, p1), s) / denom;
        return add(p1, scale(r, t));
    };
    // Make a shallow copy and enforce CCW
    var pts = polygon.map(function(p) {
        return {
            x: p.x,
            y: p.y
        };
    });
    if (signedArea(pts) < 0) pts.reverse();
    var n = pts.length;
    // Compute outward normals for each edge
    var normals = [];
    for(var i = 0; i < n; i++){
        var p = pts[i], q = pts[(i + 1) % n];
        var edge = sub(q, p);
        // For CCW polygon, inward normal = (-edge.y, edge.x)
        // so outward normal = (edge.y, -edge.x)
        var out = normalize({
            x: edge.y,
            y: -edge.x
        });
        normals.push(out);
    }
    // Build offset edges
    var offsetEdges = normals.map(function(nrm, i) {
        var p1 = add(pts[i], scale(nrm, d));
        var p2 = add(pts[(i + 1) % n], scale(nrm, d));
        return {
            p1: p1,
            p2: p2
        };
    });
    // Intersect consecutive offset edges
    var inflated = [];
    for(var _i2 = 0; _i2 < n; _i2++){
        var prevEdge = offsetEdges[(_i2 - 1 + n) % n];
        var currEdge = offsetEdges[_i2];
        var ip = intersectLines(prevEdge.p1, prevEdge.p2, currEdge.p1, currEdge.p2);
        inflated.push(ip);
    }
    return inflated;
}
function $e815fda779bc047b$var$miterBox(pts, centerX, centerY, width, height, strokeWidth) {
    var tpts = $e815fda779bc047b$var$transformPoints(pts, centerX, centerY, width, height);
    var offsetPoints = $e815fda779bc047b$var$inflatePolygon(tpts, strokeWidth);
    var bb = $e815fda779bc047b$var$makeBoundingBox();
    offsetPoints.forEach(function(pt) {
        return $e815fda779bc047b$var$expandBoundingBoxByPoint(bb, pt.x, pt.y);
    });
    return bb;
}
var $e815fda779bc047b$var$roundRectangleIntersectLine = function roundRectangleIntersectLine(x, y, nodeX, nodeY, width, height, padding) {
    var radius = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 'auto';
    var cornerRadius = radius === 'auto' ? $e815fda779bc047b$var$getRoundRectangleRadius(width, height) : radius;
    var halfWidth = width / 2;
    var halfHeight = height / 2;
    cornerRadius = Math.min(cornerRadius, halfWidth, halfHeight);
    var doWidth = cornerRadius !== halfWidth, doHeight = cornerRadius !== halfHeight;
    // Check intersections with straight line segments
    var straightLineIntersections;
    // Top segment, left to right
    if (doWidth) {
        var topStartX = nodeX - halfWidth + cornerRadius - padding;
        var topStartY = nodeY - halfHeight - padding;
        var topEndX = nodeX + halfWidth - cornerRadius + padding;
        var topEndY = topStartY;
        straightLineIntersections = $e815fda779bc047b$var$finiteLinesIntersect(x, y, nodeX, nodeY, topStartX, topStartY, topEndX, topEndY, false);
        if (straightLineIntersections.length > 0) return straightLineIntersections;
    }
    // Right segment, top to bottom
    if (doHeight) {
        var rightStartX = nodeX + halfWidth + padding;
        var rightStartY = nodeY - halfHeight + cornerRadius - padding;
        var rightEndX = rightStartX;
        var rightEndY = nodeY + halfHeight - cornerRadius + padding;
        straightLineIntersections = $e815fda779bc047b$var$finiteLinesIntersect(x, y, nodeX, nodeY, rightStartX, rightStartY, rightEndX, rightEndY, false);
        if (straightLineIntersections.length > 0) return straightLineIntersections;
    }
    // Bottom segment, left to right
    if (doWidth) {
        var bottomStartX = nodeX - halfWidth + cornerRadius - padding;
        var bottomStartY = nodeY + halfHeight + padding;
        var bottomEndX = nodeX + halfWidth - cornerRadius + padding;
        var bottomEndY = bottomStartY;
        straightLineIntersections = $e815fda779bc047b$var$finiteLinesIntersect(x, y, nodeX, nodeY, bottomStartX, bottomStartY, bottomEndX, bottomEndY, false);
        if (straightLineIntersections.length > 0) return straightLineIntersections;
    }
    // Left segment, top to bottom
    if (doHeight) {
        var leftStartX = nodeX - halfWidth - padding;
        var leftStartY = nodeY - halfHeight + cornerRadius - padding;
        var leftEndX = leftStartX;
        var leftEndY = nodeY + halfHeight - cornerRadius + padding;
        straightLineIntersections = $e815fda779bc047b$var$finiteLinesIntersect(x, y, nodeX, nodeY, leftStartX, leftStartY, leftEndX, leftEndY, false);
        if (straightLineIntersections.length > 0) return straightLineIntersections;
    }
    // Check intersections with arc segments
    var arcIntersections;
    var topLeftCenterX = nodeX - halfWidth + cornerRadius;
    var topLeftCenterY = nodeY - halfHeight + cornerRadius;
    arcIntersections = $e815fda779bc047b$var$intersectLineCircle(x, y, nodeX, nodeY, topLeftCenterX, topLeftCenterY, cornerRadius + padding);
    // Ensure the intersection is on the desired quarter of the circle
    if (arcIntersections.length > 0 && arcIntersections[0] <= topLeftCenterX && arcIntersections[1] <= topLeftCenterY) return [
        arcIntersections[0],
        arcIntersections[1]
    ];
    var topRightCenterX = nodeX + halfWidth - cornerRadius;
    var topRightCenterY = nodeY - halfHeight + cornerRadius;
    arcIntersections = $e815fda779bc047b$var$intersectLineCircle(x, y, nodeX, nodeY, topRightCenterX, topRightCenterY, cornerRadius + padding);
    // Ensure the intersection is on the desired quarter of the circle
    if (arcIntersections.length > 0 && arcIntersections[0] >= topRightCenterX && arcIntersections[1] <= topRightCenterY) return [
        arcIntersections[0],
        arcIntersections[1]
    ];
    var bottomRightCenterX = nodeX + halfWidth - cornerRadius;
    var bottomRightCenterY = nodeY + halfHeight - cornerRadius;
    arcIntersections = $e815fda779bc047b$var$intersectLineCircle(x, y, nodeX, nodeY, bottomRightCenterX, bottomRightCenterY, cornerRadius + padding);
    // Ensure the intersection is on the desired quarter of the circle
    if (arcIntersections.length > 0 && arcIntersections[0] >= bottomRightCenterX && arcIntersections[1] >= bottomRightCenterY) return [
        arcIntersections[0],
        arcIntersections[1]
    ];
    var bottomLeftCenterX = nodeX - halfWidth + cornerRadius;
    var bottomLeftCenterY = nodeY + halfHeight - cornerRadius;
    arcIntersections = $e815fda779bc047b$var$intersectLineCircle(x, y, nodeX, nodeY, bottomLeftCenterX, bottomLeftCenterY, cornerRadius + padding);
    // Ensure the intersection is on the desired quarter of the circle
    if (arcIntersections.length > 0 && arcIntersections[0] <= bottomLeftCenterX && arcIntersections[1] >= bottomLeftCenterY) return [
        arcIntersections[0],
        arcIntersections[1]
    ];
    return []; // if nothing
};
var $e815fda779bc047b$var$inLineVicinity = function inLineVicinity(x, y, lx1, ly1, lx2, ly2, tolerance) {
    var t = tolerance;
    var x1 = Math.min(lx1, lx2);
    var x2 = Math.max(lx1, lx2);
    var y1 = Math.min(ly1, ly2);
    var y2 = Math.max(ly1, ly2);
    return x1 - t <= x && x <= x2 + t && y1 - t <= y && y <= y2 + t;
};
var $e815fda779bc047b$var$inBezierVicinity = function inBezierVicinity(x, y, x1, y1, x2, y2, x3, y3, tolerance) {
    var bb = {
        x1: Math.min(x1, x3, x2) - tolerance,
        x2: Math.max(x1, x3, x2) + tolerance,
        y1: Math.min(y1, y3, y2) - tolerance,
        y2: Math.max(y1, y3, y2) + tolerance
    };
    // if outside the rough bounding box for the bezier, then it can't be a hit
    if (x < bb.x1 || x > bb.x2 || y < bb.y1 || y > bb.y2) // console.log('bezier out of rough bb')
    return false;
    else // console.log('do more expensive check');
    return true;
};
var $e815fda779bc047b$var$solveQuadratic = function solveQuadratic(a, b, c, val) {
    c -= val;
    var r = b * b - 4 * a * c;
    if (r < 0) return [];
    var sqrtR = Math.sqrt(r);
    var denom = 2 * a;
    var root1 = (-b + sqrtR) / denom;
    var root2 = (-b - sqrtR) / denom;
    return [
        root1,
        root2
    ];
};
var $e815fda779bc047b$var$solveCubic = function solveCubic(a, b, c, d, result) {
    // Solves a cubic function, returns root in form [r1, i1, r2, i2, r3, i3], where
    // r is the real component, i is the imaginary component
    // An implementation of the Cardano method from the year 1545
    // http://en.wikipedia.org/wiki/Cubic_function#The_nature_of_the_roots
    var epsilon = 0.00001;
    // avoid division by zero while keeping the overall expression close in value
    if (a === 0) a = epsilon;
    b /= a;
    c /= a;
    d /= a;
    var discriminant, q, r, dum1, s, t, term1, r13;
    q = (3.0 * c - b * b) / 9.0;
    r = -(27.0 * d) + b * (9.0 * c - 2.0 * (b * b));
    r /= 54.0;
    discriminant = q * q * q + r * r;
    result[1] = 0;
    term1 = b / 3.0;
    if (discriminant > 0) {
        s = r + Math.sqrt(discriminant);
        s = s < 0 ? -Math.pow(-s, 1.0 / 3.0) : Math.pow(s, 1.0 / 3.0);
        t = r - Math.sqrt(discriminant);
        t = t < 0 ? -Math.pow(-t, 1.0 / 3.0) : Math.pow(t, 1.0 / 3.0);
        result[0] = -term1 + s + t;
        term1 += (s + t) / 2.0;
        result[4] = result[2] = -term1;
        term1 = Math.sqrt(3.0) * (-t + s) / 2;
        result[3] = term1;
        result[5] = -term1;
        return;
    }
    result[5] = result[3] = 0;
    if (discriminant === 0) {
        r13 = r < 0 ? -Math.pow(-r, 1.0 / 3.0) : Math.pow(r, 1.0 / 3.0);
        result[0] = -term1 + 2.0 * r13;
        result[4] = result[2] = -(r13 + term1);
        return;
    }
    q = -q;
    dum1 = q * q * q;
    dum1 = Math.acos(r / Math.sqrt(dum1));
    r13 = 2.0 * Math.sqrt(q);
    result[0] = -term1 + r13 * Math.cos(dum1 / 3.0);
    result[2] = -term1 + r13 * Math.cos((dum1 + 2.0 * Math.PI) / 3.0);
    result[4] = -term1 + r13 * Math.cos((dum1 + 4.0 * Math.PI) / 3.0);
    return;
};
var $e815fda779bc047b$var$sqdistToQuadraticBezier = function sqdistToQuadraticBezier(x, y, x1, y1, x2, y2, x3, y3) {
    // Find minimum distance by using the minimum of the distance
    // function between the given point and the curve
    // This gives the coefficients of the resulting cubic equation
    // whose roots tell us where a possible minimum is
    // (Coefficients are divided by 4)
    var a = 1.0 * x1 * x1 - 4 * x1 * x2 + 2 * x1 * x3 + 4 * x2 * x2 - 4 * x2 * x3 + x3 * x3 + y1 * y1 - 4 * y1 * y2 + 2 * y1 * y3 + 4 * y2 * y2 - 4 * y2 * y3 + y3 * y3;
    var b = 9 * x1 * x2 - 3 * x1 * x1 - 3 * x1 * x3 - 6 * x2 * x2 + 3 * x2 * x3 + 9 * y1 * y2 - 3 * y1 * y1 - 3 * y1 * y3 - 6 * y2 * y2 + 3 * y2 * y3;
    var c = 3 * x1 * x1 - 6 * x1 * x2 + x1 * x3 - x1 * x + 2 * x2 * x2 + 2 * x2 * x - x3 * x + 3 * y1 * y1 - 6 * y1 * y2 + y1 * y3 - y1 * y + 2 * y2 * y2 + 2 * y2 * y - y3 * y;
    var d = 1.0 * x1 * x2 - x1 * x1 + x1 * x - x2 * x + y1 * y2 - y1 * y1 + y1 * y - y2 * y;
    // debug("coefficients: " + a / a + ", " + b / a + ", " + c / a + ", " + d / a);
    var roots = [];
    // Use the cubic solving algorithm
    $e815fda779bc047b$var$solveCubic(a, b, c, d, roots);
    var zeroThreshold = 0.0000001;
    var params = [];
    for(var index = 0; index < 6; index += 2)if (Math.abs(roots[index + 1]) < zeroThreshold && roots[index] >= 0 && roots[index] <= 1.0) params.push(roots[index]);
    params.push(1.0);
    params.push(0.0);
    var minDistanceSquared = -1;
    var curX, curY, distSquared;
    for(var i = 0; i < params.length; i++){
        curX = Math.pow(1.0 - params[i], 2.0) * x1 + 2.0 * (1 - params[i]) * params[i] * x2 + params[i] * params[i] * x3;
        curY = Math.pow(1 - params[i], 2.0) * y1 + 2 * (1.0 - params[i]) * params[i] * y2 + params[i] * params[i] * y3;
        distSquared = Math.pow(curX - x, 2) + Math.pow(curY - y, 2);
        // debug('distance for param ' + params[i] + ": " + Math.sqrt(distSquared));
        if (minDistanceSquared >= 0) {
            if (distSquared < minDistanceSquared) minDistanceSquared = distSquared;
        } else minDistanceSquared = distSquared;
    }
    return minDistanceSquared;
};
var $e815fda779bc047b$var$sqdistToFiniteLine = function sqdistToFiniteLine(x, y, x1, y1, x2, y2) {
    var offset = [
        x - x1,
        y - y1
    ];
    var line = [
        x2 - x1,
        y2 - y1
    ];
    var lineSq = line[0] * line[0] + line[1] * line[1];
    var hypSq = offset[0] * offset[0] + offset[1] * offset[1];
    var dotProduct = offset[0] * line[0] + offset[1] * line[1];
    var adjSq = dotProduct * dotProduct / lineSq;
    if (dotProduct < 0) return hypSq;
    if (adjSq > lineSq) return (x - x2) * (x - x2) + (y - y2) * (y - y2);
    return hypSq - adjSq;
};
var $e815fda779bc047b$var$pointInsidePolygonPoints = function pointInsidePolygonPoints(x, y, points) {
    var x1, y1, x2, y2;
    var y3;
    // Intersect with vertical line through (x, y)
    var up = 0;
    // let down = 0;
    for(var i = 0; i < points.length / 2; i++){
        x1 = points[i * 2];
        y1 = points[i * 2 + 1];
        if (i + 1 < points.length / 2) {
            x2 = points[(i + 1) * 2];
            y2 = points[(i + 1) * 2 + 1];
        } else {
            x2 = points[(i + 1 - points.length / 2) * 2];
            y2 = points[(i + 1 - points.length / 2) * 2 + 1];
        }
        if (x1 == x && x2 == x) ;
        else if (x1 >= x && x >= x2 || x1 <= x && x <= x2) {
            y3 = (x - x1) / (x2 - x1) * (y2 - y1) + y1;
            if (y3 > y) up++;
        // if( y3 < y ){
        // down++;
        // }
        } else continue;
    }
    if (up % 2 === 0) return false;
    else return true;
};
var $e815fda779bc047b$var$pointInsidePolygon = function pointInsidePolygon(x, y, basePoints, centerX, centerY, width, height, direction, padding) {
    var transformedPoints = new Array(basePoints.length);
    // Gives negative angle
    var angle;
    if (direction[0] != null) {
        angle = Math.atan(direction[1] / direction[0]);
        if (direction[0] < 0) angle = angle + Math.PI / 2;
        else angle = -angle - Math.PI / 2;
    } else angle = direction;
    var cos = Math.cos(-angle);
    var sin = Math.sin(-angle);
    //    console.log("base: " + basePoints);
    for(var i = 0; i < transformedPoints.length / 2; i++){
        transformedPoints[i * 2] = width / 2 * (basePoints[i * 2] * cos - basePoints[i * 2 + 1] * sin);
        transformedPoints[i * 2 + 1] = height / 2 * (basePoints[i * 2 + 1] * cos + basePoints[i * 2] * sin);
        transformedPoints[i * 2] += centerX;
        transformedPoints[i * 2 + 1] += centerY;
    }
    var points;
    if (padding > 0) {
        var expandedLineSet = $e815fda779bc047b$var$expandPolygon(transformedPoints, -padding);
        points = $e815fda779bc047b$var$joinLines(expandedLineSet);
    } else points = transformedPoints;
    return $e815fda779bc047b$var$pointInsidePolygonPoints(x, y, points);
};
var $e815fda779bc047b$var$pointInsideRoundPolygon = function pointInsideRoundPolygon(x, y, basePoints, centerX, centerY, width, height, corners) {
    var cutPolygonPoints = new Array(basePoints.length * 2);
    for(var i = 0; i < corners.length; i++){
        var corner = corners[i];
        cutPolygonPoints[i * 4 + 0] = corner.startX;
        cutPolygonPoints[i * 4 + 1] = corner.startY;
        cutPolygonPoints[i * 4 + 2] = corner.stopX;
        cutPolygonPoints[i * 4 + 3] = corner.stopY;
        var squaredDistance = Math.pow(corner.cx - x, 2) + Math.pow(corner.cy - y, 2);
        if (squaredDistance <= Math.pow(corner.radius, 2)) return true;
    }
    return $e815fda779bc047b$var$pointInsidePolygonPoints(x, y, cutPolygonPoints);
};
var $e815fda779bc047b$var$joinLines = function joinLines(lineSet) {
    var vertices = new Array(lineSet.length / 2);
    var currentLineStartX, currentLineStartY, currentLineEndX, currentLineEndY;
    var nextLineStartX, nextLineStartY, nextLineEndX, nextLineEndY;
    for(var i = 0; i < lineSet.length / 4; i++){
        currentLineStartX = lineSet[i * 4];
        currentLineStartY = lineSet[i * 4 + 1];
        currentLineEndX = lineSet[i * 4 + 2];
        currentLineEndY = lineSet[i * 4 + 3];
        if (i < lineSet.length / 4 - 1) {
            nextLineStartX = lineSet[(i + 1) * 4];
            nextLineStartY = lineSet[(i + 1) * 4 + 1];
            nextLineEndX = lineSet[(i + 1) * 4 + 2];
            nextLineEndY = lineSet[(i + 1) * 4 + 3];
        } else {
            nextLineStartX = lineSet[0];
            nextLineStartY = lineSet[1];
            nextLineEndX = lineSet[2];
            nextLineEndY = lineSet[3];
        }
        var intersection = $e815fda779bc047b$var$finiteLinesIntersect(currentLineStartX, currentLineStartY, currentLineEndX, currentLineEndY, nextLineStartX, nextLineStartY, nextLineEndX, nextLineEndY, true);
        vertices[i * 2] = intersection[0];
        vertices[i * 2 + 1] = intersection[1];
    }
    return vertices;
};
var $e815fda779bc047b$var$expandPolygon = function expandPolygon(points, pad) {
    var expandedLineSet = new Array(points.length * 2);
    var currentPointX, currentPointY, nextPointX, nextPointY;
    for(var i = 0; i < points.length / 2; i++){
        currentPointX = points[i * 2];
        currentPointY = points[i * 2 + 1];
        if (i < points.length / 2 - 1) {
            nextPointX = points[(i + 1) * 2];
            nextPointY = points[(i + 1) * 2 + 1];
        } else {
            nextPointX = points[0];
            nextPointY = points[1];
        }
        // Current line: [currentPointX, currentPointY] to [nextPointX, nextPointY]
        // Assume CCW polygon winding
        var offsetX = nextPointY - currentPointY;
        var offsetY = -(nextPointX - currentPointX);
        // Normalize
        var offsetLength = Math.sqrt(offsetX * offsetX + offsetY * offsetY);
        var normalizedOffsetX = offsetX / offsetLength;
        var normalizedOffsetY = offsetY / offsetLength;
        expandedLineSet[i * 4] = currentPointX + normalizedOffsetX * pad;
        expandedLineSet[i * 4 + 1] = currentPointY + normalizedOffsetY * pad;
        expandedLineSet[i * 4 + 2] = nextPointX + normalizedOffsetX * pad;
        expandedLineSet[i * 4 + 3] = nextPointY + normalizedOffsetY * pad;
    }
    return expandedLineSet;
};
var $e815fda779bc047b$var$intersectLineEllipse = function intersectLineEllipse(x, y, centerX, centerY, ellipseWradius, ellipseHradius) {
    var dispX = centerX - x;
    var dispY = centerY - y;
    dispX /= ellipseWradius;
    dispY /= ellipseHradius;
    var len = Math.sqrt(dispX * dispX + dispY * dispY);
    var newLength = len - 1;
    if (newLength < 0) return [];
    var lenProportion = newLength / len;
    return [
        (centerX - x) * lenProportion + x,
        (centerY - y) * lenProportion + y
    ];
};
var $e815fda779bc047b$var$checkInEllipse = function checkInEllipse(x, y, width, height, centerX, centerY, padding) {
    x -= centerX;
    y -= centerY;
    x /= width / 2 + padding;
    y /= height / 2 + padding;
    return x * x + y * y <= 1;
};
// Returns intersections of increasing distance from line's start point
var $e815fda779bc047b$var$intersectLineCircle = function intersectLineCircle(x1, y1, x2, y2, centerX, centerY, radius) {
    // Calculate d, direction vector of line
    var d = [
        x2 - x1,
        y2 - y1
    ]; // Direction vector of line
    var f = [
        x1 - centerX,
        y1 - centerY
    ];
    var a = d[0] * d[0] + d[1] * d[1];
    var b = 2 * (f[0] * d[0] + f[1] * d[1]);
    var c = f[0] * f[0] + f[1] * f[1] - radius * radius;
    var discriminant = b * b - 4 * a * c;
    if (discriminant < 0) return [];
    var t1 = (-b + Math.sqrt(discriminant)) / (2 * a);
    var t2 = (-b - Math.sqrt(discriminant)) / (2 * a);
    var tMin = Math.min(t1, t2);
    var tMax = Math.max(t1, t2);
    var inRangeParams = [];
    if (tMin >= 0 && tMin <= 1) inRangeParams.push(tMin);
    if (tMax >= 0 && tMax <= 1) inRangeParams.push(tMax);
    if (inRangeParams.length === 0) return [];
    var nearIntersectionX = inRangeParams[0] * d[0] + x1;
    var nearIntersectionY = inRangeParams[0] * d[1] + y1;
    if (inRangeParams.length > 1) {
        if (inRangeParams[0] == inRangeParams[1]) return [
            nearIntersectionX,
            nearIntersectionY
        ];
        else {
            var farIntersectionX = inRangeParams[1] * d[0] + x1;
            var farIntersectionY = inRangeParams[1] * d[1] + y1;
            return [
                nearIntersectionX,
                nearIntersectionY,
                farIntersectionX,
                farIntersectionY
            ];
        }
    } else return [
        nearIntersectionX,
        nearIntersectionY
    ];
};
var $e815fda779bc047b$var$midOfThree = function midOfThree(a, b, c) {
    if (b <= a && a <= c || c <= a && a <= b) return a;
    else if (a <= b && b <= c || c <= b && b <= a) return b;
    else return c;
};
// (x1,y1)=>(x2,y2) intersect with (x3,y3)=>(x4,y4)
var $e815fda779bc047b$var$finiteLinesIntersect = function finiteLinesIntersect(x1, y1, x2, y2, x3, y3, x4, y4, infiniteLines) {
    var dx13 = x1 - x3;
    var dx21 = x2 - x1;
    var dx43 = x4 - x3;
    var dy13 = y1 - y3;
    var dy21 = y2 - y1;
    var dy43 = y4 - y3;
    var ua_t = dx43 * dy13 - dy43 * dx13;
    var ub_t = dx21 * dy13 - dy21 * dx13;
    var u_b = dy43 * dx21 - dx43 * dy21;
    if (u_b !== 0) {
        var ua = ua_t / u_b;
        var ub = ub_t / u_b;
        var flptThreshold = 0.001;
        var _min = 0 - flptThreshold;
        var _max = 1 + flptThreshold;
        if (_min <= ua && ua <= _max && _min <= ub && ub <= _max) return [
            x1 + ua * dx21,
            y1 + ua * dy21
        ];
        else {
            if (!infiniteLines) return [];
            else return [
                x1 + ua * dx21,
                y1 + ua * dy21
            ];
        }
    } else {
        if (ua_t === 0 || ub_t === 0) {
            // Parallel, coincident lines. Check if overlap
            // Check endpoint of second line
            if ($e815fda779bc047b$var$midOfThree(x1, x2, x4) === x4) return [
                x4,
                y4
            ];
            // Check start point of second line
            if ($e815fda779bc047b$var$midOfThree(x1, x2, x3) === x3) return [
                x3,
                y3
            ];
            // Endpoint of first line
            if ($e815fda779bc047b$var$midOfThree(x3, x4, x2) === x2) return [
                x2,
                y2
            ];
            return [];
        } else // Parallel, non-coincident
        return [];
    }
};
var $e815fda779bc047b$var$transformPoints = function transformPoints(points, centerX, centerY, width, height) {
    var ret = [];
    var halfW = width / 2;
    var halfH = height / 2;
    var x = centerX;
    var y = centerY;
    ret.push({
        x: x + halfW * points[0],
        y: y + halfH * points[1]
    });
    for(var i = 1; i < points.length / 2; i++)ret.push({
        x: x + halfW * points[i * 2],
        y: y + halfH * points[i * 2 + 1]
    });
    return ret;
};
// math.polygonIntersectLine( x, y, basePoints, centerX, centerY, width, height, padding )
// intersect a node polygon (pts transformed)
//
// math.polygonIntersectLine( x, y, basePoints, centerX, centerY )
// intersect the points (no transform)
var $e815fda779bc047b$var$polygonIntersectLine = function polygonIntersectLine(x, y, basePoints, centerX, centerY, width, height, padding) {
    var intersections = [];
    var intersection;
    var transformedPoints = new Array(basePoints.length);
    var doTransform = true;
    if (width == null) doTransform = false;
    var points;
    if (doTransform) {
        for(var i = 0; i < transformedPoints.length / 2; i++){
            transformedPoints[i * 2] = basePoints[i * 2] * width + centerX;
            transformedPoints[i * 2 + 1] = basePoints[i * 2 + 1] * height + centerY;
        }
        if (padding > 0) {
            var expandedLineSet = $e815fda779bc047b$var$expandPolygon(transformedPoints, -padding);
            points = $e815fda779bc047b$var$joinLines(expandedLineSet);
        } else points = transformedPoints;
    } else points = basePoints;
    var currentX, currentY, nextX, nextY;
    for(var _i3 = 0; _i3 < points.length / 2; _i3++){
        currentX = points[_i3 * 2];
        currentY = points[_i3 * 2 + 1];
        if (_i3 < points.length / 2 - 1) {
            nextX = points[(_i3 + 1) * 2];
            nextY = points[(_i3 + 1) * 2 + 1];
        } else {
            nextX = points[0];
            nextY = points[1];
        }
        intersection = $e815fda779bc047b$var$finiteLinesIntersect(x, y, centerX, centerY, currentX, currentY, nextX, nextY);
        if (intersection.length !== 0) intersections.push(intersection[0], intersection[1]);
    }
    return intersections;
};
var $e815fda779bc047b$var$roundPolygonIntersectLine = function roundPolygonIntersectLine(x, y, basePoints, centerX, centerY, width, height, padding, corners) {
    var intersections = [];
    var intersection;
    var lines = new Array(basePoints.length * 2);
    corners.forEach(function(corner, i) {
        if (i === 0) {
            lines[lines.length - 2] = corner.startX;
            lines[lines.length - 1] = corner.startY;
        } else {
            lines[i * 4 - 2] = corner.startX;
            lines[i * 4 - 1] = corner.startY;
        }
        lines[i * 4] = corner.stopX;
        lines[i * 4 + 1] = corner.stopY;
        intersection = $e815fda779bc047b$var$intersectLineCircle(x, y, centerX, centerY, corner.cx, corner.cy, corner.radius);
        if (intersection.length !== 0) intersections.push(intersection[0], intersection[1]);
    });
    for(var i = 0; i < lines.length / 4; i++){
        intersection = $e815fda779bc047b$var$finiteLinesIntersect(x, y, centerX, centerY, lines[i * 4], lines[i * 4 + 1], lines[i * 4 + 2], lines[i * 4 + 3], false);
        if (intersection.length !== 0) intersections.push(intersection[0], intersection[1]);
    }
    if (intersections.length > 2) {
        var lowestIntersection = [
            intersections[0],
            intersections[1]
        ];
        var lowestSquaredDistance = Math.pow(lowestIntersection[0] - x, 2) + Math.pow(lowestIntersection[1] - y, 2);
        for(var _i4 = 1; _i4 < intersections.length / 2; _i4++){
            var squaredDistance = Math.pow(intersections[_i4 * 2] - x, 2) + Math.pow(intersections[_i4 * 2 + 1] - y, 2);
            if (squaredDistance <= lowestSquaredDistance) {
                lowestIntersection[0] = intersections[_i4 * 2];
                lowestIntersection[1] = intersections[_i4 * 2 + 1];
                lowestSquaredDistance = squaredDistance;
            }
        }
        return lowestIntersection;
    }
    return intersections;
};
var $e815fda779bc047b$var$shortenIntersection = function shortenIntersection(intersection, offset, amount) {
    var disp = [
        intersection[0] - offset[0],
        intersection[1] - offset[1]
    ];
    var length = Math.sqrt(disp[0] * disp[0] + disp[1] * disp[1]);
    var lenRatio = (length - amount) / length;
    if (lenRatio < 0) lenRatio = 0.00001;
    return [
        offset[0] + lenRatio * disp[0],
        offset[1] + lenRatio * disp[1]
    ];
};
var $e815fda779bc047b$var$generateUnitNgonPointsFitToSquare = function generateUnitNgonPointsFitToSquare(sides, rotationRadians) {
    var points = $e815fda779bc047b$var$generateUnitNgonPoints(sides, rotationRadians);
    points = $e815fda779bc047b$var$fitPolygonToSquare(points);
    return points;
};
var $e815fda779bc047b$var$fitPolygonToSquare = function fitPolygonToSquare(points) {
    var x, y;
    var sides = points.length / 2;
    var minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
    for(var i = 0; i < sides; i++){
        x = points[2 * i];
        y = points[2 * i + 1];
        minX = Math.min(minX, x);
        maxX = Math.max(maxX, x);
        minY = Math.min(minY, y);
        maxY = Math.max(maxY, y);
    }
    // stretch factors
    var sx = 2 / (maxX - minX);
    var sy = 2 / (maxY - minY);
    for(var _i5 = 0; _i5 < sides; _i5++){
        x = points[2 * _i5] = points[2 * _i5] * sx;
        y = points[2 * _i5 + 1] = points[2 * _i5 + 1] * sy;
        minX = Math.min(minX, x);
        maxX = Math.max(maxX, x);
        minY = Math.min(minY, y);
        maxY = Math.max(maxY, y);
    }
    if (minY < -1) for(var _i6 = 0; _i6 < sides; _i6++)y = points[2 * _i6 + 1] = points[2 * _i6 + 1] + (-1 - minY);
    return points;
};
var $e815fda779bc047b$var$generateUnitNgonPoints = function generateUnitNgonPoints(sides, rotationRadians) {
    var increment = 1.0 / sides * 2 * Math.PI;
    var startAngle = sides % 2 === 0 ? Math.PI / 2.0 + increment / 2.0 : Math.PI / 2.0;
    startAngle += rotationRadians;
    var points = new Array(sides * 2);
    var currentAngle;
    for(var i = 0; i < sides; i++){
        currentAngle = i * increment + startAngle;
        points[2 * i] = Math.cos(currentAngle); // x
        points[2 * i + 1] = Math.sin(-currentAngle); // y
    }
    return points;
};
// Set the default radius, unless half of width or height is smaller than default
var $e815fda779bc047b$var$getRoundRectangleRadius = function getRoundRectangleRadius(width, height) {
    return Math.min(width / 4, height / 4, 8);
};
// Set the default radius
var $e815fda779bc047b$var$getRoundPolygonRadius = function getRoundPolygonRadius(width, height) {
    return Math.min(width / 10, height / 10, 8);
};
var $e815fda779bc047b$var$getCutRectangleCornerLength = function getCutRectangleCornerLength() {
    return 8;
};
var $e815fda779bc047b$var$bezierPtsToQuadCoeff = function bezierPtsToQuadCoeff(p0, p1, p2) {
    return [
        p0 - 2 * p1 + p2,
        2 * (p1 - p0),
        p0
    ];
};
// get curve width, height, and control point position offsets as a percentage of node height / width
var $e815fda779bc047b$var$getBarrelCurveConstants = function getBarrelCurveConstants(width, height) {
    return {
        heightOffset: Math.min(15, 0.05 * height),
        widthOffset: Math.min(100, 0.25 * width),
        ctrlPtOffsetPct: 0.05
    };
};
// Separating Axis Theorem (SAT) to determine if two polygons intersect. 
// The function takes two polygons as input and returns a boolean value indicating 
// whether the two polygons intersect.
function $e815fda779bc047b$var$satPolygonIntersection(poly1, poly2) {
    function getAxes(polygon) {
        var axes = [];
        for(var i = 0; i < polygon.length; i++){
            var p1 = polygon[i];
            var p2 = polygon[(i + 1) % polygon.length];
            var edge = {
                x: p2.x - p1.x,
                y: p2.y - p1.y
            };
            var normal = {
                x: -edge.y,
                y: edge.x
            };
            var length = Math.sqrt(normal.x * normal.x + normal.y * normal.y);
            axes.push({
                x: normal.x / length,
                y: normal.y / length
            });
        }
        return axes;
    }
    function project(polygon, axis) {
        var min = Infinity;
        var max = -Infinity;
        var _iterator = $e815fda779bc047b$var$_createForOfIteratorHelper(polygon), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var point = _step.value;
                var projection = point.x * axis.x + point.y * axis.y;
                min = Math.min(min, projection);
                max = Math.max(max, projection);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            min: min,
            max: max
        };
    }
    function overlaps(proj1, proj2) {
        return !(proj1.max < proj2.min || proj2.max < proj1.min);
    }
    var axes = [].concat($e815fda779bc047b$var$_toConsumableArray(getAxes(poly1)), $e815fda779bc047b$var$_toConsumableArray(getAxes(poly2)));
    var _iterator2 = $e815fda779bc047b$var$_createForOfIteratorHelper(axes), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var axis = _step2.value;
            var proj1 = project(poly1, axis);
            var proj2 = project(poly2, axis);
            if (!overlaps(proj1, proj2)) return false; // No overlap, so the polygons do not intersect
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return true; // polygons intersect
}
var $e815fda779bc047b$var$pageRankDefaults = $e815fda779bc047b$var$defaults$g({
    dampingFactor: 0.8,
    precision: 0.000001,
    iterations: 200,
    weight: function weight(edge) {
        return 1;
    }
});
var $e815fda779bc047b$var$elesfn$o = {
    pageRank: function pageRank(options) {
        var _pageRankDefaults = $e815fda779bc047b$var$pageRankDefaults(options), dampingFactor = _pageRankDefaults.dampingFactor, precision = _pageRankDefaults.precision, iterations = _pageRankDefaults.iterations, weight = _pageRankDefaults.weight;
        var cy = this._private.cy;
        var _this$byGroup = this.byGroup(), nodes = _this$byGroup.nodes, edges = _this$byGroup.edges;
        var numNodes = nodes.length;
        var numNodesSqd = numNodes * numNodes;
        var numEdges = edges.length;
        // Construct transposed adjacency matrix
        // First lets have a zeroed matrix of the right size
        // We'll also keep track of the sum of each column
        var matrix = new Array(numNodesSqd);
        var columnSum = new Array(numNodes);
        var additionalProb = (1 - dampingFactor) / numNodes;
        // Create null matrix
        for(var i = 0; i < numNodes; i++){
            for(var j = 0; j < numNodes; j++){
                var n = i * numNodes + j;
                matrix[n] = 0;
            }
            columnSum[i] = 0;
        }
        // Now, process edges
        for(var _i = 0; _i < numEdges; _i++){
            var edge = edges[_i];
            var srcId = edge.data('source');
            var tgtId = edge.data('target');
            // Don't include loops in the matrix
            if (srcId === tgtId) continue;
            var s = nodes.indexOfId(srcId);
            var t = nodes.indexOfId(tgtId);
            var w = weight(edge);
            var _n = t * numNodes + s;
            // Update matrix
            matrix[_n] += w;
            // Update column sum
            columnSum[s] += w;
        }
        // Add additional probability based on damping factor
        // Also, take into account columns that have sum = 0
        var p = 1.0 / numNodes + additionalProb; // Shorthand
        // Traverse matrix, column by column
        for(var _j = 0; _j < numNodes; _j++){
            if (columnSum[_j] === 0) // No 'links' out from node jth, assume equal probability for each possible node
            for(var _i2 = 0; _i2 < numNodes; _i2++){
                var _n2 = _i2 * numNodes + _j;
                matrix[_n2] = p;
            }
            else // Node jth has outgoing link, compute normalized probabilities
            for(var _i3 = 0; _i3 < numNodes; _i3++){
                var _n3 = _i3 * numNodes + _j;
                matrix[_n3] = matrix[_n3] / columnSum[_j] + additionalProb;
            }
        }
        // Compute dominant eigenvector using power method
        var eigenvector = new Array(numNodes);
        var temp = new Array(numNodes);
        var previous;
        // Start with a vector of all 1's
        // Also, initialize a null vector which will be used as shorthand
        for(var _i4 = 0; _i4 < numNodes; _i4++)eigenvector[_i4] = 1;
        for(var iter = 0; iter < iterations; iter++){
            // Temp array with all 0's
            for(var _i5 = 0; _i5 < numNodes; _i5++)temp[_i5] = 0;
            // Multiply matrix with previous result
            for(var _i6 = 0; _i6 < numNodes; _i6++)for(var _j2 = 0; _j2 < numNodes; _j2++){
                var _n4 = _i6 * numNodes + _j2;
                temp[_i6] += matrix[_n4] * eigenvector[_j2];
            }
            $e815fda779bc047b$var$inPlaceSumNormalize(temp);
            previous = eigenvector;
            eigenvector = temp;
            temp = previous;
            var diff = 0;
            // Compute difference (squared module) of both vectors
            for(var _i7 = 0; _i7 < numNodes; _i7++){
                var delta = previous[_i7] - eigenvector[_i7];
                diff += delta * delta;
            }
            // If difference is less than the desired threshold, stop iterating
            if (diff < precision) break;
        }
        // Construct result
        var res = {
            rank: function rank(node) {
                node = cy.collection(node)[0];
                return eigenvector[nodes.indexOf(node)];
            }
        };
        return res;
    } // pageRank
}; // elesfn
var $e815fda779bc047b$var$defaults$f = $e815fda779bc047b$var$defaults$g({
    root: null,
    weight: function weight(edge) {
        return 1;
    },
    directed: false,
    alpha: 0
});
var $e815fda779bc047b$var$elesfn$n = {
    degreeCentralityNormalized: function degreeCentralityNormalized(options) {
        options = $e815fda779bc047b$var$defaults$f(options);
        var cy = this.cy();
        var nodes = this.nodes();
        var numNodes = nodes.length;
        if (!options.directed) {
            var degrees = {};
            var maxDegree = 0;
            for(var i = 0; i < numNodes; i++){
                var node = nodes[i];
                // add current node to the current options object and call degreeCentrality
                options.root = node;
                var currDegree = this.degreeCentrality(options);
                if (maxDegree < currDegree.degree) maxDegree = currDegree.degree;
                degrees[node.id()] = currDegree.degree;
            }
            return {
                degree: function degree(node) {
                    if (maxDegree === 0) return 0;
                    if ($e815fda779bc047b$var$string(node)) // from is a selector string
                    node = cy.filter(node);
                    return degrees[node.id()] / maxDegree;
                }
            };
        } else {
            var indegrees = {};
            var outdegrees = {};
            var maxIndegree = 0;
            var maxOutdegree = 0;
            for(var _i = 0; _i < numNodes; _i++){
                var _node = nodes[_i];
                var id = _node.id();
                // add current node to the current options object and call degreeCentrality
                options.root = _node;
                var _currDegree = this.degreeCentrality(options);
                if (maxIndegree < _currDegree.indegree) maxIndegree = _currDegree.indegree;
                if (maxOutdegree < _currDegree.outdegree) maxOutdegree = _currDegree.outdegree;
                indegrees[id] = _currDegree.indegree;
                outdegrees[id] = _currDegree.outdegree;
            }
            return {
                indegree: function indegree(node) {
                    if (maxIndegree == 0) return 0;
                    if ($e815fda779bc047b$var$string(node)) // from is a selector string
                    node = cy.filter(node);
                    return indegrees[node.id()] / maxIndegree;
                },
                outdegree: function outdegree(node) {
                    if (maxOutdegree === 0) return 0;
                    if ($e815fda779bc047b$var$string(node)) // from is a selector string
                    node = cy.filter(node);
                    return outdegrees[node.id()] / maxOutdegree;
                }
            };
        }
    },
    // degreeCentralityNormalized
    // Implemented from the algorithm in Opsahl's paper
    // "Node centrality in weighted networks: Generalizing degree and shortest paths"
    // check the heading 2 "Degree"
    degreeCentrality: function degreeCentrality(options) {
        options = $e815fda779bc047b$var$defaults$f(options);
        var cy = this.cy();
        var callingEles = this;
        var _options = options, root = _options.root, weight = _options.weight, directed = _options.directed, alpha = _options.alpha;
        root = cy.collection(root)[0];
        if (!directed) {
            var connEdges = root.connectedEdges().intersection(callingEles);
            var k = connEdges.length;
            var s = 0;
            // Now, sum edge weights
            for(var i = 0; i < connEdges.length; i++)s += weight(connEdges[i]);
            return {
                degree: Math.pow(k, 1 - alpha) * Math.pow(s, alpha)
            };
        } else {
            var edges = root.connectedEdges();
            var incoming = edges.filter(function(edge) {
                return edge.target().same(root) && callingEles.has(edge);
            });
            var outgoing = edges.filter(function(edge) {
                return edge.source().same(root) && callingEles.has(edge);
            });
            var k_in = incoming.length;
            var k_out = outgoing.length;
            var s_in = 0;
            var s_out = 0;
            // Now, sum incoming edge weights
            for(var _i2 = 0; _i2 < incoming.length; _i2++)s_in += weight(incoming[_i2]);
            // Now, sum outgoing edge weights
            for(var _i3 = 0; _i3 < outgoing.length; _i3++)s_out += weight(outgoing[_i3]);
            return {
                indegree: Math.pow(k_in, 1 - alpha) * Math.pow(s_in, alpha),
                outdegree: Math.pow(k_out, 1 - alpha) * Math.pow(s_out, alpha)
            };
        }
    } // degreeCentrality
}; // elesfn
// nice, short mathematical alias
$e815fda779bc047b$var$elesfn$n.dc = $e815fda779bc047b$var$elesfn$n.degreeCentrality;
$e815fda779bc047b$var$elesfn$n.dcn = $e815fda779bc047b$var$elesfn$n.degreeCentralityNormalised = $e815fda779bc047b$var$elesfn$n.degreeCentralityNormalized;
var $e815fda779bc047b$var$defaults$e = $e815fda779bc047b$var$defaults$g({
    harmonic: true,
    weight: function weight() {
        return 1;
    },
    directed: false,
    root: null
});
var $e815fda779bc047b$var$elesfn$m = {
    closenessCentralityNormalized: function closenessCentralityNormalized(options) {
        var _defaults = $e815fda779bc047b$var$defaults$e(options), harmonic = _defaults.harmonic, weight = _defaults.weight, directed = _defaults.directed;
        var cy = this.cy();
        var closenesses = {};
        var maxCloseness = 0;
        var nodes = this.nodes();
        var fw = this.floydWarshall({
            weight: weight,
            directed: directed
        });
        // Compute closeness for every node and find the maximum closeness
        for(var i = 0; i < nodes.length; i++){
            var currCloseness = 0;
            var node_i = nodes[i];
            for(var j = 0; j < nodes.length; j++)if (i !== j) {
                var d = fw.distance(node_i, nodes[j]);
                if (harmonic) currCloseness += 1 / d;
                else currCloseness += d;
            }
            if (!harmonic) currCloseness = 1 / currCloseness;
            if (maxCloseness < currCloseness) maxCloseness = currCloseness;
            closenesses[node_i.id()] = currCloseness;
        }
        return {
            closeness: function closeness(node) {
                if (maxCloseness == 0) return 0;
                if ($e815fda779bc047b$var$string(node)) // from is a selector string
                node = cy.filter(node)[0].id();
                else // from is a node
                node = node.id();
                return closenesses[node] / maxCloseness;
            }
        };
    },
    // Implemented from pseudocode from wikipedia
    closenessCentrality: function closenessCentrality(options) {
        var _defaults2 = $e815fda779bc047b$var$defaults$e(options), root = _defaults2.root, weight = _defaults2.weight, directed = _defaults2.directed, harmonic = _defaults2.harmonic;
        root = this.filter(root)[0];
        // we need distance from this node to every other node
        var dijkstra = this.dijkstra({
            root: root,
            weight: weight,
            directed: directed
        });
        var totalDistance = 0;
        var nodes = this.nodes();
        for(var i = 0; i < nodes.length; i++){
            var n = nodes[i];
            if (!n.same(root)) {
                var d = dijkstra.distanceTo(n);
                if (harmonic) totalDistance += 1 / d;
                else totalDistance += d;
            }
        }
        return harmonic ? totalDistance : 1 / totalDistance;
    } // closenessCentrality
}; // elesfn
// nice, short mathematical alias
$e815fda779bc047b$var$elesfn$m.cc = $e815fda779bc047b$var$elesfn$m.closenessCentrality;
$e815fda779bc047b$var$elesfn$m.ccn = $e815fda779bc047b$var$elesfn$m.closenessCentralityNormalised = $e815fda779bc047b$var$elesfn$m.closenessCentralityNormalized;
var $e815fda779bc047b$var$defaults$d = $e815fda779bc047b$var$defaults$g({
    weight: null,
    directed: false
});
var $e815fda779bc047b$var$elesfn$l = {
    // Implemented from the algorithm in the paper "On Variants of Shortest-Path Betweenness Centrality and their Generic Computation" by Ulrik Brandes
    betweennessCentrality: function betweennessCentrality(options) {
        var _defaults = $e815fda779bc047b$var$defaults$d(options), directed = _defaults.directed, weight = _defaults.weight;
        var weighted = weight != null;
        var cy = this.cy();
        // starting
        var V = this.nodes();
        var A = {};
        var _C = {};
        var max = 0;
        var C = {
            set: function set(key, val) {
                _C[key] = val;
                if (val > max) max = val;
            },
            get: function get(key) {
                return _C[key];
            }
        };
        // A contains the neighborhoods of every node
        for(var i = 0; i < V.length; i++){
            var v = V[i];
            var vid = v.id();
            if (directed) A[vid] = v.outgoers().nodes(); // get outgoers of every node
            else A[vid] = v.openNeighborhood().nodes(); // get neighbors of every node
            C.set(vid, 0);
        }
        var _loop = function _loop() {
            var sid = V[s].id();
            var S = []; // stack
            var P = {};
            var g = {};
            var d = {};
            var Q = new $e815fda779bc047b$var$Heap(function(a, b) {
                return d[a] - d[b];
            }); // queue
            // init dictionaries
            for(var _i = 0; _i < V.length; _i++){
                var _vid = V[_i].id();
                P[_vid] = [];
                g[_vid] = 0;
                d[_vid] = Infinity;
            }
            g[sid] = 1; // sigma
            d[sid] = 0; // distance to s
            Q.push(sid);
            while(!Q.empty()){
                var _v = Q.pop();
                S.push(_v);
                if (weighted) for(var j = 0; j < A[_v].length; j++){
                    var w = A[_v][j];
                    var vEle = cy.getElementById(_v);
                    var edge = undefined;
                    if (vEle.edgesTo(w).length > 0) edge = vEle.edgesTo(w)[0];
                    else edge = w.edgesTo(vEle)[0];
                    var edgeWeight = weight(edge);
                    w = w.id();
                    if (d[w] > d[_v] + edgeWeight) {
                        d[w] = d[_v] + edgeWeight;
                        if (Q.nodes.indexOf(w) < 0) //if w is not in Q
                        Q.push(w);
                        else // update position if w is in Q
                        Q.updateItem(w);
                        g[w] = 0;
                        P[w] = [];
                    }
                    if (d[w] == d[_v] + edgeWeight) {
                        g[w] = g[w] + g[_v];
                        P[w].push(_v);
                    }
                }
                else for(var _j = 0; _j < A[_v].length; _j++){
                    var _w = A[_v][_j].id();
                    if (d[_w] == Infinity) {
                        Q.push(_w);
                        d[_w] = d[_v] + 1;
                    }
                    if (d[_w] == d[_v] + 1) {
                        g[_w] = g[_w] + g[_v];
                        P[_w].push(_v);
                    }
                }
            }
            var e = {};
            for(var _i2 = 0; _i2 < V.length; _i2++)e[V[_i2].id()] = 0;
            while(S.length > 0){
                var _w2 = S.pop();
                for(var _j2 = 0; _j2 < P[_w2].length; _j2++){
                    var _v2 = P[_w2][_j2];
                    e[_v2] = e[_v2] + g[_v2] / g[_w2] * (1 + e[_w2]);
                }
                if (_w2 != V[s].id()) C.set(_w2, C.get(_w2) + e[_w2]);
            }
        };
        for(var s = 0; s < V.length; s++)_loop();
        var ret = {
            betweenness: function betweenness(node) {
                var id = cy.collection(node).id();
                return C.get(id);
            },
            betweennessNormalized: function betweennessNormalized(node) {
                if (max == 0) return 0;
                var id = cy.collection(node).id();
                return C.get(id) / max;
            }
        };
        // alias
        ret.betweennessNormalised = ret.betweennessNormalized;
        return ret;
    } // betweennessCentrality
}; // elesfn
// nice, short mathematical alias
$e815fda779bc047b$var$elesfn$l.bc = $e815fda779bc047b$var$elesfn$l.betweennessCentrality;
// Implemented by Zoe Xi @zoexi for GSOC 2016
// https://github.com/cytoscape/cytoscape.js-markov-cluster
/* eslint-disable no-unused-vars */ var $e815fda779bc047b$var$defaults$c = $e815fda779bc047b$var$defaults$g({
    expandFactor: 2,
    // affects time of computation and cluster granularity to some extent: M * M
    inflateFactor: 2,
    // affects cluster granularity (the greater the value, the more clusters): M(i,j) / E(j)
    multFactor: 1,
    // optional self loops for each node. Use a neutral value to improve cluster computations.
    maxIterations: 20,
    // maximum number of iterations of the MCL algorithm in a single run
    attributes: [
        // attributes/features used to group nodes, ie. similarity values between nodes
        function(edge) {
            return 1;
        }
    ]
});
/* eslint-enable */ var $e815fda779bc047b$var$setOptions$3 = function setOptions(options) {
    return $e815fda779bc047b$var$defaults$c(options);
};
/* eslint-enable */ var $e815fda779bc047b$var$getSimilarity$1 = function getSimilarity(edge, attributes) {
    var total = 0;
    for(var i = 0; i < attributes.length; i++)total += attributes[i](edge);
    return total;
};
var $e815fda779bc047b$var$addLoops = function addLoops(M, n, val) {
    for(var i = 0; i < n; i++)M[i * n + i] = val;
};
var $e815fda779bc047b$var$normalize = function normalize(M, n) {
    var sum;
    for(var col = 0; col < n; col++){
        sum = 0;
        for(var row = 0; row < n; row++)sum += M[row * n + col];
        for(var _row = 0; _row < n; _row++)M[_row * n + col] = M[_row * n + col] / sum;
    }
};
// TODO: blocked matrix multiplication?
var $e815fda779bc047b$var$mmult = function mmult(A, B, n) {
    var C = new Array(n * n);
    for(var i = 0; i < n; i++){
        for(var j = 0; j < n; j++)C[i * n + j] = 0;
        for(var k = 0; k < n; k++)for(var _j = 0; _j < n; _j++)C[i * n + _j] += A[i * n + k] * B[k * n + _j];
    }
    return C;
};
var $e815fda779bc047b$var$expand = function expand(M, n, expandFactor /** power **/ ) {
    var _M = M.slice(0);
    for(var p = 1; p < expandFactor; p++)M = $e815fda779bc047b$var$mmult(M, _M, n);
    return M;
};
var $e815fda779bc047b$var$inflate = function inflate(M, n, inflateFactor /** r **/ ) {
    var _M = new Array(n * n);
    // M(i,j) ^ inflatePower
    for(var i = 0; i < n * n; i++)_M[i] = Math.pow(M[i], inflateFactor);
    $e815fda779bc047b$var$normalize(_M, n);
    return _M;
};
var $e815fda779bc047b$var$hasConverged = function hasConverged(M, _M, n2, roundFactor) {
    // Check that both matrices have the same elements (i,j)
    for(var i = 0; i < n2; i++){
        var v1 = Math.round(M[i] * Math.pow(10, roundFactor)) / Math.pow(10, roundFactor); // truncate to 'roundFactor' decimal places
        var v2 = Math.round(_M[i] * Math.pow(10, roundFactor)) / Math.pow(10, roundFactor);
        if (v1 !== v2) return false;
    }
    return true;
};
var $e815fda779bc047b$var$assign$2 = function assign(M, n, nodes, cy) {
    var clusters = [];
    for(var i = 0; i < n; i++){
        var cluster = [];
        for(var j = 0; j < n; j++)// Row-wise attractors and elements that they attract belong in same cluster
        if (Math.round(M[i * n + j] * 1000) / 1000 > 0) cluster.push(nodes[j]);
        if (cluster.length !== 0) clusters.push(cy.collection(cluster));
    }
    return clusters;
};
var $e815fda779bc047b$var$isDuplicate = function isDuplicate(c1, c2) {
    for(var i = 0; i < c1.length; i++){
        if (!c2[i] || c1[i].id() !== c2[i].id()) return false;
    }
    return true;
};
var $e815fda779bc047b$var$removeDuplicates = function removeDuplicates(clusters) {
    for(var i = 0; i < clusters.length; i++){
        for(var j = 0; j < clusters.length; j++)if (i != j && $e815fda779bc047b$var$isDuplicate(clusters[i], clusters[j])) clusters.splice(j, 1);
    }
    return clusters;
};
var $e815fda779bc047b$var$markovClustering = function markovClustering(options) {
    var nodes = this.nodes();
    var edges = this.edges();
    var cy = this.cy();
    // Set parameters of algorithm:
    var opts = $e815fda779bc047b$var$setOptions$3(options);
    // Map each node to its position in node array
    var id2position = {};
    for(var i = 0; i < nodes.length; i++)id2position[nodes[i].id()] = i;
    // Generate stochastic matrix M from input graph G (should be symmetric/undirected)
    var n = nodes.length, n2 = n * n;
    var M = new Array(n2), _M;
    for(var _i = 0; _i < n2; _i++)M[_i] = 0;
    for(var e = 0; e < edges.length; e++){
        var edge = edges[e];
        var _i2 = id2position[edge.source().id()];
        var j = id2position[edge.target().id()];
        var sim = $e815fda779bc047b$var$getSimilarity$1(edge, opts.attributes);
        M[_i2 * n + j] += sim; // G should be symmetric and undirected
        M[j * n + _i2] += sim;
    }
    // Begin Markov cluster algorithm
    // Step 1: Add self loops to each node, ie. add multFactor to matrix diagonal
    $e815fda779bc047b$var$addLoops(M, n, opts.multFactor);
    // Step 2: M = normalize( M );
    $e815fda779bc047b$var$normalize(M, n);
    var isStillMoving = true;
    var iterations = 0;
    while(isStillMoving && iterations < opts.maxIterations){
        isStillMoving = false;
        // Step 3:
        _M = $e815fda779bc047b$var$expand(M, n, opts.expandFactor);
        // Step 4:
        M = $e815fda779bc047b$var$inflate(_M, n, opts.inflateFactor);
        // Step 5: check to see if ~steady state has been reached
        if (!$e815fda779bc047b$var$hasConverged(M, _M, n2, 4)) isStillMoving = true;
        iterations++;
    }
    // Build clusters from matrix
    var clusters = $e815fda779bc047b$var$assign$2(M, n, nodes, cy);
    // Remove duplicate clusters due to symmetry of graph and M matrix
    clusters = $e815fda779bc047b$var$removeDuplicates(clusters);
    return clusters;
};
var $e815fda779bc047b$var$markovClustering$1 = {
    markovClustering: $e815fda779bc047b$var$markovClustering,
    mcl: $e815fda779bc047b$var$markovClustering
};
// Common distance metrics for clustering algorithms
// https://en.wikipedia.org/wiki/Hierarchical_clustering#Metric
var $e815fda779bc047b$var$identity$1 = function identity(x) {
    return x;
};
var $e815fda779bc047b$var$absDiff = function absDiff(p, q) {
    return Math.abs(q - p);
};
var $e815fda779bc047b$var$addAbsDiff = function addAbsDiff(total, p, q) {
    return total + $e815fda779bc047b$var$absDiff(p, q);
};
var $e815fda779bc047b$var$addSquaredDiff = function addSquaredDiff(total, p, q) {
    return total + Math.pow(q - p, 2);
};
var $e815fda779bc047b$var$sqrt = function sqrt(x) {
    return Math.sqrt(x);
};
var $e815fda779bc047b$var$maxAbsDiff = function maxAbsDiff(currentMax, p, q) {
    return Math.max(currentMax, $e815fda779bc047b$var$absDiff(p, q));
};
var $e815fda779bc047b$var$getDistance = function getDistance(length, getP, getQ, init, visit) {
    var post = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : $e815fda779bc047b$var$identity$1;
    var ret = init;
    var p, q;
    for(var dim = 0; dim < length; dim++){
        p = getP(dim);
        q = getQ(dim);
        ret = visit(ret, p, q);
    }
    return post(ret);
};
var $e815fda779bc047b$var$distances = {
    euclidean: function euclidean(length, getP, getQ) {
        if (length >= 2) return $e815fda779bc047b$var$getDistance(length, getP, getQ, 0, $e815fda779bc047b$var$addSquaredDiff, $e815fda779bc047b$var$sqrt);
        else // for single attr case, more efficient to avoid sqrt
        return $e815fda779bc047b$var$getDistance(length, getP, getQ, 0, $e815fda779bc047b$var$addAbsDiff);
    },
    squaredEuclidean: function squaredEuclidean(length, getP, getQ) {
        return $e815fda779bc047b$var$getDistance(length, getP, getQ, 0, $e815fda779bc047b$var$addSquaredDiff);
    },
    manhattan: function manhattan(length, getP, getQ) {
        return $e815fda779bc047b$var$getDistance(length, getP, getQ, 0, $e815fda779bc047b$var$addAbsDiff);
    },
    max: function max(length, getP, getQ) {
        return $e815fda779bc047b$var$getDistance(length, getP, getQ, -Infinity, $e815fda779bc047b$var$maxAbsDiff);
    }
};
// in case the user accidentally doesn't use camel case
$e815fda779bc047b$var$distances['squared-euclidean'] = $e815fda779bc047b$var$distances['squaredEuclidean'];
$e815fda779bc047b$var$distances['squaredeuclidean'] = $e815fda779bc047b$var$distances['squaredEuclidean'];
function $e815fda779bc047b$var$clusteringDistance(method, length, getP, getQ, nodeP, nodeQ) {
    var impl;
    if ($e815fda779bc047b$var$fn$6(method)) impl = method;
    else impl = $e815fda779bc047b$var$distances[method] || $e815fda779bc047b$var$distances.euclidean;
    if (length === 0 && $e815fda779bc047b$var$fn$6(method)) return impl(nodeP, nodeQ);
    else return impl(length, getP, getQ, nodeP, nodeQ);
}
var $e815fda779bc047b$var$defaults$b = $e815fda779bc047b$var$defaults$g({
    k: 2,
    m: 2,
    sensitivityThreshold: 0.0001,
    distance: 'euclidean',
    maxIterations: 10,
    attributes: [],
    testMode: false,
    testCentroids: null
});
var $e815fda779bc047b$var$setOptions$2 = function setOptions(options) {
    return $e815fda779bc047b$var$defaults$b(options);
};
var $e815fda779bc047b$var$getDist = function getDist(type, node, centroid, attributes, mode) {
    var noNodeP = mode !== 'kMedoids';
    var getP = noNodeP ? function(i) {
        return centroid[i];
    } : function(i) {
        return attributes[i](centroid);
    };
    var getQ = function getQ(i) {
        return attributes[i](node);
    };
    var nodeP = centroid;
    var nodeQ = node;
    return $e815fda779bc047b$var$clusteringDistance(type, attributes.length, getP, getQ, nodeP, nodeQ);
};
var $e815fda779bc047b$var$randomCentroids = function randomCentroids(nodes, k, attributes) {
    var ndim = attributes.length;
    var min = new Array(ndim);
    var max = new Array(ndim);
    var centroids = new Array(k);
    var centroid = null;
    // Find min, max values for each attribute dimension
    for(var i = 0; i < ndim; i++){
        min[i] = nodes.min(attributes[i]).value;
        max[i] = nodes.max(attributes[i]).value;
    }
    // Build k centroids, each represented as an n-dim feature vector
    for(var c = 0; c < k; c++){
        centroid = [];
        for(var _i = 0; _i < ndim; _i++)centroid[_i] = Math.random() * (max[_i] - min[_i]) + min[_i]; // random initial value
        centroids[c] = centroid;
    }
    return centroids;
};
var $e815fda779bc047b$var$classify = function classify(node, centroids, distance, attributes, type) {
    var min = Infinity;
    var index = 0;
    for(var i = 0; i < centroids.length; i++){
        var dist = $e815fda779bc047b$var$getDist(distance, node, centroids[i], attributes, type);
        if (dist < min) {
            min = dist;
            index = i;
        }
    }
    return index;
};
var $e815fda779bc047b$var$buildCluster = function buildCluster(centroid, nodes, assignment) {
    var cluster = [];
    var node = null;
    for(var n = 0; n < nodes.length; n++){
        node = nodes[n];
        if (assignment[node.id()] === centroid) //console.log("Node " + node.id() + " is associated with medoid #: " + m);
        cluster.push(node);
    }
    return cluster;
};
var $e815fda779bc047b$var$haveValuesConverged = function haveValuesConverged(v1, v2, sensitivityThreshold) {
    return Math.abs(v2 - v1) <= sensitivityThreshold;
};
var $e815fda779bc047b$var$haveMatricesConverged = function haveMatricesConverged(v1, v2, sensitivityThreshold) {
    for(var i = 0; i < v1.length; i++)for(var j = 0; j < v1[i].length; j++){
        var diff = Math.abs(v1[i][j] - v2[i][j]);
        if (diff > sensitivityThreshold) return false;
    }
    return true;
};
var $e815fda779bc047b$var$seenBefore = function seenBefore(node, medoids, n) {
    for(var i = 0; i < n; i++){
        if (node === medoids[i]) return true;
    }
    return false;
};
var $e815fda779bc047b$var$randomMedoids = function randomMedoids(nodes, k) {
    var medoids = new Array(k);
    // For small data sets, the probability of medoid conflict is greater,
    // so we need to check to see if we've already seen or chose this node before.
    if (nodes.length < 50) // Randomly select k medoids from the n nodes
    for(var i = 0; i < k; i++){
        var node = nodes[Math.floor(Math.random() * nodes.length)];
        // If we've already chosen this node to be a medoid, don't choose it again (for small data sets).
        // Instead choose a different random node.
        while($e815fda779bc047b$var$seenBefore(node, medoids, i))node = nodes[Math.floor(Math.random() * nodes.length)];
        medoids[i] = node;
    }
    else // Relatively large data set, so pretty safe to not check and just select random nodes
    for(var _i2 = 0; _i2 < k; _i2++)medoids[_i2] = nodes[Math.floor(Math.random() * nodes.length)];
    return medoids;
};
var $e815fda779bc047b$var$findCost = function findCost(potentialNewMedoid, cluster, attributes) {
    var cost = 0;
    for(var n = 0; n < cluster.length; n++)cost += $e815fda779bc047b$var$getDist('manhattan', cluster[n], potentialNewMedoid, attributes, 'kMedoids');
    return cost;
};
var $e815fda779bc047b$var$kMeans = function kMeans(options) {
    var cy = this.cy();
    var nodes = this.nodes();
    var node = null;
    // Set parameters of algorithm: # of clusters, distance metric, etc.
    var opts = $e815fda779bc047b$var$setOptions$2(options);
    // Begin k-means algorithm
    var clusters = new Array(opts.k);
    var assignment = {};
    var centroids;
    // Step 1: Initialize centroid positions
    if (opts.testMode) {
        if (typeof opts.testCentroids === 'number') {
            // TODO: implement a seeded random number generator.
            opts.testCentroids;
            centroids = $e815fda779bc047b$var$randomCentroids(nodes, opts.k, opts.attributes);
        } else if ($e815fda779bc047b$var$_typeof(opts.testCentroids) === 'object') centroids = opts.testCentroids;
        else centroids = $e815fda779bc047b$var$randomCentroids(nodes, opts.k, opts.attributes);
    } else centroids = $e815fda779bc047b$var$randomCentroids(nodes, opts.k, opts.attributes);
    var isStillMoving = true;
    var iterations = 0;
    while(isStillMoving && iterations < opts.maxIterations){
        // Step 2: Assign nodes to the nearest centroid
        for(var n = 0; n < nodes.length; n++){
            node = nodes[n];
            // Determine which cluster this node belongs to: node id => cluster #
            assignment[node.id()] = $e815fda779bc047b$var$classify(node, centroids, opts.distance, opts.attributes, 'kMeans');
        }
        // Step 3: For each of the k clusters, update its centroid
        isStillMoving = false;
        for(var c = 0; c < opts.k; c++){
            // Get all nodes that belong to this cluster
            var cluster = $e815fda779bc047b$var$buildCluster(c, nodes, assignment);
            if (cluster.length === 0) continue;
            // Update centroids by calculating avg of all nodes within the cluster.
            var ndim = opts.attributes.length;
            var centroid = centroids[c]; // [ dim_1, dim_2, dim_3, ... , dim_n ]
            var newCentroid = new Array(ndim);
            var sum = new Array(ndim);
            for(var d = 0; d < ndim; d++){
                sum[d] = 0.0;
                for(var i = 0; i < cluster.length; i++){
                    node = cluster[i];
                    sum[d] += opts.attributes[d](node);
                }
                newCentroid[d] = sum[d] / cluster.length;
                // Check to see if algorithm has converged, i.e. when centroids no longer change
                if (!$e815fda779bc047b$var$haveValuesConverged(newCentroid[d], centroid[d], opts.sensitivityThreshold)) isStillMoving = true;
            }
            centroids[c] = newCentroid;
            clusters[c] = cy.collection(cluster);
        }
        iterations++;
    }
    return clusters;
};
var $e815fda779bc047b$var$kMedoids = function kMedoids(options) {
    var cy = this.cy();
    var nodes = this.nodes();
    var node = null;
    var opts = $e815fda779bc047b$var$setOptions$2(options);
    // Begin k-medoids algorithm
    var clusters = new Array(opts.k);
    var medoids;
    var assignment = {};
    var curCost;
    var minCosts = new Array(opts.k); // minimum cost configuration for each cluster
    // Step 1: Initialize k medoids
    if (opts.testMode) {
        if (typeof opts.testCentroids === 'number') ;
        else if ($e815fda779bc047b$var$_typeof(opts.testCentroids) === 'object') medoids = opts.testCentroids;
        else medoids = $e815fda779bc047b$var$randomMedoids(nodes, opts.k);
    } else medoids = $e815fda779bc047b$var$randomMedoids(nodes, opts.k);
    var isStillMoving = true;
    var iterations = 0;
    while(isStillMoving && iterations < opts.maxIterations){
        // Step 2: Assign nodes to the nearest medoid
        for(var n = 0; n < nodes.length; n++){
            node = nodes[n];
            // Determine which cluster this node belongs to: node id => cluster #
            assignment[node.id()] = $e815fda779bc047b$var$classify(node, medoids, opts.distance, opts.attributes, 'kMedoids');
        }
        isStillMoving = false;
        // Step 3: For each medoid m, and for each node associated with mediod m,
        // select the node with the lowest configuration cost as new medoid.
        for(var m1 = 0; m1 < medoids.length; m1++){
            // Get all nodes that belong to this medoid
            var cluster = $e815fda779bc047b$var$buildCluster(m1, nodes, assignment);
            if (cluster.length === 0) continue;
            minCosts[m1] = $e815fda779bc047b$var$findCost(medoids[m1], cluster, opts.attributes); // original cost
            // Select different medoid if its configuration has the lowest cost
            for(var _n = 0; _n < cluster.length; _n++){
                curCost = $e815fda779bc047b$var$findCost(cluster[_n], cluster, opts.attributes);
                if (curCost < minCosts[m1]) {
                    minCosts[m1] = curCost;
                    medoids[m1] = cluster[_n];
                    isStillMoving = true;
                }
            }
            clusters[m1] = cy.collection(cluster);
        }
        iterations++;
    }
    return clusters;
};
var $e815fda779bc047b$var$updateCentroids = function updateCentroids(centroids, nodes, U, weight, opts) {
    var numerator, denominator;
    for(var n = 0; n < nodes.length; n++)for(var c = 0; c < centroids.length; c++)weight[n][c] = Math.pow(U[n][c], opts.m);
    for(var _c = 0; _c < centroids.length; _c++)for(var dim = 0; dim < opts.attributes.length; dim++){
        numerator = 0;
        denominator = 0;
        for(var _n2 = 0; _n2 < nodes.length; _n2++){
            numerator += weight[_n2][_c] * opts.attributes[dim](nodes[_n2]);
            denominator += weight[_n2][_c];
        }
        centroids[_c][dim] = numerator / denominator;
    }
};
var $e815fda779bc047b$var$updateMembership = function updateMembership(U, _U, centroids, nodes, opts) {
    // Save previous step
    for(var i = 0; i < U.length; i++)_U[i] = U[i].slice();
    var sum, numerator, denominator;
    var pow = 2 / (opts.m - 1);
    for(var c = 0; c < centroids.length; c++)for(var n = 0; n < nodes.length; n++){
        sum = 0;
        for(var k = 0; k < centroids.length; k++){
            // against all other centroids
            numerator = $e815fda779bc047b$var$getDist(opts.distance, nodes[n], centroids[c], opts.attributes, 'cmeans');
            denominator = $e815fda779bc047b$var$getDist(opts.distance, nodes[n], centroids[k], opts.attributes, 'cmeans');
            sum += Math.pow(numerator / denominator, pow);
        }
        U[n][c] = 1 / sum;
    }
};
var $e815fda779bc047b$var$assign$1 = function assign(nodes, U, opts, cy) {
    var clusters = new Array(opts.k);
    for(var c = 0; c < clusters.length; c++)clusters[c] = [];
    var max;
    var index;
    for(var n = 0; n < U.length; n++){
        // for each node (U is N x C matrix)
        max = -Infinity;
        index = -1;
        // Determine which cluster the node is most likely to belong in
        for(var _c2 = 0; _c2 < U[0].length; _c2++)if (U[n][_c2] > max) {
            max = U[n][_c2];
            index = _c2;
        }
        clusters[index].push(nodes[n]);
    }
    // Turn every array into a collection of nodes
    for(var _c3 = 0; _c3 < clusters.length; _c3++)clusters[_c3] = cy.collection(clusters[_c3]);
    return clusters;
};
var $e815fda779bc047b$var$fuzzyCMeans = function fuzzyCMeans(options) {
    var cy = this.cy();
    var nodes = this.nodes();
    var opts = $e815fda779bc047b$var$setOptions$2(options);
    // Begin fuzzy c-means algorithm
    var clusters;
    var centroids;
    var U;
    var _U;
    var weight;
    // Step 1: Initialize letiables.
    _U = new Array(nodes.length);
    for(var i = 0; i < nodes.length; i++)// N x C matrix
    _U[i] = new Array(opts.k);
    U = new Array(nodes.length);
    for(var _i3 = 0; _i3 < nodes.length; _i3++)// N x C matrix
    U[_i3] = new Array(opts.k);
    for(var _i4 = 0; _i4 < nodes.length; _i4++){
        var total = 0;
        for(var j = 0; j < opts.k; j++){
            U[_i4][j] = Math.random();
            total += U[_i4][j];
        }
        for(var _j = 0; _j < opts.k; _j++)U[_i4][_j] = U[_i4][_j] / total;
    }
    centroids = new Array(opts.k);
    for(var _i5 = 0; _i5 < opts.k; _i5++)centroids[_i5] = new Array(opts.attributes.length);
    weight = new Array(nodes.length);
    for(var _i6 = 0; _i6 < nodes.length; _i6++)// N x C matrix
    weight[_i6] = new Array(opts.k);
    // end init FCM
    var isStillMoving = true;
    var iterations = 0;
    while(isStillMoving && iterations < opts.maxIterations){
        isStillMoving = false;
        // Step 2: Calculate the centroids for each step.
        $e815fda779bc047b$var$updateCentroids(centroids, nodes, U, weight, opts);
        // Step 3: Update the partition matrix U.
        $e815fda779bc047b$var$updateMembership(U, _U, centroids, nodes, opts);
        // Step 4: Check for convergence.
        if (!$e815fda779bc047b$var$haveMatricesConverged(U, _U, opts.sensitivityThreshold)) isStillMoving = true;
        iterations++;
    }
    // Assign nodes to clusters with highest probability.
    clusters = $e815fda779bc047b$var$assign$1(nodes, U, opts, cy);
    return {
        clusters: clusters,
        degreeOfMembership: U
    };
};
var $e815fda779bc047b$var$kClustering = {
    kMeans: $e815fda779bc047b$var$kMeans,
    kMedoids: $e815fda779bc047b$var$kMedoids,
    fuzzyCMeans: $e815fda779bc047b$var$fuzzyCMeans,
    fcm: $e815fda779bc047b$var$fuzzyCMeans
};
// Implemented by Zoe Xi @zoexi for GSOC 2016
// https://github.com/cytoscape/cytoscape.js-hierarchical
var $e815fda779bc047b$var$defaults$a = $e815fda779bc047b$var$defaults$g({
    distance: 'euclidean',
    // distance metric to compare nodes
    linkage: 'min',
    // linkage criterion : how to determine the distance between clusters of nodes
    mode: 'threshold',
    // mode:'threshold' => clusters must be threshold distance apart
    threshold: Infinity,
    // the distance threshold
    // mode:'dendrogram' => the nodes are organised as leaves in a tree (siblings are close), merging makes clusters
    addDendrogram: false,
    // whether to add the dendrogram to the graph for viz
    dendrogramDepth: 0,
    // depth at which dendrogram branches are merged into the returned clusters
    attributes: [] // array of attr functions
});
var $e815fda779bc047b$var$linkageAliases = {
    'single': 'min',
    'complete': 'max'
};
var $e815fda779bc047b$var$setOptions$1 = function setOptions(options) {
    var opts = $e815fda779bc047b$var$defaults$a(options);
    var preferredAlias = $e815fda779bc047b$var$linkageAliases[opts.linkage];
    if (preferredAlias != null) opts.linkage = preferredAlias;
    return opts;
};
var $e815fda779bc047b$var$mergeClosest = function mergeClosest(clusters, index, dists, mins, opts) {
    // Find two closest clusters from cached mins
    var minKey = 0;
    var min = Infinity;
    var dist;
    var attrs = opts.attributes;
    var getDist = function getDist(n1, n2) {
        return $e815fda779bc047b$var$clusteringDistance(opts.distance, attrs.length, function(i) {
            return attrs[i](n1);
        }, function(i) {
            return attrs[i](n2);
        }, n1, n2);
    };
    for(var i = 0; i < clusters.length; i++){
        var key = clusters[i].key;
        var _dist = dists[key][mins[key]];
        if (_dist < min) {
            minKey = key;
            min = _dist;
        }
    }
    if (opts.mode === 'threshold' && min >= opts.threshold || opts.mode === 'dendrogram' && clusters.length === 1) return false;
    var c1 = index[minKey];
    var c2 = index[mins[minKey]];
    var merged;
    // Merge two closest clusters
    if (opts.mode === 'dendrogram') merged = {
        left: c1,
        right: c2,
        key: c1.key
    };
    else merged = {
        value: c1.value.concat(c2.value),
        key: c1.key
    };
    clusters[c1.index] = merged;
    clusters.splice(c2.index, 1);
    index[c1.key] = merged;
    // Update distances with new merged cluster
    for(var _i = 0; _i < clusters.length; _i++){
        var cur = clusters[_i];
        if (c1.key === cur.key) dist = Infinity;
        else if (opts.linkage === 'min') {
            dist = dists[c1.key][cur.key];
            if (dists[c1.key][cur.key] > dists[c2.key][cur.key]) dist = dists[c2.key][cur.key];
        } else if (opts.linkage === 'max') {
            dist = dists[c1.key][cur.key];
            if (dists[c1.key][cur.key] < dists[c2.key][cur.key]) dist = dists[c2.key][cur.key];
        } else if (opts.linkage === 'mean') dist = (dists[c1.key][cur.key] * c1.size + dists[c2.key][cur.key] * c2.size) / (c1.size + c2.size);
        else if (opts.mode === 'dendrogram') dist = getDist(cur.value, c1.value);
        else dist = getDist(cur.value[0], c1.value[0]);
        dists[c1.key][cur.key] = dists[cur.key][c1.key] = dist; // distance matrix is symmetric
    }
    // Update cached mins
    for(var _i2 = 0; _i2 < clusters.length; _i2++){
        var key1 = clusters[_i2].key;
        if (mins[key1] === c1.key || mins[key1] === c2.key) {
            var _min = key1;
            for(var j = 0; j < clusters.length; j++){
                var key2 = clusters[j].key;
                if (dists[key1][key2] < dists[key1][_min]) _min = key2;
            }
            mins[key1] = _min;
        }
        clusters[_i2].index = _i2;
    }
    // Clean up meta data used for clustering
    c1.key = c2.key = c1.index = c2.index = null;
    return true;
};
var $e815fda779bc047b$var$_getAllChildren = function getAllChildren(root, arr, cy) {
    if (!root) return;
    if (root.value) arr.push(root.value);
    else {
        if (root.left) $e815fda779bc047b$var$_getAllChildren(root.left, arr);
        if (root.right) $e815fda779bc047b$var$_getAllChildren(root.right, arr);
    }
};
var $e815fda779bc047b$var$_buildDendrogram = function buildDendrogram(root, cy) {
    if (!root) return '';
    if (root.left && root.right) {
        var leftStr = $e815fda779bc047b$var$_buildDendrogram(root.left, cy);
        var rightStr = $e815fda779bc047b$var$_buildDendrogram(root.right, cy);
        var node = cy.add({
            group: 'nodes',
            data: {
                id: leftStr + ',' + rightStr
            }
        });
        cy.add({
            group: 'edges',
            data: {
                source: leftStr,
                target: node.id()
            }
        });
        cy.add({
            group: 'edges',
            data: {
                source: rightStr,
                target: node.id()
            }
        });
        return node.id();
    } else if (root.value) return root.value.id();
};
var $e815fda779bc047b$var$_buildClustersFromTree = function buildClustersFromTree(root, k, cy) {
    if (!root) return [];
    var left = [], right = [], leaves = [];
    if (k === 0) {
        // don't cut tree, simply return all nodes as 1 single cluster
        if (root.left) $e815fda779bc047b$var$_getAllChildren(root.left, left);
        if (root.right) $e815fda779bc047b$var$_getAllChildren(root.right, right);
        leaves = left.concat(right);
        return [
            cy.collection(leaves)
        ];
    } else if (k === 1) {
        // cut at root
        if (root.value) // leaf node
        return [
            cy.collection(root.value)
        ];
        else {
            if (root.left) $e815fda779bc047b$var$_getAllChildren(root.left, left);
            if (root.right) $e815fda779bc047b$var$_getAllChildren(root.right, right);
            return [
                cy.collection(left),
                cy.collection(right)
            ];
        }
    } else {
        if (root.value) return [
            cy.collection(root.value)
        ];
        else {
            if (root.left) left = $e815fda779bc047b$var$_buildClustersFromTree(root.left, k - 1, cy);
            if (root.right) right = $e815fda779bc047b$var$_buildClustersFromTree(root.right, k - 1, cy);
            return left.concat(right);
        }
    }
};
var $e815fda779bc047b$var$hierarchicalClustering = function hierarchicalClustering(options) {
    var cy = this.cy();
    var nodes = this.nodes();
    // Set parameters of algorithm: linkage type, distance metric, etc.
    var opts = $e815fda779bc047b$var$setOptions$1(options);
    var attrs = opts.attributes;
    var getDist = function getDist(n1, n2) {
        return $e815fda779bc047b$var$clusteringDistance(opts.distance, attrs.length, function(i) {
            return attrs[i](n1);
        }, function(i) {
            return attrs[i](n2);
        }, n1, n2);
    };
    // Begin hierarchical algorithm
    var clusters = [];
    var dists = []; // distances between each pair of clusters
    var mins = []; // closest cluster for each cluster
    var index = []; // hash of all clusters by key
    // In agglomerative (bottom-up) clustering, each node starts as its own cluster
    for(var n = 0; n < nodes.length; n++){
        var cluster = {
            value: opts.mode === 'dendrogram' ? nodes[n] : [
                nodes[n]
            ],
            key: n,
            index: n
        };
        clusters[n] = cluster;
        index[n] = cluster;
        dists[n] = [];
        mins[n] = 0;
    }
    // Calculate the distance between each pair of clusters
    for(var i = 0; i < clusters.length; i++)for(var j = 0; j <= i; j++){
        var dist = undefined;
        if (opts.mode === 'dendrogram') // modes store cluster values differently
        dist = i === j ? Infinity : getDist(clusters[i].value, clusters[j].value);
        else dist = i === j ? Infinity : getDist(clusters[i].value[0], clusters[j].value[0]);
        dists[i][j] = dist;
        dists[j][i] = dist;
        if (dist < dists[i][mins[i]]) mins[i] = j; // Cache mins: closest cluster to cluster i is cluster j
    }
    // Find the closest pair of clusters and merge them into a single cluster.
    // Update distances between new cluster and each of the old clusters, and loop until threshold reached.
    var merged = $e815fda779bc047b$var$mergeClosest(clusters, index, dists, mins, opts);
    while(merged)merged = $e815fda779bc047b$var$mergeClosest(clusters, index, dists, mins, opts);
    var retClusters;
    // Dendrogram mode builds the hierarchy and adds intermediary nodes + edges
    // in addition to returning the clusters.
    if (opts.mode === 'dendrogram') {
        retClusters = $e815fda779bc047b$var$_buildClustersFromTree(clusters[0], opts.dendrogramDepth, cy);
        if (opts.addDendrogram) $e815fda779bc047b$var$_buildDendrogram(clusters[0], cy);
    } else {
        // Regular mode simply returns the clusters
        retClusters = new Array(clusters.length);
        clusters.forEach(function(cluster, i) {
            // Clean up meta data used for clustering
            cluster.key = cluster.index = null;
            retClusters[i] = cy.collection(cluster.value);
        });
    }
    return retClusters;
};
var $e815fda779bc047b$var$hierarchicalClustering$1 = {
    hierarchicalClustering: $e815fda779bc047b$var$hierarchicalClustering,
    hca: $e815fda779bc047b$var$hierarchicalClustering
};
// Implemented by Zoe Xi @zoexi for GSOC 2016
// https://github.com/cytoscape/cytoscape.js-affinity-propagation
var $e815fda779bc047b$var$defaults$9 = $e815fda779bc047b$var$defaults$g({
    distance: 'euclidean',
    // distance metric to compare attributes between two nodes
    preference: 'median',
    // suitability of a data point to serve as an exemplar
    damping: 0.8,
    // damping factor between [0.5, 1)
    maxIterations: 1000,
    // max number of iterations to run
    minIterations: 100,
    // min number of iterations to run in order for clustering to stop
    attributes: []
});
var $e815fda779bc047b$var$setOptions = function setOptions(options) {
    var dmp = options.damping;
    var pref = options.preference;
    if (!(0.5 <= dmp && dmp < 1)) $e815fda779bc047b$var$error("Damping must range on [0.5, 1).  Got: ".concat(dmp));
    var validPrefs = [
        'median',
        'mean',
        'min',
        'max'
    ];
    if (!(validPrefs.some(function(v) {
        return v === pref;
    }) || $e815fda779bc047b$var$number$1(pref))) $e815fda779bc047b$var$error("Preference must be one of [".concat(validPrefs.map(function(p) {
        return "'".concat(p, "'");
    }).join(', '), "] or a number.  Got: ").concat(pref));
    return $e815fda779bc047b$var$defaults$9(options);
};
var $e815fda779bc047b$var$getSimilarity = function getSimilarity(type, n1, n2, attributes) {
    var attr = function attr(n, i) {
        return attributes[i](n);
    };
    // nb negative because similarity should have an inverse relationship to distance
    return -$e815fda779bc047b$var$clusteringDistance(type, attributes.length, function(i) {
        return attr(n1, i);
    }, function(i) {
        return attr(n2, i);
    }, n1, n2);
};
var $e815fda779bc047b$var$getPreference = function getPreference(S, preference) {
    // larger preference = greater # of clusters
    var p = null;
    if (preference === 'median') p = $e815fda779bc047b$var$median(S);
    else if (preference === 'mean') p = $e815fda779bc047b$var$mean(S);
    else if (preference === 'min') p = $e815fda779bc047b$var$min(S);
    else if (preference === 'max') p = $e815fda779bc047b$var$max(S);
    else // Custom preference number, as set by user
    p = preference;
    return p;
};
var $e815fda779bc047b$var$findExemplars = function findExemplars(n, R, A) {
    var indices = [];
    for(var i = 0; i < n; i++)if (R[i * n + i] + A[i * n + i] > 0) indices.push(i);
    return indices;
};
var $e815fda779bc047b$var$assignClusters = function assignClusters(n, S, exemplars) {
    var clusters = [];
    for(var i = 0; i < n; i++){
        var index = -1;
        var max = -Infinity;
        for(var ei = 0; ei < exemplars.length; ei++){
            var e = exemplars[ei];
            if (S[i * n + e] > max) {
                index = e;
                max = S[i * n + e];
            }
        }
        if (index > 0) clusters.push(index);
    }
    for(var _ei = 0; _ei < exemplars.length; _ei++)clusters[exemplars[_ei]] = exemplars[_ei];
    return clusters;
};
var $e815fda779bc047b$var$assign = function assign(n, S, exemplars) {
    var clusters = $e815fda779bc047b$var$assignClusters(n, S, exemplars);
    for(var ei = 0; ei < exemplars.length; ei++){
        var ii = [];
        for(var c = 0; c < clusters.length; c++)if (clusters[c] === exemplars[ei]) ii.push(c);
        var maxI = -1;
        var maxSum = -Infinity;
        for(var i = 0; i < ii.length; i++){
            var sum = 0;
            for(var j = 0; j < ii.length; j++)sum += S[ii[j] * n + ii[i]];
            if (sum > maxSum) {
                maxI = i;
                maxSum = sum;
            }
        }
        exemplars[ei] = ii[maxI];
    }
    clusters = $e815fda779bc047b$var$assignClusters(n, S, exemplars);
    return clusters;
};
var $e815fda779bc047b$var$affinityPropagation = function affinityPropagation(options) {
    var cy = this.cy();
    var nodes = this.nodes();
    var opts = $e815fda779bc047b$var$setOptions(options);
    // Map each node to its position in node array
    var id2position = {};
    for(var i = 0; i < nodes.length; i++)id2position[nodes[i].id()] = i;
    // Begin affinity propagation algorithm
    var n; // number of data points
    var n2; // size of matrices
    var S; // similarity matrix (1D array)
    var p; // preference/suitability of a data point to serve as an exemplar
    var R; // responsibility matrix (1D array)
    var A; // availability matrix (1D array)
    n = nodes.length;
    n2 = n * n;
    // Initialize and build S similarity matrix
    S = new Array(n2);
    for(var _i = 0; _i < n2; _i++)S[_i] = -Infinity; // for cases where two data points shouldn't be linked together
    for(var _i2 = 0; _i2 < n; _i2++){
        for(var j = 0; j < n; j++)if (_i2 !== j) S[_i2 * n + j] = $e815fda779bc047b$var$getSimilarity(opts.distance, nodes[_i2], nodes[j], opts.attributes);
    }
    // Place preferences on the diagonal of S
    p = $e815fda779bc047b$var$getPreference(S, opts.preference);
    for(var _i3 = 0; _i3 < n; _i3++)S[_i3 * n + _i3] = p;
    // Initialize R responsibility matrix
    R = new Array(n2);
    for(var _i4 = 0; _i4 < n2; _i4++)R[_i4] = 0.0;
    // Initialize A availability matrix
    A = new Array(n2);
    for(var _i5 = 0; _i5 < n2; _i5++)A[_i5] = 0.0;
    var old = new Array(n);
    var Rp = new Array(n);
    var se = new Array(n);
    for(var _i6 = 0; _i6 < n; _i6++){
        old[_i6] = 0.0;
        Rp[_i6] = 0.0;
        se[_i6] = 0;
    }
    var e = new Array(n * opts.minIterations);
    for(var _i7 = 0; _i7 < e.length; _i7++)e[_i7] = 0;
    var iter;
    for(iter = 0; iter < opts.maxIterations; iter++){
        // main algorithmic loop
        // Update R responsibility matrix
        for(var _i8 = 0; _i8 < n; _i8++){
            var max = -Infinity, max2 = -Infinity, maxI = -1, AS = 0.0;
            for(var _j = 0; _j < n; _j++){
                old[_j] = R[_i8 * n + _j];
                AS = A[_i8 * n + _j] + S[_i8 * n + _j];
                if (AS >= max) {
                    max2 = max;
                    max = AS;
                    maxI = _j;
                } else if (AS > max2) max2 = AS;
            }
            for(var _j2 = 0; _j2 < n; _j2++)R[_i8 * n + _j2] = (1 - opts.damping) * (S[_i8 * n + _j2] - max) + opts.damping * old[_j2];
            R[_i8 * n + maxI] = (1 - opts.damping) * (S[_i8 * n + maxI] - max2) + opts.damping * old[maxI];
        }
        // Update A availability matrix
        for(var _i9 = 0; _i9 < n; _i9++){
            var sum = 0;
            for(var _j3 = 0; _j3 < n; _j3++){
                old[_j3] = A[_j3 * n + _i9];
                Rp[_j3] = Math.max(0, R[_j3 * n + _i9]);
                sum += Rp[_j3];
            }
            sum -= Rp[_i9];
            Rp[_i9] = R[_i9 * n + _i9];
            sum += Rp[_i9];
            for(var _j4 = 0; _j4 < n; _j4++)A[_j4 * n + _i9] = (1 - opts.damping) * Math.min(0, sum - Rp[_j4]) + opts.damping * old[_j4];
            A[_i9 * n + _i9] = (1 - opts.damping) * (sum - Rp[_i9]) + opts.damping * old[_i9];
        }
        // Check for convergence
        var K = 0;
        for(var _i10 = 0; _i10 < n; _i10++){
            var E = A[_i10 * n + _i10] + R[_i10 * n + _i10] > 0 ? 1 : 0;
            e[iter % opts.minIterations * n + _i10] = E;
            K += E;
        }
        if (K > 0 && (iter >= opts.minIterations - 1 || iter == opts.maxIterations - 1)) {
            var _sum = 0;
            for(var _i11 = 0; _i11 < n; _i11++){
                se[_i11] = 0;
                for(var _j5 = 0; _j5 < opts.minIterations; _j5++)se[_i11] += e[_j5 * n + _i11];
                if (se[_i11] === 0 || se[_i11] === opts.minIterations) _sum++;
            }
            if (_sum === n) break;
        }
    }
    // Identify exemplars (cluster centers)
    var exemplarsIndices = $e815fda779bc047b$var$findExemplars(n, R, A);
    // Assign nodes to clusters
    var clusterIndices = $e815fda779bc047b$var$assign(n, S, exemplarsIndices);
    var clusters = {};
    for(var c = 0; c < exemplarsIndices.length; c++)clusters[exemplarsIndices[c]] = [];
    for(var _i12 = 0; _i12 < nodes.length; _i12++){
        var pos = id2position[nodes[_i12].id()];
        var clusterIndex = clusterIndices[pos];
        if (clusterIndex != null) // the node may have not been assigned a cluster if no valid attributes were specified
        clusters[clusterIndex].push(nodes[_i12]);
    }
    var retClusters = new Array(exemplarsIndices.length);
    for(var _c = 0; _c < exemplarsIndices.length; _c++)retClusters[_c] = cy.collection(clusters[exemplarsIndices[_c]]);
    return retClusters;
};
var $e815fda779bc047b$var$affinityPropagation$1 = {
    affinityPropagation: $e815fda779bc047b$var$affinityPropagation,
    ap: $e815fda779bc047b$var$affinityPropagation
};
var $e815fda779bc047b$var$hierholzerDefaults = $e815fda779bc047b$var$defaults$g({
    root: undefined,
    directed: false
});
var $e815fda779bc047b$var$elesfn$k = {
    hierholzer: function hierholzer(options) {
        if (!$e815fda779bc047b$var$plainObject(options)) {
            var args = arguments;
            options = {
                root: args[0],
                directed: args[1]
            };
        }
        var _hierholzerDefaults = $e815fda779bc047b$var$hierholzerDefaults(options), root = _hierholzerDefaults.root, directed = _hierholzerDefaults.directed;
        var eles = this;
        var dflag = false;
        var oddIn;
        var oddOut;
        var startVertex;
        if (root) startVertex = $e815fda779bc047b$var$string(root) ? this.filter(root)[0].id() : root[0].id();
        var nodes = {};
        var edges = {};
        if (directed) eles.forEach(function(ele) {
            var id = ele.id();
            if (ele.isNode()) {
                var ind = ele.indegree(true);
                var outd = ele.outdegree(true);
                var d1 = ind - outd;
                var d2 = outd - ind;
                if (d1 == 1) {
                    if (oddIn) dflag = true;
                    else oddIn = id;
                } else if (d2 == 1) {
                    if (oddOut) dflag = true;
                    else oddOut = id;
                } else if (d2 > 1 || d1 > 1) dflag = true;
                nodes[id] = [];
                ele.outgoers().forEach(function(e) {
                    if (e.isEdge()) nodes[id].push(e.id());
                });
            } else edges[id] = [
                undefined,
                ele.target().id()
            ];
        });
        else eles.forEach(function(ele) {
            var id = ele.id();
            if (ele.isNode()) {
                var d = ele.degree(true);
                if (d % 2) {
                    if (!oddIn) oddIn = id;
                    else if (!oddOut) oddOut = id;
                    else dflag = true;
                }
                nodes[id] = [];
                ele.connectedEdges().forEach(function(e) {
                    return nodes[id].push(e.id());
                });
            } else edges[id] = [
                ele.source().id(),
                ele.target().id()
            ];
        });
        var result = {
            found: false,
            trail: undefined
        };
        if (dflag) return result;
        else if (oddOut && oddIn) {
            if (directed) {
                if (startVertex && oddOut != startVertex) return result;
                startVertex = oddOut;
            } else {
                if (startVertex && oddOut != startVertex && oddIn != startVertex) return result;
                else if (!startVertex) startVertex = oddOut;
            }
        } else if (!startVertex) startVertex = eles[0].id();
        var walk = function walk(v) {
            var currentNode = v;
            var subtour = [
                v
            ];
            var adj, adjTail, adjHead;
            while(nodes[currentNode].length){
                adj = nodes[currentNode].shift();
                adjTail = edges[adj][0];
                adjHead = edges[adj][1];
                if (currentNode != adjHead) {
                    nodes[adjHead] = nodes[adjHead].filter(function(e) {
                        return e != adj;
                    });
                    currentNode = adjHead;
                } else if (!directed && currentNode != adjTail) {
                    nodes[adjTail] = nodes[adjTail].filter(function(e) {
                        return e != adj;
                    });
                    currentNode = adjTail;
                }
                subtour.unshift(adj);
                subtour.unshift(currentNode);
            }
            return subtour;
        };
        var trail = [];
        var subtour = [];
        subtour = walk(startVertex);
        while(subtour.length != 1)if (nodes[subtour[0]].length == 0) {
            trail.unshift(eles.getElementById(subtour.shift()));
            trail.unshift(eles.getElementById(subtour.shift()));
        } else subtour = walk(subtour.shift()).concat(subtour);
        trail.unshift(eles.getElementById(subtour.shift())); // final node
        for(var d in nodes){
            if (nodes[d].length) return result;
        }
        result.found = true;
        result.trail = this.spawn(trail, true);
        return result;
    }
};
var $e815fda779bc047b$var$hopcroftTarjanBiconnected = function hopcroftTarjanBiconnected() {
    var eles = this;
    var nodes = {};
    var id = 0;
    var edgeCount = 0;
    var components = [];
    var stack = [];
    var visitedEdges = {};
    var buildComponent = function buildComponent(x, y) {
        var i = stack.length - 1;
        var cutset = [];
        var component = eles.spawn();
        while(stack[i].x != x || stack[i].y != y){
            cutset.push(stack.pop().edge);
            i--;
        }
        cutset.push(stack.pop().edge);
        cutset.forEach(function(edge) {
            var connectedNodes = edge.connectedNodes().intersection(eles);
            component.merge(edge);
            connectedNodes.forEach(function(node) {
                var nodeId = node.id();
                var connectedEdges = node.connectedEdges().intersection(eles);
                component.merge(node);
                if (!nodes[nodeId].cutVertex) component.merge(connectedEdges);
                else component.merge(connectedEdges.filter(function(edge) {
                    return edge.isLoop();
                }));
            });
        });
        components.push(component);
    };
    var _biconnectedSearch = function biconnectedSearch(root, currentNode, parent) {
        if (root === parent) edgeCount += 1;
        nodes[currentNode] = {
            id: id,
            low: id++,
            cutVertex: false
        };
        var edges = eles.getElementById(currentNode).connectedEdges().intersection(eles);
        if (edges.size() === 0) components.push(eles.spawn(eles.getElementById(currentNode)));
        else {
            var sourceId, targetId, otherNodeId, edgeId;
            edges.forEach(function(edge) {
                sourceId = edge.source().id();
                targetId = edge.target().id();
                otherNodeId = sourceId === currentNode ? targetId : sourceId;
                if (otherNodeId !== parent) {
                    edgeId = edge.id();
                    if (!visitedEdges[edgeId]) {
                        visitedEdges[edgeId] = true;
                        stack.push({
                            x: currentNode,
                            y: otherNodeId,
                            edge: edge
                        });
                    }
                    if (!(otherNodeId in nodes)) {
                        _biconnectedSearch(root, otherNodeId, currentNode);
                        nodes[currentNode].low = Math.min(nodes[currentNode].low, nodes[otherNodeId].low);
                        if (nodes[currentNode].id <= nodes[otherNodeId].low) {
                            nodes[currentNode].cutVertex = true;
                            buildComponent(currentNode, otherNodeId);
                        }
                    } else nodes[currentNode].low = Math.min(nodes[currentNode].low, nodes[otherNodeId].id);
                }
            });
        }
    };
    eles.forEach(function(ele) {
        if (ele.isNode()) {
            var nodeId = ele.id();
            if (!(nodeId in nodes)) {
                edgeCount = 0;
                _biconnectedSearch(nodeId, nodeId);
                nodes[nodeId].cutVertex = edgeCount > 1;
            }
        }
    });
    var cutVertices = Object.keys(nodes).filter(function(id) {
        return nodes[id].cutVertex;
    }).map(function(id) {
        return eles.getElementById(id);
    });
    return {
        cut: eles.spawn(cutVertices),
        components: components
    };
};
var $e815fda779bc047b$var$hopcroftTarjanBiconnected$1 = {
    hopcroftTarjanBiconnected: $e815fda779bc047b$var$hopcroftTarjanBiconnected,
    htbc: $e815fda779bc047b$var$hopcroftTarjanBiconnected,
    htb: $e815fda779bc047b$var$hopcroftTarjanBiconnected,
    hopcroftTarjanBiconnectedComponents: $e815fda779bc047b$var$hopcroftTarjanBiconnected
};
var $e815fda779bc047b$var$tarjanStronglyConnected = function tarjanStronglyConnected() {
    var eles = this;
    var nodes = {};
    var index = 0;
    var components = [];
    var stack = [];
    var cut = eles.spawn(eles);
    var _stronglyConnectedSearch = function stronglyConnectedSearch(sourceNodeId) {
        stack.push(sourceNodeId);
        nodes[sourceNodeId] = {
            index: index,
            low: index++,
            explored: false
        };
        var connectedEdges = eles.getElementById(sourceNodeId).connectedEdges().intersection(eles);
        connectedEdges.forEach(function(edge) {
            var targetNodeId = edge.target().id();
            if (targetNodeId !== sourceNodeId) {
                if (!(targetNodeId in nodes)) _stronglyConnectedSearch(targetNodeId);
                if (!nodes[targetNodeId].explored) nodes[sourceNodeId].low = Math.min(nodes[sourceNodeId].low, nodes[targetNodeId].low);
            }
        });
        if (nodes[sourceNodeId].index === nodes[sourceNodeId].low) {
            var componentNodes = eles.spawn();
            for(;;){
                var nodeId = stack.pop();
                componentNodes.merge(eles.getElementById(nodeId));
                nodes[nodeId].low = nodes[sourceNodeId].index;
                nodes[nodeId].explored = true;
                if (nodeId === sourceNodeId) break;
            }
            var componentEdges = componentNodes.edgesWith(componentNodes);
            var component = componentNodes.merge(componentEdges);
            components.push(component);
            cut = cut.difference(component);
        }
    };
    eles.forEach(function(ele) {
        if (ele.isNode()) {
            var nodeId = ele.id();
            if (!(nodeId in nodes)) _stronglyConnectedSearch(nodeId);
        }
    });
    return {
        cut: cut,
        components: components
    };
};
var $e815fda779bc047b$var$tarjanStronglyConnected$1 = {
    tarjanStronglyConnected: $e815fda779bc047b$var$tarjanStronglyConnected,
    tsc: $e815fda779bc047b$var$tarjanStronglyConnected,
    tscc: $e815fda779bc047b$var$tarjanStronglyConnected,
    tarjanStronglyConnectedComponents: $e815fda779bc047b$var$tarjanStronglyConnected
};
var $e815fda779bc047b$var$elesfn$j = {};
[
    $e815fda779bc047b$var$elesfn$v,
    $e815fda779bc047b$var$elesfn$u,
    $e815fda779bc047b$var$elesfn$t,
    $e815fda779bc047b$var$elesfn$s,
    $e815fda779bc047b$var$elesfn$r,
    $e815fda779bc047b$var$elesfn$q,
    $e815fda779bc047b$var$elesfn$p,
    $e815fda779bc047b$var$elesfn$o,
    $e815fda779bc047b$var$elesfn$n,
    $e815fda779bc047b$var$elesfn$m,
    $e815fda779bc047b$var$elesfn$l,
    $e815fda779bc047b$var$markovClustering$1,
    $e815fda779bc047b$var$kClustering,
    $e815fda779bc047b$var$hierarchicalClustering$1,
    $e815fda779bc047b$var$affinityPropagation$1,
    $e815fda779bc047b$var$elesfn$k,
    $e815fda779bc047b$var$hopcroftTarjanBiconnected$1,
    $e815fda779bc047b$var$tarjanStronglyConnected$1
].forEach(function(props) {
    $e815fda779bc047b$var$extend($e815fda779bc047b$var$elesfn$j, props);
});
/*!
Embeddable Minimum Strictly-Compliant Promises/A+ 1.1.1 Thenable
Copyright (c) 2013-2014 Ralf S. Engelschall (http://engelschall.com)
Licensed under The MIT License (http://opensource.org/licenses/MIT)
*/ /*  promise states [Promises/A+ 2.1]  */ var $e815fda779bc047b$var$STATE_PENDING = 0; /*  [Promises/A+ 2.1.1]  */ 
var $e815fda779bc047b$var$STATE_FULFILLED = 1; /*  [Promises/A+ 2.1.2]  */ 
var $e815fda779bc047b$var$STATE_REJECTED = 2; /*  [Promises/A+ 2.1.3]  */ 
/*  promise object constructor  */ var $e815fda779bc047b$var$_api = function api(executor) {
    /*  optionally support non-constructor/plain-function call  */ if (!(this instanceof $e815fda779bc047b$var$_api)) return new $e815fda779bc047b$var$_api(executor);
    /*  initialize object  */ this.id = 'Thenable/1.0.7';
    this.state = $e815fda779bc047b$var$STATE_PENDING; /*  initial state  */ 
    this.fulfillValue = undefined; /*  initial value  */  /*  [Promises/A+ 1.3, 2.1.2.2]  */ 
    this.rejectReason = undefined; /*  initial reason */  /*  [Promises/A+ 1.5, 2.1.3.2]  */ 
    this.onFulfilled = []; /*  initial handlers  */ 
    this.onRejected = []; /*  initial handlers  */ 
    /*  provide optional information-hiding proxy  */ this.proxy = {
        then: this.then.bind(this)
    };
    /*  support optional executor function  */ if (typeof executor === 'function') executor.call(this, this.fulfill.bind(this), this.reject.bind(this));
};
/*  promise API methods  */ $e815fda779bc047b$var$_api.prototype = {
    /*  promise resolving methods  */ fulfill: function fulfill(value) {
        return $e815fda779bc047b$var$deliver(this, $e815fda779bc047b$var$STATE_FULFILLED, 'fulfillValue', value);
    },
    reject: function reject(value) {
        return $e815fda779bc047b$var$deliver(this, $e815fda779bc047b$var$STATE_REJECTED, 'rejectReason', value);
    },
    /*  "The then Method" [Promises/A+ 1.1, 1.2, 2.2]  */ then: function then(onFulfilled, onRejected) {
        var curr = this;
        var next = new $e815fda779bc047b$var$_api(); /*  [Promises/A+ 2.2.7]  */ 
        curr.onFulfilled.push($e815fda779bc047b$var$resolver(onFulfilled, next, 'fulfill')); /*  [Promises/A+ 2.2.2/2.2.6]  */ 
        curr.onRejected.push($e815fda779bc047b$var$resolver(onRejected, next, 'reject')); /*  [Promises/A+ 2.2.3/2.2.6]  */ 
        $e815fda779bc047b$var$execute(curr);
        return next.proxy; /*  [Promises/A+ 2.2.7, 3.3]  */ 
    }
};
/*  deliver an action  */ var $e815fda779bc047b$var$deliver = function deliver(curr, state, name, value) {
    if (curr.state === $e815fda779bc047b$var$STATE_PENDING) {
        curr.state = state; /*  [Promises/A+ 2.1.2.1, 2.1.3.1]  */ 
        curr[name] = value; /*  [Promises/A+ 2.1.2.2, 2.1.3.2]  */ 
        $e815fda779bc047b$var$execute(curr);
    }
    return curr;
};
/*  execute all handlers  */ var $e815fda779bc047b$var$execute = function execute(curr) {
    if (curr.state === $e815fda779bc047b$var$STATE_FULFILLED) $e815fda779bc047b$var$execute_handlers(curr, 'onFulfilled', curr.fulfillValue);
    else if (curr.state === $e815fda779bc047b$var$STATE_REJECTED) $e815fda779bc047b$var$execute_handlers(curr, 'onRejected', curr.rejectReason);
};
/*  execute particular set of handlers  */ var $e815fda779bc047b$var$execute_handlers = function execute_handlers(curr, name, value) {
    /* global setImmediate: true */ /* global setTimeout: true */ /*  short-circuit processing  */ if (curr[name].length === 0) return;
    /*  iterate over all handlers, exactly once  */ var handlers = curr[name];
    curr[name] = []; /*  [Promises/A+ 2.2.2.3, 2.2.3.3]  */ 
    var func = function func() {
        for(var i = 0; i < handlers.length; i++)handlers[i](value); /*  [Promises/A+ 2.2.5]  */ 
    };
    /*  execute procedure asynchronously  */ /*  [Promises/A+ 2.2.4, 3.1]  */ if (typeof setImmediate === 'function') setImmediate(func);
    else setTimeout(func, 0);
};
/*  generate a resolver function  */ var $e815fda779bc047b$var$resolver = function resolver(cb, next, method) {
    return function(value) {
        if (typeof cb !== 'function') /*  [Promises/A+ 2.2.1, 2.2.7.3, 2.2.7.4]  */ next[method].call(next, value); /*  [Promises/A+ 2.2.7.3, 2.2.7.4]  */ 
        else {
            var result;
            try {
                result = cb(value);
            } catch (e) {
                next.reject(e); /*  [Promises/A+ 2.2.7.2]  */ 
                return;
            }
            $e815fda779bc047b$var$_resolve(next, result); /*  [Promises/A+ 2.2.7.1]  */ 
        }
    };
};
/*  "Promise Resolution Procedure"  */ /*  [Promises/A+ 2.3]  */ var $e815fda779bc047b$var$_resolve = function resolve(promise, x) {
    /*  sanity check arguments  */ /*  [Promises/A+ 2.3.1]  */ if (promise === x || promise.proxy === x) {
        promise.reject(new TypeError('cannot resolve promise with itself'));
        return;
    }
    /*  surgically check for a "then" method
    (mainly to just call the "getter" of "then" only once)  */ var then;
    if ($e815fda779bc047b$var$_typeof(x) === 'object' && x !== null || typeof x === 'function') try {
        then = x.then;
    } catch (e) {
        promise.reject(e); /*  [Promises/A+ 2.3.3.2]  */ 
        return;
    }
    /*  handle own Thenables    [Promises/A+ 2.3.2]
    and similar "thenables" [Promises/A+ 2.3.3]  */ if (typeof then === 'function') {
        var resolved = false;
        try {
            /*  call retrieved "then" method */ /*  [Promises/A+ 2.3.3.3]  */ then.call(x, /*  resolvePromise  */ /*  [Promises/A+ 2.3.3.3.1]  */ function(y) {
                if (resolved) return;
                resolved = true; /*  [Promises/A+ 2.3.3.3.3]  */ 
                if (y === x) /*  [Promises/A+ 3.6]  */ promise.reject(new TypeError('circular thenable chain'));
                else $e815fda779bc047b$var$_resolve(promise, y);
            }, /*  rejectPromise  */ /*  [Promises/A+ 2.3.3.3.2]  */ function(r) {
                if (resolved) return;
                resolved = true; /*  [Promises/A+ 2.3.3.3.3]  */ 
                promise.reject(r);
            });
        } catch (e) {
            if (!resolved) /*  [Promises/A+ 2.3.3.3.3]  */ promise.reject(e); /*  [Promises/A+ 2.3.3.3.4]  */ 
        }
        return;
    }
    /*  handle other values  */ promise.fulfill(x); /*  [Promises/A+ 2.3.4, 2.3.3.4]  */ 
};
// so we always have Promise.all()
$e815fda779bc047b$var$_api.all = function(ps) {
    return new $e815fda779bc047b$var$_api(function(resolveAll, rejectAll) {
        var vals = new Array(ps.length);
        var doneCount = 0;
        var fulfill = function fulfill(i, val) {
            vals[i] = val;
            doneCount++;
            if (doneCount === ps.length) resolveAll(vals);
        };
        for(var i = 0; i < ps.length; i++)(function(i) {
            var p = ps[i];
            var isPromise = p != null && p.then != null;
            if (isPromise) p.then(function(val) {
                fulfill(i, val);
            }, function(err) {
                rejectAll(err);
            });
            else {
                var val = p;
                fulfill(i, val);
            }
        })(i);
    });
};
$e815fda779bc047b$var$_api.resolve = function(val) {
    return new $e815fda779bc047b$var$_api(function(resolve, reject) {
        resolve(val);
    });
};
$e815fda779bc047b$var$_api.reject = function(val) {
    return new $e815fda779bc047b$var$_api(function(resolve, reject) {
        reject(val);
    });
};
var $e815fda779bc047b$var$Promise$1 = typeof Promise !== 'undefined' ? Promise : $e815fda779bc047b$var$_api; // eslint-disable-line no-undef
var $e815fda779bc047b$var$Animation = function Animation(target, opts, opts2) {
    var isCore = $e815fda779bc047b$var$core(target);
    var isEle = !isCore;
    var _p = this._private = $e815fda779bc047b$var$extend({
        duration: 1000
    }, opts, opts2);
    _p.target = target;
    _p.style = _p.style || _p.css;
    _p.started = false;
    _p.playing = false;
    _p.hooked = false;
    _p.applying = false;
    _p.progress = 0;
    _p.completes = [];
    _p.frames = [];
    if (_p.complete && $e815fda779bc047b$var$fn$6(_p.complete)) _p.completes.push(_p.complete);
    if (isEle) {
        var pos = target.position();
        _p.startPosition = _p.startPosition || {
            x: pos.x,
            y: pos.y
        };
        _p.startStyle = _p.startStyle || target.cy().style().getAnimationStartStyle(target, _p.style);
    }
    if (isCore) {
        var pan = target.pan();
        _p.startPan = {
            x: pan.x,
            y: pan.y
        };
        _p.startZoom = target.zoom();
    }
    // for future timeline/animations impl
    this.length = 1;
    this[0] = this;
};
var $e815fda779bc047b$var$anifn = $e815fda779bc047b$var$Animation.prototype;
$e815fda779bc047b$var$extend($e815fda779bc047b$var$anifn, {
    instanceString: function instanceString() {
        return 'animation';
    },
    hook: function hook() {
        var _p = this._private;
        if (!_p.hooked) {
            // add to target's animation queue
            var q;
            var tAni = _p.target._private.animation;
            if (_p.queue) q = tAni.queue;
            else q = tAni.current;
            q.push(this);
            // add to the animation loop pool
            if ($e815fda779bc047b$var$elementOrCollection(_p.target)) _p.target.cy().addToAnimationPool(_p.target);
            _p.hooked = true;
        }
        return this;
    },
    play: function play() {
        var _p = this._private;
        // autorewind
        if (_p.progress === 1) _p.progress = 0;
        _p.playing = true;
        _p.started = false; // needs to be started by animation loop
        _p.stopped = false;
        this.hook();
        // the animation loop will start the animation...
        return this;
    },
    playing: function playing() {
        return this._private.playing;
    },
    apply: function apply() {
        var _p = this._private;
        _p.applying = true;
        _p.started = false; // needs to be started by animation loop
        _p.stopped = false;
        this.hook();
        // the animation loop will apply the animation at this progress
        return this;
    },
    applying: function applying() {
        return this._private.applying;
    },
    pause: function pause() {
        var _p = this._private;
        _p.playing = false;
        _p.started = false;
        return this;
    },
    stop: function stop() {
        var _p = this._private;
        _p.playing = false;
        _p.started = false;
        _p.stopped = true; // to be removed from animation queues
        return this;
    },
    rewind: function rewind() {
        return this.progress(0);
    },
    fastforward: function fastforward() {
        return this.progress(1);
    },
    time: function time(t) {
        var _p = this._private;
        if (t === undefined) return _p.progress * _p.duration;
        else return this.progress(t / _p.duration);
    },
    progress: function progress(p) {
        var _p = this._private;
        var wasPlaying = _p.playing;
        if (p === undefined) return _p.progress;
        else {
            if (wasPlaying) this.pause();
            _p.progress = p;
            _p.started = false;
            if (wasPlaying) this.play();
        }
        return this;
    },
    completed: function completed() {
        return this._private.progress === 1;
    },
    reverse: function reverse() {
        var _p = this._private;
        var wasPlaying = _p.playing;
        if (wasPlaying) this.pause();
        _p.progress = 1 - _p.progress;
        _p.started = false;
        var swap = function swap(a, b) {
            var _pa = _p[a];
            if (_pa == null) return;
            _p[a] = _p[b];
            _p[b] = _pa;
        };
        swap('zoom', 'startZoom');
        swap('pan', 'startPan');
        swap('position', 'startPosition');
        // swap styles
        if (_p.style) for(var i = 0; i < _p.style.length; i++){
            var prop = _p.style[i];
            var name = prop.name;
            var startStyleProp = _p.startStyle[name];
            _p.startStyle[name] = prop;
            _p.style[i] = startStyleProp;
        }
        if (wasPlaying) this.play();
        return this;
    },
    promise: function promise(type) {
        var _p = this._private;
        var arr;
        switch(type){
            case 'frame':
                arr = _p.frames;
                break;
            default:
            case 'complete':
            case 'completed':
                arr = _p.completes;
        }
        return new $e815fda779bc047b$var$Promise$1(function(resolve, reject) {
            arr.push(function() {
                resolve();
            });
        });
    }
});
$e815fda779bc047b$var$anifn.complete = $e815fda779bc047b$var$anifn.completed;
$e815fda779bc047b$var$anifn.run = $e815fda779bc047b$var$anifn.play;
$e815fda779bc047b$var$anifn.running = $e815fda779bc047b$var$anifn.playing;
var $e815fda779bc047b$var$define$3 = {
    animated: function animated() {
        return function animatedImpl() {
            var self1 = this;
            var selfIsArrayLike = self1.length !== undefined;
            var all = selfIsArrayLike ? self1 : [
                self1
            ]; // put in array if not array-like
            var cy = this._private.cy || this;
            if (!cy.styleEnabled()) return false;
            var ele = all[0];
            if (ele) return ele._private.animation.current.length > 0;
        };
    },
    // animated
    clearQueue: function clearQueue() {
        return function clearQueueImpl() {
            var self1 = this;
            var selfIsArrayLike = self1.length !== undefined;
            var all = selfIsArrayLike ? self1 : [
                self1
            ]; // put in array if not array-like
            var cy = this._private.cy || this;
            if (!cy.styleEnabled()) return this;
            for(var i = 0; i < all.length; i++){
                var ele = all[i];
                ele._private.animation.queue = [];
            }
            return this;
        };
    },
    // clearQueue
    delay: function delay() {
        return function delayImpl(time, complete) {
            var cy = this._private.cy || this;
            if (!cy.styleEnabled()) return this;
            return this.animate({
                delay: time,
                duration: time,
                complete: complete
            });
        };
    },
    // delay
    delayAnimation: function delayAnimation() {
        return function delayAnimationImpl(time, complete) {
            var cy = this._private.cy || this;
            if (!cy.styleEnabled()) return this;
            return this.animation({
                delay: time,
                duration: time,
                complete: complete
            });
        };
    },
    // delay
    animation: function animation() {
        return function animationImpl(properties, params) {
            var self1 = this;
            var selfIsArrayLike = self1.length !== undefined;
            var all = selfIsArrayLike ? self1 : [
                self1
            ]; // put in array if not array-like
            var cy = this._private.cy || this;
            var isCore = !selfIsArrayLike;
            var isEles = !isCore;
            if (!cy.styleEnabled()) return this;
            var style = cy.style();
            properties = $e815fda779bc047b$var$extend({}, properties, params);
            var propertiesEmpty = Object.keys(properties).length === 0;
            if (propertiesEmpty) return new $e815fda779bc047b$var$Animation(all[0], properties); // nothing to animate
            if (properties.duration === undefined) properties.duration = 400;
            switch(properties.duration){
                case 'slow':
                    properties.duration = 600;
                    break;
                case 'fast':
                    properties.duration = 200;
                    break;
            }
            if (isEles) {
                properties.style = style.getPropsList(properties.style || properties.css);
                properties.css = undefined;
            }
            if (isEles && properties.renderedPosition != null) {
                var rpos = properties.renderedPosition;
                var pan = cy.pan();
                var zoom = cy.zoom();
                properties.position = $e815fda779bc047b$var$renderedToModelPosition(rpos, zoom, pan);
            }
            // override pan w/ panBy if set
            if (isCore && properties.panBy != null) {
                var panBy = properties.panBy;
                var cyPan = cy.pan();
                properties.pan = {
                    x: cyPan.x + panBy.x,
                    y: cyPan.y + panBy.y
                };
            }
            // override pan w/ center if set
            var center = properties.center || properties.centre;
            if (isCore && center != null) {
                var centerPan = cy.getCenterPan(center.eles, properties.zoom);
                if (centerPan != null) properties.pan = centerPan;
            }
            // override pan & zoom w/ fit if set
            if (isCore && properties.fit != null) {
                var fit = properties.fit;
                var fitVp = cy.getFitViewport(fit.eles || fit.boundingBox, fit.padding);
                if (fitVp != null) {
                    properties.pan = fitVp.pan;
                    properties.zoom = fitVp.zoom;
                }
            }
            // override zoom (& potentially pan) w/ zoom obj if set
            if (isCore && $e815fda779bc047b$var$plainObject(properties.zoom)) {
                var vp = cy.getZoomedViewport(properties.zoom);
                if (vp != null) {
                    if (vp.zoomed) properties.zoom = vp.zoom;
                    if (vp.panned) properties.pan = vp.pan;
                } else properties.zoom = null; // an inavalid zoom (e.g. no delta) gets automatically destroyed
            }
            return new $e815fda779bc047b$var$Animation(all[0], properties);
        };
    },
    // animate
    animate: function animate() {
        return function animateImpl(properties, params) {
            var self1 = this;
            var selfIsArrayLike = self1.length !== undefined;
            var all = selfIsArrayLike ? self1 : [
                self1
            ]; // put in array if not array-like
            var cy = this._private.cy || this;
            if (!cy.styleEnabled()) return this;
            if (params) properties = $e815fda779bc047b$var$extend({}, properties, params);
            // manually hook and run the animation
            for(var i = 0; i < all.length; i++){
                var ele = all[i];
                var queue = ele.animated() && (properties.queue === undefined || properties.queue);
                var ani = ele.animation(properties, queue ? {
                    queue: true
                } : undefined);
                ani.play();
            }
            return this; // chaining
        };
    },
    // animate
    stop: function stop() {
        return function stopImpl(clearQueue, jumpToEnd) {
            var self1 = this;
            var selfIsArrayLike = self1.length !== undefined;
            var all = selfIsArrayLike ? self1 : [
                self1
            ]; // put in array if not array-like
            var cy = this._private.cy || this;
            if (!cy.styleEnabled()) return this;
            for(var i = 0; i < all.length; i++){
                var ele = all[i];
                var _p = ele._private;
                var anis = _p.animation.current;
                for(var j = 0; j < anis.length; j++){
                    var ani = anis[j];
                    var ani_p = ani._private;
                    if (jumpToEnd) // next iteration of the animation loop, the animation
                    // will go straight to the end and be removed
                    ani_p.duration = 0;
                }
                // clear the queue of future animations
                if (clearQueue) _p.animation.queue = [];
                if (!jumpToEnd) _p.animation.current = [];
            }
            // we have to notify (the animation loop doesn't do it for us on `stop`)
            cy.notify('draw');
            return this;
        };
    } // stop
}; // define
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $e815fda779bc047b$var$isArray_1;
var $e815fda779bc047b$var$hasRequiredIsArray;
function $e815fda779bc047b$var$requireIsArray() {
    if ($e815fda779bc047b$var$hasRequiredIsArray) return $e815fda779bc047b$var$isArray_1;
    $e815fda779bc047b$var$hasRequiredIsArray = 1;
    var isArray = Array.isArray;
    $e815fda779bc047b$var$isArray_1 = isArray;
    return $e815fda779bc047b$var$isArray_1;
}
var $e815fda779bc047b$var$_isKey;
var $e815fda779bc047b$var$hasRequired_isKey;
function $e815fda779bc047b$var$require_isKey() {
    if ($e815fda779bc047b$var$hasRequired_isKey) return $e815fda779bc047b$var$_isKey;
    $e815fda779bc047b$var$hasRequired_isKey = 1;
    var isArray = $e815fda779bc047b$var$requireIsArray(), isSymbol = $e815fda779bc047b$var$requireIsSymbol();
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
    /**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */ function isKey(value, object) {
        if (isArray(value)) return false;
        var type = typeof value;
        if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
        return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
    }
    $e815fda779bc047b$var$_isKey = isKey;
    return $e815fda779bc047b$var$_isKey;
}
var $e815fda779bc047b$var$isFunction_1;
var $e815fda779bc047b$var$hasRequiredIsFunction;
function $e815fda779bc047b$var$requireIsFunction() {
    if ($e815fda779bc047b$var$hasRequiredIsFunction) return $e815fda779bc047b$var$isFunction_1;
    $e815fda779bc047b$var$hasRequiredIsFunction = 1;
    var baseGetTag = $e815fda779bc047b$var$require_baseGetTag(), isObject = $e815fda779bc047b$var$requireIsObject();
    /** `Object#toString` result references. */ var asyncTag = '[object AsyncFunction]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', proxyTag = '[object Proxy]';
    /**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */ function isFunction(value) {
        if (!isObject(value)) return false;
        // The use of `Object#toString` avoids issues with the `typeof` operator
        // in Safari 9 which returns 'object' for typed arrays and other constructors.
        var tag = baseGetTag(value);
        return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }
    $e815fda779bc047b$var$isFunction_1 = isFunction;
    return $e815fda779bc047b$var$isFunction_1;
}
var $e815fda779bc047b$var$_coreJsData;
var $e815fda779bc047b$var$hasRequired_coreJsData;
function $e815fda779bc047b$var$require_coreJsData() {
    if ($e815fda779bc047b$var$hasRequired_coreJsData) return $e815fda779bc047b$var$_coreJsData;
    $e815fda779bc047b$var$hasRequired_coreJsData = 1;
    var root = $e815fda779bc047b$var$require_root();
    /** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
    $e815fda779bc047b$var$_coreJsData = coreJsData;
    return $e815fda779bc047b$var$_coreJsData;
}
var $e815fda779bc047b$var$_isMasked;
var $e815fda779bc047b$var$hasRequired_isMasked;
function $e815fda779bc047b$var$require_isMasked() {
    if ($e815fda779bc047b$var$hasRequired_isMasked) return $e815fda779bc047b$var$_isMasked;
    $e815fda779bc047b$var$hasRequired_isMasked = 1;
    var coreJsData = $e815fda779bc047b$var$require_coreJsData();
    /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
        var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
        return uid ? 'Symbol(src)_1.' + uid : '';
    }();
    /**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */ function isMasked(func) {
        return !!maskSrcKey && maskSrcKey in func;
    }
    $e815fda779bc047b$var$_isMasked = isMasked;
    return $e815fda779bc047b$var$_isMasked;
}
/** Used for built-in method references. */ var $e815fda779bc047b$var$_toSource;
var $e815fda779bc047b$var$hasRequired_toSource;
function $e815fda779bc047b$var$require_toSource() {
    if ($e815fda779bc047b$var$hasRequired_toSource) return $e815fda779bc047b$var$_toSource;
    $e815fda779bc047b$var$hasRequired_toSource = 1;
    var funcProto = Function.prototype;
    /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
    /**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */ function toSource(func) {
        if (func != null) {
            try {
                return funcToString.call(func);
            } catch (e) {}
            try {
                return func + '';
            } catch (e) {}
        }
        return '';
    }
    $e815fda779bc047b$var$_toSource = toSource;
    return $e815fda779bc047b$var$_toSource;
}
var $e815fda779bc047b$var$_baseIsNative;
var $e815fda779bc047b$var$hasRequired_baseIsNative;
function $e815fda779bc047b$var$require_baseIsNative() {
    if ($e815fda779bc047b$var$hasRequired_baseIsNative) return $e815fda779bc047b$var$_baseIsNative;
    $e815fda779bc047b$var$hasRequired_baseIsNative = 1;
    var isFunction = $e815fda779bc047b$var$requireIsFunction(), isMasked = $e815fda779bc047b$var$require_isMasked(), isObject = $e815fda779bc047b$var$requireIsObject(), toSource = $e815fda779bc047b$var$require_toSource();
    /**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
    /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
    /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
    /** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
    /**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */ function baseIsNative(value) {
        if (!isObject(value) || isMasked(value)) return false;
        var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
        return pattern.test(toSource(value));
    }
    $e815fda779bc047b$var$_baseIsNative = baseIsNative;
    return $e815fda779bc047b$var$_baseIsNative;
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ var $e815fda779bc047b$var$_getValue;
var $e815fda779bc047b$var$hasRequired_getValue;
function $e815fda779bc047b$var$require_getValue() {
    if ($e815fda779bc047b$var$hasRequired_getValue) return $e815fda779bc047b$var$_getValue;
    $e815fda779bc047b$var$hasRequired_getValue = 1;
    function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    $e815fda779bc047b$var$_getValue = getValue;
    return $e815fda779bc047b$var$_getValue;
}
var $e815fda779bc047b$var$_getNative;
var $e815fda779bc047b$var$hasRequired_getNative;
function $e815fda779bc047b$var$require_getNative() {
    if ($e815fda779bc047b$var$hasRequired_getNative) return $e815fda779bc047b$var$_getNative;
    $e815fda779bc047b$var$hasRequired_getNative = 1;
    var baseIsNative = $e815fda779bc047b$var$require_baseIsNative(), getValue = $e815fda779bc047b$var$require_getValue();
    /**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */ function getNative(object, key) {
        var value = getValue(object, key);
        return baseIsNative(value) ? value : undefined;
    }
    $e815fda779bc047b$var$_getNative = getNative;
    return $e815fda779bc047b$var$_getNative;
}
var $e815fda779bc047b$var$_nativeCreate;
var $e815fda779bc047b$var$hasRequired_nativeCreate;
function $e815fda779bc047b$var$require_nativeCreate() {
    if ($e815fda779bc047b$var$hasRequired_nativeCreate) return $e815fda779bc047b$var$_nativeCreate;
    $e815fda779bc047b$var$hasRequired_nativeCreate = 1;
    var getNative = $e815fda779bc047b$var$require_getNative();
    /* Built-in method references that are verified to be native. */ var nativeCreate = getNative(Object, 'create');
    $e815fda779bc047b$var$_nativeCreate = nativeCreate;
    return $e815fda779bc047b$var$_nativeCreate;
}
var $e815fda779bc047b$var$_hashClear;
var $e815fda779bc047b$var$hasRequired_hashClear;
function $e815fda779bc047b$var$require_hashClear() {
    if ($e815fda779bc047b$var$hasRequired_hashClear) return $e815fda779bc047b$var$_hashClear;
    $e815fda779bc047b$var$hasRequired_hashClear = 1;
    var nativeCreate = $e815fda779bc047b$var$require_nativeCreate();
    /**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */ function hashClear() {
        this.__data__ = nativeCreate ? nativeCreate(null) : {};
        this.size = 0;
    }
    $e815fda779bc047b$var$_hashClear = hashClear;
    return $e815fda779bc047b$var$_hashClear;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ var $e815fda779bc047b$var$_hashDelete;
var $e815fda779bc047b$var$hasRequired_hashDelete;
function $e815fda779bc047b$var$require_hashDelete() {
    if ($e815fda779bc047b$var$hasRequired_hashDelete) return $e815fda779bc047b$var$_hashDelete;
    $e815fda779bc047b$var$hasRequired_hashDelete = 1;
    function hashDelete(key) {
        var result = this.has(key) && delete this.__data__[key];
        this.size -= result ? 1 : 0;
        return result;
    }
    $e815fda779bc047b$var$_hashDelete = hashDelete;
    return $e815fda779bc047b$var$_hashDelete;
}
var $e815fda779bc047b$var$_hashGet;
var $e815fda779bc047b$var$hasRequired_hashGet;
function $e815fda779bc047b$var$require_hashGet() {
    if ($e815fda779bc047b$var$hasRequired_hashGet) return $e815fda779bc047b$var$_hashGet;
    $e815fda779bc047b$var$hasRequired_hashGet = 1;
    var nativeCreate = $e815fda779bc047b$var$require_nativeCreate();
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used for built-in method references. */ var objectProto = Object.prototype;
    /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
    /**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */ function hashGet(key) {
        var data = this.__data__;
        if (nativeCreate) {
            var result = data[key];
            return result === HASH_UNDEFINED ? undefined : result;
        }
        return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }
    $e815fda779bc047b$var$_hashGet = hashGet;
    return $e815fda779bc047b$var$_hashGet;
}
var $e815fda779bc047b$var$_hashHas;
var $e815fda779bc047b$var$hasRequired_hashHas;
function $e815fda779bc047b$var$require_hashHas() {
    if ($e815fda779bc047b$var$hasRequired_hashHas) return $e815fda779bc047b$var$_hashHas;
    $e815fda779bc047b$var$hasRequired_hashHas = 1;
    var nativeCreate = $e815fda779bc047b$var$require_nativeCreate();
    /** Used for built-in method references. */ var objectProto = Object.prototype;
    /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
    /**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */ function hashHas(key) {
        var data = this.__data__;
        return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
    }
    $e815fda779bc047b$var$_hashHas = hashHas;
    return $e815fda779bc047b$var$_hashHas;
}
var $e815fda779bc047b$var$_hashSet;
var $e815fda779bc047b$var$hasRequired_hashSet;
function $e815fda779bc047b$var$require_hashSet() {
    if ($e815fda779bc047b$var$hasRequired_hashSet) return $e815fda779bc047b$var$_hashSet;
    $e815fda779bc047b$var$hasRequired_hashSet = 1;
    var nativeCreate = $e815fda779bc047b$var$require_nativeCreate();
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */ function hashSet(key, value) {
        var data = this.__data__;
        this.size += this.has(key) ? 0 : 1;
        data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
        return this;
    }
    $e815fda779bc047b$var$_hashSet = hashSet;
    return $e815fda779bc047b$var$_hashSet;
}
var $e815fda779bc047b$var$_Hash;
var $e815fda779bc047b$var$hasRequired_Hash;
function $e815fda779bc047b$var$require_Hash() {
    if ($e815fda779bc047b$var$hasRequired_Hash) return $e815fda779bc047b$var$_Hash;
    $e815fda779bc047b$var$hasRequired_Hash = 1;
    var hashClear = $e815fda779bc047b$var$require_hashClear(), hashDelete = $e815fda779bc047b$var$require_hashDelete(), hashGet = $e815fda779bc047b$var$require_hashGet(), hashHas = $e815fda779bc047b$var$require_hashHas(), hashSet = $e815fda779bc047b$var$require_hashSet();
    /**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */ function Hash(entries) {
        var index = -1, length = entries == null ? 0 : entries.length;
        this.clear();
        while(++index < length){
            var entry = entries[index];
            this.set(entry[0], entry[1]);
        }
    }
    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;
    $e815fda779bc047b$var$_Hash = Hash;
    return $e815fda779bc047b$var$_Hash;
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ var $e815fda779bc047b$var$_listCacheClear;
var $e815fda779bc047b$var$hasRequired_listCacheClear;
function $e815fda779bc047b$var$require_listCacheClear() {
    if ($e815fda779bc047b$var$hasRequired_listCacheClear) return $e815fda779bc047b$var$_listCacheClear;
    $e815fda779bc047b$var$hasRequired_listCacheClear = 1;
    function listCacheClear() {
        this.__data__ = [];
        this.size = 0;
    }
    $e815fda779bc047b$var$_listCacheClear = listCacheClear;
    return $e815fda779bc047b$var$_listCacheClear;
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ var $e815fda779bc047b$var$eq_1;
var $e815fda779bc047b$var$hasRequiredEq;
function $e815fda779bc047b$var$requireEq() {
    if ($e815fda779bc047b$var$hasRequiredEq) return $e815fda779bc047b$var$eq_1;
    $e815fda779bc047b$var$hasRequiredEq = 1;
    function eq(value, other) {
        return value === other || value !== value && other !== other;
    }
    $e815fda779bc047b$var$eq_1 = eq;
    return $e815fda779bc047b$var$eq_1;
}
var $e815fda779bc047b$var$_assocIndexOf;
var $e815fda779bc047b$var$hasRequired_assocIndexOf;
function $e815fda779bc047b$var$require_assocIndexOf() {
    if ($e815fda779bc047b$var$hasRequired_assocIndexOf) return $e815fda779bc047b$var$_assocIndexOf;
    $e815fda779bc047b$var$hasRequired_assocIndexOf = 1;
    var eq = $e815fda779bc047b$var$requireEq();
    /**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */ function assocIndexOf(array, key) {
        var length = array.length;
        while(length--){
            if (eq(array[length][0], key)) return length;
        }
        return -1;
    }
    $e815fda779bc047b$var$_assocIndexOf = assocIndexOf;
    return $e815fda779bc047b$var$_assocIndexOf;
}
var $e815fda779bc047b$var$_listCacheDelete;
var $e815fda779bc047b$var$hasRequired_listCacheDelete;
function $e815fda779bc047b$var$require_listCacheDelete() {
    if ($e815fda779bc047b$var$hasRequired_listCacheDelete) return $e815fda779bc047b$var$_listCacheDelete;
    $e815fda779bc047b$var$hasRequired_listCacheDelete = 1;
    var assocIndexOf = $e815fda779bc047b$var$require_assocIndexOf();
    /** Used for built-in method references. */ var arrayProto = Array.prototype;
    /** Built-in value references. */ var splice = arrayProto.splice;
    /**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */ function listCacheDelete(key) {
        var data = this.__data__, index = assocIndexOf(data, key);
        if (index < 0) return false;
        var lastIndex = data.length - 1;
        if (index == lastIndex) data.pop();
        else splice.call(data, index, 1);
        --this.size;
        return true;
    }
    $e815fda779bc047b$var$_listCacheDelete = listCacheDelete;
    return $e815fda779bc047b$var$_listCacheDelete;
}
var $e815fda779bc047b$var$_listCacheGet;
var $e815fda779bc047b$var$hasRequired_listCacheGet;
function $e815fda779bc047b$var$require_listCacheGet() {
    if ($e815fda779bc047b$var$hasRequired_listCacheGet) return $e815fda779bc047b$var$_listCacheGet;
    $e815fda779bc047b$var$hasRequired_listCacheGet = 1;
    var assocIndexOf = $e815fda779bc047b$var$require_assocIndexOf();
    /**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */ function listCacheGet(key) {
        var data = this.__data__, index = assocIndexOf(data, key);
        return index < 0 ? undefined : data[index][1];
    }
    $e815fda779bc047b$var$_listCacheGet = listCacheGet;
    return $e815fda779bc047b$var$_listCacheGet;
}
var $e815fda779bc047b$var$_listCacheHas;
var $e815fda779bc047b$var$hasRequired_listCacheHas;
function $e815fda779bc047b$var$require_listCacheHas() {
    if ($e815fda779bc047b$var$hasRequired_listCacheHas) return $e815fda779bc047b$var$_listCacheHas;
    $e815fda779bc047b$var$hasRequired_listCacheHas = 1;
    var assocIndexOf = $e815fda779bc047b$var$require_assocIndexOf();
    /**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */ function listCacheHas(key) {
        return assocIndexOf(this.__data__, key) > -1;
    }
    $e815fda779bc047b$var$_listCacheHas = listCacheHas;
    return $e815fda779bc047b$var$_listCacheHas;
}
var $e815fda779bc047b$var$_listCacheSet;
var $e815fda779bc047b$var$hasRequired_listCacheSet;
function $e815fda779bc047b$var$require_listCacheSet() {
    if ($e815fda779bc047b$var$hasRequired_listCacheSet) return $e815fda779bc047b$var$_listCacheSet;
    $e815fda779bc047b$var$hasRequired_listCacheSet = 1;
    var assocIndexOf = $e815fda779bc047b$var$require_assocIndexOf();
    /**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */ function listCacheSet(key, value) {
        var data = this.__data__, index = assocIndexOf(data, key);
        if (index < 0) {
            ++this.size;
            data.push([
                key,
                value
            ]);
        } else data[index][1] = value;
        return this;
    }
    $e815fda779bc047b$var$_listCacheSet = listCacheSet;
    return $e815fda779bc047b$var$_listCacheSet;
}
var $e815fda779bc047b$var$_ListCache;
var $e815fda779bc047b$var$hasRequired_ListCache;
function $e815fda779bc047b$var$require_ListCache() {
    if ($e815fda779bc047b$var$hasRequired_ListCache) return $e815fda779bc047b$var$_ListCache;
    $e815fda779bc047b$var$hasRequired_ListCache = 1;
    var listCacheClear = $e815fda779bc047b$var$require_listCacheClear(), listCacheDelete = $e815fda779bc047b$var$require_listCacheDelete(), listCacheGet = $e815fda779bc047b$var$require_listCacheGet(), listCacheHas = $e815fda779bc047b$var$require_listCacheHas(), listCacheSet = $e815fda779bc047b$var$require_listCacheSet();
    /**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */ function ListCache(entries) {
        var index = -1, length = entries == null ? 0 : entries.length;
        this.clear();
        while(++index < length){
            var entry = entries[index];
            this.set(entry[0], entry[1]);
        }
    }
    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;
    $e815fda779bc047b$var$_ListCache = ListCache;
    return $e815fda779bc047b$var$_ListCache;
}
var $e815fda779bc047b$var$_Map;
var $e815fda779bc047b$var$hasRequired_Map;
function $e815fda779bc047b$var$require_Map() {
    if ($e815fda779bc047b$var$hasRequired_Map) return $e815fda779bc047b$var$_Map;
    $e815fda779bc047b$var$hasRequired_Map = 1;
    var getNative = $e815fda779bc047b$var$require_getNative(), root = $e815fda779bc047b$var$require_root();
    /* Built-in method references that are verified to be native. */ var Map1 = getNative(root, 'Map');
    $e815fda779bc047b$var$_Map = Map1;
    return $e815fda779bc047b$var$_Map;
}
var $e815fda779bc047b$var$_mapCacheClear;
var $e815fda779bc047b$var$hasRequired_mapCacheClear;
function $e815fda779bc047b$var$require_mapCacheClear() {
    if ($e815fda779bc047b$var$hasRequired_mapCacheClear) return $e815fda779bc047b$var$_mapCacheClear;
    $e815fda779bc047b$var$hasRequired_mapCacheClear = 1;
    var Hash = $e815fda779bc047b$var$require_Hash(), ListCache = $e815fda779bc047b$var$require_ListCache(), Map1 = $e815fda779bc047b$var$require_Map();
    /**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */ function mapCacheClear() {
        this.size = 0;
        this.__data__ = {
            'hash': new Hash,
            'map': new (Map1 || ListCache),
            'string': new Hash
        };
    }
    $e815fda779bc047b$var$_mapCacheClear = mapCacheClear;
    return $e815fda779bc047b$var$_mapCacheClear;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ var $e815fda779bc047b$var$_isKeyable;
var $e815fda779bc047b$var$hasRequired_isKeyable;
function $e815fda779bc047b$var$require_isKeyable() {
    if ($e815fda779bc047b$var$hasRequired_isKeyable) return $e815fda779bc047b$var$_isKeyable;
    $e815fda779bc047b$var$hasRequired_isKeyable = 1;
    function isKeyable(value) {
        var type = typeof value;
        return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
    }
    $e815fda779bc047b$var$_isKeyable = isKeyable;
    return $e815fda779bc047b$var$_isKeyable;
}
var $e815fda779bc047b$var$_getMapData;
var $e815fda779bc047b$var$hasRequired_getMapData;
function $e815fda779bc047b$var$require_getMapData() {
    if ($e815fda779bc047b$var$hasRequired_getMapData) return $e815fda779bc047b$var$_getMapData;
    $e815fda779bc047b$var$hasRequired_getMapData = 1;
    var isKeyable = $e815fda779bc047b$var$require_isKeyable();
    /**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */ function getMapData(map, key) {
        var data = map.__data__;
        return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
    }
    $e815fda779bc047b$var$_getMapData = getMapData;
    return $e815fda779bc047b$var$_getMapData;
}
var $e815fda779bc047b$var$_mapCacheDelete;
var $e815fda779bc047b$var$hasRequired_mapCacheDelete;
function $e815fda779bc047b$var$require_mapCacheDelete() {
    if ($e815fda779bc047b$var$hasRequired_mapCacheDelete) return $e815fda779bc047b$var$_mapCacheDelete;
    $e815fda779bc047b$var$hasRequired_mapCacheDelete = 1;
    var getMapData = $e815fda779bc047b$var$require_getMapData();
    /**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */ function mapCacheDelete(key) {
        var result = getMapData(this, key)['delete'](key);
        this.size -= result ? 1 : 0;
        return result;
    }
    $e815fda779bc047b$var$_mapCacheDelete = mapCacheDelete;
    return $e815fda779bc047b$var$_mapCacheDelete;
}
var $e815fda779bc047b$var$_mapCacheGet;
var $e815fda779bc047b$var$hasRequired_mapCacheGet;
function $e815fda779bc047b$var$require_mapCacheGet() {
    if ($e815fda779bc047b$var$hasRequired_mapCacheGet) return $e815fda779bc047b$var$_mapCacheGet;
    $e815fda779bc047b$var$hasRequired_mapCacheGet = 1;
    var getMapData = $e815fda779bc047b$var$require_getMapData();
    /**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */ function mapCacheGet(key) {
        return getMapData(this, key).get(key);
    }
    $e815fda779bc047b$var$_mapCacheGet = mapCacheGet;
    return $e815fda779bc047b$var$_mapCacheGet;
}
var $e815fda779bc047b$var$_mapCacheHas;
var $e815fda779bc047b$var$hasRequired_mapCacheHas;
function $e815fda779bc047b$var$require_mapCacheHas() {
    if ($e815fda779bc047b$var$hasRequired_mapCacheHas) return $e815fda779bc047b$var$_mapCacheHas;
    $e815fda779bc047b$var$hasRequired_mapCacheHas = 1;
    var getMapData = $e815fda779bc047b$var$require_getMapData();
    /**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */ function mapCacheHas(key) {
        return getMapData(this, key).has(key);
    }
    $e815fda779bc047b$var$_mapCacheHas = mapCacheHas;
    return $e815fda779bc047b$var$_mapCacheHas;
}
var $e815fda779bc047b$var$_mapCacheSet;
var $e815fda779bc047b$var$hasRequired_mapCacheSet;
function $e815fda779bc047b$var$require_mapCacheSet() {
    if ($e815fda779bc047b$var$hasRequired_mapCacheSet) return $e815fda779bc047b$var$_mapCacheSet;
    $e815fda779bc047b$var$hasRequired_mapCacheSet = 1;
    var getMapData = $e815fda779bc047b$var$require_getMapData();
    /**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */ function mapCacheSet(key, value) {
        var data = getMapData(this, key), size = data.size;
        data.set(key, value);
        this.size += data.size == size ? 0 : 1;
        return this;
    }
    $e815fda779bc047b$var$_mapCacheSet = mapCacheSet;
    return $e815fda779bc047b$var$_mapCacheSet;
}
var $e815fda779bc047b$var$_MapCache;
var $e815fda779bc047b$var$hasRequired_MapCache;
function $e815fda779bc047b$var$require_MapCache() {
    if ($e815fda779bc047b$var$hasRequired_MapCache) return $e815fda779bc047b$var$_MapCache;
    $e815fda779bc047b$var$hasRequired_MapCache = 1;
    var mapCacheClear = $e815fda779bc047b$var$require_mapCacheClear(), mapCacheDelete = $e815fda779bc047b$var$require_mapCacheDelete(), mapCacheGet = $e815fda779bc047b$var$require_mapCacheGet(), mapCacheHas = $e815fda779bc047b$var$require_mapCacheHas(), mapCacheSet = $e815fda779bc047b$var$require_mapCacheSet();
    /**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */ function MapCache(entries) {
        var index = -1, length = entries == null ? 0 : entries.length;
        this.clear();
        while(++index < length){
            var entry = entries[index];
            this.set(entry[0], entry[1]);
        }
    }
    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;
    $e815fda779bc047b$var$_MapCache = MapCache;
    return $e815fda779bc047b$var$_MapCache;
}
var $e815fda779bc047b$var$memoize_1;
var $e815fda779bc047b$var$hasRequiredMemoize;
function $e815fda779bc047b$var$requireMemoize() {
    if ($e815fda779bc047b$var$hasRequiredMemoize) return $e815fda779bc047b$var$memoize_1;
    $e815fda779bc047b$var$hasRequiredMemoize = 1;
    var MapCache = $e815fda779bc047b$var$require_MapCache();
    /** Error message constants. */ var FUNC_ERROR_TEXT = 'Expected a function';
    /**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */ function memoize(func, resolver) {
        if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
        var memoized = function() {
            var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
            if (cache.has(key)) return cache.get(key);
            var result = func.apply(this, args);
            memoized.cache = cache.set(key, result) || cache;
            return result;
        };
        memoized.cache = new (memoize.Cache || MapCache);
        return memoized;
    }
    // Expose `MapCache`.
    memoize.Cache = MapCache;
    $e815fda779bc047b$var$memoize_1 = memoize;
    return $e815fda779bc047b$var$memoize_1;
}
var $e815fda779bc047b$var$_memoizeCapped;
var $e815fda779bc047b$var$hasRequired_memoizeCapped;
function $e815fda779bc047b$var$require_memoizeCapped() {
    if ($e815fda779bc047b$var$hasRequired_memoizeCapped) return $e815fda779bc047b$var$_memoizeCapped;
    $e815fda779bc047b$var$hasRequired_memoizeCapped = 1;
    var memoize = $e815fda779bc047b$var$requireMemoize();
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */ function memoizeCapped(func) {
        var result = memoize(func, function(key) {
            if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
            return key;
        });
        var cache = result.cache;
        return result;
    }
    $e815fda779bc047b$var$_memoizeCapped = memoizeCapped;
    return $e815fda779bc047b$var$_memoizeCapped;
}
var $e815fda779bc047b$var$_stringToPath;
var $e815fda779bc047b$var$hasRequired_stringToPath;
function $e815fda779bc047b$var$require_stringToPath() {
    if ($e815fda779bc047b$var$hasRequired_stringToPath) return $e815fda779bc047b$var$_stringToPath;
    $e815fda779bc047b$var$hasRequired_stringToPath = 1;
    var memoizeCapped = $e815fda779bc047b$var$require_memoizeCapped();
    /** Used to match property names within property paths. */ var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */ var stringToPath = memoizeCapped(function(string) {
        var result = [];
        if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
        string.replace(rePropName, function(match, number, quote, subString) {
            result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
        });
        return result;
    });
    $e815fda779bc047b$var$_stringToPath = stringToPath;
    return $e815fda779bc047b$var$_stringToPath;
}
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ var $e815fda779bc047b$var$_arrayMap;
var $e815fda779bc047b$var$hasRequired_arrayMap;
function $e815fda779bc047b$var$require_arrayMap() {
    if ($e815fda779bc047b$var$hasRequired_arrayMap) return $e815fda779bc047b$var$_arrayMap;
    $e815fda779bc047b$var$hasRequired_arrayMap = 1;
    function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    $e815fda779bc047b$var$_arrayMap = arrayMap;
    return $e815fda779bc047b$var$_arrayMap;
}
var $e815fda779bc047b$var$_baseToString;
var $e815fda779bc047b$var$hasRequired_baseToString;
function $e815fda779bc047b$var$require_baseToString() {
    if ($e815fda779bc047b$var$hasRequired_baseToString) return $e815fda779bc047b$var$_baseToString;
    $e815fda779bc047b$var$hasRequired_baseToString = 1;
    var Symbol1 = $e815fda779bc047b$var$require_Symbol(), arrayMap = $e815fda779bc047b$var$require_arrayMap(), isArray = $e815fda779bc047b$var$requireIsArray(), isSymbol = $e815fda779bc047b$var$requireIsSymbol();
    /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol1 ? Symbol1.prototype : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
    /**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */ function baseToString(value) {
        // Exit early for strings to avoid a performance hit in some environments.
        if (typeof value == 'string') return value;
        if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
        if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
        var result = value + '';
        return result == '0' && 1 / value == -Infinity ? '-0' : result;
    }
    $e815fda779bc047b$var$_baseToString = baseToString;
    return $e815fda779bc047b$var$_baseToString;
}
var $e815fda779bc047b$var$toString_1;
var $e815fda779bc047b$var$hasRequiredToString;
function $e815fda779bc047b$var$requireToString() {
    if ($e815fda779bc047b$var$hasRequiredToString) return $e815fda779bc047b$var$toString_1;
    $e815fda779bc047b$var$hasRequiredToString = 1;
    var baseToString = $e815fda779bc047b$var$require_baseToString();
    /**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */ function toString(value) {
        return value == null ? '' : baseToString(value);
    }
    $e815fda779bc047b$var$toString_1 = toString;
    return $e815fda779bc047b$var$toString_1;
}
var $e815fda779bc047b$var$_castPath;
var $e815fda779bc047b$var$hasRequired_castPath;
function $e815fda779bc047b$var$require_castPath() {
    if ($e815fda779bc047b$var$hasRequired_castPath) return $e815fda779bc047b$var$_castPath;
    $e815fda779bc047b$var$hasRequired_castPath = 1;
    var isArray = $e815fda779bc047b$var$requireIsArray(), isKey = $e815fda779bc047b$var$require_isKey(), stringToPath = $e815fda779bc047b$var$require_stringToPath(), toString = $e815fda779bc047b$var$requireToString();
    /**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */ function castPath(value, object) {
        if (isArray(value)) return value;
        return isKey(value, object) ? [
            value
        ] : stringToPath(toString(value));
    }
    $e815fda779bc047b$var$_castPath = castPath;
    return $e815fda779bc047b$var$_castPath;
}
var $e815fda779bc047b$var$_toKey;
var $e815fda779bc047b$var$hasRequired_toKey;
function $e815fda779bc047b$var$require_toKey() {
    if ($e815fda779bc047b$var$hasRequired_toKey) return $e815fda779bc047b$var$_toKey;
    $e815fda779bc047b$var$hasRequired_toKey = 1;
    var isSymbol = $e815fda779bc047b$var$requireIsSymbol();
    /**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */ function toKey(value) {
        if (typeof value == 'string' || isSymbol(value)) return value;
        var result = value + '';
        return result == '0' && 1 / value == -Infinity ? '-0' : result;
    }
    $e815fda779bc047b$var$_toKey = toKey;
    return $e815fda779bc047b$var$_toKey;
}
var $e815fda779bc047b$var$_baseGet;
var $e815fda779bc047b$var$hasRequired_baseGet;
function $e815fda779bc047b$var$require_baseGet() {
    if ($e815fda779bc047b$var$hasRequired_baseGet) return $e815fda779bc047b$var$_baseGet;
    $e815fda779bc047b$var$hasRequired_baseGet = 1;
    var castPath = $e815fda779bc047b$var$require_castPath(), toKey = $e815fda779bc047b$var$require_toKey();
    /**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */ function baseGet(object, path) {
        path = castPath(path, object);
        var index = 0, length = path.length;
        while(object != null && index < length)object = object[toKey(path[index++])];
        return index && index == length ? object : undefined;
    }
    $e815fda779bc047b$var$_baseGet = baseGet;
    return $e815fda779bc047b$var$_baseGet;
}
var $e815fda779bc047b$var$get_1;
var $e815fda779bc047b$var$hasRequiredGet;
function $e815fda779bc047b$var$requireGet() {
    if ($e815fda779bc047b$var$hasRequiredGet) return $e815fda779bc047b$var$get_1;
    $e815fda779bc047b$var$hasRequiredGet = 1;
    var baseGet = $e815fda779bc047b$var$require_baseGet();
    /**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */ function get(object, path, defaultValue) {
        var result = object == null ? undefined : baseGet(object, path);
        return result === undefined ? defaultValue : result;
    }
    $e815fda779bc047b$var$get_1 = get;
    return $e815fda779bc047b$var$get_1;
}
var $e815fda779bc047b$var$getExports = $e815fda779bc047b$var$requireGet();
var $e815fda779bc047b$var$get = /*@__PURE__*/ $e815fda779bc047b$var$getDefaultExportFromCjs($e815fda779bc047b$var$getExports);
var $e815fda779bc047b$var$_defineProperty;
var $e815fda779bc047b$var$hasRequired_defineProperty;
function $e815fda779bc047b$var$require_defineProperty() {
    if ($e815fda779bc047b$var$hasRequired_defineProperty) return $e815fda779bc047b$var$_defineProperty;
    $e815fda779bc047b$var$hasRequired_defineProperty = 1;
    var getNative = $e815fda779bc047b$var$require_getNative();
    var defineProperty = function() {
        try {
            var func = getNative(Object, 'defineProperty');
            func({}, '', {});
            return func;
        } catch (e) {}
    }();
    $e815fda779bc047b$var$_defineProperty = defineProperty;
    return $e815fda779bc047b$var$_defineProperty;
}
var $e815fda779bc047b$var$_baseAssignValue;
var $e815fda779bc047b$var$hasRequired_baseAssignValue;
function $e815fda779bc047b$var$require_baseAssignValue() {
    if ($e815fda779bc047b$var$hasRequired_baseAssignValue) return $e815fda779bc047b$var$_baseAssignValue;
    $e815fda779bc047b$var$hasRequired_baseAssignValue = 1;
    var defineProperty = $e815fda779bc047b$var$require_defineProperty();
    /**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */ function baseAssignValue(object, key, value) {
        if (key == '__proto__' && defineProperty) defineProperty(object, key, {
            'configurable': true,
            'enumerable': true,
            'value': value,
            'writable': true
        });
        else object[key] = value;
    }
    $e815fda779bc047b$var$_baseAssignValue = baseAssignValue;
    return $e815fda779bc047b$var$_baseAssignValue;
}
var $e815fda779bc047b$var$_assignValue;
var $e815fda779bc047b$var$hasRequired_assignValue;
function $e815fda779bc047b$var$require_assignValue() {
    if ($e815fda779bc047b$var$hasRequired_assignValue) return $e815fda779bc047b$var$_assignValue;
    $e815fda779bc047b$var$hasRequired_assignValue = 1;
    var baseAssignValue = $e815fda779bc047b$var$require_baseAssignValue(), eq = $e815fda779bc047b$var$requireEq();
    /** Used for built-in method references. */ var objectProto = Object.prototype;
    /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
    /**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */ function assignValue(object, key, value) {
        var objValue = object[key];
        if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
    }
    $e815fda779bc047b$var$_assignValue = assignValue;
    return $e815fda779bc047b$var$_assignValue;
}
/** Used as references for various `Number` constants. */ var $e815fda779bc047b$var$_isIndex;
var $e815fda779bc047b$var$hasRequired_isIndex;
function $e815fda779bc047b$var$require_isIndex() {
    if ($e815fda779bc047b$var$hasRequired_isIndex) return $e815fda779bc047b$var$_isIndex;
    $e815fda779bc047b$var$hasRequired_isIndex = 1;
    var MAX_SAFE_INTEGER = 9007199254740991;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */ function isIndex(value, length) {
        var type = typeof value;
        length = length == null ? MAX_SAFE_INTEGER : length;
        return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
    }
    $e815fda779bc047b$var$_isIndex = isIndex;
    return $e815fda779bc047b$var$_isIndex;
}
var $e815fda779bc047b$var$_baseSet;
var $e815fda779bc047b$var$hasRequired_baseSet;
function $e815fda779bc047b$var$require_baseSet() {
    if ($e815fda779bc047b$var$hasRequired_baseSet) return $e815fda779bc047b$var$_baseSet;
    $e815fda779bc047b$var$hasRequired_baseSet = 1;
    var assignValue = $e815fda779bc047b$var$require_assignValue(), castPath = $e815fda779bc047b$var$require_castPath(), isIndex = $e815fda779bc047b$var$require_isIndex(), isObject = $e815fda779bc047b$var$requireIsObject(), toKey = $e815fda779bc047b$var$require_toKey();
    /**
	 * The base implementation of `_.set`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @param {Function} [customizer] The function to customize path creation.
	 * @returns {Object} Returns `object`.
	 */ function baseSet(object, path, value, customizer) {
        if (!isObject(object)) return object;
        path = castPath(path, object);
        var index = -1, length = path.length, lastIndex = length - 1, nested = object;
        while(nested != null && ++index < length){
            var key = toKey(path[index]), newValue = value;
            if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
            if (index != lastIndex) {
                var objValue = nested[key];
                newValue = customizer ? customizer(objValue, key, nested) : undefined;
                if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
            }
            assignValue(nested, key, newValue);
            nested = nested[key];
        }
        return object;
    }
    $e815fda779bc047b$var$_baseSet = baseSet;
    return $e815fda779bc047b$var$_baseSet;
}
var $e815fda779bc047b$var$set_1;
var $e815fda779bc047b$var$hasRequiredSet;
function $e815fda779bc047b$var$requireSet() {
    if ($e815fda779bc047b$var$hasRequiredSet) return $e815fda779bc047b$var$set_1;
    $e815fda779bc047b$var$hasRequiredSet = 1;
    var baseSet = $e815fda779bc047b$var$require_baseSet();
    /**
	 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	 * it's created. Arrays are created for missing index properties while objects
	 * are created for all other missing properties. Use `_.setWith` to customize
	 * `path` creation.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.set(object, 'a[0].b.c', 4);
	 * console.log(object.a[0].b.c);
	 * // => 4
	 *
	 * _.set(object, ['x', '0', 'y', 'z'], 5);
	 * console.log(object.x[0].y.z);
	 * // => 5
	 */ function set(object, path, value) {
        return object == null ? object : baseSet(object, path, value);
    }
    $e815fda779bc047b$var$set_1 = set;
    return $e815fda779bc047b$var$set_1;
}
var $e815fda779bc047b$var$setExports = $e815fda779bc047b$var$requireSet();
var $e815fda779bc047b$var$set = /*@__PURE__*/ $e815fda779bc047b$var$getDefaultExportFromCjs($e815fda779bc047b$var$setExports);
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ var $e815fda779bc047b$var$_copyArray;
var $e815fda779bc047b$var$hasRequired_copyArray;
function $e815fda779bc047b$var$require_copyArray() {
    if ($e815fda779bc047b$var$hasRequired_copyArray) return $e815fda779bc047b$var$_copyArray;
    $e815fda779bc047b$var$hasRequired_copyArray = 1;
    function copyArray(source, array) {
        var index = -1, length = source.length;
        array || (array = Array(length));
        while(++index < length)array[index] = source[index];
        return array;
    }
    $e815fda779bc047b$var$_copyArray = copyArray;
    return $e815fda779bc047b$var$_copyArray;
}
var $e815fda779bc047b$var$toPath_1;
var $e815fda779bc047b$var$hasRequiredToPath;
function $e815fda779bc047b$var$requireToPath() {
    if ($e815fda779bc047b$var$hasRequiredToPath) return $e815fda779bc047b$var$toPath_1;
    $e815fda779bc047b$var$hasRequiredToPath = 1;
    var arrayMap = $e815fda779bc047b$var$require_arrayMap(), copyArray = $e815fda779bc047b$var$require_copyArray(), isArray = $e815fda779bc047b$var$requireIsArray(), isSymbol = $e815fda779bc047b$var$requireIsSymbol(), stringToPath = $e815fda779bc047b$var$require_stringToPath(), toKey = $e815fda779bc047b$var$require_toKey(), toString = $e815fda779bc047b$var$requireToString();
    /**
	 * Converts `value` to a property path array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Util
	 * @param {*} value The value to convert.
	 * @returns {Array} Returns the new property path array.
	 * @example
	 *
	 * _.toPath('a.b.c');
	 * // => ['a', 'b', 'c']
	 *
	 * _.toPath('a[0].b.c');
	 * // => ['a', '0', 'b', 'c']
	 */ function toPath(value) {
        if (isArray(value)) return arrayMap(value, toKey);
        return isSymbol(value) ? [
            value
        ] : copyArray(stringToPath(toString(value)));
    }
    $e815fda779bc047b$var$toPath_1 = toPath;
    return $e815fda779bc047b$var$toPath_1;
}
var $e815fda779bc047b$var$toPathExports = $e815fda779bc047b$var$requireToPath();
var $e815fda779bc047b$var$toPath = /*@__PURE__*/ $e815fda779bc047b$var$getDefaultExportFromCjs($e815fda779bc047b$var$toPathExports);
var $e815fda779bc047b$var$define$2 = {
    // access data field
    data: function data(params) {
        var defaults = {
            field: 'data',
            bindingEvent: 'data',
            allowBinding: false,
            allowSetting: false,
            allowGetting: false,
            settingEvent: 'data',
            settingTriggersEvent: false,
            triggerFnName: 'trigger',
            immutableKeys: {},
            // key => true if immutable
            updateStyle: false,
            beforeGet: function beforeGet(self1) {},
            beforeSet: function beforeSet(self1, obj) {},
            onSet: function onSet(self1) {},
            canSet: function canSet(self1) {
                return true;
            }
        };
        params = $e815fda779bc047b$var$extend({}, defaults, params);
        return function dataImpl(name, value) {
            var p = params;
            var self1 = this;
            var selfIsArrayLike = self1.length !== undefined;
            var all = selfIsArrayLike ? self1 : [
                self1
            ]; // put in array if not array-like
            var single = selfIsArrayLike ? self1[0] : self1;
            // .data('foo', ...)
            if ($e815fda779bc047b$var$string(name)) {
                // set or get property
                var isPathLike = name.indexOf('.') !== -1; // there might be a normal field with a dot 
                var path = isPathLike && $e815fda779bc047b$var$toPath(name);
                // .data('foo')
                if (p.allowGetting && value === undefined) {
                    // get
                    var ret;
                    if (single) {
                        p.beforeGet(single);
                        // check if it's path and a field with the same name doesn't exist
                        if (path && single._private[p.field][name] === undefined) ret = $e815fda779bc047b$var$get(single._private[p.field], path);
                        else ret = single._private[p.field][name];
                    }
                    return ret;
                // .data('foo', 'bar')
                } else if (p.allowSetting && value !== undefined) {
                    // set
                    var valid = !p.immutableKeys[name];
                    if (valid) {
                        var change = $e815fda779bc047b$var$_defineProperty$1({}, name, value);
                        p.beforeSet(self1, change);
                        for(var i = 0, l = all.length; i < l; i++){
                            var ele = all[i];
                            if (p.canSet(ele)) {
                                if (path && single._private[p.field][name] === undefined) $e815fda779bc047b$var$set(ele._private[p.field], path, value);
                                else ele._private[p.field][name] = value;
                            }
                        }
                        // update mappers if asked
                        if (p.updateStyle) self1.updateStyle();
                        // call onSet callback
                        p.onSet(self1);
                        if (p.settingTriggersEvent) self1[p.triggerFnName](p.settingEvent);
                    }
                }
            // .data({ 'foo': 'bar' })
            } else if (p.allowSetting && $e815fda779bc047b$var$plainObject(name)) {
                // extend
                var obj = name;
                var k, v;
                var keys = Object.keys(obj);
                p.beforeSet(self1, obj);
                for(var _i = 0; _i < keys.length; _i++){
                    k = keys[_i];
                    v = obj[k];
                    var _valid = !p.immutableKeys[k];
                    if (_valid) for(var j = 0; j < all.length; j++){
                        var _ele = all[j];
                        if (p.canSet(_ele)) _ele._private[p.field][k] = v;
                    }
                }
                // update mappers if asked
                if (p.updateStyle) self1.updateStyle();
                // call onSet callback
                p.onSet(self1);
                if (p.settingTriggersEvent) self1[p.triggerFnName](p.settingEvent);
            // .data(function(){ ... })
            } else if (p.allowBinding && $e815fda779bc047b$var$fn$6(name)) {
                // bind to event
                var fn = name;
                self1.on(p.bindingEvent, fn);
            // .data()
            } else if (p.allowGetting && name === undefined) {
                // get whole object
                var _ret;
                if (single) {
                    p.beforeGet(single);
                    _ret = single._private[p.field];
                }
                return _ret;
            }
            return self1; // maintain chainability
        }; // function
    },
    // data
    // remove data field
    removeData: function removeData(params) {
        var defaults = {
            field: 'data',
            event: 'data',
            triggerFnName: 'trigger',
            triggerEvent: false,
            immutableKeys: {} // key => true if immutable
        };
        params = $e815fda779bc047b$var$extend({}, defaults, params);
        return function removeDataImpl(names) {
            var p = params;
            var self1 = this;
            var selfIsArrayLike = self1.length !== undefined;
            var all = selfIsArrayLike ? self1 : [
                self1
            ]; // put in array if not array-like
            // .removeData('foo bar')
            if ($e815fda779bc047b$var$string(names)) {
                // then get the list of keys, and delete them
                var keys = names.split(/\s+/);
                var l = keys.length;
                for(var i = 0; i < l; i++){
                    // delete each non-empty key
                    var key = keys[i];
                    if ($e815fda779bc047b$var$emptyString(key)) continue;
                    var valid = !p.immutableKeys[key]; // not valid if immutable
                    if (valid) for(var i_a = 0, l_a = all.length; i_a < l_a; i_a++)all[i_a]._private[p.field][key] = undefined;
                }
                if (p.triggerEvent) self1[p.triggerFnName](p.event);
            // .removeData()
            } else if (names === undefined) {
                // then delete all keys
                for(var _i_a = 0, _l_a = all.length; _i_a < _l_a; _i_a++){
                    var _privateFields = all[_i_a]._private[p.field];
                    var _keys = Object.keys(_privateFields);
                    for(var _i2 = 0; _i2 < _keys.length; _i2++){
                        var _key = _keys[_i2];
                        var validKeyToDelete = !p.immutableKeys[_key];
                        if (validKeyToDelete) _privateFields[_key] = undefined;
                    }
                }
                if (p.triggerEvent) self1[p.triggerFnName](p.event);
            }
            return self1; // maintain chaining
        }; // function
    } // removeData
}; // define
var $e815fda779bc047b$var$define$1 = {
    eventAliasesOn: function eventAliasesOn(proto) {
        var p = proto;
        p.addListener = p.listen = p.bind = p.on;
        p.unlisten = p.unbind = p.off = p.removeListener;
        p.trigger = p.emit;
        // this is just a wrapper alias of .on()
        p.pon = p.promiseOn = function(events, selector) {
            var self1 = this;
            var args = Array.prototype.slice.call(arguments, 0);
            return new $e815fda779bc047b$var$Promise$1(function(resolve, reject) {
                var callback = function callback(e) {
                    self1.off.apply(self1, offArgs);
                    resolve(e);
                };
                var onArgs = args.concat([
                    callback
                ]);
                var offArgs = onArgs.concat([]);
                self1.on.apply(self1, onArgs);
            });
        };
    }
}; // define
// use this module to cherry pick functions into your prototype
// (useful for functions shared between the core and collections, for example)
var $e815fda779bc047b$var$define = {};
[
    $e815fda779bc047b$var$define$3,
    $e815fda779bc047b$var$define$2,
    $e815fda779bc047b$var$define$1
].forEach(function(m1) {
    $e815fda779bc047b$var$extend($e815fda779bc047b$var$define, m1);
});
var $e815fda779bc047b$var$elesfn$i = {
    animate: $e815fda779bc047b$var$define.animate(),
    animation: $e815fda779bc047b$var$define.animation(),
    animated: $e815fda779bc047b$var$define.animated(),
    clearQueue: $e815fda779bc047b$var$define.clearQueue(),
    delay: $e815fda779bc047b$var$define.delay(),
    delayAnimation: $e815fda779bc047b$var$define.delayAnimation(),
    stop: $e815fda779bc047b$var$define.stop()
};
var $e815fda779bc047b$var$elesfn$h = {
    classes: function classes(_classes) {
        var self1 = this;
        if (_classes === undefined) {
            var ret = [];
            self1[0]._private.classes.forEach(function(cls) {
                return ret.push(cls);
            });
            return ret;
        } else if (!$e815fda779bc047b$var$array(_classes)) // extract classes from string
        _classes = (_classes || '').match(/\S+/g) || [];
        var changed = [];
        var classesSet = new $e815fda779bc047b$var$Set$1(_classes);
        // check and update each ele
        for(var j = 0; j < self1.length; j++){
            var ele = self1[j];
            var _p = ele._private;
            var eleClasses = _p.classes;
            var changedEle = false;
            // check if ele has all of the passed classes
            for(var i = 0; i < _classes.length; i++){
                var cls = _classes[i];
                var eleHasClass = eleClasses.has(cls);
                if (!eleHasClass) {
                    changedEle = true;
                    break;
                }
            }
            // check if ele has classes outside of those passed
            if (!changedEle) changedEle = eleClasses.size !== _classes.length;
            if (changedEle) {
                _p.classes = classesSet;
                changed.push(ele);
            }
        }
        // trigger update style on those eles that had class changes
        if (changed.length > 0) this.spawn(changed).updateStyle().emit('class');
        return self1;
    },
    addClass: function addClass(classes) {
        return this.toggleClass(classes, true);
    },
    hasClass: function hasClass(className) {
        var ele = this[0];
        return ele != null && ele._private.classes.has(className);
    },
    toggleClass: function toggleClass(classes, toggle) {
        if (!$e815fda779bc047b$var$array(classes)) // extract classes from string
        classes = classes.match(/\S+/g) || [];
        var self1 = this;
        var toggleUndefd = toggle === undefined;
        var changed = []; // eles who had classes changed
        for(var i = 0, il = self1.length; i < il; i++){
            var ele = self1[i];
            var eleClasses = ele._private.classes;
            var changedEle = false;
            for(var j = 0; j < classes.length; j++){
                var cls = classes[j];
                var hasClass = eleClasses.has(cls);
                var changedNow = false;
                if (toggle || toggleUndefd && !hasClass) {
                    eleClasses.add(cls);
                    changedNow = true;
                } else if (!toggle || toggleUndefd && hasClass) {
                    eleClasses["delete"](cls);
                    changedNow = true;
                }
                if (!changedEle && changedNow) {
                    changed.push(ele);
                    changedEle = true;
                }
            } // for j classes
        } // for i eles
        // trigger update style on those eles that had class changes
        if (changed.length > 0) this.spawn(changed).updateStyle().emit('class');
        return self1;
    },
    removeClass: function removeClass(classes) {
        return this.toggleClass(classes, false);
    },
    flashClass: function flashClass(classes, duration) {
        var self1 = this;
        if (duration == null) duration = 250;
        else if (duration === 0) return self1; // nothing to do really
        self1.addClass(classes);
        setTimeout(function() {
            self1.removeClass(classes);
        }, duration);
        return self1;
    }
};
$e815fda779bc047b$var$elesfn$h.className = $e815fda779bc047b$var$elesfn$h.classNames = $e815fda779bc047b$var$elesfn$h.classes;
// tokens in the query language
var $e815fda779bc047b$var$tokens = {
    metaChar: '[\\!\\"\\#\\$\\%\\&\\\'\\(\\)\\*\\+\\,\\.\\/\\:\\;\\<\\=\\>\\?\\@\\[\\]\\^\\`\\{\\|\\}\\~]',
    // chars we need to escape in let names, etc
    comparatorOp: '=|\\!=|>|>=|<|<=|\\$=|\\^=|\\*=',
    // binary comparison op (used in data selectors)
    boolOp: '\\?|\\!|\\^',
    // boolean (unary) operators (used in data selectors)
    string: "\"(?:\\\\\"|[^\"])*\"|'(?:\\\\'|[^'])*'",
    // string literals (used in data selectors) -- doublequotes | singlequotes
    number: $e815fda779bc047b$var$number,
    // number literal (used in data selectors) --- e.g. 0.1234, 1234, 12e123
    meta: 'degree|indegree|outdegree',
    // allowed metadata fields (i.e. allowed functions to use from Collection)
    separator: '\\s*,\\s*',
    // queries are separated by commas, e.g. edge[foo = 'bar'], node.someClass
    descendant: '\\s+',
    child: '\\s+>\\s+',
    subject: '\\$',
    group: 'node|edge|\\*',
    directedEdge: '\\s+->\\s+',
    undirectedEdge: '\\s+<->\\s+'
};
$e815fda779bc047b$var$tokens.variable = '(?:[\\w-.]|(?:\\\\' + $e815fda779bc047b$var$tokens.metaChar + '))+'; // a variable name can have letters, numbers, dashes, and periods
$e815fda779bc047b$var$tokens.className = '(?:[\\w-]|(?:\\\\' + $e815fda779bc047b$var$tokens.metaChar + '))+'; // a class name has the same rules as a variable except it can't have a '.' in the name
$e815fda779bc047b$var$tokens.value = $e815fda779bc047b$var$tokens.string + '|' + $e815fda779bc047b$var$tokens.number; // a value literal, either a string or number
$e815fda779bc047b$var$tokens.id = $e815fda779bc047b$var$tokens.variable; // an element id (follows variable conventions)
(function() {
    var ops, op, i;
    // add @ variants to comparatorOp
    ops = $e815fda779bc047b$var$tokens.comparatorOp.split('|');
    for(i = 0; i < ops.length; i++){
        op = ops[i];
        $e815fda779bc047b$var$tokens.comparatorOp += '|@' + op;
    }
    // add ! variants to comparatorOp
    ops = $e815fda779bc047b$var$tokens.comparatorOp.split('|');
    for(i = 0; i < ops.length; i++){
        op = ops[i];
        if (op.indexOf('!') >= 0) continue;
         // skip ops that explicitly contain !
        if (op === '=') continue;
         // skip = b/c != is explicitly defined
        $e815fda779bc047b$var$tokens.comparatorOp += '|\\!' + op;
    }
})();
/**
 * Make a new query object
 *
 * @prop type {Type} The type enum (int) of the query
 * @prop checks List of checks to make against an ele to test for a match
 */ var $e815fda779bc047b$var$newQuery = function newQuery() {
    return {
        checks: []
    };
};
/**
 * A check type enum-like object.  Uses integer values for fast match() lookup.
 * The ordering does not matter as long as the ints are unique.
 */ var $e815fda779bc047b$var$Type = {
    /** E.g. node */ GROUP: 0,
    /** A collection of elements */ COLLECTION: 1,
    /** A filter(ele) function */ FILTER: 2,
    /** E.g. [foo > 1] */ DATA_COMPARE: 3,
    /** E.g. [foo] */ DATA_EXIST: 4,
    /** E.g. [?foo] */ DATA_BOOL: 5,
    /** E.g. [[degree > 2]] */ META_COMPARE: 6,
    /** E.g. :selected */ STATE: 7,
    /** E.g. #foo */ ID: 8,
    /** E.g. .foo */ CLASS: 9,
    /** E.g. #foo <-> #bar */ UNDIRECTED_EDGE: 10,
    /** E.g. #foo -> #bar */ DIRECTED_EDGE: 11,
    /** E.g. $#foo -> #bar */ NODE_SOURCE: 12,
    /** E.g. #foo -> $#bar */ NODE_TARGET: 13,
    /** E.g. $#foo <-> #bar */ NODE_NEIGHBOR: 14,
    /** E.g. #foo > #bar */ CHILD: 15,
    /** E.g. #foo #bar */ DESCENDANT: 16,
    /** E.g. $#foo > #bar */ PARENT: 17,
    /** E.g. $#foo #bar */ ANCESTOR: 18,
    /** E.g. #foo > $bar > #baz */ COMPOUND_SPLIT: 19,
    /** Always matches, useful placeholder for subject in `COMPOUND_SPLIT` */ TRUE: 20
};
var $e815fda779bc047b$var$stateSelectors = [
    {
        selector: ':selected',
        matches: function matches(ele) {
            return ele.selected();
        }
    },
    {
        selector: ':unselected',
        matches: function matches(ele) {
            return !ele.selected();
        }
    },
    {
        selector: ':selectable',
        matches: function matches(ele) {
            return ele.selectable();
        }
    },
    {
        selector: ':unselectable',
        matches: function matches(ele) {
            return !ele.selectable();
        }
    },
    {
        selector: ':locked',
        matches: function matches(ele) {
            return ele.locked();
        }
    },
    {
        selector: ':unlocked',
        matches: function matches(ele) {
            return !ele.locked();
        }
    },
    {
        selector: ':visible',
        matches: function matches(ele) {
            return ele.visible();
        }
    },
    {
        selector: ':hidden',
        matches: function matches(ele) {
            return !ele.visible();
        }
    },
    {
        selector: ':transparent',
        matches: function matches(ele) {
            return ele.transparent();
        }
    },
    {
        selector: ':grabbed',
        matches: function matches(ele) {
            return ele.grabbed();
        }
    },
    {
        selector: ':free',
        matches: function matches(ele) {
            return !ele.grabbed();
        }
    },
    {
        selector: ':removed',
        matches: function matches(ele) {
            return ele.removed();
        }
    },
    {
        selector: ':inside',
        matches: function matches(ele) {
            return !ele.removed();
        }
    },
    {
        selector: ':grabbable',
        matches: function matches(ele) {
            return ele.grabbable();
        }
    },
    {
        selector: ':ungrabbable',
        matches: function matches(ele) {
            return !ele.grabbable();
        }
    },
    {
        selector: ':animated',
        matches: function matches(ele) {
            return ele.animated();
        }
    },
    {
        selector: ':unanimated',
        matches: function matches(ele) {
            return !ele.animated();
        }
    },
    {
        selector: ':parent',
        matches: function matches(ele) {
            return ele.isParent();
        }
    },
    {
        selector: ':childless',
        matches: function matches(ele) {
            return ele.isChildless();
        }
    },
    {
        selector: ':child',
        matches: function matches(ele) {
            return ele.isChild();
        }
    },
    {
        selector: ':orphan',
        matches: function matches(ele) {
            return ele.isOrphan();
        }
    },
    {
        selector: ':nonorphan',
        matches: function matches(ele) {
            return ele.isChild();
        }
    },
    {
        selector: ':compound',
        matches: function matches(ele) {
            if (ele.isNode()) return ele.isParent();
            else return ele.source().isParent() || ele.target().isParent();
        }
    },
    {
        selector: ':loop',
        matches: function matches(ele) {
            return ele.isLoop();
        }
    },
    {
        selector: ':simple',
        matches: function matches(ele) {
            return ele.isSimple();
        }
    },
    {
        selector: ':active',
        matches: function matches(ele) {
            return ele.active();
        }
    },
    {
        selector: ':inactive',
        matches: function matches(ele) {
            return !ele.active();
        }
    },
    {
        selector: ':backgrounding',
        matches: function matches(ele) {
            return ele.backgrounding();
        }
    },
    {
        selector: ':nonbackgrounding',
        matches: function matches(ele) {
            return !ele.backgrounding();
        }
    }
].sort(function(a, b) {
    // n.b. selectors that are starting substrings of others must have the longer ones first
    return $e815fda779bc047b$var$descending(a.selector, b.selector);
});
var $e815fda779bc047b$var$lookup = function() {
    var selToFn = {};
    var s;
    for(var i = 0; i < $e815fda779bc047b$var$stateSelectors.length; i++){
        s = $e815fda779bc047b$var$stateSelectors[i];
        selToFn[s.selector] = s.matches;
    }
    return selToFn;
}();
var $e815fda779bc047b$var$stateSelectorMatches = function stateSelectorMatches(sel, ele) {
    return $e815fda779bc047b$var$lookup[sel](ele);
};
var $e815fda779bc047b$var$stateSelectorRegex = '(' + $e815fda779bc047b$var$stateSelectors.map(function(s) {
    return s.selector;
}).join('|') + ')';
// when a token like a variable has escaped meta characters, we need to clean the backslashes out
// so that values get compared properly in Selector.filter()
var $e815fda779bc047b$var$cleanMetaChars = function cleanMetaChars(str) {
    return str.replace(new RegExp('\\\\(' + $e815fda779bc047b$var$tokens.metaChar + ')', 'g'), function(match, $1) {
        return $1;
    });
};
var $e815fda779bc047b$var$replaceLastQuery = function replaceLastQuery(selector, examiningQuery, replacementQuery) {
    selector[selector.length - 1] = replacementQuery;
};
// NOTE: add new expression syntax here to have it recognised by the parser;
// - a query contains all adjacent (i.e. no separator in between) expressions;
// - the current query is stored in selector[i]
// - you need to check the query objects in match() for it actually filter properly, but that's pretty straight forward
var $e815fda779bc047b$var$exprs = [
    {
        name: 'group',
        // just used for identifying when debugging
        query: true,
        regex: '(' + $e815fda779bc047b$var$tokens.group + ')',
        populate: function populate(selector, query, _ref) {
            var _ref2 = $e815fda779bc047b$var$_slicedToArray(_ref, 1), group = _ref2[0];
            query.checks.push({
                type: $e815fda779bc047b$var$Type.GROUP,
                value: group === '*' ? group : group + 's'
            });
        }
    },
    {
        name: 'state',
        query: true,
        regex: $e815fda779bc047b$var$stateSelectorRegex,
        populate: function populate(selector, query, _ref3) {
            var _ref4 = $e815fda779bc047b$var$_slicedToArray(_ref3, 1), state = _ref4[0];
            query.checks.push({
                type: $e815fda779bc047b$var$Type.STATE,
                value: state
            });
        }
    },
    {
        name: 'id',
        query: true,
        regex: '\\#(' + $e815fda779bc047b$var$tokens.id + ')',
        populate: function populate(selector, query, _ref5) {
            var _ref6 = $e815fda779bc047b$var$_slicedToArray(_ref5, 1), id = _ref6[0];
            query.checks.push({
                type: $e815fda779bc047b$var$Type.ID,
                value: $e815fda779bc047b$var$cleanMetaChars(id)
            });
        }
    },
    {
        name: 'className',
        query: true,
        regex: '\\.(' + $e815fda779bc047b$var$tokens.className + ')',
        populate: function populate(selector, query, _ref7) {
            var _ref8 = $e815fda779bc047b$var$_slicedToArray(_ref7, 1), className = _ref8[0];
            query.checks.push({
                type: $e815fda779bc047b$var$Type.CLASS,
                value: $e815fda779bc047b$var$cleanMetaChars(className)
            });
        }
    },
    {
        name: 'dataExists',
        query: true,
        regex: '\\[\\s*(' + $e815fda779bc047b$var$tokens.variable + ')\\s*\\]',
        populate: function populate(selector, query, _ref9) {
            var _ref10 = $e815fda779bc047b$var$_slicedToArray(_ref9, 1), variable = _ref10[0];
            query.checks.push({
                type: $e815fda779bc047b$var$Type.DATA_EXIST,
                field: $e815fda779bc047b$var$cleanMetaChars(variable)
            });
        }
    },
    {
        name: 'dataCompare',
        query: true,
        regex: '\\[\\s*(' + $e815fda779bc047b$var$tokens.variable + ')\\s*(' + $e815fda779bc047b$var$tokens.comparatorOp + ')\\s*(' + $e815fda779bc047b$var$tokens.value + ')\\s*\\]',
        populate: function populate(selector, query, _ref11) {
            var _ref12 = $e815fda779bc047b$var$_slicedToArray(_ref11, 3), variable = _ref12[0], comparatorOp = _ref12[1], value = _ref12[2];
            var valueIsString = new RegExp('^' + $e815fda779bc047b$var$tokens.string + '$').exec(value) != null;
            if (valueIsString) value = value.substring(1, value.length - 1);
            else value = parseFloat(value);
            query.checks.push({
                type: $e815fda779bc047b$var$Type.DATA_COMPARE,
                field: $e815fda779bc047b$var$cleanMetaChars(variable),
                operator: comparatorOp,
                value: value
            });
        }
    },
    {
        name: 'dataBool',
        query: true,
        regex: '\\[\\s*(' + $e815fda779bc047b$var$tokens.boolOp + ')\\s*(' + $e815fda779bc047b$var$tokens.variable + ')\\s*\\]',
        populate: function populate(selector, query, _ref13) {
            var _ref14 = $e815fda779bc047b$var$_slicedToArray(_ref13, 2), boolOp = _ref14[0], variable = _ref14[1];
            query.checks.push({
                type: $e815fda779bc047b$var$Type.DATA_BOOL,
                field: $e815fda779bc047b$var$cleanMetaChars(variable),
                operator: boolOp
            });
        }
    },
    {
        name: 'metaCompare',
        query: true,
        regex: '\\[\\[\\s*(' + $e815fda779bc047b$var$tokens.meta + ')\\s*(' + $e815fda779bc047b$var$tokens.comparatorOp + ')\\s*(' + $e815fda779bc047b$var$tokens.number + ')\\s*\\]\\]',
        populate: function populate(selector, query, _ref15) {
            var _ref16 = $e815fda779bc047b$var$_slicedToArray(_ref15, 3), meta = _ref16[0], comparatorOp = _ref16[1], number = _ref16[2];
            query.checks.push({
                type: $e815fda779bc047b$var$Type.META_COMPARE,
                field: $e815fda779bc047b$var$cleanMetaChars(meta),
                operator: comparatorOp,
                value: parseFloat(number)
            });
        }
    },
    {
        name: 'nextQuery',
        separator: true,
        regex: $e815fda779bc047b$var$tokens.separator,
        populate: function populate(selector, query) {
            var currentSubject = selector.currentSubject;
            var edgeCount = selector.edgeCount;
            var compoundCount = selector.compoundCount;
            var lastQ = selector[selector.length - 1];
            if (currentSubject != null) {
                lastQ.subject = currentSubject;
                selector.currentSubject = null;
            }
            lastQ.edgeCount = edgeCount;
            lastQ.compoundCount = compoundCount;
            selector.edgeCount = 0;
            selector.compoundCount = 0;
            // go on to next query
            var nextQuery = selector[selector.length++] = $e815fda779bc047b$var$newQuery();
            return nextQuery; // this is the new query to be filled by the following exprs
        }
    },
    {
        name: 'directedEdge',
        separator: true,
        regex: $e815fda779bc047b$var$tokens.directedEdge,
        populate: function populate(selector, query) {
            if (selector.currentSubject == null) {
                // undirected edge
                var edgeQuery = $e815fda779bc047b$var$newQuery();
                var source = query;
                var target = $e815fda779bc047b$var$newQuery();
                edgeQuery.checks.push({
                    type: $e815fda779bc047b$var$Type.DIRECTED_EDGE,
                    source: source,
                    target: target
                });
                // the query in the selector should be the edge rather than the source
                $e815fda779bc047b$var$replaceLastQuery(selector, query, edgeQuery);
                selector.edgeCount++;
                // we're now populating the target query with expressions that follow
                return target;
            } else {
                // source/target
                var srcTgtQ = $e815fda779bc047b$var$newQuery();
                var _source = query;
                var _target = $e815fda779bc047b$var$newQuery();
                srcTgtQ.checks.push({
                    type: $e815fda779bc047b$var$Type.NODE_SOURCE,
                    source: _source,
                    target: _target
                });
                // the query in the selector should be the neighbourhood rather than the node
                $e815fda779bc047b$var$replaceLastQuery(selector, query, srcTgtQ);
                selector.edgeCount++;
                return _target; // now populating the target with the following expressions
            }
        }
    },
    {
        name: 'undirectedEdge',
        separator: true,
        regex: $e815fda779bc047b$var$tokens.undirectedEdge,
        populate: function populate(selector, query) {
            if (selector.currentSubject == null) {
                // undirected edge
                var edgeQuery = $e815fda779bc047b$var$newQuery();
                var source = query;
                var target = $e815fda779bc047b$var$newQuery();
                edgeQuery.checks.push({
                    type: $e815fda779bc047b$var$Type.UNDIRECTED_EDGE,
                    nodes: [
                        source,
                        target
                    ]
                });
                // the query in the selector should be the edge rather than the source
                $e815fda779bc047b$var$replaceLastQuery(selector, query, edgeQuery);
                selector.edgeCount++;
                // we're now populating the target query with expressions that follow
                return target;
            } else {
                // neighbourhood
                var nhoodQ = $e815fda779bc047b$var$newQuery();
                var node = query;
                var neighbor = $e815fda779bc047b$var$newQuery();
                nhoodQ.checks.push({
                    type: $e815fda779bc047b$var$Type.NODE_NEIGHBOR,
                    node: node,
                    neighbor: neighbor
                });
                // the query in the selector should be the neighbourhood rather than the node
                $e815fda779bc047b$var$replaceLastQuery(selector, query, nhoodQ);
                return neighbor; // now populating the neighbor with following expressions
            }
        }
    },
    {
        name: 'child',
        separator: true,
        regex: $e815fda779bc047b$var$tokens.child,
        populate: function populate(selector, query) {
            if (selector.currentSubject == null) {
                // default: child query
                var parentChildQuery = $e815fda779bc047b$var$newQuery();
                var child = $e815fda779bc047b$var$newQuery();
                var parent = selector[selector.length - 1];
                parentChildQuery.checks.push({
                    type: $e815fda779bc047b$var$Type.CHILD,
                    parent: parent,
                    child: child
                });
                // the query in the selector should be the '>' itself
                $e815fda779bc047b$var$replaceLastQuery(selector, query, parentChildQuery);
                selector.compoundCount++;
                // we're now populating the child query with expressions that follow
                return child;
            } else if (selector.currentSubject === query) {
                // compound split query
                var compound = $e815fda779bc047b$var$newQuery();
                var left = selector[selector.length - 1];
                var right = $e815fda779bc047b$var$newQuery();
                var subject = $e815fda779bc047b$var$newQuery();
                var _child = $e815fda779bc047b$var$newQuery();
                var _parent = $e815fda779bc047b$var$newQuery();
                // set up the root compound q
                compound.checks.push({
                    type: $e815fda779bc047b$var$Type.COMPOUND_SPLIT,
                    left: left,
                    right: right,
                    subject: subject
                });
                // populate the subject and replace the q at the old spot (within left) with TRUE
                subject.checks = query.checks; // take the checks from the left
                query.checks = [
                    {
                        type: $e815fda779bc047b$var$Type.TRUE
                    }
                ]; // checks under left refs the subject implicitly
                // set up the right q
                _parent.checks.push({
                    type: $e815fda779bc047b$var$Type.TRUE
                }); // parent implicitly refs the subject
                right.checks.push({
                    type: $e815fda779bc047b$var$Type.PARENT,
                    // type is swapped on right side queries
                    parent: _parent,
                    child: _child // empty for now
                });
                $e815fda779bc047b$var$replaceLastQuery(selector, left, compound);
                // update the ref since we moved things around for `query`
                selector.currentSubject = subject;
                selector.compoundCount++;
                return _child; // now populating the right side's child
            } else {
                // parent query
                // info for parent query
                var _parent2 = $e815fda779bc047b$var$newQuery();
                var _child2 = $e815fda779bc047b$var$newQuery();
                var pcQChecks = [
                    {
                        type: $e815fda779bc047b$var$Type.PARENT,
                        parent: _parent2,
                        child: _child2
                    }
                ];
                // the parent-child query takes the place of the query previously being populated
                _parent2.checks = query.checks; // the previous query contains the checks for the parent
                query.checks = pcQChecks; // pc query takes over
                selector.compoundCount++;
                return _child2; // we're now populating the child
            }
        }
    },
    {
        name: 'descendant',
        separator: true,
        regex: $e815fda779bc047b$var$tokens.descendant,
        populate: function populate(selector, query) {
            if (selector.currentSubject == null) {
                // default: descendant query
                var ancChQuery = $e815fda779bc047b$var$newQuery();
                var descendant = $e815fda779bc047b$var$newQuery();
                var ancestor = selector[selector.length - 1];
                ancChQuery.checks.push({
                    type: $e815fda779bc047b$var$Type.DESCENDANT,
                    ancestor: ancestor,
                    descendant: descendant
                });
                // the query in the selector should be the '>' itself
                $e815fda779bc047b$var$replaceLastQuery(selector, query, ancChQuery);
                selector.compoundCount++;
                // we're now populating the descendant query with expressions that follow
                return descendant;
            } else if (selector.currentSubject === query) {
                // compound split query
                var compound = $e815fda779bc047b$var$newQuery();
                var left = selector[selector.length - 1];
                var right = $e815fda779bc047b$var$newQuery();
                var subject = $e815fda779bc047b$var$newQuery();
                var _descendant = $e815fda779bc047b$var$newQuery();
                var _ancestor = $e815fda779bc047b$var$newQuery();
                // set up the root compound q
                compound.checks.push({
                    type: $e815fda779bc047b$var$Type.COMPOUND_SPLIT,
                    left: left,
                    right: right,
                    subject: subject
                });
                // populate the subject and replace the q at the old spot (within left) with TRUE
                subject.checks = query.checks; // take the checks from the left
                query.checks = [
                    {
                        type: $e815fda779bc047b$var$Type.TRUE
                    }
                ]; // checks under left refs the subject implicitly
                // set up the right q
                _ancestor.checks.push({
                    type: $e815fda779bc047b$var$Type.TRUE
                }); // ancestor implicitly refs the subject
                right.checks.push({
                    type: $e815fda779bc047b$var$Type.ANCESTOR,
                    // type is swapped on right side queries
                    ancestor: _ancestor,
                    descendant: _descendant // empty for now
                });
                $e815fda779bc047b$var$replaceLastQuery(selector, left, compound);
                // update the ref since we moved things around for `query`
                selector.currentSubject = subject;
                selector.compoundCount++;
                return _descendant; // now populating the right side's descendant
            } else {
                // ancestor query
                // info for parent query
                var _ancestor2 = $e815fda779bc047b$var$newQuery();
                var _descendant2 = $e815fda779bc047b$var$newQuery();
                var adQChecks = [
                    {
                        type: $e815fda779bc047b$var$Type.ANCESTOR,
                        ancestor: _ancestor2,
                        descendant: _descendant2
                    }
                ];
                // the parent-child query takes the place of the query previously being populated
                _ancestor2.checks = query.checks; // the previous query contains the checks for the parent
                query.checks = adQChecks; // pc query takes over
                selector.compoundCount++;
                return _descendant2; // we're now populating the child
            }
        }
    },
    {
        name: 'subject',
        modifier: true,
        regex: $e815fda779bc047b$var$tokens.subject,
        populate: function populate(selector, query) {
            if (selector.currentSubject != null && selector.currentSubject !== query) {
                $e815fda779bc047b$var$warn('Redefinition of subject in selector `' + selector.toString() + '`');
                return false;
            }
            selector.currentSubject = query;
            var topQ = selector[selector.length - 1];
            var topChk = topQ.checks[0];
            var topType = topChk == null ? null : topChk.type;
            if (topType === $e815fda779bc047b$var$Type.DIRECTED_EDGE) // directed edge with subject on the target
            // change to target node check
            topChk.type = $e815fda779bc047b$var$Type.NODE_TARGET;
            else if (topType === $e815fda779bc047b$var$Type.UNDIRECTED_EDGE) {
                // undirected edge with subject on the second node
                // change to neighbor check
                topChk.type = $e815fda779bc047b$var$Type.NODE_NEIGHBOR;
                topChk.node = topChk.nodes[1]; // second node is subject
                topChk.neighbor = topChk.nodes[0];
                // clean up unused fields for new type
                topChk.nodes = null;
            }
        }
    }
];
$e815fda779bc047b$var$exprs.forEach(function(e) {
    return e.regexObj = new RegExp('^' + e.regex);
});
/**
 * Of all the expressions, find the first match in the remaining text.
 * @param {string} remaining The remaining text to parse
 * @returns The matched expression and the newly remaining text `{ expr, match, name, remaining }`
 */ var $e815fda779bc047b$var$consumeExpr = function consumeExpr(remaining) {
    var expr;
    var match;
    var name;
    for(var j = 0; j < $e815fda779bc047b$var$exprs.length; j++){
        var e = $e815fda779bc047b$var$exprs[j];
        var n = e.name;
        var m1 = remaining.match(e.regexObj);
        if (m1 != null) {
            match = m1;
            expr = e;
            name = n;
            var consumed = m1[0];
            remaining = remaining.substring(consumed.length);
            break; // we've consumed one expr, so we can return now
        }
    }
    return {
        expr: expr,
        match: match,
        name: name,
        remaining: remaining
    };
};
/**
 * Consume all the leading whitespace
 * @param {string} remaining The text to consume
 * @returns The text with the leading whitespace removed
 */ var $e815fda779bc047b$var$consumeWhitespace = function consumeWhitespace(remaining) {
    var match = remaining.match(/^\s+/);
    if (match) {
        var consumed = match[0];
        remaining = remaining.substring(consumed.length);
    }
    return remaining;
};
/**
 * Parse the string and store the parsed representation in the Selector.
 * @param {string} selector The selector string
 * @returns `true` if the selector was successfully parsed, `false` otherwise
 */ var $e815fda779bc047b$var$parse = function parse(selector) {
    var self1 = this;
    var remaining = self1.inputText = selector;
    var currentQuery = self1[0] = $e815fda779bc047b$var$newQuery();
    self1.length = 1;
    remaining = $e815fda779bc047b$var$consumeWhitespace(remaining); // get rid of leading whitespace
    for(;;){
        var exprInfo = $e815fda779bc047b$var$consumeExpr(remaining);
        if (exprInfo.expr == null) {
            $e815fda779bc047b$var$warn('The selector `' + selector + '`is invalid');
            return false;
        } else {
            var args = exprInfo.match.slice(1);
            // let the token populate the selector object in currentQuery
            var ret = exprInfo.expr.populate(self1, currentQuery, args);
            if (ret === false) return false; // exit if population failed
            else if (ret != null) currentQuery = ret; // change the current query to be filled if the expr specifies
        }
        remaining = exprInfo.remaining;
        // we're done when there's nothing left to parse
        if (remaining.match(/^\s*$/)) break;
    }
    var lastQ = self1[self1.length - 1];
    if (self1.currentSubject != null) lastQ.subject = self1.currentSubject;
    lastQ.edgeCount = self1.edgeCount;
    lastQ.compoundCount = self1.compoundCount;
    for(var i = 0; i < self1.length; i++){
        var q = self1[i];
        // in future, this could potentially be allowed if there were operator precedence and detection of invalid combinations
        if (q.compoundCount > 0 && q.edgeCount > 0) {
            $e815fda779bc047b$var$warn('The selector `' + selector + '` is invalid because it uses both a compound selector and an edge selector');
            return false;
        }
        if (q.edgeCount > 1) {
            $e815fda779bc047b$var$warn('The selector `' + selector + '` is invalid because it uses multiple edge selectors');
            return false;
        } else if (q.edgeCount === 1) $e815fda779bc047b$var$warn('The selector `' + selector + '` is deprecated.  Edge selectors do not take effect on changes to source and target nodes after an edge is added, for performance reasons.  Use a class or data selector on edges instead, updating the class or data of an edge when your app detects a change in source or target nodes.');
    }
    return true; // success
};
/**
 * Get the selector represented as a string.  This value uses default formatting,
 * so things like spacing may differ from the input text passed to the constructor.
 * @returns {string} The selector string
 */ var $e815fda779bc047b$var$toString = function toString() {
    if (this.toStringCache != null) return this.toStringCache;
    var clean = function clean(obj) {
        if (obj == null) return '';
        else return obj;
    };
    var cleanVal = function cleanVal(val) {
        if ($e815fda779bc047b$var$string(val)) return '"' + val + '"';
        else return clean(val);
    };
    var space = function space(val) {
        return ' ' + val + ' ';
    };
    var checkToString = function checkToString(check, subject) {
        var type = check.type, value = check.value;
        switch(type){
            case $e815fda779bc047b$var$Type.GROUP:
                var group = clean(value);
                return group.substring(0, group.length - 1);
            case $e815fda779bc047b$var$Type.DATA_COMPARE:
                var field = check.field, operator = check.operator;
                return '[' + field + space(clean(operator)) + cleanVal(value) + ']';
            case $e815fda779bc047b$var$Type.DATA_BOOL:
                var _operator = check.operator, _field = check.field;
                return '[' + clean(_operator) + _field + ']';
            case $e815fda779bc047b$var$Type.DATA_EXIST:
                var _field2 = check.field;
                return '[' + _field2 + ']';
            case $e815fda779bc047b$var$Type.META_COMPARE:
                var _operator2 = check.operator, _field3 = check.field;
                return '[[' + _field3 + space(clean(_operator2)) + cleanVal(value) + ']]';
            case $e815fda779bc047b$var$Type.STATE:
                return value;
            case $e815fda779bc047b$var$Type.ID:
                return '#' + value;
            case $e815fda779bc047b$var$Type.CLASS:
                return '.' + value;
            case $e815fda779bc047b$var$Type.PARENT:
            case $e815fda779bc047b$var$Type.CHILD:
                return queryToString(check.parent, subject) + space('>') + queryToString(check.child, subject);
            case $e815fda779bc047b$var$Type.ANCESTOR:
            case $e815fda779bc047b$var$Type.DESCENDANT:
                return queryToString(check.ancestor, subject) + ' ' + queryToString(check.descendant, subject);
            case $e815fda779bc047b$var$Type.COMPOUND_SPLIT:
                var lhs = queryToString(check.left, subject);
                var sub = queryToString(check.subject, subject);
                var rhs = queryToString(check.right, subject);
                return lhs + (lhs.length > 0 ? ' ' : '') + sub + rhs;
            case $e815fda779bc047b$var$Type.TRUE:
                return '';
        }
    };
    var queryToString = function queryToString(query, subject) {
        return query.checks.reduce(function(str, chk, i) {
            return str + (subject === query && i === 0 ? '$' : '') + checkToString(chk, subject);
        }, '');
    };
    var str = '';
    for(var i = 0; i < this.length; i++){
        var query = this[i];
        str += queryToString(query, query.subject);
        if (this.length > 1 && i < this.length - 1) str += ', ';
    }
    this.toStringCache = str;
    return str;
};
var $e815fda779bc047b$var$parse$1 = {
    parse: $e815fda779bc047b$var$parse,
    toString: $e815fda779bc047b$var$toString
};
var $e815fda779bc047b$var$valCmp = function valCmp(fieldVal, operator, value) {
    var matches;
    var isFieldStr = $e815fda779bc047b$var$string(fieldVal);
    var isFieldNum = $e815fda779bc047b$var$number$1(fieldVal);
    var isValStr = $e815fda779bc047b$var$string(value);
    var fieldStr, valStr;
    var caseInsensitive = false;
    var notExpr = false;
    var isIneqCmp = false;
    if (operator.indexOf('!') >= 0) {
        operator = operator.replace('!', '');
        notExpr = true;
    }
    if (operator.indexOf('@') >= 0) {
        operator = operator.replace('@', '');
        caseInsensitive = true;
    }
    if (isFieldStr || isValStr || caseInsensitive) {
        fieldStr = !isFieldStr && !isFieldNum ? '' : '' + fieldVal;
        valStr = '' + value;
    }
    // if we're doing a case insensitive comparison, then we're using a STRING comparison
    // even if we're comparing numbers
    if (caseInsensitive) {
        fieldVal = fieldStr = fieldStr.toLowerCase();
        value = valStr = valStr.toLowerCase();
    }
    switch(operator){
        case '*=':
            matches = fieldStr.indexOf(valStr) >= 0;
            break;
        case '$=':
            matches = fieldStr.indexOf(valStr, fieldStr.length - valStr.length) >= 0;
            break;
        case '^=':
            matches = fieldStr.indexOf(valStr) === 0;
            break;
        case '=':
            matches = fieldVal === value;
            break;
        case '>':
            isIneqCmp = true;
            matches = fieldVal > value;
            break;
        case '>=':
            isIneqCmp = true;
            matches = fieldVal >= value;
            break;
        case '<':
            isIneqCmp = true;
            matches = fieldVal < value;
            break;
        case '<=':
            isIneqCmp = true;
            matches = fieldVal <= value;
            break;
        default:
            matches = false;
            break;
    }
    // apply the not op, but null vals for inequalities should always stay non-matching
    if (notExpr && (fieldVal != null || !isIneqCmp)) matches = !matches;
    return matches;
};
var $e815fda779bc047b$var$boolCmp = function boolCmp(fieldVal, operator) {
    switch(operator){
        case '?':
            return fieldVal ? true : false;
        case '!':
            return fieldVal ? false : true;
        case '^':
            return fieldVal === undefined;
    }
};
var $e815fda779bc047b$var$existCmp = function existCmp(fieldVal) {
    return fieldVal !== undefined;
};
var $e815fda779bc047b$var$data$1 = function data(ele, field) {
    return ele.data(field);
};
var $e815fda779bc047b$var$meta = function meta(ele, field) {
    return ele[field]();
};
/** A lookup of `match(check, ele)` functions by `Type` int */ var $e815fda779bc047b$var$match = [];
/**
 * Returns whether the query matches for the element
 * @param query The `{ type, value, ... }` query object
 * @param ele The element to compare against
*/ var $e815fda779bc047b$var$matches$1 = function matches(query, ele) {
    return query.checks.every(function(chk) {
        return $e815fda779bc047b$var$match[chk.type](chk, ele);
    });
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.GROUP] = function(check, ele) {
    var group = check.value;
    return group === '*' || group === ele.group();
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.STATE] = function(check, ele) {
    var stateSelector = check.value;
    return $e815fda779bc047b$var$stateSelectorMatches(stateSelector, ele);
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.ID] = function(check, ele) {
    var id = check.value;
    return ele.id() === id;
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.CLASS] = function(check, ele) {
    var cls = check.value;
    return ele.hasClass(cls);
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.META_COMPARE] = function(check, ele) {
    var field = check.field, operator = check.operator, value = check.value;
    return $e815fda779bc047b$var$valCmp($e815fda779bc047b$var$meta(ele, field), operator, value);
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.DATA_COMPARE] = function(check, ele) {
    var field = check.field, operator = check.operator, value = check.value;
    return $e815fda779bc047b$var$valCmp($e815fda779bc047b$var$data$1(ele, field), operator, value);
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.DATA_BOOL] = function(check, ele) {
    var field = check.field, operator = check.operator;
    return $e815fda779bc047b$var$boolCmp($e815fda779bc047b$var$data$1(ele, field), operator);
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.DATA_EXIST] = function(check, ele) {
    var field = check.field;
    check.operator;
    return $e815fda779bc047b$var$existCmp($e815fda779bc047b$var$data$1(ele, field));
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.UNDIRECTED_EDGE] = function(check, ele) {
    var qA = check.nodes[0];
    var qB = check.nodes[1];
    var src = ele.source();
    var tgt = ele.target();
    return $e815fda779bc047b$var$matches$1(qA, src) && $e815fda779bc047b$var$matches$1(qB, tgt) || $e815fda779bc047b$var$matches$1(qB, src) && $e815fda779bc047b$var$matches$1(qA, tgt);
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.NODE_NEIGHBOR] = function(check, ele) {
    return $e815fda779bc047b$var$matches$1(check.node, ele) && ele.neighborhood().some(function(n) {
        return n.isNode() && $e815fda779bc047b$var$matches$1(check.neighbor, n);
    });
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.DIRECTED_EDGE] = function(check, ele) {
    return $e815fda779bc047b$var$matches$1(check.source, ele.source()) && $e815fda779bc047b$var$matches$1(check.target, ele.target());
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.NODE_SOURCE] = function(check, ele) {
    return $e815fda779bc047b$var$matches$1(check.source, ele) && ele.outgoers().some(function(n) {
        return n.isNode() && $e815fda779bc047b$var$matches$1(check.target, n);
    });
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.NODE_TARGET] = function(check, ele) {
    return $e815fda779bc047b$var$matches$1(check.target, ele) && ele.incomers().some(function(n) {
        return n.isNode() && $e815fda779bc047b$var$matches$1(check.source, n);
    });
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.CHILD] = function(check, ele) {
    return $e815fda779bc047b$var$matches$1(check.child, ele) && $e815fda779bc047b$var$matches$1(check.parent, ele.parent());
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.PARENT] = function(check, ele) {
    return $e815fda779bc047b$var$matches$1(check.parent, ele) && ele.children().some(function(c) {
        return $e815fda779bc047b$var$matches$1(check.child, c);
    });
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.DESCENDANT] = function(check, ele) {
    return $e815fda779bc047b$var$matches$1(check.descendant, ele) && ele.ancestors().some(function(a) {
        return $e815fda779bc047b$var$matches$1(check.ancestor, a);
    });
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.ANCESTOR] = function(check, ele) {
    return $e815fda779bc047b$var$matches$1(check.ancestor, ele) && ele.descendants().some(function(d) {
        return $e815fda779bc047b$var$matches$1(check.descendant, d);
    });
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.COMPOUND_SPLIT] = function(check, ele) {
    return $e815fda779bc047b$var$matches$1(check.subject, ele) && $e815fda779bc047b$var$matches$1(check.left, ele) && $e815fda779bc047b$var$matches$1(check.right, ele);
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.TRUE] = function() {
    return true;
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.COLLECTION] = function(check, ele) {
    var collection = check.value;
    return collection.has(ele);
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.FILTER] = function(check, ele) {
    var filter = check.value;
    return filter(ele);
};
// filter an existing collection
var $e815fda779bc047b$var$filter = function filter(collection) {
    var self1 = this;
    // for 1 id #foo queries, just get the element
    if (self1.length === 1 && self1[0].checks.length === 1 && self1[0].checks[0].type === $e815fda779bc047b$var$Type.ID) return collection.getElementById(self1[0].checks[0].value).collection();
    var selectorFunction = function selectorFunction(element) {
        for(var j = 0; j < self1.length; j++){
            var query = self1[j];
            if ($e815fda779bc047b$var$matches$1(query, element)) return true;
        }
        return false;
    };
    if (self1.text() == null) selectorFunction = function selectorFunction() {
        return true;
    };
    return collection.filter(selectorFunction);
}; // filter
// does selector match a single element?
var $e815fda779bc047b$var$matches = function matches(ele) {
    var self1 = this;
    for(var j = 0; j < self1.length; j++){
        var query = self1[j];
        if ($e815fda779bc047b$var$matches$1(query, ele)) return true;
    }
    return false;
}; // matches
var $e815fda779bc047b$var$matching = {
    matches: $e815fda779bc047b$var$matches,
    filter: $e815fda779bc047b$var$filter
};
var $e815fda779bc047b$var$Selector = function Selector(selector) {
    this.inputText = selector;
    this.currentSubject = null;
    this.compoundCount = 0;
    this.edgeCount = 0;
    this.length = 0;
    if (selector == null || $e815fda779bc047b$var$string(selector) && selector.match(/^\s*$/)) ;
    else if ($e815fda779bc047b$var$elementOrCollection(selector)) this.addQuery({
        checks: [
            {
                type: $e815fda779bc047b$var$Type.COLLECTION,
                value: selector.collection()
            }
        ]
    });
    else if ($e815fda779bc047b$var$fn$6(selector)) this.addQuery({
        checks: [
            {
                type: $e815fda779bc047b$var$Type.FILTER,
                value: selector
            }
        ]
    });
    else if ($e815fda779bc047b$var$string(selector)) {
        if (!this.parse(selector)) this.invalid = true;
    } else $e815fda779bc047b$var$error('A selector must be created from a string; found ');
};
var $e815fda779bc047b$var$selfn = $e815fda779bc047b$var$Selector.prototype;
[
    $e815fda779bc047b$var$parse$1,
    $e815fda779bc047b$var$matching
].forEach(function(p) {
    return $e815fda779bc047b$var$extend($e815fda779bc047b$var$selfn, p);
});
$e815fda779bc047b$var$selfn.text = function() {
    return this.inputText;
};
$e815fda779bc047b$var$selfn.size = function() {
    return this.length;
};
$e815fda779bc047b$var$selfn.eq = function(i) {
    return this[i];
};
$e815fda779bc047b$var$selfn.sameText = function(otherSel) {
    return !this.invalid && !otherSel.invalid && this.text() === otherSel.text();
};
$e815fda779bc047b$var$selfn.addQuery = function(q) {
    this[this.length++] = q;
};
$e815fda779bc047b$var$selfn.selector = $e815fda779bc047b$var$selfn.toString;
var $e815fda779bc047b$var$elesfn$g = {
    allAre: function allAre(selector) {
        var selObj = new $e815fda779bc047b$var$Selector(selector);
        return this.every(function(ele) {
            return selObj.matches(ele);
        });
    },
    is: function is(selector) {
        var selObj = new $e815fda779bc047b$var$Selector(selector);
        return this.some(function(ele) {
            return selObj.matches(ele);
        });
    },
    some: function some(fn, thisArg) {
        for(var i = 0; i < this.length; i++){
            var ret = !thisArg ? fn(this[i], i, this) : fn.apply(thisArg, [
                this[i],
                i,
                this
            ]);
            if (ret) return true;
        }
        return false;
    },
    every: function every(fn, thisArg) {
        for(var i = 0; i < this.length; i++){
            var ret = !thisArg ? fn(this[i], i, this) : fn.apply(thisArg, [
                this[i],
                i,
                this
            ]);
            if (!ret) return false;
        }
        return true;
    },
    same: function same(collection) {
        // cheap collection ref check
        if (this === collection) return true;
        collection = this.cy().collection(collection);
        var thisLength = this.length;
        var collectionLength = collection.length;
        // cheap length check
        if (thisLength !== collectionLength) return false;
        // cheap element ref check
        if (thisLength === 1) return this[0] === collection[0];
        return this.every(function(ele) {
            return collection.hasElementWithId(ele.id());
        });
    },
    anySame: function anySame(collection) {
        collection = this.cy().collection(collection);
        return this.some(function(ele) {
            return collection.hasElementWithId(ele.id());
        });
    },
    allAreNeighbors: function allAreNeighbors(collection) {
        collection = this.cy().collection(collection);
        var nhood = this.neighborhood();
        return collection.every(function(ele) {
            return nhood.hasElementWithId(ele.id());
        });
    },
    contains: function contains(collection) {
        collection = this.cy().collection(collection);
        var self1 = this;
        return collection.every(function(ele) {
            return self1.hasElementWithId(ele.id());
        });
    }
};
$e815fda779bc047b$var$elesfn$g.allAreNeighbours = $e815fda779bc047b$var$elesfn$g.allAreNeighbors;
$e815fda779bc047b$var$elesfn$g.has = $e815fda779bc047b$var$elesfn$g.contains;
$e815fda779bc047b$var$elesfn$g.equal = $e815fda779bc047b$var$elesfn$g.equals = $e815fda779bc047b$var$elesfn$g.same;
var $e815fda779bc047b$var$cache = function cache(fn, name) {
    return function traversalCache(arg1, arg2, arg3, arg4) {
        var selectorOrEles = arg1;
        var eles = this;
        var key;
        if (selectorOrEles == null) key = '';
        else if ($e815fda779bc047b$var$elementOrCollection(selectorOrEles) && selectorOrEles.length === 1) key = selectorOrEles.id();
        if (eles.length === 1 && key) {
            var _p = eles[0]._private;
            var tch = _p.traversalCache = _p.traversalCache || {};
            var ch = tch[name] = tch[name] || [];
            var hash = $e815fda779bc047b$var$hashString(key);
            var cacheHit = ch[hash];
            if (cacheHit) return cacheHit;
            else return ch[hash] = fn.call(eles, arg1, arg2, arg3, arg4);
        } else return fn.call(eles, arg1, arg2, arg3, arg4);
    };
};
var $e815fda779bc047b$var$elesfn$f = {
    parent: function parent(selector) {
        var parents = [];
        // optimisation for single ele call
        if (this.length === 1) {
            var parent = this[0]._private.parent;
            if (parent) return parent;
        }
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            var _parent = ele._private.parent;
            if (_parent) parents.push(_parent);
        }
        return this.spawn(parents, true).filter(selector);
    },
    parents: function parents(selector) {
        var parents = [];
        var eles = this.parent();
        while(eles.nonempty()){
            for(var i = 0; i < eles.length; i++){
                var ele = eles[i];
                parents.push(ele);
            }
            eles = eles.parent();
        }
        return this.spawn(parents, true).filter(selector);
    },
    commonAncestors: function commonAncestors(selector) {
        var ancestors;
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            var parents = ele.parents();
            ancestors = ancestors || parents;
            ancestors = ancestors.intersect(parents); // current list must be common with current ele parents set
        }
        return ancestors.filter(selector);
    },
    orphans: function orphans(selector) {
        return this.stdFilter(function(ele) {
            return ele.isOrphan();
        }).filter(selector);
    },
    nonorphans: function nonorphans(selector) {
        return this.stdFilter(function(ele) {
            return ele.isChild();
        }).filter(selector);
    },
    children: $e815fda779bc047b$var$cache(function(selector) {
        var children = [];
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            var eleChildren = ele._private.children;
            for(var j = 0; j < eleChildren.length; j++)children.push(eleChildren[j]);
        }
        return this.spawn(children, true).filter(selector);
    }, 'children'),
    siblings: function siblings(selector) {
        return this.parent().children().not(this).filter(selector);
    },
    isParent: function isParent() {
        var ele = this[0];
        if (ele) return ele.isNode() && ele._private.children.length !== 0;
    },
    isChildless: function isChildless() {
        var ele = this[0];
        if (ele) return ele.isNode() && ele._private.children.length === 0;
    },
    isChild: function isChild() {
        var ele = this[0];
        if (ele) return ele.isNode() && ele._private.parent != null;
    },
    isOrphan: function isOrphan() {
        var ele = this[0];
        if (ele) return ele.isNode() && ele._private.parent == null;
    },
    descendants: function descendants(selector) {
        var elements = [];
        function add(eles) {
            for(var i = 0; i < eles.length; i++){
                var ele = eles[i];
                elements.push(ele);
                if (ele.children().nonempty()) add(ele.children());
            }
        }
        add(this.children());
        return this.spawn(elements, true).filter(selector);
    }
};
function $e815fda779bc047b$var$forEachCompound(eles, fn, includeSelf, recursiveStep) {
    var q = [];
    var did = new $e815fda779bc047b$var$Set$1();
    var cy = eles.cy();
    var hasCompounds = cy.hasCompoundNodes();
    for(var i = 0; i < eles.length; i++){
        var ele = eles[i];
        if (includeSelf) q.push(ele);
        else if (hasCompounds) recursiveStep(q, did, ele);
    }
    while(q.length > 0){
        var _ele = q.shift();
        fn(_ele);
        did.add(_ele.id());
        if (hasCompounds) recursiveStep(q, did, _ele);
    }
    return eles;
}
function $e815fda779bc047b$var$addChildren(q, did, ele) {
    if (ele.isParent()) {
        var children = ele._private.children;
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            if (!did.has(child.id())) q.push(child);
        }
    }
}
// very efficient version of eles.add( eles.descendants() ).forEach()
// for internal use
$e815fda779bc047b$var$elesfn$f.forEachDown = function(fn) {
    var includeSelf = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return $e815fda779bc047b$var$forEachCompound(this, fn, includeSelf, $e815fda779bc047b$var$addChildren);
};
function $e815fda779bc047b$var$addParent(q, did, ele) {
    if (ele.isChild()) {
        var parent = ele._private.parent;
        if (!did.has(parent.id())) q.push(parent);
    }
}
$e815fda779bc047b$var$elesfn$f.forEachUp = function(fn) {
    var includeSelf = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return $e815fda779bc047b$var$forEachCompound(this, fn, includeSelf, $e815fda779bc047b$var$addParent);
};
function $e815fda779bc047b$var$addParentAndChildren(q, did, ele) {
    $e815fda779bc047b$var$addParent(q, did, ele);
    $e815fda779bc047b$var$addChildren(q, did, ele);
}
$e815fda779bc047b$var$elesfn$f.forEachUpAndDown = function(fn) {
    var includeSelf = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return $e815fda779bc047b$var$forEachCompound(this, fn, includeSelf, $e815fda779bc047b$var$addParentAndChildren);
};
// aliases
$e815fda779bc047b$var$elesfn$f.ancestors = $e815fda779bc047b$var$elesfn$f.parents;
var $e815fda779bc047b$var$fn$5, $e815fda779bc047b$var$elesfn$e;
$e815fda779bc047b$var$fn$5 = $e815fda779bc047b$var$elesfn$e = {
    data: $e815fda779bc047b$var$define.data({
        field: 'data',
        bindingEvent: 'data',
        allowBinding: true,
        allowSetting: true,
        settingEvent: 'data',
        settingTriggersEvent: true,
        triggerFnName: 'trigger',
        allowGetting: true,
        immutableKeys: {
            'id': true,
            'source': true,
            'target': true,
            'parent': true
        },
        updateStyle: true
    }),
    removeData: $e815fda779bc047b$var$define.removeData({
        field: 'data',
        event: 'data',
        triggerFnName: 'trigger',
        triggerEvent: true,
        immutableKeys: {
            'id': true,
            'source': true,
            'target': true,
            'parent': true
        },
        updateStyle: true
    }),
    scratch: $e815fda779bc047b$var$define.data({
        field: 'scratch',
        bindingEvent: 'scratch',
        allowBinding: true,
        allowSetting: true,
        settingEvent: 'scratch',
        settingTriggersEvent: true,
        triggerFnName: 'trigger',
        allowGetting: true,
        updateStyle: true
    }),
    removeScratch: $e815fda779bc047b$var$define.removeData({
        field: 'scratch',
        event: 'scratch',
        triggerFnName: 'trigger',
        triggerEvent: true,
        updateStyle: true
    }),
    rscratch: $e815fda779bc047b$var$define.data({
        field: 'rscratch',
        allowBinding: false,
        allowSetting: true,
        settingTriggersEvent: false,
        allowGetting: true
    }),
    removeRscratch: $e815fda779bc047b$var$define.removeData({
        field: 'rscratch',
        triggerEvent: false
    }),
    id: function id() {
        var ele = this[0];
        if (ele) return ele._private.data.id;
    }
};
// aliases
$e815fda779bc047b$var$fn$5.attr = $e815fda779bc047b$var$fn$5.data;
$e815fda779bc047b$var$fn$5.removeAttr = $e815fda779bc047b$var$fn$5.removeData;
var $e815fda779bc047b$var$data = $e815fda779bc047b$var$elesfn$e;
var $e815fda779bc047b$var$elesfn$d = {};
function $e815fda779bc047b$var$defineDegreeFunction(callback) {
    return function(includeLoops) {
        var self1 = this;
        if (includeLoops === undefined) includeLoops = true;
        if (self1.length === 0) return;
        if (self1.isNode() && !self1.removed()) {
            var degree = 0;
            var node = self1[0];
            var connectedEdges = node._private.edges;
            for(var i = 0; i < connectedEdges.length; i++){
                var edge = connectedEdges[i];
                if (!includeLoops && edge.isLoop()) continue;
                degree += callback(node, edge);
            }
            return degree;
        } else return;
    };
}
$e815fda779bc047b$var$extend($e815fda779bc047b$var$elesfn$d, {
    degree: $e815fda779bc047b$var$defineDegreeFunction(function(node, edge) {
        if (edge.source().same(edge.target())) return 2;
        else return 1;
    }),
    indegree: $e815fda779bc047b$var$defineDegreeFunction(function(node, edge) {
        if (edge.target().same(node)) return 1;
        else return 0;
    }),
    outdegree: $e815fda779bc047b$var$defineDegreeFunction(function(node, edge) {
        if (edge.source().same(node)) return 1;
        else return 0;
    })
});
function $e815fda779bc047b$var$defineDegreeBoundsFunction(degreeFn, callback) {
    return function(includeLoops) {
        var ret;
        var nodes = this.nodes();
        for(var i = 0; i < nodes.length; i++){
            var ele = nodes[i];
            var degree = ele[degreeFn](includeLoops);
            if (degree !== undefined && (ret === undefined || callback(degree, ret))) ret = degree;
        }
        return ret;
    };
}
$e815fda779bc047b$var$extend($e815fda779bc047b$var$elesfn$d, {
    minDegree: $e815fda779bc047b$var$defineDegreeBoundsFunction('degree', function(degree, min) {
        return degree < min;
    }),
    maxDegree: $e815fda779bc047b$var$defineDegreeBoundsFunction('degree', function(degree, max) {
        return degree > max;
    }),
    minIndegree: $e815fda779bc047b$var$defineDegreeBoundsFunction('indegree', function(degree, min) {
        return degree < min;
    }),
    maxIndegree: $e815fda779bc047b$var$defineDegreeBoundsFunction('indegree', function(degree, max) {
        return degree > max;
    }),
    minOutdegree: $e815fda779bc047b$var$defineDegreeBoundsFunction('outdegree', function(degree, min) {
        return degree < min;
    }),
    maxOutdegree: $e815fda779bc047b$var$defineDegreeBoundsFunction('outdegree', function(degree, max) {
        return degree > max;
    })
});
$e815fda779bc047b$var$extend($e815fda779bc047b$var$elesfn$d, {
    totalDegree: function totalDegree(includeLoops) {
        var total = 0;
        var nodes = this.nodes();
        for(var i = 0; i < nodes.length; i++)total += nodes[i].degree(includeLoops);
        return total;
    }
});
var $e815fda779bc047b$var$fn$4, $e815fda779bc047b$var$elesfn$c;
var $e815fda779bc047b$var$beforePositionSet = function beforePositionSet(eles, newPos, silent) {
    for(var i = 0; i < eles.length; i++){
        var ele = eles[i];
        if (!ele.locked()) {
            var oldPos = ele._private.position;
            var delta = {
                x: newPos.x != null ? newPos.x - oldPos.x : 0,
                y: newPos.y != null ? newPos.y - oldPos.y : 0
            };
            if (ele.isParent() && !(delta.x === 0 && delta.y === 0)) ele.children().shift(delta, silent);
            ele.dirtyBoundingBoxCache();
        }
    }
};
var $e815fda779bc047b$var$positionDef = {
    field: 'position',
    bindingEvent: 'position',
    allowBinding: true,
    allowSetting: true,
    settingEvent: 'position',
    settingTriggersEvent: true,
    triggerFnName: 'emitAndNotify',
    allowGetting: true,
    validKeys: [
        'x',
        'y'
    ],
    beforeGet: function beforeGet(ele) {
        ele.updateCompoundBounds();
    },
    beforeSet: function beforeSet(eles, newPos) {
        $e815fda779bc047b$var$beforePositionSet(eles, newPos, false);
    },
    onSet: function onSet(eles) {
        eles.dirtyCompoundBoundsCache();
    },
    canSet: function canSet(ele) {
        return !ele.locked();
    }
};
$e815fda779bc047b$var$fn$4 = $e815fda779bc047b$var$elesfn$c = {
    position: $e815fda779bc047b$var$define.data($e815fda779bc047b$var$positionDef),
    // position but no notification to renderer
    silentPosition: $e815fda779bc047b$var$define.data($e815fda779bc047b$var$extend({}, $e815fda779bc047b$var$positionDef, {
        allowBinding: false,
        allowSetting: true,
        settingTriggersEvent: false,
        allowGetting: false,
        beforeSet: function beforeSet(eles, newPos) {
            $e815fda779bc047b$var$beforePositionSet(eles, newPos, true);
        },
        onSet: function onSet(eles) {
            eles.dirtyCompoundBoundsCache();
        }
    })),
    positions: function positions(pos, silent) {
        if ($e815fda779bc047b$var$plainObject(pos)) {
            if (silent) this.silentPosition(pos);
            else this.position(pos);
        } else if ($e815fda779bc047b$var$fn$6(pos)) {
            var _fn = pos;
            var cy = this.cy();
            cy.startBatch();
            for(var i = 0; i < this.length; i++){
                var ele = this[i];
                var _pos = undefined;
                if (_pos = _fn(ele, i)) {
                    if (silent) ele.silentPosition(_pos);
                    else ele.position(_pos);
                }
            }
            cy.endBatch();
        }
        return this; // chaining
    },
    silentPositions: function silentPositions(pos) {
        return this.positions(pos, true);
    },
    shift: function shift(dim, val, silent) {
        var delta;
        if ($e815fda779bc047b$var$plainObject(dim)) {
            delta = {
                x: $e815fda779bc047b$var$number$1(dim.x) ? dim.x : 0,
                y: $e815fda779bc047b$var$number$1(dim.y) ? dim.y : 0
            };
            silent = val;
        } else if ($e815fda779bc047b$var$string(dim) && $e815fda779bc047b$var$number$1(val)) {
            delta = {
                x: 0,
                y: 0
            };
            delta[dim] = val;
        }
        if (delta != null) {
            var cy = this.cy();
            cy.startBatch();
            for(var i = 0; i < this.length; i++){
                var ele = this[i];
                // exclude any node that is a descendant of the calling collection
                if (cy.hasCompoundNodes() && ele.isChild() && ele.ancestors().anySame(this)) continue;
                var pos = ele.position();
                var newPos = {
                    x: pos.x + delta.x,
                    y: pos.y + delta.y
                };
                if (silent) ele.silentPosition(newPos);
                else ele.position(newPos);
            }
            cy.endBatch();
        }
        return this;
    },
    silentShift: function silentShift(dim, val) {
        if ($e815fda779bc047b$var$plainObject(dim)) this.shift(dim, true);
        else if ($e815fda779bc047b$var$string(dim) && $e815fda779bc047b$var$number$1(val)) this.shift(dim, val, true);
        return this;
    },
    // get/set the rendered (i.e. on screen) positon of the element
    renderedPosition: function renderedPosition(dim, val) {
        var ele = this[0];
        var cy = this.cy();
        var zoom = cy.zoom();
        var pan = cy.pan();
        var rpos = $e815fda779bc047b$var$plainObject(dim) ? dim : undefined;
        var setting = rpos !== undefined || val !== undefined && $e815fda779bc047b$var$string(dim);
        if (ele && ele.isNode()) {
            // must have an element and must be a node to return position
            if (setting) for(var i = 0; i < this.length; i++){
                var _ele = this[i];
                if (val !== undefined) // set one dimension
                _ele.position(dim, (val - pan[dim]) / zoom);
                else if (rpos !== undefined) // set whole position
                _ele.position($e815fda779bc047b$var$renderedToModelPosition(rpos, zoom, pan));
            }
            else {
                // getting
                var pos = ele.position();
                rpos = $e815fda779bc047b$var$modelToRenderedPosition$1(pos, zoom, pan);
                if (dim === undefined) // then return the whole rendered position
                return rpos;
                else // then return the specified dimension
                return rpos[dim];
            }
        } else if (!setting) return undefined; // for empty collection case
        return this; // chaining
    },
    // get/set the position relative to the parent
    relativePosition: function relativePosition(dim, val) {
        var ele = this[0];
        var cy = this.cy();
        var ppos = $e815fda779bc047b$var$plainObject(dim) ? dim : undefined;
        var setting = ppos !== undefined || val !== undefined && $e815fda779bc047b$var$string(dim);
        var hasCompoundNodes = cy.hasCompoundNodes();
        if (ele && ele.isNode()) {
            // must have an element and must be a node to return position
            if (setting) for(var i = 0; i < this.length; i++){
                var _ele2 = this[i];
                var parent = hasCompoundNodes ? _ele2.parent() : null;
                var hasParent = parent && parent.length > 0;
                var relativeToParent = hasParent;
                if (hasParent) parent = parent[0];
                var origin = relativeToParent ? parent.position() : {
                    x: 0,
                    y: 0
                };
                if (val !== undefined) // set one dimension
                _ele2.position(dim, val + origin[dim]);
                else if (ppos !== undefined) // set whole position
                _ele2.position({
                    x: ppos.x + origin.x,
                    y: ppos.y + origin.y
                });
            }
            else {
                // getting
                var pos = ele.position();
                var _parent = hasCompoundNodes ? ele.parent() : null;
                var _hasParent = _parent && _parent.length > 0;
                var _relativeToParent = _hasParent;
                if (_hasParent) _parent = _parent[0];
                var _origin = _relativeToParent ? _parent.position() : {
                    x: 0,
                    y: 0
                };
                ppos = {
                    x: pos.x - _origin.x,
                    y: pos.y - _origin.y
                };
                if (dim === undefined) // then return the whole rendered position
                return ppos;
                else // then return the specified dimension
                return ppos[dim];
            }
        } else if (!setting) return undefined; // for empty collection case
        return this; // chaining
    }
};
// aliases
$e815fda779bc047b$var$fn$4.modelPosition = $e815fda779bc047b$var$fn$4.point = $e815fda779bc047b$var$fn$4.position;
$e815fda779bc047b$var$fn$4.modelPositions = $e815fda779bc047b$var$fn$4.points = $e815fda779bc047b$var$fn$4.positions;
$e815fda779bc047b$var$fn$4.renderedPoint = $e815fda779bc047b$var$fn$4.renderedPosition;
$e815fda779bc047b$var$fn$4.relativePoint = $e815fda779bc047b$var$fn$4.relativePosition;
var $e815fda779bc047b$var$position = $e815fda779bc047b$var$elesfn$c;
var $e815fda779bc047b$var$fn$3, $e815fda779bc047b$var$elesfn$b;
$e815fda779bc047b$var$fn$3 = $e815fda779bc047b$var$elesfn$b = {};
$e815fda779bc047b$var$elesfn$b.renderedBoundingBox = function(options) {
    var bb = this.boundingBox(options);
    var cy = this.cy();
    var zoom = cy.zoom();
    var pan = cy.pan();
    var x1 = bb.x1 * zoom + pan.x;
    var x2 = bb.x2 * zoom + pan.x;
    var y1 = bb.y1 * zoom + pan.y;
    var y2 = bb.y2 * zoom + pan.y;
    return {
        x1: x1,
        x2: x2,
        y1: y1,
        y2: y2,
        w: x2 - x1,
        h: y2 - y1
    };
};
$e815fda779bc047b$var$elesfn$b.dirtyCompoundBoundsCache = function() {
    var silent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var cy = this.cy();
    if (!cy.styleEnabled() || !cy.hasCompoundNodes()) return this;
    this.forEachUp(function(ele) {
        if (ele.isParent()) {
            var _p = ele._private;
            _p.compoundBoundsClean = false;
            _p.bbCache = null;
            if (!silent) ele.emitAndNotify('bounds');
        }
    });
    return this;
};
$e815fda779bc047b$var$elesfn$b.updateCompoundBounds = function() {
    var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var cy = this.cy();
    // not possible to do on non-compound graphs or with the style disabled
    if (!cy.styleEnabled() || !cy.hasCompoundNodes()) return this;
    // save cycles when batching -- but bounds will be stale (or not exist yet)
    if (!force && cy.batching()) return this;
    function update(parent) {
        if (!parent.isParent()) return;
        var _p = parent._private;
        var children = parent.children();
        var includeLabels = parent.pstyle('compound-sizing-wrt-labels').value === 'include';
        var min = {
            width: {
                val: parent.pstyle('min-width').pfValue,
                left: parent.pstyle('min-width-bias-left'),
                right: parent.pstyle('min-width-bias-right')
            },
            height: {
                val: parent.pstyle('min-height').pfValue,
                top: parent.pstyle('min-height-bias-top'),
                bottom: parent.pstyle('min-height-bias-bottom')
            }
        };
        var bb = children.boundingBox({
            includeLabels: includeLabels,
            includeOverlays: false,
            // updating the compound bounds happens outside of the regular
            // cache cycle (i.e. before fired events)
            useCache: false
        });
        var pos = _p.position;
        // if children take up zero area then keep position and fall back on stylesheet w/h
        if (bb.w === 0 || bb.h === 0) {
            bb = {
                w: parent.pstyle('width').pfValue,
                h: parent.pstyle('height').pfValue
            };
            bb.x1 = pos.x - bb.w / 2;
            bb.x2 = pos.x + bb.w / 2;
            bb.y1 = pos.y - bb.h / 2;
            bb.y2 = pos.y + bb.h / 2;
        }
        function computeBiasValues(propDiff, propBias, propBiasComplement) {
            var biasDiff = 0;
            var biasComplementDiff = 0;
            var biasTotal = propBias + propBiasComplement;
            if (propDiff > 0 && biasTotal > 0) {
                biasDiff = propBias / biasTotal * propDiff;
                biasComplementDiff = propBiasComplement / biasTotal * propDiff;
            }
            return {
                biasDiff: biasDiff,
                biasComplementDiff: biasComplementDiff
            };
        }
        function computePaddingValues(width, height, paddingObject, relativeTo) {
            // Assuming percentage is number from 0 to 1
            if (paddingObject.units === '%') switch(relativeTo){
                case 'width':
                    return width > 0 ? paddingObject.pfValue * width : 0;
                case 'height':
                    return height > 0 ? paddingObject.pfValue * height : 0;
                case 'average':
                    return width > 0 && height > 0 ? paddingObject.pfValue * (width + height) / 2 : 0;
                case 'min':
                    return width > 0 && height > 0 ? width > height ? paddingObject.pfValue * height : paddingObject.pfValue * width : 0;
                case 'max':
                    return width > 0 && height > 0 ? width > height ? paddingObject.pfValue * width : paddingObject.pfValue * height : 0;
                default:
                    return 0;
            }
            else if (paddingObject.units === 'px') return paddingObject.pfValue;
            else return 0;
        }
        var leftVal = min.width.left.value;
        if (min.width.left.units === 'px' && min.width.val > 0) leftVal = leftVal * 100 / min.width.val;
        var rightVal = min.width.right.value;
        if (min.width.right.units === 'px' && min.width.val > 0) rightVal = rightVal * 100 / min.width.val;
        var topVal = min.height.top.value;
        if (min.height.top.units === 'px' && min.height.val > 0) topVal = topVal * 100 / min.height.val;
        var bottomVal = min.height.bottom.value;
        if (min.height.bottom.units === 'px' && min.height.val > 0) bottomVal = bottomVal * 100 / min.height.val;
        var widthBiasDiffs = computeBiasValues(min.width.val - bb.w, leftVal, rightVal);
        var diffLeft = widthBiasDiffs.biasDiff;
        var diffRight = widthBiasDiffs.biasComplementDiff;
        var heightBiasDiffs = computeBiasValues(min.height.val - bb.h, topVal, bottomVal);
        var diffTop = heightBiasDiffs.biasDiff;
        var diffBottom = heightBiasDiffs.biasComplementDiff;
        _p.autoPadding = computePaddingValues(bb.w, bb.h, parent.pstyle('padding'), parent.pstyle('padding-relative-to').value);
        _p.autoWidth = Math.max(bb.w, min.width.val);
        pos.x = (-diffLeft + bb.x1 + bb.x2 + diffRight) / 2;
        _p.autoHeight = Math.max(bb.h, min.height.val);
        pos.y = (-diffTop + bb.y1 + bb.y2 + diffBottom) / 2;
    }
    for(var i = 0; i < this.length; i++){
        var ele = this[i];
        var _p = ele._private;
        if (!_p.compoundBoundsClean || force) {
            update(ele);
            if (!cy.batching()) _p.compoundBoundsClean = true;
        }
    }
    return this;
};
var $e815fda779bc047b$var$noninf = function noninf(x) {
    if (x === Infinity || x === -Infinity) return 0;
    return x;
};
var $e815fda779bc047b$var$updateBounds = function updateBounds(b, x1, y1, x2, y2) {
    // don't update with zero area boxes
    if (x2 - x1 === 0 || y2 - y1 === 0) return;
    // don't update with null dim
    if (x1 == null || y1 == null || x2 == null || y2 == null) return;
    b.x1 = x1 < b.x1 ? x1 : b.x1;
    b.x2 = x2 > b.x2 ? x2 : b.x2;
    b.y1 = y1 < b.y1 ? y1 : b.y1;
    b.y2 = y2 > b.y2 ? y2 : b.y2;
    b.w = b.x2 - b.x1;
    b.h = b.y2 - b.y1;
};
var $e815fda779bc047b$var$updateBoundsFromBox = function updateBoundsFromBox(b, b2) {
    if (b2 == null) return b;
    return $e815fda779bc047b$var$updateBounds(b, b2.x1, b2.y1, b2.x2, b2.y2);
};
var $e815fda779bc047b$var$prefixedProperty = function prefixedProperty(obj, field, prefix) {
    return $e815fda779bc047b$var$getPrefixedProperty(obj, field, prefix);
};
var $e815fda779bc047b$var$updateBoundsFromArrow = function updateBoundsFromArrow(bounds, ele, prefix) {
    if (ele.cy().headless()) return;
    var _p = ele._private;
    var rstyle = _p.rstyle;
    var halfArW = rstyle.arrowWidth / 2;
    var arrowType = ele.pstyle(prefix + '-arrow-shape').value;
    var x;
    var y;
    if (arrowType !== 'none') {
        if (prefix === 'source') {
            x = rstyle.srcX;
            y = rstyle.srcY;
        } else if (prefix === 'target') {
            x = rstyle.tgtX;
            y = rstyle.tgtY;
        } else {
            x = rstyle.midX;
            y = rstyle.midY;
        }
        // always store the individual arrow bounds
        var bbs = _p.arrowBounds = _p.arrowBounds || {};
        var bb = bbs[prefix] = bbs[prefix] || {};
        bb.x1 = x - halfArW;
        bb.y1 = y - halfArW;
        bb.x2 = x + halfArW;
        bb.y2 = y + halfArW;
        bb.w = bb.x2 - bb.x1;
        bb.h = bb.y2 - bb.y1;
        $e815fda779bc047b$var$expandBoundingBox(bb, 1);
        $e815fda779bc047b$var$updateBounds(bounds, bb.x1, bb.y1, bb.x2, bb.y2);
    }
};
var $e815fda779bc047b$var$updateBoundsFromLabel = function updateBoundsFromLabel(bounds, ele, prefix) {
    if (ele.cy().headless()) return;
    var prefixDash;
    if (prefix) prefixDash = prefix + '-';
    else prefixDash = '';
    var _p = ele._private;
    var rstyle = _p.rstyle;
    var label = ele.pstyle(prefixDash + 'label').strValue;
    if (label) {
        var halign = ele.pstyle('text-halign');
        var valign = ele.pstyle('text-valign');
        var labelWidth = $e815fda779bc047b$var$prefixedProperty(rstyle, 'labelWidth', prefix);
        var labelHeight = $e815fda779bc047b$var$prefixedProperty(rstyle, 'labelHeight', prefix);
        var labelX = $e815fda779bc047b$var$prefixedProperty(rstyle, 'labelX', prefix);
        var labelY = $e815fda779bc047b$var$prefixedProperty(rstyle, 'labelY', prefix);
        var marginX = ele.pstyle(prefixDash + 'text-margin-x').pfValue;
        var marginY = ele.pstyle(prefixDash + 'text-margin-y').pfValue;
        var isEdge = ele.isEdge();
        var rotation = ele.pstyle(prefixDash + 'text-rotation');
        var outlineWidth = ele.pstyle('text-outline-width').pfValue;
        var borderWidth = ele.pstyle('text-border-width').pfValue;
        var halfBorderWidth = borderWidth / 2;
        var padding = ele.pstyle('text-background-padding').pfValue;
        var marginOfError = 2; // expand to work around browser dimension inaccuracies
        var lh = labelHeight;
        var lw = labelWidth;
        var lw_2 = lw / 2;
        var lh_2 = lh / 2;
        var lx1, lx2, ly1, ly2;
        if (isEdge) {
            lx1 = labelX - lw_2;
            lx2 = labelX + lw_2;
            ly1 = labelY - lh_2;
            ly2 = labelY + lh_2;
        } else {
            switch(halign.value){
                case 'left':
                    lx1 = labelX - lw;
                    lx2 = labelX;
                    break;
                case 'center':
                    lx1 = labelX - lw_2;
                    lx2 = labelX + lw_2;
                    break;
                case 'right':
                    lx1 = labelX;
                    lx2 = labelX + lw;
                    break;
            }
            switch(valign.value){
                case 'top':
                    ly1 = labelY - lh;
                    ly2 = labelY;
                    break;
                case 'center':
                    ly1 = labelY - lh_2;
                    ly2 = labelY + lh_2;
                    break;
                case 'bottom':
                    ly1 = labelY;
                    ly2 = labelY + lh;
                    break;
            }
        }
        // shift by margin and expand by outline and border
        var leftPad = marginX - Math.max(outlineWidth, halfBorderWidth) - padding - marginOfError;
        var rightPad = marginX + Math.max(outlineWidth, halfBorderWidth) + padding + marginOfError;
        var topPad = marginY - Math.max(outlineWidth, halfBorderWidth) - padding - marginOfError;
        var botPad = marginY + Math.max(outlineWidth, halfBorderWidth) + padding + marginOfError;
        lx1 += leftPad;
        lx2 += rightPad;
        ly1 += topPad;
        ly2 += botPad;
        // always store the unrotated label bounds separately
        var bbPrefix = prefix || 'main';
        var bbs = _p.labelBounds;
        var bb = bbs[bbPrefix] = bbs[bbPrefix] || {};
        bb.x1 = lx1;
        bb.y1 = ly1;
        bb.x2 = lx2;
        bb.y2 = ly2;
        bb.w = lx2 - lx1;
        bb.h = ly2 - ly1;
        bb.leftPad = leftPad;
        bb.rightPad = rightPad;
        bb.topPad = topPad;
        bb.botPad = botPad;
        var isAutorotate = isEdge && rotation.strValue === 'autorotate';
        var isPfValue = rotation.pfValue != null && rotation.pfValue !== 0;
        if (isAutorotate || isPfValue) {
            var theta = isAutorotate ? $e815fda779bc047b$var$prefixedProperty(_p.rstyle, 'labelAngle', prefix) : rotation.pfValue;
            var cos = Math.cos(theta);
            var sin = Math.sin(theta);
            // rotation point (default value for center-center)
            var xo = (lx1 + lx2) / 2;
            var yo = (ly1 + ly2) / 2;
            if (!isEdge) {
                switch(halign.value){
                    case 'left':
                        xo = lx2;
                        break;
                    case 'right':
                        xo = lx1;
                        break;
                }
                switch(valign.value){
                    case 'top':
                        yo = ly2;
                        break;
                    case 'bottom':
                        yo = ly1;
                        break;
                }
            }
            var rotate = function rotate(x, y) {
                x = x - xo;
                y = y - yo;
                return {
                    x: x * cos - y * sin + xo,
                    y: x * sin + y * cos + yo
                };
            };
            var px1y1 = rotate(lx1, ly1);
            var px1y2 = rotate(lx1, ly2);
            var px2y1 = rotate(lx2, ly1);
            var px2y2 = rotate(lx2, ly2);
            lx1 = Math.min(px1y1.x, px1y2.x, px2y1.x, px2y2.x);
            lx2 = Math.max(px1y1.x, px1y2.x, px2y1.x, px2y2.x);
            ly1 = Math.min(px1y1.y, px1y2.y, px2y1.y, px2y2.y);
            ly2 = Math.max(px1y1.y, px1y2.y, px2y1.y, px2y2.y);
        }
        var bbPrefixRot = bbPrefix + 'Rot';
        var bbRot = bbs[bbPrefixRot] = bbs[bbPrefixRot] || {};
        bbRot.x1 = lx1;
        bbRot.y1 = ly1;
        bbRot.x2 = lx2;
        bbRot.y2 = ly2;
        bbRot.w = lx2 - lx1;
        bbRot.h = ly2 - ly1;
        $e815fda779bc047b$var$updateBounds(bounds, lx1, ly1, lx2, ly2);
        $e815fda779bc047b$var$updateBounds(_p.labelBounds.all, lx1, ly1, lx2, ly2);
    }
    return bounds;
};
var $e815fda779bc047b$var$updateBoundsFromOutline = function updateBoundsFromOutline(bounds, ele) {
    if (ele.cy().headless()) return;
    var outlineOpacity = ele.pstyle('outline-opacity').value;
    var outlineWidth = ele.pstyle('outline-width').value;
    var outlineOffset = ele.pstyle('outline-offset').value;
    var expansion = outlineWidth + outlineOffset;
    $e815fda779bc047b$var$updateBoundsFromMiter(bounds, ele, outlineOpacity, expansion, 'outside', expansion / 2);
};
var $e815fda779bc047b$var$updateBoundsFromMiter = function updateBoundsFromMiter(bounds, ele, opacity, expansionSize, expansionPosition, useFallbackValue) {
    if (opacity === 0 || expansionSize <= 0 || expansionPosition === 'inside') return;
    var cy = ele.cy();
    var r = cy.renderer();
    var rshape = r.nodeShapes[r.getNodeShape(ele)];
    if (!rshape) return;
    var _ele$position = ele.position(), x = _ele$position.x, y = _ele$position.y;
    var w = ele.width();
    var h = ele.height();
    if (rshape.hasMiterBounds) {
        if (expansionPosition === 'center') expansionSize /= 2;
        var mbb = rshape.miterBounds(x, y, w, h, expansionSize);
        $e815fda779bc047b$var$updateBoundsFromBox(bounds, mbb);
    } else if (useFallbackValue != null && useFallbackValue > 0) $e815fda779bc047b$var$expandBoundingBoxSides(bounds, [
        useFallbackValue,
        useFallbackValue,
        useFallbackValue,
        useFallbackValue
    ]);
};
var $e815fda779bc047b$var$updateBoundsFromMiterBorder = function updateBoundsFromMiterBorder(bounds, ele) {
    if (ele.cy().headless()) return;
    var borderOpacity = ele.pstyle('border-opacity').value;
    var borderWidth = ele.pstyle('border-width').pfValue;
    var borderPosition = ele.pstyle('border-position').value;
    $e815fda779bc047b$var$updateBoundsFromMiter(bounds, ele, borderOpacity, borderWidth, borderPosition);
};
// get the bounding box of the elements (in raw model position)
var $e815fda779bc047b$var$boundingBoxImpl = function boundingBoxImpl(ele, options) {
    var cy = ele._private.cy;
    var styleEnabled = cy.styleEnabled();
    var headless = cy.headless();
    var bounds = $e815fda779bc047b$var$makeBoundingBox();
    var _p = ele._private;
    var isNode = ele.isNode();
    var isEdge = ele.isEdge();
    var ex1, ex2, ey1, ey2; // extrema of body / lines
    var x, y; // node pos
    var rstyle = _p.rstyle;
    var manualExpansion = isNode && styleEnabled ? ele.pstyle('bounds-expansion').pfValue : [
        0
    ];
    // must use `display` prop only, as reading `compound.width()` causes recursion
    // (other factors like width values will be considered later in this function anyway)
    var isDisplayed = function isDisplayed(ele) {
        return ele.pstyle('display').value !== 'none';
    };
    var displayed = !styleEnabled || isDisplayed(ele) && (!isEdge || isDisplayed(ele.source()) && isDisplayed(ele.target()));
    if (displayed) {
        // displayed suffices, since we will find zero area eles anyway
        var overlayOpacity = 0;
        var overlayPadding = 0;
        if (styleEnabled && options.includeOverlays) {
            overlayOpacity = ele.pstyle('overlay-opacity').value;
            if (overlayOpacity !== 0) overlayPadding = ele.pstyle('overlay-padding').value;
        }
        var underlayOpacity = 0;
        var underlayPadding = 0;
        if (styleEnabled && options.includeUnderlays) {
            underlayOpacity = ele.pstyle('underlay-opacity').value;
            if (underlayOpacity !== 0) underlayPadding = ele.pstyle('underlay-padding').value;
        }
        var padding = Math.max(overlayPadding, underlayPadding);
        var w = 0;
        var wHalf = 0;
        if (styleEnabled) {
            w = ele.pstyle('width').pfValue;
            wHalf = w / 2;
        }
        if (isNode && options.includeNodes) {
            var pos = ele.position();
            x = pos.x;
            y = pos.y;
            var _w = ele.outerWidth();
            var halfW = _w / 2;
            var h = ele.outerHeight();
            var halfH = h / 2;
            // handle node dimensions
            /////////////////////////
            ex1 = x - halfW;
            ex2 = x + halfW;
            ey1 = y - halfH;
            ey2 = y + halfH;
            $e815fda779bc047b$var$updateBounds(bounds, ex1, ey1, ex2, ey2);
            if (styleEnabled) $e815fda779bc047b$var$updateBoundsFromOutline(bounds, ele);
            if (styleEnabled && options.includeOutlines && !headless) $e815fda779bc047b$var$updateBoundsFromOutline(bounds, ele);
            if (styleEnabled) $e815fda779bc047b$var$updateBoundsFromMiterBorder(bounds, ele);
        } else if (isEdge && options.includeEdges) {
            if (styleEnabled && !headless) {
                var curveStyle = ele.pstyle('curve-style').strValue;
                // handle edge dimensions (rough box estimate)
                //////////////////////////////////////////////
                ex1 = Math.min(rstyle.srcX, rstyle.midX, rstyle.tgtX);
                ex2 = Math.max(rstyle.srcX, rstyle.midX, rstyle.tgtX);
                ey1 = Math.min(rstyle.srcY, rstyle.midY, rstyle.tgtY);
                ey2 = Math.max(rstyle.srcY, rstyle.midY, rstyle.tgtY);
                // take into account edge width
                ex1 -= wHalf;
                ex2 += wHalf;
                ey1 -= wHalf;
                ey2 += wHalf;
                $e815fda779bc047b$var$updateBounds(bounds, ex1, ey1, ex2, ey2);
                // precise edges
                ////////////////
                if (curveStyle === 'haystack') {
                    var hpts = rstyle.haystackPts;
                    if (hpts && hpts.length === 2) {
                        ex1 = hpts[0].x;
                        ey1 = hpts[0].y;
                        ex2 = hpts[1].x;
                        ey2 = hpts[1].y;
                        if (ex1 > ex2) {
                            var temp = ex1;
                            ex1 = ex2;
                            ex2 = temp;
                        }
                        if (ey1 > ey2) {
                            var _temp = ey1;
                            ey1 = ey2;
                            ey2 = _temp;
                        }
                        $e815fda779bc047b$var$updateBounds(bounds, ex1 - wHalf, ey1 - wHalf, ex2 + wHalf, ey2 + wHalf);
                    }
                } else if (curveStyle === 'bezier' || curveStyle === 'unbundled-bezier' || $e815fda779bc047b$var$endsWith(curveStyle, 'segments') || $e815fda779bc047b$var$endsWith(curveStyle, 'taxi')) {
                    var pts;
                    switch(curveStyle){
                        case 'bezier':
                        case 'unbundled-bezier':
                            pts = rstyle.bezierPts;
                            break;
                        case 'segments':
                        case 'taxi':
                        case 'round-segments':
                        case 'round-taxi':
                            pts = rstyle.linePts;
                            break;
                    }
                    if (pts != null) for(var j = 0; j < pts.length; j++){
                        var pt = pts[j];
                        ex1 = pt.x - wHalf;
                        ex2 = pt.x + wHalf;
                        ey1 = pt.y - wHalf;
                        ey2 = pt.y + wHalf;
                        $e815fda779bc047b$var$updateBounds(bounds, ex1, ey1, ex2, ey2);
                    }
                } // bezier-like or segment-like edge
            } else {
                // headless or style disabled
                // fallback on source and target positions
                //////////////////////////////////////////
                var n1 = ele.source();
                var n1pos = n1.position();
                var n2 = ele.target();
                var n2pos = n2.position();
                ex1 = n1pos.x;
                ex2 = n2pos.x;
                ey1 = n1pos.y;
                ey2 = n2pos.y;
                if (ex1 > ex2) {
                    var _temp2 = ex1;
                    ex1 = ex2;
                    ex2 = _temp2;
                }
                if (ey1 > ey2) {
                    var _temp3 = ey1;
                    ey1 = ey2;
                    ey2 = _temp3;
                }
                // take into account edge width
                ex1 -= wHalf;
                ex2 += wHalf;
                ey1 -= wHalf;
                ey2 += wHalf;
                $e815fda779bc047b$var$updateBounds(bounds, ex1, ey1, ex2, ey2);
            } // headless or style disabled
        } // edges
        // handle edge arrow size
        /////////////////////////
        if (styleEnabled && options.includeEdges && isEdge) {
            $e815fda779bc047b$var$updateBoundsFromArrow(bounds, ele, 'mid-source');
            $e815fda779bc047b$var$updateBoundsFromArrow(bounds, ele, 'mid-target');
            $e815fda779bc047b$var$updateBoundsFromArrow(bounds, ele, 'source');
            $e815fda779bc047b$var$updateBoundsFromArrow(bounds, ele, 'target');
        }
        // ghost
        ////////
        if (styleEnabled) {
            var ghost = ele.pstyle('ghost').value === 'yes';
            if (ghost) {
                var gx = ele.pstyle('ghost-offset-x').pfValue;
                var gy = ele.pstyle('ghost-offset-y').pfValue;
                $e815fda779bc047b$var$updateBounds(bounds, bounds.x1 + gx, bounds.y1 + gy, bounds.x2 + gx, bounds.y2 + gy);
            }
        }
        // always store the body bounds separately from the labels
        var bbBody = _p.bodyBounds = _p.bodyBounds || {};
        $e815fda779bc047b$var$assignBoundingBox(bbBody, bounds);
        $e815fda779bc047b$var$expandBoundingBoxSides(bbBody, manualExpansion);
        $e815fda779bc047b$var$expandBoundingBox(bbBody, 1); // expand to work around browser dimension inaccuracies
        // overlay
        //////////
        if (styleEnabled) {
            ex1 = bounds.x1;
            ex2 = bounds.x2;
            ey1 = bounds.y1;
            ey2 = bounds.y2;
            $e815fda779bc047b$var$updateBounds(bounds, ex1 - padding, ey1 - padding, ex2 + padding, ey2 + padding);
        }
        // always store the body bounds separately from the labels
        var bbOverlay = _p.overlayBounds = _p.overlayBounds || {};
        $e815fda779bc047b$var$assignBoundingBox(bbOverlay, bounds);
        $e815fda779bc047b$var$expandBoundingBoxSides(bbOverlay, manualExpansion);
        $e815fda779bc047b$var$expandBoundingBox(bbOverlay, 1); // expand to work around browser dimension inaccuracies
        // handle label dimensions
        //////////////////////////
        var bbLabels = _p.labelBounds = _p.labelBounds || {};
        if (bbLabels.all != null) $e815fda779bc047b$var$clearBoundingBox(bbLabels.all);
        else bbLabels.all = $e815fda779bc047b$var$makeBoundingBox();
        if (styleEnabled && options.includeLabels) {
            if (options.includeMainLabels) $e815fda779bc047b$var$updateBoundsFromLabel(bounds, ele, null);
            if (isEdge) {
                if (options.includeSourceLabels) $e815fda779bc047b$var$updateBoundsFromLabel(bounds, ele, 'source');
                if (options.includeTargetLabels) $e815fda779bc047b$var$updateBoundsFromLabel(bounds, ele, 'target');
            }
        } // style enabled for labels
    } // if displayed
    bounds.x1 = $e815fda779bc047b$var$noninf(bounds.x1);
    bounds.y1 = $e815fda779bc047b$var$noninf(bounds.y1);
    bounds.x2 = $e815fda779bc047b$var$noninf(bounds.x2);
    bounds.y2 = $e815fda779bc047b$var$noninf(bounds.y2);
    bounds.w = $e815fda779bc047b$var$noninf(bounds.x2 - bounds.x1);
    bounds.h = $e815fda779bc047b$var$noninf(bounds.y2 - bounds.y1);
    if (bounds.w > 0 && bounds.h > 0 && displayed) {
        $e815fda779bc047b$var$expandBoundingBoxSides(bounds, manualExpansion);
        // expand bounds by 1 because antialiasing can increase the visual/effective size by 1 on all sides
        $e815fda779bc047b$var$expandBoundingBox(bounds, 1);
    }
    return bounds;
};
var $e815fda779bc047b$var$getKey = function getKey(opts) {
    var i = 0;
    var tf = function tf(val) {
        return (val ? 1 : 0) << i++;
    };
    var key = 0;
    key += tf(opts.incudeNodes);
    key += tf(opts.includeEdges);
    key += tf(opts.includeLabels);
    key += tf(opts.includeMainLabels);
    key += tf(opts.includeSourceLabels);
    key += tf(opts.includeTargetLabels);
    key += tf(opts.includeOverlays);
    key += tf(opts.includeOutlines);
    return key;
};
var $e815fda779bc047b$var$getBoundingBoxPosKey = function getBoundingBoxPosKey(ele) {
    var r = function r(x) {
        return Math.round(x);
    };
    if (ele.isEdge()) {
        var p1 = ele.source().position();
        var p2 = ele.target().position();
        return $e815fda779bc047b$var$hashIntsArray([
            r(p1.x),
            r(p1.y),
            r(p2.x),
            r(p2.y)
        ]);
    } else {
        var p = ele.position();
        return $e815fda779bc047b$var$hashIntsArray([
            r(p.x),
            r(p.y)
        ]);
    }
};
var $e815fda779bc047b$var$cachedBoundingBoxImpl = function cachedBoundingBoxImpl(ele, opts) {
    var _p = ele._private;
    var bb;
    var isEdge = ele.isEdge();
    var key = opts == null ? $e815fda779bc047b$var$defBbOptsKey : $e815fda779bc047b$var$getKey(opts);
    var usingDefOpts = key === $e815fda779bc047b$var$defBbOptsKey;
    if (_p.bbCache == null) {
        bb = $e815fda779bc047b$var$boundingBoxImpl(ele, $e815fda779bc047b$var$defBbOpts);
        _p.bbCache = bb;
        _p.bbCachePosKey = $e815fda779bc047b$var$getBoundingBoxPosKey(ele);
    } else bb = _p.bbCache;
    // not using def opts => need to build up bb from combination of sub bbs
    if (!usingDefOpts) {
        var isNode = ele.isNode();
        bb = $e815fda779bc047b$var$makeBoundingBox();
        if (opts.includeNodes && isNode || opts.includeEdges && !isNode) {
            if (opts.includeOverlays) $e815fda779bc047b$var$updateBoundsFromBox(bb, _p.overlayBounds);
            else $e815fda779bc047b$var$updateBoundsFromBox(bb, _p.bodyBounds);
        }
        if (opts.includeLabels) {
            if (opts.includeMainLabels && (!isEdge || opts.includeSourceLabels && opts.includeTargetLabels)) $e815fda779bc047b$var$updateBoundsFromBox(bb, _p.labelBounds.all);
            else {
                if (opts.includeMainLabels) $e815fda779bc047b$var$updateBoundsFromBox(bb, _p.labelBounds.mainRot);
                if (opts.includeSourceLabels) $e815fda779bc047b$var$updateBoundsFromBox(bb, _p.labelBounds.sourceRot);
                if (opts.includeTargetLabels) $e815fda779bc047b$var$updateBoundsFromBox(bb, _p.labelBounds.targetRot);
            }
        }
        bb.w = bb.x2 - bb.x1;
        bb.h = bb.y2 - bb.y1;
    }
    return bb;
};
var $e815fda779bc047b$var$defBbOpts = {
    includeNodes: true,
    includeEdges: true,
    includeLabels: true,
    includeMainLabels: true,
    includeSourceLabels: true,
    includeTargetLabels: true,
    includeOverlays: true,
    includeUnderlays: true,
    includeOutlines: true,
    useCache: true
};
var $e815fda779bc047b$var$defBbOptsKey = $e815fda779bc047b$var$getKey($e815fda779bc047b$var$defBbOpts);
var $e815fda779bc047b$var$filledBbOpts = $e815fda779bc047b$var$defaults$g($e815fda779bc047b$var$defBbOpts);
$e815fda779bc047b$var$elesfn$b.boundingBox = function(options) {
    var bounds;
    var useCache = options === undefined || options.useCache === undefined || options.useCache === true;
    var isDirty = $e815fda779bc047b$var$memoize(function(ele) {
        var _p = ele._private;
        return _p.bbCache == null || _p.styleDirty || _p.bbCachePosKey !== $e815fda779bc047b$var$getBoundingBoxPosKey(ele);
    }, function(ele) {
        return ele.id();
    });
    // the main usecase is ele.boundingBox() for a single element with no/def options
    // specified s.t. the cache is used, so check for this case to make it faster by
    // avoiding the overhead of the rest of the function
    if (useCache && this.length === 1 && !isDirty(this[0])) {
        if (options === undefined) options = $e815fda779bc047b$var$defBbOpts;
        else options = $e815fda779bc047b$var$filledBbOpts(options);
        bounds = $e815fda779bc047b$var$cachedBoundingBoxImpl(this[0], options);
    } else {
        bounds = $e815fda779bc047b$var$makeBoundingBox();
        options = options || $e815fda779bc047b$var$defBbOpts;
        var opts = $e815fda779bc047b$var$filledBbOpts(options);
        var eles = this;
        var cy = eles.cy();
        var styleEnabled = cy.styleEnabled();
        // cache the isDirty state for all eles, edges first since they depend on node state
        this.edges().forEach(isDirty);
        this.nodes().forEach(isDirty);
        if (styleEnabled) this.recalculateRenderedStyle(useCache);
        this.updateCompoundBounds(!useCache);
        for(var i = 0; i < eles.length; i++){
            var ele = eles[i];
            if (isDirty(ele)) ele.dirtyBoundingBoxCache();
            $e815fda779bc047b$var$updateBoundsFromBox(bounds, $e815fda779bc047b$var$cachedBoundingBoxImpl(ele, opts));
        }
    }
    bounds.x1 = $e815fda779bc047b$var$noninf(bounds.x1);
    bounds.y1 = $e815fda779bc047b$var$noninf(bounds.y1);
    bounds.x2 = $e815fda779bc047b$var$noninf(bounds.x2);
    bounds.y2 = $e815fda779bc047b$var$noninf(bounds.y2);
    bounds.w = $e815fda779bc047b$var$noninf(bounds.x2 - bounds.x1);
    bounds.h = $e815fda779bc047b$var$noninf(bounds.y2 - bounds.y1);
    return bounds;
};
$e815fda779bc047b$var$elesfn$b.dirtyBoundingBoxCache = function() {
    for(var i = 0; i < this.length; i++){
        var _p = this[i]._private;
        _p.bbCache = null;
        _p.bbCachePosKey = null;
        _p.bodyBounds = null;
        _p.overlayBounds = null;
        _p.labelBounds.all = null;
        _p.labelBounds.source = null;
        _p.labelBounds.target = null;
        _p.labelBounds.main = null;
        _p.labelBounds.sourceRot = null;
        _p.labelBounds.targetRot = null;
        _p.labelBounds.mainRot = null;
        _p.arrowBounds.source = null;
        _p.arrowBounds.target = null;
        _p.arrowBounds['mid-source'] = null;
        _p.arrowBounds['mid-target'] = null;
    }
    this.emitAndNotify('bounds');
    return this;
};
// private helper to get bounding box for custom node positions
// - good for perf in certain cases but currently requires dirtying the rendered style
// - would be better to not modify the nodes but the nodes are read directly everywhere in the renderer...
// - try to use for only things like discrete layouts where the node position would change anyway
$e815fda779bc047b$var$elesfn$b.boundingBoxAt = function(fn) {
    var nodes = this.nodes();
    var cy = this.cy();
    var hasCompoundNodes = cy.hasCompoundNodes();
    var parents = cy.collection();
    if (hasCompoundNodes) {
        parents = nodes.filter(function(node) {
            return node.isParent();
        });
        nodes = nodes.not(parents);
    }
    if ($e815fda779bc047b$var$plainObject(fn)) {
        var obj = fn;
        fn = function fn() {
            return obj;
        };
    }
    var storeOldPos = function storeOldPos(node, i) {
        return node._private.bbAtOldPos = fn(node, i);
    };
    var getOldPos = function getOldPos(node) {
        return node._private.bbAtOldPos;
    };
    cy.startBatch();
    nodes.forEach(storeOldPos).silentPositions(fn);
    if (hasCompoundNodes) {
        parents.dirtyCompoundBoundsCache();
        parents.dirtyBoundingBoxCache();
        parents.updateCompoundBounds(true); // force update b/c we're inside a batch cycle
    }
    var bb = $e815fda779bc047b$var$copyBoundingBox(this.boundingBox({
        useCache: false
    }));
    nodes.silentPositions(getOldPos);
    if (hasCompoundNodes) {
        parents.dirtyCompoundBoundsCache();
        parents.dirtyBoundingBoxCache();
        parents.updateCompoundBounds(true); // force update b/c we're inside a batch cycle
    }
    cy.endBatch();
    return bb;
};
$e815fda779bc047b$var$fn$3.boundingbox = $e815fda779bc047b$var$fn$3.bb = $e815fda779bc047b$var$fn$3.boundingBox;
$e815fda779bc047b$var$fn$3.renderedBoundingbox = $e815fda779bc047b$var$fn$3.renderedBoundingBox;
var $e815fda779bc047b$var$bounds = $e815fda779bc047b$var$elesfn$b;
var $e815fda779bc047b$var$fn$2, $e815fda779bc047b$var$elesfn$a;
$e815fda779bc047b$var$fn$2 = $e815fda779bc047b$var$elesfn$a = {};
var $e815fda779bc047b$var$defineDimFns = function defineDimFns(opts) {
    opts.uppercaseName = $e815fda779bc047b$var$capitalize(opts.name);
    opts.autoName = 'auto' + opts.uppercaseName;
    opts.labelName = 'label' + opts.uppercaseName;
    opts.outerName = 'outer' + opts.uppercaseName;
    opts.uppercaseOuterName = $e815fda779bc047b$var$capitalize(opts.outerName);
    $e815fda779bc047b$var$fn$2[opts.name] = function dimImpl() {
        var ele = this[0];
        var _p = ele._private;
        var cy = _p.cy;
        var styleEnabled = cy._private.styleEnabled;
        if (ele) {
            if (styleEnabled) {
                if (ele.isParent()) {
                    ele.updateCompoundBounds();
                    return _p[opts.autoName] || 0;
                }
                var d = ele.pstyle(opts.name);
                switch(d.strValue){
                    case 'label':
                        ele.recalculateRenderedStyle();
                        return _p.rstyle[opts.labelName] || 0;
                    default:
                        return d.pfValue;
                }
            } else return 1;
        }
    };
    $e815fda779bc047b$var$fn$2['outer' + opts.uppercaseName] = function outerDimImpl() {
        var ele = this[0];
        var _p = ele._private;
        var cy = _p.cy;
        var styleEnabled = cy._private.styleEnabled;
        if (ele) {
            if (styleEnabled) {
                var dim = ele[opts.name]();
                var borderPos = ele.pstyle('border-position').value;
                var border;
                if (borderPos === 'center') border = ele.pstyle('border-width').pfValue; // n.b. 1/2 each side
                else if (borderPos === 'outside') border = 2 * ele.pstyle('border-width').pfValue;
                else // 'inside'
                border = 0;
                var padding = 2 * ele.padding();
                return dim + border + padding;
            } else return 1;
        }
    };
    $e815fda779bc047b$var$fn$2['rendered' + opts.uppercaseName] = function renderedDimImpl() {
        var ele = this[0];
        if (ele) {
            var d = ele[opts.name]();
            return d * this.cy().zoom();
        }
    };
    $e815fda779bc047b$var$fn$2['rendered' + opts.uppercaseOuterName] = function renderedOuterDimImpl() {
        var ele = this[0];
        if (ele) {
            var od = ele[opts.outerName]();
            return od * this.cy().zoom();
        }
    };
};
$e815fda779bc047b$var$defineDimFns({
    name: 'width'
});
$e815fda779bc047b$var$defineDimFns({
    name: 'height'
});
$e815fda779bc047b$var$elesfn$a.padding = function() {
    var ele = this[0];
    var _p = ele._private;
    if (ele.isParent()) {
        ele.updateCompoundBounds();
        if (_p.autoPadding !== undefined) return _p.autoPadding;
        else return ele.pstyle('padding').pfValue;
    } else return ele.pstyle('padding').pfValue;
};
$e815fda779bc047b$var$elesfn$a.paddedHeight = function() {
    var ele = this[0];
    return ele.height() + 2 * ele.padding();
};
$e815fda779bc047b$var$elesfn$a.paddedWidth = function() {
    var ele = this[0];
    return ele.width() + 2 * ele.padding();
};
var $e815fda779bc047b$var$widthHeight = $e815fda779bc047b$var$elesfn$a;
var $e815fda779bc047b$var$ifEdge = function ifEdge(ele, getValue) {
    if (ele.isEdge() && ele.takesUpSpace()) return getValue(ele);
};
var $e815fda779bc047b$var$ifEdgeRenderedPosition = function ifEdgeRenderedPosition(ele, getPoint) {
    if (ele.isEdge() && ele.takesUpSpace()) {
        var cy = ele.cy();
        return $e815fda779bc047b$var$modelToRenderedPosition$1(getPoint(ele), cy.zoom(), cy.pan());
    }
};
var $e815fda779bc047b$var$ifEdgeRenderedPositions = function ifEdgeRenderedPositions(ele, getPoints) {
    if (ele.isEdge() && ele.takesUpSpace()) {
        var cy = ele.cy();
        var pan = cy.pan();
        var zoom = cy.zoom();
        return getPoints(ele).map(function(p) {
            return $e815fda779bc047b$var$modelToRenderedPosition$1(p, zoom, pan);
        });
    }
};
var $e815fda779bc047b$var$controlPoints = function controlPoints(ele) {
    return ele.renderer().getControlPoints(ele);
};
var $e815fda779bc047b$var$segmentPoints = function segmentPoints(ele) {
    return ele.renderer().getSegmentPoints(ele);
};
var $e815fda779bc047b$var$sourceEndpoint = function sourceEndpoint(ele) {
    return ele.renderer().getSourceEndpoint(ele);
};
var $e815fda779bc047b$var$targetEndpoint = function targetEndpoint(ele) {
    return ele.renderer().getTargetEndpoint(ele);
};
var $e815fda779bc047b$var$midpoint = function midpoint(ele) {
    return ele.renderer().getEdgeMidpoint(ele);
};
var $e815fda779bc047b$var$pts = {
    controlPoints: {
        get: $e815fda779bc047b$var$controlPoints,
        mult: true
    },
    segmentPoints: {
        get: $e815fda779bc047b$var$segmentPoints,
        mult: true
    },
    sourceEndpoint: {
        get: $e815fda779bc047b$var$sourceEndpoint
    },
    targetEndpoint: {
        get: $e815fda779bc047b$var$targetEndpoint
    },
    midpoint: {
        get: $e815fda779bc047b$var$midpoint
    }
};
var $e815fda779bc047b$var$renderedName = function renderedName(name) {
    return 'rendered' + name[0].toUpperCase() + name.substr(1);
};
var $e815fda779bc047b$var$edgePoints = Object.keys($e815fda779bc047b$var$pts).reduce(function(obj, name) {
    var spec = $e815fda779bc047b$var$pts[name];
    var rName = $e815fda779bc047b$var$renderedName(name);
    obj[name] = function() {
        return $e815fda779bc047b$var$ifEdge(this, spec.get);
    };
    if (spec.mult) obj[rName] = function() {
        return $e815fda779bc047b$var$ifEdgeRenderedPositions(this, spec.get);
    };
    else obj[rName] = function() {
        return $e815fda779bc047b$var$ifEdgeRenderedPosition(this, spec.get);
    };
    return obj;
}, {});
var $e815fda779bc047b$var$dimensions = $e815fda779bc047b$var$extend({}, $e815fda779bc047b$var$position, $e815fda779bc047b$var$bounds, $e815fda779bc047b$var$widthHeight, $e815fda779bc047b$var$edgePoints);
/*!
Event object based on jQuery events, MIT license

https://jquery.org/license/
https://tldrlegal.com/license/mit-license
https://github.com/jquery/jquery/blob/master/src/event.js
*/ var $e815fda779bc047b$var$Event = function Event(src, props) {
    this.recycle(src, props);
};
function $e815fda779bc047b$var$returnFalse() {
    return false;
}
function $e815fda779bc047b$var$returnTrue() {
    return true;
}
// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
$e815fda779bc047b$var$Event.prototype = {
    instanceString: function instanceString() {
        return 'event';
    },
    recycle: function recycle(src, props) {
        this.isImmediatePropagationStopped = this.isPropagationStopped = this.isDefaultPrevented = $e815fda779bc047b$var$returnFalse;
        if (src != null && src.preventDefault) {
            // Browser Event object
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented ? $e815fda779bc047b$var$returnTrue : $e815fda779bc047b$var$returnFalse;
        } else if (src != null && src.type) // Plain object containing all event details
        props = src;
        else // Event string
        this.type = src;
        // Put explicitly provided properties onto the event object
        if (props != null) {
            // more efficient to manually copy fields we use
            this.originalEvent = props.originalEvent;
            this.type = props.type != null ? props.type : this.type;
            this.cy = props.cy;
            this.target = props.target;
            this.position = props.position;
            this.renderedPosition = props.renderedPosition;
            this.namespace = props.namespace;
            this.layout = props.layout;
        }
        if (this.cy != null && this.position != null && this.renderedPosition == null) {
            // create a rendered position based on the passed position
            var pos = this.position;
            var zoom = this.cy.zoom();
            var pan = this.cy.pan();
            this.renderedPosition = {
                x: pos.x * zoom + pan.x,
                y: pos.y * zoom + pan.y
            };
        }
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
    },
    preventDefault: function preventDefault() {
        this.isDefaultPrevented = $e815fda779bc047b$var$returnTrue;
        var e = this.originalEvent;
        if (!e) return;
        // if preventDefault exists run it on the original event
        if (e.preventDefault) e.preventDefault();
    },
    stopPropagation: function stopPropagation() {
        this.isPropagationStopped = $e815fda779bc047b$var$returnTrue;
        var e = this.originalEvent;
        if (!e) return;
        // if stopPropagation exists run it on the original event
        if (e.stopPropagation) e.stopPropagation();
    },
    stopImmediatePropagation: function stopImmediatePropagation() {
        this.isImmediatePropagationStopped = $e815fda779bc047b$var$returnTrue;
        this.stopPropagation();
    },
    isDefaultPrevented: $e815fda779bc047b$var$returnFalse,
    isPropagationStopped: $e815fda779bc047b$var$returnFalse,
    isImmediatePropagationStopped: $e815fda779bc047b$var$returnFalse
};
var $e815fda779bc047b$var$eventRegex = /^([^.]+)(\.(?:[^.]+))?$/; // regex for matching event strings (e.g. "click.namespace")
var $e815fda779bc047b$var$universalNamespace = '.*'; // matches as if no namespace specified and prevents users from unbinding accidentally
var $e815fda779bc047b$var$defaults$8 = {
    qualifierCompare: function qualifierCompare(q1, q2) {
        return q1 === q2;
    },
    eventMatches: function eventMatches() {
        return true;
    },
    addEventFields: function addEventFields() {},
    callbackContext: function callbackContext(context /*, listener, eventObj*/ ) {
        return context;
    },
    beforeEmit: function beforeEmit() {},
    afterEmit: function afterEmit() {},
    bubble: function bubble() {
        return false;
    },
    parent: function parent() {
        return null;
    },
    context: null
};
var $e815fda779bc047b$var$defaultsKeys = Object.keys($e815fda779bc047b$var$defaults$8);
var $e815fda779bc047b$var$emptyOpts = {};
function $e815fda779bc047b$var$Emitter() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $e815fda779bc047b$var$emptyOpts;
    var context = arguments.length > 1 ? arguments[1] : undefined;
    // micro-optimisation vs Object.assign() -- reduces Element instantiation time
    for(var i = 0; i < $e815fda779bc047b$var$defaultsKeys.length; i++){
        var key = $e815fda779bc047b$var$defaultsKeys[i];
        this[key] = opts[key] || $e815fda779bc047b$var$defaults$8[key];
    }
    this.context = context || this.context;
    this.listeners = [];
    this.emitting = 0;
}
var $e815fda779bc047b$var$p = $e815fda779bc047b$var$Emitter.prototype;
var $e815fda779bc047b$var$forEachEvent = function forEachEvent(self1, handler, events, qualifier, callback, conf, confOverrides) {
    if ($e815fda779bc047b$var$fn$6(qualifier)) {
        callback = qualifier;
        qualifier = null;
    }
    if (confOverrides) {
        if (conf == null) conf = confOverrides;
        else conf = $e815fda779bc047b$var$extend({}, conf, confOverrides);
    }
    var eventList = $e815fda779bc047b$var$array(events) ? events : events.split(/\s+/);
    for(var i = 0; i < eventList.length; i++){
        var evt = eventList[i];
        if ($e815fda779bc047b$var$emptyString(evt)) continue;
        var match = evt.match($e815fda779bc047b$var$eventRegex); // type[.namespace]
        if (match) {
            var type = match[1];
            var namespace = match[2] ? match[2] : null;
            var ret = handler(self1, evt, type, namespace, qualifier, callback, conf);
            if (ret === false) break;
             // allow exiting early
        }
    }
};
var $e815fda779bc047b$var$makeEventObj = function makeEventObj(self1, obj) {
    self1.addEventFields(self1.context, obj);
    return new $e815fda779bc047b$var$Event(obj.type, obj);
};
var $e815fda779bc047b$var$forEachEventObj = function forEachEventObj(self1, handler, events) {
    if ($e815fda779bc047b$var$event(events)) {
        handler(self1, events);
        return;
    } else if ($e815fda779bc047b$var$plainObject(events)) {
        handler(self1, $e815fda779bc047b$var$makeEventObj(self1, events));
        return;
    }
    var eventList = $e815fda779bc047b$var$array(events) ? events : events.split(/\s+/);
    for(var i = 0; i < eventList.length; i++){
        var evt = eventList[i];
        if ($e815fda779bc047b$var$emptyString(evt)) continue;
        var match = evt.match($e815fda779bc047b$var$eventRegex); // type[.namespace]
        if (match) {
            var type = match[1];
            var namespace = match[2] ? match[2] : null;
            var eventObj = $e815fda779bc047b$var$makeEventObj(self1, {
                type: type,
                namespace: namespace,
                target: self1.context
            });
            handler(self1, eventObj);
        }
    }
};
$e815fda779bc047b$var$p.on = $e815fda779bc047b$var$p.addListener = function(events, qualifier, callback, conf, confOverrides) {
    $e815fda779bc047b$var$forEachEvent(this, function(self1, event, type, namespace, qualifier, callback, conf) {
        if ($e815fda779bc047b$var$fn$6(callback)) self1.listeners.push({
            event: event,
            // full event string
            callback: callback,
            // callback to run
            type: type,
            // the event type (e.g. 'click')
            namespace: namespace,
            // the event namespace (e.g. ".foo")
            qualifier: qualifier,
            // a restriction on whether to match this emitter
            conf: conf // additional configuration
        });
    }, events, qualifier, callback, conf, confOverrides);
    return this;
};
$e815fda779bc047b$var$p.one = function(events, qualifier, callback, conf) {
    return this.on(events, qualifier, callback, conf, {
        one: true
    });
};
$e815fda779bc047b$var$p.removeListener = $e815fda779bc047b$var$p.off = function(events, qualifier, callback, conf) {
    var _this = this;
    if (this.emitting !== 0) this.listeners = $e815fda779bc047b$var$copyArray(this.listeners);
    var listeners = this.listeners;
    var _loop = function _loop(i) {
        var listener = listeners[i];
        $e815fda779bc047b$var$forEachEvent(_this, function(self1, event, type, namespace, qualifier, callback /*, conf*/ ) {
            if ((listener.type === type || events === '*') && (!namespace && listener.namespace !== '.*' || listener.namespace === namespace) && (!qualifier || self1.qualifierCompare(listener.qualifier, qualifier)) && (!callback || listener.callback === callback)) {
                listeners.splice(i, 1);
                return false;
            }
        }, events, qualifier, callback, conf);
    };
    for(var i = listeners.length - 1; i >= 0; i--)_loop(i);
    return this;
};
$e815fda779bc047b$var$p.removeAllListeners = function() {
    return this.removeListener('*');
};
$e815fda779bc047b$var$p.emit = $e815fda779bc047b$var$p.trigger = function(events, extraParams, manualCallback) {
    var listeners = this.listeners;
    var numListenersBeforeEmit = listeners.length;
    this.emitting++;
    if (!$e815fda779bc047b$var$array(extraParams)) extraParams = [
        extraParams
    ];
    $e815fda779bc047b$var$forEachEventObj(this, function(self1, eventObj) {
        if (manualCallback != null) {
            listeners = [
                {
                    event: eventObj.event,
                    type: eventObj.type,
                    namespace: eventObj.namespace,
                    callback: manualCallback
                }
            ];
            numListenersBeforeEmit = listeners.length;
        }
        var _loop2 = function _loop2() {
            var listener = listeners[i];
            if (listener.type === eventObj.type && (!listener.namespace || listener.namespace === eventObj.namespace || listener.namespace === $e815fda779bc047b$var$universalNamespace) && self1.eventMatches(self1.context, listener, eventObj)) {
                var args = [
                    eventObj
                ];
                if (extraParams != null) $e815fda779bc047b$var$push(args, extraParams);
                self1.beforeEmit(self1.context, listener, eventObj);
                if (listener.conf && listener.conf.one) self1.listeners = self1.listeners.filter(function(l) {
                    return l !== listener;
                });
                var context = self1.callbackContext(self1.context, listener, eventObj);
                var ret = listener.callback.apply(context, args);
                self1.afterEmit(self1.context, listener, eventObj);
                if (ret === false) {
                    eventObj.stopPropagation();
                    eventObj.preventDefault();
                }
            } // if listener matches
        };
        for(var i = 0; i < numListenersBeforeEmit; i++)_loop2();
         // for listener
        if (self1.bubble(self1.context) && !eventObj.isPropagationStopped()) self1.parent(self1.context).emit(eventObj, extraParams);
    }, events);
    this.emitting--;
    return this;
};
var $e815fda779bc047b$var$emitterOptions$1 = {
    qualifierCompare: function qualifierCompare(selector1, selector2) {
        if (selector1 == null || selector2 == null) return selector1 == null && selector2 == null;
        else return selector1.sameText(selector2);
    },
    eventMatches: function eventMatches(ele, listener, eventObj) {
        var selector = listener.qualifier;
        if (selector != null) return ele !== eventObj.target && $e815fda779bc047b$var$element(eventObj.target) && selector.matches(eventObj.target);
        return true;
    },
    addEventFields: function addEventFields(ele, evt) {
        evt.cy = ele.cy();
        evt.target = ele;
    },
    callbackContext: function callbackContext(ele, listener, eventObj) {
        return listener.qualifier != null ? eventObj.target : ele;
    },
    beforeEmit: function beforeEmit(context, listener /*, eventObj*/ ) {
        if (listener.conf && listener.conf.once) listener.conf.onceCollection.removeListener(listener.event, listener.qualifier, listener.callback);
    },
    bubble: function bubble() {
        return true;
    },
    parent: function parent(ele) {
        return ele.isChild() ? ele.parent() : ele.cy();
    }
};
var $e815fda779bc047b$var$argSelector$1 = function argSelector(arg) {
    if ($e815fda779bc047b$var$string(arg)) return new $e815fda779bc047b$var$Selector(arg);
    else return arg;
};
var $e815fda779bc047b$var$elesfn$9 = {
    createEmitter: function createEmitter() {
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            var _p = ele._private;
            if (!_p.emitter) _p.emitter = new $e815fda779bc047b$var$Emitter($e815fda779bc047b$var$emitterOptions$1, ele);
        }
        return this;
    },
    emitter: function emitter() {
        return this._private.emitter;
    },
    on: function on(events, selector, callback) {
        var argSel = $e815fda779bc047b$var$argSelector$1(selector);
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            ele.emitter().on(events, argSel, callback);
        }
        return this;
    },
    removeListener: function removeListener(events, selector, callback) {
        var argSel = $e815fda779bc047b$var$argSelector$1(selector);
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            ele.emitter().removeListener(events, argSel, callback);
        }
        return this;
    },
    removeAllListeners: function removeAllListeners() {
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            ele.emitter().removeAllListeners();
        }
        return this;
    },
    one: function one(events, selector, callback) {
        var argSel = $e815fda779bc047b$var$argSelector$1(selector);
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            ele.emitter().one(events, argSel, callback);
        }
        return this;
    },
    once: function once(events, selector, callback) {
        var argSel = $e815fda779bc047b$var$argSelector$1(selector);
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            ele.emitter().on(events, argSel, callback, {
                once: true,
                onceCollection: this
            });
        }
    },
    emit: function emit(events, extraParams) {
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            ele.emitter().emit(events, extraParams);
        }
        return this;
    },
    emitAndNotify: function emitAndNotify(event, extraParams) {
        // for internal use only
        if (this.length === 0) return;
         // empty collections don't need to notify anything
        // notify renderer
        this.cy().notify(event, this);
        this.emit(event, extraParams);
        return this;
    }
};
$e815fda779bc047b$var$define.eventAliasesOn($e815fda779bc047b$var$elesfn$9);
var $e815fda779bc047b$var$elesfn$8 = {
    nodes: function nodes(selector) {
        return this.filter(function(ele) {
            return ele.isNode();
        }).filter(selector);
    },
    edges: function edges(selector) {
        return this.filter(function(ele) {
            return ele.isEdge();
        }).filter(selector);
    },
    // internal helper to get nodes and edges as separate collections with single iteration over elements
    byGroup: function byGroup() {
        var nodes = this.spawn();
        var edges = this.spawn();
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            if (ele.isNode()) nodes.push(ele);
            else edges.push(ele);
        }
        return {
            nodes: nodes,
            edges: edges
        };
    },
    filter: function filter(_filter, thisArg) {
        if (_filter === undefined) // check this first b/c it's the most common/performant case
        return this;
        else if ($e815fda779bc047b$var$string(_filter) || $e815fda779bc047b$var$elementOrCollection(_filter)) return new $e815fda779bc047b$var$Selector(_filter).filter(this);
        else if ($e815fda779bc047b$var$fn$6(_filter)) {
            var filterEles = this.spawn();
            var eles = this;
            for(var i = 0; i < eles.length; i++){
                var ele = eles[i];
                var include = thisArg ? _filter.apply(thisArg, [
                    ele,
                    i,
                    eles
                ]) : _filter(ele, i, eles);
                if (include) filterEles.push(ele);
            }
            return filterEles;
        }
        return this.spawn(); // if not handled by above, give 'em an empty collection
    },
    not: function not(toRemove) {
        if (!toRemove) return this;
        else {
            if ($e815fda779bc047b$var$string(toRemove)) toRemove = this.filter(toRemove);
            var elements = this.spawn();
            for(var i = 0; i < this.length; i++){
                var element = this[i];
                var remove = toRemove.has(element);
                if (!remove) elements.push(element);
            }
            return elements;
        }
    },
    absoluteComplement: function absoluteComplement() {
        var cy = this.cy();
        return cy.mutableElements().not(this);
    },
    intersect: function intersect(other) {
        // if a selector is specified, then filter by it instead
        if ($e815fda779bc047b$var$string(other)) {
            var selector = other;
            return this.filter(selector);
        }
        var elements = this.spawn();
        var col1 = this;
        var col2 = other;
        var col1Smaller = this.length < other.length;
        var colS = col1Smaller ? col1 : col2;
        var colL = col1Smaller ? col2 : col1;
        for(var i = 0; i < colS.length; i++){
            var ele = colS[i];
            if (colL.has(ele)) elements.push(ele);
        }
        return elements;
    },
    xor: function xor(other) {
        var cy = this._private.cy;
        if ($e815fda779bc047b$var$string(other)) other = cy.$(other);
        var elements = this.spawn();
        var col1 = this;
        var col2 = other;
        var add = function add(col, other) {
            for(var i = 0; i < col.length; i++){
                var ele = col[i];
                var id = ele._private.data.id;
                var inOther = other.hasElementWithId(id);
                if (!inOther) elements.push(ele);
            }
        };
        add(col1, col2);
        add(col2, col1);
        return elements;
    },
    diff: function diff(other) {
        var cy = this._private.cy;
        if ($e815fda779bc047b$var$string(other)) other = cy.$(other);
        var left = this.spawn();
        var right = this.spawn();
        var both = this.spawn();
        var col1 = this;
        var col2 = other;
        var add = function add(col, other, retEles) {
            for(var i = 0; i < col.length; i++){
                var ele = col[i];
                var id = ele._private.data.id;
                var inOther = other.hasElementWithId(id);
                if (inOther) both.merge(ele);
                else retEles.push(ele);
            }
        };
        add(col1, col2, left);
        add(col2, col1, right);
        return {
            left: left,
            right: right,
            both: both
        };
    },
    add: function add(toAdd) {
        var cy = this._private.cy;
        if (!toAdd) return this;
        if ($e815fda779bc047b$var$string(toAdd)) {
            var selector = toAdd;
            toAdd = cy.mutableElements().filter(selector);
        }
        var elements = this.spawnSelf();
        for(var i = 0; i < toAdd.length; i++){
            var ele = toAdd[i];
            var add = !this.has(ele);
            if (add) elements.push(ele);
        }
        return elements;
    },
    // in place merge on calling collection
    merge: function merge(toAdd) {
        var _p = this._private;
        var cy = _p.cy;
        if (!toAdd) return this;
        if (toAdd && $e815fda779bc047b$var$string(toAdd)) {
            var selector = toAdd;
            toAdd = cy.mutableElements().filter(selector);
        }
        var map = _p.map;
        for(var i = 0; i < toAdd.length; i++){
            var toAddEle = toAdd[i];
            var id = toAddEle._private.data.id;
            var add = !map.has(id);
            if (add) {
                var index = this.length++;
                this[index] = toAddEle;
                map.set(id, {
                    ele: toAddEle,
                    index: index
                });
            }
        }
        return this; // chaining
    },
    unmergeAt: function unmergeAt(i) {
        var ele = this[i];
        var id = ele.id();
        var _p = this._private;
        var map = _p.map;
        // remove ele
        this[i] = undefined;
        map["delete"](id);
        var unmergedLastEle = i === this.length - 1;
        // replace empty spot with last ele in collection
        if (this.length > 1 && !unmergedLastEle) {
            var lastEleI = this.length - 1;
            var lastEle = this[lastEleI];
            var lastEleId = lastEle._private.data.id;
            this[lastEleI] = undefined;
            this[i] = lastEle;
            map.set(lastEleId, {
                ele: lastEle,
                index: i
            });
        }
        // the collection is now 1 ele smaller
        this.length--;
        return this;
    },
    // remove single ele in place in calling collection
    unmergeOne: function unmergeOne(ele) {
        ele = ele[0];
        var _p = this._private;
        var id = ele._private.data.id;
        var map = _p.map;
        var entry = map.get(id);
        if (!entry) return this; // no need to remove
        var i = entry.index;
        this.unmergeAt(i);
        return this;
    },
    // remove eles in place on calling collection
    unmerge: function unmerge(toRemove) {
        var cy = this._private.cy;
        if (!toRemove) return this;
        if (toRemove && $e815fda779bc047b$var$string(toRemove)) {
            var selector = toRemove;
            toRemove = cy.mutableElements().filter(selector);
        }
        for(var i = 0; i < toRemove.length; i++)this.unmergeOne(toRemove[i]);
        return this; // chaining
    },
    unmergeBy: function unmergeBy(toRmFn) {
        for(var i = this.length - 1; i >= 0; i--){
            var ele = this[i];
            if (toRmFn(ele)) this.unmergeAt(i);
        }
        return this;
    },
    map: function map(mapFn, thisArg) {
        var arr = [];
        var eles = this;
        for(var i = 0; i < eles.length; i++){
            var ele = eles[i];
            var ret = thisArg ? mapFn.apply(thisArg, [
                ele,
                i,
                eles
            ]) : mapFn(ele, i, eles);
            arr.push(ret);
        }
        return arr;
    },
    reduce: function reduce(fn, initialValue) {
        var val = initialValue;
        var eles = this;
        for(var i = 0; i < eles.length; i++)val = fn(val, eles[i], i, eles);
        return val;
    },
    max: function max(valFn, thisArg) {
        var max = -Infinity;
        var maxEle;
        var eles = this;
        for(var i = 0; i < eles.length; i++){
            var ele = eles[i];
            var val = thisArg ? valFn.apply(thisArg, [
                ele,
                i,
                eles
            ]) : valFn(ele, i, eles);
            if (val > max) {
                max = val;
                maxEle = ele;
            }
        }
        return {
            value: max,
            ele: maxEle
        };
    },
    min: function min(valFn, thisArg) {
        var min = Infinity;
        var minEle;
        var eles = this;
        for(var i = 0; i < eles.length; i++){
            var ele = eles[i];
            var val = thisArg ? valFn.apply(thisArg, [
                ele,
                i,
                eles
            ]) : valFn(ele, i, eles);
            if (val < min) {
                min = val;
                minEle = ele;
            }
        }
        return {
            value: min,
            ele: minEle
        };
    }
};
// aliases
var $e815fda779bc047b$var$fn$1 = $e815fda779bc047b$var$elesfn$8;
$e815fda779bc047b$var$fn$1['u'] = $e815fda779bc047b$var$fn$1['|'] = $e815fda779bc047b$var$fn$1['+'] = $e815fda779bc047b$var$fn$1.union = $e815fda779bc047b$var$fn$1.or = $e815fda779bc047b$var$fn$1.add;
$e815fda779bc047b$var$fn$1['\\'] = $e815fda779bc047b$var$fn$1['!'] = $e815fda779bc047b$var$fn$1['-'] = $e815fda779bc047b$var$fn$1.difference = $e815fda779bc047b$var$fn$1.relativeComplement = $e815fda779bc047b$var$fn$1.subtract = $e815fda779bc047b$var$fn$1.not;
$e815fda779bc047b$var$fn$1['n'] = $e815fda779bc047b$var$fn$1['&'] = $e815fda779bc047b$var$fn$1['.'] = $e815fda779bc047b$var$fn$1.and = $e815fda779bc047b$var$fn$1.intersection = $e815fda779bc047b$var$fn$1.intersect;
$e815fda779bc047b$var$fn$1['^'] = $e815fda779bc047b$var$fn$1['(+)'] = $e815fda779bc047b$var$fn$1['(-)'] = $e815fda779bc047b$var$fn$1.symmetricDifference = $e815fda779bc047b$var$fn$1.symdiff = $e815fda779bc047b$var$fn$1.xor;
$e815fda779bc047b$var$fn$1.fnFilter = $e815fda779bc047b$var$fn$1.filterFn = $e815fda779bc047b$var$fn$1.stdFilter = $e815fda779bc047b$var$fn$1.filter;
$e815fda779bc047b$var$fn$1.complement = $e815fda779bc047b$var$fn$1.abscomp = $e815fda779bc047b$var$fn$1.absoluteComplement;
var $e815fda779bc047b$var$elesfn$7 = {
    isNode: function isNode() {
        return this.group() === 'nodes';
    },
    isEdge: function isEdge() {
        return this.group() === 'edges';
    },
    isLoop: function isLoop() {
        return this.isEdge() && this.source()[0] === this.target()[0];
    },
    isSimple: function isSimple() {
        return this.isEdge() && this.source()[0] !== this.target()[0];
    },
    group: function group() {
        var ele = this[0];
        if (ele) return ele._private.group;
    }
};
/**
 *  Elements are drawn in a specific order based on compound depth (low to high), the element type (nodes above edges),
 *  and z-index (low to high).  These styles affect how this applies:
 *
 *  z-compound-depth: May be `bottom | orphan | auto | top`.  The first drawn is `bottom`, then `orphan` which is the
 *      same depth as the root of the compound graph, followed by the default value `auto` which draws in order from
 *      root to leaves of the compound graph.  The last drawn is `top`.
 *  z-index-compare: May be `auto | manual`.  The default value is `auto` which always draws edges under nodes.
 *      `manual` ignores this convention and draws based on the `z-index` value setting.
 *  z-index: An integer value that affects the relative draw order of elements.  In general, an element with a higher
 *      `z-index` will be drawn on top of an element with a lower `z-index`.
 */ var $e815fda779bc047b$var$zIndexSort = function zIndexSort(a, b) {
    var cy = a.cy();
    var hasCompoundNodes = cy.hasCompoundNodes();
    function getDepth(ele) {
        var style = ele.pstyle('z-compound-depth');
        if (style.value === 'auto') return hasCompoundNodes ? ele.zDepth() : 0;
        else if (style.value === 'bottom') return -1;
        else if (style.value === 'top') return $e815fda779bc047b$var$MAX_INT$1;
        // 'orphan'
        return 0;
    }
    var depthDiff = getDepth(a) - getDepth(b);
    if (depthDiff !== 0) return depthDiff;
    function getEleDepth(ele) {
        var style = ele.pstyle('z-index-compare');
        if (style.value === 'auto') return ele.isNode() ? 1 : 0;
        // 'manual'
        return 0;
    }
    var eleDiff = getEleDepth(a) - getEleDepth(b);
    if (eleDiff !== 0) return eleDiff;
    var zDiff = a.pstyle('z-index').value - b.pstyle('z-index').value;
    if (zDiff !== 0) return zDiff;
    // compare indices in the core (order added to graph w/ last on top)
    return a.poolIndex() - b.poolIndex();
};
var $e815fda779bc047b$var$elesfn$6 = {
    forEach: function forEach(fn, thisArg) {
        if ($e815fda779bc047b$var$fn$6(fn)) {
            var N = this.length;
            for(var i = 0; i < N; i++){
                var ele = this[i];
                var ret = thisArg ? fn.apply(thisArg, [
                    ele,
                    i,
                    this
                ]) : fn(ele, i, this);
                if (ret === false) break;
                 // exit each early on return false
            }
        }
        return this;
    },
    toArray: function toArray() {
        var array = [];
        for(var i = 0; i < this.length; i++)array.push(this[i]);
        return array;
    },
    slice: function slice(start, end) {
        var array = [];
        var thisSize = this.length;
        if (end == null) end = thisSize;
        if (start == null) start = 0;
        if (start < 0) start = thisSize + start;
        if (end < 0) end = thisSize + end;
        for(var i = start; i >= 0 && i < end && i < thisSize; i++)array.push(this[i]);
        return this.spawn(array);
    },
    size: function size() {
        return this.length;
    },
    eq: function eq(i) {
        return this[i] || this.spawn();
    },
    first: function first() {
        return this[0] || this.spawn();
    },
    last: function last() {
        return this[this.length - 1] || this.spawn();
    },
    empty: function empty() {
        return this.length === 0;
    },
    nonempty: function nonempty() {
        return !this.empty();
    },
    sort: function sort(sortFn) {
        if (!$e815fda779bc047b$var$fn$6(sortFn)) return this;
        var sorted = this.toArray().sort(sortFn);
        return this.spawn(sorted);
    },
    sortByZIndex: function sortByZIndex() {
        return this.sort($e815fda779bc047b$var$zIndexSort);
    },
    zDepth: function zDepth() {
        var ele = this[0];
        if (!ele) return undefined;
        // let cy = ele.cy();
        var _p = ele._private;
        var group = _p.group;
        if (group === 'nodes') {
            var depth = _p.data.parent ? ele.parents().size() : 0;
            if (!ele.isParent()) return $e815fda779bc047b$var$MAX_INT$1 - 1; // childless nodes always on top
            return depth;
        } else {
            var src = _p.source;
            var tgt = _p.target;
            var srcDepth = src.zDepth();
            var tgtDepth = tgt.zDepth();
            return Math.max(srcDepth, tgtDepth, 0); // depth of deepest parent
        }
    }
};
$e815fda779bc047b$var$elesfn$6.each = $e815fda779bc047b$var$elesfn$6.forEach;
var $e815fda779bc047b$var$defineSymbolIterator = function defineSymbolIterator() {
    var typeofUndef = "undefined";
    var isIteratorSupported = (typeof Symbol === "undefined" ? "undefined" : $e815fda779bc047b$var$_typeof(Symbol)) != typeofUndef && $e815fda779bc047b$var$_typeof(Symbol.iterator) != typeofUndef;
    if (isIteratorSupported) $e815fda779bc047b$var$elesfn$6[Symbol.iterator] = function() {
        var _this = this;
        var entry = {
            value: undefined,
            done: false
        };
        var i = 0;
        var length = this.length;
        return $e815fda779bc047b$var$_defineProperty$1({
            next: function next() {
                if (i < length) entry.value = _this[i++];
                else {
                    entry.value = undefined;
                    entry.done = true;
                }
                return entry;
            }
        }, Symbol.iterator, function() {
            return this;
        });
    };
};
$e815fda779bc047b$var$defineSymbolIterator();
var $e815fda779bc047b$var$getLayoutDimensionOptions = $e815fda779bc047b$var$defaults$g({
    nodeDimensionsIncludeLabels: false
});
var $e815fda779bc047b$var$elesfn$5 = {
    // Calculates and returns node dimensions { x, y } based on options given
    layoutDimensions: function layoutDimensions(options) {
        options = $e815fda779bc047b$var$getLayoutDimensionOptions(options);
        var dims;
        if (!this.takesUpSpace()) dims = {
            w: 0,
            h: 0
        };
        else if (options.nodeDimensionsIncludeLabels) {
            var bbDim = this.boundingBox();
            dims = {
                w: bbDim.w,
                h: bbDim.h
            };
        } else dims = {
            w: this.outerWidth(),
            h: this.outerHeight()
        };
        // sanitise the dimensions for external layouts (avoid division by zero)
        if (dims.w === 0 || dims.h === 0) dims.w = dims.h = 1;
        return dims;
    },
    // using standard layout options, apply position function (w/ or w/o animation)
    layoutPositions: function layoutPositions(layout, options, fn) {
        var nodes = this.nodes().filter(function(n) {
            return !n.isParent();
        });
        var cy = this.cy();
        var layoutEles = options.eles; // nodes & edges
        var getMemoizeKey = function getMemoizeKey(node) {
            return node.id();
        };
        var fnMem = $e815fda779bc047b$var$memoize(fn, getMemoizeKey); // memoized version of position function
        layout.emit({
            type: 'layoutstart',
            layout: layout
        });
        layout.animations = [];
        var calculateSpacing = function calculateSpacing(spacing, nodesBb, pos) {
            var center = {
                x: nodesBb.x1 + nodesBb.w / 2,
                y: nodesBb.y1 + nodesBb.h / 2
            };
            var spacingVector = {
                // scale from center of bounding box (not necessarily 0,0)
                x: (pos.x - center.x) * spacing,
                y: (pos.y - center.y) * spacing
            };
            return {
                x: center.x + spacingVector.x,
                y: center.y + spacingVector.y
            };
        };
        var useSpacingFactor = options.spacingFactor && options.spacingFactor !== 1;
        var spacingBb = function spacingBb() {
            if (!useSpacingFactor) return null;
            var bb = $e815fda779bc047b$var$makeBoundingBox();
            for(var i = 0; i < nodes.length; i++){
                var node = nodes[i];
                var pos = fnMem(node, i);
                $e815fda779bc047b$var$expandBoundingBoxByPoint(bb, pos.x, pos.y);
            }
            return bb;
        };
        var bb = spacingBb();
        var getFinalPos = $e815fda779bc047b$var$memoize(function(node, i) {
            var newPos = fnMem(node, i);
            if (useSpacingFactor) {
                var spacing = Math.abs(options.spacingFactor);
                newPos = calculateSpacing(spacing, bb, newPos);
            }
            if (options.transform != null) newPos = options.transform(node, newPos);
            return newPos;
        }, getMemoizeKey);
        if (options.animate) {
            for(var i = 0; i < nodes.length; i++){
                var node = nodes[i];
                var newPos = getFinalPos(node, i);
                var animateNode = options.animateFilter == null || options.animateFilter(node, i);
                if (animateNode) {
                    var ani = node.animation({
                        position: newPos,
                        duration: options.animationDuration,
                        easing: options.animationEasing
                    });
                    layout.animations.push(ani);
                } else node.position(newPos);
            }
            if (options.fit) {
                var fitAni = cy.animation({
                    fit: {
                        boundingBox: layoutEles.boundingBoxAt(getFinalPos),
                        padding: options.padding
                    },
                    duration: options.animationDuration,
                    easing: options.animationEasing
                });
                layout.animations.push(fitAni);
            } else if (options.zoom !== undefined && options.pan !== undefined) {
                var zoomPanAni = cy.animation({
                    zoom: options.zoom,
                    pan: options.pan,
                    duration: options.animationDuration,
                    easing: options.animationEasing
                });
                layout.animations.push(zoomPanAni);
            }
            layout.animations.forEach(function(ani) {
                return ani.play();
            });
            layout.one('layoutready', options.ready);
            layout.emit({
                type: 'layoutready',
                layout: layout
            });
            $e815fda779bc047b$var$Promise$1.all(layout.animations.map(function(ani) {
                return ani.promise();
            })).then(function() {
                layout.one('layoutstop', options.stop);
                layout.emit({
                    type: 'layoutstop',
                    layout: layout
                });
            });
        } else {
            nodes.positions(getFinalPos);
            if (options.fit) cy.fit(options.eles, options.padding);
            if (options.zoom != null) cy.zoom(options.zoom);
            if (options.pan) cy.pan(options.pan);
            layout.one('layoutready', options.ready);
            layout.emit({
                type: 'layoutready',
                layout: layout
            });
            layout.one('layoutstop', options.stop);
            layout.emit({
                type: 'layoutstop',
                layout: layout
            });
        }
        return this; // chaining
    },
    layout: function layout(options) {
        var cy = this.cy();
        return cy.makeLayout($e815fda779bc047b$var$extend({}, options, {
            eles: this
        }));
    }
};
// aliases:
$e815fda779bc047b$var$elesfn$5.createLayout = $e815fda779bc047b$var$elesfn$5.makeLayout = $e815fda779bc047b$var$elesfn$5.layout;
function $e815fda779bc047b$var$styleCache(key, fn, ele) {
    var _p = ele._private;
    var cache = _p.styleCache = _p.styleCache || [];
    var val;
    if ((val = cache[key]) != null) return val;
    else {
        val = cache[key] = fn(ele);
        return val;
    }
}
function $e815fda779bc047b$var$cacheStyleFunction(key, fn) {
    key = $e815fda779bc047b$var$hashString(key);
    return function cachedStyleFunction(ele) {
        return $e815fda779bc047b$var$styleCache(key, fn, ele);
    };
}
function $e815fda779bc047b$var$cachePrototypeStyleFunction(key, fn) {
    key = $e815fda779bc047b$var$hashString(key);
    var selfFn = function selfFn(ele) {
        return fn.call(ele);
    };
    return function cachedPrototypeStyleFunction() {
        var ele = this[0];
        if (ele) return $e815fda779bc047b$var$styleCache(key, selfFn, ele);
    };
}
var $e815fda779bc047b$var$elesfn$4 = {
    recalculateRenderedStyle: function recalculateRenderedStyle(useCache) {
        var cy = this.cy();
        var renderer = cy.renderer();
        var styleEnabled = cy.styleEnabled();
        if (renderer && styleEnabled) renderer.recalculateRenderedStyle(this, useCache);
        return this;
    },
    dirtyStyleCache: function dirtyStyleCache() {
        var cy = this.cy();
        var dirty = function dirty(ele) {
            return ele._private.styleCache = null;
        };
        if (cy.hasCompoundNodes()) {
            var eles;
            eles = this.spawnSelf().merge(this.descendants()).merge(this.parents());
            eles.merge(eles.connectedEdges());
            eles.forEach(dirty);
        } else this.forEach(function(ele) {
            dirty(ele);
            ele.connectedEdges().forEach(dirty);
        });
        return this;
    },
    // fully updates (recalculates) the style for the elements
    updateStyle: function updateStyle(notifyRenderer) {
        var cy = this._private.cy;
        if (!cy.styleEnabled()) return this;
        if (cy.batching()) {
            var bEles = cy._private.batchStyleEles;
            bEles.merge(this);
            return this; // chaining and exit early when batching
        }
        var hasCompounds = cy.hasCompoundNodes();
        var updatedEles = this;
        notifyRenderer = notifyRenderer || notifyRenderer === undefined ? true : false;
        if (hasCompounds) // then add everything up and down for compound selector checks
        updatedEles = this.spawnSelf().merge(this.descendants()).merge(this.parents());
        // let changedEles = style.apply( updatedEles );
        var changedEles = updatedEles;
        if (notifyRenderer) changedEles.emitAndNotify('style'); // let renderer know we changed style
        else changedEles.emit('style'); // just fire the event
        updatedEles.forEach(function(ele) {
            return ele._private.styleDirty = true;
        });
        return this; // chaining
    },
    // private: clears dirty flag and recalculates style
    cleanStyle: function cleanStyle() {
        var cy = this.cy();
        if (!cy.styleEnabled()) return;
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            if (ele._private.styleDirty) {
                // n.b. this flag should be set before apply() to avoid potential infinite recursion
                ele._private.styleDirty = false;
                cy.style().apply(ele);
            }
        }
    },
    // get the internal parsed style object for the specified property
    parsedStyle: function parsedStyle(property) {
        var includeNonDefault = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        var ele = this[0];
        var cy = ele.cy();
        if (!cy.styleEnabled()) return;
        if (ele) {
            // this.cleanStyle();
            // Inline the important part of cleanStyle(), for raw performance
            if (ele._private.styleDirty) {
                // n.b. this flag should be set before apply() to avoid potential infinite recursion
                ele._private.styleDirty = false;
                cy.style().apply(ele);
            }
            var overriddenStyle = ele._private.style[property];
            if (overriddenStyle != null) return overriddenStyle;
            else if (includeNonDefault) return cy.style().getDefaultProperty(property);
            else return null;
        }
    },
    numericStyle: function numericStyle(property) {
        var ele = this[0];
        if (!ele.cy().styleEnabled()) return;
        if (ele) {
            var pstyle = ele.pstyle(property);
            return pstyle.pfValue !== undefined ? pstyle.pfValue : pstyle.value;
        }
    },
    numericStyleUnits: function numericStyleUnits(property) {
        var ele = this[0];
        if (!ele.cy().styleEnabled()) return;
        if (ele) return ele.pstyle(property).units;
    },
    // get the specified css property as a rendered value (i.e. on-screen value)
    // or get the whole rendered style if no property specified (NB doesn't allow setting)
    renderedStyle: function renderedStyle(property) {
        var cy = this.cy();
        if (!cy.styleEnabled()) return this;
        var ele = this[0];
        if (ele) return cy.style().getRenderedStyle(ele, property);
    },
    // read the calculated css style of the element or override the style (via a bypass)
    style: function style(name, value) {
        var cy = this.cy();
        if (!cy.styleEnabled()) return this;
        var updateTransitions = false;
        var style = cy.style();
        if ($e815fda779bc047b$var$plainObject(name)) {
            // then extend the bypass
            var props = name;
            style.applyBypass(this, props, updateTransitions);
            this.emitAndNotify('style'); // let the renderer know we've updated style
        } else if ($e815fda779bc047b$var$string(name)) {
            if (value === undefined) {
                // then get the property from the style
                var ele = this[0];
                if (ele) return style.getStylePropertyValue(ele, name);
                else // empty collection => can't get any value
                return;
            } else {
                // then set the bypass with the property value
                style.applyBypass(this, name, value, updateTransitions);
                this.emitAndNotify('style'); // let the renderer know we've updated style
            }
        } else if (name === undefined) {
            var _ele = this[0];
            if (_ele) return style.getRawStyle(_ele);
            else // empty collection => can't get any value
            return;
        }
        return this; // chaining
    },
    removeStyle: function removeStyle(names) {
        var cy = this.cy();
        if (!cy.styleEnabled()) return this;
        var updateTransitions = false;
        var style = cy.style();
        var eles = this;
        if (names === undefined) for(var i = 0; i < eles.length; i++){
            var ele = eles[i];
            style.removeAllBypasses(ele, updateTransitions);
        }
        else {
            names = names.split(/\s+/);
            for(var _i = 0; _i < eles.length; _i++){
                var _ele2 = eles[_i];
                style.removeBypasses(_ele2, names, updateTransitions);
            }
        }
        this.emitAndNotify('style'); // let the renderer know we've updated style
        return this; // chaining
    },
    show: function show() {
        this.css('display', 'element');
        return this; // chaining
    },
    hide: function hide() {
        this.css('display', 'none');
        return this; // chaining
    },
    effectiveOpacity: function effectiveOpacity() {
        var cy = this.cy();
        if (!cy.styleEnabled()) return 1;
        var hasCompoundNodes = cy.hasCompoundNodes();
        var ele = this[0];
        if (ele) {
            var _p = ele._private;
            var parentOpacity = ele.pstyle('opacity').value;
            if (!hasCompoundNodes) return parentOpacity;
            var parents = !_p.data.parent ? null : ele.parents();
            if (parents) for(var i = 0; i < parents.length; i++){
                var parent = parents[i];
                var opacity = parent.pstyle('opacity').value;
                parentOpacity = opacity * parentOpacity;
            }
            return parentOpacity;
        }
    },
    transparent: function transparent() {
        var cy = this.cy();
        if (!cy.styleEnabled()) return false;
        var ele = this[0];
        var hasCompoundNodes = ele.cy().hasCompoundNodes();
        if (ele) {
            if (!hasCompoundNodes) return ele.pstyle('opacity').value === 0;
            else return ele.effectiveOpacity() === 0;
        }
    },
    backgrounding: function backgrounding() {
        var cy = this.cy();
        if (!cy.styleEnabled()) return false;
        var ele = this[0];
        return ele._private.backgrounding ? true : false;
    }
};
function $e815fda779bc047b$var$checkCompound(ele, parentOk) {
    var _p = ele._private;
    var parents = _p.data.parent ? ele.parents() : null;
    if (parents) for(var i = 0; i < parents.length; i++){
        var parent = parents[i];
        if (!parentOk(parent)) return false;
    }
    return true;
}
function $e815fda779bc047b$var$defineDerivedStateFunction(specs) {
    var ok = specs.ok;
    var edgeOkViaNode = specs.edgeOkViaNode || specs.ok;
    var parentOk = specs.parentOk || specs.ok;
    return function() {
        var cy = this.cy();
        if (!cy.styleEnabled()) return true;
        var ele = this[0];
        var hasCompoundNodes = cy.hasCompoundNodes();
        if (ele) {
            var _p = ele._private;
            if (!ok(ele)) return false;
            if (ele.isNode()) return !hasCompoundNodes || $e815fda779bc047b$var$checkCompound(ele, parentOk);
            else {
                var src = _p.source;
                var tgt = _p.target;
                return edgeOkViaNode(src) && (!hasCompoundNodes || $e815fda779bc047b$var$checkCompound(src, edgeOkViaNode)) && (src === tgt || edgeOkViaNode(tgt) && (!hasCompoundNodes || $e815fda779bc047b$var$checkCompound(tgt, edgeOkViaNode)));
            }
        }
    };
}
var $e815fda779bc047b$var$eleTakesUpSpace = $e815fda779bc047b$var$cacheStyleFunction('eleTakesUpSpace', function(ele) {
    return ele.pstyle('display').value === 'element' && ele.width() !== 0 && (ele.isNode() ? ele.height() !== 0 : true);
});
$e815fda779bc047b$var$elesfn$4.takesUpSpace = $e815fda779bc047b$var$cachePrototypeStyleFunction('takesUpSpace', $e815fda779bc047b$var$defineDerivedStateFunction({
    ok: $e815fda779bc047b$var$eleTakesUpSpace
}));
var $e815fda779bc047b$var$eleInteractive = $e815fda779bc047b$var$cacheStyleFunction('eleInteractive', function(ele) {
    return ele.pstyle('events').value === 'yes' && ele.pstyle('visibility').value === 'visible' && $e815fda779bc047b$var$eleTakesUpSpace(ele);
});
var $e815fda779bc047b$var$parentInteractive = $e815fda779bc047b$var$cacheStyleFunction('parentInteractive', function(parent) {
    return parent.pstyle('visibility').value === 'visible' && $e815fda779bc047b$var$eleTakesUpSpace(parent);
});
$e815fda779bc047b$var$elesfn$4.interactive = $e815fda779bc047b$var$cachePrototypeStyleFunction('interactive', $e815fda779bc047b$var$defineDerivedStateFunction({
    ok: $e815fda779bc047b$var$eleInteractive,
    parentOk: $e815fda779bc047b$var$parentInteractive,
    edgeOkViaNode: $e815fda779bc047b$var$eleTakesUpSpace
}));
$e815fda779bc047b$var$elesfn$4.noninteractive = function() {
    var ele = this[0];
    if (ele) return !ele.interactive();
};
var $e815fda779bc047b$var$eleVisible = $e815fda779bc047b$var$cacheStyleFunction('eleVisible', function(ele) {
    return ele.pstyle('visibility').value === 'visible' && ele.pstyle('opacity').pfValue !== 0 && $e815fda779bc047b$var$eleTakesUpSpace(ele);
});
var $e815fda779bc047b$var$edgeVisibleViaNode = $e815fda779bc047b$var$eleTakesUpSpace;
$e815fda779bc047b$var$elesfn$4.visible = $e815fda779bc047b$var$cachePrototypeStyleFunction('visible', $e815fda779bc047b$var$defineDerivedStateFunction({
    ok: $e815fda779bc047b$var$eleVisible,
    edgeOkViaNode: $e815fda779bc047b$var$edgeVisibleViaNode
}));
$e815fda779bc047b$var$elesfn$4.hidden = function() {
    var ele = this[0];
    if (ele) return !ele.visible();
};
$e815fda779bc047b$var$elesfn$4.isBundledBezier = $e815fda779bc047b$var$cachePrototypeStyleFunction('isBundledBezier', function() {
    if (!this.cy().styleEnabled()) return false;
    return !this.removed() && this.pstyle('curve-style').value === 'bezier' && this.takesUpSpace();
});
$e815fda779bc047b$var$elesfn$4.bypass = $e815fda779bc047b$var$elesfn$4.css = $e815fda779bc047b$var$elesfn$4.style;
$e815fda779bc047b$var$elesfn$4.renderedCss = $e815fda779bc047b$var$elesfn$4.renderedStyle;
$e815fda779bc047b$var$elesfn$4.removeBypass = $e815fda779bc047b$var$elesfn$4.removeCss = $e815fda779bc047b$var$elesfn$4.removeStyle;
$e815fda779bc047b$var$elesfn$4.pstyle = $e815fda779bc047b$var$elesfn$4.parsedStyle;
var $e815fda779bc047b$var$elesfn$3 = {};
function $e815fda779bc047b$var$defineSwitchFunction(params) {
    return function() {
        var args = arguments;
        var changedEles = [];
        // e.g. cy.nodes().select( data, handler )
        if (args.length === 2) {
            var data = args[0];
            var handler = args[1];
            this.on(params.event, data, handler);
        } else if (args.length === 1 && $e815fda779bc047b$var$fn$6(args[0])) {
            var _handler = args[0];
            this.on(params.event, _handler);
        } else if (args.length === 0 || args.length === 1 && $e815fda779bc047b$var$array(args[0])) {
            var addlEvents = args.length === 1 ? args[0] : null;
            for(var i = 0; i < this.length; i++){
                var ele = this[i];
                var able = !params.ableField || ele._private[params.ableField];
                var changed = ele._private[params.field] != params.value;
                if (params.overrideAble) {
                    var overrideAble = params.overrideAble(ele);
                    if (overrideAble !== undefined) {
                        able = overrideAble;
                        if (!overrideAble) return this;
                         // to save cycles assume not able for all on override
                    }
                }
                if (able) {
                    ele._private[params.field] = params.value;
                    if (changed) changedEles.push(ele);
                }
            }
            var changedColl = this.spawn(changedEles);
            changedColl.updateStyle(); // change of state => possible change of style
            changedColl.emit(params.event);
            if (addlEvents) changedColl.emit(addlEvents);
        }
        return this;
    };
}
function $e815fda779bc047b$var$defineSwitchSet(params) {
    $e815fda779bc047b$var$elesfn$3[params.field] = function() {
        var ele = this[0];
        if (ele) {
            if (params.overrideField) {
                var val = params.overrideField(ele);
                if (val !== undefined) return val;
            }
            return ele._private[params.field];
        }
    };
    $e815fda779bc047b$var$elesfn$3[params.on] = $e815fda779bc047b$var$defineSwitchFunction({
        event: params.on,
        field: params.field,
        ableField: params.ableField,
        overrideAble: params.overrideAble,
        value: true
    });
    $e815fda779bc047b$var$elesfn$3[params.off] = $e815fda779bc047b$var$defineSwitchFunction({
        event: params.off,
        field: params.field,
        ableField: params.ableField,
        overrideAble: params.overrideAble,
        value: false
    });
}
$e815fda779bc047b$var$defineSwitchSet({
    field: 'locked',
    overrideField: function overrideField(ele) {
        return ele.cy().autolock() ? true : undefined;
    },
    on: 'lock',
    off: 'unlock'
});
$e815fda779bc047b$var$defineSwitchSet({
    field: 'grabbable',
    overrideField: function overrideField(ele) {
        return ele.cy().autoungrabify() || ele.pannable() ? false : undefined;
    },
    on: 'grabify',
    off: 'ungrabify'
});
$e815fda779bc047b$var$defineSwitchSet({
    field: 'selected',
    ableField: 'selectable',
    overrideAble: function overrideAble(ele) {
        return ele.cy().autounselectify() ? false : undefined;
    },
    on: 'select',
    off: 'unselect'
});
$e815fda779bc047b$var$defineSwitchSet({
    field: 'selectable',
    overrideField: function overrideField(ele) {
        return ele.cy().autounselectify() ? false : undefined;
    },
    on: 'selectify',
    off: 'unselectify'
});
$e815fda779bc047b$var$elesfn$3.deselect = $e815fda779bc047b$var$elesfn$3.unselect;
$e815fda779bc047b$var$elesfn$3.grabbed = function() {
    var ele = this[0];
    if (ele) return ele._private.grabbed;
};
$e815fda779bc047b$var$defineSwitchSet({
    field: 'active',
    on: 'activate',
    off: 'unactivate'
});
$e815fda779bc047b$var$defineSwitchSet({
    field: 'pannable',
    on: 'panify',
    off: 'unpanify'
});
$e815fda779bc047b$var$elesfn$3.inactive = function() {
    var ele = this[0];
    if (ele) return !ele._private.active;
};
var $e815fda779bc047b$var$elesfn$2 = {};
// DAG functions
////////////////
var $e815fda779bc047b$var$defineDagExtremity = function defineDagExtremity(params) {
    return function dagExtremityImpl(selector) {
        var eles = this;
        var ret = [];
        for(var i = 0; i < eles.length; i++){
            var ele = eles[i];
            if (!ele.isNode()) continue;
            var disqualified = false;
            var edges = ele.connectedEdges();
            for(var j = 0; j < edges.length; j++){
                var edge = edges[j];
                var src = edge.source();
                var tgt = edge.target();
                if (params.noIncomingEdges && tgt === ele && src !== ele || params.noOutgoingEdges && src === ele && tgt !== ele) {
                    disqualified = true;
                    break;
                }
            }
            if (!disqualified) ret.push(ele);
        }
        return this.spawn(ret, true).filter(selector);
    };
};
var $e815fda779bc047b$var$defineDagOneHop = function defineDagOneHop(params) {
    return function(selector) {
        var eles = this;
        var oEles = [];
        for(var i = 0; i < eles.length; i++){
            var ele = eles[i];
            if (!ele.isNode()) continue;
            var edges = ele.connectedEdges();
            for(var j = 0; j < edges.length; j++){
                var edge = edges[j];
                var src = edge.source();
                var tgt = edge.target();
                if (params.outgoing && src === ele) {
                    oEles.push(edge);
                    oEles.push(tgt);
                } else if (params.incoming && tgt === ele) {
                    oEles.push(edge);
                    oEles.push(src);
                }
            }
        }
        return this.spawn(oEles, true).filter(selector);
    };
};
var $e815fda779bc047b$var$defineDagAllHops = function defineDagAllHops(params) {
    return function(selector) {
        var eles = this;
        var sEles = [];
        var sElesIds = {};
        for(;;){
            var next = params.outgoing ? eles.outgoers() : eles.incomers();
            if (next.length === 0) break;
             // done if none left
            var newNext = false;
            for(var i = 0; i < next.length; i++){
                var n = next[i];
                var nid = n.id();
                if (!sElesIds[nid]) {
                    sElesIds[nid] = true;
                    sEles.push(n);
                    newNext = true;
                }
            }
            if (!newNext) break;
             // done if touched all outgoers already
            eles = next;
        }
        return this.spawn(sEles, true).filter(selector);
    };
};
$e815fda779bc047b$var$elesfn$2.clearTraversalCache = function() {
    for(var i = 0; i < this.length; i++)this[i]._private.traversalCache = null;
};
$e815fda779bc047b$var$extend($e815fda779bc047b$var$elesfn$2, {
    // get the root nodes in the DAG
    roots: $e815fda779bc047b$var$defineDagExtremity({
        noIncomingEdges: true
    }),
    // get the leaf nodes in the DAG
    leaves: $e815fda779bc047b$var$defineDagExtremity({
        noOutgoingEdges: true
    }),
    // normally called children in graph theory
    // these nodes =edges=> outgoing nodes
    outgoers: $e815fda779bc047b$var$cache($e815fda779bc047b$var$defineDagOneHop({
        outgoing: true
    }), 'outgoers'),
    // aka DAG descendants
    successors: $e815fda779bc047b$var$defineDagAllHops({
        outgoing: true
    }),
    // normally called parents in graph theory
    // these nodes <=edges= incoming nodes
    incomers: $e815fda779bc047b$var$cache($e815fda779bc047b$var$defineDagOneHop({
        incoming: true
    }), 'incomers'),
    // aka DAG ancestors
    predecessors: $e815fda779bc047b$var$defineDagAllHops({})
});
// Neighbourhood functions
//////////////////////////
$e815fda779bc047b$var$extend($e815fda779bc047b$var$elesfn$2, {
    neighborhood: $e815fda779bc047b$var$cache(function(selector) {
        var elements = [];
        var nodes = this.nodes();
        for(var i = 0; i < nodes.length; i++){
            // for all nodes
            var node = nodes[i];
            var connectedEdges = node.connectedEdges();
            // for each connected edge, add the edge and the other node
            for(var j = 0; j < connectedEdges.length; j++){
                var edge = connectedEdges[j];
                var src = edge.source();
                var tgt = edge.target();
                var otherNode = node === src ? tgt : src;
                // need check in case of loop
                if (otherNode.length > 0) elements.push(otherNode[0]); // add node 1 hop away
                // add connected edge
                elements.push(edge[0]);
            }
        }
        return this.spawn(elements, true).filter(selector);
    }, 'neighborhood'),
    closedNeighborhood: function closedNeighborhood(selector) {
        return this.neighborhood().add(this).filter(selector);
    },
    openNeighborhood: function openNeighborhood(selector) {
        return this.neighborhood(selector);
    }
});
// aliases
$e815fda779bc047b$var$elesfn$2.neighbourhood = $e815fda779bc047b$var$elesfn$2.neighborhood;
$e815fda779bc047b$var$elesfn$2.closedNeighbourhood = $e815fda779bc047b$var$elesfn$2.closedNeighborhood;
$e815fda779bc047b$var$elesfn$2.openNeighbourhood = $e815fda779bc047b$var$elesfn$2.openNeighborhood;
// Edge functions
/////////////////
$e815fda779bc047b$var$extend($e815fda779bc047b$var$elesfn$2, {
    source: $e815fda779bc047b$var$cache(function sourceImpl(selector) {
        var ele = this[0];
        var src;
        if (ele) src = ele._private.source || ele.cy().collection();
        return src && selector ? src.filter(selector) : src;
    }, 'source'),
    target: $e815fda779bc047b$var$cache(function targetImpl(selector) {
        var ele = this[0];
        var tgt;
        if (ele) tgt = ele._private.target || ele.cy().collection();
        return tgt && selector ? tgt.filter(selector) : tgt;
    }, 'target'),
    sources: $e815fda779bc047b$var$defineSourceFunction({
        attr: 'source'
    }),
    targets: $e815fda779bc047b$var$defineSourceFunction({
        attr: 'target'
    })
});
function $e815fda779bc047b$var$defineSourceFunction(params) {
    return function sourceImpl(selector) {
        var sources = [];
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            var src = ele._private[params.attr];
            if (src) sources.push(src);
        }
        return this.spawn(sources, true).filter(selector);
    };
}
$e815fda779bc047b$var$extend($e815fda779bc047b$var$elesfn$2, {
    edgesWith: $e815fda779bc047b$var$cache($e815fda779bc047b$var$defineEdgesWithFunction(), 'edgesWith'),
    edgesTo: $e815fda779bc047b$var$cache($e815fda779bc047b$var$defineEdgesWithFunction({
        thisIsSrc: true
    }), 'edgesTo')
});
function $e815fda779bc047b$var$defineEdgesWithFunction(params) {
    return function edgesWithImpl(otherNodes) {
        var elements = [];
        var cy = this._private.cy;
        var p = params || {};
        // get elements if a selector is specified
        if ($e815fda779bc047b$var$string(otherNodes)) otherNodes = cy.$(otherNodes);
        for(var h = 0; h < otherNodes.length; h++){
            var edges = otherNodes[h]._private.edges;
            for(var i = 0; i < edges.length; i++){
                var edge = edges[i];
                var edgeData = edge._private.data;
                var thisToOther = this.hasElementWithId(edgeData.source) && otherNodes.hasElementWithId(edgeData.target);
                var otherToThis = otherNodes.hasElementWithId(edgeData.source) && this.hasElementWithId(edgeData.target);
                var edgeConnectsThisAndOther = thisToOther || otherToThis;
                if (!edgeConnectsThisAndOther) continue;
                if (p.thisIsSrc || p.thisIsTgt) {
                    if (p.thisIsSrc && !thisToOther) continue;
                    if (p.thisIsTgt && !otherToThis) continue;
                }
                elements.push(edge);
            }
        }
        return this.spawn(elements, true);
    };
}
$e815fda779bc047b$var$extend($e815fda779bc047b$var$elesfn$2, {
    connectedEdges: $e815fda779bc047b$var$cache(function(selector) {
        var retEles = [];
        var eles = this;
        for(var i = 0; i < eles.length; i++){
            var node = eles[i];
            if (!node.isNode()) continue;
            var edges = node._private.edges;
            for(var j = 0; j < edges.length; j++){
                var edge = edges[j];
                retEles.push(edge);
            }
        }
        return this.spawn(retEles, true).filter(selector);
    }, 'connectedEdges'),
    connectedNodes: $e815fda779bc047b$var$cache(function(selector) {
        var retEles = [];
        var eles = this;
        for(var i = 0; i < eles.length; i++){
            var edge = eles[i];
            if (!edge.isEdge()) continue;
            retEles.push(edge.source()[0]);
            retEles.push(edge.target()[0]);
        }
        return this.spawn(retEles, true).filter(selector);
    }, 'connectedNodes'),
    parallelEdges: $e815fda779bc047b$var$cache($e815fda779bc047b$var$defineParallelEdgesFunction(), 'parallelEdges'),
    codirectedEdges: $e815fda779bc047b$var$cache($e815fda779bc047b$var$defineParallelEdgesFunction({
        codirected: true
    }), 'codirectedEdges')
});
function $e815fda779bc047b$var$defineParallelEdgesFunction(params) {
    var defaults = {
        codirected: false
    };
    params = $e815fda779bc047b$var$extend({}, defaults, params);
    return function parallelEdgesImpl(selector) {
        // micro-optimised for renderer
        var elements = [];
        var edges = this.edges();
        var p = params;
        // look at all the edges in the collection
        for(var i = 0; i < edges.length; i++){
            var edge1 = edges[i];
            var edge1_p = edge1._private;
            var src1 = edge1_p.source;
            var srcid1 = src1._private.data.id;
            var tgtid1 = edge1_p.data.target;
            var srcEdges1 = src1._private.edges;
            // look at edges connected to the src node of this edge
            for(var j = 0; j < srcEdges1.length; j++){
                var edge2 = srcEdges1[j];
                var edge2data = edge2._private.data;
                var tgtid2 = edge2data.target;
                var srcid2 = edge2data.source;
                var codirected = tgtid2 === tgtid1 && srcid2 === srcid1;
                var oppdirected = srcid1 === tgtid2 && tgtid1 === srcid2;
                if (p.codirected && codirected || !p.codirected && (codirected || oppdirected)) elements.push(edge2);
            }
        }
        return this.spawn(elements, true).filter(selector);
    };
}
// Misc functions
/////////////////
$e815fda779bc047b$var$extend($e815fda779bc047b$var$elesfn$2, {
    components: function components(root) {
        var self1 = this;
        var cy = self1.cy();
        var visited = cy.collection();
        var unvisited = root == null ? self1.nodes() : root.nodes();
        var components = [];
        if (root != null && unvisited.empty()) // root may contain only edges
        unvisited = root.sources(); // doesn't matter which node to use (undirected), so just use the source sides
        var visitInComponent = function visitInComponent(node, component) {
            visited.merge(node);
            unvisited.unmerge(node);
            component.merge(node);
        };
        if (unvisited.empty()) return self1.spawn();
        var _loop = function _loop() {
            // each iteration yields a component
            var cmpt = cy.collection();
            components.push(cmpt);
            var root = unvisited[0];
            visitInComponent(root, cmpt);
            self1.bfs({
                directed: false,
                roots: root,
                visit: function visit(v) {
                    return visitInComponent(v, cmpt);
                }
            });
            cmpt.forEach(function(node) {
                node.connectedEdges().forEach(function(e) {
                    // connectedEdges() usually cached
                    if (self1.has(e) && cmpt.has(e.source()) && cmpt.has(e.target())) // has() is cheap
                    cmpt.merge(e); // forEach() only considers nodes -- sets N at call time
                });
            });
        };
        do _loop();
        while (unvisited.length > 0);
        return components;
    },
    component: function component() {
        var ele = this[0];
        return ele.cy().mutableElements().components(ele)[0];
    }
});
$e815fda779bc047b$var$elesfn$2.componentsOf = $e815fda779bc047b$var$elesfn$2.components;
// represents a set of nodes, edges, or both together
var $e815fda779bc047b$var$Collection = function Collection(cy, elements) {
    var unique = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var removed = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (cy === undefined) {
        $e815fda779bc047b$var$error('A collection must have a reference to the core');
        return;
    }
    var map = new $e815fda779bc047b$var$Map$1();
    var createdElements = false;
    if (!elements) elements = [];
    else if (elements.length > 0 && $e815fda779bc047b$var$plainObject(elements[0]) && !$e815fda779bc047b$var$element(elements[0])) {
        createdElements = true;
        // make elements from json and restore all at once later
        var eles = [];
        var elesIds = new $e815fda779bc047b$var$Set$1();
        for(var i = 0, l = elements.length; i < l; i++){
            var json = elements[i];
            if (json.data == null) json.data = {};
            var _data = json.data;
            // make sure newly created elements have valid ids
            if (_data.id == null) _data.id = $e815fda779bc047b$var$uuid();
            else if (cy.hasElementWithId(_data.id) || elesIds.has(_data.id)) continue; // can't create element if prior id already exists
            var ele = new $e815fda779bc047b$var$Element(cy, json, false);
            eles.push(ele);
            elesIds.add(_data.id);
        }
        elements = eles;
    }
    this.length = 0;
    for(var _i = 0, _l = elements.length; _i < _l; _i++){
        var element$1 = elements[_i][0]; // [0] in case elements is an array of collections, rather than array of elements
        if (element$1 == null) continue;
        var id = element$1._private.data.id;
        if (!unique || !map.has(id)) {
            if (unique) map.set(id, {
                index: this.length,
                ele: element$1
            });
            this[this.length] = element$1;
            this.length++;
        }
    }
    this._private = {
        eles: this,
        cy: cy,
        get map () {
            if (this.lazyMap == null) this.rebuildMap();
            return this.lazyMap;
        },
        set map (m){
            this.lazyMap = m;
        },
        rebuildMap: function rebuildMap() {
            var m1 = this.lazyMap = new $e815fda779bc047b$var$Map$1();
            var eles = this.eles;
            for(var _i2 = 0; _i2 < eles.length; _i2++){
                var _ele = eles[_i2];
                m1.set(_ele.id(), {
                    index: _i2,
                    ele: _ele
                });
            }
        }
    };
    if (unique) this._private.map = map;
    // restore the elements if we created them from json
    if (createdElements && !removed) this.restore();
};
// Functions
////////////////////////////////////////////////////////////////////////////////////////////////////
// keep the prototypes in sync (an element has the same functions as a collection)
// and use elefn and elesfn as shorthands to the prototypes
var $e815fda779bc047b$var$elesfn$1 = $e815fda779bc047b$var$Element.prototype = $e815fda779bc047b$var$Collection.prototype = Object.create(Array.prototype);
$e815fda779bc047b$var$elesfn$1.instanceString = function() {
    return 'collection';
};
$e815fda779bc047b$var$elesfn$1.spawn = function(eles, unique) {
    return new $e815fda779bc047b$var$Collection(this.cy(), eles, unique);
};
$e815fda779bc047b$var$elesfn$1.spawnSelf = function() {
    return this.spawn(this);
};
$e815fda779bc047b$var$elesfn$1.cy = function() {
    return this._private.cy;
};
$e815fda779bc047b$var$elesfn$1.renderer = function() {
    return this._private.cy.renderer();
};
$e815fda779bc047b$var$elesfn$1.element = function() {
    return this[0];
};
$e815fda779bc047b$var$elesfn$1.collection = function() {
    if ($e815fda779bc047b$var$collection(this)) return this;
    else // an element
    return new $e815fda779bc047b$var$Collection(this._private.cy, [
        this
    ]);
};
$e815fda779bc047b$var$elesfn$1.unique = function() {
    return new $e815fda779bc047b$var$Collection(this._private.cy, this, true);
};
$e815fda779bc047b$var$elesfn$1.hasElementWithId = function(id) {
    id = '' + id; // id must be string
    return this._private.map.has(id);
};
$e815fda779bc047b$var$elesfn$1.getElementById = function(id) {
    id = '' + id; // id must be string
    var cy = this._private.cy;
    var entry = this._private.map.get(id);
    return entry ? entry.ele : new $e815fda779bc047b$var$Collection(cy); // get ele or empty collection
};
$e815fda779bc047b$var$elesfn$1.$id = $e815fda779bc047b$var$elesfn$1.getElementById;
$e815fda779bc047b$var$elesfn$1.poolIndex = function() {
    var cy = this._private.cy;
    var eles = cy._private.elements;
    var id = this[0]._private.data.id;
    return eles._private.map.get(id).index;
};
$e815fda779bc047b$var$elesfn$1.indexOf = function(ele) {
    var id = ele[0]._private.data.id;
    return this._private.map.get(id).index;
};
$e815fda779bc047b$var$elesfn$1.indexOfId = function(id) {
    id = '' + id; // id must be string
    return this._private.map.get(id).index;
};
$e815fda779bc047b$var$elesfn$1.json = function(obj) {
    var ele = this.element();
    var cy = this.cy();
    if (ele == null && obj) return this;
     // can't set to no eles
    if (ele == null) return undefined;
     // can't get from no eles
    var p = ele._private;
    if ($e815fda779bc047b$var$plainObject(obj)) {
        // set
        cy.startBatch();
        if (obj.data) {
            ele.data(obj.data);
            var _data2 = p.data;
            if (ele.isEdge()) {
                // source and target are immutable via data()
                var move = false;
                var spec = {};
                var src = obj.data.source;
                var tgt = obj.data.target;
                if (src != null && src != _data2.source) {
                    spec.source = '' + src; // id must be string
                    move = true;
                }
                if (tgt != null && tgt != _data2.target) {
                    spec.target = '' + tgt; // id must be string
                    move = true;
                }
                if (move) ele = ele.move(spec);
            } else {
                // parent is immutable via data()
                var newParentValSpecd = 'parent' in obj.data;
                var parent = obj.data.parent;
                if (newParentValSpecd && (parent != null || _data2.parent != null) && parent != _data2.parent) {
                    if (parent === undefined) // can't set undefined imperatively, so use null
                    parent = null;
                    if (parent != null) parent = '' + parent; // id must be string
                    ele = ele.move({
                        parent: parent
                    });
                }
            }
        }
        if (obj.position) ele.position(obj.position);
        // ignore group -- immutable
        var checkSwitch = function checkSwitch(k, trueFnName, falseFnName) {
            var obj_k = obj[k];
            if (obj_k != null && obj_k !== p[k]) {
                if (obj_k) ele[trueFnName]();
                else ele[falseFnName]();
            }
        };
        checkSwitch('removed', 'remove', 'restore');
        checkSwitch('selected', 'select', 'unselect');
        checkSwitch('selectable', 'selectify', 'unselectify');
        checkSwitch('locked', 'lock', 'unlock');
        checkSwitch('grabbable', 'grabify', 'ungrabify');
        checkSwitch('pannable', 'panify', 'unpanify');
        if (obj.classes != null) ele.classes(obj.classes);
        cy.endBatch();
        return this;
    } else if (obj === undefined) {
        // get
        var json = {
            data: $e815fda779bc047b$var$copy(p.data),
            position: $e815fda779bc047b$var$copy(p.position),
            group: p.group,
            removed: p.removed,
            selected: p.selected,
            selectable: p.selectable,
            locked: p.locked,
            grabbable: p.grabbable,
            pannable: p.pannable,
            classes: null
        };
        json.classes = '';
        var i = 0;
        p.classes.forEach(function(cls) {
            return json.classes += i++ === 0 ? cls : ' ' + cls;
        });
        return json;
    }
};
$e815fda779bc047b$var$elesfn$1.jsons = function() {
    var jsons = [];
    for(var i = 0; i < this.length; i++){
        var ele = this[i];
        var json = ele.json();
        jsons.push(json);
    }
    return jsons;
};
$e815fda779bc047b$var$elesfn$1.clone = function() {
    var cy = this.cy();
    var elesArr = [];
    for(var i = 0; i < this.length; i++){
        var ele = this[i];
        var json = ele.json();
        var clone = new $e815fda779bc047b$var$Element(cy, json, false); // NB no restore
        elesArr.push(clone);
    }
    return new $e815fda779bc047b$var$Collection(cy, elesArr);
};
$e815fda779bc047b$var$elesfn$1.copy = $e815fda779bc047b$var$elesfn$1.clone;
$e815fda779bc047b$var$elesfn$1.restore = function() {
    var notifyRenderer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var addToPool = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var self1 = this;
    var cy = self1.cy();
    var cy_p = cy._private;
    // create arrays of nodes and edges, since we need to
    // restore the nodes first
    var nodes = [];
    var edges = [];
    var elements;
    for(var _i3 = 0, l = self1.length; _i3 < l; _i3++){
        var ele = self1[_i3];
        if (addToPool && !ele.removed()) continue;
        // keep nodes first in the array and edges after
        if (ele.isNode()) // put to front of array if node
        nodes.push(ele);
        else // put to end of array if edge
        edges.push(ele);
    }
    elements = nodes.concat(edges);
    var i;
    var removeFromElements = function removeFromElements() {
        elements.splice(i, 1);
        i--;
    };
    // now, restore each element
    for(i = 0; i < elements.length; i++){
        var _ele2 = elements[i];
        var _private = _ele2._private;
        var _data3 = _private.data;
        // the traversal cache should start fresh when ele is added
        _ele2.clearTraversalCache();
        // set id and validate
        if (!addToPool && !_private.removed) ;
        else if (_data3.id === undefined) _data3.id = $e815fda779bc047b$var$uuid();
        else if ($e815fda779bc047b$var$number$1(_data3.id)) _data3.id = '' + _data3.id; // now it's a string
        else if ($e815fda779bc047b$var$emptyString(_data3.id) || !$e815fda779bc047b$var$string(_data3.id)) {
            $e815fda779bc047b$var$error('Can not create element with invalid string ID `' + _data3.id + '`');
            // can't create element if it has empty string as id or non-string id
            removeFromElements();
            continue;
        } else if (cy.hasElementWithId(_data3.id)) {
            $e815fda779bc047b$var$error('Can not create second element with ID `' + _data3.id + '`');
            // can't create element if one already has that id
            removeFromElements();
            continue;
        }
        var id = _data3.id; // id is finalised, now let's keep a ref
        if (_ele2.isNode()) {
            // extra checks for nodes
            var pos = _private.position;
            // make sure the nodes have a defined position
            if (pos.x == null) pos.x = 0;
            if (pos.y == null) pos.y = 0;
        }
        if (_ele2.isEdge()) {
            // extra checks for edges
            var edge = _ele2;
            var fields = [
                'source',
                'target'
            ];
            var fieldsLength = fields.length;
            var badSourceOrTarget = false;
            for(var j = 0; j < fieldsLength; j++){
                var field = fields[j];
                var val = _data3[field];
                if ($e815fda779bc047b$var$number$1(val)) val = _data3[field] = '' + _data3[field]; // now string
                if (val == null || val === '') {
                    // can't create if source or target is not defined properly
                    $e815fda779bc047b$var$error('Can not create edge `' + id + '` with unspecified ' + field);
                    badSourceOrTarget = true;
                } else if (!cy.hasElementWithId(val)) {
                    // can't create edge if one of its nodes doesn't exist
                    $e815fda779bc047b$var$error('Can not create edge `' + id + '` with nonexistent ' + field + ' `' + val + '`');
                    badSourceOrTarget = true;
                }
            }
            if (badSourceOrTarget) {
                removeFromElements();
                continue;
            } // can't create this
            var src = cy.getElementById(_data3.source);
            var tgt = cy.getElementById(_data3.target);
            // only one edge in node if loop
            if (src.same(tgt)) src._private.edges.push(edge);
            else {
                src._private.edges.push(edge);
                tgt._private.edges.push(edge);
            }
            edge._private.source = src;
            edge._private.target = tgt;
        } // if is edge
        // create mock ids / indexes maps for element so it can be used like collections
        _private.map = new $e815fda779bc047b$var$Map$1();
        _private.map.set(id, {
            ele: _ele2,
            index: 0
        });
        _private.removed = false;
        if (addToPool) cy.addToPool(_ele2);
    } // for each element
    // do compound node sanity checks
    for(var _i4 = 0; _i4 < nodes.length; _i4++){
        // each node
        var node = nodes[_i4];
        var _data4 = node._private.data;
        if ($e815fda779bc047b$var$number$1(_data4.parent)) // then automake string
        _data4.parent = '' + _data4.parent;
        var parentId = _data4.parent;
        var specifiedParent = parentId != null;
        if (specifiedParent || node._private.parent) {
            var parent = node._private.parent ? cy.collection().merge(node._private.parent) : cy.getElementById(parentId);
            if (parent.empty()) // non-existant parent; just remove it
            _data4.parent = undefined;
            else if (parent[0].removed()) {
                $e815fda779bc047b$var$warn('Node added with missing parent, reference to parent removed');
                _data4.parent = undefined;
                node._private.parent = null;
            } else {
                var selfAsParent = false;
                var ancestor = parent;
                while(!ancestor.empty()){
                    if (node.same(ancestor)) {
                        // mark self as parent and remove from data
                        selfAsParent = true;
                        _data4.parent = undefined; // remove parent reference
                        break;
                    }
                    ancestor = ancestor.parent();
                }
                if (!selfAsParent) {
                    // connect with children
                    parent[0]._private.children.push(node);
                    node._private.parent = parent[0];
                    // let the core know we have a compound graph
                    cy_p.hasCompoundNodes = true;
                }
            } // else
        } // if specified parent
    } // for each node
    if (elements.length > 0) {
        var restored = elements.length === self1.length ? self1 : new $e815fda779bc047b$var$Collection(cy, elements);
        for(var _i5 = 0; _i5 < restored.length; _i5++){
            var _ele3 = restored[_i5];
            if (_ele3.isNode()) continue;
            // adding an edge invalidates the traversal caches for the parallel edges
            _ele3.parallelEdges().clearTraversalCache();
            // adding an edge invalidates the traversal cache for the connected nodes
            _ele3.source().clearTraversalCache();
            _ele3.target().clearTraversalCache();
        }
        var toUpdateStyle;
        if (cy_p.hasCompoundNodes) toUpdateStyle = cy.collection().merge(restored).merge(restored.connectedNodes()).merge(restored.parent());
        else toUpdateStyle = restored;
        toUpdateStyle.dirtyCompoundBoundsCache().dirtyBoundingBoxCache().updateStyle(notifyRenderer);
        if (notifyRenderer) restored.emitAndNotify('add');
        else if (addToPool) restored.emit('add');
    }
    return self1; // chainability
};
$e815fda779bc047b$var$elesfn$1.removed = function() {
    var ele = this[0];
    return ele && ele._private.removed;
};
$e815fda779bc047b$var$elesfn$1.inside = function() {
    var ele = this[0];
    return ele && !ele._private.removed;
};
$e815fda779bc047b$var$elesfn$1.remove = function() {
    var notifyRenderer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var removeFromPool = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var self1 = this;
    var elesToRemove = [];
    var elesToRemoveIds = {};
    var cy = self1._private.cy;
    // add connected edges
    function addConnectedEdges(node) {
        var edges = node._private.edges;
        for(var i = 0; i < edges.length; i++)add(edges[i]);
    }
    // add descendant nodes
    function addChildren(node) {
        var children = node._private.children;
        for(var i = 0; i < children.length; i++)add(children[i]);
    }
    function add(ele) {
        var alreadyAdded = elesToRemoveIds[ele.id()];
        if (removeFromPool && ele.removed() || alreadyAdded) return;
        else elesToRemoveIds[ele.id()] = true;
        if (ele.isNode()) {
            elesToRemove.push(ele); // nodes are removed last
            addConnectedEdges(ele);
            addChildren(ele);
        } else elesToRemove.unshift(ele); // edges are removed first
    }
    // make the list of elements to remove
    // (may be removing more than specified due to connected edges etc)
    for(var i = 0, l = self1.length; i < l; i++){
        var ele = self1[i];
        add(ele);
    }
    function removeEdgeRef(node, edge) {
        var connectedEdges = node._private.edges;
        $e815fda779bc047b$var$removeFromArray(connectedEdges, edge);
        // removing an edges invalidates the traversal cache for its nodes
        node.clearTraversalCache();
    }
    function removeParallelRef(pllEdge) {
        // removing an edge invalidates the traversal caches for the parallel edges
        pllEdge.clearTraversalCache();
    }
    var alteredParents = [];
    alteredParents.ids = {};
    function removeChildRef(parent, ele) {
        ele = ele[0];
        parent = parent[0];
        var children = parent._private.children;
        var pid = parent.id();
        $e815fda779bc047b$var$removeFromArray(children, ele); // remove parent => child ref
        ele._private.parent = null; // remove child => parent ref
        if (!alteredParents.ids[pid]) {
            alteredParents.ids[pid] = true;
            alteredParents.push(parent);
        }
    }
    self1.dirtyCompoundBoundsCache();
    if (removeFromPool) cy.removeFromPool(elesToRemove); // remove from core pool
    for(var _i6 = 0; _i6 < elesToRemove.length; _i6++){
        var _ele4 = elesToRemove[_i6];
        if (_ele4.isEdge()) {
            // remove references to this edge in its connected nodes
            var src = _ele4.source()[0];
            var tgt = _ele4.target()[0];
            removeEdgeRef(src, _ele4);
            removeEdgeRef(tgt, _ele4);
            var pllEdges = _ele4.parallelEdges();
            for(var j = 0; j < pllEdges.length; j++){
                var pllEdge = pllEdges[j];
                removeParallelRef(pllEdge);
                if (pllEdge.isBundledBezier()) pllEdge.dirtyBoundingBoxCache();
            }
        } else {
            // remove reference to parent
            var parent = _ele4.parent();
            if (parent.length !== 0) removeChildRef(parent, _ele4);
        }
        if (removeFromPool) // mark as removed
        _ele4._private.removed = true;
    }
    // check to see if we have a compound graph or not
    var elesStillInside = cy._private.elements;
    cy._private.hasCompoundNodes = false;
    for(var _i7 = 0; _i7 < elesStillInside.length; _i7++){
        var _ele5 = elesStillInside[_i7];
        if (_ele5.isParent()) {
            cy._private.hasCompoundNodes = true;
            break;
        }
    }
    var removedElements = new $e815fda779bc047b$var$Collection(this.cy(), elesToRemove);
    if (removedElements.size() > 0) {
        // must manually notify since trigger won't do this automatically once removed
        if (notifyRenderer) removedElements.emitAndNotify('remove');
        else if (removeFromPool) removedElements.emit('remove');
    }
    // the parents who were modified by the removal need their style updated
    for(var _i8 = 0; _i8 < alteredParents.length; _i8++){
        var _ele6 = alteredParents[_i8];
        if (!removeFromPool || !_ele6.removed()) _ele6.updateStyle();
    }
    return removedElements;
};
$e815fda779bc047b$var$elesfn$1.move = function(struct) {
    var cy = this._private.cy;
    var eles = this;
    // just clean up refs, caches, etc. in the same way as when removing and then restoring
    // (our calls to remove/restore do not remove from the graph or make events)
    var notifyRenderer = false;
    var modifyPool = false;
    var toString = function toString(id) {
        return id == null ? id : '' + id;
    }; // id must be string
    if (struct.source !== undefined || struct.target !== undefined) {
        var srcId = toString(struct.source);
        var tgtId = toString(struct.target);
        var srcExists = srcId != null && cy.hasElementWithId(srcId);
        var tgtExists = tgtId != null && cy.hasElementWithId(tgtId);
        if (srcExists || tgtExists) {
            cy.batch(function() {
                // avoid duplicate style updates
                eles.remove(notifyRenderer, modifyPool); // clean up refs etc.
                eles.emitAndNotify('moveout');
                for(var i = 0; i < eles.length; i++){
                    var ele = eles[i];
                    var _data5 = ele._private.data;
                    if (ele.isEdge()) {
                        if (srcExists) _data5.source = srcId;
                        if (tgtExists) _data5.target = tgtId;
                    }
                }
                eles.restore(notifyRenderer, modifyPool); // make new refs, style, etc.
            });
            eles.emitAndNotify('move');
        }
    } else if (struct.parent !== undefined) {
        // move node to new parent
        var parentId = toString(struct.parent);
        var parentExists = parentId === null || cy.hasElementWithId(parentId);
        if (parentExists) {
            var pidToAssign = parentId === null ? undefined : parentId;
            cy.batch(function() {
                // avoid duplicate style updates
                var updated = eles.remove(notifyRenderer, modifyPool); // clean up refs etc.
                updated.emitAndNotify('moveout');
                for(var i = 0; i < eles.length; i++){
                    var ele = eles[i];
                    var _data6 = ele._private.data;
                    if (ele.isNode()) _data6.parent = pidToAssign;
                }
                updated.restore(notifyRenderer, modifyPool); // make new refs, style, etc.
            });
            eles.emitAndNotify('move');
        }
    }
    return this;
};
[
    $e815fda779bc047b$var$elesfn$j,
    $e815fda779bc047b$var$elesfn$i,
    $e815fda779bc047b$var$elesfn$h,
    $e815fda779bc047b$var$elesfn$g,
    $e815fda779bc047b$var$elesfn$f,
    $e815fda779bc047b$var$data,
    $e815fda779bc047b$var$elesfn$d,
    $e815fda779bc047b$var$dimensions,
    $e815fda779bc047b$var$elesfn$9,
    $e815fda779bc047b$var$elesfn$8,
    $e815fda779bc047b$var$elesfn$7,
    $e815fda779bc047b$var$elesfn$6,
    $e815fda779bc047b$var$elesfn$5,
    $e815fda779bc047b$var$elesfn$4,
    $e815fda779bc047b$var$elesfn$3,
    $e815fda779bc047b$var$elesfn$2
].forEach(function(props) {
    $e815fda779bc047b$var$extend($e815fda779bc047b$var$elesfn$1, props);
});
var $e815fda779bc047b$var$corefn$9 = {
    add: function add(opts) {
        var elements;
        var cy = this;
        // add the elements
        if ($e815fda779bc047b$var$elementOrCollection(opts)) {
            var eles = opts;
            if (eles._private.cy === cy) // same instance => just restore
            elements = eles.restore();
            else {
                // otherwise, copy from json
                var jsons = [];
                for(var i = 0; i < eles.length; i++){
                    var ele = eles[i];
                    jsons.push(ele.json());
                }
                elements = new $e815fda779bc047b$var$Collection(cy, jsons);
            }
        } else if ($e815fda779bc047b$var$array(opts)) {
            var _jsons = opts;
            elements = new $e815fda779bc047b$var$Collection(cy, _jsons);
        } else if ($e815fda779bc047b$var$plainObject(opts) && ($e815fda779bc047b$var$array(opts.nodes) || $e815fda779bc047b$var$array(opts.edges))) {
            var elesByGroup = opts;
            var _jsons2 = [];
            var grs = [
                'nodes',
                'edges'
            ];
            for(var _i = 0, il = grs.length; _i < il; _i++){
                var group = grs[_i];
                var elesArray = elesByGroup[group];
                if ($e815fda779bc047b$var$array(elesArray)) for(var j = 0, jl = elesArray.length; j < jl; j++){
                    var json = $e815fda779bc047b$var$extend({
                        group: group
                    }, elesArray[j]);
                    _jsons2.push(json);
                }
            }
            elements = new $e815fda779bc047b$var$Collection(cy, _jsons2);
        } else {
            var _json = opts;
            elements = new $e815fda779bc047b$var$Element(cy, _json).collection();
        }
        return elements;
    },
    remove: function remove(collection) {
        if ($e815fda779bc047b$var$elementOrCollection(collection)) ;
        else if ($e815fda779bc047b$var$string(collection)) {
            var selector = collection;
            collection = this.$(selector);
        }
        return collection.remove();
    }
};
/* global Float32Array */ /*! Bezier curve function generator. Copyright Gaetan Renaudeau. MIT License: http://en.wikipedia.org/wiki/MIT_License */ function $e815fda779bc047b$var$generateCubicBezier(mX1, mY1, mX2, mY2) {
    var NEWTON_ITERATIONS = 4, NEWTON_MIN_SLOPE = 0.001, SUBDIVISION_PRECISION = 0.0000001, SUBDIVISION_MAX_ITERATIONS = 10, kSplineTableSize = 11, kSampleStepSize = 1.0 / (kSplineTableSize - 1.0), float32ArraySupported = typeof Float32Array !== 'undefined';
    /* Must contain four arguments. */ if (arguments.length !== 4) return false;
    /* Arguments must be numbers. */ for(var i = 0; i < 4; ++i){
        if (typeof arguments[i] !== "number" || isNaN(arguments[i]) || !isFinite(arguments[i])) return false;
    }
    /* X values must be in the [0, 1] range. */ mX1 = Math.min(mX1, 1);
    mX2 = Math.min(mX2, 1);
    mX1 = Math.max(mX1, 0);
    mX2 = Math.max(mX2, 0);
    var mSampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
    function A(aA1, aA2) {
        return 1.0 - 3.0 * aA2 + 3.0 * aA1;
    }
    function B(aA1, aA2) {
        return 3.0 * aA2 - 6.0 * aA1;
    }
    function C(aA1) {
        return 3.0 * aA1;
    }
    function calcBezier(aT, aA1, aA2) {
        return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
    }
    function getSlope(aT, aA1, aA2) {
        return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
    }
    function newtonRaphsonIterate(aX, aGuessT) {
        for(var _i = 0; _i < NEWTON_ITERATIONS; ++_i){
            var currentSlope = getSlope(aGuessT, mX1, mX2);
            if (currentSlope === 0.0) return aGuessT;
            var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
            aGuessT -= currentX / currentSlope;
        }
        return aGuessT;
    }
    function calcSampleValues() {
        for(var _i2 = 0; _i2 < kSplineTableSize; ++_i2)mSampleValues[_i2] = calcBezier(_i2 * kSampleStepSize, mX1, mX2);
    }
    function binarySubdivide(aX, aA, aB) {
        var currentX, currentT, i = 0;
        do {
            currentT = aA + (aB - aA) / 2.0;
            currentX = calcBezier(currentT, mX1, mX2) - aX;
            if (currentX > 0.0) aB = currentT;
            else aA = currentT;
        }while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
        return currentT;
    }
    function getTForX(aX) {
        var intervalStart = 0.0, currentSample = 1, lastSample = kSplineTableSize - 1;
        for(; currentSample !== lastSample && mSampleValues[currentSample] <= aX; ++currentSample)intervalStart += kSampleStepSize;
        --currentSample;
        var dist = (aX - mSampleValues[currentSample]) / (mSampleValues[currentSample + 1] - mSampleValues[currentSample]), guessForT = intervalStart + dist * kSampleStepSize, initialSlope = getSlope(guessForT, mX1, mX2);
        if (initialSlope >= NEWTON_MIN_SLOPE) return newtonRaphsonIterate(aX, guessForT);
        else if (initialSlope === 0.0) return guessForT;
        else return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize);
    }
    var _precomputed = false;
    function precompute() {
        _precomputed = true;
        if (mX1 !== mY1 || mX2 !== mY2) calcSampleValues();
    }
    var f = function f(aX) {
        if (!_precomputed) precompute();
        if (mX1 === mY1 && mX2 === mY2) return aX;
        if (aX === 0) return 0;
        if (aX === 1) return 1;
        return calcBezier(getTForX(aX), mY1, mY2);
    };
    f.getControlPoints = function() {
        return [
            {
                x: mX1,
                y: mY1
            },
            {
                x: mX2,
                y: mY2
            }
        ];
    };
    var str = "generateBezier(" + [
        mX1,
        mY1,
        mX2,
        mY2
    ] + ")";
    f.toString = function() {
        return str;
    };
    return f;
}
/*! Runge-Kutta spring physics function generator. Adapted from Framer.js, copyright Koen Bok. MIT License: http://en.wikipedia.org/wiki/MIT_License */ /* Given a tension, friction, and duration, a simulation at 60FPS will first run without a defined duration in order to calculate the full path. A second pass
   then adjusts the time delta -- using the relation between actual time and duration -- to calculate the path for the duration-constrained animation. */ var $e815fda779bc047b$var$generateSpringRK4 = function() {
    function springAccelerationForState(state) {
        return -state.tension * state.x - state.friction * state.v;
    }
    function springEvaluateStateWithDerivative(initialState, dt, derivative) {
        var state = {
            x: initialState.x + derivative.dx * dt,
            v: initialState.v + derivative.dv * dt,
            tension: initialState.tension,
            friction: initialState.friction
        };
        return {
            dx: state.v,
            dv: springAccelerationForState(state)
        };
    }
    function springIntegrateState(state, dt) {
        var a = {
            dx: state.v,
            dv: springAccelerationForState(state)
        }, b = springEvaluateStateWithDerivative(state, dt * 0.5, a), c = springEvaluateStateWithDerivative(state, dt * 0.5, b), d = springEvaluateStateWithDerivative(state, dt, c), dxdt = 1.0 / 6.0 * (a.dx + 2.0 * (b.dx + c.dx) + d.dx), dvdt = 1.0 / 6.0 * (a.dv + 2.0 * (b.dv + c.dv) + d.dv);
        state.x = state.x + dxdt * dt;
        state.v = state.v + dvdt * dt;
        return state;
    }
    return function springRK4Factory(tension, friction, duration) {
        var initState = {
            x: -1,
            v: 0,
            tension: null,
            friction: null
        }, path = [
            0
        ], time_lapsed = 0, tolerance = 0.0001, DT = 0.016, have_duration, dt, last_state;
        tension = parseFloat(tension) || 500;
        friction = parseFloat(friction) || 20;
        duration = duration || null;
        initState.tension = tension;
        initState.friction = friction;
        have_duration = duration !== null;
        /* Calculate the actual time it takes for this animation to complete with the provided conditions. */ if (have_duration) {
            /* Run the simulation without a duration. */ time_lapsed = springRK4Factory(tension, friction);
            /* Compute the adjusted time delta. */ dt = time_lapsed / duration * DT;
        } else dt = DT;
        for(;;){
            /* Next/step function .*/ last_state = springIntegrateState(last_state || initState, dt);
            /* Store the position. */ path.push(1 + last_state.x);
            time_lapsed += 16;
            /* If the change threshold is reached, break. */ if (!(Math.abs(last_state.x) > tolerance && Math.abs(last_state.v) > tolerance)) break;
        }
        /* If duration is not defined, return the actual time required for completing this animation. Otherwise, return a closure that holds the
       computed path and returns a snapshot of the position according to a given percentComplete. */ return !have_duration ? time_lapsed : function(percentComplete) {
            return path[percentComplete * (path.length - 1) | 0];
        };
    };
}();
var $e815fda779bc047b$var$cubicBezier = function cubicBezier(t1, p1, t2, p2) {
    var bezier = $e815fda779bc047b$var$generateCubicBezier(t1, p1, t2, p2);
    return function(start, end, percent) {
        return start + (end - start) * bezier(percent);
    };
};
var $e815fda779bc047b$var$easings = {
    'linear': function linear(start, end, percent) {
        return start + (end - start) * percent;
    },
    // default easings
    'ease': $e815fda779bc047b$var$cubicBezier(0.25, 0.1, 0.25, 1),
    'ease-in': $e815fda779bc047b$var$cubicBezier(0.42, 0, 1, 1),
    'ease-out': $e815fda779bc047b$var$cubicBezier(0, 0, 0.58, 1),
    'ease-in-out': $e815fda779bc047b$var$cubicBezier(0.42, 0, 0.58, 1),
    // sine
    'ease-in-sine': $e815fda779bc047b$var$cubicBezier(0.47, 0, 0.745, 0.715),
    'ease-out-sine': $e815fda779bc047b$var$cubicBezier(0.39, 0.575, 0.565, 1),
    'ease-in-out-sine': $e815fda779bc047b$var$cubicBezier(0.445, 0.05, 0.55, 0.95),
    // quad
    'ease-in-quad': $e815fda779bc047b$var$cubicBezier(0.55, 0.085, 0.68, 0.53),
    'ease-out-quad': $e815fda779bc047b$var$cubicBezier(0.25, 0.46, 0.45, 0.94),
    'ease-in-out-quad': $e815fda779bc047b$var$cubicBezier(0.455, 0.03, 0.515, 0.955),
    // cubic
    'ease-in-cubic': $e815fda779bc047b$var$cubicBezier(0.55, 0.055, 0.675, 0.19),
    'ease-out-cubic': $e815fda779bc047b$var$cubicBezier(0.215, 0.61, 0.355, 1),
    'ease-in-out-cubic': $e815fda779bc047b$var$cubicBezier(0.645, 0.045, 0.355, 1),
    // quart
    'ease-in-quart': $e815fda779bc047b$var$cubicBezier(0.895, 0.03, 0.685, 0.22),
    'ease-out-quart': $e815fda779bc047b$var$cubicBezier(0.165, 0.84, 0.44, 1),
    'ease-in-out-quart': $e815fda779bc047b$var$cubicBezier(0.77, 0, 0.175, 1),
    // quint
    'ease-in-quint': $e815fda779bc047b$var$cubicBezier(0.755, 0.05, 0.855, 0.06),
    'ease-out-quint': $e815fda779bc047b$var$cubicBezier(0.23, 1, 0.32, 1),
    'ease-in-out-quint': $e815fda779bc047b$var$cubicBezier(0.86, 0, 0.07, 1),
    // expo
    'ease-in-expo': $e815fda779bc047b$var$cubicBezier(0.95, 0.05, 0.795, 0.035),
    'ease-out-expo': $e815fda779bc047b$var$cubicBezier(0.19, 1, 0.22, 1),
    'ease-in-out-expo': $e815fda779bc047b$var$cubicBezier(1, 0, 0, 1),
    // circ
    'ease-in-circ': $e815fda779bc047b$var$cubicBezier(0.6, 0.04, 0.98, 0.335),
    'ease-out-circ': $e815fda779bc047b$var$cubicBezier(0.075, 0.82, 0.165, 1),
    'ease-in-out-circ': $e815fda779bc047b$var$cubicBezier(0.785, 0.135, 0.15, 0.86),
    // user param easings...
    'spring': function spring(tension, friction, duration) {
        if (duration === 0) // can't get a spring w/ duration 0
        return $e815fda779bc047b$var$easings.linear; // duration 0 => jump to end so impl doesn't matter
        var spring = $e815fda779bc047b$var$generateSpringRK4(tension, friction, duration);
        return function(start, end, percent) {
            return start + (end - start) * spring(percent);
        };
    },
    'cubic-bezier': $e815fda779bc047b$var$cubicBezier
};
function $e815fda779bc047b$var$getEasedValue(type, start, end, percent, easingFn) {
    if (percent === 1) return end;
    if (start === end) return end;
    var val = easingFn(start, end, percent);
    if (type == null) return val;
    if (type.roundValue || type.color) val = Math.round(val);
    if (type.min !== undefined) val = Math.max(val, type.min);
    if (type.max !== undefined) val = Math.min(val, type.max);
    return val;
}
function $e815fda779bc047b$var$getValue(prop, spec) {
    if (prop.pfValue != null || prop.value != null) {
        if (prop.pfValue != null && (spec == null || spec.type.units !== '%')) return prop.pfValue;
        else return prop.value;
    } else return prop;
}
function $e815fda779bc047b$var$ease(startProp, endProp, percent, easingFn, propSpec) {
    var type = propSpec != null ? propSpec.type : null;
    if (percent < 0) percent = 0;
    else if (percent > 1) percent = 1;
    var start = $e815fda779bc047b$var$getValue(startProp, propSpec);
    var end = $e815fda779bc047b$var$getValue(endProp, propSpec);
    if ($e815fda779bc047b$var$number$1(start) && $e815fda779bc047b$var$number$1(end)) return $e815fda779bc047b$var$getEasedValue(type, start, end, percent, easingFn);
    else if ($e815fda779bc047b$var$array(start) && $e815fda779bc047b$var$array(end)) {
        var easedArr = [];
        for(var i = 0; i < end.length; i++){
            var si = start[i];
            var ei = end[i];
            if (si != null && ei != null) {
                var val = $e815fda779bc047b$var$getEasedValue(type, si, ei, percent, easingFn);
                easedArr.push(val);
            } else easedArr.push(ei);
        }
        return easedArr;
    }
    return undefined;
}
function $e815fda779bc047b$var$step$1(self1, ani, now, isCore) {
    var isEles = !isCore;
    var _p = self1._private;
    var ani_p = ani._private;
    var pEasing = ani_p.easing;
    var startTime = ani_p.startTime;
    var cy = isCore ? self1 : self1.cy();
    var style = cy.style();
    if (!ani_p.easingImpl) {
        if (pEasing == null) // use default
        ani_p.easingImpl = $e815fda779bc047b$var$easings['linear'];
        else {
            // then define w/ name
            var easingVals;
            if ($e815fda779bc047b$var$string(pEasing)) {
                var easingProp = style.parse('transition-timing-function', pEasing);
                easingVals = easingProp.value;
            } else // then assume preparsed array
            easingVals = pEasing;
            var name, args;
            if ($e815fda779bc047b$var$string(easingVals)) {
                name = easingVals;
                args = [];
            } else {
                name = easingVals[1];
                args = easingVals.slice(2).map(function(n) {
                    return +n;
                });
            }
            if (args.length > 0) {
                // create with args
                if (name === 'spring') args.push(ani_p.duration); // need duration to generate spring
                ani_p.easingImpl = $e815fda779bc047b$var$easings[name].apply(null, args);
            } else // static impl by name
            ani_p.easingImpl = $e815fda779bc047b$var$easings[name];
        }
    }
    var easing = ani_p.easingImpl;
    var percent;
    if (ani_p.duration === 0) percent = 1;
    else percent = (now - startTime) / ani_p.duration;
    if (ani_p.applying) percent = ani_p.progress;
    if (percent < 0) percent = 0;
    else if (percent > 1) percent = 1;
    if (ani_p.delay == null) {
        // then update
        var startPos = ani_p.startPosition;
        var endPos = ani_p.position;
        if (endPos && isEles && !self1.locked()) {
            var newPos = {};
            if ($e815fda779bc047b$var$valid(startPos.x, endPos.x)) newPos.x = $e815fda779bc047b$var$ease(startPos.x, endPos.x, percent, easing);
            if ($e815fda779bc047b$var$valid(startPos.y, endPos.y)) newPos.y = $e815fda779bc047b$var$ease(startPos.y, endPos.y, percent, easing);
            self1.position(newPos);
        }
        var startPan = ani_p.startPan;
        var endPan = ani_p.pan;
        var pan = _p.pan;
        var animatingPan = endPan != null && isCore;
        if (animatingPan) {
            if ($e815fda779bc047b$var$valid(startPan.x, endPan.x)) pan.x = $e815fda779bc047b$var$ease(startPan.x, endPan.x, percent, easing);
            if ($e815fda779bc047b$var$valid(startPan.y, endPan.y)) pan.y = $e815fda779bc047b$var$ease(startPan.y, endPan.y, percent, easing);
            self1.emit('pan');
        }
        var startZoom = ani_p.startZoom;
        var endZoom = ani_p.zoom;
        var animatingZoom = endZoom != null && isCore;
        if (animatingZoom) {
            if ($e815fda779bc047b$var$valid(startZoom, endZoom)) _p.zoom = $e815fda779bc047b$var$bound(_p.minZoom, $e815fda779bc047b$var$ease(startZoom, endZoom, percent, easing), _p.maxZoom);
            self1.emit('zoom');
        }
        if (animatingPan || animatingZoom) self1.emit('viewport');
        var props = ani_p.style;
        if (props && props.length > 0 && isEles) {
            for(var i = 0; i < props.length; i++){
                var prop = props[i];
                var _name = prop.name;
                var end = prop;
                var start = ani_p.startStyle[_name];
                var propSpec = style.properties[start.name];
                var easedVal = $e815fda779bc047b$var$ease(start, end, percent, easing, propSpec);
                style.overrideBypass(self1, _name, easedVal);
            } // for props
            self1.emit('style');
        } // if
    }
    ani_p.progress = percent;
    return percent;
}
function $e815fda779bc047b$var$valid(start, end) {
    if (start == null || end == null) return false;
    if ($e815fda779bc047b$var$number$1(start) && $e815fda779bc047b$var$number$1(end)) return true;
    else if (start && end) return true;
    return false;
}
function $e815fda779bc047b$var$startAnimation(self1, ani, now, isCore) {
    var ani_p = ani._private;
    ani_p.started = true;
    ani_p.startTime = now - ani_p.progress * ani_p.duration;
}
function $e815fda779bc047b$var$stepAll(now, cy) {
    var eles = cy._private.aniEles;
    var doneEles = [];
    function stepOne(ele, isCore) {
        var _p = ele._private;
        var current = _p.animation.current;
        var queue = _p.animation.queue;
        var ranAnis = false;
        // if nothing currently animating, get something from the queue
        if (current.length === 0) {
            var next = queue.shift();
            if (next) current.push(next);
        }
        var callbacks = function callbacks(_callbacks) {
            for(var j = _callbacks.length - 1; j >= 0; j--){
                var cb = _callbacks[j];
                cb();
            }
            _callbacks.splice(0, _callbacks.length);
        };
        // step and remove if done
        for(var i = current.length - 1; i >= 0; i--){
            var ani = current[i];
            var ani_p = ani._private;
            if (ani_p.stopped) {
                current.splice(i, 1);
                ani_p.hooked = false;
                ani_p.playing = false;
                ani_p.started = false;
                callbacks(ani_p.frames);
                continue;
            }
            if (!ani_p.playing && !ani_p.applying) continue;
            // an apply() while playing shouldn't do anything
            if (ani_p.playing && ani_p.applying) ani_p.applying = false;
            if (!ani_p.started) $e815fda779bc047b$var$startAnimation(ele, ani, now);
            $e815fda779bc047b$var$step$1(ele, ani, now, isCore);
            if (ani_p.applying) ani_p.applying = false;
            callbacks(ani_p.frames);
            if (ani_p.step != null) ani_p.step(now);
            if (ani.completed()) {
                current.splice(i, 1);
                ani_p.hooked = false;
                ani_p.playing = false;
                ani_p.started = false;
                callbacks(ani_p.completes);
            }
            ranAnis = true;
        }
        if (!isCore && current.length === 0 && queue.length === 0) doneEles.push(ele);
        return ranAnis;
    } // stepElement
    // handle all eles
    var ranEleAni = false;
    for(var e = 0; e < eles.length; e++){
        var ele = eles[e];
        var handledThisEle = stepOne(ele);
        ranEleAni = ranEleAni || handledThisEle;
    } // each element
    var ranCoreAni = stepOne(cy, true);
    // notify renderer
    if (ranEleAni || ranCoreAni) {
        if (eles.length > 0) cy.notify('draw', eles);
        else cy.notify('draw');
    }
    // remove elements from list of currently animating if its queues are empty
    eles.unmerge(doneEles);
    cy.emit('step');
} // stepAll
var $e815fda779bc047b$var$corefn$8 = {
    // pull in animation functions
    animate: $e815fda779bc047b$var$define.animate(),
    animation: $e815fda779bc047b$var$define.animation(),
    animated: $e815fda779bc047b$var$define.animated(),
    clearQueue: $e815fda779bc047b$var$define.clearQueue(),
    delay: $e815fda779bc047b$var$define.delay(),
    delayAnimation: $e815fda779bc047b$var$define.delayAnimation(),
    stop: $e815fda779bc047b$var$define.stop(),
    addToAnimationPool: function addToAnimationPool(eles) {
        var cy = this;
        if (!cy.styleEnabled()) return;
         // save cycles when no style used
        cy._private.aniEles.merge(eles);
    },
    stopAnimationLoop: function stopAnimationLoop() {
        this._private.animationsRunning = false;
    },
    startAnimationLoop: function startAnimationLoop() {
        var cy = this;
        cy._private.animationsRunning = true;
        if (!cy.styleEnabled()) return;
         // save cycles when no style used
        // NB the animation loop will exec in headless environments if style enabled
        // and explicit cy.destroy() is necessary to stop the loop
        function headlessStep() {
            if (!cy._private.animationsRunning) return;
            $e815fda779bc047b$var$requestAnimationFrame(function animationStep(now) {
                $e815fda779bc047b$var$stepAll(now, cy);
                headlessStep();
            });
        }
        var renderer = cy.renderer();
        if (renderer && renderer.beforeRender) // let the renderer schedule animations
        renderer.beforeRender(function rendererAnimationStep(willDraw, now) {
            $e815fda779bc047b$var$stepAll(now, cy);
        }, renderer.beforeRenderPriorities.animations);
        else // manage the animation loop ourselves
        headlessStep(); // first call
    }
};
var $e815fda779bc047b$var$emitterOptions = {
    qualifierCompare: function qualifierCompare(selector1, selector2) {
        if (selector1 == null || selector2 == null) return selector1 == null && selector2 == null;
        else return selector1.sameText(selector2);
    },
    eventMatches: function eventMatches(cy, listener, eventObj) {
        var selector = listener.qualifier;
        if (selector != null) return cy !== eventObj.target && $e815fda779bc047b$var$element(eventObj.target) && selector.matches(eventObj.target);
        return true;
    },
    addEventFields: function addEventFields(cy, evt) {
        evt.cy = cy;
        evt.target = cy;
    },
    callbackContext: function callbackContext(cy, listener, eventObj) {
        return listener.qualifier != null ? eventObj.target : cy;
    }
};
var $e815fda779bc047b$var$argSelector = function argSelector(arg) {
    if ($e815fda779bc047b$var$string(arg)) return new $e815fda779bc047b$var$Selector(arg);
    else return arg;
};
var $e815fda779bc047b$var$elesfn = {
    createEmitter: function createEmitter() {
        var _p = this._private;
        if (!_p.emitter) _p.emitter = new $e815fda779bc047b$var$Emitter($e815fda779bc047b$var$emitterOptions, this);
        return this;
    },
    emitter: function emitter() {
        return this._private.emitter;
    },
    on: function on(events, selector, callback) {
        this.emitter().on(events, $e815fda779bc047b$var$argSelector(selector), callback);
        return this;
    },
    removeListener: function removeListener(events, selector, callback) {
        this.emitter().removeListener(events, $e815fda779bc047b$var$argSelector(selector), callback);
        return this;
    },
    removeAllListeners: function removeAllListeners() {
        this.emitter().removeAllListeners();
        return this;
    },
    one: function one(events, selector, callback) {
        this.emitter().one(events, $e815fda779bc047b$var$argSelector(selector), callback);
        return this;
    },
    once: function once(events, selector, callback) {
        this.emitter().one(events, $e815fda779bc047b$var$argSelector(selector), callback);
        return this;
    },
    emit: function emit(events, extraParams) {
        this.emitter().emit(events, extraParams);
        return this;
    },
    emitAndNotify: function emitAndNotify(event, eles) {
        this.emit(event);
        this.notify(event, eles);
        return this;
    }
};
$e815fda779bc047b$var$define.eventAliasesOn($e815fda779bc047b$var$elesfn);
var $e815fda779bc047b$var$corefn$7 = {
    png: function png(options) {
        var renderer = this._private.renderer;
        options = options || {};
        return renderer.png(options);
    },
    jpg: function jpg(options) {
        var renderer = this._private.renderer;
        options = options || {};
        options.bg = options.bg || '#fff';
        return renderer.jpg(options);
    }
};
$e815fda779bc047b$var$corefn$7.jpeg = $e815fda779bc047b$var$corefn$7.jpg;
var $e815fda779bc047b$var$corefn$6 = {
    layout: function layout(options) {
        var cy = this;
        if (options == null) {
            $e815fda779bc047b$var$error('Layout options must be specified to make a layout');
            return;
        }
        if (options.name == null) {
            $e815fda779bc047b$var$error('A `name` must be specified to make a layout');
            return;
        }
        var name = options.name;
        var Layout = cy.extension('layout', name);
        if (Layout == null) {
            $e815fda779bc047b$var$error('No such layout `' + name + '` found.  Did you forget to import it and `cytoscape.use()` it?');
            return;
        }
        var eles;
        if ($e815fda779bc047b$var$string(options.eles)) eles = cy.$(options.eles);
        else eles = options.eles != null ? options.eles : cy.$();
        var layout = new Layout($e815fda779bc047b$var$extend({}, options, {
            cy: cy,
            eles: eles
        }));
        return layout;
    }
};
$e815fda779bc047b$var$corefn$6.createLayout = $e815fda779bc047b$var$corefn$6.makeLayout = $e815fda779bc047b$var$corefn$6.layout;
var $e815fda779bc047b$var$corefn$5 = {
    notify: function notify(eventName, eventEles) {
        var _p = this._private;
        if (this.batching()) {
            _p.batchNotifications = _p.batchNotifications || {};
            var eles = _p.batchNotifications[eventName] = _p.batchNotifications[eventName] || this.collection();
            if (eventEles != null) eles.merge(eventEles);
            return; // notifications are disabled during batching
        }
        if (!_p.notificationsEnabled) return;
         // exit on disabled
        var renderer = this.renderer();
        // exit if destroy() called on core or renderer in between frames #1499 #1528
        if (this.destroyed() || !renderer) return;
        renderer.notify(eventName, eventEles);
    },
    notifications: function notifications(bool) {
        var p = this._private;
        if (bool === undefined) return p.notificationsEnabled;
        else p.notificationsEnabled = bool ? true : false;
        return this;
    },
    noNotifications: function noNotifications(callback) {
        this.notifications(false);
        callback();
        this.notifications(true);
    },
    batching: function batching() {
        return this._private.batchCount > 0;
    },
    startBatch: function startBatch() {
        var _p = this._private;
        if (_p.batchCount == null) _p.batchCount = 0;
        if (_p.batchCount === 0) {
            _p.batchStyleEles = this.collection();
            _p.batchNotifications = {};
        }
        _p.batchCount++;
        return this;
    },
    endBatch: function endBatch() {
        var _p = this._private;
        if (_p.batchCount === 0) return this;
        _p.batchCount--;
        if (_p.batchCount === 0) {
            // update style for dirty eles
            _p.batchStyleEles.updateStyle();
            var renderer = this.renderer();
            // notify the renderer of queued eles and event types
            Object.keys(_p.batchNotifications).forEach(function(eventName) {
                var eles = _p.batchNotifications[eventName];
                if (eles.empty()) renderer.notify(eventName);
                else renderer.notify(eventName, eles);
            });
        }
        return this;
    },
    batch: function batch(callback) {
        this.startBatch();
        callback();
        this.endBatch();
        return this;
    },
    // for backwards compatibility
    batchData: function batchData(map) {
        var cy = this;
        return this.batch(function() {
            var ids = Object.keys(map);
            for(var i = 0; i < ids.length; i++){
                var id = ids[i];
                var data = map[id];
                var ele = cy.getElementById(id);
                ele.data(data);
            }
        });
    }
};
var $e815fda779bc047b$var$rendererDefaults = $e815fda779bc047b$var$defaults$g({
    hideEdgesOnViewport: false,
    textureOnViewport: false,
    motionBlur: false,
    motionBlurOpacity: 0.05,
    pixelRatio: undefined,
    desktopTapThreshold: 4,
    touchTapThreshold: 8,
    wheelSensitivity: 1,
    debug: false,
    showFps: false,
    // webgl options
    webgl: false,
    webglDebug: false,
    webglDebugShowAtlases: false,
    // defaults good for mobile
    webglTexSize: 2048,
    webglTexRows: 36,
    webglTexRowsNodes: 18,
    webglBatchSize: 2048,
    webglTexPerBatch: 14,
    webglBgColor: [
        255,
        255,
        255
    ]
});
var $e815fda779bc047b$var$corefn$4 = {
    renderTo: function renderTo(context, zoom, pan, pxRatio) {
        var r = this._private.renderer;
        r.renderTo(context, zoom, pan, pxRatio);
        return this;
    },
    renderer: function renderer() {
        return this._private.renderer;
    },
    forceRender: function forceRender() {
        this.notify('draw');
        return this;
    },
    resize: function resize() {
        this.invalidateSize();
        this.emitAndNotify('resize');
        return this;
    },
    initRenderer: function initRenderer(options) {
        var cy = this;
        var RendererProto = cy.extension('renderer', options.name);
        if (RendererProto == null) {
            $e815fda779bc047b$var$error("Can not initialise: No such renderer `".concat(options.name, "` found. Did you forget to import it and `cytoscape.use()` it?"));
            return;
        }
        if (options.wheelSensitivity !== undefined) $e815fda779bc047b$var$warn("You have set a custom wheel sensitivity.  This will make your app zoom unnaturally when using mainstream mice.  You should change this value from the default only if you can guarantee that all your users will use the same hardware and OS configuration as your current machine.");
        var rOpts = $e815fda779bc047b$var$rendererDefaults(options);
        rOpts.cy = cy;
        cy._private.renderer = new RendererProto(rOpts);
        this.notify('init');
    },
    destroyRenderer: function destroyRenderer() {
        var cy = this;
        cy.notify('destroy'); // destroy the renderer
        var domEle = cy.container();
        if (domEle) {
            domEle._cyreg = null;
            while(domEle.childNodes.length > 0)domEle.removeChild(domEle.childNodes[0]);
        }
        cy._private.renderer = null; // to be extra safe, remove the ref
        cy.mutableElements().forEach(function(ele) {
            var _p = ele._private;
            _p.rscratch = {};
            _p.rstyle = {};
            _p.animation.current = [];
            _p.animation.queue = [];
        });
    },
    onRender: function onRender(fn) {
        return this.on('render', fn);
    },
    offRender: function offRender(fn) {
        return this.off('render', fn);
    }
};
$e815fda779bc047b$var$corefn$4.invalidateDimensions = $e815fda779bc047b$var$corefn$4.resize;
var $e815fda779bc047b$var$corefn$3 = {
    // get a collection
    // - empty collection on no args
    // - collection of elements in the graph on selector arg
    // - guarantee a returned collection when elements or collection specified
    collection: function collection(eles, opts) {
        if ($e815fda779bc047b$var$string(eles)) return this.$(eles);
        else if ($e815fda779bc047b$var$elementOrCollection(eles)) return eles.collection();
        else if ($e815fda779bc047b$var$array(eles)) {
            if (!opts) opts = {};
            return new $e815fda779bc047b$var$Collection(this, eles, opts.unique, opts.removed);
        }
        return new $e815fda779bc047b$var$Collection(this);
    },
    nodes: function nodes(selector) {
        var nodes = this.$(function(ele) {
            return ele.isNode();
        });
        if (selector) return nodes.filter(selector);
        return nodes;
    },
    edges: function edges(selector) {
        var edges = this.$(function(ele) {
            return ele.isEdge();
        });
        if (selector) return edges.filter(selector);
        return edges;
    },
    // search the graph like jQuery
    $: function $(selector) {
        var eles = this._private.elements;
        if (selector) return eles.filter(selector);
        else return eles.spawnSelf();
    },
    mutableElements: function mutableElements() {
        return this._private.elements;
    }
};
// aliases
$e815fda779bc047b$var$corefn$3.elements = $e815fda779bc047b$var$corefn$3.filter = $e815fda779bc047b$var$corefn$3.$;
var $e815fda779bc047b$var$styfn$8 = {};
// keys for style blocks, e.g. ttfftt
var $e815fda779bc047b$var$TRUE = 't';
var $e815fda779bc047b$var$FALSE = 'f';
// (potentially expensive calculation)
// apply the style to the element based on
// - its bypass
// - what selectors match it
$e815fda779bc047b$var$styfn$8.apply = function(eles) {
    var self1 = this;
    var _p = self1._private;
    var cy = _p.cy;
    var updatedEles = cy.collection();
    for(var ie = 0; ie < eles.length; ie++){
        var ele = eles[ie];
        var cxtMeta = self1.getContextMeta(ele);
        if (cxtMeta.empty) continue;
        var cxtStyle = self1.getContextStyle(cxtMeta);
        var app = self1.applyContextStyle(cxtMeta, cxtStyle, ele);
        if (ele._private.appliedInitStyle) self1.updateTransitions(ele, app.diffProps);
        else ele._private.appliedInitStyle = true;
        var hintsDiff = self1.updateStyleHints(ele);
        if (hintsDiff) updatedEles.push(ele);
    } // for elements
    return updatedEles;
};
$e815fda779bc047b$var$styfn$8.getPropertiesDiff = function(oldCxtKey, newCxtKey) {
    var self1 = this;
    var cache = self1._private.propDiffs = self1._private.propDiffs || {};
    var dualCxtKey = oldCxtKey + '-' + newCxtKey;
    var cachedVal = cache[dualCxtKey];
    if (cachedVal) return cachedVal;
    var diffProps = [];
    var addedProp = {};
    for(var i = 0; i < self1.length; i++){
        var cxt = self1[i];
        var oldHasCxt = oldCxtKey[i] === $e815fda779bc047b$var$TRUE;
        var newHasCxt = newCxtKey[i] === $e815fda779bc047b$var$TRUE;
        var cxtHasDiffed = oldHasCxt !== newHasCxt;
        var cxtHasMappedProps = cxt.mappedProperties.length > 0;
        if (cxtHasDiffed || newHasCxt && cxtHasMappedProps) {
            var props = undefined;
            if (cxtHasDiffed && cxtHasMappedProps) props = cxt.properties; // suffices b/c mappedProperties is a subset of properties
            else if (cxtHasDiffed) props = cxt.properties; // need to check them all
            else if (cxtHasMappedProps) props = cxt.mappedProperties; // only need to check mapped
            for(var j = 0; j < props.length; j++){
                var prop = props[j];
                var name = prop.name;
                // if a later context overrides this property, then the fact that this context has switched/diffed doesn't matter
                // (semi expensive check since it makes this function O(n^2) on context length, but worth it since overall result
                // is cached)
                var laterCxtOverrides = false;
                for(var k = i + 1; k < self1.length; k++){
                    var laterCxt = self1[k];
                    var hasLaterCxt = newCxtKey[k] === $e815fda779bc047b$var$TRUE;
                    if (!hasLaterCxt) continue;
                     // can't override unless the context is active
                    laterCxtOverrides = laterCxt.properties[prop.name] != null;
                    if (laterCxtOverrides) break;
                     // exit early as long as one later context overrides
                }
                if (!addedProp[name] && !laterCxtOverrides) {
                    addedProp[name] = true;
                    diffProps.push(name);
                }
            } // for props
        } // if
    } // for contexts
    cache[dualCxtKey] = diffProps;
    return diffProps;
};
$e815fda779bc047b$var$styfn$8.getContextMeta = function(ele) {
    var self1 = this;
    var cxtKey = '';
    var diffProps;
    var prevKey = ele._private.styleCxtKey || '';
    // get the cxt key
    for(var i = 0; i < self1.length; i++){
        var context = self1[i];
        var contextSelectorMatches = context.selector && context.selector.matches(ele); // NB: context.selector may be null for 'core'
        if (contextSelectorMatches) cxtKey += $e815fda779bc047b$var$TRUE;
        else cxtKey += $e815fda779bc047b$var$FALSE;
    } // for context
    diffProps = self1.getPropertiesDiff(prevKey, cxtKey);
    ele._private.styleCxtKey = cxtKey;
    return {
        key: cxtKey,
        diffPropNames: diffProps,
        empty: diffProps.length === 0
    };
};
// gets a computed ele style object based on matched contexts
$e815fda779bc047b$var$styfn$8.getContextStyle = function(cxtMeta) {
    var cxtKey = cxtMeta.key;
    var self1 = this;
    var cxtStyles = this._private.contextStyles = this._private.contextStyles || {};
    // if already computed style, returned cached copy
    if (cxtStyles[cxtKey]) return cxtStyles[cxtKey];
    var style = {
        _private: {
            key: cxtKey
        }
    };
    for(var i = 0; i < self1.length; i++){
        var cxt = self1[i];
        var hasCxt = cxtKey[i] === $e815fda779bc047b$var$TRUE;
        if (!hasCxt) continue;
        for(var j = 0; j < cxt.properties.length; j++){
            var prop = cxt.properties[j];
            style[prop.name] = prop;
        }
    }
    cxtStyles[cxtKey] = style;
    return style;
};
$e815fda779bc047b$var$styfn$8.applyContextStyle = function(cxtMeta, cxtStyle, ele) {
    var self1 = this;
    var diffProps = cxtMeta.diffPropNames;
    var retDiffProps = {};
    var types = self1.types;
    for(var i = 0; i < diffProps.length; i++){
        var diffPropName = diffProps[i];
        var cxtProp = cxtStyle[diffPropName];
        var eleProp = ele.pstyle(diffPropName);
        if (!cxtProp) {
            // no context prop means delete
            if (!eleProp) continue; // no existing prop means nothing needs to be removed
            else if (eleProp.bypass) cxtProp = {
                name: diffPropName,
                deleteBypassed: true
            };
            else cxtProp = {
                name: diffPropName,
                "delete": true
            };
        }
        // save cycles when the context prop doesn't need to be applied
        if (eleProp === cxtProp) continue;
        // save cycles when a mapped context prop doesn't need to be applied
        if (cxtProp.mapped === types.fn // context prop is function mapper
         && eleProp != null // some props can be null even by default (e.g. a prop that overrides another one)
         && eleProp.mapping != null // ele prop is a concrete value from from a mapper
         && eleProp.mapping.value === cxtProp.value // the current prop on the ele is a flat prop value for the function mapper
        ) {
            // NB don't write to cxtProp, as it's shared among eles (stored in stylesheet)
            var mapping = eleProp.mapping; // can write to mapping, as it's a per-ele copy
            var fnValue = mapping.fnValue = cxtProp.value(ele); // temporarily cache the value in case of a miss
            if (fnValue === mapping.prevFnValue) continue;
        }
        var retDiffProp = retDiffProps[diffPropName] = {
            prev: eleProp
        };
        self1.applyParsedProperty(ele, cxtProp);
        retDiffProp.next = ele.pstyle(diffPropName);
        if (retDiffProp.next && retDiffProp.next.bypass) retDiffProp.next = retDiffProp.next.bypassed;
    }
    return {
        diffProps: retDiffProps
    };
};
$e815fda779bc047b$var$styfn$8.updateStyleHints = function(ele) {
    var _p = ele._private;
    var self1 = this;
    var propNames = self1.propertyGroupNames;
    var propGrKeys = self1.propertyGroupKeys;
    var propHash = function propHash(ele, propNames, seedKey) {
        return self1.getPropertiesHash(ele, propNames, seedKey);
    };
    var oldStyleKey = _p.styleKey;
    if (ele.removed()) return false;
    var isNode = _p.group === 'nodes';
    // get the style key hashes per prop group
    // but lazily -- only use non-default prop values to reduce the number of hashes
    //
    var overriddenStyles = ele._private.style;
    propNames = Object.keys(overriddenStyles);
    for(var i = 0; i < propGrKeys.length; i++){
        var grKey = propGrKeys[i];
        _p.styleKeys[grKey] = [
            $e815fda779bc047b$var$DEFAULT_HASH_SEED,
            $e815fda779bc047b$var$DEFAULT_HASH_SEED_ALT
        ];
    }
    var updateGrKey1 = function updateGrKey1(val, grKey) {
        return _p.styleKeys[grKey][0] = $e815fda779bc047b$var$hashInt(val, _p.styleKeys[grKey][0]);
    };
    var updateGrKey2 = function updateGrKey2(val, grKey) {
        return _p.styleKeys[grKey][1] = $e815fda779bc047b$var$hashIntAlt(val, _p.styleKeys[grKey][1]);
    };
    var updateGrKey = function updateGrKey(val, grKey) {
        updateGrKey1(val, grKey);
        updateGrKey2(val, grKey);
    };
    var updateGrKeyWStr = function updateGrKeyWStr(strVal, grKey) {
        for(var j = 0; j < strVal.length; j++){
            var ch = strVal.charCodeAt(j);
            updateGrKey1(ch, grKey);
            updateGrKey2(ch, grKey);
        }
    };
    // - hashing works on 32 bit ints b/c we use bitwise ops
    // - small numbers get cut off (e.g. 0.123 is seen as 0 by the hashing function)
    // - raise up small numbers so more significant digits are seen by hashing
    // - make small numbers larger than a normal value to avoid collisions
    // - works in practice and it's relatively cheap
    var N = 2000000000;
    var cleanNum = function cleanNum(val) {
        return -128 < val && val < 128 && Math.floor(val) !== val ? N - (val * 1024 | 0) : val;
    };
    for(var _i = 0; _i < propNames.length; _i++){
        var name = propNames[_i];
        var parsedProp = overriddenStyles[name];
        if (parsedProp == null) continue;
        var propInfo = this.properties[name];
        var type = propInfo.type;
        var _grKey = propInfo.groupKey;
        var normalizedNumberVal = undefined;
        if (propInfo.hashOverride != null) normalizedNumberVal = propInfo.hashOverride(ele, parsedProp);
        else if (parsedProp.pfValue != null) normalizedNumberVal = parsedProp.pfValue;
        // might not be a number if it allows enums
        var numberVal = propInfo.enums == null ? parsedProp.value : null;
        var haveNormNum = normalizedNumberVal != null;
        var haveUnitedNum = numberVal != null;
        var haveNum = haveNormNum || haveUnitedNum;
        var units = parsedProp.units;
        // numbers are cheaper to hash than strings
        // 1 hash op vs n hash ops (for length n string)
        if (type.number && haveNum && !type.multiple) {
            var v = haveNormNum ? normalizedNumberVal : numberVal;
            updateGrKey(cleanNum(v), _grKey);
            if (!haveNormNum && units != null) updateGrKeyWStr(units, _grKey);
        } else updateGrKeyWStr(parsedProp.strValue, _grKey);
    }
    // overall style key
    //
    var hash = [
        $e815fda779bc047b$var$DEFAULT_HASH_SEED,
        $e815fda779bc047b$var$DEFAULT_HASH_SEED_ALT
    ];
    for(var _i2 = 0; _i2 < propGrKeys.length; _i2++){
        var _grKey2 = propGrKeys[_i2];
        var grHash = _p.styleKeys[_grKey2];
        hash[0] = $e815fda779bc047b$var$hashInt(grHash[0], hash[0]);
        hash[1] = $e815fda779bc047b$var$hashIntAlt(grHash[1], hash[1]);
    }
    _p.styleKey = $e815fda779bc047b$var$combineHashes(hash[0], hash[1]);
    // label dims
    //
    var sk = _p.styleKeys;
    _p.labelDimsKey = $e815fda779bc047b$var$combineHashesArray(sk.labelDimensions);
    var labelKeys = propHash(ele, [
        'label'
    ], sk.labelDimensions);
    _p.labelKey = $e815fda779bc047b$var$combineHashesArray(labelKeys);
    _p.labelStyleKey = $e815fda779bc047b$var$combineHashesArray($e815fda779bc047b$var$hashArrays(sk.commonLabel, labelKeys));
    if (!isNode) {
        var sourceLabelKeys = propHash(ele, [
            'source-label'
        ], sk.labelDimensions);
        _p.sourceLabelKey = $e815fda779bc047b$var$combineHashesArray(sourceLabelKeys);
        _p.sourceLabelStyleKey = $e815fda779bc047b$var$combineHashesArray($e815fda779bc047b$var$hashArrays(sk.commonLabel, sourceLabelKeys));
        var targetLabelKeys = propHash(ele, [
            'target-label'
        ], sk.labelDimensions);
        _p.targetLabelKey = $e815fda779bc047b$var$combineHashesArray(targetLabelKeys);
        _p.targetLabelStyleKey = $e815fda779bc047b$var$combineHashesArray($e815fda779bc047b$var$hashArrays(sk.commonLabel, targetLabelKeys));
    }
    // node
    //
    if (isNode) {
        var _p$styleKeys = _p.styleKeys, nodeBody = _p$styleKeys.nodeBody, nodeBorder = _p$styleKeys.nodeBorder, nodeOutline = _p$styleKeys.nodeOutline, backgroundImage = _p$styleKeys.backgroundImage, compound = _p$styleKeys.compound, pie = _p$styleKeys.pie, stripe = _p$styleKeys.stripe;
        var nodeKeys = [
            nodeBody,
            nodeBorder,
            nodeOutline,
            backgroundImage,
            compound,
            pie,
            stripe
        ].filter(function(k) {
            return k != null;
        }).reduce($e815fda779bc047b$var$hashArrays, [
            $e815fda779bc047b$var$DEFAULT_HASH_SEED,
            $e815fda779bc047b$var$DEFAULT_HASH_SEED_ALT
        ]);
        _p.nodeKey = $e815fda779bc047b$var$combineHashesArray(nodeKeys);
        _p.hasPie = pie != null && pie[0] !== $e815fda779bc047b$var$DEFAULT_HASH_SEED && pie[1] !== $e815fda779bc047b$var$DEFAULT_HASH_SEED_ALT;
        _p.hasStripe = stripe != null && stripe[0] !== $e815fda779bc047b$var$DEFAULT_HASH_SEED && stripe[1] !== $e815fda779bc047b$var$DEFAULT_HASH_SEED_ALT;
    }
    return oldStyleKey !== _p.styleKey;
};
$e815fda779bc047b$var$styfn$8.clearStyleHints = function(ele) {
    var _p = ele._private;
    _p.styleCxtKey = '';
    _p.styleKeys = {};
    _p.styleKey = null;
    _p.labelKey = null;
    _p.labelStyleKey = null;
    _p.sourceLabelKey = null;
    _p.sourceLabelStyleKey = null;
    _p.targetLabelKey = null;
    _p.targetLabelStyleKey = null;
    _p.nodeKey = null;
    _p.hasPie = null;
    _p.hasStripe = null;
};
// apply a property to the style (for internal use)
// returns whether application was successful
//
// now, this function flattens the property, and here's how:
//
// for parsedProp:{ bypass: true, deleteBypass: true }
// no property is generated, instead the bypass property in the
// element's style is replaced by what's pointed to by the `bypassed`
// field in the bypass property (i.e. restoring the property the
// bypass was overriding)
//
// for parsedProp:{ mapped: truthy }
// the generated flattenedProp:{ mapping: prop }
//
// for parsedProp:{ bypass: true }
// the generated flattenedProp:{ bypassed: parsedProp }
$e815fda779bc047b$var$styfn$8.applyParsedProperty = function(ele, parsedProp) {
    var self1 = this;
    var prop = parsedProp;
    var style = ele._private.style;
    var flatProp;
    var types = self1.types;
    var type = self1.properties[prop.name].type;
    var propIsBypass = prop.bypass;
    var origProp = style[prop.name];
    var origPropIsBypass = origProp && origProp.bypass;
    var _p = ele._private;
    var flatPropMapping = 'mapping';
    var getVal = function getVal(p) {
        if (p == null) return null;
        else if (p.pfValue != null) return p.pfValue;
        else return p.value;
    };
    var checkTriggers = function checkTriggers() {
        var fromVal = getVal(origProp);
        var toVal = getVal(prop);
        self1.checkTriggers(ele, prop.name, fromVal, toVal);
    };
    // edge sanity checks to prevent the client from making serious mistakes
    if (parsedProp.name === 'curve-style' && ele.isEdge() && // loops must be bundled beziers
    (parsedProp.value !== 'bezier' && ele.isLoop() || // edges connected to compound nodes can not be haystacks
    parsedProp.value === 'haystack' && (ele.source().isParent() || ele.target().isParent()))) prop = parsedProp = this.parse(parsedProp.name, 'bezier', propIsBypass);
    if (prop["delete"]) {
        // delete the property and use the default value on falsey value
        style[prop.name] = undefined;
        checkTriggers();
        return true;
    }
    if (prop.deleteBypassed) {
        // delete the property that the
        if (!origProp) {
            checkTriggers();
            return true; // can't delete if no prop
        } else if (origProp.bypass) {
            // delete bypassed
            origProp.bypassed = undefined;
            checkTriggers();
            return true;
        } else return false; // we're unsuccessful deleting the bypassed
    }
    // check if we need to delete the current bypass
    if (prop.deleteBypass) {
        // then this property is just here to indicate we need to delete
        if (!origProp) {
            checkTriggers();
            return true; // property is already not defined
        } else if (origProp.bypass) {
            // then replace the bypass property with the original
            // because the bypassed property was already applied (and therefore parsed), we can just replace it (no reapplying necessary)
            style[prop.name] = origProp.bypassed;
            checkTriggers();
            return true;
        } else return false; // we're unsuccessful deleting the bypass
    }
    var printMappingErr = function printMappingErr() {
        $e815fda779bc047b$var$warn('Do not assign mappings to elements without corresponding data (i.e. ele `' + ele.id() + '` has no mapping for property `' + prop.name + '` with data field `' + prop.field + '`); try a `[' + prop.field + ']` selector to limit scope to elements with `' + prop.field + '` defined');
    };
    // put the property in the style objects
    switch(prop.mapped){
        // flatten the property if mapped
        case types.mapData:
            // flatten the field (e.g. data.foo.bar)
            var fields = prop.field.split('.');
            var fieldVal = _p.data;
            for(var i = 0; i < fields.length && fieldVal; i++){
                var field = fields[i];
                fieldVal = fieldVal[field];
            }
            if (fieldVal == null) {
                printMappingErr();
                return false;
            }
            var percent;
            if (!$e815fda779bc047b$var$number$1(fieldVal)) {
                // then don't apply and fall back on the existing style
                $e815fda779bc047b$var$warn('Do not use continuous mappers without specifying numeric data (i.e. `' + prop.field + ': ' + fieldVal + '` for `' + ele.id() + '` is non-numeric)');
                return false;
            } else {
                var fieldWidth = prop.fieldMax - prop.fieldMin;
                if (fieldWidth === 0) // safety check -- not strictly necessary as no props of zero range should be passed here
                percent = 0;
                else percent = (fieldVal - prop.fieldMin) / fieldWidth;
            }
            // make sure to bound percent value
            if (percent < 0) percent = 0;
            else if (percent > 1) percent = 1;
            if (type.color) {
                var r1 = prop.valueMin[0];
                var r2 = prop.valueMax[0];
                var g1 = prop.valueMin[1];
                var g2 = prop.valueMax[1];
                var b1 = prop.valueMin[2];
                var b2 = prop.valueMax[2];
                var a1 = prop.valueMin[3] == null ? 1 : prop.valueMin[3];
                var a2 = prop.valueMax[3] == null ? 1 : prop.valueMax[3];
                var clr = [
                    Math.round(r1 + (r2 - r1) * percent),
                    Math.round(g1 + (g2 - g1) * percent),
                    Math.round(b1 + (b2 - b1) * percent),
                    Math.round(a1 + (a2 - a1) * percent)
                ];
                flatProp = {
                    // colours are simple, so just create the flat property instead of expensive string parsing
                    bypass: prop.bypass,
                    // we're a bypass if the mapping property is a bypass
                    name: prop.name,
                    value: clr,
                    strValue: 'rgb(' + clr[0] + ', ' + clr[1] + ', ' + clr[2] + ')'
                };
            } else if (type.number) {
                var calcValue = prop.valueMin + (prop.valueMax - prop.valueMin) * percent;
                flatProp = this.parse(prop.name, calcValue, prop.bypass, flatPropMapping);
            } else return false; // can only map to colours and numbers
            if (!flatProp) {
                // if we can't flatten the property, then don't apply the property and fall back on the existing style
                printMappingErr();
                return false;
            }
            flatProp.mapping = prop; // keep a reference to the mapping
            prop = flatProp; // the flattened (mapped) property is the one we want
            break;
        // direct mapping
        case types.data:
            // flatten the field (e.g. data.foo.bar)
            var _fields = prop.field.split('.');
            var _fieldVal = _p.data;
            for(var _i3 = 0; _i3 < _fields.length && _fieldVal; _i3++){
                var _field = _fields[_i3];
                _fieldVal = _fieldVal[_field];
            }
            if (_fieldVal != null) flatProp = this.parse(prop.name, _fieldVal, prop.bypass, flatPropMapping);
            if (!flatProp) {
                // if we can't flatten the property, then don't apply and fall back on the existing style
                printMappingErr();
                return false;
            }
            flatProp.mapping = prop; // keep a reference to the mapping
            prop = flatProp; // the flattened (mapped) property is the one we want
            break;
        case types.fn:
            var fn = prop.value;
            var fnRetVal = prop.fnValue != null ? prop.fnValue : fn(ele); // check for cached value before calling function
            prop.prevFnValue = fnRetVal;
            if (fnRetVal == null) {
                $e815fda779bc047b$var$warn('Custom function mappers may not return null (i.e. `' + prop.name + '` for ele `' + ele.id() + '` is null)');
                return false;
            }
            flatProp = this.parse(prop.name, fnRetVal, prop.bypass, flatPropMapping);
            if (!flatProp) {
                $e815fda779bc047b$var$warn('Custom function mappers may not return invalid values for the property type (i.e. `' + prop.name + '` for ele `' + ele.id() + '` is invalid)');
                return false;
            }
            flatProp.mapping = $e815fda779bc047b$var$copy(prop); // keep a reference to the mapping
            prop = flatProp; // the flattened (mapped) property is the one we want
            break;
        case undefined:
            break;
        // just set the property
        default:
            return false;
    }
    // if the property is a bypass property, then link the resultant property to the original one
    if (propIsBypass) {
        if (origPropIsBypass) // then this bypass overrides the existing one
        prop.bypassed = origProp.bypassed; // steal bypassed prop from old bypass
        else // then link the orig prop to the new bypass
        prop.bypassed = origProp;
        style[prop.name] = prop; // and set
    } else // prop is not bypass
    if (origPropIsBypass) // then keep the orig prop (since it's a bypass) and link to the new prop
    origProp.bypassed = prop;
    else // then just replace the old prop with the new one
    style[prop.name] = prop;
    checkTriggers();
    return true;
};
$e815fda779bc047b$var$styfn$8.cleanElements = function(eles, keepBypasses) {
    for(var i = 0; i < eles.length; i++){
        var ele = eles[i];
        this.clearStyleHints(ele);
        ele.dirtyCompoundBoundsCache();
        ele.dirtyBoundingBoxCache();
        if (!keepBypasses) ele._private.style = {};
        else {
            var style = ele._private.style;
            var propNames = Object.keys(style);
            for(var j = 0; j < propNames.length; j++){
                var propName = propNames[j];
                var eleProp = style[propName];
                if (eleProp != null) {
                    if (eleProp.bypass) eleProp.bypassed = null;
                    else style[propName] = null;
                }
            }
        }
    }
};
// updates the visual style for all elements (useful for manual style modification after init)
$e815fda779bc047b$var$styfn$8.update = function() {
    var cy = this._private.cy;
    var eles = cy.mutableElements();
    eles.updateStyle();
};
// diffProps : { name => { prev, next } }
$e815fda779bc047b$var$styfn$8.updateTransitions = function(ele, diffProps) {
    var self1 = this;
    var _p = ele._private;
    var props = ele.pstyle('transition-property').value;
    var duration = ele.pstyle('transition-duration').pfValue;
    var delay = ele.pstyle('transition-delay').pfValue;
    if (props.length > 0 && duration > 0) {
        var style = {};
        // build up the style to animate towards
        var anyPrev = false;
        for(var i = 0; i < props.length; i++){
            var prop = props[i];
            var styProp = ele.pstyle(prop);
            var diffProp = diffProps[prop];
            if (!diffProp) continue;
            var prevProp = diffProp.prev;
            var fromProp = prevProp;
            var toProp = diffProp.next != null ? diffProp.next : styProp;
            var diff = false;
            var initVal = undefined;
            var initDt = 0.000001; // delta time % value for initVal (allows animating out of init zero opacity)
            if (!fromProp) continue;
            // consider px values
            if ($e815fda779bc047b$var$number$1(fromProp.pfValue) && $e815fda779bc047b$var$number$1(toProp.pfValue)) {
                diff = toProp.pfValue - fromProp.pfValue; // nonzero is truthy
                initVal = fromProp.pfValue + initDt * diff;
            // consider numerical values
            } else if ($e815fda779bc047b$var$number$1(fromProp.value) && $e815fda779bc047b$var$number$1(toProp.value)) {
                diff = toProp.value - fromProp.value; // nonzero is truthy
                initVal = fromProp.value + initDt * diff;
            // consider colour values
            } else if ($e815fda779bc047b$var$array(fromProp.value) && $e815fda779bc047b$var$array(toProp.value)) {
                diff = fromProp.value[0] !== toProp.value[0] || fromProp.value[1] !== toProp.value[1] || fromProp.value[2] !== toProp.value[2];
                initVal = fromProp.strValue;
            }
            // the previous value is good for an animation only if it's different
            if (diff) {
                style[prop] = toProp.strValue; // to val
                this.applyBypass(ele, prop, initVal); // from val
                anyPrev = true;
            }
        } // end if props allow ani
        // can't transition if there's nothing previous to transition from
        if (!anyPrev) return;
        _p.transitioning = true;
        new $e815fda779bc047b$var$Promise$1(function(resolve) {
            if (delay > 0) ele.delayAnimation(delay).play().promise().then(resolve);
            else resolve();
        }).then(function() {
            return ele.animation({
                style: style,
                duration: duration,
                easing: ele.pstyle('transition-timing-function').value,
                queue: false
            }).play().promise();
        }).then(function() {
            // if( !isBypass ){
            self1.removeBypasses(ele, props);
            ele.emitAndNotify('style');
            // }
            _p.transitioning = false;
        });
    } else if (_p.transitioning) {
        this.removeBypasses(ele, props);
        ele.emitAndNotify('style');
        _p.transitioning = false;
    }
};
$e815fda779bc047b$var$styfn$8.checkTrigger = function(ele, name, fromValue, toValue, getTrigger, onTrigger) {
    var prop = this.properties[name];
    var triggerCheck = getTrigger(prop);
    if (ele.removed()) return;
    if (triggerCheck != null && triggerCheck(fromValue, toValue, ele)) onTrigger(prop);
};
$e815fda779bc047b$var$styfn$8.checkZOrderTrigger = function(ele, name, fromValue, toValue) {
    var _this = this;
    this.checkTrigger(ele, name, fromValue, toValue, function(prop) {
        return prop.triggersZOrder;
    }, function() {
        _this._private.cy.notify('zorder', ele);
    });
};
$e815fda779bc047b$var$styfn$8.checkBoundsTrigger = function(ele, name, fromValue, toValue) {
    this.checkTrigger(ele, name, fromValue, toValue, function(prop) {
        return prop.triggersBounds;
    }, function(prop) {
        ele.dirtyCompoundBoundsCache();
        ele.dirtyBoundingBoxCache();
    });
};
$e815fda779bc047b$var$styfn$8.checkConnectedEdgesBoundsTrigger = function(ele, name, fromValue, toValue) {
    this.checkTrigger(ele, name, fromValue, toValue, function(prop) {
        return prop.triggersBoundsOfConnectedEdges;
    }, function(prop) {
        ele.connectedEdges().forEach(function(edge) {
            edge.dirtyBoundingBoxCache();
        });
    });
};
$e815fda779bc047b$var$styfn$8.checkParallelEdgesBoundsTrigger = function(ele, name, fromValue, toValue) {
    this.checkTrigger(ele, name, fromValue, toValue, function(prop) {
        return prop.triggersBoundsOfParallelEdges;
    }, function(prop) {
        ele.parallelEdges().forEach(function(pllEdge) {
            pllEdge.dirtyBoundingBoxCache();
        });
    });
};
$e815fda779bc047b$var$styfn$8.checkTriggers = function(ele, name, fromValue, toValue) {
    ele.dirtyStyleCache();
    this.checkZOrderTrigger(ele, name, fromValue, toValue);
    this.checkBoundsTrigger(ele, name, fromValue, toValue);
    this.checkConnectedEdgesBoundsTrigger(ele, name, fromValue, toValue);
    this.checkParallelEdgesBoundsTrigger(ele, name, fromValue, toValue);
};
var $e815fda779bc047b$var$styfn$7 = {};
// bypasses are applied to an existing style on an element, and just tacked on temporarily
// returns true iff application was successful for at least 1 specified property
$e815fda779bc047b$var$styfn$7.applyBypass = function(eles, name, value, updateTransitions) {
    var self1 = this;
    var props = [];
    var isBypass = true;
    // put all the properties (can specify one or many) in an array after parsing them
    if (name === '*' || name === '**') {
        // apply to all property names
        if (value !== undefined) for(var i = 0; i < self1.properties.length; i++){
            var prop = self1.properties[i];
            var _name = prop.name;
            var parsedProp = this.parse(_name, value, true);
            if (parsedProp) props.push(parsedProp);
        }
    } else if ($e815fda779bc047b$var$string(name)) {
        // then parse the single property
        var _parsedProp = this.parse(name, value, true);
        if (_parsedProp) props.push(_parsedProp);
    } else if ($e815fda779bc047b$var$plainObject(name)) {
        // then parse each property
        var specifiedProps = name;
        updateTransitions = value;
        var names = Object.keys(specifiedProps);
        for(var _i = 0; _i < names.length; _i++){
            var _name2 = names[_i];
            var _value = specifiedProps[_name2];
            if (_value === undefined) // try camel case name too
            _value = specifiedProps[$e815fda779bc047b$var$dash2camel(_name2)];
            if (_value !== undefined) {
                var _parsedProp2 = this.parse(_name2, _value, true);
                if (_parsedProp2) props.push(_parsedProp2);
            }
        }
    } else // can't do anything without well defined properties
    return false;
    // we've failed if there are no valid properties
    if (props.length === 0) return false;
    // now, apply the bypass properties on the elements
    var ret = false; // return true if at least one succesful bypass applied
    for(var _i2 = 0; _i2 < eles.length; _i2++){
        // for each ele
        var ele = eles[_i2];
        var diffProps = {};
        var diffProp = undefined;
        for(var j = 0; j < props.length; j++){
            // for each prop
            var _prop = props[j];
            if (updateTransitions) {
                var prevProp = ele.pstyle(_prop.name);
                diffProp = diffProps[_prop.name] = {
                    prev: prevProp
                };
            }
            ret = this.applyParsedProperty(ele, $e815fda779bc047b$var$copy(_prop)) || ret;
            if (updateTransitions) diffProp.next = ele.pstyle(_prop.name);
        } // for props
        if (ret) this.updateStyleHints(ele);
        if (updateTransitions) this.updateTransitions(ele, diffProps, isBypass);
    } // for eles
    return ret;
};
// only useful in specific cases like animation
$e815fda779bc047b$var$styfn$7.overrideBypass = function(eles, name, value) {
    name = $e815fda779bc047b$var$camel2dash(name);
    for(var i = 0; i < eles.length; i++){
        var ele = eles[i];
        var prop = ele._private.style[name];
        var type = this.properties[name].type;
        var isColor = type.color;
        var isMulti = type.mutiple;
        var oldValue = !prop ? null : prop.pfValue != null ? prop.pfValue : prop.value;
        if (!prop || !prop.bypass) // need a bypass if one doesn't exist
        this.applyBypass(ele, name, value);
        else {
            prop.value = value;
            if (prop.pfValue != null) prop.pfValue = value;
            if (isColor) prop.strValue = 'rgb(' + value.join(',') + ')';
            else if (isMulti) prop.strValue = value.join(' ');
            else prop.strValue = '' + value;
            this.updateStyleHints(ele);
        }
        this.checkTriggers(ele, name, oldValue, value);
    }
};
$e815fda779bc047b$var$styfn$7.removeAllBypasses = function(eles, updateTransitions) {
    return this.removeBypasses(eles, this.propertyNames, updateTransitions);
};
$e815fda779bc047b$var$styfn$7.removeBypasses = function(eles, props, updateTransitions) {
    var isBypass = true;
    for(var j = 0; j < eles.length; j++){
        var ele = eles[j];
        var diffProps = {};
        for(var i = 0; i < props.length; i++){
            var name = props[i];
            var prop = this.properties[name];
            var prevProp = ele.pstyle(prop.name);
            if (!prevProp || !prevProp.bypass) continue;
            var value = ''; // empty => remove bypass
            var parsedProp = this.parse(name, value, true);
            var diffProp = diffProps[prop.name] = {
                prev: prevProp
            };
            this.applyParsedProperty(ele, parsedProp);
            diffProp.next = ele.pstyle(prop.name);
        } // for props
        this.updateStyleHints(ele);
        if (updateTransitions) this.updateTransitions(ele, diffProps, isBypass);
    } // for eles
};
var $e815fda779bc047b$var$styfn$6 = {};
// gets what an em size corresponds to in pixels relative to a dom element
$e815fda779bc047b$var$styfn$6.getEmSizeInPixels = function() {
    var px = this.containerCss('font-size');
    if (px != null) return parseFloat(px);
    else return 1; // for headless
};
// gets css property from the core container
$e815fda779bc047b$var$styfn$6.containerCss = function(propName) {
    var cy = this._private.cy;
    var domElement = cy.container();
    var containerWindow = cy.window();
    if (containerWindow && domElement && containerWindow.getComputedStyle) return containerWindow.getComputedStyle(domElement).getPropertyValue(propName);
};
var $e815fda779bc047b$var$styfn$5 = {};
// gets the rendered style for an element
$e815fda779bc047b$var$styfn$5.getRenderedStyle = function(ele, prop) {
    if (prop) return this.getStylePropertyValue(ele, prop, true);
    else return this.getRawStyle(ele, true);
};
// gets the raw style for an element
$e815fda779bc047b$var$styfn$5.getRawStyle = function(ele, isRenderedVal) {
    var self1 = this;
    ele = ele[0]; // insure it's an element
    if (ele) {
        var rstyle = {};
        for(var i = 0; i < self1.properties.length; i++){
            var prop = self1.properties[i];
            var val = self1.getStylePropertyValue(ele, prop.name, isRenderedVal);
            if (val != null) {
                rstyle[prop.name] = val;
                rstyle[$e815fda779bc047b$var$dash2camel(prop.name)] = val;
            }
        }
        return rstyle;
    }
};
$e815fda779bc047b$var$styfn$5.getIndexedStyle = function(ele, property, subproperty, index) {
    var pstyle = ele.pstyle(property)[subproperty][index];
    return pstyle != null ? pstyle : ele.cy().style().getDefaultProperty(property)[subproperty][0];
};
$e815fda779bc047b$var$styfn$5.getStylePropertyValue = function(ele, propName, isRenderedVal) {
    var self1 = this;
    ele = ele[0]; // insure it's an element
    if (ele) {
        var prop = self1.properties[propName];
        if (prop.alias) prop = prop.pointsTo;
        var type = prop.type;
        var styleProp = ele.pstyle(prop.name);
        if (styleProp) {
            var value = styleProp.value, units = styleProp.units, strValue = styleProp.strValue;
            if (isRenderedVal && type.number && value != null && $e815fda779bc047b$var$number$1(value)) {
                var zoom = ele.cy().zoom();
                var getRenderedValue = function getRenderedValue(val) {
                    return val * zoom;
                };
                var getValueStringWithUnits = function getValueStringWithUnits(val, units) {
                    return getRenderedValue(val) + units;
                };
                var isArrayValue = $e815fda779bc047b$var$array(value);
                var haveUnits = isArrayValue ? units.every(function(u) {
                    return u != null;
                }) : units != null;
                if (haveUnits) {
                    if (isArrayValue) return value.map(function(v, i) {
                        return getValueStringWithUnits(v, units[i]);
                    }).join(' ');
                    else return getValueStringWithUnits(value, units);
                } else {
                    if (isArrayValue) return value.map(function(v) {
                        return $e815fda779bc047b$var$string(v) ? v : '' + getRenderedValue(v);
                    }).join(' ');
                    else return '' + getRenderedValue(value);
                }
            } else if (strValue != null) return strValue;
        }
        return null;
    }
};
$e815fda779bc047b$var$styfn$5.getAnimationStartStyle = function(ele, aniProps) {
    var rstyle = {};
    for(var i = 0; i < aniProps.length; i++){
        var aniProp = aniProps[i];
        var name = aniProp.name;
        var styleProp = ele.pstyle(name);
        if (styleProp !== undefined) {
            // then make a prop of it
            if ($e815fda779bc047b$var$plainObject(styleProp)) styleProp = this.parse(name, styleProp.strValue);
            else styleProp = this.parse(name, styleProp);
        }
        if (styleProp) rstyle[name] = styleProp;
    }
    return rstyle;
};
$e815fda779bc047b$var$styfn$5.getPropsList = function(propsObj) {
    var self1 = this;
    var rstyle = [];
    var style = propsObj;
    var props = self1.properties;
    if (style) {
        var names = Object.keys(style);
        for(var i = 0; i < names.length; i++){
            var name = names[i];
            var val = style[name];
            var prop = props[name] || props[$e815fda779bc047b$var$camel2dash(name)];
            var styleProp = this.parse(prop.name, val);
            if (styleProp) rstyle.push(styleProp);
        }
    }
    return rstyle;
};
$e815fda779bc047b$var$styfn$5.getNonDefaultPropertiesHash = function(ele, propNames, seed) {
    var hash = seed.slice();
    var name, val, strVal, chVal;
    var i, j;
    for(i = 0; i < propNames.length; i++){
        name = propNames[i];
        val = ele.pstyle(name, false);
        if (val == null) continue;
        else if (val.pfValue != null) {
            hash[0] = $e815fda779bc047b$var$hashInt(chVal, hash[0]);
            hash[1] = $e815fda779bc047b$var$hashIntAlt(chVal, hash[1]);
        } else {
            strVal = val.strValue;
            for(j = 0; j < strVal.length; j++){
                chVal = strVal.charCodeAt(j);
                hash[0] = $e815fda779bc047b$var$hashInt(chVal, hash[0]);
                hash[1] = $e815fda779bc047b$var$hashIntAlt(chVal, hash[1]);
            }
        }
    }
    return hash;
};
$e815fda779bc047b$var$styfn$5.getPropertiesHash = $e815fda779bc047b$var$styfn$5.getNonDefaultPropertiesHash;
var $e815fda779bc047b$var$styfn$4 = {};
$e815fda779bc047b$var$styfn$4.appendFromJson = function(json) {
    var style = this;
    for(var i = 0; i < json.length; i++){
        var context = json[i];
        var selector = context.selector;
        var props = context.style || context.css;
        var names = Object.keys(props);
        style.selector(selector); // apply selector
        for(var j = 0; j < names.length; j++){
            var name = names[j];
            var value = props[name];
            style.css(name, value); // apply property
        }
    }
    return style;
};
// accessible cy.style() function
$e815fda779bc047b$var$styfn$4.fromJson = function(json) {
    var style = this;
    style.resetToDefault();
    style.appendFromJson(json);
    return style;
};
// get json from cy.style() api
$e815fda779bc047b$var$styfn$4.json = function() {
    var json = [];
    for(var i = this.defaultLength; i < this.length; i++){
        var cxt = this[i];
        var selector = cxt.selector;
        var props = cxt.properties;
        var css = {};
        for(var j = 0; j < props.length; j++){
            var prop = props[j];
            css[prop.name] = prop.strValue;
        }
        json.push({
            selector: !selector ? 'core' : selector.toString(),
            style: css
        });
    }
    return json;
};
var $e815fda779bc047b$var$styfn$3 = {};
$e815fda779bc047b$var$styfn$3.appendFromString = function(string) {
    var self1 = this;
    var style = this;
    var remaining = '' + string;
    var selAndBlockStr;
    var blockRem;
    var propAndValStr;
    // remove comments from the style string
    remaining = remaining.replace(/[/][*](\s|.)+?[*][/]/g, '');
    function removeSelAndBlockFromRemaining() {
        // remove the parsed selector and block from the remaining text to parse
        if (remaining.length > selAndBlockStr.length) remaining = remaining.substr(selAndBlockStr.length);
        else remaining = '';
    }
    function removePropAndValFromRem() {
        // remove the parsed property and value from the remaining block text to parse
        if (blockRem.length > propAndValStr.length) blockRem = blockRem.substr(propAndValStr.length);
        else blockRem = '';
    }
    for(;;){
        var nothingLeftToParse = remaining.match(/^\s*$/);
        if (nothingLeftToParse) break;
        var selAndBlock = remaining.match(/^\s*((?:.|\s)+?)\s*\{((?:.|\s)+?)\}/);
        if (!selAndBlock) {
            $e815fda779bc047b$var$warn('Halting stylesheet parsing: String stylesheet contains more to parse but no selector and block found in: ' + remaining);
            break;
        }
        selAndBlockStr = selAndBlock[0];
        // parse the selector
        var selectorStr = selAndBlock[1];
        if (selectorStr !== 'core') {
            var selector = new $e815fda779bc047b$var$Selector(selectorStr);
            if (selector.invalid) {
                $e815fda779bc047b$var$warn('Skipping parsing of block: Invalid selector found in string stylesheet: ' + selectorStr);
                // skip this selector and block
                removeSelAndBlockFromRemaining();
                continue;
            }
        }
        // parse the block of properties and values
        var blockStr = selAndBlock[2];
        var invalidBlock = false;
        blockRem = blockStr;
        var props = [];
        for(;;){
            var _nothingLeftToParse = blockRem.match(/^\s*$/);
            if (_nothingLeftToParse) break;
            var propAndVal = blockRem.match(/^\s*(.+?)\s*:\s*(.+?)(?:\s*;|\s*$)/);
            if (!propAndVal) {
                $e815fda779bc047b$var$warn('Skipping parsing of block: Invalid formatting of style property and value definitions found in:' + blockStr);
                invalidBlock = true;
                break;
            }
            propAndValStr = propAndVal[0];
            var propStr = propAndVal[1];
            var valStr = propAndVal[2];
            var prop = self1.properties[propStr];
            if (!prop) {
                $e815fda779bc047b$var$warn('Skipping property: Invalid property name in: ' + propAndValStr);
                // skip this property in the block
                removePropAndValFromRem();
                continue;
            }
            var parsedProp = style.parse(propStr, valStr);
            if (!parsedProp) {
                $e815fda779bc047b$var$warn('Skipping property: Invalid property definition in: ' + propAndValStr);
                // skip this property in the block
                removePropAndValFromRem();
                continue;
            }
            props.push({
                name: propStr,
                val: valStr
            });
            removePropAndValFromRem();
        }
        if (invalidBlock) {
            removeSelAndBlockFromRemaining();
            break;
        }
        // put the parsed block in the style
        style.selector(selectorStr);
        for(var i = 0; i < props.length; i++){
            var _prop = props[i];
            style.css(_prop.name, _prop.val);
        }
        removeSelAndBlockFromRemaining();
    }
    return style;
};
$e815fda779bc047b$var$styfn$3.fromString = function(string) {
    var style = this;
    style.resetToDefault();
    style.appendFromString(string);
    return style;
};
var $e815fda779bc047b$var$styfn$2 = {};
(function() {
    var number$1 = $e815fda779bc047b$var$number;
    var rgba = $e815fda779bc047b$var$rgbaNoBackRefs;
    var hsla = $e815fda779bc047b$var$hslaNoBackRefs;
    var hex3$1 = $e815fda779bc047b$var$hex3;
    var hex6$1 = $e815fda779bc047b$var$hex6;
    var data = function data(prefix) {
        return '^' + prefix + '\\s*\\(\\s*([\\w\\.]+)\\s*\\)$';
    };
    var mapData = function mapData(prefix) {
        var mapArg = number$1 + '|\\w+|' + rgba + '|' + hsla + '|' + hex3$1 + '|' + hex6$1;
        return '^' + prefix + '\\s*\\(([\\w\\.]+)\\s*\\,\\s*(' + number$1 + ')\\s*\\,\\s*(' + number$1 + ')\\s*,\\s*(' + mapArg + ')\\s*\\,\\s*(' + mapArg + ')\\)$';
    };
    var urlRegexes = [
        '^url\\s*\\(\\s*[\'"]?(.+?)[\'"]?\\s*\\)$',
        '^(none)$',
        '^(.+)$'
    ];
    // each visual style property has a type and needs to be validated according to it
    $e815fda779bc047b$var$styfn$2.types = {
        time: {
            number: true,
            min: 0,
            units: 's|ms',
            implicitUnits: 'ms'
        },
        percent: {
            number: true,
            min: 0,
            max: 100,
            units: '%',
            implicitUnits: '%'
        },
        percentages: {
            number: true,
            min: 0,
            max: 100,
            units: '%',
            implicitUnits: '%',
            multiple: true
        },
        zeroOneNumber: {
            number: true,
            min: 0,
            max: 1,
            unitless: true
        },
        zeroOneNumbers: {
            number: true,
            min: 0,
            max: 1,
            unitless: true,
            multiple: true
        },
        nOneOneNumber: {
            number: true,
            min: -1,
            max: 1,
            unitless: true
        },
        nonNegativeInt: {
            number: true,
            min: 0,
            integer: true,
            unitless: true
        },
        nonNegativeNumber: {
            number: true,
            min: 0,
            unitless: true
        },
        position: {
            enums: [
                'parent',
                'origin'
            ]
        },
        nodeSize: {
            number: true,
            min: 0,
            enums: [
                'label'
            ]
        },
        number: {
            number: true,
            unitless: true
        },
        numbers: {
            number: true,
            unitless: true,
            multiple: true
        },
        positiveNumber: {
            number: true,
            unitless: true,
            min: 0,
            strictMin: true
        },
        size: {
            number: true,
            min: 0
        },
        bidirectionalSize: {
            number: true
        },
        // allows negative
        bidirectionalSizeMaybePercent: {
            number: true,
            allowPercent: true
        },
        // allows negative
        bidirectionalSizes: {
            number: true,
            multiple: true
        },
        // allows negative
        sizeMaybePercent: {
            number: true,
            min: 0,
            allowPercent: true
        },
        axisDirection: {
            enums: [
                'horizontal',
                'leftward',
                'rightward',
                'vertical',
                'upward',
                'downward',
                'auto'
            ]
        },
        axisDirectionExplicit: {
            enums: [
                'leftward',
                'rightward',
                'upward',
                'downward'
            ]
        },
        axisDirectionPrimary: {
            enums: [
                'horizontal',
                'vertical'
            ]
        },
        paddingRelativeTo: {
            enums: [
                'width',
                'height',
                'average',
                'min',
                'max'
            ]
        },
        bgWH: {
            number: true,
            min: 0,
            allowPercent: true,
            enums: [
                'auto'
            ],
            multiple: true
        },
        bgPos: {
            number: true,
            allowPercent: true,
            multiple: true
        },
        bgRelativeTo: {
            enums: [
                'inner',
                'include-padding'
            ],
            multiple: true
        },
        bgRepeat: {
            enums: [
                'repeat',
                'repeat-x',
                'repeat-y',
                'no-repeat'
            ],
            multiple: true
        },
        bgFit: {
            enums: [
                'none',
                'contain',
                'cover'
            ],
            multiple: true
        },
        bgCrossOrigin: {
            enums: [
                'anonymous',
                'use-credentials',
                'null'
            ],
            multiple: true
        },
        bgClip: {
            enums: [
                'none',
                'node'
            ],
            multiple: true
        },
        bgContainment: {
            enums: [
                'inside',
                'over'
            ],
            multiple: true
        },
        boxSelection: {
            enums: [
                'contain',
                'overlap',
                'none'
            ]
        },
        color: {
            color: true
        },
        colors: {
            color: true,
            multiple: true
        },
        fill: {
            enums: [
                'solid',
                'linear-gradient',
                'radial-gradient'
            ]
        },
        bool: {
            enums: [
                'yes',
                'no'
            ]
        },
        bools: {
            enums: [
                'yes',
                'no'
            ],
            multiple: true
        },
        lineStyle: {
            enums: [
                'solid',
                'dotted',
                'dashed'
            ]
        },
        lineCap: {
            enums: [
                'butt',
                'round',
                'square'
            ]
        },
        linePosition: {
            enums: [
                'center',
                'inside',
                'outside'
            ]
        },
        lineJoin: {
            enums: [
                'round',
                'bevel',
                'miter'
            ]
        },
        borderStyle: {
            enums: [
                'solid',
                'dotted',
                'dashed',
                'double'
            ]
        },
        curveStyle: {
            enums: [
                'bezier',
                'unbundled-bezier',
                'haystack',
                'segments',
                'straight',
                'straight-triangle',
                'taxi',
                'round-segments',
                'round-taxi'
            ]
        },
        radiusType: {
            enums: [
                'arc-radius',
                'influence-radius'
            ],
            multiple: true
        },
        fontFamily: {
            regex: '^([\\w- \\"]+(?:\\s*,\\s*[\\w- \\"]+)*)$'
        },
        fontStyle: {
            enums: [
                'italic',
                'normal',
                'oblique'
            ]
        },
        fontWeight: {
            enums: [
                'normal',
                'bold',
                'bolder',
                'lighter',
                '100',
                '200',
                '300',
                '400',
                '500',
                '600',
                '800',
                '900',
                100,
                200,
                300,
                400,
                500,
                600,
                700,
                800,
                900
            ]
        },
        textDecoration: {
            enums: [
                'none',
                'underline',
                'overline',
                'line-through'
            ]
        },
        textTransform: {
            enums: [
                'none',
                'uppercase',
                'lowercase'
            ]
        },
        textWrap: {
            enums: [
                'none',
                'wrap',
                'ellipsis'
            ]
        },
        textOverflowWrap: {
            enums: [
                'whitespace',
                'anywhere'
            ]
        },
        textBackgroundShape: {
            enums: [
                'rectangle',
                'roundrectangle',
                'round-rectangle',
                'circle'
            ]
        },
        nodeShape: {
            enums: [
                'rectangle',
                'roundrectangle',
                'round-rectangle',
                'cutrectangle',
                'cut-rectangle',
                'bottomroundrectangle',
                'bottom-round-rectangle',
                'barrel',
                'ellipse',
                'triangle',
                'round-triangle',
                'square',
                'pentagon',
                'round-pentagon',
                'hexagon',
                'round-hexagon',
                'concavehexagon',
                'concave-hexagon',
                'heptagon',
                'round-heptagon',
                'octagon',
                'round-octagon',
                'tag',
                'round-tag',
                'star',
                'diamond',
                'round-diamond',
                'vee',
                'rhomboid',
                'right-rhomboid',
                'polygon'
            ]
        },
        overlayShape: {
            enums: [
                'roundrectangle',
                'round-rectangle',
                'ellipse'
            ]
        },
        cornerRadius: {
            number: true,
            min: 0,
            units: 'px|em',
            implicitUnits: 'px',
            enums: [
                'auto'
            ]
        },
        compoundIncludeLabels: {
            enums: [
                'include',
                'exclude'
            ]
        },
        arrowShape: {
            enums: [
                'tee',
                'triangle',
                'triangle-tee',
                'circle-triangle',
                'triangle-cross',
                'triangle-backcurve',
                'vee',
                'square',
                'circle',
                'diamond',
                'chevron',
                'none'
            ]
        },
        arrowFill: {
            enums: [
                'filled',
                'hollow'
            ]
        },
        arrowWidth: {
            number: true,
            units: '%|px|em',
            implicitUnits: 'px',
            enums: [
                'match-line'
            ]
        },
        display: {
            enums: [
                'element',
                'none'
            ]
        },
        visibility: {
            enums: [
                'hidden',
                'visible'
            ]
        },
        zCompoundDepth: {
            enums: [
                'bottom',
                'orphan',
                'auto',
                'top'
            ]
        },
        zIndexCompare: {
            enums: [
                'auto',
                'manual'
            ]
        },
        valign: {
            enums: [
                'top',
                'center',
                'bottom'
            ]
        },
        halign: {
            enums: [
                'left',
                'center',
                'right'
            ]
        },
        justification: {
            enums: [
                'left',
                'center',
                'right',
                'auto'
            ]
        },
        text: {
            string: true
        },
        data: {
            mapping: true,
            regex: data('data')
        },
        layoutData: {
            mapping: true,
            regex: data('layoutData')
        },
        scratch: {
            mapping: true,
            regex: data('scratch')
        },
        mapData: {
            mapping: true,
            regex: mapData('mapData')
        },
        mapLayoutData: {
            mapping: true,
            regex: mapData('mapLayoutData')
        },
        mapScratch: {
            mapping: true,
            regex: mapData('mapScratch')
        },
        fn: {
            mapping: true,
            fn: true
        },
        url: {
            regexes: urlRegexes,
            singleRegexMatchValue: true
        },
        urls: {
            regexes: urlRegexes,
            singleRegexMatchValue: true,
            multiple: true
        },
        propList: {
            propList: true
        },
        angle: {
            number: true,
            units: 'deg|rad',
            implicitUnits: 'rad'
        },
        textRotation: {
            number: true,
            units: 'deg|rad',
            implicitUnits: 'rad',
            enums: [
                'none',
                'autorotate'
            ]
        },
        polygonPointList: {
            number: true,
            multiple: true,
            evenMultiple: true,
            min: -1,
            max: 1,
            unitless: true
        },
        edgeDistances: {
            enums: [
                'intersection',
                'node-position',
                'endpoints'
            ]
        },
        edgeEndpoint: {
            number: true,
            multiple: true,
            units: '%|px|em|deg|rad',
            implicitUnits: 'px',
            enums: [
                'inside-to-node',
                'outside-to-node',
                'outside-to-node-or-label',
                'outside-to-line',
                'outside-to-line-or-label'
            ],
            singleEnum: true,
            validate: function validate(valArr, unitsArr) {
                switch(valArr.length){
                    case 2:
                        // can be % or px only
                        return unitsArr[0] !== 'deg' && unitsArr[0] !== 'rad' && unitsArr[1] !== 'deg' && unitsArr[1] !== 'rad';
                    case 1:
                        // can be enum, deg, or rad only
                        return $e815fda779bc047b$var$string(valArr[0]) || unitsArr[0] === 'deg' || unitsArr[0] === 'rad';
                    default:
                        return false;
                }
            }
        },
        easing: {
            regexes: [
                '^(spring)\\s*\\(\\s*(' + number$1 + ')\\s*,\\s*(' + number$1 + ')\\s*\\)$',
                '^(cubic-bezier)\\s*\\(\\s*(' + number$1 + ')\\s*,\\s*(' + number$1 + ')\\s*,\\s*(' + number$1 + ')\\s*,\\s*(' + number$1 + ')\\s*\\)$'
            ],
            enums: [
                'linear',
                'ease',
                'ease-in',
                'ease-out',
                'ease-in-out',
                'ease-in-sine',
                'ease-out-sine',
                'ease-in-out-sine',
                'ease-in-quad',
                'ease-out-quad',
                'ease-in-out-quad',
                'ease-in-cubic',
                'ease-out-cubic',
                'ease-in-out-cubic',
                'ease-in-quart',
                'ease-out-quart',
                'ease-in-out-quart',
                'ease-in-quint',
                'ease-out-quint',
                'ease-in-out-quint',
                'ease-in-expo',
                'ease-out-expo',
                'ease-in-out-expo',
                'ease-in-circ',
                'ease-out-circ',
                'ease-in-out-circ'
            ]
        },
        gradientDirection: {
            enums: [
                'to-bottom',
                'to-top',
                'to-left',
                'to-right',
                'to-bottom-right',
                'to-bottom-left',
                'to-top-right',
                'to-top-left',
                'to-right-bottom',
                'to-left-bottom',
                'to-right-top',
                'to-left-top' // different order
            ]
        },
        boundsExpansion: {
            number: true,
            multiple: true,
            min: 0,
            validate: function validate(valArr) {
                var length = valArr.length;
                return length === 1 || length === 2 || length === 4;
            }
        }
    };
    var diff = {
        zeroNonZero: function zeroNonZero(val1, val2) {
            if ((val1 == null || val2 == null) && val1 !== val2) return true; // null cases could represent any value
            if (val1 == 0 && val2 != 0) return true;
            else if (val1 != 0 && val2 == 0) return true;
            else return false;
        },
        any: function any(val1, val2) {
            return val1 != val2;
        },
        emptyNonEmpty: function emptyNonEmpty(str1, str2) {
            var empty1 = $e815fda779bc047b$var$emptyString(str1);
            var empty2 = $e815fda779bc047b$var$emptyString(str2);
            return empty1 && !empty2 || !empty1 && empty2;
        }
    };
    // define visual style properties
    //
    // - n.b. adding a new group of props may require updates to updateStyleHints()
    // - adding new props to an existing group gets handled automatically
    var t = $e815fda779bc047b$var$styfn$2.types;
    var mainLabel = [
        {
            name: 'label',
            type: t.text,
            triggersBounds: diff.any,
            triggersZOrder: diff.emptyNonEmpty
        },
        {
            name: 'text-rotation',
            type: t.textRotation,
            triggersBounds: diff.any
        },
        {
            name: 'text-margin-x',
            type: t.bidirectionalSize,
            triggersBounds: diff.any
        },
        {
            name: 'text-margin-y',
            type: t.bidirectionalSize,
            triggersBounds: diff.any
        }
    ];
    var sourceLabel = [
        {
            name: 'source-label',
            type: t.text,
            triggersBounds: diff.any
        },
        {
            name: 'source-text-rotation',
            type: t.textRotation,
            triggersBounds: diff.any
        },
        {
            name: 'source-text-margin-x',
            type: t.bidirectionalSize,
            triggersBounds: diff.any
        },
        {
            name: 'source-text-margin-y',
            type: t.bidirectionalSize,
            triggersBounds: diff.any
        },
        {
            name: 'source-text-offset',
            type: t.size,
            triggersBounds: diff.any
        }
    ];
    var targetLabel = [
        {
            name: 'target-label',
            type: t.text,
            triggersBounds: diff.any
        },
        {
            name: 'target-text-rotation',
            type: t.textRotation,
            triggersBounds: diff.any
        },
        {
            name: 'target-text-margin-x',
            type: t.bidirectionalSize,
            triggersBounds: diff.any
        },
        {
            name: 'target-text-margin-y',
            type: t.bidirectionalSize,
            triggersBounds: diff.any
        },
        {
            name: 'target-text-offset',
            type: t.size,
            triggersBounds: diff.any
        }
    ];
    var labelDimensions = [
        {
            name: 'font-family',
            type: t.fontFamily,
            triggersBounds: diff.any
        },
        {
            name: 'font-style',
            type: t.fontStyle,
            triggersBounds: diff.any
        },
        {
            name: 'font-weight',
            type: t.fontWeight,
            triggersBounds: diff.any
        },
        {
            name: 'font-size',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'text-transform',
            type: t.textTransform,
            triggersBounds: diff.any
        },
        {
            name: 'text-wrap',
            type: t.textWrap,
            triggersBounds: diff.any
        },
        {
            name: 'text-overflow-wrap',
            type: t.textOverflowWrap,
            triggersBounds: diff.any
        },
        {
            name: 'text-max-width',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'text-outline-width',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'line-height',
            type: t.positiveNumber,
            triggersBounds: diff.any
        }
    ];
    var commonLabel = [
        {
            name: 'text-valign',
            type: t.valign,
            triggersBounds: diff.any
        },
        {
            name: 'text-halign',
            type: t.halign,
            triggersBounds: diff.any
        },
        {
            name: 'color',
            type: t.color
        },
        {
            name: 'text-outline-color',
            type: t.color
        },
        {
            name: 'text-outline-opacity',
            type: t.zeroOneNumber
        },
        {
            name: 'text-background-color',
            type: t.color
        },
        {
            name: 'text-background-opacity',
            type: t.zeroOneNumber
        },
        {
            name: 'text-background-padding',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'text-border-opacity',
            type: t.zeroOneNumber
        },
        {
            name: 'text-border-color',
            type: t.color
        },
        {
            name: 'text-border-width',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'text-border-style',
            type: t.borderStyle,
            triggersBounds: diff.any
        },
        {
            name: 'text-background-shape',
            type: t.textBackgroundShape,
            triggersBounds: diff.any
        },
        {
            name: 'text-justification',
            type: t.justification
        },
        {
            name: 'box-select-labels',
            type: t.bool,
            triggersBounds: diff.any
        }
    ];
    var behavior = [
        {
            name: 'events',
            type: t.bool,
            triggersZOrder: diff.any
        },
        {
            name: 'text-events',
            type: t.bool,
            triggersZOrder: diff.any
        },
        {
            name: 'box-selection',
            type: t.boxSelection,
            triggersZOrder: diff.any
        }
    ];
    var visibility = [
        {
            name: 'display',
            type: t.display,
            triggersZOrder: diff.any,
            triggersBounds: diff.any,
            triggersBoundsOfConnectedEdges: diff.any,
            triggersBoundsOfParallelEdges: function triggersBoundsOfParallelEdges(fromValue, toValue, ele) {
                if (fromValue === toValue) return false;
                // only if edge is bundled bezier (so as not to affect performance of other edges)
                return ele.pstyle('curve-style').value === 'bezier';
            }
        },
        {
            name: 'visibility',
            type: t.visibility,
            triggersZOrder: diff.any
        },
        {
            name: 'opacity',
            type: t.zeroOneNumber,
            triggersZOrder: diff.zeroNonZero
        },
        {
            name: 'text-opacity',
            type: t.zeroOneNumber
        },
        {
            name: 'min-zoomed-font-size',
            type: t.size
        },
        {
            name: 'z-compound-depth',
            type: t.zCompoundDepth,
            triggersZOrder: diff.any
        },
        {
            name: 'z-index-compare',
            type: t.zIndexCompare,
            triggersZOrder: diff.any
        },
        {
            name: 'z-index',
            type: t.number,
            triggersZOrder: diff.any
        }
    ];
    var overlay = [
        {
            name: 'overlay-padding',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'overlay-color',
            type: t.color
        },
        {
            name: 'overlay-opacity',
            type: t.zeroOneNumber,
            triggersBounds: diff.zeroNonZero
        },
        {
            name: 'overlay-shape',
            type: t.overlayShape,
            triggersBounds: diff.any
        },
        {
            name: 'overlay-corner-radius',
            type: t.cornerRadius
        }
    ];
    var underlay = [
        {
            name: 'underlay-padding',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'underlay-color',
            type: t.color
        },
        {
            name: 'underlay-opacity',
            type: t.zeroOneNumber,
            triggersBounds: diff.zeroNonZero
        },
        {
            name: 'underlay-shape',
            type: t.overlayShape,
            triggersBounds: diff.any
        },
        {
            name: 'underlay-corner-radius',
            type: t.cornerRadius
        }
    ];
    var transition = [
        {
            name: 'transition-property',
            type: t.propList
        },
        {
            name: 'transition-duration',
            type: t.time
        },
        {
            name: 'transition-delay',
            type: t.time
        },
        {
            name: 'transition-timing-function',
            type: t.easing
        }
    ];
    var nodeSizeHashOverride = function nodeSizeHashOverride(ele, parsedProp) {
        if (parsedProp.value === 'label') return -ele.poolIndex(); // no hash key hits is using label size (hitrate for perf probably low anyway)
        else return parsedProp.pfValue;
    };
    var nodeBody = [
        {
            name: 'height',
            type: t.nodeSize,
            triggersBounds: diff.any,
            hashOverride: nodeSizeHashOverride
        },
        {
            name: 'width',
            type: t.nodeSize,
            triggersBounds: diff.any,
            hashOverride: nodeSizeHashOverride
        },
        {
            name: 'shape',
            type: t.nodeShape,
            triggersBounds: diff.any
        },
        {
            name: 'shape-polygon-points',
            type: t.polygonPointList,
            triggersBounds: diff.any
        },
        {
            name: 'corner-radius',
            type: t.cornerRadius
        },
        {
            name: 'background-color',
            type: t.color
        },
        {
            name: 'background-fill',
            type: t.fill
        },
        {
            name: 'background-opacity',
            type: t.zeroOneNumber
        },
        {
            name: 'background-blacken',
            type: t.nOneOneNumber
        },
        {
            name: 'background-gradient-stop-colors',
            type: t.colors
        },
        {
            name: 'background-gradient-stop-positions',
            type: t.percentages
        },
        {
            name: 'background-gradient-direction',
            type: t.gradientDirection
        },
        {
            name: 'padding',
            type: t.sizeMaybePercent,
            triggersBounds: diff.any
        },
        {
            name: 'padding-relative-to',
            type: t.paddingRelativeTo,
            triggersBounds: diff.any
        },
        {
            name: 'bounds-expansion',
            type: t.boundsExpansion,
            triggersBounds: diff.any
        }
    ];
    var nodeBorder = [
        {
            name: 'border-color',
            type: t.color
        },
        {
            name: 'border-opacity',
            type: t.zeroOneNumber
        },
        {
            name: 'border-width',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'border-style',
            type: t.borderStyle
        },
        {
            name: 'border-cap',
            type: t.lineCap
        },
        {
            name: 'border-join',
            type: t.lineJoin
        },
        {
            name: 'border-dash-pattern',
            type: t.numbers
        },
        {
            name: 'border-dash-offset',
            type: t.number
        },
        {
            name: 'border-position',
            type: t.linePosition
        }
    ];
    var nodeOutline = [
        {
            name: 'outline-color',
            type: t.color
        },
        {
            name: 'outline-opacity',
            type: t.zeroOneNumber
        },
        {
            name: 'outline-width',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'outline-style',
            type: t.borderStyle
        },
        {
            name: 'outline-offset',
            type: t.size,
            triggersBounds: diff.any
        }
    ];
    var backgroundImage = [
        {
            name: 'background-image',
            type: t.urls
        },
        {
            name: 'background-image-crossorigin',
            type: t.bgCrossOrigin
        },
        {
            name: 'background-image-opacity',
            type: t.zeroOneNumbers
        },
        {
            name: 'background-image-containment',
            type: t.bgContainment
        },
        {
            name: 'background-image-smoothing',
            type: t.bools
        },
        {
            name: 'background-position-x',
            type: t.bgPos
        },
        {
            name: 'background-position-y',
            type: t.bgPos
        },
        {
            name: 'background-width-relative-to',
            type: t.bgRelativeTo
        },
        {
            name: 'background-height-relative-to',
            type: t.bgRelativeTo
        },
        {
            name: 'background-repeat',
            type: t.bgRepeat
        },
        {
            name: 'background-fit',
            type: t.bgFit
        },
        {
            name: 'background-clip',
            type: t.bgClip
        },
        {
            name: 'background-width',
            type: t.bgWH
        },
        {
            name: 'background-height',
            type: t.bgWH
        },
        {
            name: 'background-offset-x',
            type: t.bgPos
        },
        {
            name: 'background-offset-y',
            type: t.bgPos
        }
    ];
    var compound = [
        {
            name: 'position',
            type: t.position,
            triggersBounds: diff.any
        },
        {
            name: 'compound-sizing-wrt-labels',
            type: t.compoundIncludeLabels,
            triggersBounds: diff.any
        },
        {
            name: 'min-width',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'min-width-bias-left',
            type: t.sizeMaybePercent,
            triggersBounds: diff.any
        },
        {
            name: 'min-width-bias-right',
            type: t.sizeMaybePercent,
            triggersBounds: diff.any
        },
        {
            name: 'min-height',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'min-height-bias-top',
            type: t.sizeMaybePercent,
            triggersBounds: diff.any
        },
        {
            name: 'min-height-bias-bottom',
            type: t.sizeMaybePercent,
            triggersBounds: diff.any
        }
    ];
    var edgeLine = [
        {
            name: 'line-style',
            type: t.lineStyle
        },
        {
            name: 'line-color',
            type: t.color
        },
        {
            name: 'line-fill',
            type: t.fill
        },
        {
            name: 'line-cap',
            type: t.lineCap
        },
        {
            name: 'line-opacity',
            type: t.zeroOneNumber
        },
        {
            name: 'line-dash-pattern',
            type: t.numbers
        },
        {
            name: 'line-dash-offset',
            type: t.number
        },
        {
            name: 'line-outline-width',
            type: t.size
        },
        {
            name: 'line-outline-color',
            type: t.color
        },
        {
            name: 'line-gradient-stop-colors',
            type: t.colors
        },
        {
            name: 'line-gradient-stop-positions',
            type: t.percentages
        },
        {
            name: 'curve-style',
            type: t.curveStyle,
            triggersBounds: diff.any,
            triggersBoundsOfParallelEdges: function triggersBoundsOfParallelEdges(fromValue, toValue) {
                if (fromValue === toValue) return false;
                 // must have diff
                return fromValue === 'bezier' || // remove from bundle
                toValue === 'bezier'; // add to bundle
            }
        },
        {
            name: 'haystack-radius',
            type: t.zeroOneNumber,
            triggersBounds: diff.any
        },
        {
            name: 'source-endpoint',
            type: t.edgeEndpoint,
            triggersBounds: diff.any
        },
        {
            name: 'target-endpoint',
            type: t.edgeEndpoint,
            triggersBounds: diff.any
        },
        {
            name: 'control-point-step-size',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'control-point-distances',
            type: t.bidirectionalSizes,
            triggersBounds: diff.any
        },
        {
            name: 'control-point-weights',
            type: t.numbers,
            triggersBounds: diff.any
        },
        {
            name: 'segment-distances',
            type: t.bidirectionalSizes,
            triggersBounds: diff.any
        },
        {
            name: 'segment-weights',
            type: t.numbers,
            triggersBounds: diff.any
        },
        {
            name: 'segment-radii',
            type: t.numbers,
            triggersBounds: diff.any
        },
        {
            name: 'radius-type',
            type: t.radiusType,
            triggersBounds: diff.any
        },
        {
            name: 'taxi-turn',
            type: t.bidirectionalSizeMaybePercent,
            triggersBounds: diff.any
        },
        {
            name: 'taxi-turn-min-distance',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'taxi-direction',
            type: t.axisDirection,
            triggersBounds: diff.any
        },
        {
            name: 'taxi-radius',
            type: t.number,
            triggersBounds: diff.any
        },
        {
            name: 'edge-distances',
            type: t.edgeDistances,
            triggersBounds: diff.any
        },
        {
            name: 'arrow-scale',
            type: t.positiveNumber,
            triggersBounds: diff.any
        },
        {
            name: 'loop-direction',
            type: t.angle,
            triggersBounds: diff.any
        },
        {
            name: 'loop-sweep',
            type: t.angle,
            triggersBounds: diff.any
        },
        {
            name: 'source-distance-from-node',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'target-distance-from-node',
            type: t.size,
            triggersBounds: diff.any
        }
    ];
    var ghost = [
        {
            name: 'ghost',
            type: t.bool,
            triggersBounds: diff.any
        },
        {
            name: 'ghost-offset-x',
            type: t.bidirectionalSize,
            triggersBounds: diff.any
        },
        {
            name: 'ghost-offset-y',
            type: t.bidirectionalSize,
            triggersBounds: diff.any
        },
        {
            name: 'ghost-opacity',
            type: t.zeroOneNumber
        }
    ];
    var core = [
        {
            name: 'selection-box-color',
            type: t.color
        },
        {
            name: 'selection-box-opacity',
            type: t.zeroOneNumber
        },
        {
            name: 'selection-box-border-color',
            type: t.color
        },
        {
            name: 'selection-box-border-width',
            type: t.size
        },
        {
            name: 'active-bg-color',
            type: t.color
        },
        {
            name: 'active-bg-opacity',
            type: t.zeroOneNumber
        },
        {
            name: 'active-bg-size',
            type: t.size
        },
        {
            name: 'outside-texture-bg-color',
            type: t.color
        },
        {
            name: 'outside-texture-bg-opacity',
            type: t.zeroOneNumber
        }
    ];
    // pie backgrounds for nodes
    var pie = [];
    $e815fda779bc047b$var$styfn$2.pieBackgroundN = 16; // because the pie properties are numbered, give access to a constant N (for renderer use)
    pie.push({
        name: 'pie-size',
        type: t.sizeMaybePercent
    });
    pie.push({
        name: 'pie-hole',
        type: t.sizeMaybePercent
    });
    pie.push({
        name: 'pie-start-angle',
        type: t.angle
    });
    for(var i = 1; i <= $e815fda779bc047b$var$styfn$2.pieBackgroundN; i++){
        pie.push({
            name: 'pie-' + i + '-background-color',
            type: t.color
        });
        pie.push({
            name: 'pie-' + i + '-background-size',
            type: t.percent
        });
        pie.push({
            name: 'pie-' + i + '-background-opacity',
            type: t.zeroOneNumber
        });
    }
    // stripe backgrounds for nodes
    var stripe = [];
    $e815fda779bc047b$var$styfn$2.stripeBackgroundN = 16; // because the stripe properties are numbered, give access to a constant N (for renderer use)
    stripe.push({
        name: 'stripe-size',
        type: t.sizeMaybePercent
    });
    stripe.push({
        name: 'stripe-direction',
        type: t.axisDirectionPrimary
    });
    for(var _i = 1; _i <= $e815fda779bc047b$var$styfn$2.stripeBackgroundN; _i++){
        stripe.push({
            name: 'stripe-' + _i + '-background-color',
            type: t.color
        });
        stripe.push({
            name: 'stripe-' + _i + '-background-size',
            type: t.percent
        });
        stripe.push({
            name: 'stripe-' + _i + '-background-opacity',
            type: t.zeroOneNumber
        });
    }
    // edge arrows
    var edgeArrow = [];
    var arrowPrefixes = $e815fda779bc047b$var$styfn$2.arrowPrefixes = [
        'source',
        'mid-source',
        'target',
        'mid-target'
    ];
    [
        {
            name: 'arrow-shape',
            type: t.arrowShape,
            triggersBounds: diff.any
        },
        {
            name: 'arrow-color',
            type: t.color
        },
        {
            name: 'arrow-fill',
            type: t.arrowFill
        },
        {
            name: 'arrow-width',
            type: t.arrowWidth
        }
    ].forEach(function(prop) {
        arrowPrefixes.forEach(function(prefix) {
            var name = prefix + '-' + prop.name;
            var type = prop.type, triggersBounds = prop.triggersBounds;
            edgeArrow.push({
                name: name,
                type: type,
                triggersBounds: triggersBounds
            });
        });
    }, {});
    var props = $e815fda779bc047b$var$styfn$2.properties = [].concat(behavior, transition, visibility, overlay, underlay, ghost, commonLabel, labelDimensions, mainLabel, sourceLabel, targetLabel, nodeBody, nodeBorder, nodeOutline, backgroundImage, pie, stripe, compound, edgeLine, edgeArrow, core);
    var propGroups = $e815fda779bc047b$var$styfn$2.propertyGroups = {
        // common to all eles
        behavior: behavior,
        transition: transition,
        visibility: visibility,
        overlay: overlay,
        underlay: underlay,
        ghost: ghost,
        // labels
        commonLabel: commonLabel,
        labelDimensions: labelDimensions,
        mainLabel: mainLabel,
        sourceLabel: sourceLabel,
        targetLabel: targetLabel,
        // node props
        nodeBody: nodeBody,
        nodeBorder: nodeBorder,
        nodeOutline: nodeOutline,
        backgroundImage: backgroundImage,
        pie: pie,
        stripe: stripe,
        compound: compound,
        // edge props
        edgeLine: edgeLine,
        edgeArrow: edgeArrow,
        core: core
    };
    var propGroupNames = $e815fda779bc047b$var$styfn$2.propertyGroupNames = {};
    var propGroupKeys = $e815fda779bc047b$var$styfn$2.propertyGroupKeys = Object.keys(propGroups);
    propGroupKeys.forEach(function(key) {
        propGroupNames[key] = propGroups[key].map(function(prop) {
            return prop.name;
        });
        propGroups[key].forEach(function(prop) {
            return prop.groupKey = key;
        });
    });
    // define aliases
    var aliases = $e815fda779bc047b$var$styfn$2.aliases = [
        {
            name: 'content',
            pointsTo: 'label'
        },
        {
            name: 'control-point-distance',
            pointsTo: 'control-point-distances'
        },
        {
            name: 'control-point-weight',
            pointsTo: 'control-point-weights'
        },
        {
            name: 'segment-distance',
            pointsTo: 'segment-distances'
        },
        {
            name: 'segment-weight',
            pointsTo: 'segment-weights'
        },
        {
            name: 'segment-radius',
            pointsTo: 'segment-radii'
        },
        {
            name: 'edge-text-rotation',
            pointsTo: 'text-rotation'
        },
        {
            name: 'padding-left',
            pointsTo: 'padding'
        },
        {
            name: 'padding-right',
            pointsTo: 'padding'
        },
        {
            name: 'padding-top',
            pointsTo: 'padding'
        },
        {
            name: 'padding-bottom',
            pointsTo: 'padding'
        }
    ];
    // list of property names
    $e815fda779bc047b$var$styfn$2.propertyNames = props.map(function(p) {
        return p.name;
    });
    // allow access of properties by name ( e.g. style.properties.height )
    for(var _i2 = 0; _i2 < props.length; _i2++){
        var prop = props[_i2];
        props[prop.name] = prop; // allow lookup by name
    }
    // map aliases
    for(var _i3 = 0; _i3 < aliases.length; _i3++){
        var alias = aliases[_i3];
        var pointsToProp = props[alias.pointsTo];
        var aliasProp = {
            name: alias.name,
            alias: true,
            pointsTo: pointsToProp
        };
        // add alias prop for parsing
        props.push(aliasProp);
        props[alias.name] = aliasProp; // allow lookup by name
    }
})();
$e815fda779bc047b$var$styfn$2.getDefaultProperty = function(name) {
    return this.getDefaultProperties()[name];
};
$e815fda779bc047b$var$styfn$2.getDefaultProperties = function() {
    var _p = this._private;
    if (_p.defaultProperties != null) return _p.defaultProperties;
    var rawProps = $e815fda779bc047b$var$extend({
        // core props
        'selection-box-color': '#ddd',
        'selection-box-opacity': 0.65,
        'selection-box-border-color': '#aaa',
        'selection-box-border-width': 1,
        'active-bg-color': 'black',
        'active-bg-opacity': 0.15,
        'active-bg-size': 30,
        'outside-texture-bg-color': '#000',
        'outside-texture-bg-opacity': 0.125,
        // common node/edge props
        'events': 'yes',
        'text-events': 'no',
        'text-valign': 'top',
        'text-halign': 'center',
        'text-justification': 'auto',
        'line-height': 1,
        'color': '#000',
        'box-selection': 'contain',
        'text-outline-color': '#000',
        'text-outline-width': 0,
        'text-outline-opacity': 1,
        'text-opacity': 1,
        'text-decoration': 'none',
        'text-transform': 'none',
        'text-wrap': 'none',
        'text-overflow-wrap': 'whitespace',
        'text-max-width': 9999,
        'text-background-color': '#000',
        'text-background-opacity': 0,
        'text-background-shape': 'rectangle',
        'text-background-padding': 0,
        'text-border-opacity': 0,
        'text-border-width': 0,
        'text-border-style': 'solid',
        'text-border-color': '#000',
        'font-family': 'Helvetica Neue, Helvetica, sans-serif',
        'font-style': 'normal',
        'font-weight': 'normal',
        'font-size': 16,
        'min-zoomed-font-size': 0,
        'text-rotation': 'none',
        'source-text-rotation': 'none',
        'target-text-rotation': 'none',
        'visibility': 'visible',
        'display': 'element',
        'opacity': 1,
        'z-compound-depth': 'auto',
        'z-index-compare': 'auto',
        'z-index': 0,
        'label': '',
        'text-margin-x': 0,
        'text-margin-y': 0,
        'source-label': '',
        'source-text-offset': 0,
        'source-text-margin-x': 0,
        'source-text-margin-y': 0,
        'target-label': '',
        'target-text-offset': 0,
        'target-text-margin-x': 0,
        'target-text-margin-y': 0,
        'overlay-opacity': 0,
        'overlay-color': '#000',
        'overlay-padding': 10,
        'overlay-shape': 'round-rectangle',
        'overlay-corner-radius': 'auto',
        'underlay-opacity': 0,
        'underlay-color': '#000',
        'underlay-padding': 10,
        'underlay-shape': 'round-rectangle',
        'underlay-corner-radius': 'auto',
        'transition-property': 'none',
        'transition-duration': 0,
        'transition-delay': 0,
        'transition-timing-function': 'linear',
        'box-select-labels': 'no',
        // node props
        'background-blacken': 0,
        'background-color': '#999',
        'background-fill': 'solid',
        'background-opacity': 1,
        'background-image': 'none',
        'background-image-crossorigin': 'anonymous',
        'background-image-opacity': 1,
        'background-image-containment': 'inside',
        'background-image-smoothing': 'yes',
        'background-position-x': '50%',
        'background-position-y': '50%',
        'background-offset-x': 0,
        'background-offset-y': 0,
        'background-width-relative-to': 'include-padding',
        'background-height-relative-to': 'include-padding',
        'background-repeat': 'no-repeat',
        'background-fit': 'none',
        'background-clip': 'node',
        'background-width': 'auto',
        'background-height': 'auto',
        'border-color': '#000',
        'border-opacity': 1,
        'border-width': 0,
        'border-style': 'solid',
        'border-dash-pattern': [
            4,
            2
        ],
        'border-dash-offset': 0,
        'border-cap': 'butt',
        'border-join': 'miter',
        'border-position': 'center',
        'outline-color': '#999',
        'outline-opacity': 1,
        'outline-width': 0,
        'outline-offset': 0,
        'outline-style': 'solid',
        'height': 30,
        'width': 30,
        'shape': 'ellipse',
        'shape-polygon-points': '-1, -1,   1, -1,   1, 1,   -1, 1',
        'corner-radius': 'auto',
        'bounds-expansion': 0,
        // node gradient
        'background-gradient-direction': 'to-bottom',
        'background-gradient-stop-colors': '#999',
        'background-gradient-stop-positions': '0%',
        // ghost props
        'ghost': 'no',
        'ghost-offset-y': 0,
        'ghost-offset-x': 0,
        'ghost-opacity': 0,
        // compound props
        'padding': 0,
        'padding-relative-to': 'width',
        'position': 'origin',
        'compound-sizing-wrt-labels': 'include',
        'min-width': 0,
        'min-width-bias-left': 0,
        'min-width-bias-right': 0,
        'min-height': 0,
        'min-height-bias-top': 0,
        'min-height-bias-bottom': 0
    }, {
        // node pie bg
        'pie-size': '100%',
        'pie-hole': 0,
        'pie-start-angle': '0deg'
    }, [
        {
            name: 'pie-{{i}}-background-color',
            value: 'black'
        },
        {
            name: 'pie-{{i}}-background-size',
            value: '0%'
        },
        {
            name: 'pie-{{i}}-background-opacity',
            value: 1
        }
    ].reduce(function(css, prop) {
        for(var i = 1; i <= $e815fda779bc047b$var$styfn$2.pieBackgroundN; i++){
            var name = prop.name.replace('{{i}}', i);
            var val = prop.value;
            css[name] = val;
        }
        return css;
    }, {}), {
        // node stripes bg
        'stripe-size': '100%',
        'stripe-direction': 'horizontal'
    }, [
        {
            name: 'stripe-{{i}}-background-color',
            value: 'black'
        },
        {
            name: 'stripe-{{i}}-background-size',
            value: '0%'
        },
        {
            name: 'stripe-{{i}}-background-opacity',
            value: 1
        }
    ].reduce(function(css, prop) {
        for(var i = 1; i <= $e815fda779bc047b$var$styfn$2.stripeBackgroundN; i++){
            var name = prop.name.replace('{{i}}', i);
            var val = prop.value;
            css[name] = val;
        }
        return css;
    }, {}), {
        // edge props
        'line-style': 'solid',
        'line-color': '#999',
        'line-fill': 'solid',
        'line-cap': 'butt',
        'line-opacity': 1,
        'line-outline-width': 0,
        'line-outline-color': '#000',
        'line-gradient-stop-colors': '#999',
        'line-gradient-stop-positions': '0%',
        'control-point-step-size': 40,
        'control-point-weights': 0.5,
        'segment-weights': 0.5,
        'segment-distances': 20,
        'segment-radii': 15,
        'radius-type': 'arc-radius',
        'taxi-turn': '50%',
        'taxi-radius': 15,
        'taxi-turn-min-distance': 10,
        'taxi-direction': 'auto',
        'edge-distances': 'intersection',
        'curve-style': 'haystack',
        'haystack-radius': 0,
        'arrow-scale': 1,
        'loop-direction': '-45deg',
        'loop-sweep': '-90deg',
        'source-distance-from-node': 0,
        'target-distance-from-node': 0,
        'source-endpoint': 'outside-to-node',
        'target-endpoint': 'outside-to-node',
        'line-dash-pattern': [
            6,
            3
        ],
        'line-dash-offset': 0
    }, [
        {
            name: 'arrow-shape',
            value: 'none'
        },
        {
            name: 'arrow-color',
            value: '#999'
        },
        {
            name: 'arrow-fill',
            value: 'filled'
        },
        {
            name: 'arrow-width',
            value: 1
        }
    ].reduce(function(css, prop) {
        $e815fda779bc047b$var$styfn$2.arrowPrefixes.forEach(function(prefix) {
            var name = prefix + '-' + prop.name;
            var val = prop.value;
            css[name] = val;
        });
        return css;
    }, {}));
    var parsedProps = {};
    for(var i = 0; i < this.properties.length; i++){
        var prop = this.properties[i];
        if (prop.pointsTo) continue;
        var name = prop.name;
        var val = rawProps[name];
        var parsedProp = this.parse(name, val);
        parsedProps[name] = parsedProp;
    }
    _p.defaultProperties = parsedProps;
    return _p.defaultProperties;
};
$e815fda779bc047b$var$styfn$2.addDefaultStylesheet = function() {
    this.selector(':parent').css({
        'shape': 'rectangle',
        'padding': 10,
        'background-color': '#eee',
        'border-color': '#ccc',
        'border-width': 1
    }).selector('edge').css({
        'width': 3
    }).selector(':loop').css({
        'curve-style': 'bezier'
    }).selector('edge:compound').css({
        'curve-style': 'bezier',
        'source-endpoint': 'outside-to-line',
        'target-endpoint': 'outside-to-line'
    }).selector(':selected').css({
        'background-color': '#0169D9',
        'line-color': '#0169D9',
        'source-arrow-color': '#0169D9',
        'target-arrow-color': '#0169D9',
        'mid-source-arrow-color': '#0169D9',
        'mid-target-arrow-color': '#0169D9'
    }).selector(':parent:selected').css({
        'background-color': '#CCE1F9',
        'border-color': '#aec8e5'
    }).selector(':active').css({
        'overlay-color': 'black',
        'overlay-padding': 10,
        'overlay-opacity': 0.25
    });
    this.defaultLength = this.length;
};
var $e815fda779bc047b$var$styfn$1 = {};
// a caching layer for property parsing
$e815fda779bc047b$var$styfn$1.parse = function(name, value, propIsBypass, propIsFlat) {
    var self1 = this;
    // function values can't be cached in all cases, and there isn't much benefit of caching them anyway
    if ($e815fda779bc047b$var$fn$6(value)) return self1.parseImplWarn(name, value, propIsBypass, propIsFlat);
    var flatKey = propIsFlat === 'mapping' || propIsFlat === true || propIsFlat === false || propIsFlat == null ? 'dontcare' : propIsFlat;
    var bypassKey = propIsBypass ? 't' : 'f';
    var valueKey = '' + value;
    var argHash = $e815fda779bc047b$var$hashStrings(name, valueKey, bypassKey, flatKey);
    var propCache = self1.propCache = self1.propCache || [];
    var ret;
    if (!(ret = propCache[argHash])) ret = propCache[argHash] = self1.parseImplWarn(name, value, propIsBypass, propIsFlat);
    // - bypasses can't be shared b/c the value can be changed by animations or otherwise overridden
    // - mappings can't be shared b/c mappings are per-element
    if (propIsBypass || propIsFlat === 'mapping') {
        // need a copy since props are mutated later in their lifecycles
        ret = $e815fda779bc047b$var$copy(ret);
        if (ret) ret.value = $e815fda779bc047b$var$copy(ret.value); // because it could be an array, e.g. colour
    }
    return ret;
};
$e815fda779bc047b$var$styfn$1.parseImplWarn = function(name, value, propIsBypass, propIsFlat) {
    var prop = this.parseImpl(name, value, propIsBypass, propIsFlat);
    if (!prop && value != null) $e815fda779bc047b$var$warn("The style property `".concat(name, ": ").concat(value, "` is invalid"));
    if (prop && (prop.name === 'width' || prop.name === 'height') && value === 'label') $e815fda779bc047b$var$warn('The style value of `label` is deprecated for `' + prop.name + '`');
    return prop;
};
// parse a property; return null on invalid; return parsed property otherwise
// fields :
// - name : the name of the property
// - value : the parsed, native-typed value of the property
// - strValue : a string value that represents the property value in valid css
// - bypass : true iff the property is a bypass property
$e815fda779bc047b$var$styfn$1.parseImpl = function(name, value, propIsBypass, propIsFlat) {
    var self1 = this;
    name = $e815fda779bc047b$var$camel2dash(name); // make sure the property name is in dash form (e.g. 'property-name' not 'propertyName')
    var property = self1.properties[name];
    var passedValue = value;
    var types = self1.types;
    if (!property) return null;
     // return null on property of unknown name
    if (value === undefined) return null;
     // can't assign undefined
    // the property may be an alias
    if (property.alias) {
        property = property.pointsTo;
        name = property.name;
    }
    var valueIsString = $e815fda779bc047b$var$string(value);
    if (valueIsString) // trim the value to make parsing easier
    value = value.trim();
    var type = property.type;
    if (!type) return null;
     // no type, no luck
    // check if bypass is null or empty string (i.e. indication to delete bypass property)
    if (propIsBypass && (value === '' || value === null)) return {
        name: name,
        value: value,
        bypass: true,
        deleteBypass: true
    };
    // check if value is a function used as a mapper
    if ($e815fda779bc047b$var$fn$6(value)) return {
        name: name,
        value: value,
        strValue: 'fn',
        mapped: types.fn,
        bypass: propIsBypass
    };
    // check if value is mapped
    var data, mapData;
    if (!valueIsString || propIsFlat || value.length < 7 || value[1] !== 'a') ;
    else if (value.length >= 7 && value[0] === 'd' && (data = new RegExp(types.data.regex).exec(value))) {
        if (propIsBypass) return false;
         // mappers not allowed in bypass
        var mapped = types.data;
        return {
            name: name,
            value: data,
            strValue: '' + value,
            mapped: mapped,
            field: data[1],
            bypass: propIsBypass
        };
    } else if (value.length >= 10 && value[0] === 'm' && (mapData = new RegExp(types.mapData.regex).exec(value))) {
        if (propIsBypass) return false;
         // mappers not allowed in bypass
        if (type.multiple) return false;
         // impossible to map to num
        var _mapped = types.mapData;
        // we can map only if the type is a colour or a number
        if (!(type.color || type.number)) return false;
        var valueMin = this.parse(name, mapData[4]); // parse to validate
        if (!valueMin || valueMin.mapped) return false;
         // can't be invalid or mapped
        var valueMax = this.parse(name, mapData[5]); // parse to validate
        if (!valueMax || valueMax.mapped) return false;
         // can't be invalid or mapped
        // check if valueMin and valueMax are the same
        if (valueMin.pfValue === valueMax.pfValue || valueMin.strValue === valueMax.strValue) {
            $e815fda779bc047b$var$warn('`' + name + ': ' + value + '` is not a valid mapper because the output range is zero; converting to `' + name + ': ' + valueMin.strValue + '`');
            return this.parse(name, valueMin.strValue); // can't make much of a mapper without a range
        } else if (type.color) {
            var c1 = valueMin.value;
            var c2 = valueMax.value;
            var same = c1[0] === c2[0] // red
             && c1[1] === c2[1] // green
             && c1[2] === c2[2] // blue
             && // optional alpha
            (c1[3] === c2[3] // same alpha outright
             || (c1[3] == null || c1[3] === 1 // full opacity for colour 1?
            ) && (c2[3] == null || c2[3] === 1 // full opacity for colour 2?
            ));
            if (same) return false;
             // can't make a mapper without a range
        }
        return {
            name: name,
            value: mapData,
            strValue: '' + value,
            mapped: _mapped,
            field: mapData[1],
            fieldMin: parseFloat(mapData[2]),
            // min & max are numeric
            fieldMax: parseFloat(mapData[3]),
            valueMin: valueMin.value,
            valueMax: valueMax.value,
            bypass: propIsBypass
        };
    }
    if (type.multiple && propIsFlat !== 'multiple') {
        var vals;
        if (valueIsString) vals = value.split(/\s+/);
        else if ($e815fda779bc047b$var$array(value)) vals = value;
        else vals = [
            value
        ];
        if (type.evenMultiple && vals.length % 2 !== 0) return null;
        var valArr = [];
        var unitsArr = [];
        var pfValArr = [];
        var strVal = '';
        var hasEnum = false;
        for(var i = 0; i < vals.length; i++){
            var p = self1.parse(name, vals[i], propIsBypass, 'multiple');
            hasEnum = hasEnum || $e815fda779bc047b$var$string(p.value);
            valArr.push(p.value);
            pfValArr.push(p.pfValue != null ? p.pfValue : p.value);
            unitsArr.push(p.units);
            strVal += (i > 0 ? ' ' : '') + p.strValue;
        }
        if (type.validate && !type.validate(valArr, unitsArr)) return null;
        if (type.singleEnum && hasEnum) {
            if (valArr.length === 1 && $e815fda779bc047b$var$string(valArr[0])) return {
                name: name,
                value: valArr[0],
                strValue: valArr[0],
                bypass: propIsBypass
            };
            else return null;
        }
        return {
            name: name,
            value: valArr,
            pfValue: pfValArr,
            strValue: strVal,
            bypass: propIsBypass,
            units: unitsArr
        };
    }
    // several types also allow enums
    var checkEnums = function checkEnums() {
        for(var _i = 0; _i < type.enums.length; _i++){
            var en = type.enums[_i];
            if (en === value) return {
                name: name,
                value: value,
                strValue: '' + value,
                bypass: propIsBypass
            };
        }
        return null;
    };
    // check the type and return the appropriate object
    if (type.number) {
        var units;
        var implicitUnits = 'px'; // not set => px
        if (type.units) // use specified units if set
        units = type.units;
        if (type.implicitUnits) implicitUnits = type.implicitUnits;
        if (!type.unitless) {
            if (valueIsString) {
                var unitsRegex = 'px|em' + (type.allowPercent ? '|\\%' : '');
                if (units) unitsRegex = units;
                 // only allow explicit units if so set
                var match = value.match('^(' + $e815fda779bc047b$var$number + ')(' + unitsRegex + ')?' + '$');
                if (match) {
                    value = match[1];
                    units = match[2] || implicitUnits;
                }
            } else if (!units || type.implicitUnits) units = implicitUnits; // implicitly px if unspecified
        }
        value = parseFloat(value);
        // if not a number and enums not allowed, then the value is invalid
        if (isNaN(value) && type.enums === undefined) return null;
        // check if this number type also accepts special keywords in place of numbers
        // (i.e. `left`, `auto`, etc)
        if (isNaN(value) && type.enums !== undefined) {
            value = passedValue;
            return checkEnums();
        }
        // check if value must be an integer
        if (type.integer && !$e815fda779bc047b$var$integer(value)) return null;
        // check value is within range
        if (type.min !== undefined && (value < type.min || type.strictMin && value === type.min) || type.max !== undefined && (value > type.max || type.strictMax && value === type.max)) return null;
        var ret = {
            name: name,
            value: value,
            strValue: '' + value + (units ? units : ''),
            units: units,
            bypass: propIsBypass
        };
        // normalise value in pixels
        if (type.unitless || units !== 'px' && units !== 'em') ret.pfValue = value;
        else ret.pfValue = units === 'px' || !units ? value : this.getEmSizeInPixels() * value;
        // normalise value in ms
        if (units === 'ms' || units === 's') ret.pfValue = units === 'ms' ? value : 1000 * value;
        // normalise value in rad
        if (units === 'deg' || units === 'rad') ret.pfValue = units === 'rad' ? value : $e815fda779bc047b$var$deg2rad(value);
        // normalize value in %
        if (units === '%') ret.pfValue = value / 100;
        return ret;
    } else if (type.propList) {
        var props = [];
        var propsStr = '' + value;
        if (propsStr === 'none') ;
        else {
            // go over each prop
            var propsSplit = propsStr.split(/\s*,\s*|\s+/);
            for(var _i2 = 0; _i2 < propsSplit.length; _i2++){
                var propName = propsSplit[_i2].trim();
                if (self1.properties[propName]) props.push(propName);
                else $e815fda779bc047b$var$warn('`' + propName + '` is not a valid property name');
            }
            if (props.length === 0) return null;
        }
        return {
            name: name,
            value: props,
            strValue: props.length === 0 ? 'none' : props.join(' '),
            bypass: propIsBypass
        };
    } else if (type.color) {
        var tuple = $e815fda779bc047b$var$color2tuple(value);
        if (!tuple) return null;
        return {
            name: name,
            value: tuple,
            pfValue: tuple,
            strValue: 'rgb(' + tuple[0] + ',' + tuple[1] + ',' + tuple[2] + ')',
            // n.b. no spaces b/c of multiple support
            bypass: propIsBypass
        };
    } else if (type.regex || type.regexes) {
        // first check enums
        if (type.enums) {
            var enumProp = checkEnums();
            if (enumProp) return enumProp;
        }
        var regexes = type.regexes ? type.regexes : [
            type.regex
        ];
        for(var _i3 = 0; _i3 < regexes.length; _i3++){
            var regex = new RegExp(regexes[_i3]); // make a regex from the type string
            var m1 = regex.exec(value);
            if (m1) // regex matches
            return {
                name: name,
                value: type.singleRegexMatchValue ? m1[1] : m1,
                strValue: '' + value,
                bypass: propIsBypass
            };
        }
        return null; // didn't match any
    } else if (type.string) // just return
    return {
        name: name,
        value: '' + value,
        strValue: '' + value,
        bypass: propIsBypass
    };
    else if (type.enums) // check enums last because it's a combo type in others
    return checkEnums();
    else return null; // not a type we can handle
};
var $e815fda779bc047b$var$_Style = function Style(cy) {
    if (!(this instanceof $e815fda779bc047b$var$_Style)) return new $e815fda779bc047b$var$_Style(cy);
    if (!$e815fda779bc047b$var$core(cy)) {
        $e815fda779bc047b$var$error('A style must have a core reference');
        return;
    }
    this._private = {
        cy: cy,
        coreStyle: {}
    };
    this.length = 0;
    this.resetToDefault();
};
var $e815fda779bc047b$var$styfn = $e815fda779bc047b$var$_Style.prototype;
$e815fda779bc047b$var$styfn.instanceString = function() {
    return 'style';
};
// remove all contexts
$e815fda779bc047b$var$styfn.clear = function() {
    var _p = this._private;
    var cy = _p.cy;
    var eles = cy.elements();
    for(var i = 0; i < this.length; i++)this[i] = undefined;
    this.length = 0;
    _p.contextStyles = {};
    _p.propDiffs = {};
    this.cleanElements(eles, true);
    eles.forEach(function(ele) {
        var ele_p = ele[0]._private;
        ele_p.styleDirty = true;
        ele_p.appliedInitStyle = false;
    });
    return this; // chaining
};
$e815fda779bc047b$var$styfn.resetToDefault = function() {
    this.clear();
    this.addDefaultStylesheet();
    return this;
};
// builds a style object for the 'core' selector
$e815fda779bc047b$var$styfn.core = function(propName) {
    return this._private.coreStyle[propName] || this.getDefaultProperty(propName);
};
// create a new context from the specified selector string and switch to that context
$e815fda779bc047b$var$styfn.selector = function(selectorStr) {
    // 'core' is a special case and does not need a selector
    var selector = selectorStr === 'core' ? null : new $e815fda779bc047b$var$Selector(selectorStr);
    var i = this.length++; // new context means new index
    this[i] = {
        selector: selector,
        properties: [],
        mappedProperties: [],
        index: i
    };
    return this; // chaining
};
// add one or many css rules to the current context
$e815fda779bc047b$var$styfn.css = function() {
    var self1 = this;
    var args = arguments;
    if (args.length === 1) {
        var map = args[0];
        for(var i = 0; i < self1.properties.length; i++){
            var prop = self1.properties[i];
            var mapVal = map[prop.name];
            if (mapVal === undefined) mapVal = map[$e815fda779bc047b$var$dash2camel(prop.name)];
            if (mapVal !== undefined) this.cssRule(prop.name, mapVal);
        }
    } else if (args.length === 2) this.cssRule(args[0], args[1]);
    // do nothing if args are invalid
    return this; // chaining
};
$e815fda779bc047b$var$styfn.style = $e815fda779bc047b$var$styfn.css;
// add a single css rule to the current context
$e815fda779bc047b$var$styfn.cssRule = function(name, value) {
    // name-value pair
    var property = this.parse(name, value);
    // add property to current context if valid
    if (property) {
        var i = this.length - 1;
        this[i].properties.push(property);
        this[i].properties[property.name] = property; // allow access by name as well
        if (property.name.match(/pie-(\d+)-background-size/) && property.value) this._private.hasPie = true;
        if (property.name.match(/stripe-(\d+)-background-size/) && property.value) this._private.hasStripe = true;
        if (property.mapped) this[i].mappedProperties.push(property);
        // add to core style if necessary
        var currentSelectorIsCore = !this[i].selector;
        if (currentSelectorIsCore) this._private.coreStyle[property.name] = property;
    }
    return this; // chaining
};
$e815fda779bc047b$var$styfn.append = function(style) {
    if ($e815fda779bc047b$var$stylesheet(style)) style.appendToStyle(this);
    else if ($e815fda779bc047b$var$array(style)) this.appendFromJson(style);
    else if ($e815fda779bc047b$var$string(style)) this.appendFromString(style);
     // you probably wouldn't want to append a Style, since you'd duplicate the default parts
    return this;
};
// static function
$e815fda779bc047b$var$_Style.fromJson = function(cy, json) {
    var style = new $e815fda779bc047b$var$_Style(cy);
    style.fromJson(json);
    return style;
};
$e815fda779bc047b$var$_Style.fromString = function(cy, string) {
    return new $e815fda779bc047b$var$_Style(cy).fromString(string);
};
[
    $e815fda779bc047b$var$styfn$8,
    $e815fda779bc047b$var$styfn$7,
    $e815fda779bc047b$var$styfn$6,
    $e815fda779bc047b$var$styfn$5,
    $e815fda779bc047b$var$styfn$4,
    $e815fda779bc047b$var$styfn$3,
    $e815fda779bc047b$var$styfn$2,
    $e815fda779bc047b$var$styfn$1
].forEach(function(props) {
    $e815fda779bc047b$var$extend($e815fda779bc047b$var$styfn, props);
});
$e815fda779bc047b$var$_Style.types = $e815fda779bc047b$var$styfn.types;
$e815fda779bc047b$var$_Style.properties = $e815fda779bc047b$var$styfn.properties;
$e815fda779bc047b$var$_Style.propertyGroups = $e815fda779bc047b$var$styfn.propertyGroups;
$e815fda779bc047b$var$_Style.propertyGroupNames = $e815fda779bc047b$var$styfn.propertyGroupNames;
$e815fda779bc047b$var$_Style.propertyGroupKeys = $e815fda779bc047b$var$styfn.propertyGroupKeys;
var $e815fda779bc047b$var$corefn$2 = {
    style: function style(newStyle) {
        if (newStyle) {
            var s = this.setStyle(newStyle);
            s.update();
        }
        return this._private.style;
    },
    setStyle: function setStyle(style) {
        var _p = this._private;
        if ($e815fda779bc047b$var$stylesheet(style)) _p.style = style.generateStyle(this);
        else if ($e815fda779bc047b$var$array(style)) _p.style = $e815fda779bc047b$var$_Style.fromJson(this, style);
        else if ($e815fda779bc047b$var$string(style)) _p.style = $e815fda779bc047b$var$_Style.fromString(this, style);
        else _p.style = $e815fda779bc047b$var$_Style(this);
        return _p.style;
    },
    // e.g. cy.data() changed => recalc ele mappers
    updateStyle: function updateStyle() {
        this.mutableElements().updateStyle(); // just send to all eles
    }
};
var $e815fda779bc047b$var$defaultSelectionType = 'single';
var $e815fda779bc047b$var$corefn$1 = {
    autolock: function autolock(bool) {
        if (bool !== undefined) this._private.autolock = bool ? true : false;
        else return this._private.autolock;
        return this; // chaining
    },
    autoungrabify: function autoungrabify(bool) {
        if (bool !== undefined) this._private.autoungrabify = bool ? true : false;
        else return this._private.autoungrabify;
        return this; // chaining
    },
    autounselectify: function autounselectify(bool) {
        if (bool !== undefined) this._private.autounselectify = bool ? true : false;
        else return this._private.autounselectify;
        return this; // chaining
    },
    selectionType: function selectionType(selType) {
        var _p = this._private;
        if (_p.selectionType == null) _p.selectionType = $e815fda779bc047b$var$defaultSelectionType;
        if (selType !== undefined) {
            if (selType === 'additive' || selType === 'single') _p.selectionType = selType;
        } else return _p.selectionType;
        return this;
    },
    panningEnabled: function panningEnabled(bool) {
        if (bool !== undefined) this._private.panningEnabled = bool ? true : false;
        else return this._private.panningEnabled;
        return this; // chaining
    },
    userPanningEnabled: function userPanningEnabled(bool) {
        if (bool !== undefined) this._private.userPanningEnabled = bool ? true : false;
        else return this._private.userPanningEnabled;
        return this; // chaining
    },
    zoomingEnabled: function zoomingEnabled(bool) {
        if (bool !== undefined) this._private.zoomingEnabled = bool ? true : false;
        else return this._private.zoomingEnabled;
        return this; // chaining
    },
    userZoomingEnabled: function userZoomingEnabled(bool) {
        if (bool !== undefined) this._private.userZoomingEnabled = bool ? true : false;
        else return this._private.userZoomingEnabled;
        return this; // chaining
    },
    boxSelectionEnabled: function boxSelectionEnabled(bool) {
        if (bool !== undefined) this._private.boxSelectionEnabled = bool ? true : false;
        else return this._private.boxSelectionEnabled;
        return this; // chaining
    },
    pan: function pan() {
        var args = arguments;
        var pan = this._private.pan;
        var dim, val, dims, x, y;
        switch(args.length){
            case 0:
                // .pan()
                return pan;
            case 1:
                if ($e815fda779bc047b$var$string(args[0])) {
                    // .pan('x')
                    dim = args[0];
                    return pan[dim];
                } else if ($e815fda779bc047b$var$plainObject(args[0])) {
                    // .pan({ x: 0, y: 100 })
                    if (!this._private.panningEnabled) return this;
                    dims = args[0];
                    x = dims.x;
                    y = dims.y;
                    if ($e815fda779bc047b$var$number$1(x)) pan.x = x;
                    if ($e815fda779bc047b$var$number$1(y)) pan.y = y;
                    this.emit('pan viewport');
                }
                break;
            case 2:
                // .pan('x', 100)
                if (!this._private.panningEnabled) return this;
                dim = args[0];
                val = args[1];
                if ((dim === 'x' || dim === 'y') && $e815fda779bc047b$var$number$1(val)) pan[dim] = val;
                this.emit('pan viewport');
                break;
        }
        this.notify('viewport');
        return this; // chaining
    },
    panBy: function panBy(arg0, arg1) {
        var args = arguments;
        var pan = this._private.pan;
        var dim, val, dims, x, y;
        if (!this._private.panningEnabled) return this;
        switch(args.length){
            case 1:
                if ($e815fda779bc047b$var$plainObject(arg0)) {
                    // .panBy({ x: 0, y: 100 })
                    dims = args[0];
                    x = dims.x;
                    y = dims.y;
                    if ($e815fda779bc047b$var$number$1(x)) pan.x += x;
                    if ($e815fda779bc047b$var$number$1(y)) pan.y += y;
                    this.emit('pan viewport');
                }
                break;
            case 2:
                // .panBy('x', 100)
                dim = arg0;
                val = arg1;
                if ((dim === 'x' || dim === 'y') && $e815fda779bc047b$var$number$1(val)) pan[dim] += val;
                this.emit('pan viewport');
                break;
        }
        this.notify('viewport');
        return this; // chaining
    },
    gc: function gc() {
        this.notify('gc');
    },
    fit: function fit(elements, padding) {
        var viewportState = this.getFitViewport(elements, padding);
        if (viewportState) {
            var _p = this._private;
            _p.zoom = viewportState.zoom;
            _p.pan = viewportState.pan;
            this.emit('pan zoom viewport');
            this.notify('viewport');
        }
        return this; // chaining
    },
    getFitViewport: function getFitViewport(elements, padding) {
        if ($e815fda779bc047b$var$number$1(elements) && padding === undefined) {
            // elements is optional
            padding = elements;
            elements = undefined;
        }
        if (!this._private.panningEnabled || !this._private.zoomingEnabled) return;
        var bb;
        if ($e815fda779bc047b$var$string(elements)) {
            var sel = elements;
            elements = this.$(sel);
        } else if ($e815fda779bc047b$var$boundingBox(elements)) {
            // assume bb
            var bbe = elements;
            bb = {
                x1: bbe.x1,
                y1: bbe.y1,
                x2: bbe.x2,
                y2: bbe.y2
            };
            bb.w = bb.x2 - bb.x1;
            bb.h = bb.y2 - bb.y1;
        } else if (!$e815fda779bc047b$var$elementOrCollection(elements)) elements = this.mutableElements();
        if ($e815fda779bc047b$var$elementOrCollection(elements) && elements.empty()) return;
         // can't fit to nothing
        bb = bb || elements.boundingBox();
        var w = this.width();
        var h = this.height();
        var zoom;
        padding = $e815fda779bc047b$var$number$1(padding) ? padding : 0;
        if (!isNaN(w) && !isNaN(h) && w > 0 && h > 0 && !isNaN(bb.w) && !isNaN(bb.h) && bb.w > 0 && bb.h > 0) {
            zoom = Math.min((w - 2 * padding) / bb.w, (h - 2 * padding) / bb.h);
            // crop zoom
            zoom = zoom > this._private.maxZoom ? this._private.maxZoom : zoom;
            zoom = zoom < this._private.minZoom ? this._private.minZoom : zoom;
            var pan = {
                // now pan to middle
                x: (w - zoom * (bb.x1 + bb.x2)) / 2,
                y: (h - zoom * (bb.y1 + bb.y2)) / 2
            };
            return {
                zoom: zoom,
                pan: pan
            };
        }
        return;
    },
    zoomRange: function zoomRange(min, max) {
        var _p = this._private;
        if (max == null) {
            var opts = min;
            min = opts.min;
            max = opts.max;
        }
        if ($e815fda779bc047b$var$number$1(min) && $e815fda779bc047b$var$number$1(max) && min <= max) {
            _p.minZoom = min;
            _p.maxZoom = max;
        } else if ($e815fda779bc047b$var$number$1(min) && max === undefined && min <= _p.maxZoom) _p.minZoom = min;
        else if ($e815fda779bc047b$var$number$1(max) && min === undefined && max >= _p.minZoom) _p.maxZoom = max;
        return this;
    },
    minZoom: function minZoom(zoom) {
        if (zoom === undefined) return this._private.minZoom;
        else return this.zoomRange({
            min: zoom
        });
    },
    maxZoom: function maxZoom(zoom) {
        if (zoom === undefined) return this._private.maxZoom;
        else return this.zoomRange({
            max: zoom
        });
    },
    getZoomedViewport: function getZoomedViewport(params) {
        var _p = this._private;
        var currentPan = _p.pan;
        var currentZoom = _p.zoom;
        var pos; // in rendered px
        var zoom;
        var bail = false;
        if (!_p.zoomingEnabled) // zooming disabled
        bail = true;
        if ($e815fda779bc047b$var$number$1(params)) // then set the zoom
        zoom = params;
        else if ($e815fda779bc047b$var$plainObject(params)) {
            // then zoom about a point
            zoom = params.level;
            if (params.position != null) pos = $e815fda779bc047b$var$modelToRenderedPosition$1(params.position, currentZoom, currentPan);
            else if (params.renderedPosition != null) pos = params.renderedPosition;
            if (pos != null && !_p.panningEnabled) // panning disabled
            bail = true;
        }
        // crop zoom
        zoom = zoom > _p.maxZoom ? _p.maxZoom : zoom;
        zoom = zoom < _p.minZoom ? _p.minZoom : zoom;
        // can't zoom with invalid params
        if (bail || !$e815fda779bc047b$var$number$1(zoom) || zoom === currentZoom || pos != null && (!$e815fda779bc047b$var$number$1(pos.x) || !$e815fda779bc047b$var$number$1(pos.y))) return null;
        if (pos != null) {
            // set zoom about position
            var pan1 = currentPan;
            var zoom1 = currentZoom;
            var zoom2 = zoom;
            var pan2 = {
                x: -zoom2 / zoom1 * (pos.x - pan1.x) + pos.x,
                y: -zoom2 / zoom1 * (pos.y - pan1.y) + pos.y
            };
            return {
                zoomed: true,
                panned: true,
                zoom: zoom2,
                pan: pan2
            };
        } else // just set the zoom
        return {
            zoomed: true,
            panned: false,
            zoom: zoom,
            pan: currentPan
        };
    },
    zoom: function zoom(params) {
        if (params === undefined) // get
        return this._private.zoom;
        else {
            // set
            var vp = this.getZoomedViewport(params);
            var _p = this._private;
            if (vp == null || !vp.zoomed) return this;
            _p.zoom = vp.zoom;
            if (vp.panned) {
                _p.pan.x = vp.pan.x;
                _p.pan.y = vp.pan.y;
            }
            this.emit('zoom' + (vp.panned ? ' pan' : '') + ' viewport');
            this.notify('viewport');
            return this; // chaining
        }
    },
    viewport: function viewport(opts) {
        var _p = this._private;
        var zoomDefd = true;
        var panDefd = true;
        var events = []; // to trigger
        var zoomFailed = false;
        var panFailed = false;
        if (!opts) return this;
        if (!$e815fda779bc047b$var$number$1(opts.zoom)) zoomDefd = false;
        if (!$e815fda779bc047b$var$plainObject(opts.pan)) panDefd = false;
        if (!zoomDefd && !panDefd) return this;
        if (zoomDefd) {
            var z = opts.zoom;
            if (z < _p.minZoom || z > _p.maxZoom || !_p.zoomingEnabled) zoomFailed = true;
            else {
                _p.zoom = z;
                events.push('zoom');
            }
        }
        if (panDefd && (!zoomFailed || !opts.cancelOnFailedZoom) && _p.panningEnabled) {
            var p = opts.pan;
            if ($e815fda779bc047b$var$number$1(p.x)) {
                _p.pan.x = p.x;
                panFailed = false;
            }
            if ($e815fda779bc047b$var$number$1(p.y)) {
                _p.pan.y = p.y;
                panFailed = false;
            }
            if (!panFailed) events.push('pan');
        }
        if (events.length > 0) {
            events.push('viewport');
            this.emit(events.join(' '));
            this.notify('viewport');
        }
        return this; // chaining
    },
    center: function center(elements) {
        var pan = this.getCenterPan(elements);
        if (pan) {
            this._private.pan = pan;
            this.emit('pan viewport');
            this.notify('viewport');
        }
        return this; // chaining
    },
    getCenterPan: function getCenterPan(elements, zoom) {
        if (!this._private.panningEnabled) return;
        if ($e815fda779bc047b$var$string(elements)) {
            var selector = elements;
            elements = this.mutableElements().filter(selector);
        } else if (!$e815fda779bc047b$var$elementOrCollection(elements)) elements = this.mutableElements();
        if (elements.length === 0) return;
         // can't centre pan to nothing
        var bb = elements.boundingBox();
        var w = this.width();
        var h = this.height();
        zoom = zoom === undefined ? this._private.zoom : zoom;
        var pan = {
            // middle
            x: (w - zoom * (bb.x1 + bb.x2)) / 2,
            y: (h - zoom * (bb.y1 + bb.y2)) / 2
        };
        return pan;
    },
    reset: function reset() {
        if (!this._private.panningEnabled || !this._private.zoomingEnabled) return this;
        this.viewport({
            pan: {
                x: 0,
                y: 0
            },
            zoom: 1
        });
        return this; // chaining
    },
    invalidateSize: function invalidateSize() {
        this._private.sizeCache = null;
    },
    size: function size() {
        var _p = this._private;
        var container = _p.container;
        var cy = this;
        return _p.sizeCache = _p.sizeCache || (container ? function() {
            var style = cy.window().getComputedStyle(container);
            var val = function val(name) {
                return parseFloat(style.getPropertyValue(name));
            };
            return {
                width: container.clientWidth - val('padding-left') - val('padding-right'),
                height: container.clientHeight - val('padding-top') - val('padding-bottom')
            };
        }() : {
            // fallback if no container (not 0 b/c can be used for dividing etc)
            width: 1,
            height: 1
        });
    },
    width: function width() {
        return this.size().width;
    },
    height: function height() {
        return this.size().height;
    },
    extent: function extent() {
        var pan = this._private.pan;
        var zoom = this._private.zoom;
        var rb = this.renderedExtent();
        var b = {
            x1: (rb.x1 - pan.x) / zoom,
            x2: (rb.x2 - pan.x) / zoom,
            y1: (rb.y1 - pan.y) / zoom,
            y2: (rb.y2 - pan.y) / zoom
        };
        b.w = b.x2 - b.x1;
        b.h = b.y2 - b.y1;
        return b;
    },
    renderedExtent: function renderedExtent() {
        var width = this.width();
        var height = this.height();
        return {
            x1: 0,
            y1: 0,
            x2: width,
            y2: height,
            w: width,
            h: height
        };
    },
    multiClickDebounceTime: function multiClickDebounceTime(_int) {
        if (_int) this._private.multiClickDebounceTime = _int;
        else return this._private.multiClickDebounceTime;
        return this; // chaining
    }
};
// aliases
$e815fda779bc047b$var$corefn$1.centre = $e815fda779bc047b$var$corefn$1.center;
// backwards compatibility
$e815fda779bc047b$var$corefn$1.autolockNodes = $e815fda779bc047b$var$corefn$1.autolock;
$e815fda779bc047b$var$corefn$1.autoungrabifyNodes = $e815fda779bc047b$var$corefn$1.autoungrabify;
var $e815fda779bc047b$var$fn = {
    data: $e815fda779bc047b$var$define.data({
        field: 'data',
        bindingEvent: 'data',
        allowBinding: true,
        allowSetting: true,
        settingEvent: 'data',
        settingTriggersEvent: true,
        triggerFnName: 'trigger',
        allowGetting: true,
        updateStyle: true
    }),
    removeData: $e815fda779bc047b$var$define.removeData({
        field: 'data',
        event: 'data',
        triggerFnName: 'trigger',
        triggerEvent: true,
        updateStyle: true
    }),
    scratch: $e815fda779bc047b$var$define.data({
        field: 'scratch',
        bindingEvent: 'scratch',
        allowBinding: true,
        allowSetting: true,
        settingEvent: 'scratch',
        settingTriggersEvent: true,
        triggerFnName: 'trigger',
        allowGetting: true,
        updateStyle: true
    }),
    removeScratch: $e815fda779bc047b$var$define.removeData({
        field: 'scratch',
        event: 'scratch',
        triggerFnName: 'trigger',
        triggerEvent: true,
        updateStyle: true
    })
};
// aliases
$e815fda779bc047b$var$fn.attr = $e815fda779bc047b$var$fn.data;
$e815fda779bc047b$var$fn.removeAttr = $e815fda779bc047b$var$fn.removeData;
var $e815fda779bc047b$var$Core = function Core(opts) {
    var cy = this;
    opts = $e815fda779bc047b$var$extend({}, opts);
    var container = opts.container;
    // allow for passing a wrapped jquery object
    // e.g. cytoscape({ container: $('#cy') })
    if (container && !$e815fda779bc047b$var$htmlElement(container) && $e815fda779bc047b$var$htmlElement(container[0])) container = container[0];
    var reg = container ? container._cyreg : null; // e.g. already registered some info (e.g. readies) via jquery
    reg = reg || {};
    if (reg && reg.cy) {
        reg.cy.destroy();
        reg = {}; // old instance => replace reg completely
    }
    var readies = reg.readies = reg.readies || [];
    if (container) container._cyreg = reg;
     // make sure container assoc'd reg points to this cy
    reg.cy = cy;
    var head = $e815fda779bc047b$var$_window !== undefined && container !== undefined && !opts.headless;
    var options = opts;
    options.layout = $e815fda779bc047b$var$extend({
        name: head ? 'grid' : 'null'
    }, options.layout);
    options.renderer = $e815fda779bc047b$var$extend({
        name: head ? 'canvas' : 'null'
    }, options.renderer);
    var defVal = function defVal(def, val, altVal) {
        if (val !== undefined) return val;
        else if (altVal !== undefined) return altVal;
        else return def;
    };
    var _p = this._private = {
        container: container,
        // html dom ele container
        ready: false,
        // whether ready has been triggered
        options: options,
        // cached options
        elements: new $e815fda779bc047b$var$Collection(this),
        // elements in the graph
        listeners: [],
        // list of listeners
        aniEles: new $e815fda779bc047b$var$Collection(this),
        // elements being animated
        data: options.data || {},
        // data for the core
        scratch: {},
        // scratch object for core
        layout: null,
        renderer: null,
        destroyed: false,
        // whether destroy was called
        notificationsEnabled: true,
        // whether notifications are sent to the renderer
        minZoom: 1e-50,
        maxZoom: 1e50,
        zoomingEnabled: defVal(true, options.zoomingEnabled),
        userZoomingEnabled: defVal(true, options.userZoomingEnabled),
        panningEnabled: defVal(true, options.panningEnabled),
        userPanningEnabled: defVal(true, options.userPanningEnabled),
        boxSelectionEnabled: defVal(true, options.boxSelectionEnabled),
        autolock: defVal(false, options.autolock, options.autolockNodes),
        autoungrabify: defVal(false, options.autoungrabify, options.autoungrabifyNodes),
        autounselectify: defVal(false, options.autounselectify),
        styleEnabled: options.styleEnabled === undefined ? head : options.styleEnabled,
        zoom: $e815fda779bc047b$var$number$1(options.zoom) ? options.zoom : 1,
        pan: {
            x: $e815fda779bc047b$var$plainObject(options.pan) && $e815fda779bc047b$var$number$1(options.pan.x) ? options.pan.x : 0,
            y: $e815fda779bc047b$var$plainObject(options.pan) && $e815fda779bc047b$var$number$1(options.pan.y) ? options.pan.y : 0
        },
        animation: {
            // object for currently-running animations
            current: [],
            queue: []
        },
        hasCompoundNodes: false,
        multiClickDebounceTime: defVal(250, options.multiClickDebounceTime)
    };
    this.createEmitter();
    // set selection type
    this.selectionType(options.selectionType);
    // init zoom bounds
    this.zoomRange({
        min: options.minZoom,
        max: options.maxZoom
    });
    var loadExtData = function loadExtData(extData, next) {
        var anyIsPromise = extData.some($e815fda779bc047b$var$promise);
        if (anyIsPromise) return $e815fda779bc047b$var$Promise$1.all(extData).then(next); // load all data asynchronously, then exec rest of init
        else next(extData); // exec synchronously for convenience
    };
    // start with the default stylesheet so we have something before loading an external stylesheet
    if (_p.styleEnabled) cy.setStyle([]);
    // create the renderer
    var rendererOptions = $e815fda779bc047b$var$extend({}, options, options.renderer); // allow rendering hints in top level options
    cy.initRenderer(rendererOptions);
    var setElesAndLayout = function setElesAndLayout(elements, onload, ondone) {
        cy.notifications(false);
        // remove old elements
        var oldEles = cy.mutableElements();
        if (oldEles.length > 0) oldEles.remove();
        if (elements != null) {
            if ($e815fda779bc047b$var$plainObject(elements) || $e815fda779bc047b$var$array(elements)) cy.add(elements);
        }
        cy.one('layoutready', function(e) {
            cy.notifications(true);
            cy.emit(e); // we missed this event by turning notifications off, so pass it on
            cy.one('load', onload);
            cy.emitAndNotify('load');
        }).one('layoutstop', function() {
            cy.one('done', ondone);
            cy.emit('done');
        });
        var layoutOpts = $e815fda779bc047b$var$extend({}, cy._private.options.layout);
        layoutOpts.eles = cy.elements();
        cy.layout(layoutOpts).run();
    };
    loadExtData([
        options.style,
        options.elements
    ], function(thens) {
        var initStyle = thens[0];
        var initEles = thens[1];
        // init style
        if (_p.styleEnabled) cy.style().append(initStyle);
        // initial load
        setElesAndLayout(initEles, function() {
            // onready
            cy.startAnimationLoop();
            _p.ready = true;
            // if a ready callback is specified as an option, the bind it
            if ($e815fda779bc047b$var$fn$6(options.ready)) cy.on('ready', options.ready);
            // bind all the ready handlers registered before creating this instance
            for(var i = 0; i < readies.length; i++){
                var fn = readies[i];
                cy.on('ready', fn);
            }
            if (reg) reg.readies = [];
             // clear b/c we've bound them all and don't want to keep it around in case a new core uses the same div etc
            cy.emit('ready');
        }, options.done);
    });
};
var $e815fda779bc047b$var$corefn = $e815fda779bc047b$var$Core.prototype; // short alias
$e815fda779bc047b$var$extend($e815fda779bc047b$var$corefn, {
    instanceString: function instanceString() {
        return 'core';
    },
    isReady: function isReady() {
        return this._private.ready;
    },
    destroyed: function destroyed() {
        return this._private.destroyed;
    },
    ready: function ready(fn) {
        if (this.isReady()) this.emitter().emit('ready', [], fn); // just calls fn as though triggered via ready event
        else this.on('ready', fn);
        return this;
    },
    destroy: function destroy() {
        var cy = this;
        if (cy.destroyed()) return;
        cy.stopAnimationLoop();
        cy.destroyRenderer();
        this.emit('destroy');
        cy._private.destroyed = true;
        return cy;
    },
    hasElementWithId: function hasElementWithId(id) {
        return this._private.elements.hasElementWithId(id);
    },
    getElementById: function getElementById(id) {
        return this._private.elements.getElementById(id);
    },
    hasCompoundNodes: function hasCompoundNodes() {
        return this._private.hasCompoundNodes;
    },
    headless: function headless() {
        return this._private.renderer.isHeadless();
    },
    styleEnabled: function styleEnabled() {
        return this._private.styleEnabled;
    },
    addToPool: function addToPool(eles) {
        this._private.elements.merge(eles);
        return this; // chaining
    },
    removeFromPool: function removeFromPool(eles) {
        this._private.elements.unmerge(eles);
        return this;
    },
    container: function container() {
        return this._private.container || null;
    },
    window: function window1() {
        var container = this._private.container;
        if (container == null) return $e815fda779bc047b$var$_window;
        var ownerDocument = this._private.container.ownerDocument;
        if (ownerDocument === undefined || ownerDocument == null) return $e815fda779bc047b$var$_window;
        return ownerDocument.defaultView || $e815fda779bc047b$var$_window;
    },
    mount: function mount(container) {
        if (container == null) return;
        var cy = this;
        var _p = cy._private;
        var options = _p.options;
        if (!$e815fda779bc047b$var$htmlElement(container) && $e815fda779bc047b$var$htmlElement(container[0])) container = container[0];
        cy.stopAnimationLoop();
        cy.destroyRenderer();
        _p.container = container;
        _p.styleEnabled = true;
        cy.invalidateSize();
        cy.initRenderer($e815fda779bc047b$var$extend({}, options, options.renderer, {
            // allow custom renderer name to be re-used, otherwise use canvas
            name: options.renderer.name === 'null' ? 'canvas' : options.renderer.name
        }));
        cy.startAnimationLoop();
        cy.style(options.style);
        cy.emit('mount');
        return cy;
    },
    unmount: function unmount() {
        var cy = this;
        cy.stopAnimationLoop();
        cy.destroyRenderer();
        cy.initRenderer({
            name: 'null'
        });
        cy.emit('unmount');
        return cy;
    },
    options: function options() {
        return $e815fda779bc047b$var$copy(this._private.options);
    },
    json: function json(obj) {
        var cy = this;
        var _p = cy._private;
        var eles = cy.mutableElements();
        var getFreshRef = function getFreshRef(ele) {
            return cy.getElementById(ele.id());
        };
        if ($e815fda779bc047b$var$plainObject(obj)) {
            // set
            cy.startBatch();
            if (obj.elements) {
                var idInJson = {};
                var updateEles = function updateEles(jsons, gr) {
                    var toAdd = [];
                    var toMod = [];
                    for(var i = 0; i < jsons.length; i++){
                        var json = jsons[i];
                        if (!json.data.id) {
                            $e815fda779bc047b$var$warn('cy.json() cannot handle elements without an ID attribute');
                            continue;
                        }
                        var id = '' + json.data.id; // id must be string
                        var ele = cy.getElementById(id);
                        idInJson[id] = true;
                        if (ele.length !== 0) // existing element should be updated
                        toMod.push({
                            ele: ele,
                            json: json
                        });
                        else // otherwise should be added
                        if (gr) {
                            json.group = gr;
                            toAdd.push(json);
                        } else toAdd.push(json);
                    }
                    cy.add(toAdd);
                    for(var _i = 0; _i < toMod.length; _i++){
                        var _toMod$_i = toMod[_i], _ele = _toMod$_i.ele, _json = _toMod$_i.json;
                        _ele.json(_json);
                    }
                };
                if ($e815fda779bc047b$var$array(obj.elements)) // elements: []
                updateEles(obj.elements);
                else {
                    // elements: { nodes: [], edges: [] }
                    var grs = [
                        'nodes',
                        'edges'
                    ];
                    for(var i = 0; i < grs.length; i++){
                        var gr = grs[i];
                        var elements = obj.elements[gr];
                        if ($e815fda779bc047b$var$array(elements)) updateEles(elements, gr);
                    }
                }
                var parentsToRemove = cy.collection();
                eles.filter(function(ele) {
                    return !idInJson[ele.id()];
                }).forEach(function(ele) {
                    if (ele.isParent()) parentsToRemove.merge(ele);
                    else ele.remove();
                });
                // so that children are not removed w/parent
                parentsToRemove.forEach(function(ele) {
                    return ele.children().move({
                        parent: null
                    });
                });
                // intermediate parents may be moved by prior line, so make sure we remove by fresh refs
                parentsToRemove.forEach(function(ele) {
                    return getFreshRef(ele).remove();
                });
            }
            if (obj.style) cy.style(obj.style);
            if (obj.zoom != null && obj.zoom !== _p.zoom) cy.zoom(obj.zoom);
            if (obj.pan) {
                if (obj.pan.x !== _p.pan.x || obj.pan.y !== _p.pan.y) cy.pan(obj.pan);
            }
            if (obj.data) cy.data(obj.data);
            var fields = [
                'minZoom',
                'maxZoom',
                'zoomingEnabled',
                'userZoomingEnabled',
                'panningEnabled',
                'userPanningEnabled',
                'boxSelectionEnabled',
                'autolock',
                'autoungrabify',
                'autounselectify',
                'multiClickDebounceTime'
            ];
            for(var _i2 = 0; _i2 < fields.length; _i2++){
                var f = fields[_i2];
                if (obj[f] != null) cy[f](obj[f]);
            }
            cy.endBatch();
            return this; // chaining
        } else {
            // get
            var flat = !!obj;
            var json = {};
            if (flat) json.elements = this.elements().map(function(ele) {
                return ele.json();
            });
            else {
                json.elements = {};
                eles.forEach(function(ele) {
                    var group = ele.group();
                    if (!json.elements[group]) json.elements[group] = [];
                    json.elements[group].push(ele.json());
                });
            }
            if (this._private.styleEnabled) json.style = cy.style().json();
            json.data = $e815fda779bc047b$var$copy(cy.data());
            var options = _p.options;
            json.zoomingEnabled = _p.zoomingEnabled;
            json.userZoomingEnabled = _p.userZoomingEnabled;
            json.zoom = _p.zoom;
            json.minZoom = _p.minZoom;
            json.maxZoom = _p.maxZoom;
            json.panningEnabled = _p.panningEnabled;
            json.userPanningEnabled = _p.userPanningEnabled;
            json.pan = $e815fda779bc047b$var$copy(_p.pan);
            json.boxSelectionEnabled = _p.boxSelectionEnabled;
            json.renderer = $e815fda779bc047b$var$copy(options.renderer);
            json.hideEdgesOnViewport = options.hideEdgesOnViewport;
            json.textureOnViewport = options.textureOnViewport;
            json.wheelSensitivity = options.wheelSensitivity;
            json.motionBlur = options.motionBlur;
            json.multiClickDebounceTime = options.multiClickDebounceTime;
            return json;
        }
    }
});
$e815fda779bc047b$var$corefn.$id = $e815fda779bc047b$var$corefn.getElementById;
[
    $e815fda779bc047b$var$corefn$9,
    $e815fda779bc047b$var$corefn$8,
    $e815fda779bc047b$var$elesfn,
    $e815fda779bc047b$var$corefn$7,
    $e815fda779bc047b$var$corefn$6,
    $e815fda779bc047b$var$corefn$5,
    $e815fda779bc047b$var$corefn$4,
    $e815fda779bc047b$var$corefn$3,
    $e815fda779bc047b$var$corefn$2,
    $e815fda779bc047b$var$corefn$1,
    $e815fda779bc047b$var$fn
].forEach(function(props) {
    $e815fda779bc047b$var$extend($e815fda779bc047b$var$corefn, props);
});
/* eslint-disable no-unused-vars */ var $e815fda779bc047b$var$defaults$7 = {
    fit: true,
    // whether to fit the viewport to the graph
    directed: false,
    // whether the tree is directed downwards (or edges can point in any direction if false)
    direction: 'downward',
    // determines the direction in which the tree structure is drawn.  The possible values are 'downward', 'upward', 'rightward', or 'leftward'.
    padding: 30,
    // padding on fit
    circle: false,
    // put depths in concentric circles if true, put depths top down if false
    grid: false,
    // whether to create an even grid into which the DAG is placed (circle:false only)
    spacingFactor: 1.75,
    // positive spacing factor, larger => more space between nodes (N.B. n/a if causes overlap)
    boundingBox: undefined,
    // constrain layout bounds; { x1, y1, x2, y2 } or { x1, y1, w, h }
    avoidOverlap: true,
    // prevents node overlap, may overflow boundingBox if not enough space
    nodeDimensionsIncludeLabels: false,
    // Excludes the label when calculating node bounding boxes for the layout algorithm
    roots: undefined,
    // the roots of the trees
    depthSort: undefined,
    // a sorting function to order nodes at equal depth. e.g. function(a, b){ return a.data('weight') - b.data('weight') }
    animate: false,
    // whether to transition the node positions
    animationDuration: 500,
    // duration of animation in ms if enabled
    animationEasing: undefined,
    // easing of animation if enabled,
    animateFilter: function animateFilter(node, i) {
        return true;
    },
    // a function that determines whether the node should be animated.  All nodes animated by default on animate enabled.  Non-animated nodes are positioned immediately when the layout starts
    ready: undefined,
    // callback on layoutready
    stop: undefined,
    // callback on layoutstop
    transform: function transform(node, position) {
        return position;
    } // transform a given node position. Useful for changing flow direction in discrete layouts
};
var $e815fda779bc047b$var$deprecatedOptionDefaults = {
    maximal: false,
    // whether to shift nodes down their natural BFS depths in order to avoid upwards edges (DAGS only); setting acyclic to true sets maximal to true also
    acyclic: false // whether the tree is acyclic and thus a node could be shifted (due to the maximal option) multiple times without causing an infinite loop; setting to true sets maximal to true also; if you are uncertain whether a tree is acyclic, set to false to avoid potential infinite loops
};
/* eslint-enable */ var $e815fda779bc047b$var$getInfo = function getInfo(ele) {
    return ele.scratch('breadthfirst');
};
var $e815fda779bc047b$var$setInfo = function setInfo(ele, obj) {
    return ele.scratch('breadthfirst', obj);
};
function $e815fda779bc047b$var$BreadthFirstLayout(options) {
    this.options = $e815fda779bc047b$var$extend({}, $e815fda779bc047b$var$defaults$7, $e815fda779bc047b$var$deprecatedOptionDefaults, options);
}
$e815fda779bc047b$var$BreadthFirstLayout.prototype.run = function() {
    var options = this.options;
    var cy = options.cy;
    var eles = options.eles;
    var nodes = eles.nodes().filter(function(n) {
        return n.isChildless();
    });
    var graph = eles;
    var directed = options.directed;
    var maximal = options.acyclic || options.maximal || options.maximalAdjustments > 0; // maximalAdjustments for compat. w/ old code; also, setting acyclic to true sets maximal to true
    var hasBoundingBox = !!options.boundingBox;
    var bb = $e815fda779bc047b$var$makeBoundingBox(hasBoundingBox ? options.boundingBox : structuredClone(cy.extent()));
    var roots;
    if ($e815fda779bc047b$var$elementOrCollection(options.roots)) roots = options.roots;
    else if ($e815fda779bc047b$var$array(options.roots)) {
        var rootsArray = [];
        for(var i = 0; i < options.roots.length; i++){
            var id = options.roots[i];
            var ele = cy.getElementById(id);
            rootsArray.push(ele);
        }
        roots = cy.collection(rootsArray);
    } else if ($e815fda779bc047b$var$string(options.roots)) roots = cy.$(options.roots);
    else if (directed) roots = nodes.roots();
    else {
        var components = eles.components();
        roots = cy.collection();
        var _loop = function _loop() {
            var comp = components[_i];
            var maxDegree = comp.maxDegree(false);
            var compRoots = comp.filter(function(ele) {
                return ele.degree(false) === maxDegree;
            });
            roots = roots.add(compRoots);
        };
        for(var _i = 0; _i < components.length; _i++)_loop();
    }
    var depths = [];
    var foundByBfs = {};
    var addToDepth = function addToDepth(ele, d) {
        if (depths[d] == null) depths[d] = [];
        var i = depths[d].length;
        depths[d].push(ele);
        $e815fda779bc047b$var$setInfo(ele, {
            index: i,
            depth: d
        });
    };
    var changeDepth = function changeDepth(ele, newDepth) {
        var _getInfo = $e815fda779bc047b$var$getInfo(ele), depth = _getInfo.depth, index = _getInfo.index;
        depths[depth][index] = null;
        // add only childless nodes
        if (ele.isChildless()) addToDepth(ele, newDepth);
    };
    // find the depths of the nodes
    graph.bfs({
        roots: roots,
        directed: options.directed,
        visit: function visit(node, edge, pNode, i, depth) {
            var ele = node[0];
            var id = ele.id();
            // add only childless nodes
            if (ele.isChildless()) addToDepth(ele, depth);
            foundByBfs[id] = true;
        }
    });
    // check for nodes not found by bfs
    var orphanNodes = [];
    for(var _i2 = 0; _i2 < nodes.length; _i2++){
        var _ele = nodes[_i2];
        if (foundByBfs[_ele.id()]) continue;
        else orphanNodes.push(_ele);
    }
    // assign the nodes a depth and index
    var assignDepthsAt = function assignDepthsAt(i) {
        var eles = depths[i];
        for(var j = 0; j < eles.length; j++){
            var _ele2 = eles[j];
            if (_ele2 == null) {
                eles.splice(j, 1);
                j--;
                continue;
            }
            $e815fda779bc047b$var$setInfo(_ele2, {
                depth: i,
                index: j
            });
        }
    };
    var adjustMaximally = function adjustMaximally(ele, shifted) {
        var eInfo = $e815fda779bc047b$var$getInfo(ele);
        var incomers = ele.incomers().filter(function(el) {
            return el.isNode() && eles.has(el);
        });
        var maxDepth = -1;
        var id = ele.id();
        for(var k = 0; k < incomers.length; k++){
            var incmr = incomers[k];
            var iInfo = $e815fda779bc047b$var$getInfo(incmr);
            maxDepth = Math.max(maxDepth, iInfo.depth);
        }
        if (eInfo.depth <= maxDepth) {
            if (!options.acyclic && shifted[id]) return null;
            var newDepth = maxDepth + 1;
            changeDepth(ele, newDepth);
            shifted[id] = newDepth;
            return true;
        }
        return false;
    };
    // for the directed case, try to make the edges all go down (i.e. depth i => depth i + 1)
    if (directed && maximal) {
        var Q = [];
        var shifted = {};
        var enqueue = function enqueue(n) {
            return Q.push(n);
        };
        var dequeue = function dequeue() {
            return Q.shift();
        };
        nodes.forEach(function(n) {
            return Q.push(n);
        });
        while(Q.length > 0){
            var _ele3 = dequeue();
            var didShift = adjustMaximally(_ele3, shifted);
            if (didShift) _ele3.outgoers().filter(function(el) {
                return el.isNode() && eles.has(el);
            }).forEach(enqueue);
            else if (didShift === null) {
                $e815fda779bc047b$var$warn('Detected double maximal shift for node `' + _ele3.id() + '`.  Bailing maximal adjustment due to cycle.  Use `options.maximal: true` only on DAGs.');
                break; // exit on failure
            }
        }
    }
    // find min distance we need to leave between nodes
    var minDistance = 0;
    if (options.avoidOverlap) for(var _i3 = 0; _i3 < nodes.length; _i3++){
        var n = nodes[_i3];
        var nbb = n.layoutDimensions(options);
        var w = nbb.w;
        var h = nbb.h;
        minDistance = Math.max(minDistance, w, h);
    }
    // get the weighted percent for an element based on its connectivity to other levels
    var cachedWeightedPercent = {};
    var getWeightedPercent = function getWeightedPercent(ele) {
        if (cachedWeightedPercent[ele.id()]) return cachedWeightedPercent[ele.id()];
        var eleDepth = $e815fda779bc047b$var$getInfo(ele).depth;
        var neighbors = ele.neighborhood();
        var percent = 0;
        var samples = 0;
        for(var _i4 = 0; _i4 < neighbors.length; _i4++){
            var neighbor = neighbors[_i4];
            if (neighbor.isEdge() || neighbor.isParent() || !nodes.has(neighbor)) continue;
            var bf = $e815fda779bc047b$var$getInfo(neighbor);
            if (bf == null) continue;
            var index = bf.index;
            var depth = bf.depth;
            // unassigned neighbours shouldn't affect the ordering
            if (index == null || depth == null) continue;
            var nDepth = depths[depth].length;
            if (depth < eleDepth) {
                // only get influenced by elements above
                percent += index / nDepth;
                samples++;
            }
        }
        samples = Math.max(1, samples);
        percent = percent / samples;
        if (samples === 0) // put lone nodes at the start
        percent = 0;
        cachedWeightedPercent[ele.id()] = percent;
        return percent;
    };
    // rearrange the indices in each depth level based on connectivity
    var sortFn = function sortFn(a, b) {
        var apct = getWeightedPercent(a);
        var bpct = getWeightedPercent(b);
        var diff = apct - bpct;
        if (diff === 0) return $e815fda779bc047b$var$ascending(a.id(), b.id()); // make sure sort doesn't have don't-care comparisons
        else return diff;
    };
    if (options.depthSort !== undefined) sortFn = options.depthSort;
    var depthsLen = depths.length;
    // sort each level to make connected nodes closer
    for(var _i5 = 0; _i5 < depthsLen; _i5++){
        depths[_i5].sort(sortFn);
        assignDepthsAt(_i5);
    }
    // assign orphan nodes to a new top-level depth
    var orphanDepth = [];
    for(var _i6 = 0; _i6 < orphanNodes.length; _i6++)orphanDepth.push(orphanNodes[_i6]);
    var assignDepths = function assignDepths() {
        for(var _i7 = 0; _i7 < depthsLen; _i7++)assignDepthsAt(_i7);
    };
    // add a new top-level depth only when there are orphan nodes
    if (orphanDepth.length) {
        depths.unshift(orphanDepth);
        depthsLen = depths.length;
        assignDepths();
    }
    var biggestDepthSize = 0;
    for(var _i8 = 0; _i8 < depthsLen; _i8++)biggestDepthSize = Math.max(depths[_i8].length, biggestDepthSize);
    var center = {
        x: bb.x1 + bb.w / 2,
        y: bb.y1 + bb.h / 2
    };
    // average node size
    var aveNodeSize = nodes.reduce(function(acc, node) {
        return function(box) {
            return {
                w: acc.w === -1 ? box.w : (acc.w + box.w) / 2,
                h: acc.h === -1 ? box.h : (acc.h + box.h) / 2
            };
        }(node.boundingBox({
            includeLabels: options.nodeDimensionsIncludeLabels
        }));
    }, {
        w: -1,
        h: -1
    });
    var distanceY = Math.max(// only one depth
    depthsLen === 1 ? 0 : // inside a bounding box, no need for top & bottom padding
    hasBoundingBox ? (bb.h - options.padding * 2 - aveNodeSize.h) / (depthsLen - 1) : (bb.h - options.padding * 2 - aveNodeSize.h) / (depthsLen + 1), minDistance);
    var maxDepthSize = depths.reduce(function(max, eles) {
        return Math.max(max, eles.length);
    }, 0);
    var getPositionTopBottom = function getPositionTopBottom(ele) {
        var _getInfo2 = $e815fda779bc047b$var$getInfo(ele), depth = _getInfo2.depth, index = _getInfo2.index;
        if (options.circle) {
            var radiusStepSize = Math.min(bb.w / 2 / depthsLen, bb.h / 2 / depthsLen);
            radiusStepSize = Math.max(radiusStepSize, minDistance);
            var radius = radiusStepSize * depth + radiusStepSize - (depthsLen > 0 && depths[0].length <= 3 ? radiusStepSize / 2 : 0);
            var theta = 2 * Math.PI / depths[depth].length * index;
            if (depth === 0 && depths[0].length === 1) radius = 1;
            return {
                x: center.x + radius * Math.cos(theta),
                y: center.y + radius * Math.sin(theta)
            };
        } else {
            var depthSize = depths[depth].length;
            var distanceX = Math.max(// only one depth
            depthSize === 1 ? 0 : // inside a bounding box, no need for left & right padding
            hasBoundingBox ? (bb.w - options.padding * 2 - aveNodeSize.w) / ((options.grid ? maxDepthSize : depthSize) - 1) : (bb.w - options.padding * 2 - aveNodeSize.w) / ((options.grid ? maxDepthSize : depthSize) + 1), minDistance);
            var epos = {
                x: center.x + (index + 1 - (depthSize + 1) / 2) * distanceX,
                y: center.y + (depth + 1 - (depthsLen + 1) / 2) * distanceY
            };
            return epos;
        }
    };
    var rotateDegrees = {
        'downward': 0,
        'leftward': 90,
        'upward': 180,
        'rightward': -90
    };
    if (Object.keys(rotateDegrees).indexOf(options.direction) === -1) $e815fda779bc047b$var$error("Invalid direction '".concat(options.direction, "' specified for breadthfirst layout. Valid values are: ").concat(Object.keys(rotateDegrees).join(', ')));
    var getPosition = function getPosition(ele) {
        return $e815fda779bc047b$var$rotatePosAndSkewByBox(getPositionTopBottom(ele), bb, rotateDegrees[options.direction]);
    };
    eles.nodes().layoutPositions(this, options, getPosition);
    return this; // chaining
};
var $e815fda779bc047b$var$defaults$6 = {
    fit: true,
    // whether to fit the viewport to the graph
    padding: 30,
    // the padding on fit
    boundingBox: undefined,
    // constrain layout bounds; { x1, y1, x2, y2 } or { x1, y1, w, h }
    avoidOverlap: true,
    // prevents node overlap, may overflow boundingBox and radius if not enough space
    nodeDimensionsIncludeLabels: false,
    // Excludes the label when calculating node bounding boxes for the layout algorithm
    spacingFactor: undefined,
    // Applies a multiplicative factor (>0) to expand or compress the overall area that the nodes take up
    radius: undefined,
    // the radius of the circle
    startAngle: 1.5 * Math.PI,
    // where nodes start in radians
    sweep: undefined,
    // how many radians should be between the first and last node (defaults to full circle)
    clockwise: true,
    // whether the layout should go clockwise (true) or counterclockwise/anticlockwise (false)
    sort: undefined,
    // a sorting function to order the nodes; e.g. function(a, b){ return a.data('weight') - b.data('weight') }
    animate: false,
    // whether to transition the node positions
    animationDuration: 500,
    // duration of animation in ms if enabled
    animationEasing: undefined,
    // easing of animation if enabled
    animateFilter: function animateFilter(node, i) {
        return true;
    },
    // a function that determines whether the node should be animated.  All nodes animated by default on animate enabled.  Non-animated nodes are positioned immediately when the layout starts
    ready: undefined,
    // callback on layoutready
    stop: undefined,
    // callback on layoutstop
    transform: function transform(node, position) {
        return position;
    } // transform a given node position. Useful for changing flow direction in discrete layouts 
};
function $e815fda779bc047b$var$CircleLayout(options) {
    this.options = $e815fda779bc047b$var$extend({}, $e815fda779bc047b$var$defaults$6, options);
}
$e815fda779bc047b$var$CircleLayout.prototype.run = function() {
    var params = this.options;
    var options = params;
    var cy = params.cy;
    var eles = options.eles;
    var clockwise = options.counterclockwise !== undefined ? !options.counterclockwise : options.clockwise;
    var nodes = eles.nodes().not(':parent');
    if (options.sort) nodes = nodes.sort(options.sort);
    var bb = $e815fda779bc047b$var$makeBoundingBox(options.boundingBox ? options.boundingBox : {
        x1: 0,
        y1: 0,
        w: cy.width(),
        h: cy.height()
    });
    var center = {
        x: bb.x1 + bb.w / 2,
        y: bb.y1 + bb.h / 2
    };
    var sweep = options.sweep === undefined ? 2 * Math.PI - 2 * Math.PI / nodes.length : options.sweep;
    var dTheta = sweep / Math.max(1, nodes.length - 1);
    var r;
    var minDistance = 0;
    for(var i = 0; i < nodes.length; i++){
        var n = nodes[i];
        var nbb = n.layoutDimensions(options);
        var w = nbb.w;
        var h = nbb.h;
        minDistance = Math.max(minDistance, w, h);
    }
    if ($e815fda779bc047b$var$number$1(options.radius)) r = options.radius;
    else if (nodes.length <= 1) r = 0;
    else r = Math.min(bb.h, bb.w) / 2 - minDistance;
    // calculate the radius
    if (nodes.length > 1 && options.avoidOverlap) {
        // but only if more than one node (can't overlap)
        minDistance *= 1.75; // just to have some nice spacing
        var dcos = Math.cos(dTheta) - Math.cos(0);
        var dsin = Math.sin(dTheta) - Math.sin(0);
        var rMin = Math.sqrt(minDistance * minDistance / (dcos * dcos + dsin * dsin)); // s.t. no nodes overlapping
        r = Math.max(rMin, r);
    }
    var getPos = function getPos(ele, i) {
        var theta = options.startAngle + i * dTheta * (clockwise ? 1 : -1);
        var rx = r * Math.cos(theta);
        var ry = r * Math.sin(theta);
        var pos = {
            x: center.x + rx,
            y: center.y + ry
        };
        return pos;
    };
    eles.nodes().layoutPositions(this, options, getPos);
    return this; // chaining
};
var $e815fda779bc047b$var$defaults$5 = {
    fit: true,
    // whether to fit the viewport to the graph
    padding: 30,
    // the padding on fit
    startAngle: 1.5 * Math.PI,
    // where nodes start in radians
    sweep: undefined,
    // how many radians should be between the first and last node (defaults to full circle)
    clockwise: true,
    // whether the layout should go clockwise (true) or counterclockwise/anticlockwise (false)
    equidistant: false,
    // whether levels have an equal radial distance betwen them, may cause bounding box overflow
    minNodeSpacing: 10,
    // min spacing between outside of nodes (used for radius adjustment)
    boundingBox: undefined,
    // constrain layout bounds; { x1, y1, x2, y2 } or { x1, y1, w, h }
    avoidOverlap: true,
    // prevents node overlap, may overflow boundingBox if not enough space
    nodeDimensionsIncludeLabels: false,
    // Excludes the label when calculating node bounding boxes for the layout algorithm
    height: undefined,
    // height of layout area (overrides container height)
    width: undefined,
    // width of layout area (overrides container width)
    spacingFactor: undefined,
    // Applies a multiplicative factor (>0) to expand or compress the overall area that the nodes take up
    concentric: function concentric(node) {
        // returns numeric value for each node, placing higher nodes in levels towards the centre
        return node.degree();
    },
    levelWidth: function levelWidth(nodes) {
        // the variation of concentric values in each level
        return nodes.maxDegree() / 4;
    },
    animate: false,
    // whether to transition the node positions
    animationDuration: 500,
    // duration of animation in ms if enabled
    animationEasing: undefined,
    // easing of animation if enabled
    animateFilter: function animateFilter(node, i) {
        return true;
    },
    // a function that determines whether the node should be animated.  All nodes animated by default on animate enabled.  Non-animated nodes are positioned immediately when the layout starts
    ready: undefined,
    // callback on layoutready
    stop: undefined,
    // callback on layoutstop
    transform: function transform(node, position) {
        return position;
    } // transform a given node position. Useful for changing flow direction in discrete layouts
};
function $e815fda779bc047b$var$ConcentricLayout(options) {
    this.options = $e815fda779bc047b$var$extend({}, $e815fda779bc047b$var$defaults$5, options);
}
$e815fda779bc047b$var$ConcentricLayout.prototype.run = function() {
    var params = this.options;
    var options = params;
    var clockwise = options.counterclockwise !== undefined ? !options.counterclockwise : options.clockwise;
    var cy = params.cy;
    var eles = options.eles;
    var nodes = eles.nodes().not(':parent');
    var bb = $e815fda779bc047b$var$makeBoundingBox(options.boundingBox ? options.boundingBox : {
        x1: 0,
        y1: 0,
        w: cy.width(),
        h: cy.height()
    });
    var center = {
        x: bb.x1 + bb.w / 2,
        y: bb.y1 + bb.h / 2
    };
    var nodeValues = []; // { node, value }
    var maxNodeSize = 0;
    for(var i = 0; i < nodes.length; i++){
        var node = nodes[i];
        var value = undefined;
        // calculate the node value
        value = options.concentric(node);
        nodeValues.push({
            value: value,
            node: node
        });
        // for style mapping
        node._private.scratch.concentric = value;
    }
    // in case we used the `concentric` in style
    nodes.updateStyle();
    // calculate max size now based on potentially updated mappers
    for(var _i = 0; _i < nodes.length; _i++){
        var _node = nodes[_i];
        var nbb = _node.layoutDimensions(options);
        maxNodeSize = Math.max(maxNodeSize, nbb.w, nbb.h);
    }
    // sort node values in descreasing order
    nodeValues.sort(function(a, b) {
        return b.value - a.value;
    });
    var levelWidth = options.levelWidth(nodes);
    // put the values into levels
    var levels = [
        []
    ];
    var currentLevel = levels[0];
    for(var _i2 = 0; _i2 < nodeValues.length; _i2++){
        var val = nodeValues[_i2];
        if (currentLevel.length > 0) {
            var diff = Math.abs(currentLevel[0].value - val.value);
            if (diff >= levelWidth) {
                currentLevel = [];
                levels.push(currentLevel);
            }
        }
        currentLevel.push(val);
    }
    // create positions from levels
    var minDist = maxNodeSize + options.minNodeSpacing; // min dist between nodes
    if (!options.avoidOverlap) {
        // then strictly constrain to bb
        var firstLvlHasMulti = levels.length > 0 && levels[0].length > 1;
        var maxR = Math.min(bb.w, bb.h) / 2 - minDist;
        var rStep = maxR / (levels.length + firstLvlHasMulti ? 1 : 0);
        minDist = Math.min(minDist, rStep);
    }
    // find the metrics for each level
    var r = 0;
    for(var _i3 = 0; _i3 < levels.length; _i3++){
        var level = levels[_i3];
        var sweep = options.sweep === undefined ? 2 * Math.PI - 2 * Math.PI / level.length : options.sweep;
        var dTheta = level.dTheta = sweep / Math.max(1, level.length - 1);
        // calculate the radius
        if (level.length > 1 && options.avoidOverlap) {
            // but only if more than one node (can't overlap)
            var dcos = Math.cos(dTheta) - Math.cos(0);
            var dsin = Math.sin(dTheta) - Math.sin(0);
            var rMin = Math.sqrt(minDist * minDist / (dcos * dcos + dsin * dsin)); // s.t. no nodes overlapping
            r = Math.max(rMin, r);
        }
        level.r = r;
        r += minDist;
    }
    if (options.equidistant) {
        var rDeltaMax = 0;
        var _r = 0;
        for(var _i4 = 0; _i4 < levels.length; _i4++){
            var _level = levels[_i4];
            var rDelta = _level.r - _r;
            rDeltaMax = Math.max(rDeltaMax, rDelta);
        }
        _r = 0;
        for(var _i5 = 0; _i5 < levels.length; _i5++){
            var _level2 = levels[_i5];
            if (_i5 === 0) _r = _level2.r;
            _level2.r = _r;
            _r += rDeltaMax;
        }
    }
    // calculate the node positions
    var pos = {}; // id => position
    for(var _i6 = 0; _i6 < levels.length; _i6++){
        var _level3 = levels[_i6];
        var _dTheta = _level3.dTheta;
        var _r2 = _level3.r;
        for(var j = 0; j < _level3.length; j++){
            var _val = _level3[j];
            var theta = options.startAngle + (clockwise ? 1 : -1) * _dTheta * j;
            var p = {
                x: center.x + _r2 * Math.cos(theta),
                y: center.y + _r2 * Math.sin(theta)
            };
            pos[_val.node.id()] = p;
        }
    }
    // position the nodes
    eles.nodes().layoutPositions(this, options, function(ele) {
        var id = ele.id();
        return pos[id];
    });
    return this; // chaining
};
/*
The CoSE layout was written by Gerardo Huck.
https://www.linkedin.com/in/gerardohuck/

Based on the following article:
http://dl.acm.org/citation.cfm?id=1498047

Modifications tracked on Github.
*/ var $e815fda779bc047b$var$DEBUG;
/**
 * @brief :  default layout options
 */ var $e815fda779bc047b$var$defaults$4 = {
    // Called on `layoutready`
    ready: function ready() {},
    // Called on `layoutstop`
    stop: function stop() {},
    // Whether to animate while running the layout
    // true : Animate continuously as the layout is running
    // false : Just show the end result
    // 'end' : Animate with the end result, from the initial positions to the end positions
    animate: true,
    // Easing of the animation for animate:'end'
    animationEasing: undefined,
    // The duration of the animation for animate:'end'
    animationDuration: undefined,
    // A function that determines whether the node should be animated
    // All nodes animated by default on animate enabled
    // Non-animated nodes are positioned immediately when the layout starts
    animateFilter: function animateFilter(node, i) {
        return true;
    },
    // The layout animates only after this many milliseconds for animate:true
    // (prevents flashing on fast runs)
    animationThreshold: 250,
    // Number of iterations between consecutive screen positions update
    refresh: 20,
    // Whether to fit the network view after when done
    fit: true,
    // Padding on fit
    padding: 30,
    // Constrain layout bounds; { x1, y1, x2, y2 } or { x1, y1, w, h }
    boundingBox: undefined,
    // Excludes the label when calculating node bounding boxes for the layout algorithm
    nodeDimensionsIncludeLabels: false,
    // Randomize the initial positions of the nodes (true) or use existing positions (false)
    randomize: false,
    // Extra spacing between components in non-compound graphs
    componentSpacing: 40,
    // Node repulsion (non overlapping) multiplier
    nodeRepulsion: function nodeRepulsion(node) {
        return 2048;
    },
    // Node repulsion (overlapping) multiplier
    nodeOverlap: 4,
    // Ideal edge (non nested) length
    idealEdgeLength: function idealEdgeLength(edge) {
        return 32;
    },
    // Divisor to compute edge forces
    edgeElasticity: function edgeElasticity(edge) {
        return 32;
    },
    // Nesting factor (multiplier) to compute ideal edge length for nested edges
    nestingFactor: 1.2,
    // Gravity force (constant)
    gravity: 1,
    // Maximum number of iterations to perform
    numIter: 1000,
    // Initial temperature (maximum node displacement)
    initialTemp: 1000,
    // Cooling factor (how the temperature is reduced between consecutive iterations
    coolingFactor: 0.99,
    // Lower temperature threshold (below this point the layout will end)
    minTemp: 1.0
};
/**
 * @brief       : constructor
 * @arg options : object containing layout options
 */ function $e815fda779bc047b$var$CoseLayout(options) {
    this.options = $e815fda779bc047b$var$extend({}, $e815fda779bc047b$var$defaults$4, options);
    this.options.layout = this;
    // Exclude any edge that has a source or target node that is not in the set of passed-in nodes
    var nodes = this.options.eles.nodes();
    var edges = this.options.eles.edges();
    var notEdges = edges.filter(function(e) {
        var sourceId = e.source().data('id');
        var targetId = e.target().data('id');
        var hasSource = nodes.some(function(n) {
            return n.data('id') === sourceId;
        });
        var hasTarget = nodes.some(function(n) {
            return n.data('id') === targetId;
        });
        return !hasSource || !hasTarget;
    });
    this.options.eles = this.options.eles.not(notEdges);
}
/**
 * @brief : runs the layout
 */ $e815fda779bc047b$var$CoseLayout.prototype.run = function() {
    var options = this.options;
    var cy = options.cy;
    var layout = this;
    layout.stopped = false;
    if (options.animate === true || options.animate === false) layout.emit({
        type: 'layoutstart',
        layout: layout
    });
    // Set DEBUG - Global variable
    if (true === options.debug) $e815fda779bc047b$var$DEBUG = true;
    else $e815fda779bc047b$var$DEBUG = false;
    // Initialize layout info
    var layoutInfo = $e815fda779bc047b$var$createLayoutInfo(cy, layout, options);
    // Show LayoutInfo contents if debugging
    if ($e815fda779bc047b$var$DEBUG) $e815fda779bc047b$var$printLayoutInfo(layoutInfo);
    // If required, randomize node positions
    if (options.randomize) $e815fda779bc047b$var$randomizePositions(layoutInfo);
    var startTime = $e815fda779bc047b$var$performanceNow();
    var refresh = function refresh() {
        $e815fda779bc047b$var$refreshPositions(layoutInfo, cy, options);
        // Fit the graph if necessary
        if (true === options.fit) cy.fit(options.padding);
    };
    var mainLoop = function mainLoop(i) {
        if (layout.stopped || i >= options.numIter) // logDebug("Layout manually stopped. Stopping computation in step " + i);
        return false;
        // Do one step in the phisical simulation
        $e815fda779bc047b$var$step(layoutInfo, options);
        // Update temperature
        layoutInfo.temperature = layoutInfo.temperature * options.coolingFactor;
        // logDebug("New temperature: " + layoutInfo.temperature);
        if (layoutInfo.temperature < options.minTemp) // logDebug("Temperature drop below minimum threshold. Stopping computation in step " + i);
        return false;
        return true;
    };
    var done = function done() {
        if (options.animate === true || options.animate === false) {
            refresh();
            // Layout has finished
            layout.one('layoutstop', options.stop);
            layout.emit({
                type: 'layoutstop',
                layout: layout
            });
        } else {
            var nodes = options.eles.nodes();
            var getScaledPos = $e815fda779bc047b$var$getScaleInBoundsFn(layoutInfo, options, nodes);
            nodes.layoutPositions(layout, options, getScaledPos);
        }
    };
    var i = 0;
    var loopRet = true;
    if (options.animate === true) {
        var _frame = function frame() {
            var f = 0;
            while(loopRet && f < options.refresh){
                loopRet = mainLoop(i);
                i++;
                f++;
            }
            if (!loopRet) {
                // it's done
                $e815fda779bc047b$var$separateComponents(layoutInfo, options);
                done();
            } else {
                var now = $e815fda779bc047b$var$performanceNow();
                if (now - startTime >= options.animationThreshold) refresh();
                $e815fda779bc047b$var$requestAnimationFrame(_frame);
            }
        };
        _frame();
    } else {
        while(loopRet){
            loopRet = mainLoop(i);
            i++;
        }
        $e815fda779bc047b$var$separateComponents(layoutInfo, options);
        done();
    }
    return this; // chaining
};
/**
 * @brief : called on continuous layouts to stop them before they finish
 */ $e815fda779bc047b$var$CoseLayout.prototype.stop = function() {
    this.stopped = true;
    if (this.thread) this.thread.stop();
    this.emit('layoutstop');
    return this; // chaining
};
$e815fda779bc047b$var$CoseLayout.prototype.destroy = function() {
    if (this.thread) this.thread.stop();
    return this; // chaining
};
/**
 * @brief     : Creates an object which is contains all the data
 *              used in the layout process
 * @arg cy    : cytoscape.js object
 * @return    : layoutInfo object initialized
 */ var $e815fda779bc047b$var$createLayoutInfo = function createLayoutInfo(cy, layout, options) {
    // Shortcut
    var edges = options.eles.edges();
    var nodes = options.eles.nodes();
    var bb = $e815fda779bc047b$var$makeBoundingBox(options.boundingBox ? options.boundingBox : {
        x1: 0,
        y1: 0,
        w: cy.width(),
        h: cy.height()
    });
    var layoutInfo = {
        isCompound: cy.hasCompoundNodes(),
        layoutNodes: [],
        idToIndex: {},
        nodeSize: nodes.size(),
        graphSet: [],
        indexToGraph: [],
        layoutEdges: [],
        edgeSize: edges.size(),
        temperature: options.initialTemp,
        clientWidth: bb.w,
        clientHeight: bb.h,
        boundingBox: bb
    };
    var components = options.eles.components();
    var id2cmptId = {};
    for(var i = 0; i < components.length; i++){
        var component = components[i];
        for(var j = 0; j < component.length; j++){
            var node = component[j];
            id2cmptId[node.id()] = i;
        }
    }
    // Iterate over all nodes, creating layout nodes
    for(var i = 0; i < layoutInfo.nodeSize; i++){
        var n = nodes[i];
        var nbb = n.layoutDimensions(options);
        var tempNode = {};
        tempNode.isLocked = n.locked();
        tempNode.id = n.data('id');
        tempNode.parentId = n.data('parent');
        tempNode.cmptId = id2cmptId[n.id()];
        tempNode.children = [];
        tempNode.positionX = n.position('x');
        tempNode.positionY = n.position('y');
        tempNode.offsetX = 0;
        tempNode.offsetY = 0;
        tempNode.height = nbb.w;
        tempNode.width = nbb.h;
        tempNode.maxX = tempNode.positionX + tempNode.width / 2;
        tempNode.minX = tempNode.positionX - tempNode.width / 2;
        tempNode.maxY = tempNode.positionY + tempNode.height / 2;
        tempNode.minY = tempNode.positionY - tempNode.height / 2;
        tempNode.padLeft = parseFloat(n.style('padding'));
        tempNode.padRight = parseFloat(n.style('padding'));
        tempNode.padTop = parseFloat(n.style('padding'));
        tempNode.padBottom = parseFloat(n.style('padding'));
        // forces
        tempNode.nodeRepulsion = $e815fda779bc047b$var$fn$6(options.nodeRepulsion) ? options.nodeRepulsion(n) : options.nodeRepulsion;
        // Add new node
        layoutInfo.layoutNodes.push(tempNode);
        // Add entry to id-index map
        layoutInfo.idToIndex[tempNode.id] = i;
    }
    // Inline implementation of a queue, used for traversing the graph in BFS order
    var queue = [];
    var start = 0; // Points to the start the queue
    var end = -1; // Points to the end of the queue
    var tempGraph = [];
    // Second pass to add child information and
    // initialize queue for hierarchical traversal
    for(var i = 0; i < layoutInfo.nodeSize; i++){
        var n = layoutInfo.layoutNodes[i];
        var p_id = n.parentId;
        // Check if node n has a parent node
        if (null != p_id) // Add node Id to parent's list of children
        layoutInfo.layoutNodes[layoutInfo.idToIndex[p_id]].children.push(n.id);
        else {
            // If a node doesn't have a parent, then it's in the root graph
            queue[++end] = n.id;
            tempGraph.push(n.id);
        }
    }
    // Add root graph to graphSet
    layoutInfo.graphSet.push(tempGraph);
    // Traverse the graph, level by level,
    while(start <= end){
        // Get the node to visit and remove it from queue
        var node_id = queue[start++];
        var node_ix = layoutInfo.idToIndex[node_id];
        var node = layoutInfo.layoutNodes[node_ix];
        var children = node.children;
        if (children.length > 0) {
            // Add children nodes as a new graph to graph set
            layoutInfo.graphSet.push(children);
            // Add children to que queue to be visited
            for(var i = 0; i < children.length; i++)queue[++end] = children[i];
        }
    }
    // Create indexToGraph map
    for(var i = 0; i < layoutInfo.graphSet.length; i++){
        var graph = layoutInfo.graphSet[i];
        for(var j = 0; j < graph.length; j++){
            var index = layoutInfo.idToIndex[graph[j]];
            layoutInfo.indexToGraph[index] = i;
        }
    }
    // Iterate over all edges, creating Layout Edges
    for(var i = 0; i < layoutInfo.edgeSize; i++){
        var e = edges[i];
        var tempEdge = {};
        tempEdge.id = e.data('id');
        tempEdge.sourceId = e.data('source');
        tempEdge.targetId = e.data('target');
        // Compute ideal length
        var idealLength = $e815fda779bc047b$var$fn$6(options.idealEdgeLength) ? options.idealEdgeLength(e) : options.idealEdgeLength;
        var elasticity = $e815fda779bc047b$var$fn$6(options.edgeElasticity) ? options.edgeElasticity(e) : options.edgeElasticity;
        // Check if it's an inter graph edge
        var sourceIx = layoutInfo.idToIndex[tempEdge.sourceId];
        var targetIx = layoutInfo.idToIndex[tempEdge.targetId];
        var sourceGraph = layoutInfo.indexToGraph[sourceIx];
        var targetGraph = layoutInfo.indexToGraph[targetIx];
        if (sourceGraph != targetGraph) {
            // Find lowest common graph ancestor
            var lca = $e815fda779bc047b$var$findLCA(tempEdge.sourceId, tempEdge.targetId, layoutInfo);
            // Compute sum of node depths, relative to lca graph
            var lcaGraph = layoutInfo.graphSet[lca];
            var depth = 0;
            // Source depth
            var tempNode = layoutInfo.layoutNodes[sourceIx];
            while(-1 === lcaGraph.indexOf(tempNode.id)){
                tempNode = layoutInfo.layoutNodes[layoutInfo.idToIndex[tempNode.parentId]];
                depth++;
            }
            // Target depth
            tempNode = layoutInfo.layoutNodes[targetIx];
            while(-1 === lcaGraph.indexOf(tempNode.id)){
                tempNode = layoutInfo.layoutNodes[layoutInfo.idToIndex[tempNode.parentId]];
                depth++;
            }
            // logDebug('LCA of nodes ' + tempEdge.sourceId + ' and ' + tempEdge.targetId +
            //  ". Index: " + lca + " Contents: " + lcaGraph.toString() +
            //  ". Depth: " + depth);
            // Update idealLength
            idealLength *= depth * options.nestingFactor;
        }
        tempEdge.idealLength = idealLength;
        tempEdge.elasticity = elasticity;
        layoutInfo.layoutEdges.push(tempEdge);
    }
    // Finally, return layoutInfo object
    return layoutInfo;
};
/**
 * @brief : This function finds the index of the lowest common
 *          graph ancestor between 2 nodes in the subtree
 *          (from the graph hierarchy induced tree) whose
 *          root is graphIx
 *
 * @arg node1: node1's ID
 * @arg node2: node2's ID
 * @arg layoutInfo: layoutInfo object
 *
 */ var $e815fda779bc047b$var$findLCA = function findLCA(node1, node2, layoutInfo) {
    // Find their common ancester, starting from the root graph
    var res = $e815fda779bc047b$var$_findLCA_aux(node1, node2, 0, layoutInfo);
    if (2 > res.count) // If aux function couldn't find the common ancester,
    // then it is the root graph
    return 0;
    else return res.graph;
};
/**
 * @brief          : Auxiliary function used for LCA computation
 *
 * @arg node1      : node1's ID
 * @arg node2      : node2's ID
 * @arg graphIx    : subgraph index
 * @arg layoutInfo : layoutInfo object
 *
 * @return         : object of the form {count: X, graph: Y}, where:
 *                   X is the number of ancestors (max: 2) found in
 *                   graphIx (and it's subgraphs),
 *                   Y is the graph index of the lowest graph containing
 *                   all X nodes
 */ var $e815fda779bc047b$var$_findLCA_aux = function findLCA_aux(node1, node2, graphIx, layoutInfo) {
    var graph = layoutInfo.graphSet[graphIx];
    // If both nodes belongs to graphIx
    if (-1 < graph.indexOf(node1) && -1 < graph.indexOf(node2)) return {
        count: 2,
        graph: graphIx
    };
    // Make recursive calls for all subgraphs
    var c = 0;
    for(var i = 0; i < graph.length; i++){
        var nodeId = graph[i];
        var nodeIx = layoutInfo.idToIndex[nodeId];
        var children = layoutInfo.layoutNodes[nodeIx].children;
        // If the node has no child, skip it
        if (0 === children.length) continue;
        var childGraphIx = layoutInfo.indexToGraph[layoutInfo.idToIndex[children[0]]];
        var result = $e815fda779bc047b$var$_findLCA_aux(node1, node2, childGraphIx, layoutInfo);
        if (0 === result.count) continue;
        else if (1 === result.count) {
            // One of (node1, node2) is present in this subgraph
            c++;
            if (2 === c) break;
        } else // Both nodes are present in this subgraph
        return result;
    }
    return {
        count: c,
        graph: graphIx
    };
};
/**
 * @brief: printsLayoutInfo into js console
 *         Only used for debbuging
 */ var $e815fda779bc047b$var$printLayoutInfo;
/**
 * @brief : Randomizes the position of all nodes
 */ var $e815fda779bc047b$var$randomizePositions = function randomizePositions(layoutInfo, cy) {
    var width = layoutInfo.clientWidth;
    var height = layoutInfo.clientHeight;
    for(var i = 0; i < layoutInfo.nodeSize; i++){
        var n = layoutInfo.layoutNodes[i];
        // No need to randomize compound nodes or locked nodes
        if (0 === n.children.length && !n.isLocked) {
            n.positionX = Math.random() * width;
            n.positionY = Math.random() * height;
        }
    }
};
var $e815fda779bc047b$var$getScaleInBoundsFn = function getScaleInBoundsFn(layoutInfo, options, nodes) {
    var bb = layoutInfo.boundingBox;
    var coseBB = {
        x1: Infinity,
        x2: -Infinity,
        y1: Infinity,
        y2: -Infinity
    };
    if (options.boundingBox) {
        nodes.forEach(function(node) {
            var lnode = layoutInfo.layoutNodes[layoutInfo.idToIndex[node.data('id')]];
            coseBB.x1 = Math.min(coseBB.x1, lnode.positionX);
            coseBB.x2 = Math.max(coseBB.x2, lnode.positionX);
            coseBB.y1 = Math.min(coseBB.y1, lnode.positionY);
            coseBB.y2 = Math.max(coseBB.y2, lnode.positionY);
        });
        coseBB.w = coseBB.x2 - coseBB.x1;
        coseBB.h = coseBB.y2 - coseBB.y1;
    }
    return function(ele, i) {
        var lnode = layoutInfo.layoutNodes[layoutInfo.idToIndex[ele.data('id')]];
        if (options.boundingBox) {
            // then add extra bounding box constraint
            // Handle single node case where coseBB.w or coseBB.h is 0
            var pctX = coseBB.w === 0 ? 0.5 : (lnode.positionX - coseBB.x1) / coseBB.w;
            var pctY = coseBB.h === 0 ? 0.5 : (lnode.positionY - coseBB.y1) / coseBB.h;
            return {
                x: bb.x1 + pctX * bb.w,
                y: bb.y1 + pctY * bb.h
            };
        } else return {
            x: lnode.positionX,
            y: lnode.positionY
        };
    };
};
/**
 * @brief          : Updates the positions of nodes in the network
 * @arg layoutInfo : LayoutInfo object
 * @arg cy         : Cytoscape object
 * @arg options    : Layout options
 */ var $e815fda779bc047b$var$refreshPositions = function refreshPositions(layoutInfo, cy, options) {
    // var s = 'Refreshing positions';
    // logDebug(s);
    var layout = options.layout;
    var nodes = options.eles.nodes();
    var getScaledPos = $e815fda779bc047b$var$getScaleInBoundsFn(layoutInfo, options, nodes);
    nodes.positions(getScaledPos);
    // Trigger layoutReady only on first call
    if (true !== layoutInfo.ready) {
        // s = 'Triggering layoutready';
        // logDebug(s);
        layoutInfo.ready = true;
        layout.one('layoutready', options.ready);
        layout.emit({
            type: 'layoutready',
            layout: this
        });
    }
};
/**
 * @brief : Logs a debug message in JS console, if DEBUG is ON
 */ // var logDebug = function(text) {
//   if (DEBUG) {
//     console.debug(text);
//   }
// };
/**
 * @brief          : Performs one iteration of the physical simulation
 * @arg layoutInfo : LayoutInfo object already initialized
 * @arg cy         : Cytoscape object
 * @arg options    : Layout options
 */ var $e815fda779bc047b$var$step = function step(layoutInfo, options, _step) {
    // var s = "\n\n###############################";
    // s += "\nSTEP: " + step;
    // s += "\n###############################\n";
    // logDebug(s);
    // Calculate node repulsions
    $e815fda779bc047b$var$calculateNodeForces(layoutInfo, options);
    // Calculate edge forces
    $e815fda779bc047b$var$calculateEdgeForces(layoutInfo);
    // Calculate gravity forces
    $e815fda779bc047b$var$calculateGravityForces(layoutInfo, options);
    // Propagate forces from parent to child
    $e815fda779bc047b$var$propagateForces(layoutInfo);
    // Update positions based on calculated forces
    $e815fda779bc047b$var$updatePositions(layoutInfo);
};
/**
 * @brief : Computes the node repulsion forces
 */ var $e815fda779bc047b$var$calculateNodeForces = function calculateNodeForces(layoutInfo, options) {
    // Go through each of the graphs in graphSet
    // Nodes only repel each other if they belong to the same graph
    // var s = 'calculateNodeForces';
    // logDebug(s);
    for(var i = 0; i < layoutInfo.graphSet.length; i++){
        var graph = layoutInfo.graphSet[i];
        var numNodes = graph.length;
        // s = "Set: " + graph.toString();
        // logDebug(s);
        // Now get all the pairs of nodes
        // Only get each pair once, (A, B) = (B, A)
        for(var j = 0; j < numNodes; j++){
            var node1 = layoutInfo.layoutNodes[layoutInfo.idToIndex[graph[j]]];
            for(var k = j + 1; k < numNodes; k++){
                var node2 = layoutInfo.layoutNodes[layoutInfo.idToIndex[graph[k]]];
                $e815fda779bc047b$var$nodeRepulsion(node1, node2, layoutInfo, options);
            }
        }
    }
};
var $e815fda779bc047b$var$randomDistance = function randomDistance(max) {
    return -1 + 2 * max * Math.random();
};
/**
 * @brief : Compute the node repulsion forces between a pair of nodes
 */ var $e815fda779bc047b$var$nodeRepulsion = function nodeRepulsion(node1, node2, layoutInfo, options) {
    // var s = "Node repulsion. Node1: " + node1.id + " Node2: " + node2.id;
    var cmptId1 = node1.cmptId;
    var cmptId2 = node2.cmptId;
    if (cmptId1 !== cmptId2 && !layoutInfo.isCompound) return;
    // Get direction of line connecting both node centers
    var directionX = node2.positionX - node1.positionX;
    var directionY = node2.positionY - node1.positionY;
    var maxRandDist = 1;
    // s += "\ndirectionX: " + directionX + ", directionY: " + directionY;
    // If both centers are the same, apply a random force
    if (0 === directionX && 0 === directionY) {
        directionX = $e815fda779bc047b$var$randomDistance(maxRandDist);
        directionY = $e815fda779bc047b$var$randomDistance(maxRandDist);
    }
    var overlap = $e815fda779bc047b$var$nodesOverlap(node1, node2, directionX, directionY);
    if (overlap > 0) {
        // s += "\nNodes DO overlap.";
        // s += "\nOverlap: " + overlap;
        // If nodes overlap, repulsion force is proportional
        // to the overlap
        var force = options.nodeOverlap * overlap;
        // Compute the module and components of the force vector
        var distance = Math.sqrt(directionX * directionX + directionY * directionY);
        // s += "\nDistance: " + distance;
        var forceX = force * directionX / distance;
        var forceY = force * directionY / distance;
    } else {
        // s += "\nNodes do NOT overlap.";
        // If there's no overlap, force is inversely proportional
        // to squared distance
        // Get clipping points for both nodes
        var point1 = $e815fda779bc047b$var$findClippingPoint(node1, directionX, directionY);
        var point2 = $e815fda779bc047b$var$findClippingPoint(node2, -1 * directionX, -1 * directionY);
        // Use clipping points to compute distance
        var distanceX = point2.x - point1.x;
        var distanceY = point2.y - point1.y;
        var distanceSqr = distanceX * distanceX + distanceY * distanceY;
        var distance = Math.sqrt(distanceSqr);
        // s += "\nDistance: " + distance;
        // Compute the module and components of the force vector
        var force = (node1.nodeRepulsion + node2.nodeRepulsion) / distanceSqr;
        var forceX = force * distanceX / distance;
        var forceY = force * distanceY / distance;
    }
    // Apply force
    if (!node1.isLocked) {
        node1.offsetX -= forceX;
        node1.offsetY -= forceY;
    }
    if (!node2.isLocked) {
        node2.offsetX += forceX;
        node2.offsetY += forceY;
    }
    // s += "\nForceX: " + forceX + " ForceY: " + forceY;
    // logDebug(s);
    return;
};
/**
 * @brief  : Determines whether two nodes overlap or not
 * @return : Amount of overlapping (0 => no overlap)
 */ var $e815fda779bc047b$var$nodesOverlap = function nodesOverlap(node1, node2, dX, dY) {
    if (dX > 0) var overlapX = node1.maxX - node2.minX;
    else var overlapX = node2.maxX - node1.minX;
    if (dY > 0) var overlapY = node1.maxY - node2.minY;
    else var overlapY = node2.maxY - node1.minY;
    if (overlapX >= 0 && overlapY >= 0) return Math.sqrt(overlapX * overlapX + overlapY * overlapY);
    else return 0;
};
/**
 * @brief : Finds the point in which an edge (direction dX, dY) intersects
 *          the rectangular bounding box of it's source/target node
 */ var $e815fda779bc047b$var$findClippingPoint = function findClippingPoint(node, dX, dY) {
    // Shorcuts
    var X = node.positionX;
    var Y = node.positionY;
    var H = node.height || 1;
    var W = node.width || 1;
    var dirSlope = dY / dX;
    var nodeSlope = H / W;
    // var s = 'Computing clipping point of node ' + node.id +
    //   " . Height:  " + H + ", Width: " + W +
    //   "\nDirection " + dX + ", " + dY;
    //
    // Compute intersection
    var res = {};
    // Case: Vertical direction (up)
    if (0 === dX && 0 < dY) {
        res.x = X;
        // s += "\nUp direction";
        res.y = Y + H / 2;
        return res;
    }
    // Case: Vertical direction (down)
    if (0 === dX && 0 > dY) {
        res.x = X;
        res.y = Y + H / 2;
        // s += "\nDown direction";
        return res;
    }
    // Case: Intersects the right border
    if (0 < dX && -1 * nodeSlope <= dirSlope && dirSlope <= nodeSlope) {
        res.x = X + W / 2;
        res.y = Y + W * dY / 2 / dX;
        // s += "\nRightborder";
        return res;
    }
    // Case: Intersects the left border
    if (0 > dX && -1 * nodeSlope <= dirSlope && dirSlope <= nodeSlope) {
        res.x = X - W / 2;
        res.y = Y - W * dY / 2 / dX;
        // s += "\nLeftborder";
        return res;
    }
    // Case: Intersects the top border
    if (0 < dY && (dirSlope <= -1 * nodeSlope || dirSlope >= nodeSlope)) {
        res.x = X + H * dX / 2 / dY;
        res.y = Y + H / 2;
        // s += "\nTop border";
        return res;
    }
    // Case: Intersects the bottom border
    if (0 > dY && (dirSlope <= -1 * nodeSlope || dirSlope >= nodeSlope)) {
        res.x = X - H * dX / 2 / dY;
        res.y = Y - H / 2;
        // s += "\nBottom border";
        return res;
    }
    // s += "\nClipping point found at " + res.x + ", " + res.y;
    // logDebug(s);
    return res;
};
/**
 * @brief : Calculates all edge forces
 */ var $e815fda779bc047b$var$calculateEdgeForces = function calculateEdgeForces(layoutInfo, options) {
    // Iterate over all edges
    for(var i = 0; i < layoutInfo.edgeSize; i++){
        // Get edge, source & target nodes
        var edge = layoutInfo.layoutEdges[i];
        var sourceIx = layoutInfo.idToIndex[edge.sourceId];
        var source = layoutInfo.layoutNodes[sourceIx];
        var targetIx = layoutInfo.idToIndex[edge.targetId];
        var target = layoutInfo.layoutNodes[targetIx];
        // Get direction of line connecting both node centers
        var directionX = target.positionX - source.positionX;
        var directionY = target.positionY - source.positionY;
        // If both centers are the same, do nothing.
        // A random force has already been applied as node repulsion
        if (0 === directionX && 0 === directionY) continue;
        // Get clipping points for both nodes
        var point1 = $e815fda779bc047b$var$findClippingPoint(source, directionX, directionY);
        var point2 = $e815fda779bc047b$var$findClippingPoint(target, -1 * directionX, -1 * directionY);
        var lx = point2.x - point1.x;
        var ly = point2.y - point1.y;
        var l = Math.sqrt(lx * lx + ly * ly);
        var force = Math.pow(edge.idealLength - l, 2) / edge.elasticity;
        if (0 !== l) {
            var forceX = force * lx / l;
            var forceY = force * ly / l;
        } else {
            var forceX = 0;
            var forceY = 0;
        }
        // Add this force to target and source nodes
        if (!source.isLocked) {
            source.offsetX += forceX;
            source.offsetY += forceY;
        }
        if (!target.isLocked) {
            target.offsetX -= forceX;
            target.offsetY -= forceY;
        }
    // var s = 'Edge force between nodes ' + source.id + ' and ' + target.id;
    // s += "\nDistance: " + l + " Force: (" + forceX + ", " + forceY + ")";
    // logDebug(s);
    }
};
/**
 * @brief : Computes gravity forces for all nodes
 */ var $e815fda779bc047b$var$calculateGravityForces = function calculateGravityForces(layoutInfo, options) {
    if (options.gravity === 0) return;
    var distThreshold = 1;
    // var s = 'calculateGravityForces';
    // logDebug(s);
    for(var i = 0; i < layoutInfo.graphSet.length; i++){
        var graph = layoutInfo.graphSet[i];
        var numNodes = graph.length;
        // s = "Set: " + graph.toString();
        // logDebug(s);
        // Compute graph center
        if (0 === i) {
            var centerX = layoutInfo.clientHeight / 2;
            var centerY = layoutInfo.clientWidth / 2;
        } else {
            // Get Parent node for this graph, and use its position as center
            var temp = layoutInfo.layoutNodes[layoutInfo.idToIndex[graph[0]]];
            var parent = layoutInfo.layoutNodes[layoutInfo.idToIndex[temp.parentId]];
            var centerX = parent.positionX;
            var centerY = parent.positionY;
        }
        // s = "Center found at: " + centerX + ", " + centerY;
        // logDebug(s);
        // Apply force to all nodes in graph
        for(var j = 0; j < numNodes; j++){
            var node = layoutInfo.layoutNodes[layoutInfo.idToIndex[graph[j]]];
            // s = "Node: " + node.id;
            if (node.isLocked) continue;
            var dx = centerX - node.positionX;
            var dy = centerY - node.positionY;
            var d = Math.sqrt(dx * dx + dy * dy);
            if (d > distThreshold) {
                var fx = options.gravity * dx / d;
                var fy = options.gravity * dy / d;
                node.offsetX += fx;
                node.offsetY += fy;
            // s += ": Applied force: " + fx + ", " + fy;
            }
        // logDebug(s);
        }
    }
};
/**
 * @brief          : This function propagates the existing offsets from
 *                   parent nodes to its descendents.
 * @arg layoutInfo : layoutInfo Object
 * @arg cy         : cytoscape Object
 * @arg options    : Layout options
 */ var $e815fda779bc047b$var$propagateForces = function propagateForces(layoutInfo, options) {
    // Inline implementation of a queue, used for traversing the graph in BFS order
    var queue = [];
    var start = 0; // Points to the start the queue
    var end = -1; // Points to the end of the queue
    // logDebug('propagateForces');
    // Start by visiting the nodes in the root graph
    queue.push.apply(queue, layoutInfo.graphSet[0]);
    end += layoutInfo.graphSet[0].length;
    // Traverse the graph, level by level,
    while(start <= end){
        // Get the node to visit and remove it from queue
        var nodeId = queue[start++];
        var nodeIndex = layoutInfo.idToIndex[nodeId];
        var node = layoutInfo.layoutNodes[nodeIndex];
        var children = node.children;
        // We only need to process the node if it's compound
        if (0 < children.length && !node.isLocked) {
            var offX = node.offsetX;
            var offY = node.offsetY;
            // var s = "Propagating offset from parent node : " + node.id +
            //   ". OffsetX: " + offX + ". OffsetY: " + offY;
            // s += "\n Children: " + children.toString();
            // logDebug(s);
            for(var i = 0; i < children.length; i++){
                var childNode = layoutInfo.layoutNodes[layoutInfo.idToIndex[children[i]]];
                // Propagate offset
                childNode.offsetX += offX;
                childNode.offsetY += offY;
                // Add children to queue to be visited
                queue[++end] = children[i];
            }
            // Reset parent offsets
            node.offsetX = 0;
            node.offsetY = 0;
        }
    }
};
/**
 * @brief : Updates the layout model positions, based on
 *          the accumulated forces
 */ var $e815fda779bc047b$var$updatePositions = function updatePositions(layoutInfo, options) {
    // var s = 'Updating positions';
    // logDebug(s);
    // Reset boundaries for compound nodes
    for(var i = 0; i < layoutInfo.nodeSize; i++){
        var n = layoutInfo.layoutNodes[i];
        if (0 < n.children.length) {
            // logDebug("Resetting boundaries of compound node: " + n.id);
            n.maxX = undefined;
            n.minX = undefined;
            n.maxY = undefined;
            n.minY = undefined;
        }
    }
    for(var i = 0; i < layoutInfo.nodeSize; i++){
        var n = layoutInfo.layoutNodes[i];
        if (0 < n.children.length || n.isLocked) continue;
        // s = "Node: " + n.id + " Previous position: (" +
        // n.positionX + ", " + n.positionY + ").";
        // Limit displacement in order to improve stability
        var tempForce = $e815fda779bc047b$var$limitForce(n.offsetX, n.offsetY, layoutInfo.temperature);
        n.positionX += tempForce.x;
        n.positionY += tempForce.y;
        n.offsetX = 0;
        n.offsetY = 0;
        n.minX = n.positionX - n.width;
        n.maxX = n.positionX + n.width;
        n.minY = n.positionY - n.height;
        n.maxY = n.positionY + n.height;
        // s += " New Position: (" + n.positionX + ", " + n.positionY + ").";
        // logDebug(s);
        // Update ancestry boudaries
        $e815fda779bc047b$var$_updateAncestryBoundaries(n, layoutInfo);
    }
    // Update size, position of compund nodes
    for(var i = 0; i < layoutInfo.nodeSize; i++){
        var n = layoutInfo.layoutNodes[i];
        if (0 < n.children.length && !n.isLocked) {
            n.positionX = (n.maxX + n.minX) / 2;
            n.positionY = (n.maxY + n.minY) / 2;
            n.width = n.maxX - n.minX;
            n.height = n.maxY - n.minY;
        // s = "Updating position, size of compound node " + n.id;
        // s += "\nPositionX: " + n.positionX + ", PositionY: " + n.positionY;
        // s += "\nWidth: " + n.width + ", Height: " + n.height;
        // logDebug(s);
        }
    }
};
/**
 * @brief : Limits a force (forceX, forceY) to be not
 *          greater (in modulo) than max.
 8          Preserves force direction.
  */ var $e815fda779bc047b$var$limitForce = function limitForce(forceX, forceY, max) {
    // var s = "Limiting force: (" + forceX + ", " + forceY + "). Max: " + max;
    var force = Math.sqrt(forceX * forceX + forceY * forceY);
    if (force > max) var res = {
        x: max * forceX / force,
        y: max * forceY / force
    };
    else var res = {
        x: forceX,
        y: forceY
    };
    // s += ".\nResult: (" + res.x + ", " + res.y + ")";
    // logDebug(s);
    return res;
};
/**
 * @brief : Function used for keeping track of compound node
 *          sizes, since they should bound all their subnodes.
 */ var $e815fda779bc047b$var$_updateAncestryBoundaries = function updateAncestryBoundaries(node, layoutInfo) {
    // var s = "Propagating new position/size of node " + node.id;
    var parentId = node.parentId;
    if (null == parentId) // If there's no parent, we are done
    // s += ". No parent node.";
    // logDebug(s);
    return;
    // Get Parent Node
    var p = layoutInfo.layoutNodes[layoutInfo.idToIndex[parentId]];
    var flag = false;
    // MaxX
    if (null == p.maxX || node.maxX + p.padRight > p.maxX) {
        p.maxX = node.maxX + p.padRight;
        flag = true;
    // s += "\nNew maxX for parent node " + p.id + ": " + p.maxX;
    }
    // MinX
    if (null == p.minX || node.minX - p.padLeft < p.minX) {
        p.minX = node.minX - p.padLeft;
        flag = true;
    // s += "\nNew minX for parent node " + p.id + ": " + p.minX;
    }
    // MaxY
    if (null == p.maxY || node.maxY + p.padBottom > p.maxY) {
        p.maxY = node.maxY + p.padBottom;
        flag = true;
    // s += "\nNew maxY for parent node " + p.id + ": " + p.maxY;
    }
    // MinY
    if (null == p.minY || node.minY - p.padTop < p.minY) {
        p.minY = node.minY - p.padTop;
        flag = true;
    // s += "\nNew minY for parent node " + p.id + ": " + p.minY;
    }
    // If updated boundaries, propagate changes upward
    if (flag) // logDebug(s);
    return $e815fda779bc047b$var$_updateAncestryBoundaries(p, layoutInfo);
    // s += ". No changes in boundaries/position of parent node " + p.id;
    // logDebug(s);
    return;
};
var $e815fda779bc047b$var$separateComponents = function separateComponents(layoutInfo, options) {
    var nodes = layoutInfo.layoutNodes;
    var components = [];
    for(var i = 0; i < nodes.length; i++){
        var node = nodes[i];
        var cid = node.cmptId;
        var component = components[cid] = components[cid] || [];
        component.push(node);
    }
    var totalA = 0;
    for(var i = 0; i < components.length; i++){
        var c = components[i];
        if (!c) continue;
        c.x1 = Infinity;
        c.x2 = -Infinity;
        c.y1 = Infinity;
        c.y2 = -Infinity;
        for(var j = 0; j < c.length; j++){
            var n = c[j];
            c.x1 = Math.min(c.x1, n.positionX - n.width / 2);
            c.x2 = Math.max(c.x2, n.positionX + n.width / 2);
            c.y1 = Math.min(c.y1, n.positionY - n.height / 2);
            c.y2 = Math.max(c.y2, n.positionY + n.height / 2);
        }
        c.w = c.x2 - c.x1;
        c.h = c.y2 - c.y1;
        totalA += c.w * c.h;
    }
    components.sort(function(c1, c2) {
        return c2.w * c2.h - c1.w * c1.h;
    });
    var x = 0;
    var y = 0;
    var usedW = 0;
    var rowH = 0;
    var maxRowW = Math.sqrt(totalA) * layoutInfo.clientWidth / layoutInfo.clientHeight;
    for(var i = 0; i < components.length; i++){
        var c = components[i];
        if (!c) continue;
        for(var j = 0; j < c.length; j++){
            var n = c[j];
            if (!n.isLocked) {
                n.positionX += x - c.x1;
                n.positionY += y - c.y1;
            }
        }
        x += c.w + options.componentSpacing;
        usedW += c.w + options.componentSpacing;
        rowH = Math.max(rowH, c.h);
        if (usedW > maxRowW) {
            y += rowH + options.componentSpacing;
            x = 0;
            usedW = 0;
            rowH = 0;
        }
    }
};
var $e815fda779bc047b$var$defaults$3 = {
    fit: true,
    // whether to fit the viewport to the graph
    padding: 30,
    // padding used on fit
    boundingBox: undefined,
    // constrain layout bounds; { x1, y1, x2, y2 } or { x1, y1, w, h }
    avoidOverlap: true,
    // prevents node overlap, may overflow boundingBox if not enough space
    avoidOverlapPadding: 10,
    // extra spacing around nodes when avoidOverlap: true
    nodeDimensionsIncludeLabels: false,
    // Excludes the label when calculating node bounding boxes for the layout algorithm
    spacingFactor: undefined,
    // Applies a multiplicative factor (>0) to expand or compress the overall area that the nodes take up
    condense: false,
    // uses all available space on false, uses minimal space on true
    rows: undefined,
    // force num of rows in the grid
    cols: undefined,
    // force num of columns in the grid
    position: function position(node) {},
    // returns { row, col } for element
    sort: undefined,
    // a sorting function to order the nodes; e.g. function(a, b){ return a.data('weight') - b.data('weight') }
    animate: false,
    // whether to transition the node positions
    animationDuration: 500,
    // duration of animation in ms if enabled
    animationEasing: undefined,
    // easing of animation if enabled
    animateFilter: function animateFilter(node, i) {
        return true;
    },
    // a function that determines whether the node should be animated.  All nodes animated by default on animate enabled.  Non-animated nodes are positioned immediately when the layout starts
    ready: undefined,
    // callback on layoutready
    stop: undefined,
    // callback on layoutstop
    transform: function transform(node, position) {
        return position;
    } // transform a given node position. Useful for changing flow direction in discrete layouts 
};
function $e815fda779bc047b$var$GridLayout(options) {
    this.options = $e815fda779bc047b$var$extend({}, $e815fda779bc047b$var$defaults$3, options);
}
$e815fda779bc047b$var$GridLayout.prototype.run = function() {
    var params = this.options;
    var options = params;
    var cy = params.cy;
    var eles = options.eles;
    var nodes = eles.nodes().not(':parent');
    if (options.sort) nodes = nodes.sort(options.sort);
    var bb = $e815fda779bc047b$var$makeBoundingBox(options.boundingBox ? options.boundingBox : {
        x1: 0,
        y1: 0,
        w: cy.width(),
        h: cy.height()
    });
    if (bb.h === 0 || bb.w === 0) eles.nodes().layoutPositions(this, options, function(ele) {
        return {
            x: bb.x1,
            y: bb.y1
        };
    });
    else {
        // width/height * splits^2 = cells where splits is number of times to split width
        var cells = nodes.size();
        var splits = Math.sqrt(cells * bb.h / bb.w);
        var rows = Math.round(splits);
        var cols = Math.round(bb.w / bb.h * splits);
        var small = function small(val) {
            if (val == null) return Math.min(rows, cols);
            else {
                var min = Math.min(rows, cols);
                if (min == rows) rows = val;
                else cols = val;
            }
        };
        var large = function large(val) {
            if (val == null) return Math.max(rows, cols);
            else {
                var max = Math.max(rows, cols);
                if (max == rows) rows = val;
                else cols = val;
            }
        };
        var oRows = options.rows;
        var oCols = options.cols != null ? options.cols : options.columns;
        // if rows or columns were set in options, use those values
        if (oRows != null && oCols != null) {
            rows = oRows;
            cols = oCols;
        } else if (oRows != null && oCols == null) {
            rows = oRows;
            cols = Math.ceil(cells / rows);
        } else if (oRows == null && oCols != null) {
            cols = oCols;
            rows = Math.ceil(cells / cols);
        } else if (cols * rows > cells) {
            var sm = small();
            var lg = large();
            // reducing the small side takes away the most cells, so try it first
            if ((sm - 1) * lg >= cells) small(sm - 1);
            else if ((lg - 1) * sm >= cells) large(lg - 1);
        } else // if rounding was too low, add rows or columns
        while(cols * rows < cells){
            var _sm = small();
            var _lg = large();
            // try to add to larger side first (adds less in multiplication)
            if ((_lg + 1) * _sm >= cells) large(_lg + 1);
            else small(_sm + 1);
        }
        var cellWidth = bb.w / cols;
        var cellHeight = bb.h / rows;
        if (options.condense) {
            cellWidth = 0;
            cellHeight = 0;
        }
        if (options.avoidOverlap) for(var i = 0; i < nodes.length; i++){
            var node = nodes[i];
            var pos = node._private.position;
            if (pos.x == null || pos.y == null) {
                // for bb
                pos.x = 0;
                pos.y = 0;
            }
            var nbb = node.layoutDimensions(options);
            var p = options.avoidOverlapPadding;
            var w = nbb.w + p;
            var h = nbb.h + p;
            cellWidth = Math.max(cellWidth, w);
            cellHeight = Math.max(cellHeight, h);
        }
        var cellUsed = {}; // e.g. 'c-0-2' => true
        var used = function used(row, col) {
            return cellUsed['c-' + row + '-' + col] ? true : false;
        };
        var use = function use(row, col) {
            cellUsed['c-' + row + '-' + col] = true;
        };
        // to keep track of current cell position
        var row = 0;
        var col = 0;
        var moveToNextCell = function moveToNextCell() {
            col++;
            if (col >= cols) {
                col = 0;
                row++;
            }
        };
        // get a cache of all the manual positions
        var id2manPos = {};
        for(var _i = 0; _i < nodes.length; _i++){
            var _node = nodes[_i];
            var rcPos = options.position(_node);
            if (rcPos && (rcPos.row !== undefined || rcPos.col !== undefined)) {
                // must have at least row or col def'd
                var _pos = {
                    row: rcPos.row,
                    col: rcPos.col
                };
                if (_pos.col === undefined) {
                    // find unused col
                    _pos.col = 0;
                    while(used(_pos.row, _pos.col))_pos.col++;
                } else if (_pos.row === undefined) {
                    // find unused row
                    _pos.row = 0;
                    while(used(_pos.row, _pos.col))_pos.row++;
                }
                id2manPos[_node.id()] = _pos;
                use(_pos.row, _pos.col);
            }
        }
        var getPos = function getPos(element, i) {
            var x, y;
            if (element.locked() || element.isParent()) return false;
            // see if we have a manual position set
            var rcPos = id2manPos[element.id()];
            if (rcPos) {
                x = rcPos.col * cellWidth + cellWidth / 2 + bb.x1;
                y = rcPos.row * cellHeight + cellHeight / 2 + bb.y1;
            } else {
                // otherwise set automatically
                while(used(row, col))moveToNextCell();
                x = col * cellWidth + cellWidth / 2 + bb.x1;
                y = row * cellHeight + cellHeight / 2 + bb.y1;
                use(row, col);
                moveToNextCell();
            }
            return {
                x: x,
                y: y
            };
        };
        nodes.layoutPositions(this, options, getPos);
    }
    return this; // chaining
};
// default layout options
var $e815fda779bc047b$var$defaults$2 = {
    ready: function ready() {},
    // on layoutready
    stop: function stop() {} // on layoutstop
};
// constructor
// options : object containing layout options
function $e815fda779bc047b$var$NullLayout(options) {
    this.options = $e815fda779bc047b$var$extend({}, $e815fda779bc047b$var$defaults$2, options);
}
// runs the layout
$e815fda779bc047b$var$NullLayout.prototype.run = function() {
    var options = this.options;
    var eles = options.eles; // elements to consider in the layout
    var layout = this;
    // cy is automatically populated for us in the constructor
    // (disable eslint for next line as this serves as example layout code to external developers)
    // eslint-disable-next-line no-unused-vars
    options.cy;
    layout.emit('layoutstart');
    // puts all nodes at (0, 0)
    // n.b. most layouts would use layoutPositions(), instead of positions() and manual events
    eles.nodes().positions(function() {
        return {
            x: 0,
            y: 0
        };
    });
    // trigger layoutready when each node has had its position set at least once
    layout.one('layoutready', options.ready);
    layout.emit('layoutready');
    // trigger layoutstop when the layout stops (e.g. finishes)
    layout.one('layoutstop', options.stop);
    layout.emit('layoutstop');
    return this; // chaining
};
// called on continuous layouts to stop them before they finish
$e815fda779bc047b$var$NullLayout.prototype.stop = function() {
    return this; // chaining
};
var $e815fda779bc047b$var$defaults$1 = {
    positions: undefined,
    // map of (node id) => (position obj); or function(node){ return somPos; }
    zoom: undefined,
    // the zoom level to set (prob want fit = false if set)
    pan: undefined,
    // the pan level to set (prob want fit = false if set)
    fit: true,
    // whether to fit to viewport
    padding: 30,
    // padding on fit
    spacingFactor: undefined,
    // Applies a multiplicative factor (>0) to expand or compress the overall area that the nodes take up
    animate: false,
    // whether to transition the node positions
    animationDuration: 500,
    // duration of animation in ms if enabled
    animationEasing: undefined,
    // easing of animation if enabled
    animateFilter: function animateFilter(node, i) {
        return true;
    },
    // a function that determines whether the node should be animated.  All nodes animated by default on animate enabled.  Non-animated nodes are positioned immediately when the layout starts
    ready: undefined,
    // callback on layoutready
    stop: undefined,
    // callback on layoutstop
    transform: function transform(node, position) {
        return position;
    } // transform a given node position. Useful for changing flow direction in discrete layouts
};
function $e815fda779bc047b$var$PresetLayout(options) {
    this.options = $e815fda779bc047b$var$extend({}, $e815fda779bc047b$var$defaults$1, options);
}
$e815fda779bc047b$var$PresetLayout.prototype.run = function() {
    var options = this.options;
    var eles = options.eles;
    var nodes = eles.nodes();
    var posIsFn = $e815fda779bc047b$var$fn$6(options.positions);
    function getPosition(node) {
        if (options.positions == null) return $e815fda779bc047b$var$copyPosition(node.position());
        if (posIsFn) return options.positions(node);
        var pos = options.positions[node._private.data.id];
        if (pos == null) return null;
        return pos;
    }
    nodes.layoutPositions(this, options, function(node, i) {
        var position = getPosition(node);
        if (node.locked() || position == null) return false;
        return position;
    });
    return this; // chaining
};
var $e815fda779bc047b$var$defaults = {
    fit: true,
    // whether to fit to viewport
    padding: 30,
    // fit padding
    boundingBox: undefined,
    // constrain layout bounds; { x1, y1, x2, y2 } or { x1, y1, w, h }
    animate: false,
    // whether to transition the node positions
    animationDuration: 500,
    // duration of animation in ms if enabled
    animationEasing: undefined,
    // easing of animation if enabled
    animateFilter: function animateFilter(node, i) {
        return true;
    },
    // a function that determines whether the node should be animated.  All nodes animated by default on animate enabled.  Non-animated nodes are positioned immediately when the layout starts
    ready: undefined,
    // callback on layoutready
    stop: undefined,
    // callback on layoutstop
    transform: function transform(node, position) {
        return position;
    } // transform a given node position. Useful for changing flow direction in discrete layouts 
};
function $e815fda779bc047b$var$RandomLayout(options) {
    this.options = $e815fda779bc047b$var$extend({}, $e815fda779bc047b$var$defaults, options);
}
$e815fda779bc047b$var$RandomLayout.prototype.run = function() {
    var options = this.options;
    var cy = options.cy;
    var eles = options.eles;
    var bb = $e815fda779bc047b$var$makeBoundingBox(options.boundingBox ? options.boundingBox : {
        x1: 0,
        y1: 0,
        w: cy.width(),
        h: cy.height()
    });
    var getPos = function getPos(node, i) {
        return {
            x: bb.x1 + Math.round(Math.random() * bb.w),
            y: bb.y1 + Math.round(Math.random() * bb.h)
        };
    };
    eles.nodes().layoutPositions(this, options, getPos);
    return this; // chaining
};
var $e815fda779bc047b$var$layout = [
    {
        name: 'breadthfirst',
        impl: $e815fda779bc047b$var$BreadthFirstLayout
    },
    {
        name: 'circle',
        impl: $e815fda779bc047b$var$CircleLayout
    },
    {
        name: 'concentric',
        impl: $e815fda779bc047b$var$ConcentricLayout
    },
    {
        name: 'cose',
        impl: $e815fda779bc047b$var$CoseLayout
    },
    {
        name: 'grid',
        impl: $e815fda779bc047b$var$GridLayout
    },
    {
        name: 'null',
        impl: $e815fda779bc047b$var$NullLayout
    },
    {
        name: 'preset',
        impl: $e815fda779bc047b$var$PresetLayout
    },
    {
        name: 'random',
        impl: $e815fda779bc047b$var$RandomLayout
    }
];
function $e815fda779bc047b$var$NullRenderer(options) {
    this.options = options;
    this.notifications = 0; // for testing
}
var $e815fda779bc047b$var$noop = function noop() {};
var $e815fda779bc047b$var$throwImgErr = function throwImgErr() {
    throw new Error('A headless instance can not render images');
};
$e815fda779bc047b$var$NullRenderer.prototype = {
    recalculateRenderedStyle: $e815fda779bc047b$var$noop,
    notify: function notify() {
        this.notifications++;
    },
    init: $e815fda779bc047b$var$noop,
    isHeadless: function isHeadless() {
        return true;
    },
    png: $e815fda779bc047b$var$throwImgErr,
    jpg: $e815fda779bc047b$var$throwImgErr
};
var $e815fda779bc047b$var$BRp$f = {};
$e815fda779bc047b$var$BRp$f.arrowShapeWidth = 0.3;
$e815fda779bc047b$var$BRp$f.registerArrowShapes = function() {
    var arrowShapes = this.arrowShapes = {};
    var renderer = this;
    // Contract for arrow shapes:
    // 0, 0 is arrow tip
    // (0, 1) is direction towards node
    // (1, 0) is right
    //
    // functional api:
    // collide: check x, y in shape
    // roughCollide: called before collide, no false negatives
    // draw: draw
    // spacing: dist(arrowTip, nodeBoundary)
    // gap: dist(edgeTip, nodeBoundary), edgeTip may != arrowTip
    var bbCollide = function bbCollide(x, y, size, angle, translation, edgeWidth, padding) {
        var x1 = translation.x - size / 2 - padding;
        var x2 = translation.x + size / 2 + padding;
        var y1 = translation.y - size / 2 - padding;
        var y2 = translation.y + size / 2 + padding;
        var inside = x1 <= x && x <= x2 && y1 <= y && y <= y2;
        return inside;
    };
    var transform = function transform(x, y, size, angle, translation) {
        var xRotated = x * Math.cos(angle) - y * Math.sin(angle);
        var yRotated = x * Math.sin(angle) + y * Math.cos(angle);
        var xScaled = xRotated * size;
        var yScaled = yRotated * size;
        var xTranslated = xScaled + translation.x;
        var yTranslated = yScaled + translation.y;
        return {
            x: xTranslated,
            y: yTranslated
        };
    };
    var transformPoints = function transformPoints(pts, size, angle, translation) {
        var retPts = [];
        for(var i = 0; i < pts.length; i += 2){
            var x = pts[i];
            var y = pts[i + 1];
            retPts.push(transform(x, y, size, angle, translation));
        }
        return retPts;
    };
    var pointsToArr = function pointsToArr(pts) {
        var ret = [];
        for(var i = 0; i < pts.length; i++){
            var p = pts[i];
            ret.push(p.x, p.y);
        }
        return ret;
    };
    var standardGap = function standardGap(edge) {
        return edge.pstyle('width').pfValue * edge.pstyle('arrow-scale').pfValue * 2;
    };
    var defineArrowShape = function defineArrowShape(name, defn) {
        if ($e815fda779bc047b$var$string(defn)) defn = arrowShapes[defn];
        arrowShapes[name] = $e815fda779bc047b$var$extend({
            name: name,
            points: [
                -0.15,
                -0.3,
                0.15,
                -0.3,
                0.15,
                0.3,
                -0.15,
                0.3
            ],
            collide: function collide(x, y, size, angle, translation, padding) {
                var points = pointsToArr(transformPoints(this.points, size + 2 * padding, angle, translation));
                var inside = $e815fda779bc047b$var$pointInsidePolygonPoints(x, y, points);
                return inside;
            },
            roughCollide: bbCollide,
            draw: function draw(context, size, angle, translation) {
                var points = transformPoints(this.points, size, angle, translation);
                renderer.arrowShapeImpl('polygon')(context, points);
            },
            spacing: function spacing(edge) {
                return 0;
            },
            gap: standardGap
        }, defn);
    };
    defineArrowShape('none', {
        collide: $e815fda779bc047b$var$falsify,
        roughCollide: $e815fda779bc047b$var$falsify,
        draw: $e815fda779bc047b$var$noop$1,
        spacing: $e815fda779bc047b$var$zeroify,
        gap: $e815fda779bc047b$var$zeroify
    });
    defineArrowShape('triangle', {
        points: [
            -0.15,
            -0.3,
            0,
            0,
            0.15,
            -0.3
        ]
    });
    defineArrowShape('arrow', 'triangle');
    defineArrowShape('triangle-backcurve', {
        points: arrowShapes['triangle'].points,
        controlPoint: [
            0,
            -0.15
        ],
        roughCollide: bbCollide,
        draw: function draw(context, size, angle, translation, edgeWidth) {
            var ptsTrans = transformPoints(this.points, size, angle, translation);
            var ctrlPt = this.controlPoint;
            var ctrlPtTrans = transform(ctrlPt[0], ctrlPt[1], size, angle, translation);
            renderer.arrowShapeImpl(this.name)(context, ptsTrans, ctrlPtTrans);
        },
        gap: function gap(edge) {
            return standardGap(edge) * 0.8;
        }
    });
    defineArrowShape('triangle-tee', {
        points: [
            0,
            0,
            0.15,
            -0.3,
            -0.15,
            -0.3,
            0,
            0
        ],
        pointsTee: [
            -0.15,
            -0.4,
            -0.15,
            -0.5,
            0.15,
            -0.5,
            0.15,
            -0.4
        ],
        collide: function collide(x, y, size, angle, translation, edgeWidth, padding) {
            var triPts = pointsToArr(transformPoints(this.points, size + 2 * padding, angle, translation));
            var teePts = pointsToArr(transformPoints(this.pointsTee, size + 2 * padding, angle, translation));
            var inside = $e815fda779bc047b$var$pointInsidePolygonPoints(x, y, triPts) || $e815fda779bc047b$var$pointInsidePolygonPoints(x, y, teePts);
            return inside;
        },
        draw: function draw(context, size, angle, translation, edgeWidth) {
            var triPts = transformPoints(this.points, size, angle, translation);
            var teePts = transformPoints(this.pointsTee, size, angle, translation);
            renderer.arrowShapeImpl(this.name)(context, triPts, teePts);
        }
    });
    defineArrowShape('circle-triangle', {
        radius: 0.15,
        pointsTr: [
            0,
            -0.15,
            0.15,
            -0.45,
            -0.15,
            -0.45,
            0,
            -0.15
        ],
        collide: function collide(x, y, size, angle, translation, edgeWidth, padding) {
            var t = translation;
            var circleInside = Math.pow(t.x - x, 2) + Math.pow(t.y - y, 2) <= Math.pow((size + 2 * padding) * this.radius, 2);
            var triPts = pointsToArr(transformPoints(this.points, size + 2 * padding, angle, translation));
            return $e815fda779bc047b$var$pointInsidePolygonPoints(x, y, triPts) || circleInside;
        },
        draw: function draw(context, size, angle, translation, edgeWidth) {
            var triPts = transformPoints(this.pointsTr, size, angle, translation);
            renderer.arrowShapeImpl(this.name)(context, triPts, translation.x, translation.y, this.radius * size);
        },
        spacing: function spacing(edge) {
            return renderer.getArrowWidth(edge.pstyle('width').pfValue, edge.pstyle('arrow-scale').value) * this.radius;
        }
    });
    defineArrowShape('triangle-cross', {
        points: [
            0,
            0,
            0.15,
            -0.3,
            -0.15,
            -0.3,
            0,
            0
        ],
        baseCrossLinePts: [
            -0.15,
            -0.4,
            // first half of the rectangle
            -0.15,
            -0.4,
            0.15,
            -0.4,
            // second half of the rectangle
            0.15,
            -0.4
        ],
        crossLinePts: function crossLinePts(size, edgeWidth) {
            // shift points so that the distance between the cross points matches edge width
            var p = this.baseCrossLinePts.slice();
            var shiftFactor = edgeWidth / size;
            var y0 = 3;
            var y1 = 5;
            p[y0] = p[y0] - shiftFactor;
            p[y1] = p[y1] - shiftFactor;
            return p;
        },
        collide: function collide(x, y, size, angle, translation, edgeWidth, padding) {
            var triPts = pointsToArr(transformPoints(this.points, size + 2 * padding, angle, translation));
            var teePts = pointsToArr(transformPoints(this.crossLinePts(size, edgeWidth), size + 2 * padding, angle, translation));
            var inside = $e815fda779bc047b$var$pointInsidePolygonPoints(x, y, triPts) || $e815fda779bc047b$var$pointInsidePolygonPoints(x, y, teePts);
            return inside;
        },
        draw: function draw(context, size, angle, translation, edgeWidth) {
            var triPts = transformPoints(this.points, size, angle, translation);
            var crossLinePts = transformPoints(this.crossLinePts(size, edgeWidth), size, angle, translation);
            renderer.arrowShapeImpl(this.name)(context, triPts, crossLinePts);
        }
    });
    defineArrowShape('vee', {
        points: [
            -0.15,
            -0.3,
            0,
            0,
            0.15,
            -0.3,
            0,
            -0.15
        ],
        gap: function gap(edge) {
            return standardGap(edge) * 0.525;
        }
    });
    defineArrowShape('circle', {
        radius: 0.15,
        collide: function collide(x, y, size, angle, translation, edgeWidth, padding) {
            var t = translation;
            var inside = Math.pow(t.x - x, 2) + Math.pow(t.y - y, 2) <= Math.pow((size + 2 * padding) * this.radius, 2);
            return inside;
        },
        draw: function draw(context, size, angle, translation, edgeWidth) {
            renderer.arrowShapeImpl(this.name)(context, translation.x, translation.y, this.radius * size);
        },
        spacing: function spacing(edge) {
            return renderer.getArrowWidth(edge.pstyle('width').pfValue, edge.pstyle('arrow-scale').value) * this.radius;
        }
    });
    defineArrowShape('tee', {
        points: [
            -0.15,
            0,
            -0.15,
            -0.1,
            0.15,
            -0.1,
            0.15,
            0
        ],
        spacing: function spacing(edge) {
            return 1;
        },
        gap: function gap(edge) {
            return 1;
        }
    });
    defineArrowShape('square', {
        points: [
            -0.15,
            0.00,
            0.15,
            0.00,
            0.15,
            -0.3,
            -0.15,
            -0.3
        ]
    });
    defineArrowShape('diamond', {
        points: [
            -0.15,
            -0.15,
            0,
            -0.3,
            0.15,
            -0.15,
            0,
            0
        ],
        gap: function gap(edge) {
            return edge.pstyle('width').pfValue * edge.pstyle('arrow-scale').value;
        }
    });
    defineArrowShape('chevron', {
        points: [
            0,
            0,
            -0.15,
            -0.15,
            -0.1,
            -0.2,
            0,
            -0.1,
            0.1,
            -0.2,
            0.15,
            -0.15
        ],
        gap: function gap(edge) {
            return 0.95 * edge.pstyle('width').pfValue * edge.pstyle('arrow-scale').value;
        }
    });
};
var $e815fda779bc047b$var$BRp$e = {};
// Project mouse
$e815fda779bc047b$var$BRp$e.projectIntoViewport = function(clientX, clientY) {
    var cy = this.cy;
    var offsets = this.findContainerClientCoords();
    var offsetLeft = offsets[0];
    var offsetTop = offsets[1];
    var scale = offsets[4];
    var pan = cy.pan();
    var zoom = cy.zoom();
    var x = ((clientX - offsetLeft) / scale - pan.x) / zoom;
    var y = ((clientY - offsetTop) / scale - pan.y) / zoom;
    return [
        x,
        y
    ];
};
$e815fda779bc047b$var$BRp$e.findContainerClientCoords = function() {
    if (this.containerBB) return this.containerBB;
    var container = this.container;
    var rect = container.getBoundingClientRect();
    var style = this.cy.window().getComputedStyle(container);
    var styleValue = function styleValue(name) {
        return parseFloat(style.getPropertyValue(name));
    };
    var padding = {
        left: styleValue('padding-left'),
        right: styleValue('padding-right'),
        top: styleValue('padding-top'),
        bottom: styleValue('padding-bottom')
    };
    var border = {
        left: styleValue('border-left-width'),
        right: styleValue('border-right-width'),
        top: styleValue('border-top-width'),
        bottom: styleValue('border-bottom-width')
    };
    var clientWidth = container.clientWidth;
    var clientHeight = container.clientHeight;
    var paddingHor = padding.left + padding.right;
    var paddingVer = padding.top + padding.bottom;
    var borderHor = border.left + border.right;
    var scale = rect.width / (clientWidth + borderHor);
    var unscaledW = clientWidth - paddingHor;
    var unscaledH = clientHeight - paddingVer;
    var left = rect.left + padding.left + border.left;
    var top = rect.top + padding.top + border.top;
    return this.containerBB = [
        left,
        top,
        unscaledW,
        unscaledH,
        scale
    ];
};
$e815fda779bc047b$var$BRp$e.invalidateContainerClientCoordsCache = function() {
    this.containerBB = null;
};
$e815fda779bc047b$var$BRp$e.findNearestElement = function(x, y, interactiveElementsOnly, isTouch) {
    return this.findNearestElements(x, y, interactiveElementsOnly, isTouch)[0];
};
$e815fda779bc047b$var$BRp$e.findNearestElements = function(x, y, interactiveElementsOnly, isTouch) {
    var self1 = this;
    var r = this;
    var eles = r.getCachedZSortedEles();
    var near = []; // 1 node max, 1 edge max
    var zoom = r.cy.zoom();
    var hasCompounds = r.cy.hasCompoundNodes();
    var edgeThreshold = (isTouch ? 24 : 8) / zoom;
    var nodeThreshold = (isTouch ? 8 : 2) / zoom;
    var labelThreshold = (isTouch ? 8 : 2) / zoom;
    var minSqDist = Infinity;
    var nearEdge;
    var nearNode;
    if (interactiveElementsOnly) eles = eles.interactive;
    function addEle(ele, sqDist) {
        if (ele.isNode()) {
            if (nearNode) return; // can't replace node
            else {
                nearNode = ele;
                near.push(ele);
            }
        }
        if (ele.isEdge() && (sqDist == null || sqDist < minSqDist)) {
            if (nearEdge) // then replace existing edge
            // can replace only if same z-index
            {
                if (nearEdge.pstyle('z-compound-depth').value === ele.pstyle('z-compound-depth').value && nearEdge.pstyle('z-compound-depth').value === ele.pstyle('z-compound-depth').value) {
                    for(var i = 0; i < near.length; i++)if (near[i].isEdge()) {
                        near[i] = ele;
                        nearEdge = ele;
                        minSqDist = sqDist != null ? sqDist : minSqDist;
                        break;
                    }
                }
            } else {
                near.push(ele);
                nearEdge = ele;
                minSqDist = sqDist != null ? sqDist : minSqDist;
            }
        }
    }
    function checkNode(node) {
        var width = node.outerWidth() + 2 * nodeThreshold;
        var height = node.outerHeight() + 2 * nodeThreshold;
        var hw = width / 2;
        var hh = height / 2;
        var pos = node.position();
        var cornerRadius = node.pstyle('corner-radius').value === 'auto' ? 'auto' : node.pstyle('corner-radius').pfValue;
        var rs = node._private.rscratch;
        if (pos.x - hw <= x && x <= pos.x + hw // bb check x
         && pos.y - hh <= y && y <= pos.y + hh // bb check y
        ) {
            var shape = r.nodeShapes[self1.getNodeShape(node)];
            if (shape.checkPoint(x, y, 0, width, height, pos.x, pos.y, cornerRadius, rs)) {
                addEle(node, 0);
                return true;
            }
        }
    }
    function checkEdge(edge) {
        var _p = edge._private;
        var rs = _p.rscratch;
        var styleWidth = edge.pstyle('width').pfValue;
        var scale = edge.pstyle('arrow-scale').value;
        var width = styleWidth / 2 + edgeThreshold; // more like a distance radius from centre
        var widthSq = width * width;
        var width2 = width * 2;
        var src = _p.source;
        var tgt = _p.target;
        var sqDist;
        if (rs.edgeType === 'segments' || rs.edgeType === 'straight' || rs.edgeType === 'haystack') {
            var pts = rs.allpts;
            for(var i = 0; i + 3 < pts.length; i += 2)if ($e815fda779bc047b$var$inLineVicinity(x, y, pts[i], pts[i + 1], pts[i + 2], pts[i + 3], width2) && widthSq > (sqDist = $e815fda779bc047b$var$sqdistToFiniteLine(x, y, pts[i], pts[i + 1], pts[i + 2], pts[i + 3]))) {
                addEle(edge, sqDist);
                return true;
            }
        } else if (rs.edgeType === 'bezier' || rs.edgeType === 'multibezier' || rs.edgeType === 'self' || rs.edgeType === 'compound') {
            var pts = rs.allpts;
            for(var i = 0; i + 5 < rs.allpts.length; i += 4)if ($e815fda779bc047b$var$inBezierVicinity(x, y, pts[i], pts[i + 1], pts[i + 2], pts[i + 3], pts[i + 4], pts[i + 5], width2) && widthSq > (sqDist = $e815fda779bc047b$var$sqdistToQuadraticBezier(x, y, pts[i], pts[i + 1], pts[i + 2], pts[i + 3], pts[i + 4], pts[i + 5]))) {
                addEle(edge, sqDist);
                return true;
            }
        }
        // if we're close to the edge but didn't hit it, maybe we hit its arrows
        var src = src || _p.source;
        var tgt = tgt || _p.target;
        var arSize = self1.getArrowWidth(styleWidth, scale);
        var arrows = [
            {
                name: 'source',
                x: rs.arrowStartX,
                y: rs.arrowStartY,
                angle: rs.srcArrowAngle
            },
            {
                name: 'target',
                x: rs.arrowEndX,
                y: rs.arrowEndY,
                angle: rs.tgtArrowAngle
            },
            {
                name: 'mid-source',
                x: rs.midX,
                y: rs.midY,
                angle: rs.midsrcArrowAngle
            },
            {
                name: 'mid-target',
                x: rs.midX,
                y: rs.midY,
                angle: rs.midtgtArrowAngle
            }
        ];
        for(var i = 0; i < arrows.length; i++){
            var ar = arrows[i];
            var shape = r.arrowShapes[edge.pstyle(ar.name + '-arrow-shape').value];
            var edgeWidth = edge.pstyle('width').pfValue;
            if (shape.roughCollide(x, y, arSize, ar.angle, {
                x: ar.x,
                y: ar.y
            }, edgeWidth, edgeThreshold) && shape.collide(x, y, arSize, ar.angle, {
                x: ar.x,
                y: ar.y
            }, edgeWidth, edgeThreshold)) {
                addEle(edge);
                return true;
            }
        }
        // for compound graphs, hitting edge may actually want a connected node instead (b/c edge may have greater z-index precedence)
        if (hasCompounds && near.length > 0) {
            checkNode(src);
            checkNode(tgt);
        }
    }
    function preprop(obj, name, pre) {
        return $e815fda779bc047b$var$getPrefixedProperty(obj, name, pre);
    }
    function checkLabel(ele, prefix) {
        var _p = ele._private;
        var th = labelThreshold;
        var prefixDash;
        if (prefix) prefixDash = prefix + '-';
        else prefixDash = '';
        ele.boundingBox();
        var bb = _p.labelBounds[prefix || 'main'];
        var text = ele.pstyle(prefixDash + 'label').value;
        var eventsEnabled = ele.pstyle('text-events').strValue === 'yes';
        if (!eventsEnabled || !text) return;
        var lx = preprop(_p.rscratch, 'labelX', prefix);
        var ly = preprop(_p.rscratch, 'labelY', prefix);
        var theta = preprop(_p.rscratch, 'labelAngle', prefix);
        var ox = ele.pstyle(prefixDash + 'text-margin-x').pfValue;
        var oy = ele.pstyle(prefixDash + 'text-margin-y').pfValue;
        var lx1 = bb.x1 - th - ox; // (-ox, -oy) as bb already includes margin
        var lx2 = bb.x2 + th - ox; // and rotation is about (lx, ly)
        var ly1 = bb.y1 - th - oy;
        var ly2 = bb.y2 + th - oy;
        if (theta) {
            var cos = Math.cos(theta);
            var sin = Math.sin(theta);
            var rotate = function rotate(x, y) {
                x = x - lx;
                y = y - ly;
                return {
                    x: x * cos - y * sin + lx,
                    y: x * sin + y * cos + ly
                };
            };
            var px1y1 = rotate(lx1, ly1);
            var px1y2 = rotate(lx1, ly2);
            var px2y1 = rotate(lx2, ly1);
            var px2y2 = rotate(lx2, ly2);
            var points = [
                // with the margin added after the rotation is applied
                px1y1.x + ox,
                px1y1.y + oy,
                px2y1.x + ox,
                px2y1.y + oy,
                px2y2.x + ox,
                px2y2.y + oy,
                px1y2.x + ox,
                px1y2.y + oy
            ];
            if ($e815fda779bc047b$var$pointInsidePolygonPoints(x, y, points)) {
                addEle(ele);
                return true;
            }
        } else // do a cheaper bb check
        if ($e815fda779bc047b$var$inBoundingBox(bb, x, y)) {
            addEle(ele);
            return true;
        }
    }
    for(var i = eles.length - 1; i >= 0; i--){
        // reverse order for precedence
        var ele = eles[i];
        if (ele.isNode()) checkNode(ele) || checkLabel(ele);
        else // then edge
        checkEdge(ele) || checkLabel(ele) || checkLabel(ele, 'source') || checkLabel(ele, 'target');
    }
    return near;
};
// 'Give me everything from this box'
$e815fda779bc047b$var$BRp$e.getAllInBox = function(x1, y1, x2, y2) {
    var eles = this.getCachedZSortedEles().interactive;
    var zoom = this.cy.zoom();
    var labelThreshold = 2 / zoom;
    var box = [];
    var x1c = Math.min(x1, x2);
    var x2c = Math.max(x1, x2);
    var y1c = Math.min(y1, y2);
    var y2c = Math.max(y1, y2);
    x1 = x1c;
    x2 = x2c;
    y1 = y1c;
    y2 = y2c;
    var boxBb = $e815fda779bc047b$var$makeBoundingBox({
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    });
    var selectionBox = [
        {
            x: boxBb.x1,
            y: boxBb.y1
        },
        {
            x: boxBb.x2,
            y: boxBb.y1
        },
        {
            x: boxBb.x2,
            y: boxBb.y2
        },
        {
            x: boxBb.x1,
            y: boxBb.y2
        }
    ];
    var boxEdges = [
        [
            selectionBox[0],
            selectionBox[1]
        ],
        [
            selectionBox[1],
            selectionBox[2]
        ],
        [
            selectionBox[2],
            selectionBox[3]
        ],
        [
            selectionBox[3],
            selectionBox[0]
        ]
    ];
    function preprop(obj, name, pre) {
        return $e815fda779bc047b$var$getPrefixedProperty(obj, name, pre);
    }
    function getRotatedLabelBox(ele, prefix) {
        var _p = ele._private;
        var th = labelThreshold;
        var prefixDash = '';
        ele.boundingBox();
        var bb = _p.labelBounds['main'];
        // If the bounding box is not available, return null.
        // This indicates that the label box cannot be calculated, which is consistent
        // with the expected behavior of this function. Returning null allows the caller
        // to handle the absence of a bounding box explicitly.
        if (!bb) return null;
        var lx = preprop(_p.rscratch, 'labelX', prefix);
        var ly = preprop(_p.rscratch, 'labelY', prefix);
        var theta = preprop(_p.rscratch, 'labelAngle', prefix);
        var ox = ele.pstyle(prefixDash + 'text-margin-x').pfValue;
        var oy = ele.pstyle(prefixDash + 'text-margin-y').pfValue;
        var lx1 = bb.x1 - th - ox;
        var lx2 = bb.x2 + th - ox;
        var ly1 = bb.y1 - th - oy;
        var ly2 = bb.y2 + th - oy;
        if (theta) {
            var cos = Math.cos(theta);
            var sin = Math.sin(theta);
            var rotate = function rotate(x, y) {
                x = x - lx;
                y = y - ly;
                return {
                    x: x * cos - y * sin + lx,
                    y: x * sin + y * cos + ly
                };
            };
            return [
                rotate(lx1, ly1),
                rotate(lx2, ly1),
                rotate(lx2, ly2),
                rotate(lx1, ly2)
            ];
        } else return [
            {
                x: lx1,
                y: ly1
            },
            {
                x: lx2,
                y: ly1
            },
            {
                x: lx2,
                y: ly2
            },
            {
                x: lx1,
                y: ly2
            }
        ];
    }
    function doLinesIntersect(p1, p2, q1, q2) {
        function ccw(a, b, c) {
            return (c.y - a.y) * (b.x - a.x) > (b.y - a.y) * (c.x - a.x);
        }
        return ccw(p1, q1, q2) !== ccw(p2, q1, q2) && ccw(p1, p2, q1) !== ccw(p1, p2, q2);
    }
    for(var e = 0; e < eles.length; e++){
        var ele = eles[e];
        if (ele.isNode()) {
            var node = ele;
            var textEvents = node.pstyle('text-events').strValue === 'yes';
            var nodeBoxSelectMode = node.pstyle('box-selection').strValue;
            var labelBoxSelectEnabled = node.pstyle('box-select-labels').strValue === 'yes';
            if (nodeBoxSelectMode === 'none') continue;
            var includeLabels = (nodeBoxSelectMode === 'overlap' || labelBoxSelectEnabled) && textEvents;
            var nodeBb = node.boundingBox({
                includeNodes: true,
                includeEdges: false,
                includeLabels: includeLabels
            });
            if (nodeBoxSelectMode === 'contain') {
                var selected = false;
                if (labelBoxSelectEnabled && textEvents) {
                    var rotatedLabelBox = getRotatedLabelBox(node);
                    if (rotatedLabelBox && $e815fda779bc047b$var$satPolygonIntersection(rotatedLabelBox, selectionBox)) {
                        box.push(node);
                        selected = true;
                    }
                }
                if (!selected && $e815fda779bc047b$var$boundingBoxInBoundingBox(boxBb, nodeBb)) box.push(node);
            } else if (nodeBoxSelectMode === 'overlap') {
                if ($e815fda779bc047b$var$boundingBoxesIntersect(boxBb, nodeBb)) {
                    var nodeBodyBb = node.boundingBox({
                        includeNodes: true,
                        includeEdges: true,
                        includeLabels: false,
                        includeMainLabels: false,
                        includeSourceLabels: false,
                        includeTargetLabels: false
                    });
                    var nodeBodyCorners = [
                        {
                            x: nodeBodyBb.x1,
                            y: nodeBodyBb.y1
                        },
                        {
                            x: nodeBodyBb.x2,
                            y: nodeBodyBb.y1
                        },
                        {
                            x: nodeBodyBb.x2,
                            y: nodeBodyBb.y2
                        },
                        {
                            x: nodeBodyBb.x1,
                            y: nodeBodyBb.y2
                        }
                    ];
                    // if node body intersects, no need to check label
                    if ($e815fda779bc047b$var$satPolygonIntersection(nodeBodyCorners, selectionBox)) box.push(node);
                    else {
                        // only check label if node body didn't intersect
                        var _rotatedLabelBox = getRotatedLabelBox(node);
                        if (_rotatedLabelBox && $e815fda779bc047b$var$satPolygonIntersection(_rotatedLabelBox, selectionBox)) box.push(node);
                    }
                }
            }
        } else {
            var edge = ele;
            var _p = edge._private;
            var rs = _p.rscratch;
            var edgeBoxSelectMode = edge.pstyle('box-selection').strValue;
            if (edgeBoxSelectMode === 'none') continue;
            if (edgeBoxSelectMode === 'contain') {
                if (rs.startX != null && rs.startY != null && !$e815fda779bc047b$var$inBoundingBox(boxBb, rs.startX, rs.startY)) continue;
                if (rs.endX != null && rs.endY != null && !$e815fda779bc047b$var$inBoundingBox(boxBb, rs.endX, rs.endY)) continue;
                if (rs.edgeType === 'bezier' || rs.edgeType === 'multibezier' || rs.edgeType === 'self' || rs.edgeType === 'compound' || rs.edgeType === 'segments' || rs.edgeType === 'haystack') {
                    var pts = _p.rstyle.bezierPts || _p.rstyle.linePts || _p.rstyle.haystackPts;
                    var allInside = true;
                    for(var i = 0; i < pts.length; i++)if (!$e815fda779bc047b$var$pointInBoundingBox(boxBb, pts[i])) {
                        allInside = false;
                        break;
                    }
                    if (allInside) box.push(edge);
                } else if (rs.edgeType === 'straight') box.push(edge);
            } else if (edgeBoxSelectMode === 'overlap') {
                var _selected = false;
                // Check: either endpoint inside box
                if (rs.startX != null && rs.startY != null && rs.endX != null && rs.endY != null && ($e815fda779bc047b$var$inBoundingBox(boxBb, rs.startX, rs.startY) || $e815fda779bc047b$var$inBoundingBox(boxBb, rs.endX, rs.endY))) {
                    box.push(edge);
                    _selected = true;
                } else if (!_selected && rs.edgeType === 'haystack') {
                    var haystackPts = _p.rstyle.haystackPts;
                    for(var _i = 0; _i < haystackPts.length; _i++)if ($e815fda779bc047b$var$pointInBoundingBox(boxBb, haystackPts[_i])) {
                        box.push(edge);
                        _selected = true;
                        break;
                    }
                }
                // Segment intersection check (only if not already selected)
                if (!_selected) {
                    var _pts = _p.rstyle.bezierPts || _p.rstyle.linePts || _p.rstyle.haystackPts;
                    // straight edges
                    if ((!_pts || _pts.length < 2) && rs.edgeType === 'straight') {
                        if (rs.startX != null && rs.startY != null && rs.endX != null && rs.endY != null) _pts = [
                            {
                                x: rs.startX,
                                y: rs.startY
                            },
                            {
                                x: rs.endX,
                                y: rs.endY
                            }
                        ];
                    }
                    if (!_pts || _pts.length < 2) continue;
                    for(var _i2 = 0; _i2 < _pts.length - 1; _i2++){
                        var segStart = _pts[_i2];
                        var segEnd = _pts[_i2 + 1];
                        for(var b = 0; b < boxEdges.length; b++){
                            var _boxEdges$b = $e815fda779bc047b$var$_slicedToArray(boxEdges[b], 2), boxStart = _boxEdges$b[0], boxEnd = _boxEdges$b[1];
                            if (doLinesIntersect(segStart, segEnd, boxStart, boxEnd)) {
                                box.push(edge);
                                _selected = true;
                                break;
                            }
                        }
                        if (_selected) break;
                    }
                }
            }
        }
    }
    return box;
};
var $e815fda779bc047b$var$BRp$d = {};
$e815fda779bc047b$var$BRp$d.calculateArrowAngles = function(edge) {
    var rs = edge._private.rscratch;
    var isHaystack = rs.edgeType === 'haystack';
    var isBezier = rs.edgeType === 'bezier';
    var isMultibezier = rs.edgeType === 'multibezier';
    var isSegments = rs.edgeType === 'segments';
    var isCompound = rs.edgeType === 'compound';
    var isSelf = rs.edgeType === 'self';
    // Displacement gives direction for arrowhead orientation
    var dispX, dispY;
    var startX, startY, endX, endY, midX, midY;
    if (isHaystack) {
        startX = rs.haystackPts[0];
        startY = rs.haystackPts[1];
        endX = rs.haystackPts[2];
        endY = rs.haystackPts[3];
    } else {
        startX = rs.arrowStartX;
        startY = rs.arrowStartY;
        endX = rs.arrowEndX;
        endY = rs.arrowEndY;
    }
    midX = rs.midX;
    midY = rs.midY;
    // source
    //
    if (isSegments) {
        dispX = startX - rs.segpts[0];
        dispY = startY - rs.segpts[1];
    } else if (isMultibezier || isCompound || isSelf || isBezier) {
        var pts = rs.allpts;
        var bX = $e815fda779bc047b$var$qbezierAt(pts[0], pts[2], pts[4], 0.1);
        var bY = $e815fda779bc047b$var$qbezierAt(pts[1], pts[3], pts[5], 0.1);
        dispX = startX - bX;
        dispY = startY - bY;
    } else {
        dispX = startX - midX;
        dispY = startY - midY;
    }
    rs.srcArrowAngle = $e815fda779bc047b$var$getAngleFromDisp(dispX, dispY);
    // mid target
    //
    var midX = rs.midX;
    var midY = rs.midY;
    if (isHaystack) {
        midX = (startX + endX) / 2;
        midY = (startY + endY) / 2;
    }
    dispX = endX - startX;
    dispY = endY - startY;
    if (isSegments) {
        var pts = rs.allpts;
        if (pts.length / 2 % 2 === 0) {
            var i2 = pts.length / 2;
            var i1 = i2 - 2;
            dispX = pts[i2] - pts[i1];
            dispY = pts[i2 + 1] - pts[i1 + 1];
        } else if (rs.isRound) {
            dispX = rs.midVector[1];
            dispY = -rs.midVector[0];
        } else {
            var i2 = pts.length / 2 - 1;
            var i1 = i2 - 2;
            dispX = pts[i2] - pts[i1];
            dispY = pts[i2 + 1] - pts[i1 + 1];
        }
    } else if (isMultibezier || isCompound || isSelf) {
        var pts = rs.allpts;
        var cpts = rs.ctrlpts;
        var bp0x, bp0y;
        var bp1x, bp1y;
        if (cpts.length / 2 % 2 === 0) {
            var p0 = pts.length / 2 - 1; // startpt
            var ic = p0 + 2;
            var p1 = ic + 2;
            bp0x = $e815fda779bc047b$var$qbezierAt(pts[p0], pts[ic], pts[p1], 0.0);
            bp0y = $e815fda779bc047b$var$qbezierAt(pts[p0 + 1], pts[ic + 1], pts[p1 + 1], 0.0);
            bp1x = $e815fda779bc047b$var$qbezierAt(pts[p0], pts[ic], pts[p1], 0.0001);
            bp1y = $e815fda779bc047b$var$qbezierAt(pts[p0 + 1], pts[ic + 1], pts[p1 + 1], 0.0001);
        } else {
            var ic = pts.length / 2 - 1; // ctrpt
            var p0 = ic - 2; // startpt
            var p1 = ic + 2; // endpt
            bp0x = $e815fda779bc047b$var$qbezierAt(pts[p0], pts[ic], pts[p1], 0.4999);
            bp0y = $e815fda779bc047b$var$qbezierAt(pts[p0 + 1], pts[ic + 1], pts[p1 + 1], 0.4999);
            bp1x = $e815fda779bc047b$var$qbezierAt(pts[p0], pts[ic], pts[p1], 0.5);
            bp1y = $e815fda779bc047b$var$qbezierAt(pts[p0 + 1], pts[ic + 1], pts[p1 + 1], 0.5);
        }
        dispX = bp1x - bp0x;
        dispY = bp1y - bp0y;
    }
    rs.midtgtArrowAngle = $e815fda779bc047b$var$getAngleFromDisp(dispX, dispY);
    rs.midDispX = dispX;
    rs.midDispY = dispY;
    // mid source
    //
    dispX *= -1;
    dispY *= -1;
    if (isSegments) {
        var pts = rs.allpts;
        if (pts.length / 2 % 2 === 0) ;
        else if (!rs.isRound) {
            var i2 = pts.length / 2 - 1;
            var i3 = i2 + 2;
            dispX = -(pts[i3] - pts[i2]);
            dispY = -(pts[i3 + 1] - pts[i2 + 1]);
        }
    }
    rs.midsrcArrowAngle = $e815fda779bc047b$var$getAngleFromDisp(dispX, dispY);
    // target
    //
    if (isSegments) {
        dispX = endX - rs.segpts[rs.segpts.length - 2];
        dispY = endY - rs.segpts[rs.segpts.length - 1];
    } else if (isMultibezier || isCompound || isSelf || isBezier) {
        var pts = rs.allpts;
        var l = pts.length;
        var bX = $e815fda779bc047b$var$qbezierAt(pts[l - 6], pts[l - 4], pts[l - 2], 0.9);
        var bY = $e815fda779bc047b$var$qbezierAt(pts[l - 5], pts[l - 3], pts[l - 1], 0.9);
        dispX = endX - bX;
        dispY = endY - bY;
    } else {
        dispX = endX - midX;
        dispY = endY - midY;
    }
    rs.tgtArrowAngle = $e815fda779bc047b$var$getAngleFromDisp(dispX, dispY);
};
$e815fda779bc047b$var$BRp$d.getArrowWidth = $e815fda779bc047b$var$BRp$d.getArrowHeight = function(edgeWidth, scale) {
    var cache = this.arrowWidthCache = this.arrowWidthCache || {};
    var cachedVal = cache[edgeWidth + ', ' + scale];
    if (cachedVal) return cachedVal;
    cachedVal = Math.max(Math.pow(edgeWidth * 13.37, 0.9), 29) * scale;
    cache[edgeWidth + ', ' + scale] = cachedVal;
    return cachedVal;
};
/**
 * Explained by Blindman67 at https://stackoverflow.com/a/44856925/11028828
 */ // Declare reused variable to avoid reallocating variables every time the function is called
var $e815fda779bc047b$var$x, $e815fda779bc047b$var$y, $e815fda779bc047b$var$v1 = {}, $e815fda779bc047b$var$v2 = {}, $e815fda779bc047b$var$sinA, $e815fda779bc047b$var$sinA90, $e815fda779bc047b$var$radDirection, $e815fda779bc047b$var$drawDirection, $e815fda779bc047b$var$angle, $e815fda779bc047b$var$halfAngle, $e815fda779bc047b$var$cRadius, $e815fda779bc047b$var$lenOut, $e815fda779bc047b$var$radius, $e815fda779bc047b$var$limit;
var $e815fda779bc047b$var$startX, $e815fda779bc047b$var$startY, $e815fda779bc047b$var$stopX, $e815fda779bc047b$var$stopY;
var $e815fda779bc047b$var$lastPoint;
// convert 2 points into vector form, polar form, and normalised
var $e815fda779bc047b$var$asVec = function asVec(p, pp, v) {
    v.x = pp.x - p.x;
    v.y = pp.y - p.y;
    v.len = Math.sqrt(v.x * v.x + v.y * v.y);
    v.nx = v.x / v.len;
    v.ny = v.y / v.len;
    v.ang = Math.atan2(v.ny, v.nx);
};
var $e815fda779bc047b$var$invertVec = function invertVec(originalV, invertedV) {
    invertedV.x = originalV.x * -1;
    invertedV.y = originalV.y * -1;
    invertedV.nx = originalV.nx * -1;
    invertedV.ny = originalV.ny * -1;
    invertedV.ang = originalV.ang > 0 ? -(Math.PI - originalV.ang) : Math.PI + originalV.ang;
};
var $e815fda779bc047b$var$calcCornerArc = function calcCornerArc(previousPoint, currentPoint, nextPoint, radiusMax, isArcRadius) {
    //-----------------------------------------
    // Part 1
    previousPoint !== $e815fda779bc047b$var$lastPoint ? $e815fda779bc047b$var$asVec(currentPoint, previousPoint, $e815fda779bc047b$var$v1) : $e815fda779bc047b$var$invertVec($e815fda779bc047b$var$v2, $e815fda779bc047b$var$v1); // Avoid recalculating vec if it is the invert of the last one calculated
    $e815fda779bc047b$var$asVec(currentPoint, nextPoint, $e815fda779bc047b$var$v2);
    $e815fda779bc047b$var$sinA = $e815fda779bc047b$var$v1.nx * $e815fda779bc047b$var$v2.ny - $e815fda779bc047b$var$v1.ny * $e815fda779bc047b$var$v2.nx;
    $e815fda779bc047b$var$sinA90 = $e815fda779bc047b$var$v1.nx * $e815fda779bc047b$var$v2.nx - $e815fda779bc047b$var$v1.ny * -$e815fda779bc047b$var$v2.ny;
    $e815fda779bc047b$var$angle = Math.asin(Math.max(-1, Math.min(1, $e815fda779bc047b$var$sinA)));
    if (Math.abs($e815fda779bc047b$var$angle) < 1e-6) {
        $e815fda779bc047b$var$x = currentPoint.x;
        $e815fda779bc047b$var$y = currentPoint.y;
        $e815fda779bc047b$var$cRadius = $e815fda779bc047b$var$radius = 0;
        return;
    }
    //-----------------------------------------
    $e815fda779bc047b$var$radDirection = 1;
    $e815fda779bc047b$var$drawDirection = false;
    if ($e815fda779bc047b$var$sinA90 < 0) {
        if ($e815fda779bc047b$var$angle < 0) $e815fda779bc047b$var$angle = Math.PI + $e815fda779bc047b$var$angle;
        else {
            $e815fda779bc047b$var$angle = Math.PI - $e815fda779bc047b$var$angle;
            $e815fda779bc047b$var$radDirection = -1;
            $e815fda779bc047b$var$drawDirection = true;
        }
    } else if ($e815fda779bc047b$var$angle > 0) {
        $e815fda779bc047b$var$radDirection = -1;
        $e815fda779bc047b$var$drawDirection = true;
    }
    if (currentPoint.radius !== undefined) $e815fda779bc047b$var$radius = currentPoint.radius;
    else $e815fda779bc047b$var$radius = radiusMax;
    //-----------------------------------------
    // Part 2
    $e815fda779bc047b$var$halfAngle = $e815fda779bc047b$var$angle / 2;
    //-----------------------------------------
    $e815fda779bc047b$var$limit = Math.min($e815fda779bc047b$var$v1.len / 2, $e815fda779bc047b$var$v2.len / 2);
    if (isArcRadius) {
        //-----------------------------------------
        // Part 3
        $e815fda779bc047b$var$lenOut = Math.abs(Math.cos($e815fda779bc047b$var$halfAngle) * $e815fda779bc047b$var$radius / Math.sin($e815fda779bc047b$var$halfAngle));
        //-----------------------------------------
        // Special part A
        if ($e815fda779bc047b$var$lenOut > $e815fda779bc047b$var$limit) {
            $e815fda779bc047b$var$lenOut = $e815fda779bc047b$var$limit;
            $e815fda779bc047b$var$cRadius = Math.abs($e815fda779bc047b$var$lenOut * Math.sin($e815fda779bc047b$var$halfAngle) / Math.cos($e815fda779bc047b$var$halfAngle));
        } else $e815fda779bc047b$var$cRadius = $e815fda779bc047b$var$radius;
    } else {
        $e815fda779bc047b$var$lenOut = Math.min($e815fda779bc047b$var$limit, $e815fda779bc047b$var$radius);
        $e815fda779bc047b$var$cRadius = Math.abs($e815fda779bc047b$var$lenOut * Math.sin($e815fda779bc047b$var$halfAngle) / Math.cos($e815fda779bc047b$var$halfAngle));
    }
    //-----------------------------------------
    //-----------------------------------------
    // Part 4
    $e815fda779bc047b$var$stopX = currentPoint.x + $e815fda779bc047b$var$v2.nx * $e815fda779bc047b$var$lenOut;
    $e815fda779bc047b$var$stopY = currentPoint.y + $e815fda779bc047b$var$v2.ny * $e815fda779bc047b$var$lenOut;
    //-----------------------------------------
    // Part 5
    $e815fda779bc047b$var$x = $e815fda779bc047b$var$stopX - $e815fda779bc047b$var$v2.ny * $e815fda779bc047b$var$cRadius * $e815fda779bc047b$var$radDirection;
    $e815fda779bc047b$var$y = $e815fda779bc047b$var$stopY + $e815fda779bc047b$var$v2.nx * $e815fda779bc047b$var$cRadius * $e815fda779bc047b$var$radDirection;
    //-----------------------------------------
    // Additional Part : calculate start point E
    $e815fda779bc047b$var$startX = currentPoint.x + $e815fda779bc047b$var$v1.nx * $e815fda779bc047b$var$lenOut;
    $e815fda779bc047b$var$startY = currentPoint.y + $e815fda779bc047b$var$v1.ny * $e815fda779bc047b$var$lenOut;
    // Save last point to avoid recalculating vector when not needed
    $e815fda779bc047b$var$lastPoint = currentPoint;
};
/**
 * Draw corner provided by {@link getRoundCorner}
 *
 * @param ctx :CanvasRenderingContext2D
 * @param roundCorner {{cx:number, cy:number, radius:number, endAngle: number, startAngle: number, counterClockwise: boolean}}
 */ function $e815fda779bc047b$var$drawPreparedRoundCorner(ctx, roundCorner) {
    if (roundCorner.radius === 0) ctx.lineTo(roundCorner.cx, roundCorner.cy);
    else ctx.arc(roundCorner.cx, roundCorner.cy, roundCorner.radius, roundCorner.startAngle, roundCorner.endAngle, roundCorner.counterClockwise);
}
/**
 * Get round corner from a point and its previous and next neighbours in a path
 *
 * @param previousPoint {{x: number, y:number, radius: number?}}
 * @param currentPoint {{x: number, y:number, radius: number?}}
 * @param nextPoint {{x: number, y:number, radius: number?}}
 * @param radiusMax :number
 * @param isArcRadius :boolean
 * @return {{
 * cx:number, cy:number, radius:number,
 * startX:number, startY:number,
 * stopX:number, stopY: number,
 * endAngle: number, startAngle: number, counterClockwise: boolean
 * }}
 */ function $e815fda779bc047b$var$getRoundCorner(previousPoint, currentPoint, nextPoint, radiusMax) {
    var isArcRadius = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    if (radiusMax === 0 || currentPoint.radius === 0) return {
        cx: currentPoint.x,
        cy: currentPoint.y,
        radius: 0,
        startX: currentPoint.x,
        startY: currentPoint.y,
        stopX: currentPoint.x,
        stopY: currentPoint.y,
        startAngle: undefined,
        endAngle: undefined,
        counterClockwise: undefined
    };
    $e815fda779bc047b$var$calcCornerArc(previousPoint, currentPoint, nextPoint, radiusMax, isArcRadius);
    return {
        cx: $e815fda779bc047b$var$x,
        cy: $e815fda779bc047b$var$y,
        radius: $e815fda779bc047b$var$cRadius,
        startX: $e815fda779bc047b$var$startX,
        startY: $e815fda779bc047b$var$startY,
        stopX: $e815fda779bc047b$var$stopX,
        stopY: $e815fda779bc047b$var$stopY,
        startAngle: $e815fda779bc047b$var$v1.ang + Math.PI / 2 * $e815fda779bc047b$var$radDirection,
        endAngle: $e815fda779bc047b$var$v2.ang - Math.PI / 2 * $e815fda779bc047b$var$radDirection,
        counterClockwise: $e815fda779bc047b$var$drawDirection
    };
}
var $e815fda779bc047b$var$AVOID_IMPOSSIBLE_BEZIER_CONSTANT = 0.01;
var $e815fda779bc047b$var$AVOID_IMPOSSIBLE_BEZIER_CONSTANT_L = Math.sqrt(2 * $e815fda779bc047b$var$AVOID_IMPOSSIBLE_BEZIER_CONSTANT);
var $e815fda779bc047b$var$BRp$c = {};
$e815fda779bc047b$var$BRp$c.findMidptPtsEtc = function(edge, pairInfo) {
    var posPts = pairInfo.posPts, intersectionPts = pairInfo.intersectionPts, vectorNormInverse = pairInfo.vectorNormInverse;
    var midptPts;
    // n.b. assumes all edges in bezier bundle have same endpoints specified
    var srcManEndpt = edge.pstyle('source-endpoint');
    var tgtManEndpt = edge.pstyle('target-endpoint');
    var haveManualEndPts = srcManEndpt.units != null && tgtManEndpt.units != null;
    var recalcVectorNormInverse = function recalcVectorNormInverse(x1, y1, x2, y2) {
        var dy = y2 - y1;
        var dx = x2 - x1;
        var l = Math.sqrt(dx * dx + dy * dy);
        return {
            x: -dy / l,
            y: dx / l
        };
    };
    var edgeDistances = edge.pstyle('edge-distances').value;
    switch(edgeDistances){
        case 'node-position':
            midptPts = posPts;
            break;
        case 'intersection':
            midptPts = intersectionPts;
            break;
        case 'endpoints':
            if (haveManualEndPts) {
                var _this$manualEndptToPx = this.manualEndptToPx(edge.source()[0], srcManEndpt), _this$manualEndptToPx2 = $e815fda779bc047b$var$_slicedToArray(_this$manualEndptToPx, 2), x1 = _this$manualEndptToPx2[0], y1 = _this$manualEndptToPx2[1];
                var _this$manualEndptToPx3 = this.manualEndptToPx(edge.target()[0], tgtManEndpt), _this$manualEndptToPx4 = $e815fda779bc047b$var$_slicedToArray(_this$manualEndptToPx3, 2), x2 = _this$manualEndptToPx4[0], y2 = _this$manualEndptToPx4[1];
                var endPts = {
                    x1: x1,
                    y1: y1,
                    x2: x2,
                    y2: y2
                };
                vectorNormInverse = recalcVectorNormInverse(x1, y1, x2, y2);
                midptPts = endPts;
            } else {
                $e815fda779bc047b$var$warn("Edge ".concat(edge.id(), " has edge-distances:endpoints specified without manual endpoints specified via source-endpoint and target-endpoint.  Falling back on edge-distances:intersection (default)."));
                midptPts = intersectionPts; // back to default
            }
            break;
    }
    return {
        midptPts: midptPts,
        vectorNormInverse: vectorNormInverse
    };
};
$e815fda779bc047b$var$BRp$c.findHaystackPoints = function(edges) {
    for(var i = 0; i < edges.length; i++){
        var edge = edges[i];
        var _p = edge._private;
        var rs = _p.rscratch;
        if (!rs.haystack) {
            var angle = Math.random() * 2 * Math.PI;
            rs.source = {
                x: Math.cos(angle),
                y: Math.sin(angle)
            };
            angle = Math.random() * 2 * Math.PI;
            rs.target = {
                x: Math.cos(angle),
                y: Math.sin(angle)
            };
        }
        var src = _p.source;
        var tgt = _p.target;
        var srcPos = src.position();
        var tgtPos = tgt.position();
        var srcW = src.width();
        var tgtW = tgt.width();
        var srcH = src.height();
        var tgtH = tgt.height();
        var radius = edge.pstyle('haystack-radius').value;
        var halfRadius = radius / 2; // b/c have to half width/height
        rs.haystackPts = rs.allpts = [
            rs.source.x * srcW * halfRadius + srcPos.x,
            rs.source.y * srcH * halfRadius + srcPos.y,
            rs.target.x * tgtW * halfRadius + tgtPos.x,
            rs.target.y * tgtH * halfRadius + tgtPos.y
        ];
        rs.midX = (rs.allpts[0] + rs.allpts[2]) / 2;
        rs.midY = (rs.allpts[1] + rs.allpts[3]) / 2;
        // always override as haystack in case set to different type previously
        rs.edgeType = 'haystack';
        rs.haystack = true;
        this.storeEdgeProjections(edge);
        this.calculateArrowAngles(edge);
        this.recalculateEdgeLabelProjections(edge);
        this.calculateLabelAngles(edge);
    }
};
$e815fda779bc047b$var$BRp$c.findSegmentsPoints = function(edge, pairInfo) {
    // Segments (multiple straight lines)
    var rs = edge._private.rscratch;
    var segmentWs = edge.pstyle('segment-weights');
    var segmentDs = edge.pstyle('segment-distances');
    var segmentRs = edge.pstyle('segment-radii');
    var segmentTs = edge.pstyle('radius-type');
    var segmentsN = Math.min(segmentWs.pfValue.length, segmentDs.pfValue.length);
    var lastRadius = segmentRs.pfValue[segmentRs.pfValue.length - 1];
    var lastRadiusType = segmentTs.pfValue[segmentTs.pfValue.length - 1];
    rs.edgeType = 'segments';
    rs.segpts = [];
    rs.radii = [];
    rs.isArcRadius = [];
    for(var s = 0; s < segmentsN; s++){
        var w = segmentWs.pfValue[s];
        var d = segmentDs.pfValue[s];
        var w1 = 1 - w;
        var w2 = w;
        var _this$findMidptPtsEtc = this.findMidptPtsEtc(edge, pairInfo), midptPts = _this$findMidptPtsEtc.midptPts, vectorNormInverse = _this$findMidptPtsEtc.vectorNormInverse;
        var adjustedMidpt = {
            x: midptPts.x1 * w1 + midptPts.x2 * w2,
            y: midptPts.y1 * w1 + midptPts.y2 * w2
        };
        rs.segpts.push(adjustedMidpt.x + vectorNormInverse.x * d, adjustedMidpt.y + vectorNormInverse.y * d);
        rs.radii.push(segmentRs.pfValue[s] !== undefined ? segmentRs.pfValue[s] : lastRadius);
        rs.isArcRadius.push((segmentTs.pfValue[s] !== undefined ? segmentTs.pfValue[s] : lastRadiusType) === 'arc-radius');
    }
};
$e815fda779bc047b$var$BRp$c.findLoopPoints = function(edge, pairInfo, i, edgeIsUnbundled) {
    // Self-edge
    var rs = edge._private.rscratch;
    var dirCounts = pairInfo.dirCounts, srcPos = pairInfo.srcPos;
    var ctrlptDists = edge.pstyle('control-point-distances');
    var ctrlptDist = ctrlptDists ? ctrlptDists.pfValue[0] : undefined;
    var loopDir = edge.pstyle('loop-direction').pfValue;
    var loopSwp = edge.pstyle('loop-sweep').pfValue;
    var stepSize = edge.pstyle('control-point-step-size').pfValue;
    rs.edgeType = 'self';
    var j = i;
    var loopDist = stepSize;
    if (edgeIsUnbundled) {
        j = 0;
        loopDist = ctrlptDist;
    }
    var loopAngle = loopDir - Math.PI / 2;
    var outAngle = loopAngle - loopSwp / 2;
    var inAngle = loopAngle + loopSwp / 2;
    // increase by step size for overlapping loops, keyed on direction and sweep values
    var dc = String(loopDir + '_' + loopSwp);
    j = dirCounts[dc] === undefined ? dirCounts[dc] = 0 : ++dirCounts[dc];
    rs.ctrlpts = [
        srcPos.x + Math.cos(outAngle) * 1.4 * loopDist * (j / 3 + 1),
        srcPos.y + Math.sin(outAngle) * 1.4 * loopDist * (j / 3 + 1),
        srcPos.x + Math.cos(inAngle) * 1.4 * loopDist * (j / 3 + 1),
        srcPos.y + Math.sin(inAngle) * 1.4 * loopDist * (j / 3 + 1)
    ];
};
$e815fda779bc047b$var$BRp$c.findCompoundLoopPoints = function(edge, pairInfo, i, edgeIsUnbundled) {
    // Compound edge
    var rs = edge._private.rscratch;
    rs.edgeType = 'compound';
    var srcPos = pairInfo.srcPos, tgtPos = pairInfo.tgtPos, srcW = pairInfo.srcW, srcH = pairInfo.srcH, tgtW = pairInfo.tgtW, tgtH = pairInfo.tgtH;
    var stepSize = edge.pstyle('control-point-step-size').pfValue;
    var ctrlptDists = edge.pstyle('control-point-distances');
    var ctrlptDist = ctrlptDists ? ctrlptDists.pfValue[0] : undefined;
    var j = i;
    var loopDist = stepSize;
    if (edgeIsUnbundled) {
        j = 0;
        loopDist = ctrlptDist;
    }
    var loopW = 50;
    var loopaPos = {
        x: srcPos.x - srcW / 2,
        y: srcPos.y - srcH / 2
    };
    var loopbPos = {
        x: tgtPos.x - tgtW / 2,
        y: tgtPos.y - tgtH / 2
    };
    var loopPos = {
        x: Math.min(loopaPos.x, loopbPos.x),
        y: Math.min(loopaPos.y, loopbPos.y)
    };
    // avoids cases with impossible beziers
    var minCompoundStretch = 0.5;
    var compoundStretchA = Math.max(minCompoundStretch, Math.log(srcW * $e815fda779bc047b$var$AVOID_IMPOSSIBLE_BEZIER_CONSTANT));
    var compoundStretchB = Math.max(minCompoundStretch, Math.log(tgtW * $e815fda779bc047b$var$AVOID_IMPOSSIBLE_BEZIER_CONSTANT));
    rs.ctrlpts = [
        loopPos.x,
        loopPos.y - (1 + Math.pow(loopW, 1.12) / 100) * loopDist * (j / 3 + 1) * compoundStretchA,
        loopPos.x - (1 + Math.pow(loopW, 1.12) / 100) * loopDist * (j / 3 + 1) * compoundStretchB,
        loopPos.y
    ];
};
$e815fda779bc047b$var$BRp$c.findStraightEdgePoints = function(edge) {
    // Straight edge within bundle
    edge._private.rscratch.edgeType = 'straight';
};
$e815fda779bc047b$var$BRp$c.findBezierPoints = function(edge, pairInfo, i, edgeIsUnbundled, edgeIsSwapped) {
    var rs = edge._private.rscratch;
    var stepSize = edge.pstyle('control-point-step-size').pfValue;
    var ctrlptDists = edge.pstyle('control-point-distances');
    var ctrlptWs = edge.pstyle('control-point-weights');
    var bezierN = ctrlptDists && ctrlptWs ? Math.min(ctrlptDists.value.length, ctrlptWs.value.length) : 1;
    var ctrlptDist = ctrlptDists ? ctrlptDists.pfValue[0] : undefined;
    var ctrlptWeight = ctrlptWs.value[0];
    // (Multi)bezier
    var multi = edgeIsUnbundled;
    rs.edgeType = multi ? 'multibezier' : 'bezier';
    rs.ctrlpts = [];
    for(var b = 0; b < bezierN; b++){
        var normctrlptDist = (0.5 - pairInfo.eles.length / 2 + i) * stepSize * (edgeIsSwapped ? -1 : 1);
        var manctrlptDist = undefined;
        var sign = $e815fda779bc047b$var$signum(normctrlptDist);
        if (multi) {
            ctrlptDist = ctrlptDists ? ctrlptDists.pfValue[b] : stepSize; // fall back on step size
            ctrlptWeight = ctrlptWs.value[b];
        }
        if (edgeIsUnbundled) // multi or single unbundled
        manctrlptDist = ctrlptDist;
        else manctrlptDist = ctrlptDist !== undefined ? sign * ctrlptDist : undefined;
        var distanceFromMidpoint = manctrlptDist !== undefined ? manctrlptDist : normctrlptDist;
        var w1 = 1 - ctrlptWeight;
        var w2 = ctrlptWeight;
        var _this$findMidptPtsEtc2 = this.findMidptPtsEtc(edge, pairInfo), midptPts = _this$findMidptPtsEtc2.midptPts, vectorNormInverse = _this$findMidptPtsEtc2.vectorNormInverse;
        var adjustedMidpt = {
            x: midptPts.x1 * w1 + midptPts.x2 * w2,
            y: midptPts.y1 * w1 + midptPts.y2 * w2
        };
        rs.ctrlpts.push(adjustedMidpt.x + vectorNormInverse.x * distanceFromMidpoint, adjustedMidpt.y + vectorNormInverse.y * distanceFromMidpoint);
    }
};
$e815fda779bc047b$var$BRp$c.findTaxiPoints = function(edge, pairInfo) {
    // Taxicab geometry with two turns maximum
    var rs = edge._private.rscratch;
    rs.edgeType = 'segments';
    var VERTICAL = 'vertical';
    var HORIZONTAL = 'horizontal';
    var LEFTWARD = 'leftward';
    var RIGHTWARD = 'rightward';
    var DOWNWARD = 'downward';
    var UPWARD = 'upward';
    var AUTO = 'auto';
    var posPts = pairInfo.posPts, srcW = pairInfo.srcW, srcH = pairInfo.srcH, tgtW = pairInfo.tgtW, tgtH = pairInfo.tgtH;
    var edgeDistances = edge.pstyle('edge-distances').value;
    var dIncludesNodeBody = edgeDistances !== 'node-position';
    var taxiDir = edge.pstyle('taxi-direction').value;
    var rawTaxiDir = taxiDir; // unprocessed value
    var taxiTurn = edge.pstyle('taxi-turn');
    var turnIsPercent = taxiTurn.units === '%';
    var taxiTurnPfVal = taxiTurn.pfValue;
    var turnIsNegative = taxiTurnPfVal < 0; // i.e. from target side
    var minD = edge.pstyle('taxi-turn-min-distance').pfValue;
    var dw = dIncludesNodeBody ? (srcW + tgtW) / 2 : 0;
    var dh = dIncludesNodeBody ? (srcH + tgtH) / 2 : 0;
    var pdx = posPts.x2 - posPts.x1;
    var pdy = posPts.y2 - posPts.y1;
    // take away the effective w/h from the magnitude of the delta value
    var subDWH = function subDWH(dxy, dwh) {
        if (dxy > 0) return Math.max(dxy - dwh, 0);
        else return Math.min(dxy + dwh, 0);
    };
    var dx = subDWH(pdx, dw);
    var dy = subDWH(pdy, dh);
    var isExplicitDir = false;
    if (rawTaxiDir === AUTO) taxiDir = Math.abs(dx) > Math.abs(dy) ? HORIZONTAL : VERTICAL;
    else if (rawTaxiDir === UPWARD || rawTaxiDir === DOWNWARD) {
        taxiDir = VERTICAL;
        isExplicitDir = true;
    } else if (rawTaxiDir === LEFTWARD || rawTaxiDir === RIGHTWARD) {
        taxiDir = HORIZONTAL;
        isExplicitDir = true;
    }
    var isVert = taxiDir === VERTICAL;
    var l = isVert ? dy : dx;
    var pl = isVert ? pdy : pdx;
    var sgnL = $e815fda779bc047b$var$signum(pl);
    var forcedDir = false;
    if (!(isExplicitDir && (turnIsPercent || turnIsNegative) // forcing in this case would cause weird growing in the opposite direction
    ) && (rawTaxiDir === DOWNWARD && pl < 0 || rawTaxiDir === UPWARD && pl > 0 || rawTaxiDir === LEFTWARD && pl > 0 || rawTaxiDir === RIGHTWARD && pl < 0)) {
        sgnL *= -1;
        l = sgnL * Math.abs(l);
        forcedDir = true;
    }
    var d;
    if (turnIsPercent) {
        var p = taxiTurnPfVal < 0 ? 1 + taxiTurnPfVal : taxiTurnPfVal;
        d = p * l;
    } else {
        var k = taxiTurnPfVal < 0 ? l : 0;
        d = k + taxiTurnPfVal * sgnL;
    }
    var getIsTooClose = function getIsTooClose(d) {
        return Math.abs(d) < minD || Math.abs(d) >= Math.abs(l);
    };
    var isTooCloseSrc = getIsTooClose(d);
    var isTooCloseTgt = getIsTooClose(Math.abs(l) - Math.abs(d));
    var isTooClose = isTooCloseSrc || isTooCloseTgt;
    if (isTooClose && !forcedDir) {
        // non-ideal routing
        if (isVert) {
            // vertical fallbacks
            var lShapeInsideSrc = Math.abs(pl) <= srcH / 2;
            var lShapeInsideTgt = Math.abs(pdx) <= tgtW / 2;
            if (lShapeInsideSrc) {
                // horizontal Z-shape (direction not respected)
                var x = (posPts.x1 + posPts.x2) / 2;
                var y1 = posPts.y1, y2 = posPts.y2;
                rs.segpts = [
                    x,
                    y1,
                    x,
                    y2
                ];
            } else if (lShapeInsideTgt) {
                // vertical Z-shape (distance not respected)
                var y = (posPts.y1 + posPts.y2) / 2;
                var x1 = posPts.x1, x2 = posPts.x2;
                rs.segpts = [
                    x1,
                    y,
                    x2,
                    y
                ];
            } else // L-shape fallback (turn distance not respected, but works well with tree siblings)
            rs.segpts = [
                posPts.x1,
                posPts.y2
            ];
        } else {
            // horizontal fallbacks
            var _lShapeInsideSrc = Math.abs(pl) <= srcW / 2;
            var _lShapeInsideTgt = Math.abs(pdy) <= tgtH / 2;
            if (_lShapeInsideSrc) {
                // vertical Z-shape (direction not respected)
                var _y = (posPts.y1 + posPts.y2) / 2;
                var _x = posPts.x1, _x2 = posPts.x2;
                rs.segpts = [
                    _x,
                    _y,
                    _x2,
                    _y
                ];
            } else if (_lShapeInsideTgt) {
                // horizontal Z-shape (turn distance not respected)
                var _x3 = (posPts.x1 + posPts.x2) / 2;
                var _y2 = posPts.y1, _y3 = posPts.y2;
                rs.segpts = [
                    _x3,
                    _y2,
                    _x3,
                    _y3
                ];
            } else // L-shape (turn distance not respected, but works well for tree siblings)
            rs.segpts = [
                posPts.x2,
                posPts.y1
            ];
        }
    } else // ideal routing
    if (isVert) {
        var _y4 = posPts.y1 + d + (dIncludesNodeBody ? srcH / 2 * sgnL : 0);
        var _x4 = posPts.x1, _x5 = posPts.x2;
        rs.segpts = [
            _x4,
            _y4,
            _x5,
            _y4
        ];
    } else {
        // horizontal
        var _x6 = posPts.x1 + d + (dIncludesNodeBody ? srcW / 2 * sgnL : 0);
        var _y5 = posPts.y1, _y6 = posPts.y2;
        rs.segpts = [
            _x6,
            _y5,
            _x6,
            _y6
        ];
    }
    if (rs.isRound) {
        var radius = edge.pstyle('taxi-radius').value;
        var isArcRadius = edge.pstyle('radius-type').value[0] === 'arc-radius';
        rs.radii = new Array(rs.segpts.length / 2).fill(radius);
        rs.isArcRadius = new Array(rs.segpts.length / 2).fill(isArcRadius);
    }
};
$e815fda779bc047b$var$BRp$c.tryToCorrectInvalidPoints = function(edge, pairInfo) {
    var rs = edge._private.rscratch;
    // can only correct beziers for now...
    if (rs.edgeType === 'bezier') {
        var srcPos = pairInfo.srcPos, tgtPos = pairInfo.tgtPos, srcW = pairInfo.srcW, srcH = pairInfo.srcH, tgtW = pairInfo.tgtW, tgtH = pairInfo.tgtH, srcShape = pairInfo.srcShape, tgtShape = pairInfo.tgtShape, srcCornerRadius = pairInfo.srcCornerRadius, tgtCornerRadius = pairInfo.tgtCornerRadius, srcRs = pairInfo.srcRs, tgtRs = pairInfo.tgtRs;
        var badStart = !$e815fda779bc047b$var$number$1(rs.startX) || !$e815fda779bc047b$var$number$1(rs.startY);
        var badAStart = !$e815fda779bc047b$var$number$1(rs.arrowStartX) || !$e815fda779bc047b$var$number$1(rs.arrowStartY);
        var badEnd = !$e815fda779bc047b$var$number$1(rs.endX) || !$e815fda779bc047b$var$number$1(rs.endY);
        var badAEnd = !$e815fda779bc047b$var$number$1(rs.arrowEndX) || !$e815fda779bc047b$var$number$1(rs.arrowEndY);
        var minCpADistFactor = 3;
        var arrowW = this.getArrowWidth(edge.pstyle('width').pfValue, edge.pstyle('arrow-scale').value) * this.arrowShapeWidth;
        var minCpADist = minCpADistFactor * arrowW;
        var startACpDist = $e815fda779bc047b$var$dist({
            x: rs.ctrlpts[0],
            y: rs.ctrlpts[1]
        }, {
            x: rs.startX,
            y: rs.startY
        });
        var closeStartACp = startACpDist < minCpADist;
        var endACpDist = $e815fda779bc047b$var$dist({
            x: rs.ctrlpts[0],
            y: rs.ctrlpts[1]
        }, {
            x: rs.endX,
            y: rs.endY
        });
        var closeEndACp = endACpDist < minCpADist;
        var overlapping = false;
        if (badStart || badAStart || closeStartACp) {
            overlapping = true;
            // project control point along line from src centre to outside the src shape
            // (otherwise intersection will yield nothing)
            var cpD = {
                // delta
                x: rs.ctrlpts[0] - srcPos.x,
                y: rs.ctrlpts[1] - srcPos.y
            };
            var cpL = Math.sqrt(cpD.x * cpD.x + cpD.y * cpD.y); // length of line
            var cpM = {
                // normalised delta
                x: cpD.x / cpL,
                y: cpD.y / cpL
            };
            var radius = Math.max(srcW, srcH);
            var cpProj = {
                // *2 radius guarantees outside shape
                x: rs.ctrlpts[0] + cpM.x * 2 * radius,
                y: rs.ctrlpts[1] + cpM.y * 2 * radius
            };
            var srcCtrlPtIntn = srcShape.intersectLine(srcPos.x, srcPos.y, srcW, srcH, cpProj.x, cpProj.y, 0, srcCornerRadius, srcRs);
            if (closeStartACp) {
                rs.ctrlpts[0] = rs.ctrlpts[0] + cpM.x * (minCpADist - startACpDist);
                rs.ctrlpts[1] = rs.ctrlpts[1] + cpM.y * (minCpADist - startACpDist);
            } else {
                rs.ctrlpts[0] = srcCtrlPtIntn[0] + cpM.x * minCpADist;
                rs.ctrlpts[1] = srcCtrlPtIntn[1] + cpM.y * minCpADist;
            }
        }
        if (badEnd || badAEnd || closeEndACp) {
            overlapping = true;
            // project control point along line from tgt centre to outside the tgt shape
            // (otherwise intersection will yield nothing)
            var _cpD = {
                // delta
                x: rs.ctrlpts[0] - tgtPos.x,
                y: rs.ctrlpts[1] - tgtPos.y
            };
            var _cpL = Math.sqrt(_cpD.x * _cpD.x + _cpD.y * _cpD.y); // length of line
            var _cpM = {
                // normalised delta
                x: _cpD.x / _cpL,
                y: _cpD.y / _cpL
            };
            var _radius = Math.max(srcW, srcH);
            var _cpProj = {
                // *2 radius guarantees outside shape
                x: rs.ctrlpts[0] + _cpM.x * 2 * _radius,
                y: rs.ctrlpts[1] + _cpM.y * 2 * _radius
            };
            var tgtCtrlPtIntn = tgtShape.intersectLine(tgtPos.x, tgtPos.y, tgtW, tgtH, _cpProj.x, _cpProj.y, 0, tgtCornerRadius, tgtRs);
            if (closeEndACp) {
                rs.ctrlpts[0] = rs.ctrlpts[0] + _cpM.x * (minCpADist - endACpDist);
                rs.ctrlpts[1] = rs.ctrlpts[1] + _cpM.y * (minCpADist - endACpDist);
            } else {
                rs.ctrlpts[0] = tgtCtrlPtIntn[0] + _cpM.x * minCpADist;
                rs.ctrlpts[1] = tgtCtrlPtIntn[1] + _cpM.y * minCpADist;
            }
        }
        if (overlapping) // recalc endpts
        this.findEndpoints(edge);
    }
};
$e815fda779bc047b$var$BRp$c.storeAllpts = function(edge) {
    var rs = edge._private.rscratch;
    if (rs.edgeType === 'multibezier' || rs.edgeType === 'bezier' || rs.edgeType === 'self' || rs.edgeType === 'compound') {
        rs.allpts = [];
        rs.allpts.push(rs.startX, rs.startY);
        for(var b = 0; b + 1 < rs.ctrlpts.length; b += 2){
            // ctrl pt itself
            rs.allpts.push(rs.ctrlpts[b], rs.ctrlpts[b + 1]);
            // the midpt between ctrlpts as intermediate destination pts
            if (b + 3 < rs.ctrlpts.length) rs.allpts.push((rs.ctrlpts[b] + rs.ctrlpts[b + 2]) / 2, (rs.ctrlpts[b + 1] + rs.ctrlpts[b + 3]) / 2);
        }
        rs.allpts.push(rs.endX, rs.endY);
        var m1, mt;
        if (rs.ctrlpts.length / 2 % 2 === 0) {
            m1 = rs.allpts.length / 2 - 1;
            rs.midX = rs.allpts[m1];
            rs.midY = rs.allpts[m1 + 1];
        } else {
            m1 = rs.allpts.length / 2 - 3;
            mt = 0.5;
            rs.midX = $e815fda779bc047b$var$qbezierAt(rs.allpts[m1], rs.allpts[m1 + 2], rs.allpts[m1 + 4], mt);
            rs.midY = $e815fda779bc047b$var$qbezierAt(rs.allpts[m1 + 1], rs.allpts[m1 + 3], rs.allpts[m1 + 5], mt);
        }
    } else if (rs.edgeType === 'straight') {
        // need to calc these after endpts
        rs.allpts = [
            rs.startX,
            rs.startY,
            rs.endX,
            rs.endY
        ];
        // default midpt for labels etc
        rs.midX = (rs.startX + rs.endX + rs.arrowStartX + rs.arrowEndX) / 4;
        rs.midY = (rs.startY + rs.endY + rs.arrowStartY + rs.arrowEndY) / 4;
    } else if (rs.edgeType === 'segments') {
        rs.allpts = [];
        rs.allpts.push(rs.startX, rs.startY);
        rs.allpts.push.apply(rs.allpts, rs.segpts);
        rs.allpts.push(rs.endX, rs.endY);
        if (rs.isRound) {
            rs.roundCorners = [];
            for(var i = 2; i + 3 < rs.allpts.length; i += 2){
                var radius = rs.radii[i / 2 - 1];
                var isArcRadius = rs.isArcRadius[i / 2 - 1];
                rs.roundCorners.push($e815fda779bc047b$var$getRoundCorner({
                    x: rs.allpts[i - 2],
                    y: rs.allpts[i - 1]
                }, {
                    x: rs.allpts[i],
                    y: rs.allpts[i + 1],
                    radius: radius
                }, {
                    x: rs.allpts[i + 2],
                    y: rs.allpts[i + 3]
                }, radius, isArcRadius));
            }
        }
        if (rs.segpts.length % 4 === 0) {
            var i2 = rs.segpts.length / 2;
            var i1 = i2 - 2;
            rs.midX = (rs.segpts[i1] + rs.segpts[i2]) / 2;
            rs.midY = (rs.segpts[i1 + 1] + rs.segpts[i2 + 1]) / 2;
        } else {
            var _i = rs.segpts.length / 2 - 1;
            if (!rs.isRound) {
                rs.midX = rs.segpts[_i];
                rs.midY = rs.segpts[_i + 1];
            } else {
                var point = {
                    x: rs.segpts[_i],
                    y: rs.segpts[_i + 1]
                };
                var corner = rs.roundCorners[_i / 2];
                if (corner.radius === 0) {
                    // On collinear points
                    var nextPoint = {
                        x: rs.segpts[_i + 2],
                        y: rs.segpts[_i + 3]
                    };
                    rs.midX = point.x;
                    rs.midY = point.y;
                    rs.midVector = [
                        point.y - nextPoint.y,
                        nextPoint.x - point.x
                    ];
                } else {
                    // On rounded points
                    var v = [
                        point.x - corner.cx,
                        point.y - corner.cy
                    ];
                    var factor = corner.radius / Math.sqrt(Math.pow(v[0], 2) + Math.pow(v[1], 2));
                    v = v.map(function(c) {
                        return c * factor;
                    });
                    rs.midX = corner.cx + v[0];
                    rs.midY = corner.cy + v[1];
                    rs.midVector = v;
                }
            }
        }
    }
};
$e815fda779bc047b$var$BRp$c.checkForInvalidEdgeWarning = function(edge) {
    var rs = edge[0]._private.rscratch;
    if (rs.nodesOverlap || $e815fda779bc047b$var$number$1(rs.startX) && $e815fda779bc047b$var$number$1(rs.startY) && $e815fda779bc047b$var$number$1(rs.endX) && $e815fda779bc047b$var$number$1(rs.endY)) rs.loggedErr = false;
    else if (!rs.loggedErr) {
        rs.loggedErr = true;
        $e815fda779bc047b$var$warn('Edge `' + edge.id() + '` has invalid endpoints and so it is impossible to draw.  Adjust your edge style (e.g. control points) accordingly or use an alternative edge type.  This is expected behaviour when the source node and the target node overlap.');
    }
};
$e815fda779bc047b$var$BRp$c.findEdgeControlPoints = function(edges) {
    var _this = this;
    if (!edges || edges.length === 0) return;
    var r = this;
    var cy = r.cy;
    var hasCompounds = cy.hasCompoundNodes();
    var hashTable = new $e815fda779bc047b$var$Map$1();
    var getKey = function getKey(pairId, edgeIsUnbundled) {
        return [].concat($e815fda779bc047b$var$_toConsumableArray(pairId), [
            edgeIsUnbundled ? 1 : 0
        ]).join('-');
    };
    var pairIds = [];
    var haystackEdges = [];
    // create a table of edge (src, tgt) => list of edges between them
    for(var i = 0; i < edges.length; i++){
        var edge = edges[i];
        var _p = edge._private;
        var curveStyle = edge.pstyle('curve-style').value;
        // ignore edges who are not to be displayed
        // they shouldn't take up space
        if (edge.removed() || !edge.takesUpSpace()) continue;
        if (curveStyle === 'haystack') {
            haystackEdges.push(edge);
            continue;
        }
        var edgeIsUnbundled = curveStyle === 'unbundled-bezier' || $e815fda779bc047b$var$endsWith(curveStyle, 'segments') || curveStyle === 'straight' || curveStyle === 'straight-triangle' || $e815fda779bc047b$var$endsWith(curveStyle, 'taxi');
        var edgeIsBezier = curveStyle === 'unbundled-bezier' || curveStyle === 'bezier';
        var src = _p.source;
        var tgt = _p.target;
        var srcIndex = src.poolIndex();
        var tgtIndex = tgt.poolIndex();
        var pairId = [
            srcIndex,
            tgtIndex
        ].sort();
        var key = getKey(pairId, edgeIsUnbundled);
        var tableEntry = hashTable.get(key);
        if (tableEntry == null) {
            tableEntry = {
                eles: []
            };
            pairIds.push({
                pairId: pairId,
                edgeIsUnbundled: edgeIsUnbundled
            });
            hashTable.set(key, tableEntry);
        }
        tableEntry.eles.push(edge);
        if (edgeIsUnbundled) tableEntry.hasUnbundled = true;
        if (edgeIsBezier) tableEntry.hasBezier = true;
    }
    // for each pair (src, tgt), create the ctrl pts
    // Nested for loop is OK; total number of iterations for both loops = edgeCount
    var _loop = function _loop() {
        var _pairIds$p = pairIds[p], pairId = _pairIds$p.pairId, edgeIsUnbundled = _pairIds$p.edgeIsUnbundled;
        var key = getKey(pairId, edgeIsUnbundled);
        var pairInfo = hashTable.get(key);
        var swappedpairInfo;
        if (!pairInfo.hasUnbundled) {
            var pllEdges = pairInfo.eles[0].parallelEdges().filter(function(e) {
                return e.isBundledBezier();
            });
            $e815fda779bc047b$var$clearArray(pairInfo.eles);
            pllEdges.forEach(function(edge) {
                return pairInfo.eles.push(edge);
            });
            // for each pair id, the edges should be sorted by index
            pairInfo.eles.sort(function(edge1, edge2) {
                return edge1.poolIndex() - edge2.poolIndex();
            });
        }
        var firstEdge = pairInfo.eles[0];
        var src = firstEdge.source();
        var tgt = firstEdge.target();
        // make sure src/tgt distinction is consistent w.r.t. pairId
        if (src.poolIndex() > tgt.poolIndex()) {
            var temp = src;
            src = tgt;
            tgt = temp;
        }
        var srcPos = pairInfo.srcPos = src.position();
        var tgtPos = pairInfo.tgtPos = tgt.position();
        var srcW = pairInfo.srcW = src.outerWidth();
        var srcH = pairInfo.srcH = src.outerHeight();
        var tgtW = pairInfo.tgtW = tgt.outerWidth();
        var tgtH = pairInfo.tgtH = tgt.outerHeight();
        var srcShape = pairInfo.srcShape = r.nodeShapes[_this.getNodeShape(src)];
        var tgtShape = pairInfo.tgtShape = r.nodeShapes[_this.getNodeShape(tgt)];
        var srcCornerRadius = pairInfo.srcCornerRadius = src.pstyle('corner-radius').value === 'auto' ? 'auto' : src.pstyle('corner-radius').pfValue;
        var tgtCornerRadius = pairInfo.tgtCornerRadius = tgt.pstyle('corner-radius').value === 'auto' ? 'auto' : tgt.pstyle('corner-radius').pfValue;
        var tgtRs = pairInfo.tgtRs = tgt._private.rscratch;
        var srcRs = pairInfo.srcRs = src._private.rscratch;
        pairInfo.dirCounts = {
            'north': 0,
            'west': 0,
            'south': 0,
            'east': 0,
            'northwest': 0,
            'southwest': 0,
            'northeast': 0,
            'southeast': 0
        };
        for(var _i2 = 0; _i2 < pairInfo.eles.length; _i2++){
            var _edge = pairInfo.eles[_i2];
            var rs = _edge[0]._private.rscratch;
            var _curveStyle = _edge.pstyle('curve-style').value;
            var _edgeIsUnbundled = _curveStyle === 'unbundled-bezier' || $e815fda779bc047b$var$endsWith(_curveStyle, 'segments') || $e815fda779bc047b$var$endsWith(_curveStyle, 'taxi');
            // whether the normalised pair order is the reverse of the edge's src-tgt order
            var edgeIsSwapped = !src.same(_edge.source());
            if (!pairInfo.calculatedIntersection && src !== tgt && (pairInfo.hasBezier || pairInfo.hasUnbundled)) {
                pairInfo.calculatedIntersection = true;
                // pt outside src shape to calc distance/displacement from src to tgt
                var srcOutside = srcShape.intersectLine(srcPos.x, srcPos.y, srcW, srcH, tgtPos.x, tgtPos.y, 0, srcCornerRadius, srcRs);
                var srcIntn = pairInfo.srcIntn = srcOutside;
                // pt outside tgt shape to calc distance/displacement from src to tgt
                var tgtOutside = tgtShape.intersectLine(tgtPos.x, tgtPos.y, tgtW, tgtH, srcPos.x, srcPos.y, 0, tgtCornerRadius, tgtRs);
                var tgtIntn = pairInfo.tgtIntn = tgtOutside;
                var intersectionPts = pairInfo.intersectionPts = {
                    x1: srcOutside[0],
                    x2: tgtOutside[0],
                    y1: srcOutside[1],
                    y2: tgtOutside[1]
                };
                var posPts = pairInfo.posPts = {
                    x1: srcPos.x,
                    x2: tgtPos.x,
                    y1: srcPos.y,
                    y2: tgtPos.y
                };
                var dy = tgtOutside[1] - srcOutside[1];
                var dx = tgtOutside[0] - srcOutside[0];
                var l = Math.sqrt(dx * dx + dy * dy);
                if ($e815fda779bc047b$var$number$1(l) && l >= $e815fda779bc047b$var$AVOID_IMPOSSIBLE_BEZIER_CONSTANT_L) ;
                else l = Math.sqrt(Math.max(dx * dx, $e815fda779bc047b$var$AVOID_IMPOSSIBLE_BEZIER_CONSTANT) + Math.max(dy * dy, $e815fda779bc047b$var$AVOID_IMPOSSIBLE_BEZIER_CONSTANT));
                var vector = pairInfo.vector = {
                    x: dx,
                    y: dy
                };
                var vectorNorm = pairInfo.vectorNorm = {
                    x: vector.x / l,
                    y: vector.y / l
                };
                var vectorNormInverse = {
                    x: -vectorNorm.y,
                    y: vectorNorm.x
                };
                // if node shapes overlap, then no ctrl pts to draw
                pairInfo.nodesOverlap = !$e815fda779bc047b$var$number$1(l) || tgtShape.checkPoint(srcOutside[0], srcOutside[1], 0, tgtW, tgtH, tgtPos.x, tgtPos.y, tgtCornerRadius, tgtRs) || srcShape.checkPoint(tgtOutside[0], tgtOutside[1], 0, srcW, srcH, srcPos.x, srcPos.y, srcCornerRadius, srcRs);
                pairInfo.vectorNormInverse = vectorNormInverse;
                swappedpairInfo = {
                    nodesOverlap: pairInfo.nodesOverlap,
                    dirCounts: pairInfo.dirCounts,
                    calculatedIntersection: true,
                    hasBezier: pairInfo.hasBezier,
                    hasUnbundled: pairInfo.hasUnbundled,
                    eles: pairInfo.eles,
                    srcPos: tgtPos,
                    srcRs: tgtRs,
                    tgtPos: srcPos,
                    tgtRs: srcRs,
                    srcW: tgtW,
                    srcH: tgtH,
                    tgtW: srcW,
                    tgtH: srcH,
                    srcIntn: tgtIntn,
                    tgtIntn: srcIntn,
                    srcShape: tgtShape,
                    tgtShape: srcShape,
                    posPts: {
                        x1: posPts.x2,
                        y1: posPts.y2,
                        x2: posPts.x1,
                        y2: posPts.y1
                    },
                    intersectionPts: {
                        x1: intersectionPts.x2,
                        y1: intersectionPts.y2,
                        x2: intersectionPts.x1,
                        y2: intersectionPts.y1
                    },
                    vector: {
                        x: -vector.x,
                        y: -vector.y
                    },
                    vectorNorm: {
                        x: -vectorNorm.x,
                        y: -vectorNorm.y
                    },
                    vectorNormInverse: {
                        x: -vectorNormInverse.x,
                        y: -vectorNormInverse.y
                    }
                };
            }
            var passedPairInfo = edgeIsSwapped ? swappedpairInfo : pairInfo;
            rs.nodesOverlap = passedPairInfo.nodesOverlap;
            rs.srcIntn = passedPairInfo.srcIntn;
            rs.tgtIntn = passedPairInfo.tgtIntn;
            rs.isRound = _curveStyle.startsWith('round');
            if (hasCompounds && (src.isParent() || src.isChild() || tgt.isParent() || tgt.isChild()) && (src.parents().anySame(tgt) || tgt.parents().anySame(src) || src.same(tgt) && src.isParent())) _this.findCompoundLoopPoints(_edge, passedPairInfo, _i2, _edgeIsUnbundled);
            else if (src === tgt) _this.findLoopPoints(_edge, passedPairInfo, _i2, _edgeIsUnbundled);
            else if (_curveStyle.endsWith('segments')) _this.findSegmentsPoints(_edge, passedPairInfo);
            else if (_curveStyle.endsWith('taxi')) _this.findTaxiPoints(_edge, passedPairInfo);
            else if (_curveStyle === 'straight' || !_edgeIsUnbundled && pairInfo.eles.length % 2 === 1 && _i2 === Math.floor(pairInfo.eles.length / 2)) _this.findStraightEdgePoints(_edge);
            else _this.findBezierPoints(_edge, passedPairInfo, _i2, _edgeIsUnbundled, edgeIsSwapped);
            _this.findEndpoints(_edge);
            _this.tryToCorrectInvalidPoints(_edge, passedPairInfo);
            _this.checkForInvalidEdgeWarning(_edge);
            _this.storeAllpts(_edge);
            _this.storeEdgeProjections(_edge);
            _this.calculateArrowAngles(_edge);
            _this.recalculateEdgeLabelProjections(_edge);
            _this.calculateLabelAngles(_edge);
        } // for pair edges
    };
    for(var p = 0; p < pairIds.length; p++)_loop();
     // for pair ids
    // haystacks avoid the expense of pairInfo stuff (intersections etc.)
    this.findHaystackPoints(haystackEdges);
};
function $e815fda779bc047b$var$getPts(pts) {
    var retPts = [];
    if (pts == null) return;
    for(var i = 0; i < pts.length; i += 2){
        var x = pts[i];
        var y = pts[i + 1];
        retPts.push({
            x: x,
            y: y
        });
    }
    return retPts;
}
$e815fda779bc047b$var$BRp$c.getSegmentPoints = function(edge) {
    var rs = edge[0]._private.rscratch;
    this.recalculateRenderedStyle(edge);
    var type = rs.edgeType;
    if (type === 'segments') return $e815fda779bc047b$var$getPts(rs.segpts);
};
$e815fda779bc047b$var$BRp$c.getControlPoints = function(edge) {
    var rs = edge[0]._private.rscratch;
    this.recalculateRenderedStyle(edge);
    var type = rs.edgeType;
    if (type === 'bezier' || type === 'multibezier' || type === 'self' || type === 'compound') return $e815fda779bc047b$var$getPts(rs.ctrlpts);
};
$e815fda779bc047b$var$BRp$c.getEdgeMidpoint = function(edge) {
    var rs = edge[0]._private.rscratch;
    this.recalculateRenderedStyle(edge);
    return {
        x: rs.midX,
        y: rs.midY
    };
};
var $e815fda779bc047b$var$BRp$b = {};
$e815fda779bc047b$var$BRp$b.manualEndptToPx = function(node, prop) {
    var r = this;
    var npos = node.position();
    var w = node.outerWidth();
    var h = node.outerHeight();
    var rs = node._private.rscratch;
    if (prop.value.length === 2) {
        var p = [
            prop.pfValue[0],
            prop.pfValue[1]
        ];
        if (prop.units[0] === '%') p[0] = p[0] * w;
        if (prop.units[1] === '%') p[1] = p[1] * h;
        p[0] += npos.x;
        p[1] += npos.y;
        return p;
    } else {
        var angle = prop.pfValue[0];
        angle = -Math.PI / 2 + angle; // start at 12 o'clock
        var l = 2 * Math.max(w, h);
        var _p = [
            npos.x + Math.cos(angle) * l,
            npos.y + Math.sin(angle) * l
        ];
        return r.nodeShapes[this.getNodeShape(node)].intersectLine(npos.x, npos.y, w, h, _p[0], _p[1], 0, node.pstyle('corner-radius').value === 'auto' ? 'auto' : node.pstyle('corner-radius').pfValue, rs);
    }
};
$e815fda779bc047b$var$BRp$b.findEndpoints = function(edge) {
    var _ref, _tgtManEndpt$pfValue, _ref2, _srcManEndpt$pfValue;
    var r = this;
    var intersect;
    var source = edge.source()[0];
    var target = edge.target()[0];
    var srcPos = source.position();
    var tgtPos = target.position();
    var tgtArShape = edge.pstyle('target-arrow-shape').value;
    var srcArShape = edge.pstyle('source-arrow-shape').value;
    var tgtDist = edge.pstyle('target-distance-from-node').pfValue;
    var srcDist = edge.pstyle('source-distance-from-node').pfValue;
    var srcRs = source._private.rscratch;
    var tgtRs = target._private.rscratch;
    var curveStyle = edge.pstyle('curve-style').value;
    var rs = edge._private.rscratch;
    var et = rs.edgeType;
    var taxi = $e815fda779bc047b$var$endsWith(curveStyle, 'taxi'); // Covers taxi and round-taxi
    var self1 = et === 'self' || et === 'compound';
    var bezier = et === 'bezier' || et === 'multibezier' || self1;
    var multi = et !== 'bezier';
    var lines = et === 'straight' || et === 'segments';
    var segments = et === 'segments';
    var hasEndpts = bezier || multi || lines;
    var overrideEndpts = self1 || taxi;
    var srcManEndpt = edge.pstyle('source-endpoint');
    var srcManEndptVal = overrideEndpts ? 'outside-to-node' : srcManEndpt.value;
    var srcCornerRadius = source.pstyle('corner-radius').value === 'auto' ? 'auto' : source.pstyle('corner-radius').pfValue;
    var tgtManEndpt = edge.pstyle('target-endpoint');
    var tgtManEndptVal = overrideEndpts ? 'outside-to-node' : tgtManEndpt.value;
    var tgtCornerRadius = target.pstyle('corner-radius').value === 'auto' ? 'auto' : target.pstyle('corner-radius').pfValue;
    rs.srcManEndpt = srcManEndpt;
    rs.tgtManEndpt = tgtManEndpt;
    var p1; // last known point of edge on target side
    var p2; // last known point of edge on source side
    var p1_i; // point to intersect with target shape
    var p2_i; // point to intersect with source shape
    var tgtManEndptPt = (_ref = (tgtManEndpt === null || tgtManEndpt === undefined || (_tgtManEndpt$pfValue = tgtManEndpt.pfValue) === null || _tgtManEndpt$pfValue === undefined ? undefined : _tgtManEndpt$pfValue.length) === 2 ? tgtManEndpt.pfValue : null) !== null && _ref !== undefined ? _ref : [
        0,
        0
    ];
    var srcManEndptPt = (_ref2 = (srcManEndpt === null || srcManEndpt === undefined || (_srcManEndpt$pfValue = srcManEndpt.pfValue) === null || _srcManEndpt$pfValue === undefined ? undefined : _srcManEndpt$pfValue.length) === 2 ? srcManEndpt.pfValue : null) !== null && _ref2 !== undefined ? _ref2 : [
        0,
        0
    ];
    if (bezier) {
        var cpStart = [
            rs.ctrlpts[0],
            rs.ctrlpts[1]
        ];
        var cpEnd = multi ? [
            rs.ctrlpts[rs.ctrlpts.length - 2],
            rs.ctrlpts[rs.ctrlpts.length - 1]
        ] : cpStart;
        p1 = cpEnd;
        p2 = cpStart;
    } else if (lines) {
        var srcArrowFromPt = !segments ? [
            tgtPos.x + tgtManEndptPt[0],
            tgtPos.y + tgtManEndptPt[1]
        ] : rs.segpts.slice(0, 2);
        var tgtArrowFromPt = !segments ? [
            srcPos.x + srcManEndptPt[0],
            srcPos.y + srcManEndptPt[1]
        ] : rs.segpts.slice(rs.segpts.length - 2);
        p1 = tgtArrowFromPt;
        p2 = srcArrowFromPt;
    }
    if (tgtManEndptVal === 'inside-to-node') intersect = [
        tgtPos.x,
        tgtPos.y
    ];
    else if (tgtManEndpt.units) intersect = this.manualEndptToPx(target, tgtManEndpt);
    else if (tgtManEndptVal === 'outside-to-line') intersect = rs.tgtIntn; // use cached value from ctrlpt calc
    else {
        if (tgtManEndptVal === 'outside-to-node' || tgtManEndptVal === 'outside-to-node-or-label') p1_i = p1;
        else if (tgtManEndptVal === 'outside-to-line' || tgtManEndptVal === 'outside-to-line-or-label') p1_i = [
            srcPos.x,
            srcPos.y
        ];
        intersect = r.nodeShapes[this.getNodeShape(target)].intersectLine(tgtPos.x, tgtPos.y, target.outerWidth(), target.outerHeight(), p1_i[0], p1_i[1], 0, tgtCornerRadius, tgtRs);
        if (tgtManEndptVal === 'outside-to-node-or-label' || tgtManEndptVal === 'outside-to-line-or-label') {
            var trs = target._private.rscratch;
            var lw = trs.labelWidth;
            var lh = trs.labelHeight;
            var lx = trs.labelX;
            var ly = trs.labelY;
            var lw2 = lw / 2;
            var lh2 = lh / 2;
            var va = target.pstyle('text-valign').value;
            if (va === 'top') ly -= lh2;
            else if (va === 'bottom') ly += lh2;
            var ha = target.pstyle('text-halign').value;
            if (ha === 'left') lx -= lw2;
            else if (ha === 'right') lx += lw2;
            var labelIntersect = $e815fda779bc047b$var$polygonIntersectLine(p1_i[0], p1_i[1], [
                lx - lw2,
                ly - lh2,
                lx + lw2,
                ly - lh2,
                lx + lw2,
                ly + lh2,
                lx - lw2,
                ly + lh2
            ], tgtPos.x, tgtPos.y);
            if (labelIntersect.length > 0) {
                var refPt = srcPos;
                var intSqdist = $e815fda779bc047b$var$sqdist(refPt, $e815fda779bc047b$var$array2point(intersect));
                var labIntSqdist = $e815fda779bc047b$var$sqdist(refPt, $e815fda779bc047b$var$array2point(labelIntersect));
                var minSqDist = intSqdist;
                if (labIntSqdist < intSqdist) {
                    intersect = labelIntersect;
                    minSqDist = labIntSqdist;
                }
                if (labelIntersect.length > 2) {
                    var labInt2SqDist = $e815fda779bc047b$var$sqdist(refPt, {
                        x: labelIntersect[2],
                        y: labelIntersect[3]
                    });
                    if (labInt2SqDist < minSqDist) intersect = [
                        labelIntersect[2],
                        labelIntersect[3]
                    ];
                }
            }
        }
    }
    var arrowEnd = $e815fda779bc047b$var$shortenIntersection(intersect, p1, r.arrowShapes[tgtArShape].spacing(edge) + tgtDist);
    var edgeEnd = $e815fda779bc047b$var$shortenIntersection(intersect, p1, r.arrowShapes[tgtArShape].gap(edge) + tgtDist);
    rs.endX = edgeEnd[0];
    rs.endY = edgeEnd[1];
    rs.arrowEndX = arrowEnd[0];
    rs.arrowEndY = arrowEnd[1];
    if (srcManEndptVal === 'inside-to-node') intersect = [
        srcPos.x,
        srcPos.y
    ];
    else if (srcManEndpt.units) intersect = this.manualEndptToPx(source, srcManEndpt);
    else if (srcManEndptVal === 'outside-to-line') intersect = rs.srcIntn; // use cached value from ctrlpt calc
    else {
        if (srcManEndptVal === 'outside-to-node' || srcManEndptVal === 'outside-to-node-or-label') p2_i = p2;
        else if (srcManEndptVal === 'outside-to-line' || srcManEndptVal === 'outside-to-line-or-label') p2_i = [
            tgtPos.x,
            tgtPos.y
        ];
        intersect = r.nodeShapes[this.getNodeShape(source)].intersectLine(srcPos.x, srcPos.y, source.outerWidth(), source.outerHeight(), p2_i[0], p2_i[1], 0, srcCornerRadius, srcRs);
        if (srcManEndptVal === 'outside-to-node-or-label' || srcManEndptVal === 'outside-to-line-or-label') {
            var srs = source._private.rscratch;
            var _lw = srs.labelWidth;
            var _lh = srs.labelHeight;
            var _lx = srs.labelX;
            var _ly = srs.labelY;
            var _lw2 = _lw / 2;
            var _lh2 = _lh / 2;
            var _va = source.pstyle('text-valign').value;
            if (_va === 'top') _ly -= _lh2;
            else if (_va === 'bottom') _ly += _lh2;
            var _ha = source.pstyle('text-halign').value;
            if (_ha === 'left') _lx -= _lw2;
            else if (_ha === 'right') _lx += _lw2;
            var _labelIntersect = $e815fda779bc047b$var$polygonIntersectLine(p2_i[0], p2_i[1], [
                _lx - _lw2,
                _ly - _lh2,
                _lx + _lw2,
                _ly - _lh2,
                _lx + _lw2,
                _ly + _lh2,
                _lx - _lw2,
                _ly + _lh2
            ], srcPos.x, srcPos.y);
            if (_labelIntersect.length > 0) {
                var _refPt = tgtPos;
                var _intSqdist = $e815fda779bc047b$var$sqdist(_refPt, $e815fda779bc047b$var$array2point(intersect));
                var _labIntSqdist = $e815fda779bc047b$var$sqdist(_refPt, $e815fda779bc047b$var$array2point(_labelIntersect));
                var _minSqDist = _intSqdist;
                if (_labIntSqdist < _intSqdist) {
                    intersect = [
                        _labelIntersect[0],
                        _labelIntersect[1]
                    ];
                    _minSqDist = _labIntSqdist;
                }
                if (_labelIntersect.length > 2) {
                    var _labInt2SqDist = $e815fda779bc047b$var$sqdist(_refPt, {
                        x: _labelIntersect[2],
                        y: _labelIntersect[3]
                    });
                    if (_labInt2SqDist < _minSqDist) intersect = [
                        _labelIntersect[2],
                        _labelIntersect[3]
                    ];
                }
            }
        }
    }
    var arrowStart = $e815fda779bc047b$var$shortenIntersection(intersect, p2, r.arrowShapes[srcArShape].spacing(edge) + srcDist);
    var edgeStart = $e815fda779bc047b$var$shortenIntersection(intersect, p2, r.arrowShapes[srcArShape].gap(edge) + srcDist);
    rs.startX = edgeStart[0];
    rs.startY = edgeStart[1];
    rs.arrowStartX = arrowStart[0];
    rs.arrowStartY = arrowStart[1];
    if (hasEndpts) {
        if (!$e815fda779bc047b$var$number$1(rs.startX) || !$e815fda779bc047b$var$number$1(rs.startY) || !$e815fda779bc047b$var$number$1(rs.endX) || !$e815fda779bc047b$var$number$1(rs.endY)) rs.badLine = true;
        else rs.badLine = false;
    }
};
$e815fda779bc047b$var$BRp$b.getSourceEndpoint = function(edge) {
    var rs = edge[0]._private.rscratch;
    this.recalculateRenderedStyle(edge);
    switch(rs.edgeType){
        case 'haystack':
            return {
                x: rs.haystackPts[0],
                y: rs.haystackPts[1]
            };
        default:
            return {
                x: rs.arrowStartX,
                y: rs.arrowStartY
            };
    }
};
$e815fda779bc047b$var$BRp$b.getTargetEndpoint = function(edge) {
    var rs = edge[0]._private.rscratch;
    this.recalculateRenderedStyle(edge);
    switch(rs.edgeType){
        case 'haystack':
            return {
                x: rs.haystackPts[2],
                y: rs.haystackPts[3]
            };
        default:
            return {
                x: rs.arrowEndX,
                y: rs.arrowEndY
            };
    }
};
var $e815fda779bc047b$var$BRp$a = {};
function $e815fda779bc047b$var$pushBezierPts(r, edge, pts) {
    var qbezierAt$1 = function qbezierAt$1(p1, p2, p3, t) {
        return $e815fda779bc047b$var$qbezierAt(p1, p2, p3, t);
    };
    var _p = edge._private;
    var bpts = _p.rstyle.bezierPts;
    for(var i = 0; i < r.bezierProjPcts.length; i++){
        var p = r.bezierProjPcts[i];
        bpts.push({
            x: qbezierAt$1(pts[0], pts[2], pts[4], p),
            y: qbezierAt$1(pts[1], pts[3], pts[5], p)
        });
    }
}
$e815fda779bc047b$var$BRp$a.storeEdgeProjections = function(edge) {
    var _p = edge._private;
    var rs = _p.rscratch;
    var et = rs.edgeType;
    // clear the cached points state
    _p.rstyle.bezierPts = null;
    _p.rstyle.linePts = null;
    _p.rstyle.haystackPts = null;
    if (et === 'multibezier' || et === 'bezier' || et === 'self' || et === 'compound') {
        _p.rstyle.bezierPts = [];
        for(var i = 0; i + 5 < rs.allpts.length; i += 4)$e815fda779bc047b$var$pushBezierPts(this, edge, rs.allpts.slice(i, i + 6));
    } else if (et === 'segments') {
        var lpts = _p.rstyle.linePts = [];
        for(var i = 0; i + 1 < rs.allpts.length; i += 2)lpts.push({
            x: rs.allpts[i],
            y: rs.allpts[i + 1]
        });
    } else if (et === 'haystack') {
        var hpts = rs.haystackPts;
        _p.rstyle.haystackPts = [
            {
                x: hpts[0],
                y: hpts[1]
            },
            {
                x: hpts[2],
                y: hpts[3]
            }
        ];
    }
    _p.rstyle.arrowWidth = this.getArrowWidth(edge.pstyle('width').pfValue, edge.pstyle('arrow-scale').value) * this.arrowShapeWidth;
};
$e815fda779bc047b$var$BRp$a.recalculateEdgeProjections = function(edges) {
    this.findEdgeControlPoints(edges);
};
var $e815fda779bc047b$var$BRp$9 = {};
$e815fda779bc047b$var$BRp$9.recalculateNodeLabelProjection = function(node) {
    var content = node.pstyle('label').strValue;
    if ($e815fda779bc047b$var$emptyString(content)) return;
    var textX, textY;
    var _p = node._private;
    var nodeWidth = node.width();
    var nodeHeight = node.height();
    var padding = node.padding();
    var nodePos = node.position();
    var textHalign = node.pstyle('text-halign').strValue;
    var textValign = node.pstyle('text-valign').strValue;
    var rs = _p.rscratch;
    var rstyle = _p.rstyle;
    switch(textHalign){
        case 'left':
            textX = nodePos.x - nodeWidth / 2 - padding;
            break;
        case 'right':
            textX = nodePos.x + nodeWidth / 2 + padding;
            break;
        default:
            // e.g. center
            textX = nodePos.x;
    }
    switch(textValign){
        case 'top':
            textY = nodePos.y - nodeHeight / 2 - padding;
            break;
        case 'bottom':
            textY = nodePos.y + nodeHeight / 2 + padding;
            break;
        default:
            // e.g. middle
            textY = nodePos.y;
    }
    rs.labelX = textX;
    rs.labelY = textY;
    rstyle.labelX = textX;
    rstyle.labelY = textY;
    this.calculateLabelAngles(node);
    this.applyLabelDimensions(node);
};
var $e815fda779bc047b$var$lineAngleFromDelta = function lineAngleFromDelta(dx, dy) {
    var angle = Math.atan(dy / dx);
    if (dx === 0 && angle < 0) angle = angle * -1;
    return angle;
};
var $e815fda779bc047b$var$lineAngle = function lineAngle(p0, p1) {
    var dx = p1.x - p0.x;
    var dy = p1.y - p0.y;
    return $e815fda779bc047b$var$lineAngleFromDelta(dx, dy);
};
var $e815fda779bc047b$var$bezierAngle = function bezierAngle(p0, p1, p2, t) {
    var t0 = $e815fda779bc047b$var$bound(0, t - 0.001, 1);
    var t1 = $e815fda779bc047b$var$bound(0, t + 0.001, 1);
    var lp0 = $e815fda779bc047b$var$qbezierPtAt(p0, p1, p2, t0);
    var lp1 = $e815fda779bc047b$var$qbezierPtAt(p0, p1, p2, t1);
    return $e815fda779bc047b$var$lineAngle(lp0, lp1);
};
$e815fda779bc047b$var$BRp$9.recalculateEdgeLabelProjections = function(edge) {
    var p;
    var _p = edge._private;
    var rs = _p.rscratch;
    var r = this;
    var content = {
        mid: edge.pstyle('label').strValue,
        source: edge.pstyle('source-label').strValue,
        target: edge.pstyle('target-label').strValue
    };
    if (content.mid || content.source || content.target) ;
    else return; // no labels => no calcs
    // add center point to style so bounding box calculations can use it
    //
    p = {
        x: rs.midX,
        y: rs.midY
    };
    var setRs = function setRs(propName, prefix, value) {
        $e815fda779bc047b$var$setPrefixedProperty(_p.rscratch, propName, prefix, value);
        $e815fda779bc047b$var$setPrefixedProperty(_p.rstyle, propName, prefix, value);
    };
    setRs('labelX', null, p.x);
    setRs('labelY', null, p.y);
    var midAngle = $e815fda779bc047b$var$lineAngleFromDelta(rs.midDispX, rs.midDispY);
    setRs('labelAutoAngle', null, midAngle);
    var _createControlPointInfo = function createControlPointInfo() {
        if (_createControlPointInfo.cache) return _createControlPointInfo.cache;
         // use cache so only 1x per edge
        var ctrlpts = [];
        // store each ctrlpt info init
        for(var i = 0; i + 5 < rs.allpts.length; i += 4){
            var p0 = {
                x: rs.allpts[i],
                y: rs.allpts[i + 1]
            };
            var p1 = {
                x: rs.allpts[i + 2],
                y: rs.allpts[i + 3]
            }; // ctrlpt
            var p2 = {
                x: rs.allpts[i + 4],
                y: rs.allpts[i + 5]
            };
            ctrlpts.push({
                p0: p0,
                p1: p1,
                p2: p2,
                startDist: 0,
                length: 0,
                segments: []
            });
        }
        var bpts = _p.rstyle.bezierPts;
        var nProjs = r.bezierProjPcts.length;
        function addSegment(cp, p0, p1, t0, t1) {
            var length = $e815fda779bc047b$var$dist(p0, p1);
            var prevSegment = cp.segments[cp.segments.length - 1];
            var segment = {
                p0: p0,
                p1: p1,
                t0: t0,
                t1: t1,
                startDist: prevSegment ? prevSegment.startDist + prevSegment.length : 0,
                length: length
            };
            cp.segments.push(segment);
            cp.length += length;
        }
        // update each ctrlpt with segment info
        for(var _i = 0; _i < ctrlpts.length; _i++){
            var cp = ctrlpts[_i];
            var prevCp = ctrlpts[_i - 1];
            if (prevCp) cp.startDist = prevCp.startDist + prevCp.length;
            addSegment(cp, cp.p0, bpts[_i * nProjs], 0, r.bezierProjPcts[0]); // first
            for(var j = 0; j < nProjs - 1; j++)addSegment(cp, bpts[_i * nProjs + j], bpts[_i * nProjs + j + 1], r.bezierProjPcts[j], r.bezierProjPcts[j + 1]);
            addSegment(cp, bpts[_i * nProjs + nProjs - 1], cp.p2, r.bezierProjPcts[nProjs - 1], 1); // last
        }
        return _createControlPointInfo.cache = ctrlpts;
    };
    var calculateEndProjection = function calculateEndProjection(prefix) {
        var angle;
        var isSrc = prefix === 'source';
        if (!content[prefix]) return;
        var offset = edge.pstyle(prefix + '-text-offset').pfValue;
        switch(rs.edgeType){
            case 'self':
            case 'compound':
            case 'bezier':
            case 'multibezier':
                var cps = _createControlPointInfo();
                var selected;
                var startDist = 0;
                var totalDist = 0;
                // find the segment we're on
                for(var i = 0; i < cps.length; i++){
                    var _cp = cps[isSrc ? i : cps.length - 1 - i];
                    for(var j = 0; j < _cp.segments.length; j++){
                        var _seg = _cp.segments[isSrc ? j : _cp.segments.length - 1 - j];
                        var lastSeg = i === cps.length - 1 && j === _cp.segments.length - 1;
                        startDist = totalDist;
                        totalDist += _seg.length;
                        if (totalDist >= offset || lastSeg) {
                            selected = {
                                cp: _cp,
                                segment: _seg
                            };
                            break;
                        }
                    }
                    if (selected) break;
                }
                var cp = selected.cp;
                var seg = selected.segment;
                var tSegment = (offset - startDist) / seg.length;
                var segDt = seg.t1 - seg.t0;
                var t = isSrc ? seg.t0 + segDt * tSegment : seg.t1 - segDt * tSegment;
                t = $e815fda779bc047b$var$bound(0, t, 1);
                p = $e815fda779bc047b$var$qbezierPtAt(cp.p0, cp.p1, cp.p2, t);
                angle = $e815fda779bc047b$var$bezierAngle(cp.p0, cp.p1, cp.p2, t);
                break;
            case 'straight':
            case 'segments':
            case 'haystack':
                var d = 0, di, d0;
                var p0, p1;
                var l = rs.allpts.length;
                for(var _i2 = 0; _i2 + 3 < l; _i2 += 2){
                    if (isSrc) {
                        p0 = {
                            x: rs.allpts[_i2],
                            y: rs.allpts[_i2 + 1]
                        };
                        p1 = {
                            x: rs.allpts[_i2 + 2],
                            y: rs.allpts[_i2 + 3]
                        };
                    } else {
                        p0 = {
                            x: rs.allpts[l - 2 - _i2],
                            y: rs.allpts[l - 1 - _i2]
                        };
                        p1 = {
                            x: rs.allpts[l - 4 - _i2],
                            y: rs.allpts[l - 3 - _i2]
                        };
                    }
                    di = $e815fda779bc047b$var$dist(p0, p1);
                    d0 = d;
                    d += di;
                    if (d >= offset) break;
                }
                var pD = offset - d0;
                var _t = pD / di;
                _t = $e815fda779bc047b$var$bound(0, _t, 1);
                p = $e815fda779bc047b$var$lineAt(p0, p1, _t);
                angle = $e815fda779bc047b$var$lineAngle(p0, p1);
                break;
        }
        setRs('labelX', prefix, p.x);
        setRs('labelY', prefix, p.y);
        setRs('labelAutoAngle', prefix, angle);
    };
    calculateEndProjection('source');
    calculateEndProjection('target');
    this.applyLabelDimensions(edge);
};
$e815fda779bc047b$var$BRp$9.applyLabelDimensions = function(ele) {
    this.applyPrefixedLabelDimensions(ele);
    if (ele.isEdge()) {
        this.applyPrefixedLabelDimensions(ele, 'source');
        this.applyPrefixedLabelDimensions(ele, 'target');
    }
};
$e815fda779bc047b$var$BRp$9.applyPrefixedLabelDimensions = function(ele, prefix) {
    var _p = ele._private;
    var text = this.getLabelText(ele, prefix);
    var cacheKey = $e815fda779bc047b$var$hashString(text, ele._private.labelDimsKey);
    // save recalc if the label is the same as before
    if ($e815fda779bc047b$var$getPrefixedProperty(_p.rscratch, 'prefixedLabelDimsKey', prefix) === cacheKey) return; // then the label dimensions + text are the same
    // save the key
    $e815fda779bc047b$var$setPrefixedProperty(_p.rscratch, 'prefixedLabelDimsKey', prefix, cacheKey);
    var labelDims = this.calculateLabelDimensions(ele, text);
    var lineHeight = ele.pstyle('line-height').pfValue;
    var textWrap = ele.pstyle('text-wrap').strValue;
    var lines = $e815fda779bc047b$var$getPrefixedProperty(_p.rscratch, 'labelWrapCachedLines', prefix) || [];
    var numLines = textWrap !== 'wrap' ? 1 : Math.max(lines.length, 1);
    var normPerLineHeight = labelDims.height / numLines;
    var labelLineHeight = normPerLineHeight * lineHeight;
    var width = labelDims.width;
    var height = labelDims.height + (numLines - 1) * (lineHeight - 1) * normPerLineHeight;
    $e815fda779bc047b$var$setPrefixedProperty(_p.rstyle, 'labelWidth', prefix, width);
    $e815fda779bc047b$var$setPrefixedProperty(_p.rscratch, 'labelWidth', prefix, width);
    $e815fda779bc047b$var$setPrefixedProperty(_p.rstyle, 'labelHeight', prefix, height);
    $e815fda779bc047b$var$setPrefixedProperty(_p.rscratch, 'labelHeight', prefix, height);
    $e815fda779bc047b$var$setPrefixedProperty(_p.rscratch, 'labelLineHeight', prefix, labelLineHeight);
};
$e815fda779bc047b$var$BRp$9.getLabelText = function(ele, prefix) {
    var _p = ele._private;
    var pfd = prefix ? prefix + '-' : '';
    var text = ele.pstyle(pfd + 'label').strValue;
    var textTransform = ele.pstyle('text-transform').value;
    var rscratch = function rscratch(propName, value) {
        if (value) {
            $e815fda779bc047b$var$setPrefixedProperty(_p.rscratch, propName, prefix, value);
            return value;
        } else return $e815fda779bc047b$var$getPrefixedProperty(_p.rscratch, propName, prefix);
    };
    // for empty text, skip all processing
    if (!text) return '';
    if (textTransform == 'none') ;
    else if (textTransform == 'uppercase') text = text.toUpperCase();
    else if (textTransform == 'lowercase') text = text.toLowerCase();
    var wrapStyle = ele.pstyle('text-wrap').value;
    if (wrapStyle === 'wrap') {
        var labelKey = rscratch('labelKey');
        // save recalc if the label is the same as before
        if (labelKey != null && rscratch('labelWrapKey') === labelKey) return rscratch('labelWrapCachedText');
        var zwsp = "\u200B";
        var lines = text.split('\n');
        var maxW = ele.pstyle('text-max-width').pfValue;
        var overflow = ele.pstyle('text-overflow-wrap').value;
        var overflowAny = overflow === 'anywhere';
        var wrappedLines = [];
        var separatorRegex = /[\s\u200b]+|$/g; // Include end of string to add last word
        for(var l = 0; l < lines.length; l++){
            var line = lines[l];
            var lineDims = this.calculateLabelDimensions(ele, line);
            var lineW = lineDims.width;
            if (overflowAny) {
                var processedLine = line.split('').join(zwsp);
                line = processedLine;
            }
            if (lineW > maxW) {
                // line is too long
                var separatorMatches = line.matchAll(separatorRegex);
                var subline = '';
                var previousIndex = 0;
                // Add fake match
                var _iterator = $e815fda779bc047b$var$_createForOfIteratorHelper(separatorMatches), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var separatorMatch = _step.value;
                        var wordSeparator = separatorMatch[0];
                        var word = line.substring(previousIndex, separatorMatch.index);
                        previousIndex = separatorMatch.index + wordSeparator.length;
                        var testLine = subline.length === 0 ? word : subline + word + wordSeparator;
                        var testDims = this.calculateLabelDimensions(ele, testLine);
                        var testW = testDims.width;
                        if (testW <= maxW) // word fits on current line
                        subline += word + wordSeparator;
                        else {
                            // word starts new line
                            if (subline) wrappedLines.push(subline);
                            subline = word + wordSeparator;
                        }
                    }
                // if there's remaining text, put it in a wrapped line
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                if (!subline.match(/^[\s\u200b]+$/)) wrappedLines.push(subline);
            } else // line is already short enough
            wrappedLines.push(line);
        } // for
        rscratch('labelWrapCachedLines', wrappedLines);
        text = rscratch('labelWrapCachedText', wrappedLines.join('\n'));
        rscratch('labelWrapKey', labelKey);
    } else if (wrapStyle === 'ellipsis') {
        var _maxW = ele.pstyle('text-max-width').pfValue;
        var ellipsized = '';
        var ellipsis = "\u2026";
        var incLastCh = false;
        if (this.calculateLabelDimensions(ele, text).width < _maxW) // the label already fits
        return text;
        for(var i = 0; i < text.length; i++){
            var widthWithNextCh = this.calculateLabelDimensions(ele, ellipsized + text[i] + ellipsis).width;
            if (widthWithNextCh > _maxW) break;
            ellipsized += text[i];
            if (i === text.length - 1) incLastCh = true;
        }
        if (!incLastCh) ellipsized += ellipsis;
        return ellipsized;
    } // if ellipsize
    return text;
};
$e815fda779bc047b$var$BRp$9.getLabelJustification = function(ele) {
    var justification = ele.pstyle('text-justification').strValue;
    var textHalign = ele.pstyle('text-halign').strValue;
    if (justification === 'auto') {
        if (ele.isNode()) switch(textHalign){
            case 'left':
                return 'right';
            case 'right':
                return 'left';
            default:
                return 'center';
        }
        else return 'center';
    } else return justification;
};
$e815fda779bc047b$var$BRp$9.calculateLabelDimensions = function(ele, text) {
    var r = this;
    var containerWindow = r.cy.window();
    var document1 = containerWindow.document;
    var padding = 0; // add padding around text dims, as the measurement isn't that accurate
    var fStyle = ele.pstyle('font-style').strValue;
    var size = ele.pstyle('font-size').pfValue;
    var family = ele.pstyle('font-family').strValue;
    var weight = ele.pstyle('font-weight').strValue;
    var canvas = this.labelCalcCanvas;
    var c2d = this.labelCalcCanvasContext;
    if (!canvas) {
        canvas = this.labelCalcCanvas = document1.createElement('canvas');
        c2d = this.labelCalcCanvasContext = canvas.getContext('2d');
        var ds = canvas.style;
        ds.position = 'absolute';
        ds.left = '-9999px';
        ds.top = '-9999px';
        ds.zIndex = '-1';
        ds.visibility = 'hidden';
        ds.pointerEvents = 'none';
    }
    c2d.font = "".concat(fStyle, " ").concat(weight, " ").concat(size, "px ").concat(family);
    var width = 0;
    var height = 0;
    var lines = text.split('\n');
    for(var i = 0; i < lines.length; i++){
        var line = lines[i];
        var metrics = c2d.measureText(line);
        var w = Math.ceil(metrics.width);
        var h = size;
        width = Math.max(w, width);
        height += h;
    }
    width += padding;
    height += padding;
    return {
        width: width,
        height: height
    };
};
$e815fda779bc047b$var$BRp$9.calculateLabelAngle = function(ele, prefix) {
    var _p = ele._private;
    var rs = _p.rscratch;
    var isEdge = ele.isEdge();
    var prefixDash = prefix ? prefix + '-' : '';
    var rot = ele.pstyle(prefixDash + 'text-rotation');
    var rotStr = rot.strValue;
    if (rotStr === 'none') return 0;
    else if (isEdge && rotStr === 'autorotate') return rs.labelAutoAngle;
    else if (rotStr === 'autorotate') return 0;
    else return rot.pfValue;
};
$e815fda779bc047b$var$BRp$9.calculateLabelAngles = function(ele) {
    var r = this;
    var isEdge = ele.isEdge();
    var _p = ele._private;
    var rs = _p.rscratch;
    rs.labelAngle = r.calculateLabelAngle(ele);
    if (isEdge) {
        rs.sourceLabelAngle = r.calculateLabelAngle(ele, 'source');
        rs.targetLabelAngle = r.calculateLabelAngle(ele, 'target');
    }
};
var $e815fda779bc047b$var$BRp$8 = {};
var $e815fda779bc047b$var$TOO_SMALL_CUT_RECT = 28;
var $e815fda779bc047b$var$warnedCutRect = false;
$e815fda779bc047b$var$BRp$8.getNodeShape = function(node) {
    var r = this;
    var shape = node.pstyle('shape').value;
    if (shape === 'cutrectangle' && (node.width() < $e815fda779bc047b$var$TOO_SMALL_CUT_RECT || node.height() < $e815fda779bc047b$var$TOO_SMALL_CUT_RECT)) {
        if (!$e815fda779bc047b$var$warnedCutRect) {
            $e815fda779bc047b$var$warn('The `cutrectangle` node shape can not be used at small sizes so `rectangle` is used instead');
            $e815fda779bc047b$var$warnedCutRect = true;
        }
        return 'rectangle';
    }
    if (node.isParent()) {
        if (shape === 'rectangle' || shape === 'roundrectangle' || shape === 'round-rectangle' || shape === 'cutrectangle' || shape === 'cut-rectangle' || shape === 'barrel') return shape;
        else return 'rectangle';
    }
    if (shape === 'polygon') {
        var points = node.pstyle('shape-polygon-points').value;
        return r.nodeShapes.makePolygon(points).name;
    }
    return shape;
};
var $e815fda779bc047b$var$BRp$7 = {};
$e815fda779bc047b$var$BRp$7.registerCalculationListeners = function() {
    var cy = this.cy;
    var elesToUpdate = cy.collection();
    var r = this;
    var enqueue = function enqueue(eles) {
        var dirtyStyleCaches = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        elesToUpdate.merge(eles);
        if (dirtyStyleCaches) for(var i = 0; i < eles.length; i++){
            var ele = eles[i];
            var _p = ele._private;
            var rstyle = _p.rstyle;
            rstyle.clean = false;
            rstyle.cleanConnected = false;
        }
    };
    r.binder(cy).on('bounds.* dirty.*', function onDirtyBounds(e) {
        var ele = e.target;
        enqueue(ele);
    }).on('style.* background.*', function onDirtyStyle(e) {
        var ele = e.target;
        enqueue(ele, false);
    });
    var updateEleCalcs = function updateEleCalcs(willDraw) {
        if (willDraw) {
            var fns = r.onUpdateEleCalcsFns;
            // because we need to have up-to-date style (e.g. stylesheet mappers)
            // before calculating rendered style (and pstyle might not be called yet)
            elesToUpdate.cleanStyle();
            for(var i = 0; i < elesToUpdate.length; i++){
                var ele = elesToUpdate[i];
                var rstyle = ele._private.rstyle;
                if (ele.isNode() && !rstyle.cleanConnected) {
                    enqueue(ele.connectedEdges());
                    rstyle.cleanConnected = true;
                }
            }
            if (fns) for(var _i = 0; _i < fns.length; _i++){
                var fn = fns[_i];
                fn(willDraw, elesToUpdate);
            }
            r.recalculateRenderedStyle(elesToUpdate);
            elesToUpdate = cy.collection();
        }
    };
    r.flushRenderedStyleQueue = function() {
        updateEleCalcs(true);
    };
    r.beforeRender(updateEleCalcs, r.beforeRenderPriorities.eleCalcs);
};
$e815fda779bc047b$var$BRp$7.onUpdateEleCalcs = function(fn) {
    var fns = this.onUpdateEleCalcsFns = this.onUpdateEleCalcsFns || [];
    fns.push(fn);
};
$e815fda779bc047b$var$BRp$7.recalculateRenderedStyle = function(eles, useCache) {
    var isCleanConnected = function isCleanConnected(ele) {
        return ele._private.rstyle.cleanConnected;
    };
    if (eles.length === 0) return;
    var edges = [];
    var nodes = [];
    // the renderer can't be used for calcs when destroyed, e.g. ele.boundingBox()
    if (this.destroyed) return;
    // use cache by default for perf
    if (useCache === undefined) useCache = true;
    for(var i = 0; i < eles.length; i++){
        var ele = eles[i];
        var _p = ele._private;
        var rstyle = _p.rstyle;
        // an edge may be implicitly dirty b/c of one of its connected nodes
        // (and a request for recalc may come in between frames)
        if (ele.isEdge() && (!isCleanConnected(ele.source()) || !isCleanConnected(ele.target()))) rstyle.clean = false;
        if (ele.isEdge() && ele.isBundledBezier()) {
            if (ele.parallelEdges().some(function(ele) {
                return !ele._private.rstyle.clean && ele.isBundledBezier();
            })) rstyle.clean = false;
        }
        // only update if dirty and in graph
        if (useCache && rstyle.clean || ele.removed()) continue;
        // only update if not display: none
        if (ele.pstyle('display').value === 'none') continue;
        if (_p.group === 'nodes') nodes.push(ele);
        else // edges
        edges.push(ele);
        rstyle.clean = true;
    }
    // update node data from projections
    for(var _i2 = 0; _i2 < nodes.length; _i2++){
        var _ele = nodes[_i2];
        var _p2 = _ele._private;
        var _rstyle = _p2.rstyle;
        var pos = _ele.position();
        this.recalculateNodeLabelProjection(_ele);
        _rstyle.nodeX = pos.x;
        _rstyle.nodeY = pos.y;
        _rstyle.nodeW = _ele.pstyle('width').pfValue;
        _rstyle.nodeH = _ele.pstyle('height').pfValue;
    }
    this.recalculateEdgeProjections(edges);
    // update edge data from projections
    for(var _i3 = 0; _i3 < edges.length; _i3++){
        var _ele2 = edges[_i3];
        var _p3 = _ele2._private;
        var _rstyle2 = _p3.rstyle;
        var rs = _p3.rscratch;
        // update rstyle positions
        _rstyle2.srcX = rs.arrowStartX;
        _rstyle2.srcY = rs.arrowStartY;
        _rstyle2.tgtX = rs.arrowEndX;
        _rstyle2.tgtY = rs.arrowEndY;
        _rstyle2.midX = rs.midX;
        _rstyle2.midY = rs.midY;
        _rstyle2.labelAngle = rs.labelAngle;
        _rstyle2.sourceLabelAngle = rs.sourceLabelAngle;
        _rstyle2.targetLabelAngle = rs.targetLabelAngle;
    }
};
var $e815fda779bc047b$var$BRp$6 = {};
$e815fda779bc047b$var$BRp$6.updateCachedGrabbedEles = function() {
    var eles = this.cachedZSortedEles;
    if (!eles) // just let this be recalculated on the next z sort tick
    return;
    eles.drag = [];
    eles.nondrag = [];
    var grabTargets = [];
    for(var i = 0; i < eles.length; i++){
        var ele = eles[i];
        var rs = ele._private.rscratch;
        if (ele.grabbed() && !ele.isParent()) grabTargets.push(ele);
        else if (rs.inDragLayer) eles.drag.push(ele);
        else eles.nondrag.push(ele);
    }
    // put the grab target nodes last so it's on top of its neighbourhood
    for(var i = 0; i < grabTargets.length; i++){
        var ele = grabTargets[i];
        eles.drag.push(ele);
    }
};
$e815fda779bc047b$var$BRp$6.invalidateCachedZSortedEles = function() {
    this.cachedZSortedEles = null;
};
$e815fda779bc047b$var$BRp$6.getCachedZSortedEles = function(forceRecalc) {
    if (forceRecalc || !this.cachedZSortedEles) {
        var eles = this.cy.mutableElements().toArray();
        eles.sort($e815fda779bc047b$var$zIndexSort);
        eles.interactive = eles.filter(function(ele) {
            return ele.interactive();
        });
        this.cachedZSortedEles = eles;
        this.updateCachedGrabbedEles();
    } else eles = this.cachedZSortedEles;
    return eles;
};
var $e815fda779bc047b$var$BRp$5 = {};
[
    $e815fda779bc047b$var$BRp$e,
    $e815fda779bc047b$var$BRp$d,
    $e815fda779bc047b$var$BRp$c,
    $e815fda779bc047b$var$BRp$b,
    $e815fda779bc047b$var$BRp$a,
    $e815fda779bc047b$var$BRp$9,
    $e815fda779bc047b$var$BRp$8,
    $e815fda779bc047b$var$BRp$7,
    $e815fda779bc047b$var$BRp$6
].forEach(function(props) {
    $e815fda779bc047b$var$extend($e815fda779bc047b$var$BRp$5, props);
});
var $e815fda779bc047b$var$BRp$4 = {};
$e815fda779bc047b$var$BRp$4.getCachedImage = function(url, crossOrigin, onLoad) {
    var r = this;
    var imageCache = r.imageCache = r.imageCache || {};
    var cache = imageCache[url];
    if (cache) {
        if (!cache.image.complete) cache.image.addEventListener('load', onLoad);
        return cache.image;
    } else {
        cache = imageCache[url] = imageCache[url] || {};
        var image = cache.image = new Image(); // eslint-disable-line no-undef
        image.addEventListener('load', onLoad);
        image.addEventListener('error', function() {
            image.error = true;
        });
        // #1582 safari doesn't load data uris with crossOrigin properly
        // https://bugs.webkit.org/show_bug.cgi?id=123978
        var dataUriPrefix = 'data:';
        var isDataUri = url.substring(0, dataUriPrefix.length).toLowerCase() === dataUriPrefix;
        if (!isDataUri) {
            // if crossorigin is 'null'(stringified), then manually set it to null 
            crossOrigin = crossOrigin === 'null' ? null : crossOrigin;
            image.crossOrigin = crossOrigin; // prevent tainted canvas
        }
        image.src = url;
        return image;
    }
};
var $e815fda779bc047b$var$setGrabState = function setGrabState(ele, grabbed) {
    var ele0 = ele[0];
    if (!ele0 || ele0._private.grabbed === grabbed) return;
    ele0._private.grabbed = grabbed;
    ele.updateStyle(false);
};
var $e815fda779bc047b$var$setGrabbed = function setGrabbed(ele) {
    $e815fda779bc047b$var$setGrabState(ele, true);
};
var $e815fda779bc047b$var$setFreed = function setFreed(ele) {
    $e815fda779bc047b$var$setGrabState(ele, false);
};
var $e815fda779bc047b$var$BRp$3 = {};
/* global document, ResizeObserver, MutationObserver */ $e815fda779bc047b$var$BRp$3.registerBinding = function(target, event, handler, useCapture) {
    // eslint-disable-line no-unused-vars
    var args = Array.prototype.slice.apply(arguments, [
        1
    ]); // copy
    if (Array.isArray(target)) {
        var res = [];
        for(var i = 0; i < target.length; i++){
            var t = target[i];
            if (t !== undefined) {
                var b = this.binder(t);
                res.push(b.on.apply(b, args));
            }
        }
        return res;
    }
    var b = this.binder(target);
    return b.on.apply(b, args);
};
$e815fda779bc047b$var$BRp$3.binder = function(tgt) {
    var r = this;
    var containerWindow = r.cy.window();
    var tgtIsDom = tgt === containerWindow || tgt === containerWindow.document || tgt === containerWindow.document.body || $e815fda779bc047b$var$domElement(tgt);
    if (r.supportsPassiveEvents == null) {
        // from https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md#feature-detection
        var supportsPassive = false;
        try {
            var opts = Object.defineProperty({}, 'passive', {
                get: function get() {
                    supportsPassive = true;
                    return true;
                }
            });
            containerWindow.addEventListener('test', null, opts);
        } catch (err) {
        // not supported
        }
        r.supportsPassiveEvents = supportsPassive;
    }
    var on = function on(event, handler, useCapture) {
        var args = Array.prototype.slice.call(arguments);
        if (tgtIsDom && r.supportsPassiveEvents) // replace useCapture w/ opts obj
        args[2] = {
            capture: useCapture != null ? useCapture : false,
            passive: false,
            once: false
        };
        r.bindings.push({
            target: tgt,
            args: args
        });
        (tgt.addEventListener || tgt.on).apply(tgt, args);
        return this;
    };
    return {
        on: on,
        addEventListener: on,
        addListener: on,
        bind: on
    };
};
$e815fda779bc047b$var$BRp$3.nodeIsDraggable = function(node) {
    return node && node.isNode() && !node.locked() && node.grabbable();
};
$e815fda779bc047b$var$BRp$3.nodeIsGrabbable = function(node) {
    return this.nodeIsDraggable(node) && node.interactive();
};
$e815fda779bc047b$var$BRp$3.load = function() {
    var r = this;
    var containerWindow = r.cy.window();
    var isSelected = function isSelected(ele) {
        return ele.selected();
    };
    var getShadowRoot = function getShadowRoot(element) {
        var rootNode = element.getRootNode();
        // Check if the root node is a shadow root
        if (rootNode && rootNode.nodeType === 11 && rootNode.host !== undefined) return rootNode;
    };
    var triggerEvents = function triggerEvents(target, names, e, position) {
        if (target == null) target = r.cy;
        for(var i = 0; i < names.length; i++){
            var name = names[i];
            target.emit({
                originalEvent: e,
                type: name,
                position: position
            });
        }
    };
    var isMultSelKeyDown = function isMultSelKeyDown(e) {
        return e.shiftKey || e.metaKey || e.ctrlKey; // maybe e.altKey
    };
    var allowPanningPassthrough = function allowPanningPassthrough(down, downs) {
        var allowPassthrough = true;
        if (r.cy.hasCompoundNodes() && down && down.pannable()) // a grabbable compound node below the ele => no passthrough panning
        for(var i = 0; downs && i < downs.length; i++){
            var down = downs[i];
            //if any parent node in event hierarchy isn't pannable, reject passthrough
            if (down.isNode() && down.isParent() && !down.pannable()) {
                allowPassthrough = false;
                break;
            }
        }
        else allowPassthrough = true;
        return allowPassthrough;
    };
    var setInDragLayer = function setInDragLayer(ele) {
        ele[0]._private.rscratch.inDragLayer = true;
    };
    var setOutDragLayer = function setOutDragLayer(ele) {
        ele[0]._private.rscratch.inDragLayer = false;
    };
    var setGrabTarget = function setGrabTarget(ele) {
        ele[0]._private.rscratch.isGrabTarget = true;
    };
    var removeGrabTarget = function removeGrabTarget(ele) {
        ele[0]._private.rscratch.isGrabTarget = false;
    };
    var addToDragList = function addToDragList(ele, opts) {
        var list = opts.addToList;
        var listHasEle = list.has(ele);
        if (!listHasEle && ele.grabbable() && !ele.locked()) {
            list.merge(ele);
            $e815fda779bc047b$var$setGrabbed(ele);
        }
    };
    // helper function to determine which child nodes and inner edges
    // of a compound node to be dragged as well as the grabbed and selected nodes
    var addDescendantsToDrag = function addDescendantsToDrag(node, opts) {
        if (!node.cy().hasCompoundNodes()) return;
        if (opts.inDragLayer == null && opts.addToList == null) return;
         // nothing to do
        var innerNodes = node.descendants();
        if (opts.inDragLayer) {
            innerNodes.forEach(setInDragLayer);
            innerNodes.connectedEdges().forEach(setInDragLayer);
        }
        if (opts.addToList) addToDragList(innerNodes, opts);
    };
    // adds the given nodes and its neighbourhood to the drag layer
    var addNodesToDrag = function addNodesToDrag(nodes, opts) {
        opts = opts || {};
        var hasCompoundNodes = nodes.cy().hasCompoundNodes();
        if (opts.inDragLayer) {
            nodes.forEach(setInDragLayer);
            nodes.neighborhood().stdFilter(function(ele) {
                return !hasCompoundNodes || ele.isEdge();
            }).forEach(setInDragLayer);
        }
        if (opts.addToList) nodes.forEach(function(ele) {
            addToDragList(ele, opts);
        });
        addDescendantsToDrag(nodes, opts); // always add to drag
        // also add nodes and edges related to the topmost ancestor
        updateAncestorsInDragLayer(nodes, {
            inDragLayer: opts.inDragLayer
        });
        r.updateCachedGrabbedEles();
    };
    var addNodeToDrag = addNodesToDrag;
    var freeDraggedElements = function freeDraggedElements(grabbedEles) {
        if (!grabbedEles) return;
        // just go over all elements rather than doing a bunch of (possibly expensive) traversals
        r.getCachedZSortedEles().forEach(function(ele) {
            $e815fda779bc047b$var$setFreed(ele);
            setOutDragLayer(ele);
            removeGrabTarget(ele);
        });
        r.updateCachedGrabbedEles();
    };
    // helper function to determine which ancestor nodes and edges should go
    // to the drag layer (or should be removed from drag layer).
    var updateAncestorsInDragLayer = function updateAncestorsInDragLayer(node, opts) {
        if (opts.inDragLayer == null && opts.addToList == null) return;
         // nothing to do
        if (!node.cy().hasCompoundNodes()) return;
        // find top-level parent
        var parent = node.ancestors().orphans();
        // no parent node: no nodes to add to the drag layer
        if (parent.same(node)) return;
        var nodes = parent.descendants().spawnSelf().merge(parent).unmerge(node).unmerge(node.descendants());
        var edges = nodes.connectedEdges();
        if (opts.inDragLayer) {
            edges.forEach(setInDragLayer);
            nodes.forEach(setInDragLayer);
        }
        if (opts.addToList) nodes.forEach(function(ele) {
            addToDragList(ele, opts);
        });
    };
    var blurActiveDomElement = function blurActiveDomElement() {
        if (document.activeElement != null && document.activeElement.blur != null) document.activeElement.blur();
    };
    var haveMutationsApi = typeof MutationObserver !== 'undefined';
    var haveResizeObserverApi = typeof ResizeObserver !== 'undefined';
    // watch for when the cy container is removed from the dom
    if (haveMutationsApi) {
        r.removeObserver = new MutationObserver(function(mutns) {
            // eslint-disable-line no-undef
            for(var i = 0; i < mutns.length; i++){
                var mutn = mutns[i];
                var rNodes = mutn.removedNodes;
                if (rNodes) for(var j = 0; j < rNodes.length; j++){
                    var rNode = rNodes[j];
                    if (rNode === r.container) {
                        r.destroy();
                        break;
                    }
                }
            }
        });
        if (r.container.parentNode) r.removeObserver.observe(r.container.parentNode, {
            childList: true
        });
    } else r.registerBinding(r.container, 'DOMNodeRemoved', function(e) {
        // eslint-disable-line no-unused-vars
        r.destroy();
    });
    var onResize = $e815fda779bc047b$var$debounce(function() {
        r.cy.resize();
    }, 100);
    if (haveMutationsApi) {
        r.styleObserver = new MutationObserver(onResize); // eslint-disable-line no-undef
        r.styleObserver.observe(r.container, {
            attributes: true
        });
    }
    // auto resize
    r.registerBinding(containerWindow, 'resize', onResize); // eslint-disable-line no-undef
    if (haveResizeObserverApi) {
        r.resizeObserver = new ResizeObserver(onResize); // eslint-disable-line no-undef
        r.resizeObserver.observe(r.container);
    }
    var forEachUp = function forEachUp(domEle, fn) {
        while(domEle != null){
            fn(domEle);
            domEle = domEle.parentNode;
        }
    };
    var invalidateCoords = function invalidateCoords() {
        r.invalidateContainerClientCoordsCache();
    };
    forEachUp(r.container, function(domEle) {
        r.registerBinding(domEle, 'transitionend', invalidateCoords);
        r.registerBinding(domEle, 'animationend', invalidateCoords);
        r.registerBinding(domEle, 'scroll', invalidateCoords);
    });
    // stop right click menu from appearing on cy
    r.registerBinding(r.container, 'contextmenu', function(e) {
        e.preventDefault();
    });
    var inBoxSelection = function inBoxSelection() {
        return r.selection[4] !== 0;
    };
    var eventInContainer = function eventInContainer(e) {
        // save cycles if mouse events aren't to be captured
        var containerPageCoords = r.findContainerClientCoords();
        var x = containerPageCoords[0];
        var y = containerPageCoords[1];
        var width = containerPageCoords[2];
        var height = containerPageCoords[3];
        var positions = e.touches ? e.touches : [
            e
        ];
        var atLeastOnePosInside = false;
        for(var i = 0; i < positions.length; i++){
            var p = positions[i];
            if (x <= p.clientX && p.clientX <= x + width && y <= p.clientY && p.clientY <= y + height) {
                atLeastOnePosInside = true;
                break;
            }
        }
        if (!atLeastOnePosInside) return false;
        var container = r.container;
        var target = e.target;
        var tParent = target.parentNode;
        var containerIsTarget = false;
        while(tParent){
            if (tParent === container) {
                containerIsTarget = true;
                break;
            }
            tParent = tParent.parentNode;
        }
        if (!containerIsTarget) return false;
         // if target is outisde cy container, then this event is not for us
        return true;
    };
    // Primary key
    r.registerBinding(r.container, 'mousedown', function mousedownHandler(e) {
        if (!eventInContainer(e)) return;
        // during left mouse button gestures, ignore other buttons
        if (r.hoverData.which === 1 && e.which !== 1) return;
        e.preventDefault();
        blurActiveDomElement();
        r.hoverData.capture = true;
        r.hoverData.which = e.which;
        var cy = r.cy;
        var gpos = [
            e.clientX,
            e.clientY
        ];
        var pos = r.projectIntoViewport(gpos[0], gpos[1]);
        var select = r.selection;
        var nears = r.findNearestElements(pos[0], pos[1], true, false);
        var near = nears[0];
        var draggedElements = r.dragData.possibleDragElements;
        r.hoverData.mdownPos = pos;
        r.hoverData.mdownGPos = gpos;
        var makeEvent = function makeEvent(type) {
            return {
                originalEvent: e,
                type: type,
                position: {
                    x: pos[0],
                    y: pos[1]
                }
            };
        };
        var checkForTaphold = function checkForTaphold() {
            r.hoverData.tapholdCancelled = false;
            clearTimeout(r.hoverData.tapholdTimeout);
            r.hoverData.tapholdTimeout = setTimeout(function() {
                if (r.hoverData.tapholdCancelled) return;
                else {
                    var ele = r.hoverData.down;
                    if (ele) ele.emit(makeEvent('taphold'));
                    else cy.emit(makeEvent('taphold'));
                }
            }, r.tapholdDuration);
        };
        // Right click button
        if (e.which == 3) {
            r.hoverData.cxtStarted = true;
            var cxtEvt = {
                originalEvent: e,
                type: 'cxttapstart',
                position: {
                    x: pos[0],
                    y: pos[1]
                }
            };
            if (near) {
                near.activate();
                near.emit(cxtEvt);
                r.hoverData.down = near;
            } else cy.emit(cxtEvt);
            r.hoverData.downTime = new Date().getTime();
            r.hoverData.cxtDragged = false;
        // Primary button
        } else if (e.which == 1) {
            if (near) near.activate();
            // If something is under the cursor and it is draggable, prepare to grab it
            if (near != null) {
                if (r.nodeIsGrabbable(near)) {
                    var triggerGrab = function triggerGrab(ele) {
                        ele.emit(makeEvent('grab'));
                    };
                    setGrabTarget(near);
                    if (!near.selected()) {
                        draggedElements = r.dragData.possibleDragElements = cy.collection();
                        addNodeToDrag(near, {
                            addToList: draggedElements
                        });
                        near.emit(makeEvent('grabon')).emit(makeEvent('grab'));
                    } else {
                        draggedElements = r.dragData.possibleDragElements = cy.collection();
                        var selectedNodes = cy.$(function(ele) {
                            return ele.isNode() && ele.selected() && r.nodeIsGrabbable(ele);
                        });
                        addNodesToDrag(selectedNodes, {
                            addToList: draggedElements
                        });
                        near.emit(makeEvent('grabon'));
                        selectedNodes.forEach(triggerGrab);
                    }
                    r.redrawHint('eles', true);
                    r.redrawHint('drag', true);
                }
            }
            r.hoverData.down = near;
            r.hoverData.downs = nears;
            r.hoverData.downTime = new Date().getTime();
            triggerEvents(near, [
                'mousedown',
                'tapstart',
                'vmousedown'
            ], e, {
                x: pos[0],
                y: pos[1]
            });
            if (near == null) {
                select[4] = 1;
                r.data.bgActivePosistion = {
                    x: pos[0],
                    y: pos[1]
                };
                r.redrawHint('select', true);
                r.redraw();
            } else if (near.pannable()) select[4] = 1; // for future pan
            checkForTaphold();
        }
        // Initialize selection box coordinates
        select[0] = select[2] = pos[0];
        select[1] = select[3] = pos[1];
    }, false);
    var shadowRoot = getShadowRoot(r.container);
    r.registerBinding([
        containerWindow,
        shadowRoot
    ], 'mousemove', function mousemoveHandler(e) {
        // eslint-disable-line no-undef
        var capture = r.hoverData.capture;
        if (!capture && !eventInContainer(e)) return;
        var preventDefault = false;
        var cy = r.cy;
        var zoom = cy.zoom();
        var gpos = [
            e.clientX,
            e.clientY
        ];
        var pos = r.projectIntoViewport(gpos[0], gpos[1]);
        var mdownPos = r.hoverData.mdownPos;
        var mdownGPos = r.hoverData.mdownGPos;
        var select = r.selection;
        var near = null;
        if (!r.hoverData.draggingEles && !r.hoverData.dragging && !r.hoverData.selecting) near = r.findNearestElement(pos[0], pos[1], true, false);
        var last = r.hoverData.last;
        var down = r.hoverData.down;
        var disp = [
            pos[0] - select[2],
            pos[1] - select[3]
        ];
        var draggedElements = r.dragData.possibleDragElements;
        var isOverThresholdDrag;
        if (mdownGPos) {
            var dx = gpos[0] - mdownGPos[0];
            var dx2 = dx * dx;
            var dy = gpos[1] - mdownGPos[1];
            var dy2 = dy * dy;
            var dist2 = dx2 + dy2;
            r.hoverData.isOverThresholdDrag = isOverThresholdDrag = dist2 >= r.desktopTapThreshold2;
        }
        var multSelKeyDown = isMultSelKeyDown(e);
        if (isOverThresholdDrag) r.hoverData.tapholdCancelled = true;
        var updateDragDelta = function updateDragDelta() {
            var dragDelta = r.hoverData.dragDelta = r.hoverData.dragDelta || [];
            if (dragDelta.length === 0) {
                dragDelta.push(disp[0]);
                dragDelta.push(disp[1]);
            } else {
                dragDelta[0] += disp[0];
                dragDelta[1] += disp[1];
            }
        };
        preventDefault = true;
        triggerEvents(near, [
            'mousemove',
            'vmousemove',
            'tapdrag'
        ], e, {
            x: pos[0],
            y: pos[1]
        });
        var makeEvent = function makeEvent(type) {
            return {
                originalEvent: e,
                type: type,
                position: {
                    x: pos[0],
                    y: pos[1]
                }
            };
        };
        var goIntoBoxMode = function goIntoBoxMode() {
            r.data.bgActivePosistion = undefined;
            if (!r.hoverData.selecting) cy.emit(makeEvent('boxstart'));
            select[4] = 1;
            r.hoverData.selecting = true;
            r.redrawHint('select', true);
            r.redraw();
        };
        // trigger context drag if rmouse down
        if (r.hoverData.which === 3) // but only if over threshold
        {
            if (isOverThresholdDrag) {
                var cxtEvt = makeEvent('cxtdrag');
                if (down) down.emit(cxtEvt);
                else cy.emit(cxtEvt);
                r.hoverData.cxtDragged = true;
                if (!r.hoverData.cxtOver || near !== r.hoverData.cxtOver) {
                    if (r.hoverData.cxtOver) r.hoverData.cxtOver.emit(makeEvent('cxtdragout'));
                    r.hoverData.cxtOver = near;
                    if (near) near.emit(makeEvent('cxtdragover'));
                }
            }
        } else if (r.hoverData.dragging) {
            preventDefault = true;
            if (cy.panningEnabled() && cy.userPanningEnabled()) {
                var deltaP;
                if (r.hoverData.justStartedPan) {
                    var mdPos = r.hoverData.mdownPos;
                    deltaP = {
                        x: (pos[0] - mdPos[0]) * zoom,
                        y: (pos[1] - mdPos[1]) * zoom
                    };
                    r.hoverData.justStartedPan = false;
                } else deltaP = {
                    x: disp[0] * zoom,
                    y: disp[1] * zoom
                };
                cy.panBy(deltaP);
                cy.emit(makeEvent('dragpan'));
                r.hoverData.dragged = true;
            }
            // Needs reproject due to pan changing viewport
            pos = r.projectIntoViewport(e.clientX, e.clientY);
        // Checks primary button down & out of time & mouse not moved much
        } else if (select[4] == 1 && (down == null || down.pannable())) {
            if (isOverThresholdDrag) {
                if (!r.hoverData.dragging && cy.boxSelectionEnabled() && (multSelKeyDown || !cy.panningEnabled() || !cy.userPanningEnabled())) goIntoBoxMode();
                else if (!r.hoverData.selecting && cy.panningEnabled() && cy.userPanningEnabled()) {
                    var allowPassthrough = allowPanningPassthrough(down, r.hoverData.downs);
                    if (allowPassthrough) {
                        r.hoverData.dragging = true;
                        r.hoverData.justStartedPan = true;
                        select[4] = 0;
                        r.data.bgActivePosistion = $e815fda779bc047b$var$array2point(mdownPos);
                        r.redrawHint('select', true);
                        r.redraw();
                    }
                }
                if (down && down.pannable() && down.active()) down.unactivate();
            }
        } else {
            if (down && down.pannable() && down.active()) down.unactivate();
            if ((!down || !down.grabbed()) && near != last) {
                if (last) triggerEvents(last, [
                    'mouseout',
                    'tapdragout'
                ], e, {
                    x: pos[0],
                    y: pos[1]
                });
                if (near) triggerEvents(near, [
                    'mouseover',
                    'tapdragover'
                ], e, {
                    x: pos[0],
                    y: pos[1]
                });
                r.hoverData.last = near;
            }
            if (down) {
                if (isOverThresholdDrag) {
                    // then we can take action
                    if (cy.boxSelectionEnabled() && multSelKeyDown) {
                        // then selection overrides
                        if (down && down.grabbed()) {
                            freeDraggedElements(draggedElements);
                            down.emit(makeEvent('freeon'));
                            draggedElements.emit(makeEvent('free'));
                            if (r.dragData.didDrag) {
                                down.emit(makeEvent('dragfreeon'));
                                draggedElements.emit(makeEvent('dragfree'));
                            }
                        }
                        goIntoBoxMode();
                    } else if (down && down.grabbed() && r.nodeIsDraggable(down)) {
                        // drag node
                        var justStartedDrag = !r.dragData.didDrag;
                        if (justStartedDrag) r.redrawHint('eles', true);
                        r.dragData.didDrag = true; // indicate that we actually did drag the node
                        // now, add the elements to the drag layer if not done already
                        if (!r.hoverData.draggingEles) addNodesToDrag(draggedElements, {
                            inDragLayer: true
                        });
                        var totalShift = {
                            x: 0,
                            y: 0
                        };
                        if ($e815fda779bc047b$var$number$1(disp[0]) && $e815fda779bc047b$var$number$1(disp[1])) {
                            totalShift.x += disp[0];
                            totalShift.y += disp[1];
                            if (justStartedDrag) {
                                var dragDelta = r.hoverData.dragDelta;
                                if (dragDelta && $e815fda779bc047b$var$number$1(dragDelta[0]) && $e815fda779bc047b$var$number$1(dragDelta[1])) {
                                    totalShift.x += dragDelta[0];
                                    totalShift.y += dragDelta[1];
                                }
                            }
                        }
                        r.hoverData.draggingEles = true;
                        draggedElements.silentShift(totalShift).emit(makeEvent('position')).emit(makeEvent('drag'));
                        r.redrawHint('drag', true);
                        r.redraw();
                    }
                } else // otherwise save drag delta for when we actually start dragging so the relative grab pos is constant
                updateDragDelta();
            }
            // prevent the dragging from triggering text selection on the page
            preventDefault = true;
        }
        select[2] = pos[0];
        select[3] = pos[1];
        if (preventDefault) {
            if (e.stopPropagation) e.stopPropagation();
            if (e.preventDefault) e.preventDefault();
            return false;
        }
    }, false);
    var clickTimeout, didDoubleClick, prevClickTimeStamp;
    r.registerBinding(containerWindow, 'mouseup', function mouseupHandler(e) {
        // eslint-disable-line no-undef
        // during left mouse button gestures, ignore other buttons
        if (r.hoverData.which === 1 && e.which !== 1 && r.hoverData.capture) return;
        var capture = r.hoverData.capture;
        if (!capture) return;
        r.hoverData.capture = false;
        var cy = r.cy;
        var pos = r.projectIntoViewport(e.clientX, e.clientY);
        var select = r.selection;
        var near = r.findNearestElement(pos[0], pos[1], true, false);
        var draggedElements = r.dragData.possibleDragElements;
        var down = r.hoverData.down;
        var multSelKeyDown = isMultSelKeyDown(e);
        if (r.data.bgActivePosistion) {
            r.redrawHint('select', true);
            r.redraw();
        }
        r.hoverData.tapholdCancelled = true;
        r.data.bgActivePosistion = undefined; // not active bg now
        if (down) down.unactivate();
        var makeEvent = function makeEvent(type) {
            return {
                originalEvent: e,
                type: type,
                position: {
                    x: pos[0],
                    y: pos[1]
                }
            };
        };
        if (r.hoverData.which === 3) {
            var cxtEvt = makeEvent('cxttapend');
            if (down) down.emit(cxtEvt);
            else cy.emit(cxtEvt);
            if (!r.hoverData.cxtDragged) {
                var cxtTap = makeEvent('cxttap');
                if (down) down.emit(cxtTap);
                else cy.emit(cxtTap);
            }
            r.hoverData.cxtDragged = false;
            r.hoverData.which = null;
        } else if (r.hoverData.which === 1) {
            triggerEvents(near, [
                'mouseup',
                'tapend',
                'vmouseup'
            ], e, {
                x: pos[0],
                y: pos[1]
            });
            if (!r.dragData.didDrag && // didn't move a node around
            !r.hoverData.dragged && // didn't pan
            !r.hoverData.selecting && // not box selection
            !r.hoverData.isOverThresholdDrag // didn't move too much
            ) {
                triggerEvents(down, [
                    "click",
                    "tap",
                    "vclick"
                ], e, {
                    x: pos[0],
                    y: pos[1]
                });
                didDoubleClick = false;
                if (e.timeStamp - prevClickTimeStamp <= cy.multiClickDebounceTime()) {
                    clickTimeout && clearTimeout(clickTimeout);
                    didDoubleClick = true;
                    prevClickTimeStamp = null;
                    triggerEvents(down, [
                        "dblclick",
                        "dbltap",
                        "vdblclick"
                    ], e, {
                        x: pos[0],
                        y: pos[1]
                    });
                } else {
                    clickTimeout = setTimeout(function() {
                        if (didDoubleClick) return;
                        triggerEvents(down, [
                            "oneclick",
                            "onetap",
                            "voneclick"
                        ], e, {
                            x: pos[0],
                            y: pos[1]
                        });
                    }, cy.multiClickDebounceTime());
                    prevClickTimeStamp = e.timeStamp;
                }
            }
            // Deselect all elements if nothing is currently under the mouse cursor and we aren't dragging something
            if (down == null // not mousedown on node
             && !r.dragData.didDrag // didn't move the node around
             && !r.hoverData.selecting // not box selection
             && !r.hoverData.dragged // didn't pan
             && !isMultSelKeyDown(e)) {
                cy.$(isSelected).unselect([
                    'tapunselect'
                ]);
                if (draggedElements.length > 0) r.redrawHint('eles', true);
                r.dragData.possibleDragElements = draggedElements = cy.collection();
            }
            // Single selection
            if (near == down && !r.dragData.didDrag && !r.hoverData.selecting) {
                if (near != null && near._private.selectable) {
                    if (r.hoverData.dragging) ;
                    else if (cy.selectionType() === 'additive' || multSelKeyDown) {
                        if (near.selected()) near.unselect([
                            'tapunselect'
                        ]);
                        else near.select([
                            'tapselect'
                        ]);
                    } else if (!multSelKeyDown) {
                        cy.$(isSelected).unmerge(near).unselect([
                            'tapunselect'
                        ]);
                        near.select([
                            'tapselect'
                        ]);
                    }
                    r.redrawHint('eles', true);
                }
            }
            if (r.hoverData.selecting) {
                var box = cy.collection(r.getAllInBox(select[0], select[1], select[2], select[3]));
                r.redrawHint('select', true);
                if (box.length > 0) r.redrawHint('eles', true);
                cy.emit(makeEvent('boxend'));
                var eleWouldBeSelected = function eleWouldBeSelected(ele) {
                    return ele.selectable() && !ele.selected();
                };
                if (cy.selectionType() === 'additive') box.emit(makeEvent('box')).stdFilter(eleWouldBeSelected).select().emit(makeEvent('boxselect'));
                else {
                    if (!multSelKeyDown) cy.$(isSelected).unmerge(box).unselect();
                    box.emit(makeEvent('box')).stdFilter(eleWouldBeSelected).select().emit(makeEvent('boxselect'));
                }
                // always need redraw in case eles unselectable
                r.redraw();
            }
            // Cancel drag pan
            if (r.hoverData.dragging) {
                r.hoverData.dragging = false;
                r.redrawHint('select', true);
                r.redrawHint('eles', true);
                r.redraw();
            }
            if (!select[4]) {
                r.redrawHint('drag', true);
                r.redrawHint('eles', true);
                var downWasGrabbed = down && down.grabbed();
                freeDraggedElements(draggedElements);
                if (downWasGrabbed) {
                    down.emit(makeEvent('freeon'));
                    draggedElements.emit(makeEvent('free'));
                    if (r.dragData.didDrag) {
                        down.emit(makeEvent('dragfreeon'));
                        draggedElements.emit(makeEvent('dragfree'));
                    }
                }
            }
        } // else not right mouse
        select[4] = 0;
        r.hoverData.down = null;
        r.hoverData.cxtStarted = false;
        r.hoverData.draggingEles = false;
        r.hoverData.selecting = false;
        r.hoverData.isOverThresholdDrag = false;
        r.dragData.didDrag = false;
        r.hoverData.dragged = false;
        r.hoverData.dragDelta = [];
        r.hoverData.mdownPos = null;
        r.hoverData.mdownGPos = null;
        r.hoverData.which = null;
    }, false);
    var wheelDeltas = []; // log of first N wheel deltas
    var wheelDeltaN = 4; // how many events to log
    var inaccurateScrollDevice;
    var inaccurateScrollFactor = 100000; // base of inaccurate wheel deltas (e.g. base 5 could yield wheels of 10, 25, 50, etc.)
    var allAreDivisibleBy = function allAreDivisibleBy(list, factor) {
        for(var i = 0; i < list.length; i++){
            if (list[i] % factor !== 0) return false;
        }
        return true;
    };
    var allAreSameMagnitude = function allAreSameMagnitude(list) {
        var firstMag = Math.abs(list[0]);
        for(var i = 1; i < list.length; i++){
            if (Math.abs(list[i]) !== firstMag) return false;
        }
        return true;
    };
    var wheelHandler = function wheelHandler(e) {
        var clamp = false;
        var delta = e.deltaY;
        if (delta == null) {
            // compatibility with old browsers
            if (e.wheelDeltaY != null) delta = e.wheelDeltaY / 4;
            else if (e.wheelDelta != null) delta = e.wheelDelta / 4;
        }
        if (delta === 0) return; // no change in zoom (Bug: Zoom becomes erratic on rapid scroll due to deltaY: 0 event #3394)
        if (inaccurateScrollDevice == null) {
            if (wheelDeltas.length >= wheelDeltaN) {
                // use log to determine if inaccurate
                var wds = wheelDeltas;
                inaccurateScrollDevice = allAreDivisibleBy(wds, 5);
                if (!inaccurateScrollDevice) {
                    // check for all large values of exact same magnitude
                    var firstMag = Math.abs(wds[0]);
                    inaccurateScrollDevice = allAreSameMagnitude(wds) && firstMag > 5;
                }
                if (inaccurateScrollDevice) for(var i = 0; i < wds.length; i++)inaccurateScrollFactor = Math.min(Math.abs(wds[i]), inaccurateScrollFactor);
            // console.log('Sampled wheel deltas:', wds);
            // console.log('inaccurateScrollDevice:', inaccurateScrollDevice);
            // console.log('inaccurateScrollFactor:', inaccurateScrollFactor);
            } else {
                // clamp and log until we reach N
                wheelDeltas.push(delta);
                clamp = true;
            // console.log('Clamping initial wheel events until we get a good sample');
            }
        } else if (inaccurateScrollDevice) // keep updating
        inaccurateScrollFactor = Math.min(Math.abs(delta), inaccurateScrollFactor);
        if (r.scrollingPage) return;
         // while scrolling, ignore wheel-to-zoom
        var cy = r.cy;
        var zoom = cy.zoom();
        var pan = cy.pan();
        var pos = r.projectIntoViewport(e.clientX, e.clientY);
        var rpos = [
            pos[0] * zoom + pan.x,
            pos[1] * zoom + pan.y
        ];
        if (r.hoverData.draggingEles || r.hoverData.dragging || r.hoverData.cxtStarted || inBoxSelection()) {
            // if pan dragging or cxt dragging, wheel movements make no zoom
            e.preventDefault();
            return;
        }
        if (cy.panningEnabled() && cy.userPanningEnabled() && cy.zoomingEnabled() && cy.userZoomingEnabled()) {
            e.preventDefault();
            r.data.wheelZooming = true;
            clearTimeout(r.data.wheelTimeout);
            r.data.wheelTimeout = setTimeout(function() {
                r.data.wheelZooming = false;
                r.redrawHint('eles', true);
                r.redraw();
            }, 150);
            var diff;
            if (clamp && Math.abs(delta) > 5) delta = $e815fda779bc047b$var$signum(delta) * 5;
            diff = delta / -250;
            if (inaccurateScrollDevice) {
                diff /= inaccurateScrollFactor;
                diff *= 3;
            }
            diff = diff * r.wheelSensitivity;
            // console.log(`delta = ${delta}, diff = ${diff}, mode = ${e.deltaMode}`)
            var needsWheelFix = e.deltaMode === 1;
            if (needsWheelFix) // fixes slow wheel events on ff/linux and ff/windows
            diff *= 33;
            var newZoom = cy.zoom() * Math.pow(10, diff);
            if (e.type === 'gesturechange') newZoom = r.gestureStartZoom * e.scale;
            cy.zoom({
                level: newZoom,
                renderedPosition: {
                    x: rpos[0],
                    y: rpos[1]
                }
            });
            cy.emit({
                type: e.type === 'gesturechange' ? 'pinchzoom' : 'scrollzoom',
                originalEvent: e,
                position: {
                    x: pos[0],
                    y: pos[1]
                }
            });
        }
    };
    // Functions to help with whether mouse wheel should trigger zooming
    // --
    r.registerBinding(r.container, 'wheel', wheelHandler, true);
    // disable nonstandard wheel events
    // r.registerBinding(r.container, 'mousewheel', wheelHandler, true);
    // r.registerBinding(r.container, 'DOMMouseScroll', wheelHandler, true);
    // r.registerBinding(r.container, 'MozMousePixelScroll', wheelHandler, true); // older firefox
    r.registerBinding(containerWindow, 'scroll', function scrollHandler(e) {
        // eslint-disable-line no-unused-vars
        r.scrollingPage = true;
        clearTimeout(r.scrollingPageTimeout);
        r.scrollingPageTimeout = setTimeout(function() {
            r.scrollingPage = false;
        }, 250);
    }, true);
    // desktop safari pinch to zoom start
    r.registerBinding(r.container, 'gesturestart', function gestureStartHandler(e) {
        r.gestureStartZoom = r.cy.zoom();
        if (!r.hasTouchStarted) // don't affect touch devices like iphone
        e.preventDefault();
    }, true);
    r.registerBinding(r.container, 'gesturechange', function(e) {
        if (!r.hasTouchStarted) // don't affect touch devices like iphone
        wheelHandler(e);
    }, true);
    // Functions to help with handling mouseout/mouseover on the Cytoscape container
    // Handle mouseout on Cytoscape container
    r.registerBinding(r.container, 'mouseout', function mouseOutHandler(e) {
        var pos = r.projectIntoViewport(e.clientX, e.clientY);
        r.cy.emit({
            originalEvent: e,
            type: 'mouseout',
            position: {
                x: pos[0],
                y: pos[1]
            }
        });
    }, false);
    r.registerBinding(r.container, 'mouseover', function mouseOverHandler(e) {
        var pos = r.projectIntoViewport(e.clientX, e.clientY);
        r.cy.emit({
            originalEvent: e,
            type: 'mouseover',
            position: {
                x: pos[0],
                y: pos[1]
            }
        });
    }, false);
    var f1x1, f1y1, f2x1, f2y1; // starting points for pinch-to-zoom
    var distance1, distance1Sq; // initial distance between finger 1 and finger 2 for pinch-to-zoom
    var center1, modelCenter1; // center point on start pinch to zoom
    var offsetLeft, offsetTop;
    var containerWidth, containerHeight;
    var twoFingersStartInside;
    var distance = function distance(x1, y1, x2, y2) {
        return Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
    };
    var distanceSq = function distanceSq(x1, y1, x2, y2) {
        return (x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1);
    };
    var touchstartHandler;
    r.registerBinding(r.container, 'touchstart', touchstartHandler = function touchstartHandler(e) {
        r.hasTouchStarted = true;
        if (!eventInContainer(e)) return;
        blurActiveDomElement();
        r.touchData.capture = true;
        r.data.bgActivePosistion = undefined;
        var cy = r.cy;
        var now = r.touchData.now;
        var earlier = r.touchData.earlier;
        if (e.touches[0]) {
            var pos = r.projectIntoViewport(e.touches[0].clientX, e.touches[0].clientY);
            now[0] = pos[0];
            now[1] = pos[1];
        }
        if (e.touches[1]) {
            var pos = r.projectIntoViewport(e.touches[1].clientX, e.touches[1].clientY);
            now[2] = pos[0];
            now[3] = pos[1];
        }
        if (e.touches[2]) {
            var pos = r.projectIntoViewport(e.touches[2].clientX, e.touches[2].clientY);
            now[4] = pos[0];
            now[5] = pos[1];
        }
        var makeEvent = function makeEvent(type) {
            return {
                originalEvent: e,
                type: type,
                position: {
                    x: now[0],
                    y: now[1]
                }
            };
        };
        // record starting points for pinch-to-zoom
        if (e.touches[1]) {
            r.touchData.singleTouchMoved = true;
            freeDraggedElements(r.dragData.touchDragEles);
            var offsets = r.findContainerClientCoords();
            offsetLeft = offsets[0];
            offsetTop = offsets[1];
            containerWidth = offsets[2];
            containerHeight = offsets[3];
            f1x1 = e.touches[0].clientX - offsetLeft;
            f1y1 = e.touches[0].clientY - offsetTop;
            f2x1 = e.touches[1].clientX - offsetLeft;
            f2y1 = e.touches[1].clientY - offsetTop;
            twoFingersStartInside = 0 <= f1x1 && f1x1 <= containerWidth && 0 <= f2x1 && f2x1 <= containerWidth && 0 <= f1y1 && f1y1 <= containerHeight && 0 <= f2y1 && f2y1 <= containerHeight;
            var pan = cy.pan();
            var zoom = cy.zoom();
            distance1 = distance(f1x1, f1y1, f2x1, f2y1);
            distance1Sq = distanceSq(f1x1, f1y1, f2x1, f2y1);
            center1 = [
                (f1x1 + f2x1) / 2,
                (f1y1 + f2y1) / 2
            ];
            modelCenter1 = [
                (center1[0] - pan.x) / zoom,
                (center1[1] - pan.y) / zoom
            ];
            // consider context tap
            var cxtDistThreshold = 200;
            var cxtDistThresholdSq = cxtDistThreshold * cxtDistThreshold;
            if (distance1Sq < cxtDistThresholdSq && !e.touches[2]) {
                var near1 = r.findNearestElement(now[0], now[1], true, true);
                var near2 = r.findNearestElement(now[2], now[3], true, true);
                if (near1 && near1.isNode()) {
                    near1.activate().emit(makeEvent('cxttapstart'));
                    r.touchData.start = near1;
                } else if (near2 && near2.isNode()) {
                    near2.activate().emit(makeEvent('cxttapstart'));
                    r.touchData.start = near2;
                } else cy.emit(makeEvent('cxttapstart'));
                if (r.touchData.start) r.touchData.start._private.grabbed = false;
                r.touchData.cxt = true;
                r.touchData.cxtDragged = false;
                r.data.bgActivePosistion = undefined;
                r.redraw();
                return;
            }
        }
        if (e.touches[2]) // ignore
        // safari on ios pans the page otherwise (normally you should be able to preventdefault on touchmove...)
        {
            if (cy.boxSelectionEnabled()) e.preventDefault();
        } else if (e.touches[1]) ;
        else if (e.touches[0]) {
            var nears = r.findNearestElements(now[0], now[1], true, true);
            var near = nears[0];
            if (near != null) {
                near.activate();
                r.touchData.start = near;
                r.touchData.starts = nears;
                if (r.nodeIsGrabbable(near)) {
                    var draggedEles = r.dragData.touchDragEles = cy.collection();
                    var selectedNodes = null;
                    r.redrawHint('eles', true);
                    r.redrawHint('drag', true);
                    if (near.selected()) {
                        // reset drag elements, since near will be added again
                        selectedNodes = cy.$(function(ele) {
                            return ele.selected() && r.nodeIsGrabbable(ele);
                        });
                        addNodesToDrag(selectedNodes, {
                            addToList: draggedEles
                        });
                    } else addNodeToDrag(near, {
                        addToList: draggedEles
                    });
                    setGrabTarget(near);
                    near.emit(makeEvent('grabon'));
                    if (selectedNodes) selectedNodes.forEach(function(n) {
                        n.emit(makeEvent('grab'));
                    });
                    else near.emit(makeEvent('grab'));
                }
            }
            triggerEvents(near, [
                'touchstart',
                'tapstart',
                'vmousedown'
            ], e, {
                x: now[0],
                y: now[1]
            });
            if (near == null) {
                r.data.bgActivePosistion = {
                    x: pos[0],
                    y: pos[1]
                };
                r.redrawHint('select', true);
                r.redraw();
            }
            // Tap, taphold
            // -----
            r.touchData.singleTouchMoved = false;
            r.touchData.singleTouchStartTime = +new Date();
            clearTimeout(r.touchData.tapholdTimeout);
            r.touchData.tapholdTimeout = setTimeout(function() {
                if (r.touchData.singleTouchMoved === false && !r.pinching // if pinching, then taphold unselect shouldn't take effect
                 && !r.touchData.selecting // box selection shouldn't allow taphold through
                ) triggerEvents(r.touchData.start, [
                    'taphold'
                ], e, {
                    x: now[0],
                    y: now[1]
                });
            }, r.tapholdDuration);
        }
        if (e.touches.length >= 1) {
            var sPos = r.touchData.startPosition = [
                null,
                null,
                null,
                null,
                null,
                null
            ];
            for(var i = 0; i < now.length; i++)sPos[i] = earlier[i] = now[i];
            var touch0 = e.touches[0];
            r.touchData.startGPosition = [
                touch0.clientX,
                touch0.clientY
            ];
        }
    }, false);
    var touchmoveHandler;
    r.registerBinding(containerWindow, 'touchmove', touchmoveHandler = function touchmoveHandler(e) {
        // eslint-disable-line no-undef
        var capture = r.touchData.capture;
        if (!capture && !eventInContainer(e)) return;
        var select = r.selection;
        var cy = r.cy;
        var now = r.touchData.now;
        var earlier = r.touchData.earlier;
        var zoom = cy.zoom();
        if (e.touches[0]) {
            var pos = r.projectIntoViewport(e.touches[0].clientX, e.touches[0].clientY);
            now[0] = pos[0];
            now[1] = pos[1];
        }
        if (e.touches[1]) {
            var pos = r.projectIntoViewport(e.touches[1].clientX, e.touches[1].clientY);
            now[2] = pos[0];
            now[3] = pos[1];
        }
        if (e.touches[2]) {
            var pos = r.projectIntoViewport(e.touches[2].clientX, e.touches[2].clientY);
            now[4] = pos[0];
            now[5] = pos[1];
        }
        var makeEvent = function makeEvent(type) {
            return {
                originalEvent: e,
                type: type,
                position: {
                    x: now[0],
                    y: now[1]
                }
            };
        };
        var startGPos = r.touchData.startGPosition;
        var isOverThresholdDrag;
        if (capture && e.touches[0] && startGPos) {
            var disp = [];
            for(var j = 0; j < now.length; j++)disp[j] = now[j] - earlier[j];
            var dx = e.touches[0].clientX - startGPos[0];
            var dx2 = dx * dx;
            var dy = e.touches[0].clientY - startGPos[1];
            var dy2 = dy * dy;
            var dist2 = dx2 + dy2;
            isOverThresholdDrag = dist2 >= r.touchTapThreshold2;
        }
        // context swipe cancelling
        if (capture && r.touchData.cxt) {
            e.preventDefault();
            var f1x2 = e.touches[0].clientX - offsetLeft, f1y2 = e.touches[0].clientY - offsetTop;
            var f2x2 = e.touches[1].clientX - offsetLeft, f2y2 = e.touches[1].clientY - offsetTop;
            // var distance2 = distance( f1x2, f1y2, f2x2, f2y2 );
            var distance2Sq = distanceSq(f1x2, f1y2, f2x2, f2y2);
            var factorSq = distance2Sq / distance1Sq;
            var distThreshold = 150;
            var distThresholdSq = distThreshold * distThreshold;
            var factorThreshold = 1.5;
            var factorThresholdSq = factorThreshold * factorThreshold;
            // cancel ctx gestures if the distance b/t the fingers increases
            if (factorSq >= factorThresholdSq || distance2Sq >= distThresholdSq) {
                r.touchData.cxt = false;
                r.data.bgActivePosistion = undefined;
                r.redrawHint('select', true);
                var cxtEvt = makeEvent('cxttapend');
                if (r.touchData.start) {
                    r.touchData.start.unactivate().emit(cxtEvt);
                    r.touchData.start = null;
                } else cy.emit(cxtEvt);
            }
        }
        // context swipe
        if (capture && r.touchData.cxt) {
            var cxtEvt = makeEvent('cxtdrag');
            r.data.bgActivePosistion = undefined;
            r.redrawHint('select', true);
            if (r.touchData.start) r.touchData.start.emit(cxtEvt);
            else cy.emit(cxtEvt);
            if (r.touchData.start) r.touchData.start._private.grabbed = false;
            r.touchData.cxtDragged = true;
            var near = r.findNearestElement(now[0], now[1], true, true);
            if (!r.touchData.cxtOver || near !== r.touchData.cxtOver) {
                if (r.touchData.cxtOver) r.touchData.cxtOver.emit(makeEvent('cxtdragout'));
                r.touchData.cxtOver = near;
                if (near) near.emit(makeEvent('cxtdragover'));
            }
        // box selection
        } else if (capture && e.touches[2] && cy.boxSelectionEnabled()) {
            e.preventDefault();
            r.data.bgActivePosistion = undefined;
            this.lastThreeTouch = +new Date();
            if (!r.touchData.selecting) cy.emit(makeEvent('boxstart'));
            r.touchData.selecting = true;
            r.touchData.didSelect = true;
            select[4] = 1;
            if (!select || select.length === 0 || select[0] === undefined) {
                select[0] = (now[0] + now[2] + now[4]) / 3;
                select[1] = (now[1] + now[3] + now[5]) / 3;
                select[2] = (now[0] + now[2] + now[4]) / 3 + 1;
                select[3] = (now[1] + now[3] + now[5]) / 3 + 1;
            } else {
                select[2] = (now[0] + now[2] + now[4]) / 3;
                select[3] = (now[1] + now[3] + now[5]) / 3;
            }
            r.redrawHint('select', true);
            r.redraw();
        // pinch to zoom
        } else if (capture && e.touches[1] && !r.touchData.didSelect // don't allow box selection to degrade to pinch-to-zoom
         && cy.zoomingEnabled() && cy.panningEnabled() && cy.userZoomingEnabled() && cy.userPanningEnabled()) {
            // two fingers => pinch to zoom
            e.preventDefault();
            r.data.bgActivePosistion = undefined;
            r.redrawHint('select', true);
            var draggedEles = r.dragData.touchDragEles;
            if (draggedEles) {
                r.redrawHint('drag', true);
                for(var i = 0; i < draggedEles.length; i++){
                    var de_p = draggedEles[i]._private;
                    de_p.grabbed = false;
                    de_p.rscratch.inDragLayer = false;
                }
            }
            var _start = r.touchData.start;
            // (x2, y2) for fingers 1 and 2
            var f1x2 = e.touches[0].clientX - offsetLeft, f1y2 = e.touches[0].clientY - offsetTop;
            var f2x2 = e.touches[1].clientX - offsetLeft, f2y2 = e.touches[1].clientY - offsetTop;
            var distance2 = distance(f1x2, f1y2, f2x2, f2y2);
            // var distance2Sq = distanceSq( f1x2, f1y2, f2x2, f2y2 );
            // var factor = Math.sqrt( distance2Sq ) / Math.sqrt( distance1Sq );
            var factor = distance2 / distance1;
            if (twoFingersStartInside) {
                // delta finger1
                var df1x = f1x2 - f1x1;
                var df1y = f1y2 - f1y1;
                // delta finger 2
                var df2x = f2x2 - f2x1;
                var df2y = f2y2 - f2y1;
                // translation is the normalised vector of the two fingers movement
                // i.e. so pinching cancels out and moving together pans
                var tx = (df1x + df2x) / 2;
                var ty = (df1y + df2y) / 2;
                // now calculate the zoom
                var zoom1 = cy.zoom();
                var zoom2 = zoom1 * factor;
                var pan1 = cy.pan();
                // the model center point converted to the current rendered pos
                var ctrx = modelCenter1[0] * zoom1 + pan1.x;
                var ctry = modelCenter1[1] * zoom1 + pan1.y;
                var pan2 = {
                    x: -zoom2 / zoom1 * (ctrx - pan1.x - tx) + ctrx,
                    y: -zoom2 / zoom1 * (ctry - pan1.y - ty) + ctry
                };
                // remove dragged eles
                if (_start && _start.active()) {
                    var draggedEles = r.dragData.touchDragEles;
                    freeDraggedElements(draggedEles);
                    r.redrawHint('drag', true);
                    r.redrawHint('eles', true);
                    _start.unactivate().emit(makeEvent('freeon'));
                    draggedEles.emit(makeEvent('free'));
                    if (r.dragData.didDrag) {
                        _start.emit(makeEvent('dragfreeon'));
                        draggedEles.emit(makeEvent('dragfree'));
                    }
                }
                cy.viewport({
                    zoom: zoom2,
                    pan: pan2,
                    cancelOnFailedZoom: true
                });
                cy.emit(makeEvent('pinchzoom'));
                distance1 = distance2;
                f1x1 = f1x2;
                f1y1 = f1y2;
                f2x1 = f2x2;
                f2y1 = f2y2;
                r.pinching = true;
            }
            // Re-project
            if (e.touches[0]) {
                var pos = r.projectIntoViewport(e.touches[0].clientX, e.touches[0].clientY);
                now[0] = pos[0];
                now[1] = pos[1];
            }
            if (e.touches[1]) {
                var pos = r.projectIntoViewport(e.touches[1].clientX, e.touches[1].clientY);
                now[2] = pos[0];
                now[3] = pos[1];
            }
            if (e.touches[2]) {
                var pos = r.projectIntoViewport(e.touches[2].clientX, e.touches[2].clientY);
                now[4] = pos[0];
                now[5] = pos[1];
            }
        } else if (e.touches[0] && !r.touchData.didSelect // don't allow box selection to degrade to single finger events like panning
        ) {
            var start = r.touchData.start;
            var last = r.touchData.last;
            var near;
            if (!r.hoverData.draggingEles && !r.swipePanning) near = r.findNearestElement(now[0], now[1], true, true);
            if (capture && start != null) e.preventDefault();
            // dragging nodes
            if (capture && start != null && r.nodeIsDraggable(start)) {
                if (isOverThresholdDrag) {
                    // then dragging can happen
                    var draggedEles = r.dragData.touchDragEles;
                    var justStartedDrag = !r.dragData.didDrag;
                    if (justStartedDrag) addNodesToDrag(draggedEles, {
                        inDragLayer: true
                    });
                    r.dragData.didDrag = true;
                    var totalShift = {
                        x: 0,
                        y: 0
                    };
                    if ($e815fda779bc047b$var$number$1(disp[0]) && $e815fda779bc047b$var$number$1(disp[1])) {
                        totalShift.x += disp[0];
                        totalShift.y += disp[1];
                        if (justStartedDrag) {
                            r.redrawHint('eles', true);
                            var dragDelta = r.touchData.dragDelta;
                            if (dragDelta && $e815fda779bc047b$var$number$1(dragDelta[0]) && $e815fda779bc047b$var$number$1(dragDelta[1])) {
                                totalShift.x += dragDelta[0];
                                totalShift.y += dragDelta[1];
                            }
                        }
                    }
                    r.hoverData.draggingEles = true;
                    draggedEles.silentShift(totalShift).emit(makeEvent('position')).emit(makeEvent('drag'));
                    r.redrawHint('drag', true);
                    if (r.touchData.startPosition[0] == earlier[0] && r.touchData.startPosition[1] == earlier[1]) r.redrawHint('eles', true);
                    r.redraw();
                } else {
                    // otherwise keep track of drag delta for later
                    var dragDelta = r.touchData.dragDelta = r.touchData.dragDelta || [];
                    if (dragDelta.length === 0) {
                        dragDelta.push(disp[0]);
                        dragDelta.push(disp[1]);
                    } else {
                        dragDelta[0] += disp[0];
                        dragDelta[1] += disp[1];
                    }
                }
            }
            triggerEvents(start || near, [
                'touchmove',
                'tapdrag',
                'vmousemove'
            ], e, {
                x: now[0],
                y: now[1]
            });
            if ((!start || !start.grabbed()) && near != last) {
                if (last) last.emit(makeEvent('tapdragout'));
                if (near) near.emit(makeEvent('tapdragover'));
            }
            r.touchData.last = near;
            // check to cancel taphold
            if (capture) {
                for(var i = 0; i < now.length; i++)if (now[i] && r.touchData.startPosition[i] && isOverThresholdDrag) r.touchData.singleTouchMoved = true;
            }
            // panning
            if (capture && (start == null || start.pannable()) && cy.panningEnabled() && cy.userPanningEnabled()) {
                var allowPassthrough = allowPanningPassthrough(start, r.touchData.starts);
                if (allowPassthrough) {
                    e.preventDefault();
                    if (!r.data.bgActivePosistion) r.data.bgActivePosistion = $e815fda779bc047b$var$array2point(r.touchData.startPosition);
                    if (r.swipePanning) {
                        cy.panBy({
                            x: disp[0] * zoom,
                            y: disp[1] * zoom
                        });
                        cy.emit(makeEvent('dragpan'));
                    } else if (isOverThresholdDrag) {
                        r.swipePanning = true;
                        cy.panBy({
                            x: dx * zoom,
                            y: dy * zoom
                        });
                        cy.emit(makeEvent('dragpan'));
                        if (start) {
                            start.unactivate();
                            r.redrawHint('select', true);
                            r.touchData.start = null;
                        }
                    }
                }
                // Re-project
                var pos = r.projectIntoViewport(e.touches[0].clientX, e.touches[0].clientY);
                now[0] = pos[0];
                now[1] = pos[1];
            }
        }
        for(var j = 0; j < now.length; j++)earlier[j] = now[j];
        // the active bg indicator should be removed when making a swipe that is neither for dragging nodes or panning
        if (capture && e.touches.length > 0 && !r.hoverData.draggingEles && !r.swipePanning && r.data.bgActivePosistion != null) {
            r.data.bgActivePosistion = undefined;
            r.redrawHint('select', true);
            r.redraw();
        }
    }, false);
    var touchcancelHandler;
    r.registerBinding(containerWindow, 'touchcancel', touchcancelHandler = function touchcancelHandler(e) {
        // eslint-disable-line no-unused-vars
        var start = r.touchData.start;
        r.touchData.capture = false;
        if (start) start.unactivate();
    });
    var touchendHandler, didDoubleTouch, touchTimeout, prevTouchTimeStamp;
    r.registerBinding(containerWindow, 'touchend', touchendHandler = function touchendHandler(e) {
        // eslint-disable-line no-unused-vars
        var start = r.touchData.start;
        var capture = r.touchData.capture;
        if (capture) {
            if (e.touches.length === 0) r.touchData.capture = false;
            e.preventDefault();
        } else return;
        var select = r.selection;
        r.swipePanning = false;
        r.hoverData.draggingEles = false;
        var cy = r.cy;
        var zoom = cy.zoom();
        var now = r.touchData.now;
        var earlier = r.touchData.earlier;
        if (e.touches[0]) {
            var pos = r.projectIntoViewport(e.touches[0].clientX, e.touches[0].clientY);
            now[0] = pos[0];
            now[1] = pos[1];
        }
        if (e.touches[1]) {
            var pos = r.projectIntoViewport(e.touches[1].clientX, e.touches[1].clientY);
            now[2] = pos[0];
            now[3] = pos[1];
        }
        if (e.touches[2]) {
            var pos = r.projectIntoViewport(e.touches[2].clientX, e.touches[2].clientY);
            now[4] = pos[0];
            now[5] = pos[1];
        }
        var makeEvent = function makeEvent(type) {
            return {
                originalEvent: e,
                type: type,
                position: {
                    x: now[0],
                    y: now[1]
                }
            };
        };
        if (start) start.unactivate();
        var ctxTapend;
        if (r.touchData.cxt) {
            ctxTapend = makeEvent('cxttapend');
            if (start) start.emit(ctxTapend);
            else cy.emit(ctxTapend);
            if (!r.touchData.cxtDragged) {
                var ctxTap = makeEvent('cxttap');
                if (start) start.emit(ctxTap);
                else cy.emit(ctxTap);
            }
            if (r.touchData.start) r.touchData.start._private.grabbed = false;
            r.touchData.cxt = false;
            r.touchData.start = null;
            r.redraw();
            return;
        }
        // no more box selection if we don't have three fingers
        if (!e.touches[2] && cy.boxSelectionEnabled() && r.touchData.selecting) {
            r.touchData.selecting = false;
            var box = cy.collection(r.getAllInBox(select[0], select[1], select[2], select[3]));
            select[0] = undefined;
            select[1] = undefined;
            select[2] = undefined;
            select[3] = undefined;
            select[4] = 0;
            r.redrawHint('select', true);
            cy.emit(makeEvent('boxend'));
            var eleWouldBeSelected = function eleWouldBeSelected(ele) {
                return ele.selectable() && !ele.selected();
            };
            box.emit(makeEvent('box')).stdFilter(eleWouldBeSelected).select().emit(makeEvent('boxselect'));
            if (box.nonempty()) r.redrawHint('eles', true);
            r.redraw();
        }
        if (start != null) start.unactivate();
        if (e.touches[2]) {
            r.data.bgActivePosistion = undefined;
            r.redrawHint('select', true);
        } else if (e.touches[1]) ;
        else if (e.touches[0]) ;
        else if (!e.touches[0]) {
            r.data.bgActivePosistion = undefined;
            r.redrawHint('select', true);
            var draggedEles = r.dragData.touchDragEles;
            if (start != null) {
                var startWasGrabbed = start._private.grabbed;
                freeDraggedElements(draggedEles);
                r.redrawHint('drag', true);
                r.redrawHint('eles', true);
                if (startWasGrabbed) {
                    start.emit(makeEvent('freeon'));
                    draggedEles.emit(makeEvent('free'));
                    if (r.dragData.didDrag) {
                        start.emit(makeEvent('dragfreeon'));
                        draggedEles.emit(makeEvent('dragfree'));
                    }
                }
                triggerEvents(start, [
                    'touchend',
                    'tapend',
                    'vmouseup',
                    'tapdragout'
                ], e, {
                    x: now[0],
                    y: now[1]
                });
                start.unactivate();
                r.touchData.start = null;
            } else {
                var near = r.findNearestElement(now[0], now[1], true, true);
                triggerEvents(near, [
                    'touchend',
                    'tapend',
                    'vmouseup',
                    'tapdragout'
                ], e, {
                    x: now[0],
                    y: now[1]
                });
            }
            var dx = r.touchData.startPosition[0] - now[0];
            var dx2 = dx * dx;
            var dy = r.touchData.startPosition[1] - now[1];
            var dy2 = dy * dy;
            var dist2 = dx2 + dy2;
            var rdist2 = dist2 * zoom * zoom;
            // Tap event, roughly same as mouse click event for touch
            if (!r.touchData.singleTouchMoved) {
                if (!start) cy.$(':selected').unselect([
                    'tapunselect'
                ]);
                triggerEvents(start, [
                    'tap',
                    'vclick'
                ], e, {
                    x: now[0],
                    y: now[1]
                });
                didDoubleTouch = false;
                if (e.timeStamp - prevTouchTimeStamp <= cy.multiClickDebounceTime()) {
                    touchTimeout && clearTimeout(touchTimeout);
                    didDoubleTouch = true;
                    prevTouchTimeStamp = null;
                    triggerEvents(start, [
                        'dbltap',
                        'vdblclick'
                    ], e, {
                        x: now[0],
                        y: now[1]
                    });
                } else {
                    touchTimeout = setTimeout(function() {
                        if (didDoubleTouch) return;
                        triggerEvents(start, [
                            'onetap',
                            'voneclick'
                        ], e, {
                            x: now[0],
                            y: now[1]
                        });
                    }, cy.multiClickDebounceTime());
                    prevTouchTimeStamp = e.timeStamp;
                }
            }
            // Prepare to select the currently touched node, only if it hasn't been dragged past a certain distance
            if (start != null && !r.dragData.didDrag // didn't drag nodes around
             && start._private.selectable && rdist2 < r.touchTapThreshold2 && !r.pinching // pinch to zoom should not affect selection
            ) {
                if (cy.selectionType() === 'single') {
                    cy.$(isSelected).unmerge(start).unselect([
                        'tapunselect'
                    ]);
                    start.select([
                        'tapselect'
                    ]);
                } else if (start.selected()) start.unselect([
                    'tapunselect'
                ]);
                else start.select([
                    'tapselect'
                ]);
                r.redrawHint('eles', true);
            }
            r.touchData.singleTouchMoved = true;
        }
        for(var j = 0; j < now.length; j++)earlier[j] = now[j];
        r.dragData.didDrag = false; // reset for next touchstart
        if (e.touches.length === 0) {
            r.touchData.dragDelta = [];
            r.touchData.startPosition = [
                null,
                null,
                null,
                null,
                null,
                null
            ];
            r.touchData.startGPosition = null;
            r.touchData.didSelect = false;
        }
        if (e.touches.length < 2) {
            if (e.touches.length === 1) // the old start global pos'n may not be the same finger that remains
            r.touchData.startGPosition = [
                e.touches[0].clientX,
                e.touches[0].clientY
            ];
            r.pinching = false;
            r.redrawHint('eles', true);
            r.redraw();
        }
    //r.redraw();
    }, false);
    // fallback compatibility layer for ms pointer events
    if (typeof TouchEvent === 'undefined') {
        var pointers = [];
        var makeTouch = function makeTouch(e) {
            return {
                clientX: e.clientX,
                clientY: e.clientY,
                force: 1,
                identifier: e.pointerId,
                pageX: e.pageX,
                pageY: e.pageY,
                radiusX: e.width / 2,
                radiusY: e.height / 2,
                screenX: e.screenX,
                screenY: e.screenY,
                target: e.target
            };
        };
        var makePointer = function makePointer(e) {
            return {
                event: e,
                touch: makeTouch(e)
            };
        };
        var addPointer = function addPointer(e) {
            pointers.push(makePointer(e));
        };
        var removePointer = function removePointer(e) {
            for(var i = 0; i < pointers.length; i++){
                var p = pointers[i];
                if (p.event.pointerId === e.pointerId) {
                    pointers.splice(i, 1);
                    return;
                }
            }
        };
        var updatePointer = function updatePointer(e) {
            var p = pointers.filter(function(p) {
                return p.event.pointerId === e.pointerId;
            })[0];
            p.event = e;
            p.touch = makeTouch(e);
        };
        var addTouchesToEvent = function addTouchesToEvent(e) {
            e.touches = pointers.map(function(p) {
                return p.touch;
            });
        };
        var pointerIsMouse = function pointerIsMouse(e) {
            return e.pointerType === 'mouse' || e.pointerType === 4;
        };
        r.registerBinding(r.container, 'pointerdown', function(e) {
            if (pointerIsMouse(e)) return;
             // mouse already handled
            e.preventDefault();
            addPointer(e);
            addTouchesToEvent(e);
            touchstartHandler(e);
        });
        r.registerBinding(r.container, 'pointerup', function(e) {
            if (pointerIsMouse(e)) return;
             // mouse already handled
            removePointer(e);
            addTouchesToEvent(e);
            touchendHandler(e);
        });
        r.registerBinding(r.container, 'pointercancel', function(e) {
            if (pointerIsMouse(e)) return;
             // mouse already handled
            removePointer(e);
            addTouchesToEvent(e);
            touchcancelHandler(e);
        });
        r.registerBinding(r.container, 'pointermove', function(e) {
            if (pointerIsMouse(e)) return;
             // mouse already handled
            e.preventDefault();
            updatePointer(e);
            addTouchesToEvent(e);
            touchmoveHandler(e);
        });
    }
};
var $e815fda779bc047b$var$BRp$2 = {};
$e815fda779bc047b$var$BRp$2.generatePolygon = function(name, points) {
    return this.nodeShapes[name] = {
        renderer: this,
        name: name,
        points: points,
        draw: function draw(context, centerX, centerY, width, height, cornerRadius) {
            this.renderer.nodeShapeImpl('polygon', context, centerX, centerY, width, height, this.points);
        },
        intersectLine: function intersectLine(nodeX, nodeY, width, height, x, y, padding, cornerRadius) {
            return $e815fda779bc047b$var$polygonIntersectLine(x, y, this.points, nodeX, nodeY, width / 2, height / 2, padding);
        },
        checkPoint: function checkPoint(x, y, padding, width, height, centerX, centerY, cornerRadius) {
            return $e815fda779bc047b$var$pointInsidePolygon(x, y, this.points, centerX, centerY, width, height, [
                0,
                -1
            ], padding);
        },
        hasMiterBounds: name !== 'rectangle',
        miterBounds: function miterBounds(centerX, centerY, width, height, strokeWidth, strokePosition) {
            return $e815fda779bc047b$var$miterBox(this.points, centerX, centerY, width, height, strokeWidth);
        }
    };
};
$e815fda779bc047b$var$BRp$2.generateEllipse = function() {
    return this.nodeShapes['ellipse'] = {
        renderer: this,
        name: 'ellipse',
        draw: function draw(context, centerX, centerY, width, height, cornerRadius) {
            this.renderer.nodeShapeImpl(this.name, context, centerX, centerY, width, height);
        },
        intersectLine: function intersectLine(nodeX, nodeY, width, height, x, y, padding, cornerRadius) {
            return $e815fda779bc047b$var$intersectLineEllipse(x, y, nodeX, nodeY, width / 2 + padding, height / 2 + padding);
        },
        checkPoint: function checkPoint(x, y, padding, width, height, centerX, centerY, cornerRadius) {
            return $e815fda779bc047b$var$checkInEllipse(x, y, width, height, centerX, centerY, padding);
        }
    };
};
$e815fda779bc047b$var$BRp$2.generateRoundPolygon = function(name, points) {
    return this.nodeShapes[name] = {
        renderer: this,
        name: name,
        points: points,
        getOrCreateCorners: function getOrCreateCorners(centerX, centerY, width, height, cornerRadius, rs, field) {
            if (rs[field] !== undefined && rs[field + '-cx'] === centerX && rs[field + '-cy'] === centerY) return rs[field];
            rs[field] = new Array(points.length / 2);
            rs[field + '-cx'] = centerX;
            rs[field + '-cy'] = centerY;
            var halfW = width / 2;
            var halfH = height / 2;
            cornerRadius = cornerRadius === 'auto' ? $e815fda779bc047b$var$getRoundPolygonRadius(width, height) : cornerRadius;
            var p = new Array(points.length / 2);
            for(var _i = 0; _i < points.length / 2; _i++)p[_i] = {
                x: centerX + halfW * points[_i * 2],
                y: centerY + halfH * points[_i * 2 + 1]
            };
            var i, p1, p2, p3, len = p.length;
            p1 = p[len - 1];
            // for each point
            for(i = 0; i < len; i++){
                p2 = p[i % len];
                p3 = p[(i + 1) % len];
                rs[field][i] = $e815fda779bc047b$var$getRoundCorner(p1, p2, p3, cornerRadius);
                p1 = p2;
                p2 = p3;
            }
            return rs[field];
        },
        draw: function draw(context, centerX, centerY, width, height, cornerRadius, rs) {
            this.renderer.nodeShapeImpl('round-polygon', context, centerX, centerY, width, height, this.points, this.getOrCreateCorners(centerX, centerY, width, height, cornerRadius, rs, 'drawCorners'));
        },
        intersectLine: function intersectLine(nodeX, nodeY, width, height, x, y, padding, cornerRadius, rs) {
            return $e815fda779bc047b$var$roundPolygonIntersectLine(x, y, this.points, nodeX, nodeY, width, height, padding, this.getOrCreateCorners(nodeX, nodeY, width, height, cornerRadius, rs, 'corners'));
        },
        checkPoint: function checkPoint(x, y, padding, width, height, centerX, centerY, cornerRadius, rs) {
            return $e815fda779bc047b$var$pointInsideRoundPolygon(x, y, this.points, centerX, centerY, width, height, this.getOrCreateCorners(centerX, centerY, width, height, cornerRadius, rs, 'corners'));
        }
    };
};
$e815fda779bc047b$var$BRp$2.generateRoundRectangle = function() {
    return this.nodeShapes['round-rectangle'] = this.nodeShapes['roundrectangle'] = {
        renderer: this,
        name: 'round-rectangle',
        points: $e815fda779bc047b$var$generateUnitNgonPointsFitToSquare(4, 0),
        draw: function draw(context, centerX, centerY, width, height, cornerRadius) {
            this.renderer.nodeShapeImpl(this.name, context, centerX, centerY, width, height, this.points, cornerRadius);
        },
        intersectLine: function intersectLine(nodeX, nodeY, width, height, x, y, padding, cornerRadius) {
            return $e815fda779bc047b$var$roundRectangleIntersectLine(x, y, nodeX, nodeY, width, height, padding, cornerRadius);
        },
        checkPoint: function checkPoint(x, y, padding, width, height, centerX, centerY, cornerRadius) {
            var halfWidth = width / 2;
            var halfHeight = height / 2;
            cornerRadius = cornerRadius === 'auto' ? $e815fda779bc047b$var$getRoundRectangleRadius(width, height) : cornerRadius;
            cornerRadius = Math.min(halfWidth, halfHeight, cornerRadius);
            var diam = cornerRadius * 2;
            // Check hBox
            if ($e815fda779bc047b$var$pointInsidePolygon(x, y, this.points, centerX, centerY, width, height - diam, [
                0,
                -1
            ], padding)) return true;
            // Check vBox
            if ($e815fda779bc047b$var$pointInsidePolygon(x, y, this.points, centerX, centerY, width - diam, height, [
                0,
                -1
            ], padding)) return true;
            // Check top left quarter circle
            if ($e815fda779bc047b$var$checkInEllipse(x, y, diam, diam, centerX - halfWidth + cornerRadius, centerY - halfHeight + cornerRadius, padding)) return true;
            // Check top right quarter circle
            if ($e815fda779bc047b$var$checkInEllipse(x, y, diam, diam, centerX + halfWidth - cornerRadius, centerY - halfHeight + cornerRadius, padding)) return true;
            // Check bottom right quarter circle
            if ($e815fda779bc047b$var$checkInEllipse(x, y, diam, diam, centerX + halfWidth - cornerRadius, centerY + halfHeight - cornerRadius, padding)) return true;
            // Check bottom left quarter circle
            if ($e815fda779bc047b$var$checkInEllipse(x, y, diam, diam, centerX - halfWidth + cornerRadius, centerY + halfHeight - cornerRadius, padding)) return true;
            return false;
        }
    };
};
$e815fda779bc047b$var$BRp$2.generateCutRectangle = function() {
    return this.nodeShapes['cut-rectangle'] = this.nodeShapes['cutrectangle'] = {
        renderer: this,
        name: 'cut-rectangle',
        cornerLength: $e815fda779bc047b$var$getCutRectangleCornerLength(),
        points: $e815fda779bc047b$var$generateUnitNgonPointsFitToSquare(4, 0),
        draw: function draw(context, centerX, centerY, width, height, cornerRadius) {
            this.renderer.nodeShapeImpl(this.name, context, centerX, centerY, width, height, null, cornerRadius);
        },
        generateCutTrianglePts: function generateCutTrianglePts(width, height, centerX, centerY, cornerRadius) {
            var cl = cornerRadius === 'auto' ? this.cornerLength : cornerRadius;
            var hh = height / 2;
            var hw = width / 2;
            var xBegin = centerX - hw;
            var xEnd = centerX + hw;
            var yBegin = centerY - hh;
            var yEnd = centerY + hh;
            // points are in clockwise order, inner (imaginary) triangle pt on [4, 5]
            return {
                topLeft: [
                    xBegin,
                    yBegin + cl,
                    xBegin + cl,
                    yBegin,
                    xBegin + cl,
                    yBegin + cl
                ],
                topRight: [
                    xEnd - cl,
                    yBegin,
                    xEnd,
                    yBegin + cl,
                    xEnd - cl,
                    yBegin + cl
                ],
                bottomRight: [
                    xEnd,
                    yEnd - cl,
                    xEnd - cl,
                    yEnd,
                    xEnd - cl,
                    yEnd - cl
                ],
                bottomLeft: [
                    xBegin + cl,
                    yEnd,
                    xBegin,
                    yEnd - cl,
                    xBegin + cl,
                    yEnd - cl
                ]
            };
        },
        intersectLine: function intersectLine(nodeX, nodeY, width, height, x, y, padding, cornerRadius) {
            var cPts = this.generateCutTrianglePts(width + 2 * padding, height + 2 * padding, nodeX, nodeY, cornerRadius);
            var pts = [].concat.apply([], [
                cPts.topLeft.splice(0, 4),
                cPts.topRight.splice(0, 4),
                cPts.bottomRight.splice(0, 4),
                cPts.bottomLeft.splice(0, 4)
            ]);
            return $e815fda779bc047b$var$polygonIntersectLine(x, y, pts, nodeX, nodeY);
        },
        checkPoint: function checkPoint(x, y, padding, width, height, centerX, centerY, cornerRadius) {
            var cl = cornerRadius === 'auto' ? this.cornerLength : cornerRadius;
            // Check hBox
            if ($e815fda779bc047b$var$pointInsidePolygon(x, y, this.points, centerX, centerY, width, height - 2 * cl, [
                0,
                -1
            ], padding)) return true;
            // Check vBox
            if ($e815fda779bc047b$var$pointInsidePolygon(x, y, this.points, centerX, centerY, width - 2 * cl, height, [
                0,
                -1
            ], padding)) return true;
            var cutTrianglePts = this.generateCutTrianglePts(width, height, centerX, centerY);
            return $e815fda779bc047b$var$pointInsidePolygonPoints(x, y, cutTrianglePts.topLeft) || $e815fda779bc047b$var$pointInsidePolygonPoints(x, y, cutTrianglePts.topRight) || $e815fda779bc047b$var$pointInsidePolygonPoints(x, y, cutTrianglePts.bottomRight) || $e815fda779bc047b$var$pointInsidePolygonPoints(x, y, cutTrianglePts.bottomLeft);
        }
    };
};
$e815fda779bc047b$var$BRp$2.generateBarrel = function() {
    return this.nodeShapes['barrel'] = {
        renderer: this,
        name: 'barrel',
        points: $e815fda779bc047b$var$generateUnitNgonPointsFitToSquare(4, 0),
        draw: function draw(context, centerX, centerY, width, height, cornerRadius) {
            this.renderer.nodeShapeImpl(this.name, context, centerX, centerY, width, height);
        },
        intersectLine: function intersectLine(nodeX, nodeY, width, height, x, y, padding, cornerRadius) {
            // use two fixed t values for the bezier curve approximation
            var t0 = 0.15;
            var t1 = 0.5;
            var t2 = 0.85;
            var bPts = this.generateBarrelBezierPts(width + 2 * padding, height + 2 * padding, nodeX, nodeY);
            var approximateBarrelCurvePts = function approximateBarrelCurvePts(pts) {
                // approximate curve pts based on the two t values
                var m0 = $e815fda779bc047b$var$qbezierPtAt({
                    x: pts[0],
                    y: pts[1]
                }, {
                    x: pts[2],
                    y: pts[3]
                }, {
                    x: pts[4],
                    y: pts[5]
                }, t0);
                var m1 = $e815fda779bc047b$var$qbezierPtAt({
                    x: pts[0],
                    y: pts[1]
                }, {
                    x: pts[2],
                    y: pts[3]
                }, {
                    x: pts[4],
                    y: pts[5]
                }, t1);
                var m2 = $e815fda779bc047b$var$qbezierPtAt({
                    x: pts[0],
                    y: pts[1]
                }, {
                    x: pts[2],
                    y: pts[3]
                }, {
                    x: pts[4],
                    y: pts[5]
                }, t2);
                return [
                    pts[0],
                    pts[1],
                    m0.x,
                    m0.y,
                    m1.x,
                    m1.y,
                    m2.x,
                    m2.y,
                    pts[4],
                    pts[5]
                ];
            };
            var pts = [].concat(approximateBarrelCurvePts(bPts.topLeft), approximateBarrelCurvePts(bPts.topRight), approximateBarrelCurvePts(bPts.bottomRight), approximateBarrelCurvePts(bPts.bottomLeft));
            return $e815fda779bc047b$var$polygonIntersectLine(x, y, pts, nodeX, nodeY);
        },
        generateBarrelBezierPts: function generateBarrelBezierPts(width, height, centerX, centerY) {
            var hh = height / 2;
            var hw = width / 2;
            var xBegin = centerX - hw;
            var xEnd = centerX + hw;
            var yBegin = centerY - hh;
            var yEnd = centerY + hh;
            var curveConstants = $e815fda779bc047b$var$getBarrelCurveConstants(width, height);
            var hOffset = curveConstants.heightOffset;
            var wOffset = curveConstants.widthOffset;
            var ctrlPtXOffset = curveConstants.ctrlPtOffsetPct * width;
            // points are in clockwise order, inner (imaginary) control pt on [4, 5]
            var pts = {
                topLeft: [
                    xBegin,
                    yBegin + hOffset,
                    xBegin + ctrlPtXOffset,
                    yBegin,
                    xBegin + wOffset,
                    yBegin
                ],
                topRight: [
                    xEnd - wOffset,
                    yBegin,
                    xEnd - ctrlPtXOffset,
                    yBegin,
                    xEnd,
                    yBegin + hOffset
                ],
                bottomRight: [
                    xEnd,
                    yEnd - hOffset,
                    xEnd - ctrlPtXOffset,
                    yEnd,
                    xEnd - wOffset,
                    yEnd
                ],
                bottomLeft: [
                    xBegin + wOffset,
                    yEnd,
                    xBegin + ctrlPtXOffset,
                    yEnd,
                    xBegin,
                    yEnd - hOffset
                ]
            };
            pts.topLeft.isTop = true;
            pts.topRight.isTop = true;
            pts.bottomLeft.isBottom = true;
            pts.bottomRight.isBottom = true;
            return pts;
        },
        checkPoint: function checkPoint(x, y, padding, width, height, centerX, centerY, cornerRadius) {
            var curveConstants = $e815fda779bc047b$var$getBarrelCurveConstants(width, height);
            var hOffset = curveConstants.heightOffset;
            var wOffset = curveConstants.widthOffset;
            // Check hBox
            if ($e815fda779bc047b$var$pointInsidePolygon(x, y, this.points, centerX, centerY, width, height - 2 * hOffset, [
                0,
                -1
            ], padding)) return true;
            // Check vBox
            if ($e815fda779bc047b$var$pointInsidePolygon(x, y, this.points, centerX, centerY, width - 2 * wOffset, height, [
                0,
                -1
            ], padding)) return true;
            var barrelCurvePts = this.generateBarrelBezierPts(width, height, centerX, centerY);
            var getCurveT = function getCurveT(x, y, curvePts) {
                var x0 = curvePts[4];
                var x1 = curvePts[2];
                var x2 = curvePts[0];
                var y0 = curvePts[5];
                // var y1 = curvePts[ 3 ];
                var y2 = curvePts[1];
                var xMin = Math.min(x0, x2);
                var xMax = Math.max(x0, x2);
                var yMin = Math.min(y0, y2);
                var yMax = Math.max(y0, y2);
                if (xMin <= x && x <= xMax && yMin <= y && y <= yMax) {
                    var coeff = $e815fda779bc047b$var$bezierPtsToQuadCoeff(x0, x1, x2);
                    var roots = $e815fda779bc047b$var$solveQuadratic(coeff[0], coeff[1], coeff[2], x);
                    var validRoots = roots.filter(function(r) {
                        return 0 <= r && r <= 1;
                    });
                    if (validRoots.length > 0) return validRoots[0];
                }
                return null;
            };
            var curveRegions = Object.keys(barrelCurvePts);
            for(var i = 0; i < curveRegions.length; i++){
                var corner = curveRegions[i];
                var cornerPts = barrelCurvePts[corner];
                var t = getCurveT(x, y, cornerPts);
                if (t == null) continue;
                var y0 = cornerPts[5];
                var y1 = cornerPts[3];
                var y2 = cornerPts[1];
                var bezY = $e815fda779bc047b$var$qbezierAt(y0, y1, y2, t);
                if (cornerPts.isTop && bezY <= y) return true;
                if (cornerPts.isBottom && y <= bezY) return true;
            }
            return false;
        }
    };
};
$e815fda779bc047b$var$BRp$2.generateBottomRoundrectangle = function() {
    return this.nodeShapes['bottom-round-rectangle'] = this.nodeShapes['bottomroundrectangle'] = {
        renderer: this,
        name: 'bottom-round-rectangle',
        points: $e815fda779bc047b$var$generateUnitNgonPointsFitToSquare(4, 0),
        draw: function draw(context, centerX, centerY, width, height, cornerRadius) {
            this.renderer.nodeShapeImpl(this.name, context, centerX, centerY, width, height, this.points, cornerRadius);
        },
        intersectLine: function intersectLine(nodeX, nodeY, width, height, x, y, padding, cornerRadius) {
            var topStartX = nodeX - (width / 2 + padding);
            var topStartY = nodeY - (height / 2 + padding);
            var topEndY = topStartY;
            var topEndX = nodeX + (width / 2 + padding);
            var topIntersections = $e815fda779bc047b$var$finiteLinesIntersect(x, y, nodeX, nodeY, topStartX, topStartY, topEndX, topEndY, false);
            if (topIntersections.length > 0) return topIntersections;
            return $e815fda779bc047b$var$roundRectangleIntersectLine(x, y, nodeX, nodeY, width, height, padding, cornerRadius);
        },
        checkPoint: function checkPoint(x, y, padding, width, height, centerX, centerY, cornerRadius) {
            cornerRadius = cornerRadius === 'auto' ? $e815fda779bc047b$var$getRoundRectangleRadius(width, height) : cornerRadius;
            var diam = 2 * cornerRadius;
            // Check hBox
            if ($e815fda779bc047b$var$pointInsidePolygon(x, y, this.points, centerX, centerY, width, height - diam, [
                0,
                -1
            ], padding)) return true;
            // Check vBox
            if ($e815fda779bc047b$var$pointInsidePolygon(x, y, this.points, centerX, centerY, width - diam, height, [
                0,
                -1
            ], padding)) return true;
            // check non-rounded top side
            var outerWidth = width / 2 + 2 * padding;
            var outerHeight = height / 2 + 2 * padding;
            var points = [
                centerX - outerWidth,
                centerY - outerHeight,
                centerX - outerWidth,
                centerY,
                centerX + outerWidth,
                centerY,
                centerX + outerWidth,
                centerY - outerHeight
            ];
            if ($e815fda779bc047b$var$pointInsidePolygonPoints(x, y, points)) return true;
            // Check bottom right quarter circle
            if ($e815fda779bc047b$var$checkInEllipse(x, y, diam, diam, centerX + width / 2 - cornerRadius, centerY + height / 2 - cornerRadius, padding)) return true;
            // Check bottom left quarter circle
            if ($e815fda779bc047b$var$checkInEllipse(x, y, diam, diam, centerX - width / 2 + cornerRadius, centerY + height / 2 - cornerRadius, padding)) return true;
            return false;
        }
    };
};
$e815fda779bc047b$var$BRp$2.registerNodeShapes = function() {
    var nodeShapes = this.nodeShapes = {};
    var renderer = this;
    this.generateEllipse();
    this.generatePolygon('triangle', $e815fda779bc047b$var$generateUnitNgonPointsFitToSquare(3, 0));
    this.generateRoundPolygon('round-triangle', $e815fda779bc047b$var$generateUnitNgonPointsFitToSquare(3, 0));
    this.generatePolygon('rectangle', $e815fda779bc047b$var$generateUnitNgonPointsFitToSquare(4, 0));
    nodeShapes['square'] = nodeShapes['rectangle'];
    this.generateRoundRectangle();
    this.generateCutRectangle();
    this.generateBarrel();
    this.generateBottomRoundrectangle();
    var diamondPoints = [
        0,
        1,
        1,
        0,
        0,
        -1,
        -1,
        0
    ];
    this.generatePolygon('diamond', diamondPoints);
    this.generateRoundPolygon('round-diamond', diamondPoints);
    this.generatePolygon('pentagon', $e815fda779bc047b$var$generateUnitNgonPointsFitToSquare(5, 0));
    this.generateRoundPolygon('round-pentagon', $e815fda779bc047b$var$generateUnitNgonPointsFitToSquare(5, 0));
    this.generatePolygon('hexagon', $e815fda779bc047b$var$generateUnitNgonPointsFitToSquare(6, 0));
    this.generateRoundPolygon('round-hexagon', $e815fda779bc047b$var$generateUnitNgonPointsFitToSquare(6, 0));
    this.generatePolygon('heptagon', $e815fda779bc047b$var$generateUnitNgonPointsFitToSquare(7, 0));
    this.generateRoundPolygon('round-heptagon', $e815fda779bc047b$var$generateUnitNgonPointsFitToSquare(7, 0));
    this.generatePolygon('octagon', $e815fda779bc047b$var$generateUnitNgonPointsFitToSquare(8, 0));
    this.generateRoundPolygon('round-octagon', $e815fda779bc047b$var$generateUnitNgonPointsFitToSquare(8, 0));
    var star5Points = new Array(20);
    var outerPoints = $e815fda779bc047b$var$generateUnitNgonPoints(5, 0);
    var innerPoints = $e815fda779bc047b$var$generateUnitNgonPoints(5, Math.PI / 5);
    // Outer radius is 1; inner radius of star is smaller
    var innerRadius = 0.5 * (3 - Math.sqrt(5));
    innerRadius *= 1.57;
    for(var i = 0; i < innerPoints.length / 2; i++){
        innerPoints[i * 2] *= innerRadius;
        innerPoints[i * 2 + 1] *= innerRadius;
    }
    for(var i = 0; i < 5; i++){
        star5Points[i * 4] = outerPoints[i * 2];
        star5Points[i * 4 + 1] = outerPoints[i * 2 + 1];
        star5Points[i * 4 + 2] = innerPoints[i * 2];
        star5Points[i * 4 + 3] = innerPoints[i * 2 + 1];
    }
    star5Points = $e815fda779bc047b$var$fitPolygonToSquare(star5Points);
    this.generatePolygon('star', star5Points);
    this.generatePolygon('vee', [
        -1,
        -1,
        0,
        -0.333,
        1,
        -1,
        0,
        1
    ]);
    this.generatePolygon('rhomboid', [
        -1,
        -1,
        0.333,
        -1,
        1,
        1,
        -0.333,
        1
    ]);
    this.generatePolygon('right-rhomboid', [
        -0.333,
        -1,
        1,
        -1,
        0.333,
        1,
        -1,
        1
    ]);
    this.nodeShapes['concavehexagon'] = this.generatePolygon('concave-hexagon', [
        -1,
        -0.95,
        -0.75,
        0,
        -1,
        0.95,
        1,
        0.95,
        0.75,
        0,
        1,
        -0.95
    ]);
    var tagPoints = [
        -1,
        -1,
        0.25,
        -1,
        1,
        0,
        0.25,
        1,
        -1,
        1
    ];
    this.generatePolygon('tag', tagPoints);
    this.generateRoundPolygon('round-tag', tagPoints);
    nodeShapes.makePolygon = function(points) {
        // use caching on user-specified polygons so they are as fast as native shapes
        var key = points.join('$');
        var name = 'polygon-' + key;
        var shape;
        if (shape = this[name]) // got cached shape
        return shape;
        // create and cache new shape
        return renderer.generatePolygon(name, points);
    };
};
var $e815fda779bc047b$var$BRp$1 = {};
$e815fda779bc047b$var$BRp$1.timeToRender = function() {
    return this.redrawTotalTime / this.redrawCount;
};
$e815fda779bc047b$var$BRp$1.redraw = function(options) {
    options = options || $e815fda779bc047b$var$staticEmptyObject();
    var r = this;
    if (r.averageRedrawTime === undefined) r.averageRedrawTime = 0;
    if (r.lastRedrawTime === undefined) r.lastRedrawTime = 0;
    if (r.lastDrawTime === undefined) r.lastDrawTime = 0;
    r.requestedFrame = true;
    r.renderOptions = options;
};
$e815fda779bc047b$var$BRp$1.beforeRender = function(fn, priority) {
    // the renderer can't add tick callbacks when destroyed
    if (this.destroyed) return;
    if (priority == null) $e815fda779bc047b$var$error('Priority is not optional for beforeRender');
    var cbs = this.beforeRenderCallbacks;
    cbs.push({
        fn: fn,
        priority: priority
    });
    // higher priority callbacks executed first
    cbs.sort(function(a, b) {
        return b.priority - a.priority;
    });
};
var $e815fda779bc047b$var$beforeRenderCallbacks = function beforeRenderCallbacks(r, willDraw, startTime) {
    var cbs = r.beforeRenderCallbacks;
    for(var i = 0; i < cbs.length; i++)cbs[i].fn(willDraw, startTime);
};
$e815fda779bc047b$var$BRp$1.startRenderLoop = function() {
    var r = this;
    var cy = r.cy;
    if (r.renderLoopStarted) return;
    else r.renderLoopStarted = true;
    var _renderFn = function renderFn(requestTime) {
        if (r.destroyed) return;
        if (cy.batching()) ;
        else if (r.requestedFrame && !r.skipFrame) {
            $e815fda779bc047b$var$beforeRenderCallbacks(r, true, requestTime);
            var startTime = $e815fda779bc047b$var$performanceNow();
            r.render(r.renderOptions);
            var endTime = r.lastDrawTime = $e815fda779bc047b$var$performanceNow();
            if (r.averageRedrawTime === undefined) r.averageRedrawTime = endTime - startTime;
            if (r.redrawCount === undefined) r.redrawCount = 0;
            r.redrawCount++;
            if (r.redrawTotalTime === undefined) r.redrawTotalTime = 0;
            var duration = endTime - startTime;
            r.redrawTotalTime += duration;
            r.lastRedrawTime = duration;
            // use a weighted average with a bias from the previous average so we don't spike so easily
            r.averageRedrawTime = r.averageRedrawTime / 2 + duration / 2;
            r.requestedFrame = false;
        } else $e815fda779bc047b$var$beforeRenderCallbacks(r, false, requestTime);
        r.skipFrame = false;
        $e815fda779bc047b$var$requestAnimationFrame(_renderFn);
    };
    $e815fda779bc047b$var$requestAnimationFrame(_renderFn);
};
var $e815fda779bc047b$var$BaseRenderer = function BaseRenderer(options) {
    this.init(options);
};
var $e815fda779bc047b$var$BR = $e815fda779bc047b$var$BaseRenderer;
var $e815fda779bc047b$var$BRp = $e815fda779bc047b$var$BR.prototype;
$e815fda779bc047b$var$BRp.clientFunctions = [
    'redrawHint',
    'render',
    'renderTo',
    'matchCanvasSize',
    'nodeShapeImpl',
    'arrowShapeImpl'
];
$e815fda779bc047b$var$BRp.init = function(options) {
    var r = this;
    r.options = options;
    r.cy = options.cy;
    var ctr = r.container = options.cy.container();
    var containerWindow = r.cy.window();
    // prepend a stylesheet in the head such that
    if (containerWindow) {
        var document1 = containerWindow.document;
        var head = document1.head;
        var stylesheetId = '__________cytoscape_stylesheet';
        var className = '__________cytoscape_container';
        var stylesheetAlreadyExists = document1.getElementById(stylesheetId) != null;
        if (ctr.className.indexOf(className) < 0) ctr.className = (ctr.className || '') + ' ' + className;
        if (!stylesheetAlreadyExists) {
            var stylesheet = document1.createElement('style');
            stylesheet.id = stylesheetId;
            stylesheet.textContent = '.' + className + ' { position: relative; }';
            head.insertBefore(stylesheet, head.children[0]); // first so lowest priority
        }
        var computedStyle = containerWindow.getComputedStyle(ctr);
        var position = computedStyle.getPropertyValue('position');
        if (position === 'static') $e815fda779bc047b$var$warn('A Cytoscape container has style position:static and so can not use UI extensions properly');
    }
    r.selection = [
        undefined,
        undefined,
        undefined,
        undefined,
        0
    ]; // Coordinates for selection box, plus enabled flag
    r.bezierProjPcts = [
        0.05,
        0.225,
        0.4,
        0.5,
        0.6,
        0.775,
        0.95
    ];
    //--Pointer-related data
    r.hoverData = {
        down: null,
        last: null,
        downTime: null,
        triggerMode: null,
        dragging: false,
        initialPan: [
            null,
            null
        ],
        capture: false
    };
    r.dragData = {
        possibleDragElements: []
    };
    r.touchData = {
        start: null,
        capture: false,
        // These 3 fields related to tap, taphold events
        startPosition: [
            null,
            null,
            null,
            null,
            null,
            null
        ],
        singleTouchStartTime: null,
        singleTouchMoved: true,
        now: [
            null,
            null,
            null,
            null,
            null,
            null
        ],
        earlier: [
            null,
            null,
            null,
            null,
            null,
            null
        ]
    };
    r.redraws = 0;
    r.showFps = options.showFps;
    r.debug = options.debug;
    r.webgl = options.webgl;
    r.hideEdgesOnViewport = options.hideEdgesOnViewport;
    r.textureOnViewport = options.textureOnViewport;
    r.wheelSensitivity = options.wheelSensitivity;
    r.motionBlurEnabled = options.motionBlur; // on by default
    r.forcedPixelRatio = $e815fda779bc047b$var$number$1(options.pixelRatio) ? options.pixelRatio : null;
    r.motionBlur = options.motionBlur; // for initial kick off
    r.motionBlurOpacity = options.motionBlurOpacity;
    r.motionBlurTransparency = 1 - r.motionBlurOpacity;
    r.motionBlurPxRatio = 1;
    r.mbPxRBlurry = 1; //0.8;
    r.minMbLowQualFrames = 4;
    r.fullQualityMb = false;
    r.clearedForMotionBlur = [];
    r.desktopTapThreshold = options.desktopTapThreshold;
    r.desktopTapThreshold2 = options.desktopTapThreshold * options.desktopTapThreshold;
    r.touchTapThreshold = options.touchTapThreshold;
    r.touchTapThreshold2 = options.touchTapThreshold * options.touchTapThreshold;
    r.tapholdDuration = 500;
    r.bindings = [];
    r.beforeRenderCallbacks = [];
    r.beforeRenderPriorities = {
        // higher priority execs before lower one
        animations: 400,
        eleCalcs: 300,
        eleTxrDeq: 200,
        lyrTxrDeq: 150,
        lyrTxrSkip: 100
    };
    r.registerNodeShapes();
    r.registerArrowShapes();
    r.registerCalculationListeners();
};
$e815fda779bc047b$var$BRp.notify = function(eventName, eles) {
    var r = this;
    var cy = r.cy;
    // the renderer can't be notified after it's destroyed
    if (this.destroyed) return;
    if (eventName === 'init') {
        r.load();
        return;
    }
    if (eventName === 'destroy') {
        r.destroy();
        return;
    }
    if (eventName === 'add' || eventName === 'remove' || eventName === 'move' && cy.hasCompoundNodes() || eventName === 'load' || eventName === 'zorder' || eventName === 'mount') r.invalidateCachedZSortedEles();
    if (eventName === 'viewport') r.redrawHint('select', true);
    if (eventName === 'gc') r.redrawHint('gc', true);
    if (eventName === 'load' || eventName === 'resize' || eventName === 'mount') {
        r.invalidateContainerClientCoordsCache();
        r.matchCanvasSize(r.container);
    }
    r.redrawHint('eles', true);
    r.redrawHint('drag', true);
    this.startRenderLoop();
    this.redraw();
};
$e815fda779bc047b$var$BRp.destroy = function() {
    var r = this;
    r.destroyed = true;
    r.cy.stopAnimationLoop();
    for(var i = 0; i < r.bindings.length; i++){
        var binding = r.bindings[i];
        var b = binding;
        var tgt = b.target;
        (tgt.off || tgt.removeEventListener).apply(tgt, b.args);
    }
    r.bindings = [];
    r.beforeRenderCallbacks = [];
    r.onUpdateEleCalcsFns = [];
    if (r.removeObserver) r.removeObserver.disconnect();
    if (r.styleObserver) r.styleObserver.disconnect();
    if (r.resizeObserver) r.resizeObserver.disconnect();
    if (r.labelCalcDiv) try {
        document.body.removeChild(r.labelCalcDiv); // eslint-disable-line no-undef
    } catch (e) {
    // ie10 issue #1014
    }
};
$e815fda779bc047b$var$BRp.isHeadless = function() {
    return false;
};
[
    $e815fda779bc047b$var$BRp$f,
    $e815fda779bc047b$var$BRp$5,
    $e815fda779bc047b$var$BRp$4,
    $e815fda779bc047b$var$BRp$3,
    $e815fda779bc047b$var$BRp$2,
    $e815fda779bc047b$var$BRp$1
].forEach(function(props) {
    $e815fda779bc047b$var$extend($e815fda779bc047b$var$BRp, props);
});
var $e815fda779bc047b$var$fullFpsTime = 1000 / 60; // assume 60 frames per second
var $e815fda779bc047b$var$defs = {
    setupDequeueing: function setupDequeueing(opts) {
        return function setupDequeueingImpl() {
            var self1 = this;
            var r = this.renderer;
            if (self1.dequeueingSetup) return;
            else self1.dequeueingSetup = true;
            var queueRedraw = $e815fda779bc047b$var$debounce(function() {
                r.redrawHint('eles', true);
                r.redrawHint('drag', true);
                r.redraw();
            }, opts.deqRedrawThreshold);
            var dequeue = function dequeue(willDraw, frameStartTime) {
                var startTime = $e815fda779bc047b$var$performanceNow();
                var avgRenderTime = r.averageRedrawTime;
                var renderTime = r.lastRedrawTime;
                var deqd = [];
                var extent = r.cy.extent();
                var pixelRatio = r.getPixelRatio();
                // if we aren't in a tick that causes a draw, then the rendered style
                // queue won't automatically be flushed before dequeueing starts
                if (!willDraw) r.flushRenderedStyleQueue();
                while(true){
                    // eslint-disable-line no-constant-condition
                    var now = $e815fda779bc047b$var$performanceNow();
                    var duration = now - startTime;
                    var frameDuration = now - frameStartTime;
                    if (renderTime < $e815fda779bc047b$var$fullFpsTime) {
                        // if we're rendering faster than the ideal fps, then do dequeueing
                        // during all of the remaining frame time
                        var timeAvailable = $e815fda779bc047b$var$fullFpsTime - (willDraw ? avgRenderTime : 0);
                        if (frameDuration >= opts.deqFastCost * timeAvailable) break;
                    } else {
                        if (willDraw) {
                            if (duration >= opts.deqCost * renderTime || duration >= opts.deqAvgCost * avgRenderTime) break;
                        } else if (frameDuration >= opts.deqNoDrawCost * $e815fda779bc047b$var$fullFpsTime) break;
                    }
                    var thisDeqd = opts.deq(self1, pixelRatio, extent);
                    if (thisDeqd.length > 0) for(var i = 0; i < thisDeqd.length; i++)deqd.push(thisDeqd[i]);
                    else break;
                }
                // callbacks on dequeue
                if (deqd.length > 0) {
                    opts.onDeqd(self1, deqd);
                    if (!willDraw && opts.shouldRedraw(self1, deqd, pixelRatio, extent)) queueRedraw();
                }
            };
            var priority = opts.priority || $e815fda779bc047b$var$noop$1;
            r.beforeRender(dequeue, priority(self1));
        };
    }
};
// Allows lookups for (ele, lvl) => cache.
// Uses keys so elements may share the same cache.
var $e815fda779bc047b$var$ElementTextureCacheLookup = /*#__PURE__*/ function() {
    function ElementTextureCacheLookup(getKey) {
        var doesEleInvalidateKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $e815fda779bc047b$var$falsify;
        $e815fda779bc047b$var$_classCallCheck(this, ElementTextureCacheLookup);
        this.idsByKey = new $e815fda779bc047b$var$Map$1();
        this.keyForId = new $e815fda779bc047b$var$Map$1();
        this.cachesByLvl = new $e815fda779bc047b$var$Map$1();
        this.lvls = [];
        this.getKey = getKey;
        this.doesEleInvalidateKey = doesEleInvalidateKey;
    }
    return $e815fda779bc047b$var$_createClass(ElementTextureCacheLookup, [
        {
            key: "getIdsFor",
            value: function getIdsFor(key) {
                if (key == null) $e815fda779bc047b$var$error("Can not get id list for null key");
                var idsByKey = this.idsByKey;
                var ids = this.idsByKey.get(key);
                if (!ids) {
                    ids = new $e815fda779bc047b$var$Set$1();
                    idsByKey.set(key, ids);
                }
                return ids;
            }
        },
        {
            key: "addIdForKey",
            value: function addIdForKey(key, id) {
                if (key != null) this.getIdsFor(key).add(id);
            }
        },
        {
            key: "deleteIdForKey",
            value: function deleteIdForKey(key, id) {
                if (key != null) this.getIdsFor(key)["delete"](id);
            }
        },
        {
            key: "getNumberOfIdsForKey",
            value: function getNumberOfIdsForKey(key) {
                if (key == null) return 0;
                else return this.getIdsFor(key).size;
            }
        },
        {
            key: "updateKeyMappingFor",
            value: function updateKeyMappingFor(ele) {
                var id = ele.id();
                var prevKey = this.keyForId.get(id);
                var currKey = this.getKey(ele);
                this.deleteIdForKey(prevKey, id);
                this.addIdForKey(currKey, id);
                this.keyForId.set(id, currKey);
            }
        },
        {
            key: "deleteKeyMappingFor",
            value: function deleteKeyMappingFor(ele) {
                var id = ele.id();
                var prevKey = this.keyForId.get(id);
                this.deleteIdForKey(prevKey, id);
                this.keyForId["delete"](id);
            }
        },
        {
            key: "keyHasChangedFor",
            value: function keyHasChangedFor(ele) {
                var id = ele.id();
                var prevKey = this.keyForId.get(id);
                var newKey = this.getKey(ele);
                return prevKey !== newKey;
            }
        },
        {
            key: "isInvalid",
            value: function isInvalid(ele) {
                return this.keyHasChangedFor(ele) || this.doesEleInvalidateKey(ele);
            }
        },
        {
            key: "getCachesAt",
            value: function getCachesAt(lvl) {
                var cachesByLvl = this.cachesByLvl, lvls = this.lvls;
                var caches = cachesByLvl.get(lvl);
                if (!caches) {
                    caches = new $e815fda779bc047b$var$Map$1();
                    cachesByLvl.set(lvl, caches);
                    lvls.push(lvl);
                }
                return caches;
            }
        },
        {
            key: "getCache",
            value: function getCache(key, lvl) {
                return this.getCachesAt(lvl).get(key);
            }
        },
        {
            key: "get",
            value: function get(ele, lvl) {
                var key = this.getKey(ele);
                var cache = this.getCache(key, lvl);
                // getting for an element may need to add to the id list b/c eles can share keys
                if (cache != null) this.updateKeyMappingFor(ele);
                return cache;
            }
        },
        {
            key: "getForCachedKey",
            value: function getForCachedKey(ele, lvl) {
                var key = this.keyForId.get(ele.id()); // n.b. use cached key, not newly computed key
                var cache = this.getCache(key, lvl);
                return cache;
            }
        },
        {
            key: "hasCache",
            value: function hasCache(key, lvl) {
                return this.getCachesAt(lvl).has(key);
            }
        },
        {
            key: "has",
            value: function has(ele, lvl) {
                var key = this.getKey(ele);
                return this.hasCache(key, lvl);
            }
        },
        {
            key: "setCache",
            value: function setCache(key, lvl, cache) {
                cache.key = key;
                this.getCachesAt(lvl).set(key, cache);
            }
        },
        {
            key: "set",
            value: function set(ele, lvl, cache) {
                var key = this.getKey(ele);
                this.setCache(key, lvl, cache);
                this.updateKeyMappingFor(ele);
            }
        },
        {
            key: "deleteCache",
            value: function deleteCache(key, lvl) {
                this.getCachesAt(lvl)["delete"](key);
            }
        },
        {
            key: "delete",
            value: function _delete(ele, lvl) {
                var key = this.getKey(ele);
                this.deleteCache(key, lvl);
            }
        },
        {
            key: "invalidateKey",
            value: function invalidateKey(key) {
                var _this = this;
                this.lvls.forEach(function(lvl) {
                    return _this.deleteCache(key, lvl);
                });
            }
        },
        {
            key: "invalidate",
            value: function invalidate(ele) {
                var id = ele.id();
                var key = this.keyForId.get(id); // n.b. use stored key rather than current (potential key)
                this.deleteKeyMappingFor(ele);
                var entireKeyInvalidated = this.doesEleInvalidateKey(ele);
                if (entireKeyInvalidated) // clear mapping for current key
                this.invalidateKey(key);
                return entireKeyInvalidated || this.getNumberOfIdsForKey(key) === 0;
            }
        }
    ]);
}();
var $e815fda779bc047b$var$minTxrH = 25; // the size of the texture cache for small height eles (special case)
var $e815fda779bc047b$var$txrStepH = 50; // the min size of the regular cache, and the size it increases with each step up
var $e815fda779bc047b$var$minLvl$1 = -4; // when scaling smaller than that we don't need to re-render
var $e815fda779bc047b$var$maxLvl$1 = 3; // when larger than this scale just render directly (caching is not helpful)
var $e815fda779bc047b$var$maxZoom$1 = 7.99; // beyond this zoom level, layered textures are not used
var $e815fda779bc047b$var$eleTxrSpacing = 8; // spacing between elements on textures to avoid blitting overlaps
var $e815fda779bc047b$var$defTxrWidth = 1024; // default/minimum texture width
var $e815fda779bc047b$var$maxTxrW = 1024; // the maximum width of a texture
var $e815fda779bc047b$var$maxTxrH = 1024; // the maximum height of a texture
var $e815fda779bc047b$var$minUtility = 0.2; // if usage of texture is less than this, it is retired
var $e815fda779bc047b$var$maxFullness = 0.8; // fullness of texture after which queue removal is checked
var $e815fda779bc047b$var$maxFullnessChecks = 10; // dequeued after this many checks
var $e815fda779bc047b$var$deqCost$1 = 0.15; // % of add'l rendering cost allowed for dequeuing ele caches each frame
var $e815fda779bc047b$var$deqAvgCost$1 = 0.1; // % of add'l rendering cost compared to average overall redraw time
var $e815fda779bc047b$var$deqNoDrawCost$1 = 0.9; // % of avg frame time that can be used for dequeueing when not drawing
var $e815fda779bc047b$var$deqFastCost$1 = 0.9; // % of frame time to be used when >60fps
var $e815fda779bc047b$var$deqRedrawThreshold$1 = 100; // time to batch redraws together from dequeueing to allow more dequeueing calcs to happen in the meanwhile
var $e815fda779bc047b$var$maxDeqSize$1 = 1; // number of eles to dequeue and render at higher texture in each batch
var $e815fda779bc047b$var$getTxrReasons = {
    dequeue: 'dequeue',
    downscale: 'downscale',
    highQuality: 'highQuality'
};
var $e815fda779bc047b$var$initDefaults = $e815fda779bc047b$var$defaults$g({
    getKey: null,
    doesEleInvalidateKey: $e815fda779bc047b$var$falsify,
    drawElement: null,
    getBoundingBox: null,
    getRotationPoint: null,
    getRotationOffset: null,
    isVisible: $e815fda779bc047b$var$trueify,
    allowEdgeTxrCaching: true,
    allowParentTxrCaching: true
});
var $e815fda779bc047b$var$ElementTextureCache = function ElementTextureCache(renderer, initOptions) {
    var self1 = this;
    self1.renderer = renderer;
    self1.onDequeues = [];
    var opts = $e815fda779bc047b$var$initDefaults(initOptions);
    $e815fda779bc047b$var$extend(self1, opts);
    self1.lookup = new $e815fda779bc047b$var$ElementTextureCacheLookup(opts.getKey, opts.doesEleInvalidateKey);
    self1.setupDequeueing();
};
var $e815fda779bc047b$var$ETCp = $e815fda779bc047b$var$ElementTextureCache.prototype;
$e815fda779bc047b$var$ETCp.reasons = $e815fda779bc047b$var$getTxrReasons;
// the list of textures in which new subtextures for elements can be placed
$e815fda779bc047b$var$ETCp.getTextureQueue = function(txrH) {
    var self1 = this;
    self1.eleImgCaches = self1.eleImgCaches || {};
    return self1.eleImgCaches[txrH] = self1.eleImgCaches[txrH] || [];
};
// the list of usused textures which can be recycled (in use in texture queue)
$e815fda779bc047b$var$ETCp.getRetiredTextureQueue = function(txrH) {
    var self1 = this;
    var rtxtrQs = self1.eleImgCaches.retired = self1.eleImgCaches.retired || {};
    var rtxtrQ = rtxtrQs[txrH] = rtxtrQs[txrH] || [];
    return rtxtrQ;
};
// queue of element draw requests at different scale levels
$e815fda779bc047b$var$ETCp.getElementQueue = function() {
    var self1 = this;
    var q = self1.eleCacheQueue = self1.eleCacheQueue || new $e815fda779bc047b$var$Heap(function(a, b) {
        return b.reqs - a.reqs;
    });
    return q;
};
// queue of element draw requests at different scale levels (element id lookup)
$e815fda779bc047b$var$ETCp.getElementKeyToQueue = function() {
    var self1 = this;
    var k2q = self1.eleKeyToCacheQueue = self1.eleKeyToCacheQueue || {};
    return k2q;
};
$e815fda779bc047b$var$ETCp.getElement = function(ele, bb, pxRatio, lvl, reason) {
    var self1 = this;
    var r = this.renderer;
    var zoom = r.cy.zoom();
    var lookup = this.lookup;
    if (!bb || bb.w === 0 || bb.h === 0 || isNaN(bb.w) || isNaN(bb.h) || !ele.visible() || ele.removed()) return null;
    if (!self1.allowEdgeTxrCaching && ele.isEdge() || !self1.allowParentTxrCaching && ele.isParent()) return null;
    if (lvl == null) lvl = Math.ceil($e815fda779bc047b$var$log2(zoom * pxRatio));
    if (lvl < $e815fda779bc047b$var$minLvl$1) lvl = $e815fda779bc047b$var$minLvl$1;
    else if (zoom >= $e815fda779bc047b$var$maxZoom$1 || lvl > $e815fda779bc047b$var$maxLvl$1) return null;
    var scale = Math.pow(2, lvl);
    var eleScaledH = bb.h * scale;
    var eleScaledW = bb.w * scale;
    var scaledLabelShown = r.eleTextBiggerThanMin(ele, scale);
    if (!this.isVisible(ele, scaledLabelShown)) return null;
    var eleCache = lookup.get(ele, lvl);
    // if this get was on an unused/invalidated cache, then restore the texture usage metric
    if (eleCache && eleCache.invalidated) {
        eleCache.invalidated = false;
        eleCache.texture.invalidatedWidth -= eleCache.width;
    }
    if (eleCache) return eleCache;
    var txrH; // which texture height this ele belongs to
    if (eleScaledH <= $e815fda779bc047b$var$minTxrH) txrH = $e815fda779bc047b$var$minTxrH;
    else if (eleScaledH <= $e815fda779bc047b$var$txrStepH) txrH = $e815fda779bc047b$var$txrStepH;
    else txrH = Math.ceil(eleScaledH / $e815fda779bc047b$var$txrStepH) * $e815fda779bc047b$var$txrStepH;
    if (eleScaledH > $e815fda779bc047b$var$maxTxrH || eleScaledW > $e815fda779bc047b$var$maxTxrW) return null; // caching large elements is not efficient
    var txrQ = self1.getTextureQueue(txrH);
    // first try the second last one in case it has space at the end
    var txr = txrQ[txrQ.length - 2];
    var addNewTxr = function addNewTxr() {
        return self1.recycleTexture(txrH, eleScaledW) || self1.addTexture(txrH, eleScaledW);
    };
    // try the last one if there is no second last one
    if (!txr) txr = txrQ[txrQ.length - 1];
    // if the last one doesn't exist, we need a first one
    if (!txr) txr = addNewTxr();
    // if there's no room in the current texture, we need a new one
    if (txr.width - txr.usedWidth < eleScaledW) txr = addNewTxr();
    var scalableFrom = function scalableFrom(otherCache) {
        return otherCache && otherCache.scaledLabelShown === scaledLabelShown;
    };
    var deqing = reason && reason === $e815fda779bc047b$var$getTxrReasons.dequeue;
    var highQualityReq = reason && reason === $e815fda779bc047b$var$getTxrReasons.highQuality;
    var downscaleReq = reason && reason === $e815fda779bc047b$var$getTxrReasons.downscale;
    var higherCache; // the nearest cache with a higher level
    for(var l = lvl + 1; l <= $e815fda779bc047b$var$maxLvl$1; l++){
        var c = lookup.get(ele, l);
        if (c) {
            higherCache = c;
            break;
        }
    }
    var oneUpCache = higherCache && higherCache.level === lvl + 1 ? higherCache : null;
    var downscale = function downscale() {
        txr.context.drawImage(oneUpCache.texture.canvas, oneUpCache.x, 0, oneUpCache.width, oneUpCache.height, txr.usedWidth, 0, eleScaledW, eleScaledH);
    };
    // reset ele area in texture
    txr.context.setTransform(1, 0, 0, 1, 0, 0);
    txr.context.clearRect(txr.usedWidth, 0, eleScaledW, txrH);
    if (scalableFrom(oneUpCache)) // then we can relatively cheaply rescale the existing image w/o rerendering
    downscale();
    else if (scalableFrom(higherCache)) {
        // then use the higher cache for now and queue the next level down
        // to cheaply scale towards the smaller level
        if (highQualityReq) {
            for(var _l = higherCache.level; _l > lvl; _l--)oneUpCache = self1.getElement(ele, bb, pxRatio, _l, $e815fda779bc047b$var$getTxrReasons.downscale);
            downscale();
        } else {
            self1.queueElement(ele, higherCache.level - 1);
            return higherCache;
        }
    } else {
        var lowerCache; // the nearest cache with a lower level
        if (!deqing && !highQualityReq && !downscaleReq) for(var _l2 = lvl - 1; _l2 >= $e815fda779bc047b$var$minLvl$1; _l2--){
            var _c = lookup.get(ele, _l2);
            if (_c) {
                lowerCache = _c;
                break;
            }
        }
        if (scalableFrom(lowerCache)) {
            // then use the lower quality cache for now and queue the better one for later
            self1.queueElement(ele, lvl);
            return lowerCache;
        }
        txr.context.translate(txr.usedWidth, 0);
        txr.context.scale(scale, scale);
        this.drawElement(txr.context, ele, bb, scaledLabelShown, false);
        txr.context.scale(1 / scale, 1 / scale);
        txr.context.translate(-txr.usedWidth, 0);
    }
    eleCache = {
        x: txr.usedWidth,
        texture: txr,
        level: lvl,
        scale: scale,
        width: eleScaledW,
        height: eleScaledH,
        scaledLabelShown: scaledLabelShown
    };
    txr.usedWidth += Math.ceil(eleScaledW + $e815fda779bc047b$var$eleTxrSpacing);
    txr.eleCaches.push(eleCache);
    lookup.set(ele, lvl, eleCache);
    self1.checkTextureFullness(txr);
    return eleCache;
};
$e815fda779bc047b$var$ETCp.invalidateElements = function(eles) {
    for(var i = 0; i < eles.length; i++)this.invalidateElement(eles[i]);
};
$e815fda779bc047b$var$ETCp.invalidateElement = function(ele) {
    var self1 = this;
    var lookup = self1.lookup;
    var caches = [];
    var invalid = lookup.isInvalid(ele);
    if (!invalid) return; // override the invalidation request if the element key has not changed
    for(var lvl = $e815fda779bc047b$var$minLvl$1; lvl <= $e815fda779bc047b$var$maxLvl$1; lvl++){
        var cache = lookup.getForCachedKey(ele, lvl);
        if (cache) caches.push(cache);
    }
    var noOtherElesUseCache = lookup.invalidate(ele);
    if (noOtherElesUseCache) for(var i = 0; i < caches.length; i++){
        var _cache = caches[i];
        var txr = _cache.texture;
        // remove space from the texture it belongs to
        txr.invalidatedWidth += _cache.width;
        // mark the cache as invalidated
        _cache.invalidated = true;
        // retire the texture if its utility is low
        self1.checkTextureUtility(txr);
    }
    // remove from queue since the old req was for the old state
    self1.removeFromQueue(ele);
};
$e815fda779bc047b$var$ETCp.checkTextureUtility = function(txr) {
    // invalidate all entries in the cache if the cache size is small
    if (txr.invalidatedWidth >= $e815fda779bc047b$var$minUtility * txr.width) this.retireTexture(txr);
};
$e815fda779bc047b$var$ETCp.checkTextureFullness = function(txr) {
    // if texture has been mostly filled and passed over several times, remove
    // it from the queue so we don't need to waste time looking at it to put new things
    var self1 = this;
    var txrQ = self1.getTextureQueue(txr.height);
    if (txr.usedWidth / txr.width > $e815fda779bc047b$var$maxFullness && txr.fullnessChecks >= $e815fda779bc047b$var$maxFullnessChecks) $e815fda779bc047b$var$removeFromArray(txrQ, txr);
    else txr.fullnessChecks++;
};
$e815fda779bc047b$var$ETCp.retireTexture = function(txr) {
    var self1 = this;
    var txrH = txr.height;
    var txrQ = self1.getTextureQueue(txrH);
    var lookup = this.lookup;
    // retire the texture from the active / searchable queue:
    $e815fda779bc047b$var$removeFromArray(txrQ, txr);
    txr.retired = true;
    // remove the refs from the eles to the caches:
    var eleCaches = txr.eleCaches;
    for(var i = 0; i < eleCaches.length; i++){
        var eleCache = eleCaches[i];
        lookup.deleteCache(eleCache.key, eleCache.level);
    }
    $e815fda779bc047b$var$clearArray(eleCaches);
    // add the texture to a retired queue so it can be recycled in future:
    var rtxtrQ = self1.getRetiredTextureQueue(txrH);
    rtxtrQ.push(txr);
};
$e815fda779bc047b$var$ETCp.addTexture = function(txrH, minW) {
    var self1 = this;
    var txrQ = self1.getTextureQueue(txrH);
    var txr = {};
    txrQ.push(txr);
    txr.eleCaches = [];
    txr.height = txrH;
    txr.width = Math.max($e815fda779bc047b$var$defTxrWidth, minW);
    txr.usedWidth = 0;
    txr.invalidatedWidth = 0;
    txr.fullnessChecks = 0;
    txr.canvas = self1.renderer.makeOffscreenCanvas(txr.width, txr.height);
    txr.context = txr.canvas.getContext('2d');
    return txr;
};
$e815fda779bc047b$var$ETCp.recycleTexture = function(txrH, minW) {
    var self1 = this;
    var txrQ = self1.getTextureQueue(txrH);
    var rtxtrQ = self1.getRetiredTextureQueue(txrH);
    for(var i = 0; i < rtxtrQ.length; i++){
        var txr = rtxtrQ[i];
        if (txr.width >= minW) {
            txr.retired = false;
            txr.usedWidth = 0;
            txr.invalidatedWidth = 0;
            txr.fullnessChecks = 0;
            $e815fda779bc047b$var$clearArray(txr.eleCaches);
            txr.context.setTransform(1, 0, 0, 1, 0, 0);
            txr.context.clearRect(0, 0, txr.width, txr.height);
            $e815fda779bc047b$var$removeFromArray(rtxtrQ, txr);
            txrQ.push(txr);
            return txr;
        }
    }
};
$e815fda779bc047b$var$ETCp.queueElement = function(ele, lvl) {
    var self1 = this;
    var q = self1.getElementQueue();
    var k2q = self1.getElementKeyToQueue();
    var key = this.getKey(ele);
    var existingReq = k2q[key];
    if (existingReq) {
        // use the max lvl b/c in between lvls are cheap to make
        existingReq.level = Math.max(existingReq.level, lvl);
        existingReq.eles.merge(ele);
        existingReq.reqs++;
        q.updateItem(existingReq);
    } else {
        var req = {
            eles: ele.spawn().merge(ele),
            level: lvl,
            reqs: 1,
            key: key
        };
        q.push(req);
        k2q[key] = req;
    }
};
$e815fda779bc047b$var$ETCp.dequeue = function(pxRatio /*, extent*/ ) {
    var self1 = this;
    var q = self1.getElementQueue();
    var k2q = self1.getElementKeyToQueue();
    var dequeued = [];
    var lookup = self1.lookup;
    for(var i = 0; i < $e815fda779bc047b$var$maxDeqSize$1; i++){
        if (q.size() > 0) {
            var req = q.pop();
            var key = req.key;
            var ele = req.eles[0]; // all eles have the same key
            var cacheExists = lookup.hasCache(ele, req.level);
            // clear out the key to req lookup
            k2q[key] = null;
            // dequeueing isn't necessary with an existing cache
            if (cacheExists) continue;
            dequeued.push(req);
            var bb = self1.getBoundingBox(ele);
            self1.getElement(ele, bb, pxRatio, req.level, $e815fda779bc047b$var$getTxrReasons.dequeue);
        } else break;
    }
    return dequeued;
};
$e815fda779bc047b$var$ETCp.removeFromQueue = function(ele) {
    var self1 = this;
    var q = self1.getElementQueue();
    var k2q = self1.getElementKeyToQueue();
    var key = this.getKey(ele);
    var req = k2q[key];
    if (req != null) {
        if (req.eles.length === 1) {
            // remove if last ele in the req
            // bring to front of queue
            req.reqs = $e815fda779bc047b$var$MAX_INT$1;
            q.updateItem(req);
            q.pop(); // remove from queue
            k2q[key] = null; // remove from lookup map
        } else // otherwise just remove ele from req
        req.eles.unmerge(ele);
    }
};
$e815fda779bc047b$var$ETCp.onDequeue = function(fn) {
    this.onDequeues.push(fn);
};
$e815fda779bc047b$var$ETCp.offDequeue = function(fn) {
    $e815fda779bc047b$var$removeFromArray(this.onDequeues, fn);
};
$e815fda779bc047b$var$ETCp.setupDequeueing = $e815fda779bc047b$var$defs.setupDequeueing({
    deqRedrawThreshold: $e815fda779bc047b$var$deqRedrawThreshold$1,
    deqCost: $e815fda779bc047b$var$deqCost$1,
    deqAvgCost: $e815fda779bc047b$var$deqAvgCost$1,
    deqNoDrawCost: $e815fda779bc047b$var$deqNoDrawCost$1,
    deqFastCost: $e815fda779bc047b$var$deqFastCost$1,
    deq: function deq(self1, pxRatio, extent) {
        return self1.dequeue(pxRatio, extent);
    },
    onDeqd: function onDeqd(self1, deqd) {
        for(var i = 0; i < self1.onDequeues.length; i++){
            var fn = self1.onDequeues[i];
            fn(deqd);
        }
    },
    shouldRedraw: function shouldRedraw(self1, deqd, pxRatio, extent) {
        for(var i = 0; i < deqd.length; i++){
            var eles = deqd[i].eles;
            for(var j = 0; j < eles.length; j++){
                var bb = eles[j].boundingBox();
                if ($e815fda779bc047b$var$boundingBoxesIntersect(bb, extent)) return true;
            }
        }
        return false;
    },
    priority: function priority(self1) {
        return self1.renderer.beforeRenderPriorities.eleTxrDeq;
    }
});
var $e815fda779bc047b$var$defNumLayers = 1; // default number of layers to use
var $e815fda779bc047b$var$minLvl = -4; // when scaling smaller than that we don't need to re-render
var $e815fda779bc047b$var$maxLvl = 2; // when larger than this scale just render directly (caching is not helpful)
var $e815fda779bc047b$var$maxZoom = 3.99; // beyond this zoom level, layered textures are not used
var $e815fda779bc047b$var$deqRedrawThreshold = 50; // time to batch redraws together from dequeueing to allow more dequeueing calcs to happen in the meanwhile
var $e815fda779bc047b$var$refineEleDebounceTime = 50; // time to debounce sharper ele texture updates
var $e815fda779bc047b$var$deqCost = 0.15; // % of add'l rendering cost allowed for dequeuing ele caches each frame
var $e815fda779bc047b$var$deqAvgCost = 0.1; // % of add'l rendering cost compared to average overall redraw time
var $e815fda779bc047b$var$deqNoDrawCost = 0.9; // % of avg frame time that can be used for dequeueing when not drawing
var $e815fda779bc047b$var$deqFastCost = 0.9; // % of frame time to be used when >60fps
var $e815fda779bc047b$var$maxDeqSize = 1; // number of eles to dequeue and render at higher texture in each batch
var $e815fda779bc047b$var$invalidThreshold = 250; // time threshold for disabling b/c of invalidations
var $e815fda779bc047b$var$maxLayerArea = 16000000; // layers can't be bigger than this
var $e815fda779bc047b$var$maxLayerDim = 32767; // maximum size for the width/height of layer canvases
var $e815fda779bc047b$var$useHighQualityEleTxrReqs = true; // whether to use high quality ele txr requests (generally faster and cheaper in the longterm)
// var log = function(){ console.log.apply( console, arguments ); };
var $e815fda779bc047b$var$LayeredTextureCache = function LayeredTextureCache(renderer) {
    var self1 = this;
    var r = self1.renderer = renderer;
    var cy = r.cy;
    self1.layersByLevel = {}; // e.g. 2 => [ layer1, layer2, ..., layerN ]
    self1.firstGet = true;
    self1.lastInvalidationTime = $e815fda779bc047b$var$performanceNow() - 2 * $e815fda779bc047b$var$invalidThreshold;
    self1.skipping = false;
    self1.eleTxrDeqs = cy.collection();
    self1.scheduleElementRefinement = $e815fda779bc047b$var$debounce(function() {
        self1.refineElementTextures(self1.eleTxrDeqs);
        self1.eleTxrDeqs.unmerge(self1.eleTxrDeqs);
    }, $e815fda779bc047b$var$refineEleDebounceTime);
    r.beforeRender(function(willDraw, now) {
        if (now - self1.lastInvalidationTime <= $e815fda779bc047b$var$invalidThreshold) self1.skipping = true;
        else self1.skipping = false;
    }, r.beforeRenderPriorities.lyrTxrSkip);
    var qSort = function qSort(a, b) {
        return b.reqs - a.reqs;
    };
    self1.layersQueue = new $e815fda779bc047b$var$Heap(qSort);
    self1.setupDequeueing();
};
var $e815fda779bc047b$var$LTCp = $e815fda779bc047b$var$LayeredTextureCache.prototype;
var $e815fda779bc047b$var$layerIdPool = 0;
var $e815fda779bc047b$var$MAX_INT = Math.pow(2, 53) - 1;
$e815fda779bc047b$var$LTCp.makeLayer = function(bb, lvl) {
    var scale = Math.pow(2, lvl);
    var w = Math.ceil(bb.w * scale);
    var h = Math.ceil(bb.h * scale);
    var canvas = this.renderer.makeOffscreenCanvas(w, h);
    var layer = {
        id: $e815fda779bc047b$var$layerIdPool = ++$e815fda779bc047b$var$layerIdPool % $e815fda779bc047b$var$MAX_INT,
        bb: bb,
        level: lvl,
        width: w,
        height: h,
        canvas: canvas,
        context: canvas.getContext('2d'),
        eles: [],
        elesQueue: [],
        reqs: 0
    };
    // log('make layer %s with w %s and h %s and lvl %s', layer.id, layer.width, layer.height, layer.level);
    var cxt = layer.context;
    var dx = -layer.bb.x1;
    var dy = -layer.bb.y1;
    // do the transform on creation to save cycles (it's the same for all eles)
    cxt.scale(scale, scale);
    cxt.translate(dx, dy);
    return layer;
};
$e815fda779bc047b$var$LTCp.getLayers = function(eles, pxRatio, lvl) {
    var self1 = this;
    var r = self1.renderer;
    var cy = r.cy;
    var zoom = cy.zoom();
    var firstGet = self1.firstGet;
    self1.firstGet = false;
    // log('--\nget layers with %s eles', eles.length);
    //log eles.map(function(ele){ return ele.id() }) );
    if (lvl == null) {
        lvl = Math.ceil($e815fda779bc047b$var$log2(zoom * pxRatio));
        if (lvl < $e815fda779bc047b$var$minLvl) lvl = $e815fda779bc047b$var$minLvl;
        else if (zoom >= $e815fda779bc047b$var$maxZoom || lvl > $e815fda779bc047b$var$maxLvl) return null;
    }
    self1.validateLayersElesOrdering(lvl, eles);
    var layersByLvl = self1.layersByLevel;
    var scale = Math.pow(2, lvl);
    var layers = layersByLvl[lvl] = layersByLvl[lvl] || [];
    var bb;
    var lvlComplete = self1.levelIsComplete(lvl, eles);
    var tmpLayers;
    var checkTempLevels = function checkTempLevels() {
        var canUseAsTmpLvl = function canUseAsTmpLvl(l) {
            self1.validateLayersElesOrdering(l, eles);
            if (self1.levelIsComplete(l, eles)) {
                tmpLayers = layersByLvl[l];
                return true;
            }
        };
        var checkLvls = function checkLvls(dir) {
            if (tmpLayers) return;
            for(var l = lvl + dir; $e815fda779bc047b$var$minLvl <= l && l <= $e815fda779bc047b$var$maxLvl; l += dir){
                if (canUseAsTmpLvl(l)) break;
            }
        };
        checkLvls(1);
        checkLvls(-1);
        // remove the invalid layers; they will be replaced as needed later in this function
        for(var i = layers.length - 1; i >= 0; i--){
            var layer = layers[i];
            if (layer.invalid) $e815fda779bc047b$var$removeFromArray(layers, layer);
        }
    };
    if (!lvlComplete) // if the current level is incomplete, then use the closest, best quality layerset temporarily
    // and later queue the current layerset so we can get the proper quality level soon
    checkTempLevels();
    else // log('level complete, using existing layers\n--');
    return layers;
    var getBb = function getBb() {
        if (!bb) {
            bb = $e815fda779bc047b$var$makeBoundingBox();
            for(var i = 0; i < eles.length; i++)$e815fda779bc047b$var$updateBoundingBox(bb, eles[i].boundingBox());
        }
        return bb;
    };
    var makeLayer = function makeLayer(opts) {
        opts = opts || {};
        var after = opts.after;
        getBb();
        var w = Math.ceil(bb.w * scale);
        var h = Math.ceil(bb.h * scale);
        if (w > $e815fda779bc047b$var$maxLayerDim || h > $e815fda779bc047b$var$maxLayerDim) return null;
        var area = w * h;
        if (area > $e815fda779bc047b$var$maxLayerArea) return null;
        var layer = self1.makeLayer(bb, lvl);
        if (after != null) {
            var index = layers.indexOf(after) + 1;
            layers.splice(index, 0, layer);
        } else if (opts.insert === undefined || opts.insert) // no after specified => first layer made so put at start
        layers.unshift(layer);
        // if( tmpLayers ){
        //self.queueLayer( layer );
        // }
        return layer;
    };
    if (self1.skipping && !firstGet) // log('skip layers');
    return null;
    // log('do layers');
    var layer = null;
    var maxElesPerLayer = eles.length / $e815fda779bc047b$var$defNumLayers;
    var allowLazyQueueing = !firstGet;
    for(var i = 0; i < eles.length; i++){
        var ele = eles[i];
        var rs = ele._private.rscratch;
        var caches = rs.imgLayerCaches = rs.imgLayerCaches || {};
        // log('look at ele', ele.id());
        var existingLayer = caches[lvl];
        if (existingLayer) {
            // reuse layer for later eles
            // log('reuse layer for', ele.id());
            layer = existingLayer;
            continue;
        }
        if (!layer || layer.eles.length >= maxElesPerLayer || !$e815fda779bc047b$var$boundingBoxInBoundingBox(layer.bb, ele.boundingBox())) {
            // log('make new layer for ele %s', ele.id());
            layer = makeLayer({
                insert: true,
                after: layer
            });
            // if now layer can be built then we can't use layers at this level
            if (!layer) return null;
        // log('new layer with id %s', layer.id);
        }
        if (tmpLayers || allowLazyQueueing) // log('queue ele %s in layer %s', ele.id(), layer.id);
        self1.queueLayer(layer, ele);
        else // log('draw ele %s in layer %s', ele.id(), layer.id);
        self1.drawEleInLayer(layer, ele, lvl, pxRatio);
        layer.eles.push(ele);
        caches[lvl] = layer;
    }
    // log('--');
    if (tmpLayers) // then we only queued the current layerset and can't draw it yet
    return tmpLayers;
    if (allowLazyQueueing) // log('lazy queue level', lvl);
    return null;
    return layers;
};
// a layer may want to use an ele cache of a higher level to avoid blurriness
// so the layer level might not equal the ele level
$e815fda779bc047b$var$LTCp.getEleLevelForLayerLevel = function(lvl, pxRatio) {
    return lvl;
};
$e815fda779bc047b$var$LTCp.drawEleInLayer = function(layer, ele, lvl, pxRatio) {
    var self1 = this;
    var r = this.renderer;
    var context = layer.context;
    var bb = ele.boundingBox();
    if (bb.w === 0 || bb.h === 0 || !ele.visible()) return;
    lvl = self1.getEleLevelForLayerLevel(lvl, pxRatio);
    r.setImgSmoothing(context, false);
    r.drawCachedElement(context, ele, null, null, lvl, $e815fda779bc047b$var$useHighQualityEleTxrReqs);
    r.setImgSmoothing(context, true);
};
$e815fda779bc047b$var$LTCp.levelIsComplete = function(lvl, eles) {
    var self1 = this;
    var layers = self1.layersByLevel[lvl];
    if (!layers || layers.length === 0) return false;
    var numElesInLayers = 0;
    for(var i = 0; i < layers.length; i++){
        var layer = layers[i];
        // if there are any eles needed to be drawn yet, the level is not complete
        if (layer.reqs > 0) return false;
        // if the layer is invalid, the level is not complete
        if (layer.invalid) return false;
        numElesInLayers += layer.eles.length;
    }
    // we should have exactly the number of eles passed in to be complete
    if (numElesInLayers !== eles.length) return false;
    return true;
};
$e815fda779bc047b$var$LTCp.validateLayersElesOrdering = function(lvl, eles) {
    var layers = this.layersByLevel[lvl];
    if (!layers) return;
    // if in a layer the eles are not in the same order, then the layer is invalid
    // (i.e. there is an ele in between the eles in the layer)
    for(var i = 0; i < layers.length; i++){
        var layer = layers[i];
        var offset = -1;
        // find the offset
        for(var j = 0; j < eles.length; j++)if (layer.eles[0] === eles[j]) {
            offset = j;
            break;
        }
        if (offset < 0) {
            // then the layer has nonexistent elements and is invalid
            this.invalidateLayer(layer);
            continue;
        }
        // the eles in the layer must be in the same continuous order, else the layer is invalid
        var o = offset;
        for(var j = 0; j < layer.eles.length; j++)if (layer.eles[j] !== eles[o + j]) {
            // log('invalidate based on ordering', layer.id);
            this.invalidateLayer(layer);
            break;
        }
    }
};
$e815fda779bc047b$var$LTCp.updateElementsInLayers = function(eles, update) {
    var self1 = this;
    var isEles = $e815fda779bc047b$var$element(eles[0]);
    // collect udpated elements (cascaded from the layers) and update each
    // layer itself along the way
    for(var i = 0; i < eles.length; i++){
        var req = isEles ? null : eles[i];
        var ele = isEles ? eles[i] : eles[i].ele;
        var rs = ele._private.rscratch;
        var caches = rs.imgLayerCaches = rs.imgLayerCaches || {};
        for(var l = $e815fda779bc047b$var$minLvl; l <= $e815fda779bc047b$var$maxLvl; l++){
            var layer = caches[l];
            if (!layer) continue;
            // if update is a request from the ele cache, then it affects only
            // the matching level
            if (req && self1.getEleLevelForLayerLevel(layer.level) !== req.level) continue;
            update(layer, ele, req);
        }
    }
};
$e815fda779bc047b$var$LTCp.haveLayers = function() {
    var self1 = this;
    var haveLayers = false;
    for(var l = $e815fda779bc047b$var$minLvl; l <= $e815fda779bc047b$var$maxLvl; l++){
        var layers = self1.layersByLevel[l];
        if (layers && layers.length > 0) {
            haveLayers = true;
            break;
        }
    }
    return haveLayers;
};
$e815fda779bc047b$var$LTCp.invalidateElements = function(eles) {
    var self1 = this;
    if (eles.length === 0) return;
    self1.lastInvalidationTime = $e815fda779bc047b$var$performanceNow();
    // log('update invalidate layer time from eles');
    if (eles.length === 0 || !self1.haveLayers()) return;
    self1.updateElementsInLayers(eles, function invalAssocLayers(layer, ele, req) {
        self1.invalidateLayer(layer);
    });
};
$e815fda779bc047b$var$LTCp.invalidateLayer = function(layer) {
    // log('update invalidate layer time');
    this.lastInvalidationTime = $e815fda779bc047b$var$performanceNow();
    if (layer.invalid) return;
     // save cycles
    var lvl = layer.level;
    var eles = layer.eles;
    var layers = this.layersByLevel[lvl];
    // log('invalidate layer', layer.id );
    $e815fda779bc047b$var$removeFromArray(layers, layer);
    // layer.eles = [];
    layer.elesQueue = [];
    layer.invalid = true;
    if (layer.replacement) layer.replacement.invalid = true;
    for(var i = 0; i < eles.length; i++){
        var caches = eles[i]._private.rscratch.imgLayerCaches;
        if (caches) caches[lvl] = null;
    }
};
$e815fda779bc047b$var$LTCp.refineElementTextures = function(eles) {
    var self1 = this;
    // log('refine', eles.length);
    self1.updateElementsInLayers(eles, function refineEachEle(layer, ele, req) {
        var rLyr = layer.replacement;
        if (!rLyr) {
            rLyr = layer.replacement = self1.makeLayer(layer.bb, layer.level);
            rLyr.replaces = layer;
            rLyr.eles = layer.eles;
        // log('make replacement layer %s for %s with level %s', rLyr.id, layer.id, rLyr.level);
        }
        if (!rLyr.reqs) for(var i = 0; i < rLyr.eles.length; i++)self1.queueLayer(rLyr, rLyr.eles[i]);
    });
};
$e815fda779bc047b$var$LTCp.enqueueElementRefinement = function(ele) {
    this.eleTxrDeqs.merge(ele);
    this.scheduleElementRefinement();
};
$e815fda779bc047b$var$LTCp.queueLayer = function(layer, ele) {
    var self1 = this;
    var q = self1.layersQueue;
    var elesQ = layer.elesQueue;
    var hasId = elesQ.hasId = elesQ.hasId || {};
    // if a layer is going to be replaced, queuing is a waste of time
    if (layer.replacement) return;
    if (ele) {
        if (hasId[ele.id()]) return;
        elesQ.push(ele);
        hasId[ele.id()] = true;
    }
    if (layer.reqs) {
        layer.reqs++;
        q.updateItem(layer);
    } else {
        layer.reqs = 1;
        q.push(layer);
    }
};
$e815fda779bc047b$var$LTCp.dequeue = function(pxRatio) {
    var self1 = this;
    var q = self1.layersQueue;
    var deqd = [];
    var eleDeqs = 0;
    while(eleDeqs < $e815fda779bc047b$var$maxDeqSize){
        if (q.size() === 0) break;
        var layer = q.peek();
        // if a layer has been or will be replaced, then don't waste time with it
        if (layer.replacement) {
            // log('layer %s in queue skipped b/c it already has a replacement', layer.id);
            q.pop();
            continue;
        }
        // if this is a replacement layer that has been superceded, then forget it
        if (layer.replaces && layer !== layer.replaces.replacement) {
            // log('layer is no longer the most uptodate replacement; dequeued', layer.id)
            q.pop();
            continue;
        }
        if (layer.invalid) {
            // log('replacement layer %s is invalid; dequeued', layer.id);
            q.pop();
            continue;
        }
        var ele = layer.elesQueue.shift();
        if (ele) {
            // log('dequeue layer %s', layer.id);
            self1.drawEleInLayer(layer, ele, layer.level, pxRatio);
            eleDeqs++;
        }
        if (deqd.length === 0) // we need only one entry in deqd to queue redrawing etc
        deqd.push(true);
        // if the layer has all its eles done, then remove from the queue
        if (layer.elesQueue.length === 0) {
            q.pop();
            layer.reqs = 0;
            // log('dequeue of layer %s complete', layer.id);
            // when a replacement layer is dequeued, it replaces the old layer in the level
            if (layer.replaces) self1.applyLayerReplacement(layer);
            self1.requestRedraw();
        }
    }
    return deqd;
};
$e815fda779bc047b$var$LTCp.applyLayerReplacement = function(layer) {
    var self1 = this;
    var layersInLevel = self1.layersByLevel[layer.level];
    var replaced = layer.replaces;
    var index = layersInLevel.indexOf(replaced);
    // if the replaced layer is not in the active list for the level, then replacing
    // refs would be a mistake (i.e. overwriting the true active layer)
    if (index < 0 || replaced.invalid) // log('replacement layer would have no effect', layer.id);
    return;
    layersInLevel[index] = layer; // replace level ref
    // replace refs in eles
    for(var i = 0; i < layer.eles.length; i++){
        var _p = layer.eles[i]._private;
        var cache = _p.imgLayerCaches = _p.imgLayerCaches || {};
        if (cache) cache[layer.level] = layer;
    }
    // log('apply replacement layer %s over %s', layer.id, replaced.id);
    self1.requestRedraw();
};
$e815fda779bc047b$var$LTCp.requestRedraw = $e815fda779bc047b$var$debounce(function() {
    var r = this.renderer;
    r.redrawHint('eles', true);
    r.redrawHint('drag', true);
    r.redraw();
}, 100);
$e815fda779bc047b$var$LTCp.setupDequeueing = $e815fda779bc047b$var$defs.setupDequeueing({
    deqRedrawThreshold: $e815fda779bc047b$var$deqRedrawThreshold,
    deqCost: $e815fda779bc047b$var$deqCost,
    deqAvgCost: $e815fda779bc047b$var$deqAvgCost,
    deqNoDrawCost: $e815fda779bc047b$var$deqNoDrawCost,
    deqFastCost: $e815fda779bc047b$var$deqFastCost,
    deq: function deq(self1, pxRatio) {
        return self1.dequeue(pxRatio);
    },
    onDeqd: $e815fda779bc047b$var$noop$1,
    shouldRedraw: $e815fda779bc047b$var$trueify,
    priority: function priority(self1) {
        return self1.renderer.beforeRenderPriorities.lyrTxrDeq;
    }
});
var $e815fda779bc047b$var$CRp$b = {};
var $e815fda779bc047b$var$impl;
function $e815fda779bc047b$var$polygon(context, points) {
    for(var i = 0; i < points.length; i++){
        var pt = points[i];
        context.lineTo(pt.x, pt.y);
    }
}
function $e815fda779bc047b$var$triangleBackcurve(context, points, controlPoint) {
    var firstPt;
    for(var i = 0; i < points.length; i++){
        var pt = points[i];
        if (i === 0) firstPt = pt;
        context.lineTo(pt.x, pt.y);
    }
    context.quadraticCurveTo(controlPoint.x, controlPoint.y, firstPt.x, firstPt.y);
}
function $e815fda779bc047b$var$triangleTee(context, trianglePoints, teePoints) {
    if (context.beginPath) context.beginPath();
    var triPts = trianglePoints;
    for(var i = 0; i < triPts.length; i++){
        var pt = triPts[i];
        context.lineTo(pt.x, pt.y);
    }
    var teePts = teePoints;
    var firstTeePt = teePoints[0];
    context.moveTo(firstTeePt.x, firstTeePt.y);
    for(var i = 1; i < teePts.length; i++){
        var pt = teePts[i];
        context.lineTo(pt.x, pt.y);
    }
    if (context.closePath) context.closePath();
}
function $e815fda779bc047b$var$circleTriangle(context, trianglePoints, rx, ry, r) {
    if (context.beginPath) context.beginPath();
    context.arc(rx, ry, r, 0, Math.PI * 2, false);
    var triPts = trianglePoints;
    var firstTrPt = triPts[0];
    context.moveTo(firstTrPt.x, firstTrPt.y);
    for(var i = 0; i < triPts.length; i++){
        var pt = triPts[i];
        context.lineTo(pt.x, pt.y);
    }
    if (context.closePath) context.closePath();
}
function $e815fda779bc047b$var$circle$1(context, rx, ry, r) {
    context.arc(rx, ry, r, 0, Math.PI * 2, false);
}
$e815fda779bc047b$var$CRp$b.arrowShapeImpl = function(name) {
    return ($e815fda779bc047b$var$impl || ($e815fda779bc047b$var$impl = {
        'polygon': $e815fda779bc047b$var$polygon,
        'triangle-backcurve': $e815fda779bc047b$var$triangleBackcurve,
        'triangle-tee': $e815fda779bc047b$var$triangleTee,
        'circle-triangle': $e815fda779bc047b$var$circleTriangle,
        'triangle-cross': $e815fda779bc047b$var$triangleTee,
        'circle': $e815fda779bc047b$var$circle$1
    }))[name];
};
var $e815fda779bc047b$var$CRp$a = {};
$e815fda779bc047b$var$CRp$a.drawElement = function(context, ele, shiftToOriginWithBb, showLabel, showOverlay, showOpacity) {
    var r = this;
    if (ele.isNode()) r.drawNode(context, ele, shiftToOriginWithBb, showLabel, showOverlay, showOpacity);
    else r.drawEdge(context, ele, shiftToOriginWithBb, showLabel, showOverlay, showOpacity);
};
$e815fda779bc047b$var$CRp$a.drawElementOverlay = function(context, ele) {
    var r = this;
    if (ele.isNode()) r.drawNodeOverlay(context, ele);
    else r.drawEdgeOverlay(context, ele);
};
$e815fda779bc047b$var$CRp$a.drawElementUnderlay = function(context, ele) {
    var r = this;
    if (ele.isNode()) r.drawNodeUnderlay(context, ele);
    else r.drawEdgeUnderlay(context, ele);
};
$e815fda779bc047b$var$CRp$a.drawCachedElementPortion = function(context, ele, eleTxrCache, pxRatio, lvl, reason, getRotation, getOpacity) {
    var r = this;
    var bb = eleTxrCache.getBoundingBox(ele);
    if (bb.w === 0 || bb.h === 0) return;
     // ignore zero size case
    var eleCache = eleTxrCache.getElement(ele, bb, pxRatio, lvl, reason);
    if (eleCache != null) {
        var opacity = getOpacity(r, ele);
        if (opacity === 0) return;
        var theta = getRotation(r, ele);
        var x1 = bb.x1, y1 = bb.y1, w = bb.w, h = bb.h;
        var x, y, sx, sy, smooth;
        if (theta !== 0) {
            var rotPt = eleTxrCache.getRotationPoint(ele);
            sx = rotPt.x;
            sy = rotPt.y;
            context.translate(sx, sy);
            context.rotate(theta);
            smooth = r.getImgSmoothing(context);
            if (!smooth) r.setImgSmoothing(context, true);
            var off = eleTxrCache.getRotationOffset(ele);
            x = off.x;
            y = off.y;
        } else {
            x = x1;
            y = y1;
        }
        var oldGlobalAlpha;
        if (opacity !== 1) {
            oldGlobalAlpha = context.globalAlpha;
            context.globalAlpha = oldGlobalAlpha * opacity;
        }
        context.drawImage(eleCache.texture.canvas, eleCache.x, 0, eleCache.width, eleCache.height, x, y, w, h);
        if (opacity !== 1) context.globalAlpha = oldGlobalAlpha;
        if (theta !== 0) {
            context.rotate(-theta);
            context.translate(-sx, -sy);
            if (!smooth) r.setImgSmoothing(context, false);
        }
    } else eleTxrCache.drawElement(context, ele); // direct draw fallback
};
var $e815fda779bc047b$var$getZeroRotation = function getZeroRotation() {
    return 0;
};
var $e815fda779bc047b$var$getLabelRotation = function getLabelRotation(r, ele) {
    return r.getTextAngle(ele, null);
};
var $e815fda779bc047b$var$getSourceLabelRotation = function getSourceLabelRotation(r, ele) {
    return r.getTextAngle(ele, 'source');
};
var $e815fda779bc047b$var$getTargetLabelRotation = function getTargetLabelRotation(r, ele) {
    return r.getTextAngle(ele, 'target');
};
var $e815fda779bc047b$var$getOpacity = function getOpacity(r, ele) {
    return ele.effectiveOpacity();
};
var $e815fda779bc047b$var$getTextOpacity = function getTextOpacity(e, ele) {
    return ele.pstyle('text-opacity').pfValue * ele.effectiveOpacity();
};
$e815fda779bc047b$var$CRp$a.drawCachedElement = function(context, ele, pxRatio, extent, lvl, requestHighQuality) {
    var r = this;
    var _r$data = r.data, eleTxrCache = _r$data.eleTxrCache, lblTxrCache = _r$data.lblTxrCache, slbTxrCache = _r$data.slbTxrCache, tlbTxrCache = _r$data.tlbTxrCache;
    var bb = ele.boundingBox();
    var reason = requestHighQuality === true ? eleTxrCache.reasons.highQuality : null;
    if (bb.w === 0 || bb.h === 0 || !ele.visible()) return;
    if (!extent || $e815fda779bc047b$var$boundingBoxesIntersect(bb, extent)) {
        var isEdge = ele.isEdge();
        var badLine = ele.element()._private.rscratch.badLine;
        r.drawElementUnderlay(context, ele);
        r.drawCachedElementPortion(context, ele, eleTxrCache, pxRatio, lvl, reason, $e815fda779bc047b$var$getZeroRotation, $e815fda779bc047b$var$getOpacity);
        if (!isEdge || !badLine) r.drawCachedElementPortion(context, ele, lblTxrCache, pxRatio, lvl, reason, $e815fda779bc047b$var$getLabelRotation, $e815fda779bc047b$var$getTextOpacity);
        if (isEdge && !badLine) {
            r.drawCachedElementPortion(context, ele, slbTxrCache, pxRatio, lvl, reason, $e815fda779bc047b$var$getSourceLabelRotation, $e815fda779bc047b$var$getTextOpacity);
            r.drawCachedElementPortion(context, ele, tlbTxrCache, pxRatio, lvl, reason, $e815fda779bc047b$var$getTargetLabelRotation, $e815fda779bc047b$var$getTextOpacity);
        }
        r.drawElementOverlay(context, ele);
    }
};
$e815fda779bc047b$var$CRp$a.drawElements = function(context, eles) {
    var r = this;
    for(var i = 0; i < eles.length; i++){
        var ele = eles[i];
        r.drawElement(context, ele);
    }
};
$e815fda779bc047b$var$CRp$a.drawCachedElements = function(context, eles, pxRatio, extent) {
    var r = this;
    for(var i = 0; i < eles.length; i++){
        var ele = eles[i];
        r.drawCachedElement(context, ele, pxRatio, extent);
    }
};
$e815fda779bc047b$var$CRp$a.drawCachedNodes = function(context, eles, pxRatio, extent) {
    var r = this;
    for(var i = 0; i < eles.length; i++){
        var ele = eles[i];
        if (!ele.isNode()) continue;
        r.drawCachedElement(context, ele, pxRatio, extent);
    }
};
$e815fda779bc047b$var$CRp$a.drawLayeredElements = function(context, eles, pxRatio, extent) {
    var r = this;
    var layers = r.data.lyrTxrCache.getLayers(eles, pxRatio);
    if (layers) for(var i = 0; i < layers.length; i++){
        var layer = layers[i];
        var bb = layer.bb;
        if (bb.w === 0 || bb.h === 0) continue;
        context.drawImage(layer.canvas, bb.x1, bb.y1, bb.w, bb.h);
    }
    else // fall back on plain caching if no layers
    r.drawCachedElements(context, eles, pxRatio, extent);
};
var $e815fda779bc047b$var$CRp$9 = {};
$e815fda779bc047b$var$CRp$9.drawEdge = function(context, edge, shiftToOriginWithBb) {
    var drawLabel = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var shouldDrawOverlay = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    var shouldDrawOpacity = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
    var r = this;
    var rs = edge._private.rscratch;
    if (shouldDrawOpacity && !edge.visible()) return;
    // if bezier ctrl pts can not be calculated, then die
    if (rs.badLine || rs.allpts == null || isNaN(rs.allpts[0])) // isNaN in case edge is impossible and browser bugs (e.g. safari)
    return;
    var bb;
    if (shiftToOriginWithBb) {
        bb = shiftToOriginWithBb;
        context.translate(-bb.x1, -bb.y1);
    }
    var opacity = shouldDrawOpacity ? edge.pstyle('opacity').value : 1;
    var lineOpacity = shouldDrawOpacity ? edge.pstyle('line-opacity').value : 1;
    var curveStyle = edge.pstyle('curve-style').value;
    var lineStyle = edge.pstyle('line-style').value;
    var edgeWidth = edge.pstyle('width').pfValue;
    var lineCap = edge.pstyle('line-cap').value;
    var lineOutlineWidth = edge.pstyle('line-outline-width').value;
    var lineOutlineColor = edge.pstyle('line-outline-color').value;
    var effectiveLineOpacity = opacity * lineOpacity;
    // separate arrow opacity would require arrow-opacity property
    var effectiveArrowOpacity = opacity * lineOpacity;
    var drawLine = function drawLine() {
        var strokeOpacity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : effectiveLineOpacity;
        if (curveStyle === 'straight-triangle') {
            r.eleStrokeStyle(context, edge, strokeOpacity);
            r.drawEdgeTrianglePath(edge, context, rs.allpts);
        } else {
            context.lineWidth = edgeWidth;
            context.lineCap = lineCap;
            r.eleStrokeStyle(context, edge, strokeOpacity);
            r.drawEdgePath(edge, context, rs.allpts, lineStyle);
            context.lineCap = 'butt'; // reset for other drawing functions
        }
    };
    var drawLineOutline = function drawLineOutline() {
        var strokeOpacity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : effectiveLineOpacity;
        context.lineWidth = edgeWidth + lineOutlineWidth;
        context.lineCap = lineCap;
        if (lineOutlineWidth > 0) r.colorStrokeStyle(context, lineOutlineColor[0], lineOutlineColor[1], lineOutlineColor[2], strokeOpacity);
        else {
            // do not draw any lineOutline
            context.lineCap = 'butt'; // reset for other drawing functions
            return;
        }
        if (curveStyle === 'straight-triangle') r.drawEdgeTrianglePath(edge, context, rs.allpts);
        else {
            r.drawEdgePath(edge, context, rs.allpts, lineStyle);
            context.lineCap = 'butt'; // reset for other drawing functions
        }
    };
    var drawOverlay = function drawOverlay() {
        if (!shouldDrawOverlay) return;
        r.drawEdgeOverlay(context, edge);
    };
    var drawUnderlay = function drawUnderlay() {
        if (!shouldDrawOverlay) return;
        r.drawEdgeUnderlay(context, edge);
    };
    var drawArrows = function drawArrows() {
        var arrowOpacity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : effectiveArrowOpacity;
        r.drawArrowheads(context, edge, arrowOpacity);
    };
    var drawText = function drawText() {
        r.drawElementText(context, edge, null, drawLabel);
    };
    context.lineJoin = 'round';
    var ghost = edge.pstyle('ghost').value === 'yes';
    if (ghost) {
        var gx = edge.pstyle('ghost-offset-x').pfValue;
        var gy = edge.pstyle('ghost-offset-y').pfValue;
        var ghostOpacity = edge.pstyle('ghost-opacity').value;
        var effectiveGhostOpacity = effectiveLineOpacity * ghostOpacity;
        context.translate(gx, gy);
        drawLine(effectiveGhostOpacity);
        drawArrows(effectiveGhostOpacity);
        context.translate(-gx, -gy);
    } else drawLineOutline();
    drawUnderlay();
    drawLine();
    drawArrows();
    drawOverlay();
    drawText();
    if (shiftToOriginWithBb) context.translate(bb.x1, bb.y1);
};
var $e815fda779bc047b$var$drawEdgeOverlayUnderlay = function drawEdgeOverlayUnderlay(overlayOrUnderlay) {
    if (![
        'overlay',
        'underlay'
    ].includes(overlayOrUnderlay)) throw new Error('Invalid state');
    return function(context, edge) {
        if (!edge.visible()) return;
        var opacity = edge.pstyle("".concat(overlayOrUnderlay, "-opacity")).value;
        if (opacity === 0) return;
        var r = this;
        var usePaths = r.usePaths();
        var rs = edge._private.rscratch;
        var padding = edge.pstyle("".concat(overlayOrUnderlay, "-padding")).pfValue;
        var width = 2 * padding;
        var color = edge.pstyle("".concat(overlayOrUnderlay, "-color")).value;
        context.lineWidth = width;
        if (rs.edgeType === 'self' && !usePaths) context.lineCap = 'butt';
        else context.lineCap = 'round';
        r.colorStrokeStyle(context, color[0], color[1], color[2], opacity);
        r.drawEdgePath(edge, context, rs.allpts, 'solid');
    };
};
$e815fda779bc047b$var$CRp$9.drawEdgeOverlay = $e815fda779bc047b$var$drawEdgeOverlayUnderlay('overlay');
$e815fda779bc047b$var$CRp$9.drawEdgeUnderlay = $e815fda779bc047b$var$drawEdgeOverlayUnderlay('underlay');
$e815fda779bc047b$var$CRp$9.drawEdgePath = function(edge, context, pts, type) {
    var rs = edge._private.rscratch;
    var canvasCxt = context;
    var path;
    var pathCacheHit = false;
    var usePaths = this.usePaths();
    var lineDashPattern = edge.pstyle('line-dash-pattern').pfValue;
    var lineDashOffset = edge.pstyle('line-dash-offset').pfValue;
    if (usePaths) {
        var pathCacheKey = pts.join('$');
        var keyMatches = rs.pathCacheKey && rs.pathCacheKey === pathCacheKey;
        if (keyMatches) {
            path = context = rs.pathCache;
            pathCacheHit = true;
        } else {
            path = context = new Path2D();
            rs.pathCacheKey = pathCacheKey;
            rs.pathCache = path;
        }
    }
    if (canvasCxt.setLineDash) // for very outofdate browsers
    switch(type){
        case 'dotted':
            canvasCxt.setLineDash([
                1,
                1
            ]);
            break;
        case 'dashed':
            canvasCxt.setLineDash(lineDashPattern);
            canvasCxt.lineDashOffset = lineDashOffset;
            break;
        case 'solid':
            canvasCxt.setLineDash([]);
            break;
    }
    if (!pathCacheHit && !rs.badLine) {
        if (context.beginPath) context.beginPath();
        context.moveTo(pts[0], pts[1]);
        switch(rs.edgeType){
            case 'bezier':
            case 'self':
            case 'compound':
            case 'multibezier':
                for(var i = 2; i + 3 < pts.length; i += 4)context.quadraticCurveTo(pts[i], pts[i + 1], pts[i + 2], pts[i + 3]);
                break;
            case 'straight':
            case 'haystack':
                for(var _i = 2; _i + 1 < pts.length; _i += 2)context.lineTo(pts[_i], pts[_i + 1]);
                break;
            case 'segments':
                if (rs.isRound) {
                    var _iterator = $e815fda779bc047b$var$_createForOfIteratorHelper(rs.roundCorners), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var corner = _step.value;
                            $e815fda779bc047b$var$drawPreparedRoundCorner(context, corner);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                    context.lineTo(pts[pts.length - 2], pts[pts.length - 1]);
                } else for(var _i2 = 2; _i2 + 1 < pts.length; _i2 += 2)context.lineTo(pts[_i2], pts[_i2 + 1]);
                break;
        }
    }
    context = canvasCxt;
    if (usePaths) context.stroke(path);
    else context.stroke();
    // reset any line dashes
    if (context.setLineDash) // for very outofdate browsers
    context.setLineDash([]);
};
$e815fda779bc047b$var$CRp$9.drawEdgeTrianglePath = function(edge, context, pts) {
    // use line stroke style for triangle fill style
    context.fillStyle = context.strokeStyle;
    var edgeWidth = edge.pstyle('width').pfValue;
    for(var i = 0; i + 1 < pts.length; i += 2){
        var vector = [
            pts[i + 2] - pts[i],
            pts[i + 3] - pts[i + 1]
        ];
        var length = Math.sqrt(vector[0] * vector[0] + vector[1] * vector[1]);
        var normal = [
            vector[1] / length,
            -vector[0] / length
        ];
        var triangleHead = [
            normal[0] * edgeWidth / 2,
            normal[1] * edgeWidth / 2
        ];
        context.beginPath();
        context.moveTo(pts[i] - triangleHead[0], pts[i + 1] - triangleHead[1]);
        context.lineTo(pts[i] + triangleHead[0], pts[i + 1] + triangleHead[1]);
        context.lineTo(pts[i + 2], pts[i + 3]);
        context.closePath();
        context.fill();
    }
};
$e815fda779bc047b$var$CRp$9.drawArrowheads = function(context, edge, opacity) {
    var rs = edge._private.rscratch;
    var isHaystack = rs.edgeType === 'haystack';
    if (!isHaystack) this.drawArrowhead(context, edge, 'source', rs.arrowStartX, rs.arrowStartY, rs.srcArrowAngle, opacity);
    this.drawArrowhead(context, edge, 'mid-target', rs.midX, rs.midY, rs.midtgtArrowAngle, opacity);
    this.drawArrowhead(context, edge, 'mid-source', rs.midX, rs.midY, rs.midsrcArrowAngle, opacity);
    if (!isHaystack) this.drawArrowhead(context, edge, 'target', rs.arrowEndX, rs.arrowEndY, rs.tgtArrowAngle, opacity);
};
$e815fda779bc047b$var$CRp$9.drawArrowhead = function(context, edge, prefix, x, y, angle, opacity) {
    if (isNaN(x) || x == null || isNaN(y) || y == null || isNaN(angle) || angle == null) return;
    var self1 = this;
    var arrowShape = edge.pstyle(prefix + '-arrow-shape').value;
    if (arrowShape === 'none') return;
    var arrowClearFill = edge.pstyle(prefix + '-arrow-fill').value === 'hollow' ? 'both' : 'filled';
    var arrowFill = edge.pstyle(prefix + '-arrow-fill').value;
    var edgeWidth = edge.pstyle('width').pfValue;
    var pArrowWidth = edge.pstyle(prefix + '-arrow-width');
    var arrowWidth = pArrowWidth.value === 'match-line' ? edgeWidth : pArrowWidth.pfValue;
    if (pArrowWidth.units === '%') arrowWidth *= edgeWidth;
    var edgeOpacity = edge.pstyle('opacity').value;
    if (opacity === undefined) opacity = edgeOpacity;
    var gco = context.globalCompositeOperation;
    if (opacity !== 1 || arrowFill === 'hollow') {
        // then extra clear is needed
        context.globalCompositeOperation = 'destination-out';
        self1.colorFillStyle(context, 255, 255, 255, 1);
        self1.colorStrokeStyle(context, 255, 255, 255, 1);
        self1.drawArrowShape(edge, context, arrowClearFill, edgeWidth, arrowShape, arrowWidth, x, y, angle);
        context.globalCompositeOperation = gco;
    } // otherwise, the opaque arrow clears it for free :)
    var color = edge.pstyle(prefix + '-arrow-color').value;
    self1.colorFillStyle(context, color[0], color[1], color[2], opacity);
    self1.colorStrokeStyle(context, color[0], color[1], color[2], opacity);
    self1.drawArrowShape(edge, context, arrowFill, edgeWidth, arrowShape, arrowWidth, x, y, angle);
};
$e815fda779bc047b$var$CRp$9.drawArrowShape = function(edge, context, fill, edgeWidth, shape, shapeWidth, x, y, angle) {
    var r = this;
    var usePaths = this.usePaths() && shape !== 'triangle-cross';
    var pathCacheHit = false;
    var path;
    var canvasContext = context;
    var translation = {
        x: x,
        y: y
    };
    var scale = edge.pstyle('arrow-scale').value;
    var size = this.getArrowWidth(edgeWidth, scale);
    var shapeImpl = r.arrowShapes[shape];
    if (usePaths) {
        var cache = r.arrowPathCache = r.arrowPathCache || [];
        var key = $e815fda779bc047b$var$hashString(shape);
        var cachedPath = cache[key];
        if (cachedPath != null) {
            path = context = cachedPath;
            pathCacheHit = true;
        } else {
            path = context = new Path2D();
            cache[key] = path;
        }
    }
    if (!pathCacheHit) {
        if (context.beginPath) context.beginPath();
        if (usePaths) // store in the path cache with values easily manipulated later
        shapeImpl.draw(context, 1, 0, {
            x: 0,
            y: 0
        }, 1);
        else shapeImpl.draw(context, size, angle, translation, edgeWidth);
        if (context.closePath) context.closePath();
    }
    context = canvasContext;
    if (usePaths) {
        // set transform to arrow position/orientation
        context.translate(x, y);
        context.rotate(angle);
        context.scale(size, size);
    }
    if (fill === 'filled' || fill === 'both') {
        if (usePaths) context.fill(path);
        else context.fill();
    }
    if (fill === 'hollow' || fill === 'both') {
        context.lineWidth = shapeWidth / (usePaths ? size : 1);
        context.lineJoin = 'miter';
        if (usePaths) context.stroke(path);
        else context.stroke();
    }
    if (usePaths) {
        // reset transform by applying inverse
        context.scale(1 / size, 1 / size);
        context.rotate(-angle);
        context.translate(-x, -y);
    }
};
var $e815fda779bc047b$var$CRp$8 = {};
$e815fda779bc047b$var$CRp$8.safeDrawImage = function(context, img, ix, iy, iw, ih, x, y, w, h) {
    // detect problematic cases for old browsers with bad images (cheaper than try-catch)
    if (iw <= 0 || ih <= 0 || w <= 0 || h <= 0) return;
    try {
        context.drawImage(img, ix, iy, iw, ih, x, y, w, h);
    } catch (e) {
        $e815fda779bc047b$var$warn(e);
    }
};
$e815fda779bc047b$var$CRp$8.drawInscribedImage = function(context, img, node, index, nodeOpacity) {
    var r = this;
    var pos = node.position();
    var nodeX = pos.x;
    var nodeY = pos.y;
    var styleObj = node.cy().style();
    var getIndexedStyle = styleObj.getIndexedStyle.bind(styleObj);
    var fit = getIndexedStyle(node, 'background-fit', 'value', index);
    var repeat = getIndexedStyle(node, 'background-repeat', 'value', index);
    var nodeW = node.width();
    var nodeH = node.height();
    var paddingX2 = node.padding() * 2;
    var nodeTW = nodeW + (getIndexedStyle(node, 'background-width-relative-to', 'value', index) === 'inner' ? 0 : paddingX2);
    var nodeTH = nodeH + (getIndexedStyle(node, 'background-height-relative-to', 'value', index) === 'inner' ? 0 : paddingX2);
    var rs = node._private.rscratch;
    var clip = getIndexedStyle(node, 'background-clip', 'value', index);
    var shouldClip = clip === 'node';
    var imgOpacity = getIndexedStyle(node, 'background-image-opacity', 'value', index) * nodeOpacity;
    var smooth = getIndexedStyle(node, 'background-image-smoothing', 'value', index);
    var cornerRadius = node.pstyle('corner-radius').value;
    if (cornerRadius !== 'auto') cornerRadius = node.pstyle('corner-radius').pfValue;
    var imgW = img.width || img.cachedW;
    var imgH = img.height || img.cachedH;
    // workaround for broken browsers like ie
    if (null == imgW || null == imgH) {
        document.body.appendChild(img); // eslint-disable-line no-undef
        imgW = img.cachedW = img.width || img.offsetWidth;
        imgH = img.cachedH = img.height || img.offsetHeight;
        document.body.removeChild(img); // eslint-disable-line no-undef
    }
    var w = imgW;
    var h = imgH;
    if (getIndexedStyle(node, 'background-width', 'value', index) !== 'auto') {
        if (getIndexedStyle(node, 'background-width', 'units', index) === '%') w = getIndexedStyle(node, 'background-width', 'pfValue', index) * nodeTW;
        else w = getIndexedStyle(node, 'background-width', 'pfValue', index);
    }
    if (getIndexedStyle(node, 'background-height', 'value', index) !== 'auto') {
        if (getIndexedStyle(node, 'background-height', 'units', index) === '%') h = getIndexedStyle(node, 'background-height', 'pfValue', index) * nodeTH;
        else h = getIndexedStyle(node, 'background-height', 'pfValue', index);
    }
    if (w === 0 || h === 0) return; // no point in drawing empty image (and chrome is broken in this case)
    if (fit === 'contain') {
        var scale = Math.min(nodeTW / w, nodeTH / h);
        w *= scale;
        h *= scale;
    } else if (fit === 'cover') {
        var scale = Math.max(nodeTW / w, nodeTH / h);
        w *= scale;
        h *= scale;
    }
    var x = nodeX - nodeTW / 2; // left
    var posXUnits = getIndexedStyle(node, 'background-position-x', 'units', index);
    var posXPfVal = getIndexedStyle(node, 'background-position-x', 'pfValue', index);
    if (posXUnits === '%') x += (nodeTW - w) * posXPfVal;
    else x += posXPfVal;
    var offXUnits = getIndexedStyle(node, 'background-offset-x', 'units', index);
    var offXPfVal = getIndexedStyle(node, 'background-offset-x', 'pfValue', index);
    if (offXUnits === '%') x += (nodeTW - w) * offXPfVal;
    else x += offXPfVal;
    var y = nodeY - nodeTH / 2; // top
    var posYUnits = getIndexedStyle(node, 'background-position-y', 'units', index);
    var posYPfVal = getIndexedStyle(node, 'background-position-y', 'pfValue', index);
    if (posYUnits === '%') y += (nodeTH - h) * posYPfVal;
    else y += posYPfVal;
    var offYUnits = getIndexedStyle(node, 'background-offset-y', 'units', index);
    var offYPfVal = getIndexedStyle(node, 'background-offset-y', 'pfValue', index);
    if (offYUnits === '%') y += (nodeTH - h) * offYPfVal;
    else y += offYPfVal;
    if (rs.pathCache) {
        x -= nodeX;
        y -= nodeY;
        nodeX = 0;
        nodeY = 0;
    }
    var gAlpha = context.globalAlpha;
    context.globalAlpha = imgOpacity;
    var smoothingEnabled = r.getImgSmoothing(context);
    var isSmoothingSwitched = false;
    if (smooth === 'no' && smoothingEnabled) {
        r.setImgSmoothing(context, false);
        isSmoothingSwitched = true;
    } else if (smooth === 'yes' && !smoothingEnabled) {
        r.setImgSmoothing(context, true);
        isSmoothingSwitched = true;
    }
    if (repeat === 'no-repeat') {
        if (shouldClip) {
            context.save();
            if (rs.pathCache) context.clip(rs.pathCache);
            else {
                r.nodeShapes[r.getNodeShape(node)].draw(context, nodeX, nodeY, nodeTW, nodeTH, cornerRadius, rs);
                context.clip();
            }
        }
        r.safeDrawImage(context, img, 0, 0, imgW, imgH, x, y, w, h);
        if (shouldClip) context.restore();
    } else {
        var pattern = context.createPattern(img, repeat);
        context.fillStyle = pattern;
        r.nodeShapes[r.getNodeShape(node)].draw(context, nodeX, nodeY, nodeTW, nodeTH, cornerRadius, rs);
        context.translate(x, y);
        context.fill();
        context.translate(-x, -y);
    }
    context.globalAlpha = gAlpha;
    if (isSmoothingSwitched) r.setImgSmoothing(context, smoothingEnabled);
};
var $e815fda779bc047b$var$CRp$7 = {};
$e815fda779bc047b$var$CRp$7.eleTextBiggerThanMin = function(ele, scale) {
    if (!scale) {
        var zoom = ele.cy().zoom();
        var pxRatio = this.getPixelRatio();
        var lvl = Math.ceil($e815fda779bc047b$var$log2(zoom * pxRatio)); // the effective texture level
        scale = Math.pow(2, lvl);
    }
    var computedSize = ele.pstyle('font-size').pfValue * scale;
    var minSize = ele.pstyle('min-zoomed-font-size').pfValue;
    if (computedSize < minSize) return false;
    return true;
};
$e815fda779bc047b$var$CRp$7.drawElementText = function(context, ele, shiftToOriginWithBb, force, prefix) {
    var useEleOpacity = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
    var r = this;
    if (force == null) {
        if (useEleOpacity && !r.eleTextBiggerThanMin(ele)) return;
    } else if (force === false) return;
    if (ele.isNode()) {
        var label = ele.pstyle('label');
        if (!label || !label.value) return;
        var justification = r.getLabelJustification(ele);
        context.textAlign = justification;
        context.textBaseline = 'bottom';
    } else {
        var badLine = ele.element()._private.rscratch.badLine;
        var _label = ele.pstyle('label');
        var srcLabel = ele.pstyle('source-label');
        var tgtLabel = ele.pstyle('target-label');
        if (badLine || (!_label || !_label.value) && (!srcLabel || !srcLabel.value) && (!tgtLabel || !tgtLabel.value)) return;
        context.textAlign = 'center';
        context.textBaseline = 'bottom';
    }
    var applyRotation = !shiftToOriginWithBb;
    var bb;
    if (shiftToOriginWithBb) {
        bb = shiftToOriginWithBb;
        context.translate(-bb.x1, -bb.y1);
    }
    if (prefix == null) {
        r.drawText(context, ele, null, applyRotation, useEleOpacity);
        if (ele.isEdge()) {
            r.drawText(context, ele, 'source', applyRotation, useEleOpacity);
            r.drawText(context, ele, 'target', applyRotation, useEleOpacity);
        }
    } else r.drawText(context, ele, prefix, applyRotation, useEleOpacity);
    if (shiftToOriginWithBb) context.translate(bb.x1, bb.y1);
};
$e815fda779bc047b$var$CRp$7.getFontCache = function(context) {
    var cache;
    this.fontCaches = this.fontCaches || [];
    for(var i = 0; i < this.fontCaches.length; i++){
        cache = this.fontCaches[i];
        if (cache.context === context) return cache;
    }
    cache = {
        context: context
    };
    this.fontCaches.push(cache);
    return cache;
};
// set up canvas context with font
// returns transformed text string
$e815fda779bc047b$var$CRp$7.setupTextStyle = function(context, ele) {
    var useEleOpacity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // Font style
    var labelStyle = ele.pstyle('font-style').strValue;
    var labelSize = ele.pstyle('font-size').pfValue + 'px';
    var labelFamily = ele.pstyle('font-family').strValue;
    var labelWeight = ele.pstyle('font-weight').strValue;
    var opacity = useEleOpacity ? ele.effectiveOpacity() * ele.pstyle('text-opacity').value : 1;
    var outlineOpacity = ele.pstyle('text-outline-opacity').value * opacity;
    var color = ele.pstyle('color').value;
    var outlineColor = ele.pstyle('text-outline-color').value;
    context.font = labelStyle + ' ' + labelWeight + ' ' + labelSize + ' ' + labelFamily;
    context.lineJoin = 'round'; // so text outlines aren't jagged
    this.colorFillStyle(context, color[0], color[1], color[2], opacity);
    this.colorStrokeStyle(context, outlineColor[0], outlineColor[1], outlineColor[2], outlineOpacity);
};
function $e815fda779bc047b$var$circle(ctx, x, y, width, height) {
    var diameter = Math.min(width, height);
    var radius = diameter / 2;
    var centerX = x + width / 2;
    var centerY = y + height / 2;
    ctx.beginPath();
    ctx.arc(centerX, centerY, radius, 0, Math.PI * 2);
    ctx.closePath();
}
function $e815fda779bc047b$var$roundRect(ctx, x, y, width, height) {
    var radius = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 5;
    var r = Math.min(radius, width / 2, height / 2); // prevent overflow
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.lineTo(x + width - r, y);
    ctx.quadraticCurveTo(x + width, y, x + width, y + r);
    ctx.lineTo(x + width, y + height - r);
    ctx.quadraticCurveTo(x + width, y + height, x + width - r, y + height);
    ctx.lineTo(x + r, y + height);
    ctx.quadraticCurveTo(x, y + height, x, y + height - r);
    ctx.lineTo(x, y + r);
    ctx.quadraticCurveTo(x, y, x + r, y);
    ctx.closePath();
}
$e815fda779bc047b$var$CRp$7.getTextAngle = function(ele, prefix) {
    var theta;
    var _p = ele._private;
    var rscratch = _p.rscratch;
    var pdash = prefix ? prefix + '-' : '';
    var rotation = ele.pstyle(pdash + 'text-rotation');
    if (rotation.strValue === 'autorotate') {
        var textAngle = $e815fda779bc047b$var$getPrefixedProperty(rscratch, 'labelAngle', prefix);
        theta = ele.isEdge() ? textAngle : 0;
    } else if (rotation.strValue === 'none') theta = 0;
    else theta = rotation.pfValue;
    return theta;
};
$e815fda779bc047b$var$CRp$7.drawText = function(context, ele, prefix) {
    var applyRotation = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var useEleOpacity = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    var _p = ele._private;
    var rscratch = _p.rscratch;
    var parentOpacity = useEleOpacity ? ele.effectiveOpacity() : 1;
    if (useEleOpacity && (parentOpacity === 0 || ele.pstyle('text-opacity').value === 0)) return;
    // use 'main' as an alias for the main label (i.e. null prefix)
    if (prefix === 'main') prefix = null;
    var textX = $e815fda779bc047b$var$getPrefixedProperty(rscratch, 'labelX', prefix);
    var textY = $e815fda779bc047b$var$getPrefixedProperty(rscratch, 'labelY', prefix);
    var orgTextX, orgTextY; // used for rotation
    var text = this.getLabelText(ele, prefix);
    if (text != null && text !== '' && !isNaN(textX) && !isNaN(textY)) {
        this.setupTextStyle(context, ele, useEleOpacity);
        var pdash = prefix ? prefix + '-' : '';
        var textW = $e815fda779bc047b$var$getPrefixedProperty(rscratch, 'labelWidth', prefix);
        var textH = $e815fda779bc047b$var$getPrefixedProperty(rscratch, 'labelHeight', prefix);
        var marginX = ele.pstyle(pdash + 'text-margin-x').pfValue;
        var marginY = ele.pstyle(pdash + 'text-margin-y').pfValue;
        var isEdge = ele.isEdge();
        var halign = ele.pstyle('text-halign').value;
        var valign = ele.pstyle('text-valign').value;
        if (isEdge) {
            halign = 'center';
            valign = 'center';
        }
        textX += marginX;
        textY += marginY;
        var theta;
        if (!applyRotation) theta = 0;
        else theta = this.getTextAngle(ele, prefix);
        if (theta !== 0) {
            orgTextX = textX;
            orgTextY = textY;
            context.translate(orgTextX, orgTextY);
            context.rotate(theta);
            textX = 0;
            textY = 0;
        }
        switch(valign){
            case 'top':
                break;
            case 'center':
                textY += textH / 2;
                break;
            case 'bottom':
                textY += textH;
                break;
        }
        var backgroundOpacity = ele.pstyle('text-background-opacity').value;
        var borderOpacity = ele.pstyle('text-border-opacity').value;
        var textBorderWidth = ele.pstyle('text-border-width').pfValue;
        var backgroundPadding = ele.pstyle('text-background-padding').pfValue;
        var styleShape = ele.pstyle('text-background-shape').strValue;
        var rounded = styleShape === 'round-rectangle' || styleShape === 'roundrectangle';
        var circled = styleShape === 'circle';
        var roundRadius = 2;
        if (backgroundOpacity > 0 || textBorderWidth > 0 && borderOpacity > 0) {
            var textFill = context.fillStyle;
            var textStroke = context.strokeStyle;
            var textLineWidth = context.lineWidth;
            var textBackgroundColor = ele.pstyle('text-background-color').value;
            var textBorderColor = ele.pstyle('text-border-color').value;
            var textBorderStyle = ele.pstyle('text-border-style').value;
            var doFill = backgroundOpacity > 0;
            var doStroke = textBorderWidth > 0 && borderOpacity > 0;
            var bgX = textX - backgroundPadding;
            switch(halign){
                case 'left':
                    bgX -= textW;
                    break;
                case 'center':
                    bgX -= textW / 2;
                    break;
            }
            var bgY = textY - textH - backgroundPadding;
            var bgW = textW + 2 * backgroundPadding;
            var bgH = textH + 2 * backgroundPadding;
            if (doFill) context.fillStyle = "rgba(".concat(textBackgroundColor[0], ",").concat(textBackgroundColor[1], ",").concat(textBackgroundColor[2], ",").concat(backgroundOpacity * parentOpacity, ")");
            if (doStroke) {
                context.strokeStyle = "rgba(".concat(textBorderColor[0], ",").concat(textBorderColor[1], ",").concat(textBorderColor[2], ",").concat(borderOpacity * parentOpacity, ")");
                context.lineWidth = textBorderWidth;
                if (context.setLineDash) switch(textBorderStyle){
                    case 'dotted':
                        context.setLineDash([
                            1,
                            1
                        ]);
                        break;
                    case 'dashed':
                        context.setLineDash([
                            4,
                            2
                        ]);
                        break;
                    case 'double':
                        context.lineWidth = textBorderWidth / 4;
                        context.setLineDash([]);
                        break;
                    case 'solid':
                    default:
                        context.setLineDash([]);
                        break;
                }
            }
            if (rounded) {
                context.beginPath();
                $e815fda779bc047b$var$roundRect(context, bgX, bgY, bgW, bgH, roundRadius);
            } else if (circled) {
                context.beginPath();
                $e815fda779bc047b$var$circle(context, bgX, bgY, bgW, bgH);
            } else {
                context.beginPath();
                context.rect(bgX, bgY, bgW, bgH);
            }
            if (doFill) context.fill();
            if (doStroke) context.stroke();
            // Double border pass for 'double' style
            if (doStroke && textBorderStyle === 'double') {
                var whiteWidth = textBorderWidth / 2;
                context.beginPath();
                if (rounded) $e815fda779bc047b$var$roundRect(context, bgX + whiteWidth, bgY + whiteWidth, bgW - 2 * whiteWidth, bgH - 2 * whiteWidth, roundRadius);
                else context.rect(bgX + whiteWidth, bgY + whiteWidth, bgW - 2 * whiteWidth, bgH - 2 * whiteWidth);
                context.stroke();
            }
            context.fillStyle = textFill;
            context.strokeStyle = textStroke;
            context.lineWidth = textLineWidth;
            if (context.setLineDash) context.setLineDash([]);
        }
        var lineWidth = 2 * ele.pstyle('text-outline-width').pfValue; // *2 b/c the stroke is drawn centred on the middle
        if (lineWidth > 0) context.lineWidth = lineWidth;
        if (ele.pstyle('text-wrap').value === 'wrap') {
            var lines = $e815fda779bc047b$var$getPrefixedProperty(rscratch, 'labelWrapCachedLines', prefix);
            var lineHeight = $e815fda779bc047b$var$getPrefixedProperty(rscratch, 'labelLineHeight', prefix);
            var halfTextW = textW / 2;
            var justification = this.getLabelJustification(ele);
            if (justification === 'auto') ;
            else if (halign === 'left') {
                // auto justification : right
                if (justification === 'left') textX += -textW;
                else if (justification === 'center') textX += -halfTextW;
                 // else same as auto
            } else if (halign === 'center') {
                // auto justfication : center
                if (justification === 'left') textX += -halfTextW;
                else if (justification === 'right') textX += halfTextW;
                 // else same as auto
            } else if (halign === 'right') {
                // auto justification : left
                if (justification === 'center') textX += halfTextW;
                else if (justification === 'right') textX += textW;
                 // else same as auto
            }
            switch(valign){
                case 'top':
                    textY -= (lines.length - 1) * lineHeight;
                    break;
                case 'center':
                case 'bottom':
                    textY -= (lines.length - 1) * lineHeight;
                    break;
            }
            for(var l = 0; l < lines.length; l++){
                if (lineWidth > 0) context.strokeText(lines[l], textX, textY);
                context.fillText(lines[l], textX, textY);
                textY += lineHeight;
            }
        } else {
            if (lineWidth > 0) context.strokeText(text, textX, textY);
            context.fillText(text, textX, textY);
        }
        if (theta !== 0) {
            context.rotate(-theta);
            context.translate(-orgTextX, -orgTextY);
        }
    }
};
/* global Path2D */ var $e815fda779bc047b$var$CRp$6 = {};
$e815fda779bc047b$var$CRp$6.drawNode = function(context, node, shiftToOriginWithBb) {
    var drawLabel = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var shouldDrawOverlay = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    var shouldDrawOpacity = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
    var r = this;
    var nodeWidth, nodeHeight;
    var _p = node._private;
    var rs = _p.rscratch;
    var pos = node.position();
    if (!$e815fda779bc047b$var$number$1(pos.x) || !$e815fda779bc047b$var$number$1(pos.y)) return; // can't draw node with undefined position
    if (shouldDrawOpacity && !node.visible()) return;
    var eleOpacity = shouldDrawOpacity ? node.effectiveOpacity() : 1;
    var usePaths = r.usePaths();
    var path;
    var pathCacheHit = false;
    var padding = node.padding();
    nodeWidth = node.width() + 2 * padding;
    nodeHeight = node.height() + 2 * padding;
    //
    // setup shift
    var bb;
    if (shiftToOriginWithBb) {
        bb = shiftToOriginWithBb;
        context.translate(-bb.x1, -bb.y1);
    }
    //
    // load bg image
    var bgImgProp = node.pstyle('background-image');
    var urls = bgImgProp.value;
    var urlDefined = new Array(urls.length);
    var image = new Array(urls.length);
    var numImages = 0;
    for(var i = 0; i < urls.length; i++){
        var url = urls[i];
        var defd = urlDefined[i] = url != null && url !== 'none';
        if (defd) {
            var bgImgCrossOrigin = node.cy().style().getIndexedStyle(node, 'background-image-crossorigin', 'value', i);
            numImages++;
            // get image, and if not loaded then ask to redraw when later loaded
            image[i] = r.getCachedImage(url, bgImgCrossOrigin, function() {
                _p.backgroundTimestamp = Date.now();
                node.emitAndNotify('background');
            });
        }
    }
    //
    // setup styles
    var darkness = node.pstyle('background-blacken').value;
    var borderWidth = node.pstyle('border-width').pfValue;
    var bgOpacity = node.pstyle('background-opacity').value * eleOpacity;
    var borderColor = node.pstyle('border-color').value;
    var borderStyle = node.pstyle('border-style').value;
    var borderJoin = node.pstyle('border-join').value;
    var borderCap = node.pstyle('border-cap').value;
    var borderPosition = node.pstyle('border-position').value;
    var borderPattern = node.pstyle('border-dash-pattern').pfValue;
    var borderOffset = node.pstyle('border-dash-offset').pfValue;
    var borderOpacity = node.pstyle('border-opacity').value * eleOpacity;
    var outlineWidth = node.pstyle('outline-width').pfValue;
    var outlineColor = node.pstyle('outline-color').value;
    var outlineStyle = node.pstyle('outline-style').value;
    var outlineOpacity = node.pstyle('outline-opacity').value * eleOpacity;
    var outlineOffset = node.pstyle('outline-offset').value;
    var cornerRadius = node.pstyle('corner-radius').value;
    if (cornerRadius !== 'auto') cornerRadius = node.pstyle('corner-radius').pfValue;
    var setupShapeColor = function setupShapeColor() {
        var bgOpy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : bgOpacity;
        r.eleFillStyle(context, node, bgOpy);
    };
    var setupBorderColor = function setupBorderColor() {
        var bdrOpy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : borderOpacity;
        r.colorStrokeStyle(context, borderColor[0], borderColor[1], borderColor[2], bdrOpy);
    };
    var setupOutlineColor = function setupOutlineColor() {
        var otlnOpy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : outlineOpacity;
        r.colorStrokeStyle(context, outlineColor[0], outlineColor[1], outlineColor[2], otlnOpy);
    };
    //
    // setup shape
    var getPath = function getPath(width, height, shape, points) {
        var pathCache = r.nodePathCache = r.nodePathCache || [];
        var key = $e815fda779bc047b$var$hashStrings(shape === 'polygon' ? shape + ',' + points.join(',') : shape, '' + height, '' + width, '' + cornerRadius);
        var cachedPath = pathCache[key];
        var path;
        var cacheHit = false;
        if (cachedPath != null) {
            path = cachedPath;
            cacheHit = true;
            rs.pathCache = path;
        } else {
            path = new Path2D();
            pathCache[key] = rs.pathCache = path;
        }
        return {
            path: path,
            cacheHit: cacheHit
        };
    };
    var styleShape = node.pstyle('shape').strValue;
    var shapePts = node.pstyle('shape-polygon-points').pfValue;
    if (usePaths) {
        context.translate(pos.x, pos.y);
        var shapePath = getPath(nodeWidth, nodeHeight, styleShape, shapePts);
        path = shapePath.path;
        pathCacheHit = shapePath.cacheHit;
    }
    var drawShape = function drawShape() {
        if (!pathCacheHit) {
            var npos = pos;
            if (usePaths) npos = {
                x: 0,
                y: 0
            };
            r.nodeShapes[r.getNodeShape(node)].draw(path || context, npos.x, npos.y, nodeWidth, nodeHeight, cornerRadius, rs);
        }
        if (usePaths) context.fill(path);
        else context.fill();
    };
    var drawImages = function drawImages() {
        var nodeOpacity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : eleOpacity;
        var inside = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        var prevBging = _p.backgrounding;
        var totalCompleted = 0;
        for(var _i = 0; _i < image.length; _i++){
            var bgContainment = node.cy().style().getIndexedStyle(node, 'background-image-containment', 'value', _i);
            if (inside && bgContainment === 'over' || !inside && bgContainment === 'inside') {
                totalCompleted++;
                continue;
            }
            if (urlDefined[_i] && image[_i].complete && !image[_i].error) {
                totalCompleted++;
                r.drawInscribedImage(context, image[_i], node, _i, nodeOpacity);
            }
        }
        _p.backgrounding = !(totalCompleted === numImages);
        if (prevBging !== _p.backgrounding) // update style b/c :backgrounding state changed
        node.updateStyle(false);
    };
    var drawPie = function drawPie() {
        var redrawShape = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var pieOpacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : eleOpacity;
        if (r.hasPie(node)) {
            r.drawPie(context, node, pieOpacity);
            // redraw/restore path if steps after pie need it
            if (redrawShape) {
                if (!usePaths) r.nodeShapes[r.getNodeShape(node)].draw(context, pos.x, pos.y, nodeWidth, nodeHeight, cornerRadius, rs);
            }
        }
    };
    var drawStripe = function drawStripe() {
        var redrawShape = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var stripeOpacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : eleOpacity;
        if (r.hasStripe(node)) {
            context.save();
            if (usePaths) context.clip(rs.pathCache);
            else {
                r.nodeShapes[r.getNodeShape(node)].draw(context, pos.x, pos.y, nodeWidth, nodeHeight, cornerRadius, rs);
                context.clip();
            }
            r.drawStripe(context, node, stripeOpacity);
            context.restore();
            // redraw/restore path if steps after stripes need it
            if (redrawShape) {
                if (!usePaths) r.nodeShapes[r.getNodeShape(node)].draw(context, pos.x, pos.y, nodeWidth, nodeHeight, cornerRadius, rs);
            }
        }
    };
    var darken = function darken() {
        var darkenOpacity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : eleOpacity;
        var opacity = (darkness > 0 ? darkness : -darkness) * darkenOpacity;
        var c = darkness > 0 ? 0 : 255;
        if (darkness !== 0) {
            r.colorFillStyle(context, c, c, c, opacity);
            if (usePaths) context.fill(path);
            else context.fill();
        }
    };
    var drawBorder = function drawBorder() {
        if (borderWidth > 0) {
            context.lineWidth = borderWidth;
            context.lineCap = borderCap;
            context.lineJoin = borderJoin;
            if (context.setLineDash) // for very outofdate browsers
            switch(borderStyle){
                case 'dotted':
                    context.setLineDash([
                        1,
                        1
                    ]);
                    break;
                case 'dashed':
                    context.setLineDash(borderPattern);
                    context.lineDashOffset = borderOffset;
                    break;
                case 'solid':
                case 'double':
                    context.setLineDash([]);
                    break;
            }
            if (borderPosition !== 'center') {
                context.save();
                context.lineWidth *= 2;
                if (borderPosition === 'inside') usePaths ? context.clip(path) : context.clip();
                else {
                    var region = new Path2D();
                    region.rect(-nodeWidth / 2 - borderWidth, -nodeHeight / 2 - borderWidth, nodeWidth + 2 * borderWidth, nodeHeight + 2 * borderWidth);
                    region.addPath(path);
                    context.clip(region, 'evenodd');
                }
                usePaths ? context.stroke(path) : context.stroke();
                context.restore();
            } else usePaths ? context.stroke(path) : context.stroke();
            if (borderStyle === 'double') {
                context.lineWidth = borderWidth / 3;
                var gco = context.globalCompositeOperation;
                context.globalCompositeOperation = 'destination-out';
                if (usePaths) context.stroke(path);
                else context.stroke();
                context.globalCompositeOperation = gco;
            }
            // reset in case we changed the border style
            if (context.setLineDash) // for very outofdate browsers
            context.setLineDash([]);
        }
    };
    var drawOutline = function drawOutline() {
        if (outlineWidth > 0) {
            context.lineWidth = outlineWidth;
            context.lineCap = 'butt';
            if (context.setLineDash) // for very outofdate browsers
            switch(outlineStyle){
                case 'dotted':
                    context.setLineDash([
                        1,
                        1
                    ]);
                    break;
                case 'dashed':
                    context.setLineDash([
                        4,
                        2
                    ]);
                    break;
                case 'solid':
                case 'double':
                    context.setLineDash([]);
                    break;
            }
            var npos = pos;
            if (usePaths) npos = {
                x: 0,
                y: 0
            };
            var shape = r.getNodeShape(node);
            var bWidth = borderWidth;
            if (borderPosition === 'inside') bWidth = 0;
            if (borderPosition === 'outside') bWidth *= 2;
            var scaleX = (nodeWidth + bWidth + (outlineWidth + outlineOffset)) / nodeWidth;
            var scaleY = (nodeHeight + bWidth + (outlineWidth + outlineOffset)) / nodeHeight;
            var sWidth = nodeWidth * scaleX;
            var sHeight = nodeHeight * scaleY;
            var points = r.nodeShapes[shape].points;
            var _path;
            if (usePaths) {
                var outlinePath = getPath(sWidth, sHeight, shape, points);
                _path = outlinePath.path;
            }
            // draw the outline path, either by using expanded points or by scaling 
            // the dimensions, depending on shape
            if (shape === "ellipse") r.drawEllipsePath(_path || context, npos.x, npos.y, sWidth, sHeight);
            else if ([
                'round-diamond',
                'round-heptagon',
                'round-hexagon',
                'round-octagon',
                'round-pentagon',
                'round-polygon',
                'round-triangle',
                'round-tag'
            ].includes(shape)) {
                var sMult = 0;
                var offsetX = 0;
                var offsetY = 0;
                if (shape === 'round-diamond') sMult = (bWidth + outlineOffset + outlineWidth) * 1.4;
                else if (shape === 'round-heptagon') {
                    sMult = (bWidth + outlineOffset + outlineWidth) * 1.075;
                    offsetY = -(bWidth / 2 + outlineOffset + outlineWidth) / 35;
                } else if (shape === 'round-hexagon') sMult = (bWidth + outlineOffset + outlineWidth) * 1.12;
                else if (shape === 'round-pentagon') {
                    sMult = (bWidth + outlineOffset + outlineWidth) * 1.13;
                    offsetY = -(bWidth / 2 + outlineOffset + outlineWidth) / 15;
                } else if (shape === 'round-tag') {
                    sMult = (bWidth + outlineOffset + outlineWidth) * 1.12;
                    offsetX = (bWidth / 2 + outlineWidth + outlineOffset) * .07;
                } else if (shape === 'round-triangle') {
                    sMult = (bWidth + outlineOffset + outlineWidth) * (Math.PI / 2);
                    offsetY = -(bWidth + outlineOffset / 2 + outlineWidth) / Math.PI;
                }
                if (sMult !== 0) {
                    scaleX = (nodeWidth + sMult) / nodeWidth;
                    sWidth = nodeWidth * scaleX;
                    if (![
                        'round-hexagon',
                        'round-tag'
                    ].includes(shape)) {
                        scaleY = (nodeHeight + sMult) / nodeHeight;
                        sHeight = nodeHeight * scaleY;
                    }
                }
                cornerRadius = cornerRadius === 'auto' ? $e815fda779bc047b$var$getRoundPolygonRadius(sWidth, sHeight) : cornerRadius;
                var halfW = sWidth / 2;
                var halfH = sHeight / 2;
                var radius = cornerRadius + (bWidth + outlineWidth + outlineOffset) / 2;
                var p = new Array(points.length / 2);
                var corners = new Array(points.length / 2);
                for(var _i2 = 0; _i2 < points.length / 2; _i2++)p[_i2] = {
                    x: npos.x + offsetX + halfW * points[_i2 * 2],
                    y: npos.y + offsetY + halfH * points[_i2 * 2 + 1]
                };
                var _i3, p1, p2, p3, len = p.length;
                p1 = p[len - 1];
                // for each point
                for(_i3 = 0; _i3 < len; _i3++){
                    p2 = p[_i3 % len];
                    p3 = p[(_i3 + 1) % len];
                    corners[_i3] = $e815fda779bc047b$var$getRoundCorner(p1, p2, p3, radius);
                    p1 = p2;
                    p2 = p3;
                }
                r.drawRoundPolygonPath(_path || context, npos.x + offsetX, npos.y + offsetY, nodeWidth * scaleX, nodeHeight * scaleY, points, corners);
            } else if ([
                'roundrectangle',
                'round-rectangle'
            ].includes(shape)) {
                cornerRadius = cornerRadius === 'auto' ? $e815fda779bc047b$var$getRoundRectangleRadius(sWidth, sHeight) : cornerRadius;
                r.drawRoundRectanglePath(_path || context, npos.x, npos.y, sWidth, sHeight, cornerRadius + (bWidth + outlineWidth + outlineOffset) / 2);
            } else if ([
                'cutrectangle',
                'cut-rectangle'
            ].includes(shape)) {
                cornerRadius = cornerRadius === 'auto' ? $e815fda779bc047b$var$getCutRectangleCornerLength() : cornerRadius;
                r.drawCutRectanglePath(_path || context, npos.x, npos.y, sWidth, sHeight, null, cornerRadius + (bWidth + outlineWidth + outlineOffset) / 4);
            } else if ([
                'bottomroundrectangle',
                'bottom-round-rectangle'
            ].includes(shape)) {
                cornerRadius = cornerRadius === 'auto' ? $e815fda779bc047b$var$getRoundRectangleRadius(sWidth, sHeight) : cornerRadius;
                r.drawBottomRoundRectanglePath(_path || context, npos.x, npos.y, sWidth, sHeight, cornerRadius + (bWidth + outlineWidth + outlineOffset) / 2);
            } else if (shape === "barrel") r.drawBarrelPath(_path || context, npos.x, npos.y, sWidth, sHeight);
            else if (shape.startsWith("polygon") || [
                'rhomboid',
                'right-rhomboid',
                'round-tag',
                'tag',
                'vee'
            ].includes(shape)) {
                var pad = (bWidth + outlineWidth + outlineOffset) / nodeWidth;
                points = $e815fda779bc047b$var$joinLines($e815fda779bc047b$var$expandPolygon(points, pad));
                r.drawPolygonPath(_path || context, npos.x, npos.y, nodeWidth, nodeHeight, points);
            } else {
                var _pad = (bWidth + outlineWidth + outlineOffset) / nodeWidth;
                points = $e815fda779bc047b$var$joinLines($e815fda779bc047b$var$expandPolygon(points, -_pad));
                r.drawPolygonPath(_path || context, npos.x, npos.y, nodeWidth, nodeHeight, points);
            }
            if (usePaths) context.stroke(_path);
            else context.stroke();
            if (outlineStyle === 'double') {
                context.lineWidth = bWidth / 3;
                var gco = context.globalCompositeOperation;
                context.globalCompositeOperation = 'destination-out';
                if (usePaths) context.stroke(_path);
                else context.stroke();
                context.globalCompositeOperation = gco;
            }
            // reset in case we changed the border style
            if (context.setLineDash) // for very outofdate browsers
            context.setLineDash([]);
        }
    };
    var drawOverlay = function drawOverlay() {
        if (shouldDrawOverlay) r.drawNodeOverlay(context, node, pos, nodeWidth, nodeHeight);
    };
    var drawUnderlay = function drawUnderlay() {
        if (shouldDrawOverlay) r.drawNodeUnderlay(context, node, pos, nodeWidth, nodeHeight);
    };
    var drawText = function drawText() {
        r.drawElementText(context, node, null, drawLabel);
    };
    var ghost = node.pstyle('ghost').value === 'yes';
    if (ghost) {
        var gx = node.pstyle('ghost-offset-x').pfValue;
        var gy = node.pstyle('ghost-offset-y').pfValue;
        var ghostOpacity = node.pstyle('ghost-opacity').value;
        var effGhostOpacity = ghostOpacity * eleOpacity;
        context.translate(gx, gy);
        setupOutlineColor();
        drawOutline();
        setupShapeColor(ghostOpacity * bgOpacity);
        drawShape();
        drawImages(effGhostOpacity, true);
        setupBorderColor(ghostOpacity * borderOpacity);
        drawBorder();
        drawPie(darkness !== 0 || borderWidth !== 0);
        drawStripe(darkness !== 0 || borderWidth !== 0);
        drawImages(effGhostOpacity, false);
        darken(effGhostOpacity);
        context.translate(-gx, -gy);
    }
    if (usePaths) context.translate(-pos.x, -pos.y);
    drawUnderlay();
    if (usePaths) context.translate(pos.x, pos.y);
    setupOutlineColor();
    drawOutline();
    setupShapeColor();
    drawShape();
    drawImages(eleOpacity, true);
    setupBorderColor();
    drawBorder();
    drawPie(darkness !== 0 || borderWidth !== 0);
    drawStripe(darkness !== 0 || borderWidth !== 0);
    drawImages(eleOpacity, false);
    darken();
    if (usePaths) context.translate(-pos.x, -pos.y);
    drawText();
    drawOverlay();
    //
    // clean up shift
    if (shiftToOriginWithBb) context.translate(bb.x1, bb.y1);
};
var $e815fda779bc047b$var$drawNodeOverlayUnderlay = function drawNodeOverlayUnderlay(overlayOrUnderlay) {
    if (![
        'overlay',
        'underlay'
    ].includes(overlayOrUnderlay)) throw new Error('Invalid state');
    return function(context, node, pos, nodeWidth, nodeHeight) {
        var r = this;
        if (!node.visible()) return;
        var padding = node.pstyle("".concat(overlayOrUnderlay, "-padding")).pfValue;
        var opacity = node.pstyle("".concat(overlayOrUnderlay, "-opacity")).value;
        var color = node.pstyle("".concat(overlayOrUnderlay, "-color")).value;
        var shape = node.pstyle("".concat(overlayOrUnderlay, "-shape")).value;
        var radius = node.pstyle("".concat(overlayOrUnderlay, "-corner-radius")).value;
        if (opacity > 0) {
            pos = pos || node.position();
            if (nodeWidth == null || nodeHeight == null) {
                var _padding = node.padding();
                nodeWidth = node.width() + 2 * _padding;
                nodeHeight = node.height() + 2 * _padding;
            }
            r.colorFillStyle(context, color[0], color[1], color[2], opacity);
            r.nodeShapes[shape].draw(context, pos.x, pos.y, nodeWidth + padding * 2, nodeHeight + padding * 2, radius);
            context.fill();
        }
    };
};
$e815fda779bc047b$var$CRp$6.drawNodeOverlay = $e815fda779bc047b$var$drawNodeOverlayUnderlay('overlay');
$e815fda779bc047b$var$CRp$6.drawNodeUnderlay = $e815fda779bc047b$var$drawNodeOverlayUnderlay('underlay');
// does the node have at least one pie piece?
$e815fda779bc047b$var$CRp$6.hasPie = function(node) {
    node = node[0]; // ensure ele ref
    return node._private.hasPie;
};
$e815fda779bc047b$var$CRp$6.hasStripe = function(node) {
    node = node[0]; // ensure ele ref
    return node._private.hasStripe;
};
$e815fda779bc047b$var$CRp$6.drawPie = function(context, node, nodeOpacity, pos) {
    node = node[0]; // ensure ele ref
    pos = pos || node.position();
    var cyStyle = node.cy().style();
    var pieSize = node.pstyle('pie-size');
    var hole = node.pstyle('pie-hole');
    var overallStartAngle = node.pstyle('pie-start-angle').pfValue;
    var x = pos.x;
    var y = pos.y;
    var nodeW = node.width();
    var nodeH = node.height();
    var radius = Math.min(nodeW, nodeH) / 2; // must fit in node
    var holeRadius;
    var lastPercent = 0; // what % to continue drawing pie slices from on [0, 1]
    var usePaths = this.usePaths();
    if (usePaths) {
        x = 0;
        y = 0;
    }
    if (pieSize.units === '%') radius = radius * pieSize.pfValue;
    else if (pieSize.pfValue !== undefined) radius = pieSize.pfValue / 2; // diameter in pixels => radius
    if (hole.units === '%') holeRadius = radius * hole.pfValue;
    else if (hole.pfValue !== undefined) holeRadius = hole.pfValue / 2; // diameter in pixels => radius
    if (holeRadius >= radius) return; // the pie would be invisible anyway
    for(var i = 1; i <= cyStyle.pieBackgroundN; i++){
        // 1..N
        var size = node.pstyle('pie-' + i + '-background-size').value;
        var color = node.pstyle('pie-' + i + '-background-color').value;
        var opacity = node.pstyle('pie-' + i + '-background-opacity').value * nodeOpacity;
        var percent = size / 100; // map integer range [0, 100] to [0, 1]
        // percent can't push beyond 1
        if (percent + lastPercent > 1) percent = 1 - lastPercent;
        var angleStart = 1.5 * Math.PI + 2 * Math.PI * lastPercent; // start at 12 o'clock and go clockwise
        angleStart += overallStartAngle; // shift by the overall pie start angle
        var angleDelta = 2 * Math.PI * percent;
        var angleEnd = angleStart + angleDelta;
        // ignore if
        // - zero size
        // - we're already beyond the full circle
        // - adding the current slice would go beyond the full circle
        if (size === 0 || lastPercent >= 1 || lastPercent + percent > 1) continue;
        if (holeRadius === 0) {
            // make a pie slice
            context.beginPath();
            context.moveTo(x, y);
            context.arc(x, y, radius, angleStart, angleEnd);
            context.closePath();
        } else {
            // make a pie slice that's like the above but with a hole in the middle
            context.beginPath();
            context.arc(x, y, radius, angleStart, angleEnd);
            context.arc(x, y, holeRadius, angleEnd, angleStart, true); // true for anticlockwise
            context.closePath();
        }
        this.colorFillStyle(context, color[0], color[1], color[2], opacity);
        context.fill();
        lastPercent += percent;
    }
};
$e815fda779bc047b$var$CRp$6.drawStripe = function(context, node, nodeOpacity, pos) {
    node = node[0]; // ensure ele ref
    pos = pos || node.position();
    var cyStyle = node.cy().style();
    var x = pos.x;
    var y = pos.y;
    var nodeW = node.width();
    var nodeH = node.height();
    var lastPercent = 0; // what % to continue drawing pie slices from on [0, 1]
    var usePaths = this.usePaths();
    context.save();
    var direction = node.pstyle('stripe-direction').value;
    var stripeSize = node.pstyle('stripe-size');
    switch(direction){
        case 'vertical':
            break;
        // default
        case 'righward':
            context.rotate(-Math.PI / 2);
            break;
    }
    var stripeW = nodeW;
    var stripeH = nodeH;
    if (stripeSize.units === '%') {
        stripeW = stripeW * stripeSize.pfValue;
        stripeH = stripeH * stripeSize.pfValue;
    } else if (stripeSize.pfValue !== undefined) {
        stripeW = stripeSize.pfValue;
        stripeH = stripeSize.pfValue;
    }
    if (usePaths) {
        x = 0;
        y = 0;
    }
    // shift up from the centre of the node to the top-left corner
    y -= stripeW / 2;
    x -= stripeH / 2;
    for(var i = 1; i <= cyStyle.stripeBackgroundN; i++){
        // 1..N
        var size = node.pstyle('stripe-' + i + '-background-size').value;
        var color = node.pstyle('stripe-' + i + '-background-color').value;
        var opacity = node.pstyle('stripe-' + i + '-background-opacity').value * nodeOpacity;
        var percent = size / 100; // map integer range [0, 100] to [0, 1]
        // percent can't push beyond 1
        if (percent + lastPercent > 1) percent = 1 - lastPercent;
        // ignore if
        // - zero size
        // - we're already beyond the full chart
        // - adding the current slice would go beyond the full chart
        if (size === 0 || lastPercent >= 1 || lastPercent + percent > 1) continue;
        // draw rect for the current stripe
        context.beginPath();
        context.rect(x, y + stripeH * lastPercent, stripeW, stripeH * percent);
        context.closePath();
        this.colorFillStyle(context, color[0], color[1], color[2], opacity);
        context.fill();
        lastPercent += percent;
    }
    context.restore();
};
var $e815fda779bc047b$var$CRp$5 = {};
var $e815fda779bc047b$var$motionBlurDelay = 100;
// var isFirefox = typeof InstallTrigger !== 'undefined';
$e815fda779bc047b$var$CRp$5.getPixelRatio = function() {
    var context = this.data.contexts[0];
    if (this.forcedPixelRatio != null) return this.forcedPixelRatio;
    var containerWindow = this.cy.window();
    var backingStore = context.backingStorePixelRatio || context.webkitBackingStorePixelRatio || context.mozBackingStorePixelRatio || context.msBackingStorePixelRatio || context.oBackingStorePixelRatio || context.backingStorePixelRatio || 1;
    return (containerWindow.devicePixelRatio || 1) / backingStore; // eslint-disable-line no-undef
};
$e815fda779bc047b$var$CRp$5.paintCache = function(context) {
    var caches = this.paintCaches = this.paintCaches || [];
    var needToCreateCache = true;
    var cache;
    for(var i = 0; i < caches.length; i++){
        cache = caches[i];
        if (cache.context === context) {
            needToCreateCache = false;
            break;
        }
    }
    if (needToCreateCache) {
        cache = {
            context: context
        };
        caches.push(cache);
    }
    return cache;
};
$e815fda779bc047b$var$CRp$5.createGradientStyleFor = function(context, shapeStyleName, ele, fill, opacity) {
    var gradientStyle;
    var usePaths = this.usePaths();
    var colors = ele.pstyle(shapeStyleName + '-gradient-stop-colors').value, positions = ele.pstyle(shapeStyleName + '-gradient-stop-positions').pfValue;
    if (fill === 'radial-gradient') {
        if (ele.isEdge()) {
            var start = ele.sourceEndpoint(), end = ele.targetEndpoint(), mid = ele.midpoint();
            var d1 = $e815fda779bc047b$var$dist(start, mid);
            var d2 = $e815fda779bc047b$var$dist(end, mid);
            gradientStyle = context.createRadialGradient(mid.x, mid.y, 0, mid.x, mid.y, Math.max(d1, d2));
        } else {
            var pos = usePaths ? {
                x: 0,
                y: 0
            } : ele.position(), width = ele.paddedWidth(), height = ele.paddedHeight();
            gradientStyle = context.createRadialGradient(pos.x, pos.y, 0, pos.x, pos.y, Math.max(width, height));
        }
    } else if (ele.isEdge()) {
        var _start = ele.sourceEndpoint(), _end = ele.targetEndpoint();
        gradientStyle = context.createLinearGradient(_start.x, _start.y, _end.x, _end.y);
    } else {
        var _pos = usePaths ? {
            x: 0,
            y: 0
        } : ele.position(), _width = ele.paddedWidth(), _height = ele.paddedHeight(), halfWidth = _width / 2, halfHeight = _height / 2;
        var direction = ele.pstyle('background-gradient-direction').value;
        switch(direction){
            case 'to-bottom':
                gradientStyle = context.createLinearGradient(_pos.x, _pos.y - halfHeight, _pos.x, _pos.y + halfHeight);
                break;
            case 'to-top':
                gradientStyle = context.createLinearGradient(_pos.x, _pos.y + halfHeight, _pos.x, _pos.y - halfHeight);
                break;
            case 'to-left':
                gradientStyle = context.createLinearGradient(_pos.x + halfWidth, _pos.y, _pos.x - halfWidth, _pos.y);
                break;
            case 'to-right':
                gradientStyle = context.createLinearGradient(_pos.x - halfWidth, _pos.y, _pos.x + halfWidth, _pos.y);
                break;
            case 'to-bottom-right':
            case 'to-right-bottom':
                gradientStyle = context.createLinearGradient(_pos.x - halfWidth, _pos.y - halfHeight, _pos.x + halfWidth, _pos.y + halfHeight);
                break;
            case 'to-top-right':
            case 'to-right-top':
                gradientStyle = context.createLinearGradient(_pos.x - halfWidth, _pos.y + halfHeight, _pos.x + halfWidth, _pos.y - halfHeight);
                break;
            case 'to-bottom-left':
            case 'to-left-bottom':
                gradientStyle = context.createLinearGradient(_pos.x + halfWidth, _pos.y - halfHeight, _pos.x - halfWidth, _pos.y + halfHeight);
                break;
            case 'to-top-left':
            case 'to-left-top':
                gradientStyle = context.createLinearGradient(_pos.x + halfWidth, _pos.y + halfHeight, _pos.x - halfWidth, _pos.y - halfHeight);
                break;
        }
    }
    if (!gradientStyle) return null; // invalid gradient style
    var hasPositions = positions.length === colors.length;
    var length = colors.length;
    for(var i = 0; i < length; i++)gradientStyle.addColorStop(hasPositions ? positions[i] : i / (length - 1), 'rgba(' + colors[i][0] + ',' + colors[i][1] + ',' + colors[i][2] + ',' + opacity + ')');
    return gradientStyle;
};
$e815fda779bc047b$var$CRp$5.gradientFillStyle = function(context, ele, fill, opacity) {
    var gradientStyle = this.createGradientStyleFor(context, 'background', ele, fill, opacity);
    if (!gradientStyle) return null; // error
    context.fillStyle = gradientStyle;
};
$e815fda779bc047b$var$CRp$5.colorFillStyle = function(context, r, g, b, a) {
    context.fillStyle = 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
// turn off for now, seems context does its own caching
// var cache = this.paintCache(context);
// var fillStyle = 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
// if( cache.fillStyle !== fillStyle ){
//   context.fillStyle = cache.fillStyle = fillStyle;
// }
};
$e815fda779bc047b$var$CRp$5.eleFillStyle = function(context, ele, opacity) {
    var backgroundFill = ele.pstyle('background-fill').value;
    if (backgroundFill === 'linear-gradient' || backgroundFill === 'radial-gradient') this.gradientFillStyle(context, ele, backgroundFill, opacity);
    else {
        var backgroundColor = ele.pstyle('background-color').value;
        this.colorFillStyle(context, backgroundColor[0], backgroundColor[1], backgroundColor[2], opacity);
    }
};
$e815fda779bc047b$var$CRp$5.gradientStrokeStyle = function(context, ele, fill, opacity) {
    var gradientStyle = this.createGradientStyleFor(context, 'line', ele, fill, opacity);
    if (!gradientStyle) return null; // error
    context.strokeStyle = gradientStyle;
};
$e815fda779bc047b$var$CRp$5.colorStrokeStyle = function(context, r, g, b, a) {
    context.strokeStyle = 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
// turn off for now, seems context does its own caching
// var cache = this.paintCache(context);
// var strokeStyle = 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
// if( cache.strokeStyle !== strokeStyle ){
//   context.strokeStyle = cache.strokeStyle = strokeStyle;
// }
};
$e815fda779bc047b$var$CRp$5.eleStrokeStyle = function(context, ele, opacity) {
    var lineFill = ele.pstyle('line-fill').value;
    if (lineFill === 'linear-gradient' || lineFill === 'radial-gradient') this.gradientStrokeStyle(context, ele, lineFill, opacity);
    else {
        var lineColor = ele.pstyle('line-color').value;
        this.colorStrokeStyle(context, lineColor[0], lineColor[1], lineColor[2], opacity);
    }
};
// Resize canvas
$e815fda779bc047b$var$CRp$5.matchCanvasSize = function(container) {
    var r = this;
    var data = r.data;
    var bb = r.findContainerClientCoords();
    var width = bb[2];
    var height = bb[3];
    var pixelRatio = r.getPixelRatio();
    var mbPxRatio = r.motionBlurPxRatio;
    if (container === r.data.bufferCanvases[r.MOTIONBLUR_BUFFER_NODE] || container === r.data.bufferCanvases[r.MOTIONBLUR_BUFFER_DRAG]) pixelRatio = mbPxRatio;
    var canvasWidth = width * pixelRatio;
    var canvasHeight = height * pixelRatio;
    var canvas;
    if (canvasWidth === r.canvasWidth && canvasHeight === r.canvasHeight) return; // save cycles if same
    r.fontCaches = null; // resizing resets the style
    var canvasContainer = data.canvasContainer;
    canvasContainer.style.width = width + 'px';
    canvasContainer.style.height = height + 'px';
    for(var i = 0; i < r.CANVAS_LAYERS; i++){
        canvas = data.canvases[i];
        canvas.width = canvasWidth;
        canvas.height = canvasHeight;
        canvas.style.width = width + 'px';
        canvas.style.height = height + 'px';
    }
    for(var i = 0; i < r.BUFFER_COUNT; i++){
        canvas = data.bufferCanvases[i];
        canvas.width = canvasWidth;
        canvas.height = canvasHeight;
        canvas.style.width = width + 'px';
        canvas.style.height = height + 'px';
    }
    r.textureMult = 1;
    if (pixelRatio <= 1) {
        canvas = data.bufferCanvases[r.TEXTURE_BUFFER];
        r.textureMult = 2;
        canvas.width = canvasWidth * r.textureMult;
        canvas.height = canvasHeight * r.textureMult;
    }
    r.canvasWidth = canvasWidth;
    r.canvasHeight = canvasHeight;
    r.pixelRatio = pixelRatio;
};
$e815fda779bc047b$var$CRp$5.renderTo = function(cxt, zoom, pan, pxRatio) {
    this.render({
        forcedContext: cxt,
        forcedZoom: zoom,
        forcedPan: pan,
        drawAllLayers: true,
        forcedPxRatio: pxRatio
    });
};
$e815fda779bc047b$var$CRp$5.clearCanvas = function() {
    var r = this;
    var data = r.data;
    function clear(context) {
        context.clearRect(0, 0, r.canvasWidth, r.canvasHeight);
    }
    clear(data.contexts[r.NODE]);
    clear(data.contexts[r.DRAG]);
};
$e815fda779bc047b$var$CRp$5.render = function(options) {
    var r = this;
    options = options || $e815fda779bc047b$var$staticEmptyObject();
    var cy = r.cy;
    var forcedContext = options.forcedContext;
    var drawAllLayers = options.drawAllLayers;
    var drawOnlyNodeLayer = options.drawOnlyNodeLayer;
    var forcedZoom = options.forcedZoom;
    var forcedPan = options.forcedPan;
    var pixelRatio = options.forcedPxRatio === undefined ? this.getPixelRatio() : options.forcedPxRatio;
    var data = r.data;
    var needDraw = data.canvasNeedsRedraw;
    var textureDraw = r.textureOnViewport && !forcedContext && (r.pinching || r.hoverData.dragging || r.swipePanning || r.data.wheelZooming);
    var motionBlur = options.motionBlur !== undefined ? options.motionBlur : r.motionBlur;
    var mbPxRatio = r.motionBlurPxRatio;
    var hasCompoundNodes = cy.hasCompoundNodes();
    var inNodeDragGesture = r.hoverData.draggingEles;
    var inBoxSelection = r.hoverData.selecting || r.touchData.selecting ? true : false;
    motionBlur = motionBlur && !forcedContext && r.motionBlurEnabled && !inBoxSelection;
    var motionBlurFadeEffect = motionBlur;
    if (!forcedContext) {
        if (r.prevPxRatio !== pixelRatio) {
            r.invalidateContainerClientCoordsCache();
            r.matchCanvasSize(r.container);
            r.redrawHint('eles', true);
            r.redrawHint('drag', true);
        }
        r.prevPxRatio = pixelRatio;
    }
    if (!forcedContext && r.motionBlurTimeout) clearTimeout(r.motionBlurTimeout);
    if (motionBlur) {
        if (r.mbFrames == null) r.mbFrames = 0;
        r.mbFrames++;
        if (r.mbFrames < 3) // need several frames before even high quality motionblur
        motionBlurFadeEffect = false;
        // go to lower quality blurry frames when several m/b frames have been rendered (avoids flashing)
        if (r.mbFrames > r.minMbLowQualFrames) //r.fullQualityMb = false;
        r.motionBlurPxRatio = r.mbPxRBlurry;
    }
    if (r.clearingMotionBlur) r.motionBlurPxRatio = 1;
    // b/c drawToContext() may be async w.r.t. redraw(), keep track of last texture frame
    // because a rogue async texture frame would clear needDraw
    if (r.textureDrawLastFrame && !textureDraw) {
        needDraw[r.NODE] = true;
        needDraw[r.SELECT_BOX] = true;
    }
    var style = cy.style();
    var zoom = cy.zoom();
    var effectiveZoom = forcedZoom !== undefined ? forcedZoom : zoom;
    var pan = cy.pan();
    var effectivePan = {
        x: pan.x,
        y: pan.y
    };
    var vp = {
        zoom: zoom,
        pan: {
            x: pan.x,
            y: pan.y
        }
    };
    var prevVp = r.prevViewport;
    var viewportIsDiff = prevVp === undefined || vp.zoom !== prevVp.zoom || vp.pan.x !== prevVp.pan.x || vp.pan.y !== prevVp.pan.y;
    // we want the low quality motionblur only when the viewport is being manipulated etc (where it's not noticed)
    if (!viewportIsDiff && !(inNodeDragGesture && !hasCompoundNodes)) r.motionBlurPxRatio = 1;
    if (forcedPan) effectivePan = forcedPan;
    // apply pixel ratio
    effectiveZoom *= pixelRatio;
    effectivePan.x *= pixelRatio;
    effectivePan.y *= pixelRatio;
    var eles = r.getCachedZSortedEles();
    function mbclear(context, x, y, w, h) {
        var gco = context.globalCompositeOperation;
        context.globalCompositeOperation = 'destination-out';
        r.colorFillStyle(context, 255, 255, 255, r.motionBlurTransparency);
        context.fillRect(x, y, w, h);
        context.globalCompositeOperation = gco;
    }
    function setContextTransform(context, clear) {
        var ePan, eZoom, w, h;
        if (!r.clearingMotionBlur && (context === data.bufferContexts[r.MOTIONBLUR_BUFFER_NODE] || context === data.bufferContexts[r.MOTIONBLUR_BUFFER_DRAG])) {
            ePan = {
                x: pan.x * mbPxRatio,
                y: pan.y * mbPxRatio
            };
            eZoom = zoom * mbPxRatio;
            w = r.canvasWidth * mbPxRatio;
            h = r.canvasHeight * mbPxRatio;
        } else {
            ePan = effectivePan;
            eZoom = effectiveZoom;
            w = r.canvasWidth;
            h = r.canvasHeight;
        }
        context.setTransform(1, 0, 0, 1, 0, 0);
        if (clear === 'motionBlur') mbclear(context, 0, 0, w, h);
        else if (!forcedContext && (clear === undefined || clear)) context.clearRect(0, 0, w, h);
        if (!drawAllLayers) {
            context.translate(ePan.x, ePan.y);
            context.scale(eZoom, eZoom);
        }
        if (forcedPan) context.translate(forcedPan.x, forcedPan.y);
        if (forcedZoom) context.scale(forcedZoom, forcedZoom);
    }
    if (!textureDraw) r.textureDrawLastFrame = false;
    if (textureDraw) {
        r.textureDrawLastFrame = true;
        if (!r.textureCache) {
            r.textureCache = {};
            r.textureCache.bb = cy.mutableElements().boundingBox();
            r.textureCache.texture = r.data.bufferCanvases[r.TEXTURE_BUFFER];
            var cxt = r.data.bufferContexts[r.TEXTURE_BUFFER];
            cxt.setTransform(1, 0, 0, 1, 0, 0);
            cxt.clearRect(0, 0, r.canvasWidth * r.textureMult, r.canvasHeight * r.textureMult);
            r.render({
                forcedContext: cxt,
                drawOnlyNodeLayer: true,
                forcedPxRatio: pixelRatio * r.textureMult
            });
            var vp = r.textureCache.viewport = {
                zoom: cy.zoom(),
                pan: cy.pan(),
                width: r.canvasWidth,
                height: r.canvasHeight
            };
            vp.mpan = {
                x: (0 - vp.pan.x) / vp.zoom,
                y: (0 - vp.pan.y) / vp.zoom
            };
        }
        needDraw[r.DRAG] = false;
        needDraw[r.NODE] = false;
        var context = data.contexts[r.NODE];
        var texture = r.textureCache.texture;
        var vp = r.textureCache.viewport;
        context.setTransform(1, 0, 0, 1, 0, 0);
        if (motionBlur) mbclear(context, 0, 0, vp.width, vp.height);
        else context.clearRect(0, 0, vp.width, vp.height);
        var outsideBgColor = style.core('outside-texture-bg-color').value;
        var outsideBgOpacity = style.core('outside-texture-bg-opacity').value;
        r.colorFillStyle(context, outsideBgColor[0], outsideBgColor[1], outsideBgColor[2], outsideBgOpacity);
        context.fillRect(0, 0, vp.width, vp.height);
        var zoom = cy.zoom();
        setContextTransform(context, false);
        context.clearRect(vp.mpan.x, vp.mpan.y, vp.width / vp.zoom / pixelRatio, vp.height / vp.zoom / pixelRatio);
        context.drawImage(texture, vp.mpan.x, vp.mpan.y, vp.width / vp.zoom / pixelRatio, vp.height / vp.zoom / pixelRatio);
    } else if (r.textureOnViewport && !forcedContext) // clear the cache since we don't need it
    r.textureCache = null;
    var extent = cy.extent();
    var vpManip = r.pinching || r.hoverData.dragging || r.swipePanning || r.data.wheelZooming || r.hoverData.draggingEles || r.cy.animated();
    var hideEdges = r.hideEdgesOnViewport && vpManip;
    var needMbClear = [];
    needMbClear[r.NODE] = !needDraw[r.NODE] && motionBlur && !r.clearedForMotionBlur[r.NODE] || r.clearingMotionBlur;
    if (needMbClear[r.NODE]) r.clearedForMotionBlur[r.NODE] = true;
    needMbClear[r.DRAG] = !needDraw[r.DRAG] && motionBlur && !r.clearedForMotionBlur[r.DRAG] || r.clearingMotionBlur;
    if (needMbClear[r.DRAG]) r.clearedForMotionBlur[r.DRAG] = true;
    if (needDraw[r.NODE] || drawAllLayers || drawOnlyNodeLayer || needMbClear[r.NODE]) {
        var useBuffer = motionBlur && !needMbClear[r.NODE] && mbPxRatio !== 1;
        var context = forcedContext || (useBuffer ? r.data.bufferContexts[r.MOTIONBLUR_BUFFER_NODE] : data.contexts[r.NODE]);
        var clear = motionBlur && !useBuffer ? 'motionBlur' : undefined;
        setContextTransform(context, clear);
        if (hideEdges) r.drawCachedNodes(context, eles.nondrag, pixelRatio, extent);
        else r.drawLayeredElements(context, eles.nondrag, pixelRatio, extent);
        if (r.debug) r.drawDebugPoints(context, eles.nondrag);
        if (!drawAllLayers && !motionBlur) needDraw[r.NODE] = false;
    }
    if (!drawOnlyNodeLayer && (needDraw[r.DRAG] || drawAllLayers || needMbClear[r.DRAG])) {
        var useBuffer = motionBlur && !needMbClear[r.DRAG] && mbPxRatio !== 1;
        var context = forcedContext || (useBuffer ? r.data.bufferContexts[r.MOTIONBLUR_BUFFER_DRAG] : data.contexts[r.DRAG]);
        setContextTransform(context, motionBlur && !useBuffer ? 'motionBlur' : undefined);
        if (hideEdges) r.drawCachedNodes(context, eles.drag, pixelRatio, extent);
        else r.drawCachedElements(context, eles.drag, pixelRatio, extent);
        if (r.debug) r.drawDebugPoints(context, eles.drag);
        if (!drawAllLayers && !motionBlur) needDraw[r.DRAG] = false;
    }
    this.drawSelectionRectangle(options, setContextTransform);
    // motionblur: blit rendered blurry frames
    if (motionBlur && mbPxRatio !== 1) {
        var cxtNode = data.contexts[r.NODE];
        var txtNode = r.data.bufferCanvases[r.MOTIONBLUR_BUFFER_NODE];
        var cxtDrag = data.contexts[r.DRAG];
        var txtDrag = r.data.bufferCanvases[r.MOTIONBLUR_BUFFER_DRAG];
        var drawMotionBlur = function drawMotionBlur(cxt, txt, needClear) {
            cxt.setTransform(1, 0, 0, 1, 0, 0);
            if (needClear || !motionBlurFadeEffect) cxt.clearRect(0, 0, r.canvasWidth, r.canvasHeight);
            else mbclear(cxt, 0, 0, r.canvasWidth, r.canvasHeight);
            var pxr = mbPxRatio;
            cxt.drawImage(txt, // img
            0, 0, // sx, sy
            r.canvasWidth * pxr, r.canvasHeight * pxr, // sw, sh
            0, 0, // x, y
            r.canvasWidth, r.canvasHeight // w, h
            );
        };
        if (needDraw[r.NODE] || needMbClear[r.NODE]) {
            drawMotionBlur(cxtNode, txtNode, needMbClear[r.NODE]);
            needDraw[r.NODE] = false;
        }
        if (needDraw[r.DRAG] || needMbClear[r.DRAG]) {
            drawMotionBlur(cxtDrag, txtDrag, needMbClear[r.DRAG]);
            needDraw[r.DRAG] = false;
        }
    }
    r.prevViewport = vp;
    if (r.clearingMotionBlur) {
        r.clearingMotionBlur = false;
        r.motionBlurCleared = true;
        r.motionBlur = true;
    }
    if (motionBlur) r.motionBlurTimeout = setTimeout(function() {
        r.motionBlurTimeout = null;
        r.clearedForMotionBlur[r.NODE] = false;
        r.clearedForMotionBlur[r.DRAG] = false;
        r.motionBlur = false;
        r.clearingMotionBlur = !textureDraw;
        r.mbFrames = 0;
        needDraw[r.NODE] = true;
        needDraw[r.DRAG] = true;
        r.redraw();
    }, $e815fda779bc047b$var$motionBlurDelay);
    if (!forcedContext) cy.emit('render');
};
var $e815fda779bc047b$var$fpsHeight;
$e815fda779bc047b$var$CRp$5.drawSelectionRectangle = function(options, setContextTransform) {
    var r = this;
    var cy = r.cy;
    var data = r.data;
    var style = cy.style();
    var drawOnlyNodeLayer = options.drawOnlyNodeLayer;
    var drawAllLayers = options.drawAllLayers;
    var needDraw = data.canvasNeedsRedraw;
    var forcedContext = options.forcedContext;
    if (r.showFps || !drawOnlyNodeLayer && needDraw[r.SELECT_BOX] && !drawAllLayers) {
        var context = forcedContext || data.contexts[r.SELECT_BOX];
        setContextTransform(context);
        if (r.selection[4] == 1 && (r.hoverData.selecting || r.touchData.selecting)) {
            var zoom = r.cy.zoom();
            var borderWidth = style.core('selection-box-border-width').value / zoom;
            context.lineWidth = borderWidth;
            context.fillStyle = 'rgba(' + style.core('selection-box-color').value[0] + ',' + style.core('selection-box-color').value[1] + ',' + style.core('selection-box-color').value[2] + ',' + style.core('selection-box-opacity').value + ')';
            context.fillRect(r.selection[0], r.selection[1], r.selection[2] - r.selection[0], r.selection[3] - r.selection[1]);
            if (borderWidth > 0) {
                context.strokeStyle = 'rgba(' + style.core('selection-box-border-color').value[0] + ',' + style.core('selection-box-border-color').value[1] + ',' + style.core('selection-box-border-color').value[2] + ',' + style.core('selection-box-opacity').value + ')';
                context.strokeRect(r.selection[0], r.selection[1], r.selection[2] - r.selection[0], r.selection[3] - r.selection[1]);
            }
        }
        if (data.bgActivePosistion && !r.hoverData.selecting) {
            var zoom = r.cy.zoom();
            var pos = data.bgActivePosistion;
            context.fillStyle = 'rgba(' + style.core('active-bg-color').value[0] + ',' + style.core('active-bg-color').value[1] + ',' + style.core('active-bg-color').value[2] + ',' + style.core('active-bg-opacity').value + ')';
            context.beginPath();
            context.arc(pos.x, pos.y, style.core('active-bg-size').pfValue / zoom, 0, 2 * Math.PI);
            context.fill();
        }
        var timeToRender = r.lastRedrawTime;
        if (r.showFps && timeToRender) {
            timeToRender = Math.round(timeToRender);
            var fps = Math.round(1000 / timeToRender);
            var text = '1 frame = ' + timeToRender + ' ms = ' + fps + ' fps';
            context.setTransform(1, 0, 0, 1, 0, 0);
            context.fillStyle = 'rgba(255, 0, 0, 0.75)';
            context.strokeStyle = 'rgba(255, 0, 0, 0.75)';
            // context.lineWidth = 1;
            context.font = '30px Arial';
            if (!$e815fda779bc047b$var$fpsHeight) {
                var dims = context.measureText(text);
                $e815fda779bc047b$var$fpsHeight = dims.actualBoundingBoxAscent;
            }
            context.fillText(text, 0, $e815fda779bc047b$var$fpsHeight);
            var maxFps = 60;
            context.strokeRect(0, $e815fda779bc047b$var$fpsHeight + 10, 250, 20);
            context.fillRect(0, $e815fda779bc047b$var$fpsHeight + 10, 250 * Math.min(fps / maxFps, 1), 20);
        }
        if (!drawAllLayers) needDraw[r.SELECT_BOX] = false;
    }
};
/**
 * Notes:
 * - All colors have premultiplied alpha. Very important for textues and 
 *   blending to work correctly.
 */ function $e815fda779bc047b$var$compileShader(gl, type, source) {
    var shader = gl.createShader(type);
    gl.shaderSource(shader, source);
    gl.compileShader(shader);
    if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) throw new Error(gl.getShaderInfoLog(shader));
    // console.log(gl.getShaderInfoLog(shader));
    return shader;
}
function $e815fda779bc047b$var$createProgram(gl, vertexSource, fragementSource) {
    var vertexShader = $e815fda779bc047b$var$compileShader(gl, gl.VERTEX_SHADER, vertexSource);
    var fragmentShader = $e815fda779bc047b$var$compileShader(gl, gl.FRAGMENT_SHADER, fragementSource);
    var program = gl.createProgram();
    gl.attachShader(program, vertexShader);
    gl.attachShader(program, fragmentShader);
    gl.linkProgram(program);
    if (!gl.getProgramParameter(program, gl.LINK_STATUS)) throw new Error('Could not initialize shaders');
    return program;
}
/**
 * Creates an offscren canvas with a 2D context, for the
 * canvas renderer to use for drawing textures.
 */ function $e815fda779bc047b$var$createTextureCanvas(r, width, height) {
    if (height === undefined) height = width;
    var canvas = r.makeOffscreenCanvas(width, height);
    var ctx = canvas.context = canvas.getContext('2d');
    canvas.clear = function() {
        return ctx.clearRect(0, 0, canvas.width, canvas.height);
    };
    canvas.clear();
    return canvas;
}
/**
 * Returns the current pan & zoom values, scaled by the pixel ratio.
 */ function $e815fda779bc047b$var$getEffectivePanZoom(r) {
    var pixelRatio = r.pixelRatio;
    var zoom = r.cy.zoom();
    var pan = r.cy.pan();
    return {
        zoom: zoom * pixelRatio,
        pan: {
            x: pan.x * pixelRatio,
            y: pan.y * pixelRatio
        }
    };
}
/**
 * Returns the zoom value, scaled by the pixel ratio.
 */ function $e815fda779bc047b$var$getEffectiveZoom(r) {
    var pixelRatio = r.pixelRatio;
    var zoom = r.cy.zoom();
    return zoom * pixelRatio;
}
function $e815fda779bc047b$var$modelToRenderedPosition(r, pan, zoom, x, y) {
    var rx = x * zoom + pan.x;
    var ry = y * zoom + pan.y;
    ry = Math.round(r.canvasHeight - ry); // adjust for webgl
    return [
        rx,
        ry
    ];
}
function $e815fda779bc047b$var$isSimpleShape(node, renderTarget) {
    // the actual shape is checked in ElementDrawingWebGL._getVertTypeForShape()
    // no need to check it twice, this just checks other visual properties
    if (renderTarget.picking) // We don't care about the border or background style for picking
    return true;
    else {
        if (node.pstyle('background-fill').value !== 'solid') return false;
        if (node.pstyle('background-image').strValue !== 'none') return false;
        if (node.pstyle('border-width').value === 0) return true;
        if (node.pstyle('border-opacity').value === 0) return true;
        // we have a border but it must be simple
        if (node.pstyle('border-style').value !== 'solid') return false;
        // TODO ignoring 'border-cap', 'border-join' and 'border-position' for now
        return true;
    }
}
function $e815fda779bc047b$var$arrayEqual(a1, a2) {
    if (a1.length !== a2.length) return false;
    for(var i = 0; i < a1.length; i++){
        if (a1[i] !== a2[i]) return false;
    }
    return true;
}
/**
 * Takes color & opacity style values and converts them to WebGL format. 
 * Alpha is premultiplied.
 */ function $e815fda779bc047b$var$toWebGLColor(color, opacity, outArray) {
    var r = color[0] / 255;
    var g = color[1] / 255;
    var b = color[2] / 255;
    var a = opacity;
    var arr = outArray || new Array(4);
    arr[0] = r * a;
    arr[1] = g * a;
    arr[2] = b * a;
    arr[3] = a;
    return arr;
}
function $e815fda779bc047b$var$indexToVec4(index, outArray) {
    var arr = outArray || new Array(4);
    arr[0] = (index >> 0 & 0xFF) / 0xFF;
    arr[1] = (index >> 8 & 0xFF) / 0xFF;
    arr[2] = (index >> 16 & 0xFF) / 0xFF;
    arr[3] = (index >> 24 & 0xFF) / 0xFF;
    return arr;
}
function $e815fda779bc047b$var$vec4ToIndex(vec4) {
    return vec4[0] + (vec4[1] << 8) + (vec4[2] << 16) + (vec4[3] << 24);
}
function $e815fda779bc047b$var$createTexture(gl, debugID) {
    var texture = gl.createTexture();
    texture.buffer = function(offscreenCanvas) {
        gl.bindTexture(gl.TEXTURE_2D, texture);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_NEAREST);
        // very important, this tells webgl to premultiply colors by the alpha channel
        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, true);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, offscreenCanvas);
        gl.generateMipmap(gl.TEXTURE_2D);
        gl.bindTexture(gl.TEXTURE_2D, null);
    };
    texture.deleteTexture = function() {
        gl.deleteTexture(texture);
    };
    return texture;
}
function $e815fda779bc047b$var$getTypeInfo(gl, glslType) {
    switch(glslType){
        case 'float':
            return [
                1,
                gl.FLOAT,
                4
            ];
        case 'vec2':
            return [
                2,
                gl.FLOAT,
                4
            ];
        case 'vec3':
            return [
                3,
                gl.FLOAT,
                4
            ];
        case 'vec4':
            return [
                4,
                gl.FLOAT,
                4
            ];
        case 'int':
            return [
                1,
                gl.INT,
                4
            ];
        case 'ivec2':
            return [
                2,
                gl.INT,
                4
            ];
    }
}
function $e815fda779bc047b$var$createTypedArray(gl, glType, dataOrSize) {
    switch(glType){
        case gl.FLOAT:
            return new Float32Array(dataOrSize);
        case gl.INT:
            return new Int32Array(dataOrSize);
    }
}
function $e815fda779bc047b$var$createTypedArrayView(gl, glType, array, stride, size, i) {
    switch(glType){
        case gl.FLOAT:
            return new Float32Array(array.buffer, i * stride, size);
        case gl.INT:
            return new Int32Array(array.buffer, i * stride, size);
    }
}
/** @param {WebGLRenderingContext} gl */ function $e815fda779bc047b$var$createBufferStaticDraw(gl, type, attributeLoc, dataArray) {
    var _getTypeInfo = $e815fda779bc047b$var$getTypeInfo(gl, type), _getTypeInfo2 = $e815fda779bc047b$var$_slicedToArray(_getTypeInfo, 2), size = _getTypeInfo2[0], glType = _getTypeInfo2[1];
    var data = $e815fda779bc047b$var$createTypedArray(gl, glType, dataArray);
    var buffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
    gl.bufferData(gl.ARRAY_BUFFER, data, gl.STATIC_DRAW);
    if (glType === gl.FLOAT) gl.vertexAttribPointer(attributeLoc, size, glType, false, 0, 0);
    else if (glType === gl.INT) gl.vertexAttribIPointer(attributeLoc, size, glType, 0, 0);
    gl.enableVertexAttribArray(attributeLoc);
    gl.bindBuffer(gl.ARRAY_BUFFER, null);
    return buffer;
}
/** 
 * Creates a float buffer with gl.DYNAMIC_DRAW.
 * The returned buffer object contains functions to easily set instance data and buffer the data before a draw call.
 * @param {WebGLRenderingContext} gl 
 */ function $e815fda779bc047b$var$createBufferDynamicDraw(gl, instances, type, attributeLoc) {
    var _getTypeInfo3 = $e815fda779bc047b$var$getTypeInfo(gl, type), _getTypeInfo4 = $e815fda779bc047b$var$_slicedToArray(_getTypeInfo3, 3), size = _getTypeInfo4[0], glType = _getTypeInfo4[1], bytes = _getTypeInfo4[2];
    var dataArray = $e815fda779bc047b$var$createTypedArray(gl, glType, instances * size);
    var stride = size * bytes;
    var buffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
    gl.bufferData(gl.ARRAY_BUFFER, instances * stride, gl.DYNAMIC_DRAW);
    gl.enableVertexAttribArray(attributeLoc);
    if (glType === gl.FLOAT) gl.vertexAttribPointer(attributeLoc, size, glType, false, stride, 0);
    else if (glType === gl.INT) gl.vertexAttribIPointer(attributeLoc, size, glType, stride, 0);
    gl.vertexAttribDivisor(attributeLoc, 1);
    gl.bindBuffer(gl.ARRAY_BUFFER, null);
    // use array views to set values directly into the buffer array
    var views = new Array(instances);
    for(var i = 0; i < instances; i++)views[i] = $e815fda779bc047b$var$createTypedArrayView(gl, glType, dataArray, stride, size, i);
    buffer.dataArray = dataArray;
    buffer.stride = stride;
    buffer.size = size;
    buffer.getView = function(i) {
        return views[i];
    };
    buffer.setPoint = function(i, x, y) {
        var view = views[i];
        view[0] = x;
        view[1] = y;
    };
    buffer.bufferSubData = function(count) {
        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
        if (count) gl.bufferSubData(gl.ARRAY_BUFFER, 0, dataArray, 0, count * size);
        else gl.bufferSubData(gl.ARRAY_BUFFER, 0, dataArray);
    };
    return buffer;
}
/** 
 * Creates a buffer of 3x3 matrix data for use as attribute data.
 * @param {WebGLRenderingContext} gl 
 */ function $e815fda779bc047b$var$create3x3MatrixBufferDynamicDraw(gl, instances, attributeLoc) {
    var matrixSize = 9; // 3x3 matrix
    var matrixData = new Float32Array(instances * matrixSize);
    // use matrix views to set values directly into the matrixData array
    var matrixViews = new Array(instances);
    for(var i = 0; i < instances; i++){
        var byteOffset = i * matrixSize * 4; // 4 bytes per float
        matrixViews[i] = new Float32Array(matrixData.buffer, byteOffset, matrixSize); // array view
    }
    var buffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
    gl.bufferData(gl.ARRAY_BUFFER, matrixData.byteLength, gl.DYNAMIC_DRAW);
    // each row of the matrix needs to be a separate attribute
    for(var _i = 0; _i < 3; _i++){
        var loc = attributeLoc + _i;
        gl.enableVertexAttribArray(loc);
        gl.vertexAttribPointer(loc, 3, gl.FLOAT, false, 36, _i * 12);
        gl.vertexAttribDivisor(loc, 1);
    }
    gl.bindBuffer(gl.ARRAY_BUFFER, null);
    buffer.getMatrixView = function(i) {
        return matrixViews[i];
    };
    // TODO this is too slow, use getMatrixView and pass the view directly to the glmatrix library
    buffer.setData = function(matrix, i) {
        matrixViews[i].set(matrix, 0);
    };
    buffer.bufferSubData = function() {
        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
        gl.bufferSubData(gl.ARRAY_BUFFER, 0, matrixData);
    };
    return buffer;
}
/** 
 * Creates a Frame Buffer to use for offscreen rendering.
 * @param {WebGLRenderingContext} gl 
 */ function $e815fda779bc047b$var$createPickingFrameBuffer(gl) {
    // Create and bind the framebuffer
    var fb = gl.createFramebuffer();
    gl.bindFramebuffer(gl.FRAMEBUFFER, fb);
    // Create a texture to render to
    var targetTexture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, targetTexture);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    // attach the texture as the first color attachment
    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, targetTexture, 0);
    gl.bindFramebuffer(gl.FRAMEBUFFER, null);
    fb.setFramebufferAttachmentSizes = function(width, height) {
        gl.bindTexture(gl.TEXTURE_2D, targetTexture);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, width, height, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
    };
    return fb;
}
/**
 * Common utilities
 * @module glMatrix
 */ // Configuration Constants
var $e815fda779bc047b$var$ARRAY_TYPE = typeof Float32Array !== 'undefined' ? Float32Array : Array;
if (!Math.hypot) Math.hypot = function() {
    var y = 0, i = arguments.length;
    while(i--)y += arguments[i] * arguments[i];
    return Math.sqrt(y);
};
/**
 * 3x3 Matrix
 * @module mat3
 */ /**
 * Creates a new identity mat3
 *
 * @returns {mat3} a new 3x3 matrix
 */ function $e815fda779bc047b$var$create() {
    var out = new $e815fda779bc047b$var$ARRAY_TYPE(9);
    if ($e815fda779bc047b$var$ARRAY_TYPE != Float32Array) {
        out[1] = 0;
        out[2] = 0;
        out[3] = 0;
        out[5] = 0;
        out[6] = 0;
        out[7] = 0;
    }
    out[0] = 1;
    out[4] = 1;
    out[8] = 1;
    return out;
}
/**
 * Set a mat3 to the identity matrix
 *
 * @param {mat3} out the receiving matrix
 * @returns {mat3} out
 */ function $e815fda779bc047b$var$identity(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 1;
    out[5] = 0;
    out[6] = 0;
    out[7] = 0;
    out[8] = 1;
    return out;
}
/**
 * Multiplies two mat3's
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the first operand
 * @param {ReadonlyMat3} b the second operand
 * @returns {mat3} out
 */ function $e815fda779bc047b$var$multiply(out, a, b) {
    var a00 = a[0], a01 = a[1], a02 = a[2];
    var a10 = a[3], a11 = a[4], a12 = a[5];
    var a20 = a[6], a21 = a[7], a22 = a[8];
    var b00 = b[0], b01 = b[1], b02 = b[2];
    var b10 = b[3], b11 = b[4], b12 = b[5];
    var b20 = b[6], b21 = b[7], b22 = b[8];
    out[0] = b00 * a00 + b01 * a10 + b02 * a20;
    out[1] = b00 * a01 + b01 * a11 + b02 * a21;
    out[2] = b00 * a02 + b01 * a12 + b02 * a22;
    out[3] = b10 * a00 + b11 * a10 + b12 * a20;
    out[4] = b10 * a01 + b11 * a11 + b12 * a21;
    out[5] = b10 * a02 + b11 * a12 + b12 * a22;
    out[6] = b20 * a00 + b21 * a10 + b22 * a20;
    out[7] = b20 * a01 + b21 * a11 + b22 * a21;
    out[8] = b20 * a02 + b21 * a12 + b22 * a22;
    return out;
}
/**
 * Translate a mat3 by the given vector
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the matrix to translate
 * @param {ReadonlyVec2} v vector to translate by
 * @returns {mat3} out
 */ function $e815fda779bc047b$var$translate(out, a, v) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a10 = a[3], a11 = a[4], a12 = a[5], a20 = a[6], a21 = a[7], a22 = a[8], x = v[0], y = v[1];
    out[0] = a00;
    out[1] = a01;
    out[2] = a02;
    out[3] = a10;
    out[4] = a11;
    out[5] = a12;
    out[6] = x * a00 + y * a10 + a20;
    out[7] = x * a01 + y * a11 + a21;
    out[8] = x * a02 + y * a12 + a22;
    return out;
}
/**
 * Rotates a mat3 by the given angle
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat3} out
 */ function $e815fda779bc047b$var$rotate(out, a, rad) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a10 = a[3], a11 = a[4], a12 = a[5], a20 = a[6], a21 = a[7], a22 = a[8], s = Math.sin(rad), c = Math.cos(rad);
    out[0] = c * a00 + s * a10;
    out[1] = c * a01 + s * a11;
    out[2] = c * a02 + s * a12;
    out[3] = c * a10 - s * a00;
    out[4] = c * a11 - s * a01;
    out[5] = c * a12 - s * a02;
    out[6] = a20;
    out[7] = a21;
    out[8] = a22;
    return out;
}
/**
 * Scales the mat3 by the dimensions in the given vec2
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the matrix to rotate
 * @param {ReadonlyVec2} v the vec2 to scale the matrix by
 * @returns {mat3} out
 **/ function $e815fda779bc047b$var$scale(out, a, v) {
    var x = v[0], y = v[1];
    out[0] = x * a[0];
    out[1] = x * a[1];
    out[2] = x * a[2];
    out[3] = y * a[3];
    out[4] = y * a[4];
    out[5] = y * a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    return out;
}
/**
 * Generates a 2D projection matrix with the given bounds
 *
 * @param {mat3} out mat3 frustum matrix will be written into
 * @param {number} width Width of your gl context
 * @param {number} height Height of gl context
 * @returns {mat3} out
 */ function $e815fda779bc047b$var$projection(out, width, height) {
    out[0] = 2 / width;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = -2 / height;
    out[5] = 0;
    out[6] = -1;
    out[7] = 1;
    out[8] = 1;
    return out;
}
// A "texture atlas" is a big canvas, and sections of it are used as textures for nodes/labels.
/**
 * A single square texture atlas (also known as a "sprite sheet").
 */ var $e815fda779bc047b$var$Atlas = /*#__PURE__*/ function() {
    function Atlas(r, texSize, texRows, createTextureCanvas) {
        $e815fda779bc047b$var$_classCallCheck(this, Atlas);
        this.debugID = Math.floor(Math.random() * 10000);
        this.r = r;
        this.texSize = texSize;
        this.texRows = texRows;
        this.texHeight = Math.floor(texSize / texRows);
        this.enableWrapping = true; // hardcoded for now, can be made an option
        this.locked = false; // once an atlas is locked it can no longer be drawn to
        this.texture = null; // WebGLTexture object
        this.needsBuffer = true;
        // a "location" is an pointer into the atlas with a 'row' and 'x' fields
        this.freePointer = {
            x: 0,
            row: 0
        };
        // map from the style key to the row/x where the texture starts
        // if the texture wraps then there's a second location
        this.keyToLocation = new Map(); // styleKey -> [ location, location ]
        this.canvas = createTextureCanvas(r, texSize, texSize);
        this.scratch = createTextureCanvas(r, texSize, this.texHeight, 'scratch');
    }
    return $e815fda779bc047b$var$_createClass(Atlas, [
        {
            key: "lock",
            value: function lock() {
                this.locked = true;
            }
        },
        {
            key: "getKeys",
            value: function getKeys() {
                return new Set(this.keyToLocation.keys());
            }
        },
        {
            key: "getScale",
            value: function getScale(_ref) {
                var w = _ref.w, h = _ref.h;
                var texHeight = this.texHeight, maxTexWidth = this.texSize;
                // try to fit to the height of a row
                var scale = texHeight / h; // TODO what about pixelRatio?
                var texW = w * scale;
                var texH = h * scale;
                // if the scaled width is too wide then scale to fit max width instead
                if (texW > maxTexWidth) {
                    scale = maxTexWidth / w;
                    texW = w * scale;
                    texH = h * scale;
                }
                return {
                    scale: scale,
                    texW: texW,
                    texH: texH
                };
            }
        },
        {
            key: "draw",
            value: function draw(key, bb, doDrawing) {
                var _this = this;
                if (this.locked) throw new Error('can\'t draw, atlas is locked');
                var texSize = this.texSize, texRows = this.texRows, texHeight = this.texHeight;
                var _this$getScale = this.getScale(bb), scale = _this$getScale.scale, texW = _this$getScale.texW, texH = _this$getScale.texH;
                var drawAt = function drawAt(location, canvas) {
                    if (doDrawing && canvas) {
                        var context = canvas.context;
                        var x = location.x, row = location.row;
                        var xOffset = x;
                        var yOffset = texHeight * row;
                        context.save();
                        context.translate(xOffset, yOffset);
                        context.scale(scale, scale);
                        doDrawing(context, bb);
                        context.restore();
                    }
                };
                var locations = [
                    null,
                    null
                ];
                var drawNormal = function drawNormal() {
                    // don't need to wrap, draw directly on the canvas
                    drawAt(_this.freePointer, _this.canvas);
                    locations[0] = {
                        x: _this.freePointer.x,
                        y: _this.freePointer.row * texHeight,
                        w: texW,
                        h: texH
                    };
                    locations[1] = {
                        // create a second location with a width of 0, for convenience
                        x: _this.freePointer.x + texW,
                        y: _this.freePointer.row * texHeight,
                        w: 0,
                        h: texH
                    };
                    // move the pointer to the end of the texture
                    _this.freePointer.x += texW;
                    if (_this.freePointer.x == texSize) {
                        _this.freePointer.x = 0;
                        _this.freePointer.row++;
                    }
                };
                var drawWrapped = function drawWrapped() {
                    var scratch = _this.scratch, canvas = _this.canvas;
                    // Draw to the scratch canvas
                    scratch.clear();
                    drawAt({
                        x: 0,
                        row: 0
                    }, scratch);
                    var firstTexW = texSize - _this.freePointer.x;
                    var secondTexW = texW - firstTexW;
                    var h = texHeight;
                    // copy first part of scratch to the first texture
                    var dx = _this.freePointer.x;
                    var dy = _this.freePointer.row * texHeight;
                    var w = firstTexW;
                    canvas.context.drawImage(scratch, 0, 0, w, h, dx, dy, w, h);
                    locations[0] = {
                        x: dx,
                        y: dy,
                        w: w,
                        h: texH
                    };
                    // copy second part of scratch to the second texture
                    var sx = firstTexW;
                    var _dy = (_this.freePointer.row + 1) * texHeight;
                    var _w = secondTexW;
                    if (canvas) canvas.context.drawImage(scratch, sx, 0, _w, h, 0, _dy, _w, h);
                    locations[1] = {
                        x: 0,
                        y: _dy,
                        w: _w,
                        h: texH
                    };
                    _this.freePointer.x = secondTexW;
                    _this.freePointer.row++;
                };
                var moveToStartOfNextRow = function moveToStartOfNextRow() {
                    _this.freePointer.x = 0;
                    _this.freePointer.row++;
                };
                if (this.freePointer.x + texW <= texSize) // There's enough space in the current row
                drawNormal();
                else if (this.freePointer.row >= texRows - 1) // Need to move to the next row, but there are no more rows, atlas is full.
                return false;
                else if (this.freePointer.x === texSize) {
                    // happen to be right at end of current row
                    moveToStartOfNextRow();
                    drawNormal();
                } else if (this.enableWrapping) // draw part of the texture to the end of the curent row, then wrap to the next row
                drawWrapped();
                else {
                    // move to the start of the next row, then draw normally
                    moveToStartOfNextRow();
                    drawNormal();
                }
                this.keyToLocation.set(key, locations);
                this.needsBuffer = true;
                return locations;
            }
        },
        {
            key: "getOffsets",
            value: function getOffsets(key) {
                return this.keyToLocation.get(key);
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return this.freePointer.x === 0 && this.freePointer.row === 0;
            }
        },
        {
            key: "canFit",
            value: function canFit(bb) {
                if (this.locked) return false;
                var texSize = this.texSize, texRows = this.texRows;
                var _this$getScale2 = this.getScale(bb), texW = _this$getScale2.texW;
                if (this.freePointer.x + texW > texSize) // need to wrap
                return this.freePointer.row < texRows - 1; // return true if there's a row to wrap to
                return true;
            }
        },
        {
            key: "bufferIfNeeded",
            value: function bufferIfNeeded(gl) {
                if (!this.texture) this.texture = $e815fda779bc047b$var$createTexture(gl, this.debugID);
                if (this.needsBuffer) {
                    this.texture.buffer(this.canvas);
                    this.needsBuffer = false;
                    if (this.locked) {
                        this.canvas = null;
                        this.scratch = null;
                    }
                }
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                if (this.texture) {
                    this.texture.deleteTexture();
                    this.texture = null;
                }
                this.canvas = null;
                this.scratch = null;
                this.locked = true;
            }
        }
    ]);
}();
/**
 * A collection of texture atlases, all of the same "render type". 
 * ('node-body' is an example of a render type.)
 * An AtlasCollection can also be notified when a texture is no longer needed, 
 * and it can garbage collect the unused textures.
 */ var $e815fda779bc047b$var$AtlasCollection = /*#__PURE__*/ function() {
    function AtlasCollection(r, texSize, texRows, createTextureCanvas) {
        $e815fda779bc047b$var$_classCallCheck(this, AtlasCollection);
        this.r = r;
        this.texSize = texSize;
        this.texRows = texRows;
        this.createTextureCanvas = createTextureCanvas;
        this.atlases = [];
        this.styleKeyToAtlas = new Map();
        this.markedKeys = new Set(); // marked for garbage collection
    }
    return $e815fda779bc047b$var$_createClass(AtlasCollection, [
        {
            key: "getKeys",
            value: function getKeys() {
                return new Set(this.styleKeyToAtlas.keys());
            }
        },
        {
            key: "_createAtlas",
            value: function _createAtlas() {
                var r = this.r, texSize = this.texSize, texRows = this.texRows, createTextureCanvas = this.createTextureCanvas;
                return new $e815fda779bc047b$var$Atlas(r, texSize, texRows, createTextureCanvas);
            }
        },
        {
            key: "_getScratchCanvas",
            value: function _getScratchCanvas() {
                if (!this.scratch) {
                    var r = this.r, texSize = this.texSize, texRows = this.texRows, createTextureCanvas = this.createTextureCanvas;
                    var texHeight = Math.floor(texSize / texRows);
                    this.scratch = createTextureCanvas(r, texSize, texHeight, 'scratch');
                }
                return this.scratch;
            }
        },
        {
            key: "draw",
            value: function draw(key, bb, doDrawing) {
                var atlas = this.styleKeyToAtlas.get(key);
                if (!atlas) {
                    // check for space at the end of the last atlas
                    atlas = this.atlases[this.atlases.length - 1];
                    if (!atlas || !atlas.canFit(bb)) {
                        if (atlas) atlas.lock();
                        // create a new atlas
                        atlas = this._createAtlas();
                        this.atlases.push(atlas);
                    }
                    atlas.draw(key, bb, doDrawing);
                    this.styleKeyToAtlas.set(key, atlas);
                }
                return atlas;
            }
        },
        {
            key: "getAtlas",
            value: function getAtlas(key) {
                return this.styleKeyToAtlas.get(key);
            }
        },
        {
            key: "hasAtlas",
            value: function hasAtlas(key) {
                return this.styleKeyToAtlas.has(key);
            }
        },
        {
            key: "markKeyForGC",
            value: function markKeyForGC(key) {
                this.markedKeys.add(key);
            }
        },
        {
            key: "gc",
            value: function gc() {
                var _this2 = this;
                var markedKeys = this.markedKeys;
                if (markedKeys.size === 0) {
                    console.log('nothing to garbage collect');
                    return;
                }
                var newAtlases = [];
                var newStyleKeyToAtlas = new Map();
                var newAtlas = null;
                var _iterator = $e815fda779bc047b$var$_createForOfIteratorHelper(this.atlases), _step;
                try {
                    var _loop = function _loop() {
                        var atlas = _step.value;
                        var keys = atlas.getKeys();
                        var keysToCollect = $e815fda779bc047b$var$intersection(markedKeys, keys);
                        if (keysToCollect.size === 0) {
                            // this atlas can still be used
                            newAtlases.push(atlas);
                            keys.forEach(function(k) {
                                return newStyleKeyToAtlas.set(k, atlas);
                            });
                            return 1; // continue
                        }
                        if (!newAtlas) {
                            newAtlas = _this2._createAtlas();
                            newAtlases.push(newAtlas);
                        }
                        var _iterator2 = $e815fda779bc047b$var$_createForOfIteratorHelper(keys), _step2;
                        try {
                            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                                var key = _step2.value;
                                if (!keysToCollect.has(key)) {
                                    var _atlas$getOffsets = atlas.getOffsets(key), _atlas$getOffsets2 = $e815fda779bc047b$var$_slicedToArray(_atlas$getOffsets, 2), s1 = _atlas$getOffsets2[0], s2 = _atlas$getOffsets2[1];
                                    if (!newAtlas.canFit({
                                        w: s1.w + s2.w,
                                        h: s1.h
                                    })) {
                                        newAtlas.lock();
                                        newAtlas = _this2._createAtlas();
                                        newAtlases.push(newAtlas);
                                    }
                                    if (atlas.canvas) {
                                        // if the texture can't be copied then it will have to be redrawn on the next frame
                                        _this2._copyTextureToNewAtlas(key, atlas, newAtlas);
                                        newStyleKeyToAtlas.set(key, newAtlas);
                                    }
                                }
                            }
                        } catch (err) {
                            _iterator2.e(err);
                        } finally{
                            _iterator2.f();
                        }
                        atlas.dispose();
                    };
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        if (_loop()) continue;
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                this.atlases = newAtlases;
                this.styleKeyToAtlas = newStyleKeyToAtlas;
                this.markedKeys = new Set();
            }
        },
        {
            key: "_copyTextureToNewAtlas",
            value: function _copyTextureToNewAtlas(key, oldAtlas, newAtlas) {
                var _oldAtlas$getOffsets = oldAtlas.getOffsets(key), _oldAtlas$getOffsets2 = $e815fda779bc047b$var$_slicedToArray(_oldAtlas$getOffsets, 2), s1 = _oldAtlas$getOffsets2[0], s2 = _oldAtlas$getOffsets2[1];
                if (s2.w === 0) // the texture does not wrap, draw directly to new atlas
                newAtlas.draw(key, s1, function(context) {
                    context.drawImage(oldAtlas.canvas, s1.x, s1.y, s1.w, s1.h, 0, 0, s1.w, s1.h);
                });
                else {
                    // the texture wraps, first draw both parts to a scratch canvas
                    var scratch = this._getScratchCanvas();
                    scratch.clear();
                    scratch.context.drawImage(oldAtlas.canvas, s1.x, s1.y, s1.w, s1.h, 0, 0, s1.w, s1.h);
                    scratch.context.drawImage(oldAtlas.canvas, s2.x, s2.y, s2.w, s2.h, s1.w, 0, s2.w, s2.h);
                    // now draw the scratch to the new atlas
                    var w = s1.w + s2.w;
                    var h = s1.h;
                    newAtlas.draw(key, {
                        w: w,
                        h: h
                    }, function(context) {
                        context.drawImage(scratch, 0, 0, w, h, 0, 0, w, h // the destination context has already been translated to the correct position
                        );
                    });
                }
            }
        },
        {
            key: "getCounts",
            value: function getCounts() {
                return {
                    keyCount: this.styleKeyToAtlas.size,
                    atlasCount: new Set(this.styleKeyToAtlas.values()).size
                };
            }
        }
    ]);
}();
function $e815fda779bc047b$var$intersection(set1, set2) {
    // TODO why no Set.intersection in node 16???
    if (set1.intersection) return set1.intersection(set2);
    else return new Set($e815fda779bc047b$var$_toConsumableArray(set1).filter(function(x) {
        return set2.has(x);
    }));
}
/**
 * Used to manage batches of Atlases for drawing nodes and labels.
 * Supports different types of AtlasCollections for different render types,
 * for example 'node-body' and 'node-label' would be different render types.
 * Render types are kept separate because they will likely need to be garbage collected
 * separately and its not entierly guaranteed that their style keys won't collide.
 */ var $e815fda779bc047b$var$AtlasManager = /*#__PURE__*/ function() {
    function AtlasManager(r, globalOptions) {
        $e815fda779bc047b$var$_classCallCheck(this, AtlasManager);
        this.r = r;
        this.globalOptions = globalOptions;
        this.atlasSize = globalOptions.webglTexSize;
        this.maxAtlasesPerBatch = globalOptions.webglTexPerBatch;
        this.renderTypes = new Map(); // renderType:string -> renderTypeOptions
        this.collections = new Map(); // collectionName:string -> AtlasCollection
        this.typeAndIdToKey = new Map(); // [renderType,id] => Array<style key>
    }
    return $e815fda779bc047b$var$_createClass(AtlasManager, [
        {
            key: "getAtlasSize",
            value: function getAtlasSize() {
                return this.atlasSize;
            }
        },
        {
            key: "addAtlasCollection",
            value: function addAtlasCollection(collectionName, atlasCollectionOptions) {
                var _this$globalOptions = this.globalOptions, webglTexSize = _this$globalOptions.webglTexSize, createTextureCanvas = _this$globalOptions.createTextureCanvas;
                var texRows = atlasCollectionOptions.texRows;
                var cachedCreateTextureCanvas = this._cacheScratchCanvas(createTextureCanvas);
                var atlasCollection = new $e815fda779bc047b$var$AtlasCollection(this.r, webglTexSize, texRows, cachedCreateTextureCanvas);
                this.collections.set(collectionName, atlasCollection);
            }
        },
        {
            key: "addRenderType",
            value: function addRenderType(type, renderTypeOptions) {
                var collection = renderTypeOptions.collection;
                if (!this.collections.has(collection)) throw new Error("invalid atlas collection name '".concat(collection, "'"));
                var atlasCollection = this.collections.get(collection);
                var opts = $e815fda779bc047b$var$extend({
                    type: type,
                    atlasCollection: atlasCollection
                }, renderTypeOptions);
                this.renderTypes.set(type, opts);
            }
        },
        {
            key: "getRenderTypeOpts",
            value: function getRenderTypeOpts(type) {
                return this.renderTypes.get(type);
            }
        },
        {
            key: "getAtlasCollection",
            value: function getAtlasCollection(name) {
                return this.collections.get(name);
            }
        },
        {
            key: "_cacheScratchCanvas",
            value: function _cacheScratchCanvas(createTextureCanvas) {
                // all scratch canvases for the same render type will have the same width and height (ie webglTexRows option)
                // but we'll keep track of the width and height just to be safe
                var prevW = -1;
                var prevH = -1;
                var scratchCanvas = null;
                return function(r, w, h, scratch) {
                    if (scratch) {
                        if (!scratchCanvas || w != prevW || h != prevH) {
                            prevW = w;
                            prevH = h;
                            scratchCanvas = createTextureCanvas(r, w, h);
                        }
                        return scratchCanvas;
                    } else return createTextureCanvas(r, w, h);
                };
            }
        },
        {
            key: "_key",
            value: function _key(renderType, id) {
                return "".concat(renderType, "-").concat(id); // TODO not very efficient
            }
        },
        {
            key: "invalidate",
            value: function invalidate(eles) {
                var _this3 = this;
                var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref2$forceRedraw = _ref2.forceRedraw, forceRedraw = _ref2$forceRedraw === undefined ? false : _ref2$forceRedraw, _ref2$filterEle = _ref2.filterEle, filterEle = _ref2$filterEle === undefined ? function() {
                    return true;
                } : _ref2$filterEle, _ref2$filterType = _ref2.filterType, filterType = _ref2$filterType === undefined ? function() {
                    return true;
                } : _ref2$filterType;
                var needGC = false;
                var runGCNow = false;
                var _iterator3 = $e815fda779bc047b$var$_createForOfIteratorHelper(eles), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var ele = _step3.value;
                        if (filterEle(ele)) {
                            var _iterator4 = $e815fda779bc047b$var$_createForOfIteratorHelper(this.renderTypes.values()), _step4;
                            try {
                                var _loop2 = function _loop2() {
                                    var opts = _step4.value;
                                    var renderType = opts.type;
                                    if (filterType(renderType)) {
                                        var atlasCollection = _this3.collections.get(opts.collection);
                                        var key = opts.getKey(ele);
                                        var keyArray = Array.isArray(key) ? key : [
                                            key
                                        ];
                                        // when a node's background image finishes loading, the style key doesn't change but still needs to be redrawn
                                        if (forceRedraw) {
                                            keyArray.forEach(function(key) {
                                                return atlasCollection.markKeyForGC(key);
                                            });
                                            runGCNow = true; // run GC to remove the old texture right now, that way we don't need to remember for the next gc 
                                        } else {
                                            var id = opts.getID ? opts.getID(ele) : ele.id();
                                            var mapKey = _this3._key(renderType, id);
                                            var oldKeyArray = _this3.typeAndIdToKey.get(mapKey);
                                            if (oldKeyArray !== undefined && !$e815fda779bc047b$var$arrayEqual(keyArray, oldKeyArray)) {
                                                // conservative approach, if any of the keys don't match then throw them all away
                                                needGC = true;
                                                _this3.typeAndIdToKey["delete"](mapKey);
                                                oldKeyArray.forEach(function(oldKey) {
                                                    return atlasCollection.markKeyForGC(oldKey);
                                                });
                                            }
                                        }
                                    }
                                };
                                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;)_loop2();
                            } catch (err) {
                                _iterator4.e(err);
                            } finally{
                                _iterator4.f();
                            }
                        }
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
                if (runGCNow) {
                    this.gc();
                    needGC = false;
                }
                return needGC;
            }
        },
        {
            key: "gc",
            value: function gc() {
                var _iterator5 = $e815fda779bc047b$var$_createForOfIteratorHelper(this.collections.values()), _step5;
                try {
                    for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                        var collection = _step5.value;
                        collection.gc();
                    }
                } catch (err) {
                    _iterator5.e(err);
                } finally{
                    _iterator5.f();
                }
            }
        },
        {
            key: "getOrCreateAtlas",
            value: function getOrCreateAtlas(ele, type, bb, styleKey) {
                // styleKey is not an array here
                var opts = this.renderTypes.get(type);
                var atlasCollection = this.collections.get(opts.collection);
                // draws the texture only if needed
                var drawn = false;
                var atlas = atlasCollection.draw(styleKey, bb, function(context) {
                    if (opts.drawClipped) {
                        context.save();
                        context.beginPath();
                        context.rect(0, 0, bb.w, bb.h);
                        context.clip();
                        opts.drawElement(context, ele, bb, true, true);
                        context.restore();
                    } else opts.drawElement(context, ele, bb, true, true);
                    drawn = true;
                });
                if (drawn) {
                    var id = opts.getID ? opts.getID(ele) : ele.id(); // for testing
                    var mapKey = this._key(type, id);
                    if (this.typeAndIdToKey.has(mapKey)) this.typeAndIdToKey.get(mapKey).push(styleKey);
                    else this.typeAndIdToKey.set(mapKey, [
                        styleKey
                    ]);
                }
                return atlas;
            }
        },
        {
            key: "getAtlasInfo",
            value: function getAtlasInfo(ele, type) {
                var _this4 = this;
                var opts = this.renderTypes.get(type);
                var key = opts.getKey(ele);
                var keyArray = Array.isArray(key) ? key : [
                    key
                ];
                return keyArray.map(function(styleKey) {
                    var bb = opts.getBoundingBox(ele, styleKey); // pass the key back to the getBoundingBox method
                    var atlas = _this4.getOrCreateAtlas(ele, type, bb, styleKey);
                    var _atlas$getOffsets3 = atlas.getOffsets(styleKey), _atlas$getOffsets4 = $e815fda779bc047b$var$_slicedToArray(_atlas$getOffsets3, 2), tex1 = _atlas$getOffsets4[0], tex2 = _atlas$getOffsets4[1];
                    return {
                        atlas: atlas,
                        tex: tex1,
                        tex1: tex1,
                        tex2: tex2,
                        bb: bb
                    };
                });
            }
        },
        {
            key: "getDebugInfo",
            value: function getDebugInfo() {
                var debugInfo = [];
                var _iterator6 = $e815fda779bc047b$var$_createForOfIteratorHelper(this.collections), _step6;
                try {
                    for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                        var _step6$value = $e815fda779bc047b$var$_slicedToArray(_step6.value, 2), name = _step6$value[0], collection = _step6$value[1];
                        var _collection$getCounts = collection.getCounts(), keyCount = _collection$getCounts.keyCount, atlasCount = _collection$getCounts.atlasCount;
                        debugInfo.push({
                            type: name,
                            keyCount: keyCount,
                            atlasCount: atlasCount
                        });
                    }
                } catch (err) {
                    _iterator6.e(err);
                } finally{
                    _iterator6.f();
                }
                return debugInfo;
            }
        }
    ]);
}();
var $e815fda779bc047b$var$AtlasBatchManager = /*#__PURE__*/ function() {
    function AtlasBatchManager(globalOptions) {
        $e815fda779bc047b$var$_classCallCheck(this, AtlasBatchManager);
        this.globalOptions = globalOptions;
        this.atlasSize = globalOptions.webglTexSize;
        this.maxAtlasesPerBatch = globalOptions.webglTexPerBatch;
        this.batchAtlases = [];
    }
    return $e815fda779bc047b$var$_createClass(AtlasBatchManager, [
        {
            key: "getMaxAtlasesPerBatch",
            value: function getMaxAtlasesPerBatch() {
                return this.maxAtlasesPerBatch;
            }
        },
        {
            key: "getAtlasSize",
            value: function getAtlasSize() {
                return this.atlasSize;
            }
        },
        {
            key: "getIndexArray",
            value: function getIndexArray() {
                return Array.from({
                    length: this.maxAtlasesPerBatch
                }, function(v, i) {
                    return i;
                });
            }
        },
        {
            key: "startBatch",
            value: function startBatch() {
                this.batchAtlases = [];
            }
        },
        {
            key: "getAtlasCount",
            value: function getAtlasCount() {
                return this.batchAtlases.length;
            }
        },
        {
            key: "getAtlases",
            value: function getAtlases() {
                return this.batchAtlases;
            }
        },
        {
            key: "canAddToCurrentBatch",
            value: function canAddToCurrentBatch(atlas) {
                if (this.batchAtlases.length === this.maxAtlasesPerBatch) return this.batchAtlases.includes(atlas);
                return true; // not full
            }
        },
        {
            key: "getAtlasIndexForBatch",
            value: function getAtlasIndexForBatch(atlas) {
                var atlasID = this.batchAtlases.indexOf(atlas);
                if (atlasID < 0) {
                    if (this.batchAtlases.length === this.maxAtlasesPerBatch) throw new Error('cannot add more atlases to batch');
                    this.batchAtlases.push(atlas);
                    atlasID = this.batchAtlases.length - 1;
                }
                return atlasID;
            }
        }
    ]);
}();
// Fragment shader functions to calculate signed distance
// https://iquilezles.org/articles/distfunctions2d/
// ellipse: https://www.shadertoy.com/view/4lsXDN 
/**
 * param p - point
 * float r - circle radius, eg 0.5 for unit circle
 */ var $e815fda779bc047b$var$circleSD = "\n  float circleSD(vec2 p, float r) {\n    return distance(vec2(0), p) - r; // signed distance\n  }\n";
/**
 * param p - point
 * param b - b.x = half width, b.y = half height
 */ var $e815fda779bc047b$var$rectangleSD = "\n  float rectangleSD(vec2 p, vec2 b) {\n    vec2 d = abs(p)-b;\n    return distance(vec2(0),max(d,0.0)) + min(max(d.x,d.y),0.0);\n  }\n";
/**
 * param p - point
 * param b - b.x = half width, b.y = half height
 * param cr - vector of corner radiuses
 */ var $e815fda779bc047b$var$roundRectangleSD = "\n  float roundRectangleSD(vec2 p, vec2 b, vec4 cr) {\n    cr.xy = (p.x > 0.0) ? cr.xy : cr.zw;\n    cr.x  = (p.y > 0.0) ? cr.x  : cr.y;\n    vec2 q = abs(p) - b + cr.x;\n    return min(max(q.x, q.y), 0.0) + distance(vec2(0), max(q, 0.0)) - cr.x;\n  }\n";
/**
 * param p - point
 * param ab - a.x = horizontal radius, a.y = vertical radius
 */ var $e815fda779bc047b$var$ellipseSD = "\n  float ellipseSD(vec2 p, vec2 ab) {\n    p = abs( p ); // symmetry\n\n    // find root with Newton solver\n    vec2 q = ab*(p-ab);\n    float w = (q.x<q.y)? 1.570796327 : 0.0;\n    for( int i=0; i<5; i++ ) {\n      vec2 cs = vec2(cos(w),sin(w));\n      vec2 u = ab*vec2( cs.x,cs.y);\n      vec2 v = ab*vec2(-cs.y,cs.x);\n      w = w + dot(p-u,v)/(dot(p-u,u)+dot(v,v));\n    }\n    \n    // compute final point and distance\n    float d = length(p-ab*vec2(cos(w),sin(w)));\n    \n    // return signed distance\n    return (dot(p/ab,p/ab)>1.0) ? d : -d;\n  }\n";
/**
 * Two render modes. Each mode has its own shader program. They are almost identical, the main difference is the output.
 * SCREEN:  output pixel colors to the screen
 * PICKING: output z-order index to an offscreen framebuffer, used to detect what's under the mouse cursor
 */ var $e815fda779bc047b$var$RENDER_TARGET = {
    SCREEN: {
        name: 'screen',
        screen: true
    },
    PICKING: {
        name: 'picking',
        picking: true
    }
};
/**
 * Special handing for label textures in PICKING mode. See issue #3337.
 */ var $e815fda779bc047b$var$TEX_PICKING_MODE = {
    // render the texture just like in RENDER_TARGET.SCREEN mode
    IGNORE: 1,
    // don't render the texture at all
    USE_BB: 2 // render the bounding box as an opaque rectangle
};
// Vertex types.
// Used directly in the shaders so must be numeric.
// There is only one shader program used for an entire frame that renders all types of elements.
// There are if-else blocks in the shaders that do different things depending on the vertex type.
// This allows all elements to be rendererd in large batches without switching shader programs.
var $e815fda779bc047b$var$TEXTURE = 0;
var $e815fda779bc047b$var$EDGE_STRAIGHT = 1;
var $e815fda779bc047b$var$EDGE_CURVE_SEGMENT = 2;
var $e815fda779bc047b$var$EDGE_ARROW = 3;
var $e815fda779bc047b$var$RECTANGLE = 4;
var $e815fda779bc047b$var$ROUND_RECTANGLE = 5;
var $e815fda779bc047b$var$BOTTOM_ROUND_RECTANGLE = 6;
var $e815fda779bc047b$var$ELLIPSE = 7;
var $e815fda779bc047b$var$ElementDrawingWebGL = /*#__PURE__*/ function() {
    /**
   * @param {WebGLRenderingContext} gl
   */ function ElementDrawingWebGL(r, gl, opts) {
        $e815fda779bc047b$var$_classCallCheck(this, ElementDrawingWebGL);
        this.r = r; // reference to the canvas renderer
        this.gl = gl;
        this.maxInstances = opts.webglBatchSize;
        this.atlasSize = opts.webglTexSize;
        this.bgColor = opts.bgColor;
        this.debug = opts.webglDebug;
        this.batchDebugInfo = [];
        opts.enableWrapping = true;
        opts.createTextureCanvas = $e815fda779bc047b$var$createTextureCanvas; // Unit tests mock this
        this.atlasManager = new $e815fda779bc047b$var$AtlasManager(r, opts);
        this.batchManager = new $e815fda779bc047b$var$AtlasBatchManager(opts);
        this.simpleShapeOptions = new Map();
        this.program = this._createShaderProgram($e815fda779bc047b$var$RENDER_TARGET.SCREEN);
        this.pickingProgram = this._createShaderProgram($e815fda779bc047b$var$RENDER_TARGET.PICKING);
        this.vao = this._createVAO();
    }
    /**
   * @param { string } collectionName
   * @param {{ texRows: number }} opts
   */ return $e815fda779bc047b$var$_createClass(ElementDrawingWebGL, [
        {
            key: "addAtlasCollection",
            value: function addAtlasCollection(collectionName, opts) {
                this.atlasManager.addAtlasCollection(collectionName, opts);
            }
        },
        {
            key: "addTextureAtlasRenderType",
            value: function addTextureAtlasRenderType(typeName, opts) {
                this.atlasManager.addRenderType(typeName, opts);
            }
        },
        {
            key: "addSimpleShapeRenderType",
            value: function addSimpleShapeRenderType(typeName, opts) {
                this.simpleShapeOptions.set(typeName, opts);
            }
        },
        {
            key: "invalidate",
            value: function invalidate(eles) {
                var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, type = _ref.type;
                var atlasManager = this.atlasManager;
                if (type) return atlasManager.invalidate(eles, {
                    filterType: function filterType(t) {
                        return t === type;
                    },
                    forceRedraw: true
                });
                else return atlasManager.invalidate(eles);
            }
        },
        {
            key: "gc",
            value: function gc() {
                this.atlasManager.gc();
            }
        },
        {
            key: "_createShaderProgram",
            value: function _createShaderProgram(renderTarget) {
                var gl = this.gl;
                var vertexShaderSource = "#version 300 es\n      precision highp float;\n\n      uniform mat3 uPanZoomMatrix;\n      uniform int  uAtlasSize;\n      \n      // instanced\n      in vec2 aPosition; // a vertex from the unit square\n      \n      in mat3 aTransform; // used to transform verticies, eg into a bounding box\n      in int aVertType; // the type of thing we are rendering\n\n      // the z-index that is output when using picking mode\n      in vec4 aIndex;\n      \n      // For textures\n      in int aAtlasId; // which shader unit/atlas to use\n      in vec4 aTex; // x/y/w/h of texture in atlas\n\n      // for edges\n      in vec4 aPointAPointB;\n      in vec4 aPointCPointD;\n      in vec2 aLineWidth; // also used for node border width\n\n      // simple shapes\n      in vec4 aCornerRadius; // for round-rectangle [top-right, bottom-right, top-left, bottom-left]\n      in vec4 aColor; // also used for edges\n      in vec4 aBorderColor; // aLineWidth is used for border width\n\n      // output values passed to the fragment shader\n      out vec2 vTexCoord;\n      out vec4 vColor;\n      out vec2 vPosition;\n      // flat values are not interpolated\n      flat out int vAtlasId; \n      flat out int vVertType;\n      flat out vec2 vTopRight;\n      flat out vec2 vBotLeft;\n      flat out vec4 vCornerRadius;\n      flat out vec4 vBorderColor;\n      flat out vec2 vBorderWidth;\n      flat out vec4 vIndex;\n      \n      void main(void) {\n        int vid = gl_VertexID;\n        vec2 position = aPosition; // TODO make this a vec3, simplifies some code below\n\n        if(aVertType == ".concat($e815fda779bc047b$var$TEXTURE, ") {\n          float texX = aTex.x; // texture coordinates\n          float texY = aTex.y;\n          float texW = aTex.z;\n          float texH = aTex.w;\n\n          if(vid == 1 || vid == 2 || vid == 4) {\n            texX += texW;\n          }\n          if(vid == 2 || vid == 4 || vid == 5) {\n            texY += texH;\n          }\n\n          float d = float(uAtlasSize);\n          vTexCoord = vec2(texX / d, texY / d); // tex coords must be between 0 and 1\n\n          gl_Position = vec4(uPanZoomMatrix * aTransform * vec3(position, 1.0), 1.0);\n        }\n        else if(aVertType == ").concat($e815fda779bc047b$var$RECTANGLE, " || aVertType == ").concat($e815fda779bc047b$var$ELLIPSE, " \n             || aVertType == ").concat($e815fda779bc047b$var$ROUND_RECTANGLE, " || aVertType == ").concat($e815fda779bc047b$var$BOTTOM_ROUND_RECTANGLE, ") { // simple shapes\n\n          // the bounding box is needed by the fragment shader\n          vBotLeft  = (aTransform * vec3(0, 0, 1)).xy; // flat\n          vTopRight = (aTransform * vec3(1, 1, 1)).xy; // flat\n          vPosition = (aTransform * vec3(position, 1)).xy; // will be interpolated\n\n          // calculations are done in the fragment shader, just pass these along\n          vColor = aColor;\n          vCornerRadius = aCornerRadius;\n          vBorderColor = aBorderColor;\n          vBorderWidth = aLineWidth;\n\n          gl_Position = vec4(uPanZoomMatrix * aTransform * vec3(position, 1.0), 1.0);\n        }\n        else if(aVertType == ").concat($e815fda779bc047b$var$EDGE_STRAIGHT, ") {\n          vec2 source = aPointAPointB.xy;\n          vec2 target = aPointAPointB.zw;\n\n          // adjust the geometry so that the line is centered on the edge\n          position.y = position.y - 0.5;\n\n          // stretch the unit square into a long skinny rectangle\n          vec2 xBasis = target - source;\n          vec2 yBasis = normalize(vec2(-xBasis.y, xBasis.x));\n          vec2 point = source + xBasis * position.x + yBasis * aLineWidth[0] * position.y;\n\n          gl_Position = vec4(uPanZoomMatrix * vec3(point, 1.0), 1.0);\n          vColor = aColor;\n        } \n        else if(aVertType == ").concat($e815fda779bc047b$var$EDGE_CURVE_SEGMENT, ") {\n          vec2 pointA = aPointAPointB.xy;\n          vec2 pointB = aPointAPointB.zw;\n          vec2 pointC = aPointCPointD.xy;\n          vec2 pointD = aPointCPointD.zw;\n\n          // adjust the geometry so that the line is centered on the edge\n          position.y = position.y - 0.5;\n\n          vec2 p0, p1, p2, pos;\n          if(position.x == 0.0) { // The left side of the unit square\n            p0 = pointA;\n            p1 = pointB;\n            p2 = pointC;\n            pos = position;\n          } else { // The right side of the unit square, use same approach but flip the geometry upside down\n            p0 = pointD;\n            p1 = pointC;\n            p2 = pointB;\n            pos = vec2(0.0, -position.y);\n          }\n\n          vec2 p01 = p1 - p0;\n          vec2 p12 = p2 - p1;\n          vec2 p21 = p1 - p2;\n\n          // Find the normal vector.\n          vec2 tangent = normalize(normalize(p12) + normalize(p01));\n          vec2 normal = vec2(-tangent.y, tangent.x);\n\n          // Find the vector perpendicular to p0 -> p1.\n          vec2 p01Norm = normalize(vec2(-p01.y, p01.x));\n\n          // Determine the bend direction.\n          float sigma = sign(dot(p01 + p21, normal));\n          float width = aLineWidth[0];\n\n          if(sign(pos.y) == -sigma) {\n            // This is an intersecting vertex. Adjust the position so that there's no overlap.\n            vec2 point = 0.5 * width * normal * -sigma / dot(normal, p01Norm);\n            gl_Position = vec4(uPanZoomMatrix * vec3(p1 + point, 1.0), 1.0);\n          } else {\n            // This is a non-intersecting vertex. Treat it like a mitre join.\n            vec2 point = 0.5 * width * normal * sigma * dot(normal, p01Norm);\n            gl_Position = vec4(uPanZoomMatrix * vec3(p1 + point, 1.0), 1.0);\n          }\n\n          vColor = aColor;\n        } \n        else if(aVertType == ").concat($e815fda779bc047b$var$EDGE_ARROW, " && vid < 3) {\n          // massage the first triangle into an edge arrow\n          if(vid == 0)\n            position = vec2(-0.15, -0.3);\n          if(vid == 1)\n            position = vec2(  0.0,  0.0);\n          if(vid == 2)\n            position = vec2( 0.15, -0.3);\n\n          gl_Position = vec4(uPanZoomMatrix * aTransform * vec3(position, 1.0), 1.0);\n          vColor = aColor;\n        }\n        else {\n          gl_Position = vec4(2.0, 0.0, 0.0, 1.0); // discard vertex by putting it outside webgl clip space\n        }\n\n        vAtlasId = aAtlasId;\n        vVertType = aVertType;\n        vIndex = aIndex;\n      }\n    ");
                var idxs = this.batchManager.getIndexArray();
                var fragmentShaderSource = "#version 300 es\n      precision highp float;\n\n      // declare texture unit for each texture atlas in the batch\n      ".concat(idxs.map(function(i) {
                    return "uniform sampler2D uTexture".concat(i, ";");
                }).join('\n\t'), "\n\n      uniform vec4 uBGColor;\n      uniform float uZoom;\n\n      in vec2 vTexCoord;\n      in vec4 vColor;\n      in vec2 vPosition; // model coordinates\n\n      flat in int vAtlasId;\n      flat in vec4 vIndex;\n      flat in int vVertType;\n      flat in vec2 vTopRight;\n      flat in vec2 vBotLeft;\n      flat in vec4 vCornerRadius;\n      flat in vec4 vBorderColor;\n      flat in vec2 vBorderWidth;\n\n      out vec4 outColor;\n\n      ").concat($e815fda779bc047b$var$circleSD, "\n      ").concat($e815fda779bc047b$var$rectangleSD, "\n      ").concat($e815fda779bc047b$var$roundRectangleSD, "\n      ").concat($e815fda779bc047b$var$ellipseSD, "\n\n      vec4 blend(vec4 top, vec4 bot) { // blend colors with premultiplied alpha\n        return vec4( \n          top.rgb + (bot.rgb * (1.0 - top.a)),\n          top.a   + (bot.a   * (1.0 - top.a)) \n        );\n      }\n\n      vec4 distInterp(vec4 cA, vec4 cB, float d) { // interpolate color using Signed Distance\n        // scale to the zoom level so that borders don't look blurry when zoomed in\n        // note 1.5 is an aribitrary value chosen because it looks good\n        return mix(cA, cB, 1.0 - smoothstep(0.0, 1.5 / uZoom, abs(d))); \n      }\n\n      void main(void) {\n        if(vVertType == ").concat($e815fda779bc047b$var$TEXTURE, ") {\n          // look up the texel from the texture unit\n          ").concat(idxs.map(function(i) {
                    return "if(vAtlasId == ".concat(i, ") outColor = texture(uTexture").concat(i, ", vTexCoord);");
                }).join('\n\telse '), "\n        } \n        else if(vVertType == ").concat($e815fda779bc047b$var$EDGE_ARROW, ") {\n          // mimics how canvas renderer uses context.globalCompositeOperation = 'destination-out';\n          outColor = blend(vColor, uBGColor);\n          outColor.a = 1.0; // make opaque, masks out line under arrow\n        }\n        else if(vVertType == ").concat($e815fda779bc047b$var$RECTANGLE, " && vBorderWidth == vec2(0.0)) { // simple rectangle with no border\n          outColor = vColor; // unit square is already transformed to the rectangle, nothing else needs to be done\n        }\n        else if(vVertType == ").concat($e815fda779bc047b$var$RECTANGLE, " || vVertType == ").concat($e815fda779bc047b$var$ELLIPSE, " \n          || vVertType == ").concat($e815fda779bc047b$var$ROUND_RECTANGLE, " || vVertType == ").concat($e815fda779bc047b$var$BOTTOM_ROUND_RECTANGLE, ") { // use SDF\n\n          float outerBorder = vBorderWidth[0];\n          float innerBorder = vBorderWidth[1];\n          float borderPadding = outerBorder * 2.0;\n          float w = vTopRight.x - vBotLeft.x - borderPadding;\n          float h = vTopRight.y - vBotLeft.y - borderPadding;\n          vec2 b = vec2(w/2.0, h/2.0); // half width, half height\n          vec2 p = vPosition - vec2(vTopRight.x - b[0] - outerBorder, vTopRight.y - b[1] - outerBorder); // translate to center\n\n          float d; // signed distance\n          if(vVertType == ").concat($e815fda779bc047b$var$RECTANGLE, ") {\n            d = rectangleSD(p, b);\n          } else if(vVertType == ").concat($e815fda779bc047b$var$ELLIPSE, " && w == h) {\n            d = circleSD(p, b.x); // faster than ellipse\n          } else if(vVertType == ").concat($e815fda779bc047b$var$ELLIPSE, ") {\n            d = ellipseSD(p, b);\n          } else {\n            d = roundRectangleSD(p, b, vCornerRadius.wzyx);\n          }\n\n          // use the distance to interpolate a color to smooth the edges of the shape, doesn't need multisampling\n          // we must smooth colors inwards, because we can't change pixels outside the shape's bounding box\n          if(d > 0.0) {\n            if(d > outerBorder) {\n              discard;\n            } else {\n              outColor = distInterp(vBorderColor, vec4(0), d - outerBorder);\n            }\n          } else {\n            if(d > innerBorder) {\n              vec4 outerColor = outerBorder == 0.0 ? vec4(0) : vBorderColor;\n              vec4 innerBorderColor = blend(vBorderColor, vColor);\n              outColor = distInterp(innerBorderColor, outerColor, d);\n            } \n            else {\n              vec4 outerColor;\n              if(innerBorder == 0.0 && outerBorder == 0.0) {\n                outerColor = vec4(0);\n              } else if(innerBorder == 0.0) {\n                outerColor = vBorderColor;\n              } else {\n                outerColor = blend(vBorderColor, vColor);\n              }\n              outColor = distInterp(vColor, outerColor, d - innerBorder);\n            }\n          }\n        }\n        else {\n          outColor = vColor;\n        }\n\n        ").concat(renderTarget.picking ? "if(outColor.a == 0.0) discard;\n             else outColor = vIndex;" : '', "\n      }\n    ");
                var program = $e815fda779bc047b$var$createProgram(gl, vertexShaderSource, fragmentShaderSource);
                // instance geometry
                program.aPosition = gl.getAttribLocation(program, 'aPosition');
                // attributes
                program.aIndex = gl.getAttribLocation(program, 'aIndex');
                program.aVertType = gl.getAttribLocation(program, 'aVertType');
                program.aTransform = gl.getAttribLocation(program, 'aTransform');
                program.aAtlasId = gl.getAttribLocation(program, 'aAtlasId');
                program.aTex = gl.getAttribLocation(program, 'aTex');
                program.aPointAPointB = gl.getAttribLocation(program, 'aPointAPointB');
                program.aPointCPointD = gl.getAttribLocation(program, 'aPointCPointD');
                program.aLineWidth = gl.getAttribLocation(program, 'aLineWidth');
                program.aColor = gl.getAttribLocation(program, 'aColor');
                program.aCornerRadius = gl.getAttribLocation(program, 'aCornerRadius');
                program.aBorderColor = gl.getAttribLocation(program, 'aBorderColor');
                // uniforms
                program.uPanZoomMatrix = gl.getUniformLocation(program, 'uPanZoomMatrix');
                program.uAtlasSize = gl.getUniformLocation(program, 'uAtlasSize');
                program.uBGColor = gl.getUniformLocation(program, 'uBGColor');
                program.uZoom = gl.getUniformLocation(program, 'uZoom');
                program.uTextures = [];
                for(var i = 0; i < this.batchManager.getMaxAtlasesPerBatch(); i++)program.uTextures.push(gl.getUniformLocation(program, "uTexture".concat(i)));
                return program;
            }
        },
        {
            key: "_createVAO",
            value: function _createVAO() {
                var unitSquare = [
                    0,
                    0,
                    1,
                    0,
                    1,
                    1,
                    0,
                    0,
                    1,
                    1,
                    0,
                    1
                ];
                this.vertexCount = unitSquare.length / 2;
                var n = this.maxInstances;
                var gl = this.gl, program = this.program;
                var vao = gl.createVertexArray();
                gl.bindVertexArray(vao);
                $e815fda779bc047b$var$createBufferStaticDraw(gl, 'vec2', program.aPosition, unitSquare);
                // Create buffers for all the attributes
                this.transformBuffer = $e815fda779bc047b$var$create3x3MatrixBufferDynamicDraw(gl, n, program.aTransform);
                this.indexBuffer = $e815fda779bc047b$var$createBufferDynamicDraw(gl, n, 'vec4', program.aIndex);
                this.vertTypeBuffer = $e815fda779bc047b$var$createBufferDynamicDraw(gl, n, 'int', program.aVertType);
                this.atlasIdBuffer = $e815fda779bc047b$var$createBufferDynamicDraw(gl, n, 'int', program.aAtlasId);
                this.texBuffer = $e815fda779bc047b$var$createBufferDynamicDraw(gl, n, 'vec4', program.aTex);
                this.pointAPointBBuffer = $e815fda779bc047b$var$createBufferDynamicDraw(gl, n, 'vec4', program.aPointAPointB);
                this.pointCPointDBuffer = $e815fda779bc047b$var$createBufferDynamicDraw(gl, n, 'vec4', program.aPointCPointD);
                this.lineWidthBuffer = $e815fda779bc047b$var$createBufferDynamicDraw(gl, n, 'vec2', program.aLineWidth);
                this.colorBuffer = $e815fda779bc047b$var$createBufferDynamicDraw(gl, n, 'vec4', program.aColor);
                this.cornerRadiusBuffer = $e815fda779bc047b$var$createBufferDynamicDraw(gl, n, 'vec4', program.aCornerRadius);
                this.borderColorBuffer = $e815fda779bc047b$var$createBufferDynamicDraw(gl, n, 'vec4', program.aBorderColor);
                gl.bindVertexArray(null);
                return vao;
            }
        },
        {
            key: "buffers",
            get: function get() {
                var _this = this;
                if (!this._buffers) this._buffers = Object.keys(this).filter(function(k) {
                    return $e815fda779bc047b$var$endsWith(k, 'Buffer');
                }).map(function(k) {
                    return _this[k];
                });
                return this._buffers;
            }
        },
        {
            key: "startFrame",
            value: function startFrame(panZoomMatrix) {
                var renderTarget = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $e815fda779bc047b$var$RENDER_TARGET.SCREEN;
                this.panZoomMatrix = panZoomMatrix;
                this.renderTarget = renderTarget;
                this.batchDebugInfo = [];
                this.wrappedCount = 0;
                this.simpleCount = 0;
                this.startBatch();
            }
        },
        {
            key: "startBatch",
            value: function startBatch() {
                this.instanceCount = 0;
                this.batchManager.startBatch();
            }
        },
        {
            key: "endFrame",
            value: function endFrame() {
                this.endBatch();
            }
        },
        {
            key: "_isVisible",
            value: function _isVisible(ele, opts) {
                if (ele.visible()) {
                    if (opts && opts.isVisible) return opts.isVisible(ele);
                    return true;
                }
                return false;
            }
        },
        {
            key: "drawTexture",
            value: function drawTexture(ele, eleIndex, type) {
                var atlasManager = this.atlasManager, batchManager = this.batchManager;
                var opts = atlasManager.getRenderTypeOpts(type);
                if (!this._isVisible(ele, opts)) return;
                // Edges with invalid points could be passed here (labels), causing errors
                // Ref: Random "Script Error" thrown when generating nodes and edges in newest webgl version #3365
                // https://github.com/cytoscape/cytoscape.js/issues/3365
                if (ele.isEdge() && !this._isValidEdge(ele)) return;
                if (this.renderTarget.picking && opts.getTexPickingMode) {
                    var mode = opts.getTexPickingMode(ele);
                    if (mode === $e815fda779bc047b$var$TEX_PICKING_MODE.IGNORE) return;
                    else if (mode == $e815fda779bc047b$var$TEX_PICKING_MODE.USE_BB) {
                        this.drawPickingRectangle(ele, eleIndex, type);
                        return;
                    }
                }
                // Get the atlas and the texture coordinates, will draw the texture if it hasn't been drawn yet
                // May be more than one texture if for example the label has multiple lines
                var atlasInfoArray = atlasManager.getAtlasInfo(ele, type);
                var _iterator = $e815fda779bc047b$var$_createForOfIteratorHelper(atlasInfoArray), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var atlasInfo = _step.value;
                        var atlas = atlasInfo.atlas, tex1 = atlasInfo.tex1, tex2 = atlasInfo.tex2; // tex2 is used if the label wraps and there are two textures
                        if (!batchManager.canAddToCurrentBatch(atlas)) this.endBatch();
                        var atlasIndex = batchManager.getAtlasIndexForBatch(atlas);
                        for(var _i = 0, _arr = [
                            [
                                tex1,
                                true
                            ],
                            [
                                tex2,
                                false
                            ]
                        ]; _i < _arr.length; _i++){
                            var _arr$_i = $e815fda779bc047b$var$_slicedToArray(_arr[_i], 2), tex = _arr$_i[0], first = _arr$_i[1];
                            if (tex.w != 0) {
                                var instance = this.instanceCount;
                                this.vertTypeBuffer.getView(instance)[0] = $e815fda779bc047b$var$TEXTURE;
                                var indexView = this.indexBuffer.getView(instance);
                                $e815fda779bc047b$var$indexToVec4(eleIndex, indexView);
                                // Set values in the buffers using Typed Array Views for performance.
                                var atlasIdView = this.atlasIdBuffer.getView(instance);
                                atlasIdView[0] = atlasIndex;
                                // we have two sets of texture coordinates and transforms because textures can wrap in the atlas
                                var texView = this.texBuffer.getView(instance);
                                texView[0] = tex.x;
                                texView[1] = tex.y;
                                texView[2] = tex.w;
                                texView[3] = tex.h;
                                var matrixView = this.transformBuffer.getMatrixView(instance);
                                this.setTransformMatrix(ele, matrixView, opts, atlasInfo, first);
                                this.instanceCount++;
                                if (!first) this.wrappedCount++;
                                if (this.instanceCount >= this.maxInstances) this.endBatch();
                            }
                        }
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
        },
        {
            key: "setTransformMatrix",
            value: function setTransformMatrix(ele, matrix, opts, atlasInfo) {
                var first = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
                var padding = 0;
                if (opts.shapeProps && opts.shapeProps.padding) padding = ele.pstyle(opts.shapeProps.padding).pfValue;
                if (atlasInfo) {
                    // we've already computed the bb and tex bounds for a texture
                    var bb = atlasInfo.bb, tex1 = atlasInfo.tex1, tex2 = atlasInfo.tex2;
                    // wrapped textures need separate matrix for each part
                    var ratio = tex1.w / (tex1.w + tex2.w);
                    if (!first) // first = true means its the first part of the wrapped texture
                    ratio = 1 - ratio;
                    var adjBB = this._getAdjustedBB(bb, padding, first, ratio);
                    this._applyTransformMatrix(matrix, adjBB, opts, ele);
                } else {
                    // we don't have a texture, or we want to avoid creating a texture for simple shapes
                    var _bb = opts.getBoundingBox(ele);
                    var _adjBB = this._getAdjustedBB(_bb, padding, true, 1);
                    this._applyTransformMatrix(matrix, _adjBB, opts, ele);
                }
            }
        },
        {
            key: "_applyTransformMatrix",
            value: function _applyTransformMatrix(matrix, adjBB, opts, ele) {
                var x, y;
                $e815fda779bc047b$var$identity(matrix);
                var theta = opts.getRotation ? opts.getRotation(ele) : 0;
                if (theta !== 0) {
                    var _opts$getRotationPoin = opts.getRotationPoint(ele), sx = _opts$getRotationPoin.x, sy = _opts$getRotationPoin.y;
                    $e815fda779bc047b$var$translate(matrix, matrix, [
                        sx,
                        sy
                    ]);
                    $e815fda779bc047b$var$rotate(matrix, matrix, theta);
                    var offset = opts.getRotationOffset(ele);
                    x = offset.x + (adjBB.xOffset || 0);
                    y = offset.y + (adjBB.yOffset || 0);
                } else {
                    x = adjBB.x1;
                    y = adjBB.y1;
                }
                $e815fda779bc047b$var$translate(matrix, matrix, [
                    x,
                    y
                ]);
                $e815fda779bc047b$var$scale(matrix, matrix, [
                    adjBB.w,
                    adjBB.h
                ]);
            }
        },
        {
            key: "_getAdjustedBB",
            value: function _getAdjustedBB(bb, padding, first, ratio) {
                var x1 = bb.x1, y1 = bb.y1, w = bb.w, h = bb.h, yOffset = bb.yOffset;
                if (padding) {
                    x1 -= padding;
                    y1 -= padding;
                    w += 2 * padding;
                    h += 2 * padding;
                }
                var xOffset = 0;
                var adjW = w * ratio;
                if (first && ratio < 1) w = adjW;
                else if (!first && ratio < 1) {
                    xOffset = w - adjW;
                    x1 += xOffset;
                    w = adjW;
                }
                return {
                    x1: x1,
                    y1: y1,
                    w: w,
                    h: h,
                    xOffset: xOffset,
                    yOffset: yOffset
                };
            }
        },
        {
            key: "drawPickingRectangle",
            value: function drawPickingRectangle(ele, eleIndex, type) {
                var opts = this.atlasManager.getRenderTypeOpts(type);
                var instance = this.instanceCount;
                this.vertTypeBuffer.getView(instance)[0] = $e815fda779bc047b$var$RECTANGLE;
                var indexView = this.indexBuffer.getView(instance);
                $e815fda779bc047b$var$indexToVec4(eleIndex, indexView);
                var colorView = this.colorBuffer.getView(instance);
                $e815fda779bc047b$var$toWebGLColor([
                    0,
                    0,
                    0
                ], 1, colorView); // opaque, so entire label BB is clickable
                var matrixView = this.transformBuffer.getMatrixView(instance);
                this.setTransformMatrix(ele, matrixView, opts);
                this.simpleCount++;
                this.instanceCount++;
                if (this.instanceCount >= this.maxInstances) this.endBatch();
            }
        },
        {
            key: "drawNode",
            value: function drawNode(node, eleIndex, type) {
                var opts = this.simpleShapeOptions.get(type);
                if (!this._isVisible(node, opts)) return;
                var props = opts.shapeProps;
                // Check if we have to use a texture
                var vertType = this._getVertTypeForShape(node, props.shape);
                if (vertType === undefined || opts.isSimple && !opts.isSimple(node, this.renderTarget)) {
                    this.drawTexture(node, eleIndex, type);
                    return;
                }
                // Render a "simple shape" using SDF (signed distance fields)
                var instance = this.instanceCount;
                this.vertTypeBuffer.getView(instance)[0] = vertType;
                if (vertType === $e815fda779bc047b$var$ROUND_RECTANGLE || vertType === $e815fda779bc047b$var$BOTTOM_ROUND_RECTANGLE) {
                    // get corner radius
                    var bb = opts.getBoundingBox(node);
                    var radius = this._getCornerRadius(node, props.radius, bb);
                    var radiusView = this.cornerRadiusBuffer.getView(instance);
                    radiusView[0] = radius; // top-right
                    radiusView[1] = radius; // bottom-right
                    radiusView[2] = radius; // top-left
                    radiusView[3] = radius; // bottom-left
                    if (vertType === $e815fda779bc047b$var$BOTTOM_ROUND_RECTANGLE) {
                        radiusView[0] = 0;
                        radiusView[2] = 0;
                    }
                }
                var indexView = this.indexBuffer.getView(instance);
                $e815fda779bc047b$var$indexToVec4(eleIndex, indexView);
                // Nodes should still be clickable if they pass the visibility check but
                // have background-opacity: 0
                // Also: everything but node-body is exempt from effective opacity inheritence/stacking
                var opacity = this.renderTarget.picking ? 1 : type === 'node-body' ? node.effectiveOpacity() : 1;
                var bgOpacity = this.renderTarget.picking ? 1 : node.pstyle(props.opacity).value * opacity;
                var color = node.pstyle(props.color).value;
                var colorView = this.colorBuffer.getView(instance);
                $e815fda779bc047b$var$toWebGLColor(color, bgOpacity, colorView);
                var lineWidthView = this.lineWidthBuffer.getView(instance); // reuse edge line width attribute for node border
                lineWidthView[0] = 0;
                lineWidthView[1] = 0;
                if (props.border) {
                    var borderWidth = node.pstyle('border-width').value;
                    if (borderWidth > 0) {
                        var borderColor = node.pstyle('border-color').value;
                        var borderOpacity = opacity * node.pstyle('border-opacity').value;
                        var borderColorView = this.borderColorBuffer.getView(instance);
                        $e815fda779bc047b$var$toWebGLColor(borderColor, borderOpacity, borderColorView);
                        // SDF distance is negative inside the shape and positive outside
                        var borderPos = node.pstyle('border-position').value;
                        if (borderPos === 'inside') {
                            lineWidthView[0] = 0;
                            lineWidthView[1] = -borderWidth;
                        } else if (borderPos === 'outside') {
                            lineWidthView[0] = borderWidth;
                            lineWidthView[1] = 0;
                        } else {
                            // 'center'
                            var halfWidth = borderWidth / 2;
                            lineWidthView[0] = halfWidth;
                            lineWidthView[1] = -halfWidth;
                        }
                    }
                }
                var matrixView = this.transformBuffer.getMatrixView(instance);
                this.setTransformMatrix(node, matrixView, opts);
                this.simpleCount++;
                this.instanceCount++;
                if (this.instanceCount >= this.maxInstances) this.endBatch();
            }
        },
        {
            key: "_getVertTypeForShape",
            value: function _getVertTypeForShape(node, shapeProp) {
                var shape = node.pstyle(shapeProp).value;
                switch(shape){
                    case 'rectangle':
                        return $e815fda779bc047b$var$RECTANGLE;
                    case 'ellipse':
                        return $e815fda779bc047b$var$ELLIPSE;
                    case 'roundrectangle':
                    case 'round-rectangle':
                        return $e815fda779bc047b$var$ROUND_RECTANGLE;
                    case 'bottom-round-rectangle':
                        return $e815fda779bc047b$var$BOTTOM_ROUND_RECTANGLE;
                    default:
                        return undefined;
                }
            }
        },
        {
            key: "_getCornerRadius",
            value: function _getCornerRadius(node, radiusProp, _ref2) {
                var w = _ref2.w, h = _ref2.h;
                // see CRp.drawRoundRectanglePath
                if (node.pstyle(radiusProp).value === 'auto') return $e815fda779bc047b$var$getRoundRectangleRadius(w, h);
                else {
                    var radius = node.pstyle(radiusProp).pfValue;
                    var halfWidth = w / 2;
                    var halfHeight = h / 2;
                    return Math.min(radius, halfHeight, halfWidth);
                }
            }
        },
        {
            key: "drawEdgeArrow",
            value: function drawEdgeArrow(edge, eleIndex, prefix) {
                if (!edge.visible()) return;
                // Edge points and arrow angles etc are calculated by the base renderer and cached in the rscratch object.
                var rs = edge._private.rscratch;
                var x, y, angle;
                if (prefix === 'source') {
                    x = rs.arrowStartX;
                    y = rs.arrowStartY;
                    angle = rs.srcArrowAngle;
                } else {
                    x = rs.arrowEndX;
                    y = rs.arrowEndY;
                    angle = rs.tgtArrowAngle;
                }
                // taken from CRp.drawArrowhead
                if (isNaN(x) || x == null || isNaN(y) || y == null || isNaN(angle) || angle == null) return;
                // check shape after the x/y check because pstyle() is a bit slow
                var arrowShape = edge.pstyle(prefix + '-arrow-shape').value;
                if (arrowShape === 'none') return;
                var color = edge.pstyle(prefix + '-arrow-color').value;
                var baseOpacity = edge.pstyle('opacity').value;
                var lineOpacity = edge.pstyle('line-opacity').value;
                var opacity = baseOpacity * lineOpacity;
                var lineWidth = edge.pstyle('width').pfValue;
                var scale$1 = edge.pstyle('arrow-scale').value;
                var size = this.r.getArrowWidth(lineWidth, scale$1);
                var instance = this.instanceCount;
                var transform = this.transformBuffer.getMatrixView(instance);
                $e815fda779bc047b$var$identity(transform);
                $e815fda779bc047b$var$translate(transform, transform, [
                    x,
                    y
                ]);
                $e815fda779bc047b$var$scale(transform, transform, [
                    size,
                    size
                ]);
                $e815fda779bc047b$var$rotate(transform, transform, angle);
                this.vertTypeBuffer.getView(instance)[0] = $e815fda779bc047b$var$EDGE_ARROW;
                var indexView = this.indexBuffer.getView(instance);
                $e815fda779bc047b$var$indexToVec4(eleIndex, indexView);
                var colorView = this.colorBuffer.getView(instance);
                $e815fda779bc047b$var$toWebGLColor(color, opacity, colorView);
                this.instanceCount++;
                if (this.instanceCount >= this.maxInstances) this.endBatch();
            }
        },
        {
            key: "drawEdgeLine",
            value: function drawEdgeLine(edge, eleIndex) {
                if (!edge.visible()) return;
                var points = this._getEdgePoints(edge);
                if (!points) return;
                // line style
                var baseOpacity = edge.pstyle('opacity').value;
                var lineOpacity = edge.pstyle('line-opacity').value;
                var width = edge.pstyle('width').pfValue;
                var color = edge.pstyle('line-color').value;
                var opacity = baseOpacity * lineOpacity;
                if (points.length / 2 + this.instanceCount > this.maxInstances) this.endBatch();
                if (points.length == 4) {
                    // straight line
                    var instance = this.instanceCount;
                    this.vertTypeBuffer.getView(instance)[0] = $e815fda779bc047b$var$EDGE_STRAIGHT;
                    var indexView = this.indexBuffer.getView(instance);
                    $e815fda779bc047b$var$indexToVec4(eleIndex, indexView);
                    var colorView = this.colorBuffer.getView(instance);
                    $e815fda779bc047b$var$toWebGLColor(color, opacity, colorView);
                    var lineWidthBuffer = this.lineWidthBuffer.getView(instance);
                    lineWidthBuffer[0] = width;
                    var sourceTargetView = this.pointAPointBBuffer.getView(instance);
                    sourceTargetView[0] = points[0]; // source x
                    sourceTargetView[1] = points[1]; // source y
                    sourceTargetView[2] = points[2]; // target x
                    sourceTargetView[3] = points[3]; // target y
                    this.instanceCount++;
                    if (this.instanceCount >= this.maxInstances) this.endBatch();
                } else // curved line
                for(var i = 0; i < points.length - 2; i += 2){
                    var _instance = this.instanceCount;
                    this.vertTypeBuffer.getView(_instance)[0] = $e815fda779bc047b$var$EDGE_CURVE_SEGMENT;
                    var _indexView = this.indexBuffer.getView(_instance);
                    $e815fda779bc047b$var$indexToVec4(eleIndex, _indexView);
                    var _colorView = this.colorBuffer.getView(_instance);
                    $e815fda779bc047b$var$toWebGLColor(color, opacity, _colorView);
                    var _lineWidthBuffer = this.lineWidthBuffer.getView(_instance);
                    _lineWidthBuffer[0] = width;
                    var pAx = points[i - 2], pAy = points[i - 1];
                    var pBx = points[i], pBy = points[i + 1];
                    var pCx = points[i + 2], pCy = points[i + 3];
                    var pDx = points[i + 4], pDy = points[i + 5];
                    // make phantom points for the first and last segments
                    // TODO adding 0.001 to avoid division by zero in the shader (I think), need a better solution
                    if (i == 0) {
                        pAx = 2 * pBx - pCx + 0.001;
                        pAy = 2 * pBy - pCy + 0.001;
                    }
                    if (i == points.length - 4) {
                        pDx = 2 * pCx - pBx + 0.001;
                        pDy = 2 * pCy - pBy + 0.001;
                    }
                    var pointABView = this.pointAPointBBuffer.getView(_instance);
                    pointABView[0] = pAx;
                    pointABView[1] = pAy;
                    pointABView[2] = pBx;
                    pointABView[3] = pBy;
                    var pointCDView = this.pointCPointDBuffer.getView(_instance);
                    pointCDView[0] = pCx;
                    pointCDView[1] = pCy;
                    pointCDView[2] = pDx;
                    pointCDView[3] = pDy;
                    this.instanceCount++;
                    if (this.instanceCount >= this.maxInstances) this.endBatch();
                }
            }
        },
        {
            key: "_isValidEdge",
            value: function _isValidEdge(edge) {
                var rs = edge._private.rscratch;
                if (rs.badLine || rs.allpts == null || isNaN(rs.allpts[0])) // isNaN in case edge is impossible and browser bugs (e.g. safari)
                return false;
                return true;
            }
        },
        {
            key: "_getEdgePoints",
            value: function _getEdgePoints(edge) {
                var rs = edge._private.rscratch;
                // if bezier ctrl pts can not be calculated, then die
                if (!this._isValidEdge(edge)) // isNaN in case edge is impossible and browser bugs (e.g. safari)
                return;
                var controlPoints = rs.allpts;
                if (controlPoints.length == 4) return controlPoints;
                var numSegments = this._getNumSegments(edge);
                return this._getCurveSegmentPoints(controlPoints, numSegments);
            }
        },
        {
            key: "_getNumSegments",
            value: function _getNumSegments(edge) {
                // TODO Need a heuristic that decides how many segments to use. Factors to consider:
                // - edge width/length
                // - edge curvature (the more the curvature, the more segments)
                // - zoom level (more segments when zoomed in)
                // - number of visible edges (more segments when there are fewer edges)
                // - performance (fewer segments when performance is a concern)
                // - user configurable option(s)
                // note: number of segments must be less than the max number of instances
                // note: segments don't need to be evenly spaced out, it might make sense to have shorter segments nearer to the control points
                var numSegments = 15;
                return Math.min(Math.max(numSegments, 5), this.maxInstances);
            }
        },
        {
            key: "_getCurveSegmentPoints",
            value: function _getCurveSegmentPoints(controlPoints, segments) {
                if (controlPoints.length == 4) return controlPoints; // straight line
                var curvePoints = Array((segments + 1) * 2);
                for(var i = 0; i <= segments; i++){
                    // the first and last points are the same as the first and last control points
                    if (i == 0) {
                        curvePoints[0] = controlPoints[0];
                        curvePoints[1] = controlPoints[1];
                    } else if (i == segments) {
                        curvePoints[i * 2] = controlPoints[controlPoints.length - 2];
                        curvePoints[i * 2 + 1] = controlPoints[controlPoints.length - 1];
                    } else {
                        var t = i / segments; // segments have equal length, its not strictly necessary to do it this way
                        // pass in curvePoints to set the values in the array directly
                        this._setCurvePoint(controlPoints, t, curvePoints, i * 2);
                    }
                }
                return curvePoints;
            }
        },
        {
            key: "_setCurvePoint",
            value: function _setCurvePoint(points, t, curvePoints, cpi) {
                if (points.length <= 2) {
                    curvePoints[cpi] = points[0];
                    curvePoints[cpi + 1] = points[1];
                } else {
                    var newpoints = Array(points.length - 2);
                    for(var i = 0; i < newpoints.length; i += 2){
                        var x = (1 - t) * points[i] + t * points[i + 2];
                        var y = (1 - t) * points[i + 1] + t * points[i + 3];
                        newpoints[i] = x;
                        newpoints[i + 1] = y;
                    }
                    return this._setCurvePoint(newpoints, t, curvePoints, cpi);
                }
            }
        },
        {
            key: "endBatch",
            value: function endBatch() {
                var gl = this.gl, vao = this.vao, vertexCount = this.vertexCount, count = this.instanceCount;
                if (count === 0) return;
                var program = this.renderTarget.picking ? this.pickingProgram : this.program;
                gl.useProgram(program);
                gl.bindVertexArray(vao);
                // buffer the attribute data
                var _iterator2 = $e815fda779bc047b$var$_createForOfIteratorHelper(this.buffers), _step2;
                try {
                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                        var buffer = _step2.value;
                        buffer.bufferSubData(count);
                    }
                } catch (err) {
                    _iterator2.e(err);
                } finally{
                    _iterator2.f();
                }
                var atlases = this.batchManager.getAtlases();
                // must buffer before activating texture units
                for(var i = 0; i < atlases.length; i++)atlases[i].bufferIfNeeded(gl);
                // Activate all the texture units that we need
                for(var _i2 = 0; _i2 < atlases.length; _i2++){
                    gl.activeTexture(gl.TEXTURE0 + _i2);
                    gl.bindTexture(gl.TEXTURE_2D, atlases[_i2].texture);
                    gl.uniform1i(program.uTextures[_i2], _i2);
                }
                // Set the uniforms
                gl.uniform1f(program.uZoom, $e815fda779bc047b$var$getEffectiveZoom(this.r));
                gl.uniformMatrix3fv(program.uPanZoomMatrix, false, this.panZoomMatrix);
                gl.uniform1i(program.uAtlasSize, this.batchManager.getAtlasSize());
                // set background color, needed for edge arrow color blending
                var webglBgColor = $e815fda779bc047b$var$toWebGLColor(this.bgColor, 1);
                gl.uniform4fv(program.uBGColor, webglBgColor);
                // draw!
                gl.drawArraysInstanced(gl.TRIANGLES, 0, vertexCount, count);
                gl.bindVertexArray(null);
                gl.bindTexture(gl.TEXTURE_2D, null); // TODO is this right when having multiple texture units?
                if (this.debug) this.batchDebugInfo.push({
                    count: count,
                    // instance count
                    atlasCount: atlases.length
                });
                // start the next batch, even if not needed
                this.startBatch();
            }
        },
        {
            key: "getDebugInfo",
            value: function getDebugInfo() {
                var atlasInfo = this.atlasManager.getDebugInfo();
                var totalAtlases = atlasInfo.reduce(function(count, info) {
                    return count + info.atlasCount;
                }, 0);
                var batchInfo = this.batchDebugInfo;
                var totalInstances = batchInfo.reduce(function(count, info) {
                    return count + info.count;
                }, 0);
                return {
                    atlasInfo: atlasInfo,
                    totalAtlases: totalAtlases,
                    wrappedCount: this.wrappedCount,
                    simpleCount: this.simpleCount,
                    batchCount: batchInfo.length,
                    batchInfo: batchInfo,
                    totalInstances: totalInstances
                };
            }
        }
    ]);
}();
var $e815fda779bc047b$var$CRp$4 = {};
/**
 * Initialize the WebGL rendering mode after the Canvas renderer has been initialized.
 */ $e815fda779bc047b$var$CRp$4.initWebgl = function(opts, fns) {
    var r = this;
    var gl = r.data.contexts[r.WEBGL];
    // Set defaults and limits for configuration options.
    opts.bgColor = $e815fda779bc047b$var$getBGColor(r);
    opts.webglTexSize = Math.min(opts.webglTexSize, gl.getParameter(gl.MAX_TEXTURE_SIZE));
    opts.webglTexRows = Math.min(opts.webglTexRows, 54);
    opts.webglTexRowsNodes = Math.min(opts.webglTexRowsNodes, 54);
    opts.webglBatchSize = Math.min(opts.webglBatchSize, 16384);
    opts.webglTexPerBatch = Math.min(opts.webglTexPerBatch, gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS));
    // Turn debug mode on or off.
    r.webglDebug = opts.webglDebug;
    r.webglDebugShowAtlases = opts.webglDebugShowAtlases;
    // Create offscreen framebuffer that stores the results when RENDER_TARGET.PICKING is enabled.
    // This is used to store the topmost element z-index for each pixel, which is used to tell whats under the mouse cursor point.
    r.pickingFrameBuffer = $e815fda779bc047b$var$createPickingFrameBuffer(gl);
    r.pickingFrameBuffer.needsDraw = true;
    // Create an ElementDrawingWebGL instance wich is used to do the actual WebGL rendering.
    // This instance needs to be configured to draw various types of elements.
    r.drawing = new $e815fda779bc047b$var$ElementDrawingWebGL(r, gl, opts);
    // Some functions that are used to configure ElementDrawingWebGL
    var getLabelRotation = function getLabelRotation(prop) {
        return function(ele) {
            return r.getTextAngle(ele, prop);
        };
    };
    var isLabelVisible = function isLabelVisible(prop) {
        return function(ele) {
            var label = ele.pstyle(prop);
            return label && label.value;
        };
    };
    var isLayerVisible = function isLayerVisible(prefix) {
        return function(node) {
            // prefix is 'overlay' or 'underlay'
            return node.pstyle("".concat(prefix, "-opacity")).value > 0;
        };
    };
    var getTexPickingMode = function getTexPickingMode(ele) {
        // tells when a label should be clickable
        var enabled = ele.pstyle('text-events').strValue === 'yes';
        return enabled ? $e815fda779bc047b$var$TEX_PICKING_MODE.USE_BB : $e815fda779bc047b$var$TEX_PICKING_MODE.IGNORE;
    };
    var getBBForSimpleShape = function getBBForSimpleShape(node) {
        // "simple" shapes need their BB to include border and padding
        var _node$position = node.position(), x = _node$position.x, y = _node$position.y;
        var w = node.outerWidth(); // includes border and padding
        var h = node.outerHeight();
        return {
            w: w,
            h: h,
            x1: x - w / 2,
            y1: y - h / 2
        };
    };
    // An AtlasCollection is a collection of Atlases that have the same configuraiton options.
    // Create one for node bodies and one for all types of labels.
    r.drawing.addAtlasCollection('node', {
        texRows: opts.webglTexRowsNodes
    });
    r.drawing.addAtlasCollection('label', {
        texRows: opts.webglTexRows
    });
    // Configure the different types of elements that can be rendered.
    // Node bodies can be rendered as textures or as "simple shapes". 
    // Simple shapes are preferred because they do not use texture memory.
    // Textures are required if the node body uses complex styles. 
    r.drawing.addTextureAtlasRenderType('node-body', {
        collection: 'node',
        getKey: fns.getStyleKey,
        getBoundingBox: fns.getElementBox,
        drawElement: fns.drawElement
    });
    r.drawing.addSimpleShapeRenderType('node-body', {
        getBoundingBox: getBBForSimpleShape,
        isSimple: $e815fda779bc047b$var$isSimpleShape,
        shapeProps: {
            shape: 'shape',
            color: 'background-color',
            opacity: 'background-opacity',
            radius: 'corner-radius',
            border: true
        }
    });
    r.drawing.addSimpleShapeRenderType('node-overlay', {
        getBoundingBox: getBBForSimpleShape,
        isVisible: isLayerVisible('overlay'),
        shapeProps: {
            shape: 'overlay-shape',
            color: 'overlay-color',
            opacity: 'overlay-opacity',
            padding: 'overlay-padding',
            radius: 'overlay-corner-radius'
        }
    });
    r.drawing.addSimpleShapeRenderType('node-underlay', {
        getBoundingBox: getBBForSimpleShape,
        isVisible: isLayerVisible('underlay'),
        shapeProps: {
            shape: 'underlay-shape',
            color: 'underlay-color',
            opacity: 'underlay-opacity',
            padding: 'underlay-padding',
            radius: 'underlay-corner-radius'
        }
    });
    r.drawing.addTextureAtlasRenderType('label', {
        // node label or edge mid label
        collection: 'label',
        getTexPickingMode: getTexPickingMode,
        getKey: $e815fda779bc047b$var$getStyleKeysForLabel(fns.getLabelKey, null),
        getBoundingBox: $e815fda779bc047b$var$getBoundingBoxForLabel(fns.getLabelBox, null),
        drawClipped: true,
        drawElement: fns.drawLabel,
        getRotation: getLabelRotation(null),
        getRotationPoint: fns.getLabelRotationPoint,
        getRotationOffset: fns.getLabelRotationOffset,
        isVisible: isLabelVisible('label')
    });
    r.drawing.addTextureAtlasRenderType('edge-source-label', {
        collection: 'label',
        getTexPickingMode: getTexPickingMode,
        getKey: $e815fda779bc047b$var$getStyleKeysForLabel(fns.getSourceLabelKey, 'source'),
        getBoundingBox: $e815fda779bc047b$var$getBoundingBoxForLabel(fns.getSourceLabelBox, 'source'),
        drawClipped: true,
        drawElement: fns.drawSourceLabel,
        getRotation: getLabelRotation('source'),
        getRotationPoint: fns.getSourceLabelRotationPoint,
        getRotationOffset: fns.getSourceLabelRotationOffset,
        isVisible: isLabelVisible('source-label')
    });
    r.drawing.addTextureAtlasRenderType('edge-target-label', {
        collection: 'label',
        getTexPickingMode: getTexPickingMode,
        getKey: $e815fda779bc047b$var$getStyleKeysForLabel(fns.getTargetLabelKey, 'target'),
        getBoundingBox: $e815fda779bc047b$var$getBoundingBoxForLabel(fns.getTargetLabelBox, 'target'),
        drawClipped: true,
        drawElement: fns.drawTargetLabel,
        getRotation: getLabelRotation('target'),
        getRotationPoint: fns.getTargetLabelRotationPoint,
        getRotationOffset: fns.getTargetLabelRotationOffset,
        isVisible: isLabelVisible('target-label')
    });
    // Very simplistic way of triggering garbage collection, just use a timer.
    var setGCFlag = $e815fda779bc047b$var$debounce(function() {
        console.log('garbage collect flag set');
        r.data.gc = true;
    }, 10000);
    // Event listener checks if style keys are no longer in use.
    r.onUpdateEleCalcs(function(willDraw, eles) {
        var gcNeeded = false;
        if (eles && eles.length > 0) gcNeeded |= r.drawing.invalidate(eles);
        if (gcNeeded) setGCFlag();
    });
    // "Override" certain functions in canvas and base renderer
    $e815fda779bc047b$var$overrideCanvasRendererFunctions(r);
};
function $e815fda779bc047b$var$getBGColor(r) {
    var container = r.cy.container();
    var cssColor = container && container.style && container.style.backgroundColor || 'white';
    return $e815fda779bc047b$var$color2tuple(cssColor);
}
function $e815fda779bc047b$var$getLabelLines(ele, prefix) {
    var rs = ele._private.rscratch;
    return $e815fda779bc047b$var$getPrefixedProperty(rs, 'labelWrapCachedLines', prefix) || [];
}
/** 
 * Handle multi-line labels by rendering each line as a seperate texture.
 * That means each line needs its own style key.
 */ var $e815fda779bc047b$var$getStyleKeysForLabel = function getStyleKeysForLabel(getKey, prefix) {
    return function(ele) {
        var key = getKey(ele);
        var lines = $e815fda779bc047b$var$getLabelLines(ele, prefix);
        if (lines.length > 1) return lines.map(function(line, index) {
            return "".concat(key, "_").concat(index);
        });
        return key;
    };
};
/**
 * Need to create a separate bounding box for each line of a multi-line label.
 * Note that 'drawClipped: true' should be used with this.
 */ var $e815fda779bc047b$var$getBoundingBoxForLabel = function getBoundingBoxForLabel(getBoundingBox, prefix) {
    return function(ele, styleKey) {
        var bb = getBoundingBox(ele);
        if (typeof styleKey === 'string') {
            var ui = styleKey.indexOf('_');
            if (ui > 0) {
                var lineIndex = Number(styleKey.substring(ui + 1));
                var lines = $e815fda779bc047b$var$getLabelLines(ele, prefix);
                // Adjust the height and Y coordinate for one line of the label.
                var h = bb.h / lines.length;
                var yOffset = h * lineIndex;
                var y1 = bb.y1 + yOffset;
                // the yOffset is needed when rotating the label
                return {
                    x1: bb.x1,
                    w: bb.w,
                    y1: y1,
                    h: h,
                    yOffset: yOffset
                };
            }
        }
        return bb;
    };
};
/**
 * Plug into the canvas renderer by dynamically overriding some of its functions.
 * This requires minimal changes to the canvas rendrerer.
 */ function $e815fda779bc047b$var$overrideCanvasRendererFunctions(r) {
    // Override the render function to call the webgl render function if the zoom level is appropriate
    var renderCanvas = r.render;
    r.render = function(options) {
        options = options || {};
        var cy = r.cy;
        if (r.webgl) {
            // If the zoom level is greater than the max zoom level, then disable webgl and switch back to 
            // the canvas renderer.
            if (cy.zoom() > $e815fda779bc047b$var$maxZoom$1) {
                $e815fda779bc047b$var$clearWebgl(r);
                renderCanvas.call(r, options);
            } else {
                $e815fda779bc047b$var$clearCanvas(r);
                $e815fda779bc047b$var$renderWebgl(r, options, $e815fda779bc047b$var$RENDER_TARGET.SCREEN);
            }
        }
    };
    // Override the matchCanvasSize function to update the picking frame buffer size
    var baseFunc = r.matchCanvasSize;
    r.matchCanvasSize = function(container) {
        baseFunc.call(r, container);
        r.pickingFrameBuffer.setFramebufferAttachmentSizes(r.canvasWidth, r.canvasHeight);
        r.pickingFrameBuffer.needsDraw = true;
    };
    // Override function to call the webgl version for picking.
    // Don't override r.getAllInBox() selction box picking, its not accurate enough with webgl
    r.findNearestElements = function(x, y, interactiveElementsOnly, isTouch) {
        // the canvas version of this function is very slow on large graphs
        return $e815fda779bc047b$var$findNearestElementsWebgl(r, x, y);
    };
    // need to know when the cached elements have changed so we can invalidate our caches
    var _baseFunc = r.invalidateCachedZSortedEles;
    r.invalidateCachedZSortedEles = function() {
        _baseFunc.call(r);
        r.pickingFrameBuffer.needsDraw = true;
    };
    // need to know when the cached elements have changed so we can invalidate our caches
    var _baseFunc2 = r.notify;
    r.notify = function(eventName, eles) {
        _baseFunc2.call(r, eventName, eles);
        if (eventName === 'viewport' || eventName === 'bounds') r.pickingFrameBuffer.needsDraw = true;
        else if (eventName === 'background') // background image finished loading, need to redraw
        r.drawing.invalidate(eles, {
            type: 'node-body'
        });
    };
}
function $e815fda779bc047b$var$clearWebgl(r) {
    var gl = r.data.contexts[r.WEBGL];
    gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
}
function $e815fda779bc047b$var$clearCanvas(r) {
    // the CRp.clearCanvas() function doesn't take the transform into account
    var clear = function clear(context) {
        context.save();
        context.setTransform(1, 0, 0, 1, 0, 0);
        context.clearRect(0, 0, r.canvasWidth, r.canvasHeight);
        context.restore();
    };
    clear(r.data.contexts[r.NODE]);
    clear(r.data.contexts[r.DRAG]);
}
function $e815fda779bc047b$var$createPanZoomMatrix(r) {
    var width = r.canvasWidth;
    var height = r.canvasHeight;
    var _util$getEffectivePan = $e815fda779bc047b$var$getEffectivePanZoom(r), pan = _util$getEffectivePan.pan, zoom = _util$getEffectivePan.zoom;
    var transform = $e815fda779bc047b$var$create();
    $e815fda779bc047b$var$translate(transform, transform, [
        pan.x,
        pan.y
    ]);
    $e815fda779bc047b$var$scale(transform, transform, [
        zoom,
        zoom
    ]);
    var projection$1 = $e815fda779bc047b$var$create();
    $e815fda779bc047b$var$projection(projection$1, width, height);
    var product = $e815fda779bc047b$var$create();
    $e815fda779bc047b$var$multiply(product, projection$1, transform);
    return product;
}
function $e815fda779bc047b$var$setContextTransform(r, context) {
    var width = r.canvasWidth;
    var height = r.canvasHeight;
    var _util$getEffectivePan2 = $e815fda779bc047b$var$getEffectivePanZoom(r), pan = _util$getEffectivePan2.pan, zoom = _util$getEffectivePan2.zoom;
    context.setTransform(1, 0, 0, 1, 0, 0);
    context.clearRect(0, 0, width, height);
    context.translate(pan.x, pan.y);
    context.scale(zoom, zoom);
}
function $e815fda779bc047b$var$drawSelectionRectangle(r, options) {
    r.drawSelectionRectangle(options, function(context) {
        return $e815fda779bc047b$var$setContextTransform(r, context);
    });
}
function $e815fda779bc047b$var$drawAxes(r) {
    // for debgging
    var context = r.data.contexts[r.NODE];
    context.save();
    $e815fda779bc047b$var$setContextTransform(r, context);
    context.strokeStyle = 'rgba(0, 0, 0, 0.3)';
    context.beginPath();
    context.moveTo(-1000, 0);
    context.lineTo(1000, 0);
    context.stroke();
    context.beginPath();
    context.moveTo(0, -1000);
    context.lineTo(0, 1000);
    context.stroke();
    context.restore();
}
function $e815fda779bc047b$var$drawAtlases(r) {
    // For debugging the atlases, this doesn't work for Atlases that are locked
    var draw = function draw(drawing, name, row) {
        var collection = drawing.atlasManager.getAtlasCollection(name);
        var context = r.data.contexts[r.NODE];
        var atlases = collection.atlases;
        for(var _i = 0; _i < atlases.length; _i++){
            var atlas = atlases[_i];
            var canvas = atlas.canvas;
            if (canvas) {
                var w = canvas.width;
                var h = canvas.height;
                var x = w * _i;
                var y = canvas.height * row;
                var scale = 0.4;
                context.save();
                context.scale(scale, scale);
                context.drawImage(canvas, x, y);
                context.strokeStyle = 'black';
                context.rect(x, y, w, h);
                context.stroke();
                context.restore();
            }
        }
    };
    var i = 0;
    draw(r.drawing, 'node', i++);
    draw(r.drawing, 'label', i++);
}
/**
 * Returns the z-order index of elments under or very close to the mouse cursor point.
 * Arguments are in model coordinates.
 * (x1, y1) is top left corner
 * (x2, y2) is bottom right corner (optional)
 * Returns a Set of indexes.
 */ function $e815fda779bc047b$var$getPickingIndexes(r, mX1, mY1, mX2, mY2) {
    var x, y, w, h;
    var _util$getEffectivePan3 = $e815fda779bc047b$var$getEffectivePanZoom(r), pan = _util$getEffectivePan3.pan, zoom = _util$getEffectivePan3.zoom;
    var _util$modelToRendered = $e815fda779bc047b$var$modelToRenderedPosition(r, pan, zoom, mX1, mY1), _util$modelToRendered2 = $e815fda779bc047b$var$_slicedToArray(_util$modelToRendered, 2), cX1 = _util$modelToRendered2[0], cY1 = _util$modelToRendered2[1];
    var t = 6; // should be even
    x = cX1 - t / 2;
    y = cY1 - t / 2;
    w = t;
    h = t;
    if (w === 0 || h === 0) return [];
    var gl = r.data.contexts[r.WEBGL];
    gl.bindFramebuffer(gl.FRAMEBUFFER, r.pickingFrameBuffer);
    if (r.pickingFrameBuffer.needsDraw) {
        // Draw element z-indexes to the picking framebuffer
        gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
        $e815fda779bc047b$var$renderWebgl(r, null, $e815fda779bc047b$var$RENDER_TARGET.PICKING);
        r.pickingFrameBuffer.needsDraw = false;
    }
    var n = w * h; // number of pixels to read
    var data = new Uint8Array(n * 4); // 4 bytes per pixel
    gl.readPixels(x, y, w, h, gl.RGBA, gl.UNSIGNED_BYTE, data);
    gl.bindFramebuffer(gl.FRAMEBUFFER, null);
    var indexes = new Set();
    for(var i = 0; i < n; i++){
        var pixel = data.slice(i * 4, i * 4 + 4);
        var index = $e815fda779bc047b$var$vec4ToIndex(pixel) - 1; // The framebuffer is cleared with 0s, so z-indexes are offset by 1
        if (index >= 0) indexes.add(index);
    }
    return indexes;
}
/**
 * Cy.js: model coordinate y axis goes down
 */ function $e815fda779bc047b$var$findNearestElementsWebgl(r, x, y) {
    // model coordinates
    var indexes = $e815fda779bc047b$var$getPickingIndexes(r, x, y);
    var eles = r.getCachedZSortedEles();
    var node, edge;
    var _iterator = $e815fda779bc047b$var$_createForOfIteratorHelper(indexes), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var index = _step.value;
            var ele = eles[index];
            if (!node && ele.isNode()) node = ele;
            if (!edge && ele.isEdge()) edge = ele;
            if (node && edge) break;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return [
        node,
        edge
    ].filter(Boolean);
}
/**
 * Draw one node or edge. 
 */ function $e815fda779bc047b$var$drawEle(r, index, ele) {
    var drawing = r.drawing;
    index += 1; // 0 is used to clear the background, need to offset all z-indexes by one
    if (ele.isNode()) {
        drawing.drawNode(ele, index, 'node-underlay');
        drawing.drawNode(ele, index, 'node-body');
        drawing.drawTexture(ele, index, 'label');
        drawing.drawNode(ele, index, 'node-overlay');
    } else {
        drawing.drawEdgeLine(ele, index);
        drawing.drawEdgeArrow(ele, index, 'source');
        drawing.drawEdgeArrow(ele, index, 'target');
        drawing.drawTexture(ele, index, 'label');
        drawing.drawTexture(ele, index, 'edge-source-label');
        drawing.drawTexture(ele, index, 'edge-target-label');
    }
}
/**
 * Render one frame.
 */ function $e815fda779bc047b$var$renderWebgl(r, options, renderTarget) {
    var start;
    if (r.webglDebug) start = performance.now(); // eslint-disable-line no-undef
    var drawing = r.drawing;
    var eleCount = 0;
    if (renderTarget.screen) {
        if (r.data.canvasNeedsRedraw[r.SELECT_BOX]) $e815fda779bc047b$var$drawSelectionRectangle(r, options);
    }
    // see drawing-elements.js drawCachedElement()
    if (r.data.canvasNeedsRedraw[r.NODE] || renderTarget.picking) {
        var gl = r.data.contexts[r.WEBGL];
        if (renderTarget.screen) {
            gl.clearColor(0, 0, 0, 0); // background color
            gl.enable(gl.BLEND); // enable alpha blending of colors
            gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA); // webgl colors use premultiplied alpha
        } else gl.disable(gl.BLEND); // don't blend z-order index values! they are not colors
        gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
        gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
        var panZoomMatrix = $e815fda779bc047b$var$createPanZoomMatrix(r);
        var eles = r.getCachedZSortedEles();
        eleCount = eles.length;
        drawing.startFrame(panZoomMatrix, renderTarget);
        if (renderTarget.screen) {
            for(var i = 0; i < eles.nondrag.length; i++)$e815fda779bc047b$var$drawEle(r, i, eles.nondrag[i]);
            for(var _i2 = 0; _i2 < eles.drag.length; _i2++)$e815fda779bc047b$var$drawEle(r, _i2, eles.drag[_i2]);
        } else if (renderTarget.picking) for(var _i3 = 0; _i3 < eles.length; _i3++)$e815fda779bc047b$var$drawEle(r, _i3, eles[_i3]);
        drawing.endFrame();
        if (renderTarget.screen && r.webglDebugShowAtlases) {
            $e815fda779bc047b$var$drawAxes(r);
            $e815fda779bc047b$var$drawAtlases(r);
        }
        r.data.canvasNeedsRedraw[r.NODE] = false;
        r.data.canvasNeedsRedraw[r.DRAG] = false;
    }
    if (r.webglDebug) {
        // eslint-disable-next-line no-undef
        var end = performance.now();
        var compact = false;
        var time = Math.ceil(end - start);
        var debugInfo = drawing.getDebugInfo();
        var report = [
            "".concat(eleCount, " elements"),
            "".concat(debugInfo.totalInstances, " instances"),
            "".concat(debugInfo.batchCount, " batches"),
            "".concat(debugInfo.totalAtlases, " atlases"),
            "".concat(debugInfo.wrappedCount, " wrapped textures"),
            "".concat(debugInfo.simpleCount, " simple shapes")
        ].join(', ');
        if (compact) console.log("WebGL (".concat(renderTarget.name, ") - time ").concat(time, "ms, ").concat(report));
        else {
            console.log("WebGL (".concat(renderTarget.name, ") - frame time ").concat(time, "ms"));
            console.log('Totals:');
            console.log("  ".concat(report));
            console.log('Texture Atlases Used:');
            var atlasInfo = debugInfo.atlasInfo;
            var _iterator2 = $e815fda779bc047b$var$_createForOfIteratorHelper(atlasInfo), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var info = _step2.value;
                    console.log("  ".concat(info.type, ": ").concat(info.keyCount, " keys, ").concat(info.atlasCount, " atlases"));
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            console.log('');
        }
    }
    if (r.data.gc) {
        console.log('Garbage Collect!');
        r.data.gc = false;
        drawing.gc();
    }
}
var $e815fda779bc047b$var$CRp$3 = {};
// @O Polygon drawing
$e815fda779bc047b$var$CRp$3.drawPolygonPath = function(context, x, y, width, height, points) {
    var halfW = width / 2;
    var halfH = height / 2;
    if (context.beginPath) context.beginPath();
    context.moveTo(x + halfW * points[0], y + halfH * points[1]);
    for(var i = 1; i < points.length / 2; i++)context.lineTo(x + halfW * points[i * 2], y + halfH * points[i * 2 + 1]);
    context.closePath();
};
$e815fda779bc047b$var$CRp$3.drawRoundPolygonPath = function(context, x, y, width, height, points, corners) {
    corners.forEach(function(corner) {
        return $e815fda779bc047b$var$drawPreparedRoundCorner(context, corner);
    });
    context.closePath();
};
// Round rectangle drawing
$e815fda779bc047b$var$CRp$3.drawRoundRectanglePath = function(context, x, y, width, height, radius) {
    var halfWidth = width / 2;
    var halfHeight = height / 2;
    var cornerRadius = radius === 'auto' ? $e815fda779bc047b$var$getRoundRectangleRadius(width, height) : Math.min(radius, halfHeight, halfWidth);
    if (context.beginPath) context.beginPath();
    // Start at top middle
    context.moveTo(x, y - halfHeight);
    // Arc from middle top to right side
    context.arcTo(x + halfWidth, y - halfHeight, x + halfWidth, y, cornerRadius);
    // Arc from right side to bottom
    context.arcTo(x + halfWidth, y + halfHeight, x, y + halfHeight, cornerRadius);
    // Arc from bottom to left side
    context.arcTo(x - halfWidth, y + halfHeight, x - halfWidth, y, cornerRadius);
    // Arc from left side to topBorder
    context.arcTo(x - halfWidth, y - halfHeight, x, y - halfHeight, cornerRadius);
    // Join line
    context.lineTo(x, y - halfHeight);
    context.closePath();
};
$e815fda779bc047b$var$CRp$3.drawBottomRoundRectanglePath = function(context, x, y, width, height, radius) {
    var halfWidth = width / 2;
    var halfHeight = height / 2;
    var cornerRadius = radius === 'auto' ? $e815fda779bc047b$var$getRoundRectangleRadius(width, height) : radius;
    if (context.beginPath) context.beginPath();
    // Start at top middle
    context.moveTo(x, y - halfHeight);
    context.lineTo(x + halfWidth, y - halfHeight);
    context.lineTo(x + halfWidth, y);
    context.arcTo(x + halfWidth, y + halfHeight, x, y + halfHeight, cornerRadius);
    context.arcTo(x - halfWidth, y + halfHeight, x - halfWidth, y, cornerRadius);
    context.lineTo(x - halfWidth, y - halfHeight);
    context.lineTo(x, y - halfHeight);
    context.closePath();
};
$e815fda779bc047b$var$CRp$3.drawCutRectanglePath = function(context, x, y, width, height, points, corners) {
    var halfWidth = width / 2;
    var halfHeight = height / 2;
    var cornerLength = corners === 'auto' ? $e815fda779bc047b$var$getCutRectangleCornerLength() : corners;
    if (context.beginPath) context.beginPath();
    context.moveTo(x - halfWidth + cornerLength, y - halfHeight);
    context.lineTo(x + halfWidth - cornerLength, y - halfHeight);
    context.lineTo(x + halfWidth, y - halfHeight + cornerLength);
    context.lineTo(x + halfWidth, y + halfHeight - cornerLength);
    context.lineTo(x + halfWidth - cornerLength, y + halfHeight);
    context.lineTo(x - halfWidth + cornerLength, y + halfHeight);
    context.lineTo(x - halfWidth, y + halfHeight - cornerLength);
    context.lineTo(x - halfWidth, y - halfHeight + cornerLength);
    context.closePath();
};
$e815fda779bc047b$var$CRp$3.drawBarrelPath = function(context, x, y, width, height) {
    var halfWidth = width / 2;
    var halfHeight = height / 2;
    var xBegin = x - halfWidth;
    var xEnd = x + halfWidth;
    var yBegin = y - halfHeight;
    var yEnd = y + halfHeight;
    var barrelCurveConstants = $e815fda779bc047b$var$getBarrelCurveConstants(width, height);
    var wOffset = barrelCurveConstants.widthOffset;
    var hOffset = barrelCurveConstants.heightOffset;
    var ctrlPtXOffset = barrelCurveConstants.ctrlPtOffsetPct * wOffset;
    if (context.beginPath) context.beginPath();
    context.moveTo(xBegin, yBegin + hOffset);
    context.lineTo(xBegin, yEnd - hOffset);
    context.quadraticCurveTo(xBegin + ctrlPtXOffset, yEnd, xBegin + wOffset, yEnd);
    context.lineTo(xEnd - wOffset, yEnd);
    context.quadraticCurveTo(xEnd - ctrlPtXOffset, yEnd, xEnd, yEnd - hOffset);
    context.lineTo(xEnd, yBegin + hOffset);
    context.quadraticCurveTo(xEnd - ctrlPtXOffset, yBegin, xEnd - wOffset, yBegin);
    context.lineTo(xBegin + wOffset, yBegin);
    context.quadraticCurveTo(xBegin + ctrlPtXOffset, yBegin, xBegin, yBegin + hOffset);
    context.closePath();
};
var $e815fda779bc047b$var$sin0 = Math.sin(0);
var $e815fda779bc047b$var$cos0 = Math.cos(0);
var $e815fda779bc047b$var$sin = {};
var $e815fda779bc047b$var$cos = {};
var $e815fda779bc047b$var$ellipseStepSize = Math.PI / 40;
for(var $e815fda779bc047b$var$i = 0 * Math.PI; $e815fda779bc047b$var$i < 2 * Math.PI; $e815fda779bc047b$var$i += $e815fda779bc047b$var$ellipseStepSize){
    $e815fda779bc047b$var$sin[$e815fda779bc047b$var$i] = Math.sin($e815fda779bc047b$var$i);
    $e815fda779bc047b$var$cos[$e815fda779bc047b$var$i] = Math.cos($e815fda779bc047b$var$i);
}
$e815fda779bc047b$var$CRp$3.drawEllipsePath = function(context, centerX, centerY, width, height) {
    if (context.beginPath) context.beginPath();
    if (context.ellipse) context.ellipse(centerX, centerY, width / 2, height / 2, 0, 0, 2 * Math.PI);
    else {
        var xPos, yPos;
        var rw = width / 2;
        var rh = height / 2;
        for(var i = 0 * Math.PI; i < 2 * Math.PI; i += $e815fda779bc047b$var$ellipseStepSize){
            xPos = centerX - rw * $e815fda779bc047b$var$sin[i] * $e815fda779bc047b$var$sin0 + rw * $e815fda779bc047b$var$cos[i] * $e815fda779bc047b$var$cos0;
            yPos = centerY + rh * $e815fda779bc047b$var$cos[i] * $e815fda779bc047b$var$sin0 + rh * $e815fda779bc047b$var$sin[i] * $e815fda779bc047b$var$cos0;
            if (i === 0) context.moveTo(xPos, yPos);
            else context.lineTo(xPos, yPos);
        }
    }
    context.closePath();
};
/* global atob, ArrayBuffer, Uint8Array, Blob */ var $e815fda779bc047b$var$CRp$2 = {};
$e815fda779bc047b$var$CRp$2.createBuffer = function(w, h) {
    var buffer = document.createElement('canvas'); // eslint-disable-line no-undef
    buffer.width = w;
    buffer.height = h;
    return [
        buffer,
        buffer.getContext('2d')
    ];
};
$e815fda779bc047b$var$CRp$2.bufferCanvasImage = function(options) {
    var cy = this.cy;
    var eles = cy.mutableElements();
    var bb = eles.boundingBox();
    var ctrRect = this.findContainerClientCoords();
    var width = options.full ? Math.ceil(bb.w) : ctrRect[2];
    var height = options.full ? Math.ceil(bb.h) : ctrRect[3];
    var specdMaxDims = $e815fda779bc047b$var$number$1(options.maxWidth) || $e815fda779bc047b$var$number$1(options.maxHeight);
    var pxRatio = this.getPixelRatio();
    var scale = 1;
    if (options.scale !== undefined) {
        width *= options.scale;
        height *= options.scale;
        scale = options.scale;
    } else if (specdMaxDims) {
        var maxScaleW = Infinity;
        var maxScaleH = Infinity;
        if ($e815fda779bc047b$var$number$1(options.maxWidth)) maxScaleW = scale * options.maxWidth / width;
        if ($e815fda779bc047b$var$number$1(options.maxHeight)) maxScaleH = scale * options.maxHeight / height;
        scale = Math.min(maxScaleW, maxScaleH);
        width *= scale;
        height *= scale;
    }
    if (!specdMaxDims) {
        width *= pxRatio;
        height *= pxRatio;
        scale *= pxRatio;
    }
    var buffCanvas = document.createElement('canvas'); // eslint-disable-line no-undef
    buffCanvas.width = width;
    buffCanvas.height = height;
    buffCanvas.style.width = width + 'px';
    buffCanvas.style.height = height + 'px';
    var buffCxt = buffCanvas.getContext('2d');
    // Rasterize the layers, but only if container has nonzero size
    if (width > 0 && height > 0) {
        buffCxt.clearRect(0, 0, width, height);
        buffCxt.globalCompositeOperation = 'source-over';
        var zsortedEles = this.getCachedZSortedEles();
        if (options.full) {
            // draw the full bounds of the graph
            buffCxt.translate(-bb.x1 * scale, -bb.y1 * scale);
            buffCxt.scale(scale, scale);
            this.drawElements(buffCxt, zsortedEles);
            buffCxt.scale(1 / scale, 1 / scale);
            buffCxt.translate(bb.x1 * scale, bb.y1 * scale);
        } else {
            // draw the current view
            var pan = cy.pan();
            var translation = {
                x: pan.x * scale,
                y: pan.y * scale
            };
            scale *= cy.zoom();
            buffCxt.translate(translation.x, translation.y);
            buffCxt.scale(scale, scale);
            this.drawElements(buffCxt, zsortedEles);
            buffCxt.scale(1 / scale, 1 / scale);
            buffCxt.translate(-translation.x, -translation.y);
        }
        // need to fill bg at end like this in order to fill cleared transparent pixels in jpgs
        if (options.bg) {
            buffCxt.globalCompositeOperation = 'destination-over';
            buffCxt.fillStyle = options.bg;
            buffCxt.rect(0, 0, width, height);
            buffCxt.fill();
        }
    }
    return buffCanvas;
};
function $e815fda779bc047b$var$b64ToBlob(b64, mimeType) {
    var bytes = atob(b64);
    var buff = new ArrayBuffer(bytes.length);
    var buffUint8 = new Uint8Array(buff);
    for(var i = 0; i < bytes.length; i++)buffUint8[i] = bytes.charCodeAt(i);
    return new Blob([
        buff
    ], {
        type: mimeType
    });
}
function $e815fda779bc047b$var$b64UriToB64(b64uri) {
    var i = b64uri.indexOf(',');
    return b64uri.substr(i + 1);
}
function $e815fda779bc047b$var$output(options, canvas, mimeType) {
    var getB64Uri = function getB64Uri() {
        return canvas.toDataURL(mimeType, options.quality);
    };
    switch(options.output){
        case 'blob-promise':
            return new $e815fda779bc047b$var$Promise$1(function(resolve, reject) {
                try {
                    canvas.toBlob(function(blob) {
                        if (blob != null) resolve(blob);
                        else reject(new Error('`canvas.toBlob()` sent a null value in its callback'));
                    }, mimeType, options.quality);
                } catch (err) {
                    reject(err);
                }
            });
        case 'blob':
            return $e815fda779bc047b$var$b64ToBlob($e815fda779bc047b$var$b64UriToB64(getB64Uri()), mimeType);
        case 'base64':
            return $e815fda779bc047b$var$b64UriToB64(getB64Uri());
        case 'base64uri':
        default:
            return getB64Uri();
    }
}
$e815fda779bc047b$var$CRp$2.png = function(options) {
    return $e815fda779bc047b$var$output(options, this.bufferCanvasImage(options), 'image/png');
};
$e815fda779bc047b$var$CRp$2.jpg = function(options) {
    return $e815fda779bc047b$var$output(options, this.bufferCanvasImage(options), 'image/jpeg');
};
var $e815fda779bc047b$var$CRp$1 = {};
$e815fda779bc047b$var$CRp$1.nodeShapeImpl = function(name, context, centerX, centerY, width, height, points, corners) {
    switch(name){
        case 'ellipse':
            return this.drawEllipsePath(context, centerX, centerY, width, height);
        case 'polygon':
            return this.drawPolygonPath(context, centerX, centerY, width, height, points);
        case 'round-polygon':
            return this.drawRoundPolygonPath(context, centerX, centerY, width, height, points, corners);
        case 'roundrectangle':
        case 'round-rectangle':
            return this.drawRoundRectanglePath(context, centerX, centerY, width, height, corners);
        case 'cutrectangle':
        case 'cut-rectangle':
            return this.drawCutRectanglePath(context, centerX, centerY, width, height, points, corners);
        case 'bottomroundrectangle':
        case 'bottom-round-rectangle':
            return this.drawBottomRoundRectanglePath(context, centerX, centerY, width, height, corners);
        case 'barrel':
            return this.drawBarrelPath(context, centerX, centerY, width, height);
    }
};
var $e815fda779bc047b$var$CR = $e815fda779bc047b$var$CanvasRenderer;
var $e815fda779bc047b$var$CRp = $e815fda779bc047b$var$CanvasRenderer.prototype;
$e815fda779bc047b$var$CRp.CANVAS_LAYERS = 3;
//
$e815fda779bc047b$var$CRp.SELECT_BOX = 0;
$e815fda779bc047b$var$CRp.DRAG = 1;
$e815fda779bc047b$var$CRp.NODE = 2;
$e815fda779bc047b$var$CRp.WEBGL = 3;
$e815fda779bc047b$var$CRp.CANVAS_TYPES = [
    '2d',
    '2d',
    '2d',
    'webgl2'
];
$e815fda779bc047b$var$CRp.BUFFER_COUNT = 3;
//
$e815fda779bc047b$var$CRp.TEXTURE_BUFFER = 0;
$e815fda779bc047b$var$CRp.MOTIONBLUR_BUFFER_NODE = 1;
$e815fda779bc047b$var$CRp.MOTIONBLUR_BUFFER_DRAG = 2;
function $e815fda779bc047b$var$CanvasRenderer(options) {
    var r = this;
    var containerWindow = r.cy.window();
    var document1 = containerWindow.document;
    if (options.webgl) {
        $e815fda779bc047b$var$CRp.CANVAS_LAYERS = r.CANVAS_LAYERS = 4;
        console.log('webgl rendering enabled');
    }
    r.data = {
        canvases: new Array($e815fda779bc047b$var$CRp.CANVAS_LAYERS),
        contexts: new Array($e815fda779bc047b$var$CRp.CANVAS_LAYERS),
        canvasNeedsRedraw: new Array($e815fda779bc047b$var$CRp.CANVAS_LAYERS),
        bufferCanvases: new Array($e815fda779bc047b$var$CRp.BUFFER_COUNT),
        bufferContexts: new Array($e815fda779bc047b$var$CRp.CANVAS_LAYERS)
    };
    var tapHlOffAttr = '-webkit-tap-highlight-color';
    var tapHlOffStyle = 'rgba(0,0,0,0)';
    r.data.canvasContainer = document1.createElement('div'); // eslint-disable-line no-undef
    var containerStyle = r.data.canvasContainer.style;
    r.data.canvasContainer.style[tapHlOffAttr] = tapHlOffStyle;
    containerStyle.position = 'relative';
    containerStyle.zIndex = '0';
    containerStyle.overflow = 'hidden';
    var container = options.cy.container();
    container.appendChild(r.data.canvasContainer);
    container.style[tapHlOffAttr] = tapHlOffStyle;
    var styleMap = {
        '-webkit-user-select': 'none',
        '-moz-user-select': '-moz-none',
        'user-select': 'none',
        '-webkit-tap-highlight-color': 'rgba(0,0,0,0)',
        'outline-style': 'none'
    };
    if ($e815fda779bc047b$var$ms()) {
        styleMap['-ms-touch-action'] = 'none';
        styleMap['touch-action'] = 'none';
    }
    for(var i = 0; i < $e815fda779bc047b$var$CRp.CANVAS_LAYERS; i++){
        var canvas = r.data.canvases[i] = document1.createElement('canvas'); // eslint-disable-line no-undef
        var type = $e815fda779bc047b$var$CRp.CANVAS_TYPES[i];
        r.data.contexts[i] = canvas.getContext(type);
        if (!r.data.contexts[i]) $e815fda779bc047b$var$error('Could not create canvas of type ' + type);
        Object.keys(styleMap).forEach(function(k) {
            canvas.style[k] = styleMap[k];
        });
        canvas.style.position = 'absolute';
        canvas.setAttribute('data-id', 'layer' + i);
        canvas.style.zIndex = String($e815fda779bc047b$var$CRp.CANVAS_LAYERS - i);
        r.data.canvasContainer.appendChild(canvas);
        r.data.canvasNeedsRedraw[i] = false;
    }
    r.data.topCanvas = r.data.canvases[0];
    r.data.canvases[$e815fda779bc047b$var$CRp.NODE].setAttribute('data-id', 'layer' + $e815fda779bc047b$var$CRp.NODE + '-node');
    r.data.canvases[$e815fda779bc047b$var$CRp.SELECT_BOX].setAttribute('data-id', 'layer' + $e815fda779bc047b$var$CRp.SELECT_BOX + '-selectbox');
    r.data.canvases[$e815fda779bc047b$var$CRp.DRAG].setAttribute('data-id', 'layer' + $e815fda779bc047b$var$CRp.DRAG + '-drag');
    if (r.data.canvases[$e815fda779bc047b$var$CRp.WEBGL]) r.data.canvases[$e815fda779bc047b$var$CRp.WEBGL].setAttribute('data-id', 'layer' + $e815fda779bc047b$var$CRp.WEBGL + '-webgl');
    for(var i = 0; i < $e815fda779bc047b$var$CRp.BUFFER_COUNT; i++){
        r.data.bufferCanvases[i] = document1.createElement('canvas'); // eslint-disable-line no-undef
        r.data.bufferContexts[i] = r.data.bufferCanvases[i].getContext('2d');
        r.data.bufferCanvases[i].style.position = 'absolute';
        r.data.bufferCanvases[i].setAttribute('data-id', 'buffer' + i);
        r.data.bufferCanvases[i].style.zIndex = String(-i - 1);
        r.data.bufferCanvases[i].style.visibility = 'hidden';
    //r.data.canvasContainer.appendChild(r.data.bufferCanvases[i]);
    }
    r.pathsEnabled = true;
    var emptyBb = $e815fda779bc047b$var$makeBoundingBox();
    var getBoxCenter = function getBoxCenter(bb) {
        return {
            x: (bb.x1 + bb.x2) / 2,
            y: (bb.y1 + bb.y2) / 2
        };
    };
    var getCenterOffset = function getCenterOffset(bb) {
        return {
            x: -bb.w / 2,
            y: -bb.h / 2
        };
    };
    var backgroundTimestampHasChanged = function backgroundTimestampHasChanged(ele) {
        var _p = ele[0]._private;
        var same = _p.oldBackgroundTimestamp === _p.backgroundTimestamp;
        return !same;
    };
    var getStyleKey = function getStyleKey(ele) {
        return ele[0]._private.nodeKey;
    };
    var getLabelKey = function getLabelKey(ele) {
        return ele[0]._private.labelStyleKey;
    };
    var getSourceLabelKey = function getSourceLabelKey(ele) {
        return ele[0]._private.sourceLabelStyleKey;
    };
    var getTargetLabelKey = function getTargetLabelKey(ele) {
        return ele[0]._private.targetLabelStyleKey;
    };
    var drawElement = function drawElement(context, ele, bb, scaledLabelShown, useEleOpacity) {
        return r.drawElement(context, ele, bb, false, false, useEleOpacity);
    };
    var drawLabel = function drawLabel(context, ele, bb, scaledLabelShown, useEleOpacity) {
        return r.drawElementText(context, ele, bb, scaledLabelShown, 'main', useEleOpacity);
    };
    var drawSourceLabel = function drawSourceLabel(context, ele, bb, scaledLabelShown, useEleOpacity) {
        return r.drawElementText(context, ele, bb, scaledLabelShown, 'source', useEleOpacity);
    };
    var drawTargetLabel = function drawTargetLabel(context, ele, bb, scaledLabelShown, useEleOpacity) {
        return r.drawElementText(context, ele, bb, scaledLabelShown, 'target', useEleOpacity);
    };
    var getElementBox = function getElementBox(ele) {
        ele.boundingBox();
        return ele[0]._private.bodyBounds;
    };
    var getLabelBox = function getLabelBox(ele) {
        ele.boundingBox();
        return ele[0]._private.labelBounds.main || emptyBb;
    };
    var getSourceLabelBox = function getSourceLabelBox(ele) {
        ele.boundingBox();
        return ele[0]._private.labelBounds.source || emptyBb;
    };
    var getTargetLabelBox = function getTargetLabelBox(ele) {
        ele.boundingBox();
        return ele[0]._private.labelBounds.target || emptyBb;
    };
    var isLabelVisibleAtScale = function isLabelVisibleAtScale(ele, scaledLabelShown) {
        return scaledLabelShown;
    };
    var getElementRotationPoint = function getElementRotationPoint(ele) {
        return getBoxCenter(getElementBox(ele));
    };
    var addTextMargin = function addTextMargin(prefix, pt, ele) {
        var pre = prefix ? prefix + '-' : '';
        return {
            x: pt.x + ele.pstyle(pre + 'text-margin-x').pfValue,
            y: pt.y + ele.pstyle(pre + 'text-margin-y').pfValue
        };
    };
    var getRsPt = function getRsPt(ele, x, y) {
        var rs = ele[0]._private.rscratch;
        return {
            x: rs[x],
            y: rs[y]
        };
    };
    var getLabelRotationPoint = function getLabelRotationPoint(ele) {
        return addTextMargin('', getRsPt(ele, 'labelX', 'labelY'), ele);
    };
    var getSourceLabelRotationPoint = function getSourceLabelRotationPoint(ele) {
        return addTextMargin('source', getRsPt(ele, 'sourceLabelX', 'sourceLabelY'), ele);
    };
    var getTargetLabelRotationPoint = function getTargetLabelRotationPoint(ele) {
        return addTextMargin('target', getRsPt(ele, 'targetLabelX', 'targetLabelY'), ele);
    };
    var getElementRotationOffset = function getElementRotationOffset(ele) {
        return getCenterOffset(getElementBox(ele));
    };
    var getSourceLabelRotationOffset = function getSourceLabelRotationOffset(ele) {
        return getCenterOffset(getSourceLabelBox(ele));
    };
    var getTargetLabelRotationOffset = function getTargetLabelRotationOffset(ele) {
        return getCenterOffset(getTargetLabelBox(ele));
    };
    var getLabelRotationOffset = function getLabelRotationOffset(ele) {
        var bb = getLabelBox(ele);
        var p = getCenterOffset(getLabelBox(ele));
        if (ele.isNode()) {
            switch(ele.pstyle('text-halign').value){
                case 'left':
                    p.x = -bb.w - (bb.leftPad || 0);
                    break;
                case 'right':
                    p.x = -(bb.rightPad || 0);
                    break;
            }
            switch(ele.pstyle('text-valign').value){
                case 'top':
                    p.y = -bb.h - (bb.topPad || 0);
                    break;
                case 'bottom':
                    p.y = -(bb.botPad || 0);
                    break;
            }
        }
        return p;
    };
    var eleTxrCache = r.data.eleTxrCache = new $e815fda779bc047b$var$ElementTextureCache(r, {
        getKey: getStyleKey,
        doesEleInvalidateKey: backgroundTimestampHasChanged,
        drawElement: drawElement,
        getBoundingBox: getElementBox,
        getRotationPoint: getElementRotationPoint,
        getRotationOffset: getElementRotationOffset,
        allowEdgeTxrCaching: false,
        allowParentTxrCaching: false
    });
    var lblTxrCache = r.data.lblTxrCache = new $e815fda779bc047b$var$ElementTextureCache(r, {
        getKey: getLabelKey,
        drawElement: drawLabel,
        getBoundingBox: getLabelBox,
        getRotationPoint: getLabelRotationPoint,
        getRotationOffset: getLabelRotationOffset,
        isVisible: isLabelVisibleAtScale
    });
    var slbTxrCache = r.data.slbTxrCache = new $e815fda779bc047b$var$ElementTextureCache(r, {
        getKey: getSourceLabelKey,
        drawElement: drawSourceLabel,
        getBoundingBox: getSourceLabelBox,
        getRotationPoint: getSourceLabelRotationPoint,
        getRotationOffset: getSourceLabelRotationOffset,
        isVisible: isLabelVisibleAtScale
    });
    var tlbTxrCache = r.data.tlbTxrCache = new $e815fda779bc047b$var$ElementTextureCache(r, {
        getKey: getTargetLabelKey,
        drawElement: drawTargetLabel,
        getBoundingBox: getTargetLabelBox,
        getRotationPoint: getTargetLabelRotationPoint,
        getRotationOffset: getTargetLabelRotationOffset,
        isVisible: isLabelVisibleAtScale
    });
    var lyrTxrCache = r.data.lyrTxrCache = new $e815fda779bc047b$var$LayeredTextureCache(r);
    r.onUpdateEleCalcs(function invalidateTextureCaches(willDraw, eles) {
        // each cache should check for sub-key diff to see that the update affects that cache particularly
        eleTxrCache.invalidateElements(eles);
        lblTxrCache.invalidateElements(eles);
        slbTxrCache.invalidateElements(eles);
        tlbTxrCache.invalidateElements(eles);
        // any change invalidates the layers
        lyrTxrCache.invalidateElements(eles);
        // update the old bg timestamp so diffs can be done in the ele txr caches
        for(var _i = 0; _i < eles.length; _i++){
            var _p = eles[_i]._private;
            _p.oldBackgroundTimestamp = _p.backgroundTimestamp;
        }
    });
    var refineInLayers = function refineInLayers(reqs) {
        for(var i = 0; i < reqs.length; i++)lyrTxrCache.enqueueElementRefinement(reqs[i].ele);
    };
    eleTxrCache.onDequeue(refineInLayers);
    lblTxrCache.onDequeue(refineInLayers);
    slbTxrCache.onDequeue(refineInLayers);
    tlbTxrCache.onDequeue(refineInLayers);
    if (options.webgl) r.initWebgl(options, {
        getStyleKey: getStyleKey,
        getLabelKey: getLabelKey,
        getSourceLabelKey: getSourceLabelKey,
        getTargetLabelKey: getTargetLabelKey,
        drawElement: drawElement,
        drawLabel: drawLabel,
        drawSourceLabel: drawSourceLabel,
        drawTargetLabel: drawTargetLabel,
        getElementBox: getElementBox,
        getLabelBox: getLabelBox,
        getSourceLabelBox: getSourceLabelBox,
        getTargetLabelBox: getTargetLabelBox,
        getElementRotationPoint: getElementRotationPoint,
        getElementRotationOffset: getElementRotationOffset,
        getLabelRotationPoint: getLabelRotationPoint,
        getSourceLabelRotationPoint: getSourceLabelRotationPoint,
        getTargetLabelRotationPoint: getTargetLabelRotationPoint,
        getLabelRotationOffset: getLabelRotationOffset,
        getSourceLabelRotationOffset: getSourceLabelRotationOffset,
        getTargetLabelRotationOffset: getTargetLabelRotationOffset
    });
}
$e815fda779bc047b$var$CRp.redrawHint = function(group, bool) {
    var r = this;
    switch(group){
        case 'eles':
            r.data.canvasNeedsRedraw[$e815fda779bc047b$var$CRp.NODE] = bool;
            break;
        case 'drag':
            r.data.canvasNeedsRedraw[$e815fda779bc047b$var$CRp.DRAG] = bool;
            break;
        case 'select':
            r.data.canvasNeedsRedraw[$e815fda779bc047b$var$CRp.SELECT_BOX] = bool;
            break;
        case 'gc':
            r.data.gc = true;
            break;
    }
};
// whether to use Path2D caching for drawing
var $e815fda779bc047b$var$pathsImpld = typeof Path2D !== 'undefined';
$e815fda779bc047b$var$CRp.path2dEnabled = function(on) {
    if (on === undefined) return this.pathsEnabled;
    this.pathsEnabled = on ? true : false;
};
$e815fda779bc047b$var$CRp.usePaths = function() {
    return $e815fda779bc047b$var$pathsImpld && this.pathsEnabled;
};
$e815fda779bc047b$var$CRp.setImgSmoothing = function(context, bool) {
    if (context.imageSmoothingEnabled != null) context.imageSmoothingEnabled = bool;
    else {
        context.webkitImageSmoothingEnabled = bool;
        context.mozImageSmoothingEnabled = bool;
        context.msImageSmoothingEnabled = bool;
    }
};
$e815fda779bc047b$var$CRp.getImgSmoothing = function(context) {
    if (context.imageSmoothingEnabled != null) return context.imageSmoothingEnabled;
    else return context.webkitImageSmoothingEnabled || context.mozImageSmoothingEnabled || context.msImageSmoothingEnabled;
};
$e815fda779bc047b$var$CRp.makeOffscreenCanvas = function(width, height) {
    var canvas;
    if ((typeof OffscreenCanvas === "undefined" ? "undefined" : $e815fda779bc047b$var$_typeof(OffscreenCanvas)) !== "undefined") canvas = new OffscreenCanvas(width, height);
    else {
        var containerWindow = this.cy.window();
        var document1 = containerWindow.document;
        canvas = document1.createElement('canvas'); // eslint-disable-line no-undef
        canvas.width = width;
        canvas.height = height;
    }
    return canvas;
};
[
    $e815fda779bc047b$var$CRp$b,
    $e815fda779bc047b$var$CRp$a,
    $e815fda779bc047b$var$CRp$9,
    $e815fda779bc047b$var$CRp$8,
    $e815fda779bc047b$var$CRp$7,
    $e815fda779bc047b$var$CRp$6,
    $e815fda779bc047b$var$CRp$5,
    $e815fda779bc047b$var$CRp$4,
    $e815fda779bc047b$var$CRp$3,
    $e815fda779bc047b$var$CRp$2,
    $e815fda779bc047b$var$CRp$1
].forEach(function(props) {
    $e815fda779bc047b$var$extend($e815fda779bc047b$var$CRp, props);
});
var $e815fda779bc047b$var$renderer = [
    {
        name: 'null',
        impl: $e815fda779bc047b$var$NullRenderer
    },
    {
        name: 'base',
        impl: $e815fda779bc047b$var$BR
    },
    {
        name: 'canvas',
        impl: $e815fda779bc047b$var$CR
    }
];
var $e815fda779bc047b$var$incExts = [
    {
        type: 'layout',
        extensions: $e815fda779bc047b$var$layout
    },
    {
        type: 'renderer',
        extensions: $e815fda779bc047b$var$renderer
    }
];
// registered extensions to cytoscape, indexed by name
var $e815fda779bc047b$var$extensions = {};
// registered modules for extensions, indexed by name
var $e815fda779bc047b$var$modules = {};
function $e815fda779bc047b$var$setExtension(type, name, registrant) {
    var ext = registrant;
    var overrideErr = function overrideErr(field) {
        $e815fda779bc047b$var$warn('Can not register `' + name + '` for `' + type + '` since `' + field + '` already exists in the prototype and can not be overridden');
    };
    if (type === 'core') {
        if ($e815fda779bc047b$var$Core.prototype[name]) return overrideErr(name);
        else $e815fda779bc047b$var$Core.prototype[name] = registrant;
    } else if (type === 'collection') {
        if ($e815fda779bc047b$var$Collection.prototype[name]) return overrideErr(name);
        else $e815fda779bc047b$var$Collection.prototype[name] = registrant;
    } else if (type === 'layout') {
        // fill in missing layout functions in the prototype
        var Layout = function Layout(options) {
            this.options = options;
            registrant.call(this, options);
            // make sure layout has _private for use w/ std apis like .on()
            if (!$e815fda779bc047b$var$plainObject(this._private)) this._private = {};
            this._private.cy = options.cy;
            this._private.listeners = [];
            this.createEmitter();
        };
        var layoutProto = Layout.prototype = Object.create(registrant.prototype);
        var optLayoutFns = [];
        for(var i = 0; i < optLayoutFns.length; i++){
            var fnName = optLayoutFns[i];
            layoutProto[fnName] = layoutProto[fnName] || function() {
                return this;
            };
        }
        // either .start() or .run() is defined, so autogen the other
        if (layoutProto.start && !layoutProto.run) layoutProto.run = function() {
            this.start();
            return this;
        };
        else if (!layoutProto.start && layoutProto.run) layoutProto.start = function() {
            this.run();
            return this;
        };
        var regStop = registrant.prototype.stop;
        layoutProto.stop = function() {
            var opts = this.options;
            if (opts && opts.animate) {
                var anis = this.animations;
                if (anis) for(var _i = 0; _i < anis.length; _i++)anis[_i].stop();
            }
            if (regStop) regStop.call(this);
            else this.emit('layoutstop');
            return this;
        };
        if (!layoutProto.destroy) layoutProto.destroy = function() {
            return this;
        };
        layoutProto.cy = function() {
            return this._private.cy;
        };
        var getCy = function getCy(layout) {
            return layout._private.cy;
        };
        var emitterOpts = {
            addEventFields: function addEventFields(layout, evt) {
                evt.layout = layout;
                evt.cy = getCy(layout);
                evt.target = layout;
            },
            bubble: function bubble() {
                return true;
            },
            parent: function parent(layout) {
                return getCy(layout);
            }
        };
        $e815fda779bc047b$var$extend(layoutProto, {
            createEmitter: function createEmitter() {
                this._private.emitter = new $e815fda779bc047b$var$Emitter(emitterOpts, this);
                return this;
            },
            emitter: function emitter() {
                return this._private.emitter;
            },
            on: function on(evt, cb) {
                this.emitter().on(evt, cb);
                return this;
            },
            one: function one(evt, cb) {
                this.emitter().one(evt, cb);
                return this;
            },
            once: function once(evt, cb) {
                this.emitter().one(evt, cb);
                return this;
            },
            removeListener: function removeListener(evt, cb) {
                this.emitter().removeListener(evt, cb);
                return this;
            },
            removeAllListeners: function removeAllListeners() {
                this.emitter().removeAllListeners();
                return this;
            },
            emit: function emit(evt, params) {
                this.emitter().emit(evt, params);
                return this;
            }
        });
        $e815fda779bc047b$var$define.eventAliasesOn(layoutProto);
        ext = Layout; // replace with our wrapped layout
    } else if (type === 'renderer' && name !== 'null' && name !== 'base') {
        // user registered renderers inherit from base
        var BaseRenderer = $e815fda779bc047b$var$getExtension('renderer', 'base');
        var bProto = BaseRenderer.prototype;
        var RegistrantRenderer = registrant;
        var rProto = registrant.prototype;
        var Renderer = function Renderer() {
            BaseRenderer.apply(this, arguments);
            RegistrantRenderer.apply(this, arguments);
        };
        var proto = Renderer.prototype;
        for(var pName in bProto){
            var pVal = bProto[pName];
            var existsInR = rProto[pName] != null;
            if (existsInR) return overrideErr(pName);
            proto[pName] = pVal; // take impl from base
        }
        for(var _pName in rProto)proto[_pName] = rProto[_pName]; // take impl from registrant
        bProto.clientFunctions.forEach(function(name) {
            proto[name] = proto[name] || function() {
                $e815fda779bc047b$var$error('Renderer does not implement `renderer.' + name + '()` on its prototype');
            };
        });
        ext = Renderer;
    } else if (type === '__proto__' || type === 'constructor' || type === 'prototype') // to avoid potential prototype pollution
    return $e815fda779bc047b$var$error(type + ' is an illegal type to be registered, possibly lead to prototype pollutions');
    return $e815fda779bc047b$var$setMap({
        map: $e815fda779bc047b$var$extensions,
        keys: [
            type,
            name
        ],
        value: ext
    });
}
function $e815fda779bc047b$var$getExtension(type, name) {
    return $e815fda779bc047b$var$getMap({
        map: $e815fda779bc047b$var$extensions,
        keys: [
            type,
            name
        ]
    });
}
function $e815fda779bc047b$var$setModule(type, name, moduleType, moduleName, registrant) {
    return $e815fda779bc047b$var$setMap({
        map: $e815fda779bc047b$var$modules,
        keys: [
            type,
            name,
            moduleType,
            moduleName
        ],
        value: registrant
    });
}
function $e815fda779bc047b$var$getModule(type, name, moduleType, moduleName) {
    return $e815fda779bc047b$var$getMap({
        map: $e815fda779bc047b$var$modules,
        keys: [
            type,
            name,
            moduleType,
            moduleName
        ]
    });
}
var $e815fda779bc047b$var$extension = function extension() {
    // e.g. extension('renderer', 'svg')
    if (arguments.length === 2) return $e815fda779bc047b$var$getExtension.apply(null, arguments);
    else if (arguments.length === 3) return $e815fda779bc047b$var$setExtension.apply(null, arguments);
    else if (arguments.length === 4) return $e815fda779bc047b$var$getModule.apply(null, arguments);
    else if (arguments.length === 5) return $e815fda779bc047b$var$setModule.apply(null, arguments);
    else $e815fda779bc047b$var$error('Invalid extension access syntax');
};
// allows a core instance to access extensions internally
$e815fda779bc047b$var$Core.prototype.extension = $e815fda779bc047b$var$extension;
// included extensions
$e815fda779bc047b$var$incExts.forEach(function(group) {
    group.extensions.forEach(function(ext) {
        $e815fda779bc047b$var$setExtension(group.type, ext.name, ext.impl);
    });
});
// a dummy stylesheet object that doesn't need a reference to the core
// (useful for init)
var $e815fda779bc047b$var$_Stylesheet = function Stylesheet() {
    if (!(this instanceof $e815fda779bc047b$var$_Stylesheet)) return new $e815fda779bc047b$var$_Stylesheet();
    this.length = 0;
};
var $e815fda779bc047b$var$sheetfn = $e815fda779bc047b$var$_Stylesheet.prototype;
$e815fda779bc047b$var$sheetfn.instanceString = function() {
    return 'stylesheet';
};
// just store the selector to be parsed later
$e815fda779bc047b$var$sheetfn.selector = function(selector) {
    var i = this.length++;
    this[i] = {
        selector: selector,
        properties: []
    };
    return this; // chaining
};
// just store the property to be parsed later
$e815fda779bc047b$var$sheetfn.css = function(name, value) {
    var i = this.length - 1;
    if ($e815fda779bc047b$var$string(name)) this[i].properties.push({
        name: name,
        value: value
    });
    else if ($e815fda779bc047b$var$plainObject(name)) {
        var map = name;
        var propNames = Object.keys(map);
        for(var j = 0; j < propNames.length; j++){
            var key = propNames[j];
            var mapVal = map[key];
            if (mapVal == null) continue;
            var prop = $e815fda779bc047b$var$_Style.properties[key] || $e815fda779bc047b$var$_Style.properties[$e815fda779bc047b$var$dash2camel(key)];
            if (prop == null) continue;
            var _name = prop.name;
            var _value = mapVal;
            this[i].properties.push({
                name: _name,
                value: _value
            });
        }
    }
    return this; // chaining
};
$e815fda779bc047b$var$sheetfn.style = $e815fda779bc047b$var$sheetfn.css;
// generate a real style object from the dummy stylesheet
$e815fda779bc047b$var$sheetfn.generateStyle = function(cy) {
    var style = new $e815fda779bc047b$var$_Style(cy);
    return this.appendToStyle(style);
};
// append a dummy stylesheet object on a real style object
$e815fda779bc047b$var$sheetfn.appendToStyle = function(style) {
    for(var i = 0; i < this.length; i++){
        var context = this[i];
        var selector = context.selector;
        var props = context.properties;
        style.selector(selector); // apply selector
        for(var j = 0; j < props.length; j++){
            var prop = props[j];
            style.css(prop.name, prop.value); // apply property
        }
    }
    return style;
};
var $e815fda779bc047b$var$version = "3.33.3";
var $e815fda779bc047b$export$2e2bcd8739ae039 = function cytoscape(options) {
    // if no options specified, use default
    if (options === undefined) options = {};
    // create instance
    if ($e815fda779bc047b$var$plainObject(options)) return new $e815fda779bc047b$var$Core(options);
    else if ($e815fda779bc047b$var$string(options)) return $e815fda779bc047b$var$extension.apply($e815fda779bc047b$var$extension, arguments);
};
// e.g. cytoscape.use( require('cytoscape-foo'), bar )
$e815fda779bc047b$export$2e2bcd8739ae039.use = function(ext) {
    var args = Array.prototype.slice.call(arguments, 1); // args to pass to ext
    args.unshift($e815fda779bc047b$export$2e2bcd8739ae039); // cytoscape is first arg to ext
    ext.apply(null, args);
    return this;
};
$e815fda779bc047b$export$2e2bcd8739ae039.warnings = function(bool) {
    return $e815fda779bc047b$var$warnings(bool);
};
// replaced by build system
$e815fda779bc047b$export$2e2bcd8739ae039.version = $e815fda779bc047b$var$version;
// expose public apis (mostly for extensions)
$e815fda779bc047b$export$2e2bcd8739ae039.stylesheet = $e815fda779bc047b$export$2e2bcd8739ae039.Stylesheet = $e815fda779bc047b$var$_Stylesheet;

});

parcelRegister("cTjUK", function(module, exports) {

(function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory((parcelRequire("261Fc")));
})(module.exports, function(__WEBPACK_EXTERNAL_MODULE__4__) {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                enumerable: true,
                get: getter
            });
        /******/ };
        /******/ /******/ // define __esModule on exports
        /******/ __webpack_require__.r = function(exports) {
            /******/ if (typeof Symbol !== 'undefined' && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                value: 'Module'
            });
            /******/ Object.defineProperty(exports, '__esModule', {
                value: true
            });
        /******/ };
        /******/ /******/ // create a fake namespace object
        /******/ // mode & 1: value is a module id, require it
        /******/ // mode & 2: merge all properties of value into the ns
        /******/ // mode & 4: return value when already ns object
        /******/ // mode & 8|1: behave like require
        /******/ __webpack_require__.t = function(value, mode) {
            /******/ if (mode & 1) value = __webpack_require__(value);
            /******/ if (mode & 8) return value;
            /******/ if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
            /******/ var ns = Object.create(null);
            /******/ __webpack_require__.r(ns);
            /******/ Object.defineProperty(ns, 'default', {
                enumerable: true,
                value: value
            });
            /******/ if (mode & 2 && typeof value != 'string') for(var key in value)__webpack_require__.d(ns, key, (function(key) {
                return value[key];
            }).bind(null, key));
            /******/ return ns;
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1['default'];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, 'a', getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 0);
    /******/ }([
        /* 0 */ /***/ function(module1, exports, __webpack_require__) {
            var impl = __webpack_require__(1); // registers the extension on a cytoscape lib ref
            var register = function register(cytoscape1) {
                if (!cytoscape1) return;
                 // can't register if cytoscape unspecified
                cytoscape1('layout', 'dagre', impl); // register with cytoscape.js
            };
            if (typeof cytoscape !== 'undefined') // expose to global cytoscape (i.e. window.cytoscape)
            register(cytoscape);
            module1.exports = register;
        /***/ },
        /* 1 */ /***/ function(module1, exports, __webpack_require__) {
            function _typeof(obj) {
                "@babel/helpers - typeof";
                if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                    return typeof obj;
                };
                else _typeof = function _typeof(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                };
                return _typeof(obj);
            }
            var isFunction = function isFunction(o) {
                return typeof o === 'function';
            };
            var defaults = __webpack_require__(2);
            var assign = __webpack_require__(3);
            var dagre = __webpack_require__(4); // constructor
            // options : object containing layout options
            function DagreLayout(options) {
                this.options = assign({}, defaults, options);
            } // runs the layout
            DagreLayout.prototype.run = function() {
                var options = this.options;
                var layout = this;
                var cy = options.cy; // cy is automatically populated for us in the constructor
                var eles = options.eles;
                var getVal = function getVal(ele, val) {
                    return isFunction(val) ? val.apply(ele, [
                        ele
                    ]) : val;
                };
                var bb = options.boundingBox || {
                    x1: 0,
                    y1: 0,
                    w: cy.width(),
                    h: cy.height()
                };
                if (bb.x2 === undefined) bb.x2 = bb.x1 + bb.w;
                if (bb.w === undefined) bb.w = bb.x2 - bb.x1;
                if (bb.y2 === undefined) bb.y2 = bb.y1 + bb.h;
                if (bb.h === undefined) bb.h = bb.y2 - bb.y1;
                var g = new dagre.graphlib.Graph({
                    multigraph: true,
                    compound: true
                });
                var gObj = {};
                var setGObj = function setGObj(name, val) {
                    if (val != null) gObj[name] = val;
                };
                setGObj('nodesep', options.nodeSep);
                setGObj('edgesep', options.edgeSep);
                setGObj('ranksep', options.rankSep);
                setGObj('rankdir', options.rankDir);
                setGObj('align', options.align);
                setGObj('ranker', options.ranker);
                setGObj('acyclicer', options.acyclicer);
                g.setGraph(gObj);
                g.setDefaultEdgeLabel(function() {
                    return {};
                });
                g.setDefaultNodeLabel(function() {
                    return {};
                }); // add nodes to dagre
                var nodes = eles.nodes();
                if (isFunction(options.sort)) nodes = nodes.sort(options.sort);
                for(var i = 0; i < nodes.length; i++){
                    var node = nodes[i];
                    var nbb = node.layoutDimensions(options);
                    g.setNode(node.id(), {
                        width: nbb.w,
                        height: nbb.h,
                        name: node.id()
                    }); // console.log( g.node(node.id()) );
                } // set compound parents
                for(var _i = 0; _i < nodes.length; _i++){
                    var _node = nodes[_i];
                    if (_node.isChild()) g.setParent(_node.id(), _node.parent().id());
                } // add edges to dagre
                var edges = eles.edges().stdFilter(function(edge) {
                    return !edge.source().isParent() && !edge.target().isParent(); // dagre can't handle edges on compound nodes
                });
                if (isFunction(options.sort)) edges = edges.sort(options.sort);
                for(var _i2 = 0; _i2 < edges.length; _i2++){
                    var edge = edges[_i2];
                    g.setEdge(edge.source().id(), edge.target().id(), {
                        minlen: getVal(edge, options.minLen),
                        weight: getVal(edge, options.edgeWeight),
                        name: edge.id()
                    }, edge.id()); // console.log( g.edge(edge.source().id(), edge.target().id(), edge.id()) );
                }
                dagre.layout(g);
                var gNodeIds = g.nodes();
                for(var _i3 = 0; _i3 < gNodeIds.length; _i3++){
                    var id = gNodeIds[_i3];
                    var n = g.node(id);
                    cy.getElementById(id).scratch().dagre = n;
                }
                var dagreBB;
                if (options.boundingBox) {
                    dagreBB = {
                        x1: Infinity,
                        x2: -Infinity,
                        y1: Infinity,
                        y2: -Infinity
                    };
                    nodes.forEach(function(node) {
                        var dModel = node.scratch().dagre;
                        dagreBB.x1 = Math.min(dagreBB.x1, dModel.x);
                        dagreBB.x2 = Math.max(dagreBB.x2, dModel.x);
                        dagreBB.y1 = Math.min(dagreBB.y1, dModel.y);
                        dagreBB.y2 = Math.max(dagreBB.y2, dModel.y);
                    });
                    dagreBB.w = dagreBB.x2 - dagreBB.x1;
                    dagreBB.h = dagreBB.y2 - dagreBB.y1;
                } else dagreBB = bb;
                var constrainPos = function constrainPos(p) {
                    if (options.boundingBox) {
                        var xPct = dagreBB.w === 0 ? 0 : (p.x - dagreBB.x1) / dagreBB.w;
                        var yPct = dagreBB.h === 0 ? 0 : (p.y - dagreBB.y1) / dagreBB.h;
                        return {
                            x: bb.x1 + xPct * bb.w,
                            y: bb.y1 + yPct * bb.h
                        };
                    } else return p;
                };
                nodes.layoutPositions(layout, options, function(ele) {
                    ele = _typeof(ele) === "object" ? ele : this;
                    var dModel = ele.scratch().dagre;
                    return constrainPos({
                        x: dModel.x,
                        y: dModel.y
                    });
                });
                return this; // chaining
            };
            module1.exports = DagreLayout;
        /***/ },
        /* 2 */ /***/ function(module1, exports) {
            var defaults = {
                // dagre algo options, uses default value on undefined
                nodeSep: undefined,
                // the separation between adjacent nodes in the same rank
                edgeSep: undefined,
                // the separation between adjacent edges in the same rank
                rankSep: undefined,
                // the separation between adjacent nodes in the same rank
                rankDir: undefined,
                // 'TB' for top to bottom flow, 'LR' for left to right,
                align: undefined,
                // alignment for rank nodes. Can be 'UL', 'UR', 'DL', or 'DR', where U = up, D = down, L = left, and R = right
                acyclicer: undefined,
                // If set to 'greedy', uses a greedy heuristic for finding a feedback arc set for a graph.
                // A feedback arc set is a set of edges that can be removed to make a graph acyclic.
                ranker: undefined,
                // Type of algorithm to assigns a rank to each node in the input graph.
                // Possible values: network-simplex, tight-tree or longest-path
                minLen: function minLen(edge) {
                    return 1;
                },
                // number of ranks to keep between the source and target of the edge
                edgeWeight: function edgeWeight(edge) {
                    return 1;
                },
                // higher weight edges are generally made shorter and straighter than lower weight edges
                // general layout options
                fit: true,
                // whether to fit to viewport
                padding: 30,
                // fit padding
                spacingFactor: undefined,
                // Applies a multiplicative factor (>0) to expand or compress the overall area that the nodes take up
                nodeDimensionsIncludeLabels: false,
                // whether labels should be included in determining the space used by a node
                animate: false,
                // whether to transition the node positions
                animateFilter: function animateFilter(node, i) {
                    return true;
                },
                // whether to animate specific nodes when animation is on; non-animated nodes immediately go to their final positions
                animationDuration: 500,
                // duration of animation in ms if enabled
                animationEasing: undefined,
                // easing of animation if enabled
                boundingBox: undefined,
                // constrain layout bounds; { x1, y1, x2, y2 } or { x1, y1, w, h }
                transform: function transform(node, pos) {
                    return pos;
                },
                // a function that applies a transform to the final node position
                ready: function ready() {},
                // on layoutready
                sort: undefined,
                // a sorting function to order the nodes and edges; e.g. function(a, b){ return a.data('weight') - b.data('weight') }
                // because cytoscape dagre creates a directed graph, and directed graphs use the node order as a tie breaker when
                // defining the topology of a graph, this sort function can help ensure the correct order of the nodes/edges.
                // this feature is most useful when adding and removing the same nodes and edges multiple times in a graph.
                stop: function stop() {} // on layoutstop
            };
            module1.exports = defaults;
        /***/ },
        /* 3 */ /***/ function(module1, exports) {
            // Simple, internal Object.assign() polyfill for options objects etc.
            module1.exports = Object.assign != null ? Object.assign.bind(Object) : function(tgt) {
                for(var _len = arguments.length, srcs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)srcs[_key - 1] = arguments[_key];
                srcs.forEach(function(src) {
                    Object.keys(src).forEach(function(k) {
                        return tgt[k] = src[k];
                    });
                });
                return tgt;
            };
        /***/ },
        /* 4 */ /***/ function(module1, exports) {
            module1.exports = __WEBPACK_EXTERNAL_MODULE__4__;
        /***/ }
    ]);
});

});
parcelRegister("261Fc", function(module, exports) {
/*
Copyright (c) 2012-2014 Chris Pettitt

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.
*/ 





module.exports = {
    graphlib: (parcelRequire("6mwJ2")),
    layout: (parcelRequire("VZEn7")),
    debug: (parcelRequire("8XBdx")),
    util: {
        time: (parcelRequire("1kMKg")).time,
        notime: (parcelRequire("1kMKg")).notime
    },
    version: (parcelRequire("9Grre"))
};

});
parcelRegister("6mwJ2", function(module, exports) {
/* global window */ var $4a1e2ebf410e6993$var$graphlib;

try {
    $4a1e2ebf410e6993$var$graphlib = (parcelRequire("2B9Zv"));
} catch (e) {
// continue regardless of error
}
if (!$4a1e2ebf410e6993$var$graphlib) $4a1e2ebf410e6993$var$graphlib = window.graphlib;
module.exports = $4a1e2ebf410e6993$var$graphlib;

});
parcelRegister("2B9Zv", function(module, exports) {
/**
 * Copyright (c) 2014, Chris Pettitt
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 * list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 * this list of conditions and the following disclaimer in the documentation
 * and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its contributors
 * may be used to endorse or promote products derived from this software without
 * specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ 
var $5j6So = parcelRequire("5j6So");


module.exports = {
    Graph: $5j6So.Graph,
    json: (parcelRequire("cOdIh")),
    alg: (parcelRequire("jm1Oa")),
    version: $5j6So.version
};

});
parcelRegister("5j6So", function(module, exports) {
// Includes only the "core" of graphlib


module.exports = {
    Graph: (parcelRequire("4JZcb")),
    version: (parcelRequire("5LcVV"))
};

});
parcelRegister("4JZcb", function(module, exports) {
"use strict";

var $dOCPl = parcelRequire("dOCPl");
module.exports = $373ad590b7c1733e$var$Graph;
var $373ad590b7c1733e$var$DEFAULT_EDGE_NAME = "\x00";
var $373ad590b7c1733e$var$GRAPH_NODE = "\x00";
var $373ad590b7c1733e$var$EDGE_KEY_DELIM = "\x01";
// Implementation notes:
//
//  * Node id query functions should return string ids for the nodes
//  * Edge id query functions should return an "edgeObj", edge object, that is
//    composed of enough information to uniquely identify an edge: {v, w, name}.
//  * Internally we use an "edgeId", a stringified form of the edgeObj, to
//    reference edges. This is because we need a performant way to look these
//    edges up and, object properties, which have string keys, are the closest
//    we're going to get to a performant hashtable in JavaScript.
function $373ad590b7c1733e$var$Graph(opts) {
    this._isDirected = $dOCPl.has(opts, "directed") ? opts.directed : true;
    this._isMultigraph = $dOCPl.has(opts, "multigraph") ? opts.multigraph : false;
    this._isCompound = $dOCPl.has(opts, "compound") ? opts.compound : false;
    // Label for the graph itself
    this._label = undefined;
    // Defaults to be set when creating a new node
    this._defaultNodeLabelFn = $dOCPl.constant(undefined);
    // Defaults to be set when creating a new edge
    this._defaultEdgeLabelFn = $dOCPl.constant(undefined);
    // v -> label
    this._nodes = {};
    if (this._isCompound) {
        // v -> parent
        this._parent = {};
        // v -> children
        this._children = {};
        this._children[$373ad590b7c1733e$var$GRAPH_NODE] = {};
    }
    // v -> edgeObj
    this._in = {};
    // u -> v -> Number
    this._preds = {};
    // v -> edgeObj
    this._out = {};
    // v -> w -> Number
    this._sucs = {};
    // e -> edgeObj
    this._edgeObjs = {};
    // e -> label
    this._edgeLabels = {};
}
/* Number of nodes in the graph. Should only be changed by the implementation. */ $373ad590b7c1733e$var$Graph.prototype._nodeCount = 0;
/* Number of edges in the graph. Should only be changed by the implementation. */ $373ad590b7c1733e$var$Graph.prototype._edgeCount = 0;
/* === Graph functions ========= */ $373ad590b7c1733e$var$Graph.prototype.isDirected = function() {
    return this._isDirected;
};
$373ad590b7c1733e$var$Graph.prototype.isMultigraph = function() {
    return this._isMultigraph;
};
$373ad590b7c1733e$var$Graph.prototype.isCompound = function() {
    return this._isCompound;
};
$373ad590b7c1733e$var$Graph.prototype.setGraph = function(label) {
    this._label = label;
    return this;
};
$373ad590b7c1733e$var$Graph.prototype.graph = function() {
    return this._label;
};
/* === Node functions ========== */ $373ad590b7c1733e$var$Graph.prototype.setDefaultNodeLabel = function(newDefault) {
    if (!$dOCPl.isFunction(newDefault)) newDefault = $dOCPl.constant(newDefault);
    this._defaultNodeLabelFn = newDefault;
    return this;
};
$373ad590b7c1733e$var$Graph.prototype.nodeCount = function() {
    return this._nodeCount;
};
$373ad590b7c1733e$var$Graph.prototype.nodes = function() {
    return $dOCPl.keys(this._nodes);
};
$373ad590b7c1733e$var$Graph.prototype.sources = function() {
    var self = this;
    return $dOCPl.filter(this.nodes(), function(v) {
        return $dOCPl.isEmpty(self._in[v]);
    });
};
$373ad590b7c1733e$var$Graph.prototype.sinks = function() {
    var self = this;
    return $dOCPl.filter(this.nodes(), function(v) {
        return $dOCPl.isEmpty(self._out[v]);
    });
};
$373ad590b7c1733e$var$Graph.prototype.setNodes = function(vs, value) {
    var args = arguments;
    var self = this;
    $dOCPl.each(vs, function(v) {
        if (args.length > 1) self.setNode(v, value);
        else self.setNode(v);
    });
    return this;
};
$373ad590b7c1733e$var$Graph.prototype.setNode = function(v, value) {
    if ($dOCPl.has(this._nodes, v)) {
        if (arguments.length > 1) this._nodes[v] = value;
        return this;
    }
    this._nodes[v] = arguments.length > 1 ? value : this._defaultNodeLabelFn(v);
    if (this._isCompound) {
        this._parent[v] = $373ad590b7c1733e$var$GRAPH_NODE;
        this._children[v] = {};
        this._children[$373ad590b7c1733e$var$GRAPH_NODE][v] = true;
    }
    this._in[v] = {};
    this._preds[v] = {};
    this._out[v] = {};
    this._sucs[v] = {};
    ++this._nodeCount;
    return this;
};
$373ad590b7c1733e$var$Graph.prototype.node = function(v) {
    return this._nodes[v];
};
$373ad590b7c1733e$var$Graph.prototype.hasNode = function(v) {
    return $dOCPl.has(this._nodes, v);
};
$373ad590b7c1733e$var$Graph.prototype.removeNode = function(v) {
    var self = this;
    if ($dOCPl.has(this._nodes, v)) {
        var removeEdge = function(e) {
            self.removeEdge(self._edgeObjs[e]);
        };
        delete this._nodes[v];
        if (this._isCompound) {
            this._removeFromParentsChildList(v);
            delete this._parent[v];
            $dOCPl.each(this.children(v), function(child) {
                self.setParent(child);
            });
            delete this._children[v];
        }
        $dOCPl.each($dOCPl.keys(this._in[v]), removeEdge);
        delete this._in[v];
        delete this._preds[v];
        $dOCPl.each($dOCPl.keys(this._out[v]), removeEdge);
        delete this._out[v];
        delete this._sucs[v];
        --this._nodeCount;
    }
    return this;
};
$373ad590b7c1733e$var$Graph.prototype.setParent = function(v, parent) {
    if (!this._isCompound) throw new Error("Cannot set parent in a non-compound graph");
    if ($dOCPl.isUndefined(parent)) parent = $373ad590b7c1733e$var$GRAPH_NODE;
    else {
        // Coerce parent to string
        parent += "";
        for(var ancestor = parent; !$dOCPl.isUndefined(ancestor); ancestor = this.parent(ancestor)){
            if (ancestor === v) throw new Error("Setting " + parent + " as parent of " + v + " would create a cycle");
        }
        this.setNode(parent);
    }
    this.setNode(v);
    this._removeFromParentsChildList(v);
    this._parent[v] = parent;
    this._children[parent][v] = true;
    return this;
};
$373ad590b7c1733e$var$Graph.prototype._removeFromParentsChildList = function(v) {
    delete this._children[this._parent[v]][v];
};
$373ad590b7c1733e$var$Graph.prototype.parent = function(v) {
    if (this._isCompound) {
        var parent = this._parent[v];
        if (parent !== $373ad590b7c1733e$var$GRAPH_NODE) return parent;
    }
};
$373ad590b7c1733e$var$Graph.prototype.children = function(v) {
    if ($dOCPl.isUndefined(v)) v = $373ad590b7c1733e$var$GRAPH_NODE;
    if (this._isCompound) {
        var children = this._children[v];
        if (children) return $dOCPl.keys(children);
    } else if (v === $373ad590b7c1733e$var$GRAPH_NODE) return this.nodes();
    else if (this.hasNode(v)) return [];
};
$373ad590b7c1733e$var$Graph.prototype.predecessors = function(v) {
    var predsV = this._preds[v];
    if (predsV) return $dOCPl.keys(predsV);
};
$373ad590b7c1733e$var$Graph.prototype.successors = function(v) {
    var sucsV = this._sucs[v];
    if (sucsV) return $dOCPl.keys(sucsV);
};
$373ad590b7c1733e$var$Graph.prototype.neighbors = function(v) {
    var preds = this.predecessors(v);
    if (preds) return $dOCPl.union(preds, this.successors(v));
};
$373ad590b7c1733e$var$Graph.prototype.isLeaf = function(v) {
    var neighbors;
    if (this.isDirected()) neighbors = this.successors(v);
    else neighbors = this.neighbors(v);
    return neighbors.length === 0;
};
$373ad590b7c1733e$var$Graph.prototype.filterNodes = function(filter) {
    var copy = new this.constructor({
        directed: this._isDirected,
        multigraph: this._isMultigraph,
        compound: this._isCompound
    });
    copy.setGraph(this.graph());
    var self = this;
    $dOCPl.each(this._nodes, function(value, v) {
        if (filter(v)) copy.setNode(v, value);
    });
    $dOCPl.each(this._edgeObjs, function(e) {
        if (copy.hasNode(e.v) && copy.hasNode(e.w)) copy.setEdge(e, self.edge(e));
    });
    var parents = {};
    function findParent(v) {
        var parent = self.parent(v);
        if (parent === undefined || copy.hasNode(parent)) {
            parents[v] = parent;
            return parent;
        } else if (parent in parents) return parents[parent];
        else return findParent(parent);
    }
    if (this._isCompound) $dOCPl.each(copy.nodes(), function(v) {
        copy.setParent(v, findParent(v));
    });
    return copy;
};
/* === Edge functions ========== */ $373ad590b7c1733e$var$Graph.prototype.setDefaultEdgeLabel = function(newDefault) {
    if (!$dOCPl.isFunction(newDefault)) newDefault = $dOCPl.constant(newDefault);
    this._defaultEdgeLabelFn = newDefault;
    return this;
};
$373ad590b7c1733e$var$Graph.prototype.edgeCount = function() {
    return this._edgeCount;
};
$373ad590b7c1733e$var$Graph.prototype.edges = function() {
    return $dOCPl.values(this._edgeObjs);
};
$373ad590b7c1733e$var$Graph.prototype.setPath = function(vs, value) {
    var self = this;
    var args = arguments;
    $dOCPl.reduce(vs, function(v, w) {
        if (args.length > 1) self.setEdge(v, w, value);
        else self.setEdge(v, w);
        return w;
    });
    return this;
};
/*
 * setEdge(v, w, [value, [name]])
 * setEdge({ v, w, [name] }, [value])
 */ $373ad590b7c1733e$var$Graph.prototype.setEdge = function() {
    var v, w, name, value;
    var valueSpecified = false;
    var arg0 = arguments[0];
    if (typeof arg0 === "object" && arg0 !== null && "v" in arg0) {
        v = arg0.v;
        w = arg0.w;
        name = arg0.name;
        if (arguments.length === 2) {
            value = arguments[1];
            valueSpecified = true;
        }
    } else {
        v = arg0;
        w = arguments[1];
        name = arguments[3];
        if (arguments.length > 2) {
            value = arguments[2];
            valueSpecified = true;
        }
    }
    v = "" + v;
    w = "" + w;
    if (!$dOCPl.isUndefined(name)) name = "" + name;
    var e = $373ad590b7c1733e$var$edgeArgsToId(this._isDirected, v, w, name);
    if ($dOCPl.has(this._edgeLabels, e)) {
        if (valueSpecified) this._edgeLabels[e] = value;
        return this;
    }
    if (!$dOCPl.isUndefined(name) && !this._isMultigraph) throw new Error("Cannot set a named edge when isMultigraph = false");
    // It didn't exist, so we need to create it.
    // First ensure the nodes exist.
    this.setNode(v);
    this.setNode(w);
    this._edgeLabels[e] = valueSpecified ? value : this._defaultEdgeLabelFn(v, w, name);
    var edgeObj = $373ad590b7c1733e$var$edgeArgsToObj(this._isDirected, v, w, name);
    // Ensure we add undirected edges in a consistent way.
    v = edgeObj.v;
    w = edgeObj.w;
    Object.freeze(edgeObj);
    this._edgeObjs[e] = edgeObj;
    $373ad590b7c1733e$var$incrementOrInitEntry(this._preds[w], v);
    $373ad590b7c1733e$var$incrementOrInitEntry(this._sucs[v], w);
    this._in[w][e] = edgeObj;
    this._out[v][e] = edgeObj;
    this._edgeCount++;
    return this;
};
$373ad590b7c1733e$var$Graph.prototype.edge = function(v, w, name) {
    var e = arguments.length === 1 ? $373ad590b7c1733e$var$edgeObjToId(this._isDirected, arguments[0]) : $373ad590b7c1733e$var$edgeArgsToId(this._isDirected, v, w, name);
    return this._edgeLabels[e];
};
$373ad590b7c1733e$var$Graph.prototype.hasEdge = function(v, w, name) {
    var e = arguments.length === 1 ? $373ad590b7c1733e$var$edgeObjToId(this._isDirected, arguments[0]) : $373ad590b7c1733e$var$edgeArgsToId(this._isDirected, v, w, name);
    return $dOCPl.has(this._edgeLabels, e);
};
$373ad590b7c1733e$var$Graph.prototype.removeEdge = function(v, w, name) {
    var e = arguments.length === 1 ? $373ad590b7c1733e$var$edgeObjToId(this._isDirected, arguments[0]) : $373ad590b7c1733e$var$edgeArgsToId(this._isDirected, v, w, name);
    var edge = this._edgeObjs[e];
    if (edge) {
        v = edge.v;
        w = edge.w;
        delete this._edgeLabels[e];
        delete this._edgeObjs[e];
        $373ad590b7c1733e$var$decrementOrRemoveEntry(this._preds[w], v);
        $373ad590b7c1733e$var$decrementOrRemoveEntry(this._sucs[v], w);
        delete this._in[w][e];
        delete this._out[v][e];
        this._edgeCount--;
    }
    return this;
};
$373ad590b7c1733e$var$Graph.prototype.inEdges = function(v, u) {
    var inV = this._in[v];
    if (inV) {
        var edges = $dOCPl.values(inV);
        if (!u) return edges;
        return $dOCPl.filter(edges, function(edge) {
            return edge.v === u;
        });
    }
};
$373ad590b7c1733e$var$Graph.prototype.outEdges = function(v, w) {
    var outV = this._out[v];
    if (outV) {
        var edges = $dOCPl.values(outV);
        if (!w) return edges;
        return $dOCPl.filter(edges, function(edge) {
            return edge.w === w;
        });
    }
};
$373ad590b7c1733e$var$Graph.prototype.nodeEdges = function(v, w) {
    var inEdges = this.inEdges(v, w);
    if (inEdges) return inEdges.concat(this.outEdges(v, w));
};
function $373ad590b7c1733e$var$incrementOrInitEntry(map, k) {
    if (map[k]) map[k]++;
    else map[k] = 1;
}
function $373ad590b7c1733e$var$decrementOrRemoveEntry(map, k) {
    if (!--map[k]) delete map[k];
}
function $373ad590b7c1733e$var$edgeArgsToId(isDirected, v_, w_, name) {
    var v = "" + v_;
    var w = "" + w_;
    if (!isDirected && v > w) {
        var tmp = v;
        v = w;
        w = tmp;
    }
    return v + $373ad590b7c1733e$var$EDGE_KEY_DELIM + w + $373ad590b7c1733e$var$EDGE_KEY_DELIM + ($dOCPl.isUndefined(name) ? $373ad590b7c1733e$var$DEFAULT_EDGE_NAME : name);
}
function $373ad590b7c1733e$var$edgeArgsToObj(isDirected, v_, w_, name) {
    var v = "" + v_;
    var w = "" + w_;
    if (!isDirected && v > w) {
        var tmp = v;
        v = w;
        w = tmp;
    }
    var edgeObj = {
        v: v,
        w: w
    };
    if (name) edgeObj.name = name;
    return edgeObj;
}
function $373ad590b7c1733e$var$edgeObjToId(isDirected, edgeObj) {
    return $373ad590b7c1733e$var$edgeArgsToId(isDirected, edgeObj.v, edgeObj.w, edgeObj.name);
}

});
parcelRegister("dOCPl", function(module, exports) {
/* global window */ var $a0ee10204aed0d3b$var$lodash;
















try {
    $a0ee10204aed0d3b$var$lodash = {
        clone: (parcelRequire("bTYY2")),
        constant: (parcelRequire("9HRmE")),
        each: (parcelRequire("5kE3T")),
        filter: (parcelRequire("jLJR7")),
        has: (parcelRequire("jplJt")),
        isArray: (parcelRequire("o8HxT")),
        isEmpty: (parcelRequire("44Pmt")),
        isFunction: (parcelRequire("01ubZ")),
        isUndefined: (parcelRequire("enrJD")),
        keys: (parcelRequire("LAMcS")),
        map: (parcelRequire("437iZ")),
        reduce: (parcelRequire("2KuAh")),
        size: (parcelRequire("2RKXE")),
        transform: (parcelRequire("bGcIb")),
        union: (parcelRequire("1c10x")),
        values: (parcelRequire("7D6Gq"))
    };
} catch (e) {
// continue regardless of error
}
if (!$a0ee10204aed0d3b$var$lodash) $a0ee10204aed0d3b$var$lodash = window._;
module.exports = $a0ee10204aed0d3b$var$lodash;

});
parcelRegister("bTYY2", function(module, exports) {

var $kqX4j = parcelRequire("kqX4j");
/** Used to compose bitmasks for cloning. */ var $8aa41f9fe04bb5cc$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $8aa41f9fe04bb5cc$var$clone(value) {
    return $kqX4j(value, $8aa41f9fe04bb5cc$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $8aa41f9fe04bb5cc$var$clone;

});
parcelRegister("kqX4j", function(module, exports) {

var $g779E = parcelRequire("g779E");

var $bFZGr = parcelRequire("bFZGr");

var $5i71d = parcelRequire("5i71d");

var $XXQDs = parcelRequire("XXQDs");

var $1djPb = parcelRequire("1djPb");

var $uQ1Em = parcelRequire("uQ1Em");

var $aA0pv = parcelRequire("aA0pv");

var $hIxJe = parcelRequire("hIxJe");

var $7n7lE = parcelRequire("7n7lE");

var $apVCl = parcelRequire("apVCl");

var $i0kKc = parcelRequire("i0kKc");

var $67A6V = parcelRequire("67A6V");

var $4UmGC = parcelRequire("4UmGC");

var $btuqH = parcelRequire("btuqH");

var $dFJsF = parcelRequire("dFJsF");

var $o8HxT = parcelRequire("o8HxT");

var $f504n = parcelRequire("f504n");

var $eJObK = parcelRequire("eJObK");

var $lsJ54 = parcelRequire("lsJ54");

var $jZm8C = parcelRequire("jZm8C");

var $LAMcS = parcelRequire("LAMcS");

var $f4lqP = parcelRequire("f4lqP");
/** Used to compose bitmasks for cloning. */ var $ee040e257a097984$var$CLONE_DEEP_FLAG = 1, $ee040e257a097984$var$CLONE_FLAT_FLAG = 2, $ee040e257a097984$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $ee040e257a097984$var$argsTag = '[object Arguments]', $ee040e257a097984$var$arrayTag = '[object Array]', $ee040e257a097984$var$boolTag = '[object Boolean]', $ee040e257a097984$var$dateTag = '[object Date]', $ee040e257a097984$var$errorTag = '[object Error]', $ee040e257a097984$var$funcTag = '[object Function]', $ee040e257a097984$var$genTag = '[object GeneratorFunction]', $ee040e257a097984$var$mapTag = '[object Map]', $ee040e257a097984$var$numberTag = '[object Number]', $ee040e257a097984$var$objectTag = '[object Object]', $ee040e257a097984$var$regexpTag = '[object RegExp]', $ee040e257a097984$var$setTag = '[object Set]', $ee040e257a097984$var$stringTag = '[object String]', $ee040e257a097984$var$symbolTag = '[object Symbol]', $ee040e257a097984$var$weakMapTag = '[object WeakMap]';
var $ee040e257a097984$var$arrayBufferTag = '[object ArrayBuffer]', $ee040e257a097984$var$dataViewTag = '[object DataView]', $ee040e257a097984$var$float32Tag = '[object Float32Array]', $ee040e257a097984$var$float64Tag = '[object Float64Array]', $ee040e257a097984$var$int8Tag = '[object Int8Array]', $ee040e257a097984$var$int16Tag = '[object Int16Array]', $ee040e257a097984$var$int32Tag = '[object Int32Array]', $ee040e257a097984$var$uint8Tag = '[object Uint8Array]', $ee040e257a097984$var$uint8ClampedTag = '[object Uint8ClampedArray]', $ee040e257a097984$var$uint16Tag = '[object Uint16Array]', $ee040e257a097984$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $ee040e257a097984$var$cloneableTags = {};
$ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$argsTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$arrayTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$arrayBufferTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$dataViewTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$boolTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$dateTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$float32Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$float64Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$int8Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$int16Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$int32Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$mapTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$numberTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$objectTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$regexpTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$setTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$stringTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$symbolTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$uint8Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$uint8ClampedTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$uint16Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$uint32Tag] = true;
$ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$errorTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$funcTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $ee040e257a097984$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $ee040e257a097984$var$CLONE_DEEP_FLAG, isFlat = bitmask & $ee040e257a097984$var$CLONE_FLAT_FLAG, isFull = bitmask & $ee040e257a097984$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$lsJ54(value)) return value;
    var isArr = $o8HxT(value);
    if (isArr) {
        result = $4UmGC(value);
        if (!isDeep) return $aA0pv(value, result);
    } else {
        var tag = $67A6V(value), isFunc = tag == $ee040e257a097984$var$funcTag || tag == $ee040e257a097984$var$genTag;
        if ($f504n(value)) return $uQ1Em(value, isDeep);
        if (tag == $ee040e257a097984$var$objectTag || tag == $ee040e257a097984$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $dFJsF(value);
            if (!isDeep) return isFlat ? $7n7lE(value, $1djPb(result, value)) : $hIxJe(value, $XXQDs(result, value));
        } else {
            if (!$ee040e257a097984$var$cloneableTags[tag]) return object ? value : {};
            result = $btuqH(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $g779E);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($jZm8C(value)) value.forEach(function(subValue) {
        result.add($ee040e257a097984$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($eJObK(value)) value.forEach(function(subValue, key) {
        result.set(key, $ee040e257a097984$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $i0kKc : $apVCl : isFlat ? $f4lqP : $LAMcS;
    var props = isArr ? undefined : keysFunc(value);
    $bFZGr(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $5i71d(result, key, $ee040e257a097984$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = $ee040e257a097984$var$baseClone;

});
parcelRegister("g779E", function(module, exports) {

var $iYOpJ = parcelRequire("iYOpJ");

var $jZSEZ = parcelRequire("jZSEZ");

var $fm6cW = parcelRequire("fm6cW");

var $b3G1Z = parcelRequire("b3G1Z");

var $5DEbp = parcelRequire("5DEbp");

var $czPDU = parcelRequire("czPDU");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $bbb2d98cae25b61a$var$Stack(entries) {
    var data = this.__data__ = new $iYOpJ(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$bbb2d98cae25b61a$var$Stack.prototype.clear = $jZSEZ;
$bbb2d98cae25b61a$var$Stack.prototype['delete'] = $fm6cW;
$bbb2d98cae25b61a$var$Stack.prototype.get = $b3G1Z;
$bbb2d98cae25b61a$var$Stack.prototype.has = $5DEbp;
$bbb2d98cae25b61a$var$Stack.prototype.set = $czPDU;
module.exports = $bbb2d98cae25b61a$var$Stack;

});
parcelRegister("iYOpJ", function(module, exports) {

var $bjX1n = parcelRequire("bjX1n");

var $i2OST = parcelRequire("i2OST");

var $fmh4d = parcelRequire("fmh4d");

var $3AXiV = parcelRequire("3AXiV");

var $lWpQQ = parcelRequire("lWpQQ");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $dd14efc87ba1cd5b$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$dd14efc87ba1cd5b$var$ListCache.prototype.clear = $bjX1n;
$dd14efc87ba1cd5b$var$ListCache.prototype['delete'] = $i2OST;
$dd14efc87ba1cd5b$var$ListCache.prototype.get = $fmh4d;
$dd14efc87ba1cd5b$var$ListCache.prototype.has = $3AXiV;
$dd14efc87ba1cd5b$var$ListCache.prototype.set = $lWpQQ;
module.exports = $dd14efc87ba1cd5b$var$ListCache;

});
parcelRegister("bjX1n", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $83df40714bf7006e$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $83df40714bf7006e$var$listCacheClear;

});

parcelRegister("i2OST", function(module, exports) {

var $bBnDb = parcelRequire("bBnDb");
/** Used for built-in method references. */ var $d22fe27824ff9351$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $d22fe27824ff9351$var$splice = $d22fe27824ff9351$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d22fe27824ff9351$var$listCacheDelete(key) {
    var data = this.__data__, index = $bBnDb(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $d22fe27824ff9351$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $d22fe27824ff9351$var$listCacheDelete;

});
parcelRegister("bBnDb", function(module, exports) {

var $6TC8i = parcelRequire("6TC8i");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $87257b05f5d9ad81$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($6TC8i(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $87257b05f5d9ad81$var$assocIndexOf;

});
parcelRegister("6TC8i", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $50557587dab070a0$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $50557587dab070a0$var$eq;

});



parcelRegister("fmh4d", function(module, exports) {

var $bBnDb = parcelRequire("bBnDb");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b2e6263d81cdc1b3$var$listCacheGet(key) {
    var data = this.__data__, index = $bBnDb(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $b2e6263d81cdc1b3$var$listCacheGet;

});

parcelRegister("3AXiV", function(module, exports) {

var $bBnDb = parcelRequire("bBnDb");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $29e2bc7b7348833e$var$listCacheHas(key) {
    return $bBnDb(this.__data__, key) > -1;
}
module.exports = $29e2bc7b7348833e$var$listCacheHas;

});

parcelRegister("lWpQQ", function(module, exports) {

var $bBnDb = parcelRequire("bBnDb");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $ff9311500b60ab72$var$listCacheSet(key, value) {
    var data = this.__data__, index = $bBnDb(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $ff9311500b60ab72$var$listCacheSet;

});


parcelRegister("jZSEZ", function(module, exports) {

var $iYOpJ = parcelRequire("iYOpJ");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $e8ee1d354807980a$var$stackClear() {
    this.__data__ = new $iYOpJ;
    this.size = 0;
}
module.exports = $e8ee1d354807980a$var$stackClear;

});

parcelRegister("fm6cW", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b2ddb9d63293f3a5$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
module.exports = $b2ddb9d63293f3a5$var$stackDelete;

});

parcelRegister("b3G1Z", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $80d0940a423a17dc$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $80d0940a423a17dc$var$stackGet;

});

parcelRegister("5DEbp", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $010f38d5d914cfa2$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $010f38d5d914cfa2$var$stackHas;

});

parcelRegister("czPDU", function(module, exports) {

var $iYOpJ = parcelRequire("iYOpJ");

var $2cJKd = parcelRequire("2cJKd");

var $6gDBQ = parcelRequire("6gDBQ");
/** Used as the size to enable large array optimizations. */ var $9280d00f89f25fa9$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $9280d00f89f25fa9$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $iYOpJ) {
        var pairs = data.__data__;
        if (!$2cJKd || pairs.length < $9280d00f89f25fa9$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $6gDBQ(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $9280d00f89f25fa9$var$stackSet;

});
parcelRegister("2cJKd", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $19b02faa57603249$var$Map = $6T08O($23YZo, 'Map');
module.exports = $19b02faa57603249$var$Map;

});
parcelRegister("6T08O", function(module, exports) {

var $bhj99 = parcelRequire("bhj99");

var $ii1B1 = parcelRequire("ii1B1");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $5037fd2e597c2a03$var$getNative(object, key) {
    var value = $ii1B1(object, key);
    return $bhj99(value) ? value : undefined;
}
module.exports = $5037fd2e597c2a03$var$getNative;

});
parcelRegister("bhj99", function(module, exports) {

var $01ubZ = parcelRequire("01ubZ");

var $87ifd = parcelRequire("87ifd");

var $lsJ54 = parcelRequire("lsJ54");

var $dqC5h = parcelRequire("dqC5h");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $8360225fb63098b3$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $8360225fb63098b3$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $8360225fb63098b3$var$funcProto = Function.prototype, $8360225fb63098b3$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $8360225fb63098b3$var$funcToString = $8360225fb63098b3$var$funcProto.toString;
/** Used to check objects for own properties. */ var $8360225fb63098b3$var$hasOwnProperty = $8360225fb63098b3$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $8360225fb63098b3$var$reIsNative = RegExp('^' + $8360225fb63098b3$var$funcToString.call($8360225fb63098b3$var$hasOwnProperty).replace($8360225fb63098b3$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $8360225fb63098b3$var$baseIsNative(value) {
    if (!$lsJ54(value) || $87ifd(value)) return false;
    var pattern = $01ubZ(value) ? $8360225fb63098b3$var$reIsNative : $8360225fb63098b3$var$reIsHostCtor;
    return pattern.test($dqC5h(value));
}
module.exports = $8360225fb63098b3$var$baseIsNative;

});
parcelRegister("01ubZ", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $lsJ54 = parcelRequire("lsJ54");
/** `Object#toString` result references. */ var $004783abbde551e4$var$asyncTag = '[object AsyncFunction]', $004783abbde551e4$var$funcTag = '[object Function]', $004783abbde551e4$var$genTag = '[object GeneratorFunction]', $004783abbde551e4$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $004783abbde551e4$var$isFunction(value) {
    if (!$lsJ54(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $eq6CV(value);
    return tag == $004783abbde551e4$var$funcTag || tag == $004783abbde551e4$var$genTag || tag == $004783abbde551e4$var$asyncTag || tag == $004783abbde551e4$var$proxyTag;
}
module.exports = $004783abbde551e4$var$isFunction;

});
parcelRegister("eq6CV", function(module, exports) {

var $57wYk = parcelRequire("57wYk");

var $iMn5C = parcelRequire("iMn5C");

var $5tDQy = parcelRequire("5tDQy");
/** `Object#toString` result references. */ var $a7f8a2555793d7d3$var$nullTag = '[object Null]', $a7f8a2555793d7d3$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $a7f8a2555793d7d3$var$symToStringTag = $57wYk ? $57wYk.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $a7f8a2555793d7d3$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $a7f8a2555793d7d3$var$undefinedTag : $a7f8a2555793d7d3$var$nullTag;
    return $a7f8a2555793d7d3$var$symToStringTag && $a7f8a2555793d7d3$var$symToStringTag in Object(value) ? $iMn5C(value) : $5tDQy(value);
}
module.exports = $a7f8a2555793d7d3$var$baseGetTag;

});
parcelRegister("57wYk", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/** Built-in value references. */ var $3ba72ebe7e4419b5$var$Symbol = $23YZo.Symbol;
module.exports = $3ba72ebe7e4419b5$var$Symbol;

});
parcelRegister("23YZo", function(module, exports) {

var $ljJ8G = parcelRequire("ljJ8G");
/** Detect free variable `self`. */ var $180b2bc3c0deaf6c$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $180b2bc3c0deaf6c$var$root = $ljJ8G || $180b2bc3c0deaf6c$var$freeSelf || Function('return this')();
module.exports = $180b2bc3c0deaf6c$var$root;

});
parcelRegister("ljJ8G", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $f84e62f9db5b9ccd$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $f84e62f9db5b9ccd$var$freeGlobal;

});



parcelRegister("iMn5C", function(module, exports) {

var $57wYk = parcelRequire("57wYk");
/** Used for built-in method references. */ var $dabe9ecbecc6d0b5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dabe9ecbecc6d0b5$var$hasOwnProperty = $dabe9ecbecc6d0b5$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $dabe9ecbecc6d0b5$var$nativeObjectToString = $dabe9ecbecc6d0b5$var$objectProto.toString;
/** Built-in value references. */ var $dabe9ecbecc6d0b5$var$symToStringTag = $57wYk ? $57wYk.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $dabe9ecbecc6d0b5$var$getRawTag(value) {
    var isOwn = $dabe9ecbecc6d0b5$var$hasOwnProperty.call(value, $dabe9ecbecc6d0b5$var$symToStringTag), tag = value[$dabe9ecbecc6d0b5$var$symToStringTag];
    try {
        value[$dabe9ecbecc6d0b5$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $dabe9ecbecc6d0b5$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$dabe9ecbecc6d0b5$var$symToStringTag] = tag;
        else delete value[$dabe9ecbecc6d0b5$var$symToStringTag];
    }
    return result;
}
module.exports = $dabe9ecbecc6d0b5$var$getRawTag;

});

parcelRegister("5tDQy", function(module, exports) {
/** Used for built-in method references. */ var $3fce91ec3914aaed$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3fce91ec3914aaed$var$nativeObjectToString = $3fce91ec3914aaed$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $3fce91ec3914aaed$var$objectToString(value) {
    return $3fce91ec3914aaed$var$nativeObjectToString.call(value);
}
module.exports = $3fce91ec3914aaed$var$objectToString;

});


parcelRegister("lsJ54", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $f9ff2e983beb6b86$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = $f9ff2e983beb6b86$var$isObject;

});


parcelRegister("87ifd", function(module, exports) {

var $g3dHA = parcelRequire("g3dHA");
/** Used to detect methods masquerading as native. */ var $5e8d211f630cd46d$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($g3dHA && $g3dHA.keys && $g3dHA.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $5e8d211f630cd46d$var$isMasked(func) {
    return !!$5e8d211f630cd46d$var$maskSrcKey && $5e8d211f630cd46d$var$maskSrcKey in func;
}
module.exports = $5e8d211f630cd46d$var$isMasked;

});
parcelRegister("g3dHA", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/** Used to detect overreaching core-js shims. */ var $baf78e1246b3b18f$var$coreJsData = $23YZo["__core-js_shared__"];
module.exports = $baf78e1246b3b18f$var$coreJsData;

});


parcelRegister("dqC5h", function(module, exports) {
/** Used for built-in method references. */ var $9c6b3ec69362487e$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $9c6b3ec69362487e$var$funcToString = $9c6b3ec69362487e$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $9c6b3ec69362487e$var$toSource(func) {
    if (func != null) {
        try {
            return $9c6b3ec69362487e$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = $9c6b3ec69362487e$var$toSource;

});


parcelRegister("ii1B1", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $d50b255f8680c47a$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $d50b255f8680c47a$var$getValue;

});



parcelRegister("6gDBQ", function(module, exports) {

var $j9XgB = parcelRequire("j9XgB");

var $5Rqhl = parcelRequire("5Rqhl");

var $g0JTV = parcelRequire("g0JTV");

var $iaILb = parcelRequire("iaILb");

var $4vfJO = parcelRequire("4vfJO");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $4902f64a16640324$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$4902f64a16640324$var$MapCache.prototype.clear = $j9XgB;
$4902f64a16640324$var$MapCache.prototype['delete'] = $5Rqhl;
$4902f64a16640324$var$MapCache.prototype.get = $g0JTV;
$4902f64a16640324$var$MapCache.prototype.has = $iaILb;
$4902f64a16640324$var$MapCache.prototype.set = $4vfJO;
module.exports = $4902f64a16640324$var$MapCache;

});
parcelRegister("j9XgB", function(module, exports) {

var $c8dKl = parcelRequire("c8dKl");

var $iYOpJ = parcelRequire("iYOpJ");

var $2cJKd = parcelRequire("2cJKd");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $df2cd4bc93f21548$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $c8dKl,
        'map': new ($2cJKd || $iYOpJ),
        'string': new $c8dKl
    };
}
module.exports = $df2cd4bc93f21548$var$mapCacheClear;

});
parcelRegister("c8dKl", function(module, exports) {

var $b4nbb = parcelRequire("b4nbb");

var $8ink3 = parcelRequire("8ink3");

var $VQwbj = parcelRequire("VQwbj");

var $19QNA = parcelRequire("19QNA");

var $i8qJC = parcelRequire("i8qJC");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $8d50e526a9e9b7fa$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$8d50e526a9e9b7fa$var$Hash.prototype.clear = $b4nbb;
$8d50e526a9e9b7fa$var$Hash.prototype['delete'] = $8ink3;
$8d50e526a9e9b7fa$var$Hash.prototype.get = $VQwbj;
$8d50e526a9e9b7fa$var$Hash.prototype.has = $19QNA;
$8d50e526a9e9b7fa$var$Hash.prototype.set = $i8qJC;
module.exports = $8d50e526a9e9b7fa$var$Hash;

});
parcelRegister("b4nbb", function(module, exports) {

var $k1Z3J = parcelRequire("k1Z3J");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $80f20c637ba11563$var$hashClear() {
    this.__data__ = $k1Z3J ? $k1Z3J(null) : {};
    this.size = 0;
}
module.exports = $80f20c637ba11563$var$hashClear;

});
parcelRegister("k1Z3J", function(module, exports) {

var $6T08O = parcelRequire("6T08O");
/* Built-in method references that are verified to be native. */ var $e95343b7bf5d617b$var$nativeCreate = $6T08O(Object, 'create');
module.exports = $e95343b7bf5d617b$var$nativeCreate;

});


parcelRegister("8ink3", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $60a2188452e03a76$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $60a2188452e03a76$var$hashDelete;

});

parcelRegister("VQwbj", function(module, exports) {

var $k1Z3J = parcelRequire("k1Z3J");
/** Used to stand-in for `undefined` hash values. */ var $0ade0ffa62051a98$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $0ade0ffa62051a98$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0ade0ffa62051a98$var$hasOwnProperty = $0ade0ffa62051a98$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $0ade0ffa62051a98$var$hashGet(key) {
    var data = this.__data__;
    if ($k1Z3J) {
        var result = data[key];
        return result === $0ade0ffa62051a98$var$HASH_UNDEFINED ? undefined : result;
    }
    return $0ade0ffa62051a98$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $0ade0ffa62051a98$var$hashGet;

});

parcelRegister("19QNA", function(module, exports) {

var $k1Z3J = parcelRequire("k1Z3J");
/** Used for built-in method references. */ var $0d7f9677a17b6bef$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0d7f9677a17b6bef$var$hasOwnProperty = $0d7f9677a17b6bef$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $0d7f9677a17b6bef$var$hashHas(key) {
    var data = this.__data__;
    return $k1Z3J ? data[key] !== undefined : $0d7f9677a17b6bef$var$hasOwnProperty.call(data, key);
}
module.exports = $0d7f9677a17b6bef$var$hashHas;

});

parcelRegister("i8qJC", function(module, exports) {

var $k1Z3J = parcelRequire("k1Z3J");
/** Used to stand-in for `undefined` hash values. */ var $d33db65186b62952$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $d33db65186b62952$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $k1Z3J && value === undefined ? $d33db65186b62952$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $d33db65186b62952$var$hashSet;

});



parcelRegister("5Rqhl", function(module, exports) {

var $gxIuO = parcelRequire("gxIuO");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $44464964ade29765$var$mapCacheDelete(key) {
    var result = $gxIuO(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $44464964ade29765$var$mapCacheDelete;

});
parcelRegister("gxIuO", function(module, exports) {

var $PZpyR = parcelRequire("PZpyR");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $c0b23e5f03c2595b$var$getMapData(map, key) {
    var data = map.__data__;
    return $PZpyR(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = $c0b23e5f03c2595b$var$getMapData;

});
parcelRegister("PZpyR", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $09c4668903e66c1d$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = $09c4668903e66c1d$var$isKeyable;

});



parcelRegister("g0JTV", function(module, exports) {

var $gxIuO = parcelRequire("gxIuO");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $ba80406da5503086$var$mapCacheGet(key) {
    return $gxIuO(this, key).get(key);
}
module.exports = $ba80406da5503086$var$mapCacheGet;

});

parcelRegister("iaILb", function(module, exports) {

var $gxIuO = parcelRequire("gxIuO");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d3abe18ea687dfb7$var$mapCacheHas(key) {
    return $gxIuO(this, key).has(key);
}
module.exports = $d3abe18ea687dfb7$var$mapCacheHas;

});

parcelRegister("4vfJO", function(module, exports) {

var $gxIuO = parcelRequire("gxIuO");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $347643e3dcfcc207$var$mapCacheSet(key, value) {
    var data = $gxIuO(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $347643e3dcfcc207$var$mapCacheSet;

});




parcelRegister("bFZGr", function(module, exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $88035f224ff89479$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = $88035f224ff89479$var$arrayEach;

});

parcelRegister("5i71d", function(module, exports) {

var $cWbJD = parcelRequire("cWbJD");

var $6TC8i = parcelRequire("6TC8i");
/** Used for built-in method references. */ var $3da413f0b86c10df$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3da413f0b86c10df$var$hasOwnProperty = $3da413f0b86c10df$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $3da413f0b86c10df$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($3da413f0b86c10df$var$hasOwnProperty.call(object, key) && $6TC8i(objValue, value)) || value === undefined && !(key in object)) $cWbJD(object, key, value);
}
module.exports = $3da413f0b86c10df$var$assignValue;

});
parcelRegister("cWbJD", function(module, exports) {

var $4hwTc = parcelRequire("4hwTc");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $96b401257ea00d24$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $4hwTc) $4hwTc(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
module.exports = $96b401257ea00d24$var$baseAssignValue;

});
parcelRegister("4hwTc", function(module, exports) {

var $6T08O = parcelRequire("6T08O");
var $31e24313ace94404$var$defineProperty = function() {
    try {
        var func = $6T08O(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
module.exports = $31e24313ace94404$var$defineProperty;

});



parcelRegister("XXQDs", function(module, exports) {

var $cYlGN = parcelRequire("cYlGN");

var $LAMcS = parcelRequire("LAMcS");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $0b43ef5c64ba7f70$var$baseAssign(object, source) {
    return object && $cYlGN(source, $LAMcS(source), object);
}
module.exports = $0b43ef5c64ba7f70$var$baseAssign;

});
parcelRegister("cYlGN", function(module, exports) {

var $5i71d = parcelRequire("5i71d");

var $cWbJD = parcelRequire("cWbJD");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $971be9a5edcd8d07$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $cWbJD(object, key, newValue);
        else $5i71d(object, key, newValue);
    }
    return object;
}
module.exports = $971be9a5edcd8d07$var$copyObject;

});

parcelRegister("LAMcS", function(module, exports) {

var $8C60w = parcelRequire("8C60w");

var $jViFF = parcelRequire("jViFF");

var $eMthh = parcelRequire("eMthh");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $08f0eaf3fbcb2fde$var$keys(object) {
    return $eMthh(object) ? $8C60w(object) : $jViFF(object);
}
module.exports = $08f0eaf3fbcb2fde$var$keys;

});
parcelRegister("8C60w", function(module, exports) {

var $fdM6B = parcelRequire("fdM6B");

var $aJD6g = parcelRequire("aJD6g");

var $o8HxT = parcelRequire("o8HxT");

var $f504n = parcelRequire("f504n");

var $iyUuu = parcelRequire("iyUuu");

var $1Q21n = parcelRequire("1Q21n");
/** Used for built-in method references. */ var $64568844439edb7f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $64568844439edb7f$var$hasOwnProperty = $64568844439edb7f$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $64568844439edb7f$var$arrayLikeKeys(value, inherited) {
    var isArr = $o8HxT(value), isArg = !isArr && $aJD6g(value), isBuff = !isArr && !isArg && $f504n(value), isType = !isArr && !isArg && !isBuff && $1Q21n(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $fdM6B(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $64568844439edb7f$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $iyUuu(key, length)))) result.push(key);
    return result;
}
module.exports = $64568844439edb7f$var$arrayLikeKeys;

});
parcelRegister("fdM6B", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $b14d62a510ae7f2d$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $b14d62a510ae7f2d$var$baseTimes;

});

parcelRegister("aJD6g", function(module, exports) {

var $lB3aj = parcelRequire("lB3aj");

var $8l89S = parcelRequire("8l89S");
/** Used for built-in method references. */ var $7d0c6fd0eb26be0e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7d0c6fd0eb26be0e$var$hasOwnProperty = $7d0c6fd0eb26be0e$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $7d0c6fd0eb26be0e$var$propertyIsEnumerable = $7d0c6fd0eb26be0e$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $7d0c6fd0eb26be0e$var$isArguments = $lB3aj(function() {
    return arguments;
}()) ? $lB3aj : function(value) {
    return $8l89S(value) && $7d0c6fd0eb26be0e$var$hasOwnProperty.call(value, 'callee') && !$7d0c6fd0eb26be0e$var$propertyIsEnumerable.call(value, 'callee');
};
module.exports = $7d0c6fd0eb26be0e$var$isArguments;

});
parcelRegister("lB3aj", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $fb8f823cdc90f511$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $fb8f823cdc90f511$var$baseIsArguments(value) {
    return $8l89S(value) && $eq6CV(value) == $fb8f823cdc90f511$var$argsTag;
}
module.exports = $fb8f823cdc90f511$var$baseIsArguments;

});
parcelRegister("8l89S", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $61269cf1f3e020be$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $61269cf1f3e020be$var$isObjectLike;

});



parcelRegister("o8HxT", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $0488fde9aa355453$var$isArray = Array.isArray;
module.exports = $0488fde9aa355453$var$isArray;

});

parcelRegister("f504n", function(module, exports) {

var $23YZo = parcelRequire("23YZo");

var $fiQnm = parcelRequire("fiQnm");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $23YZo.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $fiQnm;
module.exports = isBuffer;

});
parcelRegister("fiQnm", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $b2412a30bba480f5$var$stubFalse() {
    return false;
}
module.exports = $b2412a30bba480f5$var$stubFalse;

});


parcelRegister("iyUuu", function(module, exports) {
/** Used as references for various `Number` constants. */ var $d83738e053b5eb08$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $d83738e053b5eb08$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $d83738e053b5eb08$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $d83738e053b5eb08$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $d83738e053b5eb08$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $d83738e053b5eb08$var$isIndex;

});

parcelRegister("1Q21n", function(module, exports) {

var $dtRoq = parcelRequire("dtRoq");

var $91Qdd = parcelRequire("91Qdd");

var $jIny1 = parcelRequire("jIny1");
/* Node.js helper references. */ var $156c3727697ab085$var$nodeIsTypedArray = $jIny1 && $jIny1.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $156c3727697ab085$var$isTypedArray = $156c3727697ab085$var$nodeIsTypedArray ? $91Qdd($156c3727697ab085$var$nodeIsTypedArray) : $dtRoq;
module.exports = $156c3727697ab085$var$isTypedArray;

});
parcelRegister("dtRoq", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $1S9lz = parcelRequire("1S9lz");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $9d076681a0e29d68$var$argsTag = '[object Arguments]', $9d076681a0e29d68$var$arrayTag = '[object Array]', $9d076681a0e29d68$var$boolTag = '[object Boolean]', $9d076681a0e29d68$var$dateTag = '[object Date]', $9d076681a0e29d68$var$errorTag = '[object Error]', $9d076681a0e29d68$var$funcTag = '[object Function]', $9d076681a0e29d68$var$mapTag = '[object Map]', $9d076681a0e29d68$var$numberTag = '[object Number]', $9d076681a0e29d68$var$objectTag = '[object Object]', $9d076681a0e29d68$var$regexpTag = '[object RegExp]', $9d076681a0e29d68$var$setTag = '[object Set]', $9d076681a0e29d68$var$stringTag = '[object String]', $9d076681a0e29d68$var$weakMapTag = '[object WeakMap]';
var $9d076681a0e29d68$var$arrayBufferTag = '[object ArrayBuffer]', $9d076681a0e29d68$var$dataViewTag = '[object DataView]', $9d076681a0e29d68$var$float32Tag = '[object Float32Array]', $9d076681a0e29d68$var$float64Tag = '[object Float64Array]', $9d076681a0e29d68$var$int8Tag = '[object Int8Array]', $9d076681a0e29d68$var$int16Tag = '[object Int16Array]', $9d076681a0e29d68$var$int32Tag = '[object Int32Array]', $9d076681a0e29d68$var$uint8Tag = '[object Uint8Array]', $9d076681a0e29d68$var$uint8ClampedTag = '[object Uint8ClampedArray]', $9d076681a0e29d68$var$uint16Tag = '[object Uint16Array]', $9d076681a0e29d68$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $9d076681a0e29d68$var$typedArrayTags = {};
$9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$float32Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$float64Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int8Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int16Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int32Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint8Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint8ClampedTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint16Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint32Tag] = true;
$9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$argsTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$arrayTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$arrayBufferTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$boolTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$dataViewTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$dateTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$errorTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$funcTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$mapTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$numberTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$objectTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$regexpTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$setTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$stringTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $9d076681a0e29d68$var$baseIsTypedArray(value) {
    return $8l89S(value) && $1S9lz(value.length) && !!$9d076681a0e29d68$var$typedArrayTags[$eq6CV(value)];
}
module.exports = $9d076681a0e29d68$var$baseIsTypedArray;

});
parcelRegister("1S9lz", function(module, exports) {
/** Used as references for various `Number` constants. */ var $15d215b19bcf1187$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $15d215b19bcf1187$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $15d215b19bcf1187$var$MAX_SAFE_INTEGER;
}
module.exports = $15d215b19bcf1187$var$isLength;

});


parcelRegister("91Qdd", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $692cb5474f422969$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $692cb5474f422969$var$baseUnary;

});

parcelRegister("jIny1", function(module, exports) {

var $ljJ8G = parcelRequire("ljJ8G");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $ljJ8G.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});



parcelRegister("jViFF", function(module, exports) {

var $3wZFp = parcelRequire("3wZFp");

var $Xlg65 = parcelRequire("Xlg65");
/** Used for built-in method references. */ var $e811d2e210fb58cc$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e811d2e210fb58cc$var$hasOwnProperty = $e811d2e210fb58cc$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $e811d2e210fb58cc$var$baseKeys(object) {
    if (!$3wZFp(object)) return $Xlg65(object);
    var result = [];
    for(var key in Object(object))if ($e811d2e210fb58cc$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
module.exports = $e811d2e210fb58cc$var$baseKeys;

});
parcelRegister("3wZFp", function(module, exports) {
/** Used for built-in method references. */ var $292432068be14a79$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $292432068be14a79$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $292432068be14a79$var$objectProto;
    return value === proto;
}
module.exports = $292432068be14a79$var$isPrototype;

});

parcelRegister("Xlg65", function(module, exports) {

var $lW2Sc = parcelRequire("lW2Sc");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $0b26005314403d97$var$nativeKeys = $lW2Sc(Object.keys, Object);
module.exports = $0b26005314403d97$var$nativeKeys;

});
parcelRegister("lW2Sc", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $ff813e49bf3cca3d$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $ff813e49bf3cca3d$var$overArg;

});



parcelRegister("eMthh", function(module, exports) {

var $01ubZ = parcelRequire("01ubZ");

var $1S9lz = parcelRequire("1S9lz");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $ac2c42592aa05543$var$isArrayLike(value) {
    return value != null && $1S9lz(value.length) && !$01ubZ(value);
}
module.exports = $ac2c42592aa05543$var$isArrayLike;

});



parcelRegister("1djPb", function(module, exports) {

var $cYlGN = parcelRequire("cYlGN");

var $f4lqP = parcelRequire("f4lqP");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $0e266213253a5976$var$baseAssignIn(object, source) {
    return object && $cYlGN(source, $f4lqP(source), object);
}
module.exports = $0e266213253a5976$var$baseAssignIn;

});
parcelRegister("f4lqP", function(module, exports) {

var $8C60w = parcelRequire("8C60w");

var $4ECPT = parcelRequire("4ECPT");

var $eMthh = parcelRequire("eMthh");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $af87da9a76941740$var$keysIn(object) {
    return $eMthh(object) ? $8C60w(object, true) : $4ECPT(object);
}
module.exports = $af87da9a76941740$var$keysIn;

});
parcelRegister("4ECPT", function(module, exports) {

var $lsJ54 = parcelRequire("lsJ54");

var $3wZFp = parcelRequire("3wZFp");

var $7w1ie = parcelRequire("7w1ie");
/** Used for built-in method references. */ var $363905e043db7569$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $363905e043db7569$var$hasOwnProperty = $363905e043db7569$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $363905e043db7569$var$baseKeysIn(object) {
    if (!$lsJ54(object)) return $7w1ie(object);
    var isProto = $3wZFp(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$363905e043db7569$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = $363905e043db7569$var$baseKeysIn;

});
parcelRegister("7w1ie", function(module, exports) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $578c86548a505f7a$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = $578c86548a505f7a$var$nativeKeysIn;

});




parcelRegister("uQ1Em", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $23YZo.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("aA0pv", function(module, exports) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $7b3d95b0cd9dcb32$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
module.exports = $7b3d95b0cd9dcb32$var$copyArray;

});

parcelRegister("hIxJe", function(module, exports) {

var $cYlGN = parcelRequire("cYlGN");

var $6YcYN = parcelRequire("6YcYN");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $ce60b583e6a24a63$var$copySymbols(source, object) {
    return $cYlGN(source, $6YcYN(source), object);
}
module.exports = $ce60b583e6a24a63$var$copySymbols;

});
parcelRegister("6YcYN", function(module, exports) {

var $8H9RZ = parcelRequire("8H9RZ");

var $clnSu = parcelRequire("clnSu");
/** Used for built-in method references. */ var $51326a29f571e7cd$var$objectProto = Object.prototype;
/** Built-in value references. */ var $51326a29f571e7cd$var$propertyIsEnumerable = $51326a29f571e7cd$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $51326a29f571e7cd$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $51326a29f571e7cd$var$getSymbols = !$51326a29f571e7cd$var$nativeGetSymbols ? $clnSu : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $8H9RZ($51326a29f571e7cd$var$nativeGetSymbols(object), function(symbol) {
        return $51326a29f571e7cd$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $51326a29f571e7cd$var$getSymbols;

});
parcelRegister("8H9RZ", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $6549fed720324048$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $6549fed720324048$var$arrayFilter;

});

parcelRegister("clnSu", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $8fc9f7df9b0c06bb$var$stubArray() {
    return [];
}
module.exports = $8fc9f7df9b0c06bb$var$stubArray;

});



parcelRegister("7n7lE", function(module, exports) {

var $cYlGN = parcelRequire("cYlGN");

var $aiaLi = parcelRequire("aiaLi");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $55e06195de8b50ba$var$copySymbolsIn(source, object) {
    return $cYlGN(source, $aiaLi(source), object);
}
module.exports = $55e06195de8b50ba$var$copySymbolsIn;

});
parcelRegister("aiaLi", function(module, exports) {

var $hynws = parcelRequire("hynws");

var $cdnOB = parcelRequire("cdnOB");

var $6YcYN = parcelRequire("6YcYN");

var $clnSu = parcelRequire("clnSu");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $77e3eeed2d30c6bc$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $77e3eeed2d30c6bc$var$getSymbolsIn = !$77e3eeed2d30c6bc$var$nativeGetSymbols ? $clnSu : function(object) {
    var result = [];
    while(object){
        $hynws(result, $6YcYN(object));
        object = $cdnOB(object);
    }
    return result;
};
module.exports = $77e3eeed2d30c6bc$var$getSymbolsIn;

});
parcelRegister("hynws", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $cc77dbb7c08db6a8$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $cc77dbb7c08db6a8$var$arrayPush;

});

parcelRegister("cdnOB", function(module, exports) {

var $lW2Sc = parcelRequire("lW2Sc");
/** Built-in value references. */ var $8e492c1d7a7ea307$var$getPrototype = $lW2Sc(Object.getPrototypeOf, Object);
module.exports = $8e492c1d7a7ea307$var$getPrototype;

});



parcelRegister("apVCl", function(module, exports) {

var $ctgi8 = parcelRequire("ctgi8");

var $6YcYN = parcelRequire("6YcYN");

var $LAMcS = parcelRequire("LAMcS");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $7958eecccfe4cef6$var$getAllKeys(object) {
    return $ctgi8(object, $LAMcS, $6YcYN);
}
module.exports = $7958eecccfe4cef6$var$getAllKeys;

});
parcelRegister("ctgi8", function(module, exports) {

var $hynws = parcelRequire("hynws");

var $o8HxT = parcelRequire("o8HxT");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $9144d49da7a47a72$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $o8HxT(object) ? result : $hynws(result, symbolsFunc(object));
}
module.exports = $9144d49da7a47a72$var$baseGetAllKeys;

});


parcelRegister("i0kKc", function(module, exports) {

var $ctgi8 = parcelRequire("ctgi8");

var $aiaLi = parcelRequire("aiaLi");

var $f4lqP = parcelRequire("f4lqP");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $d1b85174ea17081a$var$getAllKeysIn(object) {
    return $ctgi8(object, $f4lqP, $aiaLi);
}
module.exports = $d1b85174ea17081a$var$getAllKeysIn;

});

parcelRegister("67A6V", function(module, exports) {

var $5Ehf1 = parcelRequire("5Ehf1");

var $2cJKd = parcelRequire("2cJKd");

var $f7yH3 = parcelRequire("f7yH3");

var $vH4x0 = parcelRequire("vH4x0");

var $f0N2p = parcelRequire("f0N2p");

var $eq6CV = parcelRequire("eq6CV");

var $dqC5h = parcelRequire("dqC5h");
/** `Object#toString` result references. */ var $474f685f496bfe31$var$mapTag = '[object Map]', $474f685f496bfe31$var$objectTag = '[object Object]', $474f685f496bfe31$var$promiseTag = '[object Promise]', $474f685f496bfe31$var$setTag = '[object Set]', $474f685f496bfe31$var$weakMapTag = '[object WeakMap]';
var $474f685f496bfe31$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $474f685f496bfe31$var$dataViewCtorString = $dqC5h($5Ehf1), $474f685f496bfe31$var$mapCtorString = $dqC5h($2cJKd), $474f685f496bfe31$var$promiseCtorString = $dqC5h($f7yH3), $474f685f496bfe31$var$setCtorString = $dqC5h($vH4x0), $474f685f496bfe31$var$weakMapCtorString = $dqC5h($f0N2p);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $474f685f496bfe31$var$getTag = $eq6CV;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($5Ehf1 && $474f685f496bfe31$var$getTag(new $5Ehf1(new ArrayBuffer(1))) != $474f685f496bfe31$var$dataViewTag || $2cJKd && $474f685f496bfe31$var$getTag(new $2cJKd) != $474f685f496bfe31$var$mapTag || $f7yH3 && $474f685f496bfe31$var$getTag($f7yH3.resolve()) != $474f685f496bfe31$var$promiseTag || $vH4x0 && $474f685f496bfe31$var$getTag(new $vH4x0) != $474f685f496bfe31$var$setTag || $f0N2p && $474f685f496bfe31$var$getTag(new $f0N2p) != $474f685f496bfe31$var$weakMapTag) $474f685f496bfe31$var$getTag = function(value) {
    var result = $eq6CV(value), Ctor = result == $474f685f496bfe31$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $dqC5h(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $474f685f496bfe31$var$dataViewCtorString:
            return $474f685f496bfe31$var$dataViewTag;
        case $474f685f496bfe31$var$mapCtorString:
            return $474f685f496bfe31$var$mapTag;
        case $474f685f496bfe31$var$promiseCtorString:
            return $474f685f496bfe31$var$promiseTag;
        case $474f685f496bfe31$var$setCtorString:
            return $474f685f496bfe31$var$setTag;
        case $474f685f496bfe31$var$weakMapCtorString:
            return $474f685f496bfe31$var$weakMapTag;
    }
    return result;
};
module.exports = $474f685f496bfe31$var$getTag;

});
parcelRegister("5Ehf1", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $41ce0ff3b38ee753$var$DataView = $6T08O($23YZo, 'DataView');
module.exports = $41ce0ff3b38ee753$var$DataView;

});

parcelRegister("f7yH3", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $b0226bdea11cb834$var$Promise = $6T08O($23YZo, 'Promise');
module.exports = $b0226bdea11cb834$var$Promise;

});

parcelRegister("vH4x0", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $05f44e958da968eb$var$Set = $6T08O($23YZo, 'Set');
module.exports = $05f44e958da968eb$var$Set;

});

parcelRegister("f0N2p", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $aedce50092a1e6a6$var$WeakMap = $6T08O($23YZo, 'WeakMap');
module.exports = $aedce50092a1e6a6$var$WeakMap;

});


parcelRegister("4UmGC", function(module, exports) {
/** Used for built-in method references. */ var $392dfd68f4953502$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $392dfd68f4953502$var$hasOwnProperty = $392dfd68f4953502$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $392dfd68f4953502$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $392dfd68f4953502$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = $392dfd68f4953502$var$initCloneArray;

});

parcelRegister("btuqH", function(module, exports) {

var $jjbq1 = parcelRequire("jjbq1");

var $aKTvD = parcelRequire("aKTvD");

var $5IIrB = parcelRequire("5IIrB");

var $jxFRj = parcelRequire("jxFRj");

var $5JAGM = parcelRequire("5JAGM");
/** `Object#toString` result references. */ var $85aa01d56b12d536$var$boolTag = '[object Boolean]', $85aa01d56b12d536$var$dateTag = '[object Date]', $85aa01d56b12d536$var$mapTag = '[object Map]', $85aa01d56b12d536$var$numberTag = '[object Number]', $85aa01d56b12d536$var$regexpTag = '[object RegExp]', $85aa01d56b12d536$var$setTag = '[object Set]', $85aa01d56b12d536$var$stringTag = '[object String]', $85aa01d56b12d536$var$symbolTag = '[object Symbol]';
var $85aa01d56b12d536$var$arrayBufferTag = '[object ArrayBuffer]', $85aa01d56b12d536$var$dataViewTag = '[object DataView]', $85aa01d56b12d536$var$float32Tag = '[object Float32Array]', $85aa01d56b12d536$var$float64Tag = '[object Float64Array]', $85aa01d56b12d536$var$int8Tag = '[object Int8Array]', $85aa01d56b12d536$var$int16Tag = '[object Int16Array]', $85aa01d56b12d536$var$int32Tag = '[object Int32Array]', $85aa01d56b12d536$var$uint8Tag = '[object Uint8Array]', $85aa01d56b12d536$var$uint8ClampedTag = '[object Uint8ClampedArray]', $85aa01d56b12d536$var$uint16Tag = '[object Uint16Array]', $85aa01d56b12d536$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $85aa01d56b12d536$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $85aa01d56b12d536$var$arrayBufferTag:
            return $jjbq1(object);
        case $85aa01d56b12d536$var$boolTag:
        case $85aa01d56b12d536$var$dateTag:
            return new Ctor(+object);
        case $85aa01d56b12d536$var$dataViewTag:
            return $aKTvD(object, isDeep);
        case $85aa01d56b12d536$var$float32Tag:
        case $85aa01d56b12d536$var$float64Tag:
        case $85aa01d56b12d536$var$int8Tag:
        case $85aa01d56b12d536$var$int16Tag:
        case $85aa01d56b12d536$var$int32Tag:
        case $85aa01d56b12d536$var$uint8Tag:
        case $85aa01d56b12d536$var$uint8ClampedTag:
        case $85aa01d56b12d536$var$uint16Tag:
        case $85aa01d56b12d536$var$uint32Tag:
            return $5JAGM(object, isDeep);
        case $85aa01d56b12d536$var$mapTag:
            return new Ctor;
        case $85aa01d56b12d536$var$numberTag:
        case $85aa01d56b12d536$var$stringTag:
            return new Ctor(object);
        case $85aa01d56b12d536$var$regexpTag:
            return $5IIrB(object);
        case $85aa01d56b12d536$var$setTag:
            return new Ctor;
        case $85aa01d56b12d536$var$symbolTag:
            return $jxFRj(object);
    }
}
module.exports = $85aa01d56b12d536$var$initCloneByTag;

});
parcelRegister("jjbq1", function(module, exports) {

var $lx3EF = parcelRequire("lx3EF");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $e0e8a62ea95bc20a$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $lx3EF(result).set(new $lx3EF(arrayBuffer));
    return result;
}
module.exports = $e0e8a62ea95bc20a$var$cloneArrayBuffer;

});
parcelRegister("lx3EF", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/** Built-in value references. */ var $facf83d1449a27b8$var$Uint8Array = $23YZo.Uint8Array;
module.exports = $facf83d1449a27b8$var$Uint8Array;

});


parcelRegister("aKTvD", function(module, exports) {

var $jjbq1 = parcelRequire("jjbq1");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $7d49423a2080f7e8$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $jjbq1(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = $7d49423a2080f7e8$var$cloneDataView;

});

parcelRegister("5IIrB", function(module, exports) {
/** Used to match `RegExp` flags from their coerced string values. */ var $42a38980bea1ca34$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $42a38980bea1ca34$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $42a38980bea1ca34$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = $42a38980bea1ca34$var$cloneRegExp;

});

parcelRegister("jxFRj", function(module, exports) {

var $57wYk = parcelRequire("57wYk");
/** Used to convert symbols to primitives and strings. */ var $e3a191b3227aae5b$var$symbolProto = $57wYk ? $57wYk.prototype : undefined, $e3a191b3227aae5b$var$symbolValueOf = $e3a191b3227aae5b$var$symbolProto ? $e3a191b3227aae5b$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $e3a191b3227aae5b$var$cloneSymbol(symbol) {
    return $e3a191b3227aae5b$var$symbolValueOf ? Object($e3a191b3227aae5b$var$symbolValueOf.call(symbol)) : {};
}
module.exports = $e3a191b3227aae5b$var$cloneSymbol;

});

parcelRegister("5JAGM", function(module, exports) {

var $jjbq1 = parcelRequire("jjbq1");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $42cd9d64f56ec214$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $jjbq1(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = $42cd9d64f56ec214$var$cloneTypedArray;

});


parcelRegister("dFJsF", function(module, exports) {

var $4XGZt = parcelRequire("4XGZt");

var $cdnOB = parcelRequire("cdnOB");

var $3wZFp = parcelRequire("3wZFp");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $9f425e619197b80f$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !$3wZFp(object) ? $4XGZt($cdnOB(object)) : {};
}
module.exports = $9f425e619197b80f$var$initCloneObject;

});
parcelRegister("4XGZt", function(module, exports) {

var $lsJ54 = parcelRequire("lsJ54");
/** Built-in value references. */ var $39ce05228f203f9a$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $39ce05228f203f9a$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$lsJ54(proto)) return {};
        if ($39ce05228f203f9a$var$objectCreate) return $39ce05228f203f9a$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = $39ce05228f203f9a$var$baseCreate;

});


parcelRegister("eJObK", function(module, exports) {

var $9ORep = parcelRequire("9ORep");

var $91Qdd = parcelRequire("91Qdd");

var $jIny1 = parcelRequire("jIny1");
/* Node.js helper references. */ var $abac330771f68232$var$nodeIsMap = $jIny1 && $jIny1.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $abac330771f68232$var$isMap = $abac330771f68232$var$nodeIsMap ? $91Qdd($abac330771f68232$var$nodeIsMap) : $9ORep;
module.exports = $abac330771f68232$var$isMap;

});
parcelRegister("9ORep", function(module, exports) {

var $67A6V = parcelRequire("67A6V");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $7262133281c40437$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $7262133281c40437$var$baseIsMap(value) {
    return $8l89S(value) && $67A6V(value) == $7262133281c40437$var$mapTag;
}
module.exports = $7262133281c40437$var$baseIsMap;

});


parcelRegister("jZm8C", function(module, exports) {

var $eFk8g = parcelRequire("eFk8g");

var $91Qdd = parcelRequire("91Qdd");

var $jIny1 = parcelRequire("jIny1");
/* Node.js helper references. */ var $e8d4e2fa1f2b8f08$var$nodeIsSet = $jIny1 && $jIny1.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $e8d4e2fa1f2b8f08$var$isSet = $e8d4e2fa1f2b8f08$var$nodeIsSet ? $91Qdd($e8d4e2fa1f2b8f08$var$nodeIsSet) : $eFk8g;
module.exports = $e8d4e2fa1f2b8f08$var$isSet;

});
parcelRegister("eFk8g", function(module, exports) {

var $67A6V = parcelRequire("67A6V");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $aad482e59457493b$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $aad482e59457493b$var$baseIsSet(value) {
    return $8l89S(value) && $67A6V(value) == $aad482e59457493b$var$setTag;
}
module.exports = $aad482e59457493b$var$baseIsSet;

});




parcelRegister("9HRmE", function(module, exports) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $7111863c3c692f0e$var$constant(value) {
    return function() {
        return value;
    };
}
module.exports = $7111863c3c692f0e$var$constant;

});

parcelRegister("5kE3T", function(module, exports) {

module.exports = (parcelRequire("iWSff"));

});
parcelRegister("iWSff", function(module, exports) {

var $bFZGr = parcelRequire("bFZGr");

var $4DjQp = parcelRequire("4DjQp");

var $4c8Zb = parcelRequire("4c8Zb");

var $o8HxT = parcelRequire("o8HxT");
/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function $dcb7b8b4ed4ef64b$var$forEach(collection, iteratee) {
    var func = $o8HxT(collection) ? $bFZGr : $4DjQp;
    return func(collection, $4c8Zb(iteratee));
}
module.exports = $dcb7b8b4ed4ef64b$var$forEach;

});
parcelRegister("4DjQp", function(module, exports) {

var $4xK4A = parcelRequire("4xK4A");

var $kCOH9 = parcelRequire("kCOH9");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $35fa3296f177aa01$var$baseEach = $kCOH9($4xK4A);
module.exports = $35fa3296f177aa01$var$baseEach;

});
parcelRegister("4xK4A", function(module, exports) {

var $dEvx9 = parcelRequire("dEvx9");

var $LAMcS = parcelRequire("LAMcS");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $34edfba366a0cfa1$var$baseForOwn(object, iteratee) {
    return object && $dEvx9(object, iteratee, $LAMcS);
}
module.exports = $34edfba366a0cfa1$var$baseForOwn;

});
parcelRegister("dEvx9", function(module, exports) {

var $jTvRt = parcelRequire("jTvRt");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $9f0778b809a8c692$var$baseFor = $jTvRt();
module.exports = $9f0778b809a8c692$var$baseFor;

});
parcelRegister("jTvRt", function(module, exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $e7bbde6376f4568a$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = $e7bbde6376f4568a$var$createBaseFor;

});



parcelRegister("kCOH9", function(module, exports) {

var $eMthh = parcelRequire("eMthh");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $f03eae3721f9ace8$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$eMthh(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $f03eae3721f9ace8$var$createBaseEach;

});


parcelRegister("4c8Zb", function(module, exports) {

var $4Nq5y = parcelRequire("4Nq5y");
/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $30df40d61e63f4ce$var$castFunction(value) {
    return typeof value == 'function' ? value : $4Nq5y;
}
module.exports = $30df40d61e63f4ce$var$castFunction;

});
parcelRegister("4Nq5y", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $37dff9aa04444f9c$var$identity(value) {
    return value;
}
module.exports = $37dff9aa04444f9c$var$identity;

});




parcelRegister("jLJR7", function(module, exports) {

var $8H9RZ = parcelRequire("8H9RZ");

var $agamk = parcelRequire("agamk");

var $7MWok = parcelRequire("7MWok");

var $o8HxT = parcelRequire("o8HxT");
/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */ function $e645fa20844da7aa$var$filter(collection, predicate) {
    var func = $o8HxT(collection) ? $8H9RZ : $agamk;
    return func(collection, $7MWok(predicate, 3));
}
module.exports = $e645fa20844da7aa$var$filter;

});
parcelRegister("agamk", function(module, exports) {

var $4DjQp = parcelRequire("4DjQp");
/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $77836f185896e906$var$baseFilter(collection, predicate) {
    var result = [];
    $4DjQp(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) result.push(value);
    });
    return result;
}
module.exports = $77836f185896e906$var$baseFilter;

});

parcelRegister("7MWok", function(module, exports) {

var $jShkp = parcelRequire("jShkp");

var $in5n5 = parcelRequire("in5n5");

var $4Nq5y = parcelRequire("4Nq5y");

var $o8HxT = parcelRequire("o8HxT");

var $bAYPD = parcelRequire("bAYPD");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $5aba4f6d9f8304a3$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $4Nq5y;
    if (typeof value == 'object') return $o8HxT(value) ? $in5n5(value[0], value[1]) : $jShkp(value);
    return $bAYPD(value);
}
module.exports = $5aba4f6d9f8304a3$var$baseIteratee;

});
parcelRegister("jShkp", function(module, exports) {

var $kgn8n = parcelRequire("kgn8n");

var $9dd8D = parcelRequire("9dd8D");

var $2IhDm = parcelRequire("2IhDm");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $e780807e2b795134$var$baseMatches(source) {
    var matchData = $9dd8D(source);
    if (matchData.length == 1 && matchData[0][2]) return $2IhDm(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $kgn8n(object, source, matchData);
    };
}
module.exports = $e780807e2b795134$var$baseMatches;

});
parcelRegister("kgn8n", function(module, exports) {

var $g779E = parcelRequire("g779E");

var $abgWr = parcelRequire("abgWr");
/** Used to compose bitmasks for value comparisons. */ var $ec073f38db6e7d54$var$COMPARE_PARTIAL_FLAG = 1, $ec073f38db6e7d54$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $ec073f38db6e7d54$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $g779E;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $abgWr(srcValue, objValue, $ec073f38db6e7d54$var$COMPARE_PARTIAL_FLAG | $ec073f38db6e7d54$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = $ec073f38db6e7d54$var$baseIsMatch;

});
parcelRegister("abgWr", function(module, exports) {

var $7qq40 = parcelRequire("7qq40");

var $8l89S = parcelRequire("8l89S");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $769812b29c18141e$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$8l89S(value) && !$8l89S(other)) return value !== value && other !== other;
    return $7qq40(value, other, bitmask, customizer, $769812b29c18141e$var$baseIsEqual, stack);
}
module.exports = $769812b29c18141e$var$baseIsEqual;

});
parcelRegister("7qq40", function(module, exports) {

var $g779E = parcelRequire("g779E");

var $1pRE7 = parcelRequire("1pRE7");

var $g3aCZ = parcelRequire("g3aCZ");

var $eOqMj = parcelRequire("eOqMj");

var $67A6V = parcelRequire("67A6V");

var $o8HxT = parcelRequire("o8HxT");

var $f504n = parcelRequire("f504n");

var $1Q21n = parcelRequire("1Q21n");
/** Used to compose bitmasks for value comparisons. */ var $567f2dd161ebd4f6$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $567f2dd161ebd4f6$var$argsTag = '[object Arguments]', $567f2dd161ebd4f6$var$arrayTag = '[object Array]', $567f2dd161ebd4f6$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $567f2dd161ebd4f6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $567f2dd161ebd4f6$var$hasOwnProperty = $567f2dd161ebd4f6$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $567f2dd161ebd4f6$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $o8HxT(object), othIsArr = $o8HxT(other), objTag = objIsArr ? $567f2dd161ebd4f6$var$arrayTag : $67A6V(object), othTag = othIsArr ? $567f2dd161ebd4f6$var$arrayTag : $67A6V(other);
    objTag = objTag == $567f2dd161ebd4f6$var$argsTag ? $567f2dd161ebd4f6$var$objectTag : objTag;
    othTag = othTag == $567f2dd161ebd4f6$var$argsTag ? $567f2dd161ebd4f6$var$objectTag : othTag;
    var objIsObj = objTag == $567f2dd161ebd4f6$var$objectTag, othIsObj = othTag == $567f2dd161ebd4f6$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $f504n(object)) {
        if (!$f504n(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $g779E);
        return objIsArr || $1Q21n(object) ? $1pRE7(object, other, bitmask, customizer, equalFunc, stack) : $g3aCZ(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $567f2dd161ebd4f6$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $567f2dd161ebd4f6$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $567f2dd161ebd4f6$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $g779E);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $g779E);
    return $eOqMj(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $567f2dd161ebd4f6$var$baseIsEqualDeep;

});
parcelRegister("1pRE7", function(module, exports) {

var $dXA7v = parcelRequire("dXA7v");

var $eFBTL = parcelRequire("eFBTL");

var $2l8n7 = parcelRequire("2l8n7");
/** Used to compose bitmasks for value comparisons. */ var $1081bd3a2e361911$var$COMPARE_PARTIAL_FLAG = 1, $1081bd3a2e361911$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $1081bd3a2e361911$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $1081bd3a2e361911$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $1081bd3a2e361911$var$COMPARE_UNORDERED_FLAG ? new $dXA7v : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$eFBTL(other, function(othValue, othIndex) {
                if (!$2l8n7(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
module.exports = $1081bd3a2e361911$var$equalArrays;

});
parcelRegister("dXA7v", function(module, exports) {

var $6gDBQ = parcelRequire("6gDBQ");

var $j1Tfx = parcelRequire("j1Tfx");

var $8NkYQ = parcelRequire("8NkYQ");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $a29ccdc0f60e279e$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $6gDBQ;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$a29ccdc0f60e279e$var$SetCache.prototype.add = $a29ccdc0f60e279e$var$SetCache.prototype.push = $j1Tfx;
$a29ccdc0f60e279e$var$SetCache.prototype.has = $8NkYQ;
module.exports = $a29ccdc0f60e279e$var$SetCache;

});
parcelRegister("j1Tfx", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $dda8f7b6b589544e$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $dda8f7b6b589544e$var$setCacheAdd(value) {
    this.__data__.set(value, $dda8f7b6b589544e$var$HASH_UNDEFINED);
    return this;
}
module.exports = $dda8f7b6b589544e$var$setCacheAdd;

});

parcelRegister("8NkYQ", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $66732c92c350622c$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $66732c92c350622c$var$setCacheHas;

});


parcelRegister("eFBTL", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $aae24ad60cc3cfcb$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $aae24ad60cc3cfcb$var$arraySome;

});

parcelRegister("2l8n7", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $1b44096ad4b9e2d5$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $1b44096ad4b9e2d5$var$cacheHas;

});


parcelRegister("g3aCZ", function(module, exports) {

var $57wYk = parcelRequire("57wYk");

var $lx3EF = parcelRequire("lx3EF");

var $6TC8i = parcelRequire("6TC8i");

var $1pRE7 = parcelRequire("1pRE7");

var $cwfcG = parcelRequire("cwfcG");

var $1xAji = parcelRequire("1xAji");
/** Used to compose bitmasks for value comparisons. */ var $baf52b9e146f3da7$var$COMPARE_PARTIAL_FLAG = 1, $baf52b9e146f3da7$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $baf52b9e146f3da7$var$boolTag = '[object Boolean]', $baf52b9e146f3da7$var$dateTag = '[object Date]', $baf52b9e146f3da7$var$errorTag = '[object Error]', $baf52b9e146f3da7$var$mapTag = '[object Map]', $baf52b9e146f3da7$var$numberTag = '[object Number]', $baf52b9e146f3da7$var$regexpTag = '[object RegExp]', $baf52b9e146f3da7$var$setTag = '[object Set]', $baf52b9e146f3da7$var$stringTag = '[object String]', $baf52b9e146f3da7$var$symbolTag = '[object Symbol]';
var $baf52b9e146f3da7$var$arrayBufferTag = '[object ArrayBuffer]', $baf52b9e146f3da7$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $baf52b9e146f3da7$var$symbolProto = $57wYk ? $57wYk.prototype : undefined, $baf52b9e146f3da7$var$symbolValueOf = $baf52b9e146f3da7$var$symbolProto ? $baf52b9e146f3da7$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $baf52b9e146f3da7$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $baf52b9e146f3da7$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $baf52b9e146f3da7$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $lx3EF(object), new $lx3EF(other))) return false;
            return true;
        case $baf52b9e146f3da7$var$boolTag:
        case $baf52b9e146f3da7$var$dateTag:
        case $baf52b9e146f3da7$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $6TC8i(+object, +other);
        case $baf52b9e146f3da7$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $baf52b9e146f3da7$var$regexpTag:
        case $baf52b9e146f3da7$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $baf52b9e146f3da7$var$mapTag:
            var convert = $cwfcG;
        case $baf52b9e146f3da7$var$setTag:
            var isPartial = bitmask & $baf52b9e146f3da7$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $1xAji);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $baf52b9e146f3da7$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $1pRE7(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $baf52b9e146f3da7$var$symbolTag:
            if ($baf52b9e146f3da7$var$symbolValueOf) return $baf52b9e146f3da7$var$symbolValueOf.call(object) == $baf52b9e146f3da7$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $baf52b9e146f3da7$var$equalByTag;

});
parcelRegister("cwfcG", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $91d4444cbb077e0c$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $91d4444cbb077e0c$var$mapToArray;

});

parcelRegister("1xAji", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $11f509f8f53d8c36$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $11f509f8f53d8c36$var$setToArray;

});


parcelRegister("eOqMj", function(module, exports) {

var $apVCl = parcelRequire("apVCl");
/** Used to compose bitmasks for value comparisons. */ var $ac8a81cbae0357e8$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $ac8a81cbae0357e8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ac8a81cbae0357e8$var$hasOwnProperty = $ac8a81cbae0357e8$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $ac8a81cbae0357e8$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $ac8a81cbae0357e8$var$COMPARE_PARTIAL_FLAG, objProps = $apVCl(object), objLength = objProps.length, othProps = $apVCl(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $ac8a81cbae0357e8$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
module.exports = $ac8a81cbae0357e8$var$equalObjects;

});




parcelRegister("9dd8D", function(module, exports) {

var $1n1hd = parcelRequire("1n1hd");

var $LAMcS = parcelRequire("LAMcS");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $6b4f84f6be7f825c$var$getMatchData(object) {
    var result = $LAMcS(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $1n1hd(value)
        ];
    }
    return result;
}
module.exports = $6b4f84f6be7f825c$var$getMatchData;

});
parcelRegister("1n1hd", function(module, exports) {

var $lsJ54 = parcelRequire("lsJ54");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $0ff8edf4f90a7955$var$isStrictComparable(value) {
    return value === value && !$lsJ54(value);
}
module.exports = $0ff8edf4f90a7955$var$isStrictComparable;

});


parcelRegister("2IhDm", function(module, exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $1f9d5e891556ddb9$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = $1f9d5e891556ddb9$var$matchesStrictComparable;

});


parcelRegister("in5n5", function(module, exports) {

var $abgWr = parcelRequire("abgWr");

var $i51gj = parcelRequire("i51gj");

var $2VBx6 = parcelRequire("2VBx6");

var $kPpic = parcelRequire("kPpic");

var $1n1hd = parcelRequire("1n1hd");

var $2IhDm = parcelRequire("2IhDm");

var $6DSvu = parcelRequire("6DSvu");
/** Used to compose bitmasks for value comparisons. */ var $d5fe8a98fe4800eb$var$COMPARE_PARTIAL_FLAG = 1, $d5fe8a98fe4800eb$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $d5fe8a98fe4800eb$var$baseMatchesProperty(path, srcValue) {
    if ($kPpic(path) && $1n1hd(srcValue)) return $2IhDm($6DSvu(path), srcValue);
    return function(object) {
        var objValue = $i51gj(object, path);
        return objValue === undefined && objValue === srcValue ? $2VBx6(object, path) : $abgWr(srcValue, objValue, $d5fe8a98fe4800eb$var$COMPARE_PARTIAL_FLAG | $d5fe8a98fe4800eb$var$COMPARE_UNORDERED_FLAG);
    };
}
module.exports = $d5fe8a98fe4800eb$var$baseMatchesProperty;

});
parcelRegister("i51gj", function(module, exports) {

var $lJEX1 = parcelRequire("lJEX1");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $d299ac421c05c135$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $lJEX1(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $d299ac421c05c135$var$get;

});
parcelRegister("lJEX1", function(module, exports) {

var $4RK0h = parcelRequire("4RK0h");

var $6DSvu = parcelRequire("6DSvu");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $fd2d90f592c63519$var$baseGet(object, path) {
    path = $4RK0h(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$6DSvu(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $fd2d90f592c63519$var$baseGet;

});
parcelRegister("4RK0h", function(module, exports) {

var $o8HxT = parcelRequire("o8HxT");

var $kPpic = parcelRequire("kPpic");

var $lnP3M = parcelRequire("lnP3M");

var $l6E2L = parcelRequire("l6E2L");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $38afcbfab85a0553$var$castPath(value, object) {
    if ($o8HxT(value)) return value;
    return $kPpic(value, object) ? [
        value
    ] : $lnP3M($l6E2L(value));
}
module.exports = $38afcbfab85a0553$var$castPath;

});
parcelRegister("kPpic", function(module, exports) {

var $o8HxT = parcelRequire("o8HxT");

var $9dr3u = parcelRequire("9dr3u");
/** Used to match property names within property paths. */ var $03e9beb856e9b4cd$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $03e9beb856e9b4cd$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $03e9beb856e9b4cd$var$isKey(value, object) {
    if ($o8HxT(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $9dr3u(value)) return true;
    return $03e9beb856e9b4cd$var$reIsPlainProp.test(value) || !$03e9beb856e9b4cd$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $03e9beb856e9b4cd$var$isKey;

});
parcelRegister("9dr3u", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $6b5a5095e0934938$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $6b5a5095e0934938$var$isSymbol(value) {
    return typeof value == 'symbol' || $8l89S(value) && $eq6CV(value) == $6b5a5095e0934938$var$symbolTag;
}
module.exports = $6b5a5095e0934938$var$isSymbol;

});


parcelRegister("lnP3M", function(module, exports) {

var $99Rk8 = parcelRequire("99Rk8");
/** Used to match property names within property paths. */ var $f9135a667399ede4$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $f9135a667399ede4$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $f9135a667399ede4$var$stringToPath = $99Rk8(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($f9135a667399ede4$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($f9135a667399ede4$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
module.exports = $f9135a667399ede4$var$stringToPath;

});
parcelRegister("99Rk8", function(module, exports) {

var $23xpV = parcelRequire("23xpV");
/** Used as the maximum memoize cache size. */ var $6aae515404bf5dd2$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $6aae515404bf5dd2$var$memoizeCapped(func) {
    var result = $23xpV(func, function(key) {
        if (cache.size === $6aae515404bf5dd2$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $6aae515404bf5dd2$var$memoizeCapped;

});
parcelRegister("23xpV", function(module, exports) {

var $6gDBQ = parcelRequire("6gDBQ");
/** Error message constants. */ var $17f5c88c594eac51$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $17f5c88c594eac51$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($17f5c88c594eac51$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($17f5c88c594eac51$var$memoize.Cache || $6gDBQ);
    return memoized;
}
// Expose `MapCache`.
$17f5c88c594eac51$var$memoize.Cache = $6gDBQ;
module.exports = $17f5c88c594eac51$var$memoize;

});



parcelRegister("l6E2L", function(module, exports) {

var $kJ9w3 = parcelRequire("kJ9w3");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $f5d9385a9cc7e413$var$toString(value) {
    return value == null ? '' : $kJ9w3(value);
}
module.exports = $f5d9385a9cc7e413$var$toString;

});
parcelRegister("kJ9w3", function(module, exports) {

var $57wYk = parcelRequire("57wYk");

var $i46jW = parcelRequire("i46jW");

var $o8HxT = parcelRequire("o8HxT");

var $9dr3u = parcelRequire("9dr3u");
/** Used as references for various `Number` constants. */ var $f16f644742c27c21$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $f16f644742c27c21$var$symbolProto = $57wYk ? $57wYk.prototype : undefined, $f16f644742c27c21$var$symbolToString = $f16f644742c27c21$var$symbolProto ? $f16f644742c27c21$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $f16f644742c27c21$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($o8HxT(value)) // Recursively convert values (susceptible to call stack limits).
    return $i46jW(value, $f16f644742c27c21$var$baseToString) + '';
    if ($9dr3u(value)) return $f16f644742c27c21$var$symbolToString ? $f16f644742c27c21$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$f16f644742c27c21$var$INFINITY ? '-0' : result;
}
module.exports = $f16f644742c27c21$var$baseToString;

});
parcelRegister("i46jW", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $d26d80da1ba3948c$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $d26d80da1ba3948c$var$arrayMap;

});




parcelRegister("6DSvu", function(module, exports) {

var $9dr3u = parcelRequire("9dr3u");
/** Used as references for various `Number` constants. */ var $4d60aa8c33155976$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $4d60aa8c33155976$var$toKey(value) {
    if (typeof value == 'string' || $9dr3u(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$4d60aa8c33155976$var$INFINITY ? '-0' : result;
}
module.exports = $4d60aa8c33155976$var$toKey;

});



parcelRegister("2VBx6", function(module, exports) {

var $ij33W = parcelRequire("ij33W");

var $btvBm = parcelRequire("btvBm");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $221e04e57e35dd04$var$hasIn(object, path) {
    return object != null && $btvBm(object, path, $ij33W);
}
module.exports = $221e04e57e35dd04$var$hasIn;

});
parcelRegister("ij33W", function(module, exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $d53c6080f339a51f$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = $d53c6080f339a51f$var$baseHasIn;

});

parcelRegister("btvBm", function(module, exports) {

var $4RK0h = parcelRequire("4RK0h");

var $aJD6g = parcelRequire("aJD6g");

var $o8HxT = parcelRequire("o8HxT");

var $iyUuu = parcelRequire("iyUuu");

var $1S9lz = parcelRequire("1S9lz");

var $6DSvu = parcelRequire("6DSvu");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $85aaea8f77d790ae$var$hasPath(object, path, hasFunc) {
    path = $4RK0h(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $6DSvu(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $1S9lz(length) && $iyUuu(key, length) && ($o8HxT(object) || $aJD6g(object));
}
module.exports = $85aaea8f77d790ae$var$hasPath;

});



parcelRegister("bAYPD", function(module, exports) {

var $ielIK = parcelRequire("ielIK");

var $jfdoV = parcelRequire("jfdoV");

var $kPpic = parcelRequire("kPpic");

var $6DSvu = parcelRequire("6DSvu");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $87123e72266aa58c$var$property(path) {
    return $kPpic(path) ? $ielIK($6DSvu(path)) : $jfdoV(path);
}
module.exports = $87123e72266aa58c$var$property;

});
parcelRegister("ielIK", function(module, exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $d45a621b4548f6bb$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $d45a621b4548f6bb$var$baseProperty;

});

parcelRegister("jfdoV", function(module, exports) {

var $lJEX1 = parcelRequire("lJEX1");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $e029d02f9dd10368$var$basePropertyDeep(path) {
    return function(object) {
        return $lJEX1(object, path);
    };
}
module.exports = $e029d02f9dd10368$var$basePropertyDeep;

});




parcelRegister("jplJt", function(module, exports) {

var $5aSdf = parcelRequire("5aSdf");

var $btvBm = parcelRequire("btvBm");
/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */ function $e21135b6db383fe3$var$has(object, path) {
    return object != null && $btvBm(object, path, $5aSdf);
}
module.exports = $e21135b6db383fe3$var$has;

});
parcelRegister("5aSdf", function(module, exports) {
/** Used for built-in method references. */ var $3c47f0745c8ad323$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3c47f0745c8ad323$var$hasOwnProperty = $3c47f0745c8ad323$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $3c47f0745c8ad323$var$baseHas(object, key) {
    return object != null && $3c47f0745c8ad323$var$hasOwnProperty.call(object, key);
}
module.exports = $3c47f0745c8ad323$var$baseHas;

});


parcelRegister("44Pmt", function(module, exports) {

var $jViFF = parcelRequire("jViFF");

var $67A6V = parcelRequire("67A6V");

var $aJD6g = parcelRequire("aJD6g");

var $o8HxT = parcelRequire("o8HxT");

var $eMthh = parcelRequire("eMthh");

var $f504n = parcelRequire("f504n");

var $3wZFp = parcelRequire("3wZFp");

var $1Q21n = parcelRequire("1Q21n");
/** `Object#toString` result references. */ var $2f7f607262506341$var$mapTag = '[object Map]', $2f7f607262506341$var$setTag = '[object Set]';
/** Used for built-in method references. */ var $2f7f607262506341$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2f7f607262506341$var$hasOwnProperty = $2f7f607262506341$var$objectProto.hasOwnProperty;
/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */ function $2f7f607262506341$var$isEmpty(value) {
    if (value == null) return true;
    if ($eMthh(value) && ($o8HxT(value) || typeof value == 'string' || typeof value.splice == 'function' || $f504n(value) || $1Q21n(value) || $aJD6g(value))) return !value.length;
    var tag = $67A6V(value);
    if (tag == $2f7f607262506341$var$mapTag || tag == $2f7f607262506341$var$setTag) return !value.size;
    if ($3wZFp(value)) return !$jViFF(value).length;
    for(var key in value){
        if ($2f7f607262506341$var$hasOwnProperty.call(value, key)) return false;
    }
    return true;
}
module.exports = $2f7f607262506341$var$isEmpty;

});

parcelRegister("enrJD", function(module, exports) {
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ function $a778ba4a8bc65100$var$isUndefined(value) {
    return value === undefined;
}
module.exports = $a778ba4a8bc65100$var$isUndefined;

});

parcelRegister("437iZ", function(module, exports) {

var $i46jW = parcelRequire("i46jW");

var $7MWok = parcelRequire("7MWok");

var $fDc61 = parcelRequire("fDc61");

var $o8HxT = parcelRequire("o8HxT");
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $2f2d1bf022ac3e3d$var$map(collection, iteratee) {
    var func = $o8HxT(collection) ? $i46jW : $fDc61;
    return func(collection, $7MWok(iteratee, 3));
}
module.exports = $2f2d1bf022ac3e3d$var$map;

});
parcelRegister("fDc61", function(module, exports) {

var $4DjQp = parcelRequire("4DjQp");

var $eMthh = parcelRequire("eMthh");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $b613e194c1b157de$var$baseMap(collection, iteratee) {
    var index = -1, result = $eMthh(collection) ? Array(collection.length) : [];
    $4DjQp(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
module.exports = $b613e194c1b157de$var$baseMap;

});


parcelRegister("2KuAh", function(module, exports) {

var $1FZZ3 = parcelRequire("1FZZ3");

var $4DjQp = parcelRequire("4DjQp");

var $7MWok = parcelRequire("7MWok");

var $aJqKN = parcelRequire("aJqKN");

var $o8HxT = parcelRequire("o8HxT");
/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */ function $20079a03744bdfdb$var$reduce(collection, iteratee, accumulator) {
    var func = $o8HxT(collection) ? $1FZZ3 : $aJqKN, initAccum = arguments.length < 3;
    return func(collection, $7MWok(iteratee, 4), accumulator, initAccum, $4DjQp);
}
module.exports = $20079a03744bdfdb$var$reduce;

});
parcelRegister("1FZZ3", function(module, exports) {
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $1389b3710f5da9e8$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
module.exports = $1389b3710f5da9e8$var$arrayReduce;

});

parcelRegister("aJqKN", function(module, exports) {
/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */ function $7d02dc1e77542632$var$baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
}
module.exports = $7d02dc1e77542632$var$baseReduce;

});


parcelRegister("2RKXE", function(module, exports) {

var $jViFF = parcelRequire("jViFF");

var $67A6V = parcelRequire("67A6V");

var $eMthh = parcelRequire("eMthh");

var $1SJGG = parcelRequire("1SJGG");

var $irc76 = parcelRequire("irc76");
/** `Object#toString` result references. */ var $2164f585c713957a$var$mapTag = '[object Map]', $2164f585c713957a$var$setTag = '[object Set]';
/**
 * Gets the size of `collection` by returning its length for array-like
 * values or the number of own enumerable string keyed properties for objects.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @returns {number} Returns the collection size.
 * @example
 *
 * _.size([1, 2, 3]);
 * // => 3
 *
 * _.size({ 'a': 1, 'b': 2 });
 * // => 2
 *
 * _.size('pebbles');
 * // => 7
 */ function $2164f585c713957a$var$size(collection) {
    if (collection == null) return 0;
    if ($eMthh(collection)) return $1SJGG(collection) ? $irc76(collection) : collection.length;
    var tag = $67A6V(collection);
    if (tag == $2164f585c713957a$var$mapTag || tag == $2164f585c713957a$var$setTag) return collection.size;
    return $jViFF(collection).length;
}
module.exports = $2164f585c713957a$var$size;

});
parcelRegister("1SJGG", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $o8HxT = parcelRequire("o8HxT");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $15ee4628980e0994$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $15ee4628980e0994$var$isString(value) {
    return typeof value == 'string' || !$o8HxT(value) && $8l89S(value) && $eq6CV(value) == $15ee4628980e0994$var$stringTag;
}
module.exports = $15ee4628980e0994$var$isString;

});

parcelRegister("irc76", function(module, exports) {

var $ijOWR = parcelRequire("ijOWR");

var $05hp8 = parcelRequire("05hp8");

var $etsxF = parcelRequire("etsxF");
/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */ function $d6c4251e3abece1b$var$stringSize(string) {
    return $05hp8(string) ? $etsxF(string) : $ijOWR(string);
}
module.exports = $d6c4251e3abece1b$var$stringSize;

});
parcelRegister("ijOWR", function(module, exports) {

var $ielIK = parcelRequire("ielIK");
/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */ var $d56185a2b451cebc$var$asciiSize = $ielIK('length');
module.exports = $d56185a2b451cebc$var$asciiSize;

});

parcelRegister("05hp8", function(module, exports) {
/** Used to compose unicode character classes. */ var $00fdf7eab00be2e7$var$rsAstralRange = '\\ud800-\\udfff', $00fdf7eab00be2e7$var$rsComboMarksRange = '\\u0300-\\u036f', $00fdf7eab00be2e7$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $00fdf7eab00be2e7$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $00fdf7eab00be2e7$var$rsComboRange = $00fdf7eab00be2e7$var$rsComboMarksRange + $00fdf7eab00be2e7$var$reComboHalfMarksRange + $00fdf7eab00be2e7$var$rsComboSymbolsRange, $00fdf7eab00be2e7$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $00fdf7eab00be2e7$var$rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $00fdf7eab00be2e7$var$reHasUnicode = RegExp('[' + $00fdf7eab00be2e7$var$rsZWJ + $00fdf7eab00be2e7$var$rsAstralRange + $00fdf7eab00be2e7$var$rsComboRange + $00fdf7eab00be2e7$var$rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $00fdf7eab00be2e7$var$hasUnicode(string) {
    return $00fdf7eab00be2e7$var$reHasUnicode.test(string);
}
module.exports = $00fdf7eab00be2e7$var$hasUnicode;

});

parcelRegister("etsxF", function(module, exports) {
/** Used to compose unicode character classes. */ var $a899e9fda8cd3735$var$rsAstralRange = '\\ud800-\\udfff', $a899e9fda8cd3735$var$rsComboMarksRange = '\\u0300-\\u036f', $a899e9fda8cd3735$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $a899e9fda8cd3735$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $a899e9fda8cd3735$var$rsComboRange = $a899e9fda8cd3735$var$rsComboMarksRange + $a899e9fda8cd3735$var$reComboHalfMarksRange + $a899e9fda8cd3735$var$rsComboSymbolsRange, $a899e9fda8cd3735$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $a899e9fda8cd3735$var$rsAstral = '[' + $a899e9fda8cd3735$var$rsAstralRange + ']', $a899e9fda8cd3735$var$rsCombo = '[' + $a899e9fda8cd3735$var$rsComboRange + ']', $a899e9fda8cd3735$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $a899e9fda8cd3735$var$rsModifier = '(?:' + $a899e9fda8cd3735$var$rsCombo + '|' + $a899e9fda8cd3735$var$rsFitz + ')', $a899e9fda8cd3735$var$rsNonAstral = '[^' + $a899e9fda8cd3735$var$rsAstralRange + ']', $a899e9fda8cd3735$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $a899e9fda8cd3735$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $a899e9fda8cd3735$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $a899e9fda8cd3735$var$reOptMod = $a899e9fda8cd3735$var$rsModifier + '?', $a899e9fda8cd3735$var$rsOptVar = '[' + $a899e9fda8cd3735$var$rsVarRange + ']?', $a899e9fda8cd3735$var$rsOptJoin = '(?:' + $a899e9fda8cd3735$var$rsZWJ + '(?:' + [
    $a899e9fda8cd3735$var$rsNonAstral,
    $a899e9fda8cd3735$var$rsRegional,
    $a899e9fda8cd3735$var$rsSurrPair
].join('|') + ')' + $a899e9fda8cd3735$var$rsOptVar + $a899e9fda8cd3735$var$reOptMod + ')*', $a899e9fda8cd3735$var$rsSeq = $a899e9fda8cd3735$var$rsOptVar + $a899e9fda8cd3735$var$reOptMod + $a899e9fda8cd3735$var$rsOptJoin, $a899e9fda8cd3735$var$rsSymbol = '(?:' + [
    $a899e9fda8cd3735$var$rsNonAstral + $a899e9fda8cd3735$var$rsCombo + '?',
    $a899e9fda8cd3735$var$rsCombo,
    $a899e9fda8cd3735$var$rsRegional,
    $a899e9fda8cd3735$var$rsSurrPair,
    $a899e9fda8cd3735$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $a899e9fda8cd3735$var$reUnicode = RegExp($a899e9fda8cd3735$var$rsFitz + '(?=' + $a899e9fda8cd3735$var$rsFitz + ')|' + $a899e9fda8cd3735$var$rsSymbol + $a899e9fda8cd3735$var$rsSeq, 'g');
/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */ function $a899e9fda8cd3735$var$unicodeSize(string) {
    var result = $a899e9fda8cd3735$var$reUnicode.lastIndex = 0;
    while($a899e9fda8cd3735$var$reUnicode.test(string))++result;
    return result;
}
module.exports = $a899e9fda8cd3735$var$unicodeSize;

});



parcelRegister("bGcIb", function(module, exports) {

var $bFZGr = parcelRequire("bFZGr");

var $4XGZt = parcelRequire("4XGZt");

var $4xK4A = parcelRequire("4xK4A");

var $7MWok = parcelRequire("7MWok");

var $cdnOB = parcelRequire("cdnOB");

var $o8HxT = parcelRequire("o8HxT");

var $f504n = parcelRequire("f504n");

var $01ubZ = parcelRequire("01ubZ");

var $lsJ54 = parcelRequire("lsJ54");

var $1Q21n = parcelRequire("1Q21n");
/**
 * An alternative to `_.reduce`; this method transforms `object` to a new
 * `accumulator` object which is the result of running each of its own
 * enumerable string keyed properties thru `iteratee`, with each invocation
 * potentially mutating the `accumulator` object. If `accumulator` is not
 * provided, a new object with the same `[[Prototype]]` will be used. The
 * iteratee is invoked with four arguments: (accumulator, value, key, object).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 1.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The custom accumulator value.
 * @returns {*} Returns the accumulated value.
 * @example
 *
 * _.transform([2, 3, 4], function(result, n) {
 *   result.push(n *= n);
 *   return n % 2 == 0;
 * }, []);
 * // => [4, 9]
 *
 * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] }
 */ function $880d7a3d41bd08eb$var$transform(object, iteratee, accumulator) {
    var isArr = $o8HxT(object), isArrLike = isArr || $f504n(object) || $1Q21n(object);
    iteratee = $7MWok(iteratee, 4);
    if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) accumulator = isArr ? new Ctor : [];
        else if ($lsJ54(object)) accumulator = $01ubZ(Ctor) ? $4XGZt($cdnOB(object)) : {};
        else accumulator = {};
    }
    (isArrLike ? $bFZGr : $4xK4A)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
    });
    return accumulator;
}
module.exports = $880d7a3d41bd08eb$var$transform;

});

parcelRegister("1c10x", function(module, exports) {

var $fgBHx = parcelRequire("fgBHx");

var $5iyRF = parcelRequire("5iyRF");

var $5VSS6 = parcelRequire("5VSS6");

var $jGP9B = parcelRequire("jGP9B");
/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */ var $0de7b1862975f367$var$union = $5iyRF(function(arrays) {
    return $5VSS6($fgBHx(arrays, 1, $jGP9B, true));
});
module.exports = $0de7b1862975f367$var$union;

});
parcelRegister("fgBHx", function(module, exports) {

var $hynws = parcelRequire("hynws");

var $hStNq = parcelRequire("hStNq");
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $b1d5985487d54dea$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $hStNq);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $b1d5985487d54dea$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $hynws(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $b1d5985487d54dea$var$baseFlatten;

});
parcelRegister("hStNq", function(module, exports) {

var $57wYk = parcelRequire("57wYk");

var $aJD6g = parcelRequire("aJD6g");

var $o8HxT = parcelRequire("o8HxT");
/** Built-in value references. */ var $035bd928078475ee$var$spreadableSymbol = $57wYk ? $57wYk.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $035bd928078475ee$var$isFlattenable(value) {
    return $o8HxT(value) || $aJD6g(value) || !!($035bd928078475ee$var$spreadableSymbol && value && value[$035bd928078475ee$var$spreadableSymbol]);
}
module.exports = $035bd928078475ee$var$isFlattenable;

});


parcelRegister("5iyRF", function(module, exports) {

var $4Nq5y = parcelRequire("4Nq5y");

var $b86t6 = parcelRequire("b86t6");

var $iGMVy = parcelRequire("iGMVy");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $3db9ad8fe1351fef$var$baseRest(func, start) {
    return $iGMVy($b86t6(func, start, $4Nq5y), func + '');
}
module.exports = $3db9ad8fe1351fef$var$baseRest;

});
parcelRegister("b86t6", function(module, exports) {

var $jpWht = parcelRequire("jpWht");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $81a5758ee0248452$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $81a5758ee0248452$var$overRest(func, start, transform) {
    start = $81a5758ee0248452$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $81a5758ee0248452$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $jpWht(func, this, otherArgs);
    };
}
module.exports = $81a5758ee0248452$var$overRest;

});
parcelRegister("jpWht", function(module, exports) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $e22d8f7aab4ea8e2$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = $e22d8f7aab4ea8e2$var$apply;

});


parcelRegister("iGMVy", function(module, exports) {

var $2yzAw = parcelRequire("2yzAw");

var $7WhTB = parcelRequire("7WhTB");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $d9b21a2cad7f96c2$var$setToString = $7WhTB($2yzAw);
module.exports = $d9b21a2cad7f96c2$var$setToString;

});
parcelRegister("2yzAw", function(module, exports) {

var $9HRmE = parcelRequire("9HRmE");

var $4hwTc = parcelRequire("4hwTc");

var $4Nq5y = parcelRequire("4Nq5y");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $1dca5cc74bf5ffaf$var$baseSetToString = !$4hwTc ? $4Nq5y : function(func, string) {
    return $4hwTc(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': $9HRmE(string),
        'writable': true
    });
};
module.exports = $1dca5cc74bf5ffaf$var$baseSetToString;

});

parcelRegister("7WhTB", function(module, exports) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $5c7bd4e931ae22e5$var$HOT_COUNT = 800, $5c7bd4e931ae22e5$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5c7bd4e931ae22e5$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $5c7bd4e931ae22e5$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $5c7bd4e931ae22e5$var$nativeNow(), remaining = $5c7bd4e931ae22e5$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $5c7bd4e931ae22e5$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = $5c7bd4e931ae22e5$var$shortOut;

});



parcelRegister("5VSS6", function(module, exports) {

var $dXA7v = parcelRequire("dXA7v");

var $ebE2M = parcelRequire("ebE2M");

var $eSdxB = parcelRequire("eSdxB");

var $2l8n7 = parcelRequire("2l8n7");

var $5sRi0 = parcelRequire("5sRi0");

var $1xAji = parcelRequire("1xAji");
/** Used as the size to enable large array optimizations. */ var $451cd6fc5b077ebe$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $451cd6fc5b077ebe$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $ebE2M, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $eSdxB;
    } else if (length >= $451cd6fc5b077ebe$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $5sRi0(array);
        if (set) return $1xAji(set);
        isCommon = false;
        includes = $2l8n7;
        seen = new $dXA7v;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $451cd6fc5b077ebe$var$baseUniq;

});
parcelRegister("ebE2M", function(module, exports) {

var $7pFTU = parcelRequire("7pFTU");
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $a541279ebb64f2c9$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $7pFTU(array, value, 0) > -1;
}
module.exports = $a541279ebb64f2c9$var$arrayIncludes;

});
parcelRegister("7pFTU", function(module, exports) {

var $eAor6 = parcelRequire("eAor6");

var $h2dHy = parcelRequire("h2dHy");

var $dU1uo = parcelRequire("dU1uo");
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $565b5ed18efa4b9c$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $dU1uo(array, value, fromIndex) : $eAor6(array, $h2dHy, fromIndex);
}
module.exports = $565b5ed18efa4b9c$var$baseIndexOf;

});
parcelRegister("eAor6", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $a9e76203bd7c412f$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $a9e76203bd7c412f$var$baseFindIndex;

});

parcelRegister("h2dHy", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $c66d4063f81f4687$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $c66d4063f81f4687$var$baseIsNaN;

});

parcelRegister("dU1uo", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $a1f1a90cd7caaefa$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $a1f1a90cd7caaefa$var$strictIndexOf;

});



parcelRegister("eSdxB", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $ad409cc63f3cbe79$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $ad409cc63f3cbe79$var$arrayIncludesWith;

});

parcelRegister("5sRi0", function(module, exports) {

var $vH4x0 = parcelRequire("vH4x0");

var $9iECD = parcelRequire("9iECD");

var $1xAji = parcelRequire("1xAji");
/** Used as references for various `Number` constants. */ var $3fa8e773494800f5$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $3fa8e773494800f5$var$createSet = !($vH4x0 && 1 / $1xAji(new $vH4x0([
    ,
    -0
]))[1] == $3fa8e773494800f5$var$INFINITY) ? $9iECD : function(values) {
    return new $vH4x0(values);
};
module.exports = $3fa8e773494800f5$var$createSet;

});
parcelRegister("9iECD", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $6c554e32feae9faa$var$noop() {
// No operation performed.
}
module.exports = $6c554e32feae9faa$var$noop;

});



parcelRegister("jGP9B", function(module, exports) {

var $eMthh = parcelRequire("eMthh");

var $8l89S = parcelRequire("8l89S");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $e5599ea424e07f76$var$isArrayLikeObject(value) {
    return $8l89S(value) && $eMthh(value);
}
module.exports = $e5599ea424e07f76$var$isArrayLikeObject;

});


parcelRegister("7D6Gq", function(module, exports) {

var $jaYdQ = parcelRequire("jaYdQ");

var $LAMcS = parcelRequire("LAMcS");
/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function $58e15c1958c92f73$var$values(object) {
    return object == null ? [] : $jaYdQ(object, $LAMcS(object));
}
module.exports = $58e15c1958c92f73$var$values;

});
parcelRegister("jaYdQ", function(module, exports) {

var $i46jW = parcelRequire("i46jW");
/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function $df5daa5e60cd3cbe$var$baseValues(object, props) {
    return $i46jW(props, function(key) {
        return object[key];
    });
}
module.exports = $df5daa5e60cd3cbe$var$baseValues;

});




parcelRegister("5LcVV", function(module, exports) {
module.exports = '2.1.8';

});


parcelRegister("cOdIh", function(module, exports) {

var $dOCPl = parcelRequire("dOCPl");

var $4JZcb = parcelRequire("4JZcb");
module.exports = {
    write: $9534cab8b40cf3db$var$write,
    read: $9534cab8b40cf3db$var$read
};
function $9534cab8b40cf3db$var$write(g) {
    var json = {
        options: {
            directed: g.isDirected(),
            multigraph: g.isMultigraph(),
            compound: g.isCompound()
        },
        nodes: $9534cab8b40cf3db$var$writeNodes(g),
        edges: $9534cab8b40cf3db$var$writeEdges(g)
    };
    if (!$dOCPl.isUndefined(g.graph())) json.value = $dOCPl.clone(g.graph());
    return json;
}
function $9534cab8b40cf3db$var$writeNodes(g) {
    return $dOCPl.map(g.nodes(), function(v) {
        var nodeValue = g.node(v);
        var parent = g.parent(v);
        var node = {
            v: v
        };
        if (!$dOCPl.isUndefined(nodeValue)) node.value = nodeValue;
        if (!$dOCPl.isUndefined(parent)) node.parent = parent;
        return node;
    });
}
function $9534cab8b40cf3db$var$writeEdges(g) {
    return $dOCPl.map(g.edges(), function(e) {
        var edgeValue = g.edge(e);
        var edge = {
            v: e.v,
            w: e.w
        };
        if (!$dOCPl.isUndefined(e.name)) edge.name = e.name;
        if (!$dOCPl.isUndefined(edgeValue)) edge.value = edgeValue;
        return edge;
    });
}
function $9534cab8b40cf3db$var$read(json) {
    var g = new $4JZcb(json.options).setGraph(json.value);
    $dOCPl.each(json.nodes, function(entry) {
        g.setNode(entry.v, entry.value);
        if (entry.parent) g.setParent(entry.v, entry.parent);
    });
    $dOCPl.each(json.edges, function(entry) {
        g.setEdge({
            v: entry.v,
            w: entry.w,
            name: entry.name
        }, entry.value);
    });
    return g;
}

});

parcelRegister("jm1Oa", function(module, exports) {











module.exports = {
    components: (parcelRequire("c3Kkn")),
    dijkstra: (parcelRequire("a8y4J")),
    dijkstraAll: (parcelRequire("3uso6")),
    findCycles: (parcelRequire("6pFca")),
    floydWarshall: (parcelRequire("2yn2B")),
    isAcyclic: (parcelRequire("3hBSd")),
    postorder: (parcelRequire("dX1tj")),
    preorder: (parcelRequire("e890l")),
    prim: (parcelRequire("ifTuH")),
    tarjan: (parcelRequire("38Zd5")),
    topsort: (parcelRequire("8UkLw"))
};

});
parcelRegister("c3Kkn", function(module, exports) {

var $dOCPl = parcelRequire("dOCPl");
module.exports = $8c79b38e8bb785e6$var$components;
function $8c79b38e8bb785e6$var$components(g) {
    var visited = {};
    var cmpts = [];
    var cmpt;
    function dfs(v) {
        if ($dOCPl.has(visited, v)) return;
        visited[v] = true;
        cmpt.push(v);
        $dOCPl.each(g.successors(v), dfs);
        $dOCPl.each(g.predecessors(v), dfs);
    }
    $dOCPl.each(g.nodes(), function(v) {
        cmpt = [];
        dfs(v);
        if (cmpt.length) cmpts.push(cmpt);
    });
    return cmpts;
}

});

parcelRegister("a8y4J", function(module, exports) {

var $dOCPl = parcelRequire("dOCPl");

var $5ZDax = parcelRequire("5ZDax");
module.exports = $7615155e1d66a6d5$var$dijkstra;
var $7615155e1d66a6d5$var$DEFAULT_WEIGHT_FUNC = $dOCPl.constant(1);
function $7615155e1d66a6d5$var$dijkstra(g, source, weightFn, edgeFn) {
    return $7615155e1d66a6d5$var$runDijkstra(g, String(source), weightFn || $7615155e1d66a6d5$var$DEFAULT_WEIGHT_FUNC, edgeFn || function(v) {
        return g.outEdges(v);
    });
}
function $7615155e1d66a6d5$var$runDijkstra(g, source, weightFn, edgeFn) {
    var results = {};
    var pq = new $5ZDax();
    var v, vEntry;
    var updateNeighbors = function(edge) {
        var w = edge.v !== v ? edge.v : edge.w;
        var wEntry = results[w];
        var weight = weightFn(edge);
        var distance = vEntry.distance + weight;
        if (weight < 0) throw new Error("dijkstra does not allow negative edge weights. Bad edge: " + edge + " Weight: " + weight);
        if (distance < wEntry.distance) {
            wEntry.distance = distance;
            wEntry.predecessor = v;
            pq.decrease(w, distance);
        }
    };
    g.nodes().forEach(function(v) {
        var distance = v === source ? 0 : Number.POSITIVE_INFINITY;
        results[v] = {
            distance: distance
        };
        pq.add(v, distance);
    });
    while(pq.size() > 0){
        v = pq.removeMin();
        vEntry = results[v];
        if (vEntry.distance === Number.POSITIVE_INFINITY) break;
        edgeFn(v).forEach(updateNeighbors);
    }
    return results;
}

});
parcelRegister("5ZDax", function(module, exports) {

var $dOCPl = parcelRequire("dOCPl");
module.exports = $45d10863bd1362e9$var$PriorityQueue;
/**
 * A min-priority queue data structure. This algorithm is derived from Cormen,
 * et al., "Introduction to Algorithms". The basic idea of a min-priority
 * queue is that you can efficiently (in O(1) time) get the smallest key in
 * the queue. Adding and removing elements takes O(log n) time. A key can
 * have its priority decreased in O(log n) time.
 */ function $45d10863bd1362e9$var$PriorityQueue() {
    this._arr = [];
    this._keyIndices = {};
}
/**
 * Returns the number of elements in the queue. Takes `O(1)` time.
 */ $45d10863bd1362e9$var$PriorityQueue.prototype.size = function() {
    return this._arr.length;
};
/**
 * Returns the keys that are in the queue. Takes `O(n)` time.
 */ $45d10863bd1362e9$var$PriorityQueue.prototype.keys = function() {
    return this._arr.map(function(x) {
        return x.key;
    });
};
/**
 * Returns `true` if **key** is in the queue and `false` if not.
 */ $45d10863bd1362e9$var$PriorityQueue.prototype.has = function(key) {
    return $dOCPl.has(this._keyIndices, key);
};
/**
 * Returns the priority for **key**. If **key** is not present in the queue
 * then this function returns `undefined`. Takes `O(1)` time.
 *
 * @param {Object} key
 */ $45d10863bd1362e9$var$PriorityQueue.prototype.priority = function(key) {
    var index = this._keyIndices[key];
    if (index !== undefined) return this._arr[index].priority;
};
/**
 * Returns the key for the minimum element in this queue. If the queue is
 * empty this function throws an Error. Takes `O(1)` time.
 */ $45d10863bd1362e9$var$PriorityQueue.prototype.min = function() {
    if (this.size() === 0) throw new Error("Queue underflow");
    return this._arr[0].key;
};
/**
 * Inserts a new key into the priority queue. If the key already exists in
 * the queue this function returns `false`; otherwise it will return `true`.
 * Takes `O(n)` time.
 *
 * @param {Object} key the key to add
 * @param {Number} priority the initial priority for the key
 */ $45d10863bd1362e9$var$PriorityQueue.prototype.add = function(key, priority) {
    var keyIndices = this._keyIndices;
    key = String(key);
    if (!$dOCPl.has(keyIndices, key)) {
        var arr = this._arr;
        var index = arr.length;
        keyIndices[key] = index;
        arr.push({
            key: key,
            priority: priority
        });
        this._decrease(index);
        return true;
    }
    return false;
};
/**
 * Removes and returns the smallest key in the queue. Takes `O(log n)` time.
 */ $45d10863bd1362e9$var$PriorityQueue.prototype.removeMin = function() {
    this._swap(0, this._arr.length - 1);
    var min = this._arr.pop();
    delete this._keyIndices[min.key];
    this._heapify(0);
    return min.key;
};
/**
 * Decreases the priority for **key** to **priority**. If the new priority is
 * greater than the previous priority, this function will throw an Error.
 *
 * @param {Object} key the key for which to raise priority
 * @param {Number} priority the new priority for the key
 */ $45d10863bd1362e9$var$PriorityQueue.prototype.decrease = function(key, priority) {
    var index = this._keyIndices[key];
    if (priority > this._arr[index].priority) throw new Error("New priority is greater than current priority. Key: " + key + " Old: " + this._arr[index].priority + " New: " + priority);
    this._arr[index].priority = priority;
    this._decrease(index);
};
$45d10863bd1362e9$var$PriorityQueue.prototype._heapify = function(i) {
    var arr = this._arr;
    var l = 2 * i;
    var r = l + 1;
    var largest = i;
    if (l < arr.length) {
        largest = arr[l].priority < arr[largest].priority ? l : largest;
        if (r < arr.length) largest = arr[r].priority < arr[largest].priority ? r : largest;
        if (largest !== i) {
            this._swap(i, largest);
            this._heapify(largest);
        }
    }
};
$45d10863bd1362e9$var$PriorityQueue.prototype._decrease = function(index) {
    var arr = this._arr;
    var priority = arr[index].priority;
    var parent;
    while(index !== 0){
        parent = index >> 1;
        if (arr[parent].priority < priority) break;
        this._swap(index, parent);
        index = parent;
    }
};
$45d10863bd1362e9$var$PriorityQueue.prototype._swap = function(i, j) {
    var arr = this._arr;
    var keyIndices = this._keyIndices;
    var origArrI = arr[i];
    var origArrJ = arr[j];
    arr[i] = origArrJ;
    arr[j] = origArrI;
    keyIndices[origArrJ.key] = i;
    keyIndices[origArrI.key] = j;
};

});


parcelRegister("3uso6", function(module, exports) {

var $a8y4J = parcelRequire("a8y4J");

var $dOCPl = parcelRequire("dOCPl");
module.exports = $28aa31ab5a3c320e$var$dijkstraAll;
function $28aa31ab5a3c320e$var$dijkstraAll(g, weightFunc, edgeFunc) {
    return $dOCPl.transform(g.nodes(), function(acc, v) {
        acc[v] = $a8y4J(g, v, weightFunc, edgeFunc);
    }, {});
}

});

parcelRegister("6pFca", function(module, exports) {

var $dOCPl = parcelRequire("dOCPl");

var $38Zd5 = parcelRequire("38Zd5");
module.exports = $4ab50861b5d77a2b$var$findCycles;
function $4ab50861b5d77a2b$var$findCycles(g) {
    return $dOCPl.filter($38Zd5(g), function(cmpt) {
        return cmpt.length > 1 || cmpt.length === 1 && g.hasEdge(cmpt[0], cmpt[0]);
    });
}

});
parcelRegister("38Zd5", function(module, exports) {

var $dOCPl = parcelRequire("dOCPl");
module.exports = $24a1997f93a076e1$var$tarjan;
function $24a1997f93a076e1$var$tarjan(g) {
    var index = 0;
    var stack = [];
    var visited = {}; // node id -> { onStack, lowlink, index }
    var results = [];
    function dfs(v) {
        var entry = visited[v] = {
            onStack: true,
            lowlink: index,
            index: index++
        };
        stack.push(v);
        g.successors(v).forEach(function(w) {
            if (!$dOCPl.has(visited, w)) {
                dfs(w);
                entry.lowlink = Math.min(entry.lowlink, visited[w].lowlink);
            } else if (visited[w].onStack) entry.lowlink = Math.min(entry.lowlink, visited[w].index);
        });
        if (entry.lowlink === entry.index) {
            var cmpt = [];
            var w;
            do {
                w = stack.pop();
                visited[w].onStack = false;
                cmpt.push(w);
            }while (v !== w);
            results.push(cmpt);
        }
    }
    g.nodes().forEach(function(v) {
        if (!$dOCPl.has(visited, v)) dfs(v);
    });
    return results;
}

});


parcelRegister("2yn2B", function(module, exports) {

var $dOCPl = parcelRequire("dOCPl");
module.exports = $1dc0a13696a98e60$var$floydWarshall;
var $1dc0a13696a98e60$var$DEFAULT_WEIGHT_FUNC = $dOCPl.constant(1);
function $1dc0a13696a98e60$var$floydWarshall(g, weightFn, edgeFn) {
    return $1dc0a13696a98e60$var$runFloydWarshall(g, weightFn || $1dc0a13696a98e60$var$DEFAULT_WEIGHT_FUNC, edgeFn || function(v) {
        return g.outEdges(v);
    });
}
function $1dc0a13696a98e60$var$runFloydWarshall(g, weightFn, edgeFn) {
    var results = {};
    var nodes = g.nodes();
    nodes.forEach(function(v) {
        results[v] = {};
        results[v][v] = {
            distance: 0
        };
        nodes.forEach(function(w) {
            if (v !== w) results[v][w] = {
                distance: Number.POSITIVE_INFINITY
            };
        });
        edgeFn(v).forEach(function(edge) {
            var w = edge.v === v ? edge.w : edge.v;
            var d = weightFn(edge);
            results[v][w] = {
                distance: d,
                predecessor: v
            };
        });
    });
    nodes.forEach(function(k) {
        var rowK = results[k];
        nodes.forEach(function(i) {
            var rowI = results[i];
            nodes.forEach(function(j) {
                var ik = rowI[k];
                var kj = rowK[j];
                var ij = rowI[j];
                var altDistance = ik.distance + kj.distance;
                if (altDistance < ij.distance) {
                    ij.distance = altDistance;
                    ij.predecessor = kj.predecessor;
                }
            });
        });
    });
    return results;
}

});

parcelRegister("3hBSd", function(module, exports) {

var $8UkLw = parcelRequire("8UkLw");
module.exports = $2640567c8b029db9$var$isAcyclic;
function $2640567c8b029db9$var$isAcyclic(g) {
    try {
        $8UkLw(g);
    } catch (e) {
        if (e instanceof $8UkLw.CycleException) return false;
        throw e;
    }
    return true;
}

});
parcelRegister("8UkLw", function(module, exports) {

var $dOCPl = parcelRequire("dOCPl");
module.exports = $67c3a94e2e06a874$var$topsort;
$67c3a94e2e06a874$var$topsort.CycleException = $67c3a94e2e06a874$var$CycleException;
function $67c3a94e2e06a874$var$topsort(g) {
    var visited = {};
    var stack = {};
    var results = [];
    function visit(node) {
        if ($dOCPl.has(stack, node)) throw new $67c3a94e2e06a874$var$CycleException();
        if (!$dOCPl.has(visited, node)) {
            stack[node] = true;
            visited[node] = true;
            $dOCPl.each(g.predecessors(node), visit);
            delete stack[node];
            results.push(node);
        }
    }
    $dOCPl.each(g.sinks(), visit);
    if ($dOCPl.size(visited) !== g.nodeCount()) throw new $67c3a94e2e06a874$var$CycleException();
    return results;
}
function $67c3a94e2e06a874$var$CycleException() {}
$67c3a94e2e06a874$var$CycleException.prototype = new Error(); // must be an instance of Error to pass testing

});


parcelRegister("dX1tj", function(module, exports) {

var $aCKt6 = parcelRequire("aCKt6");
module.exports = $a281ed51bb559346$var$postorder;
function $a281ed51bb559346$var$postorder(g, vs) {
    return $aCKt6(g, vs, "post");
}

});
parcelRegister("aCKt6", function(module, exports) {

var $dOCPl = parcelRequire("dOCPl");
module.exports = $7bc17fabfc4c38ec$var$dfs;
/*
 * A helper that preforms a pre- or post-order traversal on the input graph
 * and returns the nodes in the order they were visited. If the graph is
 * undirected then this algorithm will navigate using neighbors. If the graph
 * is directed then this algorithm will navigate using successors.
 *
 * Order must be one of "pre" or "post".
 */ function $7bc17fabfc4c38ec$var$dfs(g, vs, order) {
    if (!$dOCPl.isArray(vs)) vs = [
        vs
    ];
    var navigation = (g.isDirected() ? g.successors : g.neighbors).bind(g);
    var acc = [];
    var visited = {};
    $dOCPl.each(vs, function(v) {
        if (!g.hasNode(v)) throw new Error("Graph does not have node: " + v);
        $7bc17fabfc4c38ec$var$doDfs(g, v, order === "post", visited, navigation, acc);
    });
    return acc;
}
function $7bc17fabfc4c38ec$var$doDfs(g, v, postorder, visited, navigation, acc) {
    if (!$dOCPl.has(visited, v)) {
        visited[v] = true;
        if (!postorder) acc.push(v);
        $dOCPl.each(navigation(v), function(w) {
            $7bc17fabfc4c38ec$var$doDfs(g, w, postorder, visited, navigation, acc);
        });
        if (postorder) acc.push(v);
    }
}

});


parcelRegister("e890l", function(module, exports) {

var $aCKt6 = parcelRequire("aCKt6");
module.exports = $a498cc2fcabcfc22$var$preorder;
function $a498cc2fcabcfc22$var$preorder(g, vs) {
    return $aCKt6(g, vs, "pre");
}

});

parcelRegister("ifTuH", function(module, exports) {

var $dOCPl = parcelRequire("dOCPl");

var $4JZcb = parcelRequire("4JZcb");

var $5ZDax = parcelRequire("5ZDax");
module.exports = $d4a4acb6cacbea91$var$prim;
function $d4a4acb6cacbea91$var$prim(g, weightFunc) {
    var result = new $4JZcb();
    var parents = {};
    var pq = new $5ZDax();
    var v;
    function updateNeighbors(edge) {
        var w = edge.v === v ? edge.w : edge.v;
        var pri = pq.priority(w);
        if (pri !== undefined) {
            var edgeWeight = weightFunc(edge);
            if (edgeWeight < pri) {
                parents[w] = v;
                pq.decrease(w, edgeWeight);
            }
        }
    }
    if (g.nodeCount() === 0) return result;
    $dOCPl.each(g.nodes(), function(v) {
        pq.add(v, Number.POSITIVE_INFINITY);
        result.setNode(v);
    });
    // Start from an arbitrary node
    pq.decrease(g.nodes()[0], 0);
    var init = false;
    while(pq.size() > 0){
        v = pq.removeMin();
        if ($dOCPl.has(parents, v)) result.setEdge(v, parents[v]);
        else if (init) throw new Error("Input graph is not connected: " + g);
        else init = true;
        g.nodeEdges(v).forEach(updateNeighbors);
    }
    return result;
}

});




parcelRegister("VZEn7", function(module, exports) {
"use strict";

var $bqfL5 = parcelRequire("bqfL5");

var $61rsw = parcelRequire("61rsw");

var $fi6eg = parcelRequire("fi6eg");

var $hv32p = parcelRequire("hv32p");

var $1kMKg = parcelRequire("1kMKg");
var $0ae5256c4a1477f2$require$normalizeRanks = $1kMKg.normalizeRanks;

var $eBG2O = parcelRequire("eBG2O");

var $1kMKg = parcelRequire("1kMKg");
var $0ae5256c4a1477f2$require$removeEmptyRanks = $1kMKg.removeEmptyRanks;

var $YdQc0 = parcelRequire("YdQc0");

var $fSZns = parcelRequire("fSZns");

var $lWVsJ = parcelRequire("lWVsJ");

var $3dyGB = parcelRequire("3dyGB");

var $j257S = parcelRequire("j257S");

var $1kMKg = parcelRequire("1kMKg");

var $6mwJ2 = parcelRequire("6mwJ2");
var $0ae5256c4a1477f2$require$Graph = $6mwJ2.Graph;
module.exports = $0ae5256c4a1477f2$var$layout;
function $0ae5256c4a1477f2$var$layout(g, opts) {
    var time = opts && opts.debugTiming ? $1kMKg.time : $1kMKg.notime;
    time("layout", function() {
        var layoutGraph = time("  buildLayoutGraph", function() {
            return $0ae5256c4a1477f2$var$buildLayoutGraph(g);
        });
        time("  runLayout", function() {
            $0ae5256c4a1477f2$var$runLayout(layoutGraph, time);
        });
        time("  updateInputGraph", function() {
            $0ae5256c4a1477f2$var$updateInputGraph(g, layoutGraph);
        });
    });
}
function $0ae5256c4a1477f2$var$runLayout(g, time) {
    time("    makeSpaceForEdgeLabels", function() {
        $0ae5256c4a1477f2$var$makeSpaceForEdgeLabels(g);
    });
    time("    removeSelfEdges", function() {
        $0ae5256c4a1477f2$var$removeSelfEdges(g);
    });
    time("    acyclic", function() {
        $61rsw.run(g);
    });
    time("    nestingGraph.run", function() {
        $YdQc0.run(g);
    });
    time("    rank", function() {
        $hv32p($1kMKg.asNonCompoundGraph(g));
    });
    time("    injectEdgeLabelProxies", function() {
        $0ae5256c4a1477f2$var$injectEdgeLabelProxies(g);
    });
    time("    removeEmptyRanks", function() {
        $0ae5256c4a1477f2$require$removeEmptyRanks(g);
    });
    time("    nestingGraph.cleanup", function() {
        $YdQc0.cleanup(g);
    });
    time("    normalizeRanks", function() {
        $0ae5256c4a1477f2$require$normalizeRanks(g);
    });
    time("    assignRankMinMax", function() {
        $0ae5256c4a1477f2$var$assignRankMinMax(g);
    });
    time("    removeEdgeLabelProxies", function() {
        $0ae5256c4a1477f2$var$removeEdgeLabelProxies(g);
    });
    time("    normalize.run", function() {
        $fi6eg.run(g);
    });
    time("    parentDummyChains", function() {
        $eBG2O(g);
    });
    time("    addBorderSegments", function() {
        $fSZns(g);
    });
    time("    order", function() {
        $3dyGB(g);
    });
    time("    insertSelfEdges", function() {
        $0ae5256c4a1477f2$var$insertSelfEdges(g);
    });
    time("    adjustCoordinateSystem", function() {
        $lWVsJ.adjust(g);
    });
    time("    position", function() {
        $j257S(g);
    });
    time("    positionSelfEdges", function() {
        $0ae5256c4a1477f2$var$positionSelfEdges(g);
    });
    time("    removeBorderNodes", function() {
        $0ae5256c4a1477f2$var$removeBorderNodes(g);
    });
    time("    normalize.undo", function() {
        $fi6eg.undo(g);
    });
    time("    fixupEdgeLabelCoords", function() {
        $0ae5256c4a1477f2$var$fixupEdgeLabelCoords(g);
    });
    time("    undoCoordinateSystem", function() {
        $lWVsJ.undo(g);
    });
    time("    translateGraph", function() {
        $0ae5256c4a1477f2$var$translateGraph(g);
    });
    time("    assignNodeIntersects", function() {
        $0ae5256c4a1477f2$var$assignNodeIntersects(g);
    });
    time("    reversePoints", function() {
        $0ae5256c4a1477f2$var$reversePointsForReversedEdges(g);
    });
    time("    acyclic.undo", function() {
        $61rsw.undo(g);
    });
}
/*
 * Copies final layout information from the layout graph back to the input
 * graph. This process only copies whitelisted attributes from the layout graph
 * to the input graph, so it serves as a good place to determine what
 * attributes can influence layout.
 */ function $0ae5256c4a1477f2$var$updateInputGraph(inputGraph, layoutGraph) {
    $bqfL5.forEach(inputGraph.nodes(), function(v) {
        var inputLabel = inputGraph.node(v);
        var layoutLabel = layoutGraph.node(v);
        if (inputLabel) {
            inputLabel.x = layoutLabel.x;
            inputLabel.y = layoutLabel.y;
            if (layoutGraph.children(v).length) {
                inputLabel.width = layoutLabel.width;
                inputLabel.height = layoutLabel.height;
            }
        }
    });
    $bqfL5.forEach(inputGraph.edges(), function(e) {
        var inputLabel = inputGraph.edge(e);
        var layoutLabel = layoutGraph.edge(e);
        inputLabel.points = layoutLabel.points;
        if ($bqfL5.has(layoutLabel, "x")) {
            inputLabel.x = layoutLabel.x;
            inputLabel.y = layoutLabel.y;
        }
    });
    inputGraph.graph().width = layoutGraph.graph().width;
    inputGraph.graph().height = layoutGraph.graph().height;
}
var $0ae5256c4a1477f2$var$graphNumAttrs = [
    "nodesep",
    "edgesep",
    "ranksep",
    "marginx",
    "marginy"
];
var $0ae5256c4a1477f2$var$graphDefaults = {
    ranksep: 50,
    edgesep: 20,
    nodesep: 50,
    rankdir: "tb"
};
var $0ae5256c4a1477f2$var$graphAttrs = [
    "acyclicer",
    "ranker",
    "rankdir",
    "align"
];
var $0ae5256c4a1477f2$var$nodeNumAttrs = [
    "width",
    "height"
];
var $0ae5256c4a1477f2$var$nodeDefaults = {
    width: 0,
    height: 0
};
var $0ae5256c4a1477f2$var$edgeNumAttrs = [
    "minlen",
    "weight",
    "width",
    "height",
    "labeloffset"
];
var $0ae5256c4a1477f2$var$edgeDefaults = {
    minlen: 1,
    weight: 1,
    width: 0,
    height: 0,
    labeloffset: 10,
    labelpos: "r"
};
var $0ae5256c4a1477f2$var$edgeAttrs = [
    "labelpos"
];
/*
 * Constructs a new graph from the input graph, which can be used for layout.
 * This process copies only whitelisted attributes from the input graph to the
 * layout graph. Thus this function serves as a good place to determine what
 * attributes can influence layout.
 */ function $0ae5256c4a1477f2$var$buildLayoutGraph(inputGraph) {
    var g = new $0ae5256c4a1477f2$require$Graph({
        multigraph: true,
        compound: true
    });
    var graph = $0ae5256c4a1477f2$var$canonicalize(inputGraph.graph());
    g.setGraph($bqfL5.merge({}, $0ae5256c4a1477f2$var$graphDefaults, $0ae5256c4a1477f2$var$selectNumberAttrs(graph, $0ae5256c4a1477f2$var$graphNumAttrs), $bqfL5.pick(graph, $0ae5256c4a1477f2$var$graphAttrs)));
    $bqfL5.forEach(inputGraph.nodes(), function(v) {
        var node = $0ae5256c4a1477f2$var$canonicalize(inputGraph.node(v));
        g.setNode(v, $bqfL5.defaults($0ae5256c4a1477f2$var$selectNumberAttrs(node, $0ae5256c4a1477f2$var$nodeNumAttrs), $0ae5256c4a1477f2$var$nodeDefaults));
        g.setParent(v, inputGraph.parent(v));
    });
    $bqfL5.forEach(inputGraph.edges(), function(e) {
        var edge = $0ae5256c4a1477f2$var$canonicalize(inputGraph.edge(e));
        g.setEdge(e, $bqfL5.merge({}, $0ae5256c4a1477f2$var$edgeDefaults, $0ae5256c4a1477f2$var$selectNumberAttrs(edge, $0ae5256c4a1477f2$var$edgeNumAttrs), $bqfL5.pick(edge, $0ae5256c4a1477f2$var$edgeAttrs)));
    });
    return g;
}
/*
 * This idea comes from the Gansner paper: to account for edge labels in our
 * layout we split each rank in half by doubling minlen and halving ranksep.
 * Then we can place labels at these mid-points between nodes.
 *
 * We also add some minimal padding to the width to push the label for the edge
 * away from the edge itself a bit.
 */ function $0ae5256c4a1477f2$var$makeSpaceForEdgeLabels(g) {
    var graph = g.graph();
    graph.ranksep /= 2;
    $bqfL5.forEach(g.edges(), function(e) {
        var edge = g.edge(e);
        edge.minlen *= 2;
        if (edge.labelpos.toLowerCase() !== "c") {
            if (graph.rankdir === "TB" || graph.rankdir === "BT") edge.width += edge.labeloffset;
            else edge.height += edge.labeloffset;
        }
    });
}
/*
 * Creates temporary dummy nodes that capture the rank in which each edge's
 * label is going to, if it has one of non-zero width and height. We do this
 * so that we can safely remove empty ranks while preserving balance for the
 * label's position.
 */ function $0ae5256c4a1477f2$var$injectEdgeLabelProxies(g) {
    $bqfL5.forEach(g.edges(), function(e) {
        var edge = g.edge(e);
        if (edge.width && edge.height) {
            var v = g.node(e.v);
            var w = g.node(e.w);
            var label = {
                rank: (w.rank - v.rank) / 2 + v.rank,
                e: e
            };
            $1kMKg.addDummyNode(g, "edge-proxy", label, "_ep");
        }
    });
}
function $0ae5256c4a1477f2$var$assignRankMinMax(g) {
    var maxRank = 0;
    $bqfL5.forEach(g.nodes(), function(v) {
        var node = g.node(v);
        if (node.borderTop) {
            node.minRank = g.node(node.borderTop).rank;
            node.maxRank = g.node(node.borderBottom).rank;
            maxRank = $bqfL5.max(maxRank, node.maxRank);
        }
    });
    g.graph().maxRank = maxRank;
}
function $0ae5256c4a1477f2$var$removeEdgeLabelProxies(g) {
    $bqfL5.forEach(g.nodes(), function(v) {
        var node = g.node(v);
        if (node.dummy === "edge-proxy") {
            g.edge(node.e).labelRank = node.rank;
            g.removeNode(v);
        }
    });
}
function $0ae5256c4a1477f2$var$translateGraph(g) {
    var minX = Number.POSITIVE_INFINITY;
    var maxX = 0;
    var minY = Number.POSITIVE_INFINITY;
    var maxY = 0;
    var graphLabel = g.graph();
    var marginX = graphLabel.marginx || 0;
    var marginY = graphLabel.marginy || 0;
    function getExtremes(attrs) {
        var x = attrs.x;
        var y = attrs.y;
        var w = attrs.width;
        var h = attrs.height;
        minX = Math.min(minX, x - w / 2);
        maxX = Math.max(maxX, x + w / 2);
        minY = Math.min(minY, y - h / 2);
        maxY = Math.max(maxY, y + h / 2);
    }
    $bqfL5.forEach(g.nodes(), function(v) {
        getExtremes(g.node(v));
    });
    $bqfL5.forEach(g.edges(), function(e) {
        var edge = g.edge(e);
        if ($bqfL5.has(edge, "x")) getExtremes(edge);
    });
    minX -= marginX;
    minY -= marginY;
    $bqfL5.forEach(g.nodes(), function(v) {
        var node = g.node(v);
        node.x -= minX;
        node.y -= minY;
    });
    $bqfL5.forEach(g.edges(), function(e) {
        var edge = g.edge(e);
        $bqfL5.forEach(edge.points, function(p) {
            p.x -= minX;
            p.y -= minY;
        });
        if ($bqfL5.has(edge, "x")) edge.x -= minX;
        if ($bqfL5.has(edge, "y")) edge.y -= minY;
    });
    graphLabel.width = maxX - minX + marginX;
    graphLabel.height = maxY - minY + marginY;
}
function $0ae5256c4a1477f2$var$assignNodeIntersects(g) {
    $bqfL5.forEach(g.edges(), function(e) {
        var edge = g.edge(e);
        var nodeV = g.node(e.v);
        var nodeW = g.node(e.w);
        var p1, p2;
        if (!edge.points) {
            edge.points = [];
            p1 = nodeW;
            p2 = nodeV;
        } else {
            p1 = edge.points[0];
            p2 = edge.points[edge.points.length - 1];
        }
        edge.points.unshift($1kMKg.intersectRect(nodeV, p1));
        edge.points.push($1kMKg.intersectRect(nodeW, p2));
    });
}
function $0ae5256c4a1477f2$var$fixupEdgeLabelCoords(g) {
    $bqfL5.forEach(g.edges(), function(e) {
        var edge = g.edge(e);
        if ($bqfL5.has(edge, "x")) {
            if (edge.labelpos === "l" || edge.labelpos === "r") edge.width -= edge.labeloffset;
            switch(edge.labelpos){
                case "l":
                    edge.x -= edge.width / 2 + edge.labeloffset;
                    break;
                case "r":
                    edge.x += edge.width / 2 + edge.labeloffset;
                    break;
            }
        }
    });
}
function $0ae5256c4a1477f2$var$reversePointsForReversedEdges(g) {
    $bqfL5.forEach(g.edges(), function(e) {
        var edge = g.edge(e);
        if (edge.reversed) edge.points.reverse();
    });
}
function $0ae5256c4a1477f2$var$removeBorderNodes(g) {
    $bqfL5.forEach(g.nodes(), function(v) {
        if (g.children(v).length) {
            var node = g.node(v);
            var t = g.node(node.borderTop);
            var b = g.node(node.borderBottom);
            var l = g.node($bqfL5.last(node.borderLeft));
            var r = g.node($bqfL5.last(node.borderRight));
            node.width = Math.abs(r.x - l.x);
            node.height = Math.abs(b.y - t.y);
            node.x = l.x + node.width / 2;
            node.y = t.y + node.height / 2;
        }
    });
    $bqfL5.forEach(g.nodes(), function(v) {
        if (g.node(v).dummy === "border") g.removeNode(v);
    });
}
function $0ae5256c4a1477f2$var$removeSelfEdges(g) {
    $bqfL5.forEach(g.edges(), function(e) {
        if (e.v === e.w) {
            var node = g.node(e.v);
            if (!node.selfEdges) node.selfEdges = [];
            node.selfEdges.push({
                e: e,
                label: g.edge(e)
            });
            g.removeEdge(e);
        }
    });
}
function $0ae5256c4a1477f2$var$insertSelfEdges(g) {
    var layers = $1kMKg.buildLayerMatrix(g);
    $bqfL5.forEach(layers, function(layer) {
        var orderShift = 0;
        $bqfL5.forEach(layer, function(v, i) {
            var node = g.node(v);
            node.order = i + orderShift;
            $bqfL5.forEach(node.selfEdges, function(selfEdge) {
                $1kMKg.addDummyNode(g, "selfedge", {
                    width: selfEdge.label.width,
                    height: selfEdge.label.height,
                    rank: node.rank,
                    order: i + ++orderShift,
                    e: selfEdge.e,
                    label: selfEdge.label
                }, "_se");
            });
            delete node.selfEdges;
        });
    });
}
function $0ae5256c4a1477f2$var$positionSelfEdges(g) {
    $bqfL5.forEach(g.nodes(), function(v) {
        var node = g.node(v);
        if (node.dummy === "selfedge") {
            var selfNode = g.node(node.e.v);
            var x = selfNode.x + selfNode.width / 2;
            var y = selfNode.y;
            var dx = node.x - x;
            var dy = selfNode.height / 2;
            g.setEdge(node.e, node.label);
            g.removeNode(v);
            node.label.points = [
                {
                    x: x + 2 * dx / 3,
                    y: y - dy
                },
                {
                    x: x + 5 * dx / 6,
                    y: y - dy
                },
                {
                    x: x + dx,
                    y: y
                },
                {
                    x: x + 5 * dx / 6,
                    y: y + dy
                },
                {
                    x: x + 2 * dx / 3,
                    y: y + dy
                }
            ];
            node.label.x = node.x;
            node.label.y = node.y;
        }
    });
}
function $0ae5256c4a1477f2$var$selectNumberAttrs(obj, attrs) {
    return $bqfL5.mapValues($bqfL5.pick(obj, attrs), Number);
}
function $0ae5256c4a1477f2$var$canonicalize(attrs) {
    var newAttrs = {};
    $bqfL5.forEach(attrs, function(v, k) {
        newAttrs[k.toLowerCase()] = v;
    });
    return newAttrs;
}

});
parcelRegister("bqfL5", function(module, exports) {
/* global window */ var $850e58b67514fb74$var$lodash;


























try {
    $850e58b67514fb74$var$lodash = {
        cloneDeep: (parcelRequire("iGQLm")),
        constant: (parcelRequire("9HRmE")),
        defaults: (parcelRequire("1SWLj")),
        each: (parcelRequire("5kE3T")),
        filter: (parcelRequire("jLJR7")),
        find: (parcelRequire("8I8e5")),
        flatten: (parcelRequire("20Rgr")),
        forEach: (parcelRequire("iWSff")),
        forIn: (parcelRequire("jojmF")),
        has: (parcelRequire("jplJt")),
        isUndefined: (parcelRequire("enrJD")),
        last: (parcelRequire("hkfXi")),
        map: (parcelRequire("437iZ")),
        mapValues: (parcelRequire("1Z7cU")),
        max: (parcelRequire("aK6kk")),
        merge: (parcelRequire("5W3lT")),
        min: (parcelRequire("3Ne9k")),
        minBy: (parcelRequire("5oTLF")),
        now: (parcelRequire("9nn6T")),
        pick: (parcelRequire("12eN8")),
        range: (parcelRequire("fpRwA")),
        reduce: (parcelRequire("2KuAh")),
        sortBy: (parcelRequire("47O2q")),
        uniqueId: (parcelRequire("g0ikZ")),
        values: (parcelRequire("7D6Gq")),
        zipObject: (parcelRequire("d0lTW"))
    };
} catch (e) {
// continue regardless of error
}
if (!$850e58b67514fb74$var$lodash) $850e58b67514fb74$var$lodash = window._;
module.exports = $850e58b67514fb74$var$lodash;

});
parcelRegister("iGQLm", function(module, exports) {

var $kqX4j = parcelRequire("kqX4j");
/** Used to compose bitmasks for cloning. */ var $d9b513d63d79678d$var$CLONE_DEEP_FLAG = 1, $d9b513d63d79678d$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $d9b513d63d79678d$var$cloneDeep(value) {
    return $kqX4j(value, $d9b513d63d79678d$var$CLONE_DEEP_FLAG | $d9b513d63d79678d$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $d9b513d63d79678d$var$cloneDeep;

});

parcelRegister("1SWLj", function(module, exports) {

var $5iyRF = parcelRequire("5iyRF");

var $6TC8i = parcelRequire("6TC8i");

var $b8mN0 = parcelRequire("b8mN0");

var $f4lqP = parcelRequire("f4lqP");
/** Used for built-in method references. */ var $15f86a7fdfb0f225$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $15f86a7fdfb0f225$var$hasOwnProperty = $15f86a7fdfb0f225$var$objectProto.hasOwnProperty;
/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */ var $15f86a7fdfb0f225$var$defaults = $5iyRF(function(object, sources) {
    object = Object(object);
    var index = -1;
    var length = sources.length;
    var guard = length > 2 ? sources[2] : undefined;
    if (guard && $b8mN0(sources[0], sources[1], guard)) length = 1;
    while(++index < length){
        var source = sources[index];
        var props = $f4lqP(source);
        var propsIndex = -1;
        var propsLength = props.length;
        while(++propsIndex < propsLength){
            var key = props[propsIndex];
            var value = object[key];
            if (value === undefined || $6TC8i(value, $15f86a7fdfb0f225$var$objectProto[key]) && !$15f86a7fdfb0f225$var$hasOwnProperty.call(object, key)) object[key] = source[key];
        }
    }
    return object;
});
module.exports = $15f86a7fdfb0f225$var$defaults;

});
parcelRegister("b8mN0", function(module, exports) {

var $6TC8i = parcelRequire("6TC8i");

var $eMthh = parcelRequire("eMthh");

var $iyUuu = parcelRequire("iyUuu");

var $lsJ54 = parcelRequire("lsJ54");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $81b21e8b41d211e8$var$isIterateeCall(value, index, object) {
    if (!$lsJ54(object)) return false;
    var type = typeof index;
    if (type == 'number' ? $eMthh(object) && $iyUuu(index, object.length) : type == 'string' && index in object) return $6TC8i(object[index], value);
    return false;
}
module.exports = $81b21e8b41d211e8$var$isIterateeCall;

});


parcelRegister("8I8e5", function(module, exports) {

var $ePhxS = parcelRequire("ePhxS");

var $cpmrH = parcelRequire("cpmrH");
/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $6578d05764c8afc8$var$find = $ePhxS($cpmrH);
module.exports = $6578d05764c8afc8$var$find;

});
parcelRegister("ePhxS", function(module, exports) {

var $7MWok = parcelRequire("7MWok");

var $eMthh = parcelRequire("eMthh");

var $LAMcS = parcelRequire("LAMcS");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $acb3703f94fb96ce$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$eMthh(collection)) {
            var iteratee = $7MWok(predicate, 3);
            collection = $LAMcS(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
module.exports = $acb3703f94fb96ce$var$createFind;

});

parcelRegister("cpmrH", function(module, exports) {

var $eAor6 = parcelRequire("eAor6");

var $7MWok = parcelRequire("7MWok");

var $2MGGR = parcelRequire("2MGGR");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $90893b1abc59631b$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $90893b1abc59631b$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $2MGGR(fromIndex);
    if (index < 0) index = $90893b1abc59631b$var$nativeMax(length + index, 0);
    return $eAor6(array, $7MWok(predicate, 3), index);
}
module.exports = $90893b1abc59631b$var$findIndex;

});
parcelRegister("2MGGR", function(module, exports) {

var $9lLgO = parcelRequire("9lLgO");
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $20712de2064d78dd$var$toInteger(value) {
    var result = $9lLgO(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
module.exports = $20712de2064d78dd$var$toInteger;

});
parcelRegister("9lLgO", function(module, exports) {

var $iV4PZ = parcelRequire("iV4PZ");
/** Used as references for various `Number` constants. */ var $6ceabe126a95a54e$var$INFINITY = 1 / 0, $6ceabe126a95a54e$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $6ceabe126a95a54e$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $iV4PZ(value);
    if (value === $6ceabe126a95a54e$var$INFINITY || value === -$6ceabe126a95a54e$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $6ceabe126a95a54e$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
module.exports = $6ceabe126a95a54e$var$toFinite;

});
parcelRegister("iV4PZ", function(module, exports) {

var $s0iWz = parcelRequire("s0iWz");

var $lsJ54 = parcelRequire("lsJ54");

var $9dr3u = parcelRequire("9dr3u");
/** Used as references for various `Number` constants. */ var $dc614d828223dea6$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $dc614d828223dea6$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $dc614d828223dea6$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $dc614d828223dea6$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $dc614d828223dea6$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $dc614d828223dea6$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($9dr3u(value)) return $dc614d828223dea6$var$NAN;
    if ($lsJ54(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $lsJ54(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $s0iWz(value);
    var isBinary = $dc614d828223dea6$var$reIsBinary.test(value);
    return isBinary || $dc614d828223dea6$var$reIsOctal.test(value) ? $dc614d828223dea6$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $dc614d828223dea6$var$reIsBadHex.test(value) ? $dc614d828223dea6$var$NAN : +value;
}
module.exports = $dc614d828223dea6$var$toNumber;

});
parcelRegister("s0iWz", function(module, exports) {

var $kzo8D = parcelRequire("kzo8D");
/** Used to match leading whitespace. */ var $0542da1d887b1c4d$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $0542da1d887b1c4d$var$baseTrim(string) {
    return string ? string.slice(0, $kzo8D(string) + 1).replace($0542da1d887b1c4d$var$reTrimStart, '') : string;
}
module.exports = $0542da1d887b1c4d$var$baseTrim;

});
parcelRegister("kzo8D", function(module, exports) {
/** Used to match a single whitespace character. */ var $ef99cce288c7323e$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $ef99cce288c7323e$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $ef99cce288c7323e$var$reWhitespace.test(string.charAt(index)));
    return index;
}
module.exports = $ef99cce288c7323e$var$trimmedEndIndex;

});







parcelRegister("20Rgr", function(module, exports) {

var $fgBHx = parcelRequire("fgBHx");
/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $1774e6065e7ade58$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $fgBHx(array, 1) : [];
}
module.exports = $1774e6065e7ade58$var$flatten;

});

parcelRegister("jojmF", function(module, exports) {

var $dEvx9 = parcelRequire("dEvx9");

var $4c8Zb = parcelRequire("4c8Zb");

var $f4lqP = parcelRequire("f4lqP");
/**
 * Iterates over own and inherited enumerable string keyed properties of an
 * object and invokes `iteratee` for each property. The iteratee is invoked
 * with three arguments: (value, key, object). Iteratee functions may exit
 * iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forInRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forIn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
 */ function $e1df479b00a6084f$var$forIn(object, iteratee) {
    return object == null ? object : $dEvx9(object, $4c8Zb(iteratee), $f4lqP);
}
module.exports = $e1df479b00a6084f$var$forIn;

});

parcelRegister("hkfXi", function(module, exports) {
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $c9d0ae50fd1d1372$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
module.exports = $c9d0ae50fd1d1372$var$last;

});

parcelRegister("1Z7cU", function(module, exports) {

var $cWbJD = parcelRequire("cWbJD");

var $4xK4A = parcelRequire("4xK4A");

var $7MWok = parcelRequire("7MWok");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $17211428bc2045c4$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $7MWok(iteratee, 3);
    $4xK4A(object, function(value, key, object) {
        $cWbJD(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = $17211428bc2045c4$var$mapValues;

});

parcelRegister("aK6kk", function(module, exports) {

var $gv3JG = parcelRequire("gv3JG");

var $iK245 = parcelRequire("iK245");

var $4Nq5y = parcelRequire("4Nq5y");
/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */ function $7d231ba5a67a42db$var$max(array) {
    return array && array.length ? $gv3JG(array, $4Nq5y, $iK245) : undefined;
}
module.exports = $7d231ba5a67a42db$var$max;

});
parcelRegister("gv3JG", function(module, exports) {

var $9dr3u = parcelRequire("9dr3u");
/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function $c032706da200ef36$var$baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !$9dr3u(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
module.exports = $c032706da200ef36$var$baseExtremum;

});

parcelRegister("iK245", function(module, exports) {
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */ function $da4e1fe5f8bd1939$var$baseGt(value, other) {
    return value > other;
}
module.exports = $da4e1fe5f8bd1939$var$baseGt;

});


parcelRegister("5W3lT", function(module, exports) {

var $4uZ7x = parcelRequire("4uZ7x");

var $i1jm6 = parcelRequire("i1jm6");
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $4524f833ae45779b$var$merge = $i1jm6(function(object, source, srcIndex) {
    $4uZ7x(object, source, srcIndex);
});
module.exports = $4524f833ae45779b$var$merge;

});
parcelRegister("4uZ7x", function(module, exports) {

var $g779E = parcelRequire("g779E");

var $7RXmv = parcelRequire("7RXmv");

var $dEvx9 = parcelRequire("dEvx9");

var $cTZHA = parcelRequire("cTZHA");

var $lsJ54 = parcelRequire("lsJ54");

var $f4lqP = parcelRequire("f4lqP");

var $1ys2O = parcelRequire("1ys2O");
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $34696005ed9b3f30$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    $dEvx9(source, function(srcValue, key) {
        stack || (stack = new $g779E);
        if ($lsJ54(srcValue)) $cTZHA(object, source, key, srcIndex, $34696005ed9b3f30$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer($1ys2O(object, key), srcValue, key + '', object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            $7RXmv(object, key, newValue);
        }
    }, $f4lqP);
}
module.exports = $34696005ed9b3f30$var$baseMerge;

});
parcelRegister("7RXmv", function(module, exports) {

var $cWbJD = parcelRequire("cWbJD");

var $6TC8i = parcelRequire("6TC8i");
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $5bab87b519c266a0$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !$6TC8i(object[key], value) || value === undefined && !(key in object)) $cWbJD(object, key, value);
}
module.exports = $5bab87b519c266a0$var$assignMergeValue;

});

parcelRegister("cTZHA", function(module, exports) {

var $7RXmv = parcelRequire("7RXmv");

var $uQ1Em = parcelRequire("uQ1Em");

var $5JAGM = parcelRequire("5JAGM");

var $aA0pv = parcelRequire("aA0pv");

var $dFJsF = parcelRequire("dFJsF");

var $aJD6g = parcelRequire("aJD6g");

var $o8HxT = parcelRequire("o8HxT");

var $jGP9B = parcelRequire("jGP9B");

var $f504n = parcelRequire("f504n");

var $01ubZ = parcelRequire("01ubZ");

var $lsJ54 = parcelRequire("lsJ54");

var $xMy82 = parcelRequire("xMy82");

var $1Q21n = parcelRequire("1Q21n");

var $1ys2O = parcelRequire("1ys2O");

var $kp2OI = parcelRequire("kp2OI");
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $964a7bd734d0fbad$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = $1ys2O(object, key), srcValue = $1ys2O(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        $7RXmv(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = $o8HxT(srcValue), isBuff = !isArr && $f504n(srcValue), isTyped = !isArr && !isBuff && $1Q21n(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ($o8HxT(objValue)) newValue = objValue;
            else if ($jGP9B(objValue)) newValue = $aA0pv(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = $uQ1Em(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = $5JAGM(srcValue, true);
            } else newValue = [];
        } else if ($xMy82(srcValue) || $aJD6g(srcValue)) {
            newValue = objValue;
            if ($aJD6g(objValue)) newValue = $kp2OI(objValue);
            else if (!$lsJ54(objValue) || $01ubZ(objValue)) newValue = $dFJsF(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    $7RXmv(object, key, newValue);
}
module.exports = $964a7bd734d0fbad$var$baseMergeDeep;

});
parcelRegister("xMy82", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $cdnOB = parcelRequire("cdnOB");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $0658be17f7793a43$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $0658be17f7793a43$var$funcProto = Function.prototype, $0658be17f7793a43$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $0658be17f7793a43$var$funcToString = $0658be17f7793a43$var$funcProto.toString;
/** Used to check objects for own properties. */ var $0658be17f7793a43$var$hasOwnProperty = $0658be17f7793a43$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $0658be17f7793a43$var$objectCtorString = $0658be17f7793a43$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $0658be17f7793a43$var$isPlainObject(value) {
    if (!$8l89S(value) || $eq6CV(value) != $0658be17f7793a43$var$objectTag) return false;
    var proto = $cdnOB(value);
    if (proto === null) return true;
    var Ctor = $0658be17f7793a43$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $0658be17f7793a43$var$funcToString.call(Ctor) == $0658be17f7793a43$var$objectCtorString;
}
module.exports = $0658be17f7793a43$var$isPlainObject;

});

parcelRegister("1ys2O", function(module, exports) {
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $121eb86ef7ce6b9c$var$safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') return;
    if (key == '__proto__') return;
    return object[key];
}
module.exports = $121eb86ef7ce6b9c$var$safeGet;

});

parcelRegister("kp2OI", function(module, exports) {

var $cYlGN = parcelRequire("cYlGN");

var $f4lqP = parcelRequire("f4lqP");
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $eda853de6b056001$var$toPlainObject(value) {
    return $cYlGN(value, $f4lqP(value));
}
module.exports = $eda853de6b056001$var$toPlainObject;

});



parcelRegister("i1jm6", function(module, exports) {

var $5iyRF = parcelRequire("5iyRF");

var $b8mN0 = parcelRequire("b8mN0");
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $d1e75591f556b111$var$createAssigner(assigner) {
    return $5iyRF(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && $b8mN0(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
module.exports = $d1e75591f556b111$var$createAssigner;

});


parcelRegister("3Ne9k", function(module, exports) {

var $gv3JG = parcelRequire("gv3JG");

var $hGcz8 = parcelRequire("hGcz8");

var $4Nq5y = parcelRequire("4Nq5y");
/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */ function $2c30ec7848ba160d$var$min(array) {
    return array && array.length ? $gv3JG(array, $4Nq5y, $hGcz8) : undefined;
}
module.exports = $2c30ec7848ba160d$var$min;

});
parcelRegister("hGcz8", function(module, exports) {
/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */ function $cdf01b2c29e1be9c$var$baseLt(value, other) {
    return value < other;
}
module.exports = $cdf01b2c29e1be9c$var$baseLt;

});


parcelRegister("5oTLF", function(module, exports) {

var $gv3JG = parcelRequire("gv3JG");

var $7MWok = parcelRequire("7MWok");

var $hGcz8 = parcelRequire("hGcz8");
/**
 * This method is like `_.min` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.minBy(objects, function(o) { return o.n; });
 * // => { 'n': 1 }
 *
 * // The `_.property` iteratee shorthand.
 * _.minBy(objects, 'n');
 * // => { 'n': 1 }
 */ function $3eea73fc544592fd$var$minBy(array, iteratee) {
    return array && array.length ? $gv3JG(array, $7MWok(iteratee, 2), $hGcz8) : undefined;
}
module.exports = $3eea73fc544592fd$var$minBy;

});

parcelRegister("9nn6T", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $6d38303b9c8735ba$var$now = function() {
    return $23YZo.Date.now();
};
module.exports = $6d38303b9c8735ba$var$now;

});

parcelRegister("12eN8", function(module, exports) {

var $1AWBt = parcelRequire("1AWBt");

var $8KK0w = parcelRequire("8KK0w");
/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $0c11739df3ac35ad$var$pick = $8KK0w(function(object, paths) {
    return object == null ? {} : $1AWBt(object, paths);
});
module.exports = $0c11739df3ac35ad$var$pick;

});
parcelRegister("1AWBt", function(module, exports) {

var $6IXDN = parcelRequire("6IXDN");

var $2VBx6 = parcelRequire("2VBx6");
/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $12969ca4851cc4ab$var$basePick(object, paths) {
    return $6IXDN(object, paths, function(value, path) {
        return $2VBx6(object, path);
    });
}
module.exports = $12969ca4851cc4ab$var$basePick;

});
parcelRegister("6IXDN", function(module, exports) {

var $lJEX1 = parcelRequire("lJEX1");

var $eJzCK = parcelRequire("eJzCK");

var $4RK0h = parcelRequire("4RK0h");
/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function $4e551d8e73f04819$var$basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = $lJEX1(object, path);
        if (predicate(value, path)) $eJzCK(result, $4RK0h(path, object), value);
    }
    return result;
}
module.exports = $4e551d8e73f04819$var$basePickBy;

});
parcelRegister("eJzCK", function(module, exports) {

var $5i71d = parcelRequire("5i71d");

var $4RK0h = parcelRequire("4RK0h");

var $iyUuu = parcelRequire("iyUuu");

var $lsJ54 = parcelRequire("lsJ54");

var $6DSvu = parcelRequire("6DSvu");
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $aba0e6d66e8d80dd$var$baseSet(object, path, value, customizer) {
    if (!$lsJ54(object)) return object;
    path = $4RK0h(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = $6DSvu(path[index]), newValue = value;
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = $lsJ54(objValue) ? objValue : $iyUuu(path[index + 1]) ? [] : {};
        }
        $5i71d(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
module.exports = $aba0e6d66e8d80dd$var$baseSet;

});



parcelRegister("8KK0w", function(module, exports) {

var $20Rgr = parcelRequire("20Rgr");

var $b86t6 = parcelRequire("b86t6");

var $iGMVy = parcelRequire("iGMVy");
/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $65f64eb9f31faa0d$var$flatRest(func) {
    return $iGMVy($b86t6(func, undefined, $20Rgr), func + '');
}
module.exports = $65f64eb9f31faa0d$var$flatRest;

});


parcelRegister("fpRwA", function(module, exports) {

var $hDGMd = parcelRequire("hDGMd");
/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var $b392b5b21038a0ce$var$range = $hDGMd();
module.exports = $b392b5b21038a0ce$var$range;

});
parcelRegister("hDGMd", function(module, exports) {

var $ia9lU = parcelRequire("ia9lU");

var $b8mN0 = parcelRequire("b8mN0");

var $9lLgO = parcelRequire("9lLgO");
/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function $cd7742b81dd96fb0$var$createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != 'number' && $b8mN0(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = $9lLgO(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = $9lLgO(end);
        step = step === undefined ? start < end ? 1 : -1 : $9lLgO(step);
        return $ia9lU(start, end, step, fromRight);
    };
}
module.exports = $cd7742b81dd96fb0$var$createRange;

});
parcelRegister("ia9lU", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $d3906a592348eb7a$var$nativeCeil = Math.ceil, $d3906a592348eb7a$var$nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function $d3906a592348eb7a$var$baseRange(start, end, step, fromRight) {
    var index = -1, length = $d3906a592348eb7a$var$nativeMax($d3906a592348eb7a$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
module.exports = $d3906a592348eb7a$var$baseRange;

});



parcelRegister("47O2q", function(module, exports) {

var $fgBHx = parcelRequire("fgBHx");

var $jrtNg = parcelRequire("jrtNg");

var $5iyRF = parcelRequire("5iyRF");

var $b8mN0 = parcelRequire("b8mN0");
/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $300ea168693086c2$var$sortBy = $5iyRF(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $b8mN0(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $b8mN0(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $jrtNg(collection, $fgBHx(iteratees, 1), []);
});
module.exports = $300ea168693086c2$var$sortBy;

});
parcelRegister("jrtNg", function(module, exports) {

var $i46jW = parcelRequire("i46jW");

var $lJEX1 = parcelRequire("lJEX1");

var $7MWok = parcelRequire("7MWok");

var $fDc61 = parcelRequire("fDc61");

var $9xZGY = parcelRequire("9xZGY");

var $91Qdd = parcelRequire("91Qdd");

var $fyGSR = parcelRequire("fyGSR");

var $4Nq5y = parcelRequire("4Nq5y");

var $o8HxT = parcelRequire("o8HxT");
/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $e277a64de4eeade6$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $i46jW(iteratees, function(iteratee) {
        if ($o8HxT(iteratee)) return function(value) {
            return $lJEX1(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $4Nq5y
    ];
    var index = -1;
    iteratees = $i46jW(iteratees, $91Qdd($7MWok));
    var result = $fDc61(collection, function(value, key, collection) {
        var criteria = $i46jW(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return $9xZGY(result, function(object, other) {
        return $fyGSR(object, other, orders);
    });
}
module.exports = $e277a64de4eeade6$var$baseOrderBy;

});
parcelRegister("9xZGY", function(module, exports) {
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $6f370ce7a904568e$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
module.exports = $6f370ce7a904568e$var$baseSortBy;

});

parcelRegister("fyGSR", function(module, exports) {

var $1HU00 = parcelRequire("1HU00");
/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $b53b4bd61680c3b6$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $1HU00(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
module.exports = $b53b4bd61680c3b6$var$compareMultiple;

});
parcelRegister("1HU00", function(module, exports) {

var $9dr3u = parcelRequire("9dr3u");
/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $13e53edf809f77b7$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $9dr3u(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $9dr3u(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
module.exports = $13e53edf809f77b7$var$compareAscending;

});




parcelRegister("g0ikZ", function(module, exports) {

var $l6E2L = parcelRequire("l6E2L");
/** Used to generate unique IDs. */ var $ba6adedcdb459bac$var$idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function $ba6adedcdb459bac$var$uniqueId(prefix) {
    var id = ++$ba6adedcdb459bac$var$idCounter;
    return $l6E2L(prefix) + id;
}
module.exports = $ba6adedcdb459bac$var$uniqueId;

});

parcelRegister("d0lTW", function(module, exports) {

var $5i71d = parcelRequire("5i71d");

var $gMJL8 = parcelRequire("gMJL8");
/**
 * This method is like `_.fromPairs` except that it accepts two arrays,
 * one of property identifiers and one of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 0.4.0
 * @category Array
 * @param {Array} [props=[]] The property identifiers.
 * @param {Array} [values=[]] The property values.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.zipObject(['a', 'b'], [1, 2]);
 * // => { 'a': 1, 'b': 2 }
 */ function $977c4393d7c5d19f$var$zipObject(props, values) {
    return $gMJL8(props || [], values || [], $5i71d);
}
module.exports = $977c4393d7c5d19f$var$zipObject;

});
parcelRegister("gMJL8", function(module, exports) {
/**
 * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
 *
 * @private
 * @param {Array} props The property identifiers.
 * @param {Array} values The property values.
 * @param {Function} assignFunc The function to assign values.
 * @returns {Object} Returns the new object.
 */ function $c3849fdfd5a45efd$var$baseZipObject(props, values, assignFunc) {
    var index = -1, length = props.length, valsLength = values.length, result = {};
    while(++index < length){
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
    }
    return result;
}
module.exports = $c3849fdfd5a45efd$var$baseZipObject;

});



parcelRegister("61rsw", function(module, exports) {
"use strict";

var $bqfL5 = parcelRequire("bqfL5");

var $7azAU = parcelRequire("7azAU");
module.exports = {
    run: $462822e0eb73a15e$var$run,
    undo: $462822e0eb73a15e$var$undo
};
function $462822e0eb73a15e$var$run(g) {
    var fas = g.graph().acyclicer === "greedy" ? $7azAU(g, weightFn(g)) : $462822e0eb73a15e$var$dfsFAS(g);
    $bqfL5.forEach(fas, function(e) {
        var label = g.edge(e);
        g.removeEdge(e);
        label.forwardName = e.name;
        label.reversed = true;
        g.setEdge(e.w, e.v, label, $bqfL5.uniqueId("rev"));
    });
    function weightFn(g) {
        return function(e) {
            return g.edge(e).weight;
        };
    }
}
function $462822e0eb73a15e$var$dfsFAS(g) {
    var fas = [];
    var stack = {};
    var visited = {};
    function dfs(v) {
        if ($bqfL5.has(visited, v)) return;
        visited[v] = true;
        stack[v] = true;
        $bqfL5.forEach(g.outEdges(v), function(e) {
            if ($bqfL5.has(stack, e.w)) fas.push(e);
            else dfs(e.w);
        });
        delete stack[v];
    }
    $bqfL5.forEach(g.nodes(), dfs);
    return fas;
}
function $462822e0eb73a15e$var$undo(g) {
    $bqfL5.forEach(g.edges(), function(e) {
        var label = g.edge(e);
        if (label.reversed) {
            g.removeEdge(e);
            var forwardName = label.forwardName;
            delete label.reversed;
            delete label.forwardName;
            g.setEdge(e.w, e.v, label, forwardName);
        }
    });
}

});
parcelRegister("7azAU", function(module, exports) {

var $bqfL5 = parcelRequire("bqfL5");

var $6mwJ2 = parcelRequire("6mwJ2");
var $538513d89390fb19$require$Graph = $6mwJ2.Graph;

var $1Gvoz = parcelRequire("1Gvoz");
/*
 * A greedy heuristic for finding a feedback arc set for a graph. A feedback
 * arc set is a set of edges that can be removed to make a graph acyclic.
 * The algorithm comes from: P. Eades, X. Lin, and W. F. Smyth, "A fast and
 * effective heuristic for the feedback arc set problem." This implementation
 * adjusts that from the paper to allow for weighted edges.
 */ module.exports = $538513d89390fb19$var$greedyFAS;
var $538513d89390fb19$var$DEFAULT_WEIGHT_FN = $bqfL5.constant(1);
function $538513d89390fb19$var$greedyFAS(g, weightFn) {
    if (g.nodeCount() <= 1) return [];
    var state = $538513d89390fb19$var$buildState(g, weightFn || $538513d89390fb19$var$DEFAULT_WEIGHT_FN);
    var results = $538513d89390fb19$var$doGreedyFAS(state.graph, state.buckets, state.zeroIdx);
    // Expand multi-edges
    return $bqfL5.flatten($bqfL5.map(results, function(e) {
        return g.outEdges(e.v, e.w);
    }), true);
}
function $538513d89390fb19$var$doGreedyFAS(g, buckets, zeroIdx) {
    var results = [];
    var sources = buckets[buckets.length - 1];
    var sinks = buckets[0];
    var entry;
    while(g.nodeCount()){
        while(entry = sinks.dequeue())$538513d89390fb19$var$removeNode(g, buckets, zeroIdx, entry);
        while(entry = sources.dequeue())$538513d89390fb19$var$removeNode(g, buckets, zeroIdx, entry);
        if (g.nodeCount()) for(var i = buckets.length - 2; i > 0; --i){
            entry = buckets[i].dequeue();
            if (entry) {
                results = results.concat($538513d89390fb19$var$removeNode(g, buckets, zeroIdx, entry, true));
                break;
            }
        }
    }
    return results;
}
function $538513d89390fb19$var$removeNode(g, buckets, zeroIdx, entry, collectPredecessors) {
    var results = collectPredecessors ? [] : undefined;
    $bqfL5.forEach(g.inEdges(entry.v), function(edge) {
        var weight = g.edge(edge);
        var uEntry = g.node(edge.v);
        if (collectPredecessors) results.push({
            v: edge.v,
            w: edge.w
        });
        uEntry.out -= weight;
        $538513d89390fb19$var$assignBucket(buckets, zeroIdx, uEntry);
    });
    $bqfL5.forEach(g.outEdges(entry.v), function(edge) {
        var weight = g.edge(edge);
        var w = edge.w;
        var wEntry = g.node(w);
        wEntry["in"] -= weight;
        $538513d89390fb19$var$assignBucket(buckets, zeroIdx, wEntry);
    });
    g.removeNode(entry.v);
    return results;
}
function $538513d89390fb19$var$buildState(g, weightFn) {
    var fasGraph = new $538513d89390fb19$require$Graph();
    var maxIn = 0;
    var maxOut = 0;
    $bqfL5.forEach(g.nodes(), function(v) {
        fasGraph.setNode(v, {
            v: v,
            "in": 0,
            out: 0
        });
    });
    // Aggregate weights on nodes, but also sum the weights across multi-edges
    // into a single edge for the fasGraph.
    $bqfL5.forEach(g.edges(), function(e) {
        var prevWeight = fasGraph.edge(e.v, e.w) || 0;
        var weight = weightFn(e);
        var edgeWeight = prevWeight + weight;
        fasGraph.setEdge(e.v, e.w, edgeWeight);
        maxOut = Math.max(maxOut, fasGraph.node(e.v).out += weight);
        maxIn = Math.max(maxIn, fasGraph.node(e.w)["in"] += weight);
    });
    var buckets = $bqfL5.range(maxOut + maxIn + 3).map(function() {
        return new $1Gvoz();
    });
    var zeroIdx = maxIn + 1;
    $bqfL5.forEach(fasGraph.nodes(), function(v) {
        $538513d89390fb19$var$assignBucket(buckets, zeroIdx, fasGraph.node(v));
    });
    return {
        graph: fasGraph,
        buckets: buckets,
        zeroIdx: zeroIdx
    };
}
function $538513d89390fb19$var$assignBucket(buckets, zeroIdx, entry) {
    if (!entry.out) buckets[0].enqueue(entry);
    else if (!entry["in"]) buckets[buckets.length - 1].enqueue(entry);
    else buckets[entry.out - entry["in"] + zeroIdx].enqueue(entry);
}

});
parcelRegister("1Gvoz", function(module, exports) {
/*
 * Simple doubly linked list implementation derived from Cormen, et al.,
 * "Introduction to Algorithms".
 */ module.exports = $13a211288b92d897$var$List;
function $13a211288b92d897$var$List() {
    var sentinel = {};
    sentinel._next = sentinel._prev = sentinel;
    this._sentinel = sentinel;
}
$13a211288b92d897$var$List.prototype.dequeue = function() {
    var sentinel = this._sentinel;
    var entry = sentinel._prev;
    if (entry !== sentinel) {
        $13a211288b92d897$var$unlink(entry);
        return entry;
    }
};
$13a211288b92d897$var$List.prototype.enqueue = function(entry) {
    var sentinel = this._sentinel;
    if (entry._prev && entry._next) $13a211288b92d897$var$unlink(entry);
    entry._next = sentinel._next;
    sentinel._next._prev = entry;
    sentinel._next = entry;
    entry._prev = sentinel;
};
$13a211288b92d897$var$List.prototype.toString = function() {
    var strs = [];
    var sentinel = this._sentinel;
    var curr = sentinel._prev;
    while(curr !== sentinel){
        strs.push(JSON.stringify(curr, $13a211288b92d897$var$filterOutLinks));
        curr = curr._prev;
    }
    return "[" + strs.join(", ") + "]";
};
function $13a211288b92d897$var$unlink(entry) {
    entry._prev._next = entry._next;
    entry._next._prev = entry._prev;
    delete entry._next;
    delete entry._prev;
}
function $13a211288b92d897$var$filterOutLinks(k, v) {
    if (k !== "_next" && k !== "_prev") return v;
}

});



parcelRegister("fi6eg", function(module, exports) {
"use strict";

var $bqfL5 = parcelRequire("bqfL5");

var $1kMKg = parcelRequire("1kMKg");
module.exports = {
    run: $b21d5e65d022816f$var$run,
    undo: $b21d5e65d022816f$var$undo
};
/*
 * Breaks any long edges in the graph into short segments that span 1 layer
 * each. This operation is undoable with the denormalize function.
 *
 * Pre-conditions:
 *
 *    1. The input graph is a DAG.
 *    2. Each node in the graph has a "rank" property.
 *
 * Post-condition:
 *
 *    1. All edges in the graph have a length of 1.
 *    2. Dummy nodes are added where edges have been split into segments.
 *    3. The graph is augmented with a "dummyChains" attribute which contains
 *       the first dummy in each chain of dummy nodes produced.
 */ function $b21d5e65d022816f$var$run(g) {
    g.graph().dummyChains = [];
    $bqfL5.forEach(g.edges(), function(edge) {
        $b21d5e65d022816f$var$normalizeEdge(g, edge);
    });
}
function $b21d5e65d022816f$var$normalizeEdge(g, e) {
    var v = e.v;
    var vRank = g.node(v).rank;
    var w = e.w;
    var wRank = g.node(w).rank;
    var name = e.name;
    var edgeLabel = g.edge(e);
    var labelRank = edgeLabel.labelRank;
    if (wRank === vRank + 1) return;
    g.removeEdge(e);
    var dummy, attrs, i;
    for(i = 0, ++vRank; vRank < wRank; ++i, ++vRank){
        edgeLabel.points = [];
        attrs = {
            width: 0,
            height: 0,
            edgeLabel: edgeLabel,
            edgeObj: e,
            rank: vRank
        };
        dummy = $1kMKg.addDummyNode(g, "edge", attrs, "_d");
        if (vRank === labelRank) {
            attrs.width = edgeLabel.width;
            attrs.height = edgeLabel.height;
            attrs.dummy = "edge-label";
            attrs.labelpos = edgeLabel.labelpos;
        }
        g.setEdge(v, dummy, {
            weight: edgeLabel.weight
        }, name);
        if (i === 0) g.graph().dummyChains.push(dummy);
        v = dummy;
    }
    g.setEdge(v, w, {
        weight: edgeLabel.weight
    }, name);
}
function $b21d5e65d022816f$var$undo(g) {
    $bqfL5.forEach(g.graph().dummyChains, function(v) {
        var node = g.node(v);
        var origLabel = node.edgeLabel;
        var w;
        g.setEdge(node.edgeObj, origLabel);
        while(node.dummy){
            w = g.successors(v)[0];
            g.removeNode(v);
            origLabel.points.push({
                x: node.x,
                y: node.y
            });
            if (node.dummy === "edge-label") {
                origLabel.x = node.x;
                origLabel.y = node.y;
                origLabel.width = node.width;
                origLabel.height = node.height;
            }
            v = w;
            node = g.node(v);
        }
    });
}

});
parcelRegister("1kMKg", function(module, exports) {
/* eslint "no-console": off */ "use strict";

var $bqfL5 = parcelRequire("bqfL5");

var $6mwJ2 = parcelRequire("6mwJ2");
var $0f8d7874fb4245ee$require$Graph = $6mwJ2.Graph;
module.exports = {
    addDummyNode: $0f8d7874fb4245ee$var$addDummyNode,
    simplify: $0f8d7874fb4245ee$var$simplify,
    asNonCompoundGraph: $0f8d7874fb4245ee$var$asNonCompoundGraph,
    successorWeights: $0f8d7874fb4245ee$var$successorWeights,
    predecessorWeights: $0f8d7874fb4245ee$var$predecessorWeights,
    intersectRect: $0f8d7874fb4245ee$var$intersectRect,
    buildLayerMatrix: $0f8d7874fb4245ee$var$buildLayerMatrix,
    normalizeRanks: $0f8d7874fb4245ee$var$normalizeRanks,
    removeEmptyRanks: $0f8d7874fb4245ee$var$removeEmptyRanks,
    addBorderNode: $0f8d7874fb4245ee$var$addBorderNode,
    maxRank: $0f8d7874fb4245ee$var$maxRank,
    partition: $0f8d7874fb4245ee$var$partition,
    time: $0f8d7874fb4245ee$var$time,
    notime: $0f8d7874fb4245ee$var$notime
};
/*
 * Adds a dummy node to the graph and return v.
 */ function $0f8d7874fb4245ee$var$addDummyNode(g, type, attrs, name) {
    var v;
    do v = $bqfL5.uniqueId(name);
    while (g.hasNode(v));
    attrs.dummy = type;
    g.setNode(v, attrs);
    return v;
}
/*
 * Returns a new graph with only simple edges. Handles aggregation of data
 * associated with multi-edges.
 */ function $0f8d7874fb4245ee$var$simplify(g) {
    var simplified = new $0f8d7874fb4245ee$require$Graph().setGraph(g.graph());
    $bqfL5.forEach(g.nodes(), function(v) {
        simplified.setNode(v, g.node(v));
    });
    $bqfL5.forEach(g.edges(), function(e) {
        var simpleLabel = simplified.edge(e.v, e.w) || {
            weight: 0,
            minlen: 1
        };
        var label = g.edge(e);
        simplified.setEdge(e.v, e.w, {
            weight: simpleLabel.weight + label.weight,
            minlen: Math.max(simpleLabel.minlen, label.minlen)
        });
    });
    return simplified;
}
function $0f8d7874fb4245ee$var$asNonCompoundGraph(g) {
    var simplified = new $0f8d7874fb4245ee$require$Graph({
        multigraph: g.isMultigraph()
    }).setGraph(g.graph());
    $bqfL5.forEach(g.nodes(), function(v) {
        if (!g.children(v).length) simplified.setNode(v, g.node(v));
    });
    $bqfL5.forEach(g.edges(), function(e) {
        simplified.setEdge(e, g.edge(e));
    });
    return simplified;
}
function $0f8d7874fb4245ee$var$successorWeights(g) {
    var weightMap = $bqfL5.map(g.nodes(), function(v) {
        var sucs = {};
        $bqfL5.forEach(g.outEdges(v), function(e) {
            sucs[e.w] = (sucs[e.w] || 0) + g.edge(e).weight;
        });
        return sucs;
    });
    return $bqfL5.zipObject(g.nodes(), weightMap);
}
function $0f8d7874fb4245ee$var$predecessorWeights(g) {
    var weightMap = $bqfL5.map(g.nodes(), function(v) {
        var preds = {};
        $bqfL5.forEach(g.inEdges(v), function(e) {
            preds[e.v] = (preds[e.v] || 0) + g.edge(e).weight;
        });
        return preds;
    });
    return $bqfL5.zipObject(g.nodes(), weightMap);
}
/*
 * Finds where a line starting at point ({x, y}) would intersect a rectangle
 * ({x, y, width, height}) if it were pointing at the rectangle's center.
 */ function $0f8d7874fb4245ee$var$intersectRect(rect, point) {
    var x = rect.x;
    var y = rect.y;
    // Rectangle intersection algorithm from:
    // http://math.stackexchange.com/questions/108113/find-edge-between-two-boxes
    var dx = point.x - x;
    var dy = point.y - y;
    var w = rect.width / 2;
    var h = rect.height / 2;
    if (!dx && !dy) throw new Error("Not possible to find intersection inside of the rectangle");
    var sx, sy;
    if (Math.abs(dy) * w > Math.abs(dx) * h) {
        // Intersection is top or bottom of rect.
        if (dy < 0) h = -h;
        sx = h * dx / dy;
        sy = h;
    } else {
        // Intersection is left or right of rect.
        if (dx < 0) w = -w;
        sx = w;
        sy = w * dy / dx;
    }
    return {
        x: x + sx,
        y: y + sy
    };
}
/*
 * Given a DAG with each node assigned "rank" and "order" properties, this
 * function will produce a matrix with the ids of each node.
 */ function $0f8d7874fb4245ee$var$buildLayerMatrix(g) {
    var layering = $bqfL5.map($bqfL5.range($0f8d7874fb4245ee$var$maxRank(g) + 1), function() {
        return [];
    });
    $bqfL5.forEach(g.nodes(), function(v) {
        var node = g.node(v);
        var rank = node.rank;
        if (!$bqfL5.isUndefined(rank)) layering[rank][node.order] = v;
    });
    return layering;
}
/*
 * Adjusts the ranks for all nodes in the graph such that all nodes v have
 * rank(v) >= 0 and at least one node w has rank(w) = 0.
 */ function $0f8d7874fb4245ee$var$normalizeRanks(g) {
    var min = $bqfL5.min($bqfL5.map(g.nodes(), function(v) {
        return g.node(v).rank;
    }));
    $bqfL5.forEach(g.nodes(), function(v) {
        var node = g.node(v);
        if ($bqfL5.has(node, "rank")) node.rank -= min;
    });
}
function $0f8d7874fb4245ee$var$removeEmptyRanks(g) {
    // Ranks may not start at 0, so we need to offset them
    var offset = $bqfL5.min($bqfL5.map(g.nodes(), function(v) {
        return g.node(v).rank;
    }));
    var layers = [];
    $bqfL5.forEach(g.nodes(), function(v) {
        var rank = g.node(v).rank - offset;
        if (!layers[rank]) layers[rank] = [];
        layers[rank].push(v);
    });
    var delta = 0;
    var nodeRankFactor = g.graph().nodeRankFactor;
    $bqfL5.forEach(layers, function(vs, i) {
        if ($bqfL5.isUndefined(vs) && i % nodeRankFactor !== 0) --delta;
        else if (delta) $bqfL5.forEach(vs, function(v) {
            g.node(v).rank += delta;
        });
    });
}
function $0f8d7874fb4245ee$var$addBorderNode(g, prefix, rank, order) {
    var node = {
        width: 0,
        height: 0
    };
    if (arguments.length >= 4) {
        node.rank = rank;
        node.order = order;
    }
    return $0f8d7874fb4245ee$var$addDummyNode(g, "border", node, prefix);
}
function $0f8d7874fb4245ee$var$maxRank(g) {
    return $bqfL5.max($bqfL5.map(g.nodes(), function(v) {
        var rank = g.node(v).rank;
        if (!$bqfL5.isUndefined(rank)) return rank;
    }));
}
/*
 * Partition a collection into two groups: `lhs` and `rhs`. If the supplied
 * function returns true for an entry it goes into `lhs`. Otherwise it goes
 * into `rhs.
 */ function $0f8d7874fb4245ee$var$partition(collection, fn) {
    var result = {
        lhs: [],
        rhs: []
    };
    $bqfL5.forEach(collection, function(value) {
        if (fn(value)) result.lhs.push(value);
        else result.rhs.push(value);
    });
    return result;
}
/*
 * Returns a new function that wraps `fn` with a timer. The wrapper logs the
 * time it takes to execute the function.
 */ function $0f8d7874fb4245ee$var$time(name, fn) {
    var start = $bqfL5.now();
    try {
        return fn();
    } finally{
        console.log(name + " time: " + ($bqfL5.now() - start) + "ms");
    }
}
function $0f8d7874fb4245ee$var$notime(name, fn) {
    return fn();
}

});


parcelRegister("hv32p", function(module, exports) {
"use strict";

var $7JZFZ = parcelRequire("7JZFZ");
var $cbd7b02ec197fd8b$var$longestPath = $7JZFZ.longestPath;

var $8eEo6 = parcelRequire("8eEo6");

var $fT8MR = parcelRequire("fT8MR");
module.exports = $cbd7b02ec197fd8b$var$rank;
/*
 * Assigns a rank to each node in the input graph that respects the "minlen"
 * constraint specified on edges between nodes.
 *
 * This basic structure is derived from Gansner, et al., "A Technique for
 * Drawing Directed Graphs."
 *
 * Pre-conditions:
 *
 *    1. Graph must be a connected DAG
 *    2. Graph nodes must be objects
 *    3. Graph edges must have "weight" and "minlen" attributes
 *
 * Post-conditions:
 *
 *    1. Graph nodes will have a "rank" attribute based on the results of the
 *       algorithm. Ranks can start at any index (including negative), we'll
 *       fix them up later.
 */ function $cbd7b02ec197fd8b$var$rank(g) {
    switch(g.graph().ranker){
        case "network-simplex":
            $cbd7b02ec197fd8b$var$networkSimplexRanker(g);
            break;
        case "tight-tree":
            $cbd7b02ec197fd8b$var$tightTreeRanker(g);
            break;
        case "longest-path":
            $cbd7b02ec197fd8b$var$longestPathRanker(g);
            break;
        default:
            $cbd7b02ec197fd8b$var$networkSimplexRanker(g);
    }
}
// A fast and simple ranker, but results are far from optimal.
var $cbd7b02ec197fd8b$var$longestPathRanker = $cbd7b02ec197fd8b$var$longestPath;
function $cbd7b02ec197fd8b$var$tightTreeRanker(g) {
    $cbd7b02ec197fd8b$var$longestPath(g);
    $8eEo6(g);
}
function $cbd7b02ec197fd8b$var$networkSimplexRanker(g) {
    $fT8MR(g);
}

});
parcelRegister("7JZFZ", function(module, exports) {
"use strict";

var $bqfL5 = parcelRequire("bqfL5");
module.exports = {
    longestPath: $5a2c9402b96e1199$var$longestPath,
    slack: $5a2c9402b96e1199$var$slack
};
/*
 * Initializes ranks for the input graph using the longest path algorithm. This
 * algorithm scales well and is fast in practice, it yields rather poor
 * solutions. Nodes are pushed to the lowest layer possible, leaving the bottom
 * ranks wide and leaving edges longer than necessary. However, due to its
 * speed, this algorithm is good for getting an initial ranking that can be fed
 * into other algorithms.
 *
 * This algorithm does not normalize layers because it will be used by other
 * algorithms in most cases. If using this algorithm directly, be sure to
 * run normalize at the end.
 *
 * Pre-conditions:
 *
 *    1. Input graph is a DAG.
 *    2. Input graph node labels can be assigned properties.
 *
 * Post-conditions:
 *
 *    1. Each node will be assign an (unnormalized) "rank" property.
 */ function $5a2c9402b96e1199$var$longestPath(g) {
    var visited = {};
    function dfs(v) {
        var label = g.node(v);
        if ($bqfL5.has(visited, v)) return label.rank;
        visited[v] = true;
        var rank = $bqfL5.min($bqfL5.map(g.outEdges(v), function(e) {
            return dfs(e.w) - g.edge(e).minlen;
        }));
        if (rank === Number.POSITIVE_INFINITY || // return value of _.map([]) for Lodash 3
        rank === undefined || // return value of _.map([]) for Lodash 4
        rank === null) rank = 0;
        return label.rank = rank;
    }
    $bqfL5.forEach(g.sources(), dfs);
}
/*
 * Returns the amount of slack for the given edge. The slack is defined as the
 * difference between the length of the edge and its minimum length.
 */ function $5a2c9402b96e1199$var$slack(g, e) {
    return g.node(e.w).rank - g.node(e.v).rank - g.edge(e).minlen;
}

});

parcelRegister("8eEo6", function(module, exports) {
"use strict";

var $bqfL5 = parcelRequire("bqfL5");

var $6mwJ2 = parcelRequire("6mwJ2");
var $5feef5b0afc29ce6$require$Graph = $6mwJ2.Graph;

var $7JZFZ = parcelRequire("7JZFZ");
var $5feef5b0afc29ce6$require$slack = $7JZFZ.slack;
module.exports = $5feef5b0afc29ce6$var$feasibleTree;
/*
 * Constructs a spanning tree with tight edges and adjusted the input node's
 * ranks to achieve this. A tight edge is one that is has a length that matches
 * its "minlen" attribute.
 *
 * The basic structure for this function is derived from Gansner, et al., "A
 * Technique for Drawing Directed Graphs."
 *
 * Pre-conditions:
 *
 *    1. Graph must be a DAG.
 *    2. Graph must be connected.
 *    3. Graph must have at least one node.
 *    5. Graph nodes must have been previously assigned a "rank" property that
 *       respects the "minlen" property of incident edges.
 *    6. Graph edges must have a "minlen" property.
 *
 * Post-conditions:
 *
 *    - Graph nodes will have their rank adjusted to ensure that all edges are
 *      tight.
 *
 * Returns a tree (undirected graph) that is constructed using only "tight"
 * edges.
 */ function $5feef5b0afc29ce6$var$feasibleTree(g) {
    var t = new $5feef5b0afc29ce6$require$Graph({
        directed: false
    });
    // Choose arbitrary node from which to start our tree
    var start = g.nodes()[0];
    var size = g.nodeCount();
    t.setNode(start, {});
    var edge, delta;
    while($5feef5b0afc29ce6$var$tightTree(t, g) < size){
        edge = $5feef5b0afc29ce6$var$findMinSlackEdge(t, g);
        delta = t.hasNode(edge.v) ? $5feef5b0afc29ce6$require$slack(g, edge) : -$5feef5b0afc29ce6$require$slack(g, edge);
        $5feef5b0afc29ce6$var$shiftRanks(t, g, delta);
    }
    return t;
}
/*
 * Finds a maximal tree of tight edges and returns the number of nodes in the
 * tree.
 */ function $5feef5b0afc29ce6$var$tightTree(t, g) {
    function dfs(v) {
        $bqfL5.forEach(g.nodeEdges(v), function(e) {
            var edgeV = e.v, w = v === edgeV ? e.w : edgeV;
            if (!t.hasNode(w) && !$5feef5b0afc29ce6$require$slack(g, e)) {
                t.setNode(w, {});
                t.setEdge(v, w, {});
                dfs(w);
            }
        });
    }
    $bqfL5.forEach(t.nodes(), dfs);
    return t.nodeCount();
}
/*
 * Finds the edge with the smallest slack that is incident on tree and returns
 * it.
 */ function $5feef5b0afc29ce6$var$findMinSlackEdge(t, g) {
    return $bqfL5.minBy(g.edges(), function(e) {
        if (t.hasNode(e.v) !== t.hasNode(e.w)) return $5feef5b0afc29ce6$require$slack(g, e);
    });
}
function $5feef5b0afc29ce6$var$shiftRanks(t, g, delta) {
    $bqfL5.forEach(t.nodes(), function(v) {
        g.node(v).rank += delta;
    });
}

});

parcelRegister("fT8MR", function(module, exports) {
"use strict";

var $bqfL5 = parcelRequire("bqfL5");

var $8eEo6 = parcelRequire("8eEo6");

var $7JZFZ = parcelRequire("7JZFZ");
var $b912cf006614473d$require$slack = $7JZFZ.slack;

var $7JZFZ = parcelRequire("7JZFZ");
var $b912cf006614473d$require$initRank = $7JZFZ.longestPath;

var $b912cf006614473d$var$preorder = (parcelRequire("6mwJ2")).alg.preorder;

var $b912cf006614473d$var$postorder = (parcelRequire("6mwJ2")).alg.postorder;

var $1kMKg = parcelRequire("1kMKg");
var $b912cf006614473d$require$simplify = $1kMKg.simplify;
module.exports = $b912cf006614473d$var$networkSimplex;
// Expose some internals for testing purposes
$b912cf006614473d$var$networkSimplex.initLowLimValues = $b912cf006614473d$var$initLowLimValues;
$b912cf006614473d$var$networkSimplex.initCutValues = $b912cf006614473d$var$initCutValues;
$b912cf006614473d$var$networkSimplex.calcCutValue = $b912cf006614473d$var$calcCutValue;
$b912cf006614473d$var$networkSimplex.leaveEdge = $b912cf006614473d$var$leaveEdge;
$b912cf006614473d$var$networkSimplex.enterEdge = $b912cf006614473d$var$enterEdge;
$b912cf006614473d$var$networkSimplex.exchangeEdges = $b912cf006614473d$var$exchangeEdges;
/*
 * The network simplex algorithm assigns ranks to each node in the input graph
 * and iteratively improves the ranking to reduce the length of edges.
 *
 * Preconditions:
 *
 *    1. The input graph must be a DAG.
 *    2. All nodes in the graph must have an object value.
 *    3. All edges in the graph must have "minlen" and "weight" attributes.
 *
 * Postconditions:
 *
 *    1. All nodes in the graph will have an assigned "rank" attribute that has
 *       been optimized by the network simplex algorithm. Ranks start at 0.
 *
 *
 * A rough sketch of the algorithm is as follows:
 *
 *    1. Assign initial ranks to each node. We use the longest path algorithm,
 *       which assigns ranks to the lowest position possible. In general this
 *       leads to very wide bottom ranks and unnecessarily long edges.
 *    2. Construct a feasible tight tree. A tight tree is one such that all
 *       edges in the tree have no slack (difference between length of edge
 *       and minlen for the edge). This by itself greatly improves the assigned
 *       rankings by shorting edges.
 *    3. Iteratively find edges that have negative cut values. Generally a
 *       negative cut value indicates that the edge could be removed and a new
 *       tree edge could be added to produce a more compact graph.
 *
 * Much of the algorithms here are derived from Gansner, et al., "A Technique
 * for Drawing Directed Graphs." The structure of the file roughly follows the
 * structure of the overall algorithm.
 */ function $b912cf006614473d$var$networkSimplex(g) {
    g = $b912cf006614473d$require$simplify(g);
    $b912cf006614473d$require$initRank(g);
    var t = $8eEo6(g);
    $b912cf006614473d$var$initLowLimValues(t);
    $b912cf006614473d$var$initCutValues(t, g);
    var e, f;
    while(e = $b912cf006614473d$var$leaveEdge(t)){
        f = $b912cf006614473d$var$enterEdge(t, g, e);
        $b912cf006614473d$var$exchangeEdges(t, g, e, f);
    }
}
/*
 * Initializes cut values for all edges in the tree.
 */ function $b912cf006614473d$var$initCutValues(t, g) {
    var vs = $b912cf006614473d$var$postorder(t, t.nodes());
    vs = vs.slice(0, vs.length - 1);
    $bqfL5.forEach(vs, function(v) {
        $b912cf006614473d$var$assignCutValue(t, g, v);
    });
}
function $b912cf006614473d$var$assignCutValue(t, g, child) {
    var childLab = t.node(child);
    var parent = childLab.parent;
    t.edge(child, parent).cutvalue = $b912cf006614473d$var$calcCutValue(t, g, child);
}
/*
 * Given the tight tree, its graph, and a child in the graph calculate and
 * return the cut value for the edge between the child and its parent.
 */ function $b912cf006614473d$var$calcCutValue(t, g, child) {
    var childLab = t.node(child);
    var parent = childLab.parent;
    // True if the child is on the tail end of the edge in the directed graph
    var childIsTail = true;
    // The graph's view of the tree edge we're inspecting
    var graphEdge = g.edge(child, parent);
    // The accumulated cut value for the edge between this node and its parent
    var cutValue = 0;
    if (!graphEdge) {
        childIsTail = false;
        graphEdge = g.edge(parent, child);
    }
    cutValue = graphEdge.weight;
    $bqfL5.forEach(g.nodeEdges(child), function(e) {
        var isOutEdge = e.v === child, other = isOutEdge ? e.w : e.v;
        if (other !== parent) {
            var pointsToHead = isOutEdge === childIsTail, otherWeight = g.edge(e).weight;
            cutValue += pointsToHead ? otherWeight : -otherWeight;
            if ($b912cf006614473d$var$isTreeEdge(t, child, other)) {
                var otherCutValue = t.edge(child, other).cutvalue;
                cutValue += pointsToHead ? -otherCutValue : otherCutValue;
            }
        }
    });
    return cutValue;
}
function $b912cf006614473d$var$initLowLimValues(tree, root) {
    if (arguments.length < 2) root = tree.nodes()[0];
    $b912cf006614473d$var$dfsAssignLowLim(tree, {}, 1, root);
}
function $b912cf006614473d$var$dfsAssignLowLim(tree, visited, nextLim, v, parent) {
    var low = nextLim;
    var label = tree.node(v);
    visited[v] = true;
    $bqfL5.forEach(tree.neighbors(v), function(w) {
        if (!$bqfL5.has(visited, w)) nextLim = $b912cf006614473d$var$dfsAssignLowLim(tree, visited, nextLim, w, v);
    });
    label.low = low;
    label.lim = nextLim++;
    if (parent) label.parent = parent;
    else // TODO should be able to remove this when we incrementally update low lim
    delete label.parent;
    return nextLim;
}
function $b912cf006614473d$var$leaveEdge(tree) {
    return $bqfL5.find(tree.edges(), function(e) {
        return tree.edge(e).cutvalue < 0;
    });
}
function $b912cf006614473d$var$enterEdge(t, g, edge) {
    var v = edge.v;
    var w = edge.w;
    // For the rest of this function we assume that v is the tail and w is the
    // head, so if we don't have this edge in the graph we should flip it to
    // match the correct orientation.
    if (!g.hasEdge(v, w)) {
        v = edge.w;
        w = edge.v;
    }
    var vLabel = t.node(v);
    var wLabel = t.node(w);
    var tailLabel = vLabel;
    var flip = false;
    // If the root is in the tail of the edge then we need to flip the logic that
    // checks for the head and tail nodes in the candidates function below.
    if (vLabel.lim > wLabel.lim) {
        tailLabel = wLabel;
        flip = true;
    }
    var candidates = $bqfL5.filter(g.edges(), function(edge) {
        return flip === $b912cf006614473d$var$isDescendant(t, t.node(edge.v), tailLabel) && flip !== $b912cf006614473d$var$isDescendant(t, t.node(edge.w), tailLabel);
    });
    return $bqfL5.minBy(candidates, function(edge) {
        return $b912cf006614473d$require$slack(g, edge);
    });
}
function $b912cf006614473d$var$exchangeEdges(t, g, e, f) {
    var v = e.v;
    var w = e.w;
    t.removeEdge(v, w);
    t.setEdge(f.v, f.w, {});
    $b912cf006614473d$var$initLowLimValues(t);
    $b912cf006614473d$var$initCutValues(t, g);
    $b912cf006614473d$var$updateRanks(t, g);
}
function $b912cf006614473d$var$updateRanks(t, g) {
    var root = $bqfL5.find(t.nodes(), function(v) {
        return !g.node(v).parent;
    });
    var vs = $b912cf006614473d$var$preorder(t, root);
    vs = vs.slice(1);
    $bqfL5.forEach(vs, function(v) {
        var parent = t.node(v).parent, edge = g.edge(v, parent), flipped = false;
        if (!edge) {
            edge = g.edge(parent, v);
            flipped = true;
        }
        g.node(v).rank = g.node(parent).rank + (flipped ? edge.minlen : -edge.minlen);
    });
}
/*
 * Returns true if the edge is in the tree.
 */ function $b912cf006614473d$var$isTreeEdge(tree, u, v) {
    return tree.hasEdge(u, v);
}
/*
 * Returns true if the specified node is descendant of the root node per the
 * assigned low and lim attributes in the tree.
 */ function $b912cf006614473d$var$isDescendant(tree, vLabel, rootLabel) {
    return rootLabel.low <= vLabel.lim && vLabel.lim <= rootLabel.lim;
}

});


parcelRegister("eBG2O", function(module, exports) {

var $bqfL5 = parcelRequire("bqfL5");
module.exports = $aa252286d7a30ca5$var$parentDummyChains;
function $aa252286d7a30ca5$var$parentDummyChains(g) {
    var postorderNums = $aa252286d7a30ca5$var$postorder(g);
    $bqfL5.forEach(g.graph().dummyChains, function(v) {
        var node = g.node(v);
        var edgeObj = node.edgeObj;
        var pathData = $aa252286d7a30ca5$var$findPath(g, postorderNums, edgeObj.v, edgeObj.w);
        var path = pathData.path;
        var lca = pathData.lca;
        var pathIdx = 0;
        var pathV = path[pathIdx];
        var ascending = true;
        while(v !== edgeObj.w){
            node = g.node(v);
            if (ascending) {
                while((pathV = path[pathIdx]) !== lca && g.node(pathV).maxRank < node.rank)pathIdx++;
                if (pathV === lca) ascending = false;
            }
            if (!ascending) {
                while(pathIdx < path.length - 1 && g.node(pathV = path[pathIdx + 1]).minRank <= node.rank)pathIdx++;
                pathV = path[pathIdx];
            }
            g.setParent(v, pathV);
            v = g.successors(v)[0];
        }
    });
}
// Find a path from v to w through the lowest common ancestor (LCA). Return the
// full path and the LCA.
function $aa252286d7a30ca5$var$findPath(g, postorderNums, v, w) {
    var vPath = [];
    var wPath = [];
    var low = Math.min(postorderNums[v].low, postorderNums[w].low);
    var lim = Math.max(postorderNums[v].lim, postorderNums[w].lim);
    var parent;
    var lca;
    // Traverse up from v to find the LCA
    parent = v;
    do {
        parent = g.parent(parent);
        vPath.push(parent);
    }while (parent && (postorderNums[parent].low > low || lim > postorderNums[parent].lim));
    lca = parent;
    // Traverse from w to LCA
    parent = w;
    while((parent = g.parent(parent)) !== lca)wPath.push(parent);
    return {
        path: vPath.concat(wPath.reverse()),
        lca: lca
    };
}
function $aa252286d7a30ca5$var$postorder(g) {
    var result = {};
    var lim = 0;
    function dfs(v) {
        var low = lim;
        $bqfL5.forEach(g.children(v), dfs);
        result[v] = {
            low: low,
            lim: lim++
        };
    }
    $bqfL5.forEach(g.children(), dfs);
    return result;
}

});

parcelRegister("YdQc0", function(module, exports) {

var $bqfL5 = parcelRequire("bqfL5");

var $1kMKg = parcelRequire("1kMKg");
module.exports = {
    run: $0b5057358d9c05c8$var$run,
    cleanup: $0b5057358d9c05c8$var$cleanup
};
/*
 * A nesting graph creates dummy nodes for the tops and bottoms of subgraphs,
 * adds appropriate edges to ensure that all cluster nodes are placed between
 * these boundries, and ensures that the graph is connected.
 *
 * In addition we ensure, through the use of the minlen property, that nodes
 * and subgraph border nodes to not end up on the same rank.
 *
 * Preconditions:
 *
 *    1. Input graph is a DAG
 *    2. Nodes in the input graph has a minlen attribute
 *
 * Postconditions:
 *
 *    1. Input graph is connected.
 *    2. Dummy nodes are added for the tops and bottoms of subgraphs.
 *    3. The minlen attribute for nodes is adjusted to ensure nodes do not
 *       get placed on the same rank as subgraph border nodes.
 *
 * The nesting graph idea comes from Sander, "Layout of Compound Directed
 * Graphs."
 */ function $0b5057358d9c05c8$var$run(g) {
    var root = $1kMKg.addDummyNode(g, "root", {}, "_root");
    var depths = $0b5057358d9c05c8$var$treeDepths(g);
    var height = $bqfL5.max($bqfL5.values(depths)) - 1; // Note: depths is an Object not an array
    var nodeSep = 2 * height + 1;
    g.graph().nestingRoot = root;
    // Multiply minlen by nodeSep to align nodes on non-border ranks.
    $bqfL5.forEach(g.edges(), function(e) {
        g.edge(e).minlen *= nodeSep;
    });
    // Calculate a weight that is sufficient to keep subgraphs vertically compact
    var weight = $0b5057358d9c05c8$var$sumWeights(g) + 1;
    // Create border nodes and link them up
    $bqfL5.forEach(g.children(), function(child) {
        $0b5057358d9c05c8$var$dfs(g, root, nodeSep, weight, height, depths, child);
    });
    // Save the multiplier for node layers for later removal of empty border
    // layers.
    g.graph().nodeRankFactor = nodeSep;
}
function $0b5057358d9c05c8$var$dfs(g, root, nodeSep, weight, height, depths, v) {
    var children = g.children(v);
    if (!children.length) {
        if (v !== root) g.setEdge(root, v, {
            weight: 0,
            minlen: nodeSep
        });
        return;
    }
    var top = $1kMKg.addBorderNode(g, "_bt");
    var bottom = $1kMKg.addBorderNode(g, "_bb");
    var label = g.node(v);
    g.setParent(top, v);
    label.borderTop = top;
    g.setParent(bottom, v);
    label.borderBottom = bottom;
    $bqfL5.forEach(children, function(child) {
        $0b5057358d9c05c8$var$dfs(g, root, nodeSep, weight, height, depths, child);
        var childNode = g.node(child);
        var childTop = childNode.borderTop ? childNode.borderTop : child;
        var childBottom = childNode.borderBottom ? childNode.borderBottom : child;
        var thisWeight = childNode.borderTop ? weight : 2 * weight;
        var minlen = childTop !== childBottom ? 1 : height - depths[v] + 1;
        g.setEdge(top, childTop, {
            weight: thisWeight,
            minlen: minlen,
            nestingEdge: true
        });
        g.setEdge(childBottom, bottom, {
            weight: thisWeight,
            minlen: minlen,
            nestingEdge: true
        });
    });
    if (!g.parent(v)) g.setEdge(root, top, {
        weight: 0,
        minlen: height + depths[v]
    });
}
function $0b5057358d9c05c8$var$treeDepths(g) {
    var depths = {};
    function dfs(v, depth) {
        var children = g.children(v);
        if (children && children.length) $bqfL5.forEach(children, function(child) {
            dfs(child, depth + 1);
        });
        depths[v] = depth;
    }
    $bqfL5.forEach(g.children(), function(v) {
        dfs(v, 1);
    });
    return depths;
}
function $0b5057358d9c05c8$var$sumWeights(g) {
    return $bqfL5.reduce(g.edges(), function(acc, e) {
        return acc + g.edge(e).weight;
    }, 0);
}
function $0b5057358d9c05c8$var$cleanup(g) {
    var graphLabel = g.graph();
    g.removeNode(graphLabel.nestingRoot);
    delete graphLabel.nestingRoot;
    $bqfL5.forEach(g.edges(), function(e) {
        var edge = g.edge(e);
        if (edge.nestingEdge) g.removeEdge(e);
    });
}

});

parcelRegister("fSZns", function(module, exports) {

var $bqfL5 = parcelRequire("bqfL5");

var $1kMKg = parcelRequire("1kMKg");
module.exports = $b90b826f4fed8d23$var$addBorderSegments;
function $b90b826f4fed8d23$var$addBorderSegments(g) {
    function dfs(v) {
        var children = g.children(v);
        var node = g.node(v);
        if (children.length) $bqfL5.forEach(children, dfs);
        if ($bqfL5.has(node, "minRank")) {
            node.borderLeft = [];
            node.borderRight = [];
            for(var rank = node.minRank, maxRank = node.maxRank + 1; rank < maxRank; ++rank){
                $b90b826f4fed8d23$var$addBorderNode(g, "borderLeft", "_bl", v, node, rank);
                $b90b826f4fed8d23$var$addBorderNode(g, "borderRight", "_br", v, node, rank);
            }
        }
    }
    $bqfL5.forEach(g.children(), dfs);
}
function $b90b826f4fed8d23$var$addBorderNode(g, prop, prefix, sg, sgNode, rank) {
    var label = {
        width: 0,
        height: 0,
        rank: rank,
        borderType: prop
    };
    var prev = sgNode[prop][rank - 1];
    var curr = $1kMKg.addDummyNode(g, "border", label, prefix);
    sgNode[prop][rank] = curr;
    g.setParent(curr, sg);
    if (prev) g.setEdge(prev, curr, {
        weight: 1
    });
}

});

parcelRegister("lWVsJ", function(module, exports) {
"use strict";

var $bqfL5 = parcelRequire("bqfL5");
module.exports = {
    adjust: $ffab96934221be07$var$adjust,
    undo: $ffab96934221be07$var$undo
};
function $ffab96934221be07$var$adjust(g) {
    var rankDir = g.graph().rankdir.toLowerCase();
    if (rankDir === "lr" || rankDir === "rl") $ffab96934221be07$var$swapWidthHeight(g);
}
function $ffab96934221be07$var$undo(g) {
    var rankDir = g.graph().rankdir.toLowerCase();
    if (rankDir === "bt" || rankDir === "rl") $ffab96934221be07$var$reverseY(g);
    if (rankDir === "lr" || rankDir === "rl") {
        $ffab96934221be07$var$swapXY(g);
        $ffab96934221be07$var$swapWidthHeight(g);
    }
}
function $ffab96934221be07$var$swapWidthHeight(g) {
    $bqfL5.forEach(g.nodes(), function(v) {
        $ffab96934221be07$var$swapWidthHeightOne(g.node(v));
    });
    $bqfL5.forEach(g.edges(), function(e) {
        $ffab96934221be07$var$swapWidthHeightOne(g.edge(e));
    });
}
function $ffab96934221be07$var$swapWidthHeightOne(attrs) {
    var w = attrs.width;
    attrs.width = attrs.height;
    attrs.height = w;
}
function $ffab96934221be07$var$reverseY(g) {
    $bqfL5.forEach(g.nodes(), function(v) {
        $ffab96934221be07$var$reverseYOne(g.node(v));
    });
    $bqfL5.forEach(g.edges(), function(e) {
        var edge = g.edge(e);
        $bqfL5.forEach(edge.points, $ffab96934221be07$var$reverseYOne);
        if ($bqfL5.has(edge, "y")) $ffab96934221be07$var$reverseYOne(edge);
    });
}
function $ffab96934221be07$var$reverseYOne(attrs) {
    attrs.y = -attrs.y;
}
function $ffab96934221be07$var$swapXY(g) {
    $bqfL5.forEach(g.nodes(), function(v) {
        $ffab96934221be07$var$swapXYOne(g.node(v));
    });
    $bqfL5.forEach(g.edges(), function(e) {
        var edge = g.edge(e);
        $bqfL5.forEach(edge.points, $ffab96934221be07$var$swapXYOne);
        if ($bqfL5.has(edge, "x")) $ffab96934221be07$var$swapXYOne(edge);
    });
}
function $ffab96934221be07$var$swapXYOne(attrs) {
    var x = attrs.x;
    attrs.x = attrs.y;
    attrs.y = x;
}

});

parcelRegister("3dyGB", function(module, exports) {
"use strict";

var $bqfL5 = parcelRequire("bqfL5");

var $7H72Y = parcelRequire("7H72Y");

var $lesrU = parcelRequire("lesrU");

var $3CKyT = parcelRequire("3CKyT");

var $lvOrT = parcelRequire("lvOrT");

var $7mMpT = parcelRequire("7mMpT");

var $6mwJ2 = parcelRequire("6mwJ2");
var $257d7deb0180286c$require$Graph = $6mwJ2.Graph;

var $1kMKg = parcelRequire("1kMKg");
module.exports = $257d7deb0180286c$var$order;
/*
 * Applies heuristics to minimize edge crossings in the graph and sets the best
 * order solution as an order attribute on each node.
 *
 * Pre-conditions:
 *
 *    1. Graph must be DAG
 *    2. Graph nodes must be objects with a "rank" attribute
 *    3. Graph edges must have the "weight" attribute
 *
 * Post-conditions:
 *
 *    1. Graph nodes will have an "order" attribute based on the results of the
 *       algorithm.
 */ function $257d7deb0180286c$var$order(g) {
    var maxRank = $1kMKg.maxRank(g), downLayerGraphs = $257d7deb0180286c$var$buildLayerGraphs(g, $bqfL5.range(1, maxRank + 1), "inEdges"), upLayerGraphs = $257d7deb0180286c$var$buildLayerGraphs(g, $bqfL5.range(maxRank - 1, -1, -1), "outEdges");
    var layering = $7H72Y(g);
    $257d7deb0180286c$var$assignOrder(g, layering);
    var bestCC = Number.POSITIVE_INFINITY, best;
    for(var i = 0, lastBest = 0; lastBest < 4; ++i, ++lastBest){
        $257d7deb0180286c$var$sweepLayerGraphs(i % 2 ? downLayerGraphs : upLayerGraphs, i % 4 >= 2);
        layering = $1kMKg.buildLayerMatrix(g);
        var cc = $lesrU(g, layering);
        if (cc < bestCC) {
            lastBest = 0;
            best = $bqfL5.cloneDeep(layering);
            bestCC = cc;
        }
    }
    $257d7deb0180286c$var$assignOrder(g, best);
}
function $257d7deb0180286c$var$buildLayerGraphs(g, ranks, relationship) {
    return $bqfL5.map(ranks, function(rank) {
        return $lvOrT(g, rank, relationship);
    });
}
function $257d7deb0180286c$var$sweepLayerGraphs(layerGraphs, biasRight) {
    var cg = new $257d7deb0180286c$require$Graph();
    $bqfL5.forEach(layerGraphs, function(lg) {
        var root = lg.graph().root;
        var sorted = $3CKyT(lg, root, cg, biasRight);
        $bqfL5.forEach(sorted.vs, function(v, i) {
            lg.node(v).order = i;
        });
        $7mMpT(lg, cg, sorted.vs);
    });
}
function $257d7deb0180286c$var$assignOrder(g, layering) {
    $bqfL5.forEach(layering, function(layer) {
        $bqfL5.forEach(layer, function(v, i) {
            g.node(v).order = i;
        });
    });
}

});
parcelRegister("7H72Y", function(module, exports) {
"use strict";

var $bqfL5 = parcelRequire("bqfL5");
module.exports = $59a203f227f1c21c$var$initOrder;
/*
 * Assigns an initial order value for each node by performing a DFS search
 * starting from nodes in the first rank. Nodes are assigned an order in their
 * rank as they are first visited.
 *
 * This approach comes from Gansner, et al., "A Technique for Drawing Directed
 * Graphs."
 *
 * Returns a layering matrix with an array per layer and each layer sorted by
 * the order of its nodes.
 */ function $59a203f227f1c21c$var$initOrder(g) {
    var visited = {};
    var simpleNodes = $bqfL5.filter(g.nodes(), function(v) {
        return !g.children(v).length;
    });
    var maxRank = $bqfL5.max($bqfL5.map(simpleNodes, function(v) {
        return g.node(v).rank;
    }));
    var layers = $bqfL5.map($bqfL5.range(maxRank + 1), function() {
        return [];
    });
    function dfs(v) {
        if ($bqfL5.has(visited, v)) return;
        visited[v] = true;
        var node = g.node(v);
        layers[node.rank].push(v);
        $bqfL5.forEach(g.successors(v), dfs);
    }
    var orderedVs = $bqfL5.sortBy(simpleNodes, function(v) {
        return g.node(v).rank;
    });
    $bqfL5.forEach(orderedVs, dfs);
    return layers;
}

});

parcelRegister("lesrU", function(module, exports) {
"use strict";

var $bqfL5 = parcelRequire("bqfL5");
module.exports = $f750f92bb92fe0f2$var$crossCount;
/*
 * A function that takes a layering (an array of layers, each with an array of
 * ordererd nodes) and a graph and returns a weighted crossing count.
 *
 * Pre-conditions:
 *
 *    1. Input graph must be simple (not a multigraph), directed, and include
 *       only simple edges.
 *    2. Edges in the input graph must have assigned weights.
 *
 * Post-conditions:
 *
 *    1. The graph and layering matrix are left unchanged.
 *
 * This algorithm is derived from Barth, et al., "Bilayer Cross Counting."
 */ function $f750f92bb92fe0f2$var$crossCount(g, layering) {
    var cc = 0;
    for(var i = 1; i < layering.length; ++i)cc += $f750f92bb92fe0f2$var$twoLayerCrossCount(g, layering[i - 1], layering[i]);
    return cc;
}
function $f750f92bb92fe0f2$var$twoLayerCrossCount(g, northLayer, southLayer) {
    // Sort all of the edges between the north and south layers by their position
    // in the north layer and then the south. Map these edges to the position of
    // their head in the south layer.
    var southPos = $bqfL5.zipObject(southLayer, $bqfL5.map(southLayer, function(v, i) {
        return i;
    }));
    var southEntries = $bqfL5.flatten($bqfL5.map(northLayer, function(v) {
        return $bqfL5.sortBy($bqfL5.map(g.outEdges(v), function(e) {
            return {
                pos: southPos[e.w],
                weight: g.edge(e).weight
            };
        }), "pos");
    }), true);
    // Build the accumulator tree
    var firstIndex = 1;
    while(firstIndex < southLayer.length)firstIndex <<= 1;
    var treeSize = 2 * firstIndex - 1;
    firstIndex -= 1;
    var tree = $bqfL5.map(new Array(treeSize), function() {
        return 0;
    });
    // Calculate the weighted crossings
    var cc = 0;
    $bqfL5.forEach(southEntries.forEach(function(entry) {
        var index = entry.pos + firstIndex;
        tree[index] += entry.weight;
        var weightSum = 0;
        while(index > 0){
            if (index % 2) weightSum += tree[index + 1];
            index = index - 1 >> 1;
            tree[index] += entry.weight;
        }
        cc += entry.weight * weightSum;
    }));
    return cc;
}

});

parcelRegister("3CKyT", function(module, exports) {

var $bqfL5 = parcelRequire("bqfL5");

var $6dVLr = parcelRequire("6dVLr");

var $7P6no = parcelRequire("7P6no");

var $6WEME = parcelRequire("6WEME");
module.exports = $2a3909eacdbc5484$var$sortSubgraph;
function $2a3909eacdbc5484$var$sortSubgraph(g, v, cg, biasRight) {
    var movable = g.children(v);
    var node = g.node(v);
    var bl = node ? node.borderLeft : undefined;
    var br = node ? node.borderRight : undefined;
    var subgraphs = {};
    if (bl) movable = $bqfL5.filter(movable, function(w) {
        return w !== bl && w !== br;
    });
    var barycenters = $6dVLr(g, movable);
    $bqfL5.forEach(barycenters, function(entry) {
        if (g.children(entry.v).length) {
            var subgraphResult = $2a3909eacdbc5484$var$sortSubgraph(g, entry.v, cg, biasRight);
            subgraphs[entry.v] = subgraphResult;
            if ($bqfL5.has(subgraphResult, "barycenter")) $2a3909eacdbc5484$var$mergeBarycenters(entry, subgraphResult);
        }
    });
    var entries = $7P6no(barycenters, cg);
    $2a3909eacdbc5484$var$expandSubgraphs(entries, subgraphs);
    var result = $6WEME(entries, biasRight);
    if (bl) {
        result.vs = $bqfL5.flatten([
            bl,
            result.vs,
            br
        ], true);
        if (g.predecessors(bl).length) {
            var blPred = g.node(g.predecessors(bl)[0]), brPred = g.node(g.predecessors(br)[0]);
            if (!$bqfL5.has(result, "barycenter")) {
                result.barycenter = 0;
                result.weight = 0;
            }
            result.barycenter = (result.barycenter * result.weight + blPred.order + brPred.order) / (result.weight + 2);
            result.weight += 2;
        }
    }
    return result;
}
function $2a3909eacdbc5484$var$expandSubgraphs(entries, subgraphs) {
    $bqfL5.forEach(entries, function(entry) {
        entry.vs = $bqfL5.flatten(entry.vs.map(function(v) {
            if (subgraphs[v]) return subgraphs[v].vs;
            return v;
        }), true);
    });
}
function $2a3909eacdbc5484$var$mergeBarycenters(target, other) {
    if (!$bqfL5.isUndefined(target.barycenter)) {
        target.barycenter = (target.barycenter * target.weight + other.barycenter * other.weight) / (target.weight + other.weight);
        target.weight += other.weight;
    } else {
        target.barycenter = other.barycenter;
        target.weight = other.weight;
    }
}

});
parcelRegister("6dVLr", function(module, exports) {

var $bqfL5 = parcelRequire("bqfL5");
module.exports = $4880c3b846cacbd2$var$barycenter;
function $4880c3b846cacbd2$var$barycenter(g, movable) {
    return $bqfL5.map(movable, function(v) {
        var inV = g.inEdges(v);
        if (!inV.length) return {
            v: v
        };
        else {
            var result = $bqfL5.reduce(inV, function(acc, e) {
                var edge = g.edge(e), nodeU = g.node(e.v);
                return {
                    sum: acc.sum + edge.weight * nodeU.order,
                    weight: acc.weight + edge.weight
                };
            }, {
                sum: 0,
                weight: 0
            });
            return {
                v: v,
                barycenter: result.sum / result.weight,
                weight: result.weight
            };
        }
    });
}

});

parcelRegister("7P6no", function(module, exports) {
"use strict";

var $bqfL5 = parcelRequire("bqfL5");
module.exports = $5b223e00506bc319$var$resolveConflicts;
/*
 * Given a list of entries of the form {v, barycenter, weight} and a
 * constraint graph this function will resolve any conflicts between the
 * constraint graph and the barycenters for the entries. If the barycenters for
 * an entry would violate a constraint in the constraint graph then we coalesce
 * the nodes in the conflict into a new node that respects the contraint and
 * aggregates barycenter and weight information.
 *
 * This implementation is based on the description in Forster, "A Fast and
 * Simple Hueristic for Constrained Two-Level Crossing Reduction," thought it
 * differs in some specific details.
 *
 * Pre-conditions:
 *
 *    1. Each entry has the form {v, barycenter, weight}, or if the node has
 *       no barycenter, then {v}.
 *
 * Returns:
 *
 *    A new list of entries of the form {vs, i, barycenter, weight}. The list
 *    `vs` may either be a singleton or it may be an aggregation of nodes
 *    ordered such that they do not violate constraints from the constraint
 *    graph. The property `i` is the lowest original index of any of the
 *    elements in `vs`.
 */ function $5b223e00506bc319$var$resolveConflicts(entries, cg) {
    var mappedEntries = {};
    $bqfL5.forEach(entries, function(entry, i) {
        var tmp = mappedEntries[entry.v] = {
            indegree: 0,
            "in": [],
            out: [],
            vs: [
                entry.v
            ],
            i: i
        };
        if (!$bqfL5.isUndefined(entry.barycenter)) {
            tmp.barycenter = entry.barycenter;
            tmp.weight = entry.weight;
        }
    });
    $bqfL5.forEach(cg.edges(), function(e) {
        var entryV = mappedEntries[e.v];
        var entryW = mappedEntries[e.w];
        if (!$bqfL5.isUndefined(entryV) && !$bqfL5.isUndefined(entryW)) {
            entryW.indegree++;
            entryV.out.push(mappedEntries[e.w]);
        }
    });
    var sourceSet = $bqfL5.filter(mappedEntries, function(entry) {
        return !entry.indegree;
    });
    return $5b223e00506bc319$var$doResolveConflicts(sourceSet);
}
function $5b223e00506bc319$var$doResolveConflicts(sourceSet) {
    var entries = [];
    function handleIn(vEntry) {
        return function(uEntry) {
            if (uEntry.merged) return;
            if ($bqfL5.isUndefined(uEntry.barycenter) || $bqfL5.isUndefined(vEntry.barycenter) || uEntry.barycenter >= vEntry.barycenter) $5b223e00506bc319$var$mergeEntries(vEntry, uEntry);
        };
    }
    function handleOut(vEntry) {
        return function(wEntry) {
            wEntry["in"].push(vEntry);
            if (--wEntry.indegree === 0) sourceSet.push(wEntry);
        };
    }
    while(sourceSet.length){
        var entry = sourceSet.pop();
        entries.push(entry);
        $bqfL5.forEach(entry["in"].reverse(), handleIn(entry));
        $bqfL5.forEach(entry.out, handleOut(entry));
    }
    return $bqfL5.map($bqfL5.filter(entries, function(entry) {
        return !entry.merged;
    }), function(entry) {
        return $bqfL5.pick(entry, [
            "vs",
            "i",
            "barycenter",
            "weight"
        ]);
    });
}
function $5b223e00506bc319$var$mergeEntries(target, source) {
    var sum = 0;
    var weight = 0;
    if (target.weight) {
        sum += target.barycenter * target.weight;
        weight += target.weight;
    }
    if (source.weight) {
        sum += source.barycenter * source.weight;
        weight += source.weight;
    }
    target.vs = source.vs.concat(target.vs);
    target.barycenter = sum / weight;
    target.weight = weight;
    target.i = Math.min(source.i, target.i);
    source.merged = true;
}

});

parcelRegister("6WEME", function(module, exports) {

var $bqfL5 = parcelRequire("bqfL5");

var $1kMKg = parcelRequire("1kMKg");
module.exports = $50e7cbac5d0d1447$var$sort;
function $50e7cbac5d0d1447$var$sort(entries, biasRight) {
    var parts = $1kMKg.partition(entries, function(entry) {
        return $bqfL5.has(entry, "barycenter");
    });
    var sortable = parts.lhs, unsortable = $bqfL5.sortBy(parts.rhs, function(entry) {
        return -entry.i;
    }), vs = [], sum = 0, weight = 0, vsIndex = 0;
    sortable.sort($50e7cbac5d0d1447$var$compareWithBias(!!biasRight));
    vsIndex = $50e7cbac5d0d1447$var$consumeUnsortable(vs, unsortable, vsIndex);
    $bqfL5.forEach(sortable, function(entry) {
        vsIndex += entry.vs.length;
        vs.push(entry.vs);
        sum += entry.barycenter * entry.weight;
        weight += entry.weight;
        vsIndex = $50e7cbac5d0d1447$var$consumeUnsortable(vs, unsortable, vsIndex);
    });
    var result = {
        vs: $bqfL5.flatten(vs, true)
    };
    if (weight) {
        result.barycenter = sum / weight;
        result.weight = weight;
    }
    return result;
}
function $50e7cbac5d0d1447$var$consumeUnsortable(vs, unsortable, index) {
    var last;
    while(unsortable.length && (last = $bqfL5.last(unsortable)).i <= index){
        unsortable.pop();
        vs.push(last.vs);
        index++;
    }
    return index;
}
function $50e7cbac5d0d1447$var$compareWithBias(bias) {
    return function(entryV, entryW) {
        if (entryV.barycenter < entryW.barycenter) return -1;
        else if (entryV.barycenter > entryW.barycenter) return 1;
        return !bias ? entryV.i - entryW.i : entryW.i - entryV.i;
    };
}

});


parcelRegister("lvOrT", function(module, exports) {

var $bqfL5 = parcelRequire("bqfL5");

var $6mwJ2 = parcelRequire("6mwJ2");
var $fa93a057a2513c66$require$Graph = $6mwJ2.Graph;
module.exports = $fa93a057a2513c66$var$buildLayerGraph;
/*
 * Constructs a graph that can be used to sort a layer of nodes. The graph will
 * contain all base and subgraph nodes from the request layer in their original
 * hierarchy and any edges that are incident on these nodes and are of the type
 * requested by the "relationship" parameter.
 *
 * Nodes from the requested rank that do not have parents are assigned a root
 * node in the output graph, which is set in the root graph attribute. This
 * makes it easy to walk the hierarchy of movable nodes during ordering.
 *
 * Pre-conditions:
 *
 *    1. Input graph is a DAG
 *    2. Base nodes in the input graph have a rank attribute
 *    3. Subgraph nodes in the input graph has minRank and maxRank attributes
 *    4. Edges have an assigned weight
 *
 * Post-conditions:
 *
 *    1. Output graph has all nodes in the movable rank with preserved
 *       hierarchy.
 *    2. Root nodes in the movable layer are made children of the node
 *       indicated by the root attribute of the graph.
 *    3. Non-movable nodes incident on movable nodes, selected by the
 *       relationship parameter, are included in the graph (without hierarchy).
 *    4. Edges incident on movable nodes, selected by the relationship
 *       parameter, are added to the output graph.
 *    5. The weights for copied edges are aggregated as need, since the output
 *       graph is not a multi-graph.
 */ function $fa93a057a2513c66$var$buildLayerGraph(g, rank, relationship) {
    var root = $fa93a057a2513c66$var$createRootNode(g), result = new $fa93a057a2513c66$require$Graph({
        compound: true
    }).setGraph({
        root: root
    }).setDefaultNodeLabel(function(v) {
        return g.node(v);
    });
    $bqfL5.forEach(g.nodes(), function(v) {
        var node = g.node(v), parent = g.parent(v);
        if (node.rank === rank || node.minRank <= rank && rank <= node.maxRank) {
            result.setNode(v);
            result.setParent(v, parent || root);
            // This assumes we have only short edges!
            $bqfL5.forEach(g[relationship](v), function(e) {
                var u = e.v === v ? e.w : e.v, edge = result.edge(u, v), weight = !$bqfL5.isUndefined(edge) ? edge.weight : 0;
                result.setEdge(u, v, {
                    weight: g.edge(e).weight + weight
                });
            });
            if ($bqfL5.has(node, "minRank")) result.setNode(v, {
                borderLeft: node.borderLeft[rank],
                borderRight: node.borderRight[rank]
            });
        }
    });
    return result;
}
function $fa93a057a2513c66$var$createRootNode(g) {
    var v;
    while(g.hasNode(v = $bqfL5.uniqueId("_root")));
    return v;
}

});

parcelRegister("7mMpT", function(module, exports) {

var $bqfL5 = parcelRequire("bqfL5");
module.exports = $55d025054c74605a$var$addSubgraphConstraints;
function $55d025054c74605a$var$addSubgraphConstraints(g, cg, vs) {
    var prev = {}, rootPrev;
    $bqfL5.forEach(vs, function(v) {
        var child = g.parent(v), parent, prevChild;
        while(child){
            parent = g.parent(child);
            if (parent) {
                prevChild = prev[parent];
                prev[parent] = child;
            } else {
                prevChild = rootPrev;
                rootPrev = child;
            }
            if (prevChild && prevChild !== child) {
                cg.setEdge(prevChild, child);
                return;
            }
            child = parent;
        }
    });
/*
  function dfs(v) {
    var children = v ? g.children(v) : g.children();
    if (children.length) {
      var min = Number.POSITIVE_INFINITY,
          subgraphs = [];
      _.each(children, function(child) {
        var childMin = dfs(child);
        if (g.children(child).length) {
          subgraphs.push({ v: child, order: childMin });
        }
        min = Math.min(min, childMin);
      });
      _.reduce(_.sortBy(subgraphs, "order"), function(prev, curr) {
        cg.setEdge(prev.v, curr.v);
        return curr;
      });
      return min;
    }
    return g.node(v).order;
  }
  dfs(undefined);
  */ }

});


parcelRegister("j257S", function(module, exports) {
"use strict";

var $bqfL5 = parcelRequire("bqfL5");

var $1kMKg = parcelRequire("1kMKg");

var $94mUQ = parcelRequire("94mUQ");
var $ddb22e2223075eef$require$positionX = $94mUQ.positionX;
module.exports = $ddb22e2223075eef$var$position;
function $ddb22e2223075eef$var$position(g) {
    g = $1kMKg.asNonCompoundGraph(g);
    $ddb22e2223075eef$var$positionY(g);
    $bqfL5.forEach($ddb22e2223075eef$require$positionX(g), function(x, v) {
        g.node(v).x = x;
    });
}
function $ddb22e2223075eef$var$positionY(g) {
    var layering = $1kMKg.buildLayerMatrix(g);
    var rankSep = g.graph().ranksep;
    var prevY = 0;
    $bqfL5.forEach(layering, function(layer) {
        var maxHeight = $bqfL5.max($bqfL5.map(layer, function(v) {
            return g.node(v).height;
        }));
        $bqfL5.forEach(layer, function(v) {
            g.node(v).y = prevY + maxHeight / 2;
        });
        prevY += maxHeight + rankSep;
    });
}

});
parcelRegister("94mUQ", function(module, exports) {
"use strict";

var $bqfL5 = parcelRequire("bqfL5");

var $6mwJ2 = parcelRequire("6mwJ2");
var $69a6435f926c5c17$require$Graph = $6mwJ2.Graph;

var $1kMKg = parcelRequire("1kMKg");
/*
 * This module provides coordinate assignment based on Brandes and Köpf, "Fast
 * and Simple Horizontal Coordinate Assignment."
 */ module.exports = {
    positionX: $69a6435f926c5c17$var$positionX,
    findType1Conflicts: $69a6435f926c5c17$var$findType1Conflicts,
    findType2Conflicts: $69a6435f926c5c17$var$findType2Conflicts,
    addConflict: $69a6435f926c5c17$var$addConflict,
    hasConflict: $69a6435f926c5c17$var$hasConflict,
    verticalAlignment: $69a6435f926c5c17$var$verticalAlignment,
    horizontalCompaction: $69a6435f926c5c17$var$horizontalCompaction,
    alignCoordinates: $69a6435f926c5c17$var$alignCoordinates,
    findSmallestWidthAlignment: $69a6435f926c5c17$var$findSmallestWidthAlignment,
    balance: $69a6435f926c5c17$var$balance
};
/*
 * Marks all edges in the graph with a type-1 conflict with the "type1Conflict"
 * property. A type-1 conflict is one where a non-inner segment crosses an
 * inner segment. An inner segment is an edge with both incident nodes marked
 * with the "dummy" property.
 *
 * This algorithm scans layer by layer, starting with the second, for type-1
 * conflicts between the current layer and the previous layer. For each layer
 * it scans the nodes from left to right until it reaches one that is incident
 * on an inner segment. It then scans predecessors to determine if they have
 * edges that cross that inner segment. At the end a final scan is done for all
 * nodes on the current rank to see if they cross the last visited inner
 * segment.
 *
 * This algorithm (safely) assumes that a dummy node will only be incident on a
 * single node in the layers being scanned.
 */ function $69a6435f926c5c17$var$findType1Conflicts(g, layering) {
    var conflicts = {};
    function visitLayer(prevLayer, layer) {
        var // last visited node in the previous layer that is incident on an inner
        // segment.
        k0 = 0, // Tracks the last node in this layer scanned for crossings with a type-1
        // segment.
        scanPos = 0, prevLayerLength = prevLayer.length, lastNode = $bqfL5.last(layer);
        $bqfL5.forEach(layer, function(v, i) {
            var w = $69a6435f926c5c17$var$findOtherInnerSegmentNode(g, v), k1 = w ? g.node(w).order : prevLayerLength;
            if (w || v === lastNode) {
                $bqfL5.forEach(layer.slice(scanPos, i + 1), function(scanNode) {
                    $bqfL5.forEach(g.predecessors(scanNode), function(u) {
                        var uLabel = g.node(u), uPos = uLabel.order;
                        if ((uPos < k0 || k1 < uPos) && !(uLabel.dummy && g.node(scanNode).dummy)) $69a6435f926c5c17$var$addConflict(conflicts, u, scanNode);
                    });
                });
                scanPos = i + 1;
                k0 = k1;
            }
        });
        return layer;
    }
    $bqfL5.reduce(layering, visitLayer);
    return conflicts;
}
function $69a6435f926c5c17$var$findType2Conflicts(g, layering) {
    var conflicts = {};
    function scan(south, southPos, southEnd, prevNorthBorder, nextNorthBorder) {
        var v;
        $bqfL5.forEach($bqfL5.range(southPos, southEnd), function(i) {
            v = south[i];
            if (g.node(v).dummy) $bqfL5.forEach(g.predecessors(v), function(u) {
                var uNode = g.node(u);
                if (uNode.dummy && (uNode.order < prevNorthBorder || uNode.order > nextNorthBorder)) $69a6435f926c5c17$var$addConflict(conflicts, u, v);
            });
        });
    }
    function visitLayer(north, south) {
        var prevNorthPos = -1, nextNorthPos, southPos = 0;
        $bqfL5.forEach(south, function(v, southLookahead) {
            if (g.node(v).dummy === "border") {
                var predecessors = g.predecessors(v);
                if (predecessors.length) {
                    nextNorthPos = g.node(predecessors[0]).order;
                    scan(south, southPos, southLookahead, prevNorthPos, nextNorthPos);
                    southPos = southLookahead;
                    prevNorthPos = nextNorthPos;
                }
            }
            scan(south, southPos, south.length, nextNorthPos, north.length);
        });
        return south;
    }
    $bqfL5.reduce(layering, visitLayer);
    return conflicts;
}
function $69a6435f926c5c17$var$findOtherInnerSegmentNode(g, v) {
    if (g.node(v).dummy) return $bqfL5.find(g.predecessors(v), function(u) {
        return g.node(u).dummy;
    });
}
function $69a6435f926c5c17$var$addConflict(conflicts, v, w) {
    if (v > w) {
        var tmp = v;
        v = w;
        w = tmp;
    }
    var conflictsV = conflicts[v];
    if (!conflictsV) conflicts[v] = conflictsV = {};
    conflictsV[w] = true;
}
function $69a6435f926c5c17$var$hasConflict(conflicts, v, w) {
    if (v > w) {
        var tmp = v;
        v = w;
        w = tmp;
    }
    return $bqfL5.has(conflicts[v], w);
}
/*
 * Try to align nodes into vertical "blocks" where possible. This algorithm
 * attempts to align a node with one of its median neighbors. If the edge
 * connecting a neighbor is a type-1 conflict then we ignore that possibility.
 * If a previous node has already formed a block with a node after the node
 * we're trying to form a block with, we also ignore that possibility - our
 * blocks would be split in that scenario.
 */ function $69a6435f926c5c17$var$verticalAlignment(g, layering, conflicts, neighborFn) {
    var root = {}, align = {}, pos = {};
    // We cache the position here based on the layering because the graph and
    // layering may be out of sync. The layering matrix is manipulated to
    // generate different extreme alignments.
    $bqfL5.forEach(layering, function(layer) {
        $bqfL5.forEach(layer, function(v, order) {
            root[v] = v;
            align[v] = v;
            pos[v] = order;
        });
    });
    $bqfL5.forEach(layering, function(layer) {
        var prevIdx = -1;
        $bqfL5.forEach(layer, function(v) {
            var ws = neighborFn(v);
            if (ws.length) {
                ws = $bqfL5.sortBy(ws, function(w) {
                    return pos[w];
                });
                var mp = (ws.length - 1) / 2;
                for(var i = Math.floor(mp), il = Math.ceil(mp); i <= il; ++i){
                    var w = ws[i];
                    if (align[v] === v && prevIdx < pos[w] && !$69a6435f926c5c17$var$hasConflict(conflicts, v, w)) {
                        align[w] = v;
                        align[v] = root[v] = root[w];
                        prevIdx = pos[w];
                    }
                }
            }
        });
    });
    return {
        root: root,
        align: align
    };
}
function $69a6435f926c5c17$var$horizontalCompaction(g, layering, root, align, reverseSep) {
    // This portion of the algorithm differs from BK due to a number of problems.
    // Instead of their algorithm we construct a new block graph and do two
    // sweeps. The first sweep places blocks with the smallest possible
    // coordinates. The second sweep removes unused space by moving blocks to the
    // greatest coordinates without violating separation.
    var xs = {}, blockG = $69a6435f926c5c17$var$buildBlockGraph(g, layering, root, reverseSep), borderType = reverseSep ? "borderLeft" : "borderRight";
    function iterate(setXsFunc, nextNodesFunc) {
        var stack = blockG.nodes();
        var elem = stack.pop();
        var visited = {};
        while(elem){
            if (visited[elem]) setXsFunc(elem);
            else {
                visited[elem] = true;
                stack.push(elem);
                stack = stack.concat(nextNodesFunc(elem));
            }
            elem = stack.pop();
        }
    }
    // First pass, assign smallest coordinates
    function pass1(elem) {
        xs[elem] = blockG.inEdges(elem).reduce(function(acc, e) {
            return Math.max(acc, xs[e.v] + blockG.edge(e));
        }, 0);
    }
    // Second pass, assign greatest coordinates
    function pass2(elem) {
        var min = blockG.outEdges(elem).reduce(function(acc, e) {
            return Math.min(acc, xs[e.w] - blockG.edge(e));
        }, Number.POSITIVE_INFINITY);
        var node = g.node(elem);
        if (min !== Number.POSITIVE_INFINITY && node.borderType !== borderType) xs[elem] = Math.max(xs[elem], min);
    }
    iterate(pass1, blockG.predecessors.bind(blockG));
    iterate(pass2, blockG.successors.bind(blockG));
    // Assign x coordinates to all nodes
    $bqfL5.forEach(align, function(v) {
        xs[v] = xs[root[v]];
    });
    return xs;
}
function $69a6435f926c5c17$var$buildBlockGraph(g, layering, root, reverseSep) {
    var blockGraph = new $69a6435f926c5c17$require$Graph(), graphLabel = g.graph(), sepFn = $69a6435f926c5c17$var$sep(graphLabel.nodesep, graphLabel.edgesep, reverseSep);
    $bqfL5.forEach(layering, function(layer) {
        var u;
        $bqfL5.forEach(layer, function(v) {
            var vRoot = root[v];
            blockGraph.setNode(vRoot);
            if (u) {
                var uRoot = root[u], prevMax = blockGraph.edge(uRoot, vRoot);
                blockGraph.setEdge(uRoot, vRoot, Math.max(sepFn(g, v, u), prevMax || 0));
            }
            u = v;
        });
    });
    return blockGraph;
}
/*
 * Returns the alignment that has the smallest width of the given alignments.
 */ function $69a6435f926c5c17$var$findSmallestWidthAlignment(g, xss) {
    return $bqfL5.minBy($bqfL5.values(xss), function(xs) {
        var max = Number.NEGATIVE_INFINITY;
        var min = Number.POSITIVE_INFINITY;
        $bqfL5.forIn(xs, function(x, v) {
            var halfWidth = $69a6435f926c5c17$var$width(g, v) / 2;
            max = Math.max(x + halfWidth, max);
            min = Math.min(x - halfWidth, min);
        });
        return max - min;
    });
}
/*
 * Align the coordinates of each of the layout alignments such that
 * left-biased alignments have their minimum coordinate at the same point as
 * the minimum coordinate of the smallest width alignment and right-biased
 * alignments have their maximum coordinate at the same point as the maximum
 * coordinate of the smallest width alignment.
 */ function $69a6435f926c5c17$var$alignCoordinates(xss, alignTo) {
    var alignToVals = $bqfL5.values(alignTo), alignToMin = $bqfL5.min(alignToVals), alignToMax = $bqfL5.max(alignToVals);
    $bqfL5.forEach([
        "u",
        "d"
    ], function(vert) {
        $bqfL5.forEach([
            "l",
            "r"
        ], function(horiz) {
            var alignment = vert + horiz, xs = xss[alignment], delta;
            if (xs === alignTo) return;
            var xsVals = $bqfL5.values(xs);
            delta = horiz === "l" ? alignToMin - $bqfL5.min(xsVals) : alignToMax - $bqfL5.max(xsVals);
            if (delta) xss[alignment] = $bqfL5.mapValues(xs, function(x) {
                return x + delta;
            });
        });
    });
}
function $69a6435f926c5c17$var$balance(xss, align) {
    return $bqfL5.mapValues(xss.ul, function(ignore, v) {
        if (align) return xss[align.toLowerCase()][v];
        else {
            var xs = $bqfL5.sortBy($bqfL5.map(xss, v));
            return (xs[1] + xs[2]) / 2;
        }
    });
}
function $69a6435f926c5c17$var$positionX(g) {
    var layering = $1kMKg.buildLayerMatrix(g);
    var conflicts = $bqfL5.merge($69a6435f926c5c17$var$findType1Conflicts(g, layering), $69a6435f926c5c17$var$findType2Conflicts(g, layering));
    var xss = {};
    var adjustedLayering;
    $bqfL5.forEach([
        "u",
        "d"
    ], function(vert) {
        adjustedLayering = vert === "u" ? layering : $bqfL5.values(layering).reverse();
        $bqfL5.forEach([
            "l",
            "r"
        ], function(horiz) {
            if (horiz === "r") adjustedLayering = $bqfL5.map(adjustedLayering, function(inner) {
                return $bqfL5.values(inner).reverse();
            });
            var neighborFn = (vert === "u" ? g.predecessors : g.successors).bind(g);
            var align = $69a6435f926c5c17$var$verticalAlignment(g, adjustedLayering, conflicts, neighborFn);
            var xs = $69a6435f926c5c17$var$horizontalCompaction(g, adjustedLayering, align.root, align.align, horiz === "r");
            if (horiz === "r") xs = $bqfL5.mapValues(xs, function(x) {
                return -x;
            });
            xss[vert + horiz] = xs;
        });
    });
    var smallestWidth = $69a6435f926c5c17$var$findSmallestWidthAlignment(g, xss);
    $69a6435f926c5c17$var$alignCoordinates(xss, smallestWidth);
    return $69a6435f926c5c17$var$balance(xss, g.graph().align);
}
function $69a6435f926c5c17$var$sep(nodeSep, edgeSep, reverseSep) {
    return function(g, v, w) {
        var vLabel = g.node(v);
        var wLabel = g.node(w);
        var sum = 0;
        var delta;
        sum += vLabel.width / 2;
        if ($bqfL5.has(vLabel, "labelpos")) switch(vLabel.labelpos.toLowerCase()){
            case "l":
                delta = -vLabel.width / 2;
                break;
            case "r":
                delta = vLabel.width / 2;
                break;
        }
        if (delta) sum += reverseSep ? delta : -delta;
        delta = 0;
        sum += (vLabel.dummy ? edgeSep : nodeSep) / 2;
        sum += (wLabel.dummy ? edgeSep : nodeSep) / 2;
        sum += wLabel.width / 2;
        if ($bqfL5.has(wLabel, "labelpos")) switch(wLabel.labelpos.toLowerCase()){
            case "l":
                delta = wLabel.width / 2;
                break;
            case "r":
                delta = -wLabel.width / 2;
                break;
        }
        if (delta) sum += reverseSep ? delta : -delta;
        delta = 0;
        return sum;
    };
}
function $69a6435f926c5c17$var$width(g, v) {
    return g.node(v).width;
}

});



parcelRegister("8XBdx", function(module, exports) {

var $bqfL5 = parcelRequire("bqfL5");

var $1kMKg = parcelRequire("1kMKg");

var $6mwJ2 = parcelRequire("6mwJ2");
var $6860b4009ab03a40$require$Graph = $6mwJ2.Graph;
module.exports = {
    debugOrdering: $6860b4009ab03a40$var$debugOrdering
};
/* istanbul ignore next */ function $6860b4009ab03a40$var$debugOrdering(g) {
    var layerMatrix = $1kMKg.buildLayerMatrix(g);
    var h = new $6860b4009ab03a40$require$Graph({
        compound: true,
        multigraph: true
    }).setGraph({});
    $bqfL5.forEach(g.nodes(), function(v) {
        h.setNode(v, {
            label: v
        });
        h.setParent(v, "layer" + g.node(v).rank);
    });
    $bqfL5.forEach(g.edges(), function(e) {
        h.setEdge(e.v, e.w, {}, e.name);
    });
    $bqfL5.forEach(layerMatrix, function(layer, i) {
        var layerV = "layer" + i;
        h.setNode(layerV, {
            rank: "same"
        });
        $bqfL5.reduce(layer, function(u, v) {
            h.setEdge(u, v, {
                style: "invis"
            });
            return v;
        });
    });
    return h;
}

});

parcelRegister("9Grre", function(module, exports) {
module.exports = "0.8.5";

});




parcelRegister("dwZLd", function(module, exports) {

$parcel$export(module.exports, "IntegrationScopeListItem", () => $9d9e2bdbee4bbdf5$export$850c47653bc5ed82);
$parcel$export(module.exports, "IntegrationScopePicker", () => $9d9e2bdbee4bbdf5$export$dadb819fbe33454e);
$parcel$export(module.exports, "IntegrationScopeOption", () => $9d9e2bdbee4bbdf5$export$43697b580c0086f5);
$parcel$export(module.exports, "IntegrationScopeModeBtn", () => $9d9e2bdbee4bbdf5$export$b4f033e55d74aa71);
$parcel$export(module.exports, "resolveScope", () => $9d9e2bdbee4bbdf5$export$37a93f4c48de2a8d);
$parcel$export(module.exports, "IntegrationScopeBadge", () => $9d9e2bdbee4bbdf5$export$eece0a3f8635d741);
// Shared scope picker for admin → integrations forms.
//
// Writes `{scopeType, scopeId}` into the caller's draft state (via
// `draftKey` — the name of the root state slot the page already uses,
// e.g. `_newSupabaseDraft` for the Supabase page). The caller then
// forwards those two fields to `saveIntegration({...draft, scopeType,
// scopeId})`.
//
// Scope modes:
//   - Org — whole organization. scopeId is null. Default for infra kinds
//     (github, google_workspace, npm).
//   - Workspace — a specific workspace in the org. scopeId = workspaceId.
//     Sources from root.workspaces (flat list) → root.jwtClaims.workspaces
//     (fallback). Filtered in real-time by a search input (§I12).
//   - Project — a specific project. scopeId = projectId. Sources from
//     root.projects (canvas-loaded flat list) → root._scopeProjectsByOrg
//     (governance lazy-fetch). Both sources normalised to { id, key, name }.
//
// Usage in a page:
//
//   IntegrationScopePicker: {
//     draftKey: '_newSupabaseDraft',     // required
//     defaultScopeType: 'project'        // from kind.default_scope
//   }

var $3WCJD = parcelRequire("3WCJD");
// ── Helpers ───────────────────────────────────────────────────────────
// Resolve the workspace list from the two possible root sources.
// Priority: root.workspaces (flat array) → jwtClaims.workspaces.
const $9d9e2bdbee4bbdf5$var$_getWorkspaces = (root)=>{
    const orgId = root?.jwtClaims?.workspace_org_id;
    const list = Array.isArray(root?.workspaces) ? root.workspaces : root?.jwtClaims?.workspaces || [];
    return orgId ? list.filter((w)=>!w.org_id || w.org_id === orgId) : list;
};
// Resolve the project list from the two possible root sources.
// Priority: root.projects (canvas-loaded flat array) →
//           root._scopeProjectsByOrg[orgId] (governance lazy-fetch).
const $9d9e2bdbee4bbdf5$var$_getProjects = (root)=>{
    const orgId = root?.jwtClaims?.workspace_org_id;
    // Canvas context: root.projects is the full flat project list.
    if (Array.isArray(root?.projects) && root.projects.length) return root.projects.map((p)=>({
            id: p.id || p._id || p.key,
            key: p.key || p.slug,
            name: p.name || p.displayName || p.key
        }));
    // Governance context: per-org API cache.
    if (orgId) {
        const cache = (root?._scopeProjectsByOrg || {})[orgId];
        if (Array.isArray(cache)) return cache;
    }
    return [];
};
// Case-insensitive substring filter. Checks `name` and `key` (key may be
// absent for workspace items — that's fine, the OR short-circuits).
const $9d9e2bdbee4bbdf5$var$_filterItems = (items, q)=>{
    if (!q) return items;
    const lq = q.toLowerCase();
    return items.filter((it)=>(it.name || it.label || '').toLowerCase().includes(lq) || (it.key || '').toLowerCase().includes(lq));
};
// ── Lazy project-load (governance context) ───────────────────────────
const $9d9e2bdbee4bbdf5$var$_ensureProjectsLoaded = async (root, { force: force = false } = {})=>{
    if (typeof window === 'undefined') return;
    const orgId = root?.jwtClaims?.workspace_org_id;
    if (!orgId) {
        $9d9e2bdbee4bbdf5$var$_startWatcher(root);
        return;
    }
    const cache = root._scopeProjectsByOrg || {};
    if (!force && Array.isArray(cache[orgId])) return;
    if (root._scopeProjectsInFlight?.[orgId]) return;
    root._scopeProjectsInFlight = {
        ...root._scopeProjectsInFlight || {},
        [orgId]: true
    };
    const clearFlight = ()=>{
        const flight = {
            ...root._scopeProjectsInFlight || {}
        };
        delete flight[orgId];
        root._scopeProjectsInFlight = flight;
    };
    const orgs = root?.jwtClaims?.orgs || [];
    const org = orgs.find((o)=>(o.id || o._id) === orgId);
    const slug = org?.slug || org?.username;
    if (!slug) {
        clearFlight();
        $9d9e2bdbee4bbdf5$var$_startWatcher(root);
        return;
    }
    // Channel-resolved (single source of truth via @symbo.ls/channels).
    // SYMBOLS_API_URL env override is honored inside the resolver.
    const base = (0, $3WCJD.apiUrl)();
    const token = window.localStorage.getItem('symbols_bridge_access_token') || window.localStorage.getItem('symbols_access_token');
    if (!token) {
        clearFlight();
        root.update({
            _scopeProjectsByOrg: {
                ...cache,
                [orgId]: []
            },
            _scopeProjectsError: {
                ...root._scopeProjectsError || {},
                [orgId]: 'Not signed in'
            }
        });
        return;
    }
    let items = [];
    let errorMsg = null;
    try {
        const url = `${base.replace(/\/+$/, '')}/projects?owner=${encodeURIComponent(slug)}&limit=100`;
        const res = await fetch(url, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        if (!res.ok) errorMsg = res.status === 429 ? 'Rate limited' : `HTTP ${res.status}`;
        else {
            const json = await res.json().catch(()=>null);
            items = (json?.data || json?.items || []).map((p)=>({
                    id: p.id || p._id,
                    name: p.name || p.displayName || p.key,
                    key: p.key || p.slug
                }));
        }
    } catch (err) {
        errorMsg = err?.message || 'Fetch failed';
    } finally{
        root.update({
            _scopeProjectsByOrg: {
                ...root._scopeProjectsByOrg || {},
                [orgId]: items
            },
            _scopeProjectsError: {
                ...root._scopeProjectsError || {},
                [orgId]: errorMsg
            }
        });
        clearFlight();
    }
};
const $9d9e2bdbee4bbdf5$var$_startWatcher = (root)=>{
    if (typeof window === 'undefined') return;
    if (root._scopeProjectsWatcher) return;
    const started = Date.now();
    root._scopeProjectsWatcher = setInterval(()=>{
        const orgId = root?.jwtClaims?.workspace_org_id;
        const orgs = root?.jwtClaims?.orgs || [];
        const hasSlug = orgs.some((o)=>(o.id || o._id) === orgId && (o.slug || o.username));
        if (orgId && hasSlug) {
            $9d9e2bdbee4bbdf5$var$_stopWatcher(root);
            $9d9e2bdbee4bbdf5$var$_ensureProjectsLoaded(root);
        } else if (Date.now() - started > 30000) {
            $9d9e2bdbee4bbdf5$var$_stopWatcher(root);
            if (orgId) root.update({
                _scopeProjectsByOrg: {
                    ...root._scopeProjectsByOrg || {},
                    [orgId]: []
                },
                _scopeProjectsError: {
                    ...root._scopeProjectsError || {},
                    [orgId]: 'Session not loaded'
                }
            });
        }
    }, 1000);
};
const $9d9e2bdbee4bbdf5$var$_stopWatcher = (root)=>{
    if (root?._scopeProjectsWatcher) {
        clearInterval(root._scopeProjectsWatcher);
        root._scopeProjectsWatcher = null;
    }
};
const $9d9e2bdbee4bbdf5$export$850c47653bc5ed82 = {
    tag: 'button',
    type: 'button',
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    gap: 'Z',
    align: 'center left',
    width: '100%',
    padding: 'V Z1',
    border: 'none',
    background: (el, s)=>s._selected ? 'blue.1' : 'transparent',
    color: (el, s)=>s._selected ? 'blue' : 'title',
    cursor: 'pointer',
    fontSize: 'Z2',
    textAlign: 'left',
    ':hover': {
        background: 'overlayStrong'
    },
    Label: {
        tag: 'span',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        text: (el, s)=>s._label || ''
    },
    Check: {
        tag: 'span',
        fontSize: 'Y1',
        color: 'blue',
        hide: (el, s)=>!s._selected,
        text: "\u2713"
    },
    // Generic click handler: reads _draftKey, _scopeType, _value from state.
    // Workspace list sets _scopeType:'workspace', project list sets 'project'.
    onClick: (e, el, s)=>{
        const dk = s._draftKey;
        if (!dk) return;
        const type = s._scopeType || 'project';
        const clearKey = type === 'workspace' ? '_scopeWsQuery' : '_scopeProjQuery';
        s.root.update({
            [dk]: {
                ...s.root?.[dk] || {},
                scopeType: type,
                scopeId: s._value || null,
                _scopeManualMode: false
            },
            [clearKey]: ''
        });
    }
};
const $9d9e2bdbee4bbdf5$export$dadb819fbe33454e = {
    flow: 'y',
    gap: 'V',
    onDestroy: (el, s)=>$9d9e2bdbee4bbdf5$var$_stopWatcher(s?.root),
    Label: {
        tag: 'label',
        fontSize: 'Y2',
        color: 'caption',
        fontWeight: '700',
        text: 'Scope'
    },
    Hint: {
        tag: 'p',
        fontSize: 'Y2',
        color: 'caption',
        margin: '0 0 V 0',
        text: 'Org-wide infra (SSO, code) should stay at org scope. Per-product integrations (databases, analytics) are best scoped to a project so the editor only surfaces them inside that project.'
    },
    Modes: {
        flow: 'x',
        gap: 'Z',
        childExtends: 'IntegrationScopeModeBtn',
        childrenAs: 'state',
        children: (el, s)=>{
            const draftKey = el?.parent?.draftKey || s.draftKey;
            return [
                'org',
                'workspace',
                'project'
            ].map((type)=>({
                    type: type,
                    label: type === 'org' ? 'Org' : type === 'workspace' ? 'Workspace' : 'Project',
                    draftKey: draftKey
                }));
        }
    },
    // ── Workspace search-dropdown (§I12) ──────────────────────────────
    WorkspaceDropdown: {
        hide: (el, s)=>{
            const draft = s.root?.[s.draftKey] || {};
            return (draft.scopeType || s.defaultScopeType || 'org') !== 'workspace';
        },
        marginTop: 'V',
        flow: 'y',
        gap: 'V',
        // Selected-value badge — shows the chosen workspace name above the list.
        SelectedBadge: {
            tag: 'span',
            padding: 'V Z',
            round: 'Y',
            fontSize: 'Y1',
            fontWeight: '600',
            background: 'blue.1',
            color: 'blue',
            hide: (el, s)=>{
                const dk = s.draftKey;
                return !dk || !(s.root?.[dk] || {}).scopeId;
            },
            text: (el, s)=>{
                const dk = s.draftKey;
                if (!dk) return '';
                const scopeId = (s.root?.[dk] || {}).scopeId;
                if (!scopeId) return '';
                const ws = $9d9e2bdbee4bbdf5$var$_getWorkspaces(s.root);
                const found = ws.find((w)=>(w.id || w.workspace_id || w._id) === scopeId);
                return `Selected: ${found ? found.name || found.id : String(scopeId).slice(0, 10) + "\u2026"}`;
            }
        },
        SearchInput: {
            tag: 'input',
            type: 'text',
            width: '100%',
            padding: 'V Z1',
            round: 'Y',
            background: 'document',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'line',
            color: 'title',
            fontSize: 'Z2',
            placeholder: "Search workspaces\u2026",
            value: (el, s)=>s.root?._scopeWsQuery || '',
            onInput: (e, el, s)=>s.root.update({
                    _scopeWsQuery: e.target.value
                })
        },
        List: {
            flow: 'y',
            maxHeight: 'E',
            overflowY: 'auto',
            round: 'Y',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'line',
            background: 'document',
            childExtends: 'IntegrationScopeListItem',
            childrenAs: 'state',
            children: (el, s)=>{
                const dk = s.draftKey;
                const q = s.root?._scopeWsQuery || '';
                const curId = dk ? (s.root?.[dk] || {}).scopeId || '' : '';
                const ws = $9d9e2bdbee4bbdf5$var$_getWorkspaces(s.root).map((w)=>({
                        id: w.id || w.workspace_id || w._id,
                        name: w.name || w.id || w.workspace_id
                    }));
                const filtered = $9d9e2bdbee4bbdf5$var$_filterItems(ws, q);
                return filtered.map((it)=>({
                        _value: it.id,
                        _label: it.name,
                        _selected: it.id === curId,
                        _draftKey: dk,
                        _scopeType: 'workspace'
                    }));
            },
            Empty: {
                tag: 'span',
                padding: 'V Z1',
                fontSize: 'Z2',
                color: 'caption',
                fontStyle: 'italic',
                hide: (el, s)=>{
                    const dk = s.draftKey;
                    const q = s.root?._scopeWsQuery || '';
                    const ws = $9d9e2bdbee4bbdf5$var$_getWorkspaces(s.root);
                    return $9d9e2bdbee4bbdf5$var$_filterItems(ws, q).length > 0;
                },
                text: (el, s)=>{
                    const q = s.root?._scopeWsQuery || '';
                    const total = $9d9e2bdbee4bbdf5$var$_getWorkspaces(s.root).length;
                    if (!total) return 'No workspaces in this org.';
                    return q ? `No matches for "${q}".` : 'No workspaces found.';
                }
            }
        }
    },
    // ── Project search-dropdown (§I12) ────────────────────────────────
    ProjectDropdown: {
        hide: (el, s)=>{
            const draft = s.root?.[s.draftKey] || {};
            return (draft.scopeType || s.defaultScopeType || 'org') !== 'project';
        },
        marginTop: 'V',
        flow: 'y',
        gap: 'V',
        // Trigger API fetch if root.projects is empty (governance context).
        onRender: (el, s)=>{
            const draft = s.root?.[s.draftKey] || {};
            const active = (draft.scopeType || s.parent?.defaultScopeType || 'org') === 'project';
            if (active && !(Array.isArray(s.root?.projects) && s.root.projects.length)) $9d9e2bdbee4bbdf5$var$_ensureProjectsLoaded(s.root);
        },
        // Selected-value badge.
        SelectedBadge: {
            tag: 'span',
            padding: 'V Z',
            round: 'Y',
            fontSize: 'Y1',
            fontWeight: '600',
            background: 'blue.1',
            color: 'blue',
            hide: (el, s)=>{
                const dk = s.draftKey;
                return !dk || !(s.root?.[dk] || {}).scopeId;
            },
            text: (el, s)=>{
                const dk = s.draftKey;
                if (!dk) return '';
                const scopeId = (s.root?.[dk] || {}).scopeId;
                if (!scopeId) return '';
                const projects = $9d9e2bdbee4bbdf5$var$_getProjects(s.root);
                const found = projects.find((p)=>(p.id || p.key) === scopeId);
                return `Selected: ${found ? found.name || found.key : String(scopeId).slice(0, 10) + "\u2026"}`;
            }
        },
        // Loading / error hints.
        LoadingHint: {
            tag: 'span',
            fontSize: 'Y1',
            color: 'caption',
            fontStyle: 'italic',
            hide: (el, s)=>{
                if (Array.isArray(s.root?.projects) && s.root.projects.length) return true;
                const orgId = s.root?.jwtClaims?.workspace_org_id;
                return orgId && Array.isArray((s.root?._scopeProjectsByOrg || {})[orgId]);
            },
            text: "Loading projects\u2026"
        },
        ErrorHint: {
            tag: 'span',
            fontSize: 'Y1',
            color: 'red',
            hide: (el, s)=>{
                const orgId = s.root?.jwtClaims?.workspace_org_id;
                return !orgId || !(s.root?._scopeProjectsError || {})[orgId];
            },
            text: (el, s)=>{
                const orgId = s.root?.jwtClaims?.workspace_org_id;
                const err = orgId ? (s.root?._scopeProjectsError || {})[orgId] : null;
                return err ? `Could not load projects: ${err}` : '';
            }
        },
        SearchInput: {
            tag: 'input',
            type: 'text',
            width: '100%',
            padding: 'V Z1',
            round: 'Y',
            background: 'document',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'line',
            color: 'title',
            fontSize: 'Z2',
            placeholder: "Search projects\u2026",
            value: (el, s)=>s.root?._scopeProjQuery || '',
            onInput: (e, el, s)=>s.root.update({
                    _scopeProjQuery: e.target.value
                })
        },
        List: {
            flow: 'y',
            maxHeight: 'E',
            overflowY: 'auto',
            round: 'Y',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'line',
            background: 'document',
            childExtends: 'IntegrationScopeListItem',
            childrenAs: 'state',
            children: (el, s)=>{
                const dk = s.draftKey;
                const q = s.root?._scopeProjQuery || '';
                const curId = dk ? (s.root?.[dk] || {}).scopeId || '' : '';
                const projects = $9d9e2bdbee4bbdf5$var$_getProjects(s.root);
                const filtered = $9d9e2bdbee4bbdf5$var$_filterItems(projects, q);
                return filtered.map((p)=>({
                        _value: p.id || p.key,
                        _label: p.name || p.key || p.id,
                        _selected: (p.id || p.key) === curId,
                        _draftKey: dk,
                        _scopeType: 'project'
                    }));
            },
            Empty: {
                tag: 'span',
                padding: 'V Z1',
                fontSize: 'Z2',
                color: 'caption',
                fontStyle: 'italic',
                hide: (el, s)=>{
                    const q = s.root?._scopeProjQuery || '';
                    const projects = $9d9e2bdbee4bbdf5$var$_getProjects(s.root);
                    // Hide empty message while loading.
                    if (!(Array.isArray(s.root?.projects) && s.root.projects.length) && !Array.isArray((s.root?._scopeProjectsByOrg || {})[s.root?.jwtClaims?.workspace_org_id])) return true;
                    return $9d9e2bdbee4bbdf5$var$_filterItems(projects, q).length > 0;
                },
                text: (el, s)=>{
                    const q = s.root?._scopeProjQuery || '';
                    const total = $9d9e2bdbee4bbdf5$var$_getProjects(s.root).length;
                    if (!total) return 'No projects in this org.';
                    return q ? `No matches for "${q}".` : 'No projects found.';
                }
            }
        },
        // Toggle between list and manual-ID entry.
        ManualEntryToggle: {
            tag: 'button',
            type: 'button',
            padding: 'V Z',
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            fontSize: 'Y1',
            color: 'caption',
            textDecoration: 'underline',
            textAlign: 'left',
            text: (el, s)=>{
                const dk = s.draftKey;
                return (s.root?.[dk] || {})._scopeManualMode ? "\u2190 Back to list" : '+ Enter project ID manually';
            },
            onClick: (e, el, s)=>{
                const dk = s.draftKey;
                if (!dk) return;
                const current = s.root?.[dk] || {};
                s.root.update({
                    [dk]: {
                        ...current,
                        _scopeManualMode: !current._scopeManualMode
                    }
                });
            }
        },
        ManualEntryRow: {
            hide: (el, s)=>{
                const dk = s.draftKey;
                return !dk || !(s.root?.[dk] || {})._scopeManualMode;
            },
            flow: 'y',
            gap: 'V',
            Label: {
                tag: 'label',
                fontSize: 'Y1',
                color: 'caption',
                text: 'Project ID'
            },
            Input: {
                tag: 'input',
                type: 'text',
                width: '100%',
                padding: 'Z',
                round: 'Y',
                background: 'document',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: 'line',
                color: 'title',
                fontSize: 'Z2',
                placeholder: 'e.g. prj_abc123',
                value: (el, s)=>(s.root?.[s.draftKey] || {}).scopeId || '',
                onInput: (e, el, s)=>{
                    const dk = s.draftKey;
                    if (!dk) return;
                    s.root.update({
                        [dk]: {
                            ...s.root?.[dk] || {},
                            scopeType: 'project',
                            scopeId: e.target.value || null,
                            _scopeManualMode: true
                        }
                    });
                }
            }
        }
    }
};
const $9d9e2bdbee4bbdf5$export$43697b580c0086f5 = {
    tag: 'option',
    text: (el, s)=>s.label || '',
    onCreate: (el, s)=>{
        if (el.node) el.node.value = s.value == null ? '' : s.value;
    },
    onUpdate: (el, s)=>{
        if (el.node) el.node.value = s.value == null ? '' : s.value;
    }
};
const $9d9e2bdbee4bbdf5$export$b4f033e55d74aa71 = {
    tag: 'button',
    type: 'button',
    padding: 'V Z',
    round: 'Y',
    borderWidth: '1px',
    borderStyle: 'solid',
    fontSize: 'Y2',
    fontWeight: '700',
    cursor: 'pointer',
    background: (el, s)=>{
        const parent = s.parent || {};
        const draft = s.root?.[s.draftKey] || {};
        const active = (draft.scopeType || parent.defaultScopeType || 'org') === s.type;
        return active ? 'blue' : 'transparent';
    },
    color: (el, s)=>{
        const parent = s.parent || {};
        const draft = s.root?.[s.draftKey] || {};
        const active = (draft.scopeType || parent.defaultScopeType || 'org') === s.type;
        return active ? 'white' : 'title';
    },
    borderColor: 'line',
    text: (el, s)=>s.label,
    onClick: (e, el, s)=>{
        s.root.update({
            [s.draftKey]: {
                ...s.root?.[s.draftKey] || {},
                scopeType: s.type,
                scopeId: s.type === 'org' ? null : (s.root?.[s.draftKey] || {}).scopeId || null
            },
            // Clear search queries on mode switch.
            _scopeWsQuery: '',
            _scopeProjQuery: ''
        });
    }
};
const $9d9e2bdbee4bbdf5$export$37a93f4c48de2a8d = (draft, defaultScopeType = 'org')=>{
    const scopeType = draft?.scopeType || defaultScopeType;
    if (scopeType === 'org') return {
        scopeType: 'org',
        scopeId: null
    };
    return {
        scopeType: scopeType,
        scopeId: draft?.scopeId || null
    };
};
const $9d9e2bdbee4bbdf5$export$eece0a3f8635d741 = {
    tag: 'span',
    padding: 'V Z',
    round: 'Y',
    fontSize: 'Y1',
    fontWeight: '700',
    background: 'overlayStrong',
    color: 'caption',
    text: (el, s)=>{
        if (!s.scope_type || s.scope_type === 'org') return 'Org';
        const label = s.scope_type === 'workspace' ? 'Workspace' : 'Project';
        const short = s.scope_id ? `: ${String(s.scope_id).slice(0, 6)}\u{2026}` : '';
        return `${label}${short}`;
    }
};

});

parcelRegister("ks3O5", function(module, exports) {

$parcel$export(module.exports, "GenericIntNewForm", () => $ee396024eb1ef751$export$66bd1d1d68b298dc);
$parcel$export(module.exports, "GenericIntConfigField", () => $ee396024eb1ef751$export$2fe77bdc79972d76);
$parcel$export(module.exports, "GenericIntInstanceCard", () => $ee396024eb1ef751$export$310e84e07e2f1fd);
// Host contract: route matches `/admin/integrations/<kind>` (or sets
// `root._genericIntKindOverride`); `root._integrationHub` populated by
// `loadIntegrationCatalogue`; `root._genericIntFormOpen` toggles the form.

var $e92gD = parcelRequire("e92gD");

var $arXLg = parcelRequire("arXLg");
const $ee396024eb1ef751$var$_DRAFT_KEY = '_genericIntDraft';
const $ee396024eb1ef751$var$_kindFromRoot = (root)=>{
    const override = root?._genericIntKindOverride;
    if (typeof override === 'string' && override) return override;
    const m = String(root?.currentPath || '').match(/^\/admin\/integrations\/([^?#/]+)/);
    return m ? m[1] : null;
};
const $ee396024eb1ef751$var$_kindRow = (root)=>{
    const kind = $ee396024eb1ef751$var$_kindFromRoot(root);
    if (!kind) return null;
    return (root?._integrationHub?.kinds || []).find((k)=>k.kind === kind) || null;
};
// ui_flow hint column (migration 0074) — tells the form which variant
// UX to render. Today the column is populated only for registrar rows
// (backfill) but no registrar rows exist in `integration_kinds` yet,
// so every form instance evaluates to 'credential'. Wiring lives
// here so MARKETPLACE's future `MarketplaceRegistrarDomainPicker` +
// the OAuth2 connect button can drop in without touching save/delete
// logic. See NEEDED_FOR_MARKETPLACE.md § REQUEST tick-3.
const $ee396024eb1ef751$var$_uiFlow = (root)=>{
    const kr = $ee396024eb1ef751$var$_kindRow(root);
    return kr?.ui_flow || 'credential';
};
// Toast helper — openNotification depends on editor-app internals and
// throws when GlobalNotification isn't fully wired (e.g. on the workspace app).
// Swallowing the throw keeps the save/delete flow intact even if the
// toast infrastructure is missing; fall back to console for diagnostics.
const $ee396024eb1ef751$var$_toast = (el, payload)=>{
    try {
        el.call('openNotification', payload);
    } catch (err) {
        console.warn('[integration]', payload.title, payload.message || '', err);
    }
};
const $ee396024eb1ef751$var$_saveNew = async (el, s)=>{
    const orgId = s.root?.jwtClaims?.workspace_org_id;
    if (!orgId) {
        $ee396024eb1ef751$var$_toast(el, {
            title: 'No active workspace',
            type: 'error'
        });
        return;
    }
    const kind = $ee396024eb1ef751$var$_kindFromRoot(s.root);
    const kindRow = $ee396024eb1ef751$var$_kindRow(s.root);
    const draft = s.root?.[$ee396024eb1ef751$var$_DRAFT_KEY] || {};
    const fields = kindRow?.config_schema?.fields || [];
    for (const f of fields)if (f.required && !draft[f.key]) {
        $ee396024eb1ef751$var$_toast(el, {
            title: 'Missing required field',
            message: `"${f.label}" is required.`,
            type: 'error'
        });
        return;
    }
    const config = {};
    for (const f of fields)if (draft[f.key] != null && draft[f.key] !== '') config[f.key] = draft[f.key];
    const displayName = draft.displayName || config.display_name || kind;
    const slug = kindRow?.allows_multiple ? (0, $arXLg.slugify)(draft.slug || draft.displayName || kind) : 'default';
    const { scopeType: scopeType, scopeId: scopeId } = el.call('resolveScope', draft, kindRow?.default_scope || 'org');
    if ((scopeType === 'workspace' || scopeType === 'project') && !scopeId) {
        $ee396024eb1ef751$var$_toast(el, {
            title: 'Scope ID required',
            message: `Select or enter a ${scopeType} ID.`,
            type: 'error'
        });
        return;
    }
    const { ok: ok, body: body } = await (0, $e92gD.saveIntegration)({
        orgId: orgId,
        kind: kind,
        slug: slug,
        displayName: displayName,
        config: config,
        secret: draft.secret || undefined,
        scopeType: scopeType,
        scopeId: scopeId,
        enabled: true
    });
    if (ok) {
        s.root.update({
            [$ee396024eb1ef751$var$_DRAFT_KEY]: null,
            _genericIntFormOpen: false
        });
        // Reload the catalogue so the new instance appears in the list.
        // Host page can bolt on a `loadCatalogue` function; try el.call so
        // the form doesn't hard-couple to a specific loader name.
        try {
            await el.call('reloadIntegrationHub');
        } catch  {}
        $ee396024eb1ef751$var$_toast(el, {
            title: `Connected ${displayName}`,
            type: 'success'
        });
    } else $ee396024eb1ef751$var$_toast(el, {
        title: 'Connect failed',
        message: body?.error || 'Unknown error',
        type: 'error'
    });
};
const $ee396024eb1ef751$var$_deleteInstance = async (el, s, slug, scopeType, scopeId)=>{
    const orgId = s.root?.jwtClaims?.workspace_org_id;
    if (!orgId) return;
    const kind = $ee396024eb1ef751$var$_kindFromRoot(s.root);
    const { ok: ok, body: body } = await (0, $e92gD.deleteIntegration)({
        orgId: orgId,
        kind: kind,
        slug: slug,
        scopeType: scopeType,
        scopeId: scopeId
    });
    if (ok) {
        try {
            await el.call('reloadIntegrationHub');
        } catch  {}
        $ee396024eb1ef751$var$_toast(el, {
            title: 'Disconnected',
            type: 'success'
        });
    } else $ee396024eb1ef751$var$_toast(el, {
        title: 'Remove failed',
        message: body?.error || 'Server error',
        type: 'error'
    });
};
// ── §I12 Instance reorder helpers ───────────────────────────────────
//
// HTML5 drag-and-drop reorder for GenericIntInstanceCard lists.
// We store the drag source slug on root._genericIntDragSlug so the
// dragover / drop handlers can read it regardless of which nested
// element fires the event.
//
// On drop we:
//   1. Reorder root._integrationHub.integrations in-memory (instant UI).
//   2. Derive the new slug order for the affected (kind, scope) subset.
//   3. Call reorderIntegrations() to persist positions server-side.
const $ee396024eb1ef751$var$_instancesForKindScope = (root)=>{
    const kind = $ee396024eb1ef751$var$_kindFromRoot(root);
    if (!kind) return [];
    return (root?._integrationHub?.integrations || []).filter((i)=>i.kind === kind);
};
const $ee396024eb1ef751$var$_reorderInHub = (root, kind, fromSlug, toSlug)=>{
    if (fromSlug === toSlug) return;
    const all = root?._integrationHub?.integrations || [];
    const kindItems = all.filter((i)=>i.kind === kind);
    const others = all.filter((i)=>i.kind !== kind);
    const fromIdx = kindItems.findIndex((i)=>i.slug === fromSlug);
    const toIdx = kindItems.findIndex((i)=>i.slug === toSlug);
    if (fromIdx < 0 || toIdx < 0) return;
    const reordered = [
        ...kindItems
    ];
    const [moved] = reordered.splice(fromIdx, 1);
    reordered.splice(toIdx, 0, moved);
    root.update({
        _integrationHub: {
            ...root._integrationHub,
            integrations: [
                ...others,
                ...reordered
            ]
        },
        _genericIntDragSlug: null,
        _genericIntDragOverSlug: null
    });
};
const $ee396024eb1ef751$var$_persistReorder = async (el, s)=>{
    const orgId = s.root?.jwtClaims?.workspace_org_id;
    if (!orgId) return;
    const kind = $ee396024eb1ef751$var$_kindFromRoot(s.root);
    if (!kind) return;
    const items = $ee396024eb1ef751$var$_instancesForKindScope(s.root);
    if (items.length < 2) return;
    const kindRow = $ee396024eb1ef751$var$_kindRow(s.root);
    const scopeType = items[0]?.scope_type || kindRow?.default_scope || 'org';
    const scopeId = items[0]?.scope_id || null;
    const slugs = items.map((i)=>i.slug);
    const { ok: ok, body: body } = await (0, $e92gD.reorderIntegrations)({
        orgId: orgId,
        kind: kind,
        slugs: slugs,
        scopeType: scopeType,
        scopeId: scopeId
    });
    if (!ok) $ee396024eb1ef751$var$_toast(el, {
        title: 'Reorder save failed',
        message: body?.error || 'Unknown error',
        type: 'error'
    });
};
const $ee396024eb1ef751$export$66bd1d1d68b298dc = {
    hide: (el, s)=>!s.root?._genericIntFormOpen,
    flow: 'y',
    gap: 'Z1',
    padding: 'A',
    round: 'Z1',
    background: 'overlay',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'line',
    FormTitle: {
        tag: 'h3',
        fontSize: 'A',
        fontWeight: '700',
        color: 'title',
        margin: '0',
        text: (el, s)=>{
            const kr = $ee396024eb1ef751$var$_kindRow(s.root);
            return `Connect${kr?.label ? ` ${kr.label}` : ''}`;
        }
    },
    DisplayName: {
        flow: 'y',
        gap: 'V',
        hide: (el, s)=>!$ee396024eb1ef751$var$_kindRow(s.root)?.allows_multiple,
        Label: {
            tag: 'label',
            fontSize: 'Y2',
            color: 'caption',
            fontWeight: '700',
            text: 'Display name'
        },
        Input: {
            tag: 'input',
            type: 'text',
            width: '100%',
            padding: 'Z',
            round: 'Y',
            background: 'document',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'line',
            color: 'title',
            fontSize: 'Z2',
            placeholder: (el, s)=>$ee396024eb1ef751$var$_kindRow(s.root)?.label || 'My integration',
            value: (el, s)=>s.root?.[$ee396024eb1ef751$var$_DRAFT_KEY]?.displayName || '',
            onInput: (e, el, s)=>{
                s.root.update({
                    [$ee396024eb1ef751$var$_DRAFT_KEY]: {
                        ...s.root?.[$ee396024eb1ef751$var$_DRAFT_KEY] || {},
                        displayName: e.target.value
                    }
                });
            }
        }
    },
    ConfigFields: {
        flow: 'y',
        gap: 'Z1',
        childExtends: 'GenericIntConfigField',
        childrenAs: 'state',
        children: (el, s)=>{
            const fields = $ee396024eb1ef751$var$_kindRow(s.root)?.config_schema?.fields || [];
            return fields.filter((f)=>f.key !== 'display_name');
        }
    },
    IntegrationScopePicker: {
        draftKey: $ee396024eb1ef751$var$_DRAFT_KEY,
        defaultScopeType: (el, s)=>$ee396024eb1ef751$var$_kindRow(s.root)?.default_scope || 'org'
    },
    SecretField: {
        flow: 'y',
        gap: 'V',
        // Hide when:
        //   - no kind row yet,
        //   - auth_model='none' (no credential needed),
        //   - ui_flow='oauth2' (user connects via provider dialog, not a typed secret),
        //   - ui_flow='webhook' (URL is the credential, collected in ConfigFields).
        // Registrar + credential flows keep the field visible.
        hide: (el, s)=>{
            const kr = $ee396024eb1ef751$var$_kindRow(s.root);
            if (!kr || kr.auth_model === 'none') return true;
            const flow = $ee396024eb1ef751$var$_uiFlow(s.root);
            return flow === 'oauth2' || flow === 'webhook';
        },
        Label: {
            tag: 'label',
            fontSize: 'Y2',
            color: 'caption',
            fontWeight: '700',
            text: (el, s)=>$ee396024eb1ef751$var$_kindRow(s.root)?.secret_label || 'API key / Secret'
        },
        Hint: {
            tag: 'p',
            fontSize: 'Y1',
            color: 'caption',
            margin: '0 0 V 0',
            hide: (el, s)=>!$ee396024eb1ef751$var$_kindRow(s.root)?.secret_hint,
            text: (el, s)=>$ee396024eb1ef751$var$_kindRow(s.root)?.secret_hint || ''
        },
        Input: {
            tag: 'input',
            type: 'password',
            width: '100%',
            padding: 'Z',
            round: 'Y',
            background: 'document',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'line',
            color: 'title',
            fontSize: 'Z2',
            placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022",
            value: (el, s)=>s.root?.[$ee396024eb1ef751$var$_DRAFT_KEY]?.secret || '',
            onInput: (e, el, s)=>{
                s.root.update({
                    [$ee396024eb1ef751$var$_DRAFT_KEY]: {
                        ...s.root?.[$ee396024eb1ef751$var$_DRAFT_KEY] || {},
                        secret: e.target.value
                    }
                });
            }
        }
    },
    // OAuth2 flow replaces the secret field — user connects via provider
    // dialog instead of typing a key. `startOAuthFlow` is a registered
    // function in `workspace/packages/workspace/functions/` (INTEGRATIONS
    // scope). Today it's a stub; wired fully when DOMAIN's Cloudflare
    // registrar / other OAuth2 kinds land. MARKETPLACE tick 4 spec.
    MarketplaceOAuthConnectButton: {
        if: (el, s)=>$ee396024eb1ef751$var$_uiFlow(s.root) === 'oauth2'
    },
    // Registrar flow adds a domain management card AFTER the secret
    // field — user enters API key first, then uses the picker to search /
    // register domains via `sdk-bridge.callCapability`. v0 is a hint
    // card; MARKETPLACE replaces with search+results UI once DOMAIN's
    // first provider handler (porkbun.ts — shipped 2026-04-24) is wired
    // into `integration-call`'s dispatch table. MARKETPLACE tick 4 spec.
    MarketplaceRegistrarDomainPicker: {
        if: (el, s)=>$ee396024eb1ef751$var$_uiFlow(s.root) === 'registrar'
    },
    Actions: {
        flow: 'x',
        gap: 'Z',
        align: 'center flex-end',
        marginTop: 'Z',
        CancelBtn: {
            tag: 'button',
            type: 'button',
            padding: 'V A',
            round: 'Y',
            background: 'transparent',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'line',
            color: 'title',
            fontSize: 'Y2',
            cursor: 'pointer',
            text: 'Cancel',
            onClick: (e, el, s)=>{
                s.root.update({
                    _genericIntFormOpen: false,
                    [$ee396024eb1ef751$var$_DRAFT_KEY]: null
                });
            }
        },
        SaveBtn: {
            tag: 'button',
            type: 'button',
            padding: 'V A',
            round: 'Y',
            background: 'blue',
            color: 'white',
            fontSize: 'Y2',
            fontWeight: '700',
            cursor: 'pointer',
            border: 'none',
            text: (el, s)=>s.root?._genericIntSaving ? "Connecting\u2026" : 'Connect',
            onClick: async (e, el, s)=>{
                s.root.update({
                    _genericIntSaving: true
                });
                await $ee396024eb1ef751$var$_saveNew(el, s);
                s.root.update({
                    _genericIntSaving: false
                });
            }
        }
    }
};
const $ee396024eb1ef751$export$2fe77bdc79972d76 = {
    flow: 'y',
    gap: 'V',
    Label: {
        tag: 'label',
        fontSize: 'Y2',
        color: 'caption',
        fontWeight: '700',
        text: (el, s)=>{
            const req = s.required ? ' *' : '';
            return (s.label || s.key || '') + req;
        }
    },
    Input: {
        tag: 'input',
        type: 'text',
        width: '100%',
        padding: 'Z',
        round: 'Y',
        background: 'document',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'line',
        color: 'title',
        fontSize: 'Z2',
        placeholder: (el, s)=>s.placeholder || '',
        value: (el, s)=>s.root?.[$ee396024eb1ef751$var$_DRAFT_KEY]?.[s.key] || '',
        onInput: (e, el, s)=>{
            s.root.update({
                [$ee396024eb1ef751$var$_DRAFT_KEY]: {
                    ...s.root?.[$ee396024eb1ef751$var$_DRAFT_KEY] || {},
                    [s.key]: e.target.value
                }
            });
        }
    }
};
const $ee396024eb1ef751$export$310e84e07e2f1fd = {
    flow: 'y',
    gap: 'Z',
    padding: 'A',
    round: 'Z1',
    background: 'overlay',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: (el, s)=>s.root?._genericIntDragOverSlug === s.slug ? 'blue' : 'line',
    opacity: (el, s)=>s.root?._genericIntDragSlug === s.slug ? '0.4' : '1',
    // §I12 — drag-and-drop reorder
    draggable: 'true',
    onDragStart: (e, el, s)=>{
        s.root.update({
            _genericIntDragSlug: s.slug
        });
        e.dataTransfer.effectAllowed = 'move';
    },
    onDragOver: (e, el, s)=>{
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
        const dragSlug = s.root?._genericIntDragSlug;
        if (dragSlug && dragSlug !== s.slug) s.root.update({
            _genericIntDragOverSlug: s.slug
        });
    },
    onDragLeave: (e, el, s)=>{
        if (s.root?._genericIntDragOverSlug === s.slug) s.root.update({
            _genericIntDragOverSlug: null
        });
    },
    onDrop: async (e, el, s)=>{
        e.preventDefault();
        const fromSlug = s.root?._genericIntDragSlug;
        const toSlug = s.slug;
        if (!fromSlug || fromSlug === toSlug) {
            s.root.update({
                _genericIntDragSlug: null,
                _genericIntDragOverSlug: null
            });
            return;
        }
        const kind = $ee396024eb1ef751$var$_kindFromRoot(s.root);
        $ee396024eb1ef751$var$_reorderInHub(s.root, kind, fromSlug, toSlug);
        await $ee396024eb1ef751$var$_persistReorder(el, s);
    },
    onDragEnd: (e, el, s)=>{
        s.root.update({
            _genericIntDragSlug: null,
            _genericIntDragOverSlug: null
        });
    },
    Header: {
        flow: 'x',
        align: 'center space-between',
        Left: {
            flow: 'x',
            gap: 'Z',
            align: 'center',
            DragHandle: {
                tag: 'span',
                text: "\u283F",
                color: 'caption',
                fontSize: 'A',
                cursor: 'grab',
                // Prevent text selection during drag
                userSelect: 'none'
            },
            Name: {
                tag: 'span',
                fontSize: 'A',
                fontWeight: '700',
                color: 'title',
                text: (el, s)=>s.display_name || s.slug || ''
            },
            IntegrationScopeBadge: {}
        },
        Right: {
            flow: 'x',
            gap: 'Z',
            align: 'center',
            StatusPill: {
                padding: 'V Z',
                round: 'Y',
                fontSize: 'Y1',
                fontWeight: '700',
                background: (el, s)=>s.enabled ? 'green' : 'overlayStrong',
                color: (el, s)=>s.enabled ? 'white' : 'caption',
                text: (el, s)=>s.enabled ? 'Live' : 'Disabled'
            },
            TestBtn: {
                tag: 'button',
                type: 'button',
                hide: (el, s)=>{
                    const caps = $ee396024eb1ef751$var$_kindRow(s.root)?.capabilities || [];
                    return caps.length === 0 || !s.enabled;
                },
                padding: 'V Z',
                round: 'Y',
                background: 'transparent',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: 'line',
                color: 'title',
                fontSize: 'Y2',
                cursor: 'pointer',
                disabled: (el, s)=>!!s.root?._genericIntTesting?.[s.slug],
                text: (el, s)=>s.root?._genericIntTesting?.[s.slug] ? "Testing\u2026" : 'Test',
                onClick: async (e, el, s)=>{
                    const orgId = s.root?.jwtClaims?.workspace_org_id;
                    if (!orgId) return;
                    const caps = $ee396024eb1ef751$var$_kindRow(s.root)?.capabilities || [];
                    if (!caps.length) return;
                    s.root.update({
                        _genericIntTesting: {
                            ...s.root?._genericIntTesting || {},
                            [s.slug]: true
                        }
                    });
                    const res = await (0, $e92gD.callCapability)({
                        orgId: orgId,
                        kind: $ee396024eb1ef751$var$_kindFromRoot(s.root),
                        slug: s.slug
                    }, caps[0], {});
                    s.root.update({
                        _genericIntTesting: {
                            ...s.root?._genericIntTesting || {},
                            [s.slug]: false
                        }
                    });
                    $ee396024eb1ef751$var$_toast(el, res?.error ? {
                        title: 'Test failed',
                        message: res.error,
                        type: 'error'
                    } : {
                        title: "Test passed \u2713",
                        type: 'success'
                    });
                }
            },
            RemoveBtn: {
                tag: 'button',
                type: 'button',
                padding: 'V Z',
                round: 'Y',
                background: 'transparent',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: 'line',
                color: 'red',
                fontSize: 'Y2',
                cursor: 'pointer',
                text: 'Remove',
                onClick: async (e, el, s)=>{
                    await $ee396024eb1ef751$var$_deleteInstance(el, s, s.slug, s.scope_type, s.scope_id);
                }
            }
        }
    },
    ConfigPreview: {
        flow: 'y',
        gap: 'V',
        hide: (el, s)=>{
            const cfg = s.config;
            return !cfg || Object.keys(cfg).length === 0;
        },
        children: (el, s)=>{
            const cfg = s.config || {};
            return Object.entries(cfg).filter(([k])=>!k.includes('secret') && !k.includes('key') && !k.includes('token')).slice(0, 4).map(([k, v])=>({
                    key: k,
                    value: String(v)
                }));
        },
        childrenAs: 'state',
        childExtends: {
            flow: 'x',
            gap: 'Z',
            fontSize: 'Y2',
            Key: {
                color: 'caption',
                text: (el, s)=>s.key || '',
                minWidth: '120px'
            },
            Value: {
                color: 'title',
                text: (el, s)=>s.value || "\u2014",
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            }
        }
    }
};

});
parcelRegister("e92gD", function(module, exports) {

$parcel$export(module.exports, "callIntegrationOp", () => $a4c3aa2b1dc2b504$export$e39f0ece227c588f);
$parcel$export(module.exports, "callCapability", () => $a4c3aa2b1dc2b504$export$415cb9dbfbcf662e);
$parcel$export(module.exports, "listExternalSupabaseProjects", () => $a4c3aa2b1dc2b504$export$85588f1c8341c62c);
$parcel$export(module.exports, "listOrgIntegrations", () => $a4c3aa2b1dc2b504$export$ff50ba736d55c110);
$parcel$export(module.exports, "introspectExternalSupabase", () => $a4c3aa2b1dc2b504$export$6ece0c758f9c6a6);
$parcel$export(module.exports, "selectExternalSupabase", () => $a4c3aa2b1dc2b504$export$8323150a0bdc34f8);
$parcel$export(module.exports, "insertExternalSupabase", () => $a4c3aa2b1dc2b504$export$8afdc7a20b5025ed);
$parcel$export(module.exports, "updateExternalSupabase", () => $a4c3aa2b1dc2b504$export$58fada43babf3773);
$parcel$export(module.exports, "deleteExternalSupabase", () => $a4c3aa2b1dc2b504$export$9d290c8fb95e325d);
$parcel$export(module.exports, "rpcExternalSupabase", () => $a4c3aa2b1dc2b504$export$475722e542aaebd5);
$parcel$export(module.exports, "saveIntegration", () => $a4c3aa2b1dc2b504$export$6b400a7c808bfba0);
$parcel$export(module.exports, "deleteIntegration", () => $a4c3aa2b1dc2b504$export$ba41385ae01ee131);
$parcel$export(module.exports, "addIntegrationFromMarketplace", () => $a4c3aa2b1dc2b504$export$1cf78abcf6d94c6d);
$parcel$export(module.exports, "assignIntegrationScope", () => $a4c3aa2b1dc2b504$export$e0a7ede0704bb4eb);
$parcel$export(module.exports, "reorderIntegrations", () => $a4c3aa2b1dc2b504$export$cd37fb6f2cf1af92);
$parcel$export(module.exports, "loadIntegrationCatalogue", () => $a4c3aa2b1dc2b504$export$1587fb5beefd14b4);
$parcel$export(module.exports, "loadIntegrationUnits", () => $a4c3aa2b1dc2b504$export$53f09f566140490d);
$parcel$export(module.exports, "loadOrgIntegrations", () => $a4c3aa2b1dc2b504$export$68742fc05db98ed0);
$parcel$export(module.exports, "loadWorkspaceIntegrations", () => $a4c3aa2b1dc2b504$export$32940dd3fd7222d6);
$parcel$export(module.exports, "loadProjectIntegrations", () => $a4c3aa2b1dc2b504$export$bb68030dbea98deb);
$parcel$export(module.exports, "listIntegrationKinds", () => $a4c3aa2b1dc2b504$export$670cac04aa7a321c);
$parcel$export(module.exports, "findIntegrationsByCapability", () => $a4c3aa2b1dc2b504$export$861c105576c0b303);
// Client-side entry point for external integration operations.
//
// Governance-owned integrations (kind='supabase_project', 'github',
// 'google_workspace', 'npm', etc.) live in the `org_integrations` table
// of the governance Supabase project. Their secrets live in Vault.
// Neither secrets nor service-role keys can ever reach the browser —
// all ops have to round-trip through a server-side edge function.
//
// `callIntegrationOp()` is that round trip. It:
//   1. Reads the active user's governance JWT from the Supabase client.
//   2. POSTs the op body to `external-supabase-query` with that JWT.
//   3. Returns the parsed JSON response, whose shape is
//      `{ ok: true, op, result }` on success, `{ error: string }` on
//      failure.
//
// The edge function re-checks org membership from the JWT's
// `app_metadata.orgs` claim. It will 403 if the caller isn't in the
// org, 404 if the integration isn't configured, 500 on upstream errors.
//
// The function name "external-supabase-query" is historic — it handles
// not only Supabase CRUD but also `list_projects` and
// `list_integrations` which are governance-local. Everything else
// resolves a per-(org,kind,slug) external target before executing.
//
// Admin ops (writing integration config/secret, deleting) go through
// the `integration-admin` edge function via the private `_adminCall`
// helper below — same JWT auth, but the edge function additionally
// verifies admin/owner membership before touching Vault.

var $3WCJD = parcelRequire("3WCJD");

var $8RlGv = parcelRequire("8RlGv");

var $arXLg = parcelRequire("arXLg");
// ---------- Mongo (Symbols server) cutover flag ----------
//
// Env var: SYMBOLS_APP_USE_MONGO_INTEGRATIONS
//
// Feature flag: when set to "1" / "true" / "yes" / "on" (case-insensitive),
// every admin / read / capability call is routed to the Symbols server's
// /org-integrations/* REST endpoints (Mongo-backed) with the user's
// governance JWT as a bearer. When unset or falsy (default), we keep
// hitting the Supabase edge functions + RPCs exactly as before.
//
// Flip per environment once the server routes land and the data copy
// completes. See NEEDED_FOR_SERVER.md §Integrations for the server
// contract this path expects, and server/.env.example for the full list
// of related env vars (SYMBOLS_APP_USE_MONGO_INTEGRATIONS, SYMBOLS_API_URL).
//
// Migration status (2026-04-25): server routes are live; data copy in
// progress. Default remains false until the cutover is confirmed stable.
const $a4c3aa2b1dc2b504$var$_env = (key)=>{
    try {
        return '';
    } catch  {
        return '';
    }
};
const $a4c3aa2b1dc2b504$var$_useMongo = ()=>/^(1|true|yes|on)$/i.test($a4c3aa2b1dc2b504$var$_env('SYMBOLS_APP_USE_MONGO_INTEGRATIONS'));
// Server URL resolves via @symbo.ls/channels: SYMBOLS_API_URL > channel name
// (NODE_ENV) > defaultChannel ('next').
const $a4c3aa2b1dc2b504$var$_serverBase = ()=>(0, $3WCJD.apiUrl)().replace(/\/+$/, '');
const $a4c3aa2b1dc2b504$var$_serverFetch = async (path, { method: method = 'GET', body: body } = {})=>{
    const token = await $a4c3aa2b1dc2b504$var$_getAccessToken();
    if (!token) return {
        error: 'not authenticated'
    };
    try {
        const res = await fetch(`${$a4c3aa2b1dc2b504$var$_serverBase()}${path}`, {
            method: method,
            headers: {
                Authorization: `Bearer ${token}`,
                ...body ? {
                    'Content-Type': 'application/json'
                } : {}
            },
            body: body ? JSON.stringify(body) : undefined
        });
        const json = await res.json().catch(()=>null);
        if (!res.ok) return {
            error: json?.error || `HTTP ${res.status}`,
            status: res.status
        };
        return json || {
            error: 'empty response'
        };
    } catch (err) {
        return {
            error: err?.message || 'network error'
        };
    }
};
// Resolve the governance Supabase URL from the configured client. All
// edge functions live under `${url}/functions/v1/<name>`; we never
// hardcode the URL so env-switched setups (dev vs prod) "just work".
const $a4c3aa2b1dc2b504$var$_externalQueryUrl = ()=>{
    const client = (0, $8RlGv.getClient)((0, $8RlGv.PROJECT_GOVERNANCE));
    // supabase-js v2 stashes the URL on the rest builder.
    const url = client?.supabaseUrl || client?.rest?.url || '';
    if (!url) throw new Error("integrations: governance client has no URL \u2014 is configure() called?");
    return `${url.replace(/\/+$/, '')}/functions/v1/external-supabase-query`;
};
// Active session access token — required for the edge function's JWT
// check. Returns null when the user isn't signed in, so the caller can
// surface a friendly auth error instead of spinning.
const $a4c3aa2b1dc2b504$var$_getAccessToken = async ()=>{
    const client = (0, $8RlGv.getClient)((0, $8RlGv.PROJECT_GOVERNANCE));
    if (!client) return null;
    const { data: data } = await client.auth.getSession();
    return data?.session?.access_token || null;
};
const $a4c3aa2b1dc2b504$export$e39f0ece227c588f = async (body)=>{
    if ($a4c3aa2b1dc2b504$var$_useMongo()) {
        const op = body?.op;
        if (op === 'list_integrations') {
            const r = await $a4c3aa2b1dc2b504$var$_serverFetch(`/org-integrations?orgId=${encodeURIComponent(body.orgId)}`);
            return r.error ? r : {
                ok: true,
                op: op,
                result: r.integrations || []
            };
        }
        if (op === 'list_projects') {
            const r = await $a4c3aa2b1dc2b504$var$_serverFetch(`/org-integrations?orgId=${encodeURIComponent(body.orgId)}&kind=supabase_project`);
            return r.error ? r : {
                ok: true,
                op: op,
                result: (r.integrations || []).filter((i)=>i.kind === 'supabase_project')
            };
        }
        // Per-integration ops → capability call. Supabase kinds always.
        const SB_OPS = {
            introspect: 'schema.introspect',
            select: 'data.read',
            insert: 'data.write',
            update: 'data.write',
            delete: 'data.write',
            rpc: 'rpc.call'
        };
        const capability = SB_OPS[op];
        if (!capability) return {
            error: `unknown op for mongo dispatcher: ${op}`
        };
        return $a4c3aa2b1dc2b504$export$415cb9dbfbcf662e({
            orgId: body.orgId,
            kind: 'supabase_project',
            slug: body.slug || 'default'
        }, capability, {
            ...body,
            op: undefined,
            orgId: undefined,
            slug: undefined
        });
    }
    const token = await $a4c3aa2b1dc2b504$var$_getAccessToken();
    if (!token) return {
        error: 'not authenticated'
    };
    try {
        const res = await fetch($a4c3aa2b1dc2b504$var$_externalQueryUrl(), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(body)
        });
        const json = await res.json().catch(()=>null);
        if (!res.ok) return {
            error: json?.error || `HTTP ${res.status}`,
            status: res.status
        };
        return json || {
            error: 'empty response'
        };
    } catch (err) {
        return {
            error: err?.message || 'network error'
        };
    }
};
const $a4c3aa2b1dc2b504$export$85588f1c8341c62c = (orgId)=>$a4c3aa2b1dc2b504$export$e39f0ece227c588f({
        op: 'list_projects',
        orgId: orgId
    });
const $a4c3aa2b1dc2b504$export$ff50ba736d55c110 = (orgId)=>{
    if ($a4c3aa2b1dc2b504$var$_useMongo()) return $a4c3aa2b1dc2b504$var$_serverFetch(`/org-integrations?orgId=${encodeURIComponent(orgId)}`).then((r)=>r.error ? r : {
            ok: true,
            result: r.integrations || []
        });
    return $a4c3aa2b1dc2b504$export$e39f0ece227c588f({
        op: 'list_integrations',
        orgId: orgId
    });
};
const $a4c3aa2b1dc2b504$export$6ece0c758f9c6a6 = (orgId, slug = 'default')=>$a4c3aa2b1dc2b504$export$e39f0ece227c588f({
        op: 'introspect',
        orgId: orgId,
        slug: slug
    });
const $a4c3aa2b1dc2b504$export$8323150a0bdc34f8 = (orgId, slug, table, opts = {})=>$a4c3aa2b1dc2b504$export$e39f0ece227c588f({
        op: 'select',
        orgId: orgId,
        slug: slug,
        table: table,
        columns: opts.columns,
        filters: opts.filters,
        order: opts.order,
        limit: opts.limit,
        offset: opts.offset
    });
const $a4c3aa2b1dc2b504$export$8afdc7a20b5025ed = (orgId, slug, table, data)=>$a4c3aa2b1dc2b504$export$e39f0ece227c588f({
        op: 'insert',
        orgId: orgId,
        slug: slug,
        table: table,
        data: data
    });
const $a4c3aa2b1dc2b504$export$58fada43babf3773 = (orgId, slug, table, filters, data)=>$a4c3aa2b1dc2b504$export$e39f0ece227c588f({
        op: 'update',
        orgId: orgId,
        slug: slug,
        table: table,
        filters: filters,
        data: data
    });
const $a4c3aa2b1dc2b504$export$9d290c8fb95e325d = (orgId, slug, table, filters)=>$a4c3aa2b1dc2b504$export$e39f0ece227c588f({
        op: 'delete',
        orgId: orgId,
        slug: slug,
        table: table,
        filters: filters
    });
const $a4c3aa2b1dc2b504$export$475722e542aaebd5 = (orgId, slug, rpcName, rpcArgs = {})=>$a4c3aa2b1dc2b504$export$e39f0ece227c588f({
        op: 'rpc',
        orgId: orgId,
        slug: slug,
        rpc_name: rpcName,
        rpc_args: rpcArgs
    });
// ---------- admin ops (integration config CRUD) ----------
//
// These go through the `integration-admin` edge function which
// validates the user JWT, checks admin/owner membership on the target
// org, then performs the vault + org_integrations upsert.
//
// A browser-direct path (user JWT) keeps the system self-contained:
// no dependency on the Symbols server's HMAC proxy layer shipping.
// Admin membership is verified on the edge function side so we can't
// skip it by tampering with the request.
const $a4c3aa2b1dc2b504$var$_adminUrl = ()=>{
    const client = (0, $8RlGv.getClient)((0, $8RlGv.PROJECT_GOVERNANCE));
    const url = client?.supabaseUrl || client?.rest?.url || '';
    if (!url) throw new Error('integrations: governance client has no URL');
    return `${url.replace(/\/+$/, '')}/functions/v1/integration-admin`;
};
const $a4c3aa2b1dc2b504$var$_adminCall = async (op, args)=>{
    const client = (0, $8RlGv.getClient)((0, $8RlGv.PROJECT_GOVERNANCE));
    if (!client) return {
        ok: false,
        body: {
            error: 'no governance client'
        }
    };
    const { data: data } = await client.auth.getSession();
    const token = data?.session?.access_token;
    if (!token) return {
        ok: false,
        body: {
            error: 'not authenticated'
        }
    };
    try {
        const res = await fetch($a4c3aa2b1dc2b504$var$_adminUrl(), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                op: op,
                ...args
            })
        });
        const body = await res.json().catch(()=>null);
        return {
            ok: res.ok,
            body: body,
            status: res.status
        };
    } catch (err) {
        return {
            ok: false,
            body: {
                error: err?.message || 'network error'
            }
        };
    }
};
const $a4c3aa2b1dc2b504$export$6b400a7c808bfba0 = (args)=>$a4c3aa2b1dc2b504$var$_useMongo() ? $a4c3aa2b1dc2b504$var$_serverFetch('/org-integrations', {
        method: 'POST',
        body: args
    }) : $a4c3aa2b1dc2b504$var$_adminCall('upsert', args);
const $a4c3aa2b1dc2b504$export$ba41385ae01ee131 = (args)=>$a4c3aa2b1dc2b504$var$_useMongo() ? $a4c3aa2b1dc2b504$var$_serverFetch('/org-integrations', {
        method: 'DELETE',
        body: args
    }) : $a4c3aa2b1dc2b504$var$_adminCall('delete', args);
const $a4c3aa2b1dc2b504$export$1cf78abcf6d94c6d = (args)=>{
    if (!args?.kind) return Promise.resolve({
        ok: false,
        body: {
            error: 'kind required'
        }
    });
    const scopeType = args.scopeType || 'org';
    return $a4c3aa2b1dc2b504$export$6b400a7c808bfba0({
        orgId: args.orgId,
        kind: args.kind,
        slug: (0, $arXLg.slugify)(args.displayName || args.config?.display_name || args.kind),
        displayName: args.displayName || args.kind,
        config: args.config || {},
        secret: args.secret,
        scopeType: scopeType,
        scopeId: scopeType === 'org' ? null : args.scopeId || null,
        enabled: true
    });
};
const $a4c3aa2b1dc2b504$export$e0a7ede0704bb4eb = (args)=>$a4c3aa2b1dc2b504$var$_useMongo() ? $a4c3aa2b1dc2b504$var$_serverFetch('/org-integrations/assign-scope', {
        method: 'POST',
        body: args
    }) : $a4c3aa2b1dc2b504$var$_adminCall('assign_scope', args);
const $a4c3aa2b1dc2b504$export$cd37fb6f2cf1af92 = (args)=>$a4c3aa2b1dc2b504$var$_useMongo() ? $a4c3aa2b1dc2b504$var$_serverFetch('/org-integrations/reorder', {
        method: 'POST',
        body: args
    }) : $a4c3aa2b1dc2b504$var$_adminCall('reorder', args);
const $a4c3aa2b1dc2b504$export$1587fb5beefd14b4 = async (orgId)=>{
    if ($a4c3aa2b1dc2b504$var$_useMongo()) {
        const [kindsRes, integrationsRes] = await Promise.all([
            $a4c3aa2b1dc2b504$var$_serverFetch('/org-integrations/kinds'),
            orgId ? $a4c3aa2b1dc2b504$var$_serverFetch(`/org-integrations?orgId=${encodeURIComponent(orgId)}`) : Promise.resolve({
                integrations: []
            })
        ]);
        return {
            kinds: kindsRes?.kinds || [],
            integrations: integrationsRes?.integrations || []
        };
    }
    const client = (0, $8RlGv.getClient)((0, $8RlGv.PROJECT_GOVERNANCE));
    if (!client) return {
        kinds: [],
        integrations: []
    };
    const [kindsRes, integrationsRes] = await Promise.all([
        client.from('integration_kinds').select('*').order('sort_order'),
        orgId ? client.rpc('list_org_integrations', {
            p_org_id: orgId
        }) : Promise.resolve({
            data: []
        })
    ]);
    return {
        kinds: kindsRes.data || [],
        integrations: integrationsRes.data || []
    };
};
// ---------- scope-aware unified reader ----------
//
// The "integration units" shape. One entry per configured kind at the
// requested scope (with parent-scope inheritance by default). Built on
// top of `list_org_integrations(p_org_id, p_scope_type, p_scope_id,
// p_include_parents)` which handles the inheritance query server-side.
//
// Shape returned:
//   [{
//     kind, label, category, icon, description,
//     auth_model, default_scope, capabilities, allows_multiple,
//     instances: [
//       { slug, display_name, scope_type, scope_id, config, enabled, has_secret, updated_at }
//     ],
//     count
//   }, …]
//
// Scope descriptor:
//   { type: 'org' | 'workspace' | 'project', orgId, id?, includeParents? }
//
// `id` is required for workspace/project scope. `includeParents` defaults
// to true — a project view merges project + workspace + org rows so
// child contexts inherit org-wide infra (github, google_workspace, etc).
const $a4c3aa2b1dc2b504$var$_fold = (kinds, integrations)=>{
    const byKind = {};
    for (const k of kinds || [])byKind[k.kind] = {
        kind: k.kind,
        label: k.label,
        category: k.category,
        icon: k.icon,
        description: k.description,
        auth_model: k.auth_model,
        default_scope: k.default_scope,
        capabilities: k.capabilities || [],
        allows_multiple: k.allows_multiple,
        instances: [],
        count: 0
    };
    for (const i of integrations || []){
        const unit = byKind[i.kind];
        if (!unit) continue;
        unit.instances.push({
            slug: i.slug,
            display_name: i.display_name,
            scope_type: i.scope_type,
            scope_id: i.scope_id,
            config: i.config,
            enabled: i.enabled,
            has_secret: i.has_secret,
            updated_at: i.updated_at
        });
        unit.count += 1;
    }
    return Object.values(byKind).sort((a, b)=>a.category.localeCompare(b.category));
};
const $a4c3aa2b1dc2b504$export$53f09f566140490d = async (scope = {})=>{
    const { type: type = 'org', orgId: orgId, id: id = null, includeParents: includeParents = true } = scope;
    if (!orgId) return [];
    if ((type === 'workspace' || type === 'project') && !id) throw new Error(`loadIntegrationUnits: scope.id required for type="${type}"`);
    if ($a4c3aa2b1dc2b504$var$_useMongo()) {
        const qs = new URLSearchParams({
            orgId: orgId,
            scopeType: type,
            ...id ? {
                scopeId: id
            } : {},
            includeParents: String(includeParents)
        });
        const [kindsRes, rowsRes] = await Promise.all([
            $a4c3aa2b1dc2b504$var$_serverFetch('/org-integrations/kinds'),
            $a4c3aa2b1dc2b504$var$_serverFetch(`/org-integrations?${qs.toString()}`)
        ]);
        return $a4c3aa2b1dc2b504$var$_fold(kindsRes?.kinds || [], rowsRes?.integrations || []);
    }
    const client = (0, $8RlGv.getClient)((0, $8RlGv.PROJECT_GOVERNANCE));
    if (!client) return [];
    const [kindsRes, rowsRes] = await Promise.all([
        client.rpc('list_integration_kinds'),
        client.rpc('list_org_integrations', {
            p_org_id: orgId,
            p_scope_type: type,
            p_scope_id: id,
            p_include_parents: includeParents
        })
    ]);
    return $a4c3aa2b1dc2b504$var$_fold(kindsRes.data || [], rowsRes.data || []);
};
const $a4c3aa2b1dc2b504$export$68742fc05db98ed0 = (orgId, opts = {})=>$a4c3aa2b1dc2b504$export$53f09f566140490d({
        type: 'org',
        orgId: orgId,
        ...opts
    });
const $a4c3aa2b1dc2b504$export$32940dd3fd7222d6 = (orgId, workspaceId, opts = {})=>$a4c3aa2b1dc2b504$export$53f09f566140490d({
        type: 'workspace',
        orgId: orgId,
        id: workspaceId,
        ...opts
    });
const $a4c3aa2b1dc2b504$export$bb68030dbea98deb = (orgId, projectId, opts = {})=>$a4c3aa2b1dc2b504$export$53f09f566140490d({
        type: 'project',
        orgId: orgId,
        id: projectId,
        ...opts
    });
const $a4c3aa2b1dc2b504$export$670cac04aa7a321c = async ()=>{
    if ($a4c3aa2b1dc2b504$var$_useMongo()) {
        const res = await $a4c3aa2b1dc2b504$var$_serverFetch('/org-integrations/kinds');
        return res?.kinds || [];
    }
    const client = (0, $8RlGv.getClient)((0, $8RlGv.PROJECT_GOVERNANCE));
    if (!client) return [];
    const res = await client.rpc('list_integration_kinds');
    return res.data || [];
};
const $a4c3aa2b1dc2b504$export$861c105576c0b303 = async (capability, scope)=>{
    const units = await $a4c3aa2b1dc2b504$export$53f09f566140490d(scope);
    return units.filter((u)=>(u.capabilities || []).includes(capability));
};
// ---------- capability execution ----------
//
// Generic verb dispatcher. The edge function `integration-call` looks
// up the integration row by (orgId, scope, kind, slug), verifies the
// caller's org membership, and routes to a per-kind handler. The
// capability string ('webhook.trigger', 'http.request', 'metric.query',
// …) tells the handler *what* to do; `args` is opaque payload.
//
// For data ops on a supabase_project, keep using the dedicated helpers
// (selectExternalSupabase, etc.) — they're thinner and typed. Use this
// for n8n, custom_http, google_analytics, and future kinds.
//
// ref shape: { orgId, kind, slug?='default', scopeType?='org', scopeId?=null }
const $a4c3aa2b1dc2b504$var$_callUrl = ()=>{
    const client = (0, $8RlGv.getClient)((0, $8RlGv.PROJECT_GOVERNANCE));
    const url = client?.supabaseUrl || client?.rest?.url || '';
    if (!url) throw new Error('sdk-bridge: governance client has no URL');
    return `${url.replace(/\/+$/, '')}/functions/v1/integration-call`;
};
const $a4c3aa2b1dc2b504$export$415cb9dbfbcf662e = async (ref, capability, args = {})=>{
    const body = {
        orgId: ref.orgId,
        kind: ref.kind,
        slug: ref.slug || 'default',
        scopeType: ref.scopeType || 'org',
        scopeId: ref.scopeId ?? null,
        capability: capability,
        args: args
    };
    if ($a4c3aa2b1dc2b504$var$_useMongo()) return $a4c3aa2b1dc2b504$var$_serverFetch('/org-integrations/call', {
        method: 'POST',
        body: body
    });
    const token = await $a4c3aa2b1dc2b504$var$_getAccessToken();
    if (!token) return {
        error: 'not authenticated'
    };
    try {
        const res = await fetch($a4c3aa2b1dc2b504$var$_callUrl(), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(body)
        });
        const json = await res.json().catch(()=>null);
        if (!res.ok) return {
            error: json?.error || `HTTP ${res.status}`,
            status: res.status
        };
        return json || {
            error: 'empty response'
        };
    } catch (err) {
        return {
            error: err?.message || 'network error'
        };
    }
};

});
parcelRegister("arXLg", function(module, exports) {

$parcel$export(module.exports, "slugify", () => $79bac85824086cd0$export$c383cdd2a518017a);
// Lowercase, hyphen-joined, alphanumeric-only slug. Defaults to 40 chars
// max with a random fallback so callers always get a non-empty result.
const $79bac85824086cd0$export$c383cdd2a518017a = (s, { maxLen: maxLen = 40, fallbackPrefix: fallbackPrefix = 'slot' } = {})=>{
    const out = String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-+|-+$)/g, '').slice(0, maxLen);
    if (out) return out;
    return `${fallbackPrefix}-${Math.random().toString(36).slice(2, 6)}`;
};

});



parcelRegister("k3RTe", function(module, exports) {

$parcel$export(module.exports, "MarketplaceRegistrarDomainPicker", () => $e9ade3d653da4525$export$602f2ba5227d76a0);
// v1 functional domain picker — upgraded from v0 hint-card per
// MARKETPLACE tick-7 REQUEST. Renders only when IntegrationConfigureForm
// detects `_uiFlow === 'registrar'` (guard in the form's slot).
//
// UI:
//   - SearchRow: input + button → calls `domain.search` capability.
//   - ResultsList: maps `searchResults` → MarketplaceRegistrarSearchResult rows.
//   - OwnedDomains: list from `domain.list` capability, fired on mount.
//
// State is local to this component's subtree (not root) — smbls v3.14
// `state: {}` scopes state inheritance so two pickers on the same page
// don't share searchResults / ownedDomains.
//
// Wiring:
//   - `callCapabilityAndSet(inflightKey, resultKey, errorKey, capability, args, state)`
//     is a helper in `workspace/packages/marketplace/functions/index.js`
//     (shipped by MARKETPLACE per tick-7). Stubs throw until wired; same
//     pattern as `startOAuthFlow`.
//   - The search + register flow hits `integration-call` edge fn (v13+)
//     with `kind = <registrar kind>` + `capability ∈ ['domain.search',
//     'domain.register', 'domain.list']` → routed via
//     `integration_kinds.registrar_provider` to the right module in
//     `_shared/registrars/` (today: porkbun.ts).
const $e9ade3d653da4525$export$602f2ba5227d76a0 = {
    flow: 'y',
    gap: 'Z',
    padding: 'A',
    borderRadius: 'Z',
    border: '1px solid line',
    background: 'layer',
    marginTop: 'Z',
    state: {
        searchQuery: '',
        searching: false,
        searchResults: null,
        searchError: null,
        ownedDomains: null,
        registering: false,
        registerResult: null,
        registerError: null
    },
    // Fire `domain.list` on mount to populate the "Your domains" section.
    // Only runs when there's an API key configured (i.e. the integration
    // has been saved at least once) — the form state's `apiKey` field
    // signals that.
    onCreate: (el, s)=>{
        if (s?.apiKey) el.call('callCapabilityAndSet', 'listing', 'ownedDomains', 'listError', 'domain.list', {}, s);
    },
    Title: {
        tag: 'h5',
        text: 'Domain management',
        fontSize: 'Z',
        fontWeight: '600',
        color: 'title',
        margin: '0'
    },
    Hint: {
        tag: 'p',
        margin: '0',
        fontSize: 'Y',
        color: 'caption',
        // Hidden once an API key is configured.
        hide: (el, s)=>!!s?.apiKey,
        text: 'Enter your API key above to enable domain search.'
    },
    SearchRow: {
        flow: 'x',
        gap: 'Z',
        align: 'center',
        hide: (el, s)=>!s?.apiKey,
        SearchInput: {
            extends: 'Input',
            flex: '1',
            placeholder: 'example.com',
            value: (el, s)=>s.searchQuery || '',
            onInput: (e, el, s)=>s.update({
                    searchQuery: e.target.value
                })
        },
        SearchBtn: {
            extends: 'Button',
            theme: 'primary',
            disabled: (el, s)=>!s.searchQuery || !!s.searching,
            text: (el, s)=>s.searching ? "Searching\u2026" : 'Search',
            onClick: (e, el, s)=>el.call('callCapabilityAndSet', 'searching', 'searchResults', 'searchError', 'domain.search', {
                    query: s.searchQuery
                }, s)
        }
    },
    SearchError: {
        hide: (el, s)=>!s?.searchError,
        tag: 'p',
        fontSize: 'Y',
        color: 'danger',
        margin: '0',
        text: (el, s)=>s.searchError || ''
    },
    ResultsList: {
        flow: 'y',
        gap: 'X',
        hide: (el, s)=>!(Array.isArray(s?.searchResults) && s.searchResults.length),
        childExtends: 'MarketplaceRegistrarSearchResult',
        children: (el, s)=>s.searchResults || []
    },
    EmptyResults: {
        hide: (el, s)=>!(Array.isArray(s?.searchResults) && s.searchResults.length === 0),
        tag: 'p',
        fontSize: 'Y',
        color: 'caption',
        margin: '0',
        text: 'No results. Try a different query.'
    },
    OwnedDomainsSection: {
        flow: 'y',
        gap: 'X',
        marginTop: 'Z',
        hide: (el, s)=>!(Array.isArray(s?.ownedDomains) && s.ownedDomains.length),
        OwnedTitle: {
            tag: 'h6',
            fontSize: 'Z',
            fontWeight: '600',
            color: 'title',
            margin: '0',
            text: 'Your domains'
        },
        OwnedList: {
            flow: 'y',
            gap: 'X',
            // Same mini-row component used for search results — it handles
            // the domain name + (hidden) price + (hidden) register button
            // gracefully. Here the rows surface expiration info via a simple
            // text mapping before the row.
            children: (el, s)=>(s.ownedDomains || []).map((d)=>({
                        flow: 'x',
                        align: 'center space-between',
                        gap: 'Z',
                        padding: 'Y Z',
                        borderRadius: 'Y',
                        border: '1px solid line',
                        background: 'document',
                        Domain: {
                            tag: 'span',
                            flex: '1',
                            fontSize: 'Z2',
                            fontWeight: '500',
                            color: 'title',
                            text: d.domain || ''
                        },
                        ExpiresAt: {
                            tag: 'span',
                            fontSize: 'Y2',
                            color: 'caption',
                            text: d.expiresAt ? `renews ${String(d.expiresAt).slice(0, 10)}` : ''
                        }
                    }))
        }
    }
};

});

parcelRegister("1RWbR", function(module, exports) {

$parcel$export(module.exports, "MarketplaceRegistrarSearchResult", () => $15c7e11445ac08ed$export$ddee2f9abef6784);
// Single row in MarketplaceRegistrarDomainPicker's ResultsList.
// One child per `searchResults[]` entry. Shape:
//   { domain: 'example.com', available: true, priceUsd?: 12, currencyCode?: 'USD' }
//
// Available domains show price + [Register] button; taken domains show
// "taken" muted text. Per MARKETPLACE tick-7 spec; INTEGRATIONS scaffolds.
const $15c7e11445ac08ed$export$ddee2f9abef6784 = {
    flow: 'x',
    align: 'center space-between',
    gap: 'Z',
    padding: 'Y Z',
    borderRadius: 'Y',
    border: '1px solid line',
    background: 'document',
    Status: {
        tag: 'span',
        fontSize: 'A',
        text: (el)=>el.parent.available ? "\u2713" : "\u2717",
        color: (el)=>el.parent.available ? 'green' : 'caption'
    },
    Domain: {
        tag: 'span',
        flex: '1',
        fontSize: 'Z2',
        fontWeight: '500',
        color: 'title',
        text: (el)=>el.parent.domain || ''
    },
    Price: {
        tag: 'span',
        fontSize: 'Y2',
        color: 'caption',
        hide: (el)=>!el.parent.available,
        text: (el)=>{
            const p = el.parent.priceUsd;
            if (p == null) return '';
            const cur = el.parent.currencyCode || 'USD';
            return cur === 'USD' ? `$${p}/yr` : `${p} ${cur}/yr`;
        }
    },
    TakenLabel: {
        tag: 'span',
        fontSize: 'Y2',
        color: 'caption',
        hide: (el)=>el.parent.available,
        text: 'taken'
    },
    RegisterBtn: {
        extends: 'Button',
        hide: (el)=>!el.parent.available,
        // Register action — routes through the same capability layer.
        // `callCapabilityAndSet` is shipped by MARKETPLACE in
        // `marketplace/functions/index.js` (helper signature takes state
        // as the last arg — MARKETPLACE tick-9 fix).
        onClick: (e, el, s)=>el.call('callCapabilityAndSet', 'registering', 'registerResult', 'registerError', 'domain.register', {
                domain: el.parent.domain
            }, s),
        text: 'Register'
    }
};

});

parcelRegister("7eSZV", function(module, exports) {

$parcel$export(module.exports, "MarketplaceOAuthConnectButton", () => $545480a6901e52ad$export$16ac55d5a884edc9);
// v0 OAuth Connect button — scaffolded by INTEGRATIONS per
// MARKETPLACE tick-4 REQUEST. Replaces `SecretField` when the kind's
// `ui_flow === 'oauth2'` (already hidden by that guard). Button click
// calls the registered `startOAuthFlow(kind, {scopeType, scopeId, slug})`
// function which opens the provider's OAuth URL + handles the
// callback → Vault persistence. Today `startOAuthFlow` is a stub that
// throws a clear "not wired" error; DOMAIN's first OAuth2 provider
// (Cloudflare registrar) triggers the full implementation.
const $545480a6901e52ad$export$16ac55d5a884edc9 = {
    extends: 'Button',
    theme: 'primary',
    marginTop: 'Z',
    text: (el, s)=>`Connect with ${s?.kindLabel || s?.kind || 'provider'}`,
    disabled: (el, s)=>!!s?.oauthInFlight,
    onClick: (e, el, s)=>el.call('startOAuthFlow', s?.kind, {
            scopeType: s?.scopeType,
            scopeId: s?.scopeId,
            slug: s?.slug
        })
};

});

parcelRegister("iPhq6", function(module, exports) {

$parcel$export(module.exports, "ModalWindowCopy", () => $db4a80b09888ce6a$export$53e375b612d09466);
const $db4a80b09888ce6a$export$53e375b612d09466 = {
    tag: 'section',
    state: {},
    IconButton: {
        icon: 'crossmark',
        padding: 'Y2',
        position: 'absolute',
        top: 'Z2',
        right: 'Z2',
        color: 'dim',
        onClick: (ev, el, s, ctx)=>ctx.utils.closeModal(el, s, ctx)
    },
    ModalHeader: {
        onDrag: (event, element, state)=>{
            state.dragging = true;
        }
    },
    flow: 'x',
    theme: 'modal',
    padding: 'A B',
    round: 'A',
    gap: 'C',
    flow: 'column',
    overflow: 'auto',
    width: 'fit-content',
    height: 'fit-content',
    animationDuration: 'C',
    position: 'relative'
};

});

parcelRegister("cKrKj", function(module, exports) {

$parcel$export(module.exports, "ModalFooter", () => $947f4daf19aeef4a$export$519437715052e656);
$parcel$export(module.exports, "Modal", () => $947f4daf19aeef4a$export$2b77a92f1a5ad772);
// `display` is reactive — it re-evaluates whenever `root[stateKey]` changes.
// We piggy-back on that to detect open/close transitions and sync the URL:
// snapshot `location.href` on open, restore it on close. Any page-level hash
// sync (e.g. calendar.js's `_writeHash` poll) converges on the same result —
// if the modal's state is null again, that page's hash writer won't re-add a
// modal marker, so the restore sticks.
// Tracks the currently-open modal element so a global Escape listener can
// close it without each modal needing its own keyboard handler. Shared
// across all Modal instances by intent — only one modal is open at a time
// in practice, and the most-recently-opened wins if stacking ever occurs.
let $947f4daf19aeef4a$var$_topModalEl = null;
if (typeof window !== 'undefined' && !window.__modalEscBound) {
    window.__modalEscBound = true;
    document.addEventListener('keydown', (e)=>{
        if (e.key !== 'Escape' || !$947f4daf19aeef4a$var$_topModalEl) return;
        const el = $947f4daf19aeef4a$var$_topModalEl;
        const sk = typeof el.stateKey === 'string' ? el.stateKey : null;
        const root = el.state?.root;
        if (!sk || !root?.update) return;
        const extra = el.extraClose && typeof el.extraClose === 'object' && !Array.isArray(el.extraClose) ? el.extraClose : null;
        root.update(extra ? {
            [sk]: null,
            ...extra
        } : {
            [sk]: null
        });
        e.preventDefault();
    });
}
// `display` is reactive — it re-evaluates whenever `root[stateKey]` changes.
// We piggy-back on that to detect open/close transitions: snapshot URL on
// open, restore on close, and track the top modal for Escape-to-close.
const $947f4daf19aeef4a$var$_syncUrl = (el, isOpen)=>{
    if (typeof window === 'undefined') return;
    if (isOpen === el._wasOpen) return;
    if (isOpen) {
        el._urlBeforeOpen = window.location.href;
        $947f4daf19aeef4a$var$_topModalEl = el;
    } else {
        if (el._urlBeforeOpen && el._urlBeforeOpen !== window.location.href) window.history.replaceState(null, '', el._urlBeforeOpen);
        el._urlBeforeOpen = null;
        if ($947f4daf19aeef4a$var$_topModalEl === el) $947f4daf19aeef4a$var$_topModalEl = null;
    }
    el._wasOpen = isOpen;
};
const $947f4daf19aeef4a$export$519437715052e656 = {
    padding: 'A1 0 0 0'
};
const $947f4daf19aeef4a$export$2b77a92f1a5ad772 = {
    display: (el, s)=>{
        const isOpen = !!s.root?.[el.stateKey];
        $947f4daf19aeef4a$var$_syncUrl(el, isOpen);
        return isOpen ? 'flex' : 'none';
    },
    position: 'fixed',
    inset: '0',
    zIndex: '2000',
    align: 'center center',
    background: 'black.45',
    backdropFilter: 'blur(4px)',
    padding: 'A',
    onClick: (e, el, s)=>{
        if (e.target !== el.node) return;
        const root = s?.root;
        const sk = typeof el.stateKey === 'string' ? el.stateKey : null;
        if (!sk || !root?.update) return;
        const extra = el.extraClose && typeof el.extraClose === 'object' && !Array.isArray(el.extraClose) ? el.extraClose : null;
        root.update(extra ? {
            [sk]: null,
            ...extra
        } : {
            [sk]: null
        });
    },
    Window: {
        extends: 'ModalWindow',
        ModalHeader: {}
    }
};

});

parcelRegister("12Rgm", function(module, exports) {

$parcel$export(module.exports, "DraftSwitcher", () => $0c2f4b3f0d504763$export$b3771b6a97874e3d);
const $0c2f4b3f0d504763$export$b3771b6a97874e3d = {
    Input: {
        checked: ({ state: state })=>state.draft
    },
    SwitchField: {},
    Caption: {
        padding: '0',
        opacity: '.65',
        color: 'gray7',
        text: 'Draft'
    },
    extends: 'SwitchFieldWithCaption',
    onChange: (ev, el, s)=>{
        s.update({
            draft: !s.draft
        });
    }
};

});

parcelRegister("hJnvQ", function(module, exports) {

$parcel$export(module.exports, "Zoombar", () => $ce88e0bbb2919afe$export$a91af884b1f2df72);
const $ce88e0bbb2919afe$export$a91af884b1f2df72 = {
    // if: (el, s) => el.getUserSettings('allowZoombar'),
    extends: 'Navbar',
    gap: 'A',
    padding: 'V Z',
    round: 'C1',
    userSelect: 'none',
    ZoomInNavbar: {},
    Box: {
        width: 'A1',
        height: 'A1',
        aspectRatio: '1 / 1',
        round: '100%',
        overflow: 'hidden',
        flexShrink: '0',
        background: '#A3ADB6',
        onInit: (el, s)=>{
            const globalTheme = el.call('getGlobalTheme');
            const colorFromCookie = el.call('getCookie', `canvas_${globalTheme}_background`);
            const initValue = colorFromCookie || ({
                dark: '#A3ADB6',
                light: '#bac1c9'
            })[globalTheme || 'dark'];
            el.setNodeStyles({
                background: initValue
            });
            el.value = initValue;
        },
        onDblclick: (ev, el, s)=>{
            const globalTheme = el.call('getGlobalTheme');
            const value = {
                dark: '#A3ADB6',
                light: '#bac1c9'
            }[globalTheme];
            el.Input.node.value = value;
            el.setNodeStyles({
                background: value
            });
            const gs = window.__canvasGlobalScope;
            if (gs?.canvasElement) gs.canvasElement.setNodeStyles({
                background: value
            });
            el.call('removeCookie', `canvas_${globalTheme}_background`);
        },
        Input: {
            opacity: 0,
            value: (el)=>el.parent.value,
            border: '0',
            width: 'none',
            minWidth: 'none',
            textAlign: 'start',
            padding: '0',
            type: 'color',
            theme: null,
            onInput: (ev, el, s)=>{
                const value = el.node.value || '#A3ADB6';
                const globalTheme = el.call('getGlobalTheme');
                el.parent.setNodeStyles({
                    background: value
                });
                const gs = window.__canvasGlobalScope || el.context?.globalScope;
                if (gs?.canvasElement) gs.canvasElement.setNodeStyles({
                    background: value
                });
                el.call('setCookie', `canvas_${globalTheme}_background`, value);
            }
        }
    },
    NavbarButtonSet: {
        padding: '0',
        Settings: {
            icon: 'sf settings',
            onClick: (ev, el)=>{
                el.call('openModal', '/settings', {
                    key: '/settings'
                });
            },
            title: 'Settings'
        },
        Keyboard: {
            title: "Keyboard shortcuts (\u2318/)",
            attr: {
                'aria-label': 'Keyboard shortcuts'
            },
            icon: 'sf keyboard',
            onClick: (ev, el)=>el.call('openKeyboardShortcuts')
        },
        Question: {
            title: 'Docs',
            icon: 'sf question',
            onClick: (ev, el, s)=>{
                el.call('setWindow', 'explorer', 'onboarding');
            }
        }
    },
    NavbarTooltip: {
        top: '-65%',
        tooltipPosition: 'top',
        shapeDirection: 'bottom'
    }
};

});

parcelRegister("iAMfN", function(module, exports) {

$parcel$export(module.exports, "ResizeOverlay", () => $d89104f8b6e63f1d$export$4a957ab72f2178d);
const $d89104f8b6e63f1d$export$4a957ab72f2178d = {
    if: (el, s)=>!el.getUserSettings('optimizedMode'),
    '--handler-offset': '-0.25em',
    childProps: {
        position: 'absolute',
        round: '100%',
        width: 'Y1',
        height: 'Y1',
        background: '#2485F0',
        boxShadow: '#fff 0 0 0 1.5px, #000c 0 1px 4px'
    },
    children: [
        {
            right: '--handler-offset',
            bottom: '--handler-offset'
        },
        {
            left: '--handler-offset',
            bottom: '--handler-offset'
        },
        {
            right: '--handler-offset',
            top: '--handler-offset'
        },
        {
            left: '--handler-offset',
            top: '--handler-offset'
        }
    ]
};

});

parcelRegister("9KgHl", function(module, exports) {

$parcel$export(module.exports, "IconGridTypes", () => $71855cda976f2cd2$export$891988792261bc03);
const $71855cda976f2cd2$export$891988792261bc03 = {
    extends: 'Group',
    Title: {
        text: 'Icon type'
    },
    Flex: {
        flow: 'y',
        gap: 'Y2',
        margin: '- -X2',
        round: 'Y',
        childProps: {
            align: 'center space-between',
            padding: 'X1',
            round: 'X',
            cursor: 'pointer',
            color: 'paragraph',
            transition: 'B1 defaultBezier',
            transitionProperty: 'color, background',
            ':hover': {
                color: 'title',
                background: `linear-gradient(0deg,
          rgba(255,255,255,0.06) 0%,
          rgba(255,255,255,0.07) 100%
        )`
            },
            ':hover svg': {
                color: 'title'
            },
            IconText: {
                icon: 'info',
                text: '{{ text }}',
                fontSize: 'Z',
                align: 'center space-between',
                gap: 'Y2',
                Icon: {
                    transition: 'B1 defaultBezier color',
                    color: 'dim',
                    icon: '{{ icon }}',
                    padding: 'W2',
                    round: '6px',
                    fontSize: 'D',
                    background: `linear-gradient(0deg,
            rgba(255,255,255,0.06) 0%,
            rgba(255,255,255,0.07) 100%
          )`
                }
            },
            Icon: {
                name: 'checkmark',
                fontSize: 'Z',
                opacity: '0'
            }
        },
        childrenAs: 'state',
        children: ()=>[
                {
                    icon: 'icons',
                    text: 'Filled'
                },
                {
                    icon: 'iconsOutline',
                    text: 'Outline'
                },
                {
                    icon: 'iconsColored',
                    text: 'Multicolor'
                }
            ]
    }
};

});

parcelRegister("h8XPI", function(module, exports) {

$parcel$export(module.exports, "CanvasPanel", () => $c7b198a8363f24a5$export$e7af55c592e53ae4);
const $c7b198a8363f24a5$export$e7af55c592e53ae4 = {
    useGlassmorphism: (el)=>el.getUserSettings('useGlassmorphism'),
    '.useGlassmorphism': {
        theme: 'canvas-card-glass'
    },
    '!useGlassmorphism': {
        theme: 'canvas-card'
    },
    useAnimations: (el)=>el.getUserSettings('useAnimations'),
    '.useAnimations': {
        transition: 'C defaultBezier'
    },
    borderColor: 'line',
    borderWidth: '1px',
    borderStyle: 'solid'
};

});

parcelRegister("aGZxL", function(module, exports) {

$parcel$export(module.exports, "GridChooser", () => $7c8d90e70af40d0b$export$692e5e7e251a6bb5);
const $7c8d90e70af40d0b$export$692e5e7e251a6bb5 = {
    extends: 'Group',
    width: '100%',
    Title: {
        text: 'Grid options'
    },
    Grid: {
        margin: '- -X2',
        templateColumns: 'repeat(12, 1fr)',
        templateRows: 'repeat(3, 1fr)',
        gap: 'X2',
        round: 'Z2',
        overflow: 'hidden',
        childProps: {
            opacity: '0.35',
            theme: 'space',
            minHeight: 'B1',
            round: 'X1',
            isActive: (el, s)=>{
                const key = parseInt(el.key);
                const { gridOptions: gridOptions } = s.settings;
                const h = Math.floor(key / 12) + 1;
                const w = key % 12 + 1;
                return gridOptions?.w >= w && gridOptions?.h >= h;
            },
            '.isActive': {
                opacity: '.85'
            },
            '!isActive': {
                ':hover': {
                    opacity: '.45'
                }
            },
            onClick: (ev, el, s)=>{
                const key = parseInt(el.key);
                const h = Math.floor(key / 12) + 1;
                const w = key % 12 + 1;
                s.update({
                    settings: {
                        gridOptions: {
                            w: w,
                            h: h
                        }
                    }
                });
            }
        },
        children: ()=>new Array(60).fill({})
    }
};

});

parcelRegister("e7LpO", function(module, exports) {

$parcel$export(module.exports, "DragHandler", () => $a4867fd97ae359ff$export$d23484e29a0c570);
const $a4867fd97ae359ff$export$d23484e29a0c570 = {
    extends: 'Icon',
    if: (el, s)=>!el.getUserSettings('optimizedMode'),
    position: 'absolute',
    left: '50%',
    bottom: '-1.5em',
    transform: 'translate3d(-50%, 0, 1px)',
    icon: 'dragOutline',
    color: 'dim'
};

});

parcelRegister("8XRPH", function(module, exports) {

$parcel$export(module.exports, "DsNavbar", () => $686d97812487772f$export$ce2e060fe36ca634);
const $686d97812487772f$export$ce2e060fe36ca634 = {
    extends: 'Navbar',
    position: 'absolute',
    zIndex: 1,
    top: '50%',
    transform: 'translate3d(0, -50%, 0)',
    left: '--canvas-gutter',
    flow: 'y',
    padding: 'U1 U1',
    round: 'C1',
    gap: 'X',
    theme: 'canvas-card-glass',
    NavbarButtonSet: {
        padding: '0',
        gap: 'Z',
        flow: 'y',
        childProps: {
            padding: 'Y2',
            round: 'C1',
            isActive: (el)=>el.getWindow('explorer') === el.key,
            onClick: (ev, el)=>el.call('handleDsNavbarClick')
        },
        children: [
            {
                key: 'components',
                title: 'Components',
                Icon: {
                    name: 'grid'
                }
            },
            {
                key: 'pages',
                title: 'Pages',
                Icon: {
                    name: 'pages outline'
                }
            },
            {
                key: 'functions',
                title: 'Functions',
                Icon: {
                    name: 'fn outline'
                }
            },
            {
                key: 'files',
                title: 'Files',
                Icon: {
                    name: 'folder outline'
                }
            },
            {
                key: 'dependencies',
                title: 'Dependencies',
                Icon: {
                    name: 'npm outline'
                }
            }
        ],
        childrenAs: 'props'
    },
    Line: {
        margin: 'Y1 0',
        width: 'fill-available'
    },
    NavbarButtonSet_ds: {
        padding: '0',
        gap: 'Z',
        flow: 'y',
        childProps: {
            padding: 'Y2',
            round: 'C1',
            isActive: (el)=>el.getWindow('explorer') === el.key,
            onClick: (ev, el)=>el.call('handleDsNavbarClick')
        },
        children: [
            {
                key: 'color',
                title: 'Colors',
                Icon: {
                    name: 'color outline colored'
                }
            },
            {
                key: 'typography',
                title: 'Typography',
                Icon: {
                    name: 'typography outline colored'
                },
                opacity: '.7'
            },
            {
                key: 'spacing',
                title: 'Spacing',
                Icon: {
                    name: 'space outline colored'
                },
                opacity: '.7'
            },
            {
                key: 'icons',
                title: 'Icons',
                Icon: {
                    name: 'icons outline colored'
                }
            },
            {
                key: 'shape',
                title: 'Shapes',
                Icon: {
                    name: 'shape outline colored'
                }
            },
            {
                key: 'media',
                title: 'Responsive',
                Icon: {
                    name: 'device mobile half fill'
                },
                opacity: '.7'
            },
            {
                key: 'cases',
                title: 'Cases',
                Icon: {
                    name: 'boolean outline'
                }
            }
        ],
        childrenAs: 'props'
    },
    Line_2: {
        margin: 'Y1 0',
        width: 'fill-available'
    },
    NavbarButtonSet_meta: {
        padding: '0',
        gap: 'Z',
        flow: 'y',
        Expand: {
            title: 'Expand',
            icon: 'arrowAngleRight',
            onClick: (ev, el)=>{
                el.toggleWindow('explorer');
            }
        }
    },
    NavbarTooltip: {
        ignoreChildProps: true,
        ignoreChildExtends: true,
        top: '0',
        left: '110%',
        tooltipPosition: 'right',
        shapeDirection: 'left'
    }
};

});

parcelRegister("b2Fiq", function(module, exports) {

$parcel$export(module.exports, "DeviceButtonSet", () => $809fea2c383e417a$export$1772333bb1fb502e);
const $809fea2c383e417a$export$1772333bb1fb502e = {
    extends: 'NavbarButtonSet',
    gap: 'A',
    childProps: (el, state)=>{
        const isActive = el.scope.previewSize === state.key;
        const isThreeDots = state.icon === 'threeDotsVertical' && 'threeDotsVertical';
        const isResize = state.icon === 'dimensionsAlt' && (isActive ? state.icon + ' colored outline' : state.icon);
        return {
            isActive: isActive,
            isThreeDots: isThreeDots,
            theme: null,
            background: 'transparent.0',
            color: 'gray7',
            icon: isResize || isThreeDots || isActive ? state.icon : state.icon + ' outline',
            '.isThreeDots': {
                order: -15
            },
            ':hover': {
                background: 'gray4',
                color: 'gray10'
            },
            '.isActive': {
                opacity: 1,
                theme: 'secondary-highlight'
            },
            onClick: (ev, el, s, ctx)=>{
                const previewSize = s.key !== el.scope.previewSize ? s.key : 'unset';
                el.scope.previewSize = previewSize;
                el.parent.update();
                ctx.utils.setCookie('previewSize', previewSize);
                el.syncCanvas();
            }
        };
    },
    childrenAs: 'state',
    children: ()=>[
            {
                key: 'custom',
                icon: 'threeDotsVertical'
            },
            {
                key: 'mobileXS',
                icon: 'deviceMobile'
            },
            {
                key: 'tabletS',
                icon: 'deviceTabletPortrait'
            },
            {
                key: 'tabletL',
                icon: 'deviceTabletLandscape'
            },
            {
                key: 'screenM',
                icon: 'deviceSmallScreen'
            },
            {
                key: 'screenL',
                icon: 'deviceBigScreen'
            },
            {
                key: 'resizable',
                icon: 'dimensionsAlt'
            },
            {
                key: 'canvas',
                icon: 'columns'
            }
        ]
};

});

parcelRegister("dQ71H", function(module, exports) {

$parcel$export(module.exports, "ResponsiveSwitching", () => $a13594f8cb97555b$export$8dd390149ba5442e);
const $a13594f8cb97555b$export$8dd390149ba5442e = {
    extends: 'NavbarButtonSet',
    gap: 'A',
    scope: {
        previewSize: null
    },
    childrenAs: 'state',
    children: ()=>[
            {
                key: 'screenL',
                icon: 'deviceBigScreen'
            },
            {
                key: 'screenM',
                icon: 'deviceSmallScreen'
            },
            {
                key: 'tabletL',
                icon: 'deviceTabletLandscape'
            },
            {
                key: 'tabletS',
                icon: 'deviceTabletPortrait'
            },
            {
                key: 'mobileXS',
                icon: 'deviceMobile'
            },
            {
                key: 'canvas',
                icon: 'columns'
            },
            {
                key: 'custom',
                icon: 'layout'
            },
            {
                key: 'resizable',
                icon: 'dimensionsAlt'
            }
        ],
    childProps: {
        isActive: (el, s)=>el.parent.scope?.previewSize === s.key,
        icon: (el, s)=>{
            const active = el.parent.scope?.previewSize === s.key;
            return active ? s.icon : s.icon + ' outline';
        },
        title: (el, s)=>s.key,
        '.isActive': {
            theme: 'navbarButton-active'
        },
        '!isActive': {
            theme: 'navbarButton'
        },
        onClick: (ev, el, s)=>{
            const parent = el.parent;
            const scope = parent.scope;
            if (!scope) return;
            const newSize = scope.previewSize !== s.key ? s.key : null;
            scope.previewSize = newSize;
            for (const key of parent.__ref.__children){
                const child = parent[key];
                if (!child?.Icon?.node) continue;
                const isActive = child.state.key === newSize;
                const iconBase = child.state.icon;
                const outlineId = iconBase + 'Outline';
                const hasOutline = !!document.getElementById(outlineId);
                const spriteId = isActive ? iconBase : hasOutline ? outlineId : iconBase;
                const useEl = child.Icon.node.querySelector('use');
                if (useEl) useEl.setAttribute('xlink:href', '#' + spriteId);
                child.update();
            }
            if (el.syncCanvas) el.syncCanvas({
                previewSize: newSize
            });
        }
    }
};

});

parcelRegister("khCIe", function(module, exports) {

$parcel$export(module.exports, "CanvasVerticalNavbar", () => $ec436cadbf46ab3d$export$e0e7130af7b19cb6);
const $ec436cadbf46ab3d$export$e0e7130af7b19cb6 = {
    extends: 'Navbar',
    position: 'absolute',
    zIndex: 1,
    top: '50%',
    transform: 'translate3d(0, -50%, 0)',
    left: '--canvas-gutter',
    flow: 'y',
    padding: 'U1 U1',
    round: 'C1',
    gap: 'X',
    theme: 'canvas-card-glass',
    NavbarButtonSet: {
        padding: '0',
        gap: 'Z',
        flow: 'y',
        childProps: {
            padding: 'Y2',
            round: 'C1',
            isActive: (el)=>el.call('getFileSidebar') && el.call('getSidebarContent') === el.section,
            onClick: (ev, el)=>{
                const activeContent = el.section;
                el.setWindow('explorer', activeContent);
                window.setTimeout(()=>{
                    el.call('setSidebarContent', activeContent);
                }, 35);
            }
        },
        children: [
            {
                icon: 'content',
                title: 'Artboards',
                section: 'ARTBOARD_TYPES'
            },
            {
                icon: 'fnOutline',
                title: 'Functions',
                section: 'FUNCTION_TYPES'
            },
            {
                icon: 'copywritingOutline',
                title: 'State',
                section: 'STATE_TYPES'
            },
            {
                icon: 'tree',
                title: 'Design System',
                section: 'DESIGN_SYSTEM_TYPES'
            },
            {
                icon: 'folderOutline',
                title: 'Assets',
                section: 'ASSETS_TYPES'
            },
            {
                icon: 'fuse',
                title: 'Integrations',
                section: 'INTEGRATIONS_TYPES'
            },
            {
                icon: 'tutorial outline',
                title: 'Learn',
                section: 'TUTORIALS'
            }
        ],
        childrenAs: 'props'
    },
    Line: {
        margin: 'Y1 0',
        width: 'fill-available'
    },
    NavbarButtonSet_meta: {
        padding: '0',
        gap: 'Z',
        flow: 'y',
        Expand: {
            title: 'Expand',
            icon: 'arrowAngleRight',
            onClick: (ev, el)=>{
                el.toggleWindow('explorer');
            }
        }
    },
    NavbarTooltip: {
        ignoreChildProps: true,
        ignoreChildExtends: true,
        top: '0',
        left: '110%',
        tooltipPosition: 'right',
        shapeDirection: 'left'
    }
};

});

parcelRegister("1Kzry", function(module, exports) {

$parcel$export(module.exports, "ActiveContentSwitcher", () => $146594a810a9f4e5$export$f36f9c766a52306c);
const $146594a810a9f4e5$export$f36f9c766a52306c = {
    extends: [
        'Grid',
        'Navbar'
    ],
    round: 'C1',
    fontSize: 'Z1',
    templateColumns: 'repeat(7, 1fr)',
    align: 'center center',
    children: [
        {
            icon: 'magicstar',
            title: 'AI Assistant',
            section: 'AI'
        },
        {
            icon: 'content',
            title: 'Artboards',
            section: 'ARTBOARD_TYPES'
        },
        {
            icon: 'fnOutline',
            title: 'Functions',
            section: 'FUNCTION_TYPES'
        },
        {
            icon: 'tree',
            title: 'Design System',
            section: 'DESIGN_SYSTEM_TYPES'
        },
        {
            icon: 'copywritingOutline',
            title: 'State',
            section: 'STATE_TYPES'
        },
        {
            icon: 'folderOutline',
            title: 'Assets',
            section: 'ASSETS_TYPES'
        },
        {
            icon: 'fuse',
            title: 'Integrations',
            section: 'INTEGRATIONS_TYPES'
        }
    ],
    childProps: {
        textAlign: 'center',
        onClick: (ev, el, s)=>{
            const activeContent = el.section;
            el.call('setSidebarContent', activeContent);
        }
    },
    childExtends: {
        extends: [
            'NavbarButton',
            'NavbarTooltipParent'
        ],
        state: null,
        width: '100%',
        aspectRatio: 'unset',
        padding: 'Z -',
        '@dark': (el, s)=>el.section === s.activeContent ? {
                color: 'gray15',
                background: 'gray3'
            } : undefined,
        '@light': (el, s)=>el.section === s.activeContent ? {
                color: 'gray15',
                background: 'gray4'
            } : undefined,
        theme: (el, s)=>el.section !== s.activeContent ? 'transparent' : undefined,
        ':hover': (el, s)=>el.section !== s.activeContent ? {
                '@dark': {
                    color: 'gray15',
                    background: 'gray2'
                },
                '@light': {
                    color: 'gray15',
                    background: 'gray4'
                }
            } : undefined
    },
    NavbarTooltip: {
        ignoreChildExtends: true,
        ignoreChildProps: true
    }
};

});

parcelRegister("fJGMk", function(module, exports) {

$parcel$export(module.exports, "Feedback", () => $b74c3de7e1be0d1e$export$175e500a48a60fd2);
const $b74c3de7e1be0d1e$export$175e500a48a60fd2 = {
    IconText: {
        color: 'paragraph',
        text: '{{ title }}',
        flow: 'column',
        gap: 'Z',
        padding: '0',
        extends: 'Button',
        background: 'transparent',
        border: '0',
        fontSize: 'A',
        cursor: 'pointer',
        margin: '-W - -',
        Icon: {
            name: 'arrowAngleUp',
            color: 'dim',
            '.isActive': {
                color: 'orange'
            }
        },
        '!isActive': {
            ':hover svg': {
                color: 'placeholder'
            }
        },
        onClick: (ev, el, s)=>{
            const { isActive: isActive } = s;
            s.update({
                isActive: !isActive,
                upvotes: isActive ? s.upvotes - 1 : s.upvotes + 1
            });
        }
    },
    Hgroup: {
        H: {
            extends: 'DocsLink',
            text: 'Flexbox in Editor',
            fontWeight: '700',
            tag: 'h6'
        },
        P: {
            text: null,
            childProps: {
                display: 'inline'
            },
            children: [
                'by ',
                {
                    DocsLink: {
                        text: 'kiaynwang'
                    }
                },
                ' ',
                {
                    DocsLink: {
                        text: '3 hours ago'
                    }
                },
                " \u30FB ",
                {
                    DocsLink: {
                        text: '49 comments'
                    }
                }
            ]
        }
    },
    flow: 'x',
    gap: 'A2',
    align: 'flex-start'
};

});

parcelRegister("kbLH1", function(module, exports) {

$parcel$export(module.exports, "NavbarTooltipParent", () => $eb29d4870c63cb40$export$61d215aafe79203c);
const $eb29d4870c63cb40$export$61d215aafe79203c = {
    onUpdate: (el, s)=>{
        const active = window.location.pathname.includes(s.href);
        if (active) el.call('setNavbarTooltipPosition');
    },
    onMouseenter: (ev, el, s)=>{
        if (!s.hover) {
            s.hover = true;
            el.call('setNavbarTooltipPosition', {
                visible: true
            });
        }
    },
    onMouseleave: (ev, el, s)=>{
        if (s.hover) {
            s.hover = false;
            const Tooltip = el.lookup('NavbarTooltip');
            if (Tooltip) Tooltip.update({
                opacity: '0',
                visibility: 'hidden'
            });
        }
    }
};

});

parcelRegister("lRUZr", function(module, exports) {

$parcel$export(module.exports, "ResponsiveOverlay", () => $febac13f692a2366$export$b80c1f5e9d0f0b13);
const $febac13f692a2366$export$b80c1f5e9d0f0b13 = {
    Link: {
        extends: 'SquareButton',
        theme: 'quaternary',
        color: 'title',
        icon: 'logo',
        href: 'https://symbols.app'
    },
    IconText: {
        icon: 'deviceTabletLandscapeHalf fill',
        lineHeight: '1.4',
        gap: 'Z',
        text: 'Small view is temporarily disabled, please check from larger screens',
        '@mobileM': {
            flow: 'column',
            textAlign: 'center'
        }
    },
    Button: {
        theme: 'quaternary',
        round: 'B',
        padding: 'Z2 A2',
        text: 'Open anyway',
        onClick: (ev, el)=>el.parent.remove()
    },
    flow: 'x',
    if: (el)=>{
        const isTesting = location.host.includes('localhost');
        const isCanvas = location.pathname.includes('srcdoc');
        const isEmbed = el.isEmbed();
        if (isEmbed || isCanvas || isTesting) return false;
        return true;
    },
    display: 'none',
    align: 'center space-between',
    flow: 'column',
    position: 'fixed',
    inset: '0 0 0 0',
    boxSize: '100%',
    padding: 'C',
    backdropFilter: 'blur(3px)',
    zIndex: '999999',
    gap: 'A',
    '@tabletL': {
        display: 'flex'
    },
    '@dark': {
        background: 'black.9'
    },
    '@light': {
        background: 'gray15.95'
    }
};

});

parcelRegister("iCwLt", function(module, exports) {

$parcel$export(module.exports, "Code", () => $d8e5310105245251$export$52f0f02147b12c03);
const $d8e5310105245251$export$52f0f02147b12c03 = {
    extends: 'CodeWithTitleAndButtons',
    flow: 'y',
    minWidth: 'H',
    maxWidth: '50%',
    '@tabletS': {
        width: 'max-content',
        widthRange: 'auto'
    }
};

});

parcelRegister("1ho0F", function(module, exports) {

$parcel$export(module.exports, "CodePreviewWithTitle", () => $0eea00d5a871b1b2$export$193ccbdefee80ca0);
const $0eea00d5a871b1b2$export$193ccbdefee80ca0 = {
    extends: 'Group',
    tag: 'pre',
    margin: '- 0 0',
    Title: {
        order: null,
        tag: 'h5',
        text: 'Code Example',
        fontFamily: 'smbls',
        color: 'caption',
        fontSize: 'Z',
        fontWeight: '500',
        whiteSpace: 'nowrap'
    },
    CodePreview: {
        margin: '0 -Y1'
    }
};

});

parcelRegister("5zfDj", function(module, exports) {

$parcel$export(module.exports, "CodeWithTitleAndButtons", () => $40dc590bee812714$export$1c5966595d851711);
const $40dc590bee812714$export$1c5966595d851711 = {
    extends: 'CodePreviewWithTitle',
    margin: '0',
    minWidth: 'F3',
    maxWidth: '50%',
    align: 'stretch',
    '@tabletS': {
        maxWidth: 'none'
    },
    Title: {},
    CodePreview: {
        round: 'A+X',
        padding: 'A A1 D1',
        '&': {
            minWidth: '100%',
            width: 'auto'
        }
    },
    Buttons: {
        align: 'center space-between',
        margin: '-C+X1 -W 0',
        gap: 'X2',
        transition: 'B opacity',
        '&': {
            minWidth: '100%',
            width: 'auto'
        },
        childExtends: [
            'WiderButton'
        ],
        childProps: {
            round: 'Z1',
            fontSize: 'A',
            transition: 'A',
            transitionProperty: 'background, color, border',
            theme: 'secondary-highlight',
            backdropFilter: 'blur(3px)',
            zIndex: 10
        },
        CopyButton: {
            extends: [
                'WiderButton',
                'CopyButton'
            ],
            margin: '0 auto 0 0',
            icon: 'copy outline',
            value: (el)=>{
                const val = el.call('getCodePreviewValue', el.parent.value || '//');
                return val;
            }
        },
        Link: {
            href: '/dashboard#{{ title }}',
            Icon: {
                name: 'url'
            }
        },
        FrameworkSwitcher: {
            padding: 'Z B Z Z2',
            fontSize: 'A',
            fontFamily: 'smbls',
            Icon: {
                name: (el)=>{
                    const fw = el.getRootState?.()?.framework;
                    return (fw === 'domql' ? 'symbols' : fw) || 'symbols';
                }
            },
            Icon_arrow: {
                position: 'absolute',
                opacity: 0.5,
                fontSize: 'Z',
                right: 'Z1',
                icon: 'arrowAngleMirroringVertical'
            }
        }
    }
};

});

parcelRegister("7FNoC", function(module, exports) {

$parcel$export(module.exports, "CodePreview", () => $5962adc781e6efda$export$92c0a26c2d112021);

const $5962adc781e6efda$export$92c0a26c2d112021 = {
    flex: 1,
    minWidth: 'G',
    maxHeight: '100%',
    overflow: 'auto',
    display: 'block',
    whiteSpace: 'pre-wrap',
    lineHeight: 1.8,
    fontSize: '0.765em',
    fontFamily: 'Code',
    round: 'A1',
    height: 'max-content',
    transition: 'B padding',
    padding: 'A_default A1_default',
    theme: 'common-card',
    background: 'title-reversed',
    value: '// demo code',
    '& .token': {
        '&.keyword': {
            color: '#4f82ae'
        },
        '&.string': {
            color: '#c8749c'
        },
        '&.punctuation': {
            color: '#A3A3A8'
        },
        '&.function': {
            color: '#c7c981'
        },
        '&.property': {
            color: '#87b6cb'
        },
        '&.string-property': {
            color: '#C584C0'
        },
        '&.operator': {
            color: '#74b6d4'
        },
        '&.boolean': {
            color: '#589BD6'
        },
        '&.number': {
            color: '#B5CFA8'
        },
        '&.comment': {
            color: '#6A9A55'
        },
        '&.constant': {
            color: '#fff'
        }
    },
    '@light': {
        '& .token': {
            '&.keyword': {
                color: '#1373c6'
            },
            '&.string': {
                color: '#e34c94'
            },
            '&.punctuation': {
                color: '#8c8ca6'
            },
            '&.function': {
                color: '#a59300'
            },
            '&.property': {
                color: '#348cb3'
            },
            '&.string-property': {
                color: '#cd4cc3'
            },
            '&.operator': {
                color: '#74b6d4'
            },
            '&.boolean': {
                color: '#589BD6'
            },
            '&.number': {
                color: '#B5CFA8'
            },
            '&.comment': {
                color: '#6A9A55'
            },
            '&.constant': {
                color: 'black'
            }
        }
    },
    onUpdate: (el, s)=>{
        el.onRender(el, s);
    },
    onRender: async (el, s)=>{
        const prismjs = await (parcelRequire("g38L6"));
        const Prism = prismjs?.default || prismjs;
        const globalState = el.getRootState();
        const code = await el.call('getCodePreviewValue');
        if (!code || !Prism) return;
        await el.update({
            html: Prism.highlight(code, Prism.languages.javascript, globalState?.language)
        }, {
            preventListeners: true,
            preventUpdateListener: true
        });
    }
};

});
parcelRegister("g38L6", function(module, exports) {
module.exports = import("daZLk").then(()=>parcelRequire('bqaFX'));

});


parcelRegister("k12Rm", function(module, exports) {

$parcel$export(module.exports, "PageTemplate", () => $e9261e850f4b4244$export$1773bf8c632ebee7);
const $e9261e850f4b4244$export$1773bf8c632ebee7 = {
    tag: 'main',
    flow: 'x',
    width: '100%',
    margin: '- auto',
    maxWidth: 'K_default',
    padding: 'D2 E B1',
    flex: 1,
    flow: 'column',
    '@screenS': {
        padding: 'C1 C B1'
    },
    '@tabletS': {
        padding: 'C1 B'
    }
};

});

parcelRegister("lUnXR", function(module, exports) {

$parcel$export(module.exports, "DesignSystem", () => $ff316ace9c7d8873$export$76bc5a0bcb063c6b);
const $ff316ace9c7d8873$export$76bc5a0bcb063c6b = {
    Grid: {
        childExtends: {
            theme: 'common-card-interactive',
            padding: 'Z2 Y2 Z2 Z2',
            align: 'center space-between',
            flex: '1',
            round: 'A',
            gap: 'B2',
            width: '100%',
            href: '{{ href }}',
            "@tabletL": {
                maxWidth: 'none'
            },
            ":nth-child(2)": {
                "> div > p": {
                    maxWidth: 'E3'
                }
            },
            WiderButton: {
                icon: (el, s)=>s.icon,
                padding: 'Y2',
                background: (el, s)=>s.background,
                theme: (el, s)=>s.theme
            },
            Hgroup: {
                gap: 'X2',
                H: {
                    text: (el, s)=>s.title,
                    fontSize: 'A',
                    fontWeight: '500'
                },
                P: {
                    text: '{{ p }}',
                    fontSize: 'Z',
                    maxWidth: (el, s)=>s.maxWidth,
                    "@tabletL": {
                        maxWidth: 'E3+A1'
                    }
                }
            }
        },
        children: ()=>[
                {
                    title: 'Colors',
                    href: '/docs/color',
                    p: 'Colorize styles manually',
                    icon: 'color',
                    theme: 'theme',
                    maxWidth: 'E'
                },
                {
                    title: 'Typography',
                    href: '/docs/typography',
                    p: 'Style a typed material',
                    icon: 'typography',
                    theme: 'typography',
                    maxWidth: 'E'
                },
                {
                    title: 'Spacing',
                    href: '/docs/space',
                    p: "Manage properties of a size",
                    maxWidth: 'E2',
                    icon: 'space',
                    theme: 'space'
                },
                {
                    title: 'Shapes',
                    href: '/docs/shapes',
                    p: "Design an outline\n      to a chosen component",
                    icon: 'shape',
                    theme: 'shape'
                },
                {
                    title: 'Icons',
                    href: '/docs/icons',
                    p: "Label a role of subject\n      with glyphs",
                    icon: 'icons',
                    theme: 'icons'
                },
                {
                    title: 'Breakpoints',
                    href: '/docs/media',
                    p: "The devices and the breakpoints",
                    icon: 'deviceMobileOutline'
                },
                {
                    title: 'Sequence',
                    href: '/docs/sequence',
                    p: "The mapping system of\n      generative sizing units",
                    icon: 'stateColored'
                },
                {
                    title: 'Timing',
                    href: '/docs/timing',
                    p: "Tokens for transitions and animations",
                    icon: 'clock'
                }
            ]
    }
};

});

parcelRegister("4YD8Q", function(module, exports) {

$parcel$export(module.exports, "Terminal", () => $39fb20be9ecd64b8$export$8dd80f06eb58bfe1);
const $39fb20be9ecd64b8$export$8dd80f06eb58bfe1 = {
    tag: 'code',
    Icon: {
        icon: 'terminal',
        '@dark': {
            color: 'gray7'
        },
        '@light': {
            color: 'gray8'
        }
    },
    Command: {
        overflow: 'hidden',
        flex: 1,
        padding: '0',
        textOverflow: 'ellipsis',
        margin: '0 auto 0 0'
    },
    Copy: {
        extends: [
            'WiderButton',
            'CopyButton'
        ],
        icon: 'copyOutline',
        background: 'transparent.0',
        theme: 'secondary-highlight',
        value: (el)=>el.call('getCodePreviewValue', el.parent.value)
    },
    flow: 'x',
    align: 'center space-between',
    padding: 'W X W A',
    minWidth: 'G',
    minHeight: 'B2',
    round: 'Z1',
    fontFamily: 'Code',
    gap: 'X2',
    whiteSpace: 'nowrap',
    theme: 'common-card'
};

});

parcelRegister("4PMgf", function(module, exports) {

$parcel$export(module.exports, "Page", () => $38515c7900f12659$export$6955bcca4cd3539f);
const $38515c7900f12659$export$6955bcca4cd3539f = {
    tag: 'main',
    extends: 'PageTemplate',
    width: '100%',
    maxWidth: 'K_default',
    margin: '- auto'
};

});

parcelRegister("iSMVI", function(module, exports) {

$parcel$export(module.exports, "DisabledPage", () => $dbf339931575bfa8$export$9f2f77196b904b3c);
const $dbf339931575bfa8$export$9f2f77196b904b3c = {
    maxHeight: 'none',
    overflow: 'visible',
    zIndex: '100',
    position: 'absolute',
    inset: '0 0 0 0',
    height: '100%',
    '.isActive': {
        maxHeight: '100dvh',
        overflow: 'hidden'
    },
    '!isActive': {
        maxHeight: 'none',
        overflow: 'visible'
    },
    overlay: {
        extends: [
            'Overlay',
            'Flex'
        ],
        overflow: 'hidden',
        background: 'shadow-overlay',
        '!isActive': {
            animation: 'fadeOutDown',
            animationDuration: 'G',
            transition: 'G defaultBezier',
            transitionProperty: 'opacity, transform, visibility',
            opacity: '0',
            visibility: 'hidden',
            transform: 'translate3d(0, 12.5%, 0)',
            pointerEvents: 'none'
        },
        '.isActive': {
            animation: 'fadeInUp',
            animationDuration: 'G'
        },
        message: {
            animation: 'fadeInUpShort',
            animationDuration: 'G',
            animationDelay: 'G',
            margin: 'auto',
            padding: 'F E D',
            width: '100%',
            maxWidth: 'K_default',
            ArticleBig: {
                align: 'center',
                P: {
                    color: 'gray8',
                    margin: 'X 0 0',
                    animation: 'fadeInUpShort',
                    animationDuration: 'G',
                    animationDelay: 'G1'
                }
            },
            ArticleBig: {
                P: 'Add components from the marketplace.'
            }
        }
    }
};

});

parcelRegister("12gDp", function(module, exports) {

$parcel$export(module.exports, "Command", () => $0c12e19f5884d6a2$export$cc7e12c76513e857);


const $0c12e19f5884d6a2$export$cc7e12c76513e857 = {
    padding: '0 C2 0 0',
    fontSize: '0.765em',
    fontFamily: 'Code',
    '@dark': {
        '& .token': {
            '&.function': {
                color: '#DBDDAA'
            }
        }
    },
    '@light': {
        '& .token': {
            '&.function': {
                color: '#a59300'
            }
        }
    },
    onUpdate: (el, s)=>{
        el.onRender(el, s);
    },
    onRender: async (el, s)=>{
        const prismjs = await (parcelRequire("g38L6"));
        const Prism = prismjs?.default || prismjs;
        if (!Prism.languages.bash) try {
            await (parcelRequire("7RUKA"));
        } catch (e) {
            await window.require('prismjs@1.30.0/components/prism-bash.min.js');
        }
        const code = el.call('getCodePreviewValue');
        if (!code || !Prism) return;
        el.update({
            html: Prism.highlight(code, Prism.languages.bash, 'bash')
        }, {
            preventListeners: true
        });
    }
};

});
parcelRegister("7RUKA", function(module, exports) {
module.exports = import("6FC7z").then(()=>parcelRequire('1Xkr9'));

});


parcelRegister("eV3EV", function(module, exports) {

$parcel$export(module.exports, "TerminalWithTitle", () => $adc93a2c4e82e33c$export$257fce7f278657d7);
const $adc93a2c4e82e33c$export$257fce7f278657d7 = {
    extends: 'Group',
    Title: {
        tag: 'title'
    },
    Terminal: {}
};

});

parcelRegister("f0FW6", function(module, exports) {

$parcel$export(module.exports, "DesignSystemOptions", () => $aed762c554d93ff6$export$d7f7350a8dbd4c82);
const $aed762c554d93ff6$export$d7f7350a8dbd4c82 = {
    extends: 'SettingsSection',
    state: 'designSystem',
    Title: {
        text: 'Design System Settings',
        QuestionMarkTooltip: {
            onClick: (ev, el, s)=>{
                s.update({
                    useReset: true,
                    useVariable: true,
                    useDocumentTheme: true,
                    useFontImport: true,
                    useIconSprite: true,
                    useSvgSprite: true,
                    useDefaultConfig: true,
                    verbose: false
                }, {
                    preventShModalUpdate: true
                });
            }
        }
    },
    Grid: {
        childExtends: {
            extends: 'OptionToggle',
            onChange: async (ev, el, s)=>{
                const { key: key } = el;
                const val = s[key];
                await el.updateDesignSystem(null, key, !val, {
                    message: `Set ${key} design system settings to ${!val}`
                });
                el.call('setCookie', key, !val);
            },
            Input: {
                checked: (el)=>el.getDesignSystem()[el.parent.key]
            }
        },
        children: [
            {
                key: 'useReset',
                QuestionMarkTooltip: {
                    TooltipHidden: {
                        shapeDirection: 'top',
                        tip: 'Reset CSS browser defaults and matching Symbols Design System'
                    }
                },
                Caption: {
                    text: 'Apply Symbols normalizing:'
                }
            },
            {
                key: 'useVariable',
                QuestionMarkTooltip: {
                    TooltipHidden: {
                        shapeDirection: 'top',
                        tip: 'Apply CSS values as variables'
                    }
                },
                Caption: {
                    text: 'Use CSS variables:'
                }
            },
            {
                key: 'useDocumentTheme',
                QuestionMarkTooltip: {
                    TooltipHidden: {
                        shapeDirection: 'top',
                        tip: 'Apply global @dark @light, and other themes to the document'
                    }
                },
                Caption: {
                    text: 'Apply Global Themes:'
                }
            },
            {
                key: 'useFontImport',
                QuestionMarkTooltip: {
                    TooltipHidden: {
                        shapeDirection: 'top',
                        tip: 'Import fonts via @font-face from Symbols cdn'
                    }
                },
                Caption: {
                    text: 'Import Fonts:'
                }
            },
            {
                key: 'useIconSprite',
                QuestionMarkTooltip: {
                    TooltipHidden: {
                        shapeDirection: 'top',
                        tip: 'Bundle icons as SVG sprites'
                    }
                },
                Caption: {
                    text: 'Use Sprite for Icons:'
                }
            },
            {
                key: 'useSvgSprite',
                QuestionMarkTooltip: {
                    TooltipHidden: {
                        shapeDirection: 'top',
                        tip: 'Bundle SVGs as SVG sprites'
                    }
                },
                Caption: {
                    text: 'Use Sprite for SVG:'
                }
            },
            {
                key: 'useDefaultConfig',
                QuestionMarkTooltip: {
                    TooltipHidden: {
                        shapeDirection: 'top',
                        tip: 'Use default config as fallback for components'
                    }
                },
                Caption: {
                    text: 'Use default config:'
                }
            },
            {
                key: 'verbose',
                QuestionMarkTooltip: {
                    TooltipHidden: {
                        shapeDirection: 'top',
                        tip: 'Design System verbose mode in console'
                    }
                },
                Caption: {
                    text: 'Verbose mode:'
                }
            },
            {
                extends: 'SelectDropdownWithTitle',
                ignoreChildExtends: true,
                borderWidth: '1px 0 0 0',
                borderStyle: 'solid',
                padding: 'B1 - -',
                '@dark': {
                    borderColor: '--color-line-dark'
                },
                '@light': {
                    borderColor: '--color-line-light'
                },
                Title: {
                    opacity: '.65',
                    color: 'gray7',
                    text: 'Default global theme'
                },
                SelectDropdown: {
                    Value: {
                        Text: {
                            text: (el)=>el.call('toDescriptionCase', el.getDesignSystem('globalTheme')) || 'Auto'
                        }
                    },
                    Dropdown: {
                        top: '121%',
                        options: [
                            {
                                key: 'auto',
                                text: 'Auto'
                            },
                            {
                                key: 'dark',
                                text: 'Dark'
                            },
                            {
                                key: 'light',
                                text: 'Light'
                            },
                            {
                                key: 'custom',
                                text: 'Custom'
                            }
                        ],
                        onChoose: async (ev, el, s, ctx, calleeElement)=>{
                            const globalTheme = calleeElement.state.key;
                            undefined.sdk.updateData([
                                [
                                    'update',
                                    [
                                        'designSystem',
                                        'globaltheme'
                                    ],
                                    globalTheme
                                ]
                            ], {
                                message: `Updating globalTheme to ${globalTheme}`
                            });
                            el.getRootState().update({
                                globalTheme: globalTheme
                            });
                            el.call('setCookie', 'globalTheme', el.getDesignSystem('globalTheme'));
                        },
                        DropdownHeader: {
                            text: 'Global theme'
                        },
                        ListInDropdown: {
                            childExtends: {
                                extends: 'KeyValueColumnFields',
                                isActive: (el, s)=>el.getDesignSystem('globalTheme') === s.key,
                                text: (el, s)=>s.text,
                                fontWeight: '400'
                            }
                        }
                    }
                }
            }
        ],
        childrenAs: 'props'
    }
};

});

parcelRegister("ervS9", function(module, exports) {

$parcel$export(module.exports, "InstallTabs", () => $a83c4f7c0caf0e16$export$1dcef869b609755b);
const $a83c4f7c0caf0e16$export$1dcef869b609755b = {
    flow: 'x',
    align: 'end',
    gap: 'B1',
    margin: 'C1 - -',
    childProps: {
        isActive: (el, s)=>s.installTab === el.key,
        theme: 'transparent',
        border: '0 solid --document-dark-background',
        round: '0',
        padding: '0 0 A',
        align: 'end',
        '.isActive': {
            color: 'title',
            fontWeight: 'bold',
            borderWidth: '0 0 3px'
        },
        onClick: (ev, el, s)=>{
            s.update({
                installTab: el.key
            });
            el.call('setCookie', 'installTab', el.key);
        }
    },
    childExtends: 'Button',
    Development: {
        text: 'Development'
    },
    Domain: {
        extends: 'SubscribeButton',
        Text: {
            order: '-1',
            text: 'Domain'
        }
    },
    Live: {
        text: 'Live website'
    }
};

});

parcelRegister("2waml", function(module, exports) {

$parcel$export(module.exports, "SettingsSection", () => $1d569b132aa13cdd$export$d239b03507a9e5cc);
const $1d569b132aa13cdd$export$d239b03507a9e5cc = {
    extends: 'Group',
    Title: {
        flow: 'x',
        width: '100%',
        margin: 'A - -',
        align: 'center space-between',
        text: 'Platform settings',
        QuestionMarkTooltip: {
            margin: '0',
            TooltipHidden: {
                minWidth: 'none',
                padding: 'Z A',
                shapeDirection: 'top',
                description: 'Reset to default'
            },
            Icon: {
                fontSize: 'A2',
                opacity: '.65',
                name: 'refresh'
            }
        }
    },
    Grid: {
        margin: 'A -',
        templateColumns: 'repeat(4, 1fr)',
        gap: 'B1 C3',
        '@tabletM': {
            columns: 'repeat(3, 1fr)'
        },
        '@tabletS': {
            columns: 'repeat(2, 1fr)'
        },
        '@mobileL': {
            columns: 'repeat(1, 1fr)'
        },
        childExtends: 'OptionToggle'
    }
};

});

parcelRegister("9dnpP", function(module, exports) {

$parcel$export(module.exports, "InstallFooter", () => $6b577dcf5babc8c5$export$f58493c6a6fcb573);
const $6b577dcf5babc8c5$export$f58493c6a6fcb573 = {
    flow: 'x',
    align: 'center',
    gap: 'X2',
    opacity: '.35',
    Icon: {
        name: 'question mark fill'
    },
    Paragraph: {
        margin: '0',
        childrenAs: 'props',
        children: [
            {
                text: 'Learn more on how to get started at ',
                padding: '0 V1'
            },
            {
                extends: 'DocsLink',
                href: '/docs/intro',
                text: 'Documentations page'
            }
        ]
    }
};

});

parcelRegister("6Kmii", function(module, exports) {

$parcel$export(module.exports, "InstallCdn", () => $4e985513c5e5d7df$export$3c91bc0ff0f60103);
const $4e985513c5e5d7df$export$3c91bc0ff0f60103 = {
    P: {
        color: 'gray8',
        margin: '0',
        text: 'Add this script to the top of your HTML:'
    },
    Code: {
        margin: 'Z1 0 0',
        value: (el)=>`<script src="https://api.symbols.app/cdn/${el.getAppKey() && el.getAppKey().split('.')[0]}"></script>`,
        Title: null,
        Buttons: {
            FrameworkSwitcher: null
        }
    }
};

});

parcelRegister("2YyYb", function(module, exports) {

$parcel$export(module.exports, "InstallLiveExt", () => $22ac4f999871ac62$export$5093e061083d8cea);
const $22ac4f999871ac62$export$5093e061083d8cea = {
    gap: '0',
    P: {
        color: 'gray8',
        margin: '0',
        text: 'Add this script to the top of your HTML:'
    },
    Code: {
        margin: 'Z1 0 0',
        value: (el)=>`<script src="https://api.symbols.app/live/${el.getAppKey() && el.getAppKey().split('.')[0]}"></script>`,
        Title: null,
        Buttons: {
            FrameworkSwitcher: null
        }
    }
};

});

parcelRegister("5OiBB", function(module, exports) {

$parcel$export(module.exports, "InstallDomain", () => $43b00de899d89f80$export$2f1bc08691d5966);
const $43b00de899d89f80$export$2f1bc08691d5966 = {
    flow: 'y',
    gap: 'C1',
    P: {
        color: 'gray8',
        margin: '0',
        Text: {
            text: '1. Go to your DNS manager for '
        },
        LabeledHighlight: {
            text: (el)=>el.getRootState().domain
        }
    },
    ARecord: {
        P: {
            color: 'gray8',
            margin: '0 - Z2',
            text: '2. Create A records:'
        },
        Terminal: {
            width: 'fit-content',
            Icon: {},
            value: '104.18.10.164'
        },
        Terminal2: {
            extends: 'Terminal',
            value: '104.18.11.164'
        }
    },
    TxtRecord: {
        P: {
            color: 'gray8',
            margin: '0 - Z2',
            text: '3. Create TXT record:'
        },
        Code: {
            margin: 'Z1 0 0',
            Title: null,
            value: '// txt_record',
            Buttons: {
                Link: null,
                FrameworkSwitcher: null
            }
        }
    }
};

});

parcelRegister("kH7Ae", function(module, exports) {

$parcel$export(module.exports, "ChromeExt", () => $f10db4b9e5829613$export$d634877323dc1dda);
const $f10db4b9e5829613$export$d634877323dc1dda = {
    P: {
        color: 'gray8',
        margin: '0 0 X2',
        text: 'Optionally you can install the Chrome extension to have realtime preview of your Symbols:'
    },
    Link: {
        target: '_blank',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'transparent',
        display: 'inline-block',
        href: '#',
        transition: 'opacity A defaultBezier, border A defaultBezier',
        round: 'Z2',
        opacity: '.9',
        ':hover': {
            opacity: '1',
            borderColor: 'gray8.25'
        },
        Img: {
            display: 'block',
            height: 'C1',
            src: 'chrome-ext.png'
        }
    }
};

});

parcelRegister("clc6Q", function(module, exports) {

$parcel$export(module.exports, "InstallSymbolsJson", () => $8fc0d6e5af8b22b6$export$1262c65904bd4136);
const $8fc0d6e5af8b22b6$export$1262c65904bd4136 = {
    P: {
        color: 'gray8',
        margin: '0 - Z2',
        childProps: {
            display: 'inline'
        },
        children: [
            '2. Create ',
            {
                Labeled: {
                    text: 'symbols.json'
                }
            },
            ' file in your project:'
        ]
    },
    Code: {
        margin: 'Z1 0 0',
        Title: null,
        value: (el)=>{
            const rootState = el.getRootState?.();
            const framework = rootState?.framework === 'domql' ? 'symbols' : rootState?.framework || 'symbols';
            return `{
  "key": "${el.getAppKey?.() || 'my-app'}",
  "framework": "${framework}",
  "packageManager": "${rootState?.pkgManager || 'npm'}"
}`;
        }
    }
};

});

parcelRegister("f2JSf", function(module, exports) {

$parcel$export(module.exports, "InstallHero", () => $af3aa08c7ea733ae$export$b019d98b16ad2c30);
const $af3aa08c7ea733ae$export$b019d98b16ad2c30 = {
    flow: 'y',
    theme: 'headerCaptions',
    flow: 'column',
    gap: 'C1',
    padding: 'D3+Z D3 0',
    margin: '-D3+Z -D3 0',
    minWidth: '100%',
    Hgroup: {
        H: {
            text: 'Install Symbols'
        },
        P: {
            text: 'The short block to get your Symbols integrated:'
        }
    },
    'Iframe.youtube': {
        widthRange: 'G 50%',
        src: 'https://www.youtube.com/embed/QIdimVDuSEU?si=-1m28wkdUypmrI0w',
        border: '0',
        round: 'X2',
        margin: '-A -X2 -D3',
        aspectRatio: '16 / 9',
        minHeight: '0',
        allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share',
        allowfullscreen: true,
        onBeforeUpdate: ()=>false
    }
};

});

parcelRegister("eJLmi", function(module, exports) {

$parcel$export(module.exports, "UsersTable", () => $abaa011b1da2ac4d$export$23b8bf72cfd1bee4);
const $abaa011b1da2ac4d$export$23b8bf72cfd1bee4 = {
    onRender: async (el, s)=>{
        const projectMembers = await el.call('getProjectMembers');
        return s.set(projectMembers);
    },
    state: {},
    Flex_Title: {
        flow: 'x',
        align: 'center space-between',
        margin: '- - B2',
        gap: 'C1',
        Span: {
            text: 'Team Members:'
        },
        DocsLink: {
            if: (el)=>el.sdk.hasPermission('projectSettings'),
            flow: 'x',
            align: 'center',
            gap: 'X2',
            Icon: {
                name: 'plus'
            },
            text: 'Invite new member',
            theme: 'transparent',
            onClick: async (ev, el)=>{
                await el.call('openModal', '/settings', {
                    key: '/invite'
                });
            }
        }
    },
    Flex_members: {
        flow: 'y',
        childExtends: 'Grid',
        childProps: {
            align: 'center center',
            columns: '2.2em 1fr 3fr 1fr 1.8rem',
            padding: 'Z1 0',
            gap: 'C1',
            Avatar: {
                boxSize: 'B',
                key: (el, s)=>s.name
            },
            Name: {
                margin: '- - - -C',
                Text: {
                    tag: 'span',
                    text: '{{ name }}'
                },
                Strong: {
                    hide: (el, s)=>!s.username,
                    text: ' ({{ username }})'
                }
            },
            Email: {
                text: '{{ email }}'
            },
            Role: {
                role: '{{ role }}'
            },
            IconButton_Remove: {
                if: (el, s)=>el.sdk.hasPermission('iam') && s.role !== 'owner',
                icon: 'trash',
                onClick: async (ev, el, s)=>{
                    ev.preventDefault();
                    ev.stopImmediatePropagation();
                    const res = window.confirm('Do you really want to remove the User from this Project?');
                    if (res) try {
                        const rs = el.getRootState();
                        await el.sdk.removeMember(rs.projectId, s.id);
                        el.parent.remove();
                    } catch (err) {
                        console.error(err);
                    }
                }
            }
        },
        children: (el, s)=>s.parse(),
        childrenAs: 'state'
    }
};

});

parcelRegister("3ODVu", function(module, exports) {

$parcel$export(module.exports, "RoleSelect", () => $2c7503270d8ea18c$export$f783f1f51c5374cf);
const $2c7503270d8ea18c$export$f783f1f51c5374cf = {
    extends: 'SelectField',
    padding: '0',
    round: 'C1',
    Select: {
        name: 'user',
        id: 'user',
        onChange: async (ev, el, s)=>{
            ev.preventDefault();
            ev.stopImmediatePropagation();
            const res = window.confirm('Do you really want to change the User Role for this Project?');
            if (res) try {
                const rs = el.getRootState();
                await el.sdk.updateMemberRole(rs.projectId, s.id, ev.target.value);
            } catch (err) {
                console.error(err);
            }
            else ev.target.value = s.role;
        },
        childrenAs: 'props',
        children: ()=>[
                {
                    value: 'owner',
                    text: 'Owner'
                },
                {
                    value: 'admin',
                    text: 'Admin'
                },
                {
                    value: 'editor',
                    text: 'Editor'
                },
                {
                    value: 'guest',
                    text: 'Guest'
                }
            ],
        childProps: {
            tag: 'option',
            attr: {
                disabled: (el, s)=>!el.sdk.hasPermission('iam'),
                selected: (el, s)=>{
                    const userRole = s.role || -1;
                    const optionValue = el.value;
                    return userRole === optionValue;
                }
            }
        }
    }
};

});

parcelRegister("7p6X6", function(module, exports) {

$parcel$export(module.exports, "SettingsTabs", () => $564042c12049e6fa$export$230d78a31b14e415);
const $564042c12049e6fa$export$230d78a31b14e415 = {
    extends: 'TabsLinkSwitcher',
    children: (el)=>[
            el.isAdmin() && {
                href: '/project-account',
                text: el.getRootState('projectName')
            },
            el.isOwner() && {
                href: '/pricing',
                text: 'Billing'
            },
            el.isEditMode() && {
                href: '/project-data',
                text: 'Data'
            },
            {
                href: '/install',
                text: 'Install'
            },
            el.isEditMode() && {
                href: '/project-versions',
                text: 'Versions'
            },
            el.isAdmin() && {
                href: '/connect',
                text: 'Connect'
            },
            el.isAdmin() && {
                href: '/shared-libs',
                text: 'Shared Libraries'
            },
            {
                href: '/settings',
                text: 'Settings'
            }
        ].filter((v)=>v),
    childrenAs: 'props',
    childProps: {
        isActive: (el, s)=>s.key === el.href,
        borderStyle: 'solid',
        fontWeight: '400',
        padding: 'Z B1',
        '!isActive': {
            fontWeight: '400'
        },
        onClick: (ev, el, s)=>{
            // el.call(
            //   'openModal',
            //   '/settings',
            //   {
            //     key: el.props.href
            //   },
            //   { forced: true }
            // )
            s.update({
                key: el.href
            });
        }
    }
};

});

parcelRegister("3dUjC", function(module, exports) {

$parcel$export(module.exports, "DashboardTabs", () => $258e4513a246d825$export$90de4fc8eb5809e1);
const $258e4513a246d825$export$90de4fc8eb5809e1 = {
    extends: 'Grid',
    templateColumns: '3fr 7fr',
    gap: 'A',
    color: 'white',
    align: 'space-between',
    round: 'A',
    minHeight: 'G1',
    '@screenM': {
        templateColumns: '2.7fr 7fr'
    },
    '@screenS': {
        templateColumns: '1fr'
    },
    Info: {
        flow: 'y',
        flex: 1,
        flow: 'column',
        align: 'flex-start space-between',
        padding: '0',
        gap: 'E',
        '@screenS': {
            flow: 'row',
            padding: '- - Y -'
        },
        Hgroup: {
            width: '100%',
            padding: 'Z X2',
            H: {
                tag: 'h4',
                lineHeight: 1.2,
                margin: '0 0 X',
                fontWeight: '700',
                text: 'Dashboard'
            },
            P: {
                maxWidth: 'G1',
                text: 'Welcome to your development dashboard where you can customize your branding, build components, pages and add functions and files.'
            }
        },
        ContinueButton: {
            minWidth: 'auto',
            opacity: '1',
            padding: 'Z1 B',
            margin: '0',
            gap: 'X2',
            text: 'Getting Started',
            href: '/init/personalize',
            transitionProperty: 'background, transform, color, background',
            theme: 'secondary',
            '@screenS': {
                alignSelf: 'flex-end'
            }
        }
    },
    Flex: {
        margin: '- - - -Z2',
        gap: 'A',
        flex: 3,
        '@screenS': {
            gap: 'A1'
        },
        '@tabletS': {
            display: 'grid',
            columns: 'repeat(3, 1fr)'
        },
        childExtends: 'ItemHighlightAlt',
        childrenAs: 'state',
        children: ()=>[
                {
                    available: state.package > 1,
                    icon: state.package > 1 ? 'copywriting' : 'arrowUpRight',
                    title: 'Content',
                    href: state.package > 1 ? '/state' : '/pricing',
                    p: 'State and content database'
                },
                {
                    available: state.package > 1,
                    icon: state.package > 1 ? 'pages' : 'arrowUpRight',
                    title: 'Pages',
                    href: state.package > 1 ? '/pages' : '/pricing',
                    p: 'Pages, routes and flow of the app'
                },
                {
                    icon: 'menu outline',
                    title: 'Components',
                    href: '/components',
                    p: 'Symbols User Interface library'
                },
                {
                    icon: 'tree outline',
                    title: 'Design System',
                    href: '/design-system',
                    p: 'Design System of your brand'
                },
                {
                    available: state.package > 1,
                    icon: 'fn outline',
                    title: 'Functions',
                    href: state.package > 1 ? 'fn outline' : 'arrowUpRight',
                    p: 'Browser and data functions'
                }
            ]
    }
};

});

parcelRegister("l1XOK", function(module, exports) {

$parcel$export(module.exports, "IntegrationsList", () => $f4f81778e49ada91$export$859afb2d25dd0c2e);
const $f4f81778e49ada91$export$859afb2d25dd0c2e = {
    extends: 'Grid',
    height: '100%',
    width: '100%',
    padding: 'Z2 A',
    overflow: 'auto',
    overflowY: 'auto',
    templateColumns: 'repeat(4, 1fr)',
    templateRows: 'repeat(12, 1fr)',
    childrenAs: 'state',
    children: [
        {
            poster: 'https://assets.bwbx.io/images/users/iqjWHBFdfxIU/iy6P.qskNVuU/v0/1200x-1.png',
            title: 'Google Maps'
        },
        {
            poster: 'https://plausible.io/docs/img/numbers-not-adding-up.png',
            title: 'Plausible Analytics'
        },
        {
            poster: 'https://images.ctfassets.net/xny2w179f4ki/79Ufvhs5lHbhgaamd7E5SO/dbce5c98feff7e3e2411155f29d668ef/Screen_Shot_2021-12-01_at_12.29_1.png',
            title: 'Intercom'
        },
        {
            poster: 'https://assets.cdn.prod.twilio.com/original_images/whats-new-in-capturing-video-feature.png',
            title: 'Twillio Video'
        },
        {
            poster: 'https://community.fabric.microsoft.com/t5/image/serverpage/image-id/109469i0FAB4D2BF0FEEBA6?v=v2',
            title: 'Twitter Feed'
        },
        {
            poster: 'https://searchengineland.com/wp-content/seloads/2011/03/facebook-like-buttons.jpg',
            title: 'Facebook Like button'
        },
        {
            poster: 'https://cdn.pixabay.com/photo/2020/03/19/13/58/youtube-4947559_1280.jpg',
            title: 'Youtube Video'
        },
        {
            poster: 'https://i.ytimg.com/vi/NooR1uqCgtg/mqdefault.jpg',
            title: 'Figma Preview'
        },
        {
            poster: 'https://res.cloudinary.com/practicaldev/image/fetch/s--CRJTTGM8--/c_imagga_scale,f_auto,fl_progressive,h_900,q_auto,w_1600/https://dev-to-uploads.s3.amazonaws.com/i/g595slgphyi9lkqz2u18.png',
            title: 'Mardown preview'
        },
        {
            poster: 'https://vimeo-blog-images.storage.googleapis.com/2022/03/Blog_-Video-Editing-on-Tiktok-and-best-Tiktok-editing-apps.png',
            title: 'Tiktok Video'
        }
    ],
    gap: 'C1',
    childExtends: 'IntegrationItem'
};

});

parcelRegister("jAIMf", function(module, exports) {

$parcel$export(module.exports, "InstallSync", () => $e4341cede6efc806$export$7e42685671ebc8d);
const $e4341cede6efc806$export$7e42685671ebc8d = {
    P: {
        color: 'gray8',
        margin: '0',
        text: '3. Run CLI tool to synchronize:'
    },
    Terminal: {
        width: 'fit-content',
        margin: 'A 0 Z -Y',
        value: (el)=>{
            const pkg = el.getRootState?.()?.pkgManager;
            return pkg === 'npm' ? 'npm i @symbo.ls/cli -g' : pkg === 'yarn' ? 'yarn add smbls global' : pkg === 'pnpm' ? 'pnpm add smbls global' : 'npm i @symbo.ls/cli -g';
        }
    },
    Flex: {
        gap: 'C1',
        TerminalWithTitle_fetch: {
            margin: 'A - -',
            Title: {
                text: 'One-time fetch:'
            },
            Terminal: {
                margin: '0 0 0 -Y',
                value: 'smbls fetch'
            }
        },
        TerminalWithTitle_sync: {
            margin: 'A - -',
            Title: {
                text: 'Listening changes:'
            },
            Terminal: {
                margin: '0 0 0 -Y',
                value: 'smbls sync'
            }
        }
    }
};

});

parcelRegister("77wfO", function(module, exports) {

$parcel$export(module.exports, "ServerPreview", () => $52f234d3e0336f41$export$e1a41130dda87857);
const $52f234d3e0336f41$export$e1a41130dda87857 = {
    flow: 'column',
    align: 'center space-between',
    gap: 'B',
    round: 'Z2',
    padding: 'Z2 A1',
    borderWidth: '1px',
    borderStyle: 'solid',
    theme: 'common-card-outline',
    SectionHeader: {
        margin: '0',
        padding: '0',
        title: 'Development'
    }
};

});

parcelRegister("6Jezj", function(module, exports) {

$parcel$export(module.exports, "IntegrationItem", () => $4e623f13d1123dfd$export$28ffd0d8a8abd470);
const $4e623f13d1123dfd$export$28ffd0d8a8abd470 = {
    extends: [
        'Flex',
        'Link'
    ],
    position: 'relative',
    href: '/playground',
    fontWeight: 'bold',
    overflow: 'hidden',
    flexDirection: 'column',
    width: '100%',
    height: 'F2',
    padding: '0 Z 0 A2',
    round: 'Z1',
    borderStyle: 'solid',
    borderWidth: '0.5px',
    borderColor: 'line',
    background: ({ state: state })=>`url(${state.poster}) center center no-repeat`,
    backgroundSize: 'cover',
    ':after, :before': {
        content: '""',
        position: 'absolute',
        inset: '0 0 0 0',
        transition: 'B defaultBezier',
        transitionProperty: 'opacity',
        background: 'shadow-overlay',
        zIndex: 1
    },
    Title: {
        color: 'gray8',
        fontWeight: 400,
        position: 'absolute',
        inset: 'auto 0 0 0',
        padding: 'Z A Z2',
        background: 'gray1.65',
        boxShadow: '0 0 35px gray1',
        zIndex: 2,
        text: '{{ title }}'
    }
};

});

parcelRegister("9TDMg", function(module, exports) {

$parcel$export(module.exports, "SettingsFooter", () => $73481b1058f37dbd$export$263308e70c82876f);
const $73481b1058f37dbd$export$263308e70c82876f = {
    ContinueButton: {
        show: (el)=>!el.getUserSettings('autoSaveSettings'),
        hide: (el)=>el.getUserSettings('autoSaveSettings'),
        text: 'Update',
        onClick: async (ev, el)=>{
            await el.call('closeModal');
            const Canvas = el.getCanvas();
            Canvas.Iframe.update();
            el.getEditorPanels().update();
            el.call('openNotification', {
                title: 'Settings are saved',
                message: `Project settings are updated`,
                type: 'success'
            });
        }
    },
    CheckboxField: {
        margin: '- auto - -',
        checked: (el)=>el.getUserSettings('autoSaveSettings'),
        onChange: (ev, el)=>{
            el.setUserSettings('autoSaveSettings', Boolean(ev.target.checked));
            el.parent.update();
        },
        Icon: {},
        Span: {
            text: 'Auto update canvas'
        }
    },
    Flex: {
        gap: 'B2',
        childExtends: [
            'IconText',
            'DocsLink'
        ],
        ConvertToDomql3: {
            color: 'inactive',
            text: 'Convert to DOMQL3',
            onClick: async (ev, el)=>{
                await el.convertToDomql3();
            }
        },
        RestoreTypes: {
            color: 'inactive',
            text: 'Restore missing types',
            onClick: async (ev, el)=>{
                await el.restoreMissingTypes();
            }
        },
        RestoreComponents: {
            color: 'inactive',
            text: 'Restore missing components',
            onClick: async (ev, el)=>{
                await el.restoreMissingComponents();
            }
        },
        ResetSettings: {
            color: 'inactive',
            text: 'Reset settings',
            onClick: (ev, el)=>{
                el.setAllUserSettings({
                    optimizedMode: false,
                    thumbnailPreview: false,
                    allowInitialSelection: false,
                    openOnDblClick: true,
                    showGrid: true,
                    allowTabs: true,
                    allowZoombar: true,
                    allowAutoPosition: true,
                    allowTabPreview: true,
                    useAnimations: true
                }, {
                    message: 'Reset settings'
                });
            }
        },
        ClearCookies: {
            color: 'inactive',
            text: 'Clean settings cookies',
            onClick: (ev, el)=>{
                el.call('removeCookie', 'topNavbarActive');
                el.call('removeCookie', 'bottomNavbarActive');
                el.call('removeCookie', 'globalTheme');
                el.call('removeCookie', 'sceneTheme');
                el.call('removeCookie', 'globalTheme');
                el.call('removeCookie', 'framework');
                el.call('removeCookie', 'pkgManager');
                el.call('removeCookie', 'language');
                el.call('removeCookie', 'activeProject');
                el.call('removeCookie', 'installTab');
                el.call('removeCookie', 'isSidebarSticky');
                el.call('removeCookie', 'componentShowFilter');
                el.call('removeCookie', 'navbarPlacement');
                el.call('removeCookie', 'presentMode');
                el.call('removeCookie', 'showErrorBanner');
                el.call('removeCookie', 'thumbnailPreview');
                el.call('removeCookie', 'optimizedMode');
                el.call('removeCookie', 'showGrid');
                el.call('removeCookie', 'explorerAutoscroll');
                el.call('removeCookie', 'debuggingMode');
                el.call('removeCookie', 'allowCanvasReplaceRouter');
                el.call('removeCookie', 'useDomql3');
                el.call('removeCookie', 'useGlassmorphism');
                el.call('removeCookie', 'allowAutoPosition');
                el.call('removeCookie', 'allowInitialSelection');
                el.call('removeCookie', 'openOnDblClick');
                el.call('removeCookie', 'allowTabs');
                el.call('removeCookie', 'showReferences');
                el.call('removeCookie', 'allowTeamCursors');
                el.call('removeCookie', 'allowFilesidebarPreview');
                el.call('removeCookie', 'allowTabPreview');
                el.call('removeCookie', 'useAnimations');
                el.call('removeCookie', 'allowZoombar');
                el.call('removeCookie', 'previewSize');
                el.call('removeCookie', 'zoomLevel');
                el.call('removeCookie', 'userId');
                el.call('removeCookie', 'name');
                el.call('removeCookie', 'email');
                el.call('openNotification', {
                    title: 'Cookies are cleared',
                    message: `Cleared all project related cookies from browser`,
                    type: 'success'
                });
            }
        },
        ClearCache: {
            color: 'inactive',
            text: 'Clean project cache',
            fontWeight: 400,
            onClick: async (ev, el)=>{
                await el.clearCache();
            }
        }
    },
    flow: 'x',
    gap: 'B2',
    margin: 'A2 -X2 B2',
    align: 'center space-between'
};

});

parcelRegister("lUkki", function(module, exports) {

$parcel$export(module.exports, "ProjectSection", () => $ff2e98537acd4e4b$export$df6d31f85b3648aa);
const $ff2e98537acd4e4b$export$df6d31f85b3648aa = {
    extends: 'Grid',
    childExtends: 'ProjectInfo',
    templateColumns: (el)=>el.getRootState().package > 1 ? '5fr 2fr' : '1fr',
    gap: 'A',
    align: 'stretch flex-start',
    Stats: {
        Title: {
            text: 'Company'
        },
        ItemPreview: {
            gap: 'B',
            align: 'flex-start space-between',
            Strong: {
                margin: 'W - -',
                text: '{{ title }}'
            },
            Grid: {
                templateColumns: '2fr 1fr 1fr 1fr',
                width: '100%',
                childExtends: {
                    extends: 'Hgroup',
                    margin: '0',
                    H: {
                        tag: 'strong',
                        text: '{{ title }}'
                    },
                    P: {
                        text: '{{ p }}'
                    }
                },
                children: (el)=>[
                        {
                            title: el.getRootState().package > 1 ? 'Premium' : 'Starter',
                            p: 'Package'
                        },
                        {
                            title: `1.${el.getRootState().version}`,
                            p: 'Version'
                        },
                        {
                            title: el.getRootState().versionscount,
                            p: 'Publishes'
                        },
                        {
                            title: el.call('formatDate', el.getRootState().createdAt),
                            p: 'User since'
                        }
                    ],
                childrenAs: 'state'
            }
        }
    },
    Team: {
        Title: {
            text: 'Team'
        },
        ItemPreview: {
            AvatarBundle: {
                extends: 'AvatarBundle',
                fontSize: 'Y2',
                options: (el, s)=>{
                    const projectUsers = el.getRootProjectsUsers();
                    const filtered = el.call('isArray', projectUsers) ? projectUsers.filter((v)=>(v.role || 0) > -1) : projectUsers;
                    return filtered?.filter((v)=>!v.email?.endsWith('@symbo')).map((v)=>({
                            key: v.name,
                            title: v.name
                        }));
                },
                childProps: {
                    ':not(:last-child)': {
                        margin: '0 -Z 0 0'
                    }
                }
            },
            SectionHeader_last_connected: {
                margin: '0',
                title: (el)=>{
                    const projectUsers = el.getRootProjectsUsers();
                    const usersCount = projectUsers?.filter((v)=>(v.role || 0) > -1).length;
                    return `${usersCount} members`;
                },
                p: (el)=>{
                    const projectUsers = el.getRootProjectsUsers();
                    const usersCount = projectUsers?.filter((v)=>(v.role || 0) > -1).length;
                    const left = 5 - usersCount < 0 ? 0 : usersCount;
                    return `You can invite ${left} more users`;
                }
            }
        }
    }
};

});

parcelRegister("f90ed", function(module, exports) {

$parcel$export(module.exports, "ProjectInfo", () => $b067df9ed82f3a69$export$a1c9a67310a2d004);
const $b067df9ed82f3a69$export$a1c9a67310a2d004 = {
    extends: 'Group',
    tag: 'section',
    gap: 'Z',
    Title: {
        text: 'Connected',
        width: '100%'
    },
    ItemPreview: {
        flex: 1,
        templateColumns: 'repeat(12, 1fr)',
        autoFlow: 'dense',
        autoColumns: 'auto',
        autoRows: 'auto',
        justifyItems: 'stretch',
        position: 'relative',
        transition: 'C defaultBezier max-height'
    }
};

});

parcelRegister("l4XWj", function(module, exports) {

$parcel$export(module.exports, "SignupForm", () => $f588776981bca31f$export$cc15cfe224a6a69b);
const $f588776981bca31f$export$cc15cfe224a6a69b = {
    flow: 'column',
    gap: 'A',
    flex: '1',
    '@mobileL': {
        minWidth: '100%'
    },
    childExtends: {
        extends: 'InputField',
        width: '100%',
        '@mobileL': {
            maxWidth: '100%'
        },
        Title: {},
        Input: {
            width: '100%',
            onInput: (ev, el, s)=>{
                s.update({
                    [el.parent.key.toLowerCase()]: el.node.value
                });
            }
        }
    },
    Email: {
        Title: {
            text: 'Email',
            padding: '- - 0'
        },
        Input: (_, s)=>({
                height: 'B2',
                '@mobileL': {
                    height: 'unset'
                },
                autofocus: true,
                autocomplete: 'email',
                required: true,
                value: s.email ? s.email : s.value,
                placeholder: 'e.g. hello@symbo.ls',
                disabled: s.hasToken
            })
    },
    Name: {
        Title: {
            text: 'Full name',
            padding: '- - 0'
        },
        Input: {
            height: 'B2',
            '@mobileL': {
                height: 'unset'
            },
            autocomplete: '{{ value }}',
            required: true,
            value: '{{ value }}',
            placeholder: 'e.g. Mike',
            type: 'text'
        }
    },
    Password: {
        Title: {
            text: 'Password',
            padding: '- - 0'
        },
        Input: {
            height: 'B2',
            '@mobileL': {
                height: 'unset'
            },
            autocomplete: 'current-password',
            value: '{{ value }}',
            placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022",
            required: true,
            type: 'password',
            onInput: (ev, el, s)=>{
                s.password = el.node.value;
                s.update({
                    password: el.node.value
                });
            }
        }
    },
    ModalFooter: {
        padding: 'B1 - - -',
        CheckButton: {
            theme: 'primary',
            text: 'Sign up',
            height: 'B2',
            '@mobileL': {
                height: 'unset'
            },
            type: 'submit',
            icon: null
        },
        Title: null,
        Input: null
    }
};

});

parcelRegister("kx5it", function(module, exports) {

$parcel$export(module.exports, "LoginForm", () => $ef2aff98e6994a48$export$1f58f750f20f344b);
const $ef2aff98e6994a48$export$1f58f750f20f344b = {
    flow: 'column',
    height: '100%',
    gap: 'C1',
    '@mobileL': {
        height: 'unset',
        align: 'center flex-start',
        width: '100%'
    },
    Flex: {
        gap: 'A',
        flow: 'column',
        childProps: {
            width: '100%',
            '@mobileL': {
                maxWidth: '100%',
                align: 'stretch',
                width: '100%'
            }
        },
        Title: null,
        Input: null,
        Identifier: {
            Title: {
                text: 'Email or username',
                padding: '- - Y'
            },
            Input: {
                height: 'B2',
                width: '100%',
                autocomplete: 'username',
                value: (el, s)=>s.identifier ?? '',
                required: true,
                placeholder: 'e.g. hello@symbo.ls or username',
                round: 'Z2',
                '@mobileL': {
                    width: '100%',
                    height: 'unset'
                },
                onInput: (ev, el, s)=>{
                    s.update({
                        identifier: el.node.value
                    });
                }
            }
        },
        Password: {
            Title: {
                text: 'Password',
                padding: '- - X'
            },
            Input: {
                height: 'B2',
                width: '100%',
                autocomplete: 'current-password',
                value: (el, s)=>s.password ?? '',
                placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022",
                required: true,
                type: 'password',
                round: 'Z2',
                '@mobileL': {
                    width: '100%',
                    height: 'unset'
                },
                onInput: (ev, el, s)=>{
                    s.update({
                        password: el.node.value
                    });
                }
            }
        }
    },
    ModalFooter: {
        display: 'flex',
        flow: 'row',
        width: '100%',
        maxWidth: 'unset',
        align: 'center space-between',
        gap: 'Z',
        '@mobileL': {
            flow: 'column',
            gap: 'A2',
            childProps: {
                width: '100%'
            }
        },
        CheckButton: {
            theme: 'primary',
            text: 'Sign in',
            type: 'submit',
            Icon: null,
            width: 'fit-content',
            height: 'B2',
            padding: 'Z1 B1',
            '@mobileL': {
                width: '100%',
                maxWidth: '100%',
                height: 'unset'
            }
        },
        Title: null,
        Input: null,
        DocsLink: {
            margin: '- - - auto',
            fontSize: 'Z2',
            fontWeight: '400',
            href: '/reset-password',
            text: 'Forgot your password?',
            display: 'flex',
            align: 'center center',
            '@mobileL': {
                margin: '0 auto'
            }
        }
    }
};

});

parcelRegister("7VcWh", function(module, exports) {

$parcel$export(module.exports, "ItemPreview", () => $5c47e4ab89057f57$export$5f817064d72b5431);
const $5c47e4ab89057f57$export$5f817064d72b5431 = {
    extends: [
        'Flex',
        'Link'
    ],
    flow: 'column',
    align: 'space-between flex-start',
    gap: 'C2',
    round: 'Z2',
    padding: 'A1 A1',
    whiteSpace: 'nowrap',
    href: (el)=>{
        const key = el.getAppKey();
        return key ? '/account/' + key.split('.')[0] : null;
    },
    transition: 'A defaultBezier',
    transitionProperty: 'background, color, border-color',
    borderWidth: '2px',
    borderStyle: 'solid',
    theme: 'common-card-outline-interactive',
    fontWeight: '400'
};

});

parcelRegister("agkFM", function(module, exports) {

$parcel$export(module.exports, "WaitlistForm", () => $778b6f3bc2437dcf$export$c214714ed8e35309);
const $778b6f3bc2437dcf$export$c214714ed8e35309 = {
    flow: 'column',
    gap: 'B1',
    flex: '1',
    childProps: {
        value: (el, s)=>s[el.key.toLowerCase()],
        fontSize: 'A2',
        padding: 'Z1 A2',
        width: '100%',
        maxWidth: 'G',
        onChange: (ev, el, s)=>{
            s.update({
                [el.key.toLowerCase()]: el.node.value
            });
        }
    },
    childExtends: 'Input',
    Name: {
        placeholder: 'Name',
        required: true
    },
    Email: {
        placeholder: 'Email',
        required: true,
        type: 'email'
    }
};

});

parcelRegister("hAIXV", function(module, exports) {

$parcel$export(module.exports, "RequestAccessButtons", () => $cce8adb120680d08$export$cb65862e7b9e8f70);
const $cce8adb120680d08$export$cb65862e7b9e8f70 = {
    flow: 'y',
    align: 'start start',
    borderColor: 'line',
    borderStyle: 'solid',
    borderWidth: '0 0 0 1px',
    margin: '0',
    '@mobileL': {
        borderColor: 'transparent',
        borderStyle: 'unset',
        borderWidth: '0',
        padding: 'C1 0 0',
        align: 'center flex-start'
    },
    childProps: {
        width: '100%'
    },
    Hgroup: {
        H: {
            tag: 'strong',
            text: 'Get early access'
        },
        P: {
            text: `We're kicking off invite-only. Get early signup to make it to the top.`
        }
    },
    Flex: {
        flow: 'y',
        gap: 'A2',
        '@mobileL': {
            gap: 'A'
        },
        Link: {
            extends: [
                'Link',
                'Button'
            ],
            icon: 'email',
            margin: '0 0 0 -X',
            theme: 'quaternary',
            fontWeight: '500',
            text: 'Continue with email',
            href: '/signin',
            gap: 'Z',
            '@tabletS': {
                padding: '- - - C'
            },
            '@mobileL': {
                align: 'center center',
                maxWidth: '100%',
                textAlign: 'center',
                border: 'none'
            }
        }
    }
};

});

parcelRegister("dRmWs", function(module, exports) {

$parcel$export(module.exports, "InviteForm", () => $a172055ab740c50a$export$b8c329f2c3642723);
const $a172055ab740c50a$export$b8c329f2c3642723 = {
    flow: 'column',
    gap: 'B1',
    flex: '1',
    childProps: {
        Input: {
            margin: '- -Z'
        }
    },
    'InputField.name': {
        Title: {
            text: 'Full name'
        },
        Input: {
            value: '{{ name }}',
            required: true,
            placeholder: 'Mike',
            onInput: (ev, el, s)=>{
                const [, key] = el.parent.key.split('.');
                s.update({
                    [key]: el.node.value
                });
            }
        }
    },
    'InputField.email': {
        Title: {
            text: 'Email of member'
        },
        Input: {
            value: '{{ email }}',
            required: true,
            placeholder: 'mike@me.com',
            pattern: '^[^s@]+@[^s@]+.[^s@]{2,}$',
            type: 'email',
            onInput: (ev, el, s)=>{
                const [, key] = el.parent.key.split('.');
                s.update({
                    [key]: el.node.value
                });
            }
        }
    },
    Flex: {
        extends: 'GroupField',
        Title: {
            text: 'Role of member'
        },
        'SelectRoleField.role': {
            margin: '- -Z',
            Select: {
                value: '{{ role }}',
                required: true,
                onChange: (ev, el, s)=>{
                    const [, key] = el.parent.key.split('.');
                    s.update({
                        [key]: el.node.value
                    });
                },
                onRender: (el, s)=>{
                    const [, key] = el.parent.key.split('.');
                    console.error(111, s);
                    s.update({
                        [key]: 'guest'
                    });
                }
            }
        },
        Input: {
            display: 'none'
        }
    }
};

});

parcelRegister("iVQkc", function(module, exports) {

$parcel$export(module.exports, "LoginWindow", () => $dc8623753a7008ec$export$e2c4df1c67a59cff);
const $dc8623753a7008ec$export$e2c4df1c67a59cff = {
    extends: 'ModalWindow',
    tag: 'form',
    overflow: 'visible',
    position: 'relative',
    transform: 'none',
    top: 'auto',
    left: 'auto',
    flow: 'column',
    align: 'flex-start space-between',
    // boxSize: 'H1 I1',
    boxSize: 'auto',
    margin: 'auto',
    padding: 'B B2 C1',
    round: 'A',
    theme: 'dialog',
    border: '1px solid blue.1',
    boxShadow: 'black 0 0 50px, blue.5 0 15px 100px -35px',
    LoadingGifSection: {
        background: 'black.65',
        position: 'absolute',
        inset: '0',
        fullSize: true,
        transition: 'B defaultBezier',
        transitionProperty: 'opacity, visibility',
        pointerEvents: (el, s)=>s.loading ? 'auto' : 'none',
        opacity: (el, s)=>s.loading ? 1 : 0,
        visibility: (el, s)=>s.loading ? 'visible' : 'hidden'
    },
    ModalHeader: {
        margin: '0',
        Hgroup: {
            H: {
                text: 'Sign in to Symbols'
            },
            P: null
        },
        Icons: {
            Close: {
                if: ()=>[
                        '/signin',
                        '/signup',
                        '/reset-password'
                    ].includes(window.location.pathname),
                href: '/'
            }
        }
    },
    Flex: {
        align: 'start space-between',
        width: '100%',
        padding: 'B C1',
        flow: 'x',
        gap: 'C2',
        childProps: {
            flex: 1
        },
        '@mobileL': {
            wrap: 'wrap',
            padding: 'C1 B C1 B',
            gap: 'A1',
            width: '100%',
            maxWidth: '100%'
        },
        RequestAccessButtons: {
            height: '100%',
            padding: '- - - C2',
            gap: 'A2',
            Hgroup: {
                margin: '- - A'
            },
            Flex: {
                GoogleSignInButton: {
                    extends: [
                        'Link',
                        'Button'
                    ],
                    margin: '0 0 0 -X',
                    theme: 'quaternary',
                    fontWeight: '500',
                    gap: 'Z',
                    cursor: 'pointer',
                    icon: 'googleLogoNormal',
                    text: 'Sign in with Google',
                    '@tabletS': {
                        padding: '- - - C'
                    },
                    '@mobileL': {
                        padding: 'Z1 -',
                        align: 'center center',
                        maxWidth: '100%',
                        textAlign: 'center',
                        border: 'none'
                    },
                    onRender: async (el, state)=>{
                        // Make sure Google client is loaded
                        if (!window.google || !window.google.accounts || !window.google.accounts.id) {
                            console.error('Google Identity Services not loaded');
                            return;
                        }
                        const { environment: environment } = el.sdk;
                        // Initialize Google Identity Services with explicit client ID
                        window.google.accounts.id.initialize({
                            client_id: environment.googleClientId,
                            callback: async (response)=>{
                                if (!response.credential) {
                                    console.error('No credential received');
                                    return;
                                }
                                try {
                                    // Get invite token from localStorage instead of URL
                                    const inviteToken = localStorage.getItem('google_auth_invite_token');
                                    const loginResult = await el.sdk.googleAuth(response.credential, inviteToken);
                                    // Clean up the stored token
                                    localStorage.removeItem('google_auth_invite_token');
                                    el.call('applyLoader', {
                                        value: true,
                                        force: true,
                                        timeout: 1
                                    });
                                    await el.call('initializeUserSession', {
                                        loginData: loginResult
                                    }, el.getRootState(), el.sdk);
                                    state.update({
                                        loading: false
                                    });
                                    el.router('/dashboard', el.getRoot());
                                } catch (error) {
                                    console.error('Failed to sign in:', error);
                                    // Clean up stored token on error
                                    localStorage.removeItem('google_auth_invite_token');
                                    el.call('openNotification', {
                                        title: 'Failed to sign in',
                                        message: error.message,
                                        type: 'error'
                                    });
                                    state.update({
                                        loading: false
                                    });
                                }
                            },
                            auto_select: false,
                            cancel_on_tap_outside: true
                        });
                        // Pre-render the Google Sign-In button
                        window.google.accounts.id.renderButton(el.dom, {
                            type: 'standard',
                            theme: 'outline',
                            size: 'large',
                            text: 'signin_with',
                            shape: 'rectangular'
                        });
                    },
                    onClick: (ev, el, state)=>{
                        state.update({
                            loading: true
                        });
                        // Store invite token in localStorage before initiating Google auth
                        try {
                            const currentUrl = new URL(window.location.href);
                            const inviteToken = currentUrl.searchParams.get('token');
                            if (inviteToken) localStorage.setItem('google_auth_invite_token', inviteToken);
                        } catch (error) {
                            console.error('Failed to store invite token:', error);
                        }
                        // First try Google One Tap
                        try {
                            window.google?.accounts.id.prompt((notification)=>{
                                if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
                                    state.update({
                                        loading: false
                                    });
                                    el.call('handleGoogleRedirectFlow');
                                }
                            });
                        } catch (error) {
                            console.error('One Tap failed, trying redirect flow:', error);
                            // Direct fallback to redirect-based flow
                            state.update({
                                loading: false
                            });
                            el.call('handleGoogleRedirectFlow');
                        }
                    }
                },
                GithubSignInButton: {
                    if: (el)=>{
                        const environment = el.sdk?.environment;
                        if (!environment) return false;
                        return !environment.isPreview;
                    },
                    extends: [
                        'Link',
                        'Button'
                    ],
                    margin: '0 0 0 -X',
                    theme: 'quaternary',
                    fontWeight: '500',
                    gap: 'Z',
                    cursor: 'pointer',
                    icon: 'github',
                    text: 'Sign in with Github',
                    '@tabletS': {
                        padding: '- - - C'
                    },
                    '@mobileL': {
                        padding: 'Z1 -',
                        align: 'center center',
                        maxWidth: '100%',
                        textAlign: 'center',
                        border: 'none'
                    },
                    onClick: (ev, el, state)=>{
                        state.update({
                            loading: true
                        });
                        const environment = el.sdk?.environment;
                        if (!environment) return;
                        try {
                            const clientId = environment.githubClientId;
                            const currentUrl = new URL(window.location.href);
                            const inviteToken = currentUrl.searchParams.get('token');
                            // Store invite token in localStorage instead of appending to redirect URI
                            if (inviteToken) localStorage.setItem('github_auth_invite_token', inviteToken);
                            // Use clean redirect URI (no dynamic parameters)
                            const redirectUri = `${window.location.origin}/github-auth-callback`;
                            const encodedRedirectUri = encodeURIComponent(redirectUri);
                            const scope = 'user:email';
                            window.location.href = `https://github.com/login/oauth/authorize?client_id=${clientId}&redirect_uri=${encodedRedirectUri}&scope=${scope}`;
                        } catch (error) {
                            console.error('Failed to initiate GitHub login:', error);
                            // Clean up stored token on error
                            localStorage.removeItem('github_auth_invite_token');
                            state.update({
                                loading: false
                            });
                            el.call('openNotification', {
                                title: 'Failed to sign in',
                                message: 'Failed to initialize GitHub Sign-In. Please try again.',
                                type: 'error'
                            });
                        }
                    }
                },
                Link: {
                    order: 3
                }
            }
        }
    }
};

});

parcelRegister("dZej3", function(module, exports) {

$parcel$export(module.exports, "YouAreConnected", () => $a2ec11cc518f540f$export$435025809c0ec1d9);
const $a2ec11cc518f540f$export$435025809c0ec1d9 = {
    if: (el)=>el.getRootState().package > 0,
    width: '100%',
    attr: {
        id: 'connect'
    },
    SectionTitle: {
        text: 'Connection'
    },
    Grid: {
        width: '100%',
        flex: 1,
        templateColumns: 'repeat(4, 1fr)',
        position: 'relative',
        transition: 'C defaultBezier max-height',
        gap: 'A',
        ServerPreview_test: {
            gap: 'C1',
            SectionHeader: {
                title: 'Development'
            },
            Flex: {
                gap: 'A',
                flow: 'y',
                ConnectionLabel_dev: {
                    isActive: (el)=>el.getAppKey(),
                    Circle: {},
                    Link: {
                        target: '_blank',
                        fontWeight: '400',
                        href: (el)=>`https://${el.getAppKey()}/`,
                        ':hover': {
                            textDecoration: 'underline'
                        },
                        '@dark': {
                            color: 'white'
                        },
                        '@light': {
                            color: 'black'
                        },
                        text: (el)=>el.getAppKey()
                    },
                    SquareButton_force: {
                        show: (el, s)=>s.active,
                        icon: 'reload outline',
                        background: 'transparent',
                        theme: 'common-card-outline-interactive',
                        isActive: false,
                        fontSize: 'Z',
                        '--spacing-ratio': 1.2,
                        borderWidth: '1px',
                        borderStyle: 'solid',
                        onClick: async (event, el)=>{
                            el.update({
                                Icon: {
                                    name: 'checkmark outline'
                                }
                            });
                            const t = setTimeout(()=>{
                                el.update({
                                    Icon: {
                                        name: 'reload outline'
                                    }
                                });
                                clearTimeout(t);
                            }, 1000);
                            await el.call('addSmblsSubdomains', el.getAppKey());
                        }
                    },
                    text: null
                },
                ConnectionLabel_local: {
                    isActive: (el, s)=>el.getRootState('clients').localhost,
                    Circle: {},
                    text: 'localhost'
                }
            }
        },
        ServerPreview_cli: {
            SectionHeader: {
                title: 'CLI'
            },
            ConnectionLabel: {
                isActive: (el, s)=>el.getRootState('clients').cli
            }
        },
        ServerPreview_ci: {
            SectionHeader: {
                title: 'CI'
            },
            ConnectionLabel: {}
        },
        ServerPreview_prod: {
            flex: 1,
            state: 'RELEASE',
            SectionHeader: {
                title: 'Production'
            },
            ConnectionLabel_published: {
                isActive: (el)=>el.getRootState('createdAt'),
                Circle: {},
                text: (el, s)=>s.isActive ? 'Published' : 'Not published',
                Link: {
                    color: 'highlight',
                    target: '_blank',
                    fontWeight: '400',
                    hide: (el)=>!el.getRootState('domain'),
                    href: (el)=>el.getRootState('domain'),
                    text: (el)=>el.getRootState('domain') && new URL(el.getRootState('domain')).host,
                    ':hover': {
                        textDecoration: 'underline'
                    }
                }
            },
            SectionHeader_last_connected: {
                margin: '0',
                heading: null,
                Article: {
                    P: {
                        order: '-1',
                        text: 'Last publish'
                    },
                    Title: {
                        color: 'title',
                        text: (el)=>el.getRootState('updatedAt') && new Date(el.getRootState('updatedAt')).toLocaleString()
                    }
                }
            }
        }
    },
    Flex: {
        minWidth: '100%',
        align: 'center space-between',
        gridColumnStart: 'span 3',
        color: 'title',
        padding: 'B1 X - -',
        staging: {
            noChanges: {
                if: ()=>false,
                text: 'You have no staged changes'
            },
            publish: {
                if: ()=>true,
                ContinueButton_publish: {
                    scrollToTop: false,
                    href: (el)=>el.getCanvasPathname() + '/publish',
                    margin: '0',
                    color: 'white',
                    text: 'Publish'
                },
                Button_reset: {
                    onClick: async (ev, el)=>{
                        ev.preventDefault();
                        await el.call('openModal', '/reset');
                    },
                    margin: '- - - B1',
                    fontWeight: '400',
                    scrollToTop: false,
                    background: 'transparent',
                    theme: 'common-card-outline-interactive',
                    text: 'Reset'
                }
            }
        },
        version: {
            text: (el)=>`Version 1.${el.getRootState().version}`
        }
    }
};

});

parcelRegister("frXBE", function(module, exports) {

$parcel$export(module.exports, "ResetPasswordsForm", () => $b3f79d2dd6eecaa6$export$6d623bb7624668db);
const $b3f79d2dd6eecaa6$export$6d623bb7624668db = {
    flow: 'column',
    gap: 'B1',
    flex: '1',
    childExtends: {
        extends: 'InputField',
        width: '100%',
        maxWidth: 'G+B',
        Title: {},
        Input: {
            width: '100%'
        }
    },
    Password: {
        Title: {
            text: 'Type in new password'
        },
        Input: {
            type: 'password',
            autocomplete: 'password',
            placeholder: 'Password',
            value: '{{ password }}',
            height: 'B2',
            '@mobileL': {
                height: 'unset'
            },
            onInput: (ev, el, s)=>{
                s.update({
                    passwordTouched: true,
                    password: el.node.value
                });
            }
        },
        Label_1: {
            show: (el, st)=>st.passwordTouched === true && !st.password,
            color: 'red',
            text: 'Password field is required'
        }
    },
    RepeatPassword: {
        Title: {
            text: 'Repeat new password'
        },
        Input: {
            type: 'password',
            height: 'B2',
            '@mobileL': {
                height: 'unset'
            },
            autocomplete: 'password',
            placeholder: 'Password',
            value: '{{ repeatPassword }}',
            onInput: (ev, el, s)=>{
                s.update({
                    repeatPasswordTouched: true,
                    repeatPassword: el.node.value
                });
            }
        },
        Label_2: {
            show: (el, st)=>st.repeatPasswordTouched === true && !st.repeatPassword,
            color: 'red',
            text: 'Repeat password field is required'
        },
        Label_3: {
            show: (el, st)=>st.passwordTouched === true && st.repeatPasswordTouched === true && st.password !== st.repeatPassword,
            color: 'red',
            text: 'Passwords do not match'
        }
    },
    ModalFooter: {
        display: 'flex',
        flow: 'row',
        width: '100%',
        maxWidth: 'unset',
        align: 'center space-between',
        gap: 'Z',
        '@mobileL': {
            flow: 'column',
            gap: 'A2',
            childProps: {
                width: '100%'
            }
        },
        CheckButton: {
            theme: 'primary',
            text: 'Confirm',
            type: 'submit',
            Icon: null,
            width: 'fit-content',
            height: 'B2',
            padding: 'Z1 B1',
            '@mobileL': {
                width: '100%',
                maxWidth: '100%',
                height: 'unset'
            }
        },
        Title: null,
        Input: null
    }
};

});

parcelRegister("6hqC5", function(module, exports) {

$parcel$export(module.exports, "ResetEmailForm", () => $4928f9750c3dae14$export$1c367202ee4dfef3);
const $4928f9750c3dae14$export$1c367202ee4dfef3 = {
    flow: 'y',
    if: (el, s)=>!s.token,
    flow: 'column',
    gap: 'A',
    flex: '1',
    height: '100%',
    '@mobileL': {
        align: 'center unset',
        height: 'unset'
    },
    childExtends: {
        extends: 'InputField',
        width: '100%',
        Title: {},
        Input: {
            width: '100%'
        }
    },
    Email: {
        Title: {
            text: 'Email'
        },
        Input: {
            height: 'B2',
            '@mobileL': {
                height: 'unset'
            },
            autocomplete: 'username',
            value: (el, s)=>s.email || '',
            placeholder: 'e.g. hello@symbo.ls',
            onInput: (ev, el, s)=>{
                s.update({
                    touched: true,
                    email: el.node.value
                });
            }
        },
        Label: {
            show: (el, st)=>st.touched === true && !st.email,
            color: 'red',
            text: 'Email field is required'
        }
    },
    ModalFooter: {
        ignoreChildExtends: true,
        display: 'flex',
        flow: 'row',
        width: '100%',
        maxWidth: 'unset',
        align: 'center space-between',
        gap: 'Z',
        padding: 'B1 0 0',
        '@mobileL': {
            flow: 'column',
            gap: 'A2',
            childProps: {
                width: '100%'
            }
        },
        CheckButton: {
            theme: 'primary',
            text: 'Reset password',
            type: 'submit',
            Icon: null,
            width: '100%',
            height: 'B2',
            padding: 'Z1 C1 Z1 B1',
            '@mobileL': {
                width: '100%',
                maxWidth: '100%',
                height: 'unset'
            }
        }
    }
};

});

parcelRegister("lgjzd", function(module, exports) {

$parcel$export(module.exports, "EmailConfirmationSuccess", () => $f7aa4533711ff23f$export$740e4872145c79e6);
const $f7aa4533711ff23f$export$740e4872145c79e6 = {
    extends: 'Flex',
    flow: 'y',
    align: 'center center',
    gap: 'B',
    Icon: {
        name: 'checkmark circle',
        color: 'green',
        size: 'A'
    },
    H3: {
        text: 'Email Confirmed!',
        margin: '0'
    },
    P: {
        text: 'Your email has been successfully confirmed. You can now sign in to your account.',
        textAlign: 'center',
        color: 'paragraph',
        maxWidth: 'G'
    },
    SigninButton: {
        extends: [
            'Button',
            'ClickableItem'
        ],
        text: 'Go to Sign In',
        margin: 'B 0 0',
        width: '100%',
        onClick: (_, el)=>{
            el.router('/signin', el.getRoot());
        }
    }
};

});

parcelRegister("2PA50", function(module, exports) {

$parcel$export(module.exports, "UsersTableCopy", () => $20fc54de645e1649$export$bbbb5ab329022dcf);
const $20fc54de645e1649$export$bbbb5ab329022dcf = {
    H6: {
        text: 'Team Members',
        margin: '- - A'
    },
    Flex: {
        flow: 'y',
        childExtends: 'Grid',
        childProps: {
            align: 'center center',
            columns: '2.2em 1fr 3fr 1fr',
            padding: 'Z1 0',
            gap: 'C1',
            Avatar: {
                boxSize: 'B',
                key: (el, s)=>s.name
            },
            Name: {
                margin: '- - - -C',
                Text: {
                    tag: 'span',
                    text: '{{ name }}'
                },
                Strong: {
                    hide: (el, s)=>!s.username,
                    text: ' ({{ username }})'
                }
            },
            Email: {
                text: '{{ email }}'
            },
            Role: {}
        },
        children: (el)=>el.getRootProjectsUsers(),
        childrenAs: 'state'
    }
};

});

parcelRegister("joj5B", function(module, exports) {

$parcel$export(module.exports, "EmailConfirmationError", () => $e1df10f60a9d6f00$export$3ea6b5c03372ccee);
const $e1df10f60a9d6f00$export$3ea6b5c03372ccee = {
    extends: 'Flex',
    flow: 'y',
    align: 'center center',
    gap: 'B',
    Icon: {
        name: 'exclMark',
        size: 'A',
        color: 'red'
    },
    H3: {
        text: 'Confirmation Failed',
        margin: '0'
    },
    P: {
        text: (el, s)=>s.error || 'Unable to confirm your email. Please try again or contact support.',
        textAlign: 'center',
        color: 'paragraph',
        maxWidth: 'G'
    },
    TryAgainButton: {
        extends: [
            'Button',
            'ClickableItem'
        ],
        text: 'Try Again',
        margin: 'B 0 0',
        width: '100%',
        onClick: async (_, el, s)=>{
            s.update({
                loading: true
            });
            await el.call('confirmEmail');
        }
    }
};

});

parcelRegister("6QS0R", function(module, exports) {

$parcel$export(module.exports, "TutorialsPanel", () => $4fd17f40cee53b0e$export$2a1dc0901352403f);
const $4fd17f40cee53b0e$export$2a1dc0901352403f = {
    CaptionTitle: {
        Text: {
            text: 'Docs and articles'
        }
    },
    DocsSidebar: {
        top: 'auto',
        padding: '0',
        fontSize: 'Z2',
        gap: 'A2',
        childProps: {
            position: 'relative',
            padding: '- 0',
            NumbCaption: {
                Numb: null,
                SquareButton: {
                    padding: 'X'
                }
            }
        }
    },
    flow: 'y',
    gap: 'A'
};

});

parcelRegister("ffGda", function(module, exports) {

$parcel$export(module.exports, "GovernanceFields", () => $b1a90006e49d546e$export$7dca2081066c7a55);
const $b1a90006e49d546e$export$7dca2081066c7a55 = {
    if: (el)=>el.getRootState('email').endsWith('@symbols.app'),
    flow: 'x',
    gap: 'C',
    childProps: {
        gap: 'Y',
        Icon: {
            color: 'placeholder'
        }
    },
    margin: '- B2 - auto',
    childExtends: [
        'IconText',
        'DropdownParentFocus'
    ],
    Env: {
        icon: 'fuse',
        Icon_arrow: {
            color: 'dim',
            name: 'arrow angle down'
        },
        Dropdown: {
            hide: (el)=>!el.getAppKey(),
            top: 'B',
            left: '0',
            align: 'start',
            ListInDropdown: {
                childExtends: [
                    'Link'
                ],
                onClick: (ev)=>ev.stopPropagation(),
                childProps: {
                    textAlign: 'start',
                    padding: 'Z1 A',
                    color: 'inactive',
                    round: 'C1',
                    theme: null,
                    fontWeight: '400',
                    align: 'center start',
                    Icon: {
                        order: 2,
                        margin: '- - - auto'
                    },
                    ':hover': {
                        theme: 'field'
                    },
                    '.isActive': {
                        theme: 'field'
                    }
                },
                childrenAs: 'props',
                children: ()=>[
                        {
                            href: `https://dev.symbols.app${window.location.pathname}`,
                            target: '_blank',
                            text: 'Development'
                        },
                        {
                            href: `https://staging.symbols.app${window.location.pathname}`,
                            target: '_blank',
                            text: 'Staging'
                        },
                        {
                            href: `https://symbols.app${window.location.pathname}`,
                            target: '_blank',
                            text: 'Production'
                        }
                    ]
            }
        },
        text: (el)=>el.getRootState('evn')
    },
    PlatformVersion: {
        icon: 'state',
        text: 'v',
        onRender: async (el)=>{
            el.update({
                text: `v${await el.getPlatformVersion()}`
            });
        },
        Icon_arrow: {
            color: 'dim',
            name: 'arrow angle down'
        },
        Dropdown: {
            hide: (el)=>!el.getAppKey(),
            top: 'B',
            left: '0',
            align: 'start',
            ListInDropdown: {
                childExtends: [
                    'Link'
                ],
                onClick: (ev)=>ev.stopPropagation(),
                childProps: {
                    textAlign: 'start',
                    padding: 'Z1 A',
                    color: 'inactive',
                    round: 'C1',
                    theme: null,
                    fontWeight: '400',
                    align: 'center start',
                    Icon: {
                        order: 2,
                        margin: '- - - auto'
                    },
                    ':hover': {
                        theme: 'field'
                    },
                    '.isActive': {
                        theme: 'field'
                    }
                },
                childrenAs: 'props',
                children: ()=>[
                        {
                            href: (el)=>'https://github.com/symbo-ls/platform/commits/' + `v${el.getPlatformVersion()}`,
                            target: '_blank',
                            text: 'Commit'
                        },
                        {
                            href: (el)=>({
                                    production: `https://github.com/symbo-ls/platform/actions?query=branch%3Av${el.getPlatformVersion()}+event%3Aworkflow_dispatch`,
                                    staging: `https://github.com/symbo-ls/platform/actions?query=branch%3Av${el.getPlatformVersion()}+event%3Arelease`,
                                    development: `https://github.com/symbo-ls/platform/actions`
                                })[el.getRootState('env')],
                            target: '_blank',
                            text: 'Github workflow'
                        },
                        {
                            href: (el)=>'https://github.com/symbo-ls/platform/tree/refs/tags/' + `v${el.getPlatformVersion()}`,
                            target: '_blank',
                            text: 'Code'
                        },
                        {
                            target: '_blank',
                            text: 'Release notes',
                            href: (el)=>'https://github.com/symbo-ls/platform/releases' + `?after=v${el.getPlatformVersion()}`
                        }
                    ]
            }
        }
    }
};

});

parcelRegister("fRzoq", function(module, exports) {

$parcel$export(module.exports, "EditorTools", () => $b8c74292b4bd4bd3$export$3489fe258094d6f6);
const $b8c74292b4bd4bd3$export$3489fe258094d6f6 = {
    TextNavbarButtonDropdown: {
        ignoreChildProps: true,
        ignoreChildExtends: true,
        ignoreChildExtends: true,
        isActive: null,
        margin: '- U - -',
        Button: {
            icon: (el)=>{
                const preffered = el.scope?.preferredEditor;
                const map = {
                    editor: 'sf pencil',
                    code: 'code',
                    sidebar: 'sidebarLeft'
                };
                return map[preffered] || map['editor'];
            },
            text: null,
            lineHeight: 0.9,
            align: 'end',
            onClick: (ev, el)=>{
                const preferredEditor = el.scope.preferredEditor;
                if (!preferredEditor || preferredEditor === 'editor') {
                    const editorActive = el.scope.editorActive;
                    el.setCanvasScope({
                        editorActive: !editorActive
                    });
                    return;
                }
                if (preferredEditor === 'code') {
                    if (el.getWindow('componentEditor') === 'code') el.closeWindow('componentEditor');
                    else el.setWindow('componentEditor', 'code');
                }
            }
        },
        IconButton: {
            DropdownParentFocus: {
                Dropdown: {
                    EditInNavbarMenu: {
                        fontSize: 'A2'
                    }
                }
            }
        }
    },
    ShareBtn: {
        hide: true,
        icon: 'share outline',
        title: 'Share',
        isActive: (el)=>el.getWindow('componentEditor') === 'share',
        onClick: (ev, el)=>{
            if (el.getWindow('componentEditor') === 'share') el.closeWindow('componentEditor');
            else el.setWindow('componentEditor', 'share');
            el.parent.update();
        }
    },
    extends: 'NavbarButtonSet',
    gap: 'W',
    childProps: {
        '.isDisabled': {
            opacity: '.35',
            pointerEvents: 'none'
        }
    }
};

});

parcelRegister("4eZAR", function(module, exports) {

$parcel$export(module.exports, "ChooseCanvas", () => $31683f6fd5966a80$export$9771f47b4c9d5e03);
const $31683f6fd5966a80$export$9771f47b4c9d5e03 = {
    CaptionTitle: {
        extends: [
            'Flex',
            'CaptionTitle'
        ],
        align: 'center',
        padding: 'X - - A',
        Text: {
            text: 'Select Canvas',
            margin: '- C - -'
        },
        IconButton: {
            onClick: (ev, el)=>el.call('openModal', '/add-canvas'),
            theme: 'tertiary',
            icon: 'plus',
            margin: '- - - auto'
        },
        'IconButton.question': {
            theme: 'tertiary',
            icon: 'sf question',
            onClick: (ev, el)=>el.setWindow('docs', '/canvas-pages')
        }
    },
    Flex: {
        flow: 'y',
        gap: 'W2',
        margin: 'X2 - -',
        childProps: (el, s)=>({
                align: 'center',
                gap: 'Y',
                round: 'C1',
                padding: 'Z A',
                isActive: s.value === el.call('getActiveCanvasPage'),
                theme: s.value === el.call('getActiveCanvasPage') ? 'field' : 'transparent',
                ':hover': {
                    theme: 'field'
                },
                '!isActive': {
                    color: 'inactive',
                    fontWeight: '400'
                },
                '.isActive': {
                    theme: 'field',
                    fontWeight: '500',
                    color: 'title'
                },
                Icon: {
                    hide: (el, s)=>!s._id,
                    order: -1,
                    name: 'url',
                    color: 'blue.35'
                },
                Text: {
                    text: '{{ value }}'
                },
                SharedLibSuffix: {
                    hide: (el, s)=>!s._id,
                    margin: '- - - -X2',
                    opacity: '.35',
                    text: '.symbo.ls'
                },
                Icon_arrow: {
                    hide: (el, s)=>!s._id,
                    margin: '- - - auto',
                    name: 'arrowUpRight',
                    color: 'disabled'
                },
                onClick: async (ev, el, s)=>{
                    if (s._id) return window.open(`${location.origin}/nikoloza/${s.value}`);
                    if (el.getWindow('explorerMinimized')) el.expandWindow('explorer');
                    else if (s.value === 'Add new') await el.call('openModal', '/add-canvas');
                    else await el.call('openCanvasPage', s.value);
                }
            }),
        childExtends: {
            onContextmenu: (ev, el)=>{
                const data = el.scope;
                if (!data) return;
                window.requestAnimationFrame(()=>{
                    el.activateContext(ev, el);
                });
            }
        },
        childrenAs: 'state',
        children: async (el, s)=>{
            const { canvas: canvas } = el.getRootState();
            return el.call('joinArrays', [
                {
                    title: 'Default'
                },
                ...Object.values(canvas.pages || {})
            ], s.sharedLibs || []).map((v)=>({
                    value: v.title,
                    ...v
                }));
        },
        onRender: (el, s)=>{
            if (el.isEmbed()) return;
            window.requestAnimationFrame(async ()=>{
            // const mySharedLibs = await el.call('getMySharedLibraries')
            // const sharedLibs = mySharedLibs.map(lib => ({
            //   title: lib.key.split('.symbo.ls')[0],
            //   _id: lib.id,
            //   key: lib.key,
            //   name: lib.name,
            //   ...lib
            // }))
            // s.replace({
            //   sharedLibs
            // })
            });
        }
    }
};

});

parcelRegister("eFhjb", function(module, exports) {

$parcel$export(module.exports, "EditNavbar", () => $aad25219441e6b73$export$a260e8a59d12e5e);
const $aad25219441e6b73$export$a260e8a59d12e5e = {
    NavbarButtonSet_title: {
        padding: '0',
        Text: {
            ignoreChildExtends: true,
            text: '{{ key }}'
        },
        CopyButton: {
            title: 'Copy title',
            value: (el, s)=>s.key
        }
    },
    EditorTools: {
        hide: true,
        margin: '- auto - C3',
        color: 'dim',
        fontSize: 'Z1'
    },
    EditorPositionNavbar: {
        margin: '- - - auto'
    },
    NavbarButtonSet_meta: {
        Que: {
            title: 'Documentation',
            icon: 'questionMark',
            isActive: false,
            onClick: (ev, el)=>{
                el.setWindow('docs', '/properties');
            }
        },
        Close: {
            title: 'Close',
            icon: 'crossmark',
            isActive: false,
            margin: '- - - X',
            onClick: (ev, el)=>{
                el.closeWindow('componentEditor');
            }
        }
    },
    extends: 'Navbar',
    position: 'sticky',
    top: '0',
    width: '100%',
    padding: 'W X W Z2',
    fontSize: '1rem'
};

});

parcelRegister("grGZQ", function(module, exports) {

$parcel$export(module.exports, "FilesSidebarSection", () => $bf908526c9b25a03$export$656c39b7eabb5ebb);
const $bf908526c9b25a03$export$656c39b7eabb5ebb = {
    FilesSectionTitle: null,
    FilesSidebarTitle: {},
    FileSidebarAddNewItem: {
        Label: {
            hasItems: (el, s)=>el.call('hasItems', s.type)
        },
        show: (el, s)=>{
            const isVisible = el.call('getCookie', `sidebar_${s.type}`) !== 'false';
            if (!isVisible) return false;
            if (s.adding) return true;
            const hasSchema = el.getSchema(s.type);
            const fileSidebarContent = el.lookup('Overflow')?.state?.fileSidebarContent;
            const isLocalLib = !fileSidebarContent || fileSidebarContent === 'Local';
            return Boolean(isLocalLib && hasSchema && Object.keys(hasSchema).length === 0 && el.isEditMode());
        },
        ignoreChildExtends: true
    },
    FilesSectionList: null,
    FilesSidebarList: {
        hide: (el, s)=>{
            const isVisible = el.call('getCookie', `sidebar_${s.type}`) !== 'false';
            return !isVisible;
        }
    },
    extends: 'FilesSection',
    hide: (el, s)=>s.noResults === true,
    onDblclick: (ev, el, s)=>{
        el.call('setCookie', `sidebar_${s.type}`, !s.isHidden);
        s.update();
    }
};

});

parcelRegister("lGpzv", function(module, exports) {

$parcel$export(module.exports, "FilesSidebarTitle", () => $fc915b34bc68030f$export$1243751800bf9a6d);
const $fc915b34bc68030f$export$1243751800bf9a6d = {
    IconButton_arrow: {},
    Span: {},
    'NavbarButton.add': {
        if: (el)=>el.sdk.hasPermission('editMode'),
        transition: 'A defaultBezier opacity',
        color: 'disabled',
        title: 'Add new',
        icon: 'plus',
        fontSize: 'Z2',
        allowedAddNewDropdown: [
            'components',
            'pages',
            'functions',
            'methods',
            'snippets',
            'typography',
            'state'
        ],
        allowedAddNewPanel: [
            'semantic_color',
            'color',
            'theme',
            'media',
            'icons',
            'media',
            'spacing'
        ],
        allowedAddModal: [
            'font',
            'font_family',
            'templates',
            'cases',
            'dependencies',
            'files'
        ],
        hide: (el, s)=>{
            const activeFileSidebar = el.call('getActiveDynamicIslandCategory');
            return !el.sdk.hasPermission('editMode') || activeFileSidebar !== 'Local' || !el.allowedAddNewDropdown.includes(s.type) && !el.allowedAddNewPanel.includes(s.type) && !el.allowedAddModal.includes(s.type);
        },
        margin: '- - - auto',
        onClick: async (ev, el, s)=>{
            ev.stopPropagation();
            ev.preventDefault();
            el.call('setCookie', `sidebar_${s.type}`, true);
            if (el.allowedAddNewDropdown.includes(s.type)) {
                s.toggle('adding');
                return setTimeout(()=>el.lookup('FilesSidebarList').parent.lookdown('FileSidebarAddNewItem').Label.Input.node.focus(), 100);
            }
            if (el.allowedAddNewPanel.includes(s.type)) return el.call('setFloatingPanel', {
                type: el.call('getSingular', s.type),
                key: '',
                value: null
            });
            await el.call('openModal', `/add-${el.getSingular(s.type.replace(/_/gu, '-'))}`);
        }
    },
    'NavbarButton.sort': {
        transition: 'A defaultBezier opacity',
        color: 'disabled',
        title: 'Sort A/Z',
        icon: (el, s)=>{
            const value = el.call('getCookie', `sidebar_${s.type}_sort`) === 'true';
            return value ? 'textLineHeight' : 'language';
        },
        fontSize: 'Z2',
        hide: (el, s)=>{
            return ![
                'components',
                'pages',
                'files',
                'state',
                'functions',
                'methods'
            ].includes(s.type);
        },
        onClick: async (ev, el, s)=>{
            ev.stopPropagation();
            ev.preventDefault();
            const value = el.call('getCookie', `sidebar_${s.type}_sort`) === 'true';
            el.call('setCookie', `sidebar_${s.type}_sort`, !value);
            s.update();
        }
    },
    'NavbarButton.question': {},
    extends: [
        'FilesSectionTitle'
    ]
};

});

parcelRegister("1Wvl9", function(module, exports) {

$parcel$export(module.exports, "FileSidebarSearch", () => $16a384b5dc351cb9$export$77e94eb672d063ca);
const $16a384b5dc351cb9$export$77e94eb672d063ca = {
    extends: 'CanvasSearch',
    position: 'relative',
    zIndex: 'none',
    theme: 'field',
    round: 'C1',
    Form: {
        Icon: {
            top: 'Z1',
            name: 'search outline',
            position: 'absolute',
            left: 'Z2'
        },
        Input: {
            theme: 'field',
            round: 'C1',
            padding: 'Z B2 Z B2+X2',
            placeholder: 'Filter'
        }
    },
    NavbarButton: {
        opacity: '0',
        position: 'absolute',
        top: 'X',
        right: 'X',
        theme: 'transparent',
        color: 'dim',
        icon: 'crossmark',
        fontSize: 'Z2',
        onClick: (ev, el)=>{
            const { node: node } = el.parent.Form.Input;
            if (node.value) {
                el.lookup('FilesSidebar').state.update({
                    search: ''
                });
                node.value = '';
                setTimeout(()=>{
                    node.focus();
                }, 100);
            }
        }
    }
};

});

parcelRegister("bWmjE", function(module, exports) {

$parcel$export(module.exports, "FilesSidebarList", () => $8b166bf77ea59396$export$80a850316348ac68);
const $8b166bf77ea59396$export$80a850316348ac68 = {
    extends: 'FilesSectionList',
    childExtends: 'FilesSidebarListItem',
    children: async (el, s)=>{
        const FilesSidebar = el.getFilesSidebar();
        const sorted = el.call('getCookie', `sidebar_${s.type}_sort`) === 'true';
        const list = await el.call('listSidebar', s.type, {
            search: FilesSidebar?.state?.search,
            activeFileSidebar: FilesSidebar?.state?.activeFileSidebar,
            sortIf: sorted && [
                'components',
                'pages',
                'files',
                'state',
                'functions',
                'methods'
            ].includes(s.type),
            sort: (a, b)=>{
                return a.key?.toLowerCase() < b.key?.toLowerCase() ? -1 : 1;
            }
        });
        const showLayersSchema = el.scope.showLayersSchema;
        if (list.length > 0 && showLayersSchema !== undefined && el.call('hasArtbpard', s.type)) {
            Object.keys(showLayersSchema).forEach((key)=>{
                if (!list.find((item)=>item.key === key)) delete showLayersSchema[key];
            });
            el.syncCanvas({
                showLayersSchema: showLayersSchema
            });
        }
        return list;
    },
    onMouseleave: (ev, el)=>{
        if (!el.getUserSettings('allowFilesidebarPreview')) return;
        el.call('setScenePosition', null, {
            visible: false
        });
    },
    align: 'stretch',
    flow: 'column',
    fontSize: 'Z2',
    gap: 'X1'
};

});

parcelRegister("aoSJJ", function(module, exports) {

$parcel$export(module.exports, "FileSidebarAddNewItem", () => $79269ad73bb243fd$export$77fc6e2f9af9d2ef);
const $79269ad73bb243fd$export$77fc6e2f9af9d2ef = {
    if: (el)=>el.isEditMode(),
    Label: {
        flow: 'x',
        margin: '- X2 X2 0',
        fontSize: 'Z2',
        align: 'center center',
        hasItems: true,
        '.hasItems': {
            borderWidth: '0 0 1px',
            borderColor: 'line-highlight',
            borderStyle: 'solid',
            ':focus-within': {
                borderColor: 'dim'
            }
        },
        templateAreas: `"plus input icons"
        "error error error"`,
        templateColumns: '0.1fr 1fr 0.1fr',
        Icon: {
            gridArea: 'plus',
            color: 'dim',
            name: 'plus'
        },
        Input: {
            gridArea: 'input',
            padding: 'X2 -',
            width: '100%',
            round: '0',
            theme: 'transparent',
            outline: '0',
            name: 'sidebar-new-item',
            attr: {
                required: true,
                placeholder: (el, s)=>s.type === 'pages' ? '/add-new-page' : s.type === 'components' ? 'ComponentName' : s.type === 'functions' ? 'newFunction' : s.type === 'methods' ? 'newMethod' : s.type === 'state' ? 'state_collection' : s.type === 'secrets' ? 'new_secret' : s.type === 'dependencies' ? '@npm/dependency' : ''
            },
            '::placeholder': {
                color: 'dim'
            },
            ':focus-visible': {
                outline: '0'
            },
            ':focus': {
                outline: '0',
                borderColor: 'caption'
            },
            onInput: (ev, el, s)=>{
                // eslint-disable-next-line init-declarations
                let cleanedValue;
                const { node: node } = el;
                const { value: value } = node;
                let start = node.selectionStart;
                let end = node.selectionEnd;
                const isPage = s.type === 'pages';
                const isComponent = s.type === 'components';
                const isFunction = s.type === 'functions' || s.type === 'snippets' || s.type === 'methods';
                const isState = s.type === 'state';
                if (isPage) {
                    // Filter out invalid characters
                    const allowedCharacters = /[^a-zA-Z0-9/-]/gu;
                    cleanedValue = value.replace(allowedCharacters, '').toLowerCase();
                    if (!cleanedValue.startsWith('/')) {
                        cleanedValue = `/${cleanedValue}`;
                        start++;
                        end++;
                    }
                // Prevent typing invalid characters
                } else if (isComponent) {
                    // eslint-disable-next-line require-unicode-regexp
                    const allowedCharacters = /[^a-zA-Z0-9_.]/g;
                    cleanedValue = value.replace(allowedCharacters, '');
                    cleanedValue = cleanedValue.split(/[_.]/u).filter(Boolean).map((v)=>v.charAt(0).toUpperCase() + v.slice(1)).join('');
                } else if (isFunction || isState) {
                    // eslint-disable-next-line require-unicode-regexp
                    const allowedCharacters = /[^a-zA-Z0-9_]/g;
                    cleanedValue = value.replace(allowedCharacters, '');
                } else cleanedValue = value;
                if (value !== cleanedValue) {
                    el.node.value = cleanedValue;
                    node.setSelectionRange(start, end);
                }
                s.key = cleanedValue;
            }
        },
        Flex: {
            gap: 'X2',
            gridArea: 'icons',
            class: 'icons',
            opacity: 0,
            childExtends: 'IconButton',
            childProps: {
                padding: 'Y',
                fontSize: 'Z',
                theme: 'transparent',
                ':hover': {
                    theme: 'quaternary'
                }
            },
            Save: {
                type: 'submit',
                icon: 'checkmark'
            },
            Close: {
                icon: 'crossmark',
                onClick: (ev, el, s)=>{
                    s.update({
                        key: null,
                        adding: null
                    });
                }
            }
        },
        Err: {
            hide: (el, s)=>!s.err,
            gridArea: 'error',
            position: 'absolute',
            top: '101%',
            left: '0',
            right: '0',
            theme: 'navbar',
            text: (el, s)=>s.err
        },
        ':hover .icons, :focus-within .icons': {
            opacity: 1
        }
    },
    extends: [
        'Form',
        'Grid'
    ],
    onSubmit: async (ev, el, s)=>{
        ev.preventDefault();
        const { key: key } = s;
        const type = el.getSingular(s.type) || s.parent.type;
        if (el.getSchemaItem(key, type)) {
            el.call('openNotification', {
                title: `${type} already exists`,
                message: `"${key}" ${type} already exists`,
                type: 'error'
            });
            return;
        }
        try {
            await el.call('createItem', type, key);
            el.Label.Input.node.value = '';
        } catch (err) {
            if (!err) {
                el.node.reset();
                return s.update({
                    key: null,
                    err: null,
                    adding: false
                });
            }
            s.update({
                err: err
            });
        }
        s.update({
            key: null,
            adding: null
        });
    }
};

});

parcelRegister("gjDQP", function(module, exports) {

$parcel$export(module.exports, "TutorialsRow", () => $be0d554e8f20e720$export$9fdc988a22400602);
const $be0d554e8f20e720$export$9fdc988a22400602 = {
    extends: 'Group',
    background: 'highlight-reversed',
    padding: 'A1 B1',
    margin: '- -B1',
    round: 'A2',
    gap: 'A2',
    hide: (el, s)=>s.hideTutorials,
    ':hover .hide': {
        opacity: 1
    },
    Title: {
        flow: 'x',
        align: 'center space-between',
        text: 'Getting Started',
        IconText: {
            class: 'hide',
            opacity: '0',
            text: 'Hide',
            icon: 'eyeClosed',
            gap: 'Y1',
            transition: 'A defaultBezier opacity',
            cursor: 'pointer',
            ':hover': {
                textDecoration: 'underline'
            },
            onClick: (ev, el, s)=>{
                el.call('setCookie', 'hideTutorialsDashboard', 'true', 365);
                s.toggle('hideTutorials', {
                    preventUpdate: [
                        'ChooseProject'
                    ]
                });
            }
        }
    },
    Scrollable: {
        paddingInline: '0',
        margin: '- -B',
        padding: '- - - B',
        maxWidth: 'auto',
        width: 'auto',
        gap: 'C',
        ':before, &:after': {
            content: '""',
            widthRange: '1px'
        },
        childExtends: 'TutorialsRowItem',
        childrenAs: 'state',
        children: [
            {
                text: 'Getting started with basic landing page',
                youtubeId: 'jYU0soXY-To',
                duration: '14:31'
            },
            {
                text: 'Build using Symbols library',
                youtubeId: '1Vut-DOrfvg',
                duration: '1:50'
            },
            {
                text: 'What is Symbols',
                youtubeId: 'P_jjCTzS0-w',
                duration: '1:15'
            },
            {
                text: 'Navigating around Symbols',
                youtubeId: 'rugrjZ6WrDM',
                duration: '4:25'
            },
            {
                text: 'Building components',
                youtubeId: 'ScXOBnJ6ZIU',
                duration: '2:31'
            },
            {
                text: 'Building pages',
                youtubeId: '-qWxYRR15DM',
                duration: '0:56'
            },
            {
                text: 'Semi Advanced Tutorial Calculator',
                youtubeId: 'dPZCwGEysdI',
                duration: '5:23'
            },
            {
                text: 'Changing components and seeing code editor',
                youtubeId: 'W2sEhoLA0Dc',
                duration: '0:23'
            },
            {
                text: 'How to use files',
                youtubeId: 'P9D8A0258Ro',
                duration: '1:58'
            },
            {
                text: 'How to use color',
                youtubeId: 'i4JuUp39n50',
                duration: '2:02'
            },
            {
                text: 'How to use spacing',
                youtubeId: 'xFgl6jG2yrw',
                duration: '2:35'
            },
            {
                text: 'How to use icon',
                youtubeId: 'rPfSew0RGZc',
                duration: '2:19'
            }
        ]
    },
    Scrollbar: {
        extends: 'Scrollbar.scrollable'
    }
};

});

parcelRegister("2H44R", function(module, exports) {

$parcel$export(module.exports, "FilesSidebar", () => $1f62c2a1ebe193dd$export$e67c8cc2370e6f15);
const $1f62c2a1ebe193dd$export$e67c8cc2370e6f15 = {
    data: {},
    state: {
        activeFileSidebar: 'Local',
        activeContent: 'ARTBOARD_TYPES'
    },
    flow: 'y',
    minHeight: 'F1',
    height: 'max-content',
    onInit: (el, s, ctx, opts)=>{
        const activeContent = el.getWindow('explorer');
        if (!el.call('isString', activeContent)) return;
        if (activeContent.includes(':')) {
            s.activeContent = activeContent.split(':')[1];
            return;
        }
        const activeContentCookie = el.call('getCookie', el.getAppKey() + '_activeContent');
        if (activeContentCookie) s.activeContent = activeContentCookie;
    },
    ':hover': {
        '& header > a:first-child': {
            opacity: 1
        }
    },
    ExplorerSwitcher: {
        padding: 'V',
        margin: 'W2 -W1 A1'
    },
    Overflow: {
        flow: 'y',
        gap: 'B2',
        overflow: 'hidden auto',
        flex: 1,
        lazyLoad: true,
        round: 'A',
        '::-moz-scrollbar': {
            hide: true
        },
        '::-webkit-scrollbar': {
            hide: true
        },
        SectionsList: {
            flow: 'y',
            gap: 'A2',
            padding: '- Y1',
            childProps: {
                ':first-child .hr': {
                    hide: true
                }
            },
            childrenAs: 'element',
            children: (el, s)=>{
                const activeType = el.parent.activeType || el.getWindow('explorer');
                const activeContent = s.activeContent;
                if (!activeType) return [];
                const types = el.call('getActiveSidebarTypes', activeContent);
                return types.reduce((initial, type)=>{
                    if (// !s.search || //&&
                    // el.call('isString', activeType) &&
                    // activeType !== type) ||
                    !el.call('checkFeatureByPackage', type)) return initial;
                    switch(type){
                        case 'docs':
                            return [
                                ...initial,
                                {
                                    extends: 'FilesSidebarSection',
                                    state: {
                                        type: type
                                    },
                                    FilesSidebarTitle: {
                                        Span: {
                                            Text: {
                                                text: 'Learning centre'
                                            }
                                        }
                                    },
                                    // FilesSidebarList: null,
                                    FilesSidebarList: {
                                        FileSidebarAddNewItem: null,
                                        childExtends: 'FilesSidebarListItem',
                                        // childExtends: 'CaseTemplate',
                                        childProps: {
                                            isActive: false,
                                            isCurrent: false,
                                            onClick: (ev, el, s)=>{
                                                console.log('open docs');
                                            }
                                        },
                                        childrenAs: 'props'
                                    }
                                }
                            ];
                        case 'color':
                            return [
                                ...initial,
                                {
                                    extends: 'FilesSidebarSection',
                                    state: {
                                        type: type
                                    },
                                    FilesSidebarTitle: {},
                                    FilesSidebarList: {
                                        childExtends: [
                                            'ColorTemplateRow',
                                            'FilesSidebarListItem'
                                        ]
                                    }
                                }
                            ];
                        case 'gradient':
                            return [
                                ...initial,
                                {
                                    extends: 'FilesSidebarSection',
                                    state: {
                                        type: type
                                    },
                                    FilesSidebarTitle: {},
                                    FilesSidebarList: {
                                        childExtends: [
                                            'ColorTemplateRow',
                                            'FilesSidebarListItem'
                                        ]
                                    }
                                }
                            ];
                        case 'semantic_color':
                            return [
                                ...initial,
                                {
                                    extends: 'FilesSidebarSection',
                                    state: {
                                        type: type
                                    },
                                    FilesSidebarTitle: {},
                                    FilesSidebarList: {
                                        childExtends: [
                                            'SemanticColorTemplateRow',
                                            'FilesSidebarListItem'
                                        ]
                                    }
                                }
                            ];
                        case 'global_theme':
                            return [
                                ...initial,
                                {
                                    extends: 'FilesSidebarSection',
                                    state: {
                                        type: type
                                    },
                                    FilesSidebarTitle: {},
                                    FilesSidebarList: {
                                        childExtends: [
                                            'GlobalThemeTemplateRow',
                                            'FilesSidebarListItem'
                                        ]
                                    }
                                }
                            ];
                        case 'theme':
                            return [
                                ...initial,
                                {
                                    extends: 'FilesSidebarSection',
                                    state: {
                                        type: type
                                    },
                                    FilesSidebarTitle: {
                                        Span: {
                                            Text: {
                                                text: 'themes'
                                            }
                                        }
                                    },
                                    FilesSidebarList: {
                                        columns: 'repeat(3, 1fr)',
                                        childProps: {
                                            minWidth: 'none',
                                            round: 'C1'
                                        },
                                        childExtends: {
                                            extends: [
                                                'ThemeTemplateRow',
                                                'FilesSidebarListItem'
                                            ]
                                        }
                                    }
                                }
                            ];
                        case 'typography':
                            return [
                                ...initial,
                                {
                                    extends: 'FilesSidebarSection',
                                    state: {
                                        type: type
                                    },
                                    FilesSidebarTitle: {},
                                    FileSidebarAddNewItem: {
                                        border: 'none!important',
                                        onSubmit: (ev, submitEl)=>{
                                            ev.preventDefault();
                                            submitEl.call('createTypography');
                                            submitEl.Label.Input.node.value = '';
                                            return s.update({
                                                key: null,
                                                err: null,
                                                adding: false
                                            });
                                        },
                                        Label: {
                                            Icon: {},
                                            Input: {
                                                onInput: null
                                            }
                                        }
                                    },
                                    FilesSidebarList: {
                                        gap: 'Z1',
                                        childExtends: [
                                            'TypographyTemplate',
                                            'FilesSidebarListItem'
                                        ]
                                    }
                                }
                            ];
                        case 'font':
                            return [
                                ...initial,
                                {
                                    extends: 'FilesSidebarSection',
                                    state: {
                                        type: type
                                    },
                                    FilesSidebarTitle: {},
                                    FilesSidebarList: {
                                        childExtends: [
                                            'FontItemRow',
                                            'FilesSidebarListItem'
                                        ],
                                        childProps: {
                                            onClick: async (ev, el, s)=>{
                                                ev.preventDefault();
                                                if (el.lookup('Overflow')?.state.activeFileSidebar === 'Local') await el.call('openModal', '/edit-font', {
                                                    key: s.key
                                                });
                                            }
                                        }
                                    }
                                }
                            ];
                        case 'font_family':
                            return [
                                ...initial,
                                {
                                    extends: 'FilesSidebarSection',
                                    state: {
                                        type: type
                                    },
                                    FilesSidebarTitle: {
                                        Span: {
                                            text: 'Font Families',
                                            Text: null
                                        }
                                    },
                                    FilesSidebarList: {
                                        childExtends: [
                                            'FontFamilyObject',
                                            'FilesSidebarListItem'
                                        ]
                                    }
                                }
                            ];
                        case 'type_templates':
                            return [
                                ...initial,
                                {
                                    extends: 'FilesSidebarSection',
                                    state: {
                                        type: type
                                    },
                                    FilesSidebarTitle: {
                                        Span: {
                                            text: 'Text Styles',
                                            Text: null
                                        }
                                    },
                                    FilesSidebarList: {
                                        childExtends: [
                                            'TextStylesTemplate',
                                            'FilesSidebarListItem'
                                        ]
                                    }
                                }
                            ];
                        case 'spacing':
                            return [
                                ...initial,
                                {
                                    extends: 'FilesSidebarSection',
                                    gap: '0',
                                    state: {
                                        type: 'spacing'
                                    },
                                    FilesSidebarTitle: {},
                                    FileSidebarAddNewItem: {
                                        border: 'none!important',
                                        onSubmit: (ev, submitEl)=>{
                                            ev.preventDefault();
                                            submitEl.call('createSpacing');
                                            return s.update({
                                                key: null,
                                                err: null,
                                                adding: false
                                            });
                                        }
                                    },
                                    FilesSidebarList: {
                                        // display: 'flex',
                                        // flexDirection: 'column',
                                        gap: '0',
                                        // margin: '-',
                                        Default: {
                                            state: el.filterKeys(el.getDesignSystem('spacing'))
                                        },
                                        childExtends: [
                                            'SpacingTemplateRow',
                                            'FilesSidebarListItem'
                                        ]
                                    }
                                }
                            ];
                        case 'icons':
                            return [
                                ...initial,
                                {
                                    extends: 'FilesSidebarSection',
                                    state: {
                                        type: type
                                    },
                                    FilesSidebarTitle: {},
                                    // FilesSidebarList: null,
                                    FilesSidebarList: {
                                        // columns: 'repeat(7, 1fr)',
                                        // gap: 'W',
                                        // margin: '- -Y',
                                        // style: {
                                        //   svg: {
                                        //     // width: '100%',
                                        //     // height: '100%',
                                        //     display: 'inline-block'
                                        //     // fill: 'currentColor',
                                        //     // '*': {
                                        //     //   fill: 'currentColor'
                                        //     // }
                                        //   }
                                        // },
                                        FileSidebarAddNewItem: null,
                                        childExtends: 'IconTemplateRow'
                                    }
                                }
                            ];
                        case 'shape':
                            return [
                                ...initial,
                                {
                                    extends: 'FilesSidebarSection',
                                    state: {
                                        type: type
                                    },
                                    FilesSidebarTitle: {},
                                    FilesSidebarList: null,
                                    FilesSidebarGrid: {
                                    }
                                }
                            ];
                        case 'cases':
                            return [
                                ...initial,
                                {
                                    extends: 'FilesSidebarSection',
                                    state: {
                                        type: type
                                    },
                                    FilesSidebarTitle: {},
                                    // FilesSidebarList: null,
                                    FilesSidebarList: {
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: 'A',
                                        FileSidebarAddNewItem: null,
                                        childExtends: [
                                            'CaseTemplateRow',
                                            'FilesSidebarListItem'
                                        ]
                                    }
                                }
                            ];
                        case 'media':
                            return [
                                ...initial,
                                {
                                    extends: 'FilesSidebarSection',
                                    state: {
                                        type: type
                                    },
                                    FilesSidebarTitle: {},
                                    FilesSidebarList: {
                                        childExtends: [
                                            'MediaTemplateRow',
                                            'FilesSidebarListItem'
                                        ]
                                    }
                                }
                            ];
                        case 'files':
                            return [
                                ...initial,
                                {
                                    extends: 'FilesSidebarSection',
                                    state: {
                                        type: type
                                    },
                                    FilesSidebarTitle: {},
                                    FileSidebarAddNewItem: null,
                                    FilesSidebarList: {
                                        childProps: {
                                            flow: 'row'
                                        }
                                    }
                                }
                            ];
                        default:
                            return [
                                ...initial,
                                {
                                    extends: 'FilesSidebarSection',
                                    state: {
                                        type: type
                                    }
                                }
                            ];
                    }
                }, []);
            },
            onBeforeUpdate: (_, el, s, ctx, opts)=>Boolean(el.getWindow('explorer')) && !opts.layerClick
        }
    }
};

});

parcelRegister("88CLS", function(module, exports) {

$parcel$export(module.exports, "FilesSidebarListItem", () => $5ecd2540f5bc7daf$export$15a8054233279549);
const $5ecd2540f5bc7daf$export$15a8054233279549 = {
    Span: {},
    Text: {},
    EditCode: {},
    ContextMenu: {
        extends: 'NavbarButton',
        if: (el)=>el.sdk.hasPermission('editMode'),
        hide: (el, s)=>s.editing || !el.call('hasArtboard', s.type),
        class: 'layer-controls',
        icon: 'threeDots',
        padding: 'Y',
        margin: '-W',
        onClick: (ev, el)=>{
            ev.preventDefault();
            ev.stopPropagation();
            el.activateContext(ev);
        }
    },
    Rename: {
        extends: 'FileSidebarAddNewItem',
        show: (el, s)=>Boolean(s.editing),
        flex: 1,
        Label: {
            margin: '0 0 0 -1.4em',
            padding: '0 0 0 1.4em',
            Icon: null,
            Input: {
                flex: 1,
                value: (el, s)=>s.key,
                name: 'new-key',
                onInput: ()=>{}
            },
            Flex: {
                Save: {
                    type: 'submit'
                },
                Close: {
                    onClick: (ev, el, s)=>{
                        ev.preventDefault();
                        ev.stopPropagation();
                        s.update({
                            editing: false
                        });
                    }
                }
            },
            Err: {
                whiteSpace: 'pre-line',
                padding: 'X Y',
                theme: 'modal',
                round: 'X',
                fontSize: 'Y2',
                position: 'static'
            }
        },
        onSubmit: async (ev, el, s)=>{
            ev.preventDefault();
            const capitalizeType = el.call('capitalize', s.type);
            await el.call(`rename${capitalizeType}`, 'new-key', async (newKey)=>{
                // el.call('removeItemFromSidebar', s.type, s.key)
                // el.getCanvasCollection().update()
                el.node.reset();
                s.update({
                    editing: false,
                    key: newKey
                });
            });
        }
    },
    extends: 'FileItem',
    onBeforeUpdate: (_, el, s)=>{
        if (el.call('getCookie', `sidebar_${s.type}`) === 'false') return false;
        if (s.editing) return;
        const { node: node } = el;
        const scroll = el.getUserSettings('explorerAutoscroll') && s.key && s.key === el.getSelectedKey();
        if (!scroll) return;
        if (el.getRootData().sidebarClick) {
            el.getRootData().sidebarClick = false;
            return;
        }
        const t = setTimeout(()=>{
            if (!node || !node.scrollIntoView) return;
            node.scrollIntoView({
                behavior: 'smooth',
                inline: 'center',
                block: 'center'
            });
            el.getRootData().sidebarClick = false;
            clearTimeout(t);
        }, 65);
    },
    onMouseenter: (ev, el, s)=>{
        if (!el.call('hasArtboard', s.type) || s.editing) return;
        ev.stopPropagation();
        const data = el.scope;
        if (data.inContext) return;
        const Collection = el.getCanvasCollection();
        const componentFound = Collection?.lookdown((el)=>el.state?.key === s.key);
        if (data.Collection && componentFound) el.activateHovered(componentFound);
        const allowOnChosen = el.getChosenKey() && el.getChosenKey() !== s.key;
        const allowSettings = el.getUserSettings('allowFilesidebarPreview');
        if (allowOnChosen && allowSettings) {
            const t = setTimeout(()=>{
                el.call('setScenePosition', s.key, {
                    visible: true
                });
                clearTimeout(t);
            }, 0);
        }
    },
    onMouseleave: (ev, el, s)=>{
        if (!el.call('hasArtboard', s.type) || s.editing) return;
        const data = el.scope;
        if (data.inContext) return;
        if (el.getHoveredKey() === s.key) el.activateHovered(null);
        ev.stopPropagation();
    },
    onClick: async (ev, el, s)=>{
        ev.stopPropagation();
        if (s.editing) return;
        if (el.data.dblclicking) {
            el.data.dblclicking = false;
            return;
        }
        const data = el.scope;
        el.getRootData().sidebarClick = true;
        if (s.type === 'dependencies') await el.call('openModal', '/edit-dependency', {
            key: s.key
        });
        else if (s.type === 'secrets') await el.call('openModal', '/edit-secret', {
            key: s.key
        });
        else if (s.type === 'files') await el.call('openModal', '/edit-file', {
            key: s.key
        });
        else if ([
            'functions',
            'snippets',
            'methods'
        ].includes(s.type)) await el.call('activateFunction', s.key);
        else if (s.type === 'state') await el.call('activateState', s.key);
        else {
            // el.activateSelected(data.hovered)
            if (data.activeFunction || data.activeState) el.openWindow('editorPanels');
            // if (el.getRootState('isCmdPressed') && data.chosen) el.activateChosen(data.hovered, el, s)
            const component = el.getHovered() || el;
            const { state: state } = component;
            if (!el.call('inOnCurrentCanvasPage', component?.state?.type || state?.type, component?.state?.key || state?.key)) el.call('openCanvasPage', el.call('findKeyInOtherCanvasPages', state?.key) || 'Default');
            const t = setTimeout(()=>{
                if (data.chosen || state?.key === el.getSelectedKey()) // el.activateChosen(component?.state?.key)
                el.state.update({
                    showLayers: !el.state.showLayers
                });
                else {
                    el.activateSelected(state?.key);
                    el.zoomToNode(data.selected);
                }
                clearTimeout(t);
            }, 15);
        }
    },
    onDblclick: (ev, el, s)=>{
        if (s.editing) return;
        el.data.dblclicking = true;
        ev.stopPropagation();
        const hovered = el.getHoveredKey();
        if (el.call('hasArtboard', s.type)) el.activateChosen(hovered, el, s);
        el.activateSelected(hovered, el, s);
        el.call('clearFollowing');
        // Open the nested structure recursively using shared function
        el.call('expandAllLayersForParentComponent', el, s);
    },
    onContextmenu: (ev, el, s)=>{
        if (s.editing) return;
        if (s.key !== el.getHoveredKey()) el.activateHovered(s.key);
        const t = setTimeout(()=>{
            el.activateContext(ev, el);
            clearTimeout(t);
        }, 0);
    },
    onInit: (el, s)=>{
        if ([
            'pages',
            'components'
        ].includes(s.type)) {
            const showLayersSchema = el.call('getShowLayersSchema');
            const path = el.call('getLayerPath') || [];
            path.push('showLayers');
            const showLayers = el.call('getInObjectByPath', showLayersSchema, path) || false;
            s.update({
                showLayers: showLayers
            }, {
                preventStateUpdateListener: true
            });
        }
    },
    onStateUpdate: (changes, el, s)=>{
        if (changes && Object.hasOwn(changes, 'showLayers')) {
            const path = el.call('getLayerPath');
            path.push('showLayers');
            el.call('saveLayersVisibilityState', path, changes.showLayers);
        }
    }
};

});

parcelRegister("lbhEm", function(module, exports) {

$parcel$export(module.exports, "TutorialsRowItem", () => $f6b850f3578cc017$export$5cf11d85a75cc0fb);
const $f6b850f3578cc017$export$5cf11d85a75cc0fb = {
    flow: 'x',
    state: {
        text: 'Getting started with basic landing page',
        youtubeId: 'jYU0soXY-To',
        duration: '14:31'
    },
    padding: '0',
    gap: 'Y1',
    flow: 'y',
    widthRange: 'F2',
    round: '0',
    overflow: 'visible',
    ':after': null,
    cursor: 'pointer',
    opacity: '0.8',
    transition: 'A defaultBezier all',
    ':hover': {
        opacity: '1',
        '& .playButton': {
            opacity: '1'
        }
    },
    onClick: (ev, el, s)=>{
        el.call('openModalVideo', `https://www.youtube.com/embed/${s.youtubeId}?controls=1&amp;autoplay=1`);
    },
    Img: null,
    Box: {
        position: 'relative',
        Img: {
            round: 'A',
            position: 'relative',
            width: '100%',
            src: 'https://img.youtube.com/vi/{{ youtubeId }}/hqdefault.jpg'
        },
        Circle: {
            flow: 'x',
            class: 'playButton',
            opacity: '0',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transition: 'A defaultBezier all',
            transform: 'translate(-50%, -50%)',
            padding: 'Z',
            round: 'C1',
            background: 'black.35',
            Icon: {
                fontSize: 'C',
                name: 'play'
            }
        }
    },
    H3: null,
    Span: {
        text: '{{ text }}',
        color: 'title'
    },
    Time: {
        margin: '-Z - -',
        text: '{{ duration }}',
        fontWeight: '200',
        color: 'placeholder',
        fontSize: 'Z1'
    }
};

});

parcelRegister("1LZgU", function(module, exports) {

$parcel$export(module.exports, "DashboardSidebar", () => $14a9b5809a304531$export$af924ad9495a7d0a);
const $14a9b5809a304531$export$af924ad9495a7d0a = {
    flow: 'y',
    gap: 'C1',
    IconText: {
        order: '-1',
        fontWeight: '600',
        text: 'Getting Started',
        icon: 'arrow angle down',
        gap: 'Y1',
        align: 'start',
        hide: (el, s)=>!s.hideTutorials,
        cursor: 'pointer',
        ':hover': {
            textDecoration: 'underline'
        },
        Icon: {
            order: 2
        },
        onClick: (ev, el, s)=>{
            el.call('setCookie', 'hideTutorialsDashboard', 'false', 365);
            s.toggle('hideTutorials', {
                preventUpdate: [
                    'ChooseProject'
                ]
            });
        }
    },
    Title: null,
    Filter: {
        flow: 'x',
        align: 'start',
        flow: 'y',
        gap: 'A',
        position: 'sticky',
        top: 'D1',
        childExtends: {
            extends: [
                'Button'
            ],
            theme: (el, s)=>s.projectsFilter === el.key ? 'secondary' : 'tertiary',
            padding: 'Z1 A2',
            // eslint-disable-next-line no-shadow,
            onClick: async (ev, el, s)=>{
                s.update({
                    projectsFilter: el.key
                });
                el.call('setCookie', 'projectsFilter', el.key);
                el.sdk.rootBus.emit('projects:filter', el.key);
            }
        },
        All: {
            text: 'All'
        },
        Favorites: {
            text: 'Favorites'
        },
        Recents: {
            text: 'Recents'
        },
        New: {
            extends: [
                'Button'
            ],
            ignoreChildExtends: true,
            theme: null,
            fontWeight: '600',
            text: 'New Project',
            isActive: false,
            margin: 'C1 - -',
            background: 'title',
            color: 'title-reversed',
            ':hover': null,
            onClick: async (ev, el, s)=>{
                await el.call('openModal', '/settings', {
                    key: '/onboarding'
                });
            }
        }
    }
};

});

parcelRegister("eJqVp", function(module, exports) {

$parcel$export(module.exports, "NavbarFrameworks", () => $ab9a275ec31c8df1$export$7f39fc876b08398e);
const $ab9a275ec31c8df1$export$7f39fc876b08398e = {
    extends: 'NavbarButtonSet',
    children: [
        {
            title: 'Symbols',
            key: 'symbols',
            icon: 'logo'
        },
        {
            title: 'DOMQL',
            key: 'domql',
            icon: 'domql'
        },
        {
            pointerEvents: 'none',
            opacity: '.25',
            title: 'React',
            key: 'react',
            icon: 'react'
        },
        {
            pointerEvents: 'none',
            opacity: '.25',
            title: 'jQuery',
            key: 'jquery',
            icon: 'jquery'
        }
    ],
    childProps: {
        isActive: (el)=>el.getRootState('framework') === el.key,
        click: (ev, el)=>{
            el.getRootState().update({
                framework: el.key
            });
            el.call('setCookie', 'framework', el.getRootState('framework'));
        }
    }
};

});

parcelRegister("3w4DM", function(module, exports) {

$parcel$export(module.exports, "NavbarProgrammingLanguages", () => $28f7f5c900ad29c3$export$3138e9164962dadb);
const $28f7f5c900ad29c3$export$3138e9164962dadb = {
    extends: 'NavbarButtonSet',
    children: [
        {
            title: 'JavaScript',
            key: 'js',
            icon: 'js'
        },
        {
            title: 'TypeScript',
            key: 'ts',
            icon: 'ts'
        },
        {
            title: 'HTML',
            key: 'html',
            icon: 'html'
        }
    ],
    childProps: {
        isActive: (el)=>el.getRootState('language') === el.key,
        onClick: (ev, el)=>{
            el.getRootState().update({
                language: el.key
            });
            el.call('setCookie', 'language', el.getRootState('language'));
        }
    }
};

});

parcelRegister("Lg9Kk", function(module, exports) {

$parcel$export(module.exports, "CanvasVerticalNavbarCopy", () => $08e0ec2f5964e336$export$6aa8107630d84be);
const $08e0ec2f5964e336$export$6aa8107630d84be = {
    extends: 'Navbar',
    position: 'absolute',
    zIndex: 1,
    top: '50%',
    transform: 'translate3d(0, -50%, 0)',
    left: '--canvas-gutter',
    flow: 'y',
    padding: 'U1 U1',
    round: 'C1',
    gap: 'X',
    theme: 'canvas-card-glass',
    NavbarButtonSet: {
        padding: '0',
        gap: 'Z',
        flow: 'y',
        childProps: {
            padding: 'Y2',
            round: 'C1',
            isActive: (el)=>el.getWindow('explorer') === el.key,
            onClick: (ev, el)=>el.call('handleDsNavbarClick')
        },
        children: [
            {
                key: 'components',
                title: 'Components',
                Icon: {
                    name: 'grid'
                }
            },
            {
                key: 'pages',
                title: 'Pages',
                Icon: {
                    name: 'pages outline'
                }
            },
            {
                key: 'functions',
                title: 'Functions',
                Icon: {
                    name: 'fn outline'
                }
            },
            {
                key: 'files',
                title: 'Files',
                Icon: {
                    name: 'folder outline'
                }
            },
            {
                key: 'dependencies',
                title: 'Dependencies',
                Icon: {
                    name: 'npm outline'
                }
            }
        ],
        childrenAs: 'props'
    },
    Line: {
        margin: 'Y1 0',
        width: 'fill-available'
    },
    NavbarButtonSet_ds: {
        padding: '0',
        gap: 'Z',
        flow: 'y',
        childProps: {
            padding: 'Y2',
            round: 'C1',
            isActive: (el)=>el.getWindow('explorer') === el.key,
            onClick: (ev, el)=>el.call('handleDsNavbarClick')
        },
        children: [
            {
                key: 'color',
                title: 'Colors',
                Icon: {
                    name: 'color outline colored'
                }
            },
            {
                key: 'typography',
                title: 'Typography',
                Icon: {
                    name: 'typography outline colored'
                },
                opacity: '.7'
            },
            {
                key: 'spacing',
                title: 'Spacing',
                Icon: {
                    name: 'space outline colored'
                },
                opacity: '.7'
            },
            {
                key: 'icons',
                title: 'Icons',
                Icon: {
                    name: 'icons outline colored'
                }
            },
            {
                key: 'shape',
                title: 'Shapes',
                Icon: {
                    name: 'shape outline colored'
                }
            },
            {
                key: 'media',
                title: 'Responsive',
                Icon: {
                    name: 'device mobile half fill'
                },
                opacity: '.7'
            },
            {
                key: 'cases',
                title: 'Cases',
                Icon: {
                    name: 'boolean outline'
                }
            }
        ],
        childrenAs: 'props'
    },
    Line_2: {
        margin: 'Y1 0',
        width: 'fill-available'
    },
    NavbarButtonSet_meta: {
        padding: '0',
        gap: 'Z',
        flow: 'y',
        Expand: {
            title: 'Expand',
            icon: 'arrowAngleRight',
            onClick: (ev, el)=>{
                el.toggleWindow('explorer');
            }
        }
    },
    NavbarTooltip: {
        ignoreChildProps: true,
        ignoreChildExtends: true,
        top: '0',
        left: '110%',
        tooltipPosition: 'right',
        shapeDirection: 'left'
    }
};

});

parcelRegister("hfDV1", function(module, exports) {

$parcel$export(module.exports, "NavbarPackageManagers", () => $c8f2cd6b6dc2b9fc$export$9a00089f87007af0);
const $c8f2cd6b6dc2b9fc$export$9a00089f87007af0 = {
    extends: 'NavbarButtonSet',
    children: [
        {
            title: 'NPM',
            key: 'npm',
            icon: 'npm'
        },
        {
            title: 'Yarn',
            key: 'yarn',
            icon: 'yarn'
        },
        {
            title: 'PNPM',
            key: 'pnpm',
            icon: 'pnpm'
        },
        {
            pointerEvents: 'none',
            opacity: '.25',
            title: 'CDN',
            key: 'cdn',
            icon: 'cdn'
        }
    ],
    childProps: {
        isActive: (el)=>el.getRootState('pkgManager') === el.key,
        onClick: (ev, el)=>{
            el.getRootState().update({
                pkgManager: el.key
            });
            el.call('setCookie', 'pkgManager', el.getRootState('pkgManager'));
        }
    }
};

});

parcelRegister("8z6qC", function(module, exports) {

$parcel$export(module.exports, "NavbarDesignTools", () => $63c69425c7b6475e$export$a3e85e085828cf2b);
const $63c69425c7b6475e$export$a3e85e085828cf2b = {
    extends: 'NavbarButtonSet',
    children: [
        {
            title: 'Figma preview',
            key: 'figma',
            icon: 'figma'
        },
        {
            title: 'Sketch',
            key: 'sketch',
            icon: 'sketch'
        },
        {
            title: 'Discussion',
            key: 'comments',
            icon: 'discussion'
        },
        {
            title: 'Export',
            key: 'export',
            icon: 'install'
        }
    ],
    childProps: {
        isActive: (el)=>el.getRootState('designTool') === el.key,
        onClick: (ev, el)=>{
            el.getRootState().update({
                pkgManager: el.key
            });
            el.call('setCookie', 'pkgManager', el.getRootState('pkgManager'));
        }
    }
};

});

parcelRegister("7t0eg", function(module, exports) {

$parcel$export(module.exports, "FilesSidebarGrid", () => $56fb6b539895fcc8$export$a17cdbd1e02b554e);
const $56fb6b539895fcc8$export$a17cdbd1e02b554e = {
    extends: 'Grid',
    hide: (el, s)=>s.hide === true,
    fontSize: 'Z2',
    childrenAs: 'state',
    columns: 'repeat(8, 1fr)',
    margin: '- 0',
    gap: 'Z1',
    children: async (el, s)=>{
        const activeFileSidebar = s.parent.activeFileSidebar;
        return await el.call('listSidebar', s.type, {
            search: el.lookup('Overflow')?.state.search,
            activeFileSidebar: activeFileSidebar
        });
    }
};

});

parcelRegister("kk6co", function(module, exports) {

$parcel$export(module.exports, "NavbarTheming", () => $ecba7be50f45a240$export$b2e5091528fe62b7);
const $ecba7be50f45a240$export$b2e5091528fe62b7 = {
    extends: 'NavbarButtonSet',
    childProps: {
        theme: 'sepia',
        background: 'transparent.0',
        isActive: (el)=>el.getRootState('globalTheme') === el.key,
        '!isActive': {
            opacity: '0.65'
        },
        '.isActive': {
            opacity: '1'
        },
        onClick: (ev, el)=>{
            const key = el.key;
            el.getRootState().update({
                globalTheme: key,
                sceneTheme: key
            });
            el.call('setCookie', 'sceneTheme', key);
            el.call('setCookie', 'globalTheme', key);
        }
    },
    children: [
        {
            key: 'light',
            icon: (el)=>el.getRootState('sceneTheme') === el.key.toLowerCase() ? 'sun' : 'sun outline'
        },
        {
            key: 'dark',
            icon: (el)=>el.getRootState('sceneTheme') === el.key.toLowerCase() ? 'moon' : 'moon outline'
        }
    ]
};

});

parcelRegister("b0mhK", function(module, exports) {

$parcel$export(module.exports, "GlobalNotification", () => $8030fb2b899b5c65$export$3b37f25902107e4);
const $8030fb2b899b5c65$export$3b37f25902107e4 = {
    childExtends: [
        'Notification'
    ],
    flow: 'y',
    gap: 'Y1',
    position: 'fixed',
    '.left-bottom': {
        left: 'A2',
        bottom: 'Z2'
    },
    zIndex: 9990100,
    round: 'Y',
    bottom: 'C1',
    left: '50%',
    transform: 'translateX(-50%)',
    childrenAs: 'state',
    children: (el, s)=>s.notifications,
    childProps: (el, s)=>({
            theme: s.type,
            minWidth: 'F',
            maxWidth: 'G2',
            padding: 'Z1 B1 Z A',
            align: 'start',
            boxShadow: '0 10px 26px -4px document',
            animation: 'fadeInUp',
            minWidth: 'F3',
            overflow: 'hidden',
            animationDuration: 'F, C, C',
            transform: 'translate3d(-50%, 35%, 0)',
            transition: 'B defaultBezier',
            transitionProperty: 'height, background, padding',
            // eslint-disable-next-line no-shadow,
            onMouseover: (ev, el, s)=>s.hover = true,
            // eslint-disable-next-line no-shadow,
            onMouseout: (ev, el, s)=>s.hover = false,
            // eslint-disable-next-line no-shadow,
            onClick: (ev, el)=>{
                el.call('closeNotification', null, {
                    forced: true
                });
                if (s.href) el.router(s.href || '/dashboard', el.getRoot());
            },
            IconText: null,
            Hgroup: {
                H: {
                    color: 'currentColor',
                    tag: 'strong',
                    text: '{{title}}'
                },
                P: {
                    color: 'currentColor',
                    text: '{{message}}'
                }
            },
            Icon: {
                position: 'absolute',
                padding: 'Z',
                onClick: (ev, el, s)=>{
                    ev.preventDefault();
                    ev.stopPropagation();
                    el.parent.call('closeNotification', {
                        forced: true
                    });
                },
                top: '0',
                right: '0',
                boxSizing: 'none',
                name: 'crossmark',
                color: 'currentColor',
                cursor: 'pointer'
            }
        })
};

});

parcelRegister("1X8C6", function(module, exports) {

$parcel$export(module.exports, "SelectedArticlesPanel", () => $16c1fb955085b4aa$export$a169f90ca89f802b);
const $16c1fb955085b4aa$export$a169f90ca89f802b = {
    flow: 'y',
    hide: (el, s)=>s.activeContent !== 'TUTORIALS',
    flexDirection: 'column',
    align: 'start start',
    round: 'A1',
    padding: 'Z2 Z2',
    position: 'relative',
    fontSize: 'Z1',
    childProps: {
        flex: '0 0 auto',
        width: '100%',
        minHeight: 'auto'
    },
    Flex: {
        flexDirection: 'column',
        H1: {
            fontSize: 'B2',
            padding: '- - Z -',
            color: 'title',
            fontWeight: '500',
            text: (el)=>{
                const { name: name, username: username } = el.getRootState();
                return `Hi ${username || name || ''} \u{1F44B}`;
            }
        },
        P: {
            color: 'paragraph',
            text: `Let's run through a few tutorials...`
        },
        Flex: {
            flow: 'y',
            childProps: {
                padding: 'Z1 W',
                width: '100%',
                maxWidth: 'H1',
                transition: 'A defaultBezier padding',
                borderStyle: 'solid',
                borderWidth: '1px 0 0 0',
                color: 'title',
                onClick: (ev, el)=>{
                    ev.preventDefault();
                    ev.stopPropagation();
                    el.setWindow('docs', el.href.split('/docs')[1]);
                },
                borderColor: 'line'
            },
            children: [
                {
                    href: '/docs/intro',
                    text: 'Intro'
                },
                {
                    href: '/docs/components',
                    text: 'Creating your first components'
                },
                {
                    href: '/docs/pages',
                    text: 'Routing and pages'
                },
                {
                    href: '/docs/how-to-code',
                    text: 'How to code'
                },
                {
                    href: '/docs/design-system',
                    text: 'Design System reference'
                },
                {
                    href: '/docs/element',
                    text: 'The element API'
                },
                {
                    href: '/docs/properties',
                    text: 'Custom properties'
                },
                {
                    text: 'Publishing & domains (TBA)'
                },
                {
                    text: 'Import & export (TBA)'
                },
                {
                    text: 'Versioning (TBA)'
                },
                {
                    text: 'Branching (TBA)'
                },
                {
                    href: '/docs/functions',
                    text: 'Functions reference'
                },
                {
                    href: '/docs/dependencies',
                    text: 'Dependencies'
                }
            ]
        }
    }
};

});

parcelRegister("fdkWt", function(module, exports) {

$parcel$export(module.exports, "SelectRoleField", () => $b1385090827b2b04$export$e9a93c2a595c51f8);
const $b1385090827b2b04$export$e9a93c2a595c51f8 = {
    extends: 'SelectField',
    Select: {
        name: 'role',
        id: 'role',
        childrenAs: 'props',
        children: ()=>[
                {
                    value: 'guest',
                    text: 'Guest'
                },
                {
                    value: 'editor',
                    text: 'Editor'
                },
                {
                    value: 'admin',
                    text: 'Admin'
                }
            ],
        childProps: {
            tag: 'option',
            attr: {
                selected: (el, s)=>{
                    const userRole = s.role || -1;
                    const optionValue = el.value;
                    return userRole === optionValue;
                }
            }
        }
    }
};

});

parcelRegister("atXcv", function(module, exports) {

$parcel$export(module.exports, "SidebarSignupOverlay", () => $7a1a88d299ac62e0$export$4350b8e18189a32a);
const $7a1a88d299ac62e0$export$4350b8e18189a32a = {
    extends: 'SidebarPricingOverlay',
    SimpleOverlay: {
        background: 'electricBlue'
    },
    Notification: {
        onClick: (f, el, st)=>{
            el.call('openModal', '/settings', {
                key: '/signup'
            });
        },
        Hgroup: {
            H: {
                text: 'Unlock editing!'
            },
            P: {
                text: 'Sign up to unlock more features, use templates, 5000+ components and more...'
            }
        }
    }
};

});

parcelRegister("a6vU4", function(module, exports) {

$parcel$export(module.exports, "ActiveCanvasUsers", () => $75b336406896e065$export$a9ad618203b48d82);
const $75b336406896e065$export$a9ad618203b48d82 = {
    flow: 'x',
    state: {
        clients: {},
        users: []
    },
    alignSelf: 'center',
    fontSize: 'X',
    children: (el, s)=>s.users,
    childExtends: 'Avatar',
    childProps: {
        avatarType: 'initials',
        opacity: 0.35,
        transition: 'B defaultBezier',
        transitionProperty: 'opacity, outline',
        data: {},
        ':hover': {
            opacity: 1
        },
        ':not(:last-child)': {
            margin: '0 -Z 0 0'
        },
        '.isActive': {
            zIndex: 2,
            opacity: 1,
            outline: '2px solid orange'
        },
        '.isFollowingYou': {
            zIndex: 2,
            opacity: 1,
            outline: '2px solid blue'
        },
        onClick: (ev, el)=>{
            const { userId: userId } = el;
            el.call('setFollowingUser', userId);
            el.parent.update();
        },
        onDblclick: (ev, el)=>{
            const { userId: userId } = el;
            el.call('askToFollow', userId);
        }
    },
    ':empty': {
        hide: true
    },
    onInit: async (el, st)=>{
        const areClientsEqual = (prev = {}, next = {})=>{
            const prevKeys = Object.keys(prev);
            const nextKeys = Object.keys(next);
            if (prevKeys.length !== nextKeys.length) return false;
            return prevKeys.every((key)=>{
                const p = prev[key] || {};
                const n = next[key] || {};
                // Fallback: use map key as _id if field missing
                const pId = p._id || key;
                const nId = n._id || key;
                // Only compare properties that affect visual rendering
                return pId === nId && p.username === n.username && p.avatar === n.avatar && p.userId === n.userId && p.followingUser === n.followingUser;
            });
        };
        el.sdk.rootBus.on('clients:updated', (data)=>{
            if (!data) return;
            const prevClients = st.clients || {};
            if (areClientsEqual(prevClients, data)) return; // nothing important changed
            // Save new clients map; stateUpdate will derive `users` list
            st.replace({
                clients: data
            });
        });
    },
    onStateUpdate: (changes, el)=>{
        // When clients data changes, rebuild the users list for rendering
        if (!changes.clients) return;
        const clients = el.state.clients || {};
        const { followingUser: followingUser, userId: userId } = el.getRootState();
        const activeUsers = Object.keys(clients).slice(0, 5).map((id)=>({
                href: clients[id].route,
                userId: id,
                key: clients[id].username,
                title: clients[id].username,
                src: clients[id].avatar,
                isActive: followingUser === clients[id].userId,
                isFollowingYou: userId === clients[id]?.followingUser
            })).filter((u)=>u.title !== 'root').filter((v, i, a)=>a.findIndex((t)=>t.userId === v.userId) === i);
        // Update users list without triggering another stateUpdate loop
        el.state.replace({
            users: activeUsers
        }, {
            preventStateUpdateListener: true
        });
    }
};

});

parcelRegister("dHdls", function(module, exports) {

$parcel$export(module.exports, "CanvasConnection", () => $9f89a495f98b997f$export$df6f33015f82810e);
const $9f89a495f98b997f$export$df6f33015f82810e = {
    flow: 'x',
    ActiveCanvasUsers: {},
    ConnectionNavbar: {},
    gap: 'Z2'
};

});

parcelRegister("1heju", function(module, exports) {

$parcel$export(module.exports, "ConnectionNavbar", () => $0ee27b537bf1c5fb$export$3e15a33dfc6fe18c);
const $0ee27b537bf1c5fb$export$3e15a33dfc6fe18c = {
    flow: 'x',
    align: 'center space-between',
    padding: '0',
    round: 'C1',
    gap: 'A',
    theme: 'canvas-card-glass',
    ':hover .avatar': {
        opacity: 0
    },
    ConnectionLabel: {
        gap: 'Y1',
        margin: '- - - A+V',
        lineHeight: 1,
        onClick: (ev, el)=>{
            el.call('openInNewTab');
        },
        ':hover': {
            textDecoration: 'underline'
        },
        Circle: {
            boxSize: 'Y1',
            isActive: true,
            position: 'relative',
            isLoading: false,
            animationIterationCount: 'infinite',
            '.isLoading': {
                animation: 'blinking',
                animationDuration: 'G2'
            },
            '!isLoading': {
                animation: null
            },
            onRender: (el, s)=>{
                const handler = ({ origin: origin })=>{
                    if (origin === 'auto') {
                        el.update({
                            isLoading: true
                        });
                        setTimeout(()=>el.update({
                                isLoading: false
                            }), 1000);
                    }
                };
                el.sdk.rootBus.on('checkpoint:done', handler);
            }
        },
        Text: {
            maxWidth: '100%',
            text: (el)=>el.getAppKey(),
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            padding: '- - .1em'
        },
        CopyButton: null
    },
    NavbarButtonSet: {
        padding: '0 X',
        gap: 'Y',
        VersionsButton: {
            if: (el)=>el.sdk.hasPermission('editMode'),
            icon: 'version outline',
            title: 'Publishing and Versions',
            scrollToTop: false,
            onClick: (ev, el)=>{
                el.getRootState().toggle('isVersionsOpen', {
                    preventUpdate: true
                });
                el.getVersionsAside()?.update();
            }
        },
        Pub: {
            if: (el)=>el.sdk.hasPermission('editMode'),
            icon: 'upload outline',
            title: 'Publishing and Versions',
            scrollToTop: false,
            onClick: async (ev, el)=>{
                await el.call('openModal', '/publish');
            }
        },
        SettingsButton: {
            extends: 'Link',
            title: 'Settings',
            color: 'paragraph',
            icon: 'settings outline',
            isActive: (el)=>el.getWindow('modal') === 'Settings',
            scrollToTop: false,
            onClick: async (ev, el)=>{
                await el.call('openModal', '/settings', {
                    key: '/settings'
                });
            }
        },
        childProps: {
            padding: 'Y1'
        }
    }
};

});

parcelRegister("ejg9w", function(module, exports) {

$parcel$export(module.exports, "SaveCheckpointControl", () => $a6af5ea053a60417$export$edd299a88e898c3d);
const $a6af5ea053a60417$export$edd299a88e898c3d = {
    flow: 'x',
    position: 'relative',
    width: '100px',
    height: '30px',
    fontSize: 'X',
    flow: 'x',
    align: 'center',
    pointerEvents: 'auto',
    onInit: (el, s)=>{
        const handler = ({ origin: origin })=>{
            if (origin === 'auto') {
                s.status = 'autoSaved';
                setTimeout(()=>s.update({
                        status: null
                    }), 1500);
            }
        };
        el.sdk.rootBus.on('checkpoint:done', handler);
    },
    state: {
        status: null
    },
    CommitBtn: {
        extends: 'Button',
        hide: true,
        show: (el, st)=>st.status === null,
        icon: 'cloud',
        text: 'Commit',
        width: '100%',
        onClick: async (ev, el, st)=>{
            try {
                st.update({
                    status: 'saving'
                });
                await el.sdk.checkpoint();
                st.update({
                    status: 'manualSaved'
                });
                setTimeout(()=>st.update({
                        status: null
                    }), 2500);
            } catch (err) {
                console.error(err);
                st.update({
                    status: null
                });
            }
        }
    },
    ManualSavedStatusMessage: {
        if: (el, st)=>st.status === 'manualSaved',
        tag: 'Span',
        text: 'Save success',
        color: 'green',
        textAlign: 'center',
        width: '100%'
    },
    AutoSavedStatusMessage: {
        if: (el, st)=>st.status === 'autoSaved',
        tag: 'Span',
        text: 'Auto Saved',
        color: 'green',
        textAlign: 'center',
        width: '100%'
    },
    SavingStatusMessage: {
        if: (el, st)=>st.status === 'saving',
        tag: 'Span',
        text: "Saving\u2026",
        color: 'dim',
        textAlign: 'center',
        width: '100%'
    }
};

});

parcelRegister("9pNaw", function(module, exports) {

$parcel$export(module.exports, "SelectedNavbar", () => $6dac96bc10ade97b$export$6cd19c0078491cd3);
const $6dac96bc10ade97b$export$6cd19c0078491cd3 = {
    // if: (el) => el.getUserSettings('allowTitleOnArtboard'),
    state: {
        type: 'components',
        value: {},
        isEditMode: false
    },
    extends: 'EditNavbar',
    minWidth: 'G1',
    position: 'absolute',
    bottom: '100%',
    margin: 'Z -',
    left: '50%',
    transition: 'X opacity defaultBezier',
    padding: '0 W 0 Z2',
    round: 'A',
    top: 'auto',
    pointerEvents: 'auto',
    theme: 'common-box',
    borderColor: 'line',
    borderWidth: '1px',
    borderStyle: 'solid',
    width: 'calc(100% + Y1 * 2)',
    maxWidth: 'calc(100% + Y1 * 2)',
    fontSize: 'Z1',
    isEditing: (el, s)=>s.isEditMode,
    transform: 'translate3d(-50%, 0, 1px)',
    '.isEditing': {
        theme: 'field'
    },
    '!isEditing': {
        theme: 'navbar'
    },
    onBeforeUpdate: (_, el, s, ctx, opts)=>{
        s.isEditMode = Boolean(opts.force);
        const selected = el.getSelectedKey();
        if (!selected) return;
        s.key = selected;
        s.type = selected.startsWith('/') ? 'pages' : 'components';
    },
    EditorPositionNavbar: null,
    NavbarButtonSet_meta: null,
    NavbarButtonSet_title: {
        maxWidth: '40%',
        hide: (el, s)=>s.isEditMode,
        onDblclick: (ev, el, s)=>{
            s.update({
                isEditMode: true
            }, {
                force: true
            });
        },
        Text: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            lineHeight: '1.7',
            ignoreChildExtends: true,
            text: (el)=>el.getSelectedKey()
        },
        CopyButton: {
            value: (el, s)=>el.getSelectedKey()
        }
    },
    EditorTools: {
        margin: '- - - auto',
        hide: (el, s)=>s.isEditMode,
        gap: 'U',
        paddingInlineEnd: '0',
        PreviewBtn: {
            icon: 'sf play',
            title: 'Preview',
            onClick: (ev, el, s)=>{
                el.activateChosen(s.key);
                el.call('clearFollowing');
            }
        },
        ContextBtn: {
            icon: 'three dots vertical',
            title: 'Options',
            onClick: (ev, el, s)=>{
                el.activateContext(ev, s.key);
            },
            order: 3
        },
        childExtends: 'NavbarButton',
        Refresh: {
            icon: 'reload outline',
            title: 'Refresh',
            onClick: (ev, el)=>{
                const key = el.getSelectedKey();
                const item = el.getItem?.(key);
                el.call('refreshComponentOnCanvas', key, item);
            }
        },
        InNewTab: {
            icon: 'arrow up right',
            title: 'In new tab',
            onClick: (ev, el)=>{
                const url = el.call('generatePreviewUrl');
                window.open(url, 'Symbols preview');
            }
        },
        TextNavbarButtonDropdown: {}
    },
    FileSidebarAddNewItem: {
        hide: (el, s)=>!s.isEditMode,
        flex: 1,
        padding: '- Y1 - -',
        onSubmit: async (ev, el, s)=>{
            ev.preventDefault();
            const capitalizeType = el.call('capitalize', s.type);
            await el.call(`rename${capitalizeType}`, 'new-key', async (newKey)=>{
                el.node.reset();
                s.update({
                    isEditMode: false,
                    key: newKey
                });
            });
        },
        Label: {
            border: 'none',
            '.hasItems': null,
            margin: '0',
            Icon: null,
            Input: {
                autofocus: true,
                padding: '0',
                value: (el, s)=>{
                    return el.getSelectedKey();
                },
                onInput: ()=>{},
                attr: {
                    required: true,
                    placeholder: (el, s)=>'Type ' + (s.type === 'pages' ? '/page-path' : 'ComponentName')
                }
            },
            Flex: {
                childExtends: 'NavbarButton',
                Save: {
                    padding: 'Y2',
                    fontSize: 'A'
                },
                Close: {
                    order: 2,
                    padding: 'Y2',
                    fontSize: 'A',
                    onClick: (ev, el, s)=>{
                        s.parent.update({
                            isEditMode: false
                        });
                    }
                }
            }
        }
    }
};

});

parcelRegister("dCDnM", function(module, exports) {

$parcel$export(module.exports, "SidebarPricingOverlay", () => $9ead5f81f18c4f85$export$ce5cf17922a9e345);
const $9ead5f81f18c4f85$export$ce5cf17922a9e345 = {
    if: (el)=>el.isAuthorised() && el.getRootState('tier') === 'starter',
    SimpleOverlay: {
        background: 'gradient-colorful-active',
        height: 'F',
        opacity: '.9',
        zIndex: 11,
        inset: 'auto 0 0 0',
        style: {
            WebkitMaskImage: 'url(data:image/jpeg;base64,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)',
            WebkitMaskSize: '100% 100%'
        }
    },
    Notification: {
        extends: [
            'Notification',
            'Link'
        ],
        onClick: (f, el, st)=>{
            el.call('openModal', '/settings', {
                key: '/pricing'
            });
        },
        align: 'start start',
        zIndex: 12,
        margin: 'auto X Z',
        theme: null,
        color: 'caption',
        background: '--document-background',
        padding: 'Z2 A Z',
        fontWeight: 400,
        position: 'relative',
        gap: 'Y2',
        transition: 'B2 background defaultBezier',
        ':hover': {
            background: 'blue.15'
        },
        IconText: {
            hide: true
        },
        Hgroup: {
            H: {
                tag: 'strong',
                text: 'Unlock all features...'
            },
            P: {
                color: 'caption',
                text: 'Work with team and AI, remove limits, unlock custom domains with SEO and more...'
            }
        }
    }
};

});

parcelRegister("jnFf1", function(module, exports) {

$parcel$export(module.exports, "Tests", () => $e1c027f2f08dd590$export$3253960704044f84);
const $e1c027f2f08dd590$export$3253960704044f84 = {
    children: [
        'one',
        'two'
    ],
    childProps: {
        onClick: (ev, el, s)=>{
            s.update({
                act: el.text
            });
        },
        '.isAct': {
            color: 'red',
            textDecoration: 'underline'
        }
    }
};

});

parcelRegister("jU81a", function(module, exports) {

$parcel$export(module.exports, "ExplorerSwitcher", () => $e7d977710a697d51$export$a2171b94d0ca9189);
const $e7d977710a697d51$export$a2171b94d0ca9189 = {
    extends: [
        'Grid',
        'Navbar'
    ],
    round: 'C1',
    fontSize: 'Z',
    templateColumns: 'repeat(11, 1fr)',
    align: 'center center',
    onRender: (el)=>el.update(),
    childProps: {
        textAlign: 'center',
        isActive: (el, s)=>el.key === s.activeContent,
        onClick: (ev, el, s)=>{
            const activeContent = el.key;
            // el.call('setSidebarContent', activeContent)
            el.setWindow('explorer', 'explorer:' + activeContent);
        },
        theme: null
    },
    theme: null,
    children: [
        {
            icon: 'sf components',
            title: 'Artboards',
            key: 'ARTBOARD_TYPES'
        },
        {
            icon: 'fnOutline',
            title: 'Functions',
            key: 'FUNCTION_TYPES'
        },
        {
            icon: 'sf document',
            title: 'State',
            key: 'STATE_TYPES'
        },
        {
            icon: 'sf assets',
            title: 'Assets',
            key: 'ASSETS_TYPES'
        },
        {
            icon: 'sf pallete',
            title: 'Colors',
            key: 'COLOR_TYPES'
        },
        {
            icon: 'sf responsive',
            title: 'Responsive',
            key: 'RESPONSIVE_TYPES'
        },
        {
            icon: 'fontFace',
            title: 'Typography',
            key: 'TYPOGRAPHY_TYPES'
        },
        {
            icon: 'spaceOutlineColored',
            title: 'Spacing',
            key: 'SPACING_TYPES'
        },
        {
            icon: 'iconsOutlineColored',
            title: 'Icons',
            key: 'ICON_TYPES'
        },
        {
            icon: 'animationsAlt',
            title: 'Animation',
            key: 'TRANSITION_TYPES'
        },
        {
            icon: 'fuse',
            title: 'Integrations',
            key: 'INTEGRATIONS_TYPES'
        }
    ],
    gap: 'V',
    childExtends: {
        extends: [
            'NavbarButton',
            'NavbarTooltipParent'
        ],
        state: null,
        round: 'C1',
        padding: 'Z -',
        width: 'initial',
        aspectRatio: 'unset'
    },
    NavbarTooltip: {
        ignoreChildExtends: true,
        ignoreChildProps: true
    }
};

});

parcelRegister("idQdM", function(module, exports) {

$parcel$export(module.exports, "MainCanvasNavbar", () => $d441f2f871f72695$export$775593b21f1bf9b7);
const $d441f2f871f72695$export$775593b21f1bf9b7 = {
    MainNav: {
        flow: 'x',
        align: 'center',
        gap: 'X',
        LogoDropdown: {},
        TextNavbar: {}
    },
    ModesInNavbar: {
        margin: '- -Z'
    },
    CanvasPagesDropdown: {
        margin: '- -Z'
    },
    CanvasSearch: {
        flex: 1
    },
    History: {
        extends: 'NavbarButtonSet',
        gap: 'X2',
        margin: '- -Z - -Y2',
        Undo: {
            title: 'Undo',
            icon: 'undo',
            onClick: (ev, el, s)=>{
                el.sdk.undo();
            }
        },
        Redo: {
            title: 'Redo',
            icon: 'redo',
            onClick: (ev, el, s)=>{
                el.sdk.redo();
            }
        },
        History: {
            title: 'History',
            icon: 'sf history',
            onClick: (ev, el, s)=>{
                el.getRootState().toggle('isVersionsOpen', {
                    preventUpdate: true
                });
                el.getVersionsAside()?.update();
            }
        }
    },
    EnvsNavbar: {},
    PublishNavbar: {},
    MembersNavbar: {
        margin: '- -Z2 - -'
    },
    SharingNavbar: {},
    extends: 'Navbar',
    gap: 'A2',
    round: 'C1',
    padding: 'V Z',
    fontSize: 'Z',
    userSelect: 'none',
    theme: 'common-box',
    borderColor: 'line',
    borderWidth: '1px',
    borderStyle: 'solid'
};

});

parcelRegister("fqN8s", function(module, exports) {

$parcel$export(module.exports, "TextNavbar", () => $b3bf66015e73053b$export$6b8c7dc3a3321139);
const $b3bf66015e73053b$export$6b8c7dc3a3321139 = {
    Insert: {
        extends: 'TextNavbarButtonDropdown',
        key: 'insert:library',
        Button: {
            icon: 'sf plus',
            text: null
        },
        IconButton: {
            DropdownParentFocus: {
                Dropdown: {
                    'Dropdown.QuickAdd': {}
                }
            }
        }
    },
    Assistant: {
        extends: 'TextNavbarButtonDropdown',
        key: 'chat',
        Button: {
            text: 'Assistant'
        },
        IconButton: {
            DropdownParentFocus: {
                Dropdown: {
                    'Dropdown.AssistantMenu': {}
                }
            }
        }
    },
    Files: {
        extends: 'TextNavbarButtonDropdown',
        key: 'explorer',
        Button: {
            text: 'Files'
        },
        IconButton: {
            DropdownParentFocus: {
                Dropdown: {
                    'Dropdown.MoreFilesMenu': {}
                }
            }
        }
    },
    Learn: {
        extends: 'TextNavbarButtonDropdown',
        key: 'learn',
        Button: {
            text: 'Learn'
        },
        IconButton: {
            DropdownParentFocus: {
                Dropdown: {
                    'Dropdown.MoreLearnMenu': {}
                }
            }
        }
    },
    flow: 'x',
    onFrame: (el, s)=>{
        const explorer = el.getWindow('explorer');
        el.variables({
            explorer: explorer
        }).changed((changes, prev)=>{
            el.update();
        });
    }
};

});

parcelRegister("224Ar", function(module, exports) {

$parcel$export(module.exports, "SearchBar", () => $17af53846a10000b$export$79d13b60110f33be);
const $17af53846a10000b$export$79d13b60110f33be = {
    extends: [
        'DropdownParentFocus'
    ],
    position: 'relative',
    theme: 'quinary',
    round: 'C',
    minWidth: 'D3',
    margin: '-V - - -',
    tag: 'search',
    state: {
        recents: []
    },
    Input_trigger: null,
    Form: {
        flow: 'x',
        align: 'center',
        gap: 'X',
        onSubmit: (ev)=>ev.preventDefault(),
        Icon: {
            fontSize: 'Z1',
            margin: '- -B2 - A',
            name: 'search'
        },
        Input: {
            autofocus: 'autofocus',
            round: '0',
            placeholder: 'Search on Canvas',
            padding: 'Y1 B2 Y1 C',
            theme: 'transparent',
            outline: 'none',
            appearance: 'none',
            ':focus-visible': {
                outline: 'none'
            },
            '::-webkit-search-cancel-button': {
                display: 'none'
            },
            '::placeholder': {
                color: 'placeholder'
            },
            onInput: (ev, el, s)=>{
                s.update({
                    searchTerm: el.node.value
                });
            },
            flex: 1
        }
    },
    Dropdown: {
        top: '105%',
        width: '100%',
        left: '0',
        extends: [
            'CanvasSearchDropdown',
            'Dropdown'
        ]
    }
};

});

parcelRegister("dt2bX", function(module, exports) {

$parcel$export(module.exports, "CanvasSearch", () => $9cdfaf09c1d6c928$export$15f38bcfd79a2b77);
const $9cdfaf09c1d6c928$export$15f38bcfd79a2b77 = {
    extends: [
        'SearchBar'
    ],
    tag: 'search',
    state: {
        recents: []
    },
    onInit: (el, s)=>{
        const projectKey = el.getAppKey();
        const recentKey = projectKey + '_recentSearches';
        const recentsValue = window.localStorage.getItem(recentKey);
        let recents = JSON.parse(recentsValue || '[]');
        if (!recents.length) {
            const components = el.getSchema('components') || el.call('getData', 'components') || {};
            recents = Object.values(components).map((v)=>({
                    key: v.key,
                    type: v.type,
                    title: v.title
                }));
        }
        s.recents = recents.slice(0, 15);
    }
};

});

parcelRegister("2Fpg4", function(module, exports) {

$parcel$export(module.exports, "FilesSidebarCopy", () => $1f1300deff4fb37b$export$bbee6c7c940bf229);
const $1f1300deff4fb37b$export$bbee6c7c940bf229 = {
    data: {},
    state: {
        activeFileSidebar: 'Local',
        activeContent: 'ARTBOARD_TYPES',
        keyword: '',
        thread: [],
        images: [],
        selectedOption: 0
    },
    flow: 'y',
    minHeight: 'F1',
    height: 'max-content',
    onInit: (el, s)=>{
        const activeContentCookie = el.call('getCookie', el.getAppKey() + '_activeContent');
        if (activeContentCookie) s.activeContent = activeContentCookie;
    },
    ':hover': {
        '& header > a:first-child': {
            opacity: 1
        }
    },
    ActiveContentSwitcher: {
        theme: 'common-box',
        padding: 'V',
        margin: 'X -W1 Z'
    },
    Overflow: {
        flow: 'y',
        gap: 'B2',
        overflow: 'hidden auto',
        flex: 1,
        padding: '0',
        '::-moz-scrollbar': {
            hide: true
        },
        '::-webkit-scrollbar': {
            hide: true
        },
        isPaid: (el, s)=>el.getRootState('tier') !== 'starter',
        '!isPaid': {
            paddingBlockEnd: 'D3'
        },
        Flex: {
            theme: 'common-box',
            round: 'A1',
            hide: (el, s)=>![
                    'ARTBOARD_TYPES'
                ].includes(s.activeContent),
            ChooseCanvas: {
                flex: 1,
                FilesSidebarTitle: {
                    theme: null,
                    paddingInlineStart: 'A',
                    Span: {
                        ':hover': null
                    }
                }
            }
        },
        SectionsList: {
            hide: (el, s)=>[
                    'AI',
                    'TUTORIALS'
                ].includes(s.activeContent),
            flow: 'y',
            gap: 'B2',
            padding: '- Y1',
            childProps: {
                ':first-child .hr': {
                    hide: true
                }
            },
            childrenAs: 'element',
            children: (el, s)=>{
                const activeType = el.parent.activeType || el.getWindow('explorer');
                const activeContent = s.activeContent;
                if (!activeType) return [];
                const types = el.call('getActiveSidebarTypes', activeContent);
                return types.reduce((initial, type)=>{
                    if (// !s.search || //&&
                    // el.call('isString', activeType) &&
                    // activeType !== type) ||
                    !el.call('checkFeatureByPackage', type)) return initial;
                    switch(type){
                        case 'docs':
                            return [
                                ...initial,
                                {
                                    extends: 'FilesSidebarSection',
                                    state: {
                                        type: type
                                    },
                                    FilesSidebarTitle: {
                                        Span: {
                                            Text: {
                                                text: 'Learning centre'
                                            }
                                        }
                                    },
                                    // FilesSidebarList: null,
                                    FilesSidebarList: {
                                        FileSidebarAddNewItem: null,
                                        childExtends: 'FilesSidebarListItem',
                                        // childExtends: 'CaseTemplate',
                                        childProps: {
                                            isActive: false,
                                            isCurrent: false,
                                            onClick: (ev, el, s)=>{
                                                console.log('open docs');
                                            }
                                        },
                                        childrenAs: 'props'
                                    }
                                }
                            ];
                        case 'color':
                            return [
                                ...initial,
                                {
                                    flow: 'x',
                                    gap: 'B2',
                                    flexDirection: 'column',
                                    childExtends: 'FilesSidebarSection',
                                    Color: {
                                        state: {
                                            type: 'color'
                                        },
                                        FilesSidebarTitle: {},
                                        // FilesSidebarList: null,
                                        FilesSidebarList: {
                                            // margin: 'X 0 -',
                                            childExtends: [
                                                'ColorTemplateRow',
                                                'FilesSidebarListItem'
                                            ]
                                        }
                                    },
                                    Gradient: {
                                        state: {
                                            type: 'gradient'
                                        },
                                        FilesSidebarTitle: {},
                                        // FilesSidebarList: null,
                                        FilesSidebarList: {
                                            childExtends: [
                                                'ColorTemplateRow',
                                                'FilesSidebarListItem'
                                            ]
                                        }
                                    },
                                    SemanticColor: {
                                        state: {
                                            type: 'semantic_color'
                                        },
                                        FilesSidebarTitle: {},
                                        FilesSidebarList: {
                                            childExtends: [
                                                'SemanticColorTemplateRow',
                                                'FilesSidebarListItem'
                                            ]
                                        }
                                    },
                                    GlobalTheme: {
                                        state: {
                                            type: 'global_theme'
                                        },
                                        FilesSidebarTitle: {},
                                        FilesSidebarList: {
                                            childExtends: [
                                                'GlobalThemeTemplateRow',
                                                'FilesSidebarListItem'
                                            ]
                                        }
                                    },
                                    Theme: {
                                        state: {
                                            type: 'theme'
                                        },
                                        FilesSidebarTitle: {
                                            Span: {
                                                Text: {
                                                    text: 'themes'
                                                }
                                            }
                                        },
                                        FilesSidebarList: {
                                            // margin: 'X 0 -',
                                            columns: 'repeat(3, 1fr)',
                                            childProps: {
                                                minWidth: 'none',
                                                round: 'C1'
                                            },
                                            childExtends: {
                                                extends: [
                                                    'ThemeTemplateRow',
                                                    'FilesSidebarListItem'
                                                ]
                                            }
                                        }
                                    }
                                }
                            ];
                        case 'typography':
                            return [
                                ...initial,
                                {
                                    flow: 'x',
                                    gap: 'B',
                                    flexDirection: 'column',
                                    childExtends: 'FilesSidebarSection',
                                    Typography: {
                                        gap: '0',
                                        state: {
                                            type: 'typography'
                                        },
                                        FilesSidebarTitle: {},
                                        FileSidebarAddNewItem: {
                                            border: 'none!important',
                                            onSubmit: (ev, submitEl)=>{
                                                ev.preventDefault();
                                                submitEl.call('createTypography');
                                                submitEl.Label.Input.node.value = '';
                                                return s.update({
                                                    key: null,
                                                    err: null,
                                                    adding: false
                                                });
                                            },
                                            Label: {
                                                Icon: {},
                                                Input: {
                                                    onInput: null
                                                }
                                            }
                                        },
                                        FilesSidebarList: {
                                            gap: 'Z1',
                                            childExtends: [
                                                'TypographyTemplate',
                                                'FilesSidebarListItem'
                                            ]
                                        }
                                    },
                                    Fonts: {
                                        state: {
                                            type: 'font'
                                        },
                                        FilesSidebarTitle: {},
                                        // FilesSidebarGrid: null,
                                        FilesSidebarList: {
                                            childExtends: [
                                                'FontItemRow',
                                                'FilesSidebarListItem'
                                            ],
                                            childProps: {
                                                onClick: async (ev, el, s)=>{
                                                    ev.preventDefault();
                                                    if (el.lookup('Overflow')?.state.activeFileSidebar === 'Local') await el.call('openModal', '/edit-font', {
                                                        key: s.key
                                                    });
                                                }
                                            }
                                        }
                                    },
                                    FontFamily: {
                                        state: {
                                            type: 'font_family'
                                        },
                                        FilesSidebarTitle: {
                                            Span: {
                                                text: 'Font Families',
                                                Text: null
                                            }
                                        },
                                        FilesSidebarList: {
                                            childExtends: [
                                                'FontFamilyObject',
                                                'FilesSidebarListItem'
                                            ]
                                        }
                                    },
                                    TextStyles: {
                                        gap: '0',
                                        state: {
                                            type: 'templates'
                                        },
                                        FilesSidebarTitle: {
                                            Span: {
                                                text: 'Text Styles',
                                                Text: null
                                            }
                                        },
                                        FilesSidebarList: {
                                            // display: 'flex',
                                            // flexDirection: 'column',
                                            // gap: '0',
                                            // margin: '-',
                                            childExtends: [
                                                'TextStylesTemplate',
                                                'FilesSidebarListItem'
                                            ]
                                        }
                                    }
                                }
                            ];
                        case 'spacing':
                            return [
                                ...initial,
                                {
                                    extends: 'FilesSidebarSection',
                                    gap: '0',
                                    state: {
                                        type: 'spacing'
                                    },
                                    FilesSidebarTitle: {},
                                    FileSidebarAddNewItem: {
                                        border: 'none!important',
                                        onSubmit: (ev, submitEl)=>{
                                            ev.preventDefault();
                                            submitEl.call('createSpacing');
                                            return s.update({
                                                key: null,
                                                err: null,
                                                adding: false
                                            });
                                        }
                                    },
                                    FilesSidebarList: {
                                        // display: 'flex',
                                        // flexDirection: 'column',
                                        gap: '0',
                                        // margin: '-',
                                        Default: {
                                            state: el.filterKeys(el.getDesignSystem('spacing'))
                                        },
                                        childExtends: [
                                            'SpacingTemplateRow',
                                            'FilesSidebarListItem'
                                        ]
                                    }
                                }
                            ];
                        case 'icons':
                            return [
                                ...initial,
                                {
                                    extends: 'FilesSidebarSection',
                                    state: {
                                        type: type
                                    },
                                    FilesSidebarTitle: {},
                                    // FilesSidebarList: null,
                                    FilesSidebarList: {
                                        // columns: 'repeat(7, 1fr)',
                                        // gap: 'W',
                                        // margin: '- -Y',
                                        // style: {
                                        //   svg: {
                                        //     // width: '100%',
                                        //     // height: '100%',
                                        //     display: 'inline-block'
                                        //     // fill: 'currentColor',
                                        //     // '*': {
                                        //     //   fill: 'currentColor'
                                        //     // }
                                        //   }
                                        // },
                                        FileSidebarAddNewItem: null,
                                        childExtends: 'IconTemplateRow'
                                    }
                                }
                            ];
                        case 'shape':
                            return [
                                ...initial,
                                {
                                    extends: 'FilesSidebarSection',
                                    state: {
                                        type: type
                                    },
                                    FilesSidebarTitle: {},
                                    FilesSidebarList: null,
                                    FilesSidebarGrid: {
                                    }
                                }
                            ];
                        case 'cases':
                            return [
                                ...initial,
                                {
                                    extends: 'FilesSidebarSection',
                                    state: {
                                        type: type
                                    },
                                    FilesSidebarTitle: {},
                                    // FilesSidebarList: null,
                                    FilesSidebarList: {
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: 'A',
                                        FileSidebarAddNewItem: null,
                                        childExtends: [
                                            'CaseTemplateRow',
                                            'FilesSidebarListItem'
                                        ]
                                    }
                                }
                            ];
                        case 'media':
                            return [
                                ...initial,
                                {
                                    extends: 'FilesSidebarSection',
                                    state: {
                                        type: type
                                    },
                                    FilesSidebarTitle: {},
                                    FilesSidebarList: {
                                        childExtends: [
                                            'MediaTemplateRow',
                                            'FilesSidebarListItem'
                                        ]
                                    }
                                }
                            ];
                        case 'files':
                            return [
                                ...initial,
                                {
                                    extends: 'FilesSidebarSection',
                                    state: {
                                        type: type
                                    },
                                    FilesSidebarTitle: {},
                                    FileSidebarAddNewItem: null,
                                    FilesSidebarList: {
                                        childProps: {
                                            flow: 'row'
                                        }
                                    }
                                }
                            ];
                        default:
                            return [
                                ...initial,
                                {
                                    extends: 'FilesSidebarSection',
                                    state: {
                                        type: type
                                    }
                                }
                            ];
                    }
                }, []);
            },
            onBeforeUpdate: (_, el, s, ctx, opts)=>Boolean(el.getWindow('explorer')) && !opts.layerClick
        },
        AISidebarPanel: {
            flex: 1
        },
        TutorialsPanel: {}
    }
};

});

parcelRegister("5PKnX", function(module, exports) {

$parcel$export(module.exports, "ZoomInNavbar", () => $43f5b258f18881bb$export$b5f4da73219db3d9);
const $43f5b258f18881bb$var$getGS = ()=>window.__canvasGlobalScope;
const $43f5b258f18881bb$var$getIframeWindow = ()=>{
    const iframe = document.getElementById('canvas-iframe');
    return iframe?.contentWindow || window;
};
const $43f5b258f18881bb$export$b5f4da73219db3d9 = {
    flow: 'x',
    onFrame: (el)=>{
        const pz = $43f5b258f18881bb$var$getGS()?.panzoomInstance;
        const scale = pz ? pz.getTransform().scale : 0.35;
        const text = parseInt(scale * 100) + '%';
        if (el.Box && el.Box.node && el.Box.node.innerText !== text) el.Box.node.innerText = text;
    },
    align: 'center',
    NavbarButton_out: {
        title: 'Zoom out',
        icon: 'sf zoom out',
        ':not(:hover)': {
            theme: 'transparent'
        },
        onClick: (ev, el)=>{
            const gs = $43f5b258f18881bb$var$getGS();
            if (!gs?.panzoomInstance) return;
            const win = $43f5b258f18881bb$var$getIframeWindow();
            const { x: x, y: y } = gs.positions;
            gs.panzoomInstance.smoothZoom(x + win.innerWidth / 2, y + win.innerHeight / 2, 0.75);
        }
    },
    Box: {
        width: '7ch',
        textAlign: 'center',
        padding: '- Z',
        fontSize: 'Z2',
        color: 'paragraph',
        text: '100%',
        userSelect: 'none',
        onDblclick: (ev, el)=>{
            const gs = $43f5b258f18881bb$var$getGS();
            if (!gs?.panzoomInstance) return;
            const win = $43f5b258f18881bb$var$getIframeWindow();
            const { x: x, y: y } = gs.positions;
            gs.panzoomInstance.smoothZoomAbs(x + win.innerWidth / 2, y + win.innerHeight / 2, 1);
        }
    },
    NavbarButton_in: {
        title: 'Zoom in',
        icon: 'sf zoom in',
        ':not(:hover)': {
            theme: 'transparent'
        },
        onClick: (ev, el)=>{
            const gs = $43f5b258f18881bb$var$getGS();
            if (!gs?.panzoomInstance) return;
            const win = $43f5b258f18881bb$var$getIframeWindow();
            const { x: x, y: y } = gs.positions;
            gs.panzoomInstance.smoothZoom(x + win.innerWidth / 2, y + win.innerHeight / 2, 1.25);
        }
    },
    DropdownArrow: {
        margin: '- - - X2'
    }
};

});

parcelRegister("1uyoM", function(module, exports) {

$parcel$export(module.exports, "ModesInNavbar", () => $116346a307c06ef3$export$ba77faaf886999b4);
const $116346a307c06ef3$export$ba77faaf886999b4 = {
    Default: {
        isActive: (el, s)=>el.isCanvasMode('defaultMode'),
        title: 'Default mode',
        icon: 'sf cursor',
        '!isActive': {
            ':not(:hover)': {
                theme: 'transparent'
            }
        },
        onClick: (ev, el, s)=>{
            el.setCanvasMode('defaultMode');
        }
    },
    Inspect: {
        isActive: (el, s)=>el.isCanvasMode('inspectMode'),
        title: 'Inspect mode',
        icon: 'sf inspect',
        '!isActive': {
            ':not(:hover)': {
                theme: 'transparent'
            }
        },
        onClick: (ev, el, s)=>{
            el.setCanvasMode('inspectMode');
        }
    },
    Pan: {
        isActive: (el, s)=>el.isCanvasMode('panningMode'),
        title: 'Pan mode',
        icon: 'sf move',
        '!isActive': {
            ':not(:hover)': {
                theme: 'transparent'
            }
        },
        onClick: (ev, el, s)=>{
            el.setCanvasMode('panningMode');
        }
    },
    Viewing: {
        isActive: (el, s)=>el.isCanvasMode('isViewing'),
        title: 'View mode',
        icon: 'sf eye',
        '!isActive': {
            ':not(:hover)': {
                theme: 'transparent'
            }
        },
        onClick: (ev, el, s)=>{
            el.setCanvasMode('isViewing');
        },
        hide: true
    },
    Comment: {
        isActive: (el, s)=>el.isCanvasMode('isCommenting'),
        title: 'Comment mode',
        icon: 'sf comment',
        '!isActive': {
            ':not(:hover)': {
                theme: 'transparent'
            }
        },
        onClick: (ev, el, s)=>{
            el.setCanvasMode('isCommenting');
        },
        hide: true
    },
    CanvasButton: {
        ignoreChildProps: true,
        ignoreChildExtends: true,
        ignoreChildExtends: true,
        lineHeight: 1,
        padding: 'X',
        round: 'X',
        margin: '- - - -W',
        onClick: async (ev, el)=>{
            ev.stopPropagation();
        },
        DropdownArrow: {},
        extends: [
            'CanvasButton',
            'Flex',
            'DropdownParentFocus'
        ],
        Dropdown: {
            top: 'C3',
            left: '-D1',
            'Dropdown.MoreModesMenu': {}
        }
    },
    extends: 'NavbarButtonSet',
    gap: 'W2',
    onFrame: (el, s)=>{
        const canvasMode = el.getCanvasMode();
        el.variables({
            canvasMode: canvasMode
        }).changed((_)=>{
            el.update();
        });
    },
    align: 'center',
    onRender: (el)=>el.update()
};

});

parcelRegister("kCGwW", function(module, exports) {

$parcel$export(module.exports, "CanvasSearchDropdown", () => $f03858e7e4732dd4$export$b8abeb8be44361a4);

const $f03858e7e4732dd4$export$b8abeb8be44361a4 = {
    flow: 'y',
    gap: 'A',
    padding: 'Z1 A',
    minWidth: 'G2',
    scope: {},
    CaptionTitle: {
        Text: {
            text: (el, s)=>s.searchTerm ? 'Search results' : 'Recent searches'
        }
    },
    ListInDropdown: {
        gap: 'Z',
        flow: 'y',
        margin: '- -Z2',
        onInit: async (el, s)=>{
            const fuse = await (parcelRequire("geSpI"));
            const Fuse = fuse.default;
            const fuseOptions = {
                isCaseSensitive: false,
                shouldSort: true,
                findAllMatches: true,
                includeScore: true,
                threshold: 0.3,
                keys: [
                    'key',
                    'title',
                    'code'
                ]
            };
            function mapBucketToItems(bucketObj, type) {
                if (!bucketObj) return [];
                return Object.values(bucketObj).map((item)=>({
                        key: item.key,
                        title: item.title || '',
                        code: item.code || '',
                        type: type
                    })).filter((v)=>v.key);
            }
            const typesArr = el.parent.props?.typesToIndex || [
                'components',
                'pages',
                'functions',
                'state',
                'files'
            ];
            const searchItems = typesArr.flatMap((bucket)=>mapBucketToItems(el.getSchema?.(bucket), bucket));
            el.scope.fuse = new Fuse(searchItems, fuseOptions);
        },
        children: (el, s)=>{
            if (!s.searchTerm) return s.recents;
            const fuse = el.scope.fuse;
            function searchAll(query) {
                const results = fuse.search(query);
                return results.map((r)=>({
                        key: r.item.key,
                        title: r.item.title,
                        code: r.item.code,
                        type: r.item.type,
                        score: r.score
                    }));
            }
            const result = searchAll(s.searchTerm);
            return result;
        },
        childrenAs: 'state',
        childExtends: 'CanvasSearchItem'
    }
};

});
parcelRegister("geSpI", function(module, exports) {
module.exports = import("krtLM").then(()=>parcelRequire('6oWMY'));

});


parcelRegister("czd7Z", function(module, exports) {

$parcel$export(module.exports, "ThemesInNavbar", () => $9262efd71a8c1cc9$export$b868767c26e65391);
const $9262efd71a8c1cc9$export$b868767c26e65391 = {
    Dark: {
        title: 'Dark mode',
        isActive: (el)=>el.getRootState('sceneTheme') === 'dark',
        theme: 'sepia',
        icon: (el, s)=>el.getRootState('sceneTheme') === 'dark' ? 'moon' : 'moon outline',
        onClick: (ev, el, s)=>{
            const key = 'dark';
            el.getRootState().update({
                globalTheme: key,
                sceneTheme: key
            });
            el.getRoot().call('router', window.location.pathname);
            el.getRoot().call('setCookie', 'sceneTheme', key);
            el.getRoot().call('setCookie', 'globalTheme', key);
        }
    },
    Light: {
        title: 'Light mode',
        isActive: (el)=>el.getRootState('sceneTheme') === 'light',
        theme: 'sepia',
        icon: (el, s)=>el.getRootState('sceneTheme') === 'light' ? 'sun' : 'sun outline',
        onClick: (ev, el, s)=>{
            const key = 'light';
            el.getRootState().update({
                globalTheme: key,
                sceneTheme: key
            });
            el.getRoot().call('router', window.location.pathname);
            el.getRoot().call('setCookie', 'sceneTheme', key);
            el.getRoot().call('setCookie', 'globalTheme', key);
        }
    },
    extends: 'NavbarButtonSet',
    gap: 'W2'
};

});

parcelRegister("anYOu", function(module, exports) {

$parcel$export(module.exports, "CanvasSearchItem", () => $78fb399fbcc7a9e0$export$1057bd021b8a4b43);
const $78fb399fbcc7a9e0$export$1057bd021b8a4b43 = {
    Icon: {
        color: 'currentColor',
        margin: '- Y1 - -',
        fontWeight: '100',
        name: (el, s)=>({
                components: 'sfComponents',
                pages: 'sfPage',
                functions: 'fnOutline',
                state: 'sfDocument',
                files: 'sfAssets'
            })[s.type],
        opacity: '1',
        fontSize: 'A1'
    },
    Text: {
        text: '{{ key }}',
        margin: '- C - -',
        fontSize: 'A1'
    },
    Flex_Buttons: {
        gap: 'Y1',
        margin: '- - - auto',
        childExtends: [
            'CanvasButton',
            'IconButton'
        ],
        childProps: {
            padding: 'Y'
        },
        Target: {
            if: (el, s)=>el.call('hasType', 'ARTBOARD_TYPES', s.type),
            icon: 'target',
            onClick: (ev, el, s)=>{
                ev.stopPropagation();
                el.call('openArtboardItem', s.type, s.key);
            }
        },
        Open: {
            if: (el, s)=>el.call('hasType', 'ARTBOARD_TYPES', s.type),
            icon: 'arrow up right',
            onClick: (ev, el, s)=>{
                ev.stopPropagation();
                el.call('activateChosen', s.key, s.type);
            }
        },
        OpenCode: {
            if: (el, s)=>el.call('hasType', 'FUNCTION_TYPES', s.type) || el.call('hasType', 'STATE_TYPES', s.type),
            icon: 'code',
            onClick: (ev, el, s)=>{
                ev.stopPropagation();
                el.call('activateFunction', s.key);
            }
        },
        TargetFile: {
            if: (el, s)=>el.call('hasType', 'ASSETS_TYPES', s.type),
            icon: 'target',
            onClick: async (ev, el, s)=>{
                ev.stopPropagation();
                await el.call('setSidebarContent', 'files');
            }
        }
    },
    extends: [
        'KeyValueColumnFields'
    ],
    round: 'C1',
    align: 'center',
    padding: 'X Z X A',
    onClick: (ev, el, s)=>{
        el.call('openItem', s.type, s.key);
        const projectKey = el.getAppKey();
        const recentsKey = projectKey + '_recentSearches';
        const recents = s.parent.recents.filter((r)=>r.key !== s.key);
        recents.unshift(s.parse());
        s.parent.recents = recents;
        const recentsValue = JSON.stringify(s.parent.recents);
        window.localStorage.setItem(recentsKey, recentsValue);
    },
    ':hover': {
        '& svg': {
            opacity: 1
        }
    }
};

});

parcelRegister("fvvzd", function(module, exports) {

$parcel$export(module.exports, "InsertPanel", () => $b4a23cd64b5c63d9$export$344c3c4996334393);
const $b4a23cd64b5c63d9$export$344c3c4996334393 = {
    flow: 'y',
    fontSize: 'Z2',
    padding: 'A+Z Z2',
    gap: 'C',
    overflow: 'hidden auto',
    QuickAddPanel: {},
    Line: {
        margin: '-A -A -Z'
    },
    ImportInInsert: {},
    Line_2: {
        margin: '- -A'
    },
    LibraryFromInsert: {},
    Line_3: {
        margin: '- -A'
    },
    DataSourcesInInsert: {},
    Line_4: {
        margin: '- -A'
    },
    IntegrationsInInsert: {}
};

});

parcelRegister("9L7Qi", function(module, exports) {

$parcel$export(module.exports, "QuickAddPanel", () => $71ae9632b8fdfe8d$export$130c02e5d9ffc2f1);
const $71ae9632b8fdfe8d$export$130c02e5d9ffc2f1 = {
    flow: 'x',
    state: {
        type: 'components'
    },
    tag: 'form',
    flow: 'y',
    gap: 'Z',
    onSubmit: (ev, el, s)=>{
        ev.preventDefault();
        el.call('createItem', s.type, s.key);
    },
    CaptionTitle: {
        Text: {
            text: 'Quick add'
        }
    },
    Flex: {
        gap: 'X',
        margin: '- - - -Z+W',
        Select_action: {
            background: 'none',
            color: 'currentColor',
            padding: 'X Y2',
            width: 'D3',
            onChange: (ev, el, s, ctx)=>{
                const value = ev.target.value;
                if (value) s.update({
                    action: value
                });
            },
            children: [
                {
                    text: 'Create',
                    value: 'create'
                },
                {
                    text: 'Reuse',
                    value: 'reuse'
                },
                {
                    text: 'Duplicate',
                    value: 'duplicate'
                }
            ],
            childrenAs: 'props',
            childProps: {
                tag: 'option',
                attr: {
                    selected: (el, s)=>el.node.value === s.action
                }
            }
        },
        Select_type: {
            background: 'none',
            color: 'currentColor',
            padding: 'X Y2',
            width: 'E+A',
            onChange: (ev, el, s, ctx)=>{
                const value = ev.target.value;
                if (value) s.update({
                    type: value
                });
            },
            children: [
                {
                    text: 'Component',
                    value: 'components'
                },
                {
                    text: 'Page',
                    value: 'pages'
                },
                {
                    text: 'Function',
                    value: 'functions'
                },
                {
                    text: 'Method',
                    value: 'methods'
                },
                {
                    text: 'State',
                    value: 'state'
                },
                {
                    text: 'Dependency',
                    value: 'dependencies'
                }
            ],
            childrenAs: 'props',
            childProps: {
                tag: 'option',
                attr: {
                    selected: (el, s)=>el.node.value === s.action
                }
            }
        },
        FileSidebarAddNewItem: {
            Label: {
                border: 'none',
                '.hasItems': null,
                margin: '0',
                Icon: null,
                Input: {
                    padding: 'Z',
                    attr: {
                        required: true,
                        placeholder: (el, s)=>'Type ' + (s.type === 'pages' ? '/page-path' : s.type === 'components' ? 'ComponentName' : s.type === 'functions' ? 'functionName' : s.type === 'methods' ? 'methodName' : s.type === 'state' ? 'state_name' : s.type === 'secrets' ? 'secret_name' : s.type === 'dependencies' ? '@dep/name' : '') + '...'
                    }
                },
                Flex: {
                    margin: '- - - auto',
                    Save: {
                        extends: 'NavbarButton'
                    },
                    Close: null
                }
            },
            flex: 1
        }
    }
};

});

parcelRegister("1de1n", function(module, exports) {

$parcel$export(module.exports, "EnvItem", () => $0e21e1a46ce4249f$export$a7c8212cbbf10083);
const $0e21e1a46ce4249f$export$a7c8212cbbf10083 = {
    Circle: {
        margin: 'X - -',
        round: 'A',
        boxSize: 'Z',
        isActive: (el)=>el.isActive || el.parent.isActive,
        '.isActive': {
            background: 'green',
            ':hover': null
        },
        '!isActive': {
            background: 'shadow'
        }
    },
    Hgroup: {
        flow: 'y',
        margin: '- B - -',
        gap: 'X',
        H: {
            color: 'title',
            tag: 'span',
            overflow: 'hidden',
            whiteSpace: 'wrap',
            textOverflow: 'anywhere',
            text: 'Production'
        },
        P: {
            margin: '0',
            fontSize: 'Y2',
            fontWeight: '400',
            color: 'paragraph',
            overflow: 'hidden',
            overflowWrap: 'anywhere',
            whiteSpace: 'wrap',
            textOverflow: 'anywhere',
            lineBreak: 'anywhere',
            text: (el)=>`${el.call('getAppKey')}`
        }
    },
    Buttons: {
        hide: (el)=>el.getRootState('tier') === 'starter',
        margin: '-X -X - auto',
        EnvActive: {
            icon: 'checkmark',
            color: 'green'
        },
        childExtends: 'IconButton',
        childProps: {
            theme: 'transparent',
            padding: 'Y'
        }
    },
    Upgrade: {
        extends: 'Link',
        hide: (el)=>el.getRootState('tier') !== 'starter',
        color: 'blue',
        text: 'Upgrade',
        margin: '- - - auto',
        alignSelf: 'start',
        whiteSpace: 'nowrap',
        fontSize: 'Z2',
        lineHeight: 1,
        ':hover': {
            textDecoration: 'underline'
        },
        onClick: (f, el, st)=>{
            el.call('openModal', '/settings', {
                key: '/pricing'
            });
        }
    },
    flow: 'x',
    gap: 'Z',
    round: 'Z2',
    padding: 'Z Z2 Y'
};

});

parcelRegister("lOZjK", function(module, exports) {

$parcel$export(module.exports, "DomainItem", () => $fe2dd4e052ec55bb$export$1acf300af2c00da);
const $fe2dd4e052ec55bb$export$1acf300af2c00da = {
    extends: [
        'Flex'
    ],
    gap: 'Z',
    padding: 'Z Z2 Y',
    round: 'Z2',
    Icon: {
        margin: 'V2 - -',
        name: 'network',
        fontSize: 'A1'
    },
    Hgroup: {
        flow: 'y',
        margin: '- B - -',
        gap: 'X',
        H: {
            color: 'title',
            tag: 'span',
            text: 'Custom domain'
        },
        P: {
            margin: '0',
            fontSize: 'Y2',
            fontWeight: '400',
            color: 'paragraph',
            overflow: 'hidden',
            overflowWrap: 'anywhere',
            whiteSpace: 'wrap',
            textOverflow: 'anywhere',
            lineBreak: 'anywhere',
            text: (el)=>`Connect any domain to your app`
        }
    },
    Buttons: {
        hide: (el)=>el.getRootState('tier') === 'starter',
        margin: '-X -X - auto',
        childExtends: 'IconButton',
        childProps: {
            theme: 'transparent',
            padding: 'Y'
        },
        EnvOpen: {
            icon: 'arrow up right',
            color: 'title'
        }
    },
    Upgrade: {
        extends: 'Link',
        color: 'blue',
        text: 'Upgrade',
        margin: '- - - auto',
        alignSelf: 'start',
        whiteSpace: 'nowrap',
        fontSize: 'Z2',
        lineHeight: 1,
        ':hover': {
            textDecoration: 'underline'
        },
        onClick: (f, el, st)=>{
            el.call('openModal', '/settings', {
                key: '/pricing'
            });
        },
        hide: (el)=>el.getRootState('tier') !== 'starter'
    }
};

});

parcelRegister("in2VU", function(module, exports) {

$parcel$export(module.exports, "DropdownButton", () => $d5fca6637d9ab4e4$export$181f40ec41159e56);
const $d5fca6637d9ab4e4$export$181f40ec41159e56 = {
    extends: [
        'CanvasButton',
        'Flex'
    ],
    round: 'C1',
    align: 'center',
    alignSelf: 'center',
    margin: '- -X2 - -',
    '!isActive': {
        ':hover': {
            '@dark': {
                backgroundColor: 'gray4.5'
            },
            '@light': {
                backgroundColor: 'gray13.5'
            }
        },
        ':active': {
            '@dark': {
                backgroundColor: 'gray4.5'
            },
            '@light': {
                backgroundColor: 'gray13.5'
            }
        }
    },
    Button: {
        extends: [
            'CanvasButton',
            'Button'
        ],
        padding: 'Y Y2 Y Z',
        round: 'C1 0 0 C1',
        lineHeight: 0.9,
        align: 'center',
        gap: 'Y',
        icon: 'play oval',
        text: 'Preview',
        aspectRatio: 'none'
    },
    IconButton: {
        extends: [
            'CanvasButton',
            'IconButton'
        ],
        round: '0 C1 C1 0',
        theme: 'transparent',
        lineHeight: 1,
        padding: 'Y2 Y2 Y2 Y',
        margin: '- - - -X',
        icon: null,
        DropdownArrow: {}
    }
};

});

parcelRegister("8KuMX", function(module, exports) {

$parcel$export(module.exports, "EnvsDropdown", () => $65ea8091edc7de93$export$de9d64fe3a5f6d97);
const $65ea8091edc7de93$export$de9d64fe3a5f6d97 = {
    Envs: {
        flow: 'y',
        gap: 'A',
        CaptionTitle: {
            Text: {
                text: 'Environments'
            }
        },
        Flex: {
            gap: 'A',
            flow: 'y',
            margin: '- -Z2',
            childExtends: 'EnvItem',
            Prod: {
                Hgroup: {
                    H: {
                        text: 'Production'
                    },
                    P: {
                        text: 'Specify production channel'
                    }
                }
            },
            Test: {
                Hgroup: {
                    H: {
                        text: 'Test'
                    },
                    P: {
                        text: 'Specify staging channel'
                    }
                }
            },
            Dev: {
                extends: [
                    'CanvasButton',
                    'EnvItem'
                ],
                isActive: true,
                Circle: {
                    isActive: true
                },
                Hgroup: {
                    H: {
                        text: 'Development'
                    },
                    P: {
                        text: 'Default - set to latest'
                    }
                },
                Buttons: {
                    hide: false
                },
                Upgrade: null
            }
        }
    },
    Line: {
        margin: '-A'
    },
    EnvItem_Local: {
        Hgroup: {
            H: {
                text: 'Local'
            },
            P: {
                text: (el)=>`localhost:1234`
            }
        },
        Upgrade: null,
        Connect: {
            extends: 'Link',
            color: 'title',
            text: 'Connect',
            margin: '- - - auto',
            alignSelf: 'start',
            whiteSpace: 'nowrap',
            fontSize: 'Z2',
            lineHeight: 1,
            ':hover': {
                textDecoration: 'underline'
            },
            onClick: (f, el, st)=>{
                el.call('openModal', '/settings', {
                    key: '/connect'
                });
            }
        },
        margin: '- -Z2'
    },
    Line_2: {
        margin: '-A'
    },
    Domains: {
        flow: 'y',
        gap: 'A',
        CaptionTitle: {
            Text: {
                text: 'Domains'
            }
        },
        Flex: {
            gap: 'A',
            flow: 'y',
            margin: '- -Z2',
            childExtends: 'DomainItem',
            Custom: {
                Hgroup: {
                    H: {
                        text: 'Custom domain'
                    },
                    P: {
                        text: 'Connect any domain to your app'
                    }
                }
            },
            Lookup: {
                Hgroup: {
                    H: {
                        text: 'Find your domain'
                    },
                    P: {
                        text: 'Connect to a new domain'
                    }
                },
                Upgrade: null,
                Icon: {
                    name: 'sf search'
                }
            }
        }
    },
    flow: 'x',
    padding: 'Z1 A',
    flow: 'y',
    gap: 'C',
    textAlign: 'start',
    width: 'G1',
    onClick: null
};

});

parcelRegister("2XANd", function(module, exports) {

$parcel$export(module.exports, "InviteDropdown", () => $227da1b7f0e53fa1$export$eefca90c663865f2);
const $227da1b7f0e53fa1$export$eefca90c663865f2 = {
    state: {},
    ShareSection: {
        flow: 'y',
        gap: 'A',
        CaptionTitle: {
            Text: {
                text: 'New member'
            }
        },
        InviteFormInDropdown: {},
        DomainItem: {
            padding: 'Z -',
            Icon: null,
            Upgrade: null,
            Hgroup: {
                H: {
                    text: 'https://symbols.app/...'
                },
                P: {
                    order: '-1',
                    text: 'Invite by magic link'
                }
            },
            CopyButton: {
                extends: [
                    'CanvasButton',
                    'CopyButton'
                ],
                padding: 'Y2',
                round: 'C1',
                fontSize: 'Z1',
                margin: '-X -Y2 - auto',
                icon: 'copy outline'
            }
        }
    },
    Line: {
        margin: '-Z2 -A'
    },
    MembersInInvite: {},
    Line_2: {
        margin: '-Z2'
    },
    RolePermissionsInInvite: {},
    flow: 'x',
    width: 'G2',
    flow: 'y',
    gap: 'C',
    padding: 'A A2 A2',
    textAlign: 'start',
    onClick: null
};

});

parcelRegister("86Rwz", function(module, exports) {

$parcel$export(module.exports, "ImportInInsert", () => $5e786711fa009f52$export$62438493c234200e);
const $5e786711fa009f52$export$62438493c234200e = {
    flow: 'y',
    gap: 'A',
    CaptionTitle: {
        Text: {
            text: 'Import'
        }
    },
    Flex: {
        gap: 'A',
        flow: 'y',
        margin: '- -Z2',
        childExtends: 'DomainItem',
        childrenAs: 'state',
        childProps: {
            Hgroup: {
                H: {
                    text: '{{ title }}'
                },
                P: {
                    text: '{{ descr }}'
                }
            },
            Icon: {
                name: '{{ icon }}'
            },
            Button: {
                margin: '-Y -Z2 - auto',
                text: 'Connect',
                icon: 'plus oval',
                gap: 'Y1',
                Icon: {
                    order: 2,
                    color: 'blue'
                },
                extends: [
                    'CanvasButton',
                    'Button'
                ],
                padding: 'Y2 Z2',
                fontSize: 'Z2',
                onClick: (ev, el, s)=>s.onAdd?.(el, s)
            },
            align: 'start',
            Upgrade: null
        },
        children: [
            {
                icon: 'globe',
                title: 'Live website',
                descr: 'Open any website and select what to import'
            },
            {
                icon: 'figma',
                title: 'Figma',
                descr: 'Import tokens, layers and artboards'
            },
            {
                icon: 'terminal',
                title: 'Local Files',
                descr: 'Import your local starter-kit using CLI'
            }
        ]
    }
};

});

parcelRegister("QEDx0", function(module, exports) {

$parcel$export(module.exports, "DataSourcesInInsert", () => $09e46106c5878963$export$53a14e1679f3c215);
const $09e46106c5878963$export$53a14e1679f3c215 = {
    flow: 'y',
    gap: 'A',
    CaptionTitle: {
        Text: {
            text: 'Data sources'
        }
    },
    Flex: {
        gap: 'A',
        flow: 'y',
        margin: '- -Z2',
        childExtends: 'IntegrationsItem',
        childrenAs: 'state',
        childProps: {
            Button: {
                text: 'Add'
            }
        },
        children: [
            {
                icon: 'plus',
                title: 'Custom',
                descr: 'Add custom endpoint as data source',
                onConnect: (el, s)=>{},
                onAdd: (el, s)=>{
                    el.setWindow('docs', '/fetch');
                }
            }
        ]
    }
};

});

parcelRegister("67kpU", function(module, exports) {

$parcel$export(module.exports, "IntegrationsInInsert", () => $47433bde785a3ba4$export$2da129bd3ddef0e0);
const $47433bde785a3ba4$export$2da129bd3ddef0e0 = {
    flow: 'y',
    gap: 'A',
    position: 'relative',
    CaptionTitle: {
        Text: {
            text: 'INTEGRATIONS'
        }
    },
    Flex: {
        gap: 'A',
        flow: 'y',
        margin: '- -Z2',
        childExtends: 'IntegrationsItem',
        childrenAs: 'state',
        children: ()=>[
                {
                    icon: 'github',
                    title: 'Github',
                    descr: 'Connect repository and sync changes'
                },
                {
                    icon: 'slack',
                    title: 'Slack',
                    descr: 'Get notifications on important events'
                },
                {
                    icon: 'intercom',
                    title: 'Intercom',
                    descr: 'Add live support on your website'
                },
                {
                    icon: 'Amplitude',
                    title: 'Amplitude',
                    descr: 'Add Amplitude analytics to your website'
                },
                {
                    icon: 'googleAnalytics',
                    title: 'Google Analytics',
                    descr: 'Collect data to your Google Tag dashboard'
                },
                {
                    icon: 'stripe',
                    title: 'Stripe',
                    descr: 'Connect your Stripe payments to your app'
                },
                {
                    icon: 'auth0',
                    title: 'Auth0',
                    descr: 'Connect authorisation to your app'
                },
                {
                    icon: 'googleSheets',
                    title: 'Google Sheets',
                    descr: 'Connect sheets as data source'
                },
                {
                    icon: 'supabase',
                    title: 'Supabase',
                    descr: 'Connect to Supabase endpoint'
                },
                {
                    icon: 'instagram',
                    title: 'Instagram feed',
                    descr: 'Import instagram feed as data'
                },
                {
                    icon: 'npm',
                    title: 'NPM',
                    descr: 'Publish your project as NPM package'
                },
                {
                    icon: 'firebase',
                    title: 'Firebase',
                    descr: 'Connect to Firebase endpoint'
                }
            ].slice(0, 5)
    },
    InsertSectionShadow: {}
};

});

parcelRegister("ermhX", function(module, exports) {

$parcel$export(module.exports, "AssetsFromInsert", () => $a834e05b147dc6e3$export$4f64d3e5927276dc);
const $a834e05b147dc6e3$export$4f64d3e5927276dc = {
    flow: 'y',
    gap: 'Z',
    CaptionTitle: {
        Text: {
            text: 'Assets'
        }
    }
};

});

parcelRegister("d5AWx", function(module, exports) {

$parcel$export(module.exports, "LibraryFromInsert", () => $9878662691b036e9$export$7c58b3dde488193e);
const $9878662691b036e9$export$7c58b3dde488193e = {
    flow: 'y',
    gap: 'Z',
    CaptionTitle: {
        align: 'center',
        Text: {
            text: 'Insert From Library'
        },
        SearchButton: {
            extends: [
                'CanvasButton',
                'IconButton'
            ],
            icon: 'search',
            margin: '- auto - A'
        },
        ExpandButton: {
            extends: [
                'CanvasButton',
                'IconButton'
            ],
            icon: 'expand',
            onClick: (ev, el)=>{
                el.setWindow('explorer', 'insert:library');
            }
        },
        width: '100%'
    }
};

});

parcelRegister("4KRnU", function(module, exports) {

$parcel$export(module.exports, "IconsFromInsert", () => $3764de63027f31a7$export$d854251a925c666a);
const $3764de63027f31a7$export$d854251a925c666a = {
    flow: 'y',
    gap: 'Z',
    position: 'relative',
    CaptionTitle: {
        width: '100%',
        Text: {
            text: 'Icons'
        },
        SearchButton: {
            extends: [
                'CanvasButton',
                'IconButton'
            ],
            icon: 'search',
            margin: '- auto - A'
        },
        ExpandButton: {
            extends: [
                'CanvasButton',
                'IconButton'
            ],
            icon: 'expand',
            onClick: (ev, el)=>{
                el.setWindow('explorer', 'insert:icons');
            }
        },
        align: 'center'
    },
    IconsGroup: {
        limit: 96,
        childProps: {
            padding: 'auto',
            Icon: {
                fontSize: 'A'
            }
        }
    },
    InsertSectionShadow: {}
};

});

parcelRegister("DZnyP", function(module, exports) {

$parcel$export(module.exports, "FontsFromInsert", () => $07834139e6a88304$export$7509b04aaab822ed);
const $07834139e6a88304$export$7509b04aaab822ed = {
    flow: 'y',
    gap: 'Z',
    CaptionTitle: {
        Text: {
            text: 'Fonts'
        }
    }
};

});

parcelRegister("Cb24h", function(module, exports) {

$parcel$export(module.exports, "IconsGroup", () => $072c1b85332e9fae$export$201ed751e2092582);
const $072c1b85332e9fae$export$201ed751e2092582 = {
    extends: 'Grid',
    lazyLoad: true,
    columns: 'repeat(12, 1fr)',
    gap: 'X',
    margin: '- -X2',
    limit: 60,
    data: async (el, s, ctx)=>{
        const res = await fetch('https://assets.symbo.ls/icons/def_icons.json');
        const defIcons = await res.json();
        const data = el.call('arraizeIconsCategory', defIcons);
        return el.call('deepClone', data);
    },
    childExtends: 'IconTemplate',
    childrenAs: 'state',
    children: async (el, s)=>{
        const limit = el.limit;
        const data = s.data || el.data ? await el.call('exec', el.data) : [];
        if (limit) return data.slice(0, limit);
        return data;
    }
};

});

parcelRegister("96D0F", function(module, exports) {

$parcel$export(module.exports, "IconTemplateWithTooltip", () => $6a12ef19f0cefc7b$export$d7a7c0b85237e33d);
const $6a12ef19f0cefc7b$export$d7a7c0b85237e33d = {
    extends: [
        'ClickableItem',
        'Link',
        'IconText',
        'TooltipParent'
    ],
    round: 'X',
    scrollToTop: false,
    aspectRatio: '1 / 1',
    align: 'center center',
    href: (el, s)=>window.location.pathname + '/edit-icon/' + s.key,
    transition: 'A defaultBezier',
    transitionProperty: 'transform, opacity, border-radius',
    theme: null,
    padding: 'A2',
    '& @container (min-width: 50px)': {
        border: '10px solid blue',
        color: 'red !important',
        style: {
            color: 'red !important'
        }
    },
    ':hover': {
        theme: 'secondary',
        transform: 'scale(1.015)',
        '> svg': {
            fontSize: 'E'
        }
    },
    onClick: (event, element, state, ctx)=>{
        element.call('copyStringToClipboard', state.key);
    },
    Icon: {
        transition: 'A defaultBezier font-size',
        fontSize: 'D2',
        src: (el, s)=>s.value
    },
    TooltipHidden: {
        flow: 'x',
        align: 'center',
        shapeDirection: 'top',
        padding: 'X Y1',
        top: '103%',
        pointerEvents: 'auto',
        whiteSpace: 'nowrap',
        minWidth: '0',
        gap: 'X2',
        name: 'copy outline',
        title: (el, s)=>s.key,
        onClick: (event, el, state)=>{
            event.stopImmediatePropagation();
            event.preventDefault();
            el.update({
                Icon: {
                    name: 'checkmark outline'
                }
            });
            const t = setTimeout(()=>{
                el.update({
                    Icon: {
                        name: 'copy outline'
                    }
                });
                clearTimeout(t);
            }, 1000);
            el.call('copyStringToClipboard', state.key);
        },
        P: null,
        Icon: {
            color: 'dim',
            name: 'copy outline'
        }
    }
};

});

parcelRegister("fm7eR", function(module, exports) {

$parcel$export(module.exports, "IconsPanelWidget", () => $b2de8690755205e2$export$30a3b116a1c1069c);
const $b2de8690755205e2$export$30a3b116a1c1069c = {
    extends: '/icons',
    width: '100%',
    SectionHeader: null,
    Flex: {
        childProps: {
            Grid: {
                columns: 'repeat(6, 1fr)',
                fontSize: '',
                childProps: {
                    aspectRatio: '1 / 1',
                    Icon: {
                        fontSize: 'B'
                    },
                    ':hover': {
                        '> svg': {
                            fontSize: 'B'
                        }
                    }
                }
            }
        }
    },
    AddButton: {
        padding: 'Y2',
        order: 3,
        scrollToTop: false,
        href: ()=>window.location.pathname + '/add-icon'
    }
};

});

parcelRegister("1aTYz", function(module, exports) {

$parcel$export(module.exports, "IconTemplate", () => $0db22546320c614a$export$a306f48a7cb235d4);
const $0db22546320c614a$export$a306f48a7cb235d4 = {
    extends: [
        'Flex',
        'CanvasButton'
    ],
    round: 'X',
    aspectRatio: '1 / 1',
    transition: 'A defaultBezier',
    transitionProperty: 'transform, opacity, border-radius',
    padding: 'A2',
    align: 'center center',
    '& @container (min-width: 10px)': {
        border: '10px solid blue',
        color: 'red !important',
        style: {
            color: 'red !important'
        }
    },
    Icon: {
        transition: 'A defaultBezier font-size',
        fontSize: 'D2',
        src: (el, s)=>s.value
    }
};

});

parcelRegister("lFkcY", function(module, exports) {

$parcel$export(module.exports, "IntegrationsItem", () => $fc5d1a38fab754bf$export$bc7349c2edf96a12);
const $fc5d1a38fab754bf$export$bc7349c2edf96a12 = {
    extends: 'DomainItem',
    align: 'start',
    state: {
        icon: 'plus',
        title: 'Custom',
        descr: 'Add custom endpoint as data source'
    },
    Icon: {
        name: '{{ icon }}'
    },
    Hgroup: {
        H: {
            text: '{{ title }}'
        },
        P: {
            text: '{{ descr }}'
        }
    },
    Button: {
        extends: [
            'CanvasButton',
            'Button'
        ],
        margin: '-Y -Z2 - auto',
        icon: 'plus oval',
        text: 'Connect',
        gap: 'Y1',
        padding: 'Y2 Z2',
        fontSize: 'Z2',
        Icon: {
            order: 2,
            color: 'blue'
        },
        onClick: (ev, el, s)=>s.onAdd?.(el, s)
    },
    Upgrade: null
};

});

parcelRegister("gE3gP", function(module, exports) {

$parcel$export(module.exports, "IconsGroupWithCaption", () => $c1e2eb346d017ae1$export$5cfc63c7ff8809ab);
const $c1e2eb346d017ae1$export$5cfc63c7ff8809ab = {
    width: '100%',
    P: {
        margin: '0 - Z2',
        text: '{{ title }}',
        userSelect: 'none',
        color: 'dim',
        fontSize: 'Y',
        textTransform: 'uppercase'
    },
    IconsGroup: {
        if: (el, s)=>Object.keys(s.data).length
    }
};

});

parcelRegister("dNoQ6", function(module, exports) {

$parcel$export(module.exports, "InsertSectionShadow", () => $a0b31e8e2d911e2c$export$8e13aef1de89d1fa);
const $a0b31e8e2d911e2c$export$8e13aef1de89d1fa = {
    position: 'absolute',
    bottom: '0',
    left: '0',
    right: '0',
    height: 'E3',
    background: 'linear-gradient(0deg, var(--theme-common-box-dark-background) 5%, transparent 100%)',
    pointerEvents: 'none'
};

});

parcelRegister("fe3zF", function(module, exports) {

$parcel$export(module.exports, "LibraryNavbar", () => $b15aef93c70f28bf$export$91e08e50e237eb41);
const $b15aef93c70f28bf$export$91e08e50e237eb41 = {
    flow: 'x',
    align: 'center space-between',
    fontSize: 'Z',
    padding: 'Y2',
    top: '0',
    margin: '- -X2',
    border: '0',
    position: 'sticky',
    theme: 'common-box',
    zIndex: 2,
    gap: 'X',
    CanvasSearch: {
        round: 'C1',
        fontSize: 'A1',
        flex: 1,
        Form: {
            Icon: {},
            Input: {
                paddingBlock: 'Z',
                placeholder: 'Search library...',
                onInput: (ev, el, s)=>{
                    s.update({
                        search: el.node.value
                    });
                }
            }
        }
    },
    NavbarButtonSet: {
        gap: 'X2',
        margin: '- - - A2',
        padding: '0',
        Docs: {
            isActive: false,
            title: 'How it works?',
            icon: 'question mark',
            onClick: (ev, el)=>{
                el.setWindow('docs', '/components');
            }
        }
    }
};

});

parcelRegister("jWIUp", function(module, exports) {

$parcel$export(module.exports, "InsertPanelIcons", () => $e856450c96d3a873$export$eb2cbcd06e53f6cf);
const $e856450c96d3a873$export$eb2cbcd06e53f6cf = {
    flow: 'x',
    width: '100%',
    gap: 'C',
    flow: 'y',
    overflowY: 'auto',
    LibraryNavbar: {},
    Flex: {
        flow: 'y',
        gap: 'B',
        IconsGroup: {
            limit: 1000,
            childProps: {
                padding: 'auto',
                Icon: {
                    fontSize: 'A'
                }
            }
        },
        padding: 'A'
    }
};

});

parcelRegister("4HTKo", function(module, exports) {

$parcel$export(module.exports, "TutorialsInLearn", () => $36d66bd87fa040f6$export$152c5f6f7ab62400);
const $36d66bd87fa040f6$export$152c5f6f7ab62400 = {
    flow: 'x',
    state: {
        limit: 5
    },
    tag: 'form',
    flow: 'y',
    align: 'start',
    gap: 'A',
    position: 'relative',
    onSubmit: (ev, el, s)=>{
        ev.preventDefault();
        el.call('createItem', s.type, s.key);
    },
    CaptionTitle: {
        Text: {
            text: 'Video Playlist'
        }
    },
    Flex: {
        flow: 'y',
        gap: 'A',
        margin: '- - - -X',
        childExtends: 'TutorialItemInLearn',
        childrenAs: 'state',
        children: (el, s)=>[
                {
                    title: 'Getting started',
                    descr: 'Getting started with basic landing page',
                    youtubeId: 'jYU0soXY-To',
                    duration: '14:31'
                },
                {
                    title: 'Symbols library',
                    descr: 'Build using Symbols library',
                    youtubeId: '1Vut-DOrfvg',
                    duration: '1:50'
                },
                {
                    title: 'What is Symbols',
                    descr: 'What and how you can use Symbols',
                    youtubeId: 'P_jjCTzS0-w',
                    duration: '1:15'
                },
                {
                    title: 'Navigation',
                    descr: 'Navigating around Symbols',
                    youtubeId: 'rugrjZ6WrDM',
                    duration: '4:25'
                },
                {
                    title: 'Calculator Tutorial',
                    descr: 'Semi-advanced tutorial to show more functionalities',
                    youtubeId: 'dPZCwGEysdI',
                    duration: '5:23'
                },
                {
                    title: 'Building components',
                    descr: 'Learn how to create components and use properties',
                    youtubeId: 'ScXOBnJ6ZIU',
                    duration: '2:31'
                },
                {
                    title: 'Building pages',
                    descr: 'Learn how to create page and relevant properties',
                    youtubeId: '-qWxYRR15DM',
                    duration: '0:56'
                },
                {
                    title: 'Code editor',
                    descr: 'Changing components and seeing code editor',
                    youtubeId: 'W2sEhoLA0Dc',
                    duration: '0:23'
                },
                {
                    title: 'Using Files',
                    descr: 'How to upload and use files',
                    youtubeId: 'P9D8A0258Ro',
                    duration: '1:58'
                },
                {
                    title: 'Using Colors',
                    descr: 'How to use colors, shades and variables',
                    youtubeId: 'i4JuUp39n50',
                    duration: '2:02'
                },
                {
                    title: 'Using Spacing',
                    descr: 'How to use spacing and variables',
                    youtubeId: 'xFgl6jG2yrw',
                    duration: '2:35'
                },
                {
                    title: 'Using Icons',
                    descr: 'How to upload, insert and use icons',
                    youtubeId: 'rPfSew0RGZc',
                    duration: '2:19'
                }
            ].slice(0, s.limit || 30)
    },
    InsertSectionShadow: {
        left: '-C1',
        right: '-C1',
        bottom: 'C1'
    },
    Button: {
        extends: [
            'CanvasButton',
            'Button'
        ],
        zIndex: 2,
        margin: '- - - -Y2',
        icon: (el, s)=>'arrow angle ' + (s.limit === 5 ? 'down' : 'up'),
        text: (el, s)=>(s.limit === 5 ? 'More' : 'Less') + ' videos',
        gap: 'Y1',
        padding: 'Y2 Z2',
        color: 'caption',
        fontSize: 'Z2',
        Icon: {
            order: 2
        },
        onClick: (ev, el, s)=>{
            s.update({
                limit: s.limit === 5 ? 30 : 5
            });
        }
    }
};

});

parcelRegister("bCvwy", function(module, exports) {

$parcel$export(module.exports, "Lottie", () => $875bb25b674b6061$export$eeef939529b18d03);

const $875bb25b674b6061$export$eeef939529b18d03 = {
    src: 'resize.json',
    boxSize: '3.2em',
    onRender: async (el, s)=>{
        const lottie = await (parcelRequire("8FMUv"));
        const Lottie = lottie.default || lottie;
        let src = el.call('exec', el.src, el);
        if (!src) return;
        if (el.call('isString', src) && src.includes('{{')) src = el.call('replaceLiteralsWithObjectFields', src);
        const url = `https://assets.symbo.ls/lottie/${src}`;
        Lottie.loadAnimation({
            container: el.node,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: url
        });
    }
};

});
parcelRegister("8FMUv", function(module, exports) {
module.exports = import("bvqbs").then(()=>parcelRequire('5PFTV'));

});


parcelRegister("1IvMf", function(module, exports) {

$parcel$export(module.exports, "InsertPanelLibrary", () => $14028ccdea351129$export$5683a14ff3cb666a);
const $14028ccdea351129$export$5683a14ff3cb666a = {
    flow: 'x',
    overflow: 'hidden auto',
    flow: 'y',
    gap: 'Z2',
    fontSize: 'Z1',
    width: '100%',
    overflowY: 'auto',
    onEventComplete: async (el, s)=>{
        const elData = el.data;
        el.scope.__cache = {};
        s.replace({
            loading: true
        }, {
            preventListeners: true
        });
        let data;
        if (elData[s.activeLibrary]) data = elData[s.activeLibrary];
        else {
            data = await el.sdk.getProjectByKey(s.activeLibrary);
            elData[s.activeLibrary] = data;
        }
        const exclList = [
            'members',
            'usedByProjects',
            'environments',
            'project',
            'versions'
        ];
        const exclOpts = {
            exclude: [
                'canvas',
                'schema',
                ...exclList
            ]
        };
        const dataExclOpts = {
            exclude: exclList
        };
        const projData = el.call('deepClone', el.getData(), exclOpts);
        data = el.call('deepClone', data, dataExclOpts);
        const defLibrary = 'default.symbo.ls';
        if (s.activeLibrary !== defLibrary) {
            const defData = el.call('deepClone', elData[defLibrary], exclOpts);
            data = el.call('deepMerge', data, defData);
        }
        data = el.call('deepDestringifyFunctions', data);
        // Usage
        const componentsCache = Object.values(data.components);
        el.scope.libraryComponentsCache = componentsCache;
        window.setTimeout(()=>{
            el.scope.__cache = el.call('deepMerge', projData, data);
            s.replace({
                loading: false
            }, {
                preventListeners: true
            });
        }, 350);
    },
    scope: {
        __cache: {}
    },
    state: {
        activeLibrary: 'default.symbo.ls'
    },
    data: {},
    LibraryNavbar: {},
    Nav: {
        flow: 'x',
        gap: 'A',
        childExtends: 'Button',
        padding: 'Z',
        overflow: 'auto hidden',
        minHeight: 'D',
        margin: '-Z2 - -',
        onRender: (el)=>el.update(),
        childProps: {
            text: '{{ title }}',
            padding: 'Y Z',
            isActive: (el, s)=>s.parent.activeLibrary === s.projectPath?.split('/')[1] + '.symbo.ls',
            '.isActive': {
                theme: 'primary'
            },
            '!isActive': {
                theme: 'tertiary'
            },
            onClick: (ev, el, s)=>{
                const activeLibrary = s.projectPath.split('/')[1] + '.symbo.ls';
                s.parent.update({
                    activeLibrary: activeLibrary
                });
            }
        },
        childrenAs: 'state',
        children: (el)=>el.call('getSnippet', 'TEMPLATES_DATA', 'array'),
        align: 'start'
    },
    P: {
        align: 'center',
        textAlign: 'center',
        margin: '-A auto C',
        color: 'placeholder',
        maxWidth: 'F1',
        flow: 'y',
        Lottie: {
            src: 'swipe-right.json',
            fontSize: 'B1',
            margin: '- - -X2'
        },
        Text: {
            text: 'Drag and drop these components to your canvas'
        }
    },
    LoadingGif: {
        hide: (el, s)=>!s.loading
    },
    LibraryRows: {
        padding: 'Z',
        childrenAs: 'state',
        children: (el, s)=>{
            if (!el.scope.__cache.canvas) return;
            const canvasPages = el.scope.__cache.canvas.pages;
            const data = el.scope.__cache.schema.components;
            function unifyComponents(obj) {
                const allComponents = [];
                // Iterate through each key in the object
                for(const key in obj)if (obj[key].components && Array.isArray(obj[key].components)) allComponents.push(...obj[key].components);
                return allComponents;
            }
            const allDefined = unifyComponents(canvasPages);
            const filteredFromOtherPages = Object.keys(data).filter((item)=>!allDefined.includes(item));
            const arr = [
                {
                    title: 'Default',
                    components: filteredFromOtherPages
                }
            ];
            const pages = s.CACHE.canvas.pages;
            const exclPages = [
                'Archive',
                'Working'
            ];
            const pagesArr = Object.keys(pages).filter((item)=>!exclPages.includes(item));
            return arr.concat(pagesArr.map((v)=>pages[v]));
        },
        childProps: {
            CaptionTitle: {
                Text: {
                    text: '{{ title }}'
                }
            },
            Grid: {
                padding: '0',
                gap: 'A',
                margin: 'Z2 -Y -',
                templateColumns: 'repeat(4, 1fr)',
                childExtends: 'ComponentThumbnailIframe',
                childrenAs: 'state',
                children: (el, s)=>{
                    // const components = el.call('getProjectSchema', s.data)
                    const components = s.components.map((v)=>{
                        const data = el.scope.__cache;
                        const schemaItem = data.schema.components[v];
                        const dataItem = data.components[v];
                        return schemaItem && dataItem && {
                            ...schemaItem,
                            value: dataItem
                        };
                    });
                    return components.filter((v)=>v);
                }
            },
            Line: {
                margin: 'B1 -Z1'
            }
        },
        hide: (el, s)=>s.loading
    }
};

});

parcelRegister("crs58", function(module, exports) {

$parcel$export(module.exports, "BoxSizeItem", () => $90edca20dfafd46c$export$31374a5cb71755e3);
const $90edca20dfafd46c$export$31374a5cb71755e3 = {
    Icon: {
        icon: 'gap',
        color: 'gray5',
        boxSize: 'A1 A1'
    },
    SizeUnits: {
        flow: 'column-reverse',
        LetterValue: {
            color: 'white',
            fontSize: 'A1',
            padding: 'X2 X2 0 X2'
        },
        NumberValue: {
            color: 'gray5',
            fontSize: 'Y',
            padding: 'X X2 X2 X2'
        }
    },
    Span: {
        title: 'paragraph',
        text: 'Min',
        fontSize: 'Y',
        alignSelf: 'flex-end',
        margin: '- - -Y -'
    },
    flow: 'x',
    padding: 'Z Y1',
    gap: 'C',
    margin: '-1px'
};

});

parcelRegister("bIWcj", function(module, exports) {

$parcel$export(module.exports, "TutorialItemInLearn", () => $8890f29dd686e125$export$f0a956bb7c98bff8);
const $8890f29dd686e125$export$f0a956bb7c98bff8 = {
    flow: 'x',
    state: {
        title: 'Getting started',
        descr: 'Getting started with basic landing page',
        youtubeId: 'jYU0soXY-To',
        duration: '14:31'
    },
    align: 'stretch',
    padding: '0',
    gap: 'A',
    round: '0',
    overflow: 'visible',
    cursor: 'pointer',
    opacity: '0.8',
    transition: 'A defaultBezier all',
    ':hover': {
        opacity: '1',
        '& .playButton': {
            opacity: '1'
        }
    },
    onClick: (ev, el, s)=>{
        el.call('openModalVideo', `https://www.youtube.com/embed/${s.youtubeId}?controls=1&amp;autoplay=1`);
    },
    Box: {
        position: 'relative',
        width: 'D3',
        Img: {
            display: 'block',
            round: 'Z2',
            position: 'relative',
            width: '100%',
            src: 'https://img.youtube.com/vi/{{ youtubeId }}/hqdefault.jpg'
        },
        Circle: {
            flow: 'x',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            color: 'title',
            Icon: {
                fontSize: 'D',
                name: 'play oval fill'
            }
        }
    },
    Flex: {
        flow: 'y',
        gap: 'W2',
        Strong: {
            text: '{{ title }}'
        },
        Span: {
            whiteSpace: 'nowrap',
            fontWeight: '200',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            text: '{{ descr }}'
        },
        Time: {
            margin: 'auto - -',
            text: '{{ duration }}',
            fontWeight: '200'
        }
    }
};

});

parcelRegister("jnjX4", function(module, exports) {

$parcel$export(module.exports, "DynamicIsland", () => $e1afa44daf60d61e$export$67d0f66cae6d7a87);
const $e1afa44daf60d61e$export$67d0f66cae6d7a87 = {
    state: {
        recents: [],
        recentsIndex: 0,
        default: 'explorer',
        panelMap: {
            onboarding: 'IntroPanel',
            chat: 'AISidebarPanel',
            explorer: 'FilesSidebar',
            'insert:icons': 'InsertPanelIcons',
            'insert:integrations': 'IntegrationsPanel',
            'insert:library': 'InsertPanelLibrary',
            insert: 'InsertPanel',
            learn: 'LearnPanel'
        }
    },
    DynamicNavbar: {},
    content: (el, s)=>{
        const activeWindow = el.getWindow('explorer');
        if (!el.call('isString', activeWindow)) return Boolean(activeWindow) ? {
            extends: s.panelMap[s.default]
        } : {};
        // First try exact match
        if (s.panelMap[activeWindow]) return {
            extends: s.panelMap[activeWindow]
        };
        // Then try prefix match
        for(const key in s.panelMap){
            if (activeWindow.startsWith(key)) return {
                extends: s.panelMap[key]
            };
        }
        return {};
    },
    PromptAI: {
        margin: 'auto - -',
        order: 2,
        hide: true
    },
    flow: 'y',
    gap: '0',
    width: 'G1+B1',
    position: 'absolute',
    overflow: 'hidden',
    top: 'B2+X',
    padding: '0 --canvas-double-gutter',
    left: '--canvas-gutter',
    bottom: '--canvas-gutter',
    round: 'Z2',
    fontSize: 'Z2',
    minWidth: 'G2',
    maxWidth: '50vw',
    minHeight: 'I',
    resize: 'auto',
    borderColor: 'line',
    borderWidth: '1px',
    borderStyle: 'solid',
    theme: 'common-box',
    useAnimations: true,
    '.useAnimations': {
        transition: 'A1 defaultBezier',
        transitionProperty: 'transform, visibility, opacity, width'
    },
    isActive: (el)=>Boolean(el.getWindow('explorer')),
    '.isActive': {
        transform: 'none',
        opacity: 1,
        visibility: 'visible'
    },
    '!isActive': {
        transform: 'translate3d(0, 1.2em, 1px)',
        opacity: 0,
        visibility: 'hidden'
    },
    ':hover .close': {
        opacity: 1
    },
    isInsertActive: (el)=>el.getWindow('explorer') === 'insert',
    '.isInsertActive': {
        width: 'H'
    },
    isIconsActive: (el)=>el.getWindow('explorer') === 'insert:icons',
    '.isIconsActive': {
        width: 'H'
    },
    isLibraryActive: (el)=>el.getWindow('explorer') === 'insert:library',
    '.isLibraryActive': {
        width: 'I'
    },
    onBeforeUpdate: (_, el, s, ctx, opts)=>{
        if (opts.skipRecentsIndexing) return;
        const recents = s.recents || [];
        const recent = recents[0];
        const activeWindow = el.getWindow('explorer');
        if (activeWindow && activeWindow !== recent) recents.unshift(activeWindow);
        s.recents = recents;
        s.recentsIndex = 0;
    // else s.recents = recents
    },
    onRender: (el)=>Boolean(el.getWindow('explorer')) && el.update()
};

});

parcelRegister("4JY2m", function(module, exports) {

$parcel$export(module.exports, "BoxSizeRow", () => $3739ef8443f37e0c$export$e9f8f3e6c705c1c);
const $3739ef8443f37e0c$export$e9f8f3e6c705c1c = {
    Flex: {
        zIndex: 2,
        backgroundColor: 'document-background',
        border: '1px solid gray3',
        round: 'Z1',
        margin: '-1px',
        childProps: {
            ':first-child': {
                border: '.7px dashed gray3',
                round: 'Z1'
            }
        },
        childExtends: 'BoxSizeItem',
        children: [
            {
                SizeUnits: {
                    LetterValue: {},
                    NumberValue: {}
                }
            },
            {
                Icon: {
                    opacity: '0'
                },
                SizeUnits: {
                    LetterValue: {},
                    NumberValue: {}
                },
                Span: {
                    opacity: '0'
                }
            }
        ]
    },
    BoxSizeItem: {
        border: '.7px dashed gray3',
        round: 'Z1',
        margin: '-1px 0 -1px -B',
        padding: 'Z Y1 Z B',
        Icon: {
            opacity: '0'
        },
        SizeUnits: {
            LetterValue: {
                value: (el, s)=>{
                    const type = s.type;
                    const key = `max${type}`;
                    return s[key] && s[key] !== 'none' ? el.call('getLetterValueFromState', 0, key) : '';
                },
                onInput: (ev, el, s)=>{
                    const type = s.type;
                    const key = `max${type}`;
                    el.call('updateLetterStateValue', 0, key);
                }
            },
            NumberValue: {
                value: (el, s)=>{
                    const type = s.type;
                    const key = `max${type}`;
                    return s[key] && s[key] !== 'none' ? el.call('getNumberValueFromState', 0, key) : 'none';
                },
                onInput: (ev, el, s)=>{
                    const type = s.type;
                    const key = `max${type}`;
                    el.call('updateNumberStateValue', 0, key);
                }
            }
        },
        Span: {
            text: 'Max'
        }
    },
    flow: 'x'
};

});

parcelRegister("9Jl2D", function(module, exports) {

$parcel$export(module.exports, "LearnPanel", () => $7158a36fa61a64c4$export$bcddf6d1dc10e1b4);
const $7158a36fa61a64c4$export$bcddf6d1dc10e1b4 = {
    flow: 'y',
    fontSize: 'Z2',
    padding: 'A+Z Z2',
    gap: 'C',
    overflow: 'hidden auto',
    ExamplesInLearn: {},
    Line_1: {
        margin: '- -A'
    },
    TutorialsInLearn: {},
    Line_2: {
        margin: '- -A'
    },
    TutorialsPanel: {},
    Line_3: {
        margin: '- -A'
    },
    LibrariesInLearn: {}
};

});

parcelRegister("iaYUM", function(module, exports) {

$parcel$export(module.exports, "BoxSize", () => $d3b86990deb6db75$export$89a73b2d97ef42d6);
const $d3b86990deb6db75$export$89a73b2d97ef42d6 = {
    Flex: {
        gap: 'B',
        flow: 'y',
        childExtends: 'BoxSizeRow',
        children: [
            {
                type: 'Width'
            },
            {
                type: 'Height'
            }
        ],
        childrenAs: 'state'
    }
};

});

parcelRegister("5tB60", function(module, exports) {

$parcel$export(module.exports, "BoxModelSubGrid", () => $3fcc6fa14de9ee52$export$2ffab48cb1b042f8);
const $3fcc6fa14de9ee52$export$2ffab48cb1b042f8 = {
    border: '.25)',
    extends: 'Grid',
    columns: '4.375em auto 4.375em',
    rows: '4.375em auto 4.375em',
    round: 'A',
    templateAreas: `"x1 t x2"
    "l content r"
    "x3 b x4"`,
    position: 'relative',
    childrenAs: 'props',
    children: [
        {
            boxSize: '100%'
        },
        {
            boxSize: '100%'
        },
        {
            boxSize: '100%'
        },
        {
            boxSize: '100%'
        },
        {
            extends: 'Icon',
            position: 'absolute',
            top: 'Y1',
            left: 'Y1',
            icon: 'paddingColored',
            fontSize: 'A',
            color: '#8B935C'
        },
        {
            extends: 'Icon',
            icon: 'marginColored',
            position: 'absolute',
            top: '-Z1',
            left: '-Z1',
            fontSize: 'A',
            color: 'yellow'
        },
        {
            extends: 'BoxModelAside',
            gridArea: 't',
            SizeUnits: {
                LetterValue: {
                    color: '#8F9959'
                },
                NumberValue: {}
            }
        },
        {
            extends: 'BoxModelAside',
            gridArea: 'r',
            SizeUnits: {
                LetterValue: {
                    color: '#8F9959'
                },
                NumberValue: {}
            }
        },
        {
            extends: 'BoxModelMiddle',
            gridArea: 'content'
        },
        {
            extends: 'BoxModelAside',
            gridArea: 'b',
            SizeUnits: {
                LetterValue: {
                    color: '#8F9959'
                },
                NumberValue: {}
            }
        },
        {
            extends: 'BoxModelAside',
            gridArea: 'l',
            SizeUnits: {
                LetterValue: {
                    color: '#8F9959'
                },
                NumberValue: {}
            }
        }
    ]
};

});

parcelRegister("46S8T", function(module, exports) {

$parcel$export(module.exports, "BoxModelAside", () => $2fe1b8829c723d82$export$a3774f6ebc625341);
const $2fe1b8829c723d82$export$a3774f6ebc625341 = {
    SizeUnits: {},
    flow: 'x',
    align: 'center center',
    height: '100%'
};

});

parcelRegister("3hgoo", function(module, exports) {

$parcel$export(module.exports, "BoxModelMiddle", () => $262facd2e6dd997d$export$21daaad90663c234);
const $262facd2e6dd997d$export$21daaad90663c234 = {
    border: '.25)',
    Flex_lineHeight: {
        position: 'absolute',
        alignSelf: 'flex-start',
        borderLeft: '.4)',
        padding: '- - - Y2',
        height: '70%',
        align: 'center center',
        Icon: {
            icon: 'textLineHeight',
            color: '#3A5A7F'
        }
    },
    SizeUnits: {
        LetterValue: null,
        NumberValue: {
            text: '140%',
            color: '#3A5A7F',
            '::after': '%',
            onInput: (ev, el, s)=>{
                el.call('updateNumberStateValue', 0, 'lineHeight');
            },
            value: (el, s)=>el.call('getNumberValueFromState', 0, 'lineHeight')
        }
    },
    flow: 'column',
    align: 'center center',
    position: 'relative',
    height: 'C1',
    border: 'solid yellow.15',
    borderWidth: '.8px',
    padding: '- - - Y',
    round: 'Y2',
    minWidth: 'E3'
};

});

parcelRegister("itXLY", function(module, exports) {

$parcel$export(module.exports, "BorderRadiusBox", () => $d7494d131d3d7c7a$export$4fea2869a78c52a9);
const $d7494d131d3d7c7a$export$4fea2869a78c52a9 = {
    borderWidth: '.5px',
    round: (_, s)=>`${s.borderStartStartRadius} ${s.borderStartEndRadius} ${s.borderEndEndRadius} ${s.borderEndStartRadius}`,
    borderColor: 'yellow.25',
    borderStyle: 'solid',
    height: '100%',
    onClick: (ev, el, s)=>{
        const getCornerInputs = ()=>{
            const inputs = [
                ...document.querySelectorAll('input[key="NumberValue"]')
            ];
            return inputs.map((input)=>{
                const rect = input.getBoundingClientRect();
                return {
                    el: input,
                    value: input.value,
                    x: rect.left + rect.width / 2,
                    y: rect.top + rect.height / 2
                };
            });
        };
        const corners = getCornerInputs();
        let closest = null;
        let minDist = Infinity;
        for (const c of corners){
            const dx = ev.clientX - c.x;
            const dy = ev.clientY - c.y;
            const dist = Math.sqrt(dx * dx + dy * dy);
            if (dist < minDist) {
                minDist = dist;
                closest = c;
            }
        }
        if (closest) closest.el.select();
    },
    flow: 'x'
};

});

parcelRegister("gJh1a", function(module, exports) {

$parcel$export(module.exports, "QuickAccessInNavbar", () => $c2de0cb5f3c2cc40$export$462f7a846427abac);
const $c2de0cb5f3c2cc40$export$462f7a846427abac = {
    Add: {
        extends: [
            'CanvasButton',
            'Button',
            'DropdownParentFocus'
        ],
        icon: 'sf plus',
        padding: 'Y1 Z Y1 Z1',
        align: 'center',
        gap: 'Y',
        opacity: 1,
        DropdownArrow: {},
        Dropdown: {
            left: '0',
            onClick: ()=>{},
            'Dropdown.QuickAdd': {}
        }
    },
    gap: 'W2',
    align: 'center'
};

});

parcelRegister("efVsG", function(module, exports) {

$parcel$export(module.exports, "BorderRadius", () => $a60f0a1a04340da2$export$41808410d1eaf88a);
const $a60f0a1a04340da2$export$41808410d1eaf88a = {
    extends: 'Grid',
    border: '.25 solid gray6',
    borderWidth: '.5px',
    columns: '4.375em auto 4.375em',
    rows: '5em auto 5em',
    templateAreas: `"bss content bse"
    ". content ."
    "bes content bee"`,
    textAlign: 'center',
    childrenAs: 'props',
    childProps: {
        cursor: 'pointer',
        position: 'relative'
    },
    children: [
        {
            gridArea: 'bss',
            alignContent: 'flex-start',
            SizeUnits: {
                LetterValue: {
                    color: '#85684B',
                    attr: {}
                },
                NumberValue: {
                    attr: {}
                }
            }
        },
        {
            BorderRadiusBox: {},
            gridArea: 'content',
            gridRow: '1 3'
        },
        {
            gridArea: 'bse',
            alignContent: 'flex-start',
            SizeUnits: {
                LetterValue: {
                    color: '#85684B',
                    attr: {}
                },
                NumberValue: {
                    attr: {}
                }
            }
        },
        {
            gridArea: 'bes',
            alignContent: 'flex-end',
            SizeUnits: {
                LetterValue: {
                    color: '#85684B',
                    attr: {}
                },
                NumberValue: {
                    attr: {}
                }
            }
        },
        {
            gridArea: 'bee',
            alignContent: 'flex-end',
            SizeUnits: {
                LetterValue: {
                    color: '#85684B',
                    attr: {}
                },
                NumberValue: {
                    attr: {}
                }
            }
        }
    ]
};

});

parcelRegister("hvbtR", function(module, exports) {

$parcel$export(module.exports, "BoxModel", () => $cbde3cb641c98786$export$d245e7471253a18f);
const $cbde3cb641c98786$export$d245e7471253a18f = {
    extends: 'Grid',
    color: 'gray6',
    fontSize: 'Z',
    border: 'solid yellow.25',
    borderWidth: '.5px',
    position: 'relative',
    round: 'A2',
    overflow: 'hidden',
    columns: '4.375em auto 4.375em',
    rows: '4.375em auto 4.375em',
    templateAreas: `"x1 t x2"
    "l content r"
    "x3 b x4"`,
    align: 'center center',
    textAlign: 'center',
    childProps: {
        cursor: 'pointer',
        position: 'relative'
    },
    childrenAs: 'props',
    children: [
        {
            boxSize: '100%'
        },
        {
            boxSize: '100%'
        },
        {
            boxSize: '100%'
        },
        {
            boxSize: '100%'
        },
        {
            extends: 'BoxModelAside',
            gridArea: 't',
            SizeUnits: {
                LetterValue: {
                    color: '#85684B'
                },
                NumberValue: {}
            }
        },
        {
            extends: 'BoxModelAside',
            gridArea: 'r',
            SizeUnits: {
                LetterValue: {
                    color: '#85684B'
                },
                NumberValue: {}
            }
        },
        {
            extends: 'BoxModelSubGrid',
            gridArea: 'content'
        },
        {
            extends: 'BoxModelAside',
            gridArea: 'b',
            SizeUnits: {
                LetterValue: {
                    color: '#85684B'
                },
                NumberValue: {}
            }
        },
        {
            extends: 'BoxModelAside',
            gridArea: 'l',
            SizeUnits: {
                LetterValue: {
                    color: '#85684B'
                },
                NumberValue: {}
            }
        }
    ]
};

});

parcelRegister("6XBBr", function(module, exports) {

$parcel$export(module.exports, "TutorialsPanelCopy", () => $51156bea4734ec49$export$8f0fecc88b42c6a5);
const $51156bea4734ec49$export$8f0fecc88b42c6a5 = {
    flow: 'x',
    padding: 'A1 Z1',
    flow: 'y',
    gap: 'B2',
    Hgroup: {
        H: {
            fontSize: 'B2',
            margin: '0',
            color: 'title',
            fontWeight: '500',
            text: (el)=>{
                const { name: name, username: username } = el.getRootState();
                return `Hi ${username || name || ''} \u{1F44B}`;
            }
        },
        P: {
            margin: '0',
            fontSize: 'Z2',
            color: 'paragraph',
            text: `Let's run through docs and tutorials...`
        }
    },
    DocsSidebar: {
        top: 'auto',
        padding: '0',
        fontSize: 'Z2',
        childProps: {
            position: 'relative',
            padding: '- 0',
            NumbCaption: {
                Numb: null,
                SquareButton: {
                    padding: 'X'
                }
            },
            ':not(:last-child):after': {
                content: `''`,
                position: 'absolute',
                width: '100%',
                borderStyle: 'solid',
                borderWidth: '1px 0 0 0',
                borderColor: 'line',
                bottom: '-Z2+W'
            }
        }
    }
};

});

parcelRegister("7k3pW", function(module, exports) {

$parcel$export(module.exports, "LibraryItemInLearn", () => $554d0d4b53ad0395$export$74fefb16c05d779b);
const $554d0d4b53ad0395$export$74fefb16c05d779b = {
    extends: [
        'Link',
        'Flex'
    ],
    state: {
        title: 'Default',
        amount: 206,
        poster: 'https://api.symbols.app/core/files/public/68b667ce424350c909ec03f9/download',
        projectPath: 'nikoloza/default'
    },
    align: 'stretch',
    padding: '0',
    gap: 'A',
    round: '0',
    overflow: 'visible',
    cursor: 'pointer',
    opacity: '0.8',
    transition: 'A defaultBezier all',
    ':hover': {
        opacity: '1',
        '& .playButton': {
            opacity: '1'
        }
    },
    href: 'https://symbols.app/{{ projectPath }}',
    target: '_blank',
    Box: {
        position: 'relative',
        width: 'E3',
        Img: {
            display: 'block',
            round: 'Z2',
            position: 'relative',
            width: '100%',
            src: '{{ poster }}'
        }
    },
    Flex: {
        flow: 'y',
        gap: 'W2',
        Strong: {
            text: '{{ title }}'
        },
        Span: {
            whiteSpace: 'nowrap',
            fontWeight: '200',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            text: '{{ projectPath }}'
        },
        Span_2: {
            if: (el, s)=>!!s.amount,
            margin: 'auto - -',
            fontWeight: '100',
            fontSize: 'Z2',
            text: '{{ amount }} resources',
            color: 'paragraph'
        }
    }
};

});

parcelRegister("cGKkd", function(module, exports) {

$parcel$export(module.exports, "LibrariesInLearn", () => $93cd577c4a76b1cf$export$351f0a051f9760f2);
const $93cd577c4a76b1cf$export$351f0a051f9760f2 = {
    flow: 'x',
    state: {
        limit: 5
    },
    tag: 'form',
    flow: 'y',
    align: 'start',
    gap: 'A',
    position: 'relative',
    onSubmit: (ev, el, s)=>{
        ev.preventDefault();
        el.call('createItem', s.type, s.key);
    },
    CaptionTitle: {
        Text: {
            text: 'Open source libraries'
        }
    },
    Flex: {
        flow: 'y',
        gap: 'A',
        margin: '- - - -X',
        childExtends: 'LibraryItemInLearn',
        childrenAs: 'state',
        children: (el, s)=>[
                {
                    poster: 'https://api.symbols.app/core/files/public/68b667ce424350c909ec03f9/download',
                    projectPath: 'nikoloza/default',
                    amount: 206,
                    title: 'Default'
                },
                {
                    poster: 'https://api.symbols.app/core/files/public/68b667c8424350c909ec03d4/download',
                    projectPath: 'nikoloza/ecommerce',
                    amount: 271,
                    title: 'Ecommerce'
                },
                {
                    poster: 'https://api.symbols.app/core/files/public/68b667ac424350c909ec034e/download',
                    projectPath: 'nikoloza/forms',
                    amount: 248,
                    title: 'Forms'
                },
                {
                    poster: 'https://api.symbols.app/core/files/public/68b667c2424350c909ec03a6/download',
                    projectPath: 'nikoloza/ai',
                    amount: 213,
                    title: 'AI'
                },
                {
                    poster: 'https://api.symbols.app/core/files/public/68b667d6424350c909ec0421/download',
                    projectPath: 'nikoloza/web3',
                    amount: 85,
                    title: 'Web3'
                },
                {
                    poster: 'https://api.symbols.app/core/files/public/68b667db424350c909ec044f/download',
                    projectPath: 'nikoloza/content-and-marketing',
                    amount: 275,
                    title: 'Content & Marketing'
                },
                {
                    poster: 'https://api.symbols.app/core/files/public/68b66c9b424350c909ec1f66/download',
                    projectPath: 'nikoloza/docs',
                    amount: 598,
                    title: 'Docs'
                },
                {
                    poster: 'https://api.symbols.app/core/files/public/68b671ef424350c909ec5342/download',
                    projectPath: 'nikoloza/charts',
                    amount: 0,
                    title: 'Charts'
                },
                {
                    poster: 'https://api.symbols.app/core/files/public/68b66bfb424350c909ec1eb4/download',
                    projectPath: 'nikoloza/ui',
                    amount: 0,
                    title: 'No-code'
                },
                {
                    poster: 'https://api.symbols.app/core/files/public/68b672ad424350c909ec544b/download',
                    projectPath: 'nikoloza/cms',
                    amount: 0,
                    title: 'CMS'
                },
                {
                    poster: 'https://api.symbols.app/core/files/public/68b66c19424350c909ec1f0c/download',
                    projectPath: 'nikoloza/code',
                    amount: 0,
                    title: 'Code'
                },
                {
                    poster: 'https://api.symbols.app/core/files/public/68b63fae424350c909ea336e/download',
                    projectPath: 'nikoloza/miscellaneous',
                    amount: 0,
                    title: 'Miscellaneous'
                }
            ].slice(0, s.limit || 30)
    },
    InsertSectionShadow: {
        left: '-C1',
        right: '-C1',
        bottom: 'C'
    },
    Button: {
        extends: [
            'CanvasButton',
            'Button'
        ],
        zIndex: 2,
        margin: '- - - -Y2',
        icon: (el, s)=>'arrow angle ' + (s.limit === 5 ? 'down' : 'up'),
        text: (el, s)=>(s.limit === 5 ? 'More' : 'Less') + ' libraries',
        gap: 'Y1',
        padding: 'Y2 Z2',
        color: 'caption',
        fontSize: 'Z2',
        Icon: {
            order: 2
        },
        onClick: (ev, el, s)=>{
            s.update({
                limit: s.limit === 5 ? 30 : 5
            });
        }
    }
};

});

parcelRegister("5mMZ1", function(module, exports) {

$parcel$export(module.exports, "OnboardingPanel", () => $3e8500e17733acb6$export$a49e45749effe8da);
const $3e8500e17733acb6$export$a49e45749effe8da = {
    flow: 'y',
    gap: 'Z1',
    CaptionTitle: {
        Text: {
            text: 'Quick checklist'
        }
    },
    Flex: {
        flow: 'y',
        gap: 'Z2',
        childExtends: [
            'Flex',
            {}
        ],
        childProps: {
            fontWeight: '400',
            isActive: false,
            isCurrent: false,
            gap: 'Z',
            align: 'center',
            ':hover': {
                textDecoration: 'underline'
            },
            Circle: {
                order: '-1',
                boxSize: 'A',
                border: '1px solid --color-line',
                Icon: {
                    name: 'checkmark'
                }
            },
            Text: {
                '.isDone': {
                    fontWeight: '200',
                    color: 'paragraph',
                    textDecoration: 'line-through'
                }
            }
        },
        childrenAs: 'props',
        children: ()=>[
                {
                    Text: {
                        text: 'Create a component'
                    },
                    isDone: (el)=>Object.keys(el.getSchema('components') || {}).length > 0,
                    onClick: async (ev, el)=>{
                        ev.stopPropagation();
                        await el.call('openModal', '/add-component');
                    }
                },
                {
                    Text: {
                        text: 'Reuse a component'
                    },
                    isDone: (el)=>Object.keys(el.getSchema('components') || {}).length > 1,
                    onClick: async (ev, el)=>{
                        ev.stopPropagation();
                        const componentFound = Object.values(el.getSchema('components'))[0];
                        if (!componentFound?.key) return el.call('openNotification', {
                            title: 'No component to reuse',
                            message: `Please add a component first`,
                            type: 'transparentPattern'
                        });
                        await el.call('openModal', '/add-component', {
                            key: componentFound.key + 'Reused',
                            title: (componentFound.title || componentFound.key) + ' Reused',
                            type: 'components',
                            value: {
                                [componentFound.key]: {}
                            },
                            code: `export default {\n  // Reusable component:\n  ${componentFound.key}: {\n    // Overwrite properties... \n  },\n}`,
                            advanced: true
                        });
                    }
                },
                {
                    Text: {
                        text: 'Create a main page'
                    },
                    isDone: (el)=>(el.getSchema('pages') || {})['/'],
                    onClick: async (ev, el)=>{
                        ev.stopPropagation();
                        await el.call('openModal', '/add-page', {
                            title: 'Main page',
                            key: '/',
                            type: 'pages',
                            value: {
                                '/': {
                                    H1: {
                                        text: 'Hello Symbols'
                                    }
                                }
                            },
                            code: `export default {\n  '/': {\n    H1: { text: 'Hello Symbols' } \n  },\n}`,
                            advanced: true
                        });
                    }
                },
                {
                    Text: {
                        text: 'Open your page'
                    },
                    isDone: (el)=>el.call('getCookie', el.getAppKey() + '_projectRemotePageWasViewed'),
                    onClick: (ev, el)=>{
                        ev.stopPropagation();
                        const pageFound = Object.values(el.getSchema('pages'))[0];
                        if (!pageFound?.key) return el.call('openNotification', {
                            title: 'No page to open',
                            message: `Please add a page first`,
                            type: 'transparentPattern'
                        });
                        const url = `https://${el.getAppKey()}/${pageFound.key}`;
                        window.open(url, 'Symbols preview');
                        el.call('setCookie', el.getAppKey() + '_projectRemotePageWasViewed', true);
                    }
                },
                {
                    Text: {
                        text: 'Import from Library'
                    },
                    // add flag to confirm component was added,
                    isDone: (el)=>Object.keys(el.getSchema('components')).length > 1,
                    onClick: (ev, el)=>{
                        ev.stopPropagation();
                        el.setWindow('explorer', 'insert:library');
                    }
                },
                {
                    Text: {
                        text: 'Upload a logo'
                    },
                    isDone: (el)=>Object.keys(el.getData('files')).length > 0,
                    onClick: async (ev, el)=>{
                        ev.stopPropagation();
                        await el.call('openModal', '/add-file');
                    }
                },
                {
                    Text: {
                        text: 'Add a color'
                    },
                    isDone: (el)=>Object.keys(el.getData('designSystem').color || {}).length > 2,
                    onClick: (ev, el)=>{
                        ev.stopPropagation();
                        el.call('activeAddingFloatingPanel', ev, 'color');
                    }
                },
                // {
                //   Text: {
                //     text: 'Setup a global theme'
                //   },
                //   isDone: el =>
                //     Boolean(
                //       el.getData('designSystem').theme?.document[
                //         '@' + el.call('getSystemGlobalTheme')
                //       ]
                //     ),
                //   onClick: (ev, el) => {
                //     ev.stopPropagation()
                //     el.call('activeAddingFloatingPanel', ev, 'global_theme')
                //   }
                // }
                {
                    Text: {
                        text: 'Publish'
                    },
                    isDone: (el)=>el.call('getCookie', el.getAppKey() + '_projectWasPublished'),
                    onClick: async (ev, el)=>{
                        ev.stopPropagation();
                        await el.call('openModal', '/publish');
                    }
                }
            ]
    }
};

});

parcelRegister("87BOT", function(module, exports) {

$parcel$export(module.exports, "TutorialNotification", () => $0186a67554aa0f70$export$e106eb5586d3fe2c);
const $0186a67554aa0f70$export$e106eb5586d3fe2c = {
    extends: 'Navbar',
    theme: 'canvas-card-glass',
    padding: 'A C+X Z2 Z2',
    overflow: 'hidden',
    align: 'stretch',
    transition: 'all, defaultBezier, B2',
    round: 'Z2',
    state: {
        title: 'Enjoy the canvas',
        descr: 'You are about to experience the canvas experience. Pan and zoom around as you build.',
        icon: 'resize.json'
    },
    Lottie: {
        minWidth: '3.2em',
        src: '{{ icon }}',
        fontSize: 'C2',
        margin: '-A -Y2 - -Z1'
    },
    Hgroup: {
        flex: 1,
        margin: 'auto',
        padding: '- A - -',
        gap: 'Y1',
        lineHeight: 1.4,
        H: {
            tag: 'strong',
            text: '{{ title }}'
        },
        P: {
            text: '{{ descr }}'
        }
    },
    Buttons: {
        flow: 'x',
        align: 'center center',
        flow: 'y',
        borderStyle: 'solid',
        borderColor: 'line',
        borderWidth: '0 0 0 1px',
        height: '100%',
        position: 'absolute',
        top: '0',
        bottom: '0',
        right: '0',
        childExtends: [
            'CanvasButton',
            'IconButton'
        ],
        childProps: {
            round: '0',
            padding: 'A',
            flex: 1,
            ':first-child': {
                borderStyle: 'solid',
                borderColor: 'line',
                borderWidth: '0 0 1px 0'
            }
        },
        children: [
            {
                icon: 'checkmark'
            },
            {
                icon: 'question mark'
            }
        ]
    }
};

});

parcelRegister("9ovw5", function(module, exports) {

$parcel$export(module.exports, "TutorialNotificationStack", () => $6d6ecd7361ebc8a9$export$a33d0eabf7df3757);
const $6d6ecd7361ebc8a9$export$a33d0eabf7df3757 = {
    flow: 'x',
    childExtends: 'TutorialNotification',
    position: 'relative',
    flow: 'y',
    gap: 'X',
    width: 'H',
    childrenAs: 'state',
    useCookie: true,
    children: (el)=>[
            {
                key: 'explainCanvas',
                title: 'Enjoy the canvas',
                descr: 'Dive into your interactive canvas. Pan, zoom, and explore freely as you build.',
                icon: 'resize.json',
                docsArticle: '/canvas-and-editor'
            },
            {
                key: 'explainRealtime',
                title: 'Realtime experience',
                descr: 'You get a free domain for instant sharing, previews, and seamless cross-device testing.',
                icon: 'realtime-move.json',
                docsArticle: '/publish'
            },
            {
                key: 'explainEditingAndNav',
                title: 'Edit your app',
                descr: 'Double-click to open any element. Right-click for contextual actions. Topbar for navigation.',
                icon: 'double-click.json',
                docsArticle: '/building-in-symbols'
            }
        ].filter((v)=>{
            return el.useCookie ? el.call('getCookie', 'tutorialMarked_' + v.key) !== 'true' : true;
        }),
    childProps: {
        ':nth-child(1)': {
            zIndex: 3,
            position: 'relative'
        },
        ':nth-child(2)': {
            pointerEvents: 'none',
            zIndex: 2,
            opacity: 0.9,
            position: 'absolute',
            transform: 'translate3d(0, -0.7em, 0) scale(0.95)'
        },
        ':nth-child(3)': {
            pointerEvents: 'none',
            zIndex: 1,
            opacity: 0.7,
            position: 'absolute',
            transform: 'translate3d(0, -1.2em, 0) scale(0.9)'
        }
    }
};

});

parcelRegister("9tbLW", function(module, exports) {

$parcel$export(module.exports, "IntroPanel", () => $6e4ff43139b6b6cb$export$b9367e9c9a2468a2);
const $6e4ff43139b6b6cb$export$b9367e9c9a2468a2 = {
    flow: 'y',
    fontSize: 'Z1',
    padding: 'A2 A A2',
    gap: 'C',
    overflow: 'hidden auto',
    Hgroup: {
        H: {
            fontSize: 'B2',
            margin: '0',
            color: 'title',
            fontWeight: '500',
            text: (el)=>{
                const { name: name, username: username } = el.getRootState();
                return `Hi ${username || name || ''} \u{1F44B}`;
            }
        },
        P: {
            margin: '0',
            fontSize: 'Z2',
            color: 'paragraph',
            text: 'Welcome to your Symbols canvas! This quick guide will walk you through the basics of your workspace.'
        }
    },
    DragParagraph: {
        fontSize: 'Z1',
        margin: 'Z auto A'
    },
    DragComponentsTutorial: {},
    Line: {
        margin: '0'
    },
    MovingOn: {
        P: {
            color: 'paragraph',
            text: `Let's continue your journey using Symbols`
        },
        Flex: {
            flow: 'y',
            childExtends: 'Flex',
            childProps: {
                align: 'center',
                gap: 'Z',
                padding: 'Z2 W',
                width: '100%',
                transition: 'A defaultBezier padding',
                borderStyle: 'solid',
                borderWidth: '1px 0 0 0',
                color: 'title',
                borderColor: 'line',
                ':hover': {
                    textDecoration: 'underline'
                },
                Icon: {
                    order: '-2',
                    name: 'arrow up right'
                }
            },
            children: [
                {
                    Text: {
                        text: 'My content'
                    }
                },
                {
                    Text: {
                        text: 'Chat with AI'
                    }
                },
                {
                    Text: {
                        text: 'More tutorials'
                    }
                },
                {
                    Text: {
                        text: 'More examples'
                    }
                },
                {
                    Text: {
                        text: 'Library components'
                    }
                },
                {
                    Text: {
                        text: 'My code'
                    }
                },
                {
                    Text: {
                        text: 'Documentation'
                    }
                },
                {
                    Text: {
                        text: 'How to export'
                    }
                },
                {
                    Text: {
                        text: 'Support & Resources'
                    }
                }
            ]
        }
    },
    Dismiss: {
        extends: [
            'CanvasButton',
            'Button'
        ],
        alignSelf: 'start',
        fontSize: 'Z',
        gap: 'X2',
        opacity: '.65',
        margin: '- - - -A',
        padding: 'Z A',
        icon: 'x circle fill',
        text: 'Dismiss onboarding',
        onClick: (ev, el)=>{
            el.call('setCookie', 'tutorialMarked_intro', true);
            el.closeWindow('explorer');
        }
    }
};

});

parcelRegister("ilkYs", function(module, exports) {

$parcel$export(module.exports, "ExampleItemInLearn", () => $d5aa752d3f493f1d$export$ea36d12a85b634f2);
const $d5aa752d3f493f1d$export$ea36d12a85b634f2 = {
    extends: 'LibraryItemInLearn',
    href: null,
    onClick: (ev, el)=>{
        el.setWindow('docs', '/examples');
    },
    state: {
        poster: 'example_clock.png',
        descr: 'Increment and decrement a number.',
        title: 'Counter'
    },
    Box: {
        position: 'relative',
        width: 'E',
        borderColor: 'line',
        borderStyle: 'solid',
        borderWidth: '1px',
        round: 'Z2',
        Img: {
            display: 'block',
            round: 'Z2',
            position: 'relative',
            width: '100%',
            src: '{{ poster }}'
        }
    },
    Flex: {
        Strong: {},
        Span: {
            text: '{{ descr }}'
        },
        Span_2: null
    }
};

});

parcelRegister("d1iag", function(module, exports) {

$parcel$export(module.exports, "ExamplesInLearn", () => $97a97573922817eb$export$91018bcd516f5ecb);
const $97a97573922817eb$export$91018bcd516f5ecb = {
    state: {
        limit: 5
    },
    tag: 'form',
    CaptionTitle: {
        width: '100%',
        align: 'center',
        Text: {
            text: 'Quick examples'
        },
        ExpandButton: {
            extends: [
                'CanvasButton',
                'IconButton'
            ],
            margin: '- - - auto',
            icon: 'expand',
            onClick: (ev, el)=>{
                el.setWindow('docs', '/examples');
            }
        }
    },
    Flex: {
        flow: 'y',
        gap: 'A',
        margin: '- - - -X',
        childExtends: 'ExampleItemInLearn',
        childrenAs: 'state',
        children: (el, s)=>[
                {
                    poster: 'example_counter.png',
                    descr: 'Increment and decrement a number.',
                    title: 'Counter'
                },
                {
                    poster: 'example_conditional.png',
                    descr: 'Show or hide based on state.',
                    title: 'Conditional Rendering'
                },
                {
                    poster: 'example_toggling-state.png',
                    descr: 'Switch a boolean and update UI.',
                    title: 'Toggling State'
                },
                {
                    poster: 'example_fetch.png',
                    descr: 'Fetch data and update state.',
                    title: 'Async Fetch'
                },
                {
                    poster: 'example_form-input.png',
                    descr: 'Capture input and reflect in UI.',
                    title: 'Form Input'
                },
                {
                    poster: 'example_clock.png',
                    descr: 'Auto update every second.',
                    title: 'Clock'
                },
                {
                    poster: 'example_tabs.png',
                    descr: 'Switch content via active state.',
                    title: 'Tabs'
                },
                {
                    poster: 'example_accordion.png',
                    descr: 'Expand and collapse sections.',
                    title: 'Accordion'
                },
                {
                    poster: 'example_progress.png',
                    descr: 'Fill dynamically with state.',
                    title: 'Progress Bar'
                },
                {
                    poster: 'example_dynamic.png',
                    descr: 'Add and remove list items dynamically.',
                    title: 'Dynamic List'
                }
            ].slice(0, s.limit || 30)
    },
    InsertSectionShadow: {
        left: '-C1',
        right: '-C1',
        bottom: 'C'
    },
    Flex_buttons: {
        childExtends: [
            'CanvasButton',
            'Button'
        ],
        margin: '- - - -Y2',
        zIndex: 2,
        Button: {
            icon: (el, s)=>'arrow angle ' + (s.limit === 5 ? 'down' : 'up'),
            text: (el, s)=>(s.limit === 5 ? 'More' : 'Less') + ' examples',
            gap: 'Y1',
            padding: 'Y2 Z2',
            color: 'caption',
            fontSize: 'Z2',
            Icon: {
                order: 2
            },
            onClick: (ev, el, s)=>{
                s.update({
                    limit: s.limit === 5 ? 30 : 5
                });
            }
        }
    },
    flow: 'y',
    align: 'start',
    gap: 'A',
    position: 'relative'
};

});

parcelRegister("kgDNL", function(module, exports) {

$parcel$export(module.exports, "ExtensionCanvasNavbar", () => $ec142d099c8fac2c$export$22941971b7e98993);
const $ec142d099c8fac2c$export$22941971b7e98993 = {
    extends: 'Navbar',
    gap: 'A2',
    round: 'C1',
    padding: 'V Z',
    fontSize: 'Z',
    userSelect: 'none',
    theme: 'common-box',
    LogoDropdown: {},
    Inspects: {
        extends: 'NavbarButtonSet',
        gap: 'X2',
        Inspect: {
            title: 'Inspect element',
            icon: 'sf inspect',
            onClick: (ev, el, s)=>{
                if (window.chrome && window.chrome.runtime) {
                    const extId = window.prompt('What is your extension id?', // 'ohaibdehbmoofjegbepabbkaljahdhac',
                    'lfjlkobjhaemapiegmoceekipkjgapae');
                    window.chrome.runtime.sendMessage(extId, {
                        type: 'toggle_platform_mode'
                    }, (response)=>{
                        console.log('%creceived response', 'color: skyBlue', response);
                        if ('domql' in response) {
                            console.log('%cdomql received', 'color: green');
                            s.update({
                                value: response.domql
                            });
                        }
                    });
                } else console.error('chrome extension not installed');
            }
        },
        AddToCanvasButton: {
            '!value': {
                opacity: 0.35,
                pointerEvents: 'none'
            },
            extends: 'DropdownButton',
            ignoreChildExtends: true,
            ignoreChildExtends: true,
            ignoreChildProps: true,
            Button: {
                icon: 'plus oval',
                fontWeight: 400,
                text: 'Add to canvas',
                aspectRatio: 'none',
                onClick: async (ev, el, s)=>{
                    await el.closeModal();
                    const t = setTimeout(()=>{
                        el.call('openModal', '/add-component', {
                            key: 'ParsedComponent',
                            title: '',
                            type: 'components',
                            value: s.value,
                            advanced: true
                        });
                        clearTimeut(t);
                    }, 500);
                }
            },
            IconButton: {}
        },
        Edit: {
            disabled: true,
            opacity: 0.35,
            pointerEvents: 'none',
            title: 'Edit',
            icon: 'sf pencil',
            onClick: (ev, el, s)=>{}
        },
        Replace: {
            disabled: true,
            opacity: 0.35,
            title: 'Replace',
            icon: 'sf replace',
            onClick: (ev, el, s)=>{},
            pointerEvents: 'none'
        }
    },
    UrlAddressBar: {
        flex: 1
    },
    History: {
        extends: 'NavbarButtonSet',
        gap: 'X2',
        Undo: {
            title: 'Undo',
            icon: 'undo',
            onClick: (ev, el, s)=>{
                el.sdk.undo();
            }
        },
        Redo: {
            title: 'Redo',
            icon: 'redo',
            onClick: (ev, el, s)=>{
                el.sdk.redo();
            }
        },
        History: {
            title: 'History',
            icon: 'sf history',
            onClick: (ev, el, s)=>{
                el.getRootState().toggle('isVersionsOpen', {
                    preventUpdate: true
                });
                el.getVersionsAside()?.update();
            }
        }
    },
    Meta: {
        extends: 'NavbarButtonSet',
        gap: 'W2',
        InNewTab: {
            icon: 'sf arrow up right',
            title: 'In new tab',
            onClick: 'openInNewTab'
        },
        Share: {
            title: 'Share',
            icon: 'sf share',
            onClick: (ev, el, s)=>{},
            Dropdown: {
                left: 'auto',
                right: '-A',
                ShareDropdown: {}
            },
            extends: [
                'CanvasButton',
                'IconButton',
                'DropdownParentFocus'
            ]
        }
    },
    Closing: {
        extends: 'NavbarButtonSet',
        gap: 'W2',
        InNewTab: {
            icon: 'question mark',
            title: 'Help'
        },
        Quetion: {
            title: 'Close',
            icon: 'crossmark',
            onClick: (ev, el, s)=>el.closeModal()
        }
    }
};

});

parcelRegister("fcmwl", function(module, exports) {

$parcel$export(module.exports, "UrlAddressBar", () => $b10972215250e836$export$25e6a8f722a492d1);
const $b10972215250e836$export$25e6a8f722a492d1 = {
    tag: 'search',
    Form: {
        flow: 'x',
        align: 'center',
        gap: 'X',
        margin: '0',
        attr: {
            novalidate: true
        },
        onSubmit: (ev, el, s)=>{
            ev.preventDefault();
            const inputNode = el.Input.node;
            let val = inputNode.value.trim();
            if (!val) {
                inputNode.setCustomValidity('This field is required.');
                inputNode.reportValidity();
                return;
            }
            let finalUrl = val;
            let isValid = false;
            // --- 1. Try to parse as-is (preserves user's http:// or https://) ---
            try {
                const u = new URL(finalUrl);
                if (u.protocol !== 'http:' && u.protocol !== 'https:') throw new Error('Unsupported protocol');
                finalUrl = u.href;
                isValid = true;
            } catch (e) {
                // --- 2. Strip any malformed protocol and rebuild with https:// ---
                // Remove all variations: https://, http://, https:, http:, //, ///
                const cleanDomain = finalUrl.replace(/^(?:https?:?\/+)+/i, '');
                finalUrl = `https://${cleanDomain}`;
                // --- 3. Validate the fixed URL ---
                try {
                    const u = new URL(finalUrl);
                    // Ensure we have a valid hostname
                    if (!u.hostname || !u.hostname.includes('.') && u.hostname !== 'localhost') throw new Error('Invalid hostname');
                    isValid = true;
                    finalUrl = u.href;
                } catch (e2) {
                    inputNode.setCustomValidity('Please enter a valid domain (e.g., google.com)');
                    inputNode.reportValidity();
                    return;
                }
            }
            // --- 4. Submit if valid ---
            if (isValid) {
                inputNode.setCustomValidity('');
                inputNode.value = finalUrl;
                console.log(finalUrl);
                s.update({
                    url: finalUrl
                });
            }
        },
        Icon: {
            fontSize: 'Z1',
            margin: '- -B2 - A',
            name: 'network'
        },
        Input: {
            flex: 1,
            autofocus: 'autofocus',
            round: '0',
            placeholder: 'Type URL to inspect',
            padding: 'Y1 B2 Y1 B2',
            theme: 'transparent',
            outline: 'none',
            name: 'url',
            required: true,
            type: 'text',
            disabled: (el)=>{
                const t = el.call('sameOriginTop');
                return !Boolean(t && t.chrome && t.chrome.runtime);
            },
            appearance: 'none',
            ':focus-visible': {
                outline: 'none'
            },
            '::-webkit-search-cancel-button': {
                display: 'none'
            },
            '::placeholder': {
                color: 'placeholder'
            },
            onInput: (ev, el, s)=>{
                el.node.setCustomValidity('');
                s.quietUpdate({
                    urlPlaceholder: el.node.value
                });
            },
            onBlur: (ev, el, s)=>{
                let v = el.node.value.trim();
                if (v && !/^https?:\/\//i.test(v)) {
                    const clean = v.replace(/^(?:https?:?\/+)+/i, '');
                    if (clean) {
                        el.node.value = `https://${clean}`;
                        s.quietUpdate({
                            urlPlaceholder: el.node.value
                        });
                    }
                }
            }
        }
    },
    VisitedPages: {
        extends: 'Dropdown',
        width: '100%',
        left: '0'
    },
    extends: 'DropdownParentFocus',
    position: 'relative',
    theme: 'quinary',
    round: 'C',
    minWidth: 'D3',
    margin: '-V - - -'
};

});

parcelRegister("4r5iq", function(module, exports) {

$parcel$export(module.exports, "LogoDropdown", () => $33adcac232ccc193$export$bf41e5b326b68de1);
const $33adcac232ccc193$export$bf41e5b326b68de1 = {
    Logo: {
        pointerEvents: 'none',
        position: 'relative',
        top: 'auto',
        left: 'auto',
        style: {
            color: 'currentColor'
        },
        Dropdown: null
    },
    Dropdown: null,
    DropdownArrow: {
        margin: '- W2 - -'
    },
    Dropdown_2: {
        left: '-Z',
        'Dropdown.Logo': {}
    },
    extends: [
        'CanvasButton',
        'DropdownParentFocus'
    ],
    flow: 'x',
    round: 'C1',
    align: 'center',
    padding: 'W'
};

});

parcelRegister("lsqCC", function(module, exports) {

$parcel$export(module.exports, "InstallExt", () => $f9f0dd06e9ecf67f$export$ded4bf9c71b08005);
const $f9f0dd06e9ecf67f$export$ded4bf9c71b08005 = {
    extends: 'ModalWindow',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    background: 'shadow',
    ModalHeader: null,
    IconButton: null,
    Flex: {
        align: 'start',
        gap: 'Z2',
        whiteSpace: 'nowrap',
        Img: {
            src: 'chrome-ext-icon.png',
            width: 'C',
            margin: '-W - - -'
        },
        Hgroup: {
            H: {
                tag: 'strong',
                text: 'Install Chrome extension to allow inspecting'
            },
            P: {
                text: 'Extension is required to gain access to website content'
            },
            gap: 'X'
        }
    },
    Flex_Buttons: {
        align: 'start',
        gap: 'Z',
        childExtends: 'Button',
        margin: '- - - -X',
        fontSize: 'Z2',
        Install: {
            extends: [
                'Link',
                'Button'
            ],
            href: '/docs/chrome-extension',
            target: '_blank',
            text: 'Install',
            theme: 'primary',
            icon: 'arrow up right',
            gap: 'X2',
            Icon: {
                order: 2
            },
            onClick: ()=>{}
        },
        Cancel: {
            text: 'Cancel',
            theme: 'tertiary',
            gap: 'X2',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'line',
            onClick: (ev, el)=>el.closeModal()
        }
    }
};

});

parcelRegister("35xyN", function(module, exports) {

$parcel$export(module.exports, "DashboardNavbar", () => $23fbdf18ecc0a7ba$export$33004ad7afb7afec);
const $23fbdf18ecc0a7ba$export$33004ad7afb7afec = {
    LogoDropdown: {},
    HeaderBreadcrumb: {
        fontSize: 'A',
        margin: '- -A - -',
        Button_username: null,
        Button_project: null
    },
    AddNewButton: {
        extends: [
            'CanvasButton',
            'Button'
        ],
        icon: 'plus',
        padding: 'Z Z2',
        gap: 'X2',
        text: 'New Project',
        aspectRatio: 'none',
        Icon: {
            color: 'blue'
        },
        onClick: async (ev, el)=>{
            await el.call('openModal', '/settings', {
                key: '/onboarding'
            });
        }
    },
    DocsSearchHeader: {
        margin: '- auto'
    },
    ThemesInNavbar: {
        margin: '- A2 - -'
    },
    Avatar: {
        fontSize: 'X',
        onClick: async (ev, el)=>{
            await el.call('openModal', '/settings', {
                key: '/personal-account'
            });
        }
    },
    extends: 'Navbar',
    gap: 'A2',
    round: 'C1',
    padding: 'W Z2',
    fontSize: 'Z1',
    userSelect: 'none',
    theme: 'common-box',
    position: 'sticky',
    top: 'X',
    left: 'X',
    right: 'X',
    zIndex: 9999999
};

});

parcelRegister("2BrES", function(module, exports) {

$parcel$export(module.exports, "CanvasPagesDropdown", () => $1e547dd6e4268ccf$export$d89c380e41f2aa5d);
const $1e547dd6e4268ccf$export$d89c380e41f2aa5d = {
    extends: [
        'CanvasButton',
        'DropdownParentFocus',
        'Button'
    ],
    Text: {
        lineHeight: 0.9,
        width: 'D',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        text: (el)=>el.call('getActiveCanvasPage') || 'Default',
        onMouseover: (ev, el, s)=>{
            if (!s.hover) {
                s.hover = true;
                el.call('setNavbarTooltipPosition', {
                    visible: true
                });
            }
        },
        onMouseleave: (ev, el, s)=>{
            if (s.hover) {
                s.hover = false;
                const Tooltip = el.lookup('NavbarTooltip');
                if (Tooltip) Tooltip.update({
                    opacity: '0',
                    visibility: 'hidden'
                });
            }
        },
        title: 'Selected Canvas'
    },
    Dropdown: {
        left: '0',
        ChooseCanvas: {
            padding: 'X'
        }
    },
    DropdownArrow: {},
    padding: 'Y2 Y2 Y2 Z2',
    align: 'center',
    gap: 'Y',
    aspectRatio: 'none'
};

});

parcelRegister("fd4ub", function(module, exports) {

$parcel$export(module.exports, "EnvsNavbar", () => $b12b8cb36d1bd4ce$export$3fbb5972befe2441);
const $b12b8cb36d1bd4ce$export$3fbb5972befe2441 = {
    extends: [
        'CanvasButton',
        'DropdownParentFocus',
        'Button'
    ],
    padding: 'Y1 Y2 Y1 Z2',
    align: 'center',
    gap: 'Y1',
    margin: '- -Y1',
    lineHeight: 1,
    ConnectionLabel: {
        Circle: {
            boxSize: 'Y1',
            isActive: true,
            position: 'relative',
            isLoading: false,
            animationIterationCount: 'infinite',
            '.isLoading': {
                animation: 'blinking',
                animationDuration: 'G2'
            },
            '!isLoading': {
                animation: null
            },
            onRender: (el, s)=>{
                const handler = ({ origin: origin })=>{
                    if (origin === 'auto') {
                        el.update({
                            isLoading: true
                        });
                        setTimeout(()=>el.update({
                                isLoading: false
                            }), 1000);
                    }
                };
                el.sdk.rootBus.on('checkpoint:done', handler);
            }
        },
        Text: {
            maxWidth: '100%',
            text: (el)=>'development',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            padding: '- - .1em'
        },
        CopyButton: null,
        onMouseover: (ev, el, s)=>{
            if (!s.hover) {
                s.hover = true;
                el.call('setNavbarTooltipPosition', {
                    visible: true
                });
            }
        },
        onMouseleave: (ev, el, s)=>{
            if (s.hover) {
                s.hover = false;
                const Tooltip = el.lookup('NavbarTooltip');
                if (Tooltip) Tooltip.update({
                    opacity: '0',
                    visibility: 'hidden'
                });
            }
        },
        title: 'Environments'
    },
    DropdownArrow: {},
    Dropdown: {
        left: '0',
        onClick: ()=>{},
        'Dropdown.Envs': {}
    }
};

});

parcelRegister("wwOVT", function(module, exports) {

$parcel$export(module.exports, "SharingNavbar", () => $061c72bda9abec68$export$84db5d08a1872df);
const $061c72bda9abec68$export$84db5d08a1872df = {
    extends: 'NavbarButtonSet',
    gap: 'W2',
    PreviewButton: {
        extends: 'DropdownButton',
        ignoreChildExtends: true,
        ignoreChildExtends: true,
        ignoreChildProps: true,
        Button: {
            icon: 'play oval',
            text: null,
            aspectRatio: 'none',
            onClick: (ev, el)=>{
                el.openModal('/browser-preview');
            },
            Icon: {
                color: 'blue'
            }
        },
        IconButton: {
            DropdownParentFocus: {
                position: 'absolute',
                Dropdown: {
                    left: '-D2',
                    onClick: ()=>{},
                    PreviewModesMenu: {}
                },
                inset: '0'
            }
        }
    },
    InNewTab: {
        icon: 'sf arrow up right',
        title: 'In new tab',
        onClick: 'openInNewTab'
    },
    Share: {
        title: 'Share',
        icon: 'sf share',
        Dropdown: {
            left: 'auto',
            right: '-A',
            onClick: (ev, el, s)=>{},
            'Dropdown.Share': {}
        },
        extends: [
            'CanvasButton',
            'IconButton',
            'DropdownParentFocus'
        ]
    }
};

});

parcelRegister("72Jy5", function(module, exports) {

$parcel$export(module.exports, "ActiveSyncInPublish", () => $520c0d5b3f130411$export$b22bb9c2f6852300);
const $520c0d5b3f130411$export$b22bb9c2f6852300 = {
    flow: 'y',
    gap: 'A',
    margin: '- -Z2',
    Website: {
        extends: 'DomainItem',
        Icon: {
            name: 'globe'
        },
        Hgroup: {
            H: {
                text: 'Your website'
            },
            P: {
                text: 'Last version 1.2.1'
            }
        },
        Upgrade: null,
        Span: {
            margin: '- - - auto',
            fontSize: 'Y2',
            text: 'Synced 6 mins ago'
        },
        align: 'start'
    },
    Figma: {
        extends: 'DomainItem',
        Icon: {
            name: 'figma'
        },
        Hgroup: {
            H: {
                text: 'Figma'
            },
            P: {
                text: 'Last version 1.2.1'
            }
        },
        Upgrade: null,
        Span: {
            margin: '- - - auto',
            fontSize: 'Y2',
            text: '6 updates'
        },
        Sync: {
            extends: [
                'CanvasButton',
                'Button'
            ],
            padding: 'Y2 Z2',
            margin: '-Y1 -Z2 - -',
            fontSize: 'Z2',
            text: 'Sync',
            icon: 'syncOvalFill',
            gap: 'Y1',
            Icon: {
                order: 2,
                color: 'blue'
            }
        },
        align: 'start'
    },
    Autosync: {
        extends: 'DomainItem',
        Icon: null,
        Hgroup: {
            H: {
                text: 'Autosync'
            },
            P: {
                text: 'Enable auto syncing during publishing'
            }
        },
        Upgrade: null,
        Toggle: {
            margin: '- - - auto'
        },
        align: 'start'
    }
};

});

parcelRegister("j5OLG", function(module, exports) {

$parcel$export(module.exports, "SyncSuggestionsInPublish", () => $de65dd68cf50ca2e$export$c682921053737a09);
const $de65dd68cf50ca2e$export$c682921053737a09 = {
    flow: 'x',
    gap: 'A',
    flow: 'y',
    margin: '- -Z2',
    childExtends: 'DomainItem',
    childProps: {
        Icon: {
            name: '{{ icon }}'
        },
        Hgroup: {
            H: {
                text: '{{ title }}'
            },
            P: {
                text: '{{ descr }}'
            }
        },
        Upgrade: null,
        Button: {
            extends: [
                'CanvasButton',
                'Button'
            ],
            padding: 'Y2 Z2',
            margin: '-Y -Z2 - auto',
            text: 'Connect',
            icon: 'plus oval',
            gap: 'Y1',
            Icon: {
                order: 2,
                color: 'blue'
            },
            fontSize: 'Z2'
        },
        align: 'start'
    },
    children: [
        {
            icon: 'globe',
            title: 'Your website',
            descr: 'Import tokens, layers and artboards'
        },
        {
            icon: 'figma',
            title: 'Figma',
            descr: 'Import tokens, layers and artboards'
        },
        {
            icon: 'wordpress',
            title: 'Wordpress',
            descr: 'Sync Symbols components'
        },
        {
            icon: 'github',
            title: 'Github',
            descr: 'Sync with your repository'
        }
    ],
    childrenAs: 'state'
};

});

parcelRegister("861fo", function(module, exports) {

$parcel$export(module.exports, "ExportsInPublish", () => $5e4fd9f24e2e46a1$export$15ccd15a29c1f632);
const $5e4fd9f24e2e46a1$export$15ccd15a29c1f632 = {
    flow: 'x',
    gap: 'A',
    flow: 'y',
    margin: '- -Z2',
    childExtends: 'DomainItem',
    childrenAs: 'state',
    childProps: {
        align: 'start',
        Icon: {
            name: '{{ icon }}'
        },
        Hgroup: {
            H: {
                text: '{{ title }}'
            },
            P: {
                text: '{{ descr }}'
            }
        },
        Upgrade: {
            if: (el)=>el.isFree()
        },
        Select: {
            padding: 'X Y2',
            margin: '-W Y2 - auto',
            background: 'none',
            color: 'currentColor',
            onChange: (ev, el, s, ctx)=>{
                const value = ev.target.value;
                if (value) s.update({
                    action: value
                });
            },
            childrenAs: 'props',
            childProps: {
                tag: 'option',
                attr: {
                    selected: (el, s)=>el.node.value === s.action
                }
            },
            if: (el)=>!el.isFree(),
            children: [
                {
                    text: 'CLI'
                },
                {
                    text: 'Zip'
                }
            ]
        },
        IconButton: {
            if: (el)=>!el.isFree(),
            extends: [
                'CanvasButton',
                'Button'
            ],
            padding: 'Y2',
            margin: '-Y -Y2',
            icon: 'downloadOutline',
            gap: 'Y1',
            Icon: {
                order: 2,
                color: 'blue'
            }
        }
    },
    children: [
        {
            icon: 'terminal',
            title: 'Local files',
            descr: 'Download as local Javascript files'
        },
        {
            icon: 'html',
            title: 'HTML',
            descr: 'Download pre-rendered HTML'
        },
        {
            icon: 'jquery',
            title: 'jQuery',
            descr: 'Download files with jQuery runner'
        },
        {
            icon: 'react',
            title: 'React',
            descr: 'Download files with React runner'
        },
        {
            icon: 'sf assets',
            title: 'Webp',
            descr: 'Download files with jQuery runner'
        },
        {
            icon: 'icons',
            title: 'SVG',
            descr: 'Download files with React runner'
        }
    ]
};

});

parcelRegister("55lFJ", function(module, exports) {

$parcel$export(module.exports, "RolePermissionsInInvite", () => $3b3e3b01688a49e5$export$6ce90df9613e7dbd);
const $3b3e3b01688a49e5$export$6ce90df9613e7dbd = {
    flow: 'y',
    gap: 'A',
    CaptionTitle: {
        Text: {
            text: 'Role Permissions'
        }
    },
    Flex: {
        gap: 'A',
        flow: 'y',
        margin: '- -Z2',
        childExtends: 'DomainItem',
        childProps: {
            align: 'start',
            Icon: null,
            Upgrade: null,
            Hgroup: {},
            Select: {
                padding: 'X Y2',
                margin: '-W -Y2 - auto',
                background: 'none',
                color: 'currentColor',
                width: 'D3+Z2',
                onChange: (ev, el, s, ctx)=>{
                    const value = ev.target.value;
                    if (value) s.update({
                        action: value
                    });
                },
                childrenAs: 'props',
                childProps: {
                    tag: 'option',
                    attr: {
                        selected: (el, s)=>el.node.value === s.action
                    }
                }
            }
        },
        Guests: {
            Hgroup: {
                H: {
                    text: 'Guests'
                },
                P: {
                    text: 'Control access level for guests'
                }
            },
            Select: {
                children: [
                    {
                        text: 'Can view'
                    },
                    {
                        text: 'Can comment'
                    }
                ]
            }
        },
        Editors: {
            Hgroup: {
                H: {
                    text: 'Editors'
                },
                P: {
                    text: 'Control access level for editors'
                }
            },
            Select: {
                children: [
                    {
                        text: 'Can edit'
                    },
                    {
                        text: 'Can publish'
                    }
                ]
            }
        }
    }
};

});

parcelRegister("klNm3", function(module, exports) {

$parcel$export(module.exports, "PublishTools", () => $ed0c0da12bac0df4$export$97d4718db6c825d4);
const $ed0c0da12bac0df4$export$97d4718db6c825d4 = {
    flow: 'x',
    gap: 'A',
    flow: 'y',
    margin: '- -Z2',
    childExtends: 'DomainItem',
    Custom: {
        Hgroup: {
            H: {
                text: 'Version 2.0.0'
            },
            P: {
                text: 'Update Major'
            }
        }
    },
    Lookup: {
        Icon: {
            name: 'sf search'
        },
        Hgroup: {
            H: {
                text: 'Version 1.2.0'
            },
            P: {
                text: 'Update Minor'
            }
        }
    },
    Current: {
        Icon: null,
        Hgroup: {
            H: {
                text: (el)=>'Version ' + el.getRootState('version'),
                IconButton: {
                    extends: [
                        'CanvasButton',
                        'IconButton'
                    ],
                    theme: null,
                    padding: 'Y',
                    margin: '- - -Z X',
                    icon: 'search oval dotted',
                    onClick: (ev, el, s)=>{
                        el.getRootState().toggle('isVersionsOpen', {
                            preventUpdate: true
                        });
                        el.getVersionsAside()?.update();
                    }
                }
            },
            P: {
                text: 'Autosaved'
            }
        },
        Upgrade: null,
        Span: {
            margin: '- - - auto',
            text: 'Latest'
        }
    }
};

});

parcelRegister("fFWcD", function(module, exports) {

$parcel$export(module.exports, "MembersInInvite", () => $b697d53c2ed289b6$export$be96fae5728bbc55);
const $b697d53c2ed289b6$export$be96fae5728bbc55 = {
    flow: 'y',
    gap: 'A',
    CaptionTitle: {
        Text: {
            text: 'Members'
        }
    },
    Flex: {
        flow: 'y',
        onInit: async (el)=>{
            const members = await el.call('getProjectMembers');
            el.set({
                membersList: members.map((v)=>({
                        ...v.user,
                        role: v.role
                    }))
            });
        },
        children: (el)=>el.membersList,
        childrenAs: 'state',
        childExtends: 'Flex',
        childProps: {
            align: 'start',
            padding: 'Z1 0',
            gap: 'Z',
            Avatar: {
                boxSize: 'B',
                key: (el, s)=>s.name
            },
            P: {
                margin: '0',
                flex: 1,
                hide: (el, s)=>!s.username,
                text: '{{ username }}'
            },
            Select: {
                padding: 'X Y2',
                margin: '-W -Y2 - auto',
                background: 'none',
                color: 'currentColor',
                width: 'D2',
                onChange: (ev, el, s, ctx)=>{
                    const value = ev.target.value;
                    if (value) s.update({
                        action: value
                    });
                },
                childrenAs: 'props',
                childProps: {
                    tag: 'option',
                    attr: {
                        selected: (el, s)=>{
                            const userRole = s.role || -1;
                            const optionValue = el.value;
                            return userRole === optionValue;
                        }
                    }
                },
                children: [
                    {
                        value: 'guest',
                        text: 'Guest'
                    },
                    {
                        value: 'editor',
                        text: 'Editor'
                    },
                    {
                        value: 'admin',
                        text: 'Admin'
                    }
                ],
                if: (el, s)=>el.isAdmin() && s.role !== 'owner'
            }
        }
    }
};

});

parcelRegister("32mwN", function(module, exports) {

$parcel$export(module.exports, "InviteFormInDropdown", () => $2363089163289daa$export$8a8ae801343d178d);
const $2363089163289daa$export$8a8ae801343d178d = {
    flow: 'x',
    tag: 'form',
    position: 'relative',
    flow: 'y',
    onSubmit: async (ev, el, s)=>{
        ev.preventDefault();
        const { name: name, email: email, role: role } = s;
        const { projectId: projectId } = el.getRootState();
        try {
            if (projectId && email && role) {
                // NOTE: We need to be able to invite both registered and non-registered users
                await el.sdk.inviteMember(projectId, email, role, {
                    name: name,
                    callbackUrl: `${window.location.origin}/accept-invite`
                });
                el.call('openNotification', {
                    title: 'Success message',
                    message: `User '${name || email}' has been successfully invited`,
                    type: 'success'
                });
                el.node.reset();
                s.set({
                    role: 'guest'
                });
            } else el.call('openNotification', {
                title: 'Validation message',
                message: `Please fill in all fields`,
                type: 'warning'
            });
        } catch (err) {
            el.call('openNotification', {
                title: 'Error message',
                message: `${err}`,
                type: 'error'
            });
            console.error(err);
        }
    },
    Input: {
        margin: '- -A1',
        padding: 'Z2 A2 Z2 A2',
        placeholder: 'Type email to invite',
        type: 'email',
        required: true,
        onChange: (ev, el, s, ctx)=>{
            const value = ev.target.value;
            if (value) s.update({
                email: value
            });
        }
    },
    Flex: {
        position: 'absolute',
        top: 'Y+U',
        gap: 'A',
        right: '-Z',
        Select: {
            padding: 'X Y2',
            margin: '-W -Y2 - auto',
            background: 'none',
            color: 'currentColor',
            width: 'D1',
            onChange: (ev, el, s, ctx)=>{
                const value = ev.target.value;
                if (value) s.update({
                    role: value
                });
            },
            childrenAs: 'props',
            childProps: {
                tag: 'option',
                attr: {
                    selected: (el, s)=>el.node.value === s.action
                }
            },
            children: [
                {
                    text: 'Guest',
                    value: 'guest'
                },
                {
                    text: 'Editor',
                    value: 'editor'
                },
                {
                    text: 'Admin',
                    value: 'admin'
                }
            ]
        },
        Copy: {
            extends: [
                'CanvasButton',
                'IconButton'
            ],
            padding: 'Y2',
            round: 'C1',
            icon: 'send',
            Icon: {
                order: 2,
                color: 'blue'
            },
            type: 'submit'
        }
    }
};

});

parcelRegister("3rVEH", function(module, exports) {

$parcel$export(module.exports, "SharingPermissions", () => $28309ddd4ef6e5af$export$7e5858cf954c329c);
const $28309ddd4ef6e5af$export$7e5858cf954c329c = {
    flow: 'y',
    gap: 'A',
    CaptionTitle: {
        Text: {
            text: 'Access Permissions'
        }
    },
    Flex: {
        gap: 'A',
        flow: 'y',
        margin: '- -Z2',
        childExtends: 'DomainItem',
        childProps: {
            align: 'start',
            Icon: null,
            Upgrade: null,
            Hgroup: {},
            Select: {
                padding: 'X Y2',
                margin: '-W -Y2 - auto',
                background: 'none',
                color: 'currentColor',
                width: 'D3+Z2',
                onChange: (ev, el, s, ctx)=>{
                    const value = ev.target.value;
                    if (value) s.update({
                        action: value
                    });
                },
                childrenAs: 'props',
                childProps: {
                    tag: 'option',
                    attr: {
                        selected: (el, s)=>el.node.value === s.action
                    }
                }
            }
        },
        Guests: {
            Hgroup: {
                H: {
                    text: 'Preview visibility'
                },
                P: {
                    text: 'Control access to the preview links'
                }
            },
            Select: {
                children: [
                    {
                        text: 'Public'
                    },
                    {
                        text: 'Password protected'
                    },
                    {
                        text: 'Private'
                    }
                ]
            }
        },
        Editors: {
            Hgroup: {
                H: {
                    text: 'Canvas access'
                },
                P: {
                    text: 'Control access to the canvas'
                }
            },
            Select: {
                children: [
                    {
                        text: 'Public'
                    },
                    {
                        text: 'Unlisted'
                    },
                    {
                        text: 'Private'
                    }
                ]
            }
        }
    }
};

});

parcelRegister("L7ky0", function(module, exports) {

$parcel$export(module.exports, "MembersNavbar", () => $08da1391560fbe39$export$5ebc161896d8e9c7);
const $08da1391560fbe39$export$5ebc161896d8e9c7 = {
    flow: 'x',
    align: 'center',
    ActiveCanvasUsers: {},
    Invite: {
        borderColor: 'line',
        borderWidth: '1px',
        borderStyle: 'solid',
        extends: [
            'IconButton',
            'DropdownParentFocus'
        ],
        margin: '- - - -Z',
        round: 'C1',
        Icon: {
            fontSize: 'Z'
        },
        padding: 'Y+U',
        title: 'Invite Members',
        icon: 'plus',
        theme: 'secondary',
        Dropdown: {
            left: '-F1',
            onClick: ()=>{},
            InviteDropdown: {}
        }
    }
};

});

parcelRegister("jqSKN", function(module, exports) {

$parcel$export(module.exports, "PublishNavbar", () => $e25aeb019deee7fb$export$ce0dc92c408ef861);
const $e25aeb019deee7fb$export$ce0dc92c408ef861 = {
    if: (el)=>el.sdk.hasPermission('editMode'),
    state: {
        modes: {
            publish: {
                icon: 'sf upload',
                text: 'Publish',
                callback: async (el)=>{
                    await el.call('openModal', '/publish');
                }
            },
            sync: {
                icon: 'syncOvalFill',
                text: 'Sync',
                callback: async (el)=>{
                    await el.call('openModal', '/publish');
                }
            },
            export: {
                icon: 'sf download',
                text: 'Export',
                callback: async (el)=>{
                    await el.call('openModal', '/publish');
                }
            }
        },
        activeOutput: 'publish'
    },
    Button: {
        icon: (el, s)=>s.modes[s.activeOutput].icon,
        text: null,
        title: 'Publish',
        aspectRatio: 'none',
        onClick: async (ev, el, s)=>{
            await s.modes[s.activeOutput].callback(el);
        }
    },
    IconButton: {
        DropdownParentFocus: {
            position: 'absolute',
            Dropdown: {
                left: '-F',
                onClick: ()=>{},
                'Dropdown.Publish': {}
            },
            inset: '0'
        }
    },
    extends: 'DropdownButton'
};

});

parcelRegister("gWBsP", function(module, exports) {

$parcel$export(module.exports, "MoreInsertMenu", () => $c55f1faa28ded3b6$export$6ff4b60376c1373a);
const $c55f1faa28ded3b6$export$6ff4b60376c1373a = {
    CaptionTitle: {
        Text: {
            text: 'Insert from'
        },
        color: 'propValue'
    },
    ListInDropdown: {
        margin: '- -Z2',
        gap: '0',
        childProps: {
            padding: 'Z Z2',
            fontSize: 'A',
            round: 'Z2',
            fontWeight: '400',
            color: 'title',
            Text: null,
            Icon: {
                color: 'currentColor',
                opacity: '1',
                margin: '- Y1 - -',
                fontWeight: '100'
            },
            ':hover': {
                '& svg': {
                    opacity: 1
                }
            }
        },
        childrenAs: 'props',
        children: (el)=>[
                {
                    text: 'Live website',
                    Icon: {
                        name: 'globe'
                    },
                    onClick: (ev, el)=>{
                        el.openModal('/browser-extension');
                    }
                },
                {
                    text: 'Local files',
                    Icon: {
                        name: 'terminal'
                    },
                    onClick: (ev, el)=>{
                        el.openModal('/settings', {
                            key: '/install'
                        });
                    }
                }
            ]
    },
    flow: 'y',
    gap: 'Z'
};

});

parcelRegister("cPK7A", function(module, exports) {

$parcel$export(module.exports, "PreviewCanvasNavbar", () => $957e062d9ec614ff$export$95ef4f367d901261);
const $957e062d9ec614ff$export$95ef4f367d901261 = {
    extends: 'Navbar',
    gap: 'A2',
    round: 'C1',
    padding: 'V Z',
    fontSize: 'Z',
    userSelect: 'none',
    theme: 'common-box',
    LogoDropdown: {},
    ComponentAddressBar: {
        flex: 1
    },
    Select: {
        padding: 'X Y2',
        margin: '-W -Y2 - auto',
        background: 'none',
        color: 'currentColor',
        width: 'D3',
        onChange: (ev, el, s, ctx)=>{
            const value = ev.target.value;
            if (value) s.update({
                env: value
            });
        },
        childrenAs: 'props',
        childProps: {
            tag: 'option',
            attr: {
                selected: (el, s)=>el.node.value === s.action
            }
        },
        children: [
            {
                text: 'Production'
            },
            {
                text: 'Development'
            },
            {
                text: 'Staging'
            }
        ]
    },
    Meta: {
        extends: 'NavbarButtonSet',
        gap: 'W2',
        InNewTab: {
            icon: 'sf arrow up right',
            title: 'In new tab',
            onClick: (ev, el, s)=>{
                window.open(s.url);
            },
            '!url': {
                opacity: '.35',
                pointerEvents: 'none'
            }
        },
        Share: {
            title: 'Share',
            icon: 'sf share',
            onClick: (ev, el, s)=>{},
            Dropdown: {
                left: 'auto',
                right: '-A',
                ShareDropdown: {}
            },
            '!url': {
                opacity: '.35',
                pointerEvents: 'none'
            },
            extends: [
                'CanvasButton',
                'IconButton',
                'DropdownParentFocus'
            ]
        },
        Close: {
            title: 'Close',
            icon: 'crossmark',
            onClick: (ev, el, s)=>el.closeModal()
        }
    }
};

});

parcelRegister("bcH7l", function(module, exports) {

$parcel$export(module.exports, "ComponentAddressBar", () => $828242e85380682f$export$a39e9b059c0203e0);
const $828242e85380682f$export$a39e9b059c0203e0 = {
    extends: [
        'DropdownParentFocus'
    ],
    tag: 'search',
    position: 'relative',
    theme: 'quinary',
    round: 'C',
    minWidth: 'D3',
    margin: '-V - - -',
    Form: {
        flow: 'x',
        align: 'center',
        gap: 'X',
        margin: '0',
        attr: {
            novalidate: true
        },
        onSubmit: (ev, el, s)=>{
            ev.preventDefault();
        },
        Icon: {
            fontSize: 'Z1',
            margin: '- -B2 - A',
            name: 'search'
        },
        Input: {
            autofocus: 'autofocus',
            flex: 1,
            round: '0',
            placeholder: 'Search pages and components',
            padding: 'Y1 B2 Y1 B2',
            theme: 'transparent',
            value: '{{ selected }}',
            outline: 'none',
            name: 'url',
            required: true,
            type: 'text',
            appearance: 'none',
            ':focus-visible': {
                outline: 'none'
            },
            '::-webkit-search-cancel-button': {
                display: 'none'
            },
            '::placeholder': {
                color: 'placeholder'
            },
            onInput: (ev, el, s)=>{
                s.update({
                    searchTerm: el.node.value
                });
            }
        }
    },
    CanvasSearchDropdown: {
        ListInDropdown: {
            childProps: {
                Flex_Buttons: null,
                onClick: (ev, el, s)=>{
                    const key = s.key;
                    const type = s.type;
                    s.parent.update({
                        type: type,
                        key: key
                    });
                }
            }
        },
        extends: [
            'CanvasSearchDropdown',
            'Dropdown'
        ],
        width: '100%',
        left: '0',
        typesToIndex: [
            'components',
            'pages'
        ]
    }
};

});

parcelRegister("8DYXu", function(module, exports) {

$parcel$export(module.exports, "DynamicNavbar", () => $64b1405ced1fec15$export$938ef846a8a29382);
const $64b1405ced1fec15$export$938ef846a8a29382 = {
    extends: 'Navbar',
    position: 'sticky',
    top: '0',
    fontSize: 'Y2',
    margin: '- -Y1',
    padding: 'X2 0 0',
    theme: null,
    NavbarButtonSet: {
        width: '100%',
        childProps: {
            padding: 'Y'
        },
        Back: {
            icon: 'arrow angle left',
            hasBack: (el, s)=>{
                return s.recentsIndex < s.recents.length - 1;
            },
            '!hasBack': {
                opacity: '0.35',
                pointerEvents: 'none'
            },
            onClick: (ev, el, s)=>{
                const recents = s.recents;
                s.recentsIndex++;
                const prev = recents?.[s.recentsIndex];
                if (prev) el.setWindow('explorer', prev, {
                    skipRecentsIndexing: true
                });
            }
        },
        Forward: {
            icon: 'arrow angle right',
            hasForward: (el, s)=>{
                return s.recentsIndex > 0;
            },
            '!hasForward': {
                opacity: '0.35',
                pointerEvents: 'none'
            },
            onClick: (ev, el, s)=>{
                const recents = s.recents;
                s.recentsIndex--;
                const next = recents?.[s.recentsIndex];
                if (next) el.setWindow('explorer', next, {
                    skipRecentsIndexing: true
                });
            }
        },
        Close: {
            margin: '- - - auto',
            icon: 'crossmark',
            onClick: (ev, el)=>el.closeWindow('explorer')
        }
    }
};

});

parcelRegister("ljCpr", function(module, exports) {

$parcel$export(module.exports, "TextNavbarButton", () => $f8492a9cc2095c34$export$741fb40eab8e7c74);
const $f8492a9cc2095c34$export$741fb40eab8e7c74 = {
    padding: 'Y1 Z2',
    fontWeight: '400',
    lineHeight: 0.9,
    isActive: (el)=>{
        const explorer = el.getWindow('explorer');
        return explorer?.startsWith?.(el.parent.key || el.key);
    },
    onClick: (ev, el)=>{
        const active = el.parent.key || el.key;
        const explorer = el.getWindow('explorer');
        const isSelected = active === explorer;
        const hasSelected = explorer?.startsWith?.(active);
        const val = isSelected ? null : active;
        el.setWindow('explorer', val);
    },
    text: 'Files',
    key: 'explorer',
    extends: [
        'CanvasButton',
        'Button'
    ]
};

});

parcelRegister("3045l", function(module, exports) {

$parcel$export(module.exports, "MicroNavbar", () => $22f48a71080e722a$export$bbced15ff3692903);
const $22f48a71080e722a$export$bbced15ff3692903 = {
    fontSize: 'Y1',
    background: 'none',
    backdropFilter: 'none'
};

});

parcelRegister("8aUQh", function(module, exports) {

$parcel$export(module.exports, "TextNavbarButtonDropdown", () => $5f3b599b22a3db3e$export$d6cfbf32f5d6e745);
const $5f3b599b22a3db3e$export$d6cfbf32f5d6e745 = {
    key: 'insert',
    isActive: (el)=>{
        const explorer = el.getWindow('explorer');
        return explorer?.startsWith?.(el.key);
    },
    '.isActive': {
        '@dark': {
            color: 'white',
            backgroundColor: 'gray5'
        },
        '@light': {
            color: 'black',
            backgroundColor: 'gray11'
        },
        ':hover': {
            '@dark': {
                backgroundColor: 'gray5.9'
            },
            '@light': {
                backgroundColor: 'gray12.95'
            }
        }
    },
    Button: {
        extends: 'TextNavbarButton',
        text: 'Insert',
        icon: null,
        isActive: null,
        padding: 'Y2 Y1 Y2 Z2'
    },
    IconButton: {
        padding: 'Z Y2 Z Y',
        DropdownParentFocus: {
            inset: '0',
            position: 'absolute',
            Dropdown: {
                left: '-D2',
                onClick: ()=>{},
                theme: 'common-box'
            }
        }
    },
    extends: 'DropdownButton'
};

});

parcelRegister("3pSDo", function(module, exports) {

$parcel$export(module.exports, "EditNavbarCopy", () => $27ce16255c4277de$export$c7eb25e5a1ecc7f5);
const $27ce16255c4277de$export$c7eb25e5a1ecc7f5 = {
    extends: 'Navbar',
    position: 'sticky',
    top: '0',
    width: '100%',
    fontSize: '1rem',
    padding: 'W X W Z2',
    round: 'Z Z 0 0',
    onDblclick: (ev, el)=>{
        el.getRootState().codeMinimized = !el.getRootState().codeMinimized;
    },
    NavbarButtonSet_title: {
        padding: '0',
        Text: {
            ignoreChildExtends: true,
            text: '{{ key }}'
        },
        CopyButton: {
            title: 'Copy title',
            value: (el, s)=>s.parent.key
        }
    },
    EditorTools: {
        hide: true,
        margin: '- auto - C3',
        color: 'dim',
        fontSize: 'Z1'
    },
    NavbarButtonSet_meta: {
        class: 'close',
        opacity: '0',
        padding: '0',
        gap: '0',
        Que: {
            title: 'Documentation',
            icon: 'questionMark',
            isActive: false,
            margin: '- - - auto',
            onClick: (ev, el)=>{
                el.setWindow('docs', '/properties');
            }
        },
        Close: {
            title: 'Close',
            icon: 'crossmark',
            isActive: false,
            margin: '- - - X',
            onClick: (ev, el)=>{
                el.closeWindow('componentEditor');
            }
        }
    }
};

});

parcelRegister("6eXSl", function(module, exports) {

$parcel$export(module.exports, "PreviewModesMenu", () => $48b27eebb7d328d0$export$79df570625663578);
const $48b27eebb7d328d0$export$79df570625663578 = {
    flow: 'y',
    gap: 'A',
    theme: 'navbar',
    padding: 'Y1 Z2',
    ListInDropdown_themes: {
        margin: '- -Z2',
        gap: '0',
        childProps: {
            ':hover': {
                '& svg': {
                    opacity: 1
                }
            },
            padding: 'Z Z2',
            fontSize: 'A',
            fontWeight: '400',
            round: 'Z2',
            Text: null,
            color: 'title',
            Icon: {
                color: 'currentColor',
                opacity: '1',
                margin: '- Y1 - -',
                fontWeight: '100'
            }
        },
        childrenAs: 'props',
        children: (el)=>[
                {
                    text: 'Open in new tab',
                    Icon: {
                        name: 'arrow up right'
                    },
                    onClick: 'openInNewTab'
                },
                {
                    text: 'Local render',
                    Icon: {
                        name: 'playOvalDotted'
                    },
                    onClick: (ev, el, s)=>{
                        el.openModal('/browser-preview');
                    }
                },
                {
                    text: 'Remote preview',
                    Icon: {
                        name: 'network'
                    },
                    onClick: (ev, el, s)=>{
                        el.openModal('/browser-preview');
                    }
                }
            ]
    }
};

});

parcelRegister("9Fbsm", function(module, exports) {

$parcel$export(module.exports, "TutorialGifsNotificationStack", () => $7090d466efc2a11e$export$c0a4ae70da3eb869);
const $7090d466efc2a11e$export$c0a4ae70da3eb869 = {
    flow: 'x',
    childExtends: 'TutorialGifNotification',
    position: 'relative',
    flow: 'y',
    gap: 'X',
    width: 'H2',
    childrenAs: 'state',
    children: [
        {
            key: 'explainCanvas',
            title: 'Move around and zoom canvas',
            descr: 'Dive into your interactive canvas. Pan, zoom, and explore freely as you build.',
            src: 'intro.gif',
            docsArticle: '/canvas-and-editor'
        },
        {
            key: 'explainRealtime',
            title: 'Realtime experience',
            descr: 'You get a free domain for instant sharing, previews, and seamless cross-device testing.',
            src: 'realtime.gif',
            docsArticle: '/publish'
        },
        {
            key: 'explainEditingAndNav',
            title: 'Edit your app',
            descr: 'Double-click to open any element. Right-click for contextual actions. Topbar for navigation.',
            icon: 'double-click.json',
            src: 'editor.gif',
            docsArticle: '/building-in-symbols',
            callback: (el, s)=>{
                el.setWindow('explorer', 'onboarding');
            }
        }
    ],
    childProps: {
        ':nth-child(3)': {
            pointerEvents: 'none',
            zIndex: 1,
            opacity: 0.7,
            position: 'absolute',
            transform: 'translate3d(0, -1.2em, 0) scale(0.9)'
        },
        ':nth-child(2)': {
            pointerEvents: 'none',
            zIndex: 2,
            opacity: 0.9,
            position: 'absolute',
            transform: 'translate3d(0, -0.7em, 0) scale(0.95)'
        },
        ':nth-child(1)': {
            position: 'relative',
            zIndex: 3
        }
    }
};

});

parcelRegister("81u68", function(module, exports) {

$parcel$export(module.exports, "TutorialGifNotification", () => $5d75c38a05c63dc1$export$c570c7295be03d26);
const $5d75c38a05c63dc1$export$c570c7295be03d26 = {
    extends: 'Navbar',
    theme: 'canvas-card-glass',
    padding: '0',
    overflow: 'hidden',
    align: 'stretch',
    transition: 'all, defaultBezier, B2',
    round: 'Z2',
    gap: 'A',
    flow: 'y',
    width: '100%',
    borderColor: 'line-highlight',
    maxWidth: 'H2',
    rootSlide: true,
    useCookie: true,
    if: (el, s)=>{
        const preventByCookie = el.call('getCookie', 'tutorialMarked_' + s.key) === 'true';
        return el.useCookie ? !preventByCookie : true;
    },
    state: {
        title: 'Move around and zoom canvas',
        descr: 'Dive into your interactive canvas. Pan, zoom, and explore freely as you build.',
        src: 'intro.gif'
    },
    Img: {
        minWidth: '3.2em',
        src: '{{ src }}',
        fontSize: 'C2'
    },
    Hgroup: {
        flex: 1,
        margin: 'auto',
        padding: 'Z B A',
        gap: 'Y1',
        lineHeight: 1.4,
        width: '100%',
        H: {
            tag: 'strong',
            text: '{{ title }}'
        },
        P: {
            text: '{{ descr }}'
        }
    },
    TutorialNotificationButtons: {}
};

});

parcelRegister("kMHQ7", function(module, exports) {

$parcel$export(module.exports, "DragParagraph", () => $f21a4bf73346fa7d$export$ce3c911421d2fb76);
const $f21a4bf73346fa7d$export$ce3c911421d2fb76 = {
    align: 'center',
    textAlign: 'center',
    margin: '- auto',
    color: 'placeholder',
    maxWidth: 'F1',
    flow: 'y',
    Lottie: {
        src: 'swipe-right.json',
        fontSize: 'B1',
        margin: '- - -X2'
    },
    Text: {
        text: 'Drag and drop these components to your canvas'
    }
};

});

parcelRegister("02Izr", function(module, exports) {

$parcel$export(module.exports, "DragComponentsTutorial", () => $0082c2cbecb279b1$export$67274c180e682c4);
const $0082c2cbecb279b1$export$67274c180e682c4 = {
    scope: {
        __scope: {
            pages: {
                '/': {
                    align: 'center',
                    boxSize: '100%',
                    width: 'G+F',
                    Window: {
                        margin: 'auto',
                        round: 'Z2',
                        border: '1px solid gray',
                        HelloWorld: {},
                        Hr: {
                            borderColor: 'gray',
                            margin: '0'
                        },
                        ConfirmButtons: {}
                    }
                }
            },
            components: {
                ConfirmButtons: {
                    flow: 'x',
                    align: 'stretch space-around',
                    childProps: {
                        flex: 1,
                        textAlign: 'center',
                        padding: 'Z2',
                        ':hover': {
                            background: 'gray.35'
                        }
                    },
                    Link: {
                        extends: [
                            'Link',
                            'IconText'
                        ],
                        text: 'About me',
                        theme: 'transparent',
                        gap: 'X2',
                        icon: 'check',
                        Icon: {
                            color: 'green'
                        }
                    },
                    Link_contact: {
                        text: 'Contact',
                        href: '#contact'
                    }
                },
                HelloWorld: {
                    padding: 'B',
                    Flex: {
                        gap: 'A',
                        H4: {
                            text: "\uD83C\uDF00",
                            order: '-1'
                        },
                        Hgroup: {
                            H: {
                                text: 'Hello World'
                            },
                            P: {
                                text: 'This is example paragraph page that shows you how cool is Symbols'
                            }
                        }
                    }
                }
            }
        }
    },
    flow: 'y',
    childProps: {
        margin: '- - B',
        P: {
            margin: '0 0 X2'
        },
        ComponentThumbnailIframe: {
            margin: '- -Y1',
            height: 'F1',
            background: 'shadow',
            round: 'B'
        }
    },
    children: [
        {
            P: {
                text: '1. Add this component first'
            },
            ComponentThumbnailIframe: {
                state: {
                    key: 'HelloWorld',
                    title: 'Hello World',
                    type: 'components',
                    settings: {
                        gridOptions: {}
                    },
                    code: `export default {
  padding: 'B',

  Flex: {
  gap: 'A',

  H4: {
    text: '\u{1F300}',
    order: -1
  },
  Hgroup: {
    H: {
      text: 'Hello World',
    },
    P: {
      text: 'This is example paragraph page that shows you how cool is Symbols',
    },
  }
  }
}`,
                    uses: [
                        'Flex',
                        'H4',
                        'Hgroup',
                        'H',
                        'P'
                    ],
                    error: null,
                    value: {
                        padding: 'B',
                        Flex: {
                            gap: 'A',
                            H4: {
                                text: "\uD83C\uDF00",
                                order: '-1'
                            },
                            Hgroup: {
                                H: {
                                    text: 'Hello World'
                                },
                                P: {
                                    text: 'This is example paragraph page that shows you how cool is Symbols'
                                }
                            }
                        }
                    }
                }
            }
        },
        {
            P: {
                text: '2. Add this next'
            },
            ComponentThumbnailIframe: {
                state: {
                    key: 'ConfirmButtons',
                    title: 'Confirm Buttons',
                    type: 'components',
                    settings: {
                        gridOptions: {}
                    },
                    code: `export default {
  flow: 'x',
  align: 'stretch space-around',

  childProps: {
  flex: 1,
  textAlign: 'center',
  padding: 'Z2',
  ':hover': {
    background: 'gray.35',
  }
  },

  Link: {
  extends: ['Link', 'IconText'],
  text: 'About me',
  theme: 'transparent',
  gap: 'X2',
  icon: 'check',
  Icon: {
    color: 'green'
  }
  },

  Link_contact: {
  text: 'Contact',
  href: '#contact'
  },
}`,
                    uses: [
                        'Flex',
                        'Link',
                        'IconText',
                        'Icon'
                    ],
                    value: {
                        flow: 'x',
                        align: 'stretch space-around',
                        childProps: {
                            flex: 1,
                            textAlign: 'center',
                            padding: 'Z2',
                            ':hover': {
                                background: 'gray.35'
                            }
                        },
                        Link: {
                            extends: [
                                'Link',
                                'IconText'
                            ],
                            text: 'About me',
                            theme: 'transparent',
                            gap: 'X2',
                            icon: 'check',
                            Icon: {
                                color: 'green'
                            }
                        },
                        Link_contact: {
                            text: 'Contact',
                            href: '#contact'
                        }
                    }
                }
            }
        },
        {
            P: {
                text: '3. Now, lets add the page'
            },
            ComponentThumbnailIframe: {
                state: {
                    key: '/',
                    type: 'pages',
                    settings: {
                        gridOptions: {}
                    },
                    code: `export default {
  flow: 'x',
  align: 'center',
  boxSize: '100%',
  width: 'G+F',

  Window: {
  margin: 'auto',
  round: 'Z2',
  border: '1px solid gray',

  HelloWorld: {},

  Hr: {
    borderColor: 'gray',
    margin: '0'
  },

  ConfirmButtons: {}
  }
}`,
                    uses: [
                        'Flex',
                        'Window',
                        'HelloWorld',
                        'Hr',
                        'ConfirmButtons'
                    ],
                    value: {
                        flow: 'x',
                        align: 'center',
                        boxSize: '100%',
                        width: 'G+F',
                        Window: {
                            margin: 'auto',
                            round: 'Z2',
                            border: '1px solid gray',
                            HelloWorld: {},
                            Hr: {
                                borderColor: 'gray',
                                margin: '0'
                            },
                            ConfirmButtons: {}
                        }
                    }
                }
            }
        }
    ]
};

});

parcelRegister("2Zkcw", function(module, exports) {

$parcel$export(module.exports, "EditInNavbarMenu", () => $22d0f2c782fc2315$export$da905cf9b153f6ba);
const $22d0f2c782fc2315$export$da905cf9b153f6ba = {
    ListInDropdown: {
        margin: '- -Z2',
        gap: '0',
        childProps: {
            ':hover': {
                '& svg': {
                    opacity: 1
                }
            },
            padding: 'Z Z2',
            fontSize: 'A',
            fontWeight: '400',
            round: 'Z2',
            Text: null,
            color: 'title',
            Icon: {
                color: 'currentColor',
                opacity: '1',
                order: '-1',
                margin: '- Y1 - -',
                fontWeight: '100'
            }
        },
        childrenAs: 'props',
        children: (el)=>[
                {
                    text: 'Open in Editor',
                    Icon: {
                        name: 'playOvalDotted'
                    },
                    onClick: (ev, el, s)=>{
                        el.setCanvasScope({
                            editorActive: true,
                            preferredEditor: 'editor'
                        });
                    }
                },
                {
                    text: 'Edit in Code',
                    Icon: {
                        name: 'code'
                    },
                    onClick: (ev, el, s)=>{
                        if (el.getWindow('componentEditor') === 'code') el.closeWindow('componentEditor');
                        else el.setWindow('componentEditor', 'code');
                        el.setCanvasScope({
                            preferredEditor: 'code'
                        });
                    }
                },
                {
                    text: 'Open in Sidebar',
                    Icon: {
                        name: 'sidebarLeftFill'
                    },
                    onClick: async (ev, el, s)=>{
                        if (el.getWindow('explorer') !== 'explorer') await el.setWindow('explorer', 'explorer');
                        setTimeout(()=>{
                            const itemFound = el.call('findFileSidebarItem', s.type, s.key);
                            itemFound?.state?.update({
                                showLayers: true
                            });
                        }, 350);
                        el.setCanvasScope({
                            preferredEditor: 'sidebar'
                        });
                    }
                }
            ]
    },
    flow: 'y',
    gap: 'A',
    theme: 'navbar',
    padding: 'Y Z1',
    onClick: (ev, el)=>{
        el.lookup('TextNavbarButtonDropdown').update();
    }
};

});

parcelRegister("dmC3K", function(module, exports) {

$parcel$export(module.exports, "IntegrationsPanel", () => $9baada42113f2631$export$9ce8cb617ed70d0f);
const $9baada42113f2631$export$9ce8cb617ed70d0f = {
    flow: 'y',
    fontSize: 'Z2',
    padding: 'A+Z Z2',
    gap: 'C',
    overflow: 'hidden auto',
    ImportInInsert: {},
    Line_3: {
        margin: '- -A'
    },
    DataSourcesInInsert: {},
    Line_4: {
        margin: '- -A'
    },
    IntegrationsInInsert: {}
};

});

parcelRegister("g9DKZ", function(module, exports) {

$parcel$export(module.exports, "QuickAddDropdownCopy", () => $bc2c538389dd2d8d$export$f34a0a16744815a0);
const $bc2c538389dd2d8d$export$f34a0a16744815a0 = {
    state: {},
    QuickAddMenu: {
        CaptionTitle: {
            margin: '- - Z',
            Text: {
                text: 'Quick add'
            }
        },
        ListInDropdown: {
            margin: '- -Z2',
            gap: '-',
            childProps: {
                ':hover': {
                    '& svg': {
                        opacity: 1
                    }
                },
                padding: 'Z Z2',
                fontSize: 'A',
                gap: 'X',
                fontWeight: '400',
                round: 'Z2',
                Text: null,
                color: 'title',
                Icon: {
                    color: 'currentColor',
                    opacity: '1',
                    margin: '0',
                    fontWeight: '100'
                }
            },
            childrenAs: 'props',
            children: (el)=>[
                    {
                        text: 'Component',
                        Icon: {
                            name: 'plus'
                        },
                        onClick: (ev, el, s)=>{
                            const key = el.call('findNewName', 'components', 'NewComponent', {
                                autoRename: true
                            });
                            el.call('createItem', 'components', key);
                        }
                    },
                    {
                        text: 'Page',
                        Icon: {
                            name: 'plus'
                        },
                        onClick: (ev, el, s)=>{
                            const key = el.call('findNewName', 'pages', '/new-page', {
                                autoRename: true
                            });
                            el.call('createItem', 'pages', key);
                        }
                    },
                    {
                        text: 'File',
                        Icon: {
                            name: 'plus'
                        },
                        onClick: (ev, el, s)=>{
                            el.call('openModal', '/add-file');
                        }
                    }
                ]
        }
    },
    Line: {
        margin: 'A -Z2 B'
    },
    QuickAddPanel: {
        CaptionTitle: {
            margin: '- - Y2',
            Text: {
                text: 'apply action'
            }
        },
        Flex: {
            flow: 'y',
            gap: 'Z2',
            childProps: {
                width: '100%'
            },
            Select_action: {
                width: '100%'
            },
            Select_type: {
                width: '100%'
            },
            FileSidebarAddNewItem: {
                order: 2,
                margin: '-X W -',
                Label: {
                    Flex: {
                        margin: '- -W - -',
                        order: 2,
                        opacity: 1,
                        Save: {
                            extends: 'NavbarButton'
                        },
                        Close: null
                    }
                }
            }
        }
    },
    width: 'G+C',
    flow: 'y',
    gap: 'A',
    padding: 'A A1',
    textAlign: 'start'
};

});

parcelRegister("dOgZa", function(module, exports) {

$parcel$export(module.exports, "ProjectCodeSidebar", () => $a0dd1ed5cc7f0aa0$export$c8a86ba5661b8e21);
const $a0dd1ed5cc7f0aa0$export$c8a86ba5661b8e21 = {
    extends: 'DocsSidebar',
    childExtends: {
        state: {
            show: true
        }
    },
    position: 'relative',
    top: '0',
    gap: 'B2',
    childProps: {
        NumbCaption: {
            position: 'sticky',
            top: '0',
            theme: 'common-box',
            padding: 'W -',
            href: null,
            Numb: null,
            CaptionTitle: {
                ':hover': {
                    textDecoration: 'underline'
                },
                Text: {
                    text: '{{ title }}'
                },
                onClick: (ev, el, s)=>{
                    ev.preventDefault();
                    ev.stopPropagation();
                    el.lookup('Overflow').state.update({
                        type: s.key,
                        key: null
                    }, {
                        forceMonacoUpdate: true
                    });
                }
            },
            Text: null,
            SquareButton: {
                extends: [
                    'CanvasButton',
                    'SquareButton'
                ],
                margin: '-Y1 -',
                padding: 'X',
                round: 'X',
                icon: (el, s)=>s.show ? 'arrow angle up' : 'arrow angle down',
                hide: (el, s)=>!s.sub_links?.length,
                onClick: (ev, el, s)=>{
                    ev.preventDefault();
                    ev.stopPropagation();
                    s.toggle('show');
                }
            }
        },
        NavLinks: {
            margin: 'Z - -',
            padding: '- - - Z2',
            borderWidth: '0 0 0 1px',
            borderStyle: 'solid',
            borderColor: 'line',
            hide: (el, s)=>!s.show || !s.sub_links?.length,
            childProps: {
                NumbCaption: {
                    Numb: null,
                    href: null,
                    isActive: (el, s)=>s.key === el.lookup((el, s)=>s.selectedKey)?.state.selectedKey,
                    onClick: (ev, el, s)=>{
                        ev.preventDefault();
                        ev.stopPropagation();
                        el.lookup('Overflow').state.update({
                            type: s.parent.key,
                            key: s.key
                        }, {
                            forceMonacoUpdate: true
                        });
                    }
                }
            }
        }
    },
    children: (el)=>{
        const arrayize = (obj = {})=>Object.keys(obj).map((key)=>({
                    title: key,
                    key: key
                }));
        const rootData = [
            {
                title: '~',
                sub_links: [
                    {
                        title: 'index.html',
                        key: 'index.html'
                    },
                    {
                        title: 'app.js',
                        key: 'app.js'
                    },
                    {
                        title: 'package.json',
                        key: 'package.json'
                    },
                    {
                        title: 'sitemap.xml',
                        key: 'sitemap.xml'
                    }
                ]
            },
            {
                title: 'Components',
                key: 'components',
                sub_links: arrayize(el.getData('components')).slice(0, 10)
            },
            {
                title: 'Pages',
                key: 'pages',
                sub_links: arrayize(el.getData('pages')).slice(0, 10)
            },
            {
                title: 'State',
                key: 'state',
                sub_links: arrayize(el.getData('state')).slice(0, 10)
            },
            {
                title: 'Functions',
                key: 'functions',
                sub_links: arrayize(el.getData('functions')).slice(0, 10)
            },
            {
                title: 'Methods',
                key: 'methods',
                sub_links: arrayize(el.getData('methods'))
            },
            {
                title: 'Snippets',
                key: 'snippets',
                sub_links: arrayize(el.getData('snippers'))
            },
            {
                title: 'Files',
                key: 'files',
                sub_links: arrayize(el.getData('files'))
            },
            {
                title: 'Design System',
                key: 'designSystem',
                sub_links: arrayize(el.getData('designSystem'))
            },
            {
                title: 'Dependencies',
                key: 'dependencies'
            },
            {
                title: 'Integrations',
                key: 'integrations'
            },
            {
                title: 'Canvas',
                key: 'canvas'
            },
            {
                title: 'Settings',
                key: 'settings'
            },
            {
                title: 'Secrets',
                key: 'secrets'
            }
        ];
        return rootData;
    }
};

});

parcelRegister("j7Idj", function(module, exports) {

$parcel$export(module.exports, "ProjectCodeData", () => $dec0f7aa7119857d$export$b8b6f2080b29843a);
const $dec0f7aa7119857d$export$b8b6f2080b29843a = {
    Header: {
        text: (el, s)=>(s.key || s.type || '') + ' data'
    },
    CodePreviewWidget: {
        Monaco: {
            fileTab: {
                code: (el, s)=>{
                    const { type: type, key: key } = s;
                    if (!type) return `// select category or file`;
                    const typeFactory = el.getData(type);
                    const code = el.stringifyCode(key ? typeFactory[key] : typeFactory);
                    return code;
                },
                filename: 'data.js',
                fileTabKey: 'data'
            },
            onCodeEditCallback: (editor, _, el, s)=>{
                const code = editor.getValue();
                const value = el.call('evalStringCodeUnsafe', code, {
                    onError: (err)=>{
                        s.update({
                            err: err
                        });
                    }
                });
            }
        }
    }
};

});

parcelRegister("7XRyk", function(module, exports) {

$parcel$export(module.exports, "MoreInsertMenuCopy", () => $5cc79589cb0cde57$export$bac1bf419db5b814);
const $5cc79589cb0cde57$export$bac1bf419db5b814 = {
    CaptionTitle: {
        Text: {
            text: 'Insert from'
        }
    },
    ListInDropdown: {
        margin: '- -Z2',
        gap: '0',
        childProps: {
            padding: 'Z Z2',
            fontSize: 'A',
            round: 'Z2',
            fontWeight: '400',
            color: 'title',
            Text: null,
            Icon: {
                color: 'currentColor',
                opacity: '1',
                margin: '- Y1 - -',
                fontWeight: '100'
            },
            ':hover': {
                '& svg': {
                    opacity: 1
                }
            }
        },
        childrenAs: 'props',
        children: (el)=>[
                {
                    text: 'Components library',
                    Icon: {
                        name: 'sf components'
                    },
                    onClick: (ev, el)=>{
                        el.setWindow('explorer', 'insert:library');
                    }
                },
                {
                    text: 'Live website',
                    Icon: {
                        name: 'globe'
                    },
                    onClick: (ev, el)=>{
                        el.setWindow('explorer', 'insert:library-pages');
                    }
                },
                {
                    text: 'Local files',
                    Icon: {
                        name: 'terminal'
                    },
                    onClick: (ev, el)=>{
                        el.setWindow('explorer', 'insert:figma');
                    }
                },
                {
                    text: 'Figma',
                    Icon: {
                        name: 'figma'
                    },
                    Sup: {
                        margin: '-Z - - X2',
                        fontSize: 'Y',
                        text: '(soon)'
                    },
                    onClick: (ev, el)=>{
                        el.setWindow('explorer', 'insert:figma');
                    }
                },
                {
                    text: 'Icons',
                    Icon: {
                        name: 'icons'
                    },
                    Sup: {
                        margin: '-Z - - X2',
                        fontSize: 'Y',
                        text: '(soon)'
                    },
                    onClick: (ev, el)=>{
                        el.setWindow('explorer', 'insert:icons');
                    }
                },
                {
                    text: 'Fonts',
                    Icon: {
                        name: 'fontFace'
                    },
                    Sup: {
                        margin: '-Z - - X2',
                        fontSize: 'Y',
                        text: '(soon)'
                    },
                    onClick: (ev, el)=>{
                        el.setWindow('explorer', 'insert:fonts');
                    }
                },
                {
                    text: 'Integrations',
                    Icon: {
                        name: 'fuse'
                    },
                    Sup: {
                        margin: '-Z - - X2',
                        fontSize: 'Y',
                        text: '(soon)'
                    },
                    onClick: (ev, el)=>{
                        el.setWindow('explorer', 'insert:integrations');
                    }
                }
            ]
    },
    extends: 'Dropdown',
    padding: 'Z1 A',
    gap: 'A',
    flow: 'y'
};

});

parcelRegister("4Qggm", function(module, exports) {

$parcel$export(module.exports, "UserMenu", () => $3868a236cf88aa6f$export$72d0b49a56703654);
const $3868a236cf88aa6f$export$72d0b49a56703654 = {
    Avatar: {
        fontSize: 'X',
        onClick: async (ev, el)=>{
            await el.call('openModal', '/settings', {
                key: '/personal-account'
            });
        }
    }
};

});

parcelRegister("8ywuD", function(module, exports) {

$parcel$export(module.exports, "ProjectCodeSchema", () => $63aab42e3563aef9$export$42ea835fe08928c0);
const $63aab42e3563aef9$export$42ea835fe08928c0 = {
    Header: {
        text: (el, s)=>(s.key || s.type || '') + ' schema'
    },
    CodePreviewWidget: {
        Monaco: {
            fileTab: {
                code: (el, s)=>{
                    const { type: type, key: key } = s;
                    if (!type) return `// select category or file`;
                    const typeFactory = el.getSchema(type);
                    const code = el.stringifyCode(key ? typeFactory[key] : typeFactory);
                    return code;
                },
                filename: 'schema.js',
                fileTabKey: 'schema'
            },
            onCodeEditCallback: (editor, _, el, s)=>{
                const code = editor.getValue();
                const value = el.call('evalStringCodeUnsafe', code, {
                    onError: (err)=>{
                        s.update({
                            err: err
                        });
                    }
                });
            }
        }
    },
    borderWidth: '0 0 0 1px',
    borderStyle: 'solid',
    borderColor: 'line'
};

});

parcelRegister("74dHH", function(module, exports) {

$parcel$export(module.exports, "EditorPositionNavbar", () => $5253897070fc3d2f$export$27783dfab36f84ee);
const $5253897070fc3d2f$export$27783dfab36f84ee = {
    Expand: {
        title: 'Expand',
        icon: (el)=>'arrowCompact' + (el.getUserSettings('editorPanelsAtRight') ? 'Left' : 'Right'),
        margin: '- - - auto',
        hide: (el)=>{
            const EditorPanels = el.getEditorPanels();
            return EditorPanels?.isExpanded;
        },
        onClick: (ev, el)=>{
            const EditorPanels = el.getEditorPanels();
            EditorPanels.update({
                isExpanded: true
            });
        }
    },
    Minimize: {
        title: 'Minimize',
        icon: (el)=>'arrowCompact' + (el.getUserSettings('editorPanelsAtRight') ? 'Right' : 'Left'),
        margin: '- - - auto',
        hide: (el)=>{
            const EditorPanels = el.getEditorPanels();
            return !EditorPanels?.isExpanded;
        },
        onClick: (ev, el)=>{
            const EditorPanels = el.getEditorPanels();
            EditorPanels.update({
                isExpanded: false
            });
        }
    },
    Left: {
        title: 'Align to left',
        icon: 'boxFilledLeft',
        hide: (el)=>!el.getUserSettings('editorPanelsAtRight'),
        onClick: (ev, el)=>{
            const EditorPanels = el.getEditorPanels();
            el.call('setUserSettings', 'editorPanelsAtRight', false);
            EditorPanels.update();
        }
    },
    Right: {
        title: 'Align to right',
        icon: 'boxFilledRight',
        hide: (el)=>el.getUserSettings('editorPanelsAtRight'),
        onClick: (ev, el)=>{
            const EditorPanels = el.getEditorPanels();
            el.call('setUserSettings', 'editorPanelsAtRight', true);
            EditorPanels.update();
        }
    },
    extends: 'NavbarButtonSet'
};

});

parcelRegister("i5pTl", function(module, exports) {

$parcel$export(module.exports, "FnEditNavbar", () => $d2acc725b8be8c9b$export$47399a3499160834);
const $d2acc725b8be8c9b$export$47399a3499160834 = {
    IconText: {
        icon: 'fn outline',
        gap: 'X',
        padding: 'X Z1',
        text: '{{ key }}',
        Icon: {
            color: 'dim'
        }
    },
    EditorPositionNavbar: {
        margin: '- - - auto'
    },
    NavbarButtonSet: {
        NavbarButton_docs: {
            isActive: false,
            theme: 'transparent',
            icon: 'question mark',
            color: 'dim',
            onClick: (ev, el)=>{
                el.setWindow('docs', '/functions');
            }
        },
        NavbarButton_close: {
            icon: 'crossmark',
            isActive: false,
            onClick: (ev, el)=>{
                el.activateFunction(null);
            }
        }
    },
    extends: [
        'MicroNavbar',
        'Navbar'
    ],
    width: '100%',
    padding: 'W1 X X1'
};

});

parcelRegister("5TPxd", function(module, exports) {

$parcel$export(module.exports, "StateEditNavbar", () => $44ba1083aefc3477$export$41f9d39ae13d00c6);
const $44ba1083aefc3477$export$41f9d39ae13d00c6 = {
    IconText: {
        icon: 'state outline',
        text: '{{ key }}'
    },
    NavbarButtonSet: {
        NavbarButton_docs: {
            onClick: (ev, el)=>{
                el.setWindow('docs', '/state');
            }
        },
        NavbarButton_close: {
            onClick: (ev, el)=>{
                el.activateState(null);
            }
        }
    },
    extends: 'FnEditNavbar'
};

});

parcelRegister("i4AUN", function(module, exports) {

$parcel$export(module.exports, "TutorialPillsNotification", () => $d2853c4d44af041b$export$31da7ad61e653136);
const $d2853c4d44af041b$export$31da7ad61e653136 = {
    if: true,
    state: {
        descr: 'Symbols unifies HTML, CSS, and JavaScript into a single JavaScript object, giving you full control over structure, style, and behavior with elegant, expressive code.',
        src: 'code-preview.gif',
        title: 'Enjoy coding!',
        key: 'symbolsCodeExplained',
        docsArticle: '/building-in-symbols'
    },
    Img: {},
    Hgroup: {},
    TutorialNotificationButtons: null,
    extends: 'TutorialGifNotification',
    theme: null,
    overflow: null
};

});

parcelRegister("hqDAY", function(module, exports) {

$parcel$export(module.exports, "TutorialNotificationButtons", () => $cb039433991a9e80$export$50b88355fa57f0ba);
const $cb039433991a9e80$export$50b88355fa57f0ba = {
    flow: 'x',
    childExtends: [
        'CanvasButton',
        'Button'
    ],
    align: 'center center',
    flow: 'x',
    fontSize: 'Z2',
    borderStyle: 'solid',
    borderColor: 'line-highlight',
    borderWidth: '1px 0 0 0',
    height: '100%',
    childProps: {
        round: '0',
        padding: 'A',
        flex: 1,
        gap: 'X2',
        ':not(:last-child)': {
            borderStyle: 'solid',
            borderColor: 'line-highlight',
            borderWidth: '0 1px 0 0'
        }
    },
    children: [
        {
            icon: 'sf question oval',
            text: 'Learn more',
            onClick: (ev, el, s)=>{
                el.setWindow('docs', s.docsArticle);
            }
        },
        {
            icon: 'checkmark',
            text: 'Okay',
            onClick: (ev, el, s)=>{
                if (s.callback) el.call('exec', s.callback);
                el.lookup((el)=>el.rootSlide).remove();
                const markKey = 'tutorialMarked_' + s.key;
                el.call('setCookie', markKey, true);
            }
        }
    ]
};

});

parcelRegister("An42e", function(module, exports) {

$parcel$export(module.exports, "TutorialGifNotificationSlider", () => $06d540f4361e6469$export$3b4554570b19461f);
const $06d540f4361e6469$export$3b4554570b19461f = {
    if: (el, s)=>{
        const preventByCookie = el.call('getCookie', 'tutorialMarked_' + s.key) === 'true';
        return el.useCookie ? !preventByCookie : true;
    },
    state: {
        slides: [
            {
                title: 'Enjoy the canvas',
                descr: 'Dive into your interactive canvas. Pan, zoom, and explore freely as you build.',
                src: 'intro.gif',
                docsArticle: '/canvas-and-editor'
            },
            {
                title: 'Realtime experience',
                descr: 'You get a free domain for instant sharing, previews, and seamless cross-device testing.',
                src: 'realtime.gif',
                docsArticle: '/publish'
            },
            {
                title: 'Edit your app',
                descr: 'Double-click to open any element. Right-click for contextual actions. Topbar for navigation.',
                src: 'editor.gif',
                docsArticle: '/building-in-symbols'
            }
        ],
        activeIndex: 0,
        key: 'codeTour'
    },
    Flex: {
        childExtends: 'TutorialPillsNotification',
        childrenAs: 'state',
        children: (el, s)=>s.slides,
        childProps: {
            widthRange: '100%'
        },
        transition: 'C1 defaultBezier transform',
        onBeforeUpdate: (_, el, s)=>{
            el.set({
                transform: `translate3d(-${s.activeIndex * 100}%, 0, 1px)`
            });
        }
    },
    NavigationDots: {},
    TutorialNotificationButtons: {
        children: ()=>[
                {
                    hide: (el, s)=>s.activeIndex === 0,
                    icon: 'arrow left',
                    text: 'Previous',
                    onClick: (ev, el, s)=>{
                        s.apply((_)=>s.activeIndex--);
                    }
                },
                {
                    icon: 'sf question oval',
                    text: 'Learn more',
                    onClick: (ev, el, s)=>{
                        const activeItem = s.slides[s.activeIndex];
                        el.setWindow('docs', activeItem.docsArticle);
                    }
                },
                {
                    flow: 'row-reverse',
                    isLast: (el, s)=>el.key == s.activeIndex,
                    icon: (el)=>el.isLast ? 'checkmark' : 'arrow right',
                    text: (el)=>el.isLast ? 'Okay' : 'Next',
                    onClick: (ev, el, s)=>{
                        const activeItem = s.slides[s.activeIndex];
                        if (activeItem.callback) el.call('exec', activeItem.callback);
                        const isLast = el.isLast;
                        if (!isLast) {
                            s.apply((_)=>s.activeIndex++);
                            return;
                        }
                        el.lookup((el)=>el.rootSlider).remove();
                        el.call('setCookie', 'tutorialMarked_' + s.key, true);
                    }
                }
            ]
    },
    flow: 'x',
    position: 'relative',
    overflow: 'hidden',
    flow: 'y',
    gap: 'X',
    width: 'H2',
    theme: 'canvas-card-glass',
    rootSlider: true
};

});

parcelRegister("2InCc", function(module, exports) {

$parcel$export(module.exports, "NavigationDots", () => $1fa2024bfd7f8395$export$6659d58bd83a4f69);
const $1fa2024bfd7f8395$export$6659d58bd83a4f69 = {
    tag: 'nav',
    flow: 'x',
    gap: 'A2',
    margin: 'A -',
    padding: 'A',
    align: 'center center',
    onRender: (el)=>el.update(),
    childProps: {
        boxSize: 'Z',
        theme: 'dialog',
        round: '100%',
        cursor: 'pointer',
        isActive: (el, s)=>parseInt(el.key) === s.activeIndex,
        text: '',
        '.isActive': {
            theme: 'primary'
        },
        ':active': {
            theme: 'primary'
        }
    },
    children: (el, s)=>s.slides
};

});

parcelRegister("dQ0Mx", function(module, exports) {

$parcel$export(module.exports, "DangerZoneSection", () => $a130bcf7937653c4$export$d31dc21e4a9b38a7);
const $a130bcf7937653c4$export$d31dc21e4a9b38a7 = {
    if: (el)=>el.sdk.hasPermission('iam'),
    CardContent: {
        flow: 'y',
        align: 'start',
        gap: 'C1',
        Hgrpup: {
            H: {
                color: 'title',
                fontSize: '1.5rem',
                fontWeight: 'bold',
                text: 'Delete Project'
            },
            P: {
                margin: '0',
                text: 'Once you delete a project, there is no going back. Please be certain.'
            }
        },
        ContinueButton: {
            padding: 'Z2 C1',
            text: 'Delete Project',
            theme: null,
            border: '2px solid red.35',
            onClick: async (ev, el, st)=>{
                // Double confirmation is not recommended because it can be frustrating for users.
                if (!window.confirm(`Are you sure you want to delete this project? This action cannot be undone.`)) return;
                if (!window.confirm(`Please confirm once more that you want to permanently delete "${st.projectName}".`)) return;
                const { projectId: projectId } = st;
                try {
                    await el.sdk.removeProject(projectId) // removeProject does not return anything
                    ;
                    el.call('openNotification', {
                        title: 'Success message',
                        message: 'The project has been successfully removed.',
                        type: 'success'
                    });
                    setTimeout(()=>{
                        // SPA-nav to /dashboard after project removal. If the router
                        // ever fails to apply the new route, fall back to a full
                        // navigation so the user isn't stranded on the now-deleted
                        // project's settings page.
                        try {
                            el.router('/dashboard', el.getRoot());
                        } catch (_) {
                            if (typeof window !== 'undefined') window.location.href = '/dashboard';
                        }
                    }, 1000);
                } catch (error) {
                    el.call('openNotification', {
                        title: 'Error message',
                        message: `Error: ${error.message || 'Failed to delete project.'}`,
                        type: 'error'
                    });
                }
            }
        }
    },
    flow: 'x',
    width: '100%',
    maxWidth: 'I2',
    gap: 'B1',
    align: 'flex-start',
    position: 'relative',
    flow: 'y',
    margin: 'C1 0'
};

});

parcelRegister("5ImE2", function(module, exports) {

$parcel$export(module.exports, "MembersTable", () => $4292a095a42f3ed9$export$779b75330d069eb);
const $4292a095a42f3ed9$export$779b75330d069eb = {
    state: {
        memberRoleBeingEdited: null,
        successMessage: null,
        errorMessage: null,
        projectMembers: [],
        toUpdate: null
    },
    TableHeader: {
        extends: 'Grid',
        columns: '2.2em 1fr 2fr 1fr 1fr',
        padding: 'A1',
        borderBottom: '1px solid --color-line',
        fontWeight: 'bold',
        background: 'background-alt',
        AvatarHeader: {
            text: ''
        },
        NameHeader: {
            text: 'Name'
        },
        EmailHeader: {
            text: 'Email'
        },
        RoleHeader: {
            text: 'Role'
        },
        ActionsHeader: {
            show: (el)=>el.isAdmin(),
            text: 'Actions'
        }
    },
    TableBody: {
        childProps: {
            Avatar: {
                boxSize: 'B',
                text: '{{name}}'
            },
            NameCell: {
                text: '{{name}}'
            },
            EmailCell: {
                text: '{{email}}'
            },
            RoleCell: {
                HiddenElement: {
                    show: false,
                    tag: 'div',
                    display: 'none',
                    text: ''
                },
                RoleSelectField: {
                    show: (el, s)=>s.parent.memberRoleBeingEdited === s.id,
                    extends: 'SelectField',
                    padding: '0',
                    round: 'C1',
                    position: 'relative',
                    Select: {
                        name: 'user',
                        id: 'user',
                        onChange: (ev, el, s)=>{
                            ev.preventDefault();
                            ev.stopImmediatePropagation();
                            s.parent.update({
                                toUpdate: {
                                    id: s.id,
                                    newRole: ev.target.value
                                }
                            });
                        },
                        childrenAs: 'props',
                        children: ()=>[
                                {
                                    value: 'owner',
                                    text: 'Owner'
                                },
                                {
                                    value: 'admin',
                                    text: 'Admin'
                                },
                                {
                                    value: 'editor',
                                    text: 'Editor'
                                },
                                {
                                    value: 'guest',
                                    text: 'Guest'
                                }
                            ],
                        childProps: {
                            tag: 'option',
                            attr: {
                                disabled: (el)=>!el.isAdmin(),
                                selected: (el, s)=>s.role === el.value
                            }
                        }
                    }
                },
                CurrentRole: {
                    show: (el, s)=>s.parent.memberRoleBeingEdited !== s.id,
                    text: '{{role}}'
                }
            },
            ActionsCell: {
                flow: 'x',
                childExtends: 'IconButton',
                show: (el)=>el.isAdmin(),
                flow: 'x',
                gap: 'A1',
                EditButton: {
                    show: (el, s)=>el.isAdmin(),
                    background: 'transparent',
                    color: 'gray8',
                    ':hover': {
                        background: 'gray4',
                        color: 'white'
                    },
                    icon: 'edit',
                    onClick: (ev, el, s)=>{
                        s.parent.update({
                            memberRoleBeingEdited: s.id,
                            toUpdate: null
                        });
                    }
                },
                ConfirmUpdateRoleButton: {
                    show: (el, s)=>s.parent.memberRoleBeingEdited === s.id,
                    background: 'transparent',
                    color: 'gray8',
                    icon: 'check',
                    ':hover': {
                        background: 'gray4',
                        color: 'white'
                    },
                    onClick: async (ev, el, s)=>{
                        ev.preventDefault();
                        ev.stopImmediatePropagation();
                        if (!s.parent.toUpdate) return;
                        try {
                            const { id: memberId, newRole: newRole } = s.parent.toUpdate;
                            if (newRole) {
                                // Call API to update member role
                                await el.sdk.updateMemberRole(s.root.projectId, memberId, newRole);
                                s.parent.update({
                                    memberRoleBeingEdited: null,
                                    toUpdate: null,
                                    successMessage: 'Member role updated successfully!'
                                });
                                // Refresh the table after a short delay
                                setTimeout(async ()=>{
                                    const result = await el.sdk.getProjectMembers(s.root.projectId);
                                    s.parent.replace({
                                        projectMembers: result.map((r)=>({
                                                ...r,
                                                id: r.user.id,
                                                email: r.user.email,
                                                name: r.user.name || r.user.email,
                                                role: r.role
                                            })) || []
                                    });
                                }, 500);
                            }
                        } catch (error) {
                            s.parent.update({
                                errorMessage: `Error: ${error.message || 'Failed to update member role'}`,
                                memberRoleBeingEdited: null,
                                toUpdate: null
                            });
                        }
                    }
                },
                CrossmarkButton: {
                    show: (el, s)=>s.parent.memberRoleBeingEdited === s.id,
                    background: 'transparent',
                    color: 'gray8',
                    ':hover': {
                        background: 'gray4',
                        color: 'white'
                    },
                    icon: 'crossmark',
                    onClick: (ev, el, s)=>{
                        s.parent.update({
                            memberRoleBeingEdited: null,
                            toUpdate: null
                        });
                    }
                },
                TrashButton: {
                    show: (el, s)=>s.role !== 'owner' && [
                            'owner',
                            'admin'
                        ].includes(s.root.projectRole),
                    background: 'transparent',
                    color: 'gray8',
                    ':hover': {
                        background: 'gray4',
                        color: 'white'
                    },
                    icon: 'trash',
                    onClick: async (ev, el, s)=>{
                        const memberId = s.id;
                        ev.preventDefault();
                        ev.stopImmediatePropagation();
                        const memberName = s.name;
                        const res = window.confirm(`Do you really want to remove ${memberName} from this project?`);
                        if (res) try {
                            await el.sdk.removeMember(el.getRootState('projectId'), memberId);
                            s.parent.update({
                                successMessage: `${memberName} has been removed from the project.`
                            });
                        } catch (err) {
                            s.parent.update({
                                errorMessage: `Error: ${err.message || 'Failed to remove member'}`
                            });
                        }
                    }
                }
            },
            columns: '2.2em 1fr 2fr 1fr 1fr',
            width: '100%',
            align: 'center center',
            padding: 'A1',
            borderBottom: '1px solid var(--color-border-light)',
            ':hover': {
                background: 'var(--color-background-hover)'
            }
        },
        flow: 'y',
        width: '100%',
        childExtends: 'Grid',
        childrenAs: 'state',
        children: ({ state: state })=>state.projectMembers
    },
    EmptyMessage: {
        show: (el, s)=>!s.projectMembers || s.projectMembers.length === 0,
        text: 'No team members found.',
        padding: 'B1',
        textAlign: 'center',
        opacity: '0.7'
    },
    flow: 'y',
    width: '100%',
    margin: 'B1 0',
    overflow: 'hidden',
    onRender: async (el, s)=>{
        const result = await el.sdk.getProjectMembers(el.getRootState('projectId'));
        s.update({
            projectMembers: result.map((r)=>({
                    ...r,
                    id: r.id,
                    email: r.user.email,
                    name: r.user.name || r.user.email,
                    role: r.role
                })) || []
        });
    },
    onStateUpdate: (changes, el)=>{
        if (changes.successMessage) el.call('openNotification', {
            title: 'Success message',
            message: changes.successMessage,
            type: 'success'
        });
        if (changes.errorMessage) el.call('openNotification', {
            title: 'Error message',
            message: changes.errorMessage,
            type: 'error'
        });
    }
};

});

parcelRegister("hUYpv", function(module, exports) {

$parcel$export(module.exports, "SettingsModal", () => $d0b686dd946e364c$export$dfaef62a0892bd28);
const $d0b686dd946e364c$export$dfaef62a0892bd28 = {};

});

parcelRegister("3Rfs1", function(module, exports) {

$parcel$export(module.exports, "Dropdown.MoreLearnMenu", () => $2cf24e946a2e11fb$export$5887f5bebe1cc0b8);
const $2cf24e946a2e11fb$export$5887f5bebe1cc0b8 = {
    ListInDropdown: {
        margin: '- -Z2',
        gap: '0',
        childProps: {
            padding: 'Z Z2',
            fontSize: 'A',
            round: 'Z2',
            fontWeight: '400',
            color: 'title',
            Text: null,
            Icon: {
                color: 'currentColor',
                opacity: '1',
                margin: '- Y1 - -',
                fontWeight: '100'
            },
            ':hover': {
                '& svg': {
                    opacity: 1
                }
            }
        },
        childrenAs: 'props',
        children: (el)=>[
                {
                    text: 'Onboarding',
                    Icon: {
                        name: 'intOutline'
                    },
                    onClick: (ev, el)=>{
                        el.setWindow('explorer', 'onboarding');
                        el.parent.update();
                    }
                },
                {
                    text: 'Examples',
                    Icon: {
                        name: 'ratingFrame'
                    },
                    onClick: (ev, el)=>{
                        el.setWindow('docs', '/examples');
                    }
                },
                {
                    text: 'Properties',
                    Icon: {
                        name: 'ratingFrame'
                    },
                    onClick: (ev, el)=>{
                        el.setWindow('docs', '/props');
                    }
                }
            ]
    },
    GeneralNav: {
        CaptionTitle: {
            margin: 'X - X2',
            Text: {
                text: 'More'
            }
        },
        ListInDropdown: {
            margin: '- -Z2',
            gap: '0',
            childProps: {
                padding: 'Z Z2',
                fontSize: 'A',
                round: 'Z2',
                fontWeight: '400',
                Icon: null,
                ':hover': {
                    '& svg': {
                        opacity: 1
                    }
                },
                Text: null,
                color: 'title'
            },
            childrenAs: 'props',
            children: (el)=>[
                    {
                        text: 'Intro to Symbols',
                        onClick: (ev, el)=>{
                            el.setWindow('docs', '/intro');
                        }
                    },
                    {
                        text: 'Documentation',
                        onClick: (ev, el)=>{
                            el.setWindow('docs', '/developers');
                        }
                    },
                    {
                        text: 'Contribution',
                        onClick: (ev, el)=>{
                            el.setWindow('docs', '/symbols-developer');
                        }
                    }
                ]
        }
    },
    flow: 'x',
    padding: 'Z1 A',
    gap: 'A',
    flow: 'y'
};

});

parcelRegister("af8VL", function(module, exports) {

$parcel$export(module.exports, "Dropdown.Envs", () => $77523b86b533e84c$export$df2fb887d44a420a);
const $77523b86b533e84c$export$df2fb887d44a420a = {
    Envs: {
        flow: 'y',
        gap: 'A',
        CaptionTitle: {
            Text: {
                text: 'Environments'
            }
        },
        Flex: {
            gap: 'A',
            flow: 'y',
            margin: '- -Z2',
            childExtends: 'EnvItem',
            Prod: {
                Hgroup: {
                    H: {
                        text: 'Production'
                    },
                    P: {
                        text: 'Specify production channel'
                    }
                }
            },
            Test: {
                Hgroup: {
                    H: {
                        text: 'Test'
                    },
                    P: {
                        text: 'Specify staging channel'
                    }
                }
            },
            Dev: {
                extends: [
                    'CanvasButton',
                    'EnvItem'
                ],
                isActive: true,
                Circle: {
                    isActive: true
                },
                Hgroup: {
                    H: {
                        text: 'Development'
                    },
                    P: {
                        text: 'Default - set to latest'
                    }
                },
                Buttons: {
                    hide: false
                },
                Upgrade: null
            }
        }
    },
    Line: {
        margin: '-A'
    },
    EnvItem_Local: {
        Hgroup: {
            H: {
                text: 'Local'
            },
            P: {
                text: (el)=>`localhost:1234`
            }
        },
        Upgrade: null,
        Connect: {
            extends: 'Link',
            color: 'title',
            text: 'Connect',
            margin: '- - - auto',
            alignSelf: 'start',
            whiteSpace: 'nowrap',
            fontSize: 'Z2',
            lineHeight: 1,
            ':hover': {
                textDecoration: 'underline'
            },
            onClick: (f, el, st)=>{
                el.call('openModal', '/settings', {
                    key: '/connect'
                });
            }
        },
        margin: '- -Z2'
    },
    Line_2: {
        margin: '-A'
    },
    Domains: {
        flow: 'y',
        gap: 'A',
        CaptionTitle: {
            Text: {
                text: 'Domains'
            }
        },
        Flex: {
            gap: 'A',
            flow: 'y',
            margin: '- -Z2',
            childExtends: 'DomainItem',
            Custom: {
                Hgroup: {
                    H: {
                        text: 'Custom domain'
                    },
                    P: {
                        text: 'Connect any domain to your app'
                    }
                }
            },
            Lookup: {
                Hgroup: {
                    H: {
                        text: 'Find your domain'
                    },
                    P: {
                        text: 'Connect to a new domain'
                    }
                },
                Upgrade: null,
                Icon: {
                    name: 'sf search'
                }
            }
        }
    },
    flow: 'x',
    padding: 'Z1 A',
    flow: 'y',
    gap: 'C',
    textAlign: 'start',
    width: 'G1'
};

});

parcelRegister("5FLUI", function(module, exports) {

$parcel$export(module.exports, "Dropdown.QuickAdd", () => $4215f2c8d8b8bf33$export$b4fc0047ec2eaaa6);
const $4215f2c8d8b8bf33$export$b4fc0047ec2eaaa6 = {
    state: {},
    QuickAddMenu: {
        CaptionTitle: {
            margin: '- - Z',
            Text: {
                text: 'Add blank'
            }
        },
        ListInDropdown: {
            margin: '- -Z2',
            gap: '-',
            childProps: {
                ':hover': {
                    '& svg': {
                        opacity: 1
                    }
                },
                padding: 'Z Z2',
                fontSize: 'A',
                gap: 'X',
                fontWeight: '400',
                round: 'Z2',
                Text: null,
                color: 'title',
                Icon: {
                    color: 'currentColor',
                    opacity: '1',
                    margin: '0',
                    fontWeight: '100'
                }
            },
            childrenAs: 'props',
            children: (el)=>[
                    {
                        text: 'Component',
                        Icon: {
                            name: 'plus'
                        },
                        onClick: (ev, el, s)=>{
                            const key = el.call('findNewName', 'components', 'NewComponent', {
                                autoRename: true
                            });
                            el.call('createItem', 'components', key);
                        }
                    },
                    {
                        text: 'Page',
                        Icon: {
                            name: 'plus'
                        },
                        onClick: (ev, el, s)=>{
                            const key = el.call('findNewName', 'pages', '/new-page', {
                                autoRename: true
                            });
                            el.call('createItem', 'pages', key);
                        }
                    },
                    {
                        text: 'File',
                        Icon: {
                            name: 'plus'
                        },
                        onClick: (ev, el, s)=>{
                            el.call('openModal', '/add-file');
                        }
                    }
                ]
        }
    },
    Line: {
        margin: '- -Z2 X'
    },
    MoreInsertMenu: {},
    Line_2: {
        margin: '- -Z2 Z'
    },
    QuickAddPanel: {
        CaptionTitle: {
            margin: '- - Y2',
            Text: {
                text: 'apply action'
            }
        },
        Flex: {
            flow: 'y',
            gap: 'Z2',
            childProps: {
                width: '100%'
            },
            Select_action: {
                width: '100%'
            },
            Select_type: {
                width: '100%'
            },
            FileSidebarAddNewItem: {
                order: 2,
                margin: '-X W -',
                Label: {
                    Flex: {
                        margin: '- -W - -',
                        order: 2,
                        opacity: 1,
                        Save: {
                            extends: 'NavbarButton'
                        },
                        Close: null
                    }
                }
            }
        }
    },
    Line_3: {
        margin: '- -Z2 Z'
    },
    ComingSoonMenu: {
        CaptionTitle_soon: {
            Text: {
                text: 'Coming soon'
            }
        },
        ListInDropdown: {
            margin: '- -Z2',
            gap: '0',
            childProps: {
                padding: 'Z Z2',
                fontSize: 'A',
                round: 'Z2',
                fontWeight: '400',
                color: 'title',
                Text: null,
                Icon: {
                    color: 'currentColor',
                    opacity: '1',
                    margin: '- Y1 - -',
                    fontWeight: '100'
                },
                ':hover': {
                    '& svg': {
                        opacity: 1
                    }
                }
            },
            childrenAs: 'props',
            children: (el)=>[
                    {
                        text: 'Marketplace',
                        Icon: {
                            name: 'plus'
                        },
                        onClick: (ev, el)=>{
                            el.setWindow('explorer', 'insert');
                        }
                    },
                    {
                        text: 'Integrations',
                        Icon: {
                            name: 'fuse'
                        },
                        onClick: (ev, el)=>{
                            el.setWindow('explorer', 'insert:integrations');
                        }
                    },
                    {
                        text: 'Figma',
                        Icon: {
                            name: 'figma'
                        },
                        Sup: {
                            margin: '-Z - - X2',
                            fontSize: 'Y',
                            text: '(soon)'
                        },
                        onClick: (ev, el)=>{
                            el.setWindow('explorer', 'insert:figma');
                        }
                    },
                    {
                        text: 'Icons',
                        Icon: {
                            name: 'icons'
                        },
                        Sup: {
                            margin: '-Z - - X2',
                            fontSize: 'Y',
                            text: '(soon)'
                        },
                        onClick: (ev, el)=>{
                            el.setWindow('explorer', 'insert:icons');
                        }
                    },
                    {
                        text: 'Fonts',
                        Icon: {
                            name: 'fontFace'
                        },
                        Sup: {
                            margin: '-Z - - X2',
                            fontSize: 'Y',
                            text: '(soon)'
                        },
                        onClick: (ev, el)=>{
                            el.setWindow('explorer', 'insert:fonts');
                        }
                    }
                ]
        }
    },
    flow: 'x',
    width: 'G+C',
    flow: 'y',
    gap: 'A',
    padding: 'A A1',
    textAlign: 'start'
};

});

parcelRegister("4z65O", function(module, exports) {

$parcel$export(module.exports, "Dropdown.MoreFilesMenu", () => $352f28357db6a864$export$37ee3f34f795b121);
const $352f28357db6a864$export$37ee3f34f795b121 = {
    ListInDropdown: {
        margin: '- -Z2',
        gap: '0',
        childProps: {
            padding: 'Z Z2',
            fontSize: 'A',
            round: 'Z2',
            fontWeight: '400',
            color: 'title',
            Text: null,
            isActive: (el, s)=>el.key === s.activeContent,
            onClick: (ev, el, s)=>{
                const activeContent = el.key;
                el.setWindow('explorer', 'explorer:' + activeContent);
            // el.setWindow('explorer', 'explorer', {
            //   forcedValue: activeContent
            // })
            // el.call('setSidebarContent', activeContent)
            },
            Icon: {
                color: 'currentColor',
                opacity: '1',
                margin: '- Y1 - -',
                fontWeight: '100'
            },
            ':hover': {
                '& svg': {
                    opacity: 1
                }
            }
        },
        childrenAs: 'props',
        children: (el)=>[
                {
                    key: 'ARTBOARD_TYPES',
                    text: 'Artboards',
                    Icon: {
                        name: 'sf components'
                    }
                },
                {
                    key: 'FUNCTION_TYPES',
                    text: 'Functions',
                    Icon: {
                        name: 'fnOutline'
                    }
                },
                {
                    key: 'STATE_TYPES',
                    text: 'State',
                    Icon: {
                        name: 'sfDocument'
                    }
                },
                {
                    key: 'ASSETS_TYPES',
                    text: 'Assets',
                    Icon: {
                        name: 'sfAssets'
                    }
                },
                {
                    key: 'COLOR_TYPES',
                    text: 'Colors',
                    Icon: {
                        name: 'sfPallete'
                    }
                },
                {
                    key: 'RESPONSIVE_TYPES',
                    text: 'Responsive',
                    Icon: {
                        name: 'sfResponsive'
                    },
                    Sup: {
                        color: 'disabled',
                        margin: '-Z - - X2',
                        fontSize: 'Y',
                        text: '(soon)'
                    }
                },
                {
                    key: 'TYPOGRAPHY_TYPES',
                    text: 'Typography',
                    Icon: {
                        name: 'fontFace'
                    },
                    Sup: {
                        color: 'disabled',
                        margin: '-Z - - X2',
                        fontSize: 'Y',
                        text: '(soon)'
                    }
                },
                {
                    key: 'SPACING_TYPES',
                    text: 'Spacing',
                    Icon: {
                        name: 'spaceOutlineColored'
                    },
                    Sup: {
                        color: 'disabled',
                        margin: '-Z - - X2',
                        fontSize: 'Y',
                        text: '(soon)'
                    }
                },
                {
                    key: 'ICON_TYPES',
                    text: 'Icons',
                    Icon: {
                        name: 'iconsOutlineColored'
                    }
                },
                {
                    key: 'TRANSITION_TYPES',
                    text: 'Animations',
                    Icon: {
                        name: 'animationsAlt'
                    },
                    Sup: {
                        color: 'disabled',
                        margin: '-Z - - X2',
                        fontSize: 'Y',
                        text: '(soon)'
                    }
                },
                {
                    key: 'INTEGRATIONS_TYPES',
                    text: 'Integrations',
                    Icon: {
                        name: 'fuse'
                    }
                }
            ]
    },
    flow: 'x',
    padding: 'Z1 A',
    gap: 'A',
    flow: 'y'
};

});

parcelRegister("jjRPV", function(module, exports) {

$parcel$export(module.exports, "Dropdown.MoreToolsMenu", () => $e1098d769c422601$export$1a9f2d832d70a43b);
const $e1098d769c422601$export$1a9f2d832d70a43b = {
    ListInDropdown: {
        margin: '- -Z2',
        gap: '0',
        childProps: {
            padding: 'Z Z2',
            fontSize: 'A',
            round: 'Z2',
            fontWeight: '400',
            color: 'title',
            Text: null,
            Icon: {
                color: 'currentColor',
                opacity: '1',
                margin: '- Y1 - -',
                fontWeight: '100'
            },
            ':hover': {
                '& svg': {
                    opacity: 1
                }
            }
        },
        childrenAs: 'props',
        children: (el)=>[
                {
                    text: 'Get started',
                    Icon: {
                        name: 'intOutline'
                    },
                    onClick: (ev, el)=>{
                        el.setWindow('explorer', 'onboarding');
                        el.parent.update();
                    }
                },
                {
                    text: 'View',
                    hide: true,
                    Icon: {
                        name: 'eye'
                    },
                    onClick: (ev, el)=>{
                        const active = 'view';
                        const isSelected = active === el.getWindow('explorer');
                        const hasSelected = el.getWindow('explorer')?.startsWith(active);
                        const val = isSelected ? null : active;
                        el.setWindow('explorer', val);
                        el.parent.update();
                    }
                },
                {
                    text: 'Examples',
                    Icon: {
                        name: 'ratingFrame'
                    },
                    onClick: (ev, el)=>{
                        el.setWindow('docs', '/examples');
                    }
                },
                {
                    text: 'Learn using',
                    Icon: {
                        name: 'learn'
                    },
                    onClick: (ev, el)=>{
                        const active = 'learn';
                        const isSelected = active === el.getWindow('explorer');
                        const hasSelected = el.getWindow('explorer')?.startsWith(active);
                        const val = isSelected ? null : active;
                        el.setWindow('explorer', val);
                        el.parent.update();
                    }
                }
            ]
    },
    DashboardNav: {
        CaptionTitle: {
            margin: 'X - X2',
            Text: {
                text: 'Tools'
            }
        },
        ListInDropdown: {
            margin: '- -Z2',
            gap: '0',
            childProps: {
                ':hover': {
                    '& svg': {
                        opacity: 1
                    }
                },
                padding: 'Z Z2',
                fontSize: 'A',
                fontWeight: '400',
                round: 'Z2',
                Text: null,
                color: 'title',
                Icon: {
                    color: 'currentColor',
                    opacity: '1',
                    margin: '- Y1 - -',
                    fontWeight: '100'
                }
            },
            childrenAs: 'props',
            children: (el)=>[
                    {
                        text: 'Project code',
                        Icon: {
                            name: 'code'
                        },
                        onClick: (ev, el)=>{
                            el.call('openModal', '/project-code', {
                                animationProps: {
                                    animation: 'fadeIn'
                                }
                            });
                        }
                    },
                    {
                        text: 'Playground',
                        hide: true,
                        Icon: {
                            name: 'play oval'
                        }
                    },
                    {
                        text: 'Props reference',
                        Icon: {
                            name: 'code'
                        },
                        onClick: (ev, el)=>{
                            el.setWindow('docs', '/props');
                        }
                    },
                    {
                        text: 'Compiler tools',
                        Icon: {
                            name: 'code'
                        },
                        onClick: (ev, el)=>{
                            el.call('openModal', '/compile', {
                                animationProps: {
                                    animation: 'fadeIn'
                                }
                            });
                        }
                    }
                ]
        }
    },
    GeneralNav: {
        CaptionTitle: {
            margin: 'X - X2',
            Text: {
                text: 'More'
            }
        },
        ListInDropdown: {
            margin: '- -Z2',
            gap: '0',
            childProps: {
                padding: 'Z Z2',
                fontSize: 'A',
                round: 'Z2',
                fontWeight: '400',
                Icon: null,
                ':hover': {
                    '& svg': {
                        opacity: 1
                    }
                },
                Text: null,
                color: 'title'
            },
            childrenAs: 'props',
            children: (el)=>[
                    {
                        text: 'Intro to Symbols',
                        onClick: (ev, el)=>{
                            el.setWindow('explorer', 'onboarding');
                        }
                    },
                    {
                        text: 'Documentation',
                        onClick: (ev, el)=>{
                            el.setWindow('docs', '/developers');
                        }
                    },
                    {
                        text: 'Support',
                        onClick: (ev, el)=>{
                            el.setWindow('docs', '/resources');
                        }
                    },
                    {
                        text: 'Contribution',
                        onClick: (ev, el)=>{
                            el.setWindow('docs', '/symbols-developer');
                        }
                    }
                ]
        }
    },
    flow: 'x',
    padding: 'Z1 A',
    gap: 'A',
    flow: 'y'
};

});

parcelRegister("8K2wS", function(module, exports) {

$parcel$export(module.exports, "Dropdown.AssistantMenu", () => $65d494d7c5ab3299$export$59ab8e072d21d642);
const $65d494d7c5ab3299$export$59ab8e072d21d642 = {
    CaptionTitle: {
        Text: {
            text: 'AI Tools:'
        }
    },
    ListInDropdown: {
        margin: '- -Z2',
        gap: '0',
        childProps: {
            padding: 'Z Z2',
            fontSize: 'A',
            round: 'Z2',
            fontWeight: '400',
            color: 'title',
            Text: null,
            Icon: {
                color: 'currentColor',
                opacity: '1',
                margin: '- Y1 - -',
                fontWeight: '100'
            },
            ':hover': {
                '& svg': {
                    opacity: 1
                }
            }
        },
        childrenAs: 'props',
        children: (el)=>[
                {
                    text: 'AI Playground',
                    Icon: {
                        name: 'wave'
                    },
                    onClick: (ev, el)=>{
                        el.call('openModal', '/ai-playground');
                    }
                }
            ]
    },
    flow: 'x',
    padding: 'Z1 A',
    gap: 'A',
    flow: 'y'
};

});

parcelRegister("gVBtc", function(module, exports) {

$parcel$export(module.exports, "Dropdown.Logo", () => $c52f08f429f7f182$export$7013d6ee10d6e04a);
const $c52f08f429f7f182$export$7013d6ee10d6e04a = {
    CaptionTitle: {
        Text: {
            text: 'Active Project'
        },
        if: (el)=>el.isCanvas()
    },
    Flex: {
        if: (el)=>el.isCanvas(),
        gap: 'Z',
        Avatar: {
            props: (el)=>({
                    avatarType: 'initials',
                    boxSize: 'B+X1',
                    src: el.call('getProjectIcon') || `https://avatars.symbo.ls/${el.avatarType || 'initials'}/svg?seed=${el.key || 'no-avatar'}`,
                    round: 'Z'
                })
        },
        Hgroup: {
            flow: 'y',
            margin: '- Z - -',
            gap: 'W',
            H: {
                color: 'title',
                tag: 'span',
                overflow: 'hidden',
                whiteSpace: 'wrap',
                textOverflow: 'anywhere',
                text: (el)=>el.getRootState('projectName')
            },
            P: {
                margin: '0',
                fontWeight: '400',
                color: 'paragraph',
                overflow: 'hidden',
                overflowWrap: 'anywhere',
                whiteSpace: 'wrap',
                textOverflow: 'anywhere',
                lineBreak: 'anywhere',
                text: (el)=>`${el.getRootState('workingProjectOwner')}/${el.getRootState('workingProjectKey')}`
            }
        },
        Upgrade: {
            if: (el)=>el.isAuthorised() && el.getRootState('tier') === 'starter',
            extends: 'Link',
            color: 'blue',
            text: 'Free plan',
            margin: '- - - auto',
            alignSelf: 'start',
            whiteSpace: 'nowrap',
            fontSize: 'Z2',
            lineHeight: 1,
            ':hover': {
                textDecoration: 'underline'
            },
            onClick: (f, el, st)=>{
                el.call('openModal', '/settings', {
                    key: '/pricing'
                });
            }
        }
    },
    ProjectNav: {
        if: (el)=>!el.isDashboard(),
        CaptionTitle: {
            margin: 'Z - X',
            Text: {
                text: 'Project'
            }
        },
        ListInDropdown: {
            margin: '- -Z2',
            gap: '0',
            childProps: {
                padding: 'Z+V1 Z2',
                fontSize: 'A',
                round: 'Z2',
                fontWeight: '400',
                color: 'title',
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                Text: null,
                Icon: {
                    color: 'currentColor',
                    opacity: '1',
                    margin: '- Y1 - -',
                    fontWeight: '100'
                },
                ':hover': {
                    '& svg': {
                        opacity: 1
                    }
                }
            },
            childrenAs: 'props',
            children: [
                {
                    Icon: {
                        name: 'upgrade'
                    },
                    text: 'Upgrade to team',
                    Sup: {
                        color: 'disabled',
                        margin: '-Z - - X2',
                        fontSize: 'Y',
                        text: '(soon)'
                    }
                },
                {
                    Icon: {
                        name: 'billing'
                    },
                    text: 'Billing'
                },
                {
                    Icon: {
                        name: 'sf settings fill'
                    },
                    text: 'Project Settings'
                }
            ]
        }
    },
    DashboardNav: {
        CaptionTitle: {
            margin: 'X -',
            Text: {
                text: 'Dashboard'
            }
        },
        ListInDropdown: {
            margin: '- -Z2',
            gap: '0',
            childProps: {
                padding: 'Z+V1 Z2',
                fontSize: 'A',
                round: 'Z2',
                fontWeight: '400',
                color: 'title',
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                Text: null,
                Icon: {
                    color: 'currentColor',
                    opacity: '1',
                    margin: '- Y1 - -',
                    fontWeight: '100'
                },
                ':hover': {
                    '& svg': {
                        opacity: 1
                    }
                }
            },
            childrenAs: 'props',
            children: (el)=>[
                    {
                        Icon: {
                            name: 'plus oval'
                        },
                        text: 'New project',
                        onClick: async (ev, el)=>{
                            await el.call('openModal', '/settings', {
                                key: '/onboarding'
                            });
                        }
                    },
                    {
                        Icon: {
                            name: 'arrows diagonal'
                        },
                        extends: [
                            'Link',
                            'Button'
                        ],
                        text: 'Switch project',
                        href: '/dashboard'
                    },
                    {
                        Icon: {
                            name: 'back'
                        },
                        extends: [
                            'Link',
                            'Button'
                        ],
                        text: 'Back to dashboard',
                        href: '/dashboard'
                    }
                ]
        }
    },
    UserNav: {
        CaptionTitle: {
            margin: 'Z - X',
            Text: {
                text: 'User'
            }
        },
        ListInDropdown: {
            margin: '- -Z2',
            gap: '0',
            childProps: {
                padding: 'Z+V1 Z2',
                fontSize: 'A',
                round: 'Z2',
                fontWeight: '400',
                color: 'title',
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                Text: null,
                Icon: {
                    color: 'currentColor',
                    opacity: '1',
                    margin: '- Y1 - -',
                    fontWeight: '100'
                },
                ':hover': {
                    '& svg': {
                        opacity: 1
                    }
                }
            },
            childrenAs: 'props',
            children: [
                {
                    Icon: {
                        name: 'user'
                    },
                    text: 'Profile',
                    onClick: async (ev, el)=>{
                        await el.call('openModal', '/settings', {
                            key: '/personal-account'
                        });
                    }
                },
                {
                    extends: [
                        'Link',
                        'Button'
                    ],
                    Icon: {
                        name: 'logout'
                    },
                    text: 'Logout',
                    href: '/logout'
                }
            ]
        }
    },
    GeneralNav: {
        CaptionTitle: {
            margin: 'Z - -',
            Text: {
                text: 'General'
            }
        },
        ListInDropdown: {
            margin: '- -Z2',
            gap: '0',
            childProps: {
                padding: 'Z+V1 Z2',
                fontSize: 'A',
                round: 'Z2',
                fontWeight: '400',
                color: 'title',
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                Text: null,
                Icon: {
                    color: 'currentColor',
                    opacity: '1',
                    margin: '- Y1 - -',
                    fontWeight: '100'
                },
                ':hover': {
                    '& svg': {
                        opacity: 1
                    }
                }
            },
            childrenAs: 'props',
            children: (el)=>[
                    {
                        extends: 'DocsLink',
                        href: '/developers',
                        text: 'Whats New?',
                        ':hover': {
                            textDecoration: 'none'
                        },
                        Icon: {
                            name: 'news'
                        }
                    },
                    {
                        extends: 'DocsLink',
                        href: '/developers',
                        text: 'About Symbols',
                        ':hover': {
                            textDecoration: 'none'
                        },
                        Icon: {
                            name: 'sf info'
                        }
                    },
                    {
                        extends: 'DocsLink',
                        href: '/docs/resources',
                        text: 'Support',
                        ':hover': {
                            textDecoration: 'none'
                        },
                        Icon: {
                            name: 'support'
                        }
                    }
                ]
        }
    },
    extends: [
        'Flex'
    ],
    flow: 'y',
    gap: 'A',
    padding: 'Z1 A'
};

});

parcelRegister("4Pd98", function(module, exports) {

$parcel$export(module.exports, "Dropdown.MoreModesMenu", () => $38361f694f86dc43$export$663119686d13f15d);
const $38361f694f86dc43$export$663119686d13f15d = {
    ListInDropdown_themes: {
        margin: '- -Z2',
        gap: '0',
        childProps: {
            ':hover': {
                '& svg': {
                    opacity: 1
                }
            },
            padding: 'Z Z2',
            fontSize: 'A',
            fontWeight: '400',
            round: 'Z2',
            Text: null,
            color: 'title',
            Icon: {
                color: 'currentColor',
                opacity: '1',
                margin: '- Y1 - -',
                fontWeight: '100'
            }
        },
        childrenAs: 'props',
        children: (el)=>[
                {
                    text: 'Light mode',
                    isActive: (el)=>el.getRootState('sceneTheme') === 'light',
                    Icon: {
                        theme: 'sepia',
                        name: (el, s)=>el.getRootState('sceneTheme') === 'light' ? 'sun' : 'sun outline'
                    },
                    onClick: (ev, el, s)=>{
                        const key = 'light';
                        el.getRootState().update({
                            globalTheme: key,
                            sceneTheme: key
                        });
                        el.getRoot().call('router', window.location.pathname);
                        el.getRoot().call('setCookie', 'sceneTheme', key);
                        el.getRoot().call('setCookie', 'globalTheme', key);
                    }
                },
                {
                    text: 'Dark mode',
                    isActive: (el)=>el.getRootState('sceneTheme') === 'dark',
                    Icon: {
                        theme: 'sepia',
                        name: (el, s)=>el.getRootState('sceneTheme') === 'dark' ? 'moon' : 'moon outline'
                    },
                    onClick: (ev, el, s)=>{
                        const key = 'dark';
                        el.getRootState().update({
                            globalTheme: key,
                            sceneTheme: key
                        });
                        el.getRoot().call('router', window.location.pathname);
                        el.getRoot().call('setCookie', 'sceneTheme', key);
                        el.getRoot().call('setCookie', 'globalTheme', key);
                    }
                }
            ]
    },
    Line: {
        margin: '0 -Z2'
    },
    More: {
        CaptionTitle: {
            margin: 'X - Y2',
            Text: {
                text: 'More canvas modes'
            }
        },
        ListInDropdown_modes: {
            margin: '- -Z2',
            gap: '0',
            childProps: {
                ':hover': {
                    '& svg': {
                        opacity: 1
                    }
                },
                padding: 'Z Z2',
                fontSize: 'A',
                fontWeight: '400',
                round: 'Z2',
                Text: null,
                color: 'title',
                Icon: {
                    color: 'currentColor',
                    opacity: '1',
                    margin: '- Y1 - -',
                    fontWeight: '100'
                }
            },
            childrenAs: 'props',
            children: (el)=>[
                    {
                        text: 'Code mode',
                        Icon: {
                            name: 'code'
                        },
                        onClick: (ev, el)=>{
                            el.call('openModal', '/project-code', {
                                animationProps: {
                                    animation: 'fadeIn'
                                }
                            });
                        }
                    },
                    {
                        text: 'Preview mode',
                        Icon: {
                            name: 'sf eye'
                        },
                        Sup: {
                            color: 'disabled',
                            margin: '-Z - - X2',
                            fontSize: 'Y',
                            text: '(soon)'
                        }
                    },
                    {
                        text: 'Comments mode',
                        Icon: {
                            name: 'chat'
                        },
                        Sup: {
                            color: 'disabled',
                            margin: '-Z - - X2',
                            fontSize: 'Y',
                            text: '(soon)'
                        }
                    }
                ]
        }
    },
    flow: 'y',
    gap: 'A',
    padding: 'Z1 A'
};

});

parcelRegister("cjF7x", function(module, exports) {

$parcel$export(module.exports, "Dropdown.Share", () => $8f772817f9ef4f10$export$de07b2de30aa5e59);
const $8f772817f9ef4f10$export$de07b2de30aa5e59 = {
    state: {},
    ShareSection: {
        flow: 'y',
        gap: 'A',
        CaptionTitle: {
            Text: {
                text: 'Share'
            }
        },
        DomainItem_Env: {
            margin: '- -Z2',
            Upgrade: null,
            Icon: null,
            Hgroup: {
                H: {
                    text: 'Environment'
                },
                P: {
                    text: 'Inherint or switch while sharing'
                }
            },
            Select: {
                padding: 'X Y2',
                margin: '-W -Y2 - auto',
                background: 'none',
                color: 'currentColor',
                width: 'D3',
                onChange: (ev, el, s, ctx)=>{
                    const value = ev.target.value;
                    if (value) s.update({
                        env: value
                    });
                },
                childrenAs: 'props',
                childProps: {
                    tag: 'option',
                    attr: {
                        selected: (el, s)=>el.node.value === s.action
                    }
                },
                children: [
                    {
                        text: 'Current'
                    },
                    {
                        text: 'Development'
                    },
                    {
                        text: 'Staging'
                    },
                    {
                        text: 'Production'
                    }
                ]
            },
            align: 'start'
        },
        Label: {
            flow: 'x',
            align: 'start',
            gap: 'A',
            Hgroup: {
                H: {
                    tag: 'p',
                    text: 'Selection share'
                },
                P: {
                    fontSize: 'Y2',
                    color: 'paragraph',
                    text: 'Link to selected element on canvas'
                },
                gap: 'X'
            },
            Toggle: {
                margin: '- - - auto',
                fontSize: 'Y2',
                Input: {
                    onChange: (ev, el, s)=>s.update({
                            isSelcetedActive: el.node.checked
                        })
                }
            }
        },
        Flex: {
            gap: 'A',
            flow: 'y',
            margin: '- -Z2',
            childExtends: 'DomainItem',
            childProps: {
                onInit: (el, s)=>{
                    s.path = el.getCanvasPathname();
                },
                onBeforeUpdate: (_, el, s)=>{
                    const isSelected = s.parent.isSelcetedActive ? el.getSelectedKey() : '';
                    if (isSelected) s.selected = isSelected.startsWith('/') ? isSelected : '?selected=' + el.getSelectedKey();
                    else s.selected = '';
                    if (s.parent.env) {
                        const prefix = (isSelected ? '&' : '?') + 'env=';
                        s.env = ({
                            Current: prefix + 'dev',
                            Development: '',
                            Staging: prefix + 'staging',
                            Production: prefix + 'production'
                        })[s.parent.env];
                    }
                },
                Icon: null,
                Hgroup: {
                    H: {
                        text: '{{ title }}'
                    },
                    P: {
                        text: (el)=>'{{ domain }}{{ path }}{{ selected }}{{ env }}'
                    }
                },
                Upgrade: null,
                Copy: {
                    extends: [
                        'CanvasButton',
                        'IconButton'
                    ],
                    padding: 'Y2',
                    margin: '-Y - - auto',
                    icon: 'copy outline',
                    value: '{{ env }}{{ domain }}{{ path }}{{ selection }}',
                    Icon: {
                        order: 2,
                        color: 'blue'
                    }
                },
                Open: {
                    extends: [
                        'CanvasButton',
                        'Link',
                        'IconButton'
                    ],
                    padding: 'Y2',
                    margin: '-Y -Y2 -',
                    icon: 'arrow up right',
                    href: 'https://{{ domain }}{{ path }}{{ selection }}',
                    target: '_blank'
                }
            },
            childrenAs: 'state',
            children: [
                {
                    title: 'Preview link',
                    domain: 'preview.symbo.ls'
                },
                {
                    title: 'Canvas link',
                    domain: 'symbols.app'
                }
            ]
        }
    },
    Line: {
        margin: '-Z2'
    },
    SharingPermissions: {},
    flow: 'x',
    width: 'G1',
    flow: 'y',
    gap: 'C',
    padding: 'Z1 A',
    textAlign: 'start'
};

});

parcelRegister("cb5vV", function(module, exports) {

$parcel$export(module.exports, "Dropdown.Publish", () => $8ddaca0b6a4ecb64$export$cb51629418732a88);
const $8ddaca0b6a4ecb64$export$cb51629418732a88 = {
    Publish: {
        key: 'publish',
        CaptionTitle: {
            Text: {
                text: 'Publish'
            }
        },
        Section: {
            extends: 'PublishTools'
        }
    },
    Line: {
        margin: '-A2 0',
        ignoreChildProps: true
    },
    Sync: {
        key: 'sync',
        CaptionTitle: {
            Text: {
                text: 'Sync'
            }
        },
        Section: {
            extends: 'SyncSuggestionsInPublish'
        }
    },
    Line_2: {
        margin: '-A2 0',
        ignoreChildProps: true
    },
    Export: {
        key: 'export',
        CaptionTitle: {
            Text: {
                text: 'Export'
            }
        },
        Section: {
            extends: 'ExportsInPublish'
        }
    },
    flow: 'x',
    childExtends: 'Flex',
    width: 'G3',
    flow: 'y',
    gap: 'C',
    padding: 'Z1 A',
    textAlign: 'start',
    childProps: {
        flow: 'y',
        gap: 'A',
        CaptionTitle: {
            extends: [
                'CaptionTitle',
                'CanvasButton'
            ],
            margin: '- -A2',
            padding: 'A A2',
            round: 'Z2',
            Text: {},
            Icon: {
                margin: '- - - auto',
                icon: (el, s)=>s.activeOutput === el.parent.parent.key ? 'arrow angle up' : 'arrow angle down'
            },
            onClick: (ev, el, s)=>s.update({
                    activeOutput: el.parent.key
                })
        },
        Section: {
            show: (el, s)=>s.activeOutput === el.parent.key
        }
    }
};

});

parcelRegister("dXaex", function(module, exports) {

$parcel$export(module.exports, "SelectedLayerNavbar", () => $a288b937340013ef$export$de7c879de145bf13);
const $a288b937340013ef$export$de7c879de145bf13 = {
    if: (el)=>true,
    state: {
        value: {}
    },
    EditorTools: {
        padding: '0',
        margin: '0',
        hide: (el, s)=>s.isEditMode,
        gap: 'U',
        childExtends: 'NavbarButton',
        AddBtn: {
            order: '-1',
            icon: 'plus',
            title: 'Add children',
            onClick: (ev, el, s)=>{}
        },
        Remove: {
            icon: 'trash',
            title: 'Remove'
        },
        TextNavbarButtonDropdown: {},
        ContextBtn: {
            icon: 'three dots vertical',
            title: 'Options',
            onClick: (ev, el, s)=>{
                el.activateContext(ev, s.key);
            },
            order: 3
        }
    },
    EditorPositionNavbar: null,
    NavbarButtonSet_title: null,
    NavbarButtonSet_meta: null,
    extends: 'EditNavbar',
    fontSize: 'Y2',
    position: 'absolute',
    bottom: '100%',
    margin: 'Z -',
    left: '50%',
    width: 'auto',
    transition: 'X opacity defaultBezier',
    padding: '0 X',
    round: 'Z2',
    top: 'auto',
    pointerEvents: 'auto',
    borderColor: 'line',
    borderWidth: '1px',
    borderStyle: 'solid',
    theme: 'common-box',
    transform: 'translate3d(-50%, 0, 1px)'
};

});

parcelRegister("eT5im", function(module, exports) {

$parcel$export(module.exports, "QuickEditor", () => $ad6a4f3bca3779b4$export$cf3f49582cb93bb8);
const $ad6a4f3bca3779b4$export$cf3f49582cb93bb8 = {
    state: {
        recents: [],
        recentsIndex: 0,
        showLayers: true
    },
    data: {
        prevSelected: null
    },
    Header: {
        flow: 'x',
        align: 'center start',
        padding: 'Y Y1',
        gap: 'Z',
        width: '100%',
        Text: {
            tag: 'span',
            fontSize: 'Z2',
            maxWidth: '65%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        },
        QuickEditorNavbar: {
            margin: '- - - auto'
        }
    },
    Content: {
        tag: 'div',
        class: 'layers',
        fontSize: 'A1',
        overflow: 'hidden auto',
        maxHeight: 'calc(100vh - D2 - W2)',
        padding: '0 Y1 Y1'
    },
    PromptAI: {
        margin: 'auto - -',
        order: 2,
        hide: true
    },
    flow: 'y',
    gap: '0',
    position: 'absolute',
    top: 'C+X2',
    padding: '0',
    left: '--canvas-gutter',
    round: 'Z2',
    borderColor: 'line',
    borderWidth: '1px',
    borderStyle: 'solid',
    theme: 'common-box',
    minWidth: 'H',
    width: 'H',
    fontSize: 'Y2',
    opacity: '0',
    onRender: (el)=>{
        el.node.style.opacity = '0';
        el.node.style.pointerEvents = 'none';
        setInterval(()=>{
            if (!el.node) return;
            const s = el.state;
            const selected = el.getSelectedKey();
            const editorActive = el.getCanvasScope('editorActive');
            if (!selected || editorActive === false) {
                if (el.node.style.opacity !== '0') {
                    el.node.style.opacity = '0';
                    el.node.style.pointerEvents = 'none';
                }
                if (el.data.prevSelected) el.data.prevSelected = null;
                return;
            }
            if (el.node.style.opacity === '0') {
                el.node.style.opacity = '1';
                el.node.style.pointerEvents = '';
            }
            if (selected !== el.data.prevSelected) {
                el.data.prevSelected = selected;
                const selectedEl = el.getSelected();
                if (selectedEl?.state?.parse) {
                    const componentState = el.call('deepClone', selectedEl.state.parse());
                    componentState.showLayers = s.showLayers !== undefined ? s.showLayers : true;
                    componentState.recents = s.recents || [];
                    componentState.recentsIndex = s.recentsIndex || 0;
                    s.replace(componentState);
                    // Set title text
                    const textEl = el.Header?.Text;
                    if (textEl?.node) textEl.node.textContent = selected;
                    // Build recursive layer tree
                    const cn = el.Content?.node;
                    if (cn && componentState.value && typeof componentState.value === 'object') {
                        cn.style.display = '';
                        cn.textContent = '';
                        const isChild = (k, v)=>/^[A-Z]/.test(k) && v && typeof v === 'object' && !Array.isArray(v);
                        const buildLayers = (obj, container, depth)=>{
                            const entries = Object.keys(obj).filter((k)=>isChild(k, obj[k]));
                            for (const k of entries){
                                const child = obj[k];
                                const hasChildren = Object.keys(child).some((ck)=>isChild(ck, child[ck]));
                                const row = document.createElement('div');
                                row.style.cssText = 'padding:1px 0;cursor:default;padding-left:' + depth * 12 + 'px';
                                const arrow = hasChildren ? '\u25B8 ' : '\u00B7 ';
                                row.textContent = arrow + k;
                                container.appendChild(row);
                                if (hasChildren) {
                                    const nested = document.createElement('div');
                                    buildLayers(child, nested, depth + 1);
                                    container.appendChild(nested);
                                }
                            }
                        };
                        buildLayers(componentState.value, cn, 0);
                    }
                }
            }
        }, 100);
    }
};

});

parcelRegister("2Ditr", function(module, exports) {

$parcel$export(module.exports, "FileItem", () => $1ead8dd582fb6f03$export$a964e6adf466d4a6);
const $1ead8dd582fb6f03$export$a964e6adf466d4a6 = {
    data: {},
    Span: {
        order: '-1',
        class: 'dot',
        boxSize: '1.618ch',
        text: "\u30FB",
        color: 'placeholder',
        position: 'relative',
        textDecoration: 'none',
        hasError: (el, s)=>{
            if (!el.call('hasArtboard', s.type)) return false;
            const item = el.call('getItem', s.key);
            return Boolean(item?.state?.error);
        },
        '.hasError': {
            color: 'red'
        },
        Icon: {
            left: 0,
            top: 0,
            position: 'absolute',
            color: 'placeholder',
            name: (el, s)=>`arrow angle ${s.showLayers ? 'down' : 'right'}`,
            visibility: 'hidden',
            opacity: 0,
            transition: 'A defaultBezier',
            transitionProperty: 'opacity, transform',
            hasLayers: (el, s)=>Boolean(el.call('hasArtboard', s.type)),
            '!hasLayers': {
                pointerEvents: 'none'
            },
            onClick: (ev, el, s)=>{
                ev.stopPropagation();
                ev.preventDefault();
                if (!el.call('hasArtboard', s.type)) return;
                // Check for Ctrl+Click or Cmd+Click (Mac)
                const isCtrlOrCmdClick = ev && (ev.ctrlKey || ev.metaKey);
                if (isCtrlOrCmdClick) // Expand all nested layers recursively
                el.call('expandAllLayersForParentComponent', el, s);
                else // Normal click - just toggle
                s.update({
                    showLayers: !s.showLayers
                });
            }
        }
    },
    Text: {
        class: 'text',
        show: (el, s)=>!s.editing,
        text: '{{ key }}',
        maxWidth: '65%',
        overflow: 'hidden',
        padding: '.1em - .1em',
        position: 'relative',
        textOverflow: 'ellipsis'
    },
    EditCode: {
        extends: 'NavbarButton',
        if: (el)=>el.isEditMode(),
        hide: (el, s)=>s.editing || !el.call('hasArtboard', s.type),
        class: 'layer-controls',
        padding: 'Y',
        margin: '-W -Y -W auto',
        icon: 'code',
        onClick: (ev, el, s)=>{
            ev.preventDefault();
            ev.stopPropagation();
            el.setWindow('componentEditor', 'code');
            el.activateSelected(s.key);
        }
    },
    Rename: {
        extends: 'FileSidebarAddNewItem',
        show: (el, s)=>Boolean(s.editing),
        flex: 1,
        Label: {
            margin: '0 0 0 -1.4em',
            padding: '0 0 0 1.4em',
            Icon: null,
            Input: {
                flex: 1,
                value: (el, s)=>s.key,
                name: 'new-key',
                onInput: ()=>{}
            },
            Flex: {
                Save: {
                    type: 'submit'
                },
                Close: {
                    onClick: (ev, el, s)=>{
                        ev.preventDefault();
                        ev.stopPropagation();
                        s.update({
                            editing: false
                        });
                    }
                }
            },
            Err: {
                whiteSpace: 'pre-line',
                padding: 'X Y',
                theme: 'modal',
                round: 'X',
                fontSize: 'Y2',
                position: 'static'
            }
        },
        onSubmit: async (ev, el, s)=>{
            ev.preventDefault();
            el.node.reset();
            s.update({
                editing: false,
                key: newKey
            });
        }
    },
    content: (el, s)=>{
        if (!s.value) return;
        if (!s.showLayers || !el.call('hasArtboard', s.type)) return {
            hide: true
        };
        return {
            extends: 'Layers',
            minWidth: '100%',
            margin: '-Z2 - - -B',
            flex: 1,
            onClick: (ev)=>ev.stopPropagation()
        };
    },
    extends: 'Button',
    position: 'relative',
    padding: 'Y Y1',
    zIndex: '1',
    theme: 'transparent',
    isActive: (el, s)=>s.showLayers,
    isCurrent: (el, s)=>s.key === el.getSelectedKey(),
    width: '100%',
    align: 'center start',
    flow: 'x wrap',
    userSelect: 'none',
    gap: 'Z',
    round: 'Z2',
    draggable: (el, s)=>!s.showLayers && el.call('hasArtboard', s.type),
    dragstart: {
        transform: 'scale(0.97)',
        opacity: '0',
        isDragging: true
    },
    onDragstart: (ev, el, s)=>{
        if (s.showLayers || !el.call('hasArtboard', s.type)) return;
        ev.stopPropagation();
        if (ev.dataTransfer) {
            ev.dataTransfer.setData('text/component-key', s.key);
            ev.dataTransfer.effectAllowed = 'move';
        }
        if (!el.parent.data) el.parent.data = {};
        el.update(el.dragstart);
        el.parent.data.fromIndex = el.key;
        el.parent.data.state = s.parent;
    },
    onDragover: (ev, el, s)=>{
        if (s.showLayers || !el.call('hasArtboard', s.type)) return;
        ev.stopPropagation();
        ev.preventDefault();
        if (!el.parent.data) return;
        return false;
    },
    drop: {
        opacity: '1',
        transform: 'none'
    },
    onDrop: (ev, el, s)=>{
        if (s.showLayers || !el.call('hasArtboard', s.type)) return;
        if (!el.parent.data) return;
        el.call('reorderComponents', ev);
    },
    dragend: {
        opacity: '1',
        transform: 'none',
        isDragging: false
    },
    onDragend: (e, el, s)=>{
        el.update(el.dragend);
    },
    ':hover .dot': {
        color: 'transparent',
        '& svg': {
            opacity: 1,
            visibility: 'visible'
        }
    },
    ':hover .layer-controls': {
        opacity: 1
    },
    ':after': {
        content: '""',
        borderStyle: 'solid',
        borderColor: 'dim',
        borderWidth: '0 0 0 0',
        position: 'absolute',
        inset: '-W auto -W -Z'
    },
    '.isActive': {
        theme: 'layer',
        '& .dot': {
            color: 'transparent',
            '& svg': {
                opacity: 1,
                visibility: 'visible'
            }
        },
        '.isCurrent': {
            theme: 'field'
        },
        '& .layer-controls': {
            opacity: 1
        }
    },
    '!isActive': {
        color: 'caption',
        fontWeight: 400,
        opacity: '.85',
        '.isCurrent': {
            theme: 'field'
        },
        '& .layer-controls': {
            opacity: 0
        }
    },
    sidebarItem: true
};

});

parcelRegister("6hQiz", function(module, exports) {

$parcel$export(module.exports, "QuickEditorNavbar", () => $493ce5fbcd46c661$export$ebb8fd26c6d9e82);
const $493ce5fbcd46c661$export$ebb8fd26c6d9e82 = {
    Back: {
        icon: 'arrow angle left',
        hasBack: (el, s)=>{
            return s.recentsIndex < s.recents.length - 1;
        },
        '!hasBack': {
            opacity: '0.35',
            pointerEvents: 'none'
        },
        onClick: (ev, el, s)=>{
            const recents = s.recents;
            s.recentsIndex++;
            const prev = recents?.[s.recentsIndex];
            if (prev) el.setWindow('explorer', prev, {
                skipRecentsIndexing: true
            });
        }
    },
    Forward: {
        icon: 'arrow angle right',
        hasForward: (el, s)=>{
            return s.recentsIndex > 0;
        },
        '!hasForward': {
            opacity: '0.35',
            pointerEvents: 'none'
        },
        onClick: (ev, el, s)=>{
            const recents = s.recents;
            s.recentsIndex--;
            const next = recents?.[s.recentsIndex];
            if (next) el.setWindow('explorer', next, {
                skipRecentsIndexing: true
            });
        }
    },
    Close: {
        icon: 'crossmark',
        onClick: (ev, el)=>{
            el.getCanvasScope().editorActive = false;
        }
    },
    extends: 'NavbarButtonSet',
    padding: '0',
    childProps: {
        padding: 'Y'
    },
    gap: 'W',
    fontSize: 'Z2'
};

});

parcelRegister("hQB5t", function(module, exports) {

$parcel$export(module.exports, "ResponsiveToolBar", () => $cfe40fc0d8228f8a$export$696d596d48f633c3);
const $cfe40fc0d8228f8a$export$696d596d48f633c3 = {
    DeviceButtonSet: {
        flow: 'row-reverse'
    },
    ThreeDots: {
        extends: [
            'ClickableItem',
            'SquareButton'
        ],
        icon: 'threeDots vertical'
    },
    flow: 'x',
    gap: 'A'
};

});

parcelRegister("fCqyG", function(module, exports) {

$parcel$export(module.exports, "FilesSectionTitle", () => $b5ef0193614109ac$export$72f1c110d94c44ca);
const $b5ef0193614109ac$export$72f1c110d94c44ca = {
    tag: 'header',
    IconButton_arrow: {
        isVisible: (el, s)=>el.call('getCookie', `sidebar_${s.type}`) !== 'false',
        transition: 'A defaultBezier opacity',
        margin: '- -Y - -A1',
        color: 'dim',
        fontSize: 'Z2',
        // margin: '- - - auto',
        background: 'transparent',
        theme: null,
        opacity: (el, s)=>el.call('getCookie', `sidebar_${s.type}`) !== 'false' ? 0 : 1,
        icon: (el, s)=>`arrow angle ${el.call('getCookie', `sidebar_${s.type}`) !== 'false' ? 'down' : 'right'}`,
        // eslint-disable-next-line no-shadow,
        onClick: (ev, el, s)=>{
            // eslint-disable-next-line no-shadow
            const isVisible = el.call('getCookie', `sidebar_${s.type}`) !== 'false';
            el.call('setCookie', `sidebar_${s.type}`, !isVisible);
            s.update();
        }
    },
    Span: {
        extends: [
            'CaptionTitle',
            'Flex'
        ],
        margin: 'W auto - -',
        ':hover': {
            color: 'paragraph'
        },
        Text: {
            text: (el, s)=>s.type?.replace('_', ' ')
        },
        onClick: (ev, el, s)=>{
            const isVisible = el.call('getCookie', `sidebar_${s.type}`) !== 'false';
            el.call('setCookie', `sidebar_${s.type}`, !isVisible);
            s.update();
        }
    },
    'NavbarButton.question': {
        transition: 'A defaultBezier opacity',
        color: 'disabled',
        icon: 'question mark',
        title: 'Docs',
        fontSize: 'Z2',
        onClick: (ev, el, s)=>{
            ev.preventDefault();
            ev.stopPropagation();
            el.setWindow('docs', '/' + s.type);
        }
    },
    extends: 'Navbar',
    top: 0,
    zIndex: 2,
    position: 'sticky',
    minWidth: '100%',
    userSelect: 'none',
    theme: 'common-box',
    align: 'center',
    margin: '- -Y1',
    padding: '- Y1',
    fontSize: 'Z2'
};

});

parcelRegister("AgV21", function(module, exports) {

$parcel$export(module.exports, "FilesSection", () => $06d07ca45285d103$export$fcea42f222a3cf63);
const $06d07ca45285d103$export$fcea42f222a3cf63 = {
    FilesSectionTitle: {},
    FilesSectionList: {
        margin: '- -Y'
    },
    flow: 'y',
    padding: '- - X2',
    flow: 'column',
    gap: 'X2',
    ':hover': {
        '& header > button, & header > a': {
            opacity: 1
        }
    }
};

});

parcelRegister("19ak9", function(module, exports) {

$parcel$export(module.exports, "FilesSectionList", () => $0d5ea3de0f077732$export$cc9acfeac802bc55);
const $0d5ea3de0f077732$export$cc9acfeac802bc55 = {
    flow: 'y',
    childExtends: 'FileItem',
    fontSize: 'Z2',
    flow: 'column',
    align: 'stretch',
    gap: 'X1',
    childrenAs: 'state',
    children: [
        {
            type: 'components',
            key: 'Logo',
            value: {
                Img: {}
            }
        },
        {
            type: 'components',
            key: 'Header',
            value: {
                Logo: {}
            }
        }
    ]
};

});

parcelRegister("3lF3g", function(module, exports) {

$parcel$export(module.exports, "CodePreviewWidget", () => $27032d3d62e8ad8e$export$20ad329bbe9c5d2c);


const $27032d3d62e8ad8e$var$Monaco = {
    flex: 1,
    position: 'relative',
    foldLevel: 2,
    opacity: 1,
    height: '100%',
    width: '100%',
    beautify: true,
    debounceDuration: 350,
    data: {},
    fileTab: {
        code: 'export default {}',
        type: 'javascript',
        filename: 'app.js',
        fileTabKey: 'unique-key'
    },
    onCodeEditCallback: (editor, _2, el)=>{
        el.log(editor.getValue());
    },
    onRender: async (el, s)=>{
        const { StandaloneMonaco: StandaloneMonaco } = await (parcelRequire("lf4o0"));
        await StandaloneMonaco.onRender(el, s);
    },
    onBeforeUpdate: async (_, el, s, ctx, opts)=>{
        const { StandaloneMonaco: StandaloneMonaco } = await (parcelRequire("lf4o0"));
        return StandaloneMonaco.onBeforeUpdate(_, el, s, ctx, opts);
    }
};
const $27032d3d62e8ad8e$export$20ad329bbe9c5d2c = {
    display: 'flex',
    flow: 'column',
    position: 'sticky',
    top: '0',
    order: 0,
    widthRange: 'H1',
    Flex_tabs: {},
    Monaco: $27032d3d62e8ad8e$var$Monaco
};

});
parcelRegister("lf4o0", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("fFMZG"))(import.meta.resolve("5FE01")),
    import("hK3SS"),
    import("kDmLS")
]).then(()=>parcelRequire('5SF8t'));

});
parcelRegister("fFMZG", function(module, exports) {
"use strict";

var $lovBw = parcelRequire("lovBw");
module.exports = $lovBw(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("lovBw", function(module, exports) {
"use strict";
var $f9345ad2c034f768$var$cachedBundles = {};
var $f9345ad2c034f768$var$cachedPreloads = {};
var $f9345ad2c034f768$var$cachedPrefetches = {};
function $f9345ad2c034f768$var$getCache(type) {
    switch(type){
        case 'preload':
            return $f9345ad2c034f768$var$cachedPreloads;
        case 'prefetch':
            return $f9345ad2c034f768$var$cachedPrefetches;
        default:
            return $f9345ad2c034f768$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $f9345ad2c034f768$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});




parcelRegister("k216J", function(module, exports) {

$parcel$export(module.exports, "commandDefs", () => $e954da7b854b7278$export$987a47818e82961);
$parcel$export(module.exports, "commands", () => $e954da7b854b7278$export$2ccc4f72dd956183);
$parcel$export(module.exports, "CommandBar", () => $e954da7b854b7278$export$afe2359305e787af);
const $e954da7b854b7278$var$getGS = ()=>window.__canvasGlobalScope;
const $e954da7b854b7278$var$getIframeWindow = ()=>{
    const iframe = document.getElementById('canvas-iframe');
    return iframe?.contentWindow || window;
};
const $e954da7b854b7278$export$987a47818e82961 = [
    {
        name: 'zoom',
        description: 'Set zoom level',
        args: [
            '25',
            '50',
            '75',
            '100',
            '150',
            '200'
        ]
    },
    {
        name: 'mode',
        description: 'Switch canvas mode',
        args: [
            'default',
            'inspect',
            'panning',
            'interact'
        ]
    },
    {
        name: 'editor',
        description: 'Toggle QuickEditor',
        args: null
    },
    {
        name: 'settings',
        description: 'Open settings',
        args: null
    },
    {
        name: 'go',
        description: 'Navigate to route',
        args: [
            'dashboard',
            'canvas',
            'settings'
        ]
    },
    {
        name: 'open',
        description: 'Open in explorer',
        args: 'dynamic'
    },
    {
        name: 'select',
        description: 'Select on canvas',
        args: 'dynamic'
    },
    {
        name: 'search',
        description: 'Search canvas',
        args: null
    },
    {
        name: 'docs',
        description: 'Open documentation',
        args: null
    },
    {
        name: 'theme',
        description: 'Toggle theme',
        args: [
            'dark',
            'light'
        ]
    },
    // Canvas v2 commands.
    {
        name: 'auto-layout',
        description: 'Cluster items by route + tile',
        args: null
    },
    {
        name: 'fit',
        description: 'Fit selection (or all) to view',
        args: null
    },
    {
        name: 'reset',
        description: 'Reset viewport to 35%',
        args: null
    },
    {
        name: 'undo',
        description: 'Undo last canvas change',
        args: null
    },
    {
        name: 'redo',
        description: 'Redo',
        args: null
    },
    {
        name: 'duplicate',
        description: 'Duplicate selection',
        args: null
    },
    {
        name: 'delete',
        description: 'Delete selection',
        args: null
    },
    {
        name: 'group',
        description: 'Group selection',
        args: null
    },
    {
        name: 'ungroup',
        description: 'Ungroup selection',
        args: null
    },
    {
        name: 'snap',
        description: 'Toggle snap',
        args: [
            'on',
            'off',
            'grid',
            'items',
            'guides'
        ]
    },
    {
        name: 'grid-step',
        description: 'Set snap-grid step (canvas px)',
        args: 'dynamic'
    },
    {
        name: 'frame-mode',
        description: 'Toggle live iframe previews',
        args: [
            'on',
            'off'
        ]
    },
    {
        name: 'guides',
        description: 'Manage guides',
        args: [
            'clear'
        ]
    },
    {
        name: 'shortcuts',
        description: 'Show shortcuts overlay',
        args: null
    },
    {
        name: 'help',
        description: 'Show shortcuts overlay',
        args: null
    },
    {
        name: 'align',
        description: 'Align selection',
        args: [
            'left',
            'right',
            'top',
            'bottom',
            'center',
            'middle'
        ]
    },
    {
        name: 'distribute',
        description: 'Distribute selection equally',
        args: [
            'horizontal',
            'vertical'
        ]
    }
];
const $e954da7b854b7278$export$2ccc4f72dd956183 = {
    zoom (el, args) {
        const value = parseFloat(args[0]);
        if (!value || value <= 0) return 'Usage: /zoom [percentage]';
        const gs = $e954da7b854b7278$var$getGS();
        if (!gs?.panzoomInstance) return 'No canvas instance';
        const win = $e954da7b854b7278$var$getIframeWindow();
        const { x: x, y: y } = gs.positions;
        gs.panzoomInstance.smoothZoomAbs(x + win.innerWidth / 2, y + win.innerHeight / 2, value / 100);
        return `Zoom set to ${value}%`;
    },
    mode (el, args) {
        const modes = [
            'defaultMode',
            'inspectMode',
            'panningMode',
            'interactMode'
        ];
        const arg = (args[0] || '').toLowerCase();
        if (!arg) return 'Usage: /mode [default|inspect|panning|interact]';
        // Accept short names ('interact' → 'interactMode'); existing chrome
        // speaks v1-style flags which methods/index.js bridges to v2.
        const resolved = modes.find((m)=>m.toLowerCase().startsWith(arg));
        if (!resolved) return 'Unknown mode';
        el.setCanvasMode(resolved);
        return `Switched to ${resolved.replace('Mode', '')}`;
    },
    editor (el) {
        const cs = el.getCanvasScope();
        cs.editorActive = !cs.editorActive;
        return `Editor ${cs.editorActive ? 'opened' : 'closed'}`;
    },
    settings (el) {
        el.call('openModal', '/settings', {
            key: '/settings'
        });
        return 'Settings opened';
    },
    go (el, args) {
        const path = args[0];
        if (!path) return 'Usage: /go [path]';
        el.router(path, el.getRoot());
        return `Navigated to ${path}`;
    },
    open (el, args) {
        const key = args[0];
        if (!key) return 'Usage: /open [key]';
        el.call('setWindow', 'explorer', key);
        return `Opened ${key}`;
    },
    select (el, args) {
        const key = args[0];
        if (!key) return 'Usage: /select [key]';
        const rs = el.getRootState();
        const data = rs?.data;
        const type = data?.pages?.[key] ? 'pages' : 'components';
        el.call('openArtboardItem', type, key);
        return `Selected ${key}`;
    },
    search (el, args) {
        const query = args.join(' ');
        if (!query) return 'Usage: /search [query]';
        el.call('setWindow', 'explorer', 'search:' + query);
        return `Searching: ${query}`;
    },
    docs (el) {
        el.call('setWindow', 'explorer', 'onboarding');
        return 'Docs opened';
    },
    theme (el, args) {
        const target = args[0];
        if (target && target !== 'dark' && target !== 'light') return 'Usage: /theme [dark|light]';
        el.call('toggleTheme', target || undefined);
        return 'Theme toggled';
    },
    // ── Canvas v2 commands ────────────────────────────────────────────
    'auto-layout': (el)=>{
        el.call('autoLayout');
        return 'Auto-laid out';
    },
    fit: (el)=>{
        el.call('fitToSelection');
        return 'Fit to selection';
    },
    reset: (el)=>{
        el.call('resetCanvasView');
        return 'View reset';
    },
    undo: (el)=>{
        el.call('undo');
        return 'Undone';
    },
    redo: (el)=>{
        el.call('redo');
        return 'Redone';
    },
    duplicate: (el)=>{
        el.call('duplicateSelection');
        return 'Duplicated';
    },
    delete: (el)=>{
        el.call('deleteSelection');
        return 'Deleted';
    },
    group: (el)=>{
        el.call('group');
        return 'Grouped';
    },
    ungroup: (el)=>{
        const v2 = el.call('getCanvasV2');
        if (!v2) return 'No canvas';
        const ids = v2.selection.ids;
        Object.entries(v2.groups || {}).filter(([, g])=>g.children.some((c)=>ids.includes(c))).forEach(([gid])=>el.call('ungroup', gid));
        return 'Ungrouped';
    },
    snap: (el, args)=>{
        const v2 = el.call('getCanvasV2');
        if (!v2) return 'No canvas';
        const a = (args[0] || '').toLowerCase();
        if (a === 'on') {
            el.call('patchSnap', {
                enabled: true
            });
            return 'Snap on';
        }
        if (a === 'off') {
            el.call('patchSnap', {
                enabled: false
            });
            return 'Snap off';
        }
        if (a === 'grid') {
            el.call('patchSnap', {
                toGrid: !v2.snap.toGrid
            });
            return `Grid snap ${!v2.snap.toGrid ? 'on' : 'off'}`;
        }
        if (a === 'items') {
            el.call('patchSnap', {
                toItems: !v2.snap.toItems
            });
            return `Item snap ${!v2.snap.toItems ? 'on' : 'off'}`;
        }
        if (a === 'guides') {
            el.call('patchSnap', {
                toGuides: !v2.snap.toGuides
            });
            return `Guide snap ${!v2.snap.toGuides ? 'on' : 'off'}`;
        }
        return 'Usage: /snap [on|off|grid|items|guides]';
    },
    'grid-step': (el, args)=>{
        const n = Math.max(4, Math.min(500, Number(args[0]) || 0));
        if (!n) return 'Usage: /grid-step [N]';
        el.call('patchSnap', {
            gridStep: n
        });
        return `Grid step: ${n}`;
    },
    'frame-mode': (el, args)=>{
        const v2 = el.call('getCanvasV2');
        if (!v2) return 'No canvas';
        const target = args[0] === 'on' ? true : args[0] === 'off' ? false : !v2.frameMode;
        el.call('patchCanvas', {
            frameMode: target
        });
        return `Frame mode ${target ? 'on' : 'off'}`;
    },
    guides: (el, args)=>{
        if (args[0] === 'clear') {
            el.call('patchCanvas', {
                guides: {
                    horizontal: [],
                    vertical: []
                }
            });
            return 'Guides cleared';
        }
        return 'Usage: /guides clear';
    },
    shortcuts: (el)=>{
        el.call('openKeyboardShortcuts');
        return 'Shortcuts overlay';
    },
    help: (el)=>{
        el.call('openKeyboardShortcuts');
        return 'Shortcuts overlay';
    },
    align: (el, args)=>{
        const v2 = el.call('getCanvasV2');
        if (!v2) return 'No canvas';
        const ids = v2.selection.ids;
        if (ids.length < 2) return 'Select 2+ items first';
        const dir = (args[0] || '').toLowerCase();
        const items = v2.items;
        const rects = ids.map((id)=>items[id]).filter(Boolean);
        const nodeMap = $e954da7b854b7278$var$buildCanvasItemNodeMap();
        let target;
        if (dir === 'left') {
            const minX = Math.min(...rects.map((r)=>r.x));
            target = ()=>({
                    x: minX
                });
        } else if (dir === 'right') {
            const maxRight = Math.max(...rects.map((r)=>r.x + r.w));
            target = (r)=>({
                    x: maxRight - r.w
                });
        } else if (dir === 'top') {
            const minY = Math.min(...rects.map((r)=>r.y));
            target = ()=>({
                    y: minY
                });
        } else if (dir === 'bottom') {
            const maxBottom = Math.max(...rects.map((r)=>r.y + r.h));
            target = (r)=>({
                    y: maxBottom - r.h
                });
        } else if (dir === 'center') {
            const cx = (Math.min(...rects.map((r)=>r.x)) + Math.max(...rects.map((r)=>r.x + r.w))) / 2;
            target = (r)=>({
                    x: cx - r.w / 2
                });
        } else if (dir === 'middle') {
            const cy = (Math.min(...rects.map((r)=>r.y)) + Math.max(...rects.map((r)=>r.y + r.h))) / 2;
            target = (r)=>({
                    y: cy - r.h / 2
                });
        } else return 'Usage: /align [left|right|top|bottom|center|middle]';
        ids.forEach((id)=>{
            const r = items[id];
            if (!r) return;
            const patch = target(r);
            el.call('patchCanvasItem', id, patch);
            $e954da7b854b7278$var$applyItemNodePatch(nodeMap.get(id), patch);
        });
        el.call('refreshCanvasChrome');
        el.call('pushHistory');
        el.call('persistCanvasLayout');
        return `Aligned ${dir}`;
    },
    distribute: (el, args)=>{
        const v2 = el.call('getCanvasV2');
        if (!v2) return 'No canvas';
        const ids = v2.selection.ids;
        if (ids.length < 3) return 'Select 3+ items first';
        const axisArg = (args[0] || '').toLowerCase();
        const axis = axisArg.startsWith('h') ? 'h' : axisArg.startsWith('v') ? 'v' : null;
        if (!axis) return 'Usage: /distribute [horizontal|vertical]';
        const items = v2.items;
        const sorted = [
            ...ids
        ].filter((id)=>items[id]).sort((a, b)=>axis === 'h' ? items[a].x - items[b].x : items[a].y - items[b].y);
        const first = items[sorted[0]];
        const last = items[sorted[sorted.length - 1]];
        const nodeMap = $e954da7b854b7278$var$buildCanvasItemNodeMap();
        const axisKey = axis === 'h' ? 'x' : 'y';
        const sizeKey = axis === 'h' ? 'w' : 'h';
        const total = last[axisKey] + last[sizeKey] - first[axisKey];
        const sum = sorted.reduce((acc, id)=>acc + items[id][sizeKey], 0);
        const gap = (total - sum) / (sorted.length - 1);
        let cursor = first[axisKey];
        sorted.forEach((id)=>{
            const r = items[id];
            const patch = {
                [axisKey]: cursor
            };
            el.call('patchCanvasItem', id, patch);
            $e954da7b854b7278$var$applyItemNodePatch(nodeMap.get(id), patch);
            cursor += r[sizeKey] + gap;
        });
        el.call('refreshCanvasChrome');
        el.call('pushHistory');
        el.call('persistCanvasLayout');
        return `Distributed ${axis === 'h' ? 'horizontally' : 'vertically'}`;
    }
};
// One DOM query per invocation — avoids N selector scans inside the
// forEach loop below. patchCanvasItem is a non-reactive in-place
// mutation, so we still need the imperative style write for immediate
// visual feedback.
function $e954da7b854b7278$var$buildCanvasItemNodeMap() {
    const map = new Map();
    document.querySelectorAll('[data-canvas-item]').forEach((n)=>{
        map.set(n.getAttribute('data-canvas-item'), n);
    });
    return map;
}
function $e954da7b854b7278$var$applyItemNodePatch(node, patch) {
    if (!node) return;
    if (patch.x !== undefined) node.style.left = patch.x + 'px';
    if (patch.y !== undefined) node.style.top = patch.y + 'px';
}
function $e954da7b854b7278$var$runCommand(bar, input) {
    const value = (typeof input === 'string' ? input : bar.Input.node.value).trim();
    if (!value || !value.startsWith('/')) return;
    const parts = value.slice(1).split(/\s+/);
    const cmd = parts[0].toLowerCase();
    const args = parts.slice(1);
    const handler = $e954da7b854b7278$export$2ccc4f72dd956183[cmd];
    const result = handler ? handler(bar, args) : `Unknown: /${cmd}`;
    bar.Input.node.value = '';
    $e954da7b854b7278$var$hideDropdown(bar);
    bar.Input.node.blur();
    if (bar.data.feedbackTimer) clearTimeout(bar.data.feedbackTimer);
    if (bar.Feedback?.node) {
        bar.Feedback.node.textContent = result;
        bar.Feedback.node.style.opacity = '1';
        bar.data.feedbackTimer = setTimeout(()=>{
            if (bar.Feedback?.node) bar.Feedback.node.style.opacity = '0';
        }, 3000);
    }
}
function $e954da7b854b7278$var$getDynamicArgs(bar, cmd) {
    const items = [];
    try {
        const rs = bar.getRootState();
        const data = rs?.data;
        if (!data) return items;
        const categories = [
            {
                key: 'pages',
                label: 'Pages'
            },
            {
                key: 'components',
                label: 'Components'
            },
            {
                key: 'functions',
                label: 'Functions'
            }
        ];
        for (const cat of categories){
            const obj = data[cat.key];
            if (!obj || typeof obj !== 'object') continue;
            const keys = Object.keys(obj);
            if (!keys.length) continue;
            items.push({
                label: cat.label,
                type: 'header'
            });
            for (const k of keys)items.push({
                label: k,
                description: cat.key.slice(0, -1),
                type: 'arg',
                fullValue: '/' + cmd + ' ' + k
            });
        }
    } catch (e) {
    /* rootState may not be available */ }
    return items;
}
function $e954da7b854b7278$var$getFilteredItems(bar, value) {
    const raw = value || '';
    const trimmed = raw.trim();
    if (!trimmed || !trimmed.startsWith('/')) return $e954da7b854b7278$export$987a47818e82961.map((c)=>({
            label: '/' + c.name,
            description: c.description,
            type: 'command'
        }));
    const parts = trimmed.slice(1).split(/\s+/);
    const cmd = parts[0].toLowerCase();
    const hasSpace = raw.includes(' ');
    if (hasSpace) {
        const def = $e954da7b854b7278$export$987a47818e82961.find((c)=>c.name === cmd);
        if (!def) return [];
        if (def.args === 'dynamic') {
            const all = $e954da7b854b7278$var$getDynamicArgs(bar, cmd);
            const argFilter = (parts[1] || '').toLowerCase();
            if (!argFilter) return all;
            return all.filter((a)=>a.type === 'header' ? false : a.label.toLowerCase().includes(argFilter));
        }
        if (!def.args) return [
            {
                label: '/' + cmd,
                description: 'Run ' + def.description.toLowerCase(),
                type: 'run',
                fullValue: '/' + cmd
            }
        ];
        const argFilter = (parts[1] || '').toLowerCase();
        return def.args.filter((a)=>!argFilter || a.startsWith(argFilter)).map((a)=>({
                label: a,
                description: '',
                type: 'arg',
                fullValue: '/' + cmd + ' ' + a
            }));
    }
    return $e954da7b854b7278$export$987a47818e82961.filter((c)=>c.name.startsWith(cmd)).map((c)=>({
            label: '/' + c.name,
            description: c.description,
            type: 'command'
        }));
}
function $e954da7b854b7278$var$renderDropdown(bar, items, activeIndex) {
    const dropdown = bar.CmdDropdown?.node;
    if (!dropdown) return;
    dropdown.textContent = '';
    if (!items.length) {
        dropdown.style.opacity = '0';
        dropdown.style.visibility = 'hidden';
        return;
    }
    let selectableIndex = 0;
    items.forEach((item)=>{
        if (item.type === 'header') {
            const header = document.createElement('div');
            header.style.cssText = "padding:4px 8px 2px;font-size:0.8em;opacity:0.35;text-transform:uppercase;letter-spacing:0.05em;pointer-events:none;user-select:none;";
            header.textContent = item.label;
            dropdown.appendChild(header);
            return;
        }
        const idx = selectableIndex++;
        const row = document.createElement('div');
        row.style.cssText = "display:flex;align-items:center;justify-content:space-between;padding:4px 8px;cursor:pointer;border-radius:4px;gap:8px;" + (idx === activeIndex ? 'background:rgba(255,255,255,0.08);' : '');
        row.dataset.index = idx;
        row.dataset.itemIndex = items.indexOf(item);
        const left = document.createElement('span');
        left.style.cssText = 'font-weight:500;white-space:nowrap;';
        left.textContent = item.label;
        row.appendChild(left);
        if (item.description) {
            const right = document.createElement('span');
            right.style.cssText = 'opacity:0.4;font-size:0.9em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;';
            right.textContent = item.description;
            row.appendChild(right);
        }
        dropdown.appendChild(row);
    });
}
function $e954da7b854b7278$var$getSelectableItems(items) {
    return items.filter((i)=>i.type !== 'header');
}
function $e954da7b854b7278$var$updateDropdown(bar) {
    const value = bar.Input?.node?.value || '';
    const items = $e954da7b854b7278$var$getFilteredItems(bar, value);
    bar.data.filteredItems = items;
    bar.data.selectableItems = $e954da7b854b7278$var$getSelectableItems(items);
    bar.data.activeIndex = -1;
    $e954da7b854b7278$var$renderDropdown(bar, items, -1);
}
function $e954da7b854b7278$var$showDropdown(bar) {
    $e954da7b854b7278$var$updateDropdown(bar);
    const dropdown = bar.CmdDropdown?.node;
    if (dropdown) {
        dropdown.style.opacity = '1';
        dropdown.style.visibility = 'visible';
        dropdown.style.pointerEvents = 'auto';
    }
    bar.data.isOpen = true;
}
function $e954da7b854b7278$var$hideDropdown(bar) {
    const dropdown = bar.CmdDropdown?.node;
    if (dropdown) {
        dropdown.style.opacity = '0';
        dropdown.style.visibility = 'hidden';
        dropdown.style.pointerEvents = 'none';
    }
    bar.data.activeIndex = -1;
    bar.data.isOpen = false;
}
const $e954da7b854b7278$export$afe2359305e787af = {
    extends: 'Navbar',
    position: 'relative',
    gap: '0',
    round: 'C1',
    userSelect: 'none',
    cursor: 'text',
    minWidth: 'G+C',
    padding: '0',
    data: {
        feedbackTimer: null,
        filteredItems: [],
        selectableItems: [],
        activeIndex: -1,
        isOpen: false
    },
    onRender: (el)=>{
        if (el.__cmdBarInit) return;
        el.__cmdBarInit = true;
        el.node.addEventListener('click', (e)=>{
            const row = e.target.closest('[data-index]');
            if (!row) return;
            e.stopPropagation();
            const itemIdx = parseInt(row.dataset.itemIndex);
            const item = el.data.filteredItems[itemIdx];
            if (!item) return;
            if (item.type === 'run' || item.type === 'arg') $e954da7b854b7278$var$runCommand(el, item.fullValue);
            else {
                el.Input.node.value = item.label + ' ';
                $e954da7b854b7278$var$showDropdown(el);
                el.Input.node.focus();
            }
        });
        document.addEventListener('mousedown', (e)=>{
            // el.node is null once the CommandBar unmounts (e.g. route change);
            // the listener outlives the element, so guard against that.
            if (!el.node) return;
            if (!el.node.contains(e.target)) {
                $e954da7b854b7278$var$hideDropdown(el);
                el.Input?.node?.blur?.();
            }
        });
    },
    onClick: (e, el)=>{
        el.Input.node.focus();
        if (!el.data.isOpen) $e954da7b854b7278$var$showDropdown(el);
    },
    Icon: {
        name: 'chevronRight',
        width: 'A',
        height: 'A',
        margin: '- -B - -',
        opacity: '.35',
        flexShrink: '0',
        marginLeft: 'Z',
        pointerEvents: 'none'
    },
    Input: {
        tag: 'input',
        type: 'text',
        placeholder: 'Search or /command',
        theme: null,
        border: '0',
        outline: 'none',
        background: 'transparent',
        color: 'currentColor',
        fontFamily: 'inherit',
        width: '100%',
        padding: 'Z Z Z B2',
        flexGrow: '1',
        '::placeholder': {
            color: 'currentColor',
            opacity: '.25'
        },
        onInput: (e, el)=>{
            const bar = el.parent;
            $e954da7b854b7278$var$updateDropdown(bar);
        },
        onKeyDown: (e, el)=>{
            const bar = el.parent;
            const selectable = bar.data.selectableItems || [];
            let idx = bar.data.activeIndex;
            if (e.key === 'ArrowDown') {
                e.preventDefault();
                if (!bar.data.isOpen) {
                    $e954da7b854b7278$var$showDropdown(bar);
                    return;
                }
                idx = idx < selectable.length - 1 ? idx + 1 : 0;
                bar.data.activeIndex = idx;
                $e954da7b854b7278$var$renderDropdown(bar, bar.data.filteredItems, idx);
                return;
            }
            if (e.key === 'ArrowUp') {
                e.preventDefault();
                if (!bar.data.isOpen) {
                    $e954da7b854b7278$var$showDropdown(bar);
                    return;
                }
                idx = idx > 0 ? idx - 1 : selectable.length - 1;
                bar.data.activeIndex = idx;
                $e954da7b854b7278$var$renderDropdown(bar, bar.data.filteredItems, idx);
                return;
            }
            if (e.key === 'Tab') {
                e.preventDefault();
                const item = selectable[idx >= 0 ? idx : 0];
                if (!item) return;
                el.node.value = item.type === 'arg' ? item.fullValue : item.label + ' ';
                $e954da7b854b7278$var$updateDropdown(bar);
                return;
            }
            if (e.key === 'Enter') {
                e.preventDefault();
                if (idx >= 0 && selectable[idx]) {
                    const item = selectable[idx];
                    if (item.type === 'run') $e954da7b854b7278$var$runCommand(bar, item.fullValue);
                    else if (item.type === 'arg') $e954da7b854b7278$var$runCommand(bar, item.fullValue);
                    else {
                        el.node.value = item.label + ' ';
                        bar.data.activeIndex = -1;
                        $e954da7b854b7278$var$showDropdown(bar);
                    }
                    return;
                }
                if (!el.node.value.trim()) return;
                $e954da7b854b7278$var$runCommand(bar, el.node.value);
            }
            if (e.key === 'Escape') {
                e.preventDefault();
                if (el.node.value) {
                    el.node.value = '';
                    $e954da7b854b7278$var$updateDropdown(bar);
                } else {
                    $e954da7b854b7278$var$hideDropdown(bar);
                    el.node.blur();
                }
            }
        }
    },
    CmdDropdown: {
        position: 'absolute',
        top: '100%',
        left: '0',
        right: '0',
        marginTop: 'Y',
        flow: 'y',
        gap: 'W',
        padding: 'Z',
        round: 'Z2',
        theme: 'canvas-card-glass',
        fontSize: 'Z2',
        color: 'white',
        opacity: '0',
        visibility: 'hidden',
        pointerEvents: 'none',
        transition: 'A opacity defaultBezier',
        zIndex: '1000',
        maxHeight: 'H',
        overflow: 'hidden auto',
        scrollBehavior: 'smooth'
    },
    Feedback: {
        tag: 'span',
        position: 'absolute',
        top: '100%',
        left: '0',
        marginTop: 'Y',
        fontSize: 'Z2',
        color: 'white',
        theme: 'canvas-card-glass',
        padding: 'Y Z',
        round: 'Z',
        opacity: '0',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: 'I',
        transition: 'B opacity defaultBezier',
        pointerEvents: 'none',
        zIndex: '1001'
    }
};

});

parcelRegister("42QGH", function(module, exports) {

$parcel$export(module.exports, "CommandPalette", () => $2f2038044b760b94$export$d5c1975cbb44d2a4);
// CommandPalette — single input that's both a slash-command palette
// and a project search. Typing `/` shows commands; anything else is
// fuzzy-searched against project schema. Replaces SearchBar on
// canvas/workspace pages.
//
// Dropdown item shape:
//   { kind: 'cmd', name, description, args, snippet }
//   { kind: 'item', type, key, score }
//
// Global shortcut: Cmd/Ctrl+K focuses the input.

var $k216J = parcelRequire("k216J");
const $2f2038044b760b94$var$MAX_DROPDOWN = 20;
function $2f2038044b760b94$var$filterCommands(query) {
    const q = query.trim().toLowerCase();
    const tag = (c)=>({
            kind: 'cmd',
            name: c.name,
            description: c.description,
            args: c.args
        });
    if (!q) return (0, $k216J.commandDefs).slice(0, $2f2038044b760b94$var$MAX_DROPDOWN).map(tag);
    return (0, $k216J.commandDefs).filter((c)=>c.name.toLowerCase().includes(q) || c.description?.toLowerCase().includes(q)).slice(0, $2f2038044b760b94$var$MAX_DROPDOWN).map(tag);
}
function $2f2038044b760b94$var$fuzzySearchItems(el, query) {
    const q = query.trim().toLowerCase();
    if (!q) return [];
    const data = el.getRootState?.()?.data || el.state?.root?.data;
    if (!data) return [];
    const out = [];
    const scan = (obj, type)=>{
        if (!obj) return;
        for (const key of Object.keys(obj)){
            if (key.toLowerCase().includes(q)) out.push({
                kind: 'item',
                type: type,
                key: key
            });
            if (out.length >= $2f2038044b760b94$var$MAX_DROPDOWN) return;
        }
    };
    scan(data.pages, 'pages');
    scan(data.components, 'components');
    scan(data.functions, 'functions');
    return out.slice(0, $2f2038044b760b94$var$MAX_DROPDOWN);
}
function $2f2038044b760b94$var$runCommand(el, input) {
    const value = input.trim();
    if (!value.startsWith('/')) return null;
    const [name, ...args] = value.slice(1).split(/\s+/);
    const handler = (0, $k216J.commands)[name.toLowerCase()];
    if (!handler) return `Unknown: /${name}`;
    try {
        return handler(el, args) || `Ran /${name}`;
    } catch (e) {
        return `Error: ${e.message || e}`;
    }
}
function $2f2038044b760b94$var$highlightIndex(palette, delta) {
    const items = palette.Dropdown?.node?.querySelectorAll('[data-cp-item]');
    if (!items?.length) return;
    const cur = Array.from(items).findIndex((i)=>i.hasAttribute('data-cp-active'));
    items.forEach((i)=>i.removeAttribute('data-cp-active'));
    const next = ((cur < 0 ? -1 : cur) + delta + items.length) % items.length;
    const target = items[Math.max(0, next)];
    target?.setAttribute('data-cp-active', '1');
    target?.style?.setProperty?.('background', 'rgba(64,156,255,0.22)');
    Array.from(items).forEach((i, idx)=>{
        if (idx !== next) i.style?.setProperty?.('background', '');
    });
}
function $2f2038044b760b94$var$executeHighlighted(palette, el) {
    const active = palette.Dropdown?.node?.querySelector('[data-cp-item][data-cp-active]') || palette.Dropdown?.node?.querySelector('[data-cp-item]');
    if (!active) return null;
    const kind = active.getAttribute('data-cp-kind');
    const name = active.getAttribute('data-cp-name');
    if (kind === 'cmd') {
        palette.Input.node.value = '/' + name + ' ';
        palette.Input.node.focus();
        $2f2038044b760b94$var$updateDropdown(palette, el);
        return null;
    }
    if (kind === 'item') {
        const key = active.getAttribute('data-cp-key');
        const type = active.getAttribute('data-cp-type');
        el.call('openArtboardItem', type, key);
        palette.Input.node.value = '';
        palette.Input.node.blur();
        $2f2038044b760b94$var$hideDropdown(palette);
        return null;
    }
    return null;
}
function $2f2038044b760b94$var$hideDropdown(palette) {
    palette.Dropdown?.update?.({
        style: {
            display: 'none'
        }
    });
}
function $2f2038044b760b94$var$showDropdown(palette) {
    palette.Dropdown?.update?.({
        style: {
            display: 'block'
        }
    });
}
function $2f2038044b760b94$var$renderDropdown(palette, rows) {
    const node = palette.Dropdown?.node;
    if (!node) return;
    node.innerHTML = '';
    if (!rows.length) {
        $2f2038044b760b94$var$hideDropdown(palette);
        return;
    }
    $2f2038044b760b94$var$showDropdown(palette);
    for (const row of rows){
        const div = node.ownerDocument.createElement('div');
        div.setAttribute('data-cp-item', '1');
        div.setAttribute('data-cp-kind', row.kind);
        div.style.padding = '8px 12px';
        div.style.cursor = 'pointer';
        div.style.display = 'flex';
        div.style.justifyContent = 'space-between';
        div.style.gap = '12px';
        div.style.borderRadius = '4px';
        div.onmouseenter = ()=>{
            div.style.background = 'rgba(255,255,255,0.08)';
        };
        div.onmouseleave = ()=>{
            div.style.background = '';
        };
        if (row.kind === 'cmd') {
            div.setAttribute('data-cp-name', row.name);
            div.innerHTML = `<span><span style="font-family:monospace;color:#8ab4f8">/${row.name}</span>` + (Array.isArray(row.args) ? ` <span style="opacity:.55;font-size:11px">[${row.args.join('|')}]</span>` : '') + `</span><span style="opacity:.65;font-size:12px">${row.description || ''}</span>`;
        } else {
            div.setAttribute('data-cp-name', row.key);
            div.setAttribute('data-cp-kind', 'item');
            div.setAttribute('data-cp-type', row.type);
            div.setAttribute('data-cp-key', row.key);
            div.innerHTML = `<span>${row.key}</span><span style="opacity:.55;font-size:11px">${row.type}</span>`;
        }
        node.appendChild(div);
    }
}
function $2f2038044b760b94$var$updateDropdown(palette, el) {
    const value = palette.Input?.node?.value || '';
    if (value.startsWith('/')) {
        const rows = $2f2038044b760b94$var$filterCommands(value.slice(1));
        $2f2038044b760b94$var$renderDropdown(palette, rows);
        return;
    }
    if (value.trim()) {
        const rows = $2f2038044b760b94$var$fuzzySearchItems(el, value);
        $2f2038044b760b94$var$renderDropdown(palette, rows);
        return;
    }
    // Empty + focused: show top commands.
    $2f2038044b760b94$var$renderDropdown(palette, $2f2038044b760b94$var$filterCommands(''));
}
function $2f2038044b760b94$var$setFeedback(palette, msg) {
    const fb = palette.Feedback;
    if (!fb?.update) return;
    fb.update({
        text: msg,
        style: {
            display: msg ? 'block' : 'none'
        }
    });
    if (msg) {
        clearTimeout(palette.__feedbackTimer);
        palette.__feedbackTimer = setTimeout(()=>{
            fb.update({
                style: {
                    display: 'none'
                }
            });
        }, 2500);
    }
}
const $2f2038044b760b94$export$d5c1975cbb44d2a4 = {
    tag: 'div',
    position: 'relative',
    width: '100%',
    maxWidth: '560px',
    fontSize: 'Y',
    onInit: (el)=>{
        // Cmd/Ctrl+K to focus from anywhere.
        if (el.__cpBound) return;
        el.__cpBound = true;
        const handler = (ev)=>{
            if ((ev.metaKey || ev.ctrlKey) && ev.key.toLowerCase() === 'k') {
                ev.preventDefault();
                el.Input?.node?.focus();
                el.Input?.node?.select?.();
            }
        };
        document.addEventListener('keydown', handler);
        el.__cpUnbind = ()=>document.removeEventListener('keydown', handler);
    },
    Input: {
        tag: 'input',
        type: 'text',
        placeholder: 'Type / for command, or search',
        width: '100%',
        padding: 'W B',
        round: 'W',
        border: '1px solid rgba(255,255,255,0.12)',
        background: 'rgba(0,0,0,0.25)',
        color: 'white',
        fontSize: 'Y',
        style: {
            outline: 'none'
        },
        attr: {
            'aria-label': 'Canvas command or search'
        },
        onFocus: (ev, el)=>$2f2038044b760b94$var$updateDropdown(el.parent, el.parent),
        onInput: (ev, el)=>$2f2038044b760b94$var$updateDropdown(el.parent, el.parent),
        onBlur: (ev, el)=>{
            // Delay so click on dropdown item can fire first.
            setTimeout(()=>$2f2038044b760b94$var$hideDropdown(el.parent), 150);
        },
        onKeydown: (ev, el)=>{
            const palette = el.parent;
            if (ev.key === 'Escape') {
                el.node.value = '';
                el.node.blur();
                $2f2038044b760b94$var$hideDropdown(palette);
                return;
            }
            if (ev.key === 'ArrowDown') {
                ev.preventDefault();
                $2f2038044b760b94$var$highlightIndex(palette, 1);
                return;
            }
            if (ev.key === 'ArrowUp') {
                ev.preventDefault();
                $2f2038044b760b94$var$highlightIndex(palette, -1);
                return;
            }
            if (ev.key === 'Enter') {
                ev.preventDefault();
                // Execute highlighted item, or command from input value.
                const result = $2f2038044b760b94$var$executeHighlighted(palette, palette);
                if (result === null && palette.Input.node.value.startsWith('/')) {
                    const msg = $2f2038044b760b94$var$runCommand(palette, palette.Input.node.value);
                    if (msg) $2f2038044b760b94$var$setFeedback(palette, msg);
                    palette.Input.node.value = '';
                    $2f2038044b760b94$var$hideDropdown(palette);
                }
            }
        }
    },
    Dropdown: {
        tag: 'div',
        position: 'absolute',
        top: 'calc(100% + 6px)',
        left: '0',
        right: '0',
        maxHeight: '60vh',
        overflow: 'auto',
        background: '#1c1f24',
        color: 'white',
        round: 'W',
        padding: 'W',
        fontSize: 'Y',
        style: {
            display: 'none',
            border: '1px solid rgba(255,255,255,0.1)',
            boxShadow: '0 10px 30px rgba(0,0,0,0.45)',
            zIndex: '100'
        },
        onPointerDown: (ev)=>ev.preventDefault(),
        onClick: (ev, el)=>{
            const item = ev.target.closest?.('[data-cp-item]');
            if (!item) return;
            const kind = item.getAttribute('data-cp-kind');
            if (kind === 'cmd') {
                const name = item.getAttribute('data-cp-name');
                el.parent.Input.node.value = '/' + name + ' ';
                el.parent.Input.node.focus();
                $2f2038044b760b94$var$updateDropdown(el.parent, el.parent);
            } else if (kind === 'item') {
                const key = item.getAttribute('data-cp-key');
                const type = item.getAttribute('data-cp-type');
                el.parent.call('openArtboardItem', type, key);
                el.parent.Input.node.value = '';
                $2f2038044b760b94$var$hideDropdown(el.parent);
            }
        }
    },
    Feedback: {
        tag: 'div',
        position: 'absolute',
        top: 'calc(100% + 6px)',
        left: '0',
        padding: 'W A',
        background: 'rgba(64,156,255,0.9)',
        color: 'white',
        round: 'W',
        fontSize: 'Y',
        style: {
            display: 'none',
            zIndex: '99'
        }
    }
};

});

parcelRegister("jUups", function(module, exports) {

$parcel$export(module.exports, "DROPDOWN_APPS", () => $e7ead60365775fc8$export$452d4cca16549844);
$parcel$export(module.exports, "WORKSPACE_PATHS", () => $e7ead60365775fc8$export$63b6349671d6f15d);
$parcel$export(module.exports, "INTRANET_PATHS", () => $e7ead60365775fc8$export$107518de889b631d);
$parcel$export(module.exports, "AppNavbarDropdownItem", () => $e7ead60365775fc8$export$9227cc93a6a67e50);
$parcel$export(module.exports, "AppNavbarButton", () => $e7ead60365775fc8$export$9fa14be9f2b7bdf0);
$parcel$export(module.exports, "AppNavbar", () => $e7ead60365775fc8$export$cb80bf6b197ce0ea);
const $e7ead60365775fc8$var$APPS = [
    {
        key: 'logo',
        icon: 'logov2',
        route: '/',
        label: 'Workspace'
    },
    {
        key: 'studio',
        icon: 'layers',
        route: '/studio',
        label: 'Studio'
    },
    {
        key: 'marketplace',
        icon: 'grid',
        route: '/marketplace',
        label: 'Marketplace'
    },
    {
        key: 'chat',
        icon: 'chat',
        route: '/chat',
        label: 'Chat'
    },
    {
        key: 'calendar',
        icon: 'date outline',
        route: '/calendar',
        label: 'Calendar'
    },
    {
        key: 'more',
        icon: 'arrowAngleDown',
        label: 'More'
    }
];
const $e7ead60365775fc8$export$452d4cca16549844 = [
    ...$e7ead60365775fc8$var$APPS.filter((a)=>a.key !== 'more'),
    {
        key: 'tickets',
        icon: 'check',
        route: '/tickets',
        label: 'Tickets'
    },
    {
        key: 'documents',
        icon: 'document',
        route: '/documents',
        label: 'Documents'
    },
    {
        key: 'meet',
        icon: 'video',
        route: '/meet',
        label: 'Meet'
    },
    {
        key: 'system',
        icon: 'settings',
        route: '/system',
        label: 'System'
    },
    {
        key: 'data',
        icon: 'database',
        route: '/data/projects',
        label: 'Data'
    }
];
// Resolve `/studio` to `/studio/<owner-slug>` for the active org. The
// auth wiring (workspace-project/functions/auth.js) sets `root.org` to
// the active org object whose canonical identifier is `org.slug`.
// Personal workspaces have no org, so fall back to the email-derived
// user slug. Last resort: `/dashboard`, which renders a workspace
// picker on its own. All routes are now local — the multi-app shell
// hosts canvas / marketplace / etc. as registered routes inside the
// same origin, so no cross-origin bouncing.
//
// Optimistic pick: when the user just clicked an org in
// AppWorkspaceSwitcher, `_pendingActiveOrgId` is set the same tick the
// trigger label flips. Without consulting it here the Studio link in
// the navbar would keep pointing at the OLD org's slug until the JWT
// refresh round-trip completes (1–5 s) — clicking Studio in that
// window navigates to the wrong studio. Resolve the pending org's
// slug from `jwtClaims.orgs` first so the whole header flips together.
const $e7ead60365775fc8$var$resolveStudioPath = (s)=>{
    const root = s?.root;
    const pendingId = root?._pendingActiveOrgId;
    if (pendingId) {
        const pendingOrg = (root?.jwtClaims?.orgs || []).find((o)=>o.id === pendingId);
        if (pendingOrg?.slug) return `/studio/${pendingOrg.slug}`;
    }
    const orgSlug = root?.org?.slug;
    if (orgSlug) return `/studio/${orgSlug}`;
    const email = root?.currentUserEmail || '';
    const userSlug = email.split('@')[0] || '';
    if (userSlug) return `/studio/${userSlug}`;
    return '/dashboard';
};
const $e7ead60365775fc8$export$63b6349671d6f15d = [
    '/',
    '/people',
    '/my',
    '/announcements',
    '/company',
    '/profile'
];
const $e7ead60365775fc8$export$107518de889b631d = $e7ead60365775fc8$export$63b6349671d6f15d;
// State items without an own `route` (the "more" button) fall through
// to `s.root.route` via the store-proxy chain, so a plain `s.route`
// read would return whatever ambient value is on root. hasOwnProperty
// guards those items from matching.
const $e7ead60365775fc8$var$_isActive = (s)=>{
    if (!s || !Object.prototype.hasOwnProperty.call(s, 'route')) return false;
    const path = s.root?.currentPath || '/';
    return s.route === '/' ? $e7ead60365775fc8$export$63b6349671d6f15d.includes(path) : path.startsWith(s.route);
};
// hasOwnProperty guard: items with no own `route` (the "more" button)
// fall through to `s.root.route` via the store-proxy chain — without
// the guard `_hrefFor` would return the current page's path as the
// More-button href, making it look like a real link.
//
// All nav links are LOCAL routes — the multi-app shell mounts every
// sub-app (canvas / marketplace / etc.) as a registered route in the
// same SPA. Studio still resolves dynamically to `/studio/<slug>`.
const $e7ead60365775fc8$var$_hrefFor = (el, s)=>{
    if (s?.key === 'studio') return $e7ead60365775fc8$var$resolveStudioPath(s);
    if (!s || !Object.prototype.hasOwnProperty.call(s, 'route')) return undefined;
    return s.route || undefined;
};
const $e7ead60365775fc8$var$_btnLabel = (s)=>s?.label || (s?.key ? s.key.charAt(0).toUpperCase() + s.key.slice(1) : '');
const $e7ead60365775fc8$var$_unreadFor = (s)=>Number(s?.root?.navUnreadCounts?.[s?.key] || 0);
const $e7ead60365775fc8$var$_closeContainingDropdown = (el)=>{
    let dropdown = el;
    while(dropdown && !dropdown.isDropdownRoot)dropdown = dropdown.parent;
    if (!dropdown) return;
    dropdown.forcedVisible = false;
    dropdown.update({
        style: {
            opacity: '0',
            visibility: 'hidden',
            pointerEvents: 'none'
        }
    });
};
const $e7ead60365775fc8$var$_toggleMoreDropdown = (e, el)=>{
    e.preventDefault();
    let header = el;
    while(header && !header.AppNavbarDropdown)header = header.parent;
    const dropdown = header?.AppNavbarDropdown;
    if (!dropdown) return;
    const newVal = !dropdown.forcedVisible;
    dropdown.forcedVisible = newVal;
    dropdown.update({
        style: {
            opacity: newVal ? '1' : '0',
            visibility: newVal ? 'visible' : 'hidden',
            pointerEvents: newVal ? 'auto' : 'none'
        }
    });
};
const $e7ead60365775fc8$export$9227cc93a6a67e50 = {
    extends: 'Link',
    flow: 'x',
    align: 'center left',
    gap: 'Z1',
    padding: 'Z1 A',
    round: 'Z',
    cursor: 'pointer',
    theme: 'tertiary',
    width: '100%',
    textDecoration: 'none',
    href: (el, s)=>$e7ead60365775fc8$var$_hrefFor(el, s),
    // Icon-only nav items have no text, so set both `title` (native
    // tooltip + status bar) and `aria-label` (screen readers) directly
    // on `attr`. Top-level `aria: { label }` does NOT promote to the
    // `aria-label` attribute in v3.14 — verified against live DOM.
    attr: {
        title: (el, s)=>$e7ead60365775fc8$var$_btnLabel(s),
        'aria-label': (el, s)=>$e7ead60365775fc8$var$_btnLabel(s)
    },
    onClick: (e, el, s)=>{
        $e7ead60365775fc8$var$_closeContainingDropdown(el);
        e.preventDefault();
        el.router($e7ead60365775fc8$var$_hrefFor(el, s), el.getRoot());
    },
    Icon: {
        name: '{{icon}}',
        boxSize: 'A A'
    },
    Label: {
        tag: 'span',
        fontSize: 'Z2',
        text: '{{label}}'
    }
};
const $e7ead60365775fc8$export$9fa14be9f2b7bdf0 = {
    // Multi-extends: NavbarButton supplies the icon-rendering chain
    // (IconText → Icon child resolved from `icon: '{{ icon }}'`) plus
    // hover tooltip wiring; Link supplies tag: 'a' + attr.href so the
    // button renders as a real anchor with native middle-click + status
    // bar URL. Custom onClick below overrides Link's routerOnClick.
    extends: [
        'NavbarButton',
        'Link'
    ],
    borderWidth: '0',
    round: '100%',
    position: 'relative',
    cursor: 'pointer',
    textDecoration: 'none',
    // Active state is driven by reactive factories instead of `isActive` +
    // `.isActive` because smbls v3.14 only wires reactive effects for
    // function props that are in the CSS_PROPS_REGISTRY. `isActive` is a
    // custom boolean, so `applyConditionals` runs the check ONCE at
    // creation and freezes it. `background` and `color` ARE in the CSS
    // registry, so their factories re-run whenever `root.currentPath`
    // updates via `locationchange`.
    //
    // Theme-aware tokens: `overlayStrong` (active) and `overlay` (hover)
    // are semantic colors that resolve correctly in both light and dark
    // mode. Previously used `black.4` / `black.2` literals which were
    // near-invisible against the dark navbar background.
    background: (el, s)=>$e7ead60365775fc8$var$_isActive(s) ? 'overlayStrong' : 'transparent',
    color: (el, s)=>$e7ead60365775fc8$var$_isActive(s) ? 'title' : 'caption',
    ':hover': {
        color: 'title',
        background: 'overlay'
    },
    href: (el, s)=>$e7ead60365775fc8$var$_hrefFor(el, s),
    // Custom navbar tooltip uses setNavbarTooltipPosition (onMouseover);
    // we still want the native title + aria-label for accessibility +
    // middle-click status bar. el.text is empty (icon-only) — top-level
    // `aria: { label }` does NOT promote to `aria-label` in v3.14, so
    // both must live on `attr`.
    attr: {
        title: (el, s)=>$e7ead60365775fc8$var$_btnLabel(s),
        'aria-label': (el, s)=>$e7ead60365775fc8$var$_btnLabel(s)
    },
    icon: '{{ icon }}',
    // Brand's onMouseleave calls Tooltip.update() which can't override
    // the inline styles setNavbarTooltipPosition sets; trigger the
    // slide-out animation directly instead.
    onMouseleave: (ev, el, s)=>{
        if (s.hover) {
            s.hover = false;
            el.call('setNavbarTooltipPosition', {
                visible: false
            });
        }
    },
    onClick: (e, el, s)=>{
        if (s.key === 'more') return $e7ead60365775fc8$var$_toggleMoreDropdown(e, el);
        e.preventDefault();
        el.router($e7ead60365775fc8$var$_hrefFor(el, s), el.getRoot());
    },
    UnreadBadge: {
        hide: (el, s)=>$e7ead60365775fc8$var$_unreadFor(s) === 0,
        position: 'absolute',
        top: '0',
        right: '0',
        width: 'Y',
        height: 'Y',
        round: '50%',
        background: 'red',
        pointerEvents: 'none'
    }
};
const $e7ead60365775fc8$export$cb80bf6b197ce0ea = {
    extends: 'Navbar',
    flow: 'x',
    align: 'center space-around',
    gap: 'Z+V',
    padding: 'V Z',
    userSelect: 'none',
    theme: 'quaternary',
    round: 'C1',
    hide: ()=>/^\/(login|signin|signup|reset-password|forgot-password|verify-email|signup-confirmation)/.test(window.location.pathname),
    childExtends: 'AppNavbarButton',
    childrenAs: 'state',
    children: $e7ead60365775fc8$var$APPS
};

});

parcelRegister("4LhuZ", function(module, exports) {

$parcel$export(module.exports, "AppHeader", () => $3779201ca5714caf$export$9bd256435c34a030);
$parcel$export(module.exports, "AppNavLink", () => $3779201ca5714caf$export$a602c5acb020e155);

var $jUups = parcelRequire("jUups");

var $dELsh = parcelRequire("dELsh");
const $3779201ca5714caf$var$TITLES = {
    '/calendar': 'Calendar',
    '/chat': 'Chat',
    '/tickets': 'My view',
    '/tickets/my': 'My view',
    '/tickets/general': 'General',
    '/tickets/feed': 'Feed',
    '/tickets/canvas': 'Canvas',
    '/tickets/stories': 'Stories',
    '/tickets/epics': 'Epics',
    '/tickets/board': 'Board',
    '/tickets/standups': 'Standups',
    '/meet': 'Meet',
    '/system': 'System',
    '/dashboard': 'Dashboard'
};
const $3779201ca5714caf$var$PREFIX_TITLES = [
    [
        '/tickets/requests',
        'Requests'
    ],
    [
        '/tickets/resolutions',
        'Resolutions'
    ],
    [
        '/tickets',
        'Tickets'
    ],
    [
        '/meet/',
        'Call'
    ],
    [
        '/documents/',
        'Documents'
    ],
    [
        '/documents',
        'Documents'
    ],
    [
        '/studio',
        'Studio'
    ],
    [
        '/admin',
        'Admin'
    ]
];
const $3779201ca5714caf$var$pageTitle = (path)=>{
    if (!path) return '';
    if ($3779201ca5714caf$var$TITLES[path]) return $3779201ca5714caf$var$TITLES[path];
    if (path.startsWith('/meet/') && path.endsWith('/transcript')) return 'Transcript';
    for (const [prefix, label] of $3779201ca5714caf$var$PREFIX_TITLES){
        if (path.startsWith(prefix)) return label;
    }
    return 'Canvas';
};
const $3779201ca5714caf$export$9bd256435c34a030 = {
    extends: 'Navbar',
    theme: null,
    padding: 'X2',
    gap: 'A',
    position: 'sticky',
    top: '0',
    zIndex: '50',
    align: 'center space-between',
    hide: (el, s)=>{
        const path = s.root?.currentPath || '/';
        return path === '/login' || path === '/signin';
    },
    Logo: {
        extends: 'Link',
        href: '/',
        hide: (el)=>(0, $dELsh.checkActiveMember)(el),
        cursor: 'pointer',
        color: 'title',
        padding: 'Y',
        align: 'center center',
        LogoIcon: {
            icon: 'logov2',
            boxSize: 'A A',
            aspectRatio: '1 / 1'
        }
    },
    // NavbarTooltip lives here (not inside AppNavbar) because `children: APPS`
    // in AppNavbar replaces all named children. P is forced to always render
    // so setNavbarTooltipPosition can write into P.node.textContent on hover.
    NavbarTooltip: {
        P: {
            if: ()=>true,
            text: ''
        }
    },
    AppNavbar: {
        hide: (el)=>!(0, $dELsh.checkActiveMember)(el),
        fontSize: 'A'
    },
    AppNavbarDropdown: {
        extends: 'Dropdown',
        top: '105%',
        left: 'X2',
        width: 'G',
        minWidth: 'G',
        theme: 'quaternary',
        onInit: (el)=>{
            el._closeHandler = (e)=>{
                if (!el.node || !el.forcedVisible) return;
                if (el.node.contains(e.target)) return;
                const navbarNode = el.parent?.AppNavbar?.node;
                if (navbarNode && navbarNode.contains(e.target)) return;
                el.forcedVisible = false;
                el.update({
                    style: {
                        opacity: '0',
                        visibility: 'hidden',
                        pointerEvents: 'none'
                    }
                });
            };
            document.addEventListener('mousedown', el._closeHandler);
        },
        onRemove: (el)=>{
            if (el._closeHandler) document.removeEventListener('mousedown', el._closeHandler);
        },
        childExtends: 'AppNavbarDropdownItem',
        childrenAs: 'state',
        children: (0, $jUups.DROPDOWN_APPS)
    },
    PageTitle: {
        hide: (el, s)=>(0, $dELsh.isIntranetRoute)(s),
        tag: 'span',
        width: 'G',
        margin: '0',
        fontSize: 'A',
        fontWeight: '600',
        color: 'title',
        text: (el, s)=>$3779201ca5714caf$var$pageTitle(s.root?.currentPath || s.root?.route || '')
    },
    // Global in-app search. Consumer fills `Form.Input.onInput` with its own
    // search source and may add extra `Dropdown` children for result rows.
    SearchBar: {
        extends: 'SearchBar',
        order: '1',
        flex: '1',
        maxWidth: 'H',
        margin: '- auto',
        Form: {
            Input: {
                width: '100%',
                padding: 'Y2 A Y2 C',
                placeholder: "Search\u2026",
                value: (el, s)=>s.root?.navSearchQuery || '',
                onInput: ()=>{},
                onKeydown: (ev, el)=>{
                    if (ev.key === 'Escape') el.node.blur();
                }
            }
        },
        Dropdown: {
            width: '100%',
            left: '0',
            maxHeight: '70vh',
            overflow: 'auto',
            padding: 'Y',
            flow: 'y',
            LoadingRow: {
                if: (el, s)=>s.root?._navSearchLoading && !s.root?.navSearchResults?.length,
                padding: 'A',
                textAlign: 'center',
                color: 'caption',
                fontSize: 'Z2',
                text: "Searching\u2026"
            },
            EmptyRow: {
                if: (el, s)=>!s.root?._navSearchLoading && s.root?.navSearchQuery && !s.root?.navSearchResults?.length,
                padding: 'A',
                textAlign: 'center',
                color: 'caption',
                fontSize: 'Z2',
                text: (el, s)=>`No results for "${s.root?.navSearchQuery || ''}"`
            }
        }
    },
    // User-facing actions on the right of the header. Slots are pre-listed
    // here so consumers that extend this header get them in a consistent
    // order; intranet/canvas fill in the real content via their own
    // component registrations (AppWorkspaceSwitcher, NotificationBell, etc.
    // are provided by sharedLibraries). Non-member views hide everything
    // except the avatar menu.
    UserActions: {
        order: '2',
        flow: 'x',
        align: 'center right',
        gap: 'A',
        padding: 'Y X',
        AppWorkspaceSwitcher: {
            hide: (el)=>!(0, $dELsh.checkActiveMember)(el)
        },
        CalOnlineUsersBar: {
            hide: (el)=>!(0, $dELsh.checkActiveMember)(el),
            maxAvatars: 6
        },
        Messenger: {
            hide: (el)=>!(0, $dELsh.checkActiveMember)(el)
        },
        NotificationWrapper: {
            hide: (el)=>!(0, $dELsh.checkActiveMember)(el),
            position: 'relative',
            NotificationBell: {},
            NotificationPanel: {}
        },
        AppAssistantToggle: {
            // Two conditions must both pass for the toggle to show:
            //   1. User is an active member (intranet auth gate)
            //   2. aiStream is registered — canvas has no backend, so the toggle
            //      must stay hidden there. The base AppAssistantToggle already
            //      gates on aiStream; repeat the check here so the membership
            //      override doesn't accidentally re-show it on no-backend apps.
            hide: (el)=>{
                if (!(0, $dELsh.checkActiveMember)(el)) return true;
                const fn = el?.context?.functions?.aiStream;
                return typeof fn !== 'function';
            }
        },
        MeWrapper: {
            position: 'relative',
            order: '99',
            Me: {
                extends: 'Avatar',
                avatarType: 'initials',
                boxSize: 'B1',
                cursor: 'pointer',
                src: (el, s)=>el.call('avatarUrlFor', s.root?.currentUserEmail),
                ':hover': {
                    filter: 'brightness(1.15)'
                },
                onClick: (e, el, s)=>{
                    e.stopPropagation();
                    s.root.update({
                        showMeMenu: !s.root.showMeMenu
                    });
                }
            },
            MeMenu: {
                position: 'absolute',
                top: '115%',
                right: '0',
                zIndex: '200',
                flow: 'y',
                gap: 'V',
                padding: 'Z',
                round: 'Z',
                minWidth: 'G',
                background: 'overlayStrong',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: 'line',
                boxShadow: '0 8px 24px var(--color-shadow)',
                opacity: (el, s)=>s.root?.showMeMenu ? '1' : '0',
                pointerEvents: (el, s)=>s.root?.showMeMenu ? 'auto' : 'none',
                transition: 'opacity 120ms ease',
                onCreate: (el, s)=>{
                    el._close = (ev)=>{
                        if (!el.node || !el.node.parentElement) return;
                        if (el.node.parentElement.contains(ev.target)) return;
                        s.root.update({
                            showMeMenu: false
                        });
                    };
                    const doc = el.context?.document || document;
                    doc.addEventListener('mousedown', el._close);
                },
                onRemove: (el)=>{
                    if (el._close) {
                        const doc = el.context?.document || document;
                        doc.removeEventListener('mousedown', el._close);
                    }
                },
                childExtends: {
                    tag: 'button',
                    type: 'button',
                    flow: 'x',
                    align: 'center left',
                    gap: 'Z1',
                    padding: 'Z1 A',
                    round: 'Y',
                    border: 'none',
                    background: 'transparent',
                    cursor: 'pointer',
                    fontSize: 'Z2',
                    fontWeight: '500',
                    width: '100%',
                    textAlign: 'left',
                    ':hover': {
                        background: 'overlay'
                    }
                },
                ProfileItem: {
                    text: 'Profile',
                    color: 'title',
                    onClick: (e, el, s)=>{
                        s.root.update({
                            showMeMenu: false,
                            profileEmail: s.root?.currentUserEmail
                        });
                    }
                },
                // Theme cycle button. Per smbls/CLAUDE.md global-theme contract,
                // the source of truth is `el.context.globalTheme` — bootShell
                // pipes our themeMode into that on create() and changeGlobalTheme
                // updates it. Reading from root state would drift from the
                // framework attribute on cold load. Persistence still goes through
                // localStorage so the next page load picks the same mode up.
                ThemeItem: {
                    color: 'title',
                    text: (el, s)=>{
                        const mode = el?.context?.globalTheme || s.root?.themeMode || 'auto';
                        return `Theme: ${mode}`;
                    },
                    onClick: (e, el, s)=>{
                        const order = [
                            'auto',
                            'light',
                            'dark'
                        ];
                        const current = el?.context?.globalTheme || s.root?.themeMode || 'auto';
                        const next = order[(order.indexOf(current) + 1) % order.length];
                        // changeGlobalTheme updates context.globalTheme + flips
                        // data-theme (or removes it for 'auto'). Mirror to root state
                        // so any UI still reading `s.root.themeMode` re-renders, and
                        // persist for the next page load.
                        try {
                            localStorage.setItem('themeMode', next);
                        } catch (_) {}
                        s.root.update({
                            themeMode: next
                        });
                        el.call('changeGlobalTheme', next);
                    }
                },
                MenuDivider: {
                    // childExtends above sets `tag: 'button'` for menu items.
                    // Override here so the divider is a non-interactive separator
                    // rather than an unlabeled focusable button.
                    tag: 'div',
                    attr: {
                        role: 'separator',
                        'aria-orientation': 'horizontal'
                    },
                    cursor: 'default',
                    height: '1px',
                    background: 'line',
                    padding: '0',
                    margin: 'V 0'
                },
                // Consumer overrides `onClick` + `href` with its own sign-out flow.
                SignOutItem: {
                    extends: 'Link',
                    text: 'Sign out',
                    color: 'red',
                    href: '#',
                    onClick: ()=>{}
                }
            }
        }
    }
};
const $3779201ca5714caf$export$a602c5acb020e155 = {
    extends: 'Link',
    cursor: 'pointer',
    padding: 'X1 A',
    round: 'C',
    textDecoration: 'none',
    transition: 'all 200ms ease',
    color: 'caption',
    fontSize: 'Z2',
    fontWeight: '500',
    href: (el, s)=>s.href,
    text: (el, s)=>s.label,
    background: (el, s)=>s.root.currentPath === s.href ? 'blue.2' : 'transparent',
    '@hover': {
        background: 'overlay'
    }
};

});
parcelRegister("dELsh", function(module, exports) {

$parcel$export(module.exports, "checkActiveMember", () => $9f13d26160331c44$export$267f5bde56f910c1);
$parcel$export(module.exports, "isIntranetRoute", () => $9f13d26160331c44$export$771e985219e76a27);

var $jUups = parcelRequire("jUups");
const $9f13d26160331c44$export$267f5bde56f910c1 = (el)=>{
    const fn = el?.context?.methods?.isActiveMember;
    if (typeof fn !== 'function') return true;
    return !!fn.call(el, el?.state);
};
const $9f13d26160331c44$export$771e985219e76a27 = (s)=>{
    const path = s?.root?.currentPath || s?.root?.route || '/';
    return (0, $jUups.INTRANET_PATHS).includes(path);
};

});


parcelRegister("7MJvY", function(module, exports) {

$parcel$export(module.exports, "appShellStyles", () => $017674f0f7386e13$export$e8cee26cf7733831);
$parcel$export(module.exports, "installAppShellSync", () => $017674f0f7386e13$export$3056e2ca3eebffce);
$parcel$export(module.exports, "uninstallAppShellSync", () => $017674f0f7386e13$export$78a9947426547bb5);
// Shared app-level layout. Both intranet and canvas extend this to get:
//   - The common grid (auto-row header, 1fr body)
//   - Document theme + root font-size
//   - Height + margin-right transition for the shared AppAssistant drawer
//     (value `H` matches AppAssistant's default width)
//
// Path-sync (publishing `window.location.pathname` / `.search` onto
// `root.currentPath` / `root.currentSearch`) is exposed as a HELPER
// function `installAppShellSync(el, s)` rather than a lifecycle hook.
// DOMQL's extends-merge replaces functions entirely, so an app that
// overrides `onCreate` on its extending shell would silently drop a
// base-level `onCreate`. Consumers invoke the helper from their own
// `onCreate` — explicit, no surprises.
//
// Consumers add their own overlays, modals, drawers as root children.
// The header slot is intentionally undeclared here: intranet mounts
// `IntranetAppHeader` and canvas mounts `CanvasAppHeader`, both of which
// extend the shared `AppHeader` base.
// The root app component in smbls does NOT inherit properties via
// `extends:` the same way children do — merging into the smblsapp root
// is handled differently. So instead of extending a component, each
// app.js imports `appShellStyles` and spreads it directly.
const $017674f0f7386e13$export$e8cee26cf7733831 = {
    display: 'grid',
    gridTemplateRows: 'auto 1fr',
    gridTemplateColumns: '1fr',
    width: '100%',
    maxWidth: 'none',
    // `minHeight` (not `height`) so pages with long content grow past the
    // viewport and the viewport's own scrollbar handles scrolling. Apps
    // that need a strict viewport fit (canvas, marketplace) override with
    // `height: '100dvh'` + `overflow: 'hidden'` locally.
    minHeight: '100dvh',
    // Start with both axes visible. The framework's default can sometimes
    // land `overflow-y: auto` on the root, which turns the shell into a
    // scroll container and prevents the viewport from scrolling on long
    // pages. Apps that want to scroll inside the shell (canvas, marketplace)
    // set their own overflow explicitly.
    overflowX: 'visible',
    overflowY: 'visible',
    theme: 'document',
    transition: 'margin-right 200ms ease',
    marginRight: (el, s)=>s.root?.assistantOpen ? 'H' : '0'
};
const $017674f0f7386e13$export$3056e2ca3eebffce = function installAppShellSync(s) {
    const el = this;
    const win = el.context?.window || window;
    if (!win.__smblsPathPatched) {
        win.__smblsPathPatched = true;
        const origPush = win.history.pushState;
        const origReplace = win.history.replaceState;
        win.history.pushState = function(...args) {
            const r = origPush.apply(this, args);
            win.dispatchEvent(new Event('locationchange'));
            return r;
        };
        win.history.replaceState = function(...args) {
            const r = origReplace.apply(this, args);
            win.dispatchEvent(new Event('locationchange'));
            return r;
        };
    }
    const root = s?.root || s || el.state?.root || el.state;
    if (!root || typeof root.update !== 'function') return null;
    const sync = ()=>{
        const path = win.location.pathname;
        const search = win.location.search;
        const patch = {};
        if (root.currentPath !== path) {
            patch.currentPath = path;
            // Scroll reset on route change. AppShell can be either the scroll
            // container (when an app sets `overflowY: auto` on its root) or a
            // plain grid that lets the viewport scroll — hit both so either
            // mode lands at the top on navigation.
            if (el.node && typeof el.node.scrollTo === 'function') el.node.scrollTo({
                top: 0
            });
            if (typeof win.scrollTo === 'function') win.scrollTo({
                top: 0
            });
        }
        if (root.currentSearch !== search) patch.currentSearch = search;
        if (Object.keys(patch).length) root.update(patch);
    };
    el._appShellSync = sync;
    if (typeof win.queueMicrotask === 'function') win.queueMicrotask(sync);
    else Promise.resolve().then(sync);
    win.addEventListener('popstate', sync);
    win.addEventListener('locationchange', sync);
    return sync;
};
const $017674f0f7386e13$export$78a9947426547bb5 = function uninstallAppShellSync() {
    const el = this;
    const win = el.context?.window || window;
    if (el._appShellSync) {
        win.removeEventListener('popstate', el._appShellSync);
        win.removeEventListener('locationchange', el._appShellSync);
        el._appShellSync = null;
    }
};

});

parcelRegister("9oqUN", function(module, exports) {

$parcel$export(module.exports, "AppAssistantToggle", () => $6d6b3bb8c70300e4$export$dbaa49ea45fc6e74);
$parcel$export(module.exports, "AppAssistant", () => $6d6b3bb8c70300e4$export$5df46efa2af4b07);
$parcel$export(module.exports, "AppAssistantSuggestion", () => $6d6b3bb8c70300e4$export$51b4b8bffc37a91e);
$parcel$export(module.exports, "AppAssistantMessage", () => $6d6b3bb8c70300e4$export$f9378366af090265);
// Shared AI assistant drawer — visual shell + state plumbing.
//
// The AI streaming backend and action-confirmation handlers are
// intentionally NOT in this file. Each consuming app registers:
//   - `aiStream(messages, attachment, onChunk, onDone, el)` function —
//     sends the prompt to the app's own AI endpoint and calls
//     `onChunk(partialText)` + `onDone(finalText)`.
//   - `aiPerformAction(action, el, s)` function — executes a proposed
//     action (create_ticket, create_event, etc.) when the user confirms.
//   - `aiActionStyles()` function — returns the `{ type → { icon, color, label } }`
//     map used to render proposed-action cards.
//
// Any app that doesn't register `aiStream` will have the toggle hidden
// automatically (AppAssistantToggle.hide reads context.functions.aiStream).
// If the toggle is shown via a consumer override, _triggerSend will
// surface a console.error and early-return instead of silently failing.
const $6d6b3bb8c70300e4$var$_ATTACH = {
    ticket: {
        label: 'Ticket',
        icon: 'check'
    },
    document: {
        label: 'Document',
        icon: 'document'
    },
    event: {
        label: 'Event',
        icon: 'date outline'
    },
    message: {
        label: 'Message',
        icon: 'chat'
    },
    link: {
        label: 'Link',
        icon: 'link'
    }
};
const $6d6b3bb8c70300e4$var$_attachMeta = (t)=>$6d6b3bb8c70300e4$var$_ATTACH[t] || {
        label: 'Item',
        icon: 'document'
    };
// Cached lookup into the consumer's `aiActionStyles` map. The function
// returns a fresh object per call so we memoize by function identity to
// avoid re-allocating on every reactive prop re-run.
let $6d6b3bb8c70300e4$var$_stylesFn = null;
let $6d6b3bb8c70300e4$var$_stylesMap = null;
const $6d6b3bb8c70300e4$var$_actionStyle = (el, type)=>{
    if (!type) return null;
    const fn = el?.context?.functions?.aiActionStyles;
    if (!fn) return null;
    if (fn !== $6d6b3bb8c70300e4$var$_stylesFn) {
        $6d6b3bb8c70300e4$var$_stylesFn = fn;
        $6d6b3bb8c70300e4$var$_stylesMap = fn() || {};
    }
    return $6d6b3bb8c70300e4$var$_stylesMap[type] || null;
};
const $6d6b3bb8c70300e4$var$_formatHtml = (text)=>{
    if (!text) return '';
    return text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>').replace(/\*(.*?)\*/g, '<em>$1</em>').replace(/`([^`]+)`/g, '<code class="assistant-inline-code">$1</code>').replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a class="assistant-link" href="$2" target="_blank" rel="noopener">$1</a>').replace(/\n/g, '<br>');
};
// Patch the last message in assistantMessages at a pinned index.
// Using an index avoids the stale-read bug of `messages[messages.length-1]`
// when concurrent updates land between SSE chunks.
const $6d6b3bb8c70300e4$var$_patchMessageAt = (root, index, patch)=>{
    const current = root.assistantMessages || [];
    if (index < 0 || index >= current.length) return;
    const updated = current.slice();
    updated[index] = {
        ...updated[index],
        ...patch
    };
    root.update({
        assistantMessages: updated
    });
};
const $6d6b3bb8c70300e4$var$_triggerSend = (el, s, query)=>{
    if (!query || s.root.assistantTyping) return;
    // Guard: aiStream must be registered. This should never fire if the toggle's
    // `hide` gate works correctly, but surfaces the misconfiguration gracefully.
    if (typeof el?.context?.functions?.aiStream !== 'function') {
        console.error("[AppAssistant] aiStream not registered \u2014 cannot send message. Register aiStream in context.functions.");
        return;
    }
    console.log("[AppAssistant] streaming\u2026", {
        query: query
    });
    const attachment = s.root.assistantAttachment || null;
    const userMsg = {
        role: 'user',
        content: query,
        attachment: attachment ? {
            ...attachment
        } : null
    };
    const msgs = [
        ...s.root.assistantMessages || [],
        userMsg
    ];
    const aiMsg = {
        role: 'assistant',
        content: '',
        _streaming: true
    };
    const aiIndex = msgs.length;
    s.root.update({
        assistantMessages: [
            ...msgs,
            aiMsg
        ],
        assistantTyping: true,
        assistantAttachment: null
    });
    const stream = el.call('aiStream', msgs, attachment, (text)=>$6d6b3bb8c70300e4$var$_patchMessageAt(s.root, aiIndex, {
            content: text
        }), (finalText)=>{
        const actionMatch = (finalText || '').match(/<!--ACTION:(.*?)-->/);
        let actions = null;
        let followUps = null;
        let displayText = finalText || '';
        if (actionMatch) {
            try {
                actions = JSON.parse(actionMatch[1]);
                followUps = actions.followUps || null;
            } catch  {}
            displayText = displayText.replace(/<!--ACTION:.*?-->/g, '').trim();
        }
        $6d6b3bb8c70300e4$var$_patchMessageAt(s.root, aiIndex, {
            role: 'assistant',
            content: displayText,
            _streaming: false,
            _actions: actions,
            _followUps: followUps
        });
        s.root.update({
            assistantTyping: false
        });
    });
    if (stream && typeof stream.then === 'function') stream.catch((err)=>{
        console.error('[AppAssistant] aiStream failed', err);
        $6d6b3bb8c70300e4$var$_patchMessageAt(s.root, aiIndex, {
            role: 'assistant',
            content: "Connection error \u2014 please try again.",
            _streaming: false
        });
        s.root.update({
            assistantTyping: false
        });
    });
};
const $6d6b3bb8c70300e4$export$dbaa49ea45fc6e74 = {
    tag: 'button',
    type: 'button',
    title: 'AI Assistant',
    'aria-label': 'Toggle AI Assistant',
    padding: 'Z',
    round: 'Z',
    cursor: 'pointer',
    background: 'transparent',
    color: 'caption',
    ':hover': {
        background: 'overlay',
        color: 'title'
    },
    // Gate on aiStream registration so apps without a backend don't show
    // the toggle. Context functions are set at boot — this is a one-time
    // check, not reactive. Consumers that override this hide must also gate
    // on hasAiStream (or this condition) to avoid showing the button on
    // surfaces with no AI backend.
    hide: (el)=>{
        const fn = el?.context?.functions?.aiStream;
        const missing = typeof fn !== 'function';
        if (missing && true) // Warn only once per element (not on every re-render). If you see
        // this warning, register an `aiStream` function in the project's
        // functions before showing the AI assistant toggle.
        {
            if (!el._aiStreamWarnFired) {
                el._aiStreamWarnFired = true;
                console.warn("[AppAssistantToggle] aiStream not registered \u2014 toggle hidden.");
            }
        }
        return missing;
    },
    onClick: (e, el, s)=>{
        s.root.update({
            assistantOpen: !s.root.assistantOpen
        });
    },
    Icon: {
        icon: 'magicstar',
        boxSize: 'A A'
    }
};
const $6d6b3bb8c70300e4$export$5df46efa2af4b07 = {
    extends: 'CommonCard',
    // Warn once on mount when aiStream is not registered but the panel is
    // being shown anyway. This surfaces the inheritance-from-shared-lib
    // regression early (toggle override that skips the aiStream gate).
    // Also start the realtime ticket subscription so Simona auto-surfaces
    // when user-originated tickets ship. The call is guarded — apps that
    // don't register `subscribeTicketRealtime` (e.g. canvas) are skipped
    // silently; no subscription is opened.
    onInit: (el, s)=>{
        if (typeof el?.context?.functions?.aiStream !== 'function') console.warn("[AppAssistant] mounted without aiStream registered. The panel will render but Send will do nothing. Register aiStream in context.functions or hide the toggle.");
        if (typeof el?.context?.functions?.subscribeTicketRealtime === 'function') el.call('subscribeTicketRealtime', s.root);
    },
    // Tear down the realtime channel when the panel is removed from the DOM
    // to avoid leaking open WebSocket channels after navigation.
    onRemove: (el)=>{
        if (typeof el?.context?.functions?.unsubscribeTicketRealtime === 'function') el.call('unsubscribeTicketRealtime');
    },
    hide: (el, s)=>!s.root.assistantOpen,
    flow: 'x',
    width: (el, s)=>{
        const w = Number(s.root.assistantWidth);
        return Number.isFinite(w) && w > 0 ? w + 'px' : 'H';
    },
    minWidth: 'G+A',
    maxWidth: 'J',
    padding: '0',
    color: 'title',
    overflow: 'hidden',
    position: 'fixed',
    top: '0',
    right: '0',
    height: '100dvh',
    zIndex: '10000',
    round: '0',
    borderLeftWidth: '1px',
    borderLeftColor: 'line',
    borderLeftStyle: 'solid',
    // Global cursor + select lock during resize — done via reactive prop on
    // the drawer root instead of mutating `document.body.style` so it stays
    // within DOMQL's declarative model.
    cursor: (el, s)=>s.root.assistantResizing ? 'col-resize' : '',
    userSelect: (el, s)=>s.root.assistantResizing ? 'none' : '',
    ResizeHandle: {
        width: 'V',
        cursor: 'col-resize',
        background: 'transparent',
        borderLeftWidth: '1px',
        borderLeftColor: 'line',
        borderLeftStyle: 'solid',
        flexShrink: '0',
        ':hover': {
            background: 'blue.15'
        },
        onMousedown: (e, el, s)=>{
            e.preventDefault();
            const rect = el.parent?.node?.getBoundingClientRect?.();
            el._dragStartX = e.clientX;
            el._dragStartW = rect ? rect.width : 500;
            s.root.update({
                assistantResizing: true
            });
            if (el.node?.setPointerCapture && e.pointerId != null) try {
                el.node.setPointerCapture(e.pointerId);
            } catch  {}
        },
        onMousemove: (e, el, s)=>{
            if (!s.root.assistantResizing) return;
            if (el._dragStartX == null) return;
            const dx = el._dragStartX - e.clientX;
            const next = Math.max(250, Math.min(800, el._dragStartW + dx));
            if (next === s.root.assistantWidth) return;
            s.root.update({
                assistantWidth: next
            });
        },
        onMouseup: (e, el, s)=>{
            if (!s.root.assistantResizing) return;
            el._dragStartX = null;
            el._dragStartW = null;
            s.root.update({
                assistantResizing: false
            });
            if (el.node?.releasePointerCapture && e.pointerId != null) try {
                el.node.releasePointerCapture(e.pointerId);
            } catch  {}
        },
        onMouseleave: (e, el, s)=>{
            if (!s.root.assistantResizing) return;
            el._dragStartX = null;
            el._dragStartW = null;
            s.root.update({
                assistantResizing: false
            });
        }
    },
    Panel: {
        flow: 'y',
        flex: '1',
        minWidth: '0',
        overflow: 'hidden',
        Header: {
            flow: 'x',
            align: 'center space-between',
            padding: 'Z1 A',
            borderBottomWidth: '1px',
            borderBottomColor: 'line',
            borderBottomStyle: 'solid',
            minHeight: 'D',
            TitleGroup: {
                flow: 'x',
                align: 'center left',
                gap: 'Z',
                AiIcon: {
                    extends: 'Icon',
                    icon: 'star',
                    boxSize: 'A1 A1',
                    color: 'caption'
                },
                Title: {
                    tag: 'h3',
                    text: 'AI Assistant',
                    margin: '0',
                    fontSize: 'A',
                    fontWeight: '600'
                }
            },
            CloseBtn: {
                tag: 'button',
                type: 'button',
                padding: 'Z',
                round: 'Z',
                cursor: 'pointer',
                background: 'transparent',
                borderWidth: '0',
                color: 'caption',
                ':hover': {
                    background: 'overlay',
                    color: 'title'
                },
                onClick: (e, el, s)=>{
                    s.root.update({
                        assistantOpen: false
                    });
                },
                Icon: {
                    icon: 'x',
                    boxSize: 'Z2 Z2'
                }
            }
        },
        Thread: {
            flex: '1',
            flow: 'y',
            gap: 'A',
            padding: 'A',
            overflow: 'auto',
            minHeight: '0',
            // Auto-scroll to bottom when a new message arrives. Reads scrollHeight
            // (Rule 39 allows reading `el.node`) and calls `.scrollTo()` — a
            // native method with no DOMQL equivalent, treated like `.focus()`.
            // Also retries the realtime ticket subscription if user identity was
            // not yet available at onInit time (auth resolves asynchronously after
            // the panel mounts).
            onUpdate: (el, s)=>{
                if (!el?.node) return;
                const msgs = s.root.assistantMessages || [];
                const sig = msgs.length;
                if (sig !== el._lastLen) {
                    el._lastLen = sig;
                    const win = el.context?.window || window;
                    win.requestAnimationFrame(()=>{
                        if (el.node && typeof el.node.scrollTo === 'function') el.node.scrollTo({
                            top: el.node.scrollHeight
                        });
                    });
                }
                // Retry subscription once user identity becomes available.
                // subscribeTicketRealtime is idempotent: no-ops when already subscribed
                // for the same identity.
                const userId = s.root?.currentUserId || s.root?.currentUserEmail;
                if (userId && !el._realtimeSubscribed) {
                    if (typeof el?.context?.functions?.subscribeTicketRealtime === 'function') {
                        el.call('subscribeTicketRealtime', s.root);
                        el._realtimeSubscribed = true;
                    }
                }
            },
            Welcome: {
                if: (el, s)=>!(s.root.assistantMessages || []).length && !s.root.assistantTyping,
                flow: 'y',
                align: 'center center',
                gap: 'A',
                flex: '1',
                padding: 'C A',
                textAlign: 'center',
                WelcomeIcon: {
                    extends: 'Icon',
                    icon: 'star',
                    boxSize: 'D D',
                    color: 'caption',
                    opacity: '.4'
                },
                WelcomeText: {
                    tag: 'p',
                    margin: '0',
                    fontSize: 'Z2',
                    color: 'caption',
                    lineHeight: '1.6',
                    maxWidth: 'G',
                    text: (el)=>el.call('aiWelcomeText') || 'Ask me anything.'
                },
                Suggestions: {
                    flow: 'x wrap',
                    gap: 'Z',
                    justifyContent: 'center',
                    marginTop: 'Z',
                    childExtends: 'AppAssistantSuggestion',
                    childrenAs: 'state',
                    children: (el)=>el.call('aiSuggestions') || []
                }
            },
            Messages: {
                if: (el, s)=>(s.root.assistantMessages || []).length > 0 || s.root.assistantTyping,
                flow: 'y',
                gap: 'A',
                childExtends: 'AppAssistantMessage',
                childrenAs: 'state',
                children: (el, s)=>s.root.assistantMessages || []
            }
        },
        TypingIndicator: {
            if: (el, s)=>s.root.assistantTyping,
            flow: 'x',
            gap: 'Y',
            align: 'center left',
            padding: 'Z A',
            Label: {
                tag: 'span',
                text: 'Thinking',
                fontSize: 'Y2',
                color: 'caption',
                fontWeight: '500'
            },
            Dot_1: {
                width: 'Y',
                height: 'Y',
                round: '100%',
                background: 'caption',
                animation: 'pulse 1.2s ease-in-out infinite 0s'
            },
            Dot_2: {
                width: 'Y',
                height: 'Y',
                round: '100%',
                background: 'caption',
                animation: 'pulse 1.2s ease-in-out infinite 0.2s'
            },
            Dot_3: {
                width: 'Y',
                height: 'Y',
                round: '100%',
                background: 'caption',
                animation: 'pulse 1.2s ease-in-out infinite 0.4s'
            }
        },
        InputArea: {
            flow: 'y',
            gap: 'Z',
            padding: 'Z A A A',
            borderTopWidth: '1px',
            borderTopColor: 'line',
            borderTopStyle: 'solid',
            AttachmentPreview: {
                // Use `if` (DOM-level removal) rather than `hide` (CSS display:none)
                // so the chip is entirely absent from the DOM — and its child text
                // factories never run — when no attachment is set. `hide` only applies
                // CSS and can still render child text (e.g. "Item") if the reactive
                // display update lags behind the initial DOM paint.
                if: (el, s)=>!!s.root.assistantAttachment,
                flow: 'x',
                gap: 'Z',
                align: 'center',
                padding: 'Z Z1',
                round: 'Z',
                borderWidth: '1px',
                borderColor: 'blue.3',
                borderStyle: 'solid',
                background: 'blue.05',
                AttachIcon: {
                    extends: 'Icon',
                    icon: (el, s)=>$6d6b3bb8c70300e4$var$_attachMeta(s.root.assistantAttachment?.type).icon,
                    boxSize: 'A A',
                    color: 'blue',
                    flexShrink: '0'
                },
                AttachInfo: {
                    flow: 'y',
                    gap: 'V',
                    flex: '1',
                    minWidth: '0',
                    TypeLabel: {
                        tag: 'span',
                        fontSize: 'Y2',
                        fontWeight: '600',
                        color: 'blue',
                        text: (el, s)=>$6d6b3bb8c70300e4$var$_attachMeta(s.root.assistantAttachment?.type).label
                    },
                    AttachTitle: {
                        tag: 'span',
                        fontSize: 'Z2',
                        color: 'title',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        text: (el, s)=>s.root.assistantAttachment?.title || ''
                    }
                },
                RemoveBtn: {
                    tag: 'button',
                    type: 'button',
                    padding: 'V',
                    round: 'V',
                    background: 'transparent',
                    borderWidth: '0',
                    color: 'caption',
                    cursor: 'pointer',
                    fontSize: 'Z2',
                    text: "\u2715",
                    ':hover': {
                        color: 'title'
                    },
                    onClick: (e, el, s)=>{
                        s.root.update({
                            assistantAttachment: null
                        });
                    }
                }
            },
            ComposerBox: {
                placeholder: "Ask a question\u2026",
                maxWidth: '100%',
                // _onSend (underscore prefix) avoids DOMQL treating this as the
                // DOM 'send' event handler — see ComposerBox.js for full rationale.
                _onSend: (body, el, s)=>{
                    $6d6b3bb8c70300e4$var$_triggerSend(el, s, body || 'Tell me about this');
                }
            }
        }
    }
};
const $6d6b3bb8c70300e4$export$51b4b8bffc37a91e = {
    tag: 'button',
    type: 'button',
    padding: 'Z A',
    round: 'C',
    fontSize: 'Z2',
    fontWeight: '500',
    cursor: 'pointer',
    fontFamily: 'inherit',
    borderWidth: '1px',
    borderColor: 'line',
    borderStyle: 'solid',
    background: 'transparent',
    color: 'caption',
    transition: 'all 120ms ease',
    ':hover': {
        borderColor: 'title',
        color: 'title',
        background: 'overlay'
    },
    text: (el, s)=>s?.text || '',
    onClick: (e, el, s)=>{
        const query = s?.text || '';
        if (query) $6d6b3bb8c70300e4$var$_triggerSend(el, s, query);
    }
};
const $6d6b3bb8c70300e4$export$f9378366af090265 = {
    flow: 'y',
    gap: 'Z',
    AttachedCard: {
        hide: (el, s)=>!s.attachment,
        flow: 'x',
        gap: 'Z',
        align: 'center',
        padding: 'Z Z1',
        round: 'Z',
        borderWidth: '1px',
        borderColor: 'blue.3',
        borderStyle: 'solid',
        background: 'blue.05',
        alignSelf: 'flex-end',
        maxWidth: '90%',
        CardIcon: {
            extends: 'Icon',
            icon: (el, s)=>$6d6b3bb8c70300e4$var$_attachMeta(s.attachment?.type).icon,
            boxSize: 'Z2 Z2',
            color: 'blue'
        },
        CardLabel: {
            tag: 'span',
            fontSize: 'Y2',
            fontWeight: '600',
            color: 'blue',
            text: (el, s)=>$6d6b3bb8c70300e4$var$_attachMeta(s.attachment?.type).label
        },
        CardTitle: {
            tag: 'span',
            fontSize: 'Z2',
            color: 'title',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>s.attachment?.title || ''
        }
    },
    Bubble: {
        padding: 'Z1 A',
        round: 'Z',
        background: 'transparent',
        alignSelf: 'flex-start',
        maxWidth: '90%',
        borderWidth: '1px',
        borderColor: 'line',
        borderStyle: 'solid',
        isUser: (el, s)=>s.role === 'user',
        '.isUser': {
            background: 'blue.1',
            alignSelf: 'flex-end',
            borderWidth: '0',
            borderStyle: 'none'
        },
        RoleLabel: {
            tag: 'span',
            fontSize: 'Y1',
            fontWeight: '600',
            letterSpacing: '.04em',
            color: 'caption',
            textTransform: 'uppercase',
            marginBottom: 'V',
            text: (el, s)=>s.role === 'user' ? 'You' : 'AI'
        },
        // AI output is lightweight markdown (bold/italic/code/link/linebreak).
        // Rendered via `html:` because expanding the markdown into DOMQL children
        // would require a full parser — out of scope for this shell. Content is
        // produced by our AI server, not user input, so the XSS surface is
        // limited to the model's own output.
        MsgContent: {
            tag: 'div',
            html: (el, s)=>$6d6b3bb8c70300e4$var$_formatHtml(s.content),
            fontSize: 'Z2',
            lineHeight: '1.65',
            color: 'title'
        }
    },
    ActionCard: {
        hide: (el, s)=>!(s._actions && s._actions.type && s._actions.type !== 'info' && !s._actions._confirmed),
        flow: 'y',
        gap: 'Z',
        padding: 'A',
        round: 'Z',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: (el, s)=>{
            const style = $6d6b3bb8c70300e4$var$_actionStyle(el, s._actions?.type);
            return style ? `${style.color}.3` : 'line';
        },
        background: (el, s)=>{
            const style = $6d6b3bb8c70300e4$var$_actionStyle(el, s._actions?.type);
            return style ? `${style.color}.06` : 'overlay';
        },
        alignSelf: 'flex-start',
        maxWidth: '90%',
        CardHeader: {
            flow: 'x',
            gap: 'Z',
            align: 'center left',
            Icon: {
                boxSize: 'A A',
                icon: (el, s)=>$6d6b3bb8c70300e4$var$_actionStyle(el, s._actions?.type)?.icon || 'state',
                color: (el, s)=>$6d6b3bb8c70300e4$var$_actionStyle(el, s._actions?.type)?.color || 'caption'
            },
            Label: {
                tag: 'span',
                fontSize: 'Y2',
                fontWeight: '700',
                textTransform: 'uppercase',
                letterSpacing: '.04em',
                color: (el, s)=>$6d6b3bb8c70300e4$var$_actionStyle(el, s._actions?.type)?.color || 'caption',
                text: (el, s)=>$6d6b3bb8c70300e4$var$_actionStyle(el, s._actions?.type)?.label || 'Action'
            }
        },
        CardTitle: {
            tag: 'h4',
            margin: '0',
            fontSize: 'Z2',
            fontWeight: '600',
            color: 'title',
            text: (el, s)=>{
                const a = s._actions;
                if (!a) return '';
                if (a.title) return a.title;
                if (a.number) return `#${a.number}`;
                return '';
            }
        },
        CardMeta: {
            hide: (el, s)=>{
                const a = s._actions;
                return !(a?.body || a?.date || a?.priority || a?.category || a?.column_key);
            },
            tag: 'p',
            margin: '0',
            fontSize: 'Y2',
            color: 'caption',
            lineHeight: '1.4',
            text: (el, s)=>{
                const a = s._actions;
                if (!a) return '';
                const parts = [];
                if (a.body) parts.push(a.body.slice(0, 80) + (a.body.length > 80 ? '...' : ''));
                if (a.date) parts.push(`Date: ${a.date}`);
                if (a.startTime) parts.push(`${a.startTime}\u{2013}${a.endTime || ''}`);
                if (a.priority) parts.push(`Priority: ${a.priority}`);
                if (a.category) parts.push(`Category: ${a.category}`);
                if (a.assignee) parts.push(`\u{2192} ${a.assignee}`);
                return parts.join(" \xb7 ");
            }
        },
        CardActions: {
            flow: 'x',
            gap: 'Z',
            marginTop: 'V',
            ConfirmBtn: {
                extends: 'Button',
                theme: 'primary',
                padding: 'Z A',
                fontSize: 'Z2',
                text: 'Confirm',
                onClick: (e, el, s)=>{
                    const a = s._actions;
                    if (!a) return;
                    try {
                        el.call('aiPerformAction', a, s);
                    } catch (err) {
                        console.error('[AppAssistant] aiPerformAction failed', err);
                    }
                    const root = s.root;
                    const msgs = root.assistantMessages || [];
                    const idx = msgs.indexOf(s);
                    if (idx >= 0) {
                        const updated = msgs.slice();
                        updated[idx] = {
                            ...updated[idx],
                            _actions: {
                                ...a,
                                _confirmed: true
                            }
                        };
                        root.update({
                            assistantMessages: updated
                        });
                    }
                }
            },
            CancelBtn: {
                tag: 'button',
                type: 'button',
                padding: 'Z A',
                fontSize: 'Z2',
                fontWeight: '500',
                background: 'transparent',
                borderWidth: '0',
                color: 'caption',
                cursor: 'pointer',
                fontFamily: 'inherit',
                text: 'Cancel',
                ':hover': {
                    color: 'title'
                },
                onClick: (e, el, s)=>{
                    const root = s.root;
                    const msgs = root.assistantMessages || [];
                    const idx = msgs.indexOf(s);
                    if (idx >= 0) {
                        const updated = msgs.slice();
                        updated[idx] = {
                            ...updated[idx],
                            _actions: null
                        };
                        root.update({
                            assistantMessages: updated
                        });
                    }
                }
            }
        }
    },
    ConfirmedCard: {
        hide: (el, s)=>!s._actions?._confirmed,
        flow: 'x',
        gap: 'Z',
        align: 'center left',
        padding: 'Z A',
        round: 'Z',
        background: 'green.08',
        borderWidth: '1px',
        borderColor: 'green.3',
        borderStyle: 'solid',
        alignSelf: 'flex-start',
        maxWidth: '90%',
        Icon: {
            icon: 'check',
            boxSize: 'A A',
            color: 'green'
        },
        Label: {
            tag: 'span',
            fontSize: 'Z2',
            fontWeight: '600',
            color: 'green',
            text: (el, s)=>{
                const a = s._actions;
                if (!a) return 'Done';
                const style = $6d6b3bb8c70300e4$var$_actionStyle(el, a.type);
                return `\u{2713} ${style?.label || 'Action'} \u{2014} ${a.title || '#' + (a.number || '')}`;
            }
        }
    },
    FollowUps: {
        hide: (el, s)=>{
            if (s.role !== 'assistant' || s._streaming) return true;
            const fups = s._followUps || s.followUps;
            return !(fups && fups.length);
        },
        flow: 'x wrap',
        gap: 'Y',
        marginTop: 'V',
        childExtends: 'AppAssistantSuggestion',
        childrenAs: 'state',
        children: (el, s)=>{
            const fups = s._followUps || s.followUps || [];
            return fups.map((q, i)=>({
                    key: i,
                    text: q
                }));
        }
    }
};

});

parcelRegister("ekuwz", function(module, exports) {

$parcel$export(module.exports, "ComposerBox", () => $a6ea9c6f1e781d04$export$daf2da4896efca30);
// Shared composer input — textarea-backed (no contenteditable, no DOM writes).
// Usage:
//   ComposerBox: {
//     placeholder: 'Ask a question…',
//     _onSend: (body, el, s) => { /* handle send */ }
//   }
//
// NOTE: the callback is named `_onSend` (underscore prefix), NOT `onSend`.
// DOMQL treats any `onXxx` property (where X is uppercase) as a DOM event
// handler and registers it as an event listener for the synthetic 'send'
// DOM event — which never fires. The underscore prefix keeps it as a plain
// property that _submit can read via el.parent._onSend.
//
// The textarea's value is driven by component state `_composerDraft` so
// clearing after submit is a state update — no `el.node.innerHTML = ''` or
// other DOM mutations. Each ComposerBox gets its own local state slot
// (DOMQL auto-creates `_composerDraft` on first update), so multiple
// composers coexist without collisions.
const $a6ea9c6f1e781d04$var$_submit = (el, s)=>{
    const body = ((s._composerDraft || '') + '').trim();
    if (!body) return;
    // Use _onSend (underscore-prefixed) so DOMQL does not mistake it for a
    // DOM event handler and try to register it as an event listener for
    // the synthetic 'send' event — which never fires. The underscore prefix
    // bypasses isEventHandler() and keeps the function as a plain property
    // on the ComposerBox element, readable via el.parent._onSend.
    const onSend = el.parent?._onSend;
    if (typeof onSend === 'function') onSend(body, el, s);
    s.update({
        _composerDraft: ''
    });
};
const $a6ea9c6f1e781d04$export$daf2da4896efca30 = {
    flow: 'y',
    position: 'relative',
    padding: 'A A2 C1',
    round: 'A',
    overflow: 'hidden',
    theme: 'field',
    transition: 'B all defaultBezier',
    width: '100%',
    maxWidth: 'I1',
    margin: '0 auto',
    // Isolated state per ComposerBox instance — _composerDraft is local to
    // this component so multiple composers (AI assistant, chat, daily updates)
    // don't share the same draft slot on the root state.
    state: {
        _composerDraft: ''
    },
    SendBtn: {
        extends: 'CircleButton',
        position: 'absolute',
        bottom: 'Z',
        right: 'Z',
        zIndex: '1',
        padding: 'Z',
        icon: 'chevronUp',
        Icon: {
            transform: 'rotate(45deg)'
        },
        // Reusable brand CTA theme — canonical "submit" affordance used by
        // ContinueButton, SignupForm, LoginForm, etc. across the editor.
        // brand/designSystem/theme.js → primary:
        //   @dark : white text on electricBlue background
        //   @light: white text on gray1 (near-black) background
        // Both modes guarantee high contrast — no white-on-white possible.
        // Replaces the inline @dark override that hardcoded `background:
        // white` + `color: title` (semantic 'title' resolves to white in
        // dark mode → white text on white bg → invisible — the bug).
        theme: 'primary',
        onClick: (e, el, s)=>{
            e.preventDefault();
            $a6ea9c6f1e781d04$var$_submit(el, s);
        }
    },
    Editor: {
        tag: 'textarea',
        rows: '1',
        spellcheck: 'true',
        width: '100%',
        minHeight: 'C',
        maxHeight: 'F',
        padding: '0',
        outline: 'none',
        borderWidth: '0',
        background: 'transparent',
        fontSize: 'Z2',
        fontFamily: 'inherit',
        lineHeight: '1.5',
        resize: 'none',
        overflow: 'auto',
        wordBreak: 'break-word',
        color: 'title',
        placeholder: (el, s)=>{
            const ph = el.parent?.placeholder;
            return typeof ph === 'function' ? ph(el, s) : ph || "Type something\u2026";
        },
        value: (el, s)=>s._composerDraft || '',
        onInput: (e, el, s)=>{
            s.update({
                _composerDraft: e.target.value
            });
        },
        onKeydown: (e, el, s)=>{
            if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault();
                $a6ea9c6f1e781d04$var$_submit(el, s);
            }
        }
    }
};

});

parcelRegister("jlDkL", function(module, exports) {

$parcel$export(module.exports, "CommonCard", () => $e15e7d5e5e3753fc$export$ba844440fc96ec36);
const $e15e7d5e5e3753fc$export$ba844440fc96ec36 = {
    background: 'overlayStrong',
    round: 'A',
    padding: 'A'
};

});

parcelRegister("gBYsy", function(module, exports) {

$parcel$export(module.exports, "AppPage", () => $c17f000b955cc594$export$e2e9b8b5e72b52f3);
const $c17f000b955cc594$export$e2e9b8b5e72b52f3 = {
    flow: 'x',
    width: '100%',
    maxWidth: 'none',
    margin: '0',
    padding: '0',
    overflow: 'hidden',
    theme: 'document'
};

});

parcelRegister("5pzX6", function(module, exports) {

$parcel$export(module.exports, "AppMain", () => $3f0b2ce5da55b792$export$d9658a619df134e1);
const $3f0b2ce5da55b792$export$d9658a619df134e1 = {
    extends: 'CommonCard',
    flow: 'y',
    flex: '1 1 0',
    minWidth: '0',
    minHeight: '0',
    overflow: 'hidden',
    margin: '- X2 X2 -',
    Header: {
        flow: 'x',
        flex: '0 0 auto'
    },
    Body: {
        flex: '1 1 0',
        flow: 'y',
        minHeight: '0',
        overflow: 'hidden',
        position: 'relative'
    }
};

});

parcelRegister("28WTj", function(module, exports) {

$parcel$export(module.exports, "AppSidebar", () => $18fa02aa66405cf5$export$5b229532c5a8c084);
$parcel$export(module.exports, "PeopleGroup", () => $18fa02aa66405cf5$export$7c7e61f64744b9);
$parcel$export(module.exports, "AppPersonRow", () => $18fa02aa66405cf5$export$9ea2ed864c273f8b);
const $18fa02aa66405cf5$export$5b229532c5a8c084 = {
    flow: 'y',
    width: 'G',
    minWidth: 'G',
    alignSelf: 'stretch',
    color: 'title',
    overflow: 'hidden',
    padding: '- Z X2 X2',
    gap: 'Z',
    fontSize: 'Z',
    childExtends: 'CommonCard',
    childProps: {
        flow: 'y'
    }
};
const $18fa02aa66405cf5$export$7c7e61f64744b9 = {
    flow: 'y',
    gap: 'Z',
    marginBottom: 'Z1',
    CaptionTitle: {
        fontSize: 'Y2',
        Text: {
            text: (el)=>el.parent?.parent?.label || ''
        }
    },
    List: {
        flow: 'y',
        gap: 'Y',
        childExtends: 'AppPersonRow',
        childrenAs: 'state',
        children: (el, s)=>{
            const group = el.parent.groupName;
            const fn = group === 'team' ? 'activeMembers' : 'peopleByShareClass';
            return el.call(fn, group) || [];
        }
    }
};
const $18fa02aa66405cf5$export$9ea2ed864c273f8b = {
    flow: 'x',
    align: 'center left',
    gap: 'Z',
    padding: 'Z Z1',
    margin: '- -Z1',
    round: 'Z',
    fontSize: 'Z1',
    cursor: 'pointer',
    attr: {
        'data-personrow': 'true',
        'data-email': (el, s)=>s && (s.email || s.user?.email) || ''
    },
    ':hover': {
        background: 'overlay'
    },
    Avatar: {
        avatarType: 'initials',
        boxSize: 'B1 B1',
        src: (el, s)=>el.call('avatarUrl', s && (s.name || s.user?.name))
    },
    Info: {
        flow: 'y',
        gap: 'V',
        flex: '1',
        minWidth: '0',
        overflow: 'hidden',
        Name: {
            tag: 'span',
            fontSize: 'Z2',
            color: 'title',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>s?.name || s?.user?.name || s?.email || s?.user?.email || ''
        },
        Caption: {
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>s?.position || s?.role || s?.membership?.role || ''
        }
    }
};

});

parcelRegister("lUMqC", function(module, exports) {

$parcel$export(module.exports, "PeopleSection", () => $ff4464c811b6bf8d$export$dd2d4d0b8ec52ff3);
const $ff4464c811b6bf8d$export$dd2d4d0b8ec52ff3 = {
    flow: 'y',
    padding: 'A B',
    gap: 'Z1',
    flex: '1',
    minHeight: '0',
    overflow: 'auto'
};

});

parcelRegister("akZSB", function(module, exports) {

$parcel$export(module.exports, "ChatDrawer", () => $786bc5ac3a5e7f91$export$44cd7a5d7a54ac6b);
$parcel$export(module.exports, "ChatDrawerChannelRow", () => $786bc5ac3a5e7f91$export$ccfa0778f53f27fa);
$parcel$export(module.exports, "ChatDrawerMessage", () => $786bc5ac3a5e7f91$export$ea51ed8b2b5db9aa);
$parcel$export(module.exports, "toggleChatDrawer", () => $786bc5ac3a5e7f91$export$16400b2feecb7ef5);
$parcel$export(module.exports, "openChatDrawer", () => $786bc5ac3a5e7f91$export$b224f6f4d5f630ca);
$parcel$export(module.exports, "closeChatDrawer", () => $786bc5ac3a5e7f91$export$3fac3d2397dfa418);
// Shared ChatDrawer bridge — registers the federated chat drawer from
// @symbo.ls/collab-features/chat into the editor's component registry.
// The workspace app picks it up through sharedLibraries
// (workspace/packages/shared is imported by workspace/packages/workspace/
// sharedLibraries.js), so this file serves both apps. Single source of
// truth.
//
// Workspace's app.js declares `ChatDrawer: {}` at root; canvas app.js
// does the same. Both resolve to the package's component via this
// re-export.
parcelRequire("kve3A");
var $f7X5N = parcelRequire("f7X5N");
const $786bc5ac3a5e7f91$export$44cd7a5d7a54ac6b = (0, $f7X5N).ChatDrawer;
const $786bc5ac3a5e7f91$export$ccfa0778f53f27fa = (0, $f7X5N).ChatDrawerChannelRow;
const $786bc5ac3a5e7f91$export$ea51ed8b2b5db9aa = (0, $f7X5N).ChatDrawerMessage;
const $786bc5ac3a5e7f91$export$16400b2feecb7ef5 = (0, $f7X5N).toggleChatDrawer;
const $786bc5ac3a5e7f91$export$b224f6f4d5f630ca = (0, $f7X5N).openChatDrawer;
const $786bc5ac3a5e7f91$export$3fac3d2397dfa418 = (0, $f7X5N).closeChatDrawer;

});
parcelRegister("kve3A", function(module, exports) {

$parcel$export(module.exports, "chat", () => (parcelRequire("f7X5N")));
$parcel$export(module.exports, "notifications", () => (parcelRequire("eONSp")));
// Root export for @symbo.ls/collab-features. Mirrors the shape of
// @symbo.ls/finance-features: one subpath per feature, each bound to
// the governance Supabase project via sdk-bridge.
//
// Current state: the intranet owns the full chat implementation. This
// package exposes a stable surface so future consumers (editor chat
// embed, admin monitoring) can import from here without depending on
// the intranet package directly.

var $f7X5N = parcelRequire("f7X5N");

var $2uy7C = parcelRequire("2uy7C");

var $3QQYd = parcelRequire("3QQYd");

var $guMdf = parcelRequire("guMdf");

var $eONSp = parcelRequire("eONSp");

});
parcelRegister("f7X5N", function(module, exports) {

$parcel$export(module.exports, "CHAT_CONFIG", () => (parcelRequire("jk0e4")).CHAT_CONFIG);
$parcel$export(module.exports, "chatClient", () => (parcelRequire("hieSu")).chatClient);
$parcel$export(module.exports, "chatAvailable", () => (parcelRequire("hieSu")).chatAvailable);
$parcel$export(module.exports, "listChannels", () => (parcelRequire("9uyCk")).listChannels);
$parcel$export(module.exports, "listMessages", () => (parcelRequire("9uyCk")).listMessages);
$parcel$export(module.exports, "sendMessage", () => (parcelRequire("9uyCk")).sendMessage);
$parcel$export(module.exports, "deleteMessage", () => (parcelRequire("9uyCk")).deleteMessage);
$parcel$export(module.exports, "channelDisplayName", () => (parcelRequire("9uyCk")).channelDisplayName);
$parcel$export(module.exports, "subscribeMessages", () => (parcelRequire("9uyCk")).subscribeMessages);
$parcel$export(module.exports, "unreadCount", () => (parcelRequire("9uyCk")).unreadCount);
$parcel$export(module.exports, "ChatDrawer", () => (parcelRequire("jL41b")).ChatDrawer);
$parcel$export(module.exports, "ChatDrawerChannelRow", () => (parcelRequire("jL41b")).ChatDrawerChannelRow);
$parcel$export(module.exports, "ChatDrawerMessage", () => (parcelRequire("jL41b")).ChatDrawerMessage);
$parcel$export(module.exports, "toggleChatDrawer", () => (parcelRequire("jL41b")).toggleChatDrawer);
$parcel$export(module.exports, "openChatDrawer", () => (parcelRequire("jL41b")).openChatDrawer);
$parcel$export(module.exports, "closeChatDrawer", () => (parcelRequire("jL41b")).closeChatDrawer);
$parcel$export(module.exports, "bootstrapChatState", () => (parcelRequire("jL41b")).bootstrapChatState);
$parcel$export(module.exports, "switchChannel", () => (parcelRequire("jL41b")).switchChannel);
// Public surface for @symbo.ls/collab-features/chat. Import from here
// — internals may rearrange as more of the intranet's chat logic
// migrates into the package.

var $jk0e4 = parcelRequire("jk0e4");

var $hieSu = parcelRequire("hieSu");

var $9uyCk = parcelRequire("9uyCk");

var $jL41b = parcelRequire("jL41b");

});
parcelRegister("jk0e4", function(module, exports) {

$parcel$export(module.exports, "CHAT_CONFIG", () => $e1100f72327f3d10$export$72d3bf9ceabcb87b);

var $8RlGv = parcelRequire("8RlGv");
const $e1100f72327f3d10$export$72d3bf9ceabcb87b = {
    projectName: (0, $8RlGv.PROJECT_GOVERNANCE),
    tables: {
        channels: 'chat_channels',
        channelMembers: 'chat_channel_members',
        messages: 'chat_messages',
        reactions: 'chat_reactions',
        mentions: 'chat_mentions'
    }
};

});

parcelRegister("hieSu", function(module, exports) {

$parcel$export(module.exports, "chatClient", () => $c96fa8891987924f$export$a1c1749a1bf18610);
$parcel$export(module.exports, "chatAvailable", () => $c96fa8891987924f$export$d2fcb6e9d5032321);

var $8RlGv = parcelRequire("8RlGv");

var $jk0e4 = parcelRequire("jk0e4");
const $c96fa8891987924f$export$a1c1749a1bf18610 = ()=>(0, $8RlGv.getClient)((0, $jk0e4.CHAT_CONFIG).projectName);
const $c96fa8891987924f$export$d2fcb6e9d5032321 = ()=>!!$c96fa8891987924f$export$a1c1749a1bf18610();

});

parcelRegister("9uyCk", function(module, exports) {

$parcel$export(module.exports, "listChannels", () => $6e91c4a0e892fe37$export$17a8ba8225483fd0);
$parcel$export(module.exports, "channelDisplayName", () => $6e91c4a0e892fe37$export$27109ced7a4912bf);
$parcel$export(module.exports, "listMessages", () => $6e91c4a0e892fe37$export$166aade1657b7533);
$parcel$export(module.exports, "sendMessage", () => $6e91c4a0e892fe37$export$465cb47180de50f0);
$parcel$export(module.exports, "deleteMessage", () => $6e91c4a0e892fe37$export$b7572a81e749f23f);
$parcel$export(module.exports, "subscribeMessages", () => $6e91c4a0e892fe37$export$402ddcaca1250bd);
$parcel$export(module.exports, "unreadCount", () => $6e91c4a0e892fe37$export$acb9fd9c5a541324);
// Chat data access. Thin wrappers over the SDK adapter so the wire
// shape stays consistent with the rest of the workspace surface
// (sdk → adapter → workspace-project worker → Supabase). Realtime
// subscriptions stay on the direct Supabase client (`subscribeMessages`
// below) because the worker doesn't proxy WebSocket channels — that's
// the documented split per shared/functions/chat/subscribeRealtime.js.
//
// Migrated 2026-04-30 from direct `chatClient()` reads to
// `getSDK().execute('workspaceProject.chat[.X]', '<method>', ...)`.
// Direct Supabase reads bypassed the worker auth / RLS and meant the
// audit saw 0 calls to /workspace-project/* — see AUDIT_PLAN.md.

var $hieSu = parcelRequire("hieSu");

var $bfqVY = parcelRequire("bfqVY");

var $jk0e4 = parcelRequire("jk0e4");
const { tables: $6e91c4a0e892fe37$var$tables } = (0, $jk0e4.CHAT_CONFIG);
// Normalize SDK envelope. `execute()` returns either a bare array/row
// or `{ data, error }`-shaped — adapters vary across surfaces. Squash
// to `{ data, error }` so consumers don't branch on shape.
const $6e91c4a0e892fe37$var$_envelope = (raw)=>{
    if (raw == null) return {
        data: [],
        error: null
    };
    if (raw && typeof raw === 'object' && ('data' in raw || 'error' in raw)) return {
        data: raw.data ?? [],
        error: raw.error ?? null
    };
    return {
        data: raw,
        error: null
    };
};
const $6e91c4a0e892fe37$export$17a8ba8225483fd0 = async ()=>{
    const sdk = (0, $bfqVY.getSDK)?.();
    if (!sdk?.execute) return {
        data: [],
        error: null
    };
    try {
        const [channelsRaw, membersRaw] = await Promise.all([
            sdk.execute('workspaceProject.chat', 'list'),
            sdk.execute('workspaceProject.chat.members', 'list')
        ]);
        const channelsRes = $6e91c4a0e892fe37$var$_envelope(channelsRaw);
        const membersRes = $6e91c4a0e892fe37$var$_envelope(membersRaw);
        if (channelsRes.error) return channelsRes;
        const memberMap = new Map();
        for (const m of membersRes.data || []){
            if (!memberMap.has(m.channel_id)) memberMap.set(m.channel_id, []);
            memberMap.get(m.channel_id).push(m.member_email);
        }
        const data = (channelsRes.data || []).slice().sort((a, b)=>new Date(a.created_at || 0) - new Date(b.created_at || 0)).map((ch)=>({
                ...ch,
                _memberEmails: memberMap.get(ch.id) || []
            }));
        return {
            data: data,
            error: null
        };
    } catch (error) {
        return {
            data: [],
            error: error
        };
    }
};
const $6e91c4a0e892fe37$export$27109ced7a4912bf = (channel, currentUserEmail, peopleByEmail = {})=>{
    if (!channel) return '';
    if (channel.kind === 'channel') return `#${channel.name || 'channel'}`;
    const others = (channel._memberEmails || []).filter((e)=>e !== currentUserEmail).map((e)=>peopleByEmail[e]?.name || e);
    if (channel.kind === 'dm') return others[0] || 'Direct message';
    return others.join(', ') || 'Group DM';
};
const $6e91c4a0e892fe37$export$166aade1657b7533 = async ({ channelId: channelId, beforeId: beforeId, limit: limit = 50 } = {})=>{
    const sdk = (0, $bfqVY.getSDK)?.();
    if (!sdk?.execute) return {
        data: [],
        error: null
    };
    try {
        const raw = await sdk.execute('workspaceProject.chat.messages', 'list', {
            channelId: channelId,
            options: {
                limit: limit,
                order: {
                    column: 'created_at',
                    ascending: false
                },
                ...beforeId ? {
                    filter: {
                        column: 'id',
                        op: 'lt',
                        value: beforeId
                    }
                } : {}
            }
        });
        return $6e91c4a0e892fe37$var$_envelope(raw);
    } catch (error) {
        return {
            data: [],
            error: error
        };
    }
};
const $6e91c4a0e892fe37$export$465cb47180de50f0 = async ({ channelId: channelId, senderEmail: senderEmail, body: body, parentId: parentId = null })=>{
    const sdk = (0, $bfqVY.getSDK)?.();
    if (!sdk?.execute) return {
        data: null,
        error: new Error('sdk unavailable')
    };
    try {
        const raw = await sdk.execute('workspaceProject.chat.messages', 'create', {
            channelId: channelId,
            payload: {
                sender_email: senderEmail,
                body: body,
                parent_id: parentId
            }
        });
        return $6e91c4a0e892fe37$var$_envelope(raw);
    } catch (error) {
        return {
            data: null,
            error: error
        };
    }
};
const $6e91c4a0e892fe37$export$b7572a81e749f23f = async (messageId)=>{
    const sdk = (0, $bfqVY.getSDK)?.();
    if (!sdk?.execute) return {
        data: null,
        error: new Error('sdk unavailable')
    };
    try {
        const raw = await sdk.execute('workspaceProject.chat.messages', 'remove', {
            messageId: messageId
        });
        return $6e91c4a0e892fe37$var$_envelope(raw);
    } catch (error) {
        return {
            data: null,
            error: error
        };
    }
};
const $6e91c4a0e892fe37$export$402ddcaca1250bd = ({ channelId: channelId, onInsert: onInsert, onUpdate: onUpdate, onDelete: onDelete } = {})=>{
    const sb = (0, $hieSu.chatClient)();
    if (!sb) return ()=>{};
    const name = `rt-chat-${channelId || 'all'}-${Math.random().toString(36).slice(2, 8)}`;
    const ch = sb.channel(name);
    const filter = channelId ? `channel_id=eq.${channelId}` : undefined;
    ch.on('postgres_changes', {
        event: 'INSERT',
        schema: 'public',
        table: $6e91c4a0e892fe37$var$tables.messages,
        filter: filter
    }, (payload)=>onInsert?.(payload.new));
    if (onUpdate) ch.on('postgres_changes', {
        event: 'UPDATE',
        schema: 'public',
        table: $6e91c4a0e892fe37$var$tables.messages,
        filter: filter
    }, (payload)=>onUpdate(payload.new));
    if (onDelete) ch.on('postgres_changes', {
        event: 'DELETE',
        schema: 'public',
        table: $6e91c4a0e892fe37$var$tables.messages,
        filter: filter
    }, (payload)=>onDelete(payload.old));
    ch.subscribe();
    return ()=>{
        try {
            ch.unsubscribe();
        } catch  {}
    };
};
const $6e91c4a0e892fe37$export$acb9fd9c5a541324 = ({ messagesByChannel: messagesByChannel, channelMembers: channelMembers, currentUserEmail: currentUserEmail })=>{
    if (!messagesByChannel || !channelMembers || !currentUserEmail) return 0;
    const myMemberships = channelMembers.filter((m)=>m.member_email === currentUserEmail);
    let total = 0;
    for (const mm of myMemberships){
        if (mm.muted) continue;
        const cutoff = mm.last_read_at ? new Date(mm.last_read_at).getTime() : 0;
        const msgs = messagesByChannel[mm.channel_id] || [];
        for (const msg of msgs){
            if (msg.deleted) continue;
            const author = msg.authorEmail ?? msg.author_email ?? msg.sender_email;
            if (author === currentUserEmail) continue;
            const t = new Date(msg.createdAt ?? msg.created_at ?? 0).getTime();
            if (t > cutoff) total++;
        }
    }
    return total;
};

});

parcelRegister("jL41b", function(module, exports) {

$parcel$export(module.exports, "bootstrapChatState", () => $e625860720fec096$export$b347b1ac9ab7d62b);
$parcel$export(module.exports, "switchChannel", () => $e625860720fec096$export$c84605f0f811629);
$parcel$export(module.exports, "toggleChatDrawer", () => $e625860720fec096$export$16400b2feecb7ef5);
$parcel$export(module.exports, "openChatDrawer", () => $e625860720fec096$export$b224f6f4d5f630ca);
$parcel$export(module.exports, "closeChatDrawer", () => $e625860720fec096$export$3fac3d2397dfa418);
$parcel$export(module.exports, "ChatDrawer", () => $e625860720fec096$export$44cd7a5d7a54ac6b);
$parcel$export(module.exports, "ChatDrawerChannelRow", () => $e625860720fec096$export$ccfa0778f53f27fa);
$parcel$export(module.exports, "ChatDrawerMessage", () => $e625860720fec096$export$ea51ed8b2b5db9aa);
// ChatDrawer — right-side slide-in that reuses the full chat surface
// (ChatMessageList + ChatComposer + ChatHoverActions + ChatThreadPanel).
// Mirrors the chat page's shared root state (`channels`, `channelMembers`,
// `messagesByChannel`, `activeChannelId`, `activeThreadRootId`) so every
// bubble, composer affordance, hover action, and thread reply works
// identically to /chat. No parallel `_chatDrawer*` state.
//
// Data lifecycle:
//   - On open: if `root.channels` is empty (user hasn't visited /chat
//     this session) the drawer fetches channels + members itself.
//   - On active-channel change: loads the last 50 messages into
//     `messagesByChannel[id]` if absent, and binds a realtime
//     subscription scoped to that channel.
//   - Message sends + reactions route through the intranet's registered
//     functions (el.call('sendMessage', …)) which already target the
//     same shared state — nothing to wire.
//
// Event delegation: the /chat page installs document-level click /
// pointerdown / keydown handlers in its onCreate. When the drawer is
// opened from another route those handlers don't exist. We install a
// scoped subset from the drawer's onCreate — mention picking, thread
// open, tab / action buttons — guarded so we never double-install when
// the chat page IS mounted.

var $9uyCk = parcelRequire("9uyCk");

var $hieSu = parcelRequire("hieSu");

var $jk0e4 = parcelRequire("jk0e4");
const { tables: $e625860720fec096$var$tables } = (0, $jk0e4.CHAT_CONFIG);
// ─── shared-state loader ──────────────────────────────────────────────────
// Row shape used by ChatMessageList / ChatMessageRow — matches the
// intranet's `rowToMessage` exactly so the bubble renderer doesn't
// fork on where the data came from.
const $e625860720fec096$var$_rowToMessage = (r)=>({
        id: r.id,
        channelId: r.channel_id,
        authorEmail: r.author_email,
        body: r.body,
        attachments: r.attachments || null,
        replyTo: r.reply_to,
        threadRoot: r.thread_root,
        threadCount: r.thread_count || 0,
        editedAt: r.edited_at,
        deleted: !!r.deleted,
        createdAt: r.created_at
    });
const $e625860720fec096$var$_rowToChannel = (r)=>({
        id: r.id,
        kind: r.kind,
        name: r.name,
        topic: r.topic,
        isPrivate: !!r.is_private,
        isArchived: !!r.is_archived,
        createdBy: r.created_by,
        createdAt: r.created_at,
        updatedAt: r.updated_at,
        _memberEmails: r._memberEmails || []
    });
const $e625860720fec096$export$b347b1ac9ab7d62b = async (root)=>{
    if (!root) return;
    // Editor doesn't auto-populate `root.currentUserEmail` the way the
    // intranet's auth flow does — pull it from the governance Supabase
    // session directly so bubble rendering (own-vs-other) + send paths
    // work everywhere the drawer mounts.
    if (!root.currentUserEmail) {
        const sb = (0, $hieSu.chatClient)();
        if (sb) try {
            const { data: data } = await sb.auth.getUser();
            const email = data?.user?.email;
            if (email) root.update({
                currentUserEmail: email
            });
        } catch  {}
        if (!root.currentUserEmail) {
            root.update({
                _chatDrawerLoading: false,
                _chatDrawerError: 'Chat needs a workspace sign-in. Sign in via the intranet once to activate governance, then the drawer will work everywhere.'
            });
            return;
        }
    }
    await $e625860720fec096$var$_loadChannelsIntoRoot(root);
    if (root.activeChannelId) await $e625860720fec096$var$_loadMessagesIntoRoot(root, root.activeChannelId);
};
const $e625860720fec096$export$c84605f0f811629 = async (root, channelId)=>{
    if (!root || !channelId) return;
    root.update({
        activeChannelId: channelId,
        activeThreadRootId: null,
        _chatDrawerSwitcherOpen: false
    });
    await $e625860720fec096$var$_loadMessagesIntoRoot(root, channelId);
};
const $e625860720fec096$var$_loadChannelsIntoRoot = async (root)=>{
    if ((root.channels || []).length) return;
    // Editor runs with governance as an OPTIONAL extension — the Supabase
    // client for `governance` only exists after activateExtension() or
    // loginAll() has fanned out. When chat is opened in a context where
    // the session hasn't hydrated (e.g. editor logged in as a personal-org
    // user with no team-org claim), `chatClient()` is null and every query
    // would throw. Surface a readable state instead of crashing.
    const sb = (0, $hieSu.chatClient)();
    if (!sb) {
        root.update({
            _chatDrawerLoading: false,
            _chatDrawerError: 'Chat requires a governance session. Sign in with a workspace account to continue.'
        });
        return;
    }
    root.update({
        _chatDrawerLoading: true,
        _chatDrawerError: null
    });
    const [chRes, memRes] = await Promise.all([
        (0, $9uyCk.listChannels)(),
        sb.from($e625860720fec096$var$tables.channelMembers).select('*')
    ]);
    const channels = (chRes.data || []).map($e625860720fec096$var$_rowToChannel);
    const channelMembers = memRes.data || [];
    const me = root.currentUserEmail;
    const myIds = new Set(channelMembers.filter((m)=>m.member_email === me).map((m)=>m.channel_id));
    const active = root.activeChannelId && channels.some((c)=>c.id === root.activeChannelId) ? root.activeChannelId : channels.find((c)=>myIds.has(c.id))?.id || channels[0]?.id || null;
    root.update({
        channels: channels,
        channelMembers: channelMembers,
        activeChannelId: active,
        activeTab: root.activeTab || 'conversation',
        _chatDrawerLoading: false
    });
};
const $e625860720fec096$var$_loadMessagesIntoRoot = async (root, channelId)=>{
    if (!channelId) return;
    const map = root.messagesByChannel || {};
    if ((map[channelId] || []).length) return;
    const { data: data } = await (0, $9uyCk.listMessages)({
        channelId: channelId,
        limit: 50
    });
    const msgs = (data || []).map($e625860720fec096$var$_rowToMessage).reverse();
    root.update({
        messagesByChannel: {
            ...root.messagesByChannel || {},
            [channelId]: msgs
        }
    });
};
// Channel name formatter — shared between the drawer header title,
// switcher trigger, and each row in the switcher popover.
const $e625860720fec096$var$_channelLabel = (ch, root)=>{
    if (!ch) return 'Chat';
    if (ch.kind === 'channel') return `#${ch.name || 'channel'}`;
    const peopleByEmail = {};
    for (const p of root?.people || [])peopleByEmail[p.email] = p;
    const others = (ch._memberEmails || []).filter((e)=>e !== root?.currentUserEmail);
    const names = others.map((e)=>peopleByEmail[e]?.name || e);
    if (ch.kind === 'dm') return names[0] || 'Direct message';
    return names.join(', ') || 'Group DM';
};
const $e625860720fec096$export$16400b2feecb7ef5 = (root)=>{
    if (!root) return;
    root.update({
        _chatDrawerOpen: !root._chatDrawerOpen
    });
};
const $e625860720fec096$export$b224f6f4d5f630ca = (root, channelId = null)=>{
    if (!root) return;
    root.update({
        _chatDrawerOpen: true,
        ...channelId ? {
            activeChannelId: channelId
        } : {}
    });
};
const $e625860720fec096$export$3fac3d2397dfa418 = (root)=>root?.update({
        _chatDrawerOpen: false
    });
// ─── minimal delegation (only when chat page is not mounted) ──────────────
// The /chat page installs a much richer handler set. When the drawer is
// invoked from another route we cover the subset the ChatComposer needs.
const $e625860720fec096$var$_installDelegation = (root)=>{
    if (typeof document === 'undefined') return ()=>{};
    if (document.__chatDrawerDelegationInstalled) return ()=>{};
    document.__chatDrawerDelegationInstalled = true;
    const threadOpen = (ev)=>{
        const node = ev.target?.closest?.('[data-thread-open]');
        if (!node) return;
        const id = parseInt(node.getAttribute('data-thread-open'), 10);
        if (!isNaN(id)) {
            root.update({
                activeThreadRootId: id
            });
            ev.stopPropagation();
        }
    };
    document.addEventListener('click', threadOpen, true);
    return ()=>{
        document.removeEventListener('click', threadOpen, true);
        document.__chatDrawerDelegationInstalled = false;
    };
};
const $e625860720fec096$export$44cd7a5d7a54ac6b = {
    hide: (el, s)=>!s.root?._chatDrawerOpen,
    position: 'fixed',
    top: '0',
    right: '0',
    bottom: '0',
    width: 'H1',
    maxWidth: 'calc(100vw - A)',
    zIndex: '300',
    theme: 'document',
    background: 'document',
    borderLeft: '1px solid',
    borderColor: 'line',
    boxShadow: '-8px 0 32px var(--color-shadow)',
    flow: 'y',
    overflow: 'hidden',
    onCreate: (el, s)=>{
        el._uninstall = $e625860720fec096$var$_installDelegation(s.root);
    },
    onUpdate: (el, s)=>{
        const root = s.root;
        if (!root) return;
        // Just opened → bootstrap channels if needed.
        const open = !!root._chatDrawerOpen;
        if (open && !el._bootstrapped) {
            el._bootstrapped = true;
            $e625860720fec096$var$_loadChannelsIntoRoot(root).then(()=>{
                if (root.activeChannelId) $e625860720fec096$var$_loadMessagesIntoRoot(root, root.activeChannelId);
            });
        }
        if (!open) el._bootstrapped = false;
        // Active channel changed → load messages + (re)bind realtime.
        const chId = root.activeChannelId;
        if (el._subChannelId !== chId) {
            if (el._unsubRT) {
                try {
                    el._unsubRT();
                } catch  {}
                el._unsubRT = null;
            }
            if (chId) {
                $e625860720fec096$var$_loadMessagesIntoRoot(root, chId);
                el._unsubRT = (0, $9uyCk.subscribeMessages)({
                    channelId: chId,
                    onInsert: (row)=>{
                        const msg = $e625860720fec096$var$_rowToMessage(row);
                        const map = root.messagesByChannel || {};
                        const cur = map[msg.channelId] || [];
                        if (cur.some((m)=>m.id === msg.id)) return;
                        root.update({
                            messagesByChannel: {
                                ...map,
                                [msg.channelId]: [
                                    ...cur,
                                    msg
                                ]
                            }
                        });
                    }
                });
            }
            el._subChannelId = chId;
        }
    },
    onRemove: (el)=>{
        if (el._unsubRT) try {
            el._unsubRT();
        } catch  {}
        if (el._uninstall) try {
            el._uninstall();
        } catch  {}
    },
    // Header — title, channel select, close.
    Header: {
        flow: 'x',
        align: 'center space-between',
        padding: 'V Z',
        gap: 'V',
        borderBottomWidth: '1px',
        borderBottomStyle: 'solid',
        borderBottomColor: 'line',
        flex: '0 0 auto',
        // Title doubles as the channel switcher trigger. Clicking the chip
        // opens a popover of all channels — matches common messenger UX
        // (Slack, Linear) where the active channel's name in the header IS
        // the switcher.
        ChannelSwitcher: {
            position: 'relative',
            flex: '1 1 auto',
            minWidth: '0',
            Trigger: {
                tag: 'button',
                type: 'button',
                flow: 'x',
                align: 'center left',
                gap: 'V',
                padding: 'V Z',
                margin: '0 0 0 -Z',
                round: 'Y',
                border: 'none',
                background: 'transparent',
                color: 'title',
                cursor: 'pointer',
                maxWidth: '100%',
                minWidth: '0',
                ':hover': {
                    background: 'overlay'
                },
                transition: 'background 120ms ease',
                onClick: (e, el, s)=>{
                    if ((s.root?.channels?.length ?? 0) < 2) return;
                    s.root.update({
                        _chatDrawerSwitcherOpen: !s.root._chatDrawerSwitcherOpen
                    });
                },
                Icon: {
                    icon: 'chat',
                    boxSize: 'Z1',
                    color: 'caption',
                    flex: '0 0 auto'
                },
                Label: {
                    tag: 'span',
                    fontSize: 'Z2',
                    fontWeight: '700',
                    letterSpacing: '-.005em',
                    color: 'title',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    minWidth: '0',
                    text: (el, s)=>{
                        const root = s.root;
                        const ch = (root?.channels || []).find((c)=>c.id === root?.activeChannelId);
                        return ch ? $e625860720fec096$var$_channelLabel(ch, root) : 'Chat';
                    }
                },
                Caret: {
                    extends: 'Icon',
                    icon: 'chevronDown',
                    boxSize: 'Z',
                    color: 'caption',
                    flex: '0 0 auto',
                    hide: (el, s)=>(s.root?.channels?.length ?? 0) < 2
                }
            },
            Popover: {
                hide: (el, s)=>!s.root?._chatDrawerSwitcherOpen,
                position: 'absolute',
                top: 'calc(100% + 4px)',
                left: '0',
                zIndex: '10',
                width: 'H',
                maxWidth: 'calc(100vw - A)',
                maxHeight: 'F',
                overflow: 'auto',
                round: 'Z',
                background: 'overlayStrong',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: 'line',
                boxShadow: '0 8px 24px var(--color-shadow)',
                padding: 'V',
                flow: 'y',
                childExtends: 'ChatDrawerChannelRow',
                childrenAs: 'state',
                children: (el, s)=>s.root?.channels || []
            }
        },
        CloseBtn: {
            extends: 'IconButton',
            title: 'Close',
            aria: {
                label: 'Close'
            },
            Icon: {
                icon: 'close'
            },
            onClick: (e, el, s)=>$e625860720fec096$export$3fac3d2397dfa418(s.root)
        }
    },
    // Loading / empty screens — only while the first load is in flight.
    LoadingState: {
        hide: (el, s)=>{
            const root = s.root;
            if (!root?._chatDrawerLoading) return true;
            return (root.channels || []).length > 0;
        },
        flex: '1 1 auto',
        align: 'center center',
        flow: 'y',
        color: 'caption',
        fontSize: 'Z2',
        text: "Loading\u2026"
    },
    ErrorState: {
        hide: (el, s)=>!s.root?._chatDrawerError,
        flex: '1 1 auto',
        align: 'center center',
        flow: 'y',
        gap: 'Z',
        color: 'caption',
        fontSize: 'Z2',
        padding: 'A',
        textAlign: 'center',
        text: (el, s)=>s.root?._chatDrawerError || ''
    },
    EmptyState: {
        hide: (el, s)=>{
            const root = s.root;
            if (!root) return true;
            if (root._chatDrawerLoading) return true;
            if (root._chatDrawerError) return true;
            return (root.channels || []).length > 0;
        },
        flex: '1 1 auto',
        align: 'center center',
        flow: 'y',
        gap: 'Z',
        color: 'caption',
        fontSize: 'Z2',
        padding: 'A',
        text: 'No channels available.'
    },
    // Body — full chat surface. The MessageList + Composer + HoverActions
    // + ThreadPanel are the exact same components used on /chat, so bubble
    // + composer + hover menus + thread bubbles stay visually identical.
    Body: {
        hide: (el, s)=>!s.root?.activeChannelId,
        flex: '1 1 auto',
        flow: 'y',
        minHeight: '0',
        position: 'relative',
        overflow: 'hidden',
        // Full /chat surface — these components are registered via
        // `editor/packages/shared/components/chat/` and resolve in every
        // app whose sharedLibraries includes shared/context.js (intranet
        // AND editor canvas). Bubble style, markdown, reactions, hover
        // actions, mention-picker, and WYSIWYG composer all stay identical
        // to the /chat page.
        Conversation: {
            extends: 'ChatMessageList',
            flex: '1 1 0',
            padding: 'Z1 V V V',
            minHeight: '0',
            overflowX: 'hidden'
        },
        Composer: {
            extends: 'ChatComposer',
            flex: '0 0 auto',
            padding: '0 Z V Z',
            Toolbar: {
                width: '100%',
                margin: '0',
                gap: 'V'
            },
            Box: {
                width: '100%',
                margin: '0'
            }
        }
    },
    // Right-hand thread panel slides over the body when a bubble's
    // "Reply in thread" action is triggered. Same component as /chat.
    Thread: {
        extends: 'ChatThreadPanel',
        hide: (el, s)=>!(s.root?._chatDrawerOpen && s.root?.activeThreadRootId),
        position: 'absolute',
        top: '0',
        right: '0',
        bottom: '0',
        width: '100%',
        zIndex: '10',
        background: 'document',
        borderLeftWidth: '1px',
        borderLeftStyle: 'solid',
        borderLeftColor: 'line'
    },
    // Shared viewport-fixed hover actions overlay — same instance pattern
    // as /chat's ChatMain so bubble-hover menus work inside the drawer.
    HoverActions: {
        extends: 'ChatHoverActions'
    }
};
const $e625860720fec096$export$ccfa0778f53f27fa = {
    tag: 'button',
    type: 'button',
    flow: 'x',
    align: 'center left',
    gap: 'Z',
    width: '100%',
    padding: 'V Z',
    round: 'V',
    border: 'none',
    cursor: 'pointer',
    fontSize: 'Z2',
    textAlign: 'left',
    color: 'title',
    background: (el, s)=>s.id === s.root?.activeChannelId ? 'overlay' : 'transparent',
    ':hover': {
        background: 'overlay'
    },
    transition: 'background 100ms ease',
    onClick: (e, el, s)=>$e625860720fec096$export$c84605f0f811629(s.root, s.id),
    Label: {
        tag: 'span',
        flex: '1 1 auto',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        text: (el, s)=>$e625860720fec096$var$_channelLabel(s, s.root)
    }
};
const $e625860720fec096$export$ea51ed8b2b5db9aa = {
    extends: 'ChatMessageRow'
};

});


parcelRegister("2uy7C", function(module, exports) {
// @symbo.ls/collab-features/tickets — governance Supabase tickets
// access for consumers outside the intranet (editor embed, admin
// dashboard, reporting). Tickets live in the governance project.

var $8RlGv = parcelRequire("8RlGv");
const $1d08da055646e7be$export$4a55714468b4097e = Object.freeze({
    projectName: (0, $8RlGv.PROJECT_GOVERNANCE),
    tables: {
        tickets: 'tickets',
        comments: 'ticket_comments',
        columns: 'ticket_columns',
        fieldValues: 'ticket_field_values',
        stories: 'stories'
    }
});
const $1d08da055646e7be$var$_sb = ()=>(0, $8RlGv.getClient)($1d08da055646e7be$export$4a55714468b4097e.projectName);
const $1d08da055646e7be$export$85d23bc773d4cda9 = ()=>!!$1d08da055646e7be$var$_sb();
const $1d08da055646e7be$export$8846572c632e9da8 = async ({ assignee: assignee, columnKey: columnKey, limit: limit = 50 } = {})=>{
    const sb = $1d08da055646e7be$var$_sb();
    if (!sb) return {
        data: [],
        error: null
    };
    let q = sb.from($1d08da055646e7be$export$4a55714468b4097e.tables.tickets).select('*').eq('deleted', false).order('updated_at', {
        ascending: false
    }).limit(limit);
    if (assignee) q = q.eq('assignee_email', assignee);
    if (columnKey) q = q.eq('column_key', columnKey);
    return q;
};
const $1d08da055646e7be$export$ec22c3e055f07a21 = async (id)=>{
    const sb = $1d08da055646e7be$var$_sb();
    if (!sb) return {
        data: null,
        error: null
    };
    return sb.from($1d08da055646e7be$export$4a55714468b4097e.tables.tickets).select('*').eq('id', id).maybeSingle();
};
const $1d08da055646e7be$export$4a694c14548a40cc = async ()=>{
    const sb = $1d08da055646e7be$var$_sb();
    if (!sb) return {
        data: [],
        error: null
    };
    return sb.from($1d08da055646e7be$export$4a55714468b4097e.tables.columns).select('*').order('position', {
        ascending: true
    });
};
const $1d08da055646e7be$export$c893896d3c34d919 = async (patch)=>{
    const sb = $1d08da055646e7be$var$_sb();
    if (!sb) return {
        data: null,
        error: new Error('governance unavailable')
    };
    return sb.from($1d08da055646e7be$export$4a55714468b4097e.tables.tickets).insert(patch).select('*').single();
};
const $1d08da055646e7be$export$3d9b22d1b89cce7d = async (id, patch)=>{
    const sb = $1d08da055646e7be$var$_sb();
    if (!sb) return {
        data: null,
        error: new Error('governance unavailable')
    };
    return sb.from($1d08da055646e7be$export$4a55714468b4097e.tables.tickets).update({
        ...patch,
        updated_at: new Date().toISOString()
    }).eq('id', id).select('*').maybeSingle();
};
const $1d08da055646e7be$export$985d2dc908bbfcae = async (ticketId)=>{
    const sb = $1d08da055646e7be$var$_sb();
    if (!sb) return {
        data: [],
        error: null
    };
    return sb.from($1d08da055646e7be$export$4a55714468b4097e.tables.comments).select('*').eq('ticket_id', ticketId).order('created_at', {
        ascending: true
    });
};

});

parcelRegister("3QQYd", function(module, exports) {
// @symbo.ls/collab-features/docs — governance docs + kb + notes.

var $8RlGv = parcelRequire("8RlGv");
const $2cdf513368453e09$export$8343d96161bb9013 = Object.freeze({
    projectName: (0, $8RlGv.PROJECT_GOVERNANCE),
    tables: {
        documents: 'documents',
        kb: 'kb_articles',
        notes: 'notes',
        links: 'links',
        resourceLinks: 'resource_links'
    }
});
const $2cdf513368453e09$var$_sb = ()=>(0, $8RlGv.getClient)($2cdf513368453e09$export$8343d96161bb9013.projectName);
const $2cdf513368453e09$export$8a6f3d729a0f1a59 = ()=>!!$2cdf513368453e09$var$_sb();
const $2cdf513368453e09$export$914ddbed0a6461ef = async ({ limit: limit = 50 } = {})=>{
    const sb = $2cdf513368453e09$var$_sb();
    if (!sb) return {
        data: [],
        error: null
    };
    return sb.from($2cdf513368453e09$export$8343d96161bb9013.tables.documents).select('*').order('updated_at', {
        ascending: false
    }).limit(limit);
};
const $2cdf513368453e09$export$b4b1149beeebd6b3 = async ()=>{
    const sb = $2cdf513368453e09$var$_sb();
    if (!sb) return {
        data: [],
        error: null
    };
    return sb.from($2cdf513368453e09$export$8343d96161bb9013.tables.kb).select('*').order('created_at', {
        ascending: false
    });
};
const $2cdf513368453e09$export$24d99501b0ca39d2 = async (slug)=>{
    const sb = $2cdf513368453e09$var$_sb();
    if (!sb) return {
        data: null,
        error: null
    };
    return sb.from($2cdf513368453e09$export$8343d96161bb9013.tables.kb).select('*').eq('slug', slug).maybeSingle();
};
const $2cdf513368453e09$export$f38e03736b118217 = async (row)=>{
    const sb = $2cdf513368453e09$var$_sb();
    if (!sb) return {
        data: null,
        error: new Error('governance unavailable')
    };
    return sb.from($2cdf513368453e09$export$8343d96161bb9013.tables.kb).upsert(row, {
        onConflict: 'slug'
    }).select('*').single();
};
const $2cdf513368453e09$export$9c0421d833a32f19 = async ({ owner: owner } = {})=>{
    const sb = $2cdf513368453e09$var$_sb();
    if (!sb) return {
        data: [],
        error: null
    };
    let q = sb.from($2cdf513368453e09$export$8343d96161bb9013.tables.notes).select('*').order('updated_at', {
        ascending: false
    });
    if (owner) q = q.eq('owner_email', owner);
    return q;
};

});

parcelRegister("guMdf", function(module, exports) {
// @symbo.ls/collab-features/meet — room + participant + transcript
// helpers. Token minting + AI analysis stay on edge functions; these
// are thin read/write wrappers for room catalog + transcript retrieval.

var $8RlGv = parcelRequire("8RlGv");
const $c024d8ba245335b1$export$65ae9ac868c719a0 = Object.freeze({
    projectName: (0, $8RlGv.PROJECT_GOVERNANCE),
    tables: {
        rooms: 'meet_rooms',
        members: 'meet_room_members',
        participants: 'meet_participants',
        transcripts: 'meet_transcripts',
        analyses: 'meet_transcript_analyses',
        waitingRoom: 'meet_waiting_room',
        meetings: 'meetings'
    }
});
const $c024d8ba245335b1$var$_sb = ()=>(0, $8RlGv.getClient)($c024d8ba245335b1$export$65ae9ac868c719a0.projectName);
const $c024d8ba245335b1$export$d9796b07690e2296 = ()=>!!$c024d8ba245335b1$var$_sb();
const $c024d8ba245335b1$export$3e733f72ac39f4f8 = async ({ includeEnded: includeEnded = false } = {})=>{
    const sb = $c024d8ba245335b1$var$_sb();
    if (!sb) return {
        data: [],
        error: null
    };
    let q = sb.from($c024d8ba245335b1$export$65ae9ac868c719a0.tables.rooms).select('*').order('created_at', {
        ascending: false
    });
    if (!includeEnded) q = q.is('ended_at', null);
    return q;
};
const $c024d8ba245335b1$export$ddb5e34974173ddf = async (id)=>{
    const sb = $c024d8ba245335b1$var$_sb();
    if (!sb) return {
        data: null,
        error: null
    };
    return sb.from($c024d8ba245335b1$export$65ae9ac868c719a0.tables.rooms).select('*').eq('id', id).maybeSingle();
};
const $c024d8ba245335b1$export$4a6fbf23fa252689 = async (row)=>{
    const sb = $c024d8ba245335b1$var$_sb();
    if (!sb) return {
        data: null,
        error: new Error('governance unavailable')
    };
    return sb.from($c024d8ba245335b1$export$65ae9ac868c719a0.tables.rooms).insert(row).select('*').single();
};
const $c024d8ba245335b1$export$9e9dea53e6bfe5ab = async (roomId)=>{
    const sb = $c024d8ba245335b1$var$_sb();
    if (!sb) return {
        data: [],
        error: null
    };
    return sb.from($c024d8ba245335b1$export$65ae9ac868c719a0.tables.transcripts).select('*').eq('room_id', roomId).order('started_at', {
        ascending: true
    });
};
const $c024d8ba245335b1$export$5dc1b0e5a3838a26 = async (roomId)=>{
    const sb = $c024d8ba245335b1$var$_sb();
    if (!sb) return {
        data: null,
        error: null
    };
    return sb.from($c024d8ba245335b1$export$65ae9ac868c719a0.tables.analyses).select('*').eq('room_id', roomId).order('created_at', {
        ascending: false
    }).limit(1).maybeSingle();
};

});

parcelRegister("eONSp", function(module, exports) {

$parcel$export(module.exports, "listNotifications", () => (parcelRequire("4rKNA")).listNotifications);
$parcel$export(module.exports, "markRead", () => (parcelRequire("4rKNA")).markRead);
$parcel$export(module.exports, "markAllRead", () => (parcelRequire("4rKNA")).markAllRead);
$parcel$export(module.exports, "NotificationBell", () => (parcelRequire("bNH27")).NotificationBell);
$parcel$export(module.exports, "NotificationPanel", () => (parcelRequire("bNH27")).NotificationPanel);
$parcel$export(module.exports, "NotificationWrapper", () => (parcelRequire("bNH27")).NotificationWrapper);

var $4rKNA = parcelRequire("4rKNA");

var $bNH27 = parcelRequire("bNH27");

});
parcelRegister("4rKNA", function(module, exports) {

$parcel$export(module.exports, "listNotifications", () => $33cdfc474f0c14fa$export$3f7dacf8d16faf1b);
$parcel$export(module.exports, "markRead", () => $33cdfc474f0c14fa$export$3aa17b355b211dc5);
$parcel$export(module.exports, "markAllRead", () => $33cdfc474f0c14fa$export$6c0c468221c7877f);
// Notification queries. Consumed by both the components in this
// package (NotificationBell + NotificationPanel) and by any app that
// wants to prime `root.notifications` on login or refresh it
// imperatively.

var $8RlGv = parcelRequire("8RlGv");
const $33cdfc474f0c14fa$var$_sb = ()=>(0, $8RlGv.getClient)((0, $8RlGv.PROJECT_GOVERNANCE));
const $33cdfc474f0c14fa$export$3f7dacf8d16faf1b = async ({ recipientEmail: recipientEmail, limit: limit = 50 } = {})=>{
    const sb = $33cdfc474f0c14fa$var$_sb();
    if (!sb) return {
        data: [],
        error: null
    };
    let q = sb.from('notifications').select('*').order('created_at', {
        ascending: false
    }).limit(limit);
    if (recipientEmail) q = q.eq('user_email', recipientEmail);
    return q;
};
const $33cdfc474f0c14fa$export$3aa17b355b211dc5 = async (notifId)=>{
    const sb = $33cdfc474f0c14fa$var$_sb();
    if (!sb) return {
        error: new Error('governance unavailable')
    };
    return sb.from('notifications').update({
        read: true
    }).eq('id', notifId);
};
const $33cdfc474f0c14fa$export$6c0c468221c7877f = async (recipientEmail)=>{
    const sb = $33cdfc474f0c14fa$var$_sb();
    if (!sb) return {
        error: new Error('governance unavailable')
    };
    return sb.from('notifications').update({
        read: true
    }).eq('user_email', recipientEmail).eq('read', false);
};

});

parcelRegister("bNH27", function(module, exports) {

$parcel$export(module.exports, "NotificationBell", () => $8975a6c9dc05f99e$export$da43598a51abd858);
$parcel$export(module.exports, "NotificationPanel", () => $8975a6c9dc05f99e$export$20171ad88b646892);
$parcel$export(module.exports, "NotificationWrapper", () => $8975a6c9dc05f99e$export$3785346a4fed4152);
// Notification bell + panel — reusable across intranet and editor.
// Reads `root.notifications` array (caller populates via listNotifications).
// Writes go through collab-features/notifications/queries directly so
// the components are self-sufficient (no `el.call` dependency on a
// specific app's function registry).

var $4rKNA = parcelRequire("4rKNA");
const $8975a6c9dc05f99e$var$_unread = (root)=>(root?.notifications || []).filter((n)=>!n.read).length;
const $8975a6c9dc05f99e$var$ICON_BY_TYPE = {
    mention: 'chat',
    ticket_assign: 'check',
    calendar_invite: 'date',
    doc_share: 'document',
    system: 'settings'
};
const $8975a6c9dc05f99e$var$COLOR_BY_TYPE = {
    mention: 'blue',
    ticket_assign: 'green',
    calendar_invite: 'purple',
    doc_share: 'orange',
    system: 'caption'
};
const $8975a6c9dc05f99e$var$_timeAgo = (iso)=>{
    if (!iso) return '';
    const ms = Date.now() - new Date(iso).getTime();
    const mins = Math.floor(ms / 60000);
    if (mins < 1) return 'now';
    if (mins < 60) return `${mins}m`;
    const hrs = Math.floor(mins / 60);
    if (hrs < 24) return `${hrs}h`;
    return `${Math.floor(hrs / 24)}d`;
};
// Optimistic write helper — updates root state instantly, fires server
// write in the background. Errors are logged, not surfaced.
const $8975a6c9dc05f99e$var$_markReadOptimistic = async (root, id)=>{
    if (!root || !id) return;
    root.update({
        notifications: (root.notifications || []).map((n)=>n.id === id ? {
                ...n,
                read: true
            } : n)
    });
    const { error: error } = await (0, $4rKNA.markRead)(id);
    if (error) console.warn('[notifications] markRead failed:', error?.message || error);
};
const $8975a6c9dc05f99e$var$_markAllReadOptimistic = async (root)=>{
    if (!root?.currentUserEmail) return;
    root.update({
        notifications: (root.notifications || []).map((n)=>({
                ...n,
                read: true
            }))
    });
    const { error: error } = await (0, $4rKNA.markAllRead)(root.currentUserEmail);
    if (error) console.warn('[notifications] markAllRead failed:', error?.message || error);
};
const $8975a6c9dc05f99e$export$da43598a51abd858 = {
    tag: 'button',
    type: 'button',
    title: 'Notifications',
    position: 'relative',
    padding: 'Z',
    round: 'Z',
    cursor: 'pointer',
    borderWidth: '0',
    background: 'transparent',
    color: 'caption',
    ':hover': {
        background: 'overlay',
        color: 'title'
    },
    onClick: (e, el, s)=>{
        e.stopPropagation();
        s.root.update({
            notificationsPanelOpen: !s.root.notificationsPanelOpen
        });
    },
    Icon: {
        icon: 'bell',
        boxSize: 'A A'
    },
    UnreadBadge: {
        if: (el, s)=>$8975a6c9dc05f99e$var$_unread(s.root) > 0,
        position: 'absolute',
        top: '0',
        right: '0',
        minWidth: 'Z',
        height: 'Z',
        padding: '0 V',
        round: 'C',
        background: 'red',
        color: 'white',
        fontSize: 'W',
        fontWeight: '700',
        lineHeight: '1',
        align: 'center center',
        pointerEvents: 'none',
        text: (el, s)=>{
            const n = $8975a6c9dc05f99e$var$_unread(s.root);
            return n > 99 ? '99+' : String(n);
        }
    }
};
const $8975a6c9dc05f99e$export$20171ad88b646892 = {
    display: (el, s)=>s.root?.notificationsPanelOpen ? 'flex' : 'none',
    position: 'absolute',
    top: 'B1',
    right: '0',
    width: '360px',
    maxHeight: '480px',
    overflow: 'hidden',
    padding: '0',
    round: 'Z1',
    background: 'document',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'line',
    boxShadow: '0 16px 48px -8px var(--color-shadow)',
    zIndex: '3000',
    flow: 'y',
    onRender: (el)=>{
        const handler = (e)=>{
            if (!el.node?.contains(e.target) && !el.parent?.node?.contains(e.target)) {
                el.state.root.update({
                    notificationsPanelOpen: false
                });
                document.removeEventListener('mousedown', handler);
            }
        };
        setTimeout(()=>document.addEventListener('mousedown', handler), 0);
        el._closeHandler = handler;
    },
    onRemove: (el)=>{
        if (el._closeHandler) document.removeEventListener('mousedown', el._closeHandler);
    },
    Header: {
        flow: 'x',
        align: 'center space-between',
        padding: 'Z1 A',
        borderBottom: '1px solid var(--color-line)',
        Title: {
            tag: 'span',
            text: 'Notifications',
            fontWeight: '700',
            fontSize: 'Z1',
            color: 'title'
        },
        MarkAllBtn: {
            tag: 'button',
            type: 'button',
            text: 'Mark all read',
            background: 'none',
            borderWidth: '0',
            color: 'blue',
            fontSize: 'Y2',
            fontWeight: '600',
            cursor: 'pointer',
            padding: '0',
            if: (el, s)=>$8975a6c9dc05f99e$var$_unread(s.root) > 0,
            onClick: (e, el, s)=>{
                e.stopPropagation();
                $8975a6c9dc05f99e$var$_markAllReadOptimistic(s.root);
            }
        }
    },
    List: {
        overflow: 'auto',
        maxHeight: '420px',
        flow: 'y',
        Empty: {
            if: (el, s)=>!(s.root?.notifications || []).length,
            padding: 'C A',
            textAlign: 'center',
            color: 'caption',
            fontSize: 'Z1',
            text: 'No notifications yet'
        },
        childrenAs: 'state',
        children: (el, s)=>(s.root?.notifications || []).slice(0, 30),
        childExtends: {
            flow: 'x',
            gap: 'Z',
            padding: 'Z1 A',
            cursor: 'pointer',
            borderBottom: '1px solid var(--color-line)',
            background: (el, s)=>s.read ? 'transparent' : 'overlay',
            ':hover': {
                background: 'overlayStrong'
            },
            onClick: (e, el, s)=>{
                e.stopPropagation();
                $8975a6c9dc05f99e$var$_markReadOptimistic(s.root, s.id);
                if (s.href) {
                    s.root.update({
                        notificationsPanelOpen: false
                    });
                    let rootEl = el;
                    while(rootEl && !rootEl.routes)rootEl = rootEl.parent;
                    if (rootEl) el.router(s.href, rootEl);
                }
            },
            UnreadDot: {
                if: (el, s)=>!s.read,
                width: 'V',
                height: 'V',
                round: '50%',
                background: 'blue',
                flexShrink: '0',
                marginTop: 'Z'
            },
            TypeIcon: {
                Icon: {
                    icon: (el, s)=>$8975a6c9dc05f99e$var$ICON_BY_TYPE[s.parent?.state?.type] || 'star',
                    boxSize: 'A',
                    color: (el, s)=>$8975a6c9dc05f99e$var$COLOR_BY_TYPE[s.parent?.state?.type] || 'caption'
                }
            },
            Body: {
                flex: '1',
                flow: 'y',
                gap: 'W',
                minWidth: '0',
                NTitle: {
                    tag: 'span',
                    fontSize: 'Z',
                    fontWeight: '600',
                    color: 'title',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    text: (el, s)=>s.parent?.state?.title || ''
                },
                NBody: {
                    if: (el, s)=>s.parent?.state?.body,
                    tag: 'span',
                    fontSize: 'Y2',
                    color: 'caption',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    text: (el, s)=>s.parent?.state?.body || ''
                }
            },
            Time: {
                tag: 'span',
                fontSize: 'Y2',
                color: 'caption',
                flexShrink: '0',
                whiteSpace: 'nowrap',
                text: (el, s)=>$8975a6c9dc05f99e$var$_timeAgo(s.createdAt || s.created_at)
            }
        }
    }
};

const $8975a6c9dc05f99e$export$3785346a4fed4152 = {
    position: 'relative',
    onRender: async (el, s)=>{
        if (el._loaded) return;
        el._loaded = true;
        const email = s.root?.currentUserEmail;
        if (!email) return;
        const { listNotifications: listNotifications } = await Promise.resolve((parcelRequire("4rKNA")));
        const { data: data } = await listNotifications({
            recipientEmail: email,
            limit: 50
        });
        const rows = (data || []).map((n)=>({
                ...n,
                createdAt: n.created_at,
                read: !!n.read
            }));
        s.root.update({
            notifications: rows
        });
    },
    NotificationBell: {},
    NotificationPanel: {}
};

});




parcelRegister("3woMp", function(module, exports) {
// Chat UI surface. Lives in shared/ so every app pulling shared/context.js
// (canvas, workspace-project, future embeds) gets ChatMain, ChatComposer,
// ChatSidebar, ChatThreadPanel etc. via key reference automatically.
//
// Page-level surfaces (Main, Sidebar, SearchPanel, MentionDropdown, modals)
// are exported here and used inside workspace-project's /chat route via
// `extends`. Embed-level surfaces (MessageList, Composer, ChatHover*) are
// what ChatDrawer in canvas extends. All resolve via the same registry.

var $icuiF = parcelRequire("icuiF");

var $3UdbF = parcelRequire("3UdbF");

var $jTgjx = parcelRequire("jTgjx");

var $lzthD = parcelRequire("lzthD");

var $a1CiO = parcelRequire("a1CiO");

var $aVlLH = parcelRequire("aVlLH");

var $lPE0G = parcelRequire("lPE0G");

var $dIbQ8 = parcelRequire("dIbQ8");

var $laIZe = parcelRequire("laIZe");

var $llQg9 = parcelRequire("llQg9");

var $a5q8o = parcelRequire("a5q8o");

var $kKfCw = parcelRequire("kKfCw");

var $27JlV = parcelRequire("27JlV");
$parcel$exportWildcard(module.exports, $icuiF);
$parcel$exportWildcard(module.exports, $3UdbF);
$parcel$exportWildcard(module.exports, $jTgjx);
$parcel$exportWildcard(module.exports, $lzthD);
$parcel$exportWildcard(module.exports, $a1CiO);
$parcel$exportWildcard(module.exports, $aVlLH);
$parcel$exportWildcard(module.exports, $lPE0G);
$parcel$exportWildcard(module.exports, $dIbQ8);
$parcel$exportWildcard(module.exports, $laIZe);
$parcel$exportWildcard(module.exports, $llQg9);
$parcel$exportWildcard(module.exports, $a5q8o);
$parcel$exportWildcard(module.exports, $kKfCw);
$parcel$exportWildcard(module.exports, $27JlV);

});
parcelRegister("icuiF", function(module, exports) {

$parcel$export(module.exports, "ChatSidebar", () => $d400d9f30bdd89ab$export$c9634fb3dbc93f1f);
$parcel$export(module.exports, "ChatSidebarGroup", () => $d400d9f30bdd89ab$export$fec01ae84ff953ba);
$parcel$export(module.exports, "ChatSidebarGroupHeader", () => $d400d9f30bdd89ab$export$3fbd61ffbad7de76);
$parcel$export(module.exports, "ChatChannelRow", () => $d400d9f30bdd89ab$export$417eb58734500cda);
$parcel$export(module.exports, "ChatDMRow", () => $d400d9f30bdd89ab$export$6511568de1d088c1);
$parcel$export(module.exports, "ChatGroupRow", () => $d400d9f30bdd89ab$export$875ae4400b6e0ab);
$parcel$export(module.exports, "ChatPinnedRow", () => $d400d9f30bdd89ab$export$c71b0e4b1cc807f1);
$parcel$export(module.exports, "ChatSidebarMore", () => $d400d9f30bdd89ab$export$9c4ce95a604aa6c3);
$parcel$export(module.exports, "ChatSidebarMenuItem", () => $d400d9f30bdd89ab$export$8aa0535fc50b913d);
// Chat sidebar — extends shared-gov's AppSidebar shell so the chrome (width,
// background, border, scrollable people section, person flyout) is identical
// to calendar's sidebar. The slot extends fill in chat-specific bits:
//
//   Top    → "New message" button
//   Middle → CHANNELS / DIRECT MESSAGES / EXTERNAL PEOPLE groups
//
// Channel rows show unread counts via UnreadBadge; the active row is themed.
//
// Each group in Middle is a `ChatSidebarGroup` instance — the wrapper handles
// collapse state reading, the collapsible Header, and the List hide pattern.
// Each instance supplies local state (groupKey, label, addAction) plus its
// own List.childExtends + children factory.

var $jg4vi = parcelRequire("jg4vi");
const $d400d9f30bdd89ab$var$_getUnread = (s)=>{
    if (!s?.id || !s?.root) return 0;
    const me = s.root.currentUserEmail;
    const msgs = s.root.messagesByChannel?.[s.id] || [];
    const members = s.root.channelMembers || [];
    const membership = members.find((m)=>m.channel_id === s.id && m.member_email === me);
    return (0, $jg4vi.unreadCount)(msgs, membership?.last_read_at, me);
};
const $d400d9f30bdd89ab$var$_getMentionCount = (s)=>{
    if (!s?.id || !s?.root) return 0;
    const mentions = s.root.myMentions || [];
    return mentions.filter((m)=>m.channel_id === s.id && !m.read_at).length;
};
const $d400d9f30bdd89ab$var$_isMuted = (s)=>{
    if (!s?.id || !s?.root) return false;
    return (0, $jg4vi.mutedChannels)(s.root.channelMembers, s.root.currentUserEmail).has(s.id);
};
// Trailing bell-slash icon shown on muted conversations. Fades the row
// to signal "notifications off".
const $d400d9f30bdd89ab$var$_muteIndicator = {
    hide: (el, s)=>!$d400d9f30bdd89ab$var$_isMuted(s),
    tag: 'span',
    fontSize: 'Y2',
    color: 'caption',
    marginLeft: 'Y',
    opacity: '.7',
    text: "\uD83D\uDD15" // 🔕
};
const $d400d9f30bdd89ab$var$_unreadBadge = {
    hide: (el, s)=>$d400d9f30bdd89ab$var$_getUnread(s) === 0,
    tag: 'span',
    padding: 'V Z',
    round: 'B',
    fontSize: 'Y1',
    fontWeight: '700',
    background: 'blue',
    color: 'white',
    marginLeft: 'auto',
    text: (el, s)=>{
        const n = $d400d9f30bdd89ab$var$_getUnread(s);
        return n > 99 ? '99+' : String(n);
    }
};
const $d400d9f30bdd89ab$var$_mentionBadge = {
    hide: (el, s)=>$d400d9f30bdd89ab$var$_getMentionCount(s) === 0,
    tag: 'span',
    padding: 'V Z',
    round: 'B',
    fontSize: 'Y1',
    fontWeight: '700',
    background: 'red',
    color: 'white',
    marginLeft: 'Y',
    text: '@'
};
const $d400d9f30bdd89ab$export$c9634fb3dbc93f1f = {
    extends: 'AppSidebar',
    PeopleSection: null,
    position: 'relative',
    minWidth: 'F3',
    maxWidth: '50dvw',
    ResizeHandle: {
        ignoreChildExtends: true,
        position: 'absolute',
        top: '50%',
        right: 'W2',
        width: 'W2',
        height: 'C1',
        cursor: 'col-resize',
        zIndex: '10',
        transform: 'translateY(-50%)',
        background: 'overlayStrong',
        ':hover': {
            background: 'blue.2'
        },
        onCreate: (el)=>{
            if (!el.node) return;
            el.node.addEventListener('mousedown', (e)=>{
                e.preventDefault();
                const sidebar = el.node.parentElement;
                if (!sidebar) return;
                const startX = e.clientX;
                const startW = sidebar.offsetWidth;
                const onMove = (ev)=>{
                    const w = Math.min(Math.max(startW + ev.clientX - startX, 200), window.innerWidth * 0.5);
                    sidebar.style.width = w + 'px';
                };
                const onUp = ()=>{
                    document.removeEventListener('mousemove', onMove);
                    document.removeEventListener('mouseup', onUp);
                };
                document.addEventListener('mousemove', onMove);
                document.addEventListener('mouseup', onUp);
            });
        }
    },
    Top: null,
    Middle: {
        flow: 'y',
        gap: 'B',
        flex: '1',
        overflow: 'auto',
        // Pinned channels/DMs — only visible when there are pinned items
        PinnedGroup: {
            extends: 'ChatSidebarGroup',
            display: (el, s)=>{
                const pinned = s?.root?._pinnedChannels || [];
                return pinned.length > 0 ? 'flex' : 'none';
            },
            state: {
                groupKey: 'PINNED',
                label: 'PINNED',
                addAction: null
            },
            List: {
                childExtends: 'ChatPinnedRow',
                children: (el, s)=>{
                    const root = s && s.root;
                    if (!root) return [];
                    const pinnedIds = new Set(root._pinnedChannels || []);
                    return (root.channels || []).filter((c)=>pinnedIds.has(c.id));
                }
            }
        },
        ChannelsGroup: {
            extends: 'ChatSidebarGroup',
            state: {
                groupKey: 'CHANNELS',
                label: 'CHANNELS',
                addAction: 'new-channel'
            },
            List: {
                childExtends: 'ChatChannelRow',
                children: (el, s)=>{
                    const root = s && s.root;
                    if (!root) return [];
                    const me = root.currentUserEmail;
                    const hidden = new Set(root._hiddenChannels || []);
                    const myIds = new Set((root.channelMembers || []).filter((m)=>m.member_email === me).map((m)=>m.channel_id));
                    const seen = new Set();
                    return (root.channels || []).filter((c)=>{
                        if (c.kind !== 'channel') return false;
                        if (!myIds.has(c.id)) return false;
                        if (hidden.has(c.id)) return false;
                        if (seen.has(c.id)) return false;
                        seen.add(c.id);
                        return true;
                    });
                }
            }
        },
        DMsGroup: {
            extends: 'ChatSidebarGroup',
            state: {
                groupKey: 'DIRECT_MESSAGES',
                label: 'DIRECT MESSAGES',
                addAction: 'new-message'
            },
            List: {
                childExtends: 'ChatDMRow',
                children: (el, s)=>{
                    const root = s && s.root;
                    const hidden = new Set(root?._hiddenChannels || []);
                    return (0, $jg4vi.buildDMChannels)(root, false).filter((c)=>c.kind === 'dm' && !hidden.has(c.id));
                }
            }
        },
        GroupsGroup: {
            extends: 'ChatSidebarGroup',
            display: (el, s)=>{
                const root = s && s.root;
                if (!root) return 'none';
                const hidden = new Set(root._hiddenChannels || []);
                const hasGroups = (0, $jg4vi.buildDMChannels)(root, false).some((c)=>c.kind === 'group_dm' && !hidden.has(c.id));
                return hasGroups ? 'flex' : 'none';
            },
            state: {
                groupKey: 'GROUPS',
                label: 'GROUPS',
                addAction: 'new-group'
            },
            List: {
                childExtends: 'ChatGroupRow',
                children: (el, s)=>{
                    const root = s && s.root;
                    const hidden = new Set(root?._hiddenChannels || []);
                    return (0, $jg4vi.buildDMChannels)(root, false).filter((c)=>c.kind === 'group_dm' && !hidden.has(c.id));
                }
            }
        },
        ExternalGroup: {
            extends: 'ChatSidebarGroup',
            state: {
                groupKey: 'EXTERNAL',
                label: 'EXTERNAL PEOPLE',
                addAction: 'new-external-message'
            },
            List: {
                childExtends: 'ChatDMRow',
                children: (el, s)=>{
                    const root = s && s.root;
                    const hidden = new Set(root?._hiddenChannels || []);
                    return (0, $jg4vi.buildDMChannels)(root, true).filter((c)=>!hidden.has(c.id));
                }
            }
        }
    }
};
const $d400d9f30bdd89ab$export$fec01ae84ff953ba = {
    flow: 'y',
    gap: 'Z',
    Header: {
        extends: 'ChatSidebarGroupHeader'
    },
    List: {
        flow: 'y',
        gap: 'V',
        hide: (el, s)=>!!(s && s.root && s.root.collapsedGroups && s.root.collapsedGroups[s.groupKey]),
        childrenAs: 'state'
    }
};
const $d400d9f30bdd89ab$export$3fbd61ffbad7de76 = {
    flow: 'x',
    align: 'center left',
    gap: 'X2',
    cursor: 'pointer',
    padding: 'V 0',
    attr: {
        'data-toggle-group': (el, s)=>s && s.groupKey
    },
    Caret: {
        extends: 'Icon',
        icon: 'arrowAngleDown',
        boxSize: 'Z',
        color: 'caption',
        // The Icon base resolves `el.icon` once in `onInit` and bakes the SVG
        // into `el.src`, so a reactive `icon: (el, s) => ...` factory never
        // re-runs when state flips. Rotating a single icon via the reactive
        // `transform:` CSS factory IS picked up by the effect pipeline — and
        // animates smoothly as a bonus. Collapsed → arrow points right.
        transform: (el, s)=>s && s.root && s.root.collapsedGroups && s.root.collapsedGroups[s.groupKey] ? 'rotate(-90deg)' : 'rotate(0deg)',
        transition: 'transform 120ms ease'
    },
    CaptionTitle: {
        fontSize: 'Y2',
        flex: '1',
        Text: {
            text: (el, s)=>s && s.label || ''
        }
    },
    AddBtn: {
        tag: 'span',
        fontSize: 'A',
        color: 'caption',
        padding: '0 V',
        text: '+',
        attr: {
            'data-action': (el, s)=>s && s.addAction
        },
        ':hover': {
            color: 'title'
        }
    }
};
const $d400d9f30bdd89ab$export$417eb58734500cda = {
    extends: 'SidebarRow',
    attr: {
        'data-cid': (el, s)=>s && s.id || ''
    },
    background: (el, s)=>{
        const root = s && s.root;
        return root && s.id === root.activeChannelId ? 'white.1' : 'transparent';
    },
    color: (el, s)=>{
        const root = s && s.root;
        return root && s.id === root.activeChannelId ? 'title' : 'caption';
    },
    fontWeight: (el, s)=>{
        const root = s && s.root;
        return root && s.id === root.activeChannelId ? '600' : '400';
    },
    opacity: (el, s)=>$d400d9f30bdd89ab$var$_isMuted(s) ? '.6' : '1',
    Icon: {
        tag: 'span',
        text: '#',
        color: 'caption'
    },
    Label: {
        text: (el, s)=>s && s.name || 'channel',
        fontWeight: (el, s)=>$d400d9f30bdd89ab$var$_getUnread(s) > 0 && !$d400d9f30bdd89ab$var$_isMuted(s) ? '700' : 'inherit'
    },
    MuteIndicator: $d400d9f30bdd89ab$var$_muteIndicator,
    UnreadBadge: $d400d9f30bdd89ab$var$_unreadBadge,
    MentionBadge: $d400d9f30bdd89ab$var$_mentionBadge,
    MoreBtn: {
        extends: 'ChatSidebarMore',
        items: (el, s)=>[
                {
                    label: 'Invite',
                    action: 'invite-channel'
                },
                {
                    label: 'Rename',
                    action: 'rename-channel'
                },
                {
                    label: 'Settings',
                    action: 'channel-settings'
                },
                {
                    label: 'Pin to top',
                    action: 'pin-to-top'
                },
                {
                    label: $d400d9f30bdd89ab$var$_isMuted(s) ? 'Unmute' : 'Mute',
                    action: 'toggle-mute'
                }
            ]
    }
};
const $d400d9f30bdd89ab$export$6511568de1d088c1 = {
    extends: 'SidebarRow',
    gap: 'A',
    attr: {
        'data-cid': (el, s)=>s && s.id || '',
        draggable: 'true'
    },
    opacity: (el, s)=>$d400d9f30bdd89ab$var$_isMuted(s) ? '.6' : '1',
    background: (el, s)=>{
        const root = s && s.root;
        if (root && root._dragOverCid === s.id) return 'blue.05';
        return root && s.id === root.activeChannelId ? 'white.1' : 'transparent';
    },
    fontWeight: (el, s)=>{
        const root = s && s.root;
        return root && s.id === root.activeChannelId ? '600' : '400';
    },
    onDragStart: (e, el, s)=>{
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text/plain', s.id);
        s.root.update({
            _dragSourceCid: s.id
        });
    },
    onDragEnd: (e, el, s)=>{
        s.root.update({
            _dragSourceCid: null,
            _dragOverCid: null
        });
    },
    onDragOver: (e, el, s)=>{
        const src = s.root._dragSourceCid;
        if (!src || src === s.id) return;
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
        if (s.root._dragOverCid !== s.id) s.root.update({
            _dragOverCid: s.id
        });
    },
    onDragLeave: (e, el, s)=>{
        if (s.root._dragOverCid === s.id) s.root.update({
            _dragOverCid: null
        });
    },
    onDrop: async (e, el, s)=>{
        e.preventDefault();
        const srcId = e.dataTransfer.getData('text/plain');
        s.root.update({
            _dragSourceCid: null,
            _dragOverCid: null
        });
        if (!srcId || srcId === s.id) return;
        // Collect all unique member emails from both DMs
        const me = s.root.currentUserEmail;
        const members = s.root.channelMembers || [];
        const srcEmails = members.filter((m)=>m.channel_id === srcId && m.member_email !== me).map((m)=>m.member_email);
        const dstEmails = members.filter((m)=>m.channel_id === s.id && m.member_email !== me).map((m)=>m.member_email);
        const allEmails = Array.from(new Set([
            ...srcEmails,
            ...dstEmails
        ]));
        if (allEmails.length < 2) return;
        try {
            await el.call('createChannel', {
                kind: 'group_dm',
                memberEmails: allEmails
            });
        } catch (err) {
            console.error('[ChatDMRow] Group DM creation failed:', err);
        }
    },
    Icon: {
        tag: 'div',
        position: 'relative',
        flexShrink: '0',
        width: 'auto',
        height: 'auto',
        boxSize: 'auto',
        Avatar: {
            display: (el, s)=>s && s.kind === 'group_dm' ? 'none' : 'flex',
            avatarType: 'initials',
            boxSize: 'A1 A1',
            src: (el, s)=>{
                const root = s && s.root;
                if (!root) return el.call('avatarUrl', null);
                const me = root.currentUserEmail;
                const map = el.call('peopleByEmail');
                const other = (root.channelMembers || []).find((m)=>m.channel_id === s.id && m.member_email !== me);
                const otherEmail = other && other.member_email;
                return el.call('avatarUrl', otherEmail && map[otherEmail]?.name || otherEmail);
            }
        },
        AvatarBundle: {
            display: (el, s)=>s && s.kind === 'group_dm' ? 'flex' : 'none',
            emails: (el, s)=>{
                const root = s && s.root;
                if (!root) return [];
                const me = root.currentUserEmail;
                return (root.channelMembers || []).filter((m)=>m.channel_id === s.id && m.member_email !== me).map((m)=>m.member_email).slice(0, 3);
            }
        },
        OnlineDot: {
            hide: (el, s)=>{
                if (s && s.kind === 'group_dm') return true;
                const root = s && s.root;
                if (!root || !root.presence) return true;
                const me = root.currentUserEmail;
                const other = (root.channelMembers || []).find((m)=>m.channel_id === s.id && m.member_email !== me);
                return !(other && root.presence[other.member_email]);
            },
            position: 'absolute',
            bottom: '0',
            right: '0',
            width: 'Y',
            height: 'Y',
            round: '100%',
            background: 'green',
            borderWidth: '2px',
            borderColor: 'overlayStrong',
            borderStyle: 'solid'
        }
    },
    Label: {
        color: 'title',
        fontWeight: (el, s)=>$d400d9f30bdd89ab$var$_getUnread(s) > 0 && !$d400d9f30bdd89ab$var$_isMuted(s) ? '700' : 'inherit',
        text: (el, s)=>{
            const root = s && s.root;
            if (!root) return '';
            return (0, $jg4vi.channelDisplayName)(s, root.channelMembers || [], el.call('peopleByEmail'), root.currentUserEmail);
        }
    },
    MuteIndicator: $d400d9f30bdd89ab$var$_muteIndicator,
    UnreadBadge: $d400d9f30bdd89ab$var$_unreadBadge,
    MentionBadge: $d400d9f30bdd89ab$var$_mentionBadge,
    MoreBtn: {
        extends: 'ChatSidebarMore',
        items: (el, s)=>{
            const muteItem = {
                label: $d400d9f30bdd89ab$var$_isMuted(s) ? 'Unmute' : 'Mute',
                action: 'toggle-mute'
            };
            if (s && s.kind === 'group_dm') return [
                {
                    label: 'Create channel',
                    action: 'convert-to-channel'
                },
                {
                    label: 'Rename',
                    action: 'rename-channel'
                },
                {
                    label: 'Pin to top',
                    action: 'pin-to-top'
                },
                muteItem,
                {
                    label: 'Hide',
                    action: 'hide-dm'
                },
                {
                    label: 'Leave',
                    action: 'leave-channel',
                    color: 'red'
                }
            ];
            return [
                {
                    label: 'Hide',
                    action: 'hide-dm'
                },
                {
                    label: 'Start group chat',
                    action: 'start-group-chat'
                },
                {
                    label: 'Pin to top',
                    action: 'pin-to-top'
                },
                muteItem
            ];
        }
    }
};
const $d400d9f30bdd89ab$export$875ae4400b6e0ab = {
    extends: 'ChatDMRow',
    Label: {
        color: 'title',
        fontWeight: (el, s)=>$d400d9f30bdd89ab$var$_getUnread(s) > 0 ? '700' : 'inherit',
        text: (el, s)=>{
            const root = s && s.root;
            if (!root) return '';
            return (0, $jg4vi.channelDisplayName)(s, root.channelMembers || [], el.call('peopleByEmail'), root.currentUserEmail, {
                firstOnly: true
            });
        }
    }
};
const $d400d9f30bdd89ab$export$c71b0e4b1cc807f1 = {
    extends: 'SidebarRow',
    attr: {
        'data-cid': (el, s)=>s && s.id || '',
        draggable: 'true'
    },
    background: (el, s)=>{
        const root = s && s.root;
        return root && s.id === root.activeChannelId ? 'white.1' : 'transparent';
    },
    fontWeight: (el, s)=>{
        const root = s && s.root;
        return root && s.id === root.activeChannelId ? '600' : '400';
    },
    // SidebarRow base keys: Icon → Label → MoreBtn
    // For channels: # prefix. For DMs/groups: hidden (avatar in Label).
    Icon: {
        tag: 'span',
        icon: null,
        text: (el, s)=>s && s.kind === 'channel' ? '#' : '',
        color: 'caption',
        display: (el, s)=>s && s.kind === 'channel' ? 'inline' : 'none'
    },
    // Label includes avatar for DMs/groups, just text for channels
    Label: {
        flow: 'x',
        align: 'center left',
        gap: 'Z',
        flex: '1',
        minWidth: '0',
        // Single avatar for 1:1 DMs
        Avatar_dm: {
            tag: 'img',
            display: (el, s)=>s && s.kind === 'dm' ? 'block' : 'none',
            width: 'A1',
            height: 'A1',
            round: '100%',
            flexShrink: '0',
            src: (el, s)=>{
                if (!s || s.kind !== 'dm') return '';
                const root = s && s.root;
                if (!root) return '';
                const me = root.currentUserEmail;
                const map = el.call('peopleByEmail');
                const other = (root.channelMembers || []).find((m)=>m.channel_id === s.id && m.member_email !== me);
                return el.call('avatarUrl', other && map[other.member_email]?.name || '');
            }
        },
        // Stacked avatars for group DMs
        AvatarBundle: {
            display: (el, s)=>s && s.kind === 'group_dm' ? 'flex' : 'none',
            flexShrink: '0',
            emails: (el, s)=>{
                const root = s && s.root;
                if (!root) return [];
                const me = root.currentUserEmail;
                return (root.channelMembers || []).filter((m)=>m.channel_id === s.id && m.member_email !== me).map((m)=>m.member_email).slice(0, 3);
            }
        },
        Text: {
            tag: 'span',
            fontSize: 'Z2',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>{
                if (!s) return '';
                if (s.kind === 'channel') return s.name || '';
                const root = s.root;
                if (!root) return '';
                return (0, $jg4vi.channelDisplayName)(s, root.channelMembers || [], el.call('peopleByEmail'), root.currentUserEmail);
            }
        }
    },
    MoreBtn: {
        extends: 'ChatSidebarMore'
    }
};
const $d400d9f30bdd89ab$export$9c4ce95a604aa6c3 = {
    extends: 'SidebarItemMore'
};
const $d400d9f30bdd89ab$export$8aa0535fc50b913d = {
    extends: 'SidebarItemMenuItem'
};

});
parcelRegister("jg4vi", function(module, exports) {

$parcel$export(module.exports, "rowToMessage", () => $e053014cc8681657$export$de50266104c2ad29);
$parcel$export(module.exports, "rowToChannel", () => $e053014cc8681657$export$2324ba16057d4458);
$parcel$export(module.exports, "unreadCount", () => $e053014cc8681657$export$acb9fd9c5a541324);
$parcel$export(module.exports, "mutedChannels", () => $e053014cc8681657$export$4d14912bb87de3de);
$parcel$export(module.exports, "channelDisplayName", () => $e053014cc8681657$export$27109ced7a4912bf);
$parcel$export(module.exports, "buildDMChannels", () => $e053014cc8681657$export$587d95e3f07d1c9b);
$parcel$export(module.exports, "groupMessages", () => $e053014cc8681657$export$6e0f5ca138042cea);
// Pure helpers — no Supabase calls live here. Imports + writes happen in
// sendMessage / subscribeRealtime / createChannel / markRead.

var $cxvtm = parcelRequire("cxvtm");

var $jlK4b = parcelRequire("jlK4b");
const $e053014cc8681657$export$de50266104c2ad29 = (r)=>({
        id: r.id,
        channelId: r.channel_id,
        authorEmail: r.author_email,
        body: r.body,
        attachments: r.attachments || null,
        replyTo: r.reply_to,
        threadRoot: r.thread_root,
        threadCount: r.thread_count || 0,
        editedAt: r.edited_at,
        deleted: !!r.deleted,
        createdAt: r.created_at
    });
const $e053014cc8681657$export$2324ba16057d4458 = (r)=>({
        id: r.id,
        kind: r.kind,
        name: r.name,
        topic: r.topic,
        isPrivate: !!r.is_private,
        isArchived: !!r.is_archived,
        createdBy: r.created_by,
        createdAt: r.created_at,
        updatedAt: r.updated_at
    });
const $e053014cc8681657$export$acb9fd9c5a541324 = (messages, lastReadAt, currentUserEmail)=>{
    if (!Array.isArray(messages) || !messages.length) return 0;
    const cutoff = lastReadAt ? new Date(lastReadAt).getTime() : 0;
    let n = 0;
    for (const m of messages){
        if (m.deleted) continue;
        if (m.authorEmail === currentUserEmail) continue;
        const t = m.createdAt ? new Date(m.createdAt).getTime() : 0;
        if (t > cutoff) n++;
    }
    return n;
};
// Per-(channelMembers identity, me) cache of the set of muted channel ids.
// Invalidates automatically when channelMembers is replaced (which happens
// on every realtime upsert). Drastically cuts the cost of `_isMuted` calls
// on every sidebar row during render.
const $e053014cc8681657$var$_mutedCache = new WeakMap();
const $e053014cc8681657$export$4d14912bb87de3de = (channelMembers, me)=>{
    if (!channelMembers || !me) return $e053014cc8681657$var$_EMPTY_SET;
    let cached = $e053014cc8681657$var$_mutedCache.get(channelMembers);
    if (cached && cached._me === me) return cached;
    const set = new Set();
    for (const m of channelMembers)if (m.member_email === me && m.muted) set.add(m.channel_id);
    set._me = me;
    $e053014cc8681657$var$_mutedCache.set(channelMembers, set);
    return set;
};
const $e053014cc8681657$var$_EMPTY_SET = new Set();
const $e053014cc8681657$export$27109ced7a4912bf = (channel, members, peopleByEmail, currentUserEmail, opts = {})=>{
    if (!channel) return '';
    if (channel.kind === 'channel') return channel.name || 'channel';
    const others = (members || []).filter((m)=>m.channel_id === channel.id && m.member_email !== currentUserEmail).map((m)=>{
        const full = peopleByEmail[m.member_email]?.name || m.member_email;
        return opts.firstOnly ? (0, $jlK4b.firstName)(full) : full;
    });
    if (channel.kind === 'dm') return others[0] || 'Direct message';
    return others.join(', ') || 'Group DM';
};
const $e053014cc8681657$export$587d95e3f07d1c9b = (root, external)=>{
    if (!root) return [];
    const me = root.currentUserEmail;
    const members = root.channelMembers || [];
    const peopleEmails = new Set((root.people || []).map((p)=>p.email));
    const myChannelOthers = new Map();
    for (const ch of root.channels || []){
        if (ch.kind !== 'dm' && ch.kind !== 'group_dm') continue;
        const all = members.filter((m)=>m.channel_id === ch.id).map((m)=>m.member_email);
        if (!all.includes(me)) continue;
        const others = all.filter((e)=>e !== me);
        if (!others.length) continue;
        myChannelOthers.set(ch.id, others);
    }
    const seenIds = new Set();
    const seenMemberKeys = new Set();
    return (root.channels || []).filter((c)=>{
        if (!myChannelOthers.has(c.id)) return false;
        if (seenIds.has(c.id)) return false;
        const others = myChannelOthers.get(c.id);
        const allInternal = others.every((e)=>peopleEmails.has(e));
        if (external ? allInternal : !allInternal) return false;
        const memberKey = others.slice().sort().join(',');
        if (seenMemberKeys.has(memberKey)) return false;
        seenIds.add(c.id);
        seenMemberKeys.add(memberKey);
        return true;
    });
};
const $e053014cc8681657$export$6e0f5ca138042cea = (messages = [])=>{
    const FIVE_MIN = 300000;
    let lastAuthor = null;
    let lastTime = 0;
    let lastDay = null;
    return messages.map((m)=>{
        const t = new Date(m.createdAt).getTime();
        const day = (0, $cxvtm.localDate)(new Date(m.createdAt));
        const newDay = day !== lastDay;
        const grouped = !newDay && m.authorEmail === lastAuthor && t - lastTime < FIVE_MIN;
        lastAuthor = m.authorEmail;
        lastTime = t;
        lastDay = day;
        return {
            ...m,
            _grouped: grouped,
            _newDay: newDay,
            _day: day
        };
    });
};

});
parcelRegister("cxvtm", function(module, exports) {

$parcel$export(module.exports, "pad2", () => $9210fae5076a9fe4$export$9decc9dc70e2c76f);
$parcel$export(module.exports, "localDate", () => $9210fae5076a9fe4$export$d30d8547ed0ef255);
$parcel$export(module.exports, "localTime", () => $9210fae5076a9fe4$export$f0dfd716e7b023cd);
$parcel$export(module.exports, "todayISO", () => $9210fae5076a9fe4$export$424906fec691dc17);
$parcel$export(module.exports, "dayLabel", () => $9210fae5076a9fe4$export$fed04f446fd15195);
$parcel$export(module.exports, "clockTime", () => $9210fae5076a9fe4$export$f9a26c3ca99aeecf);
const $9210fae5076a9fe4$export$9decc9dc70e2c76f = (n)=>String(n).padStart(2, '0');
const $9210fae5076a9fe4$export$d30d8547ed0ef255 = (d)=>`${d.getFullYear()}-${$9210fae5076a9fe4$export$9decc9dc70e2c76f(d.getMonth() + 1)}-${$9210fae5076a9fe4$export$9decc9dc70e2c76f(d.getDate())}`;
const $9210fae5076a9fe4$export$f0dfd716e7b023cd = (d)=>`${$9210fae5076a9fe4$export$9decc9dc70e2c76f(d.getHours())}:${$9210fae5076a9fe4$export$9decc9dc70e2c76f(d.getMinutes())}`;
const $9210fae5076a9fe4$export$424906fec691dc17 = ()=>$9210fae5076a9fe4$export$d30d8547ed0ef255(new Date());
const $9210fae5076a9fe4$export$fed04f446fd15195 = (iso)=>{
    const d = new Date(iso);
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);
    if ($9210fae5076a9fe4$export$d30d8547ed0ef255(d) === $9210fae5076a9fe4$export$d30d8547ed0ef255(today)) return 'Today';
    if ($9210fae5076a9fe4$export$d30d8547ed0ef255(d) === $9210fae5076a9fe4$export$d30d8547ed0ef255(yesterday)) return 'Yesterday';
    return d.toLocaleDateString(undefined, {
        weekday: 'long',
        month: 'short',
        day: 'numeric'
    });
};
const $9210fae5076a9fe4$export$f9a26c3ca99aeecf = (ts)=>{
    const d = new Date(ts);
    return d.toLocaleTimeString(undefined, {
        hour: '2-digit',
        minute: '2-digit'
    });
};

});

parcelRegister("jlK4b", function(module, exports) {

$parcel$export(module.exports, "peopleByEmail", () => $e163b64f7de99060$export$382bec5fef9c5392);
$parcel$export(module.exports, "firstName", () => $e163b64f7de99060$export$6514a1206b6ef315);
$parcel$export(module.exports, "findPerson", () => $e163b64f7de99060$export$9cba0ebbc6894563);
$parcel$export(module.exports, "avatarUrl", () => $e163b64f7de99060$export$3e7937c9301724ed);
$parcel$export(module.exports, "avatarUrlFor", () => $e163b64f7de99060$export$a2abf70522ed0b3b);
$parcel$export(module.exports, "activeMembers", () => $e163b64f7de99060$export$622cce44779cc764);
$parcel$export(module.exports, "peopleByShareClass", () => $e163b64f7de99060$export$603ed1223ee6477d);
$parcel$export(module.exports, "isSelf", () => $e163b64f7de99060$export$b56c5b9b8805de6e);
$parcel$export(module.exports, "viewedEmail", () => $e163b64f7de99060$export$2e8b924842b44174);
$parcel$export(module.exports, "viewedPerson", () => $e163b64f7de99060$export$b34bfb05be6e8cb0);
// People lookup helpers. WeakMap-cached by root.people identity for O(1) lookups.
const $e163b64f7de99060$var$_peopleByEmailCache = new WeakMap();
const $e163b64f7de99060$var$_emptyMap = Object.freeze({});
const $e163b64f7de99060$var$_ensureMap = (people)=>{
    if (!people || !people.length) return $e163b64f7de99060$var$_emptyMap;
    let cached = $e163b64f7de99060$var$_peopleByEmailCache.get(people);
    if (cached) return cached;
    cached = Object.create(null);
    for (const p of people)if (p && p.email) cached[p.email] = p;
    $e163b64f7de99060$var$_peopleByEmailCache.set(people, cached);
    return cached;
};
function $e163b64f7de99060$export$382bec5fef9c5392(root) {
    const r = root != null ? root : this && this.state && this.state.root;
    return $e163b64f7de99060$var$_ensureMap(r && r.people || null);
}
// Fuzzy match by email prefix when exact lookup fails. Matches the part
// before `@` against each person's name first-word or email prefix. Used
// so chat messages from aliased emails (e.g. tornike@symbols.app when the
// record is svinchy@symbols.app / Tornike Svintradze) still resolve to the
// person's full name.
const $e163b64f7de99060$var$_fuzzyByPrefixCache = new WeakMap();
const $e163b64f7de99060$var$_fuzzyMatch = (people, email)=>{
    if (!people || !people.length || !email) return null;
    const at = email.indexOf('@');
    if (at < 2) return null;
    const prefix = email.slice(0, at).toLowerCase();
    const domain = email.slice(at + 1).toLowerCase();
    let cached = $e163b64f7de99060$var$_fuzzyByPrefixCache.get(people);
    if (!cached) {
        cached = Object.create(null);
        for (const p of people){
            if (!p || !p.email) continue;
            const pAt = p.email.indexOf('@');
            if (pAt < 0) continue;
            const pPrefix = p.email.slice(0, pAt).toLowerCase();
            const pDomain = p.email.slice(pAt + 1).toLowerCase();
            cached[pPrefix + '@' + pDomain] = p;
            cached[pPrefix] = p;
            const first = $e163b64f7de99060$export$6514a1206b6ef315(p.name);
            if (first) cached[first.toLowerCase()] = cached[first.toLowerCase()] || p;
        }
        $e163b64f7de99060$var$_fuzzyByPrefixCache.set(people, cached);
    }
    return cached[prefix + '@' + domain] || cached[prefix] || null;
};
function $e163b64f7de99060$export$9cba0ebbc6894563(rootOrEmail, maybeEmail) {
    if (typeof rootOrEmail === 'string' && maybeEmail === undefined) {
        const root = this && this.state && this.state.root;
        if (!root) return null;
        const scoped = root.people || null;
        const full = root.peopleAll || null;
        return $e163b64f7de99060$var$_ensureMap(scoped)[rootOrEmail] || $e163b64f7de99060$var$_fuzzyMatch(scoped, rootOrEmail) || $e163b64f7de99060$var$_ensureMap(full)[rootOrEmail] || $e163b64f7de99060$var$_fuzzyMatch(full, rootOrEmail) || null;
    }
    if (!rootOrEmail || !maybeEmail) return null;
    const scoped = rootOrEmail.people || null;
    const full = rootOrEmail.peopleAll || null;
    return $e163b64f7de99060$var$_ensureMap(scoped)[maybeEmail] || $e163b64f7de99060$var$_fuzzyMatch(scoped, maybeEmail) || $e163b64f7de99060$var$_ensureMap(full)[maybeEmail] || $e163b64f7de99060$var$_fuzzyMatch(full, maybeEmail) || null;
}
const $e163b64f7de99060$export$3e7937c9301724ed = (seed)=>`https://api.dicebear.com/7.x/initials/svg?seed=${encodeURIComponent(seed || '?')}`;
const $e163b64f7de99060$export$6514a1206b6ef315 = (name, fallback = '')=>(name || '').split(/\s+/)[0] || name || fallback;
function $e163b64f7de99060$export$a2abf70522ed0b3b(root, email) {
    let r = root, e = email;
    if (typeof root === 'string' && email === undefined) {
        e = root;
        r = this && this.state && this.state.root;
    }
    const p = $e163b64f7de99060$export$9cba0ebbc6894563(r, e);
    return $e163b64f7de99060$export$3e7937c9301724ed(p && p.name || e);
}
// Active team members — people with operational roles (member, manager, admin,
// superadmin). Excludes advisors, investors, and shareholders who have left.
// CU-10 §90: roles are no longer on the person object; look up via
// root.roles.byUser[userId]. A person with no role entry defaults to 'member'
// (operational) for backward compatibility with people added before the migration.
const $e163b64f7de99060$var$_ACTIVE_ROLES = new Set([
    'member',
    'manager',
    'admin',
    'superadmin'
]);
const $e163b64f7de99060$var$_activeMembersCache = new WeakMap();
function $e163b64f7de99060$export$622cce44779cc764(root) {
    const r = root != null ? root : this && this.state && this.state.root;
    const people = r && r.people || [];
    if (!people.length) return people;
    const byUser = r?.roles?.byUser || {};
    // Cache key must incorporate byUser since it changes when roles load.
    // Use a two-key WeakMap trick: cache on people array, invalidate when
    // byUser reference changes via version bump (root.roles.version).
    const version = r?.roles?.version ?? 0;
    let cached = $e163b64f7de99060$var$_activeMembersCache.get(people);
    if (cached && cached.version === version) return cached.result;
    const result = people.filter((p)=>{
        // Legacy fallback: person still has .roles from a pre-§90 render.
        if (Array.isArray(p.roles) && p.roles.length > 0) return p.roles.some((role)=>$e163b64f7de99060$var$_ACTIVE_ROLES.has(role));
        const assignedRole = byUser[p.userId] || 'member';
        return $e163b64f7de99060$var$_ACTIVE_ROLES.has(assignedRole);
    });
    $e163b64f7de99060$var$_activeMembersCache.set(people, {
        version: version,
        result: result
    });
    return result;
}
function $e163b64f7de99060$export$603ed1223ee6477d(rootOrCls, maybeCls) {
    let root, cls;
    if (maybeCls !== undefined) {
        root = rootOrCls;
        cls = maybeCls;
    } else {
        root = this && this.state && this.state.root;
        cls = rootOrCls;
    }
    return (root && root.people || []).filter((p)=>p.share_class === cls);
}
function $e163b64f7de99060$export$b56c5b9b8805de6e(s) {
    const state = s != null ? s : this && this.state;
    const root = state && state.root;
    if (!root) return true;
    const viewed = typeof window !== 'undefined' ? new URLSearchParams(window.location.search).get('u') : null;
    return !viewed || viewed === root.currentUserEmail;
}
const $e163b64f7de99060$export$2e8b924842b44174 = (s)=>{
    const fromQuery = typeof window !== 'undefined' ? new URLSearchParams(window.location.search).get('u') : null;
    return fromQuery || s && s.root && s.root.currentUserEmail || '';
};
const $e163b64f7de99060$export$b34bfb05be6e8cb0 = (s, { allowQuery: allowQuery = false } = {})=>{
    const root = s && s.root;
    if (!root) return null;
    const email = allowQuery ? $e163b64f7de99060$export$2e8b924842b44174(s) : root.currentUserEmail;
    return $e163b64f7de99060$export$9cba0ebbc6894563(root, email);
};

});



parcelRegister("3UdbF", function(module, exports) {

$parcel$export(module.exports, "ChatMain", () => $2d80d4c71299cbcb$export$a2ba04232d307b65);
$parcel$export(module.exports, "ChatHeader", () => $2d80d4c71299cbcb$export$1263ff8fe28ec69f);
// Right-hand main column. Splits the channel content area from the
// optional thread panel that slides in when `activeThreadRootId` is
// set. The ChannelColumn extends shared-gov's `AppMain` (header + body
// shell) and adds a Composer footer + filter bar specific to chat.

var $jg4vi = parcelRequire("jg4vi");
const $2d80d4c71299cbcb$export$a2ba04232d307b65 = {
    flow: 'x',
    flex: '1 1 0',
    minWidth: '0',
    minHeight: '0',
    overflow: 'hidden',
    theme: 'document',
    ChannelColumn: {
        extends: 'AppMain',
        padding: '0',
        // Header now hosts the tab switcher in its center group (Calendar's
        // ViewSwitcher pattern). The standalone Tabs row underneath has been
        // removed — see ChatHeader.CenterGroup below.
        Header: {
            extends: 'ChatHeader'
        },
        Body: null,
        ChatFilterBar: {},
        // The four tab views are stacked siblings — each uses `hide` to show
        // only when its tab is active. flex:1 + min-height:0 means whichever
        // one is visible expands to fill the remaining space and scrolls
        // independently.
        Conversation: {
            extends: 'ChatMessageList',
            width: '100%',
            maxWidth: 'I1',
            margin: '0 auto'
        },
        ChatFilesView: {},
        ChatLinksView: {},
        ChatTicketsView: {},
        // Composer only on the conversation tab.
        Footer: {
            extends: 'ChatComposer',
            hide: (el, s)=>!(s && s.root && s.root.activeTab === 'conversation'),
            Toolbar: {
                width: '100%',
                maxWidth: 'I1',
                margin: '0 auto'
            },
            Box: {
                width: '100%',
                maxWidth: 'I1',
                margin: '0 auto'
            }
        }
    },
    Thread: {
        extends: 'ChatThreadPanel',
        hide: (el, s)=>!(s && s.root && s.root.activeThreadRootId)
    },
    // Single shared hover-actions overlay — viewport-fixed, lives outside
    // the message-list and thread-panel scroll containers. Both lists use
    // setupHoverActions(scrollNode) to position this on bubble hover.
    HoverActions: {
        extends: 'ChatHoverActions'
    }
};
const $2d80d4c71299cbcb$export$1263ff8fe28ec69f = {
    extends: 'PageHeader',
    padding: 'A B1',
    minHeight: 'D1',
    backdropFilter: 'blur(20px)',
    LeftGroup: {
        flow: 'y',
        align: 'flex-start left',
        gap: 'V',
        flex: '1',
        minWidth: '0',
        Title: {
            tag: 'h2',
            fontSize: 'B1',
            fontWeight: '600',
            letterSpacing: '-.01em',
            margin: '0',
            color: 'title',
            cursor: 'pointer',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            ':hover': {
                opacity: '.8'
            },
            onClick: (e, el, s)=>{
                const root = s && s.root;
                if (!root) return;
                const ch = (root.channels || []).find((c)=>c.id === root.activeChannelId);
                if (!ch) return;
                root.update({
                    showChannelSettings: ch.id
                });
            },
            text: (el, s)=>{
                const root = s && s.root;
                if (!root) return 'Select a channel';
                const activeId = root.activeChannelId;
                if (!activeId) return 'Select a channel';
                const ch = (root.channels || []).find((c)=>c.id === activeId);
                if (ch) {
                    const prefix = ch.kind === 'channel' ? '# ' : '';
                    return prefix + (0, $jg4vi.channelDisplayName)(ch, root.channelMembers || [], el.call('peopleByEmail'), root.currentUserEmail, {
                        firstOnly: ch.kind === 'group_dm'
                    });
                }
                // Channel id is set (URL hash, deep link, cross-workspace handoff)
                // but the channel isn't in this user's loaded list yet. Show a
                // neutral placeholder instead of the misleading "Select a channel"
                // — the conversation pane is already rendering messages from it.
                return 'Channel';
            }
        },
        Topic: null,
        // Cross-resource link pills — surfaces the event/meet this channel is
        // tied to (if any). Clicking a pill navigates to that resource.
        Links: {
            extends: 'LinkedResources',
            marginTop: 'Y',
            type: 'chat_channel',
            id: (el, s)=>s?.root?.activeChannelId || null
        }
    },
    // Center-positioned tab switcher — Conversation / Files / Links / Tickets.
    // Uses the shared `SharedViewSwitcher` from shared-gov, so the same
    // component drives calendar's view tabs and chat's content tabs.
    CenterGroup: {
        TabSwitcher: {
            extends: 'SharedViewSwitcher',
            stateKey: 'activeTab',
            childExtends: 'SharedViewSwitcherBtn',
            children: [
                {
                    value: 'conversation',
                    label: 'Conversation'
                },
                {
                    value: 'files',
                    label: 'Files'
                },
                {
                    value: 'links',
                    label: 'Links'
                },
                {
                    value: 'tickets',
                    label: 'Tickets'
                }
            ]
        }
    },
    RightGroup: {
        gap: 'A',
        // Cross-app: start a meet call with all members of the active channel /
        // DM. Creates (or reuses) a meet_rooms row linked via chat_channel_id,
        // auto-seeds meet_room_members from chat_channel_members, and drops the
        // initiator straight into the call. Other members see the room appear
        // in their /meet list with a LIVE badge (via realtime).
        CallChannelBtn: {
            extends: 'IconButton',
            hide: (el, s)=>!s?.root?.activeChannelId,
            Icon: {
                icon: 'video'
            },
            title: 'Call all participants',
            aria: {
                label: 'Call all participants'
            },
            onClick: async (e, el, s)=>{
                const root = s.root;
                const channelId = root.activeChannelId;
                if (!channelId) return;
                const channel = (root.channels || []).find((c)=>c.id === channelId);
                if (!channel) return;
                const isDm = channel.kind === 'dm' || channel.kind === 'group_dm';
                // Reuse an existing active meet room for this channel if one exists.
                const existing = (root.rooms || []).find((r)=>r.chatChannelId === channelId && !r.endedAt);
                let id = existing?.id;
                if (!id) id = await el.call('createRoom', {
                    name: (channel.name || (isDm ? 'Direct call' : 'Channel call')) + (isDm ? '' : " \xb7 call"),
                    kind: isDm ? 'dm' : 'room',
                    chatChannelId: channelId,
                    // DMs default transcribe-off (privacy); channels default on.
                    transcribeEnabled: !isDm,
                    // Private unless it's an already-public channel.
                    isPrivate: isDm || !!channel.is_private
                });
                if (!id) return;
                root.update({
                    activeRoomId: id,
                    meetView: 'call'
                });
                if (typeof window !== 'undefined') window.location.hash = `room=${id}&view=call`;
                await el.call('connectCall', id);
                let __root = el;
                while(__root && !__root.routes)__root = __root.parent;
                if (__root) el.router('/meet', __root);
            }
        },
        // AiToggle / Profile already live in the global AppHeader.
        // Chat-only actions: filter toggle and member count.
        FilterBtn: {
            extends: 'IconButton',
            Icon: {
                icon: 'filter'
            },
            title: 'Toggle filters',
            aria: {
                label: 'Toggle filters'
            },
            data: {
                action: 'toggle-filter-bar'
            }
        },
        MemberCount: {
            tag: 'span',
            fontSize: 'Z2',
            color: 'caption',
            text: (el, s)=>{
                const root = s && s.root;
                if (!root || !root.activeChannelId) return '';
                const n = (root.channelMembers || []).filter((m)=>m.channel_id === root.activeChannelId).length;
                return `${n} member${n === 1 ? '' : 's'}`;
            }
        }
    }
};

});

parcelRegister("jTgjx", function(module, exports) {

$parcel$export(module.exports, "ChatMessageList", () => $e7afcf01cffb91a8$export$7929958f2754af59);
$parcel$export(module.exports, "ChatMessageRow", () => $e7afcf01cffb91a8$export$7dc8c500c62e1f50);
$parcel$export(module.exports, "ChatReactionPill", () => $e7afcf01cffb91a8$export$862e4c513906162f);
$parcel$export(module.exports, "ChatReactionEmoji", () => $e7afcf01cffb91a8$export$e0cc898e68e345aa);
$parcel$export(module.exports, "ChatAttachmentRender", () => $e7afcf01cffb91a8$export$95cef358fd3c8eb7);
$parcel$export(module.exports, "ChatHoverActions", () => $e7afcf01cffb91a8$export$94495b079485a912);
$parcel$export(module.exports, "ChatHoverIconBtn", () => $e7afcf01cffb91a8$export$3017a3477d88be04);
$parcel$export(module.exports, "ChatHoverQuickReact", () => $e7afcf01cffb91a8$export$bd07e541b2244e8);
$parcel$export(module.exports, "ChatHoverDivider", () => $e7afcf01cffb91a8$export$d77fd82e5147ff4f);
$parcel$export(module.exports, "ChatHoverMenuItem", () => $e7afcf01cffb91a8$export$3a4cc3d9be110717);
// Slack/Google-Chat hybrid message list. Day separators, author grouping,
// markdown bubbles, hover reply, thread count chip, attachment grid.

var $jg4vi = parcelRequire("jg4vi");

var $lwYfR = parcelRequire("lwYfR");

var $5WCCa = parcelRequire("5WCCa");

var $htapf = parcelRequire("htapf");

var $bfqVY = parcelRequire("bfqVY");
// Credit metering for chat-prefill AI now happens server-side. The
// edge function that runs the AI prompt knows the actual token count
// and burns there — see server/packages/credit-meter.
// How many messages to show initially per channel. Scrolling to the top
// loads the next page. Keeps initial render fast even for channels with
// thousands of messages.
const $e7afcf01cffb91a8$var$_PAGE_SIZE = 50;
// Visible count per channel is stored in root.chatVisibleCounts so
// changes trigger reactive re-renders of the message list.
const $e7afcf01cffb91a8$var$_getVisible = (root, channelId)=>root.chatVisibleCounts && root.chatVisibleCounts[channelId] || $e7afcf01cffb91a8$var$_PAGE_SIZE;
const $e7afcf01cffb91a8$export$7929958f2754af59 = {
    hide: (el, s)=>!(s && s.root && (s.root.activeTab || 'conversation') === 'conversation'),
    flex: '1 1 0',
    flow: 'y',
    padding: 'B B1 B1 B1',
    gap: 'Z1',
    overflow: 'auto',
    minHeight: '0',
    position: 'relative',
    onCreate: (el, s)=>{
        if (!el || !el.node) return;
        const container = el.node;
        // ── Scroll to bottom on first render ──
        requestAnimationFrame(()=>requestAnimationFrame(()=>{
                if (!container) return;
                container.style.scrollBehavior = 'auto';
                container.scrollTop = container.scrollHeight;
                container.style.scrollBehavior = '';
            }));
        // Delegated bubble-hover → shared ChatHoverActions (mounted at ChatMain
        // level, position: fixed). Keeps actions out of this scroll container.
        (0, $htapf.setupHoverActions)(container);
    },
    onUpdate: (el, s)=>{
        if (!el || !el.node) return;
        const root = s && s.root;
        if (!root) return;
        const channelId = root.activeChannelId || '';
        const map = root.messagesByChannel || {};
        const list = map[channelId] || [];
        const sig = `${channelId}:${list.length}`;
        const channelChanged = el._lastChannel !== channelId;
        const countGrew = sig !== el._lastSig;
        if (!channelChanged && !countGrew) return;
        el._lastSig = sig;
        if (channelChanged) {
            root.update({
                chatVisibleCounts: {
                    ...root.chatVisibleCounts || {},
                    [channelId]: $e7afcf01cffb91a8$var$_PAGE_SIZE
                }
            });
            el._lastChannel = channelId;
        }
        const n = el.node;
        const nearBottom = channelChanged || n.scrollHeight - n.scrollTop - n.clientHeight < 150;
        if (nearBottom) // Double rAF ensures children have rendered before scrolling.
        requestAnimationFrame(()=>requestAnimationFrame(()=>{
                if (!el.node) return;
                el.node.style.scrollBehavior = 'auto';
                el.node.scrollTop = el.node.scrollHeight;
                el.node.style.scrollBehavior = '';
            }));
    },
    Empty: {
        if: (el, s)=>{
            const root = s && s.root;
            if (!root) return true;
            if (!root.activeChannelId) return true;
            const map = root.messagesByChannel || {};
            const list = (map[root.activeChannelId] || []).filter((m)=>!m.threadRoot);
            return list.length === 0;
        },
        flow: 'y',
        align: 'center center',
        flex: '1',
        color: 'caption',
        fontSize: 'A',
        text: (el, s)=>s.root.activeChannelId ? "No messages yet \u2014 say something." : 'Pick a channel from the sidebar.'
    },
    // "Load earlier messages" sentinel — shown when there are more messages
    // than the current visible window. Clicking or scrolling into view
    // expands the window by one page.
    LoadMore: {
        hide: (el, s)=>{
            const root = s && s.root;
            if (!root || !root.activeChannelId) return true;
            const map = root.messagesByChannel || {};
            const all = (map[root.activeChannelId] || []).filter((m)=>!m.threadRoot && (m.body && m.body.trim() || m.attachments && m.attachments.length));
            return all.length <= $e7afcf01cffb91a8$var$_getVisible(root, root.activeChannelId);
        },
        tag: 'button',
        type: 'button',
        attr: {
            'data-load-more': 'true'
        },
        alignSelf: 'center',
        padding: 'Z A',
        round: 'C',
        borderWidth: '1px',
        borderColor: 'line',
        borderStyle: 'solid',
        background: 'overlay',
        color: 'caption',
        cursor: 'pointer',
        fontSize: 'Y2',
        fontWeight: '600',
        marginBottom: 'Z',
        ':hover': {
            background: 'overlayStrong',
            color: 'title'
        },
        text: (el, s)=>{
            const root = s && s.root;
            if (!root) return '';
            const chId = root.activeChannelId;
            const map = root.messagesByChannel || {};
            const total = (map[chId] || []).filter((m)=>!m.threadRoot && (m.body && m.body.trim() || m.attachments && m.attachments.length)).length;
            const visible = $e7afcf01cffb91a8$var$_getVisible(root, chId);
            return `Load ${Math.min($e7afcf01cffb91a8$var$_PAGE_SIZE, total - visible)} earlier messages`;
        },
        onClick: (e, el, s)=>{
            const root = s && s.root;
            if (!root) return;
            const chId = root.activeChannelId;
            const map = root.messagesByChannel || {};
            const total = (map[chId] || []).filter((m)=>!m.threadRoot).length;
            const cur = $e7afcf01cffb91a8$var$_getVisible(root, chId);
            const next = Math.min(cur + $e7afcf01cffb91a8$var$_PAGE_SIZE, total);
            const prevScroll = el.parent?.node?.scrollHeight || 0;
            root.update({
                chatVisibleCounts: {
                    ...root.chatVisibleCounts || {},
                    [chId]: next
                }
            });
            // Preserve scroll position after prepending older messages.
            requestAnimationFrame(()=>{
                const container = el.parent?.node;
                if (container) {
                    const newScroll = container.scrollHeight;
                    container.scrollTop = newScroll - prevScroll;
                }
            });
        }
    },
    Spacer: {
        flex: '1 1 auto'
    },
    List: {
        flow: 'y',
        gap: '0',
        childExtends: 'ChatMessageRow',
        childrenAs: 'state',
        children: (el, s)=>{
            const root = s && s.root;
            if (!root || !root.activeChannelId) return [];
            const map = root.messagesByChannel || {};
            const flat = (map[root.activeChannelId] || []).filter((m)=>!m.threadRoot && (m.body && m.body.trim() || m.attachments && m.attachments.length));
            const filtered = (0, $lwYfR.applyFilters)(flat, root.filters);
            // Paginate: show only the last N messages.
            const visible = $e7afcf01cffb91a8$var$_getVisible(root, root.activeChannelId);
            const paged = filtered.length > visible ? filtered.slice(filtered.length - visible) : filtered;
            return (0, $jg4vi.groupMessages)(paged);
        }
    }
};
const $e7afcf01cffb91a8$var$_isMine = (s)=>!!(s && s.root && s.authorEmail && s.authorEmail === s.root.currentUserEmail);
const $e7afcf01cffb91a8$export$7dc8c500c62e1f50 = {
    flow: 'y',
    gap: '0',
    position: 'relative',
    contentVisibility: 'auto',
    containIntrinsicSize: 'auto 80px',
    marginTop: (el, s)=>s && s._grouped ? 'V' : 'A',
    attr: {
        'data-msg-id': (el, s)=>String(s && s.id || ''),
        'data-mine': (el, s)=>$e7afcf01cffb91a8$var$_isMine(s) ? 'true' : 'false',
        id: (el, s)=>s && s.id ? `msg-${s.id}` : null
    },
    // Day separator pill — only the first message of a new day renders one.
    // The flag is set by groupMessages on the children() preprocessing pass.
    DaySeparator: {
        if: (el, s)=>!!(s && s._newDay),
        flow: 'x',
        align: 'center center',
        gap: 'A',
        padding: 'A B Z B',
        LineL: {
            flex: '1',
            height: '1px',
            background: 'line',
            opacity: '.5'
        },
        Pill: {
            tag: 'span',
            padding: 'V A',
            round: 'F',
            borderWidth: '1px',
            borderColor: 'line',
            borderStyle: 'solid',
            background: 'overlayStrong',
            color: 'caption',
            fontSize: 'Y2',
            fontWeight: '700',
            letterSpacing: '.04em',
            text: (el, s)=>s && s.createdAt ? el.call('dayLabel', s.createdAt) : ''
        },
        LineR: {
            flex: '1',
            height: '1px',
            background: 'line',
            opacity: '.5'
        }
    },
    Row: {
        flow: 'x',
        gap: 'A',
        align: 'flex-start left',
        flexDirection: (el, s)=>$e7afcf01cffb91a8$var$_isMine(s) ? 'row-reverse' : 'row',
        // Show hover-time when the bubble row is hovered.
        onCreate: (el)=>{
            if (!el.node) return;
            const row = el.node.closest('[data-msg-id]') || el.node;
            row.addEventListener('mouseenter', ()=>{
                const time = el.node.querySelector('[data-hover-time]');
                if (time) time.style.opacity = '1';
            });
            row.addEventListener('mouseleave', ()=>{
                const time = el.node.querySelector('[data-hover-time]');
                if (time) time.style.opacity = '0';
            });
        },
        // Tighter top padding for grouped continuation rows so a same-author
        // run reads as one stacked unit instead of separate cards.
        padding: (el, s)=>s && s._grouped ? 'V B 0 B' : 'A B 0 B',
        position: 'relative',
        transition: 'background 120ms ease',
        ':hover': {
            background: 'overlay'
        },
        // Fixed-width avatar gutter — keeps continuation messages perfectly
        // aligned even when the avatar is hidden.
        AvatarSlot: {
            flow: 'y',
            align: 'flex-start center',
            flex: '0 0 auto',
            width: 'C',
            paddingTop: 'V',
            Avatar: {
                if: (el, s)=>!(s && s._grouped),
                avatarType: 'initials',
                boxSize: 'C C',
                round: '50%',
                borderWidth: '1.5px',
                borderColor: 'line',
                borderStyle: 'solid',
                boxShadow: '0 1px 3px var(--color-shadow)',
                cursor: 'pointer',
                attr: {
                    'data-personrow': 'true',
                    'data-email': (el, s)=>s && s.authorEmail || ''
                },
                src: (el, s)=>el.call('avatarUrl', s && el.call('findPerson', s.authorEmail)?.name || s && s.authorEmail)
            }
        },
        Content: {
            flex: '1 1 0',
            flow: 'y',
            gap: 'V',
            minWidth: '0',
            align: (el, s)=>$e7afcf01cffb91a8$var$_isMine(s) ? 'flex-end' : 'flex-start',
            // Author name — only first message of a group.
            Author: {
                if: (el, s)=>!(s && s._grouped),
                tag: 'span',
                fontSize: 'A',
                fontWeight: '700',
                letterSpacing: '-.005em',
                color: 'title',
                marginBottom: 'V',
                text: (el, s)=>{
                    const p = s && el.call('findPerson', s.authorEmail);
                    return p && p.name || s && s.authorEmail || 'unknown';
                }
            },
            // Body + hover-time row — time appears next to the bubble on hover.
            BodyRow: {
                hide: (el, s)=>!(s && s.body),
                flow: 'x',
                gap: 'Z',
                align: 'center',
                flexDirection: (el, s)=>$e7afcf01cffb91a8$var$_isMine(s) ? 'row-reverse' : 'row',
                Body: {
                    tag: 'div',
                    maxWidth: 'I',
                    padding: 'Z1 A',
                    // Stacked bubbles get tighter corners on the connecting edge.
                    // First message: large top corners, small bottom-tail corner.
                    // Middle (grouped): small all around.
                    // The _grouped flag from groupMessages drives this.
                    round: (el, s)=>{
                        const mine = $e7afcf01cffb91a8$var$_isMine(s);
                        if (s && s._grouped) // Continuation bubble — tight corners on the stacking side.
                        return mine ? 'Z A1 Z A1' : 'A1 Z A1 Z';
                        // First in group — standard asymmetric tail.
                        return mine ? 'A1 A1 Z A1' : 'A1 A1 A1 Z';
                    },
                    background: (el, s)=>$e7afcf01cffb91a8$var$_isMine(s) ? 'blue.12' : 'white.08',
                    color: 'title',
                    fontSize: 'Z2',
                    lineHeight: '1.5',
                    wordBreak: 'break-word',
                    opacity: (el, s)=>s && s._optimistic ? '0.55' : '1',
                    onCreate: (el, s)=>(0, $5WCCa.renderMarkdown)(el, s && s.body, null, s && s.root && s.root.people, s && s.root && s.root.channels),
                    onUpdate: (el, s)=>(0, $5WCCa.renderMarkdown)(el, s && s.body, null, s && s.root && s.root.people, s && s.root && s.root.channels)
                },
                Time: {
                    tag: 'span',
                    fontSize: 'Y2',
                    color: 'caption',
                    opacity: '0',
                    transition: 'opacity 120ms ease',
                    whiteSpace: 'nowrap',
                    attr: {
                        'data-hover-time': 'true'
                    },
                    text: (el, s)=>s && s.createdAt ? el.call('clockTime', s.createdAt) : ''
                }
            },
            // Reaction pills below the bubble.
            Reactions: {
                flow: 'x wrap',
                gap: 'V',
                display: (el, s)=>{
                    const r = s && s.reactions;
                    return r && Object.keys(r).length > 0 ? 'flex' : 'none';
                },
                flexDirection: (el, s)=>$e7afcf01cffb91a8$var$_isMine(s) ? 'row-reverse' : 'row',
                childExtends: 'ChatReactionPill',
                childrenAs: 'state',
                children: (el, s)=>{
                    const r = s && s.reactions;
                    if (!r) return [];
                    return Object.entries(r).map(([emoji, users])=>({
                            emoji: emoji,
                            users: users,
                            count: users.length,
                            isMine: users.includes(s.root?.currentUserEmail),
                            msgId: s.id
                        }));
                }
            },
            // Attachments grid: images render as thumbnails, others as file chips.
            Attachments: {
                flow: 'x wrap',
                gap: 'Z',
                if: (el, s)=>!!(s && s.attachments && s.attachments.length),
                childExtends: 'ChatAttachmentRender',
                childrenAs: 'state',
                children: (el, s)=>s.attachments
            },
            // Thread reply count chip — styled as a clickable inline pill that
            // sits flush under the message body, matching Slack's inline thread
            // affordance.
            ThreadLink: {
                hide: (el, s)=>!(s && parseInt(s.threadCount, 10) > 0),
                tag: 'button',
                type: 'button',
                flow: 'x',
                align: 'center left',
                gap: 'Y',
                padding: 'V Z1',
                round: 'C',
                border: 'none',
                background: 'blue.1',
                color: 'blue',
                cursor: 'pointer',
                fontSize: 'Y2',
                fontWeight: '600',
                alignSelf: (el, s)=>$e7afcf01cffb91a8$var$_isMine(s) ? 'flex-end' : 'flex-start',
                marginTop: 'V',
                ':hover': {
                    background: 'blue.2'
                },
                transition: 'background 120ms ease',
                attr: {
                    'data-thread-open': (el, s)=>String(s && s.id || '')
                },
                ThreadIcon: {
                    extends: 'Icon',
                    icon: 'chat',
                    boxSize: 'Z'
                },
                Text: {
                    tag: 'span',
                    text: (el, s)=>{
                        const n = s && parseInt(s.threadCount, 10) || 0;
                        return `${n} repl${n === 1 ? 'y' : 'ies'}`;
                    }
                }
            }
        },
        // Small avatars of members who have read up to this message.
        SeenAvatars: {
            flow: 'x',
            gap: 'V',
            padding: '0 0 0 D1',
            hide: (el, s)=>{
                if (!s?.id || !s?.root) return true;
                const cid = s.root.activeChannelId;
                const members = (s.root.channelMembers || []).filter((m)=>m.channel_id === cid && m.member_email !== s.root.currentUserEmail);
                // Find members whose last_read_at falls on or after this message
                const msgTime = s.createdAt ? new Date(s.createdAt).getTime() : 0;
                if (!msgTime) return true;
                // Get all messages in channel to find the next message
                const msgs = (s.root.messagesByChannel?.[cid] || []).filter((m)=>!m.threadRoot);
                const idx = msgs.findIndex((m)=>m.id === s.id);
                const nextTime = idx >= 0 && idx < msgs.length - 1 ? new Date(msgs[idx + 1].createdAt).getTime() : Infinity;
                const seenBy = members.filter((m)=>{
                    const readAt = m.last_read_at ? new Date(m.last_read_at).getTime() : 0;
                    return readAt >= msgTime && readAt < nextTime;
                });
                return seenBy.length === 0;
            },
            childExtends: {
                avatarType: 'initials',
                boxSize: 'Z2',
                round: '50%',
                title: (el, s)=>s._seenName || '',
                src: (el, s)=>el.call('avatarUrl', s._seenName)
            },
            childrenAs: 'state',
            children: (el, s)=>{
                if (!s?.id || !s?.root) return [];
                const cid = s.root.activeChannelId;
                const members = (s.root.channelMembers || []).filter((m)=>m.channel_id === cid && m.member_email !== s.root.currentUserEmail);
                const msgTime = s.createdAt ? new Date(s.createdAt).getTime() : 0;
                if (!msgTime) return [];
                const msgs = (s.root.messagesByChannel?.[cid] || []).filter((m)=>!m.threadRoot);
                const idx = msgs.findIndex((m)=>m.id === s.id);
                const nextTime = idx >= 0 && idx < msgs.length - 1 ? new Date(msgs[idx + 1].createdAt).getTime() : Infinity;
                const people = s.root.people || [];
                return members.filter((m)=>{
                    const readAt = m.last_read_at ? new Date(m.last_read_at).getTime() : 0;
                    return readAt >= msgTime && readAt < nextTime;
                }).map((m)=>{
                    const person = people.find((p)=>p.email === m.member_email);
                    return {
                        _seenName: person?.name || m.member_email
                    };
                });
            }
        }
    }
};
// Helper: is this a media type that can be previewed in a lightbox?
const $e7afcf01cffb91a8$var$_isMedia = (mime)=>mime && (mime.startsWith('image/') || mime.startsWith('video/'));
const $e7afcf01cffb91a8$export$862e4c513906162f = {
    tag: 'button',
    type: 'button',
    flow: 'x',
    align: 'center center',
    gap: 'V',
    padding: 'V Z',
    round: 'B',
    cursor: 'pointer',
    fontSize: 'Y2',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: (el, s)=>s && s.isMine ? 'blue.4' : 'line',
    background: (el, s)=>s && s.isMine ? 'blue.08' : 'transparent',
    color: 'title',
    ':hover': {
        background: 'overlay'
    },
    transition: 'background 100ms ease',
    Emoji: {
        tag: 'span',
        text: (el, s)=>s.emoji
    },
    Count: {
        tag: 'span',
        fontSize: 'Y1',
        fontWeight: '600',
        color: (el, s)=>s && s.isMine ? 'blue' : 'caption',
        text: (el, s)=>String(s.count || 0)
    },
    onClick: (e, el, s)=>{
        e.stopPropagation();
        if (!s || !s.msgId) return;
        el.call('toggleReaction', s.msgId, s.emoji);
    }
};
const $e7afcf01cffb91a8$export$e0cc898e68e345aa = {
    tag: 'button',
    align: 'center center',
    width: 'B',
    height: 'B',
    round: 'Z',
    background: 'transparent',
    borderWidth: '0',
    fontSize: 'A',
    cursor: 'pointer',
    text: (el, s)=>s.emoji,
    ':hover': {
        background: 'overlay'
    },
    onClick: (ev, el, s)=>{
        ev.preventDefault();
        ev.stopPropagation();
        const msgId = $e7afcf01cffb91a8$var$_activeMsgId(el);
        if (!msgId || !s?.emoji) return;
        el.call('toggleReaction', msgId, s.emoji);
        const popover = el.node.closest('[data-arp-popover]');
        if (popover) {
            popover.style.opacity = '0';
            popover.style.pointerEvents = 'none';
        }
    }
};
const $e7afcf01cffb91a8$export$95cef358fd3c8eb7 = {
    round: 'Z',
    overflow: 'hidden',
    maxWidth: 'I',
    cursor: 'pointer',
    transition: 'opacity 120ms ease',
    ':hover': {
        opacity: '.85'
    },
    onClick: (e, el, s)=>{
        if (!s || !s.url) return;
        if ($e7afcf01cffb91a8$var$_isMedia(s.mime)) s.root.update({
            lightbox: {
                url: s.url,
                mime: s.mime,
                name: s.name
            }
        });
        else window.open(s.url, '_blank');
    },
    // Image thumbnail
    ImageThumb: {
        tag: 'img',
        width: '100%',
        maxHeight: 'G',
        round: 'Z',
        objectFit: 'cover',
        hide: (el, s)=>!(s && s.mime && s.mime.startsWith('image/')),
        src: (el, s)=>s.url,
        alt: (el, s)=>s.name || 'image'
    },
    // Video thumbnail
    VideoThumb: {
        tag: 'video',
        width: '100%',
        maxHeight: 'G',
        round: 'Z',
        objectFit: 'cover',
        hide: (el, s)=>!(s && s.mime && s.mime.startsWith('video/')),
        src: (el, s)=>s.url,
        preload: 'metadata'
    },
    // Non-media file chip
    FileChip: {
        hide: (el, s)=>!!(s && $e7afcf01cffb91a8$var$_isMedia(s.mime)),
        flow: 'x',
        align: 'center left',
        gap: 'V',
        padding: 'V Z',
        borderWidth: '1px',
        borderColor: 'line',
        borderStyle: 'solid',
        background: 'document',
        ':hover': {
            background: 'overlay'
        },
        Icon: {
            tag: 'span',
            fontSize: 'A',
            text: (el, s)=>{
                if (!s) return "\uD83D\uDCC4";
                const m = s.mime || '';
                if (m.includes('pdf')) return "\uD83D\uDCD5";
                if (m.includes('zip') || m.includes('archive')) return "\uD83D\uDDDC";
                return "\uD83D\uDCC4";
            }
        },
        Info: {
            flow: 'y',
            gap: 'V',
            minWidth: '0',
            Name: {
                tag: 'span',
                fontSize: 'Y2',
                color: 'title',
                fontWeight: '600',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                text: (el, s)=>s && s.name || ''
            },
            Size: {
                tag: 'span',
                fontSize: 'Y2',
                color: 'caption',
                text: (el, s)=>el.call('formatBytes', s && s.size)
            }
        }
    }
};
const $e7afcf01cffb91a8$var$_ARP_EMOJIS = [
    "\uD83D\uDC4D",
    "\u2764\uFE0F",
    "\uD83C\uDF89",
    "\uD83D\uDE80",
    "\uD83D\uDD25",
    "\uD83D\uDC4F",
    "\uD83D\uDC40",
    "\uD83D\uDE02",
    "\uD83D\uDE0D",
    "\uD83E\uDD14",
    "\uD83D\uDE2E",
    "\uD83D\uDE22",
    "\uD83D\uDE21",
    "\u2705",
    "\u274C",
    "\uD83D\uDCAF",
    "\uD83D\uDE4F",
    "\uD83D\uDCAA",
    "\uD83E\uDEE1",
    "\uD83E\uDD1D",
    "\uD83D\uDC4B",
    "\uD83C\uDFAF",
    "\uD83D\uDCA1",
    "\u2B50"
];
const $e7afcf01cffb91a8$var$_QUICK_REACTS = [
    '\uD83D\uDC4D',
    '\u2764\uFE0F',
    '\uD83D\uDE02',
    '\uD83D\uDC40'
];
const $e7afcf01cffb91a8$var$_activeMsgId = (el)=>{
    const v = el.node.closest('[data-hover-actions]')?.getAttribute('data-active-msg');
    const id = v ? parseInt(v, 10) : NaN;
    return Number.isFinite(id) ? id : null;
};
const $e7afcf01cffb91a8$var$_closeParentPopover = (el)=>$e7afcf01cffb91a8$var$_togglePopover(el.node.closest('[data-ha-popover]'), false);
const $e7afcf01cffb91a8$var$_togglePopover = (node, open)=>{
    if (!node) return;
    const isOpen = open ?? node.style.opacity !== '1';
    node.style.opacity = isOpen ? '1' : '0';
    node.style.pointerEvents = isOpen ? 'auto' : 'none';
    if (isOpen) requestAnimationFrame(()=>{
        const rect = node.getBoundingClientRect();
        if (rect.right > window.innerWidth) {
            node.style.left = 'auto';
            node.style.right = '0';
        }
        if (rect.bottom > window.innerHeight) {
            node.style.top = 'auto';
            node.style.bottom = '100%';
        }
    });
};
const $e7afcf01cffb91a8$var$_getMsgBody = (msgId, root)=>{
    const list = (root?.messagesByChannel || {})[root?.activeChannelId] || [];
    return list.find((m)=>m.id === msgId)?.body || '';
};
const $e7afcf01cffb91a8$var$_titleFromBody = (body, fallback)=>(body.split('\n')[0] || fallback).slice(0, 120);
// Gather ±10 messages around the target for thread context.
const $e7afcf01cffb91a8$var$_getChatContext = (msgId, root)=>{
    const list = (root?.messagesByChannel || {})[root?.activeChannelId] || [];
    const idx = list.findIndex((m)=>m.id === msgId);
    if (idx === -1) return '';
    const start = Math.max(0, idx - 10);
    const end = Math.min(list.length, idx + 11);
    return list.slice(start, end).map((m)=>{
        const person = (root.people || []).find((p)=>p.email === m.authorEmail);
        const name = person?.name || m.authorEmail || 'unknown';
        const marker = m.id === msgId ? ' [THIS MESSAGE]' : '';
        return `${name}${marker}: ${(m.body || '').trim()}`;
    }).join('\n');
};
// AI-prefill: sends chat context to AI to generate structured ticket/note fields.
const $e7afcf01cffb91a8$var$_aiPrefill = async (root, msgId, type, el)=>{
    const context = $e7afcf01cffb91a8$var$_getChatContext(msgId, root);
    const body = $e7afcf01cffb91a8$var$_getMsgBody(msgId, root);
    const today = new Date().toISOString().slice(0, 10);
    const prompts = {
        ticket: `Based on this chat conversation, create a ticket. Extract: title (short), body (description), priority (low/medium/high/urgent/critical), issueType (bug/feature/user-story/subtask), acceptanceCriteria, stepsToReproduce (if bug). For dueDate only use today's date ${today} if explicitly mentioned. Return ONLY valid JSON.`,
        note: `Based on this chat conversation, create a note. Extract: title (short summary), content (key points from the discussion). Return ONLY valid JSON with {title, content}.`,
        kb: `Based on this chat conversation, create a knowledge base article. Extract: title (topic), content (structured explanation of the topic discussed). Return ONLY valid JSON with {title, content}.`,
        event: `Based on this chat conversation, create a calendar event. Extract: title (meeting/event name), description (agenda/context). For dates only use today ${today}. Return ONLY valid JSON with {title, description}.`
    };
    try {
        // Routes through the workspace wrapper's /ai/chat endpoint via the
        // SDK entity dispatcher. The wrapper buffers the upstream SSE stream
        // and returns the aggregated text; streaming UX is intentionally lost
        // here in exchange for unified auth + tenant scoping.
        const result = await (0, $bfqVY.getSDK)().execute('workspaceProject.aiChat', 'rpc', {
            messages: [
                {
                    role: 'system',
                    content: prompts[type] || prompts.ticket
                },
                {
                    role: 'user',
                    content: `Chat thread:\n${context}\n\nTarget message: ${body}`
                }
            ]
        });
        const full = result?.text || result?.data?.text || '';
        if (!full) return null;
        const m = full.match(/\{[\s\S]*\}/);
        if (!m) return null;
        // AI may append text after JSON — try parsing, then truncate on failure
        try {
            return JSON.parse(m[0]);
        } catch  {
            // Find balanced braces
            let depth = 0, end = 0;
            for(let i = 0; i < m[0].length; i++){
                if (m[0][i] === '{') depth++;
                if (m[0][i] === '}') {
                    depth--;
                    if (depth === 0) {
                        end = i + 1;
                        break;
                    }
                }
            }
            try {
                return JSON.parse(m[0].slice(0, end));
            } catch  {
                return null;
            }
        }
    } catch (err) {
        console.error('[_aiPrefill]', err);
        return null;
    }
};
const $e7afcf01cffb91a8$export$94495b079485a912 = {
    attr: {
        'data-hover-actions': 'true'
    },
    position: 'fixed',
    top: '0',
    left: '0',
    flow: 'x',
    padding: 'V',
    round: 'Z',
    background: 'overlayStrong',
    backdropFilter: 'blur(8px)',
    borderWidth: '1px',
    borderColor: 'line',
    borderStyle: 'solid',
    zIndex: '100',
    boxShadow: '0 4px 12px var(--color-shadow)',
    opacity: '0',
    pointerEvents: 'none',
    transition: 'opacity 120ms ease',
    fontSize: 'Z1',
    onCreate: (el)=>{
        if (!el || !el.node) return;
        const node = el.node;
        node.addEventListener('mouseenter', ()=>{
            node.setAttribute('data-hover-lock', 'true');
            node.style.opacity = '1';
            node.style.pointerEvents = 'auto';
        });
        node.addEventListener('mouseleave', ()=>{
            node.removeAttribute('data-hover-lock');
            node.style.opacity = '0';
            node.style.pointerEvents = 'none';
            // Close any open sub-popovers on leave.
            node.querySelectorAll('[data-ha-popover]').forEach((p)=>$e7afcf01cffb91a8$var$_togglePopover(p, false));
        });
    },
    // Quick reactions (outside).
    QuickReacts: {
        flow: 'x',
        childExtends: 'ChatHoverQuickReact',
        childrenAs: 'state',
        children: ()=>$e7afcf01cffb91a8$var$_QUICK_REACTS.map((emoji)=>({
                    emoji: emoji
                }))
    },
    MoreReactBtn: {
        extends: 'ChatHoverIconBtn',
        position: 'relative',
        title: 'More reactions',
        aria: {
            label: 'More reactions'
        },
        Icon: {
            icon: 'add',
            boxSize: 'A',
            pointerEvents: 'none'
        },
        onClick: (e, el)=>{
            e.stopPropagation();
            $e7afcf01cffb91a8$var$_togglePopover(el.node.querySelector('[data-ha-popover="emoji"]'));
        },
        ArpPopover: {
            flow: 'y',
            gap: 'Z1',
            position: 'absolute',
            top: '100%',
            left: '0',
            zIndex: '200',
            width: 'G',
            maxWidth: '90vw',
            maxHeight: '50vh',
            overflow: 'auto',
            padding: 'Z1',
            round: 'Z',
            background: 'overlayStrong',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'line',
            boxShadow: '0 4px 12px var(--color-shadow)',
            opacity: '0',
            pointerEvents: 'none',
            transition: 'opacity 120ms ease',
            attr: {
                'data-ha-popover': 'emoji'
            },
            EmojiGrid: {
                display: 'grid',
                gridTemplateColumns: 'repeat(8, 1fr)',
                gap: 'V',
                childExtends: 'ChatReactionEmoji',
                childrenAs: 'state',
                children: ()=>$e7afcf01cffb91a8$var$_ARP_EMOJIS.map((emoji)=>({
                            emoji: emoji
                        }))
            }
        }
    },
    Divider_1: {
        extends: 'ChatHoverDivider'
    },
    ThreadBtn: {
        extends: 'ChatHoverIconBtn',
        title: 'Reply in thread',
        aria: {
            label: 'Reply in thread'
        },
        Icon: {
            icon: 'chat',
            boxSize: 'A',
            pointerEvents: 'none'
        },
        onClick: (e, el, s)=>{
            e.stopPropagation();
            const msgId = $e7afcf01cffb91a8$var$_activeMsgId(el);
            const root = s?.root;
            if (!msgId || !root) return;
            root.update({
                activeThreadRootId: msgId
            });
        }
    },
    ReplyBtn: {
        extends: 'ChatHoverIconBtn',
        title: 'Reply',
        aria: {
            label: 'Reply'
        },
        Icon: {
            icon: 'reply',
            boxSize: 'A',
            pointerEvents: 'none'
        },
        onClick: (e, el, s)=>{
            e.stopPropagation();
            const msgId = $e7afcf01cffb91a8$var$_activeMsgId(el);
            const root = s?.root;
            if (!msgId || !root) return;
            root.update({
                composerReplyToMsgId: msgId
            });
            const composer = document.querySelector('[data-key="ChannelColumn"] [data-key="Footer"] [data-key="Editor"], [data-key="ChannelColumn"] [data-key="Footer"] [contenteditable="true"], [data-key="ChannelColumn"] [data-key="Footer"] textarea');
            composer?.focus();
        }
    },
    Divider_2: {
        extends: 'ChatHoverDivider'
    },
    MoreMenuBtn: {
        extends: 'ChatHoverIconBtn',
        position: 'relative',
        title: 'More actions',
        aria: {
            label: 'More actions'
        },
        Icon: {
            icon: 'more',
            boxSize: 'A',
            pointerEvents: 'none'
        },
        onClick: (e, el)=>{
            e.stopPropagation();
            $e7afcf01cffb91a8$var$_togglePopover(el.node.querySelector('[data-ha-popover="menu"]'));
        },
        MenuPopover: {
            flow: 'y',
            gap: '0',
            position: 'absolute',
            top: '100%',
            right: '0',
            zIndex: '200',
            minWidth: 'F',
            padding: 'V',
            round: 'Z',
            background: 'overlayStrong',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'line',
            boxShadow: '0 4px 12px var(--color-shadow)',
            opacity: '0',
            pointerEvents: 'none',
            transition: 'opacity 120ms ease',
            attr: {
                'data-ha-popover': 'menu'
            },
            CreateTicket: {
                extends: 'ChatHoverMenuItem',
                Icon: {
                    icon: 'checkmark'
                },
                Label: {
                    text: 'Create ticket'
                },
                onClick: async (e, el, s)=>{
                    e.stopPropagation();
                    const msgId = $e7afcf01cffb91a8$var$_activeMsgId(el);
                    const root = s?.root;
                    if (!msgId || !root) return;
                    const body = $e7afcf01cffb91a8$var$_getMsgBody(msgId, root);
                    $e7afcf01cffb91a8$var$_closeParentPopover(el);
                    // Open modal immediately with basic content + loading indicator
                    root.update({
                        selectedTicket: {
                            _new: true
                        },
                        ticketDraft: el.call('freshTicket', {
                            title: $e7afcf01cffb91a8$var$_titleFromBody(body, ''),
                            body: body
                        }),
                        ticketEditMode: true,
                        _aiTicketLoading: true
                    });
                    // AI-prefill from chat context in background
                    const ai = await $e7afcf01cffb91a8$var$_aiPrefill(root, msgId, 'ticket', el);
                    if (ai) {
                        const draft = root.ticketDraft || {};
                        root.update({
                            ticketDraft: {
                                ...draft,
                                ...ai
                            }
                        });
                    }
                    root.update({
                        _aiTicketLoading: false
                    });
                }
            },
            CreateEvent: {
                extends: 'ChatHoverMenuItem',
                Icon: {
                    icon: 'date'
                },
                Label: {
                    text: 'Create event'
                },
                onClick: async (e, el, s)=>{
                    e.stopPropagation();
                    const msgId = $e7afcf01cffb91a8$var$_activeMsgId(el);
                    const root = s?.root;
                    if (!msgId || !root) return;
                    const body = $e7afcf01cffb91a8$var$_getMsgBody(msgId, root);
                    $e7afcf01cffb91a8$var$_closeParentPopover(el);
                    const ai = await $e7afcf01cffb91a8$var$_aiPrefill(root, msgId, 'event', el);
                    el.call('saveEventToSupabase', {
                        title: ai?.title || $e7afcf01cffb91a8$var$_titleFromBody(body, 'Untitled event'),
                        description: ai?.description || body,
                        start_time: new Date().toISOString(),
                        end_time: new Date(Date.now() + 3600000).toISOString(),
                        type: 'meeting',
                        author: root.currentUserEmail
                    });
                }
            },
            CreateNote: {
                extends: 'ChatHoverMenuItem',
                Icon: {
                    icon: 'document'
                },
                Label: {
                    text: 'Create note'
                },
                onClick: async (e, el, s)=>{
                    e.stopPropagation();
                    const msgId = $e7afcf01cffb91a8$var$_activeMsgId(el);
                    const root = s?.root;
                    if (!msgId || !root) return;
                    const body = $e7afcf01cffb91a8$var$_getMsgBody(msgId, root);
                    $e7afcf01cffb91a8$var$_closeParentPopover(el);
                    const ai = await $e7afcf01cffb91a8$var$_aiPrefill(root, msgId, 'note', el);
                    el.call('createNote', {
                        title: ai?.title || $e7afcf01cffb91a8$var$_titleFromBody(body, 'Untitled note'),
                        content: ai?.content || body,
                        tags: [
                            'chat'
                        ]
                    });
                }
            },
            CreateKB: {
                extends: 'ChatHoverMenuItem',
                Icon: {
                    icon: 'star'
                },
                Label: {
                    text: 'Create knowledge base'
                },
                onClick: async (e, el, s)=>{
                    e.stopPropagation();
                    const msgId = $e7afcf01cffb91a8$var$_activeMsgId(el);
                    const root = s?.root;
                    if (!msgId || !root) return;
                    const body = $e7afcf01cffb91a8$var$_getMsgBody(msgId, root);
                    $e7afcf01cffb91a8$var$_closeParentPopover(el);
                    const ai = await $e7afcf01cffb91a8$var$_aiPrefill(root, msgId, 'kb', el);
                    el.call('createKnowledgeArticle', {
                        title: ai?.title || $e7afcf01cffb91a8$var$_titleFromBody(body, 'Untitled article'),
                        content: ai?.content || body
                    });
                }
            },
            Bookmark: {
                extends: 'ChatHoverMenuItem',
                Icon: {
                    icon: 'bookmark'
                },
                Label: {
                    text: 'Bookmark'
                },
                onClick: (e, el, s)=>{
                    e.stopPropagation();
                    const msgId = $e7afcf01cffb91a8$var$_activeMsgId(el);
                    if (!msgId || !s?.root) return;
                    el.call('toggleChatBookmark', msgId);
                    $e7afcf01cffb91a8$var$_closeParentPopover(el);
                }
            },
            Pin: {
                extends: 'ChatHoverMenuItem',
                Icon: {
                    icon: 'pin'
                },
                Label: {
                    text: 'Pin'
                },
                onClick: (e, el, s)=>{
                    e.stopPropagation();
                    const msgId = $e7afcf01cffb91a8$var$_activeMsgId(el);
                    if (!msgId || !s?.root) return;
                    el.call('toggleChatPin', msgId);
                    $e7afcf01cffb91a8$var$_closeParentPopover(el);
                }
            },
            CopyURL: {
                extends: 'ChatHoverMenuItem',
                Icon: {
                    icon: 'link'
                },
                Label: {
                    text: 'Copy URL'
                },
                onClick: (e, el)=>{
                    e.stopPropagation();
                    const msgId = $e7afcf01cffb91a8$var$_activeMsgId(el);
                    if (!msgId) return;
                    navigator.clipboard?.writeText(`${window.location.origin}${window.location.pathname}#msg-${msgId}`);
                    $e7afcf01cffb91a8$var$_closeParentPopover(el);
                }
            },
            Forward: {
                extends: 'ChatHoverMenuItem',
                Icon: {
                    icon: 'arrowRight'
                },
                Label: {
                    text: 'Forward'
                },
                onClick: (e, el, s)=>{
                    e.stopPropagation();
                    const msgId = $e7afcf01cffb91a8$var$_activeMsgId(el);
                    const root = s?.root;
                    if (!msgId || !root) return;
                    navigator.clipboard?.writeText($e7afcf01cffb91a8$var$_getMsgBody(msgId, root));
                    $e7afcf01cffb91a8$var$_closeParentPopover(el);
                }
            }
        }
    }
};
const $e7afcf01cffb91a8$export$3017a3477d88be04 = {
    tag: 'button',
    type: 'button',
    flow: 'x',
    align: 'center center',
    padding: 'Z Z1',
    round: 'V',
    border: 'none',
    background: 'transparent',
    color: 'subtitle',
    cursor: 'pointer',
    ':hover': {
        background: 'line',
        color: 'title'
    },
    transition: 'background 100ms ease'
};
const $e7afcf01cffb91a8$export$bd07e541b2244e8 = {
    extends: 'ChatHoverIconBtn',
    padding: 'Z',
    fontSize: 'Z',
    lineHeight: '1',
    text: (el, s)=>s.emoji,
    ':hover': {
        background: 'line',
        transform: 'scale(1.2)'
    },
    transition: 'transform 100ms ease',
    onClick: (e, el, s)=>{
        e.stopPropagation();
        const msgId = $e7afcf01cffb91a8$var$_activeMsgId(el);
        if (msgId && s?.emoji) el.call('toggleReaction', msgId, s.emoji);
    }
};
const $e7afcf01cffb91a8$export$d77fd82e5147ff4f = {
    width: '1px',
    height: 'A',
    background: 'line',
    alignSelf: 'center',
    margin: '0 Y'
};
const $e7afcf01cffb91a8$export$3a4cc3d9be110717 = {
    tag: 'button',
    type: 'button',
    flow: 'x',
    align: 'center left',
    gap: 'Z',
    padding: 'Z A',
    round: 'V',
    border: 'none',
    background: 'transparent',
    color: 'title',
    cursor: 'pointer',
    fontSize: 'Z2',
    textAlign: 'left',
    width: '100%',
    ':hover': {
        background: 'line'
    },
    transition: 'background 100ms ease',
    Icon: {
        boxSize: 'A',
        flex: '0 0 auto',
        pointerEvents: 'none'
    },
    Label: {
        tag: 'span',
        flex: '1 1 auto'
    }
};

});
parcelRegister("lwYfR", function(module, exports) {

$parcel$export(module.exports, "applyFilters", () => $facb537e432d9713$export$47150c42ed89d097);
$parcel$export(module.exports, "collectAttachments", () => $facb537e432d9713$export$fc9a9d4507c41a3e);
$parcel$export(module.exports, "collectLinks", () => $facb537e432d9713$export$f6afacae993e0c8f);
$parcel$export(module.exports, "collectTickets", () => $facb537e432d9713$export$a944a8bd32d089ba);
$parcel$export(module.exports, "collectAuthors", () => $facb537e432d9713$export$4fa3a39962f56eed);
// Pure helpers for the Files / Links / Tickets tab views and the
// conversation filter bar. Operate on the in-memory `messagesByChannel`
// bucket — no Supabase calls.
//
// Each `collect*` result is cached against the input array reference via
// a WeakMap so the same channel's scans run at most once per render
// cycle. The Files / Links / Tickets tab views each call their collector
// twice per render (Empty.if + children) — without this cache that's
// 6 full passes over the channel's message list per reactive update.
const $facb537e432d9713$var$_LINK_RE = /(https?:\/\/[^\s<>"`)\]]+)/g;
const $facb537e432d9713$var$_TICKET_RE = /#([A-Z][A-Z0-9_-]{1,15}-\d+)/g;
const $facb537e432d9713$var$_MENTION_RE = /@[a-zA-Z0-9._-]+/;
const $facb537e432d9713$var$_attachmentsCache = new WeakMap();
const $facb537e432d9713$var$_linksCache = new WeakMap();
const $facb537e432d9713$var$_ticketsCache = new WeakMap();
const $facb537e432d9713$var$_authorsCache = new WeakMap();
const $facb537e432d9713$var$_EMPTY = Object.freeze([]);
const $facb537e432d9713$export$47150c42ed89d097 = (messages, filters)=>{
    if (!filters) return messages || [];
    const q = (filters.query || '').trim().toLowerCase();
    return (messages || []).filter((m)=>{
        if (filters.authorEmail && m.authorEmail !== filters.authorEmail) return false;
        if (filters.hasAttachments && !(m.attachments && m.attachments.length)) return false;
        if (filters.hasMentions && !$facb537e432d9713$var$_MENTION_RE.test(m.body || '')) return false;
        if (q && !(m.body || '').toLowerCase().includes(q)) return false;
        return true;
    });
};
const $facb537e432d9713$export$fc9a9d4507c41a3e = (messages)=>{
    if (!messages || !messages.length) return $facb537e432d9713$var$_EMPTY;
    const cached = $facb537e432d9713$var$_attachmentsCache.get(messages);
    if (cached) return cached;
    const out = [];
    for (const m of messages){
        if (!m.attachments || !m.attachments.length) continue;
        for (const a of m.attachments)out.push({
            ...a,
            messageId: m.id,
            authorEmail: m.authorEmail,
            createdAt: m.createdAt
        });
    }
    $facb537e432d9713$var$_attachmentsCache.set(messages, out);
    return out;
};
const $facb537e432d9713$export$f6afacae993e0c8f = (messages)=>{
    if (!messages || !messages.length) return $facb537e432d9713$var$_EMPTY;
    const cached = $facb537e432d9713$var$_linksCache.get(messages);
    if (cached) return cached;
    const seen = new Map();
    for (const m of messages){
        if (!m.body) continue;
        $facb537e432d9713$var$_LINK_RE.lastIndex = 0;
        let match;
        while((match = $facb537e432d9713$var$_LINK_RE.exec(m.body)) !== null){
            const url = match[1];
            const prev = seen.get(url);
            if (!prev || new Date(m.createdAt) > new Date(prev.createdAt)) seen.set(url, {
                url: url,
                messageId: m.id,
                authorEmail: m.authorEmail,
                createdAt: m.createdAt,
                body: m.body
            });
        }
    }
    const out = [
        ...seen.values()
    ].sort((a, b)=>new Date(b.createdAt) - new Date(a.createdAt));
    $facb537e432d9713$var$_linksCache.set(messages, out);
    return out;
};
const $facb537e432d9713$export$a944a8bd32d089ba = (messages)=>{
    if (!messages || !messages.length) return $facb537e432d9713$var$_EMPTY;
    const cached = $facb537e432d9713$var$_ticketsCache.get(messages);
    if (cached) return cached;
    const out = [];
    for (const m of messages){
        if (!m.body) continue;
        $facb537e432d9713$var$_TICKET_RE.lastIndex = 0;
        let match;
        while((match = $facb537e432d9713$var$_TICKET_RE.exec(m.body)) !== null)out.push({
            ref: match[1],
            messageId: m.id,
            authorEmail: m.authorEmail,
            createdAt: m.createdAt,
            body: m.body
        });
    }
    out.sort((a, b)=>new Date(b.createdAt) - new Date(a.createdAt));
    $facb537e432d9713$var$_ticketsCache.set(messages, out);
    return out;
};
const $facb537e432d9713$export$4fa3a39962f56eed = (messages)=>{
    if (!messages || !messages.length) return $facb537e432d9713$var$_EMPTY;
    const cached = $facb537e432d9713$var$_authorsCache.get(messages);
    if (cached) return cached;
    const seen = new Set();
    const out = [];
    for (const m of messages){
        if (!m.authorEmail || seen.has(m.authorEmail)) continue;
        seen.add(m.authorEmail);
        out.push(m.authorEmail);
    }
    $facb537e432d9713$var$_authorsCache.set(messages, out);
    return out;
};

});

parcelRegister("5WCCa", function(module, exports) {

$parcel$export(module.exports, "MARKDOWN_COMPONENTS", () => $45405298edf226e2$export$fbdb5cc005ccb507);
$parcel$export(module.exports, "renderMarkdown", () => $45405298edf226e2$export$bd27f0c8b4b4eabc);
// Single source for the markdown → DOMQL tree handoff.
//
// @deprecated — use the MarkdownPreview component or applyMarkdownToElement
// from shared/components/MarkdownPreview.js directly. This shim delegates to
// that implementation and is kept for back-compat with consumers that call
// renderMarkdown() imperatively. Do not add new callers here.
//
// Legacy chat surfaces (MessageList, ThreadPanel, TicketDetailModal) continue
// to work unchanged because the shim forwards withMentions:true and
// demoteHeadings:false — matching the original behaviour. Workspace surfaces
// that need heading demotion should call applyMarkdownToElement directly with
// demoteHeadings:true, or mount a MarkdownPreview component.

var $8f98e = parcelRequire("8f98e");
const $45405298edf226e2$export$fbdb5cc005ccb507 = {
    h1: 'H1',
    h2: 'H2',
    h3: 'H3',
    h4: 'H4',
    h5: 'H5',
    h6: 'H6',
    paragraph: 'P',
    pre: 'ChatCode',
    code: 'ChatInlineCode',
    codeBlock: 'ChatCode',
    blockquote: 'Blockquote',
    ul: 'ChatUL',
    ol: 'ChatOL',
    li: 'LI',
    hr: 'ChatHr',
    strong: 'Strong',
    em: 'Em',
    del: 'Del',
    link: 'Link',
    img: 'Img'
};
const $45405298edf226e2$export$bd27f0c8b4b4eabc = (el, body, emptyNode, people, channels)=>{
    (0, $8f98e.applyMarkdownToElement)(el, body, emptyNode, {
        withMentions: true,
        demoteHeadings: false,
        components: $45405298edf226e2$export$fbdb5cc005ccb507,
        people: people,
        channels: channels
    });
};

});

parcelRegister("htapf", function(module, exports) {

$parcel$export(module.exports, "setupHoverActions", () => $cb7d379438a00a94$export$3d4b608edbd04910);
// Container-agnostic hover-actions binder. Attaches delegated bubble-hover
// listeners on the scroll container and positions the single global
// [data-hover-actions] element via viewport-fixed coords.
const $cb7d379438a00a94$export$3d4b608edbd04910 = (container)=>{
    if (!container || container.__hoverActionsBound) return;
    container.__hoverActionsBound = true;
    // Both the full chat page (ChatMain) and the overlay drawer (ChatDrawer)
    // render their own [data-hover-actions]. A document-wide querySelector
    // would pick whichever lives earlier in the DOM — often the drawer's,
    // which is display:none when closed. Scope to the container's chat
    // root once, then cache the resolved element behind an isConnected
    // guard so mouseover (one of the chattiest DOM events) stays cheap.
    const _scope = container.closest('[data-key="ChatMain"], [data-key="ChatDrawer"]') || document;
    let _ha = null;
    const _getActions = ()=>_ha && _ha.isConnected ? _ha : _ha = _scope.querySelector('[data-hover-actions]');
    const _showActions = (bubble)=>{
        const row = bubble.closest('[data-msg-id]');
        if (!row) return;
        const ha = _getActions();
        if (!ha) return;
        const msgId = row.getAttribute('data-msg-id');
        const isMine = row.getAttribute('data-mine') === 'true';
        ha.setAttribute('data-active-msg', msgId);
        const bRect = bubble.getBoundingClientRect();
        let top = bRect.bottom + 2;
        let left = isMine ? bRect.right - ha.offsetWidth : bRect.left;
        if (top + ha.offsetHeight > window.innerHeight - 4) top = bRect.top - ha.offsetHeight - 2;
        if (left + ha.offsetWidth > window.innerWidth - 4) left = window.innerWidth - ha.offsetWidth - 4;
        if (left < 4) left = 4;
        ha.style.top = top + 'px';
        ha.style.left = left + 'px';
        ha.style.opacity = '1';
        ha.style.pointerEvents = 'auto';
    };
    const _hideActions = ()=>{
        const ha = _getActions();
        if (!ha || ha.hasAttribute('data-hover-lock')) return;
        if (ha.style.opacity === '0') return;
        ha.style.opacity = '0';
        ha.style.pointerEvents = 'none';
    };
    container.addEventListener('mouseover', (ev)=>{
        const bubble = ev.target.closest && ev.target.closest('[data-key="Body"]');
        if (bubble) _showActions(bubble);
    });
    container.addEventListener('mouseout', (ev)=>{
        const related = ev.relatedTarget;
        const ha = _getActions();
        if (ha && related && ha.contains(related)) return;
        if (related && related.closest && related.closest('[data-key="Body"]')) return;
        _hideActions();
    });
    container.addEventListener('scroll', _hideActions, {
        passive: true
    });
};

});


parcelRegister("lzthD", function(module, exports) {

$parcel$export(module.exports, "ChatComposer", () => $fb4394eb1e32e310$export$813afa0a1cccf433);
$parcel$export(module.exports, "ChatAttachmentChip", () => $fb4394eb1e32e310$export$3517aef680514d54);
// WYSIWYG chat composer. Uses a contenteditable div instead of a textarea
// so formatting (bold, italic, code, links, lists) renders visually as
// the user types. On send, innerHTML is converted to markdown via
// htmlToMarkdown() so the message body stored in Supabase is clean
// markdown (rendered by symbolize-markdown in the message timeline).

var $aG9qy = parcelRequire("aG9qy");

var $f0zrS = parcelRequire("f0zrS");

var $bfqVY = parcelRequire("bfqVY");
// Normalize SDK list responses — different routes wrap data under
// different keys (`data`, `rows`, `events`, `notes`, `articles`, `tickets`).
const $fb4394eb1e32e310$var$_normalizeList = (res)=>{
    if (Array.isArray(res)) return res;
    if (!res || typeof res !== 'object') return [];
    return res.data || res.rows || res.events || res.notes || res.articles || res.tickets || [];
};
// On-demand reference data cache — avoids re-fetching on every keystroke.
const $fb4394eb1e32e310$var$_refCache = {
    tickets: null,
    events: null,
    notes: null,
    kb: null
};
const $fb4394eb1e32e310$var$_fetchRef = async (type, query)=>{
    if (type === 'ticket') {
        if (!$fb4394eb1e32e310$var$_refCache.tickets) {
            // migrated 2026-04-27 to SDK route workspaceProject.tickets/list
            const res = await (0, $bfqVY.getSDK)().execute('workspaceProject.tickets', 'list', {
                filter: {
                    deleted: false
                },
                options: {
                    columns: 'id, number, title, state, column_key',
                    order: {
                        updated_at: 'desc'
                    },
                    limit: 50
                }
            });
            $fb4394eb1e32e310$var$_refCache.tickets = $fb4394eb1e32e310$var$_normalizeList(res);
            setTimeout(()=>{
                $fb4394eb1e32e310$var$_refCache.tickets = null;
            }, 60000);
        }
        const q = (query || '').toLowerCase();
        return $fb4394eb1e32e310$var$_refCache.tickets.filter((t)=>!q || t.title && t.title.toLowerCase().includes(q) || t.number && String(t.number).includes(q)).slice(0, 6);
    }
    if (type === 'event') {
        if (!$fb4394eb1e32e310$var$_refCache.events) {
            // migrated 2026-04-27 to SDK route workspaceProject.calendar/list
            const res = await (0, $bfqVY.getSDK)().execute('workspaceProject.calendar', 'list', {
                filter: {},
                options: {
                    columns: 'id, title, date, start_time, end_time',
                    order: {
                        date: 'desc'
                    },
                    limit: 50
                }
            });
            $fb4394eb1e32e310$var$_refCache.events = $fb4394eb1e32e310$var$_normalizeList(res);
            setTimeout(()=>{
                $fb4394eb1e32e310$var$_refCache.events = null;
            }, 60000);
        }
        const q = (query || '').toLowerCase();
        return $fb4394eb1e32e310$var$_refCache.events.filter((ev)=>!q || ev.title && ev.title.toLowerCase().includes(q)).slice(0, 6);
    }
    if (type === 'reference') {
        if (!$fb4394eb1e32e310$var$_refCache.notes) {
            // migrated 2026-04-27 to SDK route workspaceProject.documents.notes/list
            const res = await (0, $bfqVY.getSDK)().execute('workspaceProject.documents.notes', 'list', {
                options: {
                    columns: 'id, title',
                    order: {
                        updated_at: 'desc'
                    },
                    limit: 30
                }
            });
            $fb4394eb1e32e310$var$_refCache.notes = $fb4394eb1e32e310$var$_normalizeList(res).map((n)=>({
                    ...n,
                    _refType: 'note'
                }));
            setTimeout(()=>{
                $fb4394eb1e32e310$var$_refCache.notes = null;
            }, 60000);
        }
        if (!$fb4394eb1e32e310$var$_refCache.kb) {
            // migrated 2026-04-27 to SDK route workspaceProject.documents.kb/list
            const res = await (0, $bfqVY.getSDK)().execute('workspaceProject.documents.kb', 'list', {
                options: {
                    columns: 'id, title',
                    order: {
                        updated_at: 'desc'
                    },
                    limit: 30
                }
            });
            $fb4394eb1e32e310$var$_refCache.kb = $fb4394eb1e32e310$var$_normalizeList(res).map((a)=>({
                    ...a,
                    _refType: 'knowledge base'
                }));
            setTimeout(()=>{
                $fb4394eb1e32e310$var$_refCache.kb = null;
            }, 60000);
        }
        const q = (query || '').toLowerCase();
        return [
            ...$fb4394eb1e32e310$var$_refCache.notes,
            ...$fb4394eb1e32e310$var$_refCache.kb
        ].filter((d)=>!q || d.title && d.title.toLowerCase().includes(q)).slice(0, 6);
    }
    return [];
};
// ── execCommand helpers ─────────────────────────────────────────────
// execCommand is deprecated but still the only synchronous, cross-browser
// way to manipulate selection formatting inside a contenteditable. Every
// major browser still supports it for these basic operations.
const $fb4394eb1e32e310$var$_exec = (cmd, value)=>document.execCommand(cmd, false, value || null);
const $fb4394eb1e32e310$var$_findEditor = (el)=>{
    let cur = el;
    for(let i = 0; i < 8 && cur; i++){
        if (cur.Box && cur.Box.Editor && cur.Box.Editor.node) return cur.Box.Editor.node;
        if (cur.Editor && cur.Editor.node) return cur.Editor.node;
        cur = cur.parent;
    }
    return null;
};
// Toolbar button — uses onMouseDown+preventDefault so the editor never loses
// focus; this preserves the selection/caret so execCommand can actually apply
// formatting. `isActive` reads queryCommandState against the (reactive)
// composerSelVersion signal so buttons highlight when their format is active.
const $fb4394eb1e32e310$var$_isActiveCmd = (cmd, value)=>{
    if (!cmd) return false;
    try {
        if (cmd === 'formatBlock') {
            const block = (document.queryCommandValue('formatBlock') || '').toLowerCase();
            return block === (value || '').toLowerCase();
        }
        return document.queryCommandState(cmd);
    } catch (_) {
        return false;
    }
};
const $fb4394eb1e32e310$var$_btn = (icon, title, cmd, value)=>({
        extends: 'NavbarButton',
        padding: 'Y2',
        title: title,
        aria: {
            label: title
        },
        // Read the reactive signal so DOMQL re-evaluates background when selection
        // moves. The actual lookup goes through document.queryCommandState.
        background: (el, s)=>{
            s.root?.composerSelVersion;
            return $fb4394eb1e32e310$var$_isActiveCmd(cmd, value) ? 'overlay' : 'transparent';
        },
        color: (el, s)=>{
            s.root?.composerSelVersion;
            return $fb4394eb1e32e310$var$_isActiveCmd(cmd, value) ? 'title' : 'caption';
        },
        Icon: {
            icon: icon
        },
        onMouseDown: (e, el)=>{
            // Prevent the editor from losing focus on button press. This is the
            // critical piece — without it, execCommand has no selection to act on.
            e.preventDefault();
            e.stopPropagation();
            const editor = $fb4394eb1e32e310$var$_findEditor(el.parent && el.parent.parent);
            if (editor) editor.focus();
            $fb4394eb1e32e310$var$_exec(cmd, value);
        },
        onClick: (e)=>{
            e.preventDefault();
        }
    });
const $fb4394eb1e32e310$export$813afa0a1cccf433 = {
    flow: 'y',
    padding: '0 B A B',
    background: 'transparent',
    gap: 'V',
    onCreate: (el, s)=>{
        const root = s && s.root;
        if (!root) return;
        // selectionchange fires globally (URL bar, other inputs, sidebar labels).
        // Gate on composer focus so the toolbar buttons don't re-render on
        // unrelated selections. Also diff the resolved active-command set so
        // we only mutate state when formatting actually changed — moving the
        // caret through plain text produces no state update.
        const CMDS = [
            'bold',
            'italic',
            'strikeThrough',
            'underline',
            'insertUnorderedList',
            'insertOrderedList'
        ];
        el._selListener = ()=>{
            const editor = el.Box?.Editor?.node;
            if (!editor) return;
            const active = document.activeElement;
            if (active !== editor && !editor.contains(active)) return;
            if (el._selRaf) return;
            el._selRaf = requestAnimationFrame(()=>{
                el._selRaf = null;
                const r = el.state?.root;
                if (!r) return;
                let sig = '';
                try {
                    for (const c of CMDS)sig += document.queryCommandState(c) ? '1' : '0';
                    sig += '|' + (document.queryCommandValue('formatBlock') || '').toLowerCase();
                } catch (_) {
                    sig = '_err';
                }
                if (sig === el._lastCmdSig) return;
                el._lastCmdSig = sig;
                r.update({
                    composerSelVersion: (r.composerSelVersion || 0) + 1
                });
            });
        };
        document.addEventListener('selectionchange', el._selListener);
        // Clear editor on channel switch. v3.14 onUpdate doesn't fire on root state
        // changes, so we check inside the selection rAF loop isn't useful either.
        // The poll is cheap (~5 calls/s, each one map lookup + string compare).
        el._channelTimer = setInterval(()=>{
            const r = el.state?.root;
            if (!r) return;
            const editor = el.Box?.Editor?.node;
            if (editor && r.activeChannelId && el._lastChannel !== r.activeChannelId) {
                el._lastChannel = r.activeChannelId;
                editor.innerHTML = '';
            }
        }, 200);
    },
    onRemove: (el)=>{
        if (el._selListener) document.removeEventListener('selectionchange', el._selListener);
        if (el._selRaf) cancelAnimationFrame(el._selRaf);
        if (el._channelTimer) clearInterval(el._channelTimer);
    },
    // Toolbar at the bottom.
    Toolbar: {
        flow: 'x',
        gap: 'V',
        align: 'center left',
        order: '10',
        Bold: $fb4394eb1e32e310$var$_btn('bold', 'Bold', 'bold'),
        Italic: $fb4394eb1e32e310$var$_btn('italic', 'Italic', 'italic'),
        Strike: $fb4394eb1e32e310$var$_btn('strikethrough', 'Strikethrough', 'strikeThrough'),
        Underline: $fb4394eb1e32e310$var$_btn('underline', 'Underline', 'underline'),
        Code: {
            extends: 'NavbarButton',
            padding: 'Y2',
            title: 'Code',
            aria: {
                label: 'Code'
            },
            background: (el, s)=>{
                s.root?.composerSelVersion;
                // Active when selection is inside a <code> element.
                try {
                    const sel = window.getSelection();
                    if (!sel || !sel.rangeCount) return 'transparent';
                    let n = sel.getRangeAt(0).startContainer;
                    while(n){
                        if (n.nodeType === 1 && n.tagName === 'CODE') return 'overlay';
                        n = n.parentNode;
                    }
                } catch (_) {}
                return 'transparent';
            },
            Icon: {
                icon: 'code'
            },
            onMouseDown: (e, el)=>{
                e.preventDefault();
                e.stopPropagation();
                const editor = $fb4394eb1e32e310$var$_findEditor(el.parent && el.parent.parent);
                if (!editor) return;
                editor.focus();
                const sel = window.getSelection();
                if (!sel || !sel.rangeCount || sel.isCollapsed) return;
                const range = sel.getRangeAt(0);
                // Bail if selection spans block elements — surroundContents would throw.
                try {
                    const code = document.createElement('code');
                    code.style.fontFamily = 'monospace';
                    code.style.background = 'rgba(255,255,255,0.08)';
                    code.style.padding = '1px 4px';
                    code.style.borderRadius = '3px';
                    range.surroundContents(code);
                    sel.collapseToEnd();
                } catch (_) {
                    // Fallback: wrap extracted fragment.
                    const frag = range.extractContents();
                    const code = document.createElement('code');
                    code.style.fontFamily = 'monospace';
                    code.style.background = 'rgba(255,255,255,0.08)';
                    code.style.padding = '1px 4px';
                    code.style.borderRadius = '3px';
                    code.appendChild(frag);
                    range.insertNode(code);
                    sel.collapseToEnd();
                }
            },
            onClick: (e)=>{
                e.preventDefault();
            }
        },
        Link: {
            extends: 'NavbarButton',
            padding: 'Y2',
            title: 'Link',
            aria: {
                label: 'Link'
            },
            Icon: {
                icon: 'link'
            },
            // Capture the selection before the prompt steals focus — prompt()
            // collapses the selection, so we need to snapshot it first.
            onMouseDown: (e, el)=>{
                e.preventDefault();
                e.stopPropagation();
                const editor = $fb4394eb1e32e310$var$_findEditor(el.parent && el.parent.parent);
                if (!editor) return;
                editor.focus();
                const sel = window.getSelection();
                const savedRange = sel && sel.rangeCount ? sel.getRangeAt(0).cloneRange() : null;
                const url = prompt('URL:');
                if (!url) return;
                if (savedRange) {
                    sel.removeAllRanges();
                    sel.addRange(savedRange);
                }
                $fb4394eb1e32e310$var$_exec('createLink', url);
            },
            onClick: (e)=>{
                e.preventDefault();
            }
        },
        Quote: $fb4394eb1e32e310$var$_btn('quote', 'Blockquote', 'formatBlock', 'blockquote'),
        UList: $fb4394eb1e32e310$var$_btn('listBulleted', 'Bulleted list', 'insertUnorderedList'),
        OList: $fb4394eb1e32e310$var$_btn('listNumbered', 'Numbered list', 'insertOrderedList'),
        Heading: $fb4394eb1e32e310$var$_btn('heading', 'Heading', 'formatBlock', 'h5'),
        Rule: {
            extends: 'NavbarButton',
            padding: 'Y2',
            title: 'Horizontal rule',
            aria: {
                label: 'Horizontal rule'
            },
            Icon: {
                icon: 'minus'
            },
            onMouseDown: (e, el)=>{
                e.preventDefault();
                e.stopPropagation();
                const editor = $fb4394eb1e32e310$var$_findEditor(el.parent && el.parent.parent);
                if (editor) editor.focus();
                $fb4394eb1e32e310$var$_exec('insertHorizontalRule');
            },
            onClick: (e)=>{
                e.preventDefault();
            }
        },
        Spacer: {
            flex: '1'
        },
        AttachBtn: {
            extends: 'NavbarButton',
            padding: 'Y2',
            title: 'Attach file',
            aria: {
                label: 'Attach file'
            },
            Icon: {
                icon: 'attachment'
            },
            onMouseDown: (e)=>{
                e.preventDefault();
                e.stopPropagation();
            },
            onClick: (e, el)=>{
                e.preventDefault();
                e.stopPropagation();
                const inputNode = el.parent && el.parent.HiddenFile && el.parent.HiddenFile.node;
                if (inputNode) inputNode.click();
            }
        },
        // Cross-app: launch a meet call linked to the active chat channel.
        // Reuses an existing meet_room if one already exists for this channel,
        // otherwise creates a new one. The room is linked via meet_rooms.chat_channel_id
        // so the channel can later show a "call in progress" banner (future).
        StartCallBtn: {
            extends: 'NavbarButton',
            padding: 'Y2',
            title: 'Start call',
            aria: {
                label: 'Start call'
            },
            Icon: {
                icon: 'video'
            },
            hide: (el, s)=>!s.root.activeChannelId,
            onClick: async (e, el, s)=>{
                e.preventDefault();
                e.stopPropagation();
                const root = s.root;
                const channelId = root.activeChannelId;
                if (!channelId) return;
                const channel = (root.channels || []).find((c)=>c.id === channelId);
                const isDm = channel?.kind === 'dm' || channel?.kind === 'group_dm';
                const existing = (root.rooms || []).find((r)=>r.chatChannelId === channelId && !r.endedAt);
                let id = existing?.id;
                if (!id) id = await el.call('createRoom', {
                    name: (channel?.name || (isDm ? 'DM' : 'Channel')) + ' call',
                    kind: isDm ? 'dm' : 'room',
                    chatChannelId: channelId,
                    // DMs default transcribe-off (privacy); channels default on.
                    transcribeEnabled: !isDm
                });
                if (!id) return;
                root.update({
                    activeRoomId: id,
                    meetView: 'call'
                });
                if (typeof window !== 'undefined') window.location.hash = `room=${id}&view=call`;
                let __root = el;
                while(__root && !__root.routes)__root = __root.parent;
                if (__root) el.router('/meet', __root);
                await el.call('connectCall', id);
            }
        },
        HiddenFile: {
            tag: 'input',
            type: 'file',
            multiple: true,
            accept: '*/*',
            display: 'none',
            onChange: (e, el, s)=>{
                const root = s && s.root;
                if (!root || !root.activeChannelId) return;
                const files = [
                    ...e.target.files || []
                ];
                for (const file of files)el.call('uploadAttachment', {
                    channelId: root.activeChannelId,
                    file: file
                });
                e.target.value = '';
            }
        }
    },
    Box: {
        flow: 'y',
        position: 'relative',
        padding: 'A A2 C1',
        round: 'A',
        overflow: 'hidden',
        theme: 'field',
        transition: 'B all defaultBezier',
        // Pending attachment chips — inside Box above the Editor,
        // matching PromptGallery's position inside PromptTextarea.
        AttachmentBar: {
            flow: 'x wrap',
            gap: 'Z',
            margin: '0',
            if: (el, s)=>{
                const root = s && s.root;
                if (!root || !root.activeChannelId) return false;
                const list = (root.pendingAttachments || {})[root.activeChannelId] || [];
                return list.length > 0;
            },
            childExtends: 'ChatAttachmentChip',
            childrenAs: 'state',
            childProps: {
                boxSize: 'D'
            },
            children: (el, s)=>s.root.pendingAttachments[s.root.activeChannelId] || []
        },
        // CircleButton send at bottom-right.
        SendBtn: {
            extends: 'CircleButton',
            position: 'absolute',
            bottom: 'Z',
            right: 'Z',
            zIndex: '1',
            padding: 'Z',
            icon: 'chevronUp',
            Icon: {
                transform: 'rotate(45deg)'
            },
            '@dark': {
                background: 'white',
                color: 'title',
                ':hover': {
                    background: 'gray14',
                    color: 'gray1'
                },
                ':active': {
                    background: 'gray13',
                    color: 'gray1'
                }
            },
            onClick: (e, el, s)=>{
                e.preventDefault();
                const root = s && s.root;
                if (!root || !root.activeChannelId) return;
                const editor = el.parent && el.parent.Editor && el.parent.Editor.node;
                if (!editor) return;
                const html = editor.innerHTML || '';
                const body = (0, $f0zrS.htmlToMarkdown)(html);
                const pending = (root.pendingAttachments || {})[root.activeChannelId] || [];
                if (!body && pending.length === 0) return;
                el.call('sendMessage', {
                    channelId: root.activeChannelId,
                    body: body
                });
                editor.innerHTML = '';
            }
        },
        Flex: null,
        Button: null,
        // The WYSIWYG editor — contenteditable div replaces the old textarea.
        // Formatting is applied visually via execCommand from the toolbar.
        // On send, innerHTML is converted to markdown via htmlToMarkdown().
        Editor: {
            tag: 'div',
            minWidth: '100%',
            minHeight: 'C',
            maxHeight: 'F',
            padding: '0',
            outline: 'none',
            fontSize: 'Z2',
            lineHeight: '1.5',
            overflow: 'auto',
            wordBreak: 'break-word',
            attr: {
                contenteditable: 'true',
                'data-composer-input': 'true',
                'data-placeholder': (el, s)=>{
                    const root = s && s.root;
                    if (!root) return 'Message';
                    const ch = (root.channels || []).find((c)=>c.id === root.activeChannelId);
                    if (!ch) return 'Message';
                    if (ch.kind === 'channel') return `Message #${ch.name || ''}`;
                    return 'Message';
                },
                spellcheck: 'true'
            },
            // Show placeholder when empty via CSS pseudo-element.
            ':empty::before': {
                content: 'attr(data-placeholder)',
                color: 'caption',
                pointerEvents: 'none'
            },
            onInput: (e, el, s)=>{
                const root = s && s.root;
                if (!root) return;
                // Mention autocomplete.
                const sel = window.getSelection();
                if (!sel || !sel.rangeCount) return;
                const range = sel.getRangeAt(0);
                const textNode = range.startContainer;
                // Only detect mentions when the caret is inside THIS editor.
                // When the user clicks the mention dropdown, the selection moves
                // outside the editor and we must NOT null the picker — otherwise
                // the pick handler finds picker=null and can't do the replacement.
                if (!el.node.contains(textNode)) return;
                if (textNode.nodeType !== 3) {
                    if (root.mentionPicker) root.update({
                        mentionPicker: null
                    });
                    return;
                }
                const text = textNode.textContent || '';
                const caret = range.startOffset;
                const trig = (0, $aG9qy.detectReferenceTrigger)(text, caret);
                if (!trig) {
                    if (root.mentionPicker) root.update({
                        mentionPicker: null
                    });
                    return;
                }
                const q = (trig.query || '').trim().toLowerCase();
                let options = [];
                if (trig.type === 'person') options = el.call('activeMembers').filter((p)=>!q || p.email && p.email.toLowerCase().split('@')[0].includes(q) || p.name && p.name.toLowerCase().includes(q)).slice(0, 6);
                else if (trig.type === 'channel') options = (root.channels || []).filter((c)=>c.kind === 'channel' && (!q || c.name && c.name.toLowerCase().includes(q))).slice(0, 6);
                else if (trig.type === 'ticket' || trig.type === 'event' || trig.type === 'reference') {
                    // Fetch on-demand — async, updates picker when ready.
                    $fb4394eb1e32e310$var$_fetchRef(trig.type, q).then((fetched)=>{
                        if (!root.mentionPicker || root.mentionPicker.type !== trig.type) return;
                        root.update({
                            mentionPicker: {
                                ...root.mentionPicker,
                                options: fetched
                            }
                        });
                    });
                    // Show empty picker immediately so position is set.
                    options = [];
                }
                const rect = el.node.getBoundingClientRect();
                root.update({
                    mentionPicker: {
                        type: trig.type,
                        query: trig.query,
                        start: trig.start,
                        end: trig.end,
                        top: rect.top - 240,
                        left: rect.left,
                        options: options,
                        activeIndex: 0
                    }
                });
            },
            onKeydown: (e, el, s)=>{
                const root = s && s.root;
                // ── Mention picker keyboard nav ──
                const picker = root && root.mentionPicker;
                if (picker && picker.options && picker.options.length) {
                    const opts = picker.options;
                    const idx = picker.activeIndex || 0;
                    if (e.key === 'ArrowDown') {
                        e.preventDefault();
                        root.update({
                            mentionPicker: {
                                ...picker,
                                activeIndex: (idx + 1) % opts.length
                            }
                        });
                        return;
                    }
                    if (e.key === 'ArrowUp') {
                        e.preventDefault();
                        root.update({
                            mentionPicker: {
                                ...picker,
                                activeIndex: (idx - 1 + opts.length) % opts.length
                            }
                        });
                        return;
                    }
                    if (e.key === 'Enter' || e.key === 'Tab') {
                        e.preventDefault();
                        // Simulate pointerdown pick via the module-level handler.
                        const rows = document.querySelectorAll('[data-mention-pick]');
                        const row = rows[idx];
                        if (row) row.dispatchEvent(new PointerEvent('pointerdown', {
                            bubbles: true,
                            cancelable: true,
                            view: window
                        }));
                        return;
                    }
                    if (e.key === 'Escape') {
                        root.update({
                            mentionPicker: null
                        });
                        return;
                    }
                }
                // Formatting shortcuts.
                if (e.metaKey || e.ctrlKey) {
                    const k = e.key.toLowerCase();
                    if (k === 'b') {
                        e.preventDefault();
                        $fb4394eb1e32e310$var$_exec('bold');
                        return;
                    }
                    if (k === 'i') {
                        e.preventDefault();
                        $fb4394eb1e32e310$var$_exec('italic');
                        return;
                    }
                    if (k === 'u') {
                        e.preventDefault();
                        $fb4394eb1e32e310$var$_exec('underline');
                        return;
                    }
                }
                if (e.key === 'Escape' && root && root.mentionPicker) {
                    root.update({
                        mentionPicker: null
                    });
                    return;
                }
                // Enter = send (Shift+Enter = newline).
                if (e.key === 'Enter' && !e.shiftKey) {
                    e.preventDefault();
                    if (!root || !root.activeChannelId) return;
                    const html = el.node.innerHTML || '';
                    const body = (0, $f0zrS.htmlToMarkdown)(html);
                    const pending = (root.pendingAttachments || {})[root.activeChannelId] || [];
                    if (!body && pending.length === 0) return;
                    el.call('sendMessage', {
                        channelId: root.activeChannelId,
                        body: body
                    });
                    el.node.innerHTML = '';
                    if (root.mentionPicker) root.update({
                        mentionPicker: null
                    });
                }
            },
            onPaste: (e, el, s)=>{
                const root = s && s.root;
                if (!root || !root.activeChannelId) return;
                // Handle pasted images.
                const items = e.clipboardData && e.clipboardData.items || [];
                for (const it of items)if (it.kind === 'file') {
                    const file = it.getAsFile();
                    if (file) {
                        e.preventDefault();
                        el.call('uploadAttachment', {
                            channelId: root.activeChannelId,
                            file: file
                        });
                        return;
                    }
                }
                // For text paste, strip rich HTML and paste as plain text to keep
                // the editor clean (avoid pasting styled content from other apps).
                const text = e.clipboardData && e.clipboardData.getData('text/plain');
                if (text) {
                    e.preventDefault();
                    $fb4394eb1e32e310$var$_exec('insertText', text);
                }
            }
        }
    }
};
const $fb4394eb1e32e310$export$3517aef680514d54 = {
    flow: 'x',
    align: 'center left',
    gap: 'V',
    padding: 'V Z',
    round: 'Z',
    borderWidth: '1px',
    borderColor: 'line',
    borderStyle: 'solid',
    background: 'document',
    attr: {
        'data-attachment-id': (el, s)=>s && s.id || ''
    },
    Name: {
        tag: 'span',
        fontSize: 'Y2',
        color: 'title',
        maxWidth: 'F',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        text: (el, s)=>s && s.name || ''
    },
    Status: {
        tag: 'span',
        fontSize: 'Y2',
        color: 'caption',
        text: (el, s)=>s && s.uploading ? '...' : ''
    },
    RemoveBtn: {
        tag: 'button',
        type: 'button',
        text: 'x',
        padding: '0 V',
        border: 'none',
        background: 'transparent',
        cursor: 'pointer',
        color: 'caption',
        fontSize: 'Z2',
        attr: {
            'data-attachment-remove': (el, s)=>s && s.id || ''
        },
        ':hover': {
            color: 'title'
        }
    }
};

});
parcelRegister("aG9qy", function(module, exports) {

$parcel$export(module.exports, "detectReferenceTrigger", () => $7c6523b6a3bb1f55$export$d020266d80e6dea5);
$parcel$export(module.exports, "detectMentionTrigger", () => $7c6523b6a3bb1f55$export$22de456b6b833c31);
// Reference trigger detector for the composer's autocomplete dropdown.
// Supports multiple trigger patterns: @person, #channel, ##ticket,
// @@event, +reference (docs/notes/kb).
// Trigger definitions in priority order (longest prefix first).
const $7c6523b6a3bb1f55$var$TRIGGERS = [
    {
        prefix: '@@',
        type: 'event'
    },
    {
        prefix: '##',
        type: 'ticket'
    },
    {
        prefix: '@',
        type: 'person'
    },
    {
        prefix: '#',
        type: 'channel'
    },
    {
        prefix: '+',
        type: 'reference'
    }
];
const $7c6523b6a3bb1f55$export$d020266d80e6dea5 = (body, caret)=>{
    if (caret == null || !body) return null;
    const upToCaret = body.slice(0, caret);
    for (const { prefix: prefix, type: type } of $7c6523b6a3bb1f55$var$TRIGGERS){
        const idx = upToCaret.lastIndexOf(prefix);
        if (idx < 0) continue;
        // Must be at start or preceded by whitespace.
        if (idx > 0 && !/\s/.test(body[idx - 1])) continue;
        const after = upToCaret.slice(idx + prefix.length);
        // Allow alphanumeric, dots, underscores, dashes, spaces (for titles).
        if (!/^[a-zA-Z0-9._\- ]*$/.test(after)) continue;
        return {
            type: type,
            query: after,
            start: idx,
            end: caret
        };
    }
    return null;
};
const $7c6523b6a3bb1f55$export$22de456b6b833c31 = (body, caret)=>{
    const result = $7c6523b6a3bb1f55$export$d020266d80e6dea5(body, caret);
    if (!result || result.type !== 'person') return null;
    return {
        query: result.query,
        start: result.start,
        end: result.end
    };
};

});

parcelRegister("f0zrS", function(module, exports) {

$parcel$export(module.exports, "htmlToMarkdown", () => $aed25a73b3f4bc74$export$d04d5f37c3f9457c);
$parcel$export(module.exports, "textToHtml", () => $aed25a73b3f4bc74$export$1e9041aaa5d81b58);
// Lightweight HTML → Markdown converter for the WYSIWYG composer.
// Operates on the innerHTML of a contenteditable div at send time.
// Only handles the subset of HTML that execCommand / the toolbar produce.
const $aed25a73b3f4bc74$var$_escape = (t)=>t.replace(/([*_~`\[\]])/g, '\\$1');
const $aed25a73b3f4bc74$var$_walk = (node)=>{
    if (node.nodeType === 3) return node.textContent;
    if (node.nodeType !== 1) return '';
    const tag = node.tagName.toLowerCase();
    const children = [
        ...node.childNodes
    ].map($aed25a73b3f4bc74$var$_walk).join('');
    switch(tag){
        case 'b':
        case 'strong':
            return `**${children}**`;
        case 'i':
        case 'em':
            return `*${children}*`;
        case 's':
        case 'del':
        case 'strike':
            return `~~${children}~~`;
        case 'u':
            return children // markdown has no underline, keep plain
            ;
        case 'code':
            return `\`${children}\``;
        case 'pre':
            return `\n\`\`\`\n${node.textContent}\n\`\`\`\n`;
        case 'a':
            {
                const href = node.getAttribute('href') || '';
                return href ? `[${children}](${href})` : children;
            }
        case 'br':
            return '\n';
        case 'div':
        case 'p':
            return children ? `\n${children}\n` : '\n';
        case 'blockquote':
            return children.split('\n').map((l)=>l ? `> ${l}` : '').join('\n');
        case 'h1':
            return `\n# ${children}\n`;
        case 'h2':
            return `\n## ${children}\n`;
        case 'h3':
            return `\n### ${children}\n`;
        case 'h4':
            return `\n#### ${children}\n`;
        case 'h5':
            return `\n##### ${children}\n`;
        case 'h6':
            return `\n###### ${children}\n`;
        case 'ul':
            return '\n' + [
                ...node.children
            ].map((li)=>`- ${$aed25a73b3f4bc74$var$_walk(li).trim()}`).join('\n') + '\n';
        case 'ol':
            return '\n' + [
                ...node.children
            ].map((li, i)=>`${i + 1}. ${$aed25a73b3f4bc74$var$_walk(li).trim()}`).join('\n') + '\n';
        case 'li':
            return children;
        case 'hr':
            return '\n---\n';
        case 'img':
            {
                const src = node.getAttribute('src') || '';
                const alt = node.getAttribute('alt') || '';
                return `![${alt}](${src})`;
            }
        default:
            return children;
    }
};
const $aed25a73b3f4bc74$export$d04d5f37c3f9457c = (html)=>{
    if (!html || !html.trim()) return '';
    const div = document.createElement('div');
    div.innerHTML = html;
    const md = $aed25a73b3f4bc74$var$_walk(div);
    // Collapse excessive blank lines, strip non-breaking spaces, then trim.
    return md.replace(/\u00A0/g, ' ').replace(/\n{3,}/g, '\n\n').trim();
};
const $aed25a73b3f4bc74$export$1e9041aaa5d81b58 = (text)=>{
    if (!text) return '';
    return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\n/g, '<br>');
};

});


parcelRegister("a1CiO", function(module, exports) {

$parcel$export(module.exports, "ChatNewChannelModal", () => $74c7b5717b77694a$export$6d2a9c1433eba703);
$parcel$export(module.exports, "ChatModalKindBtn", () => $74c7b5717b77694a$export$8193534e6e0080fa);
$parcel$export(module.exports, "ChatMemberPickRow", () => $74c7b5717b77694a$export$e69ac338bf754e77);
// Modal for creating a new channel or starting a DM. Picks members from the
// existing root.people directory. Calls createChannel which handles the
// insert + membership rows + dedupe.
const $74c7b5717b77694a$export$6d2a9c1433eba703 = {
    extends: 'Modal',
    stateKey: 'showNewChannel',
    extraClose: {
        newChannelDraft: null
    },
    Window: {
        width: 'I',
        maxWidth: '90vw',
        ModalHeader: {
            Hgroup: {
                H: {
                    text: (el, s)=>s.root?.newChannelDraft?.kind === 'channel' ? 'Create channel' : 'New direct message'
                },
                P: {
                    text: (el, s)=>s.root?.newChannelDraft?.kind === 'channel' ? 'Pick a name and add the people who should join' : 'Pick one or more people to message'
                }
            }
        },
        Content: {
            flow: 'y',
            gap: 'A',
            flex: '1',
            overflow: 'auto',
            padding: 'A 0',
            KindToggle: {
                flow: 'x',
                gap: 'Z',
                ChannelBtn: {
                    extends: 'ChatModalKindBtn',
                    text: '# Channel',
                    kind: 'channel',
                    onClick: (e, el, s)=>s.root.update({
                            newChannelDraft: {
                                ...s.root?.newChannelDraft,
                                kind: 'channel'
                            }
                        }),
                    theme: (el, s)=>s.root?.newChannelDraft?.kind === 'channel' ? 'primary' : 'secondary'
                },
                DMBtn: {
                    extends: 'ChatModalKindBtn',
                    text: 'Direct',
                    kind: 'dm',
                    onClick: (e, el, s)=>s.root.update({
                            newChannelDraft: {
                                ...s.root?.newChannelDraft,
                                kind: 'dm'
                            }
                        }),
                    theme: (el, s)=>s.root?.newChannelDraft?.kind !== 'channel' ? 'primary' : 'secondary'
                }
            },
            NameField: {
                display: (el, s)=>s.root?.newChannelDraft?.kind === 'channel' ? 'flex' : 'none',
                flow: 'y',
                gap: 'V',
                CaptionTitle: {
                    fontSize: 'Y2',
                    Text: {
                        text: 'NAME'
                    }
                },
                Input: {
                    tag: 'input',
                    padding: 'Z A',
                    round: 'Z',
                    borderWidth: '1px',
                    borderColor: 'line',
                    borderStyle: 'solid',
                    background: 'document',
                    color: 'title',
                    fontSize: 'Z2',
                    placeholder: 'e.g. design-reviews',
                    value: (el, s)=>s.root?.newChannelDraft?.name || '',
                    onInput: (e, el, s)=>s.root.update({
                            newChannelDraft: {
                                ...s.root?.newChannelDraft,
                                name: e.target.value
                            }
                        })
                }
            },
            TopicField: {
                display: (el, s)=>s.root?.newChannelDraft?.kind === 'channel' ? 'flex' : 'none',
                flow: 'y',
                gap: 'V',
                CaptionTitle: {
                    fontSize: 'Y2',
                    Text: {
                        text: 'TOPIC (optional)'
                    }
                },
                Input: {
                    tag: 'input',
                    padding: 'Z A',
                    round: 'Z',
                    borderWidth: '1px',
                    borderColor: 'line',
                    borderStyle: 'solid',
                    background: 'document',
                    color: 'title',
                    fontSize: 'Z2',
                    value: (el, s)=>s.root?.newChannelDraft?.topic || '',
                    onInput: (e, el, s)=>s.root.update({
                            newChannelDraft: {
                                ...s.root?.newChannelDraft,
                                topic: e.target.value
                            }
                        })
                }
            },
            MembersField: {
                flow: 'y',
                gap: 'V',
                maxHeight: 'G',
                overflow: 'hidden',
                HeaderRow: {
                    flow: 'x',
                    align: 'center space-between',
                    CaptionTitle: {
                        fontSize: 'Y2',
                        Text: {
                            text: 'MEMBERS'
                        }
                    },
                    SelectAllBtn: {
                        tag: 'button',
                        type: 'button',
                        fontSize: 'Y2',
                        color: 'accent',
                        background: 'transparent',
                        borderWidth: '0',
                        cursor: 'pointer',
                        padding: '0',
                        ':hover': {
                            opacity: '.8'
                        },
                        text: (el, s)=>{
                            const me = s.root?.currentUserEmail;
                            const all = el.call('activeMembers').filter((p)=>p.email !== me);
                            const selected = s.root?.newChannelDraft?.members || [];
                            return selected.length >= all.length ? 'Deselect all' : 'Select all';
                        },
                        onClick: (e, el, s)=>{
                            const me = s.root?.currentUserEmail;
                            const all = el.call('activeMembers').filter((p)=>p.email !== me);
                            const selected = s.root?.newChannelDraft?.members || [];
                            const members = selected.length >= all.length ? [] : all.map((p)=>p.email);
                            s.root.update({
                                newChannelDraft: {
                                    ...s.root?.newChannelDraft,
                                    members: members
                                }
                            });
                        }
                    }
                },
                Search: {
                    tag: 'input',
                    padding: 'Z A',
                    round: 'Z',
                    borderWidth: '1px',
                    borderColor: 'line',
                    borderStyle: 'solid',
                    background: 'document',
                    color: 'title',
                    fontSize: 'Z2',
                    placeholder: "Search teammates\u2026",
                    value: (el, s)=>s.root?.newChannelDraft?.memberQuery || '',
                    onInput: (e, el, s)=>s.root.update({
                            newChannelDraft: {
                                ...s.root?.newChannelDraft,
                                memberQuery: e.target.value
                            }
                        }),
                    onKeydown: (e, el, s)=>{
                        if (e.key !== 'Enter') return;
                        e.preventDefault();
                        const q = (s.root?.newChannelDraft?.memberQuery || '').trim().toLowerCase();
                        if (!q) return;
                        const me = s.root.currentUserEmail;
                        const first = el.call('activeMembers').find((p)=>{
                            if (p.email === me) return false;
                            const n = (p.name || '').toLowerCase();
                            const em = (p.email || '').toLowerCase();
                            return n.includes(q) || em.includes(q);
                        });
                        if (!first) return;
                        const draft = s.root?.newChannelDraft || {
                            members: []
                        };
                        const has = (draft.members || []).includes(first.email);
                        const members = has ? draft.members.filter((m)=>m !== first.email) : [
                            ...draft.members || [],
                            first.email
                        ];
                        s.root.update({
                            newChannelDraft: {
                                ...draft,
                                members: members,
                                memberQuery: ''
                            }
                        });
                        e.target.value = '';
                    }
                },
                List: {
                    flow: 'y',
                    gap: 'V',
                    overflow: 'auto',
                    maxHeight: 'F',
                    childExtends: 'ChatMemberPickRow',
                    childrenAs: 'state',
                    children: (el, s)=>{
                        const me = s.root?.currentUserEmail;
                        const q = (s.root?.newChannelDraft && s.root?.newChannelDraft.memberQuery || '').trim().toLowerCase();
                        const all = el.call('activeMembers').filter((p)=>p.email !== me);
                        if (!q) return all;
                        return all.filter((p)=>{
                            const n = (p.name || '').toLowerCase();
                            const em = (p.email || '').toLowerCase();
                            return n.includes(q) || em.includes(q);
                        });
                    }
                }
            }
        },
        ModalFooter: {
            flow: 'x',
            gap: 'Z1',
            SubmitBtn: {
                extends: 'Button',
                theme: 'primary',
                text: (el, s)=>s.root?.newChannelDraft?.kind === 'channel' ? 'Create channel' : 'Open DM',
                onClick: async (e, el, s)=>{
                    const d = s.root?.newChannelDraft || {};
                    const memberEmails = (d.members || []).filter(Boolean);
                    const isChannel = d.kind === 'channel';
                    // Block submit unless the draft is valid: a channel needs a name,
                    // a DM needs at least one other member. Avoids creating empty
                    // stub rows that show as blank entries in the sidebar.
                    if (isChannel && !(d.name || '').trim()) return;
                    if (!isChannel && memberEmails.length === 0) return;
                    const kind = isChannel ? 'channel' : memberEmails.length > 1 ? 'group_dm' : 'dm';
                    await el.call('createChannel', {
                        kind: kind,
                        name: isChannel ? d.name.trim() : null,
                        topic: d.topic || null,
                        isPrivate: !!d.is_private,
                        memberEmails: memberEmails
                    });
                }
            }
        }
    }
};
const $74c7b5717b77694a$export$8193534e6e0080fa = {
    tag: 'button',
    padding: 'Z A',
    round: 'Z',
    border: 'none',
    cursor: 'pointer',
    fontSize: 'Z2',
    fontWeight: '600'
};
const $74c7b5717b77694a$export$e69ac338bf754e77 = {
    flow: 'x',
    align: 'center left',
    gap: 'Z1',
    padding: 'Z Z1',
    round: 'Z',
    cursor: 'pointer',
    ':hover': {
        background: 'overlay'
    },
    background: (el, s)=>(s.root?.newChannelDraft?.members || []).includes(s.email) ? 'overlay' : 'transparent',
    onClick: (e, el, s)=>{
        const draft = s.root?.newChannelDraft || {
            members: []
        };
        const has = (draft.members || []).includes(s.email);
        const members = has ? draft.members.filter((m)=>m !== s.email) : [
            ...draft.members || [],
            s.email
        ];
        s.root.update({
            newChannelDraft: {
                ...draft,
                members: members
            }
        });
    },
    Avatar: {
        avatarType: 'initials',
        boxSize: 'B B',
        src: (el, s)=>el.call('avatarUrl', s && s.name)
    },
    Name: {
        tag: 'span',
        flex: '1',
        fontSize: 'Z2',
        color: 'title',
        text: (el, s)=>s.name || s.email
    },
    Check: {
        tag: 'span',
        fontSize: 'Z2',
        color: 'accent',
        text: (el, s)=>(s.root?.newChannelDraft?.members || []).includes(s.email) ? "\u2713" : ''
    }
};

});

parcelRegister("aVlLH", function(module, exports) {

$parcel$export(module.exports, "ChatChannelSettingsModal", () => $7f401cf993d62750$export$c7ee22e954f210dd);
$parcel$export(module.exports, "ChatSettingsMemberRow", () => $7f401cf993d62750$export$6fa363666c71b120);
// Channel settings — name/topic/privacy/archive. Opened by clicking the
// channel title in ChatHeader (writes the channel id into showChannelSettings).
const $7f401cf993d62750$var$_curChannel = (root)=>{
    if (!root?.showChannelSettings) return null;
    return (root.channels || []).find((c)=>c.id === root.showChannelSettings) || null;
};
// Per-channel draft map keyed by channel id. Avoids the `_id` sentinel that
// would otherwise duplicate `showChannelSettings` as a sync key.
const $7f401cf993d62750$var$_draft = (root)=>{
    const ch = $7f401cf993d62750$var$_curChannel(root);
    if (!ch) return {};
    return root?.channelSettingsDrafts?.[ch.id] || {};
};
const $7f401cf993d62750$var$_initDraft = (root)=>{
    const ch = $7f401cf993d62750$var$_curChannel(root);
    if (!ch) return;
    const drafts = root.channelSettingsDrafts || {};
    if (drafts[ch.id]) return;
    root.update({
        channelSettingsDrafts: {
            ...drafts,
            [ch.id]: {
                name: ch.name || '',
                topic: ch.topic || '',
                is_private: !!ch.is_private
            }
        }
    });
};
const $7f401cf993d62750$var$_patchDraft = (root, patch)=>{
    const ch = $7f401cf993d62750$var$_curChannel(root);
    if (!ch) return;
    const drafts = root.channelSettingsDrafts || {};
    root.update({
        channelSettingsDrafts: {
            ...drafts,
            [ch.id]: {
                ...drafts[ch.id] || {},
                ...patch
            }
        }
    });
};
const $7f401cf993d62750$export$c7ee22e954f210dd = {
    extends: 'Modal',
    stateKey: 'showChannelSettings',
    onUpdate: (el, s)=>{
        $7f401cf993d62750$var$_initDraft(s.root);
    },
    Window: {
        width: 'I',
        maxWidth: '90vw',
        ModalHeader: {
            Hgroup: {
                H: {
                    text: (el, s)=>{
                        const ch = $7f401cf993d62750$var$_curChannel(s.root);
                        return ch ? `${ch.kind === 'channel' ? '# ' : ''}${ch.name || 'Channel'} settings` : 'Settings';
                    }
                },
                P: {
                    text: 'Manage the name, topic, privacy, and members.'
                }
            },
            Icons: {
                ArchiveBtn: {
                    extends: 'IconButton',
                    title: (el, s)=>$7f401cf993d62750$var$_curChannel(s.root)?.is_archived ? 'Unarchive channel' : 'Archive channel',
                    Icon: {
                        icon: 'archive'
                    },
                    onClick: (e, el, s)=>{
                        const ch = $7f401cf993d62750$var$_curChannel(s.root);
                        if (!ch) return;
                        const willArchive = !ch.is_archived;
                        s.root.update({
                            confirmAction: {
                                title: willArchive ? `Archive ${ch.kind === 'channel' ? '#' + (ch.name || 'channel') : 'conversation'}?` : `Unarchive ${ch.kind === 'channel' ? '#' + (ch.name || 'channel') : 'conversation'}?`,
                                message: willArchive ? 'Archived channels are hidden from the sidebar. Members can unarchive later.' : 'The channel will appear in the sidebar again.',
                                confirmText: willArchive ? 'Archive' : 'Unarchive',
                                confirmTheme: willArchive ? 'red' : 'primary',
                                icon: 'archive',
                                onConfirm: async ()=>{
                                    await el.call('updateChannel', ch.id, {
                                        is_archived: willArchive
                                    });
                                    s.root.update({
                                        showChannelSettings: null
                                    });
                                }
                            }
                        });
                    }
                }
            }
        },
        Fields: {
            flow: 'y',
            gap: 'B',
            NameField: {
                extends: 'InputField',
                display: (el, s)=>$7f401cf993d62750$var$_curChannel(s.root)?.kind === 'channel' ? 'flex' : 'none',
                Title: {
                    text: 'Name'
                },
                Input: {
                    tag: 'input',
                    type: 'text',
                    placeholder: 'e.g. design-reviews',
                    value: (el, s)=>$7f401cf993d62750$var$_draft(s.root).name || '',
                    onInput: (e, el, s)=>$7f401cf993d62750$var$_patchDraft(s.root, {
                            name: e.target.value
                        })
                }
            },
            TopicField: {
                extends: 'InputField',
                display: (el, s)=>$7f401cf993d62750$var$_curChannel(s.root)?.kind === 'channel' ? 'flex' : 'none',
                Title: {
                    text: 'Topic'
                },
                Input: {
                    tag: 'input',
                    type: 'text',
                    placeholder: 'What is this channel about?',
                    value: (el, s)=>$7f401cf993d62750$var$_draft(s.root).topic || '',
                    onInput: (e, el, s)=>$7f401cf993d62750$var$_patchDraft(s.root, {
                            topic: e.target.value
                        })
                }
            },
            PrivacyRow: {
                display: (el, s)=>$7f401cf993d62750$var$_curChannel(s.root)?.kind === 'channel' ? 'flex' : 'none',
                flow: 'x',
                align: 'center left',
                gap: 'Z1',
                padding: 'Z 0',
                Box: {
                    tag: 'input',
                    type: 'checkbox',
                    margin: '0',
                    cursor: 'pointer',
                    checked: (el, s)=>!!$7f401cf993d62750$var$_draft(s.root).is_private,
                    onChange: (e, el, s)=>$7f401cf993d62750$var$_patchDraft(s.root, {
                            is_private: e.target.checked
                        })
                },
                Label: {
                    tag: 'label',
                    text: "Private channel \u2014 only invited members can see messages.",
                    fontSize: 'Z2',
                    color: 'title'
                }
            },
            MuteRow: {
                flow: 'x',
                align: 'center left',
                gap: 'Z1',
                padding: 'Z 0',
                Box: {
                    tag: 'input',
                    type: 'checkbox',
                    margin: '0',
                    cursor: 'pointer',
                    checked: (el, s)=>{
                        const ch = $7f401cf993d62750$var$_curChannel(s.root);
                        if (!ch) return false;
                        const me = s.root?.currentUserEmail;
                        const row = (s.root?.channelMembers || []).find((m)=>m.channel_id === ch.id && m.member_email === me);
                        return !!row?.muted;
                    },
                    onChange: async (e, el, s)=>{
                        const ch = $7f401cf993d62750$var$_curChannel(s.root);
                        if (!ch) return;
                        await el.call('setChannelMute', ch.id, e.target.checked);
                    }
                },
                Label: {
                    tag: 'label',
                    text: "Mute notifications \u2014 no bell, dimmed unread badge.",
                    fontSize: 'Z2',
                    color: 'title'
                }
            },
            LinksSection: {
                flow: 'y',
                gap: 'Z',
                SectionLabel: {
                    tag: 'span',
                    text: 'Linked event / call',
                    fontSize: 'Z2',
                    fontWeight: '600',
                    color: 'title'
                },
                Current: {
                    extends: 'LinkedResources',
                    type: 'chat_channel',
                    id: (el, s)=>$7f401cf993d62750$var$_curChannel(s.root)?.id || null
                },
                EventPicker: {
                    tag: 'select',
                    padding: 'Y Z',
                    round: 'Z',
                    fontSize: 'Z2',
                    background: 'overlay',
                    color: 'title',
                    borderWidth: '1px',
                    borderColor: 'line',
                    borderStyle: 'solid',
                    cursor: 'pointer',
                    onChange: async (e, el, s)=>{
                        const ch = $7f401cf993d62750$var$_curChannel(s.root);
                        const evId = e.target.value;
                        if (!ch || !evId) return;
                        await el.call('linkResources', 'chat_channel', ch.id, 'calendar_event', evId);
                        e.target.value = '';
                    },
                    childExtends: {
                        tag: 'option',
                        value: (el, s)=>s.value,
                        text: (el, s)=>s.label
                    },
                    childrenAs: 'state',
                    children: (el, s)=>{
                        const events = (s.root?.events || []).slice(0, 50);
                        return [
                            {
                                value: '',
                                label: "Link to calendar event\u2026"
                            },
                            ...events.map((e)=>({
                                    value: String(e.id),
                                    label: `${e.title || 'Event'} \xb7 ${e.date || ''}`
                                }))
                        ];
                    }
                }
            },
            MembersSection: {
                flow: 'y',
                gap: 'Z',
                Label: {
                    tag: 'span',
                    text: 'Members',
                    fontSize: 'Z2',
                    fontWeight: '600',
                    color: 'title'
                },
                List: {
                    flow: 'y',
                    gap: 'Y',
                    paddingLeft: 'Z',
                    childExtends: 'ChatSettingsMemberRow',
                    childrenAs: 'state',
                    children: (el, s)=>{
                        const ch = $7f401cf993d62750$var$_curChannel(s.root);
                        if (!ch) return [];
                        const mems = (s.root.channelMembers || []).filter((m)=>m.channel_id === ch.id);
                        return mems.map((m)=>({
                                email: m.member_email,
                                role: m.role
                            }));
                    }
                },
                Empty: {
                    display: (el, s)=>{
                        const ch = $7f401cf993d62750$var$_curChannel(s.root);
                        if (!ch) return 'none';
                        const mems = (s.root.channelMembers || []).filter((m)=>m.channel_id === ch.id);
                        return mems.length ? 'none' : 'flex';
                    },
                    text: 'No members loaded yet.',
                    fontSize: 'Z2',
                    color: 'caption'
                }
            }
        },
        ModalFooter: {
            flow: 'x',
            gap: 'Z1',
            childExtends: 'Button',
            SaveBtn: {
                theme: 'primary',
                text: 'Save',
                onClick: async (e, el, s)=>{
                    const ch = $7f401cf993d62750$var$_curChannel(s.root);
                    if (!ch) return;
                    const d = $7f401cf993d62750$var$_draft(s.root);
                    await el.call('updateChannel', ch.id, {
                        name: d.name || null,
                        topic: d.topic || null,
                        is_private: !!d.is_private
                    });
                    s.root.update({
                        showChannelSettings: null
                    });
                }
            }
        }
    }
};
const $7f401cf993d62750$export$6fa363666c71b120 = {
    flow: 'x',
    align: 'center left',
    gap: 'Z1',
    padding: 'Y Z',
    round: 'Z',
    background: 'overlay',
    Avatar: {
        avatarType: 'initials',
        boxSize: 'B B',
        src: (el, s)=>el.call('avatarUrl', s.email)
    },
    Info: {
        flow: 'y',
        flex: '1',
        minWidth: '0',
        Name: {
            tag: 'span',
            fontSize: 'Z2',
            color: 'title',
            text: (el, s)=>{
                const p = el.call('findPerson', s.email);
                return p && p.name || s.email || '';
            }
        },
        Role: {
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            text: (el, s)=>s.role || 'member'
        }
    }
};

});

parcelRegister("lPE0G", function(module, exports) {

$parcel$export(module.exports, "ChatThreadPanel", () => $fe4d659130d071b3$export$7bab10434014f53f);
$parcel$export(module.exports, "ChatThreadReplyRow", () => $fe4d659130d071b3$export$abab3a28e54010e8);
// Right-side thread drawer. Fixed Header, scroll-area Body, compact Footer.

var $5WCCa = parcelRequire("5WCCa");

var $htapf = parcelRequire("htapf");
const $fe4d659130d071b3$var$_parentMessage = (root)=>{
    if (!root || !root.activeChannelId || !root.activeThreadRootId) return null;
    const list = (root.messagesByChannel || {})[root.activeChannelId] || [];
    return list.find((m)=>m.id === root.activeThreadRootId) || null;
};
const $fe4d659130d071b3$var$_isMine = (s)=>!!(s && s.root && s.authorEmail && s.authorEmail === s.root.currentUserEmail);
const $fe4d659130d071b3$export$7bab10434014f53f = {
    flow: 'y',
    width: 'I',
    minWidth: 'H',
    maxWidth: 'I1',
    height: '100%',
    minHeight: '0',
    background: 'document',
    Header: {
        flow: 'x',
        align: 'center space-between',
        padding: 'A B',
        borderBottomWidth: '1px',
        borderBottomColor: 'line',
        borderBottomStyle: 'solid',
        flex: '0 0 auto',
        TitleGroup: {
            flow: 'y',
            gap: 'V',
            Title: {
                tag: 'h3',
                margin: '0',
                fontSize: 'A',
                fontWeight: '700',
                color: 'title',
                text: 'Thread'
            },
            Subtitle: {
                tag: 'span',
                fontSize: 'Y2',
                color: 'caption',
                text: (el, s)=>{
                    const root = s && s.root;
                    if (!root) return '';
                    const ch = (root.channels || []).find((c)=>c.id === root.activeChannelId);
                    if (!ch) return '';
                    if (ch.kind === 'channel') return '# ' + (ch.name || '');
                    if (ch.kind === 'dm') return 'Direct message';
                    // group_dm — show first names of the other participants
                    return el.call('channelDisplayName', ch, root.channelMembers || [], el.call('peopleByEmail'), root.currentUserEmail, {
                        firstOnly: true
                    });
                }
            }
        },
        CloseBtn: {
            extends: 'IconButton',
            Icon: {
                icon: 'dismiss'
            },
            attr: {
                'data-action': 'close-thread'
            }
        }
    },
    Body: {
        flex: '1 1 0',
        minHeight: '0',
        flow: 'y',
        overflow: 'auto',
        overscrollBehavior: 'contain',
        padding: 'A',
        gap: 'A',
        onCreate: (el)=>{
            if (!el || !el.node) return;
            // Reuse the shared overlay for thread replies — same positioning
            // semantics as the main message list.
            (0, $htapf.setupHoverActions)(el.node);
            requestAnimationFrame(()=>requestAnimationFrame(()=>{
                    if (el && el.node) el.node.scrollTop = el.node.scrollHeight;
                }));
        },
        onUpdate: (el, s)=>{
            if (!el || !el.node) return;
            const root = s && s.root;
            const ch = root && root.activeChannelId;
            const tid = root && root.activeThreadRootId;
            const list = root && root.messagesByChannel && root.messagesByChannel[ch] || [];
            const replyCount = list.filter((m)=>m.threadRoot === tid).length;
            const sig = `${tid}:${replyCount}`;
            if (el._lastSig === sig) return;
            el._lastSig = sig;
            requestAnimationFrame(()=>requestAnimationFrame(()=>{
                    if (el && el.node) el.node.scrollTop = el.node.scrollHeight;
                }));
        },
        // Parent message — the root of the thread.
        Parent: {
            flow: 'x',
            gap: 'Z1',
            paddingBottom: 'A',
            borderBottomWidth: '1px',
            borderBottomColor: 'line',
            borderBottomStyle: 'solid',
            Avatar: {
                avatarType: 'initials',
                boxSize: 'B1 B1',
                round: '50%',
                flex: '0 0 auto',
                cursor: 'pointer',
                attr: {
                    'data-personrow': 'true',
                    'data-email': (el, s)=>{
                        const parent = $fe4d659130d071b3$var$_parentMessage(s && s.root);
                        return parent && parent.authorEmail || '';
                    }
                },
                src: (el, s)=>{
                    const parent = $fe4d659130d071b3$var$_parentMessage(s && s.root);
                    const person = parent && el.call('findPerson', parent.authorEmail);
                    return el.call('avatarUrl', person && person.name || parent && parent.authorEmail);
                }
            },
            Content: {
                flex: '1 1 0',
                flow: 'y',
                gap: '0',
                minWidth: '0',
                Meta: {
                    flow: 'x',
                    gap: 'Z',
                    align: 'baseline left',
                    Author: {
                        tag: 'span',
                        fontSize: 'Z2',
                        fontWeight: '700',
                        color: 'title',
                        text: (el, s)=>{
                            const parent = $fe4d659130d071b3$var$_parentMessage(s && s.root);
                            const person = parent && el.call('findPerson', parent.authorEmail);
                            return person && person.name || parent && parent.authorEmail || '';
                        }
                    },
                    Time: {
                        tag: 'span',
                        fontSize: 'Y2',
                        color: 'caption',
                        text: (el, s)=>{
                            const parent = $fe4d659130d071b3$var$_parentMessage(s && s.root);
                            return parent && parent.createdAt ? el.call('clockTime', parent.createdAt) : '';
                        }
                    }
                },
                Body: {
                    tag: 'div',
                    fontSize: 'Z2',
                    lineHeight: '1.5',
                    color: 'title',
                    wordBreak: 'break-word',
                    padding: (el, s)=>{
                        const p = $fe4d659130d071b3$var$_parentMessage(s && s.root);
                        return p && p.body ? 'Z1 A' : '0';
                    },
                    round: 'A A A V',
                    background: (el, s)=>{
                        const p = $fe4d659130d071b3$var$_parentMessage(s && s.root);
                        return p && p.body ? 'white.06' : 'transparent';
                    },
                    borderWidth: (el, s)=>{
                        const p = $fe4d659130d071b3$var$_parentMessage(s && s.root);
                        return p && p.body ? '1px' : '0';
                    },
                    borderStyle: 'solid',
                    borderColor: 'white.08',
                    marginTop: (el, s)=>{
                        const p = $fe4d659130d071b3$var$_parentMessage(s && s.root);
                        return p && p.body ? 'Z' : '0';
                    },
                    maxWidth: '100%',
                    // Use reactive `text` so the body always renders even when
                    // el.set() from renderMarkdown misses due to timing. The
                    // onUpdate will upgrade it to formatted markdown when it fires.
                    text: (el, s)=>{
                        const p = $fe4d659130d071b3$var$_parentMessage(s && s.root);
                        return p && p.body || '';
                    },
                    onUpdate: (el, s)=>{
                        const p = $fe4d659130d071b3$var$_parentMessage(s && s.root);
                        if (p && p.body) (0, $5WCCa.renderMarkdown)(el, p.body, null, s.root.people);
                    }
                }
            }
        },
        ReplyCount: {
            tag: 'span',
            fontSize: 'Y2',
            fontWeight: '600',
            color: 'caption',
            letterSpacing: '.04em',
            padding: 'V 0',
            text: (el, s)=>{
                const root = s && s.root;
                if (!root || !root.activeChannelId) return '';
                const list = (root.messagesByChannel || {})[root.activeChannelId] || [];
                const n = list.filter((m)=>m.threadRoot === root.activeThreadRootId).length;
                return n === 0 ? 'No replies yet' : `${n} repl${n === 1 ? 'y' : 'ies'}`;
            }
        },
        Replies: {
            flow: 'y',
            gap: 'Z',
            childExtends: 'ChatThreadReplyRow',
            childrenAs: 'state',
            children: (el, s)=>{
                const root = s && s.root;
                if (!root || !root.activeChannelId || !root.activeThreadRootId) return [];
                const map = root.messagesByChannel || {};
                const list = map[root.activeChannelId] || [];
                return list.filter((m)=>m.threadRoot === root.activeThreadRootId);
            }
        }
    },
    Footer: {
        flow: 'y',
        position: 'relative',
        padding: 'Z A',
        background: 'transparent',
        flex: '0 0 auto',
        // Send icon pinned top-right, matching the main composer pattern.
        SendBtn: {
            extends: 'IconButton',
            position: 'absolute',
            top: 'Z',
            right: 'Z',
            zIndex: '1',
            Icon: {
                icon: 'arrowAngleRight'
            },
            '@dark': {
                background: 'white',
                color: 'title',
                ':hover': {
                    background: 'gray14',
                    color: 'gray1'
                },
                ':active': {
                    background: 'gray13',
                    color: 'gray1'
                }
            },
            onClick: (e, el, s)=>{
                e.preventDefault();
                const root = s && s.root;
                if (!root || !root.activeChannelId || !root.activeThreadRootId) return;
                const ta = el.parent && el.parent.Field && el.parent.Field.node;
                const body = (ta && ta.value || '').trim();
                if (!body) return;
                el.call('sendMessage', {
                    channelId: root.activeChannelId,
                    body: body,
                    replyTo: root.activeThreadRootId,
                    threadRoot: root.activeThreadRootId
                });
                if (ta) {
                    ta.value = '';
                    ta.style.height = 'auto';
                }
            }
        },
        Field: {
            tag: 'textarea',
            width: '100%',
            minHeight: 'B1',
            maxHeight: 'E',
            padding: 'Z A',
            round: 'A',
            theme: 'field',
            color: 'title',
            fontSize: 'Z2',
            lineHeight: '1.5',
            resize: 'none',
            outline: 'none',
            attr: {
                placeholder: "Reply to thread\u2026",
                rows: 2
            },
            onInput: (e, el)=>{
                if (el && el.node) {
                    el.node.style.height = 'auto';
                    el.node.style.height = Math.min(el.node.scrollHeight, 200) + 'px';
                }
            },
            onKeydown: (e, el, s)=>{
                if (e.key !== 'Enter' || e.shiftKey) return;
                e.preventDefault();
                const root = s && s.root;
                if (!root || !root.activeChannelId || !root.activeThreadRootId) return;
                const body = (e.target.value || '').trim();
                if (!body) return;
                el.call('sendMessage', {
                    channelId: root.activeChannelId,
                    body: body,
                    replyTo: root.activeThreadRootId,
                    threadRoot: root.activeThreadRootId
                });
                e.target.value = '';
                if (el.node) el.node.style.height = 'auto';
            }
        }
    }
};
const $fe4d659130d071b3$export$abab3a28e54010e8 = {
    flow: 'x',
    gap: 'Z1',
    align: 'flex-start left',
    padding: 'Z 0',
    Avatar: {
        avatarType: 'initials',
        boxSize: 'B1 B1',
        round: '50%',
        flex: '0 0 auto',
        cursor: 'pointer',
        attr: {
            'data-personrow': 'true',
            'data-email': (el, s)=>s && s.authorEmail || ''
        },
        src: (el, s)=>{
            if (!s) return el.call('avatarUrl', null);
            const person = el.call('findPerson', s.authorEmail);
            return el.call('avatarUrl', person && person.name || s.authorEmail);
        }
    },
    Content: {
        flex: '1 1 0',
        flow: 'y',
        gap: '0',
        minWidth: '0',
        Meta: {
            flow: 'x',
            gap: 'Z',
            align: 'baseline left',
            Author: {
                tag: 'span',
                fontSize: 'Z2',
                fontWeight: '700',
                color: 'title',
                text: (el, s)=>{
                    if (!s) return '';
                    const person = el.call('findPerson', s.authorEmail);
                    return person && person.name || s.authorEmail || '';
                }
            },
            Time: {
                tag: 'span',
                fontSize: 'Y2',
                color: 'caption',
                text: (el, s)=>s && s.createdAt ? el.call('clockTime', s.createdAt) : ''
            }
        },
        Body: {
            hide: (el, s)=>!(s && s.body),
            tag: 'div',
            fontSize: 'Z2',
            lineHeight: '1.5',
            color: 'title',
            wordBreak: 'break-word',
            padding: 'Z1 A',
            round: (el, s)=>$fe4d659130d071b3$var$_isMine(s) ? 'A A V A' : 'A A A V',
            background: (el, s)=>$fe4d659130d071b3$var$_isMine(s) ? 'blue.08' : 'white.06',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: (el, s)=>$fe4d659130d071b3$var$_isMine(s) ? 'blue.15' : 'white.08',
            marginTop: 'V',
            maxWidth: '100%',
            text: (el, s)=>s && s.body || '',
            onUpdate: (el, s)=>{
                if (s && s.body) (0, $5WCCa.renderMarkdown)(el, s.body, null, s && s.root && s.root.people);
            }
        }
    }
};

});

parcelRegister("dIbQ8", function(module, exports) {

$parcel$export(module.exports, "ChatSearchPanel", () => $9fb89190af0f9319$export$b35dfb3fb21962c8);
$parcel$export(module.exports, "ChatSearchResultRow", () => $9fb89190af0f9319$export$54712c9ab880970c);
// Full-screen search overlay. Triggered from the sidebar Search box (or ⌘K).
// Calls chat_search_messages RPC, ranks by ts_rank, and renders results
// grouped by channel. Clicking a result jumps to that channel.
const $9fb89190af0f9319$export$b35dfb3fb21962c8 = {
    hide: (el, s)=>!(s && s.root && s.root.searchOpen),
    position: 'fixed',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    zIndex: 2100,
    flow: 'y',
    align: 'flex-start center',
    paddingTop: 'C',
    background: 'black.5',
    attr: {
        'data-search-scrim': 'true'
    },
    Card: {
        flow: 'y',
        width: 'J',
        maxWidth: '90vw',
        maxHeight: '80vh',
        round: 'Z2',
        theme: 'modal',
        borderWidth: '1px',
        borderColor: 'line',
        borderStyle: 'solid',
        boxShadow: '0 16px 48px var(--color-shadow)',
        overflow: 'hidden',
        Header: {
            flow: 'x',
            align: 'center left',
            gap: 'Z1',
            padding: 'A B',
            borderBottomWidth: '1px',
            borderBottomColor: 'line',
            borderBottomStyle: 'solid',
            Icon: {
                tag: 'span',
                text: "\uD83D\uDD0D",
                fontSize: 'A',
                color: 'caption'
            },
            Input: {
                tag: 'input',
                flex: '1',
                padding: 'V 0',
                border: 'none',
                outline: 'none',
                background: 'transparent',
                color: 'title',
                fontSize: 'A',
                attr: {
                    placeholder: "Search all messages\u2026",
                    autofocus: true
                },
                onInput: (e, el)=>{
                    el.call('searchMessages', e.target.value);
                },
                onKeydown: (e, el, s)=>{
                    if (e.key === 'Escape') el.call('closeSearch');
                }
            },
            CloseBtn: {
                tag: 'button',
                type: 'button',
                text: 'Esc',
                padding: 'V Z',
                round: 'V',
                border: 'none',
                background: 'overlay',
                color: 'caption',
                cursor: 'pointer',
                fontSize: 'Y2',
                attr: {
                    'data-action': 'close-search'
                }
            }
        },
        Body: {
            flex: '1',
            flow: 'y',
            overflow: 'auto',
            Empty: {
                if: (el, s)=>{
                    const root = s && s.root;
                    if (!root) return false;
                    if (!root.searchQuery) return true;
                    return (root.searchResults || []).length === 0;
                },
                flow: 'y',
                align: 'center center',
                padding: 'C',
                color: 'caption',
                fontSize: 'Z2',
                text: (el, s)=>{
                    if (!s.root.searchQuery) return 'Type to search messages across every channel you belong to.';
                    return `No matches for "${s.root.searchQuery}"`;
                }
            },
            Results: {
                flow: 'y',
                childExtends: 'ChatSearchResultRow',
                childrenAs: 'state',
                children: (el, s)=>s && s.root && s.root.searchResults || []
            }
        }
    }
};
const $9fb89190af0f9319$export$54712c9ab880970c = {
    flow: 'y',
    gap: 'V',
    padding: 'A B',
    borderBottomWidth: '1px',
    borderBottomColor: 'line',
    borderBottomStyle: 'solid',
    cursor: 'pointer',
    ':hover': {
        background: 'overlay'
    },
    attr: {
        'data-search-jump': (el, s)=>String(s && s.id || '')
    },
    Meta: {
        flow: 'x',
        gap: 'Z',
        align: 'baseline left',
        Channel: {
            tag: 'span',
            fontSize: 'Y2',
            fontWeight: '600',
            color: 'accent',
            text: (el, s)=>{
                if (!s) return '';
                if (s.channel_kind === 'channel') return '#' + (s.channel_name || 'channel');
                return 'DM';
            }
        },
        Author: {
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            text: (el, s)=>{
                if (!s) return '';
                const root = s.root;
                const person = el.call('findPerson', s.author_email);
                return person && person.name || s.author_email || '';
            }
        },
        Time: {
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            text: (el, s)=>s && s.created_at ? el.call('clockTime', s.created_at) : ''
        }
    },
    Body: {
        tag: 'div',
        fontSize: 'Z2',
        color: 'subtitle',
        lineHeight: '1.5',
        text: (el, s)=>s && s.body || ''
    }
};

});

parcelRegister("laIZe", function(module, exports) {

$parcel$export(module.exports, "ChatMentionDropdown", () => $f69d6d8c9229ded3$export$8f11fcd6196575a2);
$parcel$export(module.exports, "ChatMentionRow", () => $f69d6d8c9229ded3$export$61aaf3df4e8c577);
// Floating autocomplete shown above the composer for @mentions,
// #channels, ##tickets, @@events, and +references.
const $f69d6d8c9229ded3$export$8f11fcd6196575a2 = {
    hide: (el, s)=>!(s && s.root && s.root.mentionPicker && (s.root.mentionPicker.options || []).length > 0),
    position: 'fixed',
    zIndex: 2050,
    flow: 'y',
    width: 'G',
    maxHeight: 'F',
    round: 'Z',
    theme: 'modal',
    borderWidth: '1px',
    borderColor: 'line',
    borderStyle: 'solid',
    boxShadow: '0 8px 24px var(--color-shadow)',
    overflow: 'auto',
    bottom: (el, s)=>{
        const picker = s && s.root && s.root.mentionPicker;
        if (!picker) return 'auto';
        const editorBottom = typeof window !== 'undefined' ? window.innerHeight - (picker.top + 240) : 100;
        return `${Math.max(8, editorBottom)}px`;
    },
    left: (el, s)=>s && s.root && s.root.mentionPicker ? `${Math.max(8, s.root.mentionPicker.left)}px` : '0',
    childExtends: 'ChatMentionRow',
    childrenAs: 'state',
    children: (el, s)=>{
        const picker = s && s.root && s.root.mentionPicker;
        if (!picker || !picker.options) return [];
        return picker.options.map((p, i)=>({
                ...p,
                _idx: i,
                _active: i === (picker.activeIndex || 0),
                _pickerType: picker.type || 'person'
            }));
    }
};
const $f69d6d8c9229ded3$export$61aaf3df4e8c577 = {
    flow: 'x',
    align: 'center left',
    gap: 'Z',
    padding: 'Y2 Z',
    cursor: 'pointer',
    round: 'Z',
    background: (el, s)=>s && s._active ? 'overlay' : 'transparent',
    ':hover': {
        background: 'overlay'
    },
    attr: {
        'data-mention-pick': (el, s)=>{
            if (!s) return '';
            const t = s._pickerType;
            if (t === 'person') return s.email || '';
            if (t === 'channel') return s.name || '';
            if (t === 'ticket') return String(s.number || s.id || '');
            if (t === 'event') return s.title || '';
            if (t === 'reference') return s.title || '';
            return '';
        }
    },
    Icon_prefix: {
        tag: 'span',
        fontSize: 'Z2',
        color: 'caption',
        fontWeight: '600',
        display: (el, s)=>s && s._pickerType !== 'person' ? 'inline' : 'none',
        text: (el, s)=>{
            if (!s) return '';
            const t = s._pickerType;
            if (t === 'channel') return '#';
            if (t === 'ticket') return '##';
            if (t === 'event') return '@@';
            if (t === 'reference') return '+';
            return '';
        }
    },
    Avatar: {
        display: (el, s)=>s && s._pickerType === 'person' ? 'flex' : 'none',
        avatarType: 'initials',
        boxSize: 'A1 A1',
        src: (el, s)=>el.call('avatarUrl', s && s.name)
    },
    Info: {
        flow: 'y',
        gap: 'V',
        flex: '1',
        minWidth: '0',
        Name: {
            tag: 'span',
            fontSize: 'Z2',
            color: 'title',
            fontWeight: '600',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>{
                if (!s) return '';
                const t = s._pickerType;
                if (t === 'person') return s.name || '';
                if (t === 'channel') return s.name || '';
                if (t === 'ticket') return (s.number ? `#${s.number} \xb7 ` : '') + (s.title || '');
                if (t === 'event') return s.title || '';
                if (t === 'reference') return s.title || '';
                return s.name || s.title || '';
            }
        },
        Detail: {
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>{
                if (!s) return '';
                const t = s._pickerType;
                if (t === 'person') return s.email ? '@' + s.email.split('@')[0] : '';
                if (t === 'channel') return s.topic || '';
                if (t === 'ticket') return s.state || s.column_key || '';
                if (t === 'event') return s.date || '';
                if (t === 'reference') return s._refType || '';
                return '';
            },
            display: (el, s)=>{
                if (!s) return 'none';
                const t = s._pickerType;
                if (t === 'person') return s.email ? 'block' : 'none';
                if (t === 'channel') return s.topic ? 'block' : 'none';
                return 'block';
            }
        }
    }
};

});

parcelRegister("llQg9", function(module, exports) {

$parcel$export(module.exports, "ChatFilterBar", () => $f8b418ca59d90197$export$34b2c167beab0bca);
$parcel$export(module.exports, "ChatAuthorOption", () => $f8b418ca59d90197$export$880aedeaa938b684);
$parcel$export(module.exports, "ChatFilterToggle", () => $f8b418ca59d90197$export$2328b58827205693);
$parcel$export(module.exports, "ChatFilesView", () => $f8b418ca59d90197$export$8cb828a6f6a548fb);
$parcel$export(module.exports, "ChatFileCard", () => $f8b418ca59d90197$export$be8e6aa667e482a6);
$parcel$export(module.exports, "ChatLinksView", () => $f8b418ca59d90197$export$93dd371eb54a6382);
$parcel$export(module.exports, "ChatLinkRow", () => $f8b418ca59d90197$export$5ad3a96d265d9da7);
$parcel$export(module.exports, "ChatTicketsView", () => $f8b418ca59d90197$export$ef28380e0ac292d8);
$parcel$export(module.exports, "ChatTicketRow", () => $f8b418ca59d90197$export$6e26aea64abc6dd5);
// Filter bar + the four content views (Conversation, Files, Links,
// Tickets) the channel header's TabSwitcher swaps between via
// `root.activeTab`. The tab bar itself lives in Main.js — it uses
// SharedViewSwitcher from shared-gov.

var $lwYfR = parcelRequire("lwYfR");
// Cache the per-channel "no threads" filter so the Files / Links /
// Tickets collectors can hit the messageScans WeakMap caches with a
// stable array reference. Keyed off the source `root.messagesByChannel`
// reference + active channel id; rebuilds whenever either changes.
const $f8b418ca59d90197$var$_channelMessagesCache = new WeakMap();
const $f8b418ca59d90197$var$_channelMessages = (root)=>{
    if (!root || !root.activeChannelId) return $f8b418ca59d90197$var$_EMPTY;
    const map = root.messagesByChannel || {};
    const src = map[root.activeChannelId];
    if (!src || !src.length) return $f8b418ca59d90197$var$_EMPTY;
    let cached = $f8b418ca59d90197$var$_channelMessagesCache.get(map);
    if (!cached) {
        cached = {};
        $f8b418ca59d90197$var$_channelMessagesCache.set(map, cached);
    }
    const slot = cached[root.activeChannelId];
    if (slot && slot.src === src) return slot.list;
    const list = src.filter((m)=>!m.threadRoot);
    cached[root.activeChannelId] = {
        src: src,
        list: list
    };
    return list;
};
const $f8b418ca59d90197$var$_EMPTY = Object.freeze([]);
const $f8b418ca59d90197$export$34b2c167beab0bca = {
    hide: (el, s)=>!(s && s.root && s.root.activeTab === 'conversation' && s.root.showFilterBar),
    flow: 'x wrap',
    align: 'center left',
    gap: 'Z1',
    padding: 'Z B1',
    borderBottomWidth: '1px',
    borderBottomColor: 'overlay',
    borderBottomStyle: 'solid',
    background: 'overlayStrong',
    flex: '0 0 auto',
    // Anchor for the filters-clear delegate's local input/select reset.
    attr: {
        'data-filter-bar': 'true'
    },
    Search: {
        tag: 'input',
        flex: '1',
        minWidth: 'G',
        padding: 'V Z1',
        round: 'C',
        borderWidth: '1px',
        borderColor: 'line',
        borderStyle: 'solid',
        background: 'overlay',
        color: 'title',
        fontSize: 'Y2',
        placeholder: "Filter messages in this channel\u2026",
        onInput: (e, el, s)=>{
            const root = s && s.root;
            if (!root) return;
            root.update({
                filters: {
                    ...root.filters,
                    query: e.target.value
                }
            });
        }
    },
    AuthorSelect: {
        tag: 'select',
        padding: 'V Z',
        round: 'C',
        borderWidth: '1px',
        borderColor: 'line',
        borderStyle: 'solid',
        background: 'overlay',
        color: 'title',
        fontSize: 'Y2',
        cursor: 'pointer',
        onChange: (e, el, s)=>{
            const root = s && s.root;
            if (!root) return;
            root.update({
                filters: {
                    ...root.filters,
                    authorEmail: e.target.value || null
                }
            });
        },
        childExtends: 'ChatAuthorOption',
        childrenAs: 'state',
        children: (el, s)=>{
            const root = s && s.root;
            if (!root) return [
                {
                    value: '',
                    label: 'All authors'
                }
            ];
            const msgs = $f8b418ca59d90197$var$_channelMessages(root);
            const authors = (0, $lwYfR.collectAuthors)(msgs);
            return [
                {
                    value: '',
                    label: 'All authors'
                },
                ...authors.map((email)=>{
                    const p = el.call('findPerson', email);
                    return {
                        value: email,
                        label: p && p.name || email
                    };
                })
            ];
        }
    },
    HasAttachments: {
        extends: 'ChatFilterToggle',
        label: "\uD83D\uDCCE Attachments",
        field: 'hasAttachments'
    },
    HasMentions: {
        extends: 'ChatFilterToggle',
        label: '@ Mentions',
        field: 'hasMentions'
    },
    ClearBtn: {
        tag: 'button',
        type: 'button',
        padding: 'V Z',
        round: 'C',
        border: 'none',
        background: 'transparent',
        color: 'caption',
        cursor: 'pointer',
        fontSize: 'Y2',
        fontWeight: '600',
        text: 'Clear',
        attr: {
            'data-action': 'filters-clear'
        },
        ':hover': {
            color: 'title'
        }
    }
};
const $f8b418ca59d90197$export$880aedeaa938b684 = {
    tag: 'option',
    attr: {
        value: (el, s)=>s && s.value || '',
        selected: (el, s)=>{
            if (!s || !el || !el.parent) return null;
            const root = el.parent.state && el.parent.state.root;
            const cur = root && root.filters && root.filters.authorEmail || '';
            return s.value === cur ? 'selected' : null;
        }
    },
    text: (el, s)=>s && s.label || ''
};
const $f8b418ca59d90197$export$2328b58827205693 = {
    tag: 'button',
    type: 'button',
    padding: 'V Z',
    round: 'C',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: (el, s)=>{
        const f = s && s.root && s.root.filters;
        return f && f[el.field] ? 'cyan' : 'line';
    },
    background: (el, s)=>{
        const f = s && s.root && s.root.filters;
        return f && f[el.field] ? 'cyan.2' : 'overlay';
    },
    color: (el, s)=>{
        const f = s && s.root && s.root.filters;
        return f && f[el.field] ? 'cyan' : 'caption';
    },
    cursor: 'pointer',
    fontSize: 'Y2',
    fontWeight: '600',
    text: (el)=>el.label || '',
    transition: 'all 120ms ease',
    attr: {
        'data-filter-toggle': (el)=>el.field || ''
    }
};
const $f8b418ca59d90197$export$8cb828a6f6a548fb = {
    hide: (el, s)=>!(s && s.root && s.root.activeTab === 'files'),
    flex: '1 1 0',
    minHeight: '0',
    flow: 'y',
    overflow: 'auto',
    padding: 'B B1',
    gap: 'A',
    Empty: {
        if: (el, s)=>{
            const root = s && s.root;
            if (!root) return true;
            return (0, $lwYfR.collectAttachments)($f8b418ca59d90197$var$_channelMessages(root)).length === 0;
        },
        flow: 'y',
        align: 'center center',
        flex: '1',
        color: 'caption',
        fontSize: 'A',
        padding: 'C',
        text: 'No files shared in this channel yet.'
    },
    Grid: {
        flow: 'x wrap',
        gap: 'Z1',
        childExtends: 'ChatFileCard',
        childrenAs: 'state',
        children: (el, s)=>{
            const root = s && s.root;
            if (!root) return [];
            return (0, $lwYfR.collectAttachments)($f8b418ca59d90197$var$_channelMessages(root));
        }
    }
};
const $f8b418ca59d90197$var$_isMediaFile = (mime)=>mime && (mime.startsWith('image/') || mime.startsWith('video/'));
const $f8b418ca59d90197$export$be8e6aa667e482a6 = {
    flow: 'y',
    gap: 'V',
    padding: 'Z',
    round: 'Z1',
    background: 'overlay',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'line',
    width: 'I',
    cursor: 'pointer',
    transition: 'border-color 120ms ease, transform 120ms ease',
    ':hover': {
        borderColor: 'overlayStrong',
        transform: 'translateY(-2px)'
    },
    onClick: (e, el, s)=>{
        if (!s || !s.url) return;
        if ($f8b418ca59d90197$var$_isMediaFile(s.mime)) s.root.update({
            lightbox: {
                url: s.url,
                mime: s.mime,
                name: s.name
            }
        });
        else window.open(s.url, '_blank');
    },
    ImageThumb: {
        hide: (el, s)=>!(s && s.mime && s.mime.startsWith('image/')),
        tag: 'img',
        width: '100%',
        height: 'F',
        round: 'Z',
        objectFit: 'cover',
        src: (el, s)=>s.url,
        alt: (el, s)=>s.name || 'image'
    },
    VideoThumb: {
        hide: (el, s)=>!(s && s.mime && s.mime.startsWith('video/')),
        tag: 'video',
        width: '100%',
        height: 'F',
        round: 'Z',
        objectFit: 'cover',
        src: (el, s)=>s.url,
        preload: 'metadata'
    },
    IconBlock: {
        hide: (el, s)=>!!(s && $f8b418ca59d90197$var$_isMediaFile(s.mime)),
        flow: 'y',
        align: 'center center',
        height: 'F',
        background: 'overlay',
        round: 'Z',
        Icon: {
            tag: 'span',
            fontSize: 'C',
            text: (el, s)=>{
                if (!s) return "\uD83D\uDCC4";
                const m = s.mime || '';
                if (m.startsWith('audio/')) return "\uD83C\uDFB5";
                if (m.includes('pdf')) return "\uD83D\uDCD5";
                if (m.includes('zip') || m.includes('archive')) return "\uD83D\uDDDC";
                return "\uD83D\uDCC4";
            }
        }
    },
    Name: {
        tag: 'span',
        fontSize: 'Z2',
        fontWeight: '600',
        color: 'title',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        text: (el, s)=>s && s.name || ''
    },
    Footer: {
        flow: 'x',
        align: 'center space-between',
        gap: 'Z',
        Meta: {
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            flex: '1',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>{
                if (!s) return '';
                const root = s.root;
                const person = root && el.call('findPerson', s.authorEmail);
                const who = person && person.name || s.authorEmail || '';
                return `${el.call('formatBytes', s.size)} \xb7 ${who}`;
            }
        },
        GoToMsg: {
            tag: 'button',
            type: 'button',
            text: 'Go to message',
            fontSize: 'Y1',
            fontWeight: '600',
            padding: 'V Z',
            round: 'V',
            borderWidth: '0',
            background: 'transparent',
            color: 'blue',
            cursor: 'pointer',
            whiteSpace: 'nowrap',
            ':hover': {
                background: 'blue.1'
            },
            onClick: (e, el, s)=>{
                e.stopPropagation();
                if (!s || !s.messageId) return;
                const msgId = s.messageId;
                const root = s.root;
                const chId = root.activeChannelId;
                root.update({
                    activeTab: 'conversation'
                });
                const PAGE = 50;
                const tryScroll = (attempt)=>{
                    if (attempt > 40) return;
                    const msgEl = document.getElementById('msg-' + msgId);
                    if (msgEl) {
                        msgEl.scrollIntoView({
                            behavior: 'smooth',
                            block: 'center'
                        });
                        msgEl.style.outline = '2px solid var(--color-blue)';
                        msgEl.style.outlineOffset = '2px';
                        msgEl.style.borderRadius = '8px';
                        setTimeout(()=>{
                            msgEl.style.outline = '';
                            msgEl.style.outlineOffset = '';
                            msgEl.style.borderRadius = '';
                        }, 2000);
                        return;
                    }
                    // Expand visible count directly via state
                    const counts = root.chatVisibleCounts || {};
                    const cur = counts[chId] || PAGE;
                    const map = root.messagesByChannel || {};
                    const total = (map[chId] || []).filter((m)=>!m.threadRoot).length;
                    if (cur < total) root.update({
                        chatVisibleCounts: {
                            ...counts,
                            [chId]: Math.min(cur + PAGE, total)
                        }
                    });
                    requestAnimationFrame(()=>setTimeout(()=>tryScroll(attempt + 1), 50));
                };
                requestAnimationFrame(()=>tryScroll(0));
            }
        }
    }
};
const $f8b418ca59d90197$export$93dd371eb54a6382 = {
    hide: (el, s)=>!(s && s.root && s.root.activeTab === 'links'),
    flex: '1 1 0',
    minHeight: '0',
    flow: 'y',
    overflow: 'auto',
    padding: 'B B1',
    gap: 'V',
    Empty: {
        if: (el, s)=>{
            const root = s && s.root;
            if (!root) return true;
            return (0, $lwYfR.collectLinks)($f8b418ca59d90197$var$_channelMessages(root)).length === 0;
        },
        flow: 'y',
        align: 'center center',
        flex: '1',
        color: 'caption',
        fontSize: 'A',
        padding: 'C',
        text: 'No links shared in this channel yet.'
    },
    List: {
        flow: 'y',
        gap: 'V',
        childExtends: 'ChatLinkRow',
        childrenAs: 'state',
        children: (el, s)=>{
            const root = s && s.root;
            if (!root) return [];
            return (0, $lwYfR.collectLinks)($f8b418ca59d90197$var$_channelMessages(root));
        }
    }
};
const $f8b418ca59d90197$export$5ad3a96d265d9da7 = {
    flow: 'y',
    gap: 'V',
    padding: 'Z A',
    round: 'Z',
    cursor: 'pointer',
    background: 'overlay',
    borderLeftWidth: '2px',
    borderLeftStyle: 'solid',
    borderLeftColor: 'cyan',
    transition: 'background 120ms ease',
    ':hover': {
        background: 'line'
    },
    attr: {
        'data-link': (el, s)=>s && s.url || ''
    },
    Url: {
        tag: 'span',
        fontSize: 'Z2',
        fontWeight: '600',
        color: 'cyan',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        text: (el, s)=>s && s.url || ''
    },
    Meta: {
        tag: 'span',
        fontSize: 'Y2',
        color: 'caption',
        text: (el, s)=>{
            if (!s) return '';
            const root = s.root;
            const person = root && el.call('findPerson', s.authorEmail);
            const who = person && person.name || s.authorEmail || '';
            const when = s.createdAt ? `${el.call('dayLabel', s.createdAt)} \xb7 ${el.call('clockTime', s.createdAt)}` : '';
            return `${who} \xb7 ${when}`;
        }
    }
};
const $f8b418ca59d90197$export$ef28380e0ac292d8 = {
    hide: (el, s)=>!(s && s.root && s.root.activeTab === 'tickets'),
    flex: '1 1 0',
    minHeight: '0',
    flow: 'y',
    overflow: 'auto',
    padding: 'B B1',
    gap: 'V',
    Empty: {
        if: (el, s)=>{
            const root = s && s.root;
            if (!root) return true;
            return (0, $lwYfR.collectTickets)($f8b418ca59d90197$var$_channelMessages(root)).length === 0;
        },
        flow: 'y',
        align: 'center center',
        flex: '1',
        color: 'caption',
        fontSize: 'A',
        padding: 'C',
        text: 'No tickets referenced in this channel yet. Use #PROJECT-123 syntax to link tickets.'
    },
    List: {
        flow: 'y',
        gap: 'V',
        childExtends: 'ChatTicketRow',
        childrenAs: 'state',
        children: (el, s)=>{
            const root = s && s.root;
            if (!root) return [];
            return (0, $lwYfR.collectTickets)($f8b418ca59d90197$var$_channelMessages(root));
        }
    }
};
const $f8b418ca59d90197$export$6e26aea64abc6dd5 = {
    flow: 'x',
    gap: 'A',
    align: 'center left',
    padding: 'Z A',
    round: 'Z',
    cursor: 'pointer',
    background: 'overlay',
    transition: 'background 120ms ease',
    ':hover': {
        background: 'line'
    },
    Tag: {
        tag: 'span',
        padding: 'V Z',
        round: 'C',
        background: 'cyan.2',
        color: 'cyan',
        fontSize: 'Y2',
        fontWeight: '700',
        fontFamily: 'monospace',
        text: (el, s)=>s && s.ref ? '#' + s.ref : ''
    },
    Body: {
        tag: 'span',
        flex: '1',
        fontSize: 'Z2',
        color: 'subtitle',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        text: (el, s)=>s && s.body || ''
    },
    Meta: {
        tag: 'span',
        fontSize: 'Y2',
        color: 'caption',
        text: (el, s)=>{
            if (!s) return '';
            const root = s.root;
            const person = root && el.call('findPerson', s.authorEmail);
            return person && person.name || s.authorEmail || '';
        }
    }
};

});

parcelRegister("a5q8o", function(module, exports) {

$parcel$export(module.exports, "ChatCode", () => $757ea4c064fba096$export$90f2041570aa310b);
$parcel$export(module.exports, "ChatInlineCode", () => $757ea4c064fba096$export$8b7ab4015ca8e694);
$parcel$export(module.exports, "ChatUL", () => $757ea4c064fba096$export$372a0f26bc636741);
$parcel$export(module.exports, "ChatHr", () => $757ea4c064fba096$export$94c45d686982c959);
$parcel$export(module.exports, "ChatOL", () => $757ea4c064fba096$export$cb73969235886812);
// `onRender`/`onUpdate` are neutralised because CodePreview's default
// lifecycle rewrites the DOM with its `value` prop — chat feeds code in
// as markdown children via symbolize-markdown's `pre` → ChatCode mapping
// instead, and that subtree must survive each render.
const $757ea4c064fba096$export$90f2041570aa310b = {
    extends: 'CodePreview',
    maxWidth: '100%',
    theme: 'scene',
    background: 'black',
    color: 'white',
    onRender: ()=>{},
    onUpdate: ()=>{}
};
const $757ea4c064fba096$export$8b7ab4015ca8e694 = {
    tag: 'code',
    fontFamily: 'monospace',
    fontSize: 'Y2',
    background: 'white.08',
    padding: '1px 4px',
    round: 'V',
    color: 'cyan'
};
const $757ea4c064fba096$export$372a0f26bc636741 = {
    tag: 'ul',
    padding: 'V 0 V A',
    margin: 'V 0',
    flow: 'y',
    gap: 'V',
    listStyleType: 'disc',
    listStylePosition: 'outside',
    color: 'title'
};
const $757ea4c064fba096$export$94c45d686982c959 = {
    extends: 'Hr',
    margin: 'Z 0',
    background: 'line',
    height: '1px',
    border: 'none',
    opacity: '.5'
};
const $757ea4c064fba096$export$cb73969235886812 = {
    tag: 'ol',
    padding: 'V 0 V A',
    margin: 'V 0',
    flow: 'y',
    gap: 'V',
    listStyleType: 'decimal',
    listStylePosition: 'outside',
    color: 'title'
};

});

parcelRegister("kKfCw", function(module, exports) {

$parcel$export(module.exports, "ChatSidebarDropdown", () => $f1a4386254de9427$export$96b5c70c4ba326ad);
$parcel$export(module.exports, "ChatSidebarDropdownItem", () => $f1a4386254de9427$export$c68dda97932f623);
// Shared sidebar dropdown — rendered at page level to escape overflow/opacity.
// Controlled via root.sidebarDropdown state set by SidebarItemMore.onClick.
// Always in DOM but off-screen when closed — avoids first-render flash.
//
// Position + opacity are reactive DOMQL props (not inline style side-effects).
// This works around a DOMQL v3.14 quirk where `onUpdate` doesn't re-fire when
// only a reactive `children:` factory changes — the dropdown used to render
// its new children correctly but keep its position stuck at -9999px because
// the position writer was tied to `onUpdate`, not the reactive state read.
const $f1a4386254de9427$var$_resolvePos = (s)=>{
    const dd = s?.root?.sidebarDropdown;
    if (!dd?.open) return {
        top: -9999,
        left: -9999,
        opacity: 0,
        pointerEvents: 'none'
    };
    let top = dd.top || 0;
    let left = dd.left || 0;
    // We can't measure self-dimensions here (runs on every root update, before
    // layout). Use conservative defaults + real window bounds. The first render
    // places the menu; on the rare edge-overflow case a scroll handler corrects.
    const ddH = 200;
    const ddW = 200;
    if (typeof window !== 'undefined') {
        if (top + ddH > window.innerHeight) top = (dd.btnTop || top) - ddH - 2;
        if (left + ddW > window.innerWidth) left = window.innerWidth - ddW - 4;
        if (left < 4) left = 4;
    }
    return {
        top: top,
        left: left,
        opacity: 1,
        pointerEvents: 'auto'
    };
};
const $f1a4386254de9427$export$96b5c70c4ba326ad = {
    position: 'fixed',
    zIndex: 9999,
    flow: 'y',
    minWidth: 'F',
    padding: 'V',
    round: 'Z',
    background: 'overlayStrong',
    borderWidth: '1px',
    borderColor: 'line',
    borderStyle: 'solid',
    boxShadow: '0 8px 24px -4px rgba(0, 0, 0, 0.5)',
    // Reactive positioning — re-evaluates on every root state change.
    top: (el, s)=>$f1a4386254de9427$var$_resolvePos(s).top + 'px',
    left: (el, s)=>$f1a4386254de9427$var$_resolvePos(s).left + 'px',
    opacity: (el, s)=>String($f1a4386254de9427$var$_resolvePos(s).opacity),
    pointerEvents: (el, s)=>$f1a4386254de9427$var$_resolvePos(s).pointerEvents,
    onCreate: (el, s)=>{
        // Close on outside click. Uses capture so it runs before inner click
        // handlers and won't race with MoreBtn's own click (which carries a
        // `data-key="MoreBtn"` that we match on here to exempt).
        el._clickAway = (ev)=>{
            if (!el.node) return;
            if (el.node.contains(ev.target)) return;
            if (ev.target.closest('[data-key="MoreBtn"]')) return;
            if (s.root?.sidebarDropdown?.open) s.root.update({
                sidebarDropdown: {
                    open: false
                }
            });
        };
        setTimeout(()=>document.addEventListener('click', el._clickAway, true), 0);
    },
    onRemove: (el)=>{
        if (el._clickAway) document.removeEventListener('click', el._clickAway, true);
    },
    childExtends: 'ChatSidebarDropdownItem',
    childrenAs: 'state',
    children: (el, s)=>{
        const dd = s.root?.sidebarDropdown;
        return (dd?.items || []).map((item)=>({
                ...item,
                _channelId: dd?.channelId
            }));
    }
};
const $f1a4386254de9427$export$c68dda97932f623 = {
    tag: 'button',
    type: 'button',
    padding: 'Z A',
    round: 'V',
    background: 'transparent',
    borderWidth: '0',
    cursor: 'pointer',
    fontSize: 'Z2',
    fontWeight: '500',
    textAlign: 'left',
    whiteSpace: 'nowrap',
    color: (el, s)=>s.color || 'title',
    ':hover': {
        background: 'overlay'
    },
    text: (el, s)=>s.label || '',
    onClick: (e, el, s)=>{
        e.stopPropagation();
        const action = s.action;
        const channelId = s._channelId;
        const root = s.root;
        root.update({
            sidebarDropdown: {
                open: false
            }
        });
        if (!action || !channelId) return;
        if (action === 'rename-channel') {
            const ch = (root.channels || []).find((c)=>c.id === channelId);
            root.update({
                renameModal: {
                    open: true,
                    channelId: channelId,
                    currentName: ch?.name || ''
                }
            });
        } else if (action === 'hide-dm') el.call('hideDM', channelId);
        else if (action === 'leave-channel') el.call('leaveChannel', channelId);
        else if (action === 'pin-to-top') el.call('pinToTop', channelId);
        else if (action === 'invite-channel' || action === 'channel-settings') el.call('openChannelSettings', channelId);
        else if (action === 'start-group-chat') el.call('startGroupChat', channelId);
        else if (action === 'convert-to-channel') el.call('convertToChannel', channelId);
    }
};

});

parcelRegister("27JlV", function(module, exports) {

$parcel$export(module.exports, "ChatRenameModal", () => $18bf6a50f6643cc4$export$35846d8d7b6fee63);
// Simple rename modal for channels and group DMs.
const $18bf6a50f6643cc4$export$35846d8d7b6fee63 = {
    show: (el, s)=>!!s.root?.renameModal?.open,
    position: 'fixed',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    zIndex: 10000,
    align: 'center center',
    background: 'black.5',
    onClick: (e, el, s)=>{
        if (e.target === el.node) s.root.update({
            renameModal: {
                open: false
            }
        });
    },
    Card: {
        flow: 'y',
        gap: 'A',
        padding: 'B',
        round: 'A',
        background: 'overlayStrong',
        borderWidth: '1px',
        borderColor: 'line',
        borderStyle: 'solid',
        width: 'H',
        maxWidth: '90vw',
        boxShadow: '0 16px 48px -8px rgba(0, 0, 0, 0.6)',
        Title: {
            tag: 'h3',
            margin: '0',
            fontSize: 'A',
            fontWeight: '600',
            color: 'title',
            text: 'Rename'
        },
        Input: {
            tag: 'input',
            type: 'text',
            padding: 'Z A',
            round: 'Z',
            borderWidth: '1px',
            borderColor: 'line',
            borderStyle: 'solid',
            background: 'document',
            color: 'title',
            fontSize: 'Z2',
            fontFamily: 'inherit',
            value: (el, s)=>s.root?.renameModal?.currentName || '',
            onInput: (e, el, s)=>{
                s.root.update({
                    renameModal: {
                        ...s.root.renameModal,
                        currentName: e.target.value
                    }
                });
            },
            onKeydown: (e, el, s)=>{
                if (e.key === 'Enter') {
                    e.preventDefault();
                    const rm = s.root?.renameModal;
                    if (rm?.currentName?.trim() && rm?.channelId) {
                        el.call('renameChannel', rm.channelId, rm.currentName.trim());
                        s.root.update({
                            renameModal: {
                                open: false
                            }
                        });
                    }
                }
                if (e.key === 'Escape') s.root.update({
                    renameModal: {
                        open: false
                    }
                });
            },
            onCreate: (el)=>{
                requestAnimationFrame(()=>{
                    if (el.node) {
                        el.node.focus();
                        el.node.select();
                    }
                });
            }
        },
        Actions: {
            flow: 'x',
            gap: 'Z',
            align: 'center right',
            CancelBtn: {
                extends: 'Button',
                theme: 'secondary',
                text: 'Cancel',
                onClick: (e, el, s)=>s.root.update({
                        renameModal: {
                            open: false
                        }
                    })
            },
            SaveBtn: {
                extends: 'Button',
                theme: 'primary',
                text: 'Save',
                onClick: (e, el, s)=>{
                    const rm = s.root?.renameModal;
                    if (rm?.currentName?.trim() && rm?.channelId) {
                        el.call('renameChannel', rm.channelId, rm.currentName.trim());
                        s.root.update({
                            renameModal: {
                                open: false
                            }
                        });
                    }
                }
            }
        }
    }
};

});


parcelRegister("2TbuY", function(module, exports) {

$parcel$export(module.exports, "NotificationPanel", () => $21a9a336c6fbb2bb$export$20171ad88b646892);
$parcel$export(module.exports, "NotificationWrapper", () => $21a9a336c6fbb2bb$export$3785346a4fed4152);
// Shared notifications bridge — NotificationPanel + self-loading
// NotificationWrapper from @symbo.ls/collab-features/notifications.
// Shared across editor + intranet via sharedLibraries.
//
// NotificationBell is owned by ./NotificationBell.js (the local
// Button-based badge component). This bridge does not re-export it —
// frank's duplicate-export scan would flag both files.
parcelRequire("kve3A");
var $eONSp = parcelRequire("eONSp");
const $21a9a336c6fbb2bb$export$20171ad88b646892 = (0, $eONSp).NotificationPanel;
const $21a9a336c6fbb2bb$export$3785346a4fed4152 = (0, $eONSp).NotificationWrapper;

});

parcelRegister("fIdC9", function(module, exports) {

$parcel$export(module.exports, "Messenger", () => $b70586959f7619c0$export$1182391b36b9d1bf);
// Shared messenger button for the app header. Toggles `root._chatDrawerOpen`
// and, on open, bootstraps chat state via `@symbo.ls/collab-features` so the
// drawer renders immediately after. Unread badge is driven by the same
// package's `chat.unreadCount` helper; it lazy-loads once per app and
// caches the function on `root.__chatUnreadMod`.


const $b70586959f7619c0$export$1182391b36b9d1bf = {
    tag: 'button',
    type: 'button',
    // smbls 3.14.x — FA-L11 fix landed; top-level `title` + `aria: { label }`
    // are now reliable on tag-typed elements (button/a/img/...). Previously
    // these required an `attr: { ... }` wrapper because per-tag
    // HTML_ATTRIBUTES dropped the global default attrs.
    title: 'Messenger',
    aria: {
        label: 'Messenger'
    },
    position: 'relative',
    padding: 'Z',
    round: 'Z',
    cursor: 'pointer',
    borderWidth: '0',
    background: (el, s)=>s.root?._chatDrawerOpen ? 'overlay' : 'transparent',
    color: (el, s)=>s.root?._chatDrawerOpen ? 'title' : 'caption',
    ':hover': {
        background: 'overlay',
        color: 'title'
    },
    onClick: async (e, el, s)=>{
        const opening = !s.root._chatDrawerOpen;
        s.root.update({
            _chatDrawerOpen: opening
        });
        if (!opening) return;
        const { chat: chat } = await Promise.resolve((parcelRequire("kve3A")));
        if (chat.bootstrapChatState) await chat.bootstrapChatState(s.root);
        else {
            const { data: data } = await chat.listChannels();
            const channels = data || [];
            const active = channels[0]?.id || null;
            s.root.update({
                _chatDrawerChannels: channels,
                _chatDrawerChannelId: active,
                _chatDrawerLoading: false
            });
            if (active) {
                const res = await chat.listMessages({
                    channelId: active,
                    limit: 50
                });
                s.root.update({
                    _chatDrawerMessages: (res.data || []).slice().reverse()
                });
            }
        }
    },
    // Lazy-load the unread helper once per app so the UnreadBadge factories
    // can compute synchronously from DOMQL.
    onRender: async (el, s)=>{
        if (s.root?.__chatUnreadMod) return;
        const { chat: chat } = await Promise.resolve((parcelRequire("kve3A")));
        s.root.update({
            __chatUnreadMod: {
                unreadCount: chat.unreadCount
            }
        });
    },
    Icon: {
        icon: 'chat',
        boxSize: 'A A'
    },
    UnreadBadge: {
        if: (el, s)=>{
            const { unreadCount: unreadCount } = s.root?.__chatUnreadMod || {};
            if (!unreadCount) return false;
            return unreadCount({
                messagesByChannel: s.root?.messagesByChannel,
                channelMembers: s.root?.channelMembers,
                currentUserEmail: s.root?.currentUserEmail
            }) > 0;
        },
        position: 'absolute',
        top: '0',
        right: '0',
        minWidth: 'Z',
        height: 'Z',
        padding: '0 V',
        round: 'C',
        background: 'red',
        color: 'white',
        fontSize: 'W',
        fontWeight: '700',
        lineHeight: '1',
        align: 'center center',
        pointerEvents: 'none',
        text: (el, s)=>{
            const { unreadCount: unreadCount } = s.root?.__chatUnreadMod || {};
            if (!unreadCount) return '';
            const n = unreadCount({
                messagesByChannel: s.root?.messagesByChannel,
                channelMembers: s.root?.channelMembers,
                currentUserEmail: s.root?.currentUserEmail
            });
            return n > 99 ? '99+' : String(n);
        }
    }
};

});

parcelRegister("lJCNv", function(module, exports) {

$parcel$export(module.exports, "RemoteProjectCard", () => $fd2be5509efee59f$export$aa31529a48787cf9);
// Card for a connected external Supabase project. Consumers pass
// `__remoteBasePath` on the parent (RemoteProjectPicker) so clicks
// route within the consumer's own URL space (gov: /data/external,
// CMS: /tables).
const $fd2be5509efee59f$export$aa31529a48787cf9 = {
    tag: 'button',
    type: 'button',
    flow: 'y',
    gap: 'Z1',
    padding: 'A',
    round: 'Z1',
    background: 'overlay',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'line',
    cursor: 'pointer',
    textAlign: 'left',
    ':hover': {
        borderColor: 'title'
    },
    transition: 'border-color 150ms ease',
    onClick: (e, el, s)=>{
        const base = el.parent?.__remoteBasePath || '/data/external';
        const target = el.call('makeRemoteUrl', base, {
            slug: s.slug
        });
        const root = el.call('findRouteRoot', el) || el.getRoot();
        if (root) el.router(target, root);
    },
    TopRow: {
        flow: 'x',
        align: 'center space-between',
        gap: 'Z',
        Left: {
            flow: 'x',
            align: 'center',
            gap: 'Z1',
            Icon: {
                icon: 'database',
                boxSize: 'A'
            },
            Name: {
                tag: 'span',
                fontSize: 'A',
                fontWeight: '700',
                color: 'title',
                text: (el, s)=>s.display_name || s.slug
            }
        },
        Pill: {
            padding: 'V Z',
            round: 'Y',
            fontSize: 'Y1',
            fontWeight: '700',
            background: (el, s)=>s.enabled && s.has_secret ? 'green' : 'overlayStrong',
            color: (el, s)=>s.enabled && s.has_secret ? 'white' : 'caption',
            text: (el, s)=>{
                if (!s.has_secret) return 'No secret';
                return s.enabled ? 'Live' : 'Disabled';
            }
        }
    },
    Meta: {
        tag: 'p',
        fontSize: 'Y2',
        color: 'caption',
        margin: '0',
        text: (el, s)=>`${s.config?.project_ref || "\u2014"} \xb7 slug: ${s.slug}`
    },
    Url: {
        tag: 'p',
        fontSize: 'Y2',
        color: 'caption',
        margin: '0',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        text: (el, s)=>s.config?.url || ''
    }
};

});

parcelRegister("lenBB", function(module, exports) {

$parcel$export(module.exports, "RemoteTableCard", () => $f74d3756e8d48124$export$2ee2600a87044e7e);
const $f74d3756e8d48124$export$2ee2600a87044e7e = {
    tag: 'button',
    type: 'button',
    flow: 'y',
    gap: 'V',
    padding: 'A',
    round: 'Z1',
    background: 'overlay',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'line',
    cursor: 'pointer',
    textAlign: 'left',
    ':hover': {
        borderColor: 'title'
    },
    transition: 'border-color 150ms ease',
    onClick: (e, el, s)=>{
        const base = el.parent?.__remoteBasePath || '/data/external';
        const target = el.call('makeRemoteUrl', base, {
            slug: s.slug,
            table: s.name
        });
        const root = el.call('findRouteRoot', el) || el.getRoot();
        if (root) el.router(target, root);
    },
    TopRow: {
        flow: 'x',
        align: 'center space-between',
        gap: 'Z',
        Name: {
            tag: 'span',
            fontSize: 'A',
            fontWeight: '700',
            color: 'title',
            text: (el, s)=>s.name
        },
        ColumnCount: {
            padding: 'V Z',
            round: 'Y',
            background: 'overlayStrong',
            color: 'caption',
            fontSize: 'Y1',
            fontWeight: '700',
            text: (el, s)=>`${(s.columns || []).length} cols`
        }
    },
    ColumnPreview: {
        tag: 'p',
        fontSize: 'Y2',
        color: 'caption',
        margin: '0',
        lineHeight: '1.4',
        overflow: 'hidden',
        display: '-webkit-box',
        WebkitLineClamp: '2',
        WebkitBoxOrient: 'vertical',
        text: (el, s)=>{
            const cols = s.columns || [];
            return cols.map((c)=>c.name).slice(0, 8).join(', ') + (cols.length > 8 ? "\u2026" : '');
        }
    }
};

});

parcelRegister("fcpAL", function(module, exports) {

$parcel$export(module.exports, "RemoteRowTr", () => $b10bd40fc8094fd8$export$35c07715d36a8b74);
$parcel$export(module.exports, "RemoteRowTable", () => $b10bd40fc8094fd8$export$80c6477bfcc96a9f);
// Paged, realtime-subscribed rows for one external Supabase table.
// Click a row to open RemoteRowEditor (update mode).
const $b10bd40fc8094fd8$export$35c07715d36a8b74 = {
    tag: 'tr',
    cursor: 'pointer',
    ':hover': {
        background: 'overlayStrong'
    },
    onClick: (e, el, s)=>{
        const { slug: slug, table: table } = el.call('parseRemotePath');
        const schema = el.call('schemaForRemoteTable', s.root, slug, table);
        const values = {};
        for (const c of schema?.columns || []){
            const v = s.__row?.[c.name];
            values[c.name] = v == null ? '' : typeof v === 'object' ? JSON.stringify(v) : String(v);
        }
        s.root.update({
            _extEditor: {
                mode: 'update',
                slug: slug,
                table: table,
                values: values,
                original: s.__row
            }
        });
    },
    childExtends: {
        tag: 'td',
        padding: 'Z',
        borderBottomWidth: '1px',
        borderBottomStyle: 'solid',
        borderBottomColor: 'line',
        fontSize: 'Y2',
        color: 'title',
        fontFamily: 'mono',
        verticalAlign: 'top',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '320px',
        text: (el, s)=>{
            const v = s.value;
            if (v == null) return '';
            if (typeof v === 'string') return v;
            if (typeof v === 'object') return JSON.stringify(v);
            return String(v);
        }
    },
    childrenAs: 'state',
    children: (el, s)=>{
        const row = s.__row || {};
        return (s.__cols || []).map((c)=>({
                name: c.name,
                value: row[c.name]
            }));
    }
};
const $b10bd40fc8094fd8$export$80c6477bfcc96a9f = {
    overflow: 'auto',
    round: 'Z1',
    background: 'overlay',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'line',
    Inner: {
        tag: 'table',
        width: '100%',
        borderCollapse: 'collapse',
        fontSize: 'Y2',
        Head: {
            tag: 'thead',
            background: 'overlayStrong',
            Row: {
                tag: 'tr',
                childExtends: {
                    tag: 'th',
                    padding: 'Z',
                    textAlign: 'left',
                    color: 'caption',
                    fontWeight: '700',
                    letterSpacing: '.04em',
                    textTransform: 'uppercase',
                    fontSize: 'Y1',
                    borderBottomWidth: '1px',
                    borderBottomStyle: 'solid',
                    borderBottomColor: 'line',
                    whiteSpace: 'nowrap',
                    text: (el, s)=>s.name
                },
                childrenAs: 'state',
                children: (el, s)=>{
                    const { slug: slug, table: table } = el.call('parseRemotePath');
                    if (!slug || !table) return [];
                    const schema = el.call('schemaForRemoteTable', s.root, slug, table);
                    return schema?.columns || [];
                }
            }
        },
        Body: {
            tag: 'tbody',
            childExtends: 'RemoteRowTr',
            childrenAs: 'state',
            children: (el, s)=>{
                const rows = s.root?._extRows || [];
                const { slug: slug, table: table } = el.call('parseRemotePath');
                const schema = el.call('schemaForRemoteTable', s.root, slug, table);
                const cols = schema?.columns || [];
                return rows.map((r, idx)=>({
                        __row: r,
                        __idx: idx,
                        __cols: cols
                    }));
            }
        }
    }
};

});

parcelRegister("i2MvJ", function(module, exports) {

$parcel$export(module.exports, "RemoteRowField", () => $d22e0b1c5f090580$export$2f1522e16b2052ef);
$parcel$export(module.exports, "RemoteRowEditor", () => $d22e0b1c5f090580$export$fee7e3bc4d5737b4);
// Side-panel row editor (insert or update). Reads + writes
// `root._extEditor`. Save/delete flow through saveRemoteRow /
// deleteRemoteRow. Opens when `_extEditor` is non-null.
const $d22e0b1c5f090580$export$2f1522e16b2052ef = {
    flow: 'y',
    gap: 'V',
    Label: {
        tag: 'label',
        fontSize: 'Y2',
        color: 'caption',
        fontWeight: '700',
        text: (el, s)=>{
            const col = s.col || {};
            const parts = [
                col.name
            ];
            if (col.is_primary_key) parts.push('(PK)');
            if (!col.nullable) parts.push('*');
            return parts.join(' ');
        }
    },
    TypeHint: {
        tag: 'span',
        fontSize: 'Y1',
        color: 'caption',
        text: (el, s)=>{
            const col = s.col || {};
            return col.format ? `${col.type} \xb7 ${col.format}` : col.type || '';
        }
    },
    Input: {
        hide: (el, s)=>{
            const col = s.col || {};
            return col.type === 'boolean' || col.format === 'jsonb' || col.format === 'json';
        },
        tag: 'input',
        type: 'text',
        width: '100%',
        padding: 'Z',
        round: 'Y',
        background: 'document',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'line',
        color: 'title',
        fontFamily: 'mono',
        fontSize: 'Z2',
        disabled: (el, s)=>{
            const ed = s.root?._extEditor;
            const col = s.col || {};
            return ed?.mode === 'update' && col.is_primary_key;
        },
        placeholder: (el, s)=>{
            const col = s.col || {};
            if (col.format === 'uuid') return '00000000-0000-0000-0000-000000000000';
            if (col.format === 'date-time') return '2026-01-01T00:00:00Z';
            return col.nullable ? '(null)' : '';
        },
        value: (el, s)=>{
            const ed = s.root?._extEditor;
            return ed?.values?.[s.fieldKey] ?? '';
        },
        onInput: (e, el, s)=>{
            const ed = s.root?._extEditor;
            if (!ed) return;
            s.root.update({
                _extEditor: {
                    ...ed,
                    values: {
                        ...ed.values || {},
                        [s.fieldKey]: e.target.value
                    }
                }
            });
        }
    },
    BoolSelect: {
        hide: (el, s)=>s.col?.type !== 'boolean',
        tag: 'select',
        width: '100%',
        padding: 'Z',
        round: 'Y',
        background: 'document',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'line',
        color: 'title',
        fontSize: 'Z2',
        value: (el, s)=>{
            const ed = s.root?._extEditor;
            const v = ed?.values?.[s.fieldKey];
            if (v === true || v === 'true') return 'true';
            if (v === false || v === 'false') return 'false';
            return '';
        },
        onChange: (e, el, s)=>{
            const ed = s.root?._extEditor;
            if (!ed) return;
            s.root.update({
                _extEditor: {
                    ...ed,
                    values: {
                        ...ed.values || {},
                        [s.fieldKey]: e.target.value
                    }
                }
            });
        },
        OptEmpty: {
            tag: 'option',
            value: '',
            text: "\u2014"
        },
        OptTrue: {
            tag: 'option',
            value: 'true',
            text: 'true'
        },
        OptFalse: {
            tag: 'option',
            value: 'false',
            text: 'false'
        }
    },
    JsonArea: {
        hide: (el, s)=>{
            const col = s.col || {};
            return col.format !== 'jsonb' && col.format !== 'json';
        },
        tag: 'textarea',
        rows: '4',
        width: '100%',
        padding: 'Z',
        round: 'Y',
        background: 'document',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'line',
        color: 'title',
        fontFamily: 'mono',
        fontSize: 'Y2',
        placeholder: '{} or []',
        value: (el, s)=>{
            const ed = s.root?._extEditor;
            return ed?.values?.[s.fieldKey] ?? '';
        },
        onInput: (e, el, s)=>{
            const ed = s.root?._extEditor;
            if (!ed) return;
            s.root.update({
                _extEditor: {
                    ...ed,
                    values: {
                        ...ed.values || {},
                        [s.fieldKey]: e.target.value
                    }
                }
            });
        }
    }
};
const $d22e0b1c5f090580$export$fee7e3bc4d5737b4 = {
    hide: (el, s)=>!s.root?._extEditor,
    position: 'fixed',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    background: 'rgba(0,0,0,0.4)',
    zIndex: '100',
    align: 'flex-start flex-end',
    onClick: (e, el, s)=>{
        if (e.target === el.node) s.root.update({
            _extEditor: null
        });
    },
    Panel: {
        width: '520px',
        height: '100%',
        background: 'document',
        borderLeftWidth: '1px',
        borderLeftStyle: 'solid',
        borderLeftColor: 'line',
        overflow: 'auto',
        flow: 'y',
        boxShadow: '-8px 0 32px rgba(0,0,0,0.15)',
        Header: {
            flow: 'x',
            align: 'center space-between',
            padding: 'A',
            borderBottomWidth: '1px',
            borderBottomStyle: 'solid',
            borderBottomColor: 'line',
            Title: {
                flow: 'y',
                gap: 'V',
                H2: {
                    tag: 'h2',
                    fontSize: 'B',
                    fontWeight: '700',
                    color: 'title',
                    margin: '0',
                    text: (el, s)=>s.root?._extEditor?.mode === 'insert' ? 'New row' : 'Edit row'
                },
                Meta: {
                    tag: 'span',
                    fontSize: 'Y2',
                    color: 'caption',
                    text: (el, s)=>{
                        const ed = s.root?._extEditor;
                        if (!ed) return '';
                        return `${ed.slug} \xb7 ${ed.table}`;
                    }
                }
            },
            CloseBtn: {
                tag: 'button',
                type: 'button',
                padding: 'V Z',
                round: 'Y',
                background: 'transparent',
                border: 'none',
                color: 'caption',
                fontSize: 'A',
                cursor: 'pointer',
                text: "\xd7",
                onClick: (e, el, s)=>s.root.update({
                        _extEditor: null
                    })
            }
        },
        Body: {
            padding: 'A',
            flow: 'y',
            gap: 'Z1',
            Fields: {
                flow: 'y',
                gap: 'Z1',
                childExtends: 'RemoteRowField',
                childrenAs: 'state',
                children: (el, s)=>{
                    const ed = s.root?._extEditor;
                    if (!ed) return [];
                    const schema = el.call('schemaForRemoteTable', s.root, ed.slug, ed.table);
                    return (schema?.columns || []).map((c)=>({
                            col: c,
                            fieldKey: c.name
                        }));
                }
            }
        },
        Footer: {
            flow: 'x',
            align: 'center space-between',
            padding: 'A',
            gap: 'Z',
            borderTopWidth: '1px',
            borderTopStyle: 'solid',
            borderTopColor: 'line',
            background: 'overlay',
            position: 'sticky',
            bottom: '0',
            DeleteBtn: {
                tag: 'button',
                type: 'button',
                hide: (el, s)=>s.root?._extEditor?.mode !== 'update',
                padding: 'V Z',
                round: 'Y',
                background: 'transparent',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: 'line',
                color: 'red',
                fontSize: 'Y2',
                cursor: 'pointer',
                text: 'Delete row',
                onClick: async (e, el, s)=>{
                    if (!window.confirm('Delete this row? This cannot be undone.')) return;
                    const res = await el.call('deleteRemoteRow', s.root);
                    if (res?.ok) el.call('openNotification', {
                        title: 'Row deleted',
                        type: 'success'
                    });
                    else el.call('openNotification', {
                        title: 'Delete failed',
                        message: res?.error,
                        type: 'error'
                    });
                }
            },
            Right: {
                flow: 'x',
                gap: 'Z',
                CancelBtn: {
                    tag: 'button',
                    type: 'button',
                    padding: 'V Z',
                    round: 'Y',
                    background: 'transparent',
                    borderWidth: '1px',
                    borderStyle: 'solid',
                    borderColor: 'line',
                    color: 'title',
                    fontSize: 'Y2',
                    cursor: 'pointer',
                    text: 'Cancel',
                    onClick: (e, el, s)=>s.root.update({
                            _extEditor: null
                        })
                },
                SaveBtn: {
                    tag: 'button',
                    type: 'button',
                    padding: 'V A',
                    round: 'Y',
                    background: 'blue',
                    color: 'white',
                    fontSize: 'Y2',
                    fontWeight: '700',
                    cursor: 'pointer',
                    border: 'none',
                    text: (el, s)=>s.root?._extEditorSaving ? "Saving\u2026" : 'Save',
                    onClick: async (e, el, s)=>{
                        const res = await el.call('saveRemoteRow', s.root);
                        if (res?.ok) el.call('openNotification', {
                            title: 'Saved',
                            type: 'success'
                        });
                        else el.call('openNotification', {
                            title: 'Save failed',
                            message: res?.error,
                            type: 'error'
                        });
                    }
                }
            }
        }
    }
};

});

parcelRegister("9SajF", function(module, exports) {

$parcel$export(module.exports, "RemoteProjectPicker", () => $730128c6ba99f997$export$4bb391e9b5bfabb0);
// List of connected Supabase projects. Click to drill into schema.
// Consumers set `__remoteBasePath` on this picker so cards route
// inside the right URL space (gov: /data/external, CMS: /tables).
const $730128c6ba99f997$export$4bb391e9b5bfabb0 = {
    hide: (el, s)=>!!el.call('parseRemotePath').slug,
    flow: 'y',
    gap: 'A',
    Hint: {
        tag: 'p',
        fontSize: 'Z2',
        color: 'caption',
        margin: '0',
        text: 'External Supabase projects connected to this org. Click a project to browse its schema and rows.'
    },
    EmptyState: {
        hide: (el, s)=>(s.root?._extProjects || []).length > 0 || s.root?._extLoading,
        padding: 'C',
        round: 'Z1',
        background: 'overlay',
        borderWidth: '1px',
        borderStyle: 'dashed',
        borderColor: 'line',
        textAlign: 'center',
        flow: 'y',
        gap: 'Z1',
        Title: {
            tag: 'h2',
            fontSize: 'B',
            color: 'title',
            margin: '0',
            text: 'No external projects connected yet'
        },
        Subtitle: {
            tag: 'p',
            fontSize: 'Z2',
            color: 'caption',
            margin: '0',
            text: 'Connect aihouse, hotcard, benefits, or any Supabase project to make its data browsable here.'
        },
        CTA: {
            tag: 'button',
            type: 'button',
            padding: 'Z A',
            round: 'Y',
            background: 'blue',
            color: 'white',
            fontSize: 'Z2',
            fontWeight: '700',
            cursor: 'pointer',
            border: 'none',
            text: 'Connect a project',
            margin: 'Z1 auto 0',
            onClick: (e, el)=>{
                const root = el.call('findRouteRoot', el) || el.getRoot();
                if (root) el.router('/admin/integrations/supabase', root);
            }
        }
    },
    LoadingState: {
        hide: (el, s)=>!s.root?._extLoading,
        padding: 'C',
        textAlign: 'center',
        color: 'caption',
        fontSize: 'Z2',
        text: "Loading connected projects\u2026"
    },
    ProjectCards: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
        gap: 'A',
        childExtends: 'RemoteProjectCard',
        childrenAs: 'state',
        children: (el, s)=>s.root?._extProjects || []
    }
};

});

parcelRegister("2CNCe", function(module, exports) {

$parcel$export(module.exports, "RemoteSchemaList", () => $1e959e0162c8fddd$export$2c8c70ed7d513cd2);
// Tables grid for one external project. Click a card to view rows.
const $1e959e0162c8fddd$export$2c8c70ed7d513cd2 = {
    hide: (el, s)=>{
        const p = el.call('parseRemotePath');
        return !p.slug || !!p.table;
    },
    flow: 'y',
    gap: 'A',
    LoadingState: {
        hide: (el, s)=>!s.root?._extSchemaLoading,
        padding: 'C',
        textAlign: 'center',
        color: 'caption',
        fontSize: 'Z2',
        text: "Introspecting schema\u2026"
    },
    ErrorState: {
        hide: (el, s)=>!s.root?._extSchemaError,
        padding: 'A',
        round: 'Z1',
        background: 'overlayStrong',
        color: 'red',
        fontSize: 'Z2',
        text: (el, s)=>s.root?._extSchemaError || ''
    },
    TableGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
        gap: 'A',
        childExtends: 'RemoteTableCard',
        childrenAs: 'state',
        children: (el, s)=>{
            const { slug: slug } = el.call('parseRemotePath');
            if (!slug) return [];
            const tables = s.root?._extSchemaBySlug?.[slug] || [];
            return tables.map((t)=>({
                    ...t,
                    slug: slug
                }));
        }
    }
};

});

parcelRegister("1xLYr", function(module, exports) {

$parcel$export(module.exports, "RemoteTableRows", () => $11fe161c6523843d$export$f5f3c277f02840de);
// Rows view for one table: toolbar (new/refresh/paginate) + table +
// floating row editor. Reads URL shape via parseRemotePath.

var $kDfBU = parcelRequire("kDfBU");
const $11fe161c6523843d$export$f5f3c277f02840de = {
    hide: (el, s)=>{
        const p = el.call('parseRemotePath');
        return !p.slug || !p.table;
    },
    flow: 'y',
    gap: 'Z1',
    Toolbar: {
        flow: 'x',
        align: 'center space-between',
        gap: 'Z',
        padding: '0 0 Z 0',
        Left: {
            flow: 'x',
            align: 'center',
            gap: 'Z',
            TotalBadge: {
                padding: 'V Z',
                round: 'Y',
                background: 'overlayStrong',
                color: 'caption',
                fontSize: 'Y2',
                fontWeight: '700',
                text: (el, s)=>{
                    const n = s.root?._extRowsTotal;
                    if (n == null) return "loading\u2026";
                    return `${n.toLocaleString()} rows`;
                }
            },
            NewRowBtn: {
                tag: 'button',
                type: 'button',
                padding: 'V Z',
                round: 'Y',
                background: 'blue',
                color: 'white',
                fontSize: 'Y2',
                fontWeight: '700',
                cursor: 'pointer',
                border: 'none',
                text: '+ New row',
                onClick: (e, el, s)=>{
                    const { slug: slug, table: table } = el.call('parseRemotePath');
                    const schema = el.call('schemaForRemoteTable', s.root, slug, table);
                    const blank = {};
                    for (const c of schema?.columns || [])blank[c.name] = c.default != null ? String(c.default) : '';
                    s.root.update({
                        _extEditor: {
                            mode: 'insert',
                            slug: slug,
                            table: table,
                            values: blank,
                            original: null
                        }
                    });
                }
            },
            RefreshBtn: {
                tag: 'button',
                type: 'button',
                padding: 'V Z',
                round: 'Y',
                background: 'transparent',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: 'line',
                color: 'title',
                fontSize: 'Y2',
                cursor: 'pointer',
                text: 'Refresh',
                onClick: (e, el, s)=>{
                    const { slug: slug, table: table } = el.call('parseRemotePath');
                    el.call('loadRemoteRows', s.root, slug, table, s.root?._extRowsPage || 0);
                }
            }
        },
        Right: {
            flow: 'x',
            gap: 'Z',
            Prev: {
                tag: 'button',
                type: 'button',
                padding: 'V Z',
                round: 'Y',
                background: 'transparent',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: 'line',
                color: 'title',
                fontSize: 'Y2',
                cursor: 'pointer',
                disabled: (el, s)=>(s.root?._extRowsPage || 0) <= 0,
                text: "\u2190 Prev",
                onClick: (e, el, s)=>{
                    const { slug: slug, table: table } = el.call('parseRemotePath');
                    const page = Math.max(0, (s.root?._extRowsPage || 0) - 1);
                    el.call('loadRemoteRows', s.root, slug, table, page);
                }
            },
            PageIndicator: {
                padding: 'V Z',
                fontSize: 'Y2',
                color: 'caption',
                text: (el, s)=>{
                    const page = s.root?._extRowsPage || 0;
                    const total = s.root?._extRowsTotal || 0;
                    const end = Math.min(total, (page + 1) * (0, $kDfBU.REMOTE_PAGE_SIZE));
                    return `${page * (0, $kDfBU.REMOTE_PAGE_SIZE) + 1}\u{2013}${end}`;
                }
            },
            Next: {
                tag: 'button',
                type: 'button',
                padding: 'V Z',
                round: 'Y',
                background: 'transparent',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: 'line',
                color: 'title',
                fontSize: 'Y2',
                cursor: 'pointer',
                disabled: (el, s)=>{
                    const page = s.root?._extRowsPage || 0;
                    const total = s.root?._extRowsTotal || 0;
                    return (page + 1) * (0, $kDfBU.REMOTE_PAGE_SIZE) >= total;
                },
                text: "Next \u2192",
                onClick: (e, el, s)=>{
                    const { slug: slug, table: table } = el.call('parseRemotePath');
                    const page = (s.root?._extRowsPage || 0) + 1;
                    el.call('loadRemoteRows', s.root, slug, table, page);
                }
            }
        }
    },
    LoadingState: {
        hide: (el, s)=>!s.root?._extRowsLoading,
        padding: 'C',
        textAlign: 'center',
        color: 'caption',
        fontSize: 'Z2',
        text: "Loading rows\u2026"
    },
    ErrorState: {
        hide: (el, s)=>!s.root?._extRowsError,
        padding: 'A',
        round: 'Z1',
        background: 'overlayStrong',
        color: 'red',
        fontSize: 'Z2',
        text: (el, s)=>s.root?._extRowsError || ''
    },
    Table: {
        extends: 'RemoteRowTable'
    },
    Editor: {
        extends: 'RemoteRowEditor'
    }
};

});
parcelRegister("kDfBU", function(module, exports) {

$parcel$export(module.exports, "REMOTE_PAGE_SIZE", () => $f0538f17063f7674$export$c045e5c5afaa270e);
$parcel$export(module.exports, "getRemoteRealtimeClient", () => $f0538f17063f7674$export$ec9ca85f15144620);
$parcel$export(module.exports, "tearDownRemoteRealtime", () => $f0538f17063f7674$export$1270e7835d50a082);
$parcel$export(module.exports, "parseRemotePath", () => $f0538f17063f7674$export$d8adf6eaef493085);
$parcel$export(module.exports, "makeRemoteUrl", () => $f0538f17063f7674$export$e7633ae2e03675e0);
$parcel$export(module.exports, "loadRemoteProjects", () => $f0538f17063f7674$export$f81aa8839ad17e6b);
$parcel$export(module.exports, "loadRemoteSchema", () => $f0538f17063f7674$export$f058e75b6a8e0ee1);
$parcel$export(module.exports, "loadRemoteRows", () => $f0538f17063f7674$export$c3901e5c4bd88c3);
$parcel$export(module.exports, "schemaForRemoteTable", () => $f0538f17063f7674$export$ad5eedbb2fb6efc5);
$parcel$export(module.exports, "pkColumnOf", () => $f0538f17063f7674$export$a3140cbc9a39249e);
$parcel$export(module.exports, "coerceRemoteValue", () => $f0538f17063f7674$export$97e80b573b14583a);
$parcel$export(module.exports, "reactToRemotePath", () => $f0538f17063f7674$export$dfa8e583cfdf0416);
$parcel$export(module.exports, "saveRemoteRow", () => $f0538f17063f7674$export$f92b3efc98187173);
$parcel$export(module.exports, "deleteRemoteRow", () => $f0538f17063f7674$export$4d43055218cdf21e);
// Helpers for browsing external Supabase projects connected via the
// governance Integrations hub. Consumed by gov's data-external page
// and by the editor CMS — both talk to the same edge functions
// (integration-admin + external-supabase-query) via sdk-bridge, so no
// service-role key ever reaches the browser.
//
// State lives on the consumer's root state under the `_ext*` prefix
// so it doesn't clash with app state. Callers invoke these through
// `el.call('loadRemoteProjects', s.root)` etc.

var $e92gD = parcelRequire("e92gD");

var $dNnfS = parcelRequire("dNnfS");
const $f0538f17063f7674$export$c045e5c5afaa270e = 50;
// Per-project realtime client pool — one ws connection per slug,
// re-used across table subscriptions. Re-created when anon_key
// rotates.
const $f0538f17063f7674$var$_realtimeClients = new Map();
const $f0538f17063f7674$export$ec9ca85f15144620 = function getRemoteRealtimeClient(slug, url, anonKey) {
    if (!url || !anonKey) return null;
    const existing = $f0538f17063f7674$var$_realtimeClients.get(slug);
    if (existing?.url === url && existing?.anonKey === anonKey) return existing.client;
    const client = (0, $dNnfS.createClient)(url, anonKey, {
        auth: {
            persistSession: false,
            autoRefreshToken: false
        }
    });
    $f0538f17063f7674$var$_realtimeClients.set(slug, {
        url: url,
        anonKey: anonKey,
        client: client
    });
    return client;
};
const $f0538f17063f7674$export$1270e7835d50a082 = function tearDownRemoteRealtime(slug) {
    const entry = $f0538f17063f7674$var$_realtimeClients.get(slug);
    if (!entry) return;
    try {
        entry.client.removeAllChannels();
    } catch  {}
    $f0538f17063f7674$var$_realtimeClients.delete(slug);
};
const $f0538f17063f7674$export$d8adf6eaef493085 = function parseRemotePath() {
    if (typeof window === 'undefined') return {
        slug: null,
        table: null
    };
    const params = new URLSearchParams(window.location.search || '');
    return {
        slug: params.get('slug') || null,
        table: params.get('t') || null
    };
};
const $f0538f17063f7674$export$e7633ae2e03675e0 = function makeRemoteUrl(basePath, { slug: slug, table: table }) {
    const params = new URLSearchParams();
    if (slug) params.set('slug', slug);
    if (table) params.set('t', table);
    const qs = params.toString();
    return `${basePath}${qs ? `?${qs}` : ''}`;
};
const $f0538f17063f7674$export$f81aa8839ad17e6b = async function loadRemoteProjects(root) {
    const orgId = root?.jwtClaims?.workspace_org_id;
    if (!orgId) {
        if (!root._extProjectsWatcher) root._extProjectsWatcher = setInterval(()=>{
            if (root?.jwtClaims?.workspace_org_id) {
                clearInterval(root._extProjectsWatcher);
                root._extProjectsWatcher = null;
                loadRemoteProjects(root);
            }
        }, 300);
        return;
    }
    root.update({
        _extLoading: true
    });
    const res = await (0, $e92gD.listExternalSupabaseProjects)(orgId);
    root.update({
        _extProjects: res?.result?.projects || [],
        _extError: res?.error || null,
        _extLoading: false
    });
};
const $f0538f17063f7674$export$f058e75b6a8e0ee1 = async function loadRemoteSchema(root, slug) {
    const orgId = root?.jwtClaims?.workspace_org_id;
    if (!orgId || !slug) {
        if (!root._extSchemaWatcher) root._extSchemaWatcher = setInterval(()=>{
            if (root?.jwtClaims?.workspace_org_id) {
                clearInterval(root._extSchemaWatcher);
                root._extSchemaWatcher = null;
                loadRemoteSchema(root, slug);
            }
        }, 300);
        return;
    }
    root.update({
        _extSchemaLoading: true,
        _extSchemaError: null
    });
    const res = await (0, $e92gD.introspectExternalSupabase)(orgId, slug);
    root.update({
        _extSchemaBySlug: {
            ...root._extSchemaBySlug || {},
            [slug]: res?.result?.tables || []
        },
        _extSchemaError: res?.error || null,
        _extSchemaLoading: false
    });
};
const $f0538f17063f7674$export$c3901e5c4bd88c3 = async function loadRemoteRows(root, slug, table, page = 0) {
    const orgId = root?.jwtClaims?.workspace_org_id;
    if (!orgId || !slug || !table) return;
    root.update({
        _extRowsLoading: true
    });
    const res = await (0, $e92gD.selectExternalSupabase)(orgId, slug, table, {
        limit: $f0538f17063f7674$export$c045e5c5afaa270e,
        offset: page * $f0538f17063f7674$export$c045e5c5afaa270e
    });
    root.update({
        _extRows: res?.result?.rows || [],
        _extRowsTotal: res?.result?.total ?? null,
        _extRowsPage: page,
        _extRowsError: res?.error || null,
        _extRowsLoading: false,
        _extCurrentTable: {
            slug: slug,
            table: table
        }
    });
    const project = (root?._extProjects || []).find((p)=>p.slug === slug);
    const anonKey = project?.config?.anon_key;
    const url = project?.config?.url;
    if (anonKey && url) {
        const client = $f0538f17063f7674$export$ec9ca85f15144620(slug, url, anonKey);
        if (client) {
            try {
                client.removeAllChannels();
            } catch  {}
            client.channel(`ext-${slug}-${table}`).on('postgres_changes', {
                event: '*',
                schema: 'public',
                table: table
            }, ()=>{
                loadRemoteRows(root, slug, table, root._extRowsPage || 0);
            }).subscribe();
        }
    }
};
const $f0538f17063f7674$export$ad5eedbb2fb6efc5 = function schemaForRemoteTable(root, slug, table) {
    const list = root?._extSchemaBySlug?.[slug] || [];
    return list.find((t)=>t.name === table) || null;
};
const $f0538f17063f7674$export$a3140cbc9a39249e = function pkColumnOf(schema) {
    const pk = (schema?.columns || []).find((c)=>c.is_primary_key);
    return pk?.name || (schema?.columns || []).find((c)=>c.name === 'id')?.name || null;
};
const $f0538f17063f7674$export$97e80b573b14583a = function coerceRemoteValue(raw, col) {
    if (raw === '' || raw == null) {
        if (col.nullable) return null;
        return raw;
    }
    const t = col.type;
    if (t === 'integer' || t === 'number') {
        const n = Number(raw);
        return Number.isFinite(n) ? n : raw;
    }
    if (t === 'boolean') return raw === 'true' || raw === true;
    if (col.format === 'json' || col.format === 'jsonb' || t === 'object') try {
        return JSON.parse(raw);
    } catch  {
        return raw;
    }
    return raw;
};
const $f0538f17063f7674$export$dfa8e583cfdf0416 = function reactToRemotePath(root) {
    const { slug: slug, table: table } = $f0538f17063f7674$export$d8adf6eaef493085();
    if (!slug) {
        if (!root._extProjects) $f0538f17063f7674$export$f81aa8839ad17e6b(root);
        return;
    }
    if (slug && !table) {
        if (!root._extProjects) $f0538f17063f7674$export$f81aa8839ad17e6b(root);
        if (!root._extSchemaBySlug?.[slug]) $f0538f17063f7674$export$f058e75b6a8e0ee1(root, slug);
        return;
    }
    if (slug && table) {
        if (!root._extProjects) $f0538f17063f7674$export$f81aa8839ad17e6b(root);
        if (!root._extSchemaBySlug?.[slug]) $f0538f17063f7674$export$f058e75b6a8e0ee1(root, slug);
        const cur = root._extCurrentTable;
        if (cur?.slug !== slug || cur?.table !== table) $f0538f17063f7674$export$c3901e5c4bd88c3(root, slug, table, 0);
    }
};
const $f0538f17063f7674$export$f92b3efc98187173 = async function saveRemoteRow(root) {
    const ed = root?._extEditor;
    if (!ed) return {
        ok: false,
        error: 'no editor state'
    };
    const schema = $f0538f17063f7674$export$ad5eedbb2fb6efc5(root, ed.slug, ed.table);
    const cols = schema?.columns || [];
    const orgId = root?.jwtClaims?.workspace_org_id;
    root.update({
        _extEditorSaving: true
    });
    const payload = {};
    for (const c of cols){
        const raw = ed.values?.[c.name];
        if (ed.mode === 'insert' && (raw == null || raw === '')) {
            if (c.default != null || c.is_primary_key) continue;
        }
        payload[c.name] = $f0538f17063f7674$export$97e80b573b14583a(raw, c);
    }
    let res;
    if (ed.mode === 'insert') res = await (0, $e92gD.insertExternalSupabase)(orgId, ed.slug, ed.table, payload);
    else {
        const pk = $f0538f17063f7674$export$a3140cbc9a39249e(schema);
        if (!pk) {
            root.update({
                _extEditorSaving: false
            });
            return {
                ok: false,
                error: 'no primary key'
            };
        }
        const pkValue = ed.original?.[pk];
        const patch = {
            ...payload
        };
        delete patch[pk];
        res = await (0, $e92gD.updateExternalSupabase)(orgId, ed.slug, ed.table, [
            {
                column: pk,
                op: 'eq',
                value: pkValue
            }
        ], patch);
    }
    root.update({
        _extEditorSaving: false
    });
    if (res?.ok) {
        root.update({
            _extEditor: null
        });
        $f0538f17063f7674$export$c3901e5c4bd88c3(root, ed.slug, ed.table, root?._extRowsPage || 0);
    }
    return res;
};
const $f0538f17063f7674$export$4d43055218cdf21e = async function deleteRemoteRow(root) {
    const ed = root?._extEditor;
    if (!ed || ed.mode !== 'update') return {
        ok: false,
        error: 'not update mode'
    };
    const schema = $f0538f17063f7674$export$ad5eedbb2fb6efc5(root, ed.slug, ed.table);
    const pk = $f0538f17063f7674$export$a3140cbc9a39249e(schema);
    if (!pk) return {
        ok: false,
        error: 'no primary key'
    };
    const pkValue = ed.original?.[pk];
    if (pkValue == null) return {
        ok: false,
        error: 'no pk value'
    };
    const orgId = root?.jwtClaims?.workspace_org_id;
    const res = await (0, $e92gD.deleteExternalSupabase)(orgId, ed.slug, ed.table, [
        {
            column: pk,
            op: 'eq',
            value: pkValue
        }
    ]);
    if (res?.ok) {
        root.update({
            _extEditor: null
        });
        $f0538f17063f7674$export$c3901e5c4bd88c3(root, ed.slug, ed.table, root?._extRowsPage || 0);
    }
    return res;
};

});


parcelRegister("fyhXe", function(module, exports) {

$parcel$export(module.exports, "InstallableStateBadge", () => $b527f55b8868254b$export$a1963638b5b6d3da);
$parcel$export(module.exports, "InstallableRailChip", () => $b527f55b8868254b$export$f49870ed9d9a8efc);
$parcel$export(module.exports, "InstallableGridCard", () => $b527f55b8868254b$export$65df3c6c6153e22e);
$parcel$export(module.exports, "InstallableListRow", () => $b527f55b8868254b$export$6d7e9c530d199bbd);
$parcel$export(module.exports, "InstallableRailItem", () => $b527f55b8868254b$export$5902caf46b31d368);
// InstallableRailItem — one chip/card/row in an InstallableRail.
//
// State shape (set by parent via childrenAs:'state'):
//   display    { icon, label, tagline, color? }  — from IntegrationKind.display
//   installed  boolean                            — true when an instance exists
//   domain     string                             — 'integration'|'library'|'mcp'|…
//   kind       string                             — kind key, e.g. 'github'
//   _layout    'rail'|'grid'|'list'              — forwarded from parent
// ── Installed state badge ─────────────────────────────────────────────
const $b527f55b8868254b$export$a1963638b5b6d3da = {
    tag: 'span',
    padding: 'X2 Y2',
    round: 'Y',
    fontSize: 'Y1',
    fontWeight: '700',
    letterSpacing: '0.04em',
    background: (el, s)=>s.installed ? 'green.1' : 'overlayStrong',
    color: (el, s)=>s.installed ? 'green' : 'caption',
    text: (el, s)=>s.installed ? 'Installed' : 'Available'
};
const $b527f55b8868254b$export$f49870ed9d9a8efc = {
    tag: 'button',
    type: 'button',
    flow: 'x',
    gap: 'Y',
    align: 'center left',
    padding: 'Y Z',
    round: 'Z2',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'line',
    background: (el, s)=>s.installed ? 'overlayStrong' : 'document',
    cursor: 'pointer',
    flexShrink: '0',
    whiteSpace: 'nowrap',
    transition: 'B defaultBezier',
    transitionProperty: 'background, border-color',
    ':hover': {
        borderColor: 'blue.5',
        background: 'blue.1'
    },
    '@media(prefers-reduced-motion:reduce)': {
        transition: 'none'
    },
    Icon: {
        fontSize: 'B',
        name: (el, s)=>s.display?.icon || s.kind || 'grid',
        color: (el, s)=>s.display?.color || 'title'
    },
    Label: {
        tag: 'span',
        fontSize: 'Z2',
        fontWeight: '600',
        color: 'title',
        text: (el, s)=>s.display?.label || s.kind || ''
    },
    InstallableStateBadge: {
        hide: (el, s)=>!s.installed
    },
    onClick: (e, el, s)=>{
        el.call('openInstallableModal', {
            domain: s.domain,
            kind: s.kind,
            installed: s.installed
        });
    }
};
const $b527f55b8868254b$export$65df3c6c6153e22e = {
    tag: 'button',
    type: 'button',
    flow: 'y',
    gap: 'Y',
    padding: 'Z Z2',
    round: 'A',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'line',
    background: 'document',
    cursor: 'pointer',
    align: 'start left',
    transition: 'B defaultBezier',
    transitionProperty: 'background, border-color',
    ':hover': {
        borderColor: 'blue.5',
        background: 'blue.1'
    },
    '@media(prefers-reduced-motion:reduce)': {
        transition: 'none'
    },
    CardHeader: {
        flow: 'x',
        gap: 'Y',
        align: 'center space-between',
        width: '100%',
        Icon: {
            fontSize: 'C',
            name: (el, s)=>s.display?.icon || s.kind || 'grid',
            color: (el, s)=>s.display?.color || 'title'
        },
        InstallableStateBadge: {
            hide: (el, s)=>!s.installed
        }
    },
    CardBody: {
        flow: 'y',
        gap: 'X2',
        align: 'start left',
        CardLabel: {
            tag: 'span',
            fontSize: 'Z2',
            fontWeight: '700',
            color: 'title',
            text: (el, s)=>s.display?.label || s.kind || ''
        },
        CardTagline: {
            tag: 'p',
            margin: '0',
            fontSize: 'Y2',
            fontWeight: '400',
            color: 'paragraph',
            lineHeight: '1.4',
            overflow: 'hidden',
            text: (el, s)=>s.display?.tagline || s.display?.description || ''
        }
    },
    onClick: (e, el, s)=>{
        el.call('openInstallableModal', {
            domain: s.domain,
            kind: s.kind,
            installed: s.installed
        });
    }
};
const $b527f55b8868254b$export$6d7e9c530d199bbd = {
    tag: 'button',
    type: 'button',
    flow: 'x',
    gap: 'Z',
    align: 'center left',
    padding: 'Y Z2',
    borderWidth: '0 0 1px 0',
    borderStyle: 'solid',
    borderColor: 'line',
    background: 'transparent',
    cursor: 'pointer',
    width: '100%',
    textAlign: 'left',
    transition: 'B defaultBezier',
    transitionProperty: 'background',
    ':hover': {
        background: 'overlayStrong'
    },
    ':last-child': {
        borderBottomColor: 'transparent'
    },
    '@media(prefers-reduced-motion:reduce)': {
        transition: 'none'
    },
    Icon: {
        fontSize: 'B',
        name: (el, s)=>s.display?.icon || s.kind || 'grid',
        color: (el, s)=>s.display?.color || 'title',
        flexShrink: '0'
    },
    Info: {
        flow: 'y',
        gap: 'X2',
        flex: '1 1 0',
        minWidth: '0',
        RowLabel: {
            tag: 'span',
            fontSize: 'Z2',
            fontWeight: '600',
            color: 'title',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>s.display?.label || s.kind || ''
        },
        RowTagline: {
            tag: 'p',
            margin: '0',
            fontSize: 'Y2',
            fontWeight: '400',
            color: 'paragraph',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>s.display?.tagline || s.display?.description || ''
        }
    },
    InstallableStateBadge: {
        flexShrink: '0'
    },
    ChevronIcon: {
        extends: 'Icon',
        name: 'arrow right',
        fontSize: 'Z2',
        color: 'caption',
        flexShrink: '0'
    },
    onClick: (e, el, s)=>{
        el.call('openInstallableModal', {
            domain: s.domain,
            kind: s.kind,
            installed: s.installed
        });
    }
};
const $b527f55b8868254b$export$5902caf46b31d368 = {
    InstallableRailChip: {
        hide: (el, s)=>s._layout !== 'rail',
        domain: (el, s)=>s.domain,
        kind: (el, s)=>s.kind,
        display: (el, s)=>s.display,
        installed: (el, s)=>s.installed
    },
    InstallableGridCard: {
        hide: (el, s)=>s._layout !== 'grid',
        domain: (el, s)=>s.domain,
        kind: (el, s)=>s.kind,
        display: (el, s)=>s.display,
        installed: (el, s)=>s.installed
    },
    InstallableListRow: {
        hide: (el, s)=>s._layout !== 'list',
        domain: (el, s)=>s.domain,
        kind: (el, s)=>s.kind,
        display: (el, s)=>s.display,
        installed: (el, s)=>s.installed
    }
};

});

parcelRegister("cJaYC", function(module, exports) {

$parcel$export(module.exports, "InstallableRailAddButton", () => $944233c687d36629$export$f6295fff5648df5b);
$parcel$export(module.exports, "InstallableRailEmpty", () => $944233c687d36629$export$949dbda2a48ca1b2);
$parcel$export(module.exports, "InstallableRailSkeleton", () => $944233c687d36629$export$bd8eaac2c4a74596);
$parcel$export(module.exports, "InstallableRailHeader", () => $944233c687d36629$export$93f1668b0294386b);
$parcel$export(module.exports, "InstallableRail", () => $944233c687d36629$export$3e84008fc72231e4);
// InstallableRail — generic catalog + instances rail/grid/list.
//
// Renders one of three layouts of installable items (integrations,
// libraries, MCP connectors, plugins, templates) for a given scopeType.
//
// Props (set on element or forwarded via parent):
//   domain        – 'integration'|'library'|'mcp'|'plugin'|'template'
//   scopeType     – 'org'|'workspace'|'project'
//                   NOTE: `scope` is a DOMQL v3.14 reserved keyword (CSS-variable
//                   scope mixin). Always use `scopeType` for this prop.
//   scopeId       – active org / workspace / project id
//   title         – rail header copy (optional)
//   emptyHint     – empty-state CTA copy (optional)
//   layout        – 'rail'|'grid'|'list'  (default: 'rail')
//   filter        – { category?, applicable_to?, … } extra catalogue filter
//   onAddClick    – optional hook before modal opens
//   onInstanceClick – optional manage-deeplink override
//
// Root state keys written by this component (all prefixed to avoid
// collisions when multiple rails are on the same page):
//   _installableRailLoading_<domain>_<scopeType>     boolean
//   _installableRailError_<domain>_<scopeType>       string|null
//   _installableRailKinds_<domain>_<scopeType>       array of catalogue rows
//   _installableRailInstances_<domain>_<scopeType>   array of instance rows
//
// Data contract (Phase 1 — display.* columns assumed present):
//   kind row: { kind, domain, category, display: { icon, label, tagline, color? },
//               applicable_to_scopes, enabled, … }
//   instance:  { kind, scope_type, scope_id, slug, display_name, enabled, … }
// ── State key helpers ─────────────────────────────────────────────────

var $3WCJD = parcelRequire("3WCJD");
const $944233c687d36629$var$_railKey = (domain, scopeType)=>`_installableRail_${domain}_${scopeType}`;
const $944233c687d36629$var$_getKinds = (root, domain, scopeType)=>root?.[`${$944233c687d36629$var$_railKey(domain, scopeType)}_kinds`] || [];
const $944233c687d36629$var$_getInstances = (root, domain, scopeType)=>root?.[`${$944233c687d36629$var$_railKey(domain, scopeType)}_instances`] || [];
const $944233c687d36629$var$_isLoading = (root, domain, scopeType)=>!!root?.[`${$944233c687d36629$var$_railKey(domain, scopeType)}_loading`];
const $944233c687d36629$var$_getError = (root, domain, scopeType)=>root?.[`${$944233c687d36629$var$_railKey(domain, scopeType)}_error`] || null;
const $944233c687d36629$var$_hasInstalled = (instances, kind)=>instances.some((i)=>i.kind === kind);
// ── Data loading helpers ───────────────────────────────────────────────
// Keeps network calls out of the component declarations so they're
// plain async functions (allowed — they don't use el.*).
const $944233c687d36629$var$_POLL_INTERVAL = 30000;
// Governance Supabase credentials — catalog (integration_kinds) is
// publicly readable via the anon key (migration 0063 + 0102 RLS policy).
// These are the published fallback values from sdk-bridge/src/env.js;
// they are NOT secrets. The same values are embedded in the marketplace
// build today (see workspace/packages/marketplace/dist).
const $944233c687d36629$var$_GOV_SUPABASE_URL = 'https://becrzpqaiovbvfmrosro.supabase.co';
const $944233c687d36629$var$_GOV_ANON_KEY = 'sb_publishable_suMZ-1Crw-304sk_MY-VZA_8aU6ZFfa';
const $944233c687d36629$var$_apiBase = ()=>{
    try {
        return (0, $3WCJD.apiUrl)().replace(/\/+$/, '');
    } catch  {
        return (0, $3WCJD.apiUrl)();
    }
};
const $944233c687d36629$var$_getToken = ()=>{
    if (typeof window === 'undefined') return null;
    return window.localStorage?.getItem('symbols_bridge_access_token') || window.localStorage?.getItem('symbols_access_token') || null;
};
// Bug A+B fix: query Supabase REST directly for integration_kinds.
//
// Previously this called /core/integration-kinds on the Symbols server,
// which doesn't exist (404). The catalog lives in the governance Supabase
// `integration_kinds` table (migration 0063). PostgREST's `cs.{}` (contains)
// operator is native there — no custom parser needed.
// Matches the pattern used by marketplace's hydrateLiveCatalog (#3741).
const $944233c687d36629$var$_fetchKinds = async (domain, scopeType)=>{
    if (typeof window === 'undefined') return [];
    const params = new URLSearchParams({
        enabled: 'eq.true'
    });
    if (scopeType) params.set('applicable_to_scopes', `cs.{${scopeType}}`);
    try {
        const res = await fetch(`${$944233c687d36629$var$_GOV_SUPABASE_URL}/rest/v1/integration_kinds?${params}`, {
            headers: {
                apikey: $944233c687d36629$var$_GOV_ANON_KEY,
                Authorization: `Bearer ${$944233c687d36629$var$_GOV_ANON_KEY}`
            }
        });
        if (!res.ok) return [];
        const json = await res.json().catch(()=>null);
        // PostgREST returns a plain array; filter enabled defensively.
        return (Array.isArray(json) ? json : json?.data || []).filter((k)=>k.enabled !== false);
    } catch  {
        return [];
    }
};
// Fetch installed instances for a given scopeType.
// Bug C fix: scopeId is guaranteed to be a resolved value by the time it
// reaches here — see _resolveElProp usage in onInit below. Guard added here
// as a belt-and-suspenders check: skip the fetch rather than send a null/
// function-literal string as a query param.
const $944233c687d36629$var$_fetchInstances = async (domain, scopeType, scopeId)=>{
    if (typeof window === 'undefined') return [];
    // Skip fetch when scopeId hasn't resolved yet (e.g. orgId not loaded).
    if (!scopeId || typeof scopeId === 'function') return [];
    if (!scopeId && scopeType !== 'org') return [];
    const token = $944233c687d36629$var$_getToken();
    if (!token) return [];
    const headers = {
        Authorization: `Bearer ${token}`
    };
    const params = new URLSearchParams({
        scope_type: scopeType
    });
    if (scopeId) params.set('scope_id', scopeId);
    // The endpoint varies by domain; fall back to org-integrations for integrations.
    const segment = domain === 'integration' ? 'org-integrations' : `${domain}-instances`;
    try {
        const res = await fetch(`${$944233c687d36629$var$_apiBase()}/core/${segment}?${params}`, {
            headers: headers
        });
        if (!res.ok) return [];
        const json = await res.json().catch(()=>null);
        return json?.data || json?.integrations || json?.instances || json || [];
    } catch  {
        return [];
    }
};
// Bug C fix: DOMQL v3.14 props may be function-typed when accessed via `el.X`
// in onInit — the framework doesn't auto-evaluate factory props on access.
// Resolve here before passing to async fetch helpers so no function literal
// ever reaches a URLSearchParams value.
const $944233c687d36629$var$_resolveElProp = (el, s, prop)=>{
    const v = el[prop];
    return typeof v === 'function' ? v(el, s) : v;
};
// Called onInit and by the realtime/poll tick. Writes into root state.
const $944233c687d36629$var$_loadRail = async (root, domain, scopeType, scopeId)=>{
    if (!domain || !scopeType) return;
    const loadingKey = `${$944233c687d36629$var$_railKey(domain, scopeType)}_loading`;
    const errorKey = `${$944233c687d36629$var$_railKey(domain, scopeType)}_error`;
    const kindsKey = `${$944233c687d36629$var$_railKey(domain, scopeType)}_kinds`;
    const instancesKey = `${$944233c687d36629$var$_railKey(domain, scopeType)}_instances`;
    // Only start a fresh load if not already in flight.
    if (root?.[loadingKey]) return;
    root.update({
        [loadingKey]: true,
        [errorKey]: null
    });
    try {
        const [kinds, instances] = await Promise.all([
            $944233c687d36629$var$_fetchKinds(domain, scopeType),
            $944233c687d36629$var$_fetchInstances(domain, scopeType, scopeId)
        ]);
        root.update({
            [kindsKey]: kinds,
            [instancesKey]: instances,
            [loadingKey]: false
        });
    } catch (err) {
        root.update({
            [loadingKey]: false,
            [errorKey]: err?.message || 'Load failed'
        });
    }
};
const $944233c687d36629$export$f6295fff5648df5b = {
    tag: 'button',
    type: 'button',
    flow: 'x',
    gap: 'Y',
    align: 'center center',
    padding: 'Y Z',
    round: 'Z2',
    borderWidth: '1px',
    borderStyle: 'dashed',
    borderColor: 'line',
    background: 'transparent',
    color: 'blue',
    fontSize: 'Z2',
    fontWeight: '600',
    cursor: 'pointer',
    flexShrink: '0',
    transition: 'B defaultBezier',
    transitionProperty: 'background, border-color',
    ':hover': {
        background: 'blue.1',
        borderColor: 'blue.5'
    },
    '@media(prefers-reduced-motion:reduce)': {
        transition: 'none'
    },
    Icon: {
        name: 'plus',
        fontSize: 'Z2',
        color: 'blue'
    },
    Label: {
        tag: 'span',
        text: (el, s)=>`Add ${s.domain || 'item'}`
    },
    onClick: (e, el, s)=>{
        if (typeof s.onAddClick === 'function') s.onAddClick(s.domain);
        el.call('openInstallableModal', {
            domain: s.domain,
            defaultScope: {
                type: s.scopeType,
                id: s.scopeId
            },
            catalogFilter: s.filter
        });
    }
};
const $944233c687d36629$export$949dbda2a48ca1b2 = {
    flow: 'y',
    gap: 'Z',
    align: 'center center',
    padding: 'B A',
    round: 'A',
    borderWidth: '1px',
    borderStyle: 'dashed',
    borderColor: 'line',
    background: 'overlayStrong',
    width: '100%',
    EmptyIcon: {
        extends: 'Icon',
        name: (el, s)=>{
            const icons = {
                integration: 'grid',
                library: 'bookmark',
                mcp: 'terminal',
                plugin: 'puzzle',
                template: 'layers'
            };
            return icons[s.domain] || 'grid';
        },
        fontSize: 'D',
        color: 'caption'
    },
    EmptyLabel: {
        tag: 'p',
        margin: '0',
        fontSize: 'Z2',
        fontWeight: '600',
        color: 'title',
        textAlign: 'center',
        text: (el, s)=>s.emptyHint || `Add your first ${s.domain || 'item'}`
    },
    EmptyHint: {
        tag: 'p',
        margin: '0',
        fontSize: 'Y2',
        fontWeight: '400',
        color: 'caption',
        textAlign: 'center',
        text: (el, s)=>{
            const domain = s.domain || 'item';
            const scopeType = s.scopeType || 'workspace';
            return `No ${domain}s installed for this ${scopeType} yet.`;
        }
    },
    AddButton: {
        extends: 'InstallableRailAddButton',
        domain: (el, s)=>s.domain,
        scopeType: (el, s)=>s.scopeType,
        scopeId: (el, s)=>s.scopeId,
        filter: (el, s)=>s.filter,
        onAddClick: (el, s)=>s.onAddClick
    }
};
const $944233c687d36629$export$bd8eaac2c4a74596 = {
    flow: 'x',
    gap: 'Z',
    align: 'center left',
    childExtends: {
        round: 'Y',
        background: 'line',
        height: 'B',
        width: 'E',
        flexShrink: '0',
        // Pulse animation via opacity — respects prefers-reduced-motion at
        // the keyframe level (no JS toggle needed).
        animation: 'pulse 1.5s ease-in-out infinite',
        '@media(prefers-reduced-motion:reduce)': {
            animation: 'none',
            opacity: '0.5'
        }
    },
    Item_1: {
        width: 'E'
    },
    Item_2: {
        width: 'D2',
        opacity: '0.8'
    },
    Item_3: {
        width: 'D2',
        opacity: '0.6'
    }
};
const $944233c687d36629$export$93f1668b0294386b = {
    flow: 'x',
    gap: 'Z',
    align: 'center space-between',
    TitleGroup: {
        flow: 'x',
        gap: 'Y',
        align: 'center left',
        TitleIcon: {
            extends: 'Icon',
            name: (el, s)=>{
                const icons = {
                    integration: 'grid',
                    library: 'bookmark',
                    mcp: 'terminal',
                    plugin: 'puzzle',
                    template: 'layers'
                };
                return icons[s.domain] || 'grid';
            },
            fontSize: 'B',
            color: 'caption',
            hide: (el, s)=>!s.domain
        },
        Title: {
            tag: 'h3',
            margin: '0',
            fontSize: 'Z2',
            fontWeight: '700',
            color: 'title',
            hide: (el, s)=>!s.title,
            text: (el, s)=>s.title || ''
        }
    },
    AddButton: {
        extends: 'InstallableRailAddButton',
        domain: (el, s)=>s.domain,
        scopeType: (el, s)=>s.scopeType,
        scopeId: (el, s)=>s.scopeId,
        filter: (el, s)=>s.filter,
        onAddClick: (el, s)=>s.onAddClick,
        // In list layout hide from header — empty state handles it.
        hide: (el, s)=>s.layout === 'list'
    }
};
const $944233c687d36629$export$3e84008fc72231e4 = {
    flow: 'y',
    gap: 'Z',
    // ── Initialise: load catalogue + instances, start poll ──────────────
    onInit: (el, s)=>{
        const root = s.root;
        // Bug C fix: resolve DOMQL v3.14 props via _resolveElProp — accessing
        // el.X for a factory prop returns the function, not its result.
        const domain = $944233c687d36629$var$_resolveElProp(el, s, 'domain');
        const scopeType = $944233c687d36629$var$_resolveElProp(el, s, 'scopeType');
        const scopeId = $944233c687d36629$var$_resolveElProp(el, s, 'scopeId');
        if (!domain || !scopeType) return;
        // Kick off the first fetch.
        $944233c687d36629$var$_loadRail(root, domain, scopeType, scopeId);
        // Poll every 30 s as fallback realtime.
        // Store the timer id on the element (transient; not root state).
        el._railPollTimer = setInterval(()=>{
            // Re-resolve scopeId on each tick — orgId may become available
            // after the initial render (e.g. lazy auth hydration).
            const latestScopeId = $944233c687d36629$var$_resolveElProp(el, s, 'scopeId');
            $944233c687d36629$var$_loadRail(root, domain, scopeType, latestScopeId);
        }, $944233c687d36629$var$_POLL_INTERVAL);
    },
    // Clean up poll timer on destroy.
    onDestroy: (el, s)=>{
        if (el._railPollTimer) {
            clearInterval(el._railPollTimer);
            el._railPollTimer = null;
        }
    },
    // ── Header ───────────────────────────────────────────────────────────
    InstallableRailHeader: {
        domain: (el, s)=>el.parent?.domain,
        title: (el, s)=>el.parent?.title,
        scopeType: (el, s)=>el.parent?.scopeType,
        scopeId: (el, s)=>el.parent?.scopeId,
        filter: (el, s)=>el.parent?.filter,
        layout: (el, s)=>el.parent?.layout || 'rail',
        onAddClick: (el, s)=>el.parent?.onAddClick,
        hide: (el, s)=>!el.parent?.title && !el.parent?.domain
    },
    // ── Loading skeleton (while first fetch is in flight) ────────────────
    InstallableRailSkeleton: {
        hide: (el, s)=>{
            const p = el.parent;
            if (!p) return true;
            return !$944233c687d36629$var$_isLoading(s.root, p.domain, p.scopeType);
        }
    },
    // ── Error banner ─────────────────────────────────────────────────────
    ErrorBanner: {
        flow: 'x',
        gap: 'Y',
        align: 'center left',
        padding: 'Y Z',
        round: 'Y',
        background: 'red.1',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'red.5',
        hide: (el, s)=>{
            const p = el.parent;
            if (!p) return true;
            return !$944233c687d36629$var$_getError(s.root, p.domain, p.scopeType);
        },
        Icon: {
            name: 'alert circle',
            fontSize: 'Z2',
            color: 'red'
        },
        Message: {
            tag: 'span',
            fontSize: 'Y2',
            color: 'red',
            text: (el, s)=>{
                const p = el.parent;
                if (!p) return '';
                return $944233c687d36629$var$_getError(s.root, p.domain, p.scopeType) || '';
            }
        },
        RetryButton: {
            tag: 'button',
            type: 'button',
            padding: 'X2 Y',
            round: 'Y',
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            fontSize: 'Y1',
            color: 'red',
            textDecoration: 'underline',
            text: 'Retry',
            onClick: (e, el, s)=>{
                const p = el.parent?.parent;
                if (!p) return;
                $944233c687d36629$var$_loadRail(s.root, p.domain, p.scopeType, p.scopeId);
            }
        }
    },
    // ── Empty state ───────────────────────────────────────────────────────
    InstallableRailEmpty: {
        domain: (el, s)=>el.parent?.domain,
        scopeType: (el, s)=>el.parent?.scopeType,
        scopeId: (el, s)=>el.parent?.scopeId,
        filter: (el, s)=>el.parent?.filter,
        emptyHint: (el, s)=>el.parent?.emptyHint,
        onAddClick: (el, s)=>el.parent?.onAddClick,
        hide: (el, s)=>{
            const p = el.parent;
            if (!p) return true;
            // Show empty only when not loading, no error, and no kinds found.
            if ($944233c687d36629$var$_isLoading(s.root, p.domain, p.scopeType)) return true;
            if ($944233c687d36629$var$_getError(s.root, p.domain, p.scopeType)) return true;
            const kinds = $944233c687d36629$var$_getKinds(s.root, p.domain, p.scopeType);
            return kinds.length > 0;
        }
    },
    // ── Rail layout (horizontal scroll strip) ────────────────────────────
    RailStrip: {
        flow: 'x',
        gap: 'Z',
        overflowX: 'auto',
        overflowY: 'hidden',
        padding: 'X2 0',
        // Hide scrollbar visually but keep scroll accessible.
        scrollbarWidth: 'none',
        '::-webkit-scrollbar': {
            display: 'none'
        },
        hide: (el, s)=>{
            const p = el.parent;
            if (!p || (p.layout || 'rail') !== 'rail') return true;
            if ($944233c687d36629$var$_isLoading(s.root, p.domain, p.scopeType)) return true;
            return $944233c687d36629$var$_getKinds(s.root, p.domain, p.scopeType).length === 0;
        },
        childExtends: 'InstallableRailItem',
        childrenAs: 'state',
        children: (el, s)=>{
            const p = el.parent;
            if (!p) return [];
            const domain = p.domain;
            const scopeType = p.scopeType;
            const kinds = $944233c687d36629$var$_getKinds(s.root, domain, scopeType);
            const instances = $944233c687d36629$var$_getInstances(s.root, domain, scopeType);
            return kinds.map((k)=>({
                    domain: domain,
                    kind: k.kind,
                    display: k.display || {
                        icon: k.icon,
                        label: k.label,
                        tagline: k.description
                    },
                    installed: $944233c687d36629$var$_hasInstalled(instances, k.kind),
                    _layout: 'rail'
                }));
        },
        // Trailing add button at the end of the chip row.
        AddButton: {
            extends: 'InstallableRailAddButton',
            domain: (el, s)=>el.parent?.parent?.domain,
            scopeType: (el, s)=>el.parent?.parent?.scopeType,
            scopeId: (el, s)=>el.parent?.parent?.scopeId,
            filter: (el, s)=>el.parent?.parent?.filter,
            onAddClick: (el, s)=>el.parent?.parent?.onAddClick
        }
    },
    // ── Grid layout (responsive card grid) ───────────────────────────────
    GridStrip: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
        gap: 'Z',
        hide: (el, s)=>{
            const p = el.parent;
            if (!p || (p.layout || 'rail') !== 'grid') return true;
            if ($944233c687d36629$var$_isLoading(s.root, p.domain, p.scopeType)) return true;
            return $944233c687d36629$var$_getKinds(s.root, p.domain, p.scopeType).length === 0;
        },
        childExtends: 'InstallableRailItem',
        childrenAs: 'state',
        children: (el, s)=>{
            const p = el.parent;
            if (!p) return [];
            const domain = p.domain;
            const scopeType = p.scopeType;
            const kinds = $944233c687d36629$var$_getKinds(s.root, domain, scopeType);
            const instances = $944233c687d36629$var$_getInstances(s.root, domain, scopeType);
            return kinds.map((k)=>({
                    domain: domain,
                    kind: k.kind,
                    display: k.display || {
                        icon: k.icon,
                        label: k.label,
                        tagline: k.description
                    },
                    installed: $944233c687d36629$var$_hasInstalled(instances, k.kind),
                    _layout: 'grid'
                }));
        }
    },
    // ── List layout (vertical management list) ────────────────────────────
    ListStrip: {
        flow: 'y',
        round: 'A',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'line',
        background: 'document',
        overflow: 'hidden',
        hide: (el, s)=>{
            const p = el.parent;
            if (!p || (p.layout || 'rail') !== 'list') return true;
            if ($944233c687d36629$var$_isLoading(s.root, p.domain, p.scopeType)) return true;
            return $944233c687d36629$var$_getKinds(s.root, p.domain, p.scopeType).length === 0;
        },
        childExtends: 'InstallableRailItem',
        childrenAs: 'state',
        children: (el, s)=>{
            const p = el.parent;
            if (!p) return [];
            const domain = p.domain;
            const scopeType = p.scopeType;
            const kinds = $944233c687d36629$var$_getKinds(s.root, domain, scopeType);
            const instances = $944233c687d36629$var$_getInstances(s.root, domain, scopeType);
            return kinds.map((k)=>({
                    domain: domain,
                    kind: k.kind,
                    display: k.display || {
                        icon: k.icon,
                        label: k.label,
                        tagline: k.description
                    },
                    installed: $944233c687d36629$var$_hasInstalled(instances, k.kind),
                    _layout: 'list'
                }));
        },
        // List footer: "Add" button at the bottom of the list.
        ListAddRow: {
            flow: 'x',
            gap: 'Y',
            align: 'center left',
            padding: 'Y Z2',
            borderTop: '1px',
            borderTopStyle: 'solid',
            borderTopColor: 'line',
            AddButton: {
                extends: 'InstallableRailAddButton',
                domain: (el, s)=>el.parent?.parent?.parent?.domain,
                scopeType: (el, s)=>el.parent?.parent?.parent?.scopeType,
                scopeId: (el, s)=>el.parent?.parent?.parent?.scopeId,
                filter: (el, s)=>el.parent?.parent?.parent?.filter,
                onAddClick: (el, s)=>el.parent?.parent?.parent?.onAddClick
            }
        }
    }
};

});

parcelRegister("7jUEZ", function(module, exports) {

$parcel$export(module.exports, "InstallableModalStub", () => $5546424afddacdc7$export$c9dd3bdf492f7f70);
// InstallableModalStub — Phase 3 placeholder modal.
//
// Mounted at each consuming app root alongside the existing Modal overlay.
// Opens whenever root.state._installableModal is set (by openInstallableModal).
// Closing clears that key.
//
// Phase 4 (MarketplaceInstallModal extensibility) replaces this component
// with the real install/manage flow. The stateKey '_installableModal' and the
// close pattern are the stable contract Phase 4 hooks into.
//
// Mount at app root (e.g. canvas/app.js, intranet/app.js):
//   InstallableModalStub: {}
//
// No additional props needed — reads everything from root.state._installableModal.
const $5546424afddacdc7$export$c9dd3bdf492f7f70 = {
    extends: 'Modal',
    stateKey: '_installableModal',
    Window: {
        extends: 'ModalWindow',
        width: 'H2',
        maxWidth: '90vw',
        ModalHeader: {
            flow: 'x',
            gap: 'Z',
            align: 'center space-between',
            padding: '0 0 Z 0',
            TitleGroup: {
                flow: 'y',
                gap: 'X2',
                Title: {
                    tag: 'h2',
                    margin: '0',
                    fontSize: 'B',
                    fontWeight: '700',
                    color: 'title',
                    text: (el, s)=>{
                        const data = s.root?._installableModal;
                        if (!data) return 'Install';
                        const label = data.kind || data.domain || 'item';
                        return data.installed ? `Manage ${label}` : `Install ${label}`;
                    }
                },
                Subtitle: {
                    tag: 'p',
                    margin: '0',
                    fontSize: 'Z2',
                    fontWeight: '400',
                    color: 'caption',
                    text: (el, s)=>{
                        const data = s.root?._installableModal;
                        if (!data) return '';
                        const parts = [];
                        if (data.domain) parts.push(`Domain: ${data.domain}`);
                        if (data.defaultScope?.type) parts.push(`Scope: ${data.defaultScope.type}`);
                        return parts.join(" \xb7 ");
                    }
                }
            },
            CloseButton: {
                tag: 'button',
                type: 'button',
                padding: 'Y',
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                color: 'caption',
                round: 'Y',
                ':hover': {
                    background: 'overlayStrong',
                    color: 'title'
                },
                onClick: (e, el, s)=>{
                    s.root?.update({
                        _installableModal: null
                    });
                },
                Icon: {
                    name: 'close',
                    fontSize: 'B'
                }
            }
        },
        // ── Phase 4 notice ────────────────────────────────────────────────────
        PhaseNotice: {
            flow: 'y',
            gap: 'Z',
            padding: 'Z A',
            round: 'A',
            background: 'blue.1',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'blue.3',
            NoticeRow: {
                flow: 'x',
                gap: 'Y',
                align: 'center left',
                Icon: {
                    name: 'info',
                    fontSize: 'Z2',
                    color: 'blue'
                },
                Label: {
                    tag: 'span',
                    fontSize: 'Z2',
                    fontWeight: '600',
                    color: 'blue',
                    text: "Phase 4 \u2014 MarketplaceInstallModal coming soon"
                }
            },
            Description: {
                tag: 'p',
                margin: '0',
                fontSize: 'Y2',
                color: 'paragraph',
                lineHeight: '1.5',
                text: (el, s)=>{
                    const data = s.root?._installableModal;
                    if (!data) return '';
                    return `openInstallableModal was called with: domain="${data.domain || "\u2014"}", ` + `kind="${data.kind || "\u2014"}", installed=${!!data.installed}. ` + 'Phase 4 MarketplaceInstallModal extensibility will wire this up with the ' + 'full install / manage flow.';
                }
            }
        },
        // ── Args debug display ────────────────────────────────────────────────
        ArgsDisplay: {
            flow: 'y',
            gap: 'Y',
            padding: 'Z A',
            round: 'A',
            background: 'overlayStrong',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'line',
            ArgsLabel: {
                tag: 'span',
                fontSize: 'Y1',
                fontWeight: '700',
                letterSpacing: '0.04em',
                color: 'caption',
                text: 'RECEIVED ARGS'
            },
            ArgsCode: {
                tag: 'pre',
                margin: '0',
                fontSize: 'Y2',
                color: 'paragraph',
                fontFamily: 'monospace',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-all',
                text: (el, s)=>{
                    const data = s.root?._installableModal;
                    return data ? JSON.stringify(data, null, 2) : '{}';
                }
            }
        },
        // ── Footer ────────────────────────────────────────────────────────────
        ModalFooter: {
            extends: 'ModalFooter',
            flow: 'x',
            gap: 'Y',
            align: 'center right',
            DismissButton: {
                tag: 'button',
                type: 'button',
                padding: 'Y Z2',
                round: 'Y',
                background: 'overlayStrong',
                border: 'none',
                cursor: 'pointer',
                fontSize: 'Z2',
                fontWeight: '600',
                color: 'title',
                text: 'Dismiss',
                ':hover': {
                    background: 'line'
                },
                onClick: (e, el, s)=>{
                    s.root?.update({
                        _installableModal: null
                    });
                }
            }
        }
    }
};

});

parcelRegister("e9Nub", function(module, exports) {

$parcel$export(module.exports, "AdminSidebar", () => (parcelRequire("5nhB0")).AdminSidebar);
$parcel$export(module.exports, "AdminSidebarLink", () => (parcelRequire("5nhB0")).AdminSidebarLink);
$parcel$export(module.exports, "AdminUserRow", () => (parcelRequire("5nhB0")).AdminUserRow);
$parcel$export(module.exports, "AdminLogDay", () => (parcelRequire("9aGUO")).AdminLogDay);
$parcel$export(module.exports, "AdminLogGroup", () => (parcelRequire("9aGUO")).AdminLogGroup);
$parcel$export(module.exports, "AdminLogCalendar", () => (parcelRequire("9aGUO")).AdminLogCalendar);
$parcel$export(module.exports, "AdminLogCalendarCell", () => (parcelRequire("9aGUO")).AdminLogCalendarCell);
$parcel$export(module.exports, "AdminLogRow", () => (parcelRequire("9aGUO")).AdminLogRow);
$parcel$export(module.exports, "AdminActivityScoringRow", () => (parcelRequire("g7qnn")).AdminActivityScoringRow);
// Components from identity pages (admin surfaces) that are resolved by
// PascalCase string-key within admin page trees. Exported here so they
// land in the shared library component registry and are available in
// workspace-project and any future runner-shell consumer.

var $5nhB0 = parcelRequire("5nhB0");

var $9aGUO = parcelRequire("9aGUO");

var $g7qnn = parcelRequire("g7qnn");

});
parcelRegister("5nhB0", function(module, exports) {

$parcel$export(module.exports, "admin", () => $3e9cbfe4e194f304$export$7d0f136b730edfdf);
$parcel$export(module.exports, "AdminSidebar", () => $3e9cbfe4e194f304$export$f645866abb13e87f);
$parcel$export(module.exports, "AdminSidebarLink", () => $3e9cbfe4e194f304$export$235cac2b64fb3140);
$parcel$export(module.exports, "AdminUserRow", () => $3e9cbfe4e194f304$export$a95ea0363e7aded2);

var $chzVb = parcelRequire("chzVb");
const $3e9cbfe4e194f304$var$_headerRow = {
    display: 'grid',
    gridTemplateColumns: '2fr 1fr auto',
    gap: 'Z',
    padding: 'Z A',
    borderBottomWidth: '2px',
    borderBottomStyle: 'solid',
    borderBottomColor: 'line',
    childProps: {
        fontSize: 'Y1',
        fontWeight: '700',
        letterSpacing: '.04em',
        textTransform: 'uppercase',
        color: 'caption'
    },
    H01: {
        text: 'Name'
    },
    H02: {
        text: 'Role'
    },
    H03: {
        text: '',
        width: 'C2'
    }
};
const $3e9cbfe4e194f304$var$_userRow = {
    display: 'grid',
    gridTemplateColumns: '2fr 1fr auto',
    gap: 'Z',
    align: 'center',
    padding: 'Z1 A',
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: 'line',
    ':hover': {
        background: 'overlayStrong'
    },
    Left: {
        flow: 'x',
        align: 'center',
        gap: 'Z1',
        minWidth: '0',
        Avatar: {
            align: 'center center',
            width: 'B1',
            height: 'B1',
            round: '50%',
            color: 'white',
            fontSize: 'Z',
            fontWeight: '700',
            background: 'blue',
            text: (el, s)=>s.avatar || ''
        },
        Info: {
            flow: 'y',
            gap: 'V',
            flex: '1',
            minWidth: '0',
            Name: {
                tag: 'span',
                fontSize: 'A',
                fontWeight: '600',
                color: 'title',
                text: (el, s)=>s.name
            },
            Email: {
                tag: 'span',
                fontSize: 'Z2',
                color: 'caption',
                text: (el, s)=>s.email
            }
        }
    },
    RoleBadge: {
        tag: 'span',
        padding: 'V Z1',
        round: 'Y',
        alignSelf: 'center',
        justifySelf: 'flex-start',
        width: 'fit-content',
        background: (el, s)=>(0, $chzVb.roleColor)(s, s.userId ? (0, $chzVb.roleOf)(s, s.userId) || 'member' : 'member'),
        color: 'white',
        fontSize: 'Z2',
        fontWeight: '700',
        text: (el, s)=>{
            // eslint-disable-next-line no-unused-expressions
            s.root.roles && s.root.roles.version;
            const cur = s.userId ? (0, $chzVb.roleOf)(s, s.userId) || 'member' : 'member';
            return (0, $chzVb.roleLabel)(s, cur);
        }
    },
    EditBtn: {
        tag: 'button',
        text: 'Edit',
        width: 'C2',
        padding: 'V Z1',
        round: 'Y',
        borderWidth: '1px',
        borderColor: 'line',
        borderStyle: 'solid',
        background: 'transparent',
        color: 'title',
        cursor: 'pointer',
        fontSize: 'Z2',
        alignSelf: 'center',
        ':hover': {
            background: 'overlay'
        },
        onClick: (e, el, s)=>{
            if (!s.email) return;
            const root = el.call('findRouteRoot', el);
            if (root) el.router(`/profile?u=${encodeURIComponent(s.email)}`, root);
        }
    }
};
const $3e9cbfe4e194f304$export$7d0f136b730edfdf = {
    extends: 'AppPage',
    metadata: {
        title: 'Admin / Symbols Workspace'
    },
    onInit: (el, s)=>{
        if (!el.call('shouldRedirectNoPerm', s, 'admin.pages.read')) return;
        const root = el.call('findRouteRoot', el);
        if (root) el.router('/', root, {}, {
            pushState: true
        });
    },
    AdminSidebar: {},
    AdminMain: {
        extends: 'AppMain',
        padding: '0',
        Header: {
            extends: 'PageHeader',
            LeftGroup: {
                Title: {
                    text: 'Users & Roles'
                }
            }
        },
        Body: {
            overflow: 'auto',
            padding: 'B',
            flow: 'y',
            gap: 'B',
            RoleGroups: {
                flow: 'y',
                gap: 'B',
                childExtends: {
                    flow: 'y',
                    round: 'Z2',
                    background: 'overlay',
                    borderWidth: '1px',
                    borderStyle: 'solid',
                    borderColor: 'line',
                    padding: 'A',
                    GroupTitle: {
                        flow: 'x',
                        align: 'center space-between',
                        margin: '0 0 Z 0',
                        GroupName: {
                            flow: 'x',
                            align: 'center',
                            gap: 'Z',
                            H2: {
                                tag: 'h2',
                                fontSize: 'B',
                                fontWeight: '800',
                                color: 'title',
                                margin: '0',
                                text: (el, s)=>s.name
                            },
                            Badge: {
                                tag: 'span',
                                padding: 'V Z',
                                round: 'Y',
                                fontSize: 'Y1',
                                fontWeight: '700',
                                color: 'caption',
                                background: 'overlayStrong',
                                text: (el, s)=>String((s.people || []).length)
                            }
                        }
                    },
                    GroupHeader: $3e9cbfe4e194f304$var$_headerRow,
                    GroupList: {
                        flow: 'y',
                        childExtends: $3e9cbfe4e194f304$var$_userRow,
                        childrenAs: 'state',
                        children: (el, s)=>s.people || []
                    }
                },
                childrenAs: 'state',
                children: (el, s)=>{
                    // eslint-disable-next-line no-unused-expressions
                    s.root.roles && s.root.roles.version;
                    return el.call('groupFilteredPeople');
                }
            }
        }
    }
};
const $3e9cbfe4e194f304$export$f645866abb13e87f = {
    extends: 'AppSidebar',
    PeopleSection: null,
    width: 'G',
    minWidth: 'G',
    Top: null,
    Middle: {
        flow: 'y',
        gap: 'V',
        childExtends: 'AdminSidebarLink',
        childrenAs: 'state',
        children: ()=>[
                {
                    label: 'Users & Roles',
                    href: '/admin'
                },
                {
                    label: 'Teams & Permissions',
                    href: '/admin/teams'
                },
                {
                    label: 'Permissions Overview',
                    href: '/admin/permissions'
                },
                {
                    label: 'Cap Table',
                    href: '/admin/cap-table'
                },
                {
                    label: 'Activity Scoring',
                    href: '/admin/activity-scoring'
                },
                {
                    label: 'Activity Logs',
                    href: '/admin/logs'
                },
                {
                    label: 'Integrations',
                    href: '/admin/integrations'
                },
                {
                    label: 'External data',
                    href: '/data/external'
                },
                {
                    label: 'Status',
                    href: '/admin/status'
                },
                {
                    label: 'Danger Zone',
                    href: '/admin/danger'
                }
            ]
    }
};
const $3e9cbfe4e194f304$export$235cac2b64fb3140 = {
    extends: 'Link',
    Label: {
        text: (el, s)=>s.label || ''
    },
    padding: 'Z A',
    round: 'Z',
    fontSize: 'A',
    textDecoration: 'none',
    cursor: 'pointer',
    href: (el, s)=>s.href,
    background: (el, s)=>(s.root?.currentPath || '/') === s.href ? 'overlay' : 'transparent',
    color: (el, s)=>(s.root?.currentPath || '/') === s.href ? 'title' : 'subtitle'
};
const $3e9cbfe4e194f304$export$a95ea0363e7aded2 = $3e9cbfe4e194f304$var$_userRow;

});
parcelRegister("chzVb", function(module, exports) {

$parcel$export(module.exports, "changeGlobalTheme", () => $8f12efc6c5fca999$export$204c4d227c4ac61c);
$parcel$export(module.exports, "sb", () => $8f12efc6c5fca999$export$f92973b23adda3f5);
$parcel$export(module.exports, "findMe", () => $8f12efc6c5fca999$export$60234ffb840d2c6b);
$parcel$export(module.exports, "colorFromEmail", () => $8f12efc6c5fca999$export$83002bccc5c3affe);
$parcel$export(module.exports, "initials", () => $8f12efc6c5fca999$export$82a129a7016c8ea8);
$parcel$export(module.exports, "allRoles", () => $8f12efc6c5fca999$export$34e53dc58297a06);
$parcel$export(module.exports, "roleOf", () => $8f12efc6c5fca999$export$18940861040fad6d);
$parcel$export(module.exports, "currentRole", () => $8f12efc6c5fca999$export$6e14c2db638aade1);
$parcel$export(module.exports, "roleMeta", () => $8f12efc6c5fca999$export$fefb98939145397d);
$parcel$export(module.exports, "roleColor", () => $8f12efc6c5fca999$export$c2844249c9ada549);
$parcel$export(module.exports, "roleLabel", () => $8f12efc6c5fca999$export$ec59b59d53da5a56);
$parcel$export(module.exports, "roleIsCore", () => $8f12efc6c5fca999$export$352d4eb3fe50bbbd);
$parcel$export(module.exports, "isCoreMember", () => $8f12efc6c5fca999$export$e377f8f4015a2bc7);
$parcel$export(module.exports, "formatTime", () => $8f12efc6c5fca999$export$3203edd9e5edd663);
$parcel$export(module.exports, "formatLongDay", () => $8f12efc6c5fca999$export$3e1c8b5ea48e709a);
$parcel$export(module.exports, "formatMonthShort", () => $8f12efc6c5fca999$export$81711723c5a14da7);
$parcel$export(module.exports, "startOAuthFlow", () => $8f12efc6c5fca999$export$a0675cce39901380);
$parcel$export(module.exports, "closeModal", () => $8f12efc6c5fca999$export$3f6fecd573f3fa48);
$parcel$export(module.exports, "canvasOrigin", () => (parcelRequire("17kPZ")).canvasOrigin);
$parcel$export(module.exports, "canvasUrl", () => (parcelRequire("17kPZ")).canvasUrl);
$parcel$export(module.exports, "getSupabaseAsync", () => (parcelRequire("8RlGv")).getSupabaseAsync);
parcelRequire("82gA2");
var $8RlGv = parcelRequire("8RlGv");
var $82gA2 = parcelRequire("82gA2");

var $jlK4b = parcelRequire("jlK4b");
parcelRequire("8augU");
var $5SInI = parcelRequire("5SInI");

var $17kPZ = parcelRequire("17kPZ");

var $1aCCy = parcelRequire("1aCCy");

var $ghHor = parcelRequire("ghHor");

var $hi6Pt = parcelRequire("hi6Pt");

var $jcSut = parcelRequire("jcSut");

var $bglB6 = parcelRequire("bglB6");

var $UgXQ6 = parcelRequire("UgXQ6");

var $cxvtm = parcelRequire("cxvtm");

var $1ALAp = parcelRequire("1ALAp");

var $9A9aQ = parcelRequire("9A9aQ");

var $1SBiR = parcelRequire("1SBiR");

var $EbDZN = parcelRequire("EbDZN");

var $6bofb = parcelRequire("6bofb");

var $bnIri = parcelRequire("bnIri");

var $erP2O = parcelRequire("erP2O");

var $lcqII = parcelRequire("lcqII");

var $kx73S = parcelRequire("kx73S");

var $dDXET = parcelRequire("dDXET");

var $cptSY = parcelRequire("cptSY");

var $5OmcJ = parcelRequire("5OmcJ");

var $2u3aj = parcelRequire("2u3aj");

var $jjwpk = parcelRequire("jjwpk");
const $8f12efc6c5fca999$export$204c4d227c4ac61c = (...args)=>(0, $5SInI.changeGlobalTheme)(...args);
const $8f12efc6c5fca999$export$f92973b23adda3f5 = (0, $8RlGv.getSupabase);
const $8f12efc6c5fca999$export$60234ffb840d2c6b = (s, { allowQuery: allowQuery = true } = {})=>{
    return (0, $jlK4b.viewedPerson)(s, {
        allowQuery: allowQuery
    }) || (0, $jlK4b.findPerson)(s && s.root, s && s.root && s.root.currentUserEmail) || {};
};
const $8f12efc6c5fca999$var$PALETTE = [
    'blue',
    'purple',
    'pink',
    'cerulean',
    'green',
    'orange',
    'indigo'
];
const $8f12efc6c5fca999$export$83002bccc5c3affe = (email)=>{
    const k = (email || '').split('').reduce((a, c)=>a + c.charCodeAt(0), 0);
    return $8f12efc6c5fca999$var$PALETTE[k % $8f12efc6c5fca999$var$PALETTE.length];
};
const $8f12efc6c5fca999$export$82a129a7016c8ea8 = (name)=>(name || '').split(/\s+/).filter(Boolean).slice(0, 2).map((p)=>p[0]).join('').toUpperCase();
const $8f12efc6c5fca999$var$_rolesByName = (s)=>{
    const list = s && s.root && s.root.roles && s.root.roles.available;
    if (!list || !list.length) return {};
    const map = {};
    for (const r of list)map[r.name] = r;
    return map;
};
const $8f12efc6c5fca999$export$34e53dc58297a06 = (s)=>s && s.root && s.root.roles && s.root.roles.available || [];
const $8f12efc6c5fca999$export$18940861040fad6d = (s, userId)=>s && s.root && s.root.roles && s.root.roles.byUser && s.root.roles.byUser[userId] || null;
const $8f12efc6c5fca999$export$6e14c2db638aade1 = (s)=>$8f12efc6c5fca999$export$18940861040fad6d(s, s && s.root && s.root.currentUserId);
const $8f12efc6c5fca999$export$fefb98939145397d = (s, role)=>$8f12efc6c5fca999$var$_rolesByName(s)[role] || null;
const $8f12efc6c5fca999$export$c2844249c9ada549 = (s, role)=>$8f12efc6c5fca999$export$fefb98939145397d(s, role)?.color || 'gray';
const $8f12efc6c5fca999$export$ec59b59d53da5a56 = (s, role)=>$8f12efc6c5fca999$export$fefb98939145397d(s, role)?.label || (role ? role.replace(/^./, (c)=>c.toUpperCase()) : 'Member');
const $8f12efc6c5fca999$export$352d4eb3fe50bbbd = (s, role)=>!!$8f12efc6c5fca999$export$fefb98939145397d(s, role)?.is_core;
const $8f12efc6c5fca999$export$e377f8f4015a2bc7 = (s)=>{
    const role = $8f12efc6c5fca999$export$6e14c2db638aade1(s);
    if (!role) return false;
    return $8f12efc6c5fca999$export$352d4eb3fe50bbbd(s, role);
};
const $8f12efc6c5fca999$var$_fmtCache = new Map();
const $8f12efc6c5fca999$var$_fmt = (locale, options)=>{
    const k = locale + JSON.stringify(options);
    if (!$8f12efc6c5fca999$var$_fmtCache.has(k)) $8f12efc6c5fca999$var$_fmtCache.set(k, new Intl.DateTimeFormat(locale, options));
    return $8f12efc6c5fca999$var$_fmtCache.get(k);
};
const $8f12efc6c5fca999$export$3203edd9e5edd663 = (ts, tz)=>{
    if (!ts) return '';
    try {
        return $8f12efc6c5fca999$var$_fmt('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            timeZone: tz,
            hour12: true
        }).format(ts).toLowerCase().replace(' ', '');
    } catch  {
        return $8f12efc6c5fca999$var$_fmt('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        }).format(ts);
    }
};
const $8f12efc6c5fca999$export$3e1c8b5ea48e709a = (ts)=>$8f12efc6c5fca999$var$_fmt('en-US', {
        day: 'numeric',
        month: 'long',
        weekday: 'long'
    }).format(ts);
const $8f12efc6c5fca999$export$81711723c5a14da7 = (ts)=>$8f12efc6c5fca999$var$_fmt('en', {
        month: 'short'
    }).format(ts);
const $8f12efc6c5fca999$export$a0675cce39901380 = (kind, { scopeType: scopeType, scopeId: scopeId, slug: slug } = {})=>{
    console.warn(`[startOAuthFlow] stub \u{2014} kind=${kind} scope=${scopeType}:${scopeId ?? 'null'} slug=${slug ?? 'default'}`);
    throw new Error(`OAuth flow not wired yet for ${kind} \u{2014} coming in follow-up once DOMAIN's first OAuth2 provider (Cloudflare registrar) ships.`);
};
const $8f12efc6c5fca999$export$3f6fecd573f3fa48 = function() {
    const root = this?.state?.root;
    if (!root?.update) return;
    let m = this;
    while(m){
        const sk = typeof m.stateKey === 'string' ? m.stateKey : null;
        if (sk) {
            const extra = m.extraClose && typeof m.extraClose === 'object' && !Array.isArray(m.extraClose) ? m.extraClose : null;
            root.update(extra ? {
                [sk]: null,
                ...extra
            } : {
                [sk]: null
            });
            return;
        }
        m = m.parent;
    }
};
$parcel$exportWildcard(module.exports, $82gA2);
$parcel$exportWildcard(module.exports, $jlK4b);
$parcel$exportWildcard(module.exports, $1aCCy);
$parcel$exportWildcard(module.exports, $ghHor);
$parcel$exportWildcard(module.exports, $hi6Pt);
$parcel$exportWildcard(module.exports, $jcSut);
$parcel$exportWildcard(module.exports, $bglB6);
$parcel$exportWildcard(module.exports, $UgXQ6);
$parcel$exportWildcard(module.exports, $cxvtm);
$parcel$exportWildcard(module.exports, $1ALAp);
$parcel$exportWildcard(module.exports, $9A9aQ);
$parcel$exportWildcard(module.exports, $1SBiR);
$parcel$exportWildcard(module.exports, $EbDZN);
$parcel$exportWildcard(module.exports, $6bofb);
$parcel$exportWildcard(module.exports, $bnIri);
$parcel$exportWildcard(module.exports, $erP2O);
$parcel$exportWildcard(module.exports, $lcqII);
$parcel$exportWildcard(module.exports, $kx73S);
$parcel$exportWildcard(module.exports, $dDXET);
$parcel$exportWildcard(module.exports, $cptSY);
$parcel$exportWildcard(module.exports, $5OmcJ);
$parcel$exportWildcard(module.exports, $2u3aj);
$parcel$exportWildcard(module.exports, $jjwpk);

});
parcelRegister("17kPZ", function(module, exports) {

$parcel$export(module.exports, "canvasOrigin", () => $0d069bc69fee4658$export$37bc00fba23a1100);
$parcel$export(module.exports, "canvasUrl", () => $0d069bc69fee4658$export$8cde1d63b9dbd29e);
$parcel$export(module.exports, "workspaceOrigin", () => $0d069bc69fee4658$export$1709c826e52a7691);
$parcel$export(module.exports, "workspaceUrl", () => $0d069bc69fee4658$export$327b3a5168bd3166);
// Resolve the canvas (editor) origin from the current workspace host.
// Mirrors the env tiers in server/packages/channels/channels.json:
//   localhost           → http://canvas.localhost:1355
//   next.my.symbols.app → https://canvas.next.symbols.app
//   dev.my.symbols.app  → https://canvas.dev.symbols.app
//   …<tier>.my.symbols.app → https://canvas.<tier>.symbols.app
//   my.symbols.app (prod) → https://edit.symbols.app
//
// Use this instead of hardcoding `https://edit.symbols.app/…` anywhere a
// workspace surface needs to deep-link into the editor (org/project create,
// open-in-canvas, etc.).
const $0d069bc69fee4658$export$37bc00fba23a1100 = ()=>{
    if (typeof window === 'undefined') return 'https://edit.symbols.app';
    const host = window.location.hostname;
    if (host.endsWith('.localhost') || host === 'localhost') return 'http://canvas.localhost:1355';
    // Tier subdomain on .my.symbols.app: split off the `my.` prefix and
    // route to canvas under the same tier.
    const m = host.match(/^([a-z0-9-]+)\.my\.symbols\.app$/i);
    if (m) return `https://canvas.${m[1]}.symbols.app`;
    if (host === 'my.symbols.app') return 'https://edit.symbols.app';
    return 'https://edit.symbols.app';
};
const $0d069bc69fee4658$export$8cde1d63b9dbd29e = (path = '/')=>{
    const p = path.startsWith('/') ? path : `/${path}`;
    return `${$0d069bc69fee4658$export$37bc00fba23a1100()}${p}`;
};
const $0d069bc69fee4658$export$1709c826e52a7691 = ()=>{
    if (typeof window === 'undefined') return 'https://my.symbols.app';
    const host = window.location.hostname;
    if (host.endsWith('.localhost') || host === 'localhost') return 'http://my.localhost:1355';
    // Tier subdomain on .symbols.app: e.g. canvas.next.symbols.app → next.my.symbols.app.
    const m = host.match(/^canvas\.([a-z0-9-]+)\.symbols\.app$/i);
    if (m) return `https://${m[1]}.my.symbols.app`;
    // Preview tier subdomain: <tier>.preview.symbols.app → <tier>.my.symbols.app.
    // Used by the preview surface's PRIVATE-project gate to hand off to
    // the same-tier workspace shell for sign-in.
    const pm = host.match(/^([a-z0-9-]+)\.preview\.symbols\.app$/i);
    if (pm) return `https://${pm[1]}.my.symbols.app`;
    if (host === 'preview.symbols.app') return 'https://my.symbols.app';
    if (host === 'edit.symbols.app') return 'https://my.symbols.app';
    // Any my.<tier>.symbols.app stays — already on the workspace shell.
    if (/\bmy\.[a-z0-9.-]+\.symbols\.app$/i.test(host) || host === 'my.symbols.app') return `${window.location.protocol}//${host}`;
    return 'https://my.symbols.app';
};
const $0d069bc69fee4658$export$327b3a5168bd3166 = (path = '/')=>{
    const p = path.startsWith('/') ? path : `/${path}`;
    return `${$0d069bc69fee4658$export$1709c826e52a7691()}${p}`;
};

});

parcelRegister("1aCCy", function(module, exports) {

$parcel$export(module.exports, "aiStream", () => $0da4aee9f66075b5$export$878a61b0c0af99dd);
$parcel$export(module.exports, "aiActionStyles", () => $0da4aee9f66075b5$export$521c301728abae36);
$parcel$export(module.exports, "aiSuggestions", () => $0da4aee9f66075b5$export$8b7c0f192bda3159);
$parcel$export(module.exports, "fetchPendingApprovals", () => $0da4aee9f66075b5$export$b1f4fbd50795be9a);
$parcel$export(module.exports, "aiWelcomeText", () => $0da4aee9f66075b5$export$685f2c86cb5ea7a0);
$parcel$export(module.exports, "aiPerformAction", () => $0da4aee9f66075b5$export$34f4b73b6bb5f6f9);
$parcel$export(module.exports, "subscribeTicketRealtime", () => $0da4aee9f66075b5$export$e213f1f9272c4814);
$parcel$export(module.exports, "unsubscribeTicketRealtime", () => $0da4aee9f66075b5$export$7d639d10c28c9b0);
// Intranet-side AI assistant wiring for the shared AppAssistant component.
//
// The shared AppAssistant (workspace/packages/shared/components/AppAssistant.js)
// calls these via `el.call('...')`:
//
//   - aiStream(messages, attachment, onChunk, onDone)
//       Streams the AI response to the governance ai-chat edge function
//       and burns credits via the shared credit-meter.
//
//   - aiPerformAction(action, s)
//       Dispatches a confirmed action proposed by the assistant
//       (create_ticket, create_event, create_note, create_kb,
//        update_ticket, move_ticket).
//
//   - aiActionStyles()
//       Returns the icon/color/label map used for proposed-action cards.
//
//   - aiSuggestions()
//       Returns the starter prompts shown in the Welcome view.
//
//   - aiWelcomeText()
//       Returns the Welcome copy shown above the suggestions.
//
//   - fetchPendingApprovals()  — TASK#4360
//       Returns tickets in state='awaiting_approval' for the governance
//       workspace. Server-side, the ai-chat edge function injects the same
//       data into the AI prompt; this client helper exists so non-AI
//       surfaces (or future inline cards) can surface the count/list with
//       the same query and avoid drift.
//
// Canvas registers nothing; the toggle button self-hides when
// `context.functions.aiStream` is absent.
//
//   - subscribeTicketRealtime(root)
//       Opens a Supabase realtime channel on public.tickets. On state
//       transitions (→done, blocked→in_progress, →awaiting_approval) for
//       tickets whose metadata.simona_user_id matches the signed-in user,
//       injects a system message into root.assistantMessages so Simona
//       auto-surfaces the update in the thread.
//
//   - unsubscribeTicketRealtime()
//       Removes the realtime channel opened by subscribeTicketRealtime.
// migrated 2026-04-27 — getSupabase + sb.channel/removeChannel replaced by
// the SDK realtime API (`workspaceProject.realtime.tickets` subscribe).
// SUPABASE_URL/ANON_KEY remain as exports for the AI edge fn fetch
// fallback at the bottom of this file (kept until the wrapper exposes a
// dedicated /workspace/ai-fallback route).

var $82gA2 = parcelRequire("82gA2");

var $bfqVY = parcelRequire("bfqVY");
// Credit metering for ai-chat now happens server-side inside the
// `ai-chat` Supabase edge function — server knows the actual token
// count from the AI provider response, so client-side estimation is
// inherently inaccurate AND trivially manipulable from the browser.
// See server/packages/credit-meter for the canonical burn primitive
// used by edge functions.
const $0da4aee9f66075b5$var$AI_CHAT_URL = `${(0, $82gA2.RAW_URL)}/functions/v1/ai-chat`;
// Resolve a fresh bearer session. Returns { token, session } so callers
// can reuse the session for follow-up reads (e.g. workspace_org_id)
// without hitting `getSession()` twice.
//
// SDK's TokenManager handles refresh internally — `getSession()` returns
// the live access token (or null if signed-out). Falls back to anon for
// the edge function path that still accepts an unauthenticated call.
// Async because the SDK proxy makes getSession() return a Promise.
async function $0da4aee9f66075b5$var$_resolveBearer() {
    const anon = {
        token: (0, $82gA2.SUPABASE_ANON_KEY),
        session: null
    };
    try {
        const session = await (0, $bfqVY.getSDK)().getSession();
        if (!session?.access_token) return anon;
        return {
            token: session.access_token,
            session: session
        };
    } catch (err) {
        console.error('[aiAssistant] getSession failed:', err);
        return anon;
    }
}
const $0da4aee9f66075b5$export$878a61b0c0af99dd = async function aiStream(messages, attachment, onChunk, onDone) {
    try {
        const { token: token } = await $0da4aee9f66075b5$var$_resolveBearer();
        const doFetch = (bearerToken)=>fetch($0da4aee9f66075b5$var$AI_CHAT_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    apikey: (0, $82gA2.SUPABASE_ANON_KEY),
                    Authorization: `Bearer ${bearerToken}`
                },
                body: JSON.stringify({
                    messages: messages,
                    attachedCard: attachment || null
                })
            });
        let res = await doFetch(token);
        if (res.status === 401 && token !== (0, $82gA2.SUPABASE_ANON_KEY)) res = await doFetch((0, $82gA2.SUPABASE_ANON_KEY));
        if (!res.ok || !res.body) {
            const err = await res.text();
            onDone('Connection error: ' + err);
            return;
        }
        const reader = res.body.getReader();
        const decoder = new TextDecoder();
        let buffer = '';
        let full = '';
        while(true){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            buffer += decoder.decode(value, {
                stream: true
            });
            const lines = buffer.split('\n');
            buffer = lines.pop() || '';
            // Batch chunks from one network read into a single onChunk call so
            // a multi-line SSE frame doesn't cascade into multiple root-state
            // updates (which re-run every reactive factory in the drawer).
            let batched = false;
            for (const line of lines){
                if (!line.startsWith('data: ')) continue;
                const json = line.slice(6).trim();
                if (json === '[DONE]') continue;
                try {
                    const parsed = JSON.parse(json);
                    if (parsed.text) {
                        full += parsed.text;
                        batched = true;
                    }
                } catch  {}
            }
            if (batched) onChunk(full);
        }
        onDone(full || 'Sorry, I could not generate a response.');
    } catch (e) {
        console.error('[aiAssistant] AI stream failed:', e);
        onDone("Connection error \u2014 please try again.");
    }
};
const $0da4aee9f66075b5$export$521c301728abae36 = function aiActionStyles() {
    return {
        create_ticket: {
            icon: 'check',
            color: 'orange',
            label: 'Create Ticket'
        },
        create_event: {
            icon: 'date outline',
            color: 'blue',
            label: 'Create Event'
        },
        create_note: {
            icon: 'document',
            color: 'green',
            label: 'Create Note'
        },
        create_kb: {
            icon: 'document',
            color: 'cyan',
            label: 'Create KB Article'
        },
        update_ticket: {
            icon: 'edit',
            color: 'yellow',
            label: 'Update Ticket'
        },
        move_ticket: {
            icon: 'arrowRight',
            color: 'purple',
            label: 'Move Ticket'
        }
    };
};
const $0da4aee9f66075b5$export$8b7c0f192bda3159 = function aiSuggestions() {
    return [
        {
            text: 'Who is on the team?'
        },
        {
            text: 'What events are coming up?'
        },
        {
            text: 'Show me company documents'
        },
        {
            text: 'What tickets are open?'
        },
        {
            text: 'What is pending approval?'
        }
    ];
};
const $0da4aee9f66075b5$export$b1f4fbd50795be9a = async function fetchPendingApprovals() {
    try {
        // migrated 2026-04-27 to SDK route workspaceProject.tickets list
        // The wrapper applies the workspace scope from the JWT, so the
        // _GOVERNANCE_WORKSPACE_ID constant is no longer threaded — callers
        // already running under the governance workspace JWT will see only
        // governance rows. Other workspaces would see THEIR awaiting_approval
        // tickets, which is the correct multi-tenant behavior.
        const result = await (0, $bfqVY.getSDK)().execute('workspaceProject.tickets', 'list', {
            filter: {
                state: 'awaiting_approval',
                deleted: false
            },
            options: {
                columns: 'id,number,title,priority,labels,assignee_email,reporter_email,updated_at,created_at'
            },
            order: {
                column: 'updated_at',
                ascending: false
            },
            limit: 50
        });
        const rows = Array.isArray(result?.data) ? result.data : result?.data || result || [];
        if (!Array.isArray(rows)) return [];
        const now = Date.now();
        return rows.map((t)=>{
            const labels = Array.isArray(t.labels) ? t.labels : [];
            const ts = t.updated_at || t.created_at;
            const ageMs = ts ? now - new Date(ts).getTime() : null;
            return {
                ...t,
                labels: labels,
                ageMs: Number.isFinite(ageMs) && ageMs >= 0 ? ageMs : null,
                needsHumanApproval: labels.includes('human-approval-needed')
            };
        });
    } catch (err) {
        console.error('[aiAssistant] fetchPendingApprovals error:', err);
        return [];
    }
};
const $0da4aee9f66075b5$export$685f2c86cb5ea7a0 = function aiWelcomeText() {
    return 'Ask me about documents, team, calendar, or tickets.';
};
// Action → [registered function name, payload builder]. `me` is the
// current user's email. Each builder returns the payload to pass into
// the named function via `el.call`.
const $0da4aee9f66075b5$var$_ACTION_DISPATCH = {
    create_ticket: (a, me)=>[
            'saveTicketToSupabase',
            {
                title: a.title || 'New ticket',
                body: a.body || '',
                columnKey: 'backlog',
                priority: a.priority || 'medium',
                assigneeEmail: a.assignee || me,
                reporterEmail: me
            }
        ],
    create_event: (a, me)=>[
            'saveEventToSupabase',
            {
                title: a.title || 'New event',
                date: a.date || new Date().toISOString().slice(0, 10),
                startTime: a.startTime || '09:00',
                endTime: a.endTime || '10:00',
                type: 'meeting',
                creatorEmail: me
            }
        ],
    create_note: (a)=>[
            'createNote',
            {
                title: a.title || 'New note',
                content: a.content || a.body || '',
                source: 'ai'
            }
        ],
    create_kb: (a)=>[
            'saveKbArticle',
            {
                title: a.title || 'New article',
                category: a.category || 'General',
                content: a.content || a.body || '',
                summary: (a.content || a.body || '').slice(0, 100)
            }
        ],
    move_ticket: (a)=>[
            'moveTicket',
            {
                ticketId: a.number,
                columnKey: a.column_key,
                position: 0
            }
        ]
};
const $0da4aee9f66075b5$export$34f4b73b6bb5f6f9 = function aiPerformAction(a, s) {
    if (!a) return;
    const root = s && s.root || this?.state?.root;
    const me = root?.currentUserEmail;
    const type = a.type;
    // `update_ticket` writes directly through the SDK rather than through a
    // registered mutator, so it stays a special case outside the table.
    if (type === 'update_ticket') {
        const row = {
            updated_at: new Date().toISOString()
        };
        if (a.body) row.body = a.body;
        if (a.title) row.title = a.title;
        if (a.column_key) row.column_key = a.column_key;
        if (a.priority) row.priority = a.priority;
        // migrated 2026-04-27 to SDK route workspaceProject.tickets update
        (0, $bfqVY.getSDK)().execute('workspaceProject.tickets', 'update', {
            number: a.number,
            payload: row
        }).catch((err)=>console.error('[aiAssistant] update_ticket failed:', err));
        return;
    }
    const builder = $0da4aee9f66075b5$var$_ACTION_DISPATCH[type];
    if (!builder) return;
    const [fnName, payload] = builder(a, me);
    this.call(fnName, payload);
};
// ─── Realtime ticket subscription ──────────────────────────────────────────
//
// Watches public.tickets via Supabase realtime. When a Simona-originated
// ticket (metadata.simona_user_id === current user) transitions to a
// noteworthy state, injects a system notification card into the assistant
// thread so Simona surfaces it without being invoked manually.
//
// Design invariants:
//   - One channel per session; calling subscribeTicketRealtime again
//     while already subscribed is a no-op (returns existing channel).
//   - User identity comes from root.currentUserId (preferred) with
//     root.currentUserEmail as fallback — matches how simona.md tags tickets.
//   - System messages use role:'system' so AppAssistantMessage renders them
//     with the 'AI' role label and the standard assistant bubble style.
//   - unsubscribeTicketRealtime() removes the channel and clears the ref so
//     the AppAssistant onRemove lifecycle can clean up without leaking sockets.
// Noteworthy state transitions: oldState → newState label shown to user.
const $0da4aee9f66075b5$var$_TRANSITION_LABEL = {
    done: 'shipped',
    awaiting_approval: 'awaiting your approval',
    in_progress: 'started'
};
// Build the human-readable notification text for a ticket state change.
const $0da4aee9f66075b5$var$_notifyText = (ticket, newState)=>{
    const label = $0da4aee9f66075b5$var$_TRANSITION_LABEL[newState] || newState;
    const title = ticket.title ? `"${ticket.title}"` : `#${ticket.id}`;
    const sha = ticket.metadata?.commitSha ? ` (commit \`${ticket.metadata.commitSha.slice(0, 7)}\`)` : '';
    // Intranet ticket deep-link — relative path works for all origins.
    const href = `/tickets/${ticket.id}`;
    const link = `[View ticket \u{2192}](${href})`;
    return `Your ticket ${title} just **${label}**${sha}. ${link}`;
};
// Module-level subscription handle so subscribe/unsubscribe are stateless
// from the component's perspective — it just calls el.call('subscribeTicketRealtime', root).
//
// migrated 2026-04-27 to SDK realtime — `workspaceProject.realtime.tickets`
// dispatches through the SDK's transport-agnostic provider. Today's wire
// is Supabase realtime via supabaseRealtimeProvider in bootShell; backend
// can swap to native socket.io without touching this file.
let $0da4aee9f66075b5$var$_ticketUnsub = null;
let $0da4aee9f66075b5$var$_ticketChannelUserId = null // identity the channel was opened for
;
const $0da4aee9f66075b5$export$e213f1f9272c4814 = function subscribeTicketRealtime(root) {
    const userId = root?.currentUserId || root?.currentUserEmail || null;
    // If already subscribed for the same user, skip.
    if ($0da4aee9f66075b5$var$_ticketUnsub && $0da4aee9f66075b5$var$_ticketChannelUserId === userId) return $0da4aee9f66075b5$var$_ticketUnsub;
    // If subscribed for a DIFFERENT user (workspace switch / sign-out + re-in),
    // tear down and re-subscribe for the new identity.
    if ($0da4aee9f66075b5$var$_ticketUnsub && $0da4aee9f66075b5$var$_ticketChannelUserId !== userId) $0da4aee9f66075b5$export$7d639d10c28c9b0();
    // No user yet — defer; subscribeTicketRealtime will be called again once
    // root.currentUserId populates (AppAssistant.Panel.Thread.onUpdate retries).
    if (!userId) return null;
    $0da4aee9f66075b5$var$_ticketChannelUserId = userId;
    let _resolved = null;
    let _cancelled = false;
    Promise.resolve((0, $bfqVY.getSDK)().getService?.('workspaceProject')).then((wp)=>{
        if (_cancelled || !wp?.realtime?.subscribeTickets) return;
        _resolved = wp.realtime.subscribeTickets({}, (event, payload)=>{
            if (event !== 'UPDATE') return;
            const ticket = payload?.new;
            const oldTicket = payload?.old;
            if (!ticket) return;
            // Filter: only tickets Simona tagged for this user.
            const meta = ticket.metadata || {};
            const ticketUserId = meta.simona_user_id;
            if (!ticketUserId || ticketUserId !== userId) return;
            const newState = ticket.state;
            const oldState = oldTicket?.state;
            // Ignore transitions that aren't noteworthy.
            if (newState === oldState) return;
            if (!$0da4aee9f66075b5$var$_TRANSITION_LABEL[newState]) return;
            // 'in_progress' is only interesting when coming from 'blocked'
            // (downstream dep shipped). Ignore fresh pick-up from backlog.
            if (newState === 'in_progress' && oldState !== 'blocked') return;
            // Inject a system notification into the assistant thread. The
            // `root.update` call re-runs every reactive factory in the drawer —
            // structurally safe because we append, never splice.
            const notifMsg = {
                role: 'system',
                content: $0da4aee9f66075b5$var$_notifyText(ticket, newState),
                _ticketNotif: true,
                _ticketId: ticket.id,
                _ticketState: newState
            };
            const current = root?.assistantMessages || [];
            if (root?.update) root.update({
                assistantMessages: [
                    ...current,
                    notifMsg
                ],
                assistantOpen: true
            });
        });
    }).catch((err)=>{
        console.warn('[aiAssistant] subscribeTicketRealtime failed:', err?.message || err);
    });
    // Stable wrapper around the (possibly still-resolving) subscription.
    $0da4aee9f66075b5$var$_ticketUnsub = ()=>{
        _cancelled = true;
        if (typeof _resolved === 'function') try {
            _resolved();
        } catch (_) {}
    };
    return $0da4aee9f66075b5$var$_ticketUnsub;
};
const $0da4aee9f66075b5$export$7d639d10c28c9b0 = function unsubscribeTicketRealtime() {
    if (!$0da4aee9f66075b5$var$_ticketUnsub) return;
    try {
        $0da4aee9f66075b5$var$_ticketUnsub();
    } catch (_) {}
    $0da4aee9f66075b5$var$_ticketUnsub = null;
    $0da4aee9f66075b5$var$_ticketChannelUserId = null;
};

});

parcelRegister("hi6Pt", function(module, exports) {

$parcel$export(module.exports, "isOptimisticId", () => $c9696a40cdec1e71$export$896acb2e77110797);
$parcel$export(module.exports, "upsertRow", () => $c9696a40cdec1e71$export$68670caa4128ccb4);
$parcel$export(module.exports, "softDeleteRow", () => $c9696a40cdec1e71$export$cb43d73b439578d7);
// Generic Supabase upsert/soft-delete helpers. Bind via .call('upsertRow', ...)
// from any DOMQL element so the active fetch context (config.fetch) is reused.
const $c9696a40cdec1e71$var$_logErr = (scope, err)=>console.error(`[${scope}]`, err?.message || err);
const $c9696a40cdec1e71$var$OPTIMISTIC_ID_FLOOR = 1000000000000;
const $c9696a40cdec1e71$export$896acb2e77110797 = (id)=>typeof id !== 'number' || id >= $c9696a40cdec1e71$var$OPTIMISTIC_ID_FLOOR;
const $c9696a40cdec1e71$export$68670caa4128ccb4 = async function({ from: from, row: row }) {
    const fetch = this.context?.fetch;
    if (!fetch?.upsert) {
        $c9696a40cdec1e71$var$_logErr('upsertRow', 'context.fetch.upsert missing');
        return null;
    }
    const data = $c9696a40cdec1e71$export$896acb2e77110797(row?.id) ? {
        ...row,
        id: undefined
    } : row;
    try {
        const result = await fetch.upsert({
            from: from,
            data: data
        });
        if (result?.error) {
            $c9696a40cdec1e71$var$_logErr('upsertRow', result.error);
            return null;
        }
        return result?.data?.[0]?.id ?? null;
    } catch (e) {
        $c9696a40cdec1e71$var$_logErr('upsertRow', e);
        return null;
    }
};
const $c9696a40cdec1e71$export$cb43d73b439578d7 = async function({ from: from, id: id }) {
    if ($c9696a40cdec1e71$export$896acb2e77110797(id)) return true;
    const fetch = this.context?.fetch;
    if (!fetch?.update) {
        $c9696a40cdec1e71$var$_logErr('softDeleteRow', 'context.fetch.update missing');
        return false;
    }
    try {
        const result = await fetch.update({
            from: from,
            params: {
                id: id
            },
            data: {
                deleted: true,
                dirty: true,
                updated_at: new Date().toISOString()
            }
        });
        if (result?.error) {
            $c9696a40cdec1e71$var$_logErr('softDeleteRow', result.error);
            return false;
        }
        return true;
    } catch (e) {
        $c9696a40cdec1e71$var$_logErr('softDeleteRow', e);
        return false;
    }
};

});

parcelRegister("jcSut", function(module, exports) {

$parcel$export(module.exports, "hasSessionToken", () => $dfb967f9eda44672$export$99e0bf065eb0a9bc);
$parcel$export(module.exports, "redirectIfUnauthed", () => $dfb967f9eda44672$export$2b286f8a5e41ae5);
$parcel$export(module.exports, "subscribeAuthSession", () => $dfb967f9eda44672$export$6aaad40b0d5ceb3e);
$parcel$export(module.exports, "getSessionEmail", () => $dfb967f9eda44672$export$b05a4894cb6b5460);
$parcel$export(module.exports, "signInWithPassword", () => $dfb967f9eda44672$export$1509ad863a77c4a4);
$parcel$export(module.exports, "signOut", () => $dfb967f9eda44672$export$b0ac3a1c242cb1ea);

var $bfqVY = parcelRequire("bfqVY");

var $8RlGv = parcelRequire("8RlGv");

var $iikzf = parcelRequire("iikzf");
const $dfb967f9eda44672$export$99e0bf065eb0a9bc = ()=>{
    if (typeof window === 'undefined') return false;
    // Symbols SDK access token — primary signal when SDK auth (not Supabase
    // federation) seeded the session. Without this, /tickets and other
    // workspace-project routes bounce to /login even though the user is
    // signed in via the Symbols SDK.
    try {
        const sym = window.localStorage.getItem('symbols_access_token');
        if (sym) {
            const exp = +window.localStorage.getItem('symbols_expires_at');
            if (!exp || exp > Date.now()) return true;
        }
    } catch (e) {}
    // Supabase federation tokens — sb-<ref>-auth-token shape.
    for(let i = 0; i < window.localStorage.length; i++){
        const k = window.localStorage.key(i);
        if (k && k.startsWith('sb-') && k.endsWith('-auth-token')) return true;
    }
    return false;
};
// Supabase-JS asynchronously parses URL-hash tokens from magic-link /
// OAuth / recovery callbacks into localStorage. If we bounce to /login
// before that happens, a valid sign-in lands on the login page and
// the tokens in the hash are lost.
const $dfb967f9eda44672$var$_hasHashSession = ()=>{
    if (typeof window === 'undefined') return false;
    const h = window.location.hash || '';
    return h.includes('access_token=') && h.includes('refresh_token=');
};
const $dfb967f9eda44672$export$2b286f8a5e41ae5 = ({ loginPath: loginPath = '/login', homePath: homePath = '/', publicPathPrefixes: publicPathPrefixes = [] } = {})=>{
    if (typeof window === 'undefined') return;
    const path = window.location.pathname;
    if (publicPathPrefixes.some((p)=>path === p || path.startsWith(p + '/') || path.startsWith(p + '?') || path === p)) return;
    if ($dfb967f9eda44672$var$_hasHashSession()) return;
    if (!$dfb967f9eda44672$export$99e0bf065eb0a9bc() && path !== loginPath) window.location.replace(loginPath);
    else if ($dfb967f9eda44672$export$99e0bf065eb0a9bc() && path === loginPath) window.location.replace(homePath);
};
const $dfb967f9eda44672$export$6aaad40b0d5ceb3e = (root, onSignIn, onWorkspaceChange)=>{
    if (!root) return ()=>{};
    let lastUserId = null;
    let lastActiveWorkspaceId = null;
    let lastClaimsKey = null;
    const handler = (_event, session)=>{
        const u = session?.user;
        const govClaims = (0, $iikzf.readGovernanceClaims)();
        const nextEmail = u?.email || '';
        const nextId = u?.id || u?._id || '';
        const nextSignedIn = !!u || !!govClaims.sub;
        // The SDK's `_currentUser` (Mongo) doesn't carry app_metadata; the
        // governance JWT is the source of orgs / active_workspace_id / role.
        // Merge sdk app_metadata first so federation claims win on conflict.
        const nextClaims = {
            ...u?.app_metadata || {},
            ...govClaims
        };
        const nextActiveWs = nextClaims?.active_workspace_id || '';
        const userChanged = root.signedIn !== nextSignedIn || root.currentUserEmail !== nextEmail || root.currentUserId !== nextId;
        // Full-payload diff so TOKEN_REFRESHED ticks that re-mint an
        // identical claim set are no-ops, but ANY claim change (orgs,
        // permissions, workspaces, tier, role, ...) still propagates.
        // Stringify is ~50µs on a 2kB JWT vs the cost of stale role/perm
        // gates — correctness wins.
        const claimsKey = JSON.stringify(nextClaims);
        const claimsChanged = claimsKey !== lastClaimsKey;
        // Derive shell-scope state from claims so the OrgSwitcher / shell chrome
        // doesn't have to wait on a separate `/orgs` round-trip — the JWT
        // already carries the user's org membership + active workspace.
        const orgsList = Array.isArray(nextClaims.orgs) ? nextClaims.orgs : [];
        const workspacesList = Array.isArray(nextClaims.workspaces) ? nextClaims.workspaces : [];
        const activeWorkspace = workspacesList.find((w)=>w.id === nextActiveWs) || null;
        const activeOrgId = activeWorkspace?.org_id || nextClaims.workspace_org_id || null;
        const activeOrg = activeOrgId ? orgsList.find((o)=>o.id === activeOrgId) : orgsList[0] || null;
        if (userChanged) {
            root.update({
                signedIn: nextSignedIn,
                currentUserEmail: nextEmail,
                currentUserId: nextId,
                jwtClaims: nextClaims,
                orgs: orgsList,
                workspaces: workspacesList,
                org: activeOrg,
                workspace: activeWorkspace
            });
            lastClaimsKey = claimsKey;
        } else if (nextSignedIn && claimsChanged) {
            root.update({
                jwtClaims: nextClaims,
                orgs: orgsList,
                workspaces: workspacesList,
                org: activeOrg,
                workspace: activeWorkspace
            });
            lastClaimsKey = claimsKey;
        }
        if (nextId && nextId !== lastUserId) {
            // New sign-in: fire onSignIn and record the starting workspace.
            lastUserId = nextId;
            lastActiveWorkspaceId = nextActiveWs;
            if (typeof onSignIn === 'function') onSignIn({
                id: nextId,
                email: nextEmail
            });
        } else if (nextId && nextActiveWs && nextActiveWs !== lastActiveWorkspaceId) {
            // Same user, different active workspace — workspace switch just landed.
            // Fire onWorkspaceChange so callers can re-load workspace-scoped data
            // without a full page reload.
            lastActiveWorkspaceId = nextActiveWs;
            if (typeof onWorkspaceChange === 'function') onWorkspaceChange(nextClaims);
        } else if (!nextId) {
            lastUserId = null;
            lastActiveWorkspaceId = null;
        }
    };
    // The SDK proxy in shared/functions/sdk.js wraps method calls so they
    // auto-await SDK init — `getSDK().onAuthStateChange(cb)` therefore
    // returns Promise<unsub> instead of a sync unsub. Use a cancel-token
    // shim so callers (workspace-project app onCreate) can safely call
    // the returned unsub from onRemove without storing a Promise.
    let unsub = null;
    let cancelled = false;
    Promise.resolve((0, $bfqVY.getSDK)().onAuthStateChange(handler)).then((sub)=>{
        if (cancelled) {
            if (typeof sub === 'function') try {
                sub();
            } catch (_) {}
            return;
        }
        unsub = typeof sub === 'function' ? sub : null;
    }).catch(()=>{});
    return ()=>{
        cancelled = true;
        if (typeof unsub === 'function') try {
            unsub();
        } catch (_) {}
    };
};
const $dfb967f9eda44672$export$b05a4894cb6b5460 = async ()=>{
    const session = await (0, $bfqVY.getSDK)().getSession();
    return session?.user?.email || null;
};
const $dfb967f9eda44672$export$1509ad863a77c4a4 = async function(email, password) {
    const { ok: ok, results: results, error: error } = await (0, $8RlGv.loginAll)({
        email: email,
        password: password
    });
    if (!ok) return {
        data: {
            user: null,
            session: null
        },
        error: {
            message: error?.message || 'Sign-in failed',
            status: error?.status
        }
    };
    // SDK session mirrors the Supabase shape (access_token + user) so the
    // login UI's downstream readers (AppLoginCard) keep working unchanged.
    // The SDK proxy makes getSession() return a Promise — await it.
    const session = await (0, $bfqVY.getSDK)().getSession();
    return {
        data: {
            user: session?.user || null,
            session: session || null,
            projects: results
        },
        error: null
    };
};
const $dfb967f9eda44672$export$b0ac3a1c242cb1ea = async function() {
    await (0, $8RlGv.logoutAll)();
};

});
parcelRegister("iikzf", function(module, exports) {

$parcel$export(module.exports, "readGovernanceClaims", () => $d519dcb8148d527c$export$de01475765b9636);
$parcel$export(module.exports, "diagnoseAuth", () => $d519dcb8148d527c$export$dbc2ee77fc19789e);
$parcel$export(module.exports, "runAuthDiagnostic", () => $d519dcb8148d527c$export$5cea61f51fe21dfa);
// Federation auth diagnostics — decodes the local auth state without
// hitting the network so callers can tell at a glance whether the
// governance Supabase JWT (required by the workspace API wrapper) is
// present, valid, and carries the workspace_id claim.
//
// Why this exists: the wrapper at /workspace/* requires a Supabase JWT
// with `workspace_id` (or `app_metadata.workspace_id` /
// `app_metadata.active_workspace_id`). The Symbols SDK's own token from
// `/core/auth/login` does NOT carry that claim, so calls authed with the
// SDK token alone get 401. The federation bridge (`loginAll` in
// `@symbo.ls/sdk-bridge`) signs the user into BOTH tenants and writes
// the governance JWT to localStorage under `sb-<gov-ref>-auth-token`.
// When auth fails the most common causes are:
//   1. governance JWT missing (federation never ran or was cleared)
//   2. governance JWT expired
//   3. governance JWT lacks workspace_id claim
//   4. SDK token present but no governance — wrapper sees the wrong tenant
//
// Use:
//   import { diagnoseAuth } from '<shared>/functions/diagnoseAuth.js'
//   console.table(diagnoseAuth())
// Or paste the body of `runAuthDiagnostic()` into a browser console for
// a no-build inspection.

var $ghHor = parcelRequire("ghHor");
const $d519dcb8148d527c$var$_decodeJwt = (token)=>{
    if (!token || typeof token !== 'string') return null;
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    try {
        const padded = parts[1].replace(/-/g, '+').replace(/_/g, '/');
        const json = atob(padded + '='.repeat((4 - padded.length % 4) % 4));
        return JSON.parse(json);
    } catch  {
        return null;
    }
};
const $d519dcb8148d527c$var$_readGovernanceTokenRaw = ()=>{
    if (typeof window === 'undefined') return {
        ref: null,
        raw: null,
        parsed: null
    };
    const ref = ((0, $ghHor.RAW_SUPABASE_URL) || '').split('//')[1]?.split('.')[0] || null;
    if (!ref) return {
        ref: null,
        raw: null,
        parsed: null
    };
    let raw = null;
    try {
        raw = window.localStorage.getItem(`sb-${ref}-auth-token`);
    } catch  {
        raw = null;
    }
    if (!raw) return {
        ref: ref,
        raw: null,
        parsed: null
    };
    try {
        return {
            ref: ref,
            raw: raw,
            parsed: JSON.parse(raw)
        };
    } catch  {
        return {
            ref: ref,
            raw: raw,
            parsed: null
        };
    }
};
const $d519dcb8148d527c$var$_readSdkToken = ()=>{
    if (typeof window === 'undefined') return null;
    try {
        return window.localStorage.getItem('symbols_access_token');
    } catch  {
        return null;
    }
};
const $d519dcb8148d527c$export$de01475765b9636 = ()=>{
    const { parsed: parsed } = $d519dcb8148d527c$var$_readGovernanceTokenRaw();
    const token = parsed?.access_token || parsed?.currentSession?.access_token;
    const payload = $d519dcb8148d527c$var$_decodeJwt(token);
    if (!payload) return {};
    return {
        ...payload.app_metadata || {},
        ...payload
    };
};
const $d519dcb8148d527c$var$_expiryStatus = (epochSec)=>{
    if (!epochSec) return {
        expired: null,
        secondsLeft: null
    };
    const now = Date.now() / 1000;
    const left = epochSec - now;
    return {
        expired: left <= 0,
        secondsLeft: Math.floor(left)
    };
};
const $d519dcb8148d527c$var$_claimWorkspaceId = (claims)=>{
    if (!claims) return null;
    return claims.workspace_id || claims.workspaceId || claims.app_metadata?.workspace_id || claims.app_metadata?.active_workspace_id || null;
};
const $d519dcb8148d527c$export$dbc2ee77fc19789e = ()=>{
    const { ref: ref, parsed: parsed } = $d519dcb8148d527c$var$_readGovernanceTokenRaw();
    const sdkToken = $d519dcb8148d527c$var$_readSdkToken();
    const govAccessToken = parsed?.access_token || parsed?.currentSession?.access_token || null;
    const govRefreshTokenPresent = !!(parsed?.refresh_token || parsed?.currentSession?.refresh_token);
    const govClaims = $d519dcb8148d527c$var$_decodeJwt(govAccessToken);
    const govExp = $d519dcb8148d527c$var$_expiryStatus(govClaims?.exp);
    const govWorkspaceId = $d519dcb8148d527c$var$_claimWorkspaceId(govClaims);
    const sdkClaims = $d519dcb8148d527c$var$_decodeJwt(sdkToken);
    const sdkExp = $d519dcb8148d527c$var$_expiryStatus(sdkClaims?.exp);
    const governance = {
        ref: ref,
        present: !!govAccessToken,
        accessToken: govAccessToken ? `${govAccessToken.slice(0, 12)}\u{2026}` : null,
        expiresAt: govClaims?.exp ? new Date(govClaims.exp * 1000).toISOString() : null,
        expiresInSec: govExp.secondsLeft,
        expired: govExp.expired,
        userId: govClaims?.sub || null,
        email: govClaims?.email || govClaims?.app_metadata?.email || null,
        workspaceIdClaim: govWorkspaceId,
        missingClaim: !!govAccessToken && !govWorkspaceId,
        refreshTokenPresent: govRefreshTokenPresent
    };
    const sdk = {
        present: !!sdkToken,
        expiresInSec: sdkExp.secondsLeft,
        expired: sdkExp.expired
    };
    let diagnosis = 'ok';
    let suggestedAction = "Auth state looks healthy \u2014 calls to /workspace/* should succeed.";
    if (!governance.present && !sdk.present) {
        diagnosis = 'all_missing';
        suggestedAction = 'No tokens in localStorage. Sign in via the federated login (loginAll).';
    } else if (!governance.present && sdk.present) {
        diagnosis = 'sdk_only';
        suggestedAction = "SDK token present but governance Supabase JWT is missing. Federation never ran or its session was cleared. Sign out completely and sign in again \u2014 `loginAll()` will re-mint both.";
    } else if (governance.expired) {
        diagnosis = 'governance_expired';
        suggestedAction = governance.refreshTokenPresent ? 'Governance JWT is expired but a refresh token is present. The Supabase auth-js client should auto-refresh; if it isn\'t, force a re-login.' : "Governance JWT is expired and no refresh token \u2014 sign in again.";
    } else if (governance.missingClaim) {
        diagnosis = 'governance_missing_workspace_claim';
        suggestedAction = "Governance JWT is valid but lacks `workspace_id` (and `app_metadata.workspace_id` / `active_workspace_id`). Server-side: the symbols-auth-bridge edge function isn't writing the claim into app_metadata. Likely a backend config issue \u2014 verify the bridge edge function for the governance project.";
    }
    return {
        governance: governance,
        sdk: sdk,
        wrapperWillAccept: governance.present && !governance.expired && !governance.missingClaim,
        diagnosis: diagnosis,
        suggestedAction: suggestedAction
    };
};
const $d519dcb8148d527c$export$5cea61f51fe21dfa = ()=>{
    const result = $d519dcb8148d527c$export$dbc2ee77fc19789e();
    // eslint-disable-next-line no-console
    console.group('[auth-diagnostic]');
    // eslint-disable-next-line no-console
    console.log('diagnosis:', result.diagnosis);
    // eslint-disable-next-line no-console
    console.log('suggestion:', result.suggestedAction);
    // eslint-disable-next-line no-console
    console.log('governance:', result.governance);
    // eslint-disable-next-line no-console
    console.log('sdk:', result.sdk);
    // eslint-disable-next-line no-console
    console.log('wrapper will accept calls:', result.wrapperWillAccept);
    // eslint-disable-next-line no-console
    console.groupEnd();
    return result;
};

});


parcelRegister("bglB6", function(module, exports) {

$parcel$export(module.exports, "currentPermissions", () => $8331f124d102389c$export$74b261995140129d);
$parcel$export(module.exports, "hasPermission", () => $8331f124d102389c$export$b325ec6732b039cf);
$parcel$export(module.exports, "hasRole", () => $8331f124d102389c$export$128c909470667330);
$parcel$export(module.exports, "userIsSuperadmin", () => $8331f124d102389c$export$1f77f77e69786261);
$parcel$export(module.exports, "userIsAdmin", () => $8331f124d102389c$export$4fa022b027db4f78);
$parcel$export(module.exports, "isExternalEmail", () => $8331f124d102389c$export$2743fcd812a5361c);
$parcel$export(module.exports, "currentUser", () => $8331f124d102389c$export$5671b2216dc5440f);
$parcel$export(module.exports, "currentUserIsAdmin", () => $8331f124d102389c$export$da10c08bc4dc3bad);
$parcel$export(module.exports, "currentUserIsSuperadmin", () => $8331f124d102389c$export$26fd45a3c2642bc0);
$parcel$export(module.exports, "isAdmin", () => $8331f124d102389c$export$fc970ed23da99565);
$parcel$export(module.exports, "findRouteRoot", () => $8331f124d102389c$export$cb73ea256889842e);
$parcel$export(module.exports, "shouldRedirectNonAdmin", () => $8331f124d102389c$export$e11f93c844913942);
$parcel$export(module.exports, "shouldRedirectNoPerm", () => $8331f124d102389c$export$a81d7c13204c7285);
$parcel$export(module.exports, "isSuperAdmin", () => $8331f124d102389c$export$35299ffa64889538);
$parcel$export(module.exports, "isManager", () => $8331f124d102389c$export$3dab6dfb846a0869);
$parcel$export(module.exports, "canAdmin", () => $8331f124d102389c$export$ef34a013d83db0f0);
$parcel$export(module.exports, "canSuperadmin", () => $8331f124d102389c$export$98ebe541db8507e7);
$parcel$export(module.exports, "canManage", () => $8331f124d102389c$export$15469708e04353e3);
$parcel$export(module.exports, "canAccessPrivate", () => $8331f124d102389c$export$fb0f0a656c460aeb);
$parcel$export(module.exports, "canEditProfile", () => $8331f124d102389c$export$c43c98c9a9584587);
$parcel$export(module.exports, "isActiveMember", () => $8331f124d102389c$export$ea4361933911274e);
$parcel$export(module.exports, "groupByRole", () => $8331f124d102389c$export$30a11599e39125d);
$parcel$export(module.exports, "rowToPerson", () => $8331f124d102389c$export$6aecab3ebd55662d);
// Role / people helpers. DB-side RLS is the real source of truth;
// these helpers exist so the UI can hide affordances ahead of the round-trip.
//
// Phase E (§I11): prefer JWT-claim permission checks
// (`hasPermission`, `canAdmin`, etc.) over role-name matching.
// Legacy `userIsAdmin` / `userIsSuperadmin` kept as the second leg of
// a union check during the dual-read migration window — matches the
// governance SQL side (see 0067_permission_based_rls.sql).

var $jlK4b = parcelRequire("jlK4b");
// ── Phase E JWT-claim readers ────────────────────────────────────
// Live claim name is `permissions` (matches `symbols-auth-bridge` +
// `jwt_has_perm` helper). TASKS_NEEDED §62 mentions `active_permissions`
// — that's documentation drift; code authoritative.
const $8331f124d102389c$var$_claims = (root)=>root && root.jwtClaims || {};
const $8331f124d102389c$export$74b261995140129d = (root)=>$8331f124d102389c$var$_claims(root).permissions || [];
function $8331f124d102389c$export$b325ec6732b039cf(root, perm) {
    const r = root != null ? root : this && this.state && this.state.root;
    if (!r) return false;
    if ($8331f124d102389c$var$_claims(r).is_owner) return true;
    return $8331f124d102389c$export$74b261995140129d(r).includes(perm);
}
function $8331f124d102389c$export$128c909470667330(user, role) {
    // CU-10 §90: roles are no longer on the person object. They live in
    // root.roles.byUser[userId]. We check that instead.
    if (!user) return false;
    // Legacy path: if person still has a .roles array (pre-migration client),
    // honour it during the transition window.
    if (Array.isArray(user.roles) && user.roles.length > 0) return user.roles.includes(role);
    // New path: look up the userId in root.roles.byUser via the closure
    // on `this.state.root` (available when called via el.call).
    const root = this && this.state && this.state.root;
    if (!root || !user.userId) return false;
    const assignedRole = (root.roles?.byUser || {})[user.userId];
    return assignedRole === role;
}
function $8331f124d102389c$export$1f77f77e69786261(user) {
    return $8331f124d102389c$export$128c909470667330(user, 'superadmin');
}
function $8331f124d102389c$export$4fa022b027db4f78(user) {
    return $8331f124d102389c$export$128c909470667330(user, 'superadmin') || $8331f124d102389c$export$128c909470667330(user, 'admin');
}
function $8331f124d102389c$export$2743fcd812a5361c(email, people = []) {
    if (!email) return true;
    return !people.find((p)=>p.email === email);
}
function $8331f124d102389c$export$5671b2216dc5440f(root) {
    const r = root != null ? root : this && this.state && this.state.root;
    return r ? (0, $jlK4b.findPerson)(r, r.currentUserEmail) : null;
}
function $8331f124d102389c$export$da10c08bc4dc3bad(root) {
    const r = root != null ? root : this && this.state && this.state.root;
    if (!r) return false;
    // JWT-based ownership trumps the Mongo `roles.byUser` lookup. The auth
    // gates on /admin/* pages use JWT claims (isOwner / org_role / perms),
    // so the dropdown discovery link must follow the same rule — otherwise
    // legitimate owners can reach the pages directly but never see the
    // entry point. Mongo `roles.byUser` is org-membership-scoped and not
    // always seeded for owners on every org.
    const c = r.jwtClaims;
    if (c?.is_owner === true) return true;
    if (c?.org_role === 'admin' || c?.org_role === 'owner') return true;
    if (c?.workspace_role === 'admin' || c?.workspace_role === 'owner') return true;
    return $8331f124d102389c$export$4fa022b027db4f78($8331f124d102389c$export$5671b2216dc5440f(r));
}
function $8331f124d102389c$export$26fd45a3c2642bc0(root) {
    const r = root != null ? root : this && this.state && this.state.root;
    return $8331f124d102389c$export$1f77f77e69786261($8331f124d102389c$export$5671b2216dc5440f(r));
}
function $8331f124d102389c$export$fc970ed23da99565(s) {
    const root = s?.root || this && this.state && this.state.root;
    return $8331f124d102389c$export$4fa022b027db4f78($8331f124d102389c$export$5671b2216dc5440f(root));
}
function $8331f124d102389c$export$cb73ea256889842e(startEl) {
    let cur = startEl || this;
    while(cur && !cur.routes)cur = cur.parent;
    return cur || null;
}
function $8331f124d102389c$export$e11f93c844913942(s, role) {
    const root = s?.root || this && this.state && this.state.root;
    if (!root?.currentUserId) return false;
    if (!Array.isArray(root.people) || !root.people.length) return false;
    const checker = role === 'superadmin' ? $8331f124d102389c$export$1f77f77e69786261 : $8331f124d102389c$export$4fa022b027db4f78;
    // Phase E union: permission-matching leg first so JWT-carried owners
    // and perm-granted users pass without needing a Supabase `user_roles`
    // row. Legacy role check remains as the second leg during the
    // dual-read window.
    const permKey = role === 'superadmin' ? 'admin.danger.access' : 'admin.pages.read';
    if ($8331f124d102389c$export$b325ec6732b039cf(root, permKey)) return false;
    return !checker($8331f124d102389c$export$5671b2216dc5440f(root));
}
function $8331f124d102389c$export$a81d7c13204c7285(s, perm) {
    const root = s?.root || this && this.state && this.state.root;
    if (!root?.currentUserId) return false;
    // Owner/perm path works before `people` is seeded; only fall back to
    // the legacy branch if we *have* to.
    if ($8331f124d102389c$var$_claims(root).is_owner) return false;
    if ($8331f124d102389c$export$b325ec6732b039cf(root, perm)) return false;
    if (!Array.isArray(root.people) || !root.people.length) return false;
    // Final legacy leg — `admin.pages.read` maps to admin; explicit perms
    // not in the claim fall through to role-name check so users with
    // `user_roles` entries but no Phase E JWT don't lose access.
    if (perm === 'admin.pages.read') return !$8331f124d102389c$export$4fa022b027db4f78($8331f124d102389c$export$5671b2216dc5440f(root));
    if (perm === 'admin.danger.access') return !$8331f124d102389c$export$1f77f77e69786261($8331f124d102389c$export$5671b2216dc5440f(root));
    return true;
}
function $8331f124d102389c$export$35299ffa64889538(s) {
    const root = s?.root || this && this.state && this.state.root;
    return $8331f124d102389c$export$1f77f77e69786261($8331f124d102389c$export$5671b2216dc5440f(root));
}
function $8331f124d102389c$export$3dab6dfb846a0869(s) {
    const root = s?.root || this && this.state && this.state.root;
    const user = $8331f124d102389c$export$5671b2216dc5440f(root);
    return $8331f124d102389c$export$128c909470667330(user, 'manager') || $8331f124d102389c$export$4fa022b027db4f78(user);
}
function $8331f124d102389c$export$ef34a013d83db0f0(s) {
    const root = s?.root || this && this.state && this.state.root;
    return $8331f124d102389c$export$b325ec6732b039cf(root, 'admin.pages.read') || $8331f124d102389c$export$4fa022b027db4f78($8331f124d102389c$export$5671b2216dc5440f(root));
}
function $8331f124d102389c$export$98ebe541db8507e7(s) {
    const root = s?.root || this && this.state && this.state.root;
    return $8331f124d102389c$export$b325ec6732b039cf(root, 'admin.danger.access') || $8331f124d102389c$export$1f77f77e69786261($8331f124d102389c$export$5671b2216dc5440f(root));
}
function $8331f124d102389c$export$15469708e04353e3(s) {
    const root = s?.root || this && this.state && this.state.root;
    if ($8331f124d102389c$export$b325ec6732b039cf(root, 'member.update_role')) return true;
    const user = $8331f124d102389c$export$5671b2216dc5440f(root);
    return $8331f124d102389c$export$128c909470667330(user, 'manager') || $8331f124d102389c$export$4fa022b027db4f78(user);
}
function $8331f124d102389c$export$fb0f0a656c460aeb(sOrPerson, maybePerson) {
    let root, person;
    if (maybePerson !== undefined) {
        root = sOrPerson?.root || this && this.state && this.state.root;
        person = maybePerson;
    } else {
        root = this && this.state && this.state.root;
        person = sOrPerson;
    }
    if (!root) return true;
    const isSelfUser = !person?.email || person.email === root.currentUserEmail;
    if (isSelfUser) return true;
    if ($8331f124d102389c$export$b325ec6732b039cf(root, 'profile.private.read')) return true;
    return $8331f124d102389c$export$1f77f77e69786261($8331f124d102389c$export$5671b2216dc5440f(root));
}
function $8331f124d102389c$export$c43c98c9a9584587(sOrPerson, maybePerson) {
    let root, person;
    if (maybePerson !== undefined) {
        root = sOrPerson?.root || this && this.state && this.state.root;
        person = maybePerson;
    } else {
        root = this && this.state && this.state.root;
        person = sOrPerson;
    }
    if (!root) return false;
    const isSelfUser = !person?.email || person.email === root.currentUserEmail;
    if (isSelfUser) return true;
    if ($8331f124d102389c$export$b325ec6732b039cf(root, 'profile.edit_others')) return true;
    return $8331f124d102389c$export$1f77f77e69786261($8331f124d102389c$export$5671b2216dc5440f(root));
}
function $8331f124d102389c$export$ea4361933911274e(s) {
    const root = s?.root || this && this.state && this.state.root;
    if (!root || !root.signedIn) return false;
    const people = root.people || [];
    const email = root.currentUserEmail;
    if (!email || !people.find((p)=>p.email === email)) return false;
    // CU-10 §90: roles.available dropped with public.roles view (migration 0087).
    // Any signed-in org member is considered active regardless of role.
    return true;
}
function $8331f124d102389c$export$30a11599e39125d(people) {
    const root = this && this.state && this.state.root;
    const available = root?.roles?.available || [];
    // CU-10 §90: role from root.roles.byUser[userId]; fallback to p.roles for legacy data.
    const byUser = root?.roles?.byUser || {};
    const groups = {};
    for (const p of people || []){
        const legacyRoles = Array.isArray(p.roles) && p.roles.length > 0 ? p.roles : null;
        const role = legacyRoles ? legacyRoles[0] : byUser[p.userId] || 'member';
        if (!groups[role]) groups[role] = [];
        groups[role].push(p);
    }
    // Order by the roles enum order, then any extras
    const ordered = available.length ? available.map((r)=>r.name) : [
        'superadmin',
        'admin',
        'manager',
        'member',
        'advisor',
        'investor'
    ];
    return ordered.filter((r)=>groups[r]?.length).map((r)=>{
        const meta = available.find((m)=>m.name === r) || {};
        return {
            role: r,
            label: meta.label || r.replace(/^./, (c)=>c.toUpperCase()),
            color: meta.color || 'gray',
            users: groups[r].sort((a, b)=>(a.name || '').localeCompare(b.name || ''))
        };
    });
}
const $8331f124d102389c$export$6aecab3ebd55662d = (r)=>({
        name: r.name,
        email: r.email,
        avatar: r.avatar,
        position: r.position,
        location: r.location,
        country: r.country,
        city: r.city,
        timezone: r.timezone,
        github: r.github,
        weeklyHours: r.weekly_hours,
        workingDays: r.working_days,
        workingHours: {
            start: r.working_hours_start,
            end: r.working_hours_end
        },
        // CU-10 §90: roles/isAdmin removed from people view. Role data lives in
        // root.roles.byUser[userId] (server GET /auth/org/:orgId/member-roles).
        origin_valuation: r.origin_valuation
    });

});

parcelRegister("UgXQ6", function(module, exports) {

$parcel$export(module.exports, "appSettingsFetch", () => $0a9263cde00f3f12$export$3970e432c1515f85);
$parcel$export(module.exports, "peopleFetch", () => $0a9263cde00f3f12$export$4e12284f8c6638cd);
$parcel$export(module.exports, "appPageBoilerplateFetch", () => $0a9263cde00f3f12$export$8bf8c59a80c21236);

var $bglB6 = parcelRequire("bglB6");
const $0a9263cde00f3f12$export$3970e432c1515f85 = {
    method: 'select',
    from: 'workspaceProject.companySettings',
    as: '~/_settings',
    // companySettings.get returns one row { current_user_email, company_name, ... }
    // — guard the transform to also accept array-of-rows for back-compat.
    transform: (rowOrRows)=>{
        const r = Array.isArray(rowOrRows) ? Object.fromEntries(rowOrRows.map((row)=>[
                row.key,
                row.value
            ])) : rowOrRows || {};
        // Never fall back to another user's email — leaving it null/empty lets
        // the auth gate or page-level guards handle the missing identity, rather
        // than silently rendering Nika's data to whoever happens to load the
        // page before the auth subscription resolves.
        return {
            currentUserEmail: r.current_user_email || '',
            companyName: r.company_name || 'Symbols'
        };
    }
};
const $0a9263cde00f3f12$export$4e12284f8c6638cd = {
    method: 'select',
    from: 'workspaceProject.people',
    order: 'name',
    as: '~/people',
    transform: (rows)=>({
            people: (rows || []).map((0, $bglB6.rowToPerson))
        })
};
const $0a9263cde00f3f12$export$8bf8c59a80c21236 = [
    $0a9263cde00f3f12$export$3970e432c1515f85,
    $0a9263cde00f3f12$export$4e12284f8c6638cd
];

});

parcelRegister("1ALAp", function(module, exports) {

$parcel$export(module.exports, "githubColorTokenFromName", () => $128e10e3ba30688e$export$f46bad6610667829);
const $128e10e3ba30688e$var$GITHUB_COLOR_TOKEN = {
    GRAY: 'caption',
    RED: 'red',
    ORANGE: 'orange',
    YELLOW: 'yellow',
    GREEN: 'green',
    BLUE: 'blue',
    PURPLE: 'purple',
    PINK: 'magenta'
};
const $128e10e3ba30688e$export$f46bad6610667829 = (color)=>$128e10e3ba30688e$var$GITHUB_COLOR_TOKEN[color] || 'caption';

});

parcelRegister("9A9aQ", function(module, exports) {

$parcel$export(module.exports, "formatBytes", () => $6f9e979cb831ca64$export$e1a3971de07c83b5);
const $6f9e979cb831ca64$export$e1a3971de07c83b5 = (sz)=>{
    if (!sz) return '';
    if (sz < 1024) return sz + ' B';
    if (sz < 1048576) return Math.round(sz / 1024) + ' KB';
    return Math.round(sz / 1024 / 1024) + ' MB';
};

});

parcelRegister("1SBiR", function(module, exports) {

$parcel$export(module.exports, "setNavbarTooltipPosition", () => $15e7c53f2b6b64ef$export$f8022f975d76fe07);
const $15e7c53f2b6b64ef$export$f8022f975d76fe07 = function setNavbarTooltipPosition(params) {
    const el = this;
    const tooltip = el.lookup('NavbarTooltip');
    if (!tooltip || !tooltip.node) return;
    const node = tooltip.node;
    if (!params || !params.visible) {
        node.style.opacity = '0';
        node.style.visibility = 'hidden';
        node.style.transform = 'translate3d(-50%,-10%,0)';
        return;
    }
    const titleVal = typeof el.title === 'function' ? el.title(el, el.state) : el.title;
    const title = titleVal || '';
    if (tooltip.P && tooltip.P.node) tooltip.P.node.textContent = title;
    const btnRect = el.node.getBoundingClientRect();
    const parentRect = tooltip.parent.node.getBoundingClientRect();
    const left = btnRect.left - parentRect.left + btnRect.width / 2;
    node.style.left = left + 'px';
    node.style.opacity = '1';
    node.style.visibility = 'visible';
    node.style.transform = 'translate3d(-50%,0,0)';
};

});

parcelRegister("EbDZN", function(module, exports) {

$parcel$export(module.exports, "groupLabel", () => $078cc4d0d9cddc95$export$808794a1efddf200);
$parcel$export(module.exports, "groupKeyOf", () => $078cc4d0d9cddc95$export$93bce263b840bcab);
$parcel$export(module.exports, "peopleGroupCategories", () => $078cc4d0d9cddc95$export$473366439e5e7e9e);
$parcel$export(module.exports, "peopleRoleCategories", () => $078cc4d0d9cddc95$export$bf495272b9b17544);
$parcel$export(module.exports, "peopleTeamCategories", () => $078cc4d0d9cddc95$export$2a0f7f5c3adbe817);
$parcel$export(module.exports, "filterPeople", () => $078cc4d0d9cddc95$export$8d0a56f9265c826);
$parcel$export(module.exports, "groupFilteredPeople", () => $078cc4d0d9cddc95$export$1878c8b52d8511e3);
// People grouping and filtering helpers.
// All are el.call()-compatible (regular functions, `this` binds to element).
parcelRequire("bglB6");

var $gMSeo = parcelRequire("gMSeo");
const $078cc4d0d9cddc95$var$GROUP_LABEL = {};
function $078cc4d0d9cddc95$export$808794a1efddf200(raw) {
    return $078cc4d0d9cddc95$var$GROUP_LABEL[raw] || (raw || 'Other').replace(/^./, (c)=>c.toUpperCase());
}
function $078cc4d0d9cddc95$export$93bce263b840bcab(person, teamsByEmail) {
    const email = String(person?.email || '').toLowerCase();
    const teams = teamsByEmail?.[email] || [];
    return teams[0]?.name || 'Other';
}
// Clip `public.people` (cross-tenant) down to the active org's roster.
// NEVER return unfiltered people for a known active org — that leaks
// cross-tenant users. Legacy orgs bypass via LEGACY_ORG_IDS.
const $078cc4d0d9cddc95$var$_activeOrgPeople = (root)=>{
    const people = root?.people || [];
    const orgId = root?.jwtClaims?.workspace_org_id;
    if (!orgId) return people;
    if ((0, $gMSeo.LEGACY_ORG_IDS).has(orgId)) return people;
    const set = root?.orgMembersByOrgId?.[orgId];
    if (!set) {
        const myEmail = String(root?.currentUserEmail || '').toLowerCase();
        if (!myEmail) return [];
        return people.filter((p)=>String(p?.email || '').toLowerCase() === myEmail);
    }
    return people.filter((p)=>!!set[String(p?.email || '').toLowerCase()]);
};
function $078cc4d0d9cddc95$export$473366439e5e7e9e() {
    const root = this && this.state && this.state.root;
    const people = $078cc4d0d9cddc95$var$_activeOrgPeople(root);
    const counts = new Map();
    for (const p of people){
        const k = $078cc4d0d9cddc95$export$93bce263b840bcab(p, root?.teamsByEmail);
        counts.set(k, (counts.get(k) || 0) + 1);
    }
    return [
        ...counts.entries()
    ].sort((a, b)=>a[0].localeCompare(b[0])).map(([key, count])=>({
            key: key,
            label: $078cc4d0d9cddc95$export$808794a1efddf200(key),
            count: count,
            name: key,
            kind: 'group'
        }));
}
// Returns all roles with user counts derived from root.roles.byUser.
// CU-10 §90: roles no longer on person object; source is root.roles.byUser.
// el.call('peopleRoleCategories')
// CU-10 §90: public.roles view dropped (migration 0087). Role order/labels
// fall back to the canonical hardcoded list; counts derived from byUser.
const $078cc4d0d9cddc95$var$ROLE_FALLBACK_ORDER = [
    'superadmin',
    'admin',
    'manager',
    'member',
    'advisor',
    'investor'
];
const $078cc4d0d9cddc95$var$ROLE_FALLBACK_LABELS = {
    superadmin: 'Superadmin',
    admin: 'Admin',
    manager: 'Manager',
    member: 'Member',
    advisor: 'Advisor',
    investor: 'Investor'
};
function $078cc4d0d9cddc95$export$bf495272b9b17544() {
    const root = this && this.state && this.state.root;
    const people = $078cc4d0d9cddc95$var$_activeOrgPeople(root);
    const byUser = root?.roles?.byUser || {};
    const counts = new Map();
    for (const p of people){
        // Legacy fallback for pre-§90 data still in p.roles
        const legacyRoles = Array.isArray(p.roles) && p.roles.length > 0 ? p.roles : null;
        if (legacyRoles) for (const r of legacyRoles)counts.set(r, (counts.get(r) || 0) + 1);
        else {
            const role = byUser[p.userId] || 'member';
            counts.set(role, (counts.get(role) || 0) + 1);
        }
    }
    return $078cc4d0d9cddc95$var$ROLE_FALLBACK_ORDER.filter((r)=>counts.has(r)).map((r)=>({
            key: r,
            label: $078cc4d0d9cddc95$var$ROLE_FALLBACK_LABELS[r] || r.replace(/^./, (c)=>c.toUpperCase()),
            count: counts.get(r) || 0,
            name: r,
            kind: 'role'
        }));
}
function $078cc4d0d9cddc95$export$2a0f7f5c3adbe817() {
    const root = this && this.state && this.state.root;
    const teamsByEmail = root?.teamsByEmail || {};
    const counts = {
        active: 0,
        external: 0,
        none: 0
    };
    for (const p of $078cc4d0d9cddc95$var$_activeOrgPeople(root)){
        const email = String(p?.email || '').toLowerCase();
        counts[(0, $gMSeo.effectiveCategory)(teamsByEmail[email])] += 1;
    }
    const out = [
        {
            key: 'active',
            label: 'Active',
            count: counts.active,
            name: 'active',
            kind: 'category'
        },
        {
            key: 'external',
            label: 'External',
            count: counts.external,
            name: 'external',
            kind: 'category'
        }
    ];
    if (counts.none > 0) out.push({
        key: 'none',
        label: 'Unassigned',
        count: counts.none,
        name: 'none',
        kind: 'category'
    });
    return out;
}
function $078cc4d0d9cddc95$export$8d0a56f9265c826() {
    const root = this && this.state && this.state.root;
    const people = root?.people || [];
    const g = root?.selectedGroup;
    const r = root?.selectedRole;
    const c = root?.selectedTeamCategory // 'active' | 'external' | 'none' | null
    ;
    const activeOrgId = root?.jwtClaims?.workspace_org_id;
    const isLegacy = activeOrgId && (0, $gMSeo.LEGACY_ORG_IDS).has(activeOrgId);
    const orgMembers = activeOrgId && !isLegacy ? root?.orgMembersByOrgId?.[activeOrgId] : null;
    const teamsByEmail = root?.teamsByEmail || {};
    // CU-10 §90: role per person from root.roles.byUser (not p.roles)
    const byUser = root?.roles?.byUser || {};
    return people.filter((p)=>{
        if (orgMembers && !!!orgMembers[String(p?.email || '').toLowerCase()]) return false;
        if (g && $078cc4d0d9cddc95$export$93bce263b840bcab(p, teamsByEmail) !== g) return false;
        if (r) {
            // Legacy fallback: person still has .roles array
            const legacyRoles = Array.isArray(p.roles) && p.roles.length > 0 ? p.roles : null;
            if (legacyRoles) {
                if (legacyRoles.length === 0 && r !== 'member') return false;
                if (legacyRoles.length > 0 && !legacyRoles.includes(r)) return false;
            } else {
                const assignedRole = byUser[p.userId] || 'member';
                if (assignedRole !== r) return false;
            }
        }
        if (c) {
            const email = String(p?.email || '').toLowerCase();
            const cat = (0, $gMSeo.effectiveCategory)(teamsByEmail[email]);
            if (cat !== c) return false;
        }
        return true;
    });
}
function $078cc4d0d9cddc95$export$1878c8b52d8511e3() {
    const root = this && this.state && this.state.root;
    const filtered = $078cc4d0d9cddc95$export$8d0a56f9265c826.call(this);
    // Role filter active — single group labelled with the role
    if (root?.selectedRole) {
        const available = root?.roles?.available || [];
        const meta = available.find((r)=>r.name === root.selectedRole);
        return [
            {
                name: meta?.label || root.selectedRole,
                people: filtered
            }
        ];
    }
    // Category filter active — single group labelled with the category
    if (root?.selectedTeamCategory) {
        const label = root.selectedTeamCategory.charAt(0).toUpperCase() + root.selectedTeamCategory.slice(1);
        return [
            {
                name: label,
                people: filtered
            }
        ];
    }
    // Default (including explicit team filter) — group by team name
    const buckets = new Map();
    for (const p of filtered){
        const k = $078cc4d0d9cddc95$export$93bce263b840bcab(p, root?.teamsByEmail);
        if (!buckets.has(k)) buckets.set(k, []);
        buckets.get(k).push(p);
    }
    // Sort: named teams alphabetically first, then "Other" last
    return [
        ...buckets.entries()
    ].sort((a, b)=>{
        if (a[0] === 'Other') return 1;
        if (b[0] === 'Other') return -1;
        return a[0].localeCompare(b[0]);
    }).map(([key, ppl])=>({
            name: $078cc4d0d9cddc95$export$808794a1efddf200(key),
            people: ppl
        }));
}

});
parcelRegister("gMSeo", function(module, exports) {

$parcel$export(module.exports, "PERMISSION_GROUPS", () => $c38b323b0e554a5d$export$40d95c19a7e19d13);
$parcel$export(module.exports, "LEGACY_ORG_IDS", () => $c38b323b0e554a5d$export$3dee873c174bc8d8);
$parcel$export(module.exports, "PERMISSIONS_BY_GROUP", () => $c38b323b0e554a5d$export$2931f501d90fd912);
$parcel$export(module.exports, "hasPerm", () => $c38b323b0e554a5d$export$cdac03a8d3b5824e);
$parcel$export(module.exports, "isOwner", () => $c38b323b0e554a5d$export$e71175321a2b5dc8);
$parcel$export(module.exports, "effectiveCategory", () => $c38b323b0e554a5d$export$74316c6523cc040e);
$parcel$export(module.exports, "permLabel", () => $c38b323b0e554a5d$export$72bc84371f3e87c6);
$parcel$export(module.exports, "permDescription", () => $c38b323b0e554a5d$export$6e2715c6663b7445);
// Permission vocabulary — single source of truth for the intranet's
// team-based access control. 30 keys, grouped by domain. The server
// mirrors this file at `server/src/core/constants/permissions.js`
// and must stay in sync (see NEEDED_FOR_SERVER.md §I11).
//
// Effective permissions for a user in an org =
//   owner-bypass  ∪  OrgMember.role perms  ∪  team perms  ∪  ancestor team perms
//
// Checked in:
//   • Governance RLS (`jwt_has_perm(key)` — migration 0060)
//   • Server endpoints that mutate teams / perms
//   • Intranet UI gates (admin matrix, tab visibility)
//
// No wildcards by design — enumerate effective perms exactly.
// ── Permission keys ────────────────────────────────────────────────
const $c38b323b0e554a5d$export$d6eefc103e184eaa = {
    // Admin (settings-page surfaces; not "superuser")
    'admin.pages.read': {
        group: 'Admin',
        label: 'Access /admin surfaces',
        description: 'Read-level access to any /admin page (blanket gate; specific write perms layered on top)'
    },
    'admin.users': {
        group: 'Admin',
        label: 'Manage users',
        description: 'Invite, deactivate, reset password, view all accounts'
    },
    'admin.teams': {
        group: 'Admin',
        label: 'Manage teams',
        description: 'Create, rename, delete teams; add/remove members'
    },
    'admin.team_permissions': {
        group: 'Admin',
        label: 'Edit team permissions',
        description: 'Change the permission matrix on any team (separate from membership to prevent self-escalation)'
    },
    'admin.billing': {
        group: 'Admin',
        label: 'Manage billing',
        description: 'Subscription tier, payment methods, plan changes'
    },
    'admin.integrations': {
        group: 'Admin',
        label: 'Manage integrations',
        description: 'Connect and configure external services'
    },
    'admin.commercials': {
        group: 'Admin',
        label: 'Manage commercials',
        description: 'Edit public-facing services, packages, pricing'
    },
    'admin.cap_table': {
        group: 'Admin',
        label: 'Manage cap table',
        description: 'View + edit cap table, grants, vesting'
    },
    'admin.hr': {
        group: 'Admin',
        label: 'Edit HR fields',
        description: 'Title, start date, position on other users\' profiles'
    },
    'admin.logs': {
        group: 'Admin',
        label: 'View activity logs',
        description: 'Audit trail + security logs'
    },
    'admin.system': {
        group: 'Admin',
        label: 'System administration',
        description: 'System status, danger zone, data export'
    },
    'admin.company': {
        group: 'Admin',
        label: 'Edit company page',
        description: 'Edit /company content'
    },
    // Docs
    'docs.edit_others': {
        group: 'Docs',
        label: 'Edit others\' docs',
        description: 'Modify docs authored by other people'
    },
    'docs.delete_others': {
        group: 'Docs',
        label: 'Delete others\' docs',
        description: 'Remove docs authored by other people'
    },
    'docs.read_private': {
        group: 'Docs',
        label: 'Read private docs',
        description: 'View docs not explicitly shared with you'
    },
    // Knowledge base
    'kb.edit_others': {
        group: 'KB',
        label: 'Edit others\' KB pages',
        description: 'Modify wiki pages authored by other people'
    },
    'kb.delete_others': {
        group: 'KB',
        label: 'Delete others\' KB pages',
        description: 'Remove wiki pages authored by other people'
    },
    // Tickets
    'tickets.assign': {
        group: 'Tickets',
        label: 'Assign tickets',
        description: 'Set assignee on tickets'
    },
    'tickets.close_others': {
        group: 'Tickets',
        label: 'Close others\' tickets',
        description: 'Mark as done tickets you don\'t own'
    },
    'tickets.delete_others': {
        group: 'Tickets',
        label: 'Delete others\' tickets',
        description: 'Remove tickets you don\'t own'
    },
    'tickets.manage_columns': {
        group: 'Tickets',
        label: 'Manage ticket workflow',
        description: 'Edit board columns, statuses, order'
    },
    // Stories / announcements
    'stories.post': {
        group: 'Stories',
        label: 'Post announcements',
        description: 'Publish org-wide stories and announcements'
    },
    'stories.edit_others': {
        group: 'Stories',
        label: 'Edit others\' stories',
        description: 'Modify stories authored by other people'
    },
    'stories.delete_others': {
        group: 'Stories',
        label: 'Delete others\' stories',
        description: 'Remove stories authored by other people'
    },
    'stories.pin': {
        group: 'Stories',
        label: 'Pin stories',
        description: 'Promote stories to the top of the feed'
    },
    // Calendar
    'calendar.create_org_events': {
        group: 'Calendar',
        label: 'Create org events',
        description: 'Create events visible to the whole org'
    },
    'calendar.edit_others': {
        group: 'Calendar',
        label: 'Edit others\' events',
        description: 'Modify events organized by other people'
    },
    // Chat
    'chat.create_channels': {
        group: 'Chat',
        label: 'Create channels',
        description: 'Add new chat channels'
    },
    'chat.archive_channels': {
        group: 'Chat',
        label: 'Archive channels',
        description: 'Archive chat channels'
    },
    'chat.delete_others': {
        group: 'Chat',
        label: 'Delete others\' messages',
        description: 'Remove chat messages from other people'
    },
    // Grants
    'grants.view_others': {
        group: 'Grants',
        label: 'View others\' grants',
        description: 'See cap-table detail for grants belonging to other people'
    }
};
const $c38b323b0e554a5d$export$e08c7aae438e15b4 = Object.keys($c38b323b0e554a5d$export$d6eefc103e184eaa);
const $c38b323b0e554a5d$export$40d95c19a7e19d13 = [
    ...new Set($c38b323b0e554a5d$export$e08c7aae438e15b4.map((k)=>$c38b323b0e554a5d$export$d6eefc103e184eaa[k].group))
];
const $c38b323b0e554a5d$export$1a21b5fac534dc68 = {
    owner: $c38b323b0e554a5d$export$e08c7aae438e15b4,
    admin: $c38b323b0e554a5d$export$e08c7aae438e15b4.filter((k)=>k.startsWith('admin.')),
    member: []
};
const $c38b323b0e554a5d$export$1f4c54125d840468 = [
    // Active category — members of these teams see the full intranet.
    {
        slug: 'members',
        name: 'Members',
        category: 'active',
        permissions: []
    },
    {
        slug: 'admin',
        name: 'Admin',
        category: 'active',
        permissions: $c38b323b0e554a5d$export$e08c7aae438e15b4.filter((k)=>k.startsWith('admin.'))
    },
    {
        slug: 'manager',
        name: 'Manager',
        category: 'active',
        permissions: [
            'tickets.assign',
            'tickets.close_others',
            'calendar.create_org_events',
            'stories.post',
            'docs.edit_others'
        ]
    },
    {
        slug: 'hr',
        name: 'HR',
        category: 'active',
        permissions: [
            'admin.hr',
            'admin.users'
        ]
    },
    {
        slug: 'finance',
        name: 'Finance',
        category: 'active',
        permissions: [
            'admin.billing',
            'admin.cap_table',
            'grants.view_others'
        ]
    },
    {
        slug: 'content',
        name: 'Content',
        category: 'active',
        permissions: [
            'docs.edit_others',
            'kb.edit_others',
            'stories.post',
            'stories.pin'
        ]
    },
    // External category — trimmed intranet surface.
    {
        slug: 'advisors',
        name: 'Advisors',
        category: 'external',
        permissions: []
    },
    {
        slug: 'investors',
        name: 'Investors',
        category: 'external',
        permissions: []
    },
    {
        slug: 'alumni',
        name: 'Alumni',
        category: 'external',
        permissions: []
    }
];
const $c38b323b0e554a5d$export$3528e60aa7f8a8ca = new Set($c38b323b0e554a5d$export$1f4c54125d840468.map((t)=>t.slug));
const $c38b323b0e554a5d$export$a513ea61a7bee91c = [
    'active',
    'external',
    'archived'
];
const $c38b323b0e554a5d$export$3dee873c174bc8d8 = new Set([
    '69b77a61e0e0de1aa47d01cb' // Symbols System — original pre-multitenancy home
]);
const $c38b323b0e554a5d$export$2931f501d90fd912 = Object.fromEntries($c38b323b0e554a5d$export$40d95c19a7e19d13.map((g)=>[
        g,
        $c38b323b0e554a5d$export$e08c7aae438e15b4.filter((k)=>$c38b323b0e554a5d$export$d6eefc103e184eaa[k].group === g)
    ]));
const $c38b323b0e554a5d$export$cdac03a8d3b5824e = (claims, key)=>!!claims && (claims.is_owner === true || (claims.permissions || []).includes(key));
const $c38b323b0e554a5d$export$ea4361933911274e = (claims)=>!!claims && (claims.teams || []).some((t)=>t.category === 'active');
const $c38b323b0e554a5d$export$f047224f8a005577 = (claims, slug)=>!!claims && (claims.teams || []).some((t)=>t.slug === slug);
const $c38b323b0e554a5d$export$e71175321a2b5dc8 = (claims)=>!!claims && claims.is_owner === true;
const $c38b323b0e554a5d$export$fc970ed23da99565 = (claims)=>!!claims && (claims.org_role === 'owner' || claims.org_role === 'admin');
const $c38b323b0e554a5d$export$52070e566ccb1e3e = (claims)=>$c38b323b0e554a5d$export$e71175321a2b5dc8(claims) || $c38b323b0e554a5d$export$fc970ed23da99565(claims) || $c38b323b0e554a5d$export$ea4361933911274e(claims);
const $c38b323b0e554a5d$export$74316c6523cc040e = (teams)=>{
    if (!teams) return 'none';
    if (teams.some((t)=>t.category === 'active')) return 'active';
    if (teams.some((t)=>t.category === 'external')) return 'external';
    return 'none';
};
const $c38b323b0e554a5d$export$5e71ab9ac92f9020 = function(s) {
    const el = this;
    const claims = s?.root?.jwtClaims;
    // Claims still loading — don't bounce.
    if (!claims || !Array.isArray(claims.teams)) return false;
    if ($c38b323b0e554a5d$export$52070e566ccb1e3e(claims)) return false;
    const root = el.call('findRouteRoot', el);
    if (root) el.router('/', root, {}, {
        pushState: true
    });
    return true;
};
const $c38b323b0e554a5d$export$72bc84371f3e87c6 = (key)=>$c38b323b0e554a5d$export$d6eefc103e184eaa[key]?.label || key;
const $c38b323b0e554a5d$export$6e2715c6663b7445 = (key)=>$c38b323b0e554a5d$export$d6eefc103e184eaa[key]?.description || '';
const $c38b323b0e554a5d$export$912c8ba879008689 = (key)=>$c38b323b0e554a5d$export$d6eefc103e184eaa[key]?.group || 'Other';

});


parcelRegister("6bofb", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE", () => $4806937edf8f97a8$export$6f0555de4f60e84e);
$parcel$export(module.exports, "linkResources", () => $4806937edf8f97a8$export$1a1fbe0cef65583f);
$parcel$export(module.exports, "unlinkResources", () => $4806937edf8f97a8$export$829a9fa68d6e4cdf);
$parcel$export(module.exports, "getLinkedResources", () => $4806937edf8f97a8$export$7f0c8230a9f61c14);
$parcel$export(module.exports, "backfillMeetRoomLinks", () => $4806937edf8f97a8$export$ae288418cc560b02);
// Cross-resource link helpers. Reads/writes the `resource_links` table so
// chat channels, calendar events, and meet rooms can reference each other.
//
// All functions support both direct calls and `el.call('fn', ...)` — root is
// inferred from `this.state.root` when the user passes a channel/event/room.

var $bfqVY = parcelRequire("bfqVY");
const $4806937edf8f97a8$export$6f0555de4f60e84e = Object.freeze({
    CHAT_CHANNEL: 'chat_channel',
    MEET_ROOM: 'meet_room',
    CALENDAR_EVENT: 'calendar_event'
});
const $4806937edf8f97a8$var$_VALID_TYPES = new Set(Object.values($4806937edf8f97a8$export$6f0555de4f60e84e));
// (type, id) pairs are sorted lexicographically so (A, B) and (B, A) collapse
// to the same row server-side (enforced by the CHECK constraint).
const $4806937edf8f97a8$var$_order = (aType, aId, bType, bId)=>{
    const a = `${aType}\x00${aId}`;
    const b = `${bType}\x00${bId}`;
    return a < b ? [
        aType,
        aId,
        bType,
        bId
    ] : [
        bType,
        bId,
        aType,
        aId
    ];
};
const $4806937edf8f97a8$var$_asId = (x)=>x == null ? null : String(x);
// Per-(links array identity) cache for getLinkedResources results. The cache
// is invalidated automatically whenever `root.resourceLinks` is replaced
// (link/unlink optimistic updates always produce a new array reference).
const $4806937edf8f97a8$var$_linksCache = new WeakMap();
async function $4806937edf8f97a8$export$1a1fbe0cef65583f(aType, aId, bType, bId) {
    const root = this?.state?.root;
    const me = root?.currentUserEmail;
    if (!aType || aId == null || !bType || bId == null) return null;
    if (aType === bType && $4806937edf8f97a8$var$_asId(aId) === $4806937edf8f97a8$var$_asId(bId)) return null;
    const [t1, i1, t2, i2] = $4806937edf8f97a8$var$_order(aType, $4806937edf8f97a8$var$_asId(aId), bType, $4806937edf8f97a8$var$_asId(bId));
    try {
        // migrated 2026-04-27 to SDK route workspaceProject.documents.resourceLinks create
        // Wrapper handles upsert-on-(a_type,a_id,b_type,b_id) — same unique
        // constraint enforces dedup server-side.
        const result = await (0, $bfqVY.getSDK)().execute('workspaceProject.documents.resourceLinks', 'create', {
            payload: {
                a_type: t1,
                a_id: i1,
                b_type: t2,
                b_id: i2,
                created_by: me
            }
        });
        const data = Array.isArray(result?.data) ? result.data[0] : result?.data ?? result ?? null;
        if (!data) return null;
        // Optimistic state merge.
        if (root) {
            const cur = root.resourceLinks || [];
            const exists = cur.some((r)=>r.id === data.id);
            if (!exists) root.update({
                resourceLinks: [
                    ...cur,
                    data
                ]
            });
        }
        return data;
    } catch (err) {
        console.error('[linkResources]', err);
        return null;
    }
}
async function $4806937edf8f97a8$export$829a9fa68d6e4cdf(aType, aId, bType, bId) {
    const root = this?.state?.root;
    const [t1, i1, t2, i2] = $4806937edf8f97a8$var$_order(aType, $4806937edf8f97a8$var$_asId(aId), bType, $4806937edf8f97a8$var$_asId(bId));
    try {
        // migrated 2026-04-27 to SDK route workspaceProject.documents.resourceLinks removeByPair
        // The composite-key delete path — the row id isn't known at the call
        // site, so we pass the (a_type, a_id, b_type, b_id) tuple as a filter
        // and let the server resolve the row.
        await (0, $bfqVY.getSDK)().execute('workspaceProject.documents.resourceLinks', 'removeByPair', {
            filter: {
                a_type: t1,
                a_id: i1,
                b_type: t2,
                b_id: i2
            }
        });
        if (root) {
            const cur = root.resourceLinks || [];
            root.update({
                resourceLinks: cur.filter((r)=>!(r.a_type === t1 && r.a_id === i1 && r.b_type === t2 && r.b_id === i2))
            });
        }
        return true;
    } catch (err) {
        console.error('[unlinkResources]', err?.message || err);
        return false;
    }
}
function $4806937edf8f97a8$export$7f0c8230a9f61c14(rootOrType, maybeId, maybeType) {
    let root, type, id;
    if (typeof rootOrType === 'string') {
        root = this?.state?.root;
        type = rootOrType;
        id = maybeId;
    } else {
        root = rootOrType;
        type = maybeId;
        id = maybeType;
    }
    const links = root && root.resourceLinks || null;
    if (!links) return [];
    let byKey = $4806937edf8f97a8$var$_linksCache.get(links);
    if (!byKey) {
        byKey = new Map();
        $4806937edf8f97a8$var$_linksCache.set(links, byKey);
    }
    const sid = $4806937edf8f97a8$var$_asId(id);
    const key = `${type}\x00${sid}`;
    const cached = byKey.get(key);
    if (cached) return cached;
    const out = [];
    for (const r of links){
        if (r.a_type === type && $4806937edf8f97a8$var$_asId(r.a_id) === sid) out.push({
            type: r.b_type,
            id: r.b_id,
            linkId: r.id
        });
        else if (r.b_type === type && $4806937edf8f97a8$var$_asId(r.b_id) === sid) out.push({
            type: r.a_type,
            id: r.a_id,
            linkId: r.id
        });
    }
    byKey.set(key, out);
    return out;
}
async function $4806937edf8f97a8$export$ae288418cc560b02() {
    const root = this?.state?.root;
    const ops = [];
    for (const r of root?.rooms || []){
        if (r.calendarEventId != null) ops.push($4806937edf8f97a8$export$1a1fbe0cef65583f.call(this, 'meet_room', r.id, 'calendar_event', r.calendarEventId));
        if (r.chatChannelId != null) ops.push($4806937edf8f97a8$export$1a1fbe0cef65583f.call(this, 'meet_room', r.id, 'chat_channel', r.chatChannelId));
    }
    await Promise.all(ops);
}

});

parcelRegister("bnIri", function(module, exports) {

$parcel$export(module.exports, "workspaceTier", () => $8494506be09824fa$export$26b243a5e707887e);
$parcel$export(module.exports, "hasTier", () => $8494506be09824fa$export$3d400e65c5f3e7);
$parcel$export(module.exports, "isPro", () => $8494506be09824fa$export$9fe74708de43930a);
$parcel$export(module.exports, "isScale", () => $8494506be09824fa$export$eb76689a55efb3e5);
$parcel$export(module.exports, "isEnterprise", () => $8494506be09824fa$export$af1c71b531c949f4);
$parcel$export(module.exports, "tierLabel", () => $8494506be09824fa$export$4f49b3815c00b719);
// Tier helpers. Reads the active workspace's tier from JWT claims
// (populated by the bridge from the server's workspace billing endpoint).
//
// The intranet itself is NOT tier-gated — it's an org-level feature.
// Anyone in a team org gets every collab surface. Monetization happens
// via server-side credit metering (PRICING.md), not access gates.
//
// These helpers remain for a narrow set of admin-power surfaces
// (`admin-permissions`, `admin-logs`) that stay Scale-only because they
// exist for multi-org tenants with dedicated admin staff — not because
// we want to upsell core collab.
//
// Tier order: free < pro < scale < enterprise. Each tier "includes" all
// tiers below it.
const $8494506be09824fa$var$TIER_ORDER = {
    free: 0,
    pro: 1,
    scale: 2,
    enterprise: 3
};
const $8494506be09824fa$var$_normalize = (raw)=>{
    if (!raw) return 'free';
    const s = typeof raw === 'string' ? raw : raw.tier || raw.plan || raw.name || '';
    return String(s).toLowerCase().trim() || 'free';
};
const $8494506be09824fa$export$26b243a5e707887e = (root)=>$8494506be09824fa$var$_normalize(root?.jwtClaims?.workspace_tier);
const $8494506be09824fa$export$3d400e65c5f3e7 = (root, minTier)=>{
    const cur = $8494506be09824fa$var$TIER_ORDER[$8494506be09824fa$export$26b243a5e707887e(root)] ?? 0;
    const min = $8494506be09824fa$var$TIER_ORDER[$8494506be09824fa$var$_normalize(minTier)] ?? 0;
    return cur >= min;
};
const $8494506be09824fa$export$9fe74708de43930a = (root)=>$8494506be09824fa$export$3d400e65c5f3e7(root, 'pro');
const $8494506be09824fa$export$eb76689a55efb3e5 = (root)=>$8494506be09824fa$export$3d400e65c5f3e7(root, 'scale');
const $8494506be09824fa$export$af1c71b531c949f4 = (root)=>$8494506be09824fa$export$3d400e65c5f3e7(root, 'enterprise');
const $8494506be09824fa$export$4f49b3815c00b719 = (tier)=>{
    const t = $8494506be09824fa$var$_normalize(tier);
    return t.charAt(0).toUpperCase() + t.slice(1);
};

});

parcelRegister("erP2O", function(module, exports) {

$parcel$export(module.exports, "loadAllTeams", () => $a84b2eaa90fde7b6$export$3cdd454e9fc60cd4);
$parcel$export(module.exports, "loadTeamMembers", () => $a84b2eaa90fde7b6$export$4d61445feb376f64);
$parcel$export(module.exports, "personTeams", () => $a84b2eaa90fde7b6$export$14c8ce83a4142100);
$parcel$export(module.exports, "primaryTeamName", () => $a84b2eaa90fde7b6$export$7a146fa902c3b991);
$parcel$export(module.exports, "addMemberToTeam", () => $a84b2eaa90fde7b6$export$1799d229e79f350b);
$parcel$export(module.exports, "removeMemberFromTeam", () => $a84b2eaa90fde7b6$export$8c1358525ec9cee6);
$parcel$export(module.exports, "createTeam", () => $a84b2eaa90fde7b6$export$dadd67f86cf9b534);
$parcel$export(module.exports, "updateTeamPermissions", () => $a84b2eaa90fde7b6$export$d6d54ebf00abd93b);
$parcel$export(module.exports, "inviteToTeam", () => $a84b2eaa90fde7b6$export$69073f265828e8b9);
$parcel$export(module.exports, "teamsInOrg", () => $a84b2eaa90fde7b6$export$6d550913e15f5dd8);
$parcel$export(module.exports, "isActiveOrgMember", () => $a84b2eaa90fde7b6$export$19e5c3d8b2f178);
// Teams directory — sourced from Mongo via the Symbols SDK, not from
// Supabase. The `user_profiles.department` / `user_profiles.group_name`
// text columns on governance are legacy; team membership is now
// canonical in Mongo's `Team` + `TeamMember`.
//
// Load once per session into root state:
//   root.teams         Array of { id, name, slug, parentTeam, orgId }
//   root.teamsByEmail  { [lowercase email]: Array<{ id, name, role }> }
//
// Consumers (peopleGroups, PersonCard, MemberProfile, _person mapper)
// read from root.teamsByEmail instead of person.department / .group.

var $bfqVY = parcelRequire("bfqVY");
// SDK list-response unwrap — the server returns either `{items}`,
// `{data:{items}}`, `{data:[...]}`, or a bare array depending on the
// endpoint + version. Normalize to a plain array.
const $a84b2eaa90fde7b6$var$_unwrapList = (r)=>r?.items || r?.data?.items || r?.data || (Array.isArray(r) ? r : []);
// Use the shared SDK instance (pointed at the same channel as the rest of
// the workspace — `localhost:8080` in localNext, `next.api.symbols.app`
// in next, etc.). The previous hack here built its own SDK and copied
// the federation bridge token into `symbols_access_token`, which broke
// `/core/*` calls in localNext mode (bridge token is signed by prod, the
// local server uses a different secret). The shared SDK already carries
// the locally-minted token via TokenManager — no per-module override.
const $a84b2eaa90fde7b6$var$_getSdk = ()=>{
    if (typeof window === 'undefined') return null;
    return (0, $bfqVY.getSDK)();
};
const $a84b2eaa90fde7b6$export$3cdd454e9fc60cd4 = async (root)=>{
    const sdk = await $a84b2eaa90fde7b6$var$_getSdk();
    if (!sdk) return {
        teams: [],
        teamsByEmail: {},
        orgMembersByOrgId: {}
    };
    // Fetch members for EVERY org the user belongs to. Filtering by
    // type (`'team'` only) used to skip the Symbols System home org on
    // some accounts — when the active workspace lives under such an
    // org, /people then renders empty.
    const orgs = root?.jwtClaims?.orgs || [];
    const teams = [];
    const teamsByEmail = {};
    const orgMembersByOrgId = {};
    // Serialize per-org to stay under the 180 req/min free-tier cap.
    // Parallel across orgs bursts 5×(N team members) simultaneous calls,
    // which trips HTTP 429 and silently skips orgs. Sequential adds
    // a small latency hit on cold load but keeps loadAllTeams robust.
    for (const org of orgs){
        const orgId = org.id;
        if (!orgId) continue;
        // Org roster — one call per org. Drives the /people filter below.
        // Store as a plain lookup object ({email: true}) not a Set because
        // smbls's root.update() path JSON-clones state and Sets don't
        // survive — the entries become empty {}. Plain objects round-trip.
        try {
            const oRes = await sdk.listOrgMembers(orgId);
            const oMembers = $a84b2eaa90fde7b6$var$_unwrapList(oRes);
            const map = {};
            for (const m of oMembers){
                const email = (m?.user?.email || m?.email || '').toLowerCase();
                if (email) map[email] = true;
            }
            orgMembersByOrgId[orgId] = map;
        } catch (err) {
            console.warn('[teams] listOrgMembers failed for', orgId, err);
        // Leave key unset on failure — filterToActiveOrg treats a
        // missing entry as "show full cross-tenant list" rather than
        // "empty org", so the UI degrades gracefully.
        }
        // Teams inside the org. On failure (rate limit, network, etc.)
        // skip this org and keep iterating — do NOT exit loadAllTeams,
        // otherwise the caller destructures undefined.
        let list = [];
        try {
            const res = await sdk.listTeams(orgId);
            list = $a84b2eaa90fde7b6$var$_unwrapList(res);
        } catch (err) {
            console.warn('[teams] listTeams failed for', orgId, err);
            continue;
        }
        for (const t of list){
            const team = {
                id: t._id || t.id,
                name: t.name,
                slug: t.slug,
                parentTeam: t.parentTeam || null,
                category: t.category || 'active',
                isSystem: !!t.isSystem,
                permissions: t.permissions || [],
                orgId: orgId,
                orgName: org.name
            };
            teams.push(team);
        // Member fetching is intentionally deferred — each listTeamMembers
        // is a separate API call and with many teams this bursts past the
        // free-tier cap (180 req/min) and causes 429s. loadTeamMembers()
        // is called lazily when the user opens a team detail view.
        }
    }
    return {
        teams: teams,
        teamsByEmail: teamsByEmail,
        orgMembersByOrgId: orgMembersByOrgId
    };
};
const $a84b2eaa90fde7b6$export$4d61445feb376f64 = async (root, team)=>{
    if (!team?.id) return;
    // Skip if already loaded this session.
    if (root?.teamMembersLoaded?.[team.id]) return;
    const sdk = await $a84b2eaa90fde7b6$var$_getSdk();
    if (!sdk) return;
    try {
        const mRes = await sdk.listTeamMembers(team.orgId, team.id);
        const members = $a84b2eaa90fde7b6$var$_unwrapList(mRes);
        // Merge new entries into the existing teamsByEmail map without
        // touching entries from other teams (different teamId).
        const next = {
            ...root?.teamsByEmail || {}
        };
        for (const m of members){
            const email = (m?.user?.email || m?.email || '').toLowerCase();
            if (!email) continue;
            const entry = {
                id: team.id,
                name: team.name,
                slug: team.slug,
                category: team.category,
                orgId: team.orgId,
                role: m?.role || 'member'
            };
            // Avoid duplicate entries for this team on re-open.
            const existing = (next[email] || []).filter((e)=>e.id !== team.id);
            next[email] = [
                ...existing,
                entry
            ];
        }
        root.update({
            teamsByEmail: next,
            teamMembersLoaded: {
                ...root?.teamMembersLoaded || {},
                [team.id]: true
            }
        });
    } catch (err) {
        console.warn('[teams] loadTeamMembers failed for', team.id, err);
    }
};
const $a84b2eaa90fde7b6$export$14c8ce83a4142100 = (email, root)=>{
    const key = String(email || '').toLowerCase();
    return root?.teamsByEmail?.[key] || [];
};
const $a84b2eaa90fde7b6$export$7a146fa902c3b991 = (email, root)=>{
    const teams = $a84b2eaa90fde7b6$export$14c8ce83a4142100(email, root);
    return teams.length ? teams[0].name : null;
};
// ── Write helpers ─────────────────────────────────────────────────
// Thin wrappers around SDK methods. Optimistically update
// root.teamsByEmail on success so the UI reflects the change before
// the next `loadAllTeams()` refresh.
const $a84b2eaa90fde7b6$var$_indexedTeamsByEmail = (teamsByEmail, email, team, role = 'member')=>{
    const key = String(email || '').toLowerCase();
    const entry = {
        id: team.id,
        name: team.name,
        slug: team.slug,
        orgId: team.orgId,
        role: role
    };
    return {
        ...teamsByEmail,
        [key]: [
            ...teamsByEmail?.[key] || [],
            entry
        ]
    };
};
const $a84b2eaa90fde7b6$var$_removedFromTeamsByEmail = (teamsByEmail, email, teamId)=>{
    const key = String(email || '').toLowerCase();
    const next = {
        ...teamsByEmail
    };
    next[key] = (next[key] || []).filter((t)=>t.id !== teamId);
    if (!next[key].length) delete next[key];
    return next;
};
const $a84b2eaa90fde7b6$export$1799d229e79f350b = async (root, { orgId: orgId, teamId: teamId, userId: userId, email: email, role: role = 'member' })=>{
    const sdk = await $a84b2eaa90fde7b6$var$_getSdk();
    if (!sdk) throw new Error('SDK not available');
    await sdk.addTeamMember(orgId, teamId, {
        userId: userId,
        role: role
    });
    const team = (root?.teams || []).find((t)=>t.id === teamId) || {
        id: teamId,
        name: '',
        slug: '',
        orgId: orgId
    };
    root.update({
        teamsByEmail: $a84b2eaa90fde7b6$var$_indexedTeamsByEmail(root.teamsByEmail || {}, email, team, role)
    });
};
const $a84b2eaa90fde7b6$export$8c1358525ec9cee6 = async (root, { orgId: orgId, teamId: teamId, userId: userId, email: email })=>{
    const sdk = await $a84b2eaa90fde7b6$var$_getSdk();
    if (!sdk) throw new Error('SDK not available');
    const mRes = await sdk.listTeamMembers(orgId, teamId);
    const members = $a84b2eaa90fde7b6$var$_unwrapList(mRes);
    const row = members.find((m)=>m?.user?.id === userId || m?.user?._id === userId || m?.userId === userId);
    const memberId = row?.id || row?._id;
    if (memberId) await sdk.removeTeamMember(orgId, teamId, memberId);
    root.update({
        teamsByEmail: $a84b2eaa90fde7b6$var$_removedFromTeamsByEmail(root.teamsByEmail || {}, email, teamId)
    });
};
const $a84b2eaa90fde7b6$export$dadd67f86cf9b534 = async (root, { orgId: orgId, name: name })=>{
    const sdk = await $a84b2eaa90fde7b6$var$_getSdk();
    if (!sdk) throw new Error('SDK not available');
    const slug = String(name || '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    const res = await sdk.createTeam(orgId, {
        name: name,
        slug: slug
    });
    const created = res?.data || res;
    const team = {
        id: created._id || created.id,
        name: created.name,
        slug: created.slug,
        parentTeam: created.parentTeam || null,
        category: created.category || 'active',
        isSystem: !!created.isSystem,
        permissions: created.permissions || [],
        orgId: orgId,
        orgName: (root?.jwtClaims?.orgs || []).find((o)=>o.id === orgId)?.name || ''
    };
    root.update({
        teams: [
            ...root?.teams || [],
            team
        ]
    });
    return team;
};
const $a84b2eaa90fde7b6$export$d6d54ebf00abd93b = async (root, { orgId: orgId, teamId: teamId, permissions: permissions })=>{
    const sdk = await $a84b2eaa90fde7b6$var$_getSdk();
    if (!sdk) throw new Error('SDK not available');
    const res = await sdk.updateTeam(orgId, teamId, {
        permissions: permissions
    });
    const updated = res?.data || res;
    const nextTeams = (root?.teams || []).map((t)=>t.id === teamId ? {
            ...t,
            permissions: updated?.permissions || permissions
        } : t);
    root.update({
        teams: nextTeams
    });
    return updated;
};
const $a84b2eaa90fde7b6$export$69073f265828e8b9 = async (root, { orgId: orgId, teamId: teamId, email: email })=>{
    const sdk = await $a84b2eaa90fde7b6$var$_getSdk();
    if (!sdk) throw new Error('SDK not available');
    if (!email) throw new Error('email required');
    return sdk.inviteToTeam(orgId, teamId, {
        email: email
    });
};
const $a84b2eaa90fde7b6$export$6d550913e15f5dd8 = (orgId, root)=>(root?.teams || []).filter((t)=>t.orgId === orgId);
const $a84b2eaa90fde7b6$export$19e5c3d8b2f178 = (email, root)=>{
    const orgId = root?.jwtClaims?.workspace_org_id;
    if (!orgId) return false;
    const set = root?.orgMembersByOrgId?.[orgId];
    if (!set) return false;
    return !!set[String(email || '').toLowerCase()];
};

});

parcelRegister("lcqII", function(module, exports) {

var $kZOF8 = parcelRequire("kZOF8");

var $2290d = parcelRequire("2290d");
$parcel$exportWildcard(module.exports, $kZOF8);
$parcel$exportWildcard(module.exports, $2290d);

});
parcelRegister("kZOF8", function(module, exports) {

$parcel$export(module.exports, "getMonthName", () => $03f1d1c4bf9b1e16$export$e7af3ee2c84591cc);
$parcel$export(module.exports, "getMonthLabel", () => $03f1d1c4bf9b1e16$export$5492c4ce9d26d774);
$parcel$export(module.exports, "getDayNames", () => $03f1d1c4bf9b1e16$export$d03409b923543a08);
$parcel$export(module.exports, "getMonthDays", () => $03f1d1c4bf9b1e16$export$214c174a056fc56f);
$parcel$export(module.exports, "isToday", () => $03f1d1c4bf9b1e16$export$629b0a497aa65267);
$parcel$export(module.exports, "formatDate", () => $03f1d1c4bf9b1e16$export$3ae94a2503e890a1);
$parcel$export(module.exports, "assignLanes", () => $03f1d1c4bf9b1e16$export$5e82f59d50595df4);
$parcel$export(module.exports, "getEventsForDay", () => $03f1d1c4bf9b1e16$export$e2572468fb9b0fd1);
$parcel$export(module.exports, "HOUR_PX", () => $03f1d1c4bf9b1e16$export$d0e73eb52e587409);
$parcel$export(module.exports, "SLOT_MIN", () => $03f1d1c4bf9b1e16$export$545d628082486514);
$parcel$export(module.exports, "formatTzTime", () => $03f1d1c4bf9b1e16$export$379b0c9dd9309abd);
$parcel$export(module.exports, "formatTzDate", () => $03f1d1c4bf9b1e16$export$b64d9bf67c4faac9);
$parcel$export(module.exports, "hhmmToMin", () => $03f1d1c4bf9b1e16$export$361693031ac6effa);
$parcel$export(module.exports, "minToHHMM", () => $03f1d1c4bf9b1e16$export$17176dec6259f9c6);
$parcel$export(module.exports, "eventUtcMs", () => $03f1d1c4bf9b1e16$export$91121fc77411a436);
$parcel$export(module.exports, "getUnavailableRanges", () => $03f1d1c4bf9b1e16$export$c3f95de39763f5b9);
$parcel$export(module.exports, "weekContainsToday", () => $03f1d1c4bf9b1e16$export$e4ff15aebfb30c58);
$parcel$export(module.exports, "getWeekDays", () => $03f1d1c4bf9b1e16$export$69ac73875782844e);
$parcel$export(module.exports, "getHours", () => $03f1d1c4bf9b1e16$export$257b40f71c07d58f);
$parcel$export(module.exports, "shouldStampPrivate", () => $03f1d1c4bf9b1e16$export$57c60d6c6403ce2c);
$parcel$export(module.exports, "eventIsPrivateFor", () => $03f1d1c4bf9b1e16$export$5606210727cdab7d);
$parcel$export(module.exports, "inferRecurrence", () => $03f1d1c4bf9b1e16$export$5ee5e2a16be91d2d);
$parcel$export(module.exports, "freshBooking", () => $03f1d1c4bf9b1e16$export$37f04dedae96c36c);
$parcel$export(module.exports, "eventToTop", () => $03f1d1c4bf9b1e16$export$a791c2189f2df0e5);
$parcel$export(module.exports, "eventToHeight", () => $03f1d1c4bf9b1e16$export$75a7111b83ab7f54);
$parcel$export(module.exports, "pxToTime", () => $03f1d1c4bf9b1e16$export$1064a26da00eecfc);
$parcel$export(module.exports, "addMinutes", () => $03f1d1c4bf9b1e16$export$2287e3d29250119e);
$parcel$export(module.exports, "getEventTheme", () => $03f1d1c4bf9b1e16$export$6f370a2ca055bfeb);
$parcel$export(module.exports, "prevMonth", () => $03f1d1c4bf9b1e16$export$ef308314adc3ab58);
$parcel$export(module.exports, "nextMonth", () => $03f1d1c4bf9b1e16$export$387da49966d7e375);
$parcel$export(module.exports, "fetchEventDetails", () => $03f1d1c4bf9b1e16$export$3aed032d051fb152);
$parcel$export(module.exports, "hasRole", () => (parcelRequire("bglB6")).hasRole);
$parcel$export(module.exports, "userIsAdmin", () => (parcelRequire("bglB6")).userIsAdmin);
$parcel$export(module.exports, "userIsSuperadmin", () => (parcelRequire("bglB6")).userIsSuperadmin);
$parcel$export(module.exports, "isExternalEmail", () => (parcelRequire("bglB6")).isExternalEmail);
$parcel$export(module.exports, "currentUser", () => (parcelRequire("bglB6")).currentUser);
$parcel$export(module.exports, "currentUserIsAdmin", () => (parcelRequire("bglB6")).currentUserIsAdmin);
$parcel$export(module.exports, "currentUserIsSuperadmin", () => (parcelRequire("bglB6")).currentUserIsSuperadmin);

var $bglB6 = parcelRequire("bglB6");

var $bfqVY = parcelRequire("bfqVY");
const $03f1d1c4bf9b1e16$var$MONTH_NAMES = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];
const $03f1d1c4bf9b1e16$var$DAY_NAMES = [
    'Sun',
    'Mon',
    'Tue',
    'Wed',
    'Thu',
    'Fri',
    'Sat'
];
function $03f1d1c4bf9b1e16$export$e7af3ee2c84591cc(year, month) {
    return $03f1d1c4bf9b1e16$var$MONTH_NAMES[month];
}
function $03f1d1c4bf9b1e16$export$5492c4ce9d26d774(year, month) {
    return `${$03f1d1c4bf9b1e16$var$MONTH_NAMES[month]} ${year}`;
}
function $03f1d1c4bf9b1e16$export$d03409b923543a08() {
    return $03f1d1c4bf9b1e16$var$DAY_NAMES;
}
function $03f1d1c4bf9b1e16$export$214c174a056fc56f(year, month) {
    const firstDay = new Date(year, month, 1).getDay();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const daysInPrevMonth = new Date(year, month, 0).getDate();
    const days = [];
    // Normalize previous month (handles January -> December of previous year)
    const prevMonthDate = new Date(year, month - 1, 1);
    const prevYear = prevMonthDate.getFullYear();
    const prevMonth = prevMonthDate.getMonth();
    // Pad start with previous month days
    for(let i = firstDay - 1; i >= 0; i--)days.push({
        day: daysInPrevMonth - i,
        month: prevMonth,
        year: prevYear,
        isOtherMonth: true
    });
    // Current month
    for(let d = 1; d <= daysInMonth; d++)days.push({
        day: d,
        month: month,
        year: year,
        isOtherMonth: false
    });
    // Normalize next month (handles December -> January of next year)
    const nextMonthDate = new Date(year, month + 1, 1);
    const nextYear = nextMonthDate.getFullYear();
    const nextMonth = nextMonthDate.getMonth();
    // Pad end to complete 6 rows (42 cells)
    const remaining = 42 - days.length;
    for(let d = 1; d <= remaining; d++)days.push({
        day: d,
        month: nextMonth,
        year: nextYear,
        isOtherMonth: true
    });
    return days;
}
function $03f1d1c4bf9b1e16$export$629b0a497aa65267(year, month, day) {
    const t = new Date();
    return t.getFullYear() === year && t.getMonth() === month && t.getDate() === day;
}
function $03f1d1c4bf9b1e16$export$3ae94a2503e890a1(year, month, day) {
    const m = String(month + 1).padStart(2, '0');
    const d = String(day).padStart(2, '0');
    return `${year}-${m}-${d}`;
}
const $03f1d1c4bf9b1e16$var$_DAY_MS = 86400000;
// Greedy lane packing — assigns each event a `_lane` (0-indexed column)
// and `_lanes` (total columns its overlap cluster needs). Used by the week
// view to render side-by-side overlapping events without them stacking on
// top of each other. O(n²) but n is small (events on one day).
const $03f1d1c4bf9b1e16$var$_toMins = (t)=>{
    const [h, m] = (t || '00:00').split(':').map(Number);
    return h * 60 + m;
};
function $03f1d1c4bf9b1e16$export$5e82f59d50595df4(evs) {
    if (!evs.length) return evs;
    // Shallow-clone every event so we don't mutate the canonical events array.
    const sorted = evs.map((e)=>({
            ...e
        })).sort((a, b)=>$03f1d1c4bf9b1e16$var$_toMins(a.startTime) - $03f1d1c4bf9b1e16$var$_toMins(b.startTime));
    // Group into overlap clusters: events that transitively overlap end up in
    // the same cluster and share the same lane count.
    const clusters = [];
    let cur = null;
    let curEnd = -1;
    for (const ev of sorted){
        const s = $03f1d1c4bf9b1e16$var$_toMins(ev.startTime);
        const e = $03f1d1c4bf9b1e16$var$_toMins(ev.endTime);
        if (cur && s < curEnd) {
            cur.push(ev);
            if (e > curEnd) curEnd = e;
        } else {
            cur = [
                ev
            ];
            clusters.push(cur);
            curEnd = e;
        }
    }
    for (const cluster of clusters){
        // Assign lanes within the cluster — pack each event into the lowest lane
        // whose last event has already ended.
        const laneEnds = [];
        for (const ev of cluster){
            const s = $03f1d1c4bf9b1e16$var$_toMins(ev.startTime);
            const e = $03f1d1c4bf9b1e16$var$_toMins(ev.endTime);
            let lane = laneEnds.findIndex((end)=>end <= s);
            if (lane === -1) {
                lane = laneEnds.length;
                laneEnds.push(e);
            } else laneEnds[lane] = e;
            ev._lane = lane;
        }
        const total = laneEnds.length;
        for (const ev of cluster)ev._lanes = total;
    }
    return sorted;
}
// Cross-midnight tail: an event with `endTime <= startTime` actually runs
// past midnight into the next day. The start day shows the [startTime, 24:00]
// portion (clipped via eventToHeight); this helper produces a synthetic
// [00:00, endTime] piece for the next day.
const $03f1d1c4bf9b1e16$var$_isCrossMidnight = (ev)=>{
    if (!ev?.startTime || !ev?.endTime) return false;
    const [sh, sm] = ev.startTime.split(':').map(Number);
    const [eh, em] = ev.endTime.split(':').map(Number);
    return eh * 60 + em <= sh * 60 + sm;
};
function $03f1d1c4bf9b1e16$export$e2572468fb9b0fd1(events, year, month, day) {
    const dateStr = $03f1d1c4bf9b1e16$export$3ae94a2503e890a1(year, month, day);
    const target = new Date(year, month, day);
    const targetDow = target.getDay();
    const prevDate = $03f1d1c4bf9b1e16$export$3ae94a2503e890a1(year, month, day - 1) // JS Date normalizes day=0/-1
    ;
    const out = [];
    for (const ev of events || []){
        // Cross-midnight tail from yesterday → render as a [00:00, endTime] piece.
        if (ev.date === prevDate && $03f1d1c4bf9b1e16$var$_isCrossMidnight(ev)) {
            out.push({
                ...ev,
                startTime: '00:00',
                _isCrossTail: true
            });
            continue;
        }
        if (ev.date === dateStr) {
            out.push(ev);
            continue;
        }
        if (!ev.recurring || ev.recurring === 'none') continue;
        const [oy, om, od] = ev.date.split('-').map(Number);
        if (!oy) continue;
        const orig = new Date(oy, om - 1, od);
        if (target < orig) continue;
        let match = false;
        switch(ev.recurring){
            case 'daily':
                match = true;
                break;
            case 'weekdays':
                match = targetDow >= 1 && targetDow <= 5;
                break;
            case 'weekends':
                match = targetDow === 0 || targetDow === 6;
                break;
            case 'weekly':
                {
                    const days = ev.recurringDays;
                    match = Array.isArray(days) && days.length ? days.includes(targetDow) : orig.getDay() === targetDow;
                    break;
                }
            case 'biweekly':
                {
                    if (orig.getDay() !== targetDow) break;
                    const diffDays = Math.round((target - orig) / $03f1d1c4bf9b1e16$var$_DAY_MS);
                    match = diffDays % 14 === 0;
                    break;
                }
            case 'monthly':
                match = orig.getDate() === target.getDate();
                break;
            case 'yearly':
                match = orig.getMonth() === target.getMonth() && orig.getDate() === target.getDate();
                break;
        }
        if (match) out.push(ev);
    }
    return out;
}
const $03f1d1c4bf9b1e16$export$d0e73eb52e587409 = 56;
const $03f1d1c4bf9b1e16$export$545d628082486514 = 15;
// Intl.DateTimeFormat is expensive to construct (one of the slowest things
// in JS). Cache one per timezone so the hot loops in availability/header
// renders don't allocate hundreds per minute tick.
const $03f1d1c4bf9b1e16$var$_timeFmt = new Map();
const $03f1d1c4bf9b1e16$var$_dateFmt = new Map();
const $03f1d1c4bf9b1e16$export$379b0c9dd9309abd = (ms, tz)=>{
    let f = $03f1d1c4bf9b1e16$var$_timeFmt.get(tz);
    if (!f) {
        f = new Intl.DateTimeFormat('en-US', {
            timeZone: tz,
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        });
        $03f1d1c4bf9b1e16$var$_timeFmt.set(tz, f);
    }
    return f.format(ms);
};
const $03f1d1c4bf9b1e16$export$b64d9bf67c4faac9 = (ms, tz)=>{
    let f = $03f1d1c4bf9b1e16$var$_dateFmt.get(tz);
    if (!f) {
        f = new Intl.DateTimeFormat('en-CA', {
            timeZone: tz,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        });
        $03f1d1c4bf9b1e16$var$_dateFmt.set(tz, f);
    }
    // en-CA returns YYYY-MM-DD already
    return f.format(ms).replace(/\u2010|\u2013/g, '-');
};
const $03f1d1c4bf9b1e16$export$361693031ac6effa = (s)=>{
    if (!s) return 0;
    const [h, m] = s.split(':').map(Number);
    return h * 60 + m;
};
const $03f1d1c4bf9b1e16$export$17176dec6259f9c6 = (n)=>{
    const total = Math.max(0, Math.min(1440, Math.round(n)));
    const h = Math.floor(total / 60);
    const m = total % 60;
    return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
};
const $03f1d1c4bf9b1e16$export$91121fc77411a436 = (dateStr, timeStr)=>{
    if (!dateStr || !timeStr) return 0;
    const [y, m, d] = dateStr.split('-').map(Number);
    const [h, mm] = timeStr.split(':').map(Number);
    return new Date(y, m - 1, d, h, mm).getTime();
};
// Backwards-compat aliases (private, so existing internal usages don't need a sweep)
const $03f1d1c4bf9b1e16$var$_formatTzTime = $03f1d1c4bf9b1e16$export$379b0c9dd9309abd;
const $03f1d1c4bf9b1e16$var$_formatTzDate = $03f1d1c4bf9b1e16$export$b64d9bf67c4faac9;
const $03f1d1c4bf9b1e16$var$_hhmmToMin = $03f1d1c4bf9b1e16$export$361693031ac6effa;
// Returns null (available), or one of 'static' / 'event' for unavailability.
//   'static' = outside working hours (general off-hours, configured in profile)
//   'event'  = busy/OOO event from the events array (custom, ad-hoc)
//
// Events with type='busy' (intra-day, has startTime/endTime) and type='ooo'
// (full-day, may have endDate) on the events list are read inline so the
// helper has a single source of truth shared by every view.
function $03f1d1c4bf9b1e16$var$_availabilityType(ms, member, events) {
    if (!member?.timezone) return null;
    const tz = member.timezone;
    const localDate = $03f1d1c4bf9b1e16$var$_formatTzDate(ms, tz);
    const localTime = $03f1d1c4bf9b1e16$var$_formatTzTime(ms, tz);
    const cur = $03f1d1c4bf9b1e16$var$_hhmmToMin(localTime);
    // Event-type: busy events from the events array. Busy + OOO are merged
    // into a single 'busy' type. If endDate is set (or differs from date),
    // it's a multi-day full-day block. Otherwise it's an intra-day time range.
    for (const ev of events || []){
        if (ev.type !== 'busy') continue;
        if (!(ev.invitees || []).includes(member.email)) continue;
        const isMultiDay = ev.endDate && ev.endDate !== ev.date;
        if (isMultiDay) {
            if (localDate >= ev.date && localDate <= ev.endDate) return 'event';
        } else {
            if (ev.date !== localDate) continue;
            const s = $03f1d1c4bf9b1e16$var$_hhmmToMin(ev.startTime || '00:00');
            const e = $03f1d1c4bf9b1e16$var$_hhmmToMin(ev.endTime || '24:00');
            if (cur >= s && cur < e) return 'event';
        }
    }
    // Static: outside working hours (handles midnight-spanning ranges where end < start)
    const wh = member.workingHours;
    if (wh) {
        const start = $03f1d1c4bf9b1e16$var$_hhmmToMin(wh.start);
        const end = $03f1d1c4bf9b1e16$var$_hhmmToMin(wh.end);
        const inHours = start < end ? cur >= start && cur < end : cur >= start || cur < end // wraps midnight
        ;
        if (!inHours) return 'static';
    }
    return null;
}
function $03f1d1c4bf9b1e16$export$c3f95de39763f5b9(member, baseMs, totalMinutes = 1440, slotMinutes = 15, events = []) {
    if (!member) return [];
    // Day columns can render before their `baseMs` reactive prop resolves
    // (state still rehydrating). Skip those frames — Intl.DateTimeFormat
    // .format(NaN) throws "Invalid time value" and would tear down every
    // DayColumn in the smbls 3.14 week view.
    if (!Number.isFinite(baseMs)) return [];
    const STEP_MS = slotMinutes * 60000;
    const ranges = [];
    let curStart = null;
    let curType = null;
    const steps = Math.ceil(totalMinutes / slotMinutes);
    for(let i = 0; i <= steps; i++){
        const isLast = i >= steps;
        let type = null;
        if (!isLast) type = $03f1d1c4bf9b1e16$var$_availabilityType(baseMs + i * STEP_MS, member, events);
        if (type !== curType || isLast) {
            if (curType != null && curStart != null) ranges.push({
                startMin: curStart,
                endMin: i * slotMinutes,
                type: curType
            });
            curStart = type ? i * slotMinutes : null;
            curType = type;
        }
    }
    return ranges;
}
function $03f1d1c4bf9b1e16$export$e4ff15aebfb30c58(year, month, day) {
    const t = new Date();
    const ty = t.getFullYear();
    const tm = t.getMonth();
    const td = t.getDate();
    const ref = new Date(year, month, day);
    const dow = ref.getDay();
    const start = new Date(year, month, day - dow);
    const end = new Date(year, month, day - dow + 6);
    const today = new Date(ty, tm, td);
    return today >= start && today <= end;
}
function $03f1d1c4bf9b1e16$export$69ac73875782844e(year, month, day) {
    const d = new Date(year, month, day);
    const dow = d.getDay();
    const days = [];
    for(let i = 0; i < 7; i++){
        const wd = new Date(year, month, day - dow + i);
        days.push({
            year: wd.getFullYear(),
            month: wd.getMonth(),
            day: wd.getDate(),
            dayName: $03f1d1c4bf9b1e16$var$DAY_NAMES[i]
        });
    }
    return days;
}
function $03f1d1c4bf9b1e16$export$257b40f71c07d58f() {
    const hours = [];
    for(let h = 0; h < 24; h++){
        const label = h === 0 ? '12 AM' : h < 12 ? `${h} AM` : h === 12 ? '12 PM' : `${h - 12} PM`;
        hours.push({
            h: h,
            label: label
        });
    }
    return hours;
}
function $03f1d1c4bf9b1e16$export$57c60d6c6403ce2c(creator, type, people) {
    if (!creator) return false;
    const isExt = (0, $bglB6.isExternalEmail)(creator.email || creator, people);
    if (isExt) return true;
    if (type === 'general') return false;
    return (0, $bglB6.hasRole)(creator, 'superadmin');
}
function $03f1d1c4bf9b1e16$export$5606210727cdab7d(event, viewer) {
    if (!event?.isPrivate) return false;
    // Superadmin (the only role allowed to do this for now) can publish a
    // private event to the team via `isTeamShared`. Once it's shared, the
    // event renders normally for everyone.
    if (event.isTeamShared) return false;
    if (!viewer) return true;
    if (viewer.email === event.creatorEmail) return false;
    if ((0, $bglB6.hasRole)(viewer, 'superadmin')) return false;
    return true;
}
function $03f1d1c4bf9b1e16$export$5ee5e2a16be91d2d(events, event) {
    // If the event already has explicit recurrence info, use it.
    if (event?.recurring && event.recurring !== 'none') return {
        recurring: event.recurring,
        recurringDays: event.recurringDays || []
    };
    if (!event?.googleEventId) return {
        recurring: 'none',
        recurringDays: []
    };
    const baseId = $03f1d1c4bf9b1e16$var$_baseEventId(event.googleEventId);
    // No date suffix → not a recurring instance
    if (!baseId || baseId === event.googleEventId) return {
        recurring: 'none',
        recurringDays: []
    };
    const siblings = (events || []).filter((e)=>$03f1d1c4bf9b1e16$var$_baseEventId(e.googleEventId) === baseId);
    if (siblings.length < 2) return {
        recurring: 'none',
        recurringDays: []
    };
    // Unique sorted dates and their day-of-week
    const dateSet = new Set(siblings.map((e)=>e.date));
    const dates = [
        ...dateSet
    ].sort();
    const parsed = dates.map((d)=>{
        const [y, m, day] = d.split('-').map(Number);
        return new Date(y, m - 1, day);
    });
    const dows = [
        ...new Set(parsed.map((d)=>d.getDay()))
    ];
    // Consecutive intervals in days
    const intervals = [];
    for(let i = 1; i < parsed.length; i++)intervals.push(Math.round((parsed[i] - parsed[i - 1]) / $03f1d1c4bf9b1e16$var$_DAY_MS));
    if (!intervals.length) return {
        recurring: 'none',
        recurringDays: []
    };
    // Pattern detection
    if (intervals.every((i)=>i === 1)) return {
        recurring: 'daily',
        recurringDays: []
    };
    if (intervals.every((i)=>i === 7) && dows.length === 1) return {
        recurring: 'weekly',
        recurringDays: dows
    };
    if (intervals.every((i)=>i === 14) && dows.length === 1) return {
        recurring: 'biweekly',
        recurringDays: []
    };
    // Same day-of-month across months
    const doms = [
        ...new Set(parsed.map((d)=>d.getDate()))
    ];
    if (doms.length === 1 && intervals.every((i)=>i >= 28 && i <= 31)) return {
        recurring: 'monthly',
        recurringDays: []
    };
    // Weekday-only pattern (Mon–Fri)
    const allWeekdays = dows.every((d)=>d >= 1 && d <= 5);
    if (allWeekdays && dows.length === 5) return {
        recurring: 'weekdays',
        recurringDays: []
    };
    // Multiple days per week — treat as weekly with specific days
    if (dows.length >= 1 && dows.length <= 5) return {
        recurring: 'weekly',
        recurringDays: dows
    };
    return {
        recurring: 'weekly',
        recurringDays: dows
    };
}
function $03f1d1c4bf9b1e16$export$37f04dedae96c36c(overrides = {}) {
    return {
        title: '',
        date: '',
        startTime: '09:00',
        endTime: '10:00',
        allDay: false,
        invitees: '',
        inviteeQuery: '',
        description: '',
        type: 'meeting',
        meetingMode: 'symbols-meet',
        meetUrl: '',
        recurring: 'none',
        recurringDays: [],
        editingEventId: null,
        ...overrides
    };
}
function $03f1d1c4bf9b1e16$export$a791c2189f2df0e5(startTime) {
    const [h, m] = startTime.split(':').map(Number);
    return (h * 60 + m) / 60 * 56;
}
function $03f1d1c4bf9b1e16$export$75a7111b83ab7f54(startTime, endTime) {
    const [sh, sm] = startTime.split(':').map(Number);
    const [eh, em] = endTime.split(':').map(Number);
    const startMins = sh * 60 + sm;
    // Cross-midnight: clip to end-of-day (24:00). The next-day tail is rendered
    // separately by getEventsForDay's wrap-around branch.
    let endMins = eh * 60 + em;
    if (endMins <= startMins) endMins = 1440;
    return Math.max((endMins - startMins) / 60 * 56, 24);
}
function $03f1d1c4bf9b1e16$export$1064a26da00eecfc(px) {
    const totalMinutes = Math.max(0, Math.min(1425, Math.round(px / 56 * 60 / 15) * 15));
    const h = Math.floor(totalMinutes / 60);
    const m = totalMinutes % 60;
    return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
}
function $03f1d1c4bf9b1e16$export$2287e3d29250119e(time, mins) {
    const [h, m] = time.split(':').map(Number);
    const total = Math.min(1440, h * 60 + m + mins);
    const nh = Math.floor(total / 60);
    const nm = total % 60;
    return `${String(nh).padStart(2, '0')}:${String(nm).padStart(2, '0')}`;
}
function $03f1d1c4bf9b1e16$export$6f370a2ca055bfeb(color) {
    const map = {
        blue: 'eventBlue',
        green: 'eventGreen',
        red: 'eventRed',
        purple: 'eventPurple',
        orange: 'eventOrange',
        indigo: 'eventIndigo'
    };
    return map[color] || 'eventBlue';
}
function $03f1d1c4bf9b1e16$export$ef308314adc3ab58(year, month) {
    if (month === 0) return {
        year: year - 1,
        month: 11
    };
    return {
        year: year,
        month: month - 1
    };
}
function $03f1d1c4bf9b1e16$export$387da49966d7e375(year, month) {
    if (month === 11) return {
        year: year + 1,
        month: 0
    };
    return {
        year: year,
        month: month + 1
    };
}
const $03f1d1c4bf9b1e16$var$_detailCache = new Set();
// Extract the base recurring event ID (strip the date suffix).
// e.g. "09aql32kefq530bfigjd8gvarc_20260413T193000Z" → "09aql32kefq530bfigjd8gvarc"
const $03f1d1c4bf9b1e16$var$_baseEventId = (geid)=>geid ? geid.replace(/_\d{8}T\d{6}Z$/, '') : null;
async function $03f1d1c4bf9b1e16$export$3aed032d051fb152(eventId, root) {
    if (!eventId || $03f1d1c4bf9b1e16$var$_detailCache.has(eventId)) return;
    $03f1d1c4bf9b1e16$var$_detailCache.add(eventId);
    try {
        // migrated 2026-04-27 to SDK route workspaceProject.calendar get
        const result = await (0, $bfqVY.getSDK)().execute('workspaceProject.calendar', 'get', {
            id: eventId,
            options: {
                columns: 'id,description,invitees'
            }
        });
        const data = Array.isArray(result?.data) ? result.data[0] : result?.data ?? result ?? null;
        if (!data) return;
        let invitees = data.invitees || [];
        let description = data.description;
        // If this instance has no invitees, inherit from a sibling (same recurring series)
        if (!invitees.length) {
            const ev = (root.events || []).find((e)=>e.id === eventId);
            const baseId = $03f1d1c4bf9b1e16$var$_baseEventId(ev?.googleEventId);
            if (baseId) {
                const sibling = (root.events || []).find((e)=>e.id !== eventId && e.invitees?.length && $03f1d1c4bf9b1e16$var$_baseEventId(e.googleEventId) === baseId);
                if (sibling) {
                    invitees = sibling.invitees;
                    if (!description && sibling.description) description = sibling.description;
                }
            }
        }
        const events = root.events || [];
        const next = events.map((e)=>e.id === eventId ? {
                ...e,
                description: description,
                invitees: invitees
            } : e);
        const updates = {
            events: next
        };
        if (root.selectedEvent?.id === eventId) updates.selectedEvent = {
            ...root.selectedEvent,
            description: description,
            invitees: invitees
        };
        root.update(updates);
    } catch (e) {
        $03f1d1c4bf9b1e16$var$_detailCache.delete(eventId);
    }
}

});

parcelRegister("2290d", function(module, exports) {

$parcel$export(module.exports, "triggerCalendarSync", () => $17b2c066a3b701e7$export$c3218349a9ca87d4);
$parcel$export(module.exports, "saveEventToSupabase", () => $17b2c066a3b701e7$export$71c8f18c84916c4);
$parcel$export(module.exports, "deleteEventFromSupabase", () => $17b2c066a3b701e7$export$1f2de9dc0b3e378a);
$parcel$export(module.exports, "updateSharedEventFields", () => $17b2c066a3b701e7$export$839d7a9bac88391c);

var $ac7NT = parcelRequire("ac7NT");
const $17b2c066a3b701e7$var$TABLE = 'calendar_events';
// Date.now() is 13 digits in 2026; Supabase autoincrement ids are <13 digits
// for the foreseeable future. Anything ≥ this is an optimistic local id.
const $17b2c066a3b701e7$var$OPTIMISTIC_ID_FLOOR = 1000000000000;
const $17b2c066a3b701e7$var$isOptimisticId = (id)=>typeof id !== 'number' || id >= $17b2c066a3b701e7$var$OPTIMISTIC_ID_FLOOR;
const $17b2c066a3b701e7$var$nowIso = ()=>new Date().toISOString();
// `date` + `startTime` are local wall-clock (the user dragged "8:30 on Apr 9"
// in their own timezone). Resolve them into a UTC instant via `new Date(...)`,
// which interprets the literal as local. This makes start_at the canonical
// timestamp the rest of the pipeline (Google sync push, _rowToEvent) reads.
const $17b2c066a3b701e7$var$_localToUtcIso = (date, time)=>{
    if (!date || !time) return null;
    const d = new Date(`${date}T${time}:00`);
    return isNaN(d) ? null : d.toISOString();
};
// Add one calendar day to a 'YYYY-MM-DD' string. Used to compute end_date
// for all-day events (Google represents "1 day all-day" as start.date=X,
// end.date=X+1 — a half-open interval).
const $17b2c066a3b701e7$var$_addDay = (ymd)=>{
    if (!ymd) return null;
    const [y, m, d] = ymd.split('-').map(Number);
    const next = new Date(y, m - 1, d + 1);
    const pad = (n)=>String(n).padStart(2, '0');
    return `${next.getFullYear()}-${pad(next.getMonth() + 1)}-${pad(next.getDate())}`;
};
const $17b2c066a3b701e7$var$_toRow = (ev, currentUserEmail)=>{
    const allDay = !!ev.allDay;
    const endDate = allDay ? $17b2c066a3b701e7$var$_addDay(ev.date) : ev.endDate || null;
    return {
        ...typeof ev.id === 'number' && !$17b2c066a3b701e7$var$isOptimisticId(ev.id) ? {
            id: ev.id
        } : {},
        title: ev.title || '(no title)',
        date: ev.date,
        end_date: endDate,
        // All-day events leave start_time/end_time NULL — the sync server's
        // pushUser keys off `!start_time` to send Google's `start: { date }`
        // shape instead of `dateTime`.
        start_time: allDay ? null : ev.startTime || null,
        end_time: allDay ? null : ev.endTime || null,
        // Preserve original UTC timestamps when available (editing without time change).
        // Re-convert only when missing (new event) or times were actually modified.
        start_at: ev.startAt || (allDay ? $17b2c066a3b701e7$var$_localToUtcIso(ev.date, '00:00') : $17b2c066a3b701e7$var$_localToUtcIso(ev.date, ev.startTime)),
        end_at: ev.endAt || (allDay ? $17b2c066a3b701e7$var$_localToUtcIso(endDate, '00:00') : $17b2c066a3b701e7$var$_localToUtcIso(ev.endDate || ev.date, ev.endTime)),
        color: ev.color || null,
        type: ev.type || 'meeting',
        description: ev.description || null,
        invitees: ev.invitees || [],
        organizer_email: ev.creatorEmail || currentUserEmail,
        google_event_id: ev.googleEventId || null,
        google_calendar_id: ev.googleCalendarId || null,
        updated_at: $17b2c066a3b701e7$var$nowIso(),
        deleted: false,
        dirty: true
    };
};
// Fire-and-forget — UI shouldn't block on the Google round-trip.
const $17b2c066a3b701e7$export$c3218349a9ca87d4 = ()=>{
    fetch((0, $ac7NT.CALENDAR_SYNC_URL), {
        method: 'POST',
        headers: (0, $ac7NT.CALENDAR_SYNC_HEADERS)
    }).catch(()=>{});
};
const $17b2c066a3b701e7$var$_logErr = (scope, err)=>console.error(`[${scope}]`, err?.message || err);

const $17b2c066a3b701e7$export$71c8f18c84916c4 = async function(ev) {
    const fetch1 = this.context?.fetch;
    if (!fetch1?.upsert) {
        $17b2c066a3b701e7$var$_logErr('saveEventToSupabase', 'context.fetch.upsert missing');
        return null;
    }
    const row = $17b2c066a3b701e7$var$_toRow(ev, this.state?.root?.currentUserEmail);
    try {
        const result = await fetch1.upsert({
            from: $17b2c066a3b701e7$var$TABLE,
            data: row
        });
        if (result?.error) {
            $17b2c066a3b701e7$var$_logErr('saveEventToSupabase', result.error);
            return null;
        }
        $17b2c066a3b701e7$export$c3218349a9ca87d4();
        // Notify invitees about the calendar event
        const me = this.state?.root?.currentUserEmail;
        const invitees = ev.invitees || [];
        if (invitees.length && me) try {
            const { createNotifications: createNotifications } = await Promise.resolve((parcelRequire("1MoPV")));
            createNotifications.call(this, invitees.filter((e)=>e !== me), {
                type: 'calendar_invite',
                title: `${ev.title || 'New event'} \u{2014} you're invited`,
                body: ev.description?.substring(0, 100) || '',
                href: '/calendar'
            });
        } catch (e) {
            $17b2c066a3b701e7$var$_logErr('saveEventToSupabase:notify', e);
        }
        return result?.data?.[0]?.id ?? null;
    } catch (e) {
        $17b2c066a3b701e7$var$_logErr('saveEventToSupabase', e);
        return null;
    }
};
const $17b2c066a3b701e7$export$1f2de9dc0b3e378a = async function(eventId) {
    if ($17b2c066a3b701e7$var$isOptimisticId(eventId)) return true;
    const fetch1 = this.context?.fetch;
    if (!fetch1?.update) {
        $17b2c066a3b701e7$var$_logErr('deleteEventFromSupabase', 'context.fetch.update missing');
        return false;
    }
    try {
        const result = await fetch1.update({
            from: $17b2c066a3b701e7$var$TABLE,
            params: {
                id: eventId
            },
            data: {
                deleted: true,
                dirty: true,
                updated_at: $17b2c066a3b701e7$var$nowIso()
            }
        });
        if (result?.error) {
            $17b2c066a3b701e7$var$_logErr('deleteEventFromSupabase', result.error);
            return false;
        }
        $17b2c066a3b701e7$export$c3218349a9ca87d4();
        return true;
    } catch (e) {
        $17b2c066a3b701e7$var$_logErr('deleteEventFromSupabase', e);
        return false;
    }
};
const $17b2c066a3b701e7$export$839d7a9bac88391c = async function(ev, fields) {
    const fetch1 = this.context?.fetch;
    if (!fetch1?.update) return;
    const data = {
        updated_at: $17b2c066a3b701e7$var$nowIso(),
        dirty: true
    };
    if (fields.type !== undefined) data.type = fields.type;
    if (fields.description !== undefined) data.description = fields.description;
    if (fields.invitees !== undefined) data.invitees = fields.invitees;
    try {
        // Update by google_event_id
        if (ev.googleEventId) await fetch1.update({
            from: $17b2c066a3b701e7$var$TABLE,
            params: {
                google_event_id: ev.googleEventId,
                deleted: false
            },
            data: data
        });
        // Also update by title + start_at to catch forwarded copies
        if (ev.title && ev.startAt) await fetch1.update({
            from: $17b2c066a3b701e7$var$TABLE,
            params: {
                title: ev.title,
                start_at: ev.startAt,
                deleted: false
            },
            data: data
        });
        $17b2c066a3b701e7$export$c3218349a9ca87d4();
    } catch (e) {
        $17b2c066a3b701e7$var$_logErr('updateSharedEventFields', e);
    }
};

});
parcelRegister("ac7NT", function(module, exports) {

$parcel$export(module.exports, "CALENDAR_SYNC_URL", () => $76c11405459181d2$export$861a374b5889fd15);
$parcel$export(module.exports, "CALENDAR_SYNC_HEADERS", () => $76c11405459181d2$export$46a64902c83f7a8c);
$parcel$export(module.exports, "GITHUB_SYNC_URL", () => $76c11405459181d2$export$6896d460090fa50c);
$parcel$export(module.exports, "GITHUB_SYNC_HEADERS", () => $76c11405459181d2$export$98153b80cb0bd3bb);
$parcel$export(module.exports, "default", () => $76c11405459181d2$export$2e2bcd8739ae039);

var $ghHor = parcelRequire("ghHor");

var $bfqVY = parcelRequire("bfqVY");
const $76c11405459181d2$export$861a374b5889fd15 = (0, $ghHor.edgeFunctionUrl)('calendar-sync');
const $76c11405459181d2$export$46a64902c83f7a8c = (0, $ghHor.edgeFunctionHeaders)();
const $76c11405459181d2$export$6896d460090fa50c = (0, $ghHor.edgeFunctionUrl)('github-sync');
const $76c11405459181d2$export$98153b80cb0bd3bb = (0, $ghHor.edgeFunctionHeaders)();
const $76c11405459181d2$export$31df27b93b6c976b = (0, $ghHor.edgeFunctionUrl)('chat');
const $76c11405459181d2$export$7899ba342088a655 = (0, $ghHor.edgeFunctionHeaders)();
var // Pure SDK fetch adapter — every `fetch:` decl in this app routes through
// sdk.execute(). registerSdkAdapter() in bootShell binds the SDK instance
// at boot, so `{ adapter: 'sdk' }` here is sufficient — no per-decl sdk
// argument needed. The previous metaFetchConfig (per-decl Supabase fallback
// for unmigrated decls) is no longer required because every consumer now
// uses an SDK entity route prefix (workspaceProject.*, auth.*, organization,
// workspace, project, marketplace.*, file, screenshot, i18n.*).
//
// `getSDK()` is passed redundantly so projects mounted standalone (without
// bootShell, e.g. test fixtures) can still wire the adapter without an
// extra registration step. The bound boot-time sdk wins when both are set.
$76c11405459181d2$export$2e2bcd8739ae039 = {
    useReset: true,
    useVariable: true,
    useFontImport: true,
    useIconSprite: true,
    useSvgSprite: true,
    useDefaultConfig: true,
    useDocumentTheme: true,
    verbose: false,
    globalTheme: 'auto',
    fetch: {
        adapter: 'sdk',
        sdk: (0, $bfqVY.getSDK)()
    }
};

});

parcelRegister("1MoPV", function(module, exports) {

$parcel$export(module.exports, "createNotification", () => $14bd8a299c62cc52$export$9c8f6e8d39c60cf3);
$parcel$export(module.exports, "createNotifications", () => $14bd8a299c62cc52$export$9baa1bac95edf573);

var $bfqVY = parcelRequire("bfqVY");
const $14bd8a299c62cc52$export$9c8f6e8d39c60cf3 = async function(opts) {
    if (!opts?.userEmail || !opts?.type || !opts?.title) return null;
    // Don't notify yourself
    const me = this?.state?.root?.currentUserEmail;
    if (me && opts.userEmail === me) return null;
    try {
        // migrated 2026-04-27 to SDK route workspaceProject.notifications/create
        const result = await (0, $bfqVY.getSDK)().execute('workspaceProject.notifications', 'create', {
            payload: {
                user_email: opts.userEmail,
                type: opts.type,
                title: opts.title,
                body: opts.body || null,
                href: opts.href || null,
                metadata: opts.metadata || {}
            }
        });
        return result?.id || result?.data?.id || null;
    } catch (e) {
        console.error('[createNotification]', e?.message || e);
        return null;
    }
};
const $14bd8a299c62cc52$export$9baa1bac95edf573 = async function(recipients, baseOpts) {
    if (!recipients?.length || !baseOpts?.type || !baseOpts?.title) return;
    const me = this?.state?.root?.currentUserEmail;
    const rows = recipients.filter((email)=>email !== me).map((email)=>({
            user_email: email,
            type: baseOpts.type,
            title: baseOpts.title,
            body: baseOpts.body || null,
            href: baseOpts.href || null,
            metadata: baseOpts.metadata || {}
        }));
    if (!rows.length) return;
    try {
        // migrated 2026-04-27 to SDK route workspaceProject.notifications/create (fan-out)
        await Promise.all(rows.map((payload)=>(0, $bfqVY.getSDK)().execute('workspaceProject.notifications', 'create', {
                payload: payload
            }).catch((err)=>{
                console.error('[createNotifications]', err?.message || err);
            })));
    } catch (e) {
        console.error('[createNotifications]', e?.message || e);
    }
};

});



parcelRegister("kx73S", function(module, exports) {

$parcel$export(module.exports, "upsertRow", () => (parcelRequire("hi6Pt")).upsertRow);
$parcel$export(module.exports, "softDeleteRow", () => (parcelRequire("hi6Pt")).softDeleteRow);

var $7MNpT = parcelRequire("7MNpT");

var $l35ii = parcelRequire("l35ii");

var $hi6Pt = parcelRequire("hi6Pt");

var $2BDiG = parcelRequire("2BDiG");

var $gcMIy = parcelRequire("gcMIy");

var $lB5wE = parcelRequire("lB5wE");
$parcel$exportWildcard(module.exports, $7MNpT);
$parcel$exportWildcard(module.exports, $l35ii);
$parcel$exportWildcard(module.exports, $2BDiG);
$parcel$exportWildcard(module.exports, $gcMIy);
$parcel$exportWildcard(module.exports, $lB5wE);

});
parcelRegister("7MNpT", function(module, exports) {

$parcel$export(module.exports, "PRIORITY_COLOR", () => $5ab359318eb40d77$export$5b5b02845d726b92);
$parcel$export(module.exports, "ISSUE_TYPE_COLOR", () => $5ab359318eb40d77$export$b3ccdd082c7d7e80);
$parcel$export(module.exports, "STATE_COLOR", () => $5ab359318eb40d77$export$4013ea9a9e0e135b);
$parcel$export(module.exports, "TICKET_STATE_COLOR", () => $5ab359318eb40d77$export$fa49b0dc2763b686);
$parcel$export(module.exports, "formatStateLabel", () => $5ab359318eb40d77$export$d70a81c727729581);
$parcel$export(module.exports, "resolveAssignees", () => $5ab359318eb40d77$export$a02f612761bc2ba4);
$parcel$export(module.exports, "columnKeyByLabel", () => $5ab359318eb40d77$export$5f50e8c220d4f33e);
$parcel$export(module.exports, "ticketColumnsFetch", () => $5ab359318eb40d77$export$666118d589db64fb);
$parcel$export(module.exports, "rowToColumn", () => $5ab359318eb40d77$export$599eb21456b62b61);
$parcel$export(module.exports, "pageBoilerplateFetch", () => $5ab359318eb40d77$export$bfdc331eea09f8e6);
$parcel$export(module.exports, "rowToTicket", () => $5ab359318eb40d77$export$d46a4ac5551c4d19);
$parcel$export(module.exports, "getTicketsForColumn", () => $5ab359318eb40d77$export$f46824493a9d9e8b);
$parcel$export(module.exports, "positionBetween", () => $5ab359318eb40d77$export$b1da032ddb0c4c4a);
$parcel$export(module.exports, "getColumnAccent", () => $5ab359318eb40d77$export$c690e53c8b88d20f);
$parcel$export(module.exports, "DONE_COLUMN_KEY", () => $5ab359318eb40d77$export$15924ca4d5d3bfac);
$parcel$export(module.exports, "isActiveColumn", () => $5ab359318eb40d77$export$3dee54d8f4ee86cf);
$parcel$export(module.exports, "ticketToStoryCard", () => $5ab359318eb40d77$export$a76503c6633fec21);
$parcel$export(module.exports, "freshTicket", () => $5ab359318eb40d77$export$18662d6c72836307);
$parcel$export(module.exports, "githubColorToken", () => (parcelRequire("1ALAp")).githubColorTokenFromName);

var $1ALAp = parcelRequire("1ALAp");
parcelRequire("UgXQ6");

var $jlK4b = parcelRequire("jlK4b");
const $5ab359318eb40d77$export$5b5b02845d726b92 = {
    urgent: 'red',
    P0: 'red',
    P1: 'orange',
    high: 'orange',
    medium: 'blue',
    P2: 'blue',
    low: 'caption',
    P3: 'caption'
};
const $5ab359318eb40d77$export$b3ccdd082c7d7e80 = {
    Bug: 'red',
    Feature: 'green',
    Task: 'blue',
    Enhancement: 'green',
    'User Story': 'purple',
    Epic: 'orange'
};
const $5ab359318eb40d77$export$4013ea9a9e0e135b = {
    OPEN: 'green',
    CLOSED: 'caption',
    MERGED: 'purple'
};
const $5ab359318eb40d77$export$fa49b0dc2763b686 = {
    not_started: 'caption',
    in_progress: 'yellow',
    blocked: 'red',
    ready_to_test: 'magenta',
    awaiting_approval: 'orange',
    done: 'green',
    closed: 'caption'
};
// Human-readable labels for all canonical ticket states.
// Falls back to title-cased raw value so new states degrade gracefully.
const $5ab359318eb40d77$var$STATE_LABEL = {
    not_started: 'Not Started',
    in_progress: 'In Progress',
    blocked: 'Blocked',
    ready_to_test: 'Ready to Test',
    awaiting_approval: 'Awaiting Approval',
    done: 'Done',
    closed: 'Closed'
};
const $5ab359318eb40d77$export$d70a81c727729581 = (state)=>{
    if (!state) return '';
    if ($5ab359318eb40d77$var$STATE_LABEL[state]) return $5ab359318eb40d77$var$STATE_LABEL[state];
    // Graceful fallback: replace underscores + title-case each word
    return state.replace(/_/g, ' ').replace(/\b\w/g, (c)=>c.toUpperCase());
};
const $5ab359318eb40d77$export$a02f612761bc2ba4 = (ticket, people)=>{
    const out = [];
    const seen = new Set();
    // Build a one-shot map for the call so the two passes below don't
    // re-walk `people` per assignee. WeakMap caching only kicks in when
    // the caller passes `root.people` directly — this local map handles
    // the smaller per-call list either way.
    const list = people || [];
    const byEmail = new Map();
    const byGithub = new Map();
    for (const p of list){
        if (p.email) byEmail.set(p.email, p);
        if (p.github) byGithub.set(p.github, p);
    }
    if (ticket?.assigneeEmail) {
        const p = byEmail.get(ticket.assigneeEmail);
        out.push({
            key: ticket.assigneeEmail,
            name: p?.name || ticket.assigneeEmail,
            avatar: p?.avatar || (0, $jlK4b.avatarUrl)(p?.name || ticket.assigneeEmail),
            login: p?.github
        });
        seen.add(ticket.assigneeEmail);
        if (p?.github) seen.add(p.github);
    }
    for (const login of ticket?.assigneeLogins || []){
        if (!login || seen.has(login)) continue;
        const p = byGithub.get(login);
        if (p?.email && seen.has(p.email)) continue;
        out.push({
            key: login,
            name: p?.name || login,
            avatar: `https://github.com/${login}.png?size=64`,
            login: login
        });
        seen.add(login);
        if (p?.email) seen.add(p.email);
    }
    return out;
};
const $5ab359318eb40d77$export$5f50e8c220d4f33e = (root, label)=>{
    const c = (root?.columns || []).find((c)=>c.label === label);
    return c?.key || null;
};
const $5ab359318eb40d77$export$666118d589db64fb = {
    method: 'select',
    from: 'workspaceProject.ticketColumns',
    order: 'position',
    as: '~/columns',
    cache: '5m',
    transform: (rows)=>({
            columns: (rows || []).map($5ab359318eb40d77$export$599eb21456b62b61)
        })
};
const $5ab359318eb40d77$export$bfdc331eea09f8e6 = [
    $5ab359318eb40d77$export$666118d589db64fb
];
const $5ab359318eb40d77$var$_foldFieldValues = (fvs)=>{
    const out = {};
    for (const v of fvs || []){
        const name = v.project_fields?.name;
        if (!name) continue;
        let value = null;
        if (v.option_name != null) value = v.option_name;
        else if (v.number_value != null) value = v.number_value;
        else if (v.date_value != null) value = v.date_value;
        else if (v.text_value != null) value = v.text_value;
        if (value != null) out[name] = value;
    }
    return out;
};
const $5ab359318eb40d77$export$d46a4ac5551c4d19 = (r)=>{
    const customFields = $5ab359318eb40d77$var$_foldFieldValues(r.ticket_field_values);
    return {
        id: r.id,
        title: r.title,
        body: r.body,
        columnKey: r.column_key,
        position: r.position,
        assigneeEmail: r.assignee_email,
        assigneeLogins: r.assignee_logins || [],
        reporterEmail: r.reporter_email,
        labels: r.labels || [],
        // Priority comes from the GitHub Project's custom field — fall back
        // to the column on the tickets table if a future migration adds it.
        priority: customFields.Priority || r.priority || null,
        dueDate: customFields['Due Date'] || r.due_date,
        githubUrl: r.github_issue_url,
        githubNodeId: r.github_node_id,
        // Mirrored Projects v2 metadata (see migrations 0014 / 0016).
        number: r.number,
        contentType: r.content_type,
        state: r.state,
        repository: r.repository,
        milestone: r.milestone,
        iterationId: r.iteration_id,
        iterationTitle: r.iteration_title || customFields.Iteration,
        iterationStart: r.iteration_start,
        iterationEnd: r.iteration_end,
        trackedByCount: r.tracked_by_count || 0,
        tracksCount: r.tracks_count || 0,
        // Issues 2.0 — GitHub native issue type + the project-level Epic field.
        issueType: r.issue_type,
        issueTypeColor: r.issue_type_color,
        epicOptionId: r.epic_option_id,
        epicName: r.epic_name || customFields.Epic,
        parentIssueUrl: r.parent_issue_url,
        subIssuesTotal: r.sub_issues_total || 0,
        subIssuesCompleted: r.sub_issues_completed || 0,
        // Common Projects v2 custom fields, surfaced as first-class props
        // for the card UI. Anything not in this list is still available via
        // `customFields[name]`.
        severity: customFields.Severity || null,
        storyPoints: customFields['Story Points'] || null,
        size: customFields.Size || null,
        estimate: customFields.Estimate || null,
        environment: customFields.Environment || null,
        reviewStatus: customFields['Review Status'] || null,
        customFields: customFields,
        createdAt: r.created_at,
        updatedAt: r.updated_at
    };
};
const $5ab359318eb40d77$export$599eb21456b62b61 = (r)=>({
        id: r.id,
        key: r.key,
        label: r.label,
        position: r.position,
        color: r.color,
        description: r.description,
        optionId: r.option_id
    });
// Filter + sort tickets that belong to a given column. Honours the active
// filter slots on root state so the board re-renders reactively when the
// user toggles a chip.
//
// Memoised: a single pass over `root.tickets` builds the entire
// `columnKey → tickets[]` index, cached on a WeakMap keyed off the
// `root.tickets` array identity. Subsequent calls (12 columns × 2 cell
// renderers per render) hit the cache. The cache is invalidated when
// `root.tickets` is replaced wholesale (the smbls update pattern) or
// when the filter signature changes — both cheap O(1) checks.
const $5ab359318eb40d77$var$_columnIndexCache = new WeakMap();
const $5ab359318eb40d77$var$_EMPTY_LIST = Object.freeze([]);
const $5ab359318eb40d77$var$_filterSignature = (root)=>`${root.filterAssignee || ''}|${root.filterLabel || ''}|${root.filterEpic || ''}|${root.filterIssueType || ''}|${(root.searchQuery || '').toLowerCase().trim()}|${root.currentUserEmail || ''}`;
const $5ab359318eb40d77$var$_buildColumnIndex = (root)=>{
    const me = root.currentUserEmail;
    const assignee = root.filterAssignee;
    const label = root.filterLabel;
    const epic = root.filterEpic;
    const issueType = root.filterIssueType;
    const q = (root.searchQuery || '').trim().toLowerCase();
    const byCol = new Map();
    for (const t of root.tickets || []){
        if (assignee === 'me') {
            if (t.assigneeEmail !== me) continue;
        } else if (assignee && assignee !== 'all') {
            if (t.assigneeEmail !== assignee) continue;
        }
        if (label && !(t.labels || []).includes(label)) continue;
        if (epic && t.epicOptionId !== epic) continue;
        if (issueType && t.issueType !== issueType) continue;
        if (q && !((t.title || '').toLowerCase().includes(q) || (t.body || '').toLowerCase().includes(q))) continue;
        let arr = byCol.get(t.columnKey);
        if (!arr) {
            arr = [];
            byCol.set(t.columnKey, arr);
        }
        arr.push(t);
    }
    for (const arr of byCol.values())arr.sort((a, b)=>(a.position || 0) - (b.position || 0));
    return byCol;
};
function $5ab359318eb40d77$export$f46824493a9d9e8b(root, columnKey) {
    if (!root || !root.tickets) return $5ab359318eb40d77$var$_EMPTY_LIST;
    let entry = $5ab359318eb40d77$var$_columnIndexCache.get(root.tickets);
    const sig = $5ab359318eb40d77$var$_filterSignature(root);
    if (!entry || entry.sig !== sig) {
        entry = {
            sig: sig,
            byCol: $5ab359318eb40d77$var$_buildColumnIndex(root)
        };
        $5ab359318eb40d77$var$_columnIndexCache.set(root.tickets, entry);
    }
    return entry.byCol.get(columnKey) || $5ab359318eb40d77$var$_EMPTY_LIST;
}
function $5ab359318eb40d77$export$b1da032ddb0c4c4a(prev, next) {
    if (prev == null && next == null) return 1000;
    if (prev == null) return next - 1000;
    if (next == null) return prev + 1000;
    return (prev + next) / 2;
}
// Convert a column key into the brand-aligned colour token used by
// TicketCard's status accent stripe. Hoisted to module scope so the
// hot-path map literal isn't allocated on every call.
const $5ab359318eb40d77$var$COLUMN_ACCENT = {
    backlog: 'caption',
    todo: 'blue',
    in_progress: 'orange',
    review: 'purple',
    done: 'green'
};
function $5ab359318eb40d77$export$c690e53c8b88d20f(columnKey) {
    return $5ab359318eb40d77$var$COLUMN_ACCENT[columnKey] || 'caption';
}
// GitHub Project 5 status column ids that count as "currently being
// worked on" — used by the My View page to bucket assigned tickets into
// "active" vs "backlog" rails. Hoisted so the lookup set isn't
// reallocated on every filter pass.
//   4d6ab783 = In Progress
//   821cd85d = In Review
//   20f135e3 = Ready For QA
//   d677f7ee = In QA
//   2ea8dd8b = Blocked for DEV (still considered active)
const $5ab359318eb40d77$var$ACTIVE_COLUMN_KEYS = new Set([
    '4d6ab783',
    '821cd85d',
    '20f135e3',
    'd677f7ee',
    '2ea8dd8b'
]);
const $5ab359318eb40d77$export$15924ca4d5d3bfac = 'eede5560';
const $5ab359318eb40d77$export$3dee54d8f4ee86cf = (columnKey)=>$5ab359318eb40d77$var$ACTIVE_COLUMN_KEYS.has(columnKey);
const $5ab359318eb40d77$export$a76503c6633fec21 = (cols, t, people)=>{
    const col = (cols || []).find((c)=>c.key === t.column_key) || {};
    let description = t.epic_name ? `${t.repository || ''} \xb7 ${col.label || ''} \xb7 ${t.epic_name}` : `${t.repository || ''} \xb7 ${col.label || ''}`;
    if (people) {
        const who = t.assignee_email ? people.find((p)=>p.email === t.assignee_email)?.name || t.assignee_email : 'Unassigned';
        description = `${description} \xb7 ${who}`;
    }
    return {
        id: t.id,
        title: `#${t.number || t.id} \xb7 ${t.title}`,
        name: `#${t.number || t.id} \xb7 ${t.title}`,
        description: description,
        color: col.color || 'GRAY',
        isTicketCard: true
    };
};
function $5ab359318eb40d77$export$18662d6c72836307(overrides = {}) {
    return {
        title: '',
        body: '',
        columnKey: 'backlog',
        assigneeEmail: '',
        labels: [],
        priority: 'medium',
        issueType: '',
        storyPoints: '',
        acceptanceCriteria: '',
        stepsToReproduce: '',
        expectedResult: '',
        dueDate: '',
        editingTicketId: null,
        agentTest: true,
        ...overrides
    };
}

});

parcelRegister("l35ii", function(module, exports) {

$parcel$export(module.exports, "triggerGithubSync", () => $f52dfc11b9c08025$export$24886cb959557ae);
$parcel$export(module.exports, "saveTicketToSupabase", () => $f52dfc11b9c08025$export$13b0e8f098884c54);
$parcel$export(module.exports, "deleteTicketFromSupabase", () => $f52dfc11b9c08025$export$c7b665ed6afe3619);
$parcel$export(module.exports, "moveTicket", () => $f52dfc11b9c08025$export$51d284ec765f2dde);
// Tickets equivalent of calendar/functions/saveEventToSupabase.js. Uses the
// generic upsertRow / softDeleteRow helpers from shared-gov so we don't
// reinvent the optimistic-id + error-handling logic per app.
//
// All three are bound as element methods (registered via functions/index.js)
// so callers do `el.call('saveTicketToSupabase', ticket)` and the active
// fetch context is reused.

var $ac7NT = parcelRequire("ac7NT");

var $hi6Pt = parcelRequire("hi6Pt");
const $f52dfc11b9c08025$var$TABLE = 'tickets';
const $f52dfc11b9c08025$var$_logErr = (scope, err)=>console.error(`[${scope}]`, err?.message || err);
const $f52dfc11b9c08025$var$_toRow = (t, currentUserEmail)=>{
    // Carry forward existing metadata so we don't clobber other fields (e.g.
    // readyForTest, agent_test set by the QA toggle on the create form).
    const prevMeta = t.metadata && typeof t.metadata === 'object' ? t.metadata : {};
    const metadata = {
        ...prevMeta
    };
    if (t.agentTest !== undefined) metadata.agent_test = !!t.agentTest;
    return {
        ...typeof t.id === 'number' && !(0, $hi6Pt.isOptimisticId)(t.id) ? {
            id: t.id
        } : {},
        title: t.title || '(no title)',
        body: t.body || null,
        column_key: t.columnKey || 'backlog',
        position: t.position || 0,
        assignee_email: t.assigneeEmail || null,
        reporter_email: t.reporterEmail || currentUserEmail,
        labels: t.labels || [],
        priority: t.priority || null,
        due_date: t.dueDate || null,
        github_issue_url: t.githubUrl || null,
        github_node_id: t.githubNodeId || null,
        metadata: metadata,
        updated_at: new Date().toISOString(),
        deleted: false,
        dirty: true
    };
};
const $f52dfc11b9c08025$export$24886cb959557ae = ()=>{
    try {
        fetch((0, $ac7NT.GITHUB_SYNC_URL), {
            method: 'POST',
            headers: (0, $ac7NT.GITHUB_SYNC_HEADERS)
        }).catch(()=>{});
    } catch  {}
};
const $f52dfc11b9c08025$export$13b0e8f098884c54 = async function(ticket) {
    const row = $f52dfc11b9c08025$var$_toRow(ticket, this.state?.root?.currentUserEmail);
    const id = await (0, $hi6Pt.upsertRow).call(this, {
        from: $f52dfc11b9c08025$var$TABLE,
        row: row
    });
    if (id != null) $f52dfc11b9c08025$export$24886cb959557ae();
    return id;
};
const $f52dfc11b9c08025$export$c7b665ed6afe3619 = async function(ticketId) {
    const ok = await (0, $hi6Pt.softDeleteRow).call(this, {
        from: $f52dfc11b9c08025$var$TABLE,
        id: ticketId
    });
    if (ok) $f52dfc11b9c08025$export$24886cb959557ae();
    return ok;
};
const $f52dfc11b9c08025$export$51d284ec765f2dde = async function({ ticketId: ticketId, columnKey: columnKey, position: position }) {
    const fetch1 = this.context?.fetch;
    if (!fetch1?.update) {
        $f52dfc11b9c08025$var$_logErr('moveTicket', 'context.fetch.update missing');
        return false;
    }
    if ((0, $hi6Pt.isOptimisticId)(ticketId)) return true;
    try {
        const result = await fetch1.update({
            from: $f52dfc11b9c08025$var$TABLE,
            params: {
                id: ticketId
            },
            data: {
                column_key: columnKey,
                position: position,
                updated_at: new Date().toISOString()
            }
        });
        if (result?.error) {
            $f52dfc11b9c08025$var$_logErr('moveTicket', result.error);
            return false;
        }
        $f52dfc11b9c08025$export$24886cb959557ae();
        return true;
    } catch (e) {
        $f52dfc11b9c08025$var$_logErr('moveTicket', e);
        return false;
    }
};

});

parcelRegister("2BDiG", function(module, exports) {

$parcel$export(module.exports, "PAGE_SIZE", () => $1e5d85b1f25a99db$export$8ec3d08588d2eeda);
$parcel$export(module.exports, "INITIAL_PAGE_SIZE", () => $1e5d85b1f25a99db$export$90091b93f6cf4241);
$parcel$export(module.exports, "fetchColumnPage", () => $1e5d85b1f25a99db$export$ad42fd312b9b2241);
$parcel$export(module.exports, "fetchRecentTickets", () => $1e5d85b1f25a99db$export$f6d9f8cf9c405d3a);
$parcel$export(module.exports, "fetchTicketsAssignedTo", () => $1e5d85b1f25a99db$export$f9bb3c6b9d0a1cb5);
$parcel$export(module.exports, "fetchProjectFieldOptions", () => $1e5d85b1f25a99db$export$3f4d1e2751f77f6f);
$parcel$export(module.exports, "fetchEpicCounts", () => $1e5d85b1f25a99db$export$d71d89610f6efb87);
$parcel$export(module.exports, "fetchColumnCounts", () => $1e5d85b1f25a99db$export$b287101829b24124);
$parcel$export(module.exports, "pageColumn", () => $1e5d85b1f25a99db$export$99ee43af29c56bcc);
$parcel$export(module.exports, "reloadTickets", () => $1e5d85b1f25a99db$export$b96b5ca5b7717416);
// Single source of truth for the tickets PostgREST loaders. Bound as
// element methods (`el.call('pageColumn', colKey)` /
// `el.call('reloadTickets')`) plus exported as plain functions for
// page `onCreate` to call directly.

var $7MNpT = parcelRequire("7MNpT");

var $ghHor = parcelRequire("ghHor");
const $1e5d85b1f25a99db$export$8ec3d08588d2eeda = 25;
const $1e5d85b1f25a99db$export$90091b93f6cf4241 = 15;
const $1e5d85b1f25a99db$var$FIELD_EMBED = 'ticket_field_values(field_id,option_name,text_value,number_value,date_value,iteration_id,project_fields(name,data_type))';
const $1e5d85b1f25a99db$var$buildFilterSuffix = (filters = {})=>{
    const out = [];
    if (filters.search) {
        const q = filters.search.replace(/[%*]/g, '').trim();
        if (q) out.push(`title=ilike.*${encodeURIComponent(q)}*`);
    }
    if (filters.assignee && filters.assignee !== 'all') {
        const AGENT_SUFFIX = encodeURIComponent('%-agent@symbols.app');
        if (filters.assignee === 'me') {
            if (filters.currentUserEmail) out.push(`assignee_email=eq.${encodeURIComponent(filters.currentUserEmail)}`);
        } else if (filters.assignee === 'agents') out.push(`assignee_email=ilike.${AGENT_SUFFIX}`);
        else if (filters.assignee === 'team') {
            out.push(`assignee_email=not.ilike.${AGENT_SUFFIX}`);
            if (filters.currentUserEmail) out.push(`assignee_email=neq.${encodeURIComponent(filters.currentUserEmail)}`);
        } else // custom email
        out.push(`assignee_email=eq.${encodeURIComponent(filters.assignee)}`);
    }
    if (filters.epic) out.push(`epic_option_id=eq.${encodeURIComponent(filters.epic)}`);
    if (filters.issueType) out.push(`issue_type=eq.${encodeURIComponent(filters.issueType)}`);
    return out.length ? '&' + out.join('&') : '';
};
const $1e5d85b1f25a99db$export$ad42fd312b9b2241 = async (colKey, offset, limit = $1e5d85b1f25a99db$export$8ec3d08588d2eeda, filters = {})=>{
    const url = `${(0, $ghHor.SUPABASE_URL)}/rest/v1/tickets?column_key=eq.${encodeURIComponent(colKey)}&deleted=eq.false&select=*,${$1e5d85b1f25a99db$var$FIELD_EMBED}&order=position&offset=${offset}&limit=${limit}${$1e5d85b1f25a99db$var$buildFilterSuffix(filters)}`;
    const res = await fetch(url, {
        headers: (0, $ghHor.restHeaders)()
    });
    if (!res.ok) return [];
    return res.json();
};
const $1e5d85b1f25a99db$export$f6d9f8cf9c405d3a = async (limit = 20, extraFilter = '')=>{
    const url = `${(0, $ghHor.SUPABASE_URL)}/rest/v1/tickets?deleted=eq.false${extraFilter}&select=id,title,body,column_key,priority,issue_type,epic_name,repository,number,state,labels,assignee_email,reporter_email,updated_at,created_at&order=updated_at.desc&limit=${limit}`;
    const res = await fetch(url, {
        headers: (0, $ghHor.restHeaders)()
    });
    if (!res.ok) return [];
    return res.json();
};
const $1e5d85b1f25a99db$export$f9bb3c6b9d0a1cb5 = async (email, limit = 100)=>{
    if (!email) return [];
    const url = `${(0, $ghHor.SUPABASE_URL)}/rest/v1/tickets?assignee_email=eq.${encodeURIComponent(email)}&deleted=eq.false&select=id,title,body,column_key,priority,issue_type,epic_name,repository,number,state,labels,assignee_email,reporter_email,updated_at,created_at&order=updated_at.desc&limit=${limit}`;
    const res = await fetch(url, {
        headers: (0, $ghHor.restHeaders)()
    });
    if (!res.ok) return [];
    return res.json();
};
const $1e5d85b1f25a99db$export$3f4d1e2751f77f6f = async (fieldName)=>{
    const res = await fetch(`${(0, $ghHor.SUPABASE_URL)}/rest/v1/project_fields?name=eq.${encodeURIComponent(fieldName)}&select=options`, {
        headers: (0, $ghHor.restHeaders)()
    });
    if (!res.ok) return [];
    const rows = await res.json();
    const opts = rows[0]?.options;
    return Array.isArray(opts) ? opts : opts?.options || [];
};
const $1e5d85b1f25a99db$export$d71d89610f6efb87 = async (epicNames)=>{
    const out = {};
    for (const name of epicNames || [])out[name] = {
        total: 0,
        byColumn: {}
    };
    // Fast path: pre-aggregated view (one SELECT, server-side grouped).
    const viewRes = await fetch(`${(0, $ghHor.SUPABASE_URL)}/rest/v1/ticket_epic_counts?select=epic_name,total,by_column`, {
        headers: (0, $ghHor.restHeaders)()
    });
    if (viewRes.ok) {
        const rows = await viewRes.json();
        for (const r of rows){
            if (!r.epic_name) continue;
            out[r.epic_name] = {
                total: r.total || 0,
                byColumn: r.by_column || {}
            };
        }
        return out;
    }
    // Fallback: view missing (404) — fetch the raw rows and aggregate in JS.
    // Scoped to non-null epic_name so the payload stays tight, and bumped to
    // a generous limit because PostgREST defaults to 1000 rows per request.
    const ticketsRes = await fetch(`${(0, $ghHor.SUPABASE_URL)}/rest/v1/tickets?deleted=eq.false&epic_name=not.is.null&select=epic_name,column_key&limit=10000`, {
        headers: (0, $ghHor.restHeaders)()
    });
    if (!ticketsRes.ok) return out;
    const tickets = await ticketsRes.json();
    for (const t of tickets){
        if (!t.epic_name) continue;
        if (!out[t.epic_name]) out[t.epic_name] = {
            total: 0,
            byColumn: {}
        };
        out[t.epic_name].total += 1;
        if (t.column_key) out[t.epic_name].byColumn[t.column_key] = (out[t.epic_name].byColumn[t.column_key] || 0) + 1;
    }
    return out;
};
const $1e5d85b1f25a99db$export$b287101829b24124 = async (filters = {}, colKeys = null)=>{
    let keys = colKeys;
    if (!keys) {
        const cols = await fetch(`${(0, $ghHor.SUPABASE_URL)}/rest/v1/ticket_columns?select=key&order=position`, {
            headers: (0, $ghHor.restHeaders)()
        }).then((r)=>r.json());
        keys = (cols || []).map((c)=>c.key);
    }
    const out = {};
    await Promise.all(keys.map(async (key)=>{
        const url = `${(0, $ghHor.SUPABASE_URL)}/rest/v1/tickets?column_key=eq.${encodeURIComponent(key)}&deleted=eq.false&select=id${$1e5d85b1f25a99db$var$buildFilterSuffix(filters)}`;
        const res = await fetch(url, {
            headers: {
                ...(0, $ghHor.restHeaders)(),
                Prefer: 'count=exact',
                Range: '0-0'
            }
        });
        const cr = res.headers.get('content-range') || '0-0/0';
        out[key] = parseInt(cr.split('/')[1] || '0', 10);
    }));
    return out;
};
const $1e5d85b1f25a99db$var$filtersFromRoot = (root)=>({
        search: root?.searchQuery || '',
        assignee: root?.filterAssignee || 'all',
        epic: root?.filterEpic || null,
        issueType: root?.filterIssueType || null,
        currentUserEmail: root?.currentUserEmail
    });
const $1e5d85b1f25a99db$export$99ee43af29c56bcc = async function(colKey) {
    const root = this.state?.root;
    if (!root) return;
    const loaded = (root.loadedByColumn || {})[colKey] || 0;
    const total = (root.totalByColumn || {})[colKey] || 0;
    if (loaded >= total) return;
    if ((root.loadingColumn || {})[colKey]) return;
    root.update({
        loadingColumn: {
            ...root.loadingColumn || {},
            [colKey]: true
        }
    });
    try {
        const rows = await $1e5d85b1f25a99db$export$ad42fd312b9b2241(colKey, loaded, $1e5d85b1f25a99db$export$8ec3d08588d2eeda, $1e5d85b1f25a99db$var$filtersFromRoot(root));
        const mapped = rows.map((0, $7MNpT.rowToTicket));
        root.update({
            tickets: [
                ...root.tickets || [],
                ...mapped
            ],
            loadedByColumn: {
                ...root.loadedByColumn || {},
                [colKey]: loaded + mapped.length
            },
            loadingColumn: {
                ...root.loadingColumn || {},
                [colKey]: false
            }
        });
    } catch (e) {
        console.error('[pageColumn]', e?.message || e);
        root.update({
            loadingColumn: {
                ...root.loadingColumn || {},
                [colKey]: false
            }
        });
    }
};
const $1e5d85b1f25a99db$export$b96b5ca5b7717416 = async function() {
    const root = this.state?.root;
    if (!root) return;
    const filters = $1e5d85b1f25a99db$var$filtersFromRoot(root);
    const colKeys = (root.columns || []).map((c)=>c.key);
    const totals = await $1e5d85b1f25a99db$export$b287101829b24124(filters, colKeys.length ? colKeys : null);
    root.update({
        totalByColumn: totals,
        tickets: [],
        loadedByColumn: {}
    });
    const first = await Promise.all(Object.keys(totals).map(async (colKey)=>{
        if (!totals[colKey]) return {
            colKey: colKey,
            rows: []
        };
        const rows = await $1e5d85b1f25a99db$export$ad42fd312b9b2241(colKey, 0, $1e5d85b1f25a99db$export$90091b93f6cf4241, filters);
        return {
            colKey: colKey,
            rows: rows
        };
    }));
    const merged = [];
    const loaded = {};
    for (const { colKey: colKey, rows: rows } of first){
        merged.push(...rows.map((0, $7MNpT.rowToTicket)));
        loaded[colKey] = rows.length;
    }
    root.update({
        tickets: merged,
        loadedByColumn: loaded
    });
};

});

parcelRegister("gcMIy", function(module, exports) {

$parcel$export(module.exports, "fetchResolutions", () => $bcc38ea02d28a846$export$b2ea353dd2e43987);
// fetchResolutions.js
// Loads /tickets/resolutions data from public.v_resolutions.
//
// v_resolutions joins type='resolution' tickets (created by subagents via
// open_resolution_ticket()) with their original ticket's resolution JSONB, so
// the UI gets fix context + original link in one query.
//
// Shape returned (one entry per resolution ticket):
//   {
//     resolutionTicketId,   // resolution ticket id
//     resolutionExternalId, // resolution ticket external_id (if any)
//     resolutionTitle,      // "Resolution: <original title>"
//     resolvedAt,           // ISO timestamp
//     resolvedBy,           // agent email that shipped the fix
//     workspaceId,
//     originalTicketId,     // parent original ticket id — links to /tickets/canvas?ticket=<id>
//     originalExternalId,
//     originalTitle,
//     originalType,
//     summary,              // resolution.summary
//     rootCause,            // resolution.root_cause
//     fix,                  // resolution.fix
//     filesTouched,         // resolution.files_touched (array or null)
//     commitSha,            // resolution.commit_sha
//     prevention            // resolution.prevention
//   }

var $ghHor = parcelRequire("ghHor");
const $bcc38ea02d28a846$var$WORKSPACE_ID = '69e5911201b0ef47b675463f';
const $bcc38ea02d28a846$export$b2ea353dd2e43987 = async ({ limit: limit = 100 } = {})=>{
    const url = `${(0, $ghHor.SUPABASE_URL)}/rest/v1/v_resolutions?workspace_id=eq.${$bcc38ea02d28a846$var$WORKSPACE_ID}&order=resolved_at.desc&limit=${limit}`;
    let rows;
    try {
        const res = await fetch(url, {
            headers: (0, $ghHor.restHeaders)()
        });
        if (!res.ok) {
            console.warn('[fetchResolutions] v_resolutions fetch failed', res.status);
            return [];
        }
        rows = await res.json();
    } catch (err) {
        console.warn('[fetchResolutions] network error', err);
        return [];
    }
    if (!Array.isArray(rows)) return [];
    return rows.map((r)=>({
            resolutionTicketId: r.resolution_ticket_id,
            resolutionExternalId: r.resolution_external_id || null,
            resolutionTitle: r.resolution_title || '',
            resolvedAt: r.resolved_at || null,
            resolvedBy: r.resolved_by || null,
            workspaceId: r.workspace_id || $bcc38ea02d28a846$var$WORKSPACE_ID,
            originalTicketId: r.original_ticket_id || null,
            originalExternalId: r.original_external_id || null,
            originalTitle: r.original_title || null,
            originalType: r.original_type || null,
            summary: r.summary || null,
            rootCause: r.root_cause || null,
            fix: r.fix || null,
            filesTouched: r.files_touched ? Array.isArray(r.files_touched) ? r.files_touched : Object.values(r.files_touched) : [],
            commitSha: r.commit_sha || null,
            prevention: r.prevention || null
        }));
};

});

parcelRegister("lB5wE", function(module, exports) {

$parcel$export(module.exports, "getTicketStore", () => $fb9156efb0058262$export$f6e48bed5fc777a3);
$parcel$export(module.exports, "ticketStore", () => $fb9156efb0058262$export$431a5cdcd25f76a3);
// Shared singleton ticket store for /tickets/* pages.
//
// Solves the duplicate-fetch problem: every bucket, rail, and consumer
// that previously called fetchGeneralTriage() independently now subscribes
// to a single in-memory store. The store:
//
//   1. Fetches triage data once (paginated initial load, limit=100 first page)
//   2. Deduplicates concurrent callers — if two pages call getStore() at the
//      same time, only one fetch fires; both get the same Promise.
//   3. Reference-counts subscribers. When the last subscriber leaves,
//      the realtime channel is torn down and the store is cleared after
//      a 5s grace period (covers SPA page transitions).
//   4. Exposes a reactive update mechanism: subscribers register callbacks
//      that receive the new triage object whenever state changes.
//   5. Buffers realtime events (200ms debounce) so rapid INSERT/UPDATE
//      storms from TEMO don't trigger N refetches.
//
// Usage from a page:
//
//   import { getTicketStore } from '../functions/tickets/ticketStore.js'
//
//   // In onCreate:
//   const store = getTicketStore()
//   el._storeUnsub = store.subscribe((triage) => {
//     s.root.update({ triage })
//   })
//   // If data already loaded, push it immediately:
//   if (store.current()) s.root.update({ triage: store.current() })
//
//   // In onRemove:
//   if (el._storeUnsub) { el._storeUnsub(); el._storeUnsub = null }

var $8kTM7 = parcelRequire("8kTM7");

var $jkGmz = parcelRequire("jkGmz");
// Grace period before clearing store after last subscriber leaves.
const $fb9156efb0058262$var$GRACE_MS = 5000;
// Max age before we consider cached data stale and refetch.
const $fb9156efb0058262$var$STALE_MS = 60000;
let $fb9156efb0058262$var$_triage = null // current triage object
;
let $fb9156efb0058262$var$_fetchedAt = 0 // epoch ms of last successful fetch
;
let $fb9156efb0058262$var$_fetchPromise = null // in-flight fetch promise (dedup)
;
let $fb9156efb0058262$var$_subscribers = new Set();
let $fb9156efb0058262$var$_rtUnsub = null;
let $fb9156efb0058262$var$_graceClearTimer = null;
let $fb9156efb0058262$var$_errorCount = 0;
const $fb9156efb0058262$var$_notify = (triage)=>{
    for (const fn of $fb9156efb0058262$var$_subscribers)try {
        fn(triage);
    } catch (_) {}
};
const $fb9156efb0058262$var$_teardownRealtime = ()=>{
    if ($fb9156efb0058262$var$_rtUnsub) {
        $fb9156efb0058262$var$_rtUnsub();
        $fb9156efb0058262$var$_rtUnsub = null;
    }
};
const $fb9156efb0058262$var$_scheduleGraceClear = ()=>{
    if ($fb9156efb0058262$var$_graceClearTimer) clearTimeout($fb9156efb0058262$var$_graceClearTimer);
    $fb9156efb0058262$var$_graceClearTimer = setTimeout(()=>{
        // Only clear if still no subscribers (could re-subscribe during grace).
        if ($fb9156efb0058262$var$_subscribers.size === 0) {
            $fb9156efb0058262$var$_triage = null;
            $fb9156efb0058262$var$_fetchedAt = 0;
            $fb9156efb0058262$var$_fetchPromise = null;
            $fb9156efb0058262$var$_errorCount = 0;
            $fb9156efb0058262$var$_teardownRealtime();
        }
        $fb9156efb0058262$var$_graceClearTimer = null;
    }, $fb9156efb0058262$var$GRACE_MS);
};
const $fb9156efb0058262$var$_setupRealtime = ()=>{
    if ($fb9156efb0058262$var$_rtUnsub) return; // already subscribed
    $fb9156efb0058262$var$_rtUnsub = (0, $jkGmz.subscribeTicketsRealtime)({
        pageName: 'store',
        tables: [
            'tickets',
            'agent_presence',
            'agent_activity_log'
        ],
        onRefresh: async ()=>{
            if ($fb9156efb0058262$var$_subscribers.size === 0) return;
            try {
                const next = await (0, $8kTM7.fetchGeneralTriage)();
                $fb9156efb0058262$var$_triage = next;
                $fb9156efb0058262$var$_fetchedAt = Date.now();
                $fb9156efb0058262$var$_errorCount = 0;
                $fb9156efb0058262$var$_notify(next);
            } catch (err) {
                console.error('[ticketStore] realtime refresh error', err);
                $fb9156efb0058262$var$_errorCount++;
            }
        }
    });
};
// Load triage if needed (not loaded, stale, or in error state).
const $fb9156efb0058262$var$_maybeLoad = async ()=>{
    const now = Date.now();
    const isStale = $fb9156efb0058262$var$_fetchedAt > 0 && now - $fb9156efb0058262$var$_fetchedAt > $fb9156efb0058262$var$STALE_MS;
    if ($fb9156efb0058262$var$_triage && !isStale) return $fb9156efb0058262$var$_triage;
    if ($fb9156efb0058262$var$_fetchPromise) return $fb9156efb0058262$var$_fetchPromise;
    // Fast path: initial limited fetch for first paint.
    // After the fast path resolves, schedule a background full refresh if
    // the server has more tickets than our initial page.
    $fb9156efb0058262$var$_fetchPromise = (0, $8kTM7.fetchGeneralTriage)({
        full: false
    }).then(async (triage)=>{
        $fb9156efb0058262$var$_triage = triage;
        $fb9156efb0058262$var$_fetchedAt = Date.now();
        $fb9156efb0058262$var$_fetchPromise = null;
        $fb9156efb0058262$var$_errorCount = 0;
        $fb9156efb0058262$var$_notify(triage);
        // Background full refresh if initial page was capped.
        if (triage._totalAvailable > triage._initialLimit && $fb9156efb0058262$var$_subscribers.size > 0) setTimeout(async ()=>{
            if ($fb9156efb0058262$var$_subscribers.size === 0) return;
            try {
                const full = await (0, $8kTM7.fetchGeneralTriage)({
                    full: true
                });
                if ($fb9156efb0058262$var$_subscribers.size === 0) return;
                $fb9156efb0058262$var$_triage = full;
                $fb9156efb0058262$var$_fetchedAt = Date.now();
                $fb9156efb0058262$var$_notify(full);
            } catch (err) {
                console.warn('[ticketStore] background full-refresh error', err);
            }
        }, 200) // slight delay so initial paint settles
        ;
        return triage;
    }).catch((err)=>{
        console.error('[ticketStore] fetch error', err);
        $fb9156efb0058262$var$_fetchPromise = null;
        $fb9156efb0058262$var$_errorCount++;
        return $fb9156efb0058262$var$_triage // return stale if available
        ;
    });
    return $fb9156efb0058262$var$_fetchPromise;
};
const $fb9156efb0058262$export$f6e48bed5fc777a3 = ()=>{
    return {
        // Subscribe to triage updates. Returns an unsubscribe function.
        subscribe (fn) {
            $fb9156efb0058262$var$_subscribers.add(fn);
            // Cancel any pending grace-clear (a subscriber just came back).
            if ($fb9156efb0058262$var$_graceClearTimer) {
                clearTimeout($fb9156efb0058262$var$_graceClearTimer);
                $fb9156efb0058262$var$_graceClearTimer = null;
            }
            // Start realtime if first subscriber.
            if ($fb9156efb0058262$var$_subscribers.size === 1) $fb9156efb0058262$var$_setupRealtime();
            // Kick off load (or use cached).
            $fb9156efb0058262$var$_maybeLoad();
            // Return unsubscribe.
            return ()=>{
                $fb9156efb0058262$var$_subscribers.delete(fn);
                if ($fb9156efb0058262$var$_subscribers.size === 0) $fb9156efb0058262$var$_scheduleGraceClear();
            };
        },
        // Synchronously return current triage (may be null before first load).
        current () {
            return $fb9156efb0058262$var$_triage;
        },
        // Force a full refetch (e.g., after the user approves a ticket).
        async refresh () {
            $fb9156efb0058262$var$_fetchedAt = 0 // mark stale to force re-fetch
            ;
            return $fb9156efb0058262$var$_maybeLoad();
        },
        // Apply an optimistic patch directly (for immediate UI feedback).
        patch (triage) {
            $fb9156efb0058262$var$_triage = triage;
            $fb9156efb0058262$var$_notify(triage);
        },
        // Expose error count so UI can show retry CTA.
        errorCount () {
            return $fb9156efb0058262$var$_errorCount;
        }
    };
};
const $fb9156efb0058262$export$431a5cdcd25f76a3 = $fb9156efb0058262$export$f6e48bed5fc777a3();

});
parcelRegister("8kTM7", function(module, exports) {

$parcel$export(module.exports, "STATE_PROGRESS_PCT", () => $611b74c82df129ec$export$f8ca14d10fbff7c7);
$parcel$export(module.exports, "fetchGeneralTriage", () => $611b74c82df129ec$export$d21d998eec863fa6);
// Workspace-wide ticket triage for /tickets/general.
//
// Classifies every open task + bug into buckets based on live
// agent_presence + agent_activity_log signal:
//
//   • now          — an agent is actively running on this ticket right now.
//                   Two conditions qualify (either is sufficient):
//                     a) agent_presence.current_ticket_id = ticket.id AND
//                        status='active' AND last_heartbeat within LIVE_WINDOW_MS
//                     b) ticket.state='in_progress' AND ticket.assignee_email
//                        matches an active presence row (heartbeat within
//                        LIVE_WINDOW_MS). Agents rarely set current_ticket_id,
//                        so (b) is the primary signal in practice.
//   • ongoing      — state='in_progress' OR there's a 'picked_up' activity
//                   log row, but no matching live presence (agent was
//                   working but isn't currently heartbeating)
//   • blocked      — state='blocked'; rendered between Ongoing and Upcoming
//                   with blocker ticket IDs from ticket_dependencies.
//   • upcoming     — state IN ('not_started', null) or never picked up
//   • readyToTest  — state='ready_to_test' (QA-pending; right column)
//
// Returns { now: [...], ongoing: [...], blocked: [...], upcoming: [...], readyToTest: [...], agentPresence: [...] }.
// Each entry: { id, external_id, type, title, state, priority,
//   assignee_email, actor, actorDisplay, tsISO, commitSha, parentStory,
//   parentEpic, updatedAt, childTotal, childDone, progressPct,
//   blockedByIds: [...] }.  blockedByIds is populated for blocked tickets.
//
// Performance changes (ticket #4498):
//   - Done/closed tickets excluded from query (reduces payload ~40%)
//   - AbortController timeout (10s) prevents silent stuck-loading
//   - _fetchAllTickets is kept for background refresh only
//   - fetchTicketPage() exported for lazy bucket loading

var $ghHor = parcelRequire("ghHor");
const $611b74c82df129ec$var$WORKSPACE_ID = '69e5911201b0ef47b675463f';
const $611b74c82df129ec$var$LIVE_WINDOW_MS = 600000 // presence fresh for 10 min
;
// Initial page size: 200 tickets covers ~99% of active workspace tasks/bugs.
// This is the FIRST paint batch — UI shows in <800ms on this limit.
// A background refetch loads the full set for completeness.
const $611b74c82df129ec$var$INITIAL_LIMIT = 200;
// Fetch timeout. After this the fetch rejects → UI shows retry CTA.
const $611b74c82df129ec$var$FETCH_TIMEOUT_MS = 10000;
const $611b74c82df129ec$export$f8ca14d10fbff7c7 = {
    not_started: 0,
    blocked: null,
    in_progress: 33,
    ready_to_test: 66,
    awaiting_approval: 80,
    done: 100
};
// Wrap a fetch with AbortController timeout.
const $611b74c82df129ec$var$_fetchWithTimeout = (url, opts, ms = $611b74c82df129ec$var$FETCH_TIMEOUT_MS)=>{
    if (typeof AbortController === 'undefined') return fetch(url, opts);
    const ctrl = new AbortController();
    const timer = setTimeout(()=>ctrl.abort(), ms);
    return fetch(url, {
        ...opts,
        signal: ctrl.signal
    }).finally(()=>clearTimeout(timer));
};
// Shared query base — excludes done/closed to keep payload small.
// Includes type=decision so ASK-USER / pending-decision tickets appear in the
// decisions bucket on /tickets/general.
const $611b74c82df129ec$var$_ticketBase = ()=>`${0, $ghHor.SUPABASE_URL}/rest/v1/tickets` + `?select=id,external_id,type,title,state,priority,assignee_email,parent_ticket_id,labels,metadata,updated_at,sub_issues_total,sub_issues_completed` + `&workspace_id=eq.${$611b74c82df129ec$var$WORKSPACE_ID}` + `&or=(type.in.(task,bug,user_story,epic,decision),type.is.null)` + `&deleted=eq.false` + `&state=not.in.(done,closed,CLOSED)` + `&order=updated_at.desc`;
const $611b74c82df129ec$export$ab2b6b8a07a14ab4 = async (offset = 0, limit = $611b74c82df129ec$var$INITIAL_LIMIT)=>{
    const r = await $611b74c82df129ec$var$_fetchWithTimeout(`${$611b74c82df129ec$var$_ticketBase()}&offset=${offset}&limit=${limit}`, {
        headers: {
            ...(0, $ghHor.restHeaders)(),
            Prefer: 'count=exact'
        }
    });
    if (!r.ok) return {
        rows: [],
        total: 0
    };
    const rows = await r.json();
    const cr = r.headers.get('content-range') || '';
    const total = parseInt(cr.split('/')[1] || '0', 10) || rows.length;
    return {
        rows: rows,
        total: total
    };
};
// Full fetch: initial page + all remaining pages in parallel.
// Used by the shared ticketStore background-refresh path.
const $611b74c82df129ec$var$_fetchAllTickets = async ()=>{
    const PAGE = 1000;
    const r0 = await $611b74c82df129ec$var$_fetchWithTimeout(`${$611b74c82df129ec$var$_ticketBase()}&offset=0&limit=${PAGE}`, {
        headers: {
            ...(0, $ghHor.restHeaders)(),
            Prefer: 'count=exact'
        }
    });
    if (!r0.ok) return [];
    const page0 = await r0.json();
    const cr = r0.headers.get('content-range') || '';
    const total = parseInt(cr.split('/')[1] || '0', 10) || page0.length;
    if (total <= PAGE) return page0;
    const pages = Math.ceil(total / PAGE);
    const rest = await Promise.all(Array.from({
        length: pages - 1
    }, (_, i)=>$611b74c82df129ec$var$_fetchWithTimeout(`${$611b74c82df129ec$var$_ticketBase()}&offset=${(i + 1) * PAGE}&limit=${PAGE}`, {
            headers: (0, $ghHor.restHeaders)()
        }).then((r)=>r.ok ? r.json() : [])));
    return [
        page0,
        ...rest
    ].flat();
};
const $611b74c82df129ec$export$d73f463c98f0202 = (rows, presence, activity, deps = [])=>{
    // Index ticket rows for parent lookups.
    const byId = new Map();
    for (const r of rows)byId.set(r.id, r);
    // Build child-task counts per parent ticket id.
    const childCountByParent = new Map();
    const childDoneByParent = new Map();
    for (const r of rows){
        if (!r.parent_ticket_id) continue;
        const effectiveType = r.type || 'task';
        if (effectiveType !== 'task' && effectiveType !== 'bug') continue;
        const pid = r.parent_ticket_id;
        childCountByParent.set(pid, (childCountByParent.get(pid) || 0) + 1);
        if (r.state === 'done' || r.state === 'closed') childDoneByParent.set(pid, (childDoneByParent.get(pid) || 0) + 1);
    }
    const epicTitleById = new Map();
    for (const r of rows)if (r.type === 'epic') epicTitleById.set(r.id, r.title || '');
    const storyById = new Map();
    for (const r of rows)if (r.type === 'user_story') storyById.set(r.id, r);
    // Walk the parent_ticket_id chain for a given ticket row until an epic is
    // found or the chain ends. Handles non-standard hierarchies (task → task →
    // story → epic) in addition to the canonical (task → story → epic) path.
    // Returns the epic's title string, or '' if no epic is reachable.
    const _resolveEpicTitle = (startRow)=>{
        let cur = startRow;
        const visited = new Set();
        while(cur && !visited.has(cur.id)){
            visited.add(cur.id);
            if (cur.type === 'epic') return cur.title || '';
            if (!cur.parent_ticket_id) return '';
            cur = byId.get(cur.parent_ticket_id) || null;
        }
        return '';
    };
    // Build live-presence index.
    const now = Date.now();
    const liveAgentByTicket = new Map();
    const livePresenceByEmail = new Map();
    for (const p of presence){
        if (p.status !== 'active') continue;
        const age = p.last_heartbeat ? now - new Date(p.last_heartbeat).getTime() : Infinity;
        if (age > $611b74c82df129ec$var$LIVE_WINDOW_MS) continue;
        if (p.current_ticket_id) liveAgentByTicket.set(p.current_ticket_id, p);
        if (p.assignee_email) livePresenceByEmail.set(p.assignee_email.toLowerCase(), p);
    }
    // Build blockers index: ticket_id → [{ id, external_id, title }] of blocker tickets.
    // deps rows have: { ticket_id, depends_on_ticket_id, kind }
    // A ticket is blocked BY depends_on_ticket_id when kind='blocked_by'.
    const blockersByTicket = new Map();
    for (const d of deps){
        if (d.kind !== 'blocked_by') continue;
        const tid = d.ticket_id;
        if (!blockersByTicket.has(tid)) blockersByTicket.set(tid, []);
        const blockerRow = byId.get(d.depends_on_ticket_id);
        blockersByTicket.get(tid).push({
            id: d.depends_on_ticket_id,
            external_id: blockerRow ? blockerRow.external_id : null,
            title: blockerRow ? blockerRow.title : null
        });
    }
    // Most-recent activity per ticket.
    const lastActivityByTicket = new Map();
    for (const a of activity){
        if (!a.ticket_id) continue;
        if (!lastActivityByTicket.has(a.ticket_id)) lastActivityByTicket.set(a.ticket_id, a);
    }
    const buckets = {
        now: [],
        ongoing: [],
        blocked: [],
        upcoming: [],
        pendingApproval: [],
        readyToTest: [],
        decisions: []
    };
    for (const r of rows){
        const rType = r.type || 'task';
        if (r.state === 'done' || r.state === 'CLOSED' || r.state === 'closed') continue;
        // Decision tickets go to their own dedicated bucket regardless of state.
        // They are ASK-USER / pending-decision items and should always be visible.
        if (rType === 'decision') {
            buckets.decisions.push({
                id: r.id,
                external_id: r.external_id,
                type: rType,
                title: r.title,
                state: r.state,
                priority: r.priority,
                assignee_email: r.assignee_email,
                labels: r.labels || [],
                parentStoryTitle: r.parent_ticket_id ? storyById.get(r.parent_ticket_id)?.title || '' : '',
                parentEpicTitle: _resolveEpicTitle(r),
                metadata: r.metadata,
                updatedAt: r.updated_at
            });
            continue;
        }
        // Only task and bug types go into the standard activity buckets.
        if (rType !== 'task' && rType !== 'bug') continue;
        if (r.state === 'awaiting_approval') {
            const parentStoryA = r.parent_ticket_id ? storyById.get(r.parent_ticket_id) : null;
            buckets.pendingApproval.push({
                id: r.id,
                external_id: r.external_id,
                type: rType,
                title: r.title,
                state: r.state,
                priority: r.priority,
                assignee_email: r.assignee_email,
                labels: r.labels || [],
                parentStoryTitle: parentStoryA?.title || '',
                parentEpicTitle: _resolveEpicTitle(r),
                metadata: r.metadata,
                updatedAt: r.updated_at
            });
            continue;
        }
        const parentStory = r.parent_ticket_id ? storyById.get(r.parent_ticket_id) : null;
        const parentEpicTitle = _resolveEpicTitle(r);
        const parentStoryTitle = parentStory?.title || '';
        const subTotal = (r.sub_issues_total || 0) + (childCountByParent.get(r.id) || 0);
        const subDone = (r.sub_issues_completed || 0) + (childDoneByParent.get(r.id) || 0);
        const isBlocked = r.state === 'blocked';
        let progressPct;
        if (subTotal > 0) progressPct = Math.round(subDone / subTotal * 100);
        else {
            const mapped = $611b74c82df129ec$export$f8ca14d10fbff7c7[r.state];
            progressPct = mapped !== null && mapped !== undefined ? mapped : 0;
        }
        const blockedByIds = blockersByTicket.get(r.id) || [];
        const entry = {
            id: r.id,
            external_id: r.external_id,
            type: rType,
            title: r.title,
            state: r.state,
            priority: r.priority,
            assignee_email: r.assignee_email,
            labels: r.labels || [],
            parentStoryTitle: parentStoryTitle,
            parentEpicTitle: parentEpicTitle,
            metadata: r.metadata,
            updatedAt: r.updated_at,
            progressPct: progressPct,
            isBlocked: isBlocked,
            childTotal: subTotal,
            childDone: subDone,
            blockedByIds: blockedByIds
        };
        if (r.state === 'ready_to_test') {
            buckets.readyToTest.push(entry);
            continue;
        }
        // Blocked tickets get their own dedicated bucket.
        if (r.state === 'blocked') {
            const lastAct = lastActivityByTicket.get(r.id);
            entry.lastActivityAgent = lastAct ? lastAct.agent_name : null;
            entry.lastActivityAt = lastAct ? lastAct.created_at : null;
            entry.liveAgent = null;
            entry.liveAgentHeartbeat = null;
            buckets.blocked.push(entry);
            continue;
        }
        let liveAgent = liveAgentByTicket.get(r.id) || null;
        if (!liveAgent && r.state === 'in_progress' && r.assignee_email) liveAgent = livePresenceByEmail.get(r.assignee_email.toLowerCase()) || null;
        const live = !!liveAgent;
        const lastAct = lastActivityByTicket.get(r.id);
        entry.liveAgent = liveAgent ? liveAgent.agent_name : null;
        entry.liveAgentHeartbeat = liveAgent ? liveAgent.last_heartbeat : null;
        entry.lastActivityAgent = lastAct ? lastAct.agent_name : null;
        entry.lastActivityAt = lastAct ? lastAct.created_at : null;
        let bucket;
        if (live) bucket = 'now';
        else if (r.state === 'in_progress' || lastAct && lastAct.kind === 'picked_up') bucket = 'ongoing';
        else bucket = 'upcoming';
        buckets[bucket].push(entry);
    }
    // Sort within buckets.
    buckets.now.sort((a, b)=>new Date(b.liveAgentHeartbeat || 0) - new Date(a.liveAgentHeartbeat || 0));
    buckets.ongoing.sort((a, b)=>new Date(b.lastActivityAt || b.updatedAt || 0) - new Date(a.lastActivityAt || a.updatedAt || 0));
    const _priRank = (p)=>({
            P0: 0,
            P1: 1,
            P2: 2,
            P3: 3
        })[p] ?? 4;
    const _byPriority = (a, b)=>{
        const d = _priRank(a.priority) - _priRank(b.priority);
        return d !== 0 ? d : new Date(b.updatedAt || 0) - new Date(a.updatedAt || 0);
    };
    buckets.blocked.sort(_byPriority);
    buckets.upcoming.sort(_byPriority);
    buckets.readyToTest.sort(_byPriority);
    // Decisions: most-recent updated first (no priority ranking — they are user decisions)
    buckets.decisions.sort((a, b)=>new Date(b.updatedAt || 0) - new Date(a.updatedAt || 0));
    const lastActivityByAgent = new Map();
    for (const a of activity){
        if (!a.agent_name) continue;
        if (!lastActivityByAgent.has(a.agent_name)) lastActivityByAgent.set(a.agent_name, a);
    }
    const agentPresence = presence.map((p)=>({
            ...p,
            lastActivity: lastActivityByAgent.get(p.agent_name) || null
        }));
    return {
        ...buckets,
        agentPresence: agentPresence
    };
};
const $611b74c82df129ec$export$d21d998eec863fa6 = async ({ full: full = false } = {})=>{
    const [{ rows: rows, total: total }, presenceRes, activityRes, depsRes] = await Promise.all([
        full ? $611b74c82df129ec$var$_fetchAllTickets().then((rows)=>({
                rows: rows,
                total: rows.length
            })) : $611b74c82df129ec$export$ab2b6b8a07a14ab4(0, $611b74c82df129ec$var$INITIAL_LIMIT),
        $611b74c82df129ec$var$_fetchWithTimeout(`${(0, $ghHor.SUPABASE_URL)}/rest/v1/agent_presence?select=agent_name,status,current_ticket_id,last_heartbeat,assignee_email&workspace_id=eq.${$611b74c82df129ec$var$WORKSPACE_ID}`, {
            headers: (0, $ghHor.restHeaders)()
        }),
        $611b74c82df129ec$var$_fetchWithTimeout(`${(0, $ghHor.SUPABASE_URL)}/rest/v1/agent_activity_log?select=ticket_id,kind,agent_name,created_at&workspace_id=eq.${$611b74c82df129ec$var$WORKSPACE_ID}&kind=in.(picked_up,shipped)&order=created_at.desc&limit=500`, {
            headers: (0, $ghHor.restHeaders)()
        }),
        // Fetch blocker dependencies for the blocked bucket.
        // Only kind='blocked_by' is needed; workspace_id scoping is via the ticket IDs.
        $611b74c82df129ec$var$_fetchWithTimeout(`${(0, $ghHor.SUPABASE_URL)}/rest/v1/ticket_dependencies?select=ticket_id,depends_on_ticket_id,kind&workspace_id=eq.${$611b74c82df129ec$var$WORKSPACE_ID}&kind=eq.blocked_by`, {
            headers: (0, $ghHor.restHeaders)()
        })
    ]);
    const presence = presenceRes.ok ? await presenceRes.json() : [];
    const activity = activityRes.ok ? await activityRes.json() : [];
    const deps = depsRes.ok ? await depsRes.json() : [];
    const triage = $611b74c82df129ec$export$d73f463c98f0202(rows, presence, activity, deps);
    // Expose total so page can decide to lazy-load more.
    triage._totalAvailable = total;
    triage._initialLimit = $611b74c82df129ec$var$INITIAL_LIMIT;
    return triage;
};

});

parcelRegister("jkGmz", function(module, exports) {

$parcel$export(module.exports, "subscribeTicketsRealtime", () => $e130bf04651d6547$export$cc994e464e5d62f7);
// Shared realtime subscription helper for all /tickets/* pages.
//
// Subscribes to up to three tables that drive ticket triage / feed / board:
//   - public.tickets        (state, assignee_email, priority, labels changes)
//   - public.agent_presence (live-heartbeat updates → "Now" vs "Ongoing")
//   - public.agent_activity_log (picked_up / shipped events)
//
// Two-tier update strategy:
//   1. Optimistic in-memory patch (immediate, <1ms): when an UPDATE event
//      arrives with a full `new` payload, the onOptimisticPatch callback
//      applies it directly to root state — UI reacts within websocket RTT.
//   2. Debounced full refetch (150ms): reconciles derived state, parent/
//      child relationships, bucket re-classification.
//
// Reconnect behavior: previously hand-rolled exponential backoff on
// CLOSED / TIMED_OUT / CHANNEL_ERROR. Reconnect logic now lives inside
// the SDK provider's underlying transport (Supabase realtime auto-
// reconnects); this helper only handles the application-level subscribe/
// unsubscribe lifecycle.
//
// Usage:
//
//   // In a page's onCreate:
//   el._rtUnsub = subscribeTicketsRealtime({
//     pageName: 'general',
//     tables: ['tickets', 'agent_presence', 'agent_activity_log'],
//     onRefresh: async () => { ... },
//     onOptimisticPatch: (table, eventType, row) => { ... }
//   })
//
//   // In onRemove:
//   if (el._rtUnsub) { el._rtUnsub(); el._rtUnsub = null }
//
// migrated 2026-04-27 to SDK realtime — `workspaceProject.realtime.tickets`
// dispatches through the SDK's transport-agnostic provider with a `tables`
// selector. Today's wire is Supabase realtime via supabaseRealtimeProvider
// in bootShell; backend can swap to native socket.io without touching this
// file.

var $bfqVY = parcelRequire("bfqVY");
const $e130bf04651d6547$var$DEFAULT_TABLES = [
    'tickets',
    'agent_presence',
    'agent_activity_log'
];
// 150ms debounce keeps "Now" bucket current during rapid TEMO picks
// (PATCH ticket → PATCH presence within ~200ms; both batched into one
// refetch).
const $e130bf04651d6547$var$DEBOUNCE_MS = 150;
const $e130bf04651d6547$export$cc994e464e5d62f7 = ({ pageName: pageName = 'tickets', tables: tables = $e130bf04651d6547$var$DEFAULT_TABLES, onRefresh: onRefresh, onOptimisticPatch: onOptimisticPatch } = {})=>{
    if (typeof window === 'undefined') return ()=>{};
    let _resolved = null;
    let _cancelled = false;
    let _debounceTimer = null;
    const _debounceRefresh = ()=>{
        if (!onRefresh) return;
        if (_debounceTimer) clearTimeout(_debounceTimer);
        _debounceTimer = setTimeout(async ()=>{
            try {
                await onRefresh();
            } catch (err) {
                console.error(`[/tickets/${pageName}] refresh error`, err);
            }
        }, $e130bf04651d6547$var$DEBOUNCE_MS);
    };
    const _onEvent = (event, payload)=>{
        // Provider tags each event with payload._kind for table routing.
        const kind = payload?._kind || 'tickets';
        const tableName = kind === 'agent_presence' ? 'agent_presence' : kind === 'agent_activity_log' ? 'agent_activity_log' : 'tickets';
        const newRow = payload?.new;
        if (onOptimisticPatch && newRow && (event === 'INSERT' || event === 'UPDATE')) try {
            onOptimisticPatch(tableName, event, newRow);
        } catch (err) {
            console.warn(`[/tickets/${pageName}] optimistic patch error`, err);
        }
        _debounceRefresh();
    };
    Promise.resolve((0, $bfqVY.getSDK)().getService?.('workspaceProject')).then((wp)=>{
        if (_cancelled || !wp?.realtime?.subscribeTickets) return;
        _resolved = wp.realtime.subscribeTickets({
            tables: tables
        }, _onEvent);
        console.log(`[/tickets/${pageName}] realtime subscribed (${tables.join(', ')})`);
    }).catch((err)=>{
        console.warn(`[/tickets/${pageName}] subscribe failed:`, err?.message || err);
    });
    return ()=>{
        _cancelled = true;
        if (_debounceTimer) {
            clearTimeout(_debounceTimer);
            _debounceTimer = null;
        }
        if (typeof _resolved === 'function') try {
            _resolved();
        } catch (_) {}
    };
};

});



parcelRegister("dDXET", function(module, exports) {

$parcel$export(module.exports, "documentsFetch", () => $9eed31cdbee2d86b$export$d105d01de62d0e69);
$parcel$export(module.exports, "notesFetch", () => $9eed31cdbee2d86b$export$d03e553205d6bd89);
$parcel$export(module.exports, "kbArticlesFetch", () => $9eed31cdbee2d86b$export$494841f739557eb1);
// Supabase fetch blocks for documents, notes, and knowledge base articles.
// Stale-while-revalidate: cached data renders instantly while a background
// refetch keeps it fresh.

var $4JrMY = parcelRequire("4JrMY");

var $58Jrg = parcelRequire("58Jrg");

var $9sHcc = parcelRequire("9sHcc");
const $9eed31cdbee2d86b$export$d105d01de62d0e69 = {
    method: 'select',
    from: 'workspaceProject.documents',
    order: 'updated_at',
    ascending: false,
    as: '~/documents',
    cache: '30s',
    transform: (rows)=>({
            documents: (rows || []).map((r)=>({
                    id: r.id,
                    title: r.title || 'Untitled',
                    folder: r.folder || 'company',
                    type: r.type || 'doc',
                    updatedAt: (r.updated_at || '').slice(0, 10),
                    author: r.author || '',
                    summary: r.summary || '',
                    content: r.content || ''
                }))
        })
};
const $9eed31cdbee2d86b$export$d03e553205d6bd89 = {
    method: 'select',
    from: 'workspaceProject.documents.notes',
    order: 'created_at',
    ascending: false,
    as: '~/notes',
    cache: '30s',
    transform: (rows)=>({
            notes: (rows || []).map((r)=>({
                    id: r.id,
                    title: r.title || 'Untitled',
                    content: r.content || '',
                    author: r.author || '',
                    source: r.source || 'member',
                    createdAt: (r.created_at || '').slice(0, 10),
                    tags: r.tags || []
                }))
        })
};
const $9eed31cdbee2d86b$export$494841f739557eb1 = {
    method: 'select',
    from: 'workspaceProject.documents.kb',
    order: 'updated_at',
    ascending: false,
    as: '~/kbArticles',
    cache: '1m',
    transform: (rows)=>({
            kbArticles: (rows || []).map((r)=>({
                    id: r.id,
                    title: r.title || 'Untitled',
                    category: r.category || 'getting-started',
                    author: r.author || '',
                    updatedAt: (r.updated_at || '').slice(0, 10),
                    summary: r.summary || '',
                    content: r.content || ''
                }))
        })
};
$parcel$exportWildcard(module.exports, $4JrMY);
$parcel$exportWildcard(module.exports, $58Jrg);
$parcel$exportWildcard(module.exports, $9sHcc);

});
parcelRegister("4JrMY", function(module, exports) {

$parcel$export(module.exports, "createNote", () => $3720ebb226f9edc6$export$4640c0d5ffcf906e);
// Insert a row into the notes table. Mirrors the inline insert in
// components/documents/Notes.js (the "+ New note" button) so the same code
// path is reused by both the user-driven button and meet's applySuggestion.
//
// Returns the new row's id on success, null on failure.
//
// migrated 2026-04-27 to SDK route workspaceProject.documents.notes

var $bfqVY = parcelRequire("bfqVY");
const $3720ebb226f9edc6$export$4640c0d5ffcf906e = async function({ title: title = 'Untitled note', content: content = '', tags: tags = [], source: source = 'member' } = {}) {
    const root = this.state.root;
    const row = {
        title: title,
        content: content,
        author: root.currentUserEmail || 'Unknown',
        source: source,
        tags: tags
    };
    let data;
    try {
        const result = await (0, $bfqVY.getSDK)().execute('workspaceProject.documents.notes', 'create', {
            payload: row
        });
        data = result?.data || result;
    } catch (err) {
        console.error('[createNote] insert failed', err);
        return null;
    }
    if (!data?.id) return null;
    // Optimistic state merge so the new note appears immediately in /documents/notes.
    const existing = root.notes || [];
    root.update({
        notes: [
            ...existing,
            {
                id: data.id,
                ...row,
                createdAt: new Date().toISOString().slice(0, 10)
            }
        ],
        selectedNoteId: data.id
    });
    return data.id;
};

});

parcelRegister("58Jrg", function(module, exports) {

$parcel$export(module.exports, "createKnowledgeArticle", () => $3be0f24f23932b1e$export$2877207fb722d716);
// migrated 2026-04-27 to SDK route workspaceProject.documents.kb

var $bfqVY = parcelRequire("bfqVY");
// kb_articles.content is EditorJS JSONB — wrap plain text into a single
// paragraph block before insert.
const $3be0f24f23932b1e$var$_toEditorBlocks = (text)=>({
        time: Date.now(),
        blocks: text ? [
            {
                id: Math.random().toString(36).slice(2, 12),
                type: 'paragraph',
                data: {
                    text: text
                }
            }
        ] : [],
        version: '2.31.6'
    });
const $3be0f24f23932b1e$export$2877207fb722d716 = async function({ title: title = 'Untitled article', content: content = '' } = {}) {
    const root = this.state.root;
    const row = {
        title: title,
        content: $3be0f24f23932b1e$var$_toEditorBlocks(content),
        author: root.currentUserEmail || 'Unknown',
        // Populate `author_email` for Phase E ownership-gated RLS (0069).
        author_email: root.currentUserEmail || null
    };
    let data;
    try {
        const result = await (0, $bfqVY.getSDK)().execute('workspaceProject.documents.kb', 'create', {
            payload: row
        });
        data = result?.data || result;
    } catch (err) {
        console.error('[createKnowledgeArticle] insert failed', err);
        return null;
    }
    if (!data?.id) return null;
    root.update({
        kbArticles: [
            ...root.kbArticles || [],
            {
                id: data.id,
                ...row,
                createdAt: new Date().toISOString().slice(0, 10)
            }
        ],
        selectedKbArticleId: data.id
    });
    return data.id;
};

});

parcelRegister("9sHcc", function(module, exports) {

$parcel$export(module.exports, "saveKbArticle", () => $6e383c62a713995d$export$6fb3abb2b7cb3f5);
// Insert a knowledge-base article into the `documents` table with
// folder='knowledge-base'. Used by meet's applySuggestion when the
// transcript extraction routes to the `knowledge_base` bucket.
//
// We reuse the `documents` table (which already has folder-based
// categorization + a matching fetch in documentsFetch) rather than
// introducing a separate kb_articles table, so KB entries automatically
// show up in /documents when filtered by the knowledge-base folder.
//
// migrated 2026-04-27 to SDK route workspaceProject.documents

var $bfqVY = parcelRequire("bfqVY");
const $6e383c62a713995d$export$6fb3abb2b7cb3f5 = async function({ id: id = null, title: title = 'Untitled article', category: category = 'general', summary: summary = '', content: content = '' } = {}) {
    const root = this.state.root;
    const row = {
        title: title,
        folder: 'knowledge-base',
        type: 'doc',
        author: root.currentUserEmail || 'Unknown',
        // Populate `author_email` for Phase E ownership-gated RLS (0069).
        // Equivalent to `author` in practice — `author` already stores emails
        // in this schema — but the new RLS policies cite `author_email`.
        author_email: root.currentUserEmail || null,
        summary: summary || '',
        // documents.content is JSONB in some schemas; wrap the plain text
        // extraction as a single text block so the editor can render it.
        content: typeof content === 'string' ? {
            blocks: [
                {
                    type: 'text',
                    text: content
                }
            ]
        } : content || {
            blocks: []
        }
    };
    let data = null;
    try {
        data = id != null ? await (0, $bfqVY.getSDK)().execute('workspaceProject.documents', 'update', {
            id: id,
            payload: row
        }) : await (0, $bfqVY.getSDK)().execute('workspaceProject.documents', 'create', {
            payload: row
        });
    } catch (err) {
        console.error('[saveKbArticle] write failed', err?.message || err);
        return null;
    }
    if (!data?.id) {
        console.error('[saveKbArticle] write returned no id');
        return null;
    }
    const existing = root.documents || [];
    const merged = {
        id: data.id,
        title: data.title || title,
        folder: data.folder || 'knowledge-base',
        type: data.type || 'doc',
        author: data.author || '',
        updatedAt: new Date().toISOString().slice(0, 10),
        summary: data.summary || summary,
        content: data.content || row.content
    };
    const next = existing.some((r)=>r.id === data.id) ? existing.map((r)=>r.id === data.id ? merged : r) : [
        merged,
        ...existing
    ];
    root.update({
        documents: next
    });
    return data.id;
};

});


parcelRegister("cptSY", function(module, exports) {

var $fM8BY = parcelRequire("fM8BY");

var $iiSsH = parcelRequire("iiSsH");

var $gYiFW = parcelRequire("gYiFW");

var $gAqLx = parcelRequire("gAqLx");

var $67Bnt = parcelRequire("67Bnt");

var $KWJPC = parcelRequire("KWJPC");

var $8oZGw = parcelRequire("8oZGw");

var $3q4bW = parcelRequire("3q4bW");

var $3AwVh = parcelRequire("3AwVh");

var $8lQZV = parcelRequire("8lQZV");

var $27MmO = parcelRequire("27MmO");

var $bWmNh = parcelRequire("bWmNh");
$parcel$exportWildcard(module.exports, $fM8BY);
$parcel$exportWildcard(module.exports, $iiSsH);
$parcel$exportWildcard(module.exports, $gYiFW);
$parcel$exportWildcard(module.exports, $gAqLx);
$parcel$exportWildcard(module.exports, $67Bnt);
$parcel$exportWildcard(module.exports, $KWJPC);
$parcel$exportWildcard(module.exports, $8oZGw);
$parcel$exportWildcard(module.exports, $3q4bW);
$parcel$exportWildcard(module.exports, $3AwVh);
$parcel$exportWildcard(module.exports, $8lQZV);
$parcel$exportWildcard(module.exports, $27MmO);
$parcel$exportWildcard(module.exports, $bWmNh);

});
parcelRegister("fM8BY", function(module, exports) {

$parcel$export(module.exports, "SUGGESTION_BUCKETS", () => $b7c204ca1f47571e$export$747e21678b553e83);
$parcel$export(module.exports, "getRoomMode", () => $b7c204ca1f47571e$export$1937fd3a9924b806);
$parcel$export(module.exports, "rowToRoom", () => $b7c204ca1f47571e$export$c302b6afd9bf1b94);
$parcel$export(module.exports, "rowToParticipant", () => $b7c204ca1f47571e$export$f0ab70cd8cf51551);
$parcel$export(module.exports, "rowToUtterance", () => $b7c204ca1f47571e$export$5ce198ad0db432fd);
$parcel$export(module.exports, "speakerDisplayName", () => $b7c204ca1f47571e$export$bbe3900bed2e7ec0);
$parcel$export(module.exports, "routeTo", () => $b7c204ca1f47571e$export$7464a66e30a44643);
$parcel$export(module.exports, "fingerprintSuggestion", () => $b7c204ca1f47571e$export$d42092b424920128);
$parcel$export(module.exports, "pruneStaleApplied", () => $b7c204ca1f47571e$export$8aa9adbb8819c0e0);
// meet — pure utilities. Row-shape transforms used by fetch blocks (allowed
// imports per the chat pattern), bucket constants, and the room-mode helper.
// Source of truth for the four AI suggestion buckets. Used by:
//   - meet-analyze Edge Function (the LLM prompt + responseSchema)
//   - meet_transcript_analyses.suggestions JSONB keys
//   - applySuggestion dispatcher
//   - SuggestionCard rendering
// Adding a fifth bucket is a one-line change here + the Edge Function schema.
const $b7c204ca1f47571e$export$747e21678b553e83 = {
    calendar_events: {
        label: 'Calendar',
        viewLabel: "View event \u2192",
        stateKey: 'selectedEventId',
        applyFn: 'saveEventToSupabase',
        route: '/calendar'
    },
    tickets: {
        label: 'Tickets',
        viewLabel: "View ticket \u2192",
        stateKey: 'selectedTicketId',
        applyFn: 'saveTicketToSupabase',
        route: '/tickets'
    },
    notes: {
        label: 'Notes',
        viewLabel: "View note \u2192",
        stateKey: 'selectedNoteId',
        applyFn: 'createNote',
        route: '/documents/notes'
    },
    knowledge_base: {
        label: 'Knowledge base',
        viewLabel: "View article \u2192",
        stateKey: 'selectedDocumentId',
        applyFn: 'saveKbArticle',
        route: '/documents/kb'
    },
    chat_messages: {
        label: 'Chat',
        viewLabel: "Open chat \u2192",
        applyFn: 'messageUser',
        route: '/chat'
    }
};
const $b7c204ca1f47571e$export$1937fd3a9924b806 = (participantCount)=>{
    if (participantCount < 3) return 'dm';
    if (participantCount < 13) return 'grid';
    return 'stage';
};
const $b7c204ca1f47571e$export$c302b6afd9bf1b94 = (r)=>({
        id: r.id,
        name: r.name || 'Untitled',
        topic: r.topic || '',
        kind: r.kind || 'room',
        isPrivate: !!r.is_private,
        transcribeEnabled: !!r.transcribe_enabled,
        livekitInitialized: !!r.livekit_initialized,
        createdBy: r.created_by,
        createdAt: r.created_at,
        endedAt: r.ended_at,
        calendarEventId: r.calendar_event_id || null,
        chatChannelId: r.chat_channel_id || null,
        // Guest-join requirements (migration 0019). `guestRequireName` defaults
        // to true; the others default false/null. Read by NewRoomModal /
        // MeetRoomSettingsModal / /meet-guest page.
        guestRequireName: r.guest_require_name !== false,
        guestRequireEmail: !!r.guest_require_email,
        guestPassword: r.guest_password || null,
        guestAutoAdmit: !!r.guest_auto_admit
    });
const $b7c204ca1f47571e$export$f0ab70cd8cf51551 = (r)=>({
        id: r.id,
        roomId: r.room_id,
        userId: r.user_id,
        identity: r.identity,
        joinedAt: r.joined_at,
        leftAt: r.left_at
    });
const $b7c204ca1f47571e$export$5ce198ad0db432fd = (r)=>({
        id: r.id,
        roomId: r.room_id,
        userId: r.user_id,
        // The transcriber writes `speaker_name` as whatever LiveKit's
        // `participant.name` is, which in our case is the user's EMAIL (set by
        // meet-token when minting the token). Keep it stored as-is; components
        // resolve the display name via root.people at render time.
        speakerEmail: r.speaker_name || '',
        text: r.text || '',
        startedAt: r.started_at,
        endedAt: r.ended_at,
        confidence: r.confidence
    });
const $b7c204ca1f47571e$export$bbe3900bed2e7ec0 = (root, speakerEmail)=>{
    if (!speakerEmail) return 'Unknown';
    const people = root?.people || [];
    const match = people.find((p)=>p.email === speakerEmail);
    return match?.name || speakerEmail;
};
const $b7c204ca1f47571e$export$7464a66e30a44643 = (el, path)=>{
    if (!el || !path) return;
    let root = el;
    while(root && !root.routes)root = root.parent;
    if (root) el.router(path, root);
};
const $b7c204ca1f47571e$export$d42092b424920128 = async (item)=>{
    const text = `${item.title || ''}|${item.description || item.content || item.body || ''}`;
    const buf = new TextEncoder().encode(text);
    const hash = await crypto.subtle.digest('SHA-256', buf);
    const bytes = new Uint8Array(hash).slice(0, 8);
    return Array.from(bytes, (b)=>b.toString(16).padStart(2, '0')).join('');
};
const $b7c204ca1f47571e$export$8aa9adbb8819c0e0 = async (appliedItems, suggestions)=>{
    if (!appliedItems?.length) return [];
    const liveFingerprints = new Set();
    for (const bucket of Object.keys($b7c204ca1f47571e$export$747e21678b553e83))for (const item of suggestions?.[bucket] || [])liveFingerprints.add(await $b7c204ca1f47571e$export$d42092b424920128(item));
    return appliedItems.filter((entry)=>liveFingerprints.has(entry.fingerprint));
};

});

parcelRegister("iiSsH", function(module, exports) {

$parcel$export(module.exports, "createRoom", () => $d53427682bef21c2$export$4a6fbf23fa252689);
// Create a new meet_rooms row + auto-add the creator as an owning member.
// camelCase API at the boundary; snake_case at the row write — same boundary
// chat's createChannel uses.
//
// migrated 2026-04-27 to SDK route workspaceProject.meet.rooms (create) +
// workspaceProject.meet.members (create)

var $bfqVY = parcelRequire("bfqVY");

var $fM8BY = parcelRequire("fM8BY");
const $d53427682bef21c2$export$4a6fbf23fa252689 = async function({ name: name, kind: kind = 'room', isPrivate: isPrivate = false, transcribeEnabled: transcribeEnabled = false, calendarEventId: calendarEventId = null, chatChannelId: chatChannelId = null }) {
    const root = this.state.root;
    const me = root.currentUserId;
    if (!me) {
        console.error("[createRoom] no currentUserId \u2014 meet requires real auth");
        return null;
    }
    const sdk = (0, $bfqVY.getSDK)();
    try {
        const result = await sdk.execute('workspaceProject.meet.rooms', 'create', {
            payload: {
                name: name || 'Untitled call',
                kind: kind,
                is_private: isPrivate,
                transcribe_enabled: transcribeEnabled,
                calendar_event_id: calendarEventId,
                chat_channel_id: chatChannelId,
                created_by: me
            }
        });
        const row = result?.data || result;
        if (!row?.id) throw new Error('createRoom: empty response');
        const room = (0, $fM8BY.rowToRoom)(row);
        // Auto-add the creator as the owning member. Other members can self-join
        // via the shareable URL (the meet_members_insert RLS policy allows
        // user_id = auth.uid() inserts).
        try {
            await sdk.execute('workspaceProject.meet.members', 'create', {
                roomId: room.id,
                payload: {
                    user_id: me,
                    role: 'owner'
                }
            });
        } catch (memErr) {
            console.warn('[createRoom] member insert failed', memErr?.message || memErr);
        }
        // Optimistic state merge — realtime will deliver the same row but the
        // user shouldn't have to wait for the round trip.
        const existing = root.rooms || [];
        if (!existing.some((r)=>r.id === room.id)) root.update({
            rooms: [
                room,
                ...existing
            ],
            activeRoomId: room.id,
            showNewRoom: false
        });
        return room.id;
    } catch (err) {
        console.error('[createRoom]', err?.message || err);
        return null;
    }
};

});

parcelRegister("gYiFW", function(module, exports) {

$parcel$export(module.exports, "mintLivekitToken", () => $c5b0bc7df33409fb$export$dc10f14113e868fd);
// Calls the meet-token endpoint via the workspace SDK and returns
// { roomName, livekitToken, livekitUrl } that the caller passes to
// room.connect(...).
//
// Meet REQUIRES a real auth session (chat / calendar can run in dev-mode
// app_settings, but LiveKit needs a stable user identity for the token's
// `identity` claim). If no session exists this rejects loudly so the UI
// can show a "sign in to start a call" message instead of silently
// minting a guest token.
//
// Routes through workspaceProject.meet.token (rpc) so the workspace JWT
// + tenant scoping flows through the SDK's TokenManager rather than a
// raw Supabase access token.

var $bfqVY = parcelRequire("bfqVY");
const $c5b0bc7df33409fb$export$dc10f14113e868fd = async function(roomId) {
    const sdk = (0, $bfqVY.getSDK)();
    // getSession() is async in v3.14 — without await session is a Promise
    // and access_token is undefined.
    const session = await sdk.getSession();
    if (!session?.access_token) throw new Error('meet requires a real session');
    try {
        return await sdk.execute('workspaceProject.meet.token', 'rpc', {
            roomId: roomId
        });
    } catch (err) {
        // SDK throws Error with the upstream HTTP status / message embedded —
        // surface a typed error so callers can switch on .status the same
        // way the raw fetch path did.
        const message = err?.message || '';
        let status = 0;
        const m = message.match(/HTTP\s+(\d+)/iu) || message.match(/^(\d+)\s/u);
        if (m) status = parseInt(m[1], 10);
        const reason = message || (status === 401 ? "session expired \u2014 please sign in again" : status === 403 ? 'not allowed to join this room' : `status ${status || '?'}`);
        console.error('[mintLivekitToken]', status || '?', reason);
        const out = new Error(reason);
        out.status = status;
        throw out;
    }
};

});

parcelRegister("gAqLx", function(module, exports) {

$parcel$export(module.exports, "subscribeMeetRealtime", () => $c134c53abd1cc665$export$2ffe1d360773a979);
// Scoped realtime subscription for meet. Different pages need different
// table+filter combinations; passing { tables, roomId } keeps each
// subscription tight so the home page doesn't receive every utterance from
// every active call across the org.
//
// Module-level subscription handle (NOT root state) — DOMQL may create a
// fresh state object on update, so direct property assignments
// (root._meetRealtimeChannel) get lost on the next update and every
// callback fires against the dead state object. Module-level vars stay
// stable across state updates.
//
// All event callbacks re-read `this.state.root` freshly via the captured
// `self` element reference so updates always land on the live root state,
// not a stale snapshot.
//
// Named distinctly from chat's subscribeRealtime to avoid function-registry
// collision. Declared as a regular `function` (not arrow) so this-binding
// from el.call(...) works.
//
// migrated 2026-04-27 to SDK realtime — `workspaceProject.realtime.meet`
// dispatches through the SDK's transport-agnostic provider with a
// per-page `tables` selector. The provider tags each callback by table
// kind ('room'|'participant'|'waiting'|'transcript'|'analysis') so the
// dispatch table below routes events without re-reading the table name.

var $bfqVY = parcelRequire("bfqVY");

var $fM8BY = parcelRequire("fM8BY");
let $c134c53abd1cc665$var$_meetUnsub = null;
let $c134c53abd1cc665$var$_meetScope = null;
const $c134c53abd1cc665$var$_rowToWaitingGuest = (r)=>({
        id: r.id,
        roomId: r.room_id,
        guestName: r.guest_name || 'Guest',
        guestEmail: r.guest_email || null,
        requestedAt: r.requested_at,
        admittedAt: r.admitted_at,
        rejectedAt: r.rejected_at
    });
// Map page-level table names to provider-level table kinds.
const $c134c53abd1cc665$var$_tablesToKinds = (tables)=>{
    const map = {
        meet_rooms: 'rooms',
        meet_participants: 'participants',
        meet_waiting_room: 'waiting',
        meet_transcripts: 'transcripts',
        meet_transcript_analyses: 'analyses'
    };
    return tables.map((t)=>map[t]).filter(Boolean);
};
const $c134c53abd1cc665$export$2ffe1d360773a979 = function(opts = {}) {
    const self = this // stable element reference
    ;
    const { tables: tables = [
        'meet_rooms'
    ], roomId: roomId = null } = opts;
    const scopeKey = `${[
        ...tables
    ].sort().join(',')}:${roomId || '*'}`;
    if ($c134c53abd1cc665$var$_meetScope === scopeKey) return $c134c53abd1cc665$var$_meetUnsub;
    if ($c134c53abd1cc665$var$_meetUnsub) {
        try {
            $c134c53abd1cc665$var$_meetUnsub();
        } catch (_) {}
        $c134c53abd1cc665$var$_meetUnsub = null;
    }
    $c134c53abd1cc665$var$_meetScope = scopeKey;
    const kinds = $c134c53abd1cc665$var$_tablesToKinds(tables);
    if (!kinds.length) return null;
    let _resolved = null;
    let _cancelled = false;
    Promise.resolve((0, $bfqVY.getSDK)().getService?.('workspaceProject')).then((wp)=>{
        if (_cancelled || !wp?.realtime?.subscribeMeet) return;
        _resolved = wp.realtime.subscribeMeet({
            roomId: roomId,
            tables: kinds
        }, (kind, payload)=>{
            const root = self.state.root;
            if (kind === 'room') {
                const next = (0, $fM8BY.rowToRoom)(payload.new || payload.old || {});
                const cur = root.rooms || [];
                if (payload.eventType === 'INSERT') {
                    if (!cur.some((r)=>r.id === next.id)) root.update({
                        rooms: [
                            next,
                            ...cur
                        ]
                    });
                } else if (payload.eventType === 'UPDATE') root.update({
                    rooms: cur.map((r)=>r.id === next.id ? next : r)
                });
                else if (payload.eventType === 'DELETE') root.update({
                    rooms: cur.filter((r)=>r.id !== next.id)
                });
                return;
            }
            if (kind === 'participant') {
                const p = (0, $fM8BY.rowToParticipant)(payload.new || payload.old || {});
                const map = {
                    ...root.liveParticipants || {}
                };
                const list = map[p.roomId] || [];
                if (payload.eventType === 'INSERT') {
                    if (!list.some((x)=>x.id === p.id)) map[p.roomId] = [
                        ...list,
                        p
                    ];
                } else if (payload.eventType === 'UPDATE') map[p.roomId] = list.map((x)=>x.id === p.id ? p : x);
                else if (payload.eventType === 'DELETE') map[p.roomId] = list.filter((x)=>x.id !== p.id);
                root.update({
                    liveParticipants: map
                });
                return;
            }
            if (kind === 'transcript') {
                const u = (0, $fM8BY.rowToUtterance)(payload.new || {});
                const cur = root.utterances || [];
                root.update({
                    utterances: [
                        ...cur,
                        u
                    ]
                });
                return;
            }
            if (kind === 'analysis') {
                if (payload.new) root.update({
                    analysis: payload.new
                });
                return;
            }
            if (kind === 'waiting') {
                const g = $c134c53abd1cc665$var$_rowToWaitingGuest(payload.new || payload.old || {});
                const map = {
                    ...root.waitingRoom || {}
                };
                const list = map[g.roomId] || [];
                if (payload.eventType === 'INSERT') {
                    if (!list.some((x)=>x.id === g.id)) map[g.roomId] = [
                        ...list,
                        g
                    ];
                } else if (payload.eventType === 'UPDATE') map[g.roomId] = list.map((x)=>x.id === g.id ? g : x);
                else if (payload.eventType === 'DELETE') map[g.roomId] = list.filter((x)=>x.id !== g.id);
                root.update({
                    waitingRoom: map
                });
            }
        });
    }).catch((err)=>{
        console.warn('[meet] subscribeMeetRealtime failed:', err?.message || err);
    });
    $c134c53abd1cc665$var$_meetUnsub = ()=>{
        _cancelled = true;
        if (typeof _resolved === 'function') try {
            _resolved();
        } catch (_) {}
        $c134c53abd1cc665$var$_meetScope = null;
    };
    return $c134c53abd1cc665$var$_meetUnsub;
};

});

parcelRegister("67Bnt", function(module, exports) {

$parcel$export(module.exports, "analyzeTranscript", () => $475063f337feb712$export$83038e27eb27b8a3);
// Calls the meet-analyze workspace endpoint for a room and returns the
// analysis row { room_id, summary, suggestions, model, generated_at,
// applied_items? }. Pass force=true to bust the cached row and re-extract.
//
// Routes through workspaceProject.aiMeetAnalyze (rpc) → POST /ai/meet-
// analyze on the workspace worker, which forwards the user's JWT to
// the meet-analyze Supabase edge function. The edge function caches in
// `meet_transcript_analyses` keyed by room_id; re-opening the
// transcript hits the cache, no model call. force=1 bypasses cache.
//
// All AI/data calls flow through @symbo.ls/sdk — never raw fetch to
// Supabase from the frontend. The SDK adapter handles auth, retries,
// and the migration path when AI endpoints move to first-class server
// routes.

var $bfqVY = parcelRequire("bfqVY");
const $475063f337feb712$export$83038e27eb27b8a3 = async function(roomId, force = false) {
    const sdk = (0, $bfqVY.getSDK)();
    // sdk.getSession() returns Promise<session> in v3.14 — without await
    // `session` is the Promise itself and access_token is undefined.
    const session = await sdk.getSession();
    if (!session?.access_token) {
        const err = new Error("session expired \u2014 please sign in again");
        err.status = 401;
        throw err;
    }
    try {
        return await sdk.execute('workspaceProject.aiMeetAnalyze', 'rpc', {
            roomId: roomId,
            force: !!force
        });
    } catch (err) {
        const message = err?.message || '';
        let status = 0;
        const m = message.match(/HTTP\s+(\d+)/iu) || message.match(/^(\d+)\s/u);
        if (m) status = parseInt(m[1], 10);
        const reason = message || (status === 422 ? 'no transcript available yet' : status === 403 ? 'not allowed to read this room' : status === 401 ? "session expired \u2014 please sign in again" : `status ${status || '?'}`);
        console.error('[analyzeTranscript]', status || '?', reason);
        const out = new Error(reason);
        out.status = status;
        throw out;
    }
};

});

parcelRegister("KWJPC", function(module, exports) {

$parcel$export(module.exports, "applySuggestion", () => $08d1dc2df2395cd9$export$b632b48a7eefd3bb);
// Single dispatcher for the four suggestion buckets on /meet/:id/transcript.
// Each bucket maps via SUGGESTION_BUCKETS to an existing creation function on
// the project (saveEventToSupabase, saveTicketToSupabase, createNote,
// messageUser). applySuggestion just forwards.
//
// On success, writes a fingerprint entry to meet_transcript_analyses.applied_items
// (gated by the meet_analysis_update_applied RLS policy from 0018_meet.sql)
// and routes the user to the destination feature.

var $bfqVY = parcelRequire("bfqVY");

var $fM8BY = parcelRequire("fM8BY");
// Per-bucket payload adapters — the LLM extraction shape
// (calendar_events, tickets, notes, chat_messages) doesn't match the
// existing creation functions' shapes, so each bucket needs a small mapping.
// Each target function uses camelCase at its boundary and converts to
// snake_case internally; we do the same.
// Loose-parse a human proposed_time string into a YYYY-MM-DD + HH:MM pair.
// Gemini may produce "next Thursday at 2pm" or "2026-04-17 14:00" or similar.
// Try Date.parse first; fall back to tomorrow 10:00 if unparseable.
const $08d1dc2df2395cd9$var$_parseProposedTime = (str)=>{
    if (!str) return null;
    const d = new Date(str);
    if (!isNaN(d)) {
        const pad = (n)=>String(n).padStart(2, '0');
        return {
            date: `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`,
            time: `${pad(d.getHours())}:${pad(d.getMinutes())}`
        };
    }
    return null;
};
// Adapters translate the Gemini extraction shape into the payload shape the
// target creation function expects. When `item.action === 'update'`, include
// `id` so saveEventToSupabase / saveTicketToSupabase hit their existing-row
// update path (those functions upsert when id is present — see tickets
// saveTicketToSupabase.js `_toRow`).
const $08d1dc2df2395cd9$var$_targetIdAsInt = (str)=>{
    if (!str) return null;
    const n = Number(str);
    return Number.isFinite(n) ? n : null;
};
const $08d1dc2df2395cd9$var$ADAPTERS = {
    calendar_events: (item)=>{
        const parsed = $08d1dc2df2395cd9$var$_parseProposedTime(item.proposed_time) || (()=>{
            const t = new Date();
            t.setDate(t.getDate() + 1);
            const pad = (n)=>String(n).padStart(2, '0');
            return {
                date: `${t.getFullYear()}-${pad(t.getMonth() + 1)}-${pad(t.getDate())}`,
                time: '10:00'
            };
        })();
        const [h, m] = parsed.time.split(':').map(Number);
        const endH = String((h + 1) % 24).padStart(2, '0');
        const payload = {
            title: item.title || 'Untitled event',
            date: parsed.date,
            startTime: parsed.time,
            endTime: `${endH}:${String(m).padStart(2, '0')}`,
            description: item.description || '',
            invitees: (item.attendees || []).filter(Boolean),
            type: 'meeting',
            meetingMode: 'symbols-meet',
            color: 'blue'
        };
        if (item.action === 'update') {
            const id = $08d1dc2df2395cd9$var$_targetIdAsInt(item.target_id);
            if (id != null) payload.id = id;
        }
        return payload;
    },
    tickets: (item)=>{
        const payload = {
            title: item.title || 'Untitled ticket',
            body: item.description || '',
            assigneeEmail: item.assignee_email || null,
            columnKey: 'backlog'
        };
        if (item.action === 'update') {
            const id = $08d1dc2df2395cd9$var$_targetIdAsInt(item.target_id);
            if (id != null) payload.id = id;
        }
        return payload;
    },
    notes: (item)=>{
        const payload = {
            title: item.title || 'Untitled note',
            content: item.content || '',
            tags: item.tags || [],
            source: 'ai'
        };
        if (item.action === 'update') {
            const id = $08d1dc2df2395cd9$var$_targetIdAsInt(item.target_id);
            if (id != null) payload.id = id;
        }
        return payload;
    },
    knowledge_base: (item)=>{
        const payload = {
            title: item.title || 'Untitled article',
            category: item.category || 'general',
            summary: item.summary || '',
            content: item.content || item.summary || '',
            source: 'ai'
        };
        if (item.action === 'update') {
            const id = $08d1dc2df2395cd9$var$_targetIdAsInt(item.target_id);
            if (id != null) payload.id = id;
        }
        return payload;
    },
    chat_messages: (item)=>({
            email: item.to_email || '',
            body: item.body || ''
        })
};
const $08d1dc2df2395cd9$export$b632b48a7eefd3bb = async function(bucket, item) {
    const cfg = (0, $fM8BY.SUGGESTION_BUCKETS)[bucket];
    if (!cfg) {
        console.error('[applySuggestion] unknown bucket', bucket);
        return null;
    }
    const root = this.state.root;
    const adapter = $08d1dc2df2395cd9$var$ADAPTERS[bucket];
    const payload = adapter(item);
    let targetId = null;
    try {
        if (bucket === 'chat_messages') {
            // chat case is special: messageUser opens (or creates) the DM with the
            // recipient and sets a draft body. The user manually sends — we never
            // auto-send chat messages.
            targetId = await this.call('messageUser', payload.email);
            // Stash the draft body on root so the chat composer picks it up after
            // navigation. Chat reads this slot in its Composer if present.
            root.update({
                meetSuggestedDraft: payload.body
            });
        } else targetId = await this.call(cfg.applyFn, payload);
    } catch (err) {
        console.error('[applySuggestion] applyFn failed', cfg.applyFn, err);
        return null;
    }
    if (!targetId) return null;
    // Persist the application in meet_transcript_analyses.applied_items so
    // re-opening the transcript page shows the checkmark. Stale fingerprints
    // from prior regenerations are pruned at the same time. The room id
    // lives in root.activeRoomId — NOT `root.route.params.id` (we use a
    // single /meet route with state sub-views, not dynamic params).
    try {
        const fingerprint = await (0, $fM8BY.fingerprintSuggestion)(item);
        const current = root.analysis?.applied_items || [];
        const pruned = await (0, $fM8BY.pruneStaleApplied)(current, root.analysis?.suggestions);
        const next = [
            ...pruned,
            {
                bucket: bucket,
                fingerprint: fingerprint,
                target_id: String(targetId),
                applied_at: new Date().toISOString()
            }
        ];
        // migrated 2026-04-27 to SDK route workspaceProject.meet.analysisAppliedItems
        const roomId = root.activeRoomId;
        if (roomId) try {
            await (0, $bfqVY.getSDK)().execute('workspaceProject.meet.analysisAppliedItems', 'update', {
                roomId: roomId,
                payload: {
                    applied_items: next
                }
            });
            root.update({
                analysis: {
                    ...root.analysis,
                    applied_items: next
                }
            });
        } catch (err) {
            console.warn('[applySuggestion] applied_items write failed', err?.message || err);
        }
    } catch (err) {
        console.warn('[applySuggestion] applied_items write skipped', err);
    }
    // Do NOT router-navigate here — `this.router()` doesn't exist on plain
    // function contexts and would throw. The caller (the click handler in
    // MeetSuggestionCard) should drive navigation via el.router after this
    // function returns.
    return targetId;
};

});

parcelRegister("8oZGw", function(module, exports) {

$parcel$export(module.exports, "buildLivekitRoom", () => $019422bdcf298c77$export$f1b6c946a1d2d862);
// Wraps livekit-client's Room construction with the mode-aware simulcast
// config. Returns the Room instance (not yet connected — caller does
// room.connect(url, token) after wiring listeners). Browser-only — never
// imported from a server-side function.
//
// Mode-driven simulcast: dm publishes 1 layer, grid 2, stage 3. Publishing
// layers nobody subscribes to is pure upload + CPU waste, especially in DMs.

var $lGaRB = parcelRequire("lGaRB");

var $fM8BY = parcelRequire("fM8BY");
const $019422bdcf298c77$var$layersForMode = (mode)=>{
    if (mode === 'dm') return [
        (0, $lGaRB.VideoPresets).h720
    ];
    if (mode === 'grid') return [
        (0, $lGaRB.VideoPresets).h360,
        (0, $lGaRB.VideoPresets).h720
    ];
    return [
        (0, $lGaRB.VideoPresets).h180,
        (0, $lGaRB.VideoPresets).h360,
        (0, $lGaRB.VideoPresets).h720
    ] // stage
    ;
};
const $019422bdcf298c77$export$f1b6c946a1d2d862 = (initialParticipantCount = 1)=>{
    const mode = (0, $fM8BY.getRoomMode)(initialParticipantCount);
    return new (0, $lGaRB.Room)({
        adaptiveStream: true,
        dynacast: true,
        videoCaptureDefaults: {
            resolution: (0, $lGaRB.VideoPresets).h720.resolution
        },
        publishDefaults: {
            simulcast: mode !== 'dm',
            videoSimulcastLayers: $019422bdcf298c77$var$layersForMode(mode)
        }
    });
};

});
parcelRegister("lGaRB", function(module, exports) {

$parcel$export(module.exports, "RoomEvent", () => $c0722d30b1d17141$export$3159c672e3b2293a);
$parcel$export(module.exports, "VideoPresets", () => $c0722d30b1d17141$export$79d56065dad1674c);
$parcel$export(module.exports, "Room", () => $c0722d30b1d17141$export$525628e68e798fb4);
function $c0722d30b1d17141$var$_mergeNamespaces(n, m) {
    m.forEach(function(e) {
        e && typeof e !== 'string' && !Array.isArray(e) && Object.keys(e).forEach(function(k) {
            if (k !== 'default' && !(k in n)) {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function() {
                        return e[k];
                    }
                });
            }
        });
    });
    return Object.freeze(n);
}
var $c0722d30b1d17141$var$e = Object.defineProperty;
var $c0722d30b1d17141$var$h = (i, s, t)=>s in i ? $c0722d30b1d17141$var$e(i, s, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: t
    }) : i[s] = t;
var $c0722d30b1d17141$var$o = (i, s, t)=>$c0722d30b1d17141$var$h(i, typeof s != "symbol" ? s + "" : s, t);
class $c0722d30b1d17141$export$ca12f2943758ef55 {
    constructor(){
        $c0722d30b1d17141$var$o(this, "_locking");
        $c0722d30b1d17141$var$o(this, "_locks");
        this._locking = Promise.resolve(), this._locks = 0;
    }
    isLocked() {
        return this._locks > 0;
    }
    lock() {
        this._locks += 1;
        let s;
        const t = new Promise((l)=>s = ()=>{
                this._locks -= 1, l();
            }), c = this._locking.then(()=>s);
        return this._locking = this._locking.then(()=>t), c;
    }
} // Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Assert that condition is truthy or throw error (with message)
 */ function $c0722d30b1d17141$var$assert(condition, msg) {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- we want the implicit conversion to boolean
    if (!condition) throw new Error(msg);
}
const $c0722d30b1d17141$var$FLOAT32_MAX = 3.4028234663852886e38, $c0722d30b1d17141$var$FLOAT32_MIN = -340282346638528860000000000000000000000, $c0722d30b1d17141$var$UINT32_MAX = 0xffffffff, $c0722d30b1d17141$var$INT32_MAX = 0x7fffffff, $c0722d30b1d17141$var$INT32_MIN = -2147483648;
/**
 * Assert a valid signed protobuf 32-bit integer.
 */ function $c0722d30b1d17141$var$assertInt32(arg) {
    if (typeof arg !== "number") throw new Error("invalid int 32: " + typeof arg);
    if (!Number.isInteger(arg) || arg > $c0722d30b1d17141$var$INT32_MAX || arg < $c0722d30b1d17141$var$INT32_MIN) throw new Error("invalid int 32: " + arg); // eslint-disable-line @typescript-eslint/restrict-plus-operands -- we want the implicit conversion to string
}
/**
 * Assert a valid unsigned protobuf 32-bit integer.
 */ function $c0722d30b1d17141$var$assertUInt32(arg) {
    if (typeof arg !== "number") throw new Error("invalid uint 32: " + typeof arg);
    if (!Number.isInteger(arg) || arg > $c0722d30b1d17141$var$UINT32_MAX || arg < 0) throw new Error("invalid uint 32: " + arg); // eslint-disable-line @typescript-eslint/restrict-plus-operands -- we want the implicit conversion to string
}
/**
 * Assert a valid protobuf float value.
 */ function $c0722d30b1d17141$var$assertFloat32(arg) {
    if (typeof arg !== "number") throw new Error("invalid float 32: " + typeof arg);
    if (!Number.isFinite(arg)) return;
    if (arg > $c0722d30b1d17141$var$FLOAT32_MAX || arg < $c0722d30b1d17141$var$FLOAT32_MIN) throw new Error("invalid float 32: " + arg); // eslint-disable-line @typescript-eslint/restrict-plus-operands -- we want the implicit conversion to string
} // Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
const $c0722d30b1d17141$var$enumTypeSymbol = Symbol("@bufbuild/protobuf/enum-type");
/**
 * Get reflection information from a generated enum.
 * If this function is called on something other than a generated
 * enum, it raises an error.
 */ function $c0722d30b1d17141$var$getEnumType(enumObject) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-explicit-any
    const t = enumObject[$c0722d30b1d17141$var$enumTypeSymbol];
    $c0722d30b1d17141$var$assert(t, "missing enum type on enum object");
    return t; // eslint-disable-line @typescript-eslint/no-unsafe-return
}
/**
 * Sets reflection information on a generated enum.
 */ function $c0722d30b1d17141$var$setEnumType(enumObject, typeName, values, opt) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
    enumObject[$c0722d30b1d17141$var$enumTypeSymbol] = $c0722d30b1d17141$var$makeEnumType(typeName, values.map((v)=>({
            no: v.no,
            name: v.name,
            localName: enumObject[v.no]
        })));
}
/**
 * Create a new EnumType with the given values.
 */ function $c0722d30b1d17141$var$makeEnumType(typeName, values, // eslint-disable-next-line @typescript-eslint/no-unused-vars
_opt) {
    const names = Object.create(null);
    const numbers = Object.create(null);
    const normalValues = [];
    for (const value of values){
        // We do not surface options at this time
        // const value: EnumValueInfo = {...v, options: v.options ?? emptyReadonlyObject};
        const n = $c0722d30b1d17141$var$normalizeEnumValue(value);
        normalValues.push(n);
        names[value.name] = n;
        numbers[value.no] = n;
    }
    return {
        typeName: typeName,
        values: normalValues,
        // We do not surface options at this time
        // options: opt?.options ?? Object.create(null),
        findName (name) {
            return names[name];
        },
        findNumber (no) {
            return numbers[no];
        }
    };
}
/**
 * Create a new enum object with the given values.
 * Sets reflection information.
 */ function $c0722d30b1d17141$var$makeEnum(typeName, values, opt) {
    const enumObject = {};
    for (const value of values){
        const n = $c0722d30b1d17141$var$normalizeEnumValue(value);
        enumObject[n.localName] = n.no;
        enumObject[n.no] = n.localName;
    }
    $c0722d30b1d17141$var$setEnumType(enumObject, typeName, values);
    return enumObject;
}
function $c0722d30b1d17141$var$normalizeEnumValue(value) {
    if ("localName" in value) return value;
    return Object.assign(Object.assign({}, value), {
        localName: value.name
    });
} // Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Message is the base class of every message, generated, or created at
 * runtime.
 *
 * It is _not_ safe to extend this class. If you want to create a message at
 * run time, use proto3.makeMessageType().
 */ class $c0722d30b1d17141$var$Message {
    /**
   * Compare with a message of the same type.
   * Note that this function disregards extensions and unknown fields.
   */ equals(other) {
        return this.getType().runtime.util.equals(this.getType(), this, other);
    }
    /**
   * Create a deep copy.
   */ clone() {
        return this.getType().runtime.util.clone(this);
    }
    /**
   * Parse from binary data, merging fields.
   *
   * Repeated fields are appended. Map entries are added, overwriting
   * existing keys.
   *
   * If a message field is already present, it will be merged with the
   * new data.
   */ fromBinary(bytes, options) {
        const type = this.getType(), format = type.runtime.bin, opt = format.makeReadOptions(options);
        format.readMessage(this, opt.readerFactory(bytes), bytes.byteLength, opt);
        return this;
    }
    /**
   * Parse a message from a JSON value.
   */ fromJson(jsonValue, options) {
        const type = this.getType(), format = type.runtime.json, opt = format.makeReadOptions(options);
        format.readMessage(type, jsonValue, opt, this);
        return this;
    }
    /**
   * Parse a message from a JSON string.
   */ fromJsonString(jsonString, options) {
        let json;
        try {
            json = JSON.parse(jsonString);
        } catch (e) {
            throw new Error("cannot decode ".concat(this.getType().typeName, " from JSON: ").concat(e instanceof Error ? e.message : String(e)));
        }
        return this.fromJson(json, options);
    }
    /**
   * Serialize the message to binary data.
   */ toBinary(options) {
        const type = this.getType(), bin = type.runtime.bin, opt = bin.makeWriteOptions(options), writer = opt.writerFactory();
        bin.writeMessage(this, writer, opt);
        return writer.finish();
    }
    /**
   * Serialize the message to a JSON value, a JavaScript value that can be
   * passed to JSON.stringify().
   */ toJson(options) {
        const type = this.getType(), json = type.runtime.json, opt = json.makeWriteOptions(options);
        return json.writeMessage(this, opt);
    }
    /**
   * Serialize the message to a JSON string.
   */ toJsonString(options) {
        var _a;
        const value = this.toJson(options);
        return JSON.stringify(value, null, (_a = options === null || options === void 0 ? void 0 : options.prettySpaces) !== null && _a !== void 0 ? _a : 0);
    }
    /**
   * Override for serialization behavior. This will be invoked when calling
   * JSON.stringify on this message (i.e. JSON.stringify(msg)).
   *
   * Note that this will not serialize google.protobuf.Any with a packed
   * message because the protobuf JSON format specifies that it needs to be
   * unpacked, and this is only possible with a type registry to look up the
   * message type.  As a result, attempting to serialize a message with this
   * type will throw an Error.
   *
   * This method is protected because you should not need to invoke it
   * directly -- instead use JSON.stringify or toJsonString for
   * stringified JSON.  Alternatively, if actual JSON is desired, you should
   * use toJson.
   */ toJSON() {
        return this.toJson({
            emitDefaultValues: true
        });
    }
    /**
   * Retrieve the MessageType of this message - a singleton that represents
   * the protobuf message declaration and provides metadata for reflection-
   * based operations.
   */ getType() {
        // Any class that extends Message _must_ provide a complete static
        // implementation of MessageType.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-return
        return Object.getPrototypeOf(this).constructor;
    }
} // Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Create a new message type using the given runtime.
 */ function $c0722d30b1d17141$var$makeMessageType(runtime, typeName, fields, opt) {
    var _a;
    const localName = (_a = opt === null || opt === void 0 ? void 0 : opt.localName) !== null && _a !== void 0 ? _a : typeName.substring(typeName.lastIndexOf(".") + 1);
    const type = {
        [localName]: function(data) {
            runtime.util.initFields(this);
            runtime.util.initPartial(data, this);
        }
    }[localName];
    Object.setPrototypeOf(type.prototype, new $c0722d30b1d17141$var$Message());
    Object.assign(type, {
        runtime: runtime,
        typeName: typeName,
        fields: runtime.util.newFieldList(fields),
        fromBinary (bytes, options) {
            return new type().fromBinary(bytes, options);
        },
        fromJson (jsonValue, options) {
            return new type().fromJson(jsonValue, options);
        },
        fromJsonString (jsonString, options) {
            return new type().fromJsonString(jsonString, options);
        },
        equals (a, b) {
            return runtime.util.equals(type, a, b);
        }
    });
    return type;
} // Copyright 2008 Google Inc.  All rights reserved.
//
// Redistribution and use in source and binary forms, with or without
// modification, are permitted provided that the following conditions are
// met:
//
// * Redistributions of source code must retain the above copyright
// notice, this list of conditions and the following disclaimer.
// * Redistributions in binary form must reproduce the above
// copyright notice, this list of conditions and the following disclaimer
// in the documentation and/or other materials provided with the
// distribution.
// * Neither the name of Google Inc. nor the names of its
// contributors may be used to endorse or promote products derived from
// this software without specific prior written permission.
//
// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
// "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
// LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
// A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
// OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
// SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
// LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
// DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
// THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
//
// Code generated by the Protocol Buffer compiler is owned by the owner
// of the input file used when generating it.  This code is not
// standalone and requires a support library to be linked with it.  This
// support library is itself covered by the above license.
/* eslint-disable prefer-const,@typescript-eslint/restrict-plus-operands */ /**
 * Read a 64 bit varint as two JS numbers.
 *
 * Returns tuple:
 * [0]: low bits
 * [1]: high bits
 *
 * Copyright 2008 Google Inc.  All rights reserved.
 *
 * See https://github.com/protocolbuffers/protobuf/blob/8a71927d74a4ce34efe2d8769fda198f52d20d12/js/experimental/runtime/kernel/buffer_decoder.js#L175
 */ function $c0722d30b1d17141$var$varint64read() {
    let lowBits = 0;
    let highBits = 0;
    for(let shift = 0; shift < 28; shift += 7){
        let b = this.buf[this.pos++];
        lowBits |= (b & 0x7f) << shift;
        if ((b & 0x80) == 0) {
            this.assertBounds();
            return [
                lowBits,
                highBits
            ];
        }
    }
    let middleByte = this.buf[this.pos++];
    // last four bits of the first 32 bit number
    lowBits |= (middleByte & 0x0f) << 28;
    // 3 upper bits are part of the next 32 bit number
    highBits = (middleByte & 0x70) >> 4;
    if ((middleByte & 0x80) == 0) {
        this.assertBounds();
        return [
            lowBits,
            highBits
        ];
    }
    for(let shift = 3; shift <= 31; shift += 7){
        let b = this.buf[this.pos++];
        highBits |= (b & 0x7f) << shift;
        if ((b & 0x80) == 0) {
            this.assertBounds();
            return [
                lowBits,
                highBits
            ];
        }
    }
    throw new Error("invalid varint");
}
/**
 * Write a 64 bit varint, given as two JS numbers, to the given bytes array.
 *
 * Copyright 2008 Google Inc.  All rights reserved.
 *
 * See https://github.com/protocolbuffers/protobuf/blob/8a71927d74a4ce34efe2d8769fda198f52d20d12/js/experimental/runtime/kernel/writer.js#L344
 */ function $c0722d30b1d17141$var$varint64write(lo, hi, bytes) {
    for(let i = 0; i < 28; i = i + 7){
        const shift = lo >>> i;
        const hasNext = !(shift >>> 7 == 0 && hi == 0);
        const byte = (hasNext ? shift | 0x80 : shift) & 0xff;
        bytes.push(byte);
        if (!hasNext) return;
    }
    const splitBits = lo >>> 28 & 0x0f | (hi & 0x07) << 4;
    const hasMoreBits = !(hi >> 3 == 0);
    bytes.push((hasMoreBits ? splitBits | 0x80 : splitBits) & 0xff);
    if (!hasMoreBits) return;
    for(let i = 3; i < 31; i = i + 7){
        const shift = hi >>> i;
        const hasNext = !(shift >>> 7 == 0);
        const byte = (hasNext ? shift | 0x80 : shift) & 0xff;
        bytes.push(byte);
        if (!hasNext) return;
    }
    bytes.push(hi >>> 31 & 0x01);
}
// constants for binary math
const $c0722d30b1d17141$var$TWO_PWR_32_DBL = 0x100000000;
/**
 * Parse decimal string of 64 bit integer value as two JS numbers.
 *
 * Copyright 2008 Google Inc.  All rights reserved.
 *
 * See https://github.com/protocolbuffers/protobuf-javascript/blob/a428c58273abad07c66071d9753bc4d1289de426/experimental/runtime/int64.js#L10
 */ function $c0722d30b1d17141$var$int64FromString(dec) {
    // Check for minus sign.
    const minus = dec[0] === "-";
    if (minus) dec = dec.slice(1);
    // Work 6 decimal digits at a time, acting like we're converting base 1e6
    // digits to binary. This is safe to do with floating point math because
    // Number.isSafeInteger(ALL_32_BITS * 1e6) == true.
    const base = 1e6;
    let lowBits = 0;
    let highBits = 0;
    function add1e6digit(begin, end) {
        // Note: Number('') is 0.
        const digit1e6 = Number(dec.slice(begin, end));
        highBits *= base;
        lowBits = lowBits * base + digit1e6;
        // Carry bits from lowBits to
        if (lowBits >= $c0722d30b1d17141$var$TWO_PWR_32_DBL) {
            highBits = highBits + (lowBits / $c0722d30b1d17141$var$TWO_PWR_32_DBL | 0);
            lowBits = lowBits % $c0722d30b1d17141$var$TWO_PWR_32_DBL;
        }
    }
    add1e6digit(-24, -18);
    add1e6digit(-18, -12);
    add1e6digit(-12, -6);
    add1e6digit(-6);
    return minus ? $c0722d30b1d17141$var$negate(lowBits, highBits) : $c0722d30b1d17141$var$newBits(lowBits, highBits);
}
/**
 * Losslessly converts a 64-bit signed integer in 32:32 split representation
 * into a decimal string.
 *
 * Copyright 2008 Google Inc.  All rights reserved.
 *
 * See https://github.com/protocolbuffers/protobuf-javascript/blob/a428c58273abad07c66071d9753bc4d1289de426/experimental/runtime/int64.js#L10
 */ function $c0722d30b1d17141$var$int64ToString(lo, hi) {
    let bits = $c0722d30b1d17141$var$newBits(lo, hi);
    // If we're treating the input as a signed value and the high bit is set, do
    // a manual two's complement conversion before the decimal conversion.
    const negative = bits.hi & 0x80000000;
    if (negative) bits = $c0722d30b1d17141$var$negate(bits.lo, bits.hi);
    const result = $c0722d30b1d17141$var$uInt64ToString(bits.lo, bits.hi);
    return negative ? "-" + result : result;
}
/**
 * Losslessly converts a 64-bit unsigned integer in 32:32 split representation
 * into a decimal string.
 *
 * Copyright 2008 Google Inc.  All rights reserved.
 *
 * See https://github.com/protocolbuffers/protobuf-javascript/blob/a428c58273abad07c66071d9753bc4d1289de426/experimental/runtime/int64.js#L10
 */ function $c0722d30b1d17141$var$uInt64ToString(lo, hi) {
    ({ lo: lo, hi: hi } = $c0722d30b1d17141$var$toUnsigned(lo, hi));
    // Skip the expensive conversion if the number is small enough to use the
    // built-in conversions.
    // Number.MAX_SAFE_INTEGER = 0x001FFFFF FFFFFFFF, thus any number with
    // highBits <= 0x1FFFFF can be safely expressed with a double and retain
    // integer precision.
    // Proven by: Number.isSafeInteger(0x1FFFFF * 2**32 + 0xFFFFFFFF) == true.
    if (hi <= 0x1FFFFF) return String($c0722d30b1d17141$var$TWO_PWR_32_DBL * hi + lo);
    // What this code is doing is essentially converting the input number from
    // base-2 to base-1e7, which allows us to represent the 64-bit range with
    // only 3 (very large) digits. Those digits are then trivial to convert to
    // a base-10 string.
    // The magic numbers used here are -
    // 2^24 = 16777216 = (1,6777216) in base-1e7.
    // 2^48 = 281474976710656 = (2,8147497,6710656) in base-1e7.
    // Split 32:32 representation into 16:24:24 representation so our
    // intermediate digits don't overflow.
    const low = lo & 0xFFFFFF;
    const mid = (lo >>> 24 | hi << 8) & 0xFFFFFF;
    const high = hi >> 16 & 0xFFFF;
    // Assemble our three base-1e7 digits, ignoring carries. The maximum
    // value in a digit at this step is representable as a 48-bit integer, which
    // can be stored in a 64-bit floating point number.
    let digitA = low + mid * 6777216 + high * 6710656;
    let digitB = mid + high * 8147497;
    let digitC = high * 2;
    // Apply carries from A to B and from B to C.
    const base = 10000000;
    if (digitA >= base) {
        digitB += Math.floor(digitA / base);
        digitA %= base;
    }
    if (digitB >= base) {
        digitC += Math.floor(digitB / base);
        digitB %= base;
    }
    // If digitC is 0, then we should have returned in the trivial code path
    // at the top for non-safe integers. Given this, we can assume both digitB
    // and digitA need leading zeros.
    return digitC.toString() + $c0722d30b1d17141$var$decimalFrom1e7WithLeadingZeros(digitB) + $c0722d30b1d17141$var$decimalFrom1e7WithLeadingZeros(digitA);
}
function $c0722d30b1d17141$var$toUnsigned(lo, hi) {
    return {
        lo: lo >>> 0,
        hi: hi >>> 0
    };
}
function $c0722d30b1d17141$var$newBits(lo, hi) {
    return {
        lo: lo | 0,
        hi: hi | 0
    };
}
/**
 * Returns two's compliment negation of input.
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Bitwise_Operators#Signed_32-bit_integers
 */ function $c0722d30b1d17141$var$negate(lowBits, highBits) {
    highBits = ~highBits;
    if (lowBits) lowBits = ~lowBits + 1;
    else // If lowBits is 0, then bitwise-not is 0xFFFFFFFF,
    // adding 1 to that, results in 0x100000000, which leaves
    // the low bits 0x0 and simply adds one to the high bits.
    highBits += 1;
    return $c0722d30b1d17141$var$newBits(lowBits, highBits);
}
/**
 * Returns decimal representation of digit1e7 with leading zeros.
 */ const $c0722d30b1d17141$var$decimalFrom1e7WithLeadingZeros = (digit1e7)=>{
    const partial = String(digit1e7);
    return "0000000".slice(partial.length) + partial;
};
/**
 * Write a 32 bit varint, signed or unsigned. Same as `varint64write(0, value, bytes)`
 *
 * Copyright 2008 Google Inc.  All rights reserved.
 *
 * See https://github.com/protocolbuffers/protobuf/blob/1b18833f4f2a2f681f4e4a25cdf3b0a43115ec26/js/binary/encoder.js#L144
 */ function $c0722d30b1d17141$var$varint32write(value, bytes) {
    if (value >= 0) {
        // write value as varint 32
        while(value > 0x7f){
            bytes.push(value & 0x7f | 0x80);
            value = value >>> 7;
        }
        bytes.push(value);
    } else {
        for(let i = 0; i < 9; i++){
            bytes.push(value & 127 | 128);
            value = value >> 7;
        }
        bytes.push(1);
    }
}
/**
 * Read an unsigned 32 bit varint.
 *
 * See https://github.com/protocolbuffers/protobuf/blob/8a71927d74a4ce34efe2d8769fda198f52d20d12/js/experimental/runtime/kernel/buffer_decoder.js#L220
 */ function $c0722d30b1d17141$var$varint32read() {
    let b = this.buf[this.pos++];
    let result = b & 0x7f;
    if ((b & 0x80) == 0) {
        this.assertBounds();
        return result;
    }
    b = this.buf[this.pos++];
    result |= (b & 0x7f) << 7;
    if ((b & 0x80) == 0) {
        this.assertBounds();
        return result;
    }
    b = this.buf[this.pos++];
    result |= (b & 0x7f) << 14;
    if ((b & 0x80) == 0) {
        this.assertBounds();
        return result;
    }
    b = this.buf[this.pos++];
    result |= (b & 0x7f) << 21;
    if ((b & 0x80) == 0) {
        this.assertBounds();
        return result;
    }
    // Extract only last 4 bits
    b = this.buf[this.pos++];
    result |= (b & 0x0f) << 28;
    for(let readBytes = 5; (b & 0x80) !== 0 && readBytes < 10; readBytes++)b = this.buf[this.pos++];
    if ((b & 0x80) != 0) throw new Error("invalid varint");
    this.assertBounds();
    // Result can have 32 bits, convert it to unsigned
    return result >>> 0;
} // Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
function $c0722d30b1d17141$var$makeInt64Support() {
    const dv = new DataView(new ArrayBuffer(8));
    // note that Safari 14 implements BigInt, but not the DataView methods
    const ok = typeof BigInt === "function" && typeof dv.getBigInt64 === "function" && typeof dv.getBigUint64 === "function" && typeof dv.setBigInt64 === "function" && typeof dv.setBigUint64 === "function" && true;
    if (ok) {
        const MIN = BigInt("-9223372036854775808"), MAX = BigInt("9223372036854775807"), UMIN = BigInt("0"), UMAX = BigInt("18446744073709551615");
        return {
            zero: BigInt(0),
            supported: true,
            parse (value) {
                const bi = typeof value == "bigint" ? value : BigInt(value);
                if (bi > MAX || bi < MIN) throw new Error("int64 invalid: ".concat(value));
                return bi;
            },
            uParse (value) {
                const bi = typeof value == "bigint" ? value : BigInt(value);
                if (bi > UMAX || bi < UMIN) throw new Error("uint64 invalid: ".concat(value));
                return bi;
            },
            enc (value) {
                dv.setBigInt64(0, this.parse(value), true);
                return {
                    lo: dv.getInt32(0, true),
                    hi: dv.getInt32(4, true)
                };
            },
            uEnc (value) {
                dv.setBigInt64(0, this.uParse(value), true);
                return {
                    lo: dv.getInt32(0, true),
                    hi: dv.getInt32(4, true)
                };
            },
            dec (lo, hi) {
                dv.setInt32(0, lo, true);
                dv.setInt32(4, hi, true);
                return dv.getBigInt64(0, true);
            },
            uDec (lo, hi) {
                dv.setInt32(0, lo, true);
                dv.setInt32(4, hi, true);
                return dv.getBigUint64(0, true);
            }
        };
    }
    const assertInt64String = (value)=>$c0722d30b1d17141$var$assert(/^-?[0-9]+$/.test(value), "int64 invalid: ".concat(value));
    const assertUInt64String = (value)=>$c0722d30b1d17141$var$assert(/^[0-9]+$/.test(value), "uint64 invalid: ".concat(value));
    return {
        zero: "0",
        supported: false,
        parse (value) {
            if (typeof value != "string") value = value.toString();
            assertInt64String(value);
            return value;
        },
        uParse (value) {
            if (typeof value != "string") value = value.toString();
            assertUInt64String(value);
            return value;
        },
        enc (value) {
            if (typeof value != "string") value = value.toString();
            assertInt64String(value);
            return $c0722d30b1d17141$var$int64FromString(value);
        },
        uEnc (value) {
            if (typeof value != "string") value = value.toString();
            assertUInt64String(value);
            return $c0722d30b1d17141$var$int64FromString(value);
        },
        dec (lo, hi) {
            return $c0722d30b1d17141$var$int64ToString(lo, hi);
        },
        uDec (lo, hi) {
            return $c0722d30b1d17141$var$uInt64ToString(lo, hi);
        }
    };
}
const $c0722d30b1d17141$var$protoInt64 = $c0722d30b1d17141$var$makeInt64Support(); // Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Scalar value types. This is a subset of field types declared by protobuf
 * enum google.protobuf.FieldDescriptorProto.Type The types GROUP and MESSAGE
 * are omitted, but the numerical values are identical.
 */ var $c0722d30b1d17141$var$ScalarType;
(function(ScalarType) {
    // 0 is reserved for errors.
    // Order is weird for historical reasons.
    ScalarType[ScalarType["DOUBLE"] = 1] = "DOUBLE";
    ScalarType[ScalarType["FLOAT"] = 2] = "FLOAT";
    // Not ZigZag encoded.  Negative numbers take 10 bytes.  Use TYPE_SINT64 if
    // negative values are likely.
    ScalarType[ScalarType["INT64"] = 3] = "INT64";
    ScalarType[ScalarType["UINT64"] = 4] = "UINT64";
    // Not ZigZag encoded.  Negative numbers take 10 bytes.  Use TYPE_SINT32 if
    // negative values are likely.
    ScalarType[ScalarType["INT32"] = 5] = "INT32";
    ScalarType[ScalarType["FIXED64"] = 6] = "FIXED64";
    ScalarType[ScalarType["FIXED32"] = 7] = "FIXED32";
    ScalarType[ScalarType["BOOL"] = 8] = "BOOL";
    ScalarType[ScalarType["STRING"] = 9] = "STRING";
    // Tag-delimited aggregate.
    // Group type is deprecated and not supported in proto3. However, Proto3
    // implementations should still be able to parse the group wire format and
    // treat group fields as unknown fields.
    // TYPE_GROUP = 10,
    // TYPE_MESSAGE = 11,  // Length-delimited aggregate.
    // New in version 2.
    ScalarType[ScalarType["BYTES"] = 12] = "BYTES";
    ScalarType[ScalarType["UINT32"] = 13] = "UINT32";
    // TYPE_ENUM = 14,
    ScalarType[ScalarType["SFIXED32"] = 15] = "SFIXED32";
    ScalarType[ScalarType["SFIXED64"] = 16] = "SFIXED64";
    ScalarType[ScalarType["SINT32"] = 17] = "SINT32";
    ScalarType[ScalarType["SINT64"] = 18] = "SINT64";
})($c0722d30b1d17141$var$ScalarType || ($c0722d30b1d17141$var$ScalarType = {}));
/**
 * JavaScript representation of fields with 64 bit integral types (int64, uint64,
 * sint64, fixed64, sfixed64).
 *
 * This is a subset of google.protobuf.FieldOptions.JSType, which defines JS_NORMAL,
 * JS_STRING, and JS_NUMBER. Protobuf-ES uses BigInt by default, but will use
 * String if `[jstype = JS_STRING]` is specified.
 *
 * ```protobuf
 * uint64 field_a = 1; // BigInt
 * uint64 field_b = 2 [jstype = JS_NORMAL]; // BigInt
 * uint64 field_b = 2 [jstype = JS_NUMBER]; // BigInt
 * uint64 field_b = 2 [jstype = JS_STRING]; // String
 * ```
 */ var $c0722d30b1d17141$var$LongType;
(function(LongType) {
    /**
   * Use JavaScript BigInt.
   */ LongType[LongType["BIGINT"] = 0] = "BIGINT";
    /**
   * Use JavaScript String.
   *
   * Field option `[jstype = JS_STRING]`.
   */ LongType[LongType["STRING"] = 1] = "STRING";
})($c0722d30b1d17141$var$LongType || ($c0722d30b1d17141$var$LongType = {})); // Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Returns true if both scalar values are equal.
 */ function $c0722d30b1d17141$var$scalarEquals(type, a, b) {
    if (a === b) // This correctly matches equal values except BYTES and (possibly) 64-bit integers.
    return true;
    // Special case BYTES - we need to compare each byte individually
    if (type == $c0722d30b1d17141$var$ScalarType.BYTES) {
        if (!(a instanceof Uint8Array) || !(b instanceof Uint8Array)) return false;
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    // Special case 64-bit integers - we support number, string and bigint representation.
    // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
    switch(type){
        case $c0722d30b1d17141$var$ScalarType.UINT64:
        case $c0722d30b1d17141$var$ScalarType.FIXED64:
        case $c0722d30b1d17141$var$ScalarType.INT64:
        case $c0722d30b1d17141$var$ScalarType.SFIXED64:
        case $c0722d30b1d17141$var$ScalarType.SINT64:
            // Loose comparison will match between 0n, 0 and "0".
            return a == b;
    }
    // Anything that hasn't been caught by strict comparison or special cased
    // BYTES and 64-bit integers is not equal.
    return false;
}
/**
 * Returns the zero value for the given scalar type.
 */ function $c0722d30b1d17141$var$scalarZeroValue(type, longType) {
    switch(type){
        case $c0722d30b1d17141$var$ScalarType.BOOL:
            return false;
        case $c0722d30b1d17141$var$ScalarType.UINT64:
        case $c0722d30b1d17141$var$ScalarType.FIXED64:
        case $c0722d30b1d17141$var$ScalarType.INT64:
        case $c0722d30b1d17141$var$ScalarType.SFIXED64:
        case $c0722d30b1d17141$var$ScalarType.SINT64:
            // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison -- acceptable since it's covered by tests
            return longType == 0 ? $c0722d30b1d17141$var$protoInt64.zero : "0";
        case $c0722d30b1d17141$var$ScalarType.DOUBLE:
        case $c0722d30b1d17141$var$ScalarType.FLOAT:
            return 0.0;
        case $c0722d30b1d17141$var$ScalarType.BYTES:
            return new Uint8Array(0);
        case $c0722d30b1d17141$var$ScalarType.STRING:
            return "";
        default:
            // Handles INT32, UINT32, SINT32, FIXED32, SFIXED32.
            // We do not use individual cases to save a few bytes code size.
            return 0;
    }
}
/**
 * Returns true for a zero-value. For example, an integer has the zero-value `0`,
 * a boolean is `false`, a string is `""`, and bytes is an empty Uint8Array.
 *
 * In proto3, zero-values are not written to the wire, unless the field is
 * optional or repeated.
 */ function $c0722d30b1d17141$var$isScalarZeroValue(type, value) {
    switch(type){
        case $c0722d30b1d17141$var$ScalarType.BOOL:
            return value === false;
        case $c0722d30b1d17141$var$ScalarType.STRING:
            return value === "";
        case $c0722d30b1d17141$var$ScalarType.BYTES:
            return value instanceof Uint8Array && !value.byteLength;
        default:
            return value == 0;
    }
} // Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/* eslint-disable prefer-const,no-case-declarations,@typescript-eslint/restrict-plus-operands */ /**
 * Protobuf binary format wire types.
 *
 * A wire type provides just enough information to find the length of the
 * following value.
 *
 * See https://developers.google.com/protocol-buffers/docs/encoding#structure
 */ var $c0722d30b1d17141$var$WireType;
(function(WireType) {
    /**
   * Used for int32, int64, uint32, uint64, sint32, sint64, bool, enum
   */ WireType[WireType["Varint"] = 0] = "Varint";
    /**
   * Used for fixed64, sfixed64, double.
   * Always 8 bytes with little-endian byte order.
   */ WireType[WireType["Bit64"] = 1] = "Bit64";
    /**
   * Used for string, bytes, embedded messages, packed repeated fields
   *
   * Only repeated numeric types (types which use the varint, 32-bit,
   * or 64-bit wire types) can be packed. In proto3, such fields are
   * packed by default.
   */ WireType[WireType["LengthDelimited"] = 2] = "LengthDelimited";
    /**
   * Start of a tag-delimited aggregate, such as a proto2 group, or a message
   * in editions with message_encoding = DELIMITED.
   */ WireType[WireType["StartGroup"] = 3] = "StartGroup";
    /**
   * End of a tag-delimited aggregate.
   */ WireType[WireType["EndGroup"] = 4] = "EndGroup";
    /**
   * Used for fixed32, sfixed32, float.
   * Always 4 bytes with little-endian byte order.
   */ WireType[WireType["Bit32"] = 5] = "Bit32";
})($c0722d30b1d17141$var$WireType || ($c0722d30b1d17141$var$WireType = {}));
class $c0722d30b1d17141$var$BinaryWriter {
    constructor(textEncoder){
        /**
     * Previous fork states.
     */ this.stack = [];
        this.textEncoder = textEncoder !== null && textEncoder !== void 0 ? textEncoder : new TextEncoder();
        this.chunks = [];
        this.buf = [];
    }
    /**
   * Return all bytes written and reset this writer.
   */ finish() {
        this.chunks.push(new Uint8Array(this.buf)); // flush the buffer
        let len = 0;
        for(let i = 0; i < this.chunks.length; i++)len += this.chunks[i].length;
        let bytes = new Uint8Array(len);
        let offset = 0;
        for(let i = 0; i < this.chunks.length; i++){
            bytes.set(this.chunks[i], offset);
            offset += this.chunks[i].length;
        }
        this.chunks = [];
        return bytes;
    }
    /**
   * Start a new fork for length-delimited data like a message
   * or a packed repeated field.
   *
   * Must be joined later with `join()`.
   */ fork() {
        this.stack.push({
            chunks: this.chunks,
            buf: this.buf
        });
        this.chunks = [];
        this.buf = [];
        return this;
    }
    /**
   * Join the last fork. Write its length and bytes, then
   * return to the previous state.
   */ join() {
        // get chunk of fork
        let chunk = this.finish();
        // restore previous state
        let prev = this.stack.pop();
        if (!prev) throw new Error("invalid state, fork stack empty");
        this.chunks = prev.chunks;
        this.buf = prev.buf;
        // write length of chunk as varint
        this.uint32(chunk.byteLength);
        return this.raw(chunk);
    }
    /**
   * Writes a tag (field number and wire type).
   *
   * Equivalent to `uint32( (fieldNo << 3 | type) >>> 0 )`.
   *
   * Generated code should compute the tag ahead of time and call `uint32()`.
   */ tag(fieldNo, type) {
        return this.uint32((fieldNo << 3 | type) >>> 0);
    }
    /**
   * Write a chunk of raw bytes.
   */ raw(chunk) {
        if (this.buf.length) {
            this.chunks.push(new Uint8Array(this.buf));
            this.buf = [];
        }
        this.chunks.push(chunk);
        return this;
    }
    /**
   * Write a `uint32` value, an unsigned 32 bit varint.
   */ uint32(value) {
        $c0722d30b1d17141$var$assertUInt32(value);
        // write value as varint 32, inlined for speed
        while(value > 0x7f){
            this.buf.push(value & 0x7f | 0x80);
            value = value >>> 7;
        }
        this.buf.push(value);
        return this;
    }
    /**
   * Write a `int32` value, a signed 32 bit varint.
   */ int32(value) {
        $c0722d30b1d17141$var$assertInt32(value);
        $c0722d30b1d17141$var$varint32write(value, this.buf);
        return this;
    }
    /**
   * Write a `bool` value, a variant.
   */ bool(value) {
        this.buf.push(value ? 1 : 0);
        return this;
    }
    /**
   * Write a `bytes` value, length-delimited arbitrary data.
   */ bytes(value) {
        this.uint32(value.byteLength); // write length of chunk as varint
        return this.raw(value);
    }
    /**
   * Write a `string` value, length-delimited data converted to UTF-8 text.
   */ string(value) {
        let chunk = this.textEncoder.encode(value);
        this.uint32(chunk.byteLength); // write length of chunk as varint
        return this.raw(chunk);
    }
    /**
   * Write a `float` value, 32-bit floating point number.
   */ float(value) {
        $c0722d30b1d17141$var$assertFloat32(value);
        let chunk = new Uint8Array(4);
        new DataView(chunk.buffer).setFloat32(0, value, true);
        return this.raw(chunk);
    }
    /**
   * Write a `double` value, a 64-bit floating point number.
   */ double(value) {
        let chunk = new Uint8Array(8);
        new DataView(chunk.buffer).setFloat64(0, value, true);
        return this.raw(chunk);
    }
    /**
   * Write a `fixed32` value, an unsigned, fixed-length 32-bit integer.
   */ fixed32(value) {
        $c0722d30b1d17141$var$assertUInt32(value);
        let chunk = new Uint8Array(4);
        new DataView(chunk.buffer).setUint32(0, value, true);
        return this.raw(chunk);
    }
    /**
   * Write a `sfixed32` value, a signed, fixed-length 32-bit integer.
   */ sfixed32(value) {
        $c0722d30b1d17141$var$assertInt32(value);
        let chunk = new Uint8Array(4);
        new DataView(chunk.buffer).setInt32(0, value, true);
        return this.raw(chunk);
    }
    /**
   * Write a `sint32` value, a signed, zigzag-encoded 32-bit varint.
   */ sint32(value) {
        $c0722d30b1d17141$var$assertInt32(value);
        // zigzag encode
        value = (value << 1 ^ value >> 31) >>> 0;
        $c0722d30b1d17141$var$varint32write(value, this.buf);
        return this;
    }
    /**
   * Write a `fixed64` value, a signed, fixed-length 64-bit integer.
   */ sfixed64(value) {
        let chunk = new Uint8Array(8), view = new DataView(chunk.buffer), tc = $c0722d30b1d17141$var$protoInt64.enc(value);
        view.setInt32(0, tc.lo, true);
        view.setInt32(4, tc.hi, true);
        return this.raw(chunk);
    }
    /**
   * Write a `fixed64` value, an unsigned, fixed-length 64 bit integer.
   */ fixed64(value) {
        let chunk = new Uint8Array(8), view = new DataView(chunk.buffer), tc = $c0722d30b1d17141$var$protoInt64.uEnc(value);
        view.setInt32(0, tc.lo, true);
        view.setInt32(4, tc.hi, true);
        return this.raw(chunk);
    }
    /**
   * Write a `int64` value, a signed 64-bit varint.
   */ int64(value) {
        let tc = $c0722d30b1d17141$var$protoInt64.enc(value);
        $c0722d30b1d17141$var$varint64write(tc.lo, tc.hi, this.buf);
        return this;
    }
    /**
   * Write a `sint64` value, a signed, zig-zag-encoded 64-bit varint.
   */ sint64(value) {
        let tc = $c0722d30b1d17141$var$protoInt64.enc(value), // zigzag encode
        sign = tc.hi >> 31, lo = tc.lo << 1 ^ sign, hi = (tc.hi << 1 | tc.lo >>> 31) ^ sign;
        $c0722d30b1d17141$var$varint64write(lo, hi, this.buf);
        return this;
    }
    /**
   * Write a `uint64` value, an unsigned 64-bit varint.
   */ uint64(value) {
        let tc = $c0722d30b1d17141$var$protoInt64.uEnc(value);
        $c0722d30b1d17141$var$varint64write(tc.lo, tc.hi, this.buf);
        return this;
    }
}
class $c0722d30b1d17141$var$BinaryReader {
    constructor(buf, textDecoder){
        this.varint64 = $c0722d30b1d17141$var$varint64read; // dirty cast for `this`
        /**
     * Read a `uint32` field, an unsigned 32 bit varint.
     */ this.uint32 = $c0722d30b1d17141$var$varint32read; // dirty cast for `this` and access to protected `buf`
        this.buf = buf;
        this.len = buf.length;
        this.pos = 0;
        this.view = new DataView(buf.buffer, buf.byteOffset, buf.byteLength);
        this.textDecoder = textDecoder !== null && textDecoder !== void 0 ? textDecoder : new TextDecoder();
    }
    /**
   * Reads a tag - field number and wire type.
   */ tag() {
        let tag = this.uint32(), fieldNo = tag >>> 3, wireType = tag & 7;
        if (fieldNo <= 0 || wireType < 0 || wireType > 5) throw new Error("illegal tag: field no " + fieldNo + " wire type " + wireType);
        return [
            fieldNo,
            wireType
        ];
    }
    /**
   * Skip one element and return the skipped data.
   *
   * When skipping StartGroup, provide the tags field number to check for
   * matching field number in the EndGroup tag.
   */ skip(wireType, fieldNo) {
        let start = this.pos;
        switch(wireType){
            case $c0722d30b1d17141$var$WireType.Varint:
                while(this.buf[this.pos++] & 0x80);
                break;
            // eslint-disable-next-line
            // @ts-ignore TS7029: Fallthrough case in switch
            case $c0722d30b1d17141$var$WireType.Bit64:
                this.pos += 4;
            // eslint-disable-next-line
            // @ts-ignore TS7029: Fallthrough case in switch
            case $c0722d30b1d17141$var$WireType.Bit32:
                this.pos += 4;
                break;
            case $c0722d30b1d17141$var$WireType.LengthDelimited:
                let len = this.uint32();
                this.pos += len;
                break;
            case $c0722d30b1d17141$var$WireType.StartGroup:
                for(;;){
                    const [fn, wt] = this.tag();
                    if (wt === $c0722d30b1d17141$var$WireType.EndGroup) {
                        if (fieldNo !== undefined && fn !== fieldNo) throw new Error("invalid end group tag");
                        break;
                    }
                    this.skip(wt, fn);
                }
                break;
            default:
                throw new Error("cant skip wire type " + wireType);
        }
        this.assertBounds();
        return this.buf.subarray(start, this.pos);
    }
    /**
   * Throws error if position in byte array is out of range.
   */ assertBounds() {
        if (this.pos > this.len) throw new RangeError("premature EOF");
    }
    /**
   * Read a `int32` field, a signed 32 bit varint.
   */ int32() {
        return this.uint32() | 0;
    }
    /**
   * Read a `sint32` field, a signed, zigzag-encoded 32-bit varint.
   */ sint32() {
        let zze = this.uint32();
        // decode zigzag
        return zze >>> 1 ^ -(zze & 1);
    }
    /**
   * Read a `int64` field, a signed 64-bit varint.
   */ int64() {
        return $c0722d30b1d17141$var$protoInt64.dec(...this.varint64());
    }
    /**
   * Read a `uint64` field, an unsigned 64-bit varint.
   */ uint64() {
        return $c0722d30b1d17141$var$protoInt64.uDec(...this.varint64());
    }
    /**
   * Read a `sint64` field, a signed, zig-zag-encoded 64-bit varint.
   */ sint64() {
        let [lo, hi] = this.varint64();
        // decode zig zag
        let s = -(lo & 1);
        lo = (lo >>> 1 | (hi & 1) << 31) ^ s;
        hi = hi >>> 1 ^ s;
        return $c0722d30b1d17141$var$protoInt64.dec(lo, hi);
    }
    /**
   * Read a `bool` field, a variant.
   */ bool() {
        let [lo, hi] = this.varint64();
        return lo !== 0 || hi !== 0;
    }
    /**
   * Read a `fixed32` field, an unsigned, fixed-length 32-bit integer.
   */ fixed32() {
        return this.view.getUint32((this.pos += 4) - 4, true);
    }
    /**
   * Read a `sfixed32` field, a signed, fixed-length 32-bit integer.
   */ sfixed32() {
        return this.view.getInt32((this.pos += 4) - 4, true);
    }
    /**
   * Read a `fixed64` field, an unsigned, fixed-length 64 bit integer.
   */ fixed64() {
        return $c0722d30b1d17141$var$protoInt64.uDec(this.sfixed32(), this.sfixed32());
    }
    /**
   * Read a `fixed64` field, a signed, fixed-length 64-bit integer.
   */ sfixed64() {
        return $c0722d30b1d17141$var$protoInt64.dec(this.sfixed32(), this.sfixed32());
    }
    /**
   * Read a `float` field, 32-bit floating point number.
   */ float() {
        return this.view.getFloat32((this.pos += 4) - 4, true);
    }
    /**
   * Read a `double` field, a 64-bit floating point number.
   */ double() {
        return this.view.getFloat64((this.pos += 8) - 8, true);
    }
    /**
   * Read a `bytes` field, length-delimited arbitrary data.
   */ bytes() {
        let len = this.uint32(), start = this.pos;
        this.pos += len;
        this.assertBounds();
        return this.buf.subarray(start, start + len);
    }
    /**
   * Read a `string` field, length-delimited data converted to UTF-8 text.
   */ string() {
        return this.textDecoder.decode(this.bytes());
    }
} // Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Create a new extension using the given runtime.
 */ function $c0722d30b1d17141$var$makeExtension(runtime, typeName, extendee, field) {
    let fi;
    return {
        typeName: typeName,
        extendee: extendee,
        get field () {
            if (!fi) {
                const i = typeof field == "function" ? field() : field;
                i.name = typeName.split(".").pop();
                i.jsonName = "[".concat(typeName, "]");
                fi = runtime.util.newFieldList([
                    i
                ]).list()[0];
            }
            return fi;
        },
        runtime: runtime
    };
}
/**
 * Create a container that allows us to read extension fields into it with the
 * same logic as regular fields.
 */ function $c0722d30b1d17141$var$createExtensionContainer(extension) {
    const localName = extension.field.localName;
    const container = Object.create(null);
    container[localName] = $c0722d30b1d17141$var$initExtensionField(extension);
    return [
        container,
        ()=>container[localName]
    ];
}
function $c0722d30b1d17141$var$initExtensionField(ext) {
    const field = ext.field;
    if (field.repeated) return [];
    if (field.default !== undefined) return field.default;
    switch(field.kind){
        case "enum":
            return field.T.values[0].no;
        case "scalar":
            return $c0722d30b1d17141$var$scalarZeroValue(field.T, field.L);
        case "message":
            // eslint-disable-next-line no-case-declarations
            const T = field.T, value = new T();
            return T.fieldWrapper ? T.fieldWrapper.unwrapField(value) : value;
        case "map":
            throw "map fields are not allowed to be extensions";
    }
}
/**
 * Helper to filter unknown fields, optimized based on field type.
 */ function $c0722d30b1d17141$var$filterUnknownFields(unknownFields, field) {
    if (!field.repeated && (field.kind == "enum" || field.kind == "scalar")) {
        // singular scalar fields do not merge, we pick the last
        for(let i = unknownFields.length - 1; i >= 0; --i){
            if (unknownFields[i].no == field.no) return [
                unknownFields[i]
            ];
        }
        return [];
    }
    return unknownFields.filter((uf)=>uf.no === field.no);
} // Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/* eslint-disable @typescript-eslint/ban-ts-comment, @typescript-eslint/no-unnecessary-condition, prefer-const */ // lookup table from base64 character to byte
let $c0722d30b1d17141$var$encTable = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".split("");
// lookup table from base64 character *code* to byte because lookup by number is fast
let $c0722d30b1d17141$var$decTable = [];
for(let i = 0; i < $c0722d30b1d17141$var$encTable.length; i++)$c0722d30b1d17141$var$decTable[$c0722d30b1d17141$var$encTable[i].charCodeAt(0)] = i;
// support base64url variants
$c0722d30b1d17141$var$decTable["-".charCodeAt(0)] = $c0722d30b1d17141$var$encTable.indexOf("+");
$c0722d30b1d17141$var$decTable["_".charCodeAt(0)] = $c0722d30b1d17141$var$encTable.indexOf("/");
const $c0722d30b1d17141$var$protoBase64 = {
    /**
   * Decodes a base64 string to a byte array.
   *
   * - ignores white-space, including line breaks and tabs
   * - allows inner padding (can decode concatenated base64 strings)
   * - does not require padding
   * - understands base64url encoding:
   *   "-" instead of "+",
   *   "_" instead of "/",
   *   no padding
   */ dec (base64Str) {
        // estimate byte size, not accounting for inner padding and whitespace
        let es = base64Str.length * 3 / 4;
        if (base64Str[base64Str.length - 2] == "=") es -= 2;
        else if (base64Str[base64Str.length - 1] == "=") es -= 1;
        let bytes = new Uint8Array(es), bytePos = 0, // position in byte array
        groupPos = 0, // position in base64 group
        b, // current byte
        p = 0; // previous byte
        for(let i = 0; i < base64Str.length; i++){
            b = $c0722d30b1d17141$var$decTable[base64Str.charCodeAt(i)];
            if (b === undefined) switch(base64Str[i]){
                // @ts-ignore TS7029: Fallthrough case in switch
                case "=":
                    groupPos = 0;
                // reset state when padding found
                // @ts-ignore TS7029: Fallthrough case in switch
                case "\n":
                case "\r":
                case "\t":
                case " ":
                    continue;
                // skip white-space, and padding
                default:
                    throw Error("invalid base64 string.");
            }
            switch(groupPos){
                case 0:
                    p = b;
                    groupPos = 1;
                    break;
                case 1:
                    bytes[bytePos++] = p << 2 | (b & 48) >> 4;
                    p = b;
                    groupPos = 2;
                    break;
                case 2:
                    bytes[bytePos++] = (p & 15) << 4 | (b & 60) >> 2;
                    p = b;
                    groupPos = 3;
                    break;
                case 3:
                    bytes[bytePos++] = (p & 3) << 6 | b;
                    groupPos = 0;
                    break;
            }
        }
        if (groupPos == 1) throw Error("invalid base64 string.");
        return bytes.subarray(0, bytePos);
    },
    /**
   * Encode a byte array to a base64 string.
   */ enc (bytes) {
        let base64 = "", groupPos = 0, // position in base64 group
        b, // current byte
        p = 0; // carry over from previous byte
        for(let i = 0; i < bytes.length; i++){
            b = bytes[i];
            switch(groupPos){
                case 0:
                    base64 += $c0722d30b1d17141$var$encTable[b >> 2];
                    p = (b & 3) << 4;
                    groupPos = 1;
                    break;
                case 1:
                    base64 += $c0722d30b1d17141$var$encTable[p | b >> 4];
                    p = (b & 15) << 2;
                    groupPos = 2;
                    break;
                case 2:
                    base64 += $c0722d30b1d17141$var$encTable[p | b >> 6];
                    base64 += $c0722d30b1d17141$var$encTable[b & 63];
                    groupPos = 0;
                    break;
            }
        }
        // add output padding
        if (groupPos) {
            base64 += $c0722d30b1d17141$var$encTable[p];
            base64 += "=";
            if (groupPos == 1) base64 += "=";
        }
        return base64;
    }
}; // Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Retrieve an extension value from a message.
 *
 * The function never returns undefined. Use hasExtension() to check whether an
 * extension is set. If the extension is not set, this function returns the
 * default value (if one was specified in the protobuf source), or the zero value
 * (for example `0` for numeric types, `[]` for repeated extension fields, and
 * an empty message instance for message fields).
 *
 * Extensions are stored as unknown fields on a message. To mutate an extension
 * value, make sure to store the new value with setExtension() after mutating.
 *
 * If the extension does not extend the given message, an error is raised.
 */ function $c0722d30b1d17141$var$getExtension(message, extension, options) {
    $c0722d30b1d17141$var$assertExtendee(extension, message);
    const opt = extension.runtime.bin.makeReadOptions(options);
    const ufs = $c0722d30b1d17141$var$filterUnknownFields(message.getType().runtime.bin.listUnknownFields(message), extension.field);
    const [container, get] = $c0722d30b1d17141$var$createExtensionContainer(extension);
    for (const uf of ufs)extension.runtime.bin.readField(container, opt.readerFactory(uf.data), extension.field, uf.wireType, opt);
    return get();
}
/**
 * Set an extension value on a message. If the message already has a value for
 * this extension, the value is replaced.
 *
 * If the extension does not extend the given message, an error is raised.
 */ function $c0722d30b1d17141$var$setExtension(message, extension, value, options) {
    $c0722d30b1d17141$var$assertExtendee(extension, message);
    const readOpt = extension.runtime.bin.makeReadOptions(options);
    const writeOpt = extension.runtime.bin.makeWriteOptions(options);
    if ($c0722d30b1d17141$var$hasExtension(message, extension)) {
        const ufs = message.getType().runtime.bin.listUnknownFields(message).filter((uf)=>uf.no != extension.field.no);
        message.getType().runtime.bin.discardUnknownFields(message);
        for (const uf of ufs)message.getType().runtime.bin.onUnknownField(message, uf.no, uf.wireType, uf.data);
    }
    const writer = writeOpt.writerFactory();
    let f = extension.field;
    // Implicit presence does not apply to extensions, see https://github.com/protocolbuffers/protobuf/issues/8234
    // We patch the field info to use explicit presence:
    if (!f.opt && !f.repeated && (f.kind == "enum" || f.kind == "scalar")) f = Object.assign(Object.assign({}, extension.field), {
        opt: true
    });
    extension.runtime.bin.writeField(f, value, writer, writeOpt);
    const reader = readOpt.readerFactory(writer.finish());
    while(reader.pos < reader.len){
        const [no, wireType] = reader.tag();
        const data = reader.skip(wireType, no);
        message.getType().runtime.bin.onUnknownField(message, no, wireType, data);
    }
}
/**
 * Check whether an extension is set on a message.
 */ function $c0722d30b1d17141$var$hasExtension(message, extension) {
    const messageType = message.getType();
    return extension.extendee.typeName === messageType.typeName && !!messageType.runtime.bin.listUnknownFields(message).find((uf)=>uf.no == extension.field.no);
}
function $c0722d30b1d17141$var$assertExtendee(extension, message) {
    $c0722d30b1d17141$var$assert(extension.extendee.typeName == message.getType().typeName, "extension ".concat(extension.typeName, " can only be applied to message ").concat(extension.extendee.typeName));
} // Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Returns true if the field is set.
 */ function $c0722d30b1d17141$var$isFieldSet(field, target) {
    const localName = field.localName;
    if (field.repeated) return target[localName].length > 0;
    if (field.oneof) return target[field.oneof.localName].case === localName; // eslint-disable-line @typescript-eslint/no-unsafe-member-access
    switch(field.kind){
        case "enum":
        case "scalar":
            if (field.opt || field.req) // explicit presence
            return target[localName] !== undefined;
            // implicit presence
            if (field.kind == "enum") return target[localName] !== field.T.values[0].no;
            return !$c0722d30b1d17141$var$isScalarZeroValue(field.T, target[localName]);
        case "message":
            return target[localName] !== undefined;
        case "map":
            return Object.keys(target[localName]).length > 0;
    }
}
/**
 * Resets the field, so that isFieldSet() will return false.
 */ function $c0722d30b1d17141$var$clearField(field, target) {
    const localName = field.localName;
    const implicitPresence = !field.opt && !field.req;
    if (field.repeated) target[localName] = [];
    else if (field.oneof) target[field.oneof.localName] = {
        case: undefined
    };
    else switch(field.kind){
        case "map":
            target[localName] = {};
            break;
        case "enum":
            target[localName] = implicitPresence ? field.T.values[0].no : undefined;
            break;
        case "scalar":
            target[localName] = implicitPresence ? $c0722d30b1d17141$var$scalarZeroValue(field.T, field.L) : undefined;
            break;
        case "message":
            target[localName] = undefined;
            break;
    }
} // Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Check whether the given object is any subtype of Message or is a specific
 * Message by passing the type.
 *
 * Just like `instanceof`, `isMessage` narrows the type. The advantage of
 * `isMessage` is that it compares identity by the message type name, not by
 * class identity. This makes it robust against the dual package hazard and
 * similar situations, where the same message is duplicated.
 *
 * This function is _mostly_ equivalent to the `instanceof` operator. For
 * example, `isMessage(foo, MyMessage)` is the same as `foo instanceof MyMessage`,
 * and `isMessage(foo)` is the same as `foo instanceof Message`. In most cases,
 * `isMessage` should be preferred over `instanceof`.
 *
 * However, due to the fact that `isMessage` does not use class identity, there
 * are subtle differences between this function and `instanceof`. Notably,
 * calling `isMessage` on an explicit type of Message will return false.
 */ function $c0722d30b1d17141$var$isMessage(arg, type) {
    if (arg === null || typeof arg != "object") return false;
    if (!Object.getOwnPropertyNames($c0722d30b1d17141$var$Message.prototype).every((m)=>m in arg && typeof arg[m] == "function")) return false;
    const actualType = arg.getType();
    if (actualType === null || typeof actualType != "function" || !("typeName" in actualType) || typeof actualType.typeName != "string") return false;
    return type === undefined ? true : actualType.typeName == type.typeName;
} // Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Wrap a primitive message field value in its corresponding wrapper
 * message. This function is idempotent.
 */ function $c0722d30b1d17141$var$wrapField(type, value) {
    if ($c0722d30b1d17141$var$isMessage(value) || !type.fieldWrapper) return value;
    return type.fieldWrapper.wrapField(value);
}
$c0722d30b1d17141$var$ScalarType.DOUBLE, $c0722d30b1d17141$var$ScalarType.FLOAT, $c0722d30b1d17141$var$ScalarType.INT64, $c0722d30b1d17141$var$ScalarType.UINT64, $c0722d30b1d17141$var$ScalarType.INT32, $c0722d30b1d17141$var$ScalarType.UINT32, $c0722d30b1d17141$var$ScalarType.BOOL, $c0722d30b1d17141$var$ScalarType.STRING, $c0722d30b1d17141$var$ScalarType.BYTES; // Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/* eslint-disable no-case-declarations,@typescript-eslint/no-unsafe-argument,@typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-call */ // Default options for parsing JSON.
const $c0722d30b1d17141$var$jsonReadDefaults = {
    ignoreUnknownFields: false
};
// Default options for serializing to JSON.
const $c0722d30b1d17141$var$jsonWriteDefaults = {
    emitDefaultValues: false,
    enumAsInteger: false,
    useProtoFieldName: false,
    prettySpaces: 0
};
function $c0722d30b1d17141$var$makeReadOptions$1(options) {
    return options ? Object.assign(Object.assign({}, $c0722d30b1d17141$var$jsonReadDefaults), options) : $c0722d30b1d17141$var$jsonReadDefaults;
}
function $c0722d30b1d17141$var$makeWriteOptions$1(options) {
    return options ? Object.assign(Object.assign({}, $c0722d30b1d17141$var$jsonWriteDefaults), options) : $c0722d30b1d17141$var$jsonWriteDefaults;
}
const $c0722d30b1d17141$var$tokenNull = Symbol();
const $c0722d30b1d17141$var$tokenIgnoredUnknownEnum = Symbol();
function $c0722d30b1d17141$var$makeJsonFormat() {
    return {
        makeReadOptions: $c0722d30b1d17141$var$makeReadOptions$1,
        makeWriteOptions: $c0722d30b1d17141$var$makeWriteOptions$1,
        readMessage (type, json, options, message) {
            if (json == null || Array.isArray(json) || typeof json != "object") throw new Error("cannot decode message ".concat(type.typeName, " from JSON: ").concat($c0722d30b1d17141$var$debugJsonValue(json)));
            message = message !== null && message !== void 0 ? message : new type();
            const oneofSeen = new Map();
            const registry = options.typeRegistry;
            for (const [jsonKey, jsonValue] of Object.entries(json)){
                const field = type.fields.findJsonName(jsonKey);
                if (field) {
                    if (field.oneof) {
                        if (jsonValue === null && field.kind == "scalar") continue;
                        const seen = oneofSeen.get(field.oneof);
                        if (seen !== undefined) throw new Error("cannot decode message ".concat(type.typeName, " from JSON: multiple keys for oneof \"").concat(field.oneof.name, "\" present: \"").concat(seen, "\", \"").concat(jsonKey, "\""));
                        oneofSeen.set(field.oneof, jsonKey);
                    }
                    $c0722d30b1d17141$var$readField$1(message, jsonValue, field, options, type);
                } else {
                    let found = false;
                    if ((registry === null || registry === void 0 ? void 0 : registry.findExtension) && jsonKey.startsWith("[") && jsonKey.endsWith("]")) {
                        const ext = registry.findExtension(jsonKey.substring(1, jsonKey.length - 1));
                        if (ext && ext.extendee.typeName == type.typeName) {
                            found = true;
                            const [container, get] = $c0722d30b1d17141$var$createExtensionContainer(ext);
                            $c0722d30b1d17141$var$readField$1(container, jsonValue, ext.field, options, ext);
                            // We pass on the options as BinaryReadOptions/BinaryWriteOptions,
                            // so that users can bring their own binary reader and writer factories
                            // if necessary.
                            $c0722d30b1d17141$var$setExtension(message, ext, get(), options);
                        }
                    }
                    if (!found && !options.ignoreUnknownFields) throw new Error("cannot decode message ".concat(type.typeName, " from JSON: key \"").concat(jsonKey, "\" is unknown"));
                }
            }
            return message;
        },
        writeMessage (message, options) {
            const type = message.getType();
            const json = {};
            let field;
            try {
                for (field of type.fields.byNumber()){
                    if (!$c0722d30b1d17141$var$isFieldSet(field, message)) {
                        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                        if (field.req) throw "required field not set";
                        if (!options.emitDefaultValues) continue;
                        if (!$c0722d30b1d17141$var$canEmitFieldDefaultValue(field)) continue;
                    }
                    const value = field.oneof ? message[field.oneof.localName].value : message[field.localName];
                    const jsonValue = $c0722d30b1d17141$var$writeField$1(field, value, options);
                    if (jsonValue !== undefined) json[options.useProtoFieldName ? field.name : field.jsonName] = jsonValue;
                }
                const registry = options.typeRegistry;
                if (registry === null || registry === void 0 ? void 0 : registry.findExtensionFor) for (const uf of type.runtime.bin.listUnknownFields(message)){
                    const ext = registry.findExtensionFor(type.typeName, uf.no);
                    if (ext && $c0722d30b1d17141$var$hasExtension(message, ext)) {
                        // We pass on the options as BinaryReadOptions, so that users can bring their own
                        // binary reader factory if necessary.
                        const value = $c0722d30b1d17141$var$getExtension(message, ext, options);
                        const jsonValue = $c0722d30b1d17141$var$writeField$1(ext.field, value, options);
                        if (jsonValue !== undefined) json[ext.field.jsonName] = jsonValue;
                    }
                }
            } catch (e) {
                const m = field ? "cannot encode field ".concat(type.typeName, ".").concat(field.name, " to JSON") : "cannot encode message ".concat(type.typeName, " to JSON");
                const r = e instanceof Error ? e.message : String(e);
                throw new Error(m + (r.length > 0 ? ": ".concat(r) : ""));
            }
            return json;
        },
        readScalar (type, json, longType) {
            // The signature of our internal function has changed. For backwards-
            // compatibility, we support the old form that is part of the public API
            // through the interface JsonFormat.
            return $c0722d30b1d17141$var$readScalar$1(type, json, longType !== null && longType !== void 0 ? longType : $c0722d30b1d17141$var$LongType.BIGINT, true);
        },
        writeScalar (type, value, emitDefaultValues) {
            // The signature of our internal function has changed. For backwards-
            // compatibility, we support the old form that is part of the public API
            // through the interface JsonFormat.
            if (value === undefined) return undefined;
            if (emitDefaultValues || $c0722d30b1d17141$var$isScalarZeroValue(type, value)) return $c0722d30b1d17141$var$writeScalar$1(type, value);
            return undefined;
        },
        debug: $c0722d30b1d17141$var$debugJsonValue
    };
}
function $c0722d30b1d17141$var$debugJsonValue(json) {
    if (json === null) return "null";
    switch(typeof json){
        case "object":
            return Array.isArray(json) ? "array" : "object";
        case "string":
            return json.length > 100 ? "string" : "\"".concat(json.split('"').join('\\"'), "\"");
        default:
            return String(json);
    }
}
// Read a JSON value for a field.
// The "parentType" argument is only used to provide context in errors.
function $c0722d30b1d17141$var$readField$1(target, jsonValue, field, options, parentType) {
    let localName = field.localName;
    if (field.repeated) {
        $c0722d30b1d17141$var$assert(field.kind != "map");
        if (jsonValue === null) return;
        if (!Array.isArray(jsonValue)) throw new Error("cannot decode field ".concat(parentType.typeName, ".").concat(field.name, " from JSON: ").concat($c0722d30b1d17141$var$debugJsonValue(jsonValue)));
        const targetArray = target[localName];
        for (const jsonItem of jsonValue){
            if (jsonItem === null) throw new Error("cannot decode field ".concat(parentType.typeName, ".").concat(field.name, " from JSON: ").concat($c0722d30b1d17141$var$debugJsonValue(jsonItem)));
            switch(field.kind){
                case "message":
                    targetArray.push(field.T.fromJson(jsonItem, options));
                    break;
                case "enum":
                    const enumValue = $c0722d30b1d17141$var$readEnum(field.T, jsonItem, options.ignoreUnknownFields, true);
                    if (enumValue !== $c0722d30b1d17141$var$tokenIgnoredUnknownEnum) targetArray.push(enumValue);
                    break;
                case "scalar":
                    try {
                        targetArray.push($c0722d30b1d17141$var$readScalar$1(field.T, jsonItem, field.L, true));
                    } catch (e) {
                        let m = "cannot decode field ".concat(parentType.typeName, ".").concat(field.name, " from JSON: ").concat($c0722d30b1d17141$var$debugJsonValue(jsonItem));
                        if (e instanceof Error && e.message.length > 0) m += ": ".concat(e.message);
                        throw new Error(m);
                    }
                    break;
            }
        }
    } else if (field.kind == "map") {
        if (jsonValue === null) return;
        if (typeof jsonValue != "object" || Array.isArray(jsonValue)) throw new Error("cannot decode field ".concat(parentType.typeName, ".").concat(field.name, " from JSON: ").concat($c0722d30b1d17141$var$debugJsonValue(jsonValue)));
        const targetMap = target[localName];
        for (const [jsonMapKey, jsonMapValue] of Object.entries(jsonValue)){
            if (jsonMapValue === null) throw new Error("cannot decode field ".concat(parentType.typeName, ".").concat(field.name, " from JSON: map value null"));
            let key;
            try {
                key = $c0722d30b1d17141$var$readMapKey(field.K, jsonMapKey);
            } catch (e) {
                let m = "cannot decode map key for field ".concat(parentType.typeName, ".").concat(field.name, " from JSON: ").concat($c0722d30b1d17141$var$debugJsonValue(jsonValue));
                if (e instanceof Error && e.message.length > 0) m += ": ".concat(e.message);
                throw new Error(m);
            }
            switch(field.V.kind){
                case "message":
                    targetMap[key] = field.V.T.fromJson(jsonMapValue, options);
                    break;
                case "enum":
                    const enumValue = $c0722d30b1d17141$var$readEnum(field.V.T, jsonMapValue, options.ignoreUnknownFields, true);
                    if (enumValue !== $c0722d30b1d17141$var$tokenIgnoredUnknownEnum) targetMap[key] = enumValue;
                    break;
                case "scalar":
                    try {
                        targetMap[key] = $c0722d30b1d17141$var$readScalar$1(field.V.T, jsonMapValue, $c0722d30b1d17141$var$LongType.BIGINT, true);
                    } catch (e) {
                        let m = "cannot decode map value for field ".concat(parentType.typeName, ".").concat(field.name, " from JSON: ").concat($c0722d30b1d17141$var$debugJsonValue(jsonValue));
                        if (e instanceof Error && e.message.length > 0) m += ": ".concat(e.message);
                        throw new Error(m);
                    }
                    break;
            }
        }
    } else {
        if (field.oneof) {
            target = target[field.oneof.localName] = {
                case: localName
            };
            localName = "value";
        }
        switch(field.kind){
            case "message":
                const messageType = field.T;
                if (jsonValue === null && messageType.typeName != "google.protobuf.Value") return;
                let currentValue = target[localName];
                if ($c0722d30b1d17141$var$isMessage(currentValue)) currentValue.fromJson(jsonValue, options);
                else {
                    target[localName] = currentValue = messageType.fromJson(jsonValue, options);
                    if (messageType.fieldWrapper && !field.oneof) target[localName] = messageType.fieldWrapper.unwrapField(currentValue);
                }
                break;
            case "enum":
                const enumValue = $c0722d30b1d17141$var$readEnum(field.T, jsonValue, options.ignoreUnknownFields, false);
                switch(enumValue){
                    case $c0722d30b1d17141$var$tokenNull:
                        $c0722d30b1d17141$var$clearField(field, target);
                        break;
                    case $c0722d30b1d17141$var$tokenIgnoredUnknownEnum:
                        break;
                    default:
                        target[localName] = enumValue;
                        break;
                }
                break;
            case "scalar":
                try {
                    const scalarValue = $c0722d30b1d17141$var$readScalar$1(field.T, jsonValue, field.L, false);
                    switch(scalarValue){
                        case $c0722d30b1d17141$var$tokenNull:
                            $c0722d30b1d17141$var$clearField(field, target);
                            break;
                        default:
                            target[localName] = scalarValue;
                            break;
                    }
                } catch (e) {
                    let m = "cannot decode field ".concat(parentType.typeName, ".").concat(field.name, " from JSON: ").concat($c0722d30b1d17141$var$debugJsonValue(jsonValue));
                    if (e instanceof Error && e.message.length > 0) m += ": ".concat(e.message);
                    throw new Error(m);
                }
                break;
        }
    }
}
function $c0722d30b1d17141$var$readMapKey(type, json) {
    if (type === $c0722d30b1d17141$var$ScalarType.BOOL) // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
    switch(json){
        case "true":
            json = true;
            break;
        case "false":
            json = false;
            break;
    }
    return $c0722d30b1d17141$var$readScalar$1(type, json, $c0722d30b1d17141$var$LongType.BIGINT, true).toString();
}
function $c0722d30b1d17141$var$readScalar$1(type, json, longType, nullAsZeroValue) {
    if (json === null) {
        if (nullAsZeroValue) return $c0722d30b1d17141$var$scalarZeroValue(type, longType);
        return $c0722d30b1d17141$var$tokenNull;
    }
    // every valid case in the switch below returns, and every fall
    // through is regarded as a failure.
    switch(type){
        // float, double: JSON value will be a number or one of the special string values "NaN", "Infinity", and "-Infinity".
        // Either numbers or strings are accepted. Exponent notation is also accepted.
        case $c0722d30b1d17141$var$ScalarType.DOUBLE:
        case $c0722d30b1d17141$var$ScalarType.FLOAT:
            if (json === "NaN") return Number.NaN;
            if (json === "Infinity") return Number.POSITIVE_INFINITY;
            if (json === "-Infinity") return Number.NEGATIVE_INFINITY;
            if (json === "") break;
            if (typeof json == "string" && json.trim().length !== json.length) break;
            if (typeof json != "string" && typeof json != "number") break;
            const float = Number(json);
            if (Number.isNaN(float)) break;
            if (!Number.isFinite(float)) break;
            if (type == $c0722d30b1d17141$var$ScalarType.FLOAT) $c0722d30b1d17141$var$assertFloat32(float);
            return float;
        // int32, fixed32, uint32: JSON value will be a decimal number. Either numbers or strings are accepted.
        case $c0722d30b1d17141$var$ScalarType.INT32:
        case $c0722d30b1d17141$var$ScalarType.FIXED32:
        case $c0722d30b1d17141$var$ScalarType.SFIXED32:
        case $c0722d30b1d17141$var$ScalarType.SINT32:
        case $c0722d30b1d17141$var$ScalarType.UINT32:
            let int32;
            if (typeof json == "number") int32 = json;
            else if (typeof json == "string" && json.length > 0) {
                if (json.trim().length === json.length) int32 = Number(json);
            }
            if (int32 === undefined) break;
            if (type == $c0722d30b1d17141$var$ScalarType.UINT32 || type == $c0722d30b1d17141$var$ScalarType.FIXED32) $c0722d30b1d17141$var$assertUInt32(int32);
            else $c0722d30b1d17141$var$assertInt32(int32);
            return int32;
        // int64, fixed64, uint64: JSON value will be a decimal string. Either numbers or strings are accepted.
        case $c0722d30b1d17141$var$ScalarType.INT64:
        case $c0722d30b1d17141$var$ScalarType.SFIXED64:
        case $c0722d30b1d17141$var$ScalarType.SINT64:
            if (typeof json != "number" && typeof json != "string") break;
            const long = $c0722d30b1d17141$var$protoInt64.parse(json);
            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
            return longType ? long.toString() : long;
        case $c0722d30b1d17141$var$ScalarType.FIXED64:
        case $c0722d30b1d17141$var$ScalarType.UINT64:
            if (typeof json != "number" && typeof json != "string") break;
            const uLong = $c0722d30b1d17141$var$protoInt64.uParse(json);
            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
            return longType ? uLong.toString() : uLong;
        // bool:
        case $c0722d30b1d17141$var$ScalarType.BOOL:
            if (typeof json !== "boolean") break;
            return json;
        // string:
        case $c0722d30b1d17141$var$ScalarType.STRING:
            if (typeof json !== "string") break;
            // A string must always contain UTF-8 encoded or 7-bit ASCII.
            // We validate with encodeURIComponent, which appears to be the fastest widely available option.
            try {
                encodeURIComponent(json);
            } catch (e) {
                throw new Error("invalid UTF8");
            }
            return json;
        // bytes: JSON value will be the data encoded as a string using standard base64 encoding with paddings.
        // Either standard or URL-safe base64 encoding with/without paddings are accepted.
        case $c0722d30b1d17141$var$ScalarType.BYTES:
            if (json === "") return new Uint8Array(0);
            if (typeof json !== "string") break;
            return $c0722d30b1d17141$var$protoBase64.dec(json);
    }
    throw new Error();
}
function $c0722d30b1d17141$var$readEnum(type, json, ignoreUnknownFields, nullAsZeroValue) {
    if (json === null) {
        if (type.typeName == "google.protobuf.NullValue") return 0; // google.protobuf.NullValue.NULL_VALUE = 0
        return nullAsZeroValue ? type.values[0].no : $c0722d30b1d17141$var$tokenNull;
    }
    // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
    switch(typeof json){
        case "number":
            if (Number.isInteger(json)) return json;
            break;
        case "string":
            const value = type.findName(json);
            if (value !== undefined) return value.no;
            if (ignoreUnknownFields) return $c0722d30b1d17141$var$tokenIgnoredUnknownEnum;
            break;
    }
    throw new Error("cannot decode enum ".concat(type.typeName, " from JSON: ").concat($c0722d30b1d17141$var$debugJsonValue(json)));
}
// Decide whether an unset field should be emitted with JSON write option `emitDefaultValues`
function $c0722d30b1d17141$var$canEmitFieldDefaultValue(field) {
    if (field.repeated || field.kind == "map") // maps are {}, repeated fields are []
    return true;
    if (field.oneof) // oneof fields are never emitted
    return false;
    if (field.kind == "message") // singular message field are allowed to emit JSON null, but we do not
    return false;
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (field.opt || field.req) // the field uses explicit presence, so we cannot emit a zero value
    return false;
    return true;
}
function $c0722d30b1d17141$var$writeField$1(field, value, options) {
    if (field.kind == "map") {
        $c0722d30b1d17141$var$assert(typeof value == "object" && value != null);
        const jsonObj = {};
        const entries = Object.entries(value);
        switch(field.V.kind){
            case "scalar":
                for (const [entryKey, entryValue] of entries)jsonObj[entryKey.toString()] = $c0722d30b1d17141$var$writeScalar$1(field.V.T, entryValue); // JSON standard allows only (double quoted) string as property key
                break;
            case "message":
                for (const [entryKey, entryValue] of entries)// JSON standard allows only (double quoted) string as property key
                jsonObj[entryKey.toString()] = entryValue.toJson(options);
                break;
            case "enum":
                const enumType = field.V.T;
                for (const [entryKey, entryValue] of entries)// JSON standard allows only (double quoted) string as property key
                jsonObj[entryKey.toString()] = $c0722d30b1d17141$var$writeEnum(enumType, entryValue, options.enumAsInteger);
                break;
        }
        return options.emitDefaultValues || entries.length > 0 ? jsonObj : undefined;
    }
    if (field.repeated) {
        $c0722d30b1d17141$var$assert(Array.isArray(value));
        const jsonArr = [];
        switch(field.kind){
            case "scalar":
                for(let i = 0; i < value.length; i++)jsonArr.push($c0722d30b1d17141$var$writeScalar$1(field.T, value[i]));
                break;
            case "enum":
                for(let i = 0; i < value.length; i++)jsonArr.push($c0722d30b1d17141$var$writeEnum(field.T, value[i], options.enumAsInteger));
                break;
            case "message":
                for(let i = 0; i < value.length; i++)jsonArr.push(value[i].toJson(options));
                break;
        }
        return options.emitDefaultValues || jsonArr.length > 0 ? jsonArr : undefined;
    }
    switch(field.kind){
        case "scalar":
            return $c0722d30b1d17141$var$writeScalar$1(field.T, value);
        case "enum":
            return $c0722d30b1d17141$var$writeEnum(field.T, value, options.enumAsInteger);
        case "message":
            return $c0722d30b1d17141$var$wrapField(field.T, value).toJson(options);
    }
}
function $c0722d30b1d17141$var$writeEnum(type, value, enumAsInteger) {
    var _a;
    $c0722d30b1d17141$var$assert(typeof value == "number");
    if (type.typeName == "google.protobuf.NullValue") return null;
    if (enumAsInteger) return value;
    const val = type.findNumber(value);
    return (_a = val === null || val === void 0 ? void 0 : val.name) !== null && _a !== void 0 ? _a : value; // if we don't know the enum value, just return the number
}
function $c0722d30b1d17141$var$writeScalar$1(type, value) {
    switch(type){
        // int32, fixed32, uint32: JSON value will be a decimal number. Either numbers or strings are accepted.
        case $c0722d30b1d17141$var$ScalarType.INT32:
        case $c0722d30b1d17141$var$ScalarType.SFIXED32:
        case $c0722d30b1d17141$var$ScalarType.SINT32:
        case $c0722d30b1d17141$var$ScalarType.FIXED32:
        case $c0722d30b1d17141$var$ScalarType.UINT32:
            $c0722d30b1d17141$var$assert(typeof value == "number");
            return value;
        // float, double: JSON value will be a number or one of the special string values "NaN", "Infinity", and "-Infinity".
        // Either numbers or strings are accepted. Exponent notation is also accepted.
        case $c0722d30b1d17141$var$ScalarType.FLOAT:
        // assertFloat32(value);
        case $c0722d30b1d17141$var$ScalarType.DOUBLE:
            // eslint-disable-line no-fallthrough
            $c0722d30b1d17141$var$assert(typeof value == "number");
            if (Number.isNaN(value)) return "NaN";
            if (value === Number.POSITIVE_INFINITY) return "Infinity";
            if (value === Number.NEGATIVE_INFINITY) return "-Infinity";
            return value;
        // string:
        case $c0722d30b1d17141$var$ScalarType.STRING:
            $c0722d30b1d17141$var$assert(typeof value == "string");
            return value;
        // bool:
        case $c0722d30b1d17141$var$ScalarType.BOOL:
            $c0722d30b1d17141$var$assert(typeof value == "boolean");
            return value;
        // JSON value will be a decimal string. Either numbers or strings are accepted.
        case $c0722d30b1d17141$var$ScalarType.UINT64:
        case $c0722d30b1d17141$var$ScalarType.FIXED64:
        case $c0722d30b1d17141$var$ScalarType.INT64:
        case $c0722d30b1d17141$var$ScalarType.SFIXED64:
        case $c0722d30b1d17141$var$ScalarType.SINT64:
            $c0722d30b1d17141$var$assert(typeof value == "bigint" || typeof value == "string" || typeof value == "number");
            return value.toString();
        // bytes: JSON value will be the data encoded as a string using standard base64 encoding with paddings.
        // Either standard or URL-safe base64 encoding with/without paddings are accepted.
        case $c0722d30b1d17141$var$ScalarType.BYTES:
            $c0722d30b1d17141$var$assert(value instanceof Uint8Array);
            return $c0722d30b1d17141$var$protoBase64.enc(value);
    }
} // Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/* eslint-disable prefer-const,no-case-declarations,@typescript-eslint/no-explicit-any,@typescript-eslint/no-unsafe-argument,@typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-return */ const $c0722d30b1d17141$var$unknownFieldsSymbol = Symbol("@bufbuild/protobuf/unknown-fields");
// Default options for parsing binary data.
const $c0722d30b1d17141$var$readDefaults = {
    readUnknownFields: true,
    readerFactory: (bytes)=>new $c0722d30b1d17141$var$BinaryReader(bytes)
};
// Default options for serializing binary data.
const $c0722d30b1d17141$var$writeDefaults = {
    writeUnknownFields: true,
    writerFactory: ()=>new $c0722d30b1d17141$var$BinaryWriter()
};
function $c0722d30b1d17141$var$makeReadOptions(options) {
    return options ? Object.assign(Object.assign({}, $c0722d30b1d17141$var$readDefaults), options) : $c0722d30b1d17141$var$readDefaults;
}
function $c0722d30b1d17141$var$makeWriteOptions(options) {
    return options ? Object.assign(Object.assign({}, $c0722d30b1d17141$var$writeDefaults), options) : $c0722d30b1d17141$var$writeDefaults;
}
function $c0722d30b1d17141$var$makeBinaryFormat() {
    return {
        makeReadOptions: $c0722d30b1d17141$var$makeReadOptions,
        makeWriteOptions: $c0722d30b1d17141$var$makeWriteOptions,
        listUnknownFields (message) {
            var _a;
            return (_a = message[$c0722d30b1d17141$var$unknownFieldsSymbol]) !== null && _a !== void 0 ? _a : [];
        },
        discardUnknownFields (message) {
            delete message[$c0722d30b1d17141$var$unknownFieldsSymbol];
        },
        writeUnknownFields (message, writer) {
            const m = message;
            const c = m[$c0722d30b1d17141$var$unknownFieldsSymbol];
            if (c) for (const f of c)writer.tag(f.no, f.wireType).raw(f.data);
        },
        onUnknownField (message, no, wireType, data) {
            const m = message;
            if (!Array.isArray(m[$c0722d30b1d17141$var$unknownFieldsSymbol])) m[$c0722d30b1d17141$var$unknownFieldsSymbol] = [];
            m[$c0722d30b1d17141$var$unknownFieldsSymbol].push({
                no: no,
                wireType: wireType,
                data: data
            });
        },
        readMessage (message, reader, lengthOrEndTagFieldNo, options, delimitedMessageEncoding) {
            const type = message.getType();
            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
            const end = delimitedMessageEncoding ? reader.len : reader.pos + lengthOrEndTagFieldNo;
            let fieldNo, wireType;
            while(reader.pos < end){
                [fieldNo, wireType] = reader.tag();
                if (delimitedMessageEncoding === true && wireType == $c0722d30b1d17141$var$WireType.EndGroup) break;
                const field = type.fields.find(fieldNo);
                if (!field) {
                    const data = reader.skip(wireType, fieldNo);
                    if (options.readUnknownFields) this.onUnknownField(message, fieldNo, wireType, data);
                    continue;
                }
                $c0722d30b1d17141$var$readField(message, reader, field, wireType, options);
            }
            if (delimitedMessageEncoding && // eslint-disable-line @typescript-eslint/strict-boolean-expressions
            (wireType != $c0722d30b1d17141$var$WireType.EndGroup || fieldNo !== lengthOrEndTagFieldNo)) throw new Error("invalid end group tag");
        },
        readField: $c0722d30b1d17141$var$readField,
        writeMessage (message, writer, options) {
            const type = message.getType();
            for (const field of type.fields.byNumber()){
                if (!$c0722d30b1d17141$var$isFieldSet(field, message)) {
                    if (field.req) throw new Error("cannot encode field ".concat(type.typeName, ".").concat(field.name, " to binary: required field not set"));
                    continue;
                }
                const value = field.oneof ? message[field.oneof.localName].value : message[field.localName];
                $c0722d30b1d17141$var$writeField(field, value, writer, options);
            }
            if (options.writeUnknownFields) this.writeUnknownFields(message, writer);
            return writer;
        },
        writeField (field, value, writer, options) {
            // The behavior of our internal function has changed, it does no longer
            // accept `undefined` values for singular scalar and map.
            // For backwards-compatibility, we support the old form that is part of
            // the public API through the interface BinaryFormat.
            if (value === undefined) return undefined;
            $c0722d30b1d17141$var$writeField(field, value, writer, options);
        }
    };
}
function $c0722d30b1d17141$var$readField(target, // eslint-disable-line @typescript-eslint/no-explicit-any -- `any` is the best choice for dynamic access
reader, field, wireType, options) {
    let { repeated: repeated, localName: localName } = field;
    if (field.oneof) {
        target = target[field.oneof.localName];
        if (target.case != localName) delete target.value;
        target.case = localName;
        localName = "value";
    }
    switch(field.kind){
        case "scalar":
        case "enum":
            const scalarType = field.kind == "enum" ? $c0722d30b1d17141$var$ScalarType.INT32 : field.T;
            let read = $c0722d30b1d17141$var$readScalar;
            // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison -- acceptable since it's covered by tests
            if (field.kind == "scalar" && field.L > 0) read = $c0722d30b1d17141$var$readScalarLTString;
            if (repeated) {
                let arr = target[localName]; // safe to assume presence of array, oneof cannot contain repeated values
                const isPacked = wireType == $c0722d30b1d17141$var$WireType.LengthDelimited && scalarType != $c0722d30b1d17141$var$ScalarType.STRING && scalarType != $c0722d30b1d17141$var$ScalarType.BYTES;
                if (isPacked) {
                    let e = reader.uint32() + reader.pos;
                    while(reader.pos < e)arr.push(read(reader, scalarType));
                } else arr.push(read(reader, scalarType));
            } else target[localName] = read(reader, scalarType);
            break;
        case "message":
            const messageType = field.T;
            if (repeated) // safe to assume presence of array, oneof cannot contain repeated values
            target[localName].push($c0722d30b1d17141$var$readMessageField(reader, new messageType(), options, field));
            else if ($c0722d30b1d17141$var$isMessage(target[localName])) $c0722d30b1d17141$var$readMessageField(reader, target[localName], options, field);
            else {
                target[localName] = $c0722d30b1d17141$var$readMessageField(reader, new messageType(), options, field);
                if (messageType.fieldWrapper && !field.oneof && !field.repeated) target[localName] = messageType.fieldWrapper.unwrapField(target[localName]);
            }
            break;
        case "map":
            let [mapKey, mapVal] = $c0722d30b1d17141$var$readMapEntry(field, reader, options);
            // safe to assume presence of map object, oneof cannot contain repeated values
            target[localName][mapKey] = mapVal;
            break;
    }
}
// Read a message, avoiding MessageType.fromBinary() to re-use the
// BinaryReadOptions and the IBinaryReader.
function $c0722d30b1d17141$var$readMessageField(reader, message, options, field) {
    const format = message.getType().runtime.bin;
    const delimited = field === null || field === void 0 ? void 0 : field.delimited;
    format.readMessage(message, reader, delimited ? field.no : reader.uint32(), // eslint-disable-line @typescript-eslint/strict-boolean-expressions
    options, delimited);
    return message;
}
// Read a map field, expecting key field = 1, value field = 2
function $c0722d30b1d17141$var$readMapEntry(field, reader, options) {
    const length = reader.uint32(), end = reader.pos + length;
    let key, val;
    while(reader.pos < end){
        const [fieldNo] = reader.tag();
        switch(fieldNo){
            case 1:
                key = $c0722d30b1d17141$var$readScalar(reader, field.K);
                break;
            case 2:
                switch(field.V.kind){
                    case "scalar":
                        val = $c0722d30b1d17141$var$readScalar(reader, field.V.T);
                        break;
                    case "enum":
                        val = reader.int32();
                        break;
                    case "message":
                        val = $c0722d30b1d17141$var$readMessageField(reader, new field.V.T(), options, undefined);
                        break;
                }
                break;
        }
    }
    if (key === undefined) key = $c0722d30b1d17141$var$scalarZeroValue(field.K, $c0722d30b1d17141$var$LongType.BIGINT);
    if (typeof key != "string" && typeof key != "number") key = key.toString();
    if (val === undefined) switch(field.V.kind){
        case "scalar":
            val = $c0722d30b1d17141$var$scalarZeroValue(field.V.T, $c0722d30b1d17141$var$LongType.BIGINT);
            break;
        case "enum":
            val = field.V.T.values[0].no;
            break;
        case "message":
            val = new field.V.T();
            break;
    }
    return [
        key,
        val
    ];
}
// Read a scalar value, but return 64 bit integral types (int64, uint64,
// sint64, fixed64, sfixed64) as string instead of bigint.
function $c0722d30b1d17141$var$readScalarLTString(reader, type) {
    const v = $c0722d30b1d17141$var$readScalar(reader, type);
    return typeof v == "bigint" ? v.toString() : v;
}
// Does not use scalarTypeInfo() for better performance.
function $c0722d30b1d17141$var$readScalar(reader, type) {
    switch(type){
        case $c0722d30b1d17141$var$ScalarType.STRING:
            return reader.string();
        case $c0722d30b1d17141$var$ScalarType.BOOL:
            return reader.bool();
        case $c0722d30b1d17141$var$ScalarType.DOUBLE:
            return reader.double();
        case $c0722d30b1d17141$var$ScalarType.FLOAT:
            return reader.float();
        case $c0722d30b1d17141$var$ScalarType.INT32:
            return reader.int32();
        case $c0722d30b1d17141$var$ScalarType.INT64:
            return reader.int64();
        case $c0722d30b1d17141$var$ScalarType.UINT64:
            return reader.uint64();
        case $c0722d30b1d17141$var$ScalarType.FIXED64:
            return reader.fixed64();
        case $c0722d30b1d17141$var$ScalarType.BYTES:
            return reader.bytes();
        case $c0722d30b1d17141$var$ScalarType.FIXED32:
            return reader.fixed32();
        case $c0722d30b1d17141$var$ScalarType.SFIXED32:
            return reader.sfixed32();
        case $c0722d30b1d17141$var$ScalarType.SFIXED64:
            return reader.sfixed64();
        case $c0722d30b1d17141$var$ScalarType.SINT64:
            return reader.sint64();
        case $c0722d30b1d17141$var$ScalarType.UINT32:
            return reader.uint32();
        case $c0722d30b1d17141$var$ScalarType.SINT32:
            return reader.sint32();
    }
}
function $c0722d30b1d17141$var$writeField(field, value, writer, options) {
    $c0722d30b1d17141$var$assert(value !== undefined);
    const repeated = field.repeated;
    switch(field.kind){
        case "scalar":
        case "enum":
            let scalarType = field.kind == "enum" ? $c0722d30b1d17141$var$ScalarType.INT32 : field.T;
            if (repeated) {
                $c0722d30b1d17141$var$assert(Array.isArray(value));
                if (field.packed) $c0722d30b1d17141$var$writePacked(writer, scalarType, field.no, value);
                else for (const item of value)$c0722d30b1d17141$var$writeScalar(writer, scalarType, field.no, item);
            } else $c0722d30b1d17141$var$writeScalar(writer, scalarType, field.no, value);
            break;
        case "message":
            if (repeated) {
                $c0722d30b1d17141$var$assert(Array.isArray(value));
                for (const item of value)$c0722d30b1d17141$var$writeMessageField(writer, options, field, item);
            } else $c0722d30b1d17141$var$writeMessageField(writer, options, field, value);
            break;
        case "map":
            $c0722d30b1d17141$var$assert(typeof value == "object" && value != null);
            for (const [key, val] of Object.entries(value))$c0722d30b1d17141$var$writeMapEntry(writer, options, field, key, val);
            break;
    }
}
function $c0722d30b1d17141$var$writeMapEntry(writer, options, field, key, value) {
    writer.tag(field.no, $c0722d30b1d17141$var$WireType.LengthDelimited);
    writer.fork();
    // javascript only allows number or string for object properties
    // we convert from our representation to the protobuf type
    let keyValue = key;
    // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check -- we deliberately handle just the special cases for map keys
    switch(field.K){
        case $c0722d30b1d17141$var$ScalarType.INT32:
        case $c0722d30b1d17141$var$ScalarType.FIXED32:
        case $c0722d30b1d17141$var$ScalarType.UINT32:
        case $c0722d30b1d17141$var$ScalarType.SFIXED32:
        case $c0722d30b1d17141$var$ScalarType.SINT32:
            keyValue = Number.parseInt(key);
            break;
        case $c0722d30b1d17141$var$ScalarType.BOOL:
            $c0722d30b1d17141$var$assert(key == "true" || key == "false");
            keyValue = key == "true";
            break;
    }
    // write key, expecting key field number = 1
    $c0722d30b1d17141$var$writeScalar(writer, field.K, 1, keyValue);
    // write value, expecting value field number = 2
    switch(field.V.kind){
        case "scalar":
            $c0722d30b1d17141$var$writeScalar(writer, field.V.T, 2, value);
            break;
        case "enum":
            $c0722d30b1d17141$var$writeScalar(writer, $c0722d30b1d17141$var$ScalarType.INT32, 2, value);
            break;
        case "message":
            $c0722d30b1d17141$var$assert(value !== undefined);
            writer.tag(2, $c0722d30b1d17141$var$WireType.LengthDelimited).bytes(value.toBinary(options));
            break;
    }
    writer.join();
}
// Value must not be undefined
function $c0722d30b1d17141$var$writeMessageField(writer, options, field, value) {
    const message = $c0722d30b1d17141$var$wrapField(field.T, value);
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (field.delimited) writer.tag(field.no, $c0722d30b1d17141$var$WireType.StartGroup).raw(message.toBinary(options)).tag(field.no, $c0722d30b1d17141$var$WireType.EndGroup);
    else writer.tag(field.no, $c0722d30b1d17141$var$WireType.LengthDelimited).bytes(message.toBinary(options));
}
function $c0722d30b1d17141$var$writeScalar(writer, type, fieldNo, value) {
    $c0722d30b1d17141$var$assert(value !== undefined);
    let [wireType, method] = $c0722d30b1d17141$var$scalarTypeInfo(type);
    writer.tag(fieldNo, wireType)[method](value);
}
function $c0722d30b1d17141$var$writePacked(writer, type, fieldNo, value) {
    if (!value.length) return;
    writer.tag(fieldNo, $c0722d30b1d17141$var$WireType.LengthDelimited).fork();
    let [, method] = $c0722d30b1d17141$var$scalarTypeInfo(type);
    for(let i = 0; i < value.length; i++)writer[method](value[i]);
    writer.join();
}
/**
 * Get information for writing a scalar value.
 *
 * Returns tuple:
 * [0]: appropriate WireType
 * [1]: name of the appropriate method of IBinaryWriter
 * [2]: whether the given value is a default value for proto3 semantics
 *
 * If argument `value` is omitted, [2] is always false.
 */ // TODO replace call-sites writeScalar() and writePacked(), then remove
function $c0722d30b1d17141$var$scalarTypeInfo(type) {
    let wireType = $c0722d30b1d17141$var$WireType.Varint;
    // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check -- INT32, UINT32, SINT32 are covered by the defaults
    switch(type){
        case $c0722d30b1d17141$var$ScalarType.BYTES:
        case $c0722d30b1d17141$var$ScalarType.STRING:
            wireType = $c0722d30b1d17141$var$WireType.LengthDelimited;
            break;
        case $c0722d30b1d17141$var$ScalarType.DOUBLE:
        case $c0722d30b1d17141$var$ScalarType.FIXED64:
        case $c0722d30b1d17141$var$ScalarType.SFIXED64:
            wireType = $c0722d30b1d17141$var$WireType.Bit64;
            break;
        case $c0722d30b1d17141$var$ScalarType.FIXED32:
        case $c0722d30b1d17141$var$ScalarType.SFIXED32:
        case $c0722d30b1d17141$var$ScalarType.FLOAT:
            wireType = $c0722d30b1d17141$var$WireType.Bit32;
            break;
    }
    const method = $c0722d30b1d17141$var$ScalarType[type].toLowerCase();
    return [
        wireType,
        method
    ];
} // Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/* eslint-disable @typescript-eslint/no-explicit-any,@typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-return,@typescript-eslint/no-unsafe-argument,no-case-declarations */ function $c0722d30b1d17141$var$makeUtilCommon() {
    return {
        setEnumType: $c0722d30b1d17141$var$setEnumType,
        initPartial (source, target) {
            if (source === undefined) return;
            const type = target.getType();
            for (const member of type.fields.byMember()){
                const localName = member.localName, t = target, s = source;
                if (s[localName] == null) continue;
                switch(member.kind){
                    case "oneof":
                        const sk = s[localName].case;
                        if (sk === undefined) continue;
                        const sourceField = member.findField(sk);
                        let val = s[localName].value;
                        if (sourceField && sourceField.kind == "message" && !$c0722d30b1d17141$var$isMessage(val, sourceField.T)) val = new sourceField.T(val);
                        else if (sourceField && sourceField.kind === "scalar" && sourceField.T === $c0722d30b1d17141$var$ScalarType.BYTES) val = $c0722d30b1d17141$var$toU8Arr(val);
                        t[localName] = {
                            case: sk,
                            value: val
                        };
                        break;
                    case "scalar":
                    case "enum":
                        let copy = s[localName];
                        if (member.T === $c0722d30b1d17141$var$ScalarType.BYTES) copy = member.repeated ? copy.map($c0722d30b1d17141$var$toU8Arr) : $c0722d30b1d17141$var$toU8Arr(copy);
                        t[localName] = copy;
                        break;
                    case "map":
                        switch(member.V.kind){
                            case "scalar":
                            case "enum":
                                if (member.V.T === $c0722d30b1d17141$var$ScalarType.BYTES) for (const [k, v] of Object.entries(s[localName]))t[localName][k] = $c0722d30b1d17141$var$toU8Arr(v);
                                else Object.assign(t[localName], s[localName]);
                                break;
                            case "message":
                                const messageType = member.V.T;
                                for (const k of Object.keys(s[localName])){
                                    let val = s[localName][k];
                                    if (!messageType.fieldWrapper) // We only take partial input for messages that are not a wrapper type.
                                    // For those messages, we recursively normalize the partial input.
                                    val = new messageType(val);
                                    t[localName][k] = val;
                                }
                                break;
                        }
                        break;
                    case "message":
                        const mt = member.T;
                        if (member.repeated) t[localName] = s[localName].map((val)=>$c0722d30b1d17141$var$isMessage(val, mt) ? val : new mt(val));
                        else {
                            const val = s[localName];
                            if (mt.fieldWrapper) {
                                if (// We can't use BytesValue.typeName as that will create a circular import
                                mt.typeName === "google.protobuf.BytesValue") t[localName] = $c0722d30b1d17141$var$toU8Arr(val);
                                else t[localName] = val;
                            } else t[localName] = $c0722d30b1d17141$var$isMessage(val, mt) ? val : new mt(val);
                        }
                        break;
                }
            }
        },
        // TODO use isFieldSet() here to support future field presence
        equals (type, a, b) {
            if (a === b) return true;
            if (!a || !b) return false;
            return type.fields.byMember().every((m)=>{
                const va = a[m.localName];
                const vb = b[m.localName];
                if (m.repeated) {
                    if (va.length !== vb.length) return false;
                    // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check -- repeated fields are never "map"
                    switch(m.kind){
                        case "message":
                            return va.every((a, i)=>m.T.equals(a, vb[i]));
                        case "scalar":
                            return va.every((a, i)=>$c0722d30b1d17141$var$scalarEquals(m.T, a, vb[i]));
                        case "enum":
                            return va.every((a, i)=>$c0722d30b1d17141$var$scalarEquals($c0722d30b1d17141$var$ScalarType.INT32, a, vb[i]));
                    }
                    throw new Error("repeated cannot contain ".concat(m.kind));
                }
                switch(m.kind){
                    case "message":
                        let a1 = va;
                        let b1 = vb;
                        if (m.T.fieldWrapper) {
                            if (a1 !== undefined && !$c0722d30b1d17141$var$isMessage(a1)) a1 = m.T.fieldWrapper.wrapField(a1);
                            if (b1 !== undefined && !$c0722d30b1d17141$var$isMessage(b1)) b1 = m.T.fieldWrapper.wrapField(b1);
                        }
                        return m.T.equals(a1, b1);
                    case "enum":
                        return $c0722d30b1d17141$var$scalarEquals($c0722d30b1d17141$var$ScalarType.INT32, va, vb);
                    case "scalar":
                        return $c0722d30b1d17141$var$scalarEquals(m.T, va, vb);
                    case "oneof":
                        if (va.case !== vb.case) return false;
                        const s = m.findField(va.case);
                        if (s === undefined) return true;
                        // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check -- oneof fields are never "map"
                        switch(s.kind){
                            case "message":
                                return s.T.equals(va.value, vb.value);
                            case "enum":
                                return $c0722d30b1d17141$var$scalarEquals($c0722d30b1d17141$var$ScalarType.INT32, va.value, vb.value);
                            case "scalar":
                                return $c0722d30b1d17141$var$scalarEquals(s.T, va.value, vb.value);
                        }
                        throw new Error("oneof cannot contain ".concat(s.kind));
                    case "map":
                        const keys = Object.keys(va).concat(Object.keys(vb));
                        switch(m.V.kind){
                            case "message":
                                const messageType = m.V.T;
                                return keys.every((k)=>messageType.equals(va[k], vb[k]));
                            case "enum":
                                return keys.every((k)=>$c0722d30b1d17141$var$scalarEquals($c0722d30b1d17141$var$ScalarType.INT32, va[k], vb[k]));
                            case "scalar":
                                const scalarType = m.V.T;
                                return keys.every((k)=>$c0722d30b1d17141$var$scalarEquals(scalarType, va[k], vb[k]));
                        }
                        break;
                }
            });
        },
        // TODO use isFieldSet() here to support future field presence
        clone (message) {
            const type = message.getType(), target = new type(), any = target;
            for (const member of type.fields.byMember()){
                const source = message[member.localName];
                let copy;
                if (member.repeated) copy = source.map($c0722d30b1d17141$var$cloneSingularField);
                else if (member.kind == "map") {
                    copy = any[member.localName];
                    for (const [key, v] of Object.entries(source))copy[key] = $c0722d30b1d17141$var$cloneSingularField(v);
                } else if (member.kind == "oneof") {
                    const f = member.findField(source.case);
                    copy = f ? {
                        case: source.case,
                        value: $c0722d30b1d17141$var$cloneSingularField(source.value)
                    } : {
                        case: undefined
                    };
                } else copy = $c0722d30b1d17141$var$cloneSingularField(source);
                any[member.localName] = copy;
            }
            for (const uf of type.runtime.bin.listUnknownFields(message))type.runtime.bin.onUnknownField(any, uf.no, uf.wireType, uf.data);
            return target;
        }
    };
}
// clone a single field value - i.e. the element type of repeated fields, the value type of maps
function $c0722d30b1d17141$var$cloneSingularField(value) {
    if (value === undefined) return value;
    if ($c0722d30b1d17141$var$isMessage(value)) return value.clone();
    if (value instanceof Uint8Array) {
        const c = new Uint8Array(value.byteLength);
        c.set(value);
        return c;
    }
    return value;
}
// converts any ArrayLike<number> to Uint8Array if necessary.
function $c0722d30b1d17141$var$toU8Arr(input) {
    return input instanceof Uint8Array ? input : new Uint8Array(input);
} // Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
function $c0722d30b1d17141$var$makeProtoRuntime(syntax, newFieldList, initFields) {
    return {
        syntax: syntax,
        json: $c0722d30b1d17141$var$makeJsonFormat(),
        bin: $c0722d30b1d17141$var$makeBinaryFormat(),
        util: Object.assign(Object.assign({}, $c0722d30b1d17141$var$makeUtilCommon()), {
            newFieldList: newFieldList,
            initFields: initFields
        }),
        makeMessageType (typeName, fields, opt) {
            return $c0722d30b1d17141$var$makeMessageType(this, typeName, fields, opt);
        },
        makeEnum: $c0722d30b1d17141$var$makeEnum,
        makeEnumType: $c0722d30b1d17141$var$makeEnumType,
        getEnumType: $c0722d30b1d17141$var$getEnumType,
        makeExtension (typeName, extendee, field) {
            return $c0722d30b1d17141$var$makeExtension(this, typeName, extendee, field);
        }
    };
} // Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
class $c0722d30b1d17141$var$InternalFieldList {
    constructor(fields, normalizer){
        this._fields = fields;
        this._normalizer = normalizer;
    }
    findJsonName(jsonName) {
        if (!this.jsonNames) {
            const t = {};
            for (const f of this.list())t[f.jsonName] = t[f.name] = f;
            this.jsonNames = t;
        }
        return this.jsonNames[jsonName];
    }
    find(fieldNo) {
        if (!this.numbers) {
            const t = {};
            for (const f of this.list())t[f.no] = f;
            this.numbers = t;
        }
        return this.numbers[fieldNo];
    }
    list() {
        if (!this.all) this.all = this._normalizer(this._fields);
        return this.all;
    }
    byNumber() {
        if (!this.numbersAsc) this.numbersAsc = this.list().concat().sort((a, b)=>a.no - b.no);
        return this.numbersAsc;
    }
    byMember() {
        if (!this.members) {
            this.members = [];
            const a = this.members;
            let o;
            for (const f of this.list()){
                if (f.oneof) {
                    if (f.oneof !== o) {
                        o = f.oneof;
                        a.push(o);
                    }
                } else a.push(f);
            }
        }
        return this.members;
    }
} // Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Returns the name of a protobuf element in generated code.
 *
 * Field names - including oneofs - are converted to lowerCamelCase. For
 * messages, enumerations and services, the package name is stripped from
 * the type name. For nested messages and enumerations, the names are joined
 * with an underscore. For methods, the first character is made lowercase.
 */ /**
 * Returns the name of a field in generated code.
 */ function $c0722d30b1d17141$var$localFieldName(protoName, inOneof) {
    const name = $c0722d30b1d17141$var$protoCamelCase(protoName);
    if (inOneof) // oneof member names are not properties, but values of the `case` property.
    return name;
    return $c0722d30b1d17141$var$safeObjectProperty($c0722d30b1d17141$var$safeMessageProperty(name));
}
/**
 * Returns the name of a oneof group in generated code.
 */ function $c0722d30b1d17141$var$localOneofName(protoName) {
    return $c0722d30b1d17141$var$localFieldName(protoName, false);
}
/**
 * Returns the JSON name for a protobuf field, exactly like protoc does.
 */ const $c0722d30b1d17141$var$fieldJsonName = $c0722d30b1d17141$var$protoCamelCase;
/**
 * Converts snake_case to protoCamelCase according to the convention
 * used by protoc to convert a field name to a JSON name.
 */ function $c0722d30b1d17141$var$protoCamelCase(snakeCase) {
    let capNext = false;
    const b = [];
    for(let i = 0; i < snakeCase.length; i++){
        let c = snakeCase.charAt(i);
        switch(c){
            case "_":
                capNext = true;
                break;
            case "0":
            case "1":
            case "2":
            case "3":
            case "4":
            case "5":
            case "6":
            case "7":
            case "8":
            case "9":
                b.push(c);
                capNext = false;
                break;
            default:
                if (capNext) {
                    capNext = false;
                    c = c.toUpperCase();
                }
                b.push(c);
                break;
        }
    }
    return b.join("");
}
/**
 * Names that cannot be used for object properties because they are reserved
 * by built-in JavaScript properties.
 */ const $c0722d30b1d17141$var$reservedObjectProperties = new Set([
    // names reserved by JavaScript
    "constructor",
    "toString",
    "toJSON",
    "valueOf"
]);
/**
 * Names that cannot be used for object properties because they are reserved
 * by the runtime.
 */ const $c0722d30b1d17141$var$reservedMessageProperties = new Set([
    // names reserved by the runtime
    "getType",
    "clone",
    "equals",
    "fromBinary",
    "fromJson",
    "fromJsonString",
    "toBinary",
    "toJson",
    "toJsonString",
    // names reserved by the runtime for the future
    "toObject"
]);
const $c0722d30b1d17141$var$fallback = (name)=>"".concat(name, "$");
/**
 * Will wrap names that are Object prototype properties or names reserved
 * for `Message`s.
 */ const $c0722d30b1d17141$var$safeMessageProperty = (name)=>{
    if ($c0722d30b1d17141$var$reservedMessageProperties.has(name)) return $c0722d30b1d17141$var$fallback(name);
    return name;
};
/**
 * Names that cannot be used for object properties because they are reserved
 * by built-in JavaScript properties.
 */ const $c0722d30b1d17141$var$safeObjectProperty = (name)=>{
    if ($c0722d30b1d17141$var$reservedObjectProperties.has(name)) return $c0722d30b1d17141$var$fallback(name);
    return name;
}; // Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
class $c0722d30b1d17141$var$InternalOneofInfo {
    constructor(name){
        this.kind = "oneof";
        this.repeated = false;
        this.packed = false;
        this.opt = false;
        this.req = false;
        this.default = undefined;
        this.fields = [];
        this.name = name;
        this.localName = $c0722d30b1d17141$var$localOneofName(name);
    }
    addField(field) {
        $c0722d30b1d17141$var$assert(field.oneof === this, "field ".concat(field.name, " not one of ").concat(this.name));
        this.fields.push(field);
    }
    findField(localName) {
        if (!this._lookup) {
            this._lookup = Object.create(null);
            for(let i = 0; i < this.fields.length; i++)this._lookup[this.fields[i].localName] = this.fields[i];
        }
        return this._lookup[localName];
    }
} // Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Convert a collection of field info to an array of normalized FieldInfo.
 *
 * The argument `packedByDefault` specifies whether fields that do not specify
 * `packed` should be packed (proto3) or unpacked (proto2).
 */ function $c0722d30b1d17141$var$normalizeFieldInfos(fieldInfos, packedByDefault) {
    var _a, _b, _c, _d, _e, _f;
    const r = [];
    let o;
    for (const field of typeof fieldInfos == "function" ? fieldInfos() : fieldInfos){
        const f = field;
        f.localName = $c0722d30b1d17141$var$localFieldName(field.name, field.oneof !== undefined);
        f.jsonName = (_a = field.jsonName) !== null && _a !== void 0 ? _a : $c0722d30b1d17141$var$fieldJsonName(field.name);
        f.repeated = (_b = field.repeated) !== null && _b !== void 0 ? _b : false;
        if (field.kind == "scalar") f.L = (_c = field.L) !== null && _c !== void 0 ? _c : $c0722d30b1d17141$var$LongType.BIGINT;
        f.delimited = (_d = field.delimited) !== null && _d !== void 0 ? _d : false;
        f.req = (_e = field.req) !== null && _e !== void 0 ? _e : false;
        f.opt = (_f = field.opt) !== null && _f !== void 0 ? _f : false;
        if (field.packed === undefined) f.packed = field.kind == "enum" || field.kind == "scalar" && field.T != $c0722d30b1d17141$var$ScalarType.BYTES && field.T != $c0722d30b1d17141$var$ScalarType.STRING;
        // We do not surface options at this time
        // f.options = field.options ?? emptyReadonlyObject;
        if (field.oneof !== undefined) {
            const ooname = typeof field.oneof == "string" ? field.oneof : field.oneof.name;
            if (!o || o.name != ooname) o = new $c0722d30b1d17141$var$InternalOneofInfo(ooname);
            f.oneof = o;
            o.addField(f);
        }
        r.push(f);
    }
    return r;
} // Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Provides functionality for messages defined with the proto3 syntax.
 */ const $c0722d30b1d17141$var$proto3 = $c0722d30b1d17141$var$makeProtoRuntime("proto3", (fields)=>{
    return new $c0722d30b1d17141$var$InternalFieldList(fields, (source)=>$c0722d30b1d17141$var$normalizeFieldInfos(source));
}, // TODO merge with proto2 and initExtensionField, also see initPartial, equals, clone
(target)=>{
    for (const member of target.getType().fields.byMember()){
        if (member.opt) continue;
        const name = member.localName, t = target;
        if (member.repeated) {
            t[name] = [];
            continue;
        }
        switch(member.kind){
            case "oneof":
                t[name] = {
                    case: undefined
                };
                break;
            case "enum":
                t[name] = 0;
                break;
            case "map":
                t[name] = {};
                break;
            case "scalar":
                t[name] = $c0722d30b1d17141$var$scalarZeroValue(member.T, member.L);
                break;
        }
    }
}); // Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * A Timestamp represents a point in time independent of any time zone or local
 * calendar, encoded as a count of seconds and fractions of seconds at
 * nanosecond resolution. The count is relative to an epoch at UTC midnight on
 * January 1, 1970, in the proleptic Gregorian calendar which extends the
 * Gregorian calendar backwards to year one.
 *
 * All minutes are 60 seconds long. Leap seconds are "smeared" so that no leap
 * second table is needed for interpretation, using a [24-hour linear
 * smear](https://developers.google.com/time/smear).
 *
 * The range is from 0001-01-01T00:00:00Z to 9999-12-31T23:59:59.999999999Z. By
 * restricting to that range, we ensure that we can convert to and from [RFC
 * 3339](https://www.ietf.org/rfc/rfc3339.txt) date strings.
 *
 * # Examples
 *
 * Example 1: Compute Timestamp from POSIX `time()`.
 *
 *     Timestamp timestamp;
 *     timestamp.set_seconds(time(NULL));
 *     timestamp.set_nanos(0);
 *
 * Example 2: Compute Timestamp from POSIX `gettimeofday()`.
 *
 *     struct timeval tv;
 *     gettimeofday(&tv, NULL);
 *
 *     Timestamp timestamp;
 *     timestamp.set_seconds(tv.tv_sec);
 *     timestamp.set_nanos(tv.tv_usec * 1000);
 *
 * Example 3: Compute Timestamp from Win32 `GetSystemTimeAsFileTime()`.
 *
 *     FILETIME ft;
 *     GetSystemTimeAsFileTime(&ft);
 *     UINT64 ticks = (((UINT64)ft.dwHighDateTime) << 32) | ft.dwLowDateTime;
 *
 *     // A Windows tick is 100 nanoseconds. Windows epoch 1601-01-01T00:00:00Z
 *     // is 11644473600 seconds before Unix epoch 1970-01-01T00:00:00Z.
 *     Timestamp timestamp;
 *     timestamp.set_seconds((INT64) ((ticks / 10000000) - 11644473600LL));
 *     timestamp.set_nanos((INT32) ((ticks % 10000000) * 100));
 *
 * Example 4: Compute Timestamp from Java `System.currentTimeMillis()`.
 *
 *     long millis = System.currentTimeMillis();
 *
 *     Timestamp timestamp = Timestamp.newBuilder().setSeconds(millis / 1000)
 *         .setNanos((int) ((millis % 1000) * 1000000)).build();
 *
 * Example 5: Compute Timestamp from Java `Instant.now()`.
 *
 *     Instant now = Instant.now();
 *
 *     Timestamp timestamp =
 *         Timestamp.newBuilder().setSeconds(now.getEpochSecond())
 *             .setNanos(now.getNano()).build();
 *
 * Example 6: Compute Timestamp from current time in Python.
 *
 *     timestamp = Timestamp()
 *     timestamp.GetCurrentTime()
 *
 * # JSON Mapping
 *
 * In JSON format, the Timestamp type is encoded as a string in the
 * [RFC 3339](https://www.ietf.org/rfc/rfc3339.txt) format. That is, the
 * format is "{year}-{month}-{day}T{hour}:{min}:{sec}[.{frac_sec}]Z"
 * where {year} is always expressed using four digits while {month}, {day},
 * {hour}, {min}, and {sec} are zero-padded to two digits each. The fractional
 * seconds, which can go up to 9 digits (i.e. up to 1 nanosecond resolution),
 * are optional. The "Z" suffix indicates the timezone ("UTC"); the timezone
 * is required. A proto3 JSON serializer should always use UTC (as indicated by
 * "Z") when printing the Timestamp type and a proto3 JSON parser should be
 * able to accept both UTC and other timezones (as indicated by an offset).
 *
 * For example, "2017-01-15T01:30:15.01Z" encodes 15.01 seconds past
 * 01:30 UTC on January 15, 2017.
 *
 * In JavaScript, one can convert a Date object to this format using the
 * standard
 * [toISOString()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString)
 * method. In Python, a standard `datetime.datetime` object can be converted
 * to this format using
 * [`strftime`](https://docs.python.org/2/library/time.html#time.strftime) with
 * the time format spec '%Y-%m-%dT%H:%M:%S.%fZ'. Likewise, in Java, one can use
 * the Joda Time's [`ISODateTimeFormat.dateTime()`](
 * http://joda-time.sourceforge.net/apidocs/org/joda/time/format/ISODateTimeFormat.html#dateTime()
 * ) to obtain a formatter capable of generating timestamps in this format.
 *
 *
 * @generated from message google.protobuf.Timestamp
 */ class $c0722d30b1d17141$var$Timestamp extends $c0722d30b1d17141$var$Message {
    constructor(data){
        super();
        /**
     * Represents seconds of UTC time since Unix epoch
     * 1970-01-01T00:00:00Z. Must be from 0001-01-01T00:00:00Z to
     * 9999-12-31T23:59:59Z inclusive.
     *
     * @generated from field: int64 seconds = 1;
     */ this.seconds = $c0722d30b1d17141$var$protoInt64.zero;
        /**
     * Non-negative fractions of a second at nanosecond resolution. Negative
     * second values with fractions must still have non-negative nanos values
     * that count forward in time. Must be from 0 to 999,999,999
     * inclusive.
     *
     * @generated from field: int32 nanos = 2;
     */ this.nanos = 0;
        $c0722d30b1d17141$var$proto3.util.initPartial(data, this);
    }
    fromJson(json, options) {
        if (typeof json !== "string") throw new Error("cannot decode google.protobuf.Timestamp from JSON: ".concat($c0722d30b1d17141$var$proto3.json.debug(json)));
        const matches = json.match(/^([0-9]{4})-([0-9]{2})-([0-9]{2})T([0-9]{2}):([0-9]{2}):([0-9]{2})(?:Z|\.([0-9]{3,9})Z|([+-][0-9][0-9]:[0-9][0-9]))$/);
        if (!matches) throw new Error("cannot decode google.protobuf.Timestamp from JSON: invalid RFC 3339 string");
        const ms = Date.parse(matches[1] + "-" + matches[2] + "-" + matches[3] + "T" + matches[4] + ":" + matches[5] + ":" + matches[6] + (matches[8] ? matches[8] : "Z"));
        if (Number.isNaN(ms)) throw new Error("cannot decode google.protobuf.Timestamp from JSON: invalid RFC 3339 string");
        if (ms < Date.parse("0001-01-01T00:00:00Z") || ms > Date.parse("9999-12-31T23:59:59Z")) throw new Error("cannot decode message google.protobuf.Timestamp from JSON: must be from 0001-01-01T00:00:00Z to 9999-12-31T23:59:59Z inclusive");
        this.seconds = $c0722d30b1d17141$var$protoInt64.parse(ms / 1000);
        this.nanos = 0;
        if (matches[7]) this.nanos = parseInt("1" + matches[7] + "0".repeat(9 - matches[7].length)) - 1000000000;
        return this;
    }
    toJson(options) {
        const ms = Number(this.seconds) * 1000;
        if (ms < Date.parse("0001-01-01T00:00:00Z") || ms > Date.parse("9999-12-31T23:59:59Z")) throw new Error("cannot encode google.protobuf.Timestamp to JSON: must be from 0001-01-01T00:00:00Z to 9999-12-31T23:59:59Z inclusive");
        if (this.nanos < 0) throw new Error("cannot encode google.protobuf.Timestamp to JSON: nanos must not be negative");
        let z = "Z";
        if (this.nanos > 0) {
            const nanosStr = (this.nanos + 1000000000).toString().substring(1);
            if (nanosStr.substring(3) === "000000") z = "." + nanosStr.substring(0, 3) + "Z";
            else if (nanosStr.substring(6) === "000") z = "." + nanosStr.substring(0, 6) + "Z";
            else z = "." + nanosStr + "Z";
        }
        return new Date(ms).toISOString().replace(".000Z", z);
    }
    toDate() {
        return new Date(Number(this.seconds) * 1000 + Math.ceil(this.nanos / 1000000));
    }
    static now() {
        return $c0722d30b1d17141$var$Timestamp.fromDate(new Date());
    }
    static fromDate(date) {
        const ms = date.getTime();
        return new $c0722d30b1d17141$var$Timestamp({
            seconds: $c0722d30b1d17141$var$protoInt64.parse(Math.floor(ms / 1000)),
            nanos: ms % 1000 * 1000000
        });
    }
    static fromBinary(bytes, options) {
        return new $c0722d30b1d17141$var$Timestamp().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new $c0722d30b1d17141$var$Timestamp().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new $c0722d30b1d17141$var$Timestamp().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return $c0722d30b1d17141$var$proto3.util.equals($c0722d30b1d17141$var$Timestamp, a, b);
    }
}
$c0722d30b1d17141$var$Timestamp.runtime = $c0722d30b1d17141$var$proto3;
$c0722d30b1d17141$var$Timestamp.typeName = "google.protobuf.Timestamp";
$c0722d30b1d17141$var$Timestamp.fields = $c0722d30b1d17141$var$proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "seconds",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 2,
            name: "nanos",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]);
const $c0722d30b1d17141$var$MetricsBatch = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.MetricsBatch", ()=>[
        {
            no: 1,
            name: "timestamp_ms",
            kind: "scalar",
            T: 3
        },
        {
            no: 2,
            name: "normalized_timestamp",
            kind: "message",
            T: $c0722d30b1d17141$var$Timestamp
        },
        {
            no: 3,
            name: "str_data",
            kind: "scalar",
            T: 9,
            repeated: true
        },
        {
            no: 4,
            name: "time_series",
            kind: "message",
            T: $c0722d30b1d17141$var$TimeSeriesMetric,
            repeated: true
        },
        {
            no: 5,
            name: "events",
            kind: "message",
            T: $c0722d30b1d17141$var$EventMetric,
            repeated: true
        }
    ]);
const $c0722d30b1d17141$var$TimeSeriesMetric = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.TimeSeriesMetric", ()=>[
        {
            no: 1,
            name: "label",
            kind: "scalar",
            T: 13
        },
        {
            no: 2,
            name: "participant_identity",
            kind: "scalar",
            T: 13
        },
        {
            no: 3,
            name: "track_sid",
            kind: "scalar",
            T: 13
        },
        {
            no: 4,
            name: "samples",
            kind: "message",
            T: $c0722d30b1d17141$var$MetricSample,
            repeated: true
        },
        {
            no: 5,
            name: "rid",
            kind: "scalar",
            T: 13
        }
    ]);
const $c0722d30b1d17141$var$MetricSample = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.MetricSample", ()=>[
        {
            no: 1,
            name: "timestamp_ms",
            kind: "scalar",
            T: 3
        },
        {
            no: 2,
            name: "normalized_timestamp",
            kind: "message",
            T: $c0722d30b1d17141$var$Timestamp
        },
        {
            no: 3,
            name: "value",
            kind: "scalar",
            T: 2
        }
    ]);
const $c0722d30b1d17141$var$EventMetric = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.EventMetric", ()=>[
        {
            no: 1,
            name: "label",
            kind: "scalar",
            T: 13
        },
        {
            no: 2,
            name: "participant_identity",
            kind: "scalar",
            T: 13
        },
        {
            no: 3,
            name: "track_sid",
            kind: "scalar",
            T: 13
        },
        {
            no: 4,
            name: "start_timestamp_ms",
            kind: "scalar",
            T: 3
        },
        {
            no: 5,
            name: "end_timestamp_ms",
            kind: "scalar",
            T: 3,
            opt: true
        },
        {
            no: 6,
            name: "normalized_start_timestamp",
            kind: "message",
            T: $c0722d30b1d17141$var$Timestamp
        },
        {
            no: 7,
            name: "normalized_end_timestamp",
            kind: "message",
            T: $c0722d30b1d17141$var$Timestamp,
            opt: true
        },
        {
            no: 8,
            name: "metadata",
            kind: "scalar",
            T: 9
        },
        {
            no: 9,
            name: "rid",
            kind: "scalar",
            T: 13
        }
    ]);
const $c0722d30b1d17141$var$AudioCodec = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeEnum("livekit.AudioCodec", [
    {
        no: 0,
        name: "DEFAULT_AC"
    },
    {
        no: 1,
        name: "OPUS"
    },
    {
        no: 2,
        name: "AAC"
    },
    {
        no: 3,
        name: "AC_MP3"
    }
]);
const $c0722d30b1d17141$var$VideoCodec = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeEnum("livekit.VideoCodec", [
    {
        no: 0,
        name: "DEFAULT_VC"
    },
    {
        no: 1,
        name: "H264_BASELINE"
    },
    {
        no: 2,
        name: "H264_MAIN"
    },
    {
        no: 3,
        name: "H264_HIGH"
    },
    {
        no: 4,
        name: "VP8"
    }
]);
const $c0722d30b1d17141$var$ImageCodec = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeEnum("livekit.ImageCodec", [
    {
        no: 0,
        name: "IC_DEFAULT"
    },
    {
        no: 1,
        name: "IC_JPEG"
    }
]);
const $c0722d30b1d17141$var$BackupCodecPolicy$1 = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeEnum("livekit.BackupCodecPolicy", [
    {
        no: 0,
        name: "PREFER_REGRESSION"
    },
    {
        no: 1,
        name: "SIMULCAST"
    },
    {
        no: 2,
        name: "REGRESSION"
    }
]);
const $c0722d30b1d17141$export$c2fc6e4ded3e0219 = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeEnum("livekit.TrackType", [
    {
        no: 0,
        name: "AUDIO"
    },
    {
        no: 1,
        name: "VIDEO"
    },
    {
        no: 2,
        name: "DATA"
    }
]);
const $c0722d30b1d17141$var$TrackSource = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeEnum("livekit.TrackSource", [
    {
        no: 0,
        name: "UNKNOWN"
    },
    {
        no: 1,
        name: "CAMERA"
    },
    {
        no: 2,
        name: "MICROPHONE"
    },
    {
        no: 3,
        name: "SCREEN_SHARE"
    },
    {
        no: 4,
        name: "SCREEN_SHARE_AUDIO"
    }
]);
const $c0722d30b1d17141$var$VideoQuality$1 = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeEnum("livekit.VideoQuality", [
    {
        no: 0,
        name: "LOW"
    },
    {
        no: 1,
        name: "MEDIUM"
    },
    {
        no: 2,
        name: "HIGH"
    },
    {
        no: 3,
        name: "OFF"
    }
]);
const $c0722d30b1d17141$var$ConnectionQuality$1 = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeEnum("livekit.ConnectionQuality", [
    {
        no: 0,
        name: "POOR"
    },
    {
        no: 1,
        name: "GOOD"
    },
    {
        no: 2,
        name: "EXCELLENT"
    },
    {
        no: 3,
        name: "LOST"
    }
]);
const $c0722d30b1d17141$var$ClientConfigSetting = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeEnum("livekit.ClientConfigSetting", [
    {
        no: 0,
        name: "UNSET"
    },
    {
        no: 1,
        name: "DISABLED"
    },
    {
        no: 2,
        name: "ENABLED"
    }
]);
const $c0722d30b1d17141$export$258d16488300d83f = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeEnum("livekit.DisconnectReason", [
    {
        no: 0,
        name: "UNKNOWN_REASON"
    },
    {
        no: 1,
        name: "CLIENT_INITIATED"
    },
    {
        no: 2,
        name: "DUPLICATE_IDENTITY"
    },
    {
        no: 3,
        name: "SERVER_SHUTDOWN"
    },
    {
        no: 4,
        name: "PARTICIPANT_REMOVED"
    },
    {
        no: 5,
        name: "ROOM_DELETED"
    },
    {
        no: 6,
        name: "STATE_MISMATCH"
    },
    {
        no: 7,
        name: "JOIN_FAILURE"
    },
    {
        no: 8,
        name: "MIGRATION"
    },
    {
        no: 9,
        name: "SIGNAL_CLOSE"
    },
    {
        no: 10,
        name: "ROOM_CLOSED"
    },
    {
        no: 11,
        name: "USER_UNAVAILABLE"
    },
    {
        no: 12,
        name: "USER_REJECTED"
    },
    {
        no: 13,
        name: "SIP_TRUNK_FAILURE"
    },
    {
        no: 14,
        name: "CONNECTION_TIMEOUT"
    },
    {
        no: 15,
        name: "MEDIA_FAILURE"
    },
    {
        no: 16,
        name: "AGENT_ERROR"
    }
]);
const $c0722d30b1d17141$var$ReconnectReason = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeEnum("livekit.ReconnectReason", [
    {
        no: 0,
        name: "RR_UNKNOWN"
    },
    {
        no: 1,
        name: "RR_SIGNAL_DISCONNECTED"
    },
    {
        no: 2,
        name: "RR_PUBLISHER_FAILED"
    },
    {
        no: 3,
        name: "RR_SUBSCRIBER_FAILED"
    },
    {
        no: 4,
        name: "RR_SWITCH_CANDIDATE"
    }
]);
const $c0722d30b1d17141$export$7882d1e2e5429abf = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeEnum("livekit.SubscriptionError", [
    {
        no: 0,
        name: "SE_UNKNOWN"
    },
    {
        no: 1,
        name: "SE_CODEC_UNSUPPORTED"
    },
    {
        no: 2,
        name: "SE_TRACK_NOTFOUND"
    }
]);
const $c0722d30b1d17141$var$AudioTrackFeature = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeEnum("livekit.AudioTrackFeature", [
    {
        no: 0,
        name: "TF_STEREO"
    },
    {
        no: 1,
        name: "TF_NO_DTX"
    },
    {
        no: 2,
        name: "TF_AUTO_GAIN_CONTROL"
    },
    {
        no: 3,
        name: "TF_ECHO_CANCELLATION"
    },
    {
        no: 4,
        name: "TF_NOISE_SUPPRESSION"
    },
    {
        no: 5,
        name: "TF_ENHANCED_NOISE_CANCELLATION"
    },
    {
        no: 6,
        name: "TF_PRECONNECT_BUFFER"
    }
]);
const $c0722d30b1d17141$var$PacketTrailerFeature = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeEnum("livekit.PacketTrailerFeature", [
    {
        no: 0,
        name: "PTF_USER_TIMESTAMP"
    },
    {
        no: 1,
        name: "PTF_FRAME_ID"
    }
]);
const $c0722d30b1d17141$var$Room$1 = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.Room", ()=>[
        {
            no: 1,
            name: "sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "empty_timeout",
            kind: "scalar",
            T: 13
        },
        {
            no: 14,
            name: "departure_timeout",
            kind: "scalar",
            T: 13
        },
        {
            no: 4,
            name: "max_participants",
            kind: "scalar",
            T: 13
        },
        {
            no: 5,
            name: "creation_time",
            kind: "scalar",
            T: 3
        },
        {
            no: 15,
            name: "creation_time_ms",
            kind: "scalar",
            T: 3
        },
        {
            no: 6,
            name: "turn_password",
            kind: "scalar",
            T: 9
        },
        {
            no: 7,
            name: "enabled_codecs",
            kind: "message",
            T: $c0722d30b1d17141$var$Codec,
            repeated: true
        },
        {
            no: 8,
            name: "metadata",
            kind: "scalar",
            T: 9
        },
        {
            no: 9,
            name: "num_participants",
            kind: "scalar",
            T: 13
        },
        {
            no: 11,
            name: "num_publishers",
            kind: "scalar",
            T: 13
        },
        {
            no: 10,
            name: "active_recording",
            kind: "scalar",
            T: 8
        },
        {
            no: 13,
            name: "version",
            kind: "message",
            T: $c0722d30b1d17141$var$TimedVersion
        }
    ]);
const $c0722d30b1d17141$var$Codec = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.Codec", ()=>[
        {
            no: 1,
            name: "mime",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "fmtp_line",
            kind: "scalar",
            T: 9
        }
    ]);
const $c0722d30b1d17141$var$ParticipantPermission = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.ParticipantPermission", ()=>[
        {
            no: 1,
            name: "can_subscribe",
            kind: "scalar",
            T: 8
        },
        {
            no: 2,
            name: "can_publish",
            kind: "scalar",
            T: 8
        },
        {
            no: 3,
            name: "can_publish_data",
            kind: "scalar",
            T: 8
        },
        {
            no: 9,
            name: "can_publish_sources",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$var$TrackSource),
            repeated: true
        },
        {
            no: 7,
            name: "hidden",
            kind: "scalar",
            T: 8
        },
        {
            no: 8,
            name: "recorder",
            kind: "scalar",
            T: 8
        },
        {
            no: 10,
            name: "can_update_metadata",
            kind: "scalar",
            T: 8
        },
        {
            no: 11,
            name: "agent",
            kind: "scalar",
            T: 8
        },
        {
            no: 12,
            name: "can_subscribe_metrics",
            kind: "scalar",
            T: 8
        },
        {
            no: 13,
            name: "can_manage_agent_session",
            kind: "scalar",
            T: 8
        }
    ]);
const $c0722d30b1d17141$var$ParticipantInfo = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.ParticipantInfo", ()=>[
        {
            no: 1,
            name: "sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "identity",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "state",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$var$ParticipantInfo_State)
        },
        {
            no: 4,
            name: "tracks",
            kind: "message",
            T: $c0722d30b1d17141$var$TrackInfo,
            repeated: true
        },
        {
            no: 5,
            name: "metadata",
            kind: "scalar",
            T: 9
        },
        {
            no: 6,
            name: "joined_at",
            kind: "scalar",
            T: 3
        },
        {
            no: 17,
            name: "joined_at_ms",
            kind: "scalar",
            T: 3
        },
        {
            no: 9,
            name: "name",
            kind: "scalar",
            T: 9
        },
        {
            no: 10,
            name: "version",
            kind: "scalar",
            T: 13
        },
        {
            no: 11,
            name: "permission",
            kind: "message",
            T: $c0722d30b1d17141$var$ParticipantPermission
        },
        {
            no: 12,
            name: "region",
            kind: "scalar",
            T: 9
        },
        {
            no: 13,
            name: "is_publisher",
            kind: "scalar",
            T: 8
        },
        {
            no: 14,
            name: "kind",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$export$2079c0e1523aec29)
        },
        {
            no: 15,
            name: "attributes",
            kind: "map",
            K: 9,
            V: {
                kind: "scalar",
                T: 9
            }
        },
        {
            no: 16,
            name: "disconnect_reason",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$export$258d16488300d83f)
        },
        {
            no: 18,
            name: "kind_details",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$var$ParticipantInfo_KindDetail),
            repeated: true
        },
        {
            no: 19,
            name: "data_tracks",
            kind: "message",
            T: $c0722d30b1d17141$var$DataTrackInfo$1,
            repeated: true
        },
        {
            no: 20,
            name: "client_protocol",
            kind: "scalar",
            T: 5
        }
    ]);
const $c0722d30b1d17141$var$ParticipantInfo_State = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeEnum("livekit.ParticipantInfo.State", [
    {
        no: 0,
        name: "JOINING"
    },
    {
        no: 1,
        name: "JOINED"
    },
    {
        no: 2,
        name: "ACTIVE"
    },
    {
        no: 3,
        name: "DISCONNECTED"
    }
]);
const $c0722d30b1d17141$export$2079c0e1523aec29 = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeEnum("livekit.ParticipantInfo.Kind", [
    {
        no: 0,
        name: "STANDARD"
    },
    {
        no: 1,
        name: "INGRESS"
    },
    {
        no: 2,
        name: "EGRESS"
    },
    {
        no: 3,
        name: "SIP"
    },
    {
        no: 4,
        name: "AGENT"
    },
    {
        no: 7,
        name: "CONNECTOR"
    },
    {
        no: 8,
        name: "BRIDGE"
    }
]);
const $c0722d30b1d17141$var$ParticipantInfo_KindDetail = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeEnum("livekit.ParticipantInfo.KindDetail", [
    {
        no: 0,
        name: "CLOUD_AGENT"
    },
    {
        no: 1,
        name: "FORWARDED"
    },
    {
        no: 2,
        name: "CONNECTOR_WHATSAPP"
    },
    {
        no: 3,
        name: "CONNECTOR_TWILIO"
    },
    {
        no: 4,
        name: "BRIDGE_RTSP"
    }
]);
const $c0722d30b1d17141$export$1efc488791285f20 = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeEnum("livekit.Encryption.Type", [
    {
        no: 0,
        name: "NONE"
    },
    {
        no: 1,
        name: "GCM"
    },
    {
        no: 2,
        name: "CUSTOM"
    }
]);
const $c0722d30b1d17141$var$SimulcastCodecInfo = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.SimulcastCodecInfo", ()=>[
        {
            no: 1,
            name: "mime_type",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "mid",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "cid",
            kind: "scalar",
            T: 9
        },
        {
            no: 4,
            name: "layers",
            kind: "message",
            T: $c0722d30b1d17141$var$VideoLayer,
            repeated: true
        },
        {
            no: 5,
            name: "video_layer_mode",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$var$VideoLayer_Mode)
        },
        {
            no: 6,
            name: "sdp_cid",
            kind: "scalar",
            T: 9
        }
    ]);
const $c0722d30b1d17141$var$TrackInfo = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.TrackInfo", ()=>[
        {
            no: 1,
            name: "sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "type",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$export$c2fc6e4ded3e0219)
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9
        },
        {
            no: 4,
            name: "muted",
            kind: "scalar",
            T: 8
        },
        {
            no: 5,
            name: "width",
            kind: "scalar",
            T: 13
        },
        {
            no: 6,
            name: "height",
            kind: "scalar",
            T: 13
        },
        {
            no: 7,
            name: "simulcast",
            kind: "scalar",
            T: 8
        },
        {
            no: 8,
            name: "disable_dtx",
            kind: "scalar",
            T: 8
        },
        {
            no: 9,
            name: "source",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$var$TrackSource)
        },
        {
            no: 10,
            name: "layers",
            kind: "message",
            T: $c0722d30b1d17141$var$VideoLayer,
            repeated: true
        },
        {
            no: 11,
            name: "mime_type",
            kind: "scalar",
            T: 9
        },
        {
            no: 12,
            name: "mid",
            kind: "scalar",
            T: 9
        },
        {
            no: 13,
            name: "codecs",
            kind: "message",
            T: $c0722d30b1d17141$var$SimulcastCodecInfo,
            repeated: true
        },
        {
            no: 14,
            name: "stereo",
            kind: "scalar",
            T: 8
        },
        {
            no: 15,
            name: "disable_red",
            kind: "scalar",
            T: 8
        },
        {
            no: 16,
            name: "encryption",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$export$1efc488791285f20)
        },
        {
            no: 17,
            name: "stream",
            kind: "scalar",
            T: 9
        },
        {
            no: 18,
            name: "version",
            kind: "message",
            T: $c0722d30b1d17141$var$TimedVersion
        },
        {
            no: 19,
            name: "audio_features",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$var$AudioTrackFeature),
            repeated: true
        },
        {
            no: 20,
            name: "backup_codec_policy",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$var$BackupCodecPolicy$1)
        },
        {
            no: 21,
            name: "packet_trailer_features",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$var$PacketTrailerFeature),
            repeated: true
        }
    ]);
const $c0722d30b1d17141$var$DataTrackInfo$1 = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.DataTrackInfo", ()=>[
        {
            no: 1,
            name: "pub_handle",
            kind: "scalar",
            T: 13
        },
        {
            no: 2,
            name: "sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9
        },
        {
            no: 4,
            name: "encryption",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$export$1efc488791285f20)
        }
    ]);
const $c0722d30b1d17141$var$DataTrackSubscriptionOptions = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.DataTrackSubscriptionOptions", ()=>[
        {
            no: 1,
            name: "target_fps",
            kind: "scalar",
            T: 13,
            opt: true
        }
    ]);
const $c0722d30b1d17141$var$VideoLayer = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.VideoLayer", ()=>[
        {
            no: 1,
            name: "quality",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$var$VideoQuality$1)
        },
        {
            no: 2,
            name: "width",
            kind: "scalar",
            T: 13
        },
        {
            no: 3,
            name: "height",
            kind: "scalar",
            T: 13
        },
        {
            no: 4,
            name: "bitrate",
            kind: "scalar",
            T: 13
        },
        {
            no: 5,
            name: "ssrc",
            kind: "scalar",
            T: 13
        },
        {
            no: 6,
            name: "spatial_layer",
            kind: "scalar",
            T: 5
        },
        {
            no: 7,
            name: "rid",
            kind: "scalar",
            T: 9
        },
        {
            no: 8,
            name: "repair_ssrc",
            kind: "scalar",
            T: 13
        }
    ]);
const $c0722d30b1d17141$var$VideoLayer_Mode = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeEnum("livekit.VideoLayer.Mode", [
    {
        no: 0,
        name: "MODE_UNUSED"
    },
    {
        no: 1,
        name: "ONE_SPATIAL_LAYER_PER_STREAM"
    },
    {
        no: 2,
        name: "MULTIPLE_SPATIAL_LAYERS_PER_STREAM"
    },
    {
        no: 3,
        name: "ONE_SPATIAL_LAYER_PER_STREAM_INCOMPLETE_RTCP_SR"
    }
]);
const $c0722d30b1d17141$var$DataPacket = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.DataPacket", ()=>[
        {
            no: 1,
            name: "kind",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$export$629a0ea4ceb9e4a6)
        },
        {
            no: 4,
            name: "participant_identity",
            kind: "scalar",
            T: 9
        },
        {
            no: 5,
            name: "destination_identities",
            kind: "scalar",
            T: 9,
            repeated: true
        },
        {
            no: 2,
            name: "user",
            kind: "message",
            T: $c0722d30b1d17141$var$UserPacket,
            oneof: "value"
        },
        {
            no: 3,
            name: "speaker",
            kind: "message",
            T: $c0722d30b1d17141$var$ActiveSpeakerUpdate,
            oneof: "value"
        },
        {
            no: 6,
            name: "sip_dtmf",
            kind: "message",
            T: $c0722d30b1d17141$var$SipDTMF,
            oneof: "value"
        },
        {
            no: 7,
            name: "transcription",
            kind: "message",
            T: $c0722d30b1d17141$var$Transcription,
            oneof: "value"
        },
        {
            no: 8,
            name: "metrics",
            kind: "message",
            T: $c0722d30b1d17141$var$MetricsBatch,
            oneof: "value"
        },
        {
            no: 9,
            name: "chat_message",
            kind: "message",
            T: $c0722d30b1d17141$var$ChatMessage,
            oneof: "value"
        },
        {
            no: 10,
            name: "rpc_request",
            kind: "message",
            T: $c0722d30b1d17141$var$RpcRequest,
            oneof: "value"
        },
        {
            no: 11,
            name: "rpc_ack",
            kind: "message",
            T: $c0722d30b1d17141$var$RpcAck,
            oneof: "value"
        },
        {
            no: 12,
            name: "rpc_response",
            kind: "message",
            T: $c0722d30b1d17141$var$RpcResponse,
            oneof: "value"
        },
        {
            no: 13,
            name: "stream_header",
            kind: "message",
            T: $c0722d30b1d17141$var$DataStream_Header,
            oneof: "value"
        },
        {
            no: 14,
            name: "stream_chunk",
            kind: "message",
            T: $c0722d30b1d17141$var$DataStream_Chunk,
            oneof: "value"
        },
        {
            no: 15,
            name: "stream_trailer",
            kind: "message",
            T: $c0722d30b1d17141$var$DataStream_Trailer,
            oneof: "value"
        },
        {
            no: 18,
            name: "encrypted_packet",
            kind: "message",
            T: $c0722d30b1d17141$var$EncryptedPacket,
            oneof: "value"
        },
        {
            no: 16,
            name: "sequence",
            kind: "scalar",
            T: 13
        },
        {
            no: 17,
            name: "participant_sid",
            kind: "scalar",
            T: 9
        }
    ]);
const $c0722d30b1d17141$export$629a0ea4ceb9e4a6 = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeEnum("livekit.DataPacket.Kind", [
    {
        no: 0,
        name: "RELIABLE"
    },
    {
        no: 1,
        name: "LOSSY"
    }
]);
const $c0722d30b1d17141$var$EncryptedPacket = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.EncryptedPacket", ()=>[
        {
            no: 1,
            name: "encryption_type",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$export$1efc488791285f20)
        },
        {
            no: 2,
            name: "iv",
            kind: "scalar",
            T: 12
        },
        {
            no: 3,
            name: "key_index",
            kind: "scalar",
            T: 13
        },
        {
            no: 4,
            name: "encrypted_value",
            kind: "scalar",
            T: 12
        }
    ]);
const $c0722d30b1d17141$var$EncryptedPacketPayload = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.EncryptedPacketPayload", ()=>[
        {
            no: 1,
            name: "user",
            kind: "message",
            T: $c0722d30b1d17141$var$UserPacket,
            oneof: "value"
        },
        {
            no: 3,
            name: "chat_message",
            kind: "message",
            T: $c0722d30b1d17141$var$ChatMessage,
            oneof: "value"
        },
        {
            no: 4,
            name: "rpc_request",
            kind: "message",
            T: $c0722d30b1d17141$var$RpcRequest,
            oneof: "value"
        },
        {
            no: 5,
            name: "rpc_ack",
            kind: "message",
            T: $c0722d30b1d17141$var$RpcAck,
            oneof: "value"
        },
        {
            no: 6,
            name: "rpc_response",
            kind: "message",
            T: $c0722d30b1d17141$var$RpcResponse,
            oneof: "value"
        },
        {
            no: 7,
            name: "stream_header",
            kind: "message",
            T: $c0722d30b1d17141$var$DataStream_Header,
            oneof: "value"
        },
        {
            no: 8,
            name: "stream_chunk",
            kind: "message",
            T: $c0722d30b1d17141$var$DataStream_Chunk,
            oneof: "value"
        },
        {
            no: 9,
            name: "stream_trailer",
            kind: "message",
            T: $c0722d30b1d17141$var$DataStream_Trailer,
            oneof: "value"
        }
    ]);
const $c0722d30b1d17141$var$ActiveSpeakerUpdate = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.ActiveSpeakerUpdate", ()=>[
        {
            no: 1,
            name: "speakers",
            kind: "message",
            T: $c0722d30b1d17141$var$SpeakerInfo,
            repeated: true
        }
    ]);
const $c0722d30b1d17141$var$SpeakerInfo = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.SpeakerInfo", ()=>[
        {
            no: 1,
            name: "sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "level",
            kind: "scalar",
            T: 2
        },
        {
            no: 3,
            name: "active",
            kind: "scalar",
            T: 8
        }
    ]);
const $c0722d30b1d17141$var$UserPacket = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.UserPacket", ()=>[
        {
            no: 1,
            name: "participant_sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 5,
            name: "participant_identity",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "payload",
            kind: "scalar",
            T: 12
        },
        {
            no: 3,
            name: "destination_sids",
            kind: "scalar",
            T: 9,
            repeated: true
        },
        {
            no: 6,
            name: "destination_identities",
            kind: "scalar",
            T: 9,
            repeated: true
        },
        {
            no: 4,
            name: "topic",
            kind: "scalar",
            T: 9,
            opt: true
        },
        {
            no: 8,
            name: "id",
            kind: "scalar",
            T: 9,
            opt: true
        },
        {
            no: 9,
            name: "start_time",
            kind: "scalar",
            T: 4,
            opt: true
        },
        {
            no: 10,
            name: "end_time",
            kind: "scalar",
            T: 4,
            opt: true
        },
        {
            no: 11,
            name: "nonce",
            kind: "scalar",
            T: 12
        }
    ]);
const $c0722d30b1d17141$var$SipDTMF = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.SipDTMF", ()=>[
        {
            no: 3,
            name: "code",
            kind: "scalar",
            T: 13
        },
        {
            no: 4,
            name: "digit",
            kind: "scalar",
            T: 9
        }
    ]);
const $c0722d30b1d17141$var$Transcription = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.Transcription", ()=>[
        {
            no: 2,
            name: "transcribed_participant_identity",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "track_id",
            kind: "scalar",
            T: 9
        },
        {
            no: 4,
            name: "segments",
            kind: "message",
            T: $c0722d30b1d17141$var$TranscriptionSegment,
            repeated: true
        }
    ]);
const $c0722d30b1d17141$var$TranscriptionSegment = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.TranscriptionSegment", ()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "text",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "start_time",
            kind: "scalar",
            T: 4
        },
        {
            no: 4,
            name: "end_time",
            kind: "scalar",
            T: 4
        },
        {
            no: 5,
            name: "final",
            kind: "scalar",
            T: 8
        },
        {
            no: 6,
            name: "language",
            kind: "scalar",
            T: 9
        }
    ]);
const $c0722d30b1d17141$var$ChatMessage = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.ChatMessage", ()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "timestamp",
            kind: "scalar",
            T: 3
        },
        {
            no: 3,
            name: "edit_timestamp",
            kind: "scalar",
            T: 3,
            opt: true
        },
        {
            no: 4,
            name: "message",
            kind: "scalar",
            T: 9
        },
        {
            no: 5,
            name: "deleted",
            kind: "scalar",
            T: 8
        },
        {
            no: 6,
            name: "generated",
            kind: "scalar",
            T: 8
        }
    ]);
const $c0722d30b1d17141$var$RpcRequest = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.RpcRequest", ()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "method",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "payload",
            kind: "scalar",
            T: 9
        },
        {
            no: 4,
            name: "response_timeout_ms",
            kind: "scalar",
            T: 13
        },
        {
            no: 5,
            name: "version",
            kind: "scalar",
            T: 13
        },
        {
            no: 6,
            name: "compressed_payload",
            kind: "scalar",
            T: 12
        }
    ]);
const $c0722d30b1d17141$var$RpcAck = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.RpcAck", ()=>[
        {
            no: 1,
            name: "request_id",
            kind: "scalar",
            T: 9
        }
    ]);
const $c0722d30b1d17141$var$RpcResponse = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.RpcResponse", ()=>[
        {
            no: 1,
            name: "request_id",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "payload",
            kind: "scalar",
            T: 9,
            oneof: "value"
        },
        {
            no: 3,
            name: "error",
            kind: "message",
            T: $c0722d30b1d17141$var$RpcError$1,
            oneof: "value"
        },
        {
            no: 4,
            name: "compressed_payload",
            kind: "scalar",
            T: 12,
            oneof: "value"
        }
    ]);
const $c0722d30b1d17141$var$RpcError$1 = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.RpcError", ()=>[
        {
            no: 1,
            name: "code",
            kind: "scalar",
            T: 13
        },
        {
            no: 2,
            name: "message",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "data",
            kind: "scalar",
            T: 9
        }
    ]);
const $c0722d30b1d17141$var$ParticipantTracks = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.ParticipantTracks", ()=>[
        {
            no: 1,
            name: "participant_sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "track_sids",
            kind: "scalar",
            T: 9,
            repeated: true
        }
    ]);
const $c0722d30b1d17141$var$ServerInfo = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.ServerInfo", ()=>[
        {
            no: 1,
            name: "edition",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$var$ServerInfo_Edition)
        },
        {
            no: 2,
            name: "version",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "protocol",
            kind: "scalar",
            T: 5
        },
        {
            no: 4,
            name: "region",
            kind: "scalar",
            T: 9
        },
        {
            no: 5,
            name: "node_id",
            kind: "scalar",
            T: 9
        },
        {
            no: 6,
            name: "debug_info",
            kind: "scalar",
            T: 9
        },
        {
            no: 7,
            name: "agent_protocol",
            kind: "scalar",
            T: 5
        }
    ]);
const $c0722d30b1d17141$var$ServerInfo_Edition = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeEnum("livekit.ServerInfo.Edition", [
    {
        no: 0,
        name: "Standard"
    },
    {
        no: 1,
        name: "Cloud"
    }
]);
const $c0722d30b1d17141$var$ClientInfo = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.ClientInfo", ()=>[
        {
            no: 1,
            name: "sdk",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$var$ClientInfo_SDK)
        },
        {
            no: 2,
            name: "version",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "protocol",
            kind: "scalar",
            T: 5
        },
        {
            no: 4,
            name: "os",
            kind: "scalar",
            T: 9
        },
        {
            no: 5,
            name: "os_version",
            kind: "scalar",
            T: 9
        },
        {
            no: 6,
            name: "device_model",
            kind: "scalar",
            T: 9
        },
        {
            no: 7,
            name: "browser",
            kind: "scalar",
            T: 9
        },
        {
            no: 8,
            name: "browser_version",
            kind: "scalar",
            T: 9
        },
        {
            no: 9,
            name: "address",
            kind: "scalar",
            T: 9
        },
        {
            no: 10,
            name: "network",
            kind: "scalar",
            T: 9
        },
        {
            no: 11,
            name: "other_sdks",
            kind: "scalar",
            T: 9
        },
        {
            no: 12,
            name: "client_protocol",
            kind: "scalar",
            T: 5
        }
    ]);
const $c0722d30b1d17141$var$ClientInfo_SDK = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeEnum("livekit.ClientInfo.SDK", [
    {
        no: 0,
        name: "UNKNOWN"
    },
    {
        no: 1,
        name: "JS"
    },
    {
        no: 2,
        name: "SWIFT"
    },
    {
        no: 3,
        name: "ANDROID"
    },
    {
        no: 4,
        name: "FLUTTER"
    },
    {
        no: 5,
        name: "GO"
    },
    {
        no: 6,
        name: "UNITY"
    },
    {
        no: 7,
        name: "REACT_NATIVE"
    },
    {
        no: 8,
        name: "RUST"
    },
    {
        no: 9,
        name: "PYTHON"
    },
    {
        no: 10,
        name: "CPP"
    },
    {
        no: 11,
        name: "UNITY_WEB"
    },
    {
        no: 12,
        name: "NODE"
    },
    {
        no: 13,
        name: "UNREAL"
    },
    {
        no: 14,
        name: "ESP32"
    }
]);
const $c0722d30b1d17141$var$ClientConfiguration = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.ClientConfiguration", ()=>[
        {
            no: 1,
            name: "video",
            kind: "message",
            T: $c0722d30b1d17141$var$VideoConfiguration
        },
        {
            no: 2,
            name: "screen",
            kind: "message",
            T: $c0722d30b1d17141$var$VideoConfiguration
        },
        {
            no: 3,
            name: "resume_connection",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$var$ClientConfigSetting)
        },
        {
            no: 4,
            name: "disabled_codecs",
            kind: "message",
            T: $c0722d30b1d17141$var$DisabledCodecs
        },
        {
            no: 5,
            name: "force_relay",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$var$ClientConfigSetting)
        }
    ]);
const $c0722d30b1d17141$var$VideoConfiguration = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.VideoConfiguration", ()=>[
        {
            no: 1,
            name: "hardware_encoder",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$var$ClientConfigSetting)
        }
    ]);
const $c0722d30b1d17141$var$DisabledCodecs = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.DisabledCodecs", ()=>[
        {
            no: 1,
            name: "codecs",
            kind: "message",
            T: $c0722d30b1d17141$var$Codec,
            repeated: true
        },
        {
            no: 2,
            name: "publish",
            kind: "message",
            T: $c0722d30b1d17141$var$Codec,
            repeated: true
        }
    ]);
const $c0722d30b1d17141$var$TimedVersion = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.TimedVersion", ()=>[
        {
            no: 1,
            name: "unix_micro",
            kind: "scalar",
            T: 3
        },
        {
            no: 2,
            name: "ticks",
            kind: "scalar",
            T: 5
        }
    ]);
const $c0722d30b1d17141$var$DataStream_OperationType = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeEnum("livekit.DataStream.OperationType", [
    {
        no: 0,
        name: "CREATE"
    },
    {
        no: 1,
        name: "UPDATE"
    },
    {
        no: 2,
        name: "DELETE"
    },
    {
        no: 3,
        name: "REACTION"
    }
]);
const $c0722d30b1d17141$var$DataStream_TextHeader = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.DataStream.TextHeader", ()=>[
        {
            no: 1,
            name: "operation_type",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$var$DataStream_OperationType)
        },
        {
            no: 2,
            name: "version",
            kind: "scalar",
            T: 5
        },
        {
            no: 3,
            name: "reply_to_stream_id",
            kind: "scalar",
            T: 9
        },
        {
            no: 4,
            name: "attached_stream_ids",
            kind: "scalar",
            T: 9,
            repeated: true
        },
        {
            no: 5,
            name: "generated",
            kind: "scalar",
            T: 8
        }
    ], {
    localName: "DataStream_TextHeader"
});
const $c0722d30b1d17141$var$DataStream_ByteHeader = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.DataStream.ByteHeader", ()=>[
        {
            no: 1,
            name: "name",
            kind: "scalar",
            T: 9
        }
    ], {
    localName: "DataStream_ByteHeader"
});
const $c0722d30b1d17141$var$DataStream_Header = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.DataStream.Header", ()=>[
        {
            no: 1,
            name: "stream_id",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "timestamp",
            kind: "scalar",
            T: 3
        },
        {
            no: 3,
            name: "topic",
            kind: "scalar",
            T: 9
        },
        {
            no: 4,
            name: "mime_type",
            kind: "scalar",
            T: 9
        },
        {
            no: 5,
            name: "total_length",
            kind: "scalar",
            T: 4,
            opt: true
        },
        {
            no: 7,
            name: "encryption_type",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$export$1efc488791285f20)
        },
        {
            no: 8,
            name: "attributes",
            kind: "map",
            K: 9,
            V: {
                kind: "scalar",
                T: 9
            }
        },
        {
            no: 9,
            name: "text_header",
            kind: "message",
            T: $c0722d30b1d17141$var$DataStream_TextHeader,
            oneof: "content_header"
        },
        {
            no: 10,
            name: "byte_header",
            kind: "message",
            T: $c0722d30b1d17141$var$DataStream_ByteHeader,
            oneof: "content_header"
        }
    ], {
    localName: "DataStream_Header"
});
const $c0722d30b1d17141$var$DataStream_Chunk = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.DataStream.Chunk", ()=>[
        {
            no: 1,
            name: "stream_id",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "chunk_index",
            kind: "scalar",
            T: 4
        },
        {
            no: 3,
            name: "content",
            kind: "scalar",
            T: 12
        },
        {
            no: 4,
            name: "version",
            kind: "scalar",
            T: 5
        },
        {
            no: 5,
            name: "iv",
            kind: "scalar",
            T: 12,
            opt: true
        }
    ], {
    localName: "DataStream_Chunk"
});
const $c0722d30b1d17141$var$DataStream_Trailer = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.DataStream.Trailer", ()=>[
        {
            no: 1,
            name: "stream_id",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "reason",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "attributes",
            kind: "map",
            K: 9,
            V: {
                kind: "scalar",
                T: 9
            }
        }
    ], {
    localName: "DataStream_Trailer"
});
const $c0722d30b1d17141$var$FilterParams = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.FilterParams", ()=>[
        {
            no: 1,
            name: "include_events",
            kind: "scalar",
            T: 9,
            repeated: true
        },
        {
            no: 2,
            name: "exclude_events",
            kind: "scalar",
            T: 9,
            repeated: true
        }
    ]);
const $c0722d30b1d17141$var$WebhookConfig = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.WebhookConfig", ()=>[
        {
            no: 1,
            name: "url",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "signing_key",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "filter_params",
            kind: "message",
            T: $c0722d30b1d17141$var$FilterParams
        }
    ]);
const $c0722d30b1d17141$var$SubscribedAudioCodec = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.SubscribedAudioCodec", ()=>[
        {
            no: 1,
            name: "codec",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "enabled",
            kind: "scalar",
            T: 8
        }
    ]);
const $c0722d30b1d17141$var$JobRestartPolicy = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeEnum("livekit.JobRestartPolicy", [
    {
        no: 0,
        name: "JRP_ON_FAILURE"
    },
    {
        no: 1,
        name: "JRP_NEVER"
    }
]);
const $c0722d30b1d17141$var$RoomAgentDispatch = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.RoomAgentDispatch", ()=>[
        {
            no: 1,
            name: "agent_name",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "metadata",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "restart_policy",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$var$JobRestartPolicy)
        }
    ]);
const $c0722d30b1d17141$var$SignalTarget = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeEnum("livekit.SignalTarget", [
    {
        no: 0,
        name: "PUBLISHER"
    },
    {
        no: 1,
        name: "SUBSCRIBER"
    }
]);
const $c0722d30b1d17141$var$StreamState = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeEnum("livekit.StreamState", [
    {
        no: 0,
        name: "ACTIVE"
    },
    {
        no: 1,
        name: "PAUSED"
    }
]);
const $c0722d30b1d17141$var$CandidateProtocol = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeEnum("livekit.CandidateProtocol", [
    {
        no: 0,
        name: "UDP"
    },
    {
        no: 1,
        name: "TCP"
    },
    {
        no: 2,
        name: "TLS"
    }
]);
const $c0722d30b1d17141$var$SignalRequest = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.SignalRequest", ()=>[
        {
            no: 1,
            name: "offer",
            kind: "message",
            T: $c0722d30b1d17141$var$SessionDescription,
            oneof: "message"
        },
        {
            no: 2,
            name: "answer",
            kind: "message",
            T: $c0722d30b1d17141$var$SessionDescription,
            oneof: "message"
        },
        {
            no: 3,
            name: "trickle",
            kind: "message",
            T: $c0722d30b1d17141$var$TrickleRequest,
            oneof: "message"
        },
        {
            no: 4,
            name: "add_track",
            kind: "message",
            T: $c0722d30b1d17141$var$AddTrackRequest,
            oneof: "message"
        },
        {
            no: 5,
            name: "mute",
            kind: "message",
            T: $c0722d30b1d17141$var$MuteTrackRequest,
            oneof: "message"
        },
        {
            no: 6,
            name: "subscription",
            kind: "message",
            T: $c0722d30b1d17141$var$UpdateSubscription,
            oneof: "message"
        },
        {
            no: 7,
            name: "track_setting",
            kind: "message",
            T: $c0722d30b1d17141$var$UpdateTrackSettings,
            oneof: "message"
        },
        {
            no: 8,
            name: "leave",
            kind: "message",
            T: $c0722d30b1d17141$var$LeaveRequest,
            oneof: "message"
        },
        {
            no: 10,
            name: "update_layers",
            kind: "message",
            T: $c0722d30b1d17141$var$UpdateVideoLayers,
            oneof: "message"
        },
        {
            no: 11,
            name: "subscription_permission",
            kind: "message",
            T: $c0722d30b1d17141$var$SubscriptionPermission,
            oneof: "message"
        },
        {
            no: 12,
            name: "sync_state",
            kind: "message",
            T: $c0722d30b1d17141$var$SyncState,
            oneof: "message"
        },
        {
            no: 13,
            name: "simulate",
            kind: "message",
            T: $c0722d30b1d17141$var$SimulateScenario,
            oneof: "message"
        },
        {
            no: 14,
            name: "ping",
            kind: "scalar",
            T: 3,
            oneof: "message"
        },
        {
            no: 15,
            name: "update_metadata",
            kind: "message",
            T: $c0722d30b1d17141$var$UpdateParticipantMetadata,
            oneof: "message"
        },
        {
            no: 16,
            name: "ping_req",
            kind: "message",
            T: $c0722d30b1d17141$var$Ping,
            oneof: "message"
        },
        {
            no: 17,
            name: "update_audio_track",
            kind: "message",
            T: $c0722d30b1d17141$var$UpdateLocalAudioTrack,
            oneof: "message"
        },
        {
            no: 18,
            name: "update_video_track",
            kind: "message",
            T: $c0722d30b1d17141$var$UpdateLocalVideoTrack,
            oneof: "message"
        },
        {
            no: 19,
            name: "publish_data_track_request",
            kind: "message",
            T: $c0722d30b1d17141$var$PublishDataTrackRequest,
            oneof: "message"
        },
        {
            no: 20,
            name: "unpublish_data_track_request",
            kind: "message",
            T: $c0722d30b1d17141$var$UnpublishDataTrackRequest,
            oneof: "message"
        },
        {
            no: 21,
            name: "update_data_subscription",
            kind: "message",
            T: $c0722d30b1d17141$var$UpdateDataSubscription,
            oneof: "message"
        }
    ]);
const $c0722d30b1d17141$var$SignalResponse = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.SignalResponse", ()=>[
        {
            no: 1,
            name: "join",
            kind: "message",
            T: $c0722d30b1d17141$var$JoinResponse,
            oneof: "message"
        },
        {
            no: 2,
            name: "answer",
            kind: "message",
            T: $c0722d30b1d17141$var$SessionDescription,
            oneof: "message"
        },
        {
            no: 3,
            name: "offer",
            kind: "message",
            T: $c0722d30b1d17141$var$SessionDescription,
            oneof: "message"
        },
        {
            no: 4,
            name: "trickle",
            kind: "message",
            T: $c0722d30b1d17141$var$TrickleRequest,
            oneof: "message"
        },
        {
            no: 5,
            name: "update",
            kind: "message",
            T: $c0722d30b1d17141$var$ParticipantUpdate,
            oneof: "message"
        },
        {
            no: 6,
            name: "track_published",
            kind: "message",
            T: $c0722d30b1d17141$var$TrackPublishedResponse,
            oneof: "message"
        },
        {
            no: 8,
            name: "leave",
            kind: "message",
            T: $c0722d30b1d17141$var$LeaveRequest,
            oneof: "message"
        },
        {
            no: 9,
            name: "mute",
            kind: "message",
            T: $c0722d30b1d17141$var$MuteTrackRequest,
            oneof: "message"
        },
        {
            no: 10,
            name: "speakers_changed",
            kind: "message",
            T: $c0722d30b1d17141$var$SpeakersChanged,
            oneof: "message"
        },
        {
            no: 11,
            name: "room_update",
            kind: "message",
            T: $c0722d30b1d17141$var$RoomUpdate,
            oneof: "message"
        },
        {
            no: 12,
            name: "connection_quality",
            kind: "message",
            T: $c0722d30b1d17141$var$ConnectionQualityUpdate,
            oneof: "message"
        },
        {
            no: 13,
            name: "stream_state_update",
            kind: "message",
            T: $c0722d30b1d17141$var$StreamStateUpdate,
            oneof: "message"
        },
        {
            no: 14,
            name: "subscribed_quality_update",
            kind: "message",
            T: $c0722d30b1d17141$var$SubscribedQualityUpdate,
            oneof: "message"
        },
        {
            no: 15,
            name: "subscription_permission_update",
            kind: "message",
            T: $c0722d30b1d17141$var$SubscriptionPermissionUpdate,
            oneof: "message"
        },
        {
            no: 16,
            name: "refresh_token",
            kind: "scalar",
            T: 9,
            oneof: "message"
        },
        {
            no: 17,
            name: "track_unpublished",
            kind: "message",
            T: $c0722d30b1d17141$var$TrackUnpublishedResponse,
            oneof: "message"
        },
        {
            no: 18,
            name: "pong",
            kind: "scalar",
            T: 3,
            oneof: "message"
        },
        {
            no: 19,
            name: "reconnect",
            kind: "message",
            T: $c0722d30b1d17141$var$ReconnectResponse,
            oneof: "message"
        },
        {
            no: 20,
            name: "pong_resp",
            kind: "message",
            T: $c0722d30b1d17141$var$Pong,
            oneof: "message"
        },
        {
            no: 21,
            name: "subscription_response",
            kind: "message",
            T: $c0722d30b1d17141$var$SubscriptionResponse,
            oneof: "message"
        },
        {
            no: 22,
            name: "request_response",
            kind: "message",
            T: $c0722d30b1d17141$var$RequestResponse,
            oneof: "message"
        },
        {
            no: 23,
            name: "track_subscribed",
            kind: "message",
            T: $c0722d30b1d17141$var$TrackSubscribed,
            oneof: "message"
        },
        {
            no: 24,
            name: "room_moved",
            kind: "message",
            T: $c0722d30b1d17141$var$RoomMovedResponse,
            oneof: "message"
        },
        {
            no: 25,
            name: "media_sections_requirement",
            kind: "message",
            T: $c0722d30b1d17141$var$MediaSectionsRequirement,
            oneof: "message"
        },
        {
            no: 26,
            name: "subscribed_audio_codec_update",
            kind: "message",
            T: $c0722d30b1d17141$var$SubscribedAudioCodecUpdate,
            oneof: "message"
        },
        {
            no: 27,
            name: "publish_data_track_response",
            kind: "message",
            T: $c0722d30b1d17141$var$PublishDataTrackResponse,
            oneof: "message"
        },
        {
            no: 28,
            name: "unpublish_data_track_response",
            kind: "message",
            T: $c0722d30b1d17141$var$UnpublishDataTrackResponse,
            oneof: "message"
        },
        {
            no: 29,
            name: "data_track_subscriber_handles",
            kind: "message",
            T: $c0722d30b1d17141$var$DataTrackSubscriberHandles,
            oneof: "message"
        }
    ]);
const $c0722d30b1d17141$var$SimulcastCodec = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.SimulcastCodec", ()=>[
        {
            no: 1,
            name: "codec",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "cid",
            kind: "scalar",
            T: 9
        },
        {
            no: 4,
            name: "layers",
            kind: "message",
            T: $c0722d30b1d17141$var$VideoLayer,
            repeated: true
        },
        {
            no: 5,
            name: "video_layer_mode",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$var$VideoLayer_Mode)
        }
    ]);
const $c0722d30b1d17141$var$AddTrackRequest = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.AddTrackRequest", ()=>[
        {
            no: 1,
            name: "cid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "type",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$export$c2fc6e4ded3e0219)
        },
        {
            no: 4,
            name: "width",
            kind: "scalar",
            T: 13
        },
        {
            no: 5,
            name: "height",
            kind: "scalar",
            T: 13
        },
        {
            no: 6,
            name: "muted",
            kind: "scalar",
            T: 8
        },
        {
            no: 7,
            name: "disable_dtx",
            kind: "scalar",
            T: 8
        },
        {
            no: 8,
            name: "source",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$var$TrackSource)
        },
        {
            no: 9,
            name: "layers",
            kind: "message",
            T: $c0722d30b1d17141$var$VideoLayer,
            repeated: true
        },
        {
            no: 10,
            name: "simulcast_codecs",
            kind: "message",
            T: $c0722d30b1d17141$var$SimulcastCodec,
            repeated: true
        },
        {
            no: 11,
            name: "sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 12,
            name: "stereo",
            kind: "scalar",
            T: 8
        },
        {
            no: 13,
            name: "disable_red",
            kind: "scalar",
            T: 8
        },
        {
            no: 14,
            name: "encryption",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$export$1efc488791285f20)
        },
        {
            no: 15,
            name: "stream",
            kind: "scalar",
            T: 9
        },
        {
            no: 16,
            name: "backup_codec_policy",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$var$BackupCodecPolicy$1)
        },
        {
            no: 17,
            name: "audio_features",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$var$AudioTrackFeature),
            repeated: true
        },
        {
            no: 18,
            name: "packet_trailer_features",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$var$PacketTrailerFeature),
            repeated: true
        }
    ]);
const $c0722d30b1d17141$var$PublishDataTrackRequest = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.PublishDataTrackRequest", ()=>[
        {
            no: 1,
            name: "pub_handle",
            kind: "scalar",
            T: 13
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "encryption",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$export$1efc488791285f20)
        }
    ]);
const $c0722d30b1d17141$var$PublishDataTrackResponse = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.PublishDataTrackResponse", ()=>[
        {
            no: 1,
            name: "info",
            kind: "message",
            T: $c0722d30b1d17141$var$DataTrackInfo$1
        }
    ]);
const $c0722d30b1d17141$var$UnpublishDataTrackRequest = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.UnpublishDataTrackRequest", ()=>[
        {
            no: 1,
            name: "pub_handle",
            kind: "scalar",
            T: 13
        }
    ]);
const $c0722d30b1d17141$var$UnpublishDataTrackResponse = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.UnpublishDataTrackResponse", ()=>[
        {
            no: 1,
            name: "info",
            kind: "message",
            T: $c0722d30b1d17141$var$DataTrackInfo$1
        }
    ]);
const $c0722d30b1d17141$var$DataTrackSubscriberHandles = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.DataTrackSubscriberHandles", ()=>[
        {
            no: 1,
            name: "sub_handles",
            kind: "map",
            K: 13,
            V: {
                kind: "message",
                T: $c0722d30b1d17141$var$DataTrackSubscriberHandles_PublishedDataTrack
            }
        }
    ]);
const $c0722d30b1d17141$var$DataTrackSubscriberHandles_PublishedDataTrack = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.DataTrackSubscriberHandles.PublishedDataTrack", ()=>[
        {
            no: 1,
            name: "publisher_identity",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "publisher_sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "track_sid",
            kind: "scalar",
            T: 9
        }
    ], {
    localName: "DataTrackSubscriberHandles_PublishedDataTrack"
});
const $c0722d30b1d17141$var$TrickleRequest = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.TrickleRequest", ()=>[
        {
            no: 1,
            name: "candidateInit",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "target",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$var$SignalTarget)
        },
        {
            no: 3,
            name: "final",
            kind: "scalar",
            T: 8
        }
    ]);
const $c0722d30b1d17141$var$MuteTrackRequest = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.MuteTrackRequest", ()=>[
        {
            no: 1,
            name: "sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "muted",
            kind: "scalar",
            T: 8
        }
    ]);
const $c0722d30b1d17141$var$JoinResponse = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.JoinResponse", ()=>[
        {
            no: 1,
            name: "room",
            kind: "message",
            T: $c0722d30b1d17141$var$Room$1
        },
        {
            no: 2,
            name: "participant",
            kind: "message",
            T: $c0722d30b1d17141$var$ParticipantInfo
        },
        {
            no: 3,
            name: "other_participants",
            kind: "message",
            T: $c0722d30b1d17141$var$ParticipantInfo,
            repeated: true
        },
        {
            no: 4,
            name: "server_version",
            kind: "scalar",
            T: 9
        },
        {
            no: 5,
            name: "ice_servers",
            kind: "message",
            T: $c0722d30b1d17141$var$ICEServer,
            repeated: true
        },
        {
            no: 6,
            name: "subscriber_primary",
            kind: "scalar",
            T: 8
        },
        {
            no: 7,
            name: "alternative_url",
            kind: "scalar",
            T: 9
        },
        {
            no: 8,
            name: "client_configuration",
            kind: "message",
            T: $c0722d30b1d17141$var$ClientConfiguration
        },
        {
            no: 9,
            name: "server_region",
            kind: "scalar",
            T: 9
        },
        {
            no: 10,
            name: "ping_timeout",
            kind: "scalar",
            T: 5
        },
        {
            no: 11,
            name: "ping_interval",
            kind: "scalar",
            T: 5
        },
        {
            no: 12,
            name: "server_info",
            kind: "message",
            T: $c0722d30b1d17141$var$ServerInfo
        },
        {
            no: 13,
            name: "sif_trailer",
            kind: "scalar",
            T: 12
        },
        {
            no: 14,
            name: "enabled_publish_codecs",
            kind: "message",
            T: $c0722d30b1d17141$var$Codec,
            repeated: true
        },
        {
            no: 15,
            name: "fast_publish",
            kind: "scalar",
            T: 8
        }
    ]);
const $c0722d30b1d17141$var$ReconnectResponse = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.ReconnectResponse", ()=>[
        {
            no: 1,
            name: "ice_servers",
            kind: "message",
            T: $c0722d30b1d17141$var$ICEServer,
            repeated: true
        },
        {
            no: 2,
            name: "client_configuration",
            kind: "message",
            T: $c0722d30b1d17141$var$ClientConfiguration
        },
        {
            no: 3,
            name: "server_info",
            kind: "message",
            T: $c0722d30b1d17141$var$ServerInfo
        },
        {
            no: 4,
            name: "last_message_seq",
            kind: "scalar",
            T: 13
        }
    ]);
const $c0722d30b1d17141$var$TrackPublishedResponse = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.TrackPublishedResponse", ()=>[
        {
            no: 1,
            name: "cid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "track",
            kind: "message",
            T: $c0722d30b1d17141$var$TrackInfo
        }
    ]);
const $c0722d30b1d17141$var$TrackUnpublishedResponse = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.TrackUnpublishedResponse", ()=>[
        {
            no: 1,
            name: "track_sid",
            kind: "scalar",
            T: 9
        }
    ]);
const $c0722d30b1d17141$var$SessionDescription = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.SessionDescription", ()=>[
        {
            no: 1,
            name: "type",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "sdp",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "id",
            kind: "scalar",
            T: 13
        },
        {
            no: 4,
            name: "mid_to_track_id",
            kind: "map",
            K: 9,
            V: {
                kind: "scalar",
                T: 9
            }
        }
    ]);
const $c0722d30b1d17141$var$ParticipantUpdate = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.ParticipantUpdate", ()=>[
        {
            no: 1,
            name: "participants",
            kind: "message",
            T: $c0722d30b1d17141$var$ParticipantInfo,
            repeated: true
        }
    ]);
const $c0722d30b1d17141$var$UpdateSubscription = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.UpdateSubscription", ()=>[
        {
            no: 1,
            name: "track_sids",
            kind: "scalar",
            T: 9,
            repeated: true
        },
        {
            no: 2,
            name: "subscribe",
            kind: "scalar",
            T: 8
        },
        {
            no: 3,
            name: "participant_tracks",
            kind: "message",
            T: $c0722d30b1d17141$var$ParticipantTracks,
            repeated: true
        }
    ]);
const $c0722d30b1d17141$var$UpdateDataSubscription = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.UpdateDataSubscription", ()=>[
        {
            no: 1,
            name: "updates",
            kind: "message",
            T: $c0722d30b1d17141$var$UpdateDataSubscription_Update,
            repeated: true
        }
    ]);
const $c0722d30b1d17141$var$UpdateDataSubscription_Update = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.UpdateDataSubscription.Update", ()=>[
        {
            no: 1,
            name: "track_sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "subscribe",
            kind: "scalar",
            T: 8
        },
        {
            no: 3,
            name: "options",
            kind: "message",
            T: $c0722d30b1d17141$var$DataTrackSubscriptionOptions
        }
    ], {
    localName: "UpdateDataSubscription_Update"
});
const $c0722d30b1d17141$var$UpdateTrackSettings = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.UpdateTrackSettings", ()=>[
        {
            no: 1,
            name: "track_sids",
            kind: "scalar",
            T: 9,
            repeated: true
        },
        {
            no: 3,
            name: "disabled",
            kind: "scalar",
            T: 8
        },
        {
            no: 4,
            name: "quality",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$var$VideoQuality$1)
        },
        {
            no: 5,
            name: "width",
            kind: "scalar",
            T: 13
        },
        {
            no: 6,
            name: "height",
            kind: "scalar",
            T: 13
        },
        {
            no: 7,
            name: "fps",
            kind: "scalar",
            T: 13
        },
        {
            no: 8,
            name: "priority",
            kind: "scalar",
            T: 13
        }
    ]);
const $c0722d30b1d17141$var$UpdateLocalAudioTrack = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.UpdateLocalAudioTrack", ()=>[
        {
            no: 1,
            name: "track_sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "features",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$var$AudioTrackFeature),
            repeated: true
        }
    ]);
const $c0722d30b1d17141$var$UpdateLocalVideoTrack = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.UpdateLocalVideoTrack", ()=>[
        {
            no: 1,
            name: "track_sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "width",
            kind: "scalar",
            T: 13
        },
        {
            no: 3,
            name: "height",
            kind: "scalar",
            T: 13
        }
    ]);
const $c0722d30b1d17141$var$LeaveRequest = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.LeaveRequest", ()=>[
        {
            no: 1,
            name: "can_reconnect",
            kind: "scalar",
            T: 8
        },
        {
            no: 2,
            name: "reason",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$export$258d16488300d83f)
        },
        {
            no: 3,
            name: "action",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$var$LeaveRequest_Action)
        },
        {
            no: 4,
            name: "regions",
            kind: "message",
            T: $c0722d30b1d17141$var$RegionSettings
        }
    ]);
const $c0722d30b1d17141$var$LeaveRequest_Action = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeEnum("livekit.LeaveRequest.Action", [
    {
        no: 0,
        name: "DISCONNECT"
    },
    {
        no: 1,
        name: "RESUME"
    },
    {
        no: 2,
        name: "RECONNECT"
    }
]);
const $c0722d30b1d17141$var$UpdateVideoLayers = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.UpdateVideoLayers", ()=>[
        {
            no: 1,
            name: "track_sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "layers",
            kind: "message",
            T: $c0722d30b1d17141$var$VideoLayer,
            repeated: true
        }
    ]);
const $c0722d30b1d17141$var$UpdateParticipantMetadata = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.UpdateParticipantMetadata", ()=>[
        {
            no: 1,
            name: "metadata",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "attributes",
            kind: "map",
            K: 9,
            V: {
                kind: "scalar",
                T: 9
            }
        },
        {
            no: 4,
            name: "request_id",
            kind: "scalar",
            T: 13
        }
    ]);
const $c0722d30b1d17141$var$ICEServer = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.ICEServer", ()=>[
        {
            no: 1,
            name: "urls",
            kind: "scalar",
            T: 9,
            repeated: true
        },
        {
            no: 2,
            name: "username",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "credential",
            kind: "scalar",
            T: 9
        }
    ]);
const $c0722d30b1d17141$var$SpeakersChanged = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.SpeakersChanged", ()=>[
        {
            no: 1,
            name: "speakers",
            kind: "message",
            T: $c0722d30b1d17141$var$SpeakerInfo,
            repeated: true
        }
    ]);
const $c0722d30b1d17141$var$RoomUpdate = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.RoomUpdate", ()=>[
        {
            no: 1,
            name: "room",
            kind: "message",
            T: $c0722d30b1d17141$var$Room$1
        }
    ]);
const $c0722d30b1d17141$var$ConnectionQualityInfo = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.ConnectionQualityInfo", ()=>[
        {
            no: 1,
            name: "participant_sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "quality",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$var$ConnectionQuality$1)
        },
        {
            no: 3,
            name: "score",
            kind: "scalar",
            T: 2
        }
    ]);
const $c0722d30b1d17141$var$ConnectionQualityUpdate = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.ConnectionQualityUpdate", ()=>[
        {
            no: 1,
            name: "updates",
            kind: "message",
            T: $c0722d30b1d17141$var$ConnectionQualityInfo,
            repeated: true
        }
    ]);
const $c0722d30b1d17141$var$StreamStateInfo = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.StreamStateInfo", ()=>[
        {
            no: 1,
            name: "participant_sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "track_sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "state",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$var$StreamState)
        }
    ]);
const $c0722d30b1d17141$var$StreamStateUpdate = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.StreamStateUpdate", ()=>[
        {
            no: 1,
            name: "stream_states",
            kind: "message",
            T: $c0722d30b1d17141$var$StreamStateInfo,
            repeated: true
        }
    ]);
const $c0722d30b1d17141$var$SubscribedQuality = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.SubscribedQuality", ()=>[
        {
            no: 1,
            name: "quality",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$var$VideoQuality$1)
        },
        {
            no: 2,
            name: "enabled",
            kind: "scalar",
            T: 8
        }
    ]);
const $c0722d30b1d17141$var$SubscribedCodec = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.SubscribedCodec", ()=>[
        {
            no: 1,
            name: "codec",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "qualities",
            kind: "message",
            T: $c0722d30b1d17141$var$SubscribedQuality,
            repeated: true
        }
    ]);
const $c0722d30b1d17141$var$SubscribedQualityUpdate = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.SubscribedQualityUpdate", ()=>[
        {
            no: 1,
            name: "track_sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "subscribed_qualities",
            kind: "message",
            T: $c0722d30b1d17141$var$SubscribedQuality,
            repeated: true
        },
        {
            no: 3,
            name: "subscribed_codecs",
            kind: "message",
            T: $c0722d30b1d17141$var$SubscribedCodec,
            repeated: true
        }
    ]);
const $c0722d30b1d17141$var$SubscribedAudioCodecUpdate = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.SubscribedAudioCodecUpdate", ()=>[
        {
            no: 1,
            name: "track_sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "subscribed_audio_codecs",
            kind: "message",
            T: $c0722d30b1d17141$var$SubscribedAudioCodec,
            repeated: true
        }
    ]);
const $c0722d30b1d17141$var$TrackPermission = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.TrackPermission", ()=>[
        {
            no: 1,
            name: "participant_sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "all_tracks",
            kind: "scalar",
            T: 8
        },
        {
            no: 3,
            name: "track_sids",
            kind: "scalar",
            T: 9,
            repeated: true
        },
        {
            no: 4,
            name: "participant_identity",
            kind: "scalar",
            T: 9
        }
    ]);
const $c0722d30b1d17141$var$SubscriptionPermission = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.SubscriptionPermission", ()=>[
        {
            no: 1,
            name: "all_participants",
            kind: "scalar",
            T: 8
        },
        {
            no: 2,
            name: "track_permissions",
            kind: "message",
            T: $c0722d30b1d17141$var$TrackPermission,
            repeated: true
        }
    ]);
const $c0722d30b1d17141$var$SubscriptionPermissionUpdate = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.SubscriptionPermissionUpdate", ()=>[
        {
            no: 1,
            name: "participant_sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "track_sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "allowed",
            kind: "scalar",
            T: 8
        }
    ]);
const $c0722d30b1d17141$var$RoomMovedResponse = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.RoomMovedResponse", ()=>[
        {
            no: 1,
            name: "room",
            kind: "message",
            T: $c0722d30b1d17141$var$Room$1
        },
        {
            no: 2,
            name: "token",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "participant",
            kind: "message",
            T: $c0722d30b1d17141$var$ParticipantInfo
        },
        {
            no: 4,
            name: "other_participants",
            kind: "message",
            T: $c0722d30b1d17141$var$ParticipantInfo,
            repeated: true
        }
    ]);
const $c0722d30b1d17141$var$SyncState = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.SyncState", ()=>[
        {
            no: 1,
            name: "answer",
            kind: "message",
            T: $c0722d30b1d17141$var$SessionDescription
        },
        {
            no: 2,
            name: "subscription",
            kind: "message",
            T: $c0722d30b1d17141$var$UpdateSubscription
        },
        {
            no: 3,
            name: "publish_tracks",
            kind: "message",
            T: $c0722d30b1d17141$var$TrackPublishedResponse,
            repeated: true
        },
        {
            no: 4,
            name: "data_channels",
            kind: "message",
            T: $c0722d30b1d17141$var$DataChannelInfo,
            repeated: true
        },
        {
            no: 5,
            name: "offer",
            kind: "message",
            T: $c0722d30b1d17141$var$SessionDescription
        },
        {
            no: 6,
            name: "track_sids_disabled",
            kind: "scalar",
            T: 9,
            repeated: true
        },
        {
            no: 7,
            name: "datachannel_receive_states",
            kind: "message",
            T: $c0722d30b1d17141$var$DataChannelReceiveState,
            repeated: true
        },
        {
            no: 8,
            name: "publish_data_tracks",
            kind: "message",
            T: $c0722d30b1d17141$var$PublishDataTrackResponse,
            repeated: true
        }
    ]);
const $c0722d30b1d17141$var$DataChannelReceiveState = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.DataChannelReceiveState", ()=>[
        {
            no: 1,
            name: "publisher_sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "last_seq",
            kind: "scalar",
            T: 13
        }
    ]);
const $c0722d30b1d17141$var$DataChannelInfo = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.DataChannelInfo", ()=>[
        {
            no: 1,
            name: "label",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 13
        },
        {
            no: 3,
            name: "target",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$var$SignalTarget)
        }
    ]);
const $c0722d30b1d17141$var$SimulateScenario = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.SimulateScenario", ()=>[
        {
            no: 1,
            name: "speaker_update",
            kind: "scalar",
            T: 5,
            oneof: "scenario"
        },
        {
            no: 2,
            name: "node_failure",
            kind: "scalar",
            T: 8,
            oneof: "scenario"
        },
        {
            no: 3,
            name: "migration",
            kind: "scalar",
            T: 8,
            oneof: "scenario"
        },
        {
            no: 4,
            name: "server_leave",
            kind: "scalar",
            T: 8,
            oneof: "scenario"
        },
        {
            no: 5,
            name: "switch_candidate_protocol",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$var$CandidateProtocol),
            oneof: "scenario"
        },
        {
            no: 6,
            name: "subscriber_bandwidth",
            kind: "scalar",
            T: 3,
            oneof: "scenario"
        },
        {
            no: 7,
            name: "disconnect_signal_on_resume",
            kind: "scalar",
            T: 8,
            oneof: "scenario"
        },
        {
            no: 8,
            name: "disconnect_signal_on_resume_no_messages",
            kind: "scalar",
            T: 8,
            oneof: "scenario"
        },
        {
            no: 9,
            name: "leave_request_full_reconnect",
            kind: "scalar",
            T: 8,
            oneof: "scenario"
        }
    ]);
const $c0722d30b1d17141$var$Ping = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.Ping", ()=>[
        {
            no: 1,
            name: "timestamp",
            kind: "scalar",
            T: 3
        },
        {
            no: 2,
            name: "rtt",
            kind: "scalar",
            T: 3
        }
    ]);
const $c0722d30b1d17141$var$Pong = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.Pong", ()=>[
        {
            no: 1,
            name: "last_ping_timestamp",
            kind: "scalar",
            T: 3
        },
        {
            no: 2,
            name: "timestamp",
            kind: "scalar",
            T: 3
        }
    ]);
const $c0722d30b1d17141$var$RegionSettings = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.RegionSettings", ()=>[
        {
            no: 1,
            name: "regions",
            kind: "message",
            T: $c0722d30b1d17141$var$RegionInfo,
            repeated: true
        }
    ]);
const $c0722d30b1d17141$var$RegionInfo = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.RegionInfo", ()=>[
        {
            no: 1,
            name: "region",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "url",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "distance",
            kind: "scalar",
            T: 3
        }
    ]);
const $c0722d30b1d17141$var$SubscriptionResponse = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.SubscriptionResponse", ()=>[
        {
            no: 1,
            name: "track_sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "err",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$export$7882d1e2e5429abf)
        }
    ]);
const $c0722d30b1d17141$var$RequestResponse = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.RequestResponse", ()=>[
        {
            no: 1,
            name: "request_id",
            kind: "scalar",
            T: 13
        },
        {
            no: 2,
            name: "reason",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$var$RequestResponse_Reason)
        },
        {
            no: 3,
            name: "message",
            kind: "scalar",
            T: 9
        },
        {
            no: 4,
            name: "trickle",
            kind: "message",
            T: $c0722d30b1d17141$var$TrickleRequest,
            oneof: "request"
        },
        {
            no: 5,
            name: "add_track",
            kind: "message",
            T: $c0722d30b1d17141$var$AddTrackRequest,
            oneof: "request"
        },
        {
            no: 6,
            name: "mute",
            kind: "message",
            T: $c0722d30b1d17141$var$MuteTrackRequest,
            oneof: "request"
        },
        {
            no: 7,
            name: "update_metadata",
            kind: "message",
            T: $c0722d30b1d17141$var$UpdateParticipantMetadata,
            oneof: "request"
        },
        {
            no: 8,
            name: "update_audio_track",
            kind: "message",
            T: $c0722d30b1d17141$var$UpdateLocalAudioTrack,
            oneof: "request"
        },
        {
            no: 9,
            name: "update_video_track",
            kind: "message",
            T: $c0722d30b1d17141$var$UpdateLocalVideoTrack,
            oneof: "request"
        },
        {
            no: 10,
            name: "publish_data_track",
            kind: "message",
            T: $c0722d30b1d17141$var$PublishDataTrackRequest,
            oneof: "request"
        },
        {
            no: 11,
            name: "unpublish_data_track",
            kind: "message",
            T: $c0722d30b1d17141$var$UnpublishDataTrackRequest,
            oneof: "request"
        }
    ]);
const $c0722d30b1d17141$var$RequestResponse_Reason = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeEnum("livekit.RequestResponse.Reason", [
    {
        no: 0,
        name: "OK"
    },
    {
        no: 1,
        name: "NOT_FOUND"
    },
    {
        no: 2,
        name: "NOT_ALLOWED"
    },
    {
        no: 3,
        name: "LIMIT_EXCEEDED"
    },
    {
        no: 4,
        name: "QUEUED"
    },
    {
        no: 5,
        name: "UNSUPPORTED_TYPE"
    },
    {
        no: 6,
        name: "UNCLASSIFIED_ERROR"
    },
    {
        no: 7,
        name: "INVALID_HANDLE"
    },
    {
        no: 8,
        name: "INVALID_NAME"
    },
    {
        no: 9,
        name: "DUPLICATE_HANDLE"
    },
    {
        no: 10,
        name: "DUPLICATE_NAME"
    }
]);
const $c0722d30b1d17141$var$TrackSubscribed = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.TrackSubscribed", ()=>[
        {
            no: 1,
            name: "track_sid",
            kind: "scalar",
            T: 9
        }
    ]);
const $c0722d30b1d17141$var$ConnectionSettings = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.ConnectionSettings", ()=>[
        {
            no: 1,
            name: "auto_subscribe",
            kind: "scalar",
            T: 8
        },
        {
            no: 2,
            name: "adaptive_stream",
            kind: "scalar",
            T: 8
        },
        {
            no: 3,
            name: "subscriber_allow_pause",
            kind: "scalar",
            T: 8,
            opt: true
        },
        {
            no: 4,
            name: "disable_ice_lite",
            kind: "scalar",
            T: 8
        },
        {
            no: 5,
            name: "auto_subscribe_data_track",
            kind: "scalar",
            T: 8,
            opt: true
        }
    ]);
const $c0722d30b1d17141$var$JoinRequest = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.JoinRequest", ()=>[
        {
            no: 1,
            name: "client_info",
            kind: "message",
            T: $c0722d30b1d17141$var$ClientInfo
        },
        {
            no: 2,
            name: "connection_settings",
            kind: "message",
            T: $c0722d30b1d17141$var$ConnectionSettings
        },
        {
            no: 3,
            name: "metadata",
            kind: "scalar",
            T: 9
        },
        {
            no: 4,
            name: "participant_attributes",
            kind: "map",
            K: 9,
            V: {
                kind: "scalar",
                T: 9
            }
        },
        {
            no: 5,
            name: "add_track_requests",
            kind: "message",
            T: $c0722d30b1d17141$var$AddTrackRequest,
            repeated: true
        },
        {
            no: 6,
            name: "publisher_offer",
            kind: "message",
            T: $c0722d30b1d17141$var$SessionDescription
        },
        {
            no: 7,
            name: "reconnect",
            kind: "scalar",
            T: 8
        },
        {
            no: 8,
            name: "reconnect_reason",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$var$ReconnectReason)
        },
        {
            no: 9,
            name: "participant_sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 10,
            name: "sync_state",
            kind: "message",
            T: $c0722d30b1d17141$var$SyncState
        }
    ]);
const $c0722d30b1d17141$var$WrappedJoinRequest = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.WrappedJoinRequest", ()=>[
        {
            no: 1,
            name: "compression",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$var$WrappedJoinRequest_Compression)
        },
        {
            no: 2,
            name: "join_request",
            kind: "scalar",
            T: 12
        }
    ]);
const $c0722d30b1d17141$var$WrappedJoinRequest_Compression = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeEnum("livekit.WrappedJoinRequest.Compression", [
    {
        no: 0,
        name: "NONE"
    },
    {
        no: 1,
        name: "GZIP"
    }
]);
const $c0722d30b1d17141$var$MediaSectionsRequirement = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.MediaSectionsRequirement", ()=>[
        {
            no: 1,
            name: "num_audios",
            kind: "scalar",
            T: 13
        },
        {
            no: 2,
            name: "num_videos",
            kind: "scalar",
            T: 13
        }
    ]);
const $c0722d30b1d17141$var$EncodingOptionsPreset = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeEnum("livekit.EncodingOptionsPreset", [
    {
        no: 0,
        name: "H264_720P_30"
    },
    {
        no: 1,
        name: "H264_720P_60"
    },
    {
        no: 2,
        name: "H264_1080P_30"
    },
    {
        no: 3,
        name: "H264_1080P_60"
    },
    {
        no: 4,
        name: "PORTRAIT_H264_720P_30"
    },
    {
        no: 5,
        name: "PORTRAIT_H264_720P_60"
    },
    {
        no: 6,
        name: "PORTRAIT_H264_1080P_30"
    },
    {
        no: 7,
        name: "PORTRAIT_H264_1080P_60"
    }
]);
const $c0722d30b1d17141$var$EncodedFileType = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeEnum("livekit.EncodedFileType", [
    {
        no: 0,
        name: "DEFAULT_FILETYPE"
    },
    {
        no: 1,
        name: "MP4"
    },
    {
        no: 2,
        name: "OGG"
    },
    {
        no: 3,
        name: "MP3"
    }
]);
const $c0722d30b1d17141$var$StreamProtocol = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeEnum("livekit.StreamProtocol", [
    {
        no: 0,
        name: "DEFAULT_PROTOCOL"
    },
    {
        no: 1,
        name: "RTMP"
    },
    {
        no: 2,
        name: "SRT"
    },
    {
        no: 3,
        name: "WEBSOCKET"
    }
]);
const $c0722d30b1d17141$var$SegmentedFileProtocol = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeEnum("livekit.SegmentedFileProtocol", [
    {
        no: 0,
        name: "DEFAULT_SEGMENTED_FILE_PROTOCOL"
    },
    {
        no: 1,
        name: "HLS_PROTOCOL"
    }
]);
const $c0722d30b1d17141$var$SegmentedFileSuffix = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeEnum("livekit.SegmentedFileSuffix", [
    {
        no: 0,
        name: "INDEX"
    },
    {
        no: 1,
        name: "TIMESTAMP"
    }
]);
const $c0722d30b1d17141$var$ImageFileSuffix = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeEnum("livekit.ImageFileSuffix", [
    {
        no: 0,
        name: "IMAGE_SUFFIX_INDEX"
    },
    {
        no: 1,
        name: "IMAGE_SUFFIX_TIMESTAMP"
    },
    {
        no: 2,
        name: "IMAGE_SUFFIX_NONE_OVERWRITE"
    }
]);
const $c0722d30b1d17141$var$AudioMixing = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeEnum("livekit.AudioMixing", [
    {
        no: 0,
        name: "DEFAULT_MIXING"
    },
    {
        no: 1,
        name: "DUAL_CHANNEL_AGENT"
    },
    {
        no: 2,
        name: "DUAL_CHANNEL_ALTERNATE"
    }
]);
const $c0722d30b1d17141$var$EncodingOptions = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.EncodingOptions", ()=>[
        {
            no: 1,
            name: "width",
            kind: "scalar",
            T: 5
        },
        {
            no: 2,
            name: "height",
            kind: "scalar",
            T: 5
        },
        {
            no: 3,
            name: "depth",
            kind: "scalar",
            T: 5
        },
        {
            no: 4,
            name: "framerate",
            kind: "scalar",
            T: 5
        },
        {
            no: 5,
            name: "audio_codec",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$var$AudioCodec)
        },
        {
            no: 6,
            name: "audio_bitrate",
            kind: "scalar",
            T: 5
        },
        {
            no: 7,
            name: "audio_frequency",
            kind: "scalar",
            T: 5
        },
        {
            no: 8,
            name: "video_codec",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$var$VideoCodec)
        },
        {
            no: 9,
            name: "video_bitrate",
            kind: "scalar",
            T: 5
        },
        {
            no: 10,
            name: "key_frame_interval",
            kind: "scalar",
            T: 1
        },
        {
            no: 11,
            name: "audio_quality",
            kind: "scalar",
            T: 5
        },
        {
            no: 12,
            name: "video_quality",
            kind: "scalar",
            T: 5
        }
    ]);
const $c0722d30b1d17141$var$StreamOutput = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.StreamOutput", ()=>[
        {
            no: 1,
            name: "protocol",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$var$StreamProtocol)
        },
        {
            no: 2,
            name: "urls",
            kind: "scalar",
            T: 9,
            repeated: true
        }
    ]);
const $c0722d30b1d17141$var$SegmentedFileOutput = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.SegmentedFileOutput", ()=>[
        {
            no: 1,
            name: "protocol",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$var$SegmentedFileProtocol)
        },
        {
            no: 2,
            name: "filename_prefix",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "playlist_name",
            kind: "scalar",
            T: 9
        },
        {
            no: 11,
            name: "live_playlist_name",
            kind: "scalar",
            T: 9
        },
        {
            no: 4,
            name: "segment_duration",
            kind: "scalar",
            T: 13
        },
        {
            no: 10,
            name: "filename_suffix",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$var$SegmentedFileSuffix)
        },
        {
            no: 8,
            name: "disable_manifest",
            kind: "scalar",
            T: 8
        },
        {
            no: 5,
            name: "s3",
            kind: "message",
            T: $c0722d30b1d17141$var$S3Upload,
            oneof: "output"
        },
        {
            no: 6,
            name: "gcp",
            kind: "message",
            T: $c0722d30b1d17141$var$GCPUpload,
            oneof: "output"
        },
        {
            no: 7,
            name: "azure",
            kind: "message",
            T: $c0722d30b1d17141$var$AzureBlobUpload,
            oneof: "output"
        },
        {
            no: 9,
            name: "aliOSS",
            kind: "message",
            T: $c0722d30b1d17141$var$AliOSSUpload,
            oneof: "output"
        }
    ]);
const $c0722d30b1d17141$var$ImageOutput = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.ImageOutput", ()=>[
        {
            no: 1,
            name: "capture_interval",
            kind: "scalar",
            T: 13
        },
        {
            no: 2,
            name: "width",
            kind: "scalar",
            T: 5
        },
        {
            no: 3,
            name: "height",
            kind: "scalar",
            T: 5
        },
        {
            no: 4,
            name: "filename_prefix",
            kind: "scalar",
            T: 9
        },
        {
            no: 5,
            name: "filename_suffix",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$var$ImageFileSuffix)
        },
        {
            no: 6,
            name: "image_codec",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$var$ImageCodec)
        },
        {
            no: 7,
            name: "disable_manifest",
            kind: "scalar",
            T: 8
        },
        {
            no: 8,
            name: "s3",
            kind: "message",
            T: $c0722d30b1d17141$var$S3Upload,
            oneof: "output"
        },
        {
            no: 9,
            name: "gcp",
            kind: "message",
            T: $c0722d30b1d17141$var$GCPUpload,
            oneof: "output"
        },
        {
            no: 10,
            name: "azure",
            kind: "message",
            T: $c0722d30b1d17141$var$AzureBlobUpload,
            oneof: "output"
        },
        {
            no: 11,
            name: "aliOSS",
            kind: "message",
            T: $c0722d30b1d17141$var$AliOSSUpload,
            oneof: "output"
        }
    ]);
const $c0722d30b1d17141$var$S3Upload = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.S3Upload", ()=>[
        {
            no: 1,
            name: "access_key",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "secret",
            kind: "scalar",
            T: 9
        },
        {
            no: 11,
            name: "session_token",
            kind: "scalar",
            T: 9
        },
        {
            no: 12,
            name: "assume_role_arn",
            kind: "scalar",
            T: 9
        },
        {
            no: 13,
            name: "assume_role_external_id",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "region",
            kind: "scalar",
            T: 9
        },
        {
            no: 4,
            name: "endpoint",
            kind: "scalar",
            T: 9
        },
        {
            no: 5,
            name: "bucket",
            kind: "scalar",
            T: 9
        },
        {
            no: 6,
            name: "force_path_style",
            kind: "scalar",
            T: 8
        },
        {
            no: 7,
            name: "metadata",
            kind: "map",
            K: 9,
            V: {
                kind: "scalar",
                T: 9
            }
        },
        {
            no: 8,
            name: "tagging",
            kind: "scalar",
            T: 9
        },
        {
            no: 9,
            name: "content_disposition",
            kind: "scalar",
            T: 9
        },
        {
            no: 10,
            name: "proxy",
            kind: "message",
            T: $c0722d30b1d17141$var$ProxyConfig
        }
    ]);
const $c0722d30b1d17141$var$GCPUpload = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.GCPUpload", ()=>[
        {
            no: 1,
            name: "credentials",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "bucket",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "proxy",
            kind: "message",
            T: $c0722d30b1d17141$var$ProxyConfig
        }
    ]);
const $c0722d30b1d17141$var$AzureBlobUpload = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.AzureBlobUpload", ()=>[
        {
            no: 1,
            name: "account_name",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "account_key",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "container_name",
            kind: "scalar",
            T: 9
        }
    ]);
const $c0722d30b1d17141$var$AliOSSUpload = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.AliOSSUpload", ()=>[
        {
            no: 1,
            name: "access_key",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "secret",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "region",
            kind: "scalar",
            T: 9
        },
        {
            no: 4,
            name: "endpoint",
            kind: "scalar",
            T: 9
        },
        {
            no: 5,
            name: "bucket",
            kind: "scalar",
            T: 9
        }
    ]);
const $c0722d30b1d17141$var$ProxyConfig = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.ProxyConfig", ()=>[
        {
            no: 1,
            name: "url",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "username",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "password",
            kind: "scalar",
            T: 9
        }
    ]);
const $c0722d30b1d17141$var$AutoParticipantEgress = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.AutoParticipantEgress", ()=>[
        {
            no: 1,
            name: "preset",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$var$EncodingOptionsPreset),
            oneof: "options"
        },
        {
            no: 2,
            name: "advanced",
            kind: "message",
            T: $c0722d30b1d17141$var$EncodingOptions,
            oneof: "options"
        },
        {
            no: 3,
            name: "file_outputs",
            kind: "message",
            T: $c0722d30b1d17141$var$EncodedFileOutput,
            repeated: true
        },
        {
            no: 4,
            name: "segment_outputs",
            kind: "message",
            T: $c0722d30b1d17141$var$SegmentedFileOutput,
            repeated: true
        }
    ]);
const $c0722d30b1d17141$var$AutoTrackEgress = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.AutoTrackEgress", ()=>[
        {
            no: 1,
            name: "filepath",
            kind: "scalar",
            T: 9
        },
        {
            no: 5,
            name: "disable_manifest",
            kind: "scalar",
            T: 8
        },
        {
            no: 2,
            name: "s3",
            kind: "message",
            T: $c0722d30b1d17141$var$S3Upload,
            oneof: "output"
        },
        {
            no: 3,
            name: "gcp",
            kind: "message",
            T: $c0722d30b1d17141$var$GCPUpload,
            oneof: "output"
        },
        {
            no: 4,
            name: "azure",
            kind: "message",
            T: $c0722d30b1d17141$var$AzureBlobUpload,
            oneof: "output"
        },
        {
            no: 6,
            name: "aliOSS",
            kind: "message",
            T: $c0722d30b1d17141$var$AliOSSUpload,
            oneof: "output"
        }
    ]);
const $c0722d30b1d17141$var$RoomCompositeEgressRequest = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.RoomCompositeEgressRequest", ()=>[
        {
            no: 1,
            name: "room_name",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "layout",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "audio_only",
            kind: "scalar",
            T: 8
        },
        {
            no: 15,
            name: "audio_mixing",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$var$AudioMixing)
        },
        {
            no: 4,
            name: "video_only",
            kind: "scalar",
            T: 8
        },
        {
            no: 5,
            name: "custom_base_url",
            kind: "scalar",
            T: 9
        },
        {
            no: 6,
            name: "file",
            kind: "message",
            T: $c0722d30b1d17141$var$EncodedFileOutput,
            oneof: "output"
        },
        {
            no: 7,
            name: "stream",
            kind: "message",
            T: $c0722d30b1d17141$var$StreamOutput,
            oneof: "output"
        },
        {
            no: 10,
            name: "segments",
            kind: "message",
            T: $c0722d30b1d17141$var$SegmentedFileOutput,
            oneof: "output"
        },
        {
            no: 8,
            name: "preset",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$var$EncodingOptionsPreset),
            oneof: "options"
        },
        {
            no: 9,
            name: "advanced",
            kind: "message",
            T: $c0722d30b1d17141$var$EncodingOptions,
            oneof: "options"
        },
        {
            no: 11,
            name: "file_outputs",
            kind: "message",
            T: $c0722d30b1d17141$var$EncodedFileOutput,
            repeated: true
        },
        {
            no: 12,
            name: "stream_outputs",
            kind: "message",
            T: $c0722d30b1d17141$var$StreamOutput,
            repeated: true
        },
        {
            no: 13,
            name: "segment_outputs",
            kind: "message",
            T: $c0722d30b1d17141$var$SegmentedFileOutput,
            repeated: true
        },
        {
            no: 14,
            name: "image_outputs",
            kind: "message",
            T: $c0722d30b1d17141$var$ImageOutput,
            repeated: true
        },
        {
            no: 16,
            name: "webhooks",
            kind: "message",
            T: $c0722d30b1d17141$var$WebhookConfig,
            repeated: true
        }
    ]);
const $c0722d30b1d17141$var$EncodedFileOutput = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.EncodedFileOutput", ()=>[
        {
            no: 1,
            name: "file_type",
            kind: "enum",
            T: $c0722d30b1d17141$var$proto3.getEnumType($c0722d30b1d17141$var$EncodedFileType)
        },
        {
            no: 2,
            name: "filepath",
            kind: "scalar",
            T: 9
        },
        {
            no: 6,
            name: "disable_manifest",
            kind: "scalar",
            T: 8
        },
        {
            no: 3,
            name: "s3",
            kind: "message",
            T: $c0722d30b1d17141$var$S3Upload,
            oneof: "output"
        },
        {
            no: 4,
            name: "gcp",
            kind: "message",
            T: $c0722d30b1d17141$var$GCPUpload,
            oneof: "output"
        },
        {
            no: 5,
            name: "azure",
            kind: "message",
            T: $c0722d30b1d17141$var$AzureBlobUpload,
            oneof: "output"
        },
        {
            no: 7,
            name: "aliOSS",
            kind: "message",
            T: $c0722d30b1d17141$var$AliOSSUpload,
            oneof: "output"
        }
    ]);
const $c0722d30b1d17141$var$RoomEgress = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.RoomEgress", ()=>[
        {
            no: 1,
            name: "room",
            kind: "message",
            T: $c0722d30b1d17141$var$RoomCompositeEgressRequest
        },
        {
            no: 3,
            name: "participant",
            kind: "message",
            T: $c0722d30b1d17141$var$AutoParticipantEgress
        },
        {
            no: 2,
            name: "tracks",
            kind: "message",
            T: $c0722d30b1d17141$var$AutoTrackEgress
        }
    ]);
const $c0722d30b1d17141$var$RoomConfiguration = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.RoomConfiguration", ()=>[
        {
            no: 1,
            name: "name",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "empty_timeout",
            kind: "scalar",
            T: 13
        },
        {
            no: 3,
            name: "departure_timeout",
            kind: "scalar",
            T: 13
        },
        {
            no: 4,
            name: "max_participants",
            kind: "scalar",
            T: 13
        },
        {
            no: 11,
            name: "metadata",
            kind: "scalar",
            T: 9
        },
        {
            no: 5,
            name: "egress",
            kind: "message",
            T: $c0722d30b1d17141$var$RoomEgress
        },
        {
            no: 7,
            name: "min_playout_delay",
            kind: "scalar",
            T: 13
        },
        {
            no: 8,
            name: "max_playout_delay",
            kind: "scalar",
            T: 13
        },
        {
            no: 9,
            name: "sync_streams",
            kind: "scalar",
            T: 8
        },
        {
            no: 10,
            name: "agents",
            kind: "message",
            T: $c0722d30b1d17141$var$RoomAgentDispatch,
            repeated: true
        },
        {
            no: 12,
            name: "tags",
            kind: "map",
            K: 9,
            V: {
                kind: "scalar",
                T: 9
            }
        }
    ]);
const $c0722d30b1d17141$var$TokenSourceRequest = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.TokenSourceRequest", ()=>[
        {
            no: 1,
            name: "room_name",
            kind: "scalar",
            T: 9,
            opt: true
        },
        {
            no: 2,
            name: "participant_name",
            kind: "scalar",
            T: 9,
            opt: true
        },
        {
            no: 3,
            name: "participant_identity",
            kind: "scalar",
            T: 9,
            opt: true
        },
        {
            no: 4,
            name: "participant_metadata",
            kind: "scalar",
            T: 9,
            opt: true
        },
        {
            no: 5,
            name: "participant_attributes",
            kind: "map",
            K: 9,
            V: {
                kind: "scalar",
                T: 9
            }
        },
        {
            no: 6,
            name: "room_config",
            kind: "message",
            T: $c0722d30b1d17141$var$RoomConfiguration,
            opt: true
        }
    ]);
const $c0722d30b1d17141$var$TokenSourceResponse = /* @__PURE__ */ $c0722d30b1d17141$var$proto3.makeMessageType("livekit.TokenSourceResponse", ()=>[
        {
            no: 1,
            name: "server_url",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "participant_token",
            kind: "scalar",
            T: 9
        }
    ]);
function $c0722d30b1d17141$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
var $c0722d30b1d17141$var$loglevel$1 = {
    exports: {}
}; /*
* loglevel - https://github.com/pimterry/loglevel
*
* Copyright (c) 2013 Tim Perry
* Licensed under the MIT license.
*/ 
var $c0722d30b1d17141$var$loglevel = $c0722d30b1d17141$var$loglevel$1.exports;
var $c0722d30b1d17141$var$hasRequiredLoglevel;
function $c0722d30b1d17141$var$requireLoglevel() {
    if ($c0722d30b1d17141$var$hasRequiredLoglevel) return $c0722d30b1d17141$var$loglevel$1.exports;
    $c0722d30b1d17141$var$hasRequiredLoglevel = 1;
    (function(module) {
        (function(root, definition) {
            if (module.exports) module.exports = definition();
            else root.log = definition();
        })($c0722d30b1d17141$var$loglevel, function() {
            // Slightly dubious tricks to cut down minimized file size
            var noop = function() {};
            var undefinedType = "undefined";
            var isIE = typeof window !== undefinedType && typeof window.navigator !== undefinedType && /Trident\/|MSIE /.test(window.navigator.userAgent);
            var logMethods = [
                "trace",
                "debug",
                "info",
                "warn",
                "error"
            ];
            var _loggersByName = {};
            var defaultLogger = null;
            // Cross-browser bind equivalent that works at least back to IE6
            function bindMethod(obj, methodName) {
                var method = obj[methodName];
                if (typeof method.bind === 'function') return method.bind(obj);
                else try {
                    return Function.prototype.bind.call(method, obj);
                } catch (e) {
                    // Missing bind shim or IE8 + Modernizr, fallback to wrapping
                    return function() {
                        return Function.prototype.apply.apply(method, [
                            obj,
                            arguments
                        ]);
                    };
                }
            }
            // Trace() doesn't print the message in IE, so for that case we need to wrap it
            function traceForIE() {
                if (console.log) {
                    if (console.log.apply) console.log.apply(console, arguments);
                    else // In old IE, native console methods themselves don't have apply().
                    Function.prototype.apply.apply(console.log, [
                        console,
                        arguments
                    ]);
                }
                if (console.trace) console.trace();
            }
            // Build the best logging method possible for this env
            // Wherever possible we want to bind, not wrap, to preserve stack traces
            function realMethod(methodName) {
                if (methodName === 'debug') methodName = 'log';
                if (typeof console === undefinedType) return false; // No method possible, for now - fixed later by enableLoggingWhenConsoleArrives
                else if (methodName === 'trace' && isIE) return traceForIE;
                else if (console[methodName] !== undefined) return bindMethod(console, methodName);
                else if (console.log !== undefined) return bindMethod(console, 'log');
                else return noop;
            }
            // These private functions always need `this` to be set properly
            function replaceLoggingMethods() {
                /*jshint validthis:true */ var level = this.getLevel();
                // Replace the actual methods.
                for(var i = 0; i < logMethods.length; i++){
                    var methodName = logMethods[i];
                    this[methodName] = i < level ? noop : this.methodFactory(methodName, level, this.name);
                }
                // Define log.log as an alias for log.debug
                this.log = this.debug;
                // Return any important warnings.
                if (typeof console === undefinedType && level < this.levels.SILENT) return "No console available for logging";
            }
            // In old IE versions, the console isn't present until you first open it.
            // We build realMethod() replacements here that regenerate logging methods
            function enableLoggingWhenConsoleArrives(methodName) {
                return function() {
                    if (typeof console !== undefinedType) {
                        replaceLoggingMethods.call(this);
                        this[methodName].apply(this, arguments);
                    }
                };
            }
            // By default, we use closely bound real methods wherever possible, and
            // otherwise we wait for a console to appear, and then try again.
            function defaultMethodFactory(methodName, _level, _loggerName) {
                /*jshint validthis:true */ return realMethod(methodName) || enableLoggingWhenConsoleArrives.apply(this, arguments);
            }
            function Logger(name, factory) {
                // Private instance variables.
                var self = this;
                /**
         * The level inherited from a parent logger (or a global default). We
         * cache this here rather than delegating to the parent so that it stays
         * in sync with the actual logging methods that we have installed (the
         * parent could change levels but we might not have rebuilt the loggers
         * in this child yet).
         * @type {number}
         */ var inheritedLevel;
                /**
         * The default level for this logger, if any. If set, this overrides
         * `inheritedLevel`.
         * @type {number|null}
         */ var defaultLevel;
                /**
         * A user-specific level for this logger. If set, this overrides
         * `defaultLevel`.
         * @type {number|null}
         */ var userLevel;
                var storageKey = "loglevel";
                if (typeof name === "string") storageKey += ":" + name;
                else if (typeof name === "symbol") storageKey = undefined;
                function persistLevelIfPossible(levelNum) {
                    var levelName = (logMethods[levelNum] || 'silent').toUpperCase();
                    if (typeof window === undefinedType || !storageKey) return;
                    // Use localStorage if available
                    try {
                        window.localStorage[storageKey] = levelName;
                        return;
                    } catch (ignore) {}
                    // Use session cookie as fallback
                    try {
                        window.document.cookie = encodeURIComponent(storageKey) + "=" + levelName + ";";
                    } catch (ignore) {}
                }
                function getPersistedLevel() {
                    var storedLevel;
                    if (typeof window === undefinedType || !storageKey) return;
                    try {
                        storedLevel = window.localStorage[storageKey];
                    } catch (ignore) {}
                    // Fallback to cookies if local storage gives us nothing
                    if (typeof storedLevel === undefinedType) try {
                        var cookie = window.document.cookie;
                        var cookieName = encodeURIComponent(storageKey);
                        var location = cookie.indexOf(cookieName + "=");
                        if (location !== -1) storedLevel = /^([^;]+)/.exec(cookie.slice(location + cookieName.length + 1))[1];
                    } catch (ignore) {}
                    // If the stored level is not valid, treat it as if nothing was stored.
                    if (self.levels[storedLevel] === undefined) storedLevel = undefined;
                    return storedLevel;
                }
                function clearPersistedLevel() {
                    if (typeof window === undefinedType || !storageKey) return;
                    // Use localStorage if available
                    try {
                        window.localStorage.removeItem(storageKey);
                    } catch (ignore) {}
                    // Use session cookie as fallback
                    try {
                        window.document.cookie = encodeURIComponent(storageKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
                    } catch (ignore) {}
                }
                function normalizeLevel(input) {
                    var level = input;
                    if (typeof level === "string" && self.levels[level.toUpperCase()] !== undefined) level = self.levels[level.toUpperCase()];
                    if (typeof level === "number" && level >= 0 && level <= self.levels.SILENT) return level;
                    else throw new TypeError("log.setLevel() called with invalid level: " + input);
                }
                /*
         *
         * Public logger API - see https://github.com/pimterry/loglevel for details
         *
         */ self.name = name;
                self.levels = {
                    "TRACE": 0,
                    "DEBUG": 1,
                    "INFO": 2,
                    "WARN": 3,
                    "ERROR": 4,
                    "SILENT": 5
                };
                self.methodFactory = factory || defaultMethodFactory;
                self.getLevel = function() {
                    if (userLevel != null) return userLevel;
                    else if (defaultLevel != null) return defaultLevel;
                    else return inheritedLevel;
                };
                self.setLevel = function(level, persist) {
                    userLevel = normalizeLevel(level);
                    if (persist !== false) // defaults to true
                    persistLevelIfPossible(userLevel);
                    // NOTE: in v2, this should call rebuild(), which updates children.
                    return replaceLoggingMethods.call(self);
                };
                self.setDefaultLevel = function(level) {
                    defaultLevel = normalizeLevel(level);
                    if (!getPersistedLevel()) self.setLevel(level, false);
                };
                self.resetLevel = function() {
                    userLevel = null;
                    clearPersistedLevel();
                    replaceLoggingMethods.call(self);
                };
                self.enableAll = function(persist) {
                    self.setLevel(self.levels.TRACE, persist);
                };
                self.disableAll = function(persist) {
                    self.setLevel(self.levels.SILENT, persist);
                };
                self.rebuild = function() {
                    if (defaultLogger !== self) inheritedLevel = normalizeLevel(defaultLogger.getLevel());
                    replaceLoggingMethods.call(self);
                    if (defaultLogger === self) for(var childName in _loggersByName)_loggersByName[childName].rebuild();
                };
                // Initialize all the internal levels.
                inheritedLevel = normalizeLevel(defaultLogger ? defaultLogger.getLevel() : "WARN");
                var initialLevel = getPersistedLevel();
                if (initialLevel != null) userLevel = normalizeLevel(initialLevel);
                replaceLoggingMethods.call(self);
            }
            /*
       *
       * Top-level API
       *
       */ defaultLogger = new Logger();
            defaultLogger.getLogger = function getLogger(name) {
                if (typeof name !== "symbol" && typeof name !== "string" || name === "") throw new TypeError("You must supply a name when creating a logger.");
                var logger = _loggersByName[name];
                if (!logger) logger = _loggersByName[name] = new Logger(name, defaultLogger.methodFactory);
                return logger;
            };
            // Grab the current global log variable in case of overwrite
            var _log = typeof window !== undefinedType ? window.log : undefined;
            defaultLogger.noConflict = function() {
                if (typeof window !== undefinedType && window.log === defaultLogger) window.log = _log;
                return defaultLogger;
            };
            defaultLogger.getLoggers = function getLoggers() {
                return _loggersByName;
            };
            // ES6 default export, for compatibility
            defaultLogger['default'] = defaultLogger;
            return defaultLogger;
        });
    })($c0722d30b1d17141$var$loglevel$1);
    return $c0722d30b1d17141$var$loglevel$1.exports;
}
var $c0722d30b1d17141$var$loglevelExports = $c0722d30b1d17141$var$requireLoglevel();
var $c0722d30b1d17141$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["trace"] = 0] = "trace";
    LogLevel[LogLevel["debug"] = 1] = "debug";
    LogLevel[LogLevel["info"] = 2] = "info";
    LogLevel[LogLevel["warn"] = 3] = "warn";
    LogLevel[LogLevel["error"] = 4] = "error";
    LogLevel[LogLevel["silent"] = 5] = "silent";
})($c0722d30b1d17141$export$243e62d78d3b544d || ($c0722d30b1d17141$export$243e62d78d3b544d = {}));
var $c0722d30b1d17141$export$69ba24dd79f4da21;
(function(LoggerNames) {
    LoggerNames["Default"] = "livekit";
    LoggerNames["Room"] = "livekit-room";
    LoggerNames["TokenSource"] = "livekit-token-source";
    LoggerNames["Participant"] = "livekit-participant";
    LoggerNames["Track"] = "livekit-track";
    LoggerNames["Publication"] = "livekit-track-publication";
    LoggerNames["Engine"] = "livekit-engine";
    LoggerNames["Signal"] = "livekit-signal";
    LoggerNames["PCManager"] = "livekit-pc-manager";
    LoggerNames["PCTransport"] = "livekit-pc-transport";
    LoggerNames["E2EE"] = "lk-e2ee";
    LoggerNames["DataTracks"] = "livekit-data-tracks";
})($c0722d30b1d17141$export$69ba24dd79f4da21 || ($c0722d30b1d17141$export$69ba24dd79f4da21 = {}));
let $c0722d30b1d17141$var$livekitLogger = $c0722d30b1d17141$var$loglevelExports.getLogger($c0722d30b1d17141$export$69ba24dd79f4da21.Default);
const $c0722d30b1d17141$var$livekitLoggers = Object.values($c0722d30b1d17141$export$69ba24dd79f4da21).map((name)=>$c0722d30b1d17141$var$loglevelExports.getLogger(name));
$c0722d30b1d17141$var$livekitLogger.setDefaultLevel($c0722d30b1d17141$export$243e62d78d3b544d.info);
/**
 * @internal
 *
 * Get a named logger. When `ctxFn` is supplied, every log call
 * automatically:
 * 1. prepends a `[key=value ...]` prefix derived from `ctxFn()` to the
 *    message string, so identifiers are visible in browser devtools
 *    without expanding the structured context object, and
 * 2. merges `ctxFn()` into the structured context passed to any
 *    `setLogExtension` consumer, so ingestion pipelines continue to
 *    receive the full metadata unchanged.
 */ function $c0722d30b1d17141$export$2b1d391cd05230fd(name, ctxFn) {
    const logger = $c0722d30b1d17141$var$loglevelExports.getLogger(name);
    logger.setDefaultLevel($c0722d30b1d17141$var$livekitLogger.getLevel());
    if (!ctxFn) return logger;
    return $c0722d30b1d17141$var$wrapWithContext(logger, ctxFn);
}
function $c0722d30b1d17141$var$wrapWithContext(base, ctxFn) {
    // Resolve the underlying method on every call so that later
    // setLogExtension installations (which replace the base logger's
    // methods via loglevel's methodFactory) are picked up.
    const wrap = (method)=>(msg, extra)=>{
            const ctx = ctxFn();
            const merged = ctx || extra ? Object.assign(Object.assign({}, ctx), extra) : undefined;
            base[method](msg, merged);
        };
    const proxy = Object.create(base);
    proxy.trace = wrap('trace');
    proxy.debug = wrap('debug');
    proxy.info = wrap('info');
    proxy.warn = wrap('warn');
    proxy.error = wrap('error');
    return proxy;
}
function $c0722d30b1d17141$export$c622e99c0ce7b1c9(level, loggerName) {
    if (loggerName) $c0722d30b1d17141$var$loglevelExports.getLogger(loggerName).setLevel(level);
    else for (const logger of $c0722d30b1d17141$var$livekitLoggers)logger.setLevel(level);
}
/**
 * use this to hook into the logging function to allow sending internal livekit logs to third party services
 * if set, the browser logs will lose their stacktrace information (see https://github.com/pimterry/loglevel#writing-plugins)
 */ function $c0722d30b1d17141$export$fd7435ba5a9de34b(extension, logger) {
    const loggers = logger ? [
        logger
    ] : $c0722d30b1d17141$var$livekitLoggers;
    loggers.forEach((logR)=>{
        const originalFactory = logR.methodFactory;
        logR.methodFactory = (methodName, configLevel, loggerName)=>{
            const rawMethod = originalFactory(methodName, configLevel, loggerName);
            const logLevel = $c0722d30b1d17141$export$243e62d78d3b544d[methodName];
            const needLog = logLevel >= configLevel && logLevel < $c0722d30b1d17141$export$243e62d78d3b544d.silent;
            return (msg, context)=>{
                if (context) rawMethod(msg, context);
                else rawMethod(msg);
                if (needLog) extension(logLevel, msg, context);
            };
        };
        logR.setLevel(logR.getLevel());
    });
}
const $c0722d30b1d17141$var$workerLogger = $c0722d30b1d17141$var$loglevelExports.getLogger($c0722d30b1d17141$export$69ba24dd79f4da21.E2EE);
const $c0722d30b1d17141$var$maxRetryDelay = 7000;
const $c0722d30b1d17141$var$DEFAULT_RETRY_DELAYS_IN_MS = [
    0,
    300,
    1200,
    2700,
    4800,
    $c0722d30b1d17141$var$maxRetryDelay,
    $c0722d30b1d17141$var$maxRetryDelay,
    $c0722d30b1d17141$var$maxRetryDelay,
    $c0722d30b1d17141$var$maxRetryDelay,
    $c0722d30b1d17141$var$maxRetryDelay
];
class $c0722d30b1d17141$export$97bc471d6a059e6e {
    constructor(retryDelays){
        this._retryDelays = retryDelays !== undefined ? [
            ...retryDelays
        ] : $c0722d30b1d17141$var$DEFAULT_RETRY_DELAYS_IN_MS;
    }
    nextRetryDelayInMs(context) {
        if (context.retryCount >= this._retryDelays.length) return null;
        const retryDelay = this._retryDelays[context.retryCount];
        if (context.retryCount <= 1) return retryDelay;
        return retryDelay + Math.random() * 1000;
    }
} /******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ 
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */ function $c0722d30b1d17141$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $c0722d30b1d17141$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $c0722d30b1d17141$var$__values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $c0722d30b1d17141$var$__await(v) {
    return this instanceof $c0722d30b1d17141$var$__await ? (this.v = v, this) : new $c0722d30b1d17141$var$__await(v);
}
function $c0722d30b1d17141$var$__asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $c0722d30b1d17141$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $c0722d30b1d17141$var$__asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $c0722d30b1d17141$var$__await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $c0722d30b1d17141$var$__asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $c0722d30b1d17141$var$__values === "function" ? $c0722d30b1d17141$var$__values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
typeof SuppressedError === "function" && SuppressedError;
var $c0722d30b1d17141$var$events = {
    exports: {}
};
var $c0722d30b1d17141$var$hasRequiredEvents;
function $c0722d30b1d17141$var$requireEvents() {
    if ($c0722d30b1d17141$var$hasRequiredEvents) return $c0722d30b1d17141$var$events.exports;
    $c0722d30b1d17141$var$hasRequiredEvents = 1;
    var R = typeof Reflect === 'object' ? Reflect : null;
    var ReflectApply = R && typeof R.apply === 'function' ? R.apply : function ReflectApply(target, receiver, args) {
        return Function.prototype.apply.call(target, receiver, args);
    };
    var ReflectOwnKeys;
    if (R && typeof R.ownKeys === 'function') ReflectOwnKeys = R.ownKeys;
    else if (Object.getOwnPropertySymbols) ReflectOwnKeys = function ReflectOwnKeys(target) {
        return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
    };
    else ReflectOwnKeys = function ReflectOwnKeys(target) {
        return Object.getOwnPropertyNames(target);
    };
    function ProcessEmitWarning(warning) {
        if (console && console.warn) console.warn(warning);
    }
    var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
        return value !== value;
    };
    function EventEmitter() {
        EventEmitter.init.call(this);
    }
    $c0722d30b1d17141$var$events.exports = EventEmitter;
    $c0722d30b1d17141$var$events.exports.once = once;
    // Backwards-compat with node 0.10.x
    EventEmitter.EventEmitter = EventEmitter;
    EventEmitter.prototype._events = undefined;
    EventEmitter.prototype._eventsCount = 0;
    EventEmitter.prototype._maxListeners = undefined;
    // By default EventEmitters will print a warning if more than 10 listeners are
    // added to it. This is a useful default which helps finding memory leaks.
    var defaultMaxListeners = 10;
    function checkListener(listener) {
        if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
    }
    Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
        enumerable: true,
        get: function() {
            return defaultMaxListeners;
        },
        set: function(arg) {
            if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
            defaultMaxListeners = arg;
        }
    });
    EventEmitter.init = function() {
        if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        }
        this._maxListeners = this._maxListeners || undefined;
    };
    // Obviously not all Emitters should be limited to 10. This function allows
    // that to be increased. Set to zero for unlimited.
    EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
        if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
        this._maxListeners = n;
        return this;
    };
    function _getMaxListeners(that) {
        if (that._maxListeners === undefined) return EventEmitter.defaultMaxListeners;
        return that._maxListeners;
    }
    EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
        return _getMaxListeners(this);
    };
    EventEmitter.prototype.emit = function emit(type) {
        var args = [];
        for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
        var doError = type === 'error';
        var events = this._events;
        if (events !== undefined) doError = doError && events.error === undefined;
        else if (!doError) return false;
        // If there is no 'error' event listener then throw.
        if (doError) {
            var er;
            if (args.length > 0) er = args[0];
            if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
            // up in Node's output if this results in an unhandled exception.
            throw er; // Unhandled 'error' event
            // At least give some kind of context to the user
            var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
            err.context = er;
            throw err; // Unhandled 'error' event
        }
        var handler = events[type];
        if (handler === undefined) return false;
        if (typeof handler === 'function') ReflectApply(handler, this, args);
        else {
            var len = handler.length;
            var listeners = arrayClone(handler, len);
            for(var i = 0; i < len; ++i)ReflectApply(listeners[i], this, args);
        }
        return true;
    };
    function _addListener(target, type, listener, prepend) {
        var m;
        var events;
        var existing;
        checkListener(listener);
        events = target._events;
        if (events === undefined) {
            events = target._events = Object.create(null);
            target._eventsCount = 0;
        } else {
            // To avoid recursion in the case that type === "newListener"! Before
            // adding it to the listeners, first emit "newListener".
            if (events.newListener !== undefined) {
                target.emit('newListener', type, listener.listener ? listener.listener : listener);
                // Re-assign `events` because a newListener handler could have caused the
                // this._events to be assigned to a new object
                events = target._events;
            }
            existing = events[type];
        }
        if (existing === undefined) {
            // Optimize the case of one listener. Don't need the extra array object.
            existing = events[type] = listener;
            ++target._eventsCount;
        } else {
            if (typeof existing === 'function') // Adding the second element, need to change to array.
            existing = events[type] = prepend ? [
                listener,
                existing
            ] : [
                existing,
                listener
            ];
            else if (prepend) existing.unshift(listener);
            else existing.push(listener);
            // Check for listener leak
            m = _getMaxListeners(target);
            if (m > 0 && existing.length > m && !existing.warned) {
                existing.warned = true;
                // No error code for this since it is a Warning
                // eslint-disable-next-line no-restricted-syntax
                var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
                w.name = 'MaxListenersExceededWarning';
                w.emitter = target;
                w.type = type;
                w.count = existing.length;
                ProcessEmitWarning(w);
            }
        }
        return target;
    }
    EventEmitter.prototype.addListener = function addListener(type, listener) {
        return _addListener(this, type, listener, false);
    };
    EventEmitter.prototype.on = EventEmitter.prototype.addListener;
    EventEmitter.prototype.prependListener = function prependListener(type, listener) {
        return _addListener(this, type, listener, true);
    };
    function onceWrapper() {
        if (!this.fired) {
            this.target.removeListener(this.type, this.wrapFn);
            this.fired = true;
            if (arguments.length === 0) return this.listener.call(this.target);
            return this.listener.apply(this.target, arguments);
        }
    }
    function _onceWrap(target, type, listener) {
        var state = {
            fired: false,
            wrapFn: undefined,
            target: target,
            type: type,
            listener: listener
        };
        var wrapped = onceWrapper.bind(state);
        wrapped.listener = listener;
        state.wrapFn = wrapped;
        return wrapped;
    }
    EventEmitter.prototype.once = function once(type, listener) {
        checkListener(listener);
        this.on(type, _onceWrap(this, type, listener));
        return this;
    };
    EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
        checkListener(listener);
        this.prependListener(type, _onceWrap(this, type, listener));
        return this;
    };
    // Emits a 'removeListener' event if and only if the listener was removed.
    EventEmitter.prototype.removeListener = function removeListener(type, listener) {
        var list, events, position, i, originalListener;
        checkListener(listener);
        events = this._events;
        if (events === undefined) return this;
        list = events[type];
        if (list === undefined) return this;
        if (list === listener || list.listener === listener) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else {
                delete events[type];
                if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
            }
        } else if (typeof list !== 'function') {
            position = -1;
            for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
                originalListener = list[i].listener;
                position = i;
                break;
            }
            if (position < 0) return this;
            if (position === 0) list.shift();
            else spliceOne(list, position);
            if (list.length === 1) events[type] = list[0];
            if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
        }
        return this;
    };
    EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
    EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
        var listeners, events, i;
        events = this._events;
        if (events === undefined) return this;
        // not listening for removeListener, no need to emit
        if (events.removeListener === undefined) {
            if (arguments.length === 0) {
                this._events = Object.create(null);
                this._eventsCount = 0;
            } else if (events[type] !== undefined) {
                if (--this._eventsCount === 0) this._events = Object.create(null);
                else delete events[type];
            }
            return this;
        }
        // emit removeListener for all listeners on all events
        if (arguments.length === 0) {
            var keys = Object.keys(events);
            var key;
            for(i = 0; i < keys.length; ++i){
                key = keys[i];
                if (key === 'removeListener') continue;
                this.removeAllListeners(key);
            }
            this.removeAllListeners('removeListener');
            this._events = Object.create(null);
            this._eventsCount = 0;
            return this;
        }
        listeners = events[type];
        if (typeof listeners === 'function') this.removeListener(type, listeners);
        else if (listeners !== undefined) // LIFO order
        for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
        return this;
    };
    function _listeners(target, type, unwrap) {
        var events = target._events;
        if (events === undefined) return [];
        var evlistener = events[type];
        if (evlistener === undefined) return [];
        if (typeof evlistener === 'function') return unwrap ? [
            evlistener.listener || evlistener
        ] : [
            evlistener
        ];
        return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
    }
    EventEmitter.prototype.listeners = function listeners(type) {
        return _listeners(this, type, true);
    };
    EventEmitter.prototype.rawListeners = function rawListeners(type) {
        return _listeners(this, type, false);
    };
    EventEmitter.listenerCount = function(emitter, type) {
        if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
        else return listenerCount.call(emitter, type);
    };
    EventEmitter.prototype.listenerCount = listenerCount;
    function listenerCount(type) {
        var events = this._events;
        if (events !== undefined) {
            var evlistener = events[type];
            if (typeof evlistener === 'function') return 1;
            else if (evlistener !== undefined) return evlistener.length;
        }
        return 0;
    }
    EventEmitter.prototype.eventNames = function eventNames() {
        return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
    };
    function arrayClone(arr, n) {
        var copy = new Array(n);
        for(var i = 0; i < n; ++i)copy[i] = arr[i];
        return copy;
    }
    function spliceOne(list, index) {
        for(; index + 1 < list.length; index++)list[index] = list[index + 1];
        list.pop();
    }
    function unwrapListeners(arr) {
        var ret = new Array(arr.length);
        for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
        return ret;
    }
    function once(emitter, name) {
        return new Promise(function(resolve, reject) {
            function errorListener(err) {
                emitter.removeListener(name, resolver);
                reject(err);
            }
            function resolver() {
                if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
                resolve([].slice.call(arguments));
            }
            eventTargetAgnosticAddListener(emitter, name, resolver, {
                once: true
            });
            if (name !== 'error') addErrorHandlerIfEventEmitter(emitter, errorListener, {
                once: true
            });
        });
    }
    function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
        if (typeof emitter.on === 'function') eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
    }
    function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
        if (typeof emitter.on === 'function') {
            if (flags.once) emitter.once(name, listener);
            else emitter.on(name, listener);
        } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
        // EventEmitters, we do not listen for `error` events here.
        emitter.addEventListener(name, function wrapListener(arg) {
            // IE does not have builtin `{ once: true }` support so we
            // have to do it manually.
            if (flags.once) emitter.removeEventListener(name, wrapListener);
            listener(arg);
        });
        else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
    }
    return $c0722d30b1d17141$var$events.exports;
}
var $c0722d30b1d17141$var$eventsExports = $c0722d30b1d17141$var$requireEvents(); /*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ 
/* eslint-env node */ let $c0722d30b1d17141$var$logDisabled_ = true;
let $c0722d30b1d17141$var$deprecationWarnings_ = true;
/**
 * Extract browser version out of the provided user agent string.
 *
 * @param {!string} uastring userAgent string.
 * @param {!string} expr Regular expression used as match criteria.
 * @param {!number} pos position in the version string to be returned.
 * @return {!number} browser version.
 */ function $c0722d30b1d17141$var$extractVersion(uastring, expr, pos) {
    const match = uastring.match(expr);
    return match && match.length >= pos && parseFloat(match[pos], 10);
}
// Wraps the peerconnection event eventNameToWrap in a function
// which returns the modified event object (or false to prevent
// the event).
function $c0722d30b1d17141$var$wrapPeerConnectionEvent(window1, eventNameToWrap, wrapper) {
    if (!window1.RTCPeerConnection) return;
    const addEventListener = Object.getOwnPropertyDescriptor(EventTarget.prototype, 'addEventListener');
    if (!addEventListener.writable) {
        $c0722d30b1d17141$var$log$4('Unable to polyfill events');
        return;
    }
    const proto = window1.RTCPeerConnection.prototype;
    const nativeAddEventListener = proto.addEventListener;
    proto.addEventListener = function(nativeEventName, cb) {
        if (nativeEventName !== eventNameToWrap) return nativeAddEventListener.apply(this, arguments);
        const wrappedCallback = (e)=>{
            const modifiedEvent = wrapper(e);
            if (modifiedEvent) {
                if (cb.handleEvent) cb.handleEvent(modifiedEvent);
                else cb(modifiedEvent);
            }
        };
        this._eventMap = this._eventMap || {};
        if (!this._eventMap[eventNameToWrap]) this._eventMap[eventNameToWrap] = new Map();
        this._eventMap[eventNameToWrap].set(cb, wrappedCallback);
        return nativeAddEventListener.apply(this, [
            nativeEventName,
            wrappedCallback
        ]);
    };
    const nativeRemoveEventListener = proto.removeEventListener;
    proto.removeEventListener = function(nativeEventName, cb) {
        if (nativeEventName !== eventNameToWrap || !this._eventMap || !this._eventMap[eventNameToWrap]) return nativeRemoveEventListener.apply(this, arguments);
        if (!this._eventMap[eventNameToWrap].has(cb)) return nativeRemoveEventListener.apply(this, arguments);
        const unwrappedCb = this._eventMap[eventNameToWrap].get(cb);
        this._eventMap[eventNameToWrap].delete(cb);
        if (this._eventMap[eventNameToWrap].size === 0) delete this._eventMap[eventNameToWrap];
        if (Object.keys(this._eventMap).length === 0) delete this._eventMap;
        return nativeRemoveEventListener.apply(this, [
            nativeEventName,
            unwrappedCb
        ]);
    };
    Object.defineProperty(proto, 'on' + eventNameToWrap, {
        get () {
            return this['_on' + eventNameToWrap];
        },
        set (cb) {
            if (this['_on' + eventNameToWrap]) {
                this.removeEventListener(eventNameToWrap, this['_on' + eventNameToWrap]);
                delete this['_on' + eventNameToWrap];
            }
            if (cb) this.addEventListener(eventNameToWrap, this['_on' + eventNameToWrap] = cb);
        },
        enumerable: true,
        configurable: true
    });
}
function $c0722d30b1d17141$var$disableLog(bool) {
    if (typeof bool !== 'boolean') return new Error('Argument type: ' + typeof bool + '. Please use a boolean.');
    $c0722d30b1d17141$var$logDisabled_ = bool;
    return bool ? 'adapter.js logging disabled' : 'adapter.js logging enabled';
}
/**
 * Disable or enable deprecation warnings
 * @param {!boolean} bool set to true to disable warnings.
 */ function $c0722d30b1d17141$var$disableWarnings(bool) {
    if (typeof bool !== 'boolean') return new Error('Argument type: ' + typeof bool + '. Please use a boolean.');
    $c0722d30b1d17141$var$deprecationWarnings_ = !bool;
    return 'adapter.js deprecation warnings ' + (bool ? 'disabled' : 'enabled');
}
function $c0722d30b1d17141$var$log$4() {
    if (typeof window === 'object') {
        if ($c0722d30b1d17141$var$logDisabled_) return;
        if (typeof console !== 'undefined' && typeof console.log === 'function') console.log.apply(console, arguments);
    }
}
/**
 * Shows a deprecation warning suggesting the modern and spec-compatible API.
 */ function $c0722d30b1d17141$var$deprecated(oldMethod, newMethod) {
    if (!$c0722d30b1d17141$var$deprecationWarnings_) return;
    console.warn(oldMethod + ' is deprecated, please use ' + newMethod + ' instead.');
}
/**
 * Browser detector.
 *
 * @return {object} result containing browser and version
 *     properties.
 */ function $c0722d30b1d17141$var$detectBrowser(window1) {
    // Returned result object.
    const result = {
        browser: null,
        version: null
    };
    // Fail early if it's not a browser
    if (typeof window1 === 'undefined' || !window1.navigator || !window1.navigator.userAgent) {
        result.browser = 'Not a browser.';
        return result;
    }
    const { navigator: navigator1 } = window1;
    // Prefer navigator.userAgentData.
    if (navigator1.userAgentData && navigator1.userAgentData.brands) {
        const chromium = navigator1.userAgentData.brands.find((brand)=>{
            return brand.brand === 'Chromium';
        });
        if (chromium) return {
            browser: 'chrome',
            version: parseInt(chromium.version, 10)
        };
    }
    if (navigator1.mozGetUserMedia) {
        // Firefox.
        result.browser = 'firefox';
        result.version = parseInt($c0722d30b1d17141$var$extractVersion(navigator1.userAgent, /Firefox\/(\d+)\./, 1));
    } else if (navigator1.webkitGetUserMedia || window1.isSecureContext === false && window1.webkitRTCPeerConnection) {
        // Chrome, Chromium, Webview, Opera.
        // Version matches Chrome/WebRTC version.
        // Chrome 74 removed webkitGetUserMedia on http as well so we need the
        // more complicated fallback to webkitRTCPeerConnection.
        result.browser = 'chrome';
        result.version = parseInt($c0722d30b1d17141$var$extractVersion(navigator1.userAgent, /Chrom(e|ium)\/(\d+)\./, 2)) || null;
    } else if (window1.RTCPeerConnection && navigator1.userAgent.match(/AppleWebKit\/(\d+)\./)) {
        // Safari.
        result.browser = 'safari';
        result.version = parseInt($c0722d30b1d17141$var$extractVersion(navigator1.userAgent, /AppleWebKit\/(\d+)\./, 1));
        result.supportsUnifiedPlan = window1.RTCRtpTransceiver && 'currentDirection' in window1.RTCRtpTransceiver.prototype;
        // Only for internal usage.
        result._safariVersion = $c0722d30b1d17141$var$extractVersion(navigator1.userAgent, /Version\/(\d+(\.?\d+))/, 1);
    } else {
        // Default fallthrough: not supported.
        result.browser = 'Not a supported browser.';
        return result;
    }
    return result;
}
/**
 * Checks if something is an object.
 *
 * @param {*} val The something you want to check.
 * @return true if val is an object, false otherwise.
 */ function $c0722d30b1d17141$var$isObject$1(val) {
    return Object.prototype.toString.call(val) === '[object Object]';
}
/**
 * Remove all empty objects and undefined values
 * from a nested object -- an enhanced and vanilla version
 * of Lodash's `compact`.
 */ function $c0722d30b1d17141$var$compactObject(data) {
    if (!$c0722d30b1d17141$var$isObject$1(data)) return data;
    return Object.keys(data).reduce(function(accumulator, key) {
        const isObj = $c0722d30b1d17141$var$isObject$1(data[key]);
        const value = isObj ? $c0722d30b1d17141$var$compactObject(data[key]) : data[key];
        const isEmptyObject = isObj && !Object.keys(value).length;
        if (value === undefined || isEmptyObject) return accumulator;
        return Object.assign(accumulator, {
            [key]: value
        });
    }, {});
}
/* iterates the stats graph recursively. */ function $c0722d30b1d17141$var$walkStats(stats, base, resultSet) {
    if (!base || resultSet.has(base.id)) return;
    resultSet.set(base.id, base);
    Object.keys(base).forEach((name)=>{
        if (name.endsWith('Id')) $c0722d30b1d17141$var$walkStats(stats, stats.get(base[name]), resultSet);
        else if (name.endsWith('Ids')) base[name].forEach((id)=>{
            $c0722d30b1d17141$var$walkStats(stats, stats.get(id), resultSet);
        });
    });
}
/* filter getStats for a sender/receiver track. */ function $c0722d30b1d17141$var$filterStats(result, track, outbound) {
    const streamStatsType = outbound ? 'outbound-rtp' : 'inbound-rtp';
    const filteredResult = new Map();
    if (track === null) return filteredResult;
    const trackStats = [];
    result.forEach((value)=>{
        if (value.type === 'track' && value.trackIdentifier === track.id) trackStats.push(value);
    });
    trackStats.forEach((trackStat)=>{
        result.forEach((stats)=>{
            if (stats.type === streamStatsType && stats.trackId === trackStat.id) $c0722d30b1d17141$var$walkStats(result, stats, filteredResult);
        });
    });
    return filteredResult;
} /*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ 
/* eslint-env node */ const $c0722d30b1d17141$var$logging = $c0722d30b1d17141$var$log$4;
function $c0722d30b1d17141$var$shimGetUserMedia$2(window1, browserDetails) {
    const navigator1 = window1 && window1.navigator;
    if (!navigator1.mediaDevices) return;
    const constraintsToChrome_ = function(c) {
        if (typeof c !== 'object' || c.mandatory || c.optional) return c;
        const cc = {};
        Object.keys(c).forEach((key)=>{
            if (key === 'require' || key === 'advanced' || key === 'mediaSource') return;
            const r = typeof c[key] === 'object' ? c[key] : {
                ideal: c[key]
            };
            if (r.exact !== undefined && typeof r.exact === 'number') r.min = r.max = r.exact;
            const oldname_ = function(prefix, name) {
                if (prefix) return prefix + name.charAt(0).toUpperCase() + name.slice(1);
                return name === 'deviceId' ? 'sourceId' : name;
            };
            if (r.ideal !== undefined) {
                cc.optional = cc.optional || [];
                let oc = {};
                if (typeof r.ideal === 'number') {
                    oc[oldname_('min', key)] = r.ideal;
                    cc.optional.push(oc);
                    oc = {};
                    oc[oldname_('max', key)] = r.ideal;
                    cc.optional.push(oc);
                } else {
                    oc[oldname_('', key)] = r.ideal;
                    cc.optional.push(oc);
                }
            }
            if (r.exact !== undefined && typeof r.exact !== 'number') {
                cc.mandatory = cc.mandatory || {};
                cc.mandatory[oldname_('', key)] = r.exact;
            } else [
                'min',
                'max'
            ].forEach((mix)=>{
                if (r[mix] !== undefined) {
                    cc.mandatory = cc.mandatory || {};
                    cc.mandatory[oldname_(mix, key)] = r[mix];
                }
            });
        });
        if (c.advanced) cc.optional = (cc.optional || []).concat(c.advanced);
        return cc;
    };
    const shimConstraints_ = function(constraints, func) {
        if (browserDetails.version >= 61) return func(constraints);
        constraints = JSON.parse(JSON.stringify(constraints));
        if (constraints && typeof constraints.audio === 'object') {
            const remap = function(obj, a, b) {
                if (a in obj && !(b in obj)) {
                    obj[b] = obj[a];
                    delete obj[a];
                }
            };
            constraints = JSON.parse(JSON.stringify(constraints));
            remap(constraints.audio, 'autoGainControl', 'googAutoGainControl');
            remap(constraints.audio, 'noiseSuppression', 'googNoiseSuppression');
            constraints.audio = constraintsToChrome_(constraints.audio);
        }
        if (constraints && typeof constraints.video === 'object') {
            // Shim facingMode for mobile & surface pro.
            let face = constraints.video.facingMode;
            face = face && (typeof face === 'object' ? face : {
                ideal: face
            });
            const getSupportedFacingModeLies = browserDetails.version < 66;
            if (face && (face.exact === 'user' || face.exact === 'environment' || face.ideal === 'user' || face.ideal === 'environment') && !(navigator1.mediaDevices.getSupportedConstraints && navigator1.mediaDevices.getSupportedConstraints().facingMode && !getSupportedFacingModeLies)) {
                delete constraints.video.facingMode;
                let matches;
                if (face.exact === 'environment' || face.ideal === 'environment') matches = [
                    'back',
                    'rear'
                ];
                else if (face.exact === 'user' || face.ideal === 'user') matches = [
                    'front'
                ];
                if (matches) // Look for matches in label, or use last cam for back (typical).
                return navigator1.mediaDevices.enumerateDevices().then((devices)=>{
                    devices = devices.filter((d)=>d.kind === 'videoinput');
                    let dev = devices.find((d)=>matches.some((match)=>d.label.toLowerCase().includes(match)));
                    if (!dev && devices.length && matches.includes('back')) dev = devices[devices.length - 1]; // more likely the back cam
                    if (dev) constraints.video.deviceId = face.exact ? {
                        exact: dev.deviceId
                    } : {
                        ideal: dev.deviceId
                    };
                    constraints.video = constraintsToChrome_(constraints.video);
                    $c0722d30b1d17141$var$logging('chrome: ' + JSON.stringify(constraints));
                    return func(constraints);
                });
            }
            constraints.video = constraintsToChrome_(constraints.video);
        }
        $c0722d30b1d17141$var$logging('chrome: ' + JSON.stringify(constraints));
        return func(constraints);
    };
    const shimError_ = function(e) {
        if (browserDetails.version >= 64) return e;
        return {
            name: ({
                PermissionDeniedError: 'NotAllowedError',
                PermissionDismissedError: 'NotAllowedError',
                InvalidStateError: 'NotAllowedError',
                DevicesNotFoundError: 'NotFoundError',
                ConstraintNotSatisfiedError: 'OverconstrainedError',
                TrackStartError: 'NotReadableError',
                MediaDeviceFailedDueToShutdown: 'NotAllowedError',
                MediaDeviceKillSwitchOn: 'NotAllowedError',
                TabCaptureError: 'AbortError',
                ScreenCaptureError: 'AbortError',
                DeviceCaptureError: 'AbortError'
            })[e.name] || e.name,
            message: e.message,
            constraint: e.constraint || e.constraintName,
            toString () {
                return this.name + (this.message && ': ') + this.message;
            }
        };
    };
    const getUserMedia_ = function(constraints, onSuccess, onError) {
        shimConstraints_(constraints, (c)=>{
            navigator1.webkitGetUserMedia(c, onSuccess, (e)=>{
                if (onError) onError(shimError_(e));
            });
        });
    };
    navigator1.getUserMedia = getUserMedia_.bind(navigator1);
    // Even though Chrome 45 has navigator.mediaDevices and a getUserMedia
    // function which returns a Promise, it does not accept spec-style
    // constraints.
    if (navigator1.mediaDevices.getUserMedia) {
        const origGetUserMedia = navigator1.mediaDevices.getUserMedia.bind(navigator1.mediaDevices);
        navigator1.mediaDevices.getUserMedia = function(cs) {
            return shimConstraints_(cs, (c)=>origGetUserMedia(c).then((stream)=>{
                    if (c.audio && !stream.getAudioTracks().length || c.video && !stream.getVideoTracks().length) {
                        stream.getTracks().forEach((track)=>{
                            track.stop();
                        });
                        throw new DOMException('', 'NotFoundError');
                    }
                    return stream;
                }, (e)=>Promise.reject(shimError_(e))));
        };
    }
} /*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ 
/* eslint-env node */ function $c0722d30b1d17141$var$shimMediaStream(window1) {
    window1.MediaStream = window1.MediaStream || window1.webkitMediaStream;
}
function $c0722d30b1d17141$var$shimOnTrack$1(window1, browserDetails) {
    if (browserDetails.version > 102) // Unified plan is supported so no need to do anything.
    return;
    if (typeof window1 === 'object' && window1.RTCPeerConnection && !('ontrack' in window1.RTCPeerConnection.prototype)) {
        Object.defineProperty(window1.RTCPeerConnection.prototype, 'ontrack', {
            get () {
                return this._ontrack;
            },
            set (f) {
                if (this._ontrack) this.removeEventListener('track', this._ontrack);
                this.addEventListener('track', this._ontrack = f);
            },
            enumerable: true,
            configurable: true
        });
        const origSetRemoteDescription = window1.RTCPeerConnection.prototype.setRemoteDescription;
        window1.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription() {
            if (!this._ontrackpoly) {
                this._ontrackpoly = (e)=>{
                    // onaddstream does not fire when a track is added to an existing
                    // stream. But stream.onaddtrack is implemented so we use that.
                    e.stream.addEventListener('addtrack', (te)=>{
                        let receiver;
                        if (window1.RTCPeerConnection.prototype.getReceivers) receiver = this.getReceivers().find((r)=>r.track && r.track.id === te.track.id);
                        else receiver = {
                            track: te.track
                        };
                        const event = new Event('track');
                        event.track = te.track;
                        event.receiver = receiver;
                        event.transceiver = {
                            receiver: receiver
                        };
                        event.streams = [
                            e.stream
                        ];
                        this.dispatchEvent(event);
                    });
                    e.stream.getTracks().forEach((track)=>{
                        let receiver;
                        if (window1.RTCPeerConnection.prototype.getReceivers) receiver = this.getReceivers().find((r)=>r.track && r.track.id === track.id);
                        else receiver = {
                            track: track
                        };
                        const event = new Event('track');
                        event.track = track;
                        event.receiver = receiver;
                        event.transceiver = {
                            receiver: receiver
                        };
                        event.streams = [
                            e.stream
                        ];
                        this.dispatchEvent(event);
                    });
                };
                this.addEventListener('addstream', this._ontrackpoly);
            }
            return origSetRemoteDescription.apply(this, arguments);
        };
    } else // even if RTCRtpTransceiver is in window, it is only used and
    // emitted in unified-plan. Unfortunately this means we need
    // to unconditionally wrap the event.
    $c0722d30b1d17141$var$wrapPeerConnectionEvent(window1, 'track', (e)=>{
        if (!e.transceiver) Object.defineProperty(e, 'transceiver', {
            value: {
                receiver: e.receiver
            }
        });
        return e;
    });
}
function $c0722d30b1d17141$var$shimGetSendersWithDtmf(window1) {
    // Overrides addTrack/removeTrack, depends on shimAddTrackRemoveTrack.
    if (typeof window1 === 'object' && window1.RTCPeerConnection && !('getSenders' in window1.RTCPeerConnection.prototype) && 'createDTMFSender' in window1.RTCPeerConnection.prototype) {
        const shimSenderWithDtmf = function(pc, track) {
            return {
                track: track,
                get dtmf () {
                    if (this._dtmf === undefined) {
                        if (track.kind === 'audio') this._dtmf = pc.createDTMFSender(track);
                        else this._dtmf = null;
                    }
                    return this._dtmf;
                },
                _pc: pc
            };
        };
        // augment addTrack when getSenders is not available.
        if (!window1.RTCPeerConnection.prototype.getSenders) {
            window1.RTCPeerConnection.prototype.getSenders = function getSenders() {
                this._senders = this._senders || [];
                return this._senders.slice(); // return a copy of the internal state.
            };
            const origAddTrack = window1.RTCPeerConnection.prototype.addTrack;
            window1.RTCPeerConnection.prototype.addTrack = function addTrack(track, stream) {
                let sender = origAddTrack.apply(this, arguments);
                if (!sender) {
                    sender = shimSenderWithDtmf(this, track);
                    this._senders.push(sender);
                }
                return sender;
            };
            const origRemoveTrack = window1.RTCPeerConnection.prototype.removeTrack;
            window1.RTCPeerConnection.prototype.removeTrack = function removeTrack(sender) {
                origRemoveTrack.apply(this, arguments);
                const idx = this._senders.indexOf(sender);
                if (idx !== -1) this._senders.splice(idx, 1);
            };
        }
        const origAddStream = window1.RTCPeerConnection.prototype.addStream;
        window1.RTCPeerConnection.prototype.addStream = function addStream(stream) {
            this._senders = this._senders || [];
            origAddStream.apply(this, [
                stream
            ]);
            stream.getTracks().forEach((track)=>{
                this._senders.push(shimSenderWithDtmf(this, track));
            });
        };
        const origRemoveStream = window1.RTCPeerConnection.prototype.removeStream;
        window1.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
            this._senders = this._senders || [];
            origRemoveStream.apply(this, [
                stream
            ]);
            stream.getTracks().forEach((track)=>{
                const sender = this._senders.find((s)=>s.track === track);
                if (sender) // remove sender
                this._senders.splice(this._senders.indexOf(sender), 1);
            });
        };
    } else if (typeof window1 === 'object' && window1.RTCPeerConnection && 'getSenders' in window1.RTCPeerConnection.prototype && 'createDTMFSender' in window1.RTCPeerConnection.prototype && window1.RTCRtpSender && !('dtmf' in window1.RTCRtpSender.prototype)) {
        const origGetSenders = window1.RTCPeerConnection.prototype.getSenders;
        window1.RTCPeerConnection.prototype.getSenders = function getSenders() {
            const senders = origGetSenders.apply(this, []);
            senders.forEach((sender)=>sender._pc = this);
            return senders;
        };
        Object.defineProperty(window1.RTCRtpSender.prototype, 'dtmf', {
            get () {
                if (this._dtmf === undefined) {
                    if (this.track.kind === 'audio') this._dtmf = this._pc.createDTMFSender(this.track);
                    else this._dtmf = null;
                }
                return this._dtmf;
            }
        });
    }
}
function $c0722d30b1d17141$var$shimSenderReceiverGetStats(window1, browserDetails) {
    if (browserDetails.version >= 67) return;
    if (!(typeof window1 === 'object' && window1.RTCPeerConnection && window1.RTCRtpSender && window1.RTCRtpReceiver)) return;
    // shim sender stats.
    if (!('getStats' in window1.RTCRtpSender.prototype)) {
        const origGetSenders = window1.RTCPeerConnection.prototype.getSenders;
        if (origGetSenders) window1.RTCPeerConnection.prototype.getSenders = function getSenders() {
            const senders = origGetSenders.apply(this, []);
            senders.forEach((sender)=>sender._pc = this);
            return senders;
        };
        const origAddTrack = window1.RTCPeerConnection.prototype.addTrack;
        if (origAddTrack) window1.RTCPeerConnection.prototype.addTrack = function addTrack() {
            const sender = origAddTrack.apply(this, arguments);
            sender._pc = this;
            return sender;
        };
        window1.RTCRtpSender.prototype.getStats = function getStats() {
            const sender = this;
            return this._pc.getStats().then((result)=>/* Note: this will include stats of all senders that
       *   send a track with the same id as sender.track as
       *   it is not possible to identify the RTCRtpSender.
       */ $c0722d30b1d17141$var$filterStats(result, sender.track, true));
        };
    }
    // shim receiver stats.
    if (!('getStats' in window1.RTCRtpReceiver.prototype)) {
        const origGetReceivers = window1.RTCPeerConnection.prototype.getReceivers;
        if (origGetReceivers) window1.RTCPeerConnection.prototype.getReceivers = function getReceivers() {
            const receivers = origGetReceivers.apply(this, []);
            receivers.forEach((receiver)=>receiver._pc = this);
            return receivers;
        };
        $c0722d30b1d17141$var$wrapPeerConnectionEvent(window1, 'track', (e)=>{
            e.receiver._pc = e.srcElement;
            return e;
        });
        window1.RTCRtpReceiver.prototype.getStats = function getStats() {
            const receiver = this;
            return this._pc.getStats().then((result)=>$c0722d30b1d17141$var$filterStats(result, receiver.track, false));
        };
    }
    if (!('getStats' in window1.RTCRtpSender.prototype && 'getStats' in window1.RTCRtpReceiver.prototype)) return;
    // shim RTCPeerConnection.getStats(track).
    const origGetStats = window1.RTCPeerConnection.prototype.getStats;
    window1.RTCPeerConnection.prototype.getStats = function getStats() {
        if (arguments.length > 0 && arguments[0] instanceof window1.MediaStreamTrack) {
            const track = arguments[0];
            let sender;
            let receiver;
            let err;
            this.getSenders().forEach((s)=>{
                if (s.track === track) {
                    if (sender) err = true;
                    else sender = s;
                }
            });
            this.getReceivers().forEach((r)=>{
                if (r.track === track) {
                    if (receiver) err = true;
                    else receiver = r;
                }
                return r.track === track;
            });
            if (err || sender && receiver) return Promise.reject(new DOMException('There are more than one sender or receiver for the track.', 'InvalidAccessError'));
            else if (sender) return sender.getStats();
            else if (receiver) return receiver.getStats();
            return Promise.reject(new DOMException('There is no sender or receiver for the track.', 'InvalidAccessError'));
        }
        return origGetStats.apply(this, arguments);
    };
}
function $c0722d30b1d17141$var$shimAddTrackRemoveTrackWithNative(window1) {
    // shim addTrack/removeTrack with native variants in order to make
    // the interactions with legacy getLocalStreams behave as in other browsers.
    // Keeps a mapping stream.id => [stream, rtpsenders...]
    window1.RTCPeerConnection.prototype.getLocalStreams = function getLocalStreams() {
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        return Object.keys(this._shimmedLocalStreams).map((streamId)=>this._shimmedLocalStreams[streamId][0]);
    };
    const origAddTrack = window1.RTCPeerConnection.prototype.addTrack;
    window1.RTCPeerConnection.prototype.addTrack = function addTrack(track, stream) {
        if (!stream) return origAddTrack.apply(this, arguments);
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        const sender = origAddTrack.apply(this, arguments);
        if (!this._shimmedLocalStreams[stream.id]) this._shimmedLocalStreams[stream.id] = [
            stream,
            sender
        ];
        else if (this._shimmedLocalStreams[stream.id].indexOf(sender) === -1) this._shimmedLocalStreams[stream.id].push(sender);
        return sender;
    };
    const origAddStream = window1.RTCPeerConnection.prototype.addStream;
    window1.RTCPeerConnection.prototype.addStream = function addStream(stream) {
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        stream.getTracks().forEach((track)=>{
            const alreadyExists = this.getSenders().find((s)=>s.track === track);
            if (alreadyExists) throw new DOMException('Track already exists.', 'InvalidAccessError');
        });
        const existingSenders = this.getSenders();
        origAddStream.apply(this, arguments);
        const newSenders = this.getSenders().filter((newSender)=>existingSenders.indexOf(newSender) === -1);
        this._shimmedLocalStreams[stream.id] = [
            stream
        ].concat(newSenders);
    };
    const origRemoveStream = window1.RTCPeerConnection.prototype.removeStream;
    window1.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        delete this._shimmedLocalStreams[stream.id];
        return origRemoveStream.apply(this, arguments);
    };
    const origRemoveTrack = window1.RTCPeerConnection.prototype.removeTrack;
    window1.RTCPeerConnection.prototype.removeTrack = function removeTrack(sender) {
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        if (sender) Object.keys(this._shimmedLocalStreams).forEach((streamId)=>{
            const idx = this._shimmedLocalStreams[streamId].indexOf(sender);
            if (idx !== -1) this._shimmedLocalStreams[streamId].splice(idx, 1);
            if (this._shimmedLocalStreams[streamId].length === 1) delete this._shimmedLocalStreams[streamId];
        });
        return origRemoveTrack.apply(this, arguments);
    };
}
function $c0722d30b1d17141$var$shimAddTrackRemoveTrack(window1, browserDetails) {
    if (!window1.RTCPeerConnection) return;
    // shim addTrack and removeTrack.
    if (window1.RTCPeerConnection.prototype.addTrack && browserDetails.version >= 65) return $c0722d30b1d17141$var$shimAddTrackRemoveTrackWithNative(window1);
    // also shim pc.getLocalStreams when addTrack is shimmed
    // to return the original streams.
    const origGetLocalStreams = window1.RTCPeerConnection.prototype.getLocalStreams;
    window1.RTCPeerConnection.prototype.getLocalStreams = function getLocalStreams() {
        const nativeStreams = origGetLocalStreams.apply(this);
        this._reverseStreams = this._reverseStreams || {};
        return nativeStreams.map((stream)=>this._reverseStreams[stream.id]);
    };
    const origAddStream = window1.RTCPeerConnection.prototype.addStream;
    window1.RTCPeerConnection.prototype.addStream = function addStream(stream) {
        this._streams = this._streams || {};
        this._reverseStreams = this._reverseStreams || {};
        stream.getTracks().forEach((track)=>{
            const alreadyExists = this.getSenders().find((s)=>s.track === track);
            if (alreadyExists) throw new DOMException('Track already exists.', 'InvalidAccessError');
        });
        // Add identity mapping for consistency with addTrack.
        // Unless this is being used with a stream from addTrack.
        if (!this._reverseStreams[stream.id]) {
            const newStream = new window1.MediaStream(stream.getTracks());
            this._streams[stream.id] = newStream;
            this._reverseStreams[newStream.id] = stream;
            stream = newStream;
        }
        origAddStream.apply(this, [
            stream
        ]);
    };
    const origRemoveStream = window1.RTCPeerConnection.prototype.removeStream;
    window1.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
        this._streams = this._streams || {};
        this._reverseStreams = this._reverseStreams || {};
        origRemoveStream.apply(this, [
            this._streams[stream.id] || stream
        ]);
        delete this._reverseStreams[this._streams[stream.id] ? this._streams[stream.id].id : stream.id];
        delete this._streams[stream.id];
    };
    window1.RTCPeerConnection.prototype.addTrack = function addTrack(track, stream) {
        if (this.signalingState === 'closed') throw new DOMException('The RTCPeerConnection\'s signalingState is \'closed\'.', 'InvalidStateError');
        const streams = [].slice.call(arguments, 1);
        if (streams.length !== 1 || !streams[0].getTracks().find((t)=>t === track)) // this is not fully correct but all we can manage without
        // [[associated MediaStreams]] internal slot.
        throw new DOMException("The adapter.js addTrack polyfill only supports a single  stream which is associated with the specified track.", 'NotSupportedError');
        const alreadyExists = this.getSenders().find((s)=>s.track === track);
        if (alreadyExists) throw new DOMException('Track already exists.', 'InvalidAccessError');
        this._streams = this._streams || {};
        this._reverseStreams = this._reverseStreams || {};
        const oldStream = this._streams[stream.id];
        if (oldStream) {
            // this is using odd Chrome behaviour, use with caution:
            // https://bugs.chromium.org/p/webrtc/issues/detail?id=7815
            // Note: we rely on the high-level addTrack/dtmf shim to
            // create the sender with a dtmf sender.
            oldStream.addTrack(track);
            // Trigger ONN async.
            Promise.resolve().then(()=>{
                this.dispatchEvent(new Event('negotiationneeded'));
            });
        } else {
            const newStream = new window1.MediaStream([
                track
            ]);
            this._streams[stream.id] = newStream;
            this._reverseStreams[newStream.id] = stream;
            this.addStream(newStream);
        }
        return this.getSenders().find((s)=>s.track === track);
    };
    // replace the internal stream id with the external one and
    // vice versa.
    function replaceInternalStreamId(pc, description) {
        let sdp = description.sdp;
        Object.keys(pc._reverseStreams || []).forEach((internalId)=>{
            const externalStream = pc._reverseStreams[internalId];
            const internalStream = pc._streams[externalStream.id];
            sdp = sdp.replace(new RegExp(internalStream.id, 'g'), externalStream.id);
        });
        return new RTCSessionDescription({
            type: description.type,
            sdp: sdp
        });
    }
    function replaceExternalStreamId(pc, description) {
        let sdp = description.sdp;
        Object.keys(pc._reverseStreams || []).forEach((internalId)=>{
            const externalStream = pc._reverseStreams[internalId];
            const internalStream = pc._streams[externalStream.id];
            sdp = sdp.replace(new RegExp(externalStream.id, 'g'), internalStream.id);
        });
        return new RTCSessionDescription({
            type: description.type,
            sdp: sdp
        });
    }
    [
        'createOffer',
        'createAnswer'
    ].forEach(function(method) {
        const nativeMethod = window1.RTCPeerConnection.prototype[method];
        const methodObj = {
            [method] () {
                const args = arguments;
                const isLegacyCall = arguments.length && typeof arguments[0] === 'function';
                if (isLegacyCall) return nativeMethod.apply(this, [
                    (description)=>{
                        const desc = replaceInternalStreamId(this, description);
                        args[0].apply(null, [
                            desc
                        ]);
                    },
                    (err)=>{
                        if (args[1]) args[1].apply(null, err);
                    },
                    arguments[2]
                ]);
                return nativeMethod.apply(this, arguments).then((description)=>replaceInternalStreamId(this, description));
            }
        };
        window1.RTCPeerConnection.prototype[method] = methodObj[method];
    });
    const origSetLocalDescription = window1.RTCPeerConnection.prototype.setLocalDescription;
    window1.RTCPeerConnection.prototype.setLocalDescription = function setLocalDescription() {
        if (!arguments.length || !arguments[0].type) return origSetLocalDescription.apply(this, arguments);
        arguments[0] = replaceExternalStreamId(this, arguments[0]);
        return origSetLocalDescription.apply(this, arguments);
    };
    // TODO: mangle getStats: https://w3c.github.io/webrtc-stats/#dom-rtcmediastreamstats-streamidentifier
    const origLocalDescription = Object.getOwnPropertyDescriptor(window1.RTCPeerConnection.prototype, 'localDescription');
    Object.defineProperty(window1.RTCPeerConnection.prototype, 'localDescription', {
        get () {
            const description = origLocalDescription.get.apply(this);
            if (description.type === '') return description;
            return replaceInternalStreamId(this, description);
        }
    });
    window1.RTCPeerConnection.prototype.removeTrack = function removeTrack(sender) {
        if (this.signalingState === 'closed') throw new DOMException('The RTCPeerConnection\'s signalingState is \'closed\'.', 'InvalidStateError');
        // We can not yet check for sender instanceof RTCRtpSender
        // since we shim RTPSender. So we check if sender._pc is set.
        if (!sender._pc) throw new DOMException("Argument 1 of RTCPeerConnection.removeTrack does not implement interface RTCRtpSender.", 'TypeError');
        const isLocal = sender._pc === this;
        if (!isLocal) throw new DOMException('Sender was not created by this connection.', 'InvalidAccessError');
        // Search for the native stream the senders track belongs to.
        this._streams = this._streams || {};
        let stream;
        Object.keys(this._streams).forEach((streamid)=>{
            const hasTrack = this._streams[streamid].getTracks().find((track)=>sender.track === track);
            if (hasTrack) stream = this._streams[streamid];
        });
        if (stream) {
            if (stream.getTracks().length === 1) // if this is the last track of the stream, remove the stream. This
            // takes care of any shimmed _senders.
            this.removeStream(this._reverseStreams[stream.id]);
            else // relying on the same odd chrome behaviour as above.
            stream.removeTrack(sender.track);
            this.dispatchEvent(new Event('negotiationneeded'));
        }
    };
}
function $c0722d30b1d17141$var$shimPeerConnection$1(window1, browserDetails) {
    if (!window1.RTCPeerConnection && window1.webkitRTCPeerConnection) // very basic support for old versions.
    window1.RTCPeerConnection = window1.webkitRTCPeerConnection;
    if (!window1.RTCPeerConnection) return;
    // shim implicit creation of RTCSessionDescription/RTCIceCandidate
    if (browserDetails.version < 53) [
        'setLocalDescription',
        'setRemoteDescription',
        'addIceCandidate'
    ].forEach(function(method) {
        const nativeMethod = window1.RTCPeerConnection.prototype[method];
        const methodObj = {
            [method] () {
                arguments[0] = new (method === 'addIceCandidate' ? window1.RTCIceCandidate : window1.RTCSessionDescription)(arguments[0]);
                return nativeMethod.apply(this, arguments);
            }
        };
        window1.RTCPeerConnection.prototype[method] = methodObj[method];
    });
}
// Attempt to fix ONN in plan-b mode.
function $c0722d30b1d17141$var$fixNegotiationNeeded(window1, browserDetails) {
    if (browserDetails.version > 102) // Plan-B is no longer supported.
    return;
    $c0722d30b1d17141$var$wrapPeerConnectionEvent(window1, 'negotiationneeded', (e)=>{
        const pc = e.target;
        if (browserDetails.version < 72 || pc.getConfiguration && pc.getConfiguration().sdpSemantics === 'plan-b') {
            if (pc.signalingState !== 'stable') return;
        }
        return e;
    });
}
var $c0722d30b1d17141$var$chromeShim = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    fixNegotiationNeeded: $c0722d30b1d17141$var$fixNegotiationNeeded,
    shimAddTrackRemoveTrack: $c0722d30b1d17141$var$shimAddTrackRemoveTrack,
    shimAddTrackRemoveTrackWithNative: $c0722d30b1d17141$var$shimAddTrackRemoveTrackWithNative,
    shimGetSendersWithDtmf: $c0722d30b1d17141$var$shimGetSendersWithDtmf,
    shimGetUserMedia: $c0722d30b1d17141$var$shimGetUserMedia$2,
    shimMediaStream: $c0722d30b1d17141$var$shimMediaStream,
    shimOnTrack: $c0722d30b1d17141$var$shimOnTrack$1,
    shimPeerConnection: $c0722d30b1d17141$var$shimPeerConnection$1,
    shimSenderReceiverGetStats: $c0722d30b1d17141$var$shimSenderReceiverGetStats
}); /*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ 
/* eslint-env node */ function $c0722d30b1d17141$var$shimGetUserMedia$1(window1, browserDetails) {
    const navigator1 = window1 && window1.navigator;
    const MediaStreamTrack1 = window1 && window1.MediaStreamTrack;
    navigator1.getUserMedia = function(constraints, onSuccess, onError) {
        // Replace Firefox 44+'s deprecation warning with unprefixed version.
        $c0722d30b1d17141$var$deprecated('navigator.getUserMedia', 'navigator.mediaDevices.getUserMedia');
        navigator1.mediaDevices.getUserMedia(constraints).then(onSuccess, onError);
    };
    if (!(browserDetails.version > 55 && 'autoGainControl' in navigator1.mediaDevices.getSupportedConstraints())) {
        const remap = function(obj, a, b) {
            if (a in obj && !(b in obj)) {
                obj[b] = obj[a];
                delete obj[a];
            }
        };
        const nativeGetUserMedia = navigator1.mediaDevices.getUserMedia.bind(navigator1.mediaDevices);
        navigator1.mediaDevices.getUserMedia = function(c) {
            if (typeof c === 'object' && typeof c.audio === 'object') {
                c = JSON.parse(JSON.stringify(c));
                remap(c.audio, 'autoGainControl', 'mozAutoGainControl');
                remap(c.audio, 'noiseSuppression', 'mozNoiseSuppression');
            }
            return nativeGetUserMedia(c);
        };
        if (MediaStreamTrack1 && MediaStreamTrack1.prototype.getSettings) {
            const nativeGetSettings = MediaStreamTrack1.prototype.getSettings;
            MediaStreamTrack1.prototype.getSettings = function() {
                const obj = nativeGetSettings.apply(this, arguments);
                remap(obj, 'mozAutoGainControl', 'autoGainControl');
                remap(obj, 'mozNoiseSuppression', 'noiseSuppression');
                return obj;
            };
        }
        if (MediaStreamTrack1 && MediaStreamTrack1.prototype.applyConstraints) {
            const nativeApplyConstraints = MediaStreamTrack1.prototype.applyConstraints;
            MediaStreamTrack1.prototype.applyConstraints = function(c) {
                if (this.kind === 'audio' && typeof c === 'object') {
                    c = JSON.parse(JSON.stringify(c));
                    remap(c, 'autoGainControl', 'mozAutoGainControl');
                    remap(c, 'noiseSuppression', 'mozNoiseSuppression');
                }
                return nativeApplyConstraints.apply(this, [
                    c
                ]);
            };
        }
    }
} /*
 *  Copyright (c) 2018 The adapter.js project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ 
/* eslint-env node */ function $c0722d30b1d17141$var$shimGetDisplayMedia(window1, preferredMediaSource) {
    if (window1.navigator.mediaDevices && 'getDisplayMedia' in window1.navigator.mediaDevices) return;
    if (!window1.navigator.mediaDevices) return;
    window1.navigator.mediaDevices.getDisplayMedia = function getDisplayMedia(constraints) {
        if (!(constraints && constraints.video)) {
            const err = new DOMException("getDisplayMedia without video constraints is undefined");
            err.name = 'NotFoundError';
            // from https://heycam.github.io/webidl/#idl-DOMException-error-names
            err.code = 8;
            return Promise.reject(err);
        }
        if (constraints.video === true) constraints.video = {
            mediaSource: preferredMediaSource
        };
        else constraints.video.mediaSource = preferredMediaSource;
        return window1.navigator.mediaDevices.getUserMedia(constraints);
    };
} /*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ 
/* eslint-env node */ function $c0722d30b1d17141$var$shimOnTrack(window1) {
    if (typeof window1 === 'object' && window1.RTCTrackEvent && 'receiver' in window1.RTCTrackEvent.prototype && !('transceiver' in window1.RTCTrackEvent.prototype)) Object.defineProperty(window1.RTCTrackEvent.prototype, 'transceiver', {
        get () {
            return {
                receiver: this.receiver
            };
        }
    });
}
function $c0722d30b1d17141$var$shimPeerConnection(window1, browserDetails) {
    if (typeof window1 !== 'object' || !(window1.RTCPeerConnection || window1.mozRTCPeerConnection)) return; // probably media.peerconnection.enabled=false in about:config
    if (!window1.RTCPeerConnection && window1.mozRTCPeerConnection) // very basic support for old versions.
    window1.RTCPeerConnection = window1.mozRTCPeerConnection;
    if (browserDetails.version < 53) // shim away need for obsolete RTCIceCandidate/RTCSessionDescription.
    [
        'setLocalDescription',
        'setRemoteDescription',
        'addIceCandidate'
    ].forEach(function(method) {
        const nativeMethod = window1.RTCPeerConnection.prototype[method];
        const methodObj = {
            [method] () {
                arguments[0] = new (method === 'addIceCandidate' ? window1.RTCIceCandidate : window1.RTCSessionDescription)(arguments[0]);
                return nativeMethod.apply(this, arguments);
            }
        };
        window1.RTCPeerConnection.prototype[method] = methodObj[method];
    });
}
function $c0722d30b1d17141$var$shimGetStats(window1, browserDetails) {
    if (typeof window1 !== 'object' || !(window1.RTCPeerConnection || window1.mozRTCPeerConnection)) return; // probably media.peerconnection.enabled=false in about:config
    if (browserDetails.version >= 151) // https://bugzilla.mozilla.org/show_bug.cgi?id=1056433
    return;
    const modernStatsTypes = {
        inboundrtp: 'inbound-rtp',
        outboundrtp: 'outbound-rtp',
        candidatepair: 'candidate-pair',
        localcandidate: 'local-candidate',
        remotecandidate: 'remote-candidate'
    };
    const nativeGetStats = window1.RTCPeerConnection.prototype.getStats;
    window1.RTCPeerConnection.prototype.getStats = function getStats() {
        const [selector, onSucc, onErr] = arguments;
        if (this.signalingState === 'closed') // No longer required in FF151+
        return Promise.resolve(new Map());
        return nativeGetStats.apply(this, [
            selector || null
        ]).then((stats)=>{
            if (browserDetails.version < 53 && !onSucc) // Shim only promise getStats with spec-hyphens in type names
            // Leave callback version alone; misc old uses of forEach before Map
            try {
                stats.forEach((stat)=>{
                    stat.type = modernStatsTypes[stat.type] || stat.type;
                });
            } catch (e) {
                if (e.name !== 'TypeError') throw e;
                // Avoid TypeError: "type" is read-only, in old versions. 34-43ish
                stats.forEach((stat, i)=>{
                    stats.set(i, Object.assign({}, stat, {
                        type: modernStatsTypes[stat.type] || stat.type
                    }));
                });
            }
            return stats;
        }).then(onSucc, onErr);
    };
}
function $c0722d30b1d17141$var$shimSenderGetStats(window1) {
    if (!(typeof window1 === 'object' && window1.RTCPeerConnection && window1.RTCRtpSender)) return;
    if (window1.RTCRtpSender && 'getStats' in window1.RTCRtpSender.prototype) return;
    const origGetSenders = window1.RTCPeerConnection.prototype.getSenders;
    if (origGetSenders) window1.RTCPeerConnection.prototype.getSenders = function getSenders() {
        const senders = origGetSenders.apply(this, []);
        senders.forEach((sender)=>sender._pc = this);
        return senders;
    };
    const origAddTrack = window1.RTCPeerConnection.prototype.addTrack;
    if (origAddTrack) window1.RTCPeerConnection.prototype.addTrack = function addTrack() {
        const sender = origAddTrack.apply(this, arguments);
        sender._pc = this;
        return sender;
    };
    window1.RTCRtpSender.prototype.getStats = function getStats() {
        return this.track ? this._pc.getStats(this.track) : Promise.resolve(new Map());
    };
}
function $c0722d30b1d17141$var$shimReceiverGetStats(window1) {
    if (!(typeof window1 === 'object' && window1.RTCPeerConnection && window1.RTCRtpSender)) return;
    if (window1.RTCRtpSender && 'getStats' in window1.RTCRtpReceiver.prototype) return;
    const origGetReceivers = window1.RTCPeerConnection.prototype.getReceivers;
    if (origGetReceivers) window1.RTCPeerConnection.prototype.getReceivers = function getReceivers() {
        const receivers = origGetReceivers.apply(this, []);
        receivers.forEach((receiver)=>receiver._pc = this);
        return receivers;
    };
    $c0722d30b1d17141$var$wrapPeerConnectionEvent(window1, 'track', (e)=>{
        e.receiver._pc = e.srcElement;
        return e;
    });
    window1.RTCRtpReceiver.prototype.getStats = function getStats() {
        return this._pc.getStats(this.track);
    };
}
function $c0722d30b1d17141$var$shimRemoveStream(window1) {
    if (!window1.RTCPeerConnection || 'removeStream' in window1.RTCPeerConnection.prototype) return;
    window1.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
        $c0722d30b1d17141$var$deprecated('removeStream', 'removeTrack');
        this.getSenders().forEach((sender)=>{
            if (sender.track && stream.getTracks().includes(sender.track)) this.removeTrack(sender);
        });
    };
}
function $c0722d30b1d17141$var$shimRTCDataChannel(window1) {
    // rename DataChannel to RTCDataChannel (native fix in FF60):
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1173851
    if (window1.DataChannel && !window1.RTCDataChannel) window1.RTCDataChannel = window1.DataChannel;
}
function $c0722d30b1d17141$var$shimAddTransceiver(window1) {
    // https://github.com/webrtcHacks/adapter/issues/998#issuecomment-516921647
    // Firefox ignores the init sendEncodings options passed to addTransceiver
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1396918
    if (!(typeof window1 === 'object' && window1.RTCPeerConnection)) return;
    const origAddTransceiver = window1.RTCPeerConnection.prototype.addTransceiver;
    if (origAddTransceiver) window1.RTCPeerConnection.prototype.addTransceiver = function addTransceiver() {
        this.setParametersPromises = [];
        // WebIDL input coercion and validation
        let sendEncodings = arguments[1] && arguments[1].sendEncodings;
        if (sendEncodings === undefined) sendEncodings = [];
        sendEncodings = [
            ...sendEncodings
        ];
        const shouldPerformCheck = sendEncodings.length > 0;
        if (shouldPerformCheck) // If sendEncodings params are provided, validate grammar
        sendEncodings.forEach((encodingParam)=>{
            if ('rid' in encodingParam) {
                const ridRegex = /^[a-z0-9]{0,16}$/i;
                if (!ridRegex.test(encodingParam.rid)) throw new TypeError('Invalid RID value provided.');
            }
            if ('scaleResolutionDownBy' in encodingParam) {
                if (!(parseFloat(encodingParam.scaleResolutionDownBy) >= 1.0)) throw new RangeError('scale_resolution_down_by must be >= 1.0');
            }
            if ('maxFramerate' in encodingParam) {
                if (!(parseFloat(encodingParam.maxFramerate) >= 0)) throw new RangeError('max_framerate must be >= 0.0');
            }
        });
        const transceiver = origAddTransceiver.apply(this, arguments);
        if (shouldPerformCheck) {
            // Check if the init options were applied. If not we do this in an
            // asynchronous way and save the promise reference in a global object.
            // This is an ugly hack, but at the same time is way more robust than
            // checking the sender parameters before and after the createOffer
            // Also note that after the createoffer we are not 100% sure that
            // the params were asynchronously applied so we might miss the
            // opportunity to recreate offer.
            const { sender: sender } = transceiver;
            const params = sender.getParameters();
            if (!('encodings' in params) || // Avoid being fooled by patched getParameters() below.
            params.encodings.length === 1 && Object.keys(params.encodings[0]).length === 0) {
                params.encodings = sendEncodings;
                sender.sendEncodings = sendEncodings;
                this.setParametersPromises.push(sender.setParameters(params).then(()=>{
                    delete sender.sendEncodings;
                }).catch(()=>{
                    delete sender.sendEncodings;
                }));
            }
        }
        return transceiver;
    };
}
function $c0722d30b1d17141$var$shimGetParameters(window1) {
    if (!(typeof window1 === 'object' && window1.RTCRtpSender)) return;
    const origGetParameters = window1.RTCRtpSender.prototype.getParameters;
    if (origGetParameters) window1.RTCRtpSender.prototype.getParameters = function getParameters() {
        const params = origGetParameters.apply(this, arguments);
        if (!('encodings' in params)) params.encodings = [].concat(this.sendEncodings || [
            {}
        ]);
        return params;
    };
}
function $c0722d30b1d17141$var$shimCreateOffer(window1) {
    // https://github.com/webrtcHacks/adapter/issues/998#issuecomment-516921647
    // Firefox ignores the init sendEncodings options passed to addTransceiver
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1396918
    if (!(typeof window1 === 'object' && window1.RTCPeerConnection)) return;
    const origCreateOffer = window1.RTCPeerConnection.prototype.createOffer;
    window1.RTCPeerConnection.prototype.createOffer = function createOffer() {
        if (this.setParametersPromises && this.setParametersPromises.length) return Promise.all(this.setParametersPromises).then(()=>{
            return origCreateOffer.apply(this, arguments);
        }).finally(()=>{
            this.setParametersPromises = [];
        });
        return origCreateOffer.apply(this, arguments);
    };
}
function $c0722d30b1d17141$var$shimCreateAnswer(window1) {
    // https://github.com/webrtcHacks/adapter/issues/998#issuecomment-516921647
    // Firefox ignores the init sendEncodings options passed to addTransceiver
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1396918
    if (!(typeof window1 === 'object' && window1.RTCPeerConnection)) return;
    const origCreateAnswer = window1.RTCPeerConnection.prototype.createAnswer;
    window1.RTCPeerConnection.prototype.createAnswer = function createAnswer() {
        if (this.setParametersPromises && this.setParametersPromises.length) return Promise.all(this.setParametersPromises).then(()=>{
            return origCreateAnswer.apply(this, arguments);
        }).finally(()=>{
            this.setParametersPromises = [];
        });
        return origCreateAnswer.apply(this, arguments);
    };
}
var $c0722d30b1d17141$var$firefoxShim = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    shimAddTransceiver: $c0722d30b1d17141$var$shimAddTransceiver,
    shimCreateAnswer: $c0722d30b1d17141$var$shimCreateAnswer,
    shimCreateOffer: $c0722d30b1d17141$var$shimCreateOffer,
    shimGetDisplayMedia: $c0722d30b1d17141$var$shimGetDisplayMedia,
    shimGetParameters: $c0722d30b1d17141$var$shimGetParameters,
    shimGetStats: $c0722d30b1d17141$var$shimGetStats,
    shimGetUserMedia: $c0722d30b1d17141$var$shimGetUserMedia$1,
    shimOnTrack: $c0722d30b1d17141$var$shimOnTrack,
    shimPeerConnection: $c0722d30b1d17141$var$shimPeerConnection,
    shimRTCDataChannel: $c0722d30b1d17141$var$shimRTCDataChannel,
    shimReceiverGetStats: $c0722d30b1d17141$var$shimReceiverGetStats,
    shimRemoveStream: $c0722d30b1d17141$var$shimRemoveStream,
    shimSenderGetStats: $c0722d30b1d17141$var$shimSenderGetStats
}); /*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ 
function $c0722d30b1d17141$var$shimLocalStreamsAPI(window1) {
    if (typeof window1 !== 'object' || !window1.RTCPeerConnection) return;
    if (!('getLocalStreams' in window1.RTCPeerConnection.prototype)) window1.RTCPeerConnection.prototype.getLocalStreams = function getLocalStreams() {
        if (!this._localStreams) this._localStreams = [];
        return this._localStreams;
    };
    if (!('addStream' in window1.RTCPeerConnection.prototype)) {
        const _addTrack = window1.RTCPeerConnection.prototype.addTrack;
        window1.RTCPeerConnection.prototype.addStream = function addStream(stream) {
            if (!this._localStreams) this._localStreams = [];
            if (!this._localStreams.includes(stream)) this._localStreams.push(stream);
            // Try to emulate Chrome's behaviour of adding in audio-video order.
            // Safari orders by track id.
            stream.getAudioTracks().forEach((track)=>_addTrack.call(this, track, stream));
            stream.getVideoTracks().forEach((track)=>_addTrack.call(this, track, stream));
        };
        window1.RTCPeerConnection.prototype.addTrack = function addTrack(track) {
            for(var _len = arguments.length, streams = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)streams[_key - 1] = arguments[_key];
            if (streams) streams.forEach((stream)=>{
                if (!this._localStreams) this._localStreams = [
                    stream
                ];
                else if (!this._localStreams.includes(stream)) this._localStreams.push(stream);
            });
            return _addTrack.apply(this, arguments);
        };
    }
    if (!('removeStream' in window1.RTCPeerConnection.prototype)) window1.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
        if (!this._localStreams) this._localStreams = [];
        const index = this._localStreams.indexOf(stream);
        if (index === -1) return;
        this._localStreams.splice(index, 1);
        const tracks = stream.getTracks();
        this.getSenders().forEach((sender)=>{
            if (tracks.includes(sender.track)) this.removeTrack(sender);
        });
    };
}
function $c0722d30b1d17141$var$shimRemoteStreamsAPI(window1) {
    if (typeof window1 !== 'object' || !window1.RTCPeerConnection) return;
    if (!('getRemoteStreams' in window1.RTCPeerConnection.prototype)) window1.RTCPeerConnection.prototype.getRemoteStreams = function getRemoteStreams() {
        return this._remoteStreams ? this._remoteStreams : [];
    };
    if (!('onaddstream' in window1.RTCPeerConnection.prototype)) {
        Object.defineProperty(window1.RTCPeerConnection.prototype, 'onaddstream', {
            get () {
                return this._onaddstream;
            },
            set (f) {
                if (this._onaddstream) {
                    this.removeEventListener('addstream', this._onaddstream);
                    this.removeEventListener('track', this._onaddstreampoly);
                }
                this.addEventListener('addstream', this._onaddstream = f);
                this.addEventListener('track', this._onaddstreampoly = (e)=>{
                    e.streams.forEach((stream)=>{
                        if (!this._remoteStreams) this._remoteStreams = [];
                        if (this._remoteStreams.includes(stream)) return;
                        this._remoteStreams.push(stream);
                        const event = new Event('addstream');
                        event.stream = stream;
                        this.dispatchEvent(event);
                    });
                });
            }
        });
        const origSetRemoteDescription = window1.RTCPeerConnection.prototype.setRemoteDescription;
        window1.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription() {
            const pc = this;
            if (!this._onaddstreampoly) this.addEventListener('track', this._onaddstreampoly = function(e) {
                e.streams.forEach((stream)=>{
                    if (!pc._remoteStreams) pc._remoteStreams = [];
                    if (pc._remoteStreams.indexOf(stream) >= 0) return;
                    pc._remoteStreams.push(stream);
                    const event = new Event('addstream');
                    event.stream = stream;
                    pc.dispatchEvent(event);
                });
            });
            return origSetRemoteDescription.apply(pc, arguments);
        };
    }
}
function $c0722d30b1d17141$var$shimCallbacksAPI(window1) {
    if (typeof window1 !== 'object' || !window1.RTCPeerConnection) return;
    const prototype = window1.RTCPeerConnection.prototype;
    const origCreateOffer = prototype.createOffer;
    const origCreateAnswer = prototype.createAnswer;
    const setLocalDescription = prototype.setLocalDescription;
    const setRemoteDescription = prototype.setRemoteDescription;
    const addIceCandidate = prototype.addIceCandidate;
    prototype.createOffer = function createOffer(successCallback, failureCallback) {
        const options = arguments.length >= 2 ? arguments[2] : arguments[0];
        const promise = origCreateOffer.apply(this, [
            options
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    prototype.createAnswer = function createAnswer(successCallback, failureCallback) {
        const options = arguments.length >= 2 ? arguments[2] : arguments[0];
        const promise = origCreateAnswer.apply(this, [
            options
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    let withCallback = function(description, successCallback, failureCallback) {
        const promise = setLocalDescription.apply(this, [
            description
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    prototype.setLocalDescription = withCallback;
    withCallback = function(description, successCallback, failureCallback) {
        const promise = setRemoteDescription.apply(this, [
            description
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    prototype.setRemoteDescription = withCallback;
    withCallback = function(candidate, successCallback, failureCallback) {
        const promise = addIceCandidate.apply(this, [
            candidate
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    prototype.addIceCandidate = withCallback;
}
function $c0722d30b1d17141$var$shimGetUserMedia(window1) {
    const navigator1 = window1 && window1.navigator;
    if (navigator1.mediaDevices && navigator1.mediaDevices.getUserMedia) {
        // shim not needed in Safari 12.1
        const mediaDevices = navigator1.mediaDevices;
        const _getUserMedia = mediaDevices.getUserMedia.bind(mediaDevices);
        navigator1.mediaDevices.getUserMedia = (constraints)=>{
            return _getUserMedia($c0722d30b1d17141$var$shimConstraints(constraints));
        };
    }
    if (!navigator1.getUserMedia && navigator1.mediaDevices && navigator1.mediaDevices.getUserMedia) navigator1.getUserMedia = (function getUserMedia(constraints, cb, errcb) {
        navigator1.mediaDevices.getUserMedia(constraints).then(cb, errcb);
    }).bind(navigator1);
}
function $c0722d30b1d17141$var$shimConstraints(constraints) {
    if (constraints && constraints.video !== undefined) return Object.assign({}, constraints, {
        video: $c0722d30b1d17141$var$compactObject(constraints.video)
    });
    return constraints;
}
function $c0722d30b1d17141$var$shimRTCIceServerUrls(window1) {
    if (!window1.RTCPeerConnection) return;
    // migrate from non-spec RTCIceServer.url to RTCIceServer.urls
    const OrigPeerConnection = window1.RTCPeerConnection;
    window1.RTCPeerConnection = function RTCPeerConnection1(pcConfig, pcConstraints) {
        if (pcConfig && pcConfig.iceServers) {
            const newIceServers = [];
            for(let i = 0; i < pcConfig.iceServers.length; i++){
                let server = pcConfig.iceServers[i];
                if (server.urls === undefined && server.url) {
                    $c0722d30b1d17141$var$deprecated('RTCIceServer.url', 'RTCIceServer.urls');
                    server = JSON.parse(JSON.stringify(server));
                    server.urls = server.url;
                    delete server.url;
                    newIceServers.push(server);
                } else newIceServers.push(pcConfig.iceServers[i]);
            }
            pcConfig.iceServers = newIceServers;
        }
        return new OrigPeerConnection(pcConfig, pcConstraints);
    };
    window1.RTCPeerConnection.prototype = OrigPeerConnection.prototype;
    // wrap static methods. Currently just generateCertificate.
    if ('generateCertificate' in OrigPeerConnection) Object.defineProperty(window1.RTCPeerConnection, 'generateCertificate', {
        get () {
            return OrigPeerConnection.generateCertificate;
        }
    });
}
function $c0722d30b1d17141$var$shimTrackEventTransceiver(window1) {
    // Add event.transceiver member over deprecated event.receiver
    if (typeof window1 === 'object' && window1.RTCTrackEvent && 'receiver' in window1.RTCTrackEvent.prototype && !('transceiver' in window1.RTCTrackEvent.prototype)) Object.defineProperty(window1.RTCTrackEvent.prototype, 'transceiver', {
        get () {
            return {
                receiver: this.receiver
            };
        }
    });
}
function $c0722d30b1d17141$var$shimCreateOfferLegacy(window1) {
    const origCreateOffer = window1.RTCPeerConnection.prototype.createOffer;
    window1.RTCPeerConnection.prototype.createOffer = function createOffer(offerOptions) {
        if (offerOptions) {
            if (typeof offerOptions.offerToReceiveAudio !== 'undefined') // support bit values
            offerOptions.offerToReceiveAudio = !!offerOptions.offerToReceiveAudio;
            const audioTransceiver = this.getTransceivers().find((transceiver)=>transceiver.receiver.track.kind === 'audio');
            if (offerOptions.offerToReceiveAudio === false && audioTransceiver) {
                if (audioTransceiver.direction === 'sendrecv') {
                    if (audioTransceiver.setDirection) audioTransceiver.setDirection('sendonly');
                    else audioTransceiver.direction = 'sendonly';
                } else if (audioTransceiver.direction === 'recvonly') {
                    if (audioTransceiver.setDirection) audioTransceiver.setDirection('inactive');
                    else audioTransceiver.direction = 'inactive';
                }
            } else if (offerOptions.offerToReceiveAudio === true && !audioTransceiver) this.addTransceiver('audio', {
                direction: 'recvonly'
            });
            if (typeof offerOptions.offerToReceiveVideo !== 'undefined') // support bit values
            offerOptions.offerToReceiveVideo = !!offerOptions.offerToReceiveVideo;
            const videoTransceiver = this.getTransceivers().find((transceiver)=>transceiver.receiver.track.kind === 'video');
            if (offerOptions.offerToReceiveVideo === false && videoTransceiver) {
                if (videoTransceiver.direction === 'sendrecv') {
                    if (videoTransceiver.setDirection) videoTransceiver.setDirection('sendonly');
                    else videoTransceiver.direction = 'sendonly';
                } else if (videoTransceiver.direction === 'recvonly') {
                    if (videoTransceiver.setDirection) videoTransceiver.setDirection('inactive');
                    else videoTransceiver.direction = 'inactive';
                }
            } else if (offerOptions.offerToReceiveVideo === true && !videoTransceiver) this.addTransceiver('video', {
                direction: 'recvonly'
            });
        }
        return origCreateOffer.apply(this, arguments);
    };
}
function $c0722d30b1d17141$var$shimAudioContext(window1) {
    if (typeof window1 !== 'object' || window1.AudioContext) return;
    window1.AudioContext = window1.webkitAudioContext;
}
var $c0722d30b1d17141$var$safariShim = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    shimAudioContext: $c0722d30b1d17141$var$shimAudioContext,
    shimCallbacksAPI: $c0722d30b1d17141$var$shimCallbacksAPI,
    shimConstraints: $c0722d30b1d17141$var$shimConstraints,
    shimCreateOfferLegacy: $c0722d30b1d17141$var$shimCreateOfferLegacy,
    shimGetUserMedia: $c0722d30b1d17141$var$shimGetUserMedia,
    shimLocalStreamsAPI: $c0722d30b1d17141$var$shimLocalStreamsAPI,
    shimRTCIceServerUrls: $c0722d30b1d17141$var$shimRTCIceServerUrls,
    shimRemoteStreamsAPI: $c0722d30b1d17141$var$shimRemoteStreamsAPI,
    shimTrackEventTransceiver: $c0722d30b1d17141$var$shimTrackEventTransceiver
});
var $c0722d30b1d17141$var$sdp$1 = {
    exports: {}
}; /* eslint-env node */ 
var $c0722d30b1d17141$var$hasRequiredSdp;
function $c0722d30b1d17141$var$requireSdp() {
    if ($c0722d30b1d17141$var$hasRequiredSdp) return $c0722d30b1d17141$var$sdp$1.exports;
    $c0722d30b1d17141$var$hasRequiredSdp = 1;
    (function(module) {
        // SDP helpers.
        const SDPUtils = {};
        // Generate an alphanumeric identifier for cname or mids.
        // TODO: use UUIDs instead? https://gist.github.com/jed/982883
        SDPUtils.generateIdentifier = function() {
            return Math.random().toString(36).substring(2, 12);
        };
        // The RTCP CNAME used by all peerconnections from the same JS.
        SDPUtils.localCName = SDPUtils.generateIdentifier();
        // Splits SDP into lines, dealing with both CRLF and LF.
        SDPUtils.splitLines = function(blob) {
            return blob.trim().split('\n').map((line)=>line.trim());
        };
        // Splits SDP into sessionpart and mediasections. Ensures CRLF.
        SDPUtils.splitSections = function(blob) {
            const parts = blob.split('\nm=');
            return parts.map((part, index)=>(index > 0 ? 'm=' + part : part).trim() + '\r\n');
        };
        // Returns the session description.
        SDPUtils.getDescription = function(blob) {
            const sections = SDPUtils.splitSections(blob);
            return sections && sections[0];
        };
        // Returns the individual media sections.
        SDPUtils.getMediaSections = function(blob) {
            const sections = SDPUtils.splitSections(blob);
            sections.shift();
            return sections;
        };
        // Returns lines that start with a certain prefix.
        SDPUtils.matchPrefix = function(blob, prefix) {
            return SDPUtils.splitLines(blob).filter((line)=>line.indexOf(prefix) === 0);
        };
        // Parses an ICE candidate line. Sample input:
        // candidate:702786350 2 udp 41819902 8.8.8.8 60769 typ relay raddr 8.8.8.8
        // rport 55996"
        // Input can be prefixed with a=.
        SDPUtils.parseCandidate = function(line) {
            let parts;
            // Parse both variants.
            if (line.indexOf('a=candidate:') === 0) parts = line.substring(12).split(' ');
            else parts = line.substring(10).split(' ');
            const candidate = {
                foundation: parts[0],
                component: {
                    1: 'rtp',
                    2: 'rtcp'
                }[parts[1]] || parts[1],
                protocol: parts[2].toLowerCase(),
                priority: parseInt(parts[3], 10),
                ip: parts[4],
                address: parts[4],
                // address is an alias for ip.
                port: parseInt(parts[5], 10),
                // skip parts[6] == 'typ'
                type: parts[7]
            };
            for(let i = 8; i < parts.length; i += 2)switch(parts[i]){
                case 'raddr':
                    candidate.relatedAddress = parts[i + 1];
                    break;
                case 'rport':
                    candidate.relatedPort = parseInt(parts[i + 1], 10);
                    break;
                case 'tcptype':
                    candidate.tcpType = parts[i + 1];
                    break;
                case 'ufrag':
                    candidate.ufrag = parts[i + 1]; // for backward compatibility.
                    candidate.usernameFragment = parts[i + 1];
                    break;
                default:
                    // extension handling, in particular ufrag. Don't overwrite.
                    if (candidate[parts[i]] === undefined) candidate[parts[i]] = parts[i + 1];
                    break;
            }
            return candidate;
        };
        // Translates a candidate object into SDP candidate attribute.
        // This does not include the a= prefix!
        SDPUtils.writeCandidate = function(candidate) {
            const sdp = [];
            sdp.push(candidate.foundation);
            const component = candidate.component;
            if (component === 'rtp') sdp.push(1);
            else if (component === 'rtcp') sdp.push(2);
            else sdp.push(component);
            sdp.push(candidate.protocol.toUpperCase());
            sdp.push(candidate.priority);
            sdp.push(candidate.address || candidate.ip);
            sdp.push(candidate.port);
            const type = candidate.type;
            sdp.push('typ');
            sdp.push(type);
            if (type !== 'host' && candidate.relatedAddress && candidate.relatedPort !== undefined) {
                sdp.push('raddr');
                sdp.push(candidate.relatedAddress);
                sdp.push('rport');
                sdp.push(candidate.relatedPort);
            }
            if (candidate.tcpType && candidate.protocol.toLowerCase() === 'tcp') {
                sdp.push('tcptype');
                sdp.push(candidate.tcpType);
            }
            if (candidate.usernameFragment || candidate.ufrag) {
                sdp.push('ufrag');
                sdp.push(candidate.usernameFragment || candidate.ufrag);
            }
            return 'candidate:' + sdp.join(' ');
        };
        // Parses an ice-options line, returns an array of option tags.
        // Sample input:
        // a=ice-options:foo bar
        SDPUtils.parseIceOptions = function(line) {
            return line.substring(14).split(' ');
        };
        // Parses a rtpmap line, returns RTCRtpCoddecParameters. Sample input:
        // a=rtpmap:111 opus/48000/2
        SDPUtils.parseRtpMap = function(line) {
            let parts = line.substring(9).split(' ');
            const parsed = {
                payloadType: parseInt(parts.shift(), 10) // was: id
            };
            parts = parts[0].split('/');
            parsed.name = parts[0];
            parsed.clockRate = parseInt(parts[1], 10); // was: clockrate
            parsed.channels = parts.length === 3 ? parseInt(parts[2], 10) : 1;
            // legacy alias, got renamed back to channels in ORTC.
            parsed.numChannels = parsed.channels;
            return parsed;
        };
        // Generates a rtpmap line from RTCRtpCodecCapability or
        // RTCRtpCodecParameters.
        SDPUtils.writeRtpMap = function(codec) {
            let pt = codec.payloadType;
            if (codec.preferredPayloadType !== undefined) pt = codec.preferredPayloadType;
            const channels = codec.channels || codec.numChannels || 1;
            return 'a=rtpmap:' + pt + ' ' + codec.name + '/' + codec.clockRate + (channels !== 1 ? '/' + channels : '') + '\r\n';
        };
        // Parses a extmap line (headerextension from RFC 5285). Sample input:
        // a=extmap:2 urn:ietf:params:rtp-hdrext:toffset
        // a=extmap:2/sendonly urn:ietf:params:rtp-hdrext:toffset
        SDPUtils.parseExtmap = function(line) {
            const parts = line.substring(9).split(' ');
            return {
                id: parseInt(parts[0], 10),
                direction: parts[0].indexOf('/') > 0 ? parts[0].split('/')[1] : 'sendrecv',
                uri: parts[1],
                attributes: parts.slice(2).join(' ')
            };
        };
        // Generates an extmap line from RTCRtpHeaderExtensionParameters or
        // RTCRtpHeaderExtension.
        SDPUtils.writeExtmap = function(headerExtension) {
            return 'a=extmap:' + (headerExtension.id || headerExtension.preferredId) + (headerExtension.direction && headerExtension.direction !== 'sendrecv' ? '/' + headerExtension.direction : '') + ' ' + headerExtension.uri + (headerExtension.attributes ? ' ' + headerExtension.attributes : '') + '\r\n';
        };
        // Parses a fmtp line, returns dictionary. Sample input:
        // a=fmtp:96 vbr=on;cng=on
        // Also deals with vbr=on; cng=on
        // Non-key-value such as telephone-events `0-15` get parsed as
        // {`0-15`:undefined}
        SDPUtils.parseFmtp = function(line) {
            const parsed = {};
            let kv;
            const parts = line.substring(line.indexOf(' ') + 1).split(';');
            for(let j = 0; j < parts.length; j++){
                kv = parts[j].trim().split('=');
                parsed[kv[0].trim()] = kv[1];
            }
            return parsed;
        };
        // Generates a fmtp line from RTCRtpCodecCapability or RTCRtpCodecParameters.
        SDPUtils.writeFmtp = function(codec) {
            let line = '';
            let pt = codec.payloadType;
            if (codec.preferredPayloadType !== undefined) pt = codec.preferredPayloadType;
            if (codec.parameters && Object.keys(codec.parameters).length) {
                const params = [];
                Object.keys(codec.parameters).forEach((param)=>{
                    if (codec.parameters[param] !== undefined) params.push(param + '=' + codec.parameters[param]);
                    else params.push(param);
                });
                line += 'a=fmtp:' + pt + ' ' + params.join(';') + '\r\n';
            }
            return line;
        };
        // Parses a rtcp-fb line, returns RTCPRtcpFeedback object. Sample input:
        // a=rtcp-fb:98 nack rpsi
        SDPUtils.parseRtcpFb = function(line) {
            const parts = line.substring(line.indexOf(' ') + 1).split(' ');
            return {
                type: parts.shift(),
                parameter: parts.join(' ')
            };
        };
        // Generate a=rtcp-fb lines from RTCRtpCodecCapability or RTCRtpCodecParameters.
        SDPUtils.writeRtcpFb = function(codec) {
            let lines = '';
            let pt = codec.payloadType;
            if (codec.preferredPayloadType !== undefined) pt = codec.preferredPayloadType;
            if (codec.rtcpFeedback && codec.rtcpFeedback.length) // FIXME: special handling for trr-int?
            codec.rtcpFeedback.forEach((fb)=>{
                lines += 'a=rtcp-fb:' + pt + ' ' + fb.type + (fb.parameter && fb.parameter.length ? ' ' + fb.parameter : '') + '\r\n';
            });
            return lines;
        };
        // Parses a RFC 5576 ssrc media attribute. Sample input:
        // a=ssrc:3735928559 cname:something
        SDPUtils.parseSsrcMedia = function(line) {
            const sp = line.indexOf(' ');
            const parts = {
                ssrc: parseInt(line.substring(7, sp), 10)
            };
            const colon = line.indexOf(':', sp);
            if (colon > -1) {
                parts.attribute = line.substring(sp + 1, colon);
                parts.value = line.substring(colon + 1);
            } else parts.attribute = line.substring(sp + 1);
            return parts;
        };
        // Parse a ssrc-group line (see RFC 5576). Sample input:
        // a=ssrc-group:semantics 12 34
        SDPUtils.parseSsrcGroup = function(line) {
            const parts = line.substring(13).split(' ');
            return {
                semantics: parts.shift(),
                ssrcs: parts.map((ssrc)=>parseInt(ssrc, 10))
            };
        };
        // Extracts the MID (RFC 5888) from a media section.
        // Returns the MID or undefined if no mid line was found.
        SDPUtils.getMid = function(mediaSection) {
            const mid = SDPUtils.matchPrefix(mediaSection, 'a=mid:')[0];
            if (mid) return mid.substring(6);
        };
        // Parses a fingerprint line for DTLS-SRTP.
        SDPUtils.parseFingerprint = function(line) {
            const parts = line.substring(14).split(' ');
            return {
                algorithm: parts[0].toLowerCase(),
                // algorithm is case-sensitive in Edge.
                value: parts[1].toUpperCase() // the definition is upper-case in RFC 4572.
            };
        };
        // Extracts DTLS parameters from SDP media section or sessionpart.
        // FIXME: for consistency with other functions this should only
        //   get the fingerprint line as input. See also getIceParameters.
        SDPUtils.getDtlsParameters = function(mediaSection, sessionpart) {
            const lines = SDPUtils.matchPrefix(mediaSection + sessionpart, 'a=fingerprint:');
            // Note: a=setup line is ignored since we use the 'auto' role in Edge.
            return {
                role: 'auto',
                fingerprints: lines.map(SDPUtils.parseFingerprint)
            };
        };
        // Serializes DTLS parameters to SDP.
        SDPUtils.writeDtlsParameters = function(params, setupType) {
            let sdp = 'a=setup:' + setupType + '\r\n';
            params.fingerprints.forEach((fp)=>{
                sdp += 'a=fingerprint:' + fp.algorithm + ' ' + fp.value + '\r\n';
            });
            return sdp;
        };
        // Parses a=crypto lines into
        //   https://rawgit.com/aboba/edgertc/master/msortc-rs4.html#dictionary-rtcsrtpsdesparameters-members
        SDPUtils.parseCryptoLine = function(line) {
            const parts = line.substring(9).split(' ');
            return {
                tag: parseInt(parts[0], 10),
                cryptoSuite: parts[1],
                keyParams: parts[2],
                sessionParams: parts.slice(3)
            };
        };
        SDPUtils.writeCryptoLine = function(parameters) {
            return 'a=crypto:' + parameters.tag + ' ' + parameters.cryptoSuite + ' ' + (typeof parameters.keyParams === 'object' ? SDPUtils.writeCryptoKeyParams(parameters.keyParams) : parameters.keyParams) + (parameters.sessionParams ? ' ' + parameters.sessionParams.join(' ') : '') + '\r\n';
        };
        // Parses the crypto key parameters into
        //   https://rawgit.com/aboba/edgertc/master/msortc-rs4.html#rtcsrtpkeyparam*
        SDPUtils.parseCryptoKeyParams = function(keyParams) {
            if (keyParams.indexOf('inline:') !== 0) return null;
            const parts = keyParams.substring(7).split('|');
            return {
                keyMethod: 'inline',
                keySalt: parts[0],
                lifeTime: parts[1],
                mkiValue: parts[2] ? parts[2].split(':')[0] : undefined,
                mkiLength: parts[2] ? parts[2].split(':')[1] : undefined
            };
        };
        SDPUtils.writeCryptoKeyParams = function(keyParams) {
            return keyParams.keyMethod + ':' + keyParams.keySalt + (keyParams.lifeTime ? '|' + keyParams.lifeTime : '') + (keyParams.mkiValue && keyParams.mkiLength ? '|' + keyParams.mkiValue + ':' + keyParams.mkiLength : '');
        };
        // Extracts all SDES parameters.
        SDPUtils.getCryptoParameters = function(mediaSection, sessionpart) {
            const lines = SDPUtils.matchPrefix(mediaSection + sessionpart, 'a=crypto:');
            return lines.map(SDPUtils.parseCryptoLine);
        };
        // Parses ICE information from SDP media section or sessionpart.
        // FIXME: for consistency with other functions this should only
        //   get the ice-ufrag and ice-pwd lines as input.
        SDPUtils.getIceParameters = function(mediaSection, sessionpart) {
            const ufrag = SDPUtils.matchPrefix(mediaSection + sessionpart, 'a=ice-ufrag:')[0];
            const pwd = SDPUtils.matchPrefix(mediaSection + sessionpart, 'a=ice-pwd:')[0];
            if (!(ufrag && pwd)) return null;
            return {
                usernameFragment: ufrag.substring(12),
                password: pwd.substring(10)
            };
        };
        // Serializes ICE parameters to SDP.
        SDPUtils.writeIceParameters = function(params) {
            let sdp = 'a=ice-ufrag:' + params.usernameFragment + '\r\n' + 'a=ice-pwd:' + params.password + '\r\n';
            if (params.iceLite) sdp += 'a=ice-lite\r\n';
            return sdp;
        };
        // Parses the SDP media section and returns RTCRtpParameters.
        SDPUtils.parseRtpParameters = function(mediaSection) {
            const description = {
                codecs: [],
                headerExtensions: [],
                fecMechanisms: [],
                rtcp: []
            };
            const lines = SDPUtils.splitLines(mediaSection);
            const mline = lines[0].split(' ');
            description.profile = mline[2];
            for(let i = 3; i < mline.length; i++){
                // find all codecs from mline[3..]
                const pt = mline[i];
                const rtpmapline = SDPUtils.matchPrefix(mediaSection, 'a=rtpmap:' + pt + ' ')[0];
                if (rtpmapline) {
                    const codec = SDPUtils.parseRtpMap(rtpmapline);
                    const fmtps = SDPUtils.matchPrefix(mediaSection, 'a=fmtp:' + pt + ' ');
                    // Only the first a=fmtp:<pt> is considered.
                    codec.parameters = fmtps.length ? SDPUtils.parseFmtp(fmtps[0]) : {};
                    codec.rtcpFeedback = SDPUtils.matchPrefix(mediaSection, 'a=rtcp-fb:' + pt + ' ').map(SDPUtils.parseRtcpFb);
                    description.codecs.push(codec);
                    // parse FEC mechanisms from rtpmap lines.
                    switch(codec.name.toUpperCase()){
                        case 'RED':
                        case 'ULPFEC':
                            description.fecMechanisms.push(codec.name.toUpperCase());
                            break;
                    }
                }
            }
            SDPUtils.matchPrefix(mediaSection, 'a=extmap:').forEach((line)=>{
                description.headerExtensions.push(SDPUtils.parseExtmap(line));
            });
            const wildcardRtcpFb = SDPUtils.matchPrefix(mediaSection, 'a=rtcp-fb:* ').map(SDPUtils.parseRtcpFb);
            description.codecs.forEach((codec)=>{
                wildcardRtcpFb.forEach((fb)=>{
                    const duplicate = codec.rtcpFeedback.find((existingFeedback)=>{
                        return existingFeedback.type === fb.type && existingFeedback.parameter === fb.parameter;
                    });
                    if (!duplicate) codec.rtcpFeedback.push(fb);
                });
            });
            // FIXME: parse rtcp.
            return description;
        };
        // Generates parts of the SDP media section describing the capabilities /
        // parameters.
        SDPUtils.writeRtpDescription = function(kind, caps) {
            let sdp = '';
            // Build the mline.
            sdp += 'm=' + kind + ' ';
            sdp += caps.codecs.length > 0 ? '9' : '0'; // reject if no codecs.
            sdp += ' ' + (caps.profile || 'UDP/TLS/RTP/SAVPF') + ' ';
            sdp += caps.codecs.map((codec)=>{
                if (codec.preferredPayloadType !== undefined) return codec.preferredPayloadType;
                return codec.payloadType;
            }).join(' ') + '\r\n';
            sdp += 'c=IN IP4 0.0.0.0\r\n';
            sdp += 'a=rtcp:9 IN IP4 0.0.0.0\r\n';
            // Add a=rtpmap lines for each codec. Also fmtp and rtcp-fb.
            caps.codecs.forEach((codec)=>{
                sdp += SDPUtils.writeRtpMap(codec);
                sdp += SDPUtils.writeFmtp(codec);
                sdp += SDPUtils.writeRtcpFb(codec);
            });
            let maxptime = 0;
            caps.codecs.forEach((codec)=>{
                if (codec.maxptime > maxptime) maxptime = codec.maxptime;
            });
            if (maxptime > 0) sdp += 'a=maxptime:' + maxptime + '\r\n';
            if (caps.headerExtensions) caps.headerExtensions.forEach((extension)=>{
                sdp += SDPUtils.writeExtmap(extension);
            });
            // FIXME: write fecMechanisms.
            return sdp;
        };
        // Parses the SDP media section and returns an array of
        // RTCRtpEncodingParameters.
        SDPUtils.parseRtpEncodingParameters = function(mediaSection) {
            const encodingParameters = [];
            const description = SDPUtils.parseRtpParameters(mediaSection);
            const hasRed = description.fecMechanisms.indexOf('RED') !== -1;
            const hasUlpfec = description.fecMechanisms.indexOf('ULPFEC') !== -1;
            // filter a=ssrc:... cname:, ignore PlanB-msid
            const ssrcs = SDPUtils.matchPrefix(mediaSection, 'a=ssrc:').map((line)=>SDPUtils.parseSsrcMedia(line)).filter((parts)=>parts.attribute === 'cname');
            const primarySsrc = ssrcs.length > 0 && ssrcs[0].ssrc;
            let secondarySsrc;
            const flows = SDPUtils.matchPrefix(mediaSection, 'a=ssrc-group:FID').map((line)=>{
                const parts = line.substring(17).split(' ');
                return parts.map((part)=>parseInt(part, 10));
            });
            if (flows.length > 0 && flows[0].length > 1 && flows[0][0] === primarySsrc) secondarySsrc = flows[0][1];
            description.codecs.forEach((codec)=>{
                if (codec.name.toUpperCase() === 'RTX' && codec.parameters.apt) {
                    let encParam = {
                        ssrc: primarySsrc,
                        codecPayloadType: parseInt(codec.parameters.apt, 10)
                    };
                    if (primarySsrc && secondarySsrc) encParam.rtx = {
                        ssrc: secondarySsrc
                    };
                    encodingParameters.push(encParam);
                    if (hasRed) {
                        encParam = JSON.parse(JSON.stringify(encParam));
                        encParam.fec = {
                            ssrc: primarySsrc,
                            mechanism: hasUlpfec ? 'red+ulpfec' : 'red'
                        };
                        encodingParameters.push(encParam);
                    }
                }
            });
            if (encodingParameters.length === 0 && primarySsrc) encodingParameters.push({
                ssrc: primarySsrc
            });
            // we support both b=AS and b=TIAS but interpret AS as TIAS.
            let bandwidth = SDPUtils.matchPrefix(mediaSection, 'b=');
            if (bandwidth.length) {
                if (bandwidth[0].indexOf('b=TIAS:') === 0) bandwidth = parseInt(bandwidth[0].substring(7), 10);
                else if (bandwidth[0].indexOf('b=AS:') === 0) // use formula from JSEP to convert b=AS to TIAS value.
                bandwidth = parseInt(bandwidth[0].substring(5), 10) * 950 - 16000;
                else bandwidth = undefined;
                encodingParameters.forEach((params)=>{
                    params.maxBitrate = bandwidth;
                });
            }
            return encodingParameters;
        };
        // parses http://draft.ortc.org/#rtcrtcpparameters*
        SDPUtils.parseRtcpParameters = function(mediaSection) {
            const rtcpParameters = {};
            // Gets the first SSRC. Note that with RTX there might be multiple
            // SSRCs.
            const remoteSsrc = SDPUtils.matchPrefix(mediaSection, 'a=ssrc:').map((line)=>SDPUtils.parseSsrcMedia(line)).filter((obj)=>obj.attribute === 'cname')[0];
            if (remoteSsrc) {
                rtcpParameters.cname = remoteSsrc.value;
                rtcpParameters.ssrc = remoteSsrc.ssrc;
            }
            // Edge uses the compound attribute instead of reducedSize
            // compound is !reducedSize
            const rsize = SDPUtils.matchPrefix(mediaSection, 'a=rtcp-rsize');
            rtcpParameters.reducedSize = rsize.length > 0;
            rtcpParameters.compound = rsize.length === 0;
            // parses the rtcp-mux attrіbute.
            // Note that Edge does not support unmuxed RTCP.
            const mux = SDPUtils.matchPrefix(mediaSection, 'a=rtcp-mux');
            rtcpParameters.mux = mux.length > 0;
            return rtcpParameters;
        };
        SDPUtils.writeRtcpParameters = function(rtcpParameters) {
            let sdp = '';
            if (rtcpParameters.reducedSize) sdp += 'a=rtcp-rsize\r\n';
            if (rtcpParameters.mux) sdp += 'a=rtcp-mux\r\n';
            if (rtcpParameters.ssrc !== undefined && rtcpParameters.cname) sdp += 'a=ssrc:' + rtcpParameters.ssrc + ' cname:' + rtcpParameters.cname + '\r\n';
            return sdp;
        };
        // parses either a=msid: or a=ssrc:... msid lines and returns
        // the id of the MediaStream and MediaStreamTrack.
        SDPUtils.parseMsid = function(mediaSection) {
            let parts;
            const spec = SDPUtils.matchPrefix(mediaSection, 'a=msid:');
            if (spec.length === 1) {
                parts = spec[0].substring(7).split(' ');
                return {
                    stream: parts[0],
                    track: parts[1]
                };
            }
            const planB = SDPUtils.matchPrefix(mediaSection, 'a=ssrc:').map((line)=>SDPUtils.parseSsrcMedia(line)).filter((msidParts)=>msidParts.attribute === 'msid');
            if (planB.length > 0) {
                parts = planB[0].value.split(' ');
                return {
                    stream: parts[0],
                    track: parts[1]
                };
            }
        };
        // SCTP
        // parses draft-ietf-mmusic-sctp-sdp-26 first and falls back
        // to draft-ietf-mmusic-sctp-sdp-05
        SDPUtils.parseSctpDescription = function(mediaSection) {
            const mline = SDPUtils.parseMLine(mediaSection);
            const maxSizeLine = SDPUtils.matchPrefix(mediaSection, 'a=max-message-size:');
            let maxMessageSize;
            if (maxSizeLine.length > 0) maxMessageSize = parseInt(maxSizeLine[0].substring(19), 10);
            if (isNaN(maxMessageSize)) maxMessageSize = 65536;
            const sctpPort = SDPUtils.matchPrefix(mediaSection, 'a=sctp-port:');
            if (sctpPort.length > 0) return {
                port: parseInt(sctpPort[0].substring(12), 10),
                protocol: mline.fmt,
                maxMessageSize: maxMessageSize
            };
            const sctpMapLines = SDPUtils.matchPrefix(mediaSection, 'a=sctpmap:');
            if (sctpMapLines.length > 0) {
                const parts = sctpMapLines[0].substring(10).split(' ');
                return {
                    port: parseInt(parts[0], 10),
                    protocol: parts[1],
                    maxMessageSize: maxMessageSize
                };
            }
        };
        // SCTP
        // outputs the draft-ietf-mmusic-sctp-sdp-26 version that all browsers
        // support by now receiving in this format, unless we originally parsed
        // as the draft-ietf-mmusic-sctp-sdp-05 format (indicated by the m-line
        // protocol of DTLS/SCTP -- without UDP/ or TCP/)
        SDPUtils.writeSctpDescription = function(media, sctp) {
            let output = [];
            if (media.protocol !== 'DTLS/SCTP') output = [
                'm=' + media.kind + ' 9 ' + media.protocol + ' ' + sctp.protocol + '\r\n',
                'c=IN IP4 0.0.0.0\r\n',
                'a=sctp-port:' + sctp.port + '\r\n'
            ];
            else output = [
                'm=' + media.kind + ' 9 ' + media.protocol + ' ' + sctp.port + '\r\n',
                'c=IN IP4 0.0.0.0\r\n',
                'a=sctpmap:' + sctp.port + ' ' + sctp.protocol + ' 65535\r\n'
            ];
            if (sctp.maxMessageSize !== undefined) output.push('a=max-message-size:' + sctp.maxMessageSize + '\r\n');
            return output.join('');
        };
        // Generate a session ID for SDP.
        // https://tools.ietf.org/html/draft-ietf-rtcweb-jsep-20#section-5.2.1
        // recommends using a cryptographically random +ve 64-bit value
        // but right now this should be acceptable and within the right range
        SDPUtils.generateSessionId = function() {
            return Math.random().toString().substr(2, 22);
        };
        // Write boiler plate for start of SDP
        // sessId argument is optional - if not supplied it will
        // be generated randomly
        // sessVersion is optional and defaults to 2
        // sessUser is optional and defaults to 'thisisadapterortc'
        SDPUtils.writeSessionBoilerplate = function(sessId, sessVer, sessUser) {
            let sessionId;
            const version = sessVer !== undefined ? sessVer : 2;
            if (sessId) sessionId = sessId;
            else sessionId = SDPUtils.generateSessionId();
            const user = sessUser || 'thisisadapterortc';
            // FIXME: sess-id should be an NTP timestamp.
            return "v=0\r\no=" + user + ' ' + sessionId + ' ' + version + ' IN IP4 127.0.0.1\r\n' + 's=-\r\n' + 't=0 0\r\n';
        };
        // Gets the direction from the mediaSection or the sessionpart.
        SDPUtils.getDirection = function(mediaSection, sessionpart) {
            // Look for sendrecv, sendonly, recvonly, inactive, default to sendrecv.
            const lines = SDPUtils.splitLines(mediaSection);
            for(let i = 0; i < lines.length; i++)switch(lines[i]){
                case 'a=sendrecv':
                case 'a=sendonly':
                case 'a=recvonly':
                case 'a=inactive':
                    return lines[i].substring(2);
            }
            if (sessionpart) return SDPUtils.getDirection(sessionpart);
            return 'sendrecv';
        };
        SDPUtils.getKind = function(mediaSection) {
            const lines = SDPUtils.splitLines(mediaSection);
            const mline = lines[0].split(' ');
            return mline[0].substring(2);
        };
        SDPUtils.isRejected = function(mediaSection) {
            return mediaSection.split(' ', 2)[1] === '0';
        };
        SDPUtils.parseMLine = function(mediaSection) {
            const lines = SDPUtils.splitLines(mediaSection);
            const parts = lines[0].substring(2).split(' ');
            return {
                kind: parts[0],
                port: parseInt(parts[1], 10),
                protocol: parts[2],
                fmt: parts.slice(3).join(' ')
            };
        };
        SDPUtils.parseOLine = function(mediaSection) {
            const line = SDPUtils.matchPrefix(mediaSection, 'o=')[0];
            const parts = line.substring(2).split(' ');
            return {
                username: parts[0],
                sessionId: parts[1],
                sessionVersion: parseInt(parts[2], 10),
                netType: parts[3],
                addressType: parts[4],
                address: parts[5]
            };
        };
        // a very naive interpretation of a valid SDP.
        SDPUtils.isValidSDP = function(blob) {
            if (typeof blob !== 'string' || blob.length === 0) return false;
            const lines = SDPUtils.splitLines(blob);
            for(let i = 0; i < lines.length; i++){
                if (lines[i].length < 2 || lines[i].charAt(1) !== '=') return false;
            // TODO: check the modifier a bit more.
            }
            return true;
        };
        module.exports = SDPUtils;
    })($c0722d30b1d17141$var$sdp$1);
    return $c0722d30b1d17141$var$sdp$1.exports;
}
var $c0722d30b1d17141$var$sdpExports = $c0722d30b1d17141$var$requireSdp();
var $c0722d30b1d17141$var$SDPUtils = /*@__PURE__*/ $c0722d30b1d17141$var$getDefaultExportFromCjs($c0722d30b1d17141$var$sdpExports);
var $c0722d30b1d17141$var$sdp = /*#__PURE__*/ $c0722d30b1d17141$var$_mergeNamespaces({
    __proto__: null,
    default: $c0722d30b1d17141$var$SDPUtils
}, [
    $c0722d30b1d17141$var$sdpExports
]); /*
 *  Copyright (c) 2017 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ 
/* eslint-env node */ function $c0722d30b1d17141$var$shimRTCIceCandidate(window1) {
    // foundation is arbitrarily chosen as an indicator for full support for
    // https://w3c.github.io/webrtc-pc/#rtcicecandidate-interface
    if (!window1.RTCIceCandidate || window1.RTCIceCandidate && 'foundation' in window1.RTCIceCandidate.prototype) return;
    const NativeRTCIceCandidate = window1.RTCIceCandidate;
    window1.RTCIceCandidate = function RTCIceCandidate1(args) {
        // Remove the a= which shouldn't be part of the candidate string.
        if (typeof args === 'object' && args.candidate && args.candidate.indexOf('a=') === 0) {
            args = JSON.parse(JSON.stringify(args));
            args.candidate = args.candidate.substring(2);
        }
        if (args.candidate && args.candidate.length) {
            // Augment the native candidate with the parsed fields.
            const nativeCandidate = new NativeRTCIceCandidate(args);
            const parsedCandidate = $c0722d30b1d17141$var$SDPUtils.parseCandidate(args.candidate);
            for(const key in parsedCandidate)if (!(key in nativeCandidate)) Object.defineProperty(nativeCandidate, key, {
                value: parsedCandidate[key]
            });
            // Override serializer to not serialize the extra attributes.
            nativeCandidate.toJSON = function toJSON() {
                return {
                    candidate: nativeCandidate.candidate,
                    sdpMid: nativeCandidate.sdpMid,
                    sdpMLineIndex: nativeCandidate.sdpMLineIndex,
                    usernameFragment: nativeCandidate.usernameFragment
                };
            };
            return nativeCandidate;
        }
        return new NativeRTCIceCandidate(args);
    };
    window1.RTCIceCandidate.prototype = NativeRTCIceCandidate.prototype;
    // Hook up the augmented candidate in onicecandidate and
    // addEventListener('icecandidate', ...)
    $c0722d30b1d17141$var$wrapPeerConnectionEvent(window1, 'icecandidate', (e)=>{
        if (e.candidate) Object.defineProperty(e, 'candidate', {
            value: new window1.RTCIceCandidate(e.candidate),
            writable: 'false'
        });
        return e;
    });
}
function $c0722d30b1d17141$var$shimRTCIceCandidateRelayProtocol(window1) {
    if (!window1.RTCIceCandidate || window1.RTCIceCandidate && 'relayProtocol' in window1.RTCIceCandidate.prototype) return;
    // Hook up the augmented candidate in onicecandidate and
    // addEventListener('icecandidate', ...)
    $c0722d30b1d17141$var$wrapPeerConnectionEvent(window1, 'icecandidate', (e)=>{
        if (e.candidate) {
            const parsedCandidate = $c0722d30b1d17141$var$SDPUtils.parseCandidate(e.candidate.candidate);
            if (parsedCandidate.type === 'relay') // This is a libwebrtc-specific mapping of local type preference
            // to relayProtocol.
            e.candidate.relayProtocol = ({
                0: 'tls',
                1: 'tcp',
                2: 'udp'
            })[parsedCandidate.priority >> 24];
        }
        return e;
    });
}
function $c0722d30b1d17141$var$shimMaxMessageSize(window1, browserDetails) {
    if (!window1.RTCPeerConnection) return;
    if (!('sctp' in window1.RTCPeerConnection.prototype)) Object.defineProperty(window1.RTCPeerConnection.prototype, 'sctp', {
        get () {
            return typeof this._sctp === 'undefined' ? null : this._sctp;
        }
    });
    const sctpInDescription = function(description) {
        if (!description || !description.sdp) return false;
        const sections = $c0722d30b1d17141$var$SDPUtils.splitSections(description.sdp);
        sections.shift();
        return sections.some((mediaSection)=>{
            const mLine = $c0722d30b1d17141$var$SDPUtils.parseMLine(mediaSection);
            return mLine && mLine.kind === 'application' && mLine.protocol.indexOf('SCTP') !== -1;
        });
    };
    const getRemoteFirefoxVersion = function(description) {
        // TODO: Is there a better solution for detecting Firefox?
        const match = description.sdp.match(/mozilla...THIS_IS_SDPARTA-(\d+)/);
        if (match === null || match.length < 2) return -1;
        const version = parseInt(match[1], 10);
        // Test for NaN (yes, this is ugly)
        return version !== version ? -1 : version;
    };
    const getCanSendMaxMessageSize = function(remoteIsFirefox) {
        // Every implementation we know can send at least 64 KiB.
        // Note: Although Chrome is technically able to send up to 256 KiB, the
        //       data does not reach the other peer reliably.
        //       See: https://bugs.chromium.org/p/webrtc/issues/detail?id=8419
        let canSendMaxMessageSize = 65536;
        if (browserDetails.browser === 'firefox') {
            if (browserDetails.version < 57) {
                if (remoteIsFirefox === -1) // FF < 57 will send in 16 KiB chunks using the deprecated PPID
                // fragmentation.
                canSendMaxMessageSize = 16384;
                else // However, other FF (and RAWRTC) can reassemble PPID-fragmented
                // messages. Thus, supporting ~2 GiB when sending.
                canSendMaxMessageSize = 2147483637;
            } else if (browserDetails.version < 60) // Currently, all FF >= 57 will reset the remote maximum message size
            // to the default value when a data channel is created at a later
            // stage. :(
            // See: https://bugzilla.mozilla.org/show_bug.cgi?id=1426831
            canSendMaxMessageSize = browserDetails.version === 57 ? 65535 : 65536;
            else // FF >= 60 supports sending ~2 GiB
            canSendMaxMessageSize = 2147483637;
        }
        return canSendMaxMessageSize;
    };
    const getMaxMessageSize = function(description, remoteIsFirefox) {
        // Note: 65536 bytes is the default value from the SDP spec. Also,
        //       every implementation we know supports receiving 65536 bytes.
        let maxMessageSize = 65536;
        // FF 57 has a slightly incorrect default remote max message size, so
        // we need to adjust it here to avoid a failure when sending.
        // See: https://bugzilla.mozilla.org/show_bug.cgi?id=1425697
        if (browserDetails.browser === 'firefox' && browserDetails.version === 57) maxMessageSize = 65535;
        const match = $c0722d30b1d17141$var$SDPUtils.matchPrefix(description.sdp, 'a=max-message-size:');
        if (match.length > 0) maxMessageSize = parseInt(match[0].substring(19), 10);
        else if (browserDetails.browser === 'firefox' && remoteIsFirefox !== -1) // If the maximum message size is not present in the remote SDP and
        // both local and remote are Firefox, the remote peer can receive
        // ~2 GiB.
        maxMessageSize = 2147483637;
        return maxMessageSize;
    };
    const origSetRemoteDescription = window1.RTCPeerConnection.prototype.setRemoteDescription;
    window1.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription() {
        this._sctp = null;
        // Chrome decided to not expose .sctp in plan-b mode.
        // As usual, adapter.js has to do an 'ugly worakaround'
        // to cover up the mess.
        if (browserDetails.browser === 'chrome' && browserDetails.version >= 76) {
            const { sdpSemantics: sdpSemantics } = this.getConfiguration();
            if (sdpSemantics === 'plan-b') Object.defineProperty(this, 'sctp', {
                get () {
                    return typeof this._sctp === 'undefined' ? null : this._sctp;
                },
                enumerable: true,
                configurable: true
            });
        }
        if (sctpInDescription(arguments[0])) {
            // Check if the remote is FF.
            const isFirefox = getRemoteFirefoxVersion(arguments[0]);
            // Get the maximum message size the local peer is capable of sending
            const canSendMMS = getCanSendMaxMessageSize(isFirefox);
            // Get the maximum message size of the remote peer.
            const remoteMMS = getMaxMessageSize(arguments[0], isFirefox);
            // Determine final maximum message size
            let maxMessageSize;
            if (canSendMMS === 0 && remoteMMS === 0) maxMessageSize = Number.POSITIVE_INFINITY;
            else if (canSendMMS === 0 || remoteMMS === 0) maxMessageSize = Math.max(canSendMMS, remoteMMS);
            else maxMessageSize = Math.min(canSendMMS, remoteMMS);
            // Create a dummy RTCSctpTransport object and the 'maxMessageSize'
            // attribute.
            const sctp = {};
            Object.defineProperty(sctp, 'maxMessageSize', {
                get () {
                    return maxMessageSize;
                }
            });
            this._sctp = sctp;
        }
        return origSetRemoteDescription.apply(this, arguments);
    };
}
function $c0722d30b1d17141$var$shimSendThrowTypeError(window1, browserDetails) {
    if (!(window1.RTCPeerConnection && 'createDataChannel' in window1.RTCPeerConnection.prototype)) return;
    if (browserDetails.browser === 'chrome' && browserDetails.version > 149) // Fixed by https://issues.chromium.org/issues/490588131
    return;
    // Note: Although Firefox >= 57 has a native implementation, the maximum
    //       message size can be reset for all data channels at a later stage.
    //       See: https://bugzilla.mozilla.org/show_bug.cgi?id=1426831
    if (browserDetails.browser === 'firefox' && browserDetails.version > 60) return;
    function wrapDcSend(dc, pc) {
        const origDataChannelSend = dc.send;
        dc.send = function send() {
            const data = arguments[0];
            const length = data.length || data.size || data.byteLength;
            if (dc.readyState === 'open' && pc.sctp && length > pc.sctp.maxMessageSize) throw new TypeError('Message too large (can send a maximum of ' + pc.sctp.maxMessageSize + ' bytes)');
            return origDataChannelSend.apply(dc, arguments);
        };
    }
    const origCreateDataChannel = window1.RTCPeerConnection.prototype.createDataChannel;
    window1.RTCPeerConnection.prototype.createDataChannel = function createDataChannel() {
        const dataChannel = origCreateDataChannel.apply(this, arguments);
        wrapDcSend(dataChannel, this);
        return dataChannel;
    };
    $c0722d30b1d17141$var$wrapPeerConnectionEvent(window1, 'datachannel', (e)=>{
        wrapDcSend(e.channel, e.target);
        return e;
    });
}
/* shims RTCConnectionState by pretending it is the same as iceConnectionState.
 * See https://bugs.chromium.org/p/webrtc/issues/detail?id=6145#c12
 * for why this is a valid hack in Chrome. In Firefox it is slightly incorrect
 * since DTLS failures would be hidden. See
 * https://bugzilla.mozilla.org/show_bug.cgi?id=1265827
 * for the Firefox tracking bug.
 */ function $c0722d30b1d17141$var$shimConnectionState(window1) {
    if (!window1.RTCPeerConnection || 'connectionState' in window1.RTCPeerConnection.prototype) return;
    const proto = window1.RTCPeerConnection.prototype;
    Object.defineProperty(proto, 'connectionState', {
        get () {
            return ({
                completed: 'connected',
                checking: 'connecting'
            })[this.iceConnectionState] || this.iceConnectionState;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(proto, 'onconnectionstatechange', {
        get () {
            return this._onconnectionstatechange || null;
        },
        set (cb) {
            if (this._onconnectionstatechange) {
                this.removeEventListener('connectionstatechange', this._onconnectionstatechange);
                delete this._onconnectionstatechange;
            }
            if (cb) this.addEventListener('connectionstatechange', this._onconnectionstatechange = cb);
        },
        enumerable: true,
        configurable: true
    });
    [
        'setLocalDescription',
        'setRemoteDescription'
    ].forEach((method)=>{
        const origMethod = proto[method];
        proto[method] = function() {
            if (!this._connectionstatechangepoly) {
                this._connectionstatechangepoly = (e)=>{
                    const pc = e.target;
                    if (pc._lastConnectionState !== pc.connectionState) {
                        pc._lastConnectionState = pc.connectionState;
                        const newEvent = new Event('connectionstatechange', e);
                        pc.dispatchEvent(newEvent);
                    }
                    return e;
                };
                this.addEventListener('iceconnectionstatechange', this._connectionstatechangepoly);
            }
            return origMethod.apply(this, arguments);
        };
    });
}
function $c0722d30b1d17141$var$removeExtmapAllowMixed(window1, browserDetails) {
    /* remove a=extmap-allow-mixed for webrtc.org < M71 */ if (!window1.RTCPeerConnection) return;
    if (browserDetails.browser === 'chrome' && browserDetails.version >= 71) return;
    if (browserDetails.browser === 'safari' && browserDetails._safariVersion >= 13.1) return;
    const nativeSRD = window1.RTCPeerConnection.prototype.setRemoteDescription;
    window1.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription(desc) {
        if (desc && desc.sdp && desc.sdp.indexOf('\na=extmap-allow-mixed') !== -1) {
            const sdp = desc.sdp.split('\n').filter((line)=>{
                return line.trim() !== 'a=extmap-allow-mixed';
            }).join('\n');
            // Safari enforces read-only-ness of RTCSessionDescription fields.
            if (window1.RTCSessionDescription && desc instanceof window1.RTCSessionDescription) arguments[0] = new window1.RTCSessionDescription({
                type: desc.type,
                sdp: sdp
            });
            else desc.sdp = sdp;
        }
        return nativeSRD.apply(this, arguments);
    };
}
function $c0722d30b1d17141$var$shimAddIceCandidateNullOrEmpty(window1, browserDetails) {
    // Support for addIceCandidate(null or undefined)
    // as well as addIceCandidate({candidate: "", ...})
    // https://bugs.chromium.org/p/chromium/issues/detail?id=978582
    // Note: must be called before other polyfills which change the signature.
    if (!(window1.RTCPeerConnection && window1.RTCPeerConnection.prototype)) return;
    const nativeAddIceCandidate = window1.RTCPeerConnection.prototype.addIceCandidate;
    if (!nativeAddIceCandidate || nativeAddIceCandidate.length === 0) return;
    window1.RTCPeerConnection.prototype.addIceCandidate = function addIceCandidate() {
        if (!arguments[0]) {
            if (arguments[1]) arguments[1].apply(null);
            return Promise.resolve();
        }
        // Firefox 68+ emits and processes {candidate: "", ...}, ignore
        // in older versions.
        // Native support for ignoring exists for Chrome M77+.
        // Safari ignores as well, exact version unknown but works in the same
        // version that also ignores addIceCandidate(null).
        if ((browserDetails.browser === 'chrome' && browserDetails.version < 78 || browserDetails.browser === 'firefox' && browserDetails.version < 68 || browserDetails.browser === 'safari') && arguments[0] && arguments[0].candidate === '') return Promise.resolve();
        return nativeAddIceCandidate.apply(this, arguments);
    };
}
// Note: Make sure to call this ahead of APIs that modify
// setLocalDescription.length
function $c0722d30b1d17141$var$shimParameterlessSetLocalDescription(window1, browserDetails) {
    if (!(window1.RTCPeerConnection && window1.RTCPeerConnection.prototype)) return;
    const nativeSetLocalDescription = window1.RTCPeerConnection.prototype.setLocalDescription;
    if (!nativeSetLocalDescription || nativeSetLocalDescription.length === 0) return;
    window1.RTCPeerConnection.prototype.setLocalDescription = function setLocalDescription() {
        let desc = arguments[0] || {};
        if (typeof desc !== 'object' || desc.type && desc.sdp) return nativeSetLocalDescription.apply(this, arguments);
        // The remaining steps should technically happen when SLD comes off the
        // RTCPeerConnection's operations chain (not ahead of going on it), but
        // this is too difficult to shim. Instead, this shim only covers the
        // common case where the operations chain is empty. This is imperfect, but
        // should cover many cases. Rationale: Even if we can't reduce the glare
        // window to zero on imperfect implementations, there's value in tapping
        // into the perfect negotiation pattern that several browsers support.
        desc = {
            type: desc.type,
            sdp: desc.sdp
        };
        if (!desc.type) switch(this.signalingState){
            case 'stable':
            case 'have-local-offer':
            case 'have-remote-pranswer':
                desc.type = 'offer';
                break;
            default:
                desc.type = 'answer';
                break;
        }
        if (desc.sdp || desc.type !== 'offer' && desc.type !== 'answer') return nativeSetLocalDescription.apply(this, [
            desc
        ]);
        const func = desc.type === 'offer' ? this.createOffer : this.createAnswer;
        return func.apply(this).then((d)=>nativeSetLocalDescription.apply(this, [
                d
            ]));
    };
}
var $c0722d30b1d17141$var$commonShim = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    removeExtmapAllowMixed: $c0722d30b1d17141$var$removeExtmapAllowMixed,
    shimAddIceCandidateNullOrEmpty: $c0722d30b1d17141$var$shimAddIceCandidateNullOrEmpty,
    shimConnectionState: $c0722d30b1d17141$var$shimConnectionState,
    shimMaxMessageSize: $c0722d30b1d17141$var$shimMaxMessageSize,
    shimParameterlessSetLocalDescription: $c0722d30b1d17141$var$shimParameterlessSetLocalDescription,
    shimRTCIceCandidate: $c0722d30b1d17141$var$shimRTCIceCandidate,
    shimRTCIceCandidateRelayProtocol: $c0722d30b1d17141$var$shimRTCIceCandidateRelayProtocol,
    shimSendThrowTypeError: $c0722d30b1d17141$var$shimSendThrowTypeError
}); /*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ 
// Shimming starts here.
function $c0722d30b1d17141$var$adapterFactory() {
    let { window: window1 } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        shimChrome: true,
        shimFirefox: true,
        shimSafari: true
    };
    // Utils.
    const logging = $c0722d30b1d17141$var$log$4;
    const browserDetails = $c0722d30b1d17141$var$detectBrowser(window1);
    const adapter = {
        browserDetails: browserDetails,
        commonShim: $c0722d30b1d17141$var$commonShim,
        extractVersion: $c0722d30b1d17141$var$extractVersion,
        disableLog: $c0722d30b1d17141$var$disableLog,
        disableWarnings: $c0722d30b1d17141$var$disableWarnings,
        sdp: // Expose sdp as a convenience. For production apps include directly.
        $c0722d30b1d17141$var$sdp
    };
    // Shim browser if found.
    switch(browserDetails.browser){
        case 'chrome':
            if (!$c0722d30b1d17141$var$chromeShim || !$c0722d30b1d17141$var$shimPeerConnection$1 || !options.shimChrome) {
                logging('Chrome shim is not included in this adapter release.');
                return adapter;
            }
            if (browserDetails.version === null) {
                logging('Chrome shim can not determine version, not shimming.');
                return adapter;
            }
            logging('adapter.js shimming chrome.');
            // Export to the adapter global object visible in the browser.
            adapter.browserShim = $c0722d30b1d17141$var$chromeShim;
            // Must be called before shimPeerConnection.
            $c0722d30b1d17141$var$shimAddIceCandidateNullOrEmpty(window1, browserDetails);
            $c0722d30b1d17141$var$shimParameterlessSetLocalDescription(window1);
            $c0722d30b1d17141$var$shimGetUserMedia$2(window1, browserDetails);
            $c0722d30b1d17141$var$shimMediaStream(window1);
            $c0722d30b1d17141$var$shimPeerConnection$1(window1, browserDetails);
            $c0722d30b1d17141$var$shimOnTrack$1(window1, browserDetails);
            $c0722d30b1d17141$var$shimAddTrackRemoveTrack(window1, browserDetails);
            $c0722d30b1d17141$var$shimGetSendersWithDtmf(window1);
            $c0722d30b1d17141$var$shimSenderReceiverGetStats(window1, browserDetails);
            $c0722d30b1d17141$var$fixNegotiationNeeded(window1, browserDetails);
            $c0722d30b1d17141$var$shimRTCIceCandidate(window1);
            $c0722d30b1d17141$var$shimRTCIceCandidateRelayProtocol(window1);
            $c0722d30b1d17141$var$shimConnectionState(window1);
            $c0722d30b1d17141$var$shimMaxMessageSize(window1, browserDetails);
            $c0722d30b1d17141$var$shimSendThrowTypeError(window1, browserDetails);
            $c0722d30b1d17141$var$removeExtmapAllowMixed(window1, browserDetails);
            break;
        case 'firefox':
            if (!$c0722d30b1d17141$var$firefoxShim || !$c0722d30b1d17141$var$shimPeerConnection || !options.shimFirefox) {
                logging('Firefox shim is not included in this adapter release.');
                return adapter;
            }
            logging('adapter.js shimming firefox.');
            // Export to the adapter global object visible in the browser.
            adapter.browserShim = $c0722d30b1d17141$var$firefoxShim;
            // Must be called before shimPeerConnection.
            $c0722d30b1d17141$var$shimAddIceCandidateNullOrEmpty(window1, browserDetails);
            $c0722d30b1d17141$var$shimParameterlessSetLocalDescription(window1);
            $c0722d30b1d17141$var$shimGetUserMedia$1(window1, browserDetails);
            $c0722d30b1d17141$var$shimPeerConnection(window1, browserDetails);
            $c0722d30b1d17141$var$shimGetStats(window1, browserDetails);
            $c0722d30b1d17141$var$shimOnTrack(window1);
            $c0722d30b1d17141$var$shimRemoveStream(window1);
            $c0722d30b1d17141$var$shimSenderGetStats(window1);
            $c0722d30b1d17141$var$shimReceiverGetStats(window1);
            $c0722d30b1d17141$var$shimRTCDataChannel(window1);
            $c0722d30b1d17141$var$shimAddTransceiver(window1);
            $c0722d30b1d17141$var$shimGetParameters(window1);
            $c0722d30b1d17141$var$shimCreateOffer(window1);
            $c0722d30b1d17141$var$shimCreateAnswer(window1);
            $c0722d30b1d17141$var$shimRTCIceCandidate(window1);
            $c0722d30b1d17141$var$shimConnectionState(window1);
            $c0722d30b1d17141$var$shimMaxMessageSize(window1, browserDetails);
            $c0722d30b1d17141$var$shimSendThrowTypeError(window1, browserDetails);
            break;
        case 'safari':
            if (!$c0722d30b1d17141$var$safariShim || !options.shimSafari) {
                logging('Safari shim is not included in this adapter release.');
                return adapter;
            }
            logging('adapter.js shimming safari.');
            // Export to the adapter global object visible in the browser.
            adapter.browserShim = $c0722d30b1d17141$var$safariShim;
            // Must be called before shimCallbackAPI.
            $c0722d30b1d17141$var$shimAddIceCandidateNullOrEmpty(window1, browserDetails);
            $c0722d30b1d17141$var$shimParameterlessSetLocalDescription(window1);
            $c0722d30b1d17141$var$shimRTCIceServerUrls(window1);
            $c0722d30b1d17141$var$shimCreateOfferLegacy(window1);
            $c0722d30b1d17141$var$shimCallbacksAPI(window1);
            $c0722d30b1d17141$var$shimLocalStreamsAPI(window1);
            $c0722d30b1d17141$var$shimRemoteStreamsAPI(window1);
            $c0722d30b1d17141$var$shimTrackEventTransceiver(window1);
            $c0722d30b1d17141$var$shimGetUserMedia(window1);
            $c0722d30b1d17141$var$shimAudioContext(window1);
            $c0722d30b1d17141$var$shimRTCIceCandidate(window1);
            $c0722d30b1d17141$var$shimRTCIceCandidateRelayProtocol(window1);
            $c0722d30b1d17141$var$shimMaxMessageSize(window1, browserDetails);
            $c0722d30b1d17141$var$shimSendThrowTypeError(window1, browserDetails);
            $c0722d30b1d17141$var$removeExtmapAllowMixed(window1, browserDetails);
            break;
        default:
            logging('Unsupported browser!');
            break;
    }
    return adapter;
} /*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ 
/* eslint-env node */ $c0722d30b1d17141$var$adapterFactory({
    window: typeof window === 'undefined' ? undefined : window
});
var $c0722d30b1d17141$var$_a, $c0722d30b1d17141$var$_b;
class $c0722d30b1d17141$var$TypedPromise extends ($c0722d30b1d17141$var$_b = Promise) {
    // eslint-disable-next-line @typescript-eslint/no-useless-constructor
    constructor(executor){
        super(executor);
    }
    catch(onrejected) {
        return super.catch(onrejected);
    }
    static reject(reason) {
        return super.reject(reason);
    }
    static all(values) {
        return super.all(values);
    }
    static race(values) {
        return super.race(values);
    }
}
$c0722d30b1d17141$var$_a = $c0722d30b1d17141$var$TypedPromise;
$c0722d30b1d17141$var$TypedPromise.resolve = (value)=>{
    return Reflect.get($c0722d30b1d17141$var$_b, "resolve", $c0722d30b1d17141$var$_a).call($c0722d30b1d17141$var$_a, value);
}; // tiny, simplified version of https://github.com/lancedikson/bowser/blob/master/src/parser-browsers.js
// reduced to only differentiate Chrome(ium) based browsers / Firefox / Safari
const $c0722d30b1d17141$var$commonVersionIdentifier = /version\/(\d+(\.?_?\d+)+)/i;
let $c0722d30b1d17141$var$browserDetails;
/**
 * @internal
 */ function $c0722d30b1d17141$export$89e15fc796a4a429(userAgent) {
    let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (typeof userAgent === 'undefined' && typeof navigator === 'undefined') return;
    const ua = (userAgent !== null && userAgent !== void 0 ? userAgent : navigator.userAgent).toLowerCase();
    if ($c0722d30b1d17141$var$browserDetails === undefined || force) {
        const browser = $c0722d30b1d17141$var$browsersList.find((_ref)=>{
            let { test: test } = _ref;
            return test.test(ua);
        });
        $c0722d30b1d17141$var$browserDetails = browser === null || browser === void 0 ? void 0 : browser.describe(ua);
    }
    return $c0722d30b1d17141$var$browserDetails;
}
const $c0722d30b1d17141$var$browsersList = [
    {
        test: /firefox|iceweasel|fxios/i,
        describe (ua) {
            const browser = {
                name: 'Firefox',
                version: $c0722d30b1d17141$var$getMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, ua),
                os: ua.toLowerCase().includes('fxios') ? 'iOS' : undefined,
                osVersion: $c0722d30b1d17141$var$getOSVersion(ua)
            };
            return browser;
        }
    },
    {
        test: /chrom|crios|crmo/i,
        describe (ua) {
            const browser = {
                name: 'Chrome',
                version: $c0722d30b1d17141$var$getMatch(/(?:chrome|chromium|crios|crmo)\/(\d+(\.?_?\d+)+)/i, ua),
                os: ua.toLowerCase().includes('crios') ? 'iOS' : undefined,
                osVersion: $c0722d30b1d17141$var$getOSVersion(ua)
            };
            return browser;
        }
    },
    /* Safari */ {
        test: /safari|applewebkit/i,
        describe (ua) {
            const browser = {
                name: 'Safari',
                version: $c0722d30b1d17141$var$getMatch($c0722d30b1d17141$var$commonVersionIdentifier, ua),
                os: ua.includes('mobile/') ? 'iOS' : 'macOS',
                osVersion: $c0722d30b1d17141$var$getOSVersion(ua)
            };
            return browser;
        }
    }
];
function $c0722d30b1d17141$var$getMatch(exp, ua) {
    let id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    const match = ua.match(exp);
    return match && match.length >= id && match[id] || '';
}
function $c0722d30b1d17141$var$getOSVersion(ua) {
    return ua.includes('mac os') ? $c0722d30b1d17141$var$getMatch(/\(.+?(\d+_\d+(:?_\d+)?)/, ua, 1).replace(/_/g, '.') : undefined;
}
var $c0722d30b1d17141$var$version$1 = "2.18.9";
const $c0722d30b1d17141$export$83d89fbfd8236492 = $c0722d30b1d17141$var$version$1;
const $c0722d30b1d17141$export$94587fadffb515a1 = 16; /** Base error that all LiveKit specific custom errors inherit from. */ 
class $c0722d30b1d17141$export$d7a71bcd3a009497 extends Error {
    constructor(code, message, options){
        super(message || 'an error has occurred');
        this.name = 'LiveKitError';
        this.code = code;
        if (typeof (options === null || options === void 0 ? void 0 : options.cause) !== 'undefined') this.cause = options === null || options === void 0 ? void 0 : options.cause;
    }
}
/**
 * LiveKit specific error type representing an error with an associated set of reasons.
 * Use this to represent an error with multiple different but contextually related variants.
 * */ class $c0722d30b1d17141$export$af3f20dcdd5a185f extends $c0722d30b1d17141$export$d7a71bcd3a009497 {
}
class $c0722d30b1d17141$export$d14bce5a8bc5fdb9 extends $c0722d30b1d17141$export$d7a71bcd3a009497 {
    constructor(){
        let message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Simulated failure';
        super(-1, message);
        this.name = 'simulated';
    }
}
var $c0722d30b1d17141$export$61182a0b21436b65;
(function(ConnectionErrorReason) {
    ConnectionErrorReason[ConnectionErrorReason["NotAllowed"] = 0] = "NotAllowed";
    ConnectionErrorReason[ConnectionErrorReason["ServerUnreachable"] = 1] = "ServerUnreachable";
    ConnectionErrorReason[ConnectionErrorReason["InternalError"] = 2] = "InternalError";
    ConnectionErrorReason[ConnectionErrorReason["Cancelled"] = 3] = "Cancelled";
    ConnectionErrorReason[ConnectionErrorReason["LeaveRequest"] = 4] = "LeaveRequest";
    ConnectionErrorReason[ConnectionErrorReason["Timeout"] = 5] = "Timeout";
    ConnectionErrorReason[ConnectionErrorReason["WebSocket"] = 6] = "WebSocket";
    ConnectionErrorReason[ConnectionErrorReason["ServiceNotFound"] = 7] = "ServiceNotFound";
})($c0722d30b1d17141$export$61182a0b21436b65 || ($c0722d30b1d17141$export$61182a0b21436b65 = {}));
class $c0722d30b1d17141$export$a3747c6e46c7a8eb extends $c0722d30b1d17141$export$af3f20dcdd5a185f {
    constructor(message, reason, status, context){
        super(1, message);
        this.name = 'ConnectionError';
        this.status = status;
        this.reason = reason;
        this.context = context;
        this.reasonName = $c0722d30b1d17141$export$61182a0b21436b65[reason];
    }
    static notAllowed(message, status, context) {
        return new $c0722d30b1d17141$export$a3747c6e46c7a8eb(message, $c0722d30b1d17141$export$61182a0b21436b65.NotAllowed, status, context);
    }
    static timeout(message) {
        return new $c0722d30b1d17141$export$a3747c6e46c7a8eb(message, $c0722d30b1d17141$export$61182a0b21436b65.Timeout);
    }
    static leaveRequest(message, context) {
        return new $c0722d30b1d17141$export$a3747c6e46c7a8eb(message, $c0722d30b1d17141$export$61182a0b21436b65.LeaveRequest, undefined, context);
    }
    static internal(message, context) {
        return new $c0722d30b1d17141$export$a3747c6e46c7a8eb(message, $c0722d30b1d17141$export$61182a0b21436b65.InternalError, undefined, context);
    }
    static cancelled(message) {
        return new $c0722d30b1d17141$export$a3747c6e46c7a8eb(message, $c0722d30b1d17141$export$61182a0b21436b65.Cancelled);
    }
    static serverUnreachable(message, status) {
        return new $c0722d30b1d17141$export$a3747c6e46c7a8eb(message, $c0722d30b1d17141$export$61182a0b21436b65.ServerUnreachable, status);
    }
    static websocket(message, status, reason) {
        return new $c0722d30b1d17141$export$a3747c6e46c7a8eb(message, $c0722d30b1d17141$export$61182a0b21436b65.WebSocket, status, reason);
    }
    static serviceNotFound(message, serviceName) {
        return new $c0722d30b1d17141$export$a3747c6e46c7a8eb(message, $c0722d30b1d17141$export$61182a0b21436b65.ServiceNotFound, undefined, serviceName);
    }
}
class $c0722d30b1d17141$export$38c5ac268e2fa84 extends $c0722d30b1d17141$export$d7a71bcd3a009497 {
    constructor(message){
        super(21, message !== null && message !== void 0 ? message : 'device is unsupported');
        this.name = 'DeviceUnsupportedError';
    }
}
class $c0722d30b1d17141$export$4fbb9423b5747257 extends $c0722d30b1d17141$export$d7a71bcd3a009497 {
    constructor(message){
        super(20, message !== null && message !== void 0 ? message : 'track is invalid');
        this.name = 'TrackInvalidError';
    }
}
class $c0722d30b1d17141$export$4d307571a351c50c extends $c0722d30b1d17141$export$d7a71bcd3a009497 {
    constructor(message){
        super(10, message !== null && message !== void 0 ? message : 'unsupported server');
        this.name = 'UnsupportedServer';
    }
}
class $c0722d30b1d17141$export$1f388e244efbf70b extends $c0722d30b1d17141$export$d7a71bcd3a009497 {
    constructor(message){
        super(12, message !== null && message !== void 0 ? message : 'unexpected connection state');
        this.name = 'UnexpectedConnectionState';
    }
}
class $c0722d30b1d17141$export$18c2792bacf23e39 extends $c0722d30b1d17141$export$d7a71bcd3a009497 {
    constructor(message){
        super(13, message !== null && message !== void 0 ? message : 'unable to negotiate');
        this.name = 'NegotiationError';
    }
}
class $c0722d30b1d17141$export$8f27e55a613eb208 extends $c0722d30b1d17141$export$d7a71bcd3a009497 {
    constructor(message){
        super(14, message !== null && message !== void 0 ? message : 'unable to publish data');
        this.name = 'PublishDataError';
    }
}
class $c0722d30b1d17141$export$7604ff526573fd27 extends $c0722d30b1d17141$export$d7a71bcd3a009497 {
    constructor(message, status){
        super(15, message);
        this.name = 'PublishTrackError';
        this.status = status;
    }
}
class $c0722d30b1d17141$export$cb33ebbc4df8a708 extends $c0722d30b1d17141$export$af3f20dcdd5a185f {
    constructor(message, reason){
        super(15, message);
        this.name = 'SignalRequestError';
        this.reason = reason;
        this.reasonName = typeof reason === 'string' ? reason : $c0722d30b1d17141$var$RequestResponse_Reason[reason];
    }
}
// NOTE: matches with https://github.com/livekit/client-sdk-swift/blob/f37bbd260d61e165084962db822c79f995f1a113/Sources/LiveKit/DataStream/StreamError.swift#L17
var $c0722d30b1d17141$export$7dd215bfe4893462;
(function(DataStreamErrorReason) {
    // Unable to open a stream with the same ID more than once.
    DataStreamErrorReason[DataStreamErrorReason["AlreadyOpened"] = 0] = "AlreadyOpened";
    // Stream closed abnormally by remote participant.
    DataStreamErrorReason[DataStreamErrorReason["AbnormalEnd"] = 1] = "AbnormalEnd";
    // Incoming chunk data could not be decoded.
    DataStreamErrorReason[DataStreamErrorReason["DecodeFailed"] = 2] = "DecodeFailed";
    // Read length exceeded total length specified in stream header.
    DataStreamErrorReason[DataStreamErrorReason["LengthExceeded"] = 3] = "LengthExceeded";
    // Read length less than total length specified in stream header.
    DataStreamErrorReason[DataStreamErrorReason["Incomplete"] = 4] = "Incomplete";
    // Unable to register a stream handler more than once.
    DataStreamErrorReason[DataStreamErrorReason["HandlerAlreadyRegistered"] = 7] = "HandlerAlreadyRegistered";
    // Encryption type mismatch.
    DataStreamErrorReason[DataStreamErrorReason["EncryptionTypeMismatch"] = 8] = "EncryptionTypeMismatch";
})($c0722d30b1d17141$export$7dd215bfe4893462 || ($c0722d30b1d17141$export$7dd215bfe4893462 = {}));
class $c0722d30b1d17141$export$a2ac0e78e1ae83d7 extends $c0722d30b1d17141$export$af3f20dcdd5a185f {
    constructor(message, reason){
        super(16, message);
        this.name = 'DataStreamError';
        this.reason = reason;
        this.reasonName = $c0722d30b1d17141$export$7dd215bfe4893462[reason];
    }
}
class $c0722d30b1d17141$export$b96a7e5c35734611 extends $c0722d30b1d17141$export$d7a71bcd3a009497 {
    constructor(message){
        super(18, message);
        this.name = 'SignalReconnectError';
    }
}
var $c0722d30b1d17141$export$843d4665ca980897;
(function(MediaDeviceFailure) {
    // user rejected permissions
    MediaDeviceFailure["PermissionDenied"] = "PermissionDenied";
    // device is not available
    MediaDeviceFailure["NotFound"] = "NotFound";
    // device is in use. On Windows, only a single tab may get access to a device at a time.
    MediaDeviceFailure["DeviceInUse"] = "DeviceInUse";
    MediaDeviceFailure["Other"] = "Other";
})($c0722d30b1d17141$export$843d4665ca980897 || ($c0722d30b1d17141$export$843d4665ca980897 = {}));
(function(MediaDeviceFailure) {
    function getFailure(error) {
        if (error && 'name' in error) {
            if (error.name === 'NotFoundError' || error.name === 'DevicesNotFoundError') return MediaDeviceFailure.NotFound;
            if (error.name === 'NotAllowedError' || error.name === 'PermissionDeniedError') return MediaDeviceFailure.PermissionDenied;
            if (error.name === 'NotReadableError' || error.name === 'TrackStartError') return MediaDeviceFailure.DeviceInUse;
            return MediaDeviceFailure.Other;
        }
    }
    MediaDeviceFailure.getFailure = getFailure;
})($c0722d30b1d17141$export$843d4665ca980897 || ($c0722d30b1d17141$export$843d4665ca980897 = {})); /**
 * Timers that can be overridden with platform specific implementations
 * that ensure that they are fired. These should be used when it is critical
 * that the timer fires on time.
 */ 
class $c0722d30b1d17141$export$22e737276454df96 {
}
$c0722d30b1d17141$export$22e737276454df96.setTimeout = function() {
    return setTimeout(...arguments);
};
$c0722d30b1d17141$export$22e737276454df96.setInterval = // eslint-disable-next-line @typescript-eslint/no-implied-eval
function() {
    return setInterval(...arguments);
};
$c0722d30b1d17141$export$22e737276454df96.clearTimeout = function() {
    return clearTimeout(...arguments);
};
$c0722d30b1d17141$export$22e737276454df96.clearInterval = function() {
    return clearInterval(...arguments);
}; /**
 * Events are the primary way LiveKit notifies your application of changes.
 *
 * The following are events emitted by [[Room]], listen to room events like
 *
 * ```typescript
 * room.on(RoomEvent.TrackPublished, (track, publication, participant) => {})
 * ```
 */ 
var $c0722d30b1d17141$export$3159c672e3b2293a;
(function(RoomEvent) {
    /**
   * When the connection to the server has been established
   */ RoomEvent["Connected"] = "connected";
    /**
   * When the connection to the server has been interrupted and it's attempting
   * to reconnect.
   */ RoomEvent["Reconnecting"] = "reconnecting";
    /**
   * When the signal connection to the server has been interrupted. This isn't noticeable to users most of the time.
   * It will resolve with a `RoomEvent.Reconnected` once the signal connection has been re-established.
   * If media fails additionally it an additional `RoomEvent.Reconnecting` will be emitted.
   */ RoomEvent["SignalReconnecting"] = "signalReconnecting";
    /**
   * Fires when a reconnection has been successful.
   */ RoomEvent["Reconnected"] = "reconnected";
    /**
   * When disconnected from room. This fires when room.disconnect() is called or
   * when an unrecoverable connection issue had occurred.
   *
   * DisconnectReason can be used to determine why the participant was disconnected. Notable reasons are
   * - DUPLICATE_IDENTITY: another client with the same identity has joined the room
   * - PARTICIPANT_REMOVED: participant was removed by RemoveParticipant API
   * - ROOM_DELETED: the room has ended via DeleteRoom API
   *
   * args: ([[DisconnectReason]])
   */ RoomEvent["Disconnected"] = "disconnected";
    /**
   * Whenever the connection state of the room changes
   *
   * args: ([[ConnectionState]])
   */ RoomEvent["ConnectionStateChanged"] = "connectionStateChanged";
    /**
   * When participant has been moved to a different room by the service request.
   * The behavior looks like the participant has been disconnected and reconnected to a different room
   * seamlessly without connection state transition.
   * A new token will be provided for reconnecting to the new room if needed.
   *
   * args: ([[room: string, token: string]])
   */ RoomEvent["Moved"] = "moved";
    /**
   * When input or output devices on the machine have changed.
   */ RoomEvent["MediaDevicesChanged"] = "mediaDevicesChanged";
    /**
   * When a [[RemoteParticipant]] joins *after* the local
   * participant. It will not emit events for participants that are already
   * in the room
   *
   * args: ([[RemoteParticipant]])
   */ RoomEvent["ParticipantConnected"] = "participantConnected";
    /**
   * When a [[RemoteParticipant]] leaves *after* the local
   * participant has joined.
   *
   * args: ([[RemoteParticipant]])
   */ RoomEvent["ParticipantDisconnected"] = "participantDisconnected";
    /**
   * When a new track is published to room *after* the local
   * participant has joined. It will not fire for tracks that are already published.
   *
   * A track published doesn't mean the participant has subscribed to it. It's
   * simply reflecting the state of the room.
   *
   * args: ([[RemoteTrackPublication]], [[RemoteParticipant]])
   */ RoomEvent["TrackPublished"] = "trackPublished";
    /**
   * The [[LocalParticipant]] has subscribed to a new track. This event will **always**
   * fire as long as new tracks are ready for use.
   *
   * args: ([[RemoteTrack]], [[RemoteTrackPublication]], [[RemoteParticipant]])
   */ RoomEvent["TrackSubscribed"] = "trackSubscribed";
    /**
   * Could not subscribe to a track
   *
   * args: (track sid, [[RemoteParticipant]])
   */ RoomEvent["TrackSubscriptionFailed"] = "trackSubscriptionFailed";
    /**
   * A [[RemoteParticipant]] has unpublished a track
   *
   * args: ([[RemoteTrackPublication]], [[RemoteParticipant]])
   */ RoomEvent["TrackUnpublished"] = "trackUnpublished";
    /**
   * A subscribed track is no longer available. Clients should listen to this
   * event and ensure they detach tracks.
   *
   * args: ([[Track]], [[RemoteTrackPublication]], [[RemoteParticipant]])
   */ RoomEvent["TrackUnsubscribed"] = "trackUnsubscribed";
    /**
   * A track that was muted, fires on both [[RemoteParticipant]]s and [[LocalParticipant]]
   *
   * args: ([[TrackPublication]], [[Participant]])
   */ RoomEvent["TrackMuted"] = "trackMuted";
    /**
   * A track that was unmuted, fires on both [[RemoteParticipant]]s and [[LocalParticipant]]
   *
   * args: ([[TrackPublication]], [[Participant]])
   */ RoomEvent["TrackUnmuted"] = "trackUnmuted";
    /**
   * A local track was published successfully. This event is helpful to know
   * when to update your local UI with the newly published track.
   *
   * args: ([[LocalTrackPublication]], [[LocalParticipant]])
   */ RoomEvent["LocalTrackPublished"] = "localTrackPublished";
    /**
   * A local track was unpublished. This event is helpful to know when to remove
   * the local track from your UI.
   *
   * When a user stops sharing their screen by pressing "End" on the browser UI,
   * this event will also fire.
   *
   * args: ([[LocalTrackPublication]], [[LocalParticipant]])
   */ RoomEvent["LocalTrackUnpublished"] = "localTrackUnpublished";
    /**
   * When a local audio track is published the SDK checks whether there is complete silence
   * on that track and emits the LocalAudioSilenceDetected event in that case.
   * This allows for applications to show UI informing users that they might have to
   * reset their audio hardware or check for proper device connectivity.
   */ RoomEvent["LocalAudioSilenceDetected"] = "localAudioSilenceDetected";
    /**
   * Active speakers changed. List of speakers are ordered by their audio level.
   * loudest speakers first. This will include the LocalParticipant too.
   *
   * Speaker updates are sent only to the publishing participant and their subscribers.
   *
   * args: (Array<[[Participant]]>)
   */ RoomEvent["ActiveSpeakersChanged"] = "activeSpeakersChanged";
    /**
   * Participant metadata is a simple way for app-specific state to be pushed to
   * all users.
   * When RoomService.UpdateParticipantMetadata is called to change a participant's
   * state, *all*  participants in the room will fire this event.
   *
   * args: (prevMetadata: string, [[Participant]])
   *
   */ RoomEvent["ParticipantMetadataChanged"] = "participantMetadataChanged";
    /**
   * Participant's display name changed
   *
   * args: (name: string, [[Participant]])
   *
   */ RoomEvent["ParticipantNameChanged"] = "participantNameChanged";
    /**
   * Participant attributes is an app-specific key value state to be pushed to
   * all users.
   * When a participant's attributes changed, this event will be emitted with the changed attributes and the participant
   * args: (changedAttributes: [[Record<string, string]], participant: [[Participant]])
   */ RoomEvent["ParticipantAttributesChanged"] = "participantAttributesChanged";
    /**
   * Emitted when the participant's state changes to ACTIVE and is ready to send/receive data messages
   *
   * args: (participant: [[Participant]])
   */ RoomEvent["ParticipantActive"] = "participantActive";
    /**
   * Room metadata is a simple way for app-specific state to be pushed to
   * all users.
   * When RoomService.UpdateRoomMetadata is called to change a room's state,
   * *all*  participants in the room will fire this event.
   *
   * args: (string)
   */ RoomEvent["RoomMetadataChanged"] = "roomMetadataChanged";
    /**
   * Data received from another participant.
   * Data packets provides the ability to use LiveKit to send/receive arbitrary payloads.
   * All participants in the room will receive the messages sent to the room.
   *
   * args: (payload: Uint8Array, participant: [[Participant]], kind: [[DataPacket_Kind]], topic?: string)
   */ RoomEvent["DataReceived"] = "dataReceived";
    /**
   * SIP DTMF tones received from another participant.
   *
   * args: (participant: [[Participant]], dtmf: [[DataPacket_Kind]])
   */ RoomEvent["SipDTMFReceived"] = "sipDTMFReceived";
    /**
   * Transcription received from a participant's track.
   * @beta
   */ RoomEvent["TranscriptionReceived"] = "transcriptionReceived";
    /**
   * Connection quality was changed for a Participant. It'll receive updates
   * from the local participant, as well as any [[RemoteParticipant]]s that we are
   * subscribed to.
   *
   * args: (connectionQuality: [[ConnectionQuality]], participant: [[Participant]])
   */ RoomEvent["ConnectionQualityChanged"] = "connectionQualityChanged";
    /**
   * StreamState indicates if a subscribed (remote) track has been paused by the SFU
   * (typically this happens because of subscriber's bandwidth constraints)
   *
   * When bandwidth conditions allow, the track will be resumed automatically.
   * TrackStreamStateChanged will also be emitted when that happens.
   *
   * args: (pub: [[RemoteTrackPublication]], streamState: [[Track.StreamState]],
   *        participant: [[RemoteParticipant]])
   */ RoomEvent["TrackStreamStateChanged"] = "trackStreamStateChanged";
    /**
   * One of subscribed tracks have changed its permissions for the current
   * participant. If permission was revoked, then the track will no longer
   * be subscribed. If permission was granted, a TrackSubscribed event will
   * be emitted.
   *
   * args: (pub: [[RemoteTrackPublication]],
   *        status: [[TrackPublication.PermissionStatus]],
   *        participant: [[RemoteParticipant]])
   */ RoomEvent["TrackSubscriptionPermissionChanged"] = "trackSubscriptionPermissionChanged";
    /**
   * One of subscribed tracks have changed its status for the current
   * participant.
   *
   * args: (pub: [[RemoteTrackPublication]],
   *        status: [[TrackPublication.SubscriptionStatus]],
   *        participant: [[RemoteParticipant]])
   */ RoomEvent["TrackSubscriptionStatusChanged"] = "trackSubscriptionStatusChanged";
    /**
   * LiveKit will attempt to autoplay all audio tracks when you attach them to
   * audio elements. However, if that fails, we'll notify you via AudioPlaybackStatusChanged.
   * `Room.canPlaybackAudio` will indicate if audio playback is permitted.
   */ RoomEvent["AudioPlaybackStatusChanged"] = "audioPlaybackChanged";
    /**
   * LiveKit will attempt to autoplay all video tracks when you attach them to
   * a video element. However, if that fails, we'll notify you via VideoPlaybackStatusChanged.
   * Calling `room.startVideo()` in a user gesture event handler will resume the video playback.
   */ RoomEvent["VideoPlaybackStatusChanged"] = "videoPlaybackChanged";
    /**
   * When we have encountered an error while attempting to create a track.
   * The errors take place in getUserMedia().
   * Use MediaDeviceFailure.getFailure(error) to get the reason of failure.
   * [[LocalParticipant.lastCameraError]] and [[LocalParticipant.lastMicrophoneError]]
   * will indicate if it had an error while creating the audio or video track respectively.
   *
   * args: (error: Error)
   */ RoomEvent["MediaDevicesError"] = "mediaDevicesError";
    /**
   * A participant's permission has changed.
   * args: (prevPermissions: [[ParticipantPermission]], participant: [[Participant]])
   */ RoomEvent["ParticipantPermissionsChanged"] = "participantPermissionsChanged";
    /**
   * Signal connected, can publish tracks.
   */ RoomEvent["SignalConnected"] = "signalConnected";
    /**
   * Recording of a room has started/stopped. Room.isRecording will be updated too.
   * args: (isRecording: boolean)
   */ RoomEvent["RecordingStatusChanged"] = "recordingStatusChanged";
    RoomEvent["ParticipantEncryptionStatusChanged"] = "participantEncryptionStatusChanged";
    RoomEvent["EncryptionError"] = "encryptionError";
    /**
   * Emits whenever the current buffer status of a data channel changes
   * args: (isLow: boolean, kind: [[DataChannelKind]])
   */ RoomEvent["DCBufferStatusChanged"] = "dcBufferStatusChanged";
    /**
   * Triggered by a call to room.switchActiveDevice
   * args: (kind: MediaDeviceKind, deviceId: string)
   */ RoomEvent["ActiveDeviceChanged"] = "activeDeviceChanged";
    RoomEvent["ChatMessage"] = "chatMessage";
    /**
   * fired when the first remote participant has subscribed to the localParticipant's track
   */ RoomEvent["LocalTrackSubscribed"] = "localTrackSubscribed";
    /**
   * fired when the client receives connection metrics from other participants
   */ RoomEvent["MetricsReceived"] = "metricsReceived";
    /**
   * Emits when a new data track has been published by a downstream participant.
   */ RoomEvent["DataTrackPublished"] = "dataTrackPublished";
    /**
   * Emits when a new data track has been unpublished by a downstream participant.
   */ RoomEvent["DataTrackUnpublished"] = "dataTrackUnpublished";
    /**
   * Emits when a new data track has been published locally.
   */ RoomEvent["LocalDataTrackPublished"] = "localDataTrackPublished";
    /**
   * Emits when a new data track has been unpublished locally.
   */ RoomEvent["LocalDataTrackUnpublished"] = "localDataTrackUnpublished";
})($c0722d30b1d17141$export$3159c672e3b2293a || ($c0722d30b1d17141$export$3159c672e3b2293a = {}));
var $c0722d30b1d17141$export$fcdfe2b7a6750691;
(function(ParticipantEvent) {
    /**
   * When a new track is published to room *after* the local
   * participant has joined. It will not fire for tracks that are already published.
   *
   * A track published doesn't mean the participant has subscribed to it. It's
   * simply reflecting the state of the room.
   *
   * args: ([[RemoteTrackPublication]])
   */ ParticipantEvent["TrackPublished"] = "trackPublished";
    /**
   * Successfully subscribed to the [[RemoteParticipant]]'s track.
   * This event will **always** fire as long as new tracks are ready for use.
   *
   * args: ([[RemoteTrack]], [[RemoteTrackPublication]])
   */ ParticipantEvent["TrackSubscribed"] = "trackSubscribed";
    /**
   * Could not subscribe to a track
   *
   * args: (track sid)
   */ ParticipantEvent["TrackSubscriptionFailed"] = "trackSubscriptionFailed";
    /**
   * A [[RemoteParticipant]] has unpublished a track
   *
   * args: ([[RemoteTrackPublication]])
   */ ParticipantEvent["TrackUnpublished"] = "trackUnpublished";
    /**
   * A subscribed track is no longer available. Clients should listen to this
   * event and ensure they detach tracks.
   *
   * args: ([[RemoteTrack]], [[RemoteTrackPublication]])
   */ ParticipantEvent["TrackUnsubscribed"] = "trackUnsubscribed";
    /**
   * A track that was muted, fires on both [[RemoteParticipant]]s and [[LocalParticipant]]
   *
   * args: ([[TrackPublication]])
   */ ParticipantEvent["TrackMuted"] = "trackMuted";
    /**
   * A track that was unmuted, fires on both [[RemoteParticipant]]s and [[LocalParticipant]]
   *
   * args: ([[TrackPublication]])
   */ ParticipantEvent["TrackUnmuted"] = "trackUnmuted";
    /**
   * A local track was published successfully. This event is helpful to know
   * when to update your local UI with the newly published track.
   *
   * args: ([[LocalTrackPublication]])
   */ ParticipantEvent["LocalTrackPublished"] = "localTrackPublished";
    /**
   * A local track was unpublished. This event is helpful to know when to remove
   * the local track from your UI.
   *
   * When a user stops sharing their screen by pressing "End" on the browser UI,
   * this event will also fire.
   *
   * args: ([[LocalTrackPublication]])
   */ ParticipantEvent["LocalTrackUnpublished"] = "localTrackUnpublished";
    /**
   * A local track has been constrained by cpu.
   * This event is useful to know when to reduce the capture resolution of the track.
   *
   * This event is emitted on the local participant.
   *
   * args: ([[LocalVideoTrack]], [[LocalTrackPublication]])
   */ ParticipantEvent["LocalTrackCpuConstrained"] = "localTrackCpuConstrained";
    /**
   * @internal
   */ ParticipantEvent["LocalSenderCreated"] = "localSenderCreated";
    /**
   * Participant metadata is a simple way for app-specific state to be pushed to
   * all users.
   * When RoomService.UpdateParticipantMetadata is called to change a participant's
   * state, *all*  participants in the room will fire this event.
   * To access the current metadata, see [[Participant.metadata]].
   *
   * args: (prevMetadata: string)
   *
   */ ParticipantEvent["ParticipantMetadataChanged"] = "participantMetadataChanged";
    /**
   * Participant's display name changed
   *
   * args: (name: string, [[Participant]])
   *
   */ ParticipantEvent["ParticipantNameChanged"] = "participantNameChanged";
    /**
   * Data received from this participant as sender.
   * Data packets provides the ability to use LiveKit to send/receive arbitrary payloads.
   * All participants in the room will receive the messages sent to the room.
   *
   * args: (payload: Uint8Array, kind: [[DataPacket_Kind]])
   */ ParticipantEvent["DataReceived"] = "dataReceived";
    /**
   * SIP DTMF tones received from this participant as sender.
   *
   * args: (dtmf: [[DataPacket_Kind]])
   */ ParticipantEvent["SipDTMFReceived"] = "sipDTMFReceived";
    /**
   * Transcription received from this participant as data source.
   * @beta
   */ ParticipantEvent["TranscriptionReceived"] = "transcriptionReceived";
    /**
   * Has speaking status changed for the current participant
   *
   * args: (speaking: boolean)
   */ ParticipantEvent["IsSpeakingChanged"] = "isSpeakingChanged";
    /**
   * Connection quality was changed for a Participant. It'll receive updates
   * from the local participant, as well as any [[RemoteParticipant]]s that we are
   * subscribed to.
   *
   * args: (connectionQuality: [[ConnectionQuality]])
   */ ParticipantEvent["ConnectionQualityChanged"] = "connectionQualityChanged";
    /**
   * StreamState indicates if a subscribed track has been paused by the SFU
   * (typically this happens because of subscriber's bandwidth constraints)
   *
   * When bandwidth conditions allow, the track will be resumed automatically.
   * TrackStreamStateChanged will also be emitted when that happens.
   *
   * args: (pub: [[RemoteTrackPublication]], streamState: [[Track.StreamState]])
   */ ParticipantEvent["TrackStreamStateChanged"] = "trackStreamStateChanged";
    /**
   * One of subscribed tracks have changed its permissions for the current
   * participant. If permission was revoked, then the track will no longer
   * be subscribed. If permission was granted, a TrackSubscribed event will
   * be emitted.
   *
   * args: (pub: [[RemoteTrackPublication]],
   *        status: [[TrackPublication.SubscriptionStatus]])
   */ ParticipantEvent["TrackSubscriptionPermissionChanged"] = "trackSubscriptionPermissionChanged";
    /**
   * One of the remote participants publications has changed its subscription status.
   *
   */ ParticipantEvent["TrackSubscriptionStatusChanged"] = "trackSubscriptionStatusChanged";
    /**
   * a local track has been constrained by cpu
   */ ParticipantEvent["TrackCpuConstrained"] = "trackCpuConstrained";
    // fired only on LocalParticipant
    /** @internal */ ParticipantEvent["MediaDevicesError"] = "mediaDevicesError";
    // fired only on LocalParticipant
    /** @internal */ ParticipantEvent["AudioStreamAcquired"] = "audioStreamAcquired";
    /**
   * A participant's permission has changed.
   * args: (prevPermissions: [[ParticipantPermission]])
   */ ParticipantEvent["ParticipantPermissionsChanged"] = "participantPermissionsChanged";
    /** @internal */ ParticipantEvent["PCTrackAdded"] = "pcTrackAdded";
    /**
   * Participant attributes is an app-specific key value state to be pushed to
   * all users.
   * When a participant's attributes changed, this event will be emitted with the changed attributes
   * args: (changedAttributes: [[Record<string, string]])
   */ ParticipantEvent["AttributesChanged"] = "attributesChanged";
    /**
   * fired on local participant only, when the first remote participant has subscribed to the track specified in the payload
   */ ParticipantEvent["LocalTrackSubscribed"] = "localTrackSubscribed";
    /** only emitted on local participant */ ParticipantEvent["ChatMessage"] = "chatMessage";
    /**
   * Emitted when the participant's state changes to ACTIVE and is ready to send/receive data messages
   */ ParticipantEvent["Active"] = "active";
})($c0722d30b1d17141$export$fcdfe2b7a6750691 || ($c0722d30b1d17141$export$fcdfe2b7a6750691 = {}));
/** @internal */ var $c0722d30b1d17141$export$c09e63b8572f869;
(function(EngineEvent) {
    EngineEvent["TransportsCreated"] = "transportsCreated";
    EngineEvent["Connected"] = "connected";
    EngineEvent["Disconnected"] = "disconnected";
    EngineEvent["Resuming"] = "resuming";
    EngineEvent["Resumed"] = "resumed";
    EngineEvent["Restarting"] = "restarting";
    EngineEvent["Restarted"] = "restarted";
    EngineEvent["SignalResumed"] = "signalResumed";
    EngineEvent["SignalRestarted"] = "signalRestarted";
    EngineEvent["Closing"] = "closing";
    EngineEvent["MediaTrackAdded"] = "mediaTrackAdded";
    EngineEvent["ActiveSpeakersUpdate"] = "activeSpeakersUpdate";
    EngineEvent["DataPacketReceived"] = "dataPacketReceived";
    EngineEvent["RTPVideoMapUpdate"] = "rtpVideoMapUpdate";
    EngineEvent["DCBufferStatusChanged"] = "dcBufferStatusChanged";
    EngineEvent["ParticipantUpdate"] = "participantUpdate";
    EngineEvent["RoomUpdate"] = "roomUpdate";
    EngineEvent["SpeakersChanged"] = "speakersChanged";
    EngineEvent["StreamStateChanged"] = "streamStateChanged";
    EngineEvent["ConnectionQualityUpdate"] = "connectionQualityUpdate";
    EngineEvent["SubscriptionError"] = "subscriptionError";
    EngineEvent["SubscriptionPermissionUpdate"] = "subscriptionPermissionUpdate";
    EngineEvent["RemoteMute"] = "remoteMute";
    EngineEvent["SubscribedQualityUpdate"] = "subscribedQualityUpdate";
    EngineEvent["LocalTrackUnpublished"] = "localTrackUnpublished";
    EngineEvent["LocalTrackSubscribed"] = "localTrackSubscribed";
    EngineEvent["Offline"] = "offline";
    EngineEvent["SignalRequestResponse"] = "signalRequestResponse";
    EngineEvent["SignalConnected"] = "signalConnected";
    EngineEvent["RoomMoved"] = "roomMoved";
    EngineEvent["PublishDataTrackResponse"] = "publishDataTrackResponse";
    EngineEvent["UnPublishDataTrackResponse"] = "unPublishDataTrackResponse";
    EngineEvent["DataTrackSubscriberHandles"] = "dataTrackSubscriberHandles";
    EngineEvent["DataTrackPacketReceived"] = "dataTrackPacketReceived";
    EngineEvent["Joined"] = "joined";
    EngineEvent["TokenRefreshed"] = "tokenRefreshed";
    EngineEvent["ServerRegionsReported"] = "serverRegionsReported";
})($c0722d30b1d17141$export$c09e63b8572f869 || ($c0722d30b1d17141$export$c09e63b8572f869 = {}));
var $c0722d30b1d17141$export$2c8510d737cc09da;
(function(TrackEvent) {
    TrackEvent["Message"] = "message";
    TrackEvent["Muted"] = "muted";
    TrackEvent["Unmuted"] = "unmuted";
    /**
   * Only fires on LocalTracks
   */ TrackEvent["Restarted"] = "restarted";
    TrackEvent["Ended"] = "ended";
    TrackEvent["Subscribed"] = "subscribed";
    TrackEvent["Unsubscribed"] = "unsubscribed";
    TrackEvent["CpuConstrained"] = "cpuConstrained";
    /** @internal */ TrackEvent["UpdateSettings"] = "updateSettings";
    /** @internal */ TrackEvent["UpdateSubscription"] = "updateSubscription";
    /** @internal */ TrackEvent["AudioPlaybackStarted"] = "audioPlaybackStarted";
    /** @internal */ TrackEvent["AudioPlaybackFailed"] = "audioPlaybackFailed";
    /**
   * @internal
   * Only fires on LocalAudioTrack instances
   */ TrackEvent["AudioSilenceDetected"] = "audioSilenceDetected";
    /** @internal */ TrackEvent["VisibilityChanged"] = "visibilityChanged";
    /** @internal */ TrackEvent["VideoDimensionsChanged"] = "videoDimensionsChanged";
    /** @internal */ TrackEvent["VideoPlaybackStarted"] = "videoPlaybackStarted";
    /** @internal */ TrackEvent["VideoPlaybackFailed"] = "videoPlaybackFailed";
    /** @internal */ TrackEvent["ElementAttached"] = "elementAttached";
    /** @internal */ TrackEvent["ElementDetached"] = "elementDetached";
    /**
   * @internal
   * Only fires on LocalTracks
   */ TrackEvent["UpstreamPaused"] = "upstreamPaused";
    /**
   * @internal
   * Only fires on LocalTracks
   */ TrackEvent["UpstreamResumed"] = "upstreamResumed";
    /**
   * @internal
   * Fires on RemoteTrackPublication
   */ TrackEvent["SubscriptionPermissionChanged"] = "subscriptionPermissionChanged";
    /**
   * Fires on RemoteTrackPublication
   */ TrackEvent["SubscriptionStatusChanged"] = "subscriptionStatusChanged";
    /**
   * Fires on RemoteTrackPublication
   */ TrackEvent["SubscriptionFailed"] = "subscriptionFailed";
    /**
   * @internal
   */ TrackEvent["TrackProcessorUpdate"] = "trackProcessorUpdate";
    /**
   * @internal
   */ TrackEvent["AudioTrackFeatureUpdate"] = "audioTrackFeatureUpdate";
    /**
   * @beta
   */ TrackEvent["TranscriptionReceived"] = "transcriptionReceived";
    /**
   * @experimental
   */ TrackEvent["TimeSyncUpdate"] = "timeSyncUpdate";
    /**
   * @internal
   */ TrackEvent["PreConnectBufferFlushed"] = "preConnectBufferFlushed";
})($c0722d30b1d17141$export$2c8510d737cc09da || ($c0722d30b1d17141$export$2c8510d737cc09da = {}));
function $c0722d30b1d17141$var$cloneDeep(value) {
    if (typeof value === 'undefined') return value;
    if (typeof structuredClone === 'function') {
        if (typeof value === 'object' && value !== null) // ensure that the value is not a proxy by spreading it
        return structuredClone(Object.assign({}, value));
        return structuredClone(value);
    } else return JSON.parse(JSON.stringify(value));
}
class $c0722d30b1d17141$export$73e76f4fd970cdf1 {
    constructor(widthOrOptions, height, maxBitrate, maxFramerate, priority){
        if (typeof widthOrOptions === 'object') {
            this.width = widthOrOptions.width;
            this.height = widthOrOptions.height;
            this.aspectRatio = widthOrOptions.aspectRatio;
            this.encoding = {
                maxBitrate: widthOrOptions.maxBitrate,
                maxFramerate: widthOrOptions.maxFramerate,
                priority: widthOrOptions.priority
            };
        } else if (height !== undefined && maxBitrate !== undefined) {
            this.width = widthOrOptions;
            this.height = height;
            this.aspectRatio = widthOrOptions / height;
            this.encoding = {
                maxBitrate: maxBitrate,
                maxFramerate: maxFramerate,
                priority: priority
            };
        } else throw new TypeError('Unsupported options: provide at least width, height and maxBitrate');
    }
    get resolution() {
        return {
            width: this.width,
            height: this.height,
            frameRate: this.encoding.maxFramerate,
            aspectRatio: this.aspectRatio
        };
    }
}
// `red` is not technically a codec, but treated as one in signalling protocol
const $c0722d30b1d17141$export$4becd19f648d58cc = [
    'opus',
    'red'
];
const $c0722d30b1d17141$var$backupVideoCodecs = [
    'vp8',
    'h264'
];
const $c0722d30b1d17141$export$986dcb5e6a94a34c = [
    'vp8',
    'h264',
    'vp9',
    'av1',
    'h265'
];
function $c0722d30b1d17141$export$5049e6bde83900(codec) {
    return !!$c0722d30b1d17141$var$backupVideoCodecs.find((backup)=>backup === codec);
}
/** @deprecated Use {@link isBackupVideoCodec} instead */ const $c0722d30b1d17141$export$da37a49ee77f9d77 = $c0722d30b1d17141$export$5049e6bde83900;
var $c0722d30b1d17141$export$1e9b3bacb871cb8a;
(function(BackupCodecPolicy) {
    // codec regression is preferred, the sfu will try to regress codec if possible but not guaranteed
    BackupCodecPolicy[BackupCodecPolicy["PREFER_REGRESSION"] = 0] = "PREFER_REGRESSION";
    // multi-codec simulcast, publish both primary and backup codec at the same time
    BackupCodecPolicy[BackupCodecPolicy["SIMULCAST"] = 1] = "SIMULCAST";
    // always use backup codec only
    BackupCodecPolicy[BackupCodecPolicy["REGRESSION"] = 2] = "REGRESSION";
})($c0722d30b1d17141$export$1e9b3bacb871cb8a || ($c0722d30b1d17141$export$1e9b3bacb871cb8a = {}));
var $c0722d30b1d17141$export$5da93632511fdb1f;
(function(AudioPresets) {
    AudioPresets.telephone = {
        maxBitrate: 12000
    };
    AudioPresets.speech = {
        maxBitrate: 24000
    };
    AudioPresets.music = {
        maxBitrate: 48000
    };
    AudioPresets.musicStereo = {
        maxBitrate: 64000
    };
    AudioPresets.musicHighQuality = {
        maxBitrate: 96000
    };
    AudioPresets.musicHighQualityStereo = {
        maxBitrate: 128000
    };
})($c0722d30b1d17141$export$5da93632511fdb1f || ($c0722d30b1d17141$export$5da93632511fdb1f = {}));
/**
 * Sane presets for video resolution/encoding
 */ const $c0722d30b1d17141$export$79d56065dad1674c = {
    h90: new $c0722d30b1d17141$export$73e76f4fd970cdf1(160, 90, 90000, 20),
    h180: new $c0722d30b1d17141$export$73e76f4fd970cdf1(320, 180, 160000, 20),
    h216: new $c0722d30b1d17141$export$73e76f4fd970cdf1(384, 216, 180000, 20),
    h360: new $c0722d30b1d17141$export$73e76f4fd970cdf1(640, 360, 450000, 20),
    h540: new $c0722d30b1d17141$export$73e76f4fd970cdf1(960, 540, 800000, 25),
    h720: new $c0722d30b1d17141$export$73e76f4fd970cdf1(1280, 720, 1700000, 30),
    h1080: new $c0722d30b1d17141$export$73e76f4fd970cdf1(1920, 1080, 3000000, 30),
    h1440: new $c0722d30b1d17141$export$73e76f4fd970cdf1(2560, 1440, 5000000, 30),
    h2160: new $c0722d30b1d17141$export$73e76f4fd970cdf1(3840, 2160, 8000000, 30)
};
/**
 * Four by three presets
 */ const $c0722d30b1d17141$export$eb5fc43ecc8ee2c7 = {
    h120: new $c0722d30b1d17141$export$73e76f4fd970cdf1(160, 120, 70000, 20),
    h180: new $c0722d30b1d17141$export$73e76f4fd970cdf1(240, 180, 125000, 20),
    h240: new $c0722d30b1d17141$export$73e76f4fd970cdf1(320, 240, 140000, 20),
    h360: new $c0722d30b1d17141$export$73e76f4fd970cdf1(480, 360, 330000, 20),
    h480: new $c0722d30b1d17141$export$73e76f4fd970cdf1(640, 480, 500000, 20),
    h540: new $c0722d30b1d17141$export$73e76f4fd970cdf1(720, 540, 600000, 25),
    h720: new $c0722d30b1d17141$export$73e76f4fd970cdf1(960, 720, 1300000, 30),
    h1080: new $c0722d30b1d17141$export$73e76f4fd970cdf1(1440, 1080, 2300000, 30),
    h1440: new $c0722d30b1d17141$export$73e76f4fd970cdf1(1920, 1440, 3800000, 30)
};
const $c0722d30b1d17141$export$a6cdf9dcd3d32f2d = {
    h360fps3: new $c0722d30b1d17141$export$73e76f4fd970cdf1(640, 360, 200000, 3, 'medium'),
    h360fps15: new $c0722d30b1d17141$export$73e76f4fd970cdf1(640, 360, 400000, 15, 'medium'),
    h720fps5: new $c0722d30b1d17141$export$73e76f4fd970cdf1(1280, 720, 800000, 5, 'medium'),
    h720fps15: new $c0722d30b1d17141$export$73e76f4fd970cdf1(1280, 720, 1500000, 15, 'medium'),
    h720fps30: new $c0722d30b1d17141$export$73e76f4fd970cdf1(1280, 720, 2000000, 30, 'medium'),
    h1080fps15: new $c0722d30b1d17141$export$73e76f4fd970cdf1(1920, 1080, 2500000, 15, 'medium'),
    h1080fps30: new $c0722d30b1d17141$export$73e76f4fd970cdf1(1920, 1080, 5000000, 30, 'medium'),
    // original resolution, without resizing
    original: new $c0722d30b1d17141$export$73e76f4fd970cdf1(0, 0, 7000000, 30, 'medium')
};
function $c0722d30b1d17141$var$mergeDefaultOptions(options, audioDefaults, videoDefaults) {
    var _a, _b;
    var _c, _d;
    const { optionsWithoutProcessor: optionsWithoutProcessor, audioProcessor: audioProcessor, videoProcessor: videoProcessor } = $c0722d30b1d17141$var$extractProcessorsFromOptions(options !== null && options !== void 0 ? options : {});
    const defaultAudioProcessor = audioDefaults === null || audioDefaults === void 0 ? void 0 : audioDefaults.processor;
    const defaultVideoProcessor = videoDefaults === null || videoDefaults === void 0 ? void 0 : videoDefaults.processor;
    const clonedOptions = optionsWithoutProcessor !== null && optionsWithoutProcessor !== void 0 ? optionsWithoutProcessor : {};
    if (clonedOptions.audio === true) clonedOptions.audio = {};
    if (clonedOptions.video === true) clonedOptions.video = {};
    // use defaults
    if (clonedOptions.audio) {
        $c0722d30b1d17141$var$mergeObjectWithoutOverwriting(clonedOptions.audio, audioDefaults);
        (_a = (_c = clonedOptions.audio).deviceId) !== null && _a !== void 0 ? _a : _c.deviceId = {
            ideal: 'default'
        };
        if (audioProcessor || defaultAudioProcessor) clonedOptions.audio.processor = audioProcessor !== null && audioProcessor !== void 0 ? audioProcessor : defaultAudioProcessor;
    }
    if (clonedOptions.video) {
        $c0722d30b1d17141$var$mergeObjectWithoutOverwriting(clonedOptions.video, videoDefaults);
        (_b = (_d = clonedOptions.video).deviceId) !== null && _b !== void 0 ? _b : _d.deviceId = {
            ideal: 'default'
        };
        if (videoProcessor || defaultVideoProcessor) clonedOptions.video.processor = videoProcessor !== null && videoProcessor !== void 0 ? videoProcessor : defaultVideoProcessor;
    }
    return clonedOptions;
}
function $c0722d30b1d17141$var$mergeObjectWithoutOverwriting(mainObject, objectToMerge) {
    Object.keys(objectToMerge).forEach((key)=>{
        if (mainObject[key] === undefined) mainObject[key] = objectToMerge[key];
    });
    return mainObject;
}
function $c0722d30b1d17141$var$constraintsForOptions(options) {
    var _a, _b;
    var _c, _d;
    const constraints = {};
    if (options.video) {
        // default video options
        if (typeof options.video === 'object') {
            const videoOptions = {};
            const target = videoOptions;
            const source = options.video;
            Object.keys(source).forEach((key)=>{
                switch(key){
                    case 'resolution':
                        // flatten VideoResolution fields
                        $c0722d30b1d17141$var$mergeObjectWithoutOverwriting(target, source.resolution);
                        break;
                    default:
                        target[key] = source[key];
                }
            });
            constraints.video = videoOptions;
            (_a = (_c = constraints.video).deviceId) !== null && _a !== void 0 ? _a : _c.deviceId = {
                ideal: 'default'
            };
        } else constraints.video = options.video ? {
            deviceId: {
                ideal: 'default'
            }
        } : false;
    } else constraints.video = false;
    if (options.audio) {
        if (typeof options.audio === 'object') {
            constraints.audio = options.audio;
            (_b = (_d = constraints.audio).deviceId) !== null && _b !== void 0 ? _b : _d.deviceId = {
                ideal: 'default'
            };
        } else constraints.audio = {
            deviceId: {
                ideal: 'default'
            }
        };
    } else constraints.audio = false;
    return constraints;
}
/**
 * This function detects silence on a given [[Track]] instance.
 * Returns true if the track seems to be entirely silent.
 */ function $c0722d30b1d17141$var$detectSilence(track_1) {
    return $c0722d30b1d17141$var$__awaiter(this, arguments, void 0, function(track) {
        let timeOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
        return function*() {
            const ctx = $c0722d30b1d17141$var$getNewAudioContext();
            if (ctx) {
                const analyser = ctx.createAnalyser();
                analyser.fftSize = 2048;
                const bufferLength = analyser.frequencyBinCount;
                const dataArray = new Uint8Array(bufferLength);
                const source = ctx.createMediaStreamSource(new MediaStream([
                    track.mediaStreamTrack
                ]));
                source.connect(analyser);
                yield $c0722d30b1d17141$var$sleep(timeOffset);
                analyser.getByteTimeDomainData(dataArray);
                const someNoise = dataArray.some((sample)=>sample !== 128 && sample !== 0);
                ctx.close();
                return !someNoise;
            }
            return false;
        }();
    });
}
/**
 * @internal
 */ function $c0722d30b1d17141$var$getNewAudioContext() {
    var _a;
    const AudioContext1 = // @ts-ignore
    typeof window !== 'undefined' && (window.AudioContext || window.webkitAudioContext);
    if (AudioContext1) {
        const audioContext = new AudioContext1({
            latencyHint: 'interactive'
        });
        // If the audio context is suspended, we need to resume it when the user clicks on the page
        if (audioContext.state === 'suspended' && typeof window !== 'undefined' && ((_a = window.document) === null || _a === void 0 ? void 0 : _a.body)) {
            const handleResume = ()=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                    var _a;
                    try {
                        if (audioContext.state === 'suspended') yield audioContext.resume();
                    } catch (e) {
                        console.warn('Error trying to auto-resume audio context', e);
                    } finally{
                        (_a = window.document.body) === null || _a === void 0 || _a.removeEventListener('click', handleResume);
                    }
                });
            // https://developer.mozilla.org/en-US/docs/Web/API/BaseAudioContext/statechange_event
            audioContext.addEventListener('statechange', ()=>{
                var _a;
                if (audioContext.state === 'closed') (_a = window.document.body) === null || _a === void 0 || _a.removeEventListener('click', handleResume);
            });
            window.document.body.addEventListener('click', handleResume);
        }
        return audioContext;
    }
}
/**
 * @internal
 */ function $c0722d30b1d17141$var$kindToSource(kind) {
    if (kind === 'audioinput') return $c0722d30b1d17141$export$13921ac0cc260818.Source.Microphone;
    else if (kind === 'videoinput') return $c0722d30b1d17141$export$13921ac0cc260818.Source.Camera;
    else return $c0722d30b1d17141$export$13921ac0cc260818.Source.Unknown;
}
/**
 * @internal
 */ function $c0722d30b1d17141$var$sourceToKind(source) {
    if (source === $c0722d30b1d17141$export$13921ac0cc260818.Source.Microphone) return 'audioinput';
    else if (source === $c0722d30b1d17141$export$13921ac0cc260818.Source.Camera) return 'videoinput';
    else return undefined;
}
/**
 * @internal
 */ function $c0722d30b1d17141$var$screenCaptureToDisplayMediaStreamOptions(options) {
    var _a, _b;
    let videoConstraints = (_a = options.video) !== null && _a !== void 0 ? _a : true;
    // treat 0 as uncapped
    if (options.resolution && options.resolution.width > 0 && options.resolution.height > 0) {
        videoConstraints = typeof videoConstraints === 'boolean' ? {} : videoConstraints;
        if ($c0722d30b1d17141$var$isSafari()) videoConstraints = Object.assign(Object.assign({}, videoConstraints), {
            width: {
                max: options.resolution.width
            },
            height: {
                max: options.resolution.height
            },
            frameRate: options.resolution.frameRate
        });
        else videoConstraints = Object.assign(Object.assign({}, videoConstraints), {
            width: {
                ideal: options.resolution.width
            },
            height: {
                ideal: options.resolution.height
            },
            frameRate: options.resolution.frameRate
        });
    }
    return {
        audio: (_b = options.audio) !== null && _b !== void 0 ? _b : false,
        video: videoConstraints,
        // @ts-expect-error support for experimental display media features
        controller: options.controller,
        selfBrowserSurface: options.selfBrowserSurface,
        surfaceSwitching: options.surfaceSwitching,
        systemAudio: options.systemAudio,
        preferCurrentTab: options.preferCurrentTab
    };
}
function $c0722d30b1d17141$var$mimeTypeToVideoCodecString(mimeType) {
    return mimeType.split('/')[1].toLowerCase();
}
function $c0722d30b1d17141$var$getTrackPublicationInfo(tracks) {
    const infos = [];
    tracks.forEach((track)=>{
        if (track.track !== undefined) infos.push(new $c0722d30b1d17141$var$TrackPublishedResponse({
            cid: track.track.mediaStreamID,
            track: track.trackInfo
        }));
    });
    return infos;
}
function $c0722d30b1d17141$var$getLogContextFromTrack(track) {
    if ('mediaStreamTrack' in track) return {
        trackID: track.sid,
        source: track.source,
        muted: track.isMuted,
        enabled: track.mediaStreamTrack.enabled,
        kind: track.kind,
        streamID: track.mediaStreamID,
        streamTrackID: track.mediaStreamTrack.id
    };
    else return {
        trackID: track.trackSid,
        enabled: track.isEnabled,
        muted: track.isMuted,
        trackInfo: Object.assign({
            mimeType: track.mimeType,
            name: track.trackName,
            encrypted: track.isEncrypted,
            kind: track.kind,
            source: track.source
        }, track.track ? $c0722d30b1d17141$var$getLogContextFromTrack(track.track) : {})
    };
}
function $c0722d30b1d17141$var$supportsSynchronizationSources() {
    return typeof RTCRtpReceiver !== 'undefined' && 'getSynchronizationSources' in RTCRtpReceiver;
}
function $c0722d30b1d17141$var$diffAttributes(oldValues, newValues) {
    var _a;
    if (oldValues === undefined) oldValues = {};
    if (newValues === undefined) newValues = {};
    const allKeys = [
        ...Object.keys(newValues),
        ...Object.keys(oldValues)
    ];
    const diff = {};
    for (const key of allKeys)if (oldValues[key] !== newValues[key]) diff[key] = (_a = newValues[key]) !== null && _a !== void 0 ? _a : '';
    return diff;
}
/** @internal */ function $c0722d30b1d17141$var$extractProcessorsFromOptions(options) {
    const newOptions = Object.assign({}, options);
    let audioProcessor;
    let videoProcessor;
    if (typeof newOptions.audio === 'object' && newOptions.audio.processor) {
        audioProcessor = newOptions.audio.processor;
        newOptions.audio = Object.assign(Object.assign({}, newOptions.audio), {
            processor: undefined
        });
    }
    if (typeof newOptions.video === 'object' && newOptions.video.processor) {
        videoProcessor = newOptions.video.processor;
        newOptions.video = Object.assign(Object.assign({}, newOptions.video), {
            processor: undefined
        });
    }
    return {
        audioProcessor: audioProcessor,
        videoProcessor: videoProcessor,
        optionsWithoutProcessor: $c0722d30b1d17141$var$cloneDeep(newOptions)
    };
}
function $c0722d30b1d17141$var$getTrackSourceFromProto(source) {
    switch(source){
        case $c0722d30b1d17141$var$TrackSource.CAMERA:
            return $c0722d30b1d17141$export$13921ac0cc260818.Source.Camera;
        case $c0722d30b1d17141$var$TrackSource.MICROPHONE:
            return $c0722d30b1d17141$export$13921ac0cc260818.Source.Microphone;
        case $c0722d30b1d17141$var$TrackSource.SCREEN_SHARE:
            return $c0722d30b1d17141$export$13921ac0cc260818.Source.ScreenShare;
        case $c0722d30b1d17141$var$TrackSource.SCREEN_SHARE_AUDIO:
            return $c0722d30b1d17141$export$13921ac0cc260818.Source.ScreenShareAudio;
        default:
            return $c0722d30b1d17141$export$13921ac0cc260818.Source.Unknown;
    }
}
function $c0722d30b1d17141$var$areDimensionsSmaller(a, b) {
    return a.width * a.height < b.width * b.height;
}
function $c0722d30b1d17141$var$layerDimensionsFor(trackInfo, quality) {
    var _a;
    return (_a = trackInfo.layers) === null || _a === void 0 ? void 0 : _a.find((l)=>l.quality === quality);
}
const $c0722d30b1d17141$var$BACKGROUND_REACTION_DELAY = 5000;
// keep old audio elements when detached, we would re-use them since on iOS
// Safari tracks which audio elements have been "blessed" by the user.
const $c0722d30b1d17141$var$recycledElements = [];
var $c0722d30b1d17141$export$a8f593954e806155;
(function(VideoQuality) {
    VideoQuality[VideoQuality["LOW"] = 0] = "LOW";
    VideoQuality[VideoQuality["MEDIUM"] = 1] = "MEDIUM";
    VideoQuality[VideoQuality["HIGH"] = 2] = "HIGH";
})($c0722d30b1d17141$export$a8f593954e806155 || ($c0722d30b1d17141$export$a8f593954e806155 = {}));
class $c0722d30b1d17141$export$13921ac0cc260818 extends $c0722d30b1d17141$var$eventsExports.EventEmitter {
    /**
   * indicates current state of stream, it'll indicate `paused` if the track
   * has been paused by congestion controller
   */ get streamState() {
        return this._streamState;
    }
    /** @internal */ setStreamState(value) {
        this._streamState = value;
    }
    constructor(mediaTrack, kind){
        let loggerOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var _a;
        super();
        this.attachedElements = [];
        this.isMuted = false;
        this._streamState = $c0722d30b1d17141$export$13921ac0cc260818.StreamState.Active;
        this.isInBackground = false;
        this._currentBitrate = 0;
        this.log = $c0722d30b1d17141$var$livekitLogger;
        this.appVisibilityChangedListener = ()=>{
            if (this.backgroundTimeout) clearTimeout(this.backgroundTimeout);
            // delay app visibility update if it goes to hidden
            // update immediately if it comes back to focus
            if (document.visibilityState === 'hidden') this.backgroundTimeout = setTimeout(()=>this.handleAppVisibilityChanged(), $c0722d30b1d17141$var$BACKGROUND_REACTION_DELAY);
            else this.handleAppVisibilityChanged();
        };
        this.log = $c0722d30b1d17141$export$2b1d391cd05230fd((_a = loggerOptions.loggerName) !== null && _a !== void 0 ? _a : $c0722d30b1d17141$export$69ba24dd79f4da21.Track);
        this.loggerContextCb = loggerOptions.loggerContextCb;
        this.setMaxListeners(100);
        this.kind = kind;
        this._mediaStreamTrack = mediaTrack;
        this._mediaStreamID = mediaTrack.id;
        this.source = $c0722d30b1d17141$export$13921ac0cc260818.Source.Unknown;
    }
    get logContext() {
        var _a;
        return Object.assign(Object.assign({}, (_a = this.loggerContextCb) === null || _a === void 0 ? void 0 : _a.call(this)), $c0722d30b1d17141$var$getLogContextFromTrack(this));
    }
    /** current receive bits per second */ get currentBitrate() {
        return this._currentBitrate;
    }
    get mediaStreamTrack() {
        return this._mediaStreamTrack;
    }
    /**
   * @internal
   * used for keep mediaStream's first id, since it's id might change
   * if we disable/enable a track
   */ get mediaStreamID() {
        return this._mediaStreamID;
    }
    attach(element) {
        let elementType = 'audio';
        if (this.kind === $c0722d30b1d17141$export$13921ac0cc260818.Kind.Video) elementType = 'video';
        if (this.attachedElements.length === 0 && this.kind === $c0722d30b1d17141$export$13921ac0cc260818.Kind.Video) this.addAppVisibilityListener();
        if (!element) {
            if (elementType === 'audio') {
                $c0722d30b1d17141$var$recycledElements.forEach((e)=>{
                    if (e.parentElement === null && !element) element = e;
                });
                if (element) // remove it from pool
                $c0722d30b1d17141$var$recycledElements.splice($c0722d30b1d17141$var$recycledElements.indexOf(element), 1);
            }
            if (!element) element = document.createElement(elementType);
        }
        if (!this.attachedElements.includes(element)) this.attachedElements.push(element);
        // even if we believe it's already attached to the element, it's possible
        // the element's srcObject was set to something else out of band.
        // we'll want to re-attach it in that case
        $c0722d30b1d17141$export$b8f95ef2322890b8(this.mediaStreamTrack, element);
        // handle auto playback failures
        const allMediaStreamTracks = element.srcObject.getTracks();
        const hasAudio = allMediaStreamTracks.some((tr)=>tr.kind === 'audio');
        // manually play media to detect auto playback status
        element.play().then(()=>{
            this.emit(hasAudio ? $c0722d30b1d17141$export$2c8510d737cc09da.AudioPlaybackStarted : $c0722d30b1d17141$export$2c8510d737cc09da.VideoPlaybackStarted);
        }).catch((e)=>{
            if (e.name === 'NotAllowedError') this.emit(hasAudio ? $c0722d30b1d17141$export$2c8510d737cc09da.AudioPlaybackFailed : $c0722d30b1d17141$export$2c8510d737cc09da.VideoPlaybackFailed, e);
            else if (e.name === 'AbortError') // commonly triggered by another `play` request, only log for debugging purposes
            $c0722d30b1d17141$var$livekitLogger.debug("".concat(hasAudio ? 'audio' : 'video', " playback aborted, likely due to new play request"));
            else $c0722d30b1d17141$var$livekitLogger.warn("could not playback ".concat(hasAudio ? 'audio' : 'video'), e);
            // If audio playback isn't allowed make sure we still play back the video
            if (hasAudio && element && allMediaStreamTracks.some((tr)=>tr.kind === 'video') && e.name === 'NotAllowedError') {
                element.muted = true;
                element.play().catch(()=>{
                // catch for Safari, exceeded options at this point to automatically play the media element
                });
            }
        });
        this.emit($c0722d30b1d17141$export$2c8510d737cc09da.ElementAttached, element);
        return element;
    }
    detach(element) {
        try {
            // detach from a single element
            if (element) {
                $c0722d30b1d17141$export$8ea68c6294970fa5(this.mediaStreamTrack, element);
                const idx = this.attachedElements.indexOf(element);
                if (idx >= 0) {
                    this.attachedElements.splice(idx, 1);
                    this.recycleElement(element);
                    this.emit($c0722d30b1d17141$export$2c8510d737cc09da.ElementDetached, element);
                }
                return element;
            }
            const detached = [];
            this.attachedElements.forEach((elm)=>{
                $c0722d30b1d17141$export$8ea68c6294970fa5(this.mediaStreamTrack, elm);
                detached.push(elm);
                this.recycleElement(elm);
                this.emit($c0722d30b1d17141$export$2c8510d737cc09da.ElementDetached, elm);
            });
            // remove all tracks
            this.attachedElements = [];
            return detached;
        } finally{
            if (this.attachedElements.length === 0) this.removeAppVisibilityListener();
        }
    }
    stop() {
        this.stopMonitor();
        this._mediaStreamTrack.stop();
    }
    enable() {
        this._mediaStreamTrack.enabled = true;
    }
    disable() {
        this._mediaStreamTrack.enabled = false;
    }
    /* @internal */ stopMonitor() {
        if (this.monitorInterval) clearInterval(this.monitorInterval);
        if (this.timeSyncHandle) cancelAnimationFrame(this.timeSyncHandle);
    }
    /** @internal */ updateLoggerOptions(loggerOptions) {
        if (loggerOptions.loggerName) this.log = $c0722d30b1d17141$export$2b1d391cd05230fd(loggerOptions.loggerName);
        if (loggerOptions.loggerContextCb) this.loggerContextCb = loggerOptions.loggerContextCb;
    }
    recycleElement(element) {
        if (element instanceof HTMLAudioElement) {
            // we only need to re-use a single element
            let shouldCache = true;
            element.pause();
            $c0722d30b1d17141$var$recycledElements.forEach((e)=>{
                if (!e.parentElement) shouldCache = false;
            });
            if (shouldCache) $c0722d30b1d17141$var$recycledElements.push(element);
        }
    }
    handleAppVisibilityChanged() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            this.isInBackground = document.visibilityState === 'hidden';
            if (!this.isInBackground && this.kind === $c0722d30b1d17141$export$13921ac0cc260818.Kind.Video) setTimeout(()=>this.attachedElements.forEach((el)=>el.play().catch(()=>{
                    /** catch clause necessary for Safari */ })), 0);
        });
    }
    addAppVisibilityListener() {
        if ($c0722d30b1d17141$var$isWeb()) {
            this.isInBackground = document.visibilityState === 'hidden';
            document.addEventListener('visibilitychange', this.appVisibilityChangedListener);
        } else this.isInBackground = false;
    }
    removeAppVisibilityListener() {
        if ($c0722d30b1d17141$var$isWeb()) document.removeEventListener('visibilitychange', this.appVisibilityChangedListener);
    }
}
function $c0722d30b1d17141$export$b8f95ef2322890b8(track, element) {
    let mediaStream;
    if (element.srcObject instanceof MediaStream) mediaStream = element.srcObject;
    else mediaStream = new MediaStream();
    // check if track matches existing track
    let existingTracks;
    if (track.kind === 'audio') existingTracks = mediaStream.getAudioTracks();
    else existingTracks = mediaStream.getVideoTracks();
    if (!existingTracks.includes(track)) {
        existingTracks.forEach((et)=>{
            mediaStream.removeTrack(et);
        });
        mediaStream.addTrack(track);
    }
    if (!$c0722d30b1d17141$var$isSafari() || !(element instanceof HTMLVideoElement)) // when in low power mode (applies to both macOS and iOS), Safari will show a play/pause overlay
    // when a video starts that has the `autoplay` attribute is set.
    // we work around this by _not_ setting the autoplay attribute on safari and instead call `setTimeout(() => el.play(),0)` further down
    element.autoplay = true;
    // In case there are no audio tracks present on the mediastream, we set the element as muted to ensure autoplay works
    element.muted = mediaStream.getAudioTracks().length === 0;
    if (element instanceof HTMLVideoElement) element.playsInline = true;
    // avoid flicker
    if (element.srcObject !== mediaStream) {
        element.srcObject = mediaStream;
        if (($c0722d30b1d17141$var$isSafari() || $c0722d30b1d17141$var$isFireFox()) && element instanceof HTMLVideoElement) // Firefox also has a timing issue where video doesn't actually get attached unless
        // performed out-of-band
        // Safari 15 has a bug where in certain layouts, video element renders
        // black until the page is resized or other changes take place.
        // Resetting the src triggers it to render.
        // https://developer.apple.com/forums/thread/690523
        setTimeout(()=>{
            element.srcObject = mediaStream;
            // Safari 15 sometimes fails to start a video
            // when the window is backgrounded before the first frame is drawn
            // manually calling play here seems to fix that
            element.play().catch(()=>{
            /** do nothing */ });
        }, 0);
    }
}
/** @internal */ function $c0722d30b1d17141$export$8ea68c6294970fa5(track, element) {
    if (element.srcObject instanceof MediaStream) {
        const mediaStream = element.srcObject;
        mediaStream.removeTrack(track);
        if (mediaStream.getTracks().length > 0) element.srcObject = mediaStream;
        else element.srcObject = null;
    }
}
(function(Track) {
    let Kind;
    (function(Kind) {
        Kind["Audio"] = "audio";
        Kind["Video"] = "video";
        Kind["Unknown"] = "unknown";
    })(Kind = Track.Kind || (Track.Kind = {}));
    let Source;
    (function(Source) {
        Source["Camera"] = "camera";
        Source["Microphone"] = "microphone";
        Source["ScreenShare"] = "screen_share";
        Source["ScreenShareAudio"] = "screen_share_audio";
        Source["Unknown"] = "unknown";
    })(Source = Track.Source || (Track.Source = {}));
    let StreamState$1;
    (function(StreamState) {
        StreamState["Active"] = "active";
        StreamState["Paused"] = "paused";
        StreamState["Unknown"] = "unknown";
    })(StreamState$1 = Track.StreamState || (Track.StreamState = {}));
    /** @internal */ function kindToProto(k) {
        switch(k){
            case Kind.Audio:
                return $c0722d30b1d17141$export$c2fc6e4ded3e0219.AUDIO;
            case Kind.Video:
                return $c0722d30b1d17141$export$c2fc6e4ded3e0219.VIDEO;
            default:
                // FIXME this was UNRECOGNIZED before
                return $c0722d30b1d17141$export$c2fc6e4ded3e0219.DATA;
        }
    }
    Track.kindToProto = kindToProto;
    /** @internal */ function kindFromProto(t) {
        switch(t){
            case $c0722d30b1d17141$export$c2fc6e4ded3e0219.AUDIO:
                return Kind.Audio;
            case $c0722d30b1d17141$export$c2fc6e4ded3e0219.VIDEO:
                return Kind.Video;
            default:
                return Kind.Unknown;
        }
    }
    Track.kindFromProto = kindFromProto;
    /** @internal */ function sourceToProto(s) {
        switch(s){
            case Source.Camera:
                return $c0722d30b1d17141$var$TrackSource.CAMERA;
            case Source.Microphone:
                return $c0722d30b1d17141$var$TrackSource.MICROPHONE;
            case Source.ScreenShare:
                return $c0722d30b1d17141$var$TrackSource.SCREEN_SHARE;
            case Source.ScreenShareAudio:
                return $c0722d30b1d17141$var$TrackSource.SCREEN_SHARE_AUDIO;
            default:
                return $c0722d30b1d17141$var$TrackSource.UNKNOWN;
        }
    }
    Track.sourceToProto = sourceToProto;
    /** @internal */ function sourceFromProto(s) {
        switch(s){
            case $c0722d30b1d17141$var$TrackSource.CAMERA:
                return Source.Camera;
            case $c0722d30b1d17141$var$TrackSource.MICROPHONE:
                return Source.Microphone;
            case $c0722d30b1d17141$var$TrackSource.SCREEN_SHARE:
                return Source.ScreenShare;
            case $c0722d30b1d17141$var$TrackSource.SCREEN_SHARE_AUDIO:
                return Source.ScreenShareAudio;
            default:
                return Source.Unknown;
        }
    }
    Track.sourceFromProto = sourceFromProto;
    /** @internal */ function streamStateFromProto(s) {
        switch(s){
            case $c0722d30b1d17141$var$StreamState.ACTIVE:
                return StreamState$1.Active;
            case $c0722d30b1d17141$var$StreamState.PAUSED:
                return StreamState$1.Paused;
            default:
                return StreamState$1.Unknown;
        }
    }
    Track.streamStateFromProto = streamStateFromProto;
})($c0722d30b1d17141$export$13921ac0cc260818 || ($c0722d30b1d17141$export$13921ac0cc260818 = {}));
const $c0722d30b1d17141$var$separator = '|';
const $c0722d30b1d17141$var$ddExtensionURI = 'https://aomediacodec.github.io/av1-rtp-spec/#dependency-descriptor-rtp-header-extension';
function $c0722d30b1d17141$var$unpackStreamId(packed) {
    const parts = packed.split($c0722d30b1d17141$var$separator);
    if (parts.length > 1) return [
        parts[0],
        packed.substr(parts[0].length + 1)
    ];
    return [
        packed,
        ''
    ];
}
function $c0722d30b1d17141$var$sleep(duration) {
    return new $c0722d30b1d17141$var$TypedPromise((resolve)=>$c0722d30b1d17141$export$22e737276454df96.setTimeout(resolve, duration));
}
/** @internal */ function $c0722d30b1d17141$var$supportsTransceiver() {
    return 'addTransceiver' in RTCPeerConnection.prototype;
}
/** @internal */ function $c0722d30b1d17141$var$supportsAddTrack() {
    return 'addTrack' in RTCPeerConnection.prototype;
}
function $c0722d30b1d17141$export$5d441b0d5c2caf15() {
    return true;
}
function $c0722d30b1d17141$export$54d539ea1a521c7e() {
    return $c0722d30b1d17141$var$supportsTransceiver();
}
function $c0722d30b1d17141$export$f157b33fe3596be1() {
    if (!('getCapabilities' in RTCRtpSender)) return false;
    if ($c0722d30b1d17141$var$isSafari() || $c0722d30b1d17141$var$isFireFox()) // Safari 17 on iPhone14 reports AV1 capability, but does not actually support it
    // Firefox does support AV1, but SVC publishing is not supported
    return false;
    const capabilities = RTCRtpSender.getCapabilities('video');
    let hasAV1 = false;
    if (capabilities) {
        for (const codec of capabilities.codecs)if (codec.mimeType.toLowerCase() === 'video/av1') {
            hasAV1 = true;
            break;
        }
    }
    return hasAV1;
}
function $c0722d30b1d17141$export$7c4c0f8271043129() {
    if (!('getCapabilities' in RTCRtpSender)) return false;
    if ($c0722d30b1d17141$var$isFireFox()) // technically speaking FireFox supports VP9, but SVC publishing is broken
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1633876
    return false;
    if ($c0722d30b1d17141$var$isSafari()) {
        const browser = $c0722d30b1d17141$export$89e15fc796a4a429();
        if ((browser === null || browser === void 0 ? void 0 : browser.version) && $c0722d30b1d17141$export$66e1c0999abad646(browser.version, '16') < 0) // Safari 16 and below does not support VP9
        return false;
        if ((browser === null || browser === void 0 ? void 0 : browser.os) === 'iOS' && (browser === null || browser === void 0 ? void 0 : browser.osVersion) && $c0722d30b1d17141$export$66e1c0999abad646(browser.osVersion, '16') < 0) // Safari 16 and below on iOS does not support VP9 we need the iOS check to account for other browsers running webkit under the hood
        return false;
    }
    const capabilities = RTCRtpSender.getCapabilities('video');
    let hasVP9 = false;
    if (capabilities) {
        for (const codec of capabilities.codecs)if (codec.mimeType.toLowerCase() === 'video/vp9') {
            hasVP9 = true;
            break;
        }
    }
    return hasVP9;
}
function $c0722d30b1d17141$var$isSVCCodec(codec) {
    return codec === 'av1' || codec === 'vp9';
}
function $c0722d30b1d17141$var$supportsSetSinkId(elm) {
    if (!document || $c0722d30b1d17141$var$isSafariBased()) return false;
    if (!elm) elm = document.createElement('audio');
    return 'setSinkId' in elm;
}
/**
 * Checks whether or not setting an audio output via {@link Room#setActiveDevice}
 * is supported for the current browser.
 */ function $c0722d30b1d17141$export$4098cfacc62a636e() {
    // Note: this is method publicly exported under a user friendly name and currently only proxying `supportsSetSinkId`
    return $c0722d30b1d17141$var$supportsSetSinkId();
}
function $c0722d30b1d17141$export$3fe402ec04821f17() {
    if (typeof RTCPeerConnection === 'undefined') return false;
    return $c0722d30b1d17141$var$supportsTransceiver() || $c0722d30b1d17141$var$supportsAddTrack();
}
function $c0722d30b1d17141$var$isFireFox() {
    var _a;
    return ((_a = $c0722d30b1d17141$export$89e15fc796a4a429()) === null || _a === void 0 ? void 0 : _a.name) === 'Firefox';
}
function $c0722d30b1d17141$var$isChromiumBased() {
    const browser = $c0722d30b1d17141$export$89e15fc796a4a429();
    return !!browser && browser.name === 'Chrome' && browser.os !== 'iOS';
}
function $c0722d30b1d17141$var$isSafari() {
    var _a;
    return ((_a = $c0722d30b1d17141$export$89e15fc796a4a429()) === null || _a === void 0 ? void 0 : _a.name) === 'Safari';
}
function $c0722d30b1d17141$var$isSafariBased() {
    const b = $c0722d30b1d17141$export$89e15fc796a4a429();
    return (b === null || b === void 0 ? void 0 : b.name) === 'Safari' || (b === null || b === void 0 ? void 0 : b.os) === 'iOS';
}
function $c0722d30b1d17141$var$isSafari17Based() {
    const b = $c0722d30b1d17141$export$89e15fc796a4a429();
    return (b === null || b === void 0 ? void 0 : b.name) === 'Safari' && b.version.startsWith('17.') || (b === null || b === void 0 ? void 0 : b.os) === 'iOS' && !!(b === null || b === void 0 ? void 0 : b.osVersion) && $c0722d30b1d17141$export$66e1c0999abad646(b.osVersion, '17') >= 0;
}
function $c0722d30b1d17141$var$isSafariSvcApi(browser) {
    if (!browser) browser = $c0722d30b1d17141$export$89e15fc796a4a429();
    // Safari 18.4 requires legacy svc api and scaleResolutionDown to be set
    return (browser === null || browser === void 0 ? void 0 : browser.name) === 'Safari' && $c0722d30b1d17141$export$66e1c0999abad646(browser.version, '18.3') > 0 || (browser === null || browser === void 0 ? void 0 : browser.os) === 'iOS' && !!(browser === null || browser === void 0 ? void 0 : browser.osVersion) && $c0722d30b1d17141$export$66e1c0999abad646(browser.osVersion, '18.3') > 0;
}
function $c0722d30b1d17141$var$isMobile() {
    var _a, _b;
    if (!$c0722d30b1d17141$var$isWeb()) return false;
    return(// @ts-expect-error `userAgentData` is not yet part of typescript
    (_b = (_a = navigator.userAgentData) === null || _a === void 0 ? void 0 : _a.mobile) !== null && _b !== void 0 ? _b : /Tablet|iPad|Mobile|Android|BlackBerry/.test(navigator.userAgent));
}
function $c0722d30b1d17141$var$isE2EESimulcastSupported() {
    const browser = $c0722d30b1d17141$export$89e15fc796a4a429();
    const supportedSafariVersion = '17.2'; // see https://bugs.webkit.org/show_bug.cgi?id=257803
    if (browser) {
        if (browser.name !== 'Safari' && browser.os !== 'iOS') return true;
        else if (browser.os === 'iOS' && browser.osVersion && $c0722d30b1d17141$export$66e1c0999abad646(browser.osVersion, supportedSafariVersion) >= 0) return true;
        else if (browser.name === 'Safari' && $c0722d30b1d17141$export$66e1c0999abad646(browser.version, supportedSafariVersion) >= 0) return true;
        else return false;
    }
}
function $c0722d30b1d17141$var$isWeb() {
    return typeof document !== 'undefined';
}
function $c0722d30b1d17141$var$isReactNative() {
    // navigator.product is deprecated on browsers, but will be set appropriately for react-native.
    return navigator.product == 'ReactNative';
}
function $c0722d30b1d17141$var$isCloud(serverUrl) {
    return serverUrl.hostname.endsWith('.livekit.cloud') || serverUrl.hostname.endsWith('.livekit.run');
}
function $c0722d30b1d17141$var$extractProjectFromUrl(serverUrl) {
    if (!$c0722d30b1d17141$var$isCloud(serverUrl)) return null;
    return serverUrl.hostname.split('.')[0];
}
function $c0722d30b1d17141$var$getLKReactNativeInfo() {
    // global defined only for ReactNative.
    // @ts-ignore
    if ($parcel$global && $parcel$global.LiveKitReactNativeGlobal) // @ts-ignore
    return $parcel$global.LiveKitReactNativeGlobal;
    return undefined;
}
function $c0722d30b1d17141$var$getReactNativeOs() {
    if (!$c0722d30b1d17141$var$isReactNative()) return undefined;
    let info = $c0722d30b1d17141$var$getLKReactNativeInfo();
    if (info) return info.platform;
    return undefined;
}
function $c0722d30b1d17141$var$getDevicePixelRatio() {
    if ($c0722d30b1d17141$var$isWeb()) return window.devicePixelRatio;
    if ($c0722d30b1d17141$var$isReactNative()) {
        let info = $c0722d30b1d17141$var$getLKReactNativeInfo();
        if (info) return info.devicePixelRatio;
    }
    return 1;
}
/**
 * @param v1 - The first version string to compare.
 * @param v2 - The second version string to compare.
 * @returns A number indicating the order of the versions:
 *   - 1 if v1 is greater than v2
 *   - -1 if v1 is less than v2
 *   - 0 if v1 and v2 are equal
 */ function $c0722d30b1d17141$export$66e1c0999abad646(v1, v2) {
    const parts1 = v1.split('.');
    const parts2 = v2.split('.');
    const k = Math.min(parts1.length, parts2.length);
    for(let i = 0; i < k; ++i){
        const p1 = parseInt(parts1[i], 10);
        const p2 = parseInt(parts2[i], 10);
        if (p1 > p2) return 1;
        if (p1 < p2) return -1;
        if (i === k - 1 && p1 === p2) return 0;
    }
    if (v1 === '' && v2 !== '') return -1;
    else if (v2 === '') return 1;
    return parts1.length == parts2.length ? 0 : parts1.length < parts2.length ? -1 : 1;
}
function $c0722d30b1d17141$var$roDispatchCallback(entries) {
    for (const entry of entries)entry.target.handleResize(entry);
}
function $c0722d30b1d17141$var$ioDispatchCallback(entries) {
    for (const entry of entries)entry.target.handleVisibilityChanged(entry);
}
let $c0722d30b1d17141$var$resizeObserver = null;
const $c0722d30b1d17141$var$getResizeObserver = ()=>{
    if (!$c0722d30b1d17141$var$resizeObserver) $c0722d30b1d17141$var$resizeObserver = new ResizeObserver($c0722d30b1d17141$var$roDispatchCallback);
    return $c0722d30b1d17141$var$resizeObserver;
};
let $c0722d30b1d17141$var$intersectionObserver = null;
const $c0722d30b1d17141$var$getIntersectionObserver = ()=>{
    if (!$c0722d30b1d17141$var$intersectionObserver) $c0722d30b1d17141$var$intersectionObserver = new IntersectionObserver($c0722d30b1d17141$var$ioDispatchCallback, {
        root: null,
        rootMargin: '0px'
    });
    return $c0722d30b1d17141$var$intersectionObserver;
};
function $c0722d30b1d17141$var$getClientInfo() {
    var _a;
    const info = new $c0722d30b1d17141$var$ClientInfo({
        sdk: $c0722d30b1d17141$var$ClientInfo_SDK.JS,
        protocol: $c0722d30b1d17141$export$94587fadffb515a1,
        version: $c0722d30b1d17141$export$83d89fbfd8236492
    });
    if ($c0722d30b1d17141$var$isReactNative()) info.os = (_a = $c0722d30b1d17141$var$getReactNativeOs()) !== null && _a !== void 0 ? _a : '';
    return info;
}
let $c0722d30b1d17141$var$emptyVideoStreamTrack;
function $c0722d30b1d17141$export$47f608edbac1bdf7() {
    if (!$c0722d30b1d17141$var$emptyVideoStreamTrack) $c0722d30b1d17141$var$emptyVideoStreamTrack = $c0722d30b1d17141$var$createDummyVideoStreamTrack();
    return $c0722d30b1d17141$var$emptyVideoStreamTrack.clone();
}
function $c0722d30b1d17141$var$createDummyVideoStreamTrack() {
    let width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 16;
    let height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;
    let enabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    let paintContent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    const canvas = document.createElement('canvas');
    // the canvas size is set to 16 by default, because electron apps seem to fail with smaller values
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    ctx === null || ctx === void 0 || ctx.fillRect(0, 0, canvas.width, canvas.height);
    if (paintContent && ctx) {
        ctx.beginPath();
        ctx.arc(width / 2, height / 2, 50, 0, Math.PI * 2, true);
        ctx.closePath();
        ctx.fillStyle = 'grey';
        ctx.fill();
    }
    // @ts-ignore
    const dummyStream = canvas.captureStream();
    const [dummyTrack] = dummyStream.getTracks();
    if (!dummyTrack) throw Error('Could not get empty media stream video track');
    dummyTrack.enabled = enabled;
    return dummyTrack;
}
let $c0722d30b1d17141$var$emptyAudioStreamTrack;
function $c0722d30b1d17141$export$59e276d6841f735c() {
    if (!$c0722d30b1d17141$var$emptyAudioStreamTrack) {
        // implementation adapted from https://blog.mozilla.org/webrtc/warm-up-with-replacetrack/
        const ctx = new AudioContext();
        const oscillator = ctx.createOscillator();
        const gain = ctx.createGain();
        gain.gain.setValueAtTime(0, 0);
        const dst = ctx.createMediaStreamDestination();
        oscillator.connect(gain);
        gain.connect(dst);
        oscillator.start();
        [$c0722d30b1d17141$var$emptyAudioStreamTrack] = dst.stream.getAudioTracks();
        if (!$c0722d30b1d17141$var$emptyAudioStreamTrack) throw Error('Could not get empty media stream audio track');
        $c0722d30b1d17141$var$emptyAudioStreamTrack.enabled = false;
    }
    return $c0722d30b1d17141$var$emptyAudioStreamTrack.clone();
}
/** An object that represents a serialized version of a `new Promise((resolve, reject) => {})`
 * constructor. Wait for a promise resolution with `await future.promise` and explicitly resolve or
 * reject the inner promise with `future.resolve(...)` or `future.reject(...)`.
 */ class $c0722d30b1d17141$var$Future {
    get isResolved() {
        return this._isResolved;
    }
    constructor(futureBase, onFinally){
        this._isResolved = false;
        this.onFinally = onFinally;
        this.promise = new Promise((resolve, reject)=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                this.resolve = resolve;
                this.reject = reject;
                if (futureBase) yield futureBase(resolve, reject);
            })).finally(()=>{
            var _a;
            this._isResolved = true;
            (_a = this.onFinally) === null || _a === void 0 || _a.call(this);
        });
    }
}
/**
 * Creates and returns an analyser web audio node that is attached to the provided track.
 * Additionally returns a convenience method `calculateVolume` to perform instant volume readings on that track.
 * Call the returned `cleanup` function to close the audioContext that has been created for the instance of this helper
 */ function $c0722d30b1d17141$export$c3a30182235995eb(track, options) {
    const opts = Object.assign({
        cloneTrack: false,
        fftSize: 2048,
        smoothingTimeConstant: 0.8,
        minDecibels: -100,
        maxDecibels: -80
    }, options);
    const audioContext = $c0722d30b1d17141$var$getNewAudioContext();
    if (!audioContext) throw new Error('Audio Context not supported on this browser');
    const streamTrack = opts.cloneTrack ? track.mediaStreamTrack.clone() : track.mediaStreamTrack;
    const mediaStreamSource = audioContext.createMediaStreamSource(new MediaStream([
        streamTrack
    ]));
    const analyser = audioContext.createAnalyser();
    analyser.minDecibels = opts.minDecibels;
    analyser.maxDecibels = opts.maxDecibels;
    analyser.fftSize = opts.fftSize;
    analyser.smoothingTimeConstant = opts.smoothingTimeConstant;
    mediaStreamSource.connect(analyser);
    const dataArray = new Uint8Array(analyser.frequencyBinCount);
    /**
   * Calculates the current volume of the track in the range from 0 to 1
   */ const calculateVolume = ()=>{
        analyser.getByteFrequencyData(dataArray);
        let sum = 0;
        for (const amplitude of dataArray)sum += Math.pow(amplitude / 255, 2);
        const volume = Math.sqrt(sum / dataArray.length);
        return volume;
    };
    const cleanup = ()=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            yield audioContext.close();
            if (opts.cloneTrack) streamTrack.stop();
        });
    return {
        calculateVolume: calculateVolume,
        analyser: analyser,
        cleanup: cleanup
    };
}
function $c0722d30b1d17141$export$c642d74e895e3217(maybeCodec) {
    return $c0722d30b1d17141$export$4becd19f648d58cc.includes(maybeCodec);
}
function $c0722d30b1d17141$export$601d10c6a66cb34c(maybeCodec) {
    return $c0722d30b1d17141$export$986dcb5e6a94a34c.includes(maybeCodec);
}
function $c0722d30b1d17141$var$unwrapConstraint(constraint) {
    if (typeof constraint === 'string' || typeof constraint === 'number') return constraint;
    if (Array.isArray(constraint)) return constraint[0];
    if (constraint.exact !== undefined) {
        if (Array.isArray(constraint.exact)) return constraint.exact[0];
        return constraint.exact;
    }
    if (constraint.ideal !== undefined) {
        if (Array.isArray(constraint.ideal)) return constraint.ideal[0];
        return constraint.ideal;
    }
    throw Error('could not unwrap constraint');
}
function $c0722d30b1d17141$var$toWebsocketUrl(url) {
    if (url.startsWith('http')) return url.replace(/^(http)/, 'ws');
    return url;
}
function $c0722d30b1d17141$var$toHttpUrl(url) {
    if (url.startsWith('ws')) return url.replace(/^(ws)/, 'http');
    return url;
}
function $c0722d30b1d17141$var$extractTranscriptionSegments(transcription, firstReceivedTimesMap) {
    return transcription.segments.map((_ref)=>{
        let { id: id, text: text, language: language, startTime: startTime, endTime: endTime, final: final } = _ref;
        var _a;
        const firstReceivedTime = (_a = firstReceivedTimesMap.get(id)) !== null && _a !== void 0 ? _a : Date.now();
        const lastReceivedTime = Date.now();
        if (final) firstReceivedTimesMap.delete(id);
        else firstReceivedTimesMap.set(id, firstReceivedTime);
        return {
            id: id,
            text: text,
            startTime: Number.parseInt(startTime.toString()),
            endTime: Number.parseInt(endTime.toString()),
            final: final,
            language: language,
            firstReceivedTime: firstReceivedTime,
            lastReceivedTime: lastReceivedTime
        };
    });
}
function $c0722d30b1d17141$var$extractChatMessage(msg) {
    const { id: id, timestamp: timestamp, message: message, editTimestamp: editTimestamp } = msg;
    return {
        id: id,
        timestamp: Number.parseInt(timestamp.toString()),
        editTimestamp: editTimestamp ? Number.parseInt(editTimestamp.toString()) : undefined,
        message: message
    };
}
function $c0722d30b1d17141$var$getDisconnectReasonFromConnectionError(e) {
    switch(e.reason){
        case $c0722d30b1d17141$export$61182a0b21436b65.LeaveRequest:
            return e.context;
        case $c0722d30b1d17141$export$61182a0b21436b65.Cancelled:
            return $c0722d30b1d17141$export$258d16488300d83f.CLIENT_INITIATED;
        case $c0722d30b1d17141$export$61182a0b21436b65.NotAllowed:
            return $c0722d30b1d17141$export$258d16488300d83f.USER_REJECTED;
        case $c0722d30b1d17141$export$61182a0b21436b65.ServerUnreachable:
            return $c0722d30b1d17141$export$258d16488300d83f.JOIN_FAILURE;
        default:
            return $c0722d30b1d17141$export$258d16488300d83f.UNKNOWN_REASON;
    }
}
/** convert bigints to numbers preserving undefined values */ function $c0722d30b1d17141$var$bigIntToNumber(value) {
    return value !== undefined ? Number(value) : undefined;
}
/** convert numbers to bigints preserving undefined values */ function $c0722d30b1d17141$var$numberToBigInt(value) {
    return value !== undefined ? BigInt(value) : undefined;
}
function $c0722d30b1d17141$export$1fcfd1ae3646c28c(track) {
    return !!track && !(track instanceof MediaStreamTrack) && track.isLocal;
}
function $c0722d30b1d17141$export$228726644c3d75db(track) {
    return !!track && track.kind == $c0722d30b1d17141$export$13921ac0cc260818.Kind.Audio;
}
function $c0722d30b1d17141$export$372680e3a49e7e3e(track) {
    return !!track && track.kind == $c0722d30b1d17141$export$13921ac0cc260818.Kind.Video;
}
function $c0722d30b1d17141$var$isLocalVideoTrack(track) {
    return $c0722d30b1d17141$export$1fcfd1ae3646c28c(track) && $c0722d30b1d17141$export$372680e3a49e7e3e(track);
}
function $c0722d30b1d17141$var$isLocalAudioTrack(track) {
    return $c0722d30b1d17141$export$1fcfd1ae3646c28c(track) && $c0722d30b1d17141$export$228726644c3d75db(track);
}
function $c0722d30b1d17141$export$8ca21404ed46ab41(track) {
    return !!track && !track.isLocal;
}
function $c0722d30b1d17141$var$isRemotePub(pub) {
    return !!pub && !pub.isLocal;
}
function $c0722d30b1d17141$var$isRemoteVideoTrack(track) {
    return $c0722d30b1d17141$export$8ca21404ed46ab41(track) && $c0722d30b1d17141$export$372680e3a49e7e3e(track);
}
function $c0722d30b1d17141$export$c3f68b5804e192f2(p) {
    return p.isLocal;
}
function $c0722d30b1d17141$export$c811619bfccaaa29(p) {
    return !p.isLocal;
}
function $c0722d30b1d17141$var$splitUtf8(s, n) {
    // adapted from https://stackoverflow.com/a/6043797
    const result = [];
    let encoded = new TextEncoder().encode(s);
    while(encoded.length > n){
        let k = n;
        while(k > 0){
            const byte = encoded[k];
            if (byte !== undefined && (byte & 0xc0) !== 0x80) break;
            k--;
        }
        result.push(encoded.slice(0, k));
        encoded = encoded.slice(k);
    }
    if (encoded.length > 0) result.push(encoded);
    return result;
}
function $c0722d30b1d17141$var$extractMaxAgeFromRequestHeaders(headers) {
    var _a;
    const cacheControl = headers.get('Cache-Control');
    if (cacheControl) {
        const maxAge = (_a = cacheControl.match(/(?:^|[,\s])max-age=(\d+)/)) === null || _a === void 0 ? void 0 : _a[1];
        if (maxAge) return parseInt(maxAge, 10);
    }
    return undefined;
}
function $c0722d30b1d17141$var$isCompressionStreamSupported() {
    return typeof CompressionStream !== 'undefined';
}
function $c0722d30b1d17141$var$createRtcUrl(url, searchParams) {
    let useV0Path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    const v0Url = $c0722d30b1d17141$var$createV0RtcUrl(url, searchParams);
    if (useV0Path) return v0Url;
    else return $c0722d30b1d17141$var$appendUrlPath(v0Url, 'v1');
}
function $c0722d30b1d17141$var$createV0RtcUrl(url, searchParams) {
    const urlObj = new URL($c0722d30b1d17141$var$toWebsocketUrl(url));
    searchParams.forEach((value, key)=>{
        urlObj.searchParams.set(key, value);
    });
    return $c0722d30b1d17141$var$appendUrlPath(urlObj, 'rtc');
}
function $c0722d30b1d17141$var$createValidateUrl(rtcWsUrl) {
    const urlObj = new URL($c0722d30b1d17141$var$toHttpUrl(rtcWsUrl));
    return $c0722d30b1d17141$var$appendUrlPath(urlObj, 'validate');
}
function $c0722d30b1d17141$var$ensureTrailingSlash(path) {
    return path.endsWith('/') ? path : "".concat(path, "/");
}
function $c0722d30b1d17141$var$appendUrlPath(urlObj, path) {
    urlObj.pathname = "".concat($c0722d30b1d17141$var$ensureTrailingSlash(urlObj.pathname)).concat(path);
    return urlObj;
}
function $c0722d30b1d17141$var$parseSignalResponse(value) {
    if (typeof value === 'string') return $c0722d30b1d17141$var$SignalResponse.fromJson(JSON.parse(value), {
        ignoreUnknownFields: true
    });
    else if (value instanceof ArrayBuffer) return $c0722d30b1d17141$var$SignalResponse.fromBinary(new Uint8Array(value));
    throw new Error("could not decode websocket message: ".concat(typeof value));
}
function $c0722d30b1d17141$var$getAbortReasonAsString(signal) {
    let defaultMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Unknown reason';
    if (!(signal instanceof AbortSignal)) return defaultMessage;
    const reason = signal.reason;
    switch(typeof reason){
        case 'string':
            return reason;
        case 'object':
            return reason instanceof Error ? reason.message : defaultMessage;
        default:
            return 'toString' in reason ? reason.toString() : defaultMessage;
    }
}
const $c0722d30b1d17141$var$ENCRYPTION_ALGORITHM = 'AES-GCM';
// How many consecutive frames can fail decrypting before a particular key gets marked as invalid
const $c0722d30b1d17141$var$DECRYPTION_FAILURE_TOLERANCE = 10;
// flag set to indicate that e2ee has been setup for sender/receiver;
const $c0722d30b1d17141$var$E2EE_FLAG = 'lk_e2ee';
const $c0722d30b1d17141$var$SALT = 'LKFrameEncryptionKey';
const $c0722d30b1d17141$var$KEY_PROVIDER_DEFAULTS = {
    sharedKey: false,
    ratchetSalt: $c0722d30b1d17141$var$SALT,
    ratchetWindowSize: 8,
    failureTolerance: $c0722d30b1d17141$var$DECRYPTION_FAILURE_TOLERANCE,
    keyringSize: 16,
    keySize: 128
};
var $c0722d30b1d17141$export$432ceae3bd7b5ad3;
(function(KeyProviderEvent) {
    KeyProviderEvent["SetKey"] = "setKey";
    /** Event for requesting to ratchet the key used to encrypt the stream */ KeyProviderEvent["RatchetRequest"] = "ratchetRequest";
    /** Emitted when a key is ratcheted. Could be after auto-ratcheting on decryption failure or
   *  following a `RatchetRequest`, will contain the ratcheted key material */ KeyProviderEvent["KeyRatcheted"] = "keyRatcheted";
})($c0722d30b1d17141$export$432ceae3bd7b5ad3 || ($c0722d30b1d17141$export$432ceae3bd7b5ad3 = {}));
var $c0722d30b1d17141$export$6da6bc56147fd1ba;
(function(KeyHandlerEvent) {
    /** Emitted when a key has been ratcheted. Is emitted when any key has been ratcheted
   * i.e. when the FrameCryptor tried to ratchet when decryption is failing  */ KeyHandlerEvent["KeyRatcheted"] = "keyRatcheted";
})($c0722d30b1d17141$export$6da6bc56147fd1ba || ($c0722d30b1d17141$export$6da6bc56147fd1ba = {}));
var $c0722d30b1d17141$export$36ec54aef832f50f;
(function(EncryptionEvent) {
    EncryptionEvent["ParticipantEncryptionStatusChanged"] = "participantEncryptionStatusChanged";
    EncryptionEvent["EncryptionError"] = "encryptionError";
})($c0722d30b1d17141$export$36ec54aef832f50f || ($c0722d30b1d17141$export$36ec54aef832f50f = {}));
var $c0722d30b1d17141$export$d8fa3f6f75909dd5;
(function(CryptorEvent) {
    CryptorEvent["Error"] = "cryptorError";
})($c0722d30b1d17141$export$d8fa3f6f75909dd5 || ($c0722d30b1d17141$export$d8fa3f6f75909dd5 = {}));
function $c0722d30b1d17141$export$2c53d20185b28316() {
    return $c0722d30b1d17141$export$426a96d741bc81b() || $c0722d30b1d17141$export$6bf50ac7ca24af81();
}
function $c0722d30b1d17141$export$6bf50ac7ca24af81() {
    // @ts-ignore
    return typeof window.RTCRtpScriptTransform !== 'undefined';
}
function $c0722d30b1d17141$export$426a96d741bc81b() {
    return typeof window.RTCRtpSender !== 'undefined' && // @ts-ignore
    typeof window.RTCRtpSender.prototype.createEncodedStreams !== 'undefined';
}
function $c0722d30b1d17141$export$4fe547020d3f319b(frame) {
    return 'type' in frame;
}
function $c0722d30b1d17141$export$16dc620a3833b13a(keyBytes_1) {
    return $c0722d30b1d17141$var$__awaiter(this, arguments, void 0, function(keyBytes) {
        let algorithm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            name: $c0722d30b1d17141$var$ENCRYPTION_ALGORITHM
        };
        let usage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'encrypt';
        return function*() {
            // https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/importKey
            return crypto.subtle.importKey('raw', keyBytes, algorithm, false, usage === 'derive' ? [
                'deriveBits',
                'deriveKey'
            ] : [
                'encrypt',
                'decrypt'
            ]);
        }();
    });
}
function $c0722d30b1d17141$export$cbc2841706abbbeb(password) {
    return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
        let enc = new TextEncoder();
        const keyMaterial = yield crypto.subtle.importKey('raw', enc.encode(password), {
            name: 'PBKDF2'
        }, false, [
            'deriveBits',
            'deriveKey'
        ]);
        return keyMaterial;
    });
}
function $c0722d30b1d17141$export$46032788f1602f4b(cryptoBuffer) {
    return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
        const keyMaterial = yield crypto.subtle.importKey('raw', cryptoBuffer, 'HKDF', false, [
            'deriveBits',
            'deriveKey'
        ]);
        return keyMaterial;
    });
}
function $c0722d30b1d17141$var$getAlgoOptions(algorithmName, salt) {
    const textEncoder = new TextEncoder();
    const encodedSalt = textEncoder.encode(salt);
    switch(algorithmName){
        case 'HKDF':
            return {
                name: 'HKDF',
                salt: encodedSalt,
                hash: 'SHA-256',
                info: new ArrayBuffer(128)
            };
        case 'PBKDF2':
            return {
                name: 'PBKDF2',
                salt: encodedSalt,
                hash: 'SHA-256',
                iterations: 100000
            };
        default:
            throw new Error("algorithm ".concat(algorithmName, " is currently unsupported"));
    }
}
/**
 * Derives a set of keys from the master key.
 * See https://tools.ietf.org/html/draft-omara-sframe-00#section-4.3.1
 */ function $c0722d30b1d17141$export$463e47238031f308(material, options) {
    return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
        const algorithmOptions = $c0722d30b1d17141$var$getAlgoOptions(material.algorithm.name, options.ratchetSalt);
        // https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/deriveKey#HKDF
        // https://developer.mozilla.org/en-US/docs/Web/API/HkdfParams
        const encryptionKey = yield crypto.subtle.deriveKey(algorithmOptions, material, {
            name: $c0722d30b1d17141$var$ENCRYPTION_ALGORITHM,
            length: options.keySize
        }, false, [
            'encrypt',
            'decrypt'
        ]);
        return {
            material: material,
            encryptionKey: encryptionKey
        };
    });
}
function $c0722d30b1d17141$export$5dfa89fd21efb3f9() {
    return window.crypto.getRandomValues(new Uint8Array(32));
}
/**
 * Ratchets a key. See
 * https://tools.ietf.org/html/draft-omara-sframe-00#section-4.3.5.1
 */ function $c0722d30b1d17141$export$90588bff5e15163b(material, salt) {
    return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
        const algorithmOptions = $c0722d30b1d17141$var$getAlgoOptions(material.algorithm.name, salt);
        // https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/deriveBits
        return crypto.subtle.deriveBits(algorithmOptions, material, 256);
    });
}
function $c0722d30b1d17141$export$8e8c01dabc426c6(frameData) {
    for(var i = 0; i < frameData.length - 3; i++){
        if (frameData[i] == 0 && frameData[i + 1] == 0 && frameData[i + 2] == 3) return true;
    }
    return false;
}
function $c0722d30b1d17141$export$54fa041aa1c6dee7(stream) {
    const dataOut = [];
    var length = stream.length;
    for(var i = 0; i < stream.length;)// Be careful about over/underflow here. byte_length_ - 3 can underflow, and
    // i + 3 can overflow, but byte_length_ - i can't, because i < byte_length_
    // above, and that expression will produce the number of bytes left in
    // the stream including the byte at i.
    if (length - i >= 3 && !stream[i] && !stream[i + 1] && stream[i + 2] == 3) {
        // Two rbsp bytes.
        dataOut.push(stream[i++]);
        dataOut.push(stream[i++]);
        // Skip the emulation byte.
        i++;
    } else // Single rbsp byte.
    dataOut.push(stream[i++]);
    return new Uint8Array(dataOut);
}
const $c0722d30b1d17141$var$kZerosInStartSequence = 2;
const $c0722d30b1d17141$var$kEmulationByte = 3;
function $c0722d30b1d17141$export$ae76453e7ef39fac(data_in) {
    const dataOut = [];
    var numConsecutiveZeros = 0;
    for(var i = 0; i < data_in.length; ++i){
        var byte = data_in[i];
        if (byte <= $c0722d30b1d17141$var$kEmulationByte && numConsecutiveZeros >= $c0722d30b1d17141$var$kZerosInStartSequence) {
            // Need to escape.
            dataOut.push($c0722d30b1d17141$var$kEmulationByte);
            numConsecutiveZeros = 0;
        }
        dataOut.push(byte);
        if (byte == 0) ++numConsecutiveZeros;
        else numConsecutiveZeros = 0;
    }
    return new Uint8Array(dataOut);
}
function $c0722d30b1d17141$export$d13ff619c22cbf06(packet) {
    var _a, _b, _c, _d, _e;
    if (((_a = packet.value) === null || _a === void 0 ? void 0 : _a.case) !== 'sipDtmf' && ((_b = packet.value) === null || _b === void 0 ? void 0 : _b.case) !== 'metrics' && ((_c = packet.value) === null || _c === void 0 ? void 0 : _c.case) !== 'speaker' && ((_d = packet.value) === null || _d === void 0 ? void 0 : _d.case) !== 'transcription' && ((_e = packet.value) === null || _e === void 0 ? void 0 : _e.case) !== 'encryptedPacket') return new $c0722d30b1d17141$var$EncryptedPacketPayload({
        value: packet.value
    });
    return undefined;
} /**
 * @experimental
 */ 
class $c0722d30b1d17141$export$c4dd488dad1b29ec extends $c0722d30b1d17141$var$eventsExports.EventEmitter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        super();
        this.latestManuallySetKeyIndex = 0;
        /**
     * Callback being invoked after a key has been ratcheted.
     * Can happen when:
     * - A decryption failure occurs and the key is auto-ratcheted
     * - A ratchet request is sent (see {@link ratchetKey()})
     * @param ratchetResult Contains the ratcheted chain key (exportable to other participants) and the derived new key material.
     * @param participantId
     * @param keyIndex
     */ this.onKeyRatcheted = (ratchetResult, participantId, keyIndex)=>{
            $c0722d30b1d17141$var$livekitLogger.debug('key ratcheted event received', {
                ratchetResult: ratchetResult,
                participantId: participantId,
                keyIndex: keyIndex
            });
        };
        this.keyInfoMap = new Map();
        this.options = Object.assign(Object.assign({}, $c0722d30b1d17141$var$KEY_PROVIDER_DEFAULTS), options);
        this.on($c0722d30b1d17141$export$432ceae3bd7b5ad3.KeyRatcheted, this.onKeyRatcheted);
    }
    /**
   * callback to invoke once a key has been set for a participant
   * @param key
   * @param participantIdentity
   * @param keyIndex
   */ onSetEncryptionKey(key, participantIdentity, keyIndex) {
        const keyInfo = {
            key: key,
            participantIdentity: participantIdentity,
            keyIndex: keyIndex
        };
        if (!this.options.sharedKey && !participantIdentity) throw new Error('participant identity needs to be passed for encryption key if sharedKey option is false');
        this.keyInfoMap.set("".concat(participantIdentity !== null && participantIdentity !== void 0 ? participantIdentity : 'shared', "-").concat(keyIndex !== null && keyIndex !== void 0 ? keyIndex : 0), keyInfo);
        if (keyIndex !== undefined) this.latestManuallySetKeyIndex = keyIndex;
        this.emit($c0722d30b1d17141$export$432ceae3bd7b5ad3.SetKey, keyInfo, keyIndex !== undefined);
    }
    getKeys() {
        return Array.from(this.keyInfoMap.values());
    }
    getLatestManuallySetKeyIndex() {
        return this.latestManuallySetKeyIndex;
    }
    getOptions() {
        return this.options;
    }
    ratchetKey(participantIdentity, keyIndex) {
        this.emit($c0722d30b1d17141$export$432ceae3bd7b5ad3.RatchetRequest, participantIdentity, keyIndex);
    }
}
/**
 * A basic KeyProvider implementation intended for a single shared
 * passphrase between all participants
 * @experimental
 */ class $c0722d30b1d17141$export$e4a829d2658cfe97 extends $c0722d30b1d17141$export$c4dd488dad1b29ec {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const opts = Object.assign(Object.assign({}, options), {
            sharedKey: true,
            // for a shared key provider failing to decrypt for a specific participant
            // should not mark the key as invalid, so we accept wrong keys forever
            // and won't try to auto-ratchet
            ratchetWindowSize: 0,
            failureTolerance: -1
        });
        super(opts);
    }
    /**
   * Accepts a passphrase that's used to create the crypto keys.
   * When passing in a string, PBKDF2 is used. (recommended for maximum compatibility across SDKs)
   * When passing in an ArrayBuffer of cryptographically random numbers, HKDF is used.
   *
   * Note: Not all client SDKS support HKDF.
   * @param key
   */ setKey(key) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            const derivedKey = typeof key === 'string' ? yield $c0722d30b1d17141$export$cbc2841706abbbeb(key) : yield $c0722d30b1d17141$export$46032788f1602f4b(key);
            this.onSetEncryptionKey(derivedKey);
        });
    }
}
var $c0722d30b1d17141$export$9ce65eca7a94c890;
(function(CryptorErrorReason) {
    CryptorErrorReason[CryptorErrorReason["InvalidKey"] = 0] = "InvalidKey";
    CryptorErrorReason[CryptorErrorReason["MissingKey"] = 1] = "MissingKey";
    CryptorErrorReason[CryptorErrorReason["InternalError"] = 2] = "InternalError";
})($c0722d30b1d17141$export$9ce65eca7a94c890 || ($c0722d30b1d17141$export$9ce65eca7a94c890 = {}));
class $c0722d30b1d17141$export$94d1ae2d97ba1565 extends $c0722d30b1d17141$export$d7a71bcd3a009497 {
    constructor(message){
        let reason = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $c0722d30b1d17141$export$9ce65eca7a94c890.InternalError;
        let participantIdentity = arguments.length > 2 ? arguments[2] : undefined;
        super(40, message);
        this.reason = reason;
        this.participantIdentity = participantIdentity;
    }
} /**
 * @experimental
 */ 
class $c0722d30b1d17141$var$E2EEManager extends $c0722d30b1d17141$var$eventsExports.EventEmitter {
    constructor(options, dcEncryptionEnabled){
        super();
        this.decryptDataRequests = new Map();
        this.encryptDataRequests = new Map();
        this.onWorkerMessage = (ev)=>{
            var _a, _b;
            const { kind: kind, data: data } = ev.data;
            switch(kind){
                case 'error':
                    $c0722d30b1d17141$var$livekitLogger.error(data.error.message);
                    // If error has uuid, it's from an async operation (encrypt/decrypt)
                    // Reject the corresponding future
                    if (data.uuid) {
                        const decryptFuture = this.decryptDataRequests.get(data.uuid);
                        if (decryptFuture === null || decryptFuture === void 0 ? void 0 : decryptFuture.reject) {
                            decryptFuture.reject(data.error);
                            break; // Don't emit general error if it's handled by future
                        }
                        const encryptFuture = this.encryptDataRequests.get(data.uuid);
                        if (encryptFuture === null || encryptFuture === void 0 ? void 0 : encryptFuture.reject) {
                            encryptFuture.reject(data.error);
                            break; // Don't emit general error if it's handled by future
                        }
                    }
                    // Emit general error event for unhandled errors
                    this.emit($c0722d30b1d17141$export$36ec54aef832f50f.EncryptionError, data.error, data.participantIdentity);
                    break;
                case 'initAck':
                    if (data.enabled) this.keyProvider.getKeys().forEach((keyInfo)=>{
                        this.postKey(keyInfo, false);
                    });
                    break;
                case 'enable':
                    if (data.enabled) this.keyProvider.getKeys().forEach((keyInfo)=>{
                        this.postKey(keyInfo, false);
                    });
                    if (this.encryptionEnabled !== data.enabled && data.participantIdentity === ((_a = this.room) === null || _a === void 0 ? void 0 : _a.localParticipant.identity)) {
                        this.emit($c0722d30b1d17141$export$36ec54aef832f50f.ParticipantEncryptionStatusChanged, data.enabled, this.room.localParticipant);
                        this.encryptionEnabled = data.enabled;
                    } else if (data.participantIdentity) {
                        const participant = (_b = this.room) === null || _b === void 0 ? void 0 : _b.getParticipantByIdentity(data.participantIdentity);
                        if (!participant) throw TypeError("couldn't set encryption status, participant not found".concat(data.participantIdentity));
                        this.emit($c0722d30b1d17141$export$36ec54aef832f50f.ParticipantEncryptionStatusChanged, data.enabled, participant);
                    }
                    break;
                case 'ratchetKey':
                    this.keyProvider.emit($c0722d30b1d17141$export$432ceae3bd7b5ad3.KeyRatcheted, data.ratchetResult, data.participantIdentity, data.keyIndex);
                    break;
                case 'decryptDataResponse':
                    const decryptFuture = this.decryptDataRequests.get(data.uuid);
                    if (decryptFuture === null || decryptFuture === void 0 ? void 0 : decryptFuture.resolve) decryptFuture.resolve(data);
                    break;
                case 'encryptDataResponse':
                    const encryptFuture = this.encryptDataRequests.get(data.uuid);
                    if (encryptFuture === null || encryptFuture === void 0 ? void 0 : encryptFuture.resolve) encryptFuture.resolve(data);
                    break;
            }
        };
        this.onWorkerError = (ev)=>{
            $c0722d30b1d17141$var$livekitLogger.error('e2ee worker encountered an error:', {
                error: ev.error
            });
            this.emit($c0722d30b1d17141$export$36ec54aef832f50f.EncryptionError, ev.error, undefined);
        };
        this.keyProvider = options.keyProvider;
        this.worker = options.worker;
        this.encryptionEnabled = false;
        this.dataChannelEncryptionEnabled = dcEncryptionEnabled;
    }
    get isEnabled() {
        return this.encryptionEnabled;
    }
    get isDataChannelEncryptionEnabled() {
        return this.isEnabled && this.dataChannelEncryptionEnabled;
    }
    /**
   * @internal
   */ setup(room) {
        if (!$c0722d30b1d17141$export$2c53d20185b28316()) throw new $c0722d30b1d17141$export$38c5ac268e2fa84('tried to setup end-to-end encryption on an unsupported browser');
        $c0722d30b1d17141$var$livekitLogger.info('setting up e2ee');
        if (room !== this.room) {
            this.room = room;
            this.setupEventListeners(room, this.keyProvider);
            // this.worker = new Worker('');
            const msg = {
                kind: 'init',
                data: {
                    keyProviderOptions: this.keyProvider.getOptions(),
                    loglevel: $c0722d30b1d17141$var$workerLogger.getLevel()
                }
            };
            if (this.worker) {
                $c0722d30b1d17141$var$livekitLogger.info("initializing worker", {
                    worker: this.worker
                });
                this.worker.onmessage = this.onWorkerMessage;
                this.worker.onerror = this.onWorkerError;
                this.worker.postMessage(msg);
            }
        }
    }
    /**
   * @internal
   */ setParticipantCryptorEnabled(enabled, participantIdentity) {
        $c0722d30b1d17141$var$livekitLogger.debug("set e2ee to ".concat(enabled, " for participant ").concat(participantIdentity));
        this.postEnable(enabled, participantIdentity);
    }
    /**
   * @internal
   */ setSifTrailer(trailer) {
        if (!trailer || trailer.length === 0) $c0722d30b1d17141$var$livekitLogger.warn("ignoring server sent trailer as it's empty");
        else this.postSifTrailer(trailer);
    }
    setupEngine(engine) {
        engine.on($c0722d30b1d17141$export$c09e63b8572f869.RTPVideoMapUpdate, (rtpMap)=>{
            this.postRTPMap(rtpMap);
        });
    }
    setupEventListeners(room, keyProvider) {
        room.on($c0722d30b1d17141$export$3159c672e3b2293a.TrackPublished, (pub, participant)=>this.setParticipantCryptorEnabled(pub.trackInfo.encryption !== $c0722d30b1d17141$export$1efc488791285f20.NONE, participant.identity));
        room.on($c0722d30b1d17141$export$3159c672e3b2293a.ConnectionStateChanged, (state)=>{
            if (state === $c0722d30b1d17141$export$cd9c3c6bf535afc9.Connected) room.remoteParticipants.forEach((participant)=>{
                participant.trackPublications.forEach((pub)=>{
                    this.setParticipantCryptorEnabled(pub.trackInfo.encryption !== $c0722d30b1d17141$export$1efc488791285f20.NONE, participant.identity);
                });
            });
        }).on($c0722d30b1d17141$export$3159c672e3b2293a.TrackUnsubscribed, (track, _, participant)=>{
            var _a;
            const msg = {
                kind: 'removeTransform',
                data: {
                    participantIdentity: participant.identity,
                    trackId: track.mediaStreamID
                }
            };
            (_a = this.worker) === null || _a === void 0 || _a.postMessage(msg);
        }).on($c0722d30b1d17141$export$3159c672e3b2293a.TrackSubscribed, (track, pub, participant)=>{
            this.setupE2EEReceiver(track, participant.identity, pub.trackInfo);
        }).on($c0722d30b1d17141$export$3159c672e3b2293a.SignalConnected, ()=>{
            if (!this.room) throw new TypeError("expected room to be present on signal connect");
            const latestKeyIndex = keyProvider.getLatestManuallySetKeyIndex();
            keyProvider.getKeys().forEach((keyInfo)=>{
                var _a;
                this.postKey(keyInfo, latestKeyIndex === ((_a = keyInfo.keyIndex) !== null && _a !== void 0 ? _a : 0));
            });
            this.setParticipantCryptorEnabled(this.room.localParticipant.isE2EEEnabled, this.room.localParticipant.identity);
        });
        room.localParticipant.on($c0722d30b1d17141$export$fcdfe2b7a6750691.LocalSenderCreated, (sender, track)=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                this.setupE2EESender(track, sender);
            }));
        room.localParticipant.on($c0722d30b1d17141$export$fcdfe2b7a6750691.LocalTrackPublished, (publication)=>{
            // Safari doesn't support retrieving payload information on RTCEncodedVideoFrame, so we need to update the codec manually once we have the trackInfo from the server
            if (!$c0722d30b1d17141$export$372680e3a49e7e3e(publication.track) || !$c0722d30b1d17141$var$isSafariBased()) return;
            const msg = {
                kind: 'updateCodec',
                data: {
                    trackId: publication.track.mediaStreamID,
                    codec: $c0722d30b1d17141$var$mimeTypeToVideoCodecString(publication.trackInfo.codecs[0].mimeType),
                    participantIdentity: this.room.localParticipant.identity
                }
            };
            this.worker.postMessage(msg);
        });
        keyProvider.on($c0722d30b1d17141$export$432ceae3bd7b5ad3.SetKey, (keyInfo, updateCurrentKeyIndex)=>this.postKey(keyInfo, updateCurrentKeyIndex !== null && updateCurrentKeyIndex !== void 0 ? updateCurrentKeyIndex : true)).on($c0722d30b1d17141$export$432ceae3bd7b5ad3.RatchetRequest, (participantId, keyIndex)=>this.postRatchetRequest(participantId, keyIndex));
    }
    encryptData(data) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.worker) throw Error('could not encrypt data, worker is missing');
            const uuid = crypto.randomUUID();
            const msg = {
                kind: 'encryptDataRequest',
                data: {
                    uuid: uuid,
                    payload: data,
                    participantIdentity: this.room.localParticipant.identity
                }
            };
            const future = new $c0722d30b1d17141$var$Future();
            future.onFinally = ()=>{
                this.encryptDataRequests.delete(uuid);
            };
            this.encryptDataRequests.set(uuid, future);
            this.worker.postMessage(msg);
            return future.promise;
        });
    }
    handleEncryptedData(payload, iv, participantIdentity, keyIndex) {
        if (!this.worker) throw Error('could not handle encrypted data, worker is missing');
        const uuid = crypto.randomUUID();
        const msg = {
            kind: 'decryptDataRequest',
            data: {
                uuid: uuid,
                payload: payload,
                iv: iv,
                participantIdentity: participantIdentity,
                keyIndex: keyIndex
            }
        };
        const future = new $c0722d30b1d17141$var$Future();
        future.onFinally = ()=>{
            this.decryptDataRequests.delete(uuid);
        };
        this.decryptDataRequests.set(uuid, future);
        this.worker.postMessage(msg);
        return future.promise;
    }
    postRatchetRequest(participantIdentity, keyIndex) {
        if (!this.worker) throw Error('could not ratchet key, worker is missing');
        const msg = {
            kind: 'ratchetRequest',
            data: {
                participantIdentity: participantIdentity,
                keyIndex: keyIndex
            }
        };
        this.worker.postMessage(msg);
    }
    postKey(_ref, updateCurrentKeyIndex) {
        let { key: key, participantIdentity: participantIdentity, keyIndex: keyIndex } = _ref;
        var _a;
        if (!this.worker) throw Error('could not set key, worker is missing');
        const msg = {
            kind: 'setKey',
            data: {
                participantIdentity: participantIdentity,
                isPublisher: participantIdentity === ((_a = this.room) === null || _a === void 0 ? void 0 : _a.localParticipant.identity),
                key: key,
                keyIndex: keyIndex,
                updateCurrentKeyIndex: updateCurrentKeyIndex
            }
        };
        this.worker.postMessage(msg);
    }
    postEnable(enabled, participantIdentity) {
        if (this.worker) {
            const enableMsg = {
                kind: 'enable',
                data: {
                    enabled: enabled,
                    participantIdentity: participantIdentity
                }
            };
            this.worker.postMessage(enableMsg);
        } else throw new ReferenceError('failed to enable e2ee, worker is not ready');
    }
    postRTPMap(map) {
        var _a;
        if (!this.worker) throw TypeError('could not post rtp map, worker is missing');
        if (!((_a = this.room) === null || _a === void 0 ? void 0 : _a.localParticipant.identity)) throw TypeError('could not post rtp map, local participant identity is missing');
        const msg = {
            kind: 'setRTPMap',
            data: {
                map: map,
                participantIdentity: this.room.localParticipant.identity
            }
        };
        this.worker.postMessage(msg);
    }
    postSifTrailer(trailer) {
        if (!this.worker) throw Error('could not post SIF trailer, worker is missing');
        const msg = {
            kind: 'setSifTrailer',
            data: {
                trailer: trailer
            }
        };
        this.worker.postMessage(msg);
    }
    setupE2EEReceiver(track, remoteId, trackInfo) {
        if (!track.receiver) return;
        if (!(trackInfo === null || trackInfo === void 0 ? void 0 : trackInfo.mimeType) || trackInfo.mimeType === '') throw new TypeError('MimeType missing from trackInfo, cannot set up E2EE cryptor');
        this.handleReceiver(track.receiver, track.mediaStreamID, remoteId, track.kind === 'video' ? $c0722d30b1d17141$var$mimeTypeToVideoCodecString(trackInfo.mimeType) : undefined);
    }
    setupE2EESender(track, sender) {
        if (!$c0722d30b1d17141$export$1fcfd1ae3646c28c(track) || !sender) {
            if (!sender) $c0722d30b1d17141$var$livekitLogger.warn('early return because sender is not ready');
            return;
        }
        this.handleSender(sender, track.mediaStreamID, undefined);
    }
    /**
   * Handles the given {@code RTCRtpReceiver} by creating a {@code TransformStream} which will inject
   * a frame decoder.
   *
   */ handleReceiver(receiver, trackId, participantIdentity, codec) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.worker) return;
            if ($c0722d30b1d17141$export$6bf50ac7ca24af81() && // Chrome occasionally throws an `InvalidState` error when using script transforms directly after introducing this API in 141.
            // Disabling it for Chrome based browsers until the API has stabilized
            !$c0722d30b1d17141$var$isChromiumBased()) {
                const options = {
                    kind: 'decode',
                    participantIdentity: participantIdentity,
                    trackId: trackId,
                    codec: codec
                };
                // @ts-ignore
                receiver.transform = new RTCRtpScriptTransform(this.worker, options);
            } else {
                if ($c0722d30b1d17141$var$E2EE_FLAG in receiver && codec) {
                    // only update codec
                    const msg = {
                        kind: 'updateCodec',
                        data: {
                            trackId: trackId,
                            codec: codec,
                            participantIdentity: participantIdentity
                        }
                    };
                    this.worker.postMessage(msg);
                    return;
                }
                // @ts-ignore
                let writable = receiver.writableStream;
                // @ts-ignore
                let readable = receiver.readableStream;
                if (!writable || !readable) {
                    // @ts-ignore
                    const receiverStreams = receiver.createEncodedStreams();
                    // @ts-ignore
                    receiver.writableStream = receiverStreams.writable;
                    writable = receiverStreams.writable;
                    // @ts-ignore
                    receiver.readableStream = receiverStreams.readable;
                    readable = receiverStreams.readable;
                }
                const msg = {
                    kind: 'decode',
                    data: {
                        readableStream: readable,
                        writableStream: writable,
                        trackId: trackId,
                        codec: codec,
                        participantIdentity: participantIdentity,
                        isReuse: $c0722d30b1d17141$var$E2EE_FLAG in receiver
                    }
                };
                this.worker.postMessage(msg, [
                    readable,
                    writable
                ]);
            }
            // @ts-ignore
            receiver[$c0722d30b1d17141$var$E2EE_FLAG] = true;
        });
    }
    /**
   * Handles the given {@code RTCRtpSender} by creating a {@code TransformStream} which will inject
   * a frame encoder.
   *
   */ handleSender(sender, trackId, codec) {
        var _a;
        if ($c0722d30b1d17141$var$E2EE_FLAG in sender || !this.worker) return;
        if (!((_a = this.room) === null || _a === void 0 ? void 0 : _a.localParticipant.identity) || this.room.localParticipant.identity === '') throw TypeError('local identity needs to be known in order to set up encrypted sender');
        if ($c0722d30b1d17141$export$6bf50ac7ca24af81() && // Chrome occasionally throws an `InvalidState` error when using script transforms directly after introducing this API in 141.
        // Disabling it for Chrome based browsers until the API has stabilized
        !$c0722d30b1d17141$var$isChromiumBased()) {
            $c0722d30b1d17141$var$livekitLogger.info('initialize script transform');
            const options = {
                kind: 'encode',
                participantIdentity: this.room.localParticipant.identity,
                trackId: trackId,
                codec: codec
            };
            // @ts-ignore
            sender.transform = new RTCRtpScriptTransform(this.worker, options);
        } else {
            $c0722d30b1d17141$var$livekitLogger.info('initialize encoded streams');
            // @ts-ignore
            const senderStreams = sender.createEncodedStreams();
            const msg = {
                kind: 'encode',
                data: {
                    readableStream: senderStreams.readable,
                    writableStream: senderStreams.writable,
                    codec: codec,
                    trackId: trackId,
                    participantIdentity: this.room.localParticipant.identity,
                    isReuse: false
                }
            };
            this.worker.postMessage(msg, [
                senderStreams.readable,
                senderStreams.writable
            ]);
        }
        // @ts-ignore
        sender[$c0722d30b1d17141$var$E2EE_FLAG] = true;
    }
}
const $c0722d30b1d17141$var$CONNECTION_BACKOFF_MIN_MS = 500;
const $c0722d30b1d17141$var$CONNECTION_BACKOFF_MAX_MS = 15000;
/**
 * BackOffStrategy implements exponential backoff for connection failures.
 *
 * When severe connection failures occur (e.g., network issues, server unavailability),
 * this strategy introduces increasing delays between reconnection attempts to avoid
 * overwhelming the server and to give transient issues time to resolve.
 *
 * This strategy is only applied to LiveKit Cloud projects. It identifies
 * projects by extracting the project name from the connection URL and tracks failures
 * per project. Self-hosted deployments (URLs without a project identifier) are not
 * subject to backoff delays.
 *
 * The class is implemented as a singleton to maintain consistent backoff state across
 * the entire application lifecycle instead of room instance lifecycle.
 */ class $c0722d30b1d17141$var$BackOffStrategy {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    constructor(){
        this.failedConnectionAttempts = new Map();
        this.backOffPromises = new Map();
    }
    static getInstance() {
        if (!this._instance) this._instance = new $c0722d30b1d17141$var$BackOffStrategy();
        return this._instance;
    }
    addFailedConnectionAttempt(urlString) {
        var _a;
        const url = new URL(urlString);
        const projectName = $c0722d30b1d17141$var$extractProjectFromUrl(url);
        if (!projectName) return;
        let failureCount = (_a = this.failedConnectionAttempts.get(projectName)) !== null && _a !== void 0 ? _a : 0;
        this.failedConnectionAttempts.set(projectName, failureCount + 1);
        this.backOffPromises.set(projectName, $c0722d30b1d17141$var$sleep(Math.min($c0722d30b1d17141$var$CONNECTION_BACKOFF_MIN_MS * Math.pow(2, failureCount), $c0722d30b1d17141$var$CONNECTION_BACKOFF_MAX_MS)));
    }
    getBackOffPromise(urlString) {
        const url = new URL(urlString);
        const projectName = url && $c0722d30b1d17141$var$extractProjectFromUrl(url);
        const backoffPromise = projectName && this.backOffPromises.get(projectName);
        return backoffPromise || Promise.resolve();
    }
    resetFailedConnectionAttempts(urlString) {
        const url = new URL(urlString);
        const projectName = url && $c0722d30b1d17141$var$extractProjectFromUrl(url);
        if (projectName) {
            this.failedConnectionAttempts.set(projectName, 0);
            this.backOffPromises.set(projectName, Promise.resolve());
        }
    }
    resetAll() {
        this.backOffPromises.clear();
        this.failedConnectionAttempts.clear();
    }
}
$c0722d30b1d17141$var$BackOffStrategy._instance = null;
const $c0722d30b1d17141$var$defaultId = 'default';
class $c0722d30b1d17141$var$DeviceManager {
    constructor(){
        this._previousDevices = [];
    }
    static getInstance() {
        if (this.instance === undefined) this.instance = new $c0722d30b1d17141$var$DeviceManager();
        return this.instance;
    }
    get previousDevices() {
        return this._previousDevices;
    }
    getDevices(kind_1) {
        return $c0722d30b1d17141$var$__awaiter(this, arguments, void 0, function(kind) {
            var _this = this;
            let requestPermissions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            return function*() {
                var _a;
                if (((_a = $c0722d30b1d17141$var$DeviceManager.userMediaPromiseMap) === null || _a === void 0 ? void 0 : _a.size) > 0) {
                    $c0722d30b1d17141$var$livekitLogger.debug('awaiting getUserMedia promise');
                    try {
                        if (kind) yield $c0722d30b1d17141$var$DeviceManager.userMediaPromiseMap.get(kind);
                        else yield Promise.all($c0722d30b1d17141$var$DeviceManager.userMediaPromiseMap.values());
                    } catch (e) {
                        $c0722d30b1d17141$var$livekitLogger.warn('error waiting for media permissons');
                    }
                }
                let devices = yield navigator.mediaDevices.enumerateDevices();
                if (requestPermissions && // for safari we need to skip this check, as otherwise it will re-acquire user media and fail on iOS https://bugs.webkit.org/show_bug.cgi?id=179363
                !($c0722d30b1d17141$var$isSafari() && _this.hasDeviceInUse(kind))) {
                    const isDummyDeviceOrEmpty = devices.filter((d)=>d.kind === kind).length === 0 || devices.some((device)=>{
                        const noLabel = device.label === '';
                        const isRelevant = kind ? device.kind === kind : true;
                        return noLabel && isRelevant;
                    });
                    if (isDummyDeviceOrEmpty) {
                        const permissionsToAcquire = {
                            video: kind !== 'audioinput' && kind !== 'audiooutput',
                            audio: kind !== 'videoinput' && {
                                deviceId: {
                                    ideal: 'default'
                                }
                            }
                        };
                        const stream = yield navigator.mediaDevices.getUserMedia(permissionsToAcquire);
                        devices = yield navigator.mediaDevices.enumerateDevices();
                        stream.getTracks().forEach((track)=>{
                            track.stop();
                        });
                    }
                }
                _this._previousDevices = devices;
                if (kind) devices = devices.filter((device)=>device.kind === kind);
                return devices;
            }();
        });
    }
    normalizeDeviceId(kind, deviceId, groupId) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            if (deviceId !== $c0722d30b1d17141$var$defaultId) return deviceId;
            // resolve actual device id if it's 'default': Chrome returns it when no
            // device has been chosen
            const devices = yield this.getDevices(kind);
            const defaultDevice = devices.find((d)=>d.deviceId === $c0722d30b1d17141$var$defaultId);
            if (!defaultDevice) {
                $c0722d30b1d17141$var$livekitLogger.warn('could not reliably determine default device');
                return undefined;
            }
            const device = devices.find((d)=>d.deviceId !== $c0722d30b1d17141$var$defaultId && d.groupId === (groupId !== null && groupId !== void 0 ? groupId : defaultDevice.groupId));
            if (!device) {
                $c0722d30b1d17141$var$livekitLogger.warn('could not reliably determine default device');
                return undefined;
            }
            return device === null || device === void 0 ? void 0 : device.deviceId;
        });
    }
    hasDeviceInUse(kind) {
        return kind ? $c0722d30b1d17141$var$DeviceManager.userMediaPromiseMap.has(kind) : $c0722d30b1d17141$var$DeviceManager.userMediaPromiseMap.size > 0;
    }
}
$c0722d30b1d17141$var$DeviceManager.mediaDeviceKinds = [
    'audioinput',
    'audiooutput',
    'videoinput'
];
$c0722d30b1d17141$var$DeviceManager.userMediaPromiseMap = new Map();
const $c0722d30b1d17141$var$U16_MAX_SIZE = 0xffff;
const $c0722d30b1d17141$var$U32_MAX_SIZE = 0xffffffff;
/**
 * A number of fields withing the data tracks packet specification assume wrap around behavior when
 * an unsigned type is incremented beyond its max size (ie, the packet `sequence` field). This
 * wrapper type manually reimplements this wrap around behavior given javascript's lack of fixed
 * size integer types.
 */ class $c0722d30b1d17141$var$WrapAroundUnsignedInt {
    static u16(raw) {
        return new $c0722d30b1d17141$var$WrapAroundUnsignedInt(raw, $c0722d30b1d17141$var$U16_MAX_SIZE);
    }
    static u32(raw) {
        return new $c0722d30b1d17141$var$WrapAroundUnsignedInt(raw, $c0722d30b1d17141$var$U32_MAX_SIZE);
    }
    constructor(raw, maxSize){
        this.value = raw;
        if (raw < 0) throw new Error('WrapAroundUnsignedInt: cannot faithfully represent an integer smaller than 0');
        if (maxSize > Number.MAX_SAFE_INTEGER) throw new Error('WrapAroundUnsignedInt: cannot faithfully represent an integer bigger than MAX_SAFE_INTEGER.');
        this.maxSize = maxSize;
        this.clamp();
    }
    /** Manually clamp the given containing value according to the wrap around max size bounds. Use
   * this after out of bounds modification to the contained value by external code. */ clamp() {
        while(this.value > this.maxSize)this.value -= this.maxSize + 1;
        while(this.value < 0)this.value += this.maxSize + 1;
    }
    clone() {
        return new $c0722d30b1d17141$var$WrapAroundUnsignedInt(this.value, this.maxSize);
    }
    /** When called, maps the containing value to a new containing value. After mapping, the wrap
   * around external max size bounds are applied. Note that this is a mutative operation. */ update(updateFn) {
        this.value = updateFn(this.value);
        this.clamp();
    }
    /** Increments the given `n` to the inner value. Note that this is a mutative operation. */ increment() {
        let n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
        this.update((value)=>value + n);
    }
    /** Decrements the given `n` from the inner value. Note that this is a mutative operation. */ decrement() {
        let n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
        this.update((value)=>value - n);
    }
    getThenIncrement() {
        const previousValue = this.value;
        this.increment();
        return new $c0722d30b1d17141$var$WrapAroundUnsignedInt(previousValue, this.maxSize);
    }
    /** Returns true if {@link this} is before the passed other {@link WrapAroundUnsignedInt}. */ isBefore(other) {
        const a = this.value >>> 0;
        const b = other.value >>> 0;
        const diff = b - a >>> 0;
        return diff !== 0 && diff < this.maxSize + 1;
    }
}
class $c0722d30b1d17141$var$DataTrackTimestamp {
    static fromRtpTicks(rtpTicks) {
        return new $c0722d30b1d17141$var$DataTrackTimestamp(rtpTicks, 90000);
    }
    /** Generates a timestamp initialized to a non cryptographically secure random value, so that
   * different streams are more difficult to correlate in packet capture. */ static rtpRandom() {
        const randomValue = Math.round(Math.random() * $c0722d30b1d17141$var$U32_MAX_SIZE);
        return $c0722d30b1d17141$var$DataTrackTimestamp.fromRtpTicks(randomValue);
    }
    constructor(raw, rateInHz){
        this.timestamp = $c0722d30b1d17141$var$WrapAroundUnsignedInt.u32(raw);
        this.rateInHz = rateInHz;
    }
    asTicks() {
        return this.timestamp.value;
    }
    clone() {
        return new $c0722d30b1d17141$var$DataTrackTimestamp(this.timestamp.value, this.rateInHz);
    }
    wrappingAdd(n) {
        this.timestamp.increment(n);
    }
    /** Returns true if {@link this} is before the passed other {@link DataTrackTimestamp}. */ isBefore(other) {
        return this.timestamp.isBefore(other.timestamp);
    }
}
class $c0722d30b1d17141$var$DataTrackClock {
    constructor(rateInHz, epoch, base){
        this.epoch = epoch;
        this.base = base;
        this.previous = base.clone();
        this.rateInHz = rateInHz;
    }
    static startingNow(base, rateInHz) {
        return new $c0722d30b1d17141$var$DataTrackClock(rateInHz, new Date(), base);
    }
    static startingAtTime(epoch, base, rateInHz) {
        return new $c0722d30b1d17141$var$DataTrackClock(rateInHz, epoch, base);
    }
    static rtpStartingNow(base) {
        return $c0722d30b1d17141$var$DataTrackClock.startingNow(base, 90000);
    }
    static rtpStartingAtTime(epoch, base) {
        return $c0722d30b1d17141$var$DataTrackClock.startingAtTime(epoch, base, 90000);
    }
    now() {
        return this.at(new Date());
    }
    at(timestamp) {
        let elapsedMs = timestamp.getTime() - this.epoch.getTime();
        let durationTicks = $c0722d30b1d17141$var$DataTrackClock.durationInMsToTicks(elapsedMs, this.rateInHz);
        let result = this.base.clone();
        result.wrappingAdd(durationTicks);
        // Enforce monotonicity in RTP wraparound space
        if (result.isBefore(this.previous)) result = this.previous;
        this.previous = result.clone();
        return result.clone();
    }
    /** Convert a duration since the epoch into clock ticks. */ static durationInMsToTicks(durationMilliseconds, rateInHz) {
        // round(nanos * rate_hz / 1e9)
        let durationNanoseconds = durationMilliseconds * 1e6;
        let ticks = (durationNanoseconds * rateInHz + 500000000) / 1000000000;
        return Math.round(ticks);
    }
}
function $c0722d30b1d17141$var$coerceToDataView(input) {
    if (input instanceof DataView) return input;
    else if (input instanceof ArrayBuffer) return new DataView(input);
    else if (input instanceof Uint8Array) return new DataView(input.buffer, input.byteOffset, input.byteLength);
    else throw new Error("Error coercing ".concat(input, " to DataView - input was not DataView, ArrayBuffer, or Uint8Array."));
}
var $c0722d30b1d17141$var$DataTrackHandleErrorReason;
(function(DataTrackHandleErrorReason) {
    DataTrackHandleErrorReason[DataTrackHandleErrorReason["Reserved"] = 0] = "Reserved";
    DataTrackHandleErrorReason[DataTrackHandleErrorReason["TooLarge"] = 1] = "TooLarge";
})($c0722d30b1d17141$var$DataTrackHandleErrorReason || ($c0722d30b1d17141$var$DataTrackHandleErrorReason = {}));
class $c0722d30b1d17141$var$DataTrackHandleError extends $c0722d30b1d17141$export$af3f20dcdd5a185f {
    constructor(message, reason){
        super(19, message);
        this.name = 'DataTrackHandleError';
        this.reason = reason;
        this.reasonName = $c0722d30b1d17141$var$DataTrackHandleErrorReason[reason];
    }
    isReason(reason) {
        return this.reason === reason;
    }
    static tooLarge() {
        return new $c0722d30b1d17141$var$DataTrackHandleError('Value too large to be a valid track handle', $c0722d30b1d17141$var$DataTrackHandleErrorReason.TooLarge);
    }
    static reserved(value) {
        return new $c0722d30b1d17141$var$DataTrackHandleError("0x".concat(value.toString(16), " is a reserved value."), $c0722d30b1d17141$var$DataTrackHandleErrorReason.Reserved);
    }
}
const $c0722d30b1d17141$var$DataTrackHandle = {
    fromNumber (raw) {
        if (raw === 0) throw $c0722d30b1d17141$var$DataTrackHandleError.reserved(raw);
        if (raw > $c0722d30b1d17141$var$U16_MAX_SIZE) throw $c0722d30b1d17141$var$DataTrackHandleError.tooLarge();
        return raw;
    }
};
/** Manage allocating new handles which don't conflict over the lifetime of the client. */ class $c0722d30b1d17141$var$DataTrackHandleAllocator {
    constructor(){
        this.value = 0;
    }
    /** Returns a unique track handle for the next publication, if one can be obtained. */ get() {
        this.value += 1;
        if (this.value > $c0722d30b1d17141$var$U16_MAX_SIZE) return null;
        return this.value;
    }
    reset() {
        this.value = 0;
    }
}
const $c0722d30b1d17141$var$DataTrackInfo = {
    from (protocolInfo) {
        return {
            sid: protocolInfo.sid,
            pubHandle: protocolInfo.pubHandle,
            name: protocolInfo.name,
            usesE2ee: protocolInfo.encryption !== $c0722d30b1d17141$export$1efc488791285f20.NONE
        };
    },
    toProtobuf (info) {
        return new $c0722d30b1d17141$var$DataTrackInfo$1({
            sid: info.sid,
            pubHandle: info.pubHandle,
            name: info.name,
            encryption: info.usesE2ee ? $c0722d30b1d17141$export$1efc488791285f20.GCM : $c0722d30b1d17141$export$1efc488791285f20.NONE
        });
    }
};
var $c0722d30b1d17141$var$QueueTaskStatus;
(function(QueueTaskStatus) {
    QueueTaskStatus[QueueTaskStatus["WAITING"] = 0] = "WAITING";
    QueueTaskStatus[QueueTaskStatus["RUNNING"] = 1] = "RUNNING";
    QueueTaskStatus[QueueTaskStatus["COMPLETED"] = 2] = "COMPLETED";
})($c0722d30b1d17141$var$QueueTaskStatus || ($c0722d30b1d17141$var$QueueTaskStatus = {}));
class $c0722d30b1d17141$var$AsyncQueue {
    constructor(){
        this.pendingTasks = new Map();
        this.taskMutex = new $c0722d30b1d17141$export$ca12f2943758ef55();
        this.nextTaskIndex = 0;
    }
    run(task) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            const taskInfo = {
                id: this.nextTaskIndex++,
                enqueuedAt: Date.now(),
                status: $c0722d30b1d17141$var$QueueTaskStatus.WAITING
            };
            this.pendingTasks.set(taskInfo.id, taskInfo);
            const unlock = yield this.taskMutex.lock();
            try {
                taskInfo.executedAt = Date.now();
                taskInfo.status = $c0722d30b1d17141$var$QueueTaskStatus.RUNNING;
                return yield task();
            } finally{
                taskInfo.status = $c0722d30b1d17141$var$QueueTaskStatus.COMPLETED;
                this.pendingTasks.delete(taskInfo.id);
                unlock();
            }
        });
    }
    flush() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            return this.run(()=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {}));
        });
    }
    snapshot() {
        return Array.from(this.pendingTasks.values());
    }
} /**
 * [WebSocket](https://developer.mozilla.org/en-US/docs/Web/API/WebSocket) with [Streams API](https://developer.mozilla.org/en-US/docs/Web/API/Streams_API)
 *
 * @see https://web.dev/websocketstream/
 */ 
class $c0722d30b1d17141$var$WebSocketStream {
    get readyState() {
        return this.ws.readyState;
    }
    constructor(url){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _a, _b;
        if ((_a = options.signal) === null || _a === void 0 ? void 0 : _a.aborted) throw new DOMException('This operation was aborted', 'AbortError');
        this.url = url;
        const ws = new WebSocket(url, (_b = options.protocols) !== null && _b !== void 0 ? _b : []);
        ws.binaryType = 'arraybuffer';
        this.ws = ws;
        const closeWithInfo = function() {
            let { closeCode: code, reason: reason } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            return ws.close(code, reason);
        };
        this.opened = new $c0722d30b1d17141$var$TypedPromise((resolve, reject)=>{
            const rejectHandler = ()=>{
                reject($c0722d30b1d17141$export$a3747c6e46c7a8eb.websocket('Encountered websocket error during connection establishment'));
            };
            ws.onopen = ()=>{
                resolve({
                    readable: new ReadableStream({
                        start (controller) {
                            ws.onmessage = (_ref)=>{
                                let { data: data } = _ref;
                                return controller.enqueue(data);
                            };
                            ws.onerror = (e)=>controller.error(e);
                        },
                        cancel: closeWithInfo
                    }),
                    writable: new WritableStream({
                        write (chunk) {
                            ws.send(chunk);
                        },
                        abort () {
                            ws.close();
                        },
                        close: closeWithInfo
                    }),
                    protocol: ws.protocol,
                    extensions: ws.extensions
                });
                ws.removeEventListener('error', rejectHandler);
            };
            ws.addEventListener('error', rejectHandler);
        });
        this.closed = new $c0722d30b1d17141$var$TypedPromise((resolve, reject)=>{
            const rejectHandler = ()=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                    const closePromise = new $c0722d30b1d17141$var$TypedPromise((res)=>{
                        if (ws.readyState === WebSocket.CLOSED) return;
                        else ws.addEventListener('close', (closeEv)=>{
                            res(closeEv);
                        }, {
                            once: true
                        });
                    });
                    const reason = yield $c0722d30b1d17141$var$TypedPromise.race([
                        $c0722d30b1d17141$var$sleep(250),
                        closePromise
                    ]);
                    if (!reason) reject($c0722d30b1d17141$export$a3747c6e46c7a8eb.websocket('Encountered unspecified websocket error without a timely close event'));
                    else // if we can infer the close reason from the close event then resolve the promise, we don't need to throw
                    resolve(reason);
                });
            ws.onclose = (_ref2)=>{
                let { code: code, reason: reason } = _ref2;
                resolve({
                    closeCode: code,
                    reason: reason
                });
                ws.removeEventListener('error', rejectHandler);
            };
            ws.addEventListener('error', rejectHandler);
        });
        if (options.signal) options.signal.onabort = ()=>ws.close();
        this.close = closeWithInfo;
    }
}
const $c0722d30b1d17141$var$passThroughQueueSignals = [
    'syncState',
    'trickle',
    'offer',
    'answer',
    'simulate',
    'leave'
];
function $c0722d30b1d17141$var$canPassThroughQueue(req) {
    const canPass = $c0722d30b1d17141$var$passThroughQueueSignals.indexOf(req.case) >= 0;
    $c0722d30b1d17141$var$livekitLogger.trace('request allowed to bypass queue:', {
        canPass: canPass,
        req: req
    });
    return canPass;
}
var $c0722d30b1d17141$var$SignalConnectionState;
(function(SignalConnectionState) {
    SignalConnectionState[SignalConnectionState["CONNECTING"] = 0] = "CONNECTING";
    SignalConnectionState[SignalConnectionState["CONNECTED"] = 1] = "CONNECTED";
    SignalConnectionState[SignalConnectionState["RECONNECTING"] = 2] = "RECONNECTING";
    SignalConnectionState[SignalConnectionState["DISCONNECTING"] = 3] = "DISCONNECTING";
    SignalConnectionState[SignalConnectionState["DISCONNECTED"] = 4] = "DISCONNECTED";
})($c0722d30b1d17141$var$SignalConnectionState || ($c0722d30b1d17141$var$SignalConnectionState = {}));
/** specifies how much time (in ms) we allow for the ws to close its connection gracefully before continuing */ const $c0722d30b1d17141$var$MAX_WS_CLOSE_TIME = 250;
/** @internal */ class $c0722d30b1d17141$var$SignalClient {
    get currentState() {
        return this.state;
    }
    get isDisconnected() {
        return this.state === $c0722d30b1d17141$var$SignalConnectionState.DISCONNECTING || this.state === $c0722d30b1d17141$var$SignalConnectionState.DISCONNECTED;
    }
    get isEstablishingConnection() {
        return this.state === $c0722d30b1d17141$var$SignalConnectionState.CONNECTING || this.state === $c0722d30b1d17141$var$SignalConnectionState.RECONNECTING;
    }
    getNextRequestId() {
        this._requestId += 1;
        return this._requestId;
    }
    constructor(){
        let useJSON = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        let loggerOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _a;
        /** signal rtt in milliseconds */ this.rtt = 0;
        this.state = $c0722d30b1d17141$var$SignalConnectionState.DISCONNECTED;
        this.log = $c0722d30b1d17141$var$livekitLogger;
        this._requestId = 0;
        this.useV0SignalPath = false;
        /** @internal */ this.resetCallbacks = ()=>{
            this.onAnswer = undefined;
            this.onLeave = undefined;
            this.onLocalTrackPublished = undefined;
            this.onLocalTrackUnpublished = undefined;
            this.onNegotiateRequested = undefined;
            this.onOffer = undefined;
            this.onRemoteMuteChanged = undefined;
            this.onSubscribedQualityUpdate = undefined;
            this.onTokenRefresh = undefined;
            this.onTrickle = undefined;
            this.onClose = undefined;
            this.onMediaSectionsRequirement = undefined;
        };
        this.loggerContextCb = loggerOptions.loggerContextCb;
        this.log = $c0722d30b1d17141$export$2b1d391cd05230fd((_a = loggerOptions.loggerName) !== null && _a !== void 0 ? _a : $c0722d30b1d17141$export$69ba24dd79f4da21.Signal, ()=>this.logContext);
        this.useJSON = useJSON;
        this.requestQueue = new $c0722d30b1d17141$var$AsyncQueue();
        this.queuedRequests = [];
        this.closingLock = new $c0722d30b1d17141$export$ca12f2943758ef55();
        this.connectionLock = new $c0722d30b1d17141$export$ca12f2943758ef55();
        this.state = $c0722d30b1d17141$var$SignalConnectionState.DISCONNECTED;
    }
    get logContext() {
        var _a, _b;
        return (_b = (_a = this.loggerContextCb) === null || _a === void 0 ? void 0 : _a.call(this)) !== null && _b !== void 0 ? _b : {};
    }
    join(url_1, token_1, opts_1, abortSignal_1) {
        return $c0722d30b1d17141$var$__awaiter(this, arguments, void 0, function(url, token, opts, abortSignal) {
            var _this = this;
            let useV0Path = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
            let publisherOffer = arguments.length > 5 ? arguments[5] : undefined;
            return function*() {
                // during a full reconnect, we'd want to start the sequence even if currently
                // connected
                _this.state = $c0722d30b1d17141$var$SignalConnectionState.CONNECTING;
                _this.options = opts;
                const res = yield _this.connect(url, token, opts, abortSignal, useV0Path, publisherOffer);
                return res;
            }();
        });
    }
    reconnect(url, token, sid, reason) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.options) {
                this.log.warn('attempted to reconnect without signal options being set, ignoring');
                return;
            }
            this.state = $c0722d30b1d17141$var$SignalConnectionState.RECONNECTING;
            // clear ping interval and restart it once reconnected
            this.clearPingInterval();
            const res = yield this.connect(url, token, Object.assign(Object.assign({}, this.options), {
                reconnect: true,
                sid: sid,
                reconnectReason: reason
            }), undefined, this.useV0SignalPath);
            return res;
        });
    }
    connect(url_1, token_1, opts_1, abortSignal_1) {
        return $c0722d30b1d17141$var$__awaiter(this, arguments, void 0, function(url, token, opts, abortSignal) {
            var _this2 = this;
            let useV0Path = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
            let publisherOffer = arguments.length > 5 ? arguments[5] : undefined;
            return function*() {
                const unlock = yield _this2.connectionLock.lock();
                _this2.connectOptions = opts;
                _this2.useV0SignalPath = useV0Path;
                const clientInfo = $c0722d30b1d17141$var$getClientInfo();
                const params = useV0Path ? $c0722d30b1d17141$var$createConnectionParams(token, clientInfo, opts) : yield $c0722d30b1d17141$var$createJoinRequestConnectionParams(token, clientInfo, opts, publisherOffer);
                const rtcUrl = $c0722d30b1d17141$var$createRtcUrl(url, params, useV0Path).toString();
                const validateUrl = $c0722d30b1d17141$var$createValidateUrl(rtcUrl).toString();
                return new Promise((resolve, reject)=>$c0722d30b1d17141$var$__awaiter(_this2, void 0, void 0, function*() {
                        var _a, _b;
                        try {
                            let alreadyAborted = false;
                            const abortHandler = (eventOrError)=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                                    if (alreadyAborted) return;
                                    alreadyAborted = true;
                                    const target = eventOrError instanceof Event ? eventOrError.currentTarget : eventOrError;
                                    const reason = $c0722d30b1d17141$var$getAbortReasonAsString(target, 'Abort handler called');
                                    // send leave if we have an active stream writer (connection is open)
                                    if (this.streamWriter && !this.isDisconnected) this.sendLeave().then(()=>this.close(reason)).catch((e)=>{
                                        this.log.error(e);
                                        this.close();
                                    });
                                    else this.close();
                                    cleanupAbortHandlers();
                                    reject($c0722d30b1d17141$export$a3747c6e46c7a8eb.cancelled(reason));
                                });
                            abortSignal === null || abortSignal === void 0 || abortSignal.addEventListener('abort', abortHandler);
                            const cleanupAbortHandlers = ()=>{
                                clearTimeout(wsTimeout);
                                abortSignal === null || abortSignal === void 0 || abortSignal.removeEventListener('abort', abortHandler);
                            };
                            const wsTimeout = setTimeout(()=>{
                                abortHandler($c0722d30b1d17141$export$a3747c6e46c7a8eb.timeout('room connection has timed out (signal)'));
                            }, opts.websocketTimeout);
                            const handleSignalConnected = (connection, firstMessage)=>{
                                this.handleSignalConnected(connection, wsTimeout, firstMessage);
                            };
                            const redactedUrl = new URL(rtcUrl);
                            if (redactedUrl.searchParams.has('access_token')) redactedUrl.searchParams.set('access_token', '<redacted>');
                            this.log.info("signal connecting to ".concat(redactedUrl), {
                                reconnect: opts.reconnect,
                                reconnectReason: opts.reconnectReason
                            });
                            if (this.ws) yield this.close(false);
                            this.ws = new $c0722d30b1d17141$var$WebSocketStream(rtcUrl);
                            try {
                                this.ws.closed.then((closeInfo)=>{
                                    var _a;
                                    if (this.isEstablishingConnection) reject($c0722d30b1d17141$export$a3747c6e46c7a8eb.internal("Websocket got closed during a (re)connection attempt: ".concat(closeInfo.reason)));
                                    if (closeInfo.closeCode !== 1000) {
                                        this.log.warn("websocket closed", {
                                            reason: closeInfo.reason,
                                            code: closeInfo.closeCode,
                                            wasClean: closeInfo.closeCode === 1000,
                                            state: this.state
                                        });
                                        if (this.state === $c0722d30b1d17141$var$SignalConnectionState.CONNECTED) this.handleOnClose((_a = closeInfo.reason) !== null && _a !== void 0 ? _a : 'Unexpected WS error');
                                    }
                                    return;
                                }).catch((reason)=>{
                                    if (this.isEstablishingConnection) reject($c0722d30b1d17141$export$a3747c6e46c7a8eb.internal("Websocket error during a (re)connection attempt: ".concat(reason)));
                                });
                                const connection = yield this.ws.opened.catch((reason)=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                                        if (this.state !== $c0722d30b1d17141$var$SignalConnectionState.CONNECTED) {
                                            this.state = $c0722d30b1d17141$var$SignalConnectionState.DISCONNECTED;
                                            clearTimeout(wsTimeout);
                                            const error = yield this.handleConnectionError(reason, validateUrl);
                                            reject(error);
                                            return;
                                        }
                                        // other errors, handle
                                        this.handleWSError(reason);
                                        reject(reason);
                                        return;
                                    }));
                                clearTimeout(wsTimeout);
                                if (!connection) return;
                                const signalReader = connection.readable.getReader();
                                this.streamWriter = connection.writable.getWriter();
                                const firstMessage = yield signalReader.read();
                                signalReader.releaseLock();
                                if (!firstMessage.value) throw $c0722d30b1d17141$export$a3747c6e46c7a8eb.internal('no message received as first message');
                                const firstSignalResponse = $c0722d30b1d17141$var$parseSignalResponse(firstMessage.value);
                                // Validate the first message
                                const validation = this.validateFirstMessage(firstSignalResponse, (_a = opts.reconnect) !== null && _a !== void 0 ? _a : false);
                                if (!validation.isValid) {
                                    reject(validation.error);
                                    return;
                                }
                                // Handle join response
                                if (((_b = firstSignalResponse.message) === null || _b === void 0 ? void 0 : _b.case) === 'join') {
                                    // Set up ping configuration
                                    this.pingTimeoutDuration = firstSignalResponse.message.value.pingTimeout;
                                    this.pingIntervalDuration = firstSignalResponse.message.value.pingInterval;
                                    if (this.pingTimeoutDuration && this.pingTimeoutDuration > 0) this.log.debug('ping config', {
                                        timeout: this.pingTimeoutDuration,
                                        interval: this.pingIntervalDuration
                                    });
                                    if (this.onJoined) this.onJoined(firstSignalResponse.message.value);
                                }
                                // Handle successful connection
                                const firstMessageToProcess = validation.shouldProcessFirstMessage ? firstSignalResponse : undefined;
                                handleSignalConnected(connection, firstMessageToProcess);
                                resolve(validation.response);
                            } catch (e) {
                                reject(e);
                            } finally{
                                cleanupAbortHandlers();
                            }
                        } finally{
                            unlock();
                        }
                    }));
            }();
        });
    }
    startReadingLoop(signalReader, firstMessage) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            if (firstMessage) this.handleSignalResponse(firstMessage);
            while(true){
                if (this.signalLatency) yield $c0722d30b1d17141$var$sleep(this.signalLatency);
                const { done: done, value: value } = yield signalReader.read();
                if (done) break;
                const resp = $c0722d30b1d17141$var$parseSignalResponse(value);
                this.handleSignalResponse(resp);
            }
        });
    }
    close() {
        return $c0722d30b1d17141$var$__awaiter(this, arguments, void 0, function() {
            var _this3 = this;
            let updateState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            let reason = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Close method called on signal client';
            return function*() {
                if ([
                    $c0722d30b1d17141$var$SignalConnectionState.DISCONNECTING || $c0722d30b1d17141$var$SignalConnectionState.DISCONNECTED
                ].includes(_this3.state)) {
                    _this3.log.debug("ignoring signal close as it's already in disconnecting state");
                    return;
                }
                const unlock = yield _this3.closingLock.lock();
                try {
                    _this3.clearPingInterval();
                    if (updateState) _this3.state = $c0722d30b1d17141$var$SignalConnectionState.DISCONNECTING;
                    if (_this3.ws) {
                        _this3.ws.close({
                            closeCode: 1000,
                            reason: reason
                        });
                        // calling `ws.close()` only starts the closing handshake (CLOSING state), prefer to wait until state is actually CLOSED
                        const closePromise = _this3.ws.closed;
                        _this3.ws = undefined;
                        _this3.streamWriter = undefined;
                        yield Promise.race([
                            closePromise,
                            $c0722d30b1d17141$var$sleep($c0722d30b1d17141$var$MAX_WS_CLOSE_TIME)
                        ]);
                    }
                } catch (e) {
                    _this3.log.debug('websocket error while closing', {
                        error: e
                    });
                } finally{
                    if (updateState) _this3.state = $c0722d30b1d17141$var$SignalConnectionState.DISCONNECTED;
                    unlock();
                }
            }();
        });
    }
    // initial offer after joining
    sendOffer(offer, offerId) {
        this.log.debug('sending offer', {
            offerSdp: offer.sdp
        });
        this.sendRequest({
            case: 'offer',
            value: $c0722d30b1d17141$var$toProtoSessionDescription(offer, offerId)
        });
    }
    // answer a server-initiated offer
    sendAnswer(answer, offerId) {
        this.log.debug('sending answer', {
            answerSdp: answer.sdp
        });
        return this.sendRequest({
            case: 'answer',
            value: $c0722d30b1d17141$var$toProtoSessionDescription(answer, offerId)
        });
    }
    sendIceCandidate(candidate, target) {
        this.log.debug('sending ice candidate', {
            candidate: candidate
        });
        return this.sendRequest({
            case: 'trickle',
            value: new $c0722d30b1d17141$var$TrickleRequest({
                candidateInit: JSON.stringify(candidate),
                target: target
            })
        });
    }
    sendMuteTrack(trackSid, muted) {
        return this.sendRequest({
            case: 'mute',
            value: new $c0722d30b1d17141$var$MuteTrackRequest({
                sid: trackSid,
                muted: muted
            })
        });
    }
    sendAddTrack(req) {
        return this.sendRequest({
            case: 'addTrack',
            value: req
        });
    }
    sendUpdateLocalMetadata(metadata_1, name_1) {
        return $c0722d30b1d17141$var$__awaiter(this, arguments, void 0, function(metadata, name) {
            var _this4 = this;
            let attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            return function*() {
                const requestId = _this4.getNextRequestId();
                yield _this4.sendRequest({
                    case: 'updateMetadata',
                    value: new $c0722d30b1d17141$var$UpdateParticipantMetadata({
                        requestId: requestId,
                        metadata: metadata,
                        name: name,
                        attributes: attributes
                    })
                });
                return requestId;
            }();
        });
    }
    sendUpdateTrackSettings(settings) {
        this.sendRequest({
            case: 'trackSetting',
            value: settings
        });
    }
    sendUpdateSubscription(sub) {
        return this.sendRequest({
            case: 'subscription',
            value: sub
        });
    }
    sendSyncState(sync) {
        return this.sendRequest({
            case: 'syncState',
            value: sync
        });
    }
    sendUpdateVideoLayers(trackSid, layers) {
        return this.sendRequest({
            case: 'updateLayers',
            value: new $c0722d30b1d17141$var$UpdateVideoLayers({
                trackSid: trackSid,
                layers: layers
            })
        });
    }
    sendUpdateSubscriptionPermissions(allParticipants, trackPermissions) {
        return this.sendRequest({
            case: 'subscriptionPermission',
            value: new $c0722d30b1d17141$var$SubscriptionPermission({
                allParticipants: allParticipants,
                trackPermissions: trackPermissions
            })
        });
    }
    sendSimulateScenario(scenario) {
        return this.sendRequest({
            case: 'simulate',
            value: scenario
        });
    }
    sendPing() {
        /** send both of ping and pingReq for compatibility to old and new server */ return Promise.all([
            this.sendRequest({
                case: 'ping',
                value: $c0722d30b1d17141$var$protoInt64.parse(Date.now())
            }),
            this.sendRequest({
                case: 'pingReq',
                value: new $c0722d30b1d17141$var$Ping({
                    timestamp: $c0722d30b1d17141$var$protoInt64.parse(Date.now()),
                    rtt: $c0722d30b1d17141$var$protoInt64.parse(this.rtt)
                })
            })
        ]);
    }
    sendUpdateLocalAudioTrack(trackSid, features) {
        return this.sendRequest({
            case: 'updateAudioTrack',
            value: new $c0722d30b1d17141$var$UpdateLocalAudioTrack({
                trackSid: trackSid,
                features: features
            })
        });
    }
    sendLeave() {
        return this.sendRequest({
            case: 'leave',
            value: new $c0722d30b1d17141$var$LeaveRequest({
                reason: $c0722d30b1d17141$export$258d16488300d83f.CLIENT_INITIATED,
                // server doesn't process this field, keeping it here to indicate the intent of a full disconnect
                action: $c0722d30b1d17141$var$LeaveRequest_Action.DISCONNECT
            })
        });
    }
    sendPublishDataTrackRequest(handle, name, usesE2ee) {
        return this.sendRequest({
            case: 'publishDataTrackRequest',
            value: new $c0722d30b1d17141$var$PublishDataTrackRequest({
                pubHandle: handle,
                name: name,
                encryption: usesE2ee ? $c0722d30b1d17141$export$1efc488791285f20.GCM : $c0722d30b1d17141$export$1efc488791285f20.NONE
            })
        });
    }
    sendUnPublishDataTrackRequest(handle) {
        return this.sendRequest({
            case: 'unpublishDataTrackRequest',
            value: new $c0722d30b1d17141$var$UnpublishDataTrackRequest({
                pubHandle: handle
            })
        });
    }
    sendUpdateDataSubscription(sid, subscribe) {
        return this.sendRequest({
            case: 'updateDataSubscription',
            value: new $c0722d30b1d17141$var$UpdateDataSubscription({
                // FIXME: consider refactoring to allow caller to pass an array of events through
                updates: [
                    new $c0722d30b1d17141$var$UpdateDataSubscription_Update({
                        trackSid: sid,
                        subscribe: subscribe
                    })
                ]
            })
        });
    }
    sendRequest(message_1) {
        return $c0722d30b1d17141$var$__awaiter(this, arguments, void 0, function(message) {
            var _this5 = this;
            let fromQueue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            return function*() {
                // capture all requests while reconnecting and put them in a queue
                // unless the request originates from the queue, then don't enqueue again
                const canQueue = !fromQueue && !$c0722d30b1d17141$var$canPassThroughQueue(message);
                if (canQueue && _this5.state === $c0722d30b1d17141$var$SignalConnectionState.RECONNECTING) {
                    _this5.queuedRequests.push(()=>$c0722d30b1d17141$var$__awaiter(_this5, void 0, void 0, function*() {
                            yield this.sendRequest(message, true);
                        }));
                    return;
                }
                // make sure previously queued requests are being sent first
                if (!fromQueue) yield _this5.requestQueue.flush();
                if (_this5.signalLatency) yield $c0722d30b1d17141$var$sleep(_this5.signalLatency);
                if (_this5.isDisconnected) {
                    // Skip requests if the signal layer is disconnected
                    // This can happen if an event is sent in the mist of room.connect() initializing
                    _this5.log.debug("skipping signal request (type: ".concat(message.case, ") - SignalClient disconnected"));
                    return;
                }
                if (!_this5.streamWriter) {
                    _this5.log.error("cannot send signal request before connected, type: ".concat(message === null || message === void 0 ? void 0 : message.case));
                    return;
                }
                const req = new $c0722d30b1d17141$var$SignalRequest({
                    message: message
                });
                try {
                    if (_this5.useJSON) yield _this5.streamWriter.write(req.toJsonString());
                    else yield _this5.streamWriter.write(req.toBinary());
                } catch (e) {
                    _this5.log.error('error sending signal message', {
                        error: e
                    });
                }
            }();
        });
    }
    handleSignalResponse(res) {
        var _a, _b;
        const msg = res.message;
        if (msg == undefined) {
            this.log.debug('received unsupported message');
            return;
        }
        let pingHandled = false;
        if (msg.case === 'answer') {
            const sd = $c0722d30b1d17141$var$fromProtoSessionDescription(msg.value);
            if (this.onAnswer) this.onAnswer(sd, msg.value.id, msg.value.midToTrackId);
        } else if (msg.case === 'offer') {
            const sd = $c0722d30b1d17141$var$fromProtoSessionDescription(msg.value);
            if (this.onOffer) this.onOffer(sd, msg.value.id, msg.value.midToTrackId);
        } else if (msg.case === 'trickle') {
            const candidate = JSON.parse(msg.value.candidateInit);
            if (this.onTrickle) this.onTrickle(candidate, msg.value.target);
        } else if (msg.case === 'update') {
            if (this.onParticipantUpdate) this.onParticipantUpdate((_a = msg.value.participants) !== null && _a !== void 0 ? _a : []);
        } else if (msg.case === 'trackPublished') {
            if (this.onLocalTrackPublished) this.onLocalTrackPublished(msg.value);
        } else if (msg.case === 'speakersChanged') {
            if (this.onSpeakersChanged) this.onSpeakersChanged((_b = msg.value.speakers) !== null && _b !== void 0 ? _b : []);
        } else if (msg.case === 'leave') {
            if (this.onLeave) this.onLeave(msg.value);
        } else if (msg.case === 'mute') {
            if (this.onRemoteMuteChanged) this.onRemoteMuteChanged(msg.value.sid, msg.value.muted);
        } else if (msg.case === 'roomUpdate') {
            if (this.onRoomUpdate && msg.value.room) this.onRoomUpdate(msg.value.room);
        } else if (msg.case === 'connectionQuality') {
            if (this.onConnectionQuality) this.onConnectionQuality(msg.value);
        } else if (msg.case === 'streamStateUpdate') {
            if (this.onStreamStateUpdate) this.onStreamStateUpdate(msg.value);
        } else if (msg.case === 'subscribedQualityUpdate') {
            if (this.onSubscribedQualityUpdate) this.onSubscribedQualityUpdate(msg.value);
        } else if (msg.case === 'subscriptionPermissionUpdate') {
            if (this.onSubscriptionPermissionUpdate) this.onSubscriptionPermissionUpdate(msg.value);
        } else if (msg.case === 'refreshToken') {
            if (this.onTokenRefresh) this.onTokenRefresh(msg.value);
        } else if (msg.case === 'trackUnpublished') {
            if (this.onLocalTrackUnpublished) this.onLocalTrackUnpublished(msg.value);
        } else if (msg.case === 'subscriptionResponse') {
            if (this.onSubscriptionError) this.onSubscriptionError(msg.value);
        } else if (msg.case === 'pong') ;
        else if (msg.case === 'pongResp') {
            this.rtt = Date.now() - Number.parseInt(msg.value.lastPingTimestamp.toString());
            this.resetPingTimeout();
            pingHandled = true;
        } else if (msg.case === 'requestResponse') {
            if (this.onRequestResponse) this.onRequestResponse(msg.value);
        } else if (msg.case === 'trackSubscribed') {
            if (this.onLocalTrackSubscribed) this.onLocalTrackSubscribed(msg.value.trackSid);
        } else if (msg.case === 'roomMoved') {
            if (this.onTokenRefresh) this.onTokenRefresh(msg.value.token);
            if (this.onRoomMoved) this.onRoomMoved(msg.value);
        } else if (msg.case === 'mediaSectionsRequirement') {
            if (this.onMediaSectionsRequirement) this.onMediaSectionsRequirement(msg.value);
        } else if (msg.case === 'publishDataTrackResponse') {
            if (this.onPublishDataTrackResponse) this.onPublishDataTrackResponse(msg.value);
        } else if (msg.case === 'unpublishDataTrackResponse') {
            if (this.onUnPublishDataTrackResponse) this.onUnPublishDataTrackResponse(msg.value);
        } else if (msg.case === 'dataTrackSubscriberHandles') {
            if (this.onDataTrackSubscriberHandles) this.onDataTrackSubscriberHandles(msg.value);
        } else this.log.debug('unsupported message', {
            msgCase: msg.case
        });
        if (!pingHandled) this.resetPingTimeout();
    }
    setReconnected() {
        while(this.queuedRequests.length > 0){
            const req = this.queuedRequests.shift();
            if (req) this.requestQueue.run(req);
        }
    }
    handleOnClose(reason) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            if (this.state === $c0722d30b1d17141$var$SignalConnectionState.DISCONNECTED) return;
            const onCloseCallback = this.onClose;
            yield this.close(undefined, reason);
            this.log.info("websocket connection closed: ".concat(reason), {
                reason: reason
            });
            if (onCloseCallback) onCloseCallback(reason);
        });
    }
    handleWSError(error) {
        this.log.error('websocket error', {
            error: error
        });
    }
    /**
   * Resets the ping timeout and starts a new timeout.
   * Call this after receiving a pong message
   */ resetPingTimeout() {
        this.clearPingTimeout();
        if (!this.pingTimeoutDuration) {
            this.log.warn('ping timeout duration not set');
            return;
        }
        this.pingTimeout = $c0722d30b1d17141$export$22e737276454df96.setTimeout(()=>{
            this.log.warn("ping timeout triggered. last pong received at: ".concat(new Date(Date.now() - this.pingTimeoutDuration * 1000).toUTCString()));
            this.handleOnClose('ping timeout');
        }, this.pingTimeoutDuration * 1000);
    }
    /**
   * Clears ping timeout (does not start a new timeout)
   */ clearPingTimeout() {
        if (this.pingTimeout) $c0722d30b1d17141$export$22e737276454df96.clearTimeout(this.pingTimeout);
    }
    startPingInterval() {
        this.clearPingInterval();
        this.resetPingTimeout();
        if (!this.pingIntervalDuration) {
            this.log.warn('ping interval duration not set');
            return;
        }
        this.log.debug('start ping interval');
        this.pingInterval = $c0722d30b1d17141$export$22e737276454df96.setInterval(()=>{
            this.sendPing();
        }, this.pingIntervalDuration * 1000);
    }
    clearPingInterval() {
        this.log.debug('clearing ping interval');
        this.clearPingTimeout();
        if (this.pingInterval) $c0722d30b1d17141$export$22e737276454df96.clearInterval(this.pingInterval);
    }
    /**
   * Handles the successful connection to the signal server
   * @param connection The WebSocket connection
   * @param timeoutHandle The timeout handle to clear
   * @param firstMessage Optional first message to process
   * @internal
   */ handleSignalConnected(connection, timeoutHandle, firstMessage) {
        this.state = $c0722d30b1d17141$var$SignalConnectionState.CONNECTED;
        this.log.info('signal connected');
        clearTimeout(timeoutHandle);
        this.startPingInterval();
        this.startReadingLoop(connection.readable.getReader(), firstMessage);
    }
    /**
   * Validates the first message received from the signal server
   * @param firstSignalResponse The first signal response received
   * @param isReconnect Whether this is a reconnection attempt
   * @returns Validation result with response or error
   * @internal
   */ validateFirstMessage(firstSignalResponse, isReconnect) {
        var _a, _b, _c, _d, _e;
        if (((_a = firstSignalResponse.message) === null || _a === void 0 ? void 0 : _a.case) === 'join') return {
            isValid: true,
            response: firstSignalResponse.message.value
        };
        else if (this.state === $c0722d30b1d17141$var$SignalConnectionState.RECONNECTING && ((_b = firstSignalResponse.message) === null || _b === void 0 ? void 0 : _b.case) !== 'leave') {
            if (((_c = firstSignalResponse.message) === null || _c === void 0 ? void 0 : _c.case) === 'reconnect') return {
                isValid: true,
                response: firstSignalResponse.message.value
            };
            else {
                // in reconnecting, any message received means signal reconnected and we still need to process it
                this.log.debug('declaring signal reconnected without reconnect response received');
                return {
                    isValid: true,
                    response: undefined,
                    shouldProcessFirstMessage: true
                };
            }
        } else if (this.isEstablishingConnection && ((_d = firstSignalResponse.message) === null || _d === void 0 ? void 0 : _d.case) === 'leave') return {
            isValid: false,
            error: $c0722d30b1d17141$export$a3747c6e46c7a8eb.leaveRequest('Received leave request while trying to (re)connect', firstSignalResponse.message.value.reason)
        };
        else if (!isReconnect) // non-reconnect case, should receive join response first
        return {
            isValid: false,
            error: $c0722d30b1d17141$export$a3747c6e46c7a8eb.internal("did not receive join response, got ".concat((_e = firstSignalResponse.message) === null || _e === void 0 ? void 0 : _e.case, " instead"))
        };
        return {
            isValid: false,
            error: $c0722d30b1d17141$export$a3747c6e46c7a8eb.internal('Unexpected first message')
        };
    }
    /**
   * Handles WebSocket connection errors by validating with the server
   * @param reason The error that occurred
   * @param validateUrl The URL to validate the connection with
   * @returns A ConnectionError with appropriate reason and status
   * @internal
   */ handleConnectionError(reason, validateUrl) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const resp = yield fetch(validateUrl);
                switch(resp.status){
                    case 404:
                        const errorMsg = yield resp.text();
                        if (errorMsg.includes('requested room does not exist')) return $c0722d30b1d17141$export$a3747c6e46c7a8eb.notAllowed(errorMsg, resp.status);
                        return $c0722d30b1d17141$export$a3747c6e46c7a8eb.serviceNotFound('v1 RTC path not found. Consider upgrading your LiveKit server version', 'v0-rtc');
                    case 401:
                    case 403:
                        const msg = yield resp.text();
                        return $c0722d30b1d17141$export$a3747c6e46c7a8eb.notAllowed(msg, resp.status);
                    default:
                        break;
                }
                if (reason instanceof $c0722d30b1d17141$export$a3747c6e46c7a8eb) return reason;
                else return $c0722d30b1d17141$export$a3747c6e46c7a8eb.internal("Encountered unknown websocket error during connection: ".concat(reason), {
                    status: resp.status,
                    statusText: resp.statusText
                });
            } catch (e) {
                return e instanceof $c0722d30b1d17141$export$a3747c6e46c7a8eb ? e : $c0722d30b1d17141$export$a3747c6e46c7a8eb.serverUnreachable(e instanceof Error ? e.message : 'server was not reachable');
            }
        });
    }
}
function $c0722d30b1d17141$var$fromProtoSessionDescription(sd) {
    const rsd = {
        type: 'offer',
        sdp: sd.sdp
    };
    switch(sd.type){
        case 'answer':
        case 'offer':
        case 'pranswer':
        case 'rollback':
            rsd.type = sd.type;
            break;
    }
    return rsd;
}
function $c0722d30b1d17141$var$toProtoSessionDescription(rsd, id) {
    const sd = new $c0722d30b1d17141$var$SessionDescription({
        sdp: rsd.sdp,
        type: rsd.type,
        id: id
    });
    return sd;
}
function $c0722d30b1d17141$var$createConnectionParams(token, info, opts) {
    var _a;
    const params = new URLSearchParams();
    params.set('access_token', token);
    // opts
    if (opts.reconnect) {
        params.set('reconnect', '1');
        if (opts.sid) params.set('sid', opts.sid);
    }
    params.set('auto_subscribe', opts.autoSubscribe ? '1' : '0');
    // ClientInfo
    params.set('sdk', $c0722d30b1d17141$var$isReactNative() ? 'reactnative' : 'js');
    params.set('version', info.version);
    params.set('protocol', info.protocol.toString());
    if (info.deviceModel) params.set('device_model', info.deviceModel);
    if (info.os) params.set('os', info.os);
    if (info.osVersion) params.set('os_version', info.osVersion);
    if (info.browser) params.set('browser', info.browser);
    if (info.browserVersion) params.set('browser_version', info.browserVersion);
    if (opts.adaptiveStream) params.set('adaptive_stream', '1');
    if (opts.reconnectReason) params.set('reconnect_reason', opts.reconnectReason.toString());
    // @ts-ignore
    if ((_a = navigator.connection) === null || _a === void 0 ? void 0 : _a.type) // @ts-ignore
    params.set('network', navigator.connection.type);
    return params;
}
function $c0722d30b1d17141$var$createJoinRequestConnectionParams(token, info, opts, publisherOffer) {
    return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
        const params = new URLSearchParams();
        params.set('access_token', token);
        const joinRequest = new $c0722d30b1d17141$var$JoinRequest({
            clientInfo: info,
            connectionSettings: new $c0722d30b1d17141$var$ConnectionSettings({
                autoSubscribe: !!opts.autoSubscribe,
                adaptiveStream: !!opts.adaptiveStream
            }),
            reconnect: !!opts.reconnect,
            participantSid: opts.sid ? opts.sid : undefined,
            publisherOffer: publisherOffer
        });
        if (opts.reconnectReason) joinRequest.reconnectReason = opts.reconnectReason;
        const joinRequestBytes = joinRequest.toBinary();
        let requestBytes;
        let compression;
        if ($c0722d30b1d17141$var$isCompressionStreamSupported()) {
            const stream = new CompressionStream('gzip');
            const writer = stream.writable.getWriter();
            writer.write(new Uint8Array(joinRequestBytes));
            writer.close();
            const chunks = [];
            const reader = stream.readable.getReader();
            while(true){
                const { done: done, value: value } = yield reader.read();
                if (done) break;
                chunks.push(value);
            }
            const totalLength = chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
            const result = new Uint8Array(totalLength);
            let offset = 0;
            for (const chunk of chunks){
                result.set(chunk, offset);
                offset += chunk.length;
            }
            requestBytes = result;
            compression = $c0722d30b1d17141$var$WrappedJoinRequest_Compression.GZIP;
        } else {
            requestBytes = joinRequestBytes;
            compression = $c0722d30b1d17141$var$WrappedJoinRequest_Compression.NONE;
        }
        const wrappedJoinRequest = new $c0722d30b1d17141$var$WrappedJoinRequest({
            joinRequest: requestBytes,
            compression: compression
        });
        const wrappedBytes = wrappedJoinRequest.toBinary();
        const bytesToBase64 = (bytes)=>{
            const binString = Array.from(bytes, (byte)=>String.fromCodePoint(byte)).join('');
            return btoa(binString);
        };
        params.set('join_request', bytesToBase64(wrappedBytes).replace(/\+/g, '-').replace(/\//g, '_'));
        return params;
    });
}
class $c0722d30b1d17141$var$DataPacketBuffer {
    constructor(){
        this.buffer = [];
        this._totalSize = 0;
    }
    push(item) {
        this.buffer.push(item);
        this._totalSize += item.data.byteLength;
    }
    pop() {
        const item = this.buffer.shift();
        if (item) this._totalSize -= item.data.byteLength;
        return item;
    }
    getAll() {
        return this.buffer.slice();
    }
    popToSequence(sequence) {
        while(this.buffer.length > 0){
            const first = this.buffer[0];
            if (first.sequence <= sequence) this.pop();
            else break;
        }
    }
    alignBufferedAmount(bufferedAmount) {
        while(this.buffer.length > 0){
            const first = this.buffer[0];
            if (this._totalSize - first.data.byteLength <= bufferedAmount) break;
            this.pop();
        }
    }
    get length() {
        return this.buffer.length;
    }
}
class $c0722d30b1d17141$var$TTLMap {
    /**
   * @param ttl ttl of the key (ms)
   */ constructor(ttl){
        this._map = new Map();
        this._lastCleanup = 0;
        this.ttl = ttl;
    }
    set(key, value) {
        const now = Date.now();
        if (now - this._lastCleanup > this.ttl / 2) this.cleanup();
        const expiresAt = now + this.ttl;
        this._map.set(key, {
            value: value,
            expiresAt: expiresAt
        });
        return this;
    }
    get(key) {
        const entry = this._map.get(key);
        if (!entry) return undefined;
        if (entry.expiresAt < Date.now()) {
            this._map.delete(key);
            return undefined;
        }
        return entry.value;
    }
    has(key) {
        const entry = this._map.get(key);
        if (!entry) return false;
        if (entry.expiresAt < Date.now()) {
            this._map.delete(key);
            return false;
        }
        return true;
    }
    delete(key) {
        return this._map.delete(key);
    }
    clear() {
        this._map.clear();
    }
    cleanup() {
        const now = Date.now();
        for (const [key, entry] of this._map.entries())if (entry.expiresAt < now) this._map.delete(key);
        this._lastCleanup = now;
    }
    get size() {
        this.cleanup();
        return this._map.size;
    }
    forEach(callback) {
        this.cleanup();
        for (const [key, entry] of this._map.entries())if (entry.expiresAt >= Date.now()) callback(entry.value, key, this.asValueMap());
    }
    map(callback) {
        this.cleanup();
        const result = [];
        const valueMap = this.asValueMap();
        for (const [key, value] of valueMap.entries())result.push(callback(value, key, valueMap));
        return result;
    }
    asValueMap() {
        const result = new Map();
        for (const [key, entry] of this._map.entries())if (entry.expiresAt >= Date.now()) result.set(key, entry.value);
        return result;
    }
}
var $c0722d30b1d17141$var$lib = {};
var $c0722d30b1d17141$var$parser = {};
var $c0722d30b1d17141$var$grammar = {
    exports: {}
};
var $c0722d30b1d17141$var$hasRequiredGrammar;
function $c0722d30b1d17141$var$requireGrammar() {
    if ($c0722d30b1d17141$var$hasRequiredGrammar) return $c0722d30b1d17141$var$grammar.exports;
    $c0722d30b1d17141$var$hasRequiredGrammar = 1;
    var grammar$1 = $c0722d30b1d17141$var$grammar.exports = {
        v: [
            {
                name: 'version',
                reg: /^(\d*)$/
            }
        ],
        o: [
            {
                // o=- 20518 0 IN IP4 203.0.113.1
                // NB: sessionId will be a String in most cases because it is huge
                name: 'origin',
                reg: /^(\S*) (\d*) (\d*) (\S*) IP(\d) (\S*)/,
                names: [
                    'username',
                    'sessionId',
                    'sessionVersion',
                    'netType',
                    'ipVer',
                    'address'
                ],
                format: '%s %s %d %s IP%d %s'
            }
        ],
        // default parsing of these only (though some of these feel outdated)
        s: [
            {
                name: 'name'
            }
        ],
        i: [
            {
                name: 'description'
            }
        ],
        u: [
            {
                name: 'uri'
            }
        ],
        e: [
            {
                name: 'email'
            }
        ],
        p: [
            {
                name: 'phone'
            }
        ],
        z: [
            {
                name: 'timezones'
            }
        ],
        // TODO: this one can actually be parsed properly...
        r: [
            {
                name: 'repeats'
            }
        ],
        // TODO: this one can also be parsed properly
        // k: [{}], // outdated thing ignored
        t: [
            {
                // t=0 0
                name: 'timing',
                reg: /^(\d*) (\d*)/,
                names: [
                    'start',
                    'stop'
                ],
                format: '%d %d'
            }
        ],
        c: [
            {
                // c=IN IP4 10.47.197.26
                name: 'connection',
                reg: /^IN IP(\d) (\S*)/,
                names: [
                    'version',
                    'ip'
                ],
                format: 'IN IP%d %s'
            }
        ],
        b: [
            {
                // b=AS:4000
                push: 'bandwidth',
                reg: /^(TIAS|AS|CT|RR|RS):(\d*)/,
                names: [
                    'type',
                    'limit'
                ],
                format: '%s:%s'
            }
        ],
        m: [
            {
                // m=video 51744 RTP/AVP 126 97 98 34 31
                // NB: special - pushes to session
                // TODO: rtp/fmtp should be filtered by the payloads found here?
                reg: /^(\w*) (\d*) ([\w/]*)(?: (.*))?/,
                names: [
                    'type',
                    'port',
                    'protocol',
                    'payloads'
                ],
                format: '%s %d %s %s'
            }
        ],
        a: [
            {
                // a=rtpmap:110 opus/48000/2
                push: 'rtp',
                reg: /^rtpmap:(\d*) ([\w\-.]*)(?:\s*\/(\d*)(?:\s*\/(\S*))?)?/,
                names: [
                    'payload',
                    'codec',
                    'rate',
                    'encoding'
                ],
                format: function(o) {
                    return o.encoding ? 'rtpmap:%d %s/%s/%s' : o.rate ? 'rtpmap:%d %s/%s' : 'rtpmap:%d %s';
                }
            },
            {
                // a=fmtp:108 profile-level-id=24;object=23;bitrate=64000
                // a=fmtp:111 minptime=10; useinbandfec=1
                push: 'fmtp',
                reg: /^fmtp:(\d*) ([\S| ]*)/,
                names: [
                    'payload',
                    'config'
                ],
                format: 'fmtp:%d %s'
            },
            {
                // a=control:streamid=0
                name: 'control',
                reg: /^control:(.*)/,
                format: 'control:%s'
            },
            {
                // a=rtcp:65179 IN IP4 193.84.77.194
                name: 'rtcp',
                reg: /^rtcp:(\d*)(?: (\S*) IP(\d) (\S*))?/,
                names: [
                    'port',
                    'netType',
                    'ipVer',
                    'address'
                ],
                format: function(o) {
                    return o.address != null ? 'rtcp:%d %s IP%d %s' : 'rtcp:%d';
                }
            },
            {
                // a=rtcp-fb:98 trr-int 100
                push: 'rtcpFbTrrInt',
                reg: /^rtcp-fb:(\*|\d*) trr-int (\d*)/,
                names: [
                    'payload',
                    'value'
                ],
                format: 'rtcp-fb:%s trr-int %d'
            },
            {
                // a=rtcp-fb:98 nack rpsi
                push: 'rtcpFb',
                reg: /^rtcp-fb:(\*|\d*) ([\w-_]*)(?: ([\w-_]*))?/,
                names: [
                    'payload',
                    'type',
                    'subtype'
                ],
                format: function(o) {
                    return o.subtype != null ? 'rtcp-fb:%s %s %s' : 'rtcp-fb:%s %s';
                }
            },
            {
                // a=extmap:2 urn:ietf:params:rtp-hdrext:toffset
                // a=extmap:1/recvonly URI-gps-string
                // a=extmap:3 urn:ietf:params:rtp-hdrext:encrypt urn:ietf:params:rtp-hdrext:smpte-tc 25@600/24
                push: 'ext',
                reg: /^extmap:(\d+)(?:\/(\w+))?(?: (urn:ietf:params:rtp-hdrext:encrypt))? (\S*)(?: (\S*))?/,
                names: [
                    'value',
                    'direction',
                    'encrypt-uri',
                    'uri',
                    'config'
                ],
                format: function(o) {
                    return 'extmap:%d' + (o.direction ? '/%s' : '%v') + (o['encrypt-uri'] ? ' %s' : '%v') + ' %s' + (o.config ? ' %s' : '');
                }
            },
            {
                // a=extmap-allow-mixed
                name: 'extmapAllowMixed',
                reg: /^(extmap-allow-mixed)/
            },
            {
                // a=crypto:1 AES_CM_128_HMAC_SHA1_80 inline:PS1uQCVeeCFCanVmcjkpPywjNWhcYD0mXXtxaVBR|2^20|1:32
                push: 'crypto',
                reg: /^crypto:(\d*) ([\w_]*) (\S*)(?: (\S*))?/,
                names: [
                    'id',
                    'suite',
                    'config',
                    'sessionConfig'
                ],
                format: function(o) {
                    return o.sessionConfig != null ? 'crypto:%d %s %s %s' : 'crypto:%d %s %s';
                }
            },
            {
                // a=setup:actpass
                name: 'setup',
                reg: /^setup:(\w*)/,
                format: 'setup:%s'
            },
            {
                // a=connection:new
                name: 'connectionType',
                reg: /^connection:(new|existing)/,
                format: 'connection:%s'
            },
            {
                // a=mid:1
                name: 'mid',
                reg: /^mid:([^\s]*)/,
                format: 'mid:%s'
            },
            {
                // a=msid:0c8b064d-d807-43b4-b434-f92a889d8587 98178685-d409-46e0-8e16-7ef0db0db64a
                name: 'msid',
                reg: /^msid:(.*)/,
                format: 'msid:%s'
            },
            {
                // a=ptime:20
                name: 'ptime',
                reg: /^ptime:(\d*(?:\.\d*)*)/,
                format: 'ptime:%d'
            },
            {
                // a=maxptime:60
                name: 'maxptime',
                reg: /^maxptime:(\d*(?:\.\d*)*)/,
                format: 'maxptime:%d'
            },
            {
                // a=sendrecv
                name: 'direction',
                reg: /^(sendrecv|recvonly|sendonly|inactive)/
            },
            {
                // a=ice-lite
                name: 'icelite',
                reg: /^(ice-lite)/
            },
            {
                // a=ice-ufrag:F7gI
                name: 'iceUfrag',
                reg: /^ice-ufrag:(\S*)/,
                format: 'ice-ufrag:%s'
            },
            {
                // a=ice-pwd:x9cml/YzichV2+XlhiMu8g
                name: 'icePwd',
                reg: /^ice-pwd:(\S*)/,
                format: 'ice-pwd:%s'
            },
            {
                // a=fingerprint:SHA-1 00:11:22:33:44:55:66:77:88:99:AA:BB:CC:DD:EE:FF:00:11:22:33
                name: 'fingerprint',
                reg: /^fingerprint:(\S*) (\S*)/,
                names: [
                    'type',
                    'hash'
                ],
                format: 'fingerprint:%s %s'
            },
            {
                // a=candidate:0 1 UDP 2113667327 203.0.113.1 54400 typ host
                // a=candidate:1162875081 1 udp 2113937151 192.168.34.75 60017 typ host generation 0 network-id 3 network-cost 10
                // a=candidate:3289912957 2 udp 1845501695 193.84.77.194 60017 typ srflx raddr 192.168.34.75 rport 60017 generation 0 network-id 3 network-cost 10
                // a=candidate:229815620 1 tcp 1518280447 192.168.150.19 60017 typ host tcptype active generation 0 network-id 3 network-cost 10
                // a=candidate:3289912957 2 tcp 1845501695 193.84.77.194 60017 typ srflx raddr 192.168.34.75 rport 60017 tcptype passive generation 0 network-id 3 network-cost 10
                push: 'candidates',
                reg: /^candidate:(\S*) (\d*) (\S*) (\d*) (\S*) (\d*) typ (\S*)(?: raddr (\S*) rport (\d*))?(?: tcptype (\S*))?(?: generation (\d*))?(?: network-id (\d*))?(?: network-cost (\d*))?/,
                names: [
                    'foundation',
                    'component',
                    'transport',
                    'priority',
                    'ip',
                    'port',
                    'type',
                    'raddr',
                    'rport',
                    'tcptype',
                    'generation',
                    'network-id',
                    'network-cost'
                ],
                format: function(o) {
                    var str = 'candidate:%s %d %s %d %s %d typ %s';
                    str += o.raddr != null ? ' raddr %s rport %d' : '%v%v';
                    // NB: candidate has three optional chunks, so %void middles one if it's missing
                    str += o.tcptype != null ? ' tcptype %s' : '%v';
                    if (o.generation != null) str += ' generation %d';
                    str += o['network-id'] != null ? ' network-id %d' : '%v';
                    str += o['network-cost'] != null ? ' network-cost %d' : '%v';
                    return str;
                }
            },
            {
                // a=end-of-candidates (keep after the candidates line for readability)
                name: 'endOfCandidates',
                reg: /^(end-of-candidates)/
            },
            {
                // a=remote-candidates:1 203.0.113.1 54400 2 203.0.113.1 54401 ...
                name: 'remoteCandidates',
                reg: /^remote-candidates:(.*)/,
                format: 'remote-candidates:%s'
            },
            {
                // a=ice-options:google-ice
                name: 'iceOptions',
                reg: /^ice-options:(\S*)/,
                format: 'ice-options:%s'
            },
            {
                // a=ssrc:2566107569 cname:t9YU8M1UxTF8Y1A1
                push: 'ssrcs',
                reg: /^ssrc:(\d*) ([\w_-]*)(?::(.*))?/,
                names: [
                    'id',
                    'attribute',
                    'value'
                ],
                format: function(o) {
                    var str = 'ssrc:%d';
                    if (o.attribute != null) {
                        str += ' %s';
                        if (o.value != null) str += ':%s';
                    }
                    return str;
                }
            },
            {
                // a=ssrc-group:FEC 1 2
                // a=ssrc-group:FEC-FR 3004364195 1080772241
                push: 'ssrcGroups',
                // token-char = %x21 / %x23-27 / %x2A-2B / %x2D-2E / %x30-39 / %x41-5A / %x5E-7E
                reg: /^ssrc-group:([\x21\x23\x24\x25\x26\x27\x2A\x2B\x2D\x2E\w]*) (.*)/,
                names: [
                    'semantics',
                    'ssrcs'
                ],
                format: 'ssrc-group:%s %s'
            },
            {
                // a=msid-semantic: WMS Jvlam5X3SX1OP6pn20zWogvaKJz5Hjf9OnlV
                name: 'msidSemantic',
                reg: /^msid-semantic:\s?(\w*) (\S*)/,
                names: [
                    'semantic',
                    'token'
                ],
                format: 'msid-semantic: %s %s' // space after ':' is not accidental
            },
            {
                // a=group:BUNDLE audio video
                push: 'groups',
                reg: /^group:(\w*) (.*)/,
                names: [
                    'type',
                    'mids'
                ],
                format: 'group:%s %s'
            },
            {
                // a=rtcp-mux
                name: 'rtcpMux',
                reg: /^(rtcp-mux)/
            },
            {
                // a=rtcp-rsize
                name: 'rtcpRsize',
                reg: /^(rtcp-rsize)/
            },
            {
                // a=sctpmap:5000 webrtc-datachannel 1024
                name: 'sctpmap',
                reg: /^sctpmap:([\w_/]*) (\S*)(?: (\S*))?/,
                names: [
                    'sctpmapNumber',
                    'app',
                    'maxMessageSize'
                ],
                format: function(o) {
                    return o.maxMessageSize != null ? 'sctpmap:%s %s %s' : 'sctpmap:%s %s';
                }
            },
            {
                // a=x-google-flag:conference
                name: 'xGoogleFlag',
                reg: /^x-google-flag:([^\s]*)/,
                format: 'x-google-flag:%s'
            },
            {
                // a=rid:1 send max-width=1280;max-height=720;max-fps=30;depend=0
                push: 'rids',
                reg: /^rid:([\d\w]+) (\w+)(?: ([\S| ]*))?/,
                names: [
                    'id',
                    'direction',
                    'params'
                ],
                format: function(o) {
                    return o.params ? 'rid:%s %s %s' : 'rid:%s %s';
                }
            },
            {
                // a=imageattr:97 send [x=800,y=640,sar=1.1,q=0.6] [x=480,y=320] recv [x=330,y=250]
                // a=imageattr:* send [x=800,y=640] recv *
                // a=imageattr:100 recv [x=320,y=240]
                push: 'imageattrs',
                reg: new RegExp(// a=imageattr:97
                "^imageattr:(\\d+|\\*)[\\s\\t]+(send|recv)[\\s\\t]+(\\*|\\[\\S+\\](?:[\\s\\t]+\\[\\S+\\])*)(?:[\\s\\t]+(recv|send)[\\s\\t]+(\\*|\\[\\S+\\](?:[\\s\\t]+\\[\\S+\\])*))?"),
                names: [
                    'pt',
                    'dir1',
                    'attrs1',
                    'dir2',
                    'attrs2'
                ],
                format: function(o) {
                    return 'imageattr:%s %s %s' + (o.dir2 ? ' %s %s' : '');
                }
            },
            {
                // a=simulcast:send 1,2,3;~4,~5 recv 6;~7,~8
                // a=simulcast:recv 1;4,5 send 6;7
                name: 'simulcast',
                reg: new RegExp(// a=simulcast:
                "^simulcast:(send|recv) ([a-zA-Z0-9\\-_~;,]+)(?:\\s?(send|recv) ([a-zA-Z0-9\\-_~;,]+))?$"),
                names: [
                    'dir1',
                    'list1',
                    'dir2',
                    'list2'
                ],
                format: function(o) {
                    return 'simulcast:%s %s' + (o.dir2 ? ' %s %s' : '');
                }
            },
            {
                // old simulcast draft 03 (implemented by Firefox)
                //   https://tools.ietf.org/html/draft-ietf-mmusic-sdp-simulcast-03
                // a=simulcast: recv pt=97;98 send pt=97
                // a=simulcast: send rid=5;6;7 paused=6,7
                name: 'simulcast_03',
                reg: /^simulcast:[\s\t]+([\S+\s\t]+)$/,
                names: [
                    'value'
                ],
                format: 'simulcast: %s'
            },
            {
                // a=framerate:25
                // a=framerate:29.97
                name: 'framerate',
                reg: /^framerate:(\d+(?:$|\.\d+))/,
                format: 'framerate:%s'
            },
            {
                // RFC4570
                // a=source-filter: incl IN IP4 239.5.2.31 10.1.15.5
                name: 'sourceFilter',
                reg: /^source-filter: *(excl|incl) (\S*) (IP4|IP6|\*) (\S*) (.*)/,
                names: [
                    'filterMode',
                    'netType',
                    'addressTypes',
                    'destAddress',
                    'srcList'
                ],
                format: 'source-filter: %s %s %s %s %s'
            },
            {
                // a=bundle-only
                name: 'bundleOnly',
                reg: /^(bundle-only)/
            },
            {
                // a=label:1
                name: 'label',
                reg: /^label:(.+)/,
                format: 'label:%s'
            },
            {
                // RFC version 26 for SCTP over DTLS
                // https://tools.ietf.org/html/draft-ietf-mmusic-sctp-sdp-26#section-5
                name: 'sctpPort',
                reg: /^sctp-port:(\d+)$/,
                format: 'sctp-port:%s'
            },
            {
                // RFC version 26 for SCTP over DTLS
                // https://tools.ietf.org/html/draft-ietf-mmusic-sctp-sdp-26#section-6
                name: 'maxMessageSize',
                reg: /^max-message-size:(\d+)$/,
                format: 'max-message-size:%s'
            },
            {
                // RFC7273
                // a=ts-refclk:ptp=IEEE1588-2008:39-A7-94-FF-FE-07-CB-D0:37
                push: 'tsRefClocks',
                reg: /^ts-refclk:([^\s=]*)(?:=(\S*))?/,
                names: [
                    'clksrc',
                    'clksrcExt'
                ],
                format: function(o) {
                    return 'ts-refclk:%s' + (o.clksrcExt != null ? '=%s' : '');
                }
            },
            {
                // RFC7273
                // a=mediaclk:direct=963214424
                name: 'mediaClk',
                reg: /^mediaclk:(?:id=(\S*))? *([^\s=]*)(?:=(\S*))?(?: *rate=(\d+)\/(\d+))?/,
                names: [
                    'id',
                    'mediaClockName',
                    'mediaClockValue',
                    'rateNumerator',
                    'rateDenominator'
                ],
                format: function(o) {
                    var str = 'mediaclk:';
                    str += o.id != null ? 'id=%s %s' : '%v%s';
                    str += o.mediaClockValue != null ? '=%s' : '';
                    str += o.rateNumerator != null ? ' rate=%s' : '';
                    str += o.rateDenominator != null ? '/%s' : '';
                    return str;
                }
            },
            {
                // a=keywds:keywords
                name: 'keywords',
                reg: /^keywds:(.+)$/,
                format: 'keywds:%s'
            },
            {
                // a=content:main
                name: 'content',
                reg: /^content:(.+)/,
                format: 'content:%s'
            },
            // BFCP https://tools.ietf.org/html/rfc4583
            {
                // a=floorctrl:c-s
                name: 'bfcpFloorCtrl',
                reg: /^floorctrl:(c-only|s-only|c-s)/,
                format: 'floorctrl:%s'
            },
            {
                // a=confid:1
                name: 'bfcpConfId',
                reg: /^confid:(\d+)/,
                format: 'confid:%s'
            },
            {
                // a=userid:1
                name: 'bfcpUserId',
                reg: /^userid:(\d+)/,
                format: 'userid:%s'
            },
            {
                // a=floorid:1
                name: 'bfcpFloorId',
                reg: /^floorid:(.+) (?:m-stream|mstrm):(.+)/,
                names: [
                    'id',
                    'mStream'
                ],
                format: 'floorid:%s mstrm:%s'
            },
            {
                // any a= that we don't understand is kept verbatim on media.invalid
                push: 'invalid',
                names: [
                    'value'
                ]
            }
        ]
    };
    // set sensible defaults to avoid polluting the grammar with boring details
    Object.keys(grammar$1).forEach(function(key) {
        var objs = grammar$1[key];
        objs.forEach(function(obj) {
            if (!obj.reg) obj.reg = /(.*)/;
            if (!obj.format) obj.format = '%s';
        });
    });
    return $c0722d30b1d17141$var$grammar.exports;
}
var $c0722d30b1d17141$var$hasRequiredParser;
function $c0722d30b1d17141$var$requireParser() {
    if ($c0722d30b1d17141$var$hasRequiredParser) return $c0722d30b1d17141$var$parser;
    $c0722d30b1d17141$var$hasRequiredParser = 1;
    (function(exports$1) {
        var toIntIfInt = function(v) {
            return String(Number(v)) === v ? Number(v) : v;
        };
        var attachProperties = function(match, location, names, rawName) {
            if (rawName && !names) location[rawName] = toIntIfInt(match[1]);
            else {
                for(var i = 0; i < names.length; i += 1)if (match[i + 1] != null) location[names[i]] = toIntIfInt(match[i + 1]);
            }
        };
        var parseReg = function(obj, location, content) {
            var needsBlank = obj.name && obj.names;
            if (obj.push && !location[obj.push]) location[obj.push] = [];
            else if (needsBlank && !location[obj.name]) location[obj.name] = {};
            var keyLocation = obj.push ? {} : // blank object that will be pushed
            needsBlank ? location[obj.name] : location; // otherwise, named location or root
            attachProperties(content.match(obj.reg), keyLocation, obj.names, obj.name);
            if (obj.push) location[obj.push].push(keyLocation);
        };
        var grammar = $c0722d30b1d17141$var$requireGrammar();
        var validLine = RegExp.prototype.test.bind(/^([a-z])=(.*)/);
        exports$1.parse = function(sdp) {
            var session = {}, media = [], location = session; // points at where properties go under (one of the above)
            // parse lines we understand
            sdp.split(/(\r\n|\r|\n)/).filter(validLine).forEach(function(l) {
                var type = l[0];
                var content = l.slice(2);
                if (type === 'm') {
                    media.push({
                        rtp: [],
                        fmtp: []
                    });
                    location = media[media.length - 1]; // point at latest media line
                }
                for(var j = 0; j < (grammar[type] || []).length; j += 1){
                    var obj = grammar[type][j];
                    if (obj.reg.test(content)) return parseReg(obj, location, content);
                }
            });
            session.media = media; // link it up
            return session;
        };
        var paramReducer = function(acc, expr) {
            var s = expr.split(/=(.+)/, 2);
            if (s.length === 2) acc[s[0]] = toIntIfInt(s[1]);
            else if (s.length === 1 && expr.length > 1) acc[s[0]] = undefined;
            return acc;
        };
        exports$1.parseParams = function(str) {
            return str.split(/;\s?/).reduce(paramReducer, {});
        };
        // For backward compatibility - alias will be removed in 3.0.0
        exports$1.parseFmtpConfig = exports$1.parseParams;
        exports$1.parsePayloads = function(str) {
            return str.toString().split(' ').map(Number);
        };
        exports$1.parseRemoteCandidates = function(str) {
            var candidates = [];
            var parts = str.split(' ').map(toIntIfInt);
            for(var i = 0; i < parts.length; i += 3)candidates.push({
                component: parts[i],
                ip: parts[i + 1],
                port: parts[i + 2]
            });
            return candidates;
        };
        exports$1.parseImageAttributes = function(str) {
            return str.split(' ').map(function(item) {
                return item.substring(1, item.length - 1).split(',').reduce(paramReducer, {});
            });
        };
        exports$1.parseSimulcastStreamList = function(str) {
            return str.split(';').map(function(stream) {
                return stream.split(',').map(function(format) {
                    var scid, paused = false;
                    if (format[0] !== '~') scid = toIntIfInt(format);
                    else {
                        scid = toIntIfInt(format.substring(1, format.length));
                        paused = true;
                    }
                    return {
                        scid: scid,
                        paused: paused
                    };
                });
            });
        };
    })($c0722d30b1d17141$var$parser);
    return $c0722d30b1d17141$var$parser;
}
var $c0722d30b1d17141$var$writer;
var $c0722d30b1d17141$var$hasRequiredWriter;
function $c0722d30b1d17141$var$requireWriter() {
    if ($c0722d30b1d17141$var$hasRequiredWriter) return $c0722d30b1d17141$var$writer;
    $c0722d30b1d17141$var$hasRequiredWriter = 1;
    var grammar = $c0722d30b1d17141$var$requireGrammar();
    // customized util.format - discards excess arguments and can void middle ones
    var formatRegExp = /%[sdv%]/g;
    var format = function(formatStr) {
        var i = 1;
        var args = arguments;
        var len = args.length;
        return formatStr.replace(formatRegExp, function(x) {
            if (i >= len) return x; // missing argument
            var arg = args[i];
            i += 1;
            switch(x){
                case '%%':
                    return '%';
                case '%s':
                    return String(arg);
                case '%d':
                    return Number(arg);
                case '%v':
                    return '';
            }
        });
    // NB: we discard excess arguments - they are typically undefined from makeLine
    };
    var makeLine = function(type, obj, location) {
        var str = obj.format instanceof Function ? obj.format(obj.push ? location : location[obj.name]) : obj.format;
        var args = [
            type + '=' + str
        ];
        if (obj.names) for(var i = 0; i < obj.names.length; i += 1){
            var n = obj.names[i];
            if (obj.name) args.push(location[obj.name][n]);
            else // for mLine and push attributes
            args.push(location[obj.names[i]]);
        }
        else args.push(location[obj.name]);
        return format.apply(null, args);
    };
    // RFC specified order
    // TODO: extend this with all the rest
    var defaultOuterOrder = [
        'v',
        'o',
        's',
        'i',
        'u',
        'e',
        'p',
        'c',
        'b',
        't',
        'r',
        'z',
        'a'
    ];
    var defaultInnerOrder = [
        'i',
        'c',
        'b',
        'a'
    ];
    $c0722d30b1d17141$var$writer = function(session, opts) {
        opts = opts || {};
        // ensure certain properties exist
        if (session.version == null) session.version = 0; // 'v=0' must be there (only defined version atm)
        if (session.name == null) session.name = ' '; // 's= ' must be there if no meaningful name set
        session.media.forEach(function(mLine) {
            if (mLine.payloads == null) mLine.payloads = '';
        });
        var outerOrder = opts.outerOrder || defaultOuterOrder;
        var innerOrder = opts.innerOrder || defaultInnerOrder;
        var sdp = [];
        // loop through outerOrder for matching properties on session
        outerOrder.forEach(function(type) {
            grammar[type].forEach(function(obj) {
                if (obj.name in session && session[obj.name] != null) sdp.push(makeLine(type, obj, session));
                else if (obj.push in session && session[obj.push] != null) session[obj.push].forEach(function(el) {
                    sdp.push(makeLine(type, obj, el));
                });
            });
        });
        // then for each media line, follow the innerOrder
        session.media.forEach(function(mLine) {
            sdp.push(makeLine('m', grammar.m[0], mLine));
            innerOrder.forEach(function(type) {
                grammar[type].forEach(function(obj) {
                    if (obj.name in mLine && mLine[obj.name] != null) sdp.push(makeLine(type, obj, mLine));
                    else if (obj.push in mLine && mLine[obj.push] != null) mLine[obj.push].forEach(function(el) {
                        sdp.push(makeLine(type, obj, el));
                    });
                });
            });
        });
        return sdp.join('\r\n') + '\r\n';
    };
    return $c0722d30b1d17141$var$writer;
}
var $c0722d30b1d17141$var$hasRequiredLib;
function $c0722d30b1d17141$var$requireLib() {
    if ($c0722d30b1d17141$var$hasRequiredLib) return $c0722d30b1d17141$var$lib;
    $c0722d30b1d17141$var$hasRequiredLib = 1;
    var parser = $c0722d30b1d17141$var$requireParser();
    var writer = $c0722d30b1d17141$var$requireWriter();
    var grammar = $c0722d30b1d17141$var$requireGrammar();
    $c0722d30b1d17141$var$lib.grammar = grammar;
    $c0722d30b1d17141$var$lib.write = writer;
    $c0722d30b1d17141$var$lib.parse = parser.parse;
    $c0722d30b1d17141$var$lib.parseParams = parser.parseParams;
    $c0722d30b1d17141$var$lib.parseFmtpConfig = parser.parseFmtpConfig; // Alias of parseParams().
    $c0722d30b1d17141$var$lib.parsePayloads = parser.parsePayloads;
    $c0722d30b1d17141$var$lib.parseRemoteCandidates = parser.parseRemoteCandidates;
    $c0722d30b1d17141$var$lib.parseImageAttributes = parser.parseImageAttributes;
    $c0722d30b1d17141$var$lib.parseSimulcastStreamList = parser.parseSimulcastStreamList;
    return $c0722d30b1d17141$var$lib;
}
var $c0722d30b1d17141$var$libExports = $c0722d30b1d17141$var$requireLib(); /**
 * Originally from ts-debounce (https://github.com/chodorowicz/ts-debounce)
 * with the following license:
 *
 * MIT License
 *
 * Copyright (c) 2017 Jakub Chodorowicz
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 * Modified to use CriticalTimers for reliable timer execution.
 */ 
/* eslint-disable @typescript-eslint/no-this-alias, @typescript-eslint/no-unused-expressions, @typescript-eslint/no-shadow */ function $c0722d30b1d17141$var$debounce(func) {
    let waitMilliseconds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _a, _b;
    let timeoutId;
    const isImmediate = (_a = options.isImmediate) !== null && _a !== void 0 ? _a : false;
    const callback = (_b = options.callback) !== null && _b !== void 0 ? _b : false;
    const maxWait = options.maxWait;
    let lastInvokeTime = Date.now();
    let promises = [];
    function nextInvokeTimeout() {
        if (maxWait !== undefined) {
            const timeSinceLastInvocation = Date.now() - lastInvokeTime;
            if (timeSinceLastInvocation + waitMilliseconds >= maxWait) return maxWait - timeSinceLastInvocation;
        }
        return waitMilliseconds;
    }
    const debouncedFunction = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        const context = this;
        return new Promise((resolve, reject)=>{
            const invokeFunction = function() {
                timeoutId = undefined;
                lastInvokeTime = Date.now();
                if (!isImmediate) {
                    const result = func.apply(context, args);
                    callback && callback(result);
                    // biome-ignore lint/suspicious/useIterableCallbackReturn: vendored code
                    promises.forEach((_ref)=>{
                        let { resolve: resolve } = _ref;
                        return resolve(result);
                    });
                    promises = [];
                }
            };
            const shouldCallNow = isImmediate && timeoutId === undefined;
            if (timeoutId !== undefined) $c0722d30b1d17141$export$22e737276454df96.clearTimeout(timeoutId);
            timeoutId = $c0722d30b1d17141$export$22e737276454df96.setTimeout(invokeFunction, nextInvokeTimeout());
            if (shouldCallNow) {
                const result = func.apply(context, args);
                callback && callback(result);
                return resolve(result);
            }
            promises.push({
                resolve: resolve,
                reject: reject
            });
        });
    };
    debouncedFunction.cancel = function(reason) {
        if (timeoutId !== undefined) $c0722d30b1d17141$export$22e737276454df96.clearTimeout(timeoutId);
        // biome-ignore lint/suspicious/useIterableCallbackReturn: vendored code
        promises.forEach((_ref2)=>{
            let { reject: reject } = _ref2;
            return reject(reason);
        });
        promises = [];
    };
    return debouncedFunction;
} /* The svc codec (av1/vp9) would use a very low bitrate at the begining and
increase slowly by the bandwidth estimator until it reach the target bitrate. The
process commonly cost more than 10 seconds cause subscriber will get blur video at
the first few seconds. So we use a 70% of target bitrate here as the start bitrate to
eliminate this issue.
*/ 
const $c0722d30b1d17141$var$startBitrateForSVC = 0.7;
const $c0722d30b1d17141$var$debounceInterval = 20;
const $c0722d30b1d17141$var$PCEvents = {
    NegotiationStarted: 'negotiationStarted',
    NegotiationComplete: 'negotiationComplete',
    // Fired with the offerId for every successful publisher answer application,
    // including answers that immediately recurse into another offer via
    // `renegotiate`. Use this rather than NegotiationComplete to know that a
    // specific offer has been negotiated end-to-end.
    OfferAnswered: 'offerAnswered',
    RTPVideoPayloadTypes: 'rtpVideoPayloadTypes'
};
/** @internal */ class $c0722d30b1d17141$var$PCTransport extends $c0722d30b1d17141$var$eventsExports.EventEmitter {
    get pc() {
        if (!this._pc) this._pc = this.createPC();
        return this._pc;
    }
    constructor(config){
        let loggerOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _a;
        super();
        this.log = $c0722d30b1d17141$var$livekitLogger;
        this.ddExtID = 0;
        this.latestOfferId = 0;
        this.latestAcknowledgedOfferId = 0;
        this.pendingCandidates = [];
        this.restartingIce = false;
        this.renegotiate = false;
        this.trackBitrates = [];
        this.remoteStereoMids = [];
        this.remoteNackMids = [];
        // debounced negotiate interface
        this.negotiate = $c0722d30b1d17141$var$debounce((onError)=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                this.emit($c0722d30b1d17141$var$PCEvents.NegotiationStarted);
                try {
                    yield this.createAndSendOffer();
                } catch (e) {
                    if (onError) onError(e);
                    else throw e;
                }
            }), $c0722d30b1d17141$var$debounceInterval);
        this.close = ()=>{
            if (!this._pc) return;
            this.pendingInitialOffer = undefined;
            this._pc.close();
            this._pc.onconnectionstatechange = null;
            this._pc.oniceconnectionstatechange = null;
            this._pc.onicegatheringstatechange = null;
            this._pc.ondatachannel = null;
            this._pc.onnegotiationneeded = null;
            this._pc.onsignalingstatechange = null;
            this._pc.onicecandidate = null;
            this._pc.ondatachannel = null;
            this._pc.ontrack = null;
            this._pc.onconnectionstatechange = null;
            this._pc.oniceconnectionstatechange = null;
            this._pc = null;
        };
        this.log = $c0722d30b1d17141$export$2b1d391cd05230fd((_a = loggerOptions.loggerName) !== null && _a !== void 0 ? _a : $c0722d30b1d17141$export$69ba24dd79f4da21.PCTransport);
        this.loggerOptions = loggerOptions;
        this.config = config;
        this._pc = this.createPC();
        this.offerLock = new $c0722d30b1d17141$export$ca12f2943758ef55();
    }
    createPC() {
        const pc = new RTCPeerConnection(this.config);
        pc.onicecandidate = (ev)=>{
            var _a;
            if (!ev.candidate) return;
            (_a = this.onIceCandidate) === null || _a === void 0 || _a.call(this, ev.candidate);
        };
        pc.onicecandidateerror = (ev)=>{
            var _a;
            (_a = this.onIceCandidateError) === null || _a === void 0 || _a.call(this, ev);
        };
        pc.oniceconnectionstatechange = ()=>{
            var _a;
            (_a = this.onIceConnectionStateChange) === null || _a === void 0 || _a.call(this, pc.iceConnectionState);
        };
        pc.onsignalingstatechange = ()=>{
            var _a;
            (_a = this.onSignalingStatechange) === null || _a === void 0 || _a.call(this, pc.signalingState);
        };
        pc.onconnectionstatechange = ()=>{
            var _a;
            (_a = this.onConnectionStateChange) === null || _a === void 0 || _a.call(this, pc.connectionState);
        };
        pc.ondatachannel = (ev)=>{
            var _a;
            (_a = this.onDataChannel) === null || _a === void 0 || _a.call(this, ev);
        };
        pc.ontrack = (ev)=>{
            var _a;
            (_a = this.onTrack) === null || _a === void 0 || _a.call(this, ev);
        };
        return pc;
    }
    get logContext() {
        var _a, _b;
        return Object.assign({}, (_b = (_a = this.loggerOptions).loggerContextCb) === null || _b === void 0 ? void 0 : _b.call(_a));
    }
    get isICEConnected() {
        return this._pc !== null && (this.pc.iceConnectionState === 'connected' || this.pc.iceConnectionState === 'completed');
    }
    addIceCandidate(candidate) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            if (this.pc.remoteDescription && !this.restartingIce) return this.pc.addIceCandidate(candidate);
            this.pendingCandidates.push(candidate);
        });
    }
    setRemoteDescription(sd, offerId) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            if (sd.type === 'answer' && this.latestOfferId > 0 && offerId > 0 && offerId !== this.latestOfferId) {
                this.log.warn('ignoring answer for old offer', Object.assign(Object.assign({}, this.logContext), {
                    offerId: offerId,
                    latestOfferId: this.latestOfferId
                }));
                return false;
            }
            let mungedSDP = undefined;
            if (sd.type === 'offer') {
                let { stereoMids: stereoMids, nackMids: nackMids } = $c0722d30b1d17141$var$extractStereoAndNackAudioFromOffer(sd);
                this.remoteStereoMids = stereoMids;
                this.remoteNackMids = nackMids;
            } else if (sd.type === 'answer') {
                if (this.pendingInitialOffer && this._pc) {
                    const initialOffer = this.pendingInitialOffer;
                    this.pendingInitialOffer = undefined;
                    const sdpParsed = $c0722d30b1d17141$var$libExports.parse((_a = initialOffer.sdp) !== null && _a !== void 0 ? _a : '');
                    sdpParsed.media.forEach((media)=>{
                        $c0722d30b1d17141$var$ensureIPAddrMatchVersion(media);
                    });
                    this.log.debug('setting pending initial offer before processing answer', this.logContext);
                    yield this.setMungedSDP(initialOffer, $c0722d30b1d17141$var$libExports.write(sdpParsed));
                }
                const sdpParsed = $c0722d30b1d17141$var$libExports.parse((_b = sd.sdp) !== null && _b !== void 0 ? _b : '');
                sdpParsed.media.forEach((media)=>{
                    const mid = $c0722d30b1d17141$var$getMidString(media.mid);
                    if (media.type === 'audio') // munge sdp for opus bitrate settings
                    this.trackBitrates.some((trackbr)=>{
                        if (!trackbr.transceiver || mid != trackbr.transceiver.mid) return false;
                        let codecPayload = 0;
                        media.rtp.some((rtp)=>{
                            if (rtp.codec.toUpperCase() === trackbr.codec.toUpperCase()) {
                                codecPayload = rtp.payload;
                                return true;
                            }
                            return false;
                        });
                        if (codecPayload === 0) return true;
                        let fmtpFound = false;
                        for (const fmtp of media.fmtp)if (fmtp.payload === codecPayload) {
                            fmtp.config = fmtp.config.split(';').filter((attr)=>!attr.includes('maxaveragebitrate')).join(';');
                            if (trackbr.maxbr > 0) fmtp.config += ";maxaveragebitrate=".concat(trackbr.maxbr * 1000);
                            fmtpFound = true;
                            break;
                        }
                        if (!fmtpFound) {
                            if (trackbr.maxbr > 0) media.fmtp.push({
                                payload: codecPayload,
                                config: "maxaveragebitrate=".concat(trackbr.maxbr * 1000)
                            });
                        }
                        return true;
                    });
                });
                mungedSDP = $c0722d30b1d17141$var$libExports.write(sdpParsed);
            }
            yield this.setMungedSDP(sd, mungedSDP, true);
            this.pendingCandidates.forEach((candidate)=>{
                this.pc.addIceCandidate(candidate);
            });
            this.pendingCandidates = [];
            this.restartingIce = false;
            // Fire OfferAnswered for every successfully applied answer, including the
            // ones that recurse into another offer via `renegotiate`. Callers waiting
            // on a specific offerId can resolve as soon as their offer's answer is in.
            if (sd.type === 'answer') {
                this.latestAcknowledgedOfferId = offerId;
                this.emit($c0722d30b1d17141$var$PCEvents.OfferAnswered, offerId);
            }
            if (this.renegotiate) {
                this.renegotiate = false;
                yield this.createAndSendOffer();
            } else if (sd.type === 'answer') {
                this.emit($c0722d30b1d17141$var$PCEvents.NegotiationComplete);
                if (sd.sdp) {
                    const sdpParsed = $c0722d30b1d17141$var$libExports.parse(sd.sdp);
                    sdpParsed.media.forEach((media)=>{
                        if (media.type === 'video') this.emit($c0722d30b1d17141$var$PCEvents.RTPVideoPayloadTypes, media.rtp);
                    });
                }
            }
            return true;
        });
    }
    createInitialOffer() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const unlock = yield this.offerLock.lock();
            try {
                if (this.pc.signalingState !== 'stable') {
                    this.log.warn('signaling state is not stable, cannot create initial offer', this.logContext);
                    return;
                }
                const offerId = this.latestOfferId + 1;
                this.latestOfferId = offerId;
                const offer = yield this.pc.createOffer();
                this.pendingInitialOffer = {
                    sdp: offer.sdp,
                    type: offer.type
                };
                const sdpParsed = $c0722d30b1d17141$var$libExports.parse((_a = offer.sdp) !== null && _a !== void 0 ? _a : '');
                sdpParsed.media.forEach((media)=>{
                    $c0722d30b1d17141$var$ensureIPAddrMatchVersion(media);
                });
                offer.sdp = $c0722d30b1d17141$var$libExports.write(sdpParsed);
                return {
                    offer: offer,
                    offerId: offerId
                };
            } finally{
                unlock();
            }
        });
    }
    createAndSendOffer(options) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const unlock = yield this.offerLock.lock();
            try {
                if (this.onOffer === undefined) return;
                if (options === null || options === void 0 ? void 0 : options.iceRestart) {
                    this.log.debug('restarting ICE', this.logContext);
                    this.restartingIce = true;
                }
                if (this._pc && (this._pc.signalingState === 'have-local-offer' || this.pendingInitialOffer)) {
                    // we're waiting for the peer to accept our offer, so we'll just wait
                    // the only exception to this is when ICE restart is needed
                    const currentSD = this._pc.remoteDescription;
                    if ((options === null || options === void 0 ? void 0 : options.iceRestart) && currentSD) // TODO: handle when ICE restart is needed but we don't have a remote description
                    // the best thing to do is to recreate the peerconnection
                    yield this._pc.setRemoteDescription(currentSD);
                    else {
                        this.renegotiate = true;
                        this.log.debug('requesting renegotiation', Object.assign({}, this.logContext));
                        return;
                    }
                } else if (!this._pc || this._pc.signalingState === 'closed') {
                    this.log.warn('could not createOffer with closed peer connection', this.logContext);
                    return;
                }
                // actually negotiate
                this.log.debug('starting to negotiate', this.logContext);
                // increase the offer id at the start to ensure the offer is always > 0 so that we can use 0 as a default value for legacy behavior
                const offerId = this.latestOfferId + 1;
                this.latestOfferId = offerId;
                const offer = yield this.pc.createOffer(options);
                this.log.debug('original offer', Object.assign({
                    sdp: offer.sdp
                }, this.logContext));
                const sdpParsed = $c0722d30b1d17141$var$libExports.parse((_a = offer.sdp) !== null && _a !== void 0 ? _a : '');
                sdpParsed.media.forEach((media)=>{
                    $c0722d30b1d17141$var$ensureIPAddrMatchVersion(media);
                    if (media.type === 'audio') $c0722d30b1d17141$var$ensureAudioNackAndStereo(media, [
                        'all'
                    ], []);
                    else if (media.type === 'video') this.trackBitrates.some((trackbr)=>{
                        if (!media.msid || !trackbr.cid || !media.msid.includes(trackbr.cid)) return false;
                        let codecPayload = 0;
                        media.rtp.some((rtp)=>{
                            if (rtp.codec.toUpperCase() === trackbr.codec.toUpperCase()) {
                                codecPayload = rtp.payload;
                                return true;
                            }
                            return false;
                        });
                        if (codecPayload === 0) return true;
                        if ($c0722d30b1d17141$var$isSVCCodec(trackbr.codec) && !$c0722d30b1d17141$var$isSafari()) this.ensureVideoDDExtensionForSVC(media, sdpParsed);
                        // mung sdp for bitrate setting that can't apply by sendEncoding
                        if (!$c0722d30b1d17141$var$isSVCCodec(trackbr.codec)) return true;
                        const startBitrate = Math.round(trackbr.maxbr * $c0722d30b1d17141$var$startBitrateForSVC);
                        for (const fmtp of media.fmtp)if (fmtp.payload === codecPayload) {
                            // if another track's fmtp already is set, we cannot override the bitrate
                            // this has the unfortunate consequence of being forced to use the
                            // initial track's bitrate for all tracks
                            if (!fmtp.config.includes('x-google-start-bitrate')) fmtp.config += ";x-google-start-bitrate=".concat(startBitrate);
                            break;
                        }
                        return true;
                    });
                });
                if (this.latestOfferId > offerId) {
                    this.log.warn('latestOfferId mismatch', Object.assign(Object.assign({}, this.logContext), {
                        latestOfferId: this.latestOfferId,
                        offerId: offerId
                    }));
                    return;
                }
                yield this.setMungedSDP(offer, $c0722d30b1d17141$var$libExports.write(sdpParsed));
                this.onOffer(offer, this.latestOfferId);
            } finally{
                unlock();
            }
        });
    }
    createAndSetAnswer() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const answer = yield this.pc.createAnswer();
            const sdpParsed = $c0722d30b1d17141$var$libExports.parse((_a = answer.sdp) !== null && _a !== void 0 ? _a : '');
            sdpParsed.media.forEach((media)=>{
                $c0722d30b1d17141$var$ensureIPAddrMatchVersion(media);
                if (media.type === 'audio') $c0722d30b1d17141$var$ensureAudioNackAndStereo(media, this.remoteStereoMids, this.remoteNackMids);
            });
            yield this.setMungedSDP(answer, $c0722d30b1d17141$var$libExports.write(sdpParsed));
            return answer;
        });
    }
    createDataChannel(label, dataChannelDict) {
        return this.pc.createDataChannel(label, dataChannelDict);
    }
    addTransceiver(mediaStreamTrack, transceiverInit) {
        return this.pc.addTransceiver(mediaStreamTrack, transceiverInit);
    }
    addTransceiverOfKind(kind, transceiverInit) {
        return this.pc.addTransceiver(kind, transceiverInit);
    }
    addTrack(track) {
        if (!this._pc) throw new $c0722d30b1d17141$export$1f388e244efbf70b('PC closed, cannot add track');
        return this._pc.addTrack(track);
    }
    setTrackCodecBitrate(info) {
        this.trackBitrates.push(info);
    }
    setConfiguration(rtcConfig) {
        var _a;
        if (!this._pc) throw new $c0722d30b1d17141$export$1f388e244efbf70b('PC closed, cannot configure');
        return (_a = this._pc) === null || _a === void 0 ? void 0 : _a.setConfiguration(rtcConfig);
    }
    canRemoveTrack() {
        var _a;
        return !!((_a = this._pc) === null || _a === void 0 ? void 0 : _a.removeTrack);
    }
    removeTrack(sender) {
        var _a;
        return (_a = this._pc) === null || _a === void 0 ? void 0 : _a.removeTrack(sender);
    }
    getConnectionState() {
        var _a, _b;
        return (_b = (_a = this._pc) === null || _a === void 0 ? void 0 : _a.connectionState) !== null && _b !== void 0 ? _b : 'closed';
    }
    getICEConnectionState() {
        var _a, _b;
        return (_b = (_a = this._pc) === null || _a === void 0 ? void 0 : _a.iceConnectionState) !== null && _b !== void 0 ? _b : 'closed';
    }
    getSignallingState() {
        var _a, _b;
        return (_b = (_a = this._pc) === null || _a === void 0 ? void 0 : _a.signalingState) !== null && _b !== void 0 ? _b : 'closed';
    }
    getTransceivers() {
        var _a, _b;
        return (_b = (_a = this._pc) === null || _a === void 0 ? void 0 : _a.getTransceivers()) !== null && _b !== void 0 ? _b : [];
    }
    getSenders() {
        var _a, _b;
        return (_b = (_a = this._pc) === null || _a === void 0 ? void 0 : _a.getSenders()) !== null && _b !== void 0 ? _b : [];
    }
    getLocalDescription() {
        var _a;
        return (_a = this._pc) === null || _a === void 0 ? void 0 : _a.localDescription;
    }
    getRemoteDescription() {
        var _a;
        return (_a = this.pc) === null || _a === void 0 ? void 0 : _a.remoteDescription;
    }
    getStats() {
        return this.pc.getStats();
    }
    getConnectedAddress() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            if (!this._pc) return;
            let selectedCandidatePairId = '';
            const candidatePairs = new Map();
            // id -> candidate ip
            const candidates = new Map();
            const stats = yield this._pc.getStats();
            stats.forEach((v)=>{
                switch(v.type){
                    case 'transport':
                        selectedCandidatePairId = v.selectedCandidatePairId;
                        break;
                    case 'candidate-pair':
                        if (selectedCandidatePairId === '' && v.selected) selectedCandidatePairId = v.id;
                        candidatePairs.set(v.id, v);
                        break;
                    case 'remote-candidate':
                        candidates.set(v.id, "".concat(v.address, ":").concat(v.port));
                        break;
                }
            });
            if (selectedCandidatePairId === '') return undefined;
            const selectedID = (_a = candidatePairs.get(selectedCandidatePairId)) === null || _a === void 0 ? void 0 : _a.remoteCandidateId;
            if (selectedID === undefined) return undefined;
            return candidates.get(selectedID);
        });
    }
    setMungedSDP(sd, munged, remote) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            const originalSdp = sd.sdp;
            if (munged) {
                sd.sdp = munged;
                try {
                    this.log.debug("setting munged ".concat(remote ? 'remote' : 'local', " description"), this.logContext);
                    if (remote) yield this.pc.setRemoteDescription(sd);
                    else yield this.pc.setLocalDescription(sd);
                    return;
                } catch (e) {
                    this.log.warn("not able to set ".concat(sd.type, ", falling back to unmodified sdp"), Object.assign(Object.assign({}, this.logContext), {
                        error: e,
                        mungedSdp: munged,
                        originalSdp: originalSdp
                    }));
                    sd.sdp = originalSdp;
                }
            }
            try {
                if (remote) yield (_a = this._pc) === null || _a === void 0 ? void 0 : _a.setRemoteDescription(sd);
                else yield (_b = this._pc) === null || _b === void 0 ? void 0 : _b.setLocalDescription(sd);
            } catch (e) {
                let msg = 'unknown error';
                if (e instanceof Error) msg = e.message;
                else if (typeof e === 'string') msg = e;
                const fields = {
                    error: msg,
                    sdp: sd.sdp
                };
                if (munged && munged !== originalSdp) fields.mungedSdp = munged;
                if (!remote && this.pc.remoteDescription) fields.remoteSdp = this.pc.remoteDescription;
                this.log.error("unable to set ".concat(sd.type), Object.assign(Object.assign({}, this.logContext), {
                    fields: fields
                }));
                throw new $c0722d30b1d17141$export$18c2792bacf23e39(msg);
            }
        });
    }
    ensureVideoDDExtensionForSVC(media, sdp) {
        var _a, _b;
        const ddFound = (_a = media.ext) === null || _a === void 0 ? void 0 : _a.some((ext)=>{
            if (ext.uri === $c0722d30b1d17141$var$ddExtensionURI) return true;
            return false;
        });
        if (!ddFound) {
            if (this.ddExtID === 0) {
                let maxID = 0;
                sdp.media.forEach((m)=>{
                    var _a;
                    (_a = m.ext) === null || _a === void 0 || _a.forEach((ext)=>{
                        if (ext.value > maxID) maxID = ext.value;
                    });
                });
                this.ddExtID = maxID + 1;
            }
            (_b = media.ext) === null || _b === void 0 || _b.push({
                value: this.ddExtID,
                uri: $c0722d30b1d17141$var$ddExtensionURI
            });
        }
    }
}
function $c0722d30b1d17141$var$ensureAudioNackAndStereo(media, stereoMids, nackMids) {
    // sdp-transform types don't include number however the parser outputs mids as numbers in some cases
    const mid = $c0722d30b1d17141$var$getMidString(media.mid);
    // found opus codec to add nack fb
    let opusPayload = 0;
    media.rtp.some((rtp)=>{
        if (rtp.codec === 'opus') {
            opusPayload = rtp.payload;
            return true;
        }
        return false;
    });
    // add nack rtcpfb if not exist
    if (opusPayload > 0) {
        if (!media.rtcpFb) media.rtcpFb = [];
        if (nackMids.includes(mid) && !media.rtcpFb.some((fb)=>fb.payload === opusPayload && fb.type === 'nack')) media.rtcpFb.push({
            payload: opusPayload,
            type: 'nack'
        });
        if (stereoMids.includes(mid) || stereoMids.length === 1 && stereoMids[0] === 'all') media.fmtp.some((fmtp)=>{
            if (fmtp.payload === opusPayload) {
                if (!fmtp.config.includes('stereo=1')) fmtp.config += ';stereo=1';
                return true;
            }
            return false;
        });
    }
}
function $c0722d30b1d17141$var$extractStereoAndNackAudioFromOffer(offer) {
    var _a;
    const stereoMids = [];
    const nackMids = [];
    const sdpParsed = $c0722d30b1d17141$var$libExports.parse((_a = offer.sdp) !== null && _a !== void 0 ? _a : '');
    let opusPayload = 0;
    sdpParsed.media.forEach((media)=>{
        var _a;
        const mid = $c0722d30b1d17141$var$getMidString(media.mid);
        if (media.type === 'audio') {
            media.rtp.some((rtp)=>{
                if (rtp.codec === 'opus') {
                    opusPayload = rtp.payload;
                    return true;
                }
                return false;
            });
            if ((_a = media.rtcpFb) === null || _a === void 0 ? void 0 : _a.some((fb)=>fb.payload === opusPayload && fb.type === 'nack')) nackMids.push(mid);
            media.fmtp.some((fmtp)=>{
                if (fmtp.payload === opusPayload) {
                    if (fmtp.config.includes('sprop-stereo=1')) stereoMids.push(mid);
                    return true;
                }
                return false;
            });
        }
    });
    return {
        stereoMids: stereoMids,
        nackMids: nackMids
    };
}
function $c0722d30b1d17141$var$ensureIPAddrMatchVersion(media) {
    // Chrome could generate sdp with c = IN IP4 <ipv6 addr>
    // in edge case and return error when set sdp.This is not a
    // sdk error but correct it if the issue detected.
    if (media.connection) {
        const isV6 = media.connection.ip.indexOf(':') >= 0;
        if (media.connection.version === 4 && isV6 || media.connection.version === 6 && !isV6) {
            // fallback to dummy address
            media.connection.ip = '0.0.0.0';
            media.connection.version = 4;
        }
    }
}
function $c0722d30b1d17141$var$getMidString(mid) {
    return typeof mid === 'number' ? mid.toFixed(0) : mid;
}
const $c0722d30b1d17141$var$defaultVideoCodec = 'vp8';
const $c0722d30b1d17141$var$publishDefaults = {
    audioPreset: $c0722d30b1d17141$export$5da93632511fdb1f.music,
    dtx: true,
    red: true,
    forceStereo: false,
    simulcast: true,
    screenShareEncoding: $c0722d30b1d17141$export$a6cdf9dcd3d32f2d.h1080fps15.encoding,
    stopMicTrackOnMute: false,
    videoCodec: $c0722d30b1d17141$var$defaultVideoCodec,
    backupCodec: true,
    preConnectBuffer: false
};
const $c0722d30b1d17141$var$audioDefaults = {
    deviceId: {
        ideal: 'default'
    },
    autoGainControl: true,
    echoCancellation: true,
    noiseSuppression: true,
    voiceIsolation: true
};
const $c0722d30b1d17141$var$videoDefaults = {
    deviceId: {
        ideal: 'default'
    },
    resolution: $c0722d30b1d17141$export$79d56065dad1674c.h720.resolution
};
const $c0722d30b1d17141$var$roomOptionDefaults = {
    adaptiveStream: false,
    dynacast: false,
    stopLocalTrackOnUnpublish: true,
    reconnectPolicy: new $c0722d30b1d17141$export$97bc471d6a059e6e(),
    disconnectOnPageLeave: true,
    webAudioMix: false,
    singlePeerConnection: true
};
const $c0722d30b1d17141$var$roomConnectOptionDefaults = {
    autoSubscribe: true,
    maxRetries: 1,
    peerConnectionTimeout: 15000,
    websocketTimeout: 15000
};
var $c0722d30b1d17141$var$PCTransportState;
(function(PCTransportState) {
    PCTransportState[PCTransportState["NEW"] = 0] = "NEW";
    PCTransportState[PCTransportState["CONNECTING"] = 1] = "CONNECTING";
    PCTransportState[PCTransportState["CONNECTED"] = 2] = "CONNECTED";
    PCTransportState[PCTransportState["FAILED"] = 3] = "FAILED";
    PCTransportState[PCTransportState["CLOSING"] = 4] = "CLOSING";
    PCTransportState[PCTransportState["CLOSED"] = 5] = "CLOSED";
})($c0722d30b1d17141$var$PCTransportState || ($c0722d30b1d17141$var$PCTransportState = {}));
class $c0722d30b1d17141$var$PCTransportManager {
    get needsPublisher() {
        return this.isPublisherConnectionRequired;
    }
    get needsSubscriber() {
        return this.isSubscriberConnectionRequired;
    }
    get currentState() {
        return this.state;
    }
    get mode() {
        return this._mode;
    }
    constructor(mode, loggerOptions, rtcConfig){
        var _a;
        this.peerConnectionTimeout = $c0722d30b1d17141$var$roomConnectOptionDefaults.peerConnectionTimeout;
        this.log = $c0722d30b1d17141$var$livekitLogger;
        this.updateState = ()=>{
            var _a, _b;
            const previousState = this.state;
            const connectionStates = this.requiredTransports.map((tr)=>tr.getConnectionState());
            if (connectionStates.every((st)=>st === 'connected')) this.state = $c0722d30b1d17141$var$PCTransportState.CONNECTED;
            else if (connectionStates.some((st)=>st === 'failed')) this.state = $c0722d30b1d17141$var$PCTransportState.FAILED;
            else if (connectionStates.some((st)=>st === 'connecting')) this.state = $c0722d30b1d17141$var$PCTransportState.CONNECTING;
            else if (connectionStates.every((st)=>st === 'closed')) this.state = $c0722d30b1d17141$var$PCTransportState.CLOSED;
            else if (connectionStates.some((st)=>st === 'closed')) this.state = $c0722d30b1d17141$var$PCTransportState.CLOSING;
            else if (connectionStates.every((st)=>st === 'new')) this.state = $c0722d30b1d17141$var$PCTransportState.NEW;
            if (previousState !== this.state) {
                this.log.debug("pc state change: from ".concat($c0722d30b1d17141$var$PCTransportState[previousState], " to ").concat($c0722d30b1d17141$var$PCTransportState[this.state]), this.logContext);
                (_a = this.onStateChange) === null || _a === void 0 || _a.call(this, this.state, this.publisher.getConnectionState(), (_b = this.subscriber) === null || _b === void 0 ? void 0 : _b.getConnectionState());
            }
        };
        this.log = $c0722d30b1d17141$export$2b1d391cd05230fd((_a = loggerOptions.loggerName) !== null && _a !== void 0 ? _a : $c0722d30b1d17141$export$69ba24dd79f4da21.PCManager);
        this.loggerOptions = loggerOptions;
        this.isPublisherConnectionRequired = mode !== 'subscriber-primary';
        this.isSubscriberConnectionRequired = mode === 'subscriber-primary';
        this.publisher = new $c0722d30b1d17141$var$PCTransport(rtcConfig, loggerOptions);
        this._mode = mode;
        if (mode !== 'publisher-only') {
            this.subscriber = new $c0722d30b1d17141$var$PCTransport(rtcConfig, loggerOptions);
            this.subscriber.onConnectionStateChange = this.updateState;
            this.subscriber.onIceConnectionStateChange = this.updateState;
            this.subscriber.onSignalingStatechange = this.updateState;
            this.subscriber.onIceCandidate = (candidate)=>{
                var _a;
                (_a = this.onIceCandidate) === null || _a === void 0 || _a.call(this, candidate, $c0722d30b1d17141$var$SignalTarget.SUBSCRIBER);
            };
            // in subscriber primary mode, server side opens sub data channels.
            this.subscriber.onDataChannel = (ev)=>{
                var _a;
                (_a = this.onDataChannel) === null || _a === void 0 || _a.call(this, ev);
            };
            this.subscriber.onTrack = (ev)=>{
                var _a;
                (_a = this.onTrack) === null || _a === void 0 || _a.call(this, ev);
            };
        }
        this.publisher.onConnectionStateChange = this.updateState;
        this.publisher.onIceConnectionStateChange = this.updateState;
        this.publisher.onSignalingStatechange = this.updateState;
        this.publisher.onIceCandidate = (candidate)=>{
            var _a;
            (_a = this.onIceCandidate) === null || _a === void 0 || _a.call(this, candidate, $c0722d30b1d17141$var$SignalTarget.PUBLISHER);
        };
        this.publisher.onTrack = (ev)=>{
            var _a;
            (_a = this.onTrack) === null || _a === void 0 || _a.call(this, ev);
        };
        this.publisher.onOffer = (offer, offerId)=>{
            var _a;
            (_a = this.onPublisherOffer) === null || _a === void 0 || _a.call(this, offer, offerId);
        };
        this.state = $c0722d30b1d17141$var$PCTransportState.NEW;
        this.connectionLock = new $c0722d30b1d17141$export$ca12f2943758ef55();
        this.remoteOfferLock = new $c0722d30b1d17141$export$ca12f2943758ef55();
    }
    get logContext() {
        var _a, _b;
        return Object.assign({}, (_b = (_a = this.loggerOptions).loggerContextCb) === null || _b === void 0 ? void 0 : _b.call(_a));
    }
    requirePublisher() {
        let require = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        this.isPublisherConnectionRequired = require;
        this.updateState();
    }
    createAndSendPublisherOffer(options) {
        return this.publisher.createAndSendOffer(options);
    }
    setPublisherAnswer(sd, offerId) {
        return this.publisher.setRemoteDescription(sd, offerId);
    }
    removeTrack(sender) {
        return this.publisher.removeTrack(sender);
    }
    close() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            if (this.publisher && this.publisher.getSignallingState() !== 'closed') {
                const publisher = this.publisher;
                for (const sender of publisher.getSenders())try {
                    // TODO: react-native-webrtc doesn't have removeTrack yet.
                    if (publisher.canRemoveTrack()) publisher.removeTrack(sender);
                } catch (e) {
                    this.log.warn('could not removeTrack', Object.assign(Object.assign({}, this.logContext), {
                        error: e
                    }));
                }
            }
            yield Promise.all([
                this.publisher.close(),
                (_a = this.subscriber) === null || _a === void 0 ? void 0 : _a.close()
            ]);
            this.updateState();
        });
    }
    triggerIceRestart() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            if (this.subscriber) this.subscriber.restartingIce = true;
            // only restart publisher if it's needed
            if (this.needsPublisher) yield this.createAndSendPublisherOffer({
                iceRestart: true
            });
        });
    }
    addIceCandidate(candidate, target) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            if (target === $c0722d30b1d17141$var$SignalTarget.PUBLISHER) yield this.publisher.addIceCandidate(candidate);
            else yield (_a = this.subscriber) === null || _a === void 0 ? void 0 : _a.addIceCandidate(candidate);
        });
    }
    createSubscriberAnswerFromOffer(sd, offerId) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c;
            this.log.debug('received server offer', Object.assign(Object.assign({}, this.logContext), {
                RTCSdpType: sd.type,
                sdp: sd.sdp,
                signalingState: (_a = this.subscriber) === null || _a === void 0 ? void 0 : _a.getSignallingState().toString()
            }));
            const unlock = yield this.remoteOfferLock.lock();
            try {
                const success = yield (_b = this.subscriber) === null || _b === void 0 ? void 0 : _b.setRemoteDescription(sd, offerId);
                if (!success) return undefined;
                // answer the offer
                const answer = yield (_c = this.subscriber) === null || _c === void 0 ? void 0 : _c.createAndSetAnswer();
                return answer;
            } finally{
                unlock();
            }
        });
    }
    updateConfiguration(config, iceRestart) {
        var _a;
        this.publisher.setConfiguration(config);
        (_a = this.subscriber) === null || _a === void 0 || _a.setConfiguration(config);
        if (iceRestart) this.triggerIceRestart();
    }
    ensurePCTransportConnection(abortController, timeout) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const unlock = yield this.connectionLock.lock();
            try {
                if (this.isPublisherConnectionRequired && this.publisher.getConnectionState() !== 'connected' && this.publisher.getConnectionState() !== 'connecting') {
                    this.log.debug('negotiation required, start negotiating', this.logContext);
                    this.publisher.negotiate();
                }
                yield Promise.all((_a = this.requiredTransports) === null || _a === void 0 ? void 0 : _a.map((transport)=>this.ensureTransportConnected(transport, abortController, timeout)));
            } finally{
                unlock();
            }
        });
    }
    negotiate(abortController) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            return new $c0722d30b1d17141$var$TypedPromise((resolve, reject)=>{
                // Capture the publisher's latest offer id at request time. We are done
                // when an offer with a higher id has had its answer successfully
                // applied — that offer is the one that includes any transceiver/SDP
                // changes that motivated this negotiate call. Concurrent callers each
                // get their own checkpoint and resolve independently.
                const checkpoint = this.publisher.latestOfferId;
                // Race: an answer past our checkpoint already arrived before we had a
                // chance to subscribe.
                if (this.publisher.latestAcknowledgedOfferId > checkpoint) {
                    this.log.debug("negotiation already handled in more recent acknowledged offer", this.logContext);
                    resolve();
                    return;
                }
                let cleanedUp = false;
                const cleanup = ()=>{
                    if (cleanedUp) return;
                    cleanedUp = true;
                    clearTimeout(deadlineTimer);
                    this.publisher.off($c0722d30b1d17141$var$PCEvents.OfferAnswered, onAnswered);
                    abortController.signal.removeEventListener('abort', onAbort);
                };
                const onAnswered = (offerId)=>{
                    if (offerId > checkpoint) {
                        cleanup();
                        resolve();
                    }
                };
                const onAbort = ()=>{
                    cleanup();
                    reject(new $c0722d30b1d17141$export$18c2792bacf23e39('negotiation aborted'));
                };
                // Single hard deadline as a backstop. Not reset on cycle progress —
                // progress is tracked via OfferAnswered, not NegotiationStarted.
                const deadlineTimer = setTimeout(()=>{
                    cleanup();
                    reject(new $c0722d30b1d17141$export$18c2792bacf23e39('negotiation timed out'));
                }, this.peerConnectionTimeout);
                abortController.signal.addEventListener('abort', onAbort);
                this.publisher.on($c0722d30b1d17141$var$PCEvents.OfferAnswered, onAnswered);
                this.publisher.negotiate((e)=>{
                    cleanup();
                    if (e instanceof Error) reject(e);
                    else reject(new Error(String(e)));
                });
            });
        });
    }
    addPublisherTransceiver(track, transceiverInit) {
        return this.publisher.addTransceiver(track, transceiverInit);
    }
    addPublisherTransceiverOfKind(kind, transceiverInit) {
        return this.publisher.addTransceiverOfKind(kind, transceiverInit);
    }
    getMidForReceiver(receiver) {
        const transceivers = this.subscriber ? this.subscriber.getTransceivers() : this.publisher.getTransceivers();
        const matchingTransceiver = transceivers.find((transceiver)=>transceiver.receiver === receiver);
        return matchingTransceiver === null || matchingTransceiver === void 0 ? void 0 : matchingTransceiver.mid;
    }
    addPublisherTrack(track) {
        return this.publisher.addTrack(track);
    }
    createPublisherDataChannel(label, dataChannelDict) {
        return this.publisher.createDataChannel(label, dataChannelDict);
    }
    /**
   * Returns the first required transport's address if no explicit target is specified
   */ getConnectedAddress(target) {
        if (target === $c0722d30b1d17141$var$SignalTarget.PUBLISHER) return this.publisher.getConnectedAddress();
        else if (target === $c0722d30b1d17141$var$SignalTarget.SUBSCRIBER) return this.publisher.getConnectedAddress();
        return this.requiredTransports[0].getConnectedAddress();
    }
    get requiredTransports() {
        const transports = [];
        if (this.isPublisherConnectionRequired) transports.push(this.publisher);
        if (this.isSubscriberConnectionRequired && this.subscriber) transports.push(this.subscriber);
        return transports;
    }
    ensureTransportConnected(pcTransport_1, abortController_1) {
        return $c0722d30b1d17141$var$__awaiter(this, arguments, void 0, function(pcTransport, abortController) {
            var _this = this;
            let timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.peerConnectionTimeout;
            return function*() {
                const connectionState = pcTransport.getConnectionState();
                if (connectionState === 'connected') return;
                return new Promise((resolve, reject)=>$c0722d30b1d17141$var$__awaiter(_this, void 0, void 0, function*() {
                        const abortHandler = ()=>{
                            this.log.warn('abort transport connection', this.logContext);
                            $c0722d30b1d17141$export$22e737276454df96.clearTimeout(connectTimeout);
                            reject($c0722d30b1d17141$export$a3747c6e46c7a8eb.cancelled('room connection has been cancelled'));
                        };
                        if (abortController === null || abortController === void 0 ? void 0 : abortController.signal.aborted) abortHandler();
                        abortController === null || abortController === void 0 || abortController.signal.addEventListener('abort', abortHandler);
                        const connectTimeout = $c0722d30b1d17141$export$22e737276454df96.setTimeout(()=>{
                            abortController === null || abortController === void 0 || abortController.signal.removeEventListener('abort', abortHandler);
                            reject($c0722d30b1d17141$export$a3747c6e46c7a8eb.internal('could not establish pc connection'));
                        }, timeout);
                        while(this.state !== $c0722d30b1d17141$var$PCTransportState.CONNECTED){
                            yield $c0722d30b1d17141$var$sleep(50); // FIXME we shouldn't rely on `sleep` in the connection paths, as it invokes `setTimeout` which can be drastically throttled by browser implementations
                            if (abortController === null || abortController === void 0 ? void 0 : abortController.signal.aborted) {
                                reject($c0722d30b1d17141$export$a3747c6e46c7a8eb.cancelled('room connection has been cancelled'));
                                return;
                            }
                        }
                        $c0722d30b1d17141$export$22e737276454df96.clearTimeout(connectTimeout);
                        abortController === null || abortController === void 0 || abortController.signal.removeEventListener('abort', abortHandler);
                        resolve();
                    }));
            }();
        });
    }
} // SPDX-FileCopyrightText: 2024 LiveKit, Inc.
//
// SPDX-License-Identifier: Apache-2.0
/**
 * Specialized error handling for RPC methods.
 *
 * Instances of this type, when thrown in a method handler, will have their `message`
 * serialized and sent across the wire. The sender will receive an equivalent error on the other side.
 *
 * Built-in types are included but developers may use any string, with a max length of 256 bytes.
 */ class $c0722d30b1d17141$export$5460eff990f31920 extends Error {
    /**
   * Creates an error object with the given code and message, plus an optional data payload.
   *
   * If thrown in an RPC method handler, the error will be sent back to the caller.
   *
   * Error codes 1001-1999 are reserved for built-in errors (see RpcError.ErrorCode for their meanings).
   */ constructor(code, message, data){
        super(message);
        this.code = code;
        this.message = $c0722d30b1d17141$var$truncateBytes(message, $c0722d30b1d17141$export$5460eff990f31920.MAX_MESSAGE_BYTES);
        this.data = data ? $c0722d30b1d17141$var$truncateBytes(data, $c0722d30b1d17141$export$5460eff990f31920.MAX_DATA_BYTES) : undefined;
    }
    /**
   * @internal
   */ static fromProto(proto) {
        return new $c0722d30b1d17141$export$5460eff990f31920(proto.code, proto.message, proto.data);
    }
    /**
   * @internal
   */ toProto() {
        return new $c0722d30b1d17141$var$RpcError$1({
            code: this.code,
            message: this.message,
            data: this.data
        });
    }
    /**
   * Creates an error object from the code, with an auto-populated message.
   *
   * @internal
   */ static builtIn(key, data) {
        return new $c0722d30b1d17141$export$5460eff990f31920($c0722d30b1d17141$export$5460eff990f31920.ErrorCode[key], $c0722d30b1d17141$export$5460eff990f31920.ErrorMessage[key], data);
    }
}
$c0722d30b1d17141$export$5460eff990f31920.MAX_MESSAGE_BYTES = 256;
$c0722d30b1d17141$export$5460eff990f31920.MAX_DATA_BYTES = 15360; // 15 KB
$c0722d30b1d17141$export$5460eff990f31920.ErrorCode = {
    APPLICATION_ERROR: 1500,
    CONNECTION_TIMEOUT: 1501,
    RESPONSE_TIMEOUT: 1502,
    RECIPIENT_DISCONNECTED: 1503,
    RESPONSE_PAYLOAD_TOO_LARGE: 1504,
    SEND_FAILED: 1505,
    UNSUPPORTED_METHOD: 1400,
    RECIPIENT_NOT_FOUND: 1401,
    REQUEST_PAYLOAD_TOO_LARGE: 1402,
    UNSUPPORTED_SERVER: 1403,
    UNSUPPORTED_VERSION: 1404
};
/**
 * @internal
 */ $c0722d30b1d17141$export$5460eff990f31920.ErrorMessage = {
    APPLICATION_ERROR: 'Application error in method handler',
    CONNECTION_TIMEOUT: 'Connection timeout',
    RESPONSE_TIMEOUT: 'Response timeout',
    RECIPIENT_DISCONNECTED: 'Recipient disconnected',
    RESPONSE_PAYLOAD_TOO_LARGE: 'Response payload too large',
    SEND_FAILED: 'Failed to send',
    UNSUPPORTED_METHOD: 'Method not supported at destination',
    RECIPIENT_NOT_FOUND: 'Recipient not found',
    REQUEST_PAYLOAD_TOO_LARGE: 'Request payload too large',
    UNSUPPORTED_SERVER: 'RPC not supported by server',
    UNSUPPORTED_VERSION: 'Unsupported RPC version'
};
/*
 * Maximum payload size for RPC requests and responses. If a payload exceeds this size,
 * the RPC call will fail with a REQUEST_PAYLOAD_TOO_LARGE(1402) or RESPONSE_PAYLOAD_TOO_LARGE(1504) error.
 */ const $c0722d30b1d17141$var$MAX_PAYLOAD_BYTES = 15360; // 15 KB
/**
 * @internal
 */ function $c0722d30b1d17141$var$byteLength(str) {
    const encoder = new TextEncoder();
    return encoder.encode(str).length;
}
/**
 * @internal
 */ function $c0722d30b1d17141$var$truncateBytes(str, maxBytes) {
    if ($c0722d30b1d17141$var$byteLength(str) <= maxBytes) return str;
    let low = 0;
    let high = str.length;
    const encoder = new TextEncoder();
    while(low < high){
        const mid = Math.floor((low + high + 1) / 2);
        if (encoder.encode(str.slice(0, mid)).length <= maxBytes) low = mid;
        else high = mid - 1;
    }
    return str.slice(0, low);
}
const $c0722d30b1d17141$var$monitorFrequency = 2000;
function $c0722d30b1d17141$var$computeBitrate(currentStats, prevStats) {
    if (!prevStats) return 0;
    let bytesNow;
    let bytesPrev;
    if ('bytesReceived' in currentStats) {
        bytesNow = currentStats.bytesReceived;
        bytesPrev = prevStats.bytesReceived;
    } else if ('bytesSent' in currentStats) {
        bytesNow = currentStats.bytesSent;
        bytesPrev = prevStats.bytesSent;
    }
    if (bytesNow === undefined || bytesPrev === undefined || currentStats.timestamp === undefined || prevStats.timestamp === undefined) return 0;
    return (bytesNow - bytesPrev) * 8000 / (currentStats.timestamp - prevStats.timestamp);
} // Check if MediaRecorder is available
const $c0722d30b1d17141$var$isMediaRecorderAvailable = typeof MediaRecorder !== 'undefined';
// Fallback class for environments without MediaRecorder
class $c0722d30b1d17141$var$FallbackRecorder {
    constructor(){
        throw new Error('MediaRecorder is not available in this environment');
    }
}
// Use conditional inheritance to avoid parse-time errors
const $c0722d30b1d17141$var$RecorderBase = $c0722d30b1d17141$var$isMediaRecorderAvailable ? MediaRecorder : $c0722d30b1d17141$var$FallbackRecorder;
class $c0722d30b1d17141$export$a7ac3398bcc4c321 extends $c0722d30b1d17141$var$RecorderBase {
    constructor(track, options){
        if (!$c0722d30b1d17141$var$isMediaRecorderAvailable) throw new Error('MediaRecorder is not available in this environment');
        super(new MediaStream([
            track.mediaStreamTrack
        ]), options);
        let dataListener;
        let streamController;
        const isClosed = ()=>streamController === undefined;
        const onStop = ()=>{
            this.removeEventListener('dataavailable', dataListener);
            this.removeEventListener('stop', onStop);
            this.removeEventListener('error', onError);
            streamController === null || streamController === void 0 || streamController.close();
            streamController = undefined;
        };
        const onError = (event)=>{
            streamController === null || streamController === void 0 || streamController.error(event);
            this.removeEventListener('dataavailable', dataListener);
            this.removeEventListener('stop', onStop);
            this.removeEventListener('error', onError);
            streamController = undefined;
        };
        this.byteStream = new ReadableStream({
            start: (controller)=>{
                streamController = controller;
                dataListener = (event)=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                        let data;
                        if (event.data.arrayBuffer) {
                            const arrayBuffer = yield event.data.arrayBuffer();
                            data = new Uint8Array(arrayBuffer);
                        // @ts-expect-error react-native passes over Uint8Arrays directly
                        } else if (event.data.byteArray) // @ts-expect-error
                        data = event.data.byteArray;
                        else throw new Error('no data available!');
                        if (isClosed()) return;
                        controller.enqueue(data);
                    });
                this.addEventListener('dataavailable', dataListener);
            },
            cancel: ()=>{
                onStop();
            }
        });
        this.addEventListener('stop', onStop);
        this.addEventListener('error', onError);
    }
}
// Helper function to check if recording is supported
function $c0722d30b1d17141$var$isRecordingSupported() {
    return $c0722d30b1d17141$var$isMediaRecorderAvailable;
}
const $c0722d30b1d17141$var$DEFAULT_DIMENSIONS_TIMEOUT = 1000;
const $c0722d30b1d17141$var$PRE_CONNECT_BUFFER_TIMEOUT = 10000;
class $c0722d30b1d17141$export$3e041ce3f33f04dd extends $c0722d30b1d17141$export$13921ac0cc260818 {
    /** @internal */ get sender() {
        return this._sender;
    }
    /** @internal */ set sender(sender) {
        this._sender = sender;
    }
    get constraints() {
        return this._constraints;
    }
    get hasPreConnectBuffer() {
        return !!this.localTrackRecorder;
    }
    /**
   *
   * @param mediaTrack
   * @param kind
   * @param constraints MediaTrackConstraints that are being used when restarting or reacquiring tracks
   * @param userProvidedTrack Signals to the SDK whether or not the mediaTrack should be managed (i.e. released and reacquired) internally by the SDK
   */ constructor(mediaTrack, kind, constraints){
        let userProvidedTrack = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        let loggerOptions = arguments.length > 4 ? arguments[4] : undefined;
        super(mediaTrack, kind, loggerOptions);
        this.manuallyStopped = false;
        this.pendingDeviceChange = false;
        this._isUpstreamPaused = false;
        this.handleTrackMuteEvent = ()=>this.debouncedTrackMuteHandler().catch(()=>this.log.debug('track mute bounce got cancelled by an unmute event', this.logContext));
        this.debouncedTrackMuteHandler = $c0722d30b1d17141$var$debounce(()=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                yield this.pauseUpstream();
            }), 5000);
        this.handleTrackUnmuteEvent = ()=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                this.debouncedTrackMuteHandler.cancel('unmute');
                yield this.resumeUpstream();
            });
        this.handleEnded = ()=>{
            if (this.isInBackground) this.reacquireTrack = true;
            this._mediaStreamTrack.removeEventListener('mute', this.handleTrackMuteEvent);
            this._mediaStreamTrack.removeEventListener('unmute', this.handleTrackUnmuteEvent);
            this.emit($c0722d30b1d17141$export$2c8510d737cc09da.Ended, this);
        };
        this.reacquireTrack = false;
        this.providedByUser = userProvidedTrack;
        this.muteLock = new $c0722d30b1d17141$export$ca12f2943758ef55();
        this.pauseUpstreamLock = new $c0722d30b1d17141$export$ca12f2943758ef55();
        this.trackChangeLock = new $c0722d30b1d17141$export$ca12f2943758ef55();
        this.trackChangeLock.lock().then((unlock)=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                try {
                    yield this.setMediaStreamTrack(mediaTrack, true);
                } finally{
                    unlock();
                }
            }));
        // added to satisfy TS compiler, constraints are synced with MediaStreamTrack
        this._constraints = mediaTrack.getConstraints();
        if (constraints) this._constraints = constraints;
    }
    get id() {
        return this._mediaStreamTrack.id;
    }
    get dimensions() {
        if (this.kind !== $c0722d30b1d17141$export$13921ac0cc260818.Kind.Video) return undefined;
        const { width: width, height: height } = this._mediaStreamTrack.getSettings();
        if (width && height) return {
            width: width,
            height: height
        };
        return undefined;
    }
    get isUpstreamPaused() {
        return this._isUpstreamPaused;
    }
    get isUserProvided() {
        return this.providedByUser;
    }
    get mediaStreamTrack() {
        var _a, _b;
        return (_b = (_a = this.processor) === null || _a === void 0 ? void 0 : _a.processedTrack) !== null && _b !== void 0 ? _b : this._mediaStreamTrack;
    }
    get isLocal() {
        return true;
    }
    /**
   * @internal
   * returns mediaStreamTrack settings of the capturing mediastreamtrack source - ignoring processors
   */ getSourceTrackSettings() {
        return this._mediaStreamTrack.getSettings();
    }
    setMediaStreamTrack(newTrack, force, isUnmuting) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            if (newTrack === this._mediaStreamTrack && !force) return;
            if (this._mediaStreamTrack) {
                // detach
                this.attachedElements.forEach((el)=>{
                    $c0722d30b1d17141$export$8ea68c6294970fa5(this._mediaStreamTrack, el);
                });
                this.debouncedTrackMuteHandler.cancel('new-track');
                this._mediaStreamTrack.removeEventListener('ended', this.handleEnded);
                this._mediaStreamTrack.removeEventListener('mute', this.handleTrackMuteEvent);
                this._mediaStreamTrack.removeEventListener('unmute', this.handleTrackUnmuteEvent);
            }
            this.mediaStream = new MediaStream([
                newTrack
            ]);
            if (newTrack) {
                newTrack.addEventListener('ended', this.handleEnded);
                // when underlying track emits mute, it indicates that the device is unable
                // to produce media. In this case we'll need to signal with remote that
                // the track is "muted"
                // note this is different from LocalTrack.mute because we do not want to
                // touch MediaStreamTrack.enabled
                newTrack.addEventListener('mute', this.handleTrackMuteEvent);
                newTrack.addEventListener('unmute', this.handleTrackUnmuteEvent);
                this._constraints = newTrack.getConstraints();
            }
            let processedTrack;
            if (this.processor && newTrack) {
                this.log.debug('restarting processor', this.logContext);
                if (this.kind === 'unknown') throw TypeError('cannot set processor on track of unknown kind');
                if (this.processorElement) {
                    $c0722d30b1d17141$export$b8f95ef2322890b8(newTrack, this.processorElement);
                    // ensure the processorElement itself stays muted
                    this.processorElement.muted = true;
                }
                yield this.processor.restart({
                    track: newTrack,
                    kind: this.kind,
                    element: this.processorElement,
                    localTrack: this
                });
                processedTrack = this.processor.processedTrack;
            }
            if (this.sender && ((_a = this.sender.transport) === null || _a === void 0 ? void 0 : _a.state) !== 'closed') yield this.sender.replaceTrack(processedTrack !== null && processedTrack !== void 0 ? processedTrack : newTrack);
            // if `newTrack` is different from the existing track, stop the
            // older track just before replacing it
            if (!this.providedByUser && this._mediaStreamTrack !== newTrack) this._mediaStreamTrack.stop();
            this._mediaStreamTrack = newTrack;
            if (newTrack) {
                // sync muted state with the enabled state of the newly provided track
                // if restarting as part of an unmute, set enabled to true directly to avoid mute cycling
                this._mediaStreamTrack.enabled = isUnmuting ? true : !this.isMuted;
                // when a valid track is replace, we'd want to start producing
                yield this.resumeUpstream();
                this.attachedElements.forEach((el)=>{
                    $c0722d30b1d17141$export$b8f95ef2322890b8(processedTrack !== null && processedTrack !== void 0 ? processedTrack : newTrack, el);
                });
            }
        });
    }
    waitForDimensions() {
        return $c0722d30b1d17141$var$__awaiter(this, arguments, void 0, function() {
            var _this = this;
            let timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $c0722d30b1d17141$var$DEFAULT_DIMENSIONS_TIMEOUT;
            return function*() {
                var _a;
                if (_this.kind === $c0722d30b1d17141$export$13921ac0cc260818.Kind.Audio) throw new Error('cannot get dimensions for audio tracks');
                if (((_a = $c0722d30b1d17141$export$89e15fc796a4a429()) === null || _a === void 0 ? void 0 : _a.os) === 'iOS') // browsers report wrong initial resolution on iOS.
                // when slightly delaying the call to .getSettings(), the correct resolution is being reported
                yield $c0722d30b1d17141$var$sleep(10);
                const started = Date.now();
                while(Date.now() - started < timeout){
                    const dims = _this.dimensions;
                    if (dims) return dims;
                    yield $c0722d30b1d17141$var$sleep(50);
                }
                throw new $c0722d30b1d17141$export$4fbb9423b5747257('unable to get track dimensions after timeout');
            }();
        });
    }
    setDeviceId(deviceId) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            if (this._constraints.deviceId === deviceId && this._mediaStreamTrack.getSettings().deviceId === $c0722d30b1d17141$var$unwrapConstraint(deviceId)) return true;
            this._constraints.deviceId = deviceId;
            // when track is muted, underlying media stream track is stopped and
            // will be restarted later
            if (this.isMuted) {
                this.pendingDeviceChange = true;
                return true;
            }
            yield this.restartTrack();
            return $c0722d30b1d17141$var$unwrapConstraint(deviceId) === this._mediaStreamTrack.getSettings().deviceId;
        });
    }
    /**
   * @returns DeviceID of the device that is currently being used for this track
   */ getDeviceId() {
        return $c0722d30b1d17141$var$__awaiter(this, arguments, void 0, function() {
            var _this2 = this;
            let normalize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            return function*() {
                // screen share doesn't have a usable device id
                if (_this2.source === $c0722d30b1d17141$export$13921ac0cc260818.Source.ScreenShare) return;
                const { deviceId: deviceId, groupId: groupId } = _this2._mediaStreamTrack.getSettings();
                const kind = _this2.kind === $c0722d30b1d17141$export$13921ac0cc260818.Kind.Audio ? 'audioinput' : 'videoinput';
                return normalize ? $c0722d30b1d17141$var$DeviceManager.getInstance().normalizeDeviceId(kind, deviceId, groupId) : deviceId;
            }();
        });
    }
    mute() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            this.setTrackMuted(true);
            return this;
        });
    }
    unmute() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            this.setTrackMuted(false);
            return this;
        });
    }
    replaceTrack(track, userProvidedOrOptions) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            const unlock = yield this.trackChangeLock.lock();
            try {
                if (!this.sender) throw new $c0722d30b1d17141$export$4fbb9423b5747257('unable to replace an unpublished track');
                let userProvidedTrack;
                let stopProcessor;
                if (typeof userProvidedOrOptions === 'boolean') userProvidedTrack = userProvidedOrOptions;
                else if (userProvidedOrOptions !== undefined) {
                    userProvidedTrack = userProvidedOrOptions.userProvidedTrack;
                    stopProcessor = userProvidedOrOptions.stopProcessor;
                }
                this.providedByUser = userProvidedTrack !== null && userProvidedTrack !== void 0 ? userProvidedTrack : true;
                this.log.debug('replace MediaStreamTrack', this.logContext);
                yield this.setMediaStreamTrack(track);
                // this must be synced *after* setting mediaStreamTrack above, since it relies
                // on the previous state in order to cleanup
                if (stopProcessor && this.processor) yield this.internalStopProcessor();
            } finally{
                unlock();
            }
            yield this.onSenderTrackSwapped();
            return this;
        });
    }
    /**
   * Hook invoked after the MediaStreamTrack on the sender has been swapped
   * (via replaceTrack, setProcessor, or stopProcessor). Fires outside the
   * trackChangeLock so subclasses can do asynchronous work such as polling
   * for new dimensions without blocking other track operations.
   */ onSenderTrackSwapped() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
        // base implementation is a no-op; LocalVideoTrack overrides this to
        // recompute sender encoding parameters.
        });
    }
    restart(constraints, isUnmuting) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            this.manuallyStopped = false;
            const unlock = yield this.trackChangeLock.lock();
            try {
                if (!constraints) constraints = this._constraints;
                const { deviceId: deviceId, facingMode: facingMode } = constraints, otherConstraints = $c0722d30b1d17141$var$__rest(constraints, [
                    "deviceId",
                    "facingMode"
                ]);
                this.log.debug('restarting track with constraints', Object.assign(Object.assign({}, this.logContext), {
                    constraints: constraints
                }));
                const streamConstraints = {
                    audio: false,
                    video: false
                };
                if (this.kind === $c0722d30b1d17141$export$13921ac0cc260818.Kind.Video) streamConstraints.video = deviceId || facingMode ? {
                    deviceId: deviceId,
                    facingMode: facingMode
                } : true;
                else streamConstraints.audio = deviceId ? Object.assign({
                    deviceId: deviceId
                }, otherConstraints) : true;
                // these steps are duplicated from setMediaStreamTrack because we must stop
                // the previous tracks before new tracks can be acquired
                this.attachedElements.forEach((el)=>{
                    $c0722d30b1d17141$export$8ea68c6294970fa5(this.mediaStreamTrack, el);
                });
                this._mediaStreamTrack.removeEventListener('ended', this.handleEnded);
                // on Safari, the old audio track must be stopped before attempting to acquire
                // the new track, otherwise the new track will stop with
                // 'A MediaStreamTrack ended due to a capture failure`
                this._mediaStreamTrack.stop();
                // create new track and attach
                const mediaStream = yield navigator.mediaDevices.getUserMedia(streamConstraints);
                const newTrack = mediaStream.getTracks()[0];
                if (this.kind === $c0722d30b1d17141$export$13921ac0cc260818.Kind.Video) // we already captured the audio track with the constraints, so we only need to apply the video constraints
                yield newTrack.applyConstraints(otherConstraints);
                newTrack.addEventListener('ended', this.handleEnded);
                this.log.debug('re-acquired MediaStreamTrack', this.logContext);
                yield this.setMediaStreamTrack(newTrack, false, isUnmuting);
                this._constraints = constraints;
                this.pendingDeviceChange = false;
                this.emit($c0722d30b1d17141$export$2c8510d737cc09da.Restarted, this);
                if (this.manuallyStopped) {
                    this.log.warn('track was stopped during a restart, stopping restarted track', this.logContext);
                    this.stop();
                }
                return this;
            } finally{
                unlock();
            }
        });
    }
    setTrackMuted(muted) {
        this.log.debug("setting ".concat(this.kind, " track ").concat(muted ? 'muted' : 'unmuted'), this.logContext);
        if (this.isMuted === muted && this._mediaStreamTrack.enabled !== muted) return;
        this.isMuted = muted;
        this._mediaStreamTrack.enabled = !muted;
        this.emit(muted ? $c0722d30b1d17141$export$2c8510d737cc09da.Muted : $c0722d30b1d17141$export$2c8510d737cc09da.Unmuted, this);
    }
    get needsReAcquisition() {
        return this._mediaStreamTrack.readyState !== 'live' || this._mediaStreamTrack.muted || !this._mediaStreamTrack.enabled || this.reacquireTrack;
    }
    handleAppVisibilityChanged() {
        const _super = Object.create(null, {
            handleAppVisibilityChanged: {
                get: ()=>super.handleAppVisibilityChanged
            }
        });
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            yield _super.handleAppVisibilityChanged.call(this);
            if (!$c0722d30b1d17141$var$isMobile()) return;
            this.log.debug("visibility changed, is in Background: ".concat(this.isInBackground), this.logContext);
            if (!this.isInBackground && this.needsReAcquisition && !this.isUserProvided && !this.isMuted) {
                this.log.debug("track needs to be reacquired, restarting ".concat(this.source), this.logContext);
                yield this.restart();
                this.reacquireTrack = false;
            }
        });
    }
    stop() {
        var _a;
        this.manuallyStopped = true;
        super.stop();
        this._mediaStreamTrack.removeEventListener('ended', this.handleEnded);
        this._mediaStreamTrack.removeEventListener('mute', this.handleTrackMuteEvent);
        this._mediaStreamTrack.removeEventListener('unmute', this.handleTrackUnmuteEvent);
        (_a = this.processor) === null || _a === void 0 || _a.destroy();
        this.processor = undefined;
    }
    /**
   * pauses publishing to the server without disabling the local MediaStreamTrack
   * this is used to display a user's own video locally while pausing publishing to
   * the server.
   * this API is unsupported on Safari < 12 due to a bug
   **/ pauseUpstream() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const unlock = yield this.pauseUpstreamLock.lock();
            try {
                if (this._isUpstreamPaused === true) return;
                if (!this.sender) {
                    this.log.warn('unable to pause upstream for an unpublished track', this.logContext);
                    return;
                }
                this._isUpstreamPaused = true;
                this.emit($c0722d30b1d17141$export$2c8510d737cc09da.UpstreamPaused, this);
                const browser = $c0722d30b1d17141$export$89e15fc796a4a429();
                if ((browser === null || browser === void 0 ? void 0 : browser.name) === 'Safari' && $c0722d30b1d17141$export$66e1c0999abad646(browser.version, '12.0') < 0) // https://bugs.webkit.org/show_bug.cgi?id=184911
                throw new $c0722d30b1d17141$export$38c5ac268e2fa84('pauseUpstream is not supported on Safari < 12.');
                if (((_a = this.sender.transport) === null || _a === void 0 ? void 0 : _a.state) !== 'closed') yield this.sender.replaceTrack(null);
            } finally{
                unlock();
            }
        });
    }
    resumeUpstream() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const unlock = yield this.pauseUpstreamLock.lock();
            try {
                if (this._isUpstreamPaused === false) return;
                if (!this.sender) {
                    this.log.warn('unable to resume upstream for an unpublished track', this.logContext);
                    return;
                }
                this._isUpstreamPaused = false;
                this.emit($c0722d30b1d17141$export$2c8510d737cc09da.UpstreamResumed, this);
                if (((_a = this.sender.transport) === null || _a === void 0 ? void 0 : _a.state) !== 'closed') // this operation is noop if mediastreamtrack is already being sent
                yield this.sender.replaceTrack(this.mediaStreamTrack);
            } finally{
                unlock();
            }
        });
    }
    /**
   * Gets the RTCStatsReport for the LocalTrack's underlying RTCRtpSender
   * See https://developer.mozilla.org/en-US/docs/Web/API/RTCStatsReport
   *
   * @returns Promise<RTCStatsReport> | undefined
   */ getRTCStatsReport() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            if (!((_a = this.sender) === null || _a === void 0 ? void 0 : _a.getStats)) return;
            const statsReport = yield this.sender.getStats();
            return statsReport;
        });
    }
    /**
   * Sets a processor on this track.
   * See https://github.com/livekit/track-processors-js for example usage
   *
   * @param processor
   * @param showProcessedStreamLocally
   * @returns
   */ setProcessor(processor_1) {
        return $c0722d30b1d17141$var$__awaiter(this, arguments, void 0, function(processor) {
            var _this3 = this;
            let showProcessedStreamLocally = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            return function*() {
                var _a;
                const unlock = yield _this3.trackChangeLock.lock();
                try {
                    _this3.log.debug('setting up processor', _this3.logContext);
                    const processorElement = document.createElement(_this3.kind);
                    const processorOptions = {
                        kind: _this3.kind,
                        track: _this3._mediaStreamTrack,
                        element: processorElement,
                        audioContext: _this3.audioContext,
                        localTrack: _this3
                    };
                    yield processor.init(processorOptions);
                    _this3.log.debug('processor initialized', _this3.logContext);
                    if (_this3.processor) yield _this3.internalStopProcessor();
                    if (_this3.kind === 'unknown') throw TypeError('cannot set processor on track of unknown kind');
                    $c0722d30b1d17141$export$b8f95ef2322890b8(_this3._mediaStreamTrack, processorElement);
                    processorElement.muted = true;
                    processorElement.play().catch((error)=>{
                        if (error instanceof DOMException && error.name === 'AbortError') {
                            // This happens on Safari when the processor is restarted, try again after a delay
                            _this3.log.warn('failed to play processor element, retrying', Object.assign(Object.assign({}, _this3.logContext), {
                                error: error
                            }));
                            setTimeout(()=>{
                                processorElement.play().catch((err)=>{
                                    _this3.log.error('failed to play processor element', Object.assign(Object.assign({}, _this3.logContext), {
                                        err: err
                                    }));
                                });
                            }, 100);
                        } else _this3.log.error('failed to play processor element', Object.assign(Object.assign({}, _this3.logContext), {
                            error: error
                        }));
                    });
                    _this3.processor = processor;
                    _this3.processorElement = processorElement;
                    if (_this3.processor.processedTrack) {
                        for (const el of _this3.attachedElements)if (el !== _this3.processorElement && showProcessedStreamLocally) {
                            $c0722d30b1d17141$export$8ea68c6294970fa5(_this3._mediaStreamTrack, el);
                            $c0722d30b1d17141$export$b8f95ef2322890b8(_this3.processor.processedTrack, el);
                        }
                        yield (_a = _this3.sender) === null || _a === void 0 ? void 0 : _a.replaceTrack(_this3.processor.processedTrack);
                    }
                    _this3.emit($c0722d30b1d17141$export$2c8510d737cc09da.TrackProcessorUpdate, _this3.processor);
                } finally{
                    unlock();
                }
                yield _this3.onSenderTrackSwapped();
            }();
        });
    }
    getProcessor() {
        return this.processor;
    }
    /**
   * Stops the track processor
   * See https://github.com/livekit/track-processors-js for example usage
   *
   */ stopProcessor() {
        return $c0722d30b1d17141$var$__awaiter(this, arguments, void 0, function() {
            var _this4 = this;
            let keepElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            return function*() {
                const unlock = yield _this4.trackChangeLock.lock();
                try {
                    yield _this4.internalStopProcessor(keepElement);
                } finally{
                    unlock();
                }
                yield _this4.onSenderTrackSwapped();
            }();
        });
    }
    /**
   * @internal
   * This method assumes the caller has acquired a trackChangeLock already.
   * The public facing method for stopping the processor is `stopProcessor` and it wraps this method in the trackChangeLock.
   */ internalStopProcessor() {
        return $c0722d30b1d17141$var$__awaiter(this, arguments, void 0, function() {
            var _this5 = this;
            let keepElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            return function*() {
                var _a, _b;
                if (!_this5.processor) return;
                _this5.log.debug('stopping processor', _this5.logContext);
                (_a = _this5.processor.processedTrack) === null || _a === void 0 || _a.stop();
                yield _this5.processor.destroy();
                _this5.processor = undefined;
                if (!keepElement) {
                    (_b = _this5.processorElement) === null || _b === void 0 || _b.remove();
                    _this5.processorElement = undefined;
                }
                // apply original track constraints in case the processor changed them
                yield _this5._mediaStreamTrack.applyConstraints(_this5._constraints);
                // force re-setting of the mediaStreamTrack on the sender
                yield _this5.setMediaStreamTrack(_this5._mediaStreamTrack, true);
                _this5.emit($c0722d30b1d17141$export$2c8510d737cc09da.TrackProcessorUpdate);
            }();
        });
    }
    /** @internal */ startPreConnectBuffer() {
        let timeslice = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 100;
        if (!$c0722d30b1d17141$var$isRecordingSupported()) {
            this.log.warn('MediaRecorder is not available, cannot start preconnect buffer', this.logContext);
            return;
        }
        if (!this.localTrackRecorder) {
            let mimeType = 'audio/webm;codecs=opus';
            if (!MediaRecorder.isTypeSupported(mimeType)) // iOS currently only supports video/mp4 as a mime type - even for audio.
            mimeType = 'video/mp4';
            this.localTrackRecorder = new $c0722d30b1d17141$export$a7ac3398bcc4c321(this, {
                mimeType: mimeType
            });
        } else {
            this.log.warn('preconnect buffer already started');
            return;
        }
        this.localTrackRecorder.start(timeslice);
        this.autoStopPreConnectBuffer = setTimeout(()=>{
            this.log.warn('preconnect buffer timed out, stopping recording automatically', this.logContext);
            this.stopPreConnectBuffer();
        }, $c0722d30b1d17141$var$PRE_CONNECT_BUFFER_TIMEOUT);
    }
    /** @internal */ stopPreConnectBuffer() {
        clearTimeout(this.autoStopPreConnectBuffer);
        if (this.localTrackRecorder) {
            this.localTrackRecorder.stop();
            this.localTrackRecorder = undefined;
        }
    }
    /** @internal */ getPreConnectBuffer() {
        var _a;
        return (_a = this.localTrackRecorder) === null || _a === void 0 ? void 0 : _a.byteStream;
    }
    getPreConnectBufferMimeType() {
        var _a;
        return (_a = this.localTrackRecorder) === null || _a === void 0 ? void 0 : _a.mimeType;
    }
}
class $c0722d30b1d17141$export$b287427b771ca237 extends $c0722d30b1d17141$export$3e041ce3f33f04dd {
    /**
   * boolean indicating whether enhanced noise cancellation is currently being used on this track
   */ get enhancedNoiseCancellation() {
        return this.isKrispNoiseFilterEnabled;
    }
    /**
   *
   * @param mediaTrack
   * @param constraints MediaTrackConstraints that are being used when restarting or reacquiring tracks
   * @param userProvidedTrack Signals to the SDK whether or not the mediaTrack should be managed (i.e. released and reacquired) internally by the SDK
   */ constructor(mediaTrack, constraints){
        let userProvidedTrack = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        let audioContext = arguments.length > 3 ? arguments[3] : undefined;
        let loggerOptions = arguments.length > 4 ? arguments[4] : undefined;
        super(mediaTrack, $c0722d30b1d17141$export$13921ac0cc260818.Kind.Audio, constraints, userProvidedTrack, loggerOptions);
        /** @internal */ this.stopOnMute = false;
        this.isKrispNoiseFilterEnabled = false;
        this.monitorSender = ()=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                if (!this.sender) {
                    this._currentBitrate = 0;
                    return;
                }
                let stats;
                try {
                    stats = yield this.getSenderStats();
                } catch (e) {
                    this.log.error('could not get audio sender stats', Object.assign(Object.assign({}, this.logContext), {
                        error: e
                    }));
                    return;
                }
                if (stats && this.prevStats) this._currentBitrate = $c0722d30b1d17141$var$computeBitrate(stats, this.prevStats);
                this.prevStats = stats;
            });
        this.handleKrispNoiseFilterEnable = ()=>{
            this.isKrispNoiseFilterEnabled = true;
            this.log.debug("Krisp noise filter enabled", this.logContext);
            this.emit($c0722d30b1d17141$export$2c8510d737cc09da.AudioTrackFeatureUpdate, this, $c0722d30b1d17141$var$AudioTrackFeature.TF_ENHANCED_NOISE_CANCELLATION, true);
        };
        this.handleKrispNoiseFilterDisable = ()=>{
            this.isKrispNoiseFilterEnabled = false;
            this.log.debug("Krisp noise filter disabled", this.logContext);
            this.emit($c0722d30b1d17141$export$2c8510d737cc09da.AudioTrackFeatureUpdate, this, $c0722d30b1d17141$var$AudioTrackFeature.TF_ENHANCED_NOISE_CANCELLATION, false);
        };
        this.audioContext = audioContext;
        this.checkForSilence();
    }
    mute() {
        const _super = Object.create(null, {
            mute: {
                get: ()=>super.mute
            }
        });
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            const unlock = yield this.muteLock.lock();
            try {
                if (this.isMuted) {
                    this.log.debug('Track already muted', this.logContext);
                    return this;
                }
                // disabled special handling as it will cause BT headsets to switch communication modes
                if (this.source === $c0722d30b1d17141$export$13921ac0cc260818.Source.Microphone && this.stopOnMute && !this.isUserProvided) {
                    this.log.debug('stopping mic track', this.logContext);
                    // also stop the track, so that microphone indicator is turned off
                    this._mediaStreamTrack.stop();
                }
                yield _super.mute.call(this);
                return this;
            } finally{
                unlock();
            }
        });
    }
    unmute() {
        const _super = Object.create(null, {
            unmute: {
                get: ()=>super.unmute
            }
        });
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            const unlock = yield this.muteLock.lock();
            try {
                if (!this.isMuted) {
                    this.log.debug('Track already unmuted', this.logContext);
                    return this;
                }
                if (this.source === $c0722d30b1d17141$export$13921ac0cc260818.Source.Microphone && (this.stopOnMute || this._mediaStreamTrack.readyState === 'ended' || this.pendingDeviceChange) && !this.isUserProvided) {
                    this.log.debug('reacquiring mic track', this.logContext);
                    yield this.restart(undefined, true);
                }
                yield _super.unmute.call(this);
                return this;
            } finally{
                unlock();
            }
        });
    }
    restartTrack(options) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            let constraints;
            if (options) {
                const streamConstraints = $c0722d30b1d17141$var$constraintsForOptions({
                    audio: options
                });
                if (typeof streamConstraints.audio !== 'boolean') constraints = streamConstraints.audio;
            }
            yield this.restart(constraints);
        });
    }
    restart(constraints, isUnmuting) {
        const _super = Object.create(null, {
            restart: {
                get: ()=>super.restart
            }
        });
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            const track = yield _super.restart.call(this, constraints, isUnmuting);
            this.checkForSilence();
            return track;
        });
    }
    /* @internal */ startMonitor() {
        if (!$c0722d30b1d17141$var$isWeb()) return;
        if (this.monitorInterval) return;
        this.monitorInterval = setInterval(()=>{
            this.monitorSender();
        }, $c0722d30b1d17141$var$monitorFrequency);
    }
    setProcessor(processor) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const unlock = yield this.trackChangeLock.lock();
            try {
                if (!$c0722d30b1d17141$var$isReactNative() && !this.audioContext) throw Error('Audio context needs to be set on LocalAudioTrack in order to enable processors');
                if (this.processor) yield this.internalStopProcessor();
                const processorOptions = {
                    kind: this.kind,
                    track: this._mediaStreamTrack,
                    // RN won't have or use AudioContext
                    audioContext: this.audioContext,
                    localTrack: this
                };
                this.log.debug("setting up audio processor ".concat(processor.name), this.logContext);
                yield processor.init(processorOptions);
                this.processor = processor;
                if (this.processor.processedTrack) {
                    yield (_a = this.sender) === null || _a === void 0 ? void 0 : _a.replaceTrack(this.processor.processedTrack);
                    this.processor.processedTrack.addEventListener('enable-lk-krisp-noise-filter', this.handleKrispNoiseFilterEnable);
                    this.processor.processedTrack.addEventListener('disable-lk-krisp-noise-filter', this.handleKrispNoiseFilterDisable);
                }
                this.emit($c0722d30b1d17141$export$2c8510d737cc09da.TrackProcessorUpdate, this.processor);
            } finally{
                unlock();
            }
        });
    }
    /**
   * @internal
   * @experimental
   */ setAudioContext(audioContext) {
        this.audioContext = audioContext;
    }
    getSenderStats() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            if (!((_a = this.sender) === null || _a === void 0 ? void 0 : _a.getStats)) return undefined;
            const stats = yield this.sender.getStats();
            let audioStats;
            stats.forEach((v)=>{
                if (v.type === 'outbound-rtp') audioStats = {
                    type: 'audio',
                    streamId: v.id,
                    packetsSent: v.packetsSent,
                    packetsLost: v.packetsLost,
                    bytesSent: v.bytesSent,
                    timestamp: v.timestamp,
                    roundTripTime: v.roundTripTime,
                    jitter: v.jitter
                };
            });
            return audioStats;
        });
    }
    checkForSilence() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            const trackIsSilent = yield $c0722d30b1d17141$var$detectSilence(this);
            if (trackIsSilent) {
                if (!this.isMuted) this.log.debug('silence detected on local audio track', this.logContext);
                this.emit($c0722d30b1d17141$export$2c8510d737cc09da.AudioSilenceDetected);
            }
            return trackIsSilent;
        });
    }
} /** @internal */ 
function $c0722d30b1d17141$var$mediaTrackToLocalTrack(mediaStreamTrack, constraints, loggerOptions) {
    switch(mediaStreamTrack.kind){
        case 'audio':
            return new $c0722d30b1d17141$export$b287427b771ca237(mediaStreamTrack, constraints, false, undefined, loggerOptions);
        case 'video':
            return new $c0722d30b1d17141$export$d5ffd2c62c538bdc(mediaStreamTrack, constraints, false, loggerOptions);
        default:
            throw new $c0722d30b1d17141$export$4fbb9423b5747257("unsupported track type: ".concat(mediaStreamTrack.kind));
    }
}
/* @internal */ const $c0722d30b1d17141$var$presets169 = Object.values($c0722d30b1d17141$export$79d56065dad1674c);
/* @internal */ const $c0722d30b1d17141$var$presets43 = Object.values($c0722d30b1d17141$export$eb5fc43ecc8ee2c7);
/* @internal */ const $c0722d30b1d17141$var$presetsScreenShare = Object.values($c0722d30b1d17141$export$a6cdf9dcd3d32f2d);
/* @internal */ const $c0722d30b1d17141$var$defaultSimulcastPresets169 = [
    $c0722d30b1d17141$export$79d56065dad1674c.h180,
    $c0722d30b1d17141$export$79d56065dad1674c.h360
];
/* @internal */ const $c0722d30b1d17141$var$defaultSimulcastPresets43 = [
    $c0722d30b1d17141$export$eb5fc43ecc8ee2c7.h180,
    $c0722d30b1d17141$export$eb5fc43ecc8ee2c7.h360
];
/* @internal */ const $c0722d30b1d17141$var$computeDefaultScreenShareSimulcastPresets = (fromPreset)=>{
    const layers = [
        {
            scaleResolutionDownBy: 2,
            fps: fromPreset.encoding.maxFramerate
        }
    ];
    return layers.map((t)=>{
        var _a, _b;
        return new $c0722d30b1d17141$export$73e76f4fd970cdf1(Math.floor(fromPreset.width / t.scaleResolutionDownBy), Math.floor(fromPreset.height / t.scaleResolutionDownBy), Math.max(150000, Math.floor(fromPreset.encoding.maxBitrate / (Math.pow(t.scaleResolutionDownBy, 2) * (((_a = fromPreset.encoding.maxFramerate) !== null && _a !== void 0 ? _a : 30) / ((_b = t.fps) !== null && _b !== void 0 ? _b : 30))))), t.fps, fromPreset.encoding.priority);
    });
};
// /**
//  *
//  * @internal
//  * @experimental
//  */
// const computeDefaultMultiCodecSimulcastEncodings = (width: number, height: number) => {
//   // use vp8 as a default
//   const vp8 = determineAppropriateEncoding(false, width, height);
//   const vp9 = { ...vp8, maxBitrate: vp8.maxBitrate * 0.9 };
//   const h264 = { ...vp8, maxBitrate: vp8.maxBitrate * 1.1 };
//   const av1 = { ...vp8, maxBitrate: vp8.maxBitrate * 0.7 };
//   return {
//     vp8,
//     vp9,
//     h264,
//     av1,
//   };
// };
const $c0722d30b1d17141$var$videoRids = [
    'q',
    'h',
    'f'
];
/* @internal */ function $c0722d30b1d17141$var$computeVideoEncodings(isScreenShare, width, height, options) {
    var _a, _b;
    let videoEncoding = options === null || options === void 0 ? void 0 : options.videoEncoding;
    if (isScreenShare) videoEncoding = options === null || options === void 0 ? void 0 : options.screenShareEncoding;
    const useSimulcast = options === null || options === void 0 ? void 0 : options.simulcast;
    const scalabilityMode = options === null || options === void 0 ? void 0 : options.scalabilityMode;
    const videoCodec = options === null || options === void 0 ? void 0 : options.videoCodec;
    if (!videoEncoding && !useSimulcast && !scalabilityMode || !width || !height) // when we aren't simulcasting or svc, will need to return a single encoding without
    // capping bandwidth. we always require a encoding for dynacast
    return [
        {}
    ];
    if (!videoEncoding) {
        // find the right encoding based on width/height
        videoEncoding = $c0722d30b1d17141$var$determineAppropriateEncoding(isScreenShare, width, height, videoCodec);
        $c0722d30b1d17141$var$livekitLogger.debug('using video encoding', videoEncoding);
    }
    const sourceFramerate = videoEncoding.maxFramerate;
    const original = new $c0722d30b1d17141$export$73e76f4fd970cdf1(width, height, videoEncoding.maxBitrate, videoEncoding.maxFramerate, videoEncoding.priority);
    if (scalabilityMode && $c0722d30b1d17141$var$isSVCCodec(videoCodec)) {
        const sm = new $c0722d30b1d17141$var$ScalabilityMode(scalabilityMode);
        const encodings = [];
        if (sm.spatial > 3) throw new Error("unsupported scalabilityMode: ".concat(scalabilityMode));
        // Before M113 in Chrome, defining multiple encodings with an SVC codec indicated
        // that SVC mode should be used. Safari still works this way.
        // This is a bit confusing but is due to how libwebrtc interpreted the encodings field
        // before M113.
        // Announced here: https://groups.google.com/g/discuss-webrtc/c/-QQ3pxrl-fw?pli=1
        const browser = $c0722d30b1d17141$export$89e15fc796a4a429();
        if ($c0722d30b1d17141$var$isSafariBased() || // Even tho RN runs M114, it does not produce SVC layers when a single encoding
        // is provided. So we'll use the legacy SVC specification for now.
        // TODO: when we upstream libwebrtc, this will need additional verification
        $c0722d30b1d17141$var$isReactNative() || (browser === null || browser === void 0 ? void 0 : browser.name) === 'Chrome' && $c0722d30b1d17141$export$66e1c0999abad646(browser === null || browser === void 0 ? void 0 : browser.version, '113') < 0) {
            const bitratesRatio = sm.suffix == 'h' ? 2 : 3;
            // safari 18.4 uses a different svc API that requires scaleResolutionDownBy to be set.
            const requireScale = $c0722d30b1d17141$var$isSafariSvcApi(browser);
            for(let i = 0; i < sm.spatial; i += 1)// in legacy SVC, scaleResolutionDownBy cannot be set
            encodings.push({
                rid: $c0722d30b1d17141$var$videoRids[2 - i],
                maxBitrate: videoEncoding.maxBitrate / Math.pow(bitratesRatio, i),
                maxFramerate: original.encoding.maxFramerate,
                scaleResolutionDownBy: requireScale ? Math.pow(2, i) : undefined
            });
            // legacy SVC, scalabilityMode is set only on the first encoding
            /* @ts-ignore */ encodings[0].scalabilityMode = scalabilityMode;
        } else encodings.push({
            maxBitrate: videoEncoding.maxBitrate,
            maxFramerate: original.encoding.maxFramerate,
            /* @ts-ignore */ scalabilityMode: scalabilityMode
        });
        if (original.encoding.priority) {
            encodings[0].priority = original.encoding.priority;
            encodings[0].networkPriority = original.encoding.priority;
        }
        $c0722d30b1d17141$var$livekitLogger.debug("using svc encoding", {
            encodings: encodings
        });
        return encodings;
    }
    if (!useSimulcast) return [
        videoEncoding
    ];
    let presets = [];
    if (isScreenShare) presets = (_a = $c0722d30b1d17141$var$sortPresets(options === null || options === void 0 ? void 0 : options.screenShareSimulcastLayers)) !== null && _a !== void 0 ? _a : $c0722d30b1d17141$var$defaultSimulcastLayers(isScreenShare, original);
    else presets = (_b = $c0722d30b1d17141$var$sortPresets(options === null || options === void 0 ? void 0 : options.videoSimulcastLayers)) !== null && _b !== void 0 ? _b : $c0722d30b1d17141$var$defaultSimulcastLayers(isScreenShare, original);
    let midPreset;
    if (presets.length > 0) {
        const lowPreset = presets[0];
        if (presets.length > 1) [, midPreset] = presets;
        // NOTE:
        //   1. Ordering of these encodings is important. Chrome seems
        //      to use the index into encodings to decide which layer
        //      to disable when CPU constrained.
        //      So encodings should be ordered in increasing spatial
        //      resolution order.
        //   2. livekit-server translates rids into layers. So, all encodings
        //      should have the base layer `q` and then more added
        //      based on other conditions.
        const size = Math.max(width, height);
        if (size >= 960 && midPreset) return $c0722d30b1d17141$var$encodingsFromPresets(width, height, [
            lowPreset,
            midPreset,
            original
        ], sourceFramerate);
        if (size >= 480) return $c0722d30b1d17141$var$encodingsFromPresets(width, height, [
            lowPreset,
            original
        ], sourceFramerate);
    }
    return $c0722d30b1d17141$var$encodingsFromPresets(width, height, [
        original
    ]);
}
function $c0722d30b1d17141$var$computeTrackBackupEncodings(track, videoCodec, opts) {
    var _a, _b, _c, _d;
    // backupCodec should not be true anymore, default codec is set in LocalParticipant.publish
    if (!opts.backupCodec || opts.backupCodec === true || opts.backupCodec.codec === opts.videoCodec) // backup codec publishing is disabled
    return;
    if (videoCodec !== opts.backupCodec.codec) $c0722d30b1d17141$var$livekitLogger.warn('requested a different codec than specified as backup', {
        serverRequested: videoCodec,
        backup: opts.backupCodec.codec
    });
    opts.videoCodec = videoCodec;
    // use backup encoding setting as videoEncoding for backup codec publishing
    opts.videoEncoding = opts.backupCodec.encoding;
    const settings = track.mediaStreamTrack.getSettings();
    const width = (_a = settings.width) !== null && _a !== void 0 ? _a : (_b = track.dimensions) === null || _b === void 0 ? void 0 : _b.width;
    const height = (_c = settings.height) !== null && _c !== void 0 ? _c : (_d = track.dimensions) === null || _d === void 0 ? void 0 : _d.height;
    // disable simulcast for screenshare backup codec since L1Tx is used by primary codec
    if (track.source === $c0722d30b1d17141$export$13921ac0cc260818.Source.ScreenShare && opts.simulcast) opts.simulcast = false;
    const encodings = $c0722d30b1d17141$var$computeVideoEncodings(track.source === $c0722d30b1d17141$export$13921ac0cc260818.Source.ScreenShare, width, height, opts);
    return encodings;
}
/* @internal */ function $c0722d30b1d17141$var$determineAppropriateEncoding(isScreenShare, width, height, codec) {
    const presets = $c0722d30b1d17141$var$presetsForResolution(isScreenShare, width, height);
    let { encoding: encoding } = presets[0];
    // handle portrait by swapping dimensions
    const size = Math.max(width, height);
    for(let i = 0; i < presets.length; i += 1){
        const preset = presets[i];
        encoding = preset.encoding;
        if (preset.width >= size) break;
    }
    // presets are based on the assumption of vp8 as a codec
    // for other codecs we adjust the maxBitrate if no specific videoEncoding has been provided
    // users should override these with ones that are optimized for their use case
    // NOTE: SVC codec bitrates are inclusive of all scalability layers. while
    // bitrate for non-SVC codecs does not include other simulcast layers.
    if (codec) switch(codec){
        case 'av1':
        case 'h265':
            encoding = Object.assign({}, encoding);
            encoding.maxBitrate = encoding.maxBitrate * 0.7;
            break;
        case 'vp9':
            encoding = Object.assign({}, encoding);
            encoding.maxBitrate = encoding.maxBitrate * 0.85;
            break;
    }
    return encoding;
}
/* @internal */ function $c0722d30b1d17141$var$presetsForResolution(isScreenShare, width, height) {
    if (isScreenShare) return $c0722d30b1d17141$var$presetsScreenShare;
    const aspect = width > height ? width / height : height / width;
    if (Math.abs(aspect - 16.0 / 9) < Math.abs(aspect - 4.0 / 3)) return $c0722d30b1d17141$var$presets169;
    return $c0722d30b1d17141$var$presets43;
}
/* @internal */ function $c0722d30b1d17141$var$defaultSimulcastLayers(isScreenShare, original) {
    if (isScreenShare) return $c0722d30b1d17141$var$computeDefaultScreenShareSimulcastPresets(original);
    const { width: width, height: height } = original;
    const aspect = width > height ? width / height : height / width;
    if (Math.abs(aspect - 16.0 / 9) < Math.abs(aspect - 4.0 / 3)) return $c0722d30b1d17141$var$defaultSimulcastPresets169;
    return $c0722d30b1d17141$var$defaultSimulcastPresets43;
}
// presets should be ordered by low, medium, high
function $c0722d30b1d17141$var$encodingsFromPresets(width, height, presets, sourceFramerate) {
    const encodings = [];
    presets.forEach((preset, idx)=>{
        if (idx >= $c0722d30b1d17141$var$videoRids.length) return;
        const size = Math.min(width, height);
        const rid = $c0722d30b1d17141$var$videoRids[idx];
        const encoding = {
            rid: rid,
            scaleResolutionDownBy: Math.max(1, size / Math.min(preset.width, preset.height)),
            maxBitrate: preset.encoding.maxBitrate
        };
        // ensure that the sourceFramerate is the highest framerate applied across all layers so that the
        // original encoding doesn't get bumped unintentionally by any of the other layers
        const maxFramerate = sourceFramerate && preset.encoding.maxFramerate ? Math.min(sourceFramerate, preset.encoding.maxFramerate) : preset.encoding.maxFramerate;
        if (maxFramerate) encoding.maxFramerate = maxFramerate;
        const browser = $c0722d30b1d17141$export$89e15fc796a4a429();
        const canSetPriority = (browser === null || browser === void 0 ? void 0 : browser.name) === 'Firefox' && browser.os !== 'iOS' || idx === 0;
        if (preset.encoding.priority && canSetPriority) {
            encoding.priority = preset.encoding.priority;
            encoding.networkPriority = preset.encoding.priority;
        }
        encodings.push(encoding);
    });
    // RN ios simulcast requires all same framerates.
    if ($c0722d30b1d17141$var$isReactNative() && $c0722d30b1d17141$var$getReactNativeOs() === 'ios') {
        let topFramerate = undefined;
        encodings.forEach((encoding)=>{
            if (!topFramerate) topFramerate = encoding.maxFramerate;
            else if (encoding.maxFramerate && encoding.maxFramerate > topFramerate) topFramerate = encoding.maxFramerate;
        });
        let notifyOnce = true;
        encodings.forEach((encoding)=>{
            var _a;
            if (encoding.maxFramerate != topFramerate) {
                if (notifyOnce) {
                    notifyOnce = false;
                    $c0722d30b1d17141$var$livekitLogger.info("Simulcast on iOS React-Native requires all encodings to share the same framerate.");
                }
                $c0722d30b1d17141$var$livekitLogger.info("Setting framerate of encoding \"".concat((_a = encoding.rid) !== null && _a !== void 0 ? _a : '', "\" to ").concat(topFramerate));
                encoding.maxFramerate = topFramerate;
            }
        });
    }
    return encodings;
}
/** @internal */ function $c0722d30b1d17141$var$sortPresets(presets) {
    if (!presets) return;
    return presets.sort((a, b)=>{
        const { encoding: aEnc } = a;
        const { encoding: bEnc } = b;
        if (aEnc.maxBitrate > bEnc.maxBitrate) return 1;
        if (aEnc.maxBitrate < bEnc.maxBitrate) return -1;
        if (aEnc.maxBitrate === bEnc.maxBitrate && aEnc.maxFramerate && bEnc.maxFramerate) return aEnc.maxFramerate > bEnc.maxFramerate ? 1 : -1;
        return 0;
    });
}
/** @internal */ class $c0722d30b1d17141$var$ScalabilityMode {
    constructor(scalabilityMode){
        const results = scalabilityMode.match(/^L(\d)T(\d)(h|_KEY|_KEY_SHIFT){0,1}$/);
        if (!results) throw new Error('invalid scalability mode');
        this.spatial = parseInt(results[1]);
        this.temporal = parseInt(results[2]);
        if (results.length > 3) switch(results[3]){
            case 'h':
            case '_KEY':
            case '_KEY_SHIFT':
                this.suffix = results[3];
        }
    }
    toString() {
        var _a;
        return "L".concat(this.spatial, "T").concat(this.temporal).concat((_a = this.suffix) !== null && _a !== void 0 ? _a : '');
    }
}
function $c0722d30b1d17141$var$getDefaultDegradationPreference(track) {
    // a few of reasons we have different default paths:
    // 1. without this, Chrome seems to aggressively resize the SVC video stating `quality-limitation: bandwidth` even when BW isn't an issue
    // 2. since we are overriding contentHint to motion (to workaround L1T3 publishing), it overrides the default degradationPreference to `balanced`
    if (track.source === $c0722d30b1d17141$export$13921ac0cc260818.Source.ScreenShare || track.constraints.height && $c0722d30b1d17141$var$unwrapConstraint(track.constraints.height) >= 1080) return 'maintain-resolution';
    else return 'balanced';
}
const $c0722d30b1d17141$var$refreshSubscribedCodecAfterNewCodec = 5000;
class $c0722d30b1d17141$export$d5ffd2c62c538bdc extends $c0722d30b1d17141$export$3e041ce3f33f04dd {
    get sender() {
        return this._sender;
    }
    set sender(sender) {
        this._sender = sender;
        if (this.degradationPreference) this.setDegradationPreference(this.degradationPreference);
    }
    /**
   *
   * @param mediaTrack
   * @param constraints MediaTrackConstraints that are being used when restarting or reacquiring tracks
   * @param userProvidedTrack Signals to the SDK whether or not the mediaTrack should be managed (i.e. released and reacquired) internally by the SDK
   */ constructor(mediaTrack, constraints){
        let userProvidedTrack = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        let loggerOptions = arguments.length > 3 ? arguments[3] : undefined;
        super(mediaTrack, $c0722d30b1d17141$export$13921ac0cc260818.Kind.Video, constraints, userProvidedTrack, loggerOptions);
        /* @internal */ this.simulcastCodecs = new Map();
        this.degradationPreference = 'balanced';
        this.isCpuConstrained = false;
        this.optimizeForPerformance = false;
        this.monitorSender = ()=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                if (!this.sender) {
                    this._currentBitrate = 0;
                    return;
                }
                let stats;
                try {
                    stats = yield this.getSenderStats();
                } catch (e) {
                    this.log.error('could not get video sender stats', Object.assign(Object.assign({}, this.logContext), {
                        error: e
                    }));
                    return;
                }
                const statsMap = new Map(stats.map((s)=>[
                        s.rid,
                        s
                    ]));
                const isCpuConstrained = stats.some((s)=>s.qualityLimitationReason === 'cpu');
                if (isCpuConstrained !== this.isCpuConstrained) {
                    this.isCpuConstrained = isCpuConstrained;
                    if (this.isCpuConstrained) this.emit($c0722d30b1d17141$export$2c8510d737cc09da.CpuConstrained);
                }
                if (this.prevStats) {
                    let totalBitrate = 0;
                    statsMap.forEach((s, key)=>{
                        var _a;
                        const prev = (_a = this.prevStats) === null || _a === void 0 ? void 0 : _a.get(key);
                        totalBitrate += $c0722d30b1d17141$var$computeBitrate(s, prev);
                    });
                    this._currentBitrate = totalBitrate;
                }
                this.prevStats = statsMap;
            });
        this.senderLock = new $c0722d30b1d17141$export$ca12f2943758ef55();
    }
    get isSimulcast() {
        if (this.sender && this.sender.getParameters().encodings.length > 1) return true;
        return false;
    }
    /* @internal */ startMonitor(signalClient) {
        var _a;
        this.signalClient = signalClient;
        if (!$c0722d30b1d17141$var$isWeb()) return;
        // save original encodings
        // TODO : merge simulcast tracks stats
        const params = (_a = this.sender) === null || _a === void 0 ? void 0 : _a.getParameters();
        if (params) this.encodings = params.encodings;
        if (this.monitorInterval) return;
        this.monitorInterval = setInterval(()=>{
            this.monitorSender();
        }, $c0722d30b1d17141$var$monitorFrequency);
    }
    stop() {
        this._mediaStreamTrack.getConstraints();
        this.simulcastCodecs.forEach((trackInfo)=>{
            trackInfo.mediaStreamTrack.stop();
        });
        super.stop();
    }
    pauseUpstream() {
        const _super = Object.create(null, {
            pauseUpstream: {
                get: ()=>super.pauseUpstream
            }
        });
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a, e_1, _b, _c;
            var _d;
            yield _super.pauseUpstream.call(this);
            try {
                for(var _e = true, _f = $c0722d30b1d17141$var$__asyncValues(this.simulcastCodecs.values()), _g; _g = yield _f.next(), _a = _g.done, !_a; _e = true){
                    _c = _g.value;
                    _e = false;
                    const sc = _c;
                    yield (_d = sc.sender) === null || _d === void 0 ? void 0 : _d.replaceTrack(null);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (!_e && !_a && (_b = _f.return)) yield _b.call(_f);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        });
    }
    resumeUpstream() {
        const _super = Object.create(null, {
            resumeUpstream: {
                get: ()=>super.resumeUpstream
            }
        });
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a, e_2, _b, _c;
            var _d;
            yield _super.resumeUpstream.call(this);
            try {
                for(var _e = true, _f = $c0722d30b1d17141$var$__asyncValues(this.simulcastCodecs.values()), _g; _g = yield _f.next(), _a = _g.done, !_a; _e = true){
                    _c = _g.value;
                    _e = false;
                    const sc = _c;
                    yield (_d = sc.sender) === null || _d === void 0 ? void 0 : _d.replaceTrack(sc.mediaStreamTrack);
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (!_e && !_a && (_b = _f.return)) yield _b.call(_f);
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
        });
    }
    mute() {
        const _super = Object.create(null, {
            mute: {
                get: ()=>super.mute
            }
        });
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            const unlock = yield this.muteLock.lock();
            try {
                if (this.isMuted) {
                    this.log.debug('Track already muted', this.logContext);
                    return this;
                }
                if (this.source === $c0722d30b1d17141$export$13921ac0cc260818.Source.Camera && !this.isUserProvided) {
                    this.log.debug('stopping camera track', this.logContext);
                    // also stop the track, so that camera indicator is turned off
                    this._mediaStreamTrack.stop();
                }
                yield _super.mute.call(this);
                return this;
            } finally{
                unlock();
            }
        });
    }
    unmute() {
        const _super = Object.create(null, {
            unmute: {
                get: ()=>super.unmute
            }
        });
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            const unlock = yield this.muteLock.lock();
            try {
                if (!this.isMuted) {
                    this.log.debug('Track already unmuted', this.logContext);
                    return this;
                }
                if (this.source === $c0722d30b1d17141$export$13921ac0cc260818.Source.Camera && !this.isUserProvided) {
                    this.log.debug('reacquiring camera track', this.logContext);
                    yield this.restart(undefined, true);
                }
                yield _super.unmute.call(this);
                return this;
            } finally{
                unlock();
            }
        });
    }
    setTrackMuted(muted) {
        super.setTrackMuted(muted);
        for (const sc of this.simulcastCodecs.values())sc.mediaStreamTrack.enabled = !muted;
    }
    getSenderStats() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            if (!((_a = this.sender) === null || _a === void 0 ? void 0 : _a.getStats)) return [];
            const items = [];
            const stats = yield this.sender.getStats();
            stats.forEach((v)=>{
                var _a;
                if (v.type === 'outbound-rtp') {
                    const vs = {
                        type: 'video',
                        streamId: v.id,
                        frameHeight: v.frameHeight,
                        frameWidth: v.frameWidth,
                        framesPerSecond: v.framesPerSecond,
                        framesSent: v.framesSent,
                        firCount: v.firCount,
                        pliCount: v.pliCount,
                        nackCount: v.nackCount,
                        packetsSent: v.packetsSent,
                        bytesSent: v.bytesSent,
                        qualityLimitationReason: v.qualityLimitationReason,
                        qualityLimitationDurations: v.qualityLimitationDurations,
                        qualityLimitationResolutionChanges: v.qualityLimitationResolutionChanges,
                        rid: (_a = v.rid) !== null && _a !== void 0 ? _a : v.id,
                        retransmittedPacketsSent: v.retransmittedPacketsSent,
                        targetBitrate: v.targetBitrate,
                        timestamp: v.timestamp
                    };
                    // locate the appropriate remote-inbound-rtp item
                    const r = stats.get(v.remoteId);
                    if (r) {
                        vs.jitter = r.jitter;
                        vs.packetsLost = r.packetsLost;
                        vs.roundTripTime = r.roundTripTime;
                    }
                    items.push(vs);
                }
            });
            // make sure highest res layer is always first
            items.sort((a, b)=>{
                var _a, _b;
                return ((_a = b.frameWidth) !== null && _a !== void 0 ? _a : 0) - ((_b = a.frameWidth) !== null && _b !== void 0 ? _b : 0);
            });
            return items;
        });
    }
    setPublishingQuality(maxQuality) {
        const qualities = [];
        for(let q = $c0722d30b1d17141$export$a8f593954e806155.LOW; q <= $c0722d30b1d17141$export$a8f593954e806155.HIGH; q += 1)qualities.push(new $c0722d30b1d17141$var$SubscribedQuality({
            quality: q,
            enabled: q <= maxQuality
        }));
        this.log.debug("setting publishing quality. max quality ".concat(maxQuality), this.logContext);
        this.setPublishingLayers($c0722d30b1d17141$var$isSVCCodec(this.codec), qualities);
    }
    restartTrack(options) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a, e_3, _b, _c;
            var _d;
            let constraints;
            if (options) {
                const streamConstraints = $c0722d30b1d17141$var$constraintsForOptions({
                    video: options
                });
                if (typeof streamConstraints.video !== 'boolean') constraints = streamConstraints.video;
            }
            yield this.restart(constraints);
            // reset cpu constrained state after track is restarted
            this.isCpuConstrained = false;
            try {
                for(var _e = true, _f = $c0722d30b1d17141$var$__asyncValues(this.simulcastCodecs.values()), _g; _g = yield _f.next(), _a = _g.done, !_a; _e = true){
                    _c = _g.value;
                    _e = false;
                    const sc = _c;
                    if (sc.sender && ((_d = sc.sender.transport) === null || _d === void 0 ? void 0 : _d.state) !== 'closed') {
                        sc.mediaStreamTrack = this.mediaStreamTrack.clone();
                        yield sc.sender.replaceTrack(sc.mediaStreamTrack);
                    }
                }
            } catch (e_3_1) {
                e_3 = {
                    error: e_3_1
                };
            } finally{
                try {
                    if (!_e && !_a && (_b = _f.return)) yield _b.call(_f);
                } finally{
                    if (e_3) throw e_3.error;
                }
            }
            // The new MediaStreamTrack may have different dimensions than the previous one
            // (e.g. switching between cameras with different native resolutions), which would
            // leave the sender's encoding parameters (scaleResolutionDownBy, maxBitrate, etc.)
            // based on the old dimensions. Recompute them so the encoded output matches the
            // new source.
            yield this.onSenderTrackSwapped();
        });
    }
    onSenderTrackSwapped() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            yield this.refreshSenderEncodings();
        });
    }
    /**
   * Recomputes encoding parameters for this track's senders based on the current
   * MediaStreamTrack dimensions and reapplies them via setParameters. This is a no-op
   * if the track hasn't been published yet or if the track is in performance-optimized
   * mode (which manages its own encodings).
   */ refreshSenderEncodings() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            if (!this.sender || !this.publishOptions || this.optimizeForPerformance) return;
            const unlock = yield this.senderLock.lock();
            try {
                let dims;
                try {
                    dims = yield this.waitForDimensions();
                } catch (e) {
                    this.log.warn('could not determine new track dimensions, skipping encoding recompute', Object.assign(Object.assign({}, this.logContext), {
                        error: e
                    }));
                    return;
                }
                if (this.lastEncodedDimensions && this.lastEncodedDimensions.width === dims.width && this.lastEncodedDimensions.height === dims.height) return;
                const isScreenShare = this.source === $c0722d30b1d17141$export$13921ac0cc260818.Source.ScreenShare;
                const newEncodings = $c0722d30b1d17141$var$computeVideoEncodings(isScreenShare, dims.width, dims.height, Object.assign({}, this.publishOptions));
                yield this.applyEncodingsToSender(this.sender, newEncodings);
                this.encodings = newEncodings;
                this.lastEncodedDimensions = dims;
                for (const [codec, sc] of this.simulcastCodecs){
                    if (!sc.sender || ((_a = sc.sender.transport) === null || _a === void 0 ? void 0 : _a.state) === 'closed') continue;
                    if (!$c0722d30b1d17141$export$5049e6bde83900(codec)) continue;
                    const backupOpts = Object.assign({}, this.publishOptions);
                    const backupEncodings = $c0722d30b1d17141$var$computeTrackBackupEncodings(this, codec, backupOpts);
                    if (!backupEncodings) continue;
                    yield this.applyEncodingsToSender(sc.sender, backupEncodings);
                    sc.encodings = backupEncodings;
                }
            } catch (e) {
                this.log.warn('failed to apply recomputed encodings', Object.assign(Object.assign({}, this.logContext), {
                    error: e
                }));
            } finally{
                unlock();
            }
        });
    }
    applyEncodingsToSender(sender, encodings) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            const params = sender.getParameters();
            if (!params.encodings || params.encodings.length !== encodings.length) return;
            params.encodings.forEach((existing, idx)=>{
                // preserve disabled layers (dynacast / Firefox workaround in
                // setPublishingLayersForSender set scaleResolutionDownBy/maxBitrate to sentinel
                // values for disabled layers — don't clobber those).
                if (existing.active === false) return;
                const next = encodings[idx];
                if (next.scaleResolutionDownBy !== undefined) existing.scaleResolutionDownBy = next.scaleResolutionDownBy;
                if (next.maxBitrate !== undefined) existing.maxBitrate = next.maxBitrate;
                if (next.maxFramerate !== undefined) existing.maxFramerate = next.maxFramerate;
                if (next.priority !== undefined) {
                    existing.priority = next.priority;
                    existing.networkPriority = next.priority;
                }
            });
            this.log.debug('updating sender encodings after track restart', Object.assign(Object.assign({}, this.logContext), {
                encodings: params.encodings
            }));
            yield sender.setParameters(params);
        });
    }
    setProcessor(processor_1) {
        const _super = Object.create(null, {
            setProcessor: {
                get: ()=>super.setProcessor
            }
        });
        return $c0722d30b1d17141$var$__awaiter(this, arguments, void 0, function(processor) {
            var _this = this;
            let showProcessedStreamLocally = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            return function*() {
                var _a, e_4, _b, _c;
                var _d, _e;
                yield _super.setProcessor.call(_this, processor, showProcessedStreamLocally);
                if ((_d = _this.processor) === null || _d === void 0 ? void 0 : _d.processedTrack) try {
                    for(var _f = true, _g = $c0722d30b1d17141$var$__asyncValues(_this.simulcastCodecs.values()), _h; _h = yield _g.next(), _a = _h.done, !_a; _f = true){
                        _c = _h.value;
                        _f = false;
                        const sc = _c;
                        yield (_e = sc.sender) === null || _e === void 0 ? void 0 : _e.replaceTrack(_this.processor.processedTrack);
                    }
                } catch (e_4_1) {
                    e_4 = {
                        error: e_4_1
                    };
                } finally{
                    try {
                        if (!_f && !_a && (_b = _g.return)) yield _b.call(_g);
                    } finally{
                        if (e_4) throw e_4.error;
                    }
                }
            }();
        });
    }
    setDegradationPreference(preference) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            this.degradationPreference = preference;
            if (this.sender) try {
                this.log.debug("setting degradationPreference to ".concat(preference), this.logContext);
                const params = this.sender.getParameters();
                params.degradationPreference = preference;
                this.sender.setParameters(params);
            } catch (e) {
                this.log.warn("failed to set degradationPreference", Object.assign({
                    error: e
                }, this.logContext));
            }
        });
    }
    addSimulcastTrack(codec, encodings) {
        if (this.simulcastCodecs.has(codec)) {
            this.log.error("".concat(codec, " already added, skipping adding simulcast codec"), this.logContext);
            return;
        }
        const simulcastCodecInfo = {
            codec: codec,
            mediaStreamTrack: this.mediaStreamTrack.clone(),
            sender: undefined,
            encodings: encodings
        };
        this.simulcastCodecs.set(codec, simulcastCodecInfo);
        return simulcastCodecInfo;
    }
    setSimulcastTrackSender(codec, sender) {
        const simulcastCodecInfo = this.simulcastCodecs.get(codec);
        if (!simulcastCodecInfo) return;
        simulcastCodecInfo.sender = sender;
        // browser will reenable disabled codec/layers after new codec has been published,
        // so refresh subscribedCodecs after publish a new codec
        setTimeout(()=>{
            if (this.subscribedCodecs) this.setPublishingCodecs(this.subscribedCodecs);
        }, $c0722d30b1d17141$var$refreshSubscribedCodecAfterNewCodec);
    }
    /**
   * @internal
   * Sets codecs that should be publishing, returns new codecs that have not yet
   * been published
   */ setPublishingCodecs(codecs) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a, codecs_1, codecs_1_1;
            var _b, e_5, _c, _d;
            this.log.debug('setting publishing codecs', Object.assign(Object.assign({}, this.logContext), {
                codecs: codecs,
                currentCodec: this.codec
            }));
            // only enable simulcast codec for preference codec setted
            if (!this.codec && codecs.length > 0) {
                yield this.setPublishingLayers($c0722d30b1d17141$var$isSVCCodec(codecs[0].codec), codecs[0].qualities);
                return [];
            }
            this.subscribedCodecs = codecs;
            const newCodecs = [];
            try {
                for(_a = true, codecs_1 = $c0722d30b1d17141$var$__asyncValues(codecs); codecs_1_1 = yield codecs_1.next(), _b = codecs_1_1.done, !_b; _a = true){
                    _d = codecs_1_1.value;
                    _a = false;
                    const codec = _d;
                    if (!this.codec || this.codec === codec.codec) yield this.setPublishingLayers($c0722d30b1d17141$var$isSVCCodec(codec.codec), codec.qualities);
                    else {
                        const simulcastCodecInfo = this.simulcastCodecs.get(codec.codec);
                        this.log.debug("try setPublishingCodec for ".concat(codec.codec), Object.assign(Object.assign({}, this.logContext), {
                            simulcastCodecInfo: simulcastCodecInfo
                        }));
                        if (!simulcastCodecInfo || !simulcastCodecInfo.sender) {
                            for (const q of codec.qualities)if (q.enabled) {
                                newCodecs.push(codec.codec);
                                break;
                            }
                        } else if (simulcastCodecInfo.encodings) {
                            this.log.debug("try setPublishingLayersForSender ".concat(codec.codec), this.logContext);
                            yield $c0722d30b1d17141$var$setPublishingLayersForSender(simulcastCodecInfo.sender, simulcastCodecInfo.encodings, codec.qualities, this.senderLock, $c0722d30b1d17141$var$isSVCCodec(codec.codec), this.log, this.logContext);
                        }
                    }
                }
            } catch (e_5_1) {
                e_5 = {
                    error: e_5_1
                };
            } finally{
                try {
                    if (!_a && !_b && (_c = codecs_1.return)) yield _c.call(codecs_1);
                } finally{
                    if (e_5) throw e_5.error;
                }
            }
            return newCodecs;
        });
    }
    /**
   * @internal
   * Sets layers that should be publishing
   */ setPublishingLayers(isSvc, qualities) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            if (this.optimizeForPerformance) {
                this.log.info('skipping setPublishingLayers due to optimized publishing performance', Object.assign(Object.assign({}, this.logContext), {
                    qualities: qualities
                }));
                return;
            }
            this.log.debug('setting publishing layers', Object.assign(Object.assign({}, this.logContext), {
                qualities: qualities
            }));
            if (!this.sender || !this.encodings) return;
            yield $c0722d30b1d17141$var$setPublishingLayersForSender(this.sender, this.encodings, qualities, this.senderLock, isSvc, this.log, this.logContext);
        });
    }
    /**
   * Designed for lower powered devices, reduces video publishing quality and disables simulcast.
   * @experimental
   */ prioritizePerformance() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.sender) throw new Error('sender not found');
            const unlock = yield this.senderLock.lock();
            try {
                this.optimizeForPerformance = true;
                const params = this.sender.getParameters();
                params.encodings = params.encodings.map((e, idx)=>{
                    var _a;
                    return Object.assign(Object.assign({}, e), {
                        active: idx === 0,
                        scaleResolutionDownBy: Math.max(1, Math.ceil(((_a = this.mediaStreamTrack.getSettings().height) !== null && _a !== void 0 ? _a : 360) / 360)),
                        scalabilityMode: idx === 0 && $c0722d30b1d17141$var$isSVCCodec(this.codec) ? 'L1T3' : undefined,
                        maxFramerate: idx === 0 ? 15 : 0,
                        maxBitrate: idx === 0 ? e.maxBitrate : 0
                    });
                });
                this.log.debug('setting performance optimised encodings', Object.assign(Object.assign({}, this.logContext), {
                    encodings: params.encodings
                }));
                this.encodings = params.encodings;
                yield this.sender.setParameters(params);
            } catch (e) {
                this.log.error('failed to set performance optimised encodings', Object.assign(Object.assign({}, this.logContext), {
                    error: e
                }));
                this.optimizeForPerformance = false;
            } finally{
                unlock();
            }
        });
    }
    handleAppVisibilityChanged() {
        const _super = Object.create(null, {
            handleAppVisibilityChanged: {
                get: ()=>super.handleAppVisibilityChanged
            }
        });
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            yield _super.handleAppVisibilityChanged.call(this);
            if (!$c0722d30b1d17141$var$isMobile()) return;
            if (this.isInBackground && this.source === $c0722d30b1d17141$export$13921ac0cc260818.Source.Camera) this._mediaStreamTrack.enabled = false;
        });
    }
}
function $c0722d30b1d17141$var$setPublishingLayersForSender(sender, senderEncodings, qualities, senderLock, isSVC, log, logContext) {
    return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
        const unlock = yield senderLock.lock();
        log.debug('setPublishingLayersForSender', Object.assign(Object.assign({}, logContext), {
            sender: sender,
            qualities: qualities,
            senderEncodings: senderEncodings
        }));
        try {
            const params = sender.getParameters();
            const { encodings: encodings } = params;
            if (!encodings) return;
            if (encodings.length !== senderEncodings.length) {
                log.warn('cannot set publishing layers, encodings mismatch', Object.assign(Object.assign({}, logContext), {
                    encodings: encodings,
                    senderEncodings: senderEncodings
                }));
                return;
            }
            let hasChanged = false;
            /* disable closable spatial layer as it has video blur / frozen issue with current server / client
      1. chrome 113: when switching to up layer with scalability Mode change, it will generate a
            low resolution frame and recover very quickly, but noticable
      2. livekit sfu: additional pli request cause video frozen for a few frames, also noticable */ const closableSpatial = false;
            /* @ts-ignore */ if (closableSpatial && encodings[0].scalabilityMode) ;
            else {
                if (isSVC) {
                    const hasEnabledEncoding = qualities.some((q)=>q.enabled);
                    if (hasEnabledEncoding) qualities.forEach((q)=>q.enabled = true);
                }
                // simulcast dynacast encodings
                encodings.forEach((encoding, idx)=>{
                    var _a;
                    let rid = (_a = encoding.rid) !== null && _a !== void 0 ? _a : '';
                    if (rid === '') rid = 'q';
                    const quality = $c0722d30b1d17141$var$videoQualityForRid(rid);
                    const subscribedQuality = qualities.find((q)=>q.quality === quality);
                    if (!subscribedQuality) return;
                    if (encoding.active !== subscribedQuality.enabled) {
                        hasChanged = true;
                        encoding.active = subscribedQuality.enabled;
                        log.debug("setting layer ".concat(subscribedQuality.quality, " to ").concat(encoding.active ? 'enabled' : 'disabled'), logContext);
                        // FireFox does not support setting encoding.active to false, so we
                        // have a workaround of lowering its bitrate and resolution to the min.
                        if ($c0722d30b1d17141$var$isFireFox()) {
                            if (subscribedQuality.enabled) {
                                encoding.scaleResolutionDownBy = senderEncodings[idx].scaleResolutionDownBy;
                                encoding.maxBitrate = senderEncodings[idx].maxBitrate;
                                /* @ts-ignore */ encoding.maxFrameRate = senderEncodings[idx].maxFrameRate;
                            } else {
                                encoding.scaleResolutionDownBy = 4;
                                encoding.maxBitrate = 10;
                                /* @ts-ignore */ encoding.maxFrameRate = 2;
                            }
                        }
                    }
                });
            }
            if (hasChanged) {
                params.encodings = encodings;
                log.debug("setting encodings", Object.assign(Object.assign({}, logContext), {
                    encodings: params.encodings
                }));
                yield sender.setParameters(params);
            }
        } finally{
            unlock();
        }
    });
}
function $c0722d30b1d17141$var$videoQualityForRid(rid) {
    switch(rid){
        case 'f':
            return $c0722d30b1d17141$export$a8f593954e806155.HIGH;
        case 'h':
            return $c0722d30b1d17141$export$a8f593954e806155.MEDIUM;
        case 'q':
            return $c0722d30b1d17141$export$a8f593954e806155.LOW;
        default:
            return $c0722d30b1d17141$export$a8f593954e806155.HIGH;
    }
}
function $c0722d30b1d17141$var$videoLayersFromEncodings(width, height, encodings, svc) {
    // default to a single layer, HQ
    if (!encodings) return [
        new $c0722d30b1d17141$var$VideoLayer({
            quality: $c0722d30b1d17141$export$a8f593954e806155.HIGH,
            width: width,
            height: height,
            bitrate: 0,
            ssrc: 0
        })
    ];
    if (svc) {
        // svc layers
        /* @ts-ignore */ const encodingSM = encodings[0].scalabilityMode;
        const sm = new $c0722d30b1d17141$var$ScalabilityMode(encodingSM);
        const layers = [];
        const resRatio = sm.suffix == 'h' ? 1.5 : 2;
        const bitratesRatio = sm.suffix == 'h' ? 2 : 3;
        for(let i = 0; i < sm.spatial; i += 1)layers.push(new $c0722d30b1d17141$var$VideoLayer({
            quality: Math.min($c0722d30b1d17141$export$a8f593954e806155.HIGH, sm.spatial - 1) - i,
            width: Math.ceil(width / Math.pow(resRatio, i)),
            height: Math.ceil(height / Math.pow(resRatio, i)),
            bitrate: encodings[0].maxBitrate ? Math.ceil(encodings[0].maxBitrate / Math.pow(bitratesRatio, i)) : 0,
            ssrc: 0
        }));
        return layers;
    }
    return encodings.map((encoding)=>{
        var _a, _b, _c;
        const scale = (_a = encoding.scaleResolutionDownBy) !== null && _a !== void 0 ? _a : 1;
        let quality = $c0722d30b1d17141$var$videoQualityForRid((_b = encoding.rid) !== null && _b !== void 0 ? _b : '');
        return new $c0722d30b1d17141$var$VideoLayer({
            quality: quality,
            width: Math.ceil(width / scale),
            height: Math.ceil(height / scale),
            bitrate: (_c = encoding.maxBitrate) !== null && _c !== void 0 ? _c : 0,
            ssrc: 0
        });
    });
}
const $c0722d30b1d17141$var$lossyDataChannel = '_lossy';
const $c0722d30b1d17141$var$reliableDataChannel = '_reliable';
const $c0722d30b1d17141$var$dataTrackDataChannel = '_data_track';
const $c0722d30b1d17141$var$minReconnectWait = 2000;
const $c0722d30b1d17141$var$leaveReconnect = 'leave-reconnect';
const $c0722d30b1d17141$var$reliabeReceiveStateTTL = 30000;
const $c0722d30b1d17141$var$lossyDataChannelBufferThresholdMin = 8192;
const $c0722d30b1d17141$var$lossyDataChannelBufferThresholdMax = 262144;
const $c0722d30b1d17141$var$initialMediaSectionsAudio = 3;
const $c0722d30b1d17141$var$initialMediaSectionsVideo = 3;
var $c0722d30b1d17141$var$PCState;
(function(PCState) {
    PCState[PCState["New"] = 0] = "New";
    PCState[PCState["Connected"] = 1] = "Connected";
    PCState[PCState["Disconnected"] = 2] = "Disconnected";
    PCState[PCState["Reconnecting"] = 3] = "Reconnecting";
    PCState[PCState["Closed"] = 4] = "Closed";
})($c0722d30b1d17141$var$PCState || ($c0722d30b1d17141$var$PCState = {}));
var $c0722d30b1d17141$var$DataChannelKind;
(function(DataChannelKind) {
    DataChannelKind[DataChannelKind["RELIABLE"] = 0] = "RELIABLE";
    DataChannelKind[DataChannelKind["LOSSY"] = 1] = "LOSSY";
    DataChannelKind[DataChannelKind["DATA_TRACK_LOSSY"] = 2] = "DATA_TRACK_LOSSY";
})($c0722d30b1d17141$var$DataChannelKind || ($c0722d30b1d17141$var$DataChannelKind = {}));
/** @internal */ class $c0722d30b1d17141$var$RTCEngine extends $c0722d30b1d17141$var$eventsExports.EventEmitter {
    get isClosed() {
        return this._isClosed;
    }
    get isNewlyCreated() {
        return this._isNewlyCreated;
    }
    get pendingReconnect() {
        return !!this.reconnectTimeout;
    }
    constructor(options){
        var _a;
        super();
        this.options = options;
        this.rtcConfig = {};
        this.peerConnectionTimeout = $c0722d30b1d17141$var$roomConnectOptionDefaults.peerConnectionTimeout;
        this.fullReconnectOnNext = false;
        /**
     * @internal
     */ this.latestRemoteOfferId = 0;
        this.subscriberPrimary = false;
        this.pcState = $c0722d30b1d17141$var$PCState.New;
        this._isClosed = true;
        this._isNewlyCreated = true;
        this.pendingTrackResolvers = {};
        this.reconnectAttempts = 0;
        this.reconnectStart = 0;
        this.attemptingReconnect = false;
        /** keeps track of how often an initial join connection has been tried */ this.joinAttempts = 0;
        /** specifies how often an initial join connection is allowed to retry */ this.maxJoinAttempts = 1;
        this.shouldFailNext = false;
        this.shouldFailOnV1Path = false;
        this.log = $c0722d30b1d17141$var$livekitLogger;
        this.reliableDataSequence = 1;
        this.reliableMessageBuffer = new $c0722d30b1d17141$var$DataPacketBuffer();
        this.reliableReceivedState = new $c0722d30b1d17141$var$TTLMap($c0722d30b1d17141$var$reliabeReceiveStateTTL);
        this.lossyDataStatCurrentBytes = 0;
        this.lossyDataStatByterate = 0;
        this.lossyDataDropCount = 0;
        this.midToTrackId = {};
        /** used to indicate whether the browser is currently waiting to reconnect */ this.isWaitingForNetworkReconnect = false;
        this.bufferStatusLowClosingFuture = new $c0722d30b1d17141$var$Future();
        this.handleDataChannel = (_a)=>$c0722d30b1d17141$var$__awaiter(this, [
                _a
            ], void 0, function(_ref) {
                var _this = this;
                let { channel: channel } = _ref;
                return function*() {
                    if (!channel) return;
                    let handler;
                    if (channel.label === $c0722d30b1d17141$var$reliableDataChannel) {
                        _this.reliableDCSub = channel;
                        handler = _this.handleDataMessage;
                    } else if (channel.label === $c0722d30b1d17141$var$lossyDataChannel) {
                        _this.lossyDCSub = channel;
                        handler = _this.handleDataMessage;
                    } else if (channel.label === $c0722d30b1d17141$var$dataTrackDataChannel) {
                        _this.dataTrackDCSub = channel;
                        handler = _this.handleDataTrackMessage;
                    } else return;
                    _this.log.debug("on data channel ".concat(channel.id, ", ").concat(channel.label));
                    channel.onmessage = handler;
                }();
            });
        this.handleDataMessage = (message)=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                var _a, _b, _c, _d, _e;
                // make sure to respect incoming data message order by processing message events one after the other
                const unlock = yield this.dataProcessLock.lock();
                try {
                    // decode
                    let buffer;
                    if (message.data instanceof ArrayBuffer) buffer = message.data;
                    else if (message.data instanceof Blob) buffer = yield message.data.arrayBuffer();
                    else {
                        this.log.error('unsupported data type', {
                            data: message.data
                        });
                        return;
                    }
                    const dp = $c0722d30b1d17141$var$DataPacket.fromBinary(new Uint8Array(buffer));
                    if (dp.sequence > 0 && dp.participantSid !== '') {
                        const lastSeq = this.reliableReceivedState.get(dp.participantSid);
                        if (lastSeq && dp.sequence <= lastSeq) // ignore duplicate or out-of-order packets in reliable channel
                        return;
                        this.reliableReceivedState.set(dp.participantSid, dp.sequence);
                    }
                    if (((_a = dp.value) === null || _a === void 0 ? void 0 : _a.case) === 'speaker') // dispatch speaker updates
                    this.emit($c0722d30b1d17141$export$c09e63b8572f869.ActiveSpeakersUpdate, dp.value.value.speakers);
                    else if (((_b = dp.value) === null || _b === void 0 ? void 0 : _b.case) === 'encryptedPacket') {
                        if (!this.e2eeManager) {
                            this.log.error('Received encrypted packet but E2EE not set up');
                            return;
                        }
                        const decryptedData = yield (_c = this.e2eeManager) === null || _c === void 0 ? void 0 : _c.handleEncryptedData(dp.value.value.encryptedValue, dp.value.value.iv, dp.participantIdentity, dp.value.value.keyIndex);
                        const decryptedPacket = $c0722d30b1d17141$var$EncryptedPacketPayload.fromBinary(decryptedData.payload);
                        const newDp = new $c0722d30b1d17141$var$DataPacket({
                            value: decryptedPacket.value,
                            participantIdentity: dp.participantIdentity,
                            participantSid: dp.participantSid
                        });
                        if (((_d = newDp.value) === null || _d === void 0 ? void 0 : _d.case) === 'user') // compatibility
                        $c0722d30b1d17141$var$applyUserDataCompat(newDp, newDp.value.value);
                        this.emit($c0722d30b1d17141$export$c09e63b8572f869.DataPacketReceived, newDp, dp.value.value.encryptionType);
                    } else {
                        if (((_e = dp.value) === null || _e === void 0 ? void 0 : _e.case) === 'user') // compatibility
                        $c0722d30b1d17141$var$applyUserDataCompat(dp, dp.value.value);
                        this.emit($c0722d30b1d17141$export$c09e63b8572f869.DataPacketReceived, dp, $c0722d30b1d17141$export$1efc488791285f20.NONE);
                    }
                } finally{
                    unlock();
                }
            });
        this.handleDataTrackMessage = (message)=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                // Decode / normalize into a common format
                let buffer;
                if (message.data instanceof ArrayBuffer) buffer = message.data;
                else if (message.data instanceof Blob) buffer = yield message.data.arrayBuffer();
                else {
                    this.log.error('unsupported data type', {
                        data: message.data
                    });
                    return;
                }
                this.emit('dataTrackPacketReceived', new Uint8Array(buffer));
            });
        this.handleDataError = (event)=>{
            const channel = event.currentTarget;
            const channelKind = channel.maxRetransmits === 0 ? 'lossy' : 'reliable';
            if (event instanceof ErrorEvent && event.error) {
                const { error: error } = event.error;
                this.log.error("DataChannel error on ".concat(channelKind, ": ").concat(event.message), {
                    error: error
                });
            } else this.log.error("Unknown DataChannel error on ".concat(channelKind), {
                event: event
            });
        };
        this.handleBufferedAmountLow = (channelKind)=>{
            this.updateAndEmitDCBufferStatus(channelKind);
        };
        // websocket reconnect behavior. if websocket is interrupted, and the PeerConnection
        // continues to work, we can reconnect to websocket to continue the session
        // after a number of retries, we'll close and give up permanently
        this.handleDisconnect = (connection, disconnectReason)=>{
            if (this._isClosed) return;
            this.log.warn("".concat(connection, " disconnected"));
            if (this.reconnectAttempts === 0) // only reset start time on the first try
            this.reconnectStart = Date.now();
            const disconnect = (duration)=>{
                this.log.warn("could not recover connection after ".concat(this.reconnectAttempts, " attempts, ").concat(duration, "ms. giving up"));
                this.emit($c0722d30b1d17141$export$c09e63b8572f869.Disconnected);
                this.close();
            };
            const duration = Date.now() - this.reconnectStart;
            let delay = this.getNextRetryDelay({
                elapsedMs: duration,
                retryCount: this.reconnectAttempts
            });
            if (delay === null) {
                disconnect(duration);
                return;
            }
            if (connection === $c0722d30b1d17141$var$leaveReconnect) delay = 0;
            this.log.debug("reconnecting in ".concat(delay, "ms"));
            this.clearReconnectTimeout();
            if (this.token) // token may have been refreshed, we do not want to recreate the regionUrlProvider
            // since the current engine may have inherited a regional url
            this.emit($c0722d30b1d17141$export$c09e63b8572f869.TokenRefreshed, this.token);
            this.reconnectTimeout = $c0722d30b1d17141$export$22e737276454df96.setTimeout(()=>this.attemptReconnect(disconnectReason).finally(()=>this.reconnectTimeout = undefined), delay);
        };
        this.waitForRestarted = ()=>{
            return new Promise((resolve, reject)=>{
                if (this.pcState === $c0722d30b1d17141$var$PCState.Connected) resolve();
                const onRestarted = ()=>{
                    this.off($c0722d30b1d17141$export$c09e63b8572f869.Disconnected, onDisconnected);
                    resolve();
                };
                const onDisconnected = ()=>{
                    this.off($c0722d30b1d17141$export$c09e63b8572f869.Restarted, onRestarted);
                    reject();
                };
                this.once($c0722d30b1d17141$export$c09e63b8572f869.Restarted, onRestarted);
                this.once($c0722d30b1d17141$export$c09e63b8572f869.Disconnected, onDisconnected);
            });
        };
        this.updateAndEmitDCBufferStatus = (kind)=>{
            if (kind === $c0722d30b1d17141$var$DataChannelKind.RELIABLE) {
                const dc = this.dataChannelForKind(kind);
                if (dc) this.reliableMessageBuffer.alignBufferedAmount(dc.bufferedAmount);
            }
            const status = this.isBufferStatusLow(kind);
            if (typeof status !== 'undefined' && status !== this.dcBufferStatus.get(kind)) {
                this.dcBufferStatus.set(kind, status);
                this.emit($c0722d30b1d17141$export$c09e63b8572f869.DCBufferStatusChanged, status, kind);
            }
        };
        this.isBufferStatusLow = (kind)=>{
            const dc = this.dataChannelForKind(kind);
            if (dc) return dc.bufferedAmount <= dc.bufferedAmountLowThreshold;
        };
        this.handleBrowserOnLine = ()=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                if (!this.url) return;
                const hasNetworkConnection = yield fetch($c0722d30b1d17141$var$toHttpUrl(this.url), {
                    method: 'HEAD'
                }).then((resp)=>resp.ok).catch(()=>false);
                if (!hasNetworkConnection) return;
                this.log.info('detected network reconnected');
                if (// in case the engine is currently reconnecting, attempt a reconnect immediately after the browser state has changed to 'onLine'
                this.client.currentState === $c0722d30b1d17141$var$SignalConnectionState.RECONNECTING || // also if the browser went offline before and the engine still thinks it's in a connected state, treat it as a network interruption that we haven't noticed yet
                this.isWaitingForNetworkReconnect && this.client.currentState === $c0722d30b1d17141$var$SignalConnectionState.CONNECTED) {
                    this.clearReconnectTimeout();
                    this.attemptReconnect($c0722d30b1d17141$var$ReconnectReason.RR_SIGNAL_DISCONNECTED);
                    this.isWaitingForNetworkReconnect = false;
                }
            });
        this.handleBrowserOffline = ()=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                if (!this.url) return;
                try {
                    yield Promise.race([
                        fetch($c0722d30b1d17141$var$toHttpUrl(this.url), {
                            method: 'HEAD'
                        }),
                        // if there's no internet connection the fetch rejects immediately, so we only use a short timeout here
                        $c0722d30b1d17141$var$sleep(4000).then(()=>Promise.reject())
                    ]);
                } catch (e) {
                    // only set if the browser still thinks it's offline after the request failed
                    if (window.navigator.onLine === false) {
                        this.log.info('detected network interruption');
                        this.isWaitingForNetworkReconnect = true;
                    }
                }
            });
        this.log = $c0722d30b1d17141$export$2b1d391cd05230fd((_a = options.loggerName) !== null && _a !== void 0 ? _a : $c0722d30b1d17141$export$69ba24dd79f4da21.Engine, ()=>this.logContext);
        this.loggerOptions = {
            loggerName: options.loggerName,
            loggerContextCb: ()=>this.logContext
        };
        this.client = new $c0722d30b1d17141$var$SignalClient(undefined, this.loggerOptions);
        this.client.signalLatency = this.options.expSignalLatency;
        this.reconnectPolicy = this.options.reconnectPolicy;
        this.closingLock = new $c0722d30b1d17141$export$ca12f2943758ef55();
        this.dataProcessLock = new $c0722d30b1d17141$export$ca12f2943758ef55();
        this.dcBufferStatus = new Map([
            [
                $c0722d30b1d17141$var$DataChannelKind.RELIABLE,
                true
            ],
            [
                $c0722d30b1d17141$var$DataChannelKind.LOSSY,
                true
            ],
            [
                $c0722d30b1d17141$var$DataChannelKind.DATA_TRACK_LOSSY,
                true
            ]
        ]);
        this.client.onParticipantUpdate = (updates)=>this.emit($c0722d30b1d17141$export$c09e63b8572f869.ParticipantUpdate, updates);
        this.client.onConnectionQuality = (update)=>this.emit($c0722d30b1d17141$export$c09e63b8572f869.ConnectionQualityUpdate, update);
        this.client.onRoomUpdate = (update)=>this.emit($c0722d30b1d17141$export$c09e63b8572f869.RoomUpdate, update);
        this.client.onSubscriptionError = (resp)=>this.emit($c0722d30b1d17141$export$c09e63b8572f869.SubscriptionError, resp);
        this.client.onSubscriptionPermissionUpdate = (update)=>this.emit($c0722d30b1d17141$export$c09e63b8572f869.SubscriptionPermissionUpdate, update);
        this.client.onSpeakersChanged = (update)=>this.emit($c0722d30b1d17141$export$c09e63b8572f869.SpeakersChanged, update);
        this.client.onStreamStateUpdate = (update)=>this.emit($c0722d30b1d17141$export$c09e63b8572f869.StreamStateChanged, update);
        this.client.onRequestResponse = (response)=>this.emit($c0722d30b1d17141$export$c09e63b8572f869.SignalRequestResponse, response);
        this.client.onParticipantUpdate = (updates)=>this.emit($c0722d30b1d17141$export$c09e63b8572f869.ParticipantUpdate, updates);
        this.client.onJoined = (joinResponse)=>this.emit($c0722d30b1d17141$export$c09e63b8572f869.Joined, joinResponse);
        this.on($c0722d30b1d17141$export$c09e63b8572f869.Closing, ()=>{
            var _a, _b;
            (_b = (_a = this.bufferStatusLowClosingFuture).reject) === null || _b === void 0 || _b.call(_a, new $c0722d30b1d17141$export$1f388e244efbf70b('engine closed'));
        });
        // Swallow the rejection at the source so it doesn't surface as an unhandled promise rejection
        // when no waitForBufferStatusLow callers are attached.
        this.bufferStatusLowClosingFuture.promise.catch(()=>{});
    }
    /** @internal */ get logContext() {
        var _a, _b, _c, _d, _e, _f;
        return {
            room: (_b = (_a = this.latestJoinResponse) === null || _a === void 0 ? void 0 : _a.room) === null || _b === void 0 ? void 0 : _b.name,
            roomID: (_d = (_c = this.latestJoinResponse) === null || _c === void 0 ? void 0 : _c.room) === null || _d === void 0 ? void 0 : _d.sid,
            participant: (_f = (_e = this.latestJoinResponse) === null || _e === void 0 ? void 0 : _e.participant) === null || _f === void 0 ? void 0 : _f.identity,
            participantID: this.participantSid
        };
    }
    join(url_1, token_1, opts_1, abortSignal_1) {
        return $c0722d30b1d17141$var$__awaiter(this, arguments, void 0, function(url, token, opts, abortSignal) {
            var _this2 = this;
            let useV0Path = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
            return function*() {
                var _a, _b, _c;
                _this2._isNewlyCreated = false;
                _this2.url = url;
                _this2.token = token;
                _this2.signalOpts = opts;
                _this2.maxJoinAttempts = opts.maxRetries;
                try {
                    _this2.joinAttempts += 1;
                    _this2.setupSignalClientCallbacks();
                    let offerProto;
                    if (!useV0Path && $c0722d30b1d17141$var$isCompressionStreamSupported()) {
                        if (!_this2.pcManager) {
                            yield _this2.configure();
                            _this2.createDataChannels();
                            _this2.addMediaSections($c0722d30b1d17141$var$initialMediaSectionsAudio, $c0722d30b1d17141$var$initialMediaSectionsVideo);
                        }
                        const offer = yield (_a = _this2.pcManager) === null || _a === void 0 ? void 0 : _a.publisher.createInitialOffer();
                        if (offer) offerProto = $c0722d30b1d17141$var$toProtoSessionDescription(offer.offer, offer.offerId);
                    }
                    if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) throw $c0722d30b1d17141$export$a3747c6e46c7a8eb.cancelled('Connection aborted');
                    if (!useV0Path && _this2.shouldFailOnV1Path) {
                        _this2.shouldFailOnV1Path = false;
                        throw $c0722d30b1d17141$export$a3747c6e46c7a8eb.serviceNotFound('Simulated v1 path failure', 'v0-rtc');
                    }
                    const joinResponse = yield _this2.client.join(url, token, opts, abortSignal, useV0Path, offerProto);
                    _this2._isClosed = false;
                    _this2.latestJoinResponse = joinResponse;
                    _this2.participantSid = (_b = joinResponse.participant) === null || _b === void 0 ? void 0 : _b.sid;
                    _this2.subscriberPrimary = joinResponse.subscriberPrimary;
                    if (!useV0Path && $c0722d30b1d17141$var$isCompressionStreamSupported()) (_c = _this2.pcManager) === null || _c === void 0 || _c.updateConfiguration(_this2.makeRTCConfiguration(joinResponse));
                    else {
                        if (!_this2.pcManager) yield _this2.configure(joinResponse, !useV0Path);
                        // create offer
                        if (!_this2.subscriberPrimary || joinResponse.fastPublish) _this2.negotiate().catch((err)=>{
                            _this2.log.error(err);
                        });
                    }
                    _this2.registerOnLineListener();
                    _this2.clientConfiguration = joinResponse.clientConfiguration;
                    _this2.emit($c0722d30b1d17141$export$c09e63b8572f869.SignalConnected, joinResponse);
                    let serverInfo = joinResponse.serverInfo;
                    if (!serverInfo) serverInfo = {
                        version: joinResponse.serverVersion,
                        region: joinResponse.serverRegion
                    };
                    _this2.log.info("connected to Livekit Server ".concat(Object.entries(serverInfo).map((_ref2)=>{
                        let [key, value] = _ref2;
                        return "".concat(key, ": ").concat(value);
                    }).join(', ')));
                    return {
                        joinResponse: joinResponse,
                        serverInfo: serverInfo
                    };
                } catch (e) {
                    if (e instanceof $c0722d30b1d17141$export$a3747c6e46c7a8eb) {
                        if (e.reason === $c0722d30b1d17141$export$61182a0b21436b65.ServerUnreachable) {
                            _this2.log.warn("Couldn't connect to server, attempt ".concat(_this2.joinAttempts, " of ").concat(_this2.maxJoinAttempts));
                            if (_this2.joinAttempts < _this2.maxJoinAttempts) return _this2.join(url, token, opts, abortSignal, useV0Path);
                        } else if (e.reason === $c0722d30b1d17141$export$61182a0b21436b65.ServiceNotFound) {
                            _this2.log.warn("Initial connection failed: ".concat(e.message, " \u2013 Retrying"));
                            if (_this2.pcManager) {
                                _this2.pcManager.onStateChange = undefined;
                                yield _this2.cleanupPeerConnections();
                            }
                            return _this2.join(url, token, opts, abortSignal, true);
                        }
                    }
                    throw e;
                }
            }();
        });
    }
    close() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            const unlock = yield this.closingLock.lock();
            if (this.isClosed) {
                unlock();
                return;
            }
            try {
                this._isClosed = true;
                this.joinAttempts = 0;
                this.emit($c0722d30b1d17141$export$c09e63b8572f869.Closing);
                this.removeAllListeners();
                this.deregisterOnLineListener();
                this.clearPendingReconnect();
                this.cleanupLossyDataStats();
                yield this.cleanupPeerConnections();
                yield this.cleanupClient();
            } finally{
                unlock();
            }
        });
    }
    cleanupPeerConnections() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            yield (_a = this.pcManager) === null || _a === void 0 ? void 0 : _a.close();
            this.pcManager = undefined;
            const dcCleanup = (dc)=>{
                if (!dc) return;
                dc.close();
                dc.onbufferedamountlow = null;
                dc.onclose = null;
                dc.onclosing = null;
                dc.onerror = null;
                dc.onmessage = null;
                dc.onopen = null;
            };
            dcCleanup(this.lossyDC);
            dcCleanup(this.lossyDCSub);
            dcCleanup(this.reliableDC);
            dcCleanup(this.reliableDCSub);
            dcCleanup(this.dataTrackDC);
            dcCleanup(this.dataTrackDCSub);
            this.lossyDC = undefined;
            this.lossyDCSub = undefined;
            this.reliableDC = undefined;
            this.reliableDCSub = undefined;
            this.dataTrackDC = undefined;
            this.dataTrackDCSub = undefined;
            this.reliableMessageBuffer = new $c0722d30b1d17141$var$DataPacketBuffer();
            this.reliableDataSequence = 1;
            this.reliableReceivedState.clear();
        });
    }
    cleanupLossyDataStats() {
        this.lossyDataStatByterate = 0;
        this.lossyDataStatCurrentBytes = 0;
        if (this.lossyDataStatInterval) {
            clearInterval(this.lossyDataStatInterval);
            this.lossyDataStatInterval = undefined;
        }
        this.lossyDataDropCount = 0;
    }
    cleanupClient() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            yield this.client.close();
            this.client.resetCallbacks();
            // Any in-flight addTrack requests are orphaned by the signal reconnect — the new session
            // won't deliver `trackPublishedResponse` for them, so reject the pending resolvers and
            // clear the map. Otherwise a subsequent `addTrack` call with the same client id (e.g. a
            // publish retry after a `NegotiationError`) throws `TrackInvalidError`.
            for (const cid of Object.keys(this.pendingTrackResolvers))this.pendingTrackResolvers[cid].reject();
            this.pendingTrackResolvers = {};
        });
    }
    addTrack(req) {
        if (this.pendingTrackResolvers[req.cid]) throw new $c0722d30b1d17141$export$4fbb9423b5747257('a track with the same ID has already been published');
        return new Promise((resolve, reject)=>{
            const publicationTimeout = setTimeout(()=>{
                delete this.pendingTrackResolvers[req.cid];
                reject($c0722d30b1d17141$export$a3747c6e46c7a8eb.timeout('publication of local track timed out, no response from server'));
            }, 10000);
            this.pendingTrackResolvers[req.cid] = {
                resolve: (info)=>{
                    clearTimeout(publicationTimeout);
                    resolve(info);
                },
                reject: ()=>{
                    clearTimeout(publicationTimeout);
                    reject(new Error('Cancelled publication by calling unpublish'));
                }
            };
            this.client.sendAddTrack(req);
        });
    }
    /**
   * Removes sender from PeerConnection, returning true if it was removed successfully
   * and a negotiation is necessary
   * @param sender
   * @returns
   */ removeTrack(sender) {
        if (sender.track && this.pendingTrackResolvers[sender.track.id]) {
            const { reject: reject } = this.pendingTrackResolvers[sender.track.id];
            if (reject) reject();
            delete this.pendingTrackResolvers[sender.track.id];
        }
        try {
            this.pcManager.removeTrack(sender);
            return true;
        } catch (e) {
            this.log.warn('failed to remove track', {
                error: e
            });
        }
        return false;
    }
    updateMuteStatus(trackSid, muted) {
        this.client.sendMuteTrack(trackSid, muted);
    }
    get dataSubscriberReadyState() {
        var _a;
        return (_a = this.reliableDCSub) === null || _a === void 0 ? void 0 : _a.readyState;
    }
    getConnectedServerAddress() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            return (_a = this.pcManager) === null || _a === void 0 ? void 0 : _a.getConnectedAddress();
        });
    }
    /* @internal */ setRegionStrategy(strategy) {
        this.regionStrategy = strategy;
    }
    configure(joinResponse, useSinglePeerConnection) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            // already configured
            if (this.pcManager && this.pcManager.currentState !== $c0722d30b1d17141$var$PCTransportState.NEW) return;
            if (!joinResponse) {
                const rtcConfig = this.makeRTCConfiguration();
                this.pcManager = new $c0722d30b1d17141$var$PCTransportManager('publisher-only', this.loggerOptions, rtcConfig);
            } else {
                this.participantSid = (_a = joinResponse.participant) === null || _a === void 0 ? void 0 : _a.sid;
                const rtcConfig = this.makeRTCConfiguration(joinResponse);
                this.pcManager = new $c0722d30b1d17141$var$PCTransportManager(useSinglePeerConnection ? 'publisher-only' : joinResponse.subscriberPrimary ? 'subscriber-primary' : 'publisher-primary', this.loggerOptions, rtcConfig);
            }
            this.emit($c0722d30b1d17141$export$c09e63b8572f869.TransportsCreated, this.pcManager.publisher, this.pcManager.subscriber);
            this.pcManager.onIceCandidate = (candidate, target)=>{
                this.client.sendIceCandidate(candidate, target);
            };
            this.pcManager.onPublisherOffer = (offer, offerId)=>{
                this.client.sendOffer(offer, offerId);
            };
            this.pcManager.onDataChannel = this.handleDataChannel;
            this.pcManager.onStateChange = (connectionState, publisherState, subscriberState)=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                    this.log.debug("primary PC state changed ".concat(connectionState));
                    if ([
                        'closed',
                        'disconnected',
                        'failed'
                    ].includes(publisherState)) // reset publisher connection promise
                    this.publisherConnectionPromise = undefined;
                    if (connectionState === $c0722d30b1d17141$var$PCTransportState.CONNECTED) {
                        const shouldEmit = this.pcState === $c0722d30b1d17141$var$PCState.New;
                        this.pcState = $c0722d30b1d17141$var$PCState.Connected;
                        if (shouldEmit) this.emit($c0722d30b1d17141$export$c09e63b8572f869.Connected, this.latestJoinResponse);
                    } else if (connectionState === $c0722d30b1d17141$var$PCTransportState.FAILED) // on Safari, PeerConnection will switch to 'disconnected' during renegotiation
                    {
                        if (this.pcState === $c0722d30b1d17141$var$PCState.Connected || this.pcState === $c0722d30b1d17141$var$PCState.Reconnecting) {
                            this.pcState = $c0722d30b1d17141$var$PCState.Disconnected;
                            this.handleDisconnect('peerconnection failed', subscriberState === 'failed' ? $c0722d30b1d17141$var$ReconnectReason.RR_SUBSCRIBER_FAILED : $c0722d30b1d17141$var$ReconnectReason.RR_PUBLISHER_FAILED);
                        }
                    }
                    // detect cases where both signal client and peer connection are severed and assume that user has lost network connection
                    const isSignalSevered = this.client.isDisconnected || this.client.currentState === $c0722d30b1d17141$var$SignalConnectionState.RECONNECTING;
                    const isPCSevered = [
                        $c0722d30b1d17141$var$PCTransportState.FAILED,
                        $c0722d30b1d17141$var$PCTransportState.CLOSING,
                        $c0722d30b1d17141$var$PCTransportState.CLOSED
                    ].includes(connectionState);
                    if (isSignalSevered && isPCSevered && !this._isClosed) this.emit($c0722d30b1d17141$export$c09e63b8572f869.Offline);
                });
            this.pcManager.onTrack = (ev)=>{
                // this fires after the underlying transceiver is stopped and potentially
                // peer connection closed, so do not bubble up if there are no streams
                if (ev.streams.length === 0) return;
                this.emit($c0722d30b1d17141$export$c09e63b8572f869.MediaTrackAdded, ev.track, ev.streams[0], ev.receiver);
            };
        });
    }
    setupSignalClientCallbacks() {
        // configure signaling client
        this.client.onAnswer = (sd, offerId, midToTrackId)=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                if (!this.pcManager) return;
                this.log.debug('received server answer', {
                    RTCSdpType: sd.type,
                    sdp: sd.sdp,
                    midToTrackId: midToTrackId
                });
                this.midToTrackId = midToTrackId;
                yield this.pcManager.setPublisherAnswer(sd, offerId);
            });
        // add candidate on trickle
        this.client.onTrickle = (candidate, target)=>{
            if (!this.pcManager) return;
            this.log.debug('got ICE candidate from peer', {
                candidate: candidate,
                target: target
            });
            this.pcManager.addIceCandidate(candidate, target);
        };
        // when server creates an offer for the client
        this.client.onOffer = (sd, offerId, midToTrackId)=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                this.latestRemoteOfferId = offerId;
                if (!this.pcManager) return;
                this.midToTrackId = midToTrackId;
                const answer = yield this.pcManager.createSubscriberAnswerFromOffer(sd, offerId);
                if (answer) this.client.sendAnswer(answer, offerId);
            });
        this.client.onLocalTrackPublished = (res)=>{
            var _a;
            this.log.debug('received trackPublishedResponse', {
                cid: res.cid,
                track: (_a = res.track) === null || _a === void 0 ? void 0 : _a.sid
            });
            if (!this.pendingTrackResolvers[res.cid]) {
                this.log.error("missing track resolver for ".concat(res.cid), {
                    cid: res.cid
                });
                return;
            }
            const { resolve: resolve } = this.pendingTrackResolvers[res.cid];
            delete this.pendingTrackResolvers[res.cid];
            resolve(res.track);
        };
        this.client.onLocalTrackUnpublished = (response)=>{
            this.emit($c0722d30b1d17141$export$c09e63b8572f869.LocalTrackUnpublished, response);
        };
        this.client.onLocalTrackSubscribed = (trackSid)=>{
            this.emit($c0722d30b1d17141$export$c09e63b8572f869.LocalTrackSubscribed, trackSid);
        };
        this.client.onTokenRefresh = (token)=>{
            this.token = token;
            this.emit($c0722d30b1d17141$export$c09e63b8572f869.TokenRefreshed, token);
        };
        this.client.onRemoteMuteChanged = (trackSid, muted)=>{
            this.emit($c0722d30b1d17141$export$c09e63b8572f869.RemoteMute, trackSid, muted);
        };
        this.client.onSubscribedQualityUpdate = (update)=>{
            this.emit($c0722d30b1d17141$export$c09e63b8572f869.SubscribedQualityUpdate, update);
        };
        this.client.onRoomMoved = (res)=>{
            var _a;
            this.participantSid = (_a = res.participant) === null || _a === void 0 ? void 0 : _a.sid;
            if (this.latestJoinResponse) this.latestJoinResponse.room = res.room;
            this.emit($c0722d30b1d17141$export$c09e63b8572f869.RoomMoved, res);
        };
        this.client.onMediaSectionsRequirement = (requirement)=>{
            this.addMediaSections(requirement.numAudios, requirement.numVideos);
            this.negotiate();
        };
        this.client.onPublishDataTrackResponse = (event)=>{
            this.emit($c0722d30b1d17141$export$c09e63b8572f869.PublishDataTrackResponse, event);
        };
        this.client.onUnPublishDataTrackResponse = (event)=>{
            this.emit($c0722d30b1d17141$export$c09e63b8572f869.UnPublishDataTrackResponse, event);
        };
        this.client.onDataTrackSubscriberHandles = (event)=>{
            this.emit($c0722d30b1d17141$export$c09e63b8572f869.DataTrackSubscriberHandles, event);
        };
        this.client.onClose = ()=>{
            this.handleDisconnect('signal', $c0722d30b1d17141$var$ReconnectReason.RR_SIGNAL_DISCONNECTED);
        };
        this.client.onLeave = (leave)=>{
            this.log.info("client leave request received (action=".concat(leave === null || leave === void 0 ? void 0 : leave.action, ")"), {
                reason: leave === null || leave === void 0 ? void 0 : leave.reason
            });
            if (leave.regions) {
                this.log.debug('updating regions');
                this.emit($c0722d30b1d17141$export$c09e63b8572f869.ServerRegionsReported, leave.regions);
            }
            switch(leave.action){
                case $c0722d30b1d17141$var$LeaveRequest_Action.DISCONNECT:
                    this.emit($c0722d30b1d17141$export$c09e63b8572f869.Disconnected, leave === null || leave === void 0 ? void 0 : leave.reason);
                    this.close();
                    break;
                case $c0722d30b1d17141$var$LeaveRequest_Action.RECONNECT:
                    this.fullReconnectOnNext = true;
                    // reconnect immediately instead of waiting for next attempt
                    this.handleDisconnect($c0722d30b1d17141$var$leaveReconnect);
                    break;
                case $c0722d30b1d17141$var$LeaveRequest_Action.RESUME:
                    // reconnect immediately instead of waiting for next attempt
                    this.handleDisconnect($c0722d30b1d17141$var$leaveReconnect);
            }
        };
    }
    makeRTCConfiguration(serverResponse) {
        var _a;
        const rtcConfig = Object.assign({}, this.rtcConfig);
        if ((_a = this.signalOpts) === null || _a === void 0 ? void 0 : _a.e2eeEnabled) {
            this.log.debug('E2EE - setting up transports with insertable streams');
            //  this makes sure that no data is sent before the transforms are ready
            // @ts-ignore
            rtcConfig.encodedInsertableStreams = true;
        }
        // @ts-ignore
        rtcConfig.sdpSemantics = 'unified-plan';
        // @ts-ignore
        rtcConfig.continualGatheringPolicy = 'gather_continually';
        if (!serverResponse) return rtcConfig;
        // update ICE servers before creating PeerConnection
        if (serverResponse.iceServers && !rtcConfig.iceServers) {
            const rtcIceServers = [];
            serverResponse.iceServers.forEach((iceServer)=>{
                const rtcIceServer = {
                    urls: iceServer.urls
                };
                if (iceServer.username) rtcIceServer.username = iceServer.username;
                if (iceServer.credential) rtcIceServer.credential = iceServer.credential;
                rtcIceServers.push(rtcIceServer);
            });
            rtcConfig.iceServers = rtcIceServers;
        }
        if (serverResponse.clientConfiguration && serverResponse.clientConfiguration.forceRelay === $c0722d30b1d17141$var$ClientConfigSetting.ENABLED) rtcConfig.iceTransportPolicy = 'relay';
        return rtcConfig;
    }
    addMediaSections(numAudios, numVideos) {
        var _a, _b;
        const transceiverInit = {
            direction: 'recvonly'
        };
        for(let i = 0; i < numAudios; i++)(_a = this.pcManager) === null || _a === void 0 || _a.addPublisherTransceiverOfKind('audio', transceiverInit);
        for(let i = 0; i < numVideos; i++)(_b = this.pcManager) === null || _b === void 0 || _b.addPublisherTransceiverOfKind('video', transceiverInit);
    }
    createDataChannels() {
        if (!this.pcManager) return;
        // clear old data channel callbacks if recreate
        if (this.lossyDC) {
            this.lossyDC.onmessage = null;
            this.lossyDC.onerror = null;
        }
        if (this.reliableDC) {
            this.reliableDC.onmessage = null;
            this.reliableDC.onerror = null;
        }
        if (this.dataTrackDC) {
            this.dataTrackDC.onmessage = null;
            this.dataTrackDC.onerror = null;
        }
        // create data channels
        this.lossyDC = this.pcManager.createPublisherDataChannel($c0722d30b1d17141$var$lossyDataChannel, {
            ordered: false,
            maxRetransmits: 0
        });
        this.reliableDC = this.pcManager.createPublisherDataChannel($c0722d30b1d17141$var$reliableDataChannel, {
            ordered: true
        });
        this.dataTrackDC = this.pcManager.createPublisherDataChannel($c0722d30b1d17141$var$dataTrackDataChannel, {
            ordered: false,
            maxRetransmits: 0
        });
        // also handle messages over the pub channel, for backwards compatibility
        this.lossyDC.onmessage = this.handleDataMessage;
        this.reliableDC.onmessage = this.handleDataMessage;
        this.dataTrackDC.onmessage = this.handleDataTrackMessage;
        // handle datachannel errors
        this.lossyDC.onerror = this.handleDataError;
        this.reliableDC.onerror = this.handleDataError;
        this.dataTrackDC.onerror = this.handleDataError;
        // set up dc buffer threshold, set to 64kB (otherwise 0 by default)
        this.lossyDC.bufferedAmountLowThreshold = 65535;
        this.reliableDC.bufferedAmountLowThreshold = 65535;
        this.dataTrackDC.bufferedAmountLowThreshold = 65535;
        // handle buffer amount low events
        this.lossyDC.onbufferedamountlow = ()=>this.handleBufferedAmountLow($c0722d30b1d17141$var$DataChannelKind.LOSSY);
        this.reliableDC.onbufferedamountlow = ()=>this.handleBufferedAmountLow($c0722d30b1d17141$var$DataChannelKind.RELIABLE);
        this.dataTrackDC.onbufferedamountlow = ()=>this.handleBufferedAmountLow($c0722d30b1d17141$var$DataChannelKind.DATA_TRACK_LOSSY);
        this.cleanupLossyDataStats();
        this.lossyDataStatInterval = setInterval(()=>{
            this.lossyDataStatByterate = this.lossyDataStatCurrentBytes;
            this.lossyDataStatCurrentBytes = 0;
            const dc = this.dataChannelForKind($c0722d30b1d17141$var$DataChannelKind.LOSSY);
            if (dc) {
                // control buffered latency to ~100ms
                const threshold = this.lossyDataStatByterate / 10;
                dc.bufferedAmountLowThreshold = Math.min(Math.max(threshold, $c0722d30b1d17141$var$lossyDataChannelBufferThresholdMin), $c0722d30b1d17141$var$lossyDataChannelBufferThresholdMax);
            }
        }, 1000);
    }
    createSender(track, opts, encodings) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            if ($c0722d30b1d17141$var$supportsTransceiver()) {
                const sender = yield this.createTransceiverRTCRtpSender(track, opts, encodings);
                return sender;
            }
            if ($c0722d30b1d17141$var$supportsAddTrack()) {
                this.log.warn('using add-track fallback');
                const sender = yield this.createRTCRtpSender(track.mediaStreamTrack);
                return sender;
            }
            throw new $c0722d30b1d17141$export$1f388e244efbf70b('Required webRTC APIs not supported on this device');
        });
    }
    createSimulcastSender(track, simulcastTrack, opts, encodings) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            // store RTCRtpSender
            if ($c0722d30b1d17141$var$supportsTransceiver()) return this.createSimulcastTransceiverSender(track, simulcastTrack, opts, encodings);
            if ($c0722d30b1d17141$var$supportsAddTrack()) {
                this.log.debug('using add-track fallback');
                return this.createRTCRtpSender(track.mediaStreamTrack);
            }
            throw new $c0722d30b1d17141$export$1f388e244efbf70b('Cannot stream on this device');
        });
    }
    createTransceiverRTCRtpSender(track, opts, encodings) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.pcManager) throw new $c0722d30b1d17141$export$1f388e244efbf70b('publisher is closed');
            const streams = [];
            if (track.mediaStream) streams.push(track.mediaStream);
            if ($c0722d30b1d17141$export$372680e3a49e7e3e(track)) track.codec = opts.videoCodec;
            const transceiverInit = {
                direction: 'sendonly',
                streams: streams
            };
            if (encodings) transceiverInit.sendEncodings = encodings;
            // addTransceiver for react-native is async. web is synchronous, but await won't effect it.
            const transceiver = yield this.pcManager.addPublisherTransceiver(track.mediaStreamTrack, transceiverInit);
            return transceiver.sender;
        });
    }
    createSimulcastTransceiverSender(track, simulcastTrack, opts, encodings) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.pcManager) throw new $c0722d30b1d17141$export$1f388e244efbf70b('publisher is closed');
            const transceiverInit = {
                direction: 'sendonly'
            };
            if (encodings) transceiverInit.sendEncodings = encodings;
            // addTransceiver for react-native is async. web is synchronous, but await won't effect it.
            const transceiver = yield this.pcManager.addPublisherTransceiver(simulcastTrack.mediaStreamTrack, transceiverInit);
            if (!opts.videoCodec) return;
            track.setSimulcastTrackSender(opts.videoCodec, transceiver.sender);
            return transceiver.sender;
        });
    }
    createRTCRtpSender(track) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.pcManager) throw new $c0722d30b1d17141$export$1f388e244efbf70b('publisher is closed');
            return this.pcManager.addPublisherTrack(track);
        });
    }
    attemptReconnect(reason) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c;
            if (this._isClosed) return;
            // guard for attempting reconnection multiple times while one attempt is still not finished
            if (this.attemptingReconnect) {
                this.log.warn('already attempting reconnect, returning early');
                return;
            }
            if (((_a = this.clientConfiguration) === null || _a === void 0 ? void 0 : _a.resumeConnection) === $c0722d30b1d17141$var$ClientConfigSetting.DISABLED || // signaling state could change to closed due to hardware sleep
            // those connections cannot be resumed
            ((_c = (_b = this.pcManager) === null || _b === void 0 ? void 0 : _b.currentState) !== null && _c !== void 0 ? _c : $c0722d30b1d17141$var$PCTransportState.NEW) === $c0722d30b1d17141$var$PCTransportState.NEW) this.fullReconnectOnNext = true;
            try {
                this.attemptingReconnect = true;
                if (this.fullReconnectOnNext) yield this.restartConnection();
                else yield this.resumeConnection(reason);
                this.clearPendingReconnect();
                this.fullReconnectOnNext = false;
            } catch (e) {
                this.reconnectAttempts += 1;
                let recoverable = true;
                if (e instanceof $c0722d30b1d17141$export$1f388e244efbf70b) {
                    this.log.debug('received unrecoverable error', {
                        error: e
                    });
                    // unrecoverable
                    recoverable = false;
                } else if (!(e instanceof $c0722d30b1d17141$export$b96a7e5c35734611)) // cannot resume
                this.fullReconnectOnNext = true;
                if (recoverable) this.handleDisconnect('reconnect', $c0722d30b1d17141$var$ReconnectReason.RR_UNKNOWN);
                else {
                    this.log.info("could not recover connection after ".concat(this.reconnectAttempts, " attempts, ").concat(Date.now() - this.reconnectStart, "ms. giving up"));
                    this.emit($c0722d30b1d17141$export$c09e63b8572f869.Disconnected);
                    yield this.close();
                }
            } finally{
                this.attemptingReconnect = false;
            }
        });
    }
    getNextRetryDelay(context) {
        try {
            return this.reconnectPolicy.nextRetryDelayInMs(context);
        } catch (e) {
            this.log.warn('encountered error in reconnect policy', {
                error: e
            });
        }
        // error in user code with provided reconnect policy, stop reconnecting
        return null;
    }
    restartConnection(regionUrl) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c;
            try {
                if (!this.url || !this.token) // permanent failure, don't attempt reconnection
                throw new $c0722d30b1d17141$export$1f388e244efbf70b('could not reconnect, url or token not saved');
                this.log.info("reconnecting, attempt: ".concat(this.reconnectAttempts));
                this.emit($c0722d30b1d17141$export$c09e63b8572f869.Restarting);
                if (!this.client.isDisconnected) yield this.client.sendLeave();
                yield this.cleanupPeerConnections();
                yield this.cleanupClient();
                let joinResponse;
                try {
                    if (!this.signalOpts) {
                        this.log.warn('attempted connection restart, without signal options present');
                        throw new $c0722d30b1d17141$export$b96a7e5c35734611();
                    }
                    // in case a regionUrl is passed, the region URL takes precedence
                    joinResponse = (yield this.join(regionUrl !== null && regionUrl !== void 0 ? regionUrl : this.url, this.token, this.signalOpts, undefined, !this.options.singlePeerConnection)).joinResponse;
                } catch (e) {
                    if (e instanceof $c0722d30b1d17141$export$a3747c6e46c7a8eb && e.reason === $c0722d30b1d17141$export$61182a0b21436b65.NotAllowed) throw new $c0722d30b1d17141$export$1f388e244efbf70b('could not reconnect, token might be expired');
                    throw new $c0722d30b1d17141$export$b96a7e5c35734611();
                }
                if (this.shouldFailNext) {
                    this.shouldFailNext = false;
                    throw new Error('simulated failure');
                }
                this.client.setReconnected();
                this.emit($c0722d30b1d17141$export$c09e63b8572f869.SignalRestarted, joinResponse);
                yield this.waitForPCReconnected();
                // re-check signal connection state before setting engine as resumed
                if (this.client.currentState !== $c0722d30b1d17141$var$SignalConnectionState.CONNECTED) throw new $c0722d30b1d17141$export$b96a7e5c35734611('Signal connection got severed during reconnect');
                (_a = this.regionStrategy) === null || _a === void 0 || _a.resetAttempts();
                // reconnect success
                this.emit($c0722d30b1d17141$export$c09e63b8572f869.Restarted);
            } catch (error) {
                const nextRegionUrl = yield (_b = this.regionStrategy) === null || _b === void 0 ? void 0 : _b.getNextUrl();
                if (nextRegionUrl) {
                    yield this.restartConnection(nextRegionUrl);
                    return;
                } else {
                    // no more regions to try (or we're not on cloud)
                    (_c = this.regionStrategy) === null || _c === void 0 || _c.resetAttempts();
                    throw error;
                }
            }
        });
    }
    resumeConnection(reason) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            if (!this.url || !this.token) // permanent failure, don't attempt reconnection
            throw new $c0722d30b1d17141$export$1f388e244efbf70b('could not reconnect, url or token not saved');
            // trigger publisher reconnect
            if (!this.pcManager) throw new $c0722d30b1d17141$export$1f388e244efbf70b('publisher and subscriber connections unset');
            this.log.info("resuming signal connection, attempt ".concat(this.reconnectAttempts));
            this.emit($c0722d30b1d17141$export$c09e63b8572f869.Resuming);
            let res;
            try {
                this.setupSignalClientCallbacks();
                res = yield this.client.reconnect(this.url, this.token, this.participantSid, reason);
            } catch (error) {
                let message = '';
                if (error instanceof Error) {
                    message = error.message;
                    this.log.error(error.message, {
                        error: error
                    });
                }
                if (error instanceof $c0722d30b1d17141$export$a3747c6e46c7a8eb && error.reason === $c0722d30b1d17141$export$61182a0b21436b65.NotAllowed) throw new $c0722d30b1d17141$export$1f388e244efbf70b('could not reconnect, token might be expired');
                if (error instanceof $c0722d30b1d17141$export$a3747c6e46c7a8eb && error.reason === $c0722d30b1d17141$export$61182a0b21436b65.LeaveRequest) throw error;
                throw new $c0722d30b1d17141$export$b96a7e5c35734611(message);
            }
            this.emit($c0722d30b1d17141$export$c09e63b8572f869.SignalResumed);
            if (res) {
                const rtcConfig = this.makeRTCConfiguration(res);
                this.pcManager.updateConfiguration(rtcConfig);
                if (this.latestJoinResponse) this.latestJoinResponse.serverInfo = res.serverInfo;
            } else this.log.warn('Did not receive reconnect response');
            if (this.shouldFailNext) {
                this.shouldFailNext = false;
                throw new Error('simulated failure');
            }
            yield this.pcManager.triggerIceRestart();
            yield this.waitForPCReconnected();
            // re-check signal connection state before setting engine as resumed
            if (this.client.currentState !== $c0722d30b1d17141$var$SignalConnectionState.CONNECTED) throw new $c0722d30b1d17141$export$b96a7e5c35734611('Signal connection got severed during reconnect');
            this.client.setReconnected();
            // recreate publish datachannel if it's id is null
            // (for safari https://bugs.webkit.org/show_bug.cgi?id=184688)
            if (((_a = this.reliableDC) === null || _a === void 0 ? void 0 : _a.readyState) === 'open' && this.reliableDC.id === null) this.createDataChannels();
            if (res === null || res === void 0 ? void 0 : res.lastMessageSeq) this.resendReliableMessagesForResume(res.lastMessageSeq);
            // resume success
            this.emit($c0722d30b1d17141$export$c09e63b8572f869.Resumed);
        });
    }
    waitForPCInitialConnection(timeout, abortController) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.pcManager) throw new $c0722d30b1d17141$export$1f388e244efbf70b('PC manager is closed');
            yield this.pcManager.ensurePCTransportConnection(abortController, timeout);
        });
    }
    waitForPCReconnected() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            this.pcState = $c0722d30b1d17141$var$PCState.Reconnecting;
            this.log.debug('waiting for peer connection to reconnect');
            try {
                yield $c0722d30b1d17141$var$sleep($c0722d30b1d17141$var$minReconnectWait); // FIXME setTimeout again not ideal for a connection critical path
                if (!this.pcManager) throw new $c0722d30b1d17141$export$1f388e244efbf70b('PC manager is closed');
                yield this.pcManager.ensurePCTransportConnection(undefined, this.peerConnectionTimeout);
                this.pcState = $c0722d30b1d17141$var$PCState.Connected;
            } catch (e) {
                // TODO do we need a `failed` state here for the PC?
                this.pcState = $c0722d30b1d17141$var$PCState.Disconnected;
                throw $c0722d30b1d17141$export$a3747c6e46c7a8eb.internal("could not establish PC connection, ".concat(e.message));
            }
        });
    }
    /** @internal */ publishRpcResponse(destinationIdentity, requestId, payload, error) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            const packet = new $c0722d30b1d17141$var$DataPacket({
                destinationIdentities: [
                    destinationIdentity
                ],
                kind: $c0722d30b1d17141$export$629a0ea4ceb9e4a6.RELIABLE,
                value: {
                    case: 'rpcResponse',
                    value: new $c0722d30b1d17141$var$RpcResponse({
                        requestId: requestId,
                        value: error ? {
                            case: 'error',
                            value: error.toProto()
                        } : {
                            case: 'payload',
                            value: payload !== null && payload !== void 0 ? payload : ''
                        }
                    })
                }
            });
            yield this.sendDataPacket(packet, $c0722d30b1d17141$var$DataChannelKind.RELIABLE);
        });
    }
    /** @internal */ publishRpcAck(destinationIdentity, requestId) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            const packet = new $c0722d30b1d17141$var$DataPacket({
                destinationIdentities: [
                    destinationIdentity
                ],
                kind: $c0722d30b1d17141$export$629a0ea4ceb9e4a6.RELIABLE,
                value: {
                    case: 'rpcAck',
                    value: new $c0722d30b1d17141$var$RpcAck({
                        requestId: requestId
                    })
                }
            });
            yield this.sendDataPacket(packet, $c0722d30b1d17141$var$DataChannelKind.RELIABLE);
        });
    }
    /* @internal */ sendDataPacket(packet, kind) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            // make sure we do have a data connection
            yield this.ensurePublisherConnected(kind);
            if (this.e2eeManager && this.e2eeManager.isDataChannelEncryptionEnabled) {
                const encryptablePacket = $c0722d30b1d17141$export$d13ff619c22cbf06(packet);
                if (encryptablePacket) {
                    const encryptedData = yield this.e2eeManager.encryptData(encryptablePacket.toBinary());
                    packet.value = {
                        case: 'encryptedPacket',
                        value: new $c0722d30b1d17141$var$EncryptedPacket({
                            encryptedValue: encryptedData.payload,
                            iv: encryptedData.iv,
                            keyIndex: encryptedData.keyIndex
                        })
                    };
                }
            }
            if (kind === $c0722d30b1d17141$var$DataChannelKind.RELIABLE) {
                packet.sequence = this.reliableDataSequence;
                this.reliableDataSequence += 1;
            }
            const msg = packet.toBinary();
            switch(kind){
                case $c0722d30b1d17141$var$DataChannelKind.LOSSY:
                case $c0722d30b1d17141$var$DataChannelKind.DATA_TRACK_LOSSY:
                    return this.sendLossyBytes(msg, kind);
                case $c0722d30b1d17141$var$DataChannelKind.RELIABLE:
                    const dc = this.dataChannelForKind(kind);
                    if (dc) {
                        yield this.waitForBufferStatusLow(kind);
                        this.reliableMessageBuffer.push({
                            data: msg,
                            sequence: packet.sequence
                        });
                        if (this.attemptingReconnect) return;
                        dc.send(msg);
                    }
                    this.updateAndEmitDCBufferStatus(kind);
                    break;
            }
        });
    }
    /* @internal */ sendLossyBytes(bytes_1, kind_1) {
        return $c0722d30b1d17141$var$__awaiter(this, arguments, void 0, function(bytes, kind) {
            var _this3 = this;
            let bufferStatusLowBehavior = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'drop';
            return function*() {
                // make sure we do have a data connection
                yield _this3.ensurePublisherConnected(kind);
                const dc = _this3.dataChannelForKind(kind);
                if (dc) {
                    if (!_this3.isBufferStatusLow(kind)) // Depending on the exact circumstance that data is being sent, either drop or wait for the
                    // buffer status to not be low before continuing.
                    switch(bufferStatusLowBehavior){
                        case 'wait':
                            yield _this3.waitForBufferStatusLow(kind);
                            break;
                        case 'drop':
                            // this.log.warn(`dropping lossy data channel message`, this.logContext);
                            // Drop messages to reduce latency
                            _this3.lossyDataDropCount += 1;
                            if (_this3.lossyDataDropCount % 100 === 0) _this3.log.warn("dropping lossy data channel messages, total dropped: ".concat(_this3.lossyDataDropCount));
                            return;
                    }
                    _this3.lossyDataStatCurrentBytes += bytes.byteLength;
                    if (_this3.attemptingReconnect) return;
                    dc.send(bytes);
                }
                _this3.updateAndEmitDCBufferStatus(kind);
            }();
        });
    }
    resendReliableMessagesForResume(lastMessageSeq) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            yield this.ensurePublisherConnected($c0722d30b1d17141$var$DataChannelKind.RELIABLE);
            const dc = this.dataChannelForKind($c0722d30b1d17141$var$DataChannelKind.RELIABLE);
            if (dc) {
                this.reliableMessageBuffer.popToSequence(lastMessageSeq);
                this.reliableMessageBuffer.getAll().forEach((msg)=>{
                    dc.send(msg.data);
                });
            }
            this.updateAndEmitDCBufferStatus($c0722d30b1d17141$var$DataChannelKind.RELIABLE);
        });
    }
    waitForBufferStatusLow(kind) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            return new $c0722d30b1d17141$var$TypedPromise((resolve, reject)=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                    if (this.isClosed) reject(new $c0722d30b1d17141$export$1f388e244efbf70b('engine closed'));
                    if (this.isBufferStatusLow(kind)) resolve();
                    else {
                        const dc = this.dataChannelForKind(kind);
                        if (!dc) {
                            reject(new $c0722d30b1d17141$export$1f388e244efbf70b("DataChannel not found, kind: ".concat(kind)));
                            return;
                        }
                        this.bufferStatusLowClosingFuture.promise.catch((e)=>reject(e));
                        dc.addEventListener('bufferedamountlow', ()=>resolve(), {
                            once: true
                        });
                    }
                }));
        });
    }
    /**
   * @internal
   */ ensureDataTransportConnected(kind_1) {
        return $c0722d30b1d17141$var$__awaiter(this, arguments, void 0, function(kind) {
            var _this4 = this;
            let subscriber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.subscriberPrimary;
            return function*() {
                var _a;
                if (!_this4.pcManager) throw new $c0722d30b1d17141$export$1f388e244efbf70b('PC manager is closed');
                const transport = subscriber ? _this4.pcManager.subscriber : _this4.pcManager.publisher;
                const transportName = subscriber ? 'Subscriber' : 'Publisher';
                if (!transport) throw $c0722d30b1d17141$export$a3747c6e46c7a8eb.internal("".concat(transportName, " connection not set"));
                let needNegotiation = false;
                if (!subscriber && !_this4.dataChannelForKind(kind, subscriber)) {
                    _this4.createDataChannels();
                    needNegotiation = true;
                }
                if (!needNegotiation && !subscriber && !_this4.pcManager.publisher.isICEConnected && _this4.pcManager.publisher.getICEConnectionState() !== 'checking') needNegotiation = true;
                if (needNegotiation) // start negotiation
                _this4.negotiate().catch((err)=>{
                    _this4.log.error(err);
                });
                const targetChannel = _this4.dataChannelForKind(kind, subscriber);
                if ((targetChannel === null || targetChannel === void 0 ? void 0 : targetChannel.readyState) === 'open') return;
                // wait until ICE connected
                const endTime = new Date().getTime() + _this4.peerConnectionTimeout;
                while(new Date().getTime() < endTime){
                    if (transport.isICEConnected && ((_a = _this4.dataChannelForKind(kind, subscriber)) === null || _a === void 0 ? void 0 : _a.readyState) === 'open') return;
                    yield $c0722d30b1d17141$var$sleep(50);
                }
                throw $c0722d30b1d17141$export$a3747c6e46c7a8eb.internal("could not establish ".concat(transportName, " connection, state: ").concat(transport.getICEConnectionState()));
            }();
        });
    }
    ensurePublisherConnected(kind) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.publisherConnectionPromise) this.publisherConnectionPromise = this.ensureDataTransportConnected(kind, false);
            yield this.publisherConnectionPromise;
        });
    }
    /* @internal */ verifyTransport() {
        if (!this.pcManager) return false;
        const allowedConnectionStates = [
            $c0722d30b1d17141$var$PCTransportState.CONNECTING,
            $c0722d30b1d17141$var$PCTransportState.CONNECTED
        ];
        if (!allowedConnectionStates.includes(this.pcManager.currentState)) return false;
        // ensure signal is connected
        if (!this.client.ws || this.client.ws.readyState === WebSocket.CLOSED) return false;
        return true;
    }
    /** @internal */ negotiate() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            // observe signal state
            return new $c0722d30b1d17141$var$TypedPromise((resolve, reject)=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                    if (!this.pcManager) {
                        reject(new $c0722d30b1d17141$export$18c2792bacf23e39('PC manager is closed'));
                        return;
                    }
                    this.pcManager.requirePublisher();
                    // don't negotiate without any transceivers or data channel, it will generate sdp without ice frag then negotiate failed
                    if (this.pcManager.publisher.getTransceivers().length == 0 && !this.lossyDC && !this.reliableDC && !this.dataTrackDC) this.createDataChannels();
                    const abortController = new AbortController();
                    const handleClosed = ()=>{
                        abortController.abort();
                        this.log.debug('engine disconnected while negotiation was ongoing');
                        resolve();
                        return;
                    };
                    if (this.isClosed) reject(new $c0722d30b1d17141$export$18c2792bacf23e39('cannot negotiate on closed engine'));
                    this.on($c0722d30b1d17141$export$c09e63b8572f869.Closing, handleClosed);
                    this.on($c0722d30b1d17141$export$c09e63b8572f869.Restarting, handleClosed);
                    this.pcManager.publisher.once($c0722d30b1d17141$var$PCEvents.RTPVideoPayloadTypes, (rtpTypes)=>{
                        const rtpMap = new Map();
                        rtpTypes.forEach((rtp)=>{
                            const codec = rtp.codec.toLowerCase();
                            if ($c0722d30b1d17141$export$601d10c6a66cb34c(codec)) rtpMap.set(rtp.payload, codec);
                        });
                        this.emit($c0722d30b1d17141$export$c09e63b8572f869.RTPVideoMapUpdate, rtpMap);
                    });
                    try {
                        yield this.pcManager.negotiate(abortController);
                        resolve();
                    } catch (e) {
                        if (abortController.signal.aborted) {
                            // negotiation was aborted due to engine close or restart, resolve
                            // cleanly to avoid triggering a cascading reconnect loop
                            resolve();
                            return;
                        }
                        if (e instanceof $c0722d30b1d17141$export$18c2792bacf23e39) this.fullReconnectOnNext = true;
                        this.handleDisconnect('negotiation', $c0722d30b1d17141$var$ReconnectReason.RR_UNKNOWN);
                        if (e instanceof Error) reject(e);
                        else reject(new Error(String(e)));
                    } finally{
                        this.off($c0722d30b1d17141$export$c09e63b8572f869.Closing, handleClosed);
                        this.off($c0722d30b1d17141$export$c09e63b8572f869.Restarting, handleClosed);
                    }
                }));
        });
    }
    dataChannelForKind(kind, sub) {
        switch(kind){
            case $c0722d30b1d17141$var$DataChannelKind.RELIABLE:
                if (!sub) return this.reliableDC;
                else return this.reliableDCSub;
            case $c0722d30b1d17141$var$DataChannelKind.LOSSY:
                if (!sub) return this.lossyDC;
                else return this.lossyDCSub;
            case $c0722d30b1d17141$var$DataChannelKind.DATA_TRACK_LOSSY:
                if (!sub) return this.dataTrackDC;
                else return this.dataTrackDCSub;
        }
    }
    /** @internal */ sendSyncState(remoteTracks, localTracks, localDataTrackInfos) {
        var _a, _b, _c, _d;
        if (!this.pcManager) {
            this.log.warn('sync state cannot be sent without peer connection setup');
            return;
        }
        const previousPublisherOffer = this.pcManager.publisher.getLocalDescription();
        const previousPublisherAnswer = this.pcManager.publisher.getRemoteDescription();
        const previousSubscriberOffer = (_a = this.pcManager.subscriber) === null || _a === void 0 ? void 0 : _a.getRemoteDescription();
        const previousSubscriberAnswer = (_b = this.pcManager.subscriber) === null || _b === void 0 ? void 0 : _b.getLocalDescription();
        /* 1. autosubscribe on, so subscribed tracks = all tracks - unsub tracks,
          in this case, we send unsub tracks, so server add all tracks to this
          subscribe pc and unsub special tracks from it.
       2. autosubscribe off, we send subscribed tracks.
    */ const autoSubscribe = (_d = (_c = this.signalOpts) === null || _c === void 0 ? void 0 : _c.autoSubscribe) !== null && _d !== void 0 ? _d : true;
        const trackSids = new Array();
        const trackSidsDisabled = new Array();
        remoteTracks.forEach((track)=>{
            if (track.isDesired !== autoSubscribe) trackSids.push(track.trackSid);
            if (!track.isEnabled) trackSidsDisabled.push(track.trackSid);
        });
        this.client.sendSyncState(new $c0722d30b1d17141$var$SyncState({
            answer: this.pcManager.mode === 'publisher-only' ? previousPublisherAnswer ? $c0722d30b1d17141$var$toProtoSessionDescription({
                sdp: previousPublisherAnswer.sdp,
                type: previousPublisherAnswer.type
            }) : undefined : previousSubscriberAnswer ? $c0722d30b1d17141$var$toProtoSessionDescription({
                sdp: previousSubscriberAnswer.sdp,
                type: previousSubscriberAnswer.type
            }) : undefined,
            offer: this.pcManager.mode === 'publisher-only' ? previousPublisherOffer ? $c0722d30b1d17141$var$toProtoSessionDescription({
                sdp: previousPublisherOffer.sdp,
                type: previousPublisherOffer.type
            }) : undefined : previousSubscriberOffer ? $c0722d30b1d17141$var$toProtoSessionDescription({
                sdp: previousSubscriberOffer.sdp,
                type: previousSubscriberOffer.type
            }) : undefined,
            subscription: new $c0722d30b1d17141$var$UpdateSubscription({
                trackSids: trackSids,
                subscribe: !autoSubscribe,
                participantTracks: []
            }),
            publishTracks: $c0722d30b1d17141$var$getTrackPublicationInfo(localTracks),
            dataChannels: this.dataChannelsInfo(),
            trackSidsDisabled: trackSidsDisabled,
            datachannelReceiveStates: this.reliableReceivedState.map((seq, sid)=>{
                return new $c0722d30b1d17141$var$DataChannelReceiveState({
                    publisherSid: sid,
                    lastSeq: seq
                });
            }),
            publishDataTracks: localDataTrackInfos.map((info)=>{
                return new $c0722d30b1d17141$var$PublishDataTrackResponse({
                    info: $c0722d30b1d17141$var$DataTrackInfo.toProtobuf(info)
                });
            })
        }));
    }
    /* @internal */ failNext() {
        // debugging method to fail the next reconnect/resume attempt
        this.shouldFailNext = true;
    }
    /* @internal */ failNextV1Path() {
        // debugging method to fail the next connection attempt for /rtc/v1 to trigger the fallback version
        this.shouldFailOnV1Path = true;
    }
    dataChannelsInfo() {
        const infos = [];
        const getInfo = (dc, target)=>{
            if ((dc === null || dc === void 0 ? void 0 : dc.id) !== undefined && dc.id !== null) infos.push(new $c0722d30b1d17141$var$DataChannelInfo({
                label: dc.label,
                id: dc.id,
                target: target
            }));
        };
        getInfo(this.dataChannelForKind($c0722d30b1d17141$var$DataChannelKind.LOSSY), $c0722d30b1d17141$var$SignalTarget.PUBLISHER);
        getInfo(this.dataChannelForKind($c0722d30b1d17141$var$DataChannelKind.RELIABLE), $c0722d30b1d17141$var$SignalTarget.PUBLISHER);
        getInfo(this.dataChannelForKind($c0722d30b1d17141$var$DataChannelKind.LOSSY, true), $c0722d30b1d17141$var$SignalTarget.SUBSCRIBER);
        getInfo(this.dataChannelForKind($c0722d30b1d17141$var$DataChannelKind.RELIABLE, true), $c0722d30b1d17141$var$SignalTarget.SUBSCRIBER);
        return infos;
    }
    clearReconnectTimeout() {
        if (this.reconnectTimeout) $c0722d30b1d17141$export$22e737276454df96.clearTimeout(this.reconnectTimeout);
    }
    clearPendingReconnect() {
        this.clearReconnectTimeout();
        this.reconnectAttempts = 0;
    }
    registerOnLineListener() {
        if ($c0722d30b1d17141$var$isWeb()) {
            window.addEventListener('online', this.handleBrowserOnLine);
            window.addEventListener('offline', this.handleBrowserOffline);
        }
    }
    deregisterOnLineListener() {
        if ($c0722d30b1d17141$var$isWeb()) {
            window.removeEventListener('online', this.handleBrowserOnLine);
            window.removeEventListener('offline', this.handleBrowserOffline);
        }
    }
    getTrackIdForReceiver(receiver) {
        var _a;
        const mid = (_a = this.pcManager) === null || _a === void 0 ? void 0 : _a.getMidForReceiver(receiver);
        if (mid) {
            const match = Object.entries(this.midToTrackId).find((_ref3)=>{
                let [key] = _ref3;
                return key === mid;
            });
            if (match) return match[1];
        }
    }
}
function $c0722d30b1d17141$var$applyUserDataCompat(newObj, oldObj) {
    const participantIdentity = newObj.participantIdentity ? newObj.participantIdentity : oldObj.participantIdentity;
    newObj.participantIdentity = participantIdentity;
    oldObj.participantIdentity = participantIdentity;
    const destinationIdentities = newObj.destinationIdentities.length !== 0 ? newObj.destinationIdentities : oldObj.destinationIdentities;
    newObj.destinationIdentities = destinationIdentities;
    oldObj.destinationIdentities = destinationIdentities;
}
const $c0722d30b1d17141$var$DEFAULT_MAX_AGE_MS = 5000;
const $c0722d30b1d17141$var$STOP_REFETCH_DELAY_MS = 30000;
class $c0722d30b1d17141$var$RegionUrlProvider {
    static fetchRegionSettings(serverUrl, token, signal) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            const unlock = yield $c0722d30b1d17141$var$RegionUrlProvider.fetchLock.lock();
            try {
                const regionSettingsResponse = yield fetch("".concat($c0722d30b1d17141$var$getCloudConfigUrl(serverUrl), "/regions"), {
                    headers: {
                        authorization: "Bearer ".concat(token)
                    },
                    signal: signal
                });
                if (regionSettingsResponse.ok) {
                    const maxAge = $c0722d30b1d17141$var$extractMaxAgeFromRequestHeaders(regionSettingsResponse.headers);
                    const maxAgeInMs = maxAge ? maxAge * 1000 : $c0722d30b1d17141$var$DEFAULT_MAX_AGE_MS;
                    const regionSettings = yield regionSettingsResponse.json();
                    return {
                        regionSettings: regionSettings,
                        updatedAtInMs: Date.now(),
                        maxAgeInMs: maxAgeInMs
                    };
                } else {
                    if (regionSettingsResponse.status === 401) throw $c0722d30b1d17141$export$a3747c6e46c7a8eb.notAllowed("Could not fetch region settings: ".concat(regionSettingsResponse.statusText), regionSettingsResponse.status);
                    else throw $c0722d30b1d17141$export$a3747c6e46c7a8eb.internal("Could not fetch region settings: ".concat(regionSettingsResponse.statusText));
                }
            } catch (e) {
                if (e instanceof $c0722d30b1d17141$export$a3747c6e46c7a8eb) // rethrow connection errors
                throw e;
                else if (signal === null || signal === void 0 ? void 0 : signal.aborted) throw $c0722d30b1d17141$export$a3747c6e46c7a8eb.cancelled("Region fetching was aborted");
                else // wrap other errors as connection errors
                throw $c0722d30b1d17141$export$a3747c6e46c7a8eb.serverUnreachable("Could not fetch region settings, ".concat(e instanceof Error ? "".concat(e.name, ": ").concat(e.message) : e));
            } finally{
                unlock();
            }
        });
    }
    static scheduleRefetch(url, token, maxAgeInMs) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            const timeout = $c0722d30b1d17141$var$RegionUrlProvider.settingsTimeouts.get(url.hostname);
            clearTimeout(timeout);
            $c0722d30b1d17141$var$RegionUrlProvider.settingsTimeouts.set(url.hostname, setTimeout(()=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                    try {
                        const newSettings = yield $c0722d30b1d17141$var$RegionUrlProvider.fetchRegionSettings(url, token);
                        $c0722d30b1d17141$var$RegionUrlProvider.updateCachedRegionSettings(url, token, newSettings);
                    } catch (error) {
                        if (error instanceof $c0722d30b1d17141$export$a3747c6e46c7a8eb && error.reason === $c0722d30b1d17141$export$61182a0b21436b65.NotAllowed) {
                            $c0722d30b1d17141$var$livekitLogger.debug('token is not valid, cancelling auto region refresh');
                            return;
                        }
                        $c0722d30b1d17141$var$livekitLogger.debug('auto refetching of region settings failed', {
                            error: error
                        });
                        // continue retrying with the same max age
                        $c0722d30b1d17141$var$RegionUrlProvider.scheduleRefetch(url, token, maxAgeInMs);
                    }
                }), maxAgeInMs));
        });
    }
    static updateCachedRegionSettings(url, token, settings) {
        $c0722d30b1d17141$var$RegionUrlProvider.cache.set(url.hostname, settings);
        $c0722d30b1d17141$var$RegionUrlProvider.scheduleRefetch(url, token, settings.maxAgeInMs);
    }
    static stopRefetch(hostname) {
        const timeout = $c0722d30b1d17141$var$RegionUrlProvider.settingsTimeouts.get(hostname);
        if (timeout) {
            clearTimeout(timeout);
            $c0722d30b1d17141$var$RegionUrlProvider.settingsTimeouts.delete(hostname);
        }
    }
    static scheduleCleanup(hostname) {
        let tracker = $c0722d30b1d17141$var$RegionUrlProvider.connectionTrackers.get(hostname);
        if (!tracker) return;
        // Cancel any existing cleanup timeout
        if (tracker.cleanupTimeout) clearTimeout(tracker.cleanupTimeout);
        // Schedule cleanup to stop refetch after delay
        tracker.cleanupTimeout = setTimeout(()=>{
            const currentTracker = $c0722d30b1d17141$var$RegionUrlProvider.connectionTrackers.get(hostname);
            if (currentTracker && currentTracker.connectionCount === 0) {
                $c0722d30b1d17141$var$livekitLogger.debug('stopping region refetch after disconnect delay', {
                    hostname: hostname
                });
                $c0722d30b1d17141$var$RegionUrlProvider.stopRefetch(hostname);
            }
            if (currentTracker) currentTracker.cleanupTimeout = undefined;
        }, $c0722d30b1d17141$var$STOP_REFETCH_DELAY_MS);
    }
    static cancelCleanup(hostname) {
        const tracker = $c0722d30b1d17141$var$RegionUrlProvider.connectionTrackers.get(hostname);
        if (tracker === null || tracker === void 0 ? void 0 : tracker.cleanupTimeout) {
            clearTimeout(tracker.cleanupTimeout);
            tracker.cleanupTimeout = undefined;
        }
    }
    notifyConnected() {
        const hostname = this.serverUrl.hostname;
        let tracker = $c0722d30b1d17141$var$RegionUrlProvider.connectionTrackers.get(hostname);
        if (!tracker) {
            tracker = {
                connectionCount: 0
            };
            $c0722d30b1d17141$var$RegionUrlProvider.connectionTrackers.set(hostname, tracker);
        }
        tracker.connectionCount++;
        // Cancel any scheduled cleanup since we have an active connection
        $c0722d30b1d17141$var$RegionUrlProvider.cancelCleanup(hostname);
    }
    notifyDisconnected() {
        const hostname = this.serverUrl.hostname;
        const tracker = $c0722d30b1d17141$var$RegionUrlProvider.connectionTrackers.get(hostname);
        if (!tracker) return;
        tracker.connectionCount = Math.max(0, tracker.connectionCount - 1);
        // If no more connections, schedule cleanup
        if (tracker.connectionCount === 0) $c0722d30b1d17141$var$RegionUrlProvider.scheduleCleanup(hostname);
    }
    constructor(url, token){
        this.attemptedRegions = [];
        this.serverUrl = new URL(url);
        this.token = token;
    }
    updateToken(token) {
        var _a;
        this.token = token;
        const url = this.getServerUrl();
        const settings = $c0722d30b1d17141$var$RegionUrlProvider.cache.get(url.hostname);
        $c0722d30b1d17141$var$RegionUrlProvider.scheduleRefetch(this.serverUrl, this.token, (_a = settings === null || settings === void 0 ? void 0 : settings.maxAgeInMs) !== null && _a !== void 0 ? _a : $c0722d30b1d17141$var$DEFAULT_MAX_AGE_MS);
    }
    isCloud() {
        return $c0722d30b1d17141$var$isCloud(this.serverUrl);
    }
    getServerUrl() {
        return this.serverUrl;
    }
    /** @internal */ fetchRegionSettings(abortSignal) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            return $c0722d30b1d17141$var$RegionUrlProvider.fetchRegionSettings(this.serverUrl, this.token, abortSignal);
        });
    }
    getNextBestRegionUrl(abortSignal) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.isCloud()) throw Error('region availability is only supported for LiveKit Cloud domains');
            let cachedSettings = $c0722d30b1d17141$var$RegionUrlProvider.cache.get(this.serverUrl.hostname);
            if (!cachedSettings || Date.now() - cachedSettings.updatedAtInMs > cachedSettings.maxAgeInMs) {
                cachedSettings = yield this.fetchRegionSettings(abortSignal);
                $c0722d30b1d17141$var$RegionUrlProvider.updateCachedRegionSettings(this.serverUrl, this.token, cachedSettings);
            }
            const regionsLeft = cachedSettings.regionSettings.regions.filter((region)=>!this.attemptedRegions.find((attempted)=>attempted.url === region.url));
            if (regionsLeft.length > 0) {
                const nextRegion = regionsLeft[0];
                this.attemptedRegions.push(nextRegion);
                $c0722d30b1d17141$var$livekitLogger.debug("next region: ".concat(nextRegion.region));
                return nextRegion.url;
            } else return null;
        });
    }
    resetAttempts() {
        this.attemptedRegions = [];
    }
    setServerReportedRegions(settings) {
        $c0722d30b1d17141$var$RegionUrlProvider.updateCachedRegionSettings(this.serverUrl, this.token, settings);
    }
}
$c0722d30b1d17141$var$RegionUrlProvider.cache = new Map();
$c0722d30b1d17141$var$RegionUrlProvider.settingsTimeouts = new Map();
$c0722d30b1d17141$var$RegionUrlProvider.connectionTrackers = new Map();
$c0722d30b1d17141$var$RegionUrlProvider.fetchLock = new $c0722d30b1d17141$export$ca12f2943758ef55();
function $c0722d30b1d17141$var$getCloudConfigUrl(serverUrl) {
    return "".concat(serverUrl.protocol.replace('ws', 'http'), "//").concat(serverUrl.host, "/settings");
}
class $c0722d30b1d17141$var$BaseStreamReader {
    get info() {
        return this._info;
    }
    /** @internal */ validateBytesReceived() {
        let doneReceiving = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        if (typeof this.totalByteSize !== 'number' || this.totalByteSize === 0) return;
        if (doneReceiving && this.bytesReceived < this.totalByteSize) throw new $c0722d30b1d17141$export$a2ac0e78e1ae83d7("Not enough chunk(s) received - expected ".concat(this.totalByteSize, " bytes of data total, only received ").concat(this.bytesReceived, " bytes"), $c0722d30b1d17141$export$7dd215bfe4893462.Incomplete);
        else if (this.bytesReceived > this.totalByteSize) throw new $c0722d30b1d17141$export$a2ac0e78e1ae83d7("Extra chunk(s) received - expected ".concat(this.totalByteSize, " bytes of data total, received ").concat(this.bytesReceived, " bytes"), $c0722d30b1d17141$export$7dd215bfe4893462.LengthExceeded);
    }
    constructor(info, stream, totalByteSize){
        this.reader = stream;
        this.totalByteSize = totalByteSize;
        this._info = info;
        this.bytesReceived = 0;
    }
}
class $c0722d30b1d17141$var$ByteStreamReader extends $c0722d30b1d17141$var$BaseStreamReader {
    handleChunkReceived(chunk) {
        var _a;
        this.bytesReceived += chunk.content.byteLength;
        this.validateBytesReceived();
        const currentProgress = this.totalByteSize ? this.bytesReceived / this.totalByteSize : undefined;
        (_a = this.onProgress) === null || _a === void 0 || _a.call(this, currentProgress);
    }
    [Symbol.asyncIterator]() {
        const reader = this.reader.getReader();
        // Suppress unhandled rejection on reader.closed — errors are
        // already propagated through reader.read() to the consumer.
        reader.closed.catch(()=>{});
        const cleanup = ()=>{
            reader.releaseLock();
            this.signal = undefined;
        };
        return {
            next: ()=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                    try {
                        const signal = this.signal;
                        if (signal === null || signal === void 0 ? void 0 : signal.aborted) throw signal.reason;
                        const result = yield new Promise((resolve, reject)=>{
                            if (signal) {
                                const onAbort = ()=>reject(signal.reason);
                                signal.addEventListener('abort', onAbort, {
                                    once: true
                                });
                                reader.read().then(resolve, reject).finally(()=>{
                                    signal.removeEventListener('abort', onAbort);
                                });
                            } else reader.read().then(resolve, reject);
                        });
                        if (result.done) {
                            this.validateBytesReceived(true);
                            return {
                                done: true,
                                value: undefined
                            };
                        } else {
                            this.handleChunkReceived(result.value);
                            return {
                                done: false,
                                value: result.value.content
                            };
                        }
                    } catch (err) {
                        cleanup();
                        throw err;
                    }
                }),
            // note: `return` runs only for premature exits, see:
            // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#errors_during_iteration
            return () {
                return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                    cleanup();
                    return {
                        done: true,
                        value: undefined
                    };
                });
            }
        };
    }
    /**
   * Injects an AbortSignal, which if aborted, will terminate the currently active
   * stream iteration operation.
   *
   * Note that when using AbortSignal.timeout(...), the timeout applies across
   * the whole iteration operation, not just one individual chunk read.
   */ withAbortSignal(signal) {
        this.signal = signal;
        return this;
    }
    readAll() {
        return $c0722d30b1d17141$var$__awaiter(this, arguments, void 0, function() {
            var _this = this;
            let opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            return function*() {
                var _a, e_1, _b, _c;
                let chunks = new Set();
                const iterator = opts.signal ? _this.withAbortSignal(opts.signal) : _this;
                try {
                    for(var _d = true, iterator_1 = $c0722d30b1d17141$var$__asyncValues(iterator), iterator_1_1; iterator_1_1 = yield iterator_1.next(), _a = iterator_1_1.done, !_a; _d = true){
                        _c = iterator_1_1.value;
                        _d = false;
                        const chunk = _c;
                        chunks.add(chunk);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (!_d && !_a && (_b = iterator_1.return)) yield _b.call(iterator_1);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                return Array.from(chunks);
            }();
        });
    }
}
/**
 * A class to read chunks from a ReadableStream and provide them in a structured format.
 */ class $c0722d30b1d17141$var$TextStreamReader extends $c0722d30b1d17141$var$BaseStreamReader {
    /**
   * A TextStreamReader instance can be used as an AsyncIterator that returns the entire string
   * that has been received up to the current point in time.
   */ constructor(info, stream, totalChunkCount){
        super(info, stream, totalChunkCount);
        this.receivedChunks = new Map();
    }
    handleChunkReceived(chunk) {
        var _a;
        const index = $c0722d30b1d17141$var$bigIntToNumber(chunk.chunkIndex);
        const previousChunkAtIndex = this.receivedChunks.get(index);
        if (previousChunkAtIndex && previousChunkAtIndex.version > chunk.version) // we have a newer version already, dropping the old one
        return;
        this.receivedChunks.set(index, chunk);
        this.bytesReceived += chunk.content.byteLength;
        this.validateBytesReceived();
        const currentProgress = this.totalByteSize ? this.bytesReceived / this.totalByteSize : undefined;
        (_a = this.onProgress) === null || _a === void 0 || _a.call(this, currentProgress);
    }
    /**
   * Async iterator implementation to allow usage of `for await...of` syntax.
   * Yields structured chunks from the stream.
   *
   */ [Symbol.asyncIterator]() {
        const reader = this.reader.getReader();
        // Suppress unhandled rejection on reader.closed — errors are
        // already propagated through reader.read() to the consumer.
        reader.closed.catch(()=>{});
        const decoder = new TextDecoder('utf-8', {
            fatal: true
        });
        const signal = this.signal;
        const cleanup = ()=>{
            reader.releaseLock();
            this.signal = undefined;
        };
        return {
            next: ()=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                    try {
                        if (signal === null || signal === void 0 ? void 0 : signal.aborted) throw signal.reason;
                        const result = yield new Promise((resolve, reject)=>{
                            if (signal) {
                                const onAbort = ()=>reject(signal.reason);
                                signal.addEventListener('abort', onAbort, {
                                    once: true
                                });
                                reader.read().then(resolve, reject).finally(()=>{
                                    signal.removeEventListener('abort', onAbort);
                                });
                            } else reader.read().then(resolve, reject);
                        });
                        if (result.done) {
                            this.validateBytesReceived(true);
                            return {
                                done: true,
                                value: undefined
                            };
                        } else {
                            this.handleChunkReceived(result.value);
                            let decodedResult;
                            try {
                                decodedResult = decoder.decode(result.value.content);
                            } catch (err) {
                                throw new $c0722d30b1d17141$export$a2ac0e78e1ae83d7("Cannot decode datastream chunk ".concat(result.value.chunkIndex, " as text: ").concat(err), $c0722d30b1d17141$export$7dd215bfe4893462.DecodeFailed);
                            }
                            return {
                                done: false,
                                value: decodedResult
                            };
                        }
                    } catch (err) {
                        cleanup();
                        throw err;
                    }
                }),
            // note: `return` runs only for premature exits, see:
            // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#errors_during_iteration
            return () {
                return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                    cleanup();
                    return {
                        done: true,
                        value: undefined
                    };
                });
            }
        };
    }
    /**
   * Injects an AbortSignal, which if aborted, will terminate the currently active
   * stream iteration operation.
   *
   * Note that when using AbortSignal.timeout(...), the timeout applies across
   * the whole iteration operation, not just one individual chunk read.
   */ withAbortSignal(signal) {
        this.signal = signal;
        return this;
    }
    readAll() {
        return $c0722d30b1d17141$var$__awaiter(this, arguments, void 0, function() {
            var _this2 = this;
            let opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            return function*() {
                var _a, e_2, _b, _c;
                let finalString = '';
                const iterator = opts.signal ? _this2.withAbortSignal(opts.signal) : _this2;
                try {
                    for(var _d = true, iterator_2 = $c0722d30b1d17141$var$__asyncValues(iterator), iterator_2_1; iterator_2_1 = yield iterator_2.next(), _a = iterator_2_1.done, !_a; _d = true){
                        _c = iterator_2_1.value;
                        _d = false;
                        const chunk = _c;
                        finalString += chunk;
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (!_d && !_a && (_b = iterator_2.return)) yield _b.call(iterator_2);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
                return finalString;
            }();
        });
    }
}
class $c0722d30b1d17141$var$IncomingDataStreamManager {
    constructor(){
        this.log = $c0722d30b1d17141$var$livekitLogger;
        this.byteStreamControllers = new Map();
        this.textStreamControllers = new Map();
        this.byteStreamHandlers = new Map();
        this.textStreamHandlers = new Map();
        this.isConnected = false;
        this.bufferedPackets = [];
    }
    setConnected(connected) {
        this.isConnected = connected;
        if (connected) this.flushBufferedPackets();
    }
    flushBufferedPackets() {
        const packets = this.bufferedPackets;
        this.bufferedPackets = [];
        for (const { packet: packet, encryptionType: encryptionType } of packets)this.handleDataStreamPacket(packet, encryptionType);
    }
    registerTextStreamHandler(topic, callback) {
        if (this.textStreamHandlers.has(topic)) throw new $c0722d30b1d17141$export$a2ac0e78e1ae83d7("A text stream handler for topic \"".concat(topic, "\" has already been set."), $c0722d30b1d17141$export$7dd215bfe4893462.HandlerAlreadyRegistered);
        this.textStreamHandlers.set(topic, callback);
    }
    unregisterTextStreamHandler(topic) {
        this.textStreamHandlers.delete(topic);
    }
    registerByteStreamHandler(topic, callback) {
        if (this.byteStreamHandlers.has(topic)) throw new $c0722d30b1d17141$export$a2ac0e78e1ae83d7("A byte stream handler for topic \"".concat(topic, "\" has already been set."), $c0722d30b1d17141$export$7dd215bfe4893462.HandlerAlreadyRegistered);
        this.byteStreamHandlers.set(topic, callback);
    }
    unregisterByteStreamHandler(topic) {
        this.byteStreamHandlers.delete(topic);
    }
    clearControllers() {
        this.byteStreamControllers.clear();
        this.textStreamControllers.clear();
        this.bufferedPackets = [];
    }
    validateParticipantHasNoActiveDataStreams(participantIdentity) {
        // Terminate any in flight data stream receives from the given participant
        const textStreamsBeingSentByDisconnectingParticipant = Array.from(this.textStreamControllers.entries()).filter((entry)=>entry[1].sendingParticipantIdentity === participantIdentity);
        const byteStreamsBeingSentByDisconnectingParticipant = Array.from(this.byteStreamControllers.entries()).filter((entry)=>entry[1].sendingParticipantIdentity === participantIdentity);
        if (textStreamsBeingSentByDisconnectingParticipant.length > 0 || byteStreamsBeingSentByDisconnectingParticipant.length > 0) {
            const abnormalEndError = new $c0722d30b1d17141$export$a2ac0e78e1ae83d7("Participant ".concat(participantIdentity, " unexpectedly disconnected in the middle of sending data"), $c0722d30b1d17141$export$7dd215bfe4893462.AbnormalEnd);
            for (const [id, controller] of byteStreamsBeingSentByDisconnectingParticipant){
                controller.controller.error(abnormalEndError);
                this.byteStreamControllers.delete(id);
            }
            for (const [id, controller] of textStreamsBeingSentByDisconnectingParticipant){
                controller.controller.error(abnormalEndError);
                this.textStreamControllers.delete(id);
            }
        }
    }
    handleDataStreamPacket(packet, encryptionType) {
        if (!this.isConnected) {
            this.bufferedPackets.push({
                packet: packet,
                encryptionType: encryptionType
            });
            return;
        }
        switch(packet.value.case){
            case 'streamHeader':
                return this.handleStreamHeader(packet.value.value, packet.participantIdentity, encryptionType);
            case 'streamChunk':
                return this.handleStreamChunk(packet.value.value, encryptionType);
            case 'streamTrailer':
                return this.handleStreamTrailer(packet.value.value, encryptionType);
            default:
                throw new Error("DataPacket of value \"".concat(packet.value.case, "\" is not data stream related!"));
        }
    }
    handleStreamHeader(streamHeader, participantIdentity, encryptionType) {
        var _a;
        if (streamHeader.contentHeader.case === 'byteHeader') {
            const streamHandlerCallback = this.byteStreamHandlers.get(streamHeader.topic);
            if (!streamHandlerCallback) {
                this.log.debug('ignoring incoming byte stream due to no handler for topic', streamHeader.topic);
                return;
            }
            let streamController;
            const info = {
                id: streamHeader.streamId,
                name: (_a = streamHeader.contentHeader.value.name) !== null && _a !== void 0 ? _a : 'unknown',
                mimeType: streamHeader.mimeType,
                size: streamHeader.totalLength ? Number(streamHeader.totalLength) : undefined,
                topic: streamHeader.topic,
                timestamp: $c0722d30b1d17141$var$bigIntToNumber(streamHeader.timestamp),
                attributes: streamHeader.attributes,
                encryptionType: encryptionType
            };
            const stream = new ReadableStream({
                start: (controller)=>{
                    streamController = controller;
                    if (this.textStreamControllers.has(streamHeader.streamId)) throw new $c0722d30b1d17141$export$a2ac0e78e1ae83d7("A data stream read is already in progress for a stream with id ".concat(streamHeader.streamId, "."), $c0722d30b1d17141$export$7dd215bfe4893462.AlreadyOpened);
                    this.byteStreamControllers.set(streamHeader.streamId, {
                        info: info,
                        controller: streamController,
                        startTime: Date.now(),
                        sendingParticipantIdentity: participantIdentity
                    });
                }
            });
            streamHandlerCallback(new $c0722d30b1d17141$var$ByteStreamReader(info, stream, $c0722d30b1d17141$var$bigIntToNumber(streamHeader.totalLength)), {
                identity: participantIdentity
            });
        } else if (streamHeader.contentHeader.case === 'textHeader') {
            const streamHandlerCallback = this.textStreamHandlers.get(streamHeader.topic);
            if (!streamHandlerCallback) {
                this.log.debug('ignoring incoming text stream due to no handler for topic', streamHeader.topic);
                return;
            }
            let streamController;
            const info = {
                id: streamHeader.streamId,
                mimeType: streamHeader.mimeType,
                size: streamHeader.totalLength ? Number(streamHeader.totalLength) : undefined,
                topic: streamHeader.topic,
                timestamp: Number(streamHeader.timestamp),
                attributes: streamHeader.attributes,
                encryptionType: encryptionType,
                attachedStreamIds: streamHeader.contentHeader.value.attachedStreamIds
            };
            const stream = new ReadableStream({
                start: (controller)=>{
                    streamController = controller;
                    if (this.textStreamControllers.has(streamHeader.streamId)) throw new $c0722d30b1d17141$export$a2ac0e78e1ae83d7("A data stream read is already in progress for a stream with id ".concat(streamHeader.streamId, "."), $c0722d30b1d17141$export$7dd215bfe4893462.AlreadyOpened);
                    this.textStreamControllers.set(streamHeader.streamId, {
                        info: info,
                        controller: streamController,
                        startTime: Date.now(),
                        sendingParticipantIdentity: participantIdentity
                    });
                }
            });
            streamHandlerCallback(new $c0722d30b1d17141$var$TextStreamReader(info, stream, $c0722d30b1d17141$var$bigIntToNumber(streamHeader.totalLength)), {
                identity: participantIdentity
            });
        }
    }
    handleStreamChunk(chunk, encryptionType) {
        const fileBuffer = this.byteStreamControllers.get(chunk.streamId);
        if (fileBuffer) {
            if (fileBuffer.info.encryptionType !== encryptionType) {
                fileBuffer.controller.error(new $c0722d30b1d17141$export$a2ac0e78e1ae83d7("Encryption type mismatch for stream ".concat(chunk.streamId, ". Expected ").concat(encryptionType, ", got ").concat(fileBuffer.info.encryptionType), $c0722d30b1d17141$export$7dd215bfe4893462.EncryptionTypeMismatch));
                this.byteStreamControllers.delete(chunk.streamId);
            } else if (chunk.content.length > 0) fileBuffer.controller.enqueue(chunk);
        }
        const textBuffer = this.textStreamControllers.get(chunk.streamId);
        if (textBuffer) {
            if (textBuffer.info.encryptionType !== encryptionType) {
                textBuffer.controller.error(new $c0722d30b1d17141$export$a2ac0e78e1ae83d7("Encryption type mismatch for stream ".concat(chunk.streamId, ". Expected ").concat(encryptionType, ", got ").concat(textBuffer.info.encryptionType), $c0722d30b1d17141$export$7dd215bfe4893462.EncryptionTypeMismatch));
                this.textStreamControllers.delete(chunk.streamId);
            } else if (chunk.content.length > 0) textBuffer.controller.enqueue(chunk);
        }
    }
    handleStreamTrailer(trailer, encryptionType) {
        const textBuffer = this.textStreamControllers.get(trailer.streamId);
        if (textBuffer) {
            if (textBuffer.info.encryptionType !== encryptionType) textBuffer.controller.error(new $c0722d30b1d17141$export$a2ac0e78e1ae83d7("Encryption type mismatch for stream ".concat(trailer.streamId, ". Expected ").concat(encryptionType, ", got ").concat(textBuffer.info.encryptionType), $c0722d30b1d17141$export$7dd215bfe4893462.EncryptionTypeMismatch));
            else {
                textBuffer.info.attributes = Object.assign(Object.assign({}, textBuffer.info.attributes), trailer.attributes);
                textBuffer.controller.close();
                this.textStreamControllers.delete(trailer.streamId);
            }
        }
        const fileBuffer = this.byteStreamControllers.get(trailer.streamId);
        if (fileBuffer) {
            if (fileBuffer.info.encryptionType !== encryptionType) fileBuffer.controller.error(new $c0722d30b1d17141$export$a2ac0e78e1ae83d7("Encryption type mismatch for stream ".concat(trailer.streamId, ". Expected ").concat(encryptionType, ", got ").concat(fileBuffer.info.encryptionType), $c0722d30b1d17141$export$7dd215bfe4893462.EncryptionTypeMismatch));
            else {
                fileBuffer.info.attributes = Object.assign(Object.assign({}, fileBuffer.info.attributes), trailer.attributes);
                fileBuffer.controller.close();
            }
            this.byteStreamControllers.delete(trailer.streamId);
        }
    }
}
class $c0722d30b1d17141$var$BaseStreamWriter {
    constructor(writableStream, info, onClose){
        this.writableStream = writableStream;
        this.defaultWriter = writableStream.getWriter();
        this.onClose = onClose;
        this.info = info;
    }
    write(chunk) {
        return this.defaultWriter.write(chunk);
    }
    close() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            yield this.defaultWriter.close();
            this.defaultWriter.releaseLock();
            (_a = this.onClose) === null || _a === void 0 || _a.call(this);
        });
    }
}
class $c0722d30b1d17141$var$TextStreamWriter extends $c0722d30b1d17141$var$BaseStreamWriter {
}
class $c0722d30b1d17141$var$ByteStreamWriter extends $c0722d30b1d17141$var$BaseStreamWriter {
}
const $c0722d30b1d17141$var$STREAM_CHUNK_SIZE = 15000;
/**
 * Manages sending custom user data via data channels.
 * @internal
 */ class $c0722d30b1d17141$var$OutgoingDataStreamManager {
    constructor(engine, log){
        this.engine = engine;
        this.log = log;
    }
    setupEngine(engine) {
        this.engine = engine;
    }
    /** {@inheritDoc LocalParticipant.sendText} */ sendText(text, options) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const streamId = crypto.randomUUID();
            const textInBytes = new TextEncoder().encode(text);
            const totalTextLength = textInBytes.byteLength;
            const fileIds = (_a = options === null || options === void 0 ? void 0 : options.attachments) === null || _a === void 0 ? void 0 : _a.map(()=>crypto.randomUUID());
            const progresses = new Array(fileIds ? fileIds.length + 1 : 1).fill(0);
            const handleProgress = (progress, idx)=>{
                var _a;
                progresses[idx] = progress;
                const totalProgress = progresses.reduce((acc, val)=>acc + val, 0);
                (_a = options === null || options === void 0 ? void 0 : options.onProgress) === null || _a === void 0 || _a.call(options, totalProgress);
            };
            const writer = yield this.streamText({
                streamId: streamId,
                totalSize: totalTextLength,
                destinationIdentities: options === null || options === void 0 ? void 0 : options.destinationIdentities,
                topic: options === null || options === void 0 ? void 0 : options.topic,
                attachedStreamIds: fileIds,
                attributes: options === null || options === void 0 ? void 0 : options.attributes
            });
            yield writer.write(text);
            // set text part of progress to 1
            handleProgress(1, 0);
            yield writer.close();
            if ((options === null || options === void 0 ? void 0 : options.attachments) && fileIds) yield Promise.all(options.attachments.map((file, idx)=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                    return this._sendFile(fileIds[idx], file, {
                        topic: options.topic,
                        mimeType: file.type,
                        onProgress: (progress)=>{
                            handleProgress(progress, idx + 1);
                        }
                    });
                })));
            return writer.info;
        });
    }
    /**
   * @internal
   */ streamText(options) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c;
            const streamId = (_a = options === null || options === void 0 ? void 0 : options.streamId) !== null && _a !== void 0 ? _a : crypto.randomUUID();
            const info = {
                id: streamId,
                mimeType: 'text/plain',
                timestamp: Date.now(),
                topic: (_b = options === null || options === void 0 ? void 0 : options.topic) !== null && _b !== void 0 ? _b : '',
                size: options === null || options === void 0 ? void 0 : options.totalSize,
                attributes: options === null || options === void 0 ? void 0 : options.attributes,
                encryptionType: ((_c = this.engine.e2eeManager) === null || _c === void 0 ? void 0 : _c.isDataChannelEncryptionEnabled) ? $c0722d30b1d17141$export$1efc488791285f20.GCM : $c0722d30b1d17141$export$1efc488791285f20.NONE,
                attachedStreamIds: options === null || options === void 0 ? void 0 : options.attachedStreamIds
            };
            const header = new $c0722d30b1d17141$var$DataStream_Header({
                streamId: streamId,
                mimeType: info.mimeType,
                topic: info.topic,
                timestamp: $c0722d30b1d17141$var$numberToBigInt(info.timestamp),
                totalLength: $c0722d30b1d17141$var$numberToBigInt(info.size),
                attributes: info.attributes,
                contentHeader: {
                    case: 'textHeader',
                    value: new $c0722d30b1d17141$var$DataStream_TextHeader({
                        version: options === null || options === void 0 ? void 0 : options.version,
                        attachedStreamIds: info.attachedStreamIds,
                        replyToStreamId: options === null || options === void 0 ? void 0 : options.replyToStreamId,
                        operationType: (options === null || options === void 0 ? void 0 : options.type) === 'update' ? $c0722d30b1d17141$var$DataStream_OperationType.UPDATE : $c0722d30b1d17141$var$DataStream_OperationType.CREATE
                    })
                }
            });
            const destinationIdentities = options === null || options === void 0 ? void 0 : options.destinationIdentities;
            const packet = new $c0722d30b1d17141$var$DataPacket({
                destinationIdentities: destinationIdentities,
                value: {
                    case: 'streamHeader',
                    value: header
                }
            });
            yield this.engine.sendDataPacket(packet, $c0722d30b1d17141$var$DataChannelKind.RELIABLE);
            let chunkId = 0;
            const engine = this.engine;
            const writableStream = new WritableStream({
                // Implement the sink
                write (text) {
                    return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                        for (const textByteChunk of $c0722d30b1d17141$var$splitUtf8(text, $c0722d30b1d17141$var$STREAM_CHUNK_SIZE)){
                            const chunk = new $c0722d30b1d17141$var$DataStream_Chunk({
                                content: textByteChunk,
                                streamId: streamId,
                                chunkIndex: $c0722d30b1d17141$var$numberToBigInt(chunkId)
                            });
                            const chunkPacket = new $c0722d30b1d17141$var$DataPacket({
                                destinationIdentities: destinationIdentities,
                                value: {
                                    case: 'streamChunk',
                                    value: chunk
                                }
                            });
                            yield engine.sendDataPacket(chunkPacket, $c0722d30b1d17141$var$DataChannelKind.RELIABLE);
                            chunkId += 1;
                        }
                    });
                },
                close () {
                    return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                        const trailer = new $c0722d30b1d17141$var$DataStream_Trailer({
                            streamId: streamId
                        });
                        const trailerPacket = new $c0722d30b1d17141$var$DataPacket({
                            destinationIdentities: destinationIdentities,
                            value: {
                                case: 'streamTrailer',
                                value: trailer
                            }
                        });
                        yield engine.sendDataPacket(trailerPacket, $c0722d30b1d17141$var$DataChannelKind.RELIABLE);
                    });
                },
                abort (err) {
                    console.log('Sink error:', err);
                // TODO handle aborts to signal something to receiver side
                }
            });
            let onEngineClose = ()=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                    yield writer.close();
                });
            engine.once($c0722d30b1d17141$export$c09e63b8572f869.Closing, onEngineClose);
            const writer = new $c0722d30b1d17141$var$TextStreamWriter(writableStream, info, ()=>this.engine.off($c0722d30b1d17141$export$c09e63b8572f869.Closing, onEngineClose));
            return writer;
        });
    }
    sendFile(file, options) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            const streamId = crypto.randomUUID();
            yield this._sendFile(streamId, file, options);
            return {
                id: streamId
            };
        });
    }
    _sendFile(streamId, file, options) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const writer = yield this.streamBytes({
                streamId: streamId,
                totalSize: file.size,
                name: file.name,
                mimeType: (_a = options === null || options === void 0 ? void 0 : options.mimeType) !== null && _a !== void 0 ? _a : file.type,
                topic: options === null || options === void 0 ? void 0 : options.topic,
                destinationIdentities: options === null || options === void 0 ? void 0 : options.destinationIdentities
            });
            const reader = file.stream().getReader();
            while(true){
                const { done: done, value: value } = yield reader.read();
                if (done) break;
                yield writer.write(value);
            }
            yield writer.close();
            return writer.info;
        });
    }
    streamBytes(options) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d, _e;
            const streamId = (_a = options === null || options === void 0 ? void 0 : options.streamId) !== null && _a !== void 0 ? _a : crypto.randomUUID();
            const destinationIdentities = options === null || options === void 0 ? void 0 : options.destinationIdentities;
            const info = {
                id: streamId,
                mimeType: (_b = options === null || options === void 0 ? void 0 : options.mimeType) !== null && _b !== void 0 ? _b : 'application/octet-stream',
                topic: (_c = options === null || options === void 0 ? void 0 : options.topic) !== null && _c !== void 0 ? _c : '',
                timestamp: Date.now(),
                attributes: options === null || options === void 0 ? void 0 : options.attributes,
                size: options === null || options === void 0 ? void 0 : options.totalSize,
                name: (_d = options === null || options === void 0 ? void 0 : options.name) !== null && _d !== void 0 ? _d : 'unknown',
                encryptionType: ((_e = this.engine.e2eeManager) === null || _e === void 0 ? void 0 : _e.isDataChannelEncryptionEnabled) ? $c0722d30b1d17141$export$1efc488791285f20.GCM : $c0722d30b1d17141$export$1efc488791285f20.NONE
            };
            const header = new $c0722d30b1d17141$var$DataStream_Header({
                totalLength: $c0722d30b1d17141$var$numberToBigInt(info.size),
                mimeType: info.mimeType,
                streamId: streamId,
                topic: info.topic,
                timestamp: $c0722d30b1d17141$var$numberToBigInt(Date.now()),
                attributes: info.attributes,
                contentHeader: {
                    case: 'byteHeader',
                    value: new $c0722d30b1d17141$var$DataStream_ByteHeader({
                        name: info.name
                    })
                }
            });
            const packet = new $c0722d30b1d17141$var$DataPacket({
                destinationIdentities: destinationIdentities,
                value: {
                    case: 'streamHeader',
                    value: header
                }
            });
            yield this.engine.sendDataPacket(packet, $c0722d30b1d17141$var$DataChannelKind.RELIABLE);
            let chunkId = 0;
            const writeMutex = new $c0722d30b1d17141$export$ca12f2943758ef55();
            const engine = this.engine;
            const logLocal = this.log;
            const writableStream = new WritableStream({
                write (chunk) {
                    return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                        const unlock = yield writeMutex.lock();
                        let byteOffset = 0;
                        try {
                            while(byteOffset < chunk.byteLength){
                                const subChunk = chunk.slice(byteOffset, byteOffset + $c0722d30b1d17141$var$STREAM_CHUNK_SIZE);
                                const chunkPacket = new $c0722d30b1d17141$var$DataPacket({
                                    destinationIdentities: destinationIdentities,
                                    value: {
                                        case: 'streamChunk',
                                        value: new $c0722d30b1d17141$var$DataStream_Chunk({
                                            content: subChunk,
                                            streamId: streamId,
                                            chunkIndex: $c0722d30b1d17141$var$numberToBigInt(chunkId)
                                        })
                                    }
                                });
                                yield engine.sendDataPacket(chunkPacket, $c0722d30b1d17141$var$DataChannelKind.RELIABLE);
                                chunkId += 1;
                                byteOffset += subChunk.byteLength;
                            }
                        } finally{
                            unlock();
                        }
                    });
                },
                close () {
                    return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                        const trailer = new $c0722d30b1d17141$var$DataStream_Trailer({
                            streamId: streamId
                        });
                        const trailerPacket = new $c0722d30b1d17141$var$DataPacket({
                            destinationIdentities: destinationIdentities,
                            value: {
                                case: 'streamTrailer',
                                value: trailer
                            }
                        });
                        yield engine.sendDataPacket(trailerPacket, $c0722d30b1d17141$var$DataChannelKind.RELIABLE);
                    });
                },
                abort (err) {
                    logLocal.error('Sink error:', err);
                }
            });
            const byteWriter = new $c0722d30b1d17141$var$ByteStreamWriter(writableStream, info);
            return byteWriter;
        });
    }
} /**
 * Implementation of AbortSignal.any
 * Creates a signal that will be aborted when any of the given signals is aborted.
 * @link https://developer.mozilla.org/en-US/docs/Web/API/AbortSignal/any
 */ 
function $c0722d30b1d17141$var$abortSignalAny(signals) {
    // Handle empty signals array
    if (signals.length === 0) {
        const controller = new AbortController();
        return controller.signal;
    }
    // Fast path for single signal
    if (signals.length === 1) return signals[0];
    // Check if any signal is already aborted
    for (const signal of signals){
        if (signal.aborted) return signal;
    }
    // Create a new controller for the combined signal
    const controller = new AbortController();
    const unlisteners = Array(signals.length);
    // Function to clean up all event listeners
    const cleanup = ()=>{
        for (const unsubscribe of unlisteners)unsubscribe();
    };
    // Add event listeners to each signal
    signals.forEach((signal, index)=>{
        const handler = ()=>{
            controller.abort(signal.reason);
            cleanup();
        };
        signal.addEventListener('abort', handler);
        unlisteners[index] = ()=>signal.removeEventListener('abort', handler);
    });
    return controller.signal;
}
/**
 * Implementation of AbortSignal.timeout
 * Creates a signal that will be aborted after the specified timeout.
 * @link https://developer.mozilla.org/en-US/docs/Web/API/AbortSignal/timeout
 */ function $c0722d30b1d17141$var$abortSignalTimeout(ms) {
    const controller = new AbortController();
    setTimeout(()=>{
        controller.abort(new DOMException("signal timed out after ".concat(ms, " ms"), 'TimeoutError'));
    }, ms);
    return controller.signal;
} // Number type sizes
const $c0722d30b1d17141$var$U8_LENGTH_BYTES = 1;
const $c0722d30b1d17141$var$U16_LENGTH_BYTES = 2;
const $c0722d30b1d17141$var$U32_LENGTH_BYTES = 4;
const $c0722d30b1d17141$var$U64_LENGTH_BYTES = 8;
/// Constants used for serialization and deserialization.
const $c0722d30b1d17141$var$SUPPORTED_VERSION = 0;
const $c0722d30b1d17141$var$BASE_HEADER_LEN = 12;
// Bitfield shifts and masks for header flags
const $c0722d30b1d17141$var$VERSION_SHIFT = 5;
const $c0722d30b1d17141$var$VERSION_MASK = 0x07;
const $c0722d30b1d17141$var$FRAME_MARKER_SHIFT = 3;
const $c0722d30b1d17141$var$FRAME_MARKER_MASK = 0x3;
const $c0722d30b1d17141$var$FRAME_MARKER_START = 0x2;
const $c0722d30b1d17141$var$FRAME_MARKER_FINAL = 0x1;
const $c0722d30b1d17141$var$FRAME_MARKER_INTER = 0x0;
const $c0722d30b1d17141$var$FRAME_MARKER_SINGLE = 0x3;
const $c0722d30b1d17141$var$EXT_WORDS_INDICATOR_SIZE = 2;
const $c0722d30b1d17141$var$EXT_FLAG_SHIFT = 0x2;
const $c0722d30b1d17141$var$EXT_FLAG_MASK = 0x1;
const $c0722d30b1d17141$var$EXT_TAG_PADDING = 0;
var $c0722d30b1d17141$var$DataTrackDeserializeErrorReason;
(function(DataTrackDeserializeErrorReason) {
    DataTrackDeserializeErrorReason[DataTrackDeserializeErrorReason["TooShort"] = 0] = "TooShort";
    DataTrackDeserializeErrorReason[DataTrackDeserializeErrorReason["HeaderOverrun"] = 1] = "HeaderOverrun";
    DataTrackDeserializeErrorReason[DataTrackDeserializeErrorReason["MissingExtWords"] = 2] = "MissingExtWords";
    DataTrackDeserializeErrorReason[DataTrackDeserializeErrorReason["UnsupportedVersion"] = 3] = "UnsupportedVersion";
    DataTrackDeserializeErrorReason[DataTrackDeserializeErrorReason["InvalidHandle"] = 4] = "InvalidHandle";
    DataTrackDeserializeErrorReason[DataTrackDeserializeErrorReason["MalformedExt"] = 5] = "MalformedExt";
})($c0722d30b1d17141$var$DataTrackDeserializeErrorReason || ($c0722d30b1d17141$var$DataTrackDeserializeErrorReason = {}));
class $c0722d30b1d17141$var$DataTrackDeserializeError extends $c0722d30b1d17141$export$af3f20dcdd5a185f {
    constructor(message, reason, options){
        super(19, message, options);
        this.name = 'DataTrackDeserializeError';
        this.reason = reason;
        this.reasonName = $c0722d30b1d17141$var$DataTrackDeserializeErrorReason[reason];
    }
    static tooShort() {
        return new $c0722d30b1d17141$var$DataTrackDeserializeError('Too short to contain a valid header', $c0722d30b1d17141$var$DataTrackDeserializeErrorReason.TooShort);
    }
    static headerOverrun() {
        return new $c0722d30b1d17141$var$DataTrackDeserializeError('Header exceeds total packet length', $c0722d30b1d17141$var$DataTrackDeserializeErrorReason.HeaderOverrun);
    }
    static missingExtWords() {
        return new $c0722d30b1d17141$var$DataTrackDeserializeError('Extension word indicator is missing', $c0722d30b1d17141$var$DataTrackDeserializeErrorReason.MissingExtWords);
    }
    static unsupportedVersion(version) {
        return new $c0722d30b1d17141$var$DataTrackDeserializeError("Unsupported version ".concat(version), $c0722d30b1d17141$var$DataTrackDeserializeErrorReason.UnsupportedVersion);
    }
    static invalidHandle(cause) {
        return new $c0722d30b1d17141$var$DataTrackDeserializeError("invalid track handle: ".concat(cause.message), $c0722d30b1d17141$var$DataTrackDeserializeErrorReason.InvalidHandle, {
            cause: cause
        });
    }
    static malformedExt(tag) {
        return new $c0722d30b1d17141$var$DataTrackDeserializeError("Extension with tag ".concat(tag, " is malformed"), $c0722d30b1d17141$var$DataTrackDeserializeErrorReason.MalformedExt);
    }
}
var $c0722d30b1d17141$var$DataTrackSerializeErrorReason;
(function(DataTrackSerializeErrorReason) {
    DataTrackSerializeErrorReason[DataTrackSerializeErrorReason["TooSmallForHeader"] = 0] = "TooSmallForHeader";
    DataTrackSerializeErrorReason[DataTrackSerializeErrorReason["TooSmallForPayload"] = 1] = "TooSmallForPayload";
})($c0722d30b1d17141$var$DataTrackSerializeErrorReason || ($c0722d30b1d17141$var$DataTrackSerializeErrorReason = {}));
class $c0722d30b1d17141$var$DataTrackSerializeError extends $c0722d30b1d17141$export$af3f20dcdd5a185f {
    constructor(message, reason, options){
        super(19, message, options);
        this.name = 'DataTrackSerializeError';
        this.reason = reason;
        this.reasonName = $c0722d30b1d17141$var$DataTrackSerializeErrorReason[reason];
    }
    static tooSmallForHeader() {
        return new $c0722d30b1d17141$var$DataTrackSerializeError('Buffer cannot fit header', $c0722d30b1d17141$var$DataTrackSerializeErrorReason.TooSmallForHeader);
    }
    static tooSmallForPayload() {
        return new $c0722d30b1d17141$var$DataTrackSerializeError('Buffer cannot fit payload', $c0722d30b1d17141$var$DataTrackSerializeErrorReason.TooSmallForPayload);
    }
} /** An abstract class implementing common behavior related to data track binary serialization. */ 
class $c0722d30b1d17141$var$Serializable {
    /** Encodes the instance as binary and returns the data as a Uint8Array. */ toBinary() {
        const lengthBytes = this.toBinaryLengthBytes();
        const output = new ArrayBuffer(lengthBytes);
        const view = new DataView(output);
        const writtenBytes = this.toBinaryInto(view);
        if (lengthBytes !== writtenBytes) // @throws-transformer ignore - this should be treated as a "panic" and not be caught
        throw new Error("".concat(this.constructor.name, ".toBinary: written bytes (").concat(writtenBytes, " bytes) not equal to allocated array buffer length (").concat(lengthBytes, " bytes)."));
        return new Uint8Array(output);
    }
}
var $c0722d30b1d17141$var$DataTrackExtensionTag;
(function(DataTrackExtensionTag) {
    DataTrackExtensionTag[DataTrackExtensionTag["UserTimestamp"] = 2] = "UserTimestamp";
    DataTrackExtensionTag[DataTrackExtensionTag["E2ee"] = 1] = "E2ee";
})($c0722d30b1d17141$var$DataTrackExtensionTag || ($c0722d30b1d17141$var$DataTrackExtensionTag = {}));
class $c0722d30b1d17141$var$DataTrackExtension extends $c0722d30b1d17141$var$Serializable {
}
class $c0722d30b1d17141$var$DataTrackUserTimestampExtension extends $c0722d30b1d17141$var$DataTrackExtension {
    constructor(timestamp){
        super();
        this.timestamp = timestamp;
    }
    toBinaryLengthBytes() {
        return $c0722d30b1d17141$var$U8_LENGTH_BYTES /* tag */  + $c0722d30b1d17141$var$U8_LENGTH_BYTES /* length */  + $c0722d30b1d17141$var$DataTrackUserTimestampExtension.lengthBytes;
    }
    toBinaryInto(dataView) {
        let byteIndex = 0;
        dataView.setUint8(byteIndex, $c0722d30b1d17141$var$DataTrackUserTimestampExtension.tag);
        byteIndex += $c0722d30b1d17141$var$U8_LENGTH_BYTES;
        dataView.setUint8(byteIndex, $c0722d30b1d17141$var$DataTrackUserTimestampExtension.lengthBytes);
        byteIndex += $c0722d30b1d17141$var$U8_LENGTH_BYTES;
        dataView.setBigUint64(byteIndex, this.timestamp);
        byteIndex += $c0722d30b1d17141$var$U64_LENGTH_BYTES;
        const totalLengthBytes = this.toBinaryLengthBytes();
        if (byteIndex !== totalLengthBytes) // @throws-transformer ignore - this should be treated as a "panic" and not be caught
        throw new Error("DataTrackUserTimestampExtension.toBinaryInto: Wrote ".concat(byteIndex, " bytes but expected length was ").concat(totalLengthBytes, " bytes"));
        return byteIndex;
    }
    toJSON() {
        return {
            tag: $c0722d30b1d17141$var$DataTrackUserTimestampExtension.tag,
            lengthBytes: $c0722d30b1d17141$var$DataTrackUserTimestampExtension.lengthBytes,
            timestamp: this.timestamp
        };
    }
}
$c0722d30b1d17141$var$DataTrackUserTimestampExtension.tag = $c0722d30b1d17141$var$DataTrackExtensionTag.UserTimestamp;
$c0722d30b1d17141$var$DataTrackUserTimestampExtension.lengthBytes = 8;
class $c0722d30b1d17141$var$DataTrackE2eeExtension extends $c0722d30b1d17141$var$DataTrackExtension {
    constructor(keyIndex, iv){
        super();
        this.keyIndex = keyIndex;
        this.iv = iv;
    }
    toBinaryLengthBytes() {
        return $c0722d30b1d17141$var$U8_LENGTH_BYTES /* tag */  + $c0722d30b1d17141$var$U8_LENGTH_BYTES /* length */  + $c0722d30b1d17141$var$DataTrackE2eeExtension.lengthBytes;
    }
    toBinaryInto(dataView) {
        let byteIndex = 0;
        dataView.setUint8(byteIndex, $c0722d30b1d17141$var$DataTrackE2eeExtension.tag);
        byteIndex += $c0722d30b1d17141$var$U8_LENGTH_BYTES;
        dataView.setUint8(byteIndex, $c0722d30b1d17141$var$DataTrackE2eeExtension.lengthBytes);
        byteIndex += $c0722d30b1d17141$var$U8_LENGTH_BYTES;
        dataView.setUint8(byteIndex, this.keyIndex);
        byteIndex += $c0722d30b1d17141$var$U8_LENGTH_BYTES;
        for(let i = 0; i < this.iv.length; i += 1){
            dataView.setUint8(byteIndex, this.iv[i]);
            byteIndex += $c0722d30b1d17141$var$U8_LENGTH_BYTES;
        }
        const totalLengthBytes = this.toBinaryLengthBytes();
        if (byteIndex !== totalLengthBytes) // @throws-transformer ignore - this should be treated as a "panic" and not be caught
        throw new Error("DataTrackE2eeExtension.toBinaryInto: Wrote ".concat(byteIndex, " bytes but expected length was ").concat(totalLengthBytes, " bytes"));
        return byteIndex;
    }
    toJSON() {
        return {
            tag: $c0722d30b1d17141$var$DataTrackE2eeExtension.tag,
            lengthBytes: $c0722d30b1d17141$var$DataTrackE2eeExtension.lengthBytes,
            keyIndex: this.keyIndex,
            iv: this.iv
        };
    }
}
$c0722d30b1d17141$var$DataTrackE2eeExtension.tag = $c0722d30b1d17141$var$DataTrackExtensionTag.E2ee;
$c0722d30b1d17141$var$DataTrackE2eeExtension.lengthBytes = 13;
class $c0722d30b1d17141$var$DataTrackExtensions extends $c0722d30b1d17141$var$Serializable {
    constructor(){
        let opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        super();
        this.userTimestamp = opts.userTimestamp;
        this.e2ee = opts.e2ee;
    }
    toBinaryLengthBytes() {
        let lengthBytes = 0;
        if (this.userTimestamp) lengthBytes += this.userTimestamp.toBinaryLengthBytes();
        if (this.e2ee) lengthBytes += this.e2ee.toBinaryLengthBytes();
        return lengthBytes;
    }
    toBinaryInto(dataView) {
        let byteIndex = 0;
        if (this.e2ee) {
            const e2eeBytes = this.e2ee.toBinaryInto(dataView);
            byteIndex += e2eeBytes;
        }
        if (this.userTimestamp) {
            const userTimestampBytes = this.userTimestamp.toBinaryInto(new DataView(dataView.buffer, dataView.byteOffset + byteIndex));
            byteIndex += userTimestampBytes;
        }
        const totalLengthBytes = this.toBinaryLengthBytes();
        if (byteIndex !== totalLengthBytes) // @throws-transformer ignore - this should be treated as a "panic" and not be caught
        throw new Error("DataTrackExtensions.toBinaryInto: Wrote ".concat(byteIndex, " bytes but expected length was ").concat(totalLengthBytes, " bytes"));
        return byteIndex;
    }
    static fromBinary(input) {
        const dataView = $c0722d30b1d17141$var$coerceToDataView(input);
        let userTimestamp;
        let e2ee;
        let byteIndex = 0;
        while(dataView.byteLength - byteIndex >= $c0722d30b1d17141$var$U8_LENGTH_BYTES + $c0722d30b1d17141$var$U8_LENGTH_BYTES){
            const tag = dataView.getUint8(byteIndex);
            byteIndex += $c0722d30b1d17141$var$U8_LENGTH_BYTES;
            const lengthBytes = dataView.getUint8(byteIndex);
            byteIndex += $c0722d30b1d17141$var$U8_LENGTH_BYTES;
            if (tag === $c0722d30b1d17141$var$EXT_TAG_PADDING) continue;
            switch(tag){
                case $c0722d30b1d17141$var$DataTrackExtensionTag.UserTimestamp:
                    if (dataView.byteLength - byteIndex < $c0722d30b1d17141$var$DataTrackUserTimestampExtension.lengthBytes) throw $c0722d30b1d17141$var$DataTrackDeserializeError.malformedExt(tag);
                    userTimestamp = new $c0722d30b1d17141$var$DataTrackUserTimestampExtension(dataView.getBigUint64(byteIndex));
                    byteIndex += lengthBytes;
                    break;
                case $c0722d30b1d17141$var$DataTrackExtensionTag.E2ee:
                    if (dataView.byteLength - byteIndex < $c0722d30b1d17141$var$DataTrackE2eeExtension.lengthBytes) throw $c0722d30b1d17141$var$DataTrackDeserializeError.malformedExt(tag);
                    const keyIndex = dataView.getUint8(byteIndex);
                    const iv = new Uint8Array(12);
                    for(let i = 0; i < iv.length; i += 1){
                        let byteIndexForIv = byteIndex;
                        byteIndexForIv += $c0722d30b1d17141$var$U8_LENGTH_BYTES; // key index
                        byteIndexForIv += i * $c0722d30b1d17141$var$U8_LENGTH_BYTES; // Index into iv array
                        iv[i] = dataView.getUint8(byteIndexForIv);
                    }
                    e2ee = new $c0722d30b1d17141$var$DataTrackE2eeExtension(keyIndex, iv);
                    byteIndex += lengthBytes;
                    break;
                default:
                    // Skip over unknown extensions (forward compatible).
                    if (dataView.byteLength - byteIndex < lengthBytes) throw $c0722d30b1d17141$var$DataTrackDeserializeError.malformedExt(tag);
                    byteIndex += lengthBytes;
                    break;
            }
        }
        // NOTE: padding bytes after extension data is intentionally not being processed
        return [
            new $c0722d30b1d17141$var$DataTrackExtensions({
                userTimestamp: userTimestamp,
                e2ee: e2ee
            }),
            dataView.byteLength
        ];
    }
    toJSON() {
        var _a, _b, _c, _d;
        return {
            userTimestamp: (_b = (_a = this.userTimestamp) === null || _a === void 0 ? void 0 : _a.toJSON()) !== null && _b !== void 0 ? _b : null,
            e2ee: (_d = (_c = this.e2ee) === null || _c === void 0 ? void 0 : _c.toJSON()) !== null && _d !== void 0 ? _d : null
        };
    }
}
const $c0722d30b1d17141$var$DataTrackFrameInternal = {
    from (frame) {
        return {
            payload: frame.payload,
            extensions: new $c0722d30b1d17141$var$DataTrackExtensions({
                userTimestamp: frame.userTimestamp ? new $c0722d30b1d17141$var$DataTrackUserTimestampExtension(frame.userTimestamp) : undefined
            })
        };
    },
    /** Converts from a DataTrackFrameInternal -> DataTrackFrame. Some internal information is
   * discarded like e2ee encrption extension data. */ lossyIntoFrame (frame) {
        var _a;
        return {
            payload: frame.payload,
            userTimestamp: (_a = frame.extensions.userTimestamp) === null || _a === void 0 ? void 0 : _a.timestamp
        };
    }
};
const $c0722d30b1d17141$var$TrackSymbol = Symbol.for('lk.track');
const $c0722d30b1d17141$var$DataTrackSymbol = Symbol.for('lk.data-track');
class $c0722d30b1d17141$export$57384944deb33057 {
    /** @internal */ constructor(info, manager, options){
        this.trackSymbol = $c0722d30b1d17141$var$TrackSymbol;
        this.isLocal = false;
        this.typeSymbol = $c0722d30b1d17141$var$DataTrackSymbol;
        this.info = info;
        this.manager = manager;
        this.publisherIdentity = options.publisherIdentity;
    }
    /** Subscribes to the data track to receive frames.
   *
   * # Returns
   *
   * A stream that yields {@link DataTrackFrame}s as they arrive.
   *
   * # Multiple Subscriptions
   *
   * An application may call `subscribe` more than once to process frames in
   * multiple places. For example, one async task might plot values on a graph
   * while another writes them to a file.
   *
   * Internally, only the first call to `subscribe` communicates with the SFU and
   * allocates the resources required to receive frames. Additional subscriptions
   * reuse the same underlying pipeline and do not trigger additional signaling.
   *
   * Note that newly created subscriptions only receive frames published after
   * the initial subscription is established.
   */ subscribe(options) {
        try {
            const [stream, sfuSubscriptionComplete] = this.manager.openSubscriptionStream(this.info.sid, options === null || options === void 0 ? void 0 : options.signal, options === null || options === void 0 ? void 0 : options.bufferSize);
            // Prevent uncaught promise rejections from bubbling up if rejections occur after the
            // readable stream is discarded.
            sfuSubscriptionComplete.catch(()=>{});
            return stream;
        } catch (err) {
            // NOTE: Rethrow errors to break Throws<...> type boundary
            throw err;
        }
    }
} /** A class for serializing / deserializing data track packet header sections. */ 
class $c0722d30b1d17141$var$DataTrackPacketHeader extends $c0722d30b1d17141$var$Serializable {
    constructor(opts){
        var _a;
        super();
        this.marker = opts.marker;
        this.trackHandle = opts.trackHandle;
        this.sequence = opts.sequence;
        this.frameNumber = opts.frameNumber;
        this.timestamp = opts.timestamp;
        this.extensions = (_a = opts.extensions) !== null && _a !== void 0 ? _a : new $c0722d30b1d17141$var$DataTrackExtensions();
    }
    extensionsMetrics() {
        const lengthBytes = this.extensions.toBinaryLengthBytes();
        const lengthWords = Math.ceil(($c0722d30b1d17141$var$EXT_WORDS_INDICATOR_SIZE + lengthBytes) / 4);
        const paddingLengthBytes = lengthWords * 4 - $c0722d30b1d17141$var$EXT_WORDS_INDICATOR_SIZE - lengthBytes;
        return {
            lengthBytes: lengthBytes,
            lengthWords: lengthWords,
            paddingLengthBytes: paddingLengthBytes
        };
    }
    toBinaryLengthBytes() {
        const { lengthBytes: extLengthBytes, paddingLengthBytes: extPaddingLengthBytes } = this.extensionsMetrics();
        let totalLengthBytes = $c0722d30b1d17141$var$BASE_HEADER_LEN;
        if (extLengthBytes > 0) totalLengthBytes += $c0722d30b1d17141$var$EXT_WORDS_INDICATOR_SIZE + extLengthBytes + extPaddingLengthBytes;
        return totalLengthBytes;
    }
    toBinaryInto(dataView) {
        if (dataView.byteLength < this.toBinaryLengthBytes()) throw $c0722d30b1d17141$var$DataTrackSerializeError.tooSmallForHeader();
        let initial = $c0722d30b1d17141$var$SUPPORTED_VERSION << $c0722d30b1d17141$var$VERSION_SHIFT;
        let marker;
        switch(this.marker){
            case $c0722d30b1d17141$var$FrameMarker.Inter:
                marker = $c0722d30b1d17141$var$FRAME_MARKER_INTER;
                break;
            case $c0722d30b1d17141$var$FrameMarker.Final:
                marker = $c0722d30b1d17141$var$FRAME_MARKER_FINAL;
                break;
            case $c0722d30b1d17141$var$FrameMarker.Start:
                marker = $c0722d30b1d17141$var$FRAME_MARKER_START;
                break;
            case $c0722d30b1d17141$var$FrameMarker.Single:
                marker = $c0722d30b1d17141$var$FRAME_MARKER_SINGLE;
                break;
        }
        initial |= marker << $c0722d30b1d17141$var$FRAME_MARKER_SHIFT;
        const { lengthBytes: extensionsLengthBytes, lengthWords: extensionsLengthWords, paddingLengthBytes: extensionsPaddingLengthBytes } = this.extensionsMetrics();
        if (extensionsLengthBytes > 0) initial |= 1 << $c0722d30b1d17141$var$EXT_FLAG_SHIFT;
        let byteIndex = 0;
        dataView.setUint8(byteIndex, initial);
        byteIndex += $c0722d30b1d17141$var$U8_LENGTH_BYTES;
        dataView.setUint8(byteIndex, 0); // Reserved
        byteIndex += $c0722d30b1d17141$var$U8_LENGTH_BYTES;
        dataView.setUint16(byteIndex, this.trackHandle);
        byteIndex += $c0722d30b1d17141$var$U16_LENGTH_BYTES;
        dataView.setUint16(byteIndex, this.sequence.value);
        byteIndex += $c0722d30b1d17141$var$U16_LENGTH_BYTES;
        dataView.setUint16(byteIndex, this.frameNumber.value);
        byteIndex += $c0722d30b1d17141$var$U16_LENGTH_BYTES;
        dataView.setUint32(byteIndex, this.timestamp.asTicks());
        byteIndex += $c0722d30b1d17141$var$U32_LENGTH_BYTES;
        if (extensionsLengthBytes > 0) {
            // NOTE: The protocol is implemented in a way where if the extension bit is set, any
            // deserializer assumes the extensions section is at least one byte long, and the "length"
            // field represents the "number of additional bytes" long the extensions section is. This is
            // potentially unintuitive so I wanted to call it out.
            const rtpOrientedExtensionLengthWords = extensionsLengthWords - 1;
            dataView.setUint16(byteIndex, rtpOrientedExtensionLengthWords);
            byteIndex += $c0722d30b1d17141$var$U16_LENGTH_BYTES;
            const extensionBytes = this.extensions.toBinaryInto(new DataView(dataView.buffer, dataView.byteOffset + byteIndex));
            byteIndex += extensionBytes;
            for(let i = 0; i < extensionsPaddingLengthBytes; i += 1){
                dataView.setUint8(byteIndex, 0);
                byteIndex += $c0722d30b1d17141$var$U8_LENGTH_BYTES;
            }
        }
        const totalLengthBytes = this.toBinaryLengthBytes();
        if (byteIndex !== totalLengthBytes) // @throws-transformer ignore - this should be treated as a "panic" and not be caught
        throw new Error("DataTrackPacketHeader.toBinaryInto: Wrote ".concat(byteIndex, " bytes but expected length was ").concat(totalLengthBytes, " bytes"));
        return totalLengthBytes;
    }
    static fromBinary(input) {
        const dataView = $c0722d30b1d17141$var$coerceToDataView(input);
        if (dataView.byteLength < $c0722d30b1d17141$var$BASE_HEADER_LEN) throw $c0722d30b1d17141$var$DataTrackDeserializeError.tooShort();
        let byteIndex = 0;
        const initial = dataView.getUint8(byteIndex);
        byteIndex += $c0722d30b1d17141$var$U8_LENGTH_BYTES;
        const version = initial >> $c0722d30b1d17141$var$VERSION_SHIFT & $c0722d30b1d17141$var$VERSION_MASK;
        if (version > $c0722d30b1d17141$var$SUPPORTED_VERSION) throw $c0722d30b1d17141$var$DataTrackDeserializeError.unsupportedVersion(version);
        let marker;
        switch(initial >> $c0722d30b1d17141$var$FRAME_MARKER_SHIFT & $c0722d30b1d17141$var$FRAME_MARKER_MASK){
            case $c0722d30b1d17141$var$FRAME_MARKER_START:
                marker = $c0722d30b1d17141$var$FrameMarker.Start;
                break;
            case $c0722d30b1d17141$var$FRAME_MARKER_FINAL:
                marker = $c0722d30b1d17141$var$FrameMarker.Final;
                break;
            case $c0722d30b1d17141$var$FRAME_MARKER_SINGLE:
                marker = $c0722d30b1d17141$var$FrameMarker.Single;
                break;
            case $c0722d30b1d17141$var$FRAME_MARKER_INTER:
            default:
                marker = $c0722d30b1d17141$var$FrameMarker.Inter;
                break;
        }
        const extensionsFlag = (initial >> $c0722d30b1d17141$var$EXT_FLAG_SHIFT & $c0722d30b1d17141$var$EXT_FLAG_MASK) > 0;
        byteIndex += $c0722d30b1d17141$var$U8_LENGTH_BYTES; // Reserved
        let trackHandle;
        try {
            trackHandle = $c0722d30b1d17141$var$DataTrackHandle.fromNumber(dataView.getUint16(byteIndex));
        } catch (e) {
            if (e instanceof $c0722d30b1d17141$var$DataTrackHandleError && (e.isReason($c0722d30b1d17141$var$DataTrackHandleErrorReason.Reserved) || e.isReason($c0722d30b1d17141$var$DataTrackHandleErrorReason.TooLarge))) throw $c0722d30b1d17141$var$DataTrackDeserializeError.invalidHandle(e);
            else throw e;
        }
        byteIndex += $c0722d30b1d17141$var$U16_LENGTH_BYTES;
        const sequence = $c0722d30b1d17141$var$WrapAroundUnsignedInt.u16(dataView.getUint16(byteIndex));
        byteIndex += $c0722d30b1d17141$var$U16_LENGTH_BYTES;
        const frameNumber = $c0722d30b1d17141$var$WrapAroundUnsignedInt.u16(dataView.getUint16(byteIndex));
        byteIndex += $c0722d30b1d17141$var$U16_LENGTH_BYTES;
        const timestamp = $c0722d30b1d17141$var$DataTrackTimestamp.fromRtpTicks(dataView.getUint32(byteIndex));
        byteIndex += $c0722d30b1d17141$var$U32_LENGTH_BYTES;
        let extensions = new $c0722d30b1d17141$var$DataTrackExtensions();
        if (extensionsFlag) {
            if (dataView.byteLength - byteIndex < $c0722d30b1d17141$var$U16_LENGTH_BYTES) throw $c0722d30b1d17141$var$DataTrackDeserializeError.missingExtWords();
            let rtpOrientedExtensionWords = dataView.getUint16(byteIndex);
            byteIndex += $c0722d30b1d17141$var$U16_LENGTH_BYTES;
            // NOTE: The protocol is implemented in a way where if the extension bit is set, any
            // deserializer assumes the extensions section is at least one byte long, and the "length"
            // field represents the "number of additional bytes" long the extensions section is. This is
            // potentially unintuitive so I wanted to call it out.
            const extensionWords = rtpOrientedExtensionWords + 1;
            let extensionLengthBytes = 4 * extensionWords - $c0722d30b1d17141$var$EXT_WORDS_INDICATOR_SIZE;
            if (byteIndex + extensionLengthBytes > dataView.byteLength) throw $c0722d30b1d17141$var$DataTrackDeserializeError.headerOverrun();
            let extensionDataView = new DataView(dataView.buffer, dataView.byteOffset + byteIndex, extensionLengthBytes);
            const [result, readBytes] = $c0722d30b1d17141$var$DataTrackExtensions.fromBinary(extensionDataView);
            extensions = result;
            byteIndex += readBytes;
        }
        return [
            new $c0722d30b1d17141$var$DataTrackPacketHeader({
                marker: marker,
                trackHandle: trackHandle,
                sequence: sequence,
                frameNumber: frameNumber,
                timestamp: timestamp,
                extensions: extensions
            }),
            byteIndex
        ];
    }
    toJSON() {
        return {
            marker: this.marker,
            trackHandle: this.trackHandle,
            sequence: this.sequence.value,
            frameNumber: this.frameNumber.value,
            timestamp: this.timestamp.asTicks(),
            extensions: this.extensions.toJSON()
        };
    }
}
/** Marker indicating a packet's position in relation to a frame. */ var $c0722d30b1d17141$var$FrameMarker;
(function(FrameMarker) {
    /** Packet is the first in a frame. */ FrameMarker[FrameMarker["Start"] = 0] = "Start";
    /** Packet is within a frame. */ FrameMarker[FrameMarker["Inter"] = 1] = "Inter";
    /** Packet is the last in a frame. */ FrameMarker[FrameMarker["Final"] = 2] = "Final";
    /** Packet is the only one in a frame. */ FrameMarker[FrameMarker["Single"] = 3] = "Single";
})($c0722d30b1d17141$var$FrameMarker || ($c0722d30b1d17141$var$FrameMarker = {}));
/** A class for serializing / deserializing data track packets. */ class $c0722d30b1d17141$export$15123dfe1dd5ee93 extends $c0722d30b1d17141$var$Serializable {
    constructor(header, payload){
        super();
        this.header = header;
        this.payload = payload;
    }
    toBinaryLengthBytes() {
        return this.header.toBinaryLengthBytes() + this.payload.byteLength;
    }
    toBinaryInto(dataView) {
        let byteIndex = 0;
        const headerLengthBytes = this.header.toBinaryInto(dataView);
        byteIndex += headerLengthBytes;
        if (dataView.byteLength - byteIndex < this.payload.byteLength) throw $c0722d30b1d17141$var$DataTrackSerializeError.tooSmallForPayload();
        for(let index = 0; index < this.payload.length; index += 1){
            dataView.setUint8(byteIndex, this.payload[index]);
            byteIndex += $c0722d30b1d17141$var$U8_LENGTH_BYTES;
        }
        const totalLengthBytes = this.toBinaryLengthBytes();
        if (byteIndex !== totalLengthBytes) // @throws-transformer ignore - this should be treated as a "panic" and not be caught
        throw new Error("DataTrackPacket.toBinaryInto: Wrote ".concat(byteIndex, " bytes but expected length was ").concat(totalLengthBytes, " bytes"));
        return totalLengthBytes;
    }
    static fromBinary(input) {
        const dataView = $c0722d30b1d17141$var$coerceToDataView(input);
        const [header, headerByteLength] = $c0722d30b1d17141$var$DataTrackPacketHeader.fromBinary(dataView);
        const payload = dataView.buffer.slice(dataView.byteOffset + headerByteLength, dataView.byteOffset + dataView.byteLength);
        return [
            new $c0722d30b1d17141$export$15123dfe1dd5ee93(header, new Uint8Array(payload)),
            dataView.byteLength
        ];
    }
    toJSON() {
        return {
            header: this.header.toJSON(),
            payload: this.payload
        };
    }
}
const $c0722d30b1d17141$var$log$3 = $c0722d30b1d17141$export$2b1d391cd05230fd($c0722d30b1d17141$export$69ba24dd79f4da21.DataTracks);
/** An error indicating a frame was dropped. */ class $c0722d30b1d17141$var$DataTrackDepacketizerDropError extends $c0722d30b1d17141$export$af3f20dcdd5a185f {
    constructor(message, reason, frameNumber, options){
        super(19, "Frame ".concat(frameNumber, " dropped: ").concat(message), options);
        this.name = 'DataTrackDepacketizerDropError';
        this.reason = reason;
        this.reasonName = $c0722d30b1d17141$var$DataTrackDepacketizerDropReason[reason];
        this.frameNumber = frameNumber;
    }
    static interrupted(frameNumber, newFrameNumber) {
        return new $c0722d30b1d17141$var$DataTrackDepacketizerDropError("Interrupted by the start of a new frame ".concat(newFrameNumber), $c0722d30b1d17141$var$DataTrackDepacketizerDropReason.Interrupted, frameNumber);
    }
    static unknownFrame(frameNumber) {
        return new $c0722d30b1d17141$var$DataTrackDepacketizerDropError('Initial packet was never received.', $c0722d30b1d17141$var$DataTrackDepacketizerDropReason.UnknownFrame, frameNumber);
    }
    static bufferFull(frameNumber) {
        return new $c0722d30b1d17141$var$DataTrackDepacketizerDropError('Reorder buffer is full.', $c0722d30b1d17141$var$DataTrackDepacketizerDropReason.BufferFull, frameNumber);
    }
    static incomplete(frameNumber, receivedPackets, expectedPackets) {
        return new $c0722d30b1d17141$var$DataTrackDepacketizerDropError("Not all packets received before final packet. Received ".concat(receivedPackets, " packets, expected ").concat(expectedPackets, " packets."), $c0722d30b1d17141$var$DataTrackDepacketizerDropReason.Incomplete, frameNumber);
    }
}
/** Reason why a frame was dropped. */ var $c0722d30b1d17141$var$DataTrackDepacketizerDropReason;
(function(DataTrackDepacketizerDropReason) {
    DataTrackDepacketizerDropReason[DataTrackDepacketizerDropReason["Interrupted"] = 0] = "Interrupted";
    DataTrackDepacketizerDropReason[DataTrackDepacketizerDropReason["UnknownFrame"] = 1] = "UnknownFrame";
    DataTrackDepacketizerDropReason[DataTrackDepacketizerDropReason["BufferFull"] = 2] = "BufferFull";
    DataTrackDepacketizerDropReason[DataTrackDepacketizerDropReason["Incomplete"] = 3] = "Incomplete";
})($c0722d30b1d17141$var$DataTrackDepacketizerDropReason || ($c0722d30b1d17141$var$DataTrackDepacketizerDropReason = {}));
class $c0722d30b1d17141$var$DataTrackDepacketizer {
    constructor(){
        this.partial = null;
    }
    /** Should be repeatedly called with received {@link DataTrackPacket}s - intermediate calls
   * aggregate the packet's state internally, and return null.
   *
   * Once this method is called with the final packet to form a frame, a new {@link DataTrackFrameInternal}
   * is returned.*/ push(packet, options) {
        switch(packet.header.marker){
            case $c0722d30b1d17141$var$FrameMarker.Single:
                return this.frameFromSingle(packet, options);
            case $c0722d30b1d17141$var$FrameMarker.Start:
                return this.beginPartial(packet, options);
            case $c0722d30b1d17141$var$FrameMarker.Inter:
            case $c0722d30b1d17141$var$FrameMarker.Final:
                return this.pushToPartial(packet);
        }
    }
    reset() {
        this.partial = null;
    }
    frameFromSingle(packet, options) {
        if (packet.header.marker !== $c0722d30b1d17141$var$FrameMarker.Single) // @throws-transformer ignore - this should be treated as a "panic" and not be caught
        throw new Error("Depacketizer.frameFromSingle: packet.header.marker was not FrameMarker.Single, found ".concat(packet.header.marker, "."));
        if (this.partial) {
            if (options === null || options === void 0 ? void 0 : options.errorOnPartialFrames) {
                const frameNumber = this.partial.frameNumber;
                this.reset();
                throw $c0722d30b1d17141$var$DataTrackDepacketizerDropError.interrupted(frameNumber, packet.header.frameNumber.value);
            } else $c0722d30b1d17141$var$log$3.warn("Data track frame ".concat(this.partial.frameNumber, " was interrupted by the start of a new frame, dropping."));
        }
        this.reset();
        return {
            payload: packet.payload,
            extensions: packet.header.extensions
        };
    }
    /** Begin assembling a new packet. */ beginPartial(packet, options) {
        if (packet.header.marker !== $c0722d30b1d17141$var$FrameMarker.Start) // @throws-transformer ignore - this should be treated as a "panic" and not be caught
        throw new Error("Depacketizer.beginPartial: packet.header.marker was not FrameMarker.Start, found ".concat(packet.header.marker, "."));
        if (this.partial) {
            if (options === null || options === void 0 ? void 0 : options.errorOnPartialFrames) {
                const frameNumber = this.partial.frameNumber;
                this.reset();
                throw $c0722d30b1d17141$var$DataTrackDepacketizerDropError.interrupted(frameNumber, packet.header.frameNumber.value);
            } else $c0722d30b1d17141$var$log$3.warn("Data track frame ".concat(this.partial.frameNumber, " was interrupted by the start of a new frame ").concat(packet.header.frameNumber.value, ", dropping."));
        }
        this.reset();
        const startSequence = packet.header.sequence;
        this.partial = {
            frameNumber: packet.header.frameNumber.value,
            startSequence: startSequence,
            extensions: packet.header.extensions,
            payloads: new Map([
                [
                    startSequence.value,
                    packet.payload
                ]
            ])
        };
        return null;
    }
    /** Push to the existing partial frame. */ pushToPartial(packet) {
        if (packet.header.marker !== $c0722d30b1d17141$var$FrameMarker.Inter && packet.header.marker !== $c0722d30b1d17141$var$FrameMarker.Final) // @throws-transformer ignore - this should be treated as a "panic" and not be caught
        throw new Error("Depacketizer.pushToPartial: packet.header.marker was not FrameMarker.Inter or FrameMarker.Final, found ".concat(packet.header.marker, "."));
        if (!this.partial) {
            this.reset();
            throw $c0722d30b1d17141$var$DataTrackDepacketizerDropError.unknownFrame(packet.header.frameNumber.value);
        }
        if (packet.header.frameNumber.value !== this.partial.frameNumber) {
            const frameNumber = this.partial.frameNumber;
            this.reset();
            throw $c0722d30b1d17141$var$DataTrackDepacketizerDropError.interrupted(frameNumber, packet.header.frameNumber.value);
        }
        // NOTE: this check will block reprocessing packets with duplicate sequence values if the
        // buffer is full already, which could maybe be problematic for very large frames.
        if (this.partial.payloads.size >= $c0722d30b1d17141$var$DataTrackDepacketizer.MAX_BUFFER_PACKETS) {
            const frameNumber = this.partial.frameNumber;
            this.reset();
            throw $c0722d30b1d17141$var$DataTrackDepacketizerDropError.bufferFull(frameNumber);
        }
        // Note: receiving a packet with a duplicate `sequence` value is something that likely won't
        // happen in actual use, but even if it does (maybe a low level network retransmission?) the
        // last packet with a given sequence received should always win.
        if (this.partial.payloads.has(packet.header.sequence.value)) $c0722d30b1d17141$var$log$3.warn("Data track frame ".concat(this.partial.frameNumber, " received duplicate packet for sequence ").concat(packet.header.sequence.value, ", so replacing with newly received packet."));
        this.partial.payloads.set(packet.header.sequence.value, packet.payload);
        if (packet.header.marker === $c0722d30b1d17141$var$FrameMarker.Final) return this.finalize(this.partial, packet.header.sequence.value);
        return null;
    }
    /** Try to reassemble the complete frame. */ finalize(partial, endSequence) {
        const received = partial.payloads.size;
        let payloadLengthBytes = 0;
        for (const p of partial.payloads.values())payloadLengthBytes += p.length;
        const payload = new Uint8Array(payloadLengthBytes);
        let sequencePointer = partial.startSequence.clone();
        let payloadOffsetPointerBytes = 0;
        while(true){
            const partialPayload = partial.payloads.get(sequencePointer.value);
            if (!partialPayload) break;
            partial.payloads.delete(sequencePointer.value);
            const payloadRemainingBytes = payload.length - payloadOffsetPointerBytes;
            if (partialPayload.length > payloadRemainingBytes) // @throws-transformer ignore - this should be treated as a "panic" and not be caught
            throw new Error("Depacketizer.finalize: Expected at least ".concat(partialPayload.length, " more bytes left in the payload buffer, only got ").concat(payloadRemainingBytes, " bytes."));
            payload.set(partialPayload, payloadOffsetPointerBytes);
            payloadOffsetPointerBytes += partialPayload.length;
            // NOTE: sequencePointer could wrap around, which is why this isn't a "<"
            if (sequencePointer.value != endSequence) {
                sequencePointer.increment();
                continue;
            }
            // The packet is done processing, reset the state so another frame can be processed next.
            this.reset();
            return {
                payload: payload,
                extensions: partial.extensions
            };
        }
        this.reset();
        throw $c0722d30b1d17141$var$DataTrackDepacketizerDropError.incomplete(partial.frameNumber, received, endSequence - partial.startSequence.value + 1);
    }
}
/** Maximum number of packets to buffer per frame before dropping. */ $c0722d30b1d17141$var$DataTrackDepacketizer.MAX_BUFFER_PACKETS = 128;
var $c0722d30b1d17141$var$DataTrackSubscribeErrorReason;
(function(DataTrackSubscribeErrorReason) {
    /** The track has been unpublished and is no longer available */ DataTrackSubscribeErrorReason[DataTrackSubscribeErrorReason["Unpublished"] = 0] = "Unpublished";
    /** Request to subscribe to data track timed-out */ DataTrackSubscribeErrorReason[DataTrackSubscribeErrorReason["Timeout"] = 1] = "Timeout";
    /** Cannot subscribe to data track when disconnected */ DataTrackSubscribeErrorReason[DataTrackSubscribeErrorReason["Disconnected"] = 2] = "Disconnected";
    /** Subscription to data track cancelled by caller */ DataTrackSubscribeErrorReason[DataTrackSubscribeErrorReason["Cancelled"] = 4] = "Cancelled";
})($c0722d30b1d17141$var$DataTrackSubscribeErrorReason || ($c0722d30b1d17141$var$DataTrackSubscribeErrorReason = {}));
class $c0722d30b1d17141$var$DataTrackSubscribeError extends $c0722d30b1d17141$export$af3f20dcdd5a185f {
    constructor(message, reason, options){
        super(22, message, options);
        this.name = 'DataTrackSubscribeError';
        this.reason = reason;
        this.reasonName = $c0722d30b1d17141$var$DataTrackSubscribeErrorReason[reason];
    }
    static unpublished() {
        return new $c0722d30b1d17141$var$DataTrackSubscribeError('The track has been unpublished and is no longer available', $c0722d30b1d17141$var$DataTrackSubscribeErrorReason.Unpublished);
    }
    static timeout() {
        return new $c0722d30b1d17141$var$DataTrackSubscribeError('Request to subscribe to data track timed-out', $c0722d30b1d17141$var$DataTrackSubscribeErrorReason.Timeout);
    }
    static disconnected() {
        return new $c0722d30b1d17141$var$DataTrackSubscribeError('Cannot subscribe to data track when disconnected', $c0722d30b1d17141$var$DataTrackSubscribeErrorReason.Disconnected);
    }
    // NOTE: this was introduced by web / there isn't a corresponding case in the rust version.
    static cancelled() {
        return new $c0722d30b1d17141$var$DataTrackSubscribeError('Subscription to data track cancelled by caller', $c0722d30b1d17141$var$DataTrackSubscribeErrorReason.Cancelled);
    }
}
const $c0722d30b1d17141$var$log$2 = $c0722d30b1d17141$export$2b1d391cd05230fd($c0722d30b1d17141$export$69ba24dd79f4da21.DataTracks);
/**
 * Pipeline for an individual data track subscription.
 */ class $c0722d30b1d17141$var$IncomingDataTrackPipeline {
    /**
   * Creates a new pipeline with the given options.
   */ constructor(options){
        var _a;
        const hasProvider = options.e2eeManager !== null;
        if (options.info.usesE2ee !== hasProvider) // @throws-transformer ignore - this should be treated as a "panic" and not be caught
        throw new Error('IncomingDataTrackPipeline: DataTrackInfo.usesE2ee must match presence of decryptionProvider');
        const depacketizer = new $c0722d30b1d17141$var$DataTrackDepacketizer();
        this.publisherIdentity = options.publisherIdentity;
        this.e2eeManager = (_a = options.e2eeManager) !== null && _a !== void 0 ? _a : null;
        this.depacketizer = depacketizer;
    }
    updateE2eeManager(e2eeManager) {
        this.e2eeManager = e2eeManager;
    }
    processPacket(packet) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            const frame = this.depacketize(packet);
            if (!frame) return null;
            const decrypted = yield this.decryptIfNeeded(frame);
            if (!decrypted) return null;
            return decrypted;
        });
    }
    /**
   * Depacketize the given frame, log if a drop occurs.
   */ depacketize(packet) {
        let frame;
        try {
            frame = this.depacketizer.push(packet);
        } catch (err) {
            // In a future version, use this to maintain drop statistics.
            // FIXME: is this a good idea?
            $c0722d30b1d17141$var$log$2.warn("Data frame depacketize error: ".concat(err));
            return null;
        }
        return frame;
    }
    /**
   * Decrypt the frame's payload if E2EE is enabled for this track.
   */ decryptIfNeeded(frame) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            const e2eeManager = this.e2eeManager;
            if (!e2eeManager) return frame;
            const e2ee = (_b = (_a = frame.extensions) === null || _a === void 0 ? void 0 : _a.e2ee) !== null && _b !== void 0 ? _b : null;
            if (!e2ee) {
                $c0722d30b1d17141$var$log$2.error('Missing E2EE meta');
                return null;
            }
            let result;
            try {
                result = yield e2eeManager.handleEncryptedData(frame.payload, e2ee.iv, this.publisherIdentity, e2ee.keyIndex);
            } catch (err) {
                $c0722d30b1d17141$var$log$2.error("Error decrypting packet: ".concat(err));
                return null;
            }
            frame.payload = result.payload;
            return frame;
        });
    }
}
const $c0722d30b1d17141$var$log$1 = $c0722d30b1d17141$export$2b1d391cd05230fd($c0722d30b1d17141$export$69ba24dd79f4da21.DataTracks);
/** How long to wait when attempting to subscribe before timing out. */ const $c0722d30b1d17141$var$SUBSCRIBE_TIMEOUT_MILLISECONDS = 10000;
/** Maximum number of {@link DataTrackFrame}s that are cached for each ReadableStream subscription.
 * If data comes in too fast and saturates this threshold, backpressure will be applied. */ const $c0722d30b1d17141$var$READABLE_STREAM_DEFAULT_BUFFER_SIZE = 16;
class $c0722d30b1d17141$var$IncomingDataTrackManager extends $c0722d30b1d17141$var$eventsExports.EventEmitter {
    constructor(options){
        var _a;
        super();
        /** Mapping between track SID and descriptor. */ this.descriptors = new Map();
        /** Mapping between subscriber handle and track SID.
     *
     * This is an index that allows track descriptors to be looked up
     * by subscriber handle in O(1) time, to make routing incoming packets
     * (a hot code path) faster.
     */ this.subscriptionHandles = new Map();
        this.e2eeManager = (_a = options === null || options === void 0 ? void 0 : options.e2eeManager) !== null && _a !== void 0 ? _a : null;
    }
    /** @internal */ updateE2eeManager(e2eeManager) {
        this.e2eeManager = e2eeManager;
        // Propegate downwards to all pre-existing pipelines
        for (const descriptor of this.descriptors.values())if (descriptor.subscription.type === 'active') descriptor.subscription.pipeline.updateE2eeManager(e2eeManager);
    }
    /** Allocates a ReadableStream which emits when a new {@link DataTrackFrame} is received from the
   * SFU. The SFU subscription is initiated lazily when the stream is created.
   *
   * @returns A tuple of the ReadableStream and a Promise that resolves once the SFU subscription
   * is fully established / the stream is ready to receive frames.
   *
   * @internal
   **/ openSubscriptionStream(sid, signal) {
        let bufferSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $c0722d30b1d17141$var$READABLE_STREAM_DEFAULT_BUFFER_SIZE;
        let streamController = null;
        const sfuSubscriptionComplete = new $c0722d30b1d17141$var$Future();
        const detachSignal = ()=>{
            signal === null || signal === void 0 || signal.removeEventListener('abort', onAbort);
        };
        const cleanup = ()=>{
            detachSignal();
            if (!streamController) {
                $c0722d30b1d17141$var$log$1.warn("ReadableStream subscribed to ".concat(sid, " was not started."));
                return;
            }
            const descriptor = this.descriptors.get(sid);
            if (!descriptor) {
                $c0722d30b1d17141$var$log$1.warn("Unknown track ".concat(sid, ", skipping cancel..."));
                return;
            }
            if (descriptor.subscription.type !== 'active') {
                $c0722d30b1d17141$var$log$1.warn("Subscription for track ".concat(sid, " is not active, skipping cancel..."));
                return;
            }
            descriptor.subscription.streamControllers.delete(streamController);
            // If no active stream controllers are left, also unsubscribe on the SFU end.
            if (descriptor.subscription.streamControllers.size === 0) this.unSubscribeRequest(descriptor.info.sid);
        };
        const onAbort = ()=>{
            var _a;
            if (!streamController) return;
            const currentDescriptor = this.descriptors.get(sid);
            if ((currentDescriptor === null || currentDescriptor === void 0 ? void 0 : currentDescriptor.subscription.type) === 'active') currentDescriptor.subscription.streamControllers.delete(streamController);
            streamController.error($c0722d30b1d17141$var$DataTrackSubscribeError.cancelled());
            (_a = sfuSubscriptionComplete.reject) === null || _a === void 0 || _a.call(sfuSubscriptionComplete, $c0722d30b1d17141$var$DataTrackSubscribeError.cancelled());
            cleanup();
        };
        const stream = new ReadableStream({
            start: (controller)=>{
                streamController = controller;
                this.subscribeRequest(sid, signal).then(()=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                        var _a, _b, _c;
                        const descriptor = this.descriptors.get(sid);
                        if (!descriptor) {
                            $c0722d30b1d17141$var$log$1.error("Unknown track ".concat(sid));
                            const err = $c0722d30b1d17141$var$DataTrackSubscribeError.disconnected();
                            controller.error(err);
                            (_a = sfuSubscriptionComplete.reject) === null || _a === void 0 || _a.call(sfuSubscriptionComplete, err);
                            return;
                        }
                        if (descriptor.subscription.type !== 'active') {
                            $c0722d30b1d17141$var$log$1.error("Subscription for track ".concat(sid, " is not active"));
                            const err = $c0722d30b1d17141$var$DataTrackSubscribeError.disconnected();
                            controller.error(err);
                            (_b = sfuSubscriptionComplete.reject) === null || _b === void 0 || _b.call(sfuSubscriptionComplete, err);
                            return;
                        }
                        // Attach the abort signal, aborting immediately if the abort signal was fired while
                        // subscribeRequest was in flight.
                        if (signal === null || signal === void 0 ? void 0 : signal.aborted) {
                            onAbort();
                            return;
                        }
                        signal === null || signal === void 0 || signal.addEventListener('abort', onAbort);
                        descriptor.subscription.streamControllers.set(controller, detachSignal);
                        (_c = sfuSubscriptionComplete.resolve) === null || _c === void 0 || _c.call(sfuSubscriptionComplete);
                    })).catch((err)=>{
                    var _a;
                    // subscribeRequest rejected (cancelled, timed out, disconnected). The signal
                    // listener was never attached in this path, so nothing to detach.
                    controller.error(err);
                    (_a = sfuSubscriptionComplete.reject) === null || _a === void 0 || _a.call(sfuSubscriptionComplete, err);
                });
            },
            cancel: ()=>{
                cleanup();
            }
        }, new CountQueuingStrategy({
            highWaterMark: bufferSize
        }));
        return [
            stream,
            sfuSubscriptionComplete.promise
        ];
    }
    /** Client requested to subscribe to a data track.
   *
   * This is sent when the user calls {@link RemoteDataTrack.subscribe}.
   *
   * Only the first request to subscribe to a given track incurs meaningful overhead; subsequent
   * requests simply attach an additional receiver to the broadcast channel, allowing them to consume
   * frames from the existing subscription pipeline.
   */ subscribeRequest(sid, signal) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            const descriptor = this.descriptors.get(sid);
            if (!descriptor) // @throws-transformer ignore - this should be treated as a "panic" and not be caught
            throw new Error('Cannot subscribe to unknown track');
            const waitForCompletionFuture = (currentDescriptor, userProvidedSignal, timeoutSignal)=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                    if (currentDescriptor.subscription.type === 'active') // Subscription has already become active! So bail out early, there is nothing to wait for.
                    return;
                    if (currentDescriptor.subscription.type !== 'pending') // @throws-transformer ignore - this should be treated as a "panic" and not be caught
                    throw new Error("Descriptor for track ".concat(sid, " is not pending, found ").concat(currentDescriptor.subscription.type));
                    const combinedSignal = $c0722d30b1d17141$var$abortSignalAny([
                        userProvidedSignal,
                        timeoutSignal
                    ].filter((s)=>typeof s !== 'undefined'));
                    const proxiedCompletionFuture = new $c0722d30b1d17141$var$Future();
                    currentDescriptor.subscription.completionFuture.promise.then(()=>{
                        var _a;
                        return (_a = proxiedCompletionFuture.resolve) === null || _a === void 0 ? void 0 : _a.call(proxiedCompletionFuture);
                    }).catch((err)=>{
                        var _a;
                        return (_a = proxiedCompletionFuture.reject) === null || _a === void 0 ? void 0 : _a.call(proxiedCompletionFuture, err);
                    });
                    const onAbort = ()=>{
                        var _a;
                        if (currentDescriptor.subscription.type !== 'pending') return;
                        currentDescriptor.subscription.pendingRequestCount -= 1;
                        if (timeoutSignal === null || timeoutSignal === void 0 ? void 0 : timeoutSignal.aborted) {
                            // A timeout should apply to the underlying SFU subscription and cancel all user
                            // subscriptions.
                            currentDescriptor.subscription.cancel();
                            return;
                        }
                        if (currentDescriptor.subscription.pendingRequestCount <= 0) {
                            // No user subscriptions are still pending, so cancel the underlying pending `sfuUpdateSubscription`
                            currentDescriptor.subscription.cancel();
                            return;
                        }
                        // Other subscriptions are still pending for this data track, so just cancel this one
                        // active user subscription, and leave the rest of the user subscriptions alone.
                        (_a = proxiedCompletionFuture.reject) === null || _a === void 0 || _a.call(proxiedCompletionFuture, $c0722d30b1d17141$var$DataTrackSubscribeError.cancelled());
                    };
                    if (combinedSignal.aborted) onAbort();
                    combinedSignal.addEventListener('abort', onAbort);
                    yield proxiedCompletionFuture.promise;
                    combinedSignal.removeEventListener('abort', onAbort);
                });
            switch(descriptor.subscription.type){
                case 'none':
                    {
                        descriptor.subscription = {
                            type: 'pending',
                            completionFuture: new $c0722d30b1d17141$var$Future(),
                            pendingRequestCount: 1,
                            cancel: ()=>{
                                var _a, _b;
                                const previousDescriptorSubscription = descriptor.subscription;
                                descriptor.subscription = {
                                    type: 'none'
                                };
                                // Let the SFU know that the subscribe has been cancelled
                                this.emit('sfuUpdateSubscription', {
                                    sid: sid,
                                    subscribe: false
                                });
                                if (previousDescriptorSubscription.type === 'pending') (_b = (_a = previousDescriptorSubscription.completionFuture).reject) === null || _b === void 0 || _b.call(_a, timeoutSignal.aborted ? $c0722d30b1d17141$var$DataTrackSubscribeError.timeout() : // NOTE: the below cancelled case was introduced by web / there isn't a corresponding case in the rust version.
                                $c0722d30b1d17141$var$DataTrackSubscribeError.cancelled());
                            }
                        };
                        this.emit('sfuUpdateSubscription', {
                            sid: sid,
                            subscribe: true
                        });
                        const timeoutSignal = $c0722d30b1d17141$var$abortSignalTimeout($c0722d30b1d17141$var$SUBSCRIBE_TIMEOUT_MILLISECONDS);
                        // Wait for the subscription to complete, or time out if it takes too long
                        yield waitForCompletionFuture(descriptor, signal, timeoutSignal);
                        return;
                    }
                case 'pending':
                    descriptor.subscription.pendingRequestCount += 1;
                    // Wait for the subscription to complete
                    yield waitForCompletionFuture(descriptor, signal);
                    return;
                case 'active':
                    return;
            }
        });
    }
    /**
   * Get information about all currently subscribed tracks.
   * @internal */ querySubscribed() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            const descriptorInfos = Array.from(this.descriptors.values()).filter((descriptor)=>descriptor.subscription.type === 'active').map((descriptor)=>[
                    descriptor.info,
                    descriptor.publisherIdentity
                ]);
            return descriptorInfos;
        });
    }
    /** Client requested to unsubscribe from a data track. */ unSubscribeRequest(sid) {
        var _a;
        const descriptor = this.descriptors.get(sid);
        if (!descriptor) // FIXME: rust implementation returns here, not throws
        // @throws-transformer ignore - this should be treated as a "panic" and not be caught
        throw new Error('Cannot subscribe to unknown track');
        if (descriptor.subscription.type !== 'active') {
            $c0722d30b1d17141$var$log$1.warn("Unexpected descriptor state in unSubscribeRequest, expected active, found ".concat((_a = descriptor.subscription) === null || _a === void 0 ? void 0 : _a.type));
            return;
        }
        this.closeStreamControllers(descriptor.subscription.streamControllers, sid);
        // FIXME: this might be wrong? Shouldn't this only occur if it is the last subscription to
        // terminate?
        const previousDescriptorSubscription = descriptor.subscription;
        descriptor.subscription = {
            type: 'none'
        };
        this.subscriptionHandles.delete(previousDescriptorSubscription.subcriptionHandle);
        this.emit('sfuUpdateSubscription', {
            sid: sid,
            subscribe: false
        });
    }
    /** Detach abort-signal listeners and close all downstream stream controllers for an active
   * subscription. Used when the subscription is being torn down by the manager (unsubscribe,
   * unpublish, or shutdown). */ closeStreamControllers(streamControllers, sid) {
        for (const [controller, detachSignal] of streamControllers){
            // Detach before close so we don't leak a listener on the user's AbortSignal.
            detachSignal();
            try {
                controller.close();
            } catch (err) {
                // Defensive: if the controller has already been errored (e.g. by a racing abort whose
                // listener removed itself before we got here), close() throws. There's nothing
                // meaningful to do other than log — the stream is already terminal.
                $c0722d30b1d17141$var$log$1.warn("Failed to close readable stream for track ".concat(sid, ": ").concat(err));
            }
        }
    }
    /** SFU notification that track publications have changed.
   *
   * This event is produced from both {@link JoinResponse} and {@link ParticipantUpdate}
   * to provide a complete view of remote participants' track publications:
   *
   * - From a `JoinResponse`, it captures the initial set of tracks published when a participant joins.
   * - From a `ParticipantUpdate`, it captures subsequent changes (i.e., new tracks being
   *   published and existing tracks unpublished).
   */ receiveSfuPublicationUpdates(updates) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            if (updates.size === 0) return;
            // Detect published track
            const publisherParticipantToSidsInUpdate = new Map();
            for (const [publisherIdentity, infos] of updates.entries()){
                const sidsInUpdate = new Set();
                for (const info of infos){
                    sidsInUpdate.add(info.sid);
                    if (this.descriptors.has(info.sid)) continue;
                    yield this.handleTrackPublished(publisherIdentity, info);
                }
                publisherParticipantToSidsInUpdate.set(publisherIdentity, sidsInUpdate);
            }
            // Detect unpublished tracks
            for (const [publisherIdentity, sidsInUpdate] of publisherParticipantToSidsInUpdate.entries()){
                const descriptorsForPublisher = Array.from(this.descriptors.entries()).filter((_ref)=>{
                    let [_sid, descriptor] = _ref;
                    return descriptor.publisherIdentity === publisherIdentity;
                }).map((_ref2)=>{
                    let [sid] = _ref2;
                    return sid;
                });
                let unpublishedSids = descriptorsForPublisher.filter((sid)=>!sidsInUpdate.has(sid));
                for (const sid of unpublishedSids)this.handleTrackUnpublished(sid);
            }
        });
    }
    /**
   * Get information about all currently remotely published tracks which could be subscribed to.
   * @internal */ queryPublications() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            return Array.from(this.descriptors.values()).map((descriptor)=>descriptor.info);
        });
    }
    handleTrackPublished(publisherIdentity, info) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            if (this.descriptors.has(info.sid)) {
                $c0722d30b1d17141$var$log$1.error("Existing descriptor for track ".concat(info.sid));
                return;
            }
            let descriptor = {
                info: info,
                publisherIdentity: publisherIdentity,
                subscription: {
                    type: 'none'
                }
            };
            this.descriptors.set(descriptor.info.sid, descriptor);
            const track = new $c0722d30b1d17141$export$57384944deb33057(descriptor.info, this, {
                publisherIdentity: publisherIdentity
            });
            this.emit('trackPublished', {
                track: track
            });
        });
    }
    handleTrackUnpublished(sid) {
        const descriptor = this.descriptors.get(sid);
        if (!descriptor) {
            $c0722d30b1d17141$var$log$1.error("Unknown track ".concat(sid));
            return;
        }
        this.descriptors.delete(sid);
        if (descriptor.subscription.type === 'active') {
            this.closeStreamControllers(descriptor.subscription.streamControllers, sid);
            this.subscriptionHandles.delete(descriptor.subscription.subcriptionHandle);
        }
        this.emit('trackUnpublished', {
            sid: sid,
            publisherIdentity: descriptor.publisherIdentity
        });
    }
    /** SFU notification that handles have been assigned for requested subscriptions. */ receivedSfuSubscriberHandles(/** Mapping between track handles attached to incoming packets to the
   * track SIDs they belong to. */ mapping) {
        for (const [handle, sid] of mapping.entries())this.registerSubscriberHandle(handle, sid);
    }
    registerSubscriberHandle(assignedHandle, sid) {
        var _a, _b;
        const descriptor = this.descriptors.get(sid);
        if (!descriptor) {
            $c0722d30b1d17141$var$log$1.error("Unknown track ".concat(sid));
            return;
        }
        switch(descriptor.subscription.type){
            case 'none':
                // Handle assigned when there is no pending or active subscription is unexpected.
                $c0722d30b1d17141$var$log$1.warn("No subscription for ".concat(sid));
                return;
            case 'active':
                // Update handle for an active subscription. This can occur following a full reconnect.
                descriptor.subscription.subcriptionHandle = assignedHandle;
                this.subscriptionHandles.set(assignedHandle, sid);
                return;
            case 'pending':
                {
                    const pipeline = new $c0722d30b1d17141$var$IncomingDataTrackPipeline({
                        info: descriptor.info,
                        publisherIdentity: descriptor.publisherIdentity,
                        e2eeManager: this.e2eeManager
                    });
                    const previousDescriptorSubscription = descriptor.subscription;
                    descriptor.subscription = {
                        type: 'active',
                        subcriptionHandle: assignedHandle,
                        pipeline: pipeline,
                        streamControllers: new Map()
                    };
                    this.subscriptionHandles.set(assignedHandle, sid);
                    (_b = (_a = previousDescriptorSubscription.completionFuture).resolve) === null || _b === void 0 || _b.call(_a);
                }
        }
    }
    /** Packet has been received over the transport. */ packetReceived(bytes) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            let packet;
            try {
                [packet] = $c0722d30b1d17141$export$15123dfe1dd5ee93.fromBinary(bytes);
            } catch (err) {
                $c0722d30b1d17141$var$log$1.error("Failed to deserialize packet: ".concat(err));
                return;
            }
            const sid = this.subscriptionHandles.get(packet.header.trackHandle);
            if (!sid) {
                $c0722d30b1d17141$var$log$1.warn("Unknown subscriber handle ".concat(packet.header.trackHandle));
                return;
            }
            const descriptor = this.descriptors.get(sid);
            if (!descriptor) {
                $c0722d30b1d17141$var$log$1.error("Missing descriptor for track ".concat(sid));
                return;
            }
            if (descriptor.subscription.type !== 'active') {
                $c0722d30b1d17141$var$log$1.warn("Received packet for track ".concat(sid, " without active subscription"));
                return;
            }
            const internalFrame = yield descriptor.subscription.pipeline.processPacket(packet);
            if (!internalFrame) // Not all packets have been received yet to form a complete frame
            return;
            // Broadcast to all downstream subscribers
            for (const controller of descriptor.subscription.streamControllers.keys()){
                if (controller.desiredSize !== null && controller.desiredSize <= 0) {
                    $c0722d30b1d17141$var$log$1.warn("Cannot send frame to subscribers: readable stream is full (desiredSize is ".concat(controller.desiredSize, "). To increase this threshold, set a higher 'options.highWaterMark' when calling .subscribe()."));
                    continue;
                }
                const frame = $c0722d30b1d17141$var$DataTrackFrameInternal.lossyIntoFrame(internalFrame);
                controller.enqueue(frame);
            }
        });
    }
    /** Resend all subscription updates.
   *
   * This must be sent after a full reconnect to ensure the SFU knows which
   * tracks are subscribed to locally.
   */ resendSubscriptionUpdates() {
        for (const [sid, descriptor] of this.descriptors){
            if (descriptor.subscription.type === 'none') continue;
            this.emit('sfuUpdateSubscription', {
                sid: sid,
                subscribe: true
            });
        }
    }
    /** Called when a remote participant is disconnected so that any pending data tracks can be
   * cancelled. */ handleRemoteParticipantDisconnected(remoteParticipantIdentity) {
        var _a, _b;
        for (const descriptor of this.descriptors.values()){
            if (descriptor.publisherIdentity !== remoteParticipantIdentity) continue;
            switch(descriptor.subscription.type){
                case 'none':
                    break;
                case 'pending':
                    (_b = (_a = descriptor.subscription.completionFuture).reject) === null || _b === void 0 || _b.call(_a, $c0722d30b1d17141$var$DataTrackSubscribeError.disconnected());
                    break;
                case 'active':
                    this.unSubscribeRequest(descriptor.info.sid);
                    break;
            }
        }
    }
    /** Resets the manager, ending any subscriptions, and getting it ready for the next room
   * connection.  */ reset() {
        var _a, _b;
        for (const descriptor of this.descriptors.values()){
            this.emit('trackUnpublished', {
                sid: descriptor.info.sid,
                publisherIdentity: descriptor.publisherIdentity
            });
            if (descriptor.subscription.type === 'pending') (_b = (_a = descriptor.subscription.completionFuture).reject) === null || _b === void 0 || _b.call(_a, $c0722d30b1d17141$var$DataTrackSubscribeError.disconnected());
            if (descriptor.subscription.type === 'active') this.closeStreamControllers(descriptor.subscription.streamControllers, descriptor.info.sid);
        }
        this.descriptors.clear();
        this.subscriptionHandles.clear();
    }
}
class $c0722d30b1d17141$var$DataTrackPacketizerError extends $c0722d30b1d17141$export$af3f20dcdd5a185f {
    constructor(message, reason, options){
        super(19, message, options);
        this.name = 'DataTrackPacketizerError';
        this.reason = reason;
        this.reasonName = $c0722d30b1d17141$var$DataTrackPacketizerReason[reason];
    }
    static mtuTooShort() {
        return new $c0722d30b1d17141$var$DataTrackPacketizerError('MTU is too short to send frame', $c0722d30b1d17141$var$DataTrackPacketizerReason.MtuTooShort);
    }
}
var $c0722d30b1d17141$var$DataTrackPacketizerReason;
(function(DataTrackPacketizerReason) {
    DataTrackPacketizerReason[DataTrackPacketizerReason["MtuTooShort"] = 0] = "MtuTooShort";
})($c0722d30b1d17141$var$DataTrackPacketizerReason || ($c0722d30b1d17141$var$DataTrackPacketizerReason = {}));
/** A packetizer takes a {@link DataTrackFrameInternal} as input and generates a series
 * of {@link DataTrackPacket}s for transmission to other clients over webrtc. */ class $c0722d30b1d17141$var$DataTrackPacketizer {
    constructor(trackHandle, mtuSizeBytes){
        this.sequence = $c0722d30b1d17141$var$WrapAroundUnsignedInt.u16(0);
        this.frameNumber = $c0722d30b1d17141$var$WrapAroundUnsignedInt.u16(0);
        this.clock = $c0722d30b1d17141$var$DataTrackClock.rtpStartingNow($c0722d30b1d17141$var$DataTrackTimestamp.rtpRandom());
        this.handle = trackHandle;
        this.mtuSizeBytes = mtuSizeBytes;
    }
    /** @internal */ static computeFrameMarker(index, packetCount) {
        if (packetCount <= 1) return $c0722d30b1d17141$var$FrameMarker.Single;
        if (index === 0) return $c0722d30b1d17141$var$FrameMarker.Start;
        else if (index === packetCount - 1) return $c0722d30b1d17141$var$FrameMarker.Final;
        else return $c0722d30b1d17141$var$FrameMarker.Inter;
    }
    /** Generates a series of packets for the specified {@link DataTrackFrameInternal}.
   *
   * NOTE: The return value of this function is a generator, so it can be lazily ran if desired,
   * or converted to an array with {@link Array.from}.
   */ *packetize(frame, options) {
        var _a;
        const frameNumber = this.frameNumber.getThenIncrement();
        const headerParams = {
            marker: $c0722d30b1d17141$var$FrameMarker.Inter,
            trackHandle: this.handle,
            sequence: $c0722d30b1d17141$var$WrapAroundUnsignedInt.u16(0),
            frameNumber: frameNumber,
            timestamp: (_a = options === null || options === void 0 ? void 0 : options.now) !== null && _a !== void 0 ? _a : this.clock.now(),
            extensions: frame.extensions
        };
        const headerSerializedLengthBytes = new $c0722d30b1d17141$var$DataTrackPacketHeader(headerParams).toBinaryLengthBytes();
        if (headerSerializedLengthBytes >= this.mtuSizeBytes) throw $c0722d30b1d17141$var$DataTrackPacketizerError.mtuTooShort();
        const maxPayloadSizeBytes = this.mtuSizeBytes - headerSerializedLengthBytes;
        const packetCount = Math.ceil(frame.payload.byteLength / maxPayloadSizeBytes);
        for(let index = 0, indexBytes = 0; indexBytes < frame.payload.byteLength; [index, indexBytes] = [
            index + 1,
            indexBytes + maxPayloadSizeBytes
        ]){
            const sequence = this.sequence.getThenIncrement();
            const packetHeader = new $c0722d30b1d17141$var$DataTrackPacketHeader(Object.assign(Object.assign({}, headerParams), {
                marker: $c0722d30b1d17141$var$DataTrackPacketizer.computeFrameMarker(index, packetCount),
                sequence: sequence
            }));
            const packetPayloadLengthBytes = Math.min(// All but the last packet will be max length ...
            maxPayloadSizeBytes, // ... and the last packet will be as long as it needs to be to finish out the buffer.
            frame.payload.byteLength - indexBytes);
            const packetPayload = new Uint8Array(frame.payload.buffer, frame.payload.byteOffset + indexBytes, packetPayloadLengthBytes);
            yield new $c0722d30b1d17141$export$15123dfe1dd5ee93(packetHeader, packetPayload);
        }
    }
}
var $c0722d30b1d17141$var$DataTrackPublishErrorReason;
(function(DataTrackPublishErrorReason) {
    /**
   * Local participant does not have permission to publish data tracks.
   *
   * Ensure the participant's token contains the `canPublishData` grant.
   */ DataTrackPublishErrorReason[DataTrackPublishErrorReason["NotAllowed"] = 0] = "NotAllowed";
    /** A track with the same name is already published by the local participant. */ DataTrackPublishErrorReason[DataTrackPublishErrorReason["DuplicateName"] = 1] = "DuplicateName";
    /** Request to publish the track took long to complete. */ DataTrackPublishErrorReason[DataTrackPublishErrorReason["Timeout"] = 2] = "Timeout";
    /** No additional data tracks can be published by the local participant. */ DataTrackPublishErrorReason[DataTrackPublishErrorReason["LimitReached"] = 3] = "LimitReached";
    /** Cannot publish data track when the room is disconnected. */ DataTrackPublishErrorReason[DataTrackPublishErrorReason["Disconnected"] = 4] = "Disconnected";
    // NOTE: this was introduced by web / there isn't a corresponding case in the rust version.
    DataTrackPublishErrorReason[DataTrackPublishErrorReason["Cancelled"] = 5] = "Cancelled";
    /** The name requested is not able to be used when creating the data track. */ DataTrackPublishErrorReason[DataTrackPublishErrorReason["InvalidName"] = 6] = "InvalidName";
    /** There was an error publishing, but it was not something that could be sorted into a known
   * category. */ DataTrackPublishErrorReason[DataTrackPublishErrorReason["Unknown"] = 7] = "Unknown";
})($c0722d30b1d17141$var$DataTrackPublishErrorReason || ($c0722d30b1d17141$var$DataTrackPublishErrorReason = {}));
class $c0722d30b1d17141$var$DataTrackPublishError extends $c0722d30b1d17141$export$af3f20dcdd5a185f {
    constructor(message, reason, options){
        super(21, message, options);
        this.name = 'DataTrackPublishError';
        this.reason = reason;
        this.reasonName = $c0722d30b1d17141$var$DataTrackPublishErrorReason[reason];
        this.rawMessage = options === null || options === void 0 ? void 0 : options.rawMessage;
    }
    static notAllowed(rawMessage) {
        return new $c0722d30b1d17141$var$DataTrackPublishError('Data track publishing unauthorized', $c0722d30b1d17141$var$DataTrackPublishErrorReason.NotAllowed, {
            rawMessage: rawMessage
        });
    }
    static duplicateName(rawMessage) {
        return new $c0722d30b1d17141$var$DataTrackPublishError('Track name already taken', $c0722d30b1d17141$var$DataTrackPublishErrorReason.DuplicateName, {
            rawMessage: rawMessage
        });
    }
    static invalidName(rawMessage) {
        return new $c0722d30b1d17141$var$DataTrackPublishError('Track name is invalid', $c0722d30b1d17141$var$DataTrackPublishErrorReason.InvalidName, {
            rawMessage: rawMessage
        });
    }
    static timeout() {
        return new $c0722d30b1d17141$var$DataTrackPublishError('Publish data track timed-out. Does the LiveKit server support data tracks?', $c0722d30b1d17141$var$DataTrackPublishErrorReason.Timeout);
    }
    static limitReached(rawMessage) {
        return new $c0722d30b1d17141$var$DataTrackPublishError('Data track publication limit reached', $c0722d30b1d17141$var$DataTrackPublishErrorReason.LimitReached, {
            rawMessage: rawMessage
        });
    }
    static unknown(reason, message) {
        return new $c0722d30b1d17141$var$DataTrackPublishError("Received RequestResponse for publishDataTrack, but reason was unrecognised (".concat(reason, ", ").concat(message, ")"), $c0722d30b1d17141$var$DataTrackPublishErrorReason.Unknown);
    }
    static disconnected() {
        return new $c0722d30b1d17141$var$DataTrackPublishError('Room disconnected', $c0722d30b1d17141$var$DataTrackPublishErrorReason.Disconnected);
    }
    // NOTE: this was introduced by web / there isn't a corresponding case in the rust version.
    static cancelled() {
        return new $c0722d30b1d17141$var$DataTrackPublishError('Publish data track cancelled by caller', $c0722d30b1d17141$var$DataTrackPublishErrorReason.Cancelled);
    }
}
var $c0722d30b1d17141$var$DataTrackPushFrameErrorReason;
(function(DataTrackPushFrameErrorReason) {
    /** Track is no longer published. */ DataTrackPushFrameErrorReason[DataTrackPushFrameErrorReason["TrackUnpublished"] = 0] = "TrackUnpublished";
    /** Frame was dropped. */ // NOTE: this should become a web specific error, the rust version of this "dropped" error means
    // something different and will be renamed to "QueueFull".
    DataTrackPushFrameErrorReason[DataTrackPushFrameErrorReason["Dropped"] = 1] = "Dropped";
})($c0722d30b1d17141$var$DataTrackPushFrameErrorReason || ($c0722d30b1d17141$var$DataTrackPushFrameErrorReason = {}));
class $c0722d30b1d17141$var$DataTrackPushFrameError extends $c0722d30b1d17141$export$af3f20dcdd5a185f {
    constructor(message, reason, options){
        super(22, message, options);
        this.name = 'DataTrackPushFrameError';
        this.reason = reason;
        this.reasonName = $c0722d30b1d17141$var$DataTrackPushFrameErrorReason[reason];
    }
    static trackUnpublished() {
        return new $c0722d30b1d17141$var$DataTrackPushFrameError('Track is no longer published', $c0722d30b1d17141$var$DataTrackPushFrameErrorReason.TrackUnpublished);
    }
    static dropped(cause) {
        return new $c0722d30b1d17141$var$DataTrackPushFrameError('Frame was dropped', $c0722d30b1d17141$var$DataTrackPushFrameErrorReason.Dropped, {
            cause: cause
        });
    }
}
var $c0722d30b1d17141$var$DataTrackOutgoingPipelineErrorReason;
(function(DataTrackOutgoingPipelineErrorReason) {
    DataTrackOutgoingPipelineErrorReason[DataTrackOutgoingPipelineErrorReason["Packetizer"] = 0] = "Packetizer";
    DataTrackOutgoingPipelineErrorReason[DataTrackOutgoingPipelineErrorReason["Encryption"] = 1] = "Encryption";
})($c0722d30b1d17141$var$DataTrackOutgoingPipelineErrorReason || ($c0722d30b1d17141$var$DataTrackOutgoingPipelineErrorReason = {}));
class $c0722d30b1d17141$var$DataTrackOutgoingPipelineError extends $c0722d30b1d17141$export$af3f20dcdd5a185f {
    constructor(message, reason, options){
        super(21, message, options);
        this.name = 'DataTrackOutgoingPipelineError';
        this.reason = reason;
        this.reasonName = $c0722d30b1d17141$var$DataTrackOutgoingPipelineErrorReason[reason];
    }
    static packetizer(cause) {
        return new $c0722d30b1d17141$var$DataTrackOutgoingPipelineError('Error packetizing frame', $c0722d30b1d17141$var$DataTrackOutgoingPipelineErrorReason.Packetizer, {
            cause: cause
        });
    }
    static encryption(cause) {
        return new $c0722d30b1d17141$var$DataTrackOutgoingPipelineError('Error encrypting frame', $c0722d30b1d17141$var$DataTrackOutgoingPipelineErrorReason.Encryption, {
            cause: cause
        });
    }
}
class $c0722d30b1d17141$export$be72d99706596eb4 {
    /** @internal */ constructor(options, manager){
        this.trackSymbol = $c0722d30b1d17141$var$TrackSymbol;
        this.isLocal = true;
        this.typeSymbol = $c0722d30b1d17141$var$DataTrackSymbol;
        /** Represents the currently active {@link DataTrackHandle} for the publication. */ this.handle = null;
        this.log = $c0722d30b1d17141$var$livekitLogger;
        /** Resolves once the data track has sent all pending packets the rtc data channel buffer. */ this.flushedFuture = new $c0722d30b1d17141$var$Future();
        this.isFlushed = true;
        this.handleManagerReset = ()=>{
            var _a, _b;
            // When the associated manager resets, mark any in flight flushes as complete
            // There's nothing actionable a user can do to get these to complete so no
            // error is being thrown.
            (_b = (_a = this.flushedFuture).resolve) === null || _b === void 0 || _b.call(_a);
            this.manager.off('packetsFlushedChange', this.handleManagerPacketsFlushedChange);
            this.manager.off('reset', this.handleManagerReset);
        };
        this.handleManagerPacketsFlushedChange = (event)=>{
            var _a, _b;
            this.isFlushed = event.isFlushed;
            if (event.isFlushed) {
                (_b = (_a = this.flushedFuture).resolve) === null || _b === void 0 || _b.call(_a);
                this.flushedFuture = new $c0722d30b1d17141$var$Future();
            }
        };
        this.options = options;
        this.manager = manager;
        this.log = $c0722d30b1d17141$export$2b1d391cd05230fd($c0722d30b1d17141$export$69ba24dd79f4da21.DataTracks);
        this.manager.on('packetsFlushedChange', this.handleManagerPacketsFlushedChange);
        this.manager.on('reset', this.handleManagerReset);
    }
    /** @internal */ static withExplicitHandle(options, manager, handle) {
        const track = new $c0722d30b1d17141$export$be72d99706596eb4(options, manager);
        track.handle = handle;
        return track;
    }
    /** Metrics about the data track publication. */ get info() {
        const descriptor = this.descriptor;
        if ((descriptor === null || descriptor === void 0 ? void 0 : descriptor.type) === 'active') return descriptor.info;
        else return undefined;
    }
    /** The raw descriptor from the manager containing the internal state for this local track. */ get descriptor() {
        return this.handle ? this.manager.getDescriptor(this.handle) : null;
    }
    /**
   * Publish the track to the SFU. This must be done before calling {@link tryPush} for the first time.
   * @internal
   * */ publish(signal) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            try {
                this.handle = yield this.manager.publishRequest(this.options, signal);
            } catch (err) {
                // NOTE: Rethrow errors to break Throws<...> type boundary
                throw err;
            }
        });
    }
    isPublished() {
        var _a;
        // NOTE: a track which is internally in the "resubscribing" state is still considered
        // published from the public API perspective.
        return ((_a = this.descriptor) === null || _a === void 0 ? void 0 : _a.type) === 'active' && this.descriptor.publishState !== 'unpublished';
    }
    /** Try pushing a frame to subscribers of the track.
   *
   * Pushing a frame can fail for several reasons:
   *
   * - The track has been unpublished by the local participant or SFU
   * - The room is no longer connected
   */ tryPush(frame) {
        if (!this.handle) throw $c0722d30b1d17141$var$DataTrackPushFrameError.trackUnpublished();
        const internalFrame = $c0722d30b1d17141$var$DataTrackFrameInternal.from(frame);
        try {
            return this.manager.tryProcessAndSend(this.handle, internalFrame);
        } catch (err) {
            // NOTE: wrapping in the bare try/catch like this means that the Throws<...> type doesn't
            // propagate upwards into the public interface.
            throw err;
        }
    }
    /**
   * When called, waits for all in flight packets to be sent before resolving.
   *
   * Use this to:
   *
   * 1. Send frames exactly in order:
   * ```ts
   * await track.tryPush(/* ... *\/);
   * await track.flush();
   * await track.tryPush(/* ... *\/);
   * await track.flush();
   * // ... etc ...
   * ```
   *
   * 2. Wait for frames to all be delivered before unpublishing a local data track:
   *
   * ```ts
   * await track.tryPush(/* ... *\/);
   * await track.tryPush(/* ... *\/);
   * await track.tryPush(/* ... *\/);
   * // ... etc ...
   * await track.flush();
   * await track.unpublish();
   * ```
   **/ flush() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            if (this.isFlushed) return;
            return this.flushedFuture.promise;
        });
    }
    /**
   * Unpublish the track from the SFU. Once this is called, any further calls to {@link tryPush}
   * will fail.
   * */ unpublish() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.handle) {
                $c0722d30b1d17141$var$livekitLogger.warn("Data track \"".concat(this.options.name, "\" is not published, so unpublishing has no effect."));
                return;
            }
            try {
                yield this.manager.unpublishRequest(this.handle);
            } catch (err) {
                // NOTE: Rethrow errors to break Throws<...> type boundary
                throw err;
            }
        });
    }
} /** Processes outgoing frames into final packets for distribution to the SFU. */ 
class $c0722d30b1d17141$var$DataTrackOutgoingPipeline {
    constructor(options){
        this.e2eeManager = options.e2eeManager;
        this.packetizer = new $c0722d30b1d17141$var$DataTrackPacketizer(options.info.pubHandle, $c0722d30b1d17141$var$DataTrackOutgoingPipeline.TRANSPORT_MTU_BYTES);
    }
    updateE2eeManager(e2eeManager) {
        this.e2eeManager = e2eeManager;
    }
    processFrame(frame) {
        return $c0722d30b1d17141$var$__asyncGenerator(this, arguments, function* processFrame_1() {
            const encryptedFrame = yield $c0722d30b1d17141$var$__await(this.encryptIfNeeded(frame));
            try {
                yield $c0722d30b1d17141$var$__await((yield* $c0722d30b1d17141$var$__asyncDelegator($c0722d30b1d17141$var$__asyncValues(this.packetizer.packetize(encryptedFrame)))));
            } catch (error) {
                if (error instanceof $c0722d30b1d17141$var$DataTrackPacketizerError) throw $c0722d30b1d17141$var$DataTrackOutgoingPipelineError.packetizer(error);
                throw error;
            }
        });
    }
    encryptIfNeeded(frame) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.e2eeManager) return frame;
            let encryptedResult;
            try {
                encryptedResult = yield this.e2eeManager.encryptData(frame.payload);
            } catch (err) {
                throw $c0722d30b1d17141$var$DataTrackOutgoingPipelineError.encryption(err);
            }
            frame.payload = encryptedResult.payload;
            frame.extensions.e2ee = new $c0722d30b1d17141$var$DataTrackE2eeExtension(encryptedResult.keyIndex, encryptedResult.iv);
            return frame;
        });
    }
}
/** Maximum transmission unit (MTU) of the transport. */ $c0722d30b1d17141$var$DataTrackOutgoingPipeline.TRANSPORT_MTU_BYTES = 16000;
const $c0722d30b1d17141$var$log = $c0722d30b1d17141$export$2b1d391cd05230fd($c0722d30b1d17141$export$69ba24dd79f4da21.DataTracks);
const $c0722d30b1d17141$var$Descriptor = {
    pending () {
        return {
            type: 'pending',
            completionFuture: new $c0722d30b1d17141$var$Future()
        };
    },
    active (info, e2eeManager) {
        return {
            type: 'active',
            info: info,
            publishState: 'published',
            pipeline: new $c0722d30b1d17141$var$DataTrackOutgoingPipeline({
                info: info,
                e2eeManager: e2eeManager
            }),
            unpublishingFuture: new $c0722d30b1d17141$var$Future()
        };
    }
};
/** How long to wait when attempting to publish before timing out. */ const $c0722d30b1d17141$var$PUBLISH_TIMEOUT_MILLISECONDS = 10000;
class $c0722d30b1d17141$var$OutgoingDataTrackManager extends $c0722d30b1d17141$var$eventsExports.EventEmitter {
    constructor(options){
        var _a;
        super();
        this.handleAllocator = new $c0722d30b1d17141$var$DataTrackHandleAllocator();
        this.descriptors = new Map();
        /** Number of packets for each data track which have been emitted via the `packetAvailable` event
     * and which have not yet been sent via the rtc data channel yet. Once this goes to 0, then
     * all in flight packets have been delivered, and the data tracks is "flushed". */ this.inFlightPacketCounter = new Map();
        this.e2eeManager = (_a = options === null || options === void 0 ? void 0 : options.e2eeManager) !== null && _a !== void 0 ? _a : null;
    }
    static withDescriptors(descriptors) {
        const manager = new $c0722d30b1d17141$var$OutgoingDataTrackManager();
        manager.descriptors = descriptors;
        return manager;
    }
    /** @internal */ updateE2eeManager(e2eeManager) {
        this.e2eeManager = e2eeManager;
        // Propegate downwards to all pre-existing pipelines
        for (const descriptor of this.descriptors.values())if (descriptor.type === 'active') descriptor.pipeline.updateE2eeManager(e2eeManager);
    }
    /**
   * Used by attached {@link LocalDataTrack} instances to query their associated descriptor info.
   * @internal
   */ getDescriptor(handle) {
        var _a;
        return (_a = this.descriptors.get(handle)) !== null && _a !== void 0 ? _a : null;
    }
    /** Used by attached {@link LocalDataTrack} instances to broadcast data track packets to other
   * subscribers.
   * @internal
   */ tryProcessAndSend(handle, frame) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a, e_1, _b, _c;
            var _d;
            const descriptor = this.getDescriptor(handle);
            if ((descriptor === null || descriptor === void 0 ? void 0 : descriptor.type) !== 'active') throw $c0722d30b1d17141$var$DataTrackPushFrameError.trackUnpublished();
            if (descriptor.publishState === 'unpublished') throw $c0722d30b1d17141$var$DataTrackPushFrameError.trackUnpublished();
            if (descriptor.publishState === 'republishing') throw $c0722d30b1d17141$var$DataTrackPushFrameError.dropped('Data track republishing');
            try {
                try {
                    for(var _e = true, _f = $c0722d30b1d17141$var$__asyncValues(descriptor.pipeline.processFrame(frame)), _g; _g = yield _f.next(), _a = _g.done, !_a; _e = true){
                        _c = _g.value;
                        _e = false;
                        const packet = _c;
                        const prev = (_d = this.inFlightPacketCounter.get(handle)) !== null && _d !== void 0 ? _d : 0;
                        this.inFlightPacketCounter.set(handle, prev + 1);
                        if (prev === 0) // A new packet has been sent, so there are now packets in the rtc data channel buffer for
                        // this data track frame
                        this.emit('packetsFlushedChange', {
                            handle: handle,
                            isFlushed: false
                        });
                        this.emit('packetAvailable', {
                            handle: handle,
                            bytes: packet.toBinary()
                        });
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (!_e && !_a && (_b = _f.return)) yield _b.call(_f);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
            } catch (err) {
                // NOTE: In the rust implementation this "dropped" error means something different (not enough room
                // in the track mpsc channel)
                throw $c0722d30b1d17141$var$DataTrackPushFrameError.dropped(err);
            }
        });
    }
    /** The client has sent a packet over the rtc data channel. This signal is used for determining
   * once all packets are sent and a data track has been "flushed".
   *
   * @internal */ handlePacketSendComplete(handle) {
        var _a;
        const prev = (_a = this.inFlightPacketCounter.get(handle)) !== null && _a !== void 0 ? _a : 0;
        let counter = prev - 1;
        if (counter < 0) {
            $c0722d30b1d17141$var$log.warn("OutgoingDataTrackManager.handlePacketSendComplete: inFlightPacketCounter was decremented below 0 (got ".concat(this.inFlightPacketCounter, " - resetting to 0. Were more packets send than were emitted?"));
            counter = 0;
        }
        this.inFlightPacketCounter.set(handle, counter);
        if (counter === 0) this.emit('packetsFlushedChange', {
            handle: handle,
            isFlushed: true
        });
    }
    /**
   * Client requested to publish a track.
   *
   * If the LiveKit server is too old and doesn't support data tracks, a
   * {@link DataTrackPublishError#timeout} will be thrown.
   *
   * @internal
   **/ publishRequest(options, signal) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            const handle = this.handleAllocator.get();
            if (!handle) throw $c0722d30b1d17141$var$DataTrackPublishError.limitReached();
            const timeoutSignal = $c0722d30b1d17141$var$abortSignalTimeout($c0722d30b1d17141$var$PUBLISH_TIMEOUT_MILLISECONDS);
            const combinedSignal = signal ? $c0722d30b1d17141$var$abortSignalAny([
                signal,
                timeoutSignal
            ]) : timeoutSignal;
            if (this.descriptors.has(handle)) // @throws-transformer ignore - this should be treated as a "panic" and not be caught
            throw new Error('Descriptor for handle already exists');
            const descriptor = $c0722d30b1d17141$var$Descriptor.pending();
            this.descriptors.set(handle, descriptor);
            const onAbort = ()=>{
                var _a, _b;
                const existingDescriptor = this.descriptors.get(handle);
                if (!existingDescriptor) {
                    $c0722d30b1d17141$var$log.warn("No descriptor for ".concat(handle));
                    return;
                }
                this.descriptors.delete(handle);
                // Let the SFU know that the publish has been cancelled
                this.emit('sfuUnpublishRequest', {
                    handle: handle
                });
                if (existingDescriptor.type === 'pending') (_b = (_a = existingDescriptor.completionFuture).reject) === null || _b === void 0 || _b.call(_a, timeoutSignal.aborted ? $c0722d30b1d17141$var$DataTrackPublishError.timeout() : // NOTE: the below cancelled case was introduced by web / there isn't a corresponding case in the rust version.
                $c0722d30b1d17141$var$DataTrackPublishError.cancelled());
            };
            if (combinedSignal.aborted) {
                onAbort(); // NOTE: this rejects `completionFuture`; the next line just returns the rejection
                return descriptor.completionFuture.promise.then(()=>handle /* no-op, makes typescript happy */ );
            }
            combinedSignal.addEventListener('abort', onAbort);
            this.emit('sfuPublishRequest', {
                handle: handle,
                name: options.name,
                usesE2ee: this.e2eeManager !== null
            });
            yield descriptor.completionFuture.promise;
            combinedSignal.removeEventListener('abort', onAbort);
            this.emit('trackPublished', {
                track: $c0722d30b1d17141$export$be72d99706596eb4.withExplicitHandle(options, this, handle)
            });
            return handle;
        });
    }
    /**
   * Get information about all currently published tracks.
   * @internal
   **/ queryPublished() {
        const descriptorInfos = Array.from(this.descriptors.values()).filter((descriptor)=>descriptor.type === 'active').map((descriptor)=>descriptor.info);
        return descriptorInfos;
    }
    /**
   * Client request to unpublish a track.
   * @internal
   **/ unpublishRequest(handle) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            const descriptor = this.descriptors.get(handle);
            if (!descriptor) {
                $c0722d30b1d17141$var$log.warn("No descriptor for ".concat(handle));
                return;
            }
            if (descriptor.type !== 'active') {
                $c0722d30b1d17141$var$log.warn("Track ".concat(handle, " not active"));
                return;
            }
            this.emit('sfuUnpublishRequest', {
                handle: handle
            });
            yield descriptor.unpublishingFuture.promise;
            this.inFlightPacketCounter.delete(handle);
            this.emit('trackUnpublished', {
                sid: descriptor.info.sid
            });
        });
    }
    /**
   * SFU responded to a request to publish a data track.
   * @internal
   **/ receivedSfuPublishResponse(handle, result) {
        var _a, _b, _c, _d;
        const descriptor = this.descriptors.get(handle);
        if (!descriptor) {
            $c0722d30b1d17141$var$log.warn("No descriptor for ".concat(handle));
            return;
        }
        this.descriptors.delete(handle);
        switch(descriptor.type){
            case 'pending':
                if (result.type === 'ok') {
                    const info = result.data;
                    const e2eeManager = info.usesE2ee ? this.e2eeManager : null;
                    this.descriptors.set(info.pubHandle, $c0722d30b1d17141$var$Descriptor.active(info, e2eeManager));
                    (_b = (_a = descriptor.completionFuture).resolve) === null || _b === void 0 || _b.call(_a);
                } else (_d = (_c = descriptor.completionFuture).reject) === null || _d === void 0 || _d.call(_c, result.error);
                return;
            case 'active':
                if (descriptor.publishState !== 'republishing') {
                    $c0722d30b1d17141$var$log.warn("Track ".concat(handle, " already active"));
                    return;
                }
                if (result.type === 'error') {
                    $c0722d30b1d17141$var$log.warn("Republish failed for track ".concat(handle));
                    return;
                }
                $c0722d30b1d17141$var$log.debug("Track ".concat(handle, " republished"));
                descriptor.info.sid = result.data.sid;
                descriptor.publishState = 'published';
                this.descriptors.set(descriptor.info.pubHandle, descriptor);
        }
    }
    /**
   * SFU notification that a track has been unpublished.
   * @internal
   **/ receivedSfuUnpublishResponse(handle) {
        var _a, _b;
        const descriptor = this.descriptors.get(handle);
        if (!descriptor) {
            $c0722d30b1d17141$var$log.warn("No descriptor for ".concat(handle));
            return;
        }
        this.descriptors.delete(handle);
        if (descriptor.type !== 'active') {
            $c0722d30b1d17141$var$log.warn("Track ".concat(handle, " not active"));
            return;
        }
        descriptor.publishState = 'unpublished';
        (_b = (_a = descriptor.unpublishingFuture).resolve) === null || _b === void 0 || _b.call(_a);
    }
    /** Republish all tracks.
   *
   * This must be sent after a full reconnect in order for existing publications
   * to be recognized by the SFU. Each republished track will be assigned a new SID.
   * @internal
   */ sfuWillRepublishTracks() {
        var _a, _b;
        for (const [handle, descriptor] of this.descriptors.entries())switch(descriptor.type){
            case 'pending':
                // TODO: support republish for pending publications
                this.descriptors.delete(handle);
                (_b = (_a = descriptor.completionFuture).reject) === null || _b === void 0 || _b.call(_a, $c0722d30b1d17141$var$DataTrackPublishError.disconnected());
                break;
            case 'active':
                descriptor.publishState = 'republishing';
                this.emit('sfuPublishRequest', {
                    handle: descriptor.info.pubHandle,
                    name: descriptor.info.name,
                    usesE2ee: descriptor.info.usesE2ee
                });
        }
    }
    /**
   * Reset's the state of the manager and all associated tracks. Run on room disconnect to get
   * the manager ready for the next room connection.
   * @internal
   **/ reset() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d;
            this.handleAllocator.reset();
            for (const descriptor of this.descriptors.values())switch(descriptor.type){
                case 'pending':
                    (_b = (_a = descriptor.completionFuture).reject) === null || _b === void 0 || _b.call(_a, $c0722d30b1d17141$var$DataTrackPublishError.disconnected());
                    break;
                case 'active':
                    // Abandon any unpublishing descriptors that were in flight and assume they will get
                    // cleaned up automatically with the connection shutdown.
                    (_d = (_c = descriptor.unpublishingFuture).resolve) === null || _d === void 0 || _d.call(_c);
                    yield this.unpublishRequest(descriptor.info.pubHandle);
                    break;
            }
            this.descriptors.clear();
            this.inFlightPacketCounter.clear();
            this.emit('reset');
        });
    }
}
class $c0722d30b1d17141$export$e3d2a545a239ada4 extends $c0722d30b1d17141$export$13921ac0cc260818 {
    constructor(mediaTrack, sid, kind, receiver, loggerOptions){
        super(mediaTrack, kind, loggerOptions);
        this.sid = sid;
        this.receiver = receiver;
    }
    get isLocal() {
        return false;
    }
    /** @internal */ setMuted(muted) {
        if (this.isMuted !== muted) {
            this.isMuted = muted;
            this._mediaStreamTrack.enabled = !muted;
            this.emit(muted ? $c0722d30b1d17141$export$2c8510d737cc09da.Muted : $c0722d30b1d17141$export$2c8510d737cc09da.Unmuted, this);
        }
    }
    /** @internal */ setMediaStream(stream) {
        // this is needed to determine when the track is finished
        this.mediaStream = stream;
        const onRemoveTrack = (event)=>{
            if (event.track === this._mediaStreamTrack) {
                stream.removeEventListener('removetrack', onRemoveTrack);
                if (this.receiver && 'playoutDelayHint' in this.receiver) this.receiver.playoutDelayHint = undefined;
                this.receiver = undefined;
                this._currentBitrate = 0;
                this.emit($c0722d30b1d17141$export$2c8510d737cc09da.Ended, this);
            }
        };
        stream.addEventListener('removetrack', onRemoveTrack);
    }
    start() {
        this.startMonitor();
        // use `enabled` of track to enable re-use of transceiver
        super.enable();
    }
    stop() {
        this.stopMonitor();
        // use `enabled` of track to enable re-use of transceiver
        super.disable();
    }
    /**
   * Gets the RTCStatsReport for the RemoteTrack's underlying RTCRtpReceiver
   * See https://developer.mozilla.org/en-US/docs/Web/API/RTCStatsReport
   *
   * @returns Promise<RTCStatsReport> | undefined
   */ getRTCStatsReport() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            if (!((_a = this.receiver) === null || _a === void 0 ? void 0 : _a.getStats)) return;
            const statsReport = yield this.receiver.getStats();
            return statsReport;
        });
    }
    /**
   * Allows to set a playout delay (in seconds) for this track.
   * A higher value allows for more buffering of the track in the browser
   * and will result in a delay of media being played back of `delayInSeconds`
   */ setPlayoutDelay(delayInSeconds) {
        if (this.receiver) {
            if ('playoutDelayHint' in this.receiver) this.receiver.playoutDelayHint = delayInSeconds;
            else this.log.warn('Playout delay not supported in this browser');
        } else this.log.warn('Cannot set playout delay, track already ended');
    }
    /**
   * Returns the current playout delay (in seconds) of this track.
   */ getPlayoutDelay() {
        if (this.receiver) {
            if ('playoutDelayHint' in this.receiver) return this.receiver.playoutDelayHint;
            else this.log.warn('Playout delay not supported in this browser');
        } else this.log.warn('Cannot get playout delay, track already ended');
        return 0;
    }
    /* @internal */ startMonitor() {
        if (!this.monitorInterval) this.monitorInterval = setInterval(()=>this.monitorReceiver(), $c0722d30b1d17141$var$monitorFrequency);
        if ($c0722d30b1d17141$var$supportsSynchronizationSources()) this.registerTimeSyncUpdate();
    }
    registerTimeSyncUpdate() {
        const loop = ()=>{
            var _a;
            this.timeSyncHandle = requestAnimationFrame(()=>loop());
            const sources = (_a = this.receiver) === null || _a === void 0 ? void 0 : _a.getSynchronizationSources()[0];
            if (sources) {
                const { timestamp: timestamp, rtpTimestamp: rtpTimestamp } = sources;
                if (rtpTimestamp && this.rtpTimestamp !== rtpTimestamp) {
                    this.emit($c0722d30b1d17141$export$2c8510d737cc09da.TimeSyncUpdate, {
                        timestamp: timestamp,
                        rtpTimestamp: rtpTimestamp
                    });
                    this.rtpTimestamp = rtpTimestamp;
                }
            }
        };
        loop();
    }
}
class $c0722d30b1d17141$export$fd37b116bd840ced extends $c0722d30b1d17141$export$e3d2a545a239ada4 {
    constructor(mediaTrack, sid, receiver, audioContext, audioOutput, loggerOptions){
        super(mediaTrack, sid, $c0722d30b1d17141$export$13921ac0cc260818.Kind.Audio, receiver, loggerOptions);
        this.monitorReceiver = ()=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                if (!this.receiver) {
                    this._currentBitrate = 0;
                    return;
                }
                const stats = yield this.getReceiverStats();
                if (stats && this.prevStats && this.receiver) this._currentBitrate = $c0722d30b1d17141$var$computeBitrate(stats, this.prevStats);
                this.prevStats = stats;
            });
        this.audioContext = audioContext;
        this.webAudioPluginNodes = [];
        if (audioOutput) this.sinkId = audioOutput.deviceId;
    }
    /**
   * sets the volume for all attached audio elements
   */ setVolume(volume) {
        var _a;
        for (const el of this.attachedElements)if (this.audioContext) (_a = this.gainNode) === null || _a === void 0 || _a.gain.setTargetAtTime(volume, 0, 0.1);
        else el.volume = volume;
        if ($c0722d30b1d17141$var$isReactNative()) // @ts-ignore
        this._mediaStreamTrack._setVolume(volume);
        this.elementVolume = volume;
    }
    /**
   * gets the volume of attached audio elements (loudest)
   */ getVolume() {
        if (this.elementVolume) return this.elementVolume;
        if ($c0722d30b1d17141$var$isReactNative()) // RN volume value defaults to 1.0 if hasn't been changed.
        return 1.0;
        let highestVolume = 0;
        this.attachedElements.forEach((element)=>{
            if (element.volume > highestVolume) highestVolume = element.volume;
        });
        return highestVolume;
    }
    /**
   * calls setSinkId on all attached elements, if supported
   * @param deviceId audio output device
   */ setSinkId(deviceId) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            this.sinkId = deviceId;
            yield Promise.all(this.attachedElements.map((elm)=>{
                if (!$c0722d30b1d17141$var$supportsSetSinkId(elm)) return;
                /* @ts-ignore */ return elm.setSinkId(deviceId);
            }));
        });
    }
    attach(element) {
        const needsNewWebAudioConnection = this.attachedElements.length === 0;
        if (!element) element = super.attach();
        else super.attach(element);
        if (this.sinkId && $c0722d30b1d17141$var$supportsSetSinkId(element)) element.setSinkId(this.sinkId).catch((e)=>{
            this.log.error('Failed to set sink id on remote audio track', e, this.logContext);
        });
        if (this.audioContext && needsNewWebAudioConnection) {
            this.log.debug('using audio context mapping', this.logContext);
            this.connectWebAudio(this.audioContext, element);
            element.volume = 0;
            element.muted = true;
        }
        if (this.elementVolume) // make sure volume setting is being applied to the newly attached element
        this.setVolume(this.elementVolume);
        return element;
    }
    detach(element) {
        let detached;
        if (!element) {
            detached = super.detach();
            this.disconnectWebAudio();
        } else {
            detached = super.detach(element);
            // if there are still any attached elements after detaching, connect webaudio to the first element that's left
            // disconnect webaudio otherwise
            if (this.audioContext) {
                if (this.attachedElements.length > 0) this.connectWebAudio(this.audioContext, this.attachedElements[0]);
                else this.disconnectWebAudio();
            }
        }
        return detached;
    }
    /**
   * @internal
   * @experimental
   */ setAudioContext(audioContext) {
        this.audioContext = audioContext;
        if (audioContext && this.attachedElements.length > 0) this.connectWebAudio(audioContext, this.attachedElements[0]);
        else if (!audioContext) this.disconnectWebAudio();
    }
    /**
   * @internal
   * @experimental
   * @param {AudioNode[]} nodes - An array of WebAudio nodes. These nodes should not be connected to each other when passed, as the sdk will take care of connecting them in the order of the array.
   */ setWebAudioPlugins(nodes) {
        this.webAudioPluginNodes = nodes;
        if (this.attachedElements.length > 0 && this.audioContext) this.connectWebAudio(this.audioContext, this.attachedElements[0]);
    }
    connectWebAudio(context, element) {
        this.disconnectWebAudio();
        // @ts-ignore attached elements always have a srcObject set
        this.sourceNode = context.createMediaStreamSource(element.srcObject);
        let lastNode = this.sourceNode;
        this.webAudioPluginNodes.forEach((node)=>{
            lastNode.connect(node);
            lastNode = node;
        });
        this.gainNode = context.createGain();
        lastNode.connect(this.gainNode);
        this.gainNode.connect(context.destination);
        if (this.elementVolume) this.gainNode.gain.setTargetAtTime(this.elementVolume, 0, 0.1);
        // try to resume the context if it isn't running already
        if (context.state !== 'running') context.resume().then(()=>{
            if (context.state !== 'running') this.emit($c0722d30b1d17141$export$2c8510d737cc09da.AudioPlaybackFailed, new Error("Audio Context couldn't be started automatically"));
        }).catch((e)=>{
            this.emit($c0722d30b1d17141$export$2c8510d737cc09da.AudioPlaybackFailed, e);
        });
    }
    disconnectWebAudio() {
        var _a, _b;
        (_a = this.gainNode) === null || _a === void 0 || _a.disconnect();
        (_b = this.sourceNode) === null || _b === void 0 || _b.disconnect();
        this.gainNode = undefined;
        this.sourceNode = undefined;
    }
    getReceiverStats() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.receiver || !this.receiver.getStats) return;
            const stats = yield this.receiver.getStats();
            let receiverStats;
            stats.forEach((v)=>{
                if (v.type === 'inbound-rtp') receiverStats = {
                    type: 'audio',
                    streamId: v.id,
                    timestamp: v.timestamp,
                    jitter: v.jitter,
                    bytesReceived: v.bytesReceived,
                    concealedSamples: v.concealedSamples,
                    concealmentEvents: v.concealmentEvents,
                    silentConcealedSamples: v.silentConcealedSamples,
                    silentConcealmentEvents: v.silentConcealmentEvents,
                    totalAudioEnergy: v.totalAudioEnergy,
                    totalSamplesDuration: v.totalSamplesDuration
                };
            });
            return receiverStats;
        });
    }
}
const $c0722d30b1d17141$var$REACTION_DELAY = 100;
class $c0722d30b1d17141$export$1db0c0ebd3ae1523 extends $c0722d30b1d17141$export$e3d2a545a239ada4 {
    constructor(mediaTrack, sid, receiver, adaptiveStreamSettings, loggerOptions){
        super(mediaTrack, sid, $c0722d30b1d17141$export$13921ac0cc260818.Kind.Video, receiver, loggerOptions);
        this.elementInfos = [];
        this.monitorReceiver = ()=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                if (!this.receiver) {
                    this._currentBitrate = 0;
                    return;
                }
                const stats = yield this.getReceiverStats();
                if (stats && this.prevStats && this.receiver) this._currentBitrate = $c0722d30b1d17141$var$computeBitrate(stats, this.prevStats);
                this.prevStats = stats;
            });
        this.debouncedHandleResize = $c0722d30b1d17141$var$debounce(()=>{
            this.updateDimensions();
        }, $c0722d30b1d17141$var$REACTION_DELAY);
        this.adaptiveStreamSettings = adaptiveStreamSettings;
    }
    get isAdaptiveStream() {
        return this.adaptiveStreamSettings !== undefined;
    }
    setStreamState(value) {
        super.setStreamState(value);
        this.log.debug('setStreamState', value);
        if (this.isAdaptiveStream && value === $c0722d30b1d17141$export$13921ac0cc260818.StreamState.Active) // update visibility for adaptive stream tracks when stream state received from server is active
        // this is needed to ensure the track is stopped when there's no element attached to it at all
        this.updateVisibility();
    }
    /**
   * Note: When using adaptiveStream, you need to use remoteVideoTrack.attach() to add the track to a HTMLVideoElement, otherwise your video tracks might never start
   */ get mediaStreamTrack() {
        return this._mediaStreamTrack;
    }
    /** @internal */ setMuted(muted) {
        super.setMuted(muted);
        this.attachedElements.forEach((element)=>{
            // detach or attach
            if (muted) $c0722d30b1d17141$export$8ea68c6294970fa5(this._mediaStreamTrack, element);
            else $c0722d30b1d17141$export$b8f95ef2322890b8(this._mediaStreamTrack, element);
        });
    }
    attach(element) {
        if (!element) element = super.attach();
        else super.attach(element);
        // It's possible attach is called multiple times on an element. When that's
        // the case, we'd want to avoid adding duplicate elementInfos
        if (this.adaptiveStreamSettings && this.elementInfos.find((info)=>info.element === element) === undefined) {
            const elementInfo = new $c0722d30b1d17141$var$HTMLElementInfo(element);
            this.observeElementInfo(elementInfo);
        }
        return element;
    }
    /**
   * Observe an ElementInfo for changes when adaptive streaming.
   * @param elementInfo
   * @internal
   */ observeElementInfo(elementInfo) {
        if (this.adaptiveStreamSettings && this.elementInfos.find((info)=>info === elementInfo) === undefined) {
            elementInfo.handleResize = ()=>{
                this.debouncedHandleResize();
            };
            elementInfo.handleVisibilityChanged = ()=>{
                this.updateVisibility();
            };
            this.elementInfos.push(elementInfo);
            elementInfo.observe();
            // trigger the first resize update cycle
            // if the tab is backgrounded, the initial resize event does not fire until
            // the tab comes into focus for the first time.
            this.debouncedHandleResize();
            this.updateVisibility();
        } else this.log.warn('visibility resize observer not triggered', this.logContext);
    }
    /**
   * Stop observing an ElementInfo for changes.
   * @param elementInfo
   * @internal
   */ stopObservingElementInfo(elementInfo) {
        if (!this.isAdaptiveStream) {
            this.log.warn('stopObservingElementInfo ignored', this.logContext);
            return;
        }
        const stopElementInfos = this.elementInfos.filter((info)=>info === elementInfo);
        for (const info of stopElementInfos)info.stopObserving();
        this.elementInfos = this.elementInfos.filter((info)=>info !== elementInfo);
        this.updateVisibility();
        this.debouncedHandleResize();
    }
    detach(element) {
        let detachedElements = [];
        if (element) {
            this.stopObservingElement(element);
            return super.detach(element);
        }
        detachedElements = super.detach();
        for (const e of detachedElements)this.stopObservingElement(e);
        return detachedElements;
    }
    /** @internal */ getDecoderImplementation() {
        var _a;
        return (_a = this.prevStats) === null || _a === void 0 ? void 0 : _a.decoderImplementation;
    }
    getReceiverStats() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.receiver || !this.receiver.getStats) return;
            const stats = yield this.receiver.getStats();
            let receiverStats;
            let codecID = '';
            let codecs = new Map();
            stats.forEach((v)=>{
                if (v.type === 'inbound-rtp') {
                    codecID = v.codecId;
                    receiverStats = {
                        type: 'video',
                        streamId: v.id,
                        framesDecoded: v.framesDecoded,
                        framesDropped: v.framesDropped,
                        framesReceived: v.framesReceived,
                        packetsReceived: v.packetsReceived,
                        packetsLost: v.packetsLost,
                        frameWidth: v.frameWidth,
                        frameHeight: v.frameHeight,
                        pliCount: v.pliCount,
                        firCount: v.firCount,
                        nackCount: v.nackCount,
                        jitter: v.jitter,
                        timestamp: v.timestamp,
                        bytesReceived: v.bytesReceived,
                        decoderImplementation: v.decoderImplementation
                    };
                } else if (v.type === 'codec') codecs.set(v.id, v);
            });
            if (receiverStats && codecID !== '' && codecs.get(codecID)) receiverStats.mimeType = codecs.get(codecID).mimeType;
            return receiverStats;
        });
    }
    stopObservingElement(element) {
        const stopElementInfos = this.elementInfos.filter((info)=>info.element === element);
        for (const info of stopElementInfos)this.stopObservingElementInfo(info);
    }
    handleAppVisibilityChanged() {
        const _super = Object.create(null, {
            handleAppVisibilityChanged: {
                get: ()=>super.handleAppVisibilityChanged
            }
        });
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            yield _super.handleAppVisibilityChanged.call(this);
            if (!this.isAdaptiveStream) return;
            this.updateVisibility();
        });
    }
    updateVisibility(forceEmit) {
        var _a, _b;
        const lastVisibilityChange = this.elementInfos.reduce((prev, info)=>Math.max(prev, info.visibilityChangedAt || 0), 0);
        const backgroundPause = ((_b = (_a = this.adaptiveStreamSettings) === null || _a === void 0 ? void 0 : _a.pauseVideoInBackground) !== null && _b !== void 0 ? _b : true // default to true
        ) ? this.isInBackground : false;
        const isPiPMode = this.elementInfos.some((info)=>info.pictureInPicture);
        const isVisible = this.elementInfos.some((info)=>info.visible) && !backgroundPause || isPiPMode;
        if (this.lastVisible === isVisible && !forceEmit) return;
        if (!isVisible && Date.now() - lastVisibilityChange < $c0722d30b1d17141$var$REACTION_DELAY) {
            // delay hidden events
            $c0722d30b1d17141$export$22e737276454df96.setTimeout(()=>{
                this.updateVisibility();
            }, $c0722d30b1d17141$var$REACTION_DELAY);
            return;
        }
        this.lastVisible = isVisible;
        this.emit($c0722d30b1d17141$export$2c8510d737cc09da.VisibilityChanged, isVisible, this);
    }
    updateDimensions() {
        var _a, _b;
        let maxWidth = 0;
        let maxHeight = 0;
        const pixelDensity = this.getPixelDensity();
        for (const info of this.elementInfos){
            const currentElementWidth = info.width() * pixelDensity;
            const currentElementHeight = info.height() * pixelDensity;
            if (currentElementWidth + currentElementHeight > maxWidth + maxHeight) {
                maxWidth = currentElementWidth;
                maxHeight = currentElementHeight;
            }
        }
        if (((_a = this.lastDimensions) === null || _a === void 0 ? void 0 : _a.width) === maxWidth && ((_b = this.lastDimensions) === null || _b === void 0 ? void 0 : _b.height) === maxHeight) return;
        this.lastDimensions = {
            width: maxWidth,
            height: maxHeight
        };
        this.emit($c0722d30b1d17141$export$2c8510d737cc09da.VideoDimensionsChanged, this.lastDimensions, this);
    }
    getPixelDensity() {
        var _a;
        const pixelDensity = (_a = this.adaptiveStreamSettings) === null || _a === void 0 ? void 0 : _a.pixelDensity;
        if (pixelDensity === 'screen') return $c0722d30b1d17141$var$getDevicePixelRatio();
        else if (!pixelDensity) {
            // when unset, we'll pick a sane default here.
            // for higher pixel density devices (mobile phones, etc), we'll use 2
            // otherwise it defaults to 1
            const devicePixelRatio = $c0722d30b1d17141$var$getDevicePixelRatio();
            if (devicePixelRatio > 2) return 2;
            else return 1;
        }
        return pixelDensity;
    }
}
class $c0722d30b1d17141$var$HTMLElementInfo {
    get visible() {
        return this.isPiP || this.isIntersecting;
    }
    get pictureInPicture() {
        return this.isPiP;
    }
    constructor(element, visible){
        this.onVisibilityChanged = (entry)=>{
            var _a;
            const { target: target, isIntersecting: isIntersecting } = entry;
            if (target === this.element) {
                this.isIntersecting = isIntersecting;
                this.isPiP = $c0722d30b1d17141$var$isElementInPiP(this.element);
                this.visibilityChangedAt = Date.now();
                (_a = this.handleVisibilityChanged) === null || _a === void 0 || _a.call(this);
            }
        };
        this.onEnterPiP = ()=>{
            var _a, _b;
            (_b = (_a = window.documentPictureInPicture) === null || _a === void 0 ? void 0 : _a.window) === null || _b === void 0 || _b.addEventListener('pagehide', this.onLeavePiP);
            // Document PiP: the browser may fire 'enter' before the app has appended its subtree into
            // documentPictureInPicture.window. Defer so pipWin.document.contains(video) is reliable.
            queueMicrotask(()=>{
                requestAnimationFrame(()=>{
                    var _a;
                    this.isPiP = $c0722d30b1d17141$var$isElementInPiP(this.element);
                    (_a = this.handleVisibilityChanged) === null || _a === void 0 || _a.call(this);
                });
            });
        };
        this.onLeavePiP = ()=>{
            var _a;
            this.isPiP = $c0722d30b1d17141$var$isElementInPiP(this.element);
            (_a = this.handleVisibilityChanged) === null || _a === void 0 || _a.call(this);
        };
        this.element = element;
        this.isIntersecting = visible !== null && visible !== void 0 ? visible : $c0722d30b1d17141$var$isElementInViewport(element);
        this.isPiP = $c0722d30b1d17141$var$isWeb() && $c0722d30b1d17141$var$isElementInPiP(element);
        this.visibilityChangedAt = 0;
    }
    width() {
        return this.element.clientWidth;
    }
    height() {
        return this.element.clientHeight;
    }
    observe() {
        var _a, _b, _c;
        // make sure we update the current visible state once we start to observe
        this.isIntersecting = $c0722d30b1d17141$var$isElementInViewport(this.element);
        this.isPiP = $c0722d30b1d17141$var$isElementInPiP(this.element);
        this.element.handleResize = ()=>{
            var _a;
            (_a = this.handleResize) === null || _a === void 0 || _a.call(this);
        };
        this.element.handleVisibilityChanged = this.onVisibilityChanged;
        $c0722d30b1d17141$var$getIntersectionObserver().observe(this.element);
        $c0722d30b1d17141$var$getResizeObserver().observe(this.element);
        this.element.addEventListener('enterpictureinpicture', this.onEnterPiP);
        this.element.addEventListener('leavepictureinpicture', this.onLeavePiP);
        (_a = window.documentPictureInPicture) === null || _a === void 0 || _a.addEventListener('enter', this.onEnterPiP);
        (_c = (_b = window.documentPictureInPicture) === null || _b === void 0 ? void 0 : _b.window) === null || _c === void 0 || _c.addEventListener('pagehide', this.onLeavePiP);
    }
    stopObserving() {
        var _a, _b, _c, _d, _e;
        (_a = $c0722d30b1d17141$var$getIntersectionObserver()) === null || _a === void 0 || _a.unobserve(this.element);
        (_b = $c0722d30b1d17141$var$getResizeObserver()) === null || _b === void 0 || _b.unobserve(this.element);
        this.element.removeEventListener('enterpictureinpicture', this.onEnterPiP);
        this.element.removeEventListener('leavepictureinpicture', this.onLeavePiP);
        (_c = window.documentPictureInPicture) === null || _c === void 0 || _c.removeEventListener('enter', this.onEnterPiP);
        (_e = (_d = window.documentPictureInPicture) === null || _d === void 0 ? void 0 : _d.window) === null || _e === void 0 || _e.removeEventListener('pagehide', this.onLeavePiP);
    }
}
function $c0722d30b1d17141$var$isElementInPiP(el) {
    var _a, _b;
    // Simple video PiP
    if (document.pictureInPictureElement === el) return true;
    // Document PiP
    if ((_a = window.documentPictureInPicture) === null || _a === void 0 ? void 0 : _a.window) return $c0722d30b1d17141$var$isElementInViewport(el, (_b = window.documentPictureInPicture) === null || _b === void 0 ? void 0 : _b.window);
    return false;
}
// does not account for occlusion by other elements or opacity property
function $c0722d30b1d17141$var$isElementInViewport(el, win) {
    const viewportWindow = win || window;
    let top = el.offsetTop;
    let left = el.offsetLeft;
    const width = el.offsetWidth;
    const height = el.offsetHeight;
    const { hidden: hidden } = el;
    const { display: display } = getComputedStyle(el);
    while(el.offsetParent){
        el = el.offsetParent;
        top += el.offsetTop;
        left += el.offsetLeft;
    }
    return top < viewportWindow.pageYOffset + viewportWindow.innerHeight && left < viewportWindow.pageXOffset + viewportWindow.innerWidth && top + height > viewportWindow.pageYOffset && left + width > viewportWindow.pageXOffset && !hidden && display !== 'none';
}
class $c0722d30b1d17141$export$7c531331788c3797 extends $c0722d30b1d17141$var$eventsExports.EventEmitter {
    constructor(kind, id, name, loggerOptions){
        var _a;
        super();
        this.metadataMuted = false;
        this.encryption = $c0722d30b1d17141$export$1efc488791285f20.NONE;
        this.log = $c0722d30b1d17141$var$livekitLogger;
        this.handleMuted = ()=>{
            this.emit($c0722d30b1d17141$export$2c8510d737cc09da.Muted);
        };
        this.handleUnmuted = ()=>{
            this.emit($c0722d30b1d17141$export$2c8510d737cc09da.Unmuted);
        };
        this.log = $c0722d30b1d17141$export$2b1d391cd05230fd((_a = loggerOptions === null || loggerOptions === void 0 ? void 0 : loggerOptions.loggerName) !== null && _a !== void 0 ? _a : $c0722d30b1d17141$export$69ba24dd79f4da21.Publication);
        this.loggerContextCb = this.loggerContextCb;
        this.setMaxListeners(100);
        this.kind = kind;
        this.trackSid = id;
        this.trackName = name;
        this.source = $c0722d30b1d17141$export$13921ac0cc260818.Source.Unknown;
    }
    /** @internal */ setTrack(track) {
        if (this.track) {
            this.track.off($c0722d30b1d17141$export$2c8510d737cc09da.Muted, this.handleMuted);
            this.track.off($c0722d30b1d17141$export$2c8510d737cc09da.Unmuted, this.handleUnmuted);
        }
        this.track = track;
        if (track) {
            // forward events
            track.on($c0722d30b1d17141$export$2c8510d737cc09da.Muted, this.handleMuted);
            track.on($c0722d30b1d17141$export$2c8510d737cc09da.Unmuted, this.handleUnmuted);
        }
    }
    get logContext() {
        var _a;
        return Object.assign(Object.assign({}, (_a = this.loggerContextCb) === null || _a === void 0 ? void 0 : _a.call(this)), $c0722d30b1d17141$var$getLogContextFromTrack(this));
    }
    get isMuted() {
        return this.metadataMuted;
    }
    get isEnabled() {
        return true;
    }
    get isSubscribed() {
        return this.track !== undefined;
    }
    get isEncrypted() {
        return this.encryption !== $c0722d30b1d17141$export$1efc488791285f20.NONE;
    }
    /**
   * an [AudioTrack] if this publication holds an audio track
   */ get audioTrack() {
        if ($c0722d30b1d17141$export$228726644c3d75db(this.track)) return this.track;
    }
    /**
   * an [VideoTrack] if this publication holds a video track
   */ get videoTrack() {
        if ($c0722d30b1d17141$export$372680e3a49e7e3e(this.track)) return this.track;
    }
    /** @internal */ updateInfo(info) {
        this.trackSid = info.sid;
        this.trackName = info.name;
        this.source = $c0722d30b1d17141$export$13921ac0cc260818.sourceFromProto(info.source);
        this.mimeType = info.mimeType;
        if (this.kind === $c0722d30b1d17141$export$13921ac0cc260818.Kind.Video && info.width > 0) {
            this.dimensions = {
                width: info.width,
                height: info.height
            };
            this.simulcasted = info.simulcast;
        }
        this.encryption = info.encryption;
        this.trackInfo = info;
        this.log.debug('update publication info', Object.assign(Object.assign({}, this.logContext), {
            info: info
        }));
    }
}
(function(TrackPublication) {
    (function(SubscriptionStatus) {
        SubscriptionStatus["Desired"] = "desired";
        SubscriptionStatus["Subscribed"] = "subscribed";
        SubscriptionStatus["Unsubscribed"] = "unsubscribed";
    })(TrackPublication.SubscriptionStatus || (TrackPublication.SubscriptionStatus = {}));
    (function(PermissionStatus) {
        PermissionStatus["Allowed"] = "allowed";
        PermissionStatus["NotAllowed"] = "not_allowed";
    })(TrackPublication.PermissionStatus || (TrackPublication.PermissionStatus = {}));
})($c0722d30b1d17141$export$7c531331788c3797 || ($c0722d30b1d17141$export$7c531331788c3797 = {}));
class $c0722d30b1d17141$export$885a52c769210b3f extends $c0722d30b1d17141$export$7c531331788c3797 {
    get isUpstreamPaused() {
        var _a;
        return (_a = this.track) === null || _a === void 0 ? void 0 : _a.isUpstreamPaused;
    }
    constructor(kind, ti, track, loggerOptions){
        super(kind, ti.sid, ti.name, loggerOptions);
        this.track = undefined;
        this.handleTrackEnded = ()=>{
            this.emit($c0722d30b1d17141$export$2c8510d737cc09da.Ended);
        };
        this.handleCpuConstrained = ()=>{
            if (this.track && $c0722d30b1d17141$export$372680e3a49e7e3e(this.track)) this.emit($c0722d30b1d17141$export$2c8510d737cc09da.CpuConstrained, this.track);
        };
        this.updateInfo(ti);
        this.setTrack(track);
    }
    setTrack(track) {
        if (this.track) {
            this.track.off($c0722d30b1d17141$export$2c8510d737cc09da.Ended, this.handleTrackEnded);
            this.track.off($c0722d30b1d17141$export$2c8510d737cc09da.CpuConstrained, this.handleCpuConstrained);
        }
        super.setTrack(track);
        if (track) {
            track.on($c0722d30b1d17141$export$2c8510d737cc09da.Ended, this.handleTrackEnded);
            track.on($c0722d30b1d17141$export$2c8510d737cc09da.CpuConstrained, this.handleCpuConstrained);
        }
    }
    get isMuted() {
        if (this.track) return this.track.isMuted;
        return super.isMuted;
    }
    get audioTrack() {
        return super.audioTrack;
    }
    get videoTrack() {
        return super.videoTrack;
    }
    get isLocal() {
        return true;
    }
    /**
   * Mute the track associated with this publication
   */ mute() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            return (_a = this.track) === null || _a === void 0 ? void 0 : _a.mute();
        });
    }
    /**
   * Unmute track associated with this publication
   */ unmute() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            return (_a = this.track) === null || _a === void 0 ? void 0 : _a.unmute();
        });
    }
    /**
   * Pauses the media stream track associated with this publication from being sent to the server
   * and signals "muted" event to other participants
   * Useful if you want to pause the stream without pausing the local media stream track
   */ pauseUpstream() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            yield (_a = this.track) === null || _a === void 0 ? void 0 : _a.pauseUpstream();
        });
    }
    /**
   * Resumes sending the media stream track associated with this publication to the server after a call to [[pauseUpstream()]]
   * and signals "unmuted" event to other participants (unless the track is explicitly muted)
   */ resumeUpstream() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            yield (_a = this.track) === null || _a === void 0 ? void 0 : _a.resumeUpstream();
        });
    }
    getTrackFeatures() {
        var _a;
        if ($c0722d30b1d17141$export$228726644c3d75db(this.track)) {
            const settings = this.track.getSourceTrackSettings();
            const features = new Set();
            if (settings.autoGainControl) features.add($c0722d30b1d17141$var$AudioTrackFeature.TF_AUTO_GAIN_CONTROL);
            if (settings.echoCancellation) features.add($c0722d30b1d17141$var$AudioTrackFeature.TF_ECHO_CANCELLATION);
            if (settings.noiseSuppression) features.add($c0722d30b1d17141$var$AudioTrackFeature.TF_NOISE_SUPPRESSION);
            if (settings.channelCount && settings.channelCount > 1) features.add($c0722d30b1d17141$var$AudioTrackFeature.TF_STEREO);
            if (!((_a = this.options) === null || _a === void 0 ? void 0 : _a.dtx)) features.add($c0722d30b1d17141$var$AudioTrackFeature.TF_NO_DTX);
            if (this.track.enhancedNoiseCancellation) features.add($c0722d30b1d17141$var$AudioTrackFeature.TF_ENHANCED_NOISE_CANCELLATION);
            return Array.from(features.values());
        } else return [];
    }
} /**
 * Creates a local video and audio track at the same time. When acquiring both
 * audio and video tracks together, it'll display a single permission prompt to
 * the user instead of two separate ones.
 * @param options
 */ 
function $c0722d30b1d17141$export$61cce20000b22feb(options, loggerOptions) {
    return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
        options !== null && options !== void 0 ? options : options = {};
        let attemptExactMatch = false;
        const { audioProcessor: audioProcessor, videoProcessor: videoProcessor, optionsWithoutProcessor: internalOptions } = $c0722d30b1d17141$var$extractProcessorsFromOptions(options);
        let retryAudioOptions = internalOptions.audio;
        let retryVideoOptions = internalOptions.video;
        if (audioProcessor && typeof internalOptions.audio === 'object') internalOptions.audio.processor = audioProcessor;
        if (videoProcessor && typeof internalOptions.video === 'object') internalOptions.video.processor = videoProcessor;
        // if the user passes a device id as a string, we default to exact match
        if (options.audio && typeof internalOptions.audio === 'object' && typeof internalOptions.audio.deviceId === 'string') {
            const deviceId = internalOptions.audio.deviceId;
            internalOptions.audio.deviceId = {
                exact: deviceId
            };
            attemptExactMatch = true;
            retryAudioOptions = Object.assign(Object.assign({}, internalOptions.audio), {
                deviceId: {
                    ideal: deviceId
                }
            });
        }
        if (internalOptions.video && typeof internalOptions.video === 'object' && typeof internalOptions.video.deviceId === 'string') {
            const deviceId = internalOptions.video.deviceId;
            internalOptions.video.deviceId = {
                exact: deviceId
            };
            attemptExactMatch = true;
            retryVideoOptions = Object.assign(Object.assign({}, internalOptions.video), {
                deviceId: {
                    ideal: deviceId
                }
            });
        }
        if (internalOptions.audio === true) internalOptions.audio = {
            deviceId: 'default'
        };
        else if (typeof internalOptions.audio === 'object' && internalOptions.audio !== null) internalOptions.audio = Object.assign(Object.assign({}, internalOptions.audio), {
            deviceId: internalOptions.audio.deviceId || 'default'
        });
        if (internalOptions.video === true) internalOptions.video = {
            deviceId: 'default'
        };
        else if (typeof internalOptions.video === 'object' && !internalOptions.video.deviceId) internalOptions.video.deviceId = 'default';
        const opts = $c0722d30b1d17141$var$mergeDefaultOptions(internalOptions, $c0722d30b1d17141$var$audioDefaults, $c0722d30b1d17141$var$videoDefaults);
        const constraints = $c0722d30b1d17141$var$constraintsForOptions(opts);
        // Keep a reference to the promise on DeviceManager and await it in getLocalDevices()
        // works around iOS Safari Bug https://bugs.webkit.org/show_bug.cgi?id=179363
        const mediaPromise = navigator.mediaDevices.getUserMedia(constraints);
        if (internalOptions.audio) {
            $c0722d30b1d17141$var$DeviceManager.userMediaPromiseMap.set('audioinput', mediaPromise);
            mediaPromise.catch(()=>$c0722d30b1d17141$var$DeviceManager.userMediaPromiseMap.delete('audioinput'));
        }
        if (internalOptions.video) {
            $c0722d30b1d17141$var$DeviceManager.userMediaPromiseMap.set('videoinput', mediaPromise);
            mediaPromise.catch(()=>$c0722d30b1d17141$var$DeviceManager.userMediaPromiseMap.delete('videoinput'));
        }
        try {
            const stream = yield mediaPromise;
            return yield Promise.all(stream.getTracks().map((mediaStreamTrack)=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                    const isAudio = mediaStreamTrack.kind === 'audio';
                    let trackOptions = isAudio ? opts.audio : opts.video;
                    if (typeof trackOptions === 'boolean' || !trackOptions) trackOptions = {};
                    let trackConstraints;
                    const conOrBool = isAudio ? constraints.audio : constraints.video;
                    if (typeof conOrBool !== 'boolean') trackConstraints = conOrBool;
                    // update the constraints with the device id the user gave permissions to in the permission prompt
                    // otherwise each track restart (e.g. mute - unmute) will try to initialize the device again -> causing additional permission prompts
                    const newDeviceId = mediaStreamTrack.getSettings().deviceId;
                    if ((trackConstraints === null || trackConstraints === void 0 ? void 0 : trackConstraints.deviceId) && $c0722d30b1d17141$var$unwrapConstraint(trackConstraints.deviceId) !== newDeviceId) trackConstraints.deviceId = newDeviceId;
                    else if (!trackConstraints) trackConstraints = {
                        deviceId: newDeviceId
                    };
                    const track = $c0722d30b1d17141$var$mediaTrackToLocalTrack(mediaStreamTrack, trackConstraints, loggerOptions);
                    if (track.kind === $c0722d30b1d17141$export$13921ac0cc260818.Kind.Video) track.source = $c0722d30b1d17141$export$13921ac0cc260818.Source.Camera;
                    else if (track.kind === $c0722d30b1d17141$export$13921ac0cc260818.Kind.Audio) track.source = $c0722d30b1d17141$export$13921ac0cc260818.Source.Microphone;
                    track.mediaStream = stream;
                    if ($c0722d30b1d17141$export$228726644c3d75db(track) && audioProcessor) yield track.setProcessor(audioProcessor);
                    else if ($c0722d30b1d17141$export$372680e3a49e7e3e(track) && videoProcessor) yield track.setProcessor(videoProcessor);
                    return track;
                })));
        } catch (e) {
            if (!attemptExactMatch) throw e;
            return $c0722d30b1d17141$export$61cce20000b22feb(Object.assign(Object.assign({}, options), {
                audio: retryAudioOptions,
                video: retryVideoOptions
            }), loggerOptions);
        }
    });
}
/**
 * Creates a [[LocalVideoTrack]] with getUserMedia()
 * @param options
 */ function $c0722d30b1d17141$export$449d1fd97929ebe7(options) {
    return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
        const tracks = yield $c0722d30b1d17141$export$61cce20000b22feb({
            audio: false,
            video: options !== null && options !== void 0 ? options : true
        });
        return tracks[0];
    });
}
function $c0722d30b1d17141$export$6e84c4c7abc03d43(options) {
    return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
        const tracks = yield $c0722d30b1d17141$export$61cce20000b22feb({
            audio: options !== null && options !== void 0 ? options : true,
            video: false
        });
        return tracks[0];
    });
}
/**
 * Creates a screen capture tracks with getDisplayMedia().
 * A LocalVideoTrack is always created and returned.
 * If { audio: true }, and the browser supports audio capture, a LocalAudioTrack is also created.
 */ function $c0722d30b1d17141$export$39e3aa92383c771(options) {
    return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
        if (options === undefined) options = {};
        if (options.resolution === undefined && !$c0722d30b1d17141$var$isSafari17Based()) options.resolution = $c0722d30b1d17141$export$a6cdf9dcd3d32f2d.h1080fps30.resolution;
        if (navigator.mediaDevices.getDisplayMedia === undefined) throw new $c0722d30b1d17141$export$38c5ac268e2fa84('getDisplayMedia not supported');
        const constraints = $c0722d30b1d17141$var$screenCaptureToDisplayMediaStreamOptions(options);
        const stream = yield navigator.mediaDevices.getDisplayMedia(constraints);
        const tracks = stream.getVideoTracks();
        if (tracks.length === 0) throw new $c0722d30b1d17141$export$4fbb9423b5747257('no video track found');
        const screenVideo = new $c0722d30b1d17141$export$d5ffd2c62c538bdc(tracks[0], undefined, false);
        screenVideo.source = $c0722d30b1d17141$export$13921ac0cc260818.Source.ScreenShare;
        const localTracks = [
            screenVideo
        ];
        if (stream.getAudioTracks().length > 0) {
            const screenAudio = new $c0722d30b1d17141$export$b287427b771ca237(stream.getAudioTracks()[0], undefined, false);
            screenAudio.source = $c0722d30b1d17141$export$13921ac0cc260818.Source.ScreenShareAudio;
            localTracks.push(screenAudio);
        }
        return localTracks;
    });
}
var $c0722d30b1d17141$export$16148de7856f4643;
(function(ConnectionQuality) {
    ConnectionQuality["Excellent"] = "excellent";
    ConnectionQuality["Good"] = "good";
    ConnectionQuality["Poor"] = "poor";
    /**
   * Indicates that a participant has temporarily (or permanently) lost connection to LiveKit.
   * For permanent disconnection a `ParticipantDisconnected` event will be emitted after a timeout
   */ ConnectionQuality["Lost"] = "lost";
    ConnectionQuality["Unknown"] = "unknown";
})($c0722d30b1d17141$export$16148de7856f4643 || ($c0722d30b1d17141$export$16148de7856f4643 = {}));
function $c0722d30b1d17141$var$qualityFromProto(q) {
    switch(q){
        case $c0722d30b1d17141$var$ConnectionQuality$1.EXCELLENT:
            return $c0722d30b1d17141$export$16148de7856f4643.Excellent;
        case $c0722d30b1d17141$var$ConnectionQuality$1.GOOD:
            return $c0722d30b1d17141$export$16148de7856f4643.Good;
        case $c0722d30b1d17141$var$ConnectionQuality$1.POOR:
            return $c0722d30b1d17141$export$16148de7856f4643.Poor;
        case $c0722d30b1d17141$var$ConnectionQuality$1.LOST:
            return $c0722d30b1d17141$export$16148de7856f4643.Lost;
        default:
            return $c0722d30b1d17141$export$16148de7856f4643.Unknown;
    }
}
class $c0722d30b1d17141$export$aada361ed1a6c65 extends $c0722d30b1d17141$var$eventsExports.EventEmitter {
    get logContext() {
        var _a, _b;
        return Object.assign({}, (_b = (_a = this.loggerOptions) === null || _a === void 0 ? void 0 : _a.loggerContextCb) === null || _b === void 0 ? void 0 : _b.call(_a));
    }
    get isEncrypted() {
        return this.trackPublications.size > 0 && Array.from(this.trackPublications.values()).every((tr)=>tr.isEncrypted);
    }
    get isAgent() {
        var _a;
        return ((_a = this.permissions) === null || _a === void 0 ? void 0 : _a.agent) || this.kind === $c0722d30b1d17141$export$2079c0e1523aec29.AGENT;
    }
    get isActive() {
        var _a;
        return ((_a = this.participantInfo) === null || _a === void 0 ? void 0 : _a.state) === $c0722d30b1d17141$var$ParticipantInfo_State.ACTIVE;
    }
    get kind() {
        return this._kind;
    }
    /** participant attributes, similar to metadata, but as a key/value map */ get attributes() {
        return Object.freeze(Object.assign({}, this._attributes));
    }
    /** @internal */ constructor(sid, identity, name, metadata, attributes, loggerOptions){
        let kind = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : $c0722d30b1d17141$export$2079c0e1523aec29.STANDARD;
        var _a;
        super();
        /** audio level between 0-1.0, 1 being loudest, 0 being softest */ this.audioLevel = 0;
        /** if participant is currently speaking */ this.isSpeaking = false;
        this._connectionQuality = $c0722d30b1d17141$export$16148de7856f4643.Unknown;
        this.log = $c0722d30b1d17141$var$livekitLogger;
        this.loggerOptions = loggerOptions;
        this.log = $c0722d30b1d17141$export$2b1d391cd05230fd((_a = loggerOptions === null || loggerOptions === void 0 ? void 0 : loggerOptions.loggerName) !== null && _a !== void 0 ? _a : $c0722d30b1d17141$export$69ba24dd79f4da21.Participant, ()=>this.logContext);
        this.setMaxListeners(100);
        this.sid = sid;
        this.identity = identity;
        this.name = name;
        this.metadata = metadata;
        this.audioTrackPublications = new Map();
        this.videoTrackPublications = new Map();
        this.trackPublications = new Map();
        this._kind = kind;
        this._attributes = attributes !== null && attributes !== void 0 ? attributes : {};
    }
    getTrackPublications() {
        return Array.from(this.trackPublications.values());
    }
    /**
   * Finds the first track that matches the source filter, for example, getting
   * the user's camera track with getTrackBySource(Track.Source.Camera).
   */ getTrackPublication(source) {
        for (const [, pub] of this.trackPublications){
            if (pub.source === source) return pub;
        }
    }
    /**
   * Finds the first track that matches the track's name.
   */ getTrackPublicationByName(name) {
        for (const [, pub] of this.trackPublications){
            if (pub.trackName === name) return pub;
        }
    }
    /**
   * Waits until the participant is active and ready to receive data messages
   * @returns a promise that resolves when the participant is active
   */ waitUntilActive() {
        if (this.isActive) return Promise.resolve();
        if (this.activeFuture) return this.activeFuture.promise;
        this.activeFuture = new $c0722d30b1d17141$var$Future();
        this.once($c0722d30b1d17141$export$fcdfe2b7a6750691.Active, ()=>{
            var _a, _b;
            (_b = (_a = this.activeFuture) === null || _a === void 0 ? void 0 : _a.resolve) === null || _b === void 0 || _b.call(_a);
            this.activeFuture = undefined;
        });
        return this.activeFuture.promise;
    }
    get connectionQuality() {
        return this._connectionQuality;
    }
    get isCameraEnabled() {
        var _a;
        const track = this.getTrackPublication($c0722d30b1d17141$export$13921ac0cc260818.Source.Camera);
        return !((_a = track === null || track === void 0 ? void 0 : track.isMuted) !== null && _a !== void 0 ? _a : true);
    }
    get isMicrophoneEnabled() {
        var _a;
        const track = this.getTrackPublication($c0722d30b1d17141$export$13921ac0cc260818.Source.Microphone);
        return !((_a = track === null || track === void 0 ? void 0 : track.isMuted) !== null && _a !== void 0 ? _a : true);
    }
    get isScreenShareEnabled() {
        const track = this.getTrackPublication($c0722d30b1d17141$export$13921ac0cc260818.Source.ScreenShare);
        return !!track;
    }
    get isLocal() {
        return false;
    }
    /** when participant joined the room */ get joinedAt() {
        if (this.participantInfo) return new Date(Number.parseInt(this.participantInfo.joinedAt.toString()) * 1000);
        return new Date();
    }
    /** @internal */ updateInfo(info) {
        var _a;
        // it's possible the update could be applied out of order due to await
        // during reconnect sequences. when that happens, it's possible for server
        // to have sent more recent version of participant info while JS is waiting
        // to process the existing payload.
        // when the participant sid remains the same, and we already have a later version
        // of the payload, they can be safely skipped
        if (this.participantInfo && this.participantInfo.sid === info.sid && this.participantInfo.version > info.version) return false;
        this.identity = info.identity;
        this.sid = info.sid;
        this._setName(info.name);
        this._setMetadata(info.metadata);
        this._setAttributes(info.attributes);
        if (info.state === $c0722d30b1d17141$var$ParticipantInfo_State.ACTIVE && ((_a = this.participantInfo) === null || _a === void 0 ? void 0 : _a.state) !== $c0722d30b1d17141$var$ParticipantInfo_State.ACTIVE) this.emit($c0722d30b1d17141$export$fcdfe2b7a6750691.Active);
        if (info.permission) this.setPermissions(info.permission);
        // set this last so setMetadata can detect changes
        this.participantInfo = info;
        return true;
    }
    /**
   * Updates metadata from server
   **/ _setMetadata(md) {
        const changed = this.metadata !== md;
        const prevMetadata = this.metadata;
        this.metadata = md;
        if (changed) this.emit($c0722d30b1d17141$export$fcdfe2b7a6750691.ParticipantMetadataChanged, prevMetadata);
    }
    _setName(name) {
        const changed = this.name !== name;
        this.name = name;
        if (changed) this.emit($c0722d30b1d17141$export$fcdfe2b7a6750691.ParticipantNameChanged, name);
    }
    /**
   * Updates metadata from server
   **/ _setAttributes(attributes) {
        const diff = $c0722d30b1d17141$var$diffAttributes(this.attributes, attributes);
        this._attributes = attributes;
        if (Object.keys(diff).length > 0) this.emit($c0722d30b1d17141$export$fcdfe2b7a6750691.AttributesChanged, diff);
    }
    /** @internal */ setPermissions(permissions) {
        var _a, _b, _c, _d, _e, _f;
        const prevPermissions = this.permissions;
        const changed = permissions.canPublish !== ((_a = this.permissions) === null || _a === void 0 ? void 0 : _a.canPublish) || permissions.canSubscribe !== ((_b = this.permissions) === null || _b === void 0 ? void 0 : _b.canSubscribe) || permissions.canPublishData !== ((_c = this.permissions) === null || _c === void 0 ? void 0 : _c.canPublishData) || permissions.hidden !== ((_d = this.permissions) === null || _d === void 0 ? void 0 : _d.hidden) || permissions.recorder !== ((_e = this.permissions) === null || _e === void 0 ? void 0 : _e.recorder) || permissions.canPublishSources.length !== this.permissions.canPublishSources.length || permissions.canPublishSources.some((value, index)=>{
            var _a;
            return value !== ((_a = this.permissions) === null || _a === void 0 ? void 0 : _a.canPublishSources[index]);
        }) || permissions.canSubscribeMetrics !== ((_f = this.permissions) === null || _f === void 0 ? void 0 : _f.canSubscribeMetrics);
        this.permissions = permissions;
        if (changed) this.emit($c0722d30b1d17141$export$fcdfe2b7a6750691.ParticipantPermissionsChanged, prevPermissions);
        return changed;
    }
    /** @internal */ setIsSpeaking(speaking) {
        if (speaking === this.isSpeaking) return;
        this.isSpeaking = speaking;
        if (speaking) this.lastSpokeAt = new Date();
        this.emit($c0722d30b1d17141$export$fcdfe2b7a6750691.IsSpeakingChanged, speaking);
    }
    /** @internal */ setConnectionQuality(q) {
        const prevQuality = this._connectionQuality;
        this._connectionQuality = $c0722d30b1d17141$var$qualityFromProto(q);
        if (prevQuality !== this._connectionQuality) this.emit($c0722d30b1d17141$export$fcdfe2b7a6750691.ConnectionQualityChanged, this._connectionQuality);
    }
    /**
   * @internal
   */ setDisconnected() {
        var _a, _b;
        if (this.activeFuture) {
            (_b = (_a = this.activeFuture).reject) === null || _b === void 0 || _b.call(_a, new Error('Participant disconnected'));
            this.activeFuture = undefined;
        }
    }
    /**
   * @internal
   */ setAudioContext(ctx) {
        this.audioContext = ctx;
        this.audioTrackPublications.forEach((track)=>$c0722d30b1d17141$export$228726644c3d75db(track.track) && track.track.setAudioContext(ctx));
    }
    addTrackPublication(publication) {
        // forward publication driven events
        publication.on($c0722d30b1d17141$export$2c8510d737cc09da.Muted, ()=>{
            this.emit($c0722d30b1d17141$export$fcdfe2b7a6750691.TrackMuted, publication);
        });
        publication.on($c0722d30b1d17141$export$2c8510d737cc09da.Unmuted, ()=>{
            this.emit($c0722d30b1d17141$export$fcdfe2b7a6750691.TrackUnmuted, publication);
        });
        const pub = publication;
        if (pub.track) pub.track.sid = publication.trackSid;
        this.trackPublications.set(publication.trackSid, publication);
        switch(publication.kind){
            case $c0722d30b1d17141$export$13921ac0cc260818.Kind.Audio:
                this.audioTrackPublications.set(publication.trackSid, publication);
                break;
            case $c0722d30b1d17141$export$13921ac0cc260818.Kind.Video:
                this.videoTrackPublications.set(publication.trackSid, publication);
                break;
        }
    }
}
function $c0722d30b1d17141$var$trackPermissionToProto(perms) {
    var _a, _b, _c;
    if (!perms.participantSid && !perms.participantIdentity) throw new Error('Invalid track permission, must provide at least one of participantIdentity and participantSid');
    return new $c0722d30b1d17141$var$TrackPermission({
        participantIdentity: (_a = perms.participantIdentity) !== null && _a !== void 0 ? _a : '',
        participantSid: (_b = perms.participantSid) !== null && _b !== void 0 ? _b : '',
        allTracks: (_c = perms.allowAll) !== null && _c !== void 0 ? _c : false,
        trackSids: perms.allowedTrackSids || []
    });
}
class $c0722d30b1d17141$export$ed007fa30041dd89 extends $c0722d30b1d17141$export$aada361ed1a6c65 {
    /** @internal */ constructor(sid, identity, engine, options, roomRpcHandlers, roomOutgoingDataStreamManager, roomOutgoingDataTrackManager){
        super(sid, identity, undefined, undefined, undefined, {
            loggerName: options.loggerName,
            loggerContextCb: ()=>this.engine.logContext
        });
        this.pendingPublishing = new Set();
        this.pendingPublishPromises = new Map();
        this.participantTrackPermissions = [];
        this.allParticipantsAllowedToSubscribe = true;
        this.encryptionType = $c0722d30b1d17141$export$1efc488791285f20.NONE;
        this.e2eeStateMutex = new $c0722d30b1d17141$export$ca12f2943758ef55();
        this.enabledPublishVideoCodecs = [];
        this.pendingAcks = new Map();
        this.pendingResponses = new Map();
        this.handleReconnecting = ()=>{
            if (!this.reconnectFuture) this.reconnectFuture = new $c0722d30b1d17141$var$Future();
        };
        this.handleReconnected = ()=>{
            var _a, _b;
            (_b = (_a = this.reconnectFuture) === null || _a === void 0 ? void 0 : _a.resolve) === null || _b === void 0 || _b.call(_a);
            this.reconnectFuture = undefined;
            this.updateTrackSubscriptionPermissions();
        };
        this.handleClosing = ()=>{
            var _a, _b, _c, _d, _e, _f;
            if (this.reconnectFuture) {
                // @throws-transformer ignore - introduced due to adding Throws into Future, investigate this
                // further
                this.reconnectFuture.promise.catch((e)=>this.log.warn(e.message));
                (_b = (_a = this.reconnectFuture) === null || _a === void 0 ? void 0 : _a.reject) === null || _b === void 0 || _b.call(_a, new Error('Got disconnected during reconnection attempt'));
                this.reconnectFuture = undefined;
            }
            if (this.signalConnectedFuture) {
                (_d = (_c = this.signalConnectedFuture).reject) === null || _d === void 0 || _d.call(_c, new Error('Got disconnected without signal connected'));
                this.signalConnectedFuture = undefined;
            }
            (_f = (_e = this.activeAgentFuture) === null || _e === void 0 ? void 0 : _e.reject) === null || _f === void 0 || _f.call(_e, new Error('Got disconnected without active agent present'));
            this.activeAgentFuture = undefined;
            this.firstActiveAgent = undefined;
        };
        this.handleSignalConnected = (joinResponse)=>{
            var _a, _b;
            if (joinResponse.participant) this.updateInfo(joinResponse.participant);
            if (!this.signalConnectedFuture) this.signalConnectedFuture = new $c0722d30b1d17141$var$Future();
            (_b = (_a = this.signalConnectedFuture).resolve) === null || _b === void 0 || _b.call(_a);
        };
        this.handleSignalRequestResponse = (response)=>{
            const { requestId: requestId, reason: reason, message: message } = response;
            const targetRequest = this.pendingSignalRequests.get(requestId);
            if (targetRequest) {
                if (reason !== $c0722d30b1d17141$var$RequestResponse_Reason.OK) targetRequest.reject(new $c0722d30b1d17141$export$cb33ebbc4df8a708(message, reason));
                this.pendingSignalRequests.delete(requestId);
            }
            switch(response.request.case){
                case 'publishDataTrack':
                    {
                        let error;
                        switch(response.reason){
                            case $c0722d30b1d17141$var$RequestResponse_Reason.NOT_ALLOWED:
                                error = $c0722d30b1d17141$var$DataTrackPublishError.notAllowed(response.message);
                                break;
                            case $c0722d30b1d17141$var$RequestResponse_Reason.DUPLICATE_NAME:
                                error = $c0722d30b1d17141$var$DataTrackPublishError.duplicateName(response.message);
                                break;
                            case $c0722d30b1d17141$var$RequestResponse_Reason.INVALID_NAME:
                                error = $c0722d30b1d17141$var$DataTrackPublishError.invalidName(response.message);
                                break;
                            case $c0722d30b1d17141$var$RequestResponse_Reason.LIMIT_EXCEEDED:
                                error = $c0722d30b1d17141$var$DataTrackPublishError.limitReached(response.message);
                                break;
                            default:
                                error = $c0722d30b1d17141$var$DataTrackPublishError.unknown(response.reason, response.message);
                                return;
                        }
                        this.roomOutgoingDataTrackManager.receivedSfuPublishResponse(response.request.value.pubHandle, {
                            type: 'error',
                            error: error
                        });
                        break;
                    }
            }
        };
        this.handleDataPacket = (packet)=>{
            switch(packet.value.case){
                case 'rpcResponse':
                    let rpcResponse = packet.value.value;
                    let payload = null;
                    let error = null;
                    if (rpcResponse.value.case === 'payload') payload = rpcResponse.value.value;
                    else if (rpcResponse.value.case === 'error') error = $c0722d30b1d17141$export$5460eff990f31920.fromProto(rpcResponse.value.value);
                    this.handleIncomingRpcResponse(rpcResponse.requestId, payload, error);
                    break;
                case 'rpcAck':
                    let rpcAck = packet.value.value;
                    this.handleIncomingRpcAck(rpcAck.requestId);
                    break;
            }
        };
        this.updateTrackSubscriptionPermissions = ()=>{
            this.log.debug('updating track subscription permissions', {
                allParticipantsAllowed: this.allParticipantsAllowedToSubscribe,
                participantTrackPermissions: this.participantTrackPermissions
            });
            this.engine.client.sendUpdateSubscriptionPermissions(this.allParticipantsAllowedToSubscribe, this.participantTrackPermissions.map((p)=>$c0722d30b1d17141$var$trackPermissionToProto(p)));
        };
        /** @internal */ this.onTrackUnmuted = (track)=>{
            this.onTrackMuted(track, track.isUpstreamPaused);
        };
        // when the local track changes in mute status, we'll notify server as such
        /** @internal */ this.onTrackMuted = (track, muted)=>{
            if (muted === undefined) muted = true;
            if (!track.sid) {
                this.log.error('could not update mute status for unpublished track', $c0722d30b1d17141$var$getLogContextFromTrack(track));
                return;
            }
            this.engine.updateMuteStatus(track.sid, muted);
        };
        this.onTrackUpstreamPaused = (track)=>{
            this.log.debug('upstream paused', $c0722d30b1d17141$var$getLogContextFromTrack(track));
            this.onTrackMuted(track, true);
        };
        this.onTrackUpstreamResumed = (track)=>{
            this.log.debug('upstream resumed', $c0722d30b1d17141$var$getLogContextFromTrack(track));
            this.onTrackMuted(track, track.isMuted);
        };
        this.onTrackFeatureUpdate = (track)=>{
            const pub = this.audioTrackPublications.get(track.sid);
            if (!pub) {
                this.log.warn("Could not update local audio track settings, missing publication for track ".concat(track.sid));
                return;
            }
            this.engine.client.sendUpdateLocalAudioTrack(pub.trackSid, pub.getTrackFeatures());
        };
        this.onTrackCpuConstrained = (track, publication)=>{
            this.log.debug('track cpu constrained', $c0722d30b1d17141$var$getLogContextFromTrack(publication));
            this.emit($c0722d30b1d17141$export$fcdfe2b7a6750691.LocalTrackCpuConstrained, track, publication);
        };
        this.handleSubscribedQualityUpdate = (update)=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                var _a, e_1, _b, _c;
                var _d;
                if (!((_d = this.roomOptions) === null || _d === void 0 ? void 0 : _d.dynacast)) return;
                const pub = this.videoTrackPublications.get(update.trackSid);
                if (!pub) {
                    this.log.warn('received subscribed quality update for unknown track', {
                        trackSid: update.trackSid
                    });
                    return;
                }
                if (!pub.videoTrack) return;
                const newCodecs = yield pub.videoTrack.setPublishingCodecs(update.subscribedCodecs);
                try {
                    for(var _e = true, newCodecs_1 = $c0722d30b1d17141$var$__asyncValues(newCodecs), newCodecs_1_1; newCodecs_1_1 = yield newCodecs_1.next(), _a = newCodecs_1_1.done, !_a; _e = true){
                        _c = newCodecs_1_1.value;
                        _e = false;
                        const codec = _c;
                        if ($c0722d30b1d17141$export$da37a49ee77f9d77(codec)) {
                            this.log.debug("publish ".concat(codec, " for ").concat(pub.videoTrack.sid), $c0722d30b1d17141$var$getLogContextFromTrack(pub));
                            yield this.publishAdditionalCodecForTrack(pub.videoTrack, codec, pub.options);
                        }
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (!_e && !_a && (_b = newCodecs_1.return)) yield _b.call(newCodecs_1);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
            });
        this.handleLocalTrackUnpublished = (unpublished)=>{
            const track = this.trackPublications.get(unpublished.trackSid);
            if (!track) {
                this.log.warn('received unpublished event for unknown track', {
                    trackSid: unpublished.trackSid
                });
                return;
            }
            this.unpublishTrack(track.track);
        };
        this.handleTrackEnded = (track)=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                if (track.source === $c0722d30b1d17141$export$13921ac0cc260818.Source.ScreenShare || track.source === $c0722d30b1d17141$export$13921ac0cc260818.Source.ScreenShareAudio) {
                    this.log.debug('unpublishing local track due to TrackEnded', $c0722d30b1d17141$var$getLogContextFromTrack(track));
                    this.unpublishTrack(track);
                } else if (track.isUserProvided) yield track.mute();
                else if ($c0722d30b1d17141$var$isLocalAudioTrack(track) || $c0722d30b1d17141$var$isLocalVideoTrack(track)) try {
                    if ($c0722d30b1d17141$var$isWeb()) try {
                        const currentPermissions = yield navigator === null || navigator === void 0 ? void 0 : navigator.permissions.query({
                            // the permission query for camera and microphone currently not supported in Safari and Firefox
                            // @ts-ignore
                            name: track.source === $c0722d30b1d17141$export$13921ac0cc260818.Source.Camera ? 'camera' : 'microphone'
                        });
                        if (currentPermissions && currentPermissions.state === 'denied') {
                            this.log.warn("user has revoked access to ".concat(track.source), $c0722d30b1d17141$var$getLogContextFromTrack(track));
                            // detect granted change after permissions were denied to try and resume then
                            currentPermissions.onchange = ()=>{
                                if (currentPermissions.state !== 'denied') {
                                    if (!track.isMuted) track.restartTrack();
                                    currentPermissions.onchange = null;
                                }
                            };
                            throw new Error('GetUserMedia Permission denied');
                        }
                    } catch (e) {
                    // permissions query fails for firefox, we continue and try to restart the track
                    }
                    if (!track.isMuted) {
                        this.log.debug('track ended, attempting to use a different device', $c0722d30b1d17141$var$getLogContextFromTrack(track));
                        if ($c0722d30b1d17141$var$isLocalAudioTrack(track)) // fall back to default device if available
                        yield track.restartTrack({
                            deviceId: 'default'
                        });
                        else yield track.restartTrack();
                    }
                } catch (e) {
                    this.log.warn("could not restart track, muting instead", $c0722d30b1d17141$var$getLogContextFromTrack(track));
                    yield track.mute();
                }
            });
        this.audioTrackPublications = new Map();
        this.videoTrackPublications = new Map();
        this.trackPublications = new Map();
        this.engine = engine;
        this.roomOptions = options;
        this.setupEngine(engine);
        this.activeDeviceMap = new Map([
            [
                'audioinput',
                'default'
            ],
            [
                'videoinput',
                'default'
            ],
            [
                'audiooutput',
                'default'
            ]
        ]);
        this.pendingSignalRequests = new Map();
        this.rpcHandlers = roomRpcHandlers;
        this.roomOutgoingDataStreamManager = roomOutgoingDataStreamManager;
        this.roomOutgoingDataTrackManager = roomOutgoingDataTrackManager;
    }
    get lastCameraError() {
        return this.cameraError;
    }
    get lastMicrophoneError() {
        return this.microphoneError;
    }
    get isE2EEEnabled() {
        return this.encryptionType !== $c0722d30b1d17141$export$1efc488791285f20.NONE;
    }
    getTrackPublication(source) {
        const track = super.getTrackPublication(source);
        if (track) return track;
    }
    getTrackPublicationByName(name) {
        const track = super.getTrackPublicationByName(name);
        if (track) return track;
    }
    /**
   * @internal
   */ setupEngine(engine) {
        var _a;
        this.engine = engine;
        this.engine.on($c0722d30b1d17141$export$c09e63b8572f869.RemoteMute, (trackSid, muted)=>{
            const pub = this.trackPublications.get(trackSid);
            if (!pub || !pub.track) return;
            if (muted) pub.mute();
            else pub.unmute();
        });
        if ((_a = this.signalConnectedFuture) === null || _a === void 0 ? void 0 : _a.isResolved) this.signalConnectedFuture = undefined;
        this.engine.on($c0722d30b1d17141$export$c09e63b8572f869.Connected, this.handleReconnected).on($c0722d30b1d17141$export$c09e63b8572f869.SignalConnected, this.handleSignalConnected).on($c0722d30b1d17141$export$c09e63b8572f869.SignalRestarted, this.handleReconnected).on($c0722d30b1d17141$export$c09e63b8572f869.SignalResumed, this.handleReconnected).on($c0722d30b1d17141$export$c09e63b8572f869.Restarting, this.handleReconnecting).on($c0722d30b1d17141$export$c09e63b8572f869.Resuming, this.handleReconnecting).on($c0722d30b1d17141$export$c09e63b8572f869.LocalTrackUnpublished, this.handleLocalTrackUnpublished).on($c0722d30b1d17141$export$c09e63b8572f869.SubscribedQualityUpdate, this.handleSubscribedQualityUpdate).on($c0722d30b1d17141$export$c09e63b8572f869.Closing, this.handleClosing).on($c0722d30b1d17141$export$c09e63b8572f869.SignalRequestResponse, this.handleSignalRequestResponse).on($c0722d30b1d17141$export$c09e63b8572f869.DataPacketReceived, this.handleDataPacket);
    }
    /**
   * Sets and updates the metadata of the local participant.
   * Note: this requires `canUpdateOwnMetadata` permission.
   * method will throw if the user doesn't have the required permissions
   * @param metadata
   */ setMetadata(metadata) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            yield this.requestMetadataUpdate({
                metadata: metadata
            });
        });
    }
    /**
   * Sets and updates the name of the local participant.
   * Note: this requires `canUpdateOwnMetadata` permission.
   * method will throw if the user doesn't have the required permissions
   * @param metadata
   */ setName(name) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            yield this.requestMetadataUpdate({
                name: name
            });
        });
    }
    /**
   * Set or update participant attributes. It will make updates only to keys that
   * are present in `attributes`, and will not override others.
   * Note: this requires `canUpdateOwnMetadata` permission.
   * @param attributes attributes to update
   */ setAttributes(attributes) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            yield this.requestMetadataUpdate({
                attributes: attributes
            });
        });
    }
    requestMetadataUpdate(_a) {
        return $c0722d30b1d17141$var$__awaiter(this, arguments, void 0, function(_ref) {
            var _this = this;
            let { metadata: metadata, name: name, attributes: attributes } = _ref;
            return function*() {
                return new $c0722d30b1d17141$var$TypedPromise((resolve, reject)=>$c0722d30b1d17141$var$__awaiter(_this, void 0, void 0, function*() {
                        var _a, _b;
                        try {
                            let isRejected = false;
                            const requestId = yield this.engine.client.sendUpdateLocalMetadata((_a = metadata !== null && metadata !== void 0 ? metadata : this.metadata) !== null && _a !== void 0 ? _a : '', (_b = name !== null && name !== void 0 ? name : this.name) !== null && _b !== void 0 ? _b : '', attributes);
                            const startTime = performance.now();
                            this.pendingSignalRequests.set(requestId, {
                                resolve: resolve,
                                reject: (error)=>{
                                    reject(error);
                                    isRejected = true;
                                },
                                values: {
                                    name: name,
                                    metadata: metadata,
                                    attributes: attributes
                                }
                            });
                            while(performance.now() - startTime < 5000 && !isRejected){
                                if ((!name || this.name === name) && (!metadata || this.metadata === metadata) && (!attributes || Object.entries(attributes).every((_ref2)=>{
                                    let [key, value] = _ref2;
                                    return this.attributes[key] === value || value === '' && !this.attributes[key];
                                }))) {
                                    this.pendingSignalRequests.delete(requestId);
                                    resolve();
                                    return;
                                }
                                yield $c0722d30b1d17141$var$sleep(50);
                            }
                            reject(new $c0722d30b1d17141$export$cb33ebbc4df8a708('Request to update local metadata timed out', 'TimeoutError'));
                        } catch (e) {
                            if (e instanceof Error) reject(e);
                            else reject(new Error(String(e)));
                        }
                    }));
            }();
        });
    }
    /**
   * Enable or disable a participant's camera track.
   *
   * If a track has already published, it'll mute or unmute the track.
   * Resolves with a `LocalTrackPublication` instance if successful and `undefined` otherwise
   */ setCameraEnabled(enabled, options, publishOptions) {
        return this.setTrackEnabled($c0722d30b1d17141$export$13921ac0cc260818.Source.Camera, enabled, options, publishOptions);
    }
    /**
   * Enable or disable a participant's microphone track.
   *
   * If a track has already published, it'll mute or unmute the track.
   * Resolves with a `LocalTrackPublication` instance if successful and `undefined` otherwise
   */ setMicrophoneEnabled(enabled, options, publishOptions) {
        return this.setTrackEnabled($c0722d30b1d17141$export$13921ac0cc260818.Source.Microphone, enabled, options, publishOptions);
    }
    /**
   * Start or stop sharing a participant's screen
   * Resolves with a `LocalTrackPublication` instance if successful and `undefined` otherwise
   */ setScreenShareEnabled(enabled, options, publishOptions) {
        return this.setTrackEnabled($c0722d30b1d17141$export$13921ac0cc260818.Source.ScreenShare, enabled, options, publishOptions);
    }
    /** @internal */ setE2EEEnabled(enabled) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            const unlock = yield this.e2eeStateMutex.lock();
            try {
                this.encryptionType = enabled ? $c0722d30b1d17141$export$1efc488791285f20.GCM : $c0722d30b1d17141$export$1efc488791285f20.NONE;
                yield Promise.all(this.pendingPublishPromises.values());
                if (this.trackPublications.size === 0 || Array.from(this.trackPublications.values()).every((pub)=>pub.isEncrypted === enabled)) return;
                yield this.republishAllTracks(undefined, false);
            } finally{
                unlock();
            }
        });
    }
    setTrackEnabled(source, enabled, options, publishOptions) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            this.log.debug('setTrackEnabled', {
                source: source,
                enabled: enabled
            });
            if (this.republishPromise) yield this.republishPromise;
            let track = this.getTrackPublication(source);
            if (enabled) {
                if (track) yield track.unmute();
                else {
                    let localTracks;
                    if (this.pendingPublishing.has(source)) {
                        const pendingTrack = yield this.waitForPendingPublicationOfSource(source);
                        if (!pendingTrack) this.log.info('waiting for pending publication promise timed out', {
                            source: source
                        });
                        yield pendingTrack === null || pendingTrack === void 0 ? void 0 : pendingTrack.unmute();
                        return pendingTrack;
                    }
                    this.pendingPublishing.add(source);
                    try {
                        switch(source){
                            case $c0722d30b1d17141$export$13921ac0cc260818.Source.Camera:
                                localTracks = yield this.createTracks({
                                    video: (_a = options) !== null && _a !== void 0 ? _a : true
                                });
                                break;
                            case $c0722d30b1d17141$export$13921ac0cc260818.Source.Microphone:
                                localTracks = yield this.createTracks({
                                    audio: (_b = options) !== null && _b !== void 0 ? _b : true
                                });
                                break;
                            case $c0722d30b1d17141$export$13921ac0cc260818.Source.ScreenShare:
                                localTracks = yield this.createScreenTracks(Object.assign({}, options));
                                break;
                            default:
                                throw new $c0722d30b1d17141$export$4fbb9423b5747257(source);
                        }
                    } catch (e) {
                        localTracks === null || localTracks === void 0 || localTracks.forEach((tr)=>{
                            tr.stop();
                        });
                        if (e instanceof Error) this.emit($c0722d30b1d17141$export$fcdfe2b7a6750691.MediaDevicesError, e, $c0722d30b1d17141$var$sourceToKind(source));
                        this.pendingPublishing.delete(source);
                        throw e;
                    }
                    for (const localTrack of localTracks){
                        const opts = Object.assign(Object.assign({}, this.roomOptions.publishDefaults), options);
                        if (source === $c0722d30b1d17141$export$13921ac0cc260818.Source.Microphone && $c0722d30b1d17141$export$228726644c3d75db(localTrack) && opts.preConnectBuffer) {
                            this.log.info('starting preconnect buffer for microphone');
                            localTrack.startPreConnectBuffer();
                        }
                    }
                    try {
                        const publishPromises = [];
                        for (const localTrack of localTracks){
                            this.log.info('publishing track', $c0722d30b1d17141$var$getLogContextFromTrack(localTrack));
                            publishPromises.push(this.publishTrack(localTrack, publishOptions));
                        }
                        const publishedTracks = yield Promise.all(publishPromises);
                        // for screen share publications including audio, this will only return the screen share publication, not the screen share audio one
                        // revisit if we want to return an array of tracks instead for v2
                        [track] = publishedTracks;
                    } catch (e) {
                        localTracks === null || localTracks === void 0 || localTracks.forEach((tr)=>{
                            tr.stop();
                        });
                        throw e;
                    } finally{
                        this.pendingPublishing.delete(source);
                    }
                }
            } else {
                if (!(track === null || track === void 0 ? void 0 : track.track) && this.pendingPublishing.has(source)) {
                    // if there's no track available yet first wait for pending publishing promises of that source to see if it becomes available
                    track = yield this.waitForPendingPublicationOfSource(source);
                    if (!track) this.log.info('waiting for pending publication promise timed out', {
                        source: source
                    });
                }
                if (track && track.track) {
                    // screenshare cannot be muted, unpublish instead
                    if (source === $c0722d30b1d17141$export$13921ac0cc260818.Source.ScreenShare) {
                        const unpublishPromises = [
                            this.unpublishTrack(track.track)
                        ];
                        const screenAudioTrack = this.getTrackPublication($c0722d30b1d17141$export$13921ac0cc260818.Source.ScreenShareAudio);
                        if (screenAudioTrack && screenAudioTrack.track) unpublishPromises.push(this.unpublishTrack(screenAudioTrack.track));
                        [track] = yield Promise.all(unpublishPromises);
                    } else yield track.mute();
                }
            }
            return track;
        });
    }
    /**
   * Publish both camera and microphone at the same time. This is useful for
   * displaying a single Permission Dialog box to the end user.
   */ enableCameraAndMicrophone() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            if (this.pendingPublishing.has($c0722d30b1d17141$export$13921ac0cc260818.Source.Camera) || this.pendingPublishing.has($c0722d30b1d17141$export$13921ac0cc260818.Source.Microphone)) // no-op it's already been requested
            return;
            this.pendingPublishing.add($c0722d30b1d17141$export$13921ac0cc260818.Source.Camera);
            this.pendingPublishing.add($c0722d30b1d17141$export$13921ac0cc260818.Source.Microphone);
            try {
                const tracks = yield this.createTracks({
                    audio: true,
                    video: true
                });
                yield Promise.all(tracks.map((track)=>this.publishTrack(track)));
            } finally{
                this.pendingPublishing.delete($c0722d30b1d17141$export$13921ac0cc260818.Source.Camera);
                this.pendingPublishing.delete($c0722d30b1d17141$export$13921ac0cc260818.Source.Microphone);
            }
        });
    }
    /**
   * Create local camera and/or microphone tracks
   * @param options
   * @returns
   */ createTracks(options) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            options !== null && options !== void 0 ? options : options = {};
            const mergedOptionsWithProcessors = $c0722d30b1d17141$var$mergeDefaultOptions(options, (_a = this.roomOptions) === null || _a === void 0 ? void 0 : _a.audioCaptureDefaults, (_b = this.roomOptions) === null || _b === void 0 ? void 0 : _b.videoCaptureDefaults);
            try {
                const tracks = yield $c0722d30b1d17141$export$61cce20000b22feb(mergedOptionsWithProcessors, {
                    loggerName: this.roomOptions.loggerName,
                    loggerContextCb: ()=>this.logContext
                });
                const localTracks = tracks.map((track)=>{
                    if ($c0722d30b1d17141$export$228726644c3d75db(track)) {
                        this.microphoneError = undefined;
                        track.setAudioContext(this.audioContext);
                        track.source = $c0722d30b1d17141$export$13921ac0cc260818.Source.Microphone;
                        this.emit($c0722d30b1d17141$export$fcdfe2b7a6750691.AudioStreamAcquired);
                    }
                    if ($c0722d30b1d17141$export$372680e3a49e7e3e(track)) {
                        this.cameraError = undefined;
                        track.source = $c0722d30b1d17141$export$13921ac0cc260818.Source.Camera;
                    }
                    return track;
                });
                return localTracks;
            } catch (err) {
                if (err instanceof Error) {
                    if (options.audio) this.microphoneError = err;
                    if (options.video) this.cameraError = err;
                }
                throw err;
            }
        });
    }
    /**
   * Creates a screen capture tracks with getDisplayMedia().
   * A LocalVideoTrack is always created and returned.
   * If { audio: true }, and the browser supports audio capture, a LocalAudioTrack is also created.
   */ createScreenTracks(options) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            if (options === undefined) options = {};
            if (navigator.mediaDevices.getDisplayMedia === undefined) throw new $c0722d30b1d17141$export$38c5ac268e2fa84('getDisplayMedia not supported');
            if (options.resolution === undefined && !$c0722d30b1d17141$var$isSafari17Based()) // we need to constrain the dimensions, otherwise it could lead to low bitrate
            // due to encoding a huge video. Encoding such large surfaces is really expensive
            // unfortunately Safari 17 has a but and cannot be constrained by default
            options.resolution = $c0722d30b1d17141$export$a6cdf9dcd3d32f2d.h1080fps30.resolution;
            const constraints = $c0722d30b1d17141$var$screenCaptureToDisplayMediaStreamOptions(options);
            const stream = yield navigator.mediaDevices.getDisplayMedia(constraints);
            const tracks = stream.getVideoTracks();
            if (tracks.length === 0) throw new $c0722d30b1d17141$export$4fbb9423b5747257('no video track found');
            const screenVideo = new $c0722d30b1d17141$export$d5ffd2c62c538bdc(tracks[0], undefined, false, {
                loggerName: this.roomOptions.loggerName,
                loggerContextCb: ()=>this.logContext
            });
            screenVideo.source = $c0722d30b1d17141$export$13921ac0cc260818.Source.ScreenShare;
            if (options.contentHint) screenVideo.mediaStreamTrack.contentHint = options.contentHint;
            const localTracks = [
                screenVideo
            ];
            if (stream.getAudioTracks().length > 0) {
                this.emit($c0722d30b1d17141$export$fcdfe2b7a6750691.AudioStreamAcquired);
                const screenAudio = new $c0722d30b1d17141$export$b287427b771ca237(stream.getAudioTracks()[0], undefined, false, this.audioContext, {
                    loggerName: this.roomOptions.loggerName,
                    loggerContextCb: ()=>this.logContext
                });
                screenAudio.source = $c0722d30b1d17141$export$13921ac0cc260818.Source.ScreenShareAudio;
                localTracks.push(screenAudio);
            }
            return localTracks;
        });
    }
    /**
   * Publish a new track to the room
   * @param track
   * @param options
   */ publishTrack(track, options) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            return this.publishOrRepublishTrack(track, options);
        });
    }
    /**
   * Waits for the engine's next `Restarted` event. Unlike `engine.waitForRestarted`, this does
   * not short-circuit when `pcState === Connected` — at the point this is called (right after a
   * `NegotiationError`) the PC transport is still connected, but `fullReconnectOnNext` has been
   * set and `attemptReconnect` is queued via setTimeout. We need to wait for that restart to
   * actually complete (which clears `pendingTrackResolvers` via `cleanupClient`) before retrying.
   */ waitForNextEngineRestart() {
        let timeoutMs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 15000;
        return new Promise((resolve, reject)=>{
            const cleanup = ()=>{
                clearTimeout(timeout);
                this.engine.off($c0722d30b1d17141$export$c09e63b8572f869.Restarted, onRestarted);
                this.engine.off($c0722d30b1d17141$export$c09e63b8572f869.Closing, onClosing);
            };
            const onRestarted = ()=>{
                cleanup();
                resolve();
            };
            const onClosing = ()=>{
                cleanup();
                reject(new Error('engine closed before restart completed'));
            };
            const timeout = setTimeout(()=>{
                cleanup();
                reject(new Error('timed out waiting for engine restart'));
            }, timeoutMs);
            this.engine.once($c0722d30b1d17141$export$c09e63b8572f869.Restarted, onRestarted);
            this.engine.once($c0722d30b1d17141$export$c09e63b8572f869.Closing, onClosing);
        });
    }
    publishOrRepublishTrack(track_1, options_1) {
        return $c0722d30b1d17141$var$__awaiter(this, arguments, void 0, function(track, options) {
            var _this2 = this;
            let isRepublish = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            let hasRetriedAfterNegotiationError = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
            return function*() {
                var _a, _b, _c, _d;
                if ($c0722d30b1d17141$var$isLocalAudioTrack(track)) track.setAudioContext(_this2.audioContext);
                yield (_a = _this2.reconnectFuture) === null || _a === void 0 ? void 0 : _a.promise;
                if (_this2.republishPromise && !isRepublish) yield _this2.republishPromise;
                if ($c0722d30b1d17141$export$1fcfd1ae3646c28c(track) && _this2.pendingPublishPromises.has(track)) yield _this2.pendingPublishPromises.get(track);
                let defaultConstraints;
                if (track instanceof MediaStreamTrack) defaultConstraints = track.getConstraints();
                else {
                    // we want to access constraints directly as `track.mediaStreamTrack`
                    // might be pointing to a non-device track (e.g. processed track) already
                    defaultConstraints = track.constraints;
                    let deviceKind = undefined;
                    switch(track.source){
                        case $c0722d30b1d17141$export$13921ac0cc260818.Source.Microphone:
                            deviceKind = 'audioinput';
                            break;
                        case $c0722d30b1d17141$export$13921ac0cc260818.Source.Camera:
                            deviceKind = 'videoinput';
                    }
                    if (deviceKind && _this2.activeDeviceMap.has(deviceKind)) defaultConstraints = Object.assign(Object.assign({}, defaultConstraints), {
                        deviceId: _this2.activeDeviceMap.get(deviceKind)
                    });
                }
                // convert raw media track into audio or video track
                if (track instanceof MediaStreamTrack) switch(track.kind){
                    case 'audio':
                        track = new $c0722d30b1d17141$export$b287427b771ca237(track, defaultConstraints, true, _this2.audioContext, {
                            loggerName: _this2.roomOptions.loggerName,
                            loggerContextCb: ()=>_this2.logContext
                        });
                        break;
                    case 'video':
                        track = new $c0722d30b1d17141$export$d5ffd2c62c538bdc(track, defaultConstraints, true, {
                            loggerName: _this2.roomOptions.loggerName,
                            loggerContextCb: ()=>_this2.logContext
                        });
                        break;
                    default:
                        throw new $c0722d30b1d17141$export$4fbb9423b5747257("unsupported MediaStreamTrack kind ".concat(track.kind));
                }
                else track.updateLoggerOptions({
                    loggerName: _this2.roomOptions.loggerName,
                    loggerContextCb: ()=>_this2.logContext
                });
                // is it already published? if so skip
                let existingPublication;
                _this2.trackPublications.forEach((publication)=>{
                    if (!publication.track) return;
                    if (publication.track === track) existingPublication = publication;
                });
                if (existingPublication) {
                    _this2.log.warn('track has already been published, skipping', $c0722d30b1d17141$var$getLogContextFromTrack(existingPublication));
                    return existingPublication;
                }
                const opts = Object.assign(Object.assign({}, _this2.roomOptions.publishDefaults), options);
                const isStereoInput = 'channelCount' in track.mediaStreamTrack.getSettings() && // @ts-ignore `channelCount` on getSettings() is currently only available for Safari, but is generally the best way to determine a stereo track https://developer.mozilla.org/en-US/docs/Web/API/MediaTrackSettings/channelCount
                track.mediaStreamTrack.getSettings().channelCount === 2 || track.mediaStreamTrack.getConstraints().channelCount === 2;
                const isStereo = (_b = opts.forceStereo) !== null && _b !== void 0 ? _b : isStereoInput;
                // disable dtx for stereo track if not enabled explicitly
                if (isStereo) {
                    if (opts.dtx === undefined) _this2.log.debug("Opus DTX will be disabled for stereo tracks by default. Enable them explicitly to make it work.", $c0722d30b1d17141$var$getLogContextFromTrack(track));
                    if (opts.red === undefined) _this2.log.debug("Opus RED will be disabled for stereo tracks by default. Enable them explicitly to make it work.");
                    (_c = opts.dtx) !== null && _c !== void 0 ? _c : opts.dtx = false;
                    (_d = opts.red) !== null && _d !== void 0 ? _d : opts.red = false;
                }
                if (!$c0722d30b1d17141$var$isE2EESimulcastSupported() && _this2.roomOptions.e2ee) {
                    _this2.log.info("End-to-end encryption is set up, simulcast publishing will be disabled on Safari versions and iOS browsers running iOS < v17.2");
                    opts.simulcast = false;
                }
                if (opts.source) track.source = opts.source;
                const publishPromise = new Promise((resolve, reject)=>$c0722d30b1d17141$var$__awaiter(_this2, void 0, void 0, function*() {
                        try {
                            if (this.engine.client.currentState !== $c0722d30b1d17141$var$SignalConnectionState.CONNECTED) {
                                this.log.debug('deferring track publication until signal is connected', {
                                    track: $c0722d30b1d17141$var$getLogContextFromTrack(track)
                                });
                                let publicationTimedOut = false;
                                const timeout = setTimeout(()=>{
                                    publicationTimedOut = true;
                                    track.stop();
                                    reject(new $c0722d30b1d17141$export$7604ff526573fd27('publishing rejected as engine not connected within timeout', 408));
                                }, 15000);
                                yield this.waitUntilEngineConnected();
                                clearTimeout(timeout);
                                if (publicationTimedOut) return;
                                const publication = yield this.publish(track, opts, isStereo);
                                resolve(publication);
                            } else try {
                                const publication = yield this.publish(track, opts, isStereo);
                                resolve(publication);
                            } catch (e) {
                                reject(e);
                            }
                        } catch (e) {
                            reject(e);
                        }
                    }));
                _this2.pendingPublishPromises.set(track, publishPromise);
                try {
                    const publication = yield publishPromise;
                    return publication;
                } catch (e) {
                    if (!hasRetriedAfterNegotiationError && e instanceof $c0722d30b1d17141$export$18c2792bacf23e39) {
                        _this2.log.warn('negotiation due to track publish failed, retrying after reconnect', {
                            error: e
                        });
                        _this2.pendingPublishPromises.delete(track);
                        yield _this2.waitForNextEngineRestart();
                        return yield _this2.publishOrRepublishTrack(track, options, isRepublish, true);
                    }
                    throw e;
                } finally{
                    _this2.pendingPublishPromises.delete(track);
                }
            }();
        });
    }
    waitUntilEngineConnected() {
        if (!this.signalConnectedFuture) this.signalConnectedFuture = new $c0722d30b1d17141$var$Future();
        return this.signalConnectedFuture.promise;
    }
    hasPermissionsToPublish(track) {
        if (!this.permissions) {
            this.log.warn('no permissions present for publishing track', $c0722d30b1d17141$var$getLogContextFromTrack(track));
            return false;
        }
        const { canPublish: canPublish, canPublishSources: canPublishSources } = this.permissions;
        if (canPublish && (canPublishSources.length === 0 || canPublishSources.map((source)=>$c0722d30b1d17141$var$getTrackSourceFromProto(source)).includes(track.source))) return true;
        this.log.warn('insufficient permissions to publish', $c0722d30b1d17141$var$getLogContextFromTrack(track));
        return false;
    }
    publish(track, opts, isStereo) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            if (!this.hasPermissionsToPublish(track)) throw new $c0722d30b1d17141$export$7604ff526573fd27('failed to publish track, insufficient permissions', 403);
            const existingTrackOfSource = Array.from(this.trackPublications.values()).find((publishedTrack)=>$c0722d30b1d17141$export$1fcfd1ae3646c28c(track) && publishedTrack.source === track.source);
            if (existingTrackOfSource && track.source !== $c0722d30b1d17141$export$13921ac0cc260818.Source.Unknown) this.log.info("publishing a second track with the same source: ".concat(track.source), $c0722d30b1d17141$var$getLogContextFromTrack(track));
            if (opts.stopMicTrackOnMute && $c0722d30b1d17141$export$228726644c3d75db(track)) track.stopOnMute = true;
            if (track.source === $c0722d30b1d17141$export$13921ac0cc260818.Source.ScreenShare && $c0722d30b1d17141$var$isFireFox()) // Firefox does not work well with simulcasted screen share
            // we frequently get no data on layer 0 when enabled
            opts.simulcast = false;
            // require full AV1/VP9 SVC support prior to using it
            if (opts.videoCodec === 'av1' && !$c0722d30b1d17141$export$f157b33fe3596be1()) opts.videoCodec = undefined;
            if (opts.videoCodec === 'vp9' && !$c0722d30b1d17141$export$7c4c0f8271043129()) opts.videoCodec = undefined;
            if (opts.videoCodec === undefined) opts.videoCodec = $c0722d30b1d17141$var$defaultVideoCodec;
            if (this.enabledPublishVideoCodecs.length > 0) // fallback to a supported codec if it is not supported
            {
                if (!this.enabledPublishVideoCodecs.some((c)=>opts.videoCodec === $c0722d30b1d17141$var$mimeTypeToVideoCodecString(c.mime))) opts.videoCodec = $c0722d30b1d17141$var$mimeTypeToVideoCodecString(this.enabledPublishVideoCodecs[0].mime);
            }
            const videoCodec = opts.videoCodec;
            // handle track actions
            track.on($c0722d30b1d17141$export$2c8510d737cc09da.Muted, this.onTrackMuted);
            track.on($c0722d30b1d17141$export$2c8510d737cc09da.Unmuted, this.onTrackUnmuted);
            track.on($c0722d30b1d17141$export$2c8510d737cc09da.Ended, this.handleTrackEnded);
            track.on($c0722d30b1d17141$export$2c8510d737cc09da.UpstreamPaused, this.onTrackUpstreamPaused);
            track.on($c0722d30b1d17141$export$2c8510d737cc09da.UpstreamResumed, this.onTrackUpstreamResumed);
            track.on($c0722d30b1d17141$export$2c8510d737cc09da.AudioTrackFeatureUpdate, this.onTrackFeatureUpdate);
            const audioFeatures = [];
            const disableDtx = !((_a = opts.dtx) !== null && _a !== void 0 ? _a : true);
            const settings = track.getSourceTrackSettings();
            if (settings.autoGainControl) audioFeatures.push($c0722d30b1d17141$var$AudioTrackFeature.TF_AUTO_GAIN_CONTROL);
            if (settings.echoCancellation) audioFeatures.push($c0722d30b1d17141$var$AudioTrackFeature.TF_ECHO_CANCELLATION);
            if (settings.noiseSuppression) audioFeatures.push($c0722d30b1d17141$var$AudioTrackFeature.TF_NOISE_SUPPRESSION);
            if (settings.channelCount && settings.channelCount > 1) audioFeatures.push($c0722d30b1d17141$var$AudioTrackFeature.TF_STEREO);
            if (disableDtx) audioFeatures.push($c0722d30b1d17141$var$AudioTrackFeature.TF_NO_DTX);
            if ($c0722d30b1d17141$var$isLocalAudioTrack(track) && track.hasPreConnectBuffer) audioFeatures.push($c0722d30b1d17141$var$AudioTrackFeature.TF_PRECONNECT_BUFFER);
            // create track publication from track
            const req = new $c0722d30b1d17141$var$AddTrackRequest({
                // get local track id for use during publishing
                cid: track.mediaStreamTrack.id,
                name: opts.name,
                type: $c0722d30b1d17141$export$13921ac0cc260818.kindToProto(track.kind),
                muted: track.isMuted,
                source: $c0722d30b1d17141$export$13921ac0cc260818.sourceToProto(track.source),
                disableDtx: disableDtx,
                encryption: this.encryptionType,
                stereo: isStereo,
                disableRed: this.isE2EEEnabled || !((_b = opts.red) !== null && _b !== void 0 ? _b : true),
                stream: opts === null || opts === void 0 ? void 0 : opts.stream,
                backupCodecPolicy: opts === null || opts === void 0 ? void 0 : opts.backupCodecPolicy,
                audioFeatures: audioFeatures
            });
            // compute encodings and layers for video
            let encodings;
            if (track.kind === $c0722d30b1d17141$export$13921ac0cc260818.Kind.Video) {
                let dims = {
                    width: 0,
                    height: 0
                };
                try {
                    dims = yield track.waitForDimensions();
                } catch (e) {
                    // use defaults, it's quite painful for congestion control without simulcast
                    // so using default dims according to publish settings
                    const defaultRes = (_d = (_c = this.roomOptions.videoCaptureDefaults) === null || _c === void 0 ? void 0 : _c.resolution) !== null && _d !== void 0 ? _d : $c0722d30b1d17141$export$79d56065dad1674c.h720.resolution;
                    dims = {
                        width: defaultRes.width,
                        height: defaultRes.height
                    };
                    // log failure
                    this.log.error('could not determine track dimensions, using defaults', Object.assign(Object.assign({}, $c0722d30b1d17141$var$getLogContextFromTrack(track)), {
                        dims: dims
                    }));
                }
                // width and height should be defined for video
                req.width = dims.width;
                req.height = dims.height;
                // for svc codecs, disable simulcast and use vp8 for backup codec
                if ($c0722d30b1d17141$var$isLocalVideoTrack(track)) {
                    if ($c0722d30b1d17141$var$isSVCCodec(videoCodec)) {
                        if (track.source === $c0722d30b1d17141$export$13921ac0cc260818.Source.ScreenShare) {
                            // vp9 svc with screenshare cannot encode multiple spatial layers
                            // doing so reduces publish resolution to minimal resolution
                            opts.scalabilityMode = 'L1T3';
                            // Chrome does not allow more than 5 fps with L1T3, and it has encoding bugs with L3T3
                            // It has a different path for screenshare handling and it seems to be untested/buggy
                            // As a workaround, we are setting contentHint to force it to go through the same
                            // path as regular camera video. While this is not optimal, it delivers the performance
                            // that we need
                            if ('contentHint' in track.mediaStreamTrack) {
                                track.mediaStreamTrack.contentHint = 'motion';
                                this.log.debug('forcing contentHint to motion for screenshare with SVC codecs', $c0722d30b1d17141$var$getLogContextFromTrack(track));
                            }
                        }
                        // set scalabilityMode to 'L3T3_KEY' by default
                        opts.scalabilityMode = (_e = opts.scalabilityMode) !== null && _e !== void 0 ? _e : 'L3T3_KEY';
                    }
                    req.simulcastCodecs = [
                        new $c0722d30b1d17141$var$SimulcastCodec({
                            codec: videoCodec,
                            cid: track.mediaStreamTrack.id
                        })
                    ];
                    // set up backup
                    if (opts.backupCodec === true) opts.backupCodec = {
                        codec: $c0722d30b1d17141$var$defaultVideoCodec
                    };
                    if (opts.backupCodec && videoCodec !== opts.backupCodec.codec && // TODO remove this once e2ee is supported for backup codecs
                    req.encryption === $c0722d30b1d17141$export$1efc488791285f20.NONE) {
                        // multi-codec simulcast requires dynacast
                        if (!this.roomOptions.dynacast) this.roomOptions.dynacast = true;
                        req.simulcastCodecs.push(new $c0722d30b1d17141$var$SimulcastCodec({
                            codec: opts.backupCodec.codec,
                            cid: ''
                        }));
                    }
                }
                encodings = $c0722d30b1d17141$var$computeVideoEncodings(track.source === $c0722d30b1d17141$export$13921ac0cc260818.Source.ScreenShare, req.width, req.height, opts);
                req.layers = $c0722d30b1d17141$var$videoLayersFromEncodings(req.width, req.height, encodings, $c0722d30b1d17141$var$isSVCCodec(opts.videoCodec));
            } else if (track.kind === $c0722d30b1d17141$export$13921ac0cc260818.Kind.Audio) encodings = [
                {
                    maxBitrate: (_f = opts.audioPreset) === null || _f === void 0 ? void 0 : _f.maxBitrate,
                    priority: (_h = (_g = opts.audioPreset) === null || _g === void 0 ? void 0 : _g.priority) !== null && _h !== void 0 ? _h : 'high',
                    networkPriority: (_k = (_j = opts.audioPreset) === null || _j === void 0 ? void 0 : _j.priority) !== null && _k !== void 0 ? _k : 'high'
                }
            ];
            if (!this.engine || this.engine.isClosed) throw new $c0722d30b1d17141$export$1f388e244efbf70b('cannot publish track when not connected');
            const negotiate = ()=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b, _c;
                    if (!this.engine.pcManager) throw new $c0722d30b1d17141$export$1f388e244efbf70b('pcManager is not ready');
                    track.sender = yield this.engine.createSender(track, opts, encodings);
                    this.emit($c0722d30b1d17141$export$fcdfe2b7a6750691.LocalSenderCreated, track.sender, track);
                    if ($c0722d30b1d17141$var$isLocalVideoTrack(track)) {
                        (_a = opts.degradationPreference) !== null && _a !== void 0 ? _a : opts.degradationPreference = $c0722d30b1d17141$var$getDefaultDegradationPreference(track);
                        track.setDegradationPreference(opts.degradationPreference);
                    }
                    if (encodings) {
                        if ($c0722d30b1d17141$var$isFireFox() && track.kind === $c0722d30b1d17141$export$13921ac0cc260818.Kind.Audio) {
                            /* Refer to RFC https://datatracker.ietf.org/doc/html/rfc7587#section-6.1,
               livekit-server uses maxaveragebitrate=510000 in the answer sdp to permit client to
               publish high quality audio track. But firefox always uses this value as the actual
               bitrates, causing the audio bitrates to rise to 510Kbps in any stereo case unexpectedly.
               So the client need to modify maxaverragebitrates in answer sdp to user provided value to
               fix the issue.
             */ let trackTransceiver = undefined;
                            for (const transceiver of this.engine.pcManager.publisher.getTransceivers())if (transceiver.sender === track.sender) {
                                trackTransceiver = transceiver;
                                break;
                            }
                            if (trackTransceiver) this.engine.pcManager.publisher.setTrackCodecBitrate({
                                transceiver: trackTransceiver,
                                codec: 'opus',
                                maxbr: ((_b = encodings[0]) === null || _b === void 0 ? void 0 : _b.maxBitrate) ? encodings[0].maxBitrate / 1000 : 0
                            });
                        } else if (track.codec && $c0722d30b1d17141$var$isSVCCodec(track.codec) && ((_c = encodings[0]) === null || _c === void 0 ? void 0 : _c.maxBitrate)) this.engine.pcManager.publisher.setTrackCodecBitrate({
                            cid: req.cid,
                            codec: track.codec,
                            maxbr: encodings[0].maxBitrate / 1000
                        });
                    }
                    yield this.engine.negotiate();
                });
            let ti;
            const addTrackPromise = new Promise((resolve, reject)=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                    var _a;
                    try {
                        ti = yield this.engine.addTrack(req);
                        resolve(ti);
                    } catch (err) {
                        if (track.sender && ((_a = this.engine.pcManager) === null || _a === void 0 ? void 0 : _a.publisher)) {
                            try {
                                this.engine.pcManager.publisher.removeTrack(track.sender);
                            } catch (e) {
                                this.log.error(e);
                            }
                            yield this.engine.negotiate().catch((negotiateErr)=>{
                                this.log.error('failed to negotiate after removing track due to failed add track request', Object.assign(Object.assign({}, $c0722d30b1d17141$var$getLogContextFromTrack(track)), {
                                    error: negotiateErr
                                }));
                            });
                        }
                        reject(err);
                    }
                }));
            if (this.enabledPublishVideoCodecs.length > 0) {
                const rets = yield Promise.all([
                    addTrackPromise,
                    negotiate()
                ]);
                ti = rets[0];
            } else {
                ti = yield addTrackPromise;
                // server might not support the codec the client has requested, in that case, fallback
                // to a supported codec
                let primaryCodecMime;
                ti.codecs.forEach((codec)=>{
                    if (primaryCodecMime === undefined) primaryCodecMime = codec.mimeType;
                });
                if (primaryCodecMime && track.kind === $c0722d30b1d17141$export$13921ac0cc260818.Kind.Video) {
                    const updatedCodec = $c0722d30b1d17141$var$mimeTypeToVideoCodecString(primaryCodecMime);
                    if (updatedCodec !== videoCodec) {
                        this.log.debug('falling back to server selected codec', Object.assign(Object.assign({}, $c0722d30b1d17141$var$getLogContextFromTrack(track)), {
                            codec: updatedCodec
                        }));
                        opts.videoCodec = updatedCodec;
                        // recompute encodings since bitrates/etc could have changed
                        encodings = $c0722d30b1d17141$var$computeVideoEncodings(track.source === $c0722d30b1d17141$export$13921ac0cc260818.Source.ScreenShare, req.width, req.height, opts);
                    }
                }
                yield negotiate();
            }
            const publication = new $c0722d30b1d17141$export$885a52c769210b3f(track.kind, ti, track, {
                loggerName: this.roomOptions.loggerName,
                loggerContextCb: ()=>this.logContext
            });
            publication.on($c0722d30b1d17141$export$2c8510d737cc09da.CpuConstrained, (constrainedTrack)=>this.onTrackCpuConstrained(constrainedTrack, publication));
            // save options for when it needs to be republished again
            publication.options = opts;
            track.sid = ti.sid;
            // keep publish options on the video track so that it can recompute encoding
            // parameters when the MediaStreamTrack is restarted (e.g. after switching cameras).
            // Seed the dimensions we encoded at publish time so the first no-op restart
            // (e.g. unmute with unchanged constraints) can skip the recompute.
            if ($c0722d30b1d17141$var$isLocalVideoTrack(track)) {
                track.publishOptions = opts;
                if (req.width && req.height) track.lastEncodedDimensions = {
                    width: req.width,
                    height: req.height
                };
            }
            this.log.debug("publishing ".concat(track.kind, " with encodings"), {
                encodings: encodings,
                trackInfo: ti
            });
            if ($c0722d30b1d17141$var$isLocalVideoTrack(track)) track.startMonitor(this.engine.client);
            else if ($c0722d30b1d17141$var$isLocalAudioTrack(track)) track.startMonitor();
            this.addTrackPublication(publication);
            // send event for publication
            this.emit($c0722d30b1d17141$export$fcdfe2b7a6750691.LocalTrackPublished, publication);
            if ($c0722d30b1d17141$var$isLocalAudioTrack(track) && ti.audioFeatures.includes($c0722d30b1d17141$var$AudioTrackFeature.TF_PRECONNECT_BUFFER)) {
                const stream = track.getPreConnectBuffer();
                const mimeType = track.getPreConnectBufferMimeType();
                // TODO: we're registering the listener after negotiation, so there might be a race
                this.on($c0722d30b1d17141$export$fcdfe2b7a6750691.LocalTrackSubscribed, (pub)=>{
                    if (pub.trackSid === ti.sid) {
                        if (!track.hasPreConnectBuffer) {
                            this.log.warn('subscribe event came to late, buffer already closed');
                            return;
                        }
                        this.log.debug('finished recording preconnect buffer', $c0722d30b1d17141$var$getLogContextFromTrack(track));
                        track.stopPreConnectBuffer();
                    }
                });
                if (stream) {
                    const bufferStreamPromise = new Promise((resolve, reject)=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                            var _a, e_2, _b, _c;
                            var _d, _e;
                            try {
                                this.log.debug('waiting for agent', $c0722d30b1d17141$var$getLogContextFromTrack(track));
                                const agentActiveTimeout = setTimeout(()=>{
                                    reject(new Error('agent not active within 10 seconds'));
                                }, 10000);
                                const agent = yield this.waitUntilActiveAgentPresent();
                                clearTimeout(agentActiveTimeout);
                                this.log.debug('sending preconnect buffer', $c0722d30b1d17141$var$getLogContextFromTrack(track));
                                const writer = yield this.streamBytes({
                                    name: 'preconnect-buffer',
                                    mimeType: mimeType,
                                    topic: 'lk.agent.pre-connect-audio-buffer',
                                    destinationIdentities: [
                                        agent.identity
                                    ],
                                    attributes: {
                                        trackId: publication.trackSid,
                                        sampleRate: String((_d = settings.sampleRate) !== null && _d !== void 0 ? _d : '48000'),
                                        channels: String((_e = settings.channelCount) !== null && _e !== void 0 ? _e : '1')
                                    }
                                });
                                try {
                                    for(var _f = true, stream_1 = $c0722d30b1d17141$var$__asyncValues(stream), stream_1_1; stream_1_1 = yield stream_1.next(), _a = stream_1_1.done, !_a; _f = true){
                                        _c = stream_1_1.value;
                                        _f = false;
                                        const chunk = _c;
                                        yield writer.write(chunk);
                                    }
                                } catch (e_2_1) {
                                    e_2 = {
                                        error: e_2_1
                                    };
                                } finally{
                                    try {
                                        if (!_f && !_a && (_b = stream_1.return)) yield _b.call(stream_1);
                                    } finally{
                                        if (e_2) throw e_2.error;
                                    }
                                }
                                yield writer.close();
                                resolve();
                            } catch (e) {
                                reject(e);
                            }
                        }));
                    bufferStreamPromise.then(()=>{
                        this.log.debug('preconnect buffer sent successfully', $c0722d30b1d17141$var$getLogContextFromTrack(track));
                    }).catch((e)=>{
                        this.log.error('error sending preconnect buffer', Object.assign(Object.assign({}, $c0722d30b1d17141$var$getLogContextFromTrack(track)), {
                            error: e
                        }));
                    });
                }
            }
            return publication;
        });
    }
    get isLocal() {
        return true;
    }
    /** @internal
   * publish additional codec to existing track
   */ publishAdditionalCodecForTrack(track, videoCodec, options) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            // TODO remove once e2ee is supported for backup tracks
            if (this.encryptionType !== $c0722d30b1d17141$export$1efc488791285f20.NONE) return;
            // is it not published? if so skip
            let existingPublication;
            this.trackPublications.forEach((publication)=>{
                if (!publication.track) return;
                if (publication.track === track) existingPublication = publication;
            });
            if (!existingPublication) throw new $c0722d30b1d17141$export$4fbb9423b5747257('track is not published');
            if (!$c0722d30b1d17141$var$isLocalVideoTrack(track)) throw new $c0722d30b1d17141$export$4fbb9423b5747257('track is not a video track');
            const opts = Object.assign(Object.assign({}, (_a = this.roomOptions) === null || _a === void 0 ? void 0 : _a.publishDefaults), options);
            const encodings = $c0722d30b1d17141$var$computeTrackBackupEncodings(track, videoCodec, opts);
            if (!encodings) {
                this.log.info("backup codec has been disabled, ignoring request to add additional codec for track", $c0722d30b1d17141$var$getLogContextFromTrack(track));
                return;
            }
            const simulcastTrack = track.addSimulcastTrack(videoCodec, encodings);
            if (!simulcastTrack) return;
            const req = new $c0722d30b1d17141$var$AddTrackRequest({
                cid: simulcastTrack.mediaStreamTrack.id,
                type: $c0722d30b1d17141$export$13921ac0cc260818.kindToProto(track.kind),
                muted: track.isMuted,
                source: $c0722d30b1d17141$export$13921ac0cc260818.sourceToProto(track.source),
                sid: track.sid,
                simulcastCodecs: [
                    {
                        codec: opts.videoCodec,
                        cid: simulcastTrack.mediaStreamTrack.id
                    }
                ]
            });
            req.layers = $c0722d30b1d17141$var$videoLayersFromEncodings(req.width, req.height, encodings);
            if (!this.engine || this.engine.isClosed) throw new $c0722d30b1d17141$export$1f388e244efbf70b('cannot publish track when not connected');
            const negotiate = ()=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                    yield this.engine.createSimulcastSender(track, simulcastTrack, opts, encodings);
                    yield this.engine.negotiate();
                });
            const rets = yield Promise.all([
                this.engine.addTrack(req),
                negotiate()
            ]);
            const ti = rets[0];
            this.log.debug("published ".concat(videoCodec, " for track ").concat(track.sid), {
                encodings: encodings,
                trackInfo: ti
            });
        });
    }
    unpublishTrack(track, stopOnUnpublish) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            if ($c0722d30b1d17141$export$1fcfd1ae3646c28c(track)) {
                const publishPromise = this.pendingPublishPromises.get(track);
                if (publishPromise) {
                    this.log.debug('awaiting publish promise before attempting to unpublish', $c0722d30b1d17141$var$getLogContextFromTrack(track));
                    yield publishPromise;
                }
            }
            // look through all published tracks to find the right ones
            const publication = this.getPublicationForTrack(track);
            const pubLogContext = publication ? $c0722d30b1d17141$var$getLogContextFromTrack(publication) : undefined;
            this.log.info('unpublishing track', pubLogContext);
            if (!publication || !publication.track) {
                this.log.warn('track was not unpublished because no publication was found', pubLogContext);
                return undefined;
            }
            track = publication.track;
            track.off($c0722d30b1d17141$export$2c8510d737cc09da.Muted, this.onTrackMuted);
            track.off($c0722d30b1d17141$export$2c8510d737cc09da.Unmuted, this.onTrackUnmuted);
            track.off($c0722d30b1d17141$export$2c8510d737cc09da.Ended, this.handleTrackEnded);
            track.off($c0722d30b1d17141$export$2c8510d737cc09da.UpstreamPaused, this.onTrackUpstreamPaused);
            track.off($c0722d30b1d17141$export$2c8510d737cc09da.UpstreamResumed, this.onTrackUpstreamResumed);
            track.off($c0722d30b1d17141$export$2c8510d737cc09da.AudioTrackFeatureUpdate, this.onTrackFeatureUpdate);
            if (stopOnUnpublish === undefined) stopOnUnpublish = (_b = (_a = this.roomOptions) === null || _a === void 0 ? void 0 : _a.stopLocalTrackOnUnpublish) !== null && _b !== void 0 ? _b : true;
            if (stopOnUnpublish) track.stop();
            else track.stopMonitor();
            let negotiationNeeded = false;
            const trackSender = track.sender;
            track.sender = undefined;
            if (this.engine.pcManager && this.engine.pcManager.currentState < $c0722d30b1d17141$var$PCTransportState.FAILED && trackSender) try {
                for (const transceiver of this.engine.pcManager.publisher.getTransceivers())// if sender is not currently sending (after replaceTrack(null))
                // removeTrack would have no effect.
                // to ensure we end up successfully removing the track, manually set
                // the transceiver to inactive
                if (transceiver.sender === trackSender) {
                    transceiver.direction = 'inactive';
                    negotiationNeeded = true;
                }
                try {
                    negotiationNeeded = this.engine.removeTrack(trackSender);
                } catch (e) {
                    this.log.warn(e);
                    negotiationNeeded = true;
                }
                if ($c0722d30b1d17141$var$isLocalVideoTrack(track)) {
                    for (const [, trackInfo] of track.simulcastCodecs)if (trackInfo.sender) {
                        try {
                            negotiationNeeded = this.engine.removeTrack(trackInfo.sender);
                        } catch (e) {
                            this.log.warn(e);
                            negotiationNeeded = true;
                        }
                        trackInfo.sender = undefined;
                    }
                    track.simulcastCodecs.clear();
                }
            } catch (e) {
                this.log.warn('failed to unpublish track', Object.assign(Object.assign({}, pubLogContext), {
                    error: e
                }));
            }
            // remove from our maps
            this.trackPublications.delete(publication.trackSid);
            switch(publication.kind){
                case $c0722d30b1d17141$export$13921ac0cc260818.Kind.Audio:
                    this.audioTrackPublications.delete(publication.trackSid);
                    break;
                case $c0722d30b1d17141$export$13921ac0cc260818.Kind.Video:
                    this.videoTrackPublications.delete(publication.trackSid);
                    break;
            }
            this.emit($c0722d30b1d17141$export$fcdfe2b7a6750691.LocalTrackUnpublished, publication);
            publication.setTrack(undefined);
            if (negotiationNeeded) yield this.engine.negotiate();
            return publication;
        });
    }
    unpublishTracks(tracks) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            const results = yield Promise.all(tracks.map((track)=>this.unpublishTrack(track)));
            return results.filter((track)=>!!track);
        });
    }
    republishAllTracks(options_1) {
        return $c0722d30b1d17141$var$__awaiter(this, arguments, void 0, function(options) {
            var _this3 = this;
            let restartTracks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            return function*() {
                if (_this3.republishPromise) yield _this3.republishPromise;
                _this3.republishPromise = new $c0722d30b1d17141$var$TypedPromise((resolve, reject)=>$c0722d30b1d17141$var$__awaiter(_this3, void 0, void 0, function*() {
                        try {
                            const localPubs = [];
                            this.trackPublications.forEach((pub)=>{
                                if (pub.track) {
                                    if (options) pub.options = Object.assign(Object.assign({}, pub.options), options);
                                    localPubs.push(pub);
                                }
                            });
                            yield Promise.all(localPubs.map((pub)=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                                    const track = pub.track;
                                    yield this.unpublishTrack(track, false);
                                    if (restartTracks && !track.isMuted && track.source !== $c0722d30b1d17141$export$13921ac0cc260818.Source.ScreenShare && track.source !== $c0722d30b1d17141$export$13921ac0cc260818.Source.ScreenShareAudio && ($c0722d30b1d17141$var$isLocalAudioTrack(track) || $c0722d30b1d17141$var$isLocalVideoTrack(track)) && !track.isUserProvided) {
                                        // generally we need to restart the track before publishing, often a full reconnect
                                        // is necessary because computer had gone to sleep.
                                        this.log.debug('restarting existing track', {
                                            track: pub.trackSid
                                        });
                                        yield track.restartTrack();
                                    }
                                    yield this.publishOrRepublishTrack(track, pub.options, true);
                                })));
                            resolve();
                        } catch (error) {
                            if (error instanceof Error) reject(error);
                            else reject(new Error(String(error)));
                        } finally{
                            this.republishPromise = undefined;
                        }
                    }));
                yield _this3.republishPromise;
            }();
        });
    }
    /**
   * Publish a new data payload to the room. Data will be forwarded to each
   * participant in the room if the destination field in publishOptions is empty
   *
   * @param data Uint8Array of the payload. To send string data, use TextEncoder.encode
   * @param options optionally specify a `reliable`, `topic` and `destination`
   */ publishData(data_1) {
        return $c0722d30b1d17141$var$__awaiter(this, arguments, void 0, function(data) {
            var _this4 = this;
            let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            return function*() {
                const kind = options.reliable ? $c0722d30b1d17141$var$DataChannelKind.RELIABLE : $c0722d30b1d17141$var$DataChannelKind.LOSSY;
                const dataPacketKind = options.reliable ? $c0722d30b1d17141$export$629a0ea4ceb9e4a6.RELIABLE : $c0722d30b1d17141$export$629a0ea4ceb9e4a6.LOSSY;
                const destinationIdentities = options.destinationIdentities;
                const topic = options.topic;
                let userPacket = new $c0722d30b1d17141$var$UserPacket({
                    participantIdentity: _this4.identity,
                    payload: data,
                    destinationIdentities: destinationIdentities,
                    topic: topic
                });
                const packet = new $c0722d30b1d17141$var$DataPacket({
                    kind: dataPacketKind,
                    value: {
                        case: 'user',
                        value: userPacket
                    }
                });
                yield _this4.engine.sendDataPacket(packet, kind);
            }();
        });
    }
    /**
   * Publish SIP DTMF message to the room.
   *
   * @param code DTMF code
   * @param digit DTMF digit
   */ publishDtmf(code, digit) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            const packet = new $c0722d30b1d17141$var$DataPacket({
                kind: $c0722d30b1d17141$export$629a0ea4ceb9e4a6.RELIABLE,
                value: {
                    case: 'sipDtmf',
                    value: new $c0722d30b1d17141$var$SipDTMF({
                        code: code,
                        digit: digit
                    })
                }
            });
            yield this.engine.sendDataPacket(packet, $c0722d30b1d17141$var$DataChannelKind.RELIABLE);
        });
    }
    /** @deprecated Consider migrating to {@link sendText} */ sendChatMessage(text, options) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            const msg = {
                id: crypto.randomUUID(),
                message: text,
                timestamp: Date.now(),
                attachedFiles: options === null || options === void 0 ? void 0 : options.attachments
            };
            const packet = new $c0722d30b1d17141$var$DataPacket({
                value: {
                    case: 'chatMessage',
                    value: new $c0722d30b1d17141$var$ChatMessage(Object.assign(Object.assign({}, msg), {
                        timestamp: $c0722d30b1d17141$var$protoInt64.parse(msg.timestamp)
                    }))
                }
            });
            yield this.engine.sendDataPacket(packet, $c0722d30b1d17141$var$DataChannelKind.RELIABLE);
            this.emit($c0722d30b1d17141$export$fcdfe2b7a6750691.ChatMessage, msg);
            return msg;
        });
    }
    /** @deprecated Consider migrating to {@link sendText} */ editChatMessage(editText, originalMessage) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            const msg = Object.assign(Object.assign({}, originalMessage), {
                message: editText,
                editTimestamp: Date.now()
            });
            const packet = new $c0722d30b1d17141$var$DataPacket({
                value: {
                    case: 'chatMessage',
                    value: new $c0722d30b1d17141$var$ChatMessage(Object.assign(Object.assign({}, msg), {
                        timestamp: $c0722d30b1d17141$var$protoInt64.parse(msg.timestamp),
                        editTimestamp: $c0722d30b1d17141$var$protoInt64.parse(msg.editTimestamp)
                    }))
                }
            });
            yield this.engine.sendDataPacket(packet, $c0722d30b1d17141$var$DataChannelKind.RELIABLE);
            this.emit($c0722d30b1d17141$export$fcdfe2b7a6750691.ChatMessage, msg);
            return msg;
        });
    }
    /**
   * Sends the given string to participants in the room via the data channel.
   * For longer messages, consider using {@link streamText} instead.
   *
   * @param text The text payload
   * @param options.topic Topic identifier used to route the stream to appropriate handlers.
   */ sendText(text, options) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            return this.roomOutgoingDataStreamManager.sendText(text, options);
        });
    }
    /**
   * Creates a new TextStreamWriter which can be used to stream text incrementally
   * to participants in the room via the data channel.
   *
   * @param options.topic Topic identifier used to route the stream to appropriate handlers.
   *
   * @internal
   * @experimental CAUTION, might get removed in a minor release
   */ streamText(options) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            return this.roomOutgoingDataStreamManager.streamText(options);
        });
    }
    /** Send a File to all participants in the room via the data channel.
   * @param file The File object payload
   * @param options.topic Topic identifier used to route the stream to appropriate handlers.
   * @param options.onProgress A callback function used to monitor the upload progress percentage.
   */ sendFile(file, options) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            return this.roomOutgoingDataStreamManager.sendFile(file, options);
        });
    }
    /**
   * Stream bytes incrementally to participants in the room via the data channel.
   * For sending files, consider using {@link sendFile} instead.
   *
   * @param options.topic Topic identifier used to route the stream to appropriate handlers.
   */ streamBytes(options) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            return this.roomOutgoingDataStreamManager.streamBytes(options);
        });
    }
    /**
   * Initiate an RPC call to a remote participant
   * @param params - Parameters for initiating the RPC call, see {@link PerformRpcParams}
   * @returns A promise that resolves with the response payload or rejects with an error.
   * @throws Error on failure. Details in `message`.
   */ performRpc(_ref3) {
        let { destinationIdentity: destinationIdentity, method: method, payload: payload, responseTimeout: responseTimeout = 15000 } = _ref3;
        const maxRoundTripLatency = 7000;
        const minEffectiveTimeout = maxRoundTripLatency + 1000;
        return new $c0722d30b1d17141$var$TypedPromise((resolve, reject)=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                var _a, _b, _c, _d;
                if ($c0722d30b1d17141$var$byteLength(payload) > $c0722d30b1d17141$var$MAX_PAYLOAD_BYTES) {
                    reject($c0722d30b1d17141$export$5460eff990f31920.builtIn('REQUEST_PAYLOAD_TOO_LARGE'));
                    return;
                }
                if (((_b = (_a = this.engine.latestJoinResponse) === null || _a === void 0 ? void 0 : _a.serverInfo) === null || _b === void 0 ? void 0 : _b.version) && $c0722d30b1d17141$export$66e1c0999abad646((_d = (_c = this.engine.latestJoinResponse) === null || _c === void 0 ? void 0 : _c.serverInfo) === null || _d === void 0 ? void 0 : _d.version, '1.8.0') < 0) {
                    reject($c0722d30b1d17141$export$5460eff990f31920.builtIn('UNSUPPORTED_SERVER'));
                    return;
                }
                const effectiveTimeout = Math.max(responseTimeout, minEffectiveTimeout);
                const id = crypto.randomUUID();
                yield this.publishRpcRequest(destinationIdentity, id, method, payload, effectiveTimeout);
                const ackTimeoutId = setTimeout(()=>{
                    this.pendingAcks.delete(id);
                    reject($c0722d30b1d17141$export$5460eff990f31920.builtIn('CONNECTION_TIMEOUT'));
                    this.pendingResponses.delete(id);
                    clearTimeout(responseTimeoutId);
                }, maxRoundTripLatency);
                this.pendingAcks.set(id, {
                    resolve: ()=>{
                        clearTimeout(ackTimeoutId);
                    },
                    participantIdentity: destinationIdentity
                });
                const responseTimeoutId = setTimeout(()=>{
                    this.pendingResponses.delete(id);
                    reject($c0722d30b1d17141$export$5460eff990f31920.builtIn('RESPONSE_TIMEOUT'));
                }, responseTimeout);
                this.pendingResponses.set(id, {
                    resolve: (responsePayload, responseError)=>{
                        clearTimeout(responseTimeoutId);
                        if (this.pendingAcks.has(id)) {
                            this.log.warn('RPC response received before ack', id);
                            this.pendingAcks.delete(id);
                            clearTimeout(ackTimeoutId);
                        }
                        if (responseError) reject(responseError);
                        else resolve(responsePayload !== null && responsePayload !== void 0 ? responsePayload : '');
                    },
                    participantIdentity: destinationIdentity
                });
            }));
    }
    /**
   * @deprecated use `room.registerRpcMethod` instead
   */ registerRpcMethod(method, handler) {
        if (this.rpcHandlers.has(method)) this.log.warn("you're overriding the RPC handler for method ".concat(method, ", in the future this will throw an error"));
        this.rpcHandlers.set(method, handler);
    }
    /**
   * @deprecated use `room.unregisterRpcMethod` instead
   */ unregisterRpcMethod(method) {
        this.rpcHandlers.delete(method);
    }
    /**
   * Control who can subscribe to LocalParticipant's published tracks.
   *
   * By default, all participants can subscribe. This allows fine-grained control over
   * who is able to subscribe at a participant and track level.
   *
   * Note: if access is given at a track-level (i.e. both [allParticipantsAllowed] and
   * [ParticipantTrackPermission.allTracksAllowed] are false), any newer published tracks
   * will not grant permissions to any participants and will require a subsequent
   * permissions update to allow subscription.
   *
   * @param allParticipantsAllowed Allows all participants to subscribe all tracks.
   *  Takes precedence over [[participantTrackPermissions]] if set to true.
   *  By default this is set to true.
   * @param participantTrackPermissions Full list of individual permissions per
   *  participant/track. Any omitted participants will not receive any permissions.
   */ setTrackSubscriptionPermissions(allParticipantsAllowed) {
        let participantTrackPermissions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        this.participantTrackPermissions = participantTrackPermissions;
        this.allParticipantsAllowedToSubscribe = allParticipantsAllowed;
        if (!this.engine.client.isDisconnected) this.updateTrackSubscriptionPermissions();
    }
    handleIncomingRpcAck(requestId) {
        const handler = this.pendingAcks.get(requestId);
        if (handler) {
            handler.resolve();
            this.pendingAcks.delete(requestId);
        } else console.error('Ack received for unexpected RPC request', requestId);
    }
    handleIncomingRpcResponse(requestId, payload, error) {
        const handler = this.pendingResponses.get(requestId);
        if (handler) {
            handler.resolve(payload, error);
            this.pendingResponses.delete(requestId);
        } else console.error('Response received for unexpected RPC request', requestId);
    }
    /** @internal */ publishRpcRequest(destinationIdentity, requestId, method, payload, responseTimeout) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            const packet = new $c0722d30b1d17141$var$DataPacket({
                destinationIdentities: [
                    destinationIdentity
                ],
                kind: $c0722d30b1d17141$export$629a0ea4ceb9e4a6.RELIABLE,
                value: {
                    case: 'rpcRequest',
                    value: new $c0722d30b1d17141$var$RpcRequest({
                        id: requestId,
                        method: method,
                        payload: payload,
                        responseTimeoutMs: responseTimeout,
                        version: 1
                    })
                }
            });
            yield this.engine.sendDataPacket(packet, $c0722d30b1d17141$var$DataChannelKind.RELIABLE);
        });
    }
    /** @internal */ handleParticipantDisconnected(participantIdentity) {
        for (const [id, { participantIdentity: pendingIdentity }] of this.pendingAcks)if (pendingIdentity === participantIdentity) this.pendingAcks.delete(id);
        for (const [id, { participantIdentity: pendingIdentity, resolve: resolve }] of this.pendingResponses)if (pendingIdentity === participantIdentity) {
            resolve(null, $c0722d30b1d17141$export$5460eff990f31920.builtIn('RECIPIENT_DISCONNECTED'));
            this.pendingResponses.delete(id);
        }
    }
    /** @internal */ setEnabledPublishCodecs(codecs) {
        this.enabledPublishVideoCodecs = codecs.filter((c)=>c.mime.split('/')[0].toLowerCase() === 'video');
    }
    /** @internal */ updateInfo(info) {
        if (!super.updateInfo(info)) return false;
        // reconcile track mute status.
        // if server's track mute status doesn't match actual, we'll have to update
        // the server's copy
        info.tracks.forEach((ti)=>{
            var _a, _b;
            const pub = this.trackPublications.get(ti.sid);
            if (pub) {
                const mutedOnServer = pub.isMuted || ((_b = (_a = pub.track) === null || _a === void 0 ? void 0 : _a.isUpstreamPaused) !== null && _b !== void 0 ? _b : false);
                if (mutedOnServer !== ti.muted) {
                    this.log.debug('updating server mute state after reconcile', Object.assign(Object.assign({}, $c0722d30b1d17141$var$getLogContextFromTrack(pub)), {
                        mutedOnServer: mutedOnServer
                    }));
                    this.engine.client.sendMuteTrack(ti.sid, mutedOnServer);
                }
            }
        });
        return true;
    }
    /** @internal */ setActiveAgent(agent) {
        var _a, _b, _c, _d;
        this.firstActiveAgent = agent;
        if (agent && !this.firstActiveAgent) this.firstActiveAgent = agent;
        if (agent) (_b = (_a = this.activeAgentFuture) === null || _a === void 0 ? void 0 : _a.resolve) === null || _b === void 0 || _b.call(_a, agent);
        else (_d = (_c = this.activeAgentFuture) === null || _c === void 0 ? void 0 : _c.reject) === null || _d === void 0 || _d.call(_c, new Error('Agent disconnected'));
        this.activeAgentFuture = undefined;
    }
    waitUntilActiveAgentPresent() {
        if (this.firstActiveAgent) return Promise.resolve(this.firstActiveAgent);
        if (!this.activeAgentFuture) this.activeAgentFuture = new $c0722d30b1d17141$var$Future();
        return this.activeAgentFuture.promise;
    }
    getPublicationForTrack(track) {
        let publication;
        this.trackPublications.forEach((pub)=>{
            const localTrack = pub.track;
            if (!localTrack) return;
            // this looks overly complicated due to this object tree
            if (track instanceof MediaStreamTrack) {
                if ($c0722d30b1d17141$var$isLocalAudioTrack(localTrack) || $c0722d30b1d17141$var$isLocalVideoTrack(localTrack)) {
                    if (localTrack.mediaStreamTrack === track) publication = pub;
                }
            } else if (track === localTrack) publication = pub;
        });
        return publication;
    }
    waitForPendingPublicationOfSource(source) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            const waitForPendingTimeout = 10000;
            const startTime = Date.now();
            while(Date.now() < startTime + waitForPendingTimeout){
                const publishPromiseEntry = Array.from(this.pendingPublishPromises.entries()).find((_ref4)=>{
                    let [pendingTrack] = _ref4;
                    return pendingTrack.source === source;
                });
                if (publishPromiseEntry) return publishPromiseEntry[1];
                yield $c0722d30b1d17141$var$sleep(20);
            }
        });
    }
    /** Publishes a data track.
   *
   * Returns the published data track if successful. Use {@link LocalDataTrack#tryPush}
   * to send data frames on the track.
   */ publishDataTrack(options) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            const track = new $c0722d30b1d17141$export$be72d99706596eb4(options, this.roomOutgoingDataTrackManager);
            yield track.publish();
            return track;
        });
    }
} /** An error which is thrown if a {@link DeferrableMap#getDeferred} call is aborted midway
 * through. */ 
class $c0722d30b1d17141$var$DeferrableMapAbortError extends DOMException {
    constructor(message, reason){
        super(message, 'AbortError');
        this.reason = reason;
    }
}
/**
 * A Map-like container keyed by unique strings that supports the ability to wait
 * for future keys to show up in the map.
 *
 * @example
 * // An already existing key:
 * const value = map.get("key");
 * // Wait for a key which will be added soon:
 * const value = await map.getDeferred("key");
 */ class $c0722d30b1d17141$var$DeferrableMap extends Map {
    constructor(){
        super(...arguments);
        this.pending = new Map();
    }
    set(key, value) {
        var _a, _b;
        super.set(key, value);
        // Resolve any futures waiting on this key.
        const futures = (_a = this.pending) === null || _a === void 0 ? void 0 : _a.get(key);
        if (futures) {
            for (const future of futures)if (!future.isResolved) (_b = future.resolve) === null || _b === void 0 || _b.call(future, value);
            this.pending.delete(key);
        }
        return this;
    }
    get [Symbol.toStringTag]() {
        return 'DeferrableMap';
    }
    getDeferred(key, signal) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            const existing = this.get(key);
            if (typeof existing !== 'undefined') return existing;
            // Bail out immediately if the signal is already aborted.
            if (signal === null || signal === void 0 ? void 0 : signal.aborted) throw new $c0722d30b1d17141$var$DeferrableMapAbortError('The operation was aborted.', signal.reason);
            const future = new $c0722d30b1d17141$var$Future(undefined, ()=>{
                // Clean up the pending list when the future settles.
                const futures = this.pending.get(key);
                if (!futures) return;
                const idx = futures.indexOf(future);
                if (idx !== -1) futures.splice(idx, 1);
                if (futures.length === 0) this.pending.delete(key);
            });
            const existingFutures = this.pending.get(key);
            if (existingFutures) existingFutures.push(future);
            else this.pending.set(key, [
                future
            ]);
            // If a signal was provided, listen for abort and reject the future.
            if (signal) {
                const onAbort = ()=>{
                    var _a;
                    if (!future.isResolved) (_a = future.reject) === null || _a === void 0 || _a.call(future, new $c0722d30b1d17141$var$DeferrableMapAbortError('The operation was aborted.', signal.reason));
                };
                signal.addEventListener('abort', onAbort, {
                    once: true
                });
                // Clean up the listener once the future settles (resolved or rejected).
                future.promise.finally(()=>{
                    signal.removeEventListener('abort', onAbort);
                });
            }
            return future.promise;
        });
    }
}
class $c0722d30b1d17141$export$c89ab28402142c29 extends $c0722d30b1d17141$export$7c531331788c3797 {
    constructor(kind, ti, autoSubscribe, loggerOptions){
        super(kind, ti.sid, ti.name, loggerOptions);
        this.track = undefined;
        /** @internal */ this.allowed = true;
        this.requestedDisabled = undefined;
        this.visible = true;
        this.handleEnded = (track)=>{
            this.setTrack(undefined);
            this.emit($c0722d30b1d17141$export$2c8510d737cc09da.Ended, track);
        };
        this.handleVisibilityChange = (visible)=>{
            this.log.debug("adaptivestream video visibility ".concat(this.trackSid, ", visible=").concat(visible), this.logContext);
            this.visible = visible;
            this.emitTrackUpdate();
        };
        this.handleVideoDimensionsChange = (dimensions)=>{
            this.log.debug("adaptivestream video dimensions ".concat(dimensions.width, "x").concat(dimensions.height), this.logContext);
            this.videoDimensionsAdaptiveStream = dimensions;
            this.emitTrackUpdate();
        };
        this.subscribed = autoSubscribe;
        this.updateInfo(ti);
    }
    /**
   * Subscribe or unsubscribe to this remote track
   * @param subscribed true to subscribe to a track, false to unsubscribe
   */ setSubscribed(subscribed) {
        const prevStatus = this.subscriptionStatus;
        const prevPermission = this.permissionStatus;
        this.subscribed = subscribed;
        // reset allowed status when desired subscription state changes
        // server will notify client via signal message if it's not allowed
        if (subscribed) this.allowed = true;
        const sub = new $c0722d30b1d17141$var$UpdateSubscription({
            trackSids: [
                this.trackSid
            ],
            subscribe: this.subscribed,
            participantTracks: [
                new $c0722d30b1d17141$var$ParticipantTracks({
                    // sending an empty participant id since TrackPublication doesn't keep it
                    // this is filled in by the participant that receives this message
                    participantSid: '',
                    trackSids: [
                        this.trackSid
                    ]
                })
            ]
        });
        this.emit($c0722d30b1d17141$export$2c8510d737cc09da.UpdateSubscription, sub);
        this.emitSubscriptionUpdateIfChanged(prevStatus);
        this.emitPermissionUpdateIfChanged(prevPermission);
    }
    get subscriptionStatus() {
        if (this.subscribed === false) return $c0722d30b1d17141$export$7c531331788c3797.SubscriptionStatus.Unsubscribed;
        if (!super.isSubscribed) return $c0722d30b1d17141$export$7c531331788c3797.SubscriptionStatus.Desired;
        return $c0722d30b1d17141$export$7c531331788c3797.SubscriptionStatus.Subscribed;
    }
    get permissionStatus() {
        return this.allowed ? $c0722d30b1d17141$export$7c531331788c3797.PermissionStatus.Allowed : $c0722d30b1d17141$export$7c531331788c3797.PermissionStatus.NotAllowed;
    }
    /**
   * Returns true if track is subscribed, and ready for playback
   */ get isSubscribed() {
        if (this.subscribed === false) return false;
        return super.isSubscribed;
    }
    // returns client's desire to subscribe to a track, also true if autoSubscribe is enabled
    get isDesired() {
        return this.subscribed !== false;
    }
    get isEnabled() {
        return this.requestedDisabled !== undefined ? !this.requestedDisabled : this.isAdaptiveStream ? this.visible : true;
    }
    get isLocal() {
        return false;
    }
    /**
   * disable server from sending down data for this track. this is useful when
   * the participant is off screen, you may disable streaming down their video
   * to reduce bandwidth requirements
   * @param enabled
   */ setEnabled(enabled) {
        if (!this.isManualOperationAllowed() || this.requestedDisabled === !enabled) return;
        this.requestedDisabled = !enabled;
        this.emitTrackUpdate();
    }
    /**
   * for tracks that support simulcasting, adjust subscribed quality
   *
   * This indicates the highest quality the client can accept. if network
   * bandwidth does not allow, server will automatically reduce quality to
   * optimize for uninterrupted video
   */ setVideoQuality(quality) {
        if (!this.isManualOperationAllowed() || this.requestedMaxQuality === quality) return;
        this.requestedMaxQuality = quality;
        this.requestedVideoDimensions = undefined;
        this.emitTrackUpdate();
    }
    /**
   * Explicitly set the video dimensions for this track.
   *
   * This will take precedence over adaptive stream dimensions.
   *
   * @param dimensions The video dimensions to set.
   */ setVideoDimensions(dimensions) {
        var _a, _b;
        if (!this.isManualOperationAllowed()) return;
        if (((_a = this.requestedVideoDimensions) === null || _a === void 0 ? void 0 : _a.width) === dimensions.width && ((_b = this.requestedVideoDimensions) === null || _b === void 0 ? void 0 : _b.height) === dimensions.height) return;
        if ($c0722d30b1d17141$var$isRemoteVideoTrack(this.track)) this.requestedVideoDimensions = dimensions;
        this.requestedMaxQuality = undefined;
        this.emitTrackUpdate();
    }
    setVideoFPS(fps) {
        if (!this.isManualOperationAllowed()) return;
        if (!$c0722d30b1d17141$var$isRemoteVideoTrack(this.track)) return;
        if (this.fps === fps) return;
        this.fps = fps;
        this.emitTrackUpdate();
    }
    get videoQuality() {
        var _a;
        return (_a = this.requestedMaxQuality) !== null && _a !== void 0 ? _a : $c0722d30b1d17141$export$a8f593954e806155.HIGH;
    }
    /** @internal */ setTrack(track) {
        const prevStatus = this.subscriptionStatus;
        const prevPermission = this.permissionStatus;
        const prevTrack = this.track;
        if (prevTrack === track) return;
        if (prevTrack) {
            // unregister listener
            prevTrack.off($c0722d30b1d17141$export$2c8510d737cc09da.VideoDimensionsChanged, this.handleVideoDimensionsChange);
            prevTrack.off($c0722d30b1d17141$export$2c8510d737cc09da.VisibilityChanged, this.handleVisibilityChange);
            prevTrack.off($c0722d30b1d17141$export$2c8510d737cc09da.Ended, this.handleEnded);
            prevTrack.detach();
            prevTrack.stopMonitor();
            this.emit($c0722d30b1d17141$export$2c8510d737cc09da.Unsubscribed, prevTrack);
        }
        super.setTrack(track);
        if (track) {
            track.sid = this.trackSid;
            track.on($c0722d30b1d17141$export$2c8510d737cc09da.VideoDimensionsChanged, this.handleVideoDimensionsChange);
            track.on($c0722d30b1d17141$export$2c8510d737cc09da.VisibilityChanged, this.handleVisibilityChange);
            track.on($c0722d30b1d17141$export$2c8510d737cc09da.Ended, this.handleEnded);
            this.emit($c0722d30b1d17141$export$2c8510d737cc09da.Subscribed, track);
        }
        this.emitPermissionUpdateIfChanged(prevPermission);
        this.emitSubscriptionUpdateIfChanged(prevStatus);
    }
    /** @internal */ setAllowed(allowed) {
        const prevStatus = this.subscriptionStatus;
        const prevPermission = this.permissionStatus;
        this.allowed = allowed;
        this.emitPermissionUpdateIfChanged(prevPermission);
        this.emitSubscriptionUpdateIfChanged(prevStatus);
    }
    /** @internal */ setSubscriptionError(error) {
        this.emit($c0722d30b1d17141$export$2c8510d737cc09da.SubscriptionFailed, error);
    }
    /** @internal */ updateInfo(info) {
        super.updateInfo(info);
        const prevMetadataMuted = this.metadataMuted;
        this.metadataMuted = info.muted;
        if (this.track) this.track.setMuted(info.muted);
        else if (prevMetadataMuted !== info.muted) this.emit(info.muted ? $c0722d30b1d17141$export$2c8510d737cc09da.Muted : $c0722d30b1d17141$export$2c8510d737cc09da.Unmuted);
    }
    emitSubscriptionUpdateIfChanged(previousStatus) {
        const currentStatus = this.subscriptionStatus;
        if (previousStatus === currentStatus) return;
        this.emit($c0722d30b1d17141$export$2c8510d737cc09da.SubscriptionStatusChanged, currentStatus, previousStatus);
    }
    emitPermissionUpdateIfChanged(previousPermissionStatus) {
        const currentPermissionStatus = this.permissionStatus;
        if (currentPermissionStatus !== previousPermissionStatus) this.emit($c0722d30b1d17141$export$2c8510d737cc09da.SubscriptionPermissionChanged, this.permissionStatus, previousPermissionStatus);
    }
    isManualOperationAllowed() {
        if (!this.isDesired) {
            this.log.warn('cannot update track settings when not subscribed', this.logContext);
            return false;
        }
        return true;
    }
    get isAdaptiveStream() {
        return $c0722d30b1d17141$var$isRemoteVideoTrack(this.track) && this.track.isAdaptiveStream;
    }
    /* @internal */ emitTrackUpdate() {
        const settings = new $c0722d30b1d17141$var$UpdateTrackSettings({
            trackSids: [
                this.trackSid
            ],
            disabled: !this.isEnabled,
            fps: this.fps
        });
        if (this.kind === $c0722d30b1d17141$export$13921ac0cc260818.Kind.Video) {
            let minDimensions = this.requestedVideoDimensions;
            if (this.videoDimensionsAdaptiveStream !== undefined) {
                if (minDimensions) {
                    // check whether the adaptive stream dimensions are smaller than the requested dimensions and use smaller one
                    const smallerAdaptive = $c0722d30b1d17141$var$areDimensionsSmaller(this.videoDimensionsAdaptiveStream, minDimensions);
                    if (smallerAdaptive) {
                        this.log.debug('using adaptive stream dimensions instead of requested', Object.assign(Object.assign({}, this.logContext), this.videoDimensionsAdaptiveStream));
                        minDimensions = this.videoDimensionsAdaptiveStream;
                    }
                } else if (this.requestedMaxQuality !== undefined && this.trackInfo) {
                    // check whether adaptive stream dimensions are smaller than the max quality layer and use smaller one
                    const maxQualityLayer = $c0722d30b1d17141$var$layerDimensionsFor(this.trackInfo, this.requestedMaxQuality);
                    if (maxQualityLayer && $c0722d30b1d17141$var$areDimensionsSmaller(this.videoDimensionsAdaptiveStream, maxQualityLayer)) {
                        this.log.debug('using adaptive stream dimensions instead of max quality layer', Object.assign(Object.assign({}, this.logContext), this.videoDimensionsAdaptiveStream));
                        minDimensions = this.videoDimensionsAdaptiveStream;
                    }
                } else {
                    this.log.debug('using adaptive stream dimensions', Object.assign(Object.assign({}, this.logContext), this.videoDimensionsAdaptiveStream));
                    minDimensions = this.videoDimensionsAdaptiveStream;
                }
            }
            if (minDimensions) {
                settings.width = Math.ceil(minDimensions.width);
                settings.height = Math.ceil(minDimensions.height);
            } else if (this.requestedMaxQuality !== undefined) {
                this.log.debug('using requested max quality', Object.assign(Object.assign({}, this.logContext), {
                    quality: this.requestedMaxQuality
                }));
                settings.quality = this.requestedMaxQuality;
            } else {
                this.log.debug('using default quality', Object.assign(Object.assign({}, this.logContext), {
                    quality: $c0722d30b1d17141$export$a8f593954e806155.HIGH
                }));
                // defaults to high quality
                settings.quality = $c0722d30b1d17141$export$a8f593954e806155.HIGH;
            }
        }
        this.emit($c0722d30b1d17141$export$2c8510d737cc09da.UpdateSettings, settings);
    }
}
class $c0722d30b1d17141$export$bf85b9e4f33346fe extends $c0722d30b1d17141$export$aada361ed1a6c65 {
    /** @internal */ static fromParticipantInfo(signalClient, pi, loggerOptions, manager) {
        return new $c0722d30b1d17141$export$bf85b9e4f33346fe(signalClient, pi.sid, pi.identity, pi.name, pi.metadata, pi.attributes, loggerOptions, pi.kind, pi.dataTracks.map((dti)=>{
            const info = $c0722d30b1d17141$var$DataTrackInfo.from(dti);
            return new $c0722d30b1d17141$export$57384944deb33057(info, manager, {
                publisherIdentity: pi.identity
            });
        }));
    }
    get logContext() {
        return Object.assign(Object.assign({}, super.logContext), {
            remoteParticipantID: this.sid,
            remoteParticipant: this.identity
        });
    }
    /** @internal */ constructor(signalClient, sid, identity, name, metadata, attributes, loggerOptions){
        let kind = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : $c0722d30b1d17141$export$2079c0e1523aec29.STANDARD;
        let remoteDataTracks = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        super(sid, identity || '', name, metadata, attributes, loggerOptions, kind);
        this.signalClient = signalClient;
        this.trackPublications = new Map();
        this.audioTrackPublications = new Map();
        this.videoTrackPublications = new Map();
        this.dataTracks = new $c0722d30b1d17141$var$DeferrableMap(remoteDataTracks.map((remoteDataTrack)=>{
            return [
                remoteDataTrack.info.name,
                remoteDataTrack
            ];
        }));
        this.volumeMap = new Map();
    }
    addTrackPublication(publication) {
        super.addTrackPublication(publication);
        // register action events
        publication.on($c0722d30b1d17141$export$2c8510d737cc09da.UpdateSettings, (settings)=>{
            this.log.debug('send update settings', Object.assign(Object.assign(Object.assign({}, this.logContext), $c0722d30b1d17141$var$getLogContextFromTrack(publication)), {
                settings: settings
            }));
            this.signalClient.sendUpdateTrackSettings(settings);
        });
        publication.on($c0722d30b1d17141$export$2c8510d737cc09da.UpdateSubscription, (sub)=>{
            sub.participantTracks.forEach((pt)=>{
                pt.participantSid = this.sid;
            });
            this.signalClient.sendUpdateSubscription(sub);
        });
        publication.on($c0722d30b1d17141$export$2c8510d737cc09da.SubscriptionPermissionChanged, (status)=>{
            this.emit($c0722d30b1d17141$export$fcdfe2b7a6750691.TrackSubscriptionPermissionChanged, publication, status);
        });
        publication.on($c0722d30b1d17141$export$2c8510d737cc09da.SubscriptionStatusChanged, (status)=>{
            this.emit($c0722d30b1d17141$export$fcdfe2b7a6750691.TrackSubscriptionStatusChanged, publication, status);
        });
        publication.on($c0722d30b1d17141$export$2c8510d737cc09da.Subscribed, (track)=>{
            this.emit($c0722d30b1d17141$export$fcdfe2b7a6750691.TrackSubscribed, track, publication);
        });
        publication.on($c0722d30b1d17141$export$2c8510d737cc09da.Unsubscribed, (previousTrack)=>{
            this.emit($c0722d30b1d17141$export$fcdfe2b7a6750691.TrackUnsubscribed, previousTrack, publication);
        });
        publication.on($c0722d30b1d17141$export$2c8510d737cc09da.SubscriptionFailed, (error)=>{
            this.emit($c0722d30b1d17141$export$fcdfe2b7a6750691.TrackSubscriptionFailed, publication.trackSid, error);
        });
    }
    getTrackPublication(source) {
        const track = super.getTrackPublication(source);
        if (track) return track;
    }
    getTrackPublicationByName(name) {
        const track = super.getTrackPublicationByName(name);
        if (track) return track;
    }
    /**
   * sets the volume on the participant's audio track
   * by default, this affects the microphone publication
   * a different source can be passed in as a second argument
   * if no track exists the volume will be applied when the microphone track is added
   */ setVolume(volume) {
        let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $c0722d30b1d17141$export$13921ac0cc260818.Source.Microphone;
        this.volumeMap.set(source, volume);
        const audioPublication = this.getTrackPublication(source);
        if (audioPublication && audioPublication.track) audioPublication.track.setVolume(volume);
    }
    /**
   * gets the volume on the participant's microphone track
   */ getVolume() {
        let source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $c0722d30b1d17141$export$13921ac0cc260818.Source.Microphone;
        const audioPublication = this.getTrackPublication(source);
        if (audioPublication && audioPublication.track) return audioPublication.track.getVolume();
        return this.volumeMap.get(source);
    }
    /** @internal */ addSubscribedMediaTrack(mediaTrack, sid, mediaStream, receiver, adaptiveStreamSettings, triesLeft) {
        // find the track publication
        // it's possible for the media track to arrive before participant info
        let publication = this.getTrackPublicationBySid(sid);
        // it's also possible that the browser didn't honor our original track id
        // FireFox would use its own local uuid instead of server track id
        if (!publication) {
            if (!sid.startsWith('TR')) // find the first track that matches type
            this.trackPublications.forEach((p)=>{
                if (!publication && mediaTrack.kind === p.kind.toString()) publication = p;
            });
        }
        // when we couldn't locate the track, it's possible that the metadata hasn't
        // yet arrived. Wait a bit longer for it to arrive, or fire an error
        if (!publication) {
            if (triesLeft === 0) {
                this.log.error('could not find published track', Object.assign(Object.assign({}, this.logContext), {
                    trackSid: sid
                }));
                this.emit($c0722d30b1d17141$export$fcdfe2b7a6750691.TrackSubscriptionFailed, sid);
                return;
            }
            if (triesLeft === undefined) triesLeft = 20;
            setTimeout(()=>{
                this.addSubscribedMediaTrack(mediaTrack, sid, mediaStream, receiver, adaptiveStreamSettings, triesLeft - 1);
            }, 150);
            return;
        }
        if (mediaTrack.readyState === 'ended') {
            this.log.error('unable to subscribe because MediaStreamTrack is ended. Do not call MediaStreamTrack.stop()', Object.assign(Object.assign({}, this.logContext), $c0722d30b1d17141$var$getLogContextFromTrack(publication)));
            this.emit($c0722d30b1d17141$export$fcdfe2b7a6750691.TrackSubscriptionFailed, sid);
            return;
        }
        const isVideo = mediaTrack.kind === 'video';
        let track;
        if (isVideo) track = new $c0722d30b1d17141$export$1db0c0ebd3ae1523(mediaTrack, sid, receiver, adaptiveStreamSettings);
        else track = new $c0722d30b1d17141$export$fd37b116bd840ced(mediaTrack, sid, receiver, this.audioContext, this.audioOutput);
        // set track info
        track.source = publication.source;
        // keep publication's muted status
        track.isMuted = publication.isMuted;
        track.setMediaStream(mediaStream);
        track.start();
        publication.setTrack(track);
        // set participant volumes on new audio tracks
        if (this.volumeMap.has(publication.source) && $c0722d30b1d17141$export$8ca21404ed46ab41(track) && $c0722d30b1d17141$export$228726644c3d75db(track)) track.setVolume(this.volumeMap.get(publication.source));
        return publication;
    }
    /** @internal */ get hasMetadata() {
        return !!this.participantInfo;
    }
    /**
   * @internal
   */ getTrackPublicationBySid(sid) {
        return this.trackPublications.get(sid);
    }
    /** @internal */ updateInfo(info) {
        if (!super.updateInfo(info)) return false;
        // we are getting a list of all available tracks, reconcile in here
        // and send out events for changes
        // reconcile track publications, publish events only if metadata is already there
        // i.e. changes since the local participant has joined
        const validTracks = new Map();
        const newTracks = new Map();
        info.tracks.forEach((ti)=>{
            var _a, _b;
            let publication = this.getTrackPublicationBySid(ti.sid);
            if (!publication) {
                // new publication
                const kind = $c0722d30b1d17141$export$13921ac0cc260818.kindFromProto(ti.type);
                if (!kind) return;
                publication = new $c0722d30b1d17141$export$c89ab28402142c29(kind, ti, (_a = this.signalClient.connectOptions) === null || _a === void 0 ? void 0 : _a.autoSubscribe, {
                    loggerContextCb: ()=>this.logContext,
                    loggerName: (_b = this.loggerOptions) === null || _b === void 0 ? void 0 : _b.loggerName
                });
                publication.updateInfo(ti);
                newTracks.set(ti.sid, publication);
                const existingTrackOfSource = Array.from(this.trackPublications.values()).find((publishedTrack)=>publishedTrack.source === (publication === null || publication === void 0 ? void 0 : publication.source));
                if (existingTrackOfSource && publication.source !== $c0722d30b1d17141$export$13921ac0cc260818.Source.Unknown) this.log.debug("received a second track publication for ".concat(this.identity, " with the same source: ").concat(publication.source), Object.assign(Object.assign({}, this.logContext), {
                    oldTrack: $c0722d30b1d17141$var$getLogContextFromTrack(existingTrackOfSource),
                    newTrack: $c0722d30b1d17141$var$getLogContextFromTrack(publication)
                }));
                this.addTrackPublication(publication);
            } else publication.updateInfo(ti);
            validTracks.set(ti.sid, publication);
        });
        // detect removed tracks
        this.trackPublications.forEach((publication)=>{
            if (!validTracks.has(publication.trackSid)) {
                this.log.trace('detected removed track on remote participant, unpublishing', Object.assign(Object.assign({}, this.logContext), $c0722d30b1d17141$var$getLogContextFromTrack(publication)));
                this.unpublishTrack(publication.trackSid, true);
            }
        });
        // always emit events for new publications, Room will not forward them unless it's ready
        newTracks.forEach((publication)=>{
            this.emit($c0722d30b1d17141$export$fcdfe2b7a6750691.TrackPublished, publication);
        });
        return true;
    }
    /** @internal */ unpublishTrack(sid, sendUnpublish) {
        const publication = this.trackPublications.get(sid);
        if (!publication) return;
        // also send unsubscribe, if track is actively subscribed
        const { track: track } = publication;
        if (track) {
            track.stop();
            publication.setTrack(undefined);
        }
        // remove track from maps only after unsubscribed has been fired
        this.trackPublications.delete(sid);
        // remove from the right type map
        switch(publication.kind){
            case $c0722d30b1d17141$export$13921ac0cc260818.Kind.Audio:
                this.audioTrackPublications.delete(sid);
                break;
            case $c0722d30b1d17141$export$13921ac0cc260818.Kind.Video:
                this.videoTrackPublications.delete(sid);
                break;
        }
        if (sendUnpublish) this.emit($c0722d30b1d17141$export$fcdfe2b7a6750691.TrackUnpublished, publication);
    }
    /**
   * @internal
   */ setAudioOutput(output) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            this.audioOutput = output;
            const promises = [];
            this.audioTrackPublications.forEach((pub)=>{
                var _a;
                if ($c0722d30b1d17141$export$228726644c3d75db(pub.track) && $c0722d30b1d17141$export$8ca21404ed46ab41(pub.track)) promises.push(pub.track.setSinkId((_a = output.deviceId) !== null && _a !== void 0 ? _a : 'default'));
            });
            yield Promise.all(promises);
        });
    }
    /** @internal */ addRemoteDataTrack(remoteDataTrack) {
        this.dataTracks.set(remoteDataTrack.info.name, remoteDataTrack);
    }
    /** @internal */ removeRemoteDataTrack(remoteDataTrackSid) {
        for (const [name, dataTrack] of this.dataTracks.entries())if (remoteDataTrackSid === dataTrack.info.sid) this.dataTracks.delete(name);
    }
    /** @internal */ emit(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        this.log.trace('participant event', Object.assign(Object.assign({}, this.logContext), {
            event: event,
            args: args
        }));
        return super.emit(event, ...args);
    }
}
var $c0722d30b1d17141$export$cd9c3c6bf535afc9;
(function(ConnectionState) {
    ConnectionState["Disconnected"] = "disconnected";
    ConnectionState["Connecting"] = "connecting";
    ConnectionState["Connected"] = "connected";
    ConnectionState["Reconnecting"] = "reconnecting";
    ConnectionState["SignalReconnecting"] = "signalReconnecting";
})($c0722d30b1d17141$export$cd9c3c6bf535afc9 || ($c0722d30b1d17141$export$cd9c3c6bf535afc9 = {}));
const $c0722d30b1d17141$var$CONNECTION_RECONCILE_FREQUENCY_MS = 4000;
/**
 * In LiveKit, a room is the logical grouping for a list of participants.
 * Participants in a room can publish tracks, and subscribe to others' tracks.
 *
 * a Room fires [[RoomEvent | RoomEvents]].
 *
 * @noInheritDoc
 */ class $c0722d30b1d17141$export$525628e68e798fb4 extends $c0722d30b1d17141$var$eventsExports.EventEmitter {
    get hasE2EESetup() {
        return this.e2eeManager !== undefined;
    }
    /**
   * Creates a new Room, the primary construct for a LiveKit session.
   * @param options
   */ constructor(options){
        var _this;
        var _a, _b, _c, _d, _e, _f;
        super();
        _this = this;
        this.state = $c0722d30b1d17141$export$cd9c3c6bf535afc9.Disconnected;
        /**
     * list of participants that are actively speaking. when this changes
     * a [[RoomEvent.ActiveSpeakersChanged]] event is fired
     */ this.activeSpeakers = [];
        /** reflects the sender encryption status of the local participant */ this.isE2EEEnabled = false;
        this.audioEnabled = true;
        this.e2eeStateMutex = new $c0722d30b1d17141$export$ca12f2943758ef55();
        this.isVideoPlaybackBlocked = false;
        this.log = $c0722d30b1d17141$var$livekitLogger;
        this.bufferedEvents = [];
        this.isResuming = false;
        this.rpcHandlers = new Map();
        this.connect = (url, token, opts)=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                var _a;
                if (!$c0722d30b1d17141$export$3fe402ec04821f17()) {
                    if ($c0722d30b1d17141$var$isReactNative()) throw Error("WebRTC isn't detected, have you called registerGlobals?");
                    else throw Error("LiveKit doesn't seem to be supported on this browser. Try to update your browser and make sure no browser extensions are disabling webRTC.");
                }
                // In case a disconnect called happened right before the connect call, make sure the disconnect is completed first by awaiting its lock
                const unlockDisconnect = yield this.disconnectLock.lock();
                if (this.state === $c0722d30b1d17141$export$cd9c3c6bf535afc9.Connected) {
                    // when the state is reconnecting or connected, this function returns immediately
                    this.log.info("already connected to room ".concat(this.name));
                    unlockDisconnect();
                    return Promise.resolve();
                }
                if (this.connectFuture) {
                    unlockDisconnect();
                    return this.connectFuture.promise;
                }
                this.setAndEmitConnectionState($c0722d30b1d17141$export$cd9c3c6bf535afc9.Connecting);
                if (((_a = this.regionUrlProvider) === null || _a === void 0 ? void 0 : _a.getServerUrl().toString()) !== $c0722d30b1d17141$var$ensureTrailingSlash(url)) {
                    this.regionUrl = undefined;
                    this.regionUrlProvider = undefined;
                }
                if ($c0722d30b1d17141$var$isCloud(new URL(url))) {
                    if (this.regionUrlProvider === undefined) this.regionUrlProvider = new $c0722d30b1d17141$var$RegionUrlProvider(url, token);
                    else this.regionUrlProvider.updateToken(token);
                    // trigger the first fetch without waiting for a response
                    // if initial connection fails, this will speed up picking regional url
                    // on subsequent runs
                    this.regionUrlProvider.fetchRegionSettings().then((settings)=>{
                        var _a;
                        (_a = this.regionUrlProvider) === null || _a === void 0 || _a.setServerReportedRegions(settings);
                    }).catch((e)=>{
                        this.log.warn('could not fetch region settings', {
                            error: e
                        });
                    });
                }
                const connectFn = (resolve, reject, regionUrl)=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                        var _a, _b;
                        if (this.abortController) this.abortController.abort();
                        // explicit creation as local var needed to satisfy TS compiler when passing it to `attemptConnection` further down
                        const abortController = new AbortController();
                        this.abortController = abortController;
                        // at this point the intention to connect has been signalled so we can allow cancelling of the connection via disconnect() again
                        unlockDisconnect === null || unlockDisconnect === void 0 || unlockDisconnect();
                        try {
                            yield $c0722d30b1d17141$var$BackOffStrategy.getInstance().getBackOffPromise(url);
                            if (abortController.signal.aborted) throw $c0722d30b1d17141$export$a3747c6e46c7a8eb.cancelled('Connection attempt aborted');
                            yield this.attemptConnection(regionUrl !== null && regionUrl !== void 0 ? regionUrl : url, token, opts, abortController);
                            this.abortController = undefined;
                            resolve();
                        } catch (error) {
                            if (this.regionUrlProvider && error instanceof $c0722d30b1d17141$export$a3747c6e46c7a8eb && error.reason !== $c0722d30b1d17141$export$61182a0b21436b65.Cancelled && error.reason !== $c0722d30b1d17141$export$61182a0b21436b65.NotAllowed) {
                                let nextUrl = null;
                                try {
                                    this.log.debug('Fetching next region');
                                    nextUrl = yield this.regionUrlProvider.getNextBestRegionUrl((_a = this.abortController) === null || _a === void 0 ? void 0 : _a.signal);
                                } catch (regionFetchError) {
                                    if (regionFetchError instanceof $c0722d30b1d17141$export$a3747c6e46c7a8eb && (regionFetchError.status === 401 || regionFetchError.reason === $c0722d30b1d17141$export$61182a0b21436b65.Cancelled)) {
                                        this.handleDisconnect(this.options.stopLocalTrackOnUnpublish);
                                        reject(regionFetchError);
                                        return;
                                    }
                                }
                                if (// making sure we only register failed attempts on things we actually care about
                                [
                                    $c0722d30b1d17141$export$61182a0b21436b65.InternalError,
                                    $c0722d30b1d17141$export$61182a0b21436b65.ServerUnreachable,
                                    $c0722d30b1d17141$export$61182a0b21436b65.Timeout
                                ].includes(error.reason)) {
                                    this.log.debug('Adding failed connection attempt to back off');
                                    $c0722d30b1d17141$var$BackOffStrategy.getInstance().addFailedConnectionAttempt(url);
                                }
                                if (nextUrl && !((_b = this.abortController) === null || _b === void 0 ? void 0 : _b.signal.aborted)) {
                                    this.log.info("Initial connection failed with ConnectionError: ".concat(error.message, ". Retrying with another region: ").concat(nextUrl));
                                    this.recreateEngine(true);
                                    yield connectFn(resolve, reject, nextUrl);
                                } else {
                                    this.handleDisconnect(this.options.stopLocalTrackOnUnpublish, $c0722d30b1d17141$var$getDisconnectReasonFromConnectionError(error));
                                    reject(error);
                                }
                            } else {
                                let disconnectReason = $c0722d30b1d17141$export$258d16488300d83f.UNKNOWN_REASON;
                                if (error instanceof $c0722d30b1d17141$export$a3747c6e46c7a8eb) disconnectReason = $c0722d30b1d17141$var$getDisconnectReasonFromConnectionError(error);
                                this.handleDisconnect(this.options.stopLocalTrackOnUnpublish, disconnectReason);
                                reject(error);
                            }
                        }
                    });
                const regionUrl = this.regionUrl;
                this.regionUrl = undefined;
                this.connectFuture = new $c0722d30b1d17141$var$Future((resolve, reject)=>{
                    connectFn(resolve, reject, regionUrl);
                }, ()=>{
                    this.clearConnectionFutures();
                });
                return this.connectFuture.promise;
            });
        this.connectSignal = (url, token, engine, connectOptions, roomOptions, abortController)=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                const { joinResponse: joinResponse, serverInfo: serverInfo } = yield engine.join(url, token, {
                    autoSubscribe: connectOptions.autoSubscribe,
                    adaptiveStream: typeof roomOptions.adaptiveStream === 'object' ? true : roomOptions.adaptiveStream,
                    maxRetries: connectOptions.maxRetries,
                    e2eeEnabled: !!this.e2eeManager,
                    websocketTimeout: connectOptions.websocketTimeout
                }, abortController.signal, !roomOptions.singlePeerConnection);
                this.serverInfo = serverInfo;
                if (!serverInfo.version) throw new $c0722d30b1d17141$export$4d307571a351c50c('unknown server version');
                if (serverInfo.version === '0.15.1' && this.options.dynacast) {
                    this.log.debug('disabling dynacast due to server version');
                    // dynacast has a bug in 0.15.1, so we cannot use it then
                    roomOptions.dynacast = false;
                }
                return joinResponse;
            });
        this.applyJoinResponse = (joinResponse)=>{
            const pi = joinResponse.participant;
            this.localParticipant.sid = pi.sid;
            this.localParticipant.identity = pi.identity;
            this.localParticipant.setEnabledPublishCodecs(joinResponse.enabledPublishCodecs);
            if (this.e2eeManager) try {
                this.e2eeManager.setSifTrailer(joinResponse.sifTrailer);
            } catch (e) {
                this.log.error(e instanceof Error ? e.message : 'Could not set SifTrailer', {
                    error: e
                });
            }
            // populate remote participants, these should not trigger new events
            this.handleParticipantUpdates([
                pi,
                ...joinResponse.otherParticipants
            ]);
            if (joinResponse.room) this.handleRoomUpdate(joinResponse.room);
        };
        this.attemptConnection = (url, token, opts, abortController)=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                var _a, _b;
                if (this.state === $c0722d30b1d17141$export$cd9c3c6bf535afc9.Reconnecting || this.isResuming || ((_a = this.engine) === null || _a === void 0 ? void 0 : _a.pendingReconnect)) {
                    this.log.info('Reconnection attempt replaced by new connection attempt');
                    // make sure we close and recreate the existing engine in order to get rid of any potentially ongoing reconnection attempts
                    this.recreateEngine(true);
                } else // create engine if previously disconnected
                this.maybeCreateEngine();
                if ((_b = this.regionUrlProvider) === null || _b === void 0 ? void 0 : _b.isCloud()) this.engine.setRegionStrategy(this.createRegionStrategy());
                this.acquireAudioContext();
                this.connOptions = Object.assign(Object.assign({}, $c0722d30b1d17141$var$roomConnectOptionDefaults), opts);
                if (this.connOptions.rtcConfig) this.engine.rtcConfig = this.connOptions.rtcConfig;
                if (this.connOptions.peerConnectionTimeout) this.engine.peerConnectionTimeout = this.connOptions.peerConnectionTimeout;
                try {
                    const joinResponse = yield this.connectSignal(url, token, this.engine, this.connOptions, this.options, abortController);
                    this.applyJoinResponse(joinResponse);
                    // forward metadata changed for the local participant
                    this.setupLocalParticipantEvents();
                    this.emit($c0722d30b1d17141$export$3159c672e3b2293a.SignalConnected);
                } catch (err) {
                    yield this.engine.close();
                    this.recreateEngine();
                    const resultingError = abortController.signal.aborted ? $c0722d30b1d17141$export$a3747c6e46c7a8eb.cancelled('Signal connection aborted') : $c0722d30b1d17141$export$a3747c6e46c7a8eb.serverUnreachable('could not establish signal connection');
                    if (err instanceof Error) resultingError.message = "".concat(resultingError.message, ": ").concat(err.message);
                    if (err instanceof $c0722d30b1d17141$export$a3747c6e46c7a8eb) {
                        resultingError.reason = err.reason;
                        resultingError.status = err.status;
                    }
                    this.log.debug("error trying to establish signal connection", {
                        error: err
                    });
                    throw resultingError;
                }
                if (abortController.signal.aborted) {
                    yield this.engine.close();
                    this.recreateEngine();
                    throw $c0722d30b1d17141$export$a3747c6e46c7a8eb.cancelled("Connection attempt aborted");
                }
                try {
                    yield this.engine.waitForPCInitialConnection(this.connOptions.peerConnectionTimeout, abortController);
                } catch (e) {
                    yield this.engine.close();
                    this.recreateEngine();
                    throw e;
                }
                // also hook unload event
                if ($c0722d30b1d17141$var$isWeb() && this.options.disconnectOnPageLeave) {
                    // capturing both 'pagehide' and 'beforeunload' to capture broadest set of browser behaviors
                    window.addEventListener('pagehide', this.onPageLeave);
                    window.addEventListener('beforeunload', this.onPageLeave);
                }
                if ($c0722d30b1d17141$var$isWeb()) window.addEventListener('freeze', this.onPageLeave);
                this.setAndEmitConnectionState($c0722d30b1d17141$export$cd9c3c6bf535afc9.Connected);
                this.emit($c0722d30b1d17141$export$3159c672e3b2293a.Connected);
                $c0722d30b1d17141$var$BackOffStrategy.getInstance().resetFailedConnectionAttempts(url);
                this.registerConnectionReconcile();
                // Notify region provider about successful connection
                if (this.regionUrlProvider) this.regionUrlProvider.notifyConnected();
            });
        /**
     * disconnects the room, emits [[RoomEvent.Disconnected]]
     */ this.disconnect = function() {
            for(var _len = arguments.length, args_1 = new Array(_len), _key = 0; _key < _len; _key++)args_1[_key] = arguments[_key];
            return $c0722d30b1d17141$var$__awaiter(_this, [
                ...args_1
            ], void 0, function() {
                var _this2 = this;
                let stopTracks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                return function*() {
                    var _a, _b, _c;
                    const unlock = yield _this2.disconnectLock.lock();
                    try {
                        if (_this2.state === $c0722d30b1d17141$export$cd9c3c6bf535afc9.Disconnected) {
                            _this2.log.debug('already disconnected');
                            return;
                        }
                        _this2.log.info('disconnect from room');
                        if (_this2.state === $c0722d30b1d17141$export$cd9c3c6bf535afc9.Connecting || _this2.state === $c0722d30b1d17141$export$cd9c3c6bf535afc9.Reconnecting || _this2.isResuming) {
                            // try aborting pending connection attempt
                            const msg = 'Abort connection attempt due to user initiated disconnect';
                            _this2.log.warn(msg);
                            (_a = _this2.abortController) === null || _a === void 0 || _a.abort(msg);
                            // in case the abort controller didn't manage to cancel the connection attempt, reject the connect promise explicitly
                            (_c = (_b = _this2.connectFuture) === null || _b === void 0 ? void 0 : _b.reject) === null || _c === void 0 || _c.call(_b, $c0722d30b1d17141$export$a3747c6e46c7a8eb.cancelled('Client initiated disconnect'));
                            _this2.connectFuture = undefined;
                        }
                        // close engine (also closes client)
                        if (_this2.engine) {
                            // send leave
                            if (!_this2.engine.client.isDisconnected) yield _this2.engine.client.sendLeave();
                            yield _this2.engine.close();
                        }
                        _this2.handleDisconnect(stopTracks, $c0722d30b1d17141$export$258d16488300d83f.CLIENT_INITIATED);
                        /* @ts-ignore */ _this2.engine = undefined;
                    } finally{
                        unlock();
                    }
                }();
            });
        };
        this.onPageLeave = ()=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                this.log.info('Page leave detected, disconnecting');
                yield this.disconnect();
            });
        /**
     * Browsers have different policies regarding audio playback. Most requiring
     * some form of user interaction (click/tap/etc).
     * In those cases, audio will be silent until a click/tap triggering one of the following
     * - `startAudio`
     * - `getUserMedia`
     */ this.startAudio = ()=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                const elements = [];
                const browser = $c0722d30b1d17141$export$89e15fc796a4a429();
                if (browser && browser.os === 'iOS') {
                    /**
         * iOS blocks audio element playback if
         * - user is not publishing audio themselves and
         * - no other audio source is playing
         *
         * as a workaround, we create an audio element with an empty track, so that
         * silent audio is always playing
         */ const audioId = 'livekit-dummy-audio-el';
                    let dummyAudioEl = document.getElementById(audioId);
                    if (!dummyAudioEl) {
                        dummyAudioEl = document.createElement('audio');
                        dummyAudioEl.id = audioId;
                        dummyAudioEl.autoplay = true;
                        dummyAudioEl.hidden = true;
                        const track = $c0722d30b1d17141$export$59e276d6841f735c();
                        track.enabled = true;
                        const stream = new MediaStream([
                            track
                        ]);
                        dummyAudioEl.srcObject = stream;
                        document.addEventListener('visibilitychange', ()=>{
                            if (!dummyAudioEl) return;
                            // set the srcObject to null on page hide in order to prevent lock screen controls to show up for it
                            dummyAudioEl.srcObject = document.hidden ? null : stream;
                            if (!document.hidden) {
                                this.log.debug('page visible again, triggering startAudio to resume playback and update playback status');
                                this.startAudio();
                            }
                        });
                        document.body.append(dummyAudioEl);
                        this.once($c0722d30b1d17141$export$3159c672e3b2293a.Disconnected, ()=>{
                            dummyAudioEl === null || dummyAudioEl === void 0 || dummyAudioEl.remove();
                            dummyAudioEl = null;
                        });
                    }
                    elements.push(dummyAudioEl);
                }
                this.remoteParticipants.forEach((p)=>{
                    p.audioTrackPublications.forEach((t)=>{
                        if (t.track) t.track.attachedElements.forEach((e)=>{
                            elements.push(e);
                        });
                    });
                });
                try {
                    yield Promise.all([
                        this.acquireAudioContext(),
                        ...elements.map((e)=>{
                            e.muted = false;
                            return e.play();
                        })
                    ]);
                    this.handleAudioPlaybackStarted();
                } catch (err) {
                    this.handleAudioPlaybackFailed(err);
                    throw err;
                }
            });
        this.startVideo = ()=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                const elements = [];
                for (const p of this.remoteParticipants.values())p.videoTrackPublications.forEach((tr)=>{
                    var _a;
                    (_a = tr.track) === null || _a === void 0 || _a.attachedElements.forEach((el)=>{
                        if (!elements.includes(el)) elements.push(el);
                    });
                });
                yield Promise.all(elements.map((el)=>el.play())).then(()=>{
                    this.handleVideoPlaybackStarted();
                }).catch((e)=>{
                    if (e.name === 'NotAllowedError') this.handleVideoPlaybackFailed();
                    else this.log.warn('Resuming video playback failed, make sure you call `startVideo` directly in a user gesture handler');
                });
            });
        this.handleRestarting = ()=>{
            this.clearConnectionReconcile();
            // in case we went from resuming to full-reconnect, make sure to reflect it on the isResuming flag
            this.isResuming = false;
            // also unwind existing participants & existing subscriptions
            for (const p of this.remoteParticipants.values())this.handleParticipantDisconnected(p.identity, p);
            if (this.setAndEmitConnectionState($c0722d30b1d17141$export$cd9c3c6bf535afc9.Reconnecting)) this.emit($c0722d30b1d17141$export$3159c672e3b2293a.Reconnecting);
        };
        this.handleRestarted = ()=>{
            this.outgoingDataTrackManager.sfuWillRepublishTracks();
            this.incomingDataTrackManager.resendSubscriptionUpdates();
        };
        this.handleSignalRestarted = (joinResponse)=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                this.log.debug("signal reconnected to server, region ".concat(joinResponse.serverRegion), {
                    region: joinResponse.serverRegion
                });
                this.bufferedEvents = [];
                this.applyJoinResponse(joinResponse);
                try {
                    // unpublish & republish tracks
                    yield this.localParticipant.republishAllTracks(undefined, true);
                } catch (error) {
                    this.log.error('error trying to re-publish tracks after reconnection', {
                        error: error
                    });
                }
                try {
                    yield this.engine.waitForRestarted();
                    this.log.debug("fully reconnected to server", {
                        region: joinResponse.serverRegion
                    });
                } catch (_a) {
                    // reconnection failed, handleDisconnect is being invoked already, just return here
                    return;
                }
                this.setAndEmitConnectionState($c0722d30b1d17141$export$cd9c3c6bf535afc9.Connected);
                this.emit($c0722d30b1d17141$export$3159c672e3b2293a.Reconnected);
                this.registerConnectionReconcile();
                this.emitBufferedEvents();
            });
        this.handleParticipantUpdates = (participantInfos)=>{
            var _a;
            // handle changes to participant state, and send events
            for (const info of participantInfos){
                if (info.identity === this.localParticipant.identity) {
                    this.localParticipant.updateInfo(info);
                    continue;
                }
                // LiveKit server doesn't send identity info prior to version 1.5.2 in disconnect updates
                // so we try to map an empty identity to an already known sID manually
                if (info.identity === '') info.identity = (_a = this.sidToIdentity.get(info.sid)) !== null && _a !== void 0 ? _a : '';
                let remoteParticipant = this.remoteParticipants.get(info.identity);
                // when it's disconnected, send updates
                if (info.state === $c0722d30b1d17141$var$ParticipantInfo_State.DISCONNECTED) this.handleParticipantDisconnected(info.identity, remoteParticipant);
                else // create participant if doesn't exist
                remoteParticipant = this.getOrCreateParticipant(info.identity, info);
            }
            // Ingest data track publication updates into data tracks infrastructure
            const mapped = new Map(participantInfos.filter((p)=>p.identity !== this.localParticipant.identity).map((info)=>{
                return [
                    info.identity,
                    info.dataTracks.map((dataTrack)=>$c0722d30b1d17141$var$DataTrackInfo.from(dataTrack))
                ];
            }));
            this.incomingDataTrackManager.receiveSfuPublicationUpdates(mapped);
        };
        // updates are sent only when there's a change to speaker ordering
        this.handleActiveSpeakersUpdate = (speakers)=>{
            const activeSpeakers = [];
            const seenSids = {};
            speakers.forEach((speaker)=>{
                seenSids[speaker.sid] = true;
                if (speaker.sid === this.localParticipant.sid) {
                    this.localParticipant.audioLevel = speaker.level;
                    this.localParticipant.setIsSpeaking(true);
                    activeSpeakers.push(this.localParticipant);
                } else {
                    const p = this.getRemoteParticipantBySid(speaker.sid);
                    if (p) {
                        p.audioLevel = speaker.level;
                        p.setIsSpeaking(true);
                        activeSpeakers.push(p);
                    }
                }
            });
            if (!seenSids[this.localParticipant.sid]) {
                this.localParticipant.audioLevel = 0;
                this.localParticipant.setIsSpeaking(false);
            }
            this.remoteParticipants.forEach((p)=>{
                if (!seenSids[p.sid]) {
                    p.audioLevel = 0;
                    p.setIsSpeaking(false);
                }
            });
            this.activeSpeakers = activeSpeakers;
            this.emitWhenConnected($c0722d30b1d17141$export$3159c672e3b2293a.ActiveSpeakersChanged, activeSpeakers);
        };
        // process list of changed speakers
        this.handleSpeakersChanged = (speakerUpdates)=>{
            const lastSpeakers = new Map();
            this.activeSpeakers.forEach((p)=>{
                const remoteParticipant = this.remoteParticipants.get(p.identity);
                if (remoteParticipant && remoteParticipant.sid !== p.sid) return;
                lastSpeakers.set(p.sid, p);
            });
            speakerUpdates.forEach((speaker)=>{
                let p = this.getRemoteParticipantBySid(speaker.sid);
                if (speaker.sid === this.localParticipant.sid) p = this.localParticipant;
                if (!p) return;
                p.audioLevel = speaker.level;
                p.setIsSpeaking(speaker.active);
                if (speaker.active) lastSpeakers.set(speaker.sid, p);
                else lastSpeakers.delete(speaker.sid);
            });
            const activeSpeakers = Array.from(lastSpeakers.values());
            activeSpeakers.sort((a, b)=>b.audioLevel - a.audioLevel);
            this.activeSpeakers = activeSpeakers;
            this.emitWhenConnected($c0722d30b1d17141$export$3159c672e3b2293a.ActiveSpeakersChanged, activeSpeakers);
        };
        this.handleStreamStateUpdate = (streamStateUpdate)=>{
            streamStateUpdate.streamStates.forEach((streamState)=>{
                const participant = this.getRemoteParticipantBySid(streamState.participantSid);
                if (!participant) return;
                const pub = participant.getTrackPublicationBySid(streamState.trackSid);
                if (!pub || !pub.track) return;
                const newStreamState = $c0722d30b1d17141$export$13921ac0cc260818.streamStateFromProto(streamState.state);
                pub.track.setStreamState(newStreamState);
                if (newStreamState !== pub.track.streamState) {
                    participant.emit($c0722d30b1d17141$export$fcdfe2b7a6750691.TrackStreamStateChanged, pub, pub.track.streamState);
                    this.emitWhenConnected($c0722d30b1d17141$export$3159c672e3b2293a.TrackStreamStateChanged, pub, pub.track.streamState, participant);
                }
            });
        };
        this.handleSubscriptionPermissionUpdate = (update)=>{
            const participant = this.getRemoteParticipantBySid(update.participantSid);
            if (!participant) return;
            const pub = participant.getTrackPublicationBySid(update.trackSid);
            if (!pub) return;
            pub.setAllowed(update.allowed);
        };
        this.handleSubscriptionError = (update)=>{
            const participant = Array.from(this.remoteParticipants.values()).find((p)=>p.trackPublications.has(update.trackSid));
            if (!participant) return;
            const pub = participant.getTrackPublicationBySid(update.trackSid);
            if (!pub) return;
            pub.setSubscriptionError(update.err);
        };
        this.handleDataPacket = (packet, encryptionType)=>{
            // find the participant
            const participant = this.remoteParticipants.get(packet.participantIdentity);
            if (packet.value.case === 'user') this.handleUserPacket(participant, packet.value.value, packet.kind, encryptionType);
            else if (packet.value.case === 'transcription') this.handleTranscription(participant, packet.value.value);
            else if (packet.value.case === 'sipDtmf') this.handleSipDtmf(participant, packet.value.value);
            else if (packet.value.case === 'chatMessage') this.handleChatMessage(participant, packet.value.value);
            else if (packet.value.case === 'metrics') this.handleMetrics(packet.value.value, participant);
            else if (packet.value.case === 'streamHeader' || packet.value.case === 'streamChunk' || packet.value.case === 'streamTrailer') this.handleDataStream(packet, encryptionType);
            else if (packet.value.case === 'rpcRequest') {
                const rpc = packet.value.value;
                this.handleIncomingRpcRequest(packet.participantIdentity, rpc.id, rpc.method, rpc.payload, rpc.responseTimeoutMs, rpc.version);
            }
        };
        this.handleUserPacket = (participant, userPacket, kind, encryptionType)=>{
            this.emit($c0722d30b1d17141$export$3159c672e3b2293a.DataReceived, userPacket.payload, participant, kind, userPacket.topic, encryptionType);
            // also emit on the participant
            participant === null || participant === void 0 || participant.emit($c0722d30b1d17141$export$fcdfe2b7a6750691.DataReceived, userPacket.payload, kind, encryptionType);
        };
        this.handleSipDtmf = (participant, dtmf)=>{
            this.emit($c0722d30b1d17141$export$3159c672e3b2293a.SipDTMFReceived, dtmf, participant);
            // also emit on the participant
            participant === null || participant === void 0 || participant.emit($c0722d30b1d17141$export$fcdfe2b7a6750691.SipDTMFReceived, dtmf);
        };
        this.handleTranscription = (_remoteParticipant, transcription)=>{
            // find the participant
            const participant = transcription.transcribedParticipantIdentity === this.localParticipant.identity ? this.localParticipant : this.getParticipantByIdentity(transcription.transcribedParticipantIdentity);
            const publication = participant === null || participant === void 0 ? void 0 : participant.trackPublications.get(transcription.trackId);
            const segments = $c0722d30b1d17141$var$extractTranscriptionSegments(transcription, this.transcriptionReceivedTimes);
            publication === null || publication === void 0 || publication.emit($c0722d30b1d17141$export$2c8510d737cc09da.TranscriptionReceived, segments);
            participant === null || participant === void 0 || participant.emit($c0722d30b1d17141$export$fcdfe2b7a6750691.TranscriptionReceived, segments, publication);
            this.emit($c0722d30b1d17141$export$3159c672e3b2293a.TranscriptionReceived, segments, participant, publication);
        };
        this.handleChatMessage = (participant, chatMessage)=>{
            const msg = $c0722d30b1d17141$var$extractChatMessage(chatMessage);
            this.emit($c0722d30b1d17141$export$3159c672e3b2293a.ChatMessage, msg, participant);
        };
        this.handleMetrics = (metrics, participant)=>{
            this.emit($c0722d30b1d17141$export$3159c672e3b2293a.MetricsReceived, metrics, participant);
        };
        this.handleDataStream = (packet, encryptionType)=>{
            this.incomingDataStreamManager.handleDataStreamPacket(packet, encryptionType);
        };
        this.bufferedSegments = new Map();
        this.handleAudioPlaybackStarted = ()=>{
            if (this.canPlaybackAudio) return;
            this.audioEnabled = true;
            this.emit($c0722d30b1d17141$export$3159c672e3b2293a.AudioPlaybackStatusChanged, true);
        };
        this.handleAudioPlaybackFailed = (e)=>{
            this.log.warn('could not playback audio', {
                error: e
            });
            if (!this.canPlaybackAudio) return;
            this.audioEnabled = false;
            this.emit($c0722d30b1d17141$export$3159c672e3b2293a.AudioPlaybackStatusChanged, false);
        };
        this.handleVideoPlaybackStarted = ()=>{
            if (this.isVideoPlaybackBlocked) {
                this.isVideoPlaybackBlocked = false;
                this.emit($c0722d30b1d17141$export$3159c672e3b2293a.VideoPlaybackStatusChanged, true);
            }
        };
        this.handleVideoPlaybackFailed = ()=>{
            if (!this.isVideoPlaybackBlocked) {
                this.isVideoPlaybackBlocked = true;
                this.emit($c0722d30b1d17141$export$3159c672e3b2293a.VideoPlaybackStatusChanged, false);
            }
        };
        this.handleDeviceChange = ()=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                var _a;
                if (((_a = $c0722d30b1d17141$export$89e15fc796a4a429()) === null || _a === void 0 ? void 0 : _a.os) !== 'iOS') // default devices are non deterministic on iOS, so we don't attempt to select them here
                yield this.selectDefaultDevices();
                this.emit($c0722d30b1d17141$export$3159c672e3b2293a.MediaDevicesChanged);
            });
        this.handleRoomUpdate = (room)=>{
            const oldRoom = this.roomInfo;
            this.roomInfo = room;
            if (oldRoom && oldRoom.metadata !== room.metadata) this.emitWhenConnected($c0722d30b1d17141$export$3159c672e3b2293a.RoomMetadataChanged, room.metadata);
            if ((oldRoom === null || oldRoom === void 0 ? void 0 : oldRoom.activeRecording) !== room.activeRecording) this.emitWhenConnected($c0722d30b1d17141$export$3159c672e3b2293a.RecordingStatusChanged, room.activeRecording);
        };
        this.handleConnectionQualityUpdate = (update)=>{
            update.updates.forEach((info)=>{
                if (info.participantSid === this.localParticipant.sid) {
                    this.localParticipant.setConnectionQuality(info.quality);
                    return;
                }
                const participant = this.getRemoteParticipantBySid(info.participantSid);
                if (participant) participant.setConnectionQuality(info.quality);
            });
        };
        this.onLocalParticipantMetadataChanged = (metadata)=>{
            this.emit($c0722d30b1d17141$export$3159c672e3b2293a.ParticipantMetadataChanged, metadata, this.localParticipant);
        };
        this.onLocalParticipantNameChanged = (name)=>{
            this.emit($c0722d30b1d17141$export$3159c672e3b2293a.ParticipantNameChanged, name, this.localParticipant);
        };
        this.onLocalAttributesChanged = (changedAttributes)=>{
            this.emit($c0722d30b1d17141$export$3159c672e3b2293a.ParticipantAttributesChanged, changedAttributes, this.localParticipant);
        };
        this.onLocalTrackMuted = (pub)=>{
            this.emit($c0722d30b1d17141$export$3159c672e3b2293a.TrackMuted, pub, this.localParticipant);
        };
        this.onLocalTrackUnmuted = (pub)=>{
            this.emit($c0722d30b1d17141$export$3159c672e3b2293a.TrackUnmuted, pub, this.localParticipant);
        };
        this.onTrackProcessorUpdate = (processor)=>{
            var _a;
            (_a = processor === null || processor === void 0 ? void 0 : processor.onPublish) === null || _a === void 0 || _a.call(processor, this);
        };
        this.onLocalTrackPublished = (pub)=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                var _a, _b, _c, _d, _e, _f;
                (_a = pub.track) === null || _a === void 0 || _a.on($c0722d30b1d17141$export$2c8510d737cc09da.TrackProcessorUpdate, this.onTrackProcessorUpdate);
                (_b = pub.track) === null || _b === void 0 || _b.on($c0722d30b1d17141$export$2c8510d737cc09da.Restarted, this.onLocalTrackRestarted);
                (_e = (_d = (_c = pub.track) === null || _c === void 0 ? void 0 : _c.getProcessor()) === null || _d === void 0 ? void 0 : _d.onPublish) === null || _e === void 0 || _e.call(_d, this);
                this.emit($c0722d30b1d17141$export$3159c672e3b2293a.LocalTrackPublished, pub, this.localParticipant);
                if ($c0722d30b1d17141$var$isLocalAudioTrack(pub.track)) {
                    const trackIsSilent = yield pub.track.checkForSilence();
                    if (trackIsSilent) this.emit($c0722d30b1d17141$export$3159c672e3b2293a.LocalAudioSilenceDetected, pub);
                }
                const deviceId = yield (_f = pub.track) === null || _f === void 0 ? void 0 : _f.getDeviceId(false);
                const deviceKind = $c0722d30b1d17141$var$sourceToKind(pub.source);
                if (deviceKind && deviceId && deviceId !== this.localParticipant.activeDeviceMap.get(deviceKind)) {
                    this.localParticipant.activeDeviceMap.set(deviceKind, deviceId);
                    this.emit($c0722d30b1d17141$export$3159c672e3b2293a.ActiveDeviceChanged, deviceKind, deviceId);
                }
            });
        this.onLocalTrackUnpublished = (pub)=>{
            var _a, _b;
            (_a = pub.track) === null || _a === void 0 || _a.off($c0722d30b1d17141$export$2c8510d737cc09da.TrackProcessorUpdate, this.onTrackProcessorUpdate);
            (_b = pub.track) === null || _b === void 0 || _b.off($c0722d30b1d17141$export$2c8510d737cc09da.Restarted, this.onLocalTrackRestarted);
            this.emit($c0722d30b1d17141$export$3159c672e3b2293a.LocalTrackUnpublished, pub, this.localParticipant);
        };
        this.onLocalTrackRestarted = (track)=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                const deviceId = yield track.getDeviceId(false);
                const deviceKind = $c0722d30b1d17141$var$sourceToKind(track.source);
                if (deviceKind && deviceId && deviceId !== this.localParticipant.activeDeviceMap.get(deviceKind)) {
                    this.log.debug("local track restarted, setting ".concat(deviceKind, " ").concat(deviceId, " active"));
                    this.localParticipant.activeDeviceMap.set(deviceKind, deviceId);
                    this.emit($c0722d30b1d17141$export$3159c672e3b2293a.ActiveDeviceChanged, deviceKind, deviceId);
                }
            });
        this.onLocalConnectionQualityChanged = (quality)=>{
            this.emit($c0722d30b1d17141$export$3159c672e3b2293a.ConnectionQualityChanged, quality, this.localParticipant);
        };
        this.onMediaDevicesError = (e, kind)=>{
            this.emit($c0722d30b1d17141$export$3159c672e3b2293a.MediaDevicesError, e, kind);
        };
        this.onLocalParticipantPermissionsChanged = (prevPermissions)=>{
            this.emit($c0722d30b1d17141$export$3159c672e3b2293a.ParticipantPermissionsChanged, prevPermissions, this.localParticipant);
        };
        this.onLocalChatMessageSent = (msg)=>{
            this.emit($c0722d30b1d17141$export$3159c672e3b2293a.ChatMessage, msg, this.localParticipant);
        };
        this.setMaxListeners(100);
        this.remoteParticipants = new Map();
        this.sidToIdentity = new Map();
        this.options = Object.assign(Object.assign({}, $c0722d30b1d17141$var$roomOptionDefaults), options);
        this.log = $c0722d30b1d17141$export$2b1d391cd05230fd((_a = this.options.loggerName) !== null && _a !== void 0 ? _a : $c0722d30b1d17141$export$69ba24dd79f4da21.Room, ()=>this.logContext);
        this.transcriptionReceivedTimes = new Map();
        this.options.audioCaptureDefaults = Object.assign(Object.assign({}, $c0722d30b1d17141$var$audioDefaults), options === null || options === void 0 ? void 0 : options.audioCaptureDefaults);
        this.options.videoCaptureDefaults = Object.assign(Object.assign({}, $c0722d30b1d17141$var$videoDefaults), options === null || options === void 0 ? void 0 : options.videoCaptureDefaults);
        this.options.publishDefaults = Object.assign(Object.assign({}, $c0722d30b1d17141$var$publishDefaults), options === null || options === void 0 ? void 0 : options.publishDefaults);
        this.maybeCreateEngine();
        this.incomingDataStreamManager = new $c0722d30b1d17141$var$IncomingDataStreamManager();
        this.outgoingDataStreamManager = new $c0722d30b1d17141$var$OutgoingDataStreamManager(this.engine, this.log);
        this.incomingDataTrackManager = new $c0722d30b1d17141$var$IncomingDataTrackManager({
            e2eeManager: this.e2eeManager
        });
        this.incomingDataTrackManager.on('sfuUpdateSubscription', (event)=>{
            this.engine.client.sendUpdateDataSubscription(event.sid, event.subscribe);
        }).on('trackPublished', (event)=>{
            var _a;
            if (event.track.publisherIdentity === this.localParticipant.identity) // Only advertize tracks from other participants
            return;
            this.emit($c0722d30b1d17141$export$3159c672e3b2293a.DataTrackPublished, event.track);
            (_a = this.remoteParticipants.get(event.track.publisherIdentity)) === null || _a === void 0 || _a.addRemoteDataTrack(event.track);
        }).on('trackUnpublished', (event)=>{
            var _a;
            if (event.publisherIdentity === this.localParticipant.identity) // Only advertize tracks from other participants
            return;
            this.emit($c0722d30b1d17141$export$3159c672e3b2293a.DataTrackUnpublished, event.sid);
            (_a = this.remoteParticipants.get(event.publisherIdentity)) === null || _a === void 0 || _a.removeRemoteDataTrack(event.sid);
        });
        this.outgoingDataTrackManager = new $c0722d30b1d17141$var$OutgoingDataTrackManager({
            e2eeManager: this.e2eeManager
        });
        this.outgoingDataTrackManager.on('sfuPublishRequest', (event)=>{
            this.engine.client.sendPublishDataTrackRequest(event.handle, event.name, event.usesE2ee);
        }).on('sfuUnpublishRequest', (event)=>{
            this.engine.client.sendUnPublishDataTrackRequest(event.handle);
        }).on('trackPublished', (event)=>{
            this.emit($c0722d30b1d17141$export$3159c672e3b2293a.LocalDataTrackPublished, event.track);
        }).on('trackUnpublished', (event)=>{
            this.emit($c0722d30b1d17141$export$3159c672e3b2293a.LocalDataTrackUnpublished, event.sid);
        }).on('packetAvailable', (_ref)=>{
            let { handle: handle, bytes: bytes } = _ref;
            this.engine.sendLossyBytes(bytes, $c0722d30b1d17141$var$DataChannelKind.DATA_TRACK_LOSSY, 'wait').finally(()=>this.outgoingDataTrackManager.handlePacketSendComplete(handle));
        });
        this.disconnectLock = new $c0722d30b1d17141$export$ca12f2943758ef55();
        this.localParticipant = new $c0722d30b1d17141$export$ed007fa30041dd89('', '', this.engine, this.options, this.rpcHandlers, this.outgoingDataStreamManager, this.outgoingDataTrackManager);
        if (this.options.e2ee || this.options.encryption) this.setupE2EE();
        this.engine.e2eeManager = this.e2eeManager;
        this.incomingDataTrackManager.updateE2eeManager((_b = this.e2eeManager) !== null && _b !== void 0 ? _b : null);
        this.outgoingDataTrackManager.updateE2eeManager((_c = this.e2eeManager) !== null && _c !== void 0 ? _c : null);
        if (this.options.videoCaptureDefaults.deviceId) this.localParticipant.activeDeviceMap.set('videoinput', $c0722d30b1d17141$var$unwrapConstraint(this.options.videoCaptureDefaults.deviceId));
        if (this.options.audioCaptureDefaults.deviceId) this.localParticipant.activeDeviceMap.set('audioinput', $c0722d30b1d17141$var$unwrapConstraint(this.options.audioCaptureDefaults.deviceId));
        if ((_d = this.options.audioOutput) === null || _d === void 0 ? void 0 : _d.deviceId) this.switchActiveDevice('audiooutput', $c0722d30b1d17141$var$unwrapConstraint(this.options.audioOutput.deviceId)).catch((e)=>this.log.warn("Could not set audio output: ".concat(e.message)));
        if ($c0722d30b1d17141$var$isWeb()) {
            const abortController = new AbortController();
            // in order to catch device changes prior to room connection we need to register the event in the constructor
            (_f = (_e = navigator.mediaDevices) === null || _e === void 0 ? void 0 : _e.addEventListener) === null || _f === void 0 || _f.call(_e, 'devicechange', this.handleDeviceChange, {
                signal: abortController.signal
            });
            if ($c0722d30b1d17141$export$525628e68e798fb4.cleanupRegistry) $c0722d30b1d17141$export$525628e68e798fb4.cleanupRegistry.register(this, ()=>{
                abortController.abort();
            });
        }
    }
    registerTextStreamHandler(topic, callback) {
        return this.incomingDataStreamManager.registerTextStreamHandler(topic, callback);
    }
    unregisterTextStreamHandler(topic) {
        return this.incomingDataStreamManager.unregisterTextStreamHandler(topic);
    }
    registerByteStreamHandler(topic, callback) {
        return this.incomingDataStreamManager.registerByteStreamHandler(topic, callback);
    }
    unregisterByteStreamHandler(topic) {
        return this.incomingDataStreamManager.unregisterByteStreamHandler(topic);
    }
    /**
   * Establishes the participant as a receiver for calls of the specified RPC method.
   *
   * @param method - The name of the indicated RPC method
   * @param handler - Will be invoked when an RPC request for this method is received
   * @returns A promise that resolves when the method is successfully registered
   * @throws {Error} If a handler for this method is already registered (must call unregisterRpcMethod first)
   *
   * @example
   * ```typescript
   * room.localParticipant?.registerRpcMethod(
   *   'greet',
   *   async (data: RpcInvocationData) => {
   *     console.log(`Received greeting from ${data.callerIdentity}: ${data.payload}`);
   *     return `Hello, ${data.callerIdentity}!`;
   *   }
   * );
   * ```
   *
   * The handler should return a Promise that resolves to a string.
   * If unable to respond within `responseTimeout`, the request will result in an error on the caller's side.
   *
   * You may throw errors of type `RpcError` with a string `message` in the handler,
   * and they will be received on the caller's side with the message intact.
   * Other errors thrown in your handler will not be transmitted as-is, and will instead arrive to the caller as `1500` ("Application Error").
   */ registerRpcMethod(method, handler) {
        if (this.rpcHandlers.has(method)) throw Error("RPC handler already registered for method ".concat(method, ", unregisterRpcMethod before trying to register again"));
        this.rpcHandlers.set(method, handler);
    }
    /**
   * Unregisters a previously registered RPC method.
   *
   * @param method - The name of the RPC method to unregister
   */ unregisterRpcMethod(method) {
        this.rpcHandlers.delete(method);
    }
    /**
   * @experimental
   */ setE2EEEnabled(enabled) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            const unlock = yield this.e2eeStateMutex.lock();
            try {
                if (this.e2eeManager) {
                    if (this.isE2EEEnabled !== enabled) {
                        yield this.localParticipant.setE2EEEnabled(enabled);
                        if (this.localParticipant.identity !== '') this.e2eeManager.setParticipantCryptorEnabled(enabled, this.localParticipant.identity);
                    }
                } else throw Error('e2ee not configured, please set e2ee settings within the room options');
            } finally{
                unlock();
            }
        });
    }
    setupE2EE() {
        // when encryption is enabled via `options.encryption`, we enable data channel encryption
        var _a, _b;
        const dcEncryptionEnabled = !!this.options.encryption;
        const e2eeOptions = this.options.encryption || this.options.e2ee;
        if (e2eeOptions) {
            if ('e2eeManager' in e2eeOptions) {
                this.e2eeManager = e2eeOptions.e2eeManager;
                this.e2eeManager.isDataChannelEncryptionEnabled = dcEncryptionEnabled;
            } else this.e2eeManager = new $c0722d30b1d17141$var$E2EEManager(e2eeOptions, dcEncryptionEnabled);
            this.e2eeManager.on($c0722d30b1d17141$export$36ec54aef832f50f.ParticipantEncryptionStatusChanged, (enabled, participant)=>{
                if ($c0722d30b1d17141$export$c3f68b5804e192f2(participant)) this.isE2EEEnabled = enabled;
                this.emit($c0722d30b1d17141$export$3159c672e3b2293a.ParticipantEncryptionStatusChanged, enabled, participant);
            });
            this.e2eeManager.on($c0722d30b1d17141$export$36ec54aef832f50f.EncryptionError, (error, participantIdentity)=>{
                const participant = participantIdentity ? this.getParticipantByIdentity(participantIdentity) : undefined;
                this.emit($c0722d30b1d17141$export$3159c672e3b2293a.EncryptionError, error, participant);
            });
            (_a = this.e2eeManager) === null || _a === void 0 || _a.setup(this);
            (_b = this.e2eeManager) === null || _b === void 0 || _b.setupEngine(this.engine);
        }
    }
    get logContext() {
        var _a, _b, _c;
        return {
            room: this.name,
            roomID: (_a = this.roomInfo) === null || _a === void 0 ? void 0 : _a.sid,
            participant: (_b = this.localParticipant) === null || _b === void 0 ? void 0 : _b.identity,
            participantID: (_c = this.localParticipant) === null || _c === void 0 ? void 0 : _c.sid
        };
    }
    /**
   * if the current room has a participant with `recorder: true` in its JWT grant
   **/ get isRecording() {
        var _a, _b;
        return (_b = (_a = this.roomInfo) === null || _a === void 0 ? void 0 : _a.activeRecording) !== null && _b !== void 0 ? _b : false;
    }
    /**
   * server assigned unique room id.
   * returns once a sid has been issued by the server.
   */ getSid() {
        if (this.state === $c0722d30b1d17141$export$cd9c3c6bf535afc9.Disconnected) return $c0722d30b1d17141$var$TypedPromise.resolve('');
        if (this.roomInfo && this.roomInfo.sid !== '') return $c0722d30b1d17141$var$TypedPromise.resolve(this.roomInfo.sid);
        return new $c0722d30b1d17141$var$TypedPromise((resolve, reject)=>{
            const handleRoomUpdate = (roomInfo)=>{
                if (roomInfo.sid !== '') {
                    this.engine.off($c0722d30b1d17141$export$c09e63b8572f869.RoomUpdate, handleRoomUpdate);
                    resolve(roomInfo.sid);
                }
            };
            this.engine.on($c0722d30b1d17141$export$c09e63b8572f869.RoomUpdate, handleRoomUpdate);
            this.once($c0722d30b1d17141$export$3159c672e3b2293a.Disconnected, ()=>{
                this.engine.off($c0722d30b1d17141$export$c09e63b8572f869.RoomUpdate, handleRoomUpdate);
                reject(new $c0722d30b1d17141$export$1f388e244efbf70b('Room disconnected before room server id was available'));
            });
        });
    }
    /** user assigned name, derived from JWT token */ get name() {
        var _a, _b;
        return (_b = (_a = this.roomInfo) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '';
    }
    /** room metadata */ get metadata() {
        var _a;
        return (_a = this.roomInfo) === null || _a === void 0 ? void 0 : _a.metadata;
    }
    get numParticipants() {
        var _a, _b;
        return (_b = (_a = this.roomInfo) === null || _a === void 0 ? void 0 : _a.numParticipants) !== null && _b !== void 0 ? _b : 0;
    }
    get numPublishers() {
        var _a, _b;
        return (_b = (_a = this.roomInfo) === null || _a === void 0 ? void 0 : _a.numPublishers) !== null && _b !== void 0 ? _b : 0;
    }
    maybeCreateEngine() {
        if (this.engine && (this.engine.isNewlyCreated || !this.engine.isClosed)) return;
        this.engine = new $c0722d30b1d17141$var$RTCEngine(this.options);
        this.engine.e2eeManager = this.e2eeManager;
        this.engine.on($c0722d30b1d17141$export$c09e63b8572f869.ParticipantUpdate, this.handleParticipantUpdates).on($c0722d30b1d17141$export$c09e63b8572f869.RoomUpdate, this.handleRoomUpdate).on($c0722d30b1d17141$export$c09e63b8572f869.SpeakersChanged, this.handleSpeakersChanged).on($c0722d30b1d17141$export$c09e63b8572f869.StreamStateChanged, this.handleStreamStateUpdate).on($c0722d30b1d17141$export$c09e63b8572f869.ConnectionQualityUpdate, this.handleConnectionQualityUpdate).on($c0722d30b1d17141$export$c09e63b8572f869.SubscriptionError, this.handleSubscriptionError).on($c0722d30b1d17141$export$c09e63b8572f869.SubscriptionPermissionUpdate, this.handleSubscriptionPermissionUpdate).on($c0722d30b1d17141$export$c09e63b8572f869.MediaTrackAdded, (mediaTrack, stream, receiver)=>{
            this.onTrackAdded(mediaTrack, stream, receiver);
        }).on($c0722d30b1d17141$export$c09e63b8572f869.Disconnected, (reason)=>{
            this.handleDisconnect(this.options.stopLocalTrackOnUnpublish, reason);
        }).on($c0722d30b1d17141$export$c09e63b8572f869.ActiveSpeakersUpdate, this.handleActiveSpeakersUpdate).on($c0722d30b1d17141$export$c09e63b8572f869.DataPacketReceived, this.handleDataPacket).on($c0722d30b1d17141$export$c09e63b8572f869.Resuming, ()=>{
            this.clearConnectionReconcile();
            this.isResuming = true;
            this.log.debug('Resuming signal connection');
            if (this.setAndEmitConnectionState($c0722d30b1d17141$export$cd9c3c6bf535afc9.SignalReconnecting)) this.emit($c0722d30b1d17141$export$3159c672e3b2293a.SignalReconnecting);
        }).on($c0722d30b1d17141$export$c09e63b8572f869.Resumed, ()=>{
            this.registerConnectionReconcile();
            this.isResuming = false;
            this.log.debug('Resumed signal connection');
            this.updateSubscriptions();
            this.emitBufferedEvents();
            if (this.setAndEmitConnectionState($c0722d30b1d17141$export$cd9c3c6bf535afc9.Connected)) this.emit($c0722d30b1d17141$export$3159c672e3b2293a.Reconnected);
        }).on($c0722d30b1d17141$export$c09e63b8572f869.SignalResumed, ()=>{
            this.bufferedEvents = [];
            if (this.state === $c0722d30b1d17141$export$cd9c3c6bf535afc9.Reconnecting || this.isResuming) this.sendSyncState();
        }).on($c0722d30b1d17141$export$c09e63b8572f869.Restarting, this.handleRestarting).on($c0722d30b1d17141$export$c09e63b8572f869.Restarted, this.handleRestarted).on($c0722d30b1d17141$export$c09e63b8572f869.SignalRestarted, this.handleSignalRestarted).on($c0722d30b1d17141$export$c09e63b8572f869.Offline, ()=>{
            if (this.setAndEmitConnectionState($c0722d30b1d17141$export$cd9c3c6bf535afc9.Reconnecting)) this.emit($c0722d30b1d17141$export$3159c672e3b2293a.Reconnecting);
        }).on($c0722d30b1d17141$export$c09e63b8572f869.DCBufferStatusChanged, (status, kind)=>{
            this.emit($c0722d30b1d17141$export$3159c672e3b2293a.DCBufferStatusChanged, status, kind);
        }).on($c0722d30b1d17141$export$c09e63b8572f869.LocalTrackSubscribed, (subscribedSid)=>{
            this.handleLocalTrackSubscribed(subscribedSid);
        }).on($c0722d30b1d17141$export$c09e63b8572f869.RoomMoved, (roomMoved)=>{
            this.log.debug('room moved', roomMoved);
            if (roomMoved.room) this.handleRoomUpdate(roomMoved.room);
            this.remoteParticipants.forEach((participant, identity)=>{
                this.handleParticipantDisconnected(identity, participant);
            });
            this.emit($c0722d30b1d17141$export$3159c672e3b2293a.Moved, roomMoved.room.name);
            if (roomMoved.participant) this.handleParticipantUpdates([
                roomMoved.participant,
                ...roomMoved.otherParticipants
            ]);
            else this.handleParticipantUpdates(roomMoved.otherParticipants);
        }).on($c0722d30b1d17141$export$c09e63b8572f869.PublishDataTrackResponse, (event)=>{
            if (!event.info) {
                this.log.warn("received PublishDataTrackResponse, but event.info was ".concat(event.info, ", so skipping."));
                return;
            }
            this.outgoingDataTrackManager.receivedSfuPublishResponse(event.info.pubHandle, {
                type: 'ok',
                data: {
                    sid: event.info.sid,
                    pubHandle: event.info.pubHandle,
                    name: event.info.name,
                    usesE2ee: event.info.encryption !== $c0722d30b1d17141$export$1efc488791285f20.NONE
                }
            });
        }).on($c0722d30b1d17141$export$c09e63b8572f869.UnPublishDataTrackResponse, (event)=>{
            if (!event.info) {
                this.log.warn("received UnPublishDataTrackResponse, but event.info was ".concat(event.info, ", so skipping."));
                return;
            }
            this.outgoingDataTrackManager.receivedSfuUnpublishResponse(event.info.pubHandle);
        }).on($c0722d30b1d17141$export$c09e63b8572f869.DataTrackSubscriberHandles, (event)=>{
            const handleToSidMapping = new Map(Object.entries(event.subHandles).map((_ref2)=>{
                let [key, value] = _ref2;
                return [
                    parseInt(key, 10),
                    value.trackSid
                ];
            }));
            this.incomingDataTrackManager.receivedSfuSubscriberHandles(handleToSidMapping);
        }).on($c0722d30b1d17141$export$c09e63b8572f869.DataTrackPacketReceived, (packetBytes)=>{
            try {
                this.incomingDataTrackManager.packetReceived(packetBytes);
            } catch (err) {
                // NOTE: wrapping in the bare try/catch like this means that the Throws<...> type doesn't
                // propagate upwards into the public interface.
                throw err;
            }
        }).on($c0722d30b1d17141$export$c09e63b8572f869.Joined, (joinResponse)=>{
            // Ingest data track publication updates into data tracks infrastructure
            const mapped = new Map(joinResponse.otherParticipants.map((participant)=>{
                return [
                    participant.identity,
                    participant.dataTracks.map((info)=>$c0722d30b1d17141$var$DataTrackInfo.from(info))
                ];
            }));
            this.incomingDataTrackManager.receiveSfuPublicationUpdates(mapped);
        }).on($c0722d30b1d17141$export$c09e63b8572f869.TokenRefreshed, (token)=>{
            var _a;
            (_a = this.regionUrlProvider) === null || _a === void 0 || _a.updateToken(token);
        }).on($c0722d30b1d17141$export$c09e63b8572f869.ServerRegionsReported, (regions)=>{
            var _a;
            (_a = this.regionUrlProvider) === null || _a === void 0 || _a.setServerReportedRegions({
                regionSettings: regions,
                updatedAtInMs: Date.now(),
                maxAgeInMs: $c0722d30b1d17141$var$DEFAULT_MAX_AGE_MS
            });
        });
        if (this.localParticipant) this.localParticipant.setupEngine(this.engine);
        if (this.e2eeManager) this.e2eeManager.setupEngine(this.engine);
        if (this.outgoingDataStreamManager) this.outgoingDataStreamManager.setupEngine(this.engine);
    }
    createRegionStrategy() {
        return {
            getNextUrl: (signal)=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                    return this.regionUrlProvider ? this.regionUrlProvider.getNextBestRegionUrl(signal) : null;
                }),
            resetAttempts: ()=>{
                var _a;
                return (_a = this.regionUrlProvider) === null || _a === void 0 ? void 0 : _a.resetAttempts();
            }
        };
    }
    /**
   * getLocalDevices abstracts navigator.mediaDevices.enumerateDevices.
   * In particular, it requests device permissions by default if needed
   * and makes sure the returned device does not consist of dummy devices
   * @param kind
   * @returns a list of available local devices
   */ static getLocalDevices(kind) {
        let requestPermissions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        return $c0722d30b1d17141$var$DeviceManager.getInstance().getDevices(kind, requestPermissions);
    }
    /**
   * prepareConnection should be called as soon as the page is loaded, in order
   * to speed up the connection attempt. This function will
   * - perform DNS resolution and pre-warm the DNS cache
   * - establish TLS connection and cache TLS keys
   *
   * With LiveKit Cloud, it will also determine the best edge data center for
   * the current client to connect to if a token is provided.
   */ prepareConnection(url, token) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            if (this.state !== $c0722d30b1d17141$export$cd9c3c6bf535afc9.Disconnected) return;
            this.log.debug("prepareConnection to ".concat(url));
            try {
                if ($c0722d30b1d17141$var$isCloud(new URL(url)) && token) {
                    this.regionUrlProvider = new $c0722d30b1d17141$var$RegionUrlProvider(url, token);
                    const regionUrl = yield this.regionUrlProvider.getNextBestRegionUrl();
                    // we will not replace the regionUrl if an attempt had already started
                    // to avoid overriding regionUrl after a new connection attempt had started
                    if (regionUrl && this.state === $c0722d30b1d17141$export$cd9c3c6bf535afc9.Disconnected) {
                        this.regionUrl = regionUrl;
                        yield fetch($c0722d30b1d17141$var$toHttpUrl(regionUrl), {
                            method: 'HEAD'
                        });
                        this.log.debug("prepared connection to ".concat(regionUrl));
                    }
                } else yield fetch($c0722d30b1d17141$var$toHttpUrl(url), {
                    method: 'HEAD'
                });
            } catch (e) {
                this.log.warn('could not prepare connection', {
                    error: e
                });
            }
        });
    }
    /**
   * retrieves a participant by identity
   * @param identity
   * @returns
   */ getParticipantByIdentity(identity) {
        if (this.localParticipant.identity === identity) return this.localParticipant;
        return this.remoteParticipants.get(identity);
    }
    clearConnectionFutures() {
        this.connectFuture = undefined;
    }
    /**
   * @internal for testing
   */ simulateScenario(scenario, arg) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            let postAction = ()=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {});
            let req;
            switch(scenario){
                case 'signal-reconnect':
                    // @ts-expect-error function is private
                    yield this.engine.client.handleOnClose('simulate disconnect');
                    break;
                case 'fail-on-v1-path':
                    this.engine.failNextV1Path();
                    break;
                case 'speaker':
                    req = new $c0722d30b1d17141$var$SimulateScenario({
                        scenario: {
                            case: 'speakerUpdate',
                            value: 3
                        }
                    });
                    break;
                case 'node-failure':
                    req = new $c0722d30b1d17141$var$SimulateScenario({
                        scenario: {
                            case: 'nodeFailure',
                            value: true
                        }
                    });
                    break;
                case 'server-leave':
                    req = new $c0722d30b1d17141$var$SimulateScenario({
                        scenario: {
                            case: 'serverLeave',
                            value: true
                        }
                    });
                    break;
                case 'migration':
                    req = new $c0722d30b1d17141$var$SimulateScenario({
                        scenario: {
                            case: 'migration',
                            value: true
                        }
                    });
                    break;
                case 'resume-reconnect':
                    this.engine.failNext();
                    // @ts-expect-error function is private
                    yield this.engine.client.handleOnClose('simulate resume-disconnect');
                    break;
                case 'disconnect-signal-on-resume':
                    postAction = ()=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                            // @ts-expect-error function is private
                            yield this.engine.client.handleOnClose('simulate resume-disconnect');
                        });
                    req = new $c0722d30b1d17141$var$SimulateScenario({
                        scenario: {
                            case: 'disconnectSignalOnResume',
                            value: true
                        }
                    });
                    break;
                case 'disconnect-signal-on-resume-no-messages':
                    postAction = ()=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                            // @ts-expect-error function is private
                            yield this.engine.client.handleOnClose('simulate resume-disconnect');
                        });
                    req = new $c0722d30b1d17141$var$SimulateScenario({
                        scenario: {
                            case: 'disconnectSignalOnResumeNoMessages',
                            value: true
                        }
                    });
                    break;
                case 'full-reconnect':
                    this.engine.fullReconnectOnNext = true;
                    // @ts-expect-error function is private
                    yield this.engine.client.handleOnClose('simulate full-reconnect');
                    break;
                case 'force-tcp':
                case 'force-tls':
                    req = new $c0722d30b1d17141$var$SimulateScenario({
                        scenario: {
                            case: 'switchCandidateProtocol',
                            value: scenario === 'force-tls' ? 2 : 1
                        }
                    });
                    postAction = ()=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                            const onLeave = this.engine.client.onLeave;
                            if (onLeave) onLeave(new $c0722d30b1d17141$var$LeaveRequest({
                                reason: $c0722d30b1d17141$export$258d16488300d83f.CLIENT_INITIATED,
                                action: $c0722d30b1d17141$var$LeaveRequest_Action.RECONNECT
                            }));
                        });
                    break;
                case 'subscriber-bandwidth':
                    if (arg === undefined || typeof arg !== 'number') throw new Error('subscriber-bandwidth requires a number as argument');
                    req = new $c0722d30b1d17141$var$SimulateScenario({
                        scenario: {
                            case: 'subscriberBandwidth',
                            value: $c0722d30b1d17141$var$numberToBigInt(arg)
                        }
                    });
                    break;
                case 'leave-full-reconnect':
                    req = new $c0722d30b1d17141$var$SimulateScenario({
                        scenario: {
                            case: 'leaveRequestFullReconnect',
                            value: true
                        }
                    });
            }
            if (req) {
                yield this.engine.client.sendSimulateScenario(req);
                yield postAction();
            }
        });
    }
    /**
   * Returns true if audio playback is enabled
   */ get canPlaybackAudio() {
        return this.audioEnabled;
    }
    /**
   * Returns true if video playback is enabled
   */ get canPlaybackVideo() {
        return !this.isVideoPlaybackBlocked;
    }
    getActiveDevice(kind) {
        return this.localParticipant.activeDeviceMap.get(kind);
    }
    /**
   * Switches all active devices used in this room to the given device.
   *
   * Note: setting AudioOutput is not supported on some browsers. See [setSinkId](https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/setSinkId#browser_compatibility)
   *
   * @param kind use `videoinput` for camera track,
   *  `audioinput` for microphone track,
   *  `audiooutput` to set speaker for all incoming audio tracks
   * @param deviceId
   */ switchActiveDevice(kind_1, deviceId_1) {
        return $c0722d30b1d17141$var$__awaiter(this, arguments, void 0, function(kind, deviceId) {
            var _this3 = this;
            let exact = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
            return function*() {
                var _a, _b, _c, _d, _e, _f;
                var _g;
                let success = true;
                let shouldTriggerImmediateDeviceChange = false;
                const deviceConstraint = exact ? {
                    exact: deviceId
                } : deviceId;
                if (kind === 'audioinput') {
                    shouldTriggerImmediateDeviceChange = _this3.localParticipant.audioTrackPublications.size === 0;
                    const prevDeviceId = (_a = _this3.getActiveDevice(kind)) !== null && _a !== void 0 ? _a : _this3.options.audioCaptureDefaults.deviceId;
                    _this3.options.audioCaptureDefaults.deviceId = deviceConstraint;
                    const tracks = Array.from(_this3.localParticipant.audioTrackPublications.values()).filter((track)=>track.source === $c0722d30b1d17141$export$13921ac0cc260818.Source.Microphone);
                    try {
                        success = (yield Promise.all(tracks.map((t)=>{
                            var _a;
                            return (_a = t.audioTrack) === null || _a === void 0 ? void 0 : _a.setDeviceId(deviceConstraint);
                        }))).every((val)=>val === true);
                    } catch (e) {
                        _this3.options.audioCaptureDefaults.deviceId = prevDeviceId;
                        throw e;
                    }
                    const isMuted = tracks.some((t)=>{
                        var _a, _b;
                        return (_b = (_a = t.track) === null || _a === void 0 ? void 0 : _a.isMuted) !== null && _b !== void 0 ? _b : false;
                    });
                    if (success && isMuted) shouldTriggerImmediateDeviceChange = true;
                } else if (kind === 'videoinput') {
                    shouldTriggerImmediateDeviceChange = _this3.localParticipant.videoTrackPublications.size === 0;
                    const prevDeviceId = (_b = _this3.getActiveDevice(kind)) !== null && _b !== void 0 ? _b : _this3.options.videoCaptureDefaults.deviceId;
                    _this3.options.videoCaptureDefaults.deviceId = deviceConstraint;
                    const tracks = Array.from(_this3.localParticipant.videoTrackPublications.values()).filter((track)=>track.source === $c0722d30b1d17141$export$13921ac0cc260818.Source.Camera);
                    try {
                        success = (yield Promise.all(tracks.map((t)=>{
                            var _a;
                            return (_a = t.videoTrack) === null || _a === void 0 ? void 0 : _a.setDeviceId(deviceConstraint);
                        }))).every((val)=>val === true);
                    } catch (e) {
                        _this3.options.videoCaptureDefaults.deviceId = prevDeviceId;
                        throw e;
                    }
                    const isMuted = tracks.some((t)=>{
                        var _a, _b;
                        return (_b = (_a = t.track) === null || _a === void 0 ? void 0 : _a.isMuted) !== null && _b !== void 0 ? _b : false;
                    });
                    if (success && isMuted) shouldTriggerImmediateDeviceChange = true;
                } else if (kind === 'audiooutput') {
                    shouldTriggerImmediateDeviceChange = true;
                    if (!$c0722d30b1d17141$var$supportsSetSinkId() && !_this3.options.webAudioMix || _this3.options.webAudioMix && _this3.audioContext && !('setSinkId' in _this3.audioContext)) throw new Error('cannot switch audio output, the current browser does not support it');
                    if (_this3.options.webAudioMix) // setting `default` for web audio output doesn't work, so we need to normalize the id before
                    deviceId = (_c = yield $c0722d30b1d17141$var$DeviceManager.getInstance().normalizeDeviceId('audiooutput', deviceId)) !== null && _c !== void 0 ? _c : '';
                    (_d = (_g = _this3.options).audioOutput) !== null && _d !== void 0 ? _d : _g.audioOutput = {};
                    const prevDeviceId = (_e = _this3.getActiveDevice(kind)) !== null && _e !== void 0 ? _e : _this3.options.audioOutput.deviceId;
                    _this3.options.audioOutput.deviceId = deviceId;
                    try {
                        if (_this3.options.webAudioMix) // @ts-expect-error setSinkId is not yet in the typescript type of AudioContext
                        (_f = _this3.audioContext) === null || _f === void 0 || _f.setSinkId(deviceId);
                        // also set audio output on all audio elements, even if webAudioMix is enabled in order to workaround echo cancellation not working on chrome with non-default output devices
                        // see https://issues.chromium.org/issues/40252911#comment7
                        yield Promise.all(Array.from(_this3.remoteParticipants.values()).map((p)=>p.setAudioOutput({
                                deviceId: deviceId
                            })));
                    } catch (e) {
                        _this3.options.audioOutput.deviceId = prevDeviceId;
                        throw e;
                    }
                }
                if (shouldTriggerImmediateDeviceChange) {
                    _this3.localParticipant.activeDeviceMap.set(kind, deviceId);
                    _this3.emit($c0722d30b1d17141$export$3159c672e3b2293a.ActiveDeviceChanged, kind, deviceId);
                }
                return success;
            }();
        });
    }
    setupLocalParticipantEvents() {
        this.localParticipant.on($c0722d30b1d17141$export$fcdfe2b7a6750691.ParticipantMetadataChanged, this.onLocalParticipantMetadataChanged).on($c0722d30b1d17141$export$fcdfe2b7a6750691.ParticipantNameChanged, this.onLocalParticipantNameChanged).on($c0722d30b1d17141$export$fcdfe2b7a6750691.AttributesChanged, this.onLocalAttributesChanged).on($c0722d30b1d17141$export$fcdfe2b7a6750691.TrackMuted, this.onLocalTrackMuted).on($c0722d30b1d17141$export$fcdfe2b7a6750691.TrackUnmuted, this.onLocalTrackUnmuted).on($c0722d30b1d17141$export$fcdfe2b7a6750691.LocalTrackPublished, this.onLocalTrackPublished).on($c0722d30b1d17141$export$fcdfe2b7a6750691.LocalTrackUnpublished, this.onLocalTrackUnpublished).on($c0722d30b1d17141$export$fcdfe2b7a6750691.ConnectionQualityChanged, this.onLocalConnectionQualityChanged).on($c0722d30b1d17141$export$fcdfe2b7a6750691.MediaDevicesError, this.onMediaDevicesError).on($c0722d30b1d17141$export$fcdfe2b7a6750691.AudioStreamAcquired, this.startAudio).on($c0722d30b1d17141$export$fcdfe2b7a6750691.ChatMessage, this.onLocalChatMessageSent).on($c0722d30b1d17141$export$fcdfe2b7a6750691.ParticipantPermissionsChanged, this.onLocalParticipantPermissionsChanged);
    }
    recreateEngine(sendLeave) {
        const oldEngine = this.engine;
        if (sendLeave && oldEngine && !oldEngine.client.isDisconnected) oldEngine.client.sendLeave().finally(()=>oldEngine.close());
        else oldEngine === null || oldEngine === void 0 || oldEngine.close();
        /* @ts-ignore */ this.engine = undefined;
        this.isResuming = false;
        // clear out existing remote participants, since they may have attached
        // the old engine
        this.remoteParticipants.clear();
        this.sidToIdentity.clear();
        this.bufferedEvents = [];
        this.maybeCreateEngine();
    }
    onTrackAdded(mediaTrack, stream, receiver) {
        // don't fire onSubscribed when connecting
        // WebRTC fires onTrack as soon as setRemoteDescription is called on the offer
        // at that time, ICE connectivity has not been established so the track is not
        // technically subscribed.
        // We'll defer these events until when the room is connected or eventually disconnected.
        if (this.state === $c0722d30b1d17141$export$cd9c3c6bf535afc9.Connecting || this.state === $c0722d30b1d17141$export$cd9c3c6bf535afc9.Reconnecting) {
            const reconnectedHandler = ()=>{
                this.log.debug('deferring on track for later', {
                    mediaTrackId: mediaTrack.id,
                    mediaStreamId: stream.id,
                    tracksInStream: stream.getTracks().map((track)=>track.id)
                });
                this.onTrackAdded(mediaTrack, stream, receiver);
                cleanup();
            };
            const cleanup = ()=>{
                this.off($c0722d30b1d17141$export$3159c672e3b2293a.Reconnected, reconnectedHandler);
                this.off($c0722d30b1d17141$export$3159c672e3b2293a.Connected, reconnectedHandler);
                this.off($c0722d30b1d17141$export$3159c672e3b2293a.Disconnected, cleanup);
            };
            this.once($c0722d30b1d17141$export$3159c672e3b2293a.Reconnected, reconnectedHandler);
            this.once($c0722d30b1d17141$export$3159c672e3b2293a.Connected, reconnectedHandler);
            this.once($c0722d30b1d17141$export$3159c672e3b2293a.Disconnected, cleanup);
            return;
        }
        if (this.state === $c0722d30b1d17141$export$cd9c3c6bf535afc9.Disconnected) {
            this.log.warn('skipping incoming track after Room disconnected');
            return;
        }
        if (mediaTrack.readyState === 'ended') {
            this.log.debug('skipping incoming track as it already ended');
            return;
        }
        const parts = $c0722d30b1d17141$var$unpackStreamId(stream.id);
        const participantSid = parts[0];
        let streamId = parts[1];
        let trackId = mediaTrack.id;
        // firefox will get streamId (pID|trackId) instead of (pID|streamId) as it doesn't support sync tracks by stream
        // and generates its own track id instead of infer from sdp track id.
        if (streamId && streamId.startsWith('TR')) trackId = streamId;
        if (participantSid === this.localParticipant.sid) {
            this.log.warn('tried to create RemoteParticipant for local participant');
            return;
        }
        const participant = Array.from(this.remoteParticipants.values()).find((p)=>p.sid === participantSid);
        if (!participant) {
            // server could require extra media sections to accelerate subscription.
            if (participantSid.startsWith('PA')) this.log.error("Tried to add a track for a participant, that's not present. Sid: ".concat(participantSid));
            return;
        }
        // in single peer connection case, the trackID is locally generated,
        // not the TR_ prefixed one generated by the server,
        // use `mid` to find the appropriate track.
        if (!trackId.startsWith('TR')) {
            const id = this.engine.getTrackIdForReceiver(receiver);
            if (!id) {
                this.log.error("Tried to add a track whose 'sid' could not be found for a participant, that's not present. Sid: ".concat(participantSid));
                return;
            }
            trackId = id;
        }
        if (!trackId.startsWith('TR')) this.log.warn("Tried to add a track whose 'sid' could not be determined for a participant, that's not present. Sid: ".concat(participantSid, ", streamId: ").concat(streamId, ", trackId: ").concat(trackId), {
            remoteParticipantID: participantSid,
            streamId: streamId,
            trackId: trackId
        });
        let adaptiveStreamSettings;
        if (this.options.adaptiveStream) {
            if (typeof this.options.adaptiveStream === 'object') adaptiveStreamSettings = this.options.adaptiveStream;
            else adaptiveStreamSettings = {};
        }
        const publication = participant.addSubscribedMediaTrack(mediaTrack, trackId, stream, receiver, adaptiveStreamSettings);
        if ((publication === null || publication === void 0 ? void 0 : publication.isEncrypted) && !this.e2eeManager) this.emit($c0722d30b1d17141$export$3159c672e3b2293a.EncryptionError, new Error("Encrypted ".concat(publication.source, " track received from participant ").concat(participant.sid, ", but room does not have encryption enabled!")));
    }
    handleLocalTrackSubscribed(subscribedSid) {
        const findPublication = ()=>this.localParticipant.getTrackPublications().find((_ref3)=>{
                let { trackSid: trackSid } = _ref3;
                return trackSid === subscribedSid;
            });
        const trackPublication = findPublication();
        if (trackPublication) {
            this.emitLocalTrackSubscribed(trackPublication);
            return;
        }
        // the track publication may not be registered yet if the server signals
        // the subscription before publishTrack has finished adding the publication.
        // defer with a timeout until LocalTrackPublished fires for the matching trackSid
        this.log.debug('deferring LocalTrackSubscribed, publication not yet available', {
            subscribedSid: subscribedSid
        });
        const TIMEOUT_MS = 10000;
        let timer;
        const onPublished = (pub)=>{
            if (pub.trackSid === subscribedSid) {
                cleanup();
                this.emitLocalTrackSubscribed(pub);
            }
        };
        const cleanup = ()=>{
            clearTimeout(timer);
            this.localParticipant.off($c0722d30b1d17141$export$fcdfe2b7a6750691.LocalTrackPublished, onPublished);
            this.off($c0722d30b1d17141$export$3159c672e3b2293a.Disconnected, cleanup);
        };
        this.localParticipant.on($c0722d30b1d17141$export$fcdfe2b7a6750691.LocalTrackPublished, onPublished);
        this.once($c0722d30b1d17141$export$3159c672e3b2293a.Disconnected, cleanup);
        timer = setTimeout(()=>{
            cleanup();
            // final attempt in case the publication was added without emitting the event
            const pub = findPublication();
            if (pub) this.emitLocalTrackSubscribed(pub);
            else this.log.warn('could not find local track publication for LocalTrackSubscribed event after timeout', {
                subscribedSid: subscribedSid
            });
        }, TIMEOUT_MS);
    }
    emitLocalTrackSubscribed(trackPublication) {
        this.localParticipant.emit($c0722d30b1d17141$export$fcdfe2b7a6750691.LocalTrackSubscribed, trackPublication);
        this.emitWhenConnected($c0722d30b1d17141$export$3159c672e3b2293a.LocalTrackSubscribed, trackPublication, this.localParticipant);
    }
    handleDisconnect() {
        let shouldStopTracks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        let reason = arguments.length > 1 ? arguments[1] : undefined;
        var _a, _b;
        this.clearConnectionReconcile();
        this.isResuming = false;
        this.bufferedEvents = [];
        this.transcriptionReceivedTimes.clear();
        this.incomingDataStreamManager.clearControllers();
        this.incomingDataTrackManager.reset();
        this.outgoingDataTrackManager.reset();
        if (this.state === $c0722d30b1d17141$export$cd9c3c6bf535afc9.Disconnected) return;
        this.regionUrl = undefined;
        // Notify region provider about disconnect to potentially stop auto-refetch
        if (this.regionUrlProvider) this.regionUrlProvider.notifyDisconnected();
        try {
            this.remoteParticipants.forEach((p)=>{
                p.trackPublications.forEach((pub)=>{
                    p.unpublishTrack(pub.trackSid);
                });
            });
            this.localParticipant.trackPublications.forEach((pub)=>{
                var _a, _b, _c;
                if (pub.track) this.localParticipant.unpublishTrack(pub.track, shouldStopTracks);
                if (shouldStopTracks) {
                    (_a = pub.track) === null || _a === void 0 || _a.detach();
                    (_b = pub.track) === null || _b === void 0 || _b.stop();
                } else (_c = pub.track) === null || _c === void 0 || _c.stopMonitor();
            });
            this.localParticipant.off($c0722d30b1d17141$export$fcdfe2b7a6750691.ParticipantMetadataChanged, this.onLocalParticipantMetadataChanged).off($c0722d30b1d17141$export$fcdfe2b7a6750691.ParticipantNameChanged, this.onLocalParticipantNameChanged).off($c0722d30b1d17141$export$fcdfe2b7a6750691.AttributesChanged, this.onLocalAttributesChanged).off($c0722d30b1d17141$export$fcdfe2b7a6750691.TrackMuted, this.onLocalTrackMuted).off($c0722d30b1d17141$export$fcdfe2b7a6750691.TrackUnmuted, this.onLocalTrackUnmuted).off($c0722d30b1d17141$export$fcdfe2b7a6750691.LocalTrackPublished, this.onLocalTrackPublished).off($c0722d30b1d17141$export$fcdfe2b7a6750691.LocalTrackUnpublished, this.onLocalTrackUnpublished).off($c0722d30b1d17141$export$fcdfe2b7a6750691.ConnectionQualityChanged, this.onLocalConnectionQualityChanged).off($c0722d30b1d17141$export$fcdfe2b7a6750691.MediaDevicesError, this.onMediaDevicesError).off($c0722d30b1d17141$export$fcdfe2b7a6750691.AudioStreamAcquired, this.startAudio).off($c0722d30b1d17141$export$fcdfe2b7a6750691.ChatMessage, this.onLocalChatMessageSent).off($c0722d30b1d17141$export$fcdfe2b7a6750691.ParticipantPermissionsChanged, this.onLocalParticipantPermissionsChanged);
            this.localParticipant.trackPublications.clear();
            this.localParticipant.videoTrackPublications.clear();
            this.localParticipant.audioTrackPublications.clear();
            this.remoteParticipants.clear();
            this.sidToIdentity.clear();
            this.activeSpeakers = [];
            if (this.audioContext && typeof this.options.webAudioMix === 'boolean') {
                this.audioContext.close();
                this.audioContext = undefined;
            }
            if ($c0722d30b1d17141$var$isWeb()) {
                window.removeEventListener('beforeunload', this.onPageLeave);
                window.removeEventListener('pagehide', this.onPageLeave);
                window.removeEventListener('freeze', this.onPageLeave);
                (_b = (_a = navigator.mediaDevices) === null || _a === void 0 ? void 0 : _a.removeEventListener) === null || _b === void 0 || _b.call(_a, 'devicechange', this.handleDeviceChange);
            }
        } finally{
            this.setAndEmitConnectionState($c0722d30b1d17141$export$cd9c3c6bf535afc9.Disconnected);
            this.emit($c0722d30b1d17141$export$3159c672e3b2293a.Disconnected, reason);
        }
    }
    handleParticipantDisconnected(identity, participant) {
        var _a;
        // remove and send event
        this.remoteParticipants.delete(identity);
        if (!participant) return;
        this.incomingDataStreamManager.validateParticipantHasNoActiveDataStreams(identity);
        this.incomingDataTrackManager.handleRemoteParticipantDisconnected(identity);
        participant.trackPublications.forEach((publication)=>{
            participant.unpublishTrack(publication.trackSid, true);
        });
        this.emit($c0722d30b1d17141$export$3159c672e3b2293a.ParticipantDisconnected, participant);
        participant.setDisconnected();
        (_a = this.localParticipant) === null || _a === void 0 || _a.handleParticipantDisconnected(participant.identity);
    }
    handleIncomingRpcRequest(callerIdentity, requestId, method, payload, responseTimeout, version) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            yield this.engine.publishRpcAck(callerIdentity, requestId);
            if (version !== 1) {
                yield this.engine.publishRpcResponse(callerIdentity, requestId, null, $c0722d30b1d17141$export$5460eff990f31920.builtIn('UNSUPPORTED_VERSION'));
                return;
            }
            const handler = this.rpcHandlers.get(method);
            if (!handler) {
                yield this.engine.publishRpcResponse(callerIdentity, requestId, null, $c0722d30b1d17141$export$5460eff990f31920.builtIn('UNSUPPORTED_METHOD'));
                return;
            }
            let responseError = null;
            let responsePayload = null;
            try {
                const response = yield handler({
                    requestId: requestId,
                    callerIdentity: callerIdentity,
                    payload: payload,
                    responseTimeout: responseTimeout
                });
                if ($c0722d30b1d17141$var$byteLength(response) > $c0722d30b1d17141$var$MAX_PAYLOAD_BYTES) {
                    responseError = $c0722d30b1d17141$export$5460eff990f31920.builtIn('RESPONSE_PAYLOAD_TOO_LARGE');
                    this.log.warn("RPC Response payload too large for ".concat(method));
                } else responsePayload = response;
            } catch (error) {
                if (error instanceof $c0722d30b1d17141$export$5460eff990f31920) responseError = error;
                else {
                    this.log.warn("Uncaught error returned by RPC handler for ".concat(method, ". Returning APPLICATION_ERROR instead."), error);
                    responseError = $c0722d30b1d17141$export$5460eff990f31920.builtIn('APPLICATION_ERROR');
                }
            }
            yield this.engine.publishRpcResponse(callerIdentity, requestId, responsePayload, responseError);
        });
    }
    /**
   * attempt to select the default devices if the previously selected devices are no longer available after a device change event
   */ selectDefaultDevices() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c;
            const previousDevices = $c0722d30b1d17141$var$DeviceManager.getInstance().previousDevices;
            // check for available devices, but don't request permissions in order to avoid prompts for kinds that haven't been used before
            const availableDevices = yield $c0722d30b1d17141$var$DeviceManager.getInstance().getDevices(undefined, false);
            const browser = $c0722d30b1d17141$export$89e15fc796a4a429();
            if ((browser === null || browser === void 0 ? void 0 : browser.name) === 'Chrome' && browser.os !== 'iOS') for (let availableDevice of availableDevices){
                const previousDevice = previousDevices.find((info)=>info.deviceId === availableDevice.deviceId);
                if (previousDevice && previousDevice.label !== '' && previousDevice.kind === availableDevice.kind && previousDevice.label !== availableDevice.label) // label has changed on device the same deviceId, indicating that the default device has changed on the OS level
                {
                    if (this.getActiveDevice(availableDevice.kind) === 'default') // emit an active device change event only if the selected output device is actually on `default`
                    this.emit($c0722d30b1d17141$export$3159c672e3b2293a.ActiveDeviceChanged, availableDevice.kind, availableDevice.deviceId);
                }
            }
            const kinds = [
                'audiooutput',
                'audioinput',
                'videoinput'
            ];
            for (let kind of kinds){
                const targetSource = $c0722d30b1d17141$var$kindToSource(kind);
                const targetPublication = this.localParticipant.getTrackPublication(targetSource);
                if (targetPublication && ((_a = targetPublication.track) === null || _a === void 0 ? void 0 : _a.isUserProvided)) continue;
                const devicesOfKind = availableDevices.filter((d)=>d.kind === kind);
                const activeDevice = this.getActiveDevice(kind);
                if (activeDevice === ((_b = previousDevices.filter((info)=>info.kind === kind)[0]) === null || _b === void 0 ? void 0 : _b.deviceId)) // in  Safari the first device is always the default, so we assume a user on the default device would like to switch to the default once it changes
                // FF doesn't emit an event when the default device changes, so we perform the same best effort and switch to the new device once connected and if it's the first in the array
                {
                    if (devicesOfKind.length > 0 && ((_c = devicesOfKind[0]) === null || _c === void 0 ? void 0 : _c.deviceId) !== activeDevice) {
                        yield this.switchActiveDevice(kind, devicesOfKind[0].deviceId);
                        continue;
                    }
                }
                if (kind === 'audioinput' && !$c0722d30b1d17141$var$isSafariBased() || kind === 'videoinput') continue;
                // switch to first available device if previously active device is not available any more
                if (devicesOfKind.length > 0 && !devicesOfKind.find((deviceInfo)=>deviceInfo.deviceId === this.getActiveDevice(kind)) && // avoid switching audio output on safari without explicit user action as it leads to slowed down audio playback
                (kind !== 'audiooutput' || !$c0722d30b1d17141$var$isSafariBased())) yield this.switchActiveDevice(kind, devicesOfKind[0].deviceId);
            }
        });
    }
    acquireAudioContext() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            if (typeof this.options.webAudioMix !== 'boolean' && this.options.webAudioMix.audioContext) // override audio context with custom audio context if supplied by user
            this.audioContext = this.options.webAudioMix.audioContext;
            else if (!this.audioContext || this.audioContext.state === 'closed') // by using an AudioContext, it reduces lag on audio elements
            // https://stackoverflow.com/questions/9811429/html5-audio-tag-on-safari-has-a-delay/54119854#54119854
            this.audioContext = (_a = $c0722d30b1d17141$var$getNewAudioContext()) !== null && _a !== void 0 ? _a : undefined;
            if (this.options.webAudioMix) this.remoteParticipants.forEach((participant)=>participant.setAudioContext(this.audioContext));
            this.localParticipant.setAudioContext(this.audioContext);
            if (this.audioContext && this.audioContext.state === 'suspended') // for iOS a newly created AudioContext is always in `suspended` state.
            // we try our best to resume the context here, if that doesn't work, we just continue with regular processing
            try {
                yield Promise.race([
                    this.audioContext.resume(),
                    $c0722d30b1d17141$var$sleep(200)
                ]);
            } catch (e) {
                this.log.warn('Could not resume audio context', {
                    error: e
                });
            }
            const newContextIsRunning = ((_b = this.audioContext) === null || _b === void 0 ? void 0 : _b.state) === 'running';
            if (newContextIsRunning !== this.canPlaybackAudio) {
                this.audioEnabled = newContextIsRunning;
                this.emit($c0722d30b1d17141$export$3159c672e3b2293a.AudioPlaybackStatusChanged, newContextIsRunning);
            }
        });
    }
    createParticipant(identity, info) {
        var _a;
        let participant;
        if (info) participant = $c0722d30b1d17141$export$bf85b9e4f33346fe.fromParticipantInfo(this.engine.client, info, {
            loggerContextCb: ()=>this.logContext,
            loggerName: this.options.loggerName
        }, this.incomingDataTrackManager);
        else participant = new $c0722d30b1d17141$export$bf85b9e4f33346fe(this.engine.client, '', identity, undefined, undefined, undefined, {
            loggerContextCb: ()=>this.logContext,
            loggerName: this.options.loggerName
        });
        if (this.options.webAudioMix) participant.setAudioContext(this.audioContext);
        if ((_a = this.options.audioOutput) === null || _a === void 0 ? void 0 : _a.deviceId) participant.setAudioOutput(this.options.audioOutput).catch((e)=>this.log.warn("Could not set audio output: ".concat(e.message)));
        return participant;
    }
    getOrCreateParticipant(identity, info) {
        if (this.remoteParticipants.has(identity)) {
            const existingParticipant = this.remoteParticipants.get(identity);
            if (info) {
                const wasUpdated = existingParticipant.updateInfo(info);
                if (wasUpdated) this.sidToIdentity.set(info.sid, info.identity);
            }
            return existingParticipant;
        }
        const participant = this.createParticipant(identity, info);
        this.remoteParticipants.set(identity, participant);
        this.sidToIdentity.set(info.sid, info.identity);
        // if we have valid info and the participant wasn't in the map before, we can assume the participant is new
        // firing here to make sure that `ParticipantConnected` fires before the initial track events
        this.emitWhenConnected($c0722d30b1d17141$export$3159c672e3b2293a.ParticipantConnected, participant);
        // also forward events
        // trackPublished is only fired for tracks added after both local participant
        // and remote participant joined the room
        participant.on($c0722d30b1d17141$export$fcdfe2b7a6750691.TrackPublished, (trackPublication)=>{
            this.emitWhenConnected($c0722d30b1d17141$export$3159c672e3b2293a.TrackPublished, trackPublication, participant);
        }).on($c0722d30b1d17141$export$fcdfe2b7a6750691.TrackSubscribed, (track, publication)=>{
            // monitor playback status
            if (track.kind === $c0722d30b1d17141$export$13921ac0cc260818.Kind.Audio) {
                track.on($c0722d30b1d17141$export$2c8510d737cc09da.AudioPlaybackStarted, this.handleAudioPlaybackStarted);
                track.on($c0722d30b1d17141$export$2c8510d737cc09da.AudioPlaybackFailed, this.handleAudioPlaybackFailed);
            } else if (track.kind === $c0722d30b1d17141$export$13921ac0cc260818.Kind.Video) {
                track.on($c0722d30b1d17141$export$2c8510d737cc09da.VideoPlaybackFailed, this.handleVideoPlaybackFailed);
                track.on($c0722d30b1d17141$export$2c8510d737cc09da.VideoPlaybackStarted, this.handleVideoPlaybackStarted);
            }
            this.emitWhenConnected($c0722d30b1d17141$export$3159c672e3b2293a.TrackSubscribed, track, publication, participant);
        }).on($c0722d30b1d17141$export$fcdfe2b7a6750691.TrackUnpublished, (publication)=>{
            this.emit($c0722d30b1d17141$export$3159c672e3b2293a.TrackUnpublished, publication, participant);
        }).on($c0722d30b1d17141$export$fcdfe2b7a6750691.TrackUnsubscribed, (track, publication)=>{
            this.emit($c0722d30b1d17141$export$3159c672e3b2293a.TrackUnsubscribed, track, publication, participant);
        }).on($c0722d30b1d17141$export$fcdfe2b7a6750691.TrackMuted, (pub)=>{
            this.emitWhenConnected($c0722d30b1d17141$export$3159c672e3b2293a.TrackMuted, pub, participant);
        }).on($c0722d30b1d17141$export$fcdfe2b7a6750691.TrackUnmuted, (pub)=>{
            this.emitWhenConnected($c0722d30b1d17141$export$3159c672e3b2293a.TrackUnmuted, pub, participant);
        }).on($c0722d30b1d17141$export$fcdfe2b7a6750691.ParticipantMetadataChanged, (metadata)=>{
            this.emitWhenConnected($c0722d30b1d17141$export$3159c672e3b2293a.ParticipantMetadataChanged, metadata, participant);
        }).on($c0722d30b1d17141$export$fcdfe2b7a6750691.ParticipantNameChanged, (name)=>{
            this.emitWhenConnected($c0722d30b1d17141$export$3159c672e3b2293a.ParticipantNameChanged, name, participant);
        }).on($c0722d30b1d17141$export$fcdfe2b7a6750691.AttributesChanged, (changedAttributes)=>{
            this.emitWhenConnected($c0722d30b1d17141$export$3159c672e3b2293a.ParticipantAttributesChanged, changedAttributes, participant);
        }).on($c0722d30b1d17141$export$fcdfe2b7a6750691.ConnectionQualityChanged, (quality)=>{
            this.emitWhenConnected($c0722d30b1d17141$export$3159c672e3b2293a.ConnectionQualityChanged, quality, participant);
        }).on($c0722d30b1d17141$export$fcdfe2b7a6750691.ParticipantPermissionsChanged, (prevPermissions)=>{
            this.emitWhenConnected($c0722d30b1d17141$export$3159c672e3b2293a.ParticipantPermissionsChanged, prevPermissions, participant);
        }).on($c0722d30b1d17141$export$fcdfe2b7a6750691.TrackSubscriptionStatusChanged, (pub, status)=>{
            this.emitWhenConnected($c0722d30b1d17141$export$3159c672e3b2293a.TrackSubscriptionStatusChanged, pub, status, participant);
        }).on($c0722d30b1d17141$export$fcdfe2b7a6750691.TrackSubscriptionFailed, (trackSid, error)=>{
            this.emit($c0722d30b1d17141$export$3159c672e3b2293a.TrackSubscriptionFailed, trackSid, participant, error);
        }).on($c0722d30b1d17141$export$fcdfe2b7a6750691.TrackSubscriptionPermissionChanged, (pub, status)=>{
            this.emitWhenConnected($c0722d30b1d17141$export$3159c672e3b2293a.TrackSubscriptionPermissionChanged, pub, status, participant);
        }).on($c0722d30b1d17141$export$fcdfe2b7a6750691.Active, ()=>{
            this.emitWhenConnected($c0722d30b1d17141$export$3159c672e3b2293a.ParticipantActive, participant);
            if (participant.kind === $c0722d30b1d17141$export$2079c0e1523aec29.AGENT) this.localParticipant.setActiveAgent(participant);
        });
        // update info at the end after callbacks have been set up
        if (info) participant.updateInfo(info);
        return participant;
    }
    sendSyncState() {
        const remoteTracks = Array.from(this.remoteParticipants.values()).reduce((acc, participant)=>{
            acc.push(...participant.getTrackPublications()); // FIXME would be nice to have this return RemoteTrackPublications directly instead of the type cast
            return acc;
        }, []);
        const localTracks = this.localParticipant.getTrackPublications(); // FIXME would be nice to have this return LocalTrackPublications directly instead of the type cast
        const localDataTrackInfos = this.outgoingDataTrackManager.queryPublished();
        this.engine.sendSyncState(remoteTracks, localTracks, localDataTrackInfos);
    }
    /**
   * After resuming, we'll need to notify the server of the current
   * subscription settings.
   */ updateSubscriptions() {
        for (const p of this.remoteParticipants.values()){
            for (const pub of p.videoTrackPublications.values())if (pub.isSubscribed && $c0722d30b1d17141$var$isRemotePub(pub)) pub.emitTrackUpdate();
        }
    }
    getRemoteParticipantBySid(sid) {
        const identity = this.sidToIdentity.get(sid);
        if (identity) return this.remoteParticipants.get(identity);
    }
    registerConnectionReconcile() {
        this.clearConnectionReconcile();
        let consecutiveFailures = 0;
        this.connectionReconcileInterval = $c0722d30b1d17141$export$22e737276454df96.setInterval(()=>{
            if (// ensure we didn't tear it down
            !this.engine || // engine detected close, but Room missed it
            this.engine.isClosed || // transports failed without notifying engine
            !this.engine.verifyTransport()) {
                consecutiveFailures++;
                this.log.warn('detected connection state mismatch', {
                    numFailures: consecutiveFailures,
                    engine: this.engine ? {
                        closed: this.engine.isClosed,
                        transportsConnectedOrConnecting: this.engine.verifyTransport()
                    } : undefined
                });
                if (consecutiveFailures >= 3) {
                    this.recreateEngine();
                    this.handleDisconnect(this.options.stopLocalTrackOnUnpublish, $c0722d30b1d17141$export$258d16488300d83f.STATE_MISMATCH);
                }
            } else consecutiveFailures = 0;
        }, $c0722d30b1d17141$var$CONNECTION_RECONCILE_FREQUENCY_MS);
    }
    clearConnectionReconcile() {
        if (this.connectionReconcileInterval) $c0722d30b1d17141$export$22e737276454df96.clearInterval(this.connectionReconcileInterval);
    }
    setAndEmitConnectionState(state) {
        if (state === this.state) // unchanged
        return false;
        this.log.info("connection state changed: ".concat(this.state, " -> ").concat(state));
        this.state = state;
        this.incomingDataStreamManager.setConnected(state === $c0722d30b1d17141$export$cd9c3c6bf535afc9.Connected);
        this.emit($c0722d30b1d17141$export$3159c672e3b2293a.ConnectionStateChanged, this.state);
        return true;
    }
    emitBufferedEvents() {
        this.bufferedEvents.forEach((_ref4)=>{
            let [ev, args] = _ref4;
            this.emit(ev, ...args);
        });
        this.bufferedEvents = [];
    }
    emitWhenConnected(event) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        if (this.state === $c0722d30b1d17141$export$cd9c3c6bf535afc9.Reconnecting || this.isResuming || !this.engine || this.engine.pendingReconnect) // in case the room is reconnecting, buffer the events by firing them later after emitting RoomEvent.Reconnected
        this.bufferedEvents.push([
            event,
            args
        ]);
        else if (this.state === $c0722d30b1d17141$export$cd9c3c6bf535afc9.Connected) return this.emit(event, ...args);
        return false;
    }
    /**
   * Allows to populate a room with simulated participants.
   * No actual connection to a server will be established, all state is
   * @experimental
   */ simulateParticipants(options) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d;
            const publishOptions = Object.assign({
                audio: true,
                video: true,
                useRealTracks: false
            }, options.publish);
            const participantOptions = Object.assign({
                count: 9,
                audio: false,
                video: true,
                aspectRatios: [
                    1.66,
                    1.7,
                    1.3
                ]
            }, options.participants);
            this.handleDisconnect();
            this.roomInfo = new $c0722d30b1d17141$var$Room$1({
                sid: 'RM_SIMULATED',
                name: 'simulated-room',
                emptyTimeout: 0,
                maxParticipants: 0,
                creationTime: $c0722d30b1d17141$var$protoInt64.parse(new Date().getTime()),
                metadata: '',
                numParticipants: 1,
                numPublishers: 1,
                turnPassword: '',
                enabledCodecs: [],
                activeRecording: false
            });
            this.localParticipant.updateInfo(new $c0722d30b1d17141$var$ParticipantInfo({
                identity: 'simulated-local',
                name: 'local-name'
            }));
            this.setupLocalParticipantEvents();
            this.emit($c0722d30b1d17141$export$3159c672e3b2293a.SignalConnected);
            this.emit($c0722d30b1d17141$export$3159c672e3b2293a.Connected);
            this.setAndEmitConnectionState($c0722d30b1d17141$export$cd9c3c6bf535afc9.Connected);
            if (publishOptions.video) {
                const camPub = new $c0722d30b1d17141$export$885a52c769210b3f($c0722d30b1d17141$export$13921ac0cc260818.Kind.Video, new $c0722d30b1d17141$var$TrackInfo({
                    source: $c0722d30b1d17141$var$TrackSource.CAMERA,
                    sid: Math.floor(Math.random() * 10000).toString(),
                    type: $c0722d30b1d17141$export$c2fc6e4ded3e0219.AUDIO,
                    name: 'video-dummy'
                }), new $c0722d30b1d17141$export$d5ffd2c62c538bdc(publishOptions.useRealTracks && ((_a = window.navigator.mediaDevices) === null || _a === void 0 ? void 0 : _a.getUserMedia) ? (yield window.navigator.mediaDevices.getUserMedia({
                    video: true
                })).getVideoTracks()[0] : $c0722d30b1d17141$var$createDummyVideoStreamTrack(160 * ((_b = participantOptions.aspectRatios[0]) !== null && _b !== void 0 ? _b : 1), 160, true, true), undefined, false, {
                    loggerName: this.options.loggerName,
                    loggerContextCb: ()=>this.logContext
                }), {
                    loggerName: this.options.loggerName,
                    loggerContextCb: ()=>this.logContext
                });
                // @ts-ignore
                this.localParticipant.addTrackPublication(camPub);
                this.localParticipant.emit($c0722d30b1d17141$export$fcdfe2b7a6750691.LocalTrackPublished, camPub);
            }
            if (publishOptions.audio) {
                const audioPub = new $c0722d30b1d17141$export$885a52c769210b3f($c0722d30b1d17141$export$13921ac0cc260818.Kind.Audio, new $c0722d30b1d17141$var$TrackInfo({
                    source: $c0722d30b1d17141$var$TrackSource.MICROPHONE,
                    sid: Math.floor(Math.random() * 10000).toString(),
                    type: $c0722d30b1d17141$export$c2fc6e4ded3e0219.AUDIO
                }), new $c0722d30b1d17141$export$b287427b771ca237(publishOptions.useRealTracks && ((_c = navigator.mediaDevices) === null || _c === void 0 ? void 0 : _c.getUserMedia) ? (yield navigator.mediaDevices.getUserMedia({
                    audio: true
                })).getAudioTracks()[0] : $c0722d30b1d17141$export$59e276d6841f735c(), undefined, false, this.audioContext, {
                    loggerName: this.options.loggerName,
                    loggerContextCb: ()=>this.logContext
                }), {
                    loggerName: this.options.loggerName,
                    loggerContextCb: ()=>this.logContext
                });
                // @ts-ignore
                this.localParticipant.addTrackPublication(audioPub);
                this.localParticipant.emit($c0722d30b1d17141$export$fcdfe2b7a6750691.LocalTrackPublished, audioPub);
            }
            for(let i = 0; i < participantOptions.count - 1; i += 1){
                let info = new $c0722d30b1d17141$var$ParticipantInfo({
                    sid: Math.floor(Math.random() * 10000).toString(),
                    identity: "simulated-".concat(i),
                    state: $c0722d30b1d17141$var$ParticipantInfo_State.ACTIVE,
                    tracks: [],
                    joinedAt: $c0722d30b1d17141$var$protoInt64.parse(Date.now())
                });
                const p = this.getOrCreateParticipant(info.identity, info);
                if (participantOptions.video) {
                    const dummyVideo = $c0722d30b1d17141$var$createDummyVideoStreamTrack(160 * ((_d = participantOptions.aspectRatios[i % participantOptions.aspectRatios.length]) !== null && _d !== void 0 ? _d : 1), 160, false, true);
                    const videoTrack = new $c0722d30b1d17141$var$TrackInfo({
                        source: $c0722d30b1d17141$var$TrackSource.CAMERA,
                        sid: Math.floor(Math.random() * 10000).toString(),
                        type: $c0722d30b1d17141$export$c2fc6e4ded3e0219.AUDIO
                    });
                    p.addSubscribedMediaTrack(dummyVideo, videoTrack.sid, new MediaStream([
                        dummyVideo
                    ]), new RTCRtpReceiver());
                    info.tracks = [
                        ...info.tracks,
                        videoTrack
                    ];
                }
                if (participantOptions.audio) {
                    const dummyTrack = $c0722d30b1d17141$export$59e276d6841f735c();
                    const audioTrack = new $c0722d30b1d17141$var$TrackInfo({
                        source: $c0722d30b1d17141$var$TrackSource.MICROPHONE,
                        sid: Math.floor(Math.random() * 10000).toString(),
                        type: $c0722d30b1d17141$export$c2fc6e4ded3e0219.AUDIO
                    });
                    p.addSubscribedMediaTrack(dummyTrack, audioTrack.sid, new MediaStream([
                        dummyTrack
                    ]), new RTCRtpReceiver());
                    info.tracks = [
                        ...info.tracks,
                        audioTrack
                    ];
                }
                p.updateInfo(info);
            }
        });
    }
    // /** @internal */
    emit(event) {
        for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
        // active speaker updates are too spammy
        if (event !== $c0722d30b1d17141$export$3159c672e3b2293a.ActiveSpeakersChanged && event !== $c0722d30b1d17141$export$3159c672e3b2293a.TranscriptionReceived) {
            // only extract logContext from arguments in order to avoid logging the whole object tree
            const minimizedArgs = $c0722d30b1d17141$var$mapArgs(args).filter((arg)=>arg !== undefined);
            if (event === $c0722d30b1d17141$export$3159c672e3b2293a.TrackSubscribed || event === $c0722d30b1d17141$export$3159c672e3b2293a.TrackUnsubscribed) this.log.trace("subscribe trace: ".concat(event), {
                event: event,
                args: minimizedArgs
            });
            this.log.debug("room event ".concat(event), {
                event: event,
                args: minimizedArgs
            });
        }
        return super.emit(event, ...args);
    }
}
$c0722d30b1d17141$export$525628e68e798fb4.cleanupRegistry = typeof FinalizationRegistry !== 'undefined' && new FinalizationRegistry((cleanup)=>{
    cleanup();
});
function $c0722d30b1d17141$var$mapArgs(args) {
    return args.map((arg)=>{
        if (!arg) return;
        if (Array.isArray(arg)) return $c0722d30b1d17141$var$mapArgs(arg);
        if (typeof arg === 'object') return 'logContext' in arg ? arg.logContext : undefined;
        return arg;
    });
} // This file was generated from JSON Schema using quicktype, do not modify it directly.
// The code generation lives at https://github.com/livekit/attribute-definitions
//
// To parse this data:
//
//   import { Convert, AgentAttributes, TranscriptionAttributes } from "./file";
//
//   const agentAttributes = Convert.toAgentAttributes(json);
//   const transcriptionAttributes = Convert.toTranscriptionAttributes(json);
// Converts JSON strings to/from your types
class $c0722d30b1d17141$var$Convert {
    static toAgentAttributes(json) {
        return JSON.parse(json);
    }
    static agentAttributesToJson(value) {
        return JSON.stringify(value);
    }
    static toTranscriptionAttributes(json) {
        return JSON.parse(json);
    }
    static transcriptionAttributesToJson(value) {
        return JSON.stringify(value);
    }
}
var $c0722d30b1d17141$export$16bd37df0047a29c = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Convert: $c0722d30b1d17141$var$Convert
});
var $c0722d30b1d17141$export$180e7b9f22912c82;
(function(CheckStatus) {
    CheckStatus[CheckStatus["IDLE"] = 0] = "IDLE";
    CheckStatus[CheckStatus["RUNNING"] = 1] = "RUNNING";
    CheckStatus[CheckStatus["SKIPPED"] = 2] = "SKIPPED";
    CheckStatus[CheckStatus["SUCCESS"] = 3] = "SUCCESS";
    CheckStatus[CheckStatus["FAILED"] = 4] = "FAILED";
})($c0722d30b1d17141$export$180e7b9f22912c82 || ($c0722d30b1d17141$export$180e7b9f22912c82 = {}));
class $c0722d30b1d17141$export$8ecd240bc8faaeeb extends $c0722d30b1d17141$var$eventsExports.EventEmitter {
    constructor(url, token){
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        super();
        this.status = $c0722d30b1d17141$export$180e7b9f22912c82.IDLE;
        this.logs = [];
        this.options = {};
        this.url = url;
        this.token = token;
        this.name = this.constructor.name;
        this.room = new $c0722d30b1d17141$export$525628e68e798fb4(options.roomOptions);
        this.connectOptions = options.connectOptions;
        this.options = options;
    }
    run(onComplete) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            if (this.status !== $c0722d30b1d17141$export$180e7b9f22912c82.IDLE) throw Error('check is running already');
            this.setStatus($c0722d30b1d17141$export$180e7b9f22912c82.RUNNING);
            try {
                yield this.perform();
            } catch (err) {
                if (err instanceof Error) {
                    if (this.options.errorsAsWarnings) this.appendWarning(err.message);
                    else this.appendError(err.message);
                }
            }
            yield this.disconnect();
            // sleep for a bit to ensure disconnect
            yield new Promise((resolve)=>setTimeout(resolve, 500));
            // @ts-ignore
            if (this.status !== $c0722d30b1d17141$export$180e7b9f22912c82.SKIPPED) this.setStatus(this.isSuccess() ? $c0722d30b1d17141$export$180e7b9f22912c82.SUCCESS : $c0722d30b1d17141$export$180e7b9f22912c82.FAILED);
            if (onComplete) onComplete();
            return this.getInfo();
        });
    }
    isSuccess() {
        return !this.logs.some((l)=>l.level === 'error');
    }
    connect(url) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            if (this.room.state === $c0722d30b1d17141$export$cd9c3c6bf535afc9.Connected) return this.room;
            if (!url) url = this.url;
            yield this.room.connect(url, this.token, this.connectOptions);
            return this.room;
        });
    }
    disconnect() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            if (this.room && this.room.state !== $c0722d30b1d17141$export$cd9c3c6bf535afc9.Disconnected) {
                yield this.room.disconnect();
                // wait for it to go through
                yield new Promise((resolve)=>setTimeout(resolve, 500));
            }
        });
    }
    skip() {
        this.setStatus($c0722d30b1d17141$export$180e7b9f22912c82.SKIPPED);
    }
    switchProtocol(protocol) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            let hasReconnecting = false;
            let hasReconnected = false;
            this.room.on($c0722d30b1d17141$export$3159c672e3b2293a.Reconnecting, ()=>{
                hasReconnecting = true;
            });
            this.room.once($c0722d30b1d17141$export$3159c672e3b2293a.Reconnected, ()=>{
                hasReconnected = true;
            });
            this.room.simulateScenario("force-".concat(protocol));
            yield new Promise((resolve)=>setTimeout(resolve, 1000));
            if (!hasReconnecting) // no need to wait for reconnection
            return;
            // wait for 10 seconds for reconnection
            const timeout = Date.now() + 10000;
            while(Date.now() < timeout){
                if (hasReconnected) return;
                yield $c0722d30b1d17141$var$sleep(100);
            }
            throw new Error("Could not reconnect using ".concat(protocol, " protocol after 10 seconds"));
        });
    }
    appendMessage(message) {
        this.logs.push({
            level: 'info',
            message: message
        });
        this.emit('update', this.getInfo());
    }
    appendWarning(message) {
        this.logs.push({
            level: 'warning',
            message: message
        });
        this.emit('update', this.getInfo());
    }
    appendError(message) {
        this.logs.push({
            level: 'error',
            message: message
        });
        this.emit('update', this.getInfo());
    }
    setStatus(status) {
        this.status = status;
        this.emit('update', this.getInfo());
    }
    get engine() {
        var _a;
        return (_a = this.room) === null || _a === void 0 ? void 0 : _a.engine;
    }
    getInfo() {
        return {
            logs: this.logs,
            name: this.name,
            status: this.status,
            description: this.description
        };
    }
} /**
 * Checks for connections quality to closests Cloud regions and determining the best quality
 */ 
class $c0722d30b1d17141$var$CloudRegionCheck extends $c0722d30b1d17141$export$8ecd240bc8faaeeb {
    get description() {
        return 'Cloud regions';
    }
    perform() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            const regionProvider = new $c0722d30b1d17141$var$RegionUrlProvider(this.url, this.token);
            if (!regionProvider.isCloud()) {
                this.skip();
                return;
            }
            const regionStats = [];
            const seenUrls = new Set();
            for(let i = 0; i < 3; i++){
                const regionUrl = yield regionProvider.getNextBestRegionUrl();
                if (!regionUrl) break;
                if (seenUrls.has(regionUrl)) continue;
                seenUrls.add(regionUrl);
                const stats = yield this.checkCloudRegion(regionUrl);
                this.appendMessage("".concat(stats.region, " RTT: ").concat(stats.rtt, "ms, duration: ").concat(stats.duration, "ms"));
                regionStats.push(stats);
            }
            regionStats.sort((a, b)=>{
                return (a.duration - b.duration) * 0.5 + (a.rtt - b.rtt) * 0.5;
            });
            const bestRegion = regionStats[0];
            this.bestStats = bestRegion;
            this.appendMessage("best Cloud region: ".concat(bestRegion.region));
        });
    }
    getInfo() {
        const info = super.getInfo();
        info.data = this.bestStats;
        return info;
    }
    checkCloudRegion(url) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            yield this.connect(url);
            if (this.options.protocol === 'tcp') yield this.switchProtocol('tcp');
            const region = (_a = this.room.serverInfo) === null || _a === void 0 ? void 0 : _a.region;
            if (!region) throw new Error('Region not found');
            const writer = yield this.room.localParticipant.streamText({
                topic: 'test'
            });
            const chunkSize = 1000; // each chunk is about 1000 bytes
            const totalSize = 1000000; // approximately 1MB of data
            const numChunks = totalSize / chunkSize; // will yield 1000 chunks
            const chunkData = 'A'.repeat(chunkSize); // create a string of 1000 'A' characters
            const startTime = Date.now();
            for(let i = 0; i < numChunks; i++)yield writer.write(chunkData);
            yield writer.close();
            const endTime = Date.now();
            const stats = yield (_b = this.room.engine.pcManager) === null || _b === void 0 ? void 0 : _b.publisher.getStats();
            const regionStats = {
                region: region,
                rtt: 10000,
                duration: endTime - startTime
            };
            stats === null || stats === void 0 || stats.forEach((stat)=>{
                if (stat.type === 'candidate-pair' && stat.nominated) regionStats.rtt = stat.currentRoundTripTime * 1000;
            });
            yield this.disconnect();
            return regionStats;
        });
    }
}
const $c0722d30b1d17141$var$TEST_DURATION = 10000;
class $c0722d30b1d17141$var$ConnectionProtocolCheck extends $c0722d30b1d17141$export$8ecd240bc8faaeeb {
    get description() {
        return 'Connection via UDP vs TCP';
    }
    perform() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            const udpStats = yield this.checkConnectionProtocol('udp');
            const tcpStats = yield this.checkConnectionProtocol('tcp');
            this.bestStats = udpStats;
            // udp should is the better protocol typically. however, we'd prefer TCP when either of these conditions are true:
            // 1. the bandwidth limitation is worse on UDP by 500ms
            // 2. the packet loss is higher on UDP by 1%
            if (udpStats.qualityLimitationDurations.bandwidth - tcpStats.qualityLimitationDurations.bandwidth > 0.5 || (udpStats.packetsLost - tcpStats.packetsLost) / udpStats.packetsSent > 0.01) {
                this.appendMessage('best connection quality via tcp');
                this.bestStats = tcpStats;
            } else this.appendMessage('best connection quality via udp');
            const stats = this.bestStats;
            this.appendMessage("upstream bitrate: ".concat((stats.bitrateTotal / stats.count / 1000 / 1000).toFixed(2), " mbps"));
            this.appendMessage("RTT: ".concat((stats.rttTotal / stats.count * 1000).toFixed(2), " ms"));
            this.appendMessage("jitter: ".concat((stats.jitterTotal / stats.count * 1000).toFixed(2), " ms"));
            if (stats.packetsLost > 0) this.appendWarning("packets lost: ".concat((stats.packetsLost / stats.packetsSent * 100).toFixed(2), "%"));
            if (stats.qualityLimitationDurations.bandwidth > 1) this.appendWarning("bandwidth limited ".concat((stats.qualityLimitationDurations.bandwidth / ($c0722d30b1d17141$var$TEST_DURATION / 1000) * 100).toFixed(2), "%"));
            if (stats.qualityLimitationDurations.cpu > 0) this.appendWarning("cpu limited ".concat((stats.qualityLimitationDurations.cpu / ($c0722d30b1d17141$var$TEST_DURATION / 1000) * 100).toFixed(2), "%"));
        });
    }
    getInfo() {
        const info = super.getInfo();
        info.data = this.bestStats;
        return info;
    }
    checkConnectionProtocol(protocol) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            yield this.connect();
            if (protocol === 'tcp') yield this.switchProtocol('tcp');
            else yield this.switchProtocol('udp');
            // create a canvas with animated content
            const canvas = document.createElement('canvas');
            canvas.width = 1280;
            canvas.height = 720;
            const ctx = canvas.getContext('2d');
            if (!ctx) throw new Error('Could not get canvas context');
            let hue = 0;
            const animate = ()=>{
                hue = (hue + 1) % 360;
                ctx.fillStyle = "hsl(".concat(hue, ", 100%, 50%)");
                ctx.fillRect(0, 0, canvas.width, canvas.height);
                requestAnimationFrame(animate);
            };
            animate();
            // create video track from canvas
            const stream = canvas.captureStream(30); // 30fps
            const videoTrack = stream.getVideoTracks()[0];
            // publish to room
            const pub = yield this.room.localParticipant.publishTrack(videoTrack, {
                simulcast: false,
                degradationPreference: 'maintain-resolution',
                videoEncoding: {
                    maxBitrate: 2000000
                }
            });
            const track = pub.track;
            const protocolStats = {
                protocol: protocol,
                packetsLost: 0,
                packetsSent: 0,
                qualityLimitationDurations: {},
                rttTotal: 0,
                jitterTotal: 0,
                bitrateTotal: 0,
                count: 0
            };
            // gather stats once a second
            const interval = setInterval(()=>$c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
                    const stats = yield track.getRTCStatsReport();
                    stats === null || stats === void 0 || stats.forEach((stat)=>{
                        if (stat.type === 'outbound-rtp') {
                            protocolStats.packetsSent = stat.packetsSent;
                            protocolStats.qualityLimitationDurations = stat.qualityLimitationDurations;
                            protocolStats.bitrateTotal += stat.targetBitrate;
                            protocolStats.count++;
                        } else if (stat.type === 'remote-inbound-rtp') {
                            protocolStats.packetsLost = stat.packetsLost;
                            protocolStats.rttTotal += stat.roundTripTime;
                            protocolStats.jitterTotal += stat.jitter;
                        }
                    });
                }), 1000);
            // wait a bit to gather stats
            yield new Promise((resolve)=>setTimeout(resolve, $c0722d30b1d17141$var$TEST_DURATION));
            clearInterval(interval);
            videoTrack.stop();
            canvas.remove();
            yield this.disconnect();
            return protocolStats;
        });
    }
}
class $c0722d30b1d17141$var$PublishAudioCheck extends $c0722d30b1d17141$export$8ecd240bc8faaeeb {
    get description() {
        return 'Can publish audio';
    }
    perform() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const room = yield this.connect();
            const track = yield $c0722d30b1d17141$export$6e84c4c7abc03d43();
            const trackIsSilent = yield $c0722d30b1d17141$var$detectSilence(track, 1000);
            if (trackIsSilent) throw new Error('unable to detect audio from microphone');
            this.appendMessage('detected audio from microphone');
            room.localParticipant.publishTrack(track);
            // wait for a few seconds to publish
            yield new Promise((resolve)=>setTimeout(resolve, 3000));
            // verify RTC stats that it's publishing
            const stats = yield (_a = track.sender) === null || _a === void 0 ? void 0 : _a.getStats();
            if (!stats) throw new Error('Could not get RTCStats');
            let numPackets = 0;
            stats.forEach((stat)=>{
                if (stat.type === 'outbound-rtp' && (stat.kind === 'audio' || !stat.kind && stat.mediaType === 'audio')) numPackets = stat.packetsSent;
            });
            if (numPackets === 0) throw new Error('Could not determine packets are sent');
            this.appendMessage("published ".concat(numPackets, " audio packets"));
        });
    }
}
class $c0722d30b1d17141$var$PublishVideoCheck extends $c0722d30b1d17141$export$8ecd240bc8faaeeb {
    get description() {
        return 'Can publish video';
    }
    perform() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const room = yield this.connect();
            const track = yield $c0722d30b1d17141$export$449d1fd97929ebe7();
            // check if we have video from camera
            yield this.checkForVideo(track.mediaStreamTrack);
            room.localParticipant.publishTrack(track);
            // wait for a few seconds to publish
            yield new Promise((resolve)=>setTimeout(resolve, 5000));
            // verify RTC stats that it's publishing
            const stats = yield (_a = track.sender) === null || _a === void 0 ? void 0 : _a.getStats();
            if (!stats) throw new Error('Could not get RTCStats');
            let numPackets = 0;
            stats.forEach((stat)=>{
                if (stat.type === 'outbound-rtp' && (stat.kind === 'video' || !stat.kind && stat.mediaType === 'video')) numPackets += stat.packetsSent;
            });
            if (numPackets === 0) throw new Error('Could not determine packets are sent');
            this.appendMessage("published ".concat(numPackets, " video packets"));
        });
    }
    checkForVideo(track) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            const stream = new MediaStream();
            stream.addTrack(track.clone());
            // Create video element to check frames
            const video = document.createElement('video');
            video.srcObject = stream;
            video.muted = true;
            video.autoplay = true;
            video.playsInline = true;
            // For iOS Safari
            video.setAttribute('playsinline', 'true');
            document.body.appendChild(video);
            yield new Promise((resolve)=>{
                video.onplay = ()=>{
                    setTimeout(()=>{
                        var _a, _b, _c, _d;
                        const canvas = document.createElement('canvas');
                        const settings = track.getSettings();
                        const width = (_b = (_a = settings.width) !== null && _a !== void 0 ? _a : video.videoWidth) !== null && _b !== void 0 ? _b : 1280;
                        const height = (_d = (_c = settings.height) !== null && _c !== void 0 ? _c : video.videoHeight) !== null && _d !== void 0 ? _d : 720;
                        canvas.width = width;
                        canvas.height = height;
                        const ctx = canvas.getContext('2d');
                        // Draw video frame to canvas
                        ctx.drawImage(video, 0, 0);
                        // Get image data and check if all pixels are black
                        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                        const data = imageData.data;
                        let isAllBlack = true;
                        for(let i = 0; i < data.length; i += 4)if (data[i] !== 0 || data[i + 1] !== 0 || data[i + 2] !== 0) {
                            isAllBlack = false;
                            break;
                        }
                        if (isAllBlack) this.appendError('camera appears to be producing only black frames');
                        else this.appendMessage('received video frames');
                        resolve();
                    }, 1000);
                };
                video.play();
            });
            stream.getTracks().forEach((t)=>t.stop());
            video.remove();
        });
    }
}
class $c0722d30b1d17141$var$ReconnectCheck extends $c0722d30b1d17141$export$8ecd240bc8faaeeb {
    get description() {
        return 'Resuming connection after interruption';
    }
    perform() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const room = yield this.connect();
            let reconnectingTriggered = false;
            let reconnected = false;
            let reconnectResolver;
            const reconnectTimeout = new Promise((resolve)=>{
                setTimeout(resolve, 5000);
                reconnectResolver = resolve;
            });
            const handleReconnecting = ()=>{
                reconnectingTriggered = true;
            };
            room.on($c0722d30b1d17141$export$3159c672e3b2293a.SignalReconnecting, handleReconnecting).on($c0722d30b1d17141$export$3159c672e3b2293a.Reconnecting, handleReconnecting).on($c0722d30b1d17141$export$3159c672e3b2293a.Reconnected, ()=>{
                reconnected = true;
                reconnectResolver(true);
            });
            (_a = room.engine.client.ws) === null || _a === void 0 || _a.close();
            const onClose = room.engine.client.onClose;
            if (onClose) onClose('');
            yield reconnectTimeout;
            if (!reconnectingTriggered) throw new Error('Did not attempt to reconnect');
            else if (!reconnected || room.state !== $c0722d30b1d17141$export$cd9c3c6bf535afc9.Connected) {
                this.appendWarning('reconnection is only possible in Redis-based configurations');
                throw new Error('Not able to reconnect');
            }
        });
    }
}
class $c0722d30b1d17141$var$TURNCheck extends $c0722d30b1d17141$export$8ecd240bc8faaeeb {
    get description() {
        return 'Can connect via TURN';
    }
    perform() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c;
            if ($c0722d30b1d17141$var$isCloud(new URL(this.url))) {
                this.appendMessage('Using region specific url');
                this.url = (_a = yield new $c0722d30b1d17141$var$RegionUrlProvider(this.url, this.token).getNextBestRegionUrl()) !== null && _a !== void 0 ? _a : this.url;
            }
            const signalClient = new $c0722d30b1d17141$var$SignalClient();
            const joinRes = yield signalClient.join(this.url, this.token, {
                autoSubscribe: true,
                maxRetries: 0,
                e2eeEnabled: false,
                websocketTimeout: 15000
            }, undefined, true);
            let hasTLS = false;
            let hasTURN = false;
            let hasSTUN = false;
            for (let iceServer of joinRes.iceServers)for (let url of iceServer.urls){
                if (url.startsWith('turn:')) {
                    hasTURN = true;
                    hasSTUN = true;
                } else if (url.startsWith('turns:')) {
                    hasTURN = true;
                    hasSTUN = true;
                    hasTLS = true;
                }
                if (url.startsWith('stun:')) hasSTUN = true;
            }
            if (!hasSTUN) this.appendWarning('No STUN servers configured on server side.');
            else if (hasTURN && !hasTLS) this.appendWarning('TURN is configured server side, but TURN/TLS is unavailable.');
            yield signalClient.close();
            if (((_c = (_b = this.connectOptions) === null || _b === void 0 ? void 0 : _b.rtcConfig) === null || _c === void 0 ? void 0 : _c.iceServers) || hasTURN) yield this.room.connect(this.url, this.token, {
                rtcConfig: {
                    iceTransportPolicy: 'relay'
                }
            });
            else {
                this.appendWarning('No TURN servers configured.');
                this.skip();
                yield new Promise((resolve)=>setTimeout(resolve, 0));
            }
        });
    }
}
class $c0722d30b1d17141$var$WebRTCCheck extends $c0722d30b1d17141$export$8ecd240bc8faaeeb {
    get description() {
        return 'Establishing WebRTC connection';
    }
    perform() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            let hasTcp = false;
            let hasIpv4Udp = false;
            this.room.on($c0722d30b1d17141$export$3159c672e3b2293a.SignalConnected, ()=>{
                var _a;
                const prevTrickle = this.room.engine.client.onTrickle;
                this.room.engine.client.onTrickle = (sd, target)=>{
                    if (sd.candidate) {
                        const candidate = new RTCIceCandidate(sd);
                        let str = "".concat(candidate.protocol, " ").concat(candidate.address, ":").concat(candidate.port, " ").concat(candidate.type);
                        if (candidate.address) {
                            if ($c0722d30b1d17141$var$isIPPrivate(candidate.address)) str += ' (private)';
                            else {
                                if (candidate.protocol === 'tcp' && candidate.tcpType === 'passive') {
                                    hasTcp = true;
                                    str += ' (passive)';
                                } else if (candidate.protocol === 'udp') hasIpv4Udp = true;
                            }
                        }
                        this.appendMessage(str);
                    }
                    if (prevTrickle) prevTrickle(sd, target);
                };
                if ((_a = this.room.engine.pcManager) === null || _a === void 0 ? void 0 : _a.subscriber) this.room.engine.pcManager.subscriber.onIceCandidateError = (ev)=>{
                    if (ev instanceof RTCPeerConnectionIceErrorEvent) this.appendWarning("error with ICE candidate: ".concat(ev.errorCode, " ").concat(ev.errorText, " ").concat(ev.url));
                };
            });
            try {
                yield this.connect();
                $c0722d30b1d17141$var$livekitLogger.info('now the room is connected');
            } catch (err) {
                this.appendWarning('ports need to be open on firewall in order to connect.');
                throw err;
            }
            if (!hasTcp) this.appendWarning('Server is not configured for ICE/TCP');
            if (!hasIpv4Udp) this.appendWarning('No public IPv4 UDP candidates were found. Your server is likely not configured correctly');
        });
    }
}
function $c0722d30b1d17141$var$isIPPrivate(address) {
    const parts = address.split('.');
    if (parts.length === 4) {
        if (parts[0] === '10') return true;
        else if (parts[0] === '192' && parts[1] === '168') return true;
        else if (parts[0] === '172') {
            const second = parseInt(parts[1], 10);
            if (second >= 16 && second <= 31) return true;
        }
    }
    return false;
}
class $c0722d30b1d17141$var$WebSocketCheck extends $c0722d30b1d17141$export$8ecd240bc8faaeeb {
    get description() {
        return 'Connecting to signal connection via WebSocket';
    }
    perform() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c;
            if (this.url.startsWith('ws:') || this.url.startsWith('http:')) this.appendWarning('Server is insecure, clients may block connections to it');
            let signalClient = new $c0722d30b1d17141$var$SignalClient();
            let joinRes;
            try {
                joinRes = yield signalClient.join(this.url, this.token, {
                    autoSubscribe: true,
                    maxRetries: 0,
                    e2eeEnabled: false,
                    websocketTimeout: 15000
                }, undefined, true);
            } catch (e) {
                if ($c0722d30b1d17141$var$isCloud(new URL(this.url))) {
                    this.appendMessage("Initial connection failed with error ".concat(e.message, ". Retrying with region fallback"));
                    const regionProvider = new $c0722d30b1d17141$var$RegionUrlProvider(this.url, this.token);
                    const regionUrl = yield regionProvider.getNextBestRegionUrl();
                    if (regionUrl) {
                        joinRes = yield signalClient.join(regionUrl, this.token, {
                            autoSubscribe: true,
                            maxRetries: 0,
                            e2eeEnabled: false,
                            websocketTimeout: 15000
                        }, undefined, true);
                        this.appendMessage("Fallback to region worked. To avoid initial connections failing, ensure you're calling room.prepareConnection() ahead of time");
                    }
                }
            }
            if (joinRes) {
                this.appendMessage("Connected to server, version ".concat(joinRes.serverVersion, "."));
                if (((_a = joinRes.serverInfo) === null || _a === void 0 ? void 0 : _a.edition) === $c0722d30b1d17141$var$ServerInfo_Edition.Cloud && ((_b = joinRes.serverInfo) === null || _b === void 0 ? void 0 : _b.region)) this.appendMessage("LiveKit Cloud: ".concat((_c = joinRes.serverInfo) === null || _c === void 0 ? void 0 : _c.region));
            } else this.appendError("Websocket connection could not be established");
            yield signalClient.close();
        });
    }
}
class $c0722d30b1d17141$export$987f59e088b53559 extends $c0722d30b1d17141$var$eventsExports.EventEmitter {
    constructor(url, token){
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        super();
        this.options = {};
        this.checkResults = new Map();
        this.url = url;
        this.token = token;
        this.options = options;
    }
    getNextCheckId() {
        const nextId = this.checkResults.size;
        this.checkResults.set(nextId, {
            logs: [],
            status: $c0722d30b1d17141$export$180e7b9f22912c82.IDLE,
            name: '',
            description: ''
        });
        return nextId;
    }
    updateCheck(checkId, info) {
        this.checkResults.set(checkId, info);
        this.emit('checkUpdate', checkId, info);
    }
    isSuccess() {
        return Array.from(this.checkResults.values()).every((r)=>r.status !== $c0722d30b1d17141$export$180e7b9f22912c82.FAILED);
    }
    getResults() {
        return Array.from(this.checkResults.values());
    }
    createAndRunCheck(check) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            const checkId = this.getNextCheckId();
            const test = new check(this.url, this.token, this.options);
            const handleUpdate = (info)=>{
                this.updateCheck(checkId, info);
            };
            test.on('update', handleUpdate);
            const result = yield test.run();
            test.off('update', handleUpdate);
            return result;
        });
    }
    checkWebsocket() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            return this.createAndRunCheck($c0722d30b1d17141$var$WebSocketCheck);
        });
    }
    checkWebRTC() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            return this.createAndRunCheck($c0722d30b1d17141$var$WebRTCCheck);
        });
    }
    checkTURN() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            return this.createAndRunCheck($c0722d30b1d17141$var$TURNCheck);
        });
    }
    checkReconnect() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            return this.createAndRunCheck($c0722d30b1d17141$var$ReconnectCheck);
        });
    }
    checkPublishAudio() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            return this.createAndRunCheck($c0722d30b1d17141$var$PublishAudioCheck);
        });
    }
    checkPublishVideo() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            return this.createAndRunCheck($c0722d30b1d17141$var$PublishVideoCheck);
        });
    }
    checkConnectionProtocol() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            const info = yield this.createAndRunCheck($c0722d30b1d17141$var$ConnectionProtocolCheck);
            if (info.data && 'protocol' in info.data) {
                const stats = info.data;
                this.options.protocol = stats.protocol;
            }
            return info;
        });
    }
    checkCloudRegion() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            return this.createAndRunCheck($c0722d30b1d17141$var$CloudRegionCheck);
        });
    }
} /** A Fixed TokenSource is a token source that takes no parameters and returns a completely
 * independently derived value on each fetch() call.
 *
 * The most common downstream implementer is {@link TokenSourceLiteral}.
 */ 
class $c0722d30b1d17141$export$ddc2e1d582f80c18 {
}
/** A Configurable TokenSource is a token source that takes a
 * {@link TokenSourceFetchOptions} object as input and returns a deterministic
 * {@link TokenSourceResponseObject} output based on the options specified.
 *
 * For example, if options.participantName is set, it should be expected that
 * all tokens that are generated will have participant name field set to the
 * provided value.
 *
 * A few common downstream implementers are {@link TokenSourceEndpoint}
 * and {@link TokenSourceCustom}.
 */ class $c0722d30b1d17141$export$6bc68771f6025194 {
}
function $c0722d30b1d17141$var$_defineProperty(e, r, t) {
    return (r = $c0722d30b1d17141$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function $c0722d30b1d17141$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r);
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $c0722d30b1d17141$var$_toPropertyKey(t) {
    var i = $c0722d30b1d17141$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
new TextEncoder();
const $c0722d30b1d17141$var$decoder = new TextDecoder();
function $c0722d30b1d17141$var$decodeBase64(encoded) {
    if (Uint8Array.fromBase64) return Uint8Array.fromBase64(encoded);
    const binary = atob(encoded);
    const bytes = new Uint8Array(binary.length);
    for(let i = 0; i < binary.length; i++)bytes[i] = binary.charCodeAt(i);
    return bytes;
}
function $c0722d30b1d17141$var$decode(input) {
    if (Uint8Array.fromBase64) return Uint8Array.fromBase64(typeof input === 'string' ? input : $c0722d30b1d17141$var$decoder.decode(input), {
        alphabet: 'base64url'
    });
    let encoded = input;
    if (encoded instanceof Uint8Array) encoded = $c0722d30b1d17141$var$decoder.decode(encoded);
    encoded = encoded.replace(/-/g, '+').replace(/_/g, '/');
    try {
        return $c0722d30b1d17141$var$decodeBase64(encoded);
    } catch (_unused) {
        throw new TypeError('The input to be decoded is not correctly encoded.');
    }
}
class $c0722d30b1d17141$var$JOSEError extends Error {
    constructor(message, options){
        var _Error$captureStackTr;
        super(message, options);
        $c0722d30b1d17141$var$_defineProperty(this, "code", 'ERR_JOSE_GENERIC');
        this.name = this.constructor.name;
        (_Error$captureStackTr = Error.captureStackTrace) === null || _Error$captureStackTr === void 0 || _Error$captureStackTr.call(Error, this, this.constructor);
    }
}
$c0722d30b1d17141$var$_defineProperty($c0722d30b1d17141$var$JOSEError, "code", 'ERR_JOSE_GENERIC');
class $c0722d30b1d17141$var$JWTClaimValidationFailed extends $c0722d30b1d17141$var$JOSEError {
    constructor(message, payload){
        let claim = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'unspecified';
        let reason = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'unspecified';
        super(message, {
            cause: {
                claim: claim,
                reason: reason,
                payload: payload
            }
        });
        $c0722d30b1d17141$var$_defineProperty(this, "code", 'ERR_JWT_CLAIM_VALIDATION_FAILED');
        $c0722d30b1d17141$var$_defineProperty(this, "claim", void 0);
        $c0722d30b1d17141$var$_defineProperty(this, "reason", void 0);
        $c0722d30b1d17141$var$_defineProperty(this, "payload", void 0);
        this.claim = claim;
        this.reason = reason;
        this.payload = payload;
    }
}
$c0722d30b1d17141$var$_defineProperty($c0722d30b1d17141$var$JWTClaimValidationFailed, "code", 'ERR_JWT_CLAIM_VALIDATION_FAILED');
class $c0722d30b1d17141$var$JWTExpired extends $c0722d30b1d17141$var$JOSEError {
    constructor(message, payload){
        let claim = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'unspecified';
        let reason = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'unspecified';
        super(message, {
            cause: {
                claim: claim,
                reason: reason,
                payload: payload
            }
        });
        $c0722d30b1d17141$var$_defineProperty(this, "code", 'ERR_JWT_EXPIRED');
        $c0722d30b1d17141$var$_defineProperty(this, "claim", void 0);
        $c0722d30b1d17141$var$_defineProperty(this, "reason", void 0);
        $c0722d30b1d17141$var$_defineProperty(this, "payload", void 0);
        this.claim = claim;
        this.reason = reason;
        this.payload = payload;
    }
}
$c0722d30b1d17141$var$_defineProperty($c0722d30b1d17141$var$JWTExpired, "code", 'ERR_JWT_EXPIRED');
class $c0722d30b1d17141$var$JOSEAlgNotAllowed extends $c0722d30b1d17141$var$JOSEError {
    constructor(){
        super(...arguments);
        $c0722d30b1d17141$var$_defineProperty(this, "code", 'ERR_JOSE_ALG_NOT_ALLOWED');
    }
}
$c0722d30b1d17141$var$_defineProperty($c0722d30b1d17141$var$JOSEAlgNotAllowed, "code", 'ERR_JOSE_ALG_NOT_ALLOWED');
class $c0722d30b1d17141$var$JOSENotSupported extends $c0722d30b1d17141$var$JOSEError {
    constructor(){
        super(...arguments);
        $c0722d30b1d17141$var$_defineProperty(this, "code", 'ERR_JOSE_NOT_SUPPORTED');
    }
}
$c0722d30b1d17141$var$_defineProperty($c0722d30b1d17141$var$JOSENotSupported, "code", 'ERR_JOSE_NOT_SUPPORTED');
class $c0722d30b1d17141$var$JWEDecryptionFailed extends $c0722d30b1d17141$var$JOSEError {
    constructor(){
        let message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'decryption operation failed';
        let options = arguments.length > 1 ? arguments[1] : undefined;
        super(message, options);
        $c0722d30b1d17141$var$_defineProperty(this, "code", 'ERR_JWE_DECRYPTION_FAILED');
    }
}
$c0722d30b1d17141$var$_defineProperty($c0722d30b1d17141$var$JWEDecryptionFailed, "code", 'ERR_JWE_DECRYPTION_FAILED');
class $c0722d30b1d17141$var$JWEInvalid extends $c0722d30b1d17141$var$JOSEError {
    constructor(){
        super(...arguments);
        $c0722d30b1d17141$var$_defineProperty(this, "code", 'ERR_JWE_INVALID');
    }
}
$c0722d30b1d17141$var$_defineProperty($c0722d30b1d17141$var$JWEInvalid, "code", 'ERR_JWE_INVALID');
class $c0722d30b1d17141$var$JWSInvalid extends $c0722d30b1d17141$var$JOSEError {
    constructor(){
        super(...arguments);
        $c0722d30b1d17141$var$_defineProperty(this, "code", 'ERR_JWS_INVALID');
    }
}
$c0722d30b1d17141$var$_defineProperty($c0722d30b1d17141$var$JWSInvalid, "code", 'ERR_JWS_INVALID');
class $c0722d30b1d17141$var$JWTInvalid extends $c0722d30b1d17141$var$JOSEError {
    constructor(){
        super(...arguments);
        $c0722d30b1d17141$var$_defineProperty(this, "code", 'ERR_JWT_INVALID');
    }
}
$c0722d30b1d17141$var$_defineProperty($c0722d30b1d17141$var$JWTInvalid, "code", 'ERR_JWT_INVALID');
class $c0722d30b1d17141$var$JWKInvalid extends $c0722d30b1d17141$var$JOSEError {
    constructor(){
        super(...arguments);
        $c0722d30b1d17141$var$_defineProperty(this, "code", 'ERR_JWK_INVALID');
    }
}
$c0722d30b1d17141$var$_defineProperty($c0722d30b1d17141$var$JWKInvalid, "code", 'ERR_JWK_INVALID');
class $c0722d30b1d17141$var$JWKSInvalid extends $c0722d30b1d17141$var$JOSEError {
    constructor(){
        super(...arguments);
        $c0722d30b1d17141$var$_defineProperty(this, "code", 'ERR_JWKS_INVALID');
    }
}
$c0722d30b1d17141$var$_defineProperty($c0722d30b1d17141$var$JWKSInvalid, "code", 'ERR_JWKS_INVALID');
class $c0722d30b1d17141$var$JWKSNoMatchingKey extends $c0722d30b1d17141$var$JOSEError {
    constructor(){
        let message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'no applicable key found in the JSON Web Key Set';
        let options = arguments.length > 1 ? arguments[1] : undefined;
        super(message, options);
        $c0722d30b1d17141$var$_defineProperty(this, "code", 'ERR_JWKS_NO_MATCHING_KEY');
    }
}
$c0722d30b1d17141$var$_defineProperty($c0722d30b1d17141$var$JWKSNoMatchingKey, "code", 'ERR_JWKS_NO_MATCHING_KEY');
class $c0722d30b1d17141$var$JWKSMultipleMatchingKeys extends $c0722d30b1d17141$var$JOSEError {
    constructor(){
        let message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'multiple matching keys found in the JSON Web Key Set';
        let options = arguments.length > 1 ? arguments[1] : undefined;
        super(message, options);
        $c0722d30b1d17141$var$_defineProperty(this, Symbol.asyncIterator, void 0);
        $c0722d30b1d17141$var$_defineProperty(this, "code", 'ERR_JWKS_MULTIPLE_MATCHING_KEYS');
    }
}
$c0722d30b1d17141$var$_defineProperty($c0722d30b1d17141$var$JWKSMultipleMatchingKeys, "code", 'ERR_JWKS_MULTIPLE_MATCHING_KEYS');
class $c0722d30b1d17141$var$JWKSTimeout extends $c0722d30b1d17141$var$JOSEError {
    constructor(){
        let message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'request timed out';
        let options = arguments.length > 1 ? arguments[1] : undefined;
        super(message, options);
        $c0722d30b1d17141$var$_defineProperty(this, "code", 'ERR_JWKS_TIMEOUT');
    }
}
$c0722d30b1d17141$var$_defineProperty($c0722d30b1d17141$var$JWKSTimeout, "code", 'ERR_JWKS_TIMEOUT');
class $c0722d30b1d17141$var$JWSSignatureVerificationFailed extends $c0722d30b1d17141$var$JOSEError {
    constructor(){
        let message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'signature verification failed';
        let options = arguments.length > 1 ? arguments[1] : undefined;
        super(message, options);
        $c0722d30b1d17141$var$_defineProperty(this, "code", 'ERR_JWS_SIGNATURE_VERIFICATION_FAILED');
    }
}
$c0722d30b1d17141$var$_defineProperty($c0722d30b1d17141$var$JWSSignatureVerificationFailed, "code", 'ERR_JWS_SIGNATURE_VERIFICATION_FAILED');
const $c0722d30b1d17141$var$isObjectLike = (value)=>typeof value === 'object' && value !== null;
function $c0722d30b1d17141$var$isObject(input) {
    if (!$c0722d30b1d17141$var$isObjectLike(input) || Object.prototype.toString.call(input) !== '[object Object]') return false;
    if (Object.getPrototypeOf(input) === null) return true;
    let proto = input;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(input) === proto;
}
function $c0722d30b1d17141$var$decodeJwt(jwt) {
    if (typeof jwt !== 'string') throw new $c0722d30b1d17141$var$JWTInvalid('JWTs must use Compact JWS serialization, JWT must be a string');
    const { 1: payload, length: length } = jwt.split('.');
    if (length === 5) throw new $c0722d30b1d17141$var$JWTInvalid('Only JWTs using Compact JWS serialization can be decoded');
    if (length !== 3) throw new $c0722d30b1d17141$var$JWTInvalid('Invalid JWT');
    if (!payload) throw new $c0722d30b1d17141$var$JWTInvalid('JWTs must contain a payload');
    let decoded;
    try {
        decoded = $c0722d30b1d17141$var$decode(payload);
    } catch (_unused) {
        throw new $c0722d30b1d17141$var$JWTInvalid('Failed to base64url decode the payload');
    }
    let result;
    try {
        result = JSON.parse($c0722d30b1d17141$var$decoder.decode(decoded));
    } catch (_unused2) {
        throw new $c0722d30b1d17141$var$JWTInvalid('Failed to parse the decoded payload as JSON');
    }
    if (!$c0722d30b1d17141$var$isObject(result)) throw new $c0722d30b1d17141$var$JWTInvalid('Invalid JWT Claims Set');
    return result;
}
const $c0722d30b1d17141$var$ONE_SECOND_IN_MILLISECONDS = 1000;
const $c0722d30b1d17141$var$ONE_MINUTE_IN_MILLISECONDS = 60 * $c0722d30b1d17141$var$ONE_SECOND_IN_MILLISECONDS;
function $c0722d30b1d17141$var$isResponseTokenValid(response) {
    const jwtPayload = $c0722d30b1d17141$export$b04d28f37d7011f5(response.participantToken);
    if (!(jwtPayload === null || jwtPayload === void 0 ? void 0 : jwtPayload.nbf) || !(jwtPayload === null || jwtPayload === void 0 ? void 0 : jwtPayload.exp)) return true;
    const now = new Date();
    const nbfInMilliseconds = jwtPayload.nbf * $c0722d30b1d17141$var$ONE_SECOND_IN_MILLISECONDS;
    const nbfDate = new Date(nbfInMilliseconds);
    const expInMilliseconds = jwtPayload.exp * $c0722d30b1d17141$var$ONE_SECOND_IN_MILLISECONDS;
    const expDate = new Date(expInMilliseconds - $c0722d30b1d17141$var$ONE_MINUTE_IN_MILLISECONDS);
    return nbfDate <= now && expDate > now;
}
/** Given a LiveKit generated participant token, decodes and returns the associated {@link TokenPayload} data. */ function $c0722d30b1d17141$export$b04d28f37d7011f5(token) {
    const payload = $c0722d30b1d17141$var$decodeJwt(token);
    const { roomConfig: roomConfig } = payload, rest = $c0722d30b1d17141$var$__rest(payload, [
        "roomConfig"
    ]);
    const mappedPayload = Object.assign(Object.assign({}, rest), {
        roomConfig: payload.roomConfig ? $c0722d30b1d17141$var$RoomConfiguration.fromJson(payload.roomConfig, {
            ignoreUnknownFields: true
        }) : undefined
    });
    return mappedPayload;
}
/** Given two TokenSourceFetchOptions values, check to see if they are deep equal. */ function $c0722d30b1d17141$export$d68dc9ebead8ada5(a, b) {
    const allKeysSet = new Set([
        ...Object.keys(a),
        ...Object.keys(b)
    ]);
    for (const key of allKeysSet)switch(key){
        case 'roomName':
        case 'participantName':
        case 'participantIdentity':
        case 'participantMetadata':
        case 'participantAttributes':
        case 'agentName':
        case 'agentMetadata':
            if (a[key] !== b[key]) return false;
            break;
        default:
            // ref: https://stackoverflow.com/a/58009992
            const exhaustiveCheckedKey = key;
            throw new Error("Options key ".concat(exhaustiveCheckedKey, " not being checked for equality!"));
    }
    return true;
} /** A TokenSourceCached is a TokenSource which caches the last {@link TokenSourceResponseObject} value and returns it
 * until a) it expires or b) the {@link TokenSourceFetchOptions} provided to .fetch(...) change. */ 
class $c0722d30b1d17141$var$TokenSourceCached extends $c0722d30b1d17141$export$6bc68771f6025194 {
    constructor(){
        super(...arguments);
        this.cachedFetchOptions = null;
        this.cachedResponse = null;
        this.fetchMutex = new $c0722d30b1d17141$export$ca12f2943758ef55();
    }
    isSameAsCachedFetchOptions(options) {
        if (!this.cachedFetchOptions) return false;
        for (const key of Object.keys(this.cachedFetchOptions))switch(key){
            case 'roomName':
            case 'participantName':
            case 'participantIdentity':
            case 'participantMetadata':
            case 'participantAttributes':
            case 'agentName':
            case 'agentMetadata':
                if (this.cachedFetchOptions[key] !== options[key]) return false;
                break;
            default:
                // ref: https://stackoverflow.com/a/58009992
                const exhaustiveCheckedKey = key;
                throw new Error("Options key ".concat(exhaustiveCheckedKey, " not being checked for equality!"));
        }
        return true;
    }
    shouldReturnCachedValueFromFetch(fetchOptions) {
        if (!this.cachedResponse) return false;
        if (!$c0722d30b1d17141$var$isResponseTokenValid(this.cachedResponse)) return false;
        if (!this.isSameAsCachedFetchOptions(fetchOptions)) return false;
        return true;
    }
    getCachedResponseJwtPayload() {
        if (!this.cachedResponse) return null;
        return $c0722d30b1d17141$export$b04d28f37d7011f5(this.cachedResponse.participantToken);
    }
    fetch(options, force) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            const unlock = yield this.fetchMutex.lock();
            try {
                if (force) this.cachedResponse = null;
                if (this.shouldReturnCachedValueFromFetch(options)) return this.cachedResponse.toJson();
                this.cachedFetchOptions = options;
                const tokenResponse = yield this.update(options);
                this.cachedResponse = tokenResponse;
                return tokenResponse.toJson();
            } finally{
                unlock();
            }
        });
    }
}
class $c0722d30b1d17141$var$TokenSourceLiteral extends $c0722d30b1d17141$export$ddc2e1d582f80c18 {
    constructor(literalOrFn){
        super();
        this.literalOrFn = literalOrFn;
    }
    fetch() {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            if (typeof this.literalOrFn === 'function') return this.literalOrFn();
            else return this.literalOrFn;
        });
    }
}
class $c0722d30b1d17141$var$TokenSourceCustom extends $c0722d30b1d17141$var$TokenSourceCached {
    constructor(customFn){
        super();
        this.customFn = customFn;
    }
    update(options) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            const resultMaybePromise = this.customFn(options);
            let result;
            if (resultMaybePromise instanceof Promise) result = yield resultMaybePromise;
            else result = resultMaybePromise;
            return $c0722d30b1d17141$var$TokenSourceResponse.fromJson(result, {
                // NOTE: it could be possible that the response body could contain more fields than just
                // what's in TokenSourceResponse depending on the implementation
                ignoreUnknownFields: true
            });
        });
    }
}
class $c0722d30b1d17141$var$TokenSourceEndpoint extends $c0722d30b1d17141$var$TokenSourceCached {
    constructor(url){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super();
        this.url = url;
        this.endpointOptions = options;
    }
    createRequestFromOptions(options) {
        var _a, _b, _c;
        const request = new $c0722d30b1d17141$var$TokenSourceRequest();
        for (const key of Object.keys(options))switch(key){
            case 'roomName':
            case 'participantName':
            case 'participantIdentity':
            case 'participantMetadata':
                request[key] = options[key];
                break;
            case 'participantAttributes':
                request.participantAttributes = (_a = options.participantAttributes) !== null && _a !== void 0 ? _a : {};
                break;
            case 'agentName':
                request.roomConfig = (_b = request.roomConfig) !== null && _b !== void 0 ? _b : new $c0722d30b1d17141$var$RoomConfiguration();
                if (request.roomConfig.agents.length === 0) request.roomConfig.agents.push(new $c0722d30b1d17141$var$RoomAgentDispatch());
                request.roomConfig.agents[0].agentName = options.agentName;
                break;
            case 'agentMetadata':
                request.roomConfig = (_c = request.roomConfig) !== null && _c !== void 0 ? _c : new $c0722d30b1d17141$var$RoomConfiguration();
                if (request.roomConfig.agents.length === 0) request.roomConfig.agents.push(new $c0722d30b1d17141$var$RoomAgentDispatch());
                request.roomConfig.agents[0].metadata = options.agentMetadata;
                break;
            default:
                // ref: https://stackoverflow.com/a/58009992
                const exhaustiveCheckedKey = key;
                throw new Error("Options key ".concat(exhaustiveCheckedKey, " not being included in forming request!"));
        }
        return request;
    }
    update(options) {
        return $c0722d30b1d17141$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const request = this.createRequestFromOptions(options);
            const response = yield fetch(this.url, Object.assign(Object.assign({}, this.endpointOptions), {
                method: (_a = this.endpointOptions.method) !== null && _a !== void 0 ? _a : 'POST',
                headers: Object.assign({
                    'Content-Type': 'application/json'
                }, this.endpointOptions.headers),
                body: request.toJsonString({
                    useProtoFieldName: true
                })
            }));
            if (!response.ok) throw new Error("Error generating token from endpoint ".concat(this.url, ": received ").concat(response.status, " / ").concat((yield response.text())));
            const body = yield response.json();
            return $c0722d30b1d17141$var$TokenSourceResponse.fromJson(body, {
                // NOTE: it could be possible that the response body could contain more fields than just
                // what's in TokenSourceResponse depending on the implementation (ie, SandboxTokenServer)
                ignoreUnknownFields: true
            });
        });
    }
}
class $c0722d30b1d17141$var$TokenSourceSandboxTokenServer extends $c0722d30b1d17141$var$TokenSourceEndpoint {
    constructor(sandboxId, options){
        const { baseUrl: baseUrl = 'https://cloud-api.livekit.io' } = options, rest = $c0722d30b1d17141$var$__rest(options, [
            "baseUrl"
        ]);
        super("".concat(baseUrl, "/api/v2/sandbox/connection-details"), Object.assign(Object.assign({}, rest), {
            headers: {
                'X-Sandbox-ID': sandboxId
            }
        }));
    }
}
const $c0722d30b1d17141$export$7aca69cbd60b236d = {
    /** TokenSource.literal contains a single, literal set of {@link TokenSourceResponseObject}
   * credentials, either provided directly or returned from a provided function. */ literal (literalOrFn) {
        return new $c0722d30b1d17141$var$TokenSourceLiteral(literalOrFn);
    },
    /**
   * TokenSource.custom allows a user to define a manual function which generates new
   * {@link TokenSourceResponseObject} values on demand.
   *
   * Use this to get credentials from custom backends / etc.
   */ custom (customFn) {
        return new $c0722d30b1d17141$var$TokenSourceCustom(customFn);
    },
    /**
   * TokenSource.endpoint creates a token source that fetches credentials from a given URL using
   * the standard endpoint format:
   * @see https://cloud.livekit.io/projects/p_/sandbox/templates/token-server
   */ endpoint (url) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return new $c0722d30b1d17141$var$TokenSourceEndpoint(url, options);
    },
    /**
   * TokenSource.sandboxTokenServer queries a sandbox token server for credentials,
   * which supports quick prototyping / getting started types of use cases.
   *
   * This token provider is INSECURE and should NOT be used in production.
   *
   * For more info:
   * @see https://cloud.livekit.io/projects/p_/sandbox/templates/token-server
   */ sandboxTokenServer (sandboxId) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return new $c0722d30b1d17141$var$TokenSourceSandboxTokenServer(sandboxId, options);
    }
}; /**
 * Try to analyze the local track to determine the facing mode of a track.
 *
 * @remarks
 * There is no property supported by all browsers to detect whether a video track originated from a user- or environment-facing camera device.
 * For this reason, we use the `facingMode` property when available, but will fall back on a string-based analysis of the device label to determine the facing mode.
 * If both methods fail, the default facing mode will be used.
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/MediaTrackConstraints/facingMode | MDN docs on facingMode}
 * @experimental
 */ 
function $c0722d30b1d17141$export$87170f5cedaf6982(localTrack) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _a;
    const track = $c0722d30b1d17141$export$1fcfd1ae3646c28c(localTrack) ? localTrack.mediaStreamTrack : localTrack;
    const trackSettings = track.getSettings();
    let result = {
        facingMode: (_a = options.defaultFacingMode) !== null && _a !== void 0 ? _a : 'user',
        confidence: 'low'
    };
    // 1. Try to get facingMode from track settings.
    if ('facingMode' in trackSettings) {
        const rawFacingMode = trackSettings.facingMode;
        $c0722d30b1d17141$var$livekitLogger.trace('rawFacingMode', {
            rawFacingMode: rawFacingMode
        });
        if (rawFacingMode && typeof rawFacingMode === 'string' && $c0722d30b1d17141$var$isFacingModeValue(rawFacingMode)) result = {
            facingMode: rawFacingMode,
            confidence: 'high'
        };
    }
    // 2. If we don't have a high confidence we try to get the facing mode from the device label.
    if ([
        'low',
        'medium'
    ].includes(result.confidence)) {
        $c0722d30b1d17141$var$livekitLogger.trace("Try to get facing mode from device label: (".concat(track.label, ")"));
        const labelAnalysisResult = $c0722d30b1d17141$export$db3659edbf169d37(track.label);
        if (labelAnalysisResult !== undefined) result = labelAnalysisResult;
    }
    return result;
}
const $c0722d30b1d17141$var$knownDeviceLabels = new Map([
    [
        'obs virtual camera',
        {
            facingMode: 'environment',
            confidence: 'medium'
        }
    ]
]);
const $c0722d30b1d17141$var$knownDeviceLabelSections = new Map([
    [
        'iphone',
        {
            facingMode: 'environment',
            confidence: 'medium'
        }
    ],
    [
        'ipad',
        {
            facingMode: 'environment',
            confidence: 'medium'
        }
    ]
]);
/**
 * Attempt to analyze the device label to determine the facing mode.
 *
 * @experimental
 */ function $c0722d30b1d17141$export$db3659edbf169d37(deviceLabel) {
    var _a;
    const label = deviceLabel.trim().toLowerCase();
    // Empty string is a valid device label but we can't infer anything from it.
    if (label === '') return undefined;
    // Can we match against widely known device labels.
    if ($c0722d30b1d17141$var$knownDeviceLabels.has(label)) return $c0722d30b1d17141$var$knownDeviceLabels.get(label);
    // Can we match against sections of the device label.
    return (_a = Array.from($c0722d30b1d17141$var$knownDeviceLabelSections.entries()).find((_ref)=>{
        let [section] = _ref;
        return label.includes(section);
    })) === null || _a === void 0 ? void 0 : _a[1];
}
function $c0722d30b1d17141$var$isFacingModeValue(item) {
    const allowedValues = [
        'user',
        'environment',
        'left',
        'right'
    ];
    return item === undefined || allowedValues.includes(item);
}
const $c0722d30b1d17141$var$SerializerSymbol = Symbol.for('lk.serializer');
function $c0722d30b1d17141$export$bd98eb3b9214859(v) {
    return typeof v === 'object' && v !== null && 'symbol' in v && v.symbol === $c0722d30b1d17141$var$SerializerSymbol;
}
/** @internal */ function $c0722d30b1d17141$var$base(params) {
    return Object.assign(Object.assign({}, params), {
        symbol: $c0722d30b1d17141$var$SerializerSymbol
    });
}
/**
 * JSON serializer — `JSON.parse` on the way in, `JSON.stringify` on the way out.
 * Defaults to `any` so individual handlers can annotate their own payload types.
 */ function $c0722d30b1d17141$var$json() {
    return $c0722d30b1d17141$var$base({
        parse: (rawString)=>JSON.parse(rawString),
        serialize: (val)=>JSON.stringify(val)
    });
}
/** Raw string serializer — passes payloads through as plain strings with no encoding. */ function $c0722d30b1d17141$var$raw() {
    return $c0722d30b1d17141$var$base({
        parse: (rawString)=>rawString,
        serialize: (val)=>val
    });
}
/** Custom serializer - allows custom defined parse and serialize functions */ function $c0722d30b1d17141$var$custom(params) {
    return $c0722d30b1d17141$var$base(params);
}
/**
 * Serializer helpers for message payload encoding.
 *
 * @example
 * ```ts
 * const a = serializers.raw(); // Serializer<string, string>
 * const b = serializer.json<{ foo: string }, { bar: string }>(); // Serializer<{ foo: string }, { bar: string }>
 * ```
 *
 * @beta
 */ const $c0722d30b1d17141$export$7824249990c72c71 = {
    json: $c0722d30b1d17141$var$json,
    raw: $c0722d30b1d17141$var$raw,
    custom: $c0722d30b1d17141$var$custom
};

});


parcelRegister("3q4bW", function(module, exports) {

$parcel$export(module.exports, "getLivekitRoom", () => $27d70d2a576f600d$export$6de9fbdca5e07c80);
$parcel$export(module.exports, "_refreshSpeakers", () => $27d70d2a576f600d$export$525392055d097f3d);
$parcel$export(module.exports, "connectCall", () => $27d70d2a576f600d$export$3ece0fb79fd8fe03);
$parcel$export(module.exports, "disconnectCall", () => $27d70d2a576f600d$export$6ce760730bb920ed);
// connectCall — mint a LiveKit token, build a Room, connect, wire events.
// Called from RoomList.MeetRoomRow onClick, Main.Join onClick, NewRoomModal
// submit, etc — anywhere the user enters a call view.
//
// Kept as a registered project function (not a page-level lifecycle hook)
// because DOMQL v3.14 doesn't fire onCreate on `if:`/`extends:` children and
// doesn't fire onUpdate on root state changes. Chat/calendar follow the
// same "imperative action functions, no lifecycle hooks on sub-views"
// pattern.
//
// LiveKit Room instance is stored in a MODULE-LEVEL variable, NOT in
// smbls reactive state. Passing the Room through `root.update({...})`
// strips class methods (the reactive proxy serializes values), so
// `room.disconnect()` fails on subsequent reads. The module variable
// preserves the live instance with methods intact. Components/functions
// that need the Room import `getLivekitRoom()`.

var $lGaRB = parcelRequire("lGaRB");

var $8oZGw = parcelRequire("8oZGw");
let $27d70d2a576f600d$var$_livekitRoom = null;
const $27d70d2a576f600d$export$6de9fbdca5e07c80 = ()=>$27d70d2a576f600d$var$_livekitRoom;
// Filter out the meet-transcriber agent — LiveKit assigns it an identity
// like `agent-AJ_<jobId>` when AgentDispatchClient dispatches a named agent.
// It's listen-only (no tracks published) and should be invisible in the
// human-facing participant grid.
const $27d70d2a576f600d$var$_isAgent = (identity)=>typeof identity === 'string' && identity.startsWith('agent-');
const $27d70d2a576f600d$var$_refreshParticipants = (root, livekitRoom)=>{
    const local = livekitRoom.localParticipant;
    const remoteValues = typeof livekitRoom.remoteParticipants?.values === 'function' ? livekitRoom.remoteParticipants.values() : Object.values(livekitRoom.remoteParticipants || {});
    const remote = Array.from(remoteValues).filter((p)=>!$27d70d2a576f600d$var$_isAgent(p.identity));
    // `id` must be stable so smbls can diff the children array and REUSE
    // the existing tile element instead of recreating it on every mic /
    // speaker event. Without a stable id, each refresh spawns fresh
    // <video> DOM nodes and the user sees a flicker every time anyone
    // speaks. Use participant.identity as the id.
    const all = [
        {
            id: local.identity,
            identity: local.identity,
            name: local.name || local.identity,
            isLocal: true,
            isMicEnabled: local.isMicrophoneEnabled,
            isCameraEnabled: local.isCameraEnabled
        },
        ...remote.map((p)=>({
                id: p.identity,
                identity: p.identity,
                name: p.name || p.identity,
                isLocal: false,
                isMicEnabled: p.isMicrophoneEnabled,
                isCameraEnabled: p.isCameraEnabled
            }))
    ];
    root.update({
        livekitParticipants: all
    });
};
const $27d70d2a576f600d$export$525392055d097f3d = (root, livekitRoom)=>{
    const speakers = livekitRoom.activeSpeakers || [];
    const set = {};
    for (const p of speakers)set[p.identity] = true;
    root.update({
        livekitSpeakers: set
    });
};
const $27d70d2a576f600d$export$3ece0fb79fd8fe03 = async function(roomId) {
    const root = this.state.root;
    if (!roomId) roomId = root.activeRoomId;
    if (!roomId) {
        console.error('[connectCall] no roomId');
        return null;
    }
    if ($27d70d2a576f600d$var$_livekitRoom) {
        console.log('[connectCall] already connected');
        return $27d70d2a576f600d$var$_livekitRoom;
    }
    if (root.meetCallInFlight) {
        console.log('[connectCall] already connecting');
        return null;
    }
    root.update({
        meetCallInFlight: true,
        meetCallError: null,
        livekitConnected: false
    });
    // Re-scope realtime to include meet_transcripts (and analyses) for this
    // specific room. Without this, MeetLiveCaptions never receives INSERT
    // events because the page-level subscription only covers meet_rooms /
    // meet_participants / meet_waiting_room. Scoping by roomId keeps the
    // stream tight — we don't want every utterance from every concurrent
    // call in the org flowing through the channel.
    this.call('subscribeMeetRealtime', {
        tables: [
            'meet_rooms',
            'meet_participants',
            'meet_waiting_room',
            'meet_transcripts',
            'meet_transcript_analyses'
        ],
        roomId: roomId
    });
    try {
        const tokenInfo = await this.call('mintLivekitToken', roomId);
        const startingCount = (root.liveParticipants?.[roomId] || []).filter((p)=>!p.leftAt).length || 1;
        const livekitRoom = (0, $8oZGw.buildLivekitRoom)(startingCount);
        const refresh = ()=>$27d70d2a576f600d$var$_refreshParticipants(root, livekitRoom);
        // Participant-set events only — events that can change WHO is in the
        // room or what tracks exist.
        livekitRoom.on((0, $lGaRB.RoomEvent).ParticipantConnected, refresh);
        livekitRoom.on((0, $lGaRB.RoomEvent).ParticipantDisconnected, refresh);
        livekitRoom.on((0, $lGaRB.RoomEvent).LocalTrackPublished, refresh);
        livekitRoom.on((0, $lGaRB.RoomEvent).LocalTrackUnpublished, refresh);
        livekitRoom.on((0, $lGaRB.RoomEvent).TrackSubscribed, refresh);
        livekitRoom.on((0, $lGaRB.RoomEvent).TrackUnsubscribed, refresh);
        // Mute toggles change isMicEnabled/isCameraEnabled — also a full
        // refresh. These fire on user action, not per-frame, so the diff
        // stays stable.
        livekitRoom.on((0, $lGaRB.RoomEvent).TrackMuted, refresh);
        livekitRoom.on((0, $lGaRB.RoomEvent).TrackUnmuted, refresh);
        // ActiveSpeakersChanged fires on EVERY spoken syllable. Route to a
        // separate state slot (livekitSpeakers) so updating it doesn't
        // invalidate the livekitParticipants diff and tear down tile DOM.
        livekitRoom.on((0, $lGaRB.RoomEvent).ActiveSpeakersChanged, ()=>$27d70d2a576f600d$export$525392055d097f3d(root, livekitRoom));
        livekitRoom.on((0, $lGaRB.RoomEvent).Disconnected, ()=>{
            console.log('[meet] livekit disconnected');
            $27d70d2a576f600d$var$_livekitRoom = null;
            root.update({
                livekitParticipants: [],
                livekitConnected: false
            });
        });
        await livekitRoom.connect(tokenInfo.livekitUrl, tokenInfo.livekitToken);
        // Publish the local mic + camera tracks. Errors here mean the browser
        // denied permission or there's no device — surface the error instead
        // of silently continuing with no tracks (which was the old bug).
        try {
            await livekitRoom.localParticipant.setMicrophoneEnabled(true);
        } catch (err) {
            console.error('[connectCall] mic enable failed (permission denied?)', err);
        }
        try {
            await livekitRoom.localParticipant.setCameraEnabled(true);
        } catch (err) {
            console.error('[connectCall] camera enable failed (permission denied?)', err);
        }
        $27d70d2a576f600d$var$_livekitRoom = livekitRoom;
        root.update({
            livekitConnected: true,
            meetCallInFlight: false
        });
        $27d70d2a576f600d$var$_refreshParticipants(root, livekitRoom);
        return livekitRoom;
    } catch (err) {
        console.error('[connectCall] failed', err);
        $27d70d2a576f600d$var$_livekitRoom = null;
        root.update({
            meetCallError: err?.message || 'connect failed',
            meetCallInFlight: false,
            livekitConnected: false
        });
        return null;
    }
};
const $27d70d2a576f600d$export$6ce760730bb920ed = async function() {
    const root = this.state.root;
    // Re-scope realtime back to the broad list view — drops the transcripts
    // + analyses subscriptions so we don't keep streaming utterances for a
    // room we're no longer in.
    try {
        this.call('subscribeMeetRealtime', {
            tables: [
                'meet_rooms',
                'meet_participants',
                'meet_waiting_room'
            ]
        });
    } catch (err) {
        console.warn('[disconnectCall] rescope failed', err);
    }
    const room = $27d70d2a576f600d$var$_livekitRoom;
    if (!room) {
        root.update({
            livekitParticipants: [],
            livekitConnected: false
        });
        return;
    }
    try {
        await room.disconnect();
    } catch (err) {
        console.warn('[disconnectCall] failed', err);
    }
    $27d70d2a576f600d$var$_livekitRoom = null;
    root.update({
        livekitParticipants: [],
        livekitConnected: false
    });
};

});

parcelRegister("3AwVh", function(module, exports) {

$parcel$export(module.exports, "endRoom", () => $29ce45b4eb35dacc$export$ded6fd72ce2908d4);
$parcel$export(module.exports, "reopenRoom", () => $29ce45b4eb35dacc$export$655a9268b24e505d);
// endRoom / reopenRoom — toggle meet_rooms.ended_at. The meet_rooms_update
// RLS policy allows the room creator (and admins) to update. Other members
// get a silent failure, which is what we want — only owners can close a
// room.
//
// Ending a room doesn't disconnect live participants — it's an advisory
// state flag. Components read it to sort, badge, and hide the call button
// on the room row. If you want to forcibly kick everyone, that's a future
// `RoomServiceClient.deleteRoom` call from a new Edge Function.
//
// migrated 2026-04-27 to SDK route workspaceProject.meet.rooms (end / reopen)

var $bfqVY = parcelRequire("bfqVY");
const $29ce45b4eb35dacc$export$ded6fd72ce2908d4 = async function(roomId) {
    const root = this.state.root;
    const id = roomId || root.activeRoomId;
    if (!id) return false;
    const endedAt = new Date().toISOString();
    try {
        await (0, $bfqVY.getSDK)().execute('workspaceProject.meet.rooms', 'end', {
            id: id
        });
    } catch (err) {
        console.error('[endRoom]', err?.message || err);
        return false;
    }
    // Optimistic state merge
    const rooms = (root.rooms || []).map((r)=>r.id === id ? {
            ...r,
            endedAt: endedAt
        } : r);
    root.update({
        rooms: rooms
    });
    return true;
};
const $29ce45b4eb35dacc$export$655a9268b24e505d = async function(roomId) {
    const root = this.state.root;
    const id = roomId || root.activeRoomId;
    if (!id) return false;
    try {
        await (0, $bfqVY.getSDK)().execute('workspaceProject.meet.rooms', 'reopen', {
            id: id
        });
    } catch (err) {
        console.error('[reopenRoom]', err?.message || err);
        return false;
    }
    const rooms = (root.rooms || []).map((r)=>r.id === id ? {
            ...r,
            endedAt: null,
            livekitInitialized: false
        } : r);
    root.update({
        rooms: rooms
    });
    return true;
};

});

parcelRegister("8lQZV", function(module, exports) {

$parcel$export(module.exports, "updateRoomSettings", () => $6149652bbe319ae3$export$af267b4b9131f585);
$parcel$export(module.exports, "admitGuest", () => $6149652bbe319ae3$export$429b8536e145ba97);
$parcel$export(module.exports, "rejectGuest", () => $6149652bbe319ae3$export$56973a318d633f4d);
// updateRoomSettings — persist guest-join requirements + basic room fields.
// Owner-only via RLS (meet_rooms_update policy). Called from
// MeetRoomSettingsModal's save button. Optimistically merges into
// root.rooms so the UI reflects the change before realtime round-trips.
//
// migrated 2026-04-27 to SDK route workspaceProject.meet.rooms (update) +
// workspaceProject.meet.waitingRoom (admit/reject)

var $bfqVY = parcelRequire("bfqVY");
const $6149652bbe319ae3$export$af267b4b9131f585 = async function(patch) {
    const root = this.state.root;
    const id = patch?.roomId || root.activeRoomId;
    if (!id) return false;
    // Only forward known columns — callers may pass extra state keys by
    // accident and the server-side relay would reject the whole write.
    const update = {};
    if (patch.name !== undefined) update.name = patch.name;
    if (patch.isPrivate !== undefined) update.is_private = !!patch.isPrivate;
    if (patch.guestRequireName !== undefined) update.guest_require_name = !!patch.guestRequireName;
    if (patch.guestRequireEmail !== undefined) update.guest_require_email = !!patch.guestRequireEmail;
    if (patch.guestAutoAdmit !== undefined) update.guest_auto_admit = !!patch.guestAutoAdmit;
    if (patch.guestPassword !== undefined) update.guest_password = patch.guestPassword || null;
    try {
        await (0, $bfqVY.getSDK)().execute('workspaceProject.meet.rooms', 'update', {
            id: id,
            payload: update
        });
    } catch (err) {
        console.error('[updateRoomSettings]', err?.message || err);
        return false;
    }
    // Optimistic local merge mirrors rowToRoom's camelCase shape.
    const rooms = (root.rooms || []).map((r)=>{
        if (r.id !== id) return r;
        return {
            ...r,
            ...patch.name !== undefined ? {
                name: patch.name
            } : {},
            ...patch.isPrivate !== undefined ? {
                isPrivate: !!patch.isPrivate
            } : {},
            ...patch.guestRequireName !== undefined ? {
                guestRequireName: !!patch.guestRequireName
            } : {},
            ...patch.guestRequireEmail !== undefined ? {
                guestRequireEmail: !!patch.guestRequireEmail
            } : {},
            ...patch.guestAutoAdmit !== undefined ? {
                guestAutoAdmit: !!patch.guestAutoAdmit
            } : {},
            ...patch.guestPassword !== undefined ? {
                guestPassword: patch.guestPassword || null
            } : {}
        };
    });
    root.update({
        rooms: rooms
    });
    return true;
};
const $6149652bbe319ae3$export$429b8536e145ba97 = async function(waitingId) {
    if (!waitingId) return false;
    try {
        await (0, $bfqVY.getSDK)().execute('workspaceProject.meet.waitingRoom', 'admit', {
            id: waitingId
        });
        return true;
    } catch (err) {
        console.error('[admitGuest]', err?.message || err);
        return false;
    }
};
const $6149652bbe319ae3$export$56973a318d633f4d = async function(waitingId) {
    if (!waitingId) return false;
    try {
        await (0, $bfqVY.getSDK)().execute('workspaceProject.meet.waitingRoom', 'reject', {
            id: waitingId
        });
        return true;
    } catch (err) {
        console.error('[rejectGuest]', err?.message || err);
        return false;
    }
};

});

parcelRegister("27MmO", function(module, exports) {

$parcel$export(module.exports, "openSuggestionModal", () => $18c1c0e7d37a6f21$export$21791be46170eb63);
// openSuggestionModal — opens the native creation modal pre-filled with
// AI-extracted suggestion data. Buckets that have a dedicated modal get
// routed there directly so the user gets the full editing experience.
// Others (notes, knowledge_base, chat_messages) fall back to
// MeetSuggestionConfirmModal.
//
// For calendar_events: opens the booking modal pre-filled with the
// suggestion data. No meet room is pre-created — the user fills in the
// meeting URL themselves, or the modal auto-generates a Google Meet link
// on save as it does for regular events.
//
// Sets root.pendingSuggestion = { bucket, item } before opening so the
// target modal's save handler can call markSuggestionApplied once the
// user confirms.

var $7MNpT = parcelRequire("7MNpT");

var $kZOF8 = parcelRequire("kZOF8");
// Mirror of the helper in applySuggestion.js — duplicated to avoid
// importing across function modules (each registered fn is self-contained).
const $18c1c0e7d37a6f21$var$_pad = (n)=>String(n).padStart(2, '0');
const $18c1c0e7d37a6f21$var$_parseProposedTime = (str)=>{
    if (!str) return null;
    const d = new Date(str);
    if (!isNaN(d)) return {
        date: `${d.getFullYear()}-${$18c1c0e7d37a6f21$var$_pad(d.getMonth() + 1)}-${$18c1c0e7d37a6f21$var$_pad(d.getDate())}`,
        time: `${$18c1c0e7d37a6f21$var$_pad(d.getHours())}:${$18c1c0e7d37a6f21$var$_pad(d.getMinutes())}`
    };
    return null;
};
const $18c1c0e7d37a6f21$var$_tomorrowAt10 = ()=>{
    const t = new Date();
    t.setDate(t.getDate() + 1);
    return {
        date: `${t.getFullYear()}-${$18c1c0e7d37a6f21$var$_pad(t.getMonth() + 1)}-${$18c1c0e7d37a6f21$var$_pad(t.getDate())}`,
        time: '10:00'
    };
};
const $18c1c0e7d37a6f21$export$21791be46170eb63 = function(bucket, item) {
    const root = this.state?.root ?? this.state;
    if (!root || !bucket || !item) return;
    if (bucket === 'tickets') {
        // Auto-create the ticket immediately so the full TicketsDetailModal
        // view mode opens — same experience as clicking a ticket at /tickets.
        const colKey = 'backlog';
        const sameCol = (root.tickets || []).filter((t)=>t.columnKey === colKey);
        const lastPos = sameCol.length ? Math.max(...sameCol.map((t)=>t.position || 0)) : 0;
        const t = {
            id: Date.now(),
            title: item.title || '',
            body: item.description || '',
            columnKey: colKey,
            position: (0, $7MNpT.positionBetween)(lastPos, null),
            assigneeEmail: item.assignee_email || null,
            reporterEmail: root.currentUserEmail,
            labels: [],
            priority: 'medium',
            dueDate: null
        };
        root.update({
            tickets: [
                ...root.tickets || [],
                t
            ],
            selectedTicket: t,
            pendingSuggestion: {
                bucket: bucket,
                item: item
            }
        });
        const self = this;
        self.call('saveTicketToSupabase', t).then(function(realId) {
            if (!realId) return;
            const updated = Object.assign({}, t, {
                id: realId
            });
            const stillExists = (root.tickets || []).some((x)=>x.id === t.id);
            root.update({
                tickets: (root.tickets || []).map((x)=>x.id === t.id ? updated : x),
                selectedTicket: stillExists ? updated : root.selectedTicket,
                pendingSuggestion: null
            });
            self.call('markSuggestionApplied', bucket, item, realId);
        });
        return;
    }
    if (bucket === 'calendar_events') {
        const { date: date, time: time } = $18c1c0e7d37a6f21$var$_parseProposedTime(item.proposed_time) || $18c1c0e7d37a6f21$var$_tomorrowAt10();
        const [h, m] = time.split(':').map(Number);
        const endH = String((h + 1) % 24).padStart(2, '0');
        const endTime = `${endH}:${String(m).padStart(2, '0')}`;
        root.update({
            newBooking: (0, $kZOF8.freshBooking)({
                title: item.title || '',
                date: date,
                startTime: time,
                endTime: endTime,
                description: item.description || '',
                invitees: (item.attendees || []).filter(Boolean).join(', '),
                type: 'meeting',
                meetingMode: 'symbols-meet'
            }),
            showNewBooking: true,
            pendingSuggestion: {
                bucket: bucket,
                item: item
            }
        });
        return;
    }
    // Fallback: generic confirm modal (notes, knowledge_base, chat_messages).
    const initTitle = bucket === 'chat_messages' ? item?.body || '' : item?.title || item?.body || '';
    root.update({
        suggestionConfirm: {
            bucket: bucket,
            item: item
        },
        suggestionConfirmTitle: initTitle
    });
};

});

parcelRegister("bWmNh", function(module, exports) {

$parcel$export(module.exports, "markSuggestionApplied", () => $8b16cae0bd20fdaa$export$5835272e445e26f);
// markSuggestionApplied — record that a suggestion was applied without
// calling the creation function. Used by NewTicketModal / NewBookingModal
// after the user saves a pre-filled suggestion through the native modal.
// Shares the fingerprint + applied_items logic with applySuggestion.js but
// skips the actual creation step.

var $bfqVY = parcelRequire("bfqVY");

var $fM8BY = parcelRequire("fM8BY");
const $8b16cae0bd20fdaa$export$5835272e445e26f = async function(bucket, item, targetId) {
    const root = this.state.root;
    if (!bucket || !item || !targetId) return;
    // Only write if the analysis row exists — otherwise there's no DB row to
    // patch. This can happen if the user opens a suggestion modal while still
    // loading the transcript page.
    if (!root.analysis || !root.activeRoomId) return;
    try {
        const fingerprint = await (0, $fM8BY.fingerprintSuggestion)(item);
        const current = root.analysis?.applied_items || [];
        const pruned = await (0, $fM8BY.pruneStaleApplied)(current, root.analysis?.suggestions);
        // Skip if already marked (e.g. double-save race)
        if (pruned.some((e)=>e.fingerprint === fingerprint)) return;
        const next = [
            ...pruned,
            {
                bucket: bucket,
                fingerprint: fingerprint,
                target_id: String(targetId),
                applied_at: new Date().toISOString()
            }
        ];
        // migrated 2026-04-27 to SDK route workspaceProject.meet.analysisAppliedItems
        try {
            await (0, $bfqVY.getSDK)().execute('workspaceProject.meet.analysisAppliedItems', 'update', {
                roomId: root.activeRoomId,
                payload: {
                    applied_items: next
                }
            });
            root.update({
                analysis: {
                    ...root.analysis,
                    applied_items: next
                }
            });
        } catch (err) {
            console.warn('[markSuggestionApplied] write failed', err?.message || err);
        }
    } catch (err) {
        console.warn('[markSuggestionApplied] skipped', err);
    }
};

});


parcelRegister("5OmcJ", function(module, exports) {

var $e8viy = parcelRequire("e8viy");

var $jkctA = parcelRequire("jkctA");

var $1QFdD = parcelRequire("1QFdD");

var $55iQs = parcelRequire("55iQs");
$parcel$exportWildcard(module.exports, $e8viy);
$parcel$exportWildcard(module.exports, $jkctA);
$parcel$exportWildcard(module.exports, $1QFdD);
$parcel$exportWildcard(module.exports, $55iQs);

});
parcelRegister("e8viy", function(module, exports) {

$parcel$export(module.exports, "subscribeNotifications", () => $a4aa173d98330ece$export$a848450d3ff9c734);
$parcel$export(module.exports, "fetchNotifications", () => $a4aa173d98330ece$export$bfd9e0818328ace6);
// migrated 2026-04-27 to SDK realtime — `workspaceProject.realtime.notifications`
// dispatches through the SDK's pluggable provider. Today's wire is Supabase
// realtime via supabaseRealtimeProvider in bootShell; when the backend ships
// native socket.io realtime, swap the provider — this file doesn't change.

var $bfqVY = parcelRequire("bfqVY");
const $a4aa173d98330ece$export$a848450d3ff9c734 = function() {
    const root = this?.state?.root;
    if (!root) return;
    const me = root.currentUserEmail;
    if (!me) return;
    // Prevent double-subscribe.
    if (root._notifChannel) return;
    let _unsub = null;
    let _cancelled = false;
    Promise.resolve((0, $bfqVY.getSDK)().getService?.('workspaceProject')).then((wp)=>{
        if (_cancelled || !wp?.realtime?.subscribeNotifications) return;
        _unsub = wp.realtime.subscribeNotifications({
            userEmail: me
        }, (_event, payload)=>{
            const row = payload?.new;
            if (!row) return;
            const cur = root.notifications || [];
            if (cur.some((n)=>n.id === row.id)) return;
            const notif = $a4aa173d98330ece$var$_rowToNotif(row);
            root.update({
                notifications: [
                    notif,
                    ...cur
                ]
            });
            $a4aa173d98330ece$var$_showBrowserNotification(notif);
        });
    }).catch((err)=>{
        console.warn('[subscribeNotifications] subscribe failed:', err?.message || err);
    });
    // Stash a callable handle that supports both fn() and .unsubscribe()
    // shapes so legacy cleanup paths keep working unchanged.
    const handle = ()=>{
        _cancelled = true;
        if (typeof _unsub === 'function') try {
            _unsub();
        } catch (_) {}
    };
    handle.unsubscribe = handle;
    root._notifChannel = handle;
};
const $a4aa173d98330ece$export$bfd9e0818328ace6 = async function() {
    const root = this?.state?.root;
    if (!root) return;
    const me = root.currentUserEmail;
    if (!me) return;
    try {
        const result = await (0, $bfqVY.getSDK)().execute('workspaceProject.notifications', 'list', {});
        const data = Array.isArray(result?.data) ? result.data : Array.isArray(result) ? result : [];
        root.update({
            notifications: data.map($a4aa173d98330ece$var$_rowToNotif)
        });
    } catch (e) {
        console.error('[fetchNotifications]', e?.message || e);
    }
};
const $a4aa173d98330ece$var$_rowToNotif = (r)=>({
        id: r.id,
        userEmail: r.user_email,
        type: r.type,
        title: r.title,
        body: r.body,
        href: r.href,
        metadata: r.metadata || {},
        read: !!r.read,
        createdAt: r.created_at
    });
const $a4aa173d98330ece$var$_showBrowserNotification = (notif)=>{
    if (typeof window === 'undefined') return;
    if (Notification.permission !== 'granted') return;
    try {
        const n = new Notification(notif.title, {
            body: notif.body || '',
            icon: '/favicon.ico',
            tag: notif.id
        });
        if (notif.href) n.onclick = ()=>{
            window.focus();
            window.location.hash = '';
            window.location.pathname = notif.href;
            n.close();
        };
    } catch (e) {}
};

});

parcelRegister("jkctA", function(module, exports) {

$parcel$export(module.exports, "markNotificationRead", () => $e1199017939e917f$export$49199adf1afcc108);
$parcel$export(module.exports, "markAllNotificationsRead", () => $e1199017939e917f$export$e084b0935ef1b664);
// migrated 2026-04-27 to SDK route workspaceProject.notifications (update / markAllRead)

var $bfqVY = parcelRequire("bfqVY");
const $e1199017939e917f$export$49199adf1afcc108 = async function(notifId) {
    if (!notifId) return;
    const root = this?.state?.root;
    if (!root) return;
    // Optimistic update
    root.update({
        notifications: (root.notifications || []).map((n)=>n.id === notifId ? {
                ...n,
                read: true
            } : n)
    });
    try {
        await (0, $bfqVY.getSDK)().execute('workspaceProject.notifications', 'update', {
            id: notifId
        });
    } catch (e) {
        console.error('[markNotificationRead]', e?.message || e);
    }
};
const $e1199017939e917f$export$e084b0935ef1b664 = async function() {
    const root = this?.state?.root;
    if (!root) return;
    const me = root.currentUserEmail;
    if (!me) return;
    // Optimistic update
    root.update({
        notifications: (root.notifications || []).map((n)=>({
                ...n,
                read: true
            }))
    });
    try {
        await (0, $bfqVY.getSDK)().execute('workspaceProject.notifications', 'markAllRead', {});
    } catch (e) {
        console.error('[markAllNotificationsRead]', e?.message || e);
    }
};

});

parcelRegister("1QFdD", function(module, exports) {

$parcel$export(module.exports, "requestBrowserPermission", () => $158a9efe098a061f$export$87583831425b9001);
/**
 * Request browser notification permission.
 * Call early in app lifecycle (e.g. onCreate of main page).
 * Returns 'granted', 'denied', or 'default'.
 */ const $158a9efe098a061f$export$87583831425b9001 = async function() {
    if (typeof window === 'undefined' || !('Notification' in window)) return 'denied';
    if (Notification.permission === 'granted') return 'granted';
    if (Notification.permission === 'denied') return 'denied';
    return Notification.requestPermission();
};

});

parcelRegister("55iQs", function(module, exports) {

$parcel$export(module.exports, "fetchOrgNotifCount", () => $3b3c099a61a9d03f$export$6b876a55bbae8046);
// §I8 — cross-org notification badge counts.
//
// Hits the server's `/auth/me/org-notifications` endpoint, which forwards
// via HMAC to the governance `symbols-admin-ops` edge fn's
// `notifications.count_by_org` handler. Response shape:
//   { data: { counts: { [orgId]: { mentions, ticketsAssigned, meetingInvites } } } }
//
// `AppWorkspaceSwitcher`'s per-org `NotifBadge` reads `root.orgNotifCount[orgId]`
// as a single aggregate number — we sum the three signals into one badge
// count per org. The signals still live behind the flat key so a future
// per-type surfacing (e.g. mention-only pulse, ticket-only indicator)
// can read `root.orgNotifSignals[orgId]` without refetching.
//
// Fails-soft: any error leaves existing counts untouched. Server itself
// already fails-soft to `{counts:{}}` when governance URL is unset, so
// a 200 response with empty counts is normal during pre-wiring.

var $8RlGv = parcelRequire("8RlGv");

var $bfqVY = parcelRequire("bfqVY");
const $3b3c099a61a9d03f$export$6b876a55bbae8046 = async (root)=>{
    if (!root) return;
    // Skip the poll when the tab is not visible — saves free-tier edge fn
    // invocations for users with the intranet backgrounded. The first call
    // on sign-in always goes through (document.hidden is false on active tab).
    if (typeof document !== 'undefined' && document.hidden) return;
    if (!(0, $8RlGv.getSymbolsToken)()) return;
    try {
        // SDK method threads the auth header + base URL through TokenManager
        // and returns the unwrapped data payload directly.
        const data = await (0, $bfqVY.getSDK)().getMyOrgNotifications();
        const counts = data && data.counts || {};
        const flat = {};
        const signals = {};
        for (const [orgId, perType] of Object.entries(counts)){
            const m = Number(perType?.mentions || 0);
            const t = Number(perType?.ticketsAssigned || 0);
            const i = Number(perType?.meetingInvites || 0);
            flat[orgId] = m + t + i;
            signals[orgId] = {
                mentions: m,
                ticketsAssigned: t,
                meetingInvites: i
            };
        }
        root.update({
            orgNotifCount: flat,
            orgNotifSignals: signals
        });
    } catch  {
    // fail-soft — leave prior counts intact
    }
};

});


parcelRegister("2u3aj", function(module, exports) {

var $4Tov7 = parcelRequire("4Tov7");
$parcel$exportWildcard(module.exports, $4Tov7);

});
parcelRegister("4Tov7", function(module, exports) {

$parcel$export(module.exports, "updateActivityScoring", () => $38ff4dd9aff7c216$export$ddafc4b5bb33fca6);
// Admin-only writer for activity_scoring_config. Receives the list of
// "dirty" rows (the admin UI already filtered out unchanged rows) and
// PATCHes them through workspaceProject.activity.updateScoringConfig.
// Server enforces is_admin() gate (RLS policy `scoring_write`), so
// non-admins silently fail.
//
// Returns true on success, false on failure — the caller uses
// the flag to decide whether to flip the local state to "saved".
//
// migrated 2026-04-27 to SDK route workspaceProject.activity.updateScoringConfig

var $bfqVY = parcelRequire("bfqVY");
const $38ff4dd9aff7c216$export$ddafc4b5bb33fca6 = async function(dirty) {
    if (!Array.isArray(dirty) || !dirty.length) return true;
    const me = this?.state?.root?.currentUserEmail || null;
    const now = new Date().toISOString();
    const rows = dirty.map((r)=>({
            activity_type: r.activity_type,
            enabled: r._draftEnabled,
            score: r._draftScore,
            updated_at: now,
            updated_by: me
        }));
    try {
        await (0, $bfqVY.getSDK)().execute('workspaceProject.activity', 'updateScoringConfig', {
            rows: rows
        });
        return true;
    } catch (err) {
        console.error('[updateActivityScoring]', err?.message || err);
        return false;
    }
};

});


parcelRegister("jjwpk", function(module, exports) {

$parcel$export(module.exports, "globalSearch", () => (parcelRequire("duWWH")).globalSearch);
$parcel$export(module.exports, "closeNavSearch", () => (parcelRequire("duWWH")).closeNavSearch);
$parcel$export(module.exports, "navigateSearchResult", () => (parcelRequire("duWWH")).navigateSearchResult);
$parcel$export(module.exports, "CATEGORY_META", () => (parcelRequire("duWWH")).CATEGORY_META);

var $duWWH = parcelRequire("duWWH");

});
parcelRegister("duWWH", function(module, exports) {

$parcel$export(module.exports, "CATEGORY_META", () => $9d3bcd1e03942af3$export$9247ea43d19dc9e);
$parcel$export(module.exports, "globalSearch", () => $9d3bcd1e03942af3$export$2b3bfbaa540c83e0);
$parcel$export(module.exports, "closeNavSearch", () => $9d3bcd1e03942af3$export$dfd1c1be4a27e9cb);
$parcel$export(module.exports, "navigateSearchResult", () => $9d3bcd1e03942af3$export$d04c18bc3487b6ed);
// Global navbar search — queries the main entity tables in parallel and
// returns a categorised result set the dropdown can render directly.
//
// Categories: people, tickets, channels, messages, events, documents, notes, kb.
// Each category caps at 5 hits.
//
// migrated 2026-04-27 to SDK route workspaceProject.search (rpc).
//
// The server wraps `workspace_global_search(q, surfaces, limit)` — a single
// SQL function the wrapper exposes via /search. The function is expected
// to return rows with at least { surface, id, title, subtitle, href }
// fields. While migrations land, surfaces lacking server-side support are
// quietly elided. People are still resolved client-side from `root.people`.
//
// TODO[server]: wire the workspace_global_search() SQL function so all
// surfaces fan out server-side; once it ships, surface-specific queries
// here are no longer needed.

var $bfqVY = parcelRequire("bfqVY");
const $9d3bcd1e03942af3$var$_LIMIT = 5;
const $9d3bcd1e03942af3$var$_DEBOUNCE_MS = 200;
// Category metadata for display ordering and labels
const $9d3bcd1e03942af3$export$9247ea43d19dc9e = {
    people: {
        label: 'People',
        icon: 'people',
        order: 0
    },
    tickets: {
        label: 'Tickets',
        icon: 'ticket',
        order: 1
    },
    channels: {
        label: 'Channels',
        icon: 'chat',
        order: 2
    },
    messages: {
        label: 'Messages',
        icon: 'chat',
        order: 3
    },
    events: {
        label: 'Events',
        icon: 'calendar',
        order: 4
    },
    documents: {
        label: 'Documents',
        icon: 'document',
        order: 5
    },
    notes: {
        label: 'Notes',
        icon: 'document',
        order: 6
    },
    kb: {
        label: 'Knowledge Base',
        icon: 'bookmark',
        order: 7
    }
};
// Map a server-side row {surface, id, title, ...} to the client-side
// flat result shape used by the dropdown. Surfaces without an explicit
// mapping fall through to a generic shape — let the server label them.
const $9d3bcd1e03942af3$var$_SURFACE_HREF = {
    tickets: (r)=>`/tickets/my?ticket=${r.number || r.id}`,
    notes: (r)=>`/documents/notes?id=${r.id}`,
    kb: (r)=>`/documents/knowledge-base?id=${r.id}`,
    events: (r)=>`/calendar?event=${r.id}`,
    channels: (r)=>`/chat?channel=${r.id}`,
    messages: (r)=>`/chat?channel=${r.channel_id}&message=${r.id}`,
    documents: (r)=>`/documents?id=${r.id}`
};
const $9d3bcd1e03942af3$var$_shapeRow = (row)=>{
    const surface = row.surface || row._category;
    const id = row.id || row._id;
    const title = row.title || row._title || `#${row.number || id}`;
    const subtitle = row.subtitle || row._subtitle || row.author || '';
    const hrefBuilder = $9d3bcd1e03942af3$var$_SURFACE_HREF[surface];
    return {
        _category: surface,
        _id: id,
        _title: title,
        _subtitle: subtitle,
        _href: row.href || row._href || (hrefBuilder ? hrefBuilder(row) : '#')
    };
};
// Group flat results by category, respecting display order
const $9d3bcd1e03942af3$var$_groupResults = (results)=>{
    const grouped = {};
    for (const r of results){
        if (!grouped[r._category]) grouped[r._category] = [];
        grouped[r._category].push(r);
    }
    return Object.entries(grouped).sort(([a], [b])=>($9d3bcd1e03942af3$export$9247ea43d19dc9e[a]?.order ?? 99) - ($9d3bcd1e03942af3$export$9247ea43d19dc9e[b]?.order ?? 99)).map(([cat, items])=>({
            category: cat,
            label: $9d3bcd1e03942af3$export$9247ea43d19dc9e[cat]?.label || cat,
            icon: $9d3bcd1e03942af3$export$9247ea43d19dc9e[cat]?.icon || 'search',
            items: items
        }));
};
const $9d3bcd1e03942af3$export$2b3bfbaa540c83e0 = async function(query) {
    const root = this.state.root;
    const q = (query || '').trim();
    root.update({
        navSearchQuery: query || '',
        _navSearchLoading: !!q,
        _navSearchOpen: !!q
    });
    if (!q) {
        root.update({
            navSearchResults: [],
            _navSearchGrouped: [],
            _navSearchLoading: false,
            _navSearchOpen: false
        });
        return;
    }
    await new Promise((r)=>setTimeout(r, $9d3bcd1e03942af3$var$_DEBOUNCE_MS));
    if (root.navSearchQuery !== query) return;
    let serverResults = [];
    try {
        const result = await (0, $bfqVY.getSDK)().execute('workspaceProject.search', 'rpc', {
            q: q,
            options: {
                limit: $9d3bcd1e03942af3$var$_LIMIT
            }
        });
        if (root.navSearchQuery !== query) return;
        const rows = Array.isArray(result?.data) ? result.data : Array.isArray(result) ? result : [];
        serverResults = rows.map($9d3bcd1e03942af3$var$_shapeRow);
    } catch (err) {
        // Swallow until the server-side search RPC ships. People-only fallback
        // still renders so the dropdown never goes empty.
        console.warn('[globalSearch] server search unavailable, returning people-only', err?.message || err);
    }
    if (root.navSearchQuery !== query) return;
    const ql = q.toLowerCase();
    const peopleHits = (root.people || []).filter((p)=>(p.name || '').toLowerCase().includes(ql) || (p.email || '').toLowerCase().includes(ql)).slice(0, $9d3bcd1e03942af3$var$_LIMIT).map((p)=>({
            _category: 'people',
            _id: p.email,
            _title: p.name || p.email,
            _subtitle: p.email,
            _href: `/people?u=${encodeURIComponent(p.email)}`
        }));
    const all = [
        ...peopleHits,
        ...serverResults
    ];
    root.update({
        navSearchResults: all,
        _navSearchGrouped: $9d3bcd1e03942af3$var$_groupResults(all),
        _navSearchLoading: false,
        _navSearchOpen: true
    });
};
const $9d3bcd1e03942af3$export$dfd1c1be4a27e9cb = function() {
    this.state.root.update({
        navSearchQuery: '',
        navSearchResults: [],
        _navSearchGrouped: [],
        _navSearchLoading: false,
        _navSearchOpen: false
    });
};
const $9d3bcd1e03942af3$export$d04c18bc3487b6ed = function(href) {
    const root = this.state.root;
    root.update({
        navSearchQuery: '',
        navSearchResults: [],
        _navSearchGrouped: [],
        _navSearchLoading: false,
        _navSearchOpen: false
    });
    const rootEl = this.getRoot();
    this.context?.utils?.router(href, rootEl, {}, {
        pushState: true,
        scrollToTop: true
    });
};

});




parcelRegister("9aGUO", function(module, exports) {

$parcel$export(module.exports, "adminLogs", () => $6ad656517b7114fb$export$70923180b48dae9a);
$parcel$export(module.exports, "AdminLogDay", () => $6ad656517b7114fb$export$95dc47629e2e2358);
$parcel$export(module.exports, "AdminLogGroup", () => $6ad656517b7114fb$export$caaadaa1b04c1a9a);
$parcel$export(module.exports, "AdminLogCalendar", () => $6ad656517b7114fb$export$59c0ad645191b1dc);
$parcel$export(module.exports, "AdminLogCalendarCell", () => $6ad656517b7114fb$export$9dfad21e541a2731);
$parcel$export(module.exports, "AdminLogRow", () => $6ad656517b7114fb$export$d0ed67ec38d5b0e0);
// /admin/logs — read-only audit log of every activity_events row across all
// users. Newest-first, paginated by simple limit. Rows are grouped by
// author so admins can scan per-person activity at a glance.

var $bfqVY = parcelRequire("bfqVY");
const $6ad656517b7114fb$var$_LIMIT = 200;
const $6ad656517b7114fb$var$_typeLabel = {
    standup: 'Standup',
    ticket_update: 'Ticket update',
    note_edit: 'Note edit',
    kb_edit: 'KB edit',
    meet_call: 'Meet call'
};
const $6ad656517b7114fb$var$_typeColor = (t)=>t === 'standup' ? 'green' : t === 'meet_call' ? 'purple' : t === 'kb_edit' || t === 'note_edit' ? 'cerulean' : 'blue';
const $6ad656517b7114fb$var$_shortTime = (ts)=>{
    try {
        return new Date(ts).toLocaleTimeString(undefined, {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        });
    } catch  {
        return '';
    }
};
const $6ad656517b7114fb$var$_shortDate = (ts)=>{
    try {
        const d = new Date(ts);
        const today = new Date();
        const sameDay = d.toDateString() === today.toDateString();
        if (sameDay) return 'Today';
        const yest = new Date();
        yest.setDate(today.getDate() - 1);
        if (d.toDateString() === yest.toDateString()) return 'Yesterday';
        const sameYear = d.getFullYear() === today.getFullYear();
        return d.toLocaleDateString(undefined, sameYear ? {
            month: 'short',
            day: 'numeric'
        } : {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
    } catch  {
        return '';
    }
};
const $6ad656517b7114fb$var$_refFor = (s)=>{
    const md = s.metadata || {};
    if (md.ticket_number) return `#${md.ticket_number}`;
    if (s.source_id) return String(s.source_id).slice(0, 8);
    return '';
};
const $6ad656517b7114fb$var$_titleFor = (s)=>{
    const md = s.metadata || {};
    return md.title || md.summary || md.body || s.source_table || '';
};
const $6ad656517b7114fb$var$_hrefFor = (s)=>{
    const md = s.metadata || {};
    switch(s.activity_type){
        case 'ticket_update':
            return md.ticket_number ? `/tickets/my?ticket=${md.ticket_number}` : '/tickets/my';
        case 'standup':
            return '/tickets/standups';
        case 'note_edit':
            return s.source_id ? `/documents/notes?id=${s.source_id}` : '/documents/notes';
        case 'kb_edit':
            return s.source_id ? `/documents/knowledge-base?id=${s.source_id}` : '/documents/knowledge-base';
        case 'meet_call':
            return s.source_id ? `/meet?room=${s.source_id}` : '/meet';
        default:
            return null;
    }
};
const $6ad656517b7114fb$var$_openRef = (el, s)=>{
    // ticket_update opens the ticket modal in-place (same UX as the ticket cards
    // elsewhere in the app); other types route to the owning page.
    if (s.activity_type === 'ticket_update') {
        const md = s.metadata || {};
        const tickets = s.root?.myTickets || [];
        const ticket = tickets.find((t)=>t.id === s.source_id || md.ticket_number && (t.number === md.ticket_number || t.id === md.ticket_number));
        if (ticket) {
            s.root?.update({
                selectedTicket: {
                    ...ticket
                }
            });
            return;
        }
    }
    const href = $6ad656517b7114fb$var$_hrefFor(s);
    if (!href) return;
    let root = el;
    while(root && !root.routes)root = root.parent;
    if (root) el.router(href, root);
};
const $6ad656517b7114fb$var$_dayKey = (r)=>r.occurred_on || (r.created_at ? r.created_at.slice(0, 10) : '');
const $6ad656517b7114fb$var$_groupByDayThenAuthor = (rows)=>{
    const days = new Map();
    for (const r of rows){
        const day = $6ad656517b7114fb$var$_dayKey(r);
        if (!days.has(day)) days.set(day, new Map());
        const authors = days.get(day);
        const email = r.user_email || "\u2014";
        if (!authors.has(email)) authors.set(email, []);
        authors.get(email).push(r);
    }
    return [
        ...days.entries()
    ].sort(([a], [b])=>b.localeCompare(a)).map(([day, authors])=>({
            _day: day,
            _authors: [
                ...authors.entries()
            ].map(([email, events])=>({
                    _email: email,
                    _events: events,
                    _count: events.length,
                    _totalScore: events.reduce((a, e)=>a + (e.score || 0), 0),
                    _latestAt: events.reduce((a, e)=>Math.max(a, new Date(e.created_at).getTime() || 0), 0)
                })).sort((a, b)=>b._latestAt - a._latestAt),
            _totalEvents: [
                ...authors.values()
            ].reduce((a, evs)=>a + evs.length, 0),
            _totalScore: [
                ...authors.values()
            ].reduce((a, evs)=>a + evs.reduce((s, e)=>s + (e.score || 0), 0), 0)
        }));
};
const $6ad656517b7114fb$export$70923180b48dae9a = {
    extends: 'AppPage',
    metadata: {
        title: 'Logs / Admin / Symbols Workspace'
    },
    onInit: (el, s)=>{
        if (!el.call('shouldRedirectNoPerm', s, 'admin.pages.read')) return;
        const root = el.call('findRouteRoot', el);
        if (root) el.router('/', root, {}, {
            pushState: true
        });
    },
    onCreate: async (el, s)=>{
        const root = s.root;
        if (!root) return;
        let email = root.currentUserEmail;
        if (!email) await new Promise((resolve)=>{
            let attempts = 0;
            const check = setInterval(()=>{
                email = root.currentUserEmail;
                if (email || ++attempts > 30) {
                    clearInterval(check);
                    resolve();
                }
            }, 200);
        });
        if (!email) return;
        try {
            // migrated 2026-04-27 to SDK route workspaceProject.auditLog/list
            const result = await (0, $bfqVY.getSDK)().execute('workspaceProject.auditLog', 'list', {
                filter: {},
                options: {
                    columns: 'id, user_email, activity_type, score, source_table, source_id, metadata, created_at, occurred_on',
                    order: {
                        created_at: 'desc'
                    },
                    limit: $6ad656517b7114fb$var$_LIMIT
                }
            });
            const data = Array.isArray(result) ? result : result?.data || result?.rows || result?.events || [];
            root.update({
                adminLogs: data || []
            });
        } catch (err) {
            console.error('[admin-logs]', err);
            root.update({
                adminLogs: []
            });
        }
    },
    AdminSidebar: {
        Bottom: {
            flow: 'y',
            gap: 'Z1',
            padding: 'A',
            borderTopWidth: '1px',
            borderTopStyle: 'solid',
            borderTopColor: 'line',
            SectionTitle: {
                tag: 'span',
                fontSize: 'Y1',
                fontWeight: '700',
                letterSpacing: '.04em',
                textTransform: 'uppercase',
                color: 'caption',
                text: 'Filter by date'
            },
            Calendar: {
                extends: 'AdminLogCalendar'
            },
            ClearBtn: {
                hide: (el, s)=>!s.root?._adminLogsSelectedDate,
                tag: 'button',
                type: 'button',
                padding: 'V Z1',
                round: 'Z',
                border: 'none',
                background: 'overlay',
                color: 'subtitle',
                fontSize: 'Y2',
                fontWeight: '600',
                cursor: 'pointer',
                alignSelf: 'flex-start',
                text: "\xd7 Clear date filter",
                ':hover': {
                    background: 'overlayStrong',
                    color: 'title'
                },
                onClick: (e, el, s)=>s.root?.update({
                        _adminLogsSelectedDate: null
                    })
            }
        }
    },
    // Scale-only admin power surface (cross-workspace audit trail).
    // Collab features stay free for any org; this page is paid.
    UpgradeGate: {
        extends: 'UpgradeBanner',
        requires: 'scale',
        hide: (el, s)=>el.call('isScale', s.root)
    },
    AdminMain: {
        extends: 'AppMain',
        padding: '0',
        hide: (el, s)=>!el.call('isScale', s.root),
        Header: {
            extends: 'PageHeader',
            LeftGroup: {
                Title: {
                    text: 'Activity Logs'
                }
            }
        },
        Body: {
            overflow: 'auto',
            padding: 'B',
            flow: 'y',
            gap: 'A',
            Intro: {
                tag: 'p',
                margin: '0',
                fontSize: 'Z2',
                color: 'caption',
                lineHeight: '1.5',
                text: (el, s)=>{
                    const rows = (s.root?.adminLogs || []).filter((r)=>!s.root?._adminLogsSelectedDate || $6ad656517b7114fb$var$_dayKey(r) === s.root._adminLogsSelectedDate);
                    const authors = new Set(rows.map((r)=>r.user_email)).size;
                    const scope = s.root?._adminLogsSelectedDate ? `on ${$6ad656517b7114fb$var$_shortDate(s.root._adminLogsSelectedDate)}` : 'across all dates';
                    return `${rows.length} events ${scope} from ${authors} ${authors === 1 ? 'person' : 'people'}.`;
                }
            },
            Empty: {
                hide: (el, s)=>{
                    const rows = (s.root?.adminLogs || []).filter((r)=>!s.root?._adminLogsSelectedDate || $6ad656517b7114fb$var$_dayKey(r) === s.root._adminLogsSelectedDate);
                    return rows.length > 0;
                },
                padding: 'A',
                color: 'caption',
                fontStyle: 'italic',
                text: 'No activity events for this filter.'
            },
            Days: {
                flow: 'y',
                gap: 'B',
                childExtends: 'AdminLogDay',
                childrenAs: 'state',
                children: (el, s)=>{
                    const rows = (s.root?.adminLogs || []).filter((r)=>!s.root?._adminLogsSelectedDate || $6ad656517b7114fb$var$_dayKey(r) === s.root._adminLogsSelectedDate);
                    return $6ad656517b7114fb$var$_groupByDayThenAuthor(rows);
                }
            }
        }
    }
};
const $6ad656517b7114fb$export$95dc47629e2e2358 = {
    flow: 'y',
    gap: 'Z1',
    DayHeader: {
        flow: 'x',
        align: 'baseline space-between',
        gap: 'Z',
        paddingBottom: 'V',
        borderBottomWidth: '1px',
        borderBottomStyle: 'solid',
        borderBottomColor: 'line',
        Title: {
            tag: 'h3',
            margin: '0',
            fontSize: 'A',
            fontWeight: '700',
            color: 'title',
            text: (el, s)=>$6ad656517b7114fb$var$_shortDate(s._day)
        },
        Stats: {
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            text: (el, s)=>`${s._totalEvents} event${s._totalEvents === 1 ? '' : 's'}`
        }
    },
    Authors: {
        flow: 'y',
        gap: 'Z1',
        childExtends: 'AdminLogGroup',
        childrenAs: 'state',
        children: (el, s)=>s._authors
    }
};
const $6ad656517b7114fb$export$caaadaa1b04c1a9a = {
    flow: 'y',
    round: 'Z2',
    background: 'overlay',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'line',
    overflow: 'hidden',
    Header: {
        flow: 'x',
        align: 'center space-between',
        gap: 'Z1',
        padding: 'Z A',
        background: 'overlayStrong',
        borderBottomWidth: '1px',
        borderBottomStyle: 'solid',
        borderBottomColor: 'line',
        LeftGroup: {
            flow: 'x',
            align: 'center left',
            gap: 'Z',
            Avatar: {
                width: 'A',
                height: 'A',
                round: '50%',
                background: (el, s)=>{
                    const me = el.call('findPerson', s._email);
                    return me?.avatar ? `url(${me.avatar}) center/cover` : `var(--color-blue)`;
                },
                flexShrink: '0'
            },
            Name: {
                tag: 'span',
                fontSize: 'Z2',
                fontWeight: '700',
                color: 'title',
                text: (el, s)=>{
                    const me = el.call('findPerson', s._email);
                    return me?.name || s._email;
                }
            },
            Email: {
                hide: (el, s)=>{
                    const me = el.call('findPerson', s._email);
                    return !me?.name;
                },
                tag: 'span',
                fontSize: 'Y2',
                color: 'caption',
                text: (el, s)=>s._email
            }
        },
        Stats: {
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            text: (el, s)=>`${s._count} event${s._count === 1 ? '' : 's'} \xb7 ${s._totalScore} pts`
        }
    },
    Events: {
        flow: 'y',
        childExtends: 'AdminLogRow',
        childrenAs: 'state',
        children: (el, s)=>s._events
    }
};
// ── Calendar (mini month view) ─────────────────────────────────────────
const $6ad656517b7114fb$var$_monthGrid = (year, month)=>{
    // Returns 6×7 = 42 cells for the month view (leading/trailing days included).
    const first = new Date(year, month, 1);
    const startDow = (first.getDay() + 6) % 7 // Monday-first
    ;
    const start = new Date(year, month, 1 - startDow);
    const cells = [];
    for(let i = 0; i < 42; i++){
        const d = new Date(start);
        d.setDate(start.getDate() + i);
        cells.push({
            _date: `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`,
            _day: d.getDate(),
            _inMonth: d.getMonth() === month
        });
    }
    return cells;
};
const $6ad656517b7114fb$export$59c0ad645191b1dc = {
    flow: 'y',
    gap: 'Z',
    padding: 'A',
    round: 'Z2',
    background: 'overlay',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'line',
    onCreate: (el, s)=>{
        const root = s.root;
        if (!root) return;
        const today = new Date();
        if (root._adminLogsCalYear == null || root._adminLogsCalMonth == null) root.update({
            _adminLogsCalYear: today.getFullYear(),
            _adminLogsCalMonth: today.getMonth()
        });
    },
    Nav: {
        flow: 'x',
        align: 'center space-between',
        gap: 'Z',
        Prev: {
            tag: 'button',
            type: 'button',
            width: 'A1',
            height: 'A1',
            round: 'Z',
            border: 'none',
            cursor: 'pointer',
            background: 'transparent',
            color: 'subtitle',
            fontSize: 'Z2',
            fontWeight: '700',
            text: "\u2039",
            ':hover': {
                background: 'overlayStrong',
                color: 'title'
            },
            onClick: (e, el, s)=>{
                const y = s.root?._adminLogsCalYear ?? new Date().getFullYear();
                const m = s.root?._adminLogsCalMonth ?? new Date().getMonth();
                const next = new Date(y, m - 1, 1);
                s.root?.update({
                    _adminLogsCalYear: next.getFullYear(),
                    _adminLogsCalMonth: next.getMonth()
                });
            }
        },
        Label: {
            tag: 'span',
            flex: '1',
            textAlign: 'center',
            fontSize: 'Z2',
            fontWeight: '700',
            color: 'title',
            text: (el, s)=>{
                const y = s.root?._adminLogsCalYear ?? new Date().getFullYear();
                const m = s.root?._adminLogsCalMonth ?? new Date().getMonth();
                return new Date(y, m, 1).toLocaleDateString(undefined, {
                    month: 'long',
                    year: 'numeric'
                });
            }
        },
        Next: {
            tag: 'button',
            type: 'button',
            width: 'A1',
            height: 'A1',
            round: 'Z',
            border: 'none',
            cursor: 'pointer',
            background: 'transparent',
            color: 'subtitle',
            fontSize: 'Z2',
            fontWeight: '700',
            text: "\u203A",
            ':hover': {
                background: 'overlayStrong',
                color: 'title'
            },
            onClick: (e, el, s)=>{
                const y = s.root?._adminLogsCalYear ?? new Date().getFullYear();
                const m = s.root?._adminLogsCalMonth ?? new Date().getMonth();
                const next = new Date(y, m + 1, 1);
                s.root?.update({
                    _adminLogsCalYear: next.getFullYear(),
                    _adminLogsCalMonth: next.getMonth()
                });
            }
        }
    },
    Dows: {
        display: 'grid',
        gridTemplateColumns: 'repeat(7, 1fr)',
        gap: 'X',
        fontSize: 'Y1',
        color: 'caption',
        fontWeight: '600',
        textAlign: 'center',
        M: {
            text: 'M'
        },
        T1: {
            text: 'T'
        },
        W: {
            text: 'W'
        },
        T2: {
            text: 'T'
        },
        F: {
            text: 'F'
        },
        Sa: {
            text: 'S'
        },
        Su: {
            text: 'S'
        }
    },
    Grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(7, 1fr)',
        gap: 'X',
        childExtends: 'AdminLogCalendarCell',
        childrenAs: 'state',
        children: (el, s)=>{
            const y = s.root?._adminLogsCalYear ?? new Date().getFullYear();
            const m = s.root?._adminLogsCalMonth ?? new Date().getMonth();
            return $6ad656517b7114fb$var$_monthGrid(y, m);
        }
    }
};
const $6ad656517b7114fb$export$9dfad21e541a2731 = {
    tag: 'button',
    type: 'button',
    aspectRatio: '1',
    round: 'Z',
    border: 'none',
    cursor: (el, s)=>s._inMonth ? 'pointer' : 'default',
    fontSize: 'Y2',
    fontWeight: '600',
    fontFamily: 'inherit',
    transition: 'background 100ms ease',
    background: (el, s)=>{
        if (s.root?._adminLogsSelectedDate === s._date) return 'blue';
        const has = (s.root?.adminLogs || []).some((r)=>$6ad656517b7114fb$var$_dayKey(r) === s._date);
        if (has) return 'blue.15';
        return 'transparent';
    },
    color: (el, s)=>{
        if (s.root?._adminLogsSelectedDate === s._date) return 'white';
        if (!s._inMonth) return 'caption';
        const has = (s.root?.adminLogs || []).some((r)=>$6ad656517b7114fb$var$_dayKey(r) === s._date);
        return has ? 'blue' : 'subtitle';
    },
    opacity: (el, s)=>s._inMonth ? '1' : '.4',
    ':hover': {
        background: (el, s)=>{
            if (s.root?._adminLogsSelectedDate === s._date) return 'blue';
            return s._inMonth ? 'overlayStrong' : 'transparent';
        }
    },
    text: (el, s)=>String(s._day),
    onClick: (e, el, s)=>{
        if (!s._inMonth) return;
        const cur = s.root?._adminLogsSelectedDate;
        s.root?.update({
            _adminLogsSelectedDate: cur === s._date ? null : s._date
        });
    }
};
const $6ad656517b7114fb$export$d0ed67ec38d5b0e0 = {
    flow: 'x',
    gap: 'Z1',
    align: 'baseline left',
    padding: 'Z A',
    fontFamily: 'mono',
    fontSize: 'Y2',
    lineHeight: '1.55',
    borderTopWidth: '1px',
    borderTopStyle: 'solid',
    borderTopColor: 'line',
    ':hover': {
        background: 'white.04'
    },
    When: {
        flow: 'y',
        gap: '0',
        flexShrink: '0',
        minWidth: 'D',
        Date: {
            tag: 'span',
            color: 'subtitle',
            fontWeight: '600',
            text: (el, s)=>$6ad656517b7114fb$var$_shortDate(s.occurred_on || s.created_at)
        },
        Time: {
            tag: 'span',
            color: 'caption',
            fontSize: 'Y1',
            text: (el, s)=>$6ad656517b7114fb$var$_shortTime(s.created_at)
        }
    },
    Type: {
        tag: 'span',
        flexShrink: '0',
        minWidth: 'C1',
        fontWeight: '700',
        color: (el, s)=>$6ad656517b7114fb$var$_typeColor(s.activity_type),
        text: (el, s)=>$6ad656517b7114fb$var$_typeLabel[s.activity_type] || s.activity_type || ''
    },
    Score: {
        tag: 'span',
        flexShrink: '0',
        minWidth: 'A2',
        textAlign: 'right',
        color: 'caption',
        fontWeight: '600',
        text: (el, s)=>`+${s.score || 0}`
    },
    Ref: {
        hide: (el, s)=>!$6ad656517b7114fb$var$_refFor(s),
        tag: 'button',
        type: 'button',
        flexShrink: '0',
        minWidth: 'B1',
        padding: '0',
        border: 'none',
        background: 'transparent',
        fontFamily: 'inherit',
        fontSize: 'inherit',
        fontWeight: '700',
        cursor: (el, s)=>$6ad656517b7114fb$var$_hrefFor(s) ? 'pointer' : 'default',
        color: (el, s)=>$6ad656517b7114fb$var$_typeColor(s.activity_type),
        textAlign: 'left',
        textDecoration: 'underline',
        textDecorationColor: 'transparent',
        transition: 'text-decoration-color 100ms ease',
        ':hover': {
            textDecorationColor: 'currentColor'
        },
        text: (el, s)=>$6ad656517b7114fb$var$_refFor(s),
        onClick: (e, el, s)=>{
            e.stopPropagation();
            $6ad656517b7114fb$var$_openRef(el, s);
        }
    },
    Detail: {
        tag: 'span',
        flex: '1',
        color: 'title',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        text: (el, s)=>$6ad656517b7114fb$var$_titleFor(s)
    }
};

});

parcelRegister("g7qnn", function(module, exports) {

$parcel$export(module.exports, "adminActivityScoring", () => $bbc1c28160e4379e$export$86aad05e240448f5);
$parcel$export(module.exports, "AdminActivityScoringRow", () => $bbc1c28160e4379e$export$16673c9d28d07522);
// /admin/activity-scoring — admin panel for tuning per-activity scores.
//
// Reads activity_scoring_config. Admin toggles `enabled` and edits `score`
// per activity type; clicking Save PATCHes each row that changed. Trigger-
// written events already use the current config row (score is snapshotted
// per-event, so edits affect future events without rewriting history).
const $bbc1c28160e4379e$var$_isRowDirty = (r)=>r._draftEnabled !== r.enabled || r._draftScore !== r.score;
const $bbc1c28160e4379e$var$_patchRow = (rows, type, patch)=>rows.map((r)=>r.activity_type === type ? {
            ...r,
            ...patch
        } : r);
const $bbc1c28160e4379e$var$_commitDraft = (root, rows)=>root?.update({
        activityScoring: rows,
        activityScoringDirty: rows.some($bbc1c28160e4379e$var$_isRowDirty)
    });
const $bbc1c28160e4379e$export$86aad05e240448f5 = {
    extends: 'AppPage',
    metadata: {
        title: 'Activity scoring / Admin / Symbols Workspace'
    },
    onInit: (el, s)=>{
        if (!el.call('shouldRedirectNoPerm', s, 'admin.pages.read')) return;
        const root = el.call('findRouteRoot', el);
        if (root) el.router('/', root, {}, {
            pushState: true
        });
    },
    fetch: {
        // migrated 2026-04-27 to entity route — workspaceProject.activity has a
        // dedicated `scoringConfig` op that returns the activity_scoring_config
        // rows. method: 'select' maps to the `list` op for that route.
        method: 'select',
        from: 'workspaceProject.activity.scoringConfig',
        as: '~/activityScoring',
        transform: (rows)=>({
                activityScoring: (rows || []).map((r)=>({
                        activity_type: r.activity_type,
                        enabled: r.enabled,
                        score: r.score,
                        label: r.label,
                        description: r.description || '',
                        // Draft values — edits flow here; Save writes them back and clears
                        _draftEnabled: r.enabled,
                        _draftScore: r.score
                    })),
                activityScoringDirty: false
            })
    },
    AdminSidebar: {},
    AdminMain: {
        extends: 'AppMain',
        padding: '0',
        Header: {
            extends: 'PageHeader',
            LeftGroup: {
                Title: {
                    text: 'Activity Scoring'
                }
            }
        },
        Body: {
            overflow: 'auto',
            padding: 'B',
            flow: 'y',
            gap: 'A',
            Intro: {
                tag: 'p',
                margin: '0',
                fontSize: 'Z2',
                color: 'caption',
                lineHeight: '1.5',
                maxWidth: 'L',
                text: "Each event below is scored when the underlying action happens (standup saved, ticket moved, note edited, KB doc updated, call analyzed). Scores are snapshot-per-event \u2014 editing a score changes future events only, never rewrites history. Disabling an activity stops emitting new events of that type."
            },
            Card: {
                flow: 'y',
                round: 'Z2',
                background: 'overlay',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: 'line',
                padding: '0',
                overflow: 'hidden',
                HeaderRow: {
                    flow: 'x',
                    align: 'center',
                    padding: 'Z1 A',
                    borderBottomWidth: '2px',
                    borderBottomStyle: 'solid',
                    borderBottomColor: 'line',
                    childProps: {
                        fontSize: 'Y1',
                        fontWeight: '700',
                        letterSpacing: '.04em',
                        textTransform: 'uppercase',
                        color: 'caption'
                    },
                    H01_Activity: {
                        flex: '2',
                        text: 'Activity'
                    },
                    H02_Description: {
                        flex: '3',
                        text: 'Description'
                    },
                    H03_Enabled: {
                        flex: '1',
                        textAlign: 'center',
                        text: 'Enabled'
                    },
                    H04_Score: {
                        flex: '1',
                        textAlign: 'right',
                        text: 'Score (pts)'
                    }
                },
                Rows: {
                    flow: 'y',
                    childExtends: 'AdminActivityScoringRow',
                    childrenAs: 'state',
                    children: (el, s)=>s.root?.activityScoring || []
                }
            },
            FooterRow: {
                flow: 'x',
                align: 'center space-between',
                gap: 'A',
                Status: {
                    tag: 'span',
                    fontSize: 'Y2',
                    color: (el, s)=>s.root?.activityScoringDirty ? 'yellow' : 'caption',
                    text: (el, s)=>{
                        if (s.root?._activityScoringSaving) return "Saving\u2026";
                        if (s.root?._activityScoringSaved) return 'Saved.';
                        if (s.root?.activityScoringDirty) return 'Unsaved changes';
                        return 'All changes saved.';
                    }
                },
                Actions: {
                    flow: 'x',
                    gap: 'Z',
                    ResetBtn: {
                        hide: (el, s)=>!s.root?.activityScoringDirty,
                        tag: 'button',
                        type: 'button',
                        text: 'Reset',
                        padding: 'Y A',
                        round: 'Y',
                        borderWidth: '1px',
                        borderColor: 'line',
                        borderStyle: 'solid',
                        background: 'transparent',
                        color: 'title',
                        cursor: 'pointer',
                        fontSize: 'Z2',
                        onClick: (e, el, s)=>{
                            const reset = (s.root?.activityScoring || []).map((r)=>({
                                    ...r,
                                    _draftEnabled: r.enabled,
                                    _draftScore: r.score
                                }));
                            s.root?.update({
                                activityScoring: reset,
                                activityScoringDirty: false
                            });
                        }
                    },
                    SaveBtn: {
                        tag: 'button',
                        type: 'button',
                        text: 'Save changes',
                        padding: 'Y A1',
                        round: 'Y',
                        border: 'none',
                        theme: 'primary',
                        cursor: 'pointer',
                        fontSize: 'Z2',
                        fontWeight: '600',
                        opacity: (el, s)=>s.root?.activityScoringDirty ? '1' : '.5',
                        pointerEvents: (el, s)=>s.root?.activityScoringDirty ? 'auto' : 'none',
                        onClick: async (e, el, s)=>{
                            const rows = s.root?.activityScoring || [];
                            const dirty = rows.filter($bbc1c28160e4379e$var$_isRowDirty);
                            if (!dirty.length) return;
                            s.root?.update({
                                _activityScoringSaving: true
                            });
                            const ok = await el.call('updateActivityScoring', dirty);
                            if (!ok) {
                                s.root?.update({
                                    _activityScoringSaving: false
                                });
                                return;
                            }
                            const dirtyByType = new Map(dirty.map((d)=>[
                                    d.activity_type,
                                    d
                                ]));
                            s.root?.update({
                                activityScoring: rows.map((r)=>{
                                    const d = dirtyByType.get(r.activity_type);
                                    return d ? {
                                        ...r,
                                        enabled: d._draftEnabled,
                                        score: d._draftScore
                                    } : r;
                                }),
                                activityScoringDirty: false,
                                _activityScoringSaving: false,
                                _activityScoringSaved: true
                            });
                            clearTimeout(el._savedTimer);
                            el._savedTimer = setTimeout(()=>s.root?.update({
                                    _activityScoringSaved: false
                                }), 2000);
                        },
                        onRemove: (el)=>clearTimeout(el._savedTimer)
                    }
                }
            }
        }
    }
};
const $bbc1c28160e4379e$export$16673c9d28d07522 = {
    flow: 'x',
    align: 'center',
    padding: 'Z1 A',
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: 'line',
    opacity: (el, s)=>s._draftEnabled ? '1' : '.5',
    Activity: {
        flex: '2',
        flow: 'y',
        gap: 'V',
        Label: {
            tag: 'span',
            fontSize: 'Z2',
            fontWeight: '700',
            color: 'title',
            text: (el, s)=>s.label || s.activity_type || ''
        },
        Slug: {
            tag: 'code',
            fontSize: 'Y1',
            color: 'caption',
            fontFamily: 'mono',
            text: (el, s)=>s.activity_type || ''
        }
    },
    Description: {
        flex: '3',
        padding: '0 A 0 0',
        fontSize: 'Y2',
        color: 'caption',
        lineHeight: '1.4',
        text: (el, s)=>s.description || ''
    },
    EnabledCell: {
        flex: '1',
        align: 'center center',
        Toggle: {
            Input: {
                checked: (el, s)=>!!s._draftEnabled,
                ':checked + div': {
                    background: 'green',
                    justifyContent: 'flex-end'
                },
                onChange: (e, el, s)=>{
                    const rows = $bbc1c28160e4379e$var$_patchRow(s.root?.activityScoring || [], s.activity_type, {
                        _draftEnabled: !s._draftEnabled
                    });
                    $bbc1c28160e4379e$var$_commitDraft(s.root, rows);
                }
            }
        }
    },
    ScoreCell: {
        flex: '1',
        align: 'center right',
        Input: {
            tag: 'input',
            type: 'number',
            min: '0',
            max: '100',
            step: '1',
            width: 'C1',
            padding: 'Y Z',
            round: 'Y',
            borderWidth: '1px',
            borderColor: 'line',
            borderStyle: 'solid',
            background: 'overlayStrong',
            color: 'title',
            fontSize: 'Z2',
            textAlign: 'right',
            value: (el, s)=>String(s._draftScore ?? s.score ?? 0),
            onCreate: (el, s)=>{
                el.node.value = String(s._draftScore ?? s.score ?? 0);
            },
            onInput: (e, el, s)=>{
                const n = parseInt(el.node.value, 10);
                const next = Number.isFinite(n) ? Math.max(0, Math.min(100, n)) : 0;
                const rows = $bbc1c28160e4379e$var$_patchRow(s.root?.activityScoring || [], s.activity_type, {
                    _draftScore: next
                });
                $bbc1c28160e4379e$var$_commitDraft(s.root, rows);
            }
        }
    }
};

});


parcelRegister("chPUZ", function(module, exports) {

$parcel$export(module.exports, "WorkspaceSwitcherItem", () => $8f1f5870239dbc31$export$67852071a44b6476);
$parcel$export(module.exports, "WorkspaceSwitcherDropdown", () => $8f1f5870239dbc31$export$7c90375d5654b95b);
$parcel$export(module.exports, "WorkspaceSwitcher", () => $8f1f5870239dbc31$export$8c6190b01e811f3e);
// WorkspaceSwitcher — shows the current workspace name and lets the user switch.
// Progressive disclosure: hidden when the user has only one workspace.
//
// v3.14 rules: flat access, el.call for registered functions, design tokens only.
const $8f1f5870239dbc31$export$67852071a44b6476 = {
    extends: 'Button',
    flow: 'x',
    align: 'center left',
    gap: 'Z1',
    padding: 'Z1 A',
    round: 'Z',
    cursor: 'pointer',
    theme: 'tertiary',
    width: '100%',
    Icon: {
        name: 'layers',
        boxSize: 'A A'
    },
    Name: {
        tag: 'span',
        fontSize: 'Z2',
        text: (el, s)=>s.name || s.title || ''
    },
    onClick: (e, el, s)=>{
        e.preventDefault();
        let dropdown = el.parent;
        while(dropdown && !dropdown.WorkspaceSwitcherDropdown)dropdown = dropdown.parent;
        if (dropdown?.WorkspaceSwitcherDropdown) dropdown.WorkspaceSwitcherDropdown.update?.({
            style: {
                opacity: '0',
                visibility: 'hidden',
                pointerEvents: 'none'
            }
        });
        el.call('switchWorkspace', s.root, el.context?.sdk, el.context?.queryClient, s.id);
        localStorage.setItem('activeWorkspace', s.id);
    }
};
const $8f1f5870239dbc31$export$7c90375d5654b95b = {
    position: 'absolute',
    top: '100%',
    left: '0',
    zIndex: '100',
    minWidth: 'G',
    padding: 'Z',
    round: 'A',
    theme: 'dialog',
    boxShadow: '0 A Z -Z black.2',
    opacity: '0',
    visibility: 'hidden',
    pointerEvents: 'none',
    childExtends: 'WorkspaceSwitcherItem',
    childrenAs: 'state',
    children: (el, s)=>s.root?.workspaces || []
};
const $8f1f5870239dbc31$export$8c6190b01e811f3e = {
    position: 'relative',
    // Progressive disclosure — hide when only one workspace
    hide: (el, s)=>!s.root?.workspaces || s.root.workspaces.length <= 1,
    Trigger: {
        extends: 'Button',
        flow: 'x',
        align: 'center left',
        gap: 'Z1',
        padding: 'Z1 A',
        round: 'Z',
        cursor: 'pointer',
        theme: 'tertiary',
        Icon: {
            name: 'layers',
            boxSize: 'A A'
        },
        Name: {
            tag: 'span',
            fontSize: 'Z2',
            text: (el, s)=>s.root?.workspace?.name || 'Select workspace'
        },
        ChevronIcon: {
            name: 'chevronDown',
            boxSize: 'A A'
        },
        onClick: (e, el)=>{
            e.stopPropagation();
            const switcher = el.parent;
            const dropdown = switcher?.WorkspaceSwitcherDropdown;
            if (!dropdown) return;
            const next = !dropdown.forcedVisible;
            dropdown.forcedVisible = next;
            dropdown.update?.({
                style: {
                    opacity: next ? '1' : '0',
                    visibility: next ? 'visible' : 'hidden',
                    pointerEvents: next ? 'auto' : 'none'
                }
            });
        }
    },
    WorkspaceSwitcherDropdown: {}
};

});

parcelRegister("i6dQ8", function(module, exports) {

$parcel$export(module.exports, "WorkspaceProjectSwitcherItem", () => $d2d385de1bb5c830$export$d5636bf216a1f735);
$parcel$export(module.exports, "WorkspaceProjectSwitcherDropdown", () => $d2d385de1bb5c830$export$bcd5239bd16b84f3);
$parcel$export(module.exports, "WorkspaceProjectSwitcher", () => $d2d385de1bb5c830$export$c434f4a5245e28d7);
// WorkspaceProjectSwitcher — shows the current workspace project and lets the
// user switch between workspace projects (activity trackers).
// Progressive disclosure: hidden when the user has only one workspace project.
//
// v3.14 rules: flat access, el.call for registered functions, design tokens only.
const $d2d385de1bb5c830$export$d5636bf216a1f735 = {
    extends: 'Button',
    flow: 'x',
    align: 'center left',
    gap: 'Z1',
    padding: 'Z1 A',
    round: 'Z',
    cursor: 'pointer',
    theme: 'tertiary',
    width: '100%',
    Icon: {
        name: 'check',
        boxSize: 'A A'
    },
    Name: {
        tag: 'span',
        fontSize: 'Z2',
        text: (el, s)=>s.name || s.title || ''
    },
    onClick: (e, el, s)=>{
        e.preventDefault();
        let dropdown = el.parent;
        while(dropdown && !dropdown.WorkspaceProjectSwitcherDropdown)dropdown = dropdown.parent;
        if (dropdown?.WorkspaceProjectSwitcherDropdown) dropdown.WorkspaceProjectSwitcherDropdown.update?.({
            style: {
                opacity: '0',
                visibility: 'hidden',
                pointerEvents: 'none'
            }
        });
        el.call('switchWorkspaceProject', s.root, el.context?.sdk, el.context?.queryClient, s.id);
        localStorage.setItem('activeWorkspaceProject', s.id);
    }
};
const $d2d385de1bb5c830$export$bcd5239bd16b84f3 = {
    position: 'absolute',
    top: '100%',
    left: '0',
    zIndex: '100',
    minWidth: 'G',
    padding: 'Z',
    round: 'A',
    theme: 'dialog',
    boxShadow: '0 A Z -Z black.2',
    opacity: '0',
    visibility: 'hidden',
    pointerEvents: 'none',
    childExtends: 'WorkspaceProjectSwitcherItem',
    childrenAs: 'state',
    children: (el, s)=>s.root?.workspaceProjects || []
};
const $d2d385de1bb5c830$export$c434f4a5245e28d7 = {
    position: 'relative',
    // Progressive disclosure — hide when only one workspace project
    hide: (el, s)=>!s.root?.workspaceProjects || s.root.workspaceProjects.length <= 1,
    Trigger: {
        extends: 'Button',
        flow: 'x',
        align: 'center left',
        gap: 'Z1',
        padding: 'Z1 A',
        round: 'Z',
        cursor: 'pointer',
        theme: 'tertiary',
        Icon: {
            name: 'check',
            boxSize: 'A A'
        },
        Name: {
            tag: 'span',
            fontSize: 'Z2',
            text: (el, s)=>s.root?.workspaceProject?.name || 'Select project'
        },
        ChevronIcon: {
            name: 'chevronDown',
            boxSize: 'A A'
        },
        onClick: (e, el)=>{
            e.stopPropagation();
            const switcher = el.parent;
            const dropdown = switcher?.WorkspaceProjectSwitcherDropdown;
            if (!dropdown) return;
            const next = !dropdown.forcedVisible;
            dropdown.forcedVisible = next;
            dropdown.update?.({
                style: {
                    opacity: next ? '1' : '0',
                    visibility: next ? 'visible' : 'hidden',
                    pointerEvents: next ? 'auto' : 'none'
                }
            });
        }
    },
    WorkspaceProjectSwitcherDropdown: {}
};

});

parcelRegister("1hUNq", function(module, exports) {

$parcel$export(module.exports, "LangSwitcherItem", () => $0f036f87f19ab76e$export$dde008690a1a9e35);
$parcel$export(module.exports, "LangSwitcherDropdown", () => $0f036f87f19ab76e$export$7edb7690b5690b3c);
$parcel$export(module.exports, "LangSwitcher", () => $0f036f87f19ab76e$export$7c78b168673b6051);
// LangSwitcher — lets the user switch the interface language.
// Shows current language code; calls setLang via el.call.
//
// v3.14 rules: flat access, el.call for registered functions, design tokens only.
const $0f036f87f19ab76e$var$SUPPORTED_LANGS = [
    {
        code: 'en',
        label: 'English'
    },
    {
        code: 'de',
        label: 'Deutsch'
    },
    {
        code: 'fr',
        label: "Fran\xe7ais"
    },
    {
        code: 'es',
        label: "Espa\xf1ol"
    }
];
const $0f036f87f19ab76e$export$dde008690a1a9e35 = {
    extends: 'Button',
    flow: 'x',
    align: 'center left',
    gap: 'Z1',
    padding: 'Z1 A',
    round: 'Z',
    cursor: 'pointer',
    theme: 'tertiary',
    width: '100%',
    Code: {
        tag: 'span',
        fontSize: 'Y2',
        fontWeight: '600',
        color: 'caption',
        width: 'B',
        text: (el, s)=>(s.code || '').toUpperCase()
    },
    Label: {
        tag: 'span',
        fontSize: 'Z2',
        text: (el, s)=>s.label || ''
    },
    onClick: (e, el, s)=>{
        e.preventDefault();
        let dropdown = el.parent;
        while(dropdown && !dropdown.LangSwitcherDropdown)dropdown = dropdown.parent;
        if (dropdown?.LangSwitcherDropdown) dropdown.LangSwitcherDropdown.update?.({
            style: {
                opacity: '0',
                visibility: 'hidden',
                pointerEvents: 'none'
            }
        });
        el.call('setLang', s.code);
    }
};
const $0f036f87f19ab76e$export$7edb7690b5690b3c = {
    position: 'absolute',
    top: '100%',
    right: '0',
    zIndex: '100',
    minWidth: 'G',
    padding: 'Z',
    round: 'A',
    theme: 'dialog',
    boxShadow: '0 A Z -Z black.2',
    opacity: '0',
    visibility: 'hidden',
    pointerEvents: 'none',
    childExtends: 'LangSwitcherItem',
    childrenAs: 'state',
    children: $0f036f87f19ab76e$var$SUPPORTED_LANGS
};
const $0f036f87f19ab76e$export$7c78b168673b6051 = {
    position: 'relative',
    Trigger: {
        extends: 'Button',
        padding: 'Z1 A',
        round: 'Z',
        cursor: 'pointer',
        theme: 'tertiary',
        title: 'Change language',
        Code: {
            tag: 'span',
            fontSize: 'Y2',
            fontWeight: '600',
            text: (el, s)=>(s.root?.lang || 'en').toUpperCase()
        },
        onClick: (e, el)=>{
            e.stopPropagation();
            const switcher = el.parent;
            const dropdown = switcher?.LangSwitcherDropdown;
            if (!dropdown) return;
            const next = !dropdown.forcedVisible;
            dropdown.forcedVisible = next;
            dropdown.update?.({
                style: {
                    opacity: next ? '1' : '0',
                    visibility: next ? 'visible' : 'hidden',
                    pointerEvents: next ? 'auto' : 'none'
                }
            });
        }
    },
    LangSwitcherDropdown: {}
};

});

parcelRegister("5wmft", function(module, exports) {

$parcel$export(module.exports, "ThemeToggle", () => $40513304d8867891$export$173e0a822059eddc);
// ThemeToggle — cycles through 'auto' | 'light' | 'dark' theme modes.
// Applies via changeGlobalTheme (never direct data-theme mutation).
//
// v3.14 rules: flat access, el.call for registered functions, design tokens only.
// Per DESIGN domain knowledge: never mutate data-theme from project code;
// use changeGlobalTheme(name) from scratch.
const $40513304d8867891$var$MODES = [
    'auto',
    'light',
    'dark'
];
const $40513304d8867891$var$_modeIcon = (mode)=>{
    if (mode === 'light') return 'sun';
    if (mode === 'dark') return 'moon';
    return 'contrast' // auto
    ;
};
const $40513304d8867891$var$_nextMode = (current)=>{
    const idx = $40513304d8867891$var$MODES.indexOf(current);
    return $40513304d8867891$var$MODES[(idx + 1) % $40513304d8867891$var$MODES.length];
};
const $40513304d8867891$export$173e0a822059eddc = {
    extends: 'Button',
    padding: 'Z1',
    round: '50%',
    cursor: 'pointer',
    theme: 'tertiary',
    title: (el, s)=>`Theme: ${s.root?.themeMode || 'auto'}`,
    Icon: {
        name: (el, s)=>$40513304d8867891$var$_modeIcon(s.root?.themeMode || 'auto'),
        boxSize: 'A A'
    },
    onClick: (e, el, s)=>{
        e.preventDefault();
        const current = s.root?.themeMode || 'auto';
        const next = $40513304d8867891$var$_nextMode(current);
        // Update state
        if (s.root) s.root.themeMode = next;
        // Persist
        localStorage.setItem('themeMode', next);
        // Signal cross-tab — storage event fires in OTHER tabs only; same tab
        // applies via state mutation above.
        localStorage.setItem('themeMode', next);
        // Apply to document via framework-approved path
        el.call('changeGlobalTheme', next);
    }
};

});

parcelRegister("hvuwl", function(module, exports) {

$parcel$export(module.exports, "NotificationBell", () => $cbed01b789314a29$export$da43598a51abd858);
// NotificationBell — shows unread notification count badge.
// Subscribes to notifications.unread via the fetch plugin.
// Navigates to /inbox on click.
//
// v3.14 rules: flat access, el.router for navigation, design tokens only.
const $cbed01b789314a29$export$da43598a51abd858 = {
    extends: 'Button',
    position: 'relative',
    padding: 'Z1',
    round: '50%',
    cursor: 'pointer',
    theme: 'tertiary',
    title: 'Notifications',
    // Declarative subscription — fetch plugin routes through SDK.
    // Result lands at ~/notificationsUnread on the root state.
    // migrated 2026-04-27 to entity route workspaceProject.realtime.notifications.
    fetch: {
        from: 'workspaceProject.realtime.notifications',
        method: 'subscribe',
        params: (el, s)=>({
                userEmail: s.root?.currentUserEmail
            }),
        as: '~/notificationsUnread'
    },
    Icon: {
        name: 'bell',
        boxSize: 'A A'
    },
    UnreadBadge: {
        // Hide badge when no unread notifications
        hide: (el, s)=>!s.root?.notificationsUnread || s.root.notificationsUnread <= 0,
        position: 'absolute',
        top: '0',
        right: '0',
        minWidth: 'Y',
        height: 'Y',
        round: '50%',
        background: 'red',
        align: 'center center',
        padding: '0 V',
        pointerEvents: 'none',
        fontSize: 'Y2',
        fontWeight: '600',
        color: 'white',
        text: (el, s)=>{
            const count = s.root?.notificationsUnread || 0;
            return count > 99 ? '99+' : String(count);
        }
    },
    onClick: (e, el)=>{
        e.preventDefault();
        el.router('/inbox', el.getRoot());
    }
};

});


parcelRegister("iYOcw", function(module, exports) {

$parcel$export(module.exports, "bootShell", () => (parcelRequire("9XTDn")).bootShell);
$parcel$export(module.exports, "registerSdkAdapter", () => (parcelRequire("5RqIx")).registerSdkAdapter);
$parcel$export(module.exports, "setLang", () => (parcelRequire("hUF7p")).setLang);
$parcel$export(module.exports, "loadI18nNamespace", () => (parcelRequire("f0cDW")).loadI18nNamespace);
$parcel$export(module.exports, "dropNonEnglishCache", () => (parcelRequire("f0cDW")).dropNonEnglishCache);
$parcel$export(module.exports, "getLoadedNamespaces", () => (parcelRequire("f0cDW")).getLoadedNamespaces);
$parcel$export(module.exports, "mergeAllNamespaces", () => (parcelRequire("f0cDW")).mergeAllNamespaces);

var $fMRch = parcelRequire("fMRch");

var $hLVac = parcelRequire("hLVac");

var $co3Xi = parcelRequire("co3Xi");

var $arXLg = parcelRequire("arXLg");

var $5Mq8K = parcelRequire("5Mq8K");

var $ktG5J = parcelRequire("ktG5J");

var $fTvdh = parcelRequire("fTvdh");

var $iL46s = parcelRequire("iL46s");

var $kjVu5 = parcelRequire("kjVu5");

var $4U3HQ = parcelRequire("4U3HQ");

var $7iKED = parcelRequire("7iKED");

var $iGUve = parcelRequire("iGUve");

var $1Qa8y = parcelRequire("1Qa8y");

var $6jBBh = parcelRequire("6jBBh");

var $kfpS5 = parcelRequire("kfpS5");

var $g8b33 = parcelRequire("g8b33");

var $am94e = parcelRequire("am94e");

var $b5PxY = parcelRequire("b5PxY");

var $dLL0m = parcelRequire("dLL0m");

var $klZWn = parcelRequire("klZWn");

var $2bGRW = parcelRequire("2bGRW");

var $avxjj = parcelRequire("avxjj");

var $flebV = parcelRequire("flebV");

var $3eWAd = parcelRequire("3eWAd");

var $cbd5h = parcelRequire("cbd5h");

var $lT7Gj = parcelRequire("lT7Gj");

var $6IYAb = parcelRequire("6IYAb");

var $j5M0h = parcelRequire("j5M0h");

var $dELsh = parcelRequire("dELsh");

var $8dTIl = parcelRequire("8dTIl");

var $aJaZ5 = parcelRequire("aJaZ5");

var $eaFBF = parcelRequire("eaFBF");

var $kZODV = parcelRequire("kZODV");

var $kNLWG = parcelRequire("kNLWG");

var $kDfBU = parcelRequire("kDfBU");

var $hJQzL = parcelRequire("hJQzL");

var $17kPZ = parcelRequire("17kPZ");

var $3BwSQ = parcelRequire("3BwSQ");

var $2LZpJ = parcelRequire("2LZpJ");

var $a71rn = parcelRequire("a71rn");

var $aOpgb = parcelRequire("aOpgb");

var $bpTkZ = parcelRequire("bpTkZ");

var $h1fI3 = parcelRequire("h1fI3");

var $bZEG1 = parcelRequire("bZEG1");

var $9b1pZ = parcelRequire("9b1pZ");

var $9UhRW = parcelRequire("9UhRW");

var $bIY7U = parcelRequire("bIY7U");

var $8bnXk = parcelRequire("8bnXk");

var $1exXd = parcelRequire("1exXd");

var $fZvot = parcelRequire("fZvot");

var $lRwgv = parcelRequire("lRwgv");

var $6niK6 = parcelRequire("6niK6");

var $eIsev = parcelRequire("eIsev");

var $99POm = parcelRequire("99POm");

var $6dPl3 = parcelRequire("6dPl3");

var $68W3F = parcelRequire("68W3F");

var $eFolT = parcelRequire("eFolT");

var $ddvty = parcelRequire("ddvty");

var $dG204 = parcelRequire("dG204");

var $cCFJt = parcelRequire("cCFJt");

var $jeUjJ = parcelRequire("jeUjJ");

var $5NW1c = parcelRequire("5NW1c");

var $88hZW = parcelRequire("88hZW");

var $999Gp = parcelRequire("999Gp");

var $i65Lz = parcelRequire("i65Lz");

var $dmv7F = parcelRequire("dmv7F");

var $k1Fdq = parcelRequire("k1Fdq");

var $fs6XN = parcelRequire("fs6XN");

var $k5qRy = parcelRequire("k5qRy");

var $ebqFT = parcelRequire("ebqFT");

var $a9CTm = parcelRequire("a9CTm");

var $dXZDz = parcelRequire("dXZDz");

var $kqhVa = parcelRequire("kqhVa");

var $ja6ZV = parcelRequire("ja6ZV");

var $jgbKP = parcelRequire("jgbKP");

var $ao3Fg = parcelRequire("ao3Fg");

var $kBoxR = parcelRequire("kBoxR");

var $bHCw7 = parcelRequire("bHCw7");

var $fvXa3 = parcelRequire("fvXa3");

var $iMsdo = parcelRequire("iMsdo");

var $28V5M = parcelRequire("28V5M");

var $lCIpp = parcelRequire("lCIpp");

var $jRYrT = parcelRequire("jRYrT");

var $cXc1w = parcelRequire("cXc1w");

var $14r18 = parcelRequire("14r18");

var $4sF1R = parcelRequire("4sF1R");

var $k7l6l = parcelRequire("k7l6l");

var $gv7AI = parcelRequire("gv7AI");

var $f5bmg = parcelRequire("f5bmg");

var $84qmQ = parcelRequire("84qmQ");

var $744AV = parcelRequire("744AV");

var $eZ6La = parcelRequire("eZ6La");

var $bdXMy = parcelRequire("bdXMy");

var $9XTDn = parcelRequire("9XTDn");

var $5RqIx = parcelRequire("5RqIx");

var $hUF7p = parcelRequire("hUF7p");

var $f0cDW = parcelRequire("f0cDW");

var $4dRLV = parcelRequire("4dRLV");
$parcel$exportWildcard(module.exports, $fMRch);
$parcel$exportWildcard(module.exports, $hLVac);
$parcel$exportWildcard(module.exports, $co3Xi);
$parcel$exportWildcard(module.exports, $arXLg);
$parcel$exportWildcard(module.exports, $5Mq8K);
$parcel$exportWildcard(module.exports, $ktG5J);
$parcel$exportWildcard(module.exports, $fTvdh);
$parcel$exportWildcard(module.exports, $iL46s);
$parcel$exportWildcard(module.exports, $kjVu5);
$parcel$exportWildcard(module.exports, $4U3HQ);
$parcel$exportWildcard(module.exports, $7iKED);
$parcel$exportWildcard(module.exports, $iGUve);
$parcel$exportWildcard(module.exports, $1Qa8y);
$parcel$exportWildcard(module.exports, $6jBBh);
$parcel$exportWildcard(module.exports, $kfpS5);
$parcel$exportWildcard(module.exports, $g8b33);
$parcel$exportWildcard(module.exports, $am94e);
$parcel$exportWildcard(module.exports, $b5PxY);
$parcel$exportWildcard(module.exports, $dLL0m);
$parcel$exportWildcard(module.exports, $klZWn);
$parcel$exportWildcard(module.exports, $2bGRW);
$parcel$exportWildcard(module.exports, $avxjj);
$parcel$exportWildcard(module.exports, $flebV);
$parcel$exportWildcard(module.exports, $3eWAd);
$parcel$exportWildcard(module.exports, $cbd5h);
$parcel$exportWildcard(module.exports, $lT7Gj);
$parcel$exportWildcard(module.exports, $6IYAb);
$parcel$exportWildcard(module.exports, $j5M0h);
$parcel$exportWildcard(module.exports, $dELsh);
$parcel$exportWildcard(module.exports, $8dTIl);
$parcel$exportWildcard(module.exports, $aJaZ5);
$parcel$exportWildcard(module.exports, $eaFBF);
$parcel$exportWildcard(module.exports, $kZODV);
$parcel$exportWildcard(module.exports, $kNLWG);
$parcel$exportWildcard(module.exports, $kDfBU);
$parcel$exportWildcard(module.exports, $hJQzL);
$parcel$exportWildcard(module.exports, $17kPZ);
$parcel$exportWildcard(module.exports, $3BwSQ);
$parcel$exportWildcard(module.exports, $2LZpJ);
$parcel$exportWildcard(module.exports, $a71rn);
$parcel$exportWildcard(module.exports, $aOpgb);
$parcel$exportWildcard(module.exports, $bpTkZ);
$parcel$exportWildcard(module.exports, $h1fI3);
$parcel$exportWildcard(module.exports, $bZEG1);
$parcel$exportWildcard(module.exports, $9b1pZ);
$parcel$exportWildcard(module.exports, $9UhRW);
$parcel$exportWildcard(module.exports, $bIY7U);
$parcel$exportWildcard(module.exports, $8bnXk);
$parcel$exportWildcard(module.exports, $1exXd);
$parcel$exportWildcard(module.exports, $fZvot);
$parcel$exportWildcard(module.exports, $lRwgv);
$parcel$exportWildcard(module.exports, $6niK6);
$parcel$exportWildcard(module.exports, $eIsev);
$parcel$exportWildcard(module.exports, $99POm);
$parcel$exportWildcard(module.exports, $6dPl3);
$parcel$exportWildcard(module.exports, $68W3F);
$parcel$exportWildcard(module.exports, $eFolT);
$parcel$exportWildcard(module.exports, $ddvty);
$parcel$exportWildcard(module.exports, $dG204);
$parcel$exportWildcard(module.exports, $cCFJt);
$parcel$exportWildcard(module.exports, $jeUjJ);
$parcel$exportWildcard(module.exports, $5NW1c);
$parcel$exportWildcard(module.exports, $88hZW);
$parcel$exportWildcard(module.exports, $999Gp);
$parcel$exportWildcard(module.exports, $i65Lz);
$parcel$exportWildcard(module.exports, $dmv7F);
$parcel$exportWildcard(module.exports, $k1Fdq);
$parcel$exportWildcard(module.exports, $fs6XN);
$parcel$exportWildcard(module.exports, $k5qRy);
$parcel$exportWildcard(module.exports, $ebqFT);
$parcel$exportWildcard(module.exports, $a9CTm);
$parcel$exportWildcard(module.exports, $dXZDz);
$parcel$exportWildcard(module.exports, $kqhVa);
$parcel$exportWildcard(module.exports, $ja6ZV);
$parcel$exportWildcard(module.exports, $jgbKP);
$parcel$exportWildcard(module.exports, $ao3Fg);
$parcel$exportWildcard(module.exports, $kBoxR);
$parcel$exportWildcard(module.exports, $bHCw7);
$parcel$exportWildcard(module.exports, $fvXa3);
$parcel$exportWildcard(module.exports, $iMsdo);
$parcel$exportWildcard(module.exports, $28V5M);
$parcel$exportWildcard(module.exports, $lCIpp);
$parcel$exportWildcard(module.exports, $jRYrT);
$parcel$exportWildcard(module.exports, $cXc1w);
$parcel$exportWildcard(module.exports, $14r18);
$parcel$exportWildcard(module.exports, $4sF1R);
$parcel$exportWildcard(module.exports, $k7l6l);
$parcel$exportWildcard(module.exports, $gv7AI);
$parcel$exportWildcard(module.exports, $f5bmg);
$parcel$exportWildcard(module.exports, $84qmQ);
$parcel$exportWildcard(module.exports, $744AV);
$parcel$exportWildcard(module.exports, $eZ6La);
$parcel$exportWildcard(module.exports, $bdXMy);
$parcel$exportWildcard(module.exports, $4dRLV);

});
parcelRegister("fMRch", function(module, exports) {

$parcel$export(module.exports, "fetchNpmPackage", () => $b7e49a8cffb12264$export$42279cf855f851c7);
const $b7e49a8cffb12264$export$42279cf855f851c7 = async function fetchNpmPackage(name, schemaVersion) {
    await window.fetch(`https://registry.npmjs.com/-/v1/search?text=${name}@${schemaVersion}&size=1`).then(async (res)=>{
        const { objects: objects } = await res.json();
        const [pkg] = objects || [];
        if (!pkg) return;
        const { name: pkgName, version: pkgVersion } = pkg;
        if (pkgName === this.state.name) this.state.replace({
            name: pkgName,
            version: pkgVersion,
            schemaVersion: schemaVersion
        });
    }).catch(()=>{
        if (name === this.state.name) this.state.replace({
            version: null,
            isLoadingPackages: false
        });
    });
};

});

parcelRegister("hLVac", function(module, exports) {

$parcel$export(module.exports, "resolveScope", () => (parcelRequire("dwZLd")).resolveScope);
// Re-exports the integration scope resolver as a project-registered
// function so any page can pick it up via `el.call('resolveScope', ...)`
// without a file import.
//
// Reads { scopeType, scopeId } off an integration draft state, supplying
// defaults. Used by every integration configure form (governance admin
// pages + marketplace install flow) so scope handling stays centralized.

var $dwZLd = parcelRequire("dwZLd");

});

parcelRegister("co3Xi", function(module, exports) {

$parcel$export(module.exports, "reloadIntegrationHub", () => $904acb60f42e81e9$export$f0dbdf3dafb604f3);
// Registered function — host pages expose this so the shared
// configure form can trigger a catalogue refresh after save / delete.
//
// Default implementation: re-fetch `loadIntegrationCatalogue(orgId)` and
// write the result onto `root._integrationHub`. Pages that need custom
// reload logic can override by redefining the function in their own
// functions/ directory.

var $e92gD = parcelRequire("e92gD");
const $904acb60f42e81e9$export$f0dbdf3dafb604f3 = async function() {
    const root = this?.state?.root || this;
    if (!root) return;
    const orgId = root?.jwtClaims?.workspace_org_id;
    if (!orgId) return;
    try {
        const data = await (0, $e92gD.loadIntegrationCatalogue)(orgId);
        root.update({
            _integrationHub: data
        });
    } catch  {
    // Silent fail — existing state keeps rendering.
    }
};

});

parcelRegister("5Mq8K", function(module, exports) {

$parcel$export(module.exports, "sameOriginTop", () => $4355b657140607f4$export$eba84fbb0d49c233);
// Returns the topmost same-origin ancestor window.
// Standalone app → window.top. Cross-origin embed → the topmost window
// still accessible without triggering SecurityError. Returns null in non-browser.
const $4355b657140607f4$export$eba84fbb0d49c233 = ()=>{
    if (typeof window === 'undefined') return null;
    let w = window;
    while(w.parent && w.parent !== w)try {
        w.parent.document;
        w = w.parent;
    } catch  {
        break;
    }
    return w;
};

});

parcelRegister("ktG5J", function(module, exports) {

$parcel$export(module.exports, "uploadFile", () => $ee872a91536e2574$export$a5575dbeeffdad98);
const $ee872a91536e2574$export$a5575dbeeffdad98 = async function uploadFile(contents) {
    try {
        const splitName = contents.name.split('.');
        const format = splitName[splitName.length - 1];
        if (!this.call('validateFormat', format)) {
            this.state.update({
                errorMessage: `Not allowed file type: ${format}`
            });
            return;
        }
        const res = await this.sdk.uploadFile(contents);
        this.state.replace({
            key: this.state.key || contents.name,
            content: res,
            format: format
        });
    } catch (error) {
        this.call('openNotification', {
            title: 'Error message',
            message: `${error.message}`,
            type: 'error'
        });
    }
};

});

parcelRegister("fTvdh", function(module, exports) {

$parcel$export(module.exports, "getLastLocationPath", () => $02fc74751a29e6de$export$fc729c47e81baa99);
const $02fc74751a29e6de$export$fc729c47e81baa99 = function getLastLocationPath(level = 0, route = window.location.pathname) {
    const routeArray = route.split('/');
    const activeRoute = routeArray[routeArray.length - level - 1];
    if (activeRoute) return `/${activeRoute}`;
};

});

parcelRegister("iL46s", function(module, exports) {

$parcel$export(module.exports, "applyDesignSystemSummaryCollection", () => $da7fcc8ea1f897c7$export$e07ddcbb10f12ba);
const $da7fcc8ea1f897c7$export$e07ddcbb10f12ba = function applyDesignSystemSummaryCollection() {
    const dataDesignSystem = this.getDesignSystem();
    const s = dataDesignSystem.color ? dataDesignSystem : this.context.designSystem;
    if (!s) return;
    const { color: color, theme: theme, typography: typography, font: font, fontFamily: fontFamily, spacing: spacing, icons: icons, timing: timing, cases: cases, GRIDS: GRIDS, media: media, devices: devices } = s;
    if (!color) return;
    return [
        {
            icon: 'colorOutline',
            href: '/color',
            iconTheme: 'theme',
            title: 'colors',
            paragraph: 'Theming of an entire app',
            iconBackground: 'red',
            properties: [
                {
                    property: 'Colors',
                    value: color && Object.keys(color).length
                },
                {
                    property: 'Themes',
                    value: theme && Object.keys(theme).length
                }
            ]
        },
        {
            icon: 'typographyOutline',
            href: '/typography',
            iconTheme: 'typography',
            title: 'typography',
            paragraph: 'Style a typed material',
            properties: [
                {
                    property: 'Base size',
                    value: typography && typography.base + 'px'
                },
                {
                    property: 'Ratio',
                    value: typography && typography.ratio
                },
                {
                    property: 'Styles',
                    value: typography && typography.styles && Object.keys(typography.styles).length
                }
            ]
        },
        {
            icon: 'spaceOutline',
            href: '/spacing',
            iconTheme: 'space',
            title: 'Spacing',
            paragraph: 'Manage sizing properties of a space',
            properties: [
                {
                    property: 'Ratio',
                    value: spacing && spacing.ratio
                },
                {
                    property: 'Templates',
                    value: 'TBA'
                }
            ]
        },
        {
            icon: 'shape',
            href: '/shape',
            iconTheme: 'shape',
            title: 'shapes',
            paragraph: 'Design an outline to a chosen component',
            properties: [
                {
                    property: 'HTML',
                    value: '32'
                },
                {
                    property: 'SVG',
                    value: 'TBA'
                }
            ]
        },
        {
            icon: 'iconsOutline',
            href: '/icons',
            iconTheme: 'color',
            title: 'Icons',
            paragraph: 'Label a role of subject with glyphs',
            properties: [
                {
                    property: 'All',
                    value: icons && Object.keys(icons).length
                },
                {
                    property: 'Fill',
                    value: icons && Object.keys(icons).filter((v)=>v.toLowerCase().includes('fill')).length
                },
                {
                    property: 'Linear',
                    value: icons && Object.keys(icons).filter((v)=>v.toLowerCase().includes('outline')).length
                },
                {
                    property: 'Colored',
                    value: icons && Object.keys(icons).filter((v)=>v.toLowerCase().includes('colored')).length
                }
            ]
        },
        {
            icon: 'fontFace',
            href: '/font',
            title: 'Fonts',
            paragraph: 'Fonts and font families',
            properties: [
                {
                    property: 'Fonts',
                    value: font && Object.keys(font).length
                },
                {
                    property: 'Families',
                    value: fontFamily && Object.keys(fontFamily).length
                }
            ]
        },
        {
            icon: 'clock',
            href: '/timing',
            iconTheme: 'icons',
            title: 'Timing',
            paragraph: 'Tokens for transitions and animations',
            properties: [
                {
                    property: 'Timing base',
                    value: timing && timing.base + 'ms'
                },
                {
                    property: 'Ratio',
                    value: timing && timing.ratio
                },
                {
                    property: 'Transitions',
                    value: 'TBA'
                },
                {
                    property: 'Animations',
                    value: 'TBA'
                }
            ]
        },
        {
            icon: 'layout outline',
            href: '/grid',
            title: 'Grids',
            paragraph: 'Grid systems for consistant layout',
            properties: [
                {
                    property: 'All grids',
                    value: GRIDS && Object.keys(GRIDS).length
                }
            ]
        },
        {
            icon: 'boolean outline',
            href: '/cases',
            title: 'Cases',
            paragraph: 'Conditional cases of UA reused in properties',
            properties: [
                {
                    property: 'All cases',
                    value: cases && Object.keys(cases).length
                }
            ]
        },
        {
            icon: 'deviceMobile',
            href: '/media',
            title: 'Breakpoints',
            paragraph: 'Device breakpoints as media and container queries',
            properties: [
                {
                    property: 'Breakpoints',
                    value: media && Object.keys(media).length
                },
                {
                    property: 'Screens',
                    value: devices && Object.keys(devices).length
                }
            ]
        },
        {
            icon: 'threeDots',
            href: '/sequence',
            title: 'Sequence',
            paragraph: 'Mapping system of generative sizing units',
            properties: [
                {
                    property: 'Breakpoints',
                    value: '8'
                },
                {
                    property: 'Screens',
                    value: '3'
                }
            ]
        }
    ];
};

});

parcelRegister("kjVu5", function(module, exports) {

$parcel$export(module.exports, "confirmEmail", () => $ecb22c2c03f5d846$export$d42a822b5f5ae147);
const $ecb22c2c03f5d846$export$d42a822b5f5ae147 = async function confirmEmail() {
    try {
        const params = new URLSearchParams(window.location.search);
        const token = params.get('token');
        const email = params.get('email');
        if (!token || !email) throw new Error('Invalid confirmation link');
        const result = await this.sdk.confirmRegistration(token);
        if (result) this.state.update({
            loading: false,
            success: true
        });
        else throw new Error('Confirmation failed');
    } catch (error) {
        this.state.update({
            loading: false,
            success: false,
            error: error.message
        });
    }
};

});

parcelRegister("4U3HQ", function(module, exports) {

$parcel$export(module.exports, "searchNpmPackages", () => $391f445a2897f22f$export$29f31f345bb88a04);
const $391f445a2897f22f$export$29f31f345bb88a04 = async function searchNpmPackages(name) {
    await window.fetch(`https://registry.npmjs.com/-/v1/search?text=${name}&size=5`).then(async (res)=>{
        const { objects: objects } = await res.json();
        const packages = objects.map((v)=>({
                name: v.package.name,
                version: v.package.version
            }));
        if (name === this.state.name) this.state.replace({
            packages: packages,
            isLoadingPackages: false
        });
    }).catch(()=>{
        if (name === this.state.name) this.state.replace({
            packages: [],
            isLoadingPackages: false
        });
    });
};

});

parcelRegister("7iKED", function(module, exports) {

$parcel$export(module.exports, "refreshUserProjects", () => $550e676b1df5323c$export$b66c22237e2200c3);
const $550e676b1df5323c$export$b66c22237e2200c3 = async function refreshUserProjects() {
    try {
        // Get current user data and projects from CoreService
        const currentUser = await this.sdk.getUserProfile();
        const userProjects = await this.sdk.getUserProjects();
        const userData = {
            ...currentUser,
            currentUser: currentUser,
            userId: currentUser.id,
            projects: userProjects || []
        };
        // Update the rootState with fresh user data and projects
        const state = this.getRootState();
        this.call('overwrite', state, userData);
        return userData;
    } catch (error) {
        console.error('[refreshUserProjects] Error:', error);
        throw error;
    }
};

});

parcelRegister("iGUve", function(module, exports) {

$parcel$export(module.exports, "getErroredCodeKey", () => $d9b7fa7b9c339a80$export$394fecdacc86f55);
const $d9b7fa7b9c339a80$export$394fecdacc86f55 = function getErroredCodeKey(key) {
    const projectKey = this.getAppKey();
    const componentKey = key || this.state.key;
    return `code-error-${projectKey}_${componentKey}`;
};

});

parcelRegister("1Qa8y", function(module, exports) {

$parcel$export(module.exports, "loadProjectData", () => $157282c9e7991991$export$416298f1f6a98821);
const $157282c9e7991991$export$416298f1f6a98821 = async function loadProjectData(projectId, fields = [
    'state',
    'system',
    'settings',
    'designSystem',
    'components',
    'pages',
    'canvas',
    'colors',
    'icons',
    'schema',
    'functions',
    'methods',
    'define',
    'packages',
    'dependencies',
    'files',
    'project'
]) {
    const projectData = this.call('deepDestringifyFunctions', await this.sdk.getProjectData(projectId));
    // If specific fields are requested, return only those
    if (Array.isArray(fields) && fields.length > 0) return fields.reduce((result, field)=>{
        if (field in projectData) result[field] = projectData[field];
        return result;
    }, {});
    return projectData;
};

});

parcelRegister("6jBBh", function(module, exports) {

$parcel$export(module.exports, "updateApplicationState", () => $4991af157a9f05b6$export$c261b3cb6fea64ae);
const $4991af157a9f05b6$export$c261b3cb6fea64ae = function updateApplicationState({ authToken: authToken, userData: userData, projectData: projectData }) {
    const state = this.getRootState();
    this.call('overwrite', state, {
        authToken: authToken
    });
    this.call('overwrite', state, userData);
    return this.call('overwrite', state, this.call('deepDestringifyFunctions', projectData));
};

});

parcelRegister("kfpS5", function(module, exports) {

$parcel$export(module.exports, "getCodePreviewValue", () => $ebd946ddc1e41669$export$975d5cb3731cc322);
const $ebd946ddc1e41669$export$975d5cb3731cc322 = function getCodePreviewValue(val) {
    const globalState = this.getRootState();
    const parentPropsValue = this.parent.value;
    const value = val || (parentPropsValue ? this.call('exec', parentPropsValue, this.parent) : this.call('exec', this.value, this));
    const framework = globalState?.framework === 'domql' ? 'symbols' : globalState?.framework;
    const code = this.call('isObjectLike', value) ? value[framework] || value['symbols'] || value['domql'] : value;
    if (!code) return;
    const stringifiedCode = this.call('isString', code) ? code : this.call('objectToString', code);
    return this.call('replaceLiteralsWithObjectFields', stringifiedCode);
};

});

parcelRegister("g8b33", function(module, exports) {

$parcel$export(module.exports, "addSmblsSubdomain", () => $bbe5f6ac45b33766$export$b1647d9bf0ff52c3);
const $bbe5f6ac45b33766$export$b1647d9bf0ff52c3 = async function addSmblsSubdomain(appKey) {
    const config = await this.getConfig();
    const API_URL = config.apiUrl;
    if (this.call('isNotProduction')) return this.warn('Creating domains is only allowed in production');
    const res = await window.fetch(`${API_URL}/add-subdomain`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            domain: appKey
        })
    }).then((response)=>response.json());
    return res;
};

});

parcelRegister("am94e", function(module, exports) {

$parcel$export(module.exports, "checkFeatureByPackage", () => $78a2fe07fa66f97a$export$7ccd2786a1d796c1);
const $78a2fe07fa66f97a$export$7ccd2786a1d796c1 = function checkFeatureByPackage(key) {
    const PAGES_PACKAGES_AVAILABILITY_MAP = {
        preview: 0,
        designSystem: 0,
        components: 0,
        integrations: 0,
        settings: 0,
        pages: 0,
        functions: 0,
        state: 0,
        gettingStarted: 0,
        docs: 0,
        colors: 0,
        color: 0,
        media: 0,
        shape: 0,
        typography: 0,
        spacing: 0,
        semantic_color: 0,
        global_themes: 0,
        gradients: 0,
        gradient: 0,
        themes: 0,
        theme: 0,
        icons: 0,
        fonts: 0,
        font: 0,
        cases: 0,
        dependencies: 0,
        secrets: 0,
        content: 0,
        methods: 0,
        snippets: 0,
        files: 0,
        publish: 0
    };
    return Number(this.getRootState()?.package) >= PAGES_PACKAGES_AVAILABILITY_MAP[key];
};

});

parcelRegister("b5PxY", function(module, exports) {

$parcel$export(module.exports, "sceneActions", () => $8138257e793727c9$export$ffcaa80d56d2b0c1);
const $8138257e793727c9$export$ffcaa80d56d2b0c1 = function sceneActions() {
    return {
        update: async (el, s, ctx)=>{
            const { demoFrameElement: demoFrameElement } = el.data;
            if (!demoFrameElement) return;
            if (s.variant) s.variant = s.variant;
            const demoComponent = el.call('deepClone', s.value);
            const frameProps = {
                ...el.scope.frameProps,
                ...s,
                style: {
                    transform: `scale(${parseFloat(s.zoomLevel, 2)})`
                }
            };
            if (s.base) frameProps.fontSize = s.base + 'px';
            if (s.ratio) frameProps['--spacing-ratio'] = s.ratio;
            demoFrameElement.update(frameProps);
            demoFrameElement.state.set(s.state);
            demoFrameElement.demoComponent.update(demoComponent);
        },
        recreate: async (el, s, ctx)=>{
            if (el.data.demoFrameElement) {
                el.data.demoFrameElement.node.remove();
                el.data.demoFrameElement.remove();
                delete el.data.demoFrameElement;
            }
            await el.onRenderScene?.(el, s, ctx);
        }
    };
};

});

parcelRegister("dLL0m", function(module, exports) {

$parcel$export(module.exports, "createBucket", () => $a06420555c152a34$export$1b8f2a181b92603a);
const $a06420555c152a34$export$1b8f2a181b92603a = async function createBucket(project) {
    const API_URL = this.getConfig().apiUrl;
    const randomString = Math.random().toString(36).slice(2, 15);
    const bucket = `symbols-bucket-${project.appKey?.split('.')[0]}-${randomString}`;
    await window.fetch(`${API_URL}/webhook/package`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            id: project.projectId,
            key: project.appKey,
            bucket: bucket
        })
    }).catch((e)=>{
        throw new Error('Problem with creating bucket', e);
    });
    await this.sdk.setBucket(bucket);
    return bucket;
};

});

parcelRegister("klZWn", function(module, exports) {

$parcel$export(module.exports, "findModal", () => $ed15d0e6ff67053e$export$2dd3fdf367431397);
const $ed15d0e6ff67053e$export$2dd3fdf367431397 = function findModal(path) {
    const el = this;
    const pathname = path || window.parent.location.pathname;
    if (!pathname) return {};
    const pathArray = pathname.slice(1).split('/');
    const Modal = el.getModal();
    const lastRoute = pathArray.pop();
    const beforeLastRoute = pathArray.pop();
    const isLastModal = Modal?.routes[`/${lastRoute}`];
    const isLastBeforeModal = Modal?.routes[`/${beforeLastRoute}`];
    return {
        index: isLastModal && 1 || isLastBeforeModal && 2 || 0,
        FoundModal: isLastModal || isLastBeforeModal,
        lastRoute: lastRoute,
        beforeLastRoute: beforeLastRoute
    };
};

});

parcelRegister("2bGRW", function(module, exports) {

$parcel$export(module.exports, "arraizeIconsCategory", () => $197ddcc2d2e84480$export$866c920f61cf7a80);
const $197ddcc2d2e84480$export$866c920f61cf7a80 = function arraizeIconsCategory(library, searchTerm) {
    return (()=>{
        const list = Object.keys(library);
        if (searchTerm) return list.filter((value)=>value.includes(searchTerm));
        return list;
    })().map((key)=>({
            key: key,
            value: library[key]
        }));
};

});

parcelRegister("avxjj", function(module, exports) {

$parcel$export(module.exports, "prettifyCode", () => $7a66a368c73727c9$export$5f0d86b4d94900dc);

const $7a66a368c73727c9$export$5f0d86b4d94900dc = async function prettifyCode(code, opts = {}) {
    const beautify = await (parcelRequire("1ql2a"));
    return beautify.js(code, {
        indent_size: 2,
        space_in_empty_paren: true,
        ...opts
    });
};

});
parcelRegister("1ql2a", function(module, exports) {
module.exports = import("lxnoL").then(()=>parcelRequire('87zMV'));

});


parcelRegister("flebV", function(module, exports) {

$parcel$export(module.exports, "loadIntercom", () => $b2b3d34519cfbdd7$export$132b3e90029bcb16);
const $b2b3d34519cfbdd7$export$132b3e90029bcb16 = function loadIntercom() {
    if (typeof window === 'undefined') return;
    // Full Symbols root state
    const s = this.getRootState();
    const APP_ID = 'i3suvh8k';
    const toUnix = (iso)=>iso ? Math.floor(new Date(iso).getTime() / 1000) : undefined;
    // ---------------------------
    // 🔹 USER IDENTITY
    // ---------------------------
    const userId = s.userId;
    const email = s.email;
    const name = s.username || s.projectName || 'User';
    const createdAt = toUnix(s.createdAt);
    const lastLogin = toUnix(s.lastLogin);
    // ---------------------------
    // 🔹 PROJECT (merged “company”) PROFILE
    //    This is what you asked for.
    //    Everything that belongs to a workspace, team,
    //    account, plan, project → goes under this.
    // ---------------------------
    const project = {
        id: s.projectId,
        name: s.projectName,
        key: s.projectKey || s.appKey,
        owner: s.workingProjectOwner || s.owner?.username,
        role: s.projectRole,
        type: s.projectType,
        visibility: s.visibility,
        tier: s.tier,
        subscription_id: s.subscription,
        status: s.status,
        created_at: createdAt,
        updated_at: toUnix(s.updatedAt),
        active_project: this.getAppKey(),
        // Optional but useful for Intercom segmentation:
        seats: s.seats,
        versions_count: s.versionscount,
        docs_context: s.docsContext,
        language: s.language
    };
    // ---------------------------
    // 🔹 EXTRA ATTRIBUTES (remaining root data)
    // ---------------------------
    const customAttributes = {
        access: s.access,
        global_role: s.globalRole,
        auth_provider: s.authProvider,
        last_login_at: lastLogin,
        is_account_owner: s.isAccountOwner,
        environment: s.environment,
        scenes_theme: s.sceneTheme
    };
    const bootAndShow = ()=>{
        if (!window.Intercom || typeof window.Intercom !== 'function') return;
        if (!window.__intercomBooted) {
            window.__intercomBooted = true;
            window.Intercom('boot', {
                app_id: APP_ID,
                hide_default_launcher: true,
                // ---------------------------
                // USER PROFILE
                // ---------------------------
                user_id: userId,
                name: name,
                email: email,
                created_at: createdAt,
                // ---------------------------
                // PROJECT PROFILE (YOUR REQUEST)
                // ---------------------------
                company: project,
                // ---------------------------
                // CUSTOM ATTRIBUTES
                // ---------------------------
                ...customAttributes
            });
        }
        // Safety: hide launcher if anything re-enabled it
        window.Intercom('update', {
            hide_default_launcher: true
        });
        // Open messenger
        window.Intercom('show');
    };
    // Script already loaded
    if (window.__intercomLoaded) {
        bootAndShow();
        return;
    }
    if (window.__loadingIntercom) return;
    window.__loadingIntercom = true;
    // Lazy-load Intercom
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://widget.intercom.io/widget/${APP_ID}`;
    script.onload = ()=>{
        window.__intercomLoaded = true;
        bootAndShow();
    };
    document.head.appendChild(script);
};

});

parcelRegister("3eWAd", function(module, exports) {

$parcel$export(module.exports, "getProjectMembers", () => $25c01f4854232356$export$6f905a407a33be1d);
const $25c01f4854232356$export$6f905a407a33be1d = async function getProjectMembers() {
    const s = this.getRootState();
    const ordering = {
        owner: 0,
        admin: 1,
        editor: 2,
        guest: 3
    };
    const projectMembers = (await this.sdk.getProjectMembers(this.getRootState('projectId'))).sort((a, b)=>{
        const roleDiff = ordering[a.role] - ordering[b.role];
        return roleDiff === 0 ? a.name > b.name ? 1 : a.name < b.name ? -1 : 0 : roleDiff;
    });
    if (projectMembers.length === 0) projectMembers.push({
        email: s.email,
        id: s.userId,
        joinedAt: s.createdAt,
        name: s.name,
        role: s.globalRole
    });
    return projectMembers;
};

});

parcelRegister("cbd5h", function(module, exports) {

$parcel$export(module.exports, "getPrefixForLocalStorage", () => $8de0a95b50f97291$export$b0bb5c8c4d68ef36);
const $8de0a95b50f97291$export$b0bb5c8c4d68ef36 = function getPrefixForLocalStorage() {};

});

parcelRegister("lT7Gj", function(module, exports) {

$parcel$export(module.exports, "addSmblsSubdomains", () => $fef4b1688af22dc8$export$1dd5d528565ec1dc);
const $fef4b1688af22dc8$export$1dd5d528565ec1dc = async function addSmblsSubdomains(appKey) {
    const res1 = await this.call('addSmblsSubdomain', appKey);
    const res2 = await this.call('addSmblsSubdomain', `www.${appKey}`);
    const successMsg = 'Domain registered successfully';
    if (res1.message.startsWith(successMsg) && res2.message.startsWith(successMsg)) this.call('openNotification', {
        title: successMsg,
        message: `"${appKey}" subdomain has been registered`,
        type: 'success'
    });
    else this.call('openNotification', {
        title: 'Error creating subdomain',
        message: res1.message + '\n' + res2.message,
        type: 'error'
    });
};

});

parcelRegister("6IYAb", function(module, exports) {

$parcel$export(module.exports, "generateSitemap", () => $4e55d89020415018$export$470c106c44438b62);
const $4e55d89020415018$export$470c106c44438b62 = function generateSitemap(baseUrl, routes) {
    const urls = Object.entries(routes).map(([path, config])=>{
        const metadata = config.metadata || {};
        const canonical = metadata.canonical || `${baseUrl}${path === '/' ? '' : path}`;
        return `
  <url>
    <loc>${canonical}</loc>
    <lastmod>${new Date().toISOString()}</lastmod>
    <changefreq>weekly</changefreq>
    <priority>${path === '/' ? '1.0' : '0.8'}</priority>
  </url>`;
    });
    return `<?xml version="1.0" encoding="UTF-8"?>
<urlset 
  xmlns="http://www.sitemaps.org/schemas/sitemap/0.9",
  xmlns:xhtml="http://www.w3.org/1999/xhtml">
${urls.join('\n')}
</urlset>`;
};

});

parcelRegister("j5M0h", function(module, exports) {

$parcel$export(module.exports, "getPluginSessionFromUrl", () => $de63b86f06693721$export$204e34bc97b6a501);
const $de63b86f06693721$export$204e34bc97b6a501 = function getPluginSessionFromUrl() {
    if (typeof window === 'undefined') return null;
    let session = null;
    try {
        session = new URL(window.location.href).searchParams.get('session');
    } catch  {
    // Ignore URL parsing errors
    }
    return session;
};

});

parcelRegister("8dTIl", function(module, exports) {

$parcel$export(module.exports, "installAppShellSync", () => (parcelRequire("7MJvY")).installAppShellSync);
$parcel$export(module.exports, "uninstallAppShellSync", () => (parcelRequire("7MJvY")).uninstallAppShellSync);
// Shared AppShell helpers — call from each project's app.js `onCreate`.
// Re-exports the installer/uninstaller defined alongside the component so
// consumers can pull them either via `el.call('installAppShellSync', s)`
// (after they're registered on the project) or by importing them
// directly from the components module when needed.

var $7MJvY = parcelRequire("7MJvY");

});

parcelRegister("aJaZ5", function(module, exports) {

$parcel$export(module.exports, "ownerSlug", () => $7cf6a095e2b4b6e4$export$7e6296f657b1fe2c);
$parcel$export(module.exports, "ownerMatches", () => $7cf6a095e2b4b6e4$export$911588fa76f0350d);
$parcel$export(module.exports, "projectKey", () => $7cf6a095e2b4b6e4$export$a59753e5f25e6cbe);
$parcel$export(module.exports, "SCREENSHOT_CDN_READY", () => $7cf6a095e2b4b6e4$export$11eb1e4fea2455f6);
$parcel$export(module.exports, "projectScreenshotUrl", () => $7cf6a095e2b4b6e4$export$b946faae724d34ec);
$parcel$export(module.exports, "groupByOwner", () => $7cf6a095e2b4b6e4$export$90a2d8a00e64886);
// Canonical owner slug for a project — org-owned projects carry
// `{ type: 'organization', slug }`, user-owned carry `{ username }`.
const $7cf6a095e2b4b6e4$export$7e6296f657b1fe2c = (project)=>{
    const o = project?.owner;
    if (!o) return project?.ownerUsername || '';
    if (typeof o === 'string') return o;
    return o.slug || o.username || '';
};
const $7cf6a095e2b4b6e4$export$911588fa76f0350d = (project, slug)=>$7cf6a095e2b4b6e4$export$7e6296f657b1fe2c(project) === slug;
const $7cf6a095e2b4b6e4$export$a59753e5f25e6cbe = (project)=>(project?.key || '').split('.')[0];
const $7cf6a095e2b4b6e4$export$11eb1e4fea2455f6 = true;
const $7cf6a095e2b4b6e4$export$b946faae724d34ec = (project, { page: page = 'root', env: env = 'production' } = {})=>{
    if (!$7cf6a095e2b4b6e4$export$11eb1e4fea2455f6) return null;
    const owner = $7cf6a095e2b4b6e4$export$7e6296f657b1fe2c(project);
    const key = $7cf6a095e2b4b6e4$export$a59753e5f25e6cbe(project);
    if (!owner || !key) return null;
    // page slug must be a non-empty string; normalize slashes to hyphens so
    // paths like '/pricing' map to the URL segment 'pricing' correctly.
    const pageSlug = (page || 'root').replace(/^\/+/, '').replace(/\//g, '-') || 'root';
    const qs = env && env !== 'production' ? `?env=${encodeURIComponent(env)}` : '';
    return `https://screenshots.symbo.ls/${owner}/${key}/${pageSlug}.webp${qs}`;
};
const $7cf6a095e2b4b6e4$export$90a2d8a00e64886 = (projects)=>{
    const map = new Map();
    for (const p of projects){
        const slug = $7cf6a095e2b4b6e4$export$7e6296f657b1fe2c(p) || 'unknown';
        if (!map.has(slug)) map.set(slug, []);
        map.get(slug).push(p);
    }
    return [
        ...map.entries()
    ].map(([owner, items])=>({
            owner: owner,
            items: items
        }));
};

});

parcelRegister("eaFBF", function(module, exports) {

$parcel$export(module.exports, "setNavbarTooltipPosition", () => $a5124609d49e57b8$export$f8022f975d76fe07);
const $a5124609d49e57b8$export$f8022f975d76fe07 = function setNavbarTooltipPosition(options = {}) {
    const TooltipElement = this.lookup('NavbarTooltip');
    if (!TooltipElement) return;
    // eslint-disable-next-line no-useless-assignment
    let transform = null;
    const tooltipRect = TooltipElement.parent.node.getBoundingClientRect();
    const elementRect = this.node.getBoundingClientRect();
    const getOffset = (rect, subtract)=>rect - subtract;
    const tooltipPosition = TooltipElement.tooltipPosition || 'bottom';
    if (tooltipPosition === 'bottom') {
        const x = getOffset(elementRect.left + elementRect.width / 2, tooltipRect.left);
        const y = getOffset(elementRect.bottom, tooltipRect.top);
        transform = `translate3d(calc(${x}px - 50%), calc(${y}px + 7.5%), 0)`;
    } else if (tooltipPosition === 'right') {
        const x = getOffset(elementRect.left, tooltipRect.left);
        const y = getOffset(elementRect.top + elementRect.height / 2, tooltipRect.top);
        transform = `translate3d(calc(${x}px + 7.5%), calc(${y}px - 50%), 0)`;
    } else if (tooltipPosition === 'left') {
        const x = getOffset(elementRect.left, tooltipRect.left);
        const y = getOffset(elementRect.top + elementRect.height / 2, tooltipRect.top);
        transform = `translate3d(calc(${x}px - 7.5%), ${y}px, 0)`;
    } else {
        // top position
        const x = getOffset(elementRect.left + elementRect.width / 2, tooltipRect.left);
        const y = getOffset(elementRect.top, tooltipRect.top);
        transform = `translate3d(calc(${x}px - 50%), calc(${y}px - 7.5%), 0)`;
    }
    const Tooltip = this.lookup('NavbarTooltip');
    if (transform && this.title && Tooltip) Tooltip.update({
        opacity: options.visible || '1',
        visibility: options.visible || 'visible',
        description: this.call('exec', this.title),
        transform: transform
    });
};

});

parcelRegister("kZODV", function(module, exports) {

$parcel$export(module.exports, "formatImports", () => $f490c9cd2ed00ec5$export$a444f85bf2d3031a);
const $f490c9cd2ed00ec5$export$a444f85bf2d3031a = function formatImports(code) {
    return code.replace(// eslint-disable-next-line prefer-named-capture-group
    /import\s*\{\s*\n\s*([^}]+)\n\s*\}\s*from\s*['"]([^'"]+)['"]/gu, (_, imports, source)=>{
        const cleanedImports = imports.trim();
        return `import { ${cleanedImports} } from '${source}'`;
    });
};

});

parcelRegister("kNLWG", function(module, exports) {

$parcel$export(module.exports, "inviteMember", () => $f24d933c2f3e2597$export$348cc448ded6dc4b);
const $f24d933c2f3e2597$export$348cc448ded6dc4b = function inviteMember() {
/* console.log(this, this.state, this.context) */ };

});

parcelRegister("hJQzL", function(module, exports) {

$parcel$export(module.exports, "hasSessionToken", () => $ce9f6c1c2add14e2$export$99e0bf065eb0a9bc);
$parcel$export(module.exports, "mirrorAuthSession", () => $ce9f6c1c2add14e2$export$8b264bf264b945cb);
$parcel$export(module.exports, "stopMirrorAuthSession", () => $ce9f6c1c2add14e2$export$fba51b09c4b55301);
// Mirrors the SDK session onto an app's root state so components can read
// `root.signedIn`, `root.currentUserId`, and
// `root.jwtClaims.workspace_org_id` without depending on gov-specific
// modules. All three editor apps (canvas, CMS, gov, future consumers)
// point at the same SDK auth pipeline, so subscribing here gives every
// origin the same identity view.
//
// Usage:
//   onCreate: (el, s) => el.call('mirrorAuthSession', s.root || s)
// Pair with `stopMirrorAuthSession` from the returned unsubscriber if
// you need a tear-down; otherwise the subscription lives for the
// lifetime of the page.

var $bfqVY = parcelRequire("bfqVY");
const $ce9f6c1c2add14e2$export$99e0bf065eb0a9bc = function hasSessionToken() {
    if (typeof window === 'undefined') return false;
    for(let i = 0; i < window.localStorage.length; i++){
        const k = window.localStorage.key(i);
        if (k && k.startsWith('sb-') && k.endsWith('-auth-token')) return true;
    }
    return false;
};
const $ce9f6c1c2add14e2$export$8b264bf264b945cb = function mirrorAuthSession(root, onSignIn) {
    if (!root || root._authMirrorInstalled) return root?._authMirrorInstalled;
    root._authMirrorInstalled = true;
    // migrated 2026-04-27 to SDK onAuthStateChange (signature is event, session;
    // matches Supabase's shape so the callback body is unchanged).
    let lastUserId = null;
    const unsubscribe = (0, $bfqVY.getSDK)().onAuthStateChange((_event, session)=>{
        const u = session?.user;
        const nextEmail = u?.email || '';
        const nextId = u?.id || '';
        const nextSignedIn = !!u;
        const nextClaims = u?.app_metadata || {};
        const changed = root.signedIn !== nextSignedIn || root.currentUserEmail !== nextEmail || root.currentUserId !== nextId;
        if (changed) root.update({
            signedIn: nextSignedIn,
            currentUserEmail: nextEmail,
            currentUserId: nextId,
            jwtClaims: nextClaims
        });
        else if (nextSignedIn) root.update({
            jwtClaims: nextClaims
        });
        if (nextId && nextId !== lastUserId) {
            lastUserId = nextId;
            if (typeof onSignIn === 'function') onSignIn({
                id: nextId,
                email: nextEmail
            });
        } else if (!nextId) lastUserId = null;
    });
    // SDK's onAuthStateChange returns the unsubscribe fn directly. The previous
    // sdk-bridge implementation returned `{ data: { subscription: { unsubscribe } } }`
    // and the wrapper here adapted that shape — keep returning a plain function so
    // stopMirrorAuthSession() works unchanged.
    const unsub = ()=>{
        if (typeof unsubscribe === 'function') unsubscribe();
    };
    root._authMirrorUnsub = unsub;
    return unsub;
};
const $ce9f6c1c2add14e2$export$fba51b09c4b55301 = function stopMirrorAuthSession(root) {
    if (!root?._authMirrorUnsub) return;
    root._authMirrorUnsub();
    delete root._authMirrorInstalled;
    delete root._authMirrorUnsub;
};

});

parcelRegister("3BwSQ", function(module, exports) {

$parcel$export(module.exports, "loadCmsTemplate", () => $29fe55cee03dbb4a$export$a3f77a3e76325b77);
$parcel$export(module.exports, "listCmsTemplates", () => $29fe55cee03dbb4a$export$efff462512a7cb2e);
$parcel$export(module.exports, "hydrateCmsTemplate", () => $29fe55cee03dbb4a$export$12aeea6e34437451);
$parcel$export(module.exports, "mergeIntoNested", () => $29fe55cee03dbb4a$export$6a3586c290191fc6);
$parcel$export(module.exports, "translateLangKey", () => $29fe55cee03dbb4a$export$a99c9fbee40ccafb);
$parcel$export(module.exports, "setLangValue", () => $29fe55cee03dbb4a$export$79ef08e9257510e7);
$parcel$export(module.exports, "listCmsPresets", () => $29fe55cee03dbb4a$export$e302e40e2a3920f7);
// Loader for cms_template rows in the governance Supabase. Read by
// the CMS root onCreate to hydrate the sidebar and initial state from
// a named template ('default', 'blog', 'portfolio', or a custom per-org
// slug).
//
// A template shape:
//   {
//     slug, name, org_id,
//     route_map: { '/path': { _section, _kind, ... }, ... },
//     default_state: { <section>: <value>, ... },
//     lang_schema, table_bindings, rich_text_paths, version
//   }
//
// `route_map` keys drive the sidebar; `default_state` seeds projectState
// on first mount. A `cms_preset` row can layer state_overrides on top.

var $8RlGv = parcelRequire("8RlGv");
const $29fe55cee03dbb4a$var$_cache = new Map();
const $29fe55cee03dbb4a$var$_cacheKey = (orgId, slug)=>`${orgId || 'default'}::${slug || 'default'}`;
const $29fe55cee03dbb4a$export$a3f77a3e76325b77 = async function loadCmsTemplate(orgId, slug) {
    const key = $29fe55cee03dbb4a$var$_cacheKey(orgId, slug);
    if ($29fe55cee03dbb4a$var$_cache.has(key)) return $29fe55cee03dbb4a$var$_cache.get(key);
    // TODO[sdk-cms]: cms_template/cms_preset are governance-tier config
    // tables (cross-org templates). They don't fit the workspace-project
    // tenant scoping model — adding a workspaceProject.documents.cms route
    // would force tenant-scoped reads on what is effectively shared
    // template metadata. Once a /governance/cms-templates wrapper or a
    // dedicated cms.* SDK service exists, swap the direct supabase call.
    const sb = await (0, $8RlGv.getSupabaseAsync)();
    if (!sb) return null;
    const { data: data, error: error } = await sb.from('cms_template').select('*').eq('org_id', orgId || 'default').eq('slug', slug || 'default').maybeSingle();
    if (error || !data) {
        // Fallback: try the 'default' org for this slug — useful during
        // local dev before org-scoped templates are seeded.
        if ((orgId || 'default') !== 'default') return loadCmsTemplate('default', slug);
        return null;
    }
    $29fe55cee03dbb4a$var$_cache.set(key, data);
    return data;
};
const $29fe55cee03dbb4a$export$efff462512a7cb2e = async function listCmsTemplates(orgId) {
    // TODO[sdk-cms]: see loadCmsTemplate for rationale.
    const sb = await (0, $8RlGv.getSupabaseAsync)();
    if (!sb) return [];
    const { data: data } = await sb.from('cms_template').select('slug, name, version, updated_at').eq('org_id', orgId || 'default').order('updated_at', {
        ascending: false
    });
    return data || [];
};
const $29fe55cee03dbb4a$export$12aeea6e34437451 = async function hydrateCmsTemplate(root, { orgId: orgId, slug: slug, force: force } = {}) {
    if (!root) return null;
    const targetSlug = slug || root?.projectSlug || 'default';
    const targetOrg = orgId || root?.jwtClaims?.workspace_org_id || 'default';
    const tpl = await $29fe55cee03dbb4a$export$a3f77a3e76325b77(targetOrg, targetSlug);
    if (!tpl) return null;
    // A template defines the whole CMS shape; when it loads it owns
    // projectState + projectLang. The previous slug's data is discarded
    // on switch — drafts should be persisted through cms_preset rows
    // before nav.
    const prevSlug = root.projectSlug;
    const slugChanged = prevSlug !== tpl.slug;
    // First hydrate on this root — there's no prior template yet, so
    // the default state in state.js is a placeholder; always prefer the
    // template's defaults over it on initial load.
    const firstHydrate = !root.projectTemplate;
    const resetData = force || slugChanged || firstHydrate || !root.projectState;
    // Deep-clone template slices before handing to root.update. State
    // proxies retain references to template objects otherwise, producing
    // phantom keys on later reads.
    const clone = (v)=>v == null ? v : structuredClone(v);
    root.update({
        projectSlug: tpl.slug,
        projectTemplate: tpl,
        projectState: resetData ? clone(tpl.default_state) || {} : root.projectState,
        projectLang: resetData ? clone(tpl.lang_schema?.strings) || {} : root.projectLang,
        activeRoute: slugChanged ? '/' : root.activeRoute
    });
    return tpl;
};
const $29fe55cee03dbb4a$export$6a3586c290191fc6 = function mergeIntoNested(root, topKey, nestedKey, innerKey, value) {
    if (!root || !topKey || nestedKey == null || innerKey == null) return;
    const top = root[topKey] || {};
    const nested = top[nestedKey];
    const nextNested = Array.isArray(nested) ? Object.assign([
        ...nested
    ], {
        [Number(innerKey)]: value
    }) : {
        ...nested || {},
        [innerKey]: value
    };
    root.update({
        [topKey]: {
            ...top,
            [nestedKey]: nextNested
        }
    });
};
const $29fe55cee03dbb4a$export$a99c9fbee40ccafb = async function translateLangKey(root, keyName) {
    const schema = root?.projectTemplate?.lang_schema;
    if (!schema || !keyName) return {
        ok: false,
        error: 'no schema or key'
    };
    const defaultLocale = schema.default || schema.locales && schema.locales[0] || 'en';
    const source = root?.projectLang?.[defaultLocale]?.[keyName];
    if (!source) return {
        ok: false,
        error: 'no source text'
    };
    const nextLang = {
        ...root.projectLang || {}
    };
    let filled = 0;
    for (const code of schema.locales || []){
        if (code === defaultLocale) continue;
        const existing = nextLang[code]?.[keyName];
        if (existing && existing.length > 0) continue;
        // Stub: mark with locale prefix. Real integration swaps this
        // for a sdk-bridge AI call.
        nextLang[code] = {
            ...nextLang[code] || {},
            [keyName]: `[${code.toUpperCase()}] ${source}`
        };
        filled += 1;
    }
    if (filled > 0) root.update({
        projectLang: nextLang
    });
    return {
        ok: true,
        filled: filled
    };
};
const $29fe55cee03dbb4a$export$79ef08e9257510e7 = function setLangValue(root, code, keyName, value) {
    $29fe55cee03dbb4a$export$6a3586c290191fc6(root, 'projectLang', code, keyName, value);
};
const $29fe55cee03dbb4a$export$e302e40e2a3920f7 = async function listCmsPresets(orgId, templateSlug) {
    // TODO[sdk-cms]: see loadCmsTemplate for rationale.
    const sb = await (0, $8RlGv.getSupabaseAsync)();
    if (!sb) return [];
    const { data: data } = await sb.from('cms_preset').select('*').eq('org_id', orgId || 'default').eq('template_slug', templateSlug).order('updated_at', {
        ascending: false
    });
    return data || [];
};

});

parcelRegister("2LZpJ", function(module, exports) {

$parcel$export(module.exports, "compileToHtml", () => $204f9c15ee0a204e$export$993cbede8d0ab919);
/* eslint-disable no-use-before-define */ /* eslint-disable prefer-named-capture-group */ const $204f9c15ee0a204e$var$convertToKebabCase = (str)=>str.replace(/([a-z0-9])([A-Z])/gu, '$1-$2').replace(/([A-Z])([A-Z][a-z])/gu, '$1-$2').toLowerCase();
const $204f9c15ee0a204e$var$formatAttributes = (attrs, indent = 2, multiline = false)=>{
    if (!attrs || typeof attrs !== 'object') return '';
    const entries = Object.entries(attrs).filter(([key])=>![
            'children',
            'childProps',
            'text',
            'tag'
        ].includes(key) && typeof key === 'string' && key.match(/^[a-zA-Z][a-zA-Z0-9]*$/u));
    if (!multiline || entries.length <= 0) return entries.map(([key, value])=>`${$204f9c15ee0a204e$var$convertToKebabCase(key)}="${value}"`).join(' ');
    return entries.map(([key, value])=>`${' '.repeat(indent + 2)}${$204f9c15ee0a204e$var$convertToKebabCase(key)}="${value}"`).join('\n');
};
const $204f9c15ee0a204e$var$MAX_DEPTH = 100;
const $204f9c15ee0a204e$export$993cbede8d0ab919 = (props, level = 0)=>{
    if (level > $204f9c15ee0a204e$var$MAX_DEPTH) throw new Error('Maximum nesting depth exceeded');
    if (!props || typeof props !== 'object') throw new Error('Invalid input: props must be an object');
    const indent = ' '.repeat(level * 2);
    // Handle root level element with tag
    if (props.tag) {
        const tagName = $204f9c15ee0a204e$var$convertToKebabCase(props.tag);
        const attributes = $204f9c15ee0a204e$var$formatAttributes(props);
        if (!props.children) // Self-closing tag
        return `${indent}<${tagName}${attributes ? ` ${attributes}` : ''} />`;
        // Block-level tag with children
        const childrenHtml = $204f9c15ee0a204e$var$compileChildren(props.children, props.childProps, level + 1);
        return `${indent}<${tagName}${attributes ? ` ${attributes}` : ''}>\n${childrenHtml}\n${indent}</${tagName}>`;
    }
    return $204f9c15ee0a204e$var$compileChildren(props, {}, level);
};
// eslint-disable-next-line no-unused-vars
const $204f9c15ee0a204e$var$compileChildren = (children, childProps = {}, level = 0)=>{
    const indent = ' '.repeat(level * 2);
    let html = '';
    if (!children || typeof children !== 'object') return html;
    Object.entries(children).forEach(([key, value])=>{
        if (!key.match(/^[a-zA-Z][a-zA-Z0-9]*$/u)) return;
        const tagName = $204f9c15ee0a204e$var$convertToKebabCase(key);
        const attributes = $204f9c15ee0a204e$var$formatAttributes(value);
        if (!value || typeof value !== 'object') return;
        if (!value.children) {
            html += `${indent}<${tagName}${attributes ? ` ${attributes}` : ''} />\n`;
            return;
        }
        // Element has children
        html += `${indent}<${tagName}${attributes ? ` ${attributes}` : ''}>\n`;
        if (Array.isArray(value.children)) value.children.forEach((child, index)=>{
            if (!child || typeof child !== 'object') return;
            const childAttributes = {
                ...value.childProps || {},
                ...child.childProps || {}
            };
            // First-child and last-child handling
            if (value.childProps && value.childProps[':first-child'] && index === 0) Object.assign(childAttributes, value.childProps[':first-child']);
            if (value.childProps && value.childProps[':last-child'] && index === value.children.length - 1) Object.assign(childAttributes, value.childProps[':last-child']);
            const childAttrs = $204f9c15ee0a204e$var$formatAttributes(childAttributes, level + 1, true);
            const childContent = child.text || '';
            html += `${indent}  <div${childAttrs ? ` ${childAttrs}` : ''}>${childContent}</div>\n`;
        });
        html += `${indent}</${tagName}>\n`;
    });
    return html;
};

});

parcelRegister("a71rn", function(module, exports) {

$parcel$export(module.exports, "stringifyProps", () => $75cbace600f579c7$export$da9ba81e9f81934b);
$parcel$export(module.exports, "codify", () => $75cbace600f579c7$export$368d04dc9198c46b);
parcelRequire("2oe0q");
var $bmfNh = parcelRequire("bmfNh");

var $2LZpJ = parcelRequire("2LZpJ");
const $75cbace600f579c7$export$da9ba81e9f81934b = (props, indent = 2)=>(0, $bmfNh.objectToString)(props, indent);
const $75cbace600f579c7$export$368d04dc9198c46b = (key, demoProps, appKey, opts = {})=>{
    const hasProps = demoProps && Object.keys(demoProps).length;
    const props = hasProps ? $75cbace600f579c7$export$da9ba81e9f81934b(demoProps, 2) : '{}';
    const propsForHtml = {
        tag: key,
        ...demoProps
    };
    const html = (0, $2LZpJ.compileToHtml)(propsForHtml);
    const boxSize = opts.width && opts.height ? ` width: ${opts.width}px; height: ${opts.height}px;` : '';
    return {
        symbols: `{
  ${key}: ${props}
}`,
        domql: `import { ${key} } from '~/smbls/${key}'

const MyComponent = {
  ${key}: ${props}
}`,
        react: hasProps ? `'use strict'

import React from 'react'
import { ${key} } from './${key}.js'

export const Component = () => {
  const props = ${props}
  return <${key} {...props} />
}` : `import { ${key} } from './${key}'

const MyComponent = props => {
  return <${key} {...props} />
}`,
        iframe: `<iframe
  title="${key}"
  style="border: 0; resize: both; padding: 0 10px 10px 0;${boxSize}"
  src="https://${appKey}/component?key=${key}&fullsize=true&hideUi=true" 
  referrerpolicy="no-referrer-when-downgrade"
></iframe>`,
        html: html
    };
};

});

parcelRegister("aOpgb", function(module, exports) {

$parcel$export(module.exports, "getThemeState", () => $7df22afd4dc7ba13$export$6c1c32a51c44427d);
$parcel$export(module.exports, "getProjectThemeValues", () => $7df22afd4dc7ba13$export$672fafd60c8680fc);
$parcel$export(module.exports, "findColorReference", () => $7df22afd4dc7ba13$export$7342cd07f40f5c4a);
$parcel$export(module.exports, "getColorReference", () => $7df22afd4dc7ba13$export$ee4504183db3c328);
$parcel$export(module.exports, "getGradientReference", () => $7df22afd4dc7ba13$export$534dd86b48e67bf2);
$parcel$export(module.exports, "getProjectColorByValue", () => $7df22afd4dc7ba13$export$ea905cca416bbbf2);
$parcel$export(module.exports, "getProjectColorsFactory", () => $7df22afd4dc7ba13$export$fec5ccb673c4b4d4);
$parcel$export(module.exports, "getProjectThemeColors", () => $7df22afd4dc7ba13$export$a691d482543a0646);
$parcel$export(module.exports, "getActiveThemeValue", () => $7df22afd4dc7ba13$export$a532b1a5af38c0fb);
$parcel$export(module.exports, "setThemeValueInProject", () => $7df22afd4dc7ba13$export$2a65b09d44c1de28);
function $7df22afd4dc7ba13$export$6c1c32a51c44427d() {
    const { state: state } = this;
    const themeState = state.key ? state : state.parent;
    return themeState.key ? themeState : themeState.parent;
}
function $7df22afd4dc7ba13$export$672fafd60c8680fc(forcedTheme, globalTheme) {
    const { state: state } = this;
    const sceneTheme = globalTheme || this.call('getGlobalTheme');
    const themeState = state.key ? state : state.parent.key ? state.parent : null;
    if (!themeState) return this.warn('Theme not found', themeState);
    const themeScope = (forcedTheme || themeState.value || themeState)[`@${sceneTheme}`] || {};
    const { color: color, background: background, borderColor: borderColor, outlineColor: outlineColor, ...rest } = themeScope;
    return {
        color: color,
        background: background,
        borderColor: borderColor,
        outlineColor: outlineColor,
        ...rest
    };
}
function $7df22afd4dc7ba13$export$7342cd07f40f5c4a(FACTORY, value) {
    const globalTheme = this.call('getGlobalTheme');
    if (!value || !this.call('isString', value)) return this.error(`Problem with ${value}`);
    const [colorValue] = value.split(' ');
    let color = FACTORY[colorValue];
    if (globalTheme && this.call('isObject', color)) color = color[`@${globalTheme}`];
    if (color && color.slice(0, 2) === '--') color = this.call('findColorReference', FACTORY, color.slice(2));
    return color;
}
function $7df22afd4dc7ba13$export$ee4504183db3c328(value) {
    return this.call('findColorReference', this.getDesignSystem('color'), value);
}
function $7df22afd4dc7ba13$export$534dd86b48e67bf2(value) {
    return this.call('findColorReference', this.getDesignSystem('gradient'), value);
}
function $7df22afd4dc7ba13$export$ea905cca416bbbf2(value) {
    if (!value) return;
    const color = this.call('getColorReference', value);
    if (color && typeof color === 'string') {
        const [colorValue, opacity] = color.split(' ');
        const colorArr = this.call('colorStringToRgbaArray', colorValue);
        const [r, g, b] = colorArr;
        return `rgba(${r}, ${g}, ${b}, ${opacity || 1})`;
    }
    const gradient = this.call('getGradientReference', value);
    return gradient;
}
function $7df22afd4dc7ba13$export$fec5ccb673c4b4d4() {
    return (key)=>this.call('getProjectColorByValue', key);
}
function $7df22afd4dc7ba13$export$a691d482543a0646(forcedTheme, sceneTheme) {
    const { color: color, background: background, borderColor: borderColor, outlineColor: outlineColor, ...rest } = this.call('getProjectThemeValues', forcedTheme, sceneTheme);
    const getFromColorFactory = this.call('getProjectColorsFactory');
    return {
        color: getFromColorFactory(color),
        background: getFromColorFactory(background),
        borderColor: getFromColorFactory(borderColor),
        outlineColor: getFromColorFactory(outlineColor),
        ...rest
    };
}
function $7df22afd4dc7ba13$export$a532b1a5af38c0fb(themeKey) {
    const { sceneTheme: sceneTheme } = this.getRootState();
    const { theme: THEME } = this.getDesignSystem();
    if (!themeKey) // eslint-disable-next-line prefer-destructuring, no-param-reassign
    themeKey = this.call('getThemeState').themeKey;
    const themeFromData = sceneTheme ? THEME[themeKey][`@${sceneTheme}`] : THEME[themeKey];
    return themeFromData;
}
async function $7df22afd4dc7ba13$export$2a65b09d44c1de28(themeKey, key, val, options) {
    const { sceneTheme: sceneTheme } = this.getRootState();
    const value = {
        [key]: val
    };
    const THEME = {
        [themeKey]: sceneTheme ? {
            [`@${sceneTheme}`]: value
        } : value
    };
    await this.updateDesignSystem({
        theme: THEME
    }, options);
}

});

parcelRegister("bpTkZ", function(module, exports) {

$parcel$export(module.exports, "isColorVariable", () => $84fcf465ccc48eed$export$a30cc56bb2eace2d);
/* eslint-disable no-invalid-this */ // eslint-disable-next-line func-style
function $84fcf465ccc48eed$export$a30cc56bb2eace2d(k, factory) {
    const v = factory[k];
    const isSrtingVar = (v2)=>this.call('isString', v2) && v2.startsWith('--');
    if (this.call('isString', v)) return isSrtingVar(v);
    if (this.call('isArray', v)) return v.some(isSrtingVar);
    if (this.call('isObject', v)) return Object.values(v).some(isSrtingVar);
    return false;
}

});

parcelRegister("h1fI3", function(module, exports) {

$parcel$export(module.exports, "isModalRoute", () => $c63eb7401ab47274$export$dccb6c3b12695432);
/* eslint-disable no-invalid-this */ // eslint-disable-next-line func-style
function $c63eb7401ab47274$export$dccb6c3b12695432(path) {
    return (this.call('findModal', path) || {}).FoundModal;
}

});

parcelRegister("bZEG1", function(module, exports) {

$parcel$export(module.exports, "sha256", () => $8bb4f1c8dfed1708$export$bced8d2aada2d1c9);
// eslint-disable-next-line func-style
async function $8bb4f1c8dfed1708$export$bced8d2aada2d1c9(message) {
    const msgBuffer = new TextEncoder('utf-8').encode(message);
    const hashBuffer = await window.crypto.subtle.digest('SHA-256', msgBuffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map((b)=>`00${b.toString(16)}`.slice(-2)).join('');
    return hashHex;
}

});

parcelRegister("9b1pZ", function(module, exports) {
/* eslint-disable no-invalid-this */ /* eslint-disable func-style */ // Legacy single-arg variant kept for git-history reference.
// The canonical arraizeIconsCategory(library, searchTerm) lives in
// ./arraizeIconsCategory.js — both files in the same barrel tripped
// frank's duplicate-export scan, so this declaration is no longer
// exported. Remove this file in a follow-up if no consumer regresses.
function $6ae63dc7f20de634$var$arraizeIconsCategory(library) {
    return (()=>{
        const list = Object.keys(library);
        if (this.state.searched) return list.filter((value)=>value.includes(this.state.searched));
        return list;
    })().map((key)=>({
            key: key,
            value: library[key]
        }));
}

});

parcelRegister("9UhRW", function(module, exports) {

$parcel$export(module.exports, "nameTheColor", () => $7367346e2d386411$export$7a7577de99024054);
/*

+-----------------------------------------------------------------+
|     Created by Chirag Mehta - http://chir.ag/projects/ntc       |
|-----------------------------------------------------------------|
|               ntc js (Name that Color JavaScript)               |
+-----------------------------------------------------------------+

All the functions, code, lists etc. have been written specifically
for the Name that Color JavaScript by Chirag Mehta unless otherwise
specified.

This script is released under the: Creative Commons License:
Attribution 2.5 http://creativecommons.org/licenses/by/2.5/

Sample Usage:
    var n_match  = nameTheColor.name("#6195ED");
    n_rgb        = n_match[0]; // This is the RGB value of the closest matching color
    n_name       = n_match[1]; // This is the text string for the name of the match
    n_exactmatch = n_match[2]; // True if exact color match, False if close-match
*/ /* eslint-disable */ const $7367346e2d386411$export$7a7577de99024054 = {
    init: function() {
        var color, rgb, hsl;
        for(var i = 0; i < $7367346e2d386411$export$7a7577de99024054.names.length; i++){
            color = '#' + $7367346e2d386411$export$7a7577de99024054.names[i][0];
            rgb = $7367346e2d386411$export$7a7577de99024054.rgb(color);
            hsl = $7367346e2d386411$export$7a7577de99024054.hsl(color);
            $7367346e2d386411$export$7a7577de99024054.names[i].push(rgb[0], rgb[1], rgb[2], hsl[0], hsl[1], hsl[2]);
        }
    },
    name: function(color) {
        color = color.toUpperCase();
        if (color.length < 3 || color.length > 7) return [
            '#000000',
            'Invalid Color: ' + color,
            false,
            false
        ];
        if (color.length % 3 == 0) color = '#' + color;
        if (color.length == 4) color = '#' + color.substr(1, 1) + color.substr(1, 1) + color.substr(2, 1) + color.substr(2, 1) + color.substr(3, 1) + color.substr(3, 1);
        var rgb = $7367346e2d386411$export$7a7577de99024054.rgb(color);
        var r = rgb[0], g = rgb[1], b = rgb[2];
        var hsl = $7367346e2d386411$export$7a7577de99024054.hsl(color);
        var h = hsl[0], s = hsl[1], l = hsl[2];
        var ndf1 = 0, ndf2 = 0, ndf = 0;
        var cl = -1, df = -1;
        for(var i = 0; i < $7367346e2d386411$export$7a7577de99024054.names.length; i++){
            if (color == '#' + $7367346e2d386411$export$7a7577de99024054.names[i][0]) return [
                '#' + $7367346e2d386411$export$7a7577de99024054.names[i][0],
                $7367346e2d386411$export$7a7577de99024054.names[i][1],
                true
            ];
            ndf1 = Math.pow(r - $7367346e2d386411$export$7a7577de99024054.names[i][2], 2) + Math.pow(g - $7367346e2d386411$export$7a7577de99024054.names[i][3], 2) + Math.pow(b - $7367346e2d386411$export$7a7577de99024054.names[i][4], 2);
            ndf2 = Math.pow(h - $7367346e2d386411$export$7a7577de99024054.names[i][5], 2) + Math.pow(s - $7367346e2d386411$export$7a7577de99024054.names[i][6], 2) + Math.pow(l - $7367346e2d386411$export$7a7577de99024054.names[i][7], 2);
            ndf = ndf1 + ndf2 * 2;
            if (df < 0 || df > ndf) {
                df = ndf;
                cl = i;
            }
        }
        return cl < 0 ? [
            '#000000',
            'Invalid Color: ' + color,
            false,
            false
        ] : [
            '#' + $7367346e2d386411$export$7a7577de99024054.names[cl][0],
            $7367346e2d386411$export$7a7577de99024054.names[cl][1],
            false
        ];
    },
    // adopted from: Farbtastic 1.2
    // http://acko.net/dev/farbtastic,
    hsl: function(color) {
        var rgb = [
            parseInt('0x' + color.substring(1, 3)) / 255,
            parseInt('0x' + color.substring(3, 5)) / 255,
            parseInt('0x' + color.substring(5, 7)) / 255
        ];
        var min, max, delta, h, s, l;
        var r = rgb[0], g = rgb[1], b = rgb[2];
        min = Math.min(r, Math.min(g, b));
        max = Math.max(r, Math.max(g, b));
        delta = max - min;
        l = (min + max) / 2;
        s = 0;
        if (l > 0 && l < 1) s = delta / (l < 0.5 ? 2 * l : 2 - 2 * l);
        h = 0;
        if (delta > 0) {
            if (max == r && max != g) h += (g - b) / delta;
            if (max == g && max != b) h += 2 + (b - r) / delta;
            if (max == b && max != r) h += 4 + (r - g) / delta;
            h /= 6;
        }
        return [
            parseInt(h * 255),
            parseInt(s * 255),
            parseInt(l * 255)
        ];
    },
    // adopted from: Farbtastic 1.2
    // http://acko.net/dev/farbtastic,
    rgb: function(color) {
        return [
            parseInt('0x' + color.substring(1, 3)),
            parseInt('0x' + color.substring(3, 5)),
            parseInt('0x' + color.substring(5, 7))
        ];
    },
    names: [
        [
            '000000',
            'Black'
        ],
        [
            '000080',
            'Navy Blue'
        ],
        [
            '0000C8',
            'Dark Blue'
        ],
        [
            '0000FF',
            'Blue'
        ],
        [
            '000741',
            'Stratos'
        ],
        [
            '001B1C',
            'Swamp'
        ],
        [
            '002387',
            'Resolution Blue'
        ],
        [
            '002900',
            'Deep Fir'
        ],
        [
            '002E20',
            'Burnham'
        ],
        [
            '002FA7',
            'International Klein Blue'
        ],
        [
            '003153',
            'Prussian Blue'
        ],
        [
            '003366',
            'Midnight Blue'
        ],
        [
            '003399',
            'Smalt'
        ],
        [
            '003532',
            'Deep Teal'
        ],
        [
            '003E40',
            'Cyprus'
        ],
        [
            '004620',
            'Kaitoke Green'
        ],
        [
            '0047AB',
            'Cobalt'
        ],
        [
            '004816',
            'Crusoe'
        ],
        [
            '004950',
            'Sherpa Blue'
        ],
        [
            '0056A7',
            'Endeavour'
        ],
        [
            '00581A',
            'Camarone'
        ],
        [
            '0066CC',
            'Science Blue'
        ],
        [
            '0066FF',
            'Blue Ribbon'
        ],
        [
            '00755E',
            'Tropical Rain Forest'
        ],
        [
            '0076A3',
            'Allports'
        ],
        [
            '007BA7',
            'Deep Cerulean'
        ],
        [
            '007EC7',
            'Lochmara'
        ],
        [
            '007FFF',
            'Azure Radiance'
        ],
        [
            '008080',
            'Teal'
        ],
        [
            '0095B6',
            'Bondi Blue'
        ],
        [
            '009DC4',
            'Pacific Blue'
        ],
        [
            '00A693',
            'Persian Green'
        ],
        [
            '00A86B',
            'Jade'
        ],
        [
            '00CC99',
            'Caribbean Green'
        ],
        [
            '00CCCC',
            "Robin's Egg Blue"
        ],
        [
            '00FF00',
            'Green'
        ],
        [
            '00FF7F',
            'Spring Green'
        ],
        [
            '00FFFF',
            'Cyan / Aqua'
        ],
        [
            '010D1A',
            'Blue Charcoal'
        ],
        [
            '011635',
            'Midnight'
        ],
        [
            '011D13',
            'Holly'
        ],
        [
            '012731',
            'Daintree'
        ],
        [
            '01361C',
            'Cardin Green'
        ],
        [
            '01371A',
            'County Green'
        ],
        [
            '013E62',
            'Astronaut Blue'
        ],
        [
            '013F6A',
            'Regal Blue'
        ],
        [
            '014B43',
            'Aqua Deep'
        ],
        [
            '015E85',
            'Orient'
        ],
        [
            '016162',
            'Blue Stone'
        ],
        [
            '016D39',
            'Fun Green'
        ],
        [
            '01796F',
            'Pine Green'
        ],
        [
            '017987',
            'Blue Lagoon'
        ],
        [
            '01826B',
            'Deep Sea'
        ],
        [
            '01A368',
            'Green Haze'
        ],
        [
            '022D15',
            'English Holly'
        ],
        [
            '02402C',
            'Sherwood Green'
        ],
        [
            '02478E',
            'Congress Blue'
        ],
        [
            '024E46',
            'Evening Sea'
        ],
        [
            '026395',
            'Bahama Blue'
        ],
        [
            '02866F',
            'Observatory'
        ],
        [
            '02A4D3',
            'Cerulean'
        ],
        [
            '03163C',
            'Tangaroa'
        ],
        [
            '032B52',
            'Green Vogue'
        ],
        [
            '036A6E',
            'Mosque'
        ],
        [
            '041004',
            'Midnight Moss'
        ],
        [
            '041322',
            'Black Pearl'
        ],
        [
            '042E4C',
            'Blue Whale'
        ],
        [
            '044022',
            'Zuccini'
        ],
        [
            '044259',
            'Teal Blue'
        ],
        [
            '051040',
            'Deep Cove'
        ],
        [
            '051657',
            'Gulf Blue'
        ],
        [
            '055989',
            'Venice Blue'
        ],
        [
            '056F57',
            'Watercourse'
        ],
        [
            '062A78',
            'Catalina Blue'
        ],
        [
            '063537',
            'Tiber'
        ],
        [
            '069B81',
            'Gossamer'
        ],
        [
            '06A189',
            'Niagara'
        ],
        [
            '073A50',
            'Tarawera'
        ],
        [
            '080110',
            'Jaguar'
        ],
        [
            '081910',
            'Black Bean'
        ],
        [
            '082567',
            'Deep Sapphire'
        ],
        [
            '088370',
            'Elf Green'
        ],
        [
            '08E8DE',
            'Bright Turquoise'
        ],
        [
            '092256',
            'Downriver'
        ],
        [
            '09230F',
            'Palm Green'
        ],
        [
            '09255D',
            'Madison'
        ],
        [
            '093624',
            'Bottle Green'
        ],
        [
            '095859',
            'Deep Sea Green'
        ],
        [
            '097F4B',
            'Salem'
        ],
        [
            '0A001C',
            'Black Russian'
        ],
        [
            '0A480D',
            'Dark Fern'
        ],
        [
            '0A6906',
            'Japanese Laurel'
        ],
        [
            '0A6F75',
            'Atoll'
        ],
        [
            '0B0B0B',
            'Cod Gray'
        ],
        [
            '0B0F08',
            'Marshland'
        ],
        [
            '0B1107',
            'Gordons Green'
        ],
        [
            '0B1304',
            'Black Forest'
        ],
        [
            '0B6207',
            'San Felix'
        ],
        [
            '0BDA51',
            'Malachite'
        ],
        [
            '0C0B1D',
            'Ebony'
        ],
        [
            '0C0D0F',
            'Woodsmoke'
        ],
        [
            '0C1911',
            'Racing Green'
        ],
        [
            '0C7A79',
            'Surfie Green'
        ],
        [
            '0C8990',
            'Blue Chill'
        ],
        [
            '0D0332',
            'Black Rock'
        ],
        [
            '0D1117',
            'Bunker'
        ],
        [
            '0D1C19',
            'Aztec'
        ],
        [
            '0D2E1C',
            'Bush'
        ],
        [
            '0E0E18',
            'Cinder'
        ],
        [
            '0E2A30',
            'Firefly'
        ],
        [
            '0F2D9E',
            'Torea Bay'
        ],
        [
            '10121D',
            'Vulcan'
        ],
        [
            '101405',
            'Green Waterloo'
        ],
        [
            '105852',
            'Eden'
        ],
        [
            '110C6C',
            'Arapawa'
        ],
        [
            '120A8F',
            'Ultramarine'
        ],
        [
            '123447',
            'Elephant'
        ],
        [
            '126B40',
            'Jewel'
        ],
        [
            '130000',
            'Diesel'
        ],
        [
            '130A06',
            'Asphalt'
        ],
        [
            '13264D',
            'Blue Zodiac'
        ],
        [
            '134F19',
            'Parsley'
        ],
        [
            '140600',
            'Nero'
        ],
        [
            '1450AA',
            'Tory Blue'
        ],
        [
            '151F4C',
            'Bunting'
        ],
        [
            '1560BD',
            'Denim'
        ],
        [
            '15736B',
            'Genoa'
        ],
        [
            '161928',
            'Mirage'
        ],
        [
            '161D10',
            'Hunter Green'
        ],
        [
            '162A40',
            'Big Stone'
        ],
        [
            '163222',
            'Celtic'
        ],
        [
            '16322C',
            'Timber Green'
        ],
        [
            '163531',
            'Gable Green'
        ],
        [
            '171F04',
            'Pine Tree'
        ],
        [
            '175579',
            'Chathams Blue'
        ],
        [
            '182D09',
            'Deep Forest Green'
        ],
        [
            '18587A',
            'Blumine'
        ],
        [
            '19330E',
            'Palm Leaf'
        ],
        [
            '193751',
            'Nile Blue'
        ],
        [
            '1959A8',
            'Fun Blue'
        ],
        [
            '1A1A68',
            'Lucky Point'
        ],
        [
            '1AB385',
            'Mountain Meadow'
        ],
        [
            '1B0245',
            'Tolopea'
        ],
        [
            '1B1035',
            'Haiti'
        ],
        [
            '1B127B',
            'Deep Koamaru'
        ],
        [
            '1B1404',
            'Acadia'
        ],
        [
            '1B2F11',
            'Seaweed'
        ],
        [
            '1B3162',
            'Biscay'
        ],
        [
            '1B659D',
            'Matisse'
        ],
        [
            '1C1208',
            'Crowshead'
        ],
        [
            '1C1E13',
            'Rangoon Green'
        ],
        [
            '1C39BB',
            'Persian Blue'
        ],
        [
            '1C402E',
            'Everglade'
        ],
        [
            '1C7C7D',
            'Elm'
        ],
        [
            '1D6142',
            'Green Pea'
        ],
        [
            '1E0F04',
            'Creole'
        ],
        [
            '1E1609',
            'Karaka'
        ],
        [
            '1E1708',
            'El Paso'
        ],
        [
            '1E385B',
            'Cello'
        ],
        [
            '1E433C',
            'Te Papa Green'
        ],
        [
            '1E90FF',
            'Dodger Blue'
        ],
        [
            '1E9AB0',
            'Eastern Blue'
        ],
        [
            '1F120F',
            'Night Rider'
        ],
        [
            '1FC2C2',
            'Java'
        ],
        [
            '20208D',
            'Jacksons Purple'
        ],
        [
            '202E54',
            'Cloud Burst'
        ],
        [
            '204852',
            'Blue Dianne'
        ],
        [
            '211A0E',
            'Eternity'
        ],
        [
            '220878',
            'Deep Blue'
        ],
        [
            '228B22',
            'Forest Green'
        ],
        [
            '233418',
            'Mallard'
        ],
        [
            '240A40',
            'Violet'
        ],
        [
            '240C02',
            'Kilamanjaro'
        ],
        [
            '242A1D',
            'Log Cabin'
        ],
        [
            '242E16',
            'Black Olive'
        ],
        [
            '24500F',
            'Green House'
        ],
        [
            '251607',
            'Graphite'
        ],
        [
            '251706',
            'Cannon Black'
        ],
        [
            '251F4F',
            'Port Gore'
        ],
        [
            '25272C',
            'Shark'
        ],
        [
            '25311C',
            'Green Kelp'
        ],
        [
            '2596D1',
            'Curious Blue'
        ],
        [
            '260368',
            'Paua'
        ],
        [
            '26056A',
            'Paris M'
        ],
        [
            '261105',
            'Wood Bark'
        ],
        [
            '261414',
            'Gondola'
        ],
        [
            '262335',
            'Steel Gray'
        ],
        [
            '26283B',
            'Ebony Clay'
        ],
        [
            '273A81',
            'Bay of Many'
        ],
        [
            '27504B',
            'Plantation'
        ],
        [
            '278A5B',
            'Eucalyptus'
        ],
        [
            '281E15',
            'Oil'
        ],
        [
            '283A77',
            'Astronaut'
        ],
        [
            '286ACD',
            'Mariner'
        ],
        [
            '290C5E',
            'Violent Violet'
        ],
        [
            '292130',
            'Bastille'
        ],
        [
            '292319',
            'Zeus'
        ],
        [
            '292937',
            'Charade'
        ],
        [
            '297B9A',
            'Jelly Bean'
        ],
        [
            '29AB87',
            'Jungle Green'
        ],
        [
            '2A0359',
            'Cherry Pie'
        ],
        [
            '2A140E',
            'Coffee Bean'
        ],
        [
            '2A2630',
            'Baltic Sea'
        ],
        [
            '2A380B',
            'Turtle Green'
        ],
        [
            '2A52BE',
            'Cerulean Blue'
        ],
        [
            '2B0202',
            'Sepia Black'
        ],
        [
            '2B194F',
            'Valhalla'
        ],
        [
            '2B3228',
            'Heavy Metal'
        ],
        [
            '2C0E8C',
            'Blue Gem'
        ],
        [
            '2C1632',
            'Revolver'
        ],
        [
            '2C2133',
            'Bleached Cedar'
        ],
        [
            '2C8C84',
            'Lochinvar'
        ],
        [
            '2D2510',
            'Mikado'
        ],
        [
            '2D383A',
            'Outer Space'
        ],
        [
            '2D569B',
            'St Tropaz'
        ],
        [
            '2E0329',
            'Jacaranda'
        ],
        [
            '2E1905',
            'Jacko Bean'
        ],
        [
            '2E3222',
            'Rangitoto'
        ],
        [
            '2E3F62',
            'Rhino'
        ],
        [
            '2E8B57',
            'Sea Green'
        ],
        [
            '2EBFD4',
            'Scooter'
        ],
        [
            '2F270E',
            'Onion'
        ],
        [
            '2F3CB3',
            'Governor Bay'
        ],
        [
            '2F519E',
            'Sapphire'
        ],
        [
            '2F5A57',
            'Spectra'
        ],
        [
            '2F6168',
            'Casal'
        ],
        [
            '300529',
            'Melanzane'
        ],
        [
            '301F1E',
            'Cocoa Brown'
        ],
        [
            '302A0F',
            'Woodrush'
        ],
        [
            '304B6A',
            'San Juan'
        ],
        [
            '30D5C8',
            'Turquoise'
        ],
        [
            '311C17',
            'Eclipse'
        ],
        [
            '314459',
            'Pickled Bluewood'
        ],
        [
            '315BA1',
            'Azure'
        ],
        [
            '31728D',
            'Calypso'
        ],
        [
            '317D82',
            'Paradiso'
        ],
        [
            '32127A',
            'Persian Indigo'
        ],
        [
            '32293A',
            'Blackcurrant'
        ],
        [
            '323232',
            'Mine Shaft'
        ],
        [
            '325D52',
            'Stromboli'
        ],
        [
            '327C14',
            'Bilbao'
        ],
        [
            '327DA0',
            'Astral'
        ],
        [
            '33036B',
            'Christalle'
        ],
        [
            '33292F',
            'Thunder'
        ],
        [
            '33CC99',
            'Shamrock'
        ],
        [
            '341515',
            'Tamarind'
        ],
        [
            '350036',
            'Mardi Gras'
        ],
        [
            '350E42',
            'Valentino'
        ],
        [
            '350E57',
            'Jagger'
        ],
        [
            '353542',
            'Tuna'
        ],
        [
            '354E8C',
            'Chambray'
        ],
        [
            '363050',
            'Martinique'
        ],
        [
            '363534',
            'Tuatara'
        ],
        [
            '363C0D',
            'Waiouru'
        ],
        [
            '36747D',
            'Ming'
        ],
        [
            '368716',
            'La Palma'
        ],
        [
            '370202',
            'Chocolate'
        ],
        [
            '371D09',
            'Clinker'
        ],
        [
            '37290E',
            'Brown Tumbleweed'
        ],
        [
            '373021',
            'Birch'
        ],
        [
            '377475',
            'Oracle'
        ],
        [
            '380474',
            'Blue Diamond'
        ],
        [
            '381A51',
            'Grape'
        ],
        [
            '383533',
            'Dune'
        ],
        [
            '384555',
            'Oxford Blue'
        ],
        [
            '384910',
            'Clover'
        ],
        [
            '394851',
            'Limed Spruce'
        ],
        [
            '396413',
            'Dell'
        ],
        [
            '3A0020',
            'Toledo'
        ],
        [
            '3A2010',
            'Sambuca'
        ],
        [
            '3A2A6A',
            'Jacarta'
        ],
        [
            '3A686C',
            'William'
        ],
        [
            '3A6A47',
            'Killarney'
        ],
        [
            '3AB09E',
            'Keppel'
        ],
        [
            '3B000B',
            'Temptress'
        ],
        [
            '3B0910',
            'Aubergine'
        ],
        [
            '3B1F1F',
            'Jon'
        ],
        [
            '3B2820',
            'Treehouse'
        ],
        [
            '3B7A57',
            'Amazon'
        ],
        [
            '3B91B4',
            'Boston Blue'
        ],
        [
            '3C0878',
            'Windsor'
        ],
        [
            '3C1206',
            'Rebel'
        ],
        [
            '3C1F76',
            'Meteorite'
        ],
        [
            '3C2005',
            'Dark Ebony'
        ],
        [
            '3C3910',
            'Camouflage'
        ],
        [
            '3C4151',
            'Bright Gray'
        ],
        [
            '3C4443',
            'Cape Cod'
        ],
        [
            '3C493A',
            'Lunar Green'
        ],
        [
            '3D0C02',
            'Bean  '
        ],
        [
            '3D2B1F',
            'Bistre'
        ],
        [
            '3D7D52',
            'Goblin'
        ],
        [
            '3E0480',
            'Kingfisher Daisy'
        ],
        [
            '3E1C14',
            'Cedar'
        ],
        [
            '3E2B23',
            'English Walnut'
        ],
        [
            '3E2C1C',
            'Black Marlin'
        ],
        [
            '3E3A44',
            'Ship Gray'
        ],
        [
            '3EABBF',
            'Pelorous'
        ],
        [
            '3F2109',
            'Bronze'
        ],
        [
            '3F2500',
            'Cola'
        ],
        [
            '3F3002',
            'Madras'
        ],
        [
            '3F307F',
            'Minsk'
        ],
        [
            '3F4C3A',
            'Cabbage Pont'
        ],
        [
            '3F583B',
            'Tom Thumb'
        ],
        [
            '3F5D53',
            'Mineral Green'
        ],
        [
            '3FC1AA',
            'Puerto Rico'
        ],
        [
            '3FFF00',
            'Harlequin'
        ],
        [
            '401801',
            'Brown Pod'
        ],
        [
            '40291D',
            'Cork'
        ],
        [
            '403B38',
            'Masala'
        ],
        [
            '403D19',
            'Thatch Green'
        ],
        [
            '405169',
            'Fiord'
        ],
        [
            '40826D',
            'Viridian'
        ],
        [
            '40A860',
            'Chateau Green'
        ],
        [
            '410056',
            'Ripe Plum'
        ],
        [
            '411F10',
            'Paco'
        ],
        [
            '412010',
            'Deep Oak'
        ],
        [
            '413C37',
            'Merlin'
        ],
        [
            '414257',
            'Gun Powder'
        ],
        [
            '414C7D',
            'East Bay'
        ],
        [
            '4169E1',
            'Royal Blue'
        ],
        [
            '41AA78',
            'Ocean Green'
        ],
        [
            '420303',
            'Burnt Maroon'
        ],
        [
            '423921',
            'Lisbon Brown'
        ],
        [
            '427977',
            'Faded Jade'
        ],
        [
            '431560',
            'Scarlet Gum'
        ],
        [
            '433120',
            'Iroko'
        ],
        [
            '433E37',
            'Armadillo'
        ],
        [
            '434C59',
            'River Bed'
        ],
        [
            '436A0D',
            'Green Leaf'
        ],
        [
            '44012D',
            'Barossa'
        ],
        [
            '441D00',
            'Morocco Brown'
        ],
        [
            '444954',
            'Mako'
        ],
        [
            '454936',
            'Kelp'
        ],
        [
            '456CAC',
            'San Marino'
        ],
        [
            '45B1E8',
            'Picton Blue'
        ],
        [
            '460B41',
            'Loulou'
        ],
        [
            '462425',
            'Crater Brown'
        ],
        [
            '465945',
            'Gray Asparagus'
        ],
        [
            '4682B4',
            'Steel Blue'
        ],
        [
            '480404',
            'Rustic Red'
        ],
        [
            '480607',
            'Bulgarian Rose'
        ],
        [
            '480656',
            'Clairvoyant'
        ],
        [
            '481C1C',
            'Cocoa Bean'
        ],
        [
            '483131',
            'Woody Brown'
        ],
        [
            '483C32',
            'Taupe'
        ],
        [
            '49170C',
            'Van Cleef'
        ],
        [
            '492615',
            'Brown Derby'
        ],
        [
            '49371B',
            'Metallic Bronze'
        ],
        [
            '495400',
            'Verdun Green'
        ],
        [
            '496679',
            'Blue Bayoux'
        ],
        [
            '497183',
            'Bismark'
        ],
        [
            '4A2A04',
            'Bracken'
        ],
        [
            '4A3004',
            'Deep Bronze'
        ],
        [
            '4A3C30',
            'Mondo'
        ],
        [
            '4A4244',
            'Tundora'
        ],
        [
            '4A444B',
            'Gravel'
        ],
        [
            '4A4E5A',
            'Trout'
        ],
        [
            '4B0082',
            'Pigment Indigo'
        ],
        [
            '4B5D52',
            'Nandor'
        ],
        [
            '4C3024',
            'Saddle'
        ],
        [
            '4C4F56',
            'Abbey'
        ],
        [
            '4D0135',
            'Blackberry'
        ],
        [
            '4D0A18',
            'Cab Sav'
        ],
        [
            '4D1E01',
            'Indian Tan'
        ],
        [
            '4D282D',
            'Cowboy'
        ],
        [
            '4D282E',
            'Livid Brown'
        ],
        [
            '4D3833',
            'Rock'
        ],
        [
            '4D3D14',
            'Punga'
        ],
        [
            '4D400F',
            'Bronzetone'
        ],
        [
            '4D5328',
            'Woodland'
        ],
        [
            '4E0606',
            'Mahogany'
        ],
        [
            '4E2A5A',
            'Bossanova'
        ],
        [
            '4E3B41',
            'Matterhorn'
        ],
        [
            '4E420C',
            'Bronze Olive'
        ],
        [
            '4E4562',
            'Mulled Wine'
        ],
        [
            '4E6649',
            'Axolotl'
        ],
        [
            '4E7F9E',
            'Wedgewood'
        ],
        [
            '4EABD1',
            'Shakespeare'
        ],
        [
            '4F1C70',
            'Honey Flower'
        ],
        [
            '4F2398',
            'Daisy Bush'
        ],
        [
            '4F69C6',
            'Indigo'
        ],
        [
            '4F7942',
            'Fern Green'
        ],
        [
            '4F9D5D',
            'Fruit Salad'
        ],
        [
            '4FA83D',
            'Apple'
        ],
        [
            '504351',
            'Mortar'
        ],
        [
            '507096',
            'Kashmir Blue'
        ],
        [
            '507672',
            'Cutty Sark'
        ],
        [
            '50C878',
            'Emerald'
        ],
        [
            '514649',
            'Emperor'
        ],
        [
            '516E3D',
            'Chalet Green'
        ],
        [
            '517C66',
            'Como'
        ],
        [
            '51808F',
            'Smalt Blue'
        ],
        [
            '52001F',
            'Castro'
        ],
        [
            '520C17',
            'Maroon Oak'
        ],
        [
            '523C94',
            'Gigas'
        ],
        [
            '533455',
            'Voodoo'
        ],
        [
            '534491',
            'Victoria'
        ],
        [
            '53824B',
            'Hippie Green'
        ],
        [
            '541012',
            'Heath'
        ],
        [
            '544333',
            'Judge Gray'
        ],
        [
            '54534D',
            'Fuscous Gray'
        ],
        [
            '549019',
            'Vida Loca'
        ],
        [
            '55280C',
            'Cioccolato'
        ],
        [
            '555B10',
            'Saratoga'
        ],
        [
            '556D56',
            'Finlandia'
        ],
        [
            '5590D9',
            'Havelock Blue'
        ],
        [
            '56B4BE',
            'Fountain Blue'
        ],
        [
            '578363',
            'Spring Leaves'
        ],
        [
            '583401',
            'Saddle Brown'
        ],
        [
            '585562',
            'Scarpa Flow'
        ],
        [
            '587156',
            'Cactus'
        ],
        [
            '589AAF',
            'Hippie Blue'
        ],
        [
            '591D35',
            'Wine Berry'
        ],
        [
            '592804',
            'Brown Bramble'
        ],
        [
            '593737',
            'Congo Brown'
        ],
        [
            '594433',
            'Millbrook'
        ],
        [
            '5A6E9C',
            'Waikawa Gray'
        ],
        [
            '5A87A0',
            'Horizon'
        ],
        [
            '5B3013',
            'Jambalaya'
        ],
        [
            '5C0120',
            'Bordeaux'
        ],
        [
            '5C0536',
            'Mulberry Wood'
        ],
        [
            '5C2E01',
            'Carnaby Tan'
        ],
        [
            '5C5D75',
            'Comet'
        ],
        [
            '5D1E0F',
            'Redwood'
        ],
        [
            '5D4C51',
            'Don Juan'
        ],
        [
            '5D5C58',
            'Chicago'
        ],
        [
            '5D5E37',
            'Verdigris'
        ],
        [
            '5D7747',
            'Dingley'
        ],
        [
            '5DA19F',
            'Breaker Bay'
        ],
        [
            '5E483E',
            'Kabul'
        ],
        [
            '5E5D3B',
            'Hemlock'
        ],
        [
            '5F3D26',
            'Irish Coffee'
        ],
        [
            '5F5F6E',
            'Mid Gray'
        ],
        [
            '5F6672',
            'Shuttle Gray'
        ],
        [
            '5FA777',
            'Aqua Forest'
        ],
        [
            '5FB3AC',
            'Tradewind'
        ],
        [
            '604913',
            'Horses Neck'
        ],
        [
            '605B73',
            'Smoky'
        ],
        [
            '606E68',
            'Corduroy'
        ],
        [
            '6093D1',
            'Danube'
        ],
        [
            '612718',
            'Espresso'
        ],
        [
            '614051',
            'Eggplant'
        ],
        [
            '615D30',
            'Costa Del Sol'
        ],
        [
            '61845F',
            'Glade Green'
        ],
        [
            '622F30',
            'Buccaneer'
        ],
        [
            '623F2D',
            'Quincy'
        ],
        [
            '624E9A',
            'Butterfly Bush'
        ],
        [
            '625119',
            'West Coast'
        ],
        [
            '626649',
            'Finch'
        ],
        [
            '639A8F',
            'Patina'
        ],
        [
            '63B76C',
            'Fern'
        ],
        [
            '6456B7',
            'Blue Violet'
        ],
        [
            '646077',
            'Dolphin'
        ],
        [
            '646463',
            'Storm Dust'
        ],
        [
            '646A54',
            'Siam'
        ],
        [
            '646E75',
            'Nevada'
        ],
        [
            '6495ED',
            'Cornflower Blue'
        ],
        [
            '64CCDB',
            'Viking'
        ],
        [
            '65000B',
            'Rosewood'
        ],
        [
            '651A14',
            'Cherrywood'
        ],
        [
            '652DC1',
            'Purple Heart'
        ],
        [
            '657220',
            'Fern Frond'
        ],
        [
            '65745D',
            'Willow Grove'
        ],
        [
            '65869F',
            'Hoki'
        ],
        [
            '660045',
            'Pompadour'
        ],
        [
            '660099',
            'Purple'
        ],
        [
            '66023C',
            'Tyrian Purple'
        ],
        [
            '661010',
            'Dark Tan'
        ],
        [
            '66B58F',
            'Silver Tree'
        ],
        [
            '66FF00',
            'Bright Green'
        ],
        [
            '66FF66',
            "Screamin' Green"
        ],
        [
            '67032D',
            'Black Rose'
        ],
        [
            '675FA6',
            'Scampi'
        ],
        [
            '676662',
            'Ironside Gray'
        ],
        [
            '678975',
            'Viridian Green'
        ],
        [
            '67A712',
            'Christi'
        ],
        [
            '683600',
            'Nutmeg Wood Finish'
        ],
        [
            '685558',
            'Zambezi'
        ],
        [
            '685E6E',
            'Salt Box'
        ],
        [
            '692545',
            'Tawny Port'
        ],
        [
            '692D54',
            'Finn'
        ],
        [
            '695F62',
            'Scorpion'
        ],
        [
            '697E9A',
            'Lynch'
        ],
        [
            '6A442E',
            'Spice'
        ],
        [
            '6A5D1B',
            'Himalaya'
        ],
        [
            '6A6051',
            'Soya Bean'
        ],
        [
            '6B2A14',
            'Hairy Heath'
        ],
        [
            '6B3FA0',
            'Royal Purple'
        ],
        [
            '6B4E31',
            'Shingle Fawn'
        ],
        [
            '6B5755',
            'Dorado'
        ],
        [
            '6B8BA2',
            'Bermuda Gray'
        ],
        [
            '6B8E23',
            'Olive Drab'
        ],
        [
            '6C3082',
            'Eminence'
        ],
        [
            '6CDAE7',
            'Turquoise Blue'
        ],
        [
            '6D0101',
            'Lonestar'
        ],
        [
            '6D5E54',
            'Pine Cone'
        ],
        [
            '6D6C6C',
            'Dove Gray'
        ],
        [
            '6D9292',
            'Juniper'
        ],
        [
            '6D92A1',
            'Gothic'
        ],
        [
            '6E0902',
            'Red Oxide'
        ],
        [
            '6E1D14',
            'Moccaccino'
        ],
        [
            '6E4826',
            'Pickled Bean'
        ],
        [
            '6E4B26',
            'Dallas'
        ],
        [
            '6E6D57',
            'Kokoda'
        ],
        [
            '6E7783',
            'Pale Sky'
        ],
        [
            '6F440C',
            'Cafe Royale'
        ],
        [
            '6F6A61',
            'Flint'
        ],
        [
            '6F8E63',
            'Highland'
        ],
        [
            '6F9D02',
            'Limeade'
        ],
        [
            '6FD0C5',
            'Downy'
        ],
        [
            '701C1C',
            'Persian Plum'
        ],
        [
            '704214',
            'Sepia'
        ],
        [
            '704A07',
            'Antique Bronze'
        ],
        [
            '704F50',
            'Ferra'
        ],
        [
            '706555',
            'Coffee'
        ],
        [
            '708090',
            'Slate Gray'
        ],
        [
            '711A00',
            'Cedar Wood Finish'
        ],
        [
            '71291D',
            'Metallic Copper'
        ],
        [
            '714693',
            'Affair'
        ],
        [
            '714AB2',
            'Studio'
        ],
        [
            '715D47',
            'Tobacco Brown'
        ],
        [
            '716338',
            'Yellow Metal'
        ],
        [
            '716B56',
            'Peat'
        ],
        [
            '716E10',
            'Olivetone'
        ],
        [
            '717486',
            'Storm Gray'
        ],
        [
            '718080',
            'Sirocco'
        ],
        [
            '71D9E2',
            'Aquamarine Blue'
        ],
        [
            '72010F',
            'Venetian Red'
        ],
        [
            '724A2F',
            'Old Copper'
        ],
        [
            '726D4E',
            'Go Ben'
        ],
        [
            '727B89',
            'Raven'
        ],
        [
            '731E8F',
            'Seance'
        ],
        [
            '734A12',
            'Raw Umber'
        ],
        [
            '736C9F',
            'Kimberly'
        ],
        [
            '736D58',
            'Crocodile'
        ],
        [
            '737829',
            'Crete'
        ],
        [
            '738678',
            'Xanadu'
        ],
        [
            '74640D',
            'Spicy Mustard'
        ],
        [
            '747D63',
            'Limed Ash'
        ],
        [
            '747D83',
            'Rolling Stone'
        ],
        [
            '748881',
            'Blue Smoke'
        ],
        [
            '749378',
            'Laurel'
        ],
        [
            '74C365',
            'Mantis'
        ],
        [
            '755A57',
            'Russett'
        ],
        [
            '7563A8',
            'Deluge'
        ],
        [
            '76395D',
            'Cosmic'
        ],
        [
            '7666C6',
            'Blue Marguerite'
        ],
        [
            '76BD17',
            'Lima'
        ],
        [
            '76D7EA',
            'Sky Blue'
        ],
        [
            '770F05',
            'Dark Burgundy'
        ],
        [
            '771F1F',
            'Crown of Thorns'
        ],
        [
            '773F1A',
            'Walnut'
        ],
        [
            '776F61',
            'Pablo'
        ],
        [
            '778120',
            'Pacifika'
        ],
        [
            '779E86',
            'Oxley'
        ],
        [
            '77DD77',
            'Pastel Green'
        ],
        [
            '780109',
            'Japanese Maple'
        ],
        [
            '782D19',
            'Mocha'
        ],
        [
            '782F16',
            'Peanut'
        ],
        [
            '78866B',
            'Camouflage Green'
        ],
        [
            '788A25',
            'Wasabi'
        ],
        [
            '788BBA',
            'Ship Cove'
        ],
        [
            '78A39C',
            'Sea Nymph'
        ],
        [
            '795D4C',
            'Roman Coffee'
        ],
        [
            '796878',
            'Old Lavender'
        ],
        [
            '796989',
            'Rum'
        ],
        [
            '796A78',
            'Fedora'
        ],
        [
            '796D62',
            'Sandstone'
        ],
        [
            '79DEEC',
            'Spray'
        ],
        [
            '7A013A',
            'Siren'
        ],
        [
            '7A58C1',
            'Fuchsia Blue'
        ],
        [
            '7A7A7A',
            'Boulder'
        ],
        [
            '7A89B8',
            'Wild Blue Yonder'
        ],
        [
            '7AC488',
            'De York'
        ],
        [
            '7B3801',
            'Red Beech'
        ],
        [
            '7B3F00',
            'Cinnamon'
        ],
        [
            '7B6608',
            'Yukon Gold'
        ],
        [
            '7B7874',
            'Tapa'
        ],
        [
            '7B7C94',
            'Waterloo '
        ],
        [
            '7B8265',
            'Flax Smoke'
        ],
        [
            '7B9F80',
            'Amulet'
        ],
        [
            '7BA05B',
            'Asparagus'
        ],
        [
            '7C1C05',
            'Kenyan Copper'
        ],
        [
            '7C7631',
            'Pesto'
        ],
        [
            '7C778A',
            'Topaz'
        ],
        [
            '7C7B7A',
            'Concord'
        ],
        [
            '7C7B82',
            'Jumbo'
        ],
        [
            '7C881A',
            'Trendy Green'
        ],
        [
            '7CA1A6',
            'Gumbo'
        ],
        [
            '7CB0A1',
            'Acapulco'
        ],
        [
            '7CB7BB',
            'Neptune'
        ],
        [
            '7D2C14',
            'Pueblo'
        ],
        [
            '7DA98D',
            'Bay Leaf'
        ],
        [
            '7DC8F7',
            'Malibu'
        ],
        [
            '7DD8C6',
            'Bermuda'
        ],
        [
            '7E3A15',
            'Copper Canyon'
        ],
        [
            '7F1734',
            'Claret'
        ],
        [
            '7F3A02',
            'Peru Tan'
        ],
        [
            '7F626D',
            'Falcon'
        ],
        [
            '7F7589',
            'Mobster'
        ],
        [
            '7F76D3',
            'Moody Blue'
        ],
        [
            '7FFF00',
            'Chartreuse'
        ],
        [
            '7FFFD4',
            'Aquamarine'
        ],
        [
            '800000',
            'Maroon'
        ],
        [
            '800B47',
            'Rose Bud Cherry'
        ],
        [
            '801818',
            'Falu Red'
        ],
        [
            '80341F',
            'Red Robin'
        ],
        [
            '803790',
            'Vivid Violet'
        ],
        [
            '80461B',
            'Russet'
        ],
        [
            '807E79',
            'Friar Gray'
        ],
        [
            '808000',
            'Olive'
        ],
        [
            '808080',
            'Gray'
        ],
        [
            '80B3AE',
            'Gulf Stream'
        ],
        [
            '80B3C4',
            'Glacier'
        ],
        [
            '80CCEA',
            'Seagull'
        ],
        [
            '81422C',
            'Nutmeg'
        ],
        [
            '816E71',
            'Spicy Pink'
        ],
        [
            '817377',
            'Empress'
        ],
        [
            '819885',
            'Spanish Green'
        ],
        [
            '826F65',
            'Sand Dune'
        ],
        [
            '828685',
            'Gunsmoke'
        ],
        [
            '828F72',
            'Battleship Gray'
        ],
        [
            '831923',
            'Merlot'
        ],
        [
            '837050',
            'Shadow'
        ],
        [
            '83AA5D',
            'Chelsea Cucumber'
        ],
        [
            '83D0C6',
            'Monte Carlo'
        ],
        [
            '843179',
            'Plum'
        ],
        [
            '84A0A0',
            'Granny Smith'
        ],
        [
            '8581D9',
            'Chetwode Blue'
        ],
        [
            '858470',
            'Bandicoot'
        ],
        [
            '859FAF',
            'Bali Hai'
        ],
        [
            '85C4CC',
            'Half Baked'
        ],
        [
            '860111',
            'Red Devil'
        ],
        [
            '863C3C',
            'Lotus'
        ],
        [
            '86483C',
            'Ironstone'
        ],
        [
            '864D1E',
            'Bull Shot'
        ],
        [
            '86560A',
            'Rusty Nail'
        ],
        [
            '868974',
            'Bitter'
        ],
        [
            '86949F',
            'Regent Gray'
        ],
        [
            '871550',
            'Disco'
        ],
        [
            '87756E',
            'Americano'
        ],
        [
            '877C7B',
            'Hurricane'
        ],
        [
            '878D91',
            'Oslo Gray'
        ],
        [
            '87AB39',
            'Sushi'
        ],
        [
            '885342',
            'Spicy Mix'
        ],
        [
            '886221',
            'Kumera'
        ],
        [
            '888387',
            'Suva Gray'
        ],
        [
            '888D65',
            'Avocado'
        ],
        [
            '893456',
            'Camelot'
        ],
        [
            '893843',
            'Solid Pink'
        ],
        [
            '894367',
            'Cannon Pink'
        ],
        [
            '897D6D',
            'Makara'
        ],
        [
            '8A3324',
            'Burnt Umber'
        ],
        [
            '8A73D6',
            'True V'
        ],
        [
            '8A8360',
            'Clay Creek'
        ],
        [
            '8A8389',
            'Monsoon'
        ],
        [
            '8A8F8A',
            'Stack'
        ],
        [
            '8AB9F1',
            'Jordy Blue'
        ],
        [
            '8B00FF',
            'Electric Violet'
        ],
        [
            '8B0723',
            'Monarch'
        ],
        [
            '8B6B0B',
            'Corn Harvest'
        ],
        [
            '8B8470',
            'Olive Haze'
        ],
        [
            '8B847E',
            'Schooner'
        ],
        [
            '8B8680',
            'Natural Gray'
        ],
        [
            '8B9C90',
            'Mantle'
        ],
        [
            '8B9FEE',
            'Portage'
        ],
        [
            '8BA690',
            'Envy'
        ],
        [
            '8BA9A5',
            'Cascade'
        ],
        [
            '8BE6D8',
            'Riptide'
        ],
        [
            '8C055E',
            'Cardinal Pink'
        ],
        [
            '8C472F',
            'Mule Fawn'
        ],
        [
            '8C5738',
            'Potters Clay'
        ],
        [
            '8C6495',
            'Trendy Pink'
        ],
        [
            '8D0226',
            'Paprika'
        ],
        [
            '8D3D38',
            'Sanguine Brown'
        ],
        [
            '8D3F3F',
            'Tosca'
        ],
        [
            '8D7662',
            'Cement'
        ],
        [
            '8D8974',
            'Granite Green'
        ],
        [
            '8D90A1',
            'Manatee'
        ],
        [
            '8DA8CC',
            'Polo Blue'
        ],
        [
            '8E0000',
            'Red Berry'
        ],
        [
            '8E4D1E',
            'Rope'
        ],
        [
            '8E6F70',
            'Opium'
        ],
        [
            '8E775E',
            'Domino'
        ],
        [
            '8E8190',
            'Mamba'
        ],
        [
            '8EABC1',
            'Nepal'
        ],
        [
            '8F021C',
            'Pohutukawa'
        ],
        [
            '8F3E33',
            'El Salva'
        ],
        [
            '8F4B0E',
            'Korma'
        ],
        [
            '8F8176',
            'Squirrel'
        ],
        [
            '8FD6B4',
            'Vista Blue'
        ],
        [
            '900020',
            'Burgundy'
        ],
        [
            '901E1E',
            'Old Brick'
        ],
        [
            '907874',
            'Hemp'
        ],
        [
            '907B71',
            'Almond Frost'
        ],
        [
            '908D39',
            'Sycamore'
        ],
        [
            '92000A',
            'Sangria'
        ],
        [
            '924321',
            'Cumin'
        ],
        [
            '926F5B',
            'Beaver'
        ],
        [
            '928573',
            'Stonewall'
        ],
        [
            '928590',
            'Venus'
        ],
        [
            '9370DB',
            'Medium Purple'
        ],
        [
            '93CCEA',
            'Cornflower'
        ],
        [
            '93DFB8',
            'Algae Green'
        ],
        [
            '944747',
            'Copper Rust'
        ],
        [
            '948771',
            'Arrowtown'
        ],
        [
            '950015',
            'Scarlett'
        ],
        [
            '956387',
            'Strikemaster'
        ],
        [
            '959396',
            'Mountain Mist'
        ],
        [
            '960018',
            'Carmine'
        ],
        [
            '964B00',
            'Brown'
        ],
        [
            '967059',
            'Leather'
        ],
        [
            '9678B6',
            "Purple Mountain's Majesty"
        ],
        [
            '967BB6',
            'Lavender Purple'
        ],
        [
            '96A8A1',
            'Pewter'
        ],
        [
            '96BBAB',
            'Summer Green'
        ],
        [
            '97605D',
            'Au Chico'
        ],
        [
            '9771B5',
            'Wisteria'
        ],
        [
            '97CD2D',
            'Atlantis'
        ],
        [
            '983D61',
            'Vin Rouge'
        ],
        [
            '9874D3',
            'Lilac Bush'
        ],
        [
            '98777B',
            'Bazaar'
        ],
        [
            '98811B',
            'Hacienda'
        ],
        [
            '988D77',
            'Pale Oyster'
        ],
        [
            '98FF98',
            'Mint Green'
        ],
        [
            '990066',
            'Fresh Eggplant'
        ],
        [
            '991199',
            'Violet Eggplant'
        ],
        [
            '991613',
            'Tamarillo'
        ],
        [
            '991B07',
            'Totem Pole'
        ],
        [
            '996666',
            'Copper Rose'
        ],
        [
            '9966CC',
            'Amethyst'
        ],
        [
            '997A8D',
            'Mountbatten Pink'
        ],
        [
            '9999CC',
            'Blue Bell'
        ],
        [
            '9A3820',
            'Prairie Sand'
        ],
        [
            '9A6E61',
            'Toast'
        ],
        [
            '9A9577',
            'Gurkha'
        ],
        [
            '9AB973',
            'Olivine'
        ],
        [
            '9AC2B8',
            'Shadow Green'
        ],
        [
            '9B4703',
            'Oregon'
        ],
        [
            '9B9E8F',
            'Lemon Grass'
        ],
        [
            '9C3336',
            'Stiletto'
        ],
        [
            '9D5616',
            'Hawaiian Tan'
        ],
        [
            '9DACB7',
            'Gull Gray'
        ],
        [
            '9DC209',
            'Pistachio'
        ],
        [
            '9DE093',
            'Granny Smith Apple'
        ],
        [
            '9DE5FF',
            'Anakiwa'
        ],
        [
            '9E5302',
            'Chelsea Gem'
        ],
        [
            '9E5B40',
            'Sepia Skin'
        ],
        [
            '9EA587',
            'Sage'
        ],
        [
            '9EA91F',
            'Citron'
        ],
        [
            '9EB1CD',
            'Rock Blue'
        ],
        [
            '9EDEE0',
            'Morning Glory'
        ],
        [
            '9F381D',
            'Cognac'
        ],
        [
            '9F821C',
            'Reef Gold'
        ],
        [
            '9F9F9C',
            'Star Dust'
        ],
        [
            '9FA0B1',
            'Santas Gray'
        ],
        [
            '9FD7D3',
            'Sinbad'
        ],
        [
            '9FDD8C',
            'Feijoa'
        ],
        [
            'A02712',
            'Tabasco'
        ],
        [
            'A1750D',
            'Buttered Rum'
        ],
        [
            'A1ADB5',
            'Hit Gray'
        ],
        [
            'A1C50A',
            'Citrus'
        ],
        [
            'A1DAD7',
            'Aqua Island'
        ],
        [
            'A1E9DE',
            'Water Leaf'
        ],
        [
            'A2006D',
            'Flirt'
        ],
        [
            'A23B6C',
            'Rouge'
        ],
        [
            'A26645',
            'Cape Palliser'
        ],
        [
            'A2AAB3',
            'Gray Chateau'
        ],
        [
            'A2AEAB',
            'Edward'
        ],
        [
            'A3807B',
            'Pharlap'
        ],
        [
            'A397B4',
            'Amethyst Smoke'
        ],
        [
            'A3E3ED',
            'Blizzard Blue'
        ],
        [
            'A4A49D',
            'Delta'
        ],
        [
            'A4A6D3',
            'Wistful'
        ],
        [
            'A4AF6E',
            'Green Smoke'
        ],
        [
            'A50B5E',
            'Jazzberry Jam'
        ],
        [
            'A59B91',
            'Zorba'
        ],
        [
            'A5CB0C',
            'Bahia'
        ],
        [
            'A62F20',
            'Roof Terracotta'
        ],
        [
            'A65529',
            'Paarl'
        ],
        [
            'A68B5B',
            'Barley Corn'
        ],
        [
            'A69279',
            'Donkey Brown'
        ],
        [
            'A6A29A',
            'Dawn'
        ],
        [
            'A72525',
            'Mexican Red'
        ],
        [
            'A7882C',
            'Luxor Gold'
        ],
        [
            'A85307',
            'Rich Gold'
        ],
        [
            'A86515',
            'Reno Sand'
        ],
        [
            'A86B6B',
            'Coral Tree'
        ],
        [
            'A8989B',
            'Dusty Gray'
        ],
        [
            'A899E6',
            'Dull Lavender'
        ],
        [
            'A8A589',
            'Tallow'
        ],
        [
            'A8AE9C',
            'Bud'
        ],
        [
            'A8AF8E',
            'Locust'
        ],
        [
            'A8BD9F',
            'Norway'
        ],
        [
            'A8E3BD',
            'Chinook'
        ],
        [
            'A9A491',
            'Gray Olive'
        ],
        [
            'A9ACB6',
            'Aluminium'
        ],
        [
            'A9B2C3',
            'Cadet Blue'
        ],
        [
            'A9B497',
            'Schist'
        ],
        [
            'A9BDBF',
            'Tower Gray'
        ],
        [
            'A9BEF2',
            'Perano'
        ],
        [
            'A9C6C2',
            'Opal'
        ],
        [
            'AA375A',
            'Night Shadz'
        ],
        [
            'AA4203',
            'Fire'
        ],
        [
            'AA8B5B',
            'Muesli'
        ],
        [
            'AA8D6F',
            'Sandal'
        ],
        [
            'AAA5A9',
            'Shady Lady'
        ],
        [
            'AAA9CD',
            'Logan'
        ],
        [
            'AAABB7',
            'Spun Pearl'
        ],
        [
            'AAD6E6',
            'Regent St Blue'
        ],
        [
            'AAF0D1',
            'Magic Mint'
        ],
        [
            'AB0563',
            'Lipstick'
        ],
        [
            'AB3472',
            'Royal Heath'
        ],
        [
            'AB917A',
            'Sandrift'
        ],
        [
            'ABA0D9',
            'Cold Purple'
        ],
        [
            'ABA196',
            'Bronco'
        ],
        [
            'AC8A56',
            'Limed Oak'
        ],
        [
            'AC91CE',
            'East Side'
        ],
        [
            'AC9E22',
            'Lemon Ginger'
        ],
        [
            'ACA494',
            'Napa'
        ],
        [
            'ACA586',
            'Hillary'
        ],
        [
            'ACA59F',
            'Cloudy'
        ],
        [
            'ACACAC',
            'Silver Chalice'
        ],
        [
            'ACB78E',
            'Swamp Green'
        ],
        [
            'ACCBB1',
            'Spring Rain'
        ],
        [
            'ACDD4D',
            'Conifer'
        ],
        [
            'ACE1AF',
            'Celadon'
        ],
        [
            'AD781B',
            'Mandalay'
        ],
        [
            'ADBED1',
            'Casper'
        ],
        [
            'ADDFAD',
            'Moss Green'
        ],
        [
            'ADE6C4',
            'Padua'
        ],
        [
            'ADFF2F',
            'Green Yellow'
        ],
        [
            'AE4560',
            'Hippie Pink'
        ],
        [
            'AE6020',
            'Desert'
        ],
        [
            'AE809E',
            'Bouquet'
        ],
        [
            'AF4035',
            'Medium Carmine'
        ],
        [
            'AF4D43',
            'Apple Blossom'
        ],
        [
            'AF593E',
            'Brown Rust'
        ],
        [
            'AF8751',
            'Driftwood'
        ],
        [
            'AF8F2C',
            'Alpine'
        ],
        [
            'AF9F1C',
            'Lucky'
        ],
        [
            'AFA09E',
            'Martini'
        ],
        [
            'AFB1B8',
            'Bombay'
        ],
        [
            'AFBDD9',
            'Pigeon Post'
        ],
        [
            'B04C6A',
            'Cadillac'
        ],
        [
            'B05D54',
            'Matrix'
        ],
        [
            'B05E81',
            'Tapestry'
        ],
        [
            'B06608',
            'Mai Tai'
        ],
        [
            'B09A95',
            'Del Rio'
        ],
        [
            'B0E0E6',
            'Powder Blue'
        ],
        [
            'B0E313',
            'Inch Worm'
        ],
        [
            'B10000',
            'Bright Red'
        ],
        [
            'B14A0B',
            'Vesuvius'
        ],
        [
            'B1610B',
            'Pumpkin Skin'
        ],
        [
            'B16D52',
            'Santa Fe'
        ],
        [
            'B19461',
            'Teak'
        ],
        [
            'B1E2C1',
            'Fringy Flower'
        ],
        [
            'B1F4E7',
            'Ice Cold'
        ],
        [
            'B20931',
            'Shiraz'
        ],
        [
            'B2A1EA',
            'Biloba Flower'
        ],
        [
            'B32D29',
            'Tall Poppy'
        ],
        [
            'B35213',
            'Fiery Orange'
        ],
        [
            'B38007',
            'Hot Toddy'
        ],
        [
            'B3AF95',
            'Taupe Gray'
        ],
        [
            'B3C110',
            'La Rioja'
        ],
        [
            'B43332',
            'Well Read'
        ],
        [
            'B44668',
            'Blush'
        ],
        [
            'B4CFD3',
            'Jungle Mist'
        ],
        [
            'B57281',
            'Turkish Rose'
        ],
        [
            'B57EDC',
            'Lavender'
        ],
        [
            'B5A27F',
            'Mongoose'
        ],
        [
            'B5B35C',
            'Olive Green'
        ],
        [
            'B5D2CE',
            'Jet Stream'
        ],
        [
            'B5ECDF',
            'Cruise'
        ],
        [
            'B6316C',
            'Hibiscus'
        ],
        [
            'B69D98',
            'Thatch'
        ],
        [
            'B6B095',
            'Heathered Gray'
        ],
        [
            'B6BAA4',
            'Eagle'
        ],
        [
            'B6D1EA',
            'Spindle'
        ],
        [
            'B6D3BF',
            'Gum Leaf'
        ],
        [
            'B7410E',
            'Rust'
        ],
        [
            'B78E5C',
            'Muddy Waters'
        ],
        [
            'B7A214',
            'Sahara'
        ],
        [
            'B7A458',
            'Husk'
        ],
        [
            'B7B1B1',
            'Nobel'
        ],
        [
            'B7C3D0',
            'Heather'
        ],
        [
            'B7F0BE',
            'Madang'
        ],
        [
            'B81104',
            'Milano Red'
        ],
        [
            'B87333',
            'Copper'
        ],
        [
            'B8B56A',
            'Gimblet'
        ],
        [
            'B8C1B1',
            'Green Spring'
        ],
        [
            'B8C25D',
            'Celery'
        ],
        [
            'B8E0F9',
            'Sail'
        ],
        [
            'B94E48',
            'Chestnut'
        ],
        [
            'B95140',
            'Crail'
        ],
        [
            'B98D28',
            'Marigold'
        ],
        [
            'B9C46A',
            'Wild Willow'
        ],
        [
            'B9C8AC',
            'Rainee'
        ],
        [
            'BA0101',
            'Guardsman Red'
        ],
        [
            'BA450C',
            'Rock Spray'
        ],
        [
            'BA6F1E',
            'Bourbon'
        ],
        [
            'BA7F03',
            'Pirate Gold'
        ],
        [
            'BAB1A2',
            'Nomad'
        ],
        [
            'BAC7C9',
            'Submarine'
        ],
        [
            'BAEEF9',
            'Charlotte'
        ],
        [
            'BB3385',
            'Medium Red Violet'
        ],
        [
            'BB8983',
            'Brandy Rose'
        ],
        [
            'BBD009',
            'Rio Grande'
        ],
        [
            'BBD7C1',
            'Surf'
        ],
        [
            'BCC9C2',
            'Powder Ash'
        ],
        [
            'BD5E2E',
            'Tuscany'
        ],
        [
            'BD978E',
            'Quicksand'
        ],
        [
            'BDB1A8',
            'Silk'
        ],
        [
            'BDB2A1',
            'Malta'
        ],
        [
            'BDB3C7',
            'Chatelle'
        ],
        [
            'BDBBD7',
            'Lavender Gray'
        ],
        [
            'BDBDC6',
            'French Gray'
        ],
        [
            'BDC8B3',
            'Clay Ash'
        ],
        [
            'BDC9CE',
            'Loblolly'
        ],
        [
            'BDEDFD',
            'French Pass'
        ],
        [
            'BEA6C3',
            'London Hue'
        ],
        [
            'BEB5B7',
            'Pink Swan'
        ],
        [
            'BEDE0D',
            'Fuego'
        ],
        [
            'BF5500',
            'Rose of Sharon'
        ],
        [
            'BFB8B0',
            'Tide'
        ],
        [
            'BFBED8',
            'Blue Haze'
        ],
        [
            'BFC1C2',
            'Silver Sand'
        ],
        [
            'BFC921',
            'Key Lime Pie'
        ],
        [
            'BFDBE2',
            'Ziggurat'
        ],
        [
            'BFFF00',
            'Lime'
        ],
        [
            'C02B18',
            'Thunderbird'
        ],
        [
            'C04737',
            'Mojo'
        ],
        [
            'C08081',
            'Old Rose'
        ],
        [
            'C0C0C0',
            'Silver'
        ],
        [
            'C0D3B9',
            'Pale Leaf'
        ],
        [
            'C0D8B6',
            'Pixie Green'
        ],
        [
            'C1440E',
            'Tia Maria'
        ],
        [
            'C154C1',
            'Fuchsia Pink'
        ],
        [
            'C1A004',
            'Buddha Gold'
        ],
        [
            'C1B7A4',
            'Bison Hide'
        ],
        [
            'C1BAB0',
            'Tea'
        ],
        [
            'C1BECD',
            'Gray Suit'
        ],
        [
            'C1D7B0',
            'Sprout'
        ],
        [
            'C1F07C',
            'Sulu'
        ],
        [
            'C26B03',
            'Indochine'
        ],
        [
            'C2955D',
            'Twine'
        ],
        [
            'C2BDB6',
            'Cotton Seed'
        ],
        [
            'C2CAC4',
            'Pumice'
        ],
        [
            'C2E8E5',
            'Jagged Ice'
        ],
        [
            'C32148',
            'Maroon Flush'
        ],
        [
            'C3B091',
            'Indian Khaki'
        ],
        [
            'C3BFC1',
            'Pale Slate'
        ],
        [
            'C3C3BD',
            'Gray Nickel'
        ],
        [
            'C3CDE6',
            'Periwinkle Gray'
        ],
        [
            'C3D1D1',
            'Tiara'
        ],
        [
            'C3DDF9',
            'Tropical Blue'
        ],
        [
            'C41E3A',
            'Cardinal'
        ],
        [
            'C45655',
            'Fuzzy Wuzzy Brown'
        ],
        [
            'C45719',
            'Orange Roughy'
        ],
        [
            'C4C4BC',
            'Mist Gray'
        ],
        [
            'C4D0B0',
            'Coriander'
        ],
        [
            'C4F4EB',
            'Mint Tulip'
        ],
        [
            'C54B8C',
            'Mulberry'
        ],
        [
            'C59922',
            'Nugget'
        ],
        [
            'C5994B',
            'Tussock'
        ],
        [
            'C5DBCA',
            'Sea Mist'
        ],
        [
            'C5E17A',
            'Yellow Green'
        ],
        [
            'C62D42',
            'Brick Red'
        ],
        [
            'C6726B',
            'Contessa'
        ],
        [
            'C69191',
            'Oriental Pink'
        ],
        [
            'C6A84B',
            'Roti'
        ],
        [
            'C6C3B5',
            'Ash'
        ],
        [
            'C6C8BD',
            'Kangaroo'
        ],
        [
            'C6E610',
            'Las Palmas'
        ],
        [
            'C7031E',
            'Monza'
        ],
        [
            'C71585',
            'Red Violet'
        ],
        [
            'C7BCA2',
            'Coral Reef'
        ],
        [
            'C7C1FF',
            'Melrose'
        ],
        [
            'C7C4BF',
            'Cloud'
        ],
        [
            'C7C9D5',
            'Ghost'
        ],
        [
            'C7CD90',
            'Pine Glade'
        ],
        [
            'C7DDE5',
            'Botticelli'
        ],
        [
            'C88A65',
            'Antique Brass'
        ],
        [
            'C8A2C8',
            'Lilac'
        ],
        [
            'C8A528',
            'Hokey Pokey'
        ],
        [
            'C8AABF',
            'Lily'
        ],
        [
            'C8B568',
            'Laser'
        ],
        [
            'C8E3D7',
            'Edgewater'
        ],
        [
            'C96323',
            'Piper'
        ],
        [
            'C99415',
            'Pizza'
        ],
        [
            'C9A0DC',
            'Light Wisteria'
        ],
        [
            'C9B29B',
            'Rodeo Dust'
        ],
        [
            'C9B35B',
            'Sundance'
        ],
        [
            'C9B93B',
            'Earls Green'
        ],
        [
            'C9C0BB',
            'Silver Rust'
        ],
        [
            'C9D9D2',
            'Conch'
        ],
        [
            'C9FFA2',
            'Reef'
        ],
        [
            'C9FFE5',
            'Aero Blue'
        ],
        [
            'CA3435',
            'Flush Mahogany'
        ],
        [
            'CABB48',
            'Turmeric'
        ],
        [
            'CADCD4',
            'Paris White'
        ],
        [
            'CAE00D',
            'Bitter Lemon'
        ],
        [
            'CAE6DA',
            'Skeptic'
        ],
        [
            'CB8FA9',
            'Viola'
        ],
        [
            'CBCAB6',
            'Foggy Gray'
        ],
        [
            'CBD3B0',
            'Green Mist'
        ],
        [
            'CBDBD6',
            'Nebula'
        ],
        [
            'CC3333',
            'Persian Red'
        ],
        [
            'CC5500',
            'Burnt Orange'
        ],
        [
            'CC7722',
            'Ochre'
        ],
        [
            'CC8899',
            'Puce'
        ],
        [
            'CCCAA8',
            'Thistle Green'
        ],
        [
            'CCCCFF',
            'Periwinkle'
        ],
        [
            'CCFF00',
            'Electric Lime'
        ],
        [
            'CD5700',
            'Tenn'
        ],
        [
            'CD5C5C',
            'Chestnut Rose'
        ],
        [
            'CD8429',
            'Brandy Punch'
        ],
        [
            'CDF4FF',
            'Onahau'
        ],
        [
            'CEB98F',
            'Sorrell Brown'
        ],
        [
            'CEBABA',
            'Cold Turkey'
        ],
        [
            'CEC291',
            'Yuma'
        ],
        [
            'CEC7A7',
            'Chino'
        ],
        [
            'CFA39D',
            'Eunry'
        ],
        [
            'CFB53B',
            'Old Gold'
        ],
        [
            'CFDCCF',
            'Tasman'
        ],
        [
            'CFE5D2',
            'Surf Crest'
        ],
        [
            'CFF9F3',
            'Humming Bird'
        ],
        [
            'CFFAF4',
            'Scandal'
        ],
        [
            'D05F04',
            'Red Stage'
        ],
        [
            'D06DA1',
            'Hopbush'
        ],
        [
            'D07D12',
            'Meteor'
        ],
        [
            'D0BEF8',
            'Perfume'
        ],
        [
            'D0C0E5',
            'Prelude'
        ],
        [
            'D0F0C0',
            'Tea Green'
        ],
        [
            'D18F1B',
            'Geebung'
        ],
        [
            'D1BEA8',
            'Vanilla'
        ],
        [
            'D1C6B4',
            'Soft Amber'
        ],
        [
            'D1D2CA',
            'Celeste'
        ],
        [
            'D1D2DD',
            'Mischka'
        ],
        [
            'D1E231',
            'Pear'
        ],
        [
            'D2691E',
            'Hot Cinnamon'
        ],
        [
            'D27D46',
            'Raw Sienna'
        ],
        [
            'D29EAA',
            'Careys Pink'
        ],
        [
            'D2B48C',
            'Tan'
        ],
        [
            'D2DA97',
            'Deco'
        ],
        [
            'D2F6DE',
            'Blue Romance'
        ],
        [
            'D2F8B0',
            'Gossip'
        ],
        [
            'D3CBBA',
            'Sisal'
        ],
        [
            'D3CDC5',
            'Swirl'
        ],
        [
            'D47494',
            'Charm'
        ],
        [
            'D4B6AF',
            'Clam Shell'
        ],
        [
            'D4BF8D',
            'Straw'
        ],
        [
            'D4C4A8',
            'Akaroa'
        ],
        [
            'D4CD16',
            'Bird Flower'
        ],
        [
            'D4D7D9',
            'Iron'
        ],
        [
            'D4DFE2',
            'Geyser'
        ],
        [
            'D4E2FC',
            'Hawkes Blue'
        ],
        [
            'D54600',
            'Grenadier'
        ],
        [
            'D591A4',
            'Can Can'
        ],
        [
            'D59A6F',
            'Whiskey'
        ],
        [
            'D5D195',
            'Winter Hazel'
        ],
        [
            'D5F6E3',
            'Granny Apple'
        ],
        [
            'D69188',
            'My Pink'
        ],
        [
            'D6C562',
            'Tacha'
        ],
        [
            'D6CEF6',
            'Moon Raker'
        ],
        [
            'D6D6D1',
            'Quill Gray'
        ],
        [
            'D6FFDB',
            'Snowy Mint'
        ],
        [
            'D7837F',
            'New York Pink'
        ],
        [
            'D7C498',
            'Pavlova'
        ],
        [
            'D7D0FF',
            'Fog'
        ],
        [
            'D84437',
            'Valencia'
        ],
        [
            'D87C63',
            'Japonica'
        ],
        [
            'D8BFD8',
            'Thistle'
        ],
        [
            'D8C2D5',
            'Maverick'
        ],
        [
            'D8FCFA',
            'Foam'
        ],
        [
            'D94972',
            'Cabaret'
        ],
        [
            'D99376',
            'Burning Sand'
        ],
        [
            'D9B99B',
            'Cameo'
        ],
        [
            'D9D6CF',
            'Timberwolf'
        ],
        [
            'D9DCC1',
            'Tana'
        ],
        [
            'D9E4F5',
            'Link Water'
        ],
        [
            'D9F7FF',
            'Mabel'
        ],
        [
            'DA3287',
            'Cerise'
        ],
        [
            'DA5B38',
            'Flame Pea'
        ],
        [
            'DA6304',
            'Bamboo'
        ],
        [
            'DA6A41',
            'Red Damask'
        ],
        [
            'DA70D6',
            'Orchid'
        ],
        [
            'DA8A67',
            'Copperfield'
        ],
        [
            'DAA520',
            'Golden Grass'
        ],
        [
            'DAECD6',
            'Zanah'
        ],
        [
            'DAF4F0',
            'Iceberg'
        ],
        [
            'DAFAFF',
            'Oyster Bay'
        ],
        [
            'DB5079',
            'Cranberry'
        ],
        [
            'DB9690',
            'Petite Orchid'
        ],
        [
            'DB995E',
            'Di Serria'
        ],
        [
            'DBDBDB',
            'Alto'
        ],
        [
            'DBFFF8',
            'Frosted Mint'
        ],
        [
            'DC143C',
            'Crimson'
        ],
        [
            'DC4333',
            'Punch'
        ],
        [
            'DCB20C',
            'Galliano'
        ],
        [
            'DCB4BC',
            'Blossom'
        ],
        [
            'DCD747',
            'Wattle'
        ],
        [
            'DCD9D2',
            'Westar'
        ],
        [
            'DCDDCC',
            'Moon Mist'
        ],
        [
            'DCEDB4',
            'Caper'
        ],
        [
            'DCF0EA',
            'Swans Down'
        ],
        [
            'DDD6D5',
            'Swiss Coffee'
        ],
        [
            'DDF9F1',
            'White Ice'
        ],
        [
            'DE3163',
            'Cerise Red'
        ],
        [
            'DE6360',
            'Roman'
        ],
        [
            'DEA681',
            'Tumbleweed'
        ],
        [
            'DEBA13',
            'Gold Tips'
        ],
        [
            'DEC196',
            'Brandy'
        ],
        [
            'DECBC6',
            'Wafer'
        ],
        [
            'DED4A4',
            'Sapling'
        ],
        [
            'DED717',
            'Barberry'
        ],
        [
            'DEE5C0',
            'Beryl Green'
        ],
        [
            'DEF5FF',
            'Pattens Blue'
        ],
        [
            'DF73FF',
            'Heliotrope'
        ],
        [
            'DFBE6F',
            'Apache'
        ],
        [
            'DFCD6F',
            'Chenin'
        ],
        [
            'DFCFDB',
            'Lola'
        ],
        [
            'DFECDA',
            'Willow Brook'
        ],
        [
            'DFFF00',
            'Chartreuse Yellow'
        ],
        [
            'E0B0FF',
            'Mauve'
        ],
        [
            'E0B646',
            'Anzac'
        ],
        [
            'E0B974',
            'Harvest Gold'
        ],
        [
            'E0C095',
            'Calico'
        ],
        [
            'E0FFFF',
            'Baby Blue'
        ],
        [
            'E16865',
            'Sunglo'
        ],
        [
            'E1BC64',
            'Equator'
        ],
        [
            'E1C0C8',
            'Pink Flare'
        ],
        [
            'E1E6D6',
            'Periglacial Blue'
        ],
        [
            'E1EAD4',
            'Kidnapper'
        ],
        [
            'E1F6E8',
            'Tara'
        ],
        [
            'E25465',
            'Mandy'
        ],
        [
            'E2725B',
            'Terracotta'
        ],
        [
            'E28913',
            'Golden Bell'
        ],
        [
            'E292C0',
            'Shocking'
        ],
        [
            'E29418',
            'Dixie'
        ],
        [
            'E29CD2',
            'Light Orchid'
        ],
        [
            'E2D8ED',
            'Snuff'
        ],
        [
            'E2EBED',
            'Mystic'
        ],
        [
            'E2F3EC',
            'Apple Green'
        ],
        [
            'E30B5C',
            'Razzmatazz'
        ],
        [
            'E32636',
            'Alizarin Crimson'
        ],
        [
            'E34234',
            'Cinnabar'
        ],
        [
            'E3BEBE',
            'Cavern Pink'
        ],
        [
            'E3F5E1',
            'Peppermint'
        ],
        [
            'E3F988',
            'Mindaro'
        ],
        [
            'E47698',
            'Deep Blush'
        ],
        [
            'E49B0F',
            'Gamboge'
        ],
        [
            'E4C2D5',
            'Melanie'
        ],
        [
            'E4CFDE',
            'Twilight'
        ],
        [
            'E4D1C0',
            'Bone'
        ],
        [
            'E4D422',
            'Sunflower'
        ],
        [
            'E4D5B7',
            'Grain Brown'
        ],
        [
            'E4D69B',
            'Zombie'
        ],
        [
            'E4F6E7',
            'Frostee'
        ],
        [
            'E4FFD1',
            'Snow Flurry'
        ],
        [
            'E52B50',
            'Amaranth'
        ],
        [
            'E5841B',
            'Zest'
        ],
        [
            'E5CCC9',
            'Dust Storm'
        ],
        [
            'E5D7BD',
            'Stark White'
        ],
        [
            'E5D8AF',
            'Hampton'
        ],
        [
            'E5E0E1',
            'Bon Jour'
        ],
        [
            'E5E5E5',
            'Mercury'
        ],
        [
            'E5F9F6',
            'Polar'
        ],
        [
            'E64E03',
            'Trinidad'
        ],
        [
            'E6BE8A',
            'Gold Sand'
        ],
        [
            'E6BEA5',
            'Cashmere'
        ],
        [
            'E6D7B9',
            'Double Spanish White'
        ],
        [
            'E6E4D4',
            'Satin Linen'
        ],
        [
            'E6F2EA',
            'Harp'
        ],
        [
            'E6F8F3',
            'Off Green'
        ],
        [
            'E6FFE9',
            'Hint of Green'
        ],
        [
            'E6FFFF',
            'Tranquil'
        ],
        [
            'E77200',
            'Mango Tango'
        ],
        [
            'E7730A',
            'Christine'
        ],
        [
            'E79F8C',
            'Tonys Pink'
        ],
        [
            'E79FC4',
            'Kobi'
        ],
        [
            'E7BCB4',
            'Rose Fog'
        ],
        [
            'E7BF05',
            'Corn'
        ],
        [
            'E7CD8C',
            'Putty'
        ],
        [
            'E7ECE6',
            'Gray Nurse'
        ],
        [
            'E7F8FF',
            'Lily White'
        ],
        [
            'E7FEFF',
            'Bubbles'
        ],
        [
            'E89928',
            'Fire Bush'
        ],
        [
            'E8B9B3',
            'Shilo'
        ],
        [
            'E8E0D5',
            'Pearl Bush'
        ],
        [
            'E8EBE0',
            'Green White'
        ],
        [
            'E8F1D4',
            'Chrome White'
        ],
        [
            'E8F2EB',
            'Gin'
        ],
        [
            'E8F5F2',
            'Aqua Squeeze'
        ],
        [
            'E96E00',
            'Clementine'
        ],
        [
            'E97451',
            'Burnt Sienna'
        ],
        [
            'E97C07',
            'Tahiti Gold'
        ],
        [
            'E9CECD',
            'Oyster Pink'
        ],
        [
            'E9D75A',
            'Confetti'
        ],
        [
            'E9E3E3',
            'Ebb'
        ],
        [
            'E9F8ED',
            'Ottoman'
        ],
        [
            'E9FFFD',
            'Clear Day'
        ],
        [
            'EA88A8',
            'Carissma'
        ],
        [
            'EAAE69',
            'Porsche'
        ],
        [
            'EAB33B',
            'Tulip Tree'
        ],
        [
            'EAC674',
            'Rob Roy'
        ],
        [
            'EADAB8',
            'Raffia'
        ],
        [
            'EAE8D4',
            'White Rock'
        ],
        [
            'EAF6EE',
            'Panache'
        ],
        [
            'EAF6FF',
            'Solitude'
        ],
        [
            'EAF9F5',
            'Aqua Spring'
        ],
        [
            'EAFFFE',
            'Dew'
        ],
        [
            'EB9373',
            'Apricot'
        ],
        [
            'EBC2AF',
            'Zinnwaldite'
        ],
        [
            'ECA927',
            'Fuel Yellow'
        ],
        [
            'ECC54E',
            'Ronchi'
        ],
        [
            'ECC7EE',
            'French Lilac'
        ],
        [
            'ECCDB9',
            'Just Right'
        ],
        [
            'ECE090',
            'Wild Rice'
        ],
        [
            'ECEBBD',
            'Fall Green'
        ],
        [
            'ECEBCE',
            'Aths Special'
        ],
        [
            'ECF245',
            'Starship'
        ],
        [
            'ED0A3F',
            'Red Ribbon'
        ],
        [
            'ED7A1C',
            'Tango'
        ],
        [
            'ED9121',
            'Carrot Orange'
        ],
        [
            'ED989E',
            'Sea Pink'
        ],
        [
            'EDB381',
            'Tacao'
        ],
        [
            'EDC9AF',
            'Desert Sand'
        ],
        [
            'EDCDAB',
            'Pancho'
        ],
        [
            'EDDCB1',
            'Chamois'
        ],
        [
            'EDEA99',
            'Primrose'
        ],
        [
            'EDF5DD',
            'Frost'
        ],
        [
            'EDF5F5',
            'Aqua Haze'
        ],
        [
            'EDF6FF',
            'Zumthor'
        ],
        [
            'EDF9F1',
            'Narvik'
        ],
        [
            'EDFC84',
            'Honeysuckle'
        ],
        [
            'EE82EE',
            'Lavender Magenta'
        ],
        [
            'EEC1BE',
            'Beauty Bush'
        ],
        [
            'EED794',
            'Chalky'
        ],
        [
            'EED9C4',
            'Almond'
        ],
        [
            'EEDC82',
            'Flax'
        ],
        [
            'EEDEDA',
            'Bizarre'
        ],
        [
            'EEE3AD',
            'Double Colonial White'
        ],
        [
            'EEEEE8',
            'Cararra'
        ],
        [
            'EEEF78',
            'Manz'
        ],
        [
            'EEF0C8',
            'Tahuna Sands'
        ],
        [
            'EEF0F3',
            'Athens Gray'
        ],
        [
            'EEF3C3',
            'Tusk'
        ],
        [
            'EEF4DE',
            'Loafer'
        ],
        [
            'EEF6F7',
            'Catskill White'
        ],
        [
            'EEFDFF',
            'Twilight Blue'
        ],
        [
            'EEFF9A',
            'Jonquil'
        ],
        [
            'EEFFE2',
            'Rice Flower'
        ],
        [
            'EF863F',
            'Jaffa'
        ],
        [
            'EFEFEF',
            'Gallery'
        ],
        [
            'EFF2F3',
            'Porcelain'
        ],
        [
            'F091A9',
            'Mauvelous'
        ],
        [
            'F0D52D',
            'Golden Dream'
        ],
        [
            'F0DB7D',
            'Golden Sand'
        ],
        [
            'F0DC82',
            'Buff'
        ],
        [
            'F0E2EC',
            'Prim'
        ],
        [
            'F0E68C',
            'Khaki'
        ],
        [
            'F0EEFD',
            'Selago'
        ],
        [
            'F0EEFF',
            'Titan White'
        ],
        [
            'F0F8FF',
            'Alice Blue'
        ],
        [
            'F0FCEA',
            'Feta'
        ],
        [
            'F18200',
            'Gold Drop'
        ],
        [
            'F19BAB',
            'Wewak'
        ],
        [
            'F1E788',
            'Sahara Sand'
        ],
        [
            'F1E9D2',
            'Parchment'
        ],
        [
            'F1E9FF',
            'Blue Chalk'
        ],
        [
            'F1EEC1',
            'Mint Julep'
        ],
        [
            'F1F1F1',
            'Seashell'
        ],
        [
            'F1F7F2',
            'Saltpan'
        ],
        [
            'F1FFAD',
            'Tidal'
        ],
        [
            'F1FFC8',
            'Chiffon'
        ],
        [
            'F2552A',
            'Flamingo'
        ],
        [
            'F28500',
            'Tangerine'
        ],
        [
            'F2C3B2',
            'Mandys Pink'
        ],
        [
            'F2F2F2',
            'Concrete'
        ],
        [
            'F2FAFA',
            'Black Squeeze'
        ],
        [
            'F34723',
            'Pomegranate'
        ],
        [
            'F3AD16',
            'Buttercup'
        ],
        [
            'F3D69D',
            'New Orleans'
        ],
        [
            'F3D9DF',
            'Vanilla Ice'
        ],
        [
            'F3E7BB',
            'Sidecar'
        ],
        [
            'F3E9E5',
            'Dawn Pink'
        ],
        [
            'F3EDCF',
            'Wheatfield'
        ],
        [
            'F3FB62',
            'Canary'
        ],
        [
            'F3FBD4',
            'Orinoco'
        ],
        [
            'F3FFD8',
            'Carla'
        ],
        [
            'F400A1',
            'Hollywood Cerise'
        ],
        [
            'F4A460',
            'Sandy brown'
        ],
        [
            'F4C430',
            'Saffron'
        ],
        [
            'F4D81C',
            'Ripe Lemon'
        ],
        [
            'F4EBD3',
            'Janna'
        ],
        [
            'F4F2EE',
            'Pampas'
        ],
        [
            'F4F4F4',
            'Wild Sand'
        ],
        [
            'F4F8FF',
            'Zircon'
        ],
        [
            'F57584',
            'Froly'
        ],
        [
            'F5C85C',
            'Cream Can'
        ],
        [
            'F5C999',
            'Manhattan'
        ],
        [
            'F5D5A0',
            'Maize'
        ],
        [
            'F5DEB3',
            'Wheat'
        ],
        [
            'F5E7A2',
            'Sandwisp'
        ],
        [
            'F5E7E2',
            'Pot Pourri'
        ],
        [
            'F5E9D3',
            'Albescent White'
        ],
        [
            'F5EDEF',
            'Soft Peach'
        ],
        [
            'F5F3E5',
            'Ecru White'
        ],
        [
            'F5F5DC',
            'Beige'
        ],
        [
            'F5FB3D',
            'Golden Fizz'
        ],
        [
            'F5FFBE',
            'Australian Mint'
        ],
        [
            'F64A8A',
            'French Rose'
        ],
        [
            'F653A6',
            'Brilliant Rose'
        ],
        [
            'F6A4C9',
            'Illusion'
        ],
        [
            'F6F0E6',
            'Merino'
        ],
        [
            'F6F7F7',
            'Black Haze'
        ],
        [
            'F6FFDC',
            'Spring Sun'
        ],
        [
            'F7468A',
            'Violet Red'
        ],
        [
            'F77703',
            'Chilean Fire'
        ],
        [
            'F77FBE',
            'Persian Pink'
        ],
        [
            'F7B668',
            'Rajah'
        ],
        [
            'F7C8DA',
            'Azalea'
        ],
        [
            'F7DBE6',
            'We Peep'
        ],
        [
            'F7F2E1',
            'Quarter Spanish White'
        ],
        [
            'F7F5FA',
            'Whisper'
        ],
        [
            'F7FAF7',
            'Snow Drift'
        ],
        [
            'F8B853',
            'Casablanca'
        ],
        [
            'F8C3DF',
            'Chantilly'
        ],
        [
            'F8D9E9',
            'Cherub'
        ],
        [
            'F8DB9D',
            'Marzipan'
        ],
        [
            'F8DD5C',
            'Energy Yellow'
        ],
        [
            'F8E4BF',
            'Givry'
        ],
        [
            'F8F0E8',
            'White Linen'
        ],
        [
            'F8F4FF',
            'Magnolia'
        ],
        [
            'F8F6F1',
            'Spring Wood'
        ],
        [
            'F8F7DC',
            'Coconut Cream'
        ],
        [
            'F8F7FC',
            'White Lilac'
        ],
        [
            'F8F8F7',
            'Desert Storm'
        ],
        [
            'F8F99C',
            'Texas'
        ],
        [
            'F8FACD',
            'Corn Field'
        ],
        [
            'F8FDD3',
            'Mimosa'
        ],
        [
            'F95A61',
            'Carnation'
        ],
        [
            'F9BF58',
            'Saffron Mango'
        ],
        [
            'F9E0ED',
            'Carousel Pink'
        ],
        [
            'F9E4BC',
            'Dairy Cream'
        ],
        [
            'F9E663',
            'Portica'
        ],
        [
            'F9EAF3',
            'Amour'
        ],
        [
            'F9F8E4',
            'Rum Swizzle'
        ],
        [
            'F9FF8B',
            'Dolly'
        ],
        [
            'F9FFF6',
            'Sugar Cane'
        ],
        [
            'FA7814',
            'Ecstasy'
        ],
        [
            'FA9D5A',
            'Tan Hide'
        ],
        [
            'FAD3A2',
            'Corvette'
        ],
        [
            'FADFAD',
            'Peach Yellow'
        ],
        [
            'FAE600',
            'Turbo'
        ],
        [
            'FAEAB9',
            'Astra'
        ],
        [
            'FAECCC',
            'Champagne'
        ],
        [
            'FAF0E6',
            'Linen'
        ],
        [
            'FAF3F0',
            'Fantasy'
        ],
        [
            'FAF7D6',
            'Citrine White'
        ],
        [
            'FAFAFA',
            'Alabaster'
        ],
        [
            'FAFDE4',
            'Hint of Yellow'
        ],
        [
            'FAFFA4',
            'Milan'
        ],
        [
            'FB607F',
            'Brink Pink'
        ],
        [
            'FB8989',
            'Geraldine'
        ],
        [
            'FBA0E3',
            'Lavender Rose'
        ],
        [
            'FBA129',
            'Sea Buckthorn'
        ],
        [
            'FBAC13',
            'Sun'
        ],
        [
            'FBAED2',
            'Lavender Pink'
        ],
        [
            'FBB2A3',
            'Rose Bud'
        ],
        [
            'FBBEDA',
            'Cupid'
        ],
        [
            'FBCCE7',
            'Classic Rose'
        ],
        [
            'FBCEB1',
            'Apricot Peach'
        ],
        [
            'FBE7B2',
            'Banana Mania'
        ],
        [
            'FBE870',
            'Marigold Yellow'
        ],
        [
            'FBE96C',
            'Festival'
        ],
        [
            'FBEA8C',
            'Sweet Corn'
        ],
        [
            'FBEC5D',
            'Candy Corn'
        ],
        [
            'FBF9F9',
            'Hint of Red'
        ],
        [
            'FBFFBA',
            'Shalimar'
        ],
        [
            'FC0FC0',
            'Shocking Pink'
        ],
        [
            'FC80A5',
            'Tickle Me Pink'
        ],
        [
            'FC9C1D',
            'Tree Poppy'
        ],
        [
            'FCC01E',
            'Lightning Yellow'
        ],
        [
            'FCD667',
            'Goldenrod'
        ],
        [
            'FCD917',
            'Candlelight'
        ],
        [
            'FCDA98',
            'Cherokee'
        ],
        [
            'FCF4D0',
            'Double Pearl Lusta'
        ],
        [
            'FCF4DC',
            'Pearl Lusta'
        ],
        [
            'FCF8F7',
            'Vista White'
        ],
        [
            'FCFBF3',
            'Bianca'
        ],
        [
            'FCFEDA',
            'Moon Glow'
        ],
        [
            'FCFFE7',
            'China Ivory'
        ],
        [
            'FCFFF9',
            'Ceramic'
        ],
        [
            'FD0E35',
            'Torch Red'
        ],
        [
            'FD5B78',
            'Wild Watermelon'
        ],
        [
            'FD7B33',
            'Crusta'
        ],
        [
            'FD7C07',
            'Sorbus'
        ],
        [
            'FD9FA2',
            'Sweet Pink'
        ],
        [
            'FDD5B1',
            'Light Apricot'
        ],
        [
            'FDD7E4',
            'Pig Pink'
        ],
        [
            'FDE1DC',
            'Cinderella'
        ],
        [
            'FDE295',
            'Golden Glow'
        ],
        [
            'FDE910',
            'Lemon'
        ],
        [
            'FDF5E6',
            'Old Lace'
        ],
        [
            'FDF6D3',
            'Half Colonial White'
        ],
        [
            'FDF7AD',
            'Drover'
        ],
        [
            'FDFEB8',
            'Pale Prim'
        ],
        [
            'FDFFD5',
            'Cumulus'
        ],
        [
            'FE28A2',
            'Persian Rose'
        ],
        [
            'FE4C40',
            'Sunset Orange'
        ],
        [
            'FE6F5E',
            'Bittersweet'
        ],
        [
            'FE9D04',
            'California'
        ],
        [
            'FEA904',
            'Yellow Sea'
        ],
        [
            'FEBAAD',
            'Melon'
        ],
        [
            'FED33C',
            'Bright Sun'
        ],
        [
            'FED85D',
            'Dandelion'
        ],
        [
            'FEDB8D',
            'Salomie'
        ],
        [
            'FEE5AC',
            'Cape Honey'
        ],
        [
            'FEEBF3',
            'Remy'
        ],
        [
            'FEEFCE',
            'Oasis'
        ],
        [
            'FEF0EC',
            'Bridesmaid'
        ],
        [
            'FEF2C7',
            'Beeswax'
        ],
        [
            'FEF3D8',
            'Bleach White'
        ],
        [
            'FEF4CC',
            'Pipi'
        ],
        [
            'FEF4DB',
            'Half Spanish White'
        ],
        [
            'FEF4F8',
            'Wisp Pink'
        ],
        [
            'FEF5F1',
            'Provincial Pink'
        ],
        [
            'FEF7DE',
            'Half Dutch White'
        ],
        [
            'FEF8E2',
            'Solitaire'
        ],
        [
            'FEF8FF',
            'White Pointer'
        ],
        [
            'FEF9E3',
            'Off Yellow'
        ],
        [
            'FEFCED',
            'Orange White'
        ],
        [
            'FF0000',
            'Red'
        ],
        [
            'FF007F',
            'Rose'
        ],
        [
            'FF00CC',
            'Purple Pizzazz'
        ],
        [
            'FF00FF',
            'Magenta / Fuchsia'
        ],
        [
            'FF2400',
            'Scarlet'
        ],
        [
            'FF3399',
            'Wild Strawberry'
        ],
        [
            'FF33CC',
            'Razzle Dazzle Rose'
        ],
        [
            'FF355E',
            'Radical Red'
        ],
        [
            'FF3F34',
            'Red Orange'
        ],
        [
            'FF4040',
            'Coral Red'
        ],
        [
            'FF4D00',
            'Vermilion'
        ],
        [
            'FF4F00',
            'International Orange'
        ],
        [
            'FF6037',
            'Outrageous Orange'
        ],
        [
            'FF6600',
            'Blaze Orange'
        ],
        [
            'FF66FF',
            'Pink Flamingo'
        ],
        [
            'FF681F',
            'Orange'
        ],
        [
            'FF69B4',
            'Hot Pink'
        ],
        [
            'FF6B53',
            'Persimmon'
        ],
        [
            'FF6FFF',
            'Blush Pink'
        ],
        [
            'FF7034',
            'Burning Orange'
        ],
        [
            'FF7518',
            'Pumpkin'
        ],
        [
            'FF7D07',
            'Flamenco'
        ],
        [
            'FF7F00',
            'Flush Orange'
        ],
        [
            'FF7F50',
            'Coral'
        ],
        [
            'FF8C69',
            'Salmon'
        ],
        [
            'FF9000',
            'Pizazz'
        ],
        [
            'FF910F',
            'West Side'
        ],
        [
            'FF91A4',
            'Pink Salmon'
        ],
        [
            'FF9933',
            'Neon Carrot'
        ],
        [
            'FF9966',
            'Atomic Tangerine'
        ],
        [
            'FF9980',
            'Vivid Tangerine'
        ],
        [
            'FF9E2C',
            'Sunshade'
        ],
        [
            'FFA000',
            'Orange Peel'
        ],
        [
            'FFA194',
            'Mona Lisa'
        ],
        [
            'FFA500',
            'Web Orange'
        ],
        [
            'FFA6C9',
            'Carnation Pink'
        ],
        [
            'FFAB81',
            'Hit Pink'
        ],
        [
            'FFAE42',
            'Yellow Orange'
        ],
        [
            'FFB0AC',
            'Cornflower Lilac'
        ],
        [
            'FFB1B3',
            'Sundown'
        ],
        [
            'FFB31F',
            'My Sin'
        ],
        [
            'FFB555',
            'Texas Rose'
        ],
        [
            'FFB7D5',
            'Cotton Candy'
        ],
        [
            'FFB97B',
            'Macaroni and Cheese'
        ],
        [
            'FFBA00',
            'Selective Yellow'
        ],
        [
            'FFBD5F',
            'Koromiko'
        ],
        [
            'FFBF00',
            'Amber'
        ],
        [
            'FFC0A8',
            'Wax Flower'
        ],
        [
            'FFC0CB',
            'Pink'
        ],
        [
            'FFC3C0',
            'Your Pink'
        ],
        [
            'FFC901',
            'Supernova'
        ],
        [
            'FFCBA4',
            'Flesh'
        ],
        [
            'FFCC33',
            'Sunglow'
        ],
        [
            'FFCC5C',
            'Golden Tainoi'
        ],
        [
            'FFCC99',
            'Peach Orange'
        ],
        [
            'FFCD8C',
            'Chardonnay'
        ],
        [
            'FFD1DC',
            'Pastel Pink'
        ],
        [
            'FFD2B7',
            'Romantic'
        ],
        [
            'FFD38C',
            'Grandis'
        ],
        [
            'FFD700',
            'Gold'
        ],
        [
            'FFD800',
            'School bus Yellow'
        ],
        [
            'FFD8D9',
            'Cosmos'
        ],
        [
            'FFDB58',
            'Mustard'
        ],
        [
            'FFDCD6',
            'Peach Schnapps'
        ],
        [
            'FFDDAF',
            'Caramel'
        ],
        [
            'FFDDCD',
            'Tuft Bush'
        ],
        [
            'FFDDCF',
            'Watusi'
        ],
        [
            'FFDDF4',
            'Pink Lace'
        ],
        [
            'FFDEAD',
            'Navajo White'
        ],
        [
            'FFDEB3',
            'Frangipani'
        ],
        [
            'FFE1DF',
            'Pippin'
        ],
        [
            'FFE1F2',
            'Pale Rose'
        ],
        [
            'FFE2C5',
            'Negroni'
        ],
        [
            'FFE5A0',
            'Cream Brulee'
        ],
        [
            'FFE5B4',
            'Peach'
        ],
        [
            'FFE6C7',
            'Tequila'
        ],
        [
            'FFE772',
            'Kournikova'
        ],
        [
            'FFEAC8',
            'Sandy Beach'
        ],
        [
            'FFEAD4',
            'Karry'
        ],
        [
            'FFEC13',
            'Broom'
        ],
        [
            'FFEDBC',
            'Colonial White'
        ],
        [
            'FFEED8',
            'Derby'
        ],
        [
            'FFEFA1',
            'Vis Vis'
        ],
        [
            'FFEFC1',
            'Egg White'
        ],
        [
            'FFEFD5',
            'Papaya Whip'
        ],
        [
            'FFEFEC',
            'Fair Pink'
        ],
        [
            'FFF0DB',
            'Peach Cream'
        ],
        [
            'FFF0F5',
            'Lavender blush'
        ],
        [
            'FFF14F',
            'Gorse'
        ],
        [
            'FFF1B5',
            'Buttermilk'
        ],
        [
            'FFF1D8',
            'Pink Lady'
        ],
        [
            'FFF1EE',
            'Forget Me Not'
        ],
        [
            'FFF1F9',
            'Tutu'
        ],
        [
            'FFF39D',
            'Picasso'
        ],
        [
            'FFF3F1',
            'Chardon'
        ],
        [
            'FFF46E',
            'Paris Daisy'
        ],
        [
            'FFF4CE',
            'Barley White'
        ],
        [
            'FFF4DD',
            'Egg Sour'
        ],
        [
            'FFF4E0',
            'Sazerac'
        ],
        [
            'FFF4E8',
            'Serenade'
        ],
        [
            'FFF4F3',
            'Chablis'
        ],
        [
            'FFF5EE',
            'Seashell Peach'
        ],
        [
            'FFF5F3',
            'Sauvignon'
        ],
        [
            'FFF6D4',
            'Milk Punch'
        ],
        [
            'FFF6DF',
            'Varden'
        ],
        [
            'FFF6F5',
            'Rose White'
        ],
        [
            'FFF8D1',
            'Baja White'
        ],
        [
            'FFF9E2',
            'Gin Fizz'
        ],
        [
            'FFF9E6',
            'Early Dawn'
        ],
        [
            'FFFACD',
            'Lemon Chiffon'
        ],
        [
            'FFFAF4',
            'Bridal Heath'
        ],
        [
            'FFFBDC',
            'Scotch Mist'
        ],
        [
            'FFFBF9',
            'Soapstone'
        ],
        [
            'FFFC99',
            'Witch Haze'
        ],
        [
            'FFFCEA',
            'Buttery White'
        ],
        [
            'FFFCEE',
            'Island Spice'
        ],
        [
            'FFFDD0',
            'Cream'
        ],
        [
            'FFFDE6',
            'Chilean Heath'
        ],
        [
            'FFFDE8',
            'Travertine'
        ],
        [
            'FFFDF3',
            'Orchid White'
        ],
        [
            'FFFDF4',
            'Quarter Pearl Lusta'
        ],
        [
            'FFFEE1',
            'Half and Half'
        ],
        [
            'FFFEEC',
            'Apricot White'
        ],
        [
            'FFFEF0',
            'Rice Cake'
        ],
        [
            'FFFEF6',
            'Black White'
        ],
        [
            'FFFEFD',
            'Romance'
        ],
        [
            'FFFF00',
            'Yellow'
        ],
        [
            'FFFF66',
            'Laser Lemon'
        ],
        [
            'FFFF99',
            'Pale Canary'
        ],
        [
            'FFFFB4',
            'Portafino'
        ],
        [
            'FFFFF0',
            'Ivory'
        ],
        [
            'FFFFFF',
            'White'
        ]
    ]
};
$7367346e2d386411$export$7a7577de99024054.init();

});

parcelRegister("bIY7U", function(module, exports) {
// eslint-disable-next-line no-empty-function
// export function updateFunctionFromState() {
//   const { key, value, code } = this.state
//   try {
//     const res = this.call('updateFunction')
//     this.test('Updating Function in data', () => {
//       return this.testCase(
//         'Value equals canvas context',
//         'isEqualFunction',
//         this.getFunctions(key),
//         value
//       )
//     })
//     if (res?.success) {
//       this.call('updateFunctionOnCanvas', code)
//       this.test('Updating Function on Canvas', () => {
//         return (
//           this.testCase(
//             'Value equals root state',
//             'isEqualFunction',
//             this.getFunctions(key),
//             value
//           ) &&
//           this.testCase(
//             'Value equals root state',
//             'isEqual',
//             this.getCanvasCollection()
//               .context.functions[key].toString()
//               .replaceAll('\n', ''),
//             value.toString().replaceAll('\n', '')
//           )
//         )
//       })
//     }
//   } catch (e) {
//     console.error(e)
//   }
// }
// export function updateFunctionOnCanvas(codeStr, type = 'functions') {
//   // window.requestAnimationFrame(() => {
//   const Canvas = this.getCanvas()
//   const { chosen } = this.getCanvasScope()
//   const Collection = this.getCanvasCollection()
//   const { key } = this.state
//   if (Collection) {
//     const { contentWindow } = Canvas.Iframe.node
//     const evalCode = this.call('evalStringCodeUnsafe', codeStr, {
//       secrets: this.getSecrets(),
//       window: contentWindow
//     })
//     const ctx = Collection.context
//     ctx[type][key] = evalCode
//     ctx.utils[key] = evalCode
//     const { packages } = contentWindow
//     packages[type][key] = evalCode
//     packages.utils[key] = evalCode
//   } else {
//     this.error('Canvas Collection was not found')
//   }
//   if (chosen) {
//     const ChosenScene = this.getChosenScene()
//     const { ComponentFrameCanvas } = ChosenScene.ViewSvitcher
//     const ChosenFrame = ComponentFrameCanvas?.Iframe
//     if (!ChosenFrame) {
//       return
//     }
//     const { contentWindow } = ChosenFrame.node
//     const evalCode = this.call('evalStringCodeUnsafe', codeStr, {
//       secrets: this.getSecrets(),
//       window: contentWindow
//     })
//     const { packages } = contentWindow
//     packages[type][key] = evalCode
//     packages.utils[key] = evalCode
//     ChosenFrame.update()
//   }
//   // })
// }
// export function updateFunction() {
//   const { key } = this.state
//   try {
//     return this.sdk.updateItem(
//       this.call('getType'),
//       {
//         ...this.state,
//         key
//       },
//       { message: `Updating function ${key}` }
//     )
//   } catch (err) {
//     this.state.update({
//       err
//     })
//   }
// }
// export async function duplicateFunction() {
//   const { key } = this.state
//   const type = this.call('getType')
//   this.sdk.addItem(
//     type,
//     {
//       ...this.state,
//       key: key.concat('Copy')
//     },
//     {
//       message: `Duplicating function ${key}`,
//       ...this.call('returnAddedCanvasPageChanges', type, key)
//     }
//   )
//   const updatedSection = await this.call('rerenderFileSidebarByType', type)
//   if (!updatedSection) {
//     await this.getDynamicIsland()?.update()
//   }
// }

});

parcelRegister("8bnXk", function(module, exports) {

$parcel$export(module.exports, "openFile", () => $5f51eef58c1baf7d$export$c47c8b06a9966d9f);
// import { evalStringCodeUnsafe } from './code-stringify'
// export const updateFile = (codeStr, el, s) => {
// const { content, key, code, type, format } = s
// s.getRootState().files[key] = { content, code, key, type, format }
// el.getRootState().update({
//   files: { [key]: s.files[key] }
// }, {
//   message: `Updated ${s.key} function`,
//   preventUpdate: true
// })
// window.requestAnimationFrame(() => {
//   const Canvas = el.getCanvas() || el.__ref.root.data.Canvas
//   const { Iframe } = this.getChosenScene().ComponentFrameCanvas
//   const { contentWindow } = Iframe.node
//   const { chosen, Collection } = Canvas.data.chosen
//   const evalCode = evalStringCodeUnsafe(codeStr, this.getSecrets(), contentWindow)
//   if (chosen || Collection) {
//     const chosenCtx = (chosen || Collection).context
//     chosenCtx.files[s.key].code = evalCode
//   }
//   const { packages } = contentWindow
//   packages.files[s.key] = evalCode
//   packages.functions[s.key] = evalCode
//   packages.utils[s.key] = evalCode
//   Iframe.update()
// })
// }
async function $5f51eef58c1baf7d$export$c47c8b06a9966d9f(key) {
    await this.call('openModal', '/edit-file', {
        key: key || this.state.key
    });
}
function $5f51eef58c1baf7d$var$appendCopyToFileName(fileName) {
    const dotIndex = fileName.lastIndexOf('.');
    const hasExtension = dotIndex !== -1;
    let name = hasExtension ? fileName.substring(0, dotIndex) : fileName;
    const extension = hasExtension ? fileName.substring(dotIndex) : '';
    // Regular expression to check if '-copy' followed by an optional number exists
    const copyRegex = /-copy(?:-(?<temp1>\d+))?$/u;
    const match = name.match(copyRegex);
    if (match) {
        // If '-copy' exists, increment the number
        const copyNumber = match[1] ? parseInt(match[1], 10) + 1 : 1;
        name = name.replace(copyRegex, `-copy-${copyNumber}`);
    } else // Otherwise, just append '-copy'
    name += '-copy';
    return name + extension;
}

});

parcelRegister("1exXd", function(module, exports) {

$parcel$export(module.exports, "componentsCollectionByFilter", () => $0e616fd7616dccae$export$18c6ece5a99af5c1);
$parcel$export(module.exports, "componentsCollectionFilter", () => $0e616fd7616dccae$export$82040223dec21d8d);
// TODO: check if its calling uses await
async function $0e616fd7616dccae$export$18c6ece5a99af5c1(limit) {
    const { recents: recents } = this.getRootState();
    const componentShowFilter = this.getUserSettings('componentShowFilter');
    const components = Object.values(this.getSchema('components'));
    if (componentShowFilter === 'all') return limit ? components.filter((v, k)=>k < limit) : components;
    if (componentShowFilter === 'recents') {
        const recentComponents = recents.map((v)=>this.getSchema('components')[v]);
        return limit ? recentComponents.filter((v, k)=>k < limit) : recentComponents;
    }
    if (componentShowFilter === 'builtins') return {} // COMPONENTS
    ;
    if (componentShowFilter === 'library') return await this.getDefaultComponents();
    return components.filter((v)=>v[this.state.type]);
}
function $0e616fd7616dccae$export$82040223dec21d8d(arr) {
    const { tags: tags, filters: filters, type: type } = this.state;
    const { recents: recents } = this.getRootState();
    const componentShowFilter = this.getUserSettings('componentShowFilter');
    const { category: category } = filters;
    const categoryFilter = (v)=>{
        if (v.draft) return;
        if (category && tags.length) return v.category === category && this.call('arrayContainsOtherArray', tags, v.tags || []);
        if (category) return v.category === category;
        if (tags.length) return this.call('arrayContainsOtherArray', tags, v.tags || []);
        return true;
    };
    if (componentShowFilter === 'all') return category || tags ? arr.filter(categoryFilter) : arr;
    if (componentShowFilter === 'recents') {
        const recentComponents = recents.map((v)=>this.getSchema('components')[v]).filter((v)=>v);
        return category || tags ? recentComponents.filter(categoryFilter) : recentComponents;
    }
    if (componentShowFilter === 'builtins') return {} // COMPONENTS
    ;
    if (componentShowFilter === 'library') return {} // LIBRARY
    ;
    return category || tags ? arr.filter((v)=>v[type] && categoryFilter(v)) : arr.filter((v)=>v[type]);
}

});

parcelRegister("fZvot", function(module, exports) {

$parcel$export(module.exports, "findIcon", () => $ba44e7ab8b5a7fcd$export$41266a01e6efb017);
$parcel$export(module.exports, "getProjectIcon", () => $ba44e7ab8b5a7fcd$export$e165bda3046afda);
const $ba44e7ab8b5a7fcd$export$41266a01e6efb017 = (key)=>{
    const iconMap = {
        deviceMobile: [
            'mobile',
            'phone',
            'unset'
        ],
        deviceTabletPortrait: [
            'tabletS'
        ],
        deviceTabletLandscape: [
            'tabletM',
            'tabletL'
        ],
        deviceSmallScreen: [
            'screenS',
            'screenM'
        ],
        deviceBigScreen: [
            'screenL',
            'tv'
        ],
        columnsOutline: [
            'canvas'
        ],
        layoutOutline: [
            'custom'
        ]
    };
    let icon = null;
    const keys = Object.keys(iconMap);
    Object.values(iconMap).forEach((device, index)=>{
        const isInArray = device.includes(key);
        if (isInArray) icon = keys[index];
        else device.forEach((deviceKey)=>{
            if (key.includes(deviceKey)) icon = keys[index];
        });
    });
    return `${icon}Outline`;
};
function $ba44e7ab8b5a7fcd$export$e165bda3046afda() {
    const state = this.getRootState();
    if (state.icon?.src) return state.icon?.src;
    return null;
}

});

parcelRegister("lRwgv", function(module, exports) {

$parcel$export(module.exports, "changeFramework", () => $fea7937024a890ef$export$f17c0ddaae59f93f);
$parcel$export(module.exports, "searchDocs", () => $fea7937024a890ef$export$c52245f773332f12);
$parcel$export(module.exports, "findSentencesWithWord", () => $fea7937024a890ef$export$bab1cc227ad17ecb);
$parcel$export(module.exports, "getArticleTitle", () => $fea7937024a890ef$export$7aa4b20764201f2f);
$parcel$export(module.exports, "splitPascalCase", () => $fea7937024a890ef$export$f5ec954482b72f5b);
$parcel$export(module.exports, "areItemsEqual", () => $fea7937024a890ef$export$1d06a25b1fb270d2);
$parcel$export(module.exports, "saveToStorage", () => $fea7937024a890ef$export$20e5eb467ec2dc0a);
$parcel$export(module.exports, "addSearch", () => $fea7937024a890ef$export$e57937c15eadcf91);
$parcel$export(module.exports, "removeSearch", () => $fea7937024a890ef$export$79b5181a1ae695e3);
$parcel$export(module.exports, "getSearches", () => $fea7937024a890ef$export$f596199f5f9d5958);
function $fea7937024a890ef$export$f17c0ddaae59f93f(val, opts = {
    quiet: true
}) {
    const platformState = this.getRootState();
    platformState[opts.quiet ? 'quietUpdate' : 'update']({
        framework: val
    });
    this.call('setCookie', 'framework', val);
}
function $fea7937024a890ef$export$c52245f773332f12({ pages: pages, components: components }) {
    const ALLOWED_PAGES = [
        'docs',
        'api',
        'developers'
    ];
    const searchingPages = Object.entries(pages).reduce((acc, [key, value])=>{
        if (ALLOWED_PAGES.some((page)=>key.includes(page))) return [
            ...acc,
            [
                key,
                value
            ]
        ];
        return acc;
    }, []);
    const search = (objectData = [], input = '', searchKey = false)=>objectData.filter(([parentKey, data])=>{
            if (!data) return false;
            return Object.entries(data).some(([key, value])=>this.call('findSentencesWithWord', value, input).length > 0 || searchKey && (key.includes(input) || parentKey.includes(input)));
        });
    const componentsMatched = search(Object.entries(components), this.state.search);
    if (this.state.search?.length < 3) return;
    const pagesMatched = componentsMatched.reduce((acc, [key, value])=>{
        const pages2 = search(searchingPages, key, true);
        if (!pages2.length || acc.some(([path])=>pages2.some(([pagePath])=>pagePath === path))) return acc;
        return [
            ...acc,
            ...pages2.map((page)=>page.concat({
                    [key]: value
                }))
        ];
    }, []);
    this.state.replace({
        result: pagesMatched,
        loading: false,
        resultFor: this.state.search
    });
}
function $fea7937024a890ef$export$bab1cc227ad17ecb(obj, searchWord) {
    const sentences = new Set();
    const findInString = (text, word)=>{
        if (typeof text !== 'string') return;
        const sentenceRegex = /[^.!?]+[.!?]+/gu;
        const matchedSentences = text.match(sentenceRegex) || [];
        matchedSentences.forEach((sentence)=>{
            if (sentence.toLowerCase().includes(word.toLowerCase())) sentences.add(sentence.trim());
        });
    };
    const traverse = (data)=>{
        if (data == null) return;
        if (typeof data === 'string') {
            findInString(data, searchWord);
            return;
        }
        if (Array.isArray(data)) {
            data.forEach((item)=>traverse(item));
            return;
        }
        if (typeof data === 'object') Object.values(data).forEach((value)=>traverse(value));
    };
    traverse(obj);
    return Array.from(sentences);
}
function $fea7937024a890ef$export$7aa4b20764201f2f(s) {
    // eslint-disable-next-line prefer-destructuring
    const [path] = s[0];
    return path.split('/')[1];
}
function $fea7937024a890ef$export$f5ec954482b72f5b(str) {
    // eslint-disable-next-line prefer-named-capture-group
    return str.replace(/([A-Z])/gu, ' $1').trim();
}
const $fea7937024a890ef$var$STORAGE_KEYS = {
    RECENT: 'RECENT_STORAGE_KEY',
    FAVORITE: 'FAVORITE_STORAGE_KEY'
};
function $fea7937024a890ef$export$1d06a25b1fb270d2(item1, item2) {
    if (item1.path !== item2.path) return false;
    const areArraysEqual = (arr1 = [], arr2 = [])=>{
        if (arr1.length !== arr2.length) return false;
        return arr1.every((item, index)=>item === arr2[index]);
    };
    return areArraysEqual(item1.names, item2.names) && areArraysEqual(item1.previews, item2.previews);
}
function $fea7937024a890ef$export$20e5eb467ec2dc0a(key, items) {
    try {
        const deduplicatedItems = items.reduce((acc, current)=>{
            const exists = acc.some((item)=>this.call('areItemsEqual', item, current));
            if (!exists) acc.push(current);
            return acc;
        }, []);
        window.localStorage.setItem(key, JSON.stringify(deduplicatedItems));
    } catch (error) {
        console.error(`Failed to save to localStorage: ${error}`);
    }
}
function $fea7937024a890ef$export$e57937c15eadcf91(value, type) {
    if (!value?.path) {
        console.error('Invalid search item provided');
        return;
    }
    const { recents: recents, favorites: favorites } = this.call('getSearches');
    if (type === 'favorite') {
        const newRecents = recents.filter((item)=>!this.call('areItemsEqual', item, value));
        const newFavorites = [
            ...favorites,
            value
        ];
        this.call('saveToStorage', $fea7937024a890ef$var$STORAGE_KEYS.RECENT, newRecents);
        this.call('saveToStorage', $fea7937024a890ef$var$STORAGE_KEYS.FAVORITE, newFavorites);
    } else {
        const isInFavorites = favorites.some((item)=>this.call('areItemsEqual', item, value));
        if (!isInFavorites) {
            const newRecents = [
                ...recents,
                value
            ];
            this.call('saveToStorage', $fea7937024a890ef$var$STORAGE_KEYS.RECENT, newRecents);
        }
    }
}
function $fea7937024a890ef$export$79b5181a1ae695e3(value, type) {
    if (!value?.path) {
        console.error('Invalid search item provided');
        return;
    }
    const { recents: recents, favorites: favorites } = this.call('getSearches');
    if (type === 'favorite') {
        const newFavorites = favorites.filter((item)=>!this.call('areItemsEqual', item, value));
        const newRecents = [
            ...recents,
            value
        ];
        this.call('saveToStorage', $fea7937024a890ef$var$STORAGE_KEYS.FAVORITE, newFavorites);
        this.call('saveToStorage', $fea7937024a890ef$var$STORAGE_KEYS.RECENT, newRecents);
    } else {
        const newFavorites = favorites.filter((item)=>!this.call('areItemsEqual', item, value));
        const newRecents = recents.filter((item)=>!this.call('areItemsEqual', item, value));
        this.call('saveToStorage', $fea7937024a890ef$var$STORAGE_KEYS.FAVORITE, newFavorites);
        this.call('saveToStorage', $fea7937024a890ef$var$STORAGE_KEYS.RECENT, newRecents);
    }
}
function $fea7937024a890ef$export$f596199f5f9d5958() {
    try {
        const recents = JSON.parse(window.localStorage.getItem($fea7937024a890ef$var$STORAGE_KEYS.RECENT) || '[]');
        const favorites = JSON.parse(window.localStorage.getItem($fea7937024a890ef$var$STORAGE_KEYS.FAVORITE) || '[]');
        return {
            recents: recents,
            favorites: favorites
        };
    } catch (error) {
        console.error(`Failed to retrieve searches: ${error}`);
        return {
            recents: [],
            favorites: []
        };
    }
}

});

parcelRegister("6niK6", function(module, exports) {

$parcel$export(module.exports, "initializeSDK", () => $4a436df698a5608d$export$26d3303d189ae997);
$parcel$export(module.exports, "updateSDKContext", () => $4a436df698a5608d$export$c0784dc55987d6a3);
$parcel$export(module.exports, "initializeUserSession", () => $4a436df698a5608d$export$cb77225f5b9034ef);
$parcel$export(module.exports, "updateUserSession", () => $4a436df698a5608d$export$6dee61322d96e5d);

var $3rsQg = parcelRequire("3rsQg");
async function $4a436df698a5608d$export$26d3303d189ae997(ctx) {
    const sdk = new (0, $3rsQg.default)();
    await sdk.initialize({});
    ctx.methods.sdk = sdk;
    return sdk;
}
async function $4a436df698a5608d$export$c0784dc55987d6a3({ userData: userData, project: project }) {
    const ctx = {};
    if (userData) ctx.user = userData.user;
    if (project) {
        ctx.appKey = project.key;
        ctx.project = project;
    }
    await this.sdk.updateContext({
        ...ctx,
        state: this.getRootState()
    });
}
async function $4a436df698a5608d$export$cb77225f5b9034ef(options) {
    const { loginData: loginData } = options;
    try {
        // Store the current timestamp in sessionStorage
        sessionStorage.setItem('lastInitUserSessionTime', Date.now().toString());
        // Extract user and tokens from login response
        const { user: userData, tokens: tokens } = loginData;
        // Add projects to userData
        const userInfo = {
            ...userData,
            currentUser: userData,
            userId: userData.id
        };
        if (userData.projectId && userData.projectName && userData.appKey) {
            const contextUpdate = {
                userData: userInfo
            };
            await this.call('updateSDKContext', contextUpdate);
            this.call('updateApplicationState', {
                authToken: tokens.accessToken,
                userData: userInfo
            });
            return;
        }
        this.call('updateApplicationState', {
            authToken: tokens.accessToken,
            userData: userInfo
        });
    } catch (error) {
        console.error('Failed to initialize user session:', error);
        throw error;
    }
}
async function $4a436df698a5608d$export$6dee61322d96e5d({ projectId: projectId }) {
    try {
        // Get current user data from CoreService
        const currentUser = await this.sdk.getUserProfile();
        const userProjects = await this.sdk.getUserProjects();
        const userData = {
            ...currentUser,
            currentUser: currentUser,
            userId: currentUser.id,
            projects: userProjects || []
        };
        if (projectId) {
            const basicProject = await this.sdk.getProject(projectId);
            if (basicProject && basicProject.id) {
                const { key: appKey, name: projectName } = basicProject;
                const currentProjectMember = basicProject.members.find((m)=>m && m.user && m.user.id === userData.id);
                const projectRole = currentProjectMember ? currentProjectMember.role : 'guest';
                const contextUpdate = {
                    userData: userData,
                    ...basicProject && {
                        project: basicProject
                    },
                    ...appKey && {
                        appKey: appKey
                    },
                    ...projectRole && {
                        projectRole: projectRole
                    }
                };
                await this.call('updateSDKContext', contextUpdate);
                const loadedProjectData = await this.call('loadProjectData', projectId);
                const projectData = {
                    ...basicProject,
                    ...loadedProjectData,
                    ...appKey && {
                        appKey: appKey
                    },
                    ...projectId && {
                        projectId: projectId
                    },
                    ...projectName && {
                        projectName: projectName
                    },
                    ...projectRole && {
                        projectRole: projectRole
                    }
                };
                return this.call('updateApplicationState', {
                    userData: userData,
                    projectData: projectData
                });
            }
        }
        this.call('updateApplicationState', {
            userData: userData
        });
    } catch (error) {
        console.error('[updateUserSession] Error:', error);
        throw error;
    }
}

});

parcelRegister("eIsev", function(module, exports) {

});

parcelRegister("99POm", function(module, exports) {

$parcel$export(module.exports, "previewUrlTokenizer", () => $6aad24fa7c925c28$export$d9654de8f8ec7d19);
$parcel$export(module.exports, "screenshotTokenizer", () => $6aad24fa7c925c28$export$c0e5e78af970a194);
$parcel$export(module.exports, "imgToBase64Url", () => $6aad24fa7c925c28$export$3ebc765b89cdf628);
$parcel$export(module.exports, "createRemoteScreenshot", () => $6aad24fa7c925c28$export$679e25a5d8771e9f);
$parcel$export(module.exports, "createMainPageScreenshot", () => $6aad24fa7c925c28$export$91f661dcb5b2097a);
function $6aad24fa7c925c28$export$d9654de8f8ec7d19(obj) {
    const { appKey: appKey } = obj;
    const key = obj.key ? `?key=${obj.key}` : '';
    const width = obj.width ? `&width=${obj.width}` : '';
    const height = obj.height ? `&height=${obj.height}` : '';
    const globalTheme = obj.globalTheme === 'dark' ? '&dark_mode=true' : '';
    const hideUi = obj.hideUi ? '&hide_ui=true' : '';
    const URI = obj.isPage ? `${obj.key}?` : `/component${key}`;
    return `https://${appKey}${URI}${width}${height}${hideUi}${globalTheme}`;
}
const $6aad24fa7c925c28$var$DEF_OPTIONS = {
    selector: true,
    lazy_load: true,
    omit_background: true,
    output: true,
    retina: true,
    filetype: 'webp'
};
function $6aad24fa7c925c28$export$c0e5e78af970a194(obj, opts = {}) {
    const { appKey: appKey } = obj;
    const key = obj.key ? `?key=${obj.key}` : '';
    const width = obj.width && !opts.pdf ? `&width=${obj.width}` : '';
    const height = obj.height && !opts.pdf ? `&height=${obj.height}` : '';
    const hideUi = obj.hideUi ? `&hide_ui=${true}` : '';
    const URI = obj.isPage ? `${obj.key}?` : `/component${key}`;
    const screenshot = opts.pdf ? '' : '&screenshot=true';
    const componentUrl = encodeURIComponent(`https://${appKey}${URI}${width}${height}${hideUi}${screenshot}`);
    const userAgent = 'user_agent=Mozilla%2F5.0%20(Macintosh%3B%20Intel%20Mac%20OS%20X%2010_15_7)%20AppleWebKit%2F537.36%20(KHTML%2C%20like%20Gecko)%20Chrome%2F128.0.0.0%20Safari%2F537.36';
    const params = [
        'token=SGG5Q3D-WZN437D-NCC3ZZ2-Q15ZMZG',
        `url=${componentUrl}`,
        userAgent,
        !opts.pdf && width,
        !opts.pdf && height,
        `dark_mode=${obj.globalTheme === 'dark'}`,
        'fresh=true',
        (opts || $6aad24fa7c925c28$var$DEF_OPTIONS).output && 'output=image',
        opts.pdf ? 'file_type=pdf&pdf_options%5Bformat%5D)=A4&pdf_options%5Bmedia%5D)=print&pdf_options%5Blandscape%5D)=false&pdf_options%5Bprint_background%5D)=true&pdf_options%5Bpage_range%5D)=1-50&full_page=true&page_range=1-50&delay=350' : `file_type=${opts?.filetype || $6aad24fa7c925c28$var$DEF_OPTIONS.filetype || 'webp'}`,
        'wait_for_event=domcontentloaded',
        (opts || $6aad24fa7c925c28$var$DEF_OPTIONS).retina && 'retina=true',
        (opts || $6aad24fa7c925c28$var$DEF_OPTIONS).selector && 'selector=%5Bkey%3D%22Component%22%5D',
        (opts || $6aad24fa7c925c28$var$DEF_OPTIONS).lazy_load && 'lazy_load=true',
        (opts || $6aad24fa7c925c28$var$DEF_OPTIONS).omit_background && 'omit_background=true'
    ].filter((v)=>v).join('&');
    return `https://shot.screenshotapi.net/screenshot?&${params}`;
}
function $6aad24fa7c925c28$export$3ebc765b89cdf628(img) {
    // Encode the SVG string to Base64
    const base64 = window.btoa(unescape(encodeURIComponent(img)));
    // Create a data URL with the Base64-encoded SVG
    const base64Url = `data:image/svg+xml;base64,${base64}`;
    return base64Url;
}
async function $6aad24fa7c925c28$export$679e25a5d8771e9f(opts = {}) {
    const data = this.getCanvasScope();
    const { selected: selected } = data;
    if (!selected?.node) return;
    const { appKey: appKey, sceneTheme: sceneTheme } = this.getRootState();
    const { key: key } = this.state;
    const width = selected.node.offsetWidth;
    const height = selected.node.offsetHeight;
    const isPage = key.startsWith('/');
    const factoryKey = isPage ? 'pages' : 'components';
    const API_URL = this.call('screenshotTokenizer', {
        appKey: appKey,
        isPage: isPage,
        key: key,
        width: width,
        height: height,
        retina: false,
        hideUi: true,
        globalTheme: sceneTheme
    }, {
        pdf: opts.pdf,
        output: false
    });
    const response = await window.fetch(API_URL, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((response2)=>response2.json());
    response.smblsUrl = response.screenshot?.replace('https://storage.screenshotapi.net/', 'https://screenshots.symbo.ls/');
    // el.log(API_URL)
    // el.log(response)
    const screenshot = opts.pdf ? {
        pdf: response
    } : {
        thumbnail: response
    };
    this.getRootState().quietUpdate({
        schema: {
            [factoryKey]: {
                [key]: screenshot
            }
        }
    }, {
        message: `Updated screenshot on "${key}"`
    });
    this.state.quietUpdate(screenshot);
    this.lookup('ComponentEditor').update();
    this.lookup('EditorPanels').state.quietReplace(screenshot);
}
async function $6aad24fa7c925c28$export$91f661dcb5b2097a(changes) {
    const pages = changes?.schema?.pages;
    const projectsLength = Object.keys(pages || {}).length;
    const MainPage = pages?.['/'];
    const onlyMainPage = MainPage && projectsLength === 1 && !changes?.schema?.components;
    if (!onlyMainPage) return;
    const { appKey: appKey, sceneTheme: sceneTheme } = this.getRootState();
    const API_URL = this.call('screenshotTokenizer', {
        appKey: appKey,
        isPage: true,
        key: '/',
        width: 920,
        height: 560,
        retina: false,
        hideUi: true,
        globalTheme: sceneTheme
    });
    const response = await window.fetch(API_URL, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((response2)=>response2.json());
    // el.log(API_URL)
    // el.log(response)
    const thumbnail = response.screenshot?.replace('https://storage.screenshotapi.net/', 'https://screenshots.symbo.ls/');
    this.getRootState().quietUpdate({
        thumbnail: thumbnail
    }, {
        preventUpdate: true,
        saveOnly: true,
        preventShModalUpdate: true,
        preventContentUpdate: true,
        message: 'Updated project thumbnail'
    });
    // eslint-disable-next-line prefer-destructuring
    const activeProj = this.getRootState('projects').filter((v)=>v.key === appKey)[0];
    activeProj.thumbnail = thumbnail;
}

});

parcelRegister("6dPl3", function(module, exports) {

$parcel$export(module.exports, "goToStudioRoute", () => $487bc7c5c64ec8e6$export$495b783ac587a3a1);
const $487bc7c5c64ec8e6$export$495b783ac587a3a1 = (componentKey)=>`/studio/${componentKey}`;

});

parcelRegister("68W3F", function(module, exports) {

$parcel$export(module.exports, "updateLocked", () => $4790868bfc90e98b$export$1b1dc2a42c70db90);
/* eslint-disable no-invalid-this */ /* eslint-disable func-style */ function $4790868bfc90e98b$export$1b1dc2a42c70db90(key) {
    const prop = `lockedPrevious_${key}`;
    const overlayElem = this[key === 'hovered' ? 'Hovered' : 'Selected'];
    const activeItem = this.getCanvasScope()[key];
    const locked = this.isReadOnly() || activeItem?.state?.locked || activeItem?.state?.content?.src;
    if (this.data[prop] === locked) return;
    this.data[prop] = locked;
    if (locked) overlayElem.setNodeStyles({
        ResizeOverlay: {
            display: 'none'
        },
        DragHandler: {
            display: 'none'
        }
    });
    else overlayElem.setNodeStyles({
        ResizeOverlay: {
            display: 'block'
        },
        DragHandler: {
            display: 'block'
        }
    });
}

});

parcelRegister("eFolT", function(module, exports) {

$parcel$export(module.exports, "intersectionObserver", () => $aad7c8d9d00c0cec$export$ef81a4cd6adfcbc3);
const $aad7c8d9d00c0cec$export$ef81a4cd6adfcbc3 = (window)=>(el, s)=>{
        window.requestAnimationFrame(()=>{
            // TODO: add small looping to find node
            if (!el.node) return;
            new window.IntersectionObserver((entries)=>{
                entries.forEach((entry)=>{
                    let t = null;
                    if (entry.isIntersecting) t = setTimeout(()=>{
                        const { scale: scale } = window.scope.positions;
                        if (!el.content) el.set(scale < 0.5 ? '123' : el.data.content(el, s));
                        window.requestAnimationFrame(()=>el.node.style.opacity = 1);
                        clearTimeout(t);
                    }, 35);
                    else {
                        clearTimeout(t);
                        if (el.content) el.removeContent();
                    }
                });
            }).observe(el.node);
        });
    };

});

parcelRegister("ddvty", function(module, exports) {

$parcel$export(module.exports, "editorPanelsReposition", () => $99f4e7b075f69b6f$export$1276f51dcba930a9);
$parcel$export(module.exports, "createCanvasArtboard", () => $99f4e7b075f69b6f$export$15527cbb38bd577a);
function $99f4e7b075f69b6f$export$1276f51dcba930a9() {
    const data = this.getCanvasScope();
    const s = this.state;
    const { priorityCode: priorityCode, activeState: activeState, activeDs: activeDs, activeFunction: activeFunction, componentEditor: componentEditor } = this.getWindow();
    this.variables({
        activeFunction: activeFunction
    }).changed(()=>{
        if (activeFunction) {
            const key = data.activeFunction;
            const schema = this.getSchema('functions')[key] || this.getSchema('methods')[key];
            const value = this.getFunctions(key) || this.getMethods(key);
            const state = this.call('deepClone', {
                key: key,
                value: value,
                ...schema
            });
            this.FunctionEditor.state.set(state, {
                forceMonacoUpdate: true
            });
            this.changeCodePriority('function');
        } else {
            this.FunctionEditor.state.set({
                code: null
            }, {
                forceMonacoUpdate: true
            });
            this.changeCodePriority('component');
        }
    });
    this.variables({
        activeState: activeState
    }).changed(()=>{
        if (activeState) {
            const key = data.activeState;
            const schema = this.getSchema('state')[key];
            const value = this.getState(key);
            const state = this.call('deepClone', {
                key: key,
                value: value,
                ...schema
            });
            this.StateEditor.state.set(state, {
                forceMonacoUpdate: true
            });
            this.changeCodePriority('state');
        } else {
            this.StateEditor.state.set({
                code: null
            }, {
                forceMonacoUpdate: true
            });
            this.changeCodePriority('component');
        }
    });
    this.variables({
        priorityCode: priorityCode
    }).changed(()=>{
        const hasComponent = s.value && componentEditor;
        if (hasComponent && activeFunction) {
            const componentState = !priorityCode || priorityCode === 'component' ? '.isActive' : '!isActive';
            const functionState = priorityCode === 'function' ? '.isActive' : '!isActive';
            this.ComponentEditor.setNodeStyles(this.ComponentEditor.props[componentState]);
            this.FunctionEditor.setNodeStyles(this.FunctionEditor.props[functionState]);
        } else {
            this.ComponentEditor.setNodeStyles(this.ComponentEditor.props['!isActive']);
            this.FunctionEditor.setNodeStyles(this.ComponentEditor.props['!isActive']);
        }
    });
}
async function $99f4e7b075f69b6f$export$15527cbb38bd577a(type, key, opts) {
    const Collection = this.getCanvasCollection();
    const item = this.getItem(key, type);
    const element = await Collection.append({
        extends: Collection.childExtend,
        state: item
    }, `${Collection.content.__ref.__children.length}`);
    const frameWindow = this.getCanvasFrameWindow();
    const addedGridItem = frameWindow.gs.addWidget(element.node);
    const gridOpts = {
        w: addedGridItem.getAttribute('gs-w'),
        h: addedGridItem.getAttribute('gs-h'),
        x: addedGridItem.getAttribute('gs-x'),
        y: addedGridItem.getAttribute('gs-y')
    };
    // Quietly save grid settings in database
    window.setTimeout(()=>{
        this.sdk.updateData([
            [
                'update',
                [
                    'schema',
                    type,
                    key,
                    'settings',
                    'gridOptions'
                ],
                gridOpts
            ]
        ], {
            skipSidebar: true
        });
    }, 350);
    if (!opts.skipSelection) {
        this.activateSelected(key);
        this.zoomToNode(this.getSelected());
    }
}

});

parcelRegister("dG204", function(module, exports) {

$parcel$export(module.exports, "positions", () => $9f50bfcc9f182e96$export$878041e1e4cd4218);
$parcel$export(module.exports, "scrollStack", () => $9f50bfcc9f182e96$export$442a5db862090a4f);
$parcel$export(module.exports, "registerScrollListener", () => $9f50bfcc9f182e96$export$2ae59a3a1c144a62);
const $9f50bfcc9f182e96$export$878041e1e4cd4218 = {};
const $9f50bfcc9f182e96$export$442a5db862090a4f = [];
const $9f50bfcc9f182e96$export$2ae59a3a1c144a62 = (el)=>$9f50bfcc9f182e96$export$442a5db862090a4f.push(el);
// Add scroll event listener
document.addEventListener('scroll', (event)=>{
    if ($9f50bfcc9f182e96$export$442a5db862090a4f.length) // Filter out elements with non-existent nodes
    for(let i = $9f50bfcc9f182e96$export$442a5db862090a4f.length - 1; i >= 0; i--){
        const v = $9f50bfcc9f182e96$export$442a5db862090a4f[i];
        if (!v.node || !document.body.contains(v.node)) {
            $9f50bfcc9f182e96$export$442a5db862090a4f.splice(i, 1);
            continue;
        }
        const handler = v.on.scroll || v.onScroll;
        if (handler) handler(event, v, v.state);
    }
});
document.addEventListener('mousemove', (event)=>{
    $9f50bfcc9f182e96$export$878041e1e4cd4218.mouseX = event.clientX;
    $9f50bfcc9f182e96$export$878041e1e4cd4218.mouseY = event.clientY;
});

});

parcelRegister("cCFJt", function(module, exports) {

$parcel$export(module.exports, "generateGrid", () => $930967dcbe78814a$export$ca2a698f6020fda);
$parcel$export(module.exports, "rerenderGrid", () => $930967dcbe78814a$export$8be1d92f975fcc7);
const $930967dcbe78814a$export$ca2a698f6020fda = (n = 24)=>{
    const obj = {
        '& > .grid-stack-item': {
            width: `${100 / n}%`
        },
        '& > .grid-stack-item[gs-x="1"]': {
            left: `${100 / n}%`
        }
    };
    for(let i = 1; i <= n; i++){
        const percent = `${100 / n * i}%`;
        obj[`& > .grid-stack-item[gs-w="${i}"]`] = {
            width: percent
        };
        obj[`& > .grid-stack-item[gs-x="${i}"]`] = {
            left: percent
        };
    }
    return obj;
};
const $930967dcbe78814a$export$8be1d92f975fcc7 = async (window, el)=>{
    const optimizedMode = el.getUserSettings('optimizedMode');
    const opts = optimizedMode ? {
        ...el.gridOptions,
        // minimal resizing and dragging,
        resizable: {
            handles: 'se'
        },
        draggable: {}
    } : el.gridOptions;
    const isFreeformFalse = el.call('getCurrentCanvasPage')?.freeform === false;
    opts.float = !isFreeformFalse;
    // eslint-disable-next-line no-multi-assign
    const gs = window.gs = window.GridStack.addGrid(el.node, opts);
    const gridItems = gs.getGridItems().map((v)=>v.gridstackNode);
    await el.updateGridsInSchema(gridItems);
};

});

parcelRegister("jeUjJ", function(module, exports) {

$parcel$export(module.exports, "toggleVersion", () => $e01b0294010ac9be$export$a73d0886b3cfedec);
function $e01b0294010ac9be$export$a73d0886b3cfedec() {
    const scope = this.getCanvasScope();
    const { isVersionsOpen: isVersionsOpen } = this.getRootState();
    const Versions = this.lookup('Versions');
    const Playground = this.lookup('Playground');
    if (isVersionsOpen) {
        // if (data.explorer) {
        //   scope.explorer = false
        //   this.data.sidebarCached = true
        //   // this.EditorPanels.FilesSidebar.update()
        // }
        const closeVersions = ()=>{
            Playground.setNodeStyles(Playground['.isVersionsOpen']);
            const { selected: selected, chosen: chosen } = scope;
            scope.selectedCached = selected;
            scope.chosenCached = chosen;
            const t2 = window.setTimeout(()=>{
                this.activateSelected(null);
                this.activateChosen(null);
                const t3 = window.setTimeout(()=>{
                    Versions.VersionsAside.setNodeStyles(Versions.VersionsAside.fadeIn);
                    Versions.VersionFooter.setNodeStyles(Versions.VersionFooter.fadeIn);
                    clearTimeout(t3);
                }, 35);
                clearTimeout(t2);
            }, 35);
        };
        const t = window.setTimeout(()=>{
            if (Playground) closeVersions();
            else {
                const t2 = window.setTimeout(()=>{
                    closeVersions();
                    clearTimeout(t2);
                }, 350);
            }
            clearTimeout(t);
        }, 350);
    } else {
        Playground.setNodeStyles(Playground['!isVersionsOpen']);
        Versions.VersionsAside.setNodeStyles(Versions.VersionsAside.fadeOut);
        Versions.VersionFooter.setNodeStyles(Versions.VersionFooter.fadeOut);
        const t = window.setTimeout(()=>{
            const t2 = window.setTimeout(()=>{
                // if (scope.sidebarCached) {
                //   delete scope.sidebarCached
                //   // this.EditorPanels.update()
                // }
                const t3 = window.setTimeout(()=>{
                    const { selectedCached: selectedCached, chosenCached: chosenCached } = scope;
                    if (selectedCached) this.activateSelected(selectedCached);
                    if (chosenCached) this.activateChosen(chosenCached);
                    clearTimeout(t3);
                }, 35);
                clearTimeout(t2);
            }, 35);
            clearTimeout(t);
        }, 35);
    }
}

});

parcelRegister("5NW1c", function(module, exports) {

$parcel$export(module.exports, "setFullscreenPosition", () => $439e889cec5ac3ca$export$9d9f5f5bc57e7eec);
function $439e889cec5ac3ca$export$9d9f5f5bc57e7eec() {
    // const { isVersionsOpen, isFullscreen, isCanvasActive } = this.getRootState()
    const { isVersionsOpen: isVersionsOpen, isFullscreen: isFullscreen } = this.getRootState();
    // const Tabs = this.lookup('CanvasNavbar')
    // console.log(isFullscreen)
    // console.log(isVersionsOpen)
    this.variables({
        isFullscreen: isFullscreen,
        isVersionsOpen: isVersionsOpen
    }).changed(()=>{
        // eslint-disable-next-line init-declarations
        let top;
        // if (isFullscreen || isVersionsOpen) {
        //   top = 'var(--spacing-Y)'
        //   Tabs?.setNodeStyles?.(Tabs.props?.fadeOut)
        // } else {
        //   top = 'var(--spacing-C)'
        //   Tabs?.setNodeStyles?.(Tabs.props?.fadeIn)
        // }
        this.setNodeStyles({
            Library: {
                top: top
            },
            CanvasPane: {
                top: top
            }
        });
    });
}

});

parcelRegister("88hZW", function(module, exports) {

$parcel$export(module.exports, "openChosen", () => $5ebd082335dac044$export$aa9638b682e61bca);
$parcel$export(module.exports, "toggleChosenNavbar", () => $5ebd082335dac044$export$87eb2d7a8ac8230b);
$parcel$export(module.exports, "closeChosen", () => $5ebd082335dac044$export$fd7623d236a723f5);
$parcel$export(module.exports, "adjustChosenFrameSize", () => $5ebd082335dac044$export$21eb8af02f1466a3);
$parcel$export(module.exports, "adjustMainWindow", () => $5ebd082335dac044$export$d794b64e719e2689);
$parcel$export(module.exports, "setChosenInitialPositions", () => $5ebd082335dac044$export$7b4561c420d8271b);
$parcel$export(module.exports, "adjustChosenAfterOpen", () => $5ebd082335dac044$export$ff4295a59c0f8173);
$parcel$export(module.exports, "adjustResponsive", () => $5ebd082335dac044$export$47085748fda14b82);
/* eslint-disable no-multi-assign */ function $5ebd082335dac044$export$aa9638b682e61bca() {
    this.variables({
        chosen: this.getChosenKey()
    }).changed((changes, prev)=>{
        this.call('canvasFade', true);
        const useAnimations = this.getUserSettings('useAnimations');
        const noPrevious = !prev.chosen;
        this.call('toggleChosenNavbar');
        if (noPrevious && useAnimations) this.call('setChosenInitialPositions');
        this.getChosenScene().update();
    });
}
function $5ebd082335dac044$export$87eb2d7a8ac8230b() {
    if (this.getChosenKey()) {
        this.getChosenSceneNavbar().setNodeStyles({
            display: 'flex'
        });
        this.getEditorPanels().ComponentEditor.EditNavbar.setNodeStyles({
            display: 'none'
        });
    } else {
        this.getChosenSceneNavbar().setNodeStyles({
            display: 'none'
        });
        this.getEditorPanels().ComponentEditor.EditNavbar.setNodeStyles({
            display: 'flex'
        });
    }
}
function $5ebd082335dac044$export$fd7623d236a723f5() {
    const { isVersionsOpen: isVersionsOpen } = this.getRootState();
    this.call('canvasFade', false);
    this.getChosenViewSvitcher().setNodeStyles({
        transitionProperty: 'none',
        opacity: 0
    });
    this.call('toggleChosenNavbar');
    this.data.loaded = null;
    if (!isVersionsOpen) this.getRootState().isFullscreen = false;
}
function $5ebd082335dac044$export$21eb8af02f1466a3() {
    const scope = this.getCanvasScope();
    const { explorer: explorerInChosenPosChanged, selected: selectedPosChanged, editorActive: editorActive } = scope;
    this.variables({
        editorActive: editorActive,
        explorerInChosenPosChanged: explorerInChosenPosChanged,
        selectedPosChanged: selectedPosChanged
    }).changed(()=>{
        const t = setTimeout(()=>{
            let left = 'var(--canvas-gutter)';
            if (this.call('isString', explorerInChosenPosChanged)) {
                const dynamicIslandElementRect = this.getDynamicIsland().node.getBoundingClientRect();
                // const width = this.getDynamicIsland().node.scrollWidth
                left = `calc(var(--canvas-gutter) + ${dynamicIslandElementRect.left + dynamicIslandElementRect.width}px)`;
            } else if (editorActive) {
                const quickEditorRect = this.getQuickEditor().node.getBoundingClientRect();
                // const width = this.getDynamicIsland().node.scrollWidth
                left = `calc(var(--canvas-gutter) + ${quickEditorRect.left + quickEditorRect.width}px)`;
            }
            this.getChosenElement().setNodeStyles({
                left: left
            });
            clearTimeout(t);
        }, 250);
    });
}
function $5ebd082335dac044$export$d794b64e719e2689() {
    const isFullscreenEditorPanels = this.getRootState('isFullscreen');
    const s = this.state;
    const data = this.getCanvasScope();
    // if (!data) return
    const { docs: docs, fiddle: fiddle, componentEditor: componentEditor, explorer: explorerInChosen, library: library, designSystem: designSystem, selected: selected, activeFunction: activeFunction, activeState: activeState, activeDs: activeDs } = data;
    const isCodeViewerActive = selected && componentEditor || activeFunction || activeState || activeDs;
    const selectedInChosen = this.getSelectedKey();
    const chosenInChosen = this.getChosenKey();
    this.variables({
        selectedInChosen: selectedInChosen,
        chosenInChosen: chosenInChosen,
        isFullscreenEditorPanels: isFullscreenEditorPanels,
        docs: docs,
        fiddle: fiddle,
        library: library,
        designSystem: designSystem,
        explorerInChosen: explorerInChosen,
        componentEditor: componentEditor,
        activeFunction: activeFunction,
        activeState: activeState,
        activeDs: activeDs,
        isCodeViewerActive: isCodeViewerActive
    }).changed(async (changes)=>{
        if (isCodeViewerActive) this.getEditorPanels().setNodeStyles({
            display: 'flex'
        });
        else this.getEditorPanels().setNodeStyles({
            display: 'none'
        });
        const selectedHasChanged = Object.hasOwn(changes, 'selectedInChosen');
        if (selectedHasChanged) {
            data.hoverLayer = null;
            data.activeLayer = null;
            if (selectedInChosen) {
                const componentState = this.call('deepClone', this.getSelected().state.parse());
                // console.log(componentState)
                await s.set(componentState, {
                    preventStateUpdateListener: true,
                    forceMonacoUpdate: true
                });
            } else if (!selectedInChosen) {
                if (s.value) {
                    delete s.code;
                    await s.remove('value', {
                        preventStateUpdateListener: true,
                        forceMonacoUpdate: false
                    });
                }
            }
            const autoscroll = this.getUserSettings('explorerAutoscroll');
            if (autoscroll && explorerInChosen) {
                await this.call('rerenderFileSidebarByType', 'components');
                await this.call('rerenderFileSidebarByType', 'pages');
            }
        }
        const codeEditorHasChanged = Object.hasOwn(changes, 'isCodeViewerActive');
        if (selectedHasChanged || codeEditorHasChanged) {
            if (isCodeViewerActive) {
                this.getComponentEditor().parent.setNodeStyles({
                    display: 'flex'
                });
                this.getComponentEditor().setNodeStyles({
                    display: 'flex'
                });
                if (codeEditorHasChanged && !selectedHasChanged) this.getComponentEditor().update();
                window.requestAnimationFrame(()=>{
                    this.changeCodePriority('component', this);
                });
            } else {
                this.getComponentEditor().parent.setNodeStyles({
                    display: 'none'
                });
                this.getComponentEditor().setNodeStyles({
                    display: 'none'
                });
            }
        }
    });
}
function $5ebd082335dac044$export$7b4561c420d8271b() {
    const data = this.getCanvasScope();
    const { positions: positions, chosen: chosen } = data;
    const { scale: scale } = positions;
    const ChosenElem = chosen?.Flex || chosen;
    if (!ChosenElem.node) return;
    const rect = ChosenElem.node.getBoundingClientRect();
    const ChosenScene = this.getChosenScene();
    const chosenScenePos = ChosenScene.node.getBoundingClientRect();
    const ViewSvitcher = ChosenScene.ViewSvitcher;
    // Calculate the position relative to ChosenScene
    const relLeft = rect.left - chosenScenePos.left + ChosenScene.node.scrollLeft;
    const relTop = rect.top - chosenScenePos.top + ChosenScene.node.scrollTop;
    const unscaledWidth = rect.width / scale;
    const unscaledHeight = rect.height / scale;
    // When scaling from center, the top-left corner shifts by:
    // (unscaled_dimension * (scale - 1)) / 2
    // We need to compensate by moving the element back
    const offsetX = unscaledWidth * (scale - 1) / 2;
    const offsetY = unscaledHeight * (scale - 1) / 2;
    const left = relLeft + offsetX;
    const top = relTop + offsetY;
    const right = left + unscaledWidth;
    const bottom = top + unscaledHeight;
    ViewSvitcher.setNodeStyles({
        opacity: 1,
        transitionProperty: 'none',
        transform: `translate3d(0, 0, 1px) scale(${scale})`,
        inset: `${top}px ${ChosenScene.node.offsetWidth - right}px ${ChosenScene.node.offsetHeight - bottom}px ${left}px`
    });
}
function $5ebd082335dac044$export$ff4295a59c0f8173() {
    const { data: data } = this;
    window.requestAnimationFrame(()=>{
        this.getChosenScene().ViewSvitcher.setNodeStyles({
            transform: 'translate3d(0, 0, 1px)',
            transitionProperty: 'transform, inset',
            position: 'absolute',
            opacity: 1,
            inset: '0',
            width: 'auto',
            height: 'auto'
        });
        window.requestAnimationFrame(()=>{
            this.getChosenSceneNavbar().update();
        });
    });
    data.loaded = true;
}
function $5ebd082335dac044$export$47085748fda14b82() {
    const { previewSize: previewSize } = this.getCanvasScope();
    const ChosenScene = this.getChosenScene();
    const { ComponentFrameCanvas: ComponentFrameCanvas } = ChosenScene.ViewSvitcher;
    const isUnset = previewSize === 'unset';
    const isResizable = previewSize === 'resizable';
    const isCustom = previewSize === 'custom';
    const isAllDevices = previewSize === 'canvas';
    this.variables({
        previewSize: previewSize
    }).changed((changes, prev)=>{
        const wasResizable = prev.previewSize === 'resizable';
        const wasCustom = prev.previewSize === 'custom';
        const wasAllDevices = prev.previewSize === 'canvas';
        ComponentFrameCanvas.setNodeStyles({
            transitionProperty: 'transform, max-width, max-height, left, top, right, width, height'
        });
        const t = setTimeout(()=>{
            ComponentFrameCanvas.setNodeStyles({
                transitionProperty: 'transform, max-width, max-height, left, top, right'
            });
            clearTimeout(t);
        }, 350);
        if (isCustom || wasCustom || isAllDevices || wasAllDevices) {
            const t2 = setTimeout(()=>{
                ChosenScene.ViewSvitcher.removeContent();
                ChosenScene.ViewSvitcher.set(ChosenScene.ViewSvitcher.data.content(this, this.state, this.context));
                clearTimeout(t2);
            }, 65);
        }
        if (isAllDevices) {
            const breakpoint = this.context.designSystem.DEVICES.mobileM;
            const [widthVal] = breakpoint;
            const maxWidth = `${widthVal}px`;
            ComponentFrameCanvas.setNodeStyles({
                ...ComponentFrameCanvas.props['.isAllDevices'],
                maxWidth: maxWidth,
                maxHeight: '100%'
            });
            const t2 = setTimeout(()=>{
                if (ChosenScene.ViewSvitcher) ChosenScene.ViewSvitcher.node.scrollBy(3600, 0);
                clearTimeout(t2);
            }, 65);
        // this.setNodeStyles({
        //   content: {}
        // })
        } else if (wasAllDevices) // this.setNodeStyles({
        //   content: {
        //   }
        // })
        ComponentFrameCanvas.setNodeStyles({
            ...ComponentFrameCanvas.props['!isAllDevices']
        });
        if (isResizable) ComponentFrameCanvas.setNodeStyles({
            ...ComponentFrameCanvas.props['.isResizable']
        });
        else if (wasResizable) ComponentFrameCanvas.setNodeStyles({
            // height: '100%',
            ...ComponentFrameCanvas.props['!isResizable']
        });
        if (isCustom) ComponentFrameCanvas.setNodeStyles({
            ...ComponentFrameCanvas.props['.isResponsiveMode']
        });
        else if (wasCustom) ComponentFrameCanvas.setNodeStyles({
            ...ComponentFrameCanvas.props['!isResponsiveMode']
        });
        if (isUnset || !previewSize) ComponentFrameCanvas.setNodeStyles({
            width: '100%',
            height: '100%',
            maxWidth: '100%',
            maxHeight: '100%'
        });
        else if (!isAllDevices && !isResizable && !isCustom) {
            const { DEVICES: DEVICES } = this.context && this.context.designSystem;
            const breakpoint = DEVICES[previewSize];
            const [width, height] = breakpoint;
            const maxWidth = width ? `${width}px` : '100%';
            ComponentFrameCanvas.setNodeStyles({
                width: '100%',
                height: `${height}px`,
                maxWidth: maxWidth
            });
        }
    });
    const responsiveState = ChosenScene.ViewSvitcher.content?.state;
    const responsiveSize = responsiveState?.previewSize;
    if (isCustom) this.variables({
        responsiveSize: responsiveSize
    }).changed(()=>{
        const devices = this.context.designSystem.DEVICES;
        const breakpoint = devices[responsiveSize];
        if (breakpoint) {
            const [widthVal, HeightVal] = breakpoint;
            const maxWidth = `calc(${`${widthVal}px`} - 1.8em)`;
            const maxHeight = `calc(${`${HeightVal}px`} - 5em)`;
            ComponentFrameCanvas.setNodeStyles({
                maxWidth: maxWidth,
                maxHeight: maxHeight
            });
        } else ComponentFrameCanvas.setNodeStyles({
            maxWidth: '100%',
            maxHeight: '100%'
        });
    });
}

});

parcelRegister("999Gp", function(module, exports) {

$parcel$export(module.exports, "handleLayerPaste", () => $6a8c77257abcb941$export$3712d80c46171fd);
$parcel$export(module.exports, "getCodeToCopy", () => $6a8c77257abcb941$export$9e726c97c31d5f);
$parcel$export(module.exports, "getActiveLayerCode", () => $6a8c77257abcb941$export$8f090cdf15e733f6);
$parcel$export(module.exports, "getFullComponentCode", () => $6a8c77257abcb941$export$550970ab68d86e29);
$parcel$export(module.exports, "getUsedComponentsKeys", () => $6a8c77257abcb941$export$d04bbea7c1955478);
/* eslint-disable no-use-before-define */ parcelRequire("2oe0q");
var $bmfNh = parcelRequire("bmfNh");
async function $6a8c77257abcb941$export$3712d80c46171fd(key, layerCode, _) {
    const data = this.getCanvasScope();
    const schema = (0, $bmfNh.deepClone)(data.selected.state.parse());
    const { activeLayer: activeLayer } = data;
    const updateDiff = activeLayer ? (0, $bmfNh.createNestedObject)(activeLayer.slice(1), {
        [key]: layerCode || {}
    }) : {
        [key]: layerCode || {}
    };
    (0, $bmfNh.deepMerge)(schema.value, updateDiff);
    delete schema.code;
    delete schema.codeStr;
    const layerInfo = activeLayer ? `${activeLayer.slice(-1)} layer` : '';
    const componentType = this.getType(schema);
    const commitMessage = `${key} layer is pasted in ${layerInfo} at ${schema.key} ${componentType.slice(0, -1)}`;
    this.sdk.updateItem(componentType, schema, {
        message: commitMessage
    });
    setTimeout(async ()=>{
    // await this.call('updateComponentOnCanvas', schema, {
    //   updatePane: true
    // })
    }, 0);
    if (activeLayer) data.activeLayer.push(key);
    else data.activeLayer = [
        'content',
        key
    ];
}
function $6a8c77257abcb941$export$9e726c97c31d5f() {
    const data = this.getCanvasScope();
    if (data.activeLayer) return this.call('getActiveLayerCode');
    return this.call('getFullComponentCode');
}
function $6a8c77257abcb941$export$8f090cdf15e733f6() {
    const data = this.getCanvasScope();
    const { activeLayer: activeLayer } = data;
    const value = (0, $bmfNh.deepClone)(data.selected.state.value);
    const layerCode = activeLayer.reduce((acc, item)=>acc[item] || acc, value);
    const key = activeLayer.length > 1 ? activeLayer[activeLayer.length - 1] : value.key;
    return {
        metadata: 'copiedFromSymbols',
        key: key,
        layerCode: layerCode
    };
}
function $6a8c77257abcb941$export$550970ab68d86e29() {
    const data = this.getCanvasScope();
    const code = (0, $bmfNh.deepClone)(data.selected.state.parse());
    code.metadata = 'copiedFromSymbols';
    return code;
}
function $6a8c77257abcb941$export$d04bbea7c1955478(DEFAULT_COMPONENT, allUsed, type, uniqUses = []) {
    let collectedKeys = [];
    allUsed.forEach((key)=>{
        if (!DEFAULT_COMPONENT[key]) {
            const keyElement = this.call('getSchemaItem', key, type);
            if (keyElement && !uniqUses[keyElement]) {
                collectedKeys.push(key);
                collectedKeys = [
                    ...collectedKeys,
                    ...$6a8c77257abcb941$export$d04bbea7c1955478.call(this, DEFAULT_COMPONENT, keyElement.uses, keyElement.type, collectedKeys)
                ];
            }
        }
    });
    return collectedKeys;
}

});

parcelRegister("i65Lz", function(module, exports) {

$parcel$export(module.exports, "handleActiveLayerDeletion", () => $d2cd429b46d20dd9$export$b6101e577079b465);
$parcel$export(module.exports, "handleComponentDeletion", () => $d2cd429b46d20dd9$export$b8b73182341c4aa);
parcelRequire("2oe0q");
var $bmfNh = parcelRequire("bmfNh");
async function $d2cd429b46d20dd9$export$b6101e577079b465(activeLayer) {
    const data = this.getCanvasScope();
    const key = data.activeLayer.pop();
    const schema = (0, $bmfNh.deepClone)(data.selected.state.parse());
    this.setCanvasMode(false);
    const confirmRemove = `Do you want to remove the "${key}" layer from ${schema.key}?`;
    if (!window.confirm(confirmRemove)) return;
    (0, $bmfNh.removeNestedKeyByPath)(schema.component, activeLayer.slice(1).concat(key));
    delete schema.code;
    delete schema.codeStr;
    const componentType = schema.key.startsWith('/') ? 'pages' : 'components';
    const commitMessage = `${key} layer is removed from ${schema.key} ${componentType}`;
// await this.updateItem(schema, null, { message: commitMessage })
// await this.updateComponentOnCanvas(schema, { updatePane: true })
}
async function $d2cd429b46d20dd9$export$b8b73182341c4aa() {
    const selected = this.getSelected();
    const item = selected?.state;
    if (item) this.call('removeCanvasArtboard', item.type, item.key);
    else this.warn('Cant find component');
}

});

parcelRegister("dmv7F", function(module, exports) {

$parcel$export(module.exports, "APP_PAGES", () => $9ba578bf198a502e$export$acc1c5b9f04218ce);
$parcel$export(module.exports, "GUEST_PAGES", () => $9ba578bf198a502e$export$e2818e9072fdb09b);
$parcel$export(module.exports, "GREEN_PAGES", () => $9ba578bf198a502e$export$d2be480eab2241d6);
$parcel$export(module.exports, "redirectBasedOnAuth", () => $9ba578bf198a502e$export$6b6ff5f3b35e0c89);
const $9ba578bf198a502e$export$acc1c5b9f04218ce = [
    '/',
    '/dashboard',
    '/cli-connect',
    '/new-tab',
    '/design-system',
    '/canvas',
    // '/extension',
    '/components',
    '/init',
    '/search',
    '/switch',
    '/studio',
    '/schema',
    '/fetch',
    '/onboarding',
    '/settings',
    '/editor',
    '/files',
    '/layouts',
    '/atoms',
    '/marketplace',
    '/editor',
    '/export',
    '/pages',
    '/page',
    '/account',
    '/data',
    '/state',
    '/logout',
    '/color',
    '/theme',
    '/connect',
    '/install',
    '/integrations',
    '/typography',
    '/spacing',
    '/shape',
    '/governance',
    '/font',
    '/cases',
    '/timing',
    '/composite',
    '/icons',
    '/grid',
    '/media'
];
const $9ba578bf198a502e$export$e2818e9072fdb09b = [
    '/signin',
    '/reset-password',
    '/access-signup',
    '/signup',
    '/privacy',
    '/terms',
    '/confirm',
    '/get-early-access'
];
const $9ba578bf198a502e$export$d2be480eab2241d6 = [
    '/invest',
    '/careers',
    '/sandpack',
    '/compile',
    '/box-model',
    '/box-size',
    '/schedule-demo',
    '/invite',
    '/accept-invite',
    '/google-auth-callback',
    '/github-auth-callback',
    '/docs',
    '/pricing',
    '/pricing-lifetime',
    '/props',
    '/snippet',
    '/functions',
    '/function',
    '/watch',
    '/tutorial',
    '/tutorials',
    '/convert',
    '/playground',
    '/fiddles',
    '/developers',
    '/timeline',
    '/index',
    '/extension',
    '/api',
    '/cli',
    '/waitlist',
    // '/library',
    '/component',
    '/blocks',
    '/block',
    '/properties',
    '/convert',
    '/markdown',
    '/learning-center'
];
function $9ba578bf198a502e$export$6b6ff5f3b35e0c89(route) {
    const redirectInside = (innerRoute)=>{
        const pathname = innerRoute;
        const isInApp = this.call('checkIfStringIsInArray', pathname, $9ba578bf198a502e$export$acc1c5b9f04218ce);
        const isGreen = this.call('checkIfStringIsInArray', pathname, $9ba578bf198a502e$export$d2be480eab2241d6);
        const isInGuests = this.call('checkIfStringIsInArray', pathname, $9ba578bf198a502e$export$e2818e9072fdb09b);
        if ((isInApp || isGreen || !isInGuests) && innerRoute && innerRoute !== '/') return innerRoute;
        return '/dashboard' // fallback to dashboard
        ;
    };
    const redirectOutside = (innnerRoute)=>{
        const isInGuests = this.call('checkIfStringIsInArray', innnerRoute, $9ba578bf198a502e$export$e2818e9072fdb09b);
        const isGreen = this.call('checkIfStringIsInArray', innnerRoute, $9ba578bf198a502e$export$d2be480eab2241d6);
        if (isInGuests || isGreen) return innnerRoute;
        const path = window.location.pathname;
        // allow embed
        if (path.startsWith('/embed')) return path;
        const [, user, projectKey] = path.split('/');
        // allow if project path matches, TODO: check with server
        if (user && projectKey) return `/${user}/${projectKey}`;
        return '/';
    };
    const isAuthorised = this.isAuthorised();
    if (isAuthorised) return redirectInside(route);
    return redirectOutside(route);
}

});

parcelRegister("k1Fdq", function(module, exports) {

$parcel$export(module.exports, "checkPrivilegies", () => $e943df2beb2afde9$export$d9531875d779e24f);
$parcel$export(module.exports, "platformPrivilegies", () => $e943df2beb2afde9$export$9f1f59a80e4c8a7a);
/* eslint-disable no-invalid-this */ /* eslint-disable func-style */ // eslint-disable-next-line no-empty-function
function $e943df2beb2afde9$export$d9531875d779e24f() {}
function $e943df2beb2afde9$export$9f1f59a80e4c8a7a() {
    const platformState = this.getRootState();
    const isDev = platformState.appKey === 'smbls.symbo.ls' || platformState.appKey === 'default.symbo.ls';
    const isAdmin = platformState.userId === 'usb148d6dd' || platformState.userId === 'usb8964b6c';
    if (!isDev || isDev && isAdmin) return true;
}

});

parcelRegister("fs6XN", function(module, exports) {

$parcel$export(module.exports, "domToSvg", () => $b3fedf510829c997$export$cd250c71e7601320);
async function $b3fedf510829c997$export$cd250c71e7601320(node) {
    if (!node) return;
    const { elementToSVG: elementToSVG } = await window.requireOnDemand('dom-to-svg');
    const svgDocument = elementToSVG(node);
    const svg = new window.XMLSerializer().serializeToString(svgDocument);
    return svg;
}

});

parcelRegister("k5qRy", function(module, exports) {

$parcel$export(module.exports, "getSessionId", () => $e9f91caa00559724$export$b3739caaf2580dd);
$parcel$export(module.exports, "storeSessionId", () => $e9f91caa00559724$export$4c02d00eb22f0aa0);
$parcel$export(module.exports, "clearSession", () => $e9f91caa00559724$export$7809a8af6f3e4c63);
$parcel$export(module.exports, "giveMeAnswer", () => $e9f91caa00559724$export$8af90985472ecadd);
$parcel$export(module.exports, "parseAIAnswer", () => $e9f91caa00559724$export$33b28256335a1637);
$parcel$export(module.exports, "animateMultiple", () => $e9f91caa00559724$export$12fb5297a6392e51);
$parcel$export(module.exports, "setPrompt", () => $e9f91caa00559724$export$4e1853f4cf46b56a);
$parcel$export(module.exports, "handleGreetingResponse", () => $e9f91caa00559724$export$a96d670f3be116b6);
$parcel$export(module.exports, "handleTextResponse", () => $e9f91caa00559724$export$da18648f8f831672);
$parcel$export(module.exports, "formatCodeBlock", () => $e9f91caa00559724$export$8dbb8448e0047b22);
$parcel$export(module.exports, "formatTextParts", () => $e9f91caa00559724$export$c3442fa986207734);
$parcel$export(module.exports, "handleCodeResponse", () => $e9f91caa00559724$export$437dfbd38e9388b8);
$parcel$export(module.exports, "sanitizeComponentCode", () => $e9f91caa00559724$export$bc39e7fd63e237cf);
$parcel$export(module.exports, "buildCodeResponseUI", () => $e9f91caa00559724$export$63fe856bc11eb743);
$parcel$export(module.exports, "buildFallbackMessage", () => $e9f91caa00559724$export$d017e3b65d5db5d);
$parcel$export(module.exports, "submitPrompt", () => $e9f91caa00559724$export$f2d682d614f105bc);
// Session management for conversation continuity
let $e9f91caa00559724$var$currentSessionId = null;
function $e9f91caa00559724$export$b3739caaf2580dd() {
    console.log("\uD83D\uDD0D getSessionId() called");
    console.log("\uD83D\uDD0D currentSessionId:", $e9f91caa00559724$var$currentSessionId);
    console.log("\uD83D\uDD0D localStorage ai_session_id:", localStorage.getItem('ai_session_id'));
    if ($e9f91caa00559724$var$currentSessionId) {
        console.log("\u2705 Using existing in-memory session ID:", $e9f91caa00559724$var$currentSessionId);
        return $e9f91caa00559724$var$currentSessionId;
    }
    // Try to get from localStorage for persistence across page reloads
    const storedSessionId = localStorage.getItem('ai_session_id');
    if (storedSessionId) {
        $e9f91caa00559724$var$currentSessionId = storedSessionId;
        console.log("\u2705 Restored session ID from localStorage:", $e9f91caa00559724$var$currentSessionId);
        return $e9f91caa00559724$var$currentSessionId;
    }
    console.log("\u274C No existing session ID - will create new session");
    return null // Let the API create a new session
    ;
}
function $e9f91caa00559724$export$4c02d00eb22f0aa0(sessionId) {
    console.log('storeSessionId called with:', sessionId);
    if (sessionId) {
        $e9f91caa00559724$var$currentSessionId = sessionId;
        try {
            localStorage.setItem('ai_session_id', sessionId);
            console.log("\u2705 Successfully stored session ID:", sessionId);
            console.log("\u2705 localStorage now contains:", localStorage.getItem('ai_session_id'));
        } catch (e) {
            console.error("\u274C Failed to store session ID in localStorage:", e);
        }
    } else console.warn("\u26A0\uFE0F storeSessionId called with null/undefined sessionId");
}
function $e9f91caa00559724$export$7809a8af6f3e4c63() {
    $e9f91caa00559724$var$currentSessionId = null;
    localStorage.removeItem('ai_session_id');
    console.log('Session cleared - next request will start new conversation');
}
async function $e9f91caa00559724$export$8af90985472ecadd(text, images, selectedModel) {
    const apiUrl = 'https://smart-assistant-production.up.railway.app/api/prompt';
    const cleanData = await this.call('getCleanCanvasScope', this.getCanvasScope());
    const data = Object.fromEntries(Object.entries(cleanData).filter(([_, value])=>value !== undefined && value !== null));
    const requestBody = {
        query: text,
        data: data,
        model: selectedModel || 'Starter' // Default to Free if no model specified
    };
    const selectedResource = this.getChosenKey() || this.getSelectedKey();
    if (selectedResource) requestBody.selectedResource = selectedResource;
    const selectedFunction = this.getCanvasScope().activeFunction;
    if (selectedFunction) requestBody.selectedFunction = selectedFunction;
    // Add session ID for conversation continuity
    console.log("\uD83D\uDD0D Building request - checking for session ID...");
    const sessionId = $e9f91caa00559724$export$b3739caaf2580dd();
    if (sessionId) {
        requestBody.session_id = sessionId;
        console.log("\u2705 Added session_id to request:", sessionId);
    } else console.log("\u274C No session_id to add to request");
    let responseHtml = '<p>Apologies, something went wrong while contacting the assistant.</p>';
    if (images && images.length > 0) {
        // if (images?.length) {
        //   [mockData[3][1].value.Img.src] = images
        //   const changes = await this.sdk.addMultipleItems([mockData[3]])
        //   this.call('animateMultiple', changes)
        //   return `<p><b>${mockData[3][1].key}</b> component with image added to the Canvas.</p>`
        // }
        const imageDataUrl = images[0] // Assuming images[0] is a data URL
        ;
        // Example: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUg..."
        const parts = imageDataUrl.split(',');
        if (parts.length === 2 && parts[0].includes('data:') && parts[0].includes('base64')) {
            const mimePart = parts[0].substring(parts[0].indexOf(':') + 1, parts[0].indexOf(';'));
            requestBody.image_data = parts[1];
            requestBody.image_mime_type = mimePart;
            console.log(`Sending image with MIME type: ${mimePart}`);
        } else console.error('Invalid or unsupported image data URL format:', imageDataUrl.substring(0, 100));
    }
    try {
        console.log('Sending request to API:', JSON.stringify(requestBody, null, 2));
        const response = await fetch(apiUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(requestBody)
        });
        const responseText = await response.text() // Get raw response text for debugging
        ;
        console.log('Raw API Response:', responseText);
        if (!response.ok) {
            let errorDetail = 'Unknown error';
            try {
                const errorData = JSON.parse(responseText);
                errorDetail = errorData.detail || errorData.error || response.statusText;
            } catch (e) {
                errorDetail = response.statusText || 'Failed to parse error response';
            }
            console.error('API Error:', response.status, errorDetail);
            responseHtml = `<p>Error from assistant: ${errorDetail}</p>`;
            return responseHtml;
        }
        try {
            const data = JSON.parse(responseText);
            console.log('Parsed API Data:', data);
            console.log("\uD83D\uDD0D Checking for session_id in response...");
            console.log("\uD83D\uDD0D Full response structure:", JSON.stringify(data, null, 2));
            // Try to extract session_id from different possible locations in the response
            let sessionId = null;
            console.log("\uD83D\uDD0D DEBUG: data.session_id value:", data.session_id);
            console.log("\uD83D\uDD0D DEBUG: typeof data.session_id:", typeof data.session_id);
            console.log("\uD83D\uDD0D DEBUG: data.session_id truthy?", !!data.session_id);
            // Check top level
            if (data.session_id) {
                sessionId = data.session_id;
                console.log("\u2705 Found session_id at top level:", sessionId);
            } else if (data.code_response && data.code_response.session_id) {
                sessionId = data.code_response.session_id;
                console.log("\u2705 Found session_id in code_response:", sessionId);
            } else if (data.response && data.response.session_id) {
                sessionId = data.response.session_id;
                console.log("\u2705 Found session_id in response:", sessionId);
            } else {
                console.warn("\u26A0\uFE0F No session_id found in API response!");
                console.warn("\u26A0\uFE0F Available response keys:", Object.keys(data));
                console.warn("\u26A0\uFE0F data.session_id specifically:", data.session_id);
                console.warn("\u26A0\uFE0F Response structure:", JSON.stringify(data, null, 2));
            }
            // Store session ID if found
            if (sessionId) {
                console.log("\u2705 Found session_id, storing it...");
                $e9f91caa00559724$export$4c02d00eb22f0aa0(sessionId);
                console.log("\u2705 Session continuity enabled - future requests will use session:", sessionId);
            }
            return data;
        } catch (e) {
            console.error('Error parsing API response:', e);
            return responseText // Return raw response if parsing fails
            ;
        }
    } catch (error) {
        console.error('Failed to fetch from API or process response:', error);
        return `<p>Failed to connect to the assistant: ${error.message}</p>`;
    }
}
function $e9f91caa00559724$export$33b28256335a1637(message) {
    // Handle our new, structured JSON response
    if (message?.code_response?.type === 'json_response') {
        const data = message.code_response.data;
        console.log('Parsing json_response:', data);
        // The AI has returned a structured asset. We can now process it.
        // The goal is to return an object that the calling component can use
        // to either render something on the canvas or display information.
        return {
            asset: data,
            type: data.type + 's',
            message: data.description || `Successfully generated ${data.type}: ${data.title}`
        };
    }
    if (message?.code_response?.type === 'symbols_component_code') {
        const data = message.code_response.component_code;
        const parsed = JSON.parse('[' + data + ']');
        return {
            asset: parsed,
            multiple: true,
            message: `Successfully generated multiple items `
        };
    }
    // Fallback for plain text or error responses from the Python server
    if (message?.code_response?.type === 'plain_text_response') return {
        message: message.code_response.content
    };
    if (message?.code_response?.type === 'error') return {
        message: `An error occurred: ${message.code_response.content}`
    };
    // Legacy handling for older response formats, if any are still in use.
    if (message && message.response) {
        const responseData = message.response;
        if (responseData.type === 'greeting') return {
            message: responseData
        };
        else if (responseData.type === 'text_response' && responseData.content) {
            const content = responseData.content;
            const parts = content.split(/(```(?:js|javascript)?\n[\s\S]*?```)/g);
            const children = parts.filter((part)=>part).map((part)=>{
                if (part.startsWith('```')) {
                    const code = part.replace(/```(js|javascript)?\n/, '').replace(/```$/, '');
                    return {
                        code: code
                    };
                } else return part.split(/(### .*)/g).filter((p)=>p).map((textPart)=>{
                    if (textPart.startsWith('### ')) return {
                        message: textPart.substring(4)
                    };
                    return {
                        message: textPart
                    };
                });
            }).flat();
            return {
                children: children
            };
        }
    }
    console.log('Unhandled message format:', message);
    return {
        message: 'Received an unrecognized response from the assistant.'
    };
}
function $e9f91caa00559724$export$12fb5297a6392e51(changes) {
    const jointData = [];
    changes.forEach((item, i)=>{
        if (i % 2 === 0) {
            const [, , value] = item;
            jointData.push({
                value: value
            });
        } else {
            const [, , schema] = item;
            const currentItem = jointData[jointData.length - 1];
            jointData[jointData.length - 1] = {
                ...currentItem,
                ...schema
            };
        }
    });
    console.log(jointData);
    jointData.forEach(async (item, i)=>{
    // const t = setTimeout(async () => {
    // await this.addComponentOnCanvas(item)
    // clearTimeout(t)
    // }, i * 350)
    });
}
async function $e9f91caa00559724$export$4e1853f4cf46b56a(msg) {
    const AIMessage = this.getFilesSidebarPrompt().Label.Span;
    await AIMessage.state.update({
        keyword: msg
    });
    const t = setTimeout(()=>{
        AIMessage.update({
            html: AIMessage.state.keyword + '&nbsp;'
        });
        AIMessage.node.focus();
        const t2 = setTimeout(()=>{
            // select all the content in the element
            document.execCommand('selectAll', false, null);
            // collapse selection to the end
            document.getSelection().collapseToEnd();
            clearTimeout(t2);
        }, 35);
        clearTimeout(t);
    }, 35);
}
function $e9f91caa00559724$export$a96d670f3be116b6(responseData) {
    return {
        flow: 'y',
        gap: 'A',
        padding: 'Y2 A',
        shape: 'bubble',
        shapeDirection: 'top right',
        round: 'C X C C',
        theme: 'dialog',
        maxWidth: 'I1',
        children: [
            {
                extends: 'P',
                text: responseData.message,
                fontWeight: '500'
            },
            {
                extends: 'P',
                text: responseData.capabilities_summary,
                margin: 'A 0 Z',
                color: 'caption'
            },
            ...responseData.categories.map((category)=>({
                    flow: 'y',
                    gap: 'Z1',
                    children: [
                        {
                            extends: 'H6',
                            text: category.name,
                            fontSize: 'Z1',
                            margin: '0 0 X'
                        },
                        {
                            flow: 'y',
                            gap: 'X',
                            children: category.items.map((item)=>({
                                    extends: 'P',
                                    text: `- ${item}`,
                                    color: 'caption',
                                    fontSize: 'Z'
                                }))
                        }
                    ]
                }))
        ]
    };
}
function $e9f91caa00559724$export$da18648f8f831672(content) {
    const parts = content.split(/(```(?:js|javascript)?\n[\s\S]*?```)/g);
    const children = parts.filter((part)=>part).map((part)=>{
        if (part.startsWith('```')) return $e9f91caa00559724$export$8dbb8448e0047b22(part);
        return $e9f91caa00559724$export$c3442fa986207734(part);
    }).flat();
    return {
        flow: 'y',
        gap: 'A',
        padding: 'Y2 A',
        shape: 'bubble',
        shapeDirection: 'top right',
        round: 'C X C C',
        theme: 'dialog',
        maxWidth: '85%',
        children: children
    };
}
function $e9f91caa00559724$export$437dfbd38e9388b8(message) {
    const { analysis_text: analysis_text, symbols_code_response: symbols_code_response, type: type } = message.code_response || {};
    let component_code = symbols_code_response ? symbols_code_response.component_code : type === 'symbols_component_code' ? message.code_response.component_code : '';
    if (component_code) component_code = $e9f91caa00559724$export$bc39e7fd63e237cf(component_code);
    if (!component_code && !analysis_text) return {
        extends: 'P',
        text: 'Invalid code response format.'
    };
    return $e9f91caa00559724$export$63fe856bc11eb743(analysis_text, component_code);
}
function $e9f91caa00559724$export$8dbb8448e0047b22(part) {
    const code = part.replace(/```(js|javascript)?\n/, '').replace(/```$/, '');
    return {
        extends: 'P',
        text: code,
        background: 'rgba(0,0,0,.1)',
        padding: 'A',
        round: 'Z2',
        fontSize: 'Z',
        fontFamily: 'monospace',
        margin: 'A 0',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-all'
    };
}
function $e9f91caa00559724$export$c3442fa986207734(part) {
    return part.split(/(### .*)/g).filter((p)=>p).map((textPart)=>{
        if (textPart.startsWith('### ')) return {
            extends: 'H6',
            text: textPart.substring(4),
            margin: 'A 0 Z',
            fontWeight: 'bold'
        };
        return {
            extends: 'P',
            text: textPart,
            color: 'caption',
            fontSize: 'Z',
            lineHeight: '1.5'
        };
    });
}
function $e9f91caa00559724$export$bc39e7fd63e237cf(code) {
    return code.replace(/(}\s*)\]/g, '$1}').replace(/,\s*([}\]])/g, '$1');
}
function $e9f91caa00559724$export$63fe856bc11eb743(analysis_text, component_code) {
    try {
        return {
            flow: 'x',
            contentEditable: false,
            shape: 'bubble',
            shapeDirection: 'top right',
            round: 'C X C C',
            theme: 'dialog',
            padding: 'Y2 A',
            margin: '- -Z',
            maxWidth: '85%',
            children: [
                analysis_text && buildAnalysisSection(analysis_text),
                component_code && buildCodeSection(component_code)
            ].filter(Boolean)
        };
    } catch (e) {
        console.error('Failed to parse Symbols component:', e);
        return {
            extends: 'P',
            text: `Error rendering component: ${e.message}`
        };
    }
}
function $e9f91caa00559724$export$d017e3b65d5db5d(message) {
    return {
        extends: 'AIMessage',
        contentEditable: false,
        shape: 'bubble',
        shapeDirection: 'top right',
        round: 'C X C C',
        theme: 'dialog',
        padding: 'Y2 A',
        color: 'paragraph',
        maxWidth: 'I1',
        html: (el, s)=>typeof message === 'object' ? `<pre>${JSON.stringify(message, null, 2)}</pre>` : message
    };
}
async function $e9f91caa00559724$export$f2d682d614f105bc() {
    const el = this;
    const s = this.state;
    const value = s.keyword;
    if (!value) return;
    const images = s.images;
    s.apply((s)=>{
        s.thread.push({
            role: 'user',
            message: value,
            images: [
                ...images
            ]
        });
        s.images = [];
        s.keyword = '';
    });
    el.Flex.Span.node.innerText = '';
    // Add a temporary "thinking" message for better UX
    s.thread.push({
        role: 'agent',
        isThinking: true,
        message: '...'
    });
    s.update();
    const selectedModel = s.model || 'Starter' // Default to Free if no model selected
    ;
    const res = await el.call('giveMeAnswer', value, images, selectedModel);
    console.log('res', res);
    const parsed = await el.call('parseAIAnswer', res);
    console.log('Parsed AI Answer:', parsed);
    if (parsed.asset.type) parsed.asset.type = el.call('getPlural', parsed.asset.type);
    // Remove "thinking" message
    s.thread.pop();
    if (parsed?.asset && (parsed.asset.type === 'components' || parsed.asset.type === 'pages')) {
        console.log('Rendering asset:', parsed.asset.title);
        try {
            const asset = parsed.asset;
            const assetType = asset.type // 'components' or 'pages'
            ;
            // First, add the item to the main data store via the SDK
            const res = el.call('createItem', `${assetType}`, asset.key, asset);
            console.log(asset);
            if (res) // Add the AI response with both message and component code
            s.thread.push({
                role: 'agent',
                message: parsed.message || `I've created a ${asset.title} for you.`,
                analysis_text: asset.description,
                component_code: JSON.stringify(asset.value, null, 2),
                component: true
            });
            else // Handle cases where the SDK fails to add the item
            throw new Error(`Could not add ${assetType} '${asset.title}'`);
        } catch (e) {
            console.error('Error adding or rendering component:', e);
            s.thread.push({
                role: 'agent',
                message: `Error adding component: ${e.message}`
            });
        }
    } else if (parsed.multiple) {
        const asset = parsed.asset;
        const res = el.call('createMultipleItems', asset);
        if (res) // Add the AI response with both message and component code
        s.thread.push({
            role: 'agent',
            message: parsed.message || `I've created a ${asset.title} for you.`,
            analysis_text: asset.description,
            component_code: JSON.stringify(asset.value, null, 2),
            component: true
        });
    } else if (parsed) // For other assets or text, display the information.
    s.thread.push({
        role: 'agent',
        analysis_text: parsed.message,
        component_code: parsed.asset ? JSON.stringify(parsed.asset, null, 2) : null,
        component: !!parsed.asset // Trigger the component renderer path
    });
    else s.thread.push({
        role: 'agent',
        message: 'Sorry, I could not process that request.'
    });
    if (s.activeContent !== 'AI') s.update({
        activeContent: 'AI'
    });
} /*
<!-- page -->
{
  key: '/about',
  title: 'About us page',
  type: 'page',
  description: '...',
  value: { ... },
}

<!-- component -->
{
  key: 'Header',
  title: 'Header component',
  type: 'components',
  description: '...',
  value: { ... },
}

<!-- function -->
{
  type: 'function',
  key: 'makeFn',
  title: 'Making function',
  description: '...',
  value: () => { ... },
}

<!-- method -->
{
  type: 'method',
  key: 'makeFn',
  title: 'Making method',
  description: '...',
  value: () => { ... },
}

<!-- dependency -->
{
  type: 'dependency',
  key: 'smbls',
  version: 'latest',
}

<!-- state -->
{
  type: 'state',
  key: 'products',
  value: [{ key: 'product1', ... }, { product2 }],
}

<!-- file -->
{
  type: 'file',
  key: 'some.jpg',
  value: 'url or base64', // need to check with @Thomas-sls about blob
}

<!-- color -->
{
  type: 'color',
  key: 'blue',
  value: '#123',
}

<!-- semantic colors (dark-light) -->
{
  type: 'color',
  key: 'call-to-action',
  value: {
    '@dark': '#123',
    '@light': '#321'
  },
}

<!-- icon -->
{
  type: 'icon',
  key: 'arrowRight',
  value: '<svg>...</svg>',
}

<!-- media query -->
{
  type: 'media',
  key: '@mobileXs',
  value: '(min-width: 100px)',
}

<!-- font -->
{
  type: 'font',
  key: 'FiraGO',
  value: [{
    // regular,
    url: 'https://cdn.jsdelivr.net/fontsource/fonts/firago@latest/latin-100-normal.woff2', // or base64,
    fontWeight: '400',
    fontStyle: 'normal',
    unicodeRange: 'latin',
  }, {
    // bold,
    url: 'https://cdn.jsdelivr.net/fontsource/fonts/firago@latest/latin-200-normal.woff2', // or base64,
    fontWeight: '700',
    fontStyle: 'normal',
    unicodeRange: 'latin',
  }],
}

<!-- font-family (often coupled with font) -->
{
  type: 'font_family',
  key: 'firaGo',
  key: 'FiraGO',
  familyName: 'FiraGO',
  type: 'serif',
  value: [
    'FiraGO', // maps with font name above
    'Helvetica, Arial, sans-serif, --system-default',
  ]
}

<!-- theme -->
{
  key: 'primary',
  type: 'theme',
  value: {
    color: '...',
    background: '...',
  }
}
*/ 

});

parcelRegister("ebqFT", function(module, exports) {

$parcel$export(module.exports, "applyLoader", () => $a536c8c98860dc04$export$b809f3664143a9b9);
function $a536c8c98860dc04$export$b809f3664143a9b9(opts = {}) {
    const t = setTimeout(()=>{
        const { MainLoader: MainLoader } = this.getRoot();
        // eslint-disable-next-line no-undefined
        if (opts.value !== undefined) this.getRootState().loading = opts.value;
        const isLoading = this.getRootState('loading');
        if (opts.force) {
            if (isLoading) MainLoader.update({
                animation: 'scaleOutIn',
                animationDelay: '0'
            });
            else MainLoader.update({
                animation: 'scaleInOut',
                animationDelay: 'F'
            });
            clearTimeout(t);
            return;
        }
        if (isLoading === null || !MainLoader) {
            clearTimeout(t);
            return;
        }
        const loaderAnimation = MainLoader.animation;
        if (isLoading === true) {
            if (loaderAnimation !== 'scaleOutIn') MainLoader.update({
                animation: 'scaleOutIn',
                animationDelay: '0'
            });
        } else if (isLoading === false) {
            if (loaderAnimation !== 'scaleInOut') MainLoader.update({
                animation: 'scaleInOut',
                animationDelay: 'F'
            });
        } else if (loaderAnimation !== 'scaleInOut') MainLoader.update({
            animation: 'scaleInOut',
            animationDelay: 'F'
        });
        clearTimeout(t);
    }, opts.timeout || 150);
} // if (isLoading === true) {
 //   if (loaderAnimation !== 'scaleOutIn') {
 //     Loader.update({ animation: 'scaleOutIn', animationDelay: '0' })
 //   }
 // } else if (isLoading === false) {
 //   if (loaderAnimation !== 'scaleInOut') {
 //     Loader.update({ animation: 'scaleInOut', animationDelay: 'F' })
 //   }
 // } else if (loaderAnimation !== 'scaleInOut') {
 //   Loader.update({ animation: 'scaleInOut', animationDelay: 'F' })
 // }

});

parcelRegister("a9CTm", function(module, exports) {

$parcel$export(module.exports, "createClientContext", () => $7648e9c4bbaf771d$export$3d579206eaf0929a);
/* eslint-disable no-empty-function */ 
var $c5dHw = parcelRequire("c5dHw");
const $7648e9c4bbaf771d$export$3d579206eaf0929a = (el)=>{
    const frameDocument = el.node.contentDocument;
    if (!frameDocument) return;
    const emotion = (0, $c5dHw.createEmotion)('demo', frameDocument.head);
    const registry = (0, $c5dHw.transformDOMQLEmotion)(emotion);
    registry.emotion = emotion;
    const state = {
        ...el.getData('state')
    };
    const designSystem = {
        ...el.getData('designSystem')
    };
    const components = {
        ...el.getData('components')
    };
    const files = {
        ...el.getData('files')
    };
    const dependencies = {
        ...el.getData('dependencies')
    };
    const functions = {
        ...el.getData('functions'),
        router: ()=>{}
    };
    const snippets = {
        ...el.getData('snippets'),
        router: ()=>{}
    };
    const methods = {
        ...el.getData('methods'),
        router: ()=>{}
    };
    return {
        key: 'demo',
        parent: frameDocument,
        state: state,
        designSystem: designSystem,
        components: components,
        snippets: snippets,
        functions: functions,
        registry: registry,
        methods: methods,
        files: files,
        dependencies: dependencies,
        initOptions: {
            emotion: emotion,
            useReset: true,
            useGlobalTheme: false
        }
    };
};

});

parcelRegister("dXZDz", function(module, exports) {

$parcel$export(module.exports, "getNumberValueFromState", () => $a2b098eb3f011ad9$export$ebe1324a36f1c00e);
$parcel$export(module.exports, "getLetterValueFromState", () => $a2b098eb3f011ad9$export$262059ad41c7021f);
$parcel$export(module.exports, "updateLetterStateValue", () => $a2b098eb3f011ad9$export$49c2a86be30f57d1);
$parcel$export(module.exports, "updateNumberStateValue", () => $a2b098eb3f011ad9$export$1b035b6b2bd9ae28);
$parcel$export(module.exports, "handleAtKey", () => $a2b098eb3f011ad9$export$2823390434059fbe);
$parcel$export(module.exports, "createSpacing", () => $a2b098eb3f011ad9$export$31a62238a3f24621);
// Helper functions
function $a2b098eb3f011ad9$var$getPropertyValues(state, property = null) {
    if (!property) return [];
    return state?.[property]?.split(' ') || [];
}
function $a2b098eb3f011ad9$var$updateProperty(state, propertyValues, property = null) {
    if (!property || !state || !Array.isArray(propertyValues)) return false;
    state.update({
        [property]: propertyValues.join(' ')
    });
    return true;
}
function $a2b098eb3f011ad9$var$getSpacingValues(context) {
    return context?.designSystem?.spacing?.sequence || {};
}
function $a2b098eb3f011ad9$var$validateIndex(index, array) {
    return index >= 0 && index < array.length;
}
function $a2b098eb3f011ad9$var$updatePropertyValuesAtIndex(state, property, index, value, syncFn) {
    const propertyValues = $a2b098eb3f011ad9$var$getPropertyValues(state, property);
    while(propertyValues.length <= index)propertyValues.push('-');
    propertyValues[index] = value;
    if ($a2b098eb3f011ad9$var$updateProperty(state, propertyValues, property)) syncFn();
}
// Value conversion helpers
function $a2b098eb3f011ad9$var$findClosestSpacingKey(value, spacingValues, property = null) {
    if (typeof value !== 'number') return null;
    // Handle negative values for margin
    const isNegative = value < 0;
    const absValue = Math.abs(value);
    let closestKey = null;
    let closestDiff = Infinity;
    Object.entries(spacingValues).forEach(([key, val])=>{
        const diff = Math.abs(absValue - val.val);
        if (diff < closestDiff) {
            closestDiff = diff;
            closestKey = key;
        }
    });
    return property === 'margin' && isNegative ? `-${closestKey}` : closestKey;
}
function $a2b098eb3f011ad9$export$ebe1324a36f1c00e(index, property = null) {
    if (property === 'lineHeight') return Math.abs(this.state?.[property]);
    const propertyValues = $a2b098eb3f011ad9$var$getPropertyValues(this.state, property);
    if (!$a2b098eb3f011ad9$var$validateIndex(index, propertyValues)) return 0;
    const value = propertyValues[index];
    const spacingValues = $a2b098eb3f011ad9$var$getSpacingValues(this.context);
    return spacingValues[value]?.val || 'none';
}
function $a2b098eb3f011ad9$export$262059ad41c7021f(index, property = null) {
    const propertyValues = $a2b098eb3f011ad9$var$getPropertyValues(this.state, property);
    if (!$a2b098eb3f011ad9$var$validateIndex(index, propertyValues)) return 0;
    return propertyValues[index];
}
// UI sync helpers
function $a2b098eb3f011ad9$var$syncNumberInput(element, value) {
    const numberInput = element?.parent?.NumberValue?.node;
    if (numberInput) numberInput.value = value;
}
function $a2b098eb3f011ad9$var$syncLetterInput(element, value) {
    const letterInput = element?.parent?.LetterValue?.node;
    if (letterInput) letterInput.value = value;
}
function $a2b098eb3f011ad9$export$49c2a86be30f57d1(index, property = null) {
    const value = this.node?.value?.trim()?.toUpperCase();
    const spacingValues = $a2b098eb3f011ad9$var$getSpacingValues(this.context);
    // Handle negative values
    const isNegative = property === 'margin' && value?.startsWith('-');
    const letterValue = isNegative ? value.substring(1) : value;
    // Validation
    if (!letterValue || !spacingValues[letterValue]) return null;
    // Get numeric value
    const numericValue = spacingValues[letterValue].val;
    const finalNumericValue = isNegative ? -numericValue : numericValue;
    // Update state
    const propertyValues = $a2b098eb3f011ad9$var$getPropertyValues(this.state, property);
    while(propertyValues.length <= index)propertyValues.push('-');
    propertyValues[index] = value;
    // Update UI if state update successful
    if ($a2b098eb3f011ad9$var$updateProperty(this.state, propertyValues, property)) $a2b098eb3f011ad9$var$syncNumberInput(this, finalNumericValue);
}
function $a2b098eb3f011ad9$export$1b035b6b2bd9ae28(index, property = null) {
    const value = this.node?.value?.trim();
    if (property === 'lineHeight') {
        this.state.update({
            lineHeight: Math.abs(parseFloat(value)) || 100
        });
        return;
    }
    if ([
        'minWidth',
        'minHeight',
        'maxWidth',
        'maxHeight'
    ].includes(property) && value === 'none') {
        $a2b098eb3f011ad9$var$updatePropertyValuesAtIndex(this.state, property, index, 'none', ()=>$a2b098eb3f011ad9$var$syncLetterInput(this, ''));
        return;
    }
    if ((property === 'width' || property === 'height') && value === 'auto') {
        $a2b098eb3f011ad9$var$updatePropertyValuesAtIndex(this.state, property, index, 'auto', ()=>$a2b098eb3f011ad9$var$syncLetterInput(this, ''));
        return;
    }
    // Handle special cases for 0 or '-'
    if (value === '0' || value === '-') {
        $a2b098eb3f011ad9$var$updatePropertyValuesAtIndex(this.state, property, index, '-', ()=>$a2b098eb3f011ad9$var$syncLetterInput(this, '-'));
        return;
    }
    const numValue = parseFloat(value);
    if (isNaN(numValue)) return null;
    const spacingValues = $a2b098eb3f011ad9$var$getSpacingValues(this.context);
    const closestKey = $a2b098eb3f011ad9$var$findClosestSpacingKey(numValue, spacingValues, property);
    if (!closestKey) return null;
    $a2b098eb3f011ad9$var$updatePropertyValuesAtIndex(this.state, property, index, closestKey, ()=>$a2b098eb3f011ad9$var$syncLetterInput(this, closestKey));
}
function $a2b098eb3f011ad9$export$2823390434059fbe(key) {
    if (!this.call('isString', key)) return '';
    return key.startsWith('@') ? key : `@${key}`;
}
async function $a2b098eb3f011ad9$export$31a62238a3f24621() {
    if (!this.node.elements) {
        console.warn('createSpacing must be used inside a Form');
        return;
    }
    const cleanedKey = this.call('handleAtKey', this.node.elements.item('sidebar-new-item').value);
    await this.updateDesignSystem(`spacing.${cleanedKey}`, {
        ratio: 1.618
    });
}

});

parcelRegister("kqhVa", function(module, exports) {

$parcel$export(module.exports, "setFloatingPanel", () => $ede42314e0da37a9$export$fb73d91ab647a6c3);
$parcel$export(module.exports, "handlePanelDelete", () => $ede42314e0da37a9$export$5e0808702caa1996);
const $ede42314e0da37a9$var$maxHeightMarginNum = 50;
const $ede42314e0da37a9$var$maxHeightMargin = `${$ede42314e0da37a9$var$maxHeightMarginNum / 2}px`;
const $ede42314e0da37a9$var$floatingPanelMaxHeight = `calc(100vh - ${$ede42314e0da37a9$var$maxHeightMargin})`;
let $ede42314e0da37a9$var$visibilityObserver = null;
let $ede42314e0da37a9$var$floatingPanelElement = null;
let $ede42314e0da37a9$var$clickAwayListenerEvent = null;
let $ede42314e0da37a9$var$cachedOverflow = null;
let $ede42314e0da37a9$var$resizeObserver = null;
function $ede42314e0da37a9$var$getOverflowElementExists(context) {
    if (!$ede42314e0da37a9$var$cachedOverflow) $ede42314e0da37a9$var$cachedOverflow = Boolean(context.getFilesSidebar()?.Overflow?.node);
    return $ede42314e0da37a9$var$cachedOverflow;
}
function $ede42314e0da37a9$var$cleanup() {
    $ede42314e0da37a9$var$visibilityObserver?.disconnect?.();
    $ede42314e0da37a9$var$resizeObserver?.disconnect?.();
    if ($ede42314e0da37a9$var$clickAwayListenerEvent) window.document.removeEventListener('click', $ede42314e0da37a9$var$clickAwayListenerEvent, {
        capture: true
    });
    $ede42314e0da37a9$var$floatingPanelElement = null;
    $ede42314e0da37a9$var$clickAwayListenerEvent = null;
    $ede42314e0da37a9$var$visibilityObserver = null;
    $ede42314e0da37a9$var$resizeObserver = null;
}
async function $ede42314e0da37a9$export$fb73d91ab647a6c3(data, opts = {}) {
    if (!data || this.call('isEmptyObject', data)) {
        if ($ede42314e0da37a9$var$floatingPanelElement) $ede42314e0da37a9$var$floatingPanelElement?.setNodeStyles?.({
            visibility: 'hidden',
            opacity: '0'
        });
        return;
    }
    $ede42314e0da37a9$var$cleanup();
    $ede42314e0da37a9$var$floatingPanelElement = this.getFloatingPanelElement();
    const calleeElement = opts.callee || data?.element || this;
    const calleeRect = calleeElement.node?.getBoundingClientRect?.() || {};
    $ede42314e0da37a9$var$clickAwayListenerEvent = (ev)=>this.handleClickAway(ev);
    // this is needed to react to external visibility changes of floating panel eg.: handleClickAway placed at Canvas comp.
    $ede42314e0da37a9$var$visibilityObserver = new MutationObserver((mutations)=>{
        for (const mutation of mutations)if (mutation.target.style?.visibility === 'hidden') $ede42314e0da37a9$var$cleanup();
    });
    $ede42314e0da37a9$var$resizeObserver = new ResizeObserver((entries)=>{
        const [floatingPanelEntry] = entries;
        if (calleeRect.top < floatingPanelEntry.contentRect.height / 2) $ede42314e0da37a9$var$floatingPanelElement.node.style.transform = `translateY(-${floatingPanelEntry.target.offsetTop - $ede42314e0da37a9$var$maxHeightMarginNum / 2}px)`;
    });
    $ede42314e0da37a9$var$visibilityObserver.observe($ede42314e0da37a9$var$floatingPanelElement.node, {
        attributes: true,
        attributeFilter: [
            'style'
        ]
    });
    $ede42314e0da37a9$var$resizeObserver.observe($ede42314e0da37a9$var$floatingPanelElement.node);
    const calleeLeftPos = calleeRect.left || 0;
    const calleeWidth = calleeRect.width || 0;
    const floatingPanelLeftPos = calleeLeftPos + calleeWidth;
    const updateStyles = (styles)=>{
        $ede42314e0da37a9$var$floatingPanelElement?.setNodeStyles?.({
            ...styles
        });
        if (opts.customProps) $ede42314e0da37a9$var$floatingPanelElement.update(opts.customProps);
    };
    const updateSidebarItem = async (calleeItem, isArtboard)=>{
        if (isArtboard) await this.call('updateItemInSidebar', calleeItem.type, calleeItem.key, opts);
        else {
            const type = calleeItem?.type || $ede42314e0da37a9$var$floatingPanelElement.state.type;
            await this.call('rerenderFileSidebarByType', type);
        }
    };
    // State management
    const updateSceneState = async (newData, calleeItemState, isArtboard, options = {})=>{
        if ($ede42314e0da37a9$var$floatingPanelElement?.state?.type !== newData?.type) options.preventUpdateAfterCount = 1;
        $ede42314e0da37a9$var$floatingPanelElement.state.set(newData, options);
        if (calleeItemState) await updateSidebarItem(calleeItemState, isArtboard);
    };
    const showPanel = ()=>{
        window.document.addEventListener('click', $ede42314e0da37a9$var$clickAwayListenerEvent, {
            capture: true
        });
        if (!$ede42314e0da37a9$var$floatingPanelElement) return;
        $ede42314e0da37a9$var$floatingPanelElement.data.isActive = true;
        const allowDropdownOverflow = $ede42314e0da37a9$var$floatingPanelElement.state?.type === 'semantic_color';
        const top = `${calleeRect.top + calleeRect.height}px`;
        updateStyles({
            opacity: '1',
            visibility: 'visible',
            position: 'absolute',
            transform: 'translateY(-50%)',
            top: top,
            overflow: allowDropdownOverflow ? 'visible' : 'auto',
            maxHeight: $ede42314e0da37a9$var$floatingPanelMaxHeight,
            left: `${floatingPanelLeftPos}px`
        }, opts);
    };
    const overflowExists = $ede42314e0da37a9$var$getOverflowElementExists(this);
    if (!overflowExists || !$ede42314e0da37a9$var$floatingPanelElement) {
        console.warn('Required components not found for FloatingPanel');
        return;
    }
    try {
        if (this.node) {
            const calleeItemState = calleeElement.lookup((el, s)=>el.Rename && el.ContextMenu && s.key)?.state || null;
            const isArtboard = calleeItemState && this.call('hasArtboard', calleeItemState?.type);
            await updateSceneState(data, calleeItemState, isArtboard);
        }
        showPanel(this);
    } catch (error) {
        console.error('Error setting up floating panel:', error);
    }
}
async function $ede42314e0da37a9$var$handlePanelKeyUp(event) {
    if (event.keyCode !== 46 || !this.state.type || this.state.type === 'global_theme' && (this.state.key === '@light' || this.state.key === '@dark') || this.state.type === 'theme' && this.state.key === 'document') return;
    await this.updateDesignSystem(`${(this.state.dsType || this.state.type).toUpperCase()}.${this.state.key}`, null);
    await this.call('setFloatingPanel');
}
let $ede42314e0da37a9$var$panelAuxFn = ()=>null;
function $ede42314e0da37a9$export$5e0808702caa1996() {
    document.body.removeEventListener('keyup', $ede42314e0da37a9$var$panelAuxFn);
    $ede42314e0da37a9$var$panelAuxFn = ()=>null;
    if (!this.call('isEmptyObject', this.state)) {
        $ede42314e0da37a9$var$panelAuxFn = $ede42314e0da37a9$var$handlePanelKeyUp.bind(this);
        document.body.addEventListener('keyup', $ede42314e0da37a9$var$panelAuxFn);
    }
}

});

parcelRegister("ja6ZV", function(module, exports) {

$parcel$export(module.exports, "handleDSKeyChange", () => $df34612114ff7256$export$76e8813304809075);
$parcel$export(module.exports, "handleGlobalThemeKeyChange", () => $df34612114ff7256$export$f74a1eed0eafdafe);
$parcel$export(module.exports, "handleMediaIcon", () => $df34612114ff7256$export$d1945d1f75ba8401);
$parcel$export(module.exports, "handleDsNavbarClick", () => $df34612114ff7256$export$15efa247ab28fca1);
async function $df34612114ff7256$export$76e8813304809075(t, inputName = 'key') {
    if (!this.node.elements) {
        console.warn('handleDSKeyChange must be used inside a Form');
        return;
    }
    const { state: s } = this;
    const type = t.toUpperCase();
    const text = this.node.elements.item(inputName).value;
    if (!text) return;
    const previousKey = s.key;
    const newKey = type === 'SPACING' || type === 'TYPOGRAPHY' ? this.call('handleAtKey', text) : text;
    if (!s.value || !previousKey) return s.update({
        key: newKey
    });
    const path = (k)=>[
            'designSystem',
            type,
            k
        ];
    this.sdk.updateData([
        [
            'update',
            path(newKey),
            s.value
        ],
        [
            'delete',
            path(previousKey)
        ]
    ], {
        message: `Renamed ${previousKey} to ${newKey}`
    });
    // this.lookup('DynamicIsland').update()
    this.updateDesignSystemOnCanvas(this.getDesignSystem());
    s.update({
        key: newKey
    });
    await this.call('rerenderFileSidebarByType', type.toLowerCase());
}
async function $df34612114ff7256$export$f74a1eed0eafdafe() {
    if (!this.node.elements) {
        console.warn('handleDSKeyChange must be used inside a Form');
        return;
    }
    const { state: s } = this;
    const type = 'THEME';
    const text = this.node.elements.item('global-theme-key').value;
    if (!text) return;
    const previousKey = s.key;
    const newKey = this.call('handleAtKey', text);
    if (!s.value || !previousKey) return s.update({
        key: newKey
    });
    const path = (k)=>[
            'designSystem',
            type,
            'document',
            k
        ];
    this.sdk.updateData([
        [
            'update',
            path(newKey),
            s.value
        ],
        [
            'delete',
            path(previousKey)
        ]
    ], {
        message: `Renamed Global Theme ${previousKey} to ${newKey}`
    });
    this.lookup('DynamicIsland').update();
    // TODO: Check if this is needed
    this.updateDesignSystemOnCanvas(this.getDesignSystem());
    s.update({
        key: newKey
    });
}
function $df34612114ff7256$export$d1945d1f75ba8401(media) {
    const { value: mediaQuery = media } = this.state;
    if (!mediaQuery) return '';
    if (mediaQuery === 'print') return 'print outline';
    if (mediaQuery.includes('prefers-color-scheme: light')) return 'sun outline';
    if (mediaQuery.includes('prefers-color-scheme: dark')) return 'moon outline';
    const widthMatch = mediaQuery.match(/(?:min|max)-width:\s*(?<width>\d+)/u);
    if (!widthMatch) return 'displayPreferencesFill';
    const width = parseInt(widthMatch.groups.width, 10);
    const isMin = mediaQuery.includes('min-width');
    if (width >= 1920) return isMin ? 'device big screen half fill' : 'device big screen outline';
    if (width >= 1366) return isMin ? 'device big screen outline' : 'device small screen outline';
    if (width >= 1024) return isMin ? 'device small screen outline' : 'device tablet landscape outline';
    if (width >= 540) return isMin ? 'device tablet landscape outline' : 'device tablet portrait outline';
    return isMin ? 'device tablet portrait outline' : 'device mobile outline';
}
function $df34612114ff7256$export$15efa247ab28fca1() {
    const { key: key } = this.props;
    const val = this.getWindow('explorer') === key ? false : key;
    this.setWindow('explorer', val);
}

});

parcelRegister("jgbKP", function(module, exports) {

$parcel$export(module.exports, "setScenePosition", () => $e058a11668f451a4$export$a55086c2c7f0cfe6);
function $e058a11668f451a4$export$a55086c2c7f0cfe6(passedKey, options = {}) {
    const Scene = this.lookup('ComponentFrameCanvasTooltip');
    const key = passedKey || this.state?.value || this.text;
    if (!options.visible || !key) return Scene.setNodeStyles({
        opacity: '0',
        visibility: 'hidden'
    });
    const type = this.call('getType', key);
    const value = this.getData(type)[key];
    const schema = this.getSchema(type)[key];
    if (!value || !schema || Scene.data.key === schema.key && Scene.visibility === 'visible') return Scene.setNodeStyles({
        opacity: '0',
        visibility: 'hidden'
    });
    Scene.data.key = schema.key;
    // eslint-disable-next-line init-declarations
    let transform;
    if (options.position === 'bottom') {
        const position = `${this.node.getBoundingClientRect().left}px`;
        const translate = `calc(${position} - 50%)`;
        transform = `translate3d(${translate}, 0, 0)`;
    } else if (options.position === 'mouse' && options.mouseEvent) {
        // Position relative to mouse cursor
        const x = options.mouseEvent.clientX //- 250
        ;
        const y = options.mouseEvent.clientY - 35;
        transform = `translate3d(${x}px, ${y}px, 0)`;
    } else {
        const rect = this.node.getBoundingClientRect();
        const tooltipNode = Scene.node;
        const tooltipWidth = tooltipNode.offsetWidth;
        const tooltipHeight = tooltipNode.offsetHeight;
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;
        let top = rect.top - 15;
        let left = rect.left + rect.width / 2 - 50;
        // Clamp left and top to keep tooltip within viewport
        left = Math.max(0, Math.min(left, viewportWidth - tooltipWidth - 35));
        top = Math.max(0, Math.min(top, viewportHeight - tooltipHeight - 35));
        const topPosition = `${top}px`;
        const leftPosition = `${left}px`;
        transform = `translate3d(${leftPosition}, ${topPosition}, 0px)`;
    }
    Scene.setNodeStyles({
        opacity: '1',
        visibility: 'visible',
        transform: transform
    });
    window.requestAnimationFrame(()=>{
        const componentState = this.call('deepClone', {
            value: value,
            ...schema
        });
        Scene.state.set(componentState);
    });
}

});

parcelRegister("ao3Fg", function(module, exports) {

$parcel$export(module.exports, "generatePreviewUrl", () => $78fefcfc642ea8dc$export$4a1e2a1448915d1e);
$parcel$export(module.exports, "generateUrl", () => $78fefcfc642ea8dc$export$bfd283b1e58f27c1);
$parcel$export(module.exports, "openInNewTab", () => $78fefcfc642ea8dc$export$9e52b10d57ddf9e3);

var $3WCJD = parcelRequire("3WCJD");
function $78fefcfc642ea8dc$export$4a1e2a1448915d1e() {
    const isCavnas = this.call('isCanvas');
    const selected = isCavnas && this.getSelected();
    const key = isCavnas && this.getSelectedKey();
    const appKey = this.getAppKey();
    let url = appKey;
    const isPage = key?.startsWith('/');
    if (key) url += isPage ? key : `/component?key=${key}`;
    if (selected?.state?.content?.src) return selected.state.content.src.replace('https://', '');
    const version = this.getActiveVersion();
    const latestVersion = this.getLatestVersion();
    const isOld = version && version !== latestVersion;
    if (isOld) url += `${url.includes('?') ? '&' : '?'}version=${version}`;
    if (this.call('isProduction')) return `https://${url}`;
    // Render via the per-channel API. channelApiUrl() reads the active
    // channel from NODE_ENV, so the local dev shell hits next.api.symbols.app
    // (or whatever channel is active) without hardcoding URLs.
    const env = this.getRootState('ENV');
    return `${(0, $3WCJD.apiUrl)(env)}/?renderUrl=${url}`;
}
function $78fefcfc642ea8dc$export$bfd283b1e58f27c1() {
    const selected = this.getSelected();
    const appKey = this.getAppKey();
    if (!selected) return `${appKey.split('.')[0]}`;
    const key = this.getSelectedKey();
    const isPage = key.startsWith('/');
    const path = isPage ? key : `/${key}`;
    return `symbo.ls/${appKey.split('.')[0]}${path || ''}`;
}
function $78fefcfc642ea8dc$export$9e52b10d57ddf9e3() {
    const openUrl = this.call('generatePreviewUrl');
    const url = window.open(openUrl, 'Symbols preview');
    // Setup interval to check when the window is closed
    this.syncCanvas({
        openUrl: openUrl
    });
    const checkInterval = setInterval(()=>{
        if (url && url.closed) {
            this.syncCanvas({
                openUrl: null
            });
            clearInterval(checkInterval);
        }
    }, 1500);
}

});

parcelRegister("kBoxR", function(module, exports) {

$parcel$export(module.exports, "capitalize", () => $effa4d7c9be099d1$export$9a00dee1beb8f576);
function $effa4d7c9be099d1$export$9a00dee1beb8f576(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});

parcelRegister("bHCw7", function(module, exports) {

$parcel$export(module.exports, "renameLegacy", () => $88519689271d0fd2$export$360f7993ab8d5ea7);
$parcel$export(module.exports, "renameComponents", () => $88519689271d0fd2$export$8f1c3a6251be3aaa);
$parcel$export(module.exports, "renamePages", () => $88519689271d0fd2$export$5971448592bfb734);
$parcel$export(module.exports, "renameFunctions", () => $88519689271d0fd2$export$4f535a74fe81b72e);
$parcel$export(module.exports, "renameFiles", () => $88519689271d0fd2$export$97753adb9ac72312);
// Base configuration for different types of items
const $88519689271d0fd2$var$itemTypes = {
    components: {
        getItems () {
            return this.getComponents();
        },
        updatePath: [
            'components'
        ],
        validateKey: ()=>true,
        getItemTypeName: ()=>'components'
    },
    pages: {
        getItems () {
            return this.getData('pages');
        },
        updatePath: [
            'pages'
        ],
        validateKey: (key)=>key.startsWith('/'),
        getItemTypeName: ()=>'pages',
        validationError: "Page's key must start with /"
    },
    functions: {
        getItems () {
            return this.getFunctions();
        },
        updatePath () {
            return [
                this.call('getType')
            ];
        },
        validateKey: ()=>true,
        getItemTypeName () {
            return this.call('getType');
        }
    },
    files: {
        getItems () {
            return this.getFiles();
        },
        updatePath: [
            'files'
        ],
        validateKey: (key, originalFormat)=>{
            const [, newFormat] = key.split('.');
            return !newFormat || newFormat === originalFormat;
        },
        validationError: 'This format is different from the original. Please maintain the same format or omit it to reuse.',
        formatKey: (key, originalFormat)=>{
            const [, newFormat] = key.split('.');
            return newFormat ? key : `${key}.${originalFormat}`;
        },
        getItemTypeName () {
            return 'files';
        }
    }
};
function $88519689271d0fd2$var$showError(errorEl, text) {
    errorEl.update({
        display: 'block!important',
        text: text
    });
    setTimeout(()=>{
        errorEl.update({
            display: '',
            text: ''
        });
    }, 2500);
}
async function $88519689271d0fd2$export$360f7993ab8d5ea7(type, inputName = 'new-key', callback = ()=>null) {
    const typeConfig = $88519689271d0fd2$var$itemTypes[type];
    if (!this.node.elements) {
        console.warn(`rename${type.charAt(0).toUpperCase() + type.slice(1)} must be used on submit of a Form`);
        return;
    }
    const { state: s } = this;
    let newKey = this.node.elements.item(inputName).value;
    const items = typeConfig.getItems.call(this);
    const errorEl = this.lookup('Label').Err;
    const handleError = (text)=>{
        $88519689271d0fd2$var$showError(errorEl, text);
        this.node.reset();
    };
    if (items[newKey]) {
        handleError(`${typeConfig.getItemTypeName.call(this)} with such key exists. Please enter a new key`);
        return;
    }
    if (typeConfig.validateKey && !typeConfig.validateKey(newKey, s.value.format)) {
        handleError(typeConfig.validationError);
        return;
    }
    if (typeConfig.formatKey) newKey = typeConfig.formatKey(newKey, s.value.format);
    this.call('rename', s.type, s.key, newKey);
    // const updatePath = this.call('isFunction', typeConfig.updatePath)
    //   ? typeConfig.updatePath.call(this)
    //   : typeConfig.updatePath
    // const factoryType = updatePath[0]
    // const schema = this.getSchema(factoryType)
    // const hasSchema = schema && schema[s.key]
    // if (hasSchema && hasSchema.key) {
    //   hasSchema.key = newKey
    // }
    // this.sdk.updateData(
    //   [
    //     ['delete', [...updatePath, s.key]],
    //     ['update', [...updatePath, newKey], s.value],
    //     hasSchema && ['delete', ['schema', ...updatePath, s.key]],
    //     hasSchema && ['update', ['schema', ...updatePath, newKey], hasSchema]
    //   ].filter((v) => v),
    //   {
    //     message: `Rename ${typeConfig.getItemTypeName.call(this)} from ${
    //       s.key
    //     } to ${newKey}`
    //   }
    // )
    window.requestAnimationFrame(()=>callback(newKey));
}
async function $88519689271d0fd2$export$8f1c3a6251be3aaa(inputName = 'NewKey', callback = ()=>null) {
    return await this.call('renameLegacy', 'components', inputName, callback);
}
async function $88519689271d0fd2$export$5971448592bfb734(inputName = '/new-key', callback = ()=>null) {
    return await this.call('renameLegacy', 'pages', inputName, callback);
}
async function $88519689271d0fd2$export$4f535a74fe81b72e(inputName = 'newKey', callback = ()=>null) {
    return await this.call('renameLegacy', 'functions', inputName, callback);
}
async function $88519689271d0fd2$export$97753adb9ac72312(inputName = 'new-key', callback = ()=>null) {
    return await this.call('renameLegacy', 'files', inputName, callback);
}

});

parcelRegister("fvXa3", function(module, exports) {

$parcel$export(module.exports, "openDependency", () => $b4b7a46dbe57f3f2$export$332885ef1f1a4198);
$parcel$export(module.exports, "upgradeDependency", () => $b4b7a46dbe57f3f2$export$c90a9c98976a46c0);
$parcel$export(module.exports, "fetchLatestDependency", () => $b4b7a46dbe57f3f2$export$4a04674e43e0aa90);
$parcel$export(module.exports, "rebuildDependency", () => $b4b7a46dbe57f3f2$export$ff8177f875ebea7f);
$parcel$export(module.exports, "deleteDependency", () => $b4b7a46dbe57f3f2$export$d68ff131ad0917e4);
function $b4b7a46dbe57f3f2$export$332885ef1f1a4198() {
    window.open(`https://www.npmjs.com/package/${this.state.key}`, '_blank').focus();
}
function $b4b7a46dbe57f3f2$export$c90a9c98976a46c0() {
    const { key: key, version: targetVersion, type: type } = this.state;
    window.fetch(`https://registry.npmjs.com/${key}`).then(async (res)=>{
        const { versions: v } = await res.json();
        const versions = Object.keys(v);
        const [targetMajor, targetMinor] = targetVersion.split('.').map(Number);
        const matchingPatches = versions.filter((version)=>{
            if (version.includes('-') || version.includes('+')) return false;
            const [major, minor] = version.split('.').map(Number);
            return major === targetMajor && minor === targetMinor;
        });
        const latest = matchingPatches.reduce((initial, current)=>{
            const [, , currentPatch] = current.split('.').map(Number);
            const [, , latestPatch] = initial.split('.').map(Number);
            return currentPatch > latestPatch ? current : latest;
        }, '');
        // TO DO: Adding message toasts to warn the status of the upgrade
        this.sdk.updateItem('dependencies', {
            key: key,
            value: latest || targetVersion,
            type: type,
            version: latest || targetVersion
        }, {
            message: 'Upgraded dependency'
        });
    });
}
function $b4b7a46dbe57f3f2$export$4a04674e43e0aa90() {
    this.sdk.updateItem('dependencies', {
        key: this.state.key,
        value: 'latest',
        type: this.state.type,
        version: 'latest'
    }, {
        message: 'Fetched latest dependency'
    });
}
function $b4b7a46dbe57f3f2$export$ff8177f875ebea7f() {
// TO DO: Waiting for a SDK function or something to rebuild some dependency if necessary
// https://symbo-ls.slack.com/archives/C084QG0K7A7/p1739831059737529
}
async function $b4b7a46dbe57f3f2$export$d68ff131ad0917e4() {
    return this.call('removeItem', 'dependency', this.state.key);
}

});

parcelRegister("iMsdo", function(module, exports) {

$parcel$export(module.exports, "shouldTypographyTagRender", () => $dac2989907b3c1ea$export$8eadd5c2b7105c6c);
$parcel$export(module.exports, "createTypography", () => $dac2989907b3c1ea$export$c3353a8513e5d9b);
function $dac2989907b3c1ea$export$8eadd5c2b7105c6c() {
    const { value: value, type: type, isDefault: isDefault } = this.state;
    if (!value || !type || type !== 'ratio' && type !== 'range' && type !== 'base') return false;
    if (isDefault) return Boolean(value);
    const typography = this.getDesignSystem('typography');
    if (!Number.isNaN(Number(value))) return value !== typography[type];
    if (value.includes('px') && type === 'base') return Number(value.replace('px', '')) !== typography[type];
    if (value.includes(',') && type === 'range') return value !== typography[type]?.join(', ');
    return false;
}
async function $dac2989907b3c1ea$export$c3353a8513e5d9b() {
    if (!this.node.elements) {
        console.warn('createTypography must be used inside a Form');
        return;
    }
    const cleanedKey = this.call('handleAtKey', this.node.elements.item('sidebar-new-item').value);
    const defaultValue = this.getDesignSystem('typography');
    await this.updateDesignSystem(`typography.${cleanedKey}`, {
        base: defaultValue.base ?? 16,
        ratio: defaultValue.ratio ?? 1.25,
        range: defaultValue.range ?? [
            -5,
            12
        ],
        subSequence: defaultValue.subSequence ?? true
    });
}

});

parcelRegister("28V5M", function(module, exports) {

$parcel$export(module.exports, "handleShadowScrolling", () => $18f89d744edff4b1$export$3b77c7fc7b55539f);
function $18f89d744edff4b1$export$3b77c7fc7b55539f() {
    const { scrollLeft: scrollLeft, offsetWidth: offsetWidth, scrollWidth: scrollWidth } = this.node;
    const Parent = this.lookup('ScrollShadows');
    if (!Parent) {
        console.warn('ScrollShadowsChild must need a ScrollShadows as a parent');
        return;
    }
    if (scrollLeft === 0 && offsetWidth === scrollWidth) return Parent.update({
        ':after': {
            opacity: '0%'
        },
        ':before': {
            opacity: '0%'
        }
    });
    if (scrollLeft + offsetWidth === scrollWidth) return Parent.update({
        ':after': {
            opacity: '0%'
        }
    });
    Parent.update({
        ':after': {
            opacity: '100%'
        }
    });
    if (scrollLeft === 0) return Parent.update({
        ':before': {
            opacity: '0%'
        }
    });
    Parent.update({
        ':before': {
            opacity: '100%'
        }
    });
}

});

parcelRegister("lCIpp", function(module, exports) {

$parcel$export(module.exports, "updateStateFromState", () => $fbdf983ee6aff3c0$export$a6f102d11977d01f);
$parcel$export(module.exports, "updateState", () => $fbdf983ee6aff3c0$export$4971331372cec95a);
$parcel$export(module.exports, "updateStateOnCanvas", () => $fbdf983ee6aff3c0$export$10b5712bd38aa51a);
$parcel$export(module.exports, "removeState", () => $fbdf983ee6aff3c0$export$50bca722ca75f12);
function $fbdf983ee6aff3c0$export$a6f102d11977d01f() {
    const { key: key, value: value, code: code } = this.state;
    try {
        const res = this.call('updateState');
        this.test('Updating State in data', ()=>{
            return this.testCase('Value equals root state', 'isEqualObject', this.getState(key), value);
        });
        if (res?.success) {
            this.call('updateStateOnCanvas', value);
            this.test('Updating State on Canvas', ()=>{
                return this.testCase('Value equals root state', 'isEqualObject', this.getState(key), value) && this.testCase('Value equals Collection state', 'isEqualObject', this.getCanvasCollection().state[key], value) && this.testCase('Value equals Collection context', 'isEqualObject', this.getCanvasContext().state[key], value);
            });
        }
    } catch (e) {
        console.error(e);
    }
}
function $fbdf983ee6aff3c0$export$4971331372cec95a() {
    const { key: key } = this.state;
    try {
        return this.sdk.updateItem('state', {
            ...this.state,
            key: key
        }, {
            message: `Updating state ${key}`
        });
    } catch (err) {
        this.state.update({
            err: err
        });
    }
}
function $fbdf983ee6aff3c0$export$10b5712bd38aa51a(obj, type = 'state') {
    // window.requestAnimationFrame(() => {
    const Collection = this.getCanvasCollection();
    const { key: key } = this.state;
    if (Collection) {
        const ctx = Collection.context;
        ctx[type][key] = obj;
        Collection.state.replace({
            [key]: obj
        });
    } else this.error('Canvas Collection was not found');
    const { chosen: chosen } = this.getCanvasScope();
    chosen;
}
async function $fbdf983ee6aff3c0$export$50bca722ca75f12() {
    return this.call('removeItem', 'state', this.state.key);
}

});

parcelRegister("jRYrT", function(module, exports) {

$parcel$export(module.exports, "shouldDisableRatioButton", () => $e771db75132e9266$export$d7734c76c04edfe);
$parcel$export(module.exports, "handleRatioButtons", () => $e771db75132e9266$export$c7a214c433bb65ed);
$parcel$export(module.exports, "handleBaseSizeButtons", () => $e771db75132e9266$export$84a2031c3dffe169);
$parcel$export(module.exports, "getBaseSizeOptions", () => $e771db75132e9266$export$c0cff8cdabf1d53);
$parcel$export(module.exports, "getRatioOptions", () => $e771db75132e9266$export$34b5688f80f8025b);
$parcel$export(module.exports, "renderRangeDropdownValue", () => $e771db75132e9266$export$37aa944133e84c53);
$parcel$export(module.exports, "generateRangeOptions", () => $e771db75132e9266$export$431ed294bd30b5b0);
function $e771db75132e9266$export$d7734c76c04edfe(mode = 1) {
    const sequenceEntries = this.call('getRatioOptions', true);
    const entryIndex = sequenceEntries.findIndex(([, value])=>value === this.state.value);
    return mode === -1 && entryIndex === 0 || mode === 1 && entryIndex === sequenceEntries.length - 1;
}
function $e771db75132e9266$export$c7a214c433bb65ed(mode = 1) {
    const sequenceEntries = this.call('getRatioOptions', true);
    const entryIndex = sequenceEntries.findIndex(([, value])=>value === this.state.value);
    if (mode === -1 && entryIndex === 0 || mode === 1 && entryIndex === sequenceEntries.length - 1) return;
    const [key, value] = sequenceEntries[entryIndex + 1 * Number(mode)];
    this.state.update({
        key: key,
        value: value
    });
}
function $e771db75132e9266$export$84a2031c3dffe169(mode = 1) {
    const options = this.call('getBaseSizeOptions');
    const entryIndex = options.findIndex(({ value: value })=>value === this.state.value);
    if (mode === -1 && entryIndex === 0 || mode === 1 && entryIndex === options.length - 1) return;
    const { key: key, value: value } = options[entryIndex + 1 * Number(mode)];
    this.state.update({
        key: key,
        value: value
    });
}
function $e771db75132e9266$export$c0cff8cdabf1d53() {
    return new Array(14).fill().map((c, index)=>{
        const value = index + 11;
        return {
            key: `1em ~ ${value}px`,
            value: value
        };
    });
}
function $e771db75132e9266$export$34b5688f80f8025b(entries = false) {
    const sequence = {
        'minor-second': 1.067,
        'major-second': 1.125,
        'minor-third': 1.2,
        'major-third': 1.25,
        'perfect-fourth': 1.333,
        'augmented-fourth': 1.414,
        'perfect-fifth': 1.5,
        'minor-sixth': 1.6,
        'golden-ratio': 1.618,
        'major-sixth': 1.667,
        'square-root-3': 1.732,
        'minor-seventh': 1.778,
        'major-seventh': 1.875,
        octave: 2,
        'square-root-5': 2.23,
        'major-tenth': 2.5,
        'major-eleventh': 2.667,
        'major-twelfth': 3,
        pi: 3.14,
        'double-octave': 4
    };
    if (entries) return Object.entries(sequence);
    return sequence;
}
function $e771db75132e9266$export$37aa944133e84c53(valueKey, index) {
    const position = valueKey === 'key' ? 0 : 1;
    const key = this.state.key?.[index];
    if (key) return valueKey === 'key' ? key.split(' ~')[position] : `~${key.split(' ~')[position]}`;
    if (!this.state.parent?.value) return null;
    const { base: base, ratio: ratio } = this.state.parent.value;
    const data = this.call('generateSequencePosition', {
        base: base,
        ratio: ratio
    }, this.state.value[index]);
    if (!data) return null;
    const [sequence] = Object.values(data.sequence);
    return valueKey === 'key' ? sequence[valueKey] : `~${sequence[valueKey]}em`;
}
function $e771db75132e9266$export$431ed294bd30b5b0(quantity, mode = 1) {
    if (!this.state.parent?.value) return [];
    return new Array(quantity).fill().map((c, index)=>{
        const value = index + quantity * mode;
        const { base: base, ratio: ratio } = this.state.parent.value;
        const data = this.call('generateSequencePosition', {
            base: base,
            ratio: ratio
        }, value);
        if (!data) return null;
        const [sequence] = Object.values(data.sequence);
        return {
            key: `${sequence.key} ~${sequence.scaling}em`,
            value: value
        };
    });
}

});

parcelRegister("cXc1w", function(module, exports) {

$parcel$export(module.exports, "createTextStyleStateFields", () => $96e452561f9d99f7$export$536c7061a89d298b);
$parcel$export(module.exports, "applyDemoStyles", () => $96e452561f9d99f7$export$540ac7da8799f626);
$parcel$export(module.exports, "extractLetterFromVar", () => $96e452561f9d99f7$export$5561a9c48ebf1e34);
function $96e452561f9d99f7$export$536c7061a89d298b(position) {
    const inheritFromState = this.parent.state.fields.at(position);
    const initValue = this.parent.state.value[inheritFromState.key];
    this.state.update({
        ...inheritFromState,
        value: initValue ?? inheritFromState.value ?? null
    });
}
function $96e452561f9d99f7$export$540ac7da8799f626() {
    const { fontWeight: fontWeight, letterWidth: letterWidth, italic: italic, lineHeight: lineHeight, fontFamily: fontFamily, letterSpacing: letterSpacing, fontSize: fontSize } = this.state.value;
    const variations = [
        '"wght"',
        '"wdth"'
    ];
    const variationValues = [
        fontWeight,
        letterWidth
    ];
    const fontFamilyValues = fontFamily && fontFamily !== 'inherit' ? this.getDesignSystem('font_family')[fontFamily].value.join(', ') : 'inherit';
    const textPreview = this.lookdown('Demo');
    textPreview?.setNodeStyles({
        fontVariationSettings: variationValues.map((v, i)=>{
            if (!v) return null;
            return `${variations[i]} ${v}`;
        }).filter((v)=>v).join(', '),
        fontFamily: fontFamilyValues,
        letterSpacing: `${letterSpacing}em`,
        fontStretch: `${letterWidth}em`,
        lineHeight: lineHeight,
        fontWeight: fontWeight,
        fontStyle: italic ? `oblique ${italic / 10}deg` : null
    });
    textPreview?.update({
        fontSize: fontSize
    });
}
function $96e452561f9d99f7$export$5561a9c48ebf1e34(input) {
    // Usando regex com grupo de captura nomeado para extrair a letra e o número
    const match = input?.match(/--font-size-(?<letter>[A-Z])(?<number>\d+)?\)/u);
    // Retorna a letra capturada se encontrada, caso contrário retorna null
    return match ? match.groups.letter + (match.groups.number || '') : null;
}

});

parcelRegister("14r18", function(module, exports) {

$parcel$export(module.exports, "isVisible", () => $0c7b1f393ba26ba9$export$795910f5f15a9633);
function $0c7b1f393ba26ba9$export$795910f5f15a9633(element) {
    const elem = element || this.node;
    if (!elem.nodeType || elem.nodeType !== 1) throw Error('element is not a node element');
    const style = window.getComputedStyle(elem);
    if (style.display === 'none') return false;
    if (style.visibility !== 'visible') return false;
    if (style.opacity < 0.1) return false;
    if (elem.offsetWidth + elem.offsetHeight + elem.getBoundingClientRect().height + elem.getBoundingClientRect().width === 0) return false;
    const elemCenter = {
        x: elem.getBoundingClientRect().left + elem.offsetWidth / 2,
        y: elem.getBoundingClientRect().top + elem.offsetHeight / 2
    };
    if (elemCenter.x < 0) return false;
    if (elemCenter.x > (document.documentElement.clientWidth || window.innerWidth)) return false;
    if (elemCenter.y < 0) return false;
    if (elemCenter.y > (document.documentElement.clientHeight || window.innerHeight)) return false;
    let pointContainer = document.elementFromPoint(elemCenter.x, elemCenter.y);
    do {
        if (pointContainer === elem) return true;
    }while (pointContainer = pointContainer.parentNode);
    return false;
}

});

parcelRegister("4sF1R", function(module, exports) {

$parcel$export(module.exports, "updateMediaQueryState", () => $33f99a767905ee30$export$48185540cc0d259b);
function $33f99a767905ee30$export$48185540cc0d259b() {
    if (!this.data) this.data = {};
    const { timeout: timeout } = this.data;
    const el = this;
    const floatingPanelState = el.state.parent;
    // float panel state is wiped out => float panel is not open => no need to update state
    if (Object.keys(floatingPanelState).length === 0) return;
    if (timeout) clearTimeout(timeout);
    this.data.timeout = setTimeout(async ()=>{
        const { value: value } = floatingPanelState;
        // check if input is valid
        const nodeValue = el.node.value;
        // only number -> add px at the end
        if (!isNaN(nodeValue)) el.node.value = `${nodeValue}px`;
        if (!$33f99a767905ee30$var$validateCssUnitValue(el.node.value)) {
            console.warn('Invalid CSS unit value');
            el.node.value = el.state.value;
            return;
        }
        el.state.quietUpdate({
            value: el.node.value
        });
        let newFloatingPanelValue;
        if (!value) // add: float panel state value is null
        newFloatingPanelValue = `(${el.state.key}: ${el.node.value})`;
        else {
            // update: find the update position to replace the state
            const values = value.split(', ');
            const { position: position } = el.state;
            values[position] = `(${el.state.key}: ${el.node.value})`;
            newFloatingPanelValue = values.join(', ');
        }
        floatingPanelState.quietUpdate({
            value: newFloatingPanelValue
        });
        if (timeout) clearTimeout(timeout);
    }, 1000);
}
function $33f99a767905ee30$var$validateCssUnitValue(value) {
    const CssUnitTypes = [
        'em',
        'ex',
        'ch',
        'rem',
        'vw',
        'vh',
        'vmin',
        'vmax',
        '%',
        'cm',
        'mm',
        'in',
        'px',
        'pt',
        'pc'
    ];
    const regexps = CssUnitTypes.map((unit)=>new RegExp(`^[0-9]+${unit}$|^[0-9]+\\.[0-9]+${unit}$`, 'i'));
    const isValid = regexps.find((regexp)=>regexp.test(value)) !== undefined;
    return isValid;
}

});

parcelRegister("k7l6l", function(module, exports) {

$parcel$export(module.exports, "MEDIATYPES", () => $ea54d461e5117335$export$d2b3673b7dbefbd8);
const $ea54d461e5117335$export$d2b3673b7dbefbd8 = ()=>[
        {
            text: 'min-width',
            value: 'minWidth'
        },
        {
            text: 'max-width',
            value: 'maxWidth'
        },
        {
            text: 'min-height',
            value: 'minHeight'
        },
        {
            text: 'max-height',
            value: 'maxHeight'
        },
        {
            text: 'exact',
            value: 'exact'
        }
    ];

});

parcelRegister("gv7AI", function(module, exports) {

$parcel$export(module.exports, "enterCanvas", () => $c0356e09ebb6eb03$export$b128cebaf7658ce4);
$parcel$export(module.exports, "leaveCanvas", () => $c0356e09ebb6eb03$export$8d88abff2ce15a72);
$parcel$export(module.exports, "switchCanvasProject", () => $c0356e09ebb6eb03$export$8510d465f1c7ebb);
// Canvas page navigation helpers for CollabService connection management
parcelRequire("2oe0q");
var $kt4aQ = parcelRequire("kt4aQ");
async function $c0356e09ebb6eb03$export$b128cebaf7658ce4() {
    const { projectId: projectId, branch: branch = 'main', pro: pro } = this.getRootState();
    if (!this.sdk) {
        if ((0, $kt4aQ.isNotProduction)()) console.warn('[enterCanvas] SDK not available');
        return;
    }
    if (!projectId) {
        if ((0, $kt4aQ.isNotProduction)()) console.warn('[enterCanvas] Missing projectId, skipping connection');
        return;
    }
    try {
        if (!this.sdk.isConnected()) {
            await this.sdk.connect({
                projectId: projectId,
                branch: branch,
                pro: pro
            });
            console.log('[enterCanvas] Connected to collaboration for project:', projectId);
        }
    } catch (error) {
        if ((0, $kt4aQ.isNotProduction)()) console.error('[enterCanvas] Failed to connect to collaboration:', error);
    }
}
function $c0356e09ebb6eb03$export$8d88abff2ce15a72() {
    if (!this.sdk?.isConnected()) return;
    try {
        this.sdk.disconnect();
        if ((0, $kt4aQ.isNotProduction)()) console.log('[leaveCanvas] Disconnected from collaboration');
    } catch (error) {
        console.error('[leaveCanvas] Error disconnecting from collaboration:', error);
    }
}
async function $c0356e09ebb6eb03$export$8510d465f1c7ebb(projectData) {
    const { projectId: projectId, branch: branch = 'main', pro: pro } = projectData || {};
    if (!this.sdk?.getService) {
        if ((0, $kt4aQ.isNotProduction)()) console.warn('[switchCanvasProject] SDK not available');
        return;
    }
    try {
        if (!projectId) throw new Error('projectId is required to switch collaboration room');
        const collabService = this.sdk.getService('collab');
        const normalizedBranch = branch || 'main';
        const desiredLiveFlag = Boolean(pro);
        if (collabService?.getConnectionInfo) {
            const connectionInfo = collabService.getConnectionInfo();
            const { connected: connected = false, connecting: connecting = false, projectId: currentProjectId, branch: currentBranch, live: currentLive } = connectionInfo || {};
            const matchesProject = currentProjectId === projectId;
            const matchesBranch = (currentBranch || 'main') === normalizedBranch;
            const matchesLive = Boolean(currentLive) === desiredLiveFlag;
            if ((connected || connecting) && matchesProject && matchesBranch && matchesLive) {
                if ((0, $kt4aQ.isNotProduction)()) console.log('[switchCanvasProject] Already connected to requested collaboration room; skipping reconnect');
                return;
            }
        }
        // Connect to new project's collaboration room
        await this.sdk.connect({
            projectId: projectId,
            branch: normalizedBranch,
            pro: pro
        });
    } catch (error) {
        console.error('[switchCanvasProject] Failed to switch collaboration room:', error);
    }
}

});

parcelRegister("f5bmg", function(module, exports) {

$parcel$export(module.exports, "handleSBMouseDown", () => $afb0221ea875d4a8$export$7dd31147432f4d28);
$parcel$export(module.exports, "handleHueMouseDown", () => $afb0221ea875d4a8$export$d7854c22ae65bc2e);
$parcel$export(module.exports, "updateSBFromEvent", () => $afb0221ea875d4a8$export$8fe649e59545fd85);
$parcel$export(module.exports, "updateHueFromEvent", () => $afb0221ea875d4a8$export$227e3b352766cd38);
$parcel$export(module.exports, "hsbToRgb", () => $afb0221ea875d4a8$export$6c9c93e2ff982b3b);
$parcel$export(module.exports, "rgbToHsb", () => $afb0221ea875d4a8$export$cbdf8703a5855945);
$parcel$export(module.exports, "rgbToHex", () => $afb0221ea875d4a8$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgb", () => $afb0221ea875d4a8$export$5a544e13ad4e1fa5);
$parcel$export(module.exports, "hexToHsb", () => $afb0221ea875d4a8$export$8a52e3f13a462b8);
$parcel$export(module.exports, "hsbToHex", () => $afb0221ea875d4a8$export$fec042be06d2e393);
$parcel$export(module.exports, "hsbToHsl", () => $afb0221ea875d4a8$export$7badd6b38be6ae00);
$parcel$export(module.exports, "hslToHsb", () => $afb0221ea875d4a8$export$2970e1a20d040f75);
$parcel$export(module.exports, "isValidColor", () => $afb0221ea875d4a8$export$35fa9d266cdb6f09);
$parcel$export(module.exports, "isEyeDropperSupported", () => $afb0221ea875d4a8$export$c58b654089cdea5a);
$parcel$export(module.exports, "handleEyeDropper", () => $afb0221ea875d4a8$export$ff47fae1e2a80c25);
$parcel$export(module.exports, "adjustShade", () => $afb0221ea875d4a8$export$19e19be604a8d03d);
$parcel$export(module.exports, "deepCompareObjects", () => $afb0221ea875d4a8$export$76775c78e51bf19f);
/**
 * Handles the saturation and brightness area mouse down event.
 *
 * @param {MouseEvent} e - The mouse event.
 */ function $afb0221ea875d4a8$export$7dd31147432f4d28(e) {
    e.preventDefault();
    const handleMouseMove = (e)=>this.call('updateSBFromEvent', e);
    const handleMouseUp = ()=>{
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
    };
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
}
function $afb0221ea875d4a8$export$d7854c22ae65bc2e(e) {
    e.preventDefault();
    const handleMouseMove = (e)=>this.call('updateHueFromEvent', e);
    const handleMouseUp = ()=>{
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
    };
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
}
function $afb0221ea875d4a8$export$8fe649e59545fd85(e) {
    const rect = this.node.getBoundingClientRect();
    const x = Math.max(0, Math.min(rect.width, e.clientX - rect.left));
    const y = Math.max(0, Math.min(rect.height, e.clientY - rect.top));
    const saturation = x / rect.width;
    const brightness = 1 - y / rect.height;
    this.state.update({
        saturation: saturation,
        brightness: brightness
    });
}
function $afb0221ea875d4a8$export$227e3b352766cd38(e) {
    const rect = this.node.getBoundingClientRect();
    const x = Math.max(0, Math.min(rect.width, e.clientX - rect.left));
    const hue = x / rect.width * 360;
    this.state.update({
        hue: hue
    });
}
function $afb0221ea875d4a8$export$6c9c93e2ff982b3b(h, s, b) {
    h = h / 360;
    const i = Math.floor(h * 6);
    const f = h * 6 - i;
    const p = b * (1 - s);
    const q = b * (1 - f * s);
    const t = b * (1 - (1 - f) * s);
    let r, g, blue;
    switch(i % 6){
        case 0:
            r = b;
            g = t;
            blue = p;
            break;
        case 1:
            r = q;
            g = b;
            blue = p;
            break;
        case 2:
            r = p;
            g = b;
            blue = t;
            break;
        case 3:
            r = p;
            g = q;
            blue = b;
            break;
        case 4:
            r = t;
            g = p;
            blue = b;
            break;
        case 5:
            r = b;
            g = p;
            blue = q;
            break;
    }
    return {
        r: Math.round(r * 255),
        g: Math.round(g * 255),
        b: Math.round(blue * 255)
    };
}
function $afb0221ea875d4a8$export$cbdf8703a5855945(r, g, b) {
    r /= 255;
    g /= 255;
    b /= 255;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const diff = max - min;
    let h = 0;
    let s = max === 0 ? 0 : diff / max;
    let brightness = max;
    if (diff !== 0) switch(max){
        case r:
            h = ((g - b) / diff + (g < b ? 6 : 0)) / 6;
            break;
        case g:
            h = ((b - r) / diff + 2) / 6;
            break;
        case b:
            h = ((r - g) / diff + 4) / 6;
            break;
    }
    return {
        h: h * 360,
        s: s,
        b: brightness
    };
}
function $afb0221ea875d4a8$export$34d09c4a771c46ef(r, g, b) {
    return '#' + (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1).toUpperCase();
}
function $afb0221ea875d4a8$export$5a544e13ad4e1fa5(hex) {
    // Remove # if present
    hex = hex.replace('#', '');
    // Handle 3-digit hex (expand to 6-digit)
    if (hex.length === 3) hex = hex.split('').map((char)=>char + char).join('');
    // Handle 6-digit hex
    if (hex.length === 6) {
        const result = /^([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    }
    return null;
}
function $afb0221ea875d4a8$export$8a52e3f13a462b8(hex) {
    // First convert hex to RGB
    const rgb = $afb0221ea875d4a8$export$5a544e13ad4e1fa5(hex);
    if (!rgb) return null;
    // Then convert RGB to HSB
    return $afb0221ea875d4a8$export$cbdf8703a5855945(rgb.r, rgb.g, rgb.b);
}
function $afb0221ea875d4a8$export$fec042be06d2e393(h, s, b) {
    // First convert HSB to RGB
    const rgb = $afb0221ea875d4a8$export$6c9c93e2ff982b3b(h, s, b);
    if (!rgb) return null;
    // Then convert RGB to hex
    return $afb0221ea875d4a8$export$34d09c4a771c46ef(rgb.r, rgb.g, rgb.b);
}
function $afb0221ea875d4a8$export$7badd6b38be6ae00(h, s, b) {
    const l = b * (2 - s) / 2;
    const sl = l !== 0 && l !== 1 ? (b - l) / Math.min(l, 1 - l) : 0;
    return {
        h: h,
        s: sl * 100,
        l: l * 100
    };
}
function $afb0221ea875d4a8$export$2970e1a20d040f75(h, s, l) {
    // Convert percentage values to decimals (0-1)
    const sDecimal = s / 100;
    const lDecimal = l / 100;
    const b = lDecimal + sDecimal * Math.min(lDecimal, 1 - lDecimal);
    const sb = b === 0 ? 0 : 2 * (1 - lDecimal / b);
    return {
        h: h,
        s: sb,
        b: b
    };
}
/**
 * Checks if a string is a valid hex color code.
 *
 * @param {string} hex - The string to check
 * @returns {boolean} True if the string is a valid hex color code
 * @private
 */ function $afb0221ea875d4a8$var$isValidHex(hex) {
    return /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(hex);
}
/**
 * Checks if the given value is a valid RGB number.
 *
 * @param value
 * @returns {boolean}
 */ /**
 * Checks if a value is a valid RGB number (0-255).
 *
 * @param {string|number} value - The value to check
 * @returns {boolean} True if the value is a valid RGB number
 * @private
 */ function $afb0221ea875d4a8$var$isValidRgbNumber(value) {
    // Check if it's a valid number string
    if (typeof value !== 'string' && typeof value !== 'number') return false;
    const num = Number(value);
    // Check if it's a valid number, integer, and within RGB range
    return !isNaN(num) && Number.isInteger(num) && num >= 0 && num <= 255;
}
function $afb0221ea875d4a8$export$35fa9d266cdb6f09(value) {
    // Check if it's a valid hex color
    if (typeof value === 'string' && value.startsWith('#')) return $afb0221ea875d4a8$var$isValidHex(value);
    // Check if it's a valid RGB number
    return $afb0221ea875d4a8$var$isValidRgbNumber(value);
}
function $afb0221ea875d4a8$export$c58b654089cdea5a() {
    return 'EyeDropper' in window;
}
async function $afb0221ea875d4a8$export$ff47fae1e2a80c25() {
    if (!('EyeDropper' in window)) {
        alert('Eye dropper is not supported in this browser. Please use Chrome 95+ or Edge 95+.');
        return null;
    }
    try {
        const eyeDropper = new EyeDropper();
        const result = await eyeDropper.open();
        if (result && result.sRGBHex) // Convert hex to HSB
        return $afb0221ea875d4a8$export$8a52e3f13a462b8(result.sRGBHex);
    } catch (error) {
        if (error.name !== 'AbortError') alert('Error using eye dropper: ' + error.message);
        return null;
    }
}
function $afb0221ea875d4a8$export$19e19be604a8d03d(rgb, shade) {
    const shadeString = shade > 0 ? '+' + shade : shade;
    const rgbString = this.call('getRgbTone', [
        rgb.r,
        rgb.g,
        rgb.b,
        1
    ], shadeString);
    const newRgb = rgbString.split(', ');
    return {
        r: newRgb[0],
        g: newRgb[1],
        b: newRgb[2]
    };
}
function $afb0221ea875d4a8$export$76775c78e51bf19f(obj1, obj2) {
    if (obj1 === obj2) return true;
    if (typeof obj1 !== 'object' || obj1 === null || typeof obj2 !== 'object' || obj2 === null) return false;
    const obj1Keys = Object.keys(obj1);
    const obj2Keys = Object.keys(obj2);
    if (obj1Keys.length !== obj2Keys.length) return false;
    for (const key of obj1Keys){
        if (!obj2.hasOwnProperty(key) || !$afb0221ea875d4a8$export$76775c78e51bf19f(obj1[key], obj2[key])) return false;
    }
    return true;
}

});

parcelRegister("84qmQ", function(module, exports) {

$parcel$export(module.exports, "DOM_EVENTS", () => $5e03267b48c2a12a$export$f552dbb36ef6b3dd);
$parcel$export(module.exports, "getComponentsList", () => $5e03267b48c2a12a$export$c02ba41b11a67d02);
$parcel$export(module.exports, "getDomqlList", () => $5e03267b48c2a12a$export$d5e3ca8a213b95b3);
$parcel$export(module.exports, "getEventsList", () => $5e03267b48c2a12a$export$b284d53355bac59b);
$parcel$export(module.exports, "getCssPropsList", () => $5e03267b48c2a12a$export$98a77d5ae19c6290);
$parcel$export(module.exports, "getHTMLAttrsList", () => $5e03267b48c2a12a$export$9711e2c49c469cff);
$parcel$export(module.exports, "getCategoriesList", () => $5e03267b48c2a12a$export$90fcb8fa0d4ee4fc);
$parcel$export(module.exports, "moveSelectionInList", () => $5e03267b48c2a12a$export$a99a881729d4d748);
$parcel$export(module.exports, "addPropKey", () => $5e03267b48c2a12a$export$aa7781387220aa73);

var $cThmB = parcelRequire("cThmB");

var $inO1F = parcelRequire("inO1F");
const $5e03267b48c2a12a$var$DOMQL_ELEMENTS = [
    'extends',
    'childExtends',
    'children',
    'childProps',
    'childrenAs',
    'state',
    'tag',
    'key',
    'childExtendsRecursive',
    'query',
    'data',
    'scope'
];
const $5e03267b48c2a12a$export$f552dbb36ef6b3dd = [
    'onAnimationcancel',
    'onAnimationend',
    'onAnimationiteration',
    'onAnimationstart',
    'onAuxclick',
    'onBeforeinput',
    'onBeforematchExperimental',
    'onBeforexrselectExperimental',
    'onBlur',
    'onClick',
    'onCompositionend',
    'onCompositionstart',
    'onCompositionupdate',
    'onContentvisibilityautostatechange',
    'onContextmenu',
    'onCopy',
    'onCut',
    'onDblclick',
    'onDOMActivateDeprecated',
    'onFocus',
    'onFocusin',
    'onFocusout',
    'onFullscreenchange',
    'onFullscreenerror',
    'onGotpointercapture',
    'onInput',
    'onKeydown',
    'onKeypressDeprecated',
    'onKeyup',
    'onLostpointercapture',
    'onMousedown',
    'onMouseenter',
    'onMouseleave',
    'onMousemove',
    'onMouseout',
    'onMouseover',
    'onMouseup',
    'onPaste',
    'onPointercancel',
    'onPointerdown',
    'onPointerenter',
    'onPointerleave',
    'onPointermove',
    'onPointerout',
    'onPointerover',
    'onPointerrawupdateExperimental',
    'onPointerup',
    'onScroll',
    'onScrollend',
    'onScrollsnapchangeExperimental',
    'onScrollsnapchangingExperimental',
    'onSecuritypolicyviolation',
    'onTouchcancel',
    'onTouchend',
    'onTouchmove',
    'onTouchstart',
    'onTransitioncancel',
    'onTransitionend',
    'onTransitionrun',
    'onTransitionstart',
    'onWheel'
];
async function $5e03267b48c2a12a$export$c02ba41b11a67d02() {
    const list = await this.call('getComponentList', 'components');
    const compList = list.filter(({ isDivider: isDivider, isSharedLib: isSharedLib, isLabel: isLabel })=>!isDivider && !isSharedLib && !isLabel);
    return {
        title: 'Components',
        items: compList
    };
}
async function $5e03267b48c2a12a$export$d5e3ca8a213b95b3() {
    let domElements = $5e03267b48c2a12a$var$DOMQL_ELEMENTS.map((item)=>({
            key: item,
            value: item
        }));
    return {
        title: 'Domql',
        items: domElements.sort()
    };
}
async function $5e03267b48c2a12a$export$b284d53355bac59b() {
    let domEventsList = $5e03267b48c2a12a$export$f552dbb36ef6b3dd.map((item)=>({
            key: item,
            value: item
        }));
    return {
        title: 'Events',
        items: domEventsList.sort()
    };
}
async function $5e03267b48c2a12a$export$98a77d5ae19c6290() {
    let cssProperties = (0, $cThmB.DEFAULT_CSS_PROPERTIES_LIST).map((item)=>({
            key: item,
            value: item
        }));
    return {
        title: 'Css',
        items: cssProperties.sort()
    };
}
async function $5e03267b48c2a12a$export$9711e2c49c469cff() {
    let htmlAttributes = (0, $inO1F.HTML_ATTRIBUTES)['default'].map((item)=>({
            key: item,
            value: item
        }));
    return {
        title: 'Html',
        items: htmlAttributes.sort()
    };
}
async function $5e03267b48c2a12a$export$90fcb8fa0d4ee4fc() {
    const state = this.state;
    const filter = state.filterText?.toLowerCase() || '';
    const components = await this.call('getComponentsList');
    const domqlList = await this.call('getDomqlList');
    const eventsList = await this.call('getEventsList');
    const cssPropsList = await this.call('getCssPropsList');
    const htmlAttrsList = await this.call('getHTMLAttrsList');
    let categories;
    if (state.parent.listType === 'OnlyProperties') categories = [
        domqlList,
        eventsList,
        cssPropsList,
        htmlAttrsList
    ];
    else if (state.parent.listType === 'OnlyChildren') categories = [
        components
    ];
    else categories = [
        components,
        domqlList,
        eventsList,
        cssPropsList,
        htmlAttrsList
    ];
    // Apply filter to each category
    return categories.map((cat)=>({
            title: cat.title,
            items: cat.items.filter((item)=>item.value.toLowerCase().includes(filter))
        })).filter((cat)=>cat.items.length > 0);
}
function $5e03267b48c2a12a$export$a99a881729d4d748(dir) {
    const root = this.state.parent;
    const title = this.state.title;
    const items = this.state.expanded ? this.state.items : [
        ...this.state.items.slice(0, 5),
        {
            value: null,
            isMore: true
        }
    ];
    const total = items.length;
    let index = items.findIndex((item)=>item.isMore ? root.isMoreSelected : item.value === root.selectedItem);
    if (dir === 'down') index = index < total - 1 ? index + 1 : 0;
    else if (dir === 'up') index = index > 0 ? index - 1 : total - 1;
    const newItem = items[index];
    root.update({
        selectedItem: newItem.value,
        selectedTitle: title,
        isMoreSelected: !!newItem.isMore
    });
    const moreEl = this.parent.lookdown('More');
    if (newItem.isMore) {
        moreEl?.set({
            background: 'gray3.5',
            round: 'Z'
        });
        this.call('addPropKey', '');
    } else {
        moreEl?.set({
            background: 'transparent'
        });
        this.call('addPropKey', newItem.value);
    }
}
function $5e03267b48c2a12a$export$aa7781387220aa73(key) {
    const panel = this.getFloatingPanelElement();
    const inputEl = panel.inputElement;
    if (!inputEl?.node) throw new Error(`Input element ${inputEl} not found`);
    inputEl.node.value = key;
}

});

parcelRegister("744AV", function(module, exports) {
// Chat function surface. Re-exports every `el.call`-addressable function
// chat components invoke (sendMessage, toggleReaction, uploadAttachment,
// markRead, setupHoverActions, subscribeRealtime, renderMarkdown, plus
// pure helpers). Lives in shared/ so every app picking up shared/context.js
// registers them automatically.
// Pure helpers — no Supabase dependency.

var $jg4vi = parcelRequire("jg4vi");

var $aG9qy = parcelRequire("aG9qy");

var $lwYfR = parcelRequire("lwYfR");

var $f0zrS = parcelRequire("f0zrS");

var $htapf = parcelRequire("htapf");

var $hRl3P = parcelRequire("hRl3P");

var $5WCCa = parcelRequire("5WCCa");

var $1Ka08 = parcelRequire("1Ka08");

var $i3NGB = parcelRequire("i3NGB");

var $kGdDD = parcelRequire("kGdDD");

var $brkK8 = parcelRequire("brkK8");

var $8LJA2 = parcelRequire("8LJA2");

var $7RhRk = parcelRequire("7RhRk");

var $lKCIH = parcelRequire("lKCIH");

var $7YjkX = parcelRequire("7YjkX");

var $9sCiC = parcelRequire("9sCiC");

var $9QyNN = parcelRequire("9QyNN");

var $cjkU0 = parcelRequire("cjkU0");

var $8JkCi = parcelRequire("8JkCi");

var $2lygP = parcelRequire("2lygP");
$parcel$exportWildcard(module.exports, $jg4vi);
$parcel$exportWildcard(module.exports, $aG9qy);
$parcel$exportWildcard(module.exports, $lwYfR);
$parcel$exportWildcard(module.exports, $f0zrS);
$parcel$exportWildcard(module.exports, $htapf);
$parcel$exportWildcard(module.exports, $hRl3P);
$parcel$exportWildcard(module.exports, $5WCCa);
$parcel$exportWildcard(module.exports, $1Ka08);
$parcel$exportWildcard(module.exports, $i3NGB);
$parcel$exportWildcard(module.exports, $kGdDD);
$parcel$exportWildcard(module.exports, $brkK8);
$parcel$exportWildcard(module.exports, $8LJA2);
$parcel$exportWildcard(module.exports, $7RhRk);
$parcel$exportWildcard(module.exports, $lKCIH);
$parcel$exportWildcard(module.exports, $7YjkX);
$parcel$exportWildcard(module.exports, $9sCiC);
$parcel$exportWildcard(module.exports, $9QyNN);
$parcel$exportWildcard(module.exports, $cjkU0);
$parcel$exportWildcard(module.exports, $8JkCi);
$parcel$exportWildcard(module.exports, $2lygP);

});
parcelRegister("1Ka08", function(module, exports) {

$parcel$export(module.exports, "sendMessage", () => $1451d855eb516c1e$export$465cb47180de50f0);
// Optimistically append the message to root.messagesByChannel, then INSERT
// via the SDK. The realtime subscription (subscribeRealtime) will see the
// inserted row come back and reconcile the optimistic id.

var $bfqVY = parcelRequire("bfqVY");

var $jg4vi = parcelRequire("jg4vi");
const $1451d855eb516c1e$export$465cb47180de50f0 = async function({ channelId: channelId, body: body, replyTo: replyTo = null, threadRoot: threadRoot = null }) {
    const root = this.state.root;
    // Pull pending attachments — strip the upload-tracking fields, keep what
    // we want stored on the message row's `attachments` jsonb column.
    const pending = root.pendingAttachments && root.pendingAttachments[channelId] || [];
    const attachments = pending.filter((a)=>a && a.url && !a.uploading).map((a)=>({
            name: a.name,
            size: a.size,
            mime: a.mime,
            url: a.url
        }));
    const trimmed = (body || '').trim();
    // Allow attachment-only messages with empty body.
    if (!trimmed && attachments.length === 0) return null;
    if (!channelId) return null;
    const author = root.currentUserEmail;
    const tempId = `tmp-${Date.now()}`;
    const now = new Date().toISOString();
    const optimistic = {
        id: tempId,
        channelId: channelId,
        authorEmail: author,
        body: trimmed,
        attachments: attachments.length ? attachments : null,
        replyTo: replyTo,
        threadRoot: threadRoot,
        createdAt: now,
        _optimistic: true
    };
    const prev = root.messagesByChannel[channelId] || [];
    root.update({
        messagesByChannel: {
            ...root.messagesByChannel,
            [channelId]: [
                ...prev,
                optimistic
            ]
        },
        pendingAttachments: (()=>{
            const next = {
                ...root.pendingAttachments
            };
            delete next[channelId];
            return next;
        })()
    });
    try {
        // migrated 2026-04-27 to SDK route workspaceProject.chat.messages create
        const data = await (0, $bfqVY.getSDK)().execute('workspaceProject.chat.messages', 'create', {
            channelId: channelId,
            payload: {
                author_email: author,
                body: trimmed,
                attachments: attachments.length ? attachments : null,
                reply_to: replyTo,
                thread_root: threadRoot
            }
        });
        // Reconcile with whatever is in state right now. Three possible states:
        //   1. Optimistic row still in list, realtime has not arrived → swap.
        //   2. Realtime arrived first and appended the real row → remove the
        //      optimistic row without re-adding (would otherwise duplicate).
        //   3. Optimistic row gone, no real row yet → append.
        const real = (0, $jg4vi.rowToMessage)(data?.data || data);
        const current = root.messagesByChannel[channelId] || [];
        const hasReal = current.some((m)=>m.id === real.id);
        const next = hasReal ? current.filter((m)=>m.id !== tempId) : current.map((m)=>m.id === tempId ? real : m);
        root.update({
            messagesByChannel: {
                ...root.messagesByChannel,
                [channelId]: next
            }
        });
        return real.id;
    } catch (e) {
        console.error('[sendMessage]', e?.message || e);
        // Rollback: drop the optimistic row.
        const list = (root.messagesByChannel[channelId] || []).filter((m)=>m.id !== tempId);
        root.update({
            messagesByChannel: {
                ...root.messagesByChannel,
                [channelId]: list
            }
        });
        return null;
    }
};

});

parcelRegister("i3NGB", function(module, exports) {

$parcel$export(module.exports, "toggleReaction", () => $d25f0c6a0ed37b3e$export$fb8a5038533fa3c3);

var $bfqVY = parcelRequire("bfqVY");
const $d25f0c6a0ed37b3e$export$fb8a5038533fa3c3 = async function(msgId, emoji) {
    const root = this?.state?.root;
    if (!root || !msgId || !emoji) return;
    const me = root.currentUserEmail;
    if (!me) return;
    // Optimistic update — toggle in local state immediately.
    const channelId = root.activeChannelId;
    const map = {
        ...root.messagesByChannel || {}
    };
    const msgs = (map[channelId] || []).map((m)=>{
        if (m.id !== msgId) return m;
        const reactions = {
            ...m.reactions || {}
        };
        const list = reactions[emoji] ? [
            ...reactions[emoji]
        ] : [];
        const idx = list.indexOf(me);
        if (idx === -1) list.push(me);
        else list.splice(idx, 1);
        if (list.length) reactions[emoji] = list;
        else delete reactions[emoji];
        return {
            ...m,
            reactions: reactions
        };
    });
    map[channelId] = msgs;
    root.update({
        messagesByChannel: map
    });
    // Persist via the SDK — the server-side `react` op handles the
    // read-modify-write atomically, no client-side race window.
    try {
        // migrated 2026-04-27 to SDK route workspaceProject.chat.messages react
        await (0, $bfqVY.getSDK)().execute('workspaceProject.chat.messages', 'react', {
            id: msgId,
            emoji: emoji,
            userId: me
        });
    } catch (err) {
        console.error('[toggleReaction]', err);
    }
};

});

parcelRegister("kGdDD", function(module, exports) {

$parcel$export(module.exports, "uploadAttachment", () => $f0e24f2fc9ffefec$export$498cf126c78420df);
// Upload a File object to the chat-attachments bucket and return the public
// URL. Optimistically tracks progress in root.pendingAttachments[channelId]
// so the composer can render upload chips while the request is in flight.
//
// migrated 2026-04-27 to SDK route workspaceProject.storage upload + publicUrl.
// The workspace API wrapper at /workspace/storage/* enforces RLS server-side,
// so the browser never sees the bucket service-role key. Multipart upload
// uses the WorkspaceProjectService.storage.upload helper which composes a
// FormData request without forcing JSON Content-Type.

var $bfqVY = parcelRequire("bfqVY");
const $f0e24f2fc9ffefec$var$_slug = (s)=>(s || '').toLowerCase().replace(/[^a-z0-9.-]/g, '-').slice(0, 80);
const $f0e24f2fc9ffefec$export$498cf126c78420df = async function({ channelId: channelId, file: file }) {
    if (!channelId || !file) return null;
    const root = this.state.root;
    const tempId = `att-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
    const path = `${channelId}/${Date.now()}-${$f0e24f2fc9ffefec$var$_slug(file.name)}`;
    const placeholder = {
        id: tempId,
        name: file.name,
        size: file.size,
        mime: file.type,
        url: null,
        uploading: true
    };
    const cur = root.pendingAttachments[channelId] || [];
    root.update({
        pendingAttachments: {
            ...root.pendingAttachments,
            [channelId]: [
                ...cur,
                placeholder
            ]
        }
    });
    try {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('path', path);
        formData.append('contentType', file.type || 'application/octet-stream');
        const result = await (0, $bfqVY.getSDK)().execute('workspaceProject.storage', 'upload', {
            bucket: 'chat-attachments',
            formData: formData,
            options: {
                cacheControl: '3600',
                upsert: false
            }
        });
        // Wrapper returns { url } (signed or public, depending on bucket config);
        // fall back to a publicUrl resolution if absent so the composer always
        // has something to render.
        const url = result?.url || result?.publicUrl || (await (0, $bfqVY.getSDK)().execute('workspaceProject.storage', 'publicUrl', {
            bucket: 'chat-attachments',
            path: path
        }))?.url || null;
        if (!url) throw new Error('upload returned no url');
        const next = (root.pendingAttachments[channelId] || []).map((a)=>a.id === tempId ? {
                ...a,
                url: url,
                uploading: false
            } : a);
        root.update({
            pendingAttachments: {
                ...root.pendingAttachments,
                [channelId]: next
            }
        });
        return url;
    } catch (e) {
        console.error('[uploadAttachment]', e?.message || e);
        const next = (root.pendingAttachments[channelId] || []).filter((a)=>a.id !== tempId);
        root.update({
            pendingAttachments: {
                ...root.pendingAttachments,
                [channelId]: next
            }
        });
        return null;
    }
};

});

parcelRegister("brkK8", function(module, exports) {

$parcel$export(module.exports, "markRead", () => $85424e802d6614aa$export$3aa17b355b211dc5);
// Bump the caller's last_read_at on the given channel. Called when the user
// switches into a channel and when a fresh message arrives in the active
// channel.

var $bfqVY = parcelRequire("bfqVY");
const $85424e802d6614aa$export$3aa17b355b211dc5 = async function(channelId) {
    if (!channelId) return;
    const root = this.state.root;
    const me = root.currentUserEmail;
    const now = new Date().toISOString();
    // Optimistic local update first.
    root.update({
        channelMembers: (root.channelMembers || []).map((m)=>m.channel_id === channelId && m.member_email === me ? {
                ...m,
                last_read_at: now
            } : m)
    });
    try {
        // migrated 2026-04-27 to SDK route workspaceProject.chat.members markRead
        await (0, $bfqVY.getSDK)().execute('workspaceProject.chat.members', 'markRead', {
            channelId: channelId,
            userId: me,
            lastReadAt: now
        });
    } catch (e) {
        console.error('[markRead]', e?.message || e);
    }
};

});

parcelRegister("8LJA2", function(module, exports) {

$parcel$export(module.exports, "markMentionsRead", () => $662611cfb6133970$export$3be6780842879acc);
// Mark every chat_mention for the caller in the given channel as read.
// Backed by the chat_mark_mentions_read SQL function from
// 0015_chat_thread_count_and_mentions_index.sql, which does the join +
// update server-side and returns the count it touched.

var $bfqVY = parcelRequire("bfqVY");
const $662611cfb6133970$export$3be6780842879acc = async function(channelId) {
    if (!channelId) return 0;
    const root = this.state.root;
    const me = root.currentUserEmail;
    const msgIds = new Set(((root.messagesByChannel || {})[channelId] || []).map((m)=>m.id));
    // Early-return if there's nothing to clear in this channel — avoids
    // a useless state write + RPC round-trip on every channel switch.
    const unread = (root.myMentions || []).filter((m)=>msgIds.has(m.message_id) && !m.read_at);
    if (unread.length === 0) return 0;
    const now = new Date().toISOString();
    root.update({
        myMentions: (root.myMentions || []).map((m)=>msgIds.has(m.message_id) && !m.read_at ? {
                ...m,
                read_at: now
            } : m)
    });
    try {
        // migrated 2026-04-27 to SDK route workspaceProject.chat.mentions markRead
        const result = await (0, $bfqVY.getSDK)().execute('workspaceProject.chat.mentions', 'markRead', {
            channelId: channelId,
            callerEmail: me
        });
        return result?.data ?? result ?? 0;
    } catch (e) {
        console.error('[markMentionsRead]', e?.message || e);
        return 0;
    }
};

});

parcelRegister("7RhRk", function(module, exports) {

$parcel$export(module.exports, "subscribeRealtime", () => $5b8b561abe209e46$export$b812432b8f92ec1e);
// TODO[sdk-realtime]: SDK realtime for chat is not yet implemented. Keep the
// direct supabase realtime channel here until the SDK exposes equivalent
// `workspaceProject.chat.*` subscribe routes — at that point migrate every
// `channel.on('postgres_changes', ...)` block below to
// `getSDK().execute('workspaceProject.chat.<table>', 'subscribe', filter, cb)`.
//
// Wires the supabase realtime channel to root state. Called once from
// pages/home.js onCreate; cancelled in onRemove.
//
// Three subscriptions:
//   1. postgres_changes on chat_messages → push into messagesByChannel
//   2. postgres_changes on chat_channels + chat_channel_members → reload lists
//   3. presence channel keyed by currentUserEmail → drives root.presence
parcelRequire("82gA2");
var $8RlGv = parcelRequire("8RlGv");

var $jg4vi = parcelRequire("jg4vi");

var $1MoPV = parcelRequire("1MoPV");

var $9sCiC = parcelRequire("9sCiC");
const $5b8b561abe209e46$export$b812432b8f92ec1e = async function() {
    const root = this.state.root;
    const me = root.currentUserEmail;
    // Guard: if already subscribed (e.g. navigated away and back), reuse.
    if (root._chatRealtimeChannel) return root._chatRealtimeChannel;
    const sb = await (0, $8RlGv.getRealtimeSupabase)();
    const channel = sb.channel('governance-chat', {
        config: {
            presence: {
                key: me
            }
        }
    });
    channel.on('postgres_changes', {
        event: 'INSERT',
        schema: 'public',
        table: 'chat_messages'
    }, (payload)=>{
        const msg = (0, $jg4vi.rowToMessage)(payload.new);
        const list = root.messagesByChannel[msg.channelId] || [];
        // Skip if we already have it (optimistic id was reconciled in sendMessage).
        if (list.some((m)=>m.id === msg.id)) return;
        root.update({
            messagesByChannel: {
                ...root.messagesByChannel,
                [msg.channelId]: [
                    ...list,
                    msg
                ]
            }
        });
    });
    channel.on('postgres_changes', {
        event: 'UPDATE',
        schema: 'public',
        table: 'chat_messages'
    }, (payload)=>{
        const msg = (0, $jg4vi.rowToMessage)(payload.new);
        const list = (root.messagesByChannel[msg.channelId] || []).map((m)=>m.id === msg.id ? msg : m);
        root.update({
            messagesByChannel: {
                ...root.messagesByChannel,
                [msg.channelId]: list
            }
        });
    });
    channel.on('postgres_changes', {
        event: '*',
        schema: 'public',
        table: 'chat_channels'
    }, (payload)=>{
        const next = (0, $jg4vi.rowToChannel)(payload.new || payload.old);
        // Read live state — `root.channels` from the closure may be stale.
        const current = root.channels || [];
        const exists = current.find((c)=>c.id === next.id);
        let channels = current;
        if (payload.eventType === 'DELETE') channels = current.filter((c)=>c.id !== next.id);
        else if (exists) channels = current.map((c)=>c.id === next.id ? next : c);
        else channels = [
            ...current,
            next
        ];
        // Only update if the array actually changed.
        if (channels !== current) root.update({
            channels: channels
        });
    });
    channel.on('postgres_changes', {
        event: '*',
        schema: 'public',
        table: 'chat_channel_members'
    }, (payload)=>{
        // Apply the delta in-place — full refetch on every membership flip
        // (e.g. every `markRead` write) was downloading the entire join table.
        const cur = root.channelMembers || [];
        const isSameRow = (a, b)=>a.channel_id === b.channel_id && a.member_email === b.member_email;
        let next = cur;
        if (payload.eventType === 'INSERT') {
            if (!cur.some((r)=>isSameRow(r, payload.new))) next = [
                ...cur,
                payload.new
            ];
        } else if (payload.eventType === 'UPDATE') next = cur.map((r)=>isSameRow(r, payload.new) ? payload.new : r);
        else if (payload.eventType === 'DELETE') next = cur.filter((r)=>!isSameRow(r, payload.old));
        if (next !== cur) root.update({
            channelMembers: next
        });
    });
    // chat_mentions: append rows that mention me, drive the sidebar badge.
    channel.on('postgres_changes', {
        event: 'INSERT',
        schema: 'public',
        table: 'chat_mentions'
    }, (payload)=>{
        const row = payload.new;
        if (!row || row.mentioned_email !== me) return;
        const cur = root.myMentions || [];
        if (cur.some((x)=>x.id === row.id)) return;
        root.update({
            myMentions: [
                ...cur,
                row
            ]
        });
        // Skip notification if the viewer muted this conversation.
        if ((0, $9sCiC.isChannelMuted)(root, row.channel_id)) return;
        // Create a notification for the mention
        const msg = (root.messagesByChannel || {})[row.channel_id]?.find((m)=>m.id === row.message_id);
        const senderName = msg?.authorName || msg?.author_email || 'Someone';
        const channelName = (root.channels || []).find((c)=>c.id === row.channel_id)?.name || 'a channel';
        (0, $1MoPV.createNotification).call({
            state: {
                root: root
            }
        }, {
            userEmail: me,
            type: 'mention',
            title: `${senderName} mentioned you in #${channelName}`,
            body: msg?.body?.substring(0, 100) || '',
            href: `/chat#channel=${row.channel_id}`
        });
    });
    channel.on('presence', {
        event: 'sync'
    }, ()=>{
        const presenceState = channel.presenceState();
        const next = {};
        for (const key of Object.keys(presenceState)){
            const meta = presenceState[key][0] || {};
            next[key] = {
                status: meta.status || 'online',
                last_seen_at: meta.online_at || new Date().toISOString()
            };
        }
        root.update({
            presence: next
        });
    });
    channel.subscribe(async (status)=>{
        if (status !== 'SUBSCRIBED') return;
        await channel.track({
            status: 'online',
            online_at: new Date().toISOString()
        });
    });
    root._chatRealtimeChannel = channel;
    return channel;
};

});
parcelRegister("9sCiC", function(module, exports) {

$parcel$export(module.exports, "setChannelMute", () => $6e3470033e29c0b4$export$d1702d46558e90d3);
$parcel$export(module.exports, "toggleChannelMute", () => $6e3470033e29c0b4$export$137d41cfd295832b);
$parcel$export(module.exports, "isChannelMuted", () => $6e3470033e29c0b4$export$f5b16b03df95f5f1);
// Toggle the `muted` flag on the current user's chat_channel_members row.
// Muted conversations suppress mention notifications, dim the unread badge,
// and show a bell-slash icon next to the title.

var $bfqVY = parcelRequire("bfqVY");
const $6e3470033e29c0b4$export$d1702d46558e90d3 = async function(channelId, muted) {
    const root = this.state.root;
    const me = root?.currentUserEmail;
    if (!channelId || !me) return false;
    try {
        // migrated 2026-04-27 to SDK route workspaceProject.chat.members mute
        await (0, $bfqVY.getSDK)().execute('workspaceProject.chat.members', 'mute', {
            channelId: channelId,
            userId: me,
            muted: !!muted
        });
        // Optimistic state reconcile — realtime will deliver the same row.
        const cur = root.channelMembers || [];
        const next = cur.map((r)=>r.channel_id === channelId && r.member_email === me ? {
                ...r,
                muted: !!muted
            } : r);
        root.update({
            channelMembers: next
        });
        return true;
    } catch (err) {
        console.error('[setChannelMute]', err);
        return false;
    }
};
const $6e3470033e29c0b4$export$137d41cfd295832b = async function(channelId) {
    const root = this.state.root;
    const me = root?.currentUserEmail;
    const cur = (root?.channelMembers || []).find((r)=>r.channel_id === channelId && r.member_email === me);
    return $6e3470033e29c0b4$export$d1702d46558e90d3.call(this, channelId, !cur?.muted);
};
const $6e3470033e29c0b4$export$f5b16b03df95f5f1 = (root, channelId)=>{
    if (!root || !channelId) return false;
    const me = root.currentUserEmail;
    const row = (root.channelMembers || []).find((r)=>r.channel_id === channelId && r.member_email === me);
    return !!row?.muted;
};

});


parcelRegister("lKCIH", function(module, exports) {

$parcel$export(module.exports, "createChannel", () => $fd5bedd07c29ba0b$export$47ab4c33d77e344d);
// Create a channel / DM / group DM and seed its membership rows. Used by
// NewChannelModal and by the "DM" button on PersonCard.

var $bfqVY = parcelRequire("bfqVY");

var $jg4vi = parcelRequire("jg4vi");
const $fd5bedd07c29ba0b$export$47ab4c33d77e344d = async function({ kind: kind = 'channel', name: name = null, topic: topic = null, isPrivate: isPrivate = false, memberEmails: memberEmails = [] }) {
    const root = this.state.root;
    const me = root.currentUserEmail;
    const sdk = (0, $bfqVY.getSDK)();
    const allMembers = Array.from(new Set([
        me,
        ...memberEmails
    ])).filter(Boolean);
    // For DMs, reuse an existing 1:1 channel between the same two emails if one
    // already exists — Slack-style. Group DMs (3+ members) reuse on exact set
    // match.
    if (kind === 'dm' || kind === 'group_dm') {
        const sortedKey = allMembers.slice().sort().join(',');
        const candidates = (root.channels || []).filter((c)=>c.kind === kind);
        for (const c of candidates){
            const cm = (root.channelMembers || []).filter((m)=>m.channel_id === c.id).map((m)=>m.member_email).sort().join(',');
            if (cm === sortedKey) return c.id;
        }
    }
    try {
        // migrated 2026-04-27 to SDK route workspaceProject.chat create
        // The wrapper's chat.createChannel may seed members server-side based on
        // the payload — we still post member rows below to make sure local state
        // reconciles correctly even if the wrapper is on an older deploy.
        const created = await sdk.execute('workspaceProject.chat', 'create', {
            payload: {
                kind: kind,
                name: name,
                topic: topic,
                is_private: isPrivate,
                created_by: me,
                members: allMembers
            }
        });
        const chRow = created?.data || created;
        const channel = (0, $jg4vi.rowToChannel)(chRow);
        const memberRows = allMembers.map((email)=>({
                channel_id: channel.id,
                member_email: email,
                role: email === me ? 'owner' : 'member'
            }));
        // migrated 2026-04-27 to SDK route workspaceProject.chat.members create
        // If the server already inserted the rows (idempotent on (channel,email)),
        // these calls are no-ops; if not, they ensure membership is seeded.
        await Promise.all(memberRows.map((row)=>sdk.execute('workspaceProject.chat.members', 'create', {
                channelId: channel.id,
                payload: row
            }).catch((err)=>{
                // Tolerate duplicate-row errors on the second insert path; surface
                // anything else to the outer catch.
                if (!/duplicate|already exists|conflict|409/i.test(err?.message || '')) throw err;
            })));
        // Guard against duplicates — realtime may push the same row.
        const existingChannels = root.channels || [];
        const alreadyExists = existingChannels.some((c)=>c.id === channel.id);
        root.update({
            channels: alreadyExists ? existingChannels : [
                ...existingChannels,
                channel
            ],
            channelMembers: [
                ...root.channelMembers || [],
                ...memberRows.map((r)=>({
                        ...r,
                        last_read_at: new Date().toISOString()
                    }))
            ],
            activeChannelId: channel.id,
            activeThreadRootId: null,
            activeTab: 'conversation',
            showNewChannel: false,
            newChannelDraft: {
                name: '',
                topic: '',
                kind: 'channel',
                is_private: false,
                members: []
            }
        });
        return channel.id;
    } catch (e) {
        console.error('[createChannel]', e?.message || e);
        return null;
    }
};

});

parcelRegister("7YjkX", function(module, exports) {

$parcel$export(module.exports, "updateChannel", () => $5cdd22eda4147644$export$31ee2f10399aafe8);
$parcel$export(module.exports, "archiveChannel", () => $5cdd22eda4147644$export$d5538795442bc1f5);
// Update channel fields (name, topic, is_private). Owner-only at the RLS
// layer. Returns the patched channel object, or null on failure.

var $bfqVY = parcelRequire("bfqVY");

var $jg4vi = parcelRequire("jg4vi");
const $5cdd22eda4147644$export$31ee2f10399aafe8 = async function(channelId, patch) {
    const root = this.state.root;
    if (!channelId || !patch) return null;
    const updates = {};
    if (patch.name !== undefined) updates.name = patch.name;
    if (patch.topic !== undefined) updates.topic = patch.topic;
    if (patch.is_private !== undefined) updates.is_private = patch.is_private;
    if (patch.is_archived !== undefined) updates.is_archived = patch.is_archived;
    try {
        // migrated 2026-04-27 to SDK route workspaceProject.chat update
        const result = await (0, $bfqVY.getSDK)().execute('workspaceProject.chat', 'update', {
            id: channelId,
            payload: updates
        });
        const ch = (0, $jg4vi.rowToChannel)(result?.data || result);
        const next = (root.channels || []).map((c)=>c.id === channelId ? ch : c);
        root.update({
            channels: next
        });
        return ch;
    } catch (err) {
        console.error('[updateChannel]', err);
        return null;
    }
};
const $5cdd22eda4147644$export$d5538795442bc1f5 = async function(channelId) {
    return $5cdd22eda4147644$export$31ee2f10399aafe8.call(this, channelId, {
        is_archived: true
    });
};

});

parcelRegister("9QyNN", function(module, exports) {

$parcel$export(module.exports, "messageUser", () => $72b3f761aa601c1e$export$e03a117874e0ae92);
// Open (or create) a 1:1 DM with the given email and switch the active
// channel to it. Used by the SharedPersonCard "Message" button on the chat
// home page so clicking a teammate's avatar takes you straight into a DM.

var $lKCIH = parcelRequire("lKCIH");
const $72b3f761aa601c1e$export$e03a117874e0ae92 = async function(email) {
    if (!email) return null;
    // Reuse createChannel's existing dedupe logic — same emails sorted = same DM.
    const id = await (0, $lKCIH.createChannel).call(this, {
        kind: 'dm',
        memberEmails: [
            email
        ]
    });
    if (!id) return null;
    const root = this.state.root;
    root.update({
        selectedPerson: null,
        activeChannelId: id,
        activeThreadRootId: null,
        activeTab: 'conversation'
    });
    return id;
};

});

parcelRegister("cjkU0", function(module, exports) {

$parcel$export(module.exports, "searchMessages", () => $8f6779293219ee89$export$219f1e8ed9be6c42);
$parcel$export(module.exports, "openSearch", () => $8f6779293219ee89$export$e0a0d6836ab230cc);
$parcel$export(module.exports, "closeSearch", () => $8f6779293219ee89$export$dd4db7a8de9ade16);
// Full-text search across all messages in channels the current user belongs
// to. Wraps the chat_search_messages SQL function added in 0014_chat_v2.

var $bfqVY = parcelRequire("bfqVY");
const $8f6779293219ee89$export$219f1e8ed9be6c42 = async function(query) {
    const root = this.state.root;
    const q = (query || '').trim();
    if (!q) {
        root.update({
            searchResults: [],
            searchQuery: ''
        });
        return;
    }
    try {
        // migrated 2026-04-27 to SDK route workspaceProject.chat.search rpc
        const result = await (0, $bfqVY.getSDK)().execute('workspaceProject.chat.search', 'rpc', {
            q: q,
            callerEmail: root.currentUserEmail
        });
        const data = result?.data ?? result ?? [];
        root.update({
            searchQuery: q,
            searchResults: Array.isArray(data) ? data : []
        });
    } catch (e) {
        console.error('[searchMessages]', e?.message || e);
        root.update({
            searchQuery: q,
            searchResults: []
        });
    }
};
const $8f6779293219ee89$export$e0a0d6836ab230cc = function() {
    this.state.root.update({
        searchOpen: true,
        searchQuery: '',
        searchResults: []
    });
};
const $8f6779293219ee89$export$dd4db7a8de9ade16 = function() {
    this.state.root.update({
        searchOpen: false,
        searchQuery: '',
        searchResults: []
    });
};

});

parcelRegister("8JkCi", function(module, exports) {

$parcel$export(module.exports, "renameChannel", () => $65b284baba0a1eb5$export$e46cf03ac68c3181);
$parcel$export(module.exports, "hideDM", () => $65b284baba0a1eb5$export$e8e549a6e284ef96);
$parcel$export(module.exports, "leaveChannel", () => $65b284baba0a1eb5$export$e6c41c8aa28ddeb9);
$parcel$export(module.exports, "pinToTop", () => $65b284baba0a1eb5$export$53a0e368e2e8a143);
$parcel$export(module.exports, "loadPinnedChannels", () => $65b284baba0a1eb5$export$e38c2a0645dc844a);
$parcel$export(module.exports, "inviteToChannel", () => $65b284baba0a1eb5$export$fa7602817427b62d);
$parcel$export(module.exports, "openChannelSettings", () => $65b284baba0a1eb5$export$25ae871ac1650689);
$parcel$export(module.exports, "startGroupChat", () => $65b284baba0a1eb5$export$9fd7652ba55bf976);
$parcel$export(module.exports, "convertToChannel", () => $65b284baba0a1eb5$export$da308ef2483725f2);
// Sidebar dropdown actions for channels, DMs, and group DMs.

var $bfqVY = parcelRequire("bfqVY");
const $65b284baba0a1eb5$export$e46cf03ac68c3181 = async function(channelId, newName) {
    const root = this?.state?.root;
    if (!root || !channelId || !newName) return;
    try {
        // migrated 2026-04-27 to SDK route workspaceProject.chat update
        await (0, $bfqVY.getSDK)().execute('workspaceProject.chat', 'update', {
            id: channelId,
            payload: {
                name: newName
            }
        });
    } catch (err) {
        console.error('[renameChannel]', err);
        return;
    }
    root.update({
        channels: (root.channels || []).map((c)=>c.id === channelId ? {
                ...c,
                name: newName
            } : c)
    });
};
const $65b284baba0a1eb5$export$e8e549a6e284ef96 = async function(channelId) {
    const root = this?.state?.root;
    if (!root || !channelId) return;
    const me = root.currentUserEmail;
    // Optimistic: remove from local channels list
    const hiddenSet = new Set(root._hiddenChannels || []);
    hiddenSet.add(channelId);
    root.update({
        _hiddenChannels: Array.from(hiddenSet),
        activeChannelId: root.activeChannelId === channelId ? null : root.activeChannelId
    });
};
const $65b284baba0a1eb5$export$e6c41c8aa28ddeb9 = async function(channelId) {
    const root = this?.state?.root;
    if (!root || !channelId) return;
    const me = root.currentUserEmail;
    try {
        // migrated 2026-04-27 to SDK route workspaceProject.chat.members remove
        await (0, $bfqVY.getSDK)().execute('workspaceProject.chat.members', 'remove', {
            channelId: channelId,
            userId: me
        });
    } catch (err) {
        console.error('[leaveChannel]', err);
        return;
    }
    root.update({
        channelMembers: (root.channelMembers || []).filter((m)=>!(m.channel_id === channelId && m.member_email === me)),
        channels: (root.channels || []).filter((c)=>c.id !== channelId),
        activeChannelId: root.activeChannelId === channelId ? null : root.activeChannelId
    });
};
// ── Pin to top — toggle pinned, persisted in localStorage ──
const $65b284baba0a1eb5$var$_PINNED_KEY = 'chat_pinned_channels';
const $65b284baba0a1eb5$var$_loadPinned = ()=>{
    try {
        return JSON.parse(localStorage.getItem($65b284baba0a1eb5$var$_PINNED_KEY) || '[]');
    } catch  {
        return [];
    }
};
const $65b284baba0a1eb5$var$_savePinned = (ids)=>{
    try {
        localStorage.setItem($65b284baba0a1eb5$var$_PINNED_KEY, JSON.stringify(ids));
    } catch  {}
};
const $65b284baba0a1eb5$export$53a0e368e2e8a143 = function(channelId) {
    const root = this?.state?.root;
    if (!root || !channelId) return;
    const current = new Set($65b284baba0a1eb5$var$_loadPinned());
    if (current.has(channelId)) current.delete(channelId);
    else current.add(channelId);
    const arr = Array.from(current);
    $65b284baba0a1eb5$var$_savePinned(arr);
    root.update({
        _pinnedChannels: arr
    });
};
const $65b284baba0a1eb5$export$e38c2a0645dc844a = function() {
    const root = this?.state?.root;
    if (!root) return;
    root.update({
        _pinnedChannels: $65b284baba0a1eb5$var$_loadPinned()
    });
};
const $65b284baba0a1eb5$export$fa7602817427b62d = function(channelId) {
    const root = this?.state?.root;
    if (!root || !channelId) return;
    const ch = (root.channels || []).find((c)=>c.id === channelId);
    if (!ch) return;
    root.update({
        showChannelSettings: channelId,
        channelSettingsTab: 'members'
    });
};
const $65b284baba0a1eb5$export$25ae871ac1650689 = function(channelId) {
    const root = this?.state?.root;
    if (!root || !channelId) return;
    root.update({
        showChannelSettings: channelId
    });
};
const $65b284baba0a1eb5$export$9fd7652ba55bf976 = function(channelId) {
    const root = this?.state?.root;
    if (!root || !channelId) return;
    const me = root.currentUserEmail;
    const members = (root.channelMembers || []).filter((m)=>m.channel_id === channelId && m.member_email !== me).map((m)=>m.member_email);
    root.update({
        showNewChannel: true,
        newChannelDraft: {
            kind: 'dm',
            name: '',
            topic: '',
            members: members,
            is_private: false
        }
    });
};
const $65b284baba0a1eb5$export$da308ef2483725f2 = function(channelId) {
    const root = this?.state?.root;
    if (!root || !channelId) return;
    const me = root.currentUserEmail;
    const members = (root.channelMembers || []).filter((m)=>m.channel_id === channelId && m.member_email !== me).map((m)=>m.member_email);
    root.update({
        showNewChannel: true,
        newChannelDraft: {
            kind: 'channel',
            name: '',
            topic: '',
            members: members,
            is_private: false
        }
    });
};

});

parcelRegister("2lygP", function(module, exports) {

$parcel$export(module.exports, "toggleChatBookmark", () => $1b58205054c5b4aa$export$11ddbc8a40fdc81b);
$parcel$export(module.exports, "toggleChatPin", () => $1b58205054c5b4aa$export$672c85ddd7f6c4b7);
// Client-side chat bookmark + pin id sets. Persists to localStorage so
// state survives reload until a server-side schema lands.
const $1b58205054c5b4aa$var$_BOOKMARKS_KEY = 'chat_bookmarked_msg_ids';
const $1b58205054c5b4aa$var$_PINS_KEY = 'chat_pinned_msg_ids';
const $1b58205054c5b4aa$var$_loadIds = (key)=>{
    try {
        const raw = typeof localStorage !== 'undefined' && localStorage.getItem(key);
        const parsed = raw ? JSON.parse(raw) : null;
        return Array.isArray(parsed) ? parsed : [];
    } catch  {
        return [];
    }
};
const $1b58205054c5b4aa$var$_saveIds = (key, ids)=>{
    try {
        if (typeof localStorage !== 'undefined') localStorage.setItem(key, JSON.stringify(ids));
    } catch  {}
};
const $1b58205054c5b4aa$var$_toggle = (ids, msgId)=>{
    const i = ids.indexOf(msgId);
    return i === -1 ? [
        ...ids,
        msgId
    ] : ids.filter((id)=>id !== msgId);
};
const $1b58205054c5b4aa$var$_toggler = (fieldKey, storageKey)=>function(msgId) {
        const root = this.state.root;
        if (!root || !msgId) return;
        const next = $1b58205054c5b4aa$var$_toggle(root[fieldKey] || $1b58205054c5b4aa$var$_loadIds(storageKey), msgId);
        $1b58205054c5b4aa$var$_saveIds(storageKey, next);
        root.update({
            [fieldKey]: next
        });
    };
const $1b58205054c5b4aa$export$11ddbc8a40fdc81b = $1b58205054c5b4aa$var$_toggler('chatBookmarkedMsgIds', $1b58205054c5b4aa$var$_BOOKMARKS_KEY);
const $1b58205054c5b4aa$export$672c85ddd7f6c4b7 = $1b58205054c5b4aa$var$_toggler('chatPinnedMsgIds', $1b58205054c5b4aa$var$_PINS_KEY);

});


parcelRegister("eZ6La", function(module, exports) {

$parcel$export(module.exports, "useOnlinePresence", () => $ae8c018b77bf6891$export$90653880a65d6508);
// useOnlinePresence — register as a project function so pages can call it
// via el.call('useOnlinePresence') from onCreate. Returns a cleanup
// function to call from onRemove.
//
// Every caller subscribes to a single shared channel (`presence:symbols`)
// so the CalOnlineUsersBar surface reflects presence across the entire
// editor and governance suite — calendar, tickets, documents, canvas,
// workspaces. The optional `app` tag is tracked as presence metadata for
// per-app breakdowns later; it no longer scopes the channel itself.
//
// migrated 2026-04-27 to SDK realtime — `workspaceProject.realtime.presence`
// dispatches through the SDK's transport-agnostic API. Today's transport
// is Supabase realtime via supabaseRealtimeProvider in bootShell; when
// backend ships native socket.io realtime alongside CollabService, swap
// the provider — this file doesn't change.

var $bfqVY = parcelRequire("bfqVY");
// One subscription + one cleanup per browser tab — no matter how many
// pages call useOnlinePresence, they all join the same shared presence
// stream instead of clobbering each other's `root.onlineUsers`.
let $ae8c018b77bf6891$var$_cleanup = null;
function $ae8c018b77bf6891$export$90653880a65d6508({ app: app = 'symbols' } = {}) {
    const el = this;
    const root = el.state.root;
    const me = root.currentUserEmail;
    if (!me) return ()=>{};
    if ($ae8c018b77bf6891$var$_cleanup) return $ae8c018b77bf6891$var$_cleanup;
    let _unsub = null;
    let _cancelled = false;
    // Resolve the workspaceProject service via the SDK proxy and subscribe.
    // The proxy auto-awaits SDK init, so this works even when called early
    // in onCreate before init has settled.
    Promise.resolve((0, $bfqVY.getSDK)().getService?.('workspaceProject')).then((wp)=>{
        if (_cancelled || !wp?.realtime?.subscribePresence) return;
        _unsub = wp.realtime.subscribePresence({
            scope: 'symbols',
            userKey: me,
            meta: {
                app: app
            }
        }, (event, data)=>{
            // The SDK provider forwards Supabase presence events as
            // ('sync'|'join'|'leave', payload). Re-derive the full online
            // list on each event so root.onlineUsers stays the canonical view.
            if (event === 'sync') {
                const state = data?.state || {};
                const seen = new Set();
                const list = [];
                for (const key of Object.keys(state)){
                    if (seen.has(key)) continue;
                    seen.add(key);
                    const meta = state[key]?.[0] || {};
                    list.push({
                        email: key,
                        since: meta.online_at || Date.now(),
                        app: meta.app || null
                    });
                }
                root.update({
                    onlineUsers: list
                });
            }
        // join/leave are followed by their own sync — no work needed here.
        });
    }).catch((err)=>{
        console.warn('[useOnlinePresence] subscribe failed:', err?.message || err);
    });
    $ae8c018b77bf6891$var$_cleanup = ()=>{
        $ae8c018b77bf6891$var$_cleanup = null;
        _cancelled = true;
        if (typeof _unsub === 'function') try {
            _unsub();
        } catch (_) {}
    };
    return $ae8c018b77bf6891$var$_cleanup;
}

});

parcelRegister("bdXMy", function(module, exports) {

$parcel$export(module.exports, "openInstallableModal", () => $82bf481bd2545477$export$3f6180825f28be87);
// openInstallableModal — Phase 4 real implementation.
//
// Registered as a shared function so el.call('openInstallableModal', opts)
// resolves from InstallableRail.js, InstallableRailItem.js, canvas tiles,
// dashboard, admin, and any other surface that needs to trigger the
// MarketplaceInstallModal without owning a marketplace island.
//
// Replaces the Phase 3 stub (which only console.warn'd + set root.state._installableModal).
//
// Delegation strategy:
//   1. Try to find a marketplace host via the marketplaceHostOf walk
//      (works when called from inside or adjacent to a MarketplaceIsland).
//   2. Fall back to root.state when outside a marketplace island — the
//      InstallableModalStub mounted at the app root also listens to
//      root.state._installableModal so it can show a fallback modal.
//   3. When a marketplace host IS found, delegate directly to the full
//      MarketplaceInstallModal via host.update({ installModal: ... }).
//
// Args:
//   domain        – 'integration'|'library'|'mcp'|'plugin'|'template'
//   kind          – kind key string (= preselectedKind), e.g. 'github'
//   installed     – boolean (true = manage flow, false = install flow)
//   defaultScope  – { type: 'org'|'workspace'|'project', id: string }
//   catalogFilter – filter object (category, applicable_to_types, applicable_to_scopes)
//   onInstalled   – (instance) => void callback
//
// Contract is the same as marketplace's openInstallableModal — this module
// is the single shared registration point; the marketplace package contains
// the full logic.
// Walk up to find a marketplace host element (same algorithm as
// marketplaceHostOf in marketplace/functions/index.js, duplicated
// here to avoid cross-package imports).
const $82bf481bd2545477$var$_findMarketplaceHost = (el)=>{
    let cur = el;
    let lastWithState = null;
    while(cur){
        if (cur._marketplaceHost && cur.state) return cur.state;
        if (cur.state) lastWithState = cur;
        if (!cur.parent) break;
        cur = cur.parent;
    }
    return lastWithState?.state || el?.state || null;
};
// Resolve item from catalogue by kind slug.
// Mirrors the slug-matching logic in marketplace/functions/index.js
// so the lookup works regardless of which package this is called from.
const $82bf481bd2545477$var$_slugForId = (id)=>String(id || '').replace(/^(int|reg|plg|tpl|lib)\./, '').replace(/-/g, '_');
const $82bf481bd2545477$var$_findItemByKind = (catalog, kind)=>{
    if (!Array.isArray(catalog) || !kind) return null;
    return catalog.find((i)=>{
        const s = $82bf481bd2545477$var$_slugForId(i.id);
        return s === kind || i.id === kind || i.id === `int.${kind}` || i.id === `plg.${kind}` || i.id === `lib.${kind}` || i.id === `tpl.${kind}`;
    }) || null;
};
// Check catalogFilter against an item. Returns error string or null.
const $82bf481bd2545477$var$_checkCatalogFilter = (item, catalogFilter)=>{
    if (!catalogFilter || !item) return null;
    if (catalogFilter.category && item.category !== catalogFilter.category) return `This item is in the "${item.category}" category, not "${catalogFilter.category}".`;
    if (Array.isArray(catalogFilter.applicable_to_types) && catalogFilter.applicable_to_types.length > 0) {
        const itemTypes = item._liveKind?.applicable_to_types || [];
        const overlap = catalogFilter.applicable_to_types.some((t)=>itemTypes.includes(t));
        if (!overlap) return `This item does not apply to the required type(s): ${catalogFilter.applicable_to_types.join(', ')}.`;
    }
    if (Array.isArray(catalogFilter.applicable_to_scopes) && catalogFilter.applicable_to_scopes.length > 0) {
        const itemScopes = item._liveKind?.applicable_to_scopes || [];
        const overlap = catalogFilter.applicable_to_scopes.some((s)=>itemScopes.includes(s));
        if (!overlap) return `This item does not apply to the required scope(s): ${catalogFilter.applicable_to_scopes.join(', ')}.`;
    }
    return null;
};
function $82bf481bd2545477$export$3f6180825f28be87(opts) {
    const el = this;
    const domain = opts?.domain || null;
    const kind = opts?.kind || opts?.preselectedKind || null;
    const installed = !!opts?.installed;
    const defaultScope = opts?.defaultScope || null;
    const catalogFilter = opts?.catalogFilter || null;
    const onInstalled = typeof opts?.onInstalled === 'function' ? opts.onInstalled : null;
    // 1. Walk element tree to find a MarketplaceIsland host.
    let host = null;
    try {
        host = $82bf481bd2545477$var$_findMarketplaceHost(el);
    } catch  {}
    // 2. Fall back to root.state when outside a marketplace island.
    if (!host) try {
        const root = el.getRoot?.();
        if (root?.state) host = root.state;
    } catch  {}
    if (!host) {
        console.warn('[openInstallableModal] Could not resolve host state. opts:', opts);
        return;
    }
    const catalog = host.catalog || [];
    // 3. Resolve the item from catalogue.
    let item = null;
    if (kind) {
        item = $82bf481bd2545477$var$_findItemByKind(catalog, kind);
        if (!item) {
            // Kind not found in catalogue — open modal with catalogError.
            host.update?.({
                installModal: {
                    item: {
                        name: kind,
                        id: kind,
                        kind: domain || 'integration'
                    },
                    step: 'config',
                    draft: {},
                    domain: domain,
                    defaultScope: defaultScope,
                    catalogFilter: catalogFilter,
                    onInstalled: onInstalled,
                    _catalogError: `"${kind}" is not available in the current catalogue. ` + 'See /admin-integration-kinds if you need to add it.'
                },
                _installModalError: null
            });
            return;
        }
        // 4. Validate catalogFilter against the found item.
        const filterError = $82bf481bd2545477$var$_checkCatalogFilter(item, catalogFilter);
        if (filterError) {
            host.update?.({
                installModal: {
                    item: item,
                    step: 'config',
                    draft: {},
                    domain: domain,
                    defaultScope: defaultScope,
                    catalogFilter: catalogFilter,
                    onInstalled: onInstalled,
                    _catalogError: filterError
                },
                _installModalError: null
            });
            return;
        }
    }
    // 5. Build initial draft — apply defaultScope if provided.
    const draft = {};
    if (defaultScope?.type) {
        draft.scopeType = defaultScope.type;
        if (defaultScope.id) draft.scopeId = defaultScope.id;
    } else if (item?._liveKind?.default_scope) draft.scopeType = item._liveKind.default_scope;
    // 6. Determine opening step.
    const openStep = defaultScope || installed ? 'config' : 'scope';
    host.update?.({
        installModal: {
            item: item || null,
            step: openStep,
            draft: draft,
            domain: domain,
            defaultScope: defaultScope,
            catalogFilter: catalogFilter,
            onInstalled: onInstalled,
            _catalogError: null
        },
        _installModalError: null
    });
}

});

parcelRegister("9XTDn", function(module, exports) {

$parcel$export(module.exports, "bootShell", () => $7414c782b8c90a2a$export$32c1b9ba1bdf9c70);
/**
 * bootShell — universal boot used by runner + standalones.
 *
 * Phase 7: dispatchUrl and wireGlobalListeners stubs removed.
 * The caller (workspace/packages/workspace/index.js or a standalone
 * app's index.js) is responsible for calling dispatchUrl + wireGlobalListeners
 * AFTER bootShell returns the shell element.
 *
 * Pattern A (single-app standalones): when `apps` has exactly one entry and
 * no pre-built `context` is supplied, bootShell resolves the manifest's `app`
 * and `context` factories, mounts the shell, then auto-dispatches the current
 * URL and wires popstate. Standalone wrappers stay tiny — one bootShell call,
 * no extra imports. Multi-app shells (workspace/index.js) continue to call
 * dispatchUrl + wireGlobalListeners explicitly after bootShell returns.
 *
 * Sequence handled here:
 *  1. Early lang/theme from localStorage
 *  2. (Polyglot init — caller responsibility before bootShell)
 *  3. (ensureSDKInit — caller responsibility, or pass pre-init sdk)
 *  4. registerSdkAdapter({ sdk })
 *  5. Build/merge context state
 *  6. Auth gate via sdk.auth.getMe() — unauthed → /login, returns null
 *  7. Eager USER + ORG + WORKSPACE + WORKSPACE_PROJECT scope fetch
 *  8. Mount shell via create(app, context) — returns shell element
 *  9. [single-app only] dispatchUrl(shell, path) — initial route
 * 10. [single-app only] wireGlobalListeners(shell, ...) — popstate + storage
 *
 * Multi-app callers then:
 *  9. dispatchUrl(shell, path) — initial route (workspace/dispatch.js)
 * 10. wireGlobalListeners(shell, ...) — popstate + storage (workspace/wireGlobalListeners.js)
 */ 
var $5RqIx = parcelRequire("5RqIx");

var $bfqVY = parcelRequire("bfqVY");

var $lBs1G = parcelRequire("lBs1G");

var $iikzf = parcelRequire("iikzf");
/**
 * Minimal single-app dispatch + popstate wiring used when bootShell
 * auto-boots a standalone (single-entry apps map).
 *
 * Routes are sourced from the manifest's `routes` array (RegExp or string).
 * If the current path matches, the manifest's `app` factory is invoked and
 * the result is set into shell.Slot (if present) or rendered as the root.
 * Falls back to fallbackRoute when no match is found.
 *
 * This is intentionally simpler than workspace/dispatch.js — standalones
 * mount a single app and don't need a multi-app dispatch table.
 */ const $7414c782b8c90a2a$var$_singleAppDispatch = async (shell, manifest, path)=>{
    const routes = manifest.routes || [];
    const matched = routes.some((r)=>{
        if (r instanceof RegExp) return r.test(path);
        if (typeof r === 'string') return r === path;
        return false;
    });
    // No route match on initial load is fine — the DOMQL router inside the
    // mounted app handles path-based page selection once the app is live.
    // We just need the app mounted; the router reads window.location itself.
    if (shell.Slot && typeof shell.Slot.set === 'function') {
        // Multi-slot shell: set the app into the Slot
        const appDef = await manifest.app?.().catch(()=>null);
        if (appDef) shell.Slot.set(appDef);
    }
// If there is no Slot, the app is already mounted as the root (create()
// used context.app directly). Nothing more to do for dispatch.
};
/**
 * Minimal popstate wiring for single-app standalones.
 * Re-dispatches on browser back/forward.
 */ const $7414c782b8c90a2a$var$_singleAppWireListeners = (shell, manifest)=>{
    window.addEventListener('popstate', ()=>{
        const path = window.location.pathname + window.location.search;
        $7414c782b8c90a2a$var$_singleAppDispatch(shell, manifest, path);
    });
};

const $7414c782b8c90a2a$export$32c1b9ba1bdf9c70 = async ({ apps: apps, defaultApp: defaultApp, fallbackRoute: fallbackRoute, sdk: sdk, context: context, publicSurface: publicSurface = false })=>{
    // Pattern A: single-app standalone — resolve manifest factories eagerly
    // so the shell is created with a real app + context instead of an empty
    // placeholder. Multi-app callers always supply a pre-built context, so
    // this branch is only entered for standalones.
    const appKeys = Object.keys(apps || {});
    const isSingleApp = appKeys.length === 1 && !context;
    let resolvedManifest = null;
    if (isSingleApp) {
        resolvedManifest = apps[appKeys[0]];
        // Resolve context factory if the manifest provides one
        const manifestContext = typeof resolvedManifest.context === 'function' ? await resolvedManifest.context().catch(()=>({})) : resolvedManifest.context || {};
        // Resolve app factory if context.app is not already set
        if (!manifestContext.app && typeof resolvedManifest.app === 'function') manifestContext.app = await resolvedManifest.app().catch(()=>({}));
        context = manifestContext;
    }
    // Default to empty context when neither caller nor manifest provides one
    if (!context) context = {};
    // 1. Early lang/theme from localStorage
    const lang = localStorage.getItem('lang') || 'en';
    const themeMode = localStorage.getItem('themeMode') || 'auto';
    // WCAG 3.1.1 — `<html lang="...">` is required for screen readers.
    // Set as early as possible so any pre-render announce uses the right
    // pronunciation. Re-applied later when `state.lang` changes via the
    // context language-watch effect.
    if (typeof document !== 'undefined' && document.documentElement) document.documentElement.lang = lang;
    if (context.state) {
        context.state.lang = lang;
        context.state.themeMode = themeMode;
        // Ensure auxiliary state fields that shared helpers depend on are
        // initialized. openNotification pushes into `notifications`; guard
        // in case the standalone state factory didn't include the field.
        if (!Array.isArray(context.state.notifications)) context.state.notifications = [];
    }
    // Pattern B: auto-SDK instantiation.
    // Fires when no explicit `sdk` is passed AND either:
    //   (a) isSingleApp — standalone wrapper (one-entry apps map, no pre-built context), OR
    //   (b) the resolved context carries workspaceApiUrl — multi-app shell that
    //       explicitly opts into SDK wiring via its context.js export.
    //
    // This covers the workspace shell (workspace/packages/workspace/) which passes
    // 5 apps + a pre-built context, so isSingleApp=false, but still needs the SDK
    // to authenticate, fetch scopes, and expose el.sdk to sub-app components.
    // The multi-app explicit-sdk path is preserved: pass `sdk` param explicitly to
    // skip this block entirely (e.g. tests, custom shells).
    const needsSdkInit = isSingleApp || !sdk && context?.workspaceApiUrl;
    if (!sdk && needsSdkInit) try {
        sdk = (0, $bfqVY.getSDK)();
    } catch (err) {
        console.warn('[bootShell] SDK init failed:', err?.message || err);
    }
    // 4. Register sdk fetch adapter (proxy passes calls through; safe pre-init).
    if (sdk) (0, $5RqIx.registerSdkAdapter)({
        sdk: sdk
    });
    // 6. Auth gate — public auth routes must render to unauthed users
    // MUST await SDK init before reading service-proxied methods: the SDK
    // populates flat method proxies (sdk.getMe, sdk.login, …) inside
    // _createServiceProxies which only runs during initialize(). Without
    // this await, sdk.getMe() can be undefined → TypeError → bounce to
    // /login even though localStorage tokens are valid. (Cookies are
    // dropped on .localhost by Chrome — localStorage is the source of
    // truth in dev.)
    const PUBLIC_AUTH_ROUTE = /^\/(login|signin|signup|signup-confirmation|reset-password|forgot-password|verify-email)(\/|$)/;
    if (sdk) {
        await (0, $bfqVY.awaitSDKInit)();
        // Attach SDK to context.methods AFTER init so DOMQL exposes el.sdk only
        // when service proxies (sdk.getMe, sdk.login, …) are populated. Reactive
        // factories that read el.sdk on first render won't see a half-built proxy.
        if (!context.methods) context.methods = {};
        if (typeof context.methods !== 'object') context.methods = {};
        context.methods.sdk = sdk;
        // Wire realtime provider — SDK exposes a transport-agnostic
        // `workspaceProject.realtime.*` API; the provider plugs in the
        // governance Supabase realtime channel as the actual wire. When
        // backend ships native socket.io realtime alongside CollabService,
        // swap the provider here without touching any consumer.
        try {
            const wp = sdk.getService?.('workspaceProject');
            if (wp && typeof wp.setRealtimeProvider === 'function') wp.setRealtimeProvider((0, $lBs1G.supabaseRealtimeProvider));
        } catch (err) {
            console.warn('[bootShell] could not wire realtime provider:', err?.message || err);
        }
        // Auth diagnostic — one snapshot on boot so the cause of any /workspace/*
        // 401s is obvious in the console without paste-and-decode gymnastics.
        // Also exposed as window.__auth.diagnose() for on-demand re-checks.
        try {
            const dx = (0, $iikzf.diagnoseAuth)();
            if (typeof window !== 'undefined') {
                window.__auth = window.__auth || {};
                window.__auth.diagnose = (0, $iikzf.runAuthDiagnostic);
                window.__auth.snapshot = dx;
            }
            // `all_missing` on cold load is a false positive — Supabase auth-js
            // hydrates `sb-*-auth-token` asynchronously after the page bootstraps.
            // Defer the warning by a tick and re-check; only log if the state
            // actually persists. Other diagnoses (sdk_only, governance_expired,
            // missing_claim) reflect real broken half-states and log immediately.
            if (dx.diagnosis === 'all_missing') setTimeout(()=>{
                const dx2 = (0, $iikzf.diagnoseAuth)();
                if (typeof window !== 'undefined') window.__auth.snapshot = dx2;
                if (dx2.diagnosis !== 'ok' && dx2.diagnosis !== 'all_missing') console.warn(`[bootShell] auth diagnostic: ${dx2.diagnosis} \u{2014} ${dx2.suggestedAction}`, dx2.governance);
                else if (dx2.diagnosis === 'all_missing') console.warn(`[bootShell] auth diagnostic: ${dx2.diagnosis} \u{2014} ${dx2.suggestedAction}`, dx2.governance);
            }, 250);
            else if (dx.diagnosis !== 'ok') console.warn(`[bootShell] auth diagnostic: ${dx.diagnosis} \u{2014} ${dx.suggestedAction}`, dx.governance);
            // Auto-recover from broken half-login states. SDK token without a
            // governance JWT means every /workspace/* call 401s — clear the
            // stale tokens so the auth gate redirects to /login and a fresh
            // loginAll re-mints both. Skips if already on /login to avoid loops.
            if (typeof window !== 'undefined' && (dx.diagnosis === 'sdk_only' || dx.diagnosis === 'governance_expired') && !/^\/(login|signin|signup|reset-password|forgot-password)/.test(window.location.pathname)) {
                try {
                    sdk.logout?.();
                } catch (_) {}
                try {
                    const supaRefs = Object.keys(localStorage).filter((k)=>k.startsWith('sb-') || k.startsWith('symbols_'));
                    for (const k of supaRefs)localStorage.removeItem(k);
                } catch (_) {}
                const next = encodeURIComponent(window.location.pathname + window.location.search);
                window.location.replace(`/login?next=${next}`);
                return null;
            }
        } catch (err) {
            console.warn('[bootShell] auth diagnostic failed:', err?.message || err);
        }
        // SDK proxies service methods directly onto the SDK instance via
        // _createServiceProxies — there is no `sdk.auth` namespace. AuthService
        // method `getMe` is exposed as flat `sdk.getMe()`. (See
        // sdk/src/utils/services.js SERVICE_METHODS map: getMe → 'auth'.)
        //
        // Skip the network round-trip when no token exists in localStorage —
        // we already know the answer is "not authed", and firing the request
        // surfaces a misleading 401 (Unauthorized) on the landing page for
        // logged-out users.
        let me = null;
        const _hasSdkToken = typeof window !== 'undefined' && !!(window.localStorage.getItem('symbols_access_token') || window.localStorage.getItem('symbols_bridge_access_token'));
        if (_hasSdkToken) try {
            me = await sdk.getMe();
        } catch (e) {
            console.warn('[bootShell] auth gate getMe failed:', e?.message);
        }
        if (!me) {
            // `publicSurface: true` opts out of the auth bounce — used by the
            // preview app, which serves visibility-gated PUBLIC snapshots and
            // must render for logged-out users. The fetch path inside preview
            // surfaces its own "not public" UI when the project gate denies.
            if (publicSurface) {
                if (context.state) context.state.user = null;
            } else {
                if (!PUBLIC_AUTH_ROUTE.test(window.location.pathname)) window.history.replaceState(null, '', '/login');
                return null;
            }
        } else if (context.state) context.state.user = me;
    }
    // 7. Eager scope fetch — ORG + WORKSPACE.
    // SDK exposes service methods FLAT (sdk.getOrganization, sdk.getWorkspace);
    // the previous sdk.organization?.get?.() chain was dead code — optional
    // chaining short-circuited on the missing namespace, returning undefined
    // and silently leaving state.org/workspace null. That null forced sub-apps
    // to refetch on render, which is one of the storm root causes.
    // workspaceProject has no get-by-id flat method (the service exposes
    // nested namespaces — tickets, chat, etc.) so we no longer attempt to
    // hydrate state.workspaceProject here.
    // Skip the eager scope fetch when running as a public surface (no
    // user) — the org/workspace lookups would 401 and waste a round-trip.
    if (sdk && context.state && context.state.user) {
        const activeOrgId = localStorage.getItem('activeOrg');
        const activeWorkspaceId = localStorage.getItem('activeWorkspace');
        const scopeFetches = [];
        if (activeOrgId && typeof sdk.getOrganization === 'function') scopeFetches.push(Promise.resolve(sdk.getOrganization(activeOrgId)).then((res)=>{
            context.state.org = res?.data || res || null;
        }).catch(()=>null));
        if (activeWorkspaceId && typeof sdk.getWorkspace === 'function') scopeFetches.push(Promise.resolve(sdk.getWorkspace(activeWorkspaceId)).then((res)=>{
            context.state.workspace = res?.data || res || null;
        }).catch(()=>null));
        await Promise.all(scopeFetches);
    }
    // 8. Mount shell
    // The context.app is the shell DOMQL root component (app.js default export).
    // If context.app is not set, fall back to a minimal empty object so
    // bootShell is still usable in tests without a full app definition.
    // Pass the project's themeMode so smbls' resolveAndApplyTheme uses our
    // storage key — otherwise the framework default ('symbols.theme') and our
    // 'themeMode' key drift, leaving `data-theme` stuck on whatever was last
    // forced even when the user has reset to 'auto'. Setting `globalTheme`
    // explicitly here also ensures the framework removes `data-theme` when
    // mode is 'auto' so prefers-color-scheme takes over live (per CLAUDE.md
    // global-theme contract).
    const { create: create } = await Promise.resolve((parcelRequire("8augU")));
    const shellApp = context.app || {};
    const shell = create(shellApp, {
        ...context,
        globalTheme: themeMode,
        themeStorageKey: 'themeMode'
    });
    // 9-10. Pattern A: single-app auto-dispatch + listener wiring.
    // Multi-app callers (workspace/index.js) handle steps 9-10 themselves
    // by calling dispatchUrl + wireGlobalListeners after bootShell returns.
    if (isSingleApp && resolvedManifest) {
        const path = window.location.pathname + window.location.search;
        await $7414c782b8c90a2a$var$_singleAppDispatch(shell, resolvedManifest, path);
        $7414c782b8c90a2a$var$_singleAppWireListeners(shell, resolvedManifest);
    }
    return shell;
};

});
parcelRegister("5RqIx", function(module, exports) {

$parcel$export(module.exports, "registerSdkAdapter", () => $4446a07bfd1b1497$export$6084c72ef9d6e870);
/**
 * @symbo.ls/fetch sdk adapter (registered, not built-in).
 *
 * Routes DOMQL `fetch:` declarations through @symbo.ls/sdk's EntityDispatcher
 * so workspace UI never speaks to a backend other than the SDK. Follows the
 * same `setup(options) → adapterObject` contract as the supabase / rest /
 * local builtin adapters, but ships from the workspace package because the
 * SDK is a peer concern (not a transport).
 *
 * Registration: call `registerSdkAdapter()` once at boot — it adds the
 * factory to @symbo.ls/fetch's runtime adapter registry. Then any project
 * config can opt in with:
 *
 *   fetch: { adapter: 'sdk', sdk: getSDK() }
 *   // or, if you'd rather hand over just the dispatcher:
 *   fetch: { adapter: 'sdk', executor: (from, op, args, cb) => sdk.execute(from, op, args, cb) }
 *
 * Argument shape — adapter packs every call into a single object whose
 * fields the EntityDispatcher's per-route `argMap` extracts into the
 * positional shape the underlying service method expects. Aliases are
 * provided so argMaps written for either `params`/`filter` or
 * `data`/`payload` work uniformly:
 *
 *   - select  → { filter, params, single, limit, offset, order, options, ...params }
 *   - insert  → { payload, data, ...params }
 *   - update  → { id, number, payload, data, ...params }
 *   - delete  → { id, number, ...params }
 *   - rpc     → params forwarded as-is
 *   - sub     → { ...params, filter }
 *
 * SDK init wait — the SDK proxy in shared/functions/sdk.js auto-awaits
 * SDK init for every method call, so `sdk.execute(...)` returns a Promise.
 * Subscribe handles this with a cancel-token shim: a sync unsubscribe fn
 * is returned immediately and the real teardown is wired up when the
 * dispatcher's promise resolves.
 */ 
var $fLrnc = parcelRequire("fLrnc");
const $4446a07bfd1b1497$var$_settle = (p)=>Promise.resolve(p).then((d)=>({
            data: d,
            error: null
        })).catch((error)=>({
            data: null,
            error: error
        }));
const $4446a07bfd1b1497$var$_packSelect = ({ params: params, single: single, limit: limit, offset: offset, order: order, options: options })=>({
        filter: params,
        params: params,
        single: single,
        limit: limit,
        offset: offset,
        order: order,
        options: options,
        ...params || {}
    });
const $4446a07bfd1b1497$var$_packCreate = ({ data: data, params: params })=>({
        payload: data,
        data: data,
        ...params || {}
    });
const $4446a07bfd1b1497$var$_packUpdate = ({ params: params, data: data })=>({
        id: params?.id ?? params?.number,
        number: params?.number ?? params?.id,
        payload: data,
        data: data,
        ...params || {}
    });
const $4446a07bfd1b1497$var$_packDelete = ({ params: params })=>({
        id: params?.id ?? params?.number,
        number: params?.number ?? params?.id,
        ...params || {}
    });
const $4446a07bfd1b1497$export$fa32832e16ed797d = (options = {})=>{
    const executor = typeof options.executor === 'function' ? options.executor : options.sdk && typeof options.sdk.execute === 'function' ? options.sdk.execute.bind(options.sdk) : null;
    if (!executor) throw new Error("@symbo.ls/fetch sdk adapter: pass { sdk } (an SDK instance with .execute) or { executor } (a function with the same signature) in your fetch config.");
    const exec = (from, op, args, cb)=>executor(from, op, args, cb);
    return {
        name: 'sdk',
        select: (cfg)=>$4446a07bfd1b1497$var$_settle(exec(cfg.from, 'list', $4446a07bfd1b1497$var$_packSelect(cfg))).then(({ data: data, error: error })=>({
                    data: cfg.single ? Array.isArray(data) ? data[0] : data : data,
                    error: error
                })),
        rpc: (cfg)=>$4446a07bfd1b1497$var$_settle(exec(cfg.from, 'rpc', cfg.params)),
        insert: (cfg)=>$4446a07bfd1b1497$var$_settle(exec(cfg.from, 'create', $4446a07bfd1b1497$var$_packCreate(cfg))),
        update: (cfg)=>$4446a07bfd1b1497$var$_settle(exec(cfg.from, 'update', $4446a07bfd1b1497$var$_packUpdate(cfg))),
        delete: (cfg)=>$4446a07bfd1b1497$var$_settle(exec(cfg.from, 'remove', $4446a07bfd1b1497$var$_packDelete(cfg))),
        // Subscribe must return a sync unsubscribe — fetch plugin assigns it
        // to ref.__unsubscribe immediately. SDK proxy may make exec() async;
        // cancel-token shim resolves both cases.
        subscribe: (cfg, cb)=>{
            let unsub = null;
            let cancelled = false;
            Promise.resolve(exec(cfg.from, 'subscribe', {
                ...cfg.params || {},
                filter: cfg.params
            }, cb)).then((sub)=>{
                if (cancelled) {
                    if (typeof sub === 'function') try {
                        sub();
                    } catch (_) {}
                    else if (sub?.unsubscribe) try {
                        sub.unsubscribe();
                    } catch (_) {}
                    return;
                }
                unsub = typeof sub === 'function' ? sub : sub?.unsubscribe ? ()=>sub.unsubscribe() : null;
            }).catch(()=>{});
            return ()=>{
                cancelled = true;
                if (typeof unsub === 'function') try {
                    unsub();
                } catch (_) {}
            };
        },
        // Auth bridges — `fetch: { from: 'auth.session', method: 'subscribe' }`
        // routes through SDK's onAuthStateChange via the dispatcher.
        getSession: ()=>Promise.resolve(exec('auth.session', 'list')).catch(()=>null),
        onAuthStateChange: (cb)=>{
            let unsub = null;
            let cancelled = false;
            Promise.resolve(exec('auth.session', 'subscribe', null, cb)).then((sub)=>{
                if (cancelled) {
                    if (typeof sub === 'function') try {
                        sub();
                    } catch (_) {}
                    return;
                }
                unsub = typeof sub === 'function' ? sub : null;
            }).catch(()=>{});
            return ()=>{
                cancelled = true;
                if (typeof unsub === 'function') try {
                    unsub();
                } catch (_) {}
            };
        }
    };
};
const $4446a07bfd1b1497$export$de27182ff8187d6c = async (options = {})=>$4446a07bfd1b1497$export$fa32832e16ed797d(options);
const $4446a07bfd1b1497$export$6084c72ef9d6e870 = (boundOptions = {})=>{
    (0, $fLrnc.registerAdapter)('sdk', ()=>Promise.resolve({
            setup: (decl = {})=>$4446a07bfd1b1497$export$fa32832e16ed797d({
                    ...boundOptions,
                    ...decl
                })
        }));
};

});

parcelRegister("lBs1G", function(module, exports) {

$parcel$export(module.exports, "supabaseRealtimeProvider", () => $fba2cb112cd3ddb5$export$5e41e9c807fbc549);
/**
 * sdkRealtimeProvider — Supabase-realtime backend for the SDK's
 * `workspaceProject.realtime.*` API surface.
 *
 * Wired into the SDK at boot via
 * `(await sdk.getService('workspaceProject')).setRealtimeProvider(supabaseRealtimeProvider)`.
 * Once installed, every consumer using
 *   `sdk.execute('workspaceProject.realtime.<entity>', 'subscribe', filter, cb)`
 * gets live events through the governance Supabase realtime channel — no
 * other code path needed.
 *
 * Why this is here and not in the SDK package: the provider depends on
 * `@symbo.ls/sdk-bridge`'s `getRealtimeSupabase()` (browser-tier WebSocket
 * client). Keeping the wire-protocol adapter in the workspace shell keeps
 * the SDK transport-agnostic — when backend ships native socket.io
 * realtime alongside CollabService, the workspace can swap providers
 * without touching the SDK or any consumer.
 *
 * Provider contract (from WorkspaceProjectService):
 *   ({ op, filter, callback }) → unsubscribe fn
 *
 * Op vocabulary + table mapping:
 *   'chat.messages'     → postgres_changes on `chat_messages`,
 *                         filtered by `channel_id` when supplied
 *   'chat.channels'     → postgres_changes on `chat_channels` + `chat_channel_members`
 *   'chat.mentions'     → postgres_changes INSERT on `chat_mentions`,
 *                         filtered by `mentioned_email`
 *   'tickets'           → postgres_changes on `tickets`
 *   'notifications'     → postgres_changes INSERT on `notifications`,
 *                         filtered by `user_email`
 *   'presence'          → Supabase presence channel (sync/join/leave),
 *                         distinct from postgres_changes
 *   'meet'              → composite: `meet_rooms` + `meet_participants` +
 *                         `meet_waiting_room`, filtered by `room_id`
 *   'agentMessages'     → postgres_changes INSERT on `agent_messages`,
 *                         filtered by `to_agent`
 */ parcelRequire("82gA2");
var $8RlGv = parcelRequire("8RlGv");
const $fba2cb112cd3ddb5$var$_channelName = (op)=>`sdk-${op}-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
// Translate Supabase postgres_changes payload → SDK callback.
// Supabase delivers { eventType: 'INSERT' | 'UPDATE' | 'DELETE', new, old, ... }
// SDK callback expects (eventType, payload). Pass the whole payload through
// so consumers that need .new/.old still have them.
const $fba2cb112cd3ddb5$var$_pgForward = (cb)=>(payload)=>{
        try {
            cb(payload?.eventType || 'INSERT', payload);
        } catch (_) {}
    };
const $fba2cb112cd3ddb5$export$5e41e9c807fbc549 = ({ op: op, filter: filter = {}, callback: callback })=>{
    const sb = (0, $8RlGv.getRealtimeSupabase)();
    if (!sb) return ()=>{};
    if (typeof callback !== 'function') return ()=>{};
    // Presence channel — keyed on userKey so two browsers from the same user
    // appear as one presence entry.
    const presenceConfig = op === 'presence' && filter.userKey ? {
        config: {
            presence: {
                key: String(filter.userKey)
            }
        }
    } : undefined;
    const channel = sb.channel($fba2cb112cd3ddb5$var$_channelName(op), presenceConfig);
    switch(op){
        case 'chat.messages':
            {
                const flt = filter.channelId ? {
                    filter: `channel_id=eq.${filter.channelId}`
                } : {};
                channel.on('postgres_changes', {
                    event: '*',
                    schema: 'public',
                    table: 'chat_messages',
                    ...flt
                }, $fba2cb112cd3ddb5$var$_pgForward(callback));
                break;
            }
        case 'chat.channels':
            channel.on('postgres_changes', {
                event: '*',
                schema: 'public',
                table: 'chat_channels'
            }, $fba2cb112cd3ddb5$var$_pgForward(callback));
            channel.on('postgres_changes', {
                event: '*',
                schema: 'public',
                table: 'chat_channel_members'
            }, (payload)=>{
                // Differentiate channel-row vs membership-row events so listeners
                // can route updates correctly. Tag the table on the payload.
                try {
                    callback(payload?.eventType || 'INSERT', {
                        ...payload,
                        _kind: 'member'
                    });
                } catch (_) {}
            });
            break;
        case 'chat.mentions':
            {
                const flt = filter.userEmail ? {
                    filter: `mentioned_email=eq.${filter.userEmail}`
                } : {};
                channel.on('postgres_changes', {
                    event: 'INSERT',
                    schema: 'public',
                    table: 'chat_mentions',
                    ...flt
                }, $fba2cb112cd3ddb5$var$_pgForward(callback));
                break;
            }
        case 'tickets':
            {
                // Multi-table feed for ticket triage — `tickets` plus optional
                // `agent_presence` (live-heartbeat status drives "Now" vs "Ongoing"
                // buckets) and `agent_activity_log` (picked_up / shipped events).
                // Consumers pick the table set via `filter.tables`; default is
                // tickets-only so cheap subscribers don't get presence noise.
                // Each callback is tagged by table kind so listeners route events
                // without re-reading payload.table.
                const requested = Array.isArray(filter.tables) && filter.tables.length ? new Set(filter.tables) : new Set([
                    'tickets'
                ]);
                const flt = filter.where ? {
                    filter: filter.where
                } : {};
                if (requested.has('tickets')) channel.on('postgres_changes', {
                    event: '*',
                    schema: 'public',
                    table: 'tickets',
                    ...flt
                }, (payload)=>{
                    try {
                        callback(payload?.eventType || 'INSERT', {
                            ...payload,
                            _kind: 'tickets'
                        });
                    } catch (_) {}
                });
                if (requested.has('agent_presence') || requested.has('presence')) channel.on('postgres_changes', {
                    event: '*',
                    schema: 'public',
                    table: 'agent_presence'
                }, (payload)=>{
                    try {
                        callback(payload?.eventType || 'INSERT', {
                            ...payload,
                            _kind: 'agent_presence'
                        });
                    } catch (_) {}
                });
                if (requested.has('agent_activity_log') || requested.has('activity')) channel.on('postgres_changes', {
                    event: '*',
                    schema: 'public',
                    table: 'agent_activity_log'
                }, (payload)=>{
                    try {
                        callback(payload?.eventType || 'INSERT', {
                            ...payload,
                            _kind: 'agent_activity_log'
                        });
                    } catch (_) {}
                });
                break;
            }
        case 'notifications':
            {
                const flt = filter.userEmail ? {
                    filter: `user_email=eq.${filter.userEmail}`
                } : {};
                channel.on('postgres_changes', {
                    event: 'INSERT',
                    schema: 'public',
                    table: 'notifications',
                    ...flt
                }, $fba2cb112cd3ddb5$var$_pgForward(callback));
                break;
            }
        case 'presence':
            channel.on('presence', {
                event: 'sync'
            }, ()=>{
                try {
                    callback('sync', {
                        state: channel.presenceState()
                    });
                } catch (_) {}
            });
            channel.on('presence', {
                event: 'join'
            }, ({ key: key, newPresences: newPresences })=>{
                try {
                    callback('join', {
                        key: key,
                        newPresences: newPresences
                    });
                } catch (_) {}
            });
            channel.on('presence', {
                event: 'leave'
            }, ({ key: key, leftPresences: leftPresences })=>{
                try {
                    callback('leave', {
                        key: key,
                        leftPresences: leftPresences
                    });
                } catch (_) {}
            });
            // Track this user once subscribed — Supabase presence requires it.
            channel.subscribe(async (status)=>{
                if (status === 'SUBSCRIBED' && filter.userKey) try {
                    await channel.track({
                        status: 'online',
                        online_at: new Date().toISOString(),
                        ...filter.meta || {}
                    });
                } catch (_) {}
            });
            // Early return — presence channel is already subscribed.
            return ()=>{
                try {
                    channel.unsubscribe();
                } catch (_) {}
            };
        case 'meet':
            {
                // Five meet tables compose the live-room feed. Consumer can pick a
                // subset via `filter.tables`; default is the rooms/participants/
                // waiting trio (the home-page sidebar use case). Transcript + analysis
                // tables are opt-in because they're high-volume and only useful on
                // an active call's transcript page.
                const requested = Array.isArray(filter.tables) && filter.tables.length ? new Set(filter.tables) : new Set([
                    'rooms',
                    'participants',
                    'waiting'
                ]);
                const roomFilter = filter.roomId ? `room_id=eq.${filter.roomId}` : null;
                const idFilter = filter.roomId ? `id=eq.${filter.roomId}` : null;
                if (requested.has('rooms')) channel.on('postgres_changes', {
                    event: '*',
                    schema: 'public',
                    table: 'meet_rooms',
                    ...idFilter ? {
                        filter: idFilter
                    } : {}
                }, (payload)=>{
                    try {
                        callback('room', payload);
                    } catch (_) {}
                });
                if (requested.has('participants')) channel.on('postgres_changes', {
                    event: '*',
                    schema: 'public',
                    table: 'meet_participants',
                    ...roomFilter ? {
                        filter: roomFilter
                    } : {}
                }, (payload)=>{
                    try {
                        callback('participant', payload);
                    } catch (_) {}
                });
                if (requested.has('waiting')) channel.on('postgres_changes', {
                    event: '*',
                    schema: 'public',
                    table: 'meet_waiting_room',
                    ...roomFilter ? {
                        filter: roomFilter
                    } : {}
                }, (payload)=>{
                    try {
                        callback('waiting', payload);
                    } catch (_) {}
                });
                if (requested.has('transcripts')) channel.on('postgres_changes', {
                    event: 'INSERT',
                    schema: 'public',
                    table: 'meet_transcripts',
                    ...roomFilter ? {
                        filter: roomFilter
                    } : {}
                }, (payload)=>{
                    try {
                        callback('transcript', payload);
                    } catch (_) {}
                });
                if (requested.has('analyses')) channel.on('postgres_changes', {
                    event: '*',
                    schema: 'public',
                    table: 'meet_transcript_analyses',
                    ...roomFilter ? {
                        filter: roomFilter
                    } : {}
                }, (payload)=>{
                    try {
                        callback('analysis', payload);
                    } catch (_) {}
                });
                break;
            }
        case 'agentMessages':
            {
                const flt = filter.toAgent ? {
                    filter: `to_agent=eq.${filter.toAgent}`
                } : {};
                channel.on('postgres_changes', {
                    event: 'INSERT',
                    schema: 'public',
                    table: 'agent_messages',
                    ...flt
                }, $fba2cb112cd3ddb5$var$_pgForward(callback));
                break;
            }
        default:
            // Unknown op — return noop unsub so caller doesn't crash.
            return ()=>{};
    }
    // Subscribe non-presence channels (presence path returned above).
    channel.subscribe();
    return ()=>{
        try {
            channel.unsubscribe();
        } catch (_) {}
    };
};

});


parcelRegister("hUF7p", function(module, exports) {

$parcel$export(module.exports, "setLang", () => $d0a78fe37d52adba$export$a3665b844fbc095d);
/**
 * setLang — universal lang change primitive.
 *
 * Updates DOM attributes, evicts stale fetch cache, reloads all known
 * i18n namespaces, updates smbls polyglot, persists to localStorage,
 * and optionally persists to the user's profile via SDK.
 */ parcelRequire("8augU");
var $d9FvG = parcelRequire("d9FvG");

var $fLrnc = parcelRequire("fLrnc");

var $f0cDW = parcelRequire("f0cDW");
const $d0a78fe37d52adba$var$RTL_LANGS = new Set([
    'ar',
    'he',
    'fa',
    'ur'
]);
const $d0a78fe37d52adba$export$a3665b844fbc095d = async (newLang, opts = {})=>{
    const { sdk: sdk, shellState: shellState } = opts.context || {};
    document.documentElement.setAttribute('lang', newLang);
    document.documentElement.setAttribute('dir', $d0a78fe37d52adba$var$RTL_LANGS.has(newLang) ? 'rtl' : 'ltr');
    (0, $f0cDW.dropNonEnglishCache)();
    for (const ns of (0, $f0cDW.getLoadedNamespaces)())await (0, $f0cDW.loadI18nNamespace)(newLang, ns);
    (0, $d9FvG.loadTranslations)(newLang, (0, $f0cDW.mergeAllNamespaces)(newLang));
    (0, $d9FvG.setLang)(newLang);
    if (shellState) shellState.lang = newLang;
    localStorage.setItem('lang', newLang);
    (0, $fLrnc.queryClient).dropNonLang('en');
    if (!opts.skipPersist && sdk && shellState?.user) // SDK proxies AuthService methods flat (sdk.updateMe). There is no
    // sdk.auth namespace — see sdk/src/utils/services.js SERVICE_METHODS.
    {
        if (typeof sdk.updateMe === 'function') await sdk.updateMe({
            preferences: {
                lang: newLang
            }
        });
    }
};

});
parcelRegister("f0cDW", function(module, exports) {

$parcel$export(module.exports, "loadI18nNamespace", () => $aec0a9c7f93b0d46$export$d7e7635cdba56b8f);
$parcel$export(module.exports, "dropNonEnglishCache", () => $aec0a9c7f93b0d46$export$20e078bbaa6a7e60);
$parcel$export(module.exports, "getLoadedNamespaces", () => $aec0a9c7f93b0d46$export$c3e88959bcdae366);
$parcel$export(module.exports, "mergeAllNamespaces", () => $aec0a9c7f93b0d46$export$fde487a3028333bc);
/**
 * i18nLoader — async-import per-lang JSON from same host with English
 * fallback and in-memory cache.
 *
 * Uses `new URL()` so Parcel statically analyses the path and emits
 * the JSON files as addressable static assets in the output bundle.
 */ const $aec0a9c7f93b0d46$var$_cache = new Map();
const $aec0a9c7f93b0d46$var$_loadedNamespaces = new Set();
// Supported languages and namespaces — Parcel resolves these at build time.
const $aec0a9c7f93b0d46$export$b4b5a31092c79bca = [
    'en',
    'de',
    'fr',
    'es'
];
const $aec0a9c7f93b0d46$export$4d2fb7344096e022 = [
    'common',
    'auth',
    'account',
    'admin'
];
















/**
 * Resolve the URL for a given lang/namespace bundle via new URL() so
 * Parcel includes the JSON as a static asset and assigns it a stable
 * content-hashed URL in the output.
 *
 * @param {string} lang
 * @param {string} namespace
 * @returns {string}
 */ function $aec0a9c7f93b0d46$var$resolveI18nUrl(lang, namespace) {
    // new URL() with a relative string + import.meta.url lets Parcel detect
    // the asset at build time and rewrite the URL to its hashed output path.
    if (lang === 'en' && namespace === 'common') return new URL((parcelRequire("1Iabu"))).href;
    if (lang === 'en' && namespace === 'auth') return new URL((parcelRequire("fxQrH"))).href;
    if (lang === 'en' && namespace === 'account') return new URL((parcelRequire("gfVBw"))).href;
    if (lang === 'en' && namespace === 'admin') return new URL((parcelRequire("csozJ"))).href;
    if (lang === 'de' && namespace === 'common') return new URL((parcelRequire("cqQor"))).href;
    if (lang === 'de' && namespace === 'auth') return new URL((parcelRequire("ajDqr"))).href;
    if (lang === 'de' && namespace === 'account') return new URL((parcelRequire("YiUYj"))).href;
    if (lang === 'de' && namespace === 'admin') return new URL((parcelRequire("lSCeR"))).href;
    if (lang === 'fr' && namespace === 'common') return new URL((parcelRequire("8TjmX"))).href;
    if (lang === 'fr' && namespace === 'auth') return new URL((parcelRequire("5Bqe2"))).href;
    if (lang === 'fr' && namespace === 'account') return new URL((parcelRequire("ctGVI"))).href;
    if (lang === 'fr' && namespace === 'admin') return new URL((parcelRequire("au1wj"))).href;
    if (lang === 'es' && namespace === 'common') return new URL((parcelRequire("iSX9H"))).href;
    if (lang === 'es' && namespace === 'auth') return new URL((parcelRequire("4su72"))).href;
    if (lang === 'es' && namespace === 'account') return new URL((parcelRequire("j8x2x"))).href;
    if (lang === 'es' && namespace === 'admin') return new URL((parcelRequire("hP4cX"))).href;
    // Fallback: runtime-only URL, not statically bundled by Parcel.
    return `/i18n/${lang}/${namespace}.json`;
}
const $aec0a9c7f93b0d46$export$d7e7635cdba56b8f = async (lang, namespace)=>{
    const key = `${lang}/${namespace}`;
    if ($aec0a9c7f93b0d46$var$_cache.has(key)) return $aec0a9c7f93b0d46$var$_cache.get(key);
    const url = $aec0a9c7f93b0d46$var$resolveI18nUrl(lang, namespace);
    try {
        const res = await fetch(url, {
            credentials: 'same-origin'
        });
        if (!res.ok) {
            if (lang !== 'en') return $aec0a9c7f93b0d46$export$d7e7635cdba56b8f('en', namespace);
            return {};
        }
        const data = await res.json();
        $aec0a9c7f93b0d46$var$_cache.set(key, data);
        $aec0a9c7f93b0d46$var$_loadedNamespaces.add(namespace);
        return data;
    } catch (e) {
        if (lang !== 'en') return $aec0a9c7f93b0d46$export$d7e7635cdba56b8f('en', namespace);
        return {};
    }
};
const $aec0a9c7f93b0d46$export$20e078bbaa6a7e60 = ()=>{
    for (const k of $aec0a9c7f93b0d46$var$_cache.keys())if (!k.startsWith('en/')) $aec0a9c7f93b0d46$var$_cache.delete(k);
};
const $aec0a9c7f93b0d46$export$c3e88959bcdae366 = ()=>Array.from($aec0a9c7f93b0d46$var$_loadedNamespaces);
const $aec0a9c7f93b0d46$export$fde487a3028333bc = (lang)=>{
    const merged = {};
    for (const ns of $aec0a9c7f93b0d46$var$_loadedNamespaces)Object.assign(merged, $aec0a9c7f93b0d46$var$_cache.get(`${lang}/${ns}`) || $aec0a9c7f93b0d46$var$_cache.get(`en/${ns}`) || {});
    return merged;
};

});
parcelRegister("1Iabu", function(module, exports) {
module.exports = import.meta.resolve("2r2ig");

});

parcelRegister("fxQrH", function(module, exports) {
module.exports = import.meta.resolve("aZgHd");

});

parcelRegister("gfVBw", function(module, exports) {
module.exports = import.meta.resolve("5jQrr");

});

parcelRegister("csozJ", function(module, exports) {
module.exports = import.meta.resolve("1F3mh");

});

parcelRegister("cqQor", function(module, exports) {
module.exports = import.meta.resolve("5ei9c");

});

parcelRegister("ajDqr", function(module, exports) {
module.exports = import.meta.resolve("lMWGU");

});

parcelRegister("YiUYj", function(module, exports) {
module.exports = import.meta.resolve("91cmq");

});

parcelRegister("lSCeR", function(module, exports) {
module.exports = import.meta.resolve("cx4IS");

});

parcelRegister("8TjmX", function(module, exports) {
module.exports = import.meta.resolve("j6irA");

});

parcelRegister("5Bqe2", function(module, exports) {
module.exports = import.meta.resolve("n2RmP");

});

parcelRegister("ctGVI", function(module, exports) {
module.exports = import.meta.resolve("8Fs04");

});

parcelRegister("au1wj", function(module, exports) {
module.exports = import.meta.resolve("1YMzE");

});

parcelRegister("iSX9H", function(module, exports) {
module.exports = import.meta.resolve("ird31");

});

parcelRegister("4su72", function(module, exports) {
module.exports = import.meta.resolve("3PVyL");

});

parcelRegister("j8x2x", function(module, exports) {
module.exports = import.meta.resolve("l5GCp");

});

parcelRegister("hP4cX", function(module, exports) {
module.exports = import.meta.resolve("hoQJa");

});



parcelRegister("4dRLV", function(module, exports) {

$parcel$export(module.exports, "switchOrg", () => (parcelRequire("f4Q74")).switchOrg);
$parcel$export(module.exports, "switchWorkspace", () => (parcelRequire("hN8C9")).switchWorkspace);
$parcel$export(module.exports, "switchWorkspaceProject", () => (parcelRequire("5NIGv")).switchWorkspaceProject);
$parcel$export(module.exports, "logout", () => (parcelRequire("KNDYr")).logout);

var $f4Q74 = parcelRequire("f4Q74");

var $hN8C9 = parcelRequire("hN8C9");

var $5NIGv = parcelRequire("5NIGv");

var $KNDYr = parcelRequire("KNDYr");

});
parcelRegister("f4Q74", function(module, exports) {

$parcel$export(module.exports, "switchOrg", () => $af9fa74d1dd8a0fa$export$f28399983e86882c);
/**
 * switchOrg — clears all scope state, re-authenticates to the new org,
 * re-fetches org data, then delegates to switchWorkspace for the default workspace.
 */ const $af9fa74d1dd8a0fa$var$ORG_KEYS = new Set([
    'org',
    'permissions',
    'orgMembers',
    'orgRoles',
    'orgTeams'
]);
const $af9fa74d1dd8a0fa$var$WORKSPACE_KEYS = new Set([
    'workspace',
    'workspaceMembers',
    'workspaceIntegrations',
    'workspaceBilling'
]);
const $af9fa74d1dd8a0fa$var$WORKSPACE_PROJECT_KEYS = new Set([
    'workspaceProject'
]);
const $af9fa74d1dd8a0fa$var$PROJECT_KEYS = new Set([
    'project',
    'projectComponents',
    'projectPages',
    'projectState'
]);

const $af9fa74d1dd8a0fa$export$f28399983e86882c = async (state, sdk, queryClient, newOrgId)=>{
    if (!sdk) {
        // Without an SDK ref the rest is a fake switch — clearing state would
        // race with the auth subscriber and look like a partial success. Bail
        // loudly so the caller's wiring bug surfaces in the console.
        // eslint-disable-next-line no-console
        console.warn("[switchOrg] aborted \u2014 SDK reference missing on element context");
        return;
    }
    for (const k of $af9fa74d1dd8a0fa$var$WORKSPACE_KEYS)state[k] = null;
    for (const k of $af9fa74d1dd8a0fa$var$WORKSPACE_PROJECT_KEYS)state[k] = null;
    for (const k of $af9fa74d1dd8a0fa$var$PROJECT_KEYS)state[k] = null;
    for (const k of $af9fa74d1dd8a0fa$var$ORG_KEYS)state[k] = null;
    await sdk.switchOrg(newOrgId);
    // queryClient is optional — shells that haven't wired @symbo.ls/fetch
    // yet (workspace shell on the `next` branch) won't have one.
    if (queryClient && typeof queryClient.clear === 'function') queryClient.clear();
    // SDK methods are flat — sdk.organization / sdk.auth / sdk.workspace
    // namespaces don't exist. Service routing is via the SERVICE_METHODS map
    // in sdk/src/utils/services.js, which exposes:
    //   sdk.getOrganization(id)         (organization service)
    //   sdk.getPermissions(...)         (auth service — only via dispatcher)
    //   sdk.listWorkspaces({ org })     (workspace service)
    // Permissions endpoint isn't shipped on every backend yet — failure
    // there shouldn't abort the switch (we only need org + workspaces to
    // bring the UI up). Fall back to null and let the auth subscriber's
    // jwt-claims-derived role gates run instead.
    const [org, permissions] = await Promise.all([
        sdk.getOrganization(newOrgId),
        Promise.resolve(typeof sdk.getPermissions === 'function' ? sdk.getPermissions(newOrgId) : sdk.execute?.('auth.permissions', 'list', [
            newOrgId
        ])).catch((err)=>{
            // eslint-disable-next-line no-console
            console.warn('[switchOrg] permissions fetch failed (continuing):', err?.message || err);
            return null;
        })
    ]);
    state.org = org;
    state.permissions = permissions;
    const workspaces = await sdk.listWorkspaces({
        organization: newOrgId
    }).catch((err)=>{
        // eslint-disable-next-line no-console
        console.warn('[switchOrg] listWorkspaces failed:', err?.message || err);
        return [];
    });
    state.workspaces = Array.isArray(workspaces) ? workspaces : workspaces?.data || [];
    const defaultWorkspace = state.workspaces[0] || null;
    if (defaultWorkspace) {
        const { switchWorkspace: switchWorkspace } = await Promise.resolve((parcelRequire("hN8C9")));
        await switchWorkspace(state, sdk, queryClient, defaultWorkspace.id || defaultWorkspace._id);
    }
    localStorage.setItem('activeOrg', newOrgId);
};

});

parcelRegister("5NIGv", function(module, exports) {

$parcel$export(module.exports, "switchWorkspaceProject", () => $439430c4410a9d50$export$a219538d8abadb93);
/**
 * switchWorkspaceProject — clears workspace-project state, invalidates
 * stale fetch cache entries, loads the new workspace project.
 *
 * NOTE: sdk.workspaceProject.getWorkspaceProject may not exist yet
 * (Phase 1.5 / Phase 8 addition). The absence is handled gracefully.
 */ const $439430c4410a9d50$var$WORKSPACE_PROJECT_KEYS = new Set([
    'workspaceProject'
]);
const $439430c4410a9d50$export$a219538d8abadb93 = async (state, sdk, queryClient, newWPId)=>{
    for (const k of $439430c4410a9d50$var$WORKSPACE_PROJECT_KEYS)state[k] = null;
    // Workspace Project cache is mostly tickets/chats with WP id in params.
    // Mark all stale; refetch lazily.
    queryClient.invalidateQueries();
    state.workspaceProject = await sdk.workspaceProject?.getWorkspaceProject?.(newWPId) || null;
    localStorage.setItem('activeWorkspaceProject', newWPId);
};

});

parcelRegister("KNDYr", function(module, exports) {

$parcel$export(module.exports, "logout", () => $08cace346f468839$export$a0973bcfe11b05c9);
/**
 * logout — signs the user out, clears all state, nukes the fetch cache,
 * signals other tabs via localStorage, and redirects to /login.
 */ /**
 * @param {object} state       - DOMQL root state
 * @param {object} sdk         - SDK instance (flat sdk.logout method)
 * @param {object} queryClient - @symbo.ls/fetch queryClient
 */ const $08cace346f468839$export$a0973bcfe11b05c9 = async (state, sdk, queryClient)=>{
    await sdk.logout?.();
    for (const k of Object.keys(state))state[k] = null;
    state.preferences = {};
    state.themeMode = 'auto';
    state.lang = 'en';
    queryClient.clear();
    localStorage.setItem('logout', String(Date.now()));
    localStorage.removeItem('activeOrg');
    localStorage.removeItem('activeWorkspace');
    localStorage.removeItem('activeWorkspaceProject');
    window.history.replaceState(null, '', '/login');
};

});



parcelRegister("bZxx9", function(module, exports) {

var $fOreV = parcelRequire("fOreV");

var $e4NW5 = parcelRequire("e4NW5");

var $h2VO7 = parcelRequire("h2VO7");

var $iVl2P = parcelRequire("iVl2P");

var $hbJvK = parcelRequire("hbJvK");

var $9Owoy = parcelRequire("9Owoy");

var $bgsWn = parcelRequire("bgsWn");

var $7e1cr = parcelRequire("7e1cr");

var $jHcY5 = parcelRequire("jHcY5");

var $ittjw = parcelRequire("ittjw");

var $4VmEZ = parcelRequire("4VmEZ");

var $Ntxk8 = parcelRequire("Ntxk8");

var $3spi0 = parcelRequire("3spi0");

var $6nkDr = parcelRequire("6nkDr");

var $3ubf6 = parcelRequire("3ubf6");

var $f1gPr = parcelRequire("f1gPr");

var $KEXbu = parcelRequire("KEXbu");

var $7vTiJ = parcelRequire("7vTiJ");

var $fGu6z = parcelRequire("fGu6z");

var $jEjO6 = parcelRequire("jEjO6");

var $ddpF8 = parcelRequire("ddpF8");

var $6x4bH = parcelRequire("6x4bH");

var $9e3m7 = parcelRequire("9e3m7");

var $7W54L = parcelRequire("7W54L");

var $3IQHm = parcelRequire("3IQHm");

var $5IOJd = parcelRequire("5IOJd");

var $87JX3 = parcelRequire("87JX3");
$parcel$exportWildcard(module.exports, $fOreV);
$parcel$exportWildcard(module.exports, $e4NW5);
$parcel$exportWildcard(module.exports, $h2VO7);
$parcel$exportWildcard(module.exports, $iVl2P);
$parcel$exportWildcard(module.exports, $hbJvK);
$parcel$exportWildcard(module.exports, $9Owoy);
$parcel$exportWildcard(module.exports, $bgsWn);
$parcel$exportWildcard(module.exports, $7e1cr);
$parcel$exportWildcard(module.exports, $jHcY5);
$parcel$exportWildcard(module.exports, $ittjw);
$parcel$exportWildcard(module.exports, $4VmEZ);
$parcel$exportWildcard(module.exports, $Ntxk8);
$parcel$exportWildcard(module.exports, $3spi0);
$parcel$exportWildcard(module.exports, $6nkDr);
$parcel$exportWildcard(module.exports, $3ubf6);
$parcel$exportWildcard(module.exports, $f1gPr);
$parcel$exportWildcard(module.exports, $KEXbu);
$parcel$exportWildcard(module.exports, $7vTiJ);
$parcel$exportWildcard(module.exports, $fGu6z);
$parcel$exportWildcard(module.exports, $jEjO6);
$parcel$exportWildcard(module.exports, $ddpF8);
$parcel$exportWildcard(module.exports, $6x4bH);
$parcel$exportWildcard(module.exports, $9e3m7);
$parcel$exportWildcard(module.exports, $7W54L);
$parcel$exportWildcard(module.exports, $3IQHm);
$parcel$exportWildcard(module.exports, $5IOJd);
$parcel$exportWildcard(module.exports, $87JX3);

});
parcelRegister("fOreV", function(module, exports) {

$parcel$export(module.exports, "getPlatformVersion", () => getPlatformVersion);
$parcel$export(module.exports, "getRootState", () => getRootState);
$parcel$export(module.exports, "getRef", () => getRef);
$parcel$export(module.exports, "getChildren", () => getChildren);
$parcel$export(module.exports, "getRoot", () => getRoot);
$parcel$export(module.exports, "getRootData", () => getRootData);
$parcel$export(module.exports, "getRootContext", () => getRootContext);
$parcel$export(module.exports, "getContext", () => getContext);
$parcel$export(module.exports, "getAppKey", () => getAppKey);
$parcel$export(module.exports, "isPlatform", () => isPlatform);
$parcel$export(module.exports, "getSchema", () => getSchema);
$parcel$export(module.exports, "getData", () => getData);
$parcel$export(module.exports, "getMySharedLibraries", () => getMySharedLibraries);
$parcel$export(module.exports, "getDefaultDesignSystem", () => getDefaultDesignSystem);
$parcel$export(module.exports, "getDefaultComponents", () => getDefaultComponents);
$parcel$export(module.exports, "getDefaultComponentsSchema", () => getDefaultComponentsSchema);
$parcel$export(module.exports, "getDefaultLibrary", () => getDefaultLibrary);
$parcel$export(module.exports, "getDefaultData", () => getDefaultData);
$parcel$export(module.exports, "getDefaults", () => getDefaults);
$parcel$export(module.exports, "getBuiltins", () => getBuiltins);
$parcel$export(module.exports, "getSecrets", () => getSecrets);
$parcel$export(module.exports, "getDependencies", () => getDependencies);
$parcel$export(module.exports, "getFiles", () => getFiles);
$parcel$export(module.exports, "getComponents", () => getComponents);
$parcel$export(module.exports, "getFunctions", () => getFunctions);
$parcel$export(module.exports, "getState", () => getState);
$parcel$export(module.exports, "getMethods", () => getMethods);
$parcel$export(module.exports, "getActivePkgManager", () => getActivePkgManager);
$parcel$export(module.exports, "getPackages", () => getPackages);
$parcel$export(module.exports, "getParsedState", () => getParsedState);
$parcel$export(module.exports, "getUtils", () => getUtils);
$parcel$export(module.exports, "getUtil", () => getUtil);
$parcel$export(module.exports, "getUserSettings", () => getUserSettings);
$parcel$export(module.exports, "setUserSettings", () => setUserSettings);
$parcel$export(module.exports, "toggleUserSettings", () => toggleUserSettings);
$parcel$export(module.exports, "setAllUserSettings", () => setAllUserSettings);
$parcel$export(module.exports, "isState", () => isState);
$parcel$export(module.exports, "addToPlatformContext", () => addToPlatformContext);
$parcel$export(module.exports, "addIfPlatformProject", () => addIfPlatformProject);
$parcel$export(module.exports, "getGlobalTheme", () => getGlobalTheme);
async function getPlatformVersion() {
    // const PKG = await import('@symbo.ls/platform/package.json')
    if (PKG) return PKG.version;
}
function getRootState(param) {
    let state = null;
    const hasRootState = (obj)=>obj.__element && obj.root?.isRootState;
    if (!this) state = window.platformState || window.smblsApp?.state;
    else if (hasRootState(this)) state = this.root;
    else if (this.__ref && this.__ref.path) {
        const hasPlatformState = this.state && hasRootState(this.state);
        const hasPlatformStateOnParent = this.call('isFunction', this.state) && this.parent.state && hasRootState(this.parent.state);
        if (hasPlatformState || hasPlatformStateOnParent) state = this.state.root || this.parent.state.root;
    }
    if (!state) state = window.platformState || window.smblsApp?.state;
    return param ? state?.[param] : state;
}
function getRef(key) {
    if (key) return this.__ref && this.__ref[key];
    return this.__ref;
}
function getChildren() {
    const __children = this.getRef('__children');
    return __children?.map((k)=>this[k]);
}
function getRoot(key) {
    const rootElem = this.getRootState()?.__element;
    return rootElem && Object.keys(rootElem).length > 0 && key ? rootElem[key] : rootElem;
}
function getRootData(key) {
    return this.getRoot('data') && Object.keys(this.getRoot('data')).length > 0 && key ? this.getRoot('data')[key] : this.getRoot('data');
}
function getRootContext(key) {
    const ctx = this.getRoot()?.context;
    return key ? ctx?.[key] : ctx;
}
function getContext(key) {
    const ctx = this.context;
    return key ? ctx[key] : ctx;
}
function getAppKey() {
    return this.getRootState()?.appKey;
}
function isPlatform() {
    return this.getRootState('projectType') === 'platform' || [
        'brand.symbo.ls',
        'smbls.symbo.ls',
        'platform.symbo.ls',
        'docs.symbo.ls',
        'assistant.symbo.ls',
        'landing.symbo.ls',
        'pricing.symbo.ls'
    ].includes(this.getAppKey());
}
function getSchema(key) {
    const { schema } = this.getRootState() || {};
    return key ? schema?.[key] : schema;
}
function getData(key) {
    const rootState = this.getRootState() || this.state?.root || {};
    const source = rootState.data || rootState;
    const { designSystem, state, components, snippets, pages, functions, methods, files, dependencies } = source;
    const data = {
        designSystem: designSystem,
        state: state,
        components: components,
        snippets: snippets,
        pages: pages,
        functions: functions,
        methods: methods,
        files: files,
        dependencies: dependencies
    };
    return key ? data[key] : data;
}
function getMySharedLibraries() {
    const root = this.getRootState && this.getRootState();
    return root && root.sharedLibraries || [];
}
async function getDefaultDesignSystem() {
    return {} // await import('@symbo.ls/library/default/designSystem')
    ;
}
async function getDefaultComponents() {
    return {} // await import('@symbo.ls/library/default/components')
    ;
}
async function getDefaultComponentsSchema() {
    const { DEFAULT_COMPONENTS_SCHEMA } = {} // await import('@symbo.ls/library/default.js')
    ;
    return DEFAULT_COMPONENTS_SCHEMA;
}
async function getDefaultLibrary() {
    const { LIBRARY } = {} // await import('@symbo.ls/library/default.js')
    ;
    return LIBRARY;
}
async function getDefaultData(key) {
    const data = {
        designSystem: await this.getDefaultDesignSystem(),
        components: await this.getDefaultComponents()
    };
    return key ? data[key] : data;
}
function getDefaults(key) {
    const defs = this.getRootState('DEFAULTS');
    return defs?.[key] || defs;
}
function getBuiltins() {
    const defs = this.getRootState('DEFAULTS');
    return defs?.DS_DEFAULTS;
}
function getSecrets(key) {
    const secrets = this.getRootState('secrets');
    return key ? secrets?.[key] : secrets;
}
function getDependencies(key) {
    const dependencies = this.getData('dependencies');
    return key ? dependencies?.[key] : dependencies;
}
function getFiles(key) {
    const files = this.getData('files');
    return key ? files?.[key] : files;
}
function getComponents(key) {
    const components = this.getData('components');
    return key ? components?.[key] : components;
}
function getFunctions(key) {
    const functions = this.getData('functions');
    return key ? functions?.[key] : functions;
}
function getState(key) {
    const state = this.getData('state');
    return key ? state?.[key] : state;
}
function getMethods(key) {
    const methods = this.getData('methods');
    return key ? methods?.[key] : methods;
}
function getActivePkgManager() {
    return this.getRootState('pkgManager');
}
function getPackages(key) {
    const packages = this.getSchema('dependencies');
    return key && packages ? packages[key] : packages || {};
}
function getParsedState(obj = this) {
    const isState2 = this.isState(obj);
    if (isState2) return obj.parse();
    const hasState = this.isState(obj.state);
    if (hasState) return obj.state.parse();
    return obj.parseDeep && obj.parseDeep() || obj;
}
function getUtils() {
    return this.context.utils;
}
function getUtil(key) {
    return this.getUtils()[key];
}
function getUserSettings(key) {
    const userSettings = this.getRootState('user');
    return key ? userSettings?.[key] : userSettings;
}
function setUserSettings(key, val, opts) {
    const autoSaveSettings = false //this.getUserSettings('autoSaveSettings')
    ;
    this.getRootState().update({
        user: {
            [key]: val
        }
    }, autoSaveSettings ? opts : {
        ...opts,
        preventUpdate: true
    });
    // console.log(key, val, opts)
    this.call('setCookie', key, val);
}
function toggleUserSettings(key, opts) {
    const val = !this.getUserSettings(key);
    this.setUserSettings(key, val, opts);
}
function setAllUserSettings(obj, opts) {
    // console.log(obj)
    this.getRootState().update({
        user: obj
    }, opts);
    // eslint-disable-next-line guard-for-in
    for(const prop in obj)this.call('setCookie', prop, this.getUserSettings(prop));
}
function isState(obj) {
    if (!this.call('isObjectLike', obj)) return false;
    return obj.update && obj.parse && obj.clean && obj.create && obj.parent && obj.destroy && obj.rootUpdate && obj.parentUpdate && obj.keys && obj.values && obj.toggle && obj.replace && obj.quietUpdate && obj.quietReplace && obj.add && obj.apply && obj.applyReplace && obj.applyFunction && obj.__element && obj.__children;
// return arrayContainsOtherArray(keys, ['update', 'parse', 'clean', 'create', 'parent', 'rootUpdate'])
}
function addToPlatformContext(type, key) {
    const context = this.context;
    const item = this.getDataItem(key, type);
    context[type][key] = this.call('deepClone', item);
}
function addIfPlatformProject(type, key) {
    if (this.isPlatform()) this.addToPlatformContext(type, key);
}
function getGlobalTheme() {
    const platformState = this.getRootState();
    if (!platformState) return 'dark';
    const { designSystem } = platformState;
    return platformState.sceneTheme || designSystem?.globalTheme;
}

});

parcelRegister("e4NW5", function(module, exports) {

$parcel$export(module.exports, "getCanvas", () => getCanvas);
$parcel$export(module.exports, "getPlayground", () => getPlayground);
$parcel$export(module.exports, "getVersionsAside", () => getVersionsAside);
$parcel$export(module.exports, "getLocalStorageCanvasData", () => getLocalStorageCanvasData);
$parcel$export(module.exports, "getCanvasScope", () => getCanvasScope);
$parcel$export(module.exports, "setCanvasScope", () => setCanvasScope);
$parcel$export(module.exports, "getActiveCanvasPage", () => getActiveCanvasPage);
$parcel$export(module.exports, "getCanvasFrame", () => getCanvasFrame);
$parcel$export(module.exports, "getCanvasFrameWindow", () => getCanvasFrameWindow);
$parcel$export(module.exports, "getEditorPanels", () => getEditorPanels);
$parcel$export(module.exports, "getComponentPanelSwitcher", () => getComponentPanelSwitcher);
$parcel$export(module.exports, "getComponentCodeEditor", () => getComponentCodeEditor);
$parcel$export(module.exports, "getDocsView", () => getDocsView);
$parcel$export(module.exports, "getDynamicIsland", () => getDynamicIsland);
$parcel$export(module.exports, "getQuickEditor", () => getQuickEditor);
$parcel$export(module.exports, "getFloatingPanelElement", () => getFloatingPanelElement);
$parcel$export(module.exports, "getCanvasModal", () => getCanvasModal);
$parcel$export(module.exports, "getCanvasNavbar", () => getCanvasNavbar);
$parcel$export(module.exports, "getFilesSidebar", () => getFilesSidebar);
$parcel$export(module.exports, "getFilesSidebarPrompt", () => getFilesSidebarPrompt);
$parcel$export(module.exports, "getCanvasPages", () => getCanvasPages);
$parcel$export(module.exports, "getComponentEditor", () => getComponentEditor);
$parcel$export(module.exports, "getChosenElement", () => getChosenElement);
$parcel$export(module.exports, "getChosenData", () => getChosenData);
$parcel$export(module.exports, "getChosenElementContext", () => getChosenElementContext);
$parcel$export(module.exports, "getChosenScene", () => getChosenScene);
$parcel$export(module.exports, "getChosenViewSvitcher", () => getChosenViewSvitcher);
$parcel$export(module.exports, "getChosenIframe", () => getChosenIframe);
$parcel$export(module.exports, "getChosenIframeWindow", () => getChosenIframeWindow);
$parcel$export(module.exports, "getChosenSceneNavbar", () => getChosenSceneNavbar);
$parcel$export(module.exports, "getCanvasCollection", () => getCanvasCollection);
$parcel$export(module.exports, "getCanvasContext", () => getCanvasContext);
$parcel$export(module.exports, "activateHovered", () => activateHovered);
$parcel$export(module.exports, "activateSelected", () => activateSelected);
$parcel$export(module.exports, "updateSelectedLabel", () => updateSelectedLabel);
$parcel$export(module.exports, "activateChosen", () => activateChosen);
$parcel$export(module.exports, "activateContext2", () => activateContext2);
$parcel$export(module.exports, "activateContext", () => activateContext);
$parcel$export(module.exports, "changeCodePriority", () => changeCodePriority);
$parcel$export(module.exports, "updateRecents", () => updateRecents);
$parcel$export(module.exports, "activateFunction", () => activateFunction);
$parcel$export(module.exports, "activateState", () => activateState);
$parcel$export(module.exports, "activateDs", () => activateDs);
$parcel$export(module.exports, "getHovered", () => getHovered);
$parcel$export(module.exports, "getHoveredKey", () => getHoveredKey);
$parcel$export(module.exports, "getSelected", () => getSelected);
$parcel$export(module.exports, "getSelectedKey", () => getSelectedKey);
$parcel$export(module.exports, "getChosen", () => getChosen);
$parcel$export(module.exports, "getChosenKey", () => getChosenKey);
$parcel$export(module.exports, "getInContext", () => getInContext);
$parcel$export(module.exports, "getInContextKey", () => getInContextKey);
$parcel$export(module.exports, "getCanvasPositions", () => getCanvasPositions);
$parcel$export(module.exports, "zoomToNode", () => zoomToNode);
$parcel$export(module.exports, "updateGridsInSchema", () => updateGridsInSchema);
$parcel$export(module.exports, "getCleanCanvasScope", () => getCleanCanvasScope);
$parcel$export(module.exports, "syncSocketCanvasData", () => syncSocketCanvasData);
$parcel$export(module.exports, "syncCanvas", () => syncCanvas);
$parcel$export(module.exports, "syncCanvasPositions", () => syncCanvasPositions);
$parcel$export(module.exports, "canvasFade", () => canvasFade);
$parcel$export(module.exports, "toggleLoading", () => toggleLoading);
$parcel$export(module.exports, "resetCanvasPan", () => resetCanvasPan);
$parcel$export(module.exports, "getCanvasScopeFromStorageOrData", () => getCanvasScopeFromStorageOrData);
$parcel$export(module.exports, "isDashboard", () => isDashboard);
$parcel$export(module.exports, "isAuthorised", () => isAuthorised);
$parcel$export(module.exports, "isFree", () => isFree);
$parcel$export(module.exports, "isCanvas", () => isCanvas);
$parcel$export(module.exports, "isEmbed", () => isEmbed);
$parcel$export(module.exports, "isEditMode", () => isEditMode);
$parcel$export(module.exports, "isAdmin", () => isAdmin);
$parcel$export(module.exports, "isOwner", () => isOwner);
$parcel$export(module.exports, "isReadOnly", () => isReadOnly);
$parcel$export(module.exports, "preventLocationChanges", () => preventLocationChanges);
$parcel$export(module.exports, "isDocs", () => isDocs);
$parcel$export(module.exports, "isDevelopers", () => isDevelopers);
$parcel$export(module.exports, "getCanvasPathname", () => getCanvasPathname);
$parcel$export(module.exports, "getCanvasPathnameAnyway", () => getCanvasPathnameAnyway);
$parcel$export(module.exports, "getCanvasPathnameLocal", () => getCanvasPathnameLocal);
$parcel$export(module.exports, "addOnCanvasStr", () => addOnCanvasStr);
$parcel$export(module.exports, "openArtboardItem", () => openArtboardItem);
$parcel$export(module.exports, "openItem", () => openItem);
$parcel$export(module.exports, "getCanvasMode", () => getCanvasMode);
$parcel$export(module.exports, "isCanvasMode", () => isCanvasMode);
$parcel$export(module.exports, "setCanvasMode", () => setCanvasMode);
/* eslint-disable curly */ /* eslint-disable no-multi-assign */ /* eslint-disable no-param-reassign */ /* eslint-disable consistent-this */ function getCanvas(childKey) {
    const Canvas = this.getRootData('Canvas') || this.lookup('Canvas') || this.lookdown('Canvas');
    if (!Canvas) return;
    if (childKey) return Canvas[childKey];
    return Canvas;
}
function getPlayground() {
    const Playground = this.getCanvas()?.parent;
    if (!Playground) return;
    return Playground;
}
function getVersionsAside() {
    const Playground = this.getPlayground();
    if (!Playground) return;
    return Playground.parent?.Versions?.VersionsAside;
}
function getLocalStorageCanvasData() {
    const localStorageKey = `${this.getAppKey()?.split('.')[0]}__data`;
    return this.call('getLocalStorage', localStorageKey);
}
function getCanvasScope(childKey) {
    const canvas = this.getCanvas();
    const scope = canvas?.scope;
    if (childKey) return scope?.[childKey];
    return scope;
}
function setCanvasScope(obj) {
    const scope = this.getCanvasScope();
    this.call('overwrite', scope, obj);
    this.syncCanvas(obj);
    return scope;
}
function getActiveCanvasPage() {
    return this.getCanvasScope('activeCanvasPage');
}
function getCanvasFrame() {
    return this.getCanvas()?.Iframe;
}
function getCanvasFrameWindow() {
    return this.getCanvasFrame()?.node.contentWindow;
}
function getEditorPanels() {
    return this.getCanvas()?.parent.Chosen.Flex?.EditorPanels;
}
function getComponentPanelSwitcher() {
    return this.getEditorPanels()?.ComponentEditor.PanelSwitcher;
}
function getComponentCodeEditor() {
    return this.getComponentPanelSwitcher()?.content?.CodePreviewWidget.Monaco;
}
function getDocsView() {
    return this.getChosenScene()?.DocsView;
}
function getDynamicIsland() {
    return this.getPlayground()?.DynamicIsland;
}
function getQuickEditor() {
    return this.getPlayground()?.QuickEditor;
}
function getFloatingPanelElement() {
    return this.getPlayground()?.FloatingPanel;
}
function getCanvasModal() {
    return this.getPlayground()?.CanvasModal;
}
function getCanvasNavbar() {
    return this.getPlayground()?.MainCanvasNavbar;
}
function getFilesSidebar() {
    // return this.getDynamicIsland()?.FilesSidebar
    return this.getDynamicIsland()?.content;
}
function getFilesSidebarPrompt() {
    return this.getFilesSidebar()?.FilesSidebarPrompt;
}
function getCanvasPages() {
    if (this.isEmbed()) return this.getCanvas()?.ChooseCanvas;
    return this.getCanvasNavbar()?.CanvasPagesDropdown;
}
function getComponentEditor() {
    return this.getEditorPanels().ComponentEditor;
}
function getChosenElement() {
    return this.getPlayground()?.Chosen;
}
function getChosenData(key1) {
    const data = this.getChosenElement()?.data;
    return key1 ? data[key1] : data;
}
function getChosenElementContext() {
    return this.getChosenElement()?.data.chosen?.context;
}
function getChosenScene() {
    return this.getChosenElement()?.Flex?.ChosenScene;
}
function getChosenViewSvitcher() {
    return this.getChosenScene()?.ViewSvitcher;
}
function getChosenIframe() {
    return this.getChosenScene()?.ViewSvitcher?.ComponentFrameCanvas.Iframe;
}
function getChosenIframeWindow() {
    return this.getChosenIframe()?.node.contentWindow;
}
function getChosenSceneNavbar() {
    return this.getChosenElement()?.SceneNavbar;
}
function getCanvasCollection() {
    return this.getCanvasScope('Collection');
}
function getCanvasContext() {
    return this.getCanvasCollection().context;
}
function activateHovered(val) {
    if (!this.call('isDefined', val)) val = this;
    const data = this.getCanvasScope();
    const hovered = data.hovered = this.call('isDefined', val) ? val : null;
    return this.syncCanvas({
        hovered: hovered
    });
}
function activateSelected(val, opts = {}) {
    const data = this.getCanvasScope();
    if (!this.call('isDefined', val)) val = this;
    else if (this.call('isString', val)) {
        const type = this.getType(val);
        const isOnCurrent = this.call('inOnCurrentCanvasPage', type, val);
        if (!isOnCurrent) {
            const onOtherCanvasPage = this.call('findKeyInOtherCanvasPages', type, val);
            if (onOtherCanvasPage) this.call('openCanvasPage', onOtherCanvasPage);
        }
        val = this.call('findComponentOnCanvas', val);
    }
    const selected = data.selected = this.call('isDefined', val) ? val : data.hovered;
    if (selected) {
        this.changeCodePriority('component', opts);
        if (this.getUserSettings('autoSelectSidebar')) {
            if (this.call('getSidebarContent') !== 'ARTBOARD_TYPES') this.call('setSidebarContent', 'ARTBOARD_TYPES');
        }
    }
    this.updateSelectedLabel();
    return !opts.preventSync ? this.syncCanvas({
        selected: selected
    }) : data;
}
function updateSelectedLabel() {
    if (this.isEmbed()) return;
    if (this.getFilesSidebar()?.FilesSidebarPrompt?.state?.focused) this.getFilesSidebar().FilesSidebarPrompt.Label.SearchOverlay.SelectedResource.update();
}
function activateChosen(val, opts = {}) {
    const data = this.getCanvasScope();
    if (!this.call('isDefined', val)) val = this;
    else if (this.call('isString', val)) {
        const type = this.getType(val);
        const isOnCurrent = this.call('inOnCurrentCanvasPage', type, val);
        let onOtherCanvas = null;
        if (isOnCurrent) onOtherCanvas = null;
        else onOtherCanvas = this.call('findKeyInOtherCanvasPages', type, val);
        if (onOtherCanvas) this.call('openCanvasPage', onOtherCanvas);
        val = data.Collection?.lookdown((el)=>el.state?.key === val);
    }
    const chosen = data.chosen = this.call('isDefined', val) ? val : data.selected;
    if (chosen && chosen.state) {
        const { key: key1 } = chosen.state;
        // this.addToTabs(key)
        this.updateRecents(key1);
        this.changeCodePriority('component', opts);
        if (this.call('getSidebarContent') !== 'ARTBOARD_TYPES') this.call('setSidebarContent', 'ARTBOARD_TYPES');
    }
    return !opts.preventSync ? this.syncCanvas({
        chosen: chosen
    }) : data;
}
function activateContext2(ev, val) {
    if (ev?.stopPropagation) ev.stopPropagation();
    const data = this.getCanvasScope();
    const isString = this.call('isString', val);
    const isDefined = this.call('isDefined', val);
    const isNull = val === null;
    if (!ev || isNull) return this.syncCanvas({
        inContext: null,
        positions: {
            contextX: null,
            contextY: null
        }
    });
    if (isString) {
        const onOtherCanvas = this.call('findKeyInOtherCanvasPages', val) || 'Default';
        if (onOtherCanvas) this.call('openCanvasPage', onOtherCanvas);
        val = this.getCanvasCollection().lookdown((el)=>el.state?.key === val) || this.getItem(val) || this.getHovered();
    } else if (!isDefined) val = this;
    const inContext = data.inContext = val;
    const { clientX, clientY } = ev;
    return this.syncCanvas({
        inContext: inContext || null,
        positions: {
            contextX: clientX || null,
            contextY: clientY || null
        }
    });
}
function activateContext(ev, val, preventDefault = true, stopPropagation = true) {
    if (ev?.stopPropagation && stopPropagation) ev.stopPropagation();
    if (ev?.preventDefault && preventDefault) ev.preventDefault();
    const data = this.getCanvasScope();
    const isString = this.call('isString', val);
    const isDefined = this.call('isDefined', val);
    const updateContextMenuPosition = ()=>{
        const ContextMenu = this.getPlayground().lookdown('ContextMenu');
        const Overflow = this.getFilesSidebar()?.Overflow;
        const target = this._contextMenuTarget;
        const PANEL_OFFSET = {
            TOP: 10
        };
        if (ContextMenu && target && Overflow) {
            const targetRect = target.getBoundingClientRect();
            const overflowRect = Overflow.node.getBoundingClientRect();
            const contextMenuRect = ContextMenu.node.getBoundingClientRect();
            const contextMenuHeight = contextMenuRect.height;
            const rightPosition = ev.clientX;
            const viewportHeight = window.innerHeight;
            let topPosition = targetRect.top + targetRect.height / 2;
            if (topPosition + contextMenuHeight > viewportHeight) topPosition = viewportHeight - contextMenuHeight - PANEL_OFFSET.TOP;
            const isOutOfBounds = targetRect.bottom > overflowRect.bottom || targetRect.top < overflowRect.top;
            if (!isOutOfBounds) ContextMenu.setNodeStyles({
                transform: `translate(${rightPosition}px, ${topPosition}px)`
            });
            return isOutOfBounds;
        }
    };
    const clearContextMenu = ()=>{
        window.removeEventListener('scroll', updateContextMenuPosition, true);
        window.removeEventListener('resize', updateContextMenuPosition, true);
        this._contextMenuTarget = null;
        return this.syncCanvas({
            inContext: null,
            positions: {
                contextX: null,
                contextY: null
            }
        });
    };
    const isNull = val === null;
    if (!ev || isNull) return clearContextMenu();
    if (isString) {
        const type = this.getType(val);
        const isOnCurrent = this.call('inOnCurrentCanvasPage', type, val);
        let onOtherCanvas = null;
        if (!isOnCurrent) onOtherCanvas = this.call('findKeyInOtherCanvasPages', val);
        if (onOtherCanvas) this.call('openCanvasPage', onOtherCanvas);
        val = this.getCanvasCollection().lookdown((el)=>el.state?.key === val) || this.getItem(val) || this.getHovered();
    } else if (!isDefined) val = this;
    const inContext = data.inContext = val;
    const { clientX, clientY } = ev;
    this._contextMenuTarget = val && val.node ? val.node : null;
    const handleScroll = ()=>{
        const hideContextMenu = updateContextMenuPosition();
        if (hideContextMenu) clearContextMenu();
    };
    const handleResize = ()=>{
        const hideContextMenu = updateContextMenuPosition();
        if (hideContextMenu) clearContextMenu();
    };
    window.addEventListener('scroll', handleScroll, true);
    window.addEventListener('resize', handleResize, true);
    requestAnimationFrame(()=>{
        updateContextMenuPosition();
    });
    return this.syncCanvas({
        inContext: inContext || null,
        positions: {
            contextX: clientX || null,
            contextY: clientY || null
        }
    });
}
function changeCodePriority(val, opts = {}) {
    if (!this.call('isDefined', val)) val = this;
    const data = this.getCanvasScope();
    const priorityCode = data.priorityCode = val;
    return !opts.preventSync ? this.syncCanvas({
        priorityCode: priorityCode
    }) : data;
}
function updateRecents(key1) {
    const platformState = this.getRootState();
    const { appKey } = platformState;
    const { recents } = platformState;
    const recentExists = recents.indexOf(key1);
    if (recentExists > -1) this.call('removeFromArray', recents, recentExists);
    if (key1) {
        recents.unshift(key1);
        if (appKey) window.localStorage.setItem(`recents_${appKey}${platformState.branch}`, JSON.stringify(recents));
    }
}
function activateFunction(val) {
    if (!this.call('isDefined', val)) val = this;
    const data = this.getCanvasScope();
    const activeFunction = data.activeFunction = val;
    if (activeFunction) this.changeCodePriority('function');
    return this.syncCanvas({
        activeFunction: activeFunction
    });
}
function activateState(val) {
    if (!this.call('isDefined', val)) val = this;
    const data = this.getCanvasScope();
    const activeState = data.activeState = val;
    if (activeState) this.changeCodePriority('state');
    return this.syncCanvas({
        activeState: activeState
    });
}
function activateDs(val) {
    if (!this.call('isDefined', val)) val = this;
    const data = this.getCanvasScope();
    const activeDs = data.activeDs = val;
    if (activeDs) this.changeCodePriority('designSystem');
    return this.syncCanvas({
        activeDs: activeDs
    });
}
function getHovered() {
    return this.getCanvasScope('hovered');
}
function getHoveredKey() {
    return this.getHovered()?.state?.key;
}
function getSelected() {
    return this.getCanvasScope('selected');
}
function getSelectedKey() {
    return this.getSelected()?.state?.key;
}
function getChosen() {
    return this.getCanvasScope('chosen');
}
function getChosenKey() {
    const chosen = this.getChosen();
    return this.call('isString', chosen) ? chosen : chosen?.state?.key;
}
function getInContext() {
    return this.getCanvasScope('inContext');
}
function getInContextKey() {
    return this.getInContext()?.state?.key;
}
function getCanvasPositions() {
    return this.getCanvasScope('positions') || {};
}
function zoomToNode(zoomedElement, opts = {}) {
    const canvasScope = this.getCanvasScope();
    const frameWindow = this.getCanvasFrameWindow();
    const { innerWidth, innerHeight } = frameWindow;
    if (!canvasScope.panzoomInstance || !zoomedElement) return;
    const getTransform = canvasScope.panzoomInstance.getTransform();
    if (opts.useZoom) canvasScope.panzoomInstance.zoomAbs(getTransform.x, getTransform.y, 0.65);
    setTimeout(()=>{
        const zoomedNode = zoomedElement.node;
        const { x, y, width, height } = zoomedNode.getBoundingClientRect();
        const panToX = x - (innerWidth - width) / 2;
        const panToY = y - (innerHeight - height) / 2;
        canvasScope.panzoomInstance.moveBy(-panToX, -panToY, true);
    }, 50);
}
async function updateGridsInSchema(items) {
    const changes = items.map((item)=>{
        if (!item.el?.ref) {
            console.error('[updateGridsInSchema] Missing element reference', item);
            return null;
        }
        const { state } = item.el.ref;
        if (!state || state.package) return null // skip packaged components or invalid state
        ;
        const type = this.getType(state);
        const path = [
            'schema',
            type,
            state.key,
            'settings',
            'gridOptions'
        ];
        const value = item._orig;
        // Skip if value did not actually change – avoids unnecessary state churn
        const currentVal = state.settings?.gridOptions;
        const isSame = currentVal && JSON.stringify(currentVal) === JSON.stringify(value);
        if (isSame) return null;
        if (!state.settings) state.settings = {};
        state.settings.gridOptions = value;
        return [
            'update',
            path,
            value
        ];
    }).filter(Boolean);
    if (!changes.length) return; // nothing to apply
    // Apply changes via CollabService but prevent a reactive run-through that would
    // immediately trigger another re-render, causing an infinite loop.
    // When the server eventually confirms (via commit) Canvas will still receive
    // the version update.
    try {
        this.sdk.updateData(changes, {
            skipCanvasUpdate: true,
            skipRuntimeTests: true,
            message: 'Updated gridOptions on artboards at ' + this.getActiveCanvasPage()
        });
    } catch (e) {
        // If the collab connection is not yet established we fall back to applying
        // the changes locally so that the UI stays in sync.
        if (this.sdk?.getService) {
            const collab = this.sdk.getService('collab');
            collab?._stateManager?.applyChanges(changes, {
                preventUpdate: true
            });
        }
    }
}
function getCleanCanvasScope(data) {
    const obj = {};
    const allowedKeys = [
        'explorer',
        'editorPanels',
        'docs',
        'previewSize',
        'modal',
        'followingUser',
        'openUrl',
        'editorActive',
        'activeCanvasPage',
        'hoverLayer',
        'activeLayer',
        'positions',
        'chosenPos',
        'monaco',
        'monacoSelection',
        'preferredEditor',
        'editorActive',
        'priorityCode',
        'showLayersSchema'
    ];
    const elementToUpdate = this.getWindowKeys();
    const allowedNodes = [
        'hovered',
        'selected',
        'chosen',
        'inContext'
    ];
    for(const prop in data){
        const val = data[prop];
        const allowed = allowedKeys.includes(prop) || elementToUpdate.includes(prop);
        if (allowed) obj[prop] = val;
        if (allowedNodes.includes(prop)) obj[prop] = this.call('isString', val) ? val : val?.state?.key ? val?.state?.key : null;
    }
    return obj;
}
function syncSocketCanvasData(clientData, opts = {}) {
    const platformState = this.getRootState();
    const canvasData = this.getCanvasScope();
    if (!canvasData) return;
    const { userId, settings, followingUser } = platformState;
    if (!settings.syncCanvas) return;
    if (!followingUser || opts.forceSendSocket) {
        if (this.sdk?.isConnected()) this.sdk.sendCursor({
            [userId]: {
                ...clientData
            }
        });
    } else if (clientData.positions?.mouseX || clientData.chosenPos?.mouseX) {
        if (this.sdk?.isConnected()) this.sdk.sendCursor({
            [userId]: {
                positions: clientData.positions?.mouseX && {
                    mouseX: clientData.positions.mouseX,
                    mouseY: clientData.positions.mouseY
                },
                chosenPos: clientData.chosenPos?.mouseX && {
                    mouseX: clientData.chosenPos.mouseX,
                    mouseY: clientData.chosenPos.mouseY
                }
            }
        });
    }
    return clientData;
}
function syncCanvas(data = {}, opts = {}) {
    const platformState = this.getRootState();
    const canvasData = this.getCanvasScope();
    const { userId } = platformState;
    const resetObjs = (key1)=>{
        if (data[key1]) data[key1] = {
            ...canvasData[key1],
            ...data[key1]
        };
    };
    resetObjs('positions');
    resetObjs('chosenPos');
    resetObjs('monaco');
    resetObjs('monacoSelection');
    // Merge incoming changes into current canvasData
    this.call('overwrite', canvasData, data);
    // Persist cleaned client state to rootState.clients
    if (!platformState.clients) platformState.clients = {};
    const reservedClientKeys = [
        'localhost',
        'cli',
        'platform'
    ];
    let clientKey = userId;
    if (reservedClientKeys.includes(clientKey)) clientKey = `user_${clientKey}`;
    const cleanData = platformState.clients[clientKey] = this.getCleanCanvasScope(canvasData);
    // Store to localStorage when relevant ( skip continuous mouse move spam )
    const localStorageKey = `${this.getAppKey()?.split('.')[0]}__data`;
    const changesWithValues = Object.values(cleanData).filter((v)=>v).length;
    if (!data.positions && changesWithValues) this.call('setLocalStorage', localStorageKey, cleanData);
    // Forward minimal delta via socket
    return this.call('syncSocketCanvasData', this.getCleanCanvasScope(data), opts);
}
function syncCanvasPositions(positions) {
    const data = this.getCanvasScope();
    if (!data) return;
    return this.syncCanvas({
        positions: positions
    });
}
function canvasFade(condition) {
    const { Fade } = this.getCanvas();
    if (condition) {
        Fade.fadeIn.background = `var(--theme-modalFade-${this.getRootState('globalTheme')}-backgroundColor)`;
        Fade.setNodeStyles(Fade.fadeIn);
    } else Fade.setNodeStyles(Fade.fadeOut);
}
function toggleLoading() {
    const data = this.getCanvasScope();
    if (!data) return;
    // eslint-disable-next-line no-unused-vars
    this.variables({
        loading: data?.loading
    }).changed((_)=>{
        if (data.loading) this.parent.LoadingGifSection?.setNodeStyles?.(this.parent.LoadingGifSection?.fadeIn);
        else this.parent.LoadingGifSection?.setNodeStyles?.(this.parent.LoadingGifSection?.fadeOut);
    });
}
const resetCanvasPan = function resetCanvasPan() {
    const canvasScope = this.getCanvasScope();
    const activeCanvasPage = this.getActiveCanvasPage();
    const localStorageKey = `${this.getAppKey()?.split('.')[0]}___${activeCanvasPage}`;
    const fromStorage = JSON.parse((this.call('sameOriginTop')?.localStorage || window.localStorage).getItem(localStorageKey));
    const { x, y, scale } = fromStorage || this.getCanvasPositions() || {};
    const { panzoomInstance } = canvasScope;
    if (panzoomInstance) {
        panzoomInstance.moveTo(x || 0, y || 0, scale || 1);
        panzoomInstance.zoomAbs(x || 0, y || 0, scale || 1);
    }
};
function getCanvasScopeFromStorageOrData() {
    const localStorageData = this.getLocalStorageCanvasData();
    const platformState = this.getRootState();
    const { userId } = platformState;
    return localStorageData || platformState.clients?.[userId];
}
function isDashboard() {
    const { pathname } = window.location;
    if (pathname.startsWith('/dashboard')) return true;
}
function isAuthorised() {
    return Boolean(this.sdk?.getAuthToken());
}
function isFree() {
    return Boolean(this.getRootState('tier') === 'free');
}
function isCanvas(routeOverride) {
    const pathname = routeOverride || window.location.pathname;
    if (pathname.startsWith('/canvas') || pathname.startsWith('/embed')) return true;
    const [, user, project] = pathname.split('/');
    if (!user || !project || this.getCanvasPathname() !== `/${user}/${project}`) return;
    return Boolean(this.getCanvasScope());
}
function isEmbed() {
    return this.getRootState('isEmbed');
}
function isEditMode() {
    return !this.isEmbed() && this.sdk?.hasPermission('editMode');
}
function isAdmin() {
    return [
        'owner',
        'admin'
    ].includes(this.getRootState('projectRole'));
}
function isOwner() {
    return [
        'owner'
    ].includes(this.getRootState('projectRole'));
}
function isReadOnly() {
    return !this.isEditMode();
}
function preventLocationChanges(window1) {
// Intercept beforeunload/navigation attempts
// window.addEventListener('beforeunload', (e) => {
//   e.preventDefault()
// })
// const expectedUrl = this.getCanvasPathnameAnyway()
// new MutationObserver(() => {
//   if (window.location.href !== expectedUrl) {
//     console.warn('Blocked forced navigation')
//     window.location.replace(expectedUrl)
//   }
// }).observe(document, { childList: true, subtree: true })
}
function isDocs() {
    const { pathname } = window.location;
    if ([
        '/docs',
        '/tutorials',
        '/index'
    ].some((p)=>pathname === p || pathname.startsWith(`${p}/`))) return true;
}
function isDevelopers() {
    const { pathname } = window.location;
    if ([
        '/developers'
    ].some((p)=>pathname === p || pathname.startsWith(`${p}/`))) return true;
}
function getCanvasPathname() {
    const { workingProjectOwner, workingProjectKey } = this.getRootState() || {};
    if (!workingProjectOwner || !workingProjectKey) return;
    return `/${workingProjectOwner}/${workingProjectKey}`;
}
function getCanvasPathnameAnyway() {
    if (this.getCanvasPathname()) return this.getCanvasPathname();
    let { appKey, owner } = this.getRootState() || {};
    appKey = appKey?.split('.')[0];
    owner = owner?.username;
    if (!owner) {
        const { members } = this.getRootState() || {};
        owner = members?.find((m)=>m.role === 'owner')?.username;
    }
    return appKey && owner ? `/${owner}/${appKey}` : '/dashboard';
}
function getCanvasPathnameLocal() {
    const s = this.state;
    return `/${s.owner?.username}/${s.key.split('.')[0]}`;
}
function addOnCanvasStr(codeStr, type = 'functions') {
    const Canvas = this.getCanvas();
    const Collection = this.getCanvasCollection();
    if (Collection) {
        const { contentWindow } = Canvas.Iframe.node;
        const evalCode = this.call('evalStringCodeUnsafe', codeStr, {
            secrets: this.getSecrets(),
            window: contentWindow
        });
        const ctx = Collection.context;
        ctx[type][key] = evalCode;
        ctx.utils[key] = evalCode;
        const { packages } = contentWindow;
        packages[type][key] = evalCode;
        packages.utils[key] = evalCode;
    } else this.error('Canvas Collection was not found');
}
function openArtboardItem(type = 'components', key1) {
    if (!this.call('inOnCurrentCanvasPage', type, key1)) this.call('openCanvasPage', this.call('findKeyInOtherCanvasPages', key1) || 'Default');
    const t = window.setTimeout(()=>{
        this.activateSelected(key1);
        const data = this.getCanvasScope();
        const t2 = window.setTimeout(()=>{
            this.zoomToNode(data.selected);
            clearTimeout(t2);
        }, 100);
        clearTimeout(t);
    }, 35);
}
function openItem(type = 'components', key1) {
    if (this.call('hasType', 'ARTBOARD_TYPES', type)) return this.call('openArtboardItem', type, key1);
    if (this.call('hasType', 'FUNCTION_TYPES', type)) return this.activateFunction(key1);
    if (this.call('hasType', 'STATE_TYPES', type)) return this.activateState(key1);
    if (this.call('hasType', 'ASSETS_TYPES', type)) return this.call('openModal', '/edit-file', {
        key: key1
    });
}
function getCanvasMode() {
    return this.getCanvasScope('canvasMode');
}
function isCanvasMode(mode) {
    const canvasMode = this.getCanvasScope('canvasMode');
    if (mode === 'defaultMode') return !canvasMode || canvasMode === 'defaultMode';
    return canvasMode === mode;
}
function setCanvasMode(mode) {
    return this.getCanvasScope().canvasMode = mode;
}

});

parcelRegister("h2VO7", function(module, exports) {

$parcel$export(module.exports, "findComponentOnCanvas", () => findComponentOnCanvas);
$parcel$export(module.exports, "findWhereItsUsedOnCanvas", () => findWhereItsUsedOnCanvas);
$parcel$export(module.exports, "refreshComponentsWhereReferencedOnCanvas", () => refreshComponentsWhereReferencedOnCanvas);
$parcel$export(module.exports, "refreshComponentOnCanvas", () => refreshComponentOnCanvas);
$parcel$export(module.exports, "queueUpdateItemInCanvas", () => queueUpdateItemInCanvas);
$parcel$export(module.exports, "refreshCanvasComponentsQueue", () => refreshCanvasComponentsQueue);
$parcel$export(module.exports, "checkIfReferencedInOtherCanvasItems", () => checkIfReferencedInOtherCanvasItems);
$parcel$export(module.exports, "openComponent", () => openComponent);
function findComponentOnCanvas(key) {
    const Collection = this.getCanvasCollection();
    return Collection?.lookdown((el)=>{
        return el.state?.key === key && el.Flex;
    });
}
function findWhereItsUsedOnCanvas(key) {
    const Collection = this.getCanvasCollection();
    return Collection.lookdownAll((el)=>el?.state?.uses?.includes(key));
}
async function refreshComponentsWhereReferencedOnCanvas(key, opts) {
    const foundInOtherComponents = this.findWhereItsUsedOnCanvas(key);
    if (foundInOtherComponents) await foundInOtherComponents.forEach(async (v)=>{
        if (v.Flex) await v.update({}, {
            forceReset: true,
            ...opts
        });
    });
}
async function refreshComponentOnCanvas(key, obj, opts = {}) {
    const activeElement = this.findComponentOnCanvas(key);
    if (!activeElement) return this.warn('Cant find on canvas');
    try {
        await activeElement.state.replace(obj, {
            forceReset: true,
            onError: opts.onError
        });
    } catch (e) {
        opts.onError?.(e);
    }
    await this.call('refreshComponentsWhereReferencedOnCanvas', key, opts);
}
function queueUpdateItemInCanvas(key) {
    const data = this.getCanvasScope();
    if (!data.queueToUpdate) data.queueToUpdate = [];
    if (data.queueToUpdate.indexOf(key) === -1) data.queueToUpdate.push(key);
}
async function refreshCanvasComponentsQueue() {
    const data = this.getCanvasScope();
    const { queueToUpdate } = data;
    if (!queueToUpdate || !queueToUpdate.length) return;
    queueToUpdate.forEach((key)=>{
        const type = this.getType(key);
        this.call('updateItemInCanvas', type, key);
    });
    data.queueToUpdate = [];
}
function checkIfReferencedInOtherCanvasItems(type, key) {
    const usedInComponents = Object.values(this.getSchema('components')).filter((v)=>v.uses?.includes(key)).map((v)=>v.key);
    const usedInPages = Object.values(this.getSchema('pages')).filter((v)=>v.uses?.includes(key)).map((v)=>v.key);
    const usedIn = usedInComponents.concat(usedInPages);
    const confirmDeps = `Component is used in "${usedIn.join(', ')}" ${type.slice(0, -1)}, do you want to remove it anyway?`;
    if (usedIn.length && !window.confirm(confirmDeps)) return false;
    return usedIn;
}
async function openComponent(opts = {}) {
    const { props, state } = this;
    const { value, extend } = state;
    let key = value || state.key;
    if (extend) key = Array.isArray(extend) ? extend[0] : extend;
    if (props?.extend) key = props.extend;
    const type = this.getType(key);
    if (!type) return;
    const SMBLS_COMPONENT = this.context[type][key];
    const PROJECT_COMPONENT = this.getItem(key);
    let isComponent = this.call('checkIfKeyIsComponent', key) && (SMBLS_COMPONENT || PROJECT_COMPONENT);
    if (!isComponent) {
        const DEFAULT_COMPONENT = await this.getDefaultComponents()[key];
        if (DEFAULT_COMPONENT) isComponent = DEFAULT_COMPONENT;
        else return;
    }
    const s = this.getCanvasCollection()?.lookdown((el)=>el.state?.key === key);
    if (s) this.activateSelected(s);
    if (!opts.chosenOnCmd && !this.getRootState('isModifierPressed')) this.activateChosen(s);
}

});

parcelRegister("iVl2P", function(module, exports) {

$parcel$export(module.exports, "getTabs", () => getTabs);
$parcel$export(module.exports, "getTabsState", () => getTabsState);
$parcel$export(module.exports, "refreshTabs", () => refreshTabs);
$parcel$export(module.exports, "addToTabs", () => addToTabs);
$parcel$export(module.exports, "isInTabs", () => isInTabs);
$parcel$export(module.exports, "closeTab", () => closeTab);
$parcel$export(module.exports, "cleanTabs", () => cleanTabs);
$parcel$export(module.exports, "closeComponentTab", () => closeComponentTab);
$parcel$export(module.exports, "updateTabsLocalStorage", () => updateTabsLocalStorage);
function getTabs() {
    return this.getCanvas().parent.CanvasNavbar;
}
function getTabsState() {
    return this.getRootState().activeTabs;
}
function refreshTabs() {
    this.getTabs().update();
}
function addToTabs(key, opts = {}) {
    const platformState = this.getRootState();
    const activeTabs = this.getTabsState();
    const item = this.getSchemaItem(key);
    const type = this.getType(key);
    const routeExists = activeTabs.filter((v)=>v.key === key);
    if (!routeExists.length) activeTabs.push({
        key: key,
        type: type,
        title: item?.title || key
    });
    this.updateTabsLocalStorage();
    platformState.quietReplace({
        activeTabs: activeTabs
    });
    if (!opts.preventUpdate) this.refreshTabs();
}
function isInTabs(key) {
    const platformState = this.getRootState();
    const { activeTabs } = platformState;
    return activeTabs.filter((v)=>v.key === key)[0];
}
function closeTab(key, opts = {}) {
    const platformState = this.getRootState();
    const { activeTabs } = platformState;
    const activeIndex = activeTabs.findIndex((v)=>v.key === key);
    if (activeIndex < 0) return;
    if (activeTabs[activeIndex]?.key === this.getChosenKey()) this.activateChosen(null);
    this.call('removeFromArray', activeTabs, activeIndex);
    this.updateTabsLocalStorage();
    platformState.quietReplace({
        activeTabs: activeTabs
    });
    if (!opts.preventUpdate) this.refreshTabs();
}
function cleanTabs() {
    const platformState = this.getRootState();
    // eslint-disable-next-line no-multi-assign
    const activeTabs = platformState.activeTabs = [];
    const key = `activeTabs_${platformState.appKey}${platformState.branch}`;
    window.localStorage.removeItem(key);
    if (platformState.appKey) window.localStorage.setItem(key, JSON.stringify(activeTabs));
}
function closeComponentTab() {
    const activeTabs = this.getTabsState();
    activeTabs.forEach(()=>{
    // if (val.route === '/editor/' + componentKey) closeTab(key)
    });
}
function updateTabsLocalStorage() {
    const platformState = this.getRootState();
    const { activeTabs } = platformState;
    const key = `activeTabs_${platformState.appKey}${platformState.branch}`;
    window.localStorage.removeItem(key);
    if (platformState.appKey) window.localStorage.setItem(key, JSON.stringify(activeTabs));
}

});

parcelRegister("hbJvK", function(module, exports) {

$parcel$export(module.exports, "getWindow", () => getWindow);
$parcel$export(module.exports, "getWindowElements", () => getWindowElements);
$parcel$export(module.exports, "getWindowKeys", () => getWindowKeys);
$parcel$export(module.exports, "setWindow", () => setWindow);
$parcel$export(module.exports, "openWindow", () => openWindow);
$parcel$export(module.exports, "closeWindow", () => closeWindow);
$parcel$export(module.exports, "refreshWindow", () => refreshWindow);
$parcel$export(module.exports, "toggleWindow", () => toggleWindow);
$parcel$export(module.exports, "isWindowMinimized", () => isWindowMinimized);
$parcel$export(module.exports, "isWindowExpanded", () => isWindowExpanded);
$parcel$export(module.exports, "minimizeWindow", () => minimizeWindow);
$parcel$export(module.exports, "toggleExpandWindow", () => toggleExpandWindow);
$parcel$export(module.exports, "expandWindow", () => expandWindow);
$parcel$export(module.exports, "toggleLibrary", () => toggleLibrary);
function getWindow(key) {
    const data = this.getCanvasScope();
    if (!key) return data || {};
    return data?.[key];
}
function getWindowElements(key) {
    const DynamicIsland = this.getDynamicIsland();
    const DocsView = this.getDocsView();
    const map = {
        explorer: [
            // Canvas.parent.DsNavbar,
            // CanvasNavbar.CanvasPanel,
            DynamicIsland
        ],
        // editorPanels: EditorPanels,
        docs: DocsView,
        modal: this.getCanvasModal()
    };
    return key ? map[key.split('Minimized')[0]] : map;
}
function getWindowKeys(excl = []) {
    const keys = Object.keys(this.getWindowElements());
    return excl ? this.call('filterArrays', keys, excl) : keys;
}
async function setWindow(key, val, opts = {
    preventUpdate: [
        'Iframe'
    ]
}) {
    const data = this.getCanvasScope();
    const elementsToUpdate = this.getWindowElements(key);
    const applyElementUpdate = async (elem)=>{
        if (elem.props['.isWindowActive']) elem.setNodeStyles(val ? elem.props['.isWindowActive'] : elem.props['!isWindowActive']);
        else await elem.update({}, opts);
    };
    data[key] = val;
    if (this.call('isArray', elementsToUpdate)) elementsToUpdate.forEach((item)=>{
        if (!item.update) return console.error('no update for', item);
        const t = setTimeout(async ()=>{
            await applyElementUpdate(item);
            clearTimeout(t);
        }, 15);
    });
    else if (!elementsToUpdate?.update) this.warn('No update for', key, elementsToUpdate);
    else if (!opts.forceUpdate && this.call('isBoolean', val)) elementsToUpdate.setNodeStyles({
        display: val ? 'flex' : 'none'
    });
    else await applyElementUpdate(elementsToUpdate);
    this.call('setCookie', key, val);
    this.syncCanvas({
        [key]: val
    });
}
function openWindow(key, opts) {
    return this.setWindow(key, true, {
        forceUpdate: true,
        ...opts
    });
}
function closeWindow(key, opts) {
    return this.setWindow(key, false, {
        forceUpdate: true,
        ...opts
    });
}
function refreshWindow(key, opts) {
    const data = this.getCanvasScope();
    this.setWindow(key, data[key], {
        forceUpdate: true,
        ...opts
    });
}
function toggleWindow(key, opts) {
    const data = this.getCanvasScope();
    this.setWindow(key, !data[key], {
        forceUpdate: true,
        ...opts
    });
}
function isWindowMinimized(key) {
    const data = this.getCanvasScope();
    return data[`${key}Minimized`];
}
function isWindowExpanded(key) {
    return !this.isWindowMinimized(key);
}
function minimizeWindow(key) {
    const data = this.getCanvasScope();
    data[`${key}Minimized`] = true;
    return this.refreshWindow(key);
}
function toggleExpandWindow(key) {
    const data = this.getCanvasScope();
    data[`${key}Minimized`] = !data[`${key}Minimized`];
    return this.refreshWindow(key);
}
function expandWindow(key) {
    const data = this.getCanvasScope();
    data[`${key}Minimized`] = false;
    return this.refreshWindow(key);
}
function toggleLibrary() {
    this.toggleWindow('library');
    this.getDynamicIsland().setNodeStyles(this.getDynamicIsland().props[this.getWindow('library') ? '.isLibraryActive' : '!isLibraryActive']);
    this.getDynamicIsland().Library.setNodeStyles(this.getDynamicIsland().Library.props[this.getWindow('library') ? '.isVisible' : '!isVisible']);
    this.getDynamicIsland().FilesSidebar.setNodeStyles(this.getDynamicIsland().FilesSidebar.props[this.getWindow('library') ? '!isVisible' : '.isVisible']);
}

});

parcelRegister("9Owoy", function(module, exports) {

$parcel$export(module.exports, "listAll", () => listAll);
$parcel$export(module.exports, "filterKeys", () => filterKeys);
$parcel$export(module.exports, "listAllAsArray", () => listAllAsArray);
$parcel$export(module.exports, "listSidebar", () => listSidebar);
function listAll(type, opts = {}) {
    const designSystemList = [
        'reset',
        'sequence',
        'unit',
        'font',
        'font_family',
        'font_face',
        'media',
        'gradient',
        'shadow',
        'icons',
        'semantic_icons',
        'timing',
        'document',
        'breakpoints',
        'devices',
        'cases',
        'animation',
        'svg',
        'grid',
        'class'
    ];
    const designSystem = opts.activeFileSidebar === 'Local' ? this.getDesignSystem() : opts.designSystem;
    // default
    if (designSystemList.includes(type)) return designSystem[type];
    // specific logics
    if (type === 'color') {
        const allColors = designSystem[type];
        return allColors && Object.entries(allColors).reduce((initial, [key, value])=>{
            if (this.call('isString', value)) return {
                ...initial,
                [key]: value
            };
            return initial;
        }, {});
    }
    if (type === 'semantic_color') {
        const allColors = designSystem.color;
        return allColors && Object.entries(allColors).reduce((initial, [key, value])=>{
            if (!this.call('isString', value)) return {
                ...initial,
                [key]: value
            };
            return initial;
        }, {});
    }
    if (type === 'theme') {
        const allThemes = designSystem[type];
        return allThemes && Object.entries(allThemes).reduce((initial, [key, value])=>{
            if (key !== 'document') return {
                ...initial,
                [key]: value
            };
            return initial;
        }, {});
    }
    if (type === 'global_theme') return designSystem.theme?.document;
    if (type === 'spacing') return this.filterKeys(designSystem.spacing, true);
    if (type === 'typography') return this.filterKeys(designSystem.typography, true);
    if (type === 'templates') return this.filterKeys(designSystem.typography?.templates, false);
    return opts[type];
}
function filterKeys(obj, keepAt = false) {
    if (!obj || typeof obj !== 'object') return obj;
    return Object.fromEntries(Object.entries(obj).filter(([key])=>key[0] === '@' === keepAt));
}
function listAllAsArray(type, opts = {}) {
    const data = this.call('listAll', type, opts);
    if (!data) return [];
    const res = Object.keys(data).reduce((initial, key)=>{
        const map = {
            key: key,
            type: type,
            value: data[key],
            ...opts.withSchema ? {} : {}
        };
        if (!opts.search) return [
            ...initial,
            map
        ];
        if (key.toLowerCase().includes(opts.search.toLowerCase()) || typeof data[key] === 'string' && data[key].toLowerCase().includes(opts.search.toLowerCase())) return [
            ...initial,
            map
        ];
        return initial;
    }, []);
    if (!res.length && opts.search) this.state.update({
        noResults: true
    });
    if (opts.sort && opts.sortIf) return res.sort(opts.sort);
    return res;
}
async function listSidebar(type, opts = {
    activeFileSidebar: 'Local'
}) {
    const activeFileSidebar = opts.activeFileSidebar || 'Local';
    const data = await this.call('getDynamicIslandDataByCategory', activeFileSidebar);
    const isLocal = activeFileSidebar === 'Local';
    const designSystem = isLocal ? this.getDesignSystem() : opts.designSystem;
    return this.call('listAllAsArray', type, {
        withSchema: false,
        ...opts,
        activeFileSidebar: activeFileSidebar,
        ...data
    }).filter((v)=>{
        const allowGlobals = [
            'dependencies',
            'secrets'
        ];
        if (allowGlobals.includes(type)) return true;
        if (designSystem?.[type]) return true;
        // TODO: remove components when variants are implemented
        const dotsAllowedList = [
            'files',
            'dependencies',
            'secrets',
            'components'
        ];
        if (!dotsAllowedList.includes(type) && v.key.includes('.')) return false;
        if (opts.search) return true;
        if (isLocal && [
            'pages',
            'components'
        ].includes(type)) return this.call('inOnCurrentCanvasPage', type, v.key);
        return true;
    });
}

});

parcelRegister("bgsWn", function(module, exports) {

$parcel$export(module.exports, "setDesignSystem", () => setDesignSystem);
$parcel$export(module.exports, "updateDesignSystemOnCanvas", () => updateDesignSystemOnCanvas);
$parcel$export(module.exports, "getDesignSystem", () => getDesignSystem);
$parcel$export(module.exports, "isBuiltinDS", () => isBuiltinDS);
$parcel$export(module.exports, "updateDesignSystem", () => updateDesignSystem);
$parcel$export(module.exports, "bulkUpdateDesignSystem", () => bulkUpdateDesignSystem);
$parcel$export(module.exports, "activeAddingFloatingPanel", () => activeAddingFloatingPanel);
/**
 * Resets the Design System with the provided object.
 * @param {object} obj - Object to reset the Design System with.
 * @param {object} [opts={}] - Options for resetting the Design System.
 */ function setDesignSystem(obj, opts = {}) {
    const { version, ...value } = obj;
    const designSystem = this.getData().designSystem = value;
    this.sdk.updateData([
        'update',
        [
            'designSystem'
        ],
        designSystem
    ], {
        message: 'Reset Design System',
        ...opts
    });
    this.updateDesignSystemOnCanvas(this.getDesignSystem(), opts);
}
function updateDesignSystemOnCanvas(obj) {
    const Collection = this.getCanvasCollection();
    if (!Collection) return;
    Collection.call('reinit', Collection.call('deepClone', obj), {
        preventInject: true
    });
    const vars = Collection.lookup('vars');
    if (vars?.update) vars.update();
}
function getDesignSystem(type) {
    const designSystem = this.getData('designSystem');
    const defaultData = this.getBuiltins();
    if (type) return {
        ...defaultData[type.toUpperCase()],
        ...designSystem[type.toUpperCase()]
    };
    return designSystem;
}
function isBuiltinDS(type, field) {
    if (!type || !field) return false;
    const defaultData = this.getDefaults('DS_DEFAULTS') // await this.getDefaultDesignSystem()
    ;
    return Boolean(defaultData?.[type.toUpperCase()]?.[field]);
}
async function updateDesignSystem(key, val, opts = {}) {
    const path = [
        'designSystem'
    ].concat(this.call('isArray', key) ? key : key.split('.'));
    // capitalize keys
    if (/[a-z]/u.test(path[1])) path[1] = path[1].toUpperCase();
    this.sdk.updateData(val ? [
        [
            'update',
            path,
            val
        ]
    ] : [
        [
            'delete',
            path
        ]
    ], {
        message: val ? `Updated ${key}` : `Removed ${key}`,
        ...opts
    });
    const type = path[path.length - 2];
    // const key = path[path.length - 1]
    if (type === 'MEDIA') this.getCanvas().update();
    else this.updateDesignSystemOnCanvas(this.getDesignSystem(), opts);
    if (!opts.preventSidebarUpdate) {
        let sectionType = type.toLowerCase();
        if (opts.isSemanticColor) sectionType = 'semantic_color';
        else if (opts.isGlobalTheme) sectionType = 'global_theme';
        else if (opts.isTextStyles) sectionType = 'templates';
        const updatedSection = await this.call('rerenderFileSidebarByType', sectionType);
        if (!updatedSection) await this.getDynamicIsland()?.update();
    }
}
function bulkUpdateDesignSystem(changes, message, opts = {}) {
    if (!message || !changes) return;
    const parsed = changes.map(({ type, path: p, value })=>{
        const path = p.includes('designSystem') ? p : [
            'designSystem',
            ...p
        ];
        return value ? [
            type,
            path,
            value
        ] : [
            type,
            path
        ];
    });
    this.sdk.updateData(parsed, {
        message: message,
        ...opts
    });
    if (!opts.preventSidebarUpdate) this.lookup('DynamicIsland')?.update();
    this.updateDesignSystemOnCanvas(this.getDesignSystem(), opts);
}
function activeAddingFloatingPanel(event, type) {
    const Section = this.call('findFileSidebarSection', type);
    if (!Section) return;
    Section?.node?.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'center'
    });
    const t = setTimeout(()=>{
        const AddButton = Section.lookdown('IconButton.add');
        AddButton.onClick(event, AddButton, AddButton.state);
        clearTimeout(t);
    }, 350);
}

});

parcelRegister("7e1cr", function(module, exports) {

$parcel$export(module.exports, "getModal", () => getModal);
$parcel$export(module.exports, "getModalData", () => getModalData);
$parcel$export(module.exports, "openModal", () => openModal);
$parcel$export(module.exports, "closeModal", () => closeModal);
$parcel$export(module.exports, "removeModal", () => removeModal);
function getModal() {
    return this.getRoot()?.Modal;
}
function getModalData(key) {
    const data = this.getModal()?.data;
    if (key) return data?.[key];
    return data;
}
async function openModal(key, val, opts = {}) {
    const el = this;
    const root = el.getRoot();
    const Modal = root.Modal;
    let FoundModal;
    // if () {
    if (key && this.getCanvasScope()) this.getCanvasScope().modal = key;
    const modalKey = key || val?.key || this.getWindow('modal');
    const content = Modal.routes[modalKey];
    if (content) {
        this.getRootState().activeModal = modalKey;
        FoundModal = content;
    } else {
        const modalParams = el.call('findModal');
        // if (val?.key) this.router(val?.key)
        if (!modalParams || opts.forcePreviewUpdate) return;
        this.getRootState().activeModal = modalParams.beforeLastRoute || modalParams.lastRoute;
        FoundModal = modalParams.FoundModal;
    }
    if (FoundModal) {
        root.state.activeModal = modalKey;
        if (root.Modal.content && !opts.forced) return;
        root.Modal.setNodeStyles({
            opacity: '1',
            visibility: 'visible',
            pointerEvents: 'auto'
        });
        await root.Modal.removeContent();
        await root.Modal.set({
            extends: FoundModal,
            state: val,
            animation: 'modalIn',
            animationFillMode: 'both',
            ...opts.animationProps
        }, {
            ...opts,
            bySet: true
        });
    }
}
async function closeModal() {
    const el = this;
    const Modal = el.getModal();
    delete this.getRootState().activeModal;
    Modal?.setNodeStyles({
        opacity: '0',
        visibility: 'hidden',
        pointerEvents: 'none'
    });
    await Modal?.content?.update({
        animation: 'modalOut',
        animationDuration: '0',
        animationDelay: '0'
    });
    const t = setTimeout(async ()=>{
        await el.call('removeModal');
        clearTimeout(t);
    }, 350);
}
async function removeModal() {
    const Modal = this.getModal();
    // if (location.pathname !== '/canvas') {
    //   const { index } = this.call('findModal')
    //   const path = window.location.pathname
    //   const routes = path.slice(1).split('/').slice(0, -index)
    //   const href = '/' + routes.join('/')
    //   this.router(
    //     href,
    //     this.getRoot(),
    //     {},
    //     {
    //       scrollToTop: false,
    //       updateStateOptions: {
    //         scrollToTop: false,
    //         forceRerender: true,
    //         onlyUpdate: 'Modal'
    //       }
    //     }
    //   )
    // }
    await Modal?.removeContent();
}

});

parcelRegister("jHcY5", function(module, exports) {

$parcel$export(module.exports, "getPlural", () => getPlural);
$parcel$export(module.exports, "getSingular", () => getSingular);
$parcel$export(module.exports, "getType", () => getType);
$parcel$export(module.exports, "getTypeByKey", () => getTypeByKey);
$parcel$export(module.exports, "getSchemaItem", () => getSchemaItem);
$parcel$export(module.exports, "getDataItem", () => getDataItem);
$parcel$export(module.exports, "getItem", () => getItem);
$parcel$export(module.exports, "prepareSchemaItem", () => prepareSchemaItem);
$parcel$export(module.exports, "setItemSchema", () => setItemSchema);
$parcel$export(module.exports, "prepareDataItem", () => prepareDataItem);
$parcel$export(module.exports, "setItemData", () => setItemData);
$parcel$export(module.exports, "validateFormat", () => validateFormat);
$parcel$export(module.exports, "validateItem", () => validateItem);
$parcel$export(module.exports, "findNewName", () => findNewName);
$parcel$export(module.exports, "convertToDomql3", () => convertToDomql3);
$parcel$export(module.exports, "restoreMissingTypes", () => restoreMissingTypes);
$parcel$export(module.exports, "restoreMissingComponents", () => restoreMissingComponents);
$parcel$export(module.exports, "clearCache", () => clearCache);
$parcel$export(module.exports, "getDefaultValuePerType", () => getDefaultValuePerType);
$parcel$export(module.exports, "buildSchemaItemFromData", () => buildSchemaItemFromData);
function getPlural(key) {
    const overwriteMap = {
        state: 'state',
        dependency: 'dependencies',
        font_family: 'font_families',
        typography: 'typographies'
    };
    return overwriteMap[key] || key.endsWith('s') ? key : `${key}s`;
}
function getSingular(key) {
    const overwriteMap = {
        dependencies: 'dependency'
    };
    return overwriteMap[key] || key.endsWith('s') && key.slice(0, -1) || key;
}
function getType(target) {
    const hasType = target && target.type;
    if (hasType) return this.getPlural(target.type);
    const itemKey = this.call('isString', target) ? target : target?.key || this.state.key;
    const schema = this.getSchema();
    return this.getTypeByKey(itemKey) || Object.keys(schema).find((key)=>itemKey in schema[key]) || null;
}
function getTypeByKey(val) {
    const key = val || this.state?.key;
    if (!key) return;
    const isPage = key.startsWith('/');
    if (isPage) return 'pages';
    const isComponent = /^[A-Z]*$/u.test(key.slice(0, 1));
    if (isComponent) return 'components';
    const isFile = /^[a-zA-Z0-9_-]+(?:\.[a-zA-Z0-9_-]+)*\.[a-zA-Z0-9]+$/u.test(key);
    if (isFile) return 'files';
    const isDependecy = /^(?:@[a-z-~][a-z-._~]*\/)?[a-z-~][a-z-._~]*$/u.test(key);
    if (isDependecy) return 'dependencies';
    const isFunction = /^[a-z][a-zA-Z0-9_]*$/u.test(key);
    if (isFunction) return 'functions';
}
function getSchemaItem(key, type) {
    const schema = this.getSchema();
    if (!type) type = this.getType(key);
    type = this.getPlural(type);
    if (key && type && schema[type]?.[key]) return schema[type][key];
    const parentObject = Object.values(schema).find((childObj)=>key in childObj);
    return parentObject ? parentObject[key] : null;
}
function getDataItem(key, type) {
    if (!key) return null;
    if (!type) type = this.getType(key);
    type = this.getPlural(type);
    if (type && this.getData(type)?.[key]) return this.getData(type)[key];
    const parentObject = Object.values(this.getData()).find((childObj)=>key in childObj);
    return parentObject ? parentObject[key] : null;
}
function getItem(key, type) {
    if (!this.getDataItem(key, type) && !this.getSchemaItem(key, type)) return;
    return {
        ...this.getSchemaItem(key, type),
        value: this.getDataItem(key, type)
    };
}
function prepareSchemaItem(obj1, forcedKey, forcedType) {
    // eslint-disable-next-line no-unused-vars, prefer-const
    let { value, ...schema } = this.getParsedState(obj1);
    // if item has a new name
    if (forcedKey && forcedKey !== schema.key) {
        schema = this.call('deepClone', schema);
        schema.key = forcedKey;
    }
    if (forcedType && forcedType !== schema.type) schema.type = forcedType;
    return schema;
}
function setItemSchema() {}
function prepareDataItem(obj1) {
    const { value } = this.getParsedState(obj1);
    return value;
}
function setItemData() {}
function validateFormat(val, arr = [
    'png',
    'svg',
    'jpeg',
    'jpg',
    'gif',
    'bmp',
    'tiff',
    'tif',
    'webp',
    'ico',
    'mp4',
    'webm',
    'avi',
    'mov',
    'wmv',
    'flv',
    'mkv',
    '3gp',
    'mp3',
    'wav',
    'ogg',
    'm4a',
    'flac',
    'aac',
    'wma',
    'mid',
    'midi',
    'pdf',
    'doc',
    'docx',
    'ppt',
    'pptx',
    'xls',
    'xlsx',
    'zip',
    'rar',
    '7z',
    'woff',
    'woff2',
    'ttf',
    'otf' // Fonts
]) {
    return arr.includes(val);
}
function validateItem(obj1) {
    const type = this.getType(obj1);
    const { key, value } = obj1;
    if (!type) return console.error('Type of item is uknown', obj1);
    if (!key) return console.error(`${type} does not have a key`, obj1);
    if (!value) return console.error(`"${key}" ${type} does not have a value`, obj1);
    if (type === 'component') {
        if (!/^[A-Z]*$/u.test(key.slice(0, 1))) return window.alert(`Error: Key "${key}" component should start with a capital case`);
        if (!/^[a-zA-Z0-9._]+$/u.test(key.slice(0, 1))) return window.alert(`Error: Key "${key}" does not have allowed chars. Use letter, numbers, . or _`);
    } else if (type === 'page') {
        if (!key.startsWith('/')) return window.alert(`Key "${key}" page should start with "/"`);
    } else if (type === 'function') {
        if (!this.call('isFunction', value)) return window.alert(`Function "${key}" is not function type`);
    } else if (type === 'file') {
        if (obj1.contentType === 'file') {
            if (!obj1.format) return window.alert(`File "${key}" does not have valid format`);
            if (!this.validateFormat(obj1.format)) return window.alert(`File format "${obj1.format}" is not supported`);
        }
        if (obj1.contentType === 'file' && !value) return window.alert(`File "${key}" does not have valid source`);
    }
    return true;
}
function findNewName(type, key, opts = {}) {
    let index = 0;
    const isPage = type === 'pages' || key.startsWith('/');
    while(true){
        let itemExists;
        if (type === 'global_theme') itemExists = this.getDesignSystem('theme').document[key];
        else if (type === 'typography' && key.charAt(0) !== '@') itemExists = this.getDesignSystem('typography').templates[key];
        else if (this.call('hasType', 'DESIGN_SYSTEM_TYPES', type)) itemExists = this.getDesignSystem(obj.type)[key];
        else itemExists = this.getSchemaItem(key, type) || this.getDataItem(key, type);
        if (!itemExists) break;
        const suffix = (isPage ? '-copy' : 'Copy') + (index || '');
        const msg = 'Component with such key exists. Please type the new key';
        index++;
        if (opts.autoRename) {
            key = key + suffix;
            continue;
        }
        key = window.prompt(msg, key + suffix);
        if (!key) return;
    }
    return key;
}
async function convertToDomql3() {
    const data = this.getData();
    const update = [];
    [
        'pages',
        'components'
    ].forEach((type)=>{
        Object.keys(data[type]).forEach((itemKey)=>{
            const value = data[type][itemKey];
            if (!value) return;
            else {
                update.push([
                    'update',
                    [
                        type,
                        itemKey
                    ],
                    value
                ]);
                update.push([
                    'delete',
                    [
                        'schema',
                        type,
                        itemKey,
                        'code'
                    ]
                ]);
                update.push([
                    'delete',
                    [
                        'schema',
                        type,
                        itemKey,
                        'codeStr'
                    ]
                ]);
            }
        });
    });
    if (update.length) {
        this.sdk.updateData(update, {
            message: `Converted ${update.length} to domql3 format`
        });
        this.call('openNotification', {
            title: 'Converted to domql3',
            message: `Converted ${update.length} to domql3 format`,
            type: 'success'
        });
    }
}
async function restoreMissingTypes() {
    const data = this.getData();
    const schema = this.getSchema();
    const update = [];
    [
        'pages',
        'components',
        'functions',
        'files',
        'state'
    ].forEach((type)=>{
        Object.keys(data[type]).forEach((itemKey)=>{
            const schemaItem = schema[type][itemKey];
            if (schemaItem && schemaItem.type && schemaItem.type.endsWith('s')) return;
            else update.push([
                'update',
                [
                    'schema',
                    type,
                    itemKey,
                    'type'
                ],
                type
            ]);
        });
    });
    if (update.length) {
        this.sdk.updateData(update, {
            message: `Restored ${update.length} types`
        });
        this.call('openNotification', {
            title: 'Restored types',
            message: `Restored ${update.length} types`,
            type: 'success'
        });
    }
}
async function restoreMissingComponents() {
    const data = this.getData();
    const schema = this.getSchema();
    const update = [];
    [
        'pages',
        'components'
    ].forEach((type)=>{
        Object.keys(data[type]).forEach((itemKey)=>{
            const schemaItem = schema[type][itemKey];
            const dataItem = data[type][itemKey];
            if (dataItem && !schemaItem) update.push([
                'update',
                [
                    'schema',
                    type,
                    itemKey
                ],
                {
                    title: itemKey,
                    key: itemKey,
                    type: type,
                    settings: {
                        gridOptions: {}
                    },
                    interactivity: [],
                    dataTypes: []
                }
            ]);
        });
    });
    if (update.length) {
        this.sdk.updateData(update, {
            message: `Restored ${update.length} components`
        });
        this.call('openNotification', {
            title: 'Restored components',
            message: `Restored ${update.length} components`,
            type: 'success'
        });
    }
}
async function clearCache(opts = {}) {
    const schema = this.getSchema();
    const update = [];
    Object.keys(schema).forEach((type)=>{
        Object.keys(schema[type]).forEach((itemKey)=>{
            const val = schema[type][itemKey];
            // cleanup all values without key
            if (!val.key && type !== 'designSystem') {
                update.push([
                    'delete',
                    [
                        type,
                        itemKey
                    ]
                ]);
                update.push([
                    'delete',
                    [
                        'schema',
                        type,
                        itemKey
                    ]
                ]);
            }
            if ([
                'pages',
                'components',
                'functions',
                'methods',
                'snippets'
            ].includes(type)) {
                update.push([
                    'delete',
                    [
                        'schema',
                        type,
                        itemKey,
                        'code'
                    ]
                ]);
                update.push([
                    'delete',
                    [
                        'schema',
                        type,
                        itemKey,
                        'codeStr'
                    ]
                ]);
            }
        });
    });
    if (update.length) {
        this.sdk.updateData(update, {
            message: `Cleared ${update.length} components`
        });
        if (opts.skipNotification) return;
        this.call('openNotification', {
            title: 'Cache is cleared',
            message: `Cleared ${update.length} cached items from database`,
            type: 'success'
        });
    }
}
function getDefaultValuePerType(type, key) {
    if (this.call('hasType', 'ARTBOARD_TYPES', type)) return {
        key: key,
        type: type,
        value: {},
        settings: {}
    };
    if (this.call('hasType', 'FUNCTION_TYPES', type)) return {
        key: key,
        // eslint-disable-next-line no-new-func,
        value: new Function(`return function ${key}() { /* console.log(this, this.state, this.context) */ }`)(),
        code: `export default function ${key} () {
        // console.log(this, this.state, this.context)
      }`,
        type: type
    };
    return {
        key: key,
        type: type,
        value: {}
    };
}
function buildSchemaItemFromData(type, key, value) {
    const schemaType = this.getPlural ? this.getPlural(type) : type;
    const base = {
        title: key,
        key: key,
        type: schemaType
    };
    if ([
        'pages',
        'components'
    ].includes(schemaType)) {
        base.settings = {
            gridOptions: {}
        };
        base.props = {};
        base.interactivity = [];
        base.dataTypes = [];
        base.error = null;
    }
    let code = null;
    try {
        const rawCode = this.call ? this.call('stringifyCode', value) : null;
        if (rawCode) code = this.call('encodeNewlines', rawCode);
    } catch (e) {
        console.error('Failed to build schema code from data', e);
    }
    if (code) base.code = code;
    return base;
}

});

parcelRegister("ittjw", function(module, exports) {

$parcel$export(module.exports, "replaceWithSecrets", () => replaceWithSecrets);
$parcel$export(module.exports, "replaceSecretsWithKeys", () => replaceSecretsWithKeys);
$parcel$export(module.exports, "getCode", () => getCode);
$parcel$export(module.exports, "stringifyCode", () => stringifyCode);
$parcel$export(module.exports, "evalStringCodeUnsafe", () => evalStringCodeUnsafe);
$parcel$export(module.exports, "parseStringCode", () => parseStringCode);

var $f35At = parcelRequire("f35At");
function replaceWithSecrets(str, secrets) {
    if (!str) return '';
    return str.includes('{{{') ? this.call('replaceLiteralsWithObjectFields', str, {
        bracketsLength: 3
    }, secrets) : str;
}
function replaceSecretsWithKeys(code, secrets) {
    if (!code || !secrets) return code || '';
    const secretKeys = Object.keys(secrets);
    if (secretKeys.length) secretKeys.forEach((secret)=>{
        const val = secrets[secret];
        // eslint-disable-next-line no-param-reassign
        code = code.replaceAll(val, `{{{ ${secret} }}}`);
    });
    return code;
}
function getCode() {
    const { state } = this;
    const route = this.call('getLocationPath', 0);
    const propsCode = this.parent.code;
    if (propsCode === 'components') return this.call('deepClone', state.value);
    else if (propsCode === 'designSystem') {
        const rootCode = this.getDesignSystem() || {};
        const subRoute = route !== '/design-system' && route.slice(1).toUpperCase();
        return subRoute ? rootCode[subRoute] : rootCode;
    } else if (propsCode === 'state') {
        const rootCode = this.getData('state') || {};
        const subRoute = this.call('getLocationPath', 1) && this.call('getLocationPath', 1).slice(1);
        return subRoute ? rootCode[subRoute] : rootCode;
    } else if (propsCode === 'data') return this.getData();
    else if (propsCode === 'schema') return this.getSchema();
}
function stringifyCode(code, options = {
    preventExportDefult: false,
    syntax: '{}',
    indent: 0
}) {
    const { state } = this;
    const codeToConvert = code || this.call('getCode', this, state);
    const codeStr = this.call('isString', codeToConvert) ? codeToConvert : this.call('isFunction', codeToConvert) ? codeToConvert.toString() : this.call('objectToString', codeToConvert, options.indent);
    const exportDefault = options.preventExportDefult ? '' : 'export default ';
    if (!codeToConvert) return exportDefault + (options.syntax || '{}');
    return exportDefault + this.replaceSecretsWithKeys(codeStr, this.getSecrets());
}
function evalStringCodeUnsafe(codeStr, opts = {}) {
    if (!codeStr) return null;
    const { secrets } = opts;
    const codeVal = codeStr.startsWith('export default ') ? codeStr.slice(15) : codeStr;
    const code = secrets ? this.replaceWithSecrets(codeVal, secrets) : codeVal;
    const decoded = this.call('decodeNewlines', code);
    const onError = (e)=>{
        this.error('Error while evaluating code:');
        this.log(codeStr);
        this.call('openNotification', {
            type: 'error',
            title: 'Error while evaluating code',
            message: 'Check the console to verbose'
        });
        throw new Error(e);
    };
    const objectified = this.call('evalStringToObject', decoded, {
        ...opts,
        onError: opts.onError || onError
    });
    if (objectified) return objectified;
}
function parseStringCode(codeStr, opts = {}) {
    if (!codeStr) return null;
    if (codeStr.startsWith('export default ')) codeStr = codeStr.slice(15);
    try {
        // Parse with range info so we can slice original code
        const ast = $f35At.parse(`(${codeStr})`, {
            ecmaVersion: 'latest',
            sourceType: 'module',
            ranges: true
        });
        const objectExpression = ast.body[0].expression;
        function slice(node) {
            return codeStr.slice(node.start - 1, node.end - 1) // adjust for wrapping ()
            ;
        }
        // ---- AST → Object or Raw Source ----
        function astToObject(node) {
            if (!node) return null;
            switch(node.type){
                case 'Literal':
                    return node.value;
                case 'TemplateLiteral':
                    // preserve raw code including backticks
                    return codeStr.slice(node.start, node.end - 2);
                case 'ArrayExpression':
                    return node.elements.map((el)=>el ? astToObject(el) : null);
                case 'ObjectExpression':
                    const obj = {};
                    for (const prop of node.properties){
                        if (prop.type === 'Property') {
                            const key = prop.key.type === 'Identifier' ? prop.key.name : prop.key.type === 'Literal' ? prop.key.value : codeStr.slice(prop.key.start - 1, prop.key.end - 1);
                            obj[key] = astToObject(prop.value);
                        } else if (prop.type === 'SpreadElement') obj[`...${codeStr.slice(prop.argument.start - 1, prop.argument.end - 1)}`] = astToObject(prop.argument);
                    }
                    return obj;
                default:
                    return codeStr.slice(node.start - 1, node.end - 1);
            }
        }
        const objectified = astToObject(objectExpression);
        if (objectified) return objectified;
        throw new Error('Failed to parse object');
    } catch (e) {
        if (opts.onError) opts.onError(e);
        console.error('Can not parse the string: ' + e.message);
        console.error(e);
        return null;
    }
}

});
parcelRegister("f35At", function(module, exports) {

$parcel$export(module.exports, "parse", () => $d184995ea4e545a3$export$98e6a39c04603d36);
// This file was generated. Do not modify manually!
var $d184995ea4e545a3$var$astralIdentifierCodes = [
    509,
    0,
    227,
    0,
    150,
    4,
    294,
    9,
    1368,
    2,
    2,
    1,
    6,
    3,
    41,
    2,
    5,
    0,
    166,
    1,
    574,
    3,
    9,
    9,
    7,
    9,
    32,
    4,
    318,
    1,
    78,
    5,
    71,
    10,
    50,
    3,
    123,
    2,
    54,
    14,
    32,
    10,
    3,
    1,
    11,
    3,
    46,
    10,
    8,
    0,
    46,
    9,
    7,
    2,
    37,
    13,
    2,
    9,
    6,
    1,
    45,
    0,
    13,
    2,
    49,
    13,
    9,
    3,
    2,
    11,
    83,
    11,
    7,
    0,
    3,
    0,
    158,
    11,
    6,
    9,
    7,
    3,
    56,
    1,
    2,
    6,
    3,
    1,
    3,
    2,
    10,
    0,
    11,
    1,
    3,
    6,
    4,
    4,
    68,
    8,
    2,
    0,
    3,
    0,
    2,
    3,
    2,
    4,
    2,
    0,
    15,
    1,
    83,
    17,
    10,
    9,
    5,
    0,
    82,
    19,
    13,
    9,
    214,
    6,
    3,
    8,
    28,
    1,
    83,
    16,
    16,
    9,
    82,
    12,
    9,
    9,
    7,
    19,
    58,
    14,
    5,
    9,
    243,
    14,
    166,
    9,
    71,
    5,
    2,
    1,
    3,
    3,
    2,
    0,
    2,
    1,
    13,
    9,
    120,
    6,
    3,
    6,
    4,
    0,
    29,
    9,
    41,
    6,
    2,
    3,
    9,
    0,
    10,
    10,
    47,
    15,
    199,
    7,
    137,
    9,
    54,
    7,
    2,
    7,
    17,
    9,
    57,
    21,
    2,
    13,
    123,
    5,
    4,
    0,
    2,
    1,
    2,
    6,
    2,
    0,
    9,
    9,
    49,
    4,
    2,
    1,
    2,
    4,
    9,
    9,
    55,
    9,
    266,
    3,
    10,
    1,
    2,
    0,
    49,
    6,
    4,
    4,
    14,
    10,
    5350,
    0,
    7,
    14,
    11465,
    27,
    2343,
    9,
    87,
    9,
    39,
    4,
    60,
    6,
    26,
    9,
    535,
    9,
    470,
    0,
    2,
    54,
    8,
    3,
    82,
    0,
    12,
    1,
    19628,
    1,
    4178,
    9,
    519,
    45,
    3,
    22,
    543,
    4,
    4,
    5,
    9,
    7,
    3,
    6,
    31,
    3,
    149,
    2,
    1418,
    49,
    513,
    54,
    5,
    49,
    9,
    0,
    15,
    0,
    23,
    4,
    2,
    14,
    1361,
    6,
    2,
    16,
    3,
    6,
    2,
    1,
    2,
    4,
    101,
    0,
    161,
    6,
    10,
    9,
    357,
    0,
    62,
    13,
    499,
    13,
    245,
    1,
    2,
    9,
    233,
    0,
    3,
    0,
    8,
    1,
    6,
    0,
    475,
    6,
    110,
    6,
    6,
    9,
    4759,
    9,
    787719,
    239
];
// This file was generated. Do not modify manually!
var $d184995ea4e545a3$var$astralIdentifierStartCodes = [
    0,
    11,
    2,
    25,
    2,
    18,
    2,
    1,
    2,
    14,
    3,
    13,
    35,
    122,
    70,
    52,
    268,
    28,
    4,
    48,
    48,
    31,
    14,
    29,
    6,
    37,
    11,
    29,
    3,
    35,
    5,
    7,
    2,
    4,
    43,
    157,
    19,
    35,
    5,
    35,
    5,
    39,
    9,
    51,
    13,
    10,
    2,
    14,
    2,
    6,
    2,
    1,
    2,
    10,
    2,
    14,
    2,
    6,
    2,
    1,
    4,
    51,
    13,
    310,
    10,
    21,
    11,
    7,
    25,
    5,
    2,
    41,
    2,
    8,
    70,
    5,
    3,
    0,
    2,
    43,
    2,
    1,
    4,
    0,
    3,
    22,
    11,
    22,
    10,
    30,
    66,
    18,
    2,
    1,
    11,
    21,
    11,
    25,
    7,
    25,
    39,
    55,
    7,
    1,
    65,
    0,
    16,
    3,
    2,
    2,
    2,
    28,
    43,
    28,
    4,
    28,
    36,
    7,
    2,
    27,
    28,
    53,
    11,
    21,
    11,
    18,
    14,
    17,
    111,
    72,
    56,
    50,
    14,
    50,
    14,
    35,
    39,
    27,
    10,
    22,
    251,
    41,
    7,
    1,
    17,
    5,
    57,
    28,
    11,
    0,
    9,
    21,
    43,
    17,
    47,
    20,
    28,
    22,
    13,
    52,
    58,
    1,
    3,
    0,
    14,
    44,
    33,
    24,
    27,
    35,
    30,
    0,
    3,
    0,
    9,
    34,
    4,
    0,
    13,
    47,
    15,
    3,
    22,
    0,
    2,
    0,
    36,
    17,
    2,
    24,
    20,
    1,
    64,
    6,
    2,
    0,
    2,
    3,
    2,
    14,
    2,
    9,
    8,
    46,
    39,
    7,
    3,
    1,
    3,
    21,
    2,
    6,
    2,
    1,
    2,
    4,
    4,
    0,
    19,
    0,
    13,
    4,
    31,
    9,
    2,
    0,
    3,
    0,
    2,
    37,
    2,
    0,
    26,
    0,
    2,
    0,
    45,
    52,
    19,
    3,
    21,
    2,
    31,
    47,
    21,
    1,
    2,
    0,
    185,
    46,
    42,
    3,
    37,
    47,
    21,
    0,
    60,
    42,
    14,
    0,
    72,
    26,
    38,
    6,
    186,
    43,
    117,
    63,
    32,
    7,
    3,
    0,
    3,
    7,
    2,
    1,
    2,
    23,
    16,
    0,
    2,
    0,
    95,
    7,
    3,
    38,
    17,
    0,
    2,
    0,
    29,
    0,
    11,
    39,
    8,
    0,
    22,
    0,
    12,
    45,
    20,
    0,
    19,
    72,
    200,
    32,
    32,
    8,
    2,
    36,
    18,
    0,
    50,
    29,
    113,
    6,
    2,
    1,
    2,
    37,
    22,
    0,
    26,
    5,
    2,
    1,
    2,
    31,
    15,
    0,
    24,
    43,
    261,
    18,
    16,
    0,
    2,
    12,
    2,
    33,
    125,
    0,
    80,
    921,
    103,
    110,
    18,
    195,
    2637,
    96,
    16,
    1071,
    18,
    5,
    26,
    3994,
    6,
    582,
    6842,
    29,
    1763,
    568,
    8,
    30,
    18,
    78,
    18,
    29,
    19,
    47,
    17,
    3,
    32,
    20,
    6,
    18,
    433,
    44,
    212,
    63,
    33,
    24,
    3,
    24,
    45,
    74,
    6,
    0,
    67,
    12,
    65,
    1,
    2,
    0,
    15,
    4,
    10,
    7381,
    42,
    31,
    98,
    114,
    8702,
    3,
    2,
    6,
    2,
    1,
    2,
    290,
    16,
    0,
    30,
    2,
    3,
    0,
    15,
    3,
    9,
    395,
    2309,
    106,
    6,
    12,
    4,
    8,
    8,
    9,
    5991,
    84,
    2,
    70,
    2,
    1,
    3,
    0,
    3,
    1,
    3,
    3,
    2,
    11,
    2,
    0,
    2,
    6,
    2,
    64,
    2,
    3,
    3,
    7,
    2,
    6,
    2,
    27,
    2,
    3,
    2,
    4,
    2,
    0,
    4,
    6,
    2,
    339,
    3,
    24,
    2,
    24,
    2,
    30,
    2,
    24,
    2,
    30,
    2,
    24,
    2,
    30,
    2,
    24,
    2,
    30,
    2,
    24,
    2,
    7,
    1845,
    30,
    7,
    5,
    262,
    61,
    147,
    44,
    11,
    6,
    17,
    0,
    322,
    29,
    19,
    43,
    485,
    27,
    229,
    29,
    3,
    0,
    208,
    30,
    2,
    2,
    2,
    1,
    2,
    6,
    3,
    4,
    10,
    1,
    225,
    6,
    2,
    3,
    2,
    1,
    2,
    14,
    2,
    196,
    60,
    67,
    8,
    0,
    1205,
    3,
    2,
    26,
    2,
    1,
    2,
    0,
    3,
    0,
    2,
    9,
    2,
    3,
    2,
    0,
    2,
    0,
    7,
    0,
    5,
    0,
    2,
    0,
    2,
    0,
    2,
    2,
    2,
    1,
    2,
    0,
    3,
    0,
    2,
    0,
    2,
    0,
    2,
    0,
    2,
    0,
    2,
    1,
    2,
    0,
    3,
    3,
    2,
    6,
    2,
    3,
    2,
    3,
    2,
    0,
    2,
    9,
    2,
    16,
    6,
    2,
    2,
    4,
    2,
    16,
    4421,
    42719,
    33,
    4381,
    3,
    5773,
    3,
    7472,
    16,
    621,
    2467,
    541,
    1507,
    4938,
    6,
    8489
];
// This file was generated. Do not modify manually!
var $d184995ea4e545a3$var$nonASCIIidentifierChars = "\u200c\u200d\xb7\u0300-\u036f\u0387\u0483-\u0487\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u064b-\u0669\u0670\u06d6-\u06dc\u06df-\u06e4\u06e7\u06e8\u06ea-\u06ed\u06f0-\u06f9\u0711\u0730-\u074a\u07a6-\u07b0\u07c0-\u07c9\u07eb-\u07f3\u07fd\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0859-\u085b\u0897-\u089f\u08ca-\u08e1\u08e3-\u0903\u093a-\u093c\u093e-\u094f\u0951-\u0957\u0962\u0963\u0966-\u096f\u0981-\u0983\u09bc\u09be-\u09c4\u09c7\u09c8\u09cb-\u09cd\u09d7\u09e2\u09e3\u09e6-\u09ef\u09fe\u0a01-\u0a03\u0a3c\u0a3e-\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a66-\u0a71\u0a75\u0a81-\u0a83\u0abc\u0abe-\u0ac5\u0ac7-\u0ac9\u0acb-\u0acd\u0ae2\u0ae3\u0ae6-\u0aef\u0afa-\u0aff\u0b01-\u0b03\u0b3c\u0b3e-\u0b44\u0b47\u0b48\u0b4b-\u0b4d\u0b55-\u0b57\u0b62\u0b63\u0b66-\u0b6f\u0b82\u0bbe-\u0bc2\u0bc6-\u0bc8\u0bca-\u0bcd\u0bd7\u0be6-\u0bef\u0c00-\u0c04\u0c3c\u0c3e-\u0c44\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62\u0c63\u0c66-\u0c6f\u0c81-\u0c83\u0cbc\u0cbe-\u0cc4\u0cc6-\u0cc8\u0cca-\u0ccd\u0cd5\u0cd6\u0ce2\u0ce3\u0ce6-\u0cef\u0cf3\u0d00-\u0d03\u0d3b\u0d3c\u0d3e-\u0d44\u0d46-\u0d48\u0d4a-\u0d4d\u0d57\u0d62\u0d63\u0d66-\u0d6f\u0d81-\u0d83\u0dca\u0dcf-\u0dd4\u0dd6\u0dd8-\u0ddf\u0de6-\u0def\u0df2\u0df3\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0e50-\u0e59\u0eb1\u0eb4-\u0ebc\u0ec8-\u0ece\u0ed0-\u0ed9\u0f18\u0f19\u0f20-\u0f29\u0f35\u0f37\u0f39\u0f3e\u0f3f\u0f71-\u0f84\u0f86\u0f87\u0f8d-\u0f97\u0f99-\u0fbc\u0fc6\u102b-\u103e\u1040-\u1049\u1056-\u1059\u105e-\u1060\u1062-\u1064\u1067-\u106d\u1071-\u1074\u1082-\u108d\u108f-\u109d\u135d-\u135f\u1369-\u1371\u1712-\u1715\u1732-\u1734\u1752\u1753\u1772\u1773\u17b4-\u17d3\u17dd\u17e0-\u17e9\u180b-\u180d\u180f-\u1819\u18a9\u1920-\u192b\u1930-\u193b\u1946-\u194f\u19d0-\u19da\u1a17-\u1a1b\u1a55-\u1a5e\u1a60-\u1a7c\u1a7f-\u1a89\u1a90-\u1a99\u1ab0-\u1abd\u1abf-\u1add\u1ae0-\u1aeb\u1b00-\u1b04\u1b34-\u1b44\u1b50-\u1b59\u1b6b-\u1b73\u1b80-\u1b82\u1ba1-\u1bad\u1bb0-\u1bb9\u1be6-\u1bf3\u1c24-\u1c37\u1c40-\u1c49\u1c50-\u1c59\u1cd0-\u1cd2\u1cd4-\u1ce8\u1ced\u1cf4\u1cf7-\u1cf9\u1dc0-\u1dff\u200c\u200d\u203f\u2040\u2054\u20d0-\u20dc\u20e1\u20e5-\u20f0\u2cef-\u2cf1\u2d7f\u2de0-\u2dff\u302a-\u302f\u3099\u309a\u30fb\ua620-\ua629\ua66f\ua674-\ua67d\ua69e\ua69f\ua6f0\ua6f1\ua802\ua806\ua80b\ua823-\ua827\ua82c\ua880\ua881\ua8b4-\ua8c5\ua8d0-\ua8d9\ua8e0-\ua8f1\ua8ff-\ua909\ua926-\ua92d\ua947-\ua953\ua980-\ua983\ua9b3-\ua9c0\ua9d0-\ua9d9\ua9e5\ua9f0-\ua9f9\uaa29-\uaa36\uaa43\uaa4c\uaa4d\uaa50-\uaa59\uaa7b-\uaa7d\uaab0\uaab2-\uaab4\uaab7\uaab8\uaabe\uaabf\uaac1\uaaeb-\uaaef\uaaf5\uaaf6\uabe3-\uabea\uabec\uabed\uabf0-\uabf9\ufb1e\ufe00-\ufe0f\ufe20-\ufe2f\ufe33\ufe34\ufe4d-\ufe4f\uff10-\uff19\uff3f\uff65";
// This file was generated. Do not modify manually!
var $d184995ea4e545a3$var$nonASCIIidentifierStartChars = "\xaa\xb5\xba\xc0-\xd6\xd8-\xf6\xf8-\u02c1\u02c6-\u02d1\u02e0-\u02e4\u02ec\u02ee\u0370-\u0374\u0376\u0377\u037a-\u037d\u037f\u0386\u0388-\u038a\u038c\u038e-\u03a1\u03a3-\u03f5\u03f7-\u0481\u048a-\u052f\u0531-\u0556\u0559\u0560-\u0588\u05d0-\u05ea\u05ef-\u05f2\u0620-\u064a\u066e\u066f\u0671-\u06d3\u06d5\u06e5\u06e6\u06ee\u06ef\u06fa-\u06fc\u06ff\u0710\u0712-\u072f\u074d-\u07a5\u07b1\u07ca-\u07ea\u07f4\u07f5\u07fa\u0800-\u0815\u081a\u0824\u0828\u0840-\u0858\u0860-\u086a\u0870-\u0887\u0889-\u088f\u08a0-\u08c9\u0904-\u0939\u093d\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098c\u098f\u0990\u0993-\u09a8\u09aa-\u09b0\u09b2\u09b6-\u09b9\u09bd\u09ce\u09dc\u09dd\u09df-\u09e1\u09f0\u09f1\u09fc\u0a05-\u0a0a\u0a0f\u0a10\u0a13-\u0a28\u0a2a-\u0a30\u0a32\u0a33\u0a35\u0a36\u0a38\u0a39\u0a59-\u0a5c\u0a5e\u0a72-\u0a74\u0a85-\u0a8d\u0a8f-\u0a91\u0a93-\u0aa8\u0aaa-\u0ab0\u0ab2\u0ab3\u0ab5-\u0ab9\u0abd\u0ad0\u0ae0\u0ae1\u0af9\u0b05-\u0b0c\u0b0f\u0b10\u0b13-\u0b28\u0b2a-\u0b30\u0b32\u0b33\u0b35-\u0b39\u0b3d\u0b5c\u0b5d\u0b5f-\u0b61\u0b71\u0b83\u0b85-\u0b8a\u0b8e-\u0b90\u0b92-\u0b95\u0b99\u0b9a\u0b9c\u0b9e\u0b9f\u0ba3\u0ba4\u0ba8-\u0baa\u0bae-\u0bb9\u0bd0\u0c05-\u0c0c\u0c0e-\u0c10\u0c12-\u0c28\u0c2a-\u0c39\u0c3d\u0c58-\u0c5a\u0c5c\u0c5d\u0c60\u0c61\u0c80\u0c85-\u0c8c\u0c8e-\u0c90\u0c92-\u0ca8\u0caa-\u0cb3\u0cb5-\u0cb9\u0cbd\u0cdc-\u0cde\u0ce0\u0ce1\u0cf1\u0cf2\u0d04-\u0d0c\u0d0e-\u0d10\u0d12-\u0d3a\u0d3d\u0d4e\u0d54-\u0d56\u0d5f-\u0d61\u0d7a-\u0d7f\u0d85-\u0d96\u0d9a-\u0db1\u0db3-\u0dbb\u0dbd\u0dc0-\u0dc6\u0e01-\u0e30\u0e32\u0e33\u0e40-\u0e46\u0e81\u0e82\u0e84\u0e86-\u0e8a\u0e8c-\u0ea3\u0ea5\u0ea7-\u0eb0\u0eb2\u0eb3\u0ebd\u0ec0-\u0ec4\u0ec6\u0edc-\u0edf\u0f00\u0f40-\u0f47\u0f49-\u0f6c\u0f88-\u0f8c\u1000-\u102a\u103f\u1050-\u1055\u105a-\u105d\u1061\u1065\u1066\u106e-\u1070\u1075-\u1081\u108e\u10a0-\u10c5\u10c7\u10cd\u10d0-\u10fa\u10fc-\u1248\u124a-\u124d\u1250-\u1256\u1258\u125a-\u125d\u1260-\u1288\u128a-\u128d\u1290-\u12b0\u12b2-\u12b5\u12b8-\u12be\u12c0\u12c2-\u12c5\u12c8-\u12d6\u12d8-\u1310\u1312-\u1315\u1318-\u135a\u1380-\u138f\u13a0-\u13f5\u13f8-\u13fd\u1401-\u166c\u166f-\u167f\u1681-\u169a\u16a0-\u16ea\u16ee-\u16f8\u1700-\u1711\u171f-\u1731\u1740-\u1751\u1760-\u176c\u176e-\u1770\u1780-\u17b3\u17d7\u17dc\u1820-\u1878\u1880-\u18a8\u18aa\u18b0-\u18f5\u1900-\u191e\u1950-\u196d\u1970-\u1974\u1980-\u19ab\u19b0-\u19c9\u1a00-\u1a16\u1a20-\u1a54\u1aa7\u1b05-\u1b33\u1b45-\u1b4c\u1b83-\u1ba0\u1bae\u1baf\u1bba-\u1be5\u1c00-\u1c23\u1c4d-\u1c4f\u1c5a-\u1c7d\u1c80-\u1c8a\u1c90-\u1cba\u1cbd-\u1cbf\u1ce9-\u1cec\u1cee-\u1cf3\u1cf5\u1cf6\u1cfa\u1d00-\u1dbf\u1e00-\u1f15\u1f18-\u1f1d\u1f20-\u1f45\u1f48-\u1f4d\u1f50-\u1f57\u1f59\u1f5b\u1f5d\u1f5f-\u1f7d\u1f80-\u1fb4\u1fb6-\u1fbc\u1fbe\u1fc2-\u1fc4\u1fc6-\u1fcc\u1fd0-\u1fd3\u1fd6-\u1fdb\u1fe0-\u1fec\u1ff2-\u1ff4\u1ff6-\u1ffc\u2071\u207f\u2090-\u209c\u2102\u2107\u210a-\u2113\u2115\u2118-\u211d\u2124\u2126\u2128\u212a-\u2139\u213c-\u213f\u2145-\u2149\u214e\u2160-\u2188\u2c00-\u2ce4\u2ceb-\u2cee\u2cf2\u2cf3\u2d00-\u2d25\u2d27\u2d2d\u2d30-\u2d67\u2d6f\u2d80-\u2d96\u2da0-\u2da6\u2da8-\u2dae\u2db0-\u2db6\u2db8-\u2dbe\u2dc0-\u2dc6\u2dc8-\u2dce\u2dd0-\u2dd6\u2dd8-\u2dde\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303c\u3041-\u3096\u309b-\u309f\u30a1-\u30fa\u30fc-\u30ff\u3105-\u312f\u3131-\u318e\u31a0-\u31bf\u31f0-\u31ff\u3400-\u4dbf\u4e00-\ua48c\ua4d0-\ua4fd\ua500-\ua60c\ua610-\ua61f\ua62a\ua62b\ua640-\ua66e\ua67f-\ua69d\ua6a0-\ua6ef\ua717-\ua71f\ua722-\ua788\ua78b-\ua7dc\ua7f1-\ua801\ua803-\ua805\ua807-\ua80a\ua80c-\ua822\ua840-\ua873\ua882-\ua8b3\ua8f2-\ua8f7\ua8fb\ua8fd\ua8fe\ua90a-\ua925\ua930-\ua946\ua960-\ua97c\ua984-\ua9b2\ua9cf\ua9e0-\ua9e4\ua9e6-\ua9ef\ua9fa-\ua9fe\uaa00-\uaa28\uaa40-\uaa42\uaa44-\uaa4b\uaa60-\uaa76\uaa7a\uaa7e-\uaaaf\uaab1\uaab5\uaab6\uaab9-\uaabd\uaac0\uaac2\uaadb-\uaadd\uaae0-\uaaea\uaaf2-\uaaf4\uab01-\uab06\uab09-\uab0e\uab11-\uab16\uab20-\uab26\uab28-\uab2e\uab30-\uab5a\uab5c-\uab69\uab70-\uabe2\uac00-\ud7a3\ud7b0-\ud7c6\ud7cb-\ud7fb\uf900-\ufa6d\ufa70-\ufad9\ufb00-\ufb06\ufb13-\ufb17\ufb1d\ufb1f-\ufb28\ufb2a-\ufb36\ufb38-\ufb3c\ufb3e\ufb40\ufb41\ufb43\ufb44\ufb46-\ufbb1\ufbd3-\ufd3d\ufd50-\ufd8f\ufd92-\ufdc7\ufdf0-\ufdfb\ufe70-\ufe74\ufe76-\ufefc\uff21-\uff3a\uff41-\uff5a\uff66-\uffbe\uffc2-\uffc7\uffca-\uffcf\uffd2-\uffd7\uffda-\uffdc";
// These are a run-length and offset encoded representation of the
// >0xffff code points that are a valid part of identifiers. The
// offset starts at 0x10000, and each pair of numbers represents an
// offset to the next range, and then a size of the range.
// Reserved word lists for various dialects of the language
var $d184995ea4e545a3$var$reservedWords = {
    3: "abstract boolean byte char class double enum export extends final float goto implements import int interface long native package private protected public short static super synchronized throws transient volatile",
    5: "class enum extends super const export import",
    6: "enum",
    strict: "implements interface let package private protected public static yield",
    strictBind: "eval arguments"
};
// And the keywords
var $d184995ea4e545a3$var$ecma5AndLessKeywords = "break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this";
var $d184995ea4e545a3$var$keywords$1 = {
    5: $d184995ea4e545a3$var$ecma5AndLessKeywords,
    "5module": $d184995ea4e545a3$var$ecma5AndLessKeywords + " export import",
    6: $d184995ea4e545a3$var$ecma5AndLessKeywords + " const class extends export import super"
};
var $d184995ea4e545a3$var$keywordRelationalOperator = /^in(stanceof)?$/;
// ## Character categories
var $d184995ea4e545a3$var$nonASCIIidentifierStart = new RegExp("[" + $d184995ea4e545a3$var$nonASCIIidentifierStartChars + "]");
var $d184995ea4e545a3$var$nonASCIIidentifier = new RegExp("[" + $d184995ea4e545a3$var$nonASCIIidentifierStartChars + $d184995ea4e545a3$var$nonASCIIidentifierChars + "]");
// This has a complexity linear to the value of the code. The
// assumption is that looking up astral identifier characters is
// rare.
function $d184995ea4e545a3$var$isInAstralSet(code, set) {
    var pos = 0x10000;
    for(var i = 0; i < set.length; i += 2){
        pos += set[i];
        if (pos > code) return false;
        pos += set[i + 1];
        if (pos >= code) return true;
    }
    return false;
}
// Test whether a given character code starts an identifier.
function $d184995ea4e545a3$export$56b48cc5d7560ffb(code, astral) {
    if (code < 65) return code === 36;
    if (code < 91) return true;
    if (code < 97) return code === 95;
    if (code < 123) return true;
    if (code <= 0xffff) return code >= 0xaa && $d184995ea4e545a3$var$nonASCIIidentifierStart.test(String.fromCharCode(code));
    if (astral === false) return false;
    return $d184995ea4e545a3$var$isInAstralSet(code, $d184995ea4e545a3$var$astralIdentifierStartCodes);
}
// Test whether a given character is part of an identifier.
function $d184995ea4e545a3$export$332f4d7bee38db93(code, astral) {
    if (code < 48) return code === 36;
    if (code < 58) return true;
    if (code < 65) return false;
    if (code < 91) return true;
    if (code < 97) return code === 95;
    if (code < 123) return true;
    if (code <= 0xffff) return code >= 0xaa && $d184995ea4e545a3$var$nonASCIIidentifier.test(String.fromCharCode(code));
    if (astral === false) return false;
    return $d184995ea4e545a3$var$isInAstralSet(code, $d184995ea4e545a3$var$astralIdentifierStartCodes) || $d184995ea4e545a3$var$isInAstralSet(code, $d184995ea4e545a3$var$astralIdentifierCodes);
}
// ## Token types
// The assignment of fine-grained, information-carrying type objects
// allows the tokenizer to store the information it has about a
// token in a way that is very cheap for the parser to look up.
// All token type variables start with an underscore, to make them
// easy to recognize.
// The `beforeExpr` property is used to disambiguate between regular
// expressions and divisions. It is set on all token types that can
// be followed by an expression (thus, a slash after them would be a
// regular expression).
//
// The `startsExpr` property is used to check if the token ends a
// `yield` expression. It is set on all token types that either can
// directly start an expression (like a quotation mark) or can
// continue an expression (like the body of a string).
//
// `isLoop` marks a keyword as starting a loop, which is important
// to know when parsing a label, in order to allow or disallow
// continue jumps to that label.
var $d184995ea4e545a3$export$f435f793048e7a0f = function TokenType(label, conf) {
    if (conf === void 0) conf = {};
    this.label = label;
    this.keyword = conf.keyword;
    this.beforeExpr = !!conf.beforeExpr;
    this.startsExpr = !!conf.startsExpr;
    this.isLoop = !!conf.isLoop;
    this.isAssign = !!conf.isAssign;
    this.prefix = !!conf.prefix;
    this.postfix = !!conf.postfix;
    this.binop = conf.binop || null;
    this.updateContext = null;
};
function $d184995ea4e545a3$var$binop(name, prec) {
    return new $d184995ea4e545a3$export$f435f793048e7a0f(name, {
        beforeExpr: true,
        binop: prec
    });
}
var $d184995ea4e545a3$var$beforeExpr = {
    beforeExpr: true
}, $d184995ea4e545a3$var$startsExpr = {
    startsExpr: true
};
// Map keyword names to token types.
var $d184995ea4e545a3$export$d53f8326294b31d8 = {};
// Succinct definitions of keyword token types
function $d184995ea4e545a3$var$kw(name, options) {
    if (options === void 0) options = {};
    options.keyword = name;
    return $d184995ea4e545a3$export$d53f8326294b31d8[name] = new $d184995ea4e545a3$export$f435f793048e7a0f(name, options);
}
var $d184995ea4e545a3$export$b54c7ea7aabba5c8 = {
    num: new $d184995ea4e545a3$export$f435f793048e7a0f("num", $d184995ea4e545a3$var$startsExpr),
    regexp: new $d184995ea4e545a3$export$f435f793048e7a0f("regexp", $d184995ea4e545a3$var$startsExpr),
    string: new $d184995ea4e545a3$export$f435f793048e7a0f("string", $d184995ea4e545a3$var$startsExpr),
    name: new $d184995ea4e545a3$export$f435f793048e7a0f("name", $d184995ea4e545a3$var$startsExpr),
    privateId: new $d184995ea4e545a3$export$f435f793048e7a0f("privateId", $d184995ea4e545a3$var$startsExpr),
    eof: new $d184995ea4e545a3$export$f435f793048e7a0f("eof"),
    // Punctuation token types.
    bracketL: new $d184995ea4e545a3$export$f435f793048e7a0f("[", {
        beforeExpr: true,
        startsExpr: true
    }),
    bracketR: new $d184995ea4e545a3$export$f435f793048e7a0f("]"),
    braceL: new $d184995ea4e545a3$export$f435f793048e7a0f("{", {
        beforeExpr: true,
        startsExpr: true
    }),
    braceR: new $d184995ea4e545a3$export$f435f793048e7a0f("}"),
    parenL: new $d184995ea4e545a3$export$f435f793048e7a0f("(", {
        beforeExpr: true,
        startsExpr: true
    }),
    parenR: new $d184995ea4e545a3$export$f435f793048e7a0f(")"),
    comma: new $d184995ea4e545a3$export$f435f793048e7a0f(",", $d184995ea4e545a3$var$beforeExpr),
    semi: new $d184995ea4e545a3$export$f435f793048e7a0f(";", $d184995ea4e545a3$var$beforeExpr),
    colon: new $d184995ea4e545a3$export$f435f793048e7a0f(":", $d184995ea4e545a3$var$beforeExpr),
    dot: new $d184995ea4e545a3$export$f435f793048e7a0f("."),
    question: new $d184995ea4e545a3$export$f435f793048e7a0f("?", $d184995ea4e545a3$var$beforeExpr),
    questionDot: new $d184995ea4e545a3$export$f435f793048e7a0f("?."),
    arrow: new $d184995ea4e545a3$export$f435f793048e7a0f("=>", $d184995ea4e545a3$var$beforeExpr),
    template: new $d184995ea4e545a3$export$f435f793048e7a0f("template"),
    invalidTemplate: new $d184995ea4e545a3$export$f435f793048e7a0f("invalidTemplate"),
    ellipsis: new $d184995ea4e545a3$export$f435f793048e7a0f("...", $d184995ea4e545a3$var$beforeExpr),
    backQuote: new $d184995ea4e545a3$export$f435f793048e7a0f("`", $d184995ea4e545a3$var$startsExpr),
    dollarBraceL: new $d184995ea4e545a3$export$f435f793048e7a0f("${", {
        beforeExpr: true,
        startsExpr: true
    }),
    // Operators. These carry several kinds of properties to help the
    // parser use them properly (the presence of these properties is
    // what categorizes them as operators).
    //
    // `binop`, when present, specifies that this operator is a binary
    // operator, and will refer to its precedence.
    //
    // `prefix` and `postfix` mark the operator as a prefix or postfix
    // unary operator.
    //
    // `isAssign` marks all of `=`, `+=`, `-=` etcetera, which act as
    // binary operators with a very low precedence, that should result
    // in AssignmentExpression nodes.
    eq: new $d184995ea4e545a3$export$f435f793048e7a0f("=", {
        beforeExpr: true,
        isAssign: true
    }),
    assign: new $d184995ea4e545a3$export$f435f793048e7a0f("_=", {
        beforeExpr: true,
        isAssign: true
    }),
    incDec: new $d184995ea4e545a3$export$f435f793048e7a0f("++/--", {
        prefix: true,
        postfix: true,
        startsExpr: true
    }),
    prefix: new $d184995ea4e545a3$export$f435f793048e7a0f("!/~", {
        beforeExpr: true,
        prefix: true,
        startsExpr: true
    }),
    logicalOR: $d184995ea4e545a3$var$binop("||", 1),
    logicalAND: $d184995ea4e545a3$var$binop("&&", 2),
    bitwiseOR: $d184995ea4e545a3$var$binop("|", 3),
    bitwiseXOR: $d184995ea4e545a3$var$binop("^", 4),
    bitwiseAND: $d184995ea4e545a3$var$binop("&", 5),
    equality: $d184995ea4e545a3$var$binop("==/!=/===/!==", 6),
    relational: $d184995ea4e545a3$var$binop("</>/<=/>=", 7),
    bitShift: $d184995ea4e545a3$var$binop("<</>>/>>>", 8),
    plusMin: new $d184995ea4e545a3$export$f435f793048e7a0f("+/-", {
        beforeExpr: true,
        binop: 9,
        prefix: true,
        startsExpr: true
    }),
    modulo: $d184995ea4e545a3$var$binop("%", 10),
    star: $d184995ea4e545a3$var$binop("*", 10),
    slash: $d184995ea4e545a3$var$binop("/", 10),
    starstar: new $d184995ea4e545a3$export$f435f793048e7a0f("**", {
        beforeExpr: true
    }),
    coalesce: $d184995ea4e545a3$var$binop("??", 1),
    // Keyword token types.
    _break: $d184995ea4e545a3$var$kw("break"),
    _case: $d184995ea4e545a3$var$kw("case", $d184995ea4e545a3$var$beforeExpr),
    _catch: $d184995ea4e545a3$var$kw("catch"),
    _continue: $d184995ea4e545a3$var$kw("continue"),
    _debugger: $d184995ea4e545a3$var$kw("debugger"),
    _default: $d184995ea4e545a3$var$kw("default", $d184995ea4e545a3$var$beforeExpr),
    _do: $d184995ea4e545a3$var$kw("do", {
        isLoop: true,
        beforeExpr: true
    }),
    _else: $d184995ea4e545a3$var$kw("else", $d184995ea4e545a3$var$beforeExpr),
    _finally: $d184995ea4e545a3$var$kw("finally"),
    _for: $d184995ea4e545a3$var$kw("for", {
        isLoop: true
    }),
    _function: $d184995ea4e545a3$var$kw("function", $d184995ea4e545a3$var$startsExpr),
    _if: $d184995ea4e545a3$var$kw("if"),
    _return: $d184995ea4e545a3$var$kw("return", $d184995ea4e545a3$var$beforeExpr),
    _switch: $d184995ea4e545a3$var$kw("switch"),
    _throw: $d184995ea4e545a3$var$kw("throw", $d184995ea4e545a3$var$beforeExpr),
    _try: $d184995ea4e545a3$var$kw("try"),
    _var: $d184995ea4e545a3$var$kw("var"),
    _const: $d184995ea4e545a3$var$kw("const"),
    _while: $d184995ea4e545a3$var$kw("while", {
        isLoop: true
    }),
    _with: $d184995ea4e545a3$var$kw("with"),
    _new: $d184995ea4e545a3$var$kw("new", {
        beforeExpr: true,
        startsExpr: true
    }),
    _this: $d184995ea4e545a3$var$kw("this", $d184995ea4e545a3$var$startsExpr),
    _super: $d184995ea4e545a3$var$kw("super", $d184995ea4e545a3$var$startsExpr),
    _class: $d184995ea4e545a3$var$kw("class", $d184995ea4e545a3$var$startsExpr),
    _extends: $d184995ea4e545a3$var$kw("extends", $d184995ea4e545a3$var$beforeExpr),
    _export: $d184995ea4e545a3$var$kw("export"),
    _import: $d184995ea4e545a3$var$kw("import", $d184995ea4e545a3$var$startsExpr),
    _null: $d184995ea4e545a3$var$kw("null", $d184995ea4e545a3$var$startsExpr),
    _true: $d184995ea4e545a3$var$kw("true", $d184995ea4e545a3$var$startsExpr),
    _false: $d184995ea4e545a3$var$kw("false", $d184995ea4e545a3$var$startsExpr),
    _in: $d184995ea4e545a3$var$kw("in", {
        beforeExpr: true,
        binop: 7
    }),
    _instanceof: $d184995ea4e545a3$var$kw("instanceof", {
        beforeExpr: true,
        binop: 7
    }),
    _typeof: $d184995ea4e545a3$var$kw("typeof", {
        beforeExpr: true,
        prefix: true,
        startsExpr: true
    }),
    _void: $d184995ea4e545a3$var$kw("void", {
        beforeExpr: true,
        prefix: true,
        startsExpr: true
    }),
    _delete: $d184995ea4e545a3$var$kw("delete", {
        beforeExpr: true,
        prefix: true,
        startsExpr: true
    })
};
// Matches a whole line break (where CRLF is considered a single
// line break). Used to count lines.
var $d184995ea4e545a3$export$a1aa2dd4ad0d3f6 = /\r\n?|\n|\u2028|\u2029/;
var $d184995ea4e545a3$export$866e20207bbc41f2 = new RegExp($d184995ea4e545a3$export$a1aa2dd4ad0d3f6.source, "g");
function $d184995ea4e545a3$export$2c19a3e3b4008fff(code) {
    return code === 10 || code === 13 || code === 0x2028 || code === 0x2029;
}
function $d184995ea4e545a3$var$nextLineBreak(code, from, end) {
    if (end === void 0) end = code.length;
    for(var i = from; i < end; i++){
        var next = code.charCodeAt(i);
        if ($d184995ea4e545a3$export$2c19a3e3b4008fff(next)) return i < end - 1 && next === 13 && code.charCodeAt(i + 1) === 10 ? i + 2 : i + 1;
    }
    return -1;
}
var $d184995ea4e545a3$export$268622f0f1cbc82b = /[\u1680\u2000-\u200a\u202f\u205f\u3000\ufeff]/;
var $d184995ea4e545a3$var$skipWhiteSpace = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g;
var $d184995ea4e545a3$var$ref = Object.prototype;
var $d184995ea4e545a3$var$hasOwnProperty = $d184995ea4e545a3$var$ref.hasOwnProperty;
var $d184995ea4e545a3$var$toString = $d184995ea4e545a3$var$ref.toString;
var $d184995ea4e545a3$var$hasOwn = Object.hasOwn || function(obj, propName) {
    return $d184995ea4e545a3$var$hasOwnProperty.call(obj, propName);
};
var $d184995ea4e545a3$var$isArray = Array.isArray || function(obj) {
    return $d184995ea4e545a3$var$toString.call(obj) === "[object Array]";
};
var $d184995ea4e545a3$var$regexpCache = Object.create(null);
function $d184995ea4e545a3$var$wordsRegexp(words) {
    return $d184995ea4e545a3$var$regexpCache[words] || ($d184995ea4e545a3$var$regexpCache[words] = new RegExp("^(?:" + words.replace(/ /g, "|") + ")$"));
}
function $d184995ea4e545a3$var$codePointToString(code) {
    // UTF-16 Decoding
    if (code <= 0xFFFF) return String.fromCharCode(code);
    code -= 0x10000;
    return String.fromCharCode((code >> 10) + 0xD800, (code & 1023) + 0xDC00);
}
var $d184995ea4e545a3$var$loneSurrogate = /(?:[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/;
// These are used when `options.locations` is on, for the
// `startLoc` and `endLoc` properties.
var $d184995ea4e545a3$export$13807d9ee5a34a42 = function Position(line, col) {
    this.line = line;
    this.column = col;
};
$d184995ea4e545a3$export$13807d9ee5a34a42.prototype.offset = function offset(n) {
    return new $d184995ea4e545a3$export$13807d9ee5a34a42(this.line, this.column + n);
};
var $d184995ea4e545a3$export$7387db7caf96fcdb = function SourceLocation(p, start, end) {
    this.start = start;
    this.end = end;
    if (p.sourceFile !== null) this.source = p.sourceFile;
};
// The `getLineInfo` function is mostly useful when the
// `locations` option is off (for performance reasons) and you
// want to find the line/column position for a given character
// offset. `input` should be the code string that the offset refers
// into.
function $d184995ea4e545a3$export$7af82191547c5ff7(input, offset) {
    for(var line = 1, cur = 0;;){
        var nextBreak = $d184995ea4e545a3$var$nextLineBreak(input, cur, offset);
        if (nextBreak < 0) return new $d184995ea4e545a3$export$13807d9ee5a34a42(line, offset - cur);
        ++line;
        cur = nextBreak;
    }
}
// A second argument must be given to configure the parser process.
// These options are recognized (only `ecmaVersion` is required):
var $d184995ea4e545a3$export$ba43bf67f3d48107 = {
    // `ecmaVersion` indicates the ECMAScript version to parse. Must be
    // either 3, 5, 6 (or 2015), 7 (2016), 8 (2017), 9 (2018), 10
    // (2019), 11 (2020), 12 (2021), 13 (2022), 14 (2023), or `"latest"`
    // (the latest version the library supports). This influences
    // support for strict mode, the set of reserved words, and support
    // for new syntax features.
    ecmaVersion: null,
    // `sourceType` indicates the mode the code should be parsed in.
    // Can be either `"script"`, `"module"` or `"commonjs"`. This influences global
    // strict mode and parsing of `import` and `export` declarations.
    sourceType: "script",
    // `onInsertedSemicolon` can be a callback that will be called when
    // a semicolon is automatically inserted. It will be passed the
    // position of the inserted semicolon as an offset, and if
    // `locations` is enabled, it is given the location as a `{line,
    // column}` object as second argument.
    onInsertedSemicolon: null,
    // `onTrailingComma` is similar to `onInsertedSemicolon`, but for
    // trailing commas.
    onTrailingComma: null,
    // By default, reserved words are only enforced if ecmaVersion >= 5.
    // Set `allowReserved` to a boolean value to explicitly turn this on
    // an off. When this option has the value "never", reserved words
    // and keywords can also not be used as property names.
    allowReserved: null,
    // When enabled, a return at the top level is not considered an
    // error.
    allowReturnOutsideFunction: false,
    // When enabled, import/export statements are not constrained to
    // appearing at the top of the program, and an import.meta expression
    // in a script isn't considered an error.
    allowImportExportEverywhere: false,
    // By default, await identifiers are allowed to appear at the top-level scope only if ecmaVersion >= 2022.
    // When enabled, await identifiers are allowed to appear at the top-level scope,
    // but they are still not allowed in non-async functions.
    allowAwaitOutsideFunction: null,
    // When enabled, super identifiers are not constrained to
    // appearing in methods and do not raise an error when they appear elsewhere.
    allowSuperOutsideMethod: null,
    // When enabled, hashbang directive in the beginning of file is
    // allowed and treated as a line comment. Enabled by default when
    // `ecmaVersion` >= 2023.
    allowHashBang: false,
    // By default, the parser will verify that private properties are
    // only used in places where they are valid and have been declared.
    // Set this to false to turn such checks off.
    checkPrivateFields: true,
    // When `locations` is on, `loc` properties holding objects with
    // `start` and `end` properties in `{line, column}` form (with
    // line being 1-based and column 0-based) will be attached to the
    // nodes.
    locations: false,
    // A function can be passed as `onToken` option, which will
    // cause Acorn to call that function with object in the same
    // format as tokens returned from `tokenizer().getToken()`. Note
    // that you are not allowed to call the parser from the
    // callback—that will corrupt its internal state.
    onToken: null,
    // A function can be passed as `onComment` option, which will
    // cause Acorn to call that function with `(block, text, start,
    // end)` parameters whenever a comment is skipped. `block` is a
    // boolean indicating whether this is a block (`/* */`) comment,
    // `text` is the content of the comment, and `start` and `end` are
    // character offsets that denote the start and end of the comment.
    // When the `locations` option is on, two more parameters are
    // passed, the full `{line, column}` locations of the start and
    // end of the comments. Note that you are not allowed to call the
    // parser from the callback—that will corrupt its internal state.
    // When this option has an array as value, objects representing the
    // comments are pushed to it.
    onComment: null,
    // Nodes have their start and end characters offsets recorded in
    // `start` and `end` properties (directly on the node, rather than
    // the `loc` object, which holds line/column data. To also add a
    // [semi-standardized][range] `range` property holding a `[start,
    // end]` array with the same numbers, set the `ranges` option to
    // `true`.
    //
    // [range]: https://bugzilla.mozilla.org/show_bug.cgi?id=745678
    ranges: false,
    // It is possible to parse multiple files into a single AST by
    // passing the tree produced by parsing the first file as
    // `program` option in subsequent parses. This will add the
    // toplevel forms of the parsed file to the `Program` (top) node
    // of an existing parse tree.
    program: null,
    // When `locations` is on, you can pass this to record the source
    // file in every node's `loc` object.
    sourceFile: null,
    // This value, if given, is stored in every node, whether
    // `locations` is on or off.
    directSourceFile: null,
    // When enabled, parenthesized expressions are represented by
    // (non-standard) ParenthesizedExpression nodes
    preserveParens: false
};
// Interpret and default an options object
var $d184995ea4e545a3$var$warnedAboutEcmaVersion = false;
function $d184995ea4e545a3$var$getOptions(opts) {
    var options = {};
    for(var opt in $d184995ea4e545a3$export$ba43bf67f3d48107)options[opt] = opts && $d184995ea4e545a3$var$hasOwn(opts, opt) ? opts[opt] : $d184995ea4e545a3$export$ba43bf67f3d48107[opt];
    if (options.ecmaVersion === "latest") options.ecmaVersion = 1e8;
    else if (options.ecmaVersion == null) {
        if (!$d184995ea4e545a3$var$warnedAboutEcmaVersion && typeof console === "object" && console.warn) {
            $d184995ea4e545a3$var$warnedAboutEcmaVersion = true;
            console.warn("Since Acorn 8.0.0, options.ecmaVersion is required.\nDefaulting to 2020, but this will stop working in the future.");
        }
        options.ecmaVersion = 11;
    } else if (options.ecmaVersion >= 2015) options.ecmaVersion -= 2009;
    if (options.allowReserved == null) options.allowReserved = options.ecmaVersion < 5;
    if (!opts || opts.allowHashBang == null) options.allowHashBang = options.ecmaVersion >= 14;
    if ($d184995ea4e545a3$var$isArray(options.onToken)) {
        var tokens = options.onToken;
        options.onToken = function(token) {
            return tokens.push(token);
        };
    }
    if ($d184995ea4e545a3$var$isArray(options.onComment)) options.onComment = $d184995ea4e545a3$var$pushComment(options, options.onComment);
    if (options.sourceType === "commonjs" && options.allowAwaitOutsideFunction) throw new Error("Cannot use allowAwaitOutsideFunction with sourceType: commonjs");
    return options;
}
function $d184995ea4e545a3$var$pushComment(options, array) {
    return function(block, text, start, end, startLoc, endLoc) {
        var comment = {
            type: block ? "Block" : "Line",
            value: text,
            start: start,
            end: end
        };
        if (options.locations) comment.loc = new $d184995ea4e545a3$export$7387db7caf96fcdb(this, startLoc, endLoc);
        if (options.ranges) comment.range = [
            start,
            end
        ];
        array.push(comment);
    };
}
// Each scope gets a bitset that may contain these flags
var $d184995ea4e545a3$var$SCOPE_TOP = 1, $d184995ea4e545a3$var$SCOPE_FUNCTION = 2, $d184995ea4e545a3$var$SCOPE_ASYNC = 4, $d184995ea4e545a3$var$SCOPE_GENERATOR = 8, $d184995ea4e545a3$var$SCOPE_ARROW = 16, $d184995ea4e545a3$var$SCOPE_SIMPLE_CATCH = 32, $d184995ea4e545a3$var$SCOPE_SUPER = 64, $d184995ea4e545a3$var$SCOPE_DIRECT_SUPER = 128, $d184995ea4e545a3$var$SCOPE_CLASS_STATIC_BLOCK = 256, $d184995ea4e545a3$var$SCOPE_CLASS_FIELD_INIT = 512, $d184995ea4e545a3$var$SCOPE_SWITCH = 1024, $d184995ea4e545a3$var$SCOPE_VAR = $d184995ea4e545a3$var$SCOPE_TOP | $d184995ea4e545a3$var$SCOPE_FUNCTION | $d184995ea4e545a3$var$SCOPE_CLASS_STATIC_BLOCK;
function $d184995ea4e545a3$var$functionFlags(async, generator) {
    return $d184995ea4e545a3$var$SCOPE_FUNCTION | (async ? $d184995ea4e545a3$var$SCOPE_ASYNC : 0) | (generator ? $d184995ea4e545a3$var$SCOPE_GENERATOR : 0);
}
// Used in checkLVal* and declareName to determine the type of a binding
var $d184995ea4e545a3$var$BIND_NONE = 0, $d184995ea4e545a3$var$BIND_VAR = 1, $d184995ea4e545a3$var$BIND_LEXICAL = 2, $d184995ea4e545a3$var$BIND_FUNCTION = 3, $d184995ea4e545a3$var$BIND_SIMPLE_CATCH = 4, $d184995ea4e545a3$var$BIND_OUTSIDE = 5; // Special case for function names as bound inside the function
var $d184995ea4e545a3$export$7acfa6ed01010e37 = function Parser(options, input, startPos) {
    this.options = options = $d184995ea4e545a3$var$getOptions(options);
    this.sourceFile = options.sourceFile;
    this.keywords = $d184995ea4e545a3$var$wordsRegexp($d184995ea4e545a3$var$keywords$1[options.ecmaVersion >= 6 ? 6 : options.sourceType === "module" ? "5module" : 5]);
    var reserved = "";
    if (options.allowReserved !== true) {
        reserved = $d184995ea4e545a3$var$reservedWords[options.ecmaVersion >= 6 ? 6 : options.ecmaVersion === 5 ? 5 : 3];
        if (options.sourceType === "module") reserved += " await";
    }
    this.reservedWords = $d184995ea4e545a3$var$wordsRegexp(reserved);
    var reservedStrict = (reserved ? reserved + " " : "") + $d184995ea4e545a3$var$reservedWords.strict;
    this.reservedWordsStrict = $d184995ea4e545a3$var$wordsRegexp(reservedStrict);
    this.reservedWordsStrictBind = $d184995ea4e545a3$var$wordsRegexp(reservedStrict + " " + $d184995ea4e545a3$var$reservedWords.strictBind);
    this.input = String(input);
    // Used to signal to callers of `readWord1` whether the word
    // contained any escape sequences. This is needed because words with
    // escape sequences must not be interpreted as keywords.
    this.containsEsc = false;
    // Set up token state
    // The current position of the tokenizer in the input.
    if (startPos) {
        this.pos = startPos;
        this.lineStart = this.input.lastIndexOf("\n", startPos - 1) + 1;
        this.curLine = this.input.slice(0, this.lineStart).split($d184995ea4e545a3$export$a1aa2dd4ad0d3f6).length;
    } else {
        this.pos = this.lineStart = 0;
        this.curLine = 1;
    }
    // Properties of the current token:
    // Its type
    this.type = $d184995ea4e545a3$export$b54c7ea7aabba5c8.eof;
    // For tokens that include more information than their type, the value
    this.value = null;
    // Its start and end offset
    this.start = this.end = this.pos;
    // And, if locations are used, the {line, column} object
    // corresponding to those offsets
    this.startLoc = this.endLoc = this.curPosition();
    // Position information for the previous token
    this.lastTokEndLoc = this.lastTokStartLoc = null;
    this.lastTokStart = this.lastTokEnd = this.pos;
    // The context stack is used to superficially track syntactic
    // context to predict whether a regular expression is allowed in a
    // given position.
    this.context = this.initialContext();
    this.exprAllowed = true;
    // Figure out if it's a module code.
    this.inModule = options.sourceType === "module";
    this.strict = this.inModule || this.strictDirective(this.pos);
    // Used to signify the start of a potential arrow function
    this.potentialArrowAt = -1;
    this.potentialArrowInForAwait = false;
    // Positions to delayed-check that yield/await does not exist in default parameters.
    this.yieldPos = this.awaitPos = this.awaitIdentPos = 0;
    // Labels in scope.
    this.labels = [];
    // Thus-far undefined exports.
    this.undefinedExports = Object.create(null);
    // If enabled, skip leading hashbang line.
    if (this.pos === 0 && options.allowHashBang && this.input.slice(0, 2) === "#!") this.skipLineComment(2);
    // Scope tracking for duplicate variable names (see scope.js)
    this.scopeStack = [];
    this.enterScope(this.options.sourceType === "commonjs" ? $d184995ea4e545a3$var$SCOPE_FUNCTION : $d184995ea4e545a3$var$SCOPE_TOP);
    // For RegExp validation
    this.regexpState = null;
    // The stack of private names.
    // Each element has two properties: 'declared' and 'used'.
    // When it exited from the outermost class definition, all used private names must be declared.
    this.privateNameStack = [];
};
var $d184995ea4e545a3$var$prototypeAccessors = {
    inFunction: {
        configurable: true
    },
    inGenerator: {
        configurable: true
    },
    inAsync: {
        configurable: true
    },
    canAwait: {
        configurable: true
    },
    allowReturn: {
        configurable: true
    },
    allowSuper: {
        configurable: true
    },
    allowDirectSuper: {
        configurable: true
    },
    treatFunctionsAsVar: {
        configurable: true
    },
    allowNewDotTarget: {
        configurable: true
    },
    allowUsing: {
        configurable: true
    },
    inClassStaticBlock: {
        configurable: true
    }
};
$d184995ea4e545a3$export$7acfa6ed01010e37.prototype.parse = function parse() {
    var node = this.options.program || this.startNode();
    this.nextToken();
    return this.parseTopLevel(node);
};
$d184995ea4e545a3$var$prototypeAccessors.inFunction.get = function() {
    return (this.currentVarScope().flags & $d184995ea4e545a3$var$SCOPE_FUNCTION) > 0;
};
$d184995ea4e545a3$var$prototypeAccessors.inGenerator.get = function() {
    return (this.currentVarScope().flags & $d184995ea4e545a3$var$SCOPE_GENERATOR) > 0;
};
$d184995ea4e545a3$var$prototypeAccessors.inAsync.get = function() {
    return (this.currentVarScope().flags & $d184995ea4e545a3$var$SCOPE_ASYNC) > 0;
};
$d184995ea4e545a3$var$prototypeAccessors.canAwait.get = function() {
    for(var i = this.scopeStack.length - 1; i >= 0; i--){
        var ref = this.scopeStack[i];
        var flags = ref.flags;
        if (flags & ($d184995ea4e545a3$var$SCOPE_CLASS_STATIC_BLOCK | $d184995ea4e545a3$var$SCOPE_CLASS_FIELD_INIT)) return false;
        if (flags & $d184995ea4e545a3$var$SCOPE_FUNCTION) return (flags & $d184995ea4e545a3$var$SCOPE_ASYNC) > 0;
    }
    return this.inModule && this.options.ecmaVersion >= 13 || this.options.allowAwaitOutsideFunction;
};
$d184995ea4e545a3$var$prototypeAccessors.allowReturn.get = function() {
    if (this.inFunction) return true;
    if (this.options.allowReturnOutsideFunction && this.currentVarScope().flags & $d184995ea4e545a3$var$SCOPE_TOP) return true;
    return false;
};
$d184995ea4e545a3$var$prototypeAccessors.allowSuper.get = function() {
    var ref = this.currentThisScope();
    var flags = ref.flags;
    return (flags & $d184995ea4e545a3$var$SCOPE_SUPER) > 0 || this.options.allowSuperOutsideMethod;
};
$d184995ea4e545a3$var$prototypeAccessors.allowDirectSuper.get = function() {
    return (this.currentThisScope().flags & $d184995ea4e545a3$var$SCOPE_DIRECT_SUPER) > 0;
};
$d184995ea4e545a3$var$prototypeAccessors.treatFunctionsAsVar.get = function() {
    return this.treatFunctionsAsVarInScope(this.currentScope());
};
$d184995ea4e545a3$var$prototypeAccessors.allowNewDotTarget.get = function() {
    for(var i = this.scopeStack.length - 1; i >= 0; i--){
        var ref = this.scopeStack[i];
        var flags = ref.flags;
        if (flags & ($d184995ea4e545a3$var$SCOPE_CLASS_STATIC_BLOCK | $d184995ea4e545a3$var$SCOPE_CLASS_FIELD_INIT) || flags & $d184995ea4e545a3$var$SCOPE_FUNCTION && !(flags & $d184995ea4e545a3$var$SCOPE_ARROW)) return true;
    }
    return false;
};
$d184995ea4e545a3$var$prototypeAccessors.allowUsing.get = function() {
    var ref = this.currentScope();
    var flags = ref.flags;
    if (flags & $d184995ea4e545a3$var$SCOPE_SWITCH) return false;
    if (!this.inModule && flags & $d184995ea4e545a3$var$SCOPE_TOP) return false;
    return true;
};
$d184995ea4e545a3$var$prototypeAccessors.inClassStaticBlock.get = function() {
    return (this.currentVarScope().flags & $d184995ea4e545a3$var$SCOPE_CLASS_STATIC_BLOCK) > 0;
};
$d184995ea4e545a3$export$7acfa6ed01010e37.extend = function extend() {
    var plugins = [], len = arguments.length;
    while(len--)plugins[len] = arguments[len];
    var cls = this;
    for(var i = 0; i < plugins.length; i++)cls = plugins[i](cls);
    return cls;
};
$d184995ea4e545a3$export$7acfa6ed01010e37.parse = function parse(input, options) {
    return new this(options, input).parse();
};
$d184995ea4e545a3$export$7acfa6ed01010e37.parseExpressionAt = function parseExpressionAt(input, pos, options) {
    var parser = new this(options, input, pos);
    parser.nextToken();
    return parser.parseExpression();
};
$d184995ea4e545a3$export$7acfa6ed01010e37.tokenizer = function tokenizer(input, options) {
    return new this(options, input);
};
Object.defineProperties($d184995ea4e545a3$export$7acfa6ed01010e37.prototype, $d184995ea4e545a3$var$prototypeAccessors);
var $d184995ea4e545a3$var$pp$9 = $d184995ea4e545a3$export$7acfa6ed01010e37.prototype;
// ## Parser utilities
var $d184995ea4e545a3$var$literal = /^(?:'((?:\\[^]|[^'\\])*?)'|"((?:\\[^]|[^"\\])*?)")/;
$d184995ea4e545a3$var$pp$9.strictDirective = function(start) {
    if (this.options.ecmaVersion < 5) return false;
    for(;;){
        // Try to find string literal.
        $d184995ea4e545a3$var$skipWhiteSpace.lastIndex = start;
        start += $d184995ea4e545a3$var$skipWhiteSpace.exec(this.input)[0].length;
        var match = $d184995ea4e545a3$var$literal.exec(this.input.slice(start));
        if (!match) return false;
        if ((match[1] || match[2]) === "use strict") {
            $d184995ea4e545a3$var$skipWhiteSpace.lastIndex = start + match[0].length;
            var spaceAfter = $d184995ea4e545a3$var$skipWhiteSpace.exec(this.input), end = spaceAfter.index + spaceAfter[0].length;
            var next = this.input.charAt(end);
            return next === ";" || next === "}" || $d184995ea4e545a3$export$a1aa2dd4ad0d3f6.test(spaceAfter[0]) && !(/[(`.[+\-/*%<>=,?^&]/.test(next) || next === "!" && this.input.charAt(end + 1) === "=");
        }
        start += match[0].length;
        // Skip semicolon, if any.
        $d184995ea4e545a3$var$skipWhiteSpace.lastIndex = start;
        start += $d184995ea4e545a3$var$skipWhiteSpace.exec(this.input)[0].length;
        if (this.input[start] === ";") start++;
    }
};
// Predicate that tests whether the next token is of the given
// type, and if yes, consumes it as a side effect.
$d184995ea4e545a3$var$pp$9.eat = function(type) {
    if (this.type === type) {
        this.next();
        return true;
    } else return false;
};
// Tests whether parsed token is a contextual keyword.
$d184995ea4e545a3$var$pp$9.isContextual = function(name) {
    return this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.name && this.value === name && !this.containsEsc;
};
// Consumes contextual keyword if possible.
$d184995ea4e545a3$var$pp$9.eatContextual = function(name) {
    if (!this.isContextual(name)) return false;
    this.next();
    return true;
};
// Asserts that following token is given contextual keyword.
$d184995ea4e545a3$var$pp$9.expectContextual = function(name) {
    if (!this.eatContextual(name)) this.unexpected();
};
// Test whether a semicolon can be inserted at the current position.
$d184995ea4e545a3$var$pp$9.canInsertSemicolon = function() {
    return this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.eof || this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.braceR || $d184995ea4e545a3$export$a1aa2dd4ad0d3f6.test(this.input.slice(this.lastTokEnd, this.start));
};
$d184995ea4e545a3$var$pp$9.insertSemicolon = function() {
    if (this.canInsertSemicolon()) {
        if (this.options.onInsertedSemicolon) this.options.onInsertedSemicolon(this.lastTokEnd, this.lastTokEndLoc);
        return true;
    }
};
// Consume a semicolon, or, failing that, see if we are allowed to
// pretend that there is a semicolon at this position.
$d184995ea4e545a3$var$pp$9.semicolon = function() {
    if (!this.eat($d184995ea4e545a3$export$b54c7ea7aabba5c8.semi) && !this.insertSemicolon()) this.unexpected();
};
$d184995ea4e545a3$var$pp$9.afterTrailingComma = function(tokType, notNext) {
    if (this.type === tokType) {
        if (this.options.onTrailingComma) this.options.onTrailingComma(this.lastTokStart, this.lastTokStartLoc);
        if (!notNext) this.next();
        return true;
    }
};
// Expect a token of a given type. If found, consume it, otherwise,
// raise an unexpected token error.
$d184995ea4e545a3$var$pp$9.expect = function(type) {
    this.eat(type) || this.unexpected();
};
// Raise an unexpected token error.
$d184995ea4e545a3$var$pp$9.unexpected = function(pos) {
    this.raise(pos != null ? pos : this.start, "Unexpected token");
};
var $d184995ea4e545a3$var$DestructuringErrors = function DestructuringErrors() {
    this.shorthandAssign = this.trailingComma = this.parenthesizedAssign = this.parenthesizedBind = this.doubleProto = -1;
};
$d184995ea4e545a3$var$pp$9.checkPatternErrors = function(refDestructuringErrors, isAssign) {
    if (!refDestructuringErrors) return;
    if (refDestructuringErrors.trailingComma > -1) this.raiseRecoverable(refDestructuringErrors.trailingComma, "Comma is not permitted after the rest element");
    var parens = isAssign ? refDestructuringErrors.parenthesizedAssign : refDestructuringErrors.parenthesizedBind;
    if (parens > -1) this.raiseRecoverable(parens, isAssign ? "Assigning to rvalue" : "Parenthesized pattern");
};
$d184995ea4e545a3$var$pp$9.checkExpressionErrors = function(refDestructuringErrors, andThrow) {
    if (!refDestructuringErrors) return false;
    var shorthandAssign = refDestructuringErrors.shorthandAssign;
    var doubleProto = refDestructuringErrors.doubleProto;
    if (!andThrow) return shorthandAssign >= 0 || doubleProto >= 0;
    if (shorthandAssign >= 0) this.raise(shorthandAssign, "Shorthand property assignments are valid only in destructuring patterns");
    if (doubleProto >= 0) this.raiseRecoverable(doubleProto, "Redefinition of __proto__ property");
};
$d184995ea4e545a3$var$pp$9.checkYieldAwaitInDefaultParams = function() {
    if (this.yieldPos && (!this.awaitPos || this.yieldPos < this.awaitPos)) this.raise(this.yieldPos, "Yield expression cannot be a default value");
    if (this.awaitPos) this.raise(this.awaitPos, "Await expression cannot be a default value");
};
$d184995ea4e545a3$var$pp$9.isSimpleAssignTarget = function(expr) {
    if (expr.type === "ParenthesizedExpression") return this.isSimpleAssignTarget(expr.expression);
    return expr.type === "Identifier" || expr.type === "MemberExpression";
};
var $d184995ea4e545a3$var$pp$8 = $d184995ea4e545a3$export$7acfa6ed01010e37.prototype;
// ### Statement parsing
// Parse a program. Initializes the parser, reads any number of
// statements, and wraps them in a Program node.  Optionally takes a
// `program` argument.  If present, the statements will be appended
// to its body instead of creating a new node.
$d184995ea4e545a3$var$pp$8.parseTopLevel = function(node) {
    var exports = Object.create(null);
    if (!node.body) node.body = [];
    while(this.type !== $d184995ea4e545a3$export$b54c7ea7aabba5c8.eof){
        var stmt = this.parseStatement(null, true, exports);
        node.body.push(stmt);
    }
    if (this.inModule) for(var i = 0, list = Object.keys(this.undefinedExports); i < list.length; i += 1){
        var name = list[i];
        this.raiseRecoverable(this.undefinedExports[name].start, "Export '" + name + "' is not defined");
    }
    this.adaptDirectivePrologue(node.body);
    this.next();
    node.sourceType = this.options.sourceType === "commonjs" ? "script" : this.options.sourceType;
    return this.finishNode(node, "Program");
};
var $d184995ea4e545a3$var$loopLabel = {
    kind: "loop"
}, $d184995ea4e545a3$var$switchLabel = {
    kind: "switch"
};
$d184995ea4e545a3$var$pp$8.isLet = function(context) {
    if (this.options.ecmaVersion < 6 || !this.isContextual("let")) return false;
    $d184995ea4e545a3$var$skipWhiteSpace.lastIndex = this.pos;
    var skip = $d184995ea4e545a3$var$skipWhiteSpace.exec(this.input);
    var next = this.pos + skip[0].length, nextCh = this.fullCharCodeAt(next);
    // For ambiguous cases, determine if a LexicalDeclaration (or only a
    // Statement) is allowed here. If context is not empty then only a Statement
    // is allowed. However, `let [` is an explicit negative lookahead for
    // ExpressionStatement, so special-case it first.
    if (nextCh === 91 || nextCh === 92) return true;
     // '[', '\'
    if (context) return false;
    if (nextCh === 123) return true;
     // '{'
    if ($d184995ea4e545a3$export$56b48cc5d7560ffb(nextCh)) {
        var start = next;
        do next += nextCh <= 0xffff ? 1 : 2;
        while ($d184995ea4e545a3$export$332f4d7bee38db93(nextCh = this.fullCharCodeAt(next)));
        if (nextCh === 92) return true;
        var ident = this.input.slice(start, next);
        if (!$d184995ea4e545a3$var$keywordRelationalOperator.test(ident)) return true;
    }
    return false;
};
// check 'async [no LineTerminator here] function'
// - 'async /*foo*/ function' is OK.
// - 'async /*\n*/ function' is invalid.
$d184995ea4e545a3$var$pp$8.isAsyncFunction = function() {
    if (this.options.ecmaVersion < 8 || !this.isContextual("async")) return false;
    $d184995ea4e545a3$var$skipWhiteSpace.lastIndex = this.pos;
    var skip = $d184995ea4e545a3$var$skipWhiteSpace.exec(this.input);
    var next = this.pos + skip[0].length, after;
    return !$d184995ea4e545a3$export$a1aa2dd4ad0d3f6.test(this.input.slice(this.pos, next)) && this.input.slice(next, next + 8) === "function" && (next + 8 === this.input.length || !($d184995ea4e545a3$export$332f4d7bee38db93(after = this.fullCharCodeAt(next + 8)) || after === 92 /* '\' */ ));
};
$d184995ea4e545a3$var$pp$8.isUsingKeyword = function(isAwaitUsing, isFor) {
    if (this.options.ecmaVersion < 17 || !this.isContextual(isAwaitUsing ? "await" : "using")) return false;
    $d184995ea4e545a3$var$skipWhiteSpace.lastIndex = this.pos;
    var skip = $d184995ea4e545a3$var$skipWhiteSpace.exec(this.input);
    var next = this.pos + skip[0].length;
    if ($d184995ea4e545a3$export$a1aa2dd4ad0d3f6.test(this.input.slice(this.pos, next))) return false;
    if (isAwaitUsing) {
        var usingEndPos = next + 5 /* using */ , after;
        if (this.input.slice(next, usingEndPos) !== "using" || usingEndPos === this.input.length || $d184995ea4e545a3$export$332f4d7bee38db93(after = this.fullCharCodeAt(usingEndPos)) || after === 92 /* '\' */ ) return false;
        $d184995ea4e545a3$var$skipWhiteSpace.lastIndex = usingEndPos;
        var skipAfterUsing = $d184995ea4e545a3$var$skipWhiteSpace.exec(this.input);
        next = usingEndPos + skipAfterUsing[0].length;
        if (skipAfterUsing && $d184995ea4e545a3$export$a1aa2dd4ad0d3f6.test(this.input.slice(usingEndPos, next))) return false;
    }
    var ch = this.fullCharCodeAt(next);
    if (!$d184995ea4e545a3$export$56b48cc5d7560ffb(ch) && ch !== 92 /* '\' */ ) return false;
    var idStart = next;
    do next += ch <= 0xffff ? 1 : 2;
    while ($d184995ea4e545a3$export$332f4d7bee38db93(ch = this.fullCharCodeAt(next)));
    if (ch === 92) return true;
    var id = this.input.slice(idStart, next);
    if ($d184995ea4e545a3$var$keywordRelationalOperator.test(id) || isFor && id === "of") return false;
    return true;
};
$d184995ea4e545a3$var$pp$8.isAwaitUsing = function(isFor) {
    return this.isUsingKeyword(true, isFor);
};
$d184995ea4e545a3$var$pp$8.isUsing = function(isFor) {
    return this.isUsingKeyword(false, isFor);
};
// Parse a single statement.
//
// If expecting a statement and finding a slash operator, parse a
// regular expression literal. This is to handle cases like
// `if (foo) /blah/.exec(foo)`, where looking at the previous token
// does not help.
$d184995ea4e545a3$var$pp$8.parseStatement = function(context, topLevel, exports) {
    var starttype = this.type, node = this.startNode(), kind;
    if (this.isLet(context)) {
        starttype = $d184995ea4e545a3$export$b54c7ea7aabba5c8._var;
        kind = "let";
    }
    // Most types of statements are recognized by the keyword they
    // start with. Many are trivial to parse, some require a bit of
    // complexity.
    switch(starttype){
        case $d184995ea4e545a3$export$b54c7ea7aabba5c8._break:
        case $d184995ea4e545a3$export$b54c7ea7aabba5c8._continue:
            return this.parseBreakContinueStatement(node, starttype.keyword);
        case $d184995ea4e545a3$export$b54c7ea7aabba5c8._debugger:
            return this.parseDebuggerStatement(node);
        case $d184995ea4e545a3$export$b54c7ea7aabba5c8._do:
            return this.parseDoStatement(node);
        case $d184995ea4e545a3$export$b54c7ea7aabba5c8._for:
            return this.parseForStatement(node);
        case $d184995ea4e545a3$export$b54c7ea7aabba5c8._function:
            // Function as sole body of either an if statement or a labeled statement
            // works, but not when it is part of a labeled statement that is the sole
            // body of an if statement.
            if (context && (this.strict || context !== "if" && context !== "label") && this.options.ecmaVersion >= 6) this.unexpected();
            return this.parseFunctionStatement(node, false, !context);
        case $d184995ea4e545a3$export$b54c7ea7aabba5c8._class:
            if (context) this.unexpected();
            return this.parseClass(node, true);
        case $d184995ea4e545a3$export$b54c7ea7aabba5c8._if:
            return this.parseIfStatement(node);
        case $d184995ea4e545a3$export$b54c7ea7aabba5c8._return:
            return this.parseReturnStatement(node);
        case $d184995ea4e545a3$export$b54c7ea7aabba5c8._switch:
            return this.parseSwitchStatement(node);
        case $d184995ea4e545a3$export$b54c7ea7aabba5c8._throw:
            return this.parseThrowStatement(node);
        case $d184995ea4e545a3$export$b54c7ea7aabba5c8._try:
            return this.parseTryStatement(node);
        case $d184995ea4e545a3$export$b54c7ea7aabba5c8._const:
        case $d184995ea4e545a3$export$b54c7ea7aabba5c8._var:
            kind = kind || this.value;
            if (context && kind !== "var") this.unexpected();
            return this.parseVarStatement(node, kind);
        case $d184995ea4e545a3$export$b54c7ea7aabba5c8._while:
            return this.parseWhileStatement(node);
        case $d184995ea4e545a3$export$b54c7ea7aabba5c8._with:
            return this.parseWithStatement(node);
        case $d184995ea4e545a3$export$b54c7ea7aabba5c8.braceL:
            return this.parseBlock(true, node);
        case $d184995ea4e545a3$export$b54c7ea7aabba5c8.semi:
            return this.parseEmptyStatement(node);
        case $d184995ea4e545a3$export$b54c7ea7aabba5c8._export:
        case $d184995ea4e545a3$export$b54c7ea7aabba5c8._import:
            if (this.options.ecmaVersion > 10 && starttype === $d184995ea4e545a3$export$b54c7ea7aabba5c8._import) {
                $d184995ea4e545a3$var$skipWhiteSpace.lastIndex = this.pos;
                var skip = $d184995ea4e545a3$var$skipWhiteSpace.exec(this.input);
                var next = this.pos + skip[0].length, nextCh = this.input.charCodeAt(next);
                if (nextCh === 40 || nextCh === 46) return this.parseExpressionStatement(node, this.parseExpression());
            }
            if (!this.options.allowImportExportEverywhere) {
                if (!topLevel) this.raise(this.start, "'import' and 'export' may only appear at the top level");
                if (!this.inModule) this.raise(this.start, "'import' and 'export' may appear only with 'sourceType: module'");
            }
            return starttype === $d184995ea4e545a3$export$b54c7ea7aabba5c8._import ? this.parseImport(node) : this.parseExport(node, exports);
        // If the statement does not start with a statement keyword or a
        // brace, it's an ExpressionStatement or LabeledStatement. We
        // simply start parsing an expression, and afterwards, if the
        // next token is a colon and the expression was a simple
        // Identifier node, we switch to interpreting it as a label.
        default:
            if (this.isAsyncFunction()) {
                if (context) this.unexpected();
                this.next();
                return this.parseFunctionStatement(node, true, !context);
            }
            var usingKind = this.isAwaitUsing(false) ? "await using" : this.isUsing(false) ? "using" : null;
            if (usingKind) {
                if (!this.allowUsing) this.raise(this.start, "Using declaration cannot appear in the top level when source type is `script` or in the bare case statement");
                if (usingKind === "await using") {
                    if (!this.canAwait) this.raise(this.start, "Await using cannot appear outside of async function");
                    this.next();
                }
                this.next();
                this.parseVar(node, false, usingKind);
                this.semicolon();
                return this.finishNode(node, "VariableDeclaration");
            }
            var maybeName = this.value, expr = this.parseExpression();
            if (starttype === $d184995ea4e545a3$export$b54c7ea7aabba5c8.name && expr.type === "Identifier" && this.eat($d184995ea4e545a3$export$b54c7ea7aabba5c8.colon)) return this.parseLabeledStatement(node, maybeName, expr, context);
            else return this.parseExpressionStatement(node, expr);
    }
};
$d184995ea4e545a3$var$pp$8.parseBreakContinueStatement = function(node, keyword) {
    var isBreak = keyword === "break";
    this.next();
    if (this.eat($d184995ea4e545a3$export$b54c7ea7aabba5c8.semi) || this.insertSemicolon()) node.label = null;
    else if (this.type !== $d184995ea4e545a3$export$b54c7ea7aabba5c8.name) this.unexpected();
    else {
        node.label = this.parseIdent();
        this.semicolon();
    }
    // Verify that there is an actual destination to break or
    // continue to.
    var i = 0;
    for(; i < this.labels.length; ++i){
        var lab = this.labels[i];
        if (node.label == null || lab.name === node.label.name) {
            if (lab.kind != null && (isBreak || lab.kind === "loop")) break;
            if (node.label && isBreak) break;
        }
    }
    if (i === this.labels.length) this.raise(node.start, "Unsyntactic " + keyword);
    return this.finishNode(node, isBreak ? "BreakStatement" : "ContinueStatement");
};
$d184995ea4e545a3$var$pp$8.parseDebuggerStatement = function(node) {
    this.next();
    this.semicolon();
    return this.finishNode(node, "DebuggerStatement");
};
$d184995ea4e545a3$var$pp$8.parseDoStatement = function(node) {
    this.next();
    this.labels.push($d184995ea4e545a3$var$loopLabel);
    node.body = this.parseStatement("do");
    this.labels.pop();
    this.expect($d184995ea4e545a3$export$b54c7ea7aabba5c8._while);
    node.test = this.parseParenExpression();
    if (this.options.ecmaVersion >= 6) this.eat($d184995ea4e545a3$export$b54c7ea7aabba5c8.semi);
    else this.semicolon();
    return this.finishNode(node, "DoWhileStatement");
};
// Disambiguating between a `for` and a `for`/`in` or `for`/`of`
// loop is non-trivial. Basically, we have to parse the init `var`
// statement or expression, disallowing the `in` operator (see
// the second parameter to `parseExpression`), and then check
// whether the next token is `in` or `of`. When there is no init
// part (semicolon immediately after the opening parenthesis), it
// is a regular `for` loop.
$d184995ea4e545a3$var$pp$8.parseForStatement = function(node) {
    this.next();
    var awaitAt = this.options.ecmaVersion >= 9 && this.canAwait && this.eatContextual("await") ? this.lastTokStart : -1;
    this.labels.push($d184995ea4e545a3$var$loopLabel);
    this.enterScope(0);
    this.expect($d184995ea4e545a3$export$b54c7ea7aabba5c8.parenL);
    if (this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.semi) {
        if (awaitAt > -1) this.unexpected(awaitAt);
        return this.parseFor(node, null);
    }
    var isLet = this.isLet();
    if (this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8._var || this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8._const || isLet) {
        var init$1 = this.startNode(), kind = isLet ? "let" : this.value;
        this.next();
        this.parseVar(init$1, true, kind);
        this.finishNode(init$1, "VariableDeclaration");
        return this.parseForAfterInit(node, init$1, awaitAt);
    }
    var startsWithLet = this.isContextual("let"), isForOf = false;
    var usingKind = this.isUsing(true) ? "using" : this.isAwaitUsing(true) ? "await using" : null;
    if (usingKind) {
        var init$2 = this.startNode();
        this.next();
        if (usingKind === "await using") {
            if (!this.canAwait) this.raise(this.start, "Await using cannot appear outside of async function");
            this.next();
        }
        this.parseVar(init$2, true, usingKind);
        this.finishNode(init$2, "VariableDeclaration");
        return this.parseForAfterInit(node, init$2, awaitAt);
    }
    var containsEsc = this.containsEsc;
    var refDestructuringErrors = new $d184995ea4e545a3$var$DestructuringErrors;
    var initPos = this.start;
    var init = awaitAt > -1 ? this.parseExprSubscripts(refDestructuringErrors, "await") : this.parseExpression(true, refDestructuringErrors);
    if (this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8._in || (isForOf = this.options.ecmaVersion >= 6 && this.isContextual("of"))) {
        if (awaitAt > -1) {
            if (this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8._in) this.unexpected(awaitAt);
            node.await = true;
        } else if (isForOf && this.options.ecmaVersion >= 8) {
            if (init.start === initPos && !containsEsc && init.type === "Identifier" && init.name === "async") this.unexpected();
            else if (this.options.ecmaVersion >= 9) node.await = false;
        }
        if (startsWithLet && isForOf) this.raise(init.start, "The left-hand side of a for-of loop may not start with 'let'.");
        this.toAssignable(init, false, refDestructuringErrors);
        this.checkLValPattern(init);
        return this.parseForIn(node, init);
    } else this.checkExpressionErrors(refDestructuringErrors, true);
    if (awaitAt > -1) this.unexpected(awaitAt);
    return this.parseFor(node, init);
};
// Helper method to parse for loop after variable initialization
$d184995ea4e545a3$var$pp$8.parseForAfterInit = function(node, init, awaitAt) {
    if ((this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8._in || this.options.ecmaVersion >= 6 && this.isContextual("of")) && init.declarations.length === 1) {
        if (this.options.ecmaVersion >= 9) {
            if (this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8._in) {
                if (awaitAt > -1) this.unexpected(awaitAt);
            } else node.await = awaitAt > -1;
        }
        return this.parseForIn(node, init);
    }
    if (awaitAt > -1) this.unexpected(awaitAt);
    return this.parseFor(node, init);
};
$d184995ea4e545a3$var$pp$8.parseFunctionStatement = function(node, isAsync, declarationPosition) {
    this.next();
    return this.parseFunction(node, $d184995ea4e545a3$var$FUNC_STATEMENT | (declarationPosition ? 0 : $d184995ea4e545a3$var$FUNC_HANGING_STATEMENT), false, isAsync);
};
$d184995ea4e545a3$var$pp$8.parseIfStatement = function(node) {
    this.next();
    node.test = this.parseParenExpression();
    // allow function declarations in branches, but only in non-strict mode
    node.consequent = this.parseStatement("if");
    node.alternate = this.eat($d184995ea4e545a3$export$b54c7ea7aabba5c8._else) ? this.parseStatement("if") : null;
    return this.finishNode(node, "IfStatement");
};
$d184995ea4e545a3$var$pp$8.parseReturnStatement = function(node) {
    if (!this.allowReturn) this.raise(this.start, "'return' outside of function");
    this.next();
    // In `return` (and `break`/`continue`), the keywords with
    // optional arguments, we eagerly look for a semicolon or the
    // possibility to insert one.
    if (this.eat($d184995ea4e545a3$export$b54c7ea7aabba5c8.semi) || this.insertSemicolon()) node.argument = null;
    else {
        node.argument = this.parseExpression();
        this.semicolon();
    }
    return this.finishNode(node, "ReturnStatement");
};
$d184995ea4e545a3$var$pp$8.parseSwitchStatement = function(node) {
    this.next();
    node.discriminant = this.parseParenExpression();
    node.cases = [];
    this.expect($d184995ea4e545a3$export$b54c7ea7aabba5c8.braceL);
    this.labels.push($d184995ea4e545a3$var$switchLabel);
    this.enterScope($d184995ea4e545a3$var$SCOPE_SWITCH);
    // Statements under must be grouped (by label) in SwitchCase
    // nodes. `cur` is used to keep the node that we are currently
    // adding statements to.
    var cur;
    for(var sawDefault = false; this.type !== $d184995ea4e545a3$export$b54c7ea7aabba5c8.braceR;)if (this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8._case || this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8._default) {
        var isCase = this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8._case;
        if (cur) this.finishNode(cur, "SwitchCase");
        node.cases.push(cur = this.startNode());
        cur.consequent = [];
        this.next();
        if (isCase) cur.test = this.parseExpression();
        else {
            if (sawDefault) this.raiseRecoverable(this.lastTokStart, "Multiple default clauses");
            sawDefault = true;
            cur.test = null;
        }
        this.expect($d184995ea4e545a3$export$b54c7ea7aabba5c8.colon);
    } else {
        if (!cur) this.unexpected();
        cur.consequent.push(this.parseStatement(null));
    }
    this.exitScope();
    if (cur) this.finishNode(cur, "SwitchCase");
    this.next(); // Closing brace
    this.labels.pop();
    return this.finishNode(node, "SwitchStatement");
};
$d184995ea4e545a3$var$pp$8.parseThrowStatement = function(node) {
    this.next();
    if ($d184995ea4e545a3$export$a1aa2dd4ad0d3f6.test(this.input.slice(this.lastTokEnd, this.start))) this.raise(this.lastTokEnd, "Illegal newline after throw");
    node.argument = this.parseExpression();
    this.semicolon();
    return this.finishNode(node, "ThrowStatement");
};
// Reused empty array added for node fields that are always empty.
var $d184995ea4e545a3$var$empty$1 = [];
$d184995ea4e545a3$var$pp$8.parseCatchClauseParam = function() {
    var param = this.parseBindingAtom();
    var simple = param.type === "Identifier";
    this.enterScope(simple ? $d184995ea4e545a3$var$SCOPE_SIMPLE_CATCH : 0);
    this.checkLValPattern(param, simple ? $d184995ea4e545a3$var$BIND_SIMPLE_CATCH : $d184995ea4e545a3$var$BIND_LEXICAL);
    this.expect($d184995ea4e545a3$export$b54c7ea7aabba5c8.parenR);
    return param;
};
$d184995ea4e545a3$var$pp$8.parseTryStatement = function(node) {
    this.next();
    node.block = this.parseBlock();
    node.handler = null;
    if (this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8._catch) {
        var clause = this.startNode();
        this.next();
        if (this.eat($d184995ea4e545a3$export$b54c7ea7aabba5c8.parenL)) clause.param = this.parseCatchClauseParam();
        else {
            if (this.options.ecmaVersion < 10) this.unexpected();
            clause.param = null;
            this.enterScope(0);
        }
        clause.body = this.parseBlock(false);
        this.exitScope();
        node.handler = this.finishNode(clause, "CatchClause");
    }
    node.finalizer = this.eat($d184995ea4e545a3$export$b54c7ea7aabba5c8._finally) ? this.parseBlock() : null;
    if (!node.handler && !node.finalizer) this.raise(node.start, "Missing catch or finally clause");
    return this.finishNode(node, "TryStatement");
};
$d184995ea4e545a3$var$pp$8.parseVarStatement = function(node, kind, allowMissingInitializer) {
    this.next();
    this.parseVar(node, false, kind, allowMissingInitializer);
    this.semicolon();
    return this.finishNode(node, "VariableDeclaration");
};
$d184995ea4e545a3$var$pp$8.parseWhileStatement = function(node) {
    this.next();
    node.test = this.parseParenExpression();
    this.labels.push($d184995ea4e545a3$var$loopLabel);
    node.body = this.parseStatement("while");
    this.labels.pop();
    return this.finishNode(node, "WhileStatement");
};
$d184995ea4e545a3$var$pp$8.parseWithStatement = function(node) {
    if (this.strict) this.raise(this.start, "'with' in strict mode");
    this.next();
    node.object = this.parseParenExpression();
    node.body = this.parseStatement("with");
    return this.finishNode(node, "WithStatement");
};
$d184995ea4e545a3$var$pp$8.parseEmptyStatement = function(node) {
    this.next();
    return this.finishNode(node, "EmptyStatement");
};
$d184995ea4e545a3$var$pp$8.parseLabeledStatement = function(node, maybeName, expr, context) {
    for(var i$1 = 0, list = this.labels; i$1 < list.length; i$1 += 1){
        var label = list[i$1];
        if (label.name === maybeName) this.raise(expr.start, "Label '" + maybeName + "' is already declared");
    }
    var kind = this.type.isLoop ? "loop" : this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8._switch ? "switch" : null;
    for(var i = this.labels.length - 1; i >= 0; i--){
        var label$1 = this.labels[i];
        if (label$1.statementStart === node.start) {
            // Update information about previous labels on this node
            label$1.statementStart = this.start;
            label$1.kind = kind;
        } else break;
    }
    this.labels.push({
        name: maybeName,
        kind: kind,
        statementStart: this.start
    });
    node.body = this.parseStatement(context ? context.indexOf("label") === -1 ? context + "label" : context : "label");
    this.labels.pop();
    node.label = expr;
    return this.finishNode(node, "LabeledStatement");
};
$d184995ea4e545a3$var$pp$8.parseExpressionStatement = function(node, expr) {
    node.expression = expr;
    this.semicolon();
    return this.finishNode(node, "ExpressionStatement");
};
// Parse a semicolon-enclosed block of statements, handling `"use
// strict"` declarations when `allowStrict` is true (used for
// function bodies).
$d184995ea4e545a3$var$pp$8.parseBlock = function(createNewLexicalScope, node, exitStrict) {
    if (createNewLexicalScope === void 0) createNewLexicalScope = true;
    if (node === void 0) node = this.startNode();
    node.body = [];
    this.expect($d184995ea4e545a3$export$b54c7ea7aabba5c8.braceL);
    if (createNewLexicalScope) this.enterScope(0);
    while(this.type !== $d184995ea4e545a3$export$b54c7ea7aabba5c8.braceR){
        var stmt = this.parseStatement(null);
        node.body.push(stmt);
    }
    if (exitStrict) this.strict = false;
    this.next();
    if (createNewLexicalScope) this.exitScope();
    return this.finishNode(node, "BlockStatement");
};
// Parse a regular `for` loop. The disambiguation code in
// `parseStatement` will already have parsed the init statement or
// expression.
$d184995ea4e545a3$var$pp$8.parseFor = function(node, init) {
    node.init = init;
    this.expect($d184995ea4e545a3$export$b54c7ea7aabba5c8.semi);
    node.test = this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.semi ? null : this.parseExpression();
    this.expect($d184995ea4e545a3$export$b54c7ea7aabba5c8.semi);
    node.update = this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.parenR ? null : this.parseExpression();
    this.expect($d184995ea4e545a3$export$b54c7ea7aabba5c8.parenR);
    node.body = this.parseStatement("for");
    this.exitScope();
    this.labels.pop();
    return this.finishNode(node, "ForStatement");
};
// Parse a `for`/`in` and `for`/`of` loop, which are almost
// same from parser's perspective.
$d184995ea4e545a3$var$pp$8.parseForIn = function(node, init) {
    var isForIn = this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8._in;
    this.next();
    if (init.type === "VariableDeclaration" && init.declarations[0].init != null && (!isForIn || this.options.ecmaVersion < 8 || this.strict || init.kind !== "var" || init.declarations[0].id.type !== "Identifier")) this.raise(init.start, (isForIn ? "for-in" : "for-of") + " loop variable declaration may not have an initializer");
    node.left = init;
    node.right = isForIn ? this.parseExpression() : this.parseMaybeAssign();
    this.expect($d184995ea4e545a3$export$b54c7ea7aabba5c8.parenR);
    node.body = this.parseStatement("for");
    this.exitScope();
    this.labels.pop();
    return this.finishNode(node, isForIn ? "ForInStatement" : "ForOfStatement");
};
// Parse a list of variable declarations.
$d184995ea4e545a3$var$pp$8.parseVar = function(node, isFor, kind, allowMissingInitializer) {
    node.declarations = [];
    node.kind = kind;
    for(;;){
        var decl = this.startNode();
        this.parseVarId(decl, kind);
        if (this.eat($d184995ea4e545a3$export$b54c7ea7aabba5c8.eq)) decl.init = this.parseMaybeAssign(isFor);
        else if (!allowMissingInitializer && kind === "const" && !(this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8._in || this.options.ecmaVersion >= 6 && this.isContextual("of"))) this.unexpected();
        else if (!allowMissingInitializer && (kind === "using" || kind === "await using") && this.options.ecmaVersion >= 17 && this.type !== $d184995ea4e545a3$export$b54c7ea7aabba5c8._in && !this.isContextual("of")) this.raise(this.lastTokEnd, "Missing initializer in " + kind + " declaration");
        else if (!allowMissingInitializer && decl.id.type !== "Identifier" && !(isFor && (this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8._in || this.isContextual("of")))) this.raise(this.lastTokEnd, "Complex binding patterns require an initialization value");
        else decl.init = null;
        node.declarations.push(this.finishNode(decl, "VariableDeclarator"));
        if (!this.eat($d184995ea4e545a3$export$b54c7ea7aabba5c8.comma)) break;
    }
    return node;
};
$d184995ea4e545a3$var$pp$8.parseVarId = function(decl, kind) {
    decl.id = kind === "using" || kind === "await using" ? this.parseIdent() : this.parseBindingAtom();
    this.checkLValPattern(decl.id, kind === "var" ? $d184995ea4e545a3$var$BIND_VAR : $d184995ea4e545a3$var$BIND_LEXICAL, false);
};
var $d184995ea4e545a3$var$FUNC_STATEMENT = 1, $d184995ea4e545a3$var$FUNC_HANGING_STATEMENT = 2, $d184995ea4e545a3$var$FUNC_NULLABLE_ID = 4;
// Parse a function declaration or literal (depending on the
// `statement & FUNC_STATEMENT`).
// Remove `allowExpressionBody` for 7.0.0, as it is only called with false
$d184995ea4e545a3$var$pp$8.parseFunction = function(node, statement, allowExpressionBody, isAsync, forInit) {
    this.initFunction(node);
    if (this.options.ecmaVersion >= 9 || this.options.ecmaVersion >= 6 && !isAsync) {
        if (this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.star && statement & $d184995ea4e545a3$var$FUNC_HANGING_STATEMENT) this.unexpected();
        node.generator = this.eat($d184995ea4e545a3$export$b54c7ea7aabba5c8.star);
    }
    if (this.options.ecmaVersion >= 8) node.async = !!isAsync;
    if (statement & $d184995ea4e545a3$var$FUNC_STATEMENT) {
        node.id = statement & $d184995ea4e545a3$var$FUNC_NULLABLE_ID && this.type !== $d184995ea4e545a3$export$b54c7ea7aabba5c8.name ? null : this.parseIdent();
        if (node.id && !(statement & $d184995ea4e545a3$var$FUNC_HANGING_STATEMENT)) this.checkLValSimple(node.id, this.strict || node.generator || node.async ? this.treatFunctionsAsVar ? $d184995ea4e545a3$var$BIND_VAR : $d184995ea4e545a3$var$BIND_LEXICAL : $d184995ea4e545a3$var$BIND_FUNCTION);
    }
    var oldYieldPos = this.yieldPos, oldAwaitPos = this.awaitPos, oldAwaitIdentPos = this.awaitIdentPos;
    this.yieldPos = 0;
    this.awaitPos = 0;
    this.awaitIdentPos = 0;
    this.enterScope($d184995ea4e545a3$var$functionFlags(node.async, node.generator));
    if (!(statement & $d184995ea4e545a3$var$FUNC_STATEMENT)) node.id = this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.name ? this.parseIdent() : null;
    this.parseFunctionParams(node);
    this.parseFunctionBody(node, allowExpressionBody, false, forInit);
    this.yieldPos = oldYieldPos;
    this.awaitPos = oldAwaitPos;
    this.awaitIdentPos = oldAwaitIdentPos;
    return this.finishNode(node, statement & $d184995ea4e545a3$var$FUNC_STATEMENT ? "FunctionDeclaration" : "FunctionExpression");
};
$d184995ea4e545a3$var$pp$8.parseFunctionParams = function(node) {
    this.expect($d184995ea4e545a3$export$b54c7ea7aabba5c8.parenL);
    node.params = this.parseBindingList($d184995ea4e545a3$export$b54c7ea7aabba5c8.parenR, false, this.options.ecmaVersion >= 8);
    this.checkYieldAwaitInDefaultParams();
};
// Parse a class declaration or literal (depending on the
// `isStatement` parameter).
$d184995ea4e545a3$var$pp$8.parseClass = function(node, isStatement) {
    this.next();
    // ecma-262 14.6 Class Definitions
    // A class definition is always strict mode code.
    var oldStrict = this.strict;
    this.strict = true;
    this.parseClassId(node, isStatement);
    this.parseClassSuper(node);
    var privateNameMap = this.enterClassBody();
    var classBody = this.startNode();
    var hadConstructor = false;
    classBody.body = [];
    this.expect($d184995ea4e545a3$export$b54c7ea7aabba5c8.braceL);
    while(this.type !== $d184995ea4e545a3$export$b54c7ea7aabba5c8.braceR){
        var element = this.parseClassElement(node.superClass !== null);
        if (element) {
            classBody.body.push(element);
            if (element.type === "MethodDefinition" && element.kind === "constructor") {
                if (hadConstructor) this.raiseRecoverable(element.start, "Duplicate constructor in the same class");
                hadConstructor = true;
            } else if (element.key && element.key.type === "PrivateIdentifier" && $d184995ea4e545a3$var$isPrivateNameConflicted(privateNameMap, element)) this.raiseRecoverable(element.key.start, "Identifier '#" + element.key.name + "' has already been declared");
        }
    }
    this.strict = oldStrict;
    this.next();
    node.body = this.finishNode(classBody, "ClassBody");
    this.exitClassBody();
    return this.finishNode(node, isStatement ? "ClassDeclaration" : "ClassExpression");
};
$d184995ea4e545a3$var$pp$8.parseClassElement = function(constructorAllowsSuper) {
    if (this.eat($d184995ea4e545a3$export$b54c7ea7aabba5c8.semi)) return null;
    var ecmaVersion = this.options.ecmaVersion;
    var node = this.startNode();
    var keyName = "";
    var isGenerator = false;
    var isAsync = false;
    var kind = "method";
    var isStatic = false;
    if (this.eatContextual("static")) {
        // Parse static init block
        if (ecmaVersion >= 13 && this.eat($d184995ea4e545a3$export$b54c7ea7aabba5c8.braceL)) {
            this.parseClassStaticBlock(node);
            return node;
        }
        if (this.isClassElementNameStart() || this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.star) isStatic = true;
        else keyName = "static";
    }
    node.static = isStatic;
    if (!keyName && ecmaVersion >= 8 && this.eatContextual("async")) {
        if ((this.isClassElementNameStart() || this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.star) && !this.canInsertSemicolon()) isAsync = true;
        else keyName = "async";
    }
    if (!keyName && (ecmaVersion >= 9 || !isAsync) && this.eat($d184995ea4e545a3$export$b54c7ea7aabba5c8.star)) isGenerator = true;
    if (!keyName && !isAsync && !isGenerator) {
        var lastValue = this.value;
        if (this.eatContextual("get") || this.eatContextual("set")) {
            if (this.isClassElementNameStart()) kind = lastValue;
            else keyName = lastValue;
        }
    }
    // Parse element name
    if (keyName) {
        // 'async', 'get', 'set', or 'static' were not a keyword contextually.
        // The last token is any of those. Make it the element name.
        node.computed = false;
        node.key = this.startNodeAt(this.lastTokStart, this.lastTokStartLoc);
        node.key.name = keyName;
        this.finishNode(node.key, "Identifier");
    } else this.parseClassElementName(node);
    // Parse element value
    if (ecmaVersion < 13 || this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.parenL || kind !== "method" || isGenerator || isAsync) {
        var isConstructor = !node.static && $d184995ea4e545a3$var$checkKeyName(node, "constructor");
        var allowsDirectSuper = isConstructor && constructorAllowsSuper;
        // Couldn't move this check into the 'parseClassMethod' method for backward compatibility.
        if (isConstructor && kind !== "method") this.raise(node.key.start, "Constructor can't have get/set modifier");
        node.kind = isConstructor ? "constructor" : kind;
        this.parseClassMethod(node, isGenerator, isAsync, allowsDirectSuper);
    } else this.parseClassField(node);
    return node;
};
$d184995ea4e545a3$var$pp$8.isClassElementNameStart = function() {
    return this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.name || this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.privateId || this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.num || this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.string || this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.bracketL || this.type.keyword;
};
$d184995ea4e545a3$var$pp$8.parseClassElementName = function(element) {
    if (this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.privateId) {
        if (this.value === "constructor") this.raise(this.start, "Classes can't have an element named '#constructor'");
        element.computed = false;
        element.key = this.parsePrivateIdent();
    } else this.parsePropertyName(element);
};
$d184995ea4e545a3$var$pp$8.parseClassMethod = function(method, isGenerator, isAsync, allowsDirectSuper) {
    // Check key and flags
    var key = method.key;
    if (method.kind === "constructor") {
        if (isGenerator) this.raise(key.start, "Constructor can't be a generator");
        if (isAsync) this.raise(key.start, "Constructor can't be an async method");
    } else if (method.static && $d184995ea4e545a3$var$checkKeyName(method, "prototype")) this.raise(key.start, "Classes may not have a static property named prototype");
    // Parse value
    var value = method.value = this.parseMethod(isGenerator, isAsync, allowsDirectSuper);
    // Check value
    if (method.kind === "get" && value.params.length !== 0) this.raiseRecoverable(value.start, "getter should have no params");
    if (method.kind === "set" && value.params.length !== 1) this.raiseRecoverable(value.start, "setter should have exactly one param");
    if (method.kind === "set" && value.params[0].type === "RestElement") this.raiseRecoverable(value.params[0].start, "Setter cannot use rest params");
    return this.finishNode(method, "MethodDefinition");
};
$d184995ea4e545a3$var$pp$8.parseClassField = function(field) {
    if ($d184995ea4e545a3$var$checkKeyName(field, "constructor")) this.raise(field.key.start, "Classes can't have a field named 'constructor'");
    else if (field.static && $d184995ea4e545a3$var$checkKeyName(field, "prototype")) this.raise(field.key.start, "Classes can't have a static field named 'prototype'");
    if (this.eat($d184995ea4e545a3$export$b54c7ea7aabba5c8.eq)) {
        // To raise SyntaxError if 'arguments' exists in the initializer.
        this.enterScope($d184995ea4e545a3$var$SCOPE_CLASS_FIELD_INIT | $d184995ea4e545a3$var$SCOPE_SUPER);
        field.value = this.parseMaybeAssign();
        this.exitScope();
    } else field.value = null;
    this.semicolon();
    return this.finishNode(field, "PropertyDefinition");
};
$d184995ea4e545a3$var$pp$8.parseClassStaticBlock = function(node) {
    node.body = [];
    var oldLabels = this.labels;
    this.labels = [];
    this.enterScope($d184995ea4e545a3$var$SCOPE_CLASS_STATIC_BLOCK | $d184995ea4e545a3$var$SCOPE_SUPER);
    while(this.type !== $d184995ea4e545a3$export$b54c7ea7aabba5c8.braceR){
        var stmt = this.parseStatement(null);
        node.body.push(stmt);
    }
    this.next();
    this.exitScope();
    this.labels = oldLabels;
    return this.finishNode(node, "StaticBlock");
};
$d184995ea4e545a3$var$pp$8.parseClassId = function(node, isStatement) {
    if (this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.name) {
        node.id = this.parseIdent();
        if (isStatement) this.checkLValSimple(node.id, $d184995ea4e545a3$var$BIND_LEXICAL, false);
    } else {
        if (isStatement === true) this.unexpected();
        node.id = null;
    }
};
$d184995ea4e545a3$var$pp$8.parseClassSuper = function(node) {
    node.superClass = this.eat($d184995ea4e545a3$export$b54c7ea7aabba5c8._extends) ? this.parseExprSubscripts(null, false) : null;
};
$d184995ea4e545a3$var$pp$8.enterClassBody = function() {
    var element = {
        declared: Object.create(null),
        used: []
    };
    this.privateNameStack.push(element);
    return element.declared;
};
$d184995ea4e545a3$var$pp$8.exitClassBody = function() {
    var ref = this.privateNameStack.pop();
    var declared = ref.declared;
    var used = ref.used;
    if (!this.options.checkPrivateFields) return;
    var len = this.privateNameStack.length;
    var parent = len === 0 ? null : this.privateNameStack[len - 1];
    for(var i = 0; i < used.length; ++i){
        var id = used[i];
        if (!$d184995ea4e545a3$var$hasOwn(declared, id.name)) {
            if (parent) parent.used.push(id);
            else this.raiseRecoverable(id.start, "Private field '#" + id.name + "' must be declared in an enclosing class");
        }
    }
};
function $d184995ea4e545a3$var$isPrivateNameConflicted(privateNameMap, element) {
    var name = element.key.name;
    var curr = privateNameMap[name];
    var next = "true";
    if (element.type === "MethodDefinition" && (element.kind === "get" || element.kind === "set")) next = (element.static ? "s" : "i") + element.kind;
    // `class { get #a(){}; static set #a(_){} }` is also conflict.
    if (curr === "iget" && next === "iset" || curr === "iset" && next === "iget" || curr === "sget" && next === "sset" || curr === "sset" && next === "sget") {
        privateNameMap[name] = "true";
        return false;
    } else if (!curr) {
        privateNameMap[name] = next;
        return false;
    } else return true;
}
function $d184995ea4e545a3$var$checkKeyName(node, name) {
    var computed = node.computed;
    var key = node.key;
    return !computed && (key.type === "Identifier" && key.name === name || key.type === "Literal" && key.value === name);
}
// Parses module export declaration.
$d184995ea4e545a3$var$pp$8.parseExportAllDeclaration = function(node, exports) {
    if (this.options.ecmaVersion >= 11) {
        if (this.eatContextual("as")) {
            node.exported = this.parseModuleExportName();
            this.checkExport(exports, node.exported, this.lastTokStart);
        } else node.exported = null;
    }
    this.expectContextual("from");
    if (this.type !== $d184995ea4e545a3$export$b54c7ea7aabba5c8.string) this.unexpected();
    node.source = this.parseExprAtom();
    if (this.options.ecmaVersion >= 16) node.attributes = this.parseWithClause();
    this.semicolon();
    return this.finishNode(node, "ExportAllDeclaration");
};
$d184995ea4e545a3$var$pp$8.parseExport = function(node, exports) {
    this.next();
    // export * from '...'
    if (this.eat($d184995ea4e545a3$export$b54c7ea7aabba5c8.star)) return this.parseExportAllDeclaration(node, exports);
    if (this.eat($d184995ea4e545a3$export$b54c7ea7aabba5c8._default)) {
        this.checkExport(exports, "default", this.lastTokStart);
        node.declaration = this.parseExportDefaultDeclaration();
        return this.finishNode(node, "ExportDefaultDeclaration");
    }
    // export var|const|let|function|class ...
    if (this.shouldParseExportStatement()) {
        node.declaration = this.parseExportDeclaration(node);
        if (node.declaration.type === "VariableDeclaration") this.checkVariableExport(exports, node.declaration.declarations);
        else this.checkExport(exports, node.declaration.id, node.declaration.id.start);
        node.specifiers = [];
        node.source = null;
        if (this.options.ecmaVersion >= 16) node.attributes = [];
    } else {
        node.declaration = null;
        node.specifiers = this.parseExportSpecifiers(exports);
        if (this.eatContextual("from")) {
            if (this.type !== $d184995ea4e545a3$export$b54c7ea7aabba5c8.string) this.unexpected();
            node.source = this.parseExprAtom();
            if (this.options.ecmaVersion >= 16) node.attributes = this.parseWithClause();
        } else {
            for(var i = 0, list = node.specifiers; i < list.length; i += 1){
                // check for keywords used as local names
                var spec = list[i];
                this.checkUnreserved(spec.local);
                // check if export is defined
                this.checkLocalExport(spec.local);
                if (spec.local.type === "Literal") this.raise(spec.local.start, "A string literal cannot be used as an exported binding without `from`.");
            }
            node.source = null;
            if (this.options.ecmaVersion >= 16) node.attributes = [];
        }
        this.semicolon();
    }
    return this.finishNode(node, "ExportNamedDeclaration");
};
$d184995ea4e545a3$var$pp$8.parseExportDeclaration = function(node) {
    return this.parseStatement(null);
};
$d184995ea4e545a3$var$pp$8.parseExportDefaultDeclaration = function() {
    var isAsync;
    if (this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8._function || (isAsync = this.isAsyncFunction())) {
        var fNode = this.startNode();
        this.next();
        if (isAsync) this.next();
        return this.parseFunction(fNode, $d184995ea4e545a3$var$FUNC_STATEMENT | $d184995ea4e545a3$var$FUNC_NULLABLE_ID, false, isAsync);
    } else if (this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8._class) {
        var cNode = this.startNode();
        return this.parseClass(cNode, "nullableID");
    } else {
        var declaration = this.parseMaybeAssign();
        this.semicolon();
        return declaration;
    }
};
$d184995ea4e545a3$var$pp$8.checkExport = function(exports, name, pos) {
    if (!exports) return;
    if (typeof name !== "string") name = name.type === "Identifier" ? name.name : name.value;
    if ($d184995ea4e545a3$var$hasOwn(exports, name)) this.raiseRecoverable(pos, "Duplicate export '" + name + "'");
    exports[name] = true;
};
$d184995ea4e545a3$var$pp$8.checkPatternExport = function(exports, pat) {
    var type = pat.type;
    if (type === "Identifier") this.checkExport(exports, pat, pat.start);
    else if (type === "ObjectPattern") for(var i = 0, list = pat.properties; i < list.length; i += 1){
        var prop = list[i];
        this.checkPatternExport(exports, prop);
    }
    else if (type === "ArrayPattern") for(var i$1 = 0, list$1 = pat.elements; i$1 < list$1.length; i$1 += 1){
        var elt = list$1[i$1];
        if (elt) this.checkPatternExport(exports, elt);
    }
    else if (type === "Property") this.checkPatternExport(exports, pat.value);
    else if (type === "AssignmentPattern") this.checkPatternExport(exports, pat.left);
    else if (type === "RestElement") this.checkPatternExport(exports, pat.argument);
};
$d184995ea4e545a3$var$pp$8.checkVariableExport = function(exports, decls) {
    if (!exports) return;
    for(var i = 0, list = decls; i < list.length; i += 1){
        var decl = list[i];
        this.checkPatternExport(exports, decl.id);
    }
};
$d184995ea4e545a3$var$pp$8.shouldParseExportStatement = function() {
    return this.type.keyword === "var" || this.type.keyword === "const" || this.type.keyword === "class" || this.type.keyword === "function" || this.isLet() || this.isAsyncFunction();
};
// Parses a comma-separated list of module exports.
$d184995ea4e545a3$var$pp$8.parseExportSpecifier = function(exports) {
    var node = this.startNode();
    node.local = this.parseModuleExportName();
    node.exported = this.eatContextual("as") ? this.parseModuleExportName() : node.local;
    this.checkExport(exports, node.exported, node.exported.start);
    return this.finishNode(node, "ExportSpecifier");
};
$d184995ea4e545a3$var$pp$8.parseExportSpecifiers = function(exports) {
    var nodes = [], first = true;
    // export { x, y as z } [from '...']
    this.expect($d184995ea4e545a3$export$b54c7ea7aabba5c8.braceL);
    while(!this.eat($d184995ea4e545a3$export$b54c7ea7aabba5c8.braceR)){
        if (!first) {
            this.expect($d184995ea4e545a3$export$b54c7ea7aabba5c8.comma);
            if (this.afterTrailingComma($d184995ea4e545a3$export$b54c7ea7aabba5c8.braceR)) break;
        } else first = false;
        nodes.push(this.parseExportSpecifier(exports));
    }
    return nodes;
};
// Parses import declaration.
$d184995ea4e545a3$var$pp$8.parseImport = function(node) {
    this.next();
    // import '...'
    if (this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.string) {
        node.specifiers = $d184995ea4e545a3$var$empty$1;
        node.source = this.parseExprAtom();
    } else {
        node.specifiers = this.parseImportSpecifiers();
        this.expectContextual("from");
        node.source = this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.string ? this.parseExprAtom() : this.unexpected();
    }
    if (this.options.ecmaVersion >= 16) node.attributes = this.parseWithClause();
    this.semicolon();
    return this.finishNode(node, "ImportDeclaration");
};
// Parses a comma-separated list of module imports.
$d184995ea4e545a3$var$pp$8.parseImportSpecifier = function() {
    var node = this.startNode();
    node.imported = this.parseModuleExportName();
    if (this.eatContextual("as")) node.local = this.parseIdent();
    else {
        this.checkUnreserved(node.imported);
        node.local = node.imported;
    }
    this.checkLValSimple(node.local, $d184995ea4e545a3$var$BIND_LEXICAL);
    return this.finishNode(node, "ImportSpecifier");
};
$d184995ea4e545a3$var$pp$8.parseImportDefaultSpecifier = function() {
    // import defaultObj, { x, y as z } from '...'
    var node = this.startNode();
    node.local = this.parseIdent();
    this.checkLValSimple(node.local, $d184995ea4e545a3$var$BIND_LEXICAL);
    return this.finishNode(node, "ImportDefaultSpecifier");
};
$d184995ea4e545a3$var$pp$8.parseImportNamespaceSpecifier = function() {
    var node = this.startNode();
    this.next();
    this.expectContextual("as");
    node.local = this.parseIdent();
    this.checkLValSimple(node.local, $d184995ea4e545a3$var$BIND_LEXICAL);
    return this.finishNode(node, "ImportNamespaceSpecifier");
};
$d184995ea4e545a3$var$pp$8.parseImportSpecifiers = function() {
    var nodes = [], first = true;
    if (this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.name) {
        nodes.push(this.parseImportDefaultSpecifier());
        if (!this.eat($d184995ea4e545a3$export$b54c7ea7aabba5c8.comma)) return nodes;
    }
    if (this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.star) {
        nodes.push(this.parseImportNamespaceSpecifier());
        return nodes;
    }
    this.expect($d184995ea4e545a3$export$b54c7ea7aabba5c8.braceL);
    while(!this.eat($d184995ea4e545a3$export$b54c7ea7aabba5c8.braceR)){
        if (!first) {
            this.expect($d184995ea4e545a3$export$b54c7ea7aabba5c8.comma);
            if (this.afterTrailingComma($d184995ea4e545a3$export$b54c7ea7aabba5c8.braceR)) break;
        } else first = false;
        nodes.push(this.parseImportSpecifier());
    }
    return nodes;
};
$d184995ea4e545a3$var$pp$8.parseWithClause = function() {
    var nodes = [];
    if (!this.eat($d184995ea4e545a3$export$b54c7ea7aabba5c8._with)) return nodes;
    this.expect($d184995ea4e545a3$export$b54c7ea7aabba5c8.braceL);
    var attributeKeys = {};
    var first = true;
    while(!this.eat($d184995ea4e545a3$export$b54c7ea7aabba5c8.braceR)){
        if (!first) {
            this.expect($d184995ea4e545a3$export$b54c7ea7aabba5c8.comma);
            if (this.afterTrailingComma($d184995ea4e545a3$export$b54c7ea7aabba5c8.braceR)) break;
        } else first = false;
        var attr = this.parseImportAttribute();
        var keyName = attr.key.type === "Identifier" ? attr.key.name : attr.key.value;
        if ($d184995ea4e545a3$var$hasOwn(attributeKeys, keyName)) this.raiseRecoverable(attr.key.start, "Duplicate attribute key '" + keyName + "'");
        attributeKeys[keyName] = true;
        nodes.push(attr);
    }
    return nodes;
};
$d184995ea4e545a3$var$pp$8.parseImportAttribute = function() {
    var node = this.startNode();
    node.key = this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.string ? this.parseExprAtom() : this.parseIdent(this.options.allowReserved !== "never");
    this.expect($d184995ea4e545a3$export$b54c7ea7aabba5c8.colon);
    if (this.type !== $d184995ea4e545a3$export$b54c7ea7aabba5c8.string) this.unexpected();
    node.value = this.parseExprAtom();
    return this.finishNode(node, "ImportAttribute");
};
$d184995ea4e545a3$var$pp$8.parseModuleExportName = function() {
    if (this.options.ecmaVersion >= 13 && this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.string) {
        var stringLiteral = this.parseLiteral(this.value);
        if ($d184995ea4e545a3$var$loneSurrogate.test(stringLiteral.value)) this.raise(stringLiteral.start, "An export name cannot include a lone surrogate.");
        return stringLiteral;
    }
    return this.parseIdent(true);
};
// Set `ExpressionStatement#directive` property for directive prologues.
$d184995ea4e545a3$var$pp$8.adaptDirectivePrologue = function(statements) {
    for(var i = 0; i < statements.length && this.isDirectiveCandidate(statements[i]); ++i)statements[i].directive = statements[i].expression.raw.slice(1, -1);
};
$d184995ea4e545a3$var$pp$8.isDirectiveCandidate = function(statement) {
    return this.options.ecmaVersion >= 5 && statement.type === "ExpressionStatement" && statement.expression.type === "Literal" && typeof statement.expression.value === "string" && // Reject parenthesized strings.
    (this.input[statement.start] === "\"" || this.input[statement.start] === "'");
};
var $d184995ea4e545a3$var$pp$7 = $d184995ea4e545a3$export$7acfa6ed01010e37.prototype;
// Convert existing expression atom to assignable pattern
// if possible.
$d184995ea4e545a3$var$pp$7.toAssignable = function(node, isBinding, refDestructuringErrors) {
    if (this.options.ecmaVersion >= 6 && node) switch(node.type){
        case "Identifier":
            if (this.inAsync && node.name === "await") this.raise(node.start, "Cannot use 'await' as identifier inside an async function");
            break;
        case "ObjectPattern":
        case "ArrayPattern":
        case "AssignmentPattern":
        case "RestElement":
            break;
        case "ObjectExpression":
            node.type = "ObjectPattern";
            if (refDestructuringErrors) this.checkPatternErrors(refDestructuringErrors, true);
            for(var i = 0, list = node.properties; i < list.length; i += 1){
                var prop = list[i];
                this.toAssignable(prop, isBinding);
                // Early error:
                //   AssignmentRestProperty[Yield, Await] :
                //     `...` DestructuringAssignmentTarget[Yield, Await]
                //
                //   It is a Syntax Error if |DestructuringAssignmentTarget| is an |ArrayLiteral| or an |ObjectLiteral|.
                if (prop.type === "RestElement" && (prop.argument.type === "ArrayPattern" || prop.argument.type === "ObjectPattern")) this.raise(prop.argument.start, "Unexpected token");
            }
            break;
        case "Property":
            // AssignmentProperty has type === "Property"
            if (node.kind !== "init") this.raise(node.key.start, "Object pattern can't contain getter or setter");
            this.toAssignable(node.value, isBinding);
            break;
        case "ArrayExpression":
            node.type = "ArrayPattern";
            if (refDestructuringErrors) this.checkPatternErrors(refDestructuringErrors, true);
            this.toAssignableList(node.elements, isBinding);
            break;
        case "SpreadElement":
            node.type = "RestElement";
            this.toAssignable(node.argument, isBinding);
            if (node.argument.type === "AssignmentPattern") this.raise(node.argument.start, "Rest elements cannot have a default value");
            break;
        case "AssignmentExpression":
            if (node.operator !== "=") this.raise(node.left.end, "Only '=' operator can be used for specifying default value.");
            node.type = "AssignmentPattern";
            delete node.operator;
            this.toAssignable(node.left, isBinding);
            break;
        case "ParenthesizedExpression":
            this.toAssignable(node.expression, isBinding, refDestructuringErrors);
            break;
        case "ChainExpression":
            this.raiseRecoverable(node.start, "Optional chaining cannot appear in left-hand side");
            break;
        case "MemberExpression":
            if (!isBinding) break;
        default:
            this.raise(node.start, "Assigning to rvalue");
    }
    else if (refDestructuringErrors) this.checkPatternErrors(refDestructuringErrors, true);
    return node;
};
// Convert list of expression atoms to binding list.
$d184995ea4e545a3$var$pp$7.toAssignableList = function(exprList, isBinding) {
    var end = exprList.length;
    for(var i = 0; i < end; i++){
        var elt = exprList[i];
        if (elt) this.toAssignable(elt, isBinding);
    }
    if (end) {
        var last = exprList[end - 1];
        if (this.options.ecmaVersion === 6 && isBinding && last && last.type === "RestElement" && last.argument.type !== "Identifier") this.unexpected(last.argument.start);
    }
    return exprList;
};
// Parses spread element.
$d184995ea4e545a3$var$pp$7.parseSpread = function(refDestructuringErrors) {
    var node = this.startNode();
    this.next();
    node.argument = this.parseMaybeAssign(false, refDestructuringErrors);
    return this.finishNode(node, "SpreadElement");
};
$d184995ea4e545a3$var$pp$7.parseRestBinding = function() {
    var node = this.startNode();
    this.next();
    // RestElement inside of a function parameter must be an identifier
    if (this.options.ecmaVersion === 6 && this.type !== $d184995ea4e545a3$export$b54c7ea7aabba5c8.name) this.unexpected();
    node.argument = this.parseBindingAtom();
    return this.finishNode(node, "RestElement");
};
// Parses lvalue (assignable) atom.
$d184995ea4e545a3$var$pp$7.parseBindingAtom = function() {
    if (this.options.ecmaVersion >= 6) switch(this.type){
        case $d184995ea4e545a3$export$b54c7ea7aabba5c8.bracketL:
            var node = this.startNode();
            this.next();
            node.elements = this.parseBindingList($d184995ea4e545a3$export$b54c7ea7aabba5c8.bracketR, true, true);
            return this.finishNode(node, "ArrayPattern");
        case $d184995ea4e545a3$export$b54c7ea7aabba5c8.braceL:
            return this.parseObj(true);
    }
    return this.parseIdent();
};
$d184995ea4e545a3$var$pp$7.parseBindingList = function(close, allowEmpty, allowTrailingComma, allowModifiers) {
    var elts = [], first = true;
    while(!this.eat(close)){
        if (first) first = false;
        else this.expect($d184995ea4e545a3$export$b54c7ea7aabba5c8.comma);
        if (allowEmpty && this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.comma) elts.push(null);
        else if (allowTrailingComma && this.afterTrailingComma(close)) break;
        else if (this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.ellipsis) {
            var rest = this.parseRestBinding();
            this.parseBindingListItem(rest);
            elts.push(rest);
            if (this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.comma) this.raiseRecoverable(this.start, "Comma is not permitted after the rest element");
            this.expect(close);
            break;
        } else elts.push(this.parseAssignableListItem(allowModifiers));
    }
    return elts;
};
$d184995ea4e545a3$var$pp$7.parseAssignableListItem = function(allowModifiers) {
    var elem = this.parseMaybeDefault(this.start, this.startLoc);
    this.parseBindingListItem(elem);
    return elem;
};
$d184995ea4e545a3$var$pp$7.parseBindingListItem = function(param) {
    return param;
};
// Parses assignment pattern around given atom if possible.
$d184995ea4e545a3$var$pp$7.parseMaybeDefault = function(startPos, startLoc, left) {
    left = left || this.parseBindingAtom();
    if (this.options.ecmaVersion < 6 || !this.eat($d184995ea4e545a3$export$b54c7ea7aabba5c8.eq)) return left;
    var node = this.startNodeAt(startPos, startLoc);
    node.left = left;
    node.right = this.parseMaybeAssign();
    return this.finishNode(node, "AssignmentPattern");
};
// The following three functions all verify that a node is an lvalue —
// something that can be bound, or assigned to. In order to do so, they perform
// a variety of checks:
//
// - Check that none of the bound/assigned-to identifiers are reserved words.
// - Record name declarations for bindings in the appropriate scope.
// - Check duplicate argument names, if checkClashes is set.
//
// If a complex binding pattern is encountered (e.g., object and array
// destructuring), the entire pattern is recursively checked.
//
// There are three versions of checkLVal*() appropriate for different
// circumstances:
//
// - checkLValSimple() shall be used if the syntactic construct supports
//   nothing other than identifiers and member expressions. Parenthesized
//   expressions are also correctly handled. This is generally appropriate for
//   constructs for which the spec says
//
//   > It is a Syntax Error if AssignmentTargetType of [the production] is not
//   > simple.
//
//   It is also appropriate for checking if an identifier is valid and not
//   defined elsewhere, like import declarations or function/class identifiers.
//
//   Examples where this is used include:
//     a += …;
//     import a from '…';
//   where a is the node to be checked.
//
// - checkLValPattern() shall be used if the syntactic construct supports
//   anything checkLValSimple() supports, as well as object and array
//   destructuring patterns. This is generally appropriate for constructs for
//   which the spec says
//
//   > It is a Syntax Error if [the production] is neither an ObjectLiteral nor
//   > an ArrayLiteral and AssignmentTargetType of [the production] is not
//   > simple.
//
//   Examples where this is used include:
//     (a = …);
//     const a = …;
//     try { … } catch (a) { … }
//   where a is the node to be checked.
//
// - checkLValInnerPattern() shall be used if the syntactic construct supports
//   anything checkLValPattern() supports, as well as default assignment
//   patterns, rest elements, and other constructs that may appear within an
//   object or array destructuring pattern.
//
//   As a special case, function parameters also use checkLValInnerPattern(),
//   as they also support defaults and rest constructs.
//
// These functions deliberately support both assignment and binding constructs,
// as the logic for both is exceedingly similar. If the node is the target of
// an assignment, then bindingType should be set to BIND_NONE. Otherwise, it
// should be set to the appropriate BIND_* constant, like BIND_VAR or
// BIND_LEXICAL.
//
// If the function is called with a non-BIND_NONE bindingType, then
// additionally a checkClashes object may be specified to allow checking for
// duplicate argument names. checkClashes is ignored if the provided construct
// is an assignment (i.e., bindingType is BIND_NONE).
$d184995ea4e545a3$var$pp$7.checkLValSimple = function(expr, bindingType, checkClashes) {
    if (bindingType === void 0) bindingType = $d184995ea4e545a3$var$BIND_NONE;
    var isBind = bindingType !== $d184995ea4e545a3$var$BIND_NONE;
    switch(expr.type){
        case "Identifier":
            if (this.strict && this.reservedWordsStrictBind.test(expr.name)) this.raiseRecoverable(expr.start, (isBind ? "Binding " : "Assigning to ") + expr.name + " in strict mode");
            if (isBind) {
                if (bindingType === $d184995ea4e545a3$var$BIND_LEXICAL && expr.name === "let") this.raiseRecoverable(expr.start, "let is disallowed as a lexically bound name");
                if (checkClashes) {
                    if ($d184995ea4e545a3$var$hasOwn(checkClashes, expr.name)) this.raiseRecoverable(expr.start, "Argument name clash");
                    checkClashes[expr.name] = true;
                }
                if (bindingType !== $d184995ea4e545a3$var$BIND_OUTSIDE) this.declareName(expr.name, bindingType, expr.start);
            }
            break;
        case "ChainExpression":
            this.raiseRecoverable(expr.start, "Optional chaining cannot appear in left-hand side");
            break;
        case "MemberExpression":
            if (isBind) this.raiseRecoverable(expr.start, "Binding member expression");
            break;
        case "ParenthesizedExpression":
            if (isBind) this.raiseRecoverable(expr.start, "Binding parenthesized expression");
            return this.checkLValSimple(expr.expression, bindingType, checkClashes);
        default:
            this.raise(expr.start, (isBind ? "Binding" : "Assigning to") + " rvalue");
    }
};
$d184995ea4e545a3$var$pp$7.checkLValPattern = function(expr, bindingType, checkClashes) {
    if (bindingType === void 0) bindingType = $d184995ea4e545a3$var$BIND_NONE;
    switch(expr.type){
        case "ObjectPattern":
            for(var i = 0, list = expr.properties; i < list.length; i += 1){
                var prop = list[i];
                this.checkLValInnerPattern(prop, bindingType, checkClashes);
            }
            break;
        case "ArrayPattern":
            for(var i$1 = 0, list$1 = expr.elements; i$1 < list$1.length; i$1 += 1){
                var elem = list$1[i$1];
                if (elem) this.checkLValInnerPattern(elem, bindingType, checkClashes);
            }
            break;
        default:
            this.checkLValSimple(expr, bindingType, checkClashes);
    }
};
$d184995ea4e545a3$var$pp$7.checkLValInnerPattern = function(expr, bindingType, checkClashes) {
    if (bindingType === void 0) bindingType = $d184995ea4e545a3$var$BIND_NONE;
    switch(expr.type){
        case "Property":
            // AssignmentProperty has type === "Property"
            this.checkLValInnerPattern(expr.value, bindingType, checkClashes);
            break;
        case "AssignmentPattern":
            this.checkLValPattern(expr.left, bindingType, checkClashes);
            break;
        case "RestElement":
            this.checkLValPattern(expr.argument, bindingType, checkClashes);
            break;
        default:
            this.checkLValPattern(expr, bindingType, checkClashes);
    }
};
// The algorithm used to determine whether a regexp can appear at a
// given point in the program is loosely based on sweet.js' approach.
// See https://github.com/mozilla/sweet.js/wiki/design
var $d184995ea4e545a3$export$68e7b4c4d99215d9 = function TokContext(token, isExpr, preserveSpace, override, generator) {
    this.token = token;
    this.isExpr = !!isExpr;
    this.preserveSpace = !!preserveSpace;
    this.override = override;
    this.generator = !!generator;
};
var $d184995ea4e545a3$export$2b5f701edfbd6f00 = {
    b_stat: new $d184995ea4e545a3$export$68e7b4c4d99215d9("{", false),
    b_expr: new $d184995ea4e545a3$export$68e7b4c4d99215d9("{", true),
    b_tmpl: new $d184995ea4e545a3$export$68e7b4c4d99215d9("${", false),
    p_stat: new $d184995ea4e545a3$export$68e7b4c4d99215d9("(", false),
    p_expr: new $d184995ea4e545a3$export$68e7b4c4d99215d9("(", true),
    q_tmpl: new $d184995ea4e545a3$export$68e7b4c4d99215d9("`", true, true, function(p) {
        return p.tryReadTemplateToken();
    }),
    f_stat: new $d184995ea4e545a3$export$68e7b4c4d99215d9("function", false),
    f_expr: new $d184995ea4e545a3$export$68e7b4c4d99215d9("function", true),
    f_expr_gen: new $d184995ea4e545a3$export$68e7b4c4d99215d9("function", true, false, null, true),
    f_gen: new $d184995ea4e545a3$export$68e7b4c4d99215d9("function", false, false, null, true)
};
var $d184995ea4e545a3$var$pp$6 = $d184995ea4e545a3$export$7acfa6ed01010e37.prototype;
$d184995ea4e545a3$var$pp$6.initialContext = function() {
    return [
        $d184995ea4e545a3$export$2b5f701edfbd6f00.b_stat
    ];
};
$d184995ea4e545a3$var$pp$6.curContext = function() {
    return this.context[this.context.length - 1];
};
$d184995ea4e545a3$var$pp$6.braceIsBlock = function(prevType) {
    var parent = this.curContext();
    if (parent === $d184995ea4e545a3$export$2b5f701edfbd6f00.f_expr || parent === $d184995ea4e545a3$export$2b5f701edfbd6f00.f_stat) return true;
    if (prevType === $d184995ea4e545a3$export$b54c7ea7aabba5c8.colon && (parent === $d184995ea4e545a3$export$2b5f701edfbd6f00.b_stat || parent === $d184995ea4e545a3$export$2b5f701edfbd6f00.b_expr)) return !parent.isExpr;
    // The check for `tt.name && exprAllowed` detects whether we are
    // after a `yield` or `of` construct. See the `updateContext` for
    // `tt.name`.
    if (prevType === $d184995ea4e545a3$export$b54c7ea7aabba5c8._return || prevType === $d184995ea4e545a3$export$b54c7ea7aabba5c8.name && this.exprAllowed) return $d184995ea4e545a3$export$a1aa2dd4ad0d3f6.test(this.input.slice(this.lastTokEnd, this.start));
    if (prevType === $d184995ea4e545a3$export$b54c7ea7aabba5c8._else || prevType === $d184995ea4e545a3$export$b54c7ea7aabba5c8.semi || prevType === $d184995ea4e545a3$export$b54c7ea7aabba5c8.eof || prevType === $d184995ea4e545a3$export$b54c7ea7aabba5c8.parenR || prevType === $d184995ea4e545a3$export$b54c7ea7aabba5c8.arrow) return true;
    if (prevType === $d184995ea4e545a3$export$b54c7ea7aabba5c8.braceL) return parent === $d184995ea4e545a3$export$2b5f701edfbd6f00.b_stat;
    if (prevType === $d184995ea4e545a3$export$b54c7ea7aabba5c8._var || prevType === $d184995ea4e545a3$export$b54c7ea7aabba5c8._const || prevType === $d184995ea4e545a3$export$b54c7ea7aabba5c8.name) return false;
    return !this.exprAllowed;
};
$d184995ea4e545a3$var$pp$6.inGeneratorContext = function() {
    for(var i = this.context.length - 1; i >= 1; i--){
        var context = this.context[i];
        if (context.token === "function") return context.generator;
    }
    return false;
};
$d184995ea4e545a3$var$pp$6.updateContext = function(prevType) {
    var update, type = this.type;
    if (type.keyword && prevType === $d184995ea4e545a3$export$b54c7ea7aabba5c8.dot) this.exprAllowed = false;
    else if (update = type.updateContext) update.call(this, prevType);
    else this.exprAllowed = type.beforeExpr;
};
// Used to handle edge cases when token context could not be inferred correctly during tokenization phase
$d184995ea4e545a3$var$pp$6.overrideContext = function(tokenCtx) {
    if (this.curContext() !== tokenCtx) this.context[this.context.length - 1] = tokenCtx;
};
// Token-specific context update code
$d184995ea4e545a3$export$b54c7ea7aabba5c8.parenR.updateContext = $d184995ea4e545a3$export$b54c7ea7aabba5c8.braceR.updateContext = function() {
    if (this.context.length === 1) {
        this.exprAllowed = true;
        return;
    }
    var out = this.context.pop();
    if (out === $d184995ea4e545a3$export$2b5f701edfbd6f00.b_stat && this.curContext().token === "function") out = this.context.pop();
    this.exprAllowed = !out.isExpr;
};
$d184995ea4e545a3$export$b54c7ea7aabba5c8.braceL.updateContext = function(prevType) {
    this.context.push(this.braceIsBlock(prevType) ? $d184995ea4e545a3$export$2b5f701edfbd6f00.b_stat : $d184995ea4e545a3$export$2b5f701edfbd6f00.b_expr);
    this.exprAllowed = true;
};
$d184995ea4e545a3$export$b54c7ea7aabba5c8.dollarBraceL.updateContext = function() {
    this.context.push($d184995ea4e545a3$export$2b5f701edfbd6f00.b_tmpl);
    this.exprAllowed = true;
};
$d184995ea4e545a3$export$b54c7ea7aabba5c8.parenL.updateContext = function(prevType) {
    var statementParens = prevType === $d184995ea4e545a3$export$b54c7ea7aabba5c8._if || prevType === $d184995ea4e545a3$export$b54c7ea7aabba5c8._for || prevType === $d184995ea4e545a3$export$b54c7ea7aabba5c8._with || prevType === $d184995ea4e545a3$export$b54c7ea7aabba5c8._while;
    this.context.push(statementParens ? $d184995ea4e545a3$export$2b5f701edfbd6f00.p_stat : $d184995ea4e545a3$export$2b5f701edfbd6f00.p_expr);
    this.exprAllowed = true;
};
$d184995ea4e545a3$export$b54c7ea7aabba5c8.incDec.updateContext = function() {
// tokExprAllowed stays unchanged
};
$d184995ea4e545a3$export$b54c7ea7aabba5c8._function.updateContext = $d184995ea4e545a3$export$b54c7ea7aabba5c8._class.updateContext = function(prevType) {
    if (prevType.beforeExpr && prevType !== $d184995ea4e545a3$export$b54c7ea7aabba5c8._else && !(prevType === $d184995ea4e545a3$export$b54c7ea7aabba5c8.semi && this.curContext() !== $d184995ea4e545a3$export$2b5f701edfbd6f00.p_stat) && !(prevType === $d184995ea4e545a3$export$b54c7ea7aabba5c8._return && $d184995ea4e545a3$export$a1aa2dd4ad0d3f6.test(this.input.slice(this.lastTokEnd, this.start))) && !((prevType === $d184995ea4e545a3$export$b54c7ea7aabba5c8.colon || prevType === $d184995ea4e545a3$export$b54c7ea7aabba5c8.braceL) && this.curContext() === $d184995ea4e545a3$export$2b5f701edfbd6f00.b_stat)) this.context.push($d184995ea4e545a3$export$2b5f701edfbd6f00.f_expr);
    else this.context.push($d184995ea4e545a3$export$2b5f701edfbd6f00.f_stat);
    this.exprAllowed = false;
};
$d184995ea4e545a3$export$b54c7ea7aabba5c8.colon.updateContext = function() {
    if (this.curContext().token === "function") this.context.pop();
    this.exprAllowed = true;
};
$d184995ea4e545a3$export$b54c7ea7aabba5c8.backQuote.updateContext = function() {
    if (this.curContext() === $d184995ea4e545a3$export$2b5f701edfbd6f00.q_tmpl) this.context.pop();
    else this.context.push($d184995ea4e545a3$export$2b5f701edfbd6f00.q_tmpl);
    this.exprAllowed = false;
};
$d184995ea4e545a3$export$b54c7ea7aabba5c8.star.updateContext = function(prevType) {
    if (prevType === $d184995ea4e545a3$export$b54c7ea7aabba5c8._function) {
        var index = this.context.length - 1;
        if (this.context[index] === $d184995ea4e545a3$export$2b5f701edfbd6f00.f_expr) this.context[index] = $d184995ea4e545a3$export$2b5f701edfbd6f00.f_expr_gen;
        else this.context[index] = $d184995ea4e545a3$export$2b5f701edfbd6f00.f_gen;
    }
    this.exprAllowed = true;
};
$d184995ea4e545a3$export$b54c7ea7aabba5c8.name.updateContext = function(prevType) {
    var allowed = false;
    if (this.options.ecmaVersion >= 6 && prevType !== $d184995ea4e545a3$export$b54c7ea7aabba5c8.dot) {
        if (this.value === "of" && !this.exprAllowed || this.value === "yield" && this.inGeneratorContext()) allowed = true;
    }
    this.exprAllowed = allowed;
};
// A recursive descent parser operates by defining functions for all
// syntactic elements, and recursively calling those, each function
// advancing the input stream and returning an AST node. Precedence
// of constructs (for example, the fact that `!x[1]` means `!(x[1])`
// instead of `(!x)[1]` is handled by the fact that the parser
// function that parses unary prefix operators is called first, and
// in turn calls the function that parses `[]` subscripts — that
// way, it'll receive the node for `x[1]` already parsed, and wraps
// *that* in the unary operator node.
//
// Acorn uses an [operator precedence parser][opp] to handle binary
// operator precedence, because it is much more compact than using
// the technique outlined above, which uses different, nesting
// functions to specify precedence, for all of the ten binary
// precedence levels that JavaScript defines.
//
// [opp]: http://en.wikipedia.org/wiki/Operator-precedence_parser
var $d184995ea4e545a3$var$pp$5 = $d184995ea4e545a3$export$7acfa6ed01010e37.prototype;
// Check if property name clashes with already added.
// Object/class getters and setters are not allowed to clash —
// either with each other or with an init property — and in
// strict mode, init properties are also not allowed to be repeated.
$d184995ea4e545a3$var$pp$5.checkPropClash = function(prop, propHash, refDestructuringErrors) {
    if (this.options.ecmaVersion >= 9 && prop.type === "SpreadElement") return;
    if (this.options.ecmaVersion >= 6 && (prop.computed || prop.method || prop.shorthand)) return;
    var key = prop.key;
    var name;
    switch(key.type){
        case "Identifier":
            name = key.name;
            break;
        case "Literal":
            name = String(key.value);
            break;
        default:
            return;
    }
    var kind = prop.kind;
    if (this.options.ecmaVersion >= 6) {
        if (name === "__proto__" && kind === "init") {
            if (propHash.proto) {
                if (refDestructuringErrors) {
                    if (refDestructuringErrors.doubleProto < 0) refDestructuringErrors.doubleProto = key.start;
                } else this.raiseRecoverable(key.start, "Redefinition of __proto__ property");
            }
            propHash.proto = true;
        }
        return;
    }
    name = "$" + name;
    var other = propHash[name];
    if (other) {
        var redefinition;
        if (kind === "init") redefinition = this.strict && other.init || other.get || other.set;
        else redefinition = other.init || other[kind];
        if (redefinition) this.raiseRecoverable(key.start, "Redefinition of property");
    } else other = propHash[name] = {
        init: false,
        get: false,
        set: false
    };
    other[kind] = true;
};
// ### Expression parsing
// These nest, from the most general expression type at the top to
// 'atomic', nondivisible expression types at the bottom. Most of
// the functions will simply let the function(s) below them parse,
// and, *if* the syntactic construct they handle is present, wrap
// the AST node that the inner parser gave them in another node.
// Parse a full expression. The optional arguments are used to
// forbid the `in` operator (in for loops initalization expressions)
// and provide reference for storing '=' operator inside shorthand
// property assignment in contexts where both object expression
// and object pattern might appear (so it's possible to raise
// delayed syntax error at correct position).
$d184995ea4e545a3$var$pp$5.parseExpression = function(forInit, refDestructuringErrors) {
    var startPos = this.start, startLoc = this.startLoc;
    var expr = this.parseMaybeAssign(forInit, refDestructuringErrors);
    if (this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.comma) {
        var node = this.startNodeAt(startPos, startLoc);
        node.expressions = [
            expr
        ];
        while(this.eat($d184995ea4e545a3$export$b54c7ea7aabba5c8.comma))node.expressions.push(this.parseMaybeAssign(forInit, refDestructuringErrors));
        return this.finishNode(node, "SequenceExpression");
    }
    return expr;
};
// Parse an assignment expression. This includes applications of
// operators like `+=`.
$d184995ea4e545a3$var$pp$5.parseMaybeAssign = function(forInit, refDestructuringErrors, afterLeftParse) {
    if (this.isContextual("yield")) {
        if (this.inGenerator) return this.parseYield(forInit);
        else this.exprAllowed = false;
    }
    var ownDestructuringErrors = false, oldParenAssign = -1, oldTrailingComma = -1, oldDoubleProto = -1;
    if (refDestructuringErrors) {
        oldParenAssign = refDestructuringErrors.parenthesizedAssign;
        oldTrailingComma = refDestructuringErrors.trailingComma;
        oldDoubleProto = refDestructuringErrors.doubleProto;
        refDestructuringErrors.parenthesizedAssign = refDestructuringErrors.trailingComma = -1;
    } else {
        refDestructuringErrors = new $d184995ea4e545a3$var$DestructuringErrors;
        ownDestructuringErrors = true;
    }
    var startPos = this.start, startLoc = this.startLoc;
    if (this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.parenL || this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.name) {
        this.potentialArrowAt = this.start;
        this.potentialArrowInForAwait = forInit === "await";
    }
    var left = this.parseMaybeConditional(forInit, refDestructuringErrors);
    if (afterLeftParse) left = afterLeftParse.call(this, left, startPos, startLoc);
    if (this.type.isAssign) {
        var node = this.startNodeAt(startPos, startLoc);
        node.operator = this.value;
        if (this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.eq) left = this.toAssignable(left, false, refDestructuringErrors);
        if (!ownDestructuringErrors) refDestructuringErrors.parenthesizedAssign = refDestructuringErrors.trailingComma = refDestructuringErrors.doubleProto = -1;
        if (refDestructuringErrors.shorthandAssign >= left.start) refDestructuringErrors.shorthandAssign = -1;
         // reset because shorthand default was used correctly
        if (this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.eq) this.checkLValPattern(left);
        else this.checkLValSimple(left);
        node.left = left;
        this.next();
        node.right = this.parseMaybeAssign(forInit);
        if (oldDoubleProto > -1) refDestructuringErrors.doubleProto = oldDoubleProto;
        return this.finishNode(node, "AssignmentExpression");
    } else if (ownDestructuringErrors) this.checkExpressionErrors(refDestructuringErrors, true);
    if (oldParenAssign > -1) refDestructuringErrors.parenthesizedAssign = oldParenAssign;
    if (oldTrailingComma > -1) refDestructuringErrors.trailingComma = oldTrailingComma;
    return left;
};
// Parse a ternary conditional (`?:`) operator.
$d184995ea4e545a3$var$pp$5.parseMaybeConditional = function(forInit, refDestructuringErrors) {
    var startPos = this.start, startLoc = this.startLoc;
    var expr = this.parseExprOps(forInit, refDestructuringErrors);
    if (this.checkExpressionErrors(refDestructuringErrors)) return expr;
    if (this.eat($d184995ea4e545a3$export$b54c7ea7aabba5c8.question)) {
        var node = this.startNodeAt(startPos, startLoc);
        node.test = expr;
        node.consequent = this.parseMaybeAssign();
        this.expect($d184995ea4e545a3$export$b54c7ea7aabba5c8.colon);
        node.alternate = this.parseMaybeAssign(forInit);
        return this.finishNode(node, "ConditionalExpression");
    }
    return expr;
};
// Start the precedence parser.
$d184995ea4e545a3$var$pp$5.parseExprOps = function(forInit, refDestructuringErrors) {
    var startPos = this.start, startLoc = this.startLoc;
    var expr = this.parseMaybeUnary(refDestructuringErrors, false, false, forInit);
    if (this.checkExpressionErrors(refDestructuringErrors)) return expr;
    return expr.start === startPos && expr.type === "ArrowFunctionExpression" ? expr : this.parseExprOp(expr, startPos, startLoc, -1, forInit);
};
// Parse binary operators with the operator precedence parsing
// algorithm. `left` is the left-hand side of the operator.
// `minPrec` provides context that allows the function to stop and
// defer further parser to one of its callers when it encounters an
// operator that has a lower precedence than the set it is parsing.
$d184995ea4e545a3$var$pp$5.parseExprOp = function(left, leftStartPos, leftStartLoc, minPrec, forInit) {
    var prec = this.type.binop;
    if (prec != null && (!forInit || this.type !== $d184995ea4e545a3$export$b54c7ea7aabba5c8._in)) {
        if (prec > minPrec) {
            var logical = this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.logicalOR || this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.logicalAND;
            var coalesce = this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.coalesce;
            if (coalesce) // Handle the precedence of `tt.coalesce` as equal to the range of logical expressions.
            // In other words, `node.right` shouldn't contain logical expressions in order to check the mixed error.
            prec = $d184995ea4e545a3$export$b54c7ea7aabba5c8.logicalAND.binop;
            var op = this.value;
            this.next();
            var startPos = this.start, startLoc = this.startLoc;
            var right = this.parseExprOp(this.parseMaybeUnary(null, false, false, forInit), startPos, startLoc, prec, forInit);
            var node = this.buildBinary(leftStartPos, leftStartLoc, left, right, op, logical || coalesce);
            if (logical && this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.coalesce || coalesce && (this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.logicalOR || this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.logicalAND)) this.raiseRecoverable(this.start, "Logical expressions and coalesce expressions cannot be mixed. Wrap either by parentheses");
            return this.parseExprOp(node, leftStartPos, leftStartLoc, minPrec, forInit);
        }
    }
    return left;
};
$d184995ea4e545a3$var$pp$5.buildBinary = function(startPos, startLoc, left, right, op, logical) {
    if (right.type === "PrivateIdentifier") this.raise(right.start, "Private identifier can only be left side of binary expression");
    var node = this.startNodeAt(startPos, startLoc);
    node.left = left;
    node.operator = op;
    node.right = right;
    return this.finishNode(node, logical ? "LogicalExpression" : "BinaryExpression");
};
// Parse unary operators, both prefix and postfix.
$d184995ea4e545a3$var$pp$5.parseMaybeUnary = function(refDestructuringErrors, sawUnary, incDec, forInit) {
    var startPos = this.start, startLoc = this.startLoc, expr;
    if (this.isContextual("await") && this.canAwait) {
        expr = this.parseAwait(forInit);
        sawUnary = true;
    } else if (this.type.prefix) {
        var node = this.startNode(), update = this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.incDec;
        node.operator = this.value;
        node.prefix = true;
        this.next();
        node.argument = this.parseMaybeUnary(null, true, update, forInit);
        this.checkExpressionErrors(refDestructuringErrors, true);
        if (update) this.checkLValSimple(node.argument);
        else if (this.strict && node.operator === "delete" && $d184995ea4e545a3$var$isLocalVariableAccess(node.argument)) this.raiseRecoverable(node.start, "Deleting local variable in strict mode");
        else if (node.operator === "delete" && $d184995ea4e545a3$var$isPrivateFieldAccess(node.argument)) this.raiseRecoverable(node.start, "Private fields can not be deleted");
        else sawUnary = true;
        expr = this.finishNode(node, update ? "UpdateExpression" : "UnaryExpression");
    } else if (!sawUnary && this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.privateId) {
        if ((forInit || this.privateNameStack.length === 0) && this.options.checkPrivateFields) this.unexpected();
        expr = this.parsePrivateIdent();
        // only could be private fields in 'in', such as #x in obj
        if (this.type !== $d184995ea4e545a3$export$b54c7ea7aabba5c8._in) this.unexpected();
    } else {
        expr = this.parseExprSubscripts(refDestructuringErrors, forInit);
        if (this.checkExpressionErrors(refDestructuringErrors)) return expr;
        while(this.type.postfix && !this.canInsertSemicolon()){
            var node$1 = this.startNodeAt(startPos, startLoc);
            node$1.operator = this.value;
            node$1.prefix = false;
            node$1.argument = expr;
            this.checkLValSimple(expr);
            this.next();
            expr = this.finishNode(node$1, "UpdateExpression");
        }
    }
    if (!incDec && this.eat($d184995ea4e545a3$export$b54c7ea7aabba5c8.starstar)) {
        if (sawUnary) this.unexpected(this.lastTokStart);
        else return this.buildBinary(startPos, startLoc, expr, this.parseMaybeUnary(null, false, false, forInit), "**", false);
    } else return expr;
};
function $d184995ea4e545a3$var$isLocalVariableAccess(node) {
    return node.type === "Identifier" || node.type === "ParenthesizedExpression" && $d184995ea4e545a3$var$isLocalVariableAccess(node.expression);
}
function $d184995ea4e545a3$var$isPrivateFieldAccess(node) {
    return node.type === "MemberExpression" && node.property.type === "PrivateIdentifier" || node.type === "ChainExpression" && $d184995ea4e545a3$var$isPrivateFieldAccess(node.expression) || node.type === "ParenthesizedExpression" && $d184995ea4e545a3$var$isPrivateFieldAccess(node.expression);
}
// Parse call, dot, and `[]`-subscript expressions.
$d184995ea4e545a3$var$pp$5.parseExprSubscripts = function(refDestructuringErrors, forInit) {
    var startPos = this.start, startLoc = this.startLoc;
    var expr = this.parseExprAtom(refDestructuringErrors, forInit);
    if (expr.type === "ArrowFunctionExpression" && this.input.slice(this.lastTokStart, this.lastTokEnd) !== ")") return expr;
    var result = this.parseSubscripts(expr, startPos, startLoc, false, forInit);
    if (refDestructuringErrors && result.type === "MemberExpression") {
        if (refDestructuringErrors.parenthesizedAssign >= result.start) refDestructuringErrors.parenthesizedAssign = -1;
        if (refDestructuringErrors.parenthesizedBind >= result.start) refDestructuringErrors.parenthesizedBind = -1;
        if (refDestructuringErrors.trailingComma >= result.start) refDestructuringErrors.trailingComma = -1;
    }
    return result;
};
$d184995ea4e545a3$var$pp$5.parseSubscripts = function(base, startPos, startLoc, noCalls, forInit) {
    var maybeAsyncArrow = this.options.ecmaVersion >= 8 && base.type === "Identifier" && base.name === "async" && this.lastTokEnd === base.end && !this.canInsertSemicolon() && base.end - base.start === 5 && this.potentialArrowAt === base.start;
    var optionalChained = false;
    while(true){
        var element = this.parseSubscript(base, startPos, startLoc, noCalls, maybeAsyncArrow, optionalChained, forInit);
        if (element.optional) optionalChained = true;
        if (element === base || element.type === "ArrowFunctionExpression") {
            if (optionalChained) {
                var chainNode = this.startNodeAt(startPos, startLoc);
                chainNode.expression = element;
                element = this.finishNode(chainNode, "ChainExpression");
            }
            return element;
        }
        base = element;
    }
};
$d184995ea4e545a3$var$pp$5.shouldParseAsyncArrow = function() {
    return !this.canInsertSemicolon() && this.eat($d184995ea4e545a3$export$b54c7ea7aabba5c8.arrow);
};
$d184995ea4e545a3$var$pp$5.parseSubscriptAsyncArrow = function(startPos, startLoc, exprList, forInit) {
    return this.parseArrowExpression(this.startNodeAt(startPos, startLoc), exprList, true, forInit);
};
$d184995ea4e545a3$var$pp$5.parseSubscript = function(base, startPos, startLoc, noCalls, maybeAsyncArrow, optionalChained, forInit) {
    var optionalSupported = this.options.ecmaVersion >= 11;
    var optional = optionalSupported && this.eat($d184995ea4e545a3$export$b54c7ea7aabba5c8.questionDot);
    if (noCalls && optional) this.raise(this.lastTokStart, "Optional chaining cannot appear in the callee of new expressions");
    var computed = this.eat($d184995ea4e545a3$export$b54c7ea7aabba5c8.bracketL);
    if (computed || optional && this.type !== $d184995ea4e545a3$export$b54c7ea7aabba5c8.parenL && this.type !== $d184995ea4e545a3$export$b54c7ea7aabba5c8.backQuote || this.eat($d184995ea4e545a3$export$b54c7ea7aabba5c8.dot)) {
        var node = this.startNodeAt(startPos, startLoc);
        node.object = base;
        if (computed) {
            node.property = this.parseExpression();
            this.expect($d184995ea4e545a3$export$b54c7ea7aabba5c8.bracketR);
        } else if (this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.privateId && base.type !== "Super") node.property = this.parsePrivateIdent();
        else node.property = this.parseIdent(this.options.allowReserved !== "never");
        node.computed = !!computed;
        if (optionalSupported) node.optional = optional;
        base = this.finishNode(node, "MemberExpression");
    } else if (!noCalls && this.eat($d184995ea4e545a3$export$b54c7ea7aabba5c8.parenL)) {
        var refDestructuringErrors = new $d184995ea4e545a3$var$DestructuringErrors, oldYieldPos = this.yieldPos, oldAwaitPos = this.awaitPos, oldAwaitIdentPos = this.awaitIdentPos;
        this.yieldPos = 0;
        this.awaitPos = 0;
        this.awaitIdentPos = 0;
        var exprList = this.parseExprList($d184995ea4e545a3$export$b54c7ea7aabba5c8.parenR, this.options.ecmaVersion >= 8, false, refDestructuringErrors);
        if (maybeAsyncArrow && !optional && this.shouldParseAsyncArrow()) {
            this.checkPatternErrors(refDestructuringErrors, false);
            this.checkYieldAwaitInDefaultParams();
            if (this.awaitIdentPos > 0) this.raise(this.awaitIdentPos, "Cannot use 'await' as identifier inside an async function");
            this.yieldPos = oldYieldPos;
            this.awaitPos = oldAwaitPos;
            this.awaitIdentPos = oldAwaitIdentPos;
            return this.parseSubscriptAsyncArrow(startPos, startLoc, exprList, forInit);
        }
        this.checkExpressionErrors(refDestructuringErrors, true);
        this.yieldPos = oldYieldPos || this.yieldPos;
        this.awaitPos = oldAwaitPos || this.awaitPos;
        this.awaitIdentPos = oldAwaitIdentPos || this.awaitIdentPos;
        var node$1 = this.startNodeAt(startPos, startLoc);
        node$1.callee = base;
        node$1.arguments = exprList;
        if (optionalSupported) node$1.optional = optional;
        base = this.finishNode(node$1, "CallExpression");
    } else if (this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.backQuote) {
        if (optional || optionalChained) this.raise(this.start, "Optional chaining cannot appear in the tag of tagged template expressions");
        var node$2 = this.startNodeAt(startPos, startLoc);
        node$2.tag = base;
        node$2.quasi = this.parseTemplate({
            isTagged: true
        });
        base = this.finishNode(node$2, "TaggedTemplateExpression");
    }
    return base;
};
// Parse an atomic expression — either a single token that is an
// expression, an expression started by a keyword like `function` or
// `new`, or an expression wrapped in punctuation like `()`, `[]`,
// or `{}`.
$d184995ea4e545a3$var$pp$5.parseExprAtom = function(refDestructuringErrors, forInit, forNew) {
    // If a division operator appears in an expression position, the
    // tokenizer got confused, and we force it to read a regexp instead.
    if (this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.slash) this.readRegexp();
    var node, canBeArrow = this.potentialArrowAt === this.start;
    switch(this.type){
        case $d184995ea4e545a3$export$b54c7ea7aabba5c8._super:
            if (!this.allowSuper) this.raise(this.start, "'super' keyword outside a method");
            node = this.startNode();
            this.next();
            if (this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.parenL && !this.allowDirectSuper) this.raise(node.start, "super() call outside constructor of a subclass");
            // The `super` keyword can appear at below:
            // SuperProperty:
            //     super [ Expression ]
            //     super . IdentifierName
            // SuperCall:
            //     super ( Arguments )
            if (this.type !== $d184995ea4e545a3$export$b54c7ea7aabba5c8.dot && this.type !== $d184995ea4e545a3$export$b54c7ea7aabba5c8.bracketL && this.type !== $d184995ea4e545a3$export$b54c7ea7aabba5c8.parenL) this.unexpected();
            return this.finishNode(node, "Super");
        case $d184995ea4e545a3$export$b54c7ea7aabba5c8._this:
            node = this.startNode();
            this.next();
            return this.finishNode(node, "ThisExpression");
        case $d184995ea4e545a3$export$b54c7ea7aabba5c8.name:
            var startPos = this.start, startLoc = this.startLoc, containsEsc = this.containsEsc;
            var id = this.parseIdent(false);
            if (this.options.ecmaVersion >= 8 && !containsEsc && id.name === "async" && !this.canInsertSemicolon() && this.eat($d184995ea4e545a3$export$b54c7ea7aabba5c8._function)) {
                this.overrideContext($d184995ea4e545a3$export$2b5f701edfbd6f00.f_expr);
                return this.parseFunction(this.startNodeAt(startPos, startLoc), 0, false, true, forInit);
            }
            if (canBeArrow && !this.canInsertSemicolon()) {
                if (this.eat($d184995ea4e545a3$export$b54c7ea7aabba5c8.arrow)) return this.parseArrowExpression(this.startNodeAt(startPos, startLoc), [
                    id
                ], false, forInit);
                if (this.options.ecmaVersion >= 8 && id.name === "async" && this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.name && !containsEsc && (!this.potentialArrowInForAwait || this.value !== "of" || this.containsEsc)) {
                    id = this.parseIdent(false);
                    if (this.canInsertSemicolon() || !this.eat($d184995ea4e545a3$export$b54c7ea7aabba5c8.arrow)) this.unexpected();
                    return this.parseArrowExpression(this.startNodeAt(startPos, startLoc), [
                        id
                    ], true, forInit);
                }
            }
            return id;
        case $d184995ea4e545a3$export$b54c7ea7aabba5c8.regexp:
            var value = this.value;
            node = this.parseLiteral(value.value);
            node.regex = {
                pattern: value.pattern,
                flags: value.flags
            };
            return node;
        case $d184995ea4e545a3$export$b54c7ea7aabba5c8.num:
        case $d184995ea4e545a3$export$b54c7ea7aabba5c8.string:
            return this.parseLiteral(this.value);
        case $d184995ea4e545a3$export$b54c7ea7aabba5c8._null:
        case $d184995ea4e545a3$export$b54c7ea7aabba5c8._true:
        case $d184995ea4e545a3$export$b54c7ea7aabba5c8._false:
            node = this.startNode();
            node.value = this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8._null ? null : this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8._true;
            node.raw = this.type.keyword;
            this.next();
            return this.finishNode(node, "Literal");
        case $d184995ea4e545a3$export$b54c7ea7aabba5c8.parenL:
            var start = this.start, expr = this.parseParenAndDistinguishExpression(canBeArrow, forInit);
            if (refDestructuringErrors) {
                if (refDestructuringErrors.parenthesizedAssign < 0 && !this.isSimpleAssignTarget(expr)) refDestructuringErrors.parenthesizedAssign = start;
                if (refDestructuringErrors.parenthesizedBind < 0) refDestructuringErrors.parenthesizedBind = start;
            }
            return expr;
        case $d184995ea4e545a3$export$b54c7ea7aabba5c8.bracketL:
            node = this.startNode();
            this.next();
            node.elements = this.parseExprList($d184995ea4e545a3$export$b54c7ea7aabba5c8.bracketR, true, true, refDestructuringErrors);
            return this.finishNode(node, "ArrayExpression");
        case $d184995ea4e545a3$export$b54c7ea7aabba5c8.braceL:
            this.overrideContext($d184995ea4e545a3$export$2b5f701edfbd6f00.b_expr);
            return this.parseObj(false, refDestructuringErrors);
        case $d184995ea4e545a3$export$b54c7ea7aabba5c8._function:
            node = this.startNode();
            this.next();
            return this.parseFunction(node, 0);
        case $d184995ea4e545a3$export$b54c7ea7aabba5c8._class:
            return this.parseClass(this.startNode(), false);
        case $d184995ea4e545a3$export$b54c7ea7aabba5c8._new:
            return this.parseNew();
        case $d184995ea4e545a3$export$b54c7ea7aabba5c8.backQuote:
            return this.parseTemplate();
        case $d184995ea4e545a3$export$b54c7ea7aabba5c8._import:
            if (this.options.ecmaVersion >= 11) return this.parseExprImport(forNew);
            else return this.unexpected();
        default:
            return this.parseExprAtomDefault();
    }
};
$d184995ea4e545a3$var$pp$5.parseExprAtomDefault = function() {
    this.unexpected();
};
$d184995ea4e545a3$var$pp$5.parseExprImport = function(forNew) {
    var node = this.startNode();
    // Consume `import` as an identifier for `import.meta`.
    // Because `this.parseIdent(true)` doesn't check escape sequences, it needs the check of `this.containsEsc`.
    if (this.containsEsc) this.raiseRecoverable(this.start, "Escape sequence in keyword import");
    this.next();
    if (this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.parenL && !forNew) return this.parseDynamicImport(node);
    else if (this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.dot) {
        var meta = this.startNodeAt(node.start, node.loc && node.loc.start);
        meta.name = "import";
        node.meta = this.finishNode(meta, "Identifier");
        return this.parseImportMeta(node);
    } else this.unexpected();
};
$d184995ea4e545a3$var$pp$5.parseDynamicImport = function(node) {
    this.next(); // skip `(`
    // Parse node.source.
    node.source = this.parseMaybeAssign();
    if (this.options.ecmaVersion >= 16) {
        if (!this.eat($d184995ea4e545a3$export$b54c7ea7aabba5c8.parenR)) {
            this.expect($d184995ea4e545a3$export$b54c7ea7aabba5c8.comma);
            if (!this.afterTrailingComma($d184995ea4e545a3$export$b54c7ea7aabba5c8.parenR)) {
                node.options = this.parseMaybeAssign();
                if (!this.eat($d184995ea4e545a3$export$b54c7ea7aabba5c8.parenR)) {
                    this.expect($d184995ea4e545a3$export$b54c7ea7aabba5c8.comma);
                    if (!this.afterTrailingComma($d184995ea4e545a3$export$b54c7ea7aabba5c8.parenR)) this.unexpected();
                }
            } else node.options = null;
        } else node.options = null;
    } else // Verify ending.
    if (!this.eat($d184995ea4e545a3$export$b54c7ea7aabba5c8.parenR)) {
        var errorPos = this.start;
        if (this.eat($d184995ea4e545a3$export$b54c7ea7aabba5c8.comma) && this.eat($d184995ea4e545a3$export$b54c7ea7aabba5c8.parenR)) this.raiseRecoverable(errorPos, "Trailing comma is not allowed in import()");
        else this.unexpected(errorPos);
    }
    return this.finishNode(node, "ImportExpression");
};
$d184995ea4e545a3$var$pp$5.parseImportMeta = function(node) {
    this.next(); // skip `.`
    var containsEsc = this.containsEsc;
    node.property = this.parseIdent(true);
    if (node.property.name !== "meta") this.raiseRecoverable(node.property.start, "The only valid meta property for import is 'import.meta'");
    if (containsEsc) this.raiseRecoverable(node.start, "'import.meta' must not contain escaped characters");
    if (this.options.sourceType !== "module" && !this.options.allowImportExportEverywhere) this.raiseRecoverable(node.start, "Cannot use 'import.meta' outside a module");
    return this.finishNode(node, "MetaProperty");
};
$d184995ea4e545a3$var$pp$5.parseLiteral = function(value) {
    var node = this.startNode();
    node.value = value;
    node.raw = this.input.slice(this.start, this.end);
    if (node.raw.charCodeAt(node.raw.length - 1) === 110) node.bigint = node.value != null ? node.value.toString() : node.raw.slice(0, -1).replace(/_/g, "");
    this.next();
    return this.finishNode(node, "Literal");
};
$d184995ea4e545a3$var$pp$5.parseParenExpression = function() {
    this.expect($d184995ea4e545a3$export$b54c7ea7aabba5c8.parenL);
    var val = this.parseExpression();
    this.expect($d184995ea4e545a3$export$b54c7ea7aabba5c8.parenR);
    return val;
};
$d184995ea4e545a3$var$pp$5.shouldParseArrow = function(exprList) {
    return !this.canInsertSemicolon();
};
$d184995ea4e545a3$var$pp$5.parseParenAndDistinguishExpression = function(canBeArrow, forInit) {
    var startPos = this.start, startLoc = this.startLoc, val, allowTrailingComma = this.options.ecmaVersion >= 8;
    if (this.options.ecmaVersion >= 6) {
        this.next();
        var innerStartPos = this.start, innerStartLoc = this.startLoc;
        var exprList = [], first = true, lastIsComma = false;
        var refDestructuringErrors = new $d184995ea4e545a3$var$DestructuringErrors, oldYieldPos = this.yieldPos, oldAwaitPos = this.awaitPos, spreadStart;
        this.yieldPos = 0;
        this.awaitPos = 0;
        // Do not save awaitIdentPos to allow checking awaits nested in parameters
        while(this.type !== $d184995ea4e545a3$export$b54c7ea7aabba5c8.parenR){
            first ? first = false : this.expect($d184995ea4e545a3$export$b54c7ea7aabba5c8.comma);
            if (allowTrailingComma && this.afterTrailingComma($d184995ea4e545a3$export$b54c7ea7aabba5c8.parenR, true)) {
                lastIsComma = true;
                break;
            } else if (this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.ellipsis) {
                spreadStart = this.start;
                exprList.push(this.parseParenItem(this.parseRestBinding()));
                if (this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.comma) this.raiseRecoverable(this.start, "Comma is not permitted after the rest element");
                break;
            } else exprList.push(this.parseMaybeAssign(false, refDestructuringErrors, this.parseParenItem));
        }
        var innerEndPos = this.lastTokEnd, innerEndLoc = this.lastTokEndLoc;
        this.expect($d184995ea4e545a3$export$b54c7ea7aabba5c8.parenR);
        if (canBeArrow && this.shouldParseArrow(exprList) && this.eat($d184995ea4e545a3$export$b54c7ea7aabba5c8.arrow)) {
            this.checkPatternErrors(refDestructuringErrors, false);
            this.checkYieldAwaitInDefaultParams();
            this.yieldPos = oldYieldPos;
            this.awaitPos = oldAwaitPos;
            return this.parseParenArrowList(startPos, startLoc, exprList, forInit);
        }
        if (!exprList.length || lastIsComma) this.unexpected(this.lastTokStart);
        if (spreadStart) this.unexpected(spreadStart);
        this.checkExpressionErrors(refDestructuringErrors, true);
        this.yieldPos = oldYieldPos || this.yieldPos;
        this.awaitPos = oldAwaitPos || this.awaitPos;
        if (exprList.length > 1) {
            val = this.startNodeAt(innerStartPos, innerStartLoc);
            val.expressions = exprList;
            this.finishNodeAt(val, "SequenceExpression", innerEndPos, innerEndLoc);
        } else val = exprList[0];
    } else val = this.parseParenExpression();
    if (this.options.preserveParens) {
        var par = this.startNodeAt(startPos, startLoc);
        par.expression = val;
        return this.finishNode(par, "ParenthesizedExpression");
    } else return val;
};
$d184995ea4e545a3$var$pp$5.parseParenItem = function(item) {
    return item;
};
$d184995ea4e545a3$var$pp$5.parseParenArrowList = function(startPos, startLoc, exprList, forInit) {
    return this.parseArrowExpression(this.startNodeAt(startPos, startLoc), exprList, false, forInit);
};
// New's precedence is slightly tricky. It must allow its argument to
// be a `[]` or dot subscript expression, but not a call — at least,
// not without wrapping it in parentheses. Thus, it uses the noCalls
// argument to parseSubscripts to prevent it from consuming the
// argument list.
var $d184995ea4e545a3$var$empty = [];
$d184995ea4e545a3$var$pp$5.parseNew = function() {
    if (this.containsEsc) this.raiseRecoverable(this.start, "Escape sequence in keyword new");
    var node = this.startNode();
    this.next();
    if (this.options.ecmaVersion >= 6 && this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.dot) {
        var meta = this.startNodeAt(node.start, node.loc && node.loc.start);
        meta.name = "new";
        node.meta = this.finishNode(meta, "Identifier");
        this.next();
        var containsEsc = this.containsEsc;
        node.property = this.parseIdent(true);
        if (node.property.name !== "target") this.raiseRecoverable(node.property.start, "The only valid meta property for new is 'new.target'");
        if (containsEsc) this.raiseRecoverable(node.start, "'new.target' must not contain escaped characters");
        if (!this.allowNewDotTarget) this.raiseRecoverable(node.start, "'new.target' can only be used in functions and class static block");
        return this.finishNode(node, "MetaProperty");
    }
    var startPos = this.start, startLoc = this.startLoc;
    node.callee = this.parseSubscripts(this.parseExprAtom(null, false, true), startPos, startLoc, true, false);
    if (this.eat($d184995ea4e545a3$export$b54c7ea7aabba5c8.parenL)) node.arguments = this.parseExprList($d184995ea4e545a3$export$b54c7ea7aabba5c8.parenR, this.options.ecmaVersion >= 8, false);
    else node.arguments = $d184995ea4e545a3$var$empty;
    return this.finishNode(node, "NewExpression");
};
// Parse template expression.
$d184995ea4e545a3$var$pp$5.parseTemplateElement = function(ref) {
    var isTagged = ref.isTagged;
    var elem = this.startNode();
    if (this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.invalidTemplate) {
        if (!isTagged) this.raiseRecoverable(this.start, "Bad escape sequence in untagged template literal");
        elem.value = {
            raw: this.value.replace(/\r\n?/g, "\n"),
            cooked: null
        };
    } else elem.value = {
        raw: this.input.slice(this.start, this.end).replace(/\r\n?/g, "\n"),
        cooked: this.value
    };
    this.next();
    elem.tail = this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.backQuote;
    return this.finishNode(elem, "TemplateElement");
};
$d184995ea4e545a3$var$pp$5.parseTemplate = function(ref) {
    if (ref === void 0) ref = {};
    var isTagged = ref.isTagged;
    if (isTagged === void 0) isTagged = false;
    var node = this.startNode();
    this.next();
    node.expressions = [];
    var curElt = this.parseTemplateElement({
        isTagged: isTagged
    });
    node.quasis = [
        curElt
    ];
    while(!curElt.tail){
        if (this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.eof) this.raise(this.pos, "Unterminated template literal");
        this.expect($d184995ea4e545a3$export$b54c7ea7aabba5c8.dollarBraceL);
        node.expressions.push(this.parseExpression());
        this.expect($d184995ea4e545a3$export$b54c7ea7aabba5c8.braceR);
        node.quasis.push(curElt = this.parseTemplateElement({
            isTagged: isTagged
        }));
    }
    this.next();
    return this.finishNode(node, "TemplateLiteral");
};
$d184995ea4e545a3$var$pp$5.isAsyncProp = function(prop) {
    return !prop.computed && prop.key.type === "Identifier" && prop.key.name === "async" && (this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.name || this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.num || this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.string || this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.bracketL || this.type.keyword || this.options.ecmaVersion >= 9 && this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.star) && !$d184995ea4e545a3$export$a1aa2dd4ad0d3f6.test(this.input.slice(this.lastTokEnd, this.start));
};
// Parse an object literal or binding pattern.
$d184995ea4e545a3$var$pp$5.parseObj = function(isPattern, refDestructuringErrors) {
    var node = this.startNode(), first = true, propHash = {};
    node.properties = [];
    this.next();
    while(!this.eat($d184995ea4e545a3$export$b54c7ea7aabba5c8.braceR)){
        if (!first) {
            this.expect($d184995ea4e545a3$export$b54c7ea7aabba5c8.comma);
            if (this.options.ecmaVersion >= 5 && this.afterTrailingComma($d184995ea4e545a3$export$b54c7ea7aabba5c8.braceR)) break;
        } else first = false;
        var prop = this.parseProperty(isPattern, refDestructuringErrors);
        if (!isPattern) this.checkPropClash(prop, propHash, refDestructuringErrors);
        node.properties.push(prop);
    }
    return this.finishNode(node, isPattern ? "ObjectPattern" : "ObjectExpression");
};
$d184995ea4e545a3$var$pp$5.parseProperty = function(isPattern, refDestructuringErrors) {
    var prop = this.startNode(), isGenerator, isAsync, startPos, startLoc;
    if (this.options.ecmaVersion >= 9 && this.eat($d184995ea4e545a3$export$b54c7ea7aabba5c8.ellipsis)) {
        if (isPattern) {
            prop.argument = this.parseIdent(false);
            if (this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.comma) this.raiseRecoverable(this.start, "Comma is not permitted after the rest element");
            return this.finishNode(prop, "RestElement");
        }
        // Parse argument.
        prop.argument = this.parseMaybeAssign(false, refDestructuringErrors);
        // To disallow trailing comma via `this.toAssignable()`.
        if (this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.comma && refDestructuringErrors && refDestructuringErrors.trailingComma < 0) refDestructuringErrors.trailingComma = this.start;
        // Finish
        return this.finishNode(prop, "SpreadElement");
    }
    if (this.options.ecmaVersion >= 6) {
        prop.method = false;
        prop.shorthand = false;
        if (isPattern || refDestructuringErrors) {
            startPos = this.start;
            startLoc = this.startLoc;
        }
        if (!isPattern) isGenerator = this.eat($d184995ea4e545a3$export$b54c7ea7aabba5c8.star);
    }
    var containsEsc = this.containsEsc;
    this.parsePropertyName(prop);
    if (!isPattern && !containsEsc && this.options.ecmaVersion >= 8 && !isGenerator && this.isAsyncProp(prop)) {
        isAsync = true;
        isGenerator = this.options.ecmaVersion >= 9 && this.eat($d184995ea4e545a3$export$b54c7ea7aabba5c8.star);
        this.parsePropertyName(prop);
    } else isAsync = false;
    this.parsePropertyValue(prop, isPattern, isGenerator, isAsync, startPos, startLoc, refDestructuringErrors, containsEsc);
    return this.finishNode(prop, "Property");
};
$d184995ea4e545a3$var$pp$5.parseGetterSetter = function(prop) {
    var kind = prop.key.name;
    this.parsePropertyName(prop);
    prop.value = this.parseMethod(false);
    prop.kind = kind;
    var paramCount = prop.kind === "get" ? 0 : 1;
    if (prop.value.params.length !== paramCount) {
        var start = prop.value.start;
        if (prop.kind === "get") this.raiseRecoverable(start, "getter should have no params");
        else this.raiseRecoverable(start, "setter should have exactly one param");
    } else if (prop.kind === "set" && prop.value.params[0].type === "RestElement") this.raiseRecoverable(prop.value.params[0].start, "Setter cannot use rest params");
};
$d184995ea4e545a3$var$pp$5.parsePropertyValue = function(prop, isPattern, isGenerator, isAsync, startPos, startLoc, refDestructuringErrors, containsEsc) {
    if ((isGenerator || isAsync) && this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.colon) this.unexpected();
    if (this.eat($d184995ea4e545a3$export$b54c7ea7aabba5c8.colon)) {
        prop.value = isPattern ? this.parseMaybeDefault(this.start, this.startLoc) : this.parseMaybeAssign(false, refDestructuringErrors);
        prop.kind = "init";
    } else if (this.options.ecmaVersion >= 6 && this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.parenL) {
        if (isPattern) this.unexpected();
        prop.method = true;
        prop.value = this.parseMethod(isGenerator, isAsync);
        prop.kind = "init";
    } else if (!isPattern && !containsEsc && this.options.ecmaVersion >= 5 && !prop.computed && prop.key.type === "Identifier" && (prop.key.name === "get" || prop.key.name === "set") && this.type !== $d184995ea4e545a3$export$b54c7ea7aabba5c8.comma && this.type !== $d184995ea4e545a3$export$b54c7ea7aabba5c8.braceR && this.type !== $d184995ea4e545a3$export$b54c7ea7aabba5c8.eq) {
        if (isGenerator || isAsync) this.unexpected();
        this.parseGetterSetter(prop);
    } else if (this.options.ecmaVersion >= 6 && !prop.computed && prop.key.type === "Identifier") {
        if (isGenerator || isAsync) this.unexpected();
        this.checkUnreserved(prop.key);
        if (prop.key.name === "await" && !this.awaitIdentPos) this.awaitIdentPos = startPos;
        if (isPattern) prop.value = this.parseMaybeDefault(startPos, startLoc, this.copyNode(prop.key));
        else if (this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.eq && refDestructuringErrors) {
            if (refDestructuringErrors.shorthandAssign < 0) refDestructuringErrors.shorthandAssign = this.start;
            prop.value = this.parseMaybeDefault(startPos, startLoc, this.copyNode(prop.key));
        } else prop.value = this.copyNode(prop.key);
        prop.kind = "init";
        prop.shorthand = true;
    } else this.unexpected();
};
$d184995ea4e545a3$var$pp$5.parsePropertyName = function(prop) {
    if (this.options.ecmaVersion >= 6) {
        if (this.eat($d184995ea4e545a3$export$b54c7ea7aabba5c8.bracketL)) {
            prop.computed = true;
            prop.key = this.parseMaybeAssign();
            this.expect($d184995ea4e545a3$export$b54c7ea7aabba5c8.bracketR);
            return prop.key;
        } else prop.computed = false;
    }
    return prop.key = this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.num || this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.string ? this.parseExprAtom() : this.parseIdent(this.options.allowReserved !== "never");
};
// Initialize empty function node.
$d184995ea4e545a3$var$pp$5.initFunction = function(node) {
    node.id = null;
    if (this.options.ecmaVersion >= 6) node.generator = node.expression = false;
    if (this.options.ecmaVersion >= 8) node.async = false;
};
// Parse object or class method.
$d184995ea4e545a3$var$pp$5.parseMethod = function(isGenerator, isAsync, allowDirectSuper) {
    var node = this.startNode(), oldYieldPos = this.yieldPos, oldAwaitPos = this.awaitPos, oldAwaitIdentPos = this.awaitIdentPos;
    this.initFunction(node);
    if (this.options.ecmaVersion >= 6) node.generator = isGenerator;
    if (this.options.ecmaVersion >= 8) node.async = !!isAsync;
    this.yieldPos = 0;
    this.awaitPos = 0;
    this.awaitIdentPos = 0;
    this.enterScope($d184995ea4e545a3$var$functionFlags(isAsync, node.generator) | $d184995ea4e545a3$var$SCOPE_SUPER | (allowDirectSuper ? $d184995ea4e545a3$var$SCOPE_DIRECT_SUPER : 0));
    this.expect($d184995ea4e545a3$export$b54c7ea7aabba5c8.parenL);
    node.params = this.parseBindingList($d184995ea4e545a3$export$b54c7ea7aabba5c8.parenR, false, this.options.ecmaVersion >= 8);
    this.checkYieldAwaitInDefaultParams();
    this.parseFunctionBody(node, false, true, false);
    this.yieldPos = oldYieldPos;
    this.awaitPos = oldAwaitPos;
    this.awaitIdentPos = oldAwaitIdentPos;
    return this.finishNode(node, "FunctionExpression");
};
// Parse arrow function expression with given parameters.
$d184995ea4e545a3$var$pp$5.parseArrowExpression = function(node, params, isAsync, forInit) {
    var oldYieldPos = this.yieldPos, oldAwaitPos = this.awaitPos, oldAwaitIdentPos = this.awaitIdentPos;
    this.enterScope($d184995ea4e545a3$var$functionFlags(isAsync, false) | $d184995ea4e545a3$var$SCOPE_ARROW);
    this.initFunction(node);
    if (this.options.ecmaVersion >= 8) node.async = !!isAsync;
    this.yieldPos = 0;
    this.awaitPos = 0;
    this.awaitIdentPos = 0;
    node.params = this.toAssignableList(params, true);
    this.parseFunctionBody(node, true, false, forInit);
    this.yieldPos = oldYieldPos;
    this.awaitPos = oldAwaitPos;
    this.awaitIdentPos = oldAwaitIdentPos;
    return this.finishNode(node, "ArrowFunctionExpression");
};
// Parse function body and check parameters.
$d184995ea4e545a3$var$pp$5.parseFunctionBody = function(node, isArrowFunction, isMethod, forInit) {
    var isExpression = isArrowFunction && this.type !== $d184995ea4e545a3$export$b54c7ea7aabba5c8.braceL;
    var oldStrict = this.strict, useStrict = false;
    if (isExpression) {
        node.body = this.parseMaybeAssign(forInit);
        node.expression = true;
        this.checkParams(node, false);
    } else {
        var nonSimple = this.options.ecmaVersion >= 7 && !this.isSimpleParamList(node.params);
        if (!oldStrict || nonSimple) {
            useStrict = this.strictDirective(this.end);
            // If this is a strict mode function, verify that argument names
            // are not repeated, and it does not try to bind the words `eval`
            // or `arguments`.
            if (useStrict && nonSimple) this.raiseRecoverable(node.start, "Illegal 'use strict' directive in function with non-simple parameter list");
        }
        // Start a new scope with regard to labels and the `inFunction`
        // flag (restore them to their old value afterwards).
        var oldLabels = this.labels;
        this.labels = [];
        if (useStrict) this.strict = true;
        // Add the params to varDeclaredNames to ensure that an error is thrown
        // if a let/const declaration in the function clashes with one of the params.
        this.checkParams(node, !oldStrict && !useStrict && !isArrowFunction && !isMethod && this.isSimpleParamList(node.params));
        // Ensure the function name isn't a forbidden identifier in strict mode, e.g. 'eval'
        if (this.strict && node.id) this.checkLValSimple(node.id, $d184995ea4e545a3$var$BIND_OUTSIDE);
        node.body = this.parseBlock(false, undefined, useStrict && !oldStrict);
        node.expression = false;
        this.adaptDirectivePrologue(node.body.body);
        this.labels = oldLabels;
    }
    this.exitScope();
};
$d184995ea4e545a3$var$pp$5.isSimpleParamList = function(params) {
    for(var i = 0, list = params; i < list.length; i += 1){
        var param = list[i];
        if (param.type !== "Identifier") return false;
    }
    return true;
};
// Checks function params for various disallowed patterns such as using "eval"
// or "arguments" and duplicate parameters.
$d184995ea4e545a3$var$pp$5.checkParams = function(node, allowDuplicates) {
    var nameHash = Object.create(null);
    for(var i = 0, list = node.params; i < list.length; i += 1){
        var param = list[i];
        this.checkLValInnerPattern(param, $d184995ea4e545a3$var$BIND_VAR, allowDuplicates ? null : nameHash);
    }
};
// Parses a comma-separated list of expressions, and returns them as
// an array. `close` is the token type that ends the list, and
// `allowEmpty` can be turned on to allow subsequent commas with
// nothing in between them to be parsed as `null` (which is needed
// for array literals).
$d184995ea4e545a3$var$pp$5.parseExprList = function(close, allowTrailingComma, allowEmpty, refDestructuringErrors) {
    var elts = [], first = true;
    while(!this.eat(close)){
        if (!first) {
            this.expect($d184995ea4e545a3$export$b54c7ea7aabba5c8.comma);
            if (allowTrailingComma && this.afterTrailingComma(close)) break;
        } else first = false;
        var elt = void 0;
        if (allowEmpty && this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.comma) elt = null;
        else if (this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.ellipsis) {
            elt = this.parseSpread(refDestructuringErrors);
            if (refDestructuringErrors && this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.comma && refDestructuringErrors.trailingComma < 0) refDestructuringErrors.trailingComma = this.start;
        } else elt = this.parseMaybeAssign(false, refDestructuringErrors);
        elts.push(elt);
    }
    return elts;
};
$d184995ea4e545a3$var$pp$5.checkUnreserved = function(ref) {
    var start = ref.start;
    var end = ref.end;
    var name = ref.name;
    if (this.inGenerator && name === "yield") this.raiseRecoverable(start, "Cannot use 'yield' as identifier inside a generator");
    if (this.inAsync && name === "await") this.raiseRecoverable(start, "Cannot use 'await' as identifier inside an async function");
    if (!(this.currentThisScope().flags & $d184995ea4e545a3$var$SCOPE_VAR) && name === "arguments") this.raiseRecoverable(start, "Cannot use 'arguments' in class field initializer");
    if (this.inClassStaticBlock && (name === "arguments" || name === "await")) this.raise(start, "Cannot use " + name + " in class static initialization block");
    if (this.keywords.test(name)) this.raise(start, "Unexpected keyword '" + name + "'");
    if (this.options.ecmaVersion < 6 && this.input.slice(start, end).indexOf("\\") !== -1) return;
    var re = this.strict ? this.reservedWordsStrict : this.reservedWords;
    if (re.test(name)) {
        if (!this.inAsync && name === "await") this.raiseRecoverable(start, "Cannot use keyword 'await' outside an async function");
        this.raiseRecoverable(start, "The keyword '" + name + "' is reserved");
    }
};
// Parse the next token as an identifier. If `liberal` is true (used
// when parsing properties), it will also convert keywords into
// identifiers.
$d184995ea4e545a3$var$pp$5.parseIdent = function(liberal) {
    var node = this.parseIdentNode();
    this.next(!!liberal);
    this.finishNode(node, "Identifier");
    if (!liberal) {
        this.checkUnreserved(node);
        if (node.name === "await" && !this.awaitIdentPos) this.awaitIdentPos = node.start;
    }
    return node;
};
$d184995ea4e545a3$var$pp$5.parseIdentNode = function() {
    var node = this.startNode();
    if (this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.name) node.name = this.value;
    else if (this.type.keyword) {
        node.name = this.type.keyword;
        // To fix https://github.com/acornjs/acorn/issues/575
        // `class` and `function` keywords push new context into this.context.
        // But there is no chance to pop the context if the keyword is consumed as an identifier such as a property name.
        // If the previous token is a dot, this does not apply because the context-managing code already ignored the keyword
        if ((node.name === "class" || node.name === "function") && (this.lastTokEnd !== this.lastTokStart + 1 || this.input.charCodeAt(this.lastTokStart) !== 46)) this.context.pop();
        this.type = $d184995ea4e545a3$export$b54c7ea7aabba5c8.name;
    } else this.unexpected();
    return node;
};
$d184995ea4e545a3$var$pp$5.parsePrivateIdent = function() {
    var node = this.startNode();
    if (this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.privateId) node.name = this.value;
    else this.unexpected();
    this.next();
    this.finishNode(node, "PrivateIdentifier");
    // For validating existence
    if (this.options.checkPrivateFields) {
        if (this.privateNameStack.length === 0) this.raise(node.start, "Private field '#" + node.name + "' must be declared in an enclosing class");
        else this.privateNameStack[this.privateNameStack.length - 1].used.push(node);
    }
    return node;
};
// Parses yield expression inside generator.
$d184995ea4e545a3$var$pp$5.parseYield = function(forInit) {
    if (!this.yieldPos) this.yieldPos = this.start;
    var node = this.startNode();
    this.next();
    if (this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.semi || this.canInsertSemicolon() || this.type !== $d184995ea4e545a3$export$b54c7ea7aabba5c8.star && !this.type.startsExpr) {
        node.delegate = false;
        node.argument = null;
    } else {
        node.delegate = this.eat($d184995ea4e545a3$export$b54c7ea7aabba5c8.star);
        node.argument = this.parseMaybeAssign(forInit);
    }
    return this.finishNode(node, "YieldExpression");
};
$d184995ea4e545a3$var$pp$5.parseAwait = function(forInit) {
    if (!this.awaitPos) this.awaitPos = this.start;
    var node = this.startNode();
    this.next();
    node.argument = this.parseMaybeUnary(null, true, false, forInit);
    return this.finishNode(node, "AwaitExpression");
};
var $d184995ea4e545a3$var$pp$4 = $d184995ea4e545a3$export$7acfa6ed01010e37.prototype;
// This function is used to raise exceptions on parse errors. It
// takes an offset integer (into the current `input`) to indicate
// the location of the error, attaches the position to the end
// of the error message, and then raises a `SyntaxError` with that
// message.
$d184995ea4e545a3$var$pp$4.raise = function(pos, message) {
    var loc = $d184995ea4e545a3$export$7af82191547c5ff7(this.input, pos);
    message += " (" + loc.line + ":" + loc.column + ")";
    if (this.sourceFile) message += " in " + this.sourceFile;
    var err = new SyntaxError(message);
    err.pos = pos;
    err.loc = loc;
    err.raisedAt = this.pos;
    throw err;
};
$d184995ea4e545a3$var$pp$4.raiseRecoverable = $d184995ea4e545a3$var$pp$4.raise;
$d184995ea4e545a3$var$pp$4.curPosition = function() {
    if (this.options.locations) return new $d184995ea4e545a3$export$13807d9ee5a34a42(this.curLine, this.pos - this.lineStart);
};
var $d184995ea4e545a3$var$pp$3 = $d184995ea4e545a3$export$7acfa6ed01010e37.prototype;
var $d184995ea4e545a3$var$Scope = function Scope(flags) {
    this.flags = flags;
    // A list of var-declared names in the current lexical scope
    this.var = [];
    // A list of lexically-declared names in the current lexical scope
    this.lexical = [];
    // A list of lexically-declared FunctionDeclaration names in the current lexical scope
    this.functions = [];
};
// The functions in this module keep track of declared variables in the current scope in order to detect duplicate variable names.
$d184995ea4e545a3$var$pp$3.enterScope = function(flags) {
    this.scopeStack.push(new $d184995ea4e545a3$var$Scope(flags));
};
$d184995ea4e545a3$var$pp$3.exitScope = function() {
    this.scopeStack.pop();
};
// The spec says:
// > At the top level of a function, or script, function declarations are
// > treated like var declarations rather than like lexical declarations.
$d184995ea4e545a3$var$pp$3.treatFunctionsAsVarInScope = function(scope) {
    return scope.flags & $d184995ea4e545a3$var$SCOPE_FUNCTION || !this.inModule && scope.flags & $d184995ea4e545a3$var$SCOPE_TOP;
};
$d184995ea4e545a3$var$pp$3.declareName = function(name, bindingType, pos) {
    var redeclared = false;
    if (bindingType === $d184995ea4e545a3$var$BIND_LEXICAL) {
        var scope = this.currentScope();
        redeclared = scope.lexical.indexOf(name) > -1 || scope.functions.indexOf(name) > -1 || scope.var.indexOf(name) > -1;
        scope.lexical.push(name);
        if (this.inModule && scope.flags & $d184995ea4e545a3$var$SCOPE_TOP) delete this.undefinedExports[name];
    } else if (bindingType === $d184995ea4e545a3$var$BIND_SIMPLE_CATCH) {
        var scope$1 = this.currentScope();
        scope$1.lexical.push(name);
    } else if (bindingType === $d184995ea4e545a3$var$BIND_FUNCTION) {
        var scope$2 = this.currentScope();
        if (this.treatFunctionsAsVar) redeclared = scope$2.lexical.indexOf(name) > -1;
        else redeclared = scope$2.lexical.indexOf(name) > -1 || scope$2.var.indexOf(name) > -1;
        scope$2.functions.push(name);
    } else for(var i = this.scopeStack.length - 1; i >= 0; --i){
        var scope$3 = this.scopeStack[i];
        if (scope$3.lexical.indexOf(name) > -1 && !(scope$3.flags & $d184995ea4e545a3$var$SCOPE_SIMPLE_CATCH && scope$3.lexical[0] === name) || !this.treatFunctionsAsVarInScope(scope$3) && scope$3.functions.indexOf(name) > -1) {
            redeclared = true;
            break;
        }
        scope$3.var.push(name);
        if (this.inModule && scope$3.flags & $d184995ea4e545a3$var$SCOPE_TOP) delete this.undefinedExports[name];
        if (scope$3.flags & $d184995ea4e545a3$var$SCOPE_VAR) break;
    }
    if (redeclared) this.raiseRecoverable(pos, "Identifier '" + name + "' has already been declared");
};
$d184995ea4e545a3$var$pp$3.checkLocalExport = function(id) {
    // scope.functions must be empty as Module code is always strict.
    if (this.scopeStack[0].lexical.indexOf(id.name) === -1 && this.scopeStack[0].var.indexOf(id.name) === -1) this.undefinedExports[id.name] = id;
};
$d184995ea4e545a3$var$pp$3.currentScope = function() {
    return this.scopeStack[this.scopeStack.length - 1];
};
$d184995ea4e545a3$var$pp$3.currentVarScope = function() {
    for(var i = this.scopeStack.length - 1;; i--){
        var scope = this.scopeStack[i];
        if (scope.flags & ($d184995ea4e545a3$var$SCOPE_VAR | $d184995ea4e545a3$var$SCOPE_CLASS_FIELD_INIT | $d184995ea4e545a3$var$SCOPE_CLASS_STATIC_BLOCK)) return scope;
    }
};
// Could be useful for `this`, `new.target`, `super()`, `super.property`, and `super[property]`.
$d184995ea4e545a3$var$pp$3.currentThisScope = function() {
    for(var i = this.scopeStack.length - 1;; i--){
        var scope = this.scopeStack[i];
        if (scope.flags & ($d184995ea4e545a3$var$SCOPE_VAR | $d184995ea4e545a3$var$SCOPE_CLASS_FIELD_INIT | $d184995ea4e545a3$var$SCOPE_CLASS_STATIC_BLOCK) && !(scope.flags & $d184995ea4e545a3$var$SCOPE_ARROW)) return scope;
    }
};
var $d184995ea4e545a3$export$85c928794f8d04d4 = function Node(parser, pos, loc) {
    this.type = "";
    this.start = pos;
    this.end = 0;
    if (parser.options.locations) this.loc = new $d184995ea4e545a3$export$7387db7caf96fcdb(parser, loc);
    if (parser.options.directSourceFile) this.sourceFile = parser.options.directSourceFile;
    if (parser.options.ranges) this.range = [
        pos,
        0
    ];
};
// Start an AST node, attaching a start offset.
var $d184995ea4e545a3$var$pp$2 = $d184995ea4e545a3$export$7acfa6ed01010e37.prototype;
$d184995ea4e545a3$var$pp$2.startNode = function() {
    return new $d184995ea4e545a3$export$85c928794f8d04d4(this, this.start, this.startLoc);
};
$d184995ea4e545a3$var$pp$2.startNodeAt = function(pos, loc) {
    return new $d184995ea4e545a3$export$85c928794f8d04d4(this, pos, loc);
};
// Finish an AST node, adding `type` and `end` properties.
function $d184995ea4e545a3$var$finishNodeAt(node, type, pos, loc) {
    node.type = type;
    node.end = pos;
    if (this.options.locations) node.loc.end = loc;
    if (this.options.ranges) node.range[1] = pos;
    return node;
}
$d184995ea4e545a3$var$pp$2.finishNode = function(node, type) {
    return $d184995ea4e545a3$var$finishNodeAt.call(this, node, type, this.lastTokEnd, this.lastTokEndLoc);
};
// Finish node at given position
$d184995ea4e545a3$var$pp$2.finishNodeAt = function(node, type, pos, loc) {
    return $d184995ea4e545a3$var$finishNodeAt.call(this, node, type, pos, loc);
};
$d184995ea4e545a3$var$pp$2.copyNode = function(node) {
    var newNode = new $d184995ea4e545a3$export$85c928794f8d04d4(this, node.start, this.startLoc);
    for(var prop in node)newNode[prop] = node[prop];
    return newNode;
};
// This file was generated by "bin/generate-unicode-script-values.js". Do not modify manually!
var $d184995ea4e545a3$var$scriptValuesAddedInUnicode = "Berf Beria_Erfe Gara Garay Gukh Gurung_Khema Hrkt Katakana_Or_Hiragana Kawi Kirat_Rai Krai Nag_Mundari Nagm Ol_Onal Onao Sidetic Sidt Sunu Sunuwar Tai_Yo Tayo Todhri Todr Tolong_Siki Tols Tulu_Tigalari Tutg Unknown Zzzz";
// This file contains Unicode properties extracted from the ECMAScript specification.
// The lists are extracted like so:
// $$('#table-binary-unicode-properties > figure > table > tbody > tr > td:nth-child(1) code').map(el => el.innerText)
// #table-binary-unicode-properties
var $d184995ea4e545a3$var$ecma9BinaryProperties = "ASCII ASCII_Hex_Digit AHex Alphabetic Alpha Any Assigned Bidi_Control Bidi_C Bidi_Mirrored Bidi_M Case_Ignorable CI Cased Changes_When_Casefolded CWCF Changes_When_Casemapped CWCM Changes_When_Lowercased CWL Changes_When_NFKC_Casefolded CWKCF Changes_When_Titlecased CWT Changes_When_Uppercased CWU Dash Default_Ignorable_Code_Point DI Deprecated Dep Diacritic Dia Emoji Emoji_Component Emoji_Modifier Emoji_Modifier_Base Emoji_Presentation Extender Ext Grapheme_Base Gr_Base Grapheme_Extend Gr_Ext Hex_Digit Hex IDS_Binary_Operator IDSB IDS_Trinary_Operator IDST ID_Continue IDC ID_Start IDS Ideographic Ideo Join_Control Join_C Logical_Order_Exception LOE Lowercase Lower Math Noncharacter_Code_Point NChar Pattern_Syntax Pat_Syn Pattern_White_Space Pat_WS Quotation_Mark QMark Radical Regional_Indicator RI Sentence_Terminal STerm Soft_Dotted SD Terminal_Punctuation Term Unified_Ideograph UIdeo Uppercase Upper Variation_Selector VS White_Space space XID_Continue XIDC XID_Start XIDS";
var $d184995ea4e545a3$var$ecma10BinaryProperties = $d184995ea4e545a3$var$ecma9BinaryProperties + " Extended_Pictographic";
var $d184995ea4e545a3$var$ecma11BinaryProperties = $d184995ea4e545a3$var$ecma10BinaryProperties;
var $d184995ea4e545a3$var$ecma12BinaryProperties = $d184995ea4e545a3$var$ecma11BinaryProperties + " EBase EComp EMod EPres ExtPict";
var $d184995ea4e545a3$var$ecma13BinaryProperties = $d184995ea4e545a3$var$ecma12BinaryProperties;
var $d184995ea4e545a3$var$ecma14BinaryProperties = $d184995ea4e545a3$var$ecma13BinaryProperties;
var $d184995ea4e545a3$var$unicodeBinaryProperties = {
    9: $d184995ea4e545a3$var$ecma9BinaryProperties,
    10: $d184995ea4e545a3$var$ecma10BinaryProperties,
    11: $d184995ea4e545a3$var$ecma11BinaryProperties,
    12: $d184995ea4e545a3$var$ecma12BinaryProperties,
    13: $d184995ea4e545a3$var$ecma13BinaryProperties,
    14: $d184995ea4e545a3$var$ecma14BinaryProperties
};
// #table-binary-unicode-properties-of-strings
var $d184995ea4e545a3$var$ecma14BinaryPropertiesOfStrings = "Basic_Emoji Emoji_Keycap_Sequence RGI_Emoji_Modifier_Sequence RGI_Emoji_Flag_Sequence RGI_Emoji_Tag_Sequence RGI_Emoji_ZWJ_Sequence RGI_Emoji";
var $d184995ea4e545a3$var$unicodeBinaryPropertiesOfStrings = {
    9: "",
    10: "",
    11: "",
    12: "",
    13: "",
    14: $d184995ea4e545a3$var$ecma14BinaryPropertiesOfStrings
};
// #table-unicode-general-category-values
var $d184995ea4e545a3$var$unicodeGeneralCategoryValues = "Cased_Letter LC Close_Punctuation Pe Connector_Punctuation Pc Control Cc cntrl Currency_Symbol Sc Dash_Punctuation Pd Decimal_Number Nd digit Enclosing_Mark Me Final_Punctuation Pf Format Cf Initial_Punctuation Pi Letter L Letter_Number Nl Line_Separator Zl Lowercase_Letter Ll Mark M Combining_Mark Math_Symbol Sm Modifier_Letter Lm Modifier_Symbol Sk Nonspacing_Mark Mn Number N Open_Punctuation Ps Other C Other_Letter Lo Other_Number No Other_Punctuation Po Other_Symbol So Paragraph_Separator Zp Private_Use Co Punctuation P punct Separator Z Space_Separator Zs Spacing_Mark Mc Surrogate Cs Symbol S Titlecase_Letter Lt Unassigned Cn Uppercase_Letter Lu";
// #table-unicode-script-values
var $d184995ea4e545a3$var$ecma9ScriptValues = "Adlam Adlm Ahom Anatolian_Hieroglyphs Hluw Arabic Arab Armenian Armn Avestan Avst Balinese Bali Bamum Bamu Bassa_Vah Bass Batak Batk Bengali Beng Bhaiksuki Bhks Bopomofo Bopo Brahmi Brah Braille Brai Buginese Bugi Buhid Buhd Canadian_Aboriginal Cans Carian Cari Caucasian_Albanian Aghb Chakma Cakm Cham Cham Cherokee Cher Common Zyyy Coptic Copt Qaac Cuneiform Xsux Cypriot Cprt Cyrillic Cyrl Deseret Dsrt Devanagari Deva Duployan Dupl Egyptian_Hieroglyphs Egyp Elbasan Elba Ethiopic Ethi Georgian Geor Glagolitic Glag Gothic Goth Grantha Gran Greek Grek Gujarati Gujr Gurmukhi Guru Han Hani Hangul Hang Hanunoo Hano Hatran Hatr Hebrew Hebr Hiragana Hira Imperial_Aramaic Armi Inherited Zinh Qaai Inscriptional_Pahlavi Phli Inscriptional_Parthian Prti Javanese Java Kaithi Kthi Kannada Knda Katakana Kana Kayah_Li Kali Kharoshthi Khar Khmer Khmr Khojki Khoj Khudawadi Sind Lao Laoo Latin Latn Lepcha Lepc Limbu Limb Linear_A Lina Linear_B Linb Lisu Lisu Lycian Lyci Lydian Lydi Mahajani Mahj Malayalam Mlym Mandaic Mand Manichaean Mani Marchen Marc Masaram_Gondi Gonm Meetei_Mayek Mtei Mende_Kikakui Mend Meroitic_Cursive Merc Meroitic_Hieroglyphs Mero Miao Plrd Modi Mongolian Mong Mro Mroo Multani Mult Myanmar Mymr Nabataean Nbat New_Tai_Lue Talu Newa Newa Nko Nkoo Nushu Nshu Ogham Ogam Ol_Chiki Olck Old_Hungarian Hung Old_Italic Ital Old_North_Arabian Narb Old_Permic Perm Old_Persian Xpeo Old_South_Arabian Sarb Old_Turkic Orkh Oriya Orya Osage Osge Osmanya Osma Pahawh_Hmong Hmng Palmyrene Palm Pau_Cin_Hau Pauc Phags_Pa Phag Phoenician Phnx Psalter_Pahlavi Phlp Rejang Rjng Runic Runr Samaritan Samr Saurashtra Saur Sharada Shrd Shavian Shaw Siddham Sidd SignWriting Sgnw Sinhala Sinh Sora_Sompeng Sora Soyombo Soyo Sundanese Sund Syloti_Nagri Sylo Syriac Syrc Tagalog Tglg Tagbanwa Tagb Tai_Le Tale Tai_Tham Lana Tai_Viet Tavt Takri Takr Tamil Taml Tangut Tang Telugu Telu Thaana Thaa Thai Thai Tibetan Tibt Tifinagh Tfng Tirhuta Tirh Ugaritic Ugar Vai Vaii Warang_Citi Wara Yi Yiii Zanabazar_Square Zanb";
var $d184995ea4e545a3$var$ecma10ScriptValues = $d184995ea4e545a3$var$ecma9ScriptValues + " Dogra Dogr Gunjala_Gondi Gong Hanifi_Rohingya Rohg Makasar Maka Medefaidrin Medf Old_Sogdian Sogo Sogdian Sogd";
var $d184995ea4e545a3$var$ecma11ScriptValues = $d184995ea4e545a3$var$ecma10ScriptValues + " Elymaic Elym Nandinagari Nand Nyiakeng_Puachue_Hmong Hmnp Wancho Wcho";
var $d184995ea4e545a3$var$ecma12ScriptValues = $d184995ea4e545a3$var$ecma11ScriptValues + " Chorasmian Chrs Diak Dives_Akuru Khitan_Small_Script Kits Yezi Yezidi";
var $d184995ea4e545a3$var$ecma13ScriptValues = $d184995ea4e545a3$var$ecma12ScriptValues + " Cypro_Minoan Cpmn Old_Uyghur Ougr Tangsa Tnsa Toto Vithkuqi Vith";
var $d184995ea4e545a3$var$ecma14ScriptValues = $d184995ea4e545a3$var$ecma13ScriptValues + " " + $d184995ea4e545a3$var$scriptValuesAddedInUnicode;
var $d184995ea4e545a3$var$unicodeScriptValues = {
    9: $d184995ea4e545a3$var$ecma9ScriptValues,
    10: $d184995ea4e545a3$var$ecma10ScriptValues,
    11: $d184995ea4e545a3$var$ecma11ScriptValues,
    12: $d184995ea4e545a3$var$ecma12ScriptValues,
    13: $d184995ea4e545a3$var$ecma13ScriptValues,
    14: $d184995ea4e545a3$var$ecma14ScriptValues
};
var $d184995ea4e545a3$var$data = {};
function $d184995ea4e545a3$var$buildUnicodeData(ecmaVersion) {
    var d = $d184995ea4e545a3$var$data[ecmaVersion] = {
        binary: $d184995ea4e545a3$var$wordsRegexp($d184995ea4e545a3$var$unicodeBinaryProperties[ecmaVersion] + " " + $d184995ea4e545a3$var$unicodeGeneralCategoryValues),
        binaryOfStrings: $d184995ea4e545a3$var$wordsRegexp($d184995ea4e545a3$var$unicodeBinaryPropertiesOfStrings[ecmaVersion]),
        nonBinary: {
            General_Category: $d184995ea4e545a3$var$wordsRegexp($d184995ea4e545a3$var$unicodeGeneralCategoryValues),
            Script: $d184995ea4e545a3$var$wordsRegexp($d184995ea4e545a3$var$unicodeScriptValues[ecmaVersion])
        }
    };
    d.nonBinary.Script_Extensions = d.nonBinary.Script;
    d.nonBinary.gc = d.nonBinary.General_Category;
    d.nonBinary.sc = d.nonBinary.Script;
    d.nonBinary.scx = d.nonBinary.Script_Extensions;
}
for(var $d184995ea4e545a3$var$i = 0, $d184995ea4e545a3$var$list = [
    9,
    10,
    11,
    12,
    13,
    14
]; $d184995ea4e545a3$var$i < $d184995ea4e545a3$var$list.length; $d184995ea4e545a3$var$i += 1){
    var $d184995ea4e545a3$var$ecmaVersion = $d184995ea4e545a3$var$list[$d184995ea4e545a3$var$i];
    $d184995ea4e545a3$var$buildUnicodeData($d184995ea4e545a3$var$ecmaVersion);
}
var $d184995ea4e545a3$var$pp$1 = $d184995ea4e545a3$export$7acfa6ed01010e37.prototype;
// Track disjunction structure to determine whether a duplicate
// capture group name is allowed because it is in a separate branch.
var $d184995ea4e545a3$var$BranchID = function BranchID(parent, base) {
    // Parent disjunction branch
    this.parent = parent;
    // Identifies this set of sibling branches
    this.base = base || this;
};
$d184995ea4e545a3$var$BranchID.prototype.separatedFrom = function separatedFrom(alt) {
    // A branch is separate from another branch if they or any of
    // their parents are siblings in a given disjunction
    for(var self = this; self; self = self.parent)for(var other = alt; other; other = other.parent){
        if (self.base === other.base && self !== other) return true;
    }
    return false;
};
$d184995ea4e545a3$var$BranchID.prototype.sibling = function sibling() {
    return new $d184995ea4e545a3$var$BranchID(this.parent, this.base);
};
var $d184995ea4e545a3$var$RegExpValidationState = function RegExpValidationState(parser) {
    this.parser = parser;
    this.validFlags = "gim" + (parser.options.ecmaVersion >= 6 ? "uy" : "") + (parser.options.ecmaVersion >= 9 ? "s" : "") + (parser.options.ecmaVersion >= 13 ? "d" : "") + (parser.options.ecmaVersion >= 15 ? "v" : "");
    this.unicodeProperties = $d184995ea4e545a3$var$data[parser.options.ecmaVersion >= 14 ? 14 : parser.options.ecmaVersion];
    this.source = "";
    this.flags = "";
    this.start = 0;
    this.switchU = false;
    this.switchV = false;
    this.switchN = false;
    this.pos = 0;
    this.lastIntValue = 0;
    this.lastStringValue = "";
    this.lastAssertionIsQuantifiable = false;
    this.numCapturingParens = 0;
    this.maxBackReference = 0;
    this.groupNames = Object.create(null);
    this.backReferenceNames = [];
    this.branchID = null;
};
$d184995ea4e545a3$var$RegExpValidationState.prototype.reset = function reset(start, pattern, flags) {
    var unicodeSets = flags.indexOf("v") !== -1;
    var unicode = flags.indexOf("u") !== -1;
    this.start = start | 0;
    this.source = pattern + "";
    this.flags = flags;
    if (unicodeSets && this.parser.options.ecmaVersion >= 15) {
        this.switchU = true;
        this.switchV = true;
        this.switchN = true;
    } else {
        this.switchU = unicode && this.parser.options.ecmaVersion >= 6;
        this.switchV = false;
        this.switchN = unicode && this.parser.options.ecmaVersion >= 9;
    }
};
$d184995ea4e545a3$var$RegExpValidationState.prototype.raise = function raise(message) {
    this.parser.raiseRecoverable(this.start, "Invalid regular expression: /" + this.source + "/: " + message);
};
// If u flag is given, this returns the code point at the index (it combines a surrogate pair).
// Otherwise, this returns the code unit of the index (can be a part of a surrogate pair).
$d184995ea4e545a3$var$RegExpValidationState.prototype.at = function at(i, forceU) {
    if (forceU === void 0) forceU = false;
    var s = this.source;
    var l = s.length;
    if (i >= l) return -1;
    var c = s.charCodeAt(i);
    if (!(forceU || this.switchU) || c <= 0xD7FF || c >= 0xE000 || i + 1 >= l) return c;
    var next = s.charCodeAt(i + 1);
    return next >= 0xDC00 && next <= 0xDFFF ? (c << 10) + next - 0x35FDC00 : c;
};
$d184995ea4e545a3$var$RegExpValidationState.prototype.nextIndex = function nextIndex(i, forceU) {
    if (forceU === void 0) forceU = false;
    var s = this.source;
    var l = s.length;
    if (i >= l) return l;
    var c = s.charCodeAt(i), next;
    if (!(forceU || this.switchU) || c <= 0xD7FF || c >= 0xE000 || i + 1 >= l || (next = s.charCodeAt(i + 1)) < 0xDC00 || next > 0xDFFF) return i + 1;
    return i + 2;
};
$d184995ea4e545a3$var$RegExpValidationState.prototype.current = function current(forceU) {
    if (forceU === void 0) forceU = false;
    return this.at(this.pos, forceU);
};
$d184995ea4e545a3$var$RegExpValidationState.prototype.lookahead = function lookahead(forceU) {
    if (forceU === void 0) forceU = false;
    return this.at(this.nextIndex(this.pos, forceU), forceU);
};
$d184995ea4e545a3$var$RegExpValidationState.prototype.advance = function advance(forceU) {
    if (forceU === void 0) forceU = false;
    this.pos = this.nextIndex(this.pos, forceU);
};
$d184995ea4e545a3$var$RegExpValidationState.prototype.eat = function eat(ch, forceU) {
    if (forceU === void 0) forceU = false;
    if (this.current(forceU) === ch) {
        this.advance(forceU);
        return true;
    }
    return false;
};
$d184995ea4e545a3$var$RegExpValidationState.prototype.eatChars = function eatChars(chs, forceU) {
    if (forceU === void 0) forceU = false;
    var pos = this.pos;
    for(var i = 0, list = chs; i < list.length; i += 1){
        var ch = list[i];
        var current = this.at(pos, forceU);
        if (current === -1 || current !== ch) return false;
        pos = this.nextIndex(pos, forceU);
    }
    this.pos = pos;
    return true;
};
/**
 * Validate the flags part of a given RegExpLiteral.
 *
 * @param {RegExpValidationState} state The state to validate RegExp.
 * @returns {void}
 */ $d184995ea4e545a3$var$pp$1.validateRegExpFlags = function(state) {
    var validFlags = state.validFlags;
    var flags = state.flags;
    var u = false;
    var v = false;
    for(var i = 0; i < flags.length; i++){
        var flag = flags.charAt(i);
        if (validFlags.indexOf(flag) === -1) this.raise(state.start, "Invalid regular expression flag");
        if (flags.indexOf(flag, i + 1) > -1) this.raise(state.start, "Duplicate regular expression flag");
        if (flag === "u") u = true;
        if (flag === "v") v = true;
    }
    if (this.options.ecmaVersion >= 15 && u && v) this.raise(state.start, "Invalid regular expression flag");
};
function $d184995ea4e545a3$var$hasProp(obj) {
    for(var _ in obj)return true;
    return false;
}
/**
 * Validate the pattern part of a given RegExpLiteral.
 *
 * @param {RegExpValidationState} state The state to validate RegExp.
 * @returns {void}
 */ $d184995ea4e545a3$var$pp$1.validateRegExpPattern = function(state) {
    this.regexp_pattern(state);
    // The goal symbol for the parse is |Pattern[~U, ~N]|. If the result of
    // parsing contains a |GroupName|, reparse with the goal symbol
    // |Pattern[~U, +N]| and use this result instead. Throw a *SyntaxError*
    // exception if _P_ did not conform to the grammar, if any elements of _P_
    // were not matched by the parse, or if any Early Error conditions exist.
    if (!state.switchN && this.options.ecmaVersion >= 9 && $d184995ea4e545a3$var$hasProp(state.groupNames)) {
        state.switchN = true;
        this.regexp_pattern(state);
    }
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-Pattern
$d184995ea4e545a3$var$pp$1.regexp_pattern = function(state) {
    state.pos = 0;
    state.lastIntValue = 0;
    state.lastStringValue = "";
    state.lastAssertionIsQuantifiable = false;
    state.numCapturingParens = 0;
    state.maxBackReference = 0;
    state.groupNames = Object.create(null);
    state.backReferenceNames.length = 0;
    state.branchID = null;
    this.regexp_disjunction(state);
    if (state.pos !== state.source.length) {
        // Make the same messages as V8.
        if (state.eat(0x29 /* ) */ )) state.raise("Unmatched ')'");
        if (state.eat(0x5D /* ] */ ) || state.eat(0x7D /* } */ )) state.raise("Lone quantifier brackets");
    }
    if (state.maxBackReference > state.numCapturingParens) state.raise("Invalid escape");
    for(var i = 0, list = state.backReferenceNames; i < list.length; i += 1){
        var name = list[i];
        if (!state.groupNames[name]) state.raise("Invalid named capture referenced");
    }
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-Disjunction
$d184995ea4e545a3$var$pp$1.regexp_disjunction = function(state) {
    var trackDisjunction = this.options.ecmaVersion >= 16;
    if (trackDisjunction) state.branchID = new $d184995ea4e545a3$var$BranchID(state.branchID, null);
    this.regexp_alternative(state);
    while(state.eat(0x7C /* | */ )){
        if (trackDisjunction) state.branchID = state.branchID.sibling();
        this.regexp_alternative(state);
    }
    if (trackDisjunction) state.branchID = state.branchID.parent;
    // Make the same message as V8.
    if (this.regexp_eatQuantifier(state, true)) state.raise("Nothing to repeat");
    if (state.eat(0x7B /* { */ )) state.raise("Lone quantifier brackets");
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-Alternative
$d184995ea4e545a3$var$pp$1.regexp_alternative = function(state) {
    while(state.pos < state.source.length && this.regexp_eatTerm(state));
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-Term
$d184995ea4e545a3$var$pp$1.regexp_eatTerm = function(state) {
    if (this.regexp_eatAssertion(state)) {
        // Handle `QuantifiableAssertion Quantifier` alternative.
        // `state.lastAssertionIsQuantifiable` is true if the last eaten Assertion
        // is a QuantifiableAssertion.
        if (state.lastAssertionIsQuantifiable && this.regexp_eatQuantifier(state)) // Make the same message as V8.
        {
            if (state.switchU) state.raise("Invalid quantifier");
        }
        return true;
    }
    if (state.switchU ? this.regexp_eatAtom(state) : this.regexp_eatExtendedAtom(state)) {
        this.regexp_eatQuantifier(state);
        return true;
    }
    return false;
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-Assertion
$d184995ea4e545a3$var$pp$1.regexp_eatAssertion = function(state) {
    var start = state.pos;
    state.lastAssertionIsQuantifiable = false;
    // ^, $
    if (state.eat(0x5E /* ^ */ ) || state.eat(0x24 /* $ */ )) return true;
    // \b \B
    if (state.eat(0x5C /* \ */ )) {
        if (state.eat(0x42 /* B */ ) || state.eat(0x62 /* b */ )) return true;
        state.pos = start;
    }
    // Lookahead / Lookbehind
    if (state.eat(0x28 /* ( */ ) && state.eat(0x3F /* ? */ )) {
        var lookbehind = false;
        if (this.options.ecmaVersion >= 9) lookbehind = state.eat(0x3C /* < */ );
        if (state.eat(0x3D /* = */ ) || state.eat(0x21 /* ! */ )) {
            this.regexp_disjunction(state);
            if (!state.eat(0x29 /* ) */ )) state.raise("Unterminated group");
            state.lastAssertionIsQuantifiable = !lookbehind;
            return true;
        }
    }
    state.pos = start;
    return false;
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-Quantifier
$d184995ea4e545a3$var$pp$1.regexp_eatQuantifier = function(state, noError) {
    if (noError === void 0) noError = false;
    if (this.regexp_eatQuantifierPrefix(state, noError)) {
        state.eat(0x3F /* ? */ );
        return true;
    }
    return false;
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-QuantifierPrefix
$d184995ea4e545a3$var$pp$1.regexp_eatQuantifierPrefix = function(state, noError) {
    return state.eat(0x2A /* * */ ) || state.eat(0x2B /* + */ ) || state.eat(0x3F /* ? */ ) || this.regexp_eatBracedQuantifier(state, noError);
};
$d184995ea4e545a3$var$pp$1.regexp_eatBracedQuantifier = function(state, noError) {
    var start = state.pos;
    if (state.eat(0x7B /* { */ )) {
        var min = 0, max = -1;
        if (this.regexp_eatDecimalDigits(state)) {
            min = state.lastIntValue;
            if (state.eat(0x2C /* , */ ) && this.regexp_eatDecimalDigits(state)) max = state.lastIntValue;
            if (state.eat(0x7D /* } */ )) {
                // SyntaxError in https://www.ecma-international.org/ecma-262/8.0/#sec-term
                if (max !== -1 && max < min && !noError) state.raise("numbers out of order in {} quantifier");
                return true;
            }
        }
        if (state.switchU && !noError) state.raise("Incomplete quantifier");
        state.pos = start;
    }
    return false;
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-Atom
$d184995ea4e545a3$var$pp$1.regexp_eatAtom = function(state) {
    return this.regexp_eatPatternCharacters(state) || state.eat(0x2E /* . */ ) || this.regexp_eatReverseSolidusAtomEscape(state) || this.regexp_eatCharacterClass(state) || this.regexp_eatUncapturingGroup(state) || this.regexp_eatCapturingGroup(state);
};
$d184995ea4e545a3$var$pp$1.regexp_eatReverseSolidusAtomEscape = function(state) {
    var start = state.pos;
    if (state.eat(0x5C /* \ */ )) {
        if (this.regexp_eatAtomEscape(state)) return true;
        state.pos = start;
    }
    return false;
};
$d184995ea4e545a3$var$pp$1.regexp_eatUncapturingGroup = function(state) {
    var start = state.pos;
    if (state.eat(0x28 /* ( */ )) {
        if (state.eat(0x3F /* ? */ )) {
            if (this.options.ecmaVersion >= 16) {
                var addModifiers = this.regexp_eatModifiers(state);
                var hasHyphen = state.eat(0x2D /* - */ );
                if (addModifiers || hasHyphen) {
                    for(var i = 0; i < addModifiers.length; i++){
                        var modifier = addModifiers.charAt(i);
                        if (addModifiers.indexOf(modifier, i + 1) > -1) state.raise("Duplicate regular expression modifiers");
                    }
                    if (hasHyphen) {
                        var removeModifiers = this.regexp_eatModifiers(state);
                        if (!addModifiers && !removeModifiers && state.current() === 0x3A /* : */ ) state.raise("Invalid regular expression modifiers");
                        for(var i$1 = 0; i$1 < removeModifiers.length; i$1++){
                            var modifier$1 = removeModifiers.charAt(i$1);
                            if (removeModifiers.indexOf(modifier$1, i$1 + 1) > -1 || addModifiers.indexOf(modifier$1) > -1) state.raise("Duplicate regular expression modifiers");
                        }
                    }
                }
            }
            if (state.eat(0x3A /* : */ )) {
                this.regexp_disjunction(state);
                if (state.eat(0x29 /* ) */ )) return true;
                state.raise("Unterminated group");
            }
        }
        state.pos = start;
    }
    return false;
};
$d184995ea4e545a3$var$pp$1.regexp_eatCapturingGroup = function(state) {
    if (state.eat(0x28 /* ( */ )) {
        if (this.options.ecmaVersion >= 9) this.regexp_groupSpecifier(state);
        else if (state.current() === 0x3F /* ? */ ) state.raise("Invalid group");
        this.regexp_disjunction(state);
        if (state.eat(0x29 /* ) */ )) {
            state.numCapturingParens += 1;
            return true;
        }
        state.raise("Unterminated group");
    }
    return false;
};
// RegularExpressionModifiers ::
//   [empty]
//   RegularExpressionModifiers RegularExpressionModifier
$d184995ea4e545a3$var$pp$1.regexp_eatModifiers = function(state) {
    var modifiers = "";
    var ch = 0;
    while((ch = state.current()) !== -1 && $d184995ea4e545a3$var$isRegularExpressionModifier(ch)){
        modifiers += $d184995ea4e545a3$var$codePointToString(ch);
        state.advance();
    }
    return modifiers;
};
// RegularExpressionModifier :: one of
//   `i` `m` `s`
function $d184995ea4e545a3$var$isRegularExpressionModifier(ch) {
    return ch === 0x69 /* i */  || ch === 0x6d /* m */  || ch === 0x73 /* s */ ;
}
// https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-ExtendedAtom
$d184995ea4e545a3$var$pp$1.regexp_eatExtendedAtom = function(state) {
    return state.eat(0x2E /* . */ ) || this.regexp_eatReverseSolidusAtomEscape(state) || this.regexp_eatCharacterClass(state) || this.regexp_eatUncapturingGroup(state) || this.regexp_eatCapturingGroup(state) || this.regexp_eatInvalidBracedQuantifier(state) || this.regexp_eatExtendedPatternCharacter(state);
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-InvalidBracedQuantifier
$d184995ea4e545a3$var$pp$1.regexp_eatInvalidBracedQuantifier = function(state) {
    if (this.regexp_eatBracedQuantifier(state, true)) state.raise("Nothing to repeat");
    return false;
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-SyntaxCharacter
$d184995ea4e545a3$var$pp$1.regexp_eatSyntaxCharacter = function(state) {
    var ch = state.current();
    if ($d184995ea4e545a3$var$isSyntaxCharacter(ch)) {
        state.lastIntValue = ch;
        state.advance();
        return true;
    }
    return false;
};
function $d184995ea4e545a3$var$isSyntaxCharacter(ch) {
    return ch === 0x24 /* $ */  || ch >= 0x28 /* ( */  && ch <= 0x2B /* + */  || ch === 0x2E /* . */  || ch === 0x3F /* ? */  || ch >= 0x5B /* [ */  && ch <= 0x5E /* ^ */  || ch >= 0x7B /* { */  && ch <= 0x7D /* } */ ;
}
// https://www.ecma-international.org/ecma-262/8.0/#prod-PatternCharacter
// But eat eager.
$d184995ea4e545a3$var$pp$1.regexp_eatPatternCharacters = function(state) {
    var start = state.pos;
    var ch = 0;
    while((ch = state.current()) !== -1 && !$d184995ea4e545a3$var$isSyntaxCharacter(ch))state.advance();
    return state.pos !== start;
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-ExtendedPatternCharacter
$d184995ea4e545a3$var$pp$1.regexp_eatExtendedPatternCharacter = function(state) {
    var ch = state.current();
    if (ch !== -1 && ch !== 0x24 /* $ */  && !(ch >= 0x28 /* ( */  && ch <= 0x2B /* + */ ) && ch !== 0x2E /* . */  && ch !== 0x3F /* ? */  && ch !== 0x5B /* [ */  && ch !== 0x5E /* ^ */  && ch !== 0x7C /* | */ ) {
        state.advance();
        return true;
    }
    return false;
};
// GroupSpecifier ::
//   [empty]
//   `?` GroupName
$d184995ea4e545a3$var$pp$1.regexp_groupSpecifier = function(state) {
    if (state.eat(0x3F /* ? */ )) {
        if (!this.regexp_eatGroupName(state)) state.raise("Invalid group");
        var trackDisjunction = this.options.ecmaVersion >= 16;
        var known = state.groupNames[state.lastStringValue];
        if (known) {
            if (trackDisjunction) for(var i = 0, list = known; i < list.length; i += 1){
                var altID = list[i];
                if (!altID.separatedFrom(state.branchID)) state.raise("Duplicate capture group name");
            }
            else state.raise("Duplicate capture group name");
        }
        if (trackDisjunction) (known || (state.groupNames[state.lastStringValue] = [])).push(state.branchID);
        else state.groupNames[state.lastStringValue] = true;
    }
};
// GroupName ::
//   `<` RegExpIdentifierName `>`
// Note: this updates `state.lastStringValue` property with the eaten name.
$d184995ea4e545a3$var$pp$1.regexp_eatGroupName = function(state) {
    state.lastStringValue = "";
    if (state.eat(0x3C /* < */ )) {
        if (this.regexp_eatRegExpIdentifierName(state) && state.eat(0x3E /* > */ )) return true;
        state.raise("Invalid capture group name");
    }
    return false;
};
// RegExpIdentifierName ::
//   RegExpIdentifierStart
//   RegExpIdentifierName RegExpIdentifierPart
// Note: this updates `state.lastStringValue` property with the eaten name.
$d184995ea4e545a3$var$pp$1.regexp_eatRegExpIdentifierName = function(state) {
    state.lastStringValue = "";
    if (this.regexp_eatRegExpIdentifierStart(state)) {
        state.lastStringValue += $d184995ea4e545a3$var$codePointToString(state.lastIntValue);
        while(this.regexp_eatRegExpIdentifierPart(state))state.lastStringValue += $d184995ea4e545a3$var$codePointToString(state.lastIntValue);
        return true;
    }
    return false;
};
// RegExpIdentifierStart ::
//   UnicodeIDStart
//   `$`
//   `_`
//   `\` RegExpUnicodeEscapeSequence[+U]
$d184995ea4e545a3$var$pp$1.regexp_eatRegExpIdentifierStart = function(state) {
    var start = state.pos;
    var forceU = this.options.ecmaVersion >= 11;
    var ch = state.current(forceU);
    state.advance(forceU);
    if (ch === 0x5C /* \ */  && this.regexp_eatRegExpUnicodeEscapeSequence(state, forceU)) ch = state.lastIntValue;
    if ($d184995ea4e545a3$var$isRegExpIdentifierStart(ch)) {
        state.lastIntValue = ch;
        return true;
    }
    state.pos = start;
    return false;
};
function $d184995ea4e545a3$var$isRegExpIdentifierStart(ch) {
    return $d184995ea4e545a3$export$56b48cc5d7560ffb(ch, true) || ch === 0x24 /* $ */  || ch === 0x5F /* _ */ ;
}
// RegExpIdentifierPart ::
//   UnicodeIDContinue
//   `$`
//   `_`
//   `\` RegExpUnicodeEscapeSequence[+U]
//   <ZWNJ>
//   <ZWJ>
$d184995ea4e545a3$var$pp$1.regexp_eatRegExpIdentifierPart = function(state) {
    var start = state.pos;
    var forceU = this.options.ecmaVersion >= 11;
    var ch = state.current(forceU);
    state.advance(forceU);
    if (ch === 0x5C /* \ */  && this.regexp_eatRegExpUnicodeEscapeSequence(state, forceU)) ch = state.lastIntValue;
    if ($d184995ea4e545a3$var$isRegExpIdentifierPart(ch)) {
        state.lastIntValue = ch;
        return true;
    }
    state.pos = start;
    return false;
};
function $d184995ea4e545a3$var$isRegExpIdentifierPart(ch) {
    return $d184995ea4e545a3$export$332f4d7bee38db93(ch, true) || ch === 0x24 /* $ */  || ch === 0x5F /* _ */  || ch === 0x200C /* <ZWNJ> */  || ch === 0x200D /* <ZWJ> */ ;
}
// https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-AtomEscape
$d184995ea4e545a3$var$pp$1.regexp_eatAtomEscape = function(state) {
    if (this.regexp_eatBackReference(state) || this.regexp_eatCharacterClassEscape(state) || this.regexp_eatCharacterEscape(state) || state.switchN && this.regexp_eatKGroupName(state)) return true;
    if (state.switchU) {
        // Make the same message as V8.
        if (state.current() === 0x63 /* c */ ) state.raise("Invalid unicode escape");
        state.raise("Invalid escape");
    }
    return false;
};
$d184995ea4e545a3$var$pp$1.regexp_eatBackReference = function(state) {
    var start = state.pos;
    if (this.regexp_eatDecimalEscape(state)) {
        var n = state.lastIntValue;
        if (state.switchU) {
            // For SyntaxError in https://www.ecma-international.org/ecma-262/8.0/#sec-atomescape
            if (n > state.maxBackReference) state.maxBackReference = n;
            return true;
        }
        if (n <= state.numCapturingParens) return true;
        state.pos = start;
    }
    return false;
};
$d184995ea4e545a3$var$pp$1.regexp_eatKGroupName = function(state) {
    if (state.eat(0x6B /* k */ )) {
        if (this.regexp_eatGroupName(state)) {
            state.backReferenceNames.push(state.lastStringValue);
            return true;
        }
        state.raise("Invalid named reference");
    }
    return false;
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-CharacterEscape
$d184995ea4e545a3$var$pp$1.regexp_eatCharacterEscape = function(state) {
    return this.regexp_eatControlEscape(state) || this.regexp_eatCControlLetter(state) || this.regexp_eatZero(state) || this.regexp_eatHexEscapeSequence(state) || this.regexp_eatRegExpUnicodeEscapeSequence(state, false) || !state.switchU && this.regexp_eatLegacyOctalEscapeSequence(state) || this.regexp_eatIdentityEscape(state);
};
$d184995ea4e545a3$var$pp$1.regexp_eatCControlLetter = function(state) {
    var start = state.pos;
    if (state.eat(0x63 /* c */ )) {
        if (this.regexp_eatControlLetter(state)) return true;
        state.pos = start;
    }
    return false;
};
$d184995ea4e545a3$var$pp$1.regexp_eatZero = function(state) {
    if (state.current() === 0x30 /* 0 */  && !$d184995ea4e545a3$var$isDecimalDigit(state.lookahead())) {
        state.lastIntValue = 0;
        state.advance();
        return true;
    }
    return false;
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-ControlEscape
$d184995ea4e545a3$var$pp$1.regexp_eatControlEscape = function(state) {
    var ch = state.current();
    if (ch === 0x74 /* t */ ) {
        state.lastIntValue = 0x09; /* \t */ 
        state.advance();
        return true;
    }
    if (ch === 0x6E /* n */ ) {
        state.lastIntValue = 0x0A; /* \n */ 
        state.advance();
        return true;
    }
    if (ch === 0x76 /* v */ ) {
        state.lastIntValue = 0x0B; /* \v */ 
        state.advance();
        return true;
    }
    if (ch === 0x66 /* f */ ) {
        state.lastIntValue = 0x0C; /* \f */ 
        state.advance();
        return true;
    }
    if (ch === 0x72 /* r */ ) {
        state.lastIntValue = 0x0D; /* \r */ 
        state.advance();
        return true;
    }
    return false;
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-ControlLetter
$d184995ea4e545a3$var$pp$1.regexp_eatControlLetter = function(state) {
    var ch = state.current();
    if ($d184995ea4e545a3$var$isControlLetter(ch)) {
        state.lastIntValue = ch % 0x20;
        state.advance();
        return true;
    }
    return false;
};
function $d184995ea4e545a3$var$isControlLetter(ch) {
    return ch >= 0x41 /* A */  && ch <= 0x5A /* Z */  || ch >= 0x61 /* a */  && ch <= 0x7A /* z */ ;
}
// https://www.ecma-international.org/ecma-262/8.0/#prod-RegExpUnicodeEscapeSequence
$d184995ea4e545a3$var$pp$1.regexp_eatRegExpUnicodeEscapeSequence = function(state, forceU) {
    if (forceU === void 0) forceU = false;
    var start = state.pos;
    var switchU = forceU || state.switchU;
    if (state.eat(0x75 /* u */ )) {
        if (this.regexp_eatFixedHexDigits(state, 4)) {
            var lead = state.lastIntValue;
            if (switchU && lead >= 0xD800 && lead <= 0xDBFF) {
                var leadSurrogateEnd = state.pos;
                if (state.eat(0x5C /* \ */ ) && state.eat(0x75 /* u */ ) && this.regexp_eatFixedHexDigits(state, 4)) {
                    var trail = state.lastIntValue;
                    if (trail >= 0xDC00 && trail <= 0xDFFF) {
                        state.lastIntValue = (lead - 0xD800) * 0x400 + (trail - 0xDC00) + 0x10000;
                        return true;
                    }
                }
                state.pos = leadSurrogateEnd;
                state.lastIntValue = lead;
            }
            return true;
        }
        if (switchU && state.eat(0x7B /* { */ ) && this.regexp_eatHexDigits(state) && state.eat(0x7D /* } */ ) && $d184995ea4e545a3$var$isValidUnicode(state.lastIntValue)) return true;
        if (switchU) state.raise("Invalid unicode escape");
        state.pos = start;
    }
    return false;
};
function $d184995ea4e545a3$var$isValidUnicode(ch) {
    return ch >= 0 && ch <= 0x10FFFF;
}
// https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-IdentityEscape
$d184995ea4e545a3$var$pp$1.regexp_eatIdentityEscape = function(state) {
    if (state.switchU) {
        if (this.regexp_eatSyntaxCharacter(state)) return true;
        if (state.eat(0x2F /* / */ )) {
            state.lastIntValue = 0x2F; /* / */ 
            return true;
        }
        return false;
    }
    var ch = state.current();
    if (ch !== 0x63 /* c */  && (!state.switchN || ch !== 0x6B /* k */ )) {
        state.lastIntValue = ch;
        state.advance();
        return true;
    }
    return false;
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-DecimalEscape
$d184995ea4e545a3$var$pp$1.regexp_eatDecimalEscape = function(state) {
    state.lastIntValue = 0;
    var ch = state.current();
    if (ch >= 0x31 /* 1 */  && ch <= 0x39 /* 9 */ ) {
        do {
            state.lastIntValue = 10 * state.lastIntValue + (ch - 0x30 /* 0 */ );
            state.advance();
        }while ((ch = state.current()) >= 0x30 /* 0 */  && ch <= 0x39 /* 9 */ );
        return true;
    }
    return false;
};
// Return values used by character set parsing methods, needed to
// forbid negation of sets that can match strings.
var $d184995ea4e545a3$var$CharSetNone = 0; // Nothing parsed
var $d184995ea4e545a3$var$CharSetOk = 1; // Construct parsed, cannot contain strings
var $d184995ea4e545a3$var$CharSetString = 2; // Construct parsed, can contain strings
// https://www.ecma-international.org/ecma-262/8.0/#prod-CharacterClassEscape
$d184995ea4e545a3$var$pp$1.regexp_eatCharacterClassEscape = function(state) {
    var ch = state.current();
    if ($d184995ea4e545a3$var$isCharacterClassEscape(ch)) {
        state.lastIntValue = -1;
        state.advance();
        return $d184995ea4e545a3$var$CharSetOk;
    }
    var negate = false;
    if (state.switchU && this.options.ecmaVersion >= 9 && ((negate = ch === 0x50 /* P */ ) || ch === 0x70 /* p */ )) {
        state.lastIntValue = -1;
        state.advance();
        var result;
        if (state.eat(0x7B /* { */ ) && (result = this.regexp_eatUnicodePropertyValueExpression(state)) && state.eat(0x7D /* } */ )) {
            if (negate && result === $d184995ea4e545a3$var$CharSetString) state.raise("Invalid property name");
            return result;
        }
        state.raise("Invalid property name");
    }
    return $d184995ea4e545a3$var$CharSetNone;
};
function $d184995ea4e545a3$var$isCharacterClassEscape(ch) {
    return ch === 0x64 /* d */  || ch === 0x44 /* D */  || ch === 0x73 /* s */  || ch === 0x53 /* S */  || ch === 0x77 /* w */  || ch === 0x57 /* W */ ;
}
// UnicodePropertyValueExpression ::
//   UnicodePropertyName `=` UnicodePropertyValue
//   LoneUnicodePropertyNameOrValue
$d184995ea4e545a3$var$pp$1.regexp_eatUnicodePropertyValueExpression = function(state) {
    var start = state.pos;
    // UnicodePropertyName `=` UnicodePropertyValue
    if (this.regexp_eatUnicodePropertyName(state) && state.eat(0x3D /* = */ )) {
        var name = state.lastStringValue;
        if (this.regexp_eatUnicodePropertyValue(state)) {
            var value = state.lastStringValue;
            this.regexp_validateUnicodePropertyNameAndValue(state, name, value);
            return $d184995ea4e545a3$var$CharSetOk;
        }
    }
    state.pos = start;
    // LoneUnicodePropertyNameOrValue
    if (this.regexp_eatLoneUnicodePropertyNameOrValue(state)) {
        var nameOrValue = state.lastStringValue;
        return this.regexp_validateUnicodePropertyNameOrValue(state, nameOrValue);
    }
    return $d184995ea4e545a3$var$CharSetNone;
};
$d184995ea4e545a3$var$pp$1.regexp_validateUnicodePropertyNameAndValue = function(state, name, value) {
    if (!$d184995ea4e545a3$var$hasOwn(state.unicodeProperties.nonBinary, name)) state.raise("Invalid property name");
    if (!state.unicodeProperties.nonBinary[name].test(value)) state.raise("Invalid property value");
};
$d184995ea4e545a3$var$pp$1.regexp_validateUnicodePropertyNameOrValue = function(state, nameOrValue) {
    if (state.unicodeProperties.binary.test(nameOrValue)) return $d184995ea4e545a3$var$CharSetOk;
    if (state.switchV && state.unicodeProperties.binaryOfStrings.test(nameOrValue)) return $d184995ea4e545a3$var$CharSetString;
    state.raise("Invalid property name");
};
// UnicodePropertyName ::
//   UnicodePropertyNameCharacters
$d184995ea4e545a3$var$pp$1.regexp_eatUnicodePropertyName = function(state) {
    var ch = 0;
    state.lastStringValue = "";
    while($d184995ea4e545a3$var$isUnicodePropertyNameCharacter(ch = state.current())){
        state.lastStringValue += $d184995ea4e545a3$var$codePointToString(ch);
        state.advance();
    }
    return state.lastStringValue !== "";
};
function $d184995ea4e545a3$var$isUnicodePropertyNameCharacter(ch) {
    return $d184995ea4e545a3$var$isControlLetter(ch) || ch === 0x5F /* _ */ ;
}
// UnicodePropertyValue ::
//   UnicodePropertyValueCharacters
$d184995ea4e545a3$var$pp$1.regexp_eatUnicodePropertyValue = function(state) {
    var ch = 0;
    state.lastStringValue = "";
    while($d184995ea4e545a3$var$isUnicodePropertyValueCharacter(ch = state.current())){
        state.lastStringValue += $d184995ea4e545a3$var$codePointToString(ch);
        state.advance();
    }
    return state.lastStringValue !== "";
};
function $d184995ea4e545a3$var$isUnicodePropertyValueCharacter(ch) {
    return $d184995ea4e545a3$var$isUnicodePropertyNameCharacter(ch) || $d184995ea4e545a3$var$isDecimalDigit(ch);
}
// LoneUnicodePropertyNameOrValue ::
//   UnicodePropertyValueCharacters
$d184995ea4e545a3$var$pp$1.regexp_eatLoneUnicodePropertyNameOrValue = function(state) {
    return this.regexp_eatUnicodePropertyValue(state);
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-CharacterClass
$d184995ea4e545a3$var$pp$1.regexp_eatCharacterClass = function(state) {
    if (state.eat(0x5B /* [ */ )) {
        var negate = state.eat(0x5E /* ^ */ );
        var result = this.regexp_classContents(state);
        if (!state.eat(0x5D /* ] */ )) state.raise("Unterminated character class");
        if (negate && result === $d184995ea4e545a3$var$CharSetString) state.raise("Negated character class may contain strings");
        return true;
    }
    return false;
};
// https://tc39.es/ecma262/#prod-ClassContents
// https://www.ecma-international.org/ecma-262/8.0/#prod-ClassRanges
$d184995ea4e545a3$var$pp$1.regexp_classContents = function(state) {
    if (state.current() === 0x5D /* ] */ ) return $d184995ea4e545a3$var$CharSetOk;
    if (state.switchV) return this.regexp_classSetExpression(state);
    this.regexp_nonEmptyClassRanges(state);
    return $d184995ea4e545a3$var$CharSetOk;
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-NonemptyClassRanges
// https://www.ecma-international.org/ecma-262/8.0/#prod-NonemptyClassRangesNoDash
$d184995ea4e545a3$var$pp$1.regexp_nonEmptyClassRanges = function(state) {
    while(this.regexp_eatClassAtom(state)){
        var left = state.lastIntValue;
        if (state.eat(0x2D /* - */ ) && this.regexp_eatClassAtom(state)) {
            var right = state.lastIntValue;
            if (state.switchU && (left === -1 || right === -1)) state.raise("Invalid character class");
            if (left !== -1 && right !== -1 && left > right) state.raise("Range out of order in character class");
        }
    }
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-ClassAtom
// https://www.ecma-international.org/ecma-262/8.0/#prod-ClassAtomNoDash
$d184995ea4e545a3$var$pp$1.regexp_eatClassAtom = function(state) {
    var start = state.pos;
    if (state.eat(0x5C /* \ */ )) {
        if (this.regexp_eatClassEscape(state)) return true;
        if (state.switchU) {
            // Make the same message as V8.
            var ch$1 = state.current();
            if (ch$1 === 0x63 /* c */  || $d184995ea4e545a3$var$isOctalDigit(ch$1)) state.raise("Invalid class escape");
            state.raise("Invalid escape");
        }
        state.pos = start;
    }
    var ch = state.current();
    if (ch !== 0x5D /* ] */ ) {
        state.lastIntValue = ch;
        state.advance();
        return true;
    }
    return false;
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-ClassEscape
$d184995ea4e545a3$var$pp$1.regexp_eatClassEscape = function(state) {
    var start = state.pos;
    if (state.eat(0x62 /* b */ )) {
        state.lastIntValue = 0x08; /* <BS> */ 
        return true;
    }
    if (state.switchU && state.eat(0x2D /* - */ )) {
        state.lastIntValue = 0x2D; /* - */ 
        return true;
    }
    if (!state.switchU && state.eat(0x63 /* c */ )) {
        if (this.regexp_eatClassControlLetter(state)) return true;
        state.pos = start;
    }
    return this.regexp_eatCharacterClassEscape(state) || this.regexp_eatCharacterEscape(state);
};
// https://tc39.es/ecma262/#prod-ClassSetExpression
// https://tc39.es/ecma262/#prod-ClassUnion
// https://tc39.es/ecma262/#prod-ClassIntersection
// https://tc39.es/ecma262/#prod-ClassSubtraction
$d184995ea4e545a3$var$pp$1.regexp_classSetExpression = function(state) {
    var result = $d184995ea4e545a3$var$CharSetOk, subResult;
    if (this.regexp_eatClassSetRange(state)) ;
    else if (subResult = this.regexp_eatClassSetOperand(state)) {
        if (subResult === $d184995ea4e545a3$var$CharSetString) result = $d184995ea4e545a3$var$CharSetString;
        // https://tc39.es/ecma262/#prod-ClassIntersection
        var start = state.pos;
        while(state.eatChars([
            0x26,
            0x26
        ])){
            if (state.current() !== 0x26 /* & */  && (subResult = this.regexp_eatClassSetOperand(state))) {
                if (subResult !== $d184995ea4e545a3$var$CharSetString) result = $d184995ea4e545a3$var$CharSetOk;
                continue;
            }
            state.raise("Invalid character in character class");
        }
        if (start !== state.pos) return result;
        // https://tc39.es/ecma262/#prod-ClassSubtraction
        while(state.eatChars([
            0x2D,
            0x2D
        ])){
            if (this.regexp_eatClassSetOperand(state)) continue;
            state.raise("Invalid character in character class");
        }
        if (start !== state.pos) return result;
    } else state.raise("Invalid character in character class");
    // https://tc39.es/ecma262/#prod-ClassUnion
    for(;;){
        if (this.regexp_eatClassSetRange(state)) continue;
        subResult = this.regexp_eatClassSetOperand(state);
        if (!subResult) return result;
        if (subResult === $d184995ea4e545a3$var$CharSetString) result = $d184995ea4e545a3$var$CharSetString;
    }
};
// https://tc39.es/ecma262/#prod-ClassSetRange
$d184995ea4e545a3$var$pp$1.regexp_eatClassSetRange = function(state) {
    var start = state.pos;
    if (this.regexp_eatClassSetCharacter(state)) {
        var left = state.lastIntValue;
        if (state.eat(0x2D /* - */ ) && this.regexp_eatClassSetCharacter(state)) {
            var right = state.lastIntValue;
            if (left !== -1 && right !== -1 && left > right) state.raise("Range out of order in character class");
            return true;
        }
        state.pos = start;
    }
    return false;
};
// https://tc39.es/ecma262/#prod-ClassSetOperand
$d184995ea4e545a3$var$pp$1.regexp_eatClassSetOperand = function(state) {
    if (this.regexp_eatClassSetCharacter(state)) return $d184995ea4e545a3$var$CharSetOk;
    return this.regexp_eatClassStringDisjunction(state) || this.regexp_eatNestedClass(state);
};
// https://tc39.es/ecma262/#prod-NestedClass
$d184995ea4e545a3$var$pp$1.regexp_eatNestedClass = function(state) {
    var start = state.pos;
    if (state.eat(0x5B /* [ */ )) {
        var negate = state.eat(0x5E /* ^ */ );
        var result = this.regexp_classContents(state);
        if (state.eat(0x5D /* ] */ )) {
            if (negate && result === $d184995ea4e545a3$var$CharSetString) state.raise("Negated character class may contain strings");
            return result;
        }
        state.pos = start;
    }
    if (state.eat(0x5C /* \ */ )) {
        var result$1 = this.regexp_eatCharacterClassEscape(state);
        if (result$1) return result$1;
        state.pos = start;
    }
    return null;
};
// https://tc39.es/ecma262/#prod-ClassStringDisjunction
$d184995ea4e545a3$var$pp$1.regexp_eatClassStringDisjunction = function(state) {
    var start = state.pos;
    if (state.eatChars([
        0x5C,
        0x71
    ])) {
        if (state.eat(0x7B /* { */ )) {
            var result = this.regexp_classStringDisjunctionContents(state);
            if (state.eat(0x7D /* } */ )) return result;
        } else // Make the same message as V8.
        state.raise("Invalid escape");
        state.pos = start;
    }
    return null;
};
// https://tc39.es/ecma262/#prod-ClassStringDisjunctionContents
$d184995ea4e545a3$var$pp$1.regexp_classStringDisjunctionContents = function(state) {
    var result = this.regexp_classString(state);
    while(state.eat(0x7C /* | */ ))if (this.regexp_classString(state) === $d184995ea4e545a3$var$CharSetString) result = $d184995ea4e545a3$var$CharSetString;
    return result;
};
// https://tc39.es/ecma262/#prod-ClassString
// https://tc39.es/ecma262/#prod-NonEmptyClassString
$d184995ea4e545a3$var$pp$1.regexp_classString = function(state) {
    var count = 0;
    while(this.regexp_eatClassSetCharacter(state))count++;
    return count === 1 ? $d184995ea4e545a3$var$CharSetOk : $d184995ea4e545a3$var$CharSetString;
};
// https://tc39.es/ecma262/#prod-ClassSetCharacter
$d184995ea4e545a3$var$pp$1.regexp_eatClassSetCharacter = function(state) {
    var start = state.pos;
    if (state.eat(0x5C /* \ */ )) {
        if (this.regexp_eatCharacterEscape(state) || this.regexp_eatClassSetReservedPunctuator(state)) return true;
        if (state.eat(0x62 /* b */ )) {
            state.lastIntValue = 0x08; /* <BS> */ 
            return true;
        }
        state.pos = start;
        return false;
    }
    var ch = state.current();
    if (ch < 0 || ch === state.lookahead() && $d184995ea4e545a3$var$isClassSetReservedDoublePunctuatorCharacter(ch)) return false;
    if ($d184995ea4e545a3$var$isClassSetSyntaxCharacter(ch)) return false;
    state.advance();
    state.lastIntValue = ch;
    return true;
};
// https://tc39.es/ecma262/#prod-ClassSetReservedDoublePunctuator
function $d184995ea4e545a3$var$isClassSetReservedDoublePunctuatorCharacter(ch) {
    return ch === 0x21 /* ! */  || ch >= 0x23 /* # */  && ch <= 0x26 /* & */  || ch >= 0x2A /* * */  && ch <= 0x2C /* , */  || ch === 0x2E /* . */  || ch >= 0x3A /* : */  && ch <= 0x40 /* @ */  || ch === 0x5E /* ^ */  || ch === 0x60 /* ` */  || ch === 0x7E /* ~ */ ;
}
// https://tc39.es/ecma262/#prod-ClassSetSyntaxCharacter
function $d184995ea4e545a3$var$isClassSetSyntaxCharacter(ch) {
    return ch === 0x28 /* ( */  || ch === 0x29 /* ) */  || ch === 0x2D /* - */  || ch === 0x2F /* / */  || ch >= 0x5B /* [ */  && ch <= 0x5D /* ] */  || ch >= 0x7B /* { */  && ch <= 0x7D /* } */ ;
}
// https://tc39.es/ecma262/#prod-ClassSetReservedPunctuator
$d184995ea4e545a3$var$pp$1.regexp_eatClassSetReservedPunctuator = function(state) {
    var ch = state.current();
    if ($d184995ea4e545a3$var$isClassSetReservedPunctuator(ch)) {
        state.lastIntValue = ch;
        state.advance();
        return true;
    }
    return false;
};
// https://tc39.es/ecma262/#prod-ClassSetReservedPunctuator
function $d184995ea4e545a3$var$isClassSetReservedPunctuator(ch) {
    return ch === 0x21 /* ! */  || ch === 0x23 /* # */  || ch === 0x25 /* % */  || ch === 0x26 /* & */  || ch === 0x2C /* , */  || ch === 0x2D /* - */  || ch >= 0x3A /* : */  && ch <= 0x3E /* > */  || ch === 0x40 /* @ */  || ch === 0x60 /* ` */  || ch === 0x7E /* ~ */ ;
}
// https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-ClassControlLetter
$d184995ea4e545a3$var$pp$1.regexp_eatClassControlLetter = function(state) {
    var ch = state.current();
    if ($d184995ea4e545a3$var$isDecimalDigit(ch) || ch === 0x5F /* _ */ ) {
        state.lastIntValue = ch % 0x20;
        state.advance();
        return true;
    }
    return false;
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-HexEscapeSequence
$d184995ea4e545a3$var$pp$1.regexp_eatHexEscapeSequence = function(state) {
    var start = state.pos;
    if (state.eat(0x78 /* x */ )) {
        if (this.regexp_eatFixedHexDigits(state, 2)) return true;
        if (state.switchU) state.raise("Invalid escape");
        state.pos = start;
    }
    return false;
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-DecimalDigits
$d184995ea4e545a3$var$pp$1.regexp_eatDecimalDigits = function(state) {
    var start = state.pos;
    var ch = 0;
    state.lastIntValue = 0;
    while($d184995ea4e545a3$var$isDecimalDigit(ch = state.current())){
        state.lastIntValue = 10 * state.lastIntValue + (ch - 0x30 /* 0 */ );
        state.advance();
    }
    return state.pos !== start;
};
function $d184995ea4e545a3$var$isDecimalDigit(ch) {
    return ch >= 0x30 /* 0 */  && ch <= 0x39 /* 9 */ ;
}
// https://www.ecma-international.org/ecma-262/8.0/#prod-HexDigits
$d184995ea4e545a3$var$pp$1.regexp_eatHexDigits = function(state) {
    var start = state.pos;
    var ch = 0;
    state.lastIntValue = 0;
    while($d184995ea4e545a3$var$isHexDigit(ch = state.current())){
        state.lastIntValue = 16 * state.lastIntValue + $d184995ea4e545a3$var$hexToInt(ch);
        state.advance();
    }
    return state.pos !== start;
};
function $d184995ea4e545a3$var$isHexDigit(ch) {
    return ch >= 0x30 /* 0 */  && ch <= 0x39 /* 9 */  || ch >= 0x41 /* A */  && ch <= 0x46 /* F */  || ch >= 0x61 /* a */  && ch <= 0x66 /* f */ ;
}
function $d184995ea4e545a3$var$hexToInt(ch) {
    if (ch >= 0x41 /* A */  && ch <= 0x46 /* F */ ) return 10 + (ch - 0x41 /* A */ );
    if (ch >= 0x61 /* a */  && ch <= 0x66 /* f */ ) return 10 + (ch - 0x61 /* a */ );
    return ch - 0x30 /* 0 */ ;
}
// https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-LegacyOctalEscapeSequence
// Allows only 0-377(octal) i.e. 0-255(decimal).
$d184995ea4e545a3$var$pp$1.regexp_eatLegacyOctalEscapeSequence = function(state) {
    if (this.regexp_eatOctalDigit(state)) {
        var n1 = state.lastIntValue;
        if (this.regexp_eatOctalDigit(state)) {
            var n2 = state.lastIntValue;
            if (n1 <= 3 && this.regexp_eatOctalDigit(state)) state.lastIntValue = n1 * 64 + n2 * 8 + state.lastIntValue;
            else state.lastIntValue = n1 * 8 + n2;
        } else state.lastIntValue = n1;
        return true;
    }
    return false;
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-OctalDigit
$d184995ea4e545a3$var$pp$1.regexp_eatOctalDigit = function(state) {
    var ch = state.current();
    if ($d184995ea4e545a3$var$isOctalDigit(ch)) {
        state.lastIntValue = ch - 0x30; /* 0 */ 
        state.advance();
        return true;
    }
    state.lastIntValue = 0;
    return false;
};
function $d184995ea4e545a3$var$isOctalDigit(ch) {
    return ch >= 0x30 /* 0 */  && ch <= 0x37 /* 7 */ ;
}
// https://www.ecma-international.org/ecma-262/8.0/#prod-Hex4Digits
// https://www.ecma-international.org/ecma-262/8.0/#prod-HexDigit
// And HexDigit HexDigit in https://www.ecma-international.org/ecma-262/8.0/#prod-HexEscapeSequence
$d184995ea4e545a3$var$pp$1.regexp_eatFixedHexDigits = function(state, length) {
    var start = state.pos;
    state.lastIntValue = 0;
    for(var i = 0; i < length; ++i){
        var ch = state.current();
        if (!$d184995ea4e545a3$var$isHexDigit(ch)) {
            state.pos = start;
            return false;
        }
        state.lastIntValue = 16 * state.lastIntValue + $d184995ea4e545a3$var$hexToInt(ch);
        state.advance();
    }
    return true;
};
// Object type used to represent tokens. Note that normally, tokens
// simply exist as properties on the parser object. This is only
// used for the onToken callback and the external tokenizer.
var $d184995ea4e545a3$export$50792b0e93539fde = function Token(p) {
    this.type = p.type;
    this.value = p.value;
    this.start = p.start;
    this.end = p.end;
    if (p.options.locations) this.loc = new $d184995ea4e545a3$export$7387db7caf96fcdb(p, p.startLoc, p.endLoc);
    if (p.options.ranges) this.range = [
        p.start,
        p.end
    ];
};
// ## Tokenizer
var $d184995ea4e545a3$var$pp = $d184995ea4e545a3$export$7acfa6ed01010e37.prototype;
// Move to the next token
$d184995ea4e545a3$var$pp.next = function(ignoreEscapeSequenceInKeyword) {
    if (!ignoreEscapeSequenceInKeyword && this.type.keyword && this.containsEsc) this.raiseRecoverable(this.start, "Escape sequence in keyword " + this.type.keyword);
    if (this.options.onToken) this.options.onToken(new $d184995ea4e545a3$export$50792b0e93539fde(this));
    this.lastTokEnd = this.end;
    this.lastTokStart = this.start;
    this.lastTokEndLoc = this.endLoc;
    this.lastTokStartLoc = this.startLoc;
    this.nextToken();
};
$d184995ea4e545a3$var$pp.getToken = function() {
    this.next();
    return new $d184995ea4e545a3$export$50792b0e93539fde(this);
};
// If we're in an ES6 environment, make parsers iterable
if (typeof Symbol !== "undefined") $d184995ea4e545a3$var$pp[Symbol.iterator] = function() {
    var this$1$1 = this;
    return {
        next: function() {
            var token = this$1$1.getToken();
            return {
                done: token.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.eof,
                value: token
            };
        }
    };
};
// Toggle strict mode. Re-reads the next number or string to please
// pedantic tests (`"use strict"; 010;` should fail).
// Read a single token, updating the parser object's token-related
// properties.
$d184995ea4e545a3$var$pp.nextToken = function() {
    var curContext = this.curContext();
    if (!curContext || !curContext.preserveSpace) this.skipSpace();
    this.start = this.pos;
    if (this.options.locations) this.startLoc = this.curPosition();
    if (this.pos >= this.input.length) return this.finishToken($d184995ea4e545a3$export$b54c7ea7aabba5c8.eof);
    if (curContext.override) return curContext.override(this);
    else this.readToken(this.fullCharCodeAtPos());
};
$d184995ea4e545a3$var$pp.readToken = function(code) {
    // Identifier or keyword. '\uXXXX' sequences are allowed in
    // identifiers, so '\' also dispatches to that.
    if ($d184995ea4e545a3$export$56b48cc5d7560ffb(code, this.options.ecmaVersion >= 6) || code === 92 /* '\' */ ) return this.readWord();
    return this.getTokenFromCode(code);
};
$d184995ea4e545a3$var$pp.fullCharCodeAt = function(pos) {
    var code = this.input.charCodeAt(pos);
    if (code <= 0xd7ff || code >= 0xdc00) return code;
    var next = this.input.charCodeAt(pos + 1);
    return next <= 0xdbff || next >= 0xe000 ? code : (code << 10) + next - 0x35fdc00;
};
$d184995ea4e545a3$var$pp.fullCharCodeAtPos = function() {
    return this.fullCharCodeAt(this.pos);
};
$d184995ea4e545a3$var$pp.skipBlockComment = function() {
    var startLoc = this.options.onComment && this.curPosition();
    var start = this.pos, end = this.input.indexOf("*/", this.pos += 2);
    if (end === -1) this.raise(this.pos - 2, "Unterminated comment");
    this.pos = end + 2;
    if (this.options.locations) for(var nextBreak = void 0, pos = start; (nextBreak = $d184995ea4e545a3$var$nextLineBreak(this.input, pos, this.pos)) > -1;){
        ++this.curLine;
        pos = this.lineStart = nextBreak;
    }
    if (this.options.onComment) this.options.onComment(true, this.input.slice(start + 2, end), start, this.pos, startLoc, this.curPosition());
};
$d184995ea4e545a3$var$pp.skipLineComment = function(startSkip) {
    var start = this.pos;
    var startLoc = this.options.onComment && this.curPosition();
    var ch = this.input.charCodeAt(this.pos += startSkip);
    while(this.pos < this.input.length && !$d184995ea4e545a3$export$2c19a3e3b4008fff(ch))ch = this.input.charCodeAt(++this.pos);
    if (this.options.onComment) this.options.onComment(false, this.input.slice(start + startSkip, this.pos), start, this.pos, startLoc, this.curPosition());
};
// Called at the start of the parse and after every token. Skips
// whitespace and comments, and.
$d184995ea4e545a3$var$pp.skipSpace = function() {
    loop: while(this.pos < this.input.length){
        var ch = this.input.charCodeAt(this.pos);
        switch(ch){
            case 32:
            case 160:
                ++this.pos;
                break;
            case 13:
                if (this.input.charCodeAt(this.pos + 1) === 10) ++this.pos;
            case 10:
            case 8232:
            case 8233:
                ++this.pos;
                if (this.options.locations) {
                    ++this.curLine;
                    this.lineStart = this.pos;
                }
                break;
            case 47:
                switch(this.input.charCodeAt(this.pos + 1)){
                    case 42:
                        this.skipBlockComment();
                        break;
                    case 47:
                        this.skipLineComment(2);
                        break;
                    default:
                        break loop;
                }
                break;
            default:
                if (ch > 8 && ch < 14 || ch >= 5760 && $d184995ea4e545a3$export$268622f0f1cbc82b.test(String.fromCharCode(ch))) ++this.pos;
                else break loop;
        }
    }
};
// Called at the end of every token. Sets `end`, `val`, and
// maintains `context` and `exprAllowed`, and skips the space after
// the token, so that the next one's `start` will point at the
// right position.
$d184995ea4e545a3$var$pp.finishToken = function(type, val) {
    this.end = this.pos;
    if (this.options.locations) this.endLoc = this.curPosition();
    var prevType = this.type;
    this.type = type;
    this.value = val;
    this.updateContext(prevType);
};
// ### Token reading
// This is the function that is called to fetch the next token. It
// is somewhat obscure, because it works in character codes rather
// than characters, and because operator parsing has been inlined
// into it.
//
// All in the name of speed.
//
$d184995ea4e545a3$var$pp.readToken_dot = function() {
    var next = this.input.charCodeAt(this.pos + 1);
    if (next >= 48 && next <= 57) return this.readNumber(true);
    var next2 = this.input.charCodeAt(this.pos + 2);
    if (this.options.ecmaVersion >= 6 && next === 46 && next2 === 46) {
        this.pos += 3;
        return this.finishToken($d184995ea4e545a3$export$b54c7ea7aabba5c8.ellipsis);
    } else {
        ++this.pos;
        return this.finishToken($d184995ea4e545a3$export$b54c7ea7aabba5c8.dot);
    }
};
$d184995ea4e545a3$var$pp.readToken_slash = function() {
    var next = this.input.charCodeAt(this.pos + 1);
    if (this.exprAllowed) {
        ++this.pos;
        return this.readRegexp();
    }
    if (next === 61) return this.finishOp($d184995ea4e545a3$export$b54c7ea7aabba5c8.assign, 2);
    return this.finishOp($d184995ea4e545a3$export$b54c7ea7aabba5c8.slash, 1);
};
$d184995ea4e545a3$var$pp.readToken_mult_modulo_exp = function(code) {
    var next = this.input.charCodeAt(this.pos + 1);
    var size = 1;
    var tokentype = code === 42 ? $d184995ea4e545a3$export$b54c7ea7aabba5c8.star : $d184995ea4e545a3$export$b54c7ea7aabba5c8.modulo;
    // exponentiation operator ** and **=
    if (this.options.ecmaVersion >= 7 && code === 42 && next === 42) {
        ++size;
        tokentype = $d184995ea4e545a3$export$b54c7ea7aabba5c8.starstar;
        next = this.input.charCodeAt(this.pos + 2);
    }
    if (next === 61) return this.finishOp($d184995ea4e545a3$export$b54c7ea7aabba5c8.assign, size + 1);
    return this.finishOp(tokentype, size);
};
$d184995ea4e545a3$var$pp.readToken_pipe_amp = function(code) {
    var next = this.input.charCodeAt(this.pos + 1);
    if (next === code) {
        if (this.options.ecmaVersion >= 12) {
            var next2 = this.input.charCodeAt(this.pos + 2);
            if (next2 === 61) return this.finishOp($d184995ea4e545a3$export$b54c7ea7aabba5c8.assign, 3);
        }
        return this.finishOp(code === 124 ? $d184995ea4e545a3$export$b54c7ea7aabba5c8.logicalOR : $d184995ea4e545a3$export$b54c7ea7aabba5c8.logicalAND, 2);
    }
    if (next === 61) return this.finishOp($d184995ea4e545a3$export$b54c7ea7aabba5c8.assign, 2);
    return this.finishOp(code === 124 ? $d184995ea4e545a3$export$b54c7ea7aabba5c8.bitwiseOR : $d184995ea4e545a3$export$b54c7ea7aabba5c8.bitwiseAND, 1);
};
$d184995ea4e545a3$var$pp.readToken_caret = function() {
    var next = this.input.charCodeAt(this.pos + 1);
    if (next === 61) return this.finishOp($d184995ea4e545a3$export$b54c7ea7aabba5c8.assign, 2);
    return this.finishOp($d184995ea4e545a3$export$b54c7ea7aabba5c8.bitwiseXOR, 1);
};
$d184995ea4e545a3$var$pp.readToken_plus_min = function(code) {
    var next = this.input.charCodeAt(this.pos + 1);
    if (next === code) {
        if (next === 45 && !this.inModule && this.input.charCodeAt(this.pos + 2) === 62 && (this.lastTokEnd === 0 || $d184995ea4e545a3$export$a1aa2dd4ad0d3f6.test(this.input.slice(this.lastTokEnd, this.pos)))) {
            // A `-->` line comment
            this.skipLineComment(3);
            this.skipSpace();
            return this.nextToken();
        }
        return this.finishOp($d184995ea4e545a3$export$b54c7ea7aabba5c8.incDec, 2);
    }
    if (next === 61) return this.finishOp($d184995ea4e545a3$export$b54c7ea7aabba5c8.assign, 2);
    return this.finishOp($d184995ea4e545a3$export$b54c7ea7aabba5c8.plusMin, 1);
};
$d184995ea4e545a3$var$pp.readToken_lt_gt = function(code) {
    var next = this.input.charCodeAt(this.pos + 1);
    var size = 1;
    if (next === code) {
        size = code === 62 && this.input.charCodeAt(this.pos + 2) === 62 ? 3 : 2;
        if (this.input.charCodeAt(this.pos + size) === 61) return this.finishOp($d184995ea4e545a3$export$b54c7ea7aabba5c8.assign, size + 1);
        return this.finishOp($d184995ea4e545a3$export$b54c7ea7aabba5c8.bitShift, size);
    }
    if (next === 33 && code === 60 && !this.inModule && this.input.charCodeAt(this.pos + 2) === 45 && this.input.charCodeAt(this.pos + 3) === 45) {
        // `<!--`, an XML-style comment that should be interpreted as a line comment
        this.skipLineComment(4);
        this.skipSpace();
        return this.nextToken();
    }
    if (next === 61) size = 2;
    return this.finishOp($d184995ea4e545a3$export$b54c7ea7aabba5c8.relational, size);
};
$d184995ea4e545a3$var$pp.readToken_eq_excl = function(code) {
    var next = this.input.charCodeAt(this.pos + 1);
    if (next === 61) return this.finishOp($d184995ea4e545a3$export$b54c7ea7aabba5c8.equality, this.input.charCodeAt(this.pos + 2) === 61 ? 3 : 2);
    if (code === 61 && next === 62 && this.options.ecmaVersion >= 6) {
        this.pos += 2;
        return this.finishToken($d184995ea4e545a3$export$b54c7ea7aabba5c8.arrow);
    }
    return this.finishOp(code === 61 ? $d184995ea4e545a3$export$b54c7ea7aabba5c8.eq : $d184995ea4e545a3$export$b54c7ea7aabba5c8.prefix, 1);
};
$d184995ea4e545a3$var$pp.readToken_question = function() {
    var ecmaVersion = this.options.ecmaVersion;
    if (ecmaVersion >= 11) {
        var next = this.input.charCodeAt(this.pos + 1);
        if (next === 46) {
            var next2 = this.input.charCodeAt(this.pos + 2);
            if (next2 < 48 || next2 > 57) return this.finishOp($d184995ea4e545a3$export$b54c7ea7aabba5c8.questionDot, 2);
        }
        if (next === 63) {
            if (ecmaVersion >= 12) {
                var next2$1 = this.input.charCodeAt(this.pos + 2);
                if (next2$1 === 61) return this.finishOp($d184995ea4e545a3$export$b54c7ea7aabba5c8.assign, 3);
            }
            return this.finishOp($d184995ea4e545a3$export$b54c7ea7aabba5c8.coalesce, 2);
        }
    }
    return this.finishOp($d184995ea4e545a3$export$b54c7ea7aabba5c8.question, 1);
};
$d184995ea4e545a3$var$pp.readToken_numberSign = function() {
    var ecmaVersion = this.options.ecmaVersion;
    var code = 35; // '#'
    if (ecmaVersion >= 13) {
        ++this.pos;
        code = this.fullCharCodeAtPos();
        if ($d184995ea4e545a3$export$56b48cc5d7560ffb(code, true) || code === 92 /* '\' */ ) return this.finishToken($d184995ea4e545a3$export$b54c7ea7aabba5c8.privateId, this.readWord1());
    }
    this.raise(this.pos, "Unexpected character '" + $d184995ea4e545a3$var$codePointToString(code) + "'");
};
$d184995ea4e545a3$var$pp.getTokenFromCode = function(code) {
    switch(code){
        // The interpretation of a dot depends on whether it is followed
        // by a digit or another two dots.
        case 46:
            return this.readToken_dot();
        // Punctuation tokens.
        case 40:
            ++this.pos;
            return this.finishToken($d184995ea4e545a3$export$b54c7ea7aabba5c8.parenL);
        case 41:
            ++this.pos;
            return this.finishToken($d184995ea4e545a3$export$b54c7ea7aabba5c8.parenR);
        case 59:
            ++this.pos;
            return this.finishToken($d184995ea4e545a3$export$b54c7ea7aabba5c8.semi);
        case 44:
            ++this.pos;
            return this.finishToken($d184995ea4e545a3$export$b54c7ea7aabba5c8.comma);
        case 91:
            ++this.pos;
            return this.finishToken($d184995ea4e545a3$export$b54c7ea7aabba5c8.bracketL);
        case 93:
            ++this.pos;
            return this.finishToken($d184995ea4e545a3$export$b54c7ea7aabba5c8.bracketR);
        case 123:
            ++this.pos;
            return this.finishToken($d184995ea4e545a3$export$b54c7ea7aabba5c8.braceL);
        case 125:
            ++this.pos;
            return this.finishToken($d184995ea4e545a3$export$b54c7ea7aabba5c8.braceR);
        case 58:
            ++this.pos;
            return this.finishToken($d184995ea4e545a3$export$b54c7ea7aabba5c8.colon);
        case 96:
            if (this.options.ecmaVersion < 6) break;
            ++this.pos;
            return this.finishToken($d184995ea4e545a3$export$b54c7ea7aabba5c8.backQuote);
        case 48:
            var next = this.input.charCodeAt(this.pos + 1);
            if (next === 120 || next === 88) return this.readRadixNumber(16);
             // '0x', '0X' - hex number
            if (this.options.ecmaVersion >= 6) {
                if (next === 111 || next === 79) return this.readRadixNumber(8);
                 // '0o', '0O' - octal number
                if (next === 98 || next === 66) return this.readRadixNumber(2);
                 // '0b', '0B' - binary number
            }
        // Anything else beginning with a digit is an integer, octal
        // number, or float.
        case 49:
        case 50:
        case 51:
        case 52:
        case 53:
        case 54:
        case 55:
        case 56:
        case 57:
            return this.readNumber(false);
        // Quotes produce strings.
        case 34:
        case 39:
            return this.readString(code);
        // Operators are parsed inline in tiny state machines. '=' (61) is
        // often referred to. `finishOp` simply skips the amount of
        // characters it is given as second argument, and returns a token
        // of the type given by its first argument.
        case 47:
            return this.readToken_slash();
        case 37:
        case 42:
            return this.readToken_mult_modulo_exp(code);
        case 124:
        case 38:
            return this.readToken_pipe_amp(code);
        case 94:
            return this.readToken_caret();
        case 43:
        case 45:
            return this.readToken_plus_min(code);
        case 60:
        case 62:
            return this.readToken_lt_gt(code);
        case 61:
        case 33:
            return this.readToken_eq_excl(code);
        case 63:
            return this.readToken_question();
        case 126:
            return this.finishOp($d184995ea4e545a3$export$b54c7ea7aabba5c8.prefix, 1);
        case 35:
            return this.readToken_numberSign();
    }
    this.raise(this.pos, "Unexpected character '" + $d184995ea4e545a3$var$codePointToString(code) + "'");
};
$d184995ea4e545a3$var$pp.finishOp = function(type, size) {
    var str = this.input.slice(this.pos, this.pos + size);
    this.pos += size;
    return this.finishToken(type, str);
};
$d184995ea4e545a3$var$pp.readRegexp = function() {
    var escaped, inClass, start = this.pos;
    for(;;){
        if (this.pos >= this.input.length) this.raise(start, "Unterminated regular expression");
        var ch = this.input.charAt(this.pos);
        if ($d184995ea4e545a3$export$a1aa2dd4ad0d3f6.test(ch)) this.raise(start, "Unterminated regular expression");
        if (!escaped) {
            if (ch === "[") inClass = true;
            else if (ch === "]" && inClass) inClass = false;
            else if (ch === "/" && !inClass) break;
            escaped = ch === "\\";
        } else escaped = false;
        ++this.pos;
    }
    var pattern = this.input.slice(start, this.pos);
    ++this.pos;
    var flagsStart = this.pos;
    var flags = this.readWord1();
    if (this.containsEsc) this.unexpected(flagsStart);
    // Validate pattern
    var state = this.regexpState || (this.regexpState = new $d184995ea4e545a3$var$RegExpValidationState(this));
    state.reset(start, pattern, flags);
    this.validateRegExpFlags(state);
    this.validateRegExpPattern(state);
    // Create Literal#value property value.
    var value = null;
    try {
        value = new RegExp(pattern, flags);
    } catch (e) {
    // ESTree requires null if it failed to instantiate RegExp object.
    // https://github.com/estree/estree/blob/a27003adf4fd7bfad44de9cef372a2eacd527b1c/es5.md#regexpliteral
    }
    return this.finishToken($d184995ea4e545a3$export$b54c7ea7aabba5c8.regexp, {
        pattern: pattern,
        flags: flags,
        value: value
    });
};
// Read an integer in the given radix. Return null if zero digits
// were read, the integer value otherwise. When `len` is given, this
// will return `null` unless the integer has exactly `len` digits.
$d184995ea4e545a3$var$pp.readInt = function(radix, len, maybeLegacyOctalNumericLiteral) {
    // `len` is used for character escape sequences. In that case, disallow separators.
    var allowSeparators = this.options.ecmaVersion >= 12 && len === undefined;
    // `maybeLegacyOctalNumericLiteral` is true if it doesn't have prefix (0x,0o,0b)
    // and isn't fraction part nor exponent part. In that case, if the first digit
    // is zero then disallow separators.
    var isLegacyOctalNumericLiteral = maybeLegacyOctalNumericLiteral && this.input.charCodeAt(this.pos) === 48;
    var start = this.pos, total = 0, lastCode = 0;
    for(var i = 0, e = len == null ? Infinity : len; i < e; ++i, ++this.pos){
        var code = this.input.charCodeAt(this.pos), val = void 0;
        if (allowSeparators && code === 95) {
            if (isLegacyOctalNumericLiteral) this.raiseRecoverable(this.pos, "Numeric separator is not allowed in legacy octal numeric literals");
            if (lastCode === 95) this.raiseRecoverable(this.pos, "Numeric separator must be exactly one underscore");
            if (i === 0) this.raiseRecoverable(this.pos, "Numeric separator is not allowed at the first of digits");
            lastCode = code;
            continue;
        }
        if (code >= 97) val = code - 97 + 10;
        else if (code >= 65) val = code - 65 + 10;
        else if (code >= 48 && code <= 57) val = code - 48;
        else val = Infinity;
        if (val >= radix) break;
        lastCode = code;
        total = total * radix + val;
    }
    if (allowSeparators && lastCode === 95) this.raiseRecoverable(this.pos - 1, "Numeric separator is not allowed at the last of digits");
    if (this.pos === start || len != null && this.pos - start !== len) return null;
    return total;
};
function $d184995ea4e545a3$var$stringToNumber(str, isLegacyOctalNumericLiteral) {
    if (isLegacyOctalNumericLiteral) return parseInt(str, 8);
    // `parseFloat(value)` stops parsing at the first numeric separator then returns a wrong value.
    return parseFloat(str.replace(/_/g, ""));
}
function $d184995ea4e545a3$var$stringToBigInt(str) {
    if (typeof BigInt !== "function") return null;
    // `BigInt(value)` throws syntax error if the string contains numeric separators.
    return BigInt(str.replace(/_/g, ""));
}
$d184995ea4e545a3$var$pp.readRadixNumber = function(radix) {
    var start = this.pos;
    this.pos += 2; // 0x
    var val = this.readInt(radix);
    if (val == null) this.raise(this.start + 2, "Expected number in radix " + radix);
    if (this.options.ecmaVersion >= 11 && this.input.charCodeAt(this.pos) === 110) {
        val = $d184995ea4e545a3$var$stringToBigInt(this.input.slice(start, this.pos));
        ++this.pos;
    } else if ($d184995ea4e545a3$export$56b48cc5d7560ffb(this.fullCharCodeAtPos())) this.raise(this.pos, "Identifier directly after number");
    return this.finishToken($d184995ea4e545a3$export$b54c7ea7aabba5c8.num, val);
};
// Read an integer, octal integer, or floating-point number.
$d184995ea4e545a3$var$pp.readNumber = function(startsWithDot) {
    var start = this.pos;
    if (!startsWithDot && this.readInt(10, undefined, true) === null) this.raise(start, "Invalid number");
    var octal = this.pos - start >= 2 && this.input.charCodeAt(start) === 48;
    if (octal && this.strict) this.raise(start, "Invalid number");
    var next = this.input.charCodeAt(this.pos);
    if (!octal && !startsWithDot && this.options.ecmaVersion >= 11 && next === 110) {
        var val$1 = $d184995ea4e545a3$var$stringToBigInt(this.input.slice(start, this.pos));
        ++this.pos;
        if ($d184995ea4e545a3$export$56b48cc5d7560ffb(this.fullCharCodeAtPos())) this.raise(this.pos, "Identifier directly after number");
        return this.finishToken($d184995ea4e545a3$export$b54c7ea7aabba5c8.num, val$1);
    }
    if (octal && /[89]/.test(this.input.slice(start, this.pos))) octal = false;
    if (next === 46 && !octal) {
        ++this.pos;
        this.readInt(10);
        next = this.input.charCodeAt(this.pos);
    }
    if ((next === 69 || next === 101) && !octal) {
        next = this.input.charCodeAt(++this.pos);
        if (next === 43 || next === 45) ++this.pos;
         // '+-'
        if (this.readInt(10) === null) this.raise(start, "Invalid number");
    }
    if ($d184995ea4e545a3$export$56b48cc5d7560ffb(this.fullCharCodeAtPos())) this.raise(this.pos, "Identifier directly after number");
    var val = $d184995ea4e545a3$var$stringToNumber(this.input.slice(start, this.pos), octal);
    return this.finishToken($d184995ea4e545a3$export$b54c7ea7aabba5c8.num, val);
};
// Read a string value, interpreting backslash-escapes.
$d184995ea4e545a3$var$pp.readCodePoint = function() {
    var ch = this.input.charCodeAt(this.pos), code;
    if (ch === 123) {
        if (this.options.ecmaVersion < 6) this.unexpected();
        var codePos = ++this.pos;
        code = this.readHexChar(this.input.indexOf("}", this.pos) - this.pos);
        ++this.pos;
        if (code > 0x10FFFF) this.invalidStringToken(codePos, "Code point out of bounds");
    } else code = this.readHexChar(4);
    return code;
};
$d184995ea4e545a3$var$pp.readString = function(quote) {
    var out = "", chunkStart = ++this.pos;
    for(;;){
        if (this.pos >= this.input.length) this.raise(this.start, "Unterminated string constant");
        var ch = this.input.charCodeAt(this.pos);
        if (ch === quote) break;
        if (ch === 92) {
            out += this.input.slice(chunkStart, this.pos);
            out += this.readEscapedChar(false);
            chunkStart = this.pos;
        } else if (ch === 0x2028 || ch === 0x2029) {
            if (this.options.ecmaVersion < 10) this.raise(this.start, "Unterminated string constant");
            ++this.pos;
            if (this.options.locations) {
                this.curLine++;
                this.lineStart = this.pos;
            }
        } else {
            if ($d184995ea4e545a3$export$2c19a3e3b4008fff(ch)) this.raise(this.start, "Unterminated string constant");
            ++this.pos;
        }
    }
    out += this.input.slice(chunkStart, this.pos++);
    return this.finishToken($d184995ea4e545a3$export$b54c7ea7aabba5c8.string, out);
};
// Reads template string tokens.
var $d184995ea4e545a3$var$INVALID_TEMPLATE_ESCAPE_ERROR = {};
$d184995ea4e545a3$var$pp.tryReadTemplateToken = function() {
    this.inTemplateElement = true;
    try {
        this.readTmplToken();
    } catch (err) {
        if (err === $d184995ea4e545a3$var$INVALID_TEMPLATE_ESCAPE_ERROR) this.readInvalidTemplateToken();
        else throw err;
    }
    this.inTemplateElement = false;
};
$d184995ea4e545a3$var$pp.invalidStringToken = function(position, message) {
    if (this.inTemplateElement && this.options.ecmaVersion >= 9) throw $d184995ea4e545a3$var$INVALID_TEMPLATE_ESCAPE_ERROR;
    else this.raise(position, message);
};
$d184995ea4e545a3$var$pp.readTmplToken = function() {
    var out = "", chunkStart = this.pos;
    for(;;){
        if (this.pos >= this.input.length) this.raise(this.start, "Unterminated template");
        var ch = this.input.charCodeAt(this.pos);
        if (ch === 96 || ch === 36 && this.input.charCodeAt(this.pos + 1) === 123) {
            if (this.pos === this.start && (this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.template || this.type === $d184995ea4e545a3$export$b54c7ea7aabba5c8.invalidTemplate)) {
                if (ch === 36) {
                    this.pos += 2;
                    return this.finishToken($d184995ea4e545a3$export$b54c7ea7aabba5c8.dollarBraceL);
                } else {
                    ++this.pos;
                    return this.finishToken($d184995ea4e545a3$export$b54c7ea7aabba5c8.backQuote);
                }
            }
            out += this.input.slice(chunkStart, this.pos);
            return this.finishToken($d184995ea4e545a3$export$b54c7ea7aabba5c8.template, out);
        }
        if (ch === 92) {
            out += this.input.slice(chunkStart, this.pos);
            out += this.readEscapedChar(true);
            chunkStart = this.pos;
        } else if ($d184995ea4e545a3$export$2c19a3e3b4008fff(ch)) {
            out += this.input.slice(chunkStart, this.pos);
            ++this.pos;
            switch(ch){
                case 13:
                    if (this.input.charCodeAt(this.pos) === 10) ++this.pos;
                case 10:
                    out += "\n";
                    break;
                default:
                    out += String.fromCharCode(ch);
                    break;
            }
            if (this.options.locations) {
                ++this.curLine;
                this.lineStart = this.pos;
            }
            chunkStart = this.pos;
        } else ++this.pos;
    }
};
// Reads a template token to search for the end, without validating any escape sequences
$d184995ea4e545a3$var$pp.readInvalidTemplateToken = function() {
    for(; this.pos < this.input.length; this.pos++)switch(this.input[this.pos]){
        case "\\":
            ++this.pos;
            break;
        case "$":
            if (this.input[this.pos + 1] !== "{") break;
        // fall through
        case "`":
            return this.finishToken($d184995ea4e545a3$export$b54c7ea7aabba5c8.invalidTemplate, this.input.slice(this.start, this.pos));
        case "\r":
            if (this.input[this.pos + 1] === "\n") ++this.pos;
        // fall through
        case "\n":
        case "\u2028":
        case "\u2029":
            ++this.curLine;
            this.lineStart = this.pos + 1;
            break;
    }
    this.raise(this.start, "Unterminated template");
};
// Used to read escaped characters
$d184995ea4e545a3$var$pp.readEscapedChar = function(inTemplate) {
    var ch = this.input.charCodeAt(++this.pos);
    ++this.pos;
    switch(ch){
        case 110:
            return "\n" // 'n' -> '\n'
            ;
        case 114:
            return "\r" // 'r' -> '\r'
            ;
        case 120:
            return String.fromCharCode(this.readHexChar(2)) // 'x'
            ;
        case 117:
            return $d184995ea4e545a3$var$codePointToString(this.readCodePoint()) // 'u'
            ;
        case 116:
            return "\t" // 't' -> '\t'
            ;
        case 98:
            return "\b" // 'b' -> '\b'
            ;
        case 118:
            return "\u000b" // 'v' -> '\u000b'
            ;
        case 102:
            return "\f" // 'f' -> '\f'
            ;
        case 13:
            if (this.input.charCodeAt(this.pos) === 10) ++this.pos;
             // '\r\n'
        case 10:
            if (this.options.locations) {
                this.lineStart = this.pos;
                ++this.curLine;
            }
            return "";
        case 56:
        case 57:
            if (this.strict) this.invalidStringToken(this.pos - 1, "Invalid escape sequence");
            if (inTemplate) {
                var codePos = this.pos - 1;
                this.invalidStringToken(codePos, "Invalid escape sequence in template string");
            }
        default:
            if (ch >= 48 && ch <= 55) {
                var octalStr = this.input.substr(this.pos - 1, 3).match(/^[0-7]+/)[0];
                var octal = parseInt(octalStr, 8);
                if (octal > 255) {
                    octalStr = octalStr.slice(0, -1);
                    octal = parseInt(octalStr, 8);
                }
                this.pos += octalStr.length - 1;
                ch = this.input.charCodeAt(this.pos);
                if ((octalStr !== "0" || ch === 56 || ch === 57) && (this.strict || inTemplate)) this.invalidStringToken(this.pos - 1 - octalStr.length, inTemplate ? "Octal literal in template string" : "Octal literal in strict mode");
                return String.fromCharCode(octal);
            }
            if ($d184995ea4e545a3$export$2c19a3e3b4008fff(ch)) {
                // Unicode new line characters after \ get removed from output in both
                // template literals and strings
                if (this.options.locations) {
                    this.lineStart = this.pos;
                    ++this.curLine;
                }
                return "";
            }
            return String.fromCharCode(ch);
    }
};
// Used to read character escape sequences ('\x', '\u', '\U').
$d184995ea4e545a3$var$pp.readHexChar = function(len) {
    var codePos = this.pos;
    var n = this.readInt(16, len);
    if (n === null) this.invalidStringToken(codePos, "Bad character escape sequence");
    return n;
};
// Read an identifier, and return it as a string. Sets `this.containsEsc`
// to whether the word contained a '\u' escape.
//
// Incrementally adds only escaped chars, adding other chunks as-is
// as a micro-optimization.
$d184995ea4e545a3$var$pp.readWord1 = function() {
    this.containsEsc = false;
    var word = "", first = true, chunkStart = this.pos;
    var astral = this.options.ecmaVersion >= 6;
    while(this.pos < this.input.length){
        var ch = this.fullCharCodeAtPos();
        if ($d184995ea4e545a3$export$332f4d7bee38db93(ch, astral)) this.pos += ch <= 0xffff ? 1 : 2;
        else if (ch === 92) {
            this.containsEsc = true;
            word += this.input.slice(chunkStart, this.pos);
            var escStart = this.pos;
            if (this.input.charCodeAt(++this.pos) !== 117) this.invalidStringToken(this.pos, "Expecting Unicode escape sequence \\uXXXX");
            ++this.pos;
            var esc = this.readCodePoint();
            if (!(first ? $d184995ea4e545a3$export$56b48cc5d7560ffb : $d184995ea4e545a3$export$332f4d7bee38db93)(esc, astral)) this.invalidStringToken(escStart, "Invalid Unicode escape");
            word += $d184995ea4e545a3$var$codePointToString(esc);
            chunkStart = this.pos;
        } else break;
        first = false;
    }
    return word + this.input.slice(chunkStart, this.pos);
};
// Read an identifier or keyword token. Will check for reserved
// words when necessary.
$d184995ea4e545a3$var$pp.readWord = function() {
    var word = this.readWord1();
    var type = $d184995ea4e545a3$export$b54c7ea7aabba5c8.name;
    if (this.keywords.test(word)) type = $d184995ea4e545a3$export$d53f8326294b31d8[word];
    return this.finishToken(type, word);
};
// Acorn is a tiny, fast JavaScript parser written in JavaScript.
//
// Acorn was written by Marijn Haverbeke, Ingvar Stepanyan, and
// various contributors and released under an MIT license.
//
// Git repositories for Acorn are available at
//
//     http://marijnhaverbeke.nl/git/acorn
//     https://github.com/acornjs/acorn.git
//
// Please use the [github bug tracker][ghbt] to report issues.
//
// [ghbt]: https://github.com/acornjs/acorn/issues
var $d184995ea4e545a3$export$83d89fbfd8236492 = "8.16.0";
$d184995ea4e545a3$export$7acfa6ed01010e37.acorn = {
    Parser: $d184995ea4e545a3$export$7acfa6ed01010e37,
    version: $d184995ea4e545a3$export$83d89fbfd8236492,
    defaultOptions: $d184995ea4e545a3$export$ba43bf67f3d48107,
    Position: $d184995ea4e545a3$export$13807d9ee5a34a42,
    SourceLocation: $d184995ea4e545a3$export$7387db7caf96fcdb,
    getLineInfo: $d184995ea4e545a3$export$7af82191547c5ff7,
    Node: $d184995ea4e545a3$export$85c928794f8d04d4,
    TokenType: $d184995ea4e545a3$export$f435f793048e7a0f,
    tokTypes: $d184995ea4e545a3$export$b54c7ea7aabba5c8,
    keywordTypes: $d184995ea4e545a3$export$d53f8326294b31d8,
    TokContext: $d184995ea4e545a3$export$68e7b4c4d99215d9,
    tokContexts: $d184995ea4e545a3$export$2b5f701edfbd6f00,
    isIdentifierChar: $d184995ea4e545a3$export$332f4d7bee38db93,
    isIdentifierStart: $d184995ea4e545a3$export$56b48cc5d7560ffb,
    Token: $d184995ea4e545a3$export$50792b0e93539fde,
    isNewLine: $d184995ea4e545a3$export$2c19a3e3b4008fff,
    lineBreak: $d184995ea4e545a3$export$a1aa2dd4ad0d3f6,
    lineBreakG: $d184995ea4e545a3$export$866e20207bbc41f2,
    nonASCIIwhitespace: $d184995ea4e545a3$export$268622f0f1cbc82b
};
// The main exported interface (under `self.acorn` when in the
// browser) is a `parse` function that takes a code string and returns
// an abstract syntax tree as specified by the [ESTree spec][estree].
//
// [estree]: https://github.com/estree/estree
function $d184995ea4e545a3$export$98e6a39c04603d36(input, options) {
    return $d184995ea4e545a3$export$7acfa6ed01010e37.parse(input, options);
}
// This function tries to parse a single expression at a given
// offset in a string. Useful for parsing mixed-language formats
// that embed JavaScript expressions.
function $d184995ea4e545a3$export$61f24eb03dd7ce92(input, pos, options) {
    return $d184995ea4e545a3$export$7acfa6ed01010e37.parseExpressionAt(input, pos, options);
}
// Acorn is organized as a tokenizer and a recursive-descent parser.
// The `tokenizer` export provides an interface to the tokenizer.
function $d184995ea4e545a3$export$5f8c09e3ae6f64e1(input, options) {
    return $d184995ea4e545a3$export$7acfa6ed01010e37.tokenizer(input, options);
}

});


parcelRegister("4VmEZ", function(module, exports) {

$parcel$export(module.exports, "getActiveBranch", () => $395e1025e0f09c9d$export$d9080b502819d98b);
$parcel$export(module.exports, "getActiveVersion", () => $395e1025e0f09c9d$export$683d510f1dd3e474);
$parcel$export(module.exports, "getLatestVersion", () => $395e1025e0f09c9d$export$892e128ba377ffbb);
$parcel$export(module.exports, "setActiveBranch", () => $395e1025e0f09c9d$export$4e5bad2272a13d5);
$parcel$export(module.exports, "setActiveVersion", () => $395e1025e0f09c9d$export$b0dd6a74f9517c68);
$parcel$export(module.exports, "getActiveProjectName", () => $395e1025e0f09c9d$export$ee497b3c885b8e5e);
$parcel$export(module.exports, "getRootProjects", () => $395e1025e0f09c9d$export$3d5e1f66ff556ecb);
$parcel$export(module.exports, "getRootProjectsUsers", () => $395e1025e0f09c9d$export$67fbc4483c75d073);
$parcel$export(module.exports, "getRootProjectId", () => $395e1025e0f09c9d$export$f030a28031d9be25);
$parcel$export(module.exports, "switchProject", () => $395e1025e0f09c9d$export$aa6a184b5d48d926);
$parcel$export(module.exports, "switchProjectByKey", () => $395e1025e0f09c9d$export$8a8b34fc133941fe);
function $395e1025e0f09c9d$export$d9080b502819d98b() {
    return this.getRootState('branch') || 'main';
}
function $395e1025e0f09c9d$export$683d510f1dd3e474() {
    return this.getRootState('version');
}
function $395e1025e0f09c9d$export$892e128ba377ffbb() {
    return this.getRootState('latestVersion');
}
async function $395e1025e0f09c9d$export$4e5bad2272a13d5(branch = 'main') {
    if (branch === 'new-branch') return await this.call('openModal', '/add-branch');
    const rootState = this.getRootState();
    const previousBranch = rootState.branch;
    const previousVersion = rootState.version;
    rootState.quietUpdate({
        loading: true,
        branch: branch,
        version: null
    });
    window.requestAnimationFrame(async ()=>{
        try {
            // const data = await this.sdk.switchBranch(branch)
            const data = await this.sdk.getProjectData(this.getRootState().projectId, {
                branch: branch
            });
            // Validate data before syncing
            if (!data || Object.keys(data).length === 0) throw new Error('Received empty data from branch switch');
            this.call('sync', data, (synced)=>{
                if (!synced) {
                    // Sync failed, restore previous state
                    rootState.update({
                        loading: false,
                        branch: previousBranch,
                        version: previousVersion
                    });
                    return;
                }
                rootState.replace({
                    ...synced,
                    loading: false
                });
            });
        } catch (error) {
            // Restore previous branch state
            rootState.update({
                loading: false,
                branch: previousBranch,
                version: previousVersion
            });
            console.error('Failed to switch branch:', error);
            this.call('openNotification', {
                type: 'error',
                message: `Failed to switch to branch "${branch}": ${error.message}`
            });
        }
    });
    this.getCanvas().lookup('Versions').update();
}
async function $395e1025e0f09c9d$export$b0dd6a74f9517c68(version) {
    const rootState = this.getRootState();
    // Skip if already on the requested version
    if (rootState.version === version || version === 'latest' && !rootState.isOld) return;
    const previousVersion = rootState.version;
    const previousIsOld = rootState.isOld;
    // Indicate loading state & whether we are on an old version
    rootState.quietUpdate({
        isOld: version !== 'latest'
    });
    // Ensure at least one awaited expression so ESLint's require-await rule passes
    await new Promise((resolve)=>{
        window.requestAnimationFrame(resolve);
    });
    try {
        const data = await this.sdk.getProjectData(rootState.projectId, {
            version: version
        });
        // Validate the received payload
        if (!data || Object.keys(data).length === 0) throw new Error('Received empty data from version switch');
        // Sync freshly received data with the current state first so that we keep
        // socket/client information intact. Once synced – replace the root state
        // to trigger full re-render.
        this.call('sync', data, (synced)=>{
            if (!synced) {
                // Sync failed – rollback to previous state
                rootState.update({
                    version: previousVersion,
                    isOld: previousIsOld
                });
                return;
            }
            rootState.replace({
                ...synced,
                version: version,
                isOld: version !== 'latest'
            });
        });
    } catch (error) {
        // Rollback to the previous state on error
        rootState.replace({
            version: previousVersion,
            isOld: previousIsOld
        });
        console.error('Failed to switch version:', error);
        this.call('openNotification', {
            type: 'error',
            message: `Failed to switch to version "${version}": ${error.message}`
        });
    }
// Force Versions sidebar to refresh its UI state
// this.getCanvas().lookup('Versions').update()
}
function $395e1025e0f09c9d$export$ee497b3c885b8e5e() {
    return this.getRootState('projectName');
}
function $395e1025e0f09c9d$export$3d5e1f66ff556ecb() {
    const projects = this.getRootState()?.projects || [];
    // Remove duplicates based on project id (This should be just a workaround)
    return [
        ...new Map(projects.map((project)=>[
                project.id,
                project
            ])).values()
    ];
}
function $395e1025e0f09c9d$export$67fbc4483c75d073() {
    return this.getRootState()?.projectUsers;
}
function $395e1025e0f09c9d$export$f030a28031d9be25() {
    return this.getRootState()?.projectId;
}
// Shared function that handles the common project switching logic
async function $395e1025e0f09c9d$var$performProjectSwitch(context, fullProjectData, projectId, projectRole) {
    const { projects: projects } = context.getRootState();
    // Reconstruct the "basicProject" shape from the new payload so that
    // everything assigned into rootState stays the same as before.
    const projectInfo = fullProjectData.projectInfo || {};
    const projectMeta = fullProjectData.projectMeta || {};
    const basicProject = {
        // Core project metadata
        ...projectMeta,
        ...projectInfo,
        // Relations,
        members: fullProjectData.members,
        owner: fullProjectData.owner,
        // Shared libraries info,
        sharedLibraries: fullProjectData.sharedLibraries || []
    };
    const { key: appKey, name: projectName, id: id } = basicProject;
    const effectiveProjectId = id || projectId;
    // Keep SDK context update semantics the same, but use reconstructed basicProject
    await context.call('updateSDKContext', {
        project: basicProject,
        appKey: appKey,
        projectRole: projectRole
    });
    context.call('applyLoader', {
        value: true,
        force: true,
        timeout: 1
    });
    const state = context.getRootState();
    state.clients = {
        localhost: {},
        cli: {},
        platform: {}
    };
    state.settings = {};
    state.project = {};
    state.canvas = {
        pages: {},
        clients: {},
        gridOptions: {
            pages: [],
            comp: [],
            atom: [],
            children: []
        }
    };
    // Use the full project data as the "loadedProjectData" part
    const loadedProjectData = fullProjectData;
    const projectData = {
        ...basicProject,
        ...loadedProjectData,
        ...appKey && {
            appKey: appKey
        },
        ...effectiveProjectId && {
            projectId: effectiveProjectId
        },
        ...projectName && {
            projectName: projectName
        },
        ...projectRole && {
            projectRole: projectRole
        },
        sharedLibraries: basicProject.sharedLibraries || loadedProjectData.sharedLibraries || []
    };
    context.call('overwrite', state, context.call('deepDestringifyFunctions', projectData));
    // If we're on canvas page, connect to new project's collaboration room
    if (context.isCanvas()) await context.call('switchCanvasProject', {
        projectId: effectiveProjectId,
        branch: 'main',
        pro: state.pro || state.userData?.pro
    });
    // Show loader until scene is ready
    context.call('applyLoader', {
        value: true,
        force: true,
        timeout: 35
    });
    return state;
}
async function $395e1025e0f09c9d$export$aa6a184b5d48d926(projectId) {
    const { projects: projects } = this.getRootState();
    // New backend returns everything we need in a single getProjectData() call
    const fullProjectData = await this.sdk.getProjectData(projectId);
    // Get the project role with fallback to API call if not found in user projects
    const effectiveProjectId = fullProjectData.projectInfo?.id || fullProjectData.projectMeta?.id || projectId;
    const projectRole = await this.sdk.getProjectRoleWithFallback(effectiveProjectId, projects);
    await $395e1025e0f09c9d$var$performProjectSwitch(this, fullProjectData, projectId, projectRole);
    this.router(this.getCanvasPathname() || this.fallbackRoute || '/canvas');
}
async function $395e1025e0f09c9d$export$8a8b34fc133941fe(projectKey) {
    // Switch active project by its key (without relying on state.activeProject)
    if (!projectKey) return;
    const rootState = this.getRootState();
    const { projects: projects = [] } = rootState;
    // 1. Fetch full project data by key (contains everything basicProject used to have)
    const fullProjectData = await this.sdk.getProjectDataByKey(projectKey);
    if (!fullProjectData) {
        this.warn(`[switchProjectByKey] Project data not found for key: ${projectKey}`);
        this.openNotification({
            type: 'error',
            title: 'Project Not Found',
            message: `Project with key "${projectKey}" not found or you don't have access to it.`
        });
        return;
    }
    const projectId = fullProjectData.projectInfo?.id || fullProjectData.projectMeta?.id;
    // 2. Determine current user role in the project with fallback to API call
    const projectRole = await this.sdk.getProjectRoleByKeyWithFallback(projectKey, projects);
    await $395e1025e0f09c9d$var$performProjectSwitch(this, fullProjectData, projectId, projectRole);
    return fullProjectData;
}

});

parcelRegister("Ntxk8", function(module, exports) {

$parcel$export(module.exports, "prepareFrameProps", () => prepareFrameProps);
$parcel$export(module.exports, "prepareCode", () => prepareCode);
$parcel$export(module.exports, "prepareRouter", () => prepareRouter);
$parcel$export(module.exports, "prepareUtils", () => prepareUtils);
$parcel$export(module.exports, "prepareMethods", () => prepareMethods);
$parcel$export(module.exports, "prepareInitOptions", () => prepareInitOptions);
parcelRequire("2oe0q");
var $bmfNh = parcelRequire("bmfNh");

var $bZxx9 = parcelRequire("bZxx9");
function prepareFrameProps(scope, state) {
    const { frameProps } = scope;
    return (0, $bmfNh.deepMerge)({
        ':focus-within': {
            outline: 'none'
        },
        ...frameProps,
        ...state.props
    }, {
        zoom: this.getUserSettings('zoomLevel'),
        direction: this.getUserSettings('languageDirection')
    });
}
function prepareCode(code) {
    const clonedCode = (0, $bmfNh.deepClone)(code);
    try {
        return (0, $bmfNh.deepDestringifyFunctions)(clonedCode);
    } catch (e) {
        console.error(e);
        return (0, $bmfNh.deepClone)(clonedCode);
    }
}
function prepareRouter(data, scope) {
    return scope.router || scope.useRouter ? (path)=>this.call('router', scope.activeItem || path || '', this, {}, {
            window: window.top || window
        }) : function(path, ...params) {
        if (typeof path !== 'string' || !path.startsWith('/') || !(this.getRootState() && this.getUserSettings('allowCanvasReplaceRouter')) || params[2]?.initialRender) return;
        window.setTimeout(()=>{
            const chosen = this.getChosenKey();
            const key = '/' + path.split('/')[1];
            this.activateSelected(key);
            if (!chosen) this.zoomToNode(this.getSelected());
        }, 1);
    };
}
function prepareUtils(data, scope) {
    const router = this.prepareRouter?.(data, scope);
    return {
        ...data?.functions,
        ...data?.snippets,
        router: router
    };
}
function prepareMethods(data, scope) {
    const router = this.prepareRouter?.(data, scope);
    return {
        ...$bZxx9,
        ...data?.methods,
        router: router
    };
}
function prepareInitOptions(scope, emotion) {
    return {
        ...scope.initOptions,
        newConfig: {},
        emotion: emotion
    };
}

});

parcelRegister("3spi0", function(module, exports) {

$parcel$export(module.exports, "prepareDesignSystem", () => $28479a94a36a821c$export$d54de307475be07a);
$parcel$export(module.exports, "prepareComponent", () => $28479a94a36a821c$export$31d40bb118b87907);
$parcel$export(module.exports, "prepareDemoApp", () => $28479a94a36a821c$export$b7a6ad77f61cc83e);
$parcel$export(module.exports, "prepareDependencies", () => $28479a94a36a821c$export$c40391394e7726ed);
$parcel$export(module.exports, "prepareContext", () => $28479a94a36a821c$export$9c634076e0a91d1f);
$parcel$export(module.exports, "renderStateComponent", () => $28479a94a36a821c$export$810dfc066ec9c57c);
parcelRequire("8augU");
var $bmfNh = parcelRequire("bmfNh");
var $4YHTc = parcelRequire("4YHTc");
var $8augU = parcelRequire("8augU");
var $1zeno = parcelRequire("1zeno");

var $bicp3 = parcelRequire("bicp3");
const $28479a94a36a821c$var$dotsBase = {
    backgroundPosition: 'top',
    backgroundRepeat: 'repeat',
    backgroundSize: '20px 20px'
};
const $28479a94a36a821c$var$platformUI = {
    gradient: {
        dotsDark: 'radial-gradient(#435067 6%, transparent 6%)',
        dotsLight: 'radial-gradient(#d9d9db 6%, transparent 6%)'
    },
    reset: {
        head: {
            overscrollBehaviorX: 'none'
        },
        body: {
            overscrollBehaviorX: 'none'
        }
    },
    theme: {
        dots: {
            ...$28479a94a36a821c$var$dotsBase,
            '@dark': {
                backgroundImage: 'dotsDark',
                ...$28479a94a36a821c$var$dotsBase
            },
            '@light': {
                backgroundImage: 'dotsLight',
                ...$28479a94a36a821c$var$dotsBase
            }
        }
    },
    animation: {
        fadeIn: {
            '0%': {
                opacity: 0
            },
            '100%': {
                opacity: 1
            }
        },
        blink: {
            '0%': {
                opacity: 1
            },
            '50%': {
                opacity: 0
            },
            '100%': {
                opacity: 1
            }
        },
        componentBlink: {
            '0%': {
                opacity: 1
            },
            '50%': {
                opacity: 0.35
            },
            '100%': {
                opacity: 1
            }
        }
    }
};
function $28479a94a36a821c$export$d54de307475be07a(data, scope) {
    const globalTheme = scope?.sceneTheme || data?.designSystem?.globalTheme;
    const designSystem = data.designSystem || {};
    if (designSystem.reset?.body) {
        designSystem.reset.body.position = 'absolute';
        designSystem.reset.body.inset = '0 0 0 0';
    }
    return (0, $bmfNh.deepMerge)(designSystem, {
        globalTheme: globalTheme,
        ...$28479a94a36a821c$var$platformUI
    });
}
function $28479a94a36a821c$export$31d40bb118b87907(scope, state, code) {
    const el = this;
    const props = state.props || {};
    const demoCode = el.prepareCode(code);
    const extend = [
        demoCode
    ];
    if (state.state) extend.push({
        state: state.state
    });
    extend.push({
        margin: 'auto',
        fontSize: props.base && `${props.base}px`,
        '--spacing-ratio': state.ratio,
        variant: state.variant,
        transition: 'all, B, defaultBezier',
        ':focus-within': {
            outline: 'none'
        }
    });
    const appjs = el.getFiles('app.js');
    if (scope.useAppjs && appjs?.code) extend.push(appjs?.code);
    return (0, $bmfNh.deepClone)({
        extend: extend
    });
}
function $28479a94a36a821c$export$b7a6ad77f61cc83e(scope, state, code) {
    const el = this;
    if (scope.renderPureComponent) return code;
    const demoComponent = el.prepareComponent(scope, state, code);
    return (0, $bmfNh.deepClone)({
        extends: [
            'Flex'
        ],
        props: el.prepareFrameProps(scope, state),
        data: {},
        demoComponent: demoComponent,
        on: scope.appEvents
    });
}
async function $28479a94a36a821c$export$c40391394e7726ed(scope, data, deps) {
    const meta = scope.document.createElement('meta');
    meta.name = 'viewport';
    meta.content = 'width=device-width, user-scalable=no';
    scope.document.head.appendChild(meta);
    if (scope.canvas) {
        await (0, $4YHTc.loadRemoteScript)('https://pkg.symbo.ls/panzoom@9.4.3/dist/panzoom.min.js', {
            document: scope.document
        });
        await (0, $4YHTc.loadRemoteScript)('https://pkg.symbo.ls/gridstack@10.3.1/dist/gridstack-all.js', {
            document: scope.document
        });
        await (0, $4YHTc.loadRemoteCSS)('https://pkg.symbo.ls/gridstack@10.3.1/dist/gridstack.css', {
            document: scope.document
        });
    }
    const isSmblsLocal = true;
    // Ensure iframe window.packages exists for loadModule
    if (!scope.window.packages) scope.window.packages = {};
    // Load smbls inside the iframe.
    // Local dev: browser bundle from local server, prod: esm.sh CDN
    if (isSmblsLocal) {
        const localUrl = 'http://localhost:5500/packages/smbls/dist/browser/index.js';
        try {
            // Shim Node globals for browser bundle
            if (!scope.window.process) scope.window.process = {
                env: {}
            };
            const mod = await (0, $bicp3.loadModule)('smbls', localUrl, scope, null, '');
            scope.window.smbls = mod;
        } catch (e) {
            this.warn('Problem with local smbls', e);
            scope.window.smbls = $8augU;
        }
    } else {
        const remoteUrl = 'https://esm.sh/smbls';
        const lastUpdated = this.state.root.updatedAt;
        const randomize = lastUpdated || Math.random();
        const cachingSuffix = `?${randomize}`;
        try {
            const mod = await (0, $bicp3.loadModule)('smbls', remoteUrl + cachingSuffix, scope, null, '');
            scope.window.smbls = mod;
        } catch (e) {
            this.warn('Problem with smbls', e);
            scope.window.smbls = $8augU;
        }
    }
}
async function $28479a94a36a821c$export$9c634076e0a91d1f(scope, data) {
    const el = this;
    const sceneMode = this.call('exec', scope.sceneMode);
    const __cache = scope.__cache;
    if (__cache) Object.assign(data, __cache) // todo: need to check
    ;
    console.log('Preparing context with sceneMode:', sceneMode);
    if (sceneMode === 'basic') return {
        components: {},
        pages: {
            '/': data
        },
        designSystem: {},
        router: {
            pushState: false
        }
    };
    if (sceneMode === 'app') return {
        ...data,
        router: {
            pushState: false
        }
    };
    return {
        ...data,
        designSystem: el.prepareDesignSystem(data, scope),
        utils: el.prepareUtils(data, scope),
        methods: el.prepareMethods(data, scope),
        sharedLibraries: (data?.sharedLibraries || []).map((v)=>(0, $bmfNh.deepDestringifyFunctions)(v) || {}),
        type: [
            'marketplace',
            'platform'
        ].includes(scope?.projectType) ? 'template' : 'app',
        initOptions: el.prepareInitOptions(scope),
        domqlOptions: {
            allowRefReference: true
        },
        editor: {
            verbose: false,
            inspect: false,
            liveSync: false,
            remote: false
        },
        ...scope.useRouter && {
            router: scope.routerOptions
        }
    };
}
async function $28479a94a36a821c$export$810dfc066ec9c57c(code) {
    if (!code) return;
    const el = this;
    const s = el.state;
    const scope = el.scope;
    const frameWindow = scope.window;
    if (!frameWindow || !scope.document) return this.warning('Unable to access iframe window or document Scene');
    const originalData = el.call('exec', scope.data) || el.getData();
    const data = (0, $bmfNh.deepClone)(originalData, undefined, {
        window: scope.window
    });
    const isAppMode = scope.sceneMode === 'app';
    let demoApp, demoAppStr, context;
    if (isAppMode) {
        // In app mode, the code IS the full app definition — use it as context directly
        const frameProps = el.prepareFrameProps(scope, s);
        demoApp = frameWindow.demoApp = {
            props: frameProps
        };
        demoAppStr = el.call('stringifyCode', demoApp, {
            preventExportDefult: true
        });
        context = await el.prepareContext(scope, code);
    } else {
        demoApp = frameWindow.demoApp = el.prepareDemoApp(scope, data, code);
        demoAppStr = el.call('stringifyCode', demoApp, {
            preventExportDefult: true
        });
        context = await el.prepareContext(scope, data);
    }
    const key = scope.rootKey;
    context.key = key;
    frameWindow.platformState = s.root;
    frameWindow.context = context;
    await el.prepareDependencies(scope, data);
    frameWindow.contextStr = el.call('stringifyCode', frameWindow.context, {
        preventExportDefult: true
    });
    el.preventLocationChanges(frameWindow);
    // Guard against concurrent renders
    const renderId = Math.random();
    frameWindow.__renderId = renderId;
    const appStr = `(async () => {
  try {
    const renderId = ${renderId}

    const previous = document.getElementById('smbls-script')
    if (previous) previous.remove()
    if (window.smblsApp) {
      try { await window.smblsApp.remove() } catch(e) {}
      window.smblsApp = null
    }
    // Clear all rendered content from body
    while (document.body.firstChild) document.body.firstChild.remove()

    // Abort if a newer render has started
    if (window.__renderId !== renderId) return

    const contextStr = ${frameWindow.contextStr}

    const smbls = window.smbls

    if (!smbls || !smbls.create) {
      throw new Error('smbls is not properly loaded or missing create method')
    }

    window.requestAnimationFrame(async() => {
      if (window.__renderId !== renderId) return
      // Bind iframe document/window so smbls renders into the iframe, not the parent
      contextStr.document = document
      contextStr.window = window
      contextStr.container = document.head
      contextStr.parent = document.body
      const smblsApp = await smbls.createSync.call(window, ${demoAppStr}, contextStr)
      if (window.__renderId !== renderId) {
        try { await smblsApp.remove() } catch(e) {}
        return
      }
      window.smblsApp = smblsApp
    })
  } catch (e) {
    console.error('[App] Fatal error:', e)
    window.demoApp.on.error.call(window.smblsApp, e, window.smblsApp)
    throw new Error(e)
  }
})()`;
    (0, $4YHTc.loadJavascript)((0, $1zeno.replaceOctalEscapeSequences)(appStr), false, scope.document, 'module');
}

});
parcelRegister("bicp3", function(module, exports) {

$parcel$export(module.exports, "loadModule", () => $838aff22702ae1b5$export$ebb47fdc8f2dbc6f);
const $838aff22702ae1b5$var$CDN_PROVIDERS = {
    skypack: {
        url: 'https://cdn.skypack.dev',
        formatUrl: (pkg, version)=>`${$838aff22702ae1b5$var$CDN_PROVIDERS.skypack.url}/${pkg}${version !== 'latest' ? `@${version}` : ''}`
    },
    symbols: {
        url: 'https://pkg.symbo.ls',
        formatUrl: (pkg, version)=>{
            const onlyDotsAndNumbers = (str)=>/^[0-9.]+$/.test(str) && str !== '';
            if (pkg.split('/').length > 2 || !onlyDotsAndNumbers(version)) return `${$838aff22702ae1b5$var$CDN_PROVIDERS.symbols.url}/${pkg}`;
            return `${$838aff22702ae1b5$var$CDN_PROVIDERS.symbols.url}/${pkg}/${version}.js`;
        }
    }
};
const $838aff22702ae1b5$export$8407093f131dcef1 = (packageName, version = 'latest', provider = 'skypack')=>{
    const cdnConfig = $838aff22702ae1b5$var$CDN_PROVIDERS[provider] || $838aff22702ae1b5$var$CDN_PROVIDERS.skypack;
    return cdnConfig.formatUrl(packageName, version);
};
async function $838aff22702ae1b5$export$ebb47fdc8f2dbc6f(key, url, options, provider, random) {
    // Helper function to execute dynamic import via Function constructor
    const createDynamicImport = (win, importUrl)=>{
        const importFn = win.Function('url', 'return import(url)');
        return importFn(importUrl);
    };
    const win = options.window;
    try {
        // --- Primary Import Attempt ---
        const mod = await createDynamicImport(win, url);
        const pkg = mod.default || mod;
        win.packages[key] = pkg;
        return pkg;
    } catch (primaryError) {
        // --- Skypack Fallback Attempt ---
        if (provider === 'skypack') {
            const fallbackUrl = $838aff22702ae1b5$export$8407093f131dcef1(key, 'latest', 'symbols') + random;
            try {
                const fallbackMod = await createDynamicImport(win, fallbackUrl);
                const fallbackPkg = fallbackMod.default || fallbackMod;
                win.packages[key] = fallbackPkg;
                return fallbackPkg;
            } catch (fallbackError) {
            // Fallback failed, proceed to final error handling and throw the original primaryError
            // The original logic dictates we throw the first error if the fallback fails.
            }
        }
        // --- Final Error Handling (Logs and Re-throws) ---
        // This catches:
        // 1. The primaryError if provider is not 'skypack'.
        // 2. The primaryError if the 'skypack' fallback also failed.
        console.error(`Failed to load ${key}:`, primaryError);
        throw primaryError;
    }
}

});


parcelRegister("6nkDr", function(module, exports) {

$parcel$export(module.exports, "renderStateComponentDashboard", () => $4a44e5c977a9f253$export$f4707c6b5ef3cb02);
parcelRequire("8augU");
var $6T8Dr = parcelRequire("6T8Dr");
var $c5dHw = parcelRequire("c5dHw");parcelRequire("2oe0q");
var $bmfNh = parcelRequire("bmfNh");

var $Ntxk8 = parcelRequire("Ntxk8");
const $4a44e5c977a9f253$var$prepareDesignSystem = async (scope, rootState)=>{
    const { cache: cache } = scope;
    const globalTheme = rootState.designSystem?.globalTheme || rootState.sceneTheme || rootState.globalTheme;
    const { useLibrary: useLibrary } = scope;
    const hasCache = cache?.designSystem;
    const lib = useLibrary ? hasCache || (0, $bmfNh.deepClone)(rootState.designSystem) : (0, $bmfNh.deepClone)(await undefined.getDefaultDesignSystem());
    return {
        ...lib,
        globalTheme: globalTheme
    };
};
const $4a44e5c977a9f253$var$prepareComponent = (scope, state, code)=>{
    const props = scope.frameProps || {};
    const extend = [];
    if (state.state) extend.push({
        state: state.state
    });
    const demoObj = (0, $Ntxk8.prepareCode)(code);
    const demoComponent = demoObj;
    return (0, $bmfNh.deepClone)({
        extends: extend.concat([
            demoComponent
        ]),
        fontSize: props.base && `${props.base}px`,
        '--spacing-ratio': state.ratio,
        variant: state.variant,
        transition: 'all, B, defaultBezier'
    });
};
const $4a44e5c977a9f253$var$prepareComponents = async (scope, rootState)=>{
    const { cache: cache, useLibrary: useLibrary } = scope;
    const hasCache = cache?.components;
    return useLibrary ? hasCache || (0, $bmfNh.deepClone)(rootState.components) : (0, $bmfNh.deepClone)(await undefined.getDefaultComponents());
};
const $4a44e5c977a9f253$var$prepareDemoApp = (scope, state, code)=>{
    const { cache: cache, useLibrary: useLibrary, renderPureComponent: renderPureComponent } = scope // eslint-disable-line
    ;
    if (renderPureComponent) return code;
    const element = state.__element;
    const appJsFromFiles = (cache?.files || state.root.files)['app.js'];
    const appJs = element.call('evalStringToObject', appJsFromFiles && appJsFromFiles.code);
    return (0, $bmfNh.deepClone)({
        extends: [
            'Flex',
            scope.useAppjs && appJs
        ],
        ...(0, $Ntxk8.prepareFrameProps)(scope, state),
        data: {},
        demoComponent: $4a44e5c977a9f253$var$prepareComponent(scope, state, code),
        ...scope.appEvents,
        ...fixScratchSwitchingOnListener
    });
};
const $4a44e5c977a9f253$export$f4707c6b5ef3cb02 = async (code, el, s, scope = {})=>{
    if (!code || el.data?.demoFrameElement) return;
    // if (el.data?.demoFrameElement) el.data?.demoFrameElement.remove()
    const rootState = s.root;
    const frameWindow = el.node.contentWindow;
    const currentDocument = el.node.contentDocument || document;
    if (!currentDocument) return;
    const emotionKey = (scope.key || el.getAppKey() || 'demo').replace(/[^A-Za-z]+/gu, '').toLowerCase();
    const emotion = (0, $c5dHw.createEmotion)(emotionKey, currentDocument.head);
    const emotionDefine = (0, $c5dHw.transformDOMQLEmotion)(emotion);
    // prepare cache
    const cache = scope.cache || el.lookup((el2)=>el2.scope.__cache)?.scope.__cache;
    if (!scope.cache) scope.cache = cache;
    // prepare domql app
    const demoApp = $4a44e5c977a9f253$var$prepareDemoApp(scope, s, code);
    if (el.node.offsetParent === null) return;
    try {
        el.data.demoFrameElement = await (0, $6T8Dr.create).call(frameWindow, demoApp, {
            key: scope.renderPureComponent ? s.key : 'demo',
            document: scope.document || currentDocument,
            designSystem: await $4a44e5c977a9f253$var$prepareDesignSystem(scope, rootState),
            components: await $4a44e5c977a9f253$var$prepareComponents(scope, rootState),
            pages: preparePages(scope, rootState),
            files: prepareFiles(scope, rootState),
            utils: (0, $Ntxk8.prepareUtils)(scope, rootState),
            snippets: prepareSnippets(scope, rootState),
            methods: el.prepareMethods(scope, rootState),
            registry: emotionDefine,
            initOptions: (0, $Ntxk8.prepareInitOptions)(scope, emotion),
            dependencies: !scope.preventDependencies && el.getDependencies(),
            window: frameWindow,
            socket: el.context.socket,
            domqlOptions: {
                alowRefReference: true
            },
            editor: {
                verbose: false,
                inspect: false,
                liveSync: false,
                remote: false
            },
            // editor: {
            //   inspect: true,
            //   sync: false,
            //   onInspect: (key, _, __, opts) => router(window.location.pathname + '/editor/' + key, el.__ref.root, {}, opts)
            // },
            router: scope.useRouter ? {
                pushState: false,
                removeOldElement: true,
                contentElementKey: 'demoComponent'
            } : false
        });
    } catch (e) {
        el.error(e);
    }
    return el.data.demoFrameElement;
};

});

parcelRegister("3ubf6", function(module, exports) {

$parcel$export(module.exports, "openNotification", () => $289ce4fda7e1ef10$export$ca2532046576fe2c);
$parcel$export(module.exports, "openNotificationParams", () => $289ce4fda7e1ef10$export$e18636bfa8c0bee6);
$parcel$export(module.exports, "closeNotification", () => $289ce4fda7e1ef10$export$d684d3158aada635);
// export async function openNotification (obj, opts = {}) {
//   const state = this.getRootState()
//   // Ensure notifications array exists
//   if (!state.notifications) {
//     await state.apply(s => {
//       s.notifications = []
//     }, { preventUpdate: true })
//   }
//   // Check if this is a repeated notification
//   const existingNotificationIndex = state.notifications.findIndex(
//     notification => notification.title === obj.title && notification.message === obj.message
//   )
//   // Generate a unique ID for each notification for better tracking
//   const notificationId = Date.now() + Math.random().toString(36).substring(2, 9)
//   let notification = { ...obj, id: notificationId, timestamp: Date.now() }
//   // If this is a duplicate notification, we'll update the existing one with a count
//   if (existingNotificationIndex !== -1 && !opts.forceNew) {
//     const existingNotification = state.notifications[existingNotificationIndex]
//     const count = existingNotification.count || 1
//     // Update the existing notification with an increased count
//     notification = {
//       ...existingNotification,
//       count: count + 1,
//       id: notificationId, // Give it a new ID to force UI update
//       timestamp: Date.now(),
//       message: `${obj.message.replace(/ \(\d+\)$/u, '')  } (${count + 1})`
//     }
//     // Remove the existing notification
//     await state.apply(
//       s => {
//         s.notifications.splice(existingNotificationIndex, 1)
//       },
//       { preventUpdate: true }
//     )
//   }
//   // Add the notification to the array
//   await state.apply(
//     s => {
//       s.notifications.push(notification)
//     },
//     { preventUpdate: true }
//   )
//   const NotifElement = this.getRoot('GlobalNotification')
//   if (!NotifElement) {
//     console.error('GlobalNotification component not found')
//     return
//   }
//   NotifElement.update()
//   const notifs = this.getRootState('notifications') || []
//   const current = NotifElement.content[notifs.length - 1]
//   if (!current) {
//     return
//   }
//   // Auto-close the notification after a delay
//   setTimeout(() => {
//     if (!current || current?.props.animation === 'fadeOutDown') {
//       return
//     }
//     current.call('closeNotification')
//   }, notification.duration || obj.duration || opts.duration || 5000)
// }
async function $289ce4fda7e1ef10$export$ca2532046576fe2c(obj, opts = {}) {
    const state = this.getRootState();
    // Check for existing notification with same title
    if (state.notifications?.some((notification)=>notification.title === obj.title)) return;
    await state.apply((s)=>{
        s.notifications.push({
            ...obj,
            id: s.notifications.length
        });
    }, {
        preventUpdate: true
    });
    const NotifElement = this.getRoot('GlobalNotification');
    await NotifElement.update();
    const notifs = this.getRootState('notifications');
    const current = NotifElement.content[notifs.length - 1];
    if (!current) return;
    const t = setTimeout(()=>{
        // console.log('remove', current)
        // if (current?.props.animation === 'fadeOutDown') {
        //   return
        // }
        current.call('closeNotification', current);
        clearTimeout(t);
    }, obj.duration || opts.duration || 3500);
}
async function $289ce4fda7e1ef10$export$e18636bfa8c0bee6(title, error, message, opts = {}) {
    return await $289ce4fda7e1ef10$export$ca2532046576fe2c.call(this, {
        title: title,
        error: error,
        message: message
    }, opts);
}
function $289ce4fda7e1ef10$export$d684d3158aada635(current, opts = {}) {
    if (!opts.forced && this.state.hover) {
        const t = setTimeout(()=>{
            this.call('closeNotification', current, opts);
            clearTimeout(t);
        }, opts.retryTimeout || 500);
        return;
    }
    const NotifElement = this.getRoot('GlobalNotification');
    if (!NotifElement || !NotifElement.content) return;
    const notifs = this.getRootState('notifications') || [];
    if (!current) {
        let key = parseInt(this.key, 10) || 0;
        while(!notifs[key] && key > -1)key = parseInt(key, 10) - 1;
        if (notifs.length > 0) notifs.splice(key, 1);
        current = NotifElement.content[key] || this.state.title && this;
    }
    if (!current) return;
    // // Use notification ID if available for more precise removal
    // const index = this.state.id
    //   ? notifs.findIndex(notification => notification.id === this.state.id)
    //   : notifs.findIndex(notification => notification.title === this.state.title)
    // if (index > -1) {
    //   notifs.splice(index, 1)
    // }
    current.update({
        animation: 'fadeOutDown',
        height: '0',
        paddingBlock: '0'
    });
    const t = setTimeout(()=>{
        current.remove();
        clearTimeout(t);
    }, opts.duration || 500);
}

});

parcelRegister("f1gPr", function(module, exports) {

$parcel$export(module.exports, "getConfig", () => $aef400d8a3c20d6d$export$44487a86467333c3);
/**
 * Resets the Design System with the provided object.
 * @param {object} obj - Object to reset the Design System with.
 * @param {object} [opts={}] - Options for resetting the Design System.
 */ function $aef400d8a3c20d6d$export$44487a86467333c3() {
    const { environment: environment } = this.sdk;
    return {
        apiUrl: environment.apiUrl
    };
}

});

parcelRegister("KEXbu", function(module, exports) {

$parcel$export(module.exports, "addCanvasPage", () => $08c4108583349cb7$export$6d14ce3b9577517d);
$parcel$export(module.exports, "openCanvasPage", () => $08c4108583349cb7$export$24e60188356e3a74);
$parcel$export(module.exports, "getCanvasPage", () => $08c4108583349cb7$export$d6a3fc958f256206);
$parcel$export(module.exports, "getCurrentCanvasPage", () => $08c4108583349cb7$export$9b63abb677f6a745);
$parcel$export(module.exports, "onCurrentCanvasPage", () => $08c4108583349cb7$export$29381aa7e0c51447);
$parcel$export(module.exports, "inOnCurrentCanvasPage", () => $08c4108583349cb7$export$85f5f9581c02a7af);
$parcel$export(module.exports, "findInOtherCanvasPages", () => $08c4108583349cb7$export$f8e73b601272202a);
$parcel$export(module.exports, "findKeyInOtherCanvasPages", () => $08c4108583349cb7$export$d74f90859a22cf4d);
$parcel$export(module.exports, "deleteCanvasPage", () => $08c4108583349cb7$export$2aa8899e61777286);
$parcel$export(module.exports, "renameCanvasPage", () => $08c4108583349cb7$export$8f94e67b894ac942);
$parcel$export(module.exports, "duplicateCanvasPage", () => $08c4108583349cb7$export$597024bd84ed5a82);
$parcel$export(module.exports, "returnAddedCanvasPageChanges", () => $08c4108583349cb7$export$43ca08285ea298c7);
$parcel$export(module.exports, "returnRemovedCanvasPageChanges", () => $08c4108583349cb7$export$fc8c77d6ce8bd677);
$parcel$export(module.exports, "addItemOnCanvasPage", () => $08c4108583349cb7$export$97f6bce516ce1947);
async function $08c4108583349cb7$export$6d14ce3b9577517d(obj, opts = {}) {
    const { title: title, freeform: freeform } = obj;
    if (!title) return window.alert('Title is required.');
    const canvasPages = this.getRootState().canvas.pages;
    const exists = title === 'Default' || canvasPages && canvasPages[title];
    const query = [
        [
            'update',
            [
                'canvas',
                'pages',
                title
            ],
            {
                title: title,
                freeform: freeform,
                pages: [],
                components: [],
                functions: [],
                methods: [],
                snippets: [],
                atom: [],
                files: [],
                dependencies: [],
                secrets: []
            }
        ]
    ];
    if (!canvasPages) query.unshift([
        'update',
        [
            'canvas',
            'pages'
        ],
        {}
    ]);
    if (exists && !opts.preventNameCheck) return this.call('openNotification', {
        type: 'error',
        title: 'Such canvas page already exists.',
        message: `Canvas page with name "${title}" already exists. Please use different name`
    });
    this.sdk.updateData(query, {
        message: `Added canvas page ${title}`
    });
    this.call('openCanvasPage', title);
}
async function $08c4108583349cb7$export$24e60188356e3a74(val) {
    let pageVal = val;
    const data = this.getCanvasScope();
    const Collection = this.getCanvasCollection();
    const activeCanvasPage = this.getActiveCanvasPage();
    this.syncCanvas({
        activeCanvasPage: pageVal
    });
    if (pageVal === activeCanvasPage) return;
    pageVal ||= this.state.value;
    data.activeCanvasPage = pageVal;
    if (Collection?.update) await Collection.update();
    await this.getCanvasPages()?.update();
    if (this.getFilesSidebar()?.update) await this.getFilesSidebar().update();
    this.call('resetCanvasPan');
}
function $08c4108583349cb7$export$d6a3fc958f256206(key) {
    const { canvas: canvas } = this.getRootState();
    return canvas.pages && Object.keys(canvas.pages).length > 0 && canvas.pages[key];
}
function $08c4108583349cb7$export$9b63abb677f6a745() {
    const activeCanvasPage = this.getActiveCanvasPage();
    return this.call('getCanvasPage', activeCanvasPage);
}
function $08c4108583349cb7$export$29381aa7e0c51447(type, key) {
    const platformState = this.getRootState();
    const activeCanvasPage = this.getActiveCanvasPage();
    const { canvas: canvas } = platformState;
    return canvas.pages[activeCanvasPage][type].includes(key);
}
function $08c4108583349cb7$export$85f5f9581c02a7af(type, key) {
    const { canvas: canvas } = this.getRootState();
    const activeCanvasPage = this.getActiveCanvasPage();
    const isDefaultActive = activeCanvasPage === 'Default';
    const isAnywhereElse = this.call('findInOtherCanvasPages', type, key);
    if (isDefaultActive && !isAnywhereElse) return true;
    const currentCanvas = canvas.pages[activeCanvasPage];
    const currentWhitelist = currentCanvas?.[type];
    if (currentWhitelist?.includes(key)) return true;
}
function $08c4108583349cb7$export$f8e73b601272202a(type, key) {
    const platformState = this.getRootState();
    const activeCanvasPage = this.getActiveCanvasPage();
    const { canvas: canvas } = platformState;
    for(const page in canvas.pages){
        if (page === activeCanvasPage) continue;
        if (canvas.pages[page][type]?.includes(key)) return page;
    }
}
function $08c4108583349cb7$export$d74f90859a22cf4d(key) {
    const platformState = this.getRootState();
    const activeCanvasPage = this.getActiveCanvasPage();
    const { canvas: canvas } = platformState;
    const type = this.getType(key);
    for(const page in canvas.pages){
        if (page === activeCanvasPage) continue;
        if (canvas.pages[page][type]?.includes(key)) return page;
    }
}
async function $08c4108583349cb7$export$2aa8899e61777286(val) {
    let pageVal = val;
    const platformState = this.getRootState();
    const activeCanvasPage = this.getActiveCanvasPage();
    pageVal ||= this.state.value;
    if (pageVal === 'Default') {
        el.call('openNotification', {
            type: 'warning',
            title: `Default can't be removed`,
            message: `Default canvas page is built-in and can't be removed`
        });
        return;
    }
    if (!window.confirm(`Do you want to remove ${pageVal} page?`)) return;
    let moveTo = window.prompt('Where do you want to move all data?', 'Default');
    const { canvas: canvas } = platformState;
    const canvasPage = canvas.pages[pageVal] || {};
    // delete canvas.pages[val]
    const query = [
        [
            'delete',
            [
                'canvas',
                'pages',
                pageVal
            ]
        ]
    ];
    if (canvas.pages[moveTo] && moveTo !== 'Default') {
        this.call('deepMerge', canvas.pages[moveTo], canvasPage);
        query.push([
            'update',
            [
                'canvas',
                'pages',
                moveTo
            ],
            canvas.pages[moveTo]
        ]);
    } else moveTo = 'Default';
    // if (val !== canvasPage.pageVal) {
    //   delete canvas.pages[pageVal.pageVal]
    // }
    this.sdk.updateData(query, {
        message: `Removed canvas page ${pageVal}`
    });
    await this.getCanvasPages().update();
    if (activeCanvasPage === moveTo || activeCanvasPage === val) await this.call('openCanvasPage', moveTo);
// await platformState.quietReplace(
//   {
//     canvas: platformState.canvas
//   },
//   {
//     message: `Removed ${val} page. All items are moved to ${moveTo}.`
//   }
// )
}
function $08c4108583349cb7$export$8f94e67b894ac942(val) {
    let pageVal = val || this.state.value;
    const platformState = this.getRootState();
    if (pageVal === 'Default') {
        el.call('openNotification', {
            type: 'warning',
            title: `Default can't be renamed`,
            message: `Default canvas page is built-in and can't be renamed`
        });
        return;
    }
    const newTitle = window.prompt('Rename canvas page', pageVal);
    if (!newTitle) return;
    const { canvas: canvas } = platformState;
    const canvasPage = canvas.pages[pageVal] || {};
    // delete canvas.pages[pageVal]
    if (pageVal !== newTitle) {
        canvasPage.title = newTitle;
        const query = [
            [
                'update',
                [
                    'canvas',
                    'pages',
                    newTitle
                ],
                canvasPage
            ],
            [
                'delete',
                [
                    'canvas',
                    'pages',
                    pageVal
                ]
            ]
        ];
        this.sdk.updateData(query, {
            message: `Renamed canvas page ${pageVal} to ${newTitle}`
        });
        this.getCanvasPages().update();
    }
// platformState.quietReplace(
//   {
//     canvas: platformState.canvas
//   },
//   {
//     message: `Renamed canvas page "${pageVal}" to ${newTitle}.`
//   }
// )
}
function $08c4108583349cb7$export$597024bd84ed5a82() {}
function $08c4108583349cb7$export$43ca08285ea298c7(type, key) {
    const activeCanvasPage = this.getActiveCanvasPage();
    if (activeCanvasPage === 'Default') return;
    const canvasPages = this.getRootState('canvas').pages || {};
    const tuples = [];
    // 1. Add the key to the active canvas page list (or ensure it exists)
    const currentList = canvasPages?.[activeCanvasPage]?.[type] || [];
    const newCurrentList = currentList.includes(key) ? currentList : [
        ...currentList,
        key
    ];
    tuples.push([
        'update',
        [
            'canvas',
            'pages',
            activeCanvasPage,
            type
        ],
        newCurrentList
    ]);
    // 2. Ensure the key is removed from *other* canvas page lists so that it
    //    is unique to the current page. This prevents unintended navigation
    //    back to "Default" when interacting with the component.
    Object.keys(canvasPages).forEach((page)=>{
        if (activeCanvasPage === page) return;
        const list = canvasPages[page]?.[type];
        if (Array.isArray(list) && list.includes(key)) tuples.push([
            'update',
            [
                'canvas',
                'pages',
                page,
                type
            ],
            list.filter((k)=>k !== key)
        ]);
    });
    return tuples;
}
function $08c4108583349cb7$export$fc8c77d6ce8bd677(type, key) {
    const activeCanvasPage = this.getActiveCanvasPage();
    if (activeCanvasPage === 'Default') return;
    const canvasPages = this.getRootState('canvas').pages || {};
    const tuples = [];
    // Remove the key from the active canvas page list
    const currentList = canvasPages?.[activeCanvasPage]?.[type] || [];
    if (currentList.includes(key)) tuples.push([
        'update',
        [
            'canvas',
            'pages',
            activeCanvasPage,
            type
        ],
        currentList.filter((k)=>k !== key)
    ]);
    return tuples;
}
async function $08c4108583349cb7$export$97f6bce516ce1947(obj) {
    const { key: key } = obj;
    const activeCanvasPage = this.getActiveCanvasPage();
    const currentCanvas = this.call('getCurrentCanvasPage');
    const isDefault = activeCanvasPage === 'Default';
    const type = this.getType(obj);
    if (!isDefault && !currentCanvas[type]) currentCanvas[type] = [];
    if (!isDefault && !currentCanvas[type].includes(key)) currentCanvas[type].push(key);
    await this.call('rerenderFileSidebarByType', type);
} // export function removeCanvasArtboardFromCanvasPage(type, key) {
 //   if (!type || !key) {
 //     return this.error('Type or key is not defined to remove from canvas page')
 //   }
 //   const activeCanvasPage = this.getActiveCanvasPage()
 //   const currentCanvas = this.call('getCurrentCanvasPage')
 //   const isDefault = activeCanvasPage === 'Default'
 //   if (!isDefault && currentCanvas[type].includes(key)) {
 //     this.call('removeValueFromArrayAll', currentCanvas[type], key)
 //     return true
 //   }
 // }

});

parcelRegister("7vTiJ", function(module, exports) {

$parcel$export(module.exports, "sendRequest", () => $57865347b9fff7d9$export$d5a1e65f8aa21b51);
async function $57865347b9fff7d9$export$d5a1e65f8aa21b51(obj) {
    let { endpointUrl: url } = obj || this.state;
    const { method: method, paramsArr: paramsArr = [], headersArr: headersArr = [], body: body = null, authArr: authArr = [] } = obj || this.state;
    return new Promise(async (resolve, reject)=>{
        // Construct query string from params array
        if (paramsArr.length > 0) {
            const queryString = paramsArr.map((param)=>`${encodeURIComponent(param.key)}=${encodeURIComponent(param.value)}`).join('&');
            url += `?${queryString}`;
        }
        // Construct headers object from headers array
        const headersObject = {};
        headersArr.forEach((header)=>{
            headersObject[header.key] = header.value;
        });
        // Construct auth string if provided
        let authString = null;
        if (authArr.length > 0) {
            const authPair = authArr.find((a)=>a.key && a.value);
            if (authPair) authString = `${authPair.key}:${authPair.value}`;
        }
        // Set up fetch options
        const options = {
            method: method,
            headers: headersObject
        };
        if (authString) options.headers.Authorization = `Basic ${btoa(authString)}`;
        if (body && method !== 'GET') options.body = typeof body === 'string' ? body : JSON.stringify(body);
        // Prevent body from being added for GET requests
        if (method === 'GET') options.body = null;
        // Send the request
        return await fetch(url, options).then((response)=>{
            if (!response.ok) return reject(new Error(`Request failed with status ${response.status}: ${response.statusText}`));
            return response.json();
        }).then((data)=>{
            resolve(data);
        }).catch((error)=>reject(`Network error occurred: ${error.message}`)) // eslint-disable-line
        ;
    });
}

});

parcelRegister("fGu6z", function(module, exports) {

$parcel$export(module.exports, "followHost", () => $b6b2217656bb281a$export$4cae41899d37cd4);
$parcel$export(module.exports, "setFollowingUser", () => $b6b2217656bb281a$export$ab83b95a1a85fd11);
$parcel$export(module.exports, "askToFollow", () => $b6b2217656bb281a$export$338a839ad3ed7b62);
$parcel$export(module.exports, "clearFollowing", () => $b6b2217656bb281a$export$1a06b88eb3fad81);
function $b6b2217656bb281a$export$4cae41899d37cd4() {
    const { followingUser: followingUser, clients: clients } = this.getRootState();
    const data = this.getCanvasScope();
    const clientCanvas = clients?.[followingUser];
    const Collection = this.getCanvasCollection();
    if (!clientCanvas || !Collection) return;
    const { selected: clientSelected, chosen: clientChosen, openUrl: openUrl } = clientCanvas;
    if (data.openUrl !== openUrl) {
        data.openUrl = openUrl;
        if (openUrl) {
            if (data.openedWindow) data.openedWindow.close();
            data.openedWindow = window.open(openUrl);
        } else {
            (data.openedWindow || window)?.close();
            data.openedWindow = null;
        }
    }
    const { followingUser: skip, ...cleanData } = clientCanvas;
    this.call('overwrite', data, cleanData);
    if (this.getSelectedKey() !== clientSelected) this.activateSelected(clientSelected);
    if (this.getChosenKey() !== clientChosen) this.activateChosen(clientChosen);
    this.variables({
        previewSize: data.previewSize
    }).changed((_)=>{
        this.getChosenSceneNavbar().update();
    });
    this.variables({
        componentEditor: data.componentEditor
    }).changed((_)=>{
        this.setWindow('componentEditor', data.componentEditor);
    });
    this.variables({
        explorer: data.explorer
    }).changed((_)=>{
        this.setWindow('explorer', data.explorer);
    });
    this.variables({
        hoverLayer: data.hoverLayer,
        activeLayer: data.activeLayer
    }).changed((_)=>{
        this.getDynamicIsland().update({});
        this.getEditorPanels().parent.update({});
    });
}
async function $b6b2217656bb281a$export$ab83b95a1a85fd11(userId) {
    let { clients: clients } = this.getRootState();
    const client = clients?.[userId];
    if (!client || userId === this.getRootState('userId')) return;
    const followingUser = this.getRootState().followingUser === userId ? null : userId;
    this.syncCanvas({
        followingUser: followingUser
    }, {
        forceSendSocket: true
    });
}
function $b6b2217656bb281a$export$338a839ad3ed7b62(targetUserId) {
    const { clients: clients, userId: userId } = this.getRootState();
    if (userId === targetUserId) return;
    const client = clients?.[userId];
    if (!client) return;
}
function $b6b2217656bb281a$export$1a06b88eb3fad81() {
    const rootState = this.getRootState();
    if (!rootState.followingUser) return;
    rootState.followingUser = null;
}

});

parcelRegister("jEjO6", function(module, exports) {

$parcel$export(module.exports, "handleGoogleAuthResponse", () => $e4e11e0cdf6b7f00$export$959d81de844d6a99);
$parcel$export(module.exports, "checkGoogleOAuthCallback", () => $e4e11e0cdf6b7f00$export$d0e289255c18ec3e);
$parcel$export(module.exports, "handleGoogleRedirectFlow", () => $e4e11e0cdf6b7f00$export$e22b9c675d4bc1c5);
$parcel$export(module.exports, "processGoogleOAuthCode", () => $e4e11e0cdf6b7f00$export$5609dd01dc17dd7);

var $3rsQg = parcelRequire("3rsQg");
const $e4e11e0cdf6b7f00$var$PLUGIN_SESSION_STORAGE_KEY = 'plugin_auth_session';
const $e4e11e0cdf6b7f00$var$ensurePluginSession = ()=>{
    if (typeof window === 'undefined') return null;
    let session = null;
    try {
        session = new URL(window.location.href).searchParams.get('session');
    } catch  {
    // Ignore URL parsing errors
    }
    if (session) {
        try {
            if (window.localStorage) window.localStorage.setItem($e4e11e0cdf6b7f00$var$PLUGIN_SESSION_STORAGE_KEY, session);
        } catch  {
        // Ignore storage errors
        }
        return session;
    }
    try {
        if (window.localStorage) return window.localStorage.getItem($e4e11e0cdf6b7f00$var$PLUGIN_SESSION_STORAGE_KEY);
    } catch  {
    // Ignore storage errors
    }
    return null;
};
async function $e4e11e0cdf6b7f00$export$959d81de844d6a99(credential) {
    const state = this.getRootState();
    try {
        // Get invite token from localStorage instead of URL
        const inviteToken = localStorage.getItem('google_auth_invite_token');
        const pluginSession = $e4e11e0cdf6b7f00$var$ensurePluginSession();
        const loginResult = pluginSession ? await this.sdk.googleAuth(credential, inviteToken, {
            session: pluginSession
        }) : await this.sdk.googleAuth(credential, inviteToken);
        if (!loginResult) throw new Error('Invalid response from server');
        // Clean up the stored token
        localStorage.removeItem('google_auth_invite_token');
        this.call('applyLoader', {
            value: true,
            force: true,
            timeout: 1
        });
        await this.call('initializeUserSession', {
            loginData: loginResult
        }, this.getRootState(), this.sdk);
        state.update({
            loading: false
        });
        this.router('/dashboard');
    } catch (error) {
        console.error('Failed to sign in with Google:', error);
        // Clean up the stored token on error
        localStorage.removeItem('google_auth_invite_token');
        this.call('openNotification', {
            title: 'Failed to sign in',
            message: error.message,
            type: 'error'
        });
        state.update({
            loading: false
        });
    }
}
function $e4e11e0cdf6b7f00$export$d0e289255c18ec3e() {
    const state = this.getRootState();
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const stateParam = urlParams.get('state');
    const error = urlParams.get('error');
    const storedState = sessionStorage.getItem('google_oauth_state');
    if (error) {
        console.error('Google OAuth error:', error);
        this.call('openNotification', {
            title: 'Authentication failed',
            message: 'Google authentication was cancelled or failed.',
            type: 'error'
        });
        // Clean up URL
        window.history.replaceState({}, document.title, window.location.pathname);
        return;
    }
    if (code && stateParam) {
        // Verify state parameter
        if (stateParam !== storedState) {
            console.error('State parameter mismatch - possible CSRF attack');
            this.call('openNotification', {
                title: 'Security error',
                message: 'Authentication failed due to security check.',
                type: 'error'
            });
            window.history.replaceState({}, document.title, window.location.pathname);
            return;
        }
        // Clean up stored state
        sessionStorage.removeItem('google_oauth_state');
        // Clean up URL first
        window.history.replaceState({}, document.title, window.location.pathname);
        // Process the OAuth code
        this.call('processGoogleOAuthCode', code, this, state);
    }
}
function $e4e11e0cdf6b7f00$export$e22b9c675d4bc1c5() {
    try {
        // Store current URL to return to after auth
        sessionStorage.setItem('google_auth_return_url', window.location.href);
        $e4e11e0cdf6b7f00$var$ensurePluginSession();
        // Store invite token in localStorage instead of appending to redirect URI
        const currentUrl = new URL(window.location.href);
        const inviteToken = currentUrl.searchParams.get('token');
        if (inviteToken) localStorage.setItem('google_auth_invite_token', inviteToken);
        // Create the Google OAuth URL with clean redirect URI (no dynamic parameters)
        const clientId = (0, $3rsQg.environment).googleClientId;
        const redirectUri = `${window.location.origin}/google-auth-callback`;
        const encodedRedirectUri = encodeURIComponent(redirectUri);
        const scope = encodeURIComponent('openid email profile');
        const responseType = 'code';
        const oauthState = `google_oauth_${Math.random().toString(36).substr(2, 9)}`;
        // Store state to verify later
        sessionStorage.setItem('google_oauth_state', oauthState);
        const googleAuthUrl = `https://accounts.google.com/o/oauth2/v2/auth?` + `client_id=${clientId}&` + `redirect_uri=${encodedRedirectUri}&` + `response_type=${responseType}&` + `scope=${scope}&` + `state=${oauthState}&` + `access_type=offline&` + `prompt=consent`;
        // Redirect to Google OAuth
        window.location.href = googleAuthUrl;
    } catch (error) {
        console.error('Failed to initiate Google redirect flow:', error);
        // Clean up stored token on error
        localStorage.removeItem('google_auth_invite_token');
        this.call('openNotification', {
            title: 'Failed to sign in',
            message: 'Unable to connect to Google. Please try again.',
            type: 'error'
        });
    }
}
async function $e4e11e0cdf6b7f00$export$5609dd01dc17dd7(code) {
    const state = this.getRootState();
    try {
        state.update({
            loading: true
        });
        // Get invite token from localStorage instead of URL
        const inviteToken = localStorage.getItem('google_auth_invite_token');
        // Use clean redirect URI (no dynamic parameters)
        const redirectUri = `${window.location.origin}/google-auth-callback`;
        const pluginSession = $e4e11e0cdf6b7f00$var$ensurePluginSession();
        const loginResult = pluginSession ? await this.sdk.googleAuthCallback(code, redirectUri, inviteToken, {
            session: pluginSession
        }) : await this.sdk.googleAuthCallback(code, redirectUri, inviteToken);
        if (!loginResult) throw new Error('Invalid authentication response');
        // Clean up the stored token
        localStorage.removeItem('google_auth_invite_token');
        await this.call('initializeUserSession', {
            loginData: loginResult
        }, this.getRootState(), this.sdk);
        state.update({
            loading: false
        });
        this.router('/dashboard');
    } catch (error) {
        console.error('Failed to process Google OAuth code:', error);
        // Clean up stored token on error
        localStorage.removeItem('google_auth_invite_token');
        this.call('openNotification', {
            title: 'Authentication failed',
            message: error.message || 'Failed to complete Google sign-in.',
            type: 'error'
        });
        state.update({
            loading: false
        });
    }
}

});

parcelRegister("ddpF8", function(module, exports) {

$parcel$export(module.exports, "groupLog", () => groupLog);
$parcel$export(module.exports, "groupLogEnd", () => groupLogEnd);
$parcel$export(module.exports, "verbose", () => verbose);
$parcel$export(module.exports, "log", () => log);
$parcel$export(module.exports, "warn", () => warn);
$parcel$export(module.exports, "error", () => error);
function groupLog(...params) {
    // if (isNotProduction()) {
    console.group(...params);
// }
}
function groupLogEnd(...params) {
    // if (isNotProduction()) {
    console.groupEnd(...params);
// }
}
function verbose(element, ...args) {
    // if (isProduction()) return
    const parent = this;
    const { __ref: ref } = parent;
    console.groupCollapsed(parent.key);
    if (args.length) args.forEach((v)=>console.log(`%c${v}:\n`, 'font-weight: bold', parent[v]));
    else {
        console.log(ref.path);
        const keys = parent.keys();
        keys.forEach((v)=>console.log(`%c${v}:`, 'font-weight: bold', parent[v]));
    }
    console.log(parent);
    console.groupEnd(parent.key);
    return parent;
}
function log(...params) {
    // if (isProduction()) return
    console.log(...params);
}
function warn(...params) {
    // if (isProduction()) return
    const { hostname } = window.location;
    if (!hostname || hostname === 'localhost' || typeof window.symbols?.faro === 'undefined') return console.warn(...params, this);
    const { trace, context } = window.symbols.faro.api.getOTEL();
    const tracer = trace.getTracer('frontend-uikit-tracer');
    const span = tracer.startSpan('warning');
    context.with(trace.setSpan(context.active(), span), ()=>{
        console.warn(...params, this);
        span.end();
    });
}
function error(...params) {
    // if (isProduction()) return
    const logger = ()=>{
        const lastParam = params[params.length - 1];
        const hasOpts = typeof lastParam === 'object' && lastParam;
        if (hasOpts?.debugger) debugger; // eslint-disable-line
        if (hasOpts?.verbose) this.verbose.call(this, ...params);
        if (this.call('isFunction', hasOpts?.onError)) hasOpts?.onError.call(this, ...params);
        console.error(...params, this);
    };
    const { hostname } = window.location;
    if (!hostname || hostname === 'localhost' || typeof window.symbols?.faro === 'undefined') return logger();
    const { trace, context } = window.symbols.faro.api.getOTEL();
    const tracer = trace.getTracer('frontend-uikit-tracer');
    const span = tracer.startSpan('error');
    context.with(trace.setSpan(context.active(), span), ()=>{
        logger();
        span.end();
    });
}

});

parcelRegister("6x4bH", function(module, exports) {

$parcel$export(module.exports, "getProjectSharedLibraries", () => $4c1912c025a6a730$export$1270ca7c3894172b);
async function $4c1912c025a6a730$export$1270ca7c3894172b(maxDepth = 5) {
    if (maxDepth < 1) return [];
    const startId = this.getRootState('id');
    const queue = [
        {
            id: startId,
            depth: 0
        }
    ];
    const visited = new Set([
        startId
    ]);
    const librariesSet = new Set();
    while(queue.length > 0){
        const { id: currentId, depth: depth } = queue.shift();
        // Only process projects within the depth limit
        if (depth >= maxDepth) break; // Exit if we've reached the max depth
        try {
            // eslint-disable-next-line no-await-in-loop
            const libs = await this.sdk.getProjectLibraries(currentId);
            if (!libs || libs.length === 0) continue; // Skip if no libraries found
            for (const lib of libs){
                // Add library to result set
                if (!librariesSet.has(lib.id)) librariesSet.add(lib.id);
                // Enqueue if we haven't visited and within depth limit
                if (!visited.has(lib.id)) {
                    visited.add(lib.id);
                    // eslint-disable-next-line max-depth
                    if (depth + 1 < maxDepth) queue.push({
                        id: lib.id,
                        depth: depth + 1
                    });
                }
            }
        } catch (error) {
            console.error(`Error fetching libraries for ${currentId}:`, error);
        }
    }
    return Array.from(librariesSet);
}

});

parcelRegister("9e3m7", function(module, exports) {

$parcel$export(module.exports, "test", () => test);
$parcel$export(module.exports, "testAll", () => testAll);
$parcel$export(module.exports, "testIf", () => testIf);
$parcel$export(module.exports, "isEqual", () => isEqual);
$parcel$export(module.exports, "isEqualFunction", () => isEqualFunction);
$parcel$export(module.exports, "isEqualObject", () => isEqualObject);
$parcel$export(module.exports, "exists", () => exists);
$parcel$export(module.exports, "existsIf", () => existsIf);
$parcel$export(module.exports, "notExists", () => notExists);
$parcel$export(module.exports, "notExistsIf", () => notExistsIf);
$parcel$export(module.exports, "testCase", () => testCase);
function test(key, fn) {
    if (!this.getUserSettings('debuggingMode')) return;
    this.groupLog('Test results: ' + key);
    try {
        const exec = fn();
        if (!exec) {
            this.error('%c' + key + ' failed: Did not pass', fn);
            window.requestAnimationFrame(()=>{
                this.call('openNotification', {
                    title: key,
                    message: 'Did not pass, was not applied. Please check console for more details.',
                    type: 'error'
                });
            });
            this.groupLogEnd('Test results: ' + key);
            return;
        }
        this.log('%cTesting ' + key + ' passed!', 'color: green; font-weight: bold');
        this.groupLogEnd('Test results: ' + key);
        return exec;
    } catch (e) {
        this.error(key + ' failed:');
        this.error(e);
        window.requestAnimationFrame(()=>{
            this.call('openNotification', {
                title: key + ' failed:',
                message: e,
                type: 'error'
            });
        });
        this.groupLogEnd('Test results: ' + key);
    }
}
function testAll(key, fn) {
    return this.test(key, async ()=>{
        const arr = await this.call('exec', fn);
        if (!Array.isArray(arr)) {
            this.error('Test array is not an array');
            return false;
        }
        if (arr.length === 0) {
            this.error('Test array is empty');
            return false;
        }
        return arr.filter((v)=>v !== undefined).every((item)=>item);
    });
}
function testIf(condition, key, fn) {
    if (condition) return this.test(key, fn);
}
function isEqual(one, second, opts = {}) {
    this.log('%cChecking equality', 'color: gray');
    const isEqual1 = one === second;
    if (!isEqual1 && !opts.skipLogging) {
        this.error('Is not equal:');
        this.log(one);
        this.log(second);
    }
    return isEqual1;
}
function isEqualFunction(one, second, opts = {}) {
    this.log('%cChecking equality of functions', 'color: gray');
    const stringifiedOne = one.toString();
    const stringifiedTwo = second.toString();
    const isEqual = this.isEqual(stringifiedOne, stringifiedTwo);
    if (!isEqual && !opts.skipLogging) {
        this.error('Is not equal:');
        this.log(one);
        this.log(second);
    }
    return isEqual;
}
function isEqualObject(one, second, opts = {}) {
    this.log('%cChecking equality of objects', 'color: gray');
    const diff = this.call('isObjectLike', one) && this.call('isObjectLike', second) && this.call('diff', one, second, void 0, {
        cloneInstances: true
    }) || null;
    const isEqual = one && second && this.call('isObjectLike', diff) && Object.keys(diff).length === 0;
    if (!isEqual && !opts.skipLogging) {
        this.error('Is not equal:');
        this.log(one);
        this.log(second);
        this.log('With diff:');
        this.log(diff);
    }
    return isEqual;
}
function exists(value) {
    this.log('%cChecking value existence', 'color: gray');
    if (value === undefined) {
        this.error('Does not exist');
        return false;
    }
    return true;
}
function existsIf(condition, value) {
    this.log('%cChecking value existence if condition applies', 'color: gray');
    if (condition && value === undefined) {
        this.error('Does not exist');
        return false;
    }
    return true;
}
function notExists(value) {
    this.log('%cChecking value non-existence', 'color: gray');
    if (value) {
        this.error('Exists');
        return false;
    }
    return true;
}
function notExistsIf(condition, value) {
    this.log('%cChecking value non-existence', 'color: gray');
    if (condition && value !== undefined) {
        this.error('Exists');
        return false;
    }
    return true;
}
function testCase(descr, func, ...params) {
    this.groupLog(descr);
    const res = this.call(func, ...params);
    if (res) this.log('%cPassed', 'color: green');
    else this.error('%cFailed: ' + descr, 'color: red');
    this.groupLogEnd(descr);
    return res;
}

});

parcelRegister("7W54L", function(module, exports) {

$parcel$export(module.exports, "getDynamicIslandDataFromState", () => $5c71e3263aa85eac$export$42ea9827051fa810);
$parcel$export(module.exports, "getActiveDynamicIslandCategory", () => $5c71e3263aa85eac$export$aec2ed4623d3fdcd);
$parcel$export(module.exports, "getSidebarContent", () => $5c71e3263aa85eac$export$87165cad90b97844);
$parcel$export(module.exports, "setSidebarContent", () => $5c71e3263aa85eac$export$78d0518ff2f2c912);
$parcel$export(module.exports, "getActiveSidebarTypes", () => $5c71e3263aa85eac$export$8aef342f82ce0193);
$parcel$export(module.exports, "isTypeSidebarActive", () => $5c71e3263aa85eac$export$80ef19cb612ee08d);
$parcel$export(module.exports, "setActiveDynamicIslandCategory", () => $5c71e3263aa85eac$export$47a332ff9439102e);
$parcel$export(module.exports, "getDynamicIslandDataByCategory", () => $5c71e3263aa85eac$export$8591565595195dd);
$parcel$export(module.exports, "toggleRenameInput", () => $5c71e3263aa85eac$export$7803446a3292744a);
$parcel$export(module.exports, "findFileSidebarSection", () => $5c71e3263aa85eac$export$a8fbf76319c1014c);
$parcel$export(module.exports, "findFileSidebarItem", () => $5c71e3263aa85eac$export$92576e8fb3da665a);
$parcel$export(module.exports, "rerenderFileSidebarByType", () => $5c71e3263aa85eac$export$5c848c9737e2d4aa);
function $5c71e3263aa85eac$export$42ea9827051fa810() {
    const { designSystem: designSystem, state: state, components: components, snippets: snippets, pages: pages, functions: functions, methods: methods, files: files, dependencies: dependencies } = this.getData();
    return {
        designSystem: designSystem,
        state: state,
        components: components,
        snippets: snippets,
        pages: pages,
        functions: functions,
        methods: methods,
        files: files,
        dependencies: dependencies
    };
}
function $5c71e3263aa85eac$export$aec2ed4623d3fdcd() {
    return this.getFilesSidebar()?.state?.activeFileSidebar || 'Local';
}
function $5c71e3263aa85eac$export$87165cad90b97844() {
    return this.getFilesSidebar()?.state?.activeContent;
}
async function $5c71e3263aa85eac$export$78d0518ff2f2c912(activeContent) {
    if (this.isEmbed()) return;
    await this.getFilesSidebar()?.state.update({
        activeContent: activeContent
    });
    this.call('setCookie', this.getAppKey() + '_activeContent', activeContent);
    return activeContent;
}
function $5c71e3263aa85eac$export$8aef342f82ce0193(contentKey = this.call('getSidebarContent')) {
    return this.call('getTypes', contentKey);
}
function $5c71e3263aa85eac$export$80ef19cb612ee08d(type) {
    return this.call('getActiveSidebarTypes').includes(type);
}
function $5c71e3263aa85eac$export$47a332ff9439102e(category) {
    this.getFilesSidebar().state.update({
        activeFileSidebar: category
    });
}
async function $5c71e3263aa85eac$export$8591565595195dd(activeFileSidebar) {
    if (!activeFileSidebar) return;
    const category = activeFileSidebar.toLowerCase();
    if (category === 'local') return this.call('getDynamicIslandDataFromState');
    else if (category === 'builtins') return {} // BUILTINS_LIBRARY
    ;
    else if (category === 'shared libraries') return await this.getDefaultDesignSystem();
}
function $5c71e3263aa85eac$export$7803446a3292744a(type, key) {
    const listEl = this.getDynamicIsland().lookdown((el, s)=>s.key === key && s.type === type);
    if (!listEl) return;
    listEl.state.update({
        editing: true
    });
    const t = setTimeout(()=>{
        listEl.Rename.Label.Input.node.select();
        clearTimeout(t);
    }, 0);
}
function $5c71e3263aa85eac$export$a8fbf76319c1014c(type) {
    const sidebar = this.getFilesSidebar();
    if (!sidebar || typeof sidebar.lookdown !== 'function') return;
    return sidebar.lookdown((el, s)=>el.FilesSidebarList && s.type === type);
}
function $5c71e3263aa85eac$export$92576e8fb3da665a(type, key) {
    const section = this.call('findFileSidebarSection', type);
    if (!section) return;
    return section.lookdown((el, s)=>el.Rename && s.key === key);
}
async function $5c71e3263aa85eac$export$5c848c9737e2d4aa(type, opts) {
    if (!this.getFilesSidebar()) return;
    const section = this.call('findFileSidebarSection', type);
    if (!section) return;
    return await section.update({}, opts);
}

});

parcelRegister("3IQHm", function(module, exports) {

$parcel$export(module.exports, "openEditor", () => $2b5e5bf179ed5a53$export$2b9f6e10153464f5);
async function $2b5e5bf179ed5a53$export$2b9f6e10153464f5(type, key) {
    const item = this.getItem(key, type) || this.getSelected()?.state;
    if (!item) return;
    const scope = this.getCanvasScope();
    const path = scope.hoverLayer;
    this.syncCanvas();
    const showLayersSchema = scope.showLayersSchema || {};
    const componentShowLayersSchema = JSON.parse(JSON.stringify(showLayersSchema?.[item.key] || {}));
    if (!componentShowLayersSchema) return;
    const updateShowLayers = (schema, path)=>{
        let current = schema;
        current.showLayers = true;
        path?.some((key)=>{
            if (key[0] !== key[0].toLowerCase()) {
                if (current[key] === undefined) current[key] = {};
                current[key].showLayers = true;
                current = current[key];
            } else return true;
        });
    };
    updateShowLayers(componentShowLayersSchema, path);
    const isActive = this.call('arraysEqual', path, scope.activeLayer || []);
    showLayersSchema[item.key] = componentShowLayersSchema;
    scope.showLayersSchema = showLayersSchema;
    if (isActive) scope.activeLayer = null;
    else scope.activeLayer = path.filter((key)=>key[0] !== key[0].toLowerCase());
    if (scope.componentEditor === 'code') {
        this.changeCodePriority('component');
        await this.getComponentCodeEditor().update({}, new (this.call('sameOriginTop') || window).Object({
            preventUpdate: true,
            allowCodeSelection: true
        }));
    }
    this.syncCanvas();
    const isExplorerActive = Boolean(scope.explorer);
    const isExplorerArtboardsActive = scope.explorer === 'explorer:ARTBOARD_TYPES';
    if (isExplorerActive && !isExplorerArtboardsActive) this.setWindow('explorer', 'explorer:ARTBOARD_TYPES');
    if (!scope.explorer && !scope.editorActive) return;
    const t = setTimeout(async ()=>{
        const componentLayer = isExplorerActive ? this.call('findFileSidebarItem', item.type, item.key) : this.getQuickEditor();
        await componentLayer.state.update({
            showLayers: true
        });
        componentLayer.node.scrollIntoViewIfNeeded();
        // componentLayer.node.focus()
        clearTimeout(t);
    }, 350);
}

});

parcelRegister("5IOJd", function(module, exports) {

$parcel$export(module.exports, "handleClickAway", () => $42a869675a3ac282$export$73ded5ed92dd58c4);
function $42a869675a3ac282$export$73ded5ed92dd58c4(event) {
    function lookupUpDOM(element, targetKey) {
        const parentElement = element?.parentElement;
        const parentKey = parentElement?.getAttribute?.('key');
        if (!parentElement) return null;
        if (parentKey === targetKey) return parentElement;
        return lookupUpDOM(parentElement, targetKey);
    }
    // Don't close if clicking the panel or its trigger
    const isFloatingPanelChildren = lookupUpDOM(event?.target, 'FloatingPanel');
    if (isFloatingPanelChildren) return;
    const floatingPanelElement = this.getFloatingPanelElement();
    floatingPanelElement?.setNodeStyles?.({
        visibility: 'hidden',
        opacity: 0
    });
}

});

parcelRegister("87JX3", function(module, exports) {

var $jUeP5 = parcelRequire("jUeP5");

var $bJ3OQ = parcelRequire("bJ3OQ");

var $jveIp = parcelRequire("jveIp");

var $lS5Gf = parcelRequire("lS5Gf");

var $kZg00 = parcelRequire("kZg00");

var $38Yjx = parcelRequire("38Yjx");

var $h8gEn = parcelRequire("h8gEn");
$parcel$exportWildcard(module.exports, $jUeP5);
$parcel$exportWildcard(module.exports, $bJ3OQ);
$parcel$exportWildcard(module.exports, $jveIp);
$parcel$exportWildcard(module.exports, $lS5Gf);
$parcel$exportWildcard(module.exports, $kZg00);
$parcel$exportWildcard(module.exports, $38Yjx);
$parcel$exportWildcard(module.exports, $h8gEn);

});
parcelRegister("jUeP5", function(module, exports) {

$parcel$export(module.exports, "createItem", () => $e7debecd1965ae21$export$1f768fd5b3313118);
$parcel$export(module.exports, "createItemInSidebar", () => $e7debecd1965ae21$export$cc30d05b2e4fb9b3);
$parcel$export(module.exports, "createArtboardInCanvas", () => $e7debecd1965ae21$export$8f280cc1f84cee52);
$parcel$export(module.exports, "createItemInCanvas", () => $e7debecd1965ae21$export$e38d6b3a2f9fbc0);
$parcel$export(module.exports, "createItemInChosen", () => $e7debecd1965ae21$export$3234d7e1956cc367);
$parcel$export(module.exports, "createCanvasItem", () => $e7debecd1965ae21$export$651d04d0277dc388);
$parcel$export(module.exports, "createMultipleItems", () => $e7debecd1965ae21$export$3e8cca83d22abb50);
/**
 * Creates an item in the database
 */ function $e7debecd1965ae21$export$1f768fd5b3313118(type, key, forcedValue, opts = {}) {
    if (!type || !key) {
        this.error('Type or key is not defined for create operation');
        this.call('openNotification', {
            type: 'error',
            title: 'projectId is required',
            message: 'projectId is required for CollabService connection'
        });
        return;
    }
    type = this.getPlural(type);
    const item = this.call('isObject', forcedValue) && forcedValue.value ? forcedValue : this.call('getDefaultValuePerType', type, key);
    if (this.call('hasArtboard', type) || this.call('hasExecutable', type)) {
        const canvasPageChanges = this.call('returnAddedCanvasPageChanges', type, key);
        if (canvasPageChanges) opts.append = canvasPageChanges;
    }
    const res = this.sdk.addItem(type, item, opts);
    this.testAll(`Creating ${key} in ${type}`, ()=>[
            this.testCase('Item exists in root state', 'exists', this.getSchemaItem(key, type) && this.getDataItem(key, type))
        ]);
    return res;
}
async function $e7debecd1965ae21$export$cc30d05b2e4fb9b3(type, key) {
    const section = this.call('findFileSidebarSection', type);
    const List = section?.FilesSidebarList?.content;
    if (!section || !List) return this.error(`Section for type "${type}" not found in sidebar`);
    await section.FilesSidebarList.content.append({
        extends: 'FilesSidebarListItem',
        state: {
            key: key,
            type: type
        }
    }, `${List.__ref.__children.length}`);
}
async function $e7debecd1965ae21$export$8f280cc1f84cee52(type, key, opts) {
    if (!this.isCanvas()) return this.error('Creating artboard on canvas requires active canvas page');
    await this.call('createCanvasArtboard', type, key, opts);
    this.testAll(`Creating ${key} ${type} artboard in Canvas`, ()=>[
            this.testCase('Item exists on canvas', 'exists', this.call('findComponentOnCanvas', key)),
            this.testCase('Item was create in canvas page', 'existsIf', this.getActiveCanvasPage() !== 'Default', this.call('inOnCurrentCanvasPage', type, key))
        ]);
}
function $e7debecd1965ae21$export$e38d6b3a2f9fbc0(type, key) {
    if (!this.isCanvas()) this.warn('Creating on canvas requires active canvas page');
    const Collection = this.getCanvasCollection();
    if (!Collection) return this.error('Canvas Collection was not found');
    const frameWindow = this.getCanvasFrameWindow();
    const value = this.getDataItem(key, type);
    const newType = this.call('toTitleCase', typeof value);
    if (this.call('hasArtboard', type)) {
        new frameWindow[newType](value);
        Collection.context[type][key] = new frameWindow[newType](value);
    } else if (this.call('hasExecutable', type)) {
        if (!value) debugger;
        Collection.context[type][key] = value;
    }
}
function $e7debecd1965ae21$export$3234d7e1956cc367(type, key) {
    if (!this.isCanvas()) this.warn('Creating on canvas requires active canvas page');
    const chosen = this.getChosenKey();
    if (chosen) {
        const frameWindow = this.getCanvasFrameWindow();
        const value = this.getDataItem(key, type);
        const newType = this.call('toTitleCase', typeof value);
        const chosenContext = this.getChosenElementContext();
        if (this.call('hasArtboard', type)) chosenContext[type][key] = new frameWindow[newType](value);
        else if (this.call('hasExecutable', type)) chosenContext[type][key] = value;
    }
}
async function $e7debecd1965ae21$export$651d04d0277dc388(type, key, opts) {
    if (!this.isCanvas()) return this.error('Creating on canvas requires active canvas page');
    if (!type || !key) return this.error('Type or key is not defined for create operation');
    type = this.getPlural(type);
    await this.call('createItemInCanvas', type, key);
    await this.call('createItemInChosen', type, key);
    const testArr = [];
    const testFn = async ()=>{
        testArr.push(this.testCase('Item exists in canvas context', 'exists', this.getCanvasContext()[type][key]), this.testCase('Item exists in choosen context', 'existsIf', this.getChosenKey(), this.getChosenKey() && this.getChosenElementContext()[type][key]));
        if (!opts.skipSidebar) {
            await this.call('createItemInSidebar', type, key);
            testArr.push(this.testCase('Item exists in sidebar', 'existsIf', this.call('isTypeSidebarActive', type), this.call('findFileSidebarItem', type, key)));
        }
        return testArr;
    };
    this.testAll(`Creating ${key} ${type}`, testFn);
    if (this.call('hasArtboard', type)) await this.call('createArtboardInCanvas', type, key, opts);
}
async function $e7debecd1965ae21$export$3e8cca83d22abb50(items, opts = {}) {
    try {
        items.forEach((item)=>{
            const elementExisted = this.getSchemaItem(item.key, item.type);
            console.log(elementExisted);
            if (elementExisted) this.call('updateItem', item.type, item.key, item);
            else this.call('createItem', item.type, item.key, item);
        });
    } catch (error) {
        throw new Error(`Failed to create item: ${error.message}`);
    }
}

});

parcelRegister("bJ3OQ", function(module, exports) {

$parcel$export(module.exports, "updateItem", () => $8896dc128f4a5967$export$72b8c6d38aa6195b);
$parcel$export(module.exports, "updateItemInCanvas", () => $8896dc128f4a5967$export$4e61994633dece8d);
$parcel$export(module.exports, "updateItemInChosenWindow", () => $8896dc128f4a5967$export$b44bca6c907e900);
$parcel$export(module.exports, "updateItemInChosenPane", () => $8896dc128f4a5967$export$8fa2c675b05774e9);
$parcel$export(module.exports, "updateItemInSidebar", () => $8896dc128f4a5967$export$2c7325e3b23d4e86);
$parcel$export(module.exports, "updateCanvasItem", () => $8896dc128f4a5967$export$5fcc796bf7d7f953);
/**
 * Updates an item in the database with the specified value
 */ function $8896dc128f4a5967$export$72b8c6d38aa6195b(type, key, obj, opts = {}) {
    if (!type || !key) return this.error('Type or key is not defined for update operation');
    type = this.getPlural(type);
    const res = this.sdk.updateItem(type, obj, opts);
    window.requestAnimationFrame(()=>{
        if (this.call('hasExecutable', type)) this.testAll(`Updating ${key} in ${type}`, ()=>[
                this.testCase('Value equals item in root state', 'isEqualObject', {
                    ...obj.value.toString()
                }, {
                    ...this.getDataItem(key).toString()
                }),
                this.testCase('Schema equals item in root state', 'isEqualObject', obj, this.getItem(key))
            ]);
        else this.testAll(`Updating ${key} in ${type}`, ()=>[
                this.testCase('Value equals item in root state', 'isEqualObject', obj.value, this.getDataItem(key, type)),
                this.testCase('Schema equals item in root state', 'isEqualObject', obj, this.getItem(key, type))
            ]);
    });
    return res;
}
async function $8896dc128f4a5967$export$4e61994633dece8d(type, key, opts = {}) {
    if (!this.isCanvas()) {
        this.warn('Updating on canvas requires active canvas page');
        return;
    }
    type = this.getPlural(type);
    const Collection = this.getCanvasCollection();
    if (!Collection) return this.error('Canvas Collection was not found');
    const obj = this.getItem(key, type);
    let { value: value, code: code } = obj;
    const frameWindow = this.getCanvasFrameWindow();
    if (code) {
        if (this.call('isString', code) && code.includes('/////n')) code = this.call('decodeNewlines', code);
        value = this.call('evalStringCodeUnsafe', code, {
            ...opts,
            secrets: this.getSecrets(),
            window: frameWindow
        });
    } else value = this.call('deepClone', value, {
        window: frameWindow
    });
    if (!value) return this.error('Component can not be parsed during canvas creation');
    Collection.context[type][key] = value;
    if (this.call('hasArtboard', type)) {
        const objToUpdate = {
            ...obj,
            value: value
        };
        await this.call('refreshComponentOnCanvas', key, objToUpdate, opts);
    }
}
async function $8896dc128f4a5967$export$b44bca6c907e900(type, key) {
    if (!this.isCanvas()) {
        this.warn('Updating on canvas requires active canvas page');
        return;
    }
    type = this.getPlural(type);
    const data = this.getCanvasScope();
    if (data.previewSize === 'canvas') {
        const { ViewSvitcher: ViewSvitcher } = this.getChosenScene();
        await ViewSvitcher.content?.update();
    } else {
        const ChosenFrame = this.getChosenIframe();
        await ChosenFrame?.update();
    }
    // testing chosen in timeout
    // due to window.onload listener in Chosen iframe
    window.setTimeout(()=>{
        this.test(`Updating ${key} ${type} on canvas`, ()=>this.testCase('Value equals chosen context', 'isEqualObject', this.getDataItem(key, type), this.getChosenElementContext()?.[type][key]));
    }, 100);
}
function $8896dc128f4a5967$export$8fa2c675b05774e9(type, key, opts = {}) {
    if (!this.isCanvas()) {
        this.warn('Updating on canvas requires active canvas page');
        return;
    }
    type = this.getPlural(type);
    const obj = this.getItem(key, type);
    const { value: value } = obj;
    const ChosenElement = this.getChosenElement();
    ChosenElement.state.set({
        ...obj,
        value: value
    }, {
        skipChosenPane: opts.skipChosenPane,
        forceMonacoUpdate: true
    });
}
function $8896dc128f4a5967$export$2c7325e3b23d4e86(type, key, opts = {}) {
    if (!this.isCanvas()) {
        this.warn('Updating on canvas requires active canvas page');
        return;
    }
    type = this.getPlural(type);
    const item = this.call('findFileSidebarItem', type, key);
    if (!item || opts.preventItemSidebarUpdate) return;
    const value = this.getDataItem(key, type);
    item.state.replace({
        value: value
    }, {
        preventUpdate: !item.state.showLayers || opts.preventItemSidebarElementUpdate
    });
}
async function $8896dc128f4a5967$export$5fcc796bf7d7f953(type, key, opts = {}) {
    if (!type || !key) return this.error('Type or key is not defined for create operation');
    type = this.getPlural(type);
    // updating code editor panel
    const hasChosen = this.getChosenKey();
    if (!opts.skipCanvasUpdate) {
        if (hasChosen) {
            if (hasChosen === key || !opts.skipChosenPane) await this.call('updateItemInChosenPane', type, key, opts);
            else await this.call('updateItemInChosenWindow', type, key, opts);
            this.call('queueUpdateItemInCanvas', key);
        } else {
            if (!opts.skipChosenPane) await this.call('updateItemInChosenPane', type, key, opts);
            await this.call('updateItemInCanvas', type, key, opts);
        }
    }
    if (!opts.skipSidebar) await this.call('updateItemInSidebar', type, key, opts);
    if (opts.skipRuntimeTests) return;
    this.testAll(`Updating ${key} ${type} on canvas`, ()=>{
        const isExecutable = this.call('hasExecutable', type);
        const isArtboard = this.call('hasArtboard', type);
        const componentOnCanvas = !hasChosen && this.findComponentOnCanvas(key);
        return [
            this.testCase('Item value equals sidebar item value', isExecutable ? 'isEqualFunction' : 'isEqualObject', this.getDataItem(key, type), this.call('findFileSidebarItem', type, key)?.state.value),
            this.testCase('Value equals canvas context', isExecutable ? 'isEqualFunction' : 'isEqualObject', this.getDataItem(key, type), this.getCanvasContext()[type][key]),
            componentOnCanvas && this.testCase('Value equals code editor state', 'isEqualObject', this.getItem(key, type), this.getChosenElement().state.parse()),
            componentOnCanvas && this.testCase('Value equals canvas item state', 'isEqualObject', this.getItem(key, type), this.findComponentOnCanvas(key).state.parse())
        ];
    });
}

});

parcelRegister("jveIp", function(module, exports) {

$parcel$export(module.exports, "removeItemFromSidebar", () => $e32c53bc6819a757$export$4ff98033131be45c);
$parcel$export(module.exports, "removeItemFromCanvas", () => $e32c53bc6819a757$export$421de41880e8315a);
$parcel$export(module.exports, "removeItemFromChosen", () => $e32c53bc6819a757$export$30d82c64babf727);
$parcel$export(module.exports, "removeItem", () => $e32c53bc6819a757$export$fe2d9b4e03920b4c);
$parcel$export(module.exports, "removeCanvasArtboard", () => $e32c53bc6819a757$export$287a7f23707a14d6);
$parcel$export(module.exports, "removeCanvasExecutable", () => $e32c53bc6819a757$export$5faba700ec13f73e);
$parcel$export(module.exports, "removeAny", () => $e32c53bc6819a757$export$d9b41b2e1c1e6bb5);
// type = this.call('getType'),
// key = this.state.key
function $e32c53bc6819a757$export$4ff98033131be45c(type, key) {
    type = this.getPlural(type);
    const item = this.call('findFileSidebarItem', type, key);
    if (!item) return;
    item.remove();
    if (!this.call('hasItems', type)) this.call('rerenderFileSidebarByType', type);
}
function $e32c53bc6819a757$export$421de41880e8315a(type, key) {
    if (!this.isCanvas()) this.warn('Removing from canvas requires active canvas page');
    type = this.getPlural(type);
    const Collection = this.getCanvasCollection();
    if (!Collection) return this.error('Canvas Collection was not found');
    delete Collection.context[type][key];
}
function $e32c53bc6819a757$export$30d82c64babf727(type, key) {
    if (!this.isCanvas()) return this.warn('Removing from chosen requires active canvas page');
    type = this.getPlural(type);
    const editor = this.getComponentEditor();
    const functionEditor = editor.parent.FunctionEditor;
    if (functionEditor.state.key === key) this.call('activateFunction', null);
    const chosen = this.getChosenKey();
    const chosenContext = this.getChosenElementContext();
    if (chosen) this.getChosenScene().update();
    if (key === this.call('getChosenKey')) this.call('ativateChosen', null);
    if (!chosenContext) {
        if (chosen) this.error('Canvas Chosen is set but chosen context was not found');
        return;
    }
    if (chosen === key) this.activateChosen(null);
    delete chosenContext[type][key];
}
function $e32c53bc6819a757$export$fe2d9b4e03920b4c(type, key, opts = {}) {
    if (!type || !key) return this.error('Type or key is not defined for remove operation');
    type = this.getPlural(type);
    const confirmMsg = `Do you want to remove the "${key}" from ${type}?`;
    if (!opts.skipConfirmation && !window.confirm(confirmMsg)) return false;
    const isInDataOrSchema = this.getData(type)[key];
    if (!isInDataOrSchema) this.warn("Trying to remove but can't find in data", type, key);
    this.sdk.deleteItem(type, key, opts);
    this.call('removeItemFromCanvas', type, key);
    this.call('removeItemFromChosen', type, key);
    const testArr = [];
    const testFn = ()=>{
        testArr.push(this.testCase('Item exists in root state', 'notExists', this.getItem(key, type)), this.testCase('Item exists in canvas context', 'notExistsIf', this.call('isCanvas'), this.getCanvasContext()[type][key]), this.testCase('Item exists in chosen context', 'notExistsIf', this.call('isCanvas'), this.getChosenElementContext()?.[type][key]));
        if (!opts.skipSidebar) {
            this.call('removeItemFromSidebar', type, key);
            testArr.push(this.testCase('Item exists in sidebar', 'notExistsIf', this.call('isTypeSidebarActive', type), this.call('findFileSidebarItem', type, key)));
        }
    };
    // run tests if in debugging mode
    this.testAll(`Removing ${key} in ${type}`, testFn);
    return true;
}
function $e32c53bc6819a757$export$287a7f23707a14d6(type = this.getType(), key, opts = {}) {
    if (!type || !key) return this.error('Type or key is not defined for remove operation');
    type = this.getPlural(type);
    const referencedRemovalPermitted = this.call('checkIfReferencedInOtherCanvasItems', type, key);
    if (!referencedRemovalPermitted) return;
    const canvasPageChanges = this.call('returnRemovedCanvasPageChanges', type, key);
    if (canvasPageChanges) opts.append = canvasPageChanges;
    const removed = this.call('removeItem', type, key, opts);
    if (!removed) return;
    const found = this.findComponentOnCanvas(key);
    if (found?.node) {
        this.getCanvasFrameWindow().gs.removeWidget(found.node);
        found.remove();
    }
    if (referencedRemovalPermitted.length) this.call('refreshComponentsWhereReferencedOnCanvas', key);
    if (this.getSelectedKey() === key) this.activateSelected(null);
    this.testAll(`Removing ${key} in ${type}`, [
        this.testCase('Item exists in root state', 'notExists', this.getSchema(type)[key]),
        this.testCase('Item exists in canvas context', 'notExists', this.getCanvasContext()[type][key]),
        this.testCase('Item exists on canvas', 'notExists', this.findComponentOnCanvas(key)),
        this.testCase('Item was removed from canvas page', 'notExists', this.getActiveCanvasPage() !== 'Default' && this.call('onCurrentCanvasPage', type, key))
    ]);
    return true;
}
function $e32c53bc6819a757$export$5faba700ec13f73e(type, key, opts) {
    if (!type || !key) return this.error('Type or key is not defined for remove operation');
    type = this.getPlural(type);
    // TODO: find components that use this function
    // and prompt the confirmation
    const removed = this.call('removeItem', type, key, opts);
    if (!removed) return;
    const Canvas = this.getCanvas();
    Canvas.update();
    this.getChosenScene().update();
    return true;
}
function $e32c53bc6819a757$export$d9b41b2e1c1e6bb5(type, key, opts) {
    if (!type || !key) return this.error('Type or key is not defined for remove operation');
    type = this.getPlural(type);
    if (this.call('hasArtboard', type)) return this.call('removeCanvasArtboard', type, key, opts);
    else if (this.call('hasExecutable', type)) return this.call('removeCanvasExecutable', type, key, opts);
    return this.call('removeItem', type, key, opts);
}

});

parcelRegister("lS5Gf", function(module, exports) {

$parcel$export(module.exports, "getTypes", () => $fec30c1f80078856$export$e1d41611756c6326);
$parcel$export(module.exports, "hasType", () => $fec30c1f80078856$export$f4e222cb4ec295d5);
$parcel$export(module.exports, "getWhichKey", () => $fec30c1f80078856$export$888f5ebd0ea35a46);
$parcel$export(module.exports, "hasItems", () => $fec30c1f80078856$export$97057de2cd25fb57);
$parcel$export(module.exports, "hasArtboard", () => $fec30c1f80078856$export$803ee7a26cf75791);
$parcel$export(module.exports, "hasExecutable", () => $fec30c1f80078856$export$5d65de9976e572db);
function $fec30c1f80078856$export$e1d41611756c6326(key) {
    const ARTBOARD_TYPES = [
        'pages',
        'components'
    ];
    // const COMPONENT_TYPES = ['components']
    // const PAGE_TYPES = ['pages']
    const STATE_TYPES = [
        'state'
    ];
    const ASSETS_TYPES = [
        'files'
    ];
    const FUNCTION_TYPES = [
        'functions',
        'methods',
        'snippets'
    ];
    const INTEGRATIONS_TYPES = [
        'dependencies',
        'secrets'
    ];
    const COLOR_TYPES = [
        'color',
        'gradient',
        'semantic_color',
        'global_theme',
        'theme'
    ];
    const TYPOGRAPHY_TYPES = [
        'typography',
        'font',
        'font_family',
        'type_templates'
    ];
    const ICON_TYPES = [
        'icons'
    ];
    const SPACING_TYPES = [
        'spacing',
        'shape'
    ];
    const RESPONSIVE_TYPES = [
        'media'
    ];
    const TRANSITION_TYPES = [
        'animations',
        'transitions'
    ];
    const DESIGN_SYSTEM_TYPES = [
        ...COLOR_TYPES,
        ...TYPOGRAPHY_TYPES,
        ...ICON_TYPES,
        ...SPACING_TYPES,
        ...RESPONSIVE_TYPES,
        ...TRANSITION_TYPES
    ];
    const DATA_TYPES = [
        ...ARTBOARD_TYPES,
        ...STATE_TYPES,
        ...ASSETS_TYPES,
        ...FUNCTION_TYPES,
        ...INTEGRATIONS_TYPES
    ];
    const ALL_TYPES = [
        ...ARTBOARD_TYPES,
        ...STATE_TYPES,
        ...ASSETS_TYPES,
        ...FUNCTION_TYPES,
        ...INTEGRATIONS_TYPES,
        ...DESIGN_SYSTEM_TYPES
    ];
    const typeMap = {
        ALL_TYPES: ALL_TYPES,
        DATA_TYPES: DATA_TYPES,
        ARTBOARD_TYPES: ARTBOARD_TYPES,
        STATE_TYPES: STATE_TYPES,
        ASSETS_TYPES: ASSETS_TYPES,
        FUNCTION_TYPES: FUNCTION_TYPES,
        INTEGRATIONS_TYPES: INTEGRATIONS_TYPES,
        COLOR_TYPES: COLOR_TYPES,
        TYPOGRAPHY_TYPES: TYPOGRAPHY_TYPES,
        ICON_TYPES: ICON_TYPES,
        SPACING_TYPES: SPACING_TYPES,
        RESPONSIVE_TYPES: RESPONSIVE_TYPES,
        TRANSITION_TYPES: TRANSITION_TYPES,
        DESIGN_SYSTEM_TYPES: DESIGN_SYSTEM_TYPES
    };
    return key ? typeMap[key] : typeMap;
}
function $fec30c1f80078856$export$f4e222cb4ec295d5(key, type) {
    const types = this.call('getTypes', key);
    return types.includes(type);
}
function $fec30c1f80078856$export$888f5ebd0ea35a46(type) {
    const typeMap = this.call('getTypes') // get the full map
    ;
    const keys = Object.keys(typeMap);
    // Skip ALL_TYPES since it's just an aggregate
    const filteredKeys = keys.filter((k)=>k !== 'ALL_TYPES');
    const foundIn = filteredKeys.filter((key)=>{
        const list = typeMap[key];
        return Array.isArray(list) && list.includes(type);
    });
    return foundIn;
}
function $fec30c1f80078856$export$97057de2cd25fb57(type) {
    const hasData = this.getData(type);
    return Boolean(hasData && Object.keys(hasData).length > 0);
}
function $fec30c1f80078856$export$803ee7a26cf75791(type) {
    return this.call('hasType', 'ARTBOARD_TYPES', type);
}
function $fec30c1f80078856$export$5d65de9976e572db(type) {
    return this.call('hasType', 'FUNCTION_TYPES', type);
}

});

parcelRegister("kZg00", function(module, exports) {

$parcel$export(module.exports, "duplicateItem", () => $f475ea41df4988ff$export$67c53289288d8c33);
async function $f475ea41df4988ff$export$67c53289288d8c33(type, key, forcedValue, opts) {
    if (!type || !key) return this.error('Type or key is not defined for create operation');
    const item = this.call('deepClone', forcedValue?.value ? forcedValue : this.call('getItem', key, type));
    if (!item) {
        this.call('openNotification', {
            type: 'error',
            title: 'Could not find target element',
            message: `We could not find ${key} in ${type}`
        });
        return this.error('Could not find target element');
    }
    const altKey = this.call('findNewName', type, key);
    if (!altKey) {
        this.call('openNotification', {
            type: 'error',
            title: 'Could not duplicate',
            message: `We could not rename ${key} to ${altKey}`
        });
        return this.error('Could not duplicate');
    }
    item.key = altKey;
    if (this.call('hasArtboard', type)) {
        if (item.settings.gridOptions.y) item.settings.gridOptions.y += 2;
    }
    await this.call('createItem', type, altKey, item, opts);
    this.testAll(`Duplicating ${key} as ${altKey} in ${type}`, ()=>[
            this.testCase('Item exists in root state', 'exists', this.getSchemaItem(altKey, type) && this.getDataItem(altKey, type))
        ]);
    return item;
}

});

parcelRegister("38Yjx", function(module, exports) {

$parcel$export(module.exports, "renameItemInSidebar", () => $24a0e79b47e1be75$export$9b435b8df4debf7a);
$parcel$export(module.exports, "rename", () => $24a0e79b47e1be75$export$7ac989ec0c9c279);
function $24a0e79b47e1be75$export$9b435b8df4debf7a(type, key1, newKey) {
    type = this.getPlural(type);
    const item = this.call('findFileSidebarItem', type, key1);
    if (!item) return;
    item.state.update({
        key: newKey
    });
}
async function $24a0e79b47e1be75$export$7ac989ec0c9c279(type, oldKey, newKey) {
    if (!type || !oldKey || !newKey) return this.error('Type, old name or new name is not defined for rename operation');
    type = this.getPlural(type);
    const confirmMsg = `Do you want to rename "${oldKey}" to "${newKey}" in ${type}?`;
    if (!window.confirm(confirmMsg)) return false;
    let item = this.call('getItem', oldKey, type);
    if (!item) {
        this.call('openNotification', {
            type: 'error',
            title: 'Could not find target element',
            message: `We could not find ${oldKey} in ${type}`
        });
        return this.error('Could not find target element');
    }
    if (this.call('getItem', newKey, type)) {
        this.call('openNotification', {
            type: 'error',
            title: 'Could not rename',
            message: `We could not rename to ${newKey} as it already exists`
        });
        return this.error('Could not rename');
    }
    item = this.call('deepClone', item);
    item.key = newKey;
    this.call('removeAny', type, oldKey, {
        skipConfirmation: true,
        skipSidebar: true
    }) // add skipSidebar, skipConfirmation
    ;
    this.call('createItem', type, newKey, item, {
        skipSidebar: true
    });
    this.call('renameItemInSidebar', type, key, newKey);
}

});

parcelRegister("h8gEn", function(module, exports) {

$parcel$export(module.exports, "delegateArtboardUpdate", () => $c7901965eaf59788$export$f400ac37a66283ae);
$parcel$export(module.exports, "delegateExecutableUpdate", () => $c7901965eaf59788$export$f6703f77fe0f17b0);
$parcel$export(module.exports, "delegateSingleUpdate", () => $c7901965eaf59788$export$2b1d43de83771646);
$parcel$export(module.exports, "delegateTypeUpdate", () => $c7901965eaf59788$export$ade1e1cd2d622c06);
$parcel$export(module.exports, "delegateUpdates", () => $c7901965eaf59788$export$d84508fc0bdb9e5a);
async function $c7901965eaf59788$export$f400ac37a66283ae(type, key, opts = {}) {
    const Collection = this.getCanvasCollection();
    const componentExists = Boolean(Collection?.context?.[type]?.[key]);
    if (!componentExists) await this.call('createCanvasItem', type, key, opts);
    else if (this.inOnCurrentCanvasPage(type, key)) await this.call('updateCanvasItem', type, key, opts);
    else await this.refreshComponentsWhereReferencedOnCanvas(key);
}
async function $c7901965eaf59788$export$f6703f77fe0f17b0(type, key, opts = {}) {
    const Collection = this.getCanvasCollection();
    const executableExists = Boolean(Collection.context[type][key]);
    if (!executableExists) await this.call('createCanvasItem', type, key, opts);
    else await this.call('updateCanvasItem', type, key, opts);
}
async function $c7901965eaf59788$export$2b1d43de83771646(type, key, opts = {}) {
    if (this.call('hasArtboard', type)) await this.call('delegateArtboardUpdate', type, key, opts);
    else if (this.call('hasExecutable', type)) await this.call('delegateExecutableUpdate', type, key, opts);
    this.addIfPlatformProject(type, key);
}
async function $c7901965eaf59788$export$ade1e1cd2d622c06(type, typeData, opts = {}) {
    if (!this.hasItems(type)) return;
    for(const key in typeData)await this.call('delegateSingleUpdate', type, key, opts);
}
async function $c7901965eaf59788$export$d84508fc0bdb9e5a(changes, opts = {}) {
    const hasSchema = Boolean(changes.schema);
    const hasDataTypes = Object.keys(changes).some((type)=>this.hasItems(type));
    if (!hasDataTypes && hasSchema) changes = changes.schema;
    for(const type in changes){
        const typeData = changes[type];
        await this.call('delegateTypeUpdate', type, typeData, {
            changes: changes,
            ...opts
        });
    }
}

});



parcelRegister("lq26P", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "state", () => $f97da985aa631574$export$ca000e230c0caa3e);
$parcel$export(module.exports, "globalState", () => $f97da985aa631574$export$8e769ad4338a911e);
$parcel$export(module.exports, "optionsState", () => $f97da985aa631574$export$de10ebaa839757cf);
$parcel$export(module.exports, "default", () => $f97da985aa631574$export$2e2bcd8739ae039);
parcelRequire("2oe0q");
var $hO2Rt = parcelRequire("hO2Rt");
parcelRequire("b4H9z");
const [, $f97da985aa631574$var$embed] = window.location.pathname.split('/');
const $f97da985aa631574$var$isEmbed = $f97da985aa631574$var$embed === 'embed';
const $f97da985aa631574$var$urlParams = new URLSearchParams(window.location.search);
const $f97da985aa631574$var$globalTheme = $f97da985aa631574$var$urlParams.get('globalTheme');
const $f97da985aa631574$var$followingUser = $f97da985aa631574$var$urlParams.get('followingUser');
const $f97da985aa631574$var$selected = $f97da985aa631574$var$urlParams.get('selected');
// @preserve-env
const $f97da985aa631574$var$ENV = "upcoming";
const $f97da985aa631574$export$ca000e230c0caa3e = {
    isRootState: true,
    isEmbed: $f97da985aa631574$var$isEmbed,
    // shareRootStateOnCanvas: true,
    ENV: (0, $hO2Rt.getCookie)('ENV') || $f97da985aa631574$var$ENV || 'development',
    // DEFAULTS: {
    //   DS_DEFAULTS,
    //   DATA_DEFAULTS,
    //   SETTINGS_DEFAULTS
    // },
    // ...deepClone(DATA_DEFAULTS),
    // schema: deepClone(DATA_DEFAULTS),
    canvas: {
        clients: {},
        pages: {}
    },
    settings: {
        remote: false,
        async: false,
        inspect: true,
        liveSync: true,
        syncCanvas: true
    },
    sampleText: 'Today is a big day for our tribe. The year ends.',
    framework: (0, $hO2Rt.getCookie)('framework') || 'symbols',
    pkgManager: (0, $hO2Rt.getCookie)('pkgManager') || 'npm',
    language: (0, $hO2Rt.getCookie)('language') || 'js',
    installTab: (0, $hO2Rt.getCookie)('installTab') || 'local',
    followingUser: $f97da985aa631574$var$followingUser,
    selected: $f97da985aa631574$var$selected,
    notifications: [],
    sync: true,
    syncDesignSystem: true,
    syncState: true,
    syncComponents: true,
    syncPages: true,
    syncSnippets: true,
    syncSchema: true,
    chosenQueue: [],
    sharedLibrary: null,
    user: {
        smblsFromLocal: (0, $hO2Rt.getCookie)('smblsFromLocal') === 'true',
        topNavbarActive: (0, $hO2Rt.getCookie)('topNavbarActive') !== 'false',
        bottomNavbarActive: (0, $hO2Rt.getCookie)('bottomNavbarActive') === 'true',
        allowTitleOnArtboard: (0, $hO2Rt.getCookie)('allowTitleOnArtboard') !== 'false',
        autoSaveSettings: (0, $hO2Rt.getCookie)('autoSaveSettings') !== 'false',
        isSidebarSticky: (0, $hO2Rt.getCookie)('isSidebarSticky') === 'true',
        autoCleanConsole: (0, $hO2Rt.getCookie)('autoCleanConsole') === 'true',
        componentShowFilter: (0, $hO2Rt.getCookie)('componentShowFilter') || 'all',
        navbarPlacement: (0, $hO2Rt.getCookie)('navbarPlacement') || 'right',
        presentMode: (0, $hO2Rt.getCookie)('presentMode') !== 'false',
        showErrorBanner: (0, $hO2Rt.getCookie)('showErrorBanner') !== 'false',
        thumbnailPreview: (0, $hO2Rt.getCookie)('thumbnailPreview') === 'true',
        optimizedMode: (0, $hO2Rt.getCookie)('optimizedMode') === 'true',
        showGrid: (0, $hO2Rt.getCookie)('showGrid') === 'true',
        explorerAutoscroll: (0, $hO2Rt.getCookie)('explorerAutoscroll') !== 'false',
        debuggingMode: (0, $hO2Rt.getCookie)('debuggingMode') === 'true',
        useGlassmorphism: (0, $hO2Rt.getCookie)('useGlassmorphism') !== 'false',
        allowAutoPosition: (0, $hO2Rt.getCookie)('allowAutoPosition') !== 'false',
        allowInitialSelection: (0, $hO2Rt.getCookie)('allowInitialSelection') !== 'false',
        allowTabs: (0, $hO2Rt.getCookie)('allowTabs') !== 'false',
        showReferences: (0, $hO2Rt.getCookie)('showReferences') !== 'false',
        allowTeamCursors: (0, $hO2Rt.getCookie)('allowTeamCursors') !== 'false',
        allowFilesidebarPreview: (0, $hO2Rt.getCookie)('allowFilesidebarPreview') !== 'false',
        allowTabPreview: (0, $hO2Rt.getCookie)('allowTabPreview') !== 'false',
        useAnimations: (0, $hO2Rt.getCookie)('useAnimations') !== 'false',
        allowZoombar: (0, $hO2Rt.getCookie)('allowZoombar') !== 'false',
        zoomLevel: (0, $hO2Rt.getCookie)('zoomLevel') || 1,
        assistant: (0, $hO2Rt.getCookie)('assistant') !== 'false',
        openOnDblClick: (0, $hO2Rt.getCookie)('openOnDblClick') === 'true',
        autoSelectSidebar: (0, $hO2Rt.getCookie)('autoSelectSidebar') === 'true',
        allowCanvasReplaceRouter: (0, $hO2Rt.getCookie)('allowCanvasReplaceRouter') !== 'false',
        languageDirection: (0, $hO2Rt.getCookie)('languageDirection') || 'ltr',
        editorPanelsAtRight: (0, $hO2Rt.getCookie)('editorPanelsAtRight') === 'true'
    },
    sharedLibraries: [],
    clients: {
        localhost: {},
        cli: {},
        platform: {}
    },
    seats: 1,
    loading: true
};
const $f97da985aa631574$export$8e769ad4338a911e = $f97da985aa631574$export$ca000e230c0caa3e;
const $f97da985aa631574$export$de10ebaa839757cf = $f97da985aa631574$export$ca000e230c0caa3e;
var $f97da985aa631574$export$2e2bcd8739ae039 = $f97da985aa631574$export$ca000e230c0caa3e;

});
parcelRegister("b4H9z", function(module, exports) {
const $81018ac8d560710f$export$e79573a1cd412b48 = {};
const $81018ac8d560710f$export$9d2f44153ac70a91 = {
    designSystem: {},
    components: {},
    integrations: {},
    snippets: {},
    pages: {},
    state: {},
    files: {},
    dependencies: {},
    methods: {},
    functions: {},
    secrets: {}
};
const $81018ac8d560710f$export$682df56aa4d8a46e = {
    remote: false,
    async: false,
    inspect: true,
    liveSync: true,
    syncCanvas: true
};

});



parcelRegister("g3lIy", function(module, exports) {

$parcel$export(module.exports, "grants", () => (parcelRequire("7m9HM")));
// Root export for @symbo.ls/finance-features. Currently surfaces the
// grants feature; extend as compensation, cap-table, and vesting
// features migrate in.

var $7m9HM = parcelRequire("7m9HM");

});
parcelRegister("7m9HM", function(module, exports) {

$parcel$export(module.exports, "GRANTS_CONFIG", () => (parcelRequire("bEP4Q")).GRANTS_CONFIG);
$parcel$export(module.exports, "grantsClient", () => (parcelRequire("i9I9s")).grantsClient);
$parcel$export(module.exports, "grantsAvailable", () => (parcelRequire("i9I9s")).grantsAvailable);
$parcel$export(module.exports, "listGrants", () => (parcelRequire("2PNsc")).listGrants);
$parcel$export(module.exports, "getGrantDetail", () => (parcelRequire("2PNsc")).getGrantDetail);
$parcel$export(module.exports, "createGrant", () => (parcelRequire("2PNsc")).createGrant);
$parcel$export(module.exports, "updateGrant", () => (parcelRequire("2PNsc")).updateGrant);
$parcel$export(module.exports, "voidGrant", () => (parcelRequire("2PNsc")).voidGrant);
$parcel$export(module.exports, "listCapTableRows", () => (parcelRequire("2PNsc")).listCapTableRows);
$parcel$export(module.exports, "listValuations", () => (parcelRequire("2PNsc")).listValuations);
$parcel$export(module.exports, "getCurrentValuation", () => (parcelRequire("2PNsc")).getCurrentValuation);
$parcel$export(module.exports, "getCompanySettings", () => (parcelRequire("2PNsc")).getCompanySettings);
$parcel$export(module.exports, "updateCompanySettings", () => (parcelRequire("2PNsc")).updateCompanySettings);
// Public surface for finance-features/grants. Import from here — do
// not reach into ./queries or ./client directly.

var $bEP4Q = parcelRequire("bEP4Q");

var $i9I9s = parcelRequire("i9I9s");

var $2PNsc = parcelRequire("2PNsc");

});
parcelRegister("bEP4Q", function(module, exports) {

$parcel$export(module.exports, "GRANTS_CONFIG", () => $87cb0cfabc2e4384$export$541fb1453804b57a);
// Every feature package declares its Supabase project here. The
// federation layer (sdk-bridge) uses this to route all data access
// through the correct client.
parcelRequire("gx7yq");
var $25Rht = parcelRequire("25Rht");
const $87cb0cfabc2e4384$export$541fb1453804b57a = {
    projectName: (0, $25Rht.PROJECT_FINANCIALS),
    // The canonical table set for grants lives in the financials project.
    // Names kept identical to current collab-project schema for a
    // zero-refactor migration (Phase 2 — dual-write + cutover).
    tables: {
        grants: 'grants',
        grantEvents: 'grant_events',
        valuations: 'valuations',
        companySettings: 'company_settings'
    }
};

});
parcelRegister("gx7yq", function(module, exports) {

$parcel$export(module.exports, "PROJECT_FINANCIALS", () => (parcelRequire("25Rht")).PROJECT_FINANCIALS);
$parcel$export(module.exports, "getClient", () => (parcelRequire("av2lU")).getClient);
// Public surface for @symbo.ls/sdk-bridge-governance. Everything the
// rest of the workspace app needs comes from here. Deep imports into
// subpaths are discouraged — keep the federation layer's internals
// internal.
//
// The abstract registry + Supabase auth primitives live in
// @symbo.ls/sdk-bridge and @symbo.ls/sdk-supabase-bridge. This package
// owns ONLY governance/financials project glue + integrations + MCP +
// prefs + cross-app peer routing.

var $25Rht = parcelRequire("25Rht");

var $av2lU = parcelRequire("av2lU");

var $db3Gy = parcelRequire("db3Gy");

var $fP7Jb = parcelRequire("fP7Jb");

var $8pgLC = parcelRequire("8pgLC");

var $6VD0V = parcelRequire("6VD0V");

var $4ydpI = parcelRequire("4ydpI");
const $c095968a2375aea4$export$d90c31306ea565a5 = ()=>(0, $av2lU.getClient)((0, $25Rht.PROJECT_GOVERNANCE));
const $c095968a2375aea4$export$dd45a343b6ac2ea2 = async ()=>(0, $av2lU.getClient)((0, $25Rht.PROJECT_GOVERNANCE));
const $c095968a2375aea4$export$973cffe86a0bea52 = $c095968a2375aea4$export$dd45a343b6ac2ea2;
const $c095968a2375aea4$export$b9a931cef18d6e89 = null;
const $c095968a2375aea4$export$22374d636991e1aa = null;
const $c095968a2375aea4$export$9ca20373711d1316 = null;
const $c095968a2375aea4$export$99634018ea086848 = null;

});
parcelRegister("25Rht", function(module, exports) {

$parcel$export(module.exports, "PROJECT_GOVERNANCE", () => $186560e04962d2d0$export$a54df3be54843d98);
$parcel$export(module.exports, "PROJECT_FINANCIALS", () => $186560e04962d2d0$export$2a07fd4d32fd5eae);
$parcel$export(module.exports, "_getFederationRegistry", () => $186560e04962d2d0$export$7b53e0b4690c41e6);
$parcel$export(module.exports, "configure", () => $186560e04962d2d0$export$8d21e34596265fa2);
$parcel$export(module.exports, "getAppConfig", () => $186560e04962d2d0$export$544aaded68bb6ae2);
// Governance + financials project registry. The federation primitives
// (registry creation, env-var conventions, app-config) live in
// @symbo.ls/sdk-supabase-bridge. This module owns ONLY the project-
// specific pieces: PROJECT_* constants, governance fallback secrets, and
// the activation predicates that decide whether each project's bridge
// should fire on login.
parcelRequire("e11aL");
var $qBiAs = parcelRequire("qBiAs");
var $cCMxT = parcelRequire("cCMxT");
parcelRequire("cVasv");
var $eEI3K = parcelRequire("eEI3K");
const $186560e04962d2d0$export$a54df3be54843d98 = 'governance';
const $186560e04962d2d0$export$2a07fd4d32fd5eae = 'financials';
// Hardcoded fallbacks — the current governance credentials the workspace
// app used before env-based config existed. Keeping them ensures zero
// behavior change on first deploy. Remove once every workspace build
// consistently supplies env vars.
const $186560e04962d2d0$var$GOVERNANCE_FALLBACK = {
    url: 'https://becrzpqaiovbvfmrosro.supabase.co',
    anonKey: 'sb_publishable_suMZ-1Crw-304sk_MY-VZA_8aU6ZFfa',
    anonJwt: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJlY3J6cHFhaW92YnZmbXJvc3JvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzU2MzE1NzAsImV4cCI6MjA5MTIwNzU3MH0.0vvvM-z9MJ2Zl2AhLBS-7gZ_eEci-GRDrFaFrdWD41U'
};
const $186560e04962d2d0$var$PROJECT_DESCRIPTORS = [
    {
        key: $186560e04962d2d0$export$a54df3be54843d98,
        opts: {
            required: true,
            fallback: $186560e04962d2d0$var$GOVERNANCE_FALLBACK,
            accessTokenTTL: 600,
            // Only fire governance if the user has at least one team-org
            // membership. Personal orgs (auto-created per-user) don't get a
            // workspace surface — landing a freshly-signed-up user with only
            // a personal org on a governance session is pure cold-start
            // waste. Apps that DO want governance unconditionally (admin
            // consoles) can override with `configure({ required: ['governance'] })`
            // which bypasses shouldActivate for required projects.
            shouldActivate: (claims)=>{
                const orgs = Array.isArray(claims?.orgs) ? claims.orgs : [];
                if (!orgs.length) return false;
                const hasType = orgs.some((o)=>o.type != null);
                if (!hasType) return true // claim not yet populated — activate
                ;
                return orgs.some((o)=>o.type === 'team');
            }
        }
    },
    {
        key: $186560e04962d2d0$export$2a07fd4d32fd5eae,
        opts: {
            required: false,
            accessTokenTTL: 300,
            roleGate: [
                'admin',
                'owner'
            ],
            // Fire the financials bridge only when governance says the user
            // is an org admin OR holds a financials-related permission. Non-
            // admin non-grantees never touch the financials bridge — saves
            // a cold-start every login.
            //
            // Grantee check: governance bridge writes `hasFinanceGrant` (camelCase)
            // into app_metadata; the old snake_case alias `has_finance_grant` is
            // preserved for backwards-compat with stale JWTs. Per CU-9 §79 both
            // are being retired in favour of explicit `financials.*` permission
            // keys in `permissions[]` — check all three so the transition is safe.
            shouldActivate: (claims)=>{
                const role = claims?.symbols_role;
                if (role === 'admin' || role === 'owner') return true;
                if (claims?.hasFinanceGrant === true) return true;
                if (claims?.has_finance_grant === true) return true;
                const perms = Array.isArray(claims?.permissions) ? claims.permissions : [];
                if (perms.some((p)=>p.startsWith('financials.'))) return true;
                return false;
            }
        }
    }
];
// Cached registry — call `resetRegistry()` in tests to force rebuild.
// Two-stage caching keeps the abstract registry's client cache intact
// across `getRegistry()` calls (no rebuild = no client churn).
let $186560e04962d2d0$var$_registryConfig = null;
let $186560e04962d2d0$var$_registry = null;
const $186560e04962d2d0$var$_ensureRegistry = ()=>{
    if ($186560e04962d2d0$var$_registry) return $186560e04962d2d0$var$_registry;
    $186560e04962d2d0$var$_registryConfig = (0, $qBiAs.buildRegistryConfig)($186560e04962d2d0$var$PROJECT_DESCRIPTORS);
    $186560e04962d2d0$var$_registry = (0, $eEI3K.createRegistry)({
        projects: $186560e04962d2d0$var$_registryConfig,
        defaultKey: $186560e04962d2d0$export$a54df3be54843d98,
        buildClient: (0, $cCMxT.createSupabaseClient)
    });
    return $186560e04962d2d0$var$_registry;
};
const $186560e04962d2d0$export$39d7fc5adc3c75a1 = ()=>{
    $186560e04962d2d0$var$_ensureRegistry();
    return $186560e04962d2d0$var$_registryConfig;
};
const $186560e04962d2d0$export$b668408ac8206d2f = ()=>{
    $186560e04962d2d0$var$_registryConfig = null;
    $186560e04962d2d0$var$_registry = null;
    $186560e04962d2d0$var$_appConfig = null;
};
const $186560e04962d2d0$export$7b53e0b4690c41e6 = ()=>$186560e04962d2d0$var$_ensureRegistry();
// App-level configuration. Lookups go through the shared factory; the
// returned object owns its own override slot. Re-export thin wrappers
// so existing call sites (`configure({ required: [...] })`) keep working.
let $186560e04962d2d0$var$_appConfig = null;
const $186560e04962d2d0$var$_ensureAppConfig = ()=>{
    if ($186560e04962d2d0$var$_appConfig) return $186560e04962d2d0$var$_appConfig;
    $186560e04962d2d0$var$_ensureRegistry();
    $186560e04962d2d0$var$_appConfig = (0, $qBiAs.createAppConfig)(()=>$186560e04962d2d0$var$_registryConfig);
    return $186560e04962d2d0$var$_appConfig;
};
const $186560e04962d2d0$export$8d21e34596265fa2 = (opts)=>$186560e04962d2d0$var$_ensureAppConfig().configure(opts);
const $186560e04962d2d0$export$544aaded68bb6ae2 = ()=>$186560e04962d2d0$var$_ensureAppConfig().get();
const $186560e04962d2d0$export$bad43d745a81bbd5 = (key)=>{
    $186560e04962d2d0$var$_ensureRegistry();
    const cfg = $186560e04962d2d0$var$_registryConfig[key];
    if (!cfg) {
        if (key === $186560e04962d2d0$export$a54df3be54843d98) throw new Error(`[sdk-bridge-governance] governance project not configured \u{2014} missing SYMBOLS_APP_GOVERNANCE_SUPABASE_* env vars`);
        return null;
    }
    return cfg;
};
const $186560e04962d2d0$export$a44e0967006104d0 = ()=>{
    $186560e04962d2d0$var$_ensureRegistry();
    return Object.keys($186560e04962d2d0$var$_registryConfig);
};

});

parcelRegister("av2lU", function(module, exports) {

$parcel$export(module.exports, "getClient", () => $7a4e9fc271c1d86b$export$6bb76d6eba7e258c);
// Singleton Supabase clients, one per configured project. Every Supabase
// access in the workspace app goes through getClient(projectKey) — never
// createClient directly. This is the federation boundary.
//
// Implementation lives in @symbo.ls/sdk-bridge (createRegistry) +
// @symbo.ls/sdk-supabase-bridge (createSupabaseClient). This file binds
// those primitives to the governance/financials registry built in
// env.js and re-exports the legacy surface (getClient, getClientAsync,
// forEachClient, _resetClients) so existing call sites keep working.

var $25Rht = parcelRequire("25Rht");
const $7a4e9fc271c1d86b$export$6bb76d6eba7e258c = (projectKey = (0, $25Rht.PROJECT_GOVERNANCE))=>(0, $25Rht._getFederationRegistry)().getClient(projectKey);
const $7a4e9fc271c1d86b$export$80567c6129dc5041 = async (projectKey)=>(0, $25Rht._getFederationRegistry)().getClient(projectKey);
const $7a4e9fc271c1d86b$export$f29328267663ba07 = (fn)=>(0, $25Rht._getFederationRegistry)().forEachClient(fn);
const $7a4e9fc271c1d86b$export$a66dfc2c6da0bd3 = ()=>(0, $25Rht._getFederationRegistry)().reset();

});

parcelRegister("db3Gy", function(module, exports) {
// Auth federation: thin wrapper around @symbo.ls/sdk-supabase-bridge's
// createAuthBridge bound to the governance/financials registry. Re-
// exports the legacy module-level surface (loginAll, logoutAll, etc.)
// so existing workspace-app call sites keep working unchanged.
parcelRequire("e11aL");
var $9COKG = parcelRequire("9COKG");

var $25Rht = parcelRequire("25Rht");
let $997f29467c1eee50$var$_auth = null;
const $997f29467c1eee50$var$_ensureAuth = ()=>{
    if ($997f29467c1eee50$var$_auth) return $997f29467c1eee50$var$_auth;
    $997f29467c1eee50$var$_auth = (0, $9COKG.createAuthBridge)({
        registry: (0, $25Rht._getFederationRegistry)(),
        appConfig: {
            configure: $25Rht.configure,
            get: (0, $25Rht.getAppConfig)
        }
    });
    return $997f29467c1eee50$var$_auth;
};
const $997f29467c1eee50$export$71d050677f938d04 = (args)=>$997f29467c1eee50$var$_ensureAuth().loginAll(args);
const $997f29467c1eee50$export$4d932ebd88db07ee = ()=>$997f29467c1eee50$var$_ensureAuth().logoutAll();
const $997f29467c1eee50$export$b45be625a0b963d1 = (key, args)=>$997f29467c1eee50$var$_ensureAuth().activateExtension(key, args);
const $997f29467c1eee50$export$c3cb4d92231617a0 = (workspaceId)=>$997f29467c1eee50$var$_ensureAuth().switchWorkspace(workspaceId);
const $997f29467c1eee50$export$fd23a70622d440f6 = ()=>$997f29467c1eee50$var$_ensureAuth().refreshClaims();
const $997f29467c1eee50$export$2e94b40918c1ba70 = ()=>$997f29467c1eee50$var$_ensureAuth().getSymbolsToken();
const $997f29467c1eee50$export$6f5cc5586c0c38b3 = ()=>$997f29467c1eee50$var$_ensureAuth().getSessionStatus();

});

parcelRegister("fP7Jb", function(module, exports) {
// Cross-app user preferences. Persisted in a parent-domain cookie so
// canvas (canvas.localhost / edit.symbols.app) and the workspace app
// (workspace.localhost / us-at.symbols.app) read the same value.
parcelRequire("iyrQA");
var $bOdwG = parcelRequire("bOdwG");
const $b8519cffd59ea549$var$COOKIE_PREFIX = 'smbls_pref_';
const $b8519cffd59ea549$var$ONE_YEAR = 31536000;
function $b8519cffd59ea549$export$5a3d9fff44d1c4a0(key) {
    return (0, $bOdwG.readCookie)($b8519cffd59ea549$var$COOKIE_PREFIX + key);
}
function $b8519cffd59ea549$export$e24d7c6b90493ae7(key, value) {
    (0, $bOdwG.writeCookie)($b8519cffd59ea549$var$COOKIE_PREFIX + key, value, $b8519cffd59ea549$var$ONE_YEAR);
}
function $b8519cffd59ea549$export$40445c847c75de48(key) {
    (0, $bOdwG.writeCookie)($b8519cffd59ea549$var$COOKIE_PREFIX + key, null, 0);
}
const $b8519cffd59ea549$export$d9ecd1289243d0da = 'activeOrg';

});
parcelRegister("iyrQA", function(module, exports) {

$parcel$export(module.exports, "readCookie", () => (parcelRequire("bOdwG")).readCookie);
$parcel$export(module.exports, "writeCookie", () => (parcelRequire("bOdwG")).writeCookie);
// Backwards-compat re-export. Cookie primitives moved to
// @symbo.ls/sdk-bridge/cookies in the Phase 2 refactor — keep this file
// so existing relative imports (`./cookies.js` from prefs.js, tests)
// continue to resolve.
parcelRequire("cVasv");
var $bOdwG = parcelRequire("bOdwG");

});


parcelRegister("8pgLC", function(module, exports) {
// Cross-app auth sync — Symbols-flavoured wiring on top of
// @symbo.ls/sdk-supabase-bridge's createCrossAppAuth. Owns the peer
// origin map (canvas ↔ workspace, dev + prod hostnames) and re-exports
// the legacy module-level surface so existing call sites in
// workspace-project, canvas, shared keep working unchanged.
parcelRequire("e11aL");
var $jEfgr = parcelRequire("jEfgr");
// Peer resolution: whichever of `canvas` / `workspace` we're NOT
// currently running as. Each app owns a `_session-bridge` route that
// reads its own localStorage and postMessages the session to the
// iframe parent. Cookies with `domain=.localhost` are silently dropped
// by Chrome (per the public-suffix treatment), so the cookie strategy
// only works on prod `.symbols.app`. For dev we iframe the peer.
function $61edaa187aaf201b$var$peerOrigin() {
    if (typeof window === 'undefined') return null;
    const host = window.location.hostname;
    const isCanvas = host.startsWith('canvas.') || host === 'edit.symbols.app';
    const isWorkspace = host.startsWith('workspace.') || host.startsWith('system-governance-intranet.') || host.startsWith('governance-intranet.') || host === 'us-at.symbols.app';
    if (host.endsWith('.localhost') || host === 'localhost') {
        if (isCanvas) return 'http://workspace.localhost:1355';
        if (isWorkspace) return 'http://canvas.localhost:1355';
        return null;
    }
    if (host.endsWith('.symbols.app')) {
        if (isCanvas) return 'https://us-at.symbols.app';
        if (isWorkspace) return 'https://edit.symbols.app';
        return null;
    }
    return null;
}
const $61edaa187aaf201b$var$_api = (0, $jEfgr.createCrossAppAuth)({
    resolvePeerOrigin: $61edaa187aaf201b$var$peerOrigin
});
const $61edaa187aaf201b$export$332974f1fffb359a = $61edaa187aaf201b$var$_api.TOKEN_KEYS;
const $61edaa187aaf201b$export$ef001aa7c423f822 = $61edaa187aaf201b$var$_api.SUPABASE_KEY_RE;
const $61edaa187aaf201b$export$a299b57594f93420 = $61edaa187aaf201b$var$_api.hydrateAuthFromCookie;
const $61edaa187aaf201b$export$45cb7059e7c59007 = $61edaa187aaf201b$var$_api.hydrateAuthFromIframeBridge;
const $61edaa187aaf201b$export$d5d56450a6fb624 = $61edaa187aaf201b$var$_api.persistAuthToCookie;
const $61edaa187aaf201b$export$5d31187a0cdf795a = $61edaa187aaf201b$var$_api.clearAuthCookie;
const $61edaa187aaf201b$export$6c3ff1d8842f6efd = $61edaa187aaf201b$var$_api.installAuthSync;
const $61edaa187aaf201b$export$b0e7e9532d134e9a = $61edaa187aaf201b$var$_api.persistSupabaseSessionsToCookie;
const $61edaa187aaf201b$export$bd8aba6d048d19e4 = $61edaa187aaf201b$var$_api.hydrateSupabaseSessionsFromCookie;
const $61edaa187aaf201b$export$2caf675105ee535 = $61edaa187aaf201b$var$_api.collectSdkTokens;
const $61edaa187aaf201b$export$e7a829cfe6b87f06 = $61edaa187aaf201b$var$_api.collectSupabaseSessions;

});

parcelRegister("6VD0V", function(module, exports) {
// Client-side entry point for external integration operations.
//
// Governance-owned integrations (kind='supabase_project', 'github',
// 'google_workspace', 'npm', etc.) live in the `org_integrations` table
// of the governance Supabase project. Their secrets live in Vault.
// Neither secrets nor service-role keys can ever reach the browser —
// all ops have to round-trip through a server-side edge function.
//
// `callIntegrationOp()` is that round trip. It:
//   1. Reads the active user's governance JWT from the Supabase client.
//   2. POSTs the op body to `external-supabase-query` with that JWT.
//   3. Returns the parsed JSON response, whose shape is
//      `{ ok: true, op, result }` on success, `{ error: string }` on
//      failure.
//
// The edge function re-checks org membership from the JWT's
// `app_metadata.orgs` claim. It will 403 if the caller isn't in the
// org, 404 if the integration isn't configured, 500 on upstream errors.
//
// The function name "external-supabase-query" is historic — it handles
// not only Supabase CRUD but also `list_projects` and
// `list_integrations` which are governance-local. Everything else
// resolves a per-(org,kind,slug) external target before executing.
//
// For admin ops (writing integration config/secret, deleting), use
// `callAdminOp()` which hits the separate `symbols-admin-ops` endpoint
// via the Symbols server proxy for HMAC signing.

var $3WCJD = parcelRequire("3WCJD");

var $av2lU = parcelRequire("av2lU");

var $25Rht = parcelRequire("25Rht");
// ---------- Mongo (Symbols server) cutover flag ----------
//
// Env var: SYMBOLS_APP_USE_MONGO_INTEGRATIONS
//
// Feature flag: when set to "1" / "true" / "yes" / "on" (case-insensitive),
// every admin / read / capability call is routed to the Symbols server's
// /org-integrations/* REST endpoints (Mongo-backed) with the user's
// governance JWT as a bearer. When unset or falsy (default), we keep
// hitting the Supabase edge functions + RPCs exactly as before.
//
// Flip per environment once the server routes land and the data copy
// completes. See NEEDED_FOR_SERVER.md §Integrations for the server
// contract this path expects, and server/.env.example for the full list
// of related env vars (SYMBOLS_APP_USE_MONGO_INTEGRATIONS, SYMBOLS_API_URL).
//
// Migration status (2026-04-25): server routes are live; data copy in
// progress. Default remains false until the cutover is confirmed stable.
const $50b6544c581ba479$var$_env = (key)=>{
    try {
        return '';
    } catch  {
        return '';
    }
};
const $50b6544c581ba479$var$_useMongo = ()=>/^(1|true|yes|on)$/i.test($50b6544c581ba479$var$_env('SYMBOLS_APP_USE_MONGO_INTEGRATIONS'));
// Server URL resolves via @symbo.ls/channels: SYMBOLS_API_URL > channel name
// (SYMBOLS_API_CHANNEL / SYMBOLS_APP_ENV / NODE_ENV) > defaultChannel ('next').
const $50b6544c581ba479$var$_serverBase = ()=>(0, $3WCJD.apiUrl)().replace(/\/+$/, '');
const $50b6544c581ba479$var$_serverFetch = async (path, { method: method = 'GET', body: body } = {})=>{
    const token = await $50b6544c581ba479$var$_getAccessToken();
    if (!token) return {
        error: 'not authenticated'
    };
    try {
        const res = await fetch(`${$50b6544c581ba479$var$_serverBase()}${path}`, {
            method: method,
            headers: {
                Authorization: `Bearer ${token}`,
                ...body ? {
                    'Content-Type': 'application/json'
                } : {}
            },
            body: body ? JSON.stringify(body) : undefined
        });
        const json = await res.json().catch(()=>null);
        if (!res.ok) return {
            error: json?.error || `HTTP ${res.status}`,
            status: res.status
        };
        return json || {
            error: 'empty response'
        };
    } catch (err) {
        return {
            error: err?.message || 'network error'
        };
    }
};
// Resolve the governance Supabase URL from the configured client. All
// edge functions live under `${url}/functions/v1/<name>`; we never
// hardcode the URL so env-switched setups (dev vs prod) "just work".
const $50b6544c581ba479$var$_externalQueryUrl = ()=>{
    const client = (0, $av2lU.getClient)((0, $25Rht.PROJECT_GOVERNANCE));
    // supabase-js v2 stashes the URL on the rest builder.
    const url = client?.supabaseUrl || client?.rest?.url || '';
    if (!url) throw new Error("sdk-bridge: governance client has no URL \u2014 is configure() called?");
    return `${url.replace(/\/+$/, '')}/functions/v1/external-supabase-query`;
};
// Active session access token — required for the edge function's JWT
// check. Returns null when the user isn't signed in, so the caller can
// surface a friendly auth error instead of spinning.
const $50b6544c581ba479$var$_getAccessToken = async ()=>{
    const client = (0, $av2lU.getClient)((0, $25Rht.PROJECT_GOVERNANCE));
    if (!client) return null;
    const { data: data } = await client.auth.getSession();
    return data?.session?.access_token || null;
};
const $50b6544c581ba479$export$e39f0ece227c588f = async (body)=>{
    if ($50b6544c581ba479$var$_useMongo()) {
        const op = body?.op;
        if (op === 'list_integrations') {
            const r = await $50b6544c581ba479$var$_serverFetch(`/org-integrations?orgId=${encodeURIComponent(body.orgId)}`);
            return r.error ? r : {
                ok: true,
                op: op,
                result: r.integrations || []
            };
        }
        if (op === 'list_projects') {
            const r = await $50b6544c581ba479$var$_serverFetch(`/org-integrations?orgId=${encodeURIComponent(body.orgId)}&kind=supabase_project`);
            return r.error ? r : {
                ok: true,
                op: op,
                result: (r.integrations || []).filter((i)=>i.kind === 'supabase_project')
            };
        }
        // Per-integration ops → capability call. Supabase kinds always.
        const SB_OPS = {
            introspect: 'schema.introspect',
            select: 'data.read',
            insert: 'data.write',
            update: 'data.write',
            delete: 'data.write',
            rpc: 'rpc.call'
        };
        const capability = SB_OPS[op];
        if (!capability) return {
            error: `unknown op for mongo dispatcher: ${op}`
        };
        return $50b6544c581ba479$export$415cb9dbfbcf662e({
            orgId: body.orgId,
            kind: 'supabase_project',
            slug: body.slug || 'default'
        }, capability, {
            ...body,
            op: undefined,
            orgId: undefined,
            slug: undefined
        });
    }
    const token = await $50b6544c581ba479$var$_getAccessToken();
    if (!token) return {
        error: 'not authenticated'
    };
    try {
        const res = await fetch($50b6544c581ba479$var$_externalQueryUrl(), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(body)
        });
        const json = await res.json().catch(()=>null);
        if (!res.ok) return {
            error: json?.error || `HTTP ${res.status}`,
            status: res.status
        };
        return json || {
            error: 'empty response'
        };
    } catch (err) {
        return {
            error: err?.message || 'network error'
        };
    }
};
const $50b6544c581ba479$export$85588f1c8341c62c = (orgId)=>$50b6544c581ba479$export$e39f0ece227c588f({
        op: 'list_projects',
        orgId: orgId
    });
const $50b6544c581ba479$export$ff50ba736d55c110 = (orgId)=>{
    if ($50b6544c581ba479$var$_useMongo()) return $50b6544c581ba479$var$_serverFetch(`/org-integrations?orgId=${encodeURIComponent(orgId)}`).then((r)=>r.error ? r : {
            ok: true,
            result: r.integrations || []
        });
    return $50b6544c581ba479$export$e39f0ece227c588f({
        op: 'list_integrations',
        orgId: orgId
    });
};
const $50b6544c581ba479$export$6ece0c758f9c6a6 = (orgId, slug = 'default')=>$50b6544c581ba479$export$e39f0ece227c588f({
        op: 'introspect',
        orgId: orgId,
        slug: slug
    });
const $50b6544c581ba479$export$8323150a0bdc34f8 = (orgId, slug, table, opts = {})=>$50b6544c581ba479$export$e39f0ece227c588f({
        op: 'select',
        orgId: orgId,
        slug: slug,
        table: table,
        columns: opts.columns,
        filters: opts.filters,
        order: opts.order,
        limit: opts.limit,
        offset: opts.offset
    });
const $50b6544c581ba479$export$8afdc7a20b5025ed = (orgId, slug, table, data)=>$50b6544c581ba479$export$e39f0ece227c588f({
        op: 'insert',
        orgId: orgId,
        slug: slug,
        table: table,
        data: data
    });
const $50b6544c581ba479$export$58fada43babf3773 = (orgId, slug, table, filters, data)=>$50b6544c581ba479$export$e39f0ece227c588f({
        op: 'update',
        orgId: orgId,
        slug: slug,
        table: table,
        filters: filters,
        data: data
    });
const $50b6544c581ba479$export$9d290c8fb95e325d = (orgId, slug, table, filters)=>$50b6544c581ba479$export$e39f0ece227c588f({
        op: 'delete',
        orgId: orgId,
        slug: slug,
        table: table,
        filters: filters
    });
const $50b6544c581ba479$export$475722e542aaebd5 = (orgId, slug, rpcName, rpcArgs = {})=>$50b6544c581ba479$export$e39f0ece227c588f({
        op: 'rpc',
        orgId: orgId,
        slug: slug,
        rpc_name: rpcName,
        rpc_args: rpcArgs
    });
// ---------- admin ops (integration config CRUD) ----------
//
// These go through the `integration-admin` edge function which
// validates the user JWT, checks admin/owner membership on the target
// org, then performs the vault + org_integrations upsert.
//
// A browser-direct path (user JWT) keeps the system self-contained:
// no dependency on the Symbols server's HMAC proxy layer shipping.
// Admin membership is verified on the edge function side so we can't
// skip it by tampering with the request.
const $50b6544c581ba479$var$_adminUrl = ()=>{
    const client = (0, $av2lU.getClient)((0, $25Rht.PROJECT_GOVERNANCE));
    const url = client?.supabaseUrl || client?.rest?.url || '';
    if (!url) throw new Error('sdk-bridge: governance client has no URL');
    return `${url.replace(/\/+$/, '')}/functions/v1/integration-admin`;
};
const $50b6544c581ba479$var$_adminCall = async (op, args)=>{
    const client = (0, $av2lU.getClient)((0, $25Rht.PROJECT_GOVERNANCE));
    if (!client) return {
        ok: false,
        body: {
            error: 'no governance client'
        }
    };
    const { data: data } = await client.auth.getSession();
    const token = data?.session?.access_token;
    if (!token) return {
        ok: false,
        body: {
            error: 'not authenticated'
        }
    };
    try {
        const res = await fetch($50b6544c581ba479$var$_adminUrl(), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                op: op,
                ...args
            })
        });
        const body = await res.json().catch(()=>null);
        return {
            ok: res.ok,
            body: body,
            status: res.status
        };
    } catch (err) {
        return {
            ok: false,
            body: {
                error: err?.message || 'network error'
            }
        };
    }
};
const $50b6544c581ba479$export$6b400a7c808bfba0 = (args)=>$50b6544c581ba479$var$_useMongo() ? $50b6544c581ba479$var$_serverFetch('/org-integrations', {
        method: 'POST',
        body: args
    }) : $50b6544c581ba479$var$_adminCall('upsert', args);
const $50b6544c581ba479$export$ba41385ae01ee131 = (args)=>$50b6544c581ba479$var$_useMongo() ? $50b6544c581ba479$var$_serverFetch('/org-integrations', {
        method: 'DELETE',
        body: args
    }) : $50b6544c581ba479$var$_adminCall('delete', args);
// Marketplace-facing wrapper over saveIntegration. Generates a slug
// from displayName (kept inline — sdk-bridge has no shared utils dep)
// and enforces the scope-null-for-org invariant.
const $50b6544c581ba479$var$_slugify = (s)=>String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-+|-+$)/g, '').slice(0, 40) || `slot-${Math.random().toString(36).slice(2, 6)}`;
const $50b6544c581ba479$export$1cf78abcf6d94c6d = (args)=>{
    if (!args?.kind) return Promise.resolve({
        ok: false,
        body: {
            error: 'kind required'
        }
    });
    const scopeType = args.scopeType || 'org';
    return $50b6544c581ba479$export$6b400a7c808bfba0({
        orgId: args.orgId,
        kind: args.kind,
        slug: $50b6544c581ba479$var$_slugify(args.displayName || args.config?.display_name || args.kind),
        displayName: args.displayName || args.kind,
        config: args.config || {},
        secret: args.secret,
        scopeType: scopeType,
        scopeId: scopeType === 'org' ? null : args.scopeId || null,
        enabled: true
    });
};
const $50b6544c581ba479$export$e0a7ede0704bb4eb = (args)=>$50b6544c581ba479$var$_useMongo() ? $50b6544c581ba479$var$_serverFetch('/org-integrations/assign-scope', {
        method: 'POST',
        body: args
    }) : $50b6544c581ba479$var$_adminCall('assign_scope', args);
const $50b6544c581ba479$export$cd37fb6f2cf1af92 = (args)=>$50b6544c581ba479$var$_useMongo() ? $50b6544c581ba479$var$_serverFetch('/org-integrations/reorder', {
        method: 'POST',
        body: args
    }) : $50b6544c581ba479$var$_adminCall('reorder', args);
const $50b6544c581ba479$export$1587fb5beefd14b4 = async (orgId)=>{
    if ($50b6544c581ba479$var$_useMongo()) {
        const [kindsRes, integrationsRes] = await Promise.all([
            $50b6544c581ba479$var$_serverFetch('/org-integrations/kinds'),
            orgId ? $50b6544c581ba479$var$_serverFetch(`/org-integrations?orgId=${encodeURIComponent(orgId)}`) : Promise.resolve({
                integrations: []
            })
        ]);
        return {
            kinds: kindsRes?.kinds || [],
            integrations: integrationsRes?.integrations || []
        };
    }
    const client = (0, $av2lU.getClient)((0, $25Rht.PROJECT_GOVERNANCE));
    if (!client) return {
        kinds: [],
        integrations: []
    };
    const [kindsRes, integrationsRes] = await Promise.all([
        client.from('integration_kinds').select('*').order('sort_order'),
        orgId ? client.rpc('list_org_integrations', {
            p_org_id: orgId
        }) : Promise.resolve({
            data: []
        })
    ]);
    return {
        kinds: kindsRes.data || [],
        integrations: integrationsRes.data || []
    };
};
// ---------- scope-aware unified reader ----------
//
// The "integration units" shape. One entry per configured kind at the
// requested scope (with parent-scope inheritance by default). Built on
// top of `list_org_integrations(p_org_id, p_scope_type, p_scope_id,
// p_include_parents)` which handles the inheritance query server-side.
//
// Shape returned:
//   [{
//     kind, label, category, icon, description,
//     auth_model, default_scope, capabilities, allows_multiple,
//     instances: [
//       { slug, display_name, scope_type, scope_id, config, enabled, has_secret, updated_at }
//     ],
//     count
//   }, …]
//
// Scope descriptor:
//   { type: 'org' | 'workspace' | 'project', orgId, id?, includeParents? }
//
// `id` is required for workspace/project scope. `includeParents` defaults
// to true — a project view merges project + workspace + org rows so
// child contexts inherit org-wide infra (github, google_workspace, etc).
const $50b6544c581ba479$var$_fold = (kinds, integrations)=>{
    const byKind = {};
    for (const k of kinds || [])byKind[k.kind] = {
        kind: k.kind,
        label: k.label,
        category: k.category,
        icon: k.icon,
        description: k.description,
        auth_model: k.auth_model,
        default_scope: k.default_scope,
        capabilities: k.capabilities || [],
        allows_multiple: k.allows_multiple,
        instances: [],
        count: 0
    };
    for (const i of integrations || []){
        const unit = byKind[i.kind];
        if (!unit) continue;
        unit.instances.push({
            slug: i.slug,
            display_name: i.display_name,
            scope_type: i.scope_type,
            scope_id: i.scope_id,
            config: i.config,
            enabled: i.enabled,
            has_secret: i.has_secret,
            updated_at: i.updated_at
        });
        unit.count += 1;
    }
    return Object.values(byKind).sort((a, b)=>a.category.localeCompare(b.category));
};
const $50b6544c581ba479$export$53f09f566140490d = async (scope = {})=>{
    const { type: type = 'org', orgId: orgId, id: id = null, includeParents: includeParents = true } = scope;
    if (!orgId) return [];
    if ((type === 'workspace' || type === 'project') && !id) throw new Error(`loadIntegrationUnits: scope.id required for type="${type}"`);
    if ($50b6544c581ba479$var$_useMongo()) {
        const qs = new URLSearchParams({
            orgId: orgId,
            scopeType: type,
            ...id ? {
                scopeId: id
            } : {},
            includeParents: String(includeParents)
        });
        const [kindsRes, rowsRes] = await Promise.all([
            $50b6544c581ba479$var$_serverFetch('/org-integrations/kinds'),
            $50b6544c581ba479$var$_serverFetch(`/org-integrations?${qs.toString()}`)
        ]);
        return $50b6544c581ba479$var$_fold(kindsRes?.kinds || [], rowsRes?.integrations || []);
    }
    const client = (0, $av2lU.getClient)((0, $25Rht.PROJECT_GOVERNANCE));
    if (!client) return [];
    const [kindsRes, rowsRes] = await Promise.all([
        client.rpc('list_integration_kinds'),
        client.rpc('list_org_integrations', {
            p_org_id: orgId,
            p_scope_type: type,
            p_scope_id: id,
            p_include_parents: includeParents
        })
    ]);
    return $50b6544c581ba479$var$_fold(kindsRes.data || [], rowsRes.data || []);
};
const $50b6544c581ba479$export$68742fc05db98ed0 = (orgId, opts = {})=>$50b6544c581ba479$export$53f09f566140490d({
        type: 'org',
        orgId: orgId,
        ...opts
    });
const $50b6544c581ba479$export$32940dd3fd7222d6 = (orgId, workspaceId, opts = {})=>$50b6544c581ba479$export$53f09f566140490d({
        type: 'workspace',
        orgId: orgId,
        id: workspaceId,
        ...opts
    });
const $50b6544c581ba479$export$bb68030dbea98deb = (orgId, projectId, opts = {})=>$50b6544c581ba479$export$53f09f566140490d({
        type: 'project',
        orgId: orgId,
        id: projectId,
        ...opts
    });
const $50b6544c581ba479$export$670cac04aa7a321c = async ()=>{
    if ($50b6544c581ba479$var$_useMongo()) {
        const res = await $50b6544c581ba479$var$_serverFetch('/org-integrations/kinds');
        return res?.kinds || [];
    }
    const client = (0, $av2lU.getClient)((0, $25Rht.PROJECT_GOVERNANCE));
    if (!client) return [];
    const res = await client.rpc('list_integration_kinds');
    return res.data || [];
};
const $50b6544c581ba479$export$861c105576c0b303 = async (capability, scope)=>{
    const units = await $50b6544c581ba479$export$53f09f566140490d(scope);
    return units.filter((u)=>(u.capabilities || []).includes(capability));
};
// ---------- capability execution ----------
//
// Generic verb dispatcher. The edge function `integration-call` looks
// up the integration row by (orgId, scope, kind, slug), verifies the
// caller's org membership, and routes to a per-kind handler. The
// capability string ('webhook.trigger', 'http.request', 'metric.query',
// …) tells the handler *what* to do; `args` is opaque payload.
//
// For data ops on a supabase_project, keep using the dedicated helpers
// (selectExternalSupabase, etc.) — they're thinner and typed. Use this
// for n8n, custom_http, google_analytics, and future kinds.
//
// ref shape: { orgId, kind, slug?='default', scopeType?='org', scopeId?=null }
const $50b6544c581ba479$var$_callUrl = ()=>{
    const client = (0, $av2lU.getClient)((0, $25Rht.PROJECT_GOVERNANCE));
    const url = client?.supabaseUrl || client?.rest?.url || '';
    if (!url) throw new Error('sdk-bridge: governance client has no URL');
    return `${url.replace(/\/+$/, '')}/functions/v1/integration-call`;
};
const $50b6544c581ba479$export$415cb9dbfbcf662e = async (ref, capability, args = {})=>{
    const body = {
        orgId: ref.orgId,
        kind: ref.kind,
        slug: ref.slug || 'default',
        scopeType: ref.scopeType || 'org',
        scopeId: ref.scopeId ?? null,
        capability: capability,
        args: args
    };
    if ($50b6544c581ba479$var$_useMongo()) return $50b6544c581ba479$var$_serverFetch('/org-integrations/call', {
        method: 'POST',
        body: body
    });
    const token = await $50b6544c581ba479$var$_getAccessToken();
    if (!token) return {
        error: 'not authenticated'
    };
    try {
        const res = await fetch($50b6544c581ba479$var$_callUrl(), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(body)
        });
        const json = await res.json().catch(()=>null);
        if (!res.ok) return {
            error: json?.error || `HTTP ${res.status}`,
            status: res.status
        };
        return json || {
            error: 'empty response'
        };
    } catch (err) {
        return {
            error: err?.message || 'network error'
        };
    }
};

});

parcelRegister("4ydpI", function(module, exports) {
// MCP connector SDK bridge — client-side wrappers for the mcp_connectors
// Supabase table. All writes go through the governance Supabase REST API;
// secrets (auth tokens) are written server-side via integration_secrets and
// referenced by auth_secret_id FK — they never travel through the browser
// in plain text.
//
// Runtime contract: JSON-RPC 2.0 over SSE / WebSocket / HTTP transport.
// Capability discovery (tools/list + resources/list) runs server-side on
// install and is cached in the `capabilities` jsonb column.
//
// Supabase RLS: every call requires the user's governance JWT; rows are
// filtered by jwt_active_workspace() so a user only ever sees their own
// workspace's connectors.

var $3WCJD = parcelRequire("3WCJD");

var $av2lU = parcelRequire("av2lU");

var $25Rht = parcelRequire("25Rht");
const $3504be1e8f02bd92$var$_gov = ()=>(0, $av2lU.getClient)((0, $25Rht.PROJECT_GOVERNANCE));
// ── Helpers ───────────────────────────────────────────────────────────────────
const $3504be1e8f02bd92$var$_getAccessToken = async ()=>{
    if (typeof window === 'undefined') return null;
    const token = window.localStorage.getItem('symbols_bridge_access_token') || window.localStorage.getItem('symbols_access_token') || null;
    return token;
};
// Resolves via @symbo.ls/channels: SYMBOLS_API_URL > channel name
// (SYMBOLS_API_CHANNEL / SYMBOLS_APP_ENV / NODE_ENV) > defaultChannel ('next').
const $3504be1e8f02bd92$var$_serverBase = ()=>{
    try {
        return (0, $3WCJD.apiUrl)().replace(/\/+$/, '');
    } catch  {
        return 'https://next.api.symbols.app';
    }
};
const $3504be1e8f02bd92$var$_serverFetch = async (path, { method: method = 'GET', body: body } = {})=>{
    const token = await $3504be1e8f02bd92$var$_getAccessToken();
    if (!token) return {
        error: 'not authenticated'
    };
    try {
        const res = await fetch(`${$3504be1e8f02bd92$var$_serverBase()}${path}`, {
            method: method,
            headers: {
                Authorization: `Bearer ${token}`,
                ...body ? {
                    'Content-Type': 'application/json'
                } : {}
            },
            body: body ? JSON.stringify(body) : undefined
        });
        const json = await res.json().catch(()=>null);
        if (!res.ok) return {
            error: json?.error || `HTTP ${res.status}`,
            status: res.status
        };
        return json || {
            error: 'empty response'
        };
    } catch (err) {
        return {
            error: err?.message || 'network error'
        };
    }
};
const $3504be1e8f02bd92$export$5c32629e639be49f = async ({ scopeType: scopeType, scopeId: scopeId } = {})=>{
    const client = $3504be1e8f02bd92$var$_gov();
    if (!client) return {
        data: [],
        error: 'sdk-bridge not configured'
    };
    let q = client.from('mcp_connectors').select('*').order('created_at', {
        ascending: true
    });
    if (scopeType) q = q.eq('scope_type', scopeType);
    if (scopeId != null) q = q.eq('scope_id', scopeId);
    const { data: data, error: error } = await q;
    return {
        data: data || [],
        error: error?.message || null
    };
};
const $3504be1e8f02bd92$export$d9238261bf4fae2d = async ({ workspaceId: workspaceId, scopeType: scopeType = 'workspace', scopeId: scopeId = null, name: name, url: url, transport: transport = 'sse', authKind: authKind = 'none', authToken: authToken })=>{
    if (!workspaceId) return {
        ok: false,
        error: 'workspaceId required'
    };
    if (!url) return {
        ok: false,
        error: 'url required'
    };
    if (!name) return {
        ok: false,
        error: 'name required'
    };
    // Route through the server endpoint so it can store the secret in Vault
    // and run capability discovery without exposing the token to the DB.
    const result = await $3504be1e8f02bd92$var$_serverFetch('/core/mcp-connectors', {
        method: 'POST',
        body: {
            workspaceId: workspaceId,
            scopeType: scopeType,
            scopeId: scopeId,
            name: name,
            url: url,
            transport: transport,
            authKind: authKind,
            authToken: authToken
        }
    });
    if (result.error) return {
        ok: false,
        error: result.error
    };
    return {
        ok: true,
        data: result
    };
};
const $3504be1e8f02bd92$export$2624c843b5958ba7 = async (connectorId)=>{
    if (!connectorId) return {
        ok: false,
        error: 'connectorId required'
    };
    const result = await $3504be1e8f02bd92$var$_serverFetch(`/core/mcp-connectors/${connectorId}/discover`, {
        method: 'POST'
    });
    if (result.error) return {
        ok: false,
        error: result.error
    };
    return {
        ok: true,
        capabilities: result.capabilities || result
    };
};
const $3504be1e8f02bd92$export$ee79419b4f8ae98c = async (connectorId)=>{
    const client = $3504be1e8f02bd92$var$_gov();
    if (!client) return {
        ok: false,
        error: 'sdk-bridge not configured'
    };
    const { error: error } = await client.from('mcp_connectors').update({
        status: 'enabled'
    }).eq('id', connectorId);
    return error ? {
        ok: false,
        error: error.message
    } : {
        ok: true
    };
};
const $3504be1e8f02bd92$export$934ad11716cb70c8 = async (connectorId)=>{
    const client = $3504be1e8f02bd92$var$_gov();
    if (!client) return {
        ok: false,
        error: 'sdk-bridge not configured'
    };
    const { error: error } = await client.from('mcp_connectors').update({
        status: 'disabled'
    }).eq('id', connectorId);
    return error ? {
        ok: false,
        error: error.message
    } : {
        ok: true
    };
};
const $3504be1e8f02bd92$export$8fc5777482cc8024 = async (connectorId)=>{
    const client = $3504be1e8f02bd92$var$_gov();
    if (!client) return {
        ok: false,
        error: 'sdk-bridge not configured'
    };
    const { error: error } = await client.from('mcp_connectors').delete().eq('id', connectorId);
    return error ? {
        ok: false,
        error: error.message
    } : {
        ok: true
    };
};

});



parcelRegister("i9I9s", function(module, exports) {

$parcel$export(module.exports, "grantsClient", () => $d37b50d94be1c937$export$d27a6a6026cef300);
$parcel$export(module.exports, "grantsAvailable", () => $d37b50d94be1c937$export$b7e5df3bcadcc4f0);
// All grant data access goes through this single function. Components
// NEVER import @supabase/supabase-js directly — that would bypass the
// federation boundary and the feature would become project-coupled.
parcelRequire("gx7yq");
var $av2lU = parcelRequire("av2lU");

var $bEP4Q = parcelRequire("bEP4Q");
const $d37b50d94be1c937$export$d27a6a6026cef300 = ()=>(0, $av2lU.getClient)((0, $bEP4Q.GRANTS_CONFIG).projectName);
const $d37b50d94be1c937$export$b7e5df3bcadcc4f0 = ()=>!!$d37b50d94be1c937$export$d27a6a6026cef300();

});

parcelRegister("2PNsc", function(module, exports) {

$parcel$export(module.exports, "listGrants", () => $2106b4b15a685cb3$export$f06a0d079b8dd594);
$parcel$export(module.exports, "getGrantDetail", () => $2106b4b15a685cb3$export$15c7783b803721a7);
$parcel$export(module.exports, "createGrant", () => $2106b4b15a685cb3$export$a91429eaf015e224);
$parcel$export(module.exports, "updateGrant", () => $2106b4b15a685cb3$export$7ca8e357bb905203);
$parcel$export(module.exports, "voidGrant", () => $2106b4b15a685cb3$export$efbaa88f4bda9f00);
$parcel$export(module.exports, "listCapTableRows", () => $2106b4b15a685cb3$export$710c612bab5c9594);
$parcel$export(module.exports, "listValuations", () => $2106b4b15a685cb3$export$69fd295b99ae8181);
$parcel$export(module.exports, "getCurrentValuation", () => $2106b4b15a685cb3$export$831fe60288547d7a);
$parcel$export(module.exports, "getCompanySettings", () => $2106b4b15a685cb3$export$6234682c19141fa);
$parcel$export(module.exports, "updateCompanySettings", () => $2106b4b15a685cb3$export$e21e3e98c598a9b9);
// Data access for grants. Every call goes through sdk-bridge to the
// financials Supabase project. RLS on the financials side gates reads:
// grantee_email = caller's email OR caller has org admin role.
//
// Grants are ORG-scoped (Symbols Inc has one cap table across all its
// workspaces), so every query keys by `orgId` — the Mongo ObjectId of
// the organization, passed as a 24-hex string.

var $i9I9s = parcelRequire("i9I9s");

var $bEP4Q = parcelRequire("bEP4Q");
const { tables: $2106b4b15a685cb3$var$tables } = (0, $bEP4Q.GRANTS_CONFIG);
const $2106b4b15a685cb3$export$f06a0d079b8dd594 = async ({ orgId: orgId, grantee: grantee, status: status } = {})=>{
    const sb = (0, $i9I9s.grantsClient)();
    if (!sb) return {
        data: [],
        error: null
    };
    let q = sb.from($2106b4b15a685cb3$var$tables.grants).select('*').order('vesting_start', {
        ascending: false
    });
    if (orgId) q = q.eq('org_id', orgId);
    if (grantee) q = q.eq('grantee_email', grantee);
    if (status) q = q.eq('status', status);
    return q;
};
const $2106b4b15a685cb3$export$15c7783b803721a7 = async (grantId)=>{
    const sb = (0, $i9I9s.grantsClient)();
    if (!sb) return {
        data: null,
        error: null
    };
    const [grantRes, eventsRes] = await Promise.all([
        sb.from($2106b4b15a685cb3$var$tables.grants).select('*').eq('id', grantId).maybeSingle(),
        sb.from($2106b4b15a685cb3$var$tables.grantEvents).select('*').eq('grant_id', grantId).order('occurred_at', {
            ascending: false
        }).limit(50)
    ]);
    if (grantRes.error || !grantRes.data) return {
        data: null,
        error: grantRes.error
    };
    return {
        data: {
            grant: grantRes.data,
            events: eventsRes.data || []
        },
        error: null
    };
};
const $2106b4b15a685cb3$export$a91429eaf015e224 = async ({ orgId: orgId, granteeEmail: granteeEmail, patch: patch })=>{
    const sb = (0, $i9I9s.grantsClient)();
    if (!sb) return {
        data: null,
        error: new Error('financials project unavailable')
    };
    const row = {
        org_id: orgId,
        grantee_email: granteeEmail,
        ...patch
    };
    const { data: data, error: error } = await sb.from($2106b4b15a685cb3$var$tables.grants).insert(row).select('*').single();
    return {
        data: data,
        error: error
    };
};
const $2106b4b15a685cb3$export$7ca8e357bb905203 = async (grantId, patch)=>{
    const sb = (0, $i9I9s.grantsClient)();
    if (!sb) return {
        data: null,
        error: new Error('financials project unavailable')
    };
    const { data: data, error: error } = await sb.from($2106b4b15a685cb3$var$tables.grants).update({
        ...patch,
        updated_at: new Date().toISOString()
    }).eq('id', grantId).select('*').single();
    return {
        data: data,
        error: error
    };
};
const $2106b4b15a685cb3$export$efbaa88f4bda9f00 = async (grantId, { reason: reason } = {})=>{
    return $2106b4b15a685cb3$export$7ca8e357bb905203(grantId, {
        status: 'void',
        notes: reason || null
    });
};
const $2106b4b15a685cb3$export$710c612bab5c9594 = async (orgId)=>{
    const sb = (0, $i9I9s.grantsClient)();
    if (!sb) return {
        data: [],
        error: null
    };
    const { data: data, error: error } = await sb.from($2106b4b15a685cb3$var$tables.grants).select('id, grantee_email, grantee_name, share_class, shares, vested_shares, equity_pct, status, vesting_start, vesting_end, salary_monthly, source, label').eq('org_id', orgId).order('shares', {
        ascending: false
    });
    return {
        data: data || [],
        error: error
    };
};
const $2106b4b15a685cb3$export$69fd295b99ae8181 = async (orgId)=>{
    const sb = (0, $i9I9s.grantsClient)();
    if (!sb) return {
        data: [],
        error: null
    };
    const { data: data, error: error } = await sb.from($2106b4b15a685cb3$var$tables.valuations).select('*').eq('org_id', orgId).order('effective_date', {
        ascending: false
    });
    return {
        data: data || [],
        error: error
    };
};
const $2106b4b15a685cb3$export$831fe60288547d7a = async (orgId)=>{
    const sb = (0, $i9I9s.grantsClient)();
    if (!sb) return {
        data: null,
        error: null
    };
    const { data: data, error: error } = await sb.from($2106b4b15a685cb3$var$tables.valuations).select('*').eq('org_id', orgId).eq('is_current', true).maybeSingle();
    return {
        data: data,
        error: error
    };
};
const $2106b4b15a685cb3$export$6234682c19141fa = async (orgId)=>{
    const sb = (0, $i9I9s.grantsClient)();
    if (!sb) return {
        data: null,
        error: null
    };
    const { data: data, error: error } = await sb.from($2106b4b15a685cb3$var$tables.companySettings).select('*').eq('org_id', orgId).maybeSingle();
    return {
        data: data,
        error: error
    };
};
const $2106b4b15a685cb3$export$e21e3e98c598a9b9 = async (orgId, patch)=>{
    const sb = (0, $i9I9s.grantsClient)();
    if (!sb) return {
        data: null,
        error: new Error('financials project unavailable')
    };
    const { data: data, error: error } = await sb.from($2106b4b15a685cb3$var$tables.companySettings).upsert({
        org_id: orgId,
        ...patch,
        updated_at: new Date().toISOString()
    }, {
        onConflict: 'org_id'
    }).select('*').single();
    return {
        data: data,
        error: error
    };
};

});



parcelRegister("gu4Va", function(module, exports) {

$parcel$export(module.exports, "getRealtimeManager", () => $c00343ea33f7adb1$export$c0a074c79f0e5db9);
// TODO[sdk-realtime] — this file is intentionally NOT migrated to the SDK
// yet. Realtime channels (`.channel`, `.subscribe`, `postgres_changes`)
// run through the live Supabase client; once SDK-side realtime support
// (workspaceProject.* `subscribe` ops) ships and the wrapper proxies
// realtime-style websockets, the per-table subscriptions below should
// route through getSDK().execute(entity, 'subscribe', filter, handler).
//
// Workspace-aware realtime subscription manager. On workspace switch,
// all active subscriptions must tear down and re-bind with the new
// `workspace_id` filter — Supabase realtime evaluates the filter at
// subscribe time and does not re-evaluate when claims change.
//
// Pattern:
//
//   const mgr = createRealtimeManager()
//   mgr.subscribe('chat_messages', `channel_id=eq.${chId}`, handler)
//   // on workspace switch: mgr.rebindAll()
//   // on unmount:           mgr.unsubscribeAll()
//
// The manager keeps a registry of (table, extraFilter, handler) tuples
// so it can regenerate each subscription with a fresh workspace filter
// when the claim changes.
parcelRequire("82gA2");
var $8RlGv = parcelRequire("8RlGv");

var $hLqco = parcelRequire("hLqco");
var $bdIjZ = parcelRequire("bdIjZ");
const $c00343ea33f7adb1$export$3f4d2b93cca330cb = (root)=>{
    const registry = new Map() // channelName → { table, extraFilter, handler, channel }
    ;
    const _buildFilter = (table, extraFilter)=>{
        const parts = [];
        if ((0, $bdIjZ.USE_MULTITENANT) && (0, $hLqco.WORKSPACE_SCOPED).has(table)) {
            const wsId = (0, $hLqco.activeWorkspaceId)(root);
            if (wsId) parts.push(`workspace_id=eq.${wsId}`);
        }
        if (extraFilter) parts.push(extraFilter);
        return parts.length ? parts.join(',') : undefined;
    };
    const _bind = (table, extraFilter, handler)=>{
        const sb = (0, $8RlGv.getSupabase)();
        const name = `rt-${table}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
        const channel = sb.channel(name);
        const filter = _buildFilter(table, extraFilter);
        channel.on('postgres_changes', {
            event: '*',
            schema: 'public',
            table: table,
            filter: filter
        }, handler);
        channel.subscribe();
        registry.set(name, {
            table: table,
            extraFilter: extraFilter,
            handler: handler,
            channel: channel
        });
        return name;
    };
    const subscribe = (table, extraFilter, handler)=>_bind(table, extraFilter, handler);
    const unsubscribe = (name)=>{
        const entry = registry.get(name);
        if (!entry) return;
        try {
            entry.channel.unsubscribe();
        } catch  {}
        registry.delete(name);
    };
    const unsubscribeAll = ()=>{
        for (const [name] of registry)unsubscribe(name);
    };
    // Tear down every active subscription and rebind with the current
    // workspace filter. Called by the workspace switcher after
    // switchWorkspace() succeeds so the new JWT's active_workspace_id
    // is applied to every open channel.
    const rebindAll = ()=>{
        const snapshot = [];
        for (const [name, entry] of registry){
            snapshot.push({
                table: entry.table,
                extraFilter: entry.extraFilter,
                handler: entry.handler
            });
            try {
                entry.channel.unsubscribe();
            } catch  {}
        }
        registry.clear();
        for (const { table: table, extraFilter: extraFilter, handler: handler } of snapshot)_bind(table, extraFilter, handler);
    };
    return {
        subscribe: subscribe,
        unsubscribe: unsubscribe,
        unsubscribeAll: unsubscribeAll,
        rebindAll: rebindAll,
        size: ()=>registry.size
    };
};
// Singleton for the current app runtime — one manager covers every page
// in the intranet. Subscribers register against it; on workspace
// switch, one `rebindAll()` resets every open channel.
let $c00343ea33f7adb1$var$_singleton = null;
const $c00343ea33f7adb1$export$c0a074c79f0e5db9 = (root)=>{
    if ($c00343ea33f7adb1$var$_singleton) return $c00343ea33f7adb1$var$_singleton;
    if (!root) throw new Error('getRealtimeManager: root required on first call');
    $c00343ea33f7adb1$var$_singleton = $c00343ea33f7adb1$export$3f4d2b93cca330cb(root);
    return $c00343ea33f7adb1$var$_singleton;
};
const $c00343ea33f7adb1$export$f011be37d617c497 = ()=>{
    $c00343ea33f7adb1$var$_singleton = null;
};

});
parcelRegister("hLqco", function(module, exports) {

$parcel$export(module.exports, "WORKSPACE_SCOPED", () => $ceeb25fc2fc26131$export$ba510865687871cf);
$parcel$export(module.exports, "activeWorkspaceId", () => $ceeb25fc2fc26131$export$d5dc34adaaba13d7);
$parcel$export(module.exports, "USE_MULTITENANT", () => (parcelRequire("bdIjZ")).USE_MULTITENANT);
// Workspace-scoped Supabase query helper. The intranet has dozens of
// `sb().from('<table>')...` call sites. In Phase 3 multi-tenancy, every
// query against the 28 workspace-scoped tables must be filtered by
// `workspace_id = <active>` so RLS (enabled in the migration follow-up)
// doesn't strip rows.
//
// Instead of updating each call site by hand (fragile, easy to miss),
// this module exposes a thin wrapper that:
//
//   1. Returns a Supabase query builder.
//   2. When USE_MULTITENANT is on AND the target table is in the
//      `WORKSPACE_SCOPED` set, the active workspace_id is automatically
//      .eq()'d onto the chain.
//   3. Provides insertScoped() / updateScoped() helpers that also set
//      workspace_id on writes.
//
// Flag off today — zero behavior change. Adopt call-site-by-call-site
// by replacing `sb().from('X')` with `scoped().from('X')`. Old call
// sites continue to work through RLS once migrations are applied and
// the flag flips on.
parcelRequire("82gA2");
var $8RlGv = parcelRequire("8RlGv");

var $bdIjZ = parcelRequire("bdIjZ");
const $ceeb25fc2fc26131$export$ba510865687871cf = new Set([
    // chat
    'chat_channels',
    'chat_channel_members',
    'chat_messages',
    'chat_reactions',
    'chat_mentions',
    // tickets
    'tickets',
    'ticket_comments',
    'ticket_columns',
    'ticket_field_values',
    'stories',
    // docs / kb
    'documents',
    'kb_articles',
    'notes',
    'links',
    'resource_links',
    // meet
    'meet_rooms',
    'meet_room_members',
    'meet_participants',
    'meet_transcripts',
    'meet_transcript_analyses',
    'meet_waiting_room',
    'meetings',
    // announcements + kudos + activity + project fields
    'announcements',
    'announcement_reactions',
    'kudos',
    'standup_activity',
    'activity_events',
    'project_fields'
]);
const $ceeb25fc2fc26131$export$d5dc34adaaba13d7 = (root)=>root?.jwtClaims?.active_workspace_id || null;
const $ceeb25fc2fc26131$export$1bcdbdc5bd168d8 = (root)=>!!$ceeb25fc2fc26131$export$d5dc34adaaba13d7(root);
const $ceeb25fc2fc26131$export$6783dd0ec17b2bbb = (root, table)=>{
    const sb = (0, $8RlGv.getSupabase)();
    const q = sb.from(table);
    if (!(0, $bdIjZ.USE_MULTITENANT)) return q;
    if (!$ceeb25fc2fc26131$export$ba510865687871cf.has(table)) return q;
    const wsId = $ceeb25fc2fc26131$export$d5dc34adaaba13d7(root);
    if (!wsId) return q // no active workspace yet → let RLS decide (will return empty)
    ;
    return q.eq('workspace_id', wsId);
};
const $ceeb25fc2fc26131$export$b8d75fc98b3e171c = (root, table, row)=>{
    const sb = (0, $8RlGv.getSupabase)();
    if ((0, $bdIjZ.USE_MULTITENANT) && $ceeb25fc2fc26131$export$ba510865687871cf.has(table)) {
        const wsId = $ceeb25fc2fc26131$export$d5dc34adaaba13d7(root);
        if (wsId) row = {
            ...row,
            workspace_id: wsId
        };
    }
    return sb.from(table).insert(row);
};
const $ceeb25fc2fc26131$export$f58b931a89ef67ce = (root, table)=>{
    const sb = (0, $8RlGv.getSupabase)();
    return sb.from(table).update // returns function — caller .update({...}).eq(...)
    ;
};
const $ceeb25fc2fc26131$export$1c197b210274bf54 = (root, table, event = '*', extraFilter = null)=>{
    const sb = (0, $8RlGv.getSupabase)();
    const channelName = `rt-${table}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
    const ch = sb.channel(channelName);
    const filters = [];
    if ((0, $bdIjZ.USE_MULTITENANT) && $ceeb25fc2fc26131$export$ba510865687871cf.has(table)) {
        const wsId = $ceeb25fc2fc26131$export$d5dc34adaaba13d7(root);
        if (wsId) filters.push(`workspace_id=eq.${wsId}`);
    }
    if (extraFilter) filters.push(extraFilter);
    const filter = filters.join(',') || undefined;
    return {
        channel: ch,
        event: event,
        table: table,
        filter: filter,
        channelName: channelName
    };
};

});
parcelRegister("bdIjZ", function(module, exports) {

$parcel$export(module.exports, "USE_FINANCIALS_PROJECT", () => $82b349e43c0c6d1a$export$1a681483c8a4e7b5);
$parcel$export(module.exports, "USE_MULTITENANT", () => $82b349e43c0c6d1a$export$7f155ea6d757f29);
$parcel$export(module.exports, "DUAL_WRITE_FINANCIALS", () => $82b349e43c0c6d1a$export$2ff542b96ee4bece);
$parcel$export(module.exports, "USE_PROFILES_OVERLAY", () => $82b349e43c0c6d1a$export$f9c40da90d757778);
$parcel$export(module.exports, "USE_ONBOARDING_GATE", () => $82b349e43c0c6d1a$export$51a4cb17b0ed5f3c);
// Single source of truth for intranet feature flags. Every flag lives
// here so flipping one at cutover time is a one-line edit with a
// visible blast radius. Importing call-sites stay flag-agnostic — they
// read the constant and branch.
//
// Flip order when the server is ready (details in
// NEEDED_FOR_INTRANET_CLIENT.md):
//
//   1. USE_FINANCIALS_PROJECT   — reads grants from financials project
//   2. USE_MULTITENANT          — scopedClient filters by workspace_id
//   3. DUAL_WRITE_FINANCIALS    — grantsWriter mirrors writes to financials
// Governance reads grants + company_settings from the financials
// Supabase project via finance-features/grants instead of direct
// governance tables. Requires server to emit `orgs[]` in JWT claims
// so financials RLS admin policies pass.
const $82b349e43c0c6d1a$export$1a681483c8a4e7b5 = true;
const $82b349e43c0c6d1a$export$7f155ea6d757f29 = true;
const $82b349e43c0c6d1a$export$2ff542b96ee4bece = true;
const $82b349e43c0c6d1a$export$f9c40da90d757778 = true;
const $82b349e43c0c6d1a$export$51a4cb17b0ed5f3c = true;

});



parcelRegister("1o8nJ", function(module, exports) {

$parcel$export(module.exports, "clearWorkspaceSwitchFallback", () => $102e88c5a9a3f9a7$export$b0a763c3ca50cce0);
$parcel$export(module.exports, "AppWorkspaceSwitcher", () => $102e88c5a9a3f9a7$export$c5761d0947018f55);
$parcel$export(module.exports, "AppOrgSwitcherItem", () => $102e88c5a9a3f9a7$export$49a29de5aebddbba);
$parcel$export(module.exports, "AppWorkspaceSwitchOverlay", () => $102e88c5a9a3f9a7$export$3b30791931ac8959);
// Org switcher. The intranet is an org-level product (MODEL.md inv 15):
// each team-org has one "home" workspace (`type:'shared'`, aka the HQ
// workspace) that backs chat, tickets, docs, meet, KB, etc. Workspaces
// exist for billing boundaries in the editor — not for collab scoping.
//
// This component lets the user pick which org's intranet to view.
// Activation goes through `el.sdk.switchWorkspace(homeWsId)` — the SDK
// owns the federation/refresh round-trip; the frontend never reaches
// directly into sdk-bridge. RLS picks up the new active_workspace_id
// from the refreshed JWT and re-scopes every tenant-table query.
//
// Renders whenever the user belongs to at least one team org. A "+ Create
// organization" footer link is always present.
//
// NOTE: the component name is kept as AppWorkspaceSwitcher for
// backwards compatibility with callers (IntranetAppHeader +
// CanvasAppHeader). It's an org switcher now.
// Module-level guard timer: cleared by app.js's onWorkspaceChange when the
// claims-change path fires successfully. If it doesn't fire within 5 s the
// timer falls back to a full reload so the overlay never hangs.
let $102e88c5a9a3f9a7$var$_wsFallbackTimer = null;
const $102e88c5a9a3f9a7$export$b0a763c3ca50cce0 = ()=>{
    if ($102e88c5a9a3f9a7$var$_wsFallbackTimer) {
        clearTimeout($102e88c5a9a3f9a7$var$_wsFallbackTimer);
        $102e88c5a9a3f9a7$var$_wsFallbackTimer = null;
    }
};
const $102e88c5a9a3f9a7$var$_orgs = (root)=>{
    const raw = root?.jwtClaims?.orgs;
    return Array.isArray(raw) ? raw : [];
};
const $102e88c5a9a3f9a7$var$_workspaces = (root)=>{
    const raw = root?.jwtClaims?.workspaces;
    if (!Array.isArray(raw)) return [];
    return raw;
};
const $102e88c5a9a3f9a7$var$_activeWsId = (root)=>root?.jwtClaims?.active_workspace_id || '';
// Find the home workspace for an org. Preference order:
//   1. type === 'shared' (server convention for team/HQ workspaces)
//   2. type === 'hq' (reserved if/when server adds it)
//   3. first workspace in that org by claim order
const $102e88c5a9a3f9a7$var$_homeWorkspace = (org, root)=>{
    const wss = $102e88c5a9a3f9a7$var$_workspaces(root).filter((w)=>(w.org_id || w.organization) === org.id);
    return wss.find((w)=>w.type === 'hq') || wss.find((w)=>w.type === 'shared') || wss[0] || null;
};
// Returns the org the UI should treat as active. Prefers the optimistic
// `_pendingActiveOrgId` (set the moment the user picks an org) over the
// JWT-derived id (which only updates after a server round-trip + JWT
// refresh — easily 1–5 s of staleness). Falls through to the JWT-active
// workspace's org when no pending pick is in flight, then to the first
// org in the claim list as a last-resort default.
const $102e88c5a9a3f9a7$var$_activeOrg = (root)=>{
    const orgs = $102e88c5a9a3f9a7$var$_orgs(root);
    const pendingId = root?._pendingActiveOrgId;
    if (pendingId) {
        const pending = orgs.find((o)=>o.id === pendingId);
        if (pending) return pending;
    }
    const activeId = $102e88c5a9a3f9a7$var$_activeWsId(root);
    const w = $102e88c5a9a3f9a7$var$_workspaces(root).find((x)=>(x.id || x.workspace_id || x._id) === activeId);
    if (!w) return orgs[0] || null;
    return orgs.find((o)=>o.id === (w.org_id || w.organization)) || null;
};
const $102e88c5a9a3f9a7$export$c5761d0947018f55 = {
    hide: (el, s)=>$102e88c5a9a3f9a7$var$_orgs(s.root).length < 1,
    position: 'relative',
    flow: 'x',
    align: 'center left',
    Trigger: {
        tag: 'button',
        type: 'button',
        flow: 'x',
        align: 'center center',
        gap: 'V',
        padding: '- Z1',
        round: 'Z',
        border: 'none',
        background: 'transparent',
        cursor: 'pointer',
        fontSize: 'Z2',
        fontWeight: '600',
        color: 'title',
        ':hover': {
            background: 'overlay'
        },
        onClick: (e, el, s)=>{
            e.stopPropagation();
            s.root.update({
                _wsMenuOpen: !s.root._wsMenuOpen
            });
        },
        Label: {
            tag: 'span',
            text: (el, s)=>$102e88c5a9a3f9a7$var$_activeOrg(s.root)?.name || 'Organization'
        },
        Chevron: {
            tag: 'span',
            fontSize: 'Y2',
            opacity: '.6',
            text: "\u25BE"
        }
    },
    Menu: {
        // `display` is the gate (block when open, none when closed) — opacity-
        // toggling via reactive `opacity:` was not re-firing on state changes
        // in v3.14, so the menu stayed transparent even after _wsMenuOpen
        // flipped to true. `hide:` returns true for closed state and DOMQL
        // sets display:none predictably across renders.
        hide: (el, s)=>!s.root?._wsMenuOpen,
        position: 'absolute',
        top: '110%',
        left: '0',
        zIndex: '200',
        minWidth: 'G',
        flow: 'y',
        padding: 'Z',
        round: 'Z',
        background: 'overlayStrong',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'line',
        boxShadow: '0 8px 24px var(--color-shadow)',
        onCreate: (el, s)=>{
            el._close = (ev)=>{
                if (!el.node?.parentElement) return;
                if (el.node.parentElement.contains(ev.target)) return;
                s.root.update({
                    _wsMenuOpen: false
                });
            };
            document.addEventListener('mousedown', el._close);
        },
        onRemove: (el)=>{
            if (el._close) document.removeEventListener('mousedown', el._close);
        },
        Orgs: {
            flow: 'y',
            childExtends: 'AppOrgSwitcherItem',
            childrenAs: 'state',
            children: (el, s)=>$102e88c5a9a3f9a7$var$_orgs(s.root)
        },
        Divider: {
            height: '1px',
            background: 'line',
            margin: 'Z 0'
        },
        CreateOrg: {
            extends: 'Link',
            href: (el)=>el.call('canvasUrl', '/organizations/new'),
            attr: {
                target: '_blank',
                rel: 'noopener'
            },
            padding: 'Z1 A',
            round: 'Y',
            fontSize: 'Z2',
            color: 'caption',
            textDecoration: 'none',
            ':hover': {
                background: 'overlay',
                color: 'title'
            },
            text: '+ Create organization'
        }
    }
};
const $102e88c5a9a3f9a7$export$49a29de5aebddbba = {
    tag: 'button',
    type: 'button',
    flow: 'x',
    align: 'center left',
    gap: 'Z1',
    width: '100%',
    padding: 'Z1 A',
    round: 'Y',
    border: 'none',
    background: (el, s)=>{
        const active = $102e88c5a9a3f9a7$var$_activeOrg(s.root);
        return active && active.id === s.id ? 'overlay' : 'transparent';
    },
    cursor: 'pointer',
    fontSize: 'Z2',
    fontWeight: '500',
    color: 'title',
    textAlign: 'left',
    ':hover': {
        background: 'overlay'
    },
    Name: {
        tag: 'span',
        flex: '1',
        text: (el, s)=>s.name
    },
    // Per-org attention badge. Reads from `root.orgNotifCount[orgId]` —
    // a simple count keyed by org id. Populated by whatever cross-org
    // notifications aggregator lands server-side (see NEEDED_FOR_SERVER
    // §I8); renders an empty string when the count is 0/undefined so the
    // slot stays invisible rather than showing stale layout.
    NotifBadge: {
        tag: 'span',
        fontSize: 'Y2',
        fontWeight: '700',
        color: 'white',
        background: 'red',
        round: 'C',
        padding: 'V Z',
        minWidth: 'Z1',
        textAlign: 'center',
        text: (el, s)=>{
            const count = s.root?.orgNotifCount?.[s.id] || 0;
            return count > 0 ? count > 99 ? '99+' : String(count) : '';
        },
        // Collapse the badge entirely when count is 0. Using visibility
        // keeps the flex gap consistent; display:none would cause layout
        // jitter on state updates in DOMQL v3.14.
        display: (el, s)=>{
            const count = s.root?.orgNotifCount?.[s.id] || 0;
            return count > 0 ? 'inline-block' : 'none';
        }
    },
    Role: {
        tag: 'span',
        fontSize: 'Y2',
        color: 'caption',
        opacity: '.7',
        text: (el, s)=>s.role || 'member'
    },
    Check: {
        tag: 'span',
        color: 'green',
        text: (el, s)=>{
            const active = $102e88c5a9a3f9a7$var$_activeOrg(s.root);
            return active && active.id === s.id ? "\u2713" : '';
        }
    },
    onClick: async (e, el, s)=>{
        e.stopPropagation();
        const active = $102e88c5a9a3f9a7$var$_activeOrg(s.root);
        if (active && active.id === s.id) {
            // Already on this org — just close the menu, no work to do.
            s.root.update({
                _wsMenuOpen: false
            });
            return;
        }
        const home = $102e88c5a9a3f9a7$var$_homeWorkspace(s, s.root);
        if (!home) {
            s.root.update({
                _wsMenuOpen: false
            });
            console.warn('[AppOrgSwitcher] org has no home workspace:', s.id);
            return;
        }
        const targetId = home.id || home.workspace_id || home._id;
        // Optimistic UI: flip the dropdown's active state THIS tick so the
        // Trigger label and the row's checkmark/highlight reflect the user's
        // pick instantly. The "Switching to <org>…" overlay paints alongside
        // for slow round-trips. `_pendingActiveOrgId` is read by `_activeOrg`
        // and clears once the JWT refresh lands (or on failure below).
        s.root.update({
            _wsMenuOpen: false,
            _pendingActiveOrgId: s.id,
            _wsSwitching: s.name || 'workspace'
        });
        try {
            const result = await el.sdk.switchWorkspace(targetId);
            if (!result?.ok) {
                // Revert the optimistic pick — JWT didn't actually move.
                s.root.update({
                    _wsSwitching: null,
                    _pendingActiveOrgId: null
                });
                const rawErr = result?.error?.message || result?.error || 'unknown error';
                console.warn('[AppOrgSwitcher] switch failed:', rawErr);
                // Surface the failure so the user understands why the dropdown
                // snapped back. The most common case is a server-side
                // membership mismatch (governance JWT lists a workspace the
                // Symbols API's `/auth/switch-workspace` endpoint disagrees
                // about) — translate that to an admin-actionable message.
                const isMembershipErr = /not a member of target workspace/i.test(String(rawErr));
                el.call('openNotification', {
                    title: `Couldn't switch to ${s.name || 'workspace'}`,
                    message: isMembershipErr ? "The server says you're not a member of that workspace. The org sidebar shows you as a member \u2014 that's a backend consistency bug. Ask an admin to re-add you, or contact support." : String(rawErr),
                    type: 'error'
                });
                return;
            }
            // The JWT refresh emitted by the federation triggers an
            // onAuthStateChange(TOKEN_REFRESHED) event which subscribeAuthSession
            // detects as a workspace change (active_workspace_id changed).
            // The onWorkspaceChange callback in app.js re-fetches all
            // workspace-scoped data and clears _wsSwitching + _pendingActiveOrgId
            // — no reload needed.
            //
            // If the onAuthStateChange event does not fire within 5 s (Supabase
            // WS not available, e.g. offline), fall back to a full reload so the
            // user is never left staring at the overlay indefinitely.
            $102e88c5a9a3f9a7$export$b0a763c3ca50cce0();
            $102e88c5a9a3f9a7$var$_wsFallbackTimer = setTimeout(()=>{
                $102e88c5a9a3f9a7$var$_wsFallbackTimer = null;
                if (s.root?._wsSwitching && typeof window !== 'undefined') {
                    console.warn("[AppOrgSwitcher] onWorkspaceChange timeout \u2014 falling back to reload");
                    window.location.reload();
                }
            }, 5000);
        } catch (err) {
            s.root.update({
                _wsSwitching: null,
                _pendingActiveOrgId: null
            });
            const msg = err?.message || String(err) || 'unknown error';
            console.warn('[AppOrgSwitcher] switch threw:', msg);
            el.call('openNotification', {
                title: `Couldn't switch to ${s.name || 'workspace'}`,
                message: msg,
                type: 'error'
            });
        }
    }
};
const $102e88c5a9a3f9a7$export$3b30791931ac8959 = {
    hide: (el, s)=>!s.root?._wsSwitching,
    position: 'fixed',
    inset: '0',
    zIndex: '1000',
    background: 'black.85',
    backdropFilter: 'blur(8px)',
    align: 'center center',
    flow: 'column',
    gap: 'A',
    Label: {
        tag: 'p',
        color: 'title',
        fontSize: 'Z1',
        fontWeight: '600',
        margin: '0',
        text: (el, s)=>`Switching to ${s.root?._wsSwitching || 'workspace'}\u{2026}`
    }
};

});

parcelRegister("3ihxA", function(module, exports) {

$parcel$export(module.exports, "DOC_FOLDERS", () => $2660a8c34ddfe582$export$311b086aef03ae07);
$parcel$export(module.exports, "KB_CATEGORIES", () => $2660a8c34ddfe582$export$5b10e3fe3de90251);
$parcel$export(module.exports, "default", () => $2660a8c34ddfe582$export$2e2bcd8739ae039);

var $cxvtm = parcelRequire("cxvtm");
const $2660a8c34ddfe582$var$_today = new Date();
const $2660a8c34ddfe582$export$311b086aef03ae07 = Object.freeze([
    {
        key: 'all',
        label: 'All documents',
        icon: 'folder'
    },
    {
        key: 'company',
        label: 'Company',
        icon: 'flag'
    },
    {
        key: 'legal',
        label: 'Legal',
        icon: 'bookmark'
    },
    {
        key: 'finance',
        label: 'Finance',
        icon: 'document'
    },
    {
        key: 'people',
        label: 'People & HR',
        icon: 'people'
    },
    {
        key: 'engineering',
        label: 'Engineering',
        icon: 'code'
    },
    {
        key: 'design',
        label: 'Design',
        icon: 'eye'
    }
]);
const $2660a8c34ddfe582$export$5b10e3fe3de90251 = Object.freeze([
    {
        key: 'all',
        label: 'All articles',
        icon: 'document'
    },
    {
        key: 'getting-started',
        label: 'Getting Started',
        icon: 'star'
    },
    {
        key: 'engineering',
        label: 'Engineering',
        icon: 'code'
    },
    {
        key: 'design',
        label: 'Design System',
        icon: 'eye'
    },
    {
        key: 'policies',
        label: 'Policies',
        icon: 'bookmark'
    },
    {
        key: 'tools',
        label: 'Tools & Infra',
        icon: 'settings'
    }
]);
var $2660a8c34ddfe582$export$2e2bcd8739ae039 = {
    isRootState: true,
    currentUserEmail: '',
    currentUserId: '',
    signedIn: false,
    companyName: 'Symbols',
    // Auth claims + org context — populated by subscribeAuthSession from the
    // governance JWT. Without these declared, smbls 3.14 silently drops the
    // updates and org switching / People filter / role gates all break.
    jwtClaims: null,
    orgs: [],
    workspaces: [],
    org: null,
    workspace: null,
    _wsSwitching: null,
    // Optimistic-pick override for AppWorkspaceSwitcher. When the user
    // clicks an org in the dropdown, this gets set to the picked org id
    // so `_activeOrg(root)` (and thus the Trigger label + checkmark)
    // reflects the choice this same tick instead of waiting for the
    // server's JWT refresh. Cleared once the workspace-change handler
    // fires (or on switch error).
    _pendingActiveOrgId: null,
    _wsRefreshing: false,
    _loginLoading: false,
    orgNotifCount: {},
    orgNotifSignals: {},
    // Financials project data (PROJECT_FINANCIALS optional federation).
    companySettings: null,
    userGrants: [],
    valuations: [],
    selectedGroup: null,
    selectedRole: null,
    currentPath: typeof window !== 'undefined' ? window.location.pathname : '/',
    navSearchQuery: '',
    navSearchResults: [],
    _navSearchGrouped: [],
    _navSearchLoading: false,
    _navSearchOpen: false,
    navUnreadCounts: {},
    contentSection: null,
    people: [],
    peopleAll: [],
    teams: [],
    teamsByEmail: {},
    orgMembersByOrgId: {},
    userDocs: [],
    userPrefs: null,
    resourceLinks: [],
    _wsMenuOpen: false,
    announcements: [],
    selectedAnnouncement: null,
    stories: [],
    birthdays: [],
    companyInfo: [],
    roles: {
        available: [],
        byUser: {},
        version: 0
    },
    // ── Calendar ──
    viewMode: 'week',
    currentYear: $2660a8c34ddfe582$var$_today.getFullYear(),
    currentMonth: $2660a8c34ddfe582$var$_today.getMonth(),
    currentDay: $2660a8c34ddfe582$var$_today.getDate(),
    currentMinutes: $2660a8c34ddfe582$var$_today.getHours() * 60 + $2660a8c34ddfe582$var$_today.getMinutes(),
    selectedEvent: null,
    showNewBooking: false,
    showEventDetail: false,
    selectedPerson: null,
    profileEmail: null,
    profileModalTab: 'profile',
    dragPreview: null,
    quickCreate: null,
    hoverTime: null,
    teamMembers: [],
    onlineUsers: [],
    newBooking: {
        title: '',
        date: (0, $cxvtm.todayISO)(),
        startTime: '09:00',
        endTime: '10:00',
        invitees: '',
        inviteeQuery: '',
        description: '',
        type: 'meeting',
        meetingMode: 'symbols-meet',
        recurring: 'none',
        recurringDays: [],
        editingEventId: null
    },
    events: [],
    // ── Tickets ──
    columns: [],
    tickets: [],
    loadedByColumn: {},
    totalByColumn: {},
    loadingColumn: {},
    epicOptions: [],
    epicCounts: {},
    myTickets: [],
    recentTickets: [],
    myViewQueueOpen: false,
    _activityData: {},
    _todayUpdate: null,
    _dailyDraft: '',
    _dailyUpdates: [],
    _standupMessages: [],
    _standupUserName: '',
    _standupHistory: {},
    _standupPhase: 'idle',
    _standupSummary: '',
    _standupActions: [],
    _standupFollowUps: [],
    _ticketComments: [],
    _mentionModal: {
        open: false
    },
    filterAssignee: null,
    filterLabel: null,
    searchQuery: '',
    // ── Requests ──
    // Backed by workspace-project SDK fetches (`requests.{customer,inbound,outbound}`,
    // `audit.reports`). Pages drive content from these arrays, so any seed
    // value (fixture rows, demo content) ships to every signed-in user. Keep
    // these empty so the empty-state UX and the real backend wiring own
    // what users see.
    customerRequests: [],
    inboundRequests: [],
    outboundRequests: [],
    auditReports: [],
    // ── Resolutions ──
    // Same reasoning as the request arrays above — empty until the
    // workspace-project backend serves the real rows for suggestions /
    // ai-improvement-prompts / pull-requests under the active workspace.
    suggestions: [],
    improvementRequests: [],
    editRequests: [],
    selectedTicket: null,
    ticketDraft: null,
    ticketEditMode: false,
    activeDrag: null,
    dropPreview: null,
    syncing: false,
    // ── Chat ──
    channels: [],
    channelMembers: [],
    activeChannelId: null,
    showNewChannel: false,
    newChannelDraft: {
        name: '',
        topic: '',
        kind: 'channel',
        is_private: false,
        members: []
    },
    messagesByChannel: {},
    activeThreadRootId: null,
    presence: {},
    typingByChannel: {},
    reactionsByMessage: {},
    myMentions: [],
    collapsedGroups: {},
    searchOpen: false,
    searchResults: [],
    mentionPicker: null,
    sidebarDropdown: {
        open: false
    },
    _hiddenChannels: [],
    _pinnedChannels: [],
    renameModal: {
        open: false
    },
    pendingAttachments: {},
    composerDraft: {},
    composerPreview: false,
    chatVisibleCounts: null,
    activeTab: 'conversation',
    showFilterBar: false,
    filters: {
        authorEmail: null,
        hasAttachments: false,
        hasMentions: false,
        query: ''
    },
    // ── Documents ──
    activeSection: 'documents',
    selectedFolder: 'all',
    selectedDocument: null,
    docsQuery: '',
    documents: [],
    selectedNoteId: null,
    notesFilter: 'all',
    notes: [],
    editorDoc: null,
    editorMode: null,
    kbQuery: '',
    selectedCategory: 'all',
    kbArticles: [],
    // ── Lightbox ──
    lightbox: null,
    // ── AI Assistant ──
    assistantOpen: false,
    assistantMessages: [],
    assistantTyping: false,
    assistantAttachment: null,
    // ── Notifications ──
    notifications: [],
    notificationsPanelOpen: false
};

});

parcelRegister("81UX8", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d8a985e6b911306$export$2e2bcd8739ae039);
// ── Intranet ──

var $jEfZu = parcelRequire("jEfZu");

var $l2NMb = parcelRequire("l2NMb");

var $2Ocvl = parcelRequire("2Ocvl");

var $d9VuD = parcelRequire("d9VuD");

var $6eHCP = parcelRequire("6eHCP");

var $8IMAu = parcelRequire("8IMAu");
parcelRequire("lSTjH");
var $5nhB0 = parcelRequire("5nhB0");
var $g7qnn = parcelRequire("g7qnn");
var $7U7d8 = parcelRequire("7U7d8");
var $5yqCy = parcelRequire("5yqCy");
var $fTOLm = parcelRequire("fTOLm");
var $kHSc9 = parcelRequire("kHSc9");
var $f9P05 = parcelRequire("f9P05");
var $8SCVM = parcelRequire("8SCVM");
var $aNbvv = parcelRequire("aNbvv");
var $1NvTc = parcelRequire("1NvTc");
var $9aGUO = parcelRequire("9aGUO");
var $20yT1 = parcelRequire("20yT1");
var $9wOaP = parcelRequire("9wOaP");
var $64fWd = parcelRequire("64fWd");
var $dLzC2 = parcelRequire("dLzC2");
var $2ruDb = parcelRequire("2ruDb");
var $la1ZO = parcelRequire("la1ZO");
var $hn0tZ = parcelRequire("hn0tZ");
var $bRgwR = parcelRequire("bRgwR");
var $4ciii = parcelRequire("4ciii");
var $15Vhj = parcelRequire("15Vhj");

var $4kOC6 = parcelRequire("4kOC6");

var $dqa5T = parcelRequire("dqa5T");

var $jawME = parcelRequire("jawME");

var $OZX3c = parcelRequire("OZX3c");

var $9JY5k = parcelRequire("9JY5k");

var $d8OdG = parcelRequire("d8OdG");

var $84zNI = parcelRequire("84zNI");

var $9WPl1 = parcelRequire("9WPl1");

var $7sHA6 = parcelRequire("7sHA6");

var $hkANY = parcelRequire("hkANY");

var $e2MYa = parcelRequire("e2MYa");

var $giliy = parcelRequire("giliy");

var $bHGYW = parcelRequire("bHGYW");

var $jCCTJ = parcelRequire("jCCTJ");

var $72ZTw = parcelRequire("72ZTw");

var $d9Ira = parcelRequire("d9Ira");

var $6BYXL = parcelRequire("6BYXL");

var $jHQvm = parcelRequire("jHQvm");

var $2h5R8 = parcelRequire("2h5R8");

var $3UggQ = parcelRequire("3UggQ");

var $iHT10 = parcelRequire("iHT10");

var $abrJA = parcelRequire("abrJA");
var $5d8a985e6b911306$export$2e2bcd8739ae039 = {
    // Intranet
    '/': (0, $jEfZu.main),
    '/people': (0, $l2NMb.people),
    '/my': (0, $2Ocvl.my),
    '/announcements': (0, $d9VuD.announcements),
    '/company': (0, $6eHCP.company),
    '/profile': (0, $la1ZO.profile),
    '/login': (0, $2ruDb.login),
    '/signin': (0, $bRgwR.signin),
    '/signup': (0, $4ciii.signup),
    '/signup-confirmation': (0, $15Vhj.signupConfirmation),
    '/reset-password': (0, $hn0tZ.resetPassword),
    '/data': (0, $8IMAu.data),
    '/data/projects': (0, $8IMAu.data),
    '/data/users': (0, $8IMAu.data),
    '/data/plans': (0, $8IMAu.data),
    '/data/organizations': (0, $8IMAu.data),
    '/data/teams': (0, $8IMAu.data),
    '/data/subscriptions': (0, $8IMAu.data),
    '/data/external': (0, $iHT10.dataExternal),
    // Calendar
    '/calendar': (0, $4kOC6.home),
    // Tickets
    '/tickets': (0, $dqa5T.myView),
    '/tickets/general': (0, $OZX3c.general),
    '/tickets/feed': (0, $9JY5k.feed),
    '/tickets/canvas': (0, $d8OdG.canvas),
    '/tickets/stories': (0, $84zNI.stories),
    '/tickets/epics': (0, $9WPl1.epics),
    '/tickets/board': (0, $jawME.home),
    '/tickets/status': (0, $3UggQ.ticketsStatus),
    '/tickets/standups': (0, $7sHA6.standups),
    // Requests
    '/tickets/requests': (0, $hkANY.requests),
    '/tickets/requests/inbound': (0, $hkANY.requestsInbound),
    '/tickets/requests/outbound': (0, $hkANY.requestsOutbound),
    '/tickets/requests/audit': (0, $hkANY.requestsAudit),
    // Resolutions
    '/tickets/resolutions': (0, $e2MYa.resolutions),
    '/tickets/resolutions/improvements': (0, $e2MYa.resolutionsImprovements),
    '/tickets/resolutions/edit-requests': (0, $e2MYa.resolutionsEditRequests),
    // Chat
    '/chat': (0, $giliy.home),
    // Documents
    '/docs': (0, $bHGYW.home),
    '/documents': (0, $bHGYW.home),
    '/documents/notes': (0, $jCCTJ.notes),
    '/documents/knowledge-base': (0, $72ZTw.knowledgeBase),
    '/documents/kb': (0, $72ZTw.knowledgeBase),
    '/documents/editor': (0, $d9Ira.editor),
    // Meet
    '/meet': (0, $6BYXL.home),
    '/meet-guest': (0, $jHQvm.guest),
    // System
    '/system': (0, $2h5R8.system),
    '/features': (0, $3UggQ.features),
    // Admin
    '/admin': (0, $5nhB0.admin),
    '/admin/cap-table': (0, $dLzC2.capTable),
    '/admin/teams': (0, $64fWd.adminTeams),
    '/admin/permissions': (0, $20yT1.adminPermissions),
    '/admin/activity-scoring': (0, $g7qnn.adminActivityScoring),
    '/admin/logs': (0, $9aGUO.adminLogs),
    '/admin/integrations': (0, $5yqCy.adminIntegrations),
    '/admin/integrations/supabase': (0, $1NvTc.adminIntegrationsSupabase),
    '/admin/integrations/github': (0, $kHSc9.adminIntegrationsGithub),
    '/admin/integrations/google': (0, $f9P05.adminIntegrationsGoogle),
    '/admin/integrations/npm': (0, $aNbvv.adminIntegrationsNpm),
    '/admin/integrations/openai': (0, $fTOLm.adminIntegrationsGeneric),
    '/admin/integrations/livekit': (0, $fTOLm.adminIntegrationsGeneric),
    '/admin/integrations/google_analytics': (0, $fTOLm.adminIntegrationsGeneric),
    '/admin/integrations/n8n': (0, $fTOLm.adminIntegrationsGeneric),
    '/admin/integrations/custom_http': (0, $fTOLm.adminIntegrationsGeneric),
    // Marketplace-seeded kinds (migration 0063). All use the generic
    // detail page — which reads config_schema.fields from the kind row
    // so no bespoke code per kind. Add to this list AND to 0063 together.
    '/admin/integrations/plausible': (0, $fTOLm.adminIntegrationsGeneric),
    '/admin/integrations/posthog': (0, $fTOLm.adminIntegrationsGeneric),
    '/admin/integrations/segment': (0, $fTOLm.adminIntegrationsGeneric),
    '/admin/integrations/mixpanel': (0, $fTOLm.adminIntegrationsGeneric),
    '/admin/integrations/firebase': (0, $fTOLm.adminIntegrationsGeneric),
    '/admin/integrations/cloudflare_workers': (0, $fTOLm.adminIntegrationsGeneric),
    '/admin/integrations/vercel': (0, $fTOLm.adminIntegrationsGeneric),
    '/admin/integrations/aws': (0, $fTOLm.adminIntegrationsGeneric),
    '/admin/integrations/postgres': (0, $fTOLm.adminIntegrationsGeneric),
    '/admin/integrations/mongodb': (0, $fTOLm.adminIntegrationsGeneric),
    '/admin/integrations/planetscale': (0, $fTOLm.adminIntegrationsGeneric),
    '/admin/integrations/neon': (0, $fTOLm.adminIntegrationsGeneric),
    '/admin/integrations/redis': (0, $fTOLm.adminIntegrationsGeneric),
    '/admin/integrations/zapier': (0, $fTOLm.adminIntegrationsGeneric),
    '/admin/integrations/make': (0, $fTOLm.adminIntegrationsGeneric),
    '/admin/integrations/temporal': (0, $fTOLm.adminIntegrationsGeneric),
    '/admin/integrations/auth0': (0, $fTOLm.adminIntegrationsGeneric),
    '/admin/integrations/clerk': (0, $fTOLm.adminIntegrationsGeneric),
    '/admin/integrations/workos': (0, $fTOLm.adminIntegrationsGeneric),
    '/admin/integrations/stripe': (0, $fTOLm.adminIntegrationsGeneric),
    '/admin/integrations/paddle': (0, $fTOLm.adminIntegrationsGeneric),
    '/admin/integrations/lemonsqueezy': (0, $fTOLm.adminIntegrationsGeneric),
    '/admin/integrations/anthropic': (0, $fTOLm.adminIntegrationsGeneric),
    '/admin/integrations/replicate': (0, $fTOLm.adminIntegrationsGeneric),
    '/admin/integrations/pinecone': (0, $fTOLm.adminIntegrationsGeneric),
    '/admin/integrations/slack': (0, $fTOLm.adminIntegrationsGeneric),
    '/admin/integrations/discord': (0, $fTOLm.adminIntegrationsGeneric),
    '/admin/integrations/twilio': (0, $fTOLm.adminIntegrationsGeneric),
    '/admin/integrations/sendgrid': (0, $fTOLm.adminIntegrationsGeneric),
    '/admin/integrations/resend': (0, $fTOLm.adminIntegrationsGeneric),
    '/admin/integrations/aws_s3': (0, $fTOLm.adminIntegrationsGeneric),
    '/admin/integrations/cloudflare_r2': (0, $fTOLm.adminIntegrationsGeneric),
    '/admin/integrations/uploadthing': (0, $fTOLm.adminIntegrationsGeneric),
    '/admin/integrations/sentry': (0, $fTOLm.adminIntegrationsGeneric),
    '/admin/integrations/datadog': (0, $fTOLm.adminIntegrationsGeneric),
    '/admin/integrations/logrocket': (0, $fTOLm.adminIntegrationsGeneric),
    '/admin/integrations/figma': (0, $fTOLm.adminIntegrationsGeneric),
    '/admin/integrations/mcp': (0, $8SCVM.adminIntegrationsMcp),
    '/admin/status': (0, $9wOaP.adminStatus),
    '/admin/danger': (0, $7U7d8.adminDanger),
    // Cross-origin auth helper. Other Symbols subdomains iframe this page
    // to request the live governance Supabase session, so e.g. the canvas
    // app can read RLS-gated integration rows without a separate signin.
    '/_session-bridge': (0, $abrJA.sessionBridge)
};

});
parcelRegister("jEfZu", function(module, exports) {

$parcel$export(module.exports, "main", () => $e4de282a872315e6$export$f22da7240b7add18);

var $chzVb = parcelRequire("chzVb");
const $e4de282a872315e6$var$_firstName = (name)=>(name || '').split(' ')[0] || 'there';
// Rolling 7-day window from `now`, filtered to where the signed-in user
// is an attendee.
const $e4de282a872315e6$var$_weekEvents = (s)=>{
    const me = s.root.currentUserEmail;
    const now = Date.now();
    const endMs = now + 604800000;
    return (s.root.intranetEvents || []).filter((e)=>{
        const t = e.startAt ? new Date(e.startAt).getTime() : 0;
        if (t < now || t >= endMs) return false;
        return Array.isArray(e.attendees) ? e.attendees.includes(me) : true;
    }).sort((x, y)=>new Date(x.startAt).getTime() - new Date(y.startAt).getTime());
};
let $e4de282a872315e6$var$_clusterCache = {
    peopleRef: null,
    me: null,
    value: []
};
const $e4de282a872315e6$var$_teamClusters = (s)=>{
    const people = s.root.people;
    const me = s.root.currentUserEmail;
    if ($e4de282a872315e6$var$_clusterCache.peopleRef === people && $e4de282a872315e6$var$_clusterCache.me === me) return $e4de282a872315e6$var$_clusterCache.value;
    const buckets = new Map();
    for (const p of people || []){
        if (p.email === me) continue;
        const key = p.location || 'Remote';
        if (!buckets.has(key)) buckets.set(key, {
            city: key,
            timezone: p.timezone,
            members: []
        });
        buckets.get(key).members.push(p);
    }
    const value = [
        ...buckets.values()
    ].slice(0, 12);
    $e4de282a872315e6$var$_clusterCache = {
        peopleRef: people,
        me: me,
        value: value
    };
    return value;
};
const $e4de282a872315e6$var$_section = (icon, intro, body)=>({
        flow: 'x',
        align: 'flex-start',
        gap: 'B',
        IconCol: {
            width: 'C',
            minWidth: 'C',
            align: 'flex-start center',
            color: 'caption',
            SectionIcon: {
                extends: 'Icon',
                icon: icon,
                boxSize: 'B'
            }
        },
        Right: {
            flow: 'y',
            gap: 'A',
            flex: '1',
            Intro: {
                flow: 'x',
                gap: 'Z',
                align: 'baseline',
                flexWrap: 'wrap',
                childExtends: 'IntroRun',
                childrenAs: 'state',
                children: (el, s)=>typeof intro === 'function' ? intro(s) : intro
            },
            Body: body
        }
    });
const $e4de282a872315e6$export$f22da7240b7add18 = {
    extends: 'Page',
    metadata: {
        title: 'Home / Symbols Workspace'
    },
    flow: 'y',
    padding: 'D C',
    gap: 'E',
    maxWidth: '1480px',
    margin: '0 auto',
    width: '100%',
    Greeting: {
        tag: 'h1',
        fontSize: 'F',
        fontWeight: '300',
        color: 'title',
        letterSpacing: '-0.03em',
        lineHeight: '1.1',
        text: (el, s)=>`Good morning ${$e4de282a872315e6$var$_firstName((0, $chzVb.findMe)(s).name)}!`
    },
    TodaySection: $e4de282a872315e6$var$_section('clock', // Both as a function so the date string isn't frozen at module load.
    ()=>[
            {
                text: 'Today is ',
                color: 'caption'
            },
            {
                text: (0, $chzVb.formatLongDay)(Date.now()),
                color: 'title',
                weight: '700'
            }
        ], {
        flow: 'x',
        gap: 'Z',
        align: 'baseline',
        Now: {
            tag: 'span',
            color: 'title',
            fontWeight: '700',
            fontSize: 'A',
            text: (el, s)=>(0, $chzVb.formatTime)(Date.now(), (0, $chzVb.findMe)(s).timezone)
        },
        In: {
            tag: 'span',
            color: 'caption',
            fontSize: 'A',
            text: (el, s)=>`in ${(0, $chzVb.findMe)(s).location || 'your city'}`
        }
    }),
    EventsSection: $e4de282a872315e6$var$_section('date', (s)=>{
        const n = $e4de282a872315e6$var$_weekEvents(s).length;
        return [
            {
                text: 'You have ',
                color: 'caption'
            },
            {
                text: `${n} event${n === 1 ? '' : 's'}`,
                color: 'green',
                weight: '700'
            },
            {
                text: ' coming up ',
                color: 'caption'
            },
            {
                text: 'in the next 7 days',
                color: 'title',
                weight: '700'
            }
        ];
    }, {
        display: 'grid',
        gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
        gap: 'B',
        childExtends: 'UpcomingEventCard',
        childrenAs: 'state',
        children: (el, s)=>$e4de282a872315e6$var$_weekEvents(s)
    }),
    StoriesSection: $e4de282a872315e6$var$_section('star', (s)=>{
        const stories = s.root.stories || [];
        const tasks = stories.reduce((a, x)=>a + (x.tasks || 0), 0);
        return [
            {
                text: 'You have ',
                color: 'caption'
            },
            {
                text: `${stories.length} stor${stories.length === 1 ? 'y' : 'ies'}`,
                color: 'blue',
                weight: '700'
            },
            {
                text: ' with ',
                color: 'caption'
            },
            {
                text: `${tasks} task${tasks === 1 ? '' : 's'}`,
                color: 'green',
                weight: '700'
            }
        ];
    }, {
        flow: 'y',
        gap: 'B',
        childExtends: 'StoryCard',
        childrenAs: 'state',
        children: (el, s)=>s.root.stories || []
    }),
    BirthdaysSection: $e4de282a872315e6$var$_section('magicstar', [
        {
            text: 'Whom to wish ',
            color: 'caption'
        },
        {
            text: 'happy birthday',
            color: 'title',
            weight: '700'
        }
    ], {
        display: 'grid',
        // auto-fit instead of fixed 5 columns — child `minWidth: 'G'` on
        // CityCluster / BirthdayItem prevented `minmax(0, 1fr)` from
        // compressing, causing horizontal overflow at <1500px viewports.
        // `min(100%, 180px)` lets columns shrink to viewport on phones.
        gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 180px), 1fr))',
        gap: 'D',
        childExtends: 'BirthdayItem',
        childrenAs: 'state',
        children: (el, s)=>s.root.birthdays || []
    }),
    TeamTimeSection: $e4de282a872315e6$var$_section('globe', [
        {
            text: 'Time for your ',
            color: 'caption'
        },
        {
            text: 'team members',
            color: 'title',
            weight: '700'
        }
    ], {
        display: 'grid',
        // Same auto-fit fix as BirthdaysSection — child clusters have
        // their own `minWidth` which fought a fixed 5-column grid.
        gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 180px), 1fr))',
        gap: 'D',
        childExtends: 'CityCluster',
        childrenAs: 'state',
        children: (el, s)=>$e4de282a872315e6$var$_teamClusters(s)
    })
};

});

parcelRegister("l2NMb", function(module, exports) {

$parcel$export(module.exports, "people", () => $f5206562da99e268$export$5c754c0557bd8d37);
const $f5206562da99e268$export$5c754c0557bd8d37 = {
    extends: 'Page',
    metadata: {
        title: 'People / Symbols Workspace'
    },
    flow: 'x',
    align: 'flex-start',
    gap: 'D',
    padding: 'D C',
    maxWidth: 'none',
    margin: '0 auto',
    width: '100%',
    PpRail: {
        flow: 'y',
        gap: 'C',
        width: 'G',
        minWidth: 'G',
        flex: '0 0 auto',
        position: 'sticky',
        top: 'D',
        PpHeading: {
            flow: 'y',
            gap: 'A',
            PpEyebrow: {
                tag: 'span',
                fontSize: 'Z2',
                fontWeight: '700',
                letterSpacing: '0.12em',
                textTransform: 'uppercase',
                color: 'blue',
                text: 'The team'
            },
            PpTitle: {
                tag: 'h1',
                fontSize: 'D',
                fontWeight: '800',
                color: 'title',
                letterSpacing: '-0.03em',
                lineHeight: '1.1',
                margin: '0',
                text: 'People'
            }
        },
        PpCategories: {
            flow: 'y',
            gap: 'Z',
            paddingTop: 'B',
            borderTopWidth: '1px',
            borderTopStyle: 'solid',
            borderTopColor: 'line',
            PpCatHead: {
                tag: 'span',
                fontSize: 'Y2',
                fontWeight: '700',
                color: 'caption',
                textTransform: 'uppercase',
                letterSpacing: '0.08em',
                text: 'Teams'
            },
            PpCatAll: {
                extends: 'PeopleFilterLink',
                state: {
                    name: null,
                    kind: 'group',
                    label: 'Everyone'
                }
            },
            PpCatList: {
                flow: 'y',
                gap: 'Y',
                childExtends: 'PeopleFilterLink',
                childrenAs: 'state',
                children: (el)=>el.call('peopleGroupCategories')
            }
        },
        PpTeamCategories: {
            // Category filter (Active / External) — I11 team-category model.
            // Replaces the legacy Supabase-user-role sidebar.
            flow: 'y',
            gap: 'Z',
            paddingTop: 'B',
            borderTopWidth: '1px',
            borderTopStyle: 'solid',
            borderTopColor: 'line',
            PpTcHead: {
                tag: 'span',
                fontSize: 'Y2',
                fontWeight: '700',
                color: 'caption',
                textTransform: 'uppercase',
                letterSpacing: '0.08em',
                text: 'Category'
            },
            PpTcAll: {
                extends: 'PeopleFilterLink',
                state: {
                    name: null,
                    kind: 'category',
                    label: 'Everyone'
                }
            },
            PpTcList: {
                flow: 'y',
                gap: 'Y',
                childExtends: 'PeopleFilterLink',
                childrenAs: 'state',
                children: (el)=>el.call('peopleTeamCategories')
            }
        }
    },
    PpBody: {
        flow: 'y',
        gap: 'D',
        flex: '1',
        minWidth: '0',
        PpGroups: {
            flow: 'y',
            gap: 'D',
            childExtends: 'PeopleGroupBlock',
            childrenAs: 'state',
            children: (el)=>el.call('groupFilteredPeople')
        }
    }
};

});

parcelRegister("2Ocvl", function(module, exports) {

$parcel$export(module.exports, "my", () => $20b9f36ef4524cd9$export$94fa0a6beb22f989);
const $20b9f36ef4524cd9$export$94fa0a6beb22f989 = {
    extends: 'ContentPage',
    metadata: {
        title: 'My profile / Symbols Workspace'
    },
    eyebrow: 'Account',
    title: 'My profile',
    sections: [
        {
            label: 'Profile'
        },
        {
            label: 'Availability'
        },
        {
            label: 'Equity grant'
        },
        {
            label: 'Documents'
        },
        {
            label: 'Checklist'
        },
        {
            label: 'Security'
        },
        {
            label: 'Notifications'
        },
        {
            label: 'Sessions'
        },
        {
            label: 'Danger zone'
        }
    ],
    PageBody: {
        flow: 'y',
        flex: '1',
        minWidth: '0',
        MemberProfile: {}
    }
};

});

parcelRegister("d9VuD", function(module, exports) {

$parcel$export(module.exports, "announcements", () => $9948b68af163019c$export$d7f3895e994ed5c7);
const $9948b68af163019c$var$_filteredAnnouncements = (s)=>{
    const filter = s.root.contentSection;
    const all = s.root.announcements || [];
    if (!filter || filter === 'All posts') return all;
    const lc = filter.toLowerCase();
    return all.filter((a)=>(a.tag || '').toLowerCase() === lc);
};
const $9948b68af163019c$export$d7f3895e994ed5c7 = {
    extends: 'ContentPage',
    metadata: {
        title: 'Announcements / Symbols Workspace'
    },
    eyebrow: 'The blog',
    title: 'Announcements',
    sections: [
        {
            label: 'All posts'
        },
        {
            label: 'Product'
        },
        {
            label: 'People'
        },
        {
            label: 'Ops'
        }
    ],
    PageBody: {
        flow: 'y',
        gap: 'D',
        flex: '1',
        minWidth: '0',
        Grid: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(440px, 1fr))',
            gap: 'C',
            childExtends: 'AnnouncementCard',
            childrenAs: 'state',
            children: (el, s)=>$9948b68af163019c$var$_filteredAnnouncements(s)
        },
        AnnouncementDetailModal: {}
    }
};

});

parcelRegister("6eHCP", function(module, exports) {

$parcel$export(module.exports, "company", () => $48a5e3f7e9a61d61$export$fd24aeccace07699);
const $48a5e3f7e9a61d61$var$SECTION_KEYS = {
    Overview: [
        'legal_name',
        'jurisdiction'
    ],
    Registration: [
        'registered_agent',
        'address'
    ],
    Address: [
        'registered_office'
    ]
};
const $48a5e3f7e9a61d61$var$_section = (label)=>({
        attr: {
            'data-content-section': label
        },
        flow: 'y',
        gap: 'A',
        padding: 'D',
        round: 'C',
        background: 'overlay',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'line',
        CiTitle: {
            tag: 'h2',
            margin: '0 0 B 0',
            fontSize: 'C',
            fontWeight: '800',
            color: 'title',
            letterSpacing: '-0.01em',
            text: label
        },
        Rows: {
            flow: 'y',
            childExtends: 'CompanyInfoRow',
            childrenAs: 'state',
            children: (el, s)=>{
                const wanted = $48a5e3f7e9a61d61$var$SECTION_KEYS[label] || [];
                return (s.root.companyInfo || []).filter((r)=>wanted.includes(r.key));
            }
        }
    });
const $48a5e3f7e9a61d61$var$RESOURCES = [
    {
        label: 'Pitch Deck',
        url: 'https://docs.google.com/presentation/d/1oarPeQXg-s1uxXYLBQ8pdtq0V8Y-PXlXjYUwB_n5SZY/edit',
        icon: 'document'
    },
    {
        label: 'Landing Page',
        url: 'https://dev.symbols.app',
        icon: 'globe'
    },
    {
        label: 'Platform Docs',
        url: 'https://dev.symbols.app/docs/intro',
        icon: 'book'
    },
    {
        label: 'SDK Docs',
        url: 'https://docs.google.com/document/d/13IAfzS9eUjapnr5PVK6AVZPkRtjTYG9An7P9GMgRrM8/edit',
        icon: 'code'
    },
    {
        label: 'Figma UI Library',
        url: 'https://www.figma.com/file/LDFnKQSxUxZeeLHt2OT67r?node-id=0:1&locale=en&type=design',
        icon: 'eye'
    },
    {
        label: 'GitHub Organization',
        url: 'https://github.com/symbo-ls',
        icon: 'github'
    },
    {
        label: 'npm Packages',
        url: 'https://www.npmjs.com/org/symbo.ls',
        icon: 'code'
    }
];
const $48a5e3f7e9a61d61$export$fd24aeccace07699 = {
    extends: 'ContentPage',
    metadata: {
        title: 'Company / Symbols Workspace'
    },
    eyebrow: 'About',
    title: 'Company',
    sections: [
        {
            label: 'Overview'
        },
        {
            label: 'Valuation'
        },
        {
            label: 'Registration'
        },
        {
            label: 'Address'
        },
        {
            label: 'Resources'
        }
    ],
    PageBody: {
        flow: 'y',
        gap: 'C',
        flex: '1',
        minWidth: '0',
        maxWidth: 'I',
        OverviewCard: $48a5e3f7e9a61d61$var$_section('Overview'),
        ValuationCard: {
            attr: {
                'data-content-section': 'Valuation'
            },
            flow: 'y',
            gap: 'A',
            padding: 'D',
            round: 'C',
            background: 'overlay',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'line',
            CiTitle: {
                tag: 'h2',
                margin: '0 0 B 0',
                fontSize: 'C',
                fontWeight: '800',
                color: 'title',
                letterSpacing: '-0.01em',
                text: 'Valuation'
            },
            CurrentVal: {
                flow: 'x',
                align: 'baseline',
                gap: 'A',
                Amount: {
                    tag: 'span',
                    fontSize: 'E',
                    fontWeight: '800',
                    color: 'title',
                    letterSpacing: '-0.04em',
                    lineHeight: '1',
                    text: (el, s)=>{
                        const v = s.root?.companySettings?.current_valuation;
                        return v ? `$${Number(v).toLocaleString()}` : "\u2014";
                    }
                },
                Label: {
                    tag: 'span',
                    fontSize: 'A',
                    color: 'caption',
                    fontWeight: '600',
                    text: 'current valuation'
                }
            },
            Description: {
                tag: 'p',
                fontSize: 'Z2',
                color: 'caption',
                lineHeight: '1.5em',
                padding: '0 0 B 0',
                margin: '0',
                borderBottomWidth: '1px',
                borderBottomStyle: 'solid',
                borderBottomColor: 'line',
                text: 'Current valuation is determined by the resources and time invested to the building the product, campaigns and brand.'
            },
            RoundsTitle: {
                tag: 'h3',
                fontSize: 'A',
                fontWeight: '700',
                color: 'subtitle',
                margin: 'A 0 0 0',
                text: 'Valuation rounds'
            },
            Rounds: {
                flow: 'y',
                childrenAs: 'state',
                children: (el, s)=>{
                    const v = s.root?.valuations;
                    return v ? v.slice().sort((a, b)=>b.amount - a.amount) : [];
                },
                childExtends: {
                    flow: 'x',
                    align: 'center space-between',
                    gap: 'B',
                    padding: 'A 0',
                    borderBottomWidth: '1px',
                    borderBottomStyle: 'solid',
                    borderBottomColor: 'line',
                    Left: {
                        flow: 'x',
                        align: 'center',
                        gap: 'Z',
                        RoundLabel: {
                            tag: 'span',
                            fontSize: 'A',
                            fontWeight: '700',
                            color: 'title',
                            text: (el, s)=>s.label || "\u2014"
                        },
                        RoundType: {
                            tag: 'span',
                            fontSize: 'Y2',
                            padding: 'V Z',
                            round: 'V',
                            fontWeight: '700',
                            color: 'caption',
                            background: 'overlayStrong',
                            borderWidth: '1px',
                            borderStyle: 'solid',
                            borderColor: 'line',
                            text: (el, s)=>s.round_type || ''
                        },
                        CurrentTag: {
                            hide: (el, s)=>s.is_current !== true,
                            tag: 'span',
                            fontSize: 'Y2',
                            padding: 'V Z',
                            round: 'V',
                            fontWeight: '700',
                            color: 'green',
                            background: 'green.12',
                            text: 'CURRENT'
                        }
                    },
                    Right: {
                        flow: 'y',
                        align: 'flex-end',
                        gap: 'V',
                        Amount: {
                            tag: 'span',
                            fontSize: 'A',
                            fontWeight: '700',
                            color: 'title',
                            text: (el, s)=>`$${Number(s.amount || 0).toLocaleString()}`
                        },
                        DateText: {
                            tag: 'span',
                            fontSize: 'Y2',
                            color: 'caption',
                            text: (el, s)=>s.effective_date || ''
                        }
                    }
                }
            }
        },
        RegistrationCard: $48a5e3f7e9a61d61$var$_section('Registration'),
        AddressCard: $48a5e3f7e9a61d61$var$_section('Address'),
        ResourcesCard: {
            ...$48a5e3f7e9a61d61$var$_section('Resources'),
            Rows: null,
            Links: {
                flow: 'y',
                childrenAs: 'state',
                children: ()=>$48a5e3f7e9a61d61$var$RESOURCES,
                childExtends: {
                    extends: 'Link',
                    href: (el, s)=>s.url,
                    target: '_blank',
                    textDecoration: 'none',
                    flow: 'x',
                    align: 'center space-between',
                    gap: 'B',
                    padding: 'A 0',
                    borderBottomWidth: '1px',
                    borderBottomStyle: 'solid',
                    borderBottomColor: 'line',
                    ':hover': {
                        background: 'overlay'
                    },
                    Left: {
                        flow: 'x',
                        align: 'center left',
                        gap: 'A',
                        Icon: {
                            icon: (el, s)=>s.icon || 'link',
                            boxSize: 'A1',
                            color: 'blue'
                        },
                        Label: {
                            tag: 'span',
                            fontSize: 'B',
                            fontWeight: '600',
                            color: 'title',
                            text: (el, s)=>s.label
                        }
                    },
                    Arrow: {
                        tag: 'span',
                        fontSize: 'Z2',
                        color: 'caption',
                        text: '\u2192'
                    }
                }
            }
        }
    }
};

});

parcelRegister("8IMAu", function(module, exports) {

$parcel$export(module.exports, "data", () => $65981f4068c7b12e$export$4051a07651545597);
$parcel$export(module.exports, "DataPlanFeature", () => $65981f4068c7b12e$export$67abb7f201537511);
$parcel$export(module.exports, "DataPlanFeatureRow", () => $65981f4068c7b12e$export$fcd8c07b3d02baa3);
$parcel$export(module.exports, "DataProjectRow", () => $65981f4068c7b12e$export$4131246133c6bc66);
$parcel$export(module.exports, "DataSubscriptionRow", () => $65981f4068c7b12e$export$56f192ec4234b344);
$parcel$export(module.exports, "DataUserRow", () => $65981f4068c7b12e$export$577e51e824103044);
$parcel$export(module.exports, "DataSidebarLink", () => $65981f4068c7b12e$export$63722944cb99b463);

var $3rsQg = parcelRequire("3rsQg");

var $fLrnc = parcelRequire("fLrnc");

var $3WCJD = parcelRequire("3WCJD");
// Friendly date formatting
const $65981f4068c7b12e$var$_formatDate = (v)=>{
    if (!v) return "\u2014";
    const d = new Date(v);
    if (isNaN(d)) return String(v);
    const now = Date.now();
    const diff = now - d.getTime();
    const mins = Math.floor(diff / 60000);
    if (mins < 1) return 'just now';
    if (mins < 60) return `${mins}m ago`;
    const hrs = Math.floor(mins / 60);
    if (hrs < 24) return `${hrs}h ago`;
    const days = Math.floor(hrs / 24);
    if (days < 7) return `${days}d ago`;
    if (days < 30) return `${Math.floor(days / 7)}w ago`;
    return d.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
    });
};
// Admin check — service token is always admin; governance users are checked on load
const $65981f4068c7b12e$var$_isDataAdmin = ()=>true;
// Tiny cache wrapper that reuses @symbo.ls/fetch's queryClient store so
// data, invalidation, and TTL share a single source of truth with the
// rest of the app. Keys follow the `resource:method:params` convention
// so queryClient.invalidateQueries('projects') nukes every project page.
const $65981f4068c7b12e$var$_cacheMeta = new Map() // key → { time, ttlMs }
;
const $65981f4068c7b12e$var$_cached = async (key, ttl, fn)=>{
    const ttlMs = typeof ttl === 'number' ? ttl : (0, $fLrnc.parseDuration)(ttl) || 60000;
    const meta = $65981f4068c7b12e$var$_cacheMeta.get(key);
    const hit = (0, $fLrnc.queryClient).getQueryData(key);
    if (hit !== undefined && meta && Date.now() - meta.time < meta.ttlMs) return hit;
    const fresh = await fn();
    (0, $fLrnc.queryClient).setQueryData(key, fresh);
    $65981f4068c7b12e$var$_cacheMeta.set(key, {
        time: Date.now(),
        ttlMs: ttlMs
    });
    return fresh;
};
const $65981f4068c7b12e$var$_invalidate = (pattern)=>{
    (0, $fLrnc.queryClient).invalidateQueries(pattern);
    if (!pattern) {
        $65981f4068c7b12e$var$_cacheMeta.clear();
        $65981f4068c7b12e$var$_ownerCache.clear();
        return;
    }
    for (const key of [
        ...$65981f4068c7b12e$var$_cacheMeta.keys()
    ])if (key.startsWith(pattern) || key.includes(pattern)) $65981f4068c7b12e$var$_cacheMeta.delete(key);
    // Owner hydration results belong to the projects cache.
    if (pattern.startsWith('projects')) $65981f4068c7b12e$var$_ownerCache.clear();
};
// API_URL resolution:
//   - ?api=<url>  → custom override (debugging)
//   - ?api=local  → channel `local`
//   - default     → channel-resolved (single source of truth via @symbo.ls/channels)
// Governance/intranet always hits the public API regardless of host —
// there's no local Symbols backend running beside the intranet dev server.
const $65981f4068c7b12e$var$_resolveApiUrl = ()=>{
    if (typeof window === 'undefined') return (0, $3WCJD.apiUrl)();
    const params = new URLSearchParams(window.location.search);
    const apiParam = params.get('api');
    if (apiParam === 'local') return (0, $3WCJD.apiUrl)('local');
    if (apiParam && /^https?:\/\//.test(apiParam)) return apiParam;
    return (0, $3WCJD.apiUrl)();
};
const $65981f4068c7b12e$var$API_URL = $65981f4068c7b12e$var$_resolveApiUrl();
const $65981f4068c7b12e$var$PAGE_SIZE = 50;
// Authenticate the SDK against the Symbols API. No `/service-token`
// endpoint exists on next.api — we authenticate via SDK login. The
// SDK's AuthService persists the access token (localStorage) and
// handles refresh. Once the server ships the HMAC bridge surfaces
// (NEEDED_FOR_SERVER.md §I0-I5) this can swap to a session-inheriting
// path that reuses the intranet's federation JWT.
// Peek at the SDK's persisted token BEFORE calling sdk.login. The
// SDK's own `auth.isAuthenticated()` doesn't trust localStorage on
// cold init, so without this check we re-login on every page load and
// trip the per-email rate-limit (429) within 10 navigations.
const $65981f4068c7b12e$var$_hasFreshToken = ()=>{
    if (typeof window === 'undefined') return false;
    try {
        const tok = window.localStorage.getItem('symbols_access_token');
        const expAt = parseInt(window.localStorage.getItem('symbols_expires_at') || '0', 10);
        return !!tok && Number.isFinite(expAt) && expAt > Date.now() + 30000;
    } catch  {
        return false;
    }
};
// Park the SDK init promise on window so it survives Parcel HMR +
// cross-route re-imports of this module.
const $65981f4068c7b12e$var$_SDK_KEY = '__governanceDataSdkPromise__';
const $65981f4068c7b12e$var$_getSDK = ()=>{
    if (typeof window !== 'undefined' && window[$65981f4068c7b12e$var$_SDK_KEY]) return window[$65981f4068c7b12e$var$_SDK_KEY];
    const promise = (async ()=>{
        const sdk = new (0, $3rsQg.default)({
            apiUrl: $65981f4068c7b12e$var$API_URL
        });
        await sdk.initialize({
            apiUrl: $65981f4068c7b12e$var$API_URL,
            observability: false
        });
        if (!$65981f4068c7b12e$var$_hasFreshToken() && !sdk.auth?.isAuthenticated?.()) // The data admin pages require an authenticated session — the user must
        // sign in via the normal /login flow first. Never fall back to a
        // hardcoded credential set; previous versions of this file embedded a
        // dev-only password that ended up in the production bundle.
        throw new Error("data: admin pages require an authenticated session \u2014 sign in via /login");
        return sdk;
    })();
    // Evict transient failures immediately so the next caller can retry.
    // For 429 login-rate-limits, keep the rejection cached for a cooldown
    // window so concurrent enrichment calls all share the same failure
    // instead of each spawning a fresh login attempt (which compounds the
    // rate-limit into a retry storm).
    if (typeof window !== 'undefined') {
        window[$65981f4068c7b12e$var$_SDK_KEY] = promise;
        promise.catch((err)=>{
            const is429 = /\b429\b|rate limit/i.test(String(err?.message || err));
            const holdMs = is429 ? 60000 : 0;
            setTimeout(()=>{
                if (window[$65981f4068c7b12e$var$_SDK_KEY] === promise) delete window[$65981f4068c7b12e$var$_SDK_KEY];
            }, holdMs);
        });
    }
    return promise;
};
// Per-id owner-email cache. The list endpoint frequently omits owner info,
// so we fetch it lazily (once per project) so grouping by team/external
// works consistently across pages.
const $65981f4068c7b12e$var$_ownerCache = new Map();
const $65981f4068c7b12e$var$_ownerInflight = new Map();
const $65981f4068c7b12e$var$_hasOwnerInfo = (p)=>!!(p?.ownerEmail || p?.owner?.email || p?.owner?.user?.email || p?.owner?.username || (p?.members || []).some((m)=>m?.role === 'owner'));
// Simple concurrency gate so 50 getProject calls don't saturate HTTP/2 on
// cold-cache page loads. Reusing a single queue keeps memory bounded.
const $65981f4068c7b12e$var$_HYDRATE_CONCURRENCY = 6;
let $65981f4068c7b12e$var$_hydrateActive = 0;
const $65981f4068c7b12e$var$_hydrateQueue = [];
const $65981f4068c7b12e$var$_withHydrateSlot = (fn)=>{
    if ($65981f4068c7b12e$var$_hydrateActive < $65981f4068c7b12e$var$_HYDRATE_CONCURRENCY) {
        $65981f4068c7b12e$var$_hydrateActive++;
        return fn().finally(()=>{
            $65981f4068c7b12e$var$_hydrateActive--;
            const next = $65981f4068c7b12e$var$_hydrateQueue.shift();
            if (next) next();
        });
    }
    return new Promise((resolve)=>{
        $65981f4068c7b12e$var$_hydrateQueue.push(()=>{
            $65981f4068c7b12e$var$_hydrateActive++;
            fn().then(resolve).finally(()=>{
                $65981f4068c7b12e$var$_hydrateActive--;
                const next = $65981f4068c7b12e$var$_hydrateQueue.shift();
                if (next) next();
            });
        });
    });
};
const $65981f4068c7b12e$var$_hydrateOwner = async (sdk, p)=>{
    if (!p) return p;
    if ($65981f4068c7b12e$var$_hasOwnerInfo(p)) return p;
    const id = p.id || p._id;
    if (!id) return p;
    if ($65981f4068c7b12e$var$_ownerCache.has(id)) return {
        ...p,
        ...$65981f4068c7b12e$var$_ownerCache.get(id)
    };
    // De-dupe overlapping requests when a page changes mid-flight.
    if ($65981f4068c7b12e$var$_ownerInflight.has(id)) return $65981f4068c7b12e$var$_ownerInflight.get(id).then((patch)=>({
            ...p,
            ...patch
        }));
    const promise = $65981f4068c7b12e$var$_withHydrateSlot(async ()=>{
        try {
            const full = await sdk.getProject(id);
            const patch = {
                owner: full?.owner,
                ownerEmail: full?.ownerEmail,
                members: full?.members,
                tier: full?.tier ?? p.tier
            };
            $65981f4068c7b12e$var$_ownerCache.set(id, patch);
            return patch;
        } catch  {
            return {};
        } finally{
            $65981f4068c7b12e$var$_ownerInflight.delete(id);
        }
    });
    $65981f4068c7b12e$var$_ownerInflight.set(id, promise);
    const patch = await promise;
    return {
        ...p,
        ...patch
    };
};
const $65981f4068c7b12e$var$_loadProjectsPage = (sdk, { page: page, search: search, team: team })=>$65981f4068c7b12e$var$_cached(`projects:select:page=${page}:search=${search || ''}:team=${team || ''}`, '60s', async ()=>{
        const params = {
            page: page,
            limit: $65981f4068c7b12e$var$PAGE_SIZE,
            search: search
        };
        if (team === 'team') params.team = 'true';
        else if (team === 'external') params.team = 'false';
        const res = await sdk.getProjects(params);
        const pag = res.pagination || {};
        const total = pag.total ?? (res.data || []).length;
        const totalPages = pag.pages ?? Math.max(1, Math.ceil(total / $65981f4068c7b12e$var$PAGE_SIZE));
        const raw = res.data || [];
        const items = await Promise.all(raw.map((p)=>$65981f4068c7b12e$var$_hydrateOwner(sdk, p)));
        return {
            items: items,
            total: total,
            totalPages: totalPages,
            page: page,
            teamCount: pag.teamCount ?? null,
            externalCount: pag.externalCount ?? null
        };
    });
const $65981f4068c7b12e$var$_loadUsersPage = (sdk, { page: page, search: search, team: team })=>$65981f4068c7b12e$var$_cached(`users:select:page=${page}:search=${search || ''}:team=${team || ''}`, '60s', async ()=>{
        const params = {
            page: page,
            limit: $65981f4068c7b12e$var$PAGE_SIZE,
            query: search
        };
        if (team === 'team') params.team = 'true';
        else if (team === 'external') params.team = 'false';
        const res = await sdk.getAdminUsers(params);
        const total = res.totalCount ?? (res.users || []).length;
        const totalPages = Math.max(1, Math.ceil(total / $65981f4068c7b12e$var$PAGE_SIZE));
        return {
            items: res.users || [],
            total: total,
            totalPages: totalPages,
            page: page,
            teamCount: res.teamCount ?? null,
            externalCount: res.externalCount ?? null
        };
    });
const $65981f4068c7b12e$var$_searchTimers = {};
const $65981f4068c7b12e$var$_reqSeq = {
    projects: 0,
    users: 0,
    detail: 0
};
// Cache-key builder for paginated sections so we can detect a synchronous
// cache hit and skip the loading flash.
const $65981f4068c7b12e$var$_paginatedKey = (section, page, search)=>`${section}:select:page=${page}:search=${search || ''}`;
const $65981f4068c7b12e$var$_loadSection = async (s, section, { page: page, search: search } = {})=>{
    const root = s.root;
    const resolvedPage = page ?? $65981f4068c7b12e$var$_pageFromQuery() ?? (section === 'projects' ? root.projectsPage : root.usersPage) ?? 1;
    const resolvedSearch = search ?? $65981f4068c7b12e$var$_searchFromQuery() ?? root.dataQuery ?? '';
    const willHit = section === 'projects' || section === 'users' ? (0, $fLrnc.queryClient).getQueryData($65981f4068c7b12e$var$_paginatedKey(section, resolvedPage, resolvedSearch)) != null : (0, $fLrnc.queryClient).getQueryData(`${section}:select:all`) != null;
    if (!willHit) s.update({
        loading: true,
        error: null
    });
    else s.update({
        error: null
    });
    try {
        const sdk = await $65981f4068c7b12e$var$_getSDK();
        const teamFilter = root.dataFilter || null;
        if (section === 'projects') {
            const seq = ++$65981f4068c7b12e$var$_reqSeq.projects;
            const r = await $65981f4068c7b12e$var$_loadProjectsPage(sdk, {
                page: resolvedPage,
                search: resolvedSearch,
                team: teamFilter
            });
            if (seq !== $65981f4068c7b12e$var$_reqSeq.projects) return;
            root.update({
                projectsPage: r.page,
                projectsTotal: r.total,
                projectsTotalPages: r.totalPages,
                projectsTeamCount: r.teamCount,
                projectsExternalCount: r.externalCount
            });
            s.update({
                projects: r.items,
                _nonce: (s._nonce || 0) + 1
            });
        } else if (section === 'users') {
            const seq = ++$65981f4068c7b12e$var$_reqSeq.users;
            const r = await $65981f4068c7b12e$var$_loadUsersPage(sdk, {
                page: resolvedPage,
                search: resolvedSearch,
                team: teamFilter
            });
            if (seq !== $65981f4068c7b12e$var$_reqSeq.users) return;
            root.update({
                usersPage: r.page,
                usersTotal: r.total,
                usersTotalPages: r.totalPages,
                usersTeamCount: r.teamCount,
                usersExternalCount: r.externalCount
            });
            s.update({
                users: r.items,
                _nonce: (s._nonce || 0) + 1
            });
        } else if (section === 'plans') {
            const plans = await $65981f4068c7b12e$var$_loadAllPlans(sdk);
            s.update({
                plans: plans
            });
        } else if (section === 'organizations') {
            const orgsBase = await $65981f4068c7b12e$var$_loadAllOrganizations(sdk);
            // Show base rows immediately while per-org enrichments run.
            // The `_nonce` bump matches the pattern used by users/projects to
            // force DOMQL to re-render keyed-list children.
            s.update({
                organizations: orgsBase.map((o)=>({
                        ...o,
                        _projectCount: null,
                        _plans: []
                    })),
                _nonce: (s._nonce || 0) + 1
            });
            // Serialize ACROSS orgs (stay under the 60 req/min free-tier
            // ceiling) but parallelize WITHIN each org — getProjects and
            // listWorkspaces are independent.
            // DOMQL's keyed-list reconciliation doesn't re-render already-
            // rendered rows on incremental state updates — so enrich all orgs
            // first, then publish the complete array in one `s.update`.
            const enriched = [
                ...orgsBase
            ];
            for(let i = 0; i < enriched.length; i++){
                const org = {
                    ...enriched[i]
                };
                const slug = org.slug || org.id;
                const id = $65981f4068c7b12e$var$_orgId(org);
                if (!slug && !id) continue;
                let projectCount = 0;
                let plans = [];
                try {
                    const r = slug ? await sdk.getProjects({
                        owner: slug,
                        page: 1,
                        limit: 1
                    }) : null;
                    projectCount = r?.pagination?.total ?? (r?.data?.length || 0);
                } catch  {}
                try {
                    const r = id ? await sdk.listWorkspaces({
                        organization: id,
                        limit: 100
                    }) : null;
                    const wss = r?.items || r?.data?.items || (Array.isArray(r?.data) ? r.data : Array.isArray(r) ? r : []);
                    // Workspace list items don't carry tier or populated
                    // subscription. Per MODEL.md inv 16 the org's "home" workspace
                    // (type:'hq', fallback 'shared') represents the intranet
                    // subscription — resolve tier via its billing endpoint.
                    const home = wss.find((w)=>w.type === 'hq') || wss.find((w)=>w.type === 'shared') || wss[0];
                    const wsId = home ? $65981f4068c7b12e$var$_wsId(home) : null;
                    if (wsId && typeof sdk.getBilling === 'function') try {
                        const bRes = await sdk.getBilling(wsId);
                        const b = bRes?.data || bRes;
                        const tier = b?.tier || b?.plan?.name || b?.plan || 'free';
                        plans = [
                            String(tier).toLowerCase()
                        ];
                    } catch  {}
                } catch  {}
                org._projectCount = projectCount;
                org._plans = plans;
                enriched[i] = org;
            }
            s.update({
                organizations: enriched,
                _nonce: (s._nonce || 0) + 1
            });
        } else if (section === 'subscriptions') {
            const subscriptions = await $65981f4068c7b12e$var$_loadAllSubscriptions(sdk);
            s.update({
                subscriptions: subscriptions
            });
        }
        s.update({
            loading: false
        });
    } catch (err) {
        console.error('[data] load failed', err);
        s.update({
            loading: false,
            error: String(err?.message || err)
        });
    }
};
// Debounced search — re-fetch current section with the new query, resetting
// to page 1. Called from the SearchInput's onInput.
const $65981f4068c7b12e$var$_searchDebounced = (s, section, q)=>{
    clearTimeout($65981f4068c7b12e$var$_searchTimers[section]);
    $65981f4068c7b12e$var$_searchTimers[section] = setTimeout(()=>{
        const pageKey = section === 'projects' ? 'projectsPage' : 'usersPage';
        s.root.update({
            [pageKey]: 1
        });
        $65981f4068c7b12e$var$_loadSection(s, section, {
            page: 1,
            search: q
        });
    }, 300);
};
const $65981f4068c7b12e$var$_loadAll = (s)=>$65981f4068c7b12e$var$_loadSection(s, s.root?.dataSection || 'projects');
// Re-open the modal for the id in ?id=… on load/navigation. Falls back to a
// stub item if the id isn't in the current list so the modal still renders.
const $65981f4068c7b12e$var$_restoreDetailFromUrl = async (s, sec)=>{
    const id = $65981f4068c7b12e$var$_detailIdFromQuery();
    if (!id) {
        if (s.root?.dataDetail) s.root.update({
            dataDetail: null
        });
        return;
    }
    if (s.root?.dataDetail?.item?.id === id || s.root?.dataDetail?.item?._id === id) return;
    const kindMap = {
        projects: 'project',
        users: 'user',
        plans: 'plan',
        organizations: 'organization',
        subscriptions: 'subscription'
    };
    const kind = kindMap[sec] || 'project';
    const listKey = sec;
    const list = s[listKey] || [];
    const found = list.find((it)=>(it.id || it._id) === id);
    if (found) await $65981f4068c7b12e$var$_openDetail(s.root, kind, found);
    else await $65981f4068c7b12e$var$_openDetail(s.root, kind, {
        id: id
    });
};
const $65981f4068c7b12e$var$_triggerSectionLoad = (s, sec)=>{
    if (sec === 'projects' || sec === 'users') {
        const page = $65981f4068c7b12e$var$_pageFromQuery() || 1;
        const search = $65981f4068c7b12e$var$_searchFromQuery();
        s.root.update({
            [sec === 'projects' ? 'projectsPage' : 'usersPage']: page
        });
        $65981f4068c7b12e$var$_loadSection(s, sec, {
            page: page,
            search: search
        });
        return;
    }
    const cacheKey = sec === 'plans' ? 'plans' : sec === 'organizations' ? 'organizations' : sec === 'subscriptions' ? 'subscriptions' : null;
    if (!cacheKey) return;
    if (!(s[cacheKey] || []).length) $65981f4068c7b12e$var$_loadSection(s, sec);
};
// Current page + total pages for the paginated section, read from root.
// Centralizes the `sec === 'projects' ? root.projectsX : root.usersX` ternary
// that otherwise spread across Prev/Next/PageInfo/Count/LoadingState.
const $65981f4068c7b12e$var$_pageInfo = (s)=>{
    const sec = $65981f4068c7b12e$var$_section(s);
    const isProjects = sec === 'projects';
    return {
        sec: sec,
        paginated: isProjects || sec === 'users',
        cur: isProjects ? s.root?.projectsPage || 1 : s.root?.usersPage || 1,
        total: isProjects ? s.root?.projectsTotalPages || 1 : s.root?.usersTotalPages || 1
    };
};
const $65981f4068c7b12e$var$_section = (s)=>{
    const path = s.root?.currentPath || '';
    const seg = path.split('/')[2] || '';
    if (seg === 'users') return 'users';
    if (seg === 'plans') return 'plans';
    if (seg === 'organizations') return 'organizations';
    if (seg === 'subscriptions') return 'subscriptions';
    return 'projects';
};
// URL query helpers — pagination lives in ?page=N and modal id in ?id=ID
// so bookmarked/reloaded URLs restore both the page and the open modal.
const $65981f4068c7b12e$var$_qs = ()=>typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : new URLSearchParams();
const $65981f4068c7b12e$var$_pageFromQuery = ()=>{
    const p = Number($65981f4068c7b12e$var$_qs().get('page'));
    return Number.isFinite(p) && p > 0 ? p : null;
};
const $65981f4068c7b12e$var$_searchFromQuery = ()=>$65981f4068c7b12e$var$_qs().get('q') || '';
const $65981f4068c7b12e$var$_detailIdFromQuery = ()=>$65981f4068c7b12e$var$_qs().get('id') || null;
const $65981f4068c7b12e$var$_pushUrl = (url)=>{
    if (typeof window === 'undefined') return;
    window.history.pushState({}, '', url);
    window.dispatchEvent(new Event('locationchange'));
};
const $65981f4068c7b12e$var$_replaceUrl = (url)=>{
    if (typeof window === 'undefined') return;
    window.history.replaceState({}, '', url);
    window.dispatchEvent(new Event('locationchange'));
};
const $65981f4068c7b12e$var$_urlFor = (section, { page: page, q: q, id: id } = {})=>{
    const sp = new URLSearchParams();
    if (page && page > 1) sp.set('page', String(page));
    if (q) sp.set('q', q);
    if (id) sp.set('id', id);
    const qs = sp.toString();
    return qs ? `/data/${section}?${qs}` : `/data/${section}`;
};
const $65981f4068c7b12e$var$_filteredOrganizations = (s)=>$65981f4068c7b12e$var$_filterByFields(s.organizations || [], $65981f4068c7b12e$var$_query(s), [
        'name',
        'slug',
        'id',
        'description'
    ]);
const $65981f4068c7b12e$var$_query = (s)=>s.root?.dataQuery || '';
// Mongo emits `_id`; SDK normalization sometimes mirrors it to `id`.
// Accept either so callers don't sprinkle `.id || ._id` everywhere.
const $65981f4068c7b12e$var$_orgId = (o)=>o?.id || o?._id || null;
const $65981f4068c7b12e$var$_wsId = (w)=>w?.id || w?._id || w?.workspace_id || null;
// Shared visual spec for tier pills in data tables. Keep identical
// across DataUserRow / DataSubscriptionRow — the `text` factory is
// per-row-shape and sits on the consumer.
const $65981f4068c7b12e$var$_TIER_BADGE = {
    tag: 'span',
    padding: 'V Z',
    round: 'Z',
    background: 'overlayStrong',
    color: 'title',
    fontSize: 'Y2',
    fontWeight: '700',
    letterSpacing: '.08em',
    textTransform: 'uppercase'
};
// Backend returns the filtered page directly. Stable-sort team entries
// first so that inside a single page the `@symbols.app` rows surface
// above the externals.
let $65981f4068c7b12e$var$_peopleMapRef = null;
let $65981f4068c7b12e$var$_peopleMap = null;
const $65981f4068c7b12e$var$_localMatch = (root, email)=>{
    if (!email || !root) return null;
    const people = root.people || [];
    if (people !== $65981f4068c7b12e$var$_peopleMapRef) {
        $65981f4068c7b12e$var$_peopleMapRef = people;
        $65981f4068c7b12e$var$_peopleMap = new Map(people.map((p)=>[
                (p?.email || '').toLowerCase(),
                p
            ]));
    }
    return $65981f4068c7b12e$var$_peopleMap.get(email.toLowerCase()) || null;
};
const $65981f4068c7b12e$var$_byTeamFirst = (fn)=>(a, b)=>(fn(a) ? 0 : 1) - (fn(b) ? 0 : 1);
// `hide`, Count text, row `children`, and EmptyState all call these selectors
// per render. Memoize by the input-array reference so the sort runs once per
// backend page, not 4+ times per keystroke.
const $65981f4068c7b12e$var$_sortCache = new WeakMap();
const $65981f4068c7b12e$var$_memoSort = (arr, predicate)=>{
    if (!Array.isArray(arr) || arr.length === 0) return arr || [];
    const hit = $65981f4068c7b12e$var$_sortCache.get(arr);
    if (hit) return hit;
    const sorted = [
        ...arr
    ].sort($65981f4068c7b12e$var$_byTeamFirst(predicate));
    $65981f4068c7b12e$var$_sortCache.set(arr, sorted);
    return sorted;
};
// Server handles team/external filtering and sorting — just pass through
const $65981f4068c7b12e$var$_filteredProjects = (s)=>s.projects || [];
const $65981f4068c7b12e$var$_filteredUsers = (s)=>s.users || [];
const $65981f4068c7b12e$var$_filterByFields = (items, q, fields)=>{
    if (!q) return items;
    const lc = q.toLowerCase();
    return items.filter((it)=>fields.some((f)=>String(it?.[f] ?? '').toLowerCase().includes(lc)));
};
// Plans are small (public /plans endpoint returns the full list) so we
// still filter client-side for responsive search on that section.
const $65981f4068c7b12e$var$_filteredPlans = (s)=>$65981f4068c7b12e$var$_filterByFields(s.plans || [], $65981f4068c7b12e$var$_query(s), [
        'name',
        'tier',
        'description',
        'id'
    ]);
const $65981f4068c7b12e$var$_isTeam = (u)=>/@symbols\.app$/i.test(u?.email || '');
const $65981f4068c7b12e$var$_teamUsers = (s)=>$65981f4068c7b12e$var$_filteredUsers(s).filter($65981f4068c7b12e$var$_isTeam);
const $65981f4068c7b12e$var$_externalUsers = (s)=>$65981f4068c7b12e$var$_filteredUsers(s).filter((u)=>!$65981f4068c7b12e$var$_isTeam(u));
// Project owner email may live on project.owner.email, project.ownerEmail,
// or be derivable from the first "owner"-role member. Pick whichever the
// API response exposes.
const $65981f4068c7b12e$var$_projectOwnerEmail = (p)=>{
    if (!p) return '';
    if (typeof p.ownerEmail === 'string') return p.ownerEmail;
    if (typeof p.owner === 'string' && /@/.test(p.owner)) return p.owner;
    if (p.owner && typeof p.owner === 'object') {
        if (p.owner.email) return p.owner.email;
        if (p.owner.user?.email) return p.owner.user.email;
        if (p.owner.username) return `${p.owner.username}@symbols.app`;
    }
    if (p.createdBy?.email) return p.createdBy.email;
    const members = p.members || [];
    const ownerMember = members.find((m)=>m?.role === 'owner');
    if (ownerMember) return ownerMember.user?.email || ownerMember.email || (ownerMember.user?.username ? `${ownerMember.user.username}@symbols.app` : '');
    return '';
};
const $65981f4068c7b12e$var$_isTeamProject = (p)=>/@symbols\.app$/i.test($65981f4068c7b12e$var$_projectOwnerEmail(p));
const $65981f4068c7b12e$var$_teamProjects = (s)=>$65981f4068c7b12e$var$_filteredProjects(s).filter($65981f4068c7b12e$var$_isTeamProject);
const $65981f4068c7b12e$var$_externalProjects = (s)=>$65981f4068c7b12e$var$_filteredProjects(s).filter((p)=>!$65981f4068c7b12e$var$_isTeamProject(p));
const $65981f4068c7b12e$var$_projectSlug = (p)=>{
    const k = p?.key || '';
    return k || (p?.name || '').toLowerCase().replace(/\s+/g, '-');
};
const $65981f4068c7b12e$var$_ownerUsername = (p)=>{
    const o = p?.owner;
    if (o?.slug) return o.slug;
    return o?.username || o?.email?.split('@')[0] || '';
};
// Transitional project-ownership helpers. In the Phase-1 workspace model a
// project's org ownership lives on `workspace.type === 'shared'` with the
// org as `workspace.organization`. Legacy projects (pre-workspace) used
// `ownerType: 'organization'` with `ownerOrganization: { name, slug }`.
// Phase-3 drops the legacy fields; until then we prefer the workspace path
// and fall back so existing rows keep rendering.
const $65981f4068c7b12e$var$_isOrgOwned = (p)=>{
    const w = p?.workspace;
    if (w && typeof w === 'object') {
        if (w.type === 'shared') return true;
        // A populated workspace.organization (vs a bare ObjectId string) is
        // the canonical signal the project sits under an org.
        if (w.organization && typeof w.organization === 'object') return true;
    }
    return p?.ownerType === 'organization';
};
const $65981f4068c7b12e$var$_ownerOrg = (p)=>{
    const wsOrg = p?.workspace?.organization;
    if (wsOrg && typeof wsOrg === 'object') return wsOrg;
    return p?.ownerOrganization || null;
};
// Source of truth for project URLs is @symbo.ls/channels mermaidUrl —
// it composes user-env (publish env) + system-env (current channel) into
// the canonical published-app URL. `_directUrl` defaults env='production'
// for the project card's primary link; per-env links pass env explicitly.
const $65981f4068c7b12e$var$_directUrl = (p, env = 'production')=>{
    const slug = $65981f4068c7b12e$var$_projectSlug(p);
    const u = $65981f4068c7b12e$var$_ownerUsername(p);
    if (!slug) return '';
    if (!u) return `https://${p?.key || ''}`;
    return (0, $3WCJD.mermaidUrl)({
        owner: u,
        key: slug,
        env: env
    }, (0, $3WCJD.currentChannel)()) || '';
};
// `_previewUrl` keeps the legacy `{owner}--{slug}.preview.symbols.app`
// route — it's the in-editor live-preview surface (not Mermaid hosting).
// Channels exposes the current sysEnv via previewUrl(); we still build
// the project subpath manually because preview is owner+slug, not
// {owner}.{key}.
const $65981f4068c7b12e$var$_previewUrl = (p)=>{
    const slug = $65981f4068c7b12e$var$_projectSlug(p);
    const u = $65981f4068c7b12e$var$_ownerUsername(p);
    if (!slug || !u) return '';
    return `https://${u}--${slug}.preview.symbols.app`;
};
const $65981f4068c7b12e$var$_canvasUrl = (p)=>{
    const slug = $65981f4068c7b12e$var$_projectSlug(p);
    const u = $65981f4068c7b12e$var$_ownerUsername(p);
    if (!slug || !u) return '';
    return `https://edit.symbols.app/${u}/${slug}`;
};
// Drop personal orgs from listings. Per MODEL.md invariant 15 the
// intranet is an org-level feature; personal orgs aren't tenants.
const $65981f4068c7b12e$var$_isPersonalOrg = (o)=>o?.type === 'personal';
const $65981f4068c7b12e$var$_loadAllOrganizations = async (sdk)=>{
    const hit = (0, $fLrnc.queryClient).getQueryData('organizations:select:all');
    if (Array.isArray(hit) && hit.length) return hit;
    try {
        const res = await sdk.listOrganizations();
        const list = Array.isArray(res) ? res : Array.isArray(res?.organizations) ? res.organizations : Array.isArray(res?.data) ? res.data : [];
        const filtered = list.filter((o)=>!$65981f4068c7b12e$var$_isPersonalOrg(o));
        // Only cache non-empty results — empty often means rate-limited.
        if (filtered.length) (0, $fLrnc.queryClient).setQueryData('organizations:select:all', filtered);
        return filtered;
    } catch (err) {
        console.warn('[data] organizations load failed', err);
        return [];
    }
};
// Subscriptions are workspace-scoped per MODEL.md invariant 10. Pull
// them by walking team-orgs → their workspaces. Each row surfaces the
// workspace, its org, tier, and status. No per-project fetches — the
// legacy project→tier derivation is dead (Project.tier was removed).
// Walk team-orgs → workspaces, then resolve tier/status via the
// billing endpoint (workspace list items carry only an unpopulated
// subscription ObjectId; tier isn't stored on the workspace).
const $65981f4068c7b12e$var$_loadAllSubscriptions = (sdk)=>$65981f4068c7b12e$var$_cached('subscriptions:select:all', '5m', async ()=>{
        try {
            const orgs = await $65981f4068c7b12e$var$_loadAllOrganizations(sdk);
            const flat = [];
            for (const org of orgs){
                const orgId = $65981f4068c7b12e$var$_orgId(org);
                if (!orgId) continue;
                try {
                    const res = await sdk.listWorkspaces({
                        organization: orgId,
                        limit: 100
                    });
                    const wss = res?.items || res?.data?.items || (Array.isArray(res?.data) ? res.data : Array.isArray(res) ? res : []);
                    for (const w of wss)flat.push({
                        org: org,
                        orgId: orgId,
                        w: w
                    });
                } catch  {}
            }
            const rows = [];
            for (const { org: org, orgId: orgId, w: w } of flat){
                const wsId = $65981f4068c7b12e$var$_wsId(w);
                let tier = 'free';
                let status = 'none';
                let currentPeriodEnd = null;
                if (wsId && typeof sdk.getBilling === 'function') try {
                    const res = await sdk.getBilling(wsId);
                    const b = res?.data || res;
                    tier = b?.tier || b?.plan?.name || 'free';
                    status = b?.subscription?.status || (b?.subscription ? 'active' : 'none');
                    currentPeriodEnd = b?.subscription?.currentPeriodEnd || null;
                } catch  {}
                rows.push({
                    id: wsId,
                    workspaceId: wsId,
                    workspaceName: w.displayName || w.name || w.slug || w.key || '',
                    workspaceSlug: w.slug || w.key || '',
                    orgId: orgId,
                    orgName: org.name || org.slug || '',
                    tier: tier,
                    status: status,
                    currentPeriodEnd: currentPeriodEnd,
                    type: w.type || 'shared'
                });
            }
            return rows;
        } catch (err) {
            console.warn('[data] subscriptions load failed', err);
            return [];
        }
    });
const $65981f4068c7b12e$var$_filteredSubscriptions = (s)=>$65981f4068c7b12e$var$_filterByFields(s.subscriptions || [], $65981f4068c7b12e$var$_query(s), [
        'workspaceName',
        'workspaceSlug',
        'workspaceId',
        'orgName',
        'status',
        'tier',
        'id'
    ]);
const $65981f4068c7b12e$var$_loadAllPlans = (sdk)=>$65981f4068c7b12e$var$_cached('plans:select:all', '5m', async ()=>{
        try {
            const res = await sdk.getPlansWithPricing();
            if (Array.isArray(res)) return res;
            if (res && Array.isArray(res.plans)) return res.plans;
            if (res && Array.isArray(res.data)) return res.data;
            return [];
        } catch (err) {
            console.warn('[data] plans load failed', err);
            return [];
        }
    });
const $65981f4068c7b12e$var$_openDetail = async (root, kind, item)=>{
    const id = item?.id || item?._id;
    // Show immediately with whatever data we have
    const isStub = !item?.name && !item?.email && !item?.key;
    root.update({
        dataDetail: {
            kind: kind,
            item: item,
            loading: isStub && !!id
        }
    });
    const sec = $65981f4068c7b12e$var$_section({
        root: root
    });
    if (id) $65981f4068c7b12e$var$_replaceUrl($65981f4068c7b12e$var$_urlFor(sec, {
        page: $65981f4068c7b12e$var$_pageFromQuery() || undefined,
        q: $65981f4068c7b12e$var$_searchFromQuery(),
        id: id
    }));
    // If we have full data already (from the list), skip the fetch
    if (!isStub || !id) return;
    const seq = ++$65981f4068c7b12e$var$_reqSeq.detail;
    try {
        const sdk = await $65981f4068c7b12e$var$_getSDK();
        // For users, fetch full detail. For projects, use lightweight getProject
        // which the SDK hits via /projects/:id (now fast since we optimized it)
        const full = kind === 'user' ? await sdk.getUser(id) : await sdk.getProject(id);
        if (seq !== $65981f4068c7b12e$var$_reqSeq.detail) return;
        if (root.dataDetail && (root.dataDetail.item?.id || root.dataDetail.item?._id) === id) root.update({
            dataDetail: {
                kind: kind,
                item: {
                    ...item,
                    ...full || {}
                },
                loading: false
            }
        });
    } catch (err) {
        console.warn('[data] detail load failed', err);
        if (root.dataDetail && (root.dataDetail.item?.id || root.dataDetail.item?._id) === id) root.update({
            dataDetail: {
                kind: kind,
                item: {
                    ...item,
                    id: id
                },
                loading: false,
                error: String(err?.message || err)
            }
        });
    }
};
const $65981f4068c7b12e$var$_closeDetail = (root)=>{
    root.update({
        dataDetail: null
    });
    const sec = $65981f4068c7b12e$var$_section({
        root: root
    });
    $65981f4068c7b12e$var$_replaceUrl($65981f4068c7b12e$var$_urlFor(sec, {
        page: $65981f4068c7b12e$var$_pageFromQuery() || undefined,
        q: $65981f4068c7b12e$var$_searchFromQuery()
    }));
};
const $65981f4068c7b12e$var$_domainsList = (detail)=>{
    if (!detail || detail.kind !== 'project') return [];
    const d = detail.item?.domains;
    if (!d) return [];
    if (Array.isArray(d)) return d.map((v)=>typeof v === 'string' ? {
            slot: v,
            domain: v
        } : {
            slot: v.slot || v.key || '',
            domain: v.domain || v.host || v.url || ''
        }).filter((x)=>x.domain);
    if (typeof d === 'object') return Object.entries(d).map(([slot, v])=>({
            slot: slot,
            domain: typeof v === 'string' ? v : v?.domain || v?.host || v?.url || ''
        })).filter((x)=>x.domain);
    return [];
};
const $65981f4068c7b12e$var$_dateKeys = new Set([
    'createdAt',
    'updatedAt',
    'lastLogin',
    'emailVerifiedAt',
    'joinedAt'
]);
const $65981f4068c7b12e$var$_fmt = (v, key)=>{
    if (v == null) return "\u2014";
    if ($65981f4068c7b12e$var$_dateKeys.has(key) || typeof v === 'string' && /^\d{4}-\d{2}-\d{2}T/.test(v)) return $65981f4068c7b12e$var$_formatDate(v);
    if (typeof v === 'object') return JSON.stringify(v);
    return String(v);
};
// Editable field definitions — 'select' fields have options, 'input' is free text
const $65981f4068c7b12e$var$_editableFields = {
    // Project fields
    name: {
        type: 'input',
        scope: 'project'
    },
    tier: {
        type: 'select',
        scope: 'project',
        options: [
            'starter',
            'growth',
            'enterprise'
        ]
    },
    access: {
        type: 'select',
        scope: 'project',
        options: [
            'public',
            'account',
            'private'
        ]
    },
    visibility: {
        type: 'select',
        scope: 'project',
        options: [
            'public',
            'private',
            'unlisted'
        ]
    },
    // User fields
    username: {
        type: 'input',
        scope: 'user'
    },
    status: {
        type: 'select',
        scope: 'both',
        options: [
            'active',
            'pending',
            'inactive',
            'suspended'
        ]
    },
    globalRole: {
        type: 'select',
        scope: 'user',
        options: [
            'user',
            'admin',
            'owner'
        ]
    }
};
const $65981f4068c7b12e$var$_isEditable = (key, kind)=>{
    const def = $65981f4068c7b12e$var$_editableFields[key];
    if (!def) return false;
    return def.scope === 'both' || def.scope === kind;
};
const $65981f4068c7b12e$var$_projectFields = [
    'id',
    'key',
    'name',
    'description',
    'tier',
    'access',
    'framework',
    'language',
    'visibility',
    'status',
    'memberCount',
    'createdAt',
    'updatedAt',
    'ownerId',
    'ownerEmail',
    'appKey',
    'plan',
    'templateKey',
    'environment',
    'region'
];
const $65981f4068c7b12e$var$_planFields = [
    'id',
    '_id',
    'name',
    'displayName',
    'tier',
    'description',
    'shortDescription',
    'status',
    'price',
    'amount',
    'currency',
    'period',
    'interval',
    'seats',
    'projects',
    'trialDays',
    'active',
    'isVisible',
    'isPopular',
    'sortOrder',
    'displayOrder',
    'lookupKey',
    'createdAt',
    'updatedAt'
];
// The pricing endpoint returns `features` as an object keyed by slug, where
// each value is {name, is_feature_available, is_feature_online, value?,
// unit?, limited?}. Normalize to the `{label, included, detail}` shape the
// DataPlanFeature component already understands so rendering stays uniform
// regardless of whether a plan returns an array or an object.
const $65981f4068c7b12e$var$_normalizePlanFeatures = (features)=>{
    if (!features) return [];
    if (Array.isArray(features)) return features;
    if (typeof features !== 'object') return [];
    return Object.values(features).map((f)=>{
        if (typeof f === 'string') return f;
        const detail = [];
        if (f.value != null) detail.push(f.unit ? `${f.value} ${f.unit}` : String(f.value));
        if (f.limited) detail.push('limited');
        return {
            label: f.name || f.label || '',
            included: f.is_feature_available !== false && f.included !== false,
            detail: detail.join(" \xb7 ")
        };
    });
};
// Prices come back in the smallest currency unit (cents), so 19900 → $199.00.
const $65981f4068c7b12e$var$_formatPrice = (cents)=>{
    if (cents == null) return null;
    const n = Number(cents);
    if (!Number.isFinite(n)) return String(cents);
    if (n === 0) return 'Free';
    return `$${(n / 100).toFixed(2)}`;
};
// Flattened pricing: prefer monthly over annual so cards stay comparable
// across tiers. Plans with no priced options (Enterprise = custom) fall
// back to a "Custom" label rather than rendering "Free".
const $65981f4068c7b12e$var$_planPrice = (p)=>{
    if (!p) return {
        amount: null,
        interval: '',
        label: ''
    };
    const opts = p.pricingOptions || [];
    const byKey = (k)=>opts.find((o)=>o.key === k || o.interval === k);
    const opt = byKey('monthly') || byKey('month') || opts.find((o)=>o.isPopular) || opts[0];
    const amount = opt?.amount ?? p.pricing?.bestPrice?.amount ?? p.price ?? p.amount;
    const interval = opt?.interval || p.interval || p.period || '';
    const label = opt?.displayName || p.pricing?.bestPrice?.displayName || '';
    if (amount == null && !opts.length) {
        const name = (p.name || '').toLowerCase();
        if (name === 'enterprise' || name.includes('custom')) return {
            amount: null,
            interval: '',
            label: 'Custom'
        };
    }
    return {
        amount: amount,
        interval: interval,
        label: label
    };
};
const $65981f4068c7b12e$var$_userFields = [
    'id',
    'name',
    'username',
    'email',
    'status',
    'globalRole',
    'emailVerified',
    'authProvider',
    'lastLogin',
    'createdAt',
    'updatedAt',
    'projectsCount',
    'phone',
    'country'
];
const $65981f4068c7b12e$export$4051a07651545597 = {
    extends: 'AppPage',
    metadata: (el, s)=>{
        const path = s.root?.currentPath || '/data/projects';
        const seg = path.replace(/^\/data\/?/, '').split(/[?/#]/)[0] || 'projects';
        const label = seg.charAt(0).toUpperCase() + seg.slice(1);
        return {
            title: label + ' / Data / Symbols Workspace'
        };
    },
    state: {
        loading: true,
        error: null,
        projects: [],
        users: [],
        plans: [],
        organizations: [],
        subscriptions: []
    },
    onCreate: (el, s)=>{
        // Detect admin status — try governance email first, fall back to SDK /auth/me
        if (s.root?._dataAdmin == null) $65981f4068c7b12e$var$_getSDK().then(async (sdk)=>{
            // Try matching governance user email against symbols.app DB
            const email = s.root?.currentUserEmail;
            if (email) {
                const res = await sdk.getAdminUsers({
                    emails: email,
                    limit: 1
                });
                const user = (res?.users || [])[0];
                if (user) {
                    s.root.update({
                        _dataAdmin: user.globalRole === 'admin' || user.globalRole === 'owner'
                    });
                    return;
                }
            }
            // Fallback: check if the SDK token itself is admin (service token case)
            try {
                const me = await sdk.getMe();
                s.root.update({
                    _dataAdmin: me?.globalRole === 'admin' || me?.globalRole === 'owner'
                });
            } catch  {
                s.root.update({
                    _dataAdmin: false
                });
            }
        }).catch(()=>s.root.update({
                _dataAdmin: false
            }));
        const sec = $65981f4068c7b12e$var$_section(s);
        $65981f4068c7b12e$var$_triggerSectionLoad(s, sec);
        $65981f4068c7b12e$var$_restoreDetailFromUrl(s, sec);
        el._lastSection = sec;
        el._lastPage = $65981f4068c7b12e$var$_pageFromQuery();
        el._lastQuery = $65981f4068c7b12e$var$_searchFromQuery();
        el._lastDetailId = $65981f4068c7b12e$var$_detailIdFromQuery();
    },
    onRemove: ()=>{
        for (const k of Object.keys($65981f4068c7b12e$var$_searchTimers)){
            clearTimeout($65981f4068c7b12e$var$_searchTimers[k]);
            delete $65981f4068c7b12e$var$_searchTimers[k];
        }
    },
    // The app mounts a single `data` page under /data, /data/projects, /data/users,
    // /data/plans (all the same component). When the user navigates between those
    // URLs, only `root.currentPath` changes — the page element isn't recreated.
    // Hook onUpdate to detect path→section transitions and fire a fresh load.
    onUpdate: (el, s)=>{
        const sec = $65981f4068c7b12e$var$_section(s);
        const pg = $65981f4068c7b12e$var$_pageFromQuery();
        const q = $65981f4068c7b12e$var$_searchFromQuery();
        const did = $65981f4068c7b12e$var$_detailIdFromQuery();
        if (el._lastSection !== sec) {
            el._lastSection = sec;
            el._lastPage = pg;
            el._lastQuery = q;
            $65981f4068c7b12e$var$_triggerSectionLoad(s, sec);
            $65981f4068c7b12e$var$_restoreDetailFromUrl(s, sec);
            return;
        }
        // Same section, different page or query — reload that section.
        if ((sec === 'projects' || sec === 'users') && (el._lastPage !== pg || el._lastQuery !== q)) {
            el._lastPage = pg;
            el._lastQuery = q;
            $65981f4068c7b12e$var$_loadSection(s, sec, {
                page: pg || 1,
                search: q
            });
        }
        // Modal id transitions.
        if (el._lastDetailId !== did) {
            el._lastDetailId = did;
            $65981f4068c7b12e$var$_restoreDetailFromUrl(s, sec);
        }
    },
    DataSidebar: {
        extends: 'AppSidebar',
        PeopleSection: null,
        width: 'G',
        minWidth: 'G',
        Top: null,
        Middle: {
            flow: 'y',
            gap: 'V',
            childExtends: 'DataSidebarLink',
            childrenAs: 'state',
            children: ()=>[
                    {
                        key: 'projects',
                        label: 'Projects',
                        href: '/data/projects'
                    },
                    {
                        key: 'users',
                        label: 'Users',
                        href: '/data/users'
                    },
                    {
                        key: 'organizations',
                        label: 'Organizations',
                        href: '/data/organizations'
                    },
                    {
                        key: 'subscriptions',
                        label: 'Subscriptions',
                        href: '/data/subscriptions'
                    },
                    {
                        key: 'plans',
                        label: 'Plans',
                        href: '/data/plans'
                    }
                ]
        }
    },
    DataMain: {
        extends: 'AppMain',
        padding: '0',
        Header: {
            extends: 'PageHeader',
            LeftGroup: {
                Title: {
                    text: (el, s)=>{
                        const sec = $65981f4068c7b12e$var$_section(s);
                        if (sec === 'users') return 'Users';
                        if (sec === 'plans') return 'Plans';
                        if (sec === 'organizations') return 'Organizations';
                        if (sec === 'subscriptions') return 'Subscriptions';
                        return 'Projects';
                    }
                },
                Count: {
                    tag: 'span',
                    color: 'caption',
                    fontSize: 'Z2',
                    margin: '0 0 0 A',
                    text: (el, s)=>{
                        const sec = $65981f4068c7b12e$var$_section(s);
                        if (sec === 'projects') return String(s.root?.projectsTotal ?? 0);
                        if (sec === 'users') return String(s.root?.usersTotal ?? 0);
                        if (sec === 'organizations') return String((s.organizations || []).length);
                        if (sec === 'subscriptions') return String((s.subscriptions || []).length);
                        return String((s.plans || []).length);
                    }
                }
            },
            FilterGroup: {
                hide: (el, s)=>{
                    const sec = $65981f4068c7b12e$var$_section(s);
                    return sec !== 'projects' && sec !== 'users';
                },
                flow: 'x',
                align: 'center',
                gap: 'Z',
                childExtends: {
                    tag: 'button',
                    type: 'button',
                    padding: 'Z A',
                    round: 'Z',
                    borderWidth: '1px',
                    borderStyle: 'solid',
                    cursor: 'pointer',
                    fontSize: 'Z2',
                    fontWeight: '600',
                    ':hover': {
                        background: 'overlayStrong'
                    }
                },
                AllBtn: {
                    text: 'All',
                    borderColor: (el, s)=>!s.root?.dataFilter ? 'title' : 'line',
                    background: (el, s)=>!s.root?.dataFilter ? 'overlay' : 'transparent',
                    color: (el, s)=>!s.root?.dataFilter ? 'title' : 'caption',
                    onClick: (e, el, s)=>{
                        if (!s.root?.dataFilter) return;
                        s.root.update({
                            dataFilter: null
                        });
                        const sec = $65981f4068c7b12e$var$_section(s);
                        $65981f4068c7b12e$var$_invalidate(sec);
                        $65981f4068c7b12e$var$_loadSection(s, sec, {
                            page: 1
                        });
                    }
                },
                TeamBtn: {
                    text: (el, s)=>{
                        const sec = $65981f4068c7b12e$var$_section(s);
                        const count = sec === 'users' ? s.root?.usersTeamCount ?? "\u2026" : s.root?.projectsTeamCount ?? "\u2026";
                        return `Team \xb7 ${count}`;
                    },
                    borderColor: (el, s)=>s.root?.dataFilter === 'team' ? 'blue' : 'line',
                    background: (el, s)=>s.root?.dataFilter === 'team' ? 'blue.2' : 'transparent',
                    color: (el, s)=>s.root?.dataFilter === 'team' ? 'blue' : 'caption',
                    onClick: (e, el, s)=>{
                        if (s.root?.dataFilter === 'team') return;
                        s.root.update({
                            dataFilter: 'team'
                        });
                        const sec = $65981f4068c7b12e$var$_section(s);
                        $65981f4068c7b12e$var$_invalidate(sec);
                        $65981f4068c7b12e$var$_loadSection(s, sec, {
                            page: 1
                        });
                    }
                },
                ExternalBtn: {
                    text: (el, s)=>{
                        const sec = $65981f4068c7b12e$var$_section(s);
                        const count = sec === 'users' ? s.root?.usersExternalCount ?? "\u2026" : s.root?.projectsExternalCount ?? "\u2026";
                        return `External \xb7 ${count}`;
                    },
                    borderColor: (el, s)=>s.root?.dataFilter === 'external' ? 'orange' : 'line',
                    background: (el, s)=>s.root?.dataFilter === 'external' ? 'orange.2' : 'transparent',
                    color: (el, s)=>s.root?.dataFilter === 'external' ? 'orange' : 'caption',
                    onClick: (e, el, s)=>{
                        if (s.root?.dataFilter === 'external') return;
                        s.root.update({
                            dataFilter: 'external'
                        });
                        const sec = $65981f4068c7b12e$var$_section(s);
                        $65981f4068c7b12e$var$_invalidate(sec);
                        $65981f4068c7b12e$var$_loadSection(s, sec, {
                            page: 1
                        });
                    }
                }
            },
            RightGroup: {
                flow: 'x',
                align: 'center right',
                gap: 'Z',
                SearchInput: {
                    tag: 'input',
                    type: 'search',
                    placeholder: "Search\u2026",
                    padding: 'Z A',
                    round: 'Z',
                    borderWidth: '1px',
                    borderStyle: 'solid',
                    borderColor: 'line',
                    background: 'document',
                    color: 'title',
                    fontSize: 'Z2',
                    width: 'F',
                    value: (el, s)=>$65981f4068c7b12e$var$_query(s),
                    onInput: (e, el, s)=>{
                        const q = e.target.value;
                        if (q === s.root?.dataQuery) return;
                        s.root.update({
                            dataQuery: q
                        });
                        const sec = $65981f4068c7b12e$var$_section(s);
                        if (sec === 'plans') return;
                        $65981f4068c7b12e$var$_searchDebounced(s, sec, q);
                    }
                },
                RefreshBtn: {
                    tag: 'button',
                    type: 'button',
                    text: (el, s)=>s.loading ? "Loading\u2026" : 'Reload',
                    padding: 'Z A',
                    round: 'Z',
                    borderWidth: '1px',
                    borderColor: 'line',
                    borderStyle: 'solid',
                    background: 'overlay',
                    cursor: 'pointer',
                    color: 'title',
                    fontSize: 'Z2',
                    fontWeight: '500',
                    ':hover': {
                        background: 'overlayStrong'
                    },
                    disabled: (el, s)=>s.loading,
                    onClick: (e, el, s)=>{
                        const sec = $65981f4068c7b12e$var$_section(s);
                        $65981f4068c7b12e$var$_invalidate(sec);
                        $65981f4068c7b12e$var$_loadSection(s, sec);
                    }
                }
            }
        },
        Body: {
            overflow: 'auto',
            padding: 'B',
            flow: 'y',
            gap: 'B',
            width: '100%',
            LoadingState: {
                hide: (el, s)=>!s.loading,
                flow: 'y',
                gap: 'Z',
                padding: 'B',
                round: 'Z',
                background: 'overlay',
                borderWidth: '1px',
                borderColor: 'line',
                borderStyle: 'solid',
                Status: {
                    tag: 'span',
                    color: 'caption',
                    fontSize: 'Z2',
                    fontWeight: '600',
                    textTransform: 'uppercase',
                    letterSpacing: '0.08em',
                    text: (el, s)=>`Loading ${$65981f4068c7b12e$var$_section(s)}\u{2026}`
                },
                Detail: {
                    tag: 'p',
                    margin: '0',
                    color: 'title',
                    text: (el, s)=>{
                        const { sec: sec, paginated: paginated, cur: cur, total: total } = $65981f4068c7b12e$var$_pageInfo(s);
                        if (!paginated) return '';
                        return total > 1 ? `Page ${cur} of ${total}` : `Page ${cur}`;
                    }
                }
            },
            ErrorBox: {
                hide: (el, s)=>!s.error,
                padding: 'B',
                round: 'Z',
                background: 'overlay',
                borderWidth: '1px',
                borderColor: 'red',
                borderStyle: 'solid',
                color: 'red',
                text: (el, s)=>s.error || ''
            },
            ProjectsView: {
                hide: (el, s)=>s.loading || !!s.error || $65981f4068c7b12e$var$_section(s) !== 'projects',
                flow: 'y',
                round: 'Z',
                borderWidth: '1px',
                borderColor: 'line',
                borderStyle: 'solid',
                background: 'overlay',
                Header: {
                    display: 'grid',
                    gridTemplateColumns: '1fr 160px 100px 80px',
                    gap: 'A',
                    padding: 'Z A',
                    borderWidth: '0 0 1px 0',
                    borderColor: 'line',
                    borderStyle: 'solid',
                    background: 'document',
                    align: 'center',
                    ColName: {
                        tag: 'span',
                        fontSize: 'Y2',
                        fontWeight: '700',
                        letterSpacing: '.1em',
                        textTransform: 'uppercase',
                        color: 'caption',
                        text: 'Name / Key'
                    },
                    ColOwner: {
                        tag: 'span',
                        fontSize: 'Y2',
                        fontWeight: '700',
                        letterSpacing: '.1em',
                        textTransform: 'uppercase',
                        color: 'caption',
                        text: 'Owner'
                    },
                    ColAccess: {
                        tag: 'span',
                        fontSize: 'Y2',
                        fontWeight: '700',
                        letterSpacing: '.1em',
                        textTransform: 'uppercase',
                        color: 'caption',
                        textAlign: 'center',
                        text: 'Access'
                    },
                    ColMembers: {
                        tag: 'span',
                        fontSize: 'Y2',
                        fontWeight: '700',
                        letterSpacing: '.1em',
                        textTransform: 'uppercase',
                        color: 'caption',
                        textAlign: 'right',
                        text: 'Members'
                    }
                },
                List: {
                    flow: 'y',
                    childrenAs: 'state',
                    children: (el, s)=>$65981f4068c7b12e$var$_filteredProjects(s),
                    childExtends: 'DataProjectRow'
                }
            },
            UsersView: {
                hide: (el, s)=>s.loading || !!s.error || $65981f4068c7b12e$var$_section(s) !== 'users',
                flow: 'y',
                round: 'Z',
                borderWidth: '1px',
                borderColor: 'line',
                borderStyle: 'solid',
                background: 'overlay',
                Header: {
                    display: 'grid',
                    gridTemplateColumns: '1fr 220px 100px 80px 80px',
                    gap: 'A',
                    padding: 'Z A',
                    borderWidth: '0 0 1px 0',
                    borderColor: 'line',
                    borderStyle: 'solid',
                    background: 'document',
                    align: 'center',
                    ColName: {
                        tag: 'span',
                        fontSize: 'Y2',
                        fontWeight: '700',
                        letterSpacing: '.1em',
                        textTransform: 'uppercase',
                        color: 'caption',
                        text: 'Name'
                    },
                    ColEmail: {
                        tag: 'span',
                        fontSize: 'Y2',
                        fontWeight: '700',
                        letterSpacing: '.1em',
                        textTransform: 'uppercase',
                        color: 'caption',
                        text: 'Email'
                    },
                    ColStatus: {
                        tag: 'span',
                        fontSize: 'Y2',
                        fontWeight: '700',
                        letterSpacing: '.1em',
                        textTransform: 'uppercase',
                        color: 'caption',
                        textAlign: 'center',
                        text: 'Status'
                    },
                    ColProvider: {
                        tag: 'span',
                        fontSize: 'Y2',
                        fontWeight: '700',
                        letterSpacing: '.1em',
                        textTransform: 'uppercase',
                        color: 'caption',
                        textAlign: 'center',
                        text: 'Provider'
                    },
                    ColRole: {
                        tag: 'span',
                        fontSize: 'Y2',
                        fontWeight: '700',
                        letterSpacing: '.1em',
                        textTransform: 'uppercase',
                        color: 'caption',
                        textAlign: 'right',
                        text: 'Role'
                    }
                },
                List: {
                    flow: 'y',
                    childrenAs: 'state',
                    children: (el, s)=>$65981f4068c7b12e$var$_filteredUsers(s),
                    childExtends: 'DataUserRow'
                }
            },
            PlansView: {
                hide: (el, s)=>s.loading || !!s.error || $65981f4068c7b12e$var$_section(s) !== 'plans',
                flow: 'y',
                gap: 'B',
                Intro: {
                    tag: 'p',
                    color: 'caption',
                    fontSize: 'Z2',
                    margin: '0',
                    text: 'Public plans & pricing from api.symbols.app'
                },
                Grid: {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
                    gap: 'B',
                    childrenAs: 'state',
                    children: (el, s)=>$65981f4068c7b12e$var$_filteredPlans(s),
                    childExtends: {
                        flow: 'y',
                        gap: 'Z',
                        padding: 'B',
                        round: 'Z',
                        background: 'overlay',
                        borderWidth: '1px',
                        borderStyle: 'solid',
                        borderColor: 'line',
                        cursor: 'pointer',
                        ':hover': {
                            background: 'overlayStrong'
                        },
                        onClick: (e, el, s)=>$65981f4068c7b12e$var$_openDetail(s.root, 'plan', s),
                        Header: {
                            flow: 'x',
                            align: 'center space-between',
                            Name: {
                                tag: 'h3',
                                margin: '0',
                                color: 'title',
                                fontSize: 'B',
                                fontWeight: '700',
                                text: (el, s)=>s.name || s.tier || s.id || ''
                            },
                            TierBadge: {
                                hide: (el, s)=>!s.tier,
                                tag: 'span',
                                padding: 'V Z',
                                round: 'Z',
                                background: 'overlayStrong',
                                color: 'caption',
                                fontSize: 'Y2',
                                fontWeight: '700',
                                letterSpacing: '.08em',
                                textTransform: 'uppercase',
                                text: (el, s)=>s.tier || ''
                            }
                        },
                        Price: {
                            flow: 'x',
                            align: 'baseline',
                            gap: 'V',
                            Amount: {
                                tag: 'strong',
                                color: 'title',
                                fontSize: 'D',
                                text: (el, s)=>{
                                    const p = $65981f4068c7b12e$var$_planPrice(s);
                                    return $65981f4068c7b12e$var$_formatPrice(p.amount) ?? p.label ?? "\u2014";
                                }
                            },
                            Period: {
                                tag: 'span',
                                color: 'caption',
                                fontSize: 'Z2',
                                text: (el, s)=>{
                                    const { interval: interval, amount: amount } = $65981f4068c7b12e$var$_planPrice(s);
                                    if (!interval || Number(amount) === 0) return '';
                                    return `/ ${interval}`;
                                }
                            }
                        },
                        ShortDescription: {
                            hide: (el, s)=>!s.shortDescription,
                            tag: 'p',
                            margin: '0',
                            color: 'title',
                            fontSize: 'Z1',
                            fontWeight: '500',
                            text: (el, s)=>s.shortDescription || ''
                        },
                        Description: {
                            tag: 'p',
                            margin: '0',
                            color: 'caption',
                            fontSize: 'Z2',
                            text: (el, s)=>s.description || ''
                        },
                        TrialBadge: {
                            hide: (el, s)=>!s.trialDays,
                            tag: 'span',
                            padding: 'V Z',
                            round: 'Z',
                            background: 'overlayStrong',
                            color: 'green',
                            fontSize: 'Y2',
                            fontWeight: '700',
                            alignSelf: 'flex-start',
                            text: (el, s)=>`${s.trialDays}-day free trial`
                        },
                        Features: {
                            hide: (el, s)=>$65981f4068c7b12e$var$_normalizePlanFeatures(s.features || s.featureList).length === 0,
                            flow: 'y',
                            gap: 'Z',
                            margin: 'Z 0 0',
                            padding: 'A 0 0',
                            borderWidth: '1px 0 0 0',
                            borderStyle: 'solid',
                            borderColor: 'line',
                            childrenAs: 'state',
                            children: (el, s)=>$65981f4068c7b12e$var$_normalizePlanFeatures(s.features || s.featureList),
                            childExtends: 'DataPlanFeature'
                        }
                    }
                }
            },
            OrganizationsList: {
                hide: (el, s)=>s.loading || !!s.error || $65981f4068c7b12e$var$_section(s) !== 'organizations',
                flow: 'y',
                round: 'Z',
                borderWidth: '1px',
                borderColor: 'line',
                borderStyle: 'solid',
                background: 'overlay',
                Header: {
                    display: 'grid',
                    gridTemplateColumns: '1fr 120px 200px 120px 80px 80px',
                    gap: 'A',
                    padding: 'Z A',
                    borderWidth: '0 0 1px 0',
                    borderColor: 'line',
                    borderStyle: 'solid',
                    background: 'document',
                    align: 'center',
                    ColName: {
                        tag: 'span',
                        fontSize: 'Y2',
                        fontWeight: '700',
                        letterSpacing: '.1em',
                        textTransform: 'uppercase',
                        color: 'caption',
                        text: 'Name'
                    },
                    ColSlug: {
                        tag: 'span',
                        fontSize: 'Y2',
                        fontWeight: '700',
                        letterSpacing: '.1em',
                        textTransform: 'uppercase',
                        color: 'caption',
                        text: 'Slug'
                    },
                    ColOwner: {
                        tag: 'span',
                        fontSize: 'Y2',
                        fontWeight: '700',
                        letterSpacing: '.1em',
                        textTransform: 'uppercase',
                        color: 'caption',
                        text: 'Owner'
                    },
                    ColPlans: {
                        tag: 'span',
                        fontSize: 'Y2',
                        fontWeight: '700',
                        letterSpacing: '.1em',
                        textTransform: 'uppercase',
                        color: 'caption',
                        text: 'Plans'
                    },
                    ColProjects: {
                        tag: 'span',
                        fontSize: 'Y2',
                        fontWeight: '700',
                        letterSpacing: '.1em',
                        textTransform: 'uppercase',
                        color: 'caption',
                        textAlign: 'right',
                        text: 'Projects'
                    },
                    ColMembers: {
                        tag: 'span',
                        fontSize: 'Y2',
                        fontWeight: '700',
                        letterSpacing: '.1em',
                        textTransform: 'uppercase',
                        color: 'caption',
                        textAlign: 'right',
                        text: 'Members'
                    }
                },
                List: {
                    flow: 'y',
                    childrenAs: 'state',
                    children: (el, s)=>$65981f4068c7b12e$var$_filteredOrganizations(s),
                    childExtends: {
                        display: 'grid',
                        gridTemplateColumns: '1fr 120px 200px 120px 80px 80px',
                        gap: 'A',
                        padding: 'Z1 A',
                        align: 'center',
                        cursor: 'pointer',
                        borderWidth: '0 0 1px 0',
                        borderColor: 'line',
                        borderStyle: 'solid',
                        ':hover': {
                            background: 'overlayStrong'
                        },
                        onClick: (e, el, s)=>$65981f4068c7b12e$var$_openDetail(s.root, 'organization', s),
                        Name: {
                            tag: 'span',
                            color: 'title',
                            fontWeight: '500',
                            style: {
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                            },
                            text: (el, s)=>s.name || s.id || ''
                        },
                        Slug: {
                            tag: 'span',
                            color: 'caption',
                            fontSize: 'Z2',
                            text: (el, s)=>s.slug || ''
                        },
                        Owner: {
                            tag: 'span',
                            color: 'caption',
                            fontSize: 'Z2',
                            style: {
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                            },
                            text: (el, s)=>s.owner?.email || s.owner?.name || ''
                        },
                        Plans: {
                            tag: 'span',
                            color: 'caption',
                            fontSize: 'Z2',
                            style: {
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                            },
                            text: (el, s)=>(s._plans || []).length ? s._plans.map((p)=>p.charAt(0).toUpperCase() + p.slice(1)).join(', ') : "\u2014"
                        },
                        ProjectCount: {
                            tag: 'span',
                            color: 'cyan',
                            fontSize: 'Z2',
                            fontWeight: '600',
                            textAlign: 'right',
                            text: (el, s)=>s._projectCount != null ? String(s._projectCount) : "\u2014"
                        },
                        MemberCount: {
                            tag: 'span',
                            color: 'caption',
                            fontSize: 'Z2',
                            textAlign: 'right',
                            text: (el, s)=>s.memberCount != null ? `${s.memberCount} member${s.memberCount === 1 ? '' : 's'}` : ''
                        }
                    }
                }
            },
            SubscriptionsList: {
                hide: (el, s)=>s.loading || !!s.error || $65981f4068c7b12e$var$_section(s) !== 'subscriptions',
                flow: 'y',
                round: 'Z',
                borderWidth: '1px',
                borderColor: 'line',
                borderStyle: 'solid',
                background: 'overlay',
                Header: {
                    display: 'grid',
                    gridTemplateColumns: '1fr 200px 80px 100px',
                    gap: 'A',
                    padding: 'Z A',
                    borderWidth: '0 0 1px 0',
                    borderColor: 'line',
                    borderStyle: 'solid',
                    background: 'document',
                    align: 'center',
                    ColWorkspace: {
                        tag: 'span',
                        fontSize: 'Y2',
                        fontWeight: '700',
                        letterSpacing: '.1em',
                        textTransform: 'uppercase',
                        color: 'caption',
                        text: 'Workspace'
                    },
                    ColOrg: {
                        tag: 'span',
                        fontSize: 'Y2',
                        fontWeight: '700',
                        letterSpacing: '.1em',
                        textTransform: 'uppercase',
                        color: 'caption',
                        text: 'Organization'
                    },
                    ColTier: {
                        tag: 'span',
                        fontSize: 'Y2',
                        fontWeight: '700',
                        letterSpacing: '.1em',
                        textTransform: 'uppercase',
                        color: 'caption',
                        textAlign: 'center',
                        text: 'Tier'
                    },
                    ColStatus: {
                        tag: 'span',
                        fontSize: 'Y2',
                        fontWeight: '700',
                        letterSpacing: '.1em',
                        textTransform: 'uppercase',
                        color: 'caption',
                        textAlign: 'right',
                        text: 'Status'
                    }
                },
                List: {
                    flow: 'y',
                    childrenAs: 'state',
                    children: (el, s)=>$65981f4068c7b12e$var$_filteredSubscriptions(s),
                    childExtends: 'DataSubscriptionRow'
                }
            },
            PaginationBar: {
                hide: (el, s)=>{
                    const p = $65981f4068c7b12e$var$_pageInfo(s);
                    if (!p.paginated || s.loading || s.error) return true;
                    return p.total <= 1;
                },
                flow: 'x',
                align: 'center',
                gap: 'A',
                padding: 'Z 0',
                PrevBtn: {
                    tag: 'button',
                    type: 'button',
                    text: "\u2190 Prev",
                    padding: 'Z A',
                    round: 'Z',
                    borderWidth: '1px',
                    borderStyle: 'solid',
                    borderColor: 'line',
                    background: 'overlay',
                    cursor: 'pointer',
                    color: 'title',
                    fontSize: 'Z2',
                    ':hover': {
                        background: 'overlayStrong'
                    },
                    disabled: (el, s)=>$65981f4068c7b12e$var$_pageInfo(s).cur <= 1 || s.loading,
                    onClick: (e, el, s)=>{
                        const { sec: sec, cur: cur } = $65981f4068c7b12e$var$_pageInfo(s);
                        if (cur <= 1) return;
                        const q = $65981f4068c7b12e$var$_searchFromQuery();
                        $65981f4068c7b12e$var$_pushUrl($65981f4068c7b12e$var$_urlFor(sec, {
                            page: cur - 1,
                            q: q
                        }));
                        $65981f4068c7b12e$var$_loadSection(s, sec, {
                            page: cur - 1,
                            search: q
                        });
                    }
                },
                PageInfo: {
                    tag: 'span',
                    color: 'caption',
                    fontSize: 'Z2',
                    text: (el, s)=>{
                        const { cur: cur, total: total } = $65981f4068c7b12e$var$_pageInfo(s);
                        return `Page ${cur} of ${total}`;
                    }
                },
                NextBtn: {
                    tag: 'button',
                    type: 'button',
                    text: "Next \u2192",
                    padding: 'Z A',
                    round: 'Z',
                    borderWidth: '1px',
                    borderStyle: 'solid',
                    borderColor: 'line',
                    background: 'overlay',
                    cursor: 'pointer',
                    color: 'title',
                    fontSize: 'Z2',
                    ':hover': {
                        background: 'overlayStrong'
                    },
                    disabled: (el, s)=>{
                        const { cur: cur, total: total } = $65981f4068c7b12e$var$_pageInfo(s);
                        return cur >= total || s.loading;
                    },
                    onClick: (e, el, s)=>{
                        const { sec: sec, cur: cur, total: total } = $65981f4068c7b12e$var$_pageInfo(s);
                        if (cur >= total) return;
                        const q = $65981f4068c7b12e$var$_searchFromQuery();
                        $65981f4068c7b12e$var$_pushUrl($65981f4068c7b12e$var$_urlFor(sec, {
                            page: cur + 1,
                            q: q
                        }));
                        $65981f4068c7b12e$var$_loadSection(s, sec, {
                            page: cur + 1,
                            search: q
                        });
                    }
                }
            },
            EmptyState: {
                hide: (el, s)=>{
                    if (s.loading || s.error) return true;
                    const sec = $65981f4068c7b12e$var$_section(s);
                    const list = sec === 'users' ? $65981f4068c7b12e$var$_filteredUsers(s) : sec === 'plans' ? $65981f4068c7b12e$var$_filteredPlans(s) : sec === 'organizations' ? $65981f4068c7b12e$var$_filteredOrganizations(s) : sec === 'subscriptions' ? $65981f4068c7b12e$var$_filteredSubscriptions(s) : $65981f4068c7b12e$var$_filteredProjects(s);
                    return list.length > 0;
                },
                padding: 'C',
                textAlign: 'center',
                color: 'caption',
                text: (el, s)=>$65981f4068c7b12e$var$_query(s) ? 'No matches' : 'No data'
            }
        }
    },
    DataDetailModal: {
        extends: 'Modal',
        stateKey: 'dataDetail',
        Window: {
            extends: 'ModalWindow',
            width: '100%',
            maxWidth: 'I1',
            maxHeight: '90dvh',
            overflow: 'auto',
            ModalHeader: {
                Hgroup: {
                    H: {
                        text: (el, s)=>{
                            const it = s.dataDetail?.item || {};
                            return it.name || it.displayName || it.workspaceName || it.key || it.email || it.id || "\u2014";
                        }
                    },
                    P: {
                        text: (el, s)=>{
                            const it = s.dataDetail?.item || {};
                            const k = s.dataDetail?.kind;
                            const prefix = k === 'user' ? 'USER' : k === 'plan' ? 'PLAN' : k === 'organization' ? 'ORGANIZATION' : k === 'subscription' ? 'SUBSCRIPTION' : 'PROJECT';
                            const sub = k === 'user' ? it.email || '' : k === 'plan' ? it.displayName || it.name || '' : k === 'subscription' ? it.workspaceName || it.workspaceSlug || it.orgName || '' : it.key || it.slug || '';
                            return sub ? `${prefix} \xb7 ${sub}` : prefix;
                        }
                    }
                }
            },
            Summary: {
                flow: 'y',
                padding: 'A C',
                // Toggle edit mode button
                EditToggle: {
                    hide: (el, s)=>!$65981f4068c7b12e$var$_isDataAdmin() || s.dataDetail?.kind === 'plan',
                    flow: 'x',
                    align: 'center right',
                    padding: '0 0 Z 0',
                    ToggleBtn: {
                        tag: 'button',
                        type: 'button',
                        padding: 'Z A',
                        round: 'Z',
                        borderWidth: '1px',
                        borderStyle: 'solid',
                        cursor: 'pointer',
                        fontSize: 'Z2',
                        fontWeight: '600',
                        borderColor: (el, s)=>s.root?._editing ? 'blue' : 'line',
                        background: (el, s)=>s.root?._editing ? 'blue.2' : 'transparent',
                        color: (el, s)=>s.root?._editing ? 'blue' : 'caption',
                        text: (el, s)=>s.root?._editing ? 'Cancel' : 'Edit',
                        onClick: (e, el, s)=>{
                            if (s.root?._editing) s.root.update({
                                _editing: false,
                                _editDraft: null
                            });
                            else s.root.update({
                                _editing: true,
                                _editDraft: {
                                    ...s.dataDetail?.item
                                }
                            });
                        }
                    },
                    SaveBtn: {
                        tag: 'button',
                        type: 'button',
                        hide: (el, s)=>!s.root?._editing,
                        text: (el, s)=>s.root?._saving ? "Saving\u2026" : 'Save',
                        disabled: (el, s)=>!!s.root?._saving,
                        padding: 'Z A',
                        round: 'Z',
                        borderWidth: '0',
                        background: 'blue',
                        color: 'white',
                        fontWeight: '600',
                        cursor: 'pointer',
                        margin: '0 0 0 Z',
                        onClick: async (e, el, s)=>{
                            const detail = s.dataDetail;
                            const draft = s.root?._editDraft;
                            if (!detail?.item || !draft) return;
                            const id = detail.item.id || detail.item._id;
                            const kind = detail.kind;
                            // Collect only changed editable fields
                            const changes = {};
                            for (const [key, def] of Object.entries($65981f4068c7b12e$var$_editableFields)){
                                if (!$65981f4068c7b12e$var$_isEditable(key, kind)) continue;
                                if (draft[key] !== undefined && draft[key] !== detail.item[key]) changes[key] = draft[key];
                            }
                            if (!Object.keys(changes).length) {
                                s.root.update({
                                    _editing: false,
                                    _editDraft: null
                                });
                                return;
                            }
                            s.root.update({
                                _saving: true
                            });
                            try {
                                const sdk = await $65981f4068c7b12e$var$_getSDK();
                                if (kind === 'project') await sdk.updateProject(id, changes);
                                else if (kind === 'user') await sdk.updateUser(id, changes);
                                const updated = {
                                    ...detail.item,
                                    ...changes
                                };
                                s.root.update({
                                    dataDetail: {
                                        ...detail,
                                        item: updated
                                    },
                                    _editing: false,
                                    _editDraft: null,
                                    _saving: false
                                });
                                $65981f4068c7b12e$var$_invalidate(kind === 'project' ? 'projects' : 'users');
                            } catch (err) {
                                console.error('[data] save failed', err);
                                s.root.update({
                                    _saving: false
                                });
                            }
                        }
                    }
                },
                SummaryInner: {
                    flow: 'y',
                    childrenAs: 'state',
                    children: (el, s)=>{
                        const kind = s.dataDetail?.kind;
                        const it = s.root?._editing ? s.root?._editDraft || {} : s.dataDetail?.item || {};
                        const fields = kind === 'user' ? $65981f4068c7b12e$var$_userFields : kind === 'plan' ? $65981f4068c7b12e$var$_planFields : $65981f4068c7b12e$var$_projectFields;
                        return fields.filter((f)=>it[f] != null && it[f] !== '' || s.root?._editing && $65981f4068c7b12e$var$_isEditable(f, kind)).map((f)=>({
                                key: f,
                                value: it[f] ?? '',
                                _kind: kind,
                                _editable: $65981f4068c7b12e$var$_isEditable(f, kind) && $65981f4068c7b12e$var$_isDataAdmin(),
                                _editing: !!s.root?._editing
                            }));
                    },
                    childExtends: {
                        display: 'grid',
                        gridTemplateColumns: '120px 1fr',
                        gap: 'Z',
                        padding: 'Z A',
                        align: 'center',
                        borderWidth: '0 0 1px 0',
                        borderColor: 'line',
                        borderStyle: 'solid',
                        Label: {
                            tag: 'span',
                            color: 'caption',
                            fontSize: 'Z2',
                            fontWeight: '600',
                            text: (el, s)=>s.key
                        },
                        // Read-only value
                        Value: {
                            tag: 'span',
                            hide: (el, s)=>s._editing && s._editable,
                            color: 'title',
                            fontSize: 'Z2',
                            textAlign: 'right',
                            style: {
                                wordBreak: 'break-word'
                            },
                            text: (el, s)=>$65981f4068c7b12e$var$_fmt(s.value, s.key)
                        },
                        // Editable select
                        Select: {
                            tag: 'select',
                            hide: (el, s)=>!(s._editing && s._editable && $65981f4068c7b12e$var$_editableFields[s.key]?.type === 'select'),
                            padding: 'V Z',
                            round: 'Z',
                            borderWidth: '1px',
                            borderStyle: 'solid',
                            borderColor: 'blue',
                            background: 'document',
                            color: 'title',
                            fontSize: 'Z2',
                            cursor: 'pointer',
                            value: (el, s)=>s.value ?? '',
                            childrenAs: 'state',
                            children: (el, s)=>($65981f4068c7b12e$var$_editableFields[s.key]?.options || []).map((o)=>({
                                        value: o,
                                        text: o
                                    })),
                            childExtends: {
                                tag: 'option',
                                value: (el, s)=>s.value,
                                text: (el, s)=>s.text
                            },
                            onChange: (e, el, s)=>{
                                const draft = {
                                    ...s.root?._editDraft || {}
                                };
                                draft[s.key] = e.target.value;
                                s.root.update({
                                    _editDraft: draft
                                });
                            }
                        },
                        // Editable input
                        Input: {
                            tag: 'input',
                            type: 'text',
                            hide: (el, s)=>!(s._editing && s._editable && $65981f4068c7b12e$var$_editableFields[s.key]?.type === 'input'),
                            padding: 'V Z',
                            round: 'Z',
                            borderWidth: '1px',
                            borderStyle: 'solid',
                            borderColor: 'blue',
                            background: 'document',
                            color: 'title',
                            fontSize: 'Z2',
                            width: '100%',
                            value: (el, s)=>s.value ?? '',
                            onInput: (e, el, s)=>{
                                const draft = {
                                    ...s.root?._editDraft || {}
                                };
                                draft[s.key] = e.target.value;
                                s.root.update({
                                    _editDraft: draft
                                });
                            }
                        }
                    }
                }
            },
            // Plan features — pretty nested rendering of item.features.
            // Reuses the DataPlanFeature component so strings, {label,included,detail}
            // and nested {group, items} shapes all render the same as on cards.
            PlanFeatures: {
                hide: (el, s)=>{
                    if (s.dataDetail?.kind !== 'plan') return true;
                    const it = s.dataDetail?.item || {};
                    return $65981f4068c7b12e$var$_normalizePlanFeatures(it.features || it.featureList).length === 0;
                },
                flow: 'y',
                gap: 'A',
                padding: 'A C',
                SectionLabel: {
                    tag: 'span',
                    fontSize: 'Y2',
                    fontWeight: '700',
                    letterSpacing: '.12em',
                    textTransform: 'uppercase',
                    color: 'caption',
                    text: (el, s)=>{
                        const it = s.dataDetail?.item || {};
                        const n = $65981f4068c7b12e$var$_normalizePlanFeatures(it.features || it.featureList).length;
                        return `Features (${n})`;
                    }
                },
                FeaturesBox: {
                    flow: 'y',
                    gap: 'A',
                    padding: 'A',
                    round: 'Z',
                    background: 'overlay',
                    borderWidth: '1px',
                    borderStyle: 'solid',
                    borderColor: 'line',
                    childrenAs: 'state',
                    children: (el, s)=>{
                        const it = s.dataDetail?.item || {};
                        return $65981f4068c7b12e$var$_normalizePlanFeatures(it.features || it.featureList);
                    },
                    childExtends: 'DataPlanFeature'
                }
            },
            // Pricing options — the /plans endpoint returns an array with every
            // available price tier (monthly/yearly/etc.) + any lookup keys.
            PlanPricingOptions: {
                hide: (el, s)=>{
                    if (s.dataDetail?.kind !== 'plan') return true;
                    return !(s.dataDetail?.item?.pricingOptions || []).length;
                },
                flow: 'y',
                gap: 'Z',
                padding: 'A C',
                SectionLabel: {
                    tag: 'span',
                    fontSize: 'Y2',
                    fontWeight: '700',
                    letterSpacing: '.12em',
                    textTransform: 'uppercase',
                    color: 'caption',
                    text: (el, s)=>`Pricing options (${(s.dataDetail?.item?.pricingOptions || []).length})`
                },
                OptionsList: {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
                    gap: 'Z',
                    childrenAs: 'state',
                    children: (el, s)=>s.dataDetail?.item?.pricingOptions || [],
                    childExtends: {
                        flow: 'y',
                        gap: 'V',
                        padding: 'A',
                        round: 'Z',
                        background: 'overlay',
                        borderWidth: '1px',
                        borderStyle: 'solid',
                        borderColor: (el, s)=>s.isPopular ? 'blue' : 'line',
                        Header: {
                            flow: 'x',
                            align: 'center space-between',
                            Name: {
                                tag: 'strong',
                                color: 'title',
                                text: (el, s)=>s.displayName || s.key || ''
                            },
                            Popular: {
                                hide: (el, s)=>!s.isPopular,
                                tag: 'span',
                                padding: 'V Z',
                                round: 'Z',
                                background: 'blue',
                                color: 'white',
                                fontSize: 'Y2',
                                fontWeight: '700',
                                textTransform: 'uppercase',
                                text: 'Popular'
                            }
                        },
                        Price: {
                            flow: 'x',
                            align: 'baseline',
                            gap: 'V',
                            Amount: {
                                tag: 'strong',
                                color: 'title',
                                fontSize: 'C',
                                text: (el, s)=>$65981f4068c7b12e$var$_formatPrice(s.amount) ?? "\u2014"
                            },
                            Interval: {
                                tag: 'span',
                                color: 'caption',
                                fontSize: 'Z2',
                                text: (el, s)=>s.interval && Number(s.amount) !== 0 ? `/ ${s.interval}` : ''
                            }
                        },
                        Desc: {
                            hide: (el, s)=>!s.description,
                            tag: 'span',
                            color: 'caption',
                            fontSize: 'Z2',
                            text: (el, s)=>s.description || ''
                        },
                        LookupKey: {
                            hide: (el, s)=>!s.lookupKey,
                            tag: 'code',
                            fontSize: 'Y2',
                            color: 'caption',
                            text: (el, s)=>s.lookupKey || ''
                        }
                    }
                }
            },
            // Plan limits — when the plan exposes a numeric limits/quotas object,
            // render it as a neat two-column grid instead of raw JSON.
            PlanLimits: {
                hide: (el, s)=>{
                    if (s.dataDetail?.kind !== 'plan') return true;
                    const lim = s.dataDetail?.item?.limits || s.dataDetail?.item?.quotas;
                    return !lim || typeof lim !== 'object' || Object.keys(lim).length === 0;
                },
                flow: 'y',
                gap: 'Z',
                padding: 'A C',
                SectionLabel: {
                    tag: 'span',
                    fontSize: 'Y2',
                    fontWeight: '700',
                    letterSpacing: '.12em',
                    textTransform: 'uppercase',
                    color: 'caption',
                    text: 'Limits'
                },
                LimitsGrid: {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))',
                    gap: 'Z',
                    childrenAs: 'state',
                    children: (el, s)=>{
                        const lim = s.dataDetail?.item?.limits || s.dataDetail?.item?.quotas || {};
                        return Object.entries(lim).map(([key, value])=>({
                                key: key,
                                value: value
                            }));
                    },
                    childExtends: {
                        flow: 'y',
                        gap: 'V',
                        padding: 'Z A',
                        round: 'Z',
                        background: 'overlay',
                        borderWidth: '1px',
                        borderStyle: 'solid',
                        borderColor: 'line',
                        Label: {
                            tag: 'span',
                            fontSize: 'Y2',
                            color: 'caption',
                            fontWeight: '600',
                            letterSpacing: '.04em',
                            textTransform: 'uppercase',
                            text: (el, s)=>s.key
                        },
                        Value: {
                            tag: 'strong',
                            color: 'title',
                            fontSize: 'Z1',
                            text: (el, s)=>{
                                const v = s.value;
                                if (v === true) return 'Yes';
                                if (v === false) return 'No';
                                if (v === null || v === undefined) return "\u2014";
                                if (typeof v === 'number' && !Number.isFinite(v)) return "\u221E";
                                if (typeof v === 'object') return JSON.stringify(v);
                                return String(v);
                            }
                        }
                    }
                }
            },
            // Local profile — shown only when the selected user's email matches
            // a row in root.people. Clicking opens the intranet profile modal
            // (same mechanism as AppHeader's ProfileItem: root.profileEmail = …).
            LocalUserCard: {
                hide: (el, s)=>s.dataDetail?.kind !== 'user' || !$65981f4068c7b12e$var$_localMatch(s.root, s.dataDetail?.item?.email),
                flow: 'y',
                gap: 'Z',
                padding: 'A C',
                SectionLabel: {
                    tag: 'span',
                    fontSize: 'Y2',
                    fontWeight: '700',
                    letterSpacing: '.12em',
                    textTransform: 'uppercase',
                    color: 'caption',
                    text: 'Local profile'
                },
                Card: {
                    flow: 'x',
                    align: 'center',
                    gap: 'A',
                    padding: 'A',
                    round: 'Z',
                    background: 'overlay',
                    borderWidth: '1px',
                    borderStyle: 'solid',
                    borderColor: 'line',
                    cursor: 'pointer',
                    ':hover': {
                        background: 'overlayStrong',
                        borderColor: 'blue'
                    },
                    onClick: (e, el, s)=>{
                        const m = $65981f4068c7b12e$var$_localMatch(s.root, s.dataDetail?.item?.email);
                        if (!m) return;
                        s.root.update({
                            dataDetail: null,
                            profileEmail: m.email
                        });
                    },
                    Avatar: {
                        extends: 'Avatar',
                        avatarType: 'initials',
                        boxSize: 'C C',
                        src: (el, s)=>el.call('avatarUrlFor', $65981f4068c7b12e$var$_localMatch(s.root, s.dataDetail?.item?.email)?.email)
                    },
                    Info: {
                        flow: 'y',
                        gap: 'V',
                        flex: '1',
                        minWidth: '0',
                        Name: {
                            tag: 'span',
                            color: 'title',
                            fontSize: 'Z1',
                            fontWeight: '600',
                            style: {
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                            },
                            text: (el, s)=>$65981f4068c7b12e$var$_localMatch(s.root, s.dataDetail?.item?.email)?.name || ''
                        },
                        Meta: {
                            tag: 'span',
                            color: 'caption',
                            fontSize: 'Z2',
                            text: (el, s)=>{
                                const m = $65981f4068c7b12e$var$_localMatch(s.root, s.dataDetail?.item?.email);
                                if (!m) return '';
                                const email = String(m.email || '').toLowerCase();
                                const team = (s.root?.teamsByEmail?.[email] || [])[0]?.name;
                                return [
                                    m.position,
                                    team,
                                    m.location
                                ].filter(Boolean).join(" \xb7 ");
                            }
                        },
                        Email: {
                            tag: 'span',
                            color: 'caption',
                            fontSize: 'Z2',
                            text: (el, s)=>$65981f4068c7b12e$var$_localMatch(s.root, s.dataDetail?.item?.email)?.email || ''
                        }
                    },
                    OpenHint: {
                        tag: 'span',
                        color: 'blue',
                        fontSize: 'Z2',
                        fontWeight: '600',
                        text: "Open profile \u2192"
                    }
                }
            },
            // Members — only for projects. Rows from item.members with
            // name / email / role. Hidden when the list is empty.
            Members: {
                hide: (el, s)=>{
                    const d = s.dataDetail;
                    if (!d || d.kind !== 'project' && d.kind !== 'organization') return true;
                    const m = d.item?.members;
                    return !Array.isArray(m) || m.length === 0;
                },
                flow: 'y',
                gap: 'Z',
                padding: 'A C',
                SectionLabel: {
                    tag: 'span',
                    fontSize: 'Y2',
                    fontWeight: '700',
                    letterSpacing: '.12em',
                    textTransform: 'uppercase',
                    color: 'caption',
                    text: (el, s)=>`Members (${(s.dataDetail?.item?.members || []).length})`
                },
                MembersList: {
                    flow: 'y',
                    round: 'Z',
                    background: 'overlay',
                    borderWidth: '1px',
                    borderColor: 'line',
                    borderStyle: 'solid',
                    childrenAs: 'state',
                    children: (el, s)=>s.dataDetail?.item?.members || [],
                    childExtends: {
                        flow: 'x',
                        align: 'center',
                        gap: 'A',
                        padding: 'Z A',
                        borderWidth: '0 0 1px 0',
                        borderColor: 'line',
                        borderStyle: 'solid',
                        Name: {
                            tag: 'span',
                            color: 'title',
                            fontWeight: '500',
                            flex: '1',
                            minWidth: '0',
                            style: {
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                            },
                            text: (el, s)=>s.user && (s.user.name || s.user.email) || s.name || s.email || s.userId || s.user_id || ''
                        },
                        Email: {
                            tag: 'span',
                            color: 'caption',
                            fontSize: 'Z2',
                            text: (el, s)=>s.user && s.user.email || s.email || ''
                        },
                        Role: {
                            tag: 'span',
                            color: 'title',
                            fontSize: 'Z2',
                            fontWeight: '600',
                            width: 'D',
                            textAlign: 'right',
                            text: (el, s)=>s.role || s.permissions && String(s.permissions) || ''
                        }
                    }
                }
            },
            // Domains — only for projects. `domains` is either an array or an
            // object keyed by slot (main, www, …) with `.domain` strings.
            Domains: {
                hide: (el, s)=>$65981f4068c7b12e$var$_domainsList(s.dataDetail).length === 0,
                flow: 'y',
                gap: 'Z',
                padding: 'A C',
                SectionLabel: {
                    tag: 'span',
                    fontSize: 'Y2',
                    fontWeight: '700',
                    letterSpacing: '.12em',
                    textTransform: 'uppercase',
                    color: 'caption',
                    text: (el, s)=>`Domains (${$65981f4068c7b12e$var$_domainsList(s.dataDetail).length})`
                },
                DomainsList: {
                    flow: 'x',
                    gap: 'Z',
                    style: {
                        flexWrap: 'wrap'
                    },
                    childrenAs: 'state',
                    children: (el, s)=>$65981f4068c7b12e$var$_domainsList(s.dataDetail),
                    childExtends: {
                        tag: 'a',
                        padding: 'V Z1',
                        round: 'Z',
                        background: 'overlay',
                        borderWidth: '1px',
                        borderStyle: 'solid',
                        borderColor: 'line',
                        color: 'title',
                        fontSize: 'Z2',
                        textDecoration: 'none',
                        target: '_blank',
                        href: (el, s)=>{
                            const host = s.domain || '';
                            if (!host) return '#';
                            return /^https?:\/\//.test(host) ? host : `https://${host}`;
                        },
                        text: (el, s)=>{
                            const label = s.domain || s.slot || '';
                            return s.slot && s.slot !== s.domain ? `${s.slot}: ${s.domain}` : label;
                        }
                    }
                }
            },
            // Permissions — shows item.permissions (object or array).
            // Applies to both projects (project-level ACLs) and users (globalRole etc).
            Permissions: {
                hide: (el, s)=>{
                    const it = s.dataDetail?.item || {};
                    const p = it.permissions;
                    if (p == null) return true;
                    if (Array.isArray(p)) return p.length === 0;
                    if (typeof p === 'object') return Object.keys(p).length === 0;
                    return false;
                },
                flow: 'y',
                gap: 'Z',
                padding: 'A C C',
                SectionLabel: {
                    tag: 'span',
                    fontSize: 'Y2',
                    fontWeight: '700',
                    letterSpacing: '.12em',
                    textTransform: 'uppercase',
                    color: 'caption',
                    text: 'Permissions'
                },
                PermissionsList: {
                    flow: 'y',
                    round: 'Z',
                    background: 'overlay',
                    borderWidth: '1px',
                    borderColor: 'line',
                    borderStyle: 'solid',
                    childrenAs: 'state',
                    children: (el, s)=>{
                        const p = s.dataDetail?.item?.permissions;
                        if (!p) return [];
                        if (Array.isArray(p)) return p.map((v, i)=>({
                                key: String(i),
                                value: v
                            }));
                        if (typeof p === 'object') return Object.entries(p).map(([k, v])=>({
                                key: k,
                                value: v
                            }));
                        return [
                            {
                                key: 'value',
                                value: p
                            }
                        ];
                    },
                    childExtends: {
                        flow: 'x',
                        align: 'start space-between',
                        gap: 'B',
                        padding: 'Z A',
                        borderWidth: '0 0 1px 0',
                        borderColor: 'line',
                        borderStyle: 'solid',
                        Label: {
                            tag: 'span',
                            color: 'caption',
                            fontSize: 'Z2',
                            fontWeight: '600',
                            text: (el, s)=>s.key
                        },
                        Value: {
                            tag: 'span',
                            color: 'title',
                            fontSize: 'Z2',
                            textAlign: 'right',
                            style: {
                                wordBreak: 'break-word',
                                maxWidth: '60%'
                            },
                            text: (el, s)=>$65981f4068c7b12e$var$_fmt(s.value)
                        }
                    }
                }
            },
            // Footer — only for projects. Three deep-link buttons.
            ModalFooter: {
                hide: (el, s)=>s.dataDetail?.kind !== 'project',
                flow: 'x',
                align: 'center',
                gap: 'Z',
                padding: 'A C B',
                borderWidth: '1px 0 0 0',
                borderStyle: 'solid',
                borderColor: 'line',
                style: {
                    flexWrap: 'wrap'
                },
                DirectBtn: {
                    tag: 'a',
                    target: '_blank',
                    hide: (el, s)=>!$65981f4068c7b12e$var$_directUrl(s.dataDetail?.item),
                    href: (el, s)=>$65981f4068c7b12e$var$_directUrl(s.dataDetail?.item) || '#',
                    padding: 'Z A',
                    round: 'Z',
                    borderWidth: '1px',
                    borderStyle: 'solid',
                    borderColor: 'line',
                    background: 'overlay',
                    color: 'title',
                    fontSize: 'Z2',
                    fontWeight: '500',
                    textDecoration: 'none',
                    ':hover': {
                        background: 'overlayStrong'
                    },
                    text: 'Open direct'
                },
                PreviewBtn: {
                    tag: 'a',
                    target: '_blank',
                    hide: (el, s)=>!$65981f4068c7b12e$var$_previewUrl(s.dataDetail?.item),
                    href: (el, s)=>$65981f4068c7b12e$var$_previewUrl(s.dataDetail?.item) || '#',
                    padding: 'Z A',
                    round: 'Z',
                    borderWidth: '1px',
                    borderStyle: 'solid',
                    borderColor: 'line',
                    background: 'overlay',
                    color: 'title',
                    fontSize: 'Z2',
                    fontWeight: '500',
                    textDecoration: 'none',
                    ':hover': {
                        background: 'overlayStrong'
                    },
                    text: 'Open preview'
                },
                CanvasBtn: {
                    tag: 'a',
                    target: '_blank',
                    hide: (el, s)=>!$65981f4068c7b12e$var$_canvasUrl(s.dataDetail?.item),
                    href: (el, s)=>$65981f4068c7b12e$var$_canvasUrl(s.dataDetail?.item) || '#',
                    padding: 'Z A',
                    round: 'Z',
                    borderWidth: '0',
                    background: 'blue',
                    color: 'white',
                    fontSize: 'Z2',
                    fontWeight: '600',
                    textDecoration: 'none',
                    ':hover': {
                        filter: 'brightness(1.1)'
                    },
                    text: 'Open canvas'
                },
                // Transfer ownership — select from available orgs
                TransferGroup: {
                    hide: (el, s)=>!$65981f4068c7b12e$var$_isDataAdmin(),
                    flow: 'x',
                    align: 'center',
                    gap: 'Z',
                    margin: '0 0 0 auto',
                    OrgSelect: {
                        tag: 'select',
                        padding: 'Z A',
                        round: 'Z',
                        borderWidth: '1px',
                        borderStyle: 'solid',
                        borderColor: 'line',
                        background: 'document',
                        color: 'title',
                        fontSize: 'Z2',
                        cursor: 'pointer',
                        childrenAs: 'state',
                        children: (el, s)=>{
                            const orgs = s.organizations || [];
                            const current = s.dataDetail?.item?.owner?.slug || s.dataDetail?.item?.owner?.username || '';
                            return [
                                {
                                    value: '',
                                    text: `Owner: ${current || "\u2014"}`
                                },
                                ...orgs.map((o)=>({
                                        value: o.id || o._id,
                                        text: o.name,
                                        slug: o.slug
                                    }))
                            ];
                        },
                        childExtends: {
                            tag: 'option',
                            value: (el, s)=>s.value,
                            text: (el, s)=>s.text
                        },
                        onChange: async (e, el, s)=>{
                            const orgId = e.target.value;
                            if (!orgId) return;
                            const projectId = s.dataDetail?.item?.id || s.dataDetail?.item?._id;
                            if (!projectId) return;
                            try {
                                const sdk = await $65981f4068c7b12e$var$_getSDK();
                                await sdk.transferProjectOwnership(projectId, {
                                    targetType: 'organization',
                                    organizationId: orgId
                                });
                                // Refresh the detail
                                const orgs = s.organizations || [];
                                const org = orgs.find((o)=>(o.id || o._id) === orgId);
                                const detail = s.dataDetail;
                                if (detail?.item) {
                                    detail.item.ownerType = 'organization';
                                    detail.item.owner = {
                                        name: org?.name,
                                        slug: org?.slug,
                                        type: 'organization'
                                    };
                                    detail.item.ownerOrganization = {
                                        name: org?.name,
                                        slug: org?.slug
                                    };
                                    // Forward-compat: write workspace path so Phase-3-aware
                                    // renderers (see _isOrgOwned / _ownerOrg) pick up the
                                    // transfer without refetching.
                                    detail.item.workspace = {
                                        ...detail.item.workspace || {},
                                        type: 'shared',
                                        organization: {
                                            name: org?.name,
                                            slug: org?.slug
                                        }
                                    };
                                    s.root.update({
                                        dataDetail: {
                                            ...detail
                                        }
                                    });
                                }
                                $65981f4068c7b12e$var$_invalidate('projects');
                                e.target.value = '';
                            } catch (err) {
                                console.error('[data] transfer failed', err);
                            }
                        }
                    }
                }
            }
        }
    }
};
const $65981f4068c7b12e$export$67abb7f201537511 = {
    flow: 'y',
    gap: 'V',
    // Group header — only shown when the feature object looks like a nested group.
    GroupHeader: {
        hide: (el, s)=>!(s?.group && Array.isArray(s?.items)),
        tag: 'span',
        fontSize: 'Y2',
        fontWeight: '700',
        letterSpacing: '.12em',
        textTransform: 'uppercase',
        color: 'caption',
        text: (el, s)=>s.group || ''
    },
    // Nested items — only when this is a group. Each item follows the same
    // shape rules as flat features (string or { label, included }).
    GroupItems: {
        hide: (el, s)=>!Array.isArray(s?.items),
        flow: 'y',
        gap: 'V',
        padding: '0 0 0 A',
        childrenAs: 'state',
        children: (el, s)=>s.items || [],
        childExtends: 'DataPlanFeatureRow'
    },
    DataPlanFeatureRow: {
        hide: (el, s)=>Array.isArray(s?.items)
    }
};
const $65981f4068c7b12e$export$fcd8c07b3d02baa3 = {
    flow: 'x',
    align: 'center left',
    gap: 'Z',
    fontSize: 'Z2',
    Mark: {
        tag: 'span',
        width: 'Z1',
        textAlign: 'center',
        fontWeight: '700',
        color: (el, s)=>{
            if (typeof s === 'string') return 'green';
            return s?.included === false ? 'caption' : 'green';
        },
        text: (el, s)=>{
            if (typeof s === 'string') return "\u2713";
            return s?.included === false ? "\u2014" : "\u2713";
        }
    },
    Label: {
        tag: 'span',
        flex: '1',
        color: (el, s)=>typeof s !== 'string' && s?.included === false ? 'caption' : 'title',
        text: (el, s)=>{
            if (typeof s === 'string') return s;
            return s?.label || s?.name || s?.text || '';
        }
    },
    Detail: {
        hide: (el, s)=>typeof s === 'string' || !(s?.detail || s?.value),
        tag: 'span',
        color: 'caption',
        fontSize: 'Y2',
        text: (el, s)=>s?.detail || s?.value || ''
    }
};
const $65981f4068c7b12e$export$4131246133c6bc66 = {
    display: 'grid',
    gridTemplateColumns: '1fr 160px 100px 80px',
    gap: 'A',
    padding: 'Z1 A',
    align: 'center',
    cursor: 'pointer',
    borderWidth: '0 0 1px 0',
    borderColor: 'line',
    borderStyle: 'solid',
    ':hover': {
        background: 'overlayStrong'
    },
    onClick: (e, el, s)=>$65981f4068c7b12e$var$_openDetail(s.root, 'project', s),
    NameGroup: {
        flow: 'x',
        align: 'center',
        gap: 'Z',
        minWidth: '0',
        Name: {
            tag: 'span',
            color: 'title',
            fontWeight: '500',
            style: {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            },
            text: (el, s)=>s.name || s.key || s.id || ''
        },
        Key: {
            tag: 'span',
            color: 'caption',
            fontSize: 'Y2',
            style: {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            },
            text: (el, s)=>{
                const owner = $65981f4068c7b12e$var$_ownerUsername(s);
                const slug = $65981f4068c7b12e$var$_projectSlug(s);
                return owner ? `${owner}/${slug}` : s.key || '';
            }
        }
    },
    OwnerCol: {
        flow: 'x',
        align: 'center left',
        gap: 'Y',
        minWidth: '0',
        Icon: {
            tag: 'span',
            fontSize: 'Y2',
            text: (el, s)=>$65981f4068c7b12e$var$_isOrgOwned(s) ? "\uD83C\uDFE2" : "\uD83D\uDC64"
        },
        Text: {
            tag: 'span',
            color: 'subtitle',
            fontSize: 'Z2',
            style: {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            },
            text: (el, s)=>{
                if ($65981f4068c7b12e$var$_isOrgOwned(s)) {
                    const org = $65981f4068c7b12e$var$_ownerOrg(s);
                    return org?.name || org?.slug || '';
                }
                return $65981f4068c7b12e$var$_ownerUsername(s) || '';
            }
        }
    },
    AccessCol: {
        textAlign: 'center',
        Badge: {
            tag: 'span',
            padding: 'V Z',
            round: 'Z',
            fontSize: 'Y2',
            fontWeight: '600',
            letterSpacing: '.06em',
            textTransform: 'uppercase',
            background: (el, s)=>s.access === 'public' ? 'green.2' : 'overlayStrong',
            color: (el, s)=>s.access === 'public' ? 'green' : 'caption',
            text: (el, s)=>s.access || ''
        }
    },
    Members: {
        tag: 'span',
        color: 'caption',
        fontSize: 'Z2',
        textAlign: 'right',
        text: (el, s)=>s.memberCount != null ? `${s.memberCount} user${s.memberCount === 1 ? '' : 's'}` : ''
    }
};
const $65981f4068c7b12e$export$56f192ec4234b344 = {
    display: 'grid',
    gridTemplateColumns: '1fr 200px 80px 100px',
    gap: 'A',
    padding: 'Z1 A',
    align: 'center',
    cursor: 'pointer',
    borderWidth: '0 0 1px 0',
    borderColor: 'line',
    borderStyle: 'solid',
    ':hover': {
        background: 'overlayStrong'
    },
    onClick: (e, el, s)=>$65981f4068c7b12e$var$_openDetail(s.root, 'subscription', s),
    WorkspaceGroup: {
        flow: 'y',
        minWidth: '0',
        Name: {
            tag: 'span',
            color: 'title',
            fontWeight: '500',
            style: {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            },
            text: (el, s)=>s.workspaceName || s.workspaceSlug || s.workspaceId || ''
        },
        Slug: {
            tag: 'span',
            color: 'caption',
            fontSize: 'Y2',
            text: (el, s)=>s.workspaceSlug || ''
        }
    },
    Org: {
        tag: 'span',
        color: 'caption',
        fontSize: 'Z2',
        style: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        },
        text: (el, s)=>s.orgName || ''
    },
    Tier: {
        ...$65981f4068c7b12e$var$_TIER_BADGE,
        textAlign: 'center',
        text: (el, s)=>s.tier || "\u2014"
    },
    Status: {
        tag: 'span',
        color: (el, s)=>s.status === 'active' ? 'green' : 'caption',
        fontSize: 'Z2',
        textAlign: 'right',
        text: (el, s)=>s.status || ''
    }
};
const $65981f4068c7b12e$export$577e51e824103044 = {
    display: 'grid',
    gridTemplateColumns: '1fr 220px 100px 80px 80px',
    gap: 'A',
    padding: 'Z1 A',
    align: 'center',
    cursor: 'pointer',
    borderWidth: '0 0 1px 0',
    borderColor: 'line',
    borderStyle: 'solid',
    ':hover': {
        background: 'overlayStrong'
    },
    onClick: (e, el, s)=>$65981f4068c7b12e$var$_openDetail(s.root, 'user', s),
    NameGroup: {
        flow: 'x',
        align: 'center',
        gap: 'Z',
        flex: '1',
        minWidth: '0',
        Name: {
            tag: 'span',
            color: 'title',
            fontWeight: '500',
            style: {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            },
            text: (el, s)=>s.name || s.username || s.email || s.id || ''
        },
        Username: {
            hide: (el, s)=>!s.username,
            tag: 'span',
            color: 'caption',
            fontSize: 'Y2',
            text: (el, s)=>`@${s.username}`
        },
        VerifiedBadge: {
            hide: (el, s)=>!s.emailVerified,
            tag: 'span',
            title: 'Verified',
            padding: 'V Z',
            round: 'Z',
            background: 'green',
            color: 'white',
            fontSize: 'Y2',
            fontWeight: '700',
            letterSpacing: '.04em',
            textTransform: 'uppercase',
            text: "\u2713"
        }
    },
    Email: {
        tag: 'span',
        color: 'caption',
        fontSize: 'Z2',
        style: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        },
        text: (el, s)=>s.email || ''
    },
    StatusCol: {
        textAlign: 'center',
        Badge: {
            tag: 'span',
            padding: 'V Z',
            round: 'Z',
            fontSize: 'Y2',
            fontWeight: '600',
            letterSpacing: '.06em',
            textTransform: 'uppercase',
            background: (el, s)=>{
                const st = s.status || 'active';
                if (st === 'active') return 'green.2';
                if (st === 'pending') return 'yellow.2';
                return 'overlayStrong';
            },
            color: (el, s)=>{
                const st = s.status || 'active';
                if (st === 'active') return 'green';
                if (st === 'pending') return 'yellow';
                return 'caption';
            },
            text: (el, s)=>s.status || 'active'
        }
    },
    Provider: {
        tag: 'span',
        color: 'caption',
        fontSize: 'Y2',
        textAlign: 'center',
        text: (el, s)=>s.authProvider || ''
    },
    Role: {
        tag: 'span',
        color: 'caption',
        fontSize: 'Z2',
        textAlign: 'right',
        text: (el, s)=>s.globalRole || 'user'
    }
};
const $65981f4068c7b12e$export$63722944cb99b463 = {
    tag: 'button',
    type: 'button',
    Label: {
        tag: 'span',
        text: (el, s)=>s.label || ''
    },
    flow: 'x',
    align: 'center left',
    width: '100%',
    textAlign: 'left',
    padding: 'Z A',
    round: 'Z',
    fontSize: 'A',
    borderWidth: '0',
    cursor: 'pointer',
    onClick: (e, el, s)=>{
        e.preventDefault();
        s.root.update({
            dataQuery: ''
        });
        let root = el;
        while(root && !root.routes)root = root.parent;
        if (root) el.router(s.href, root);
    },
    background: (el, s)=>{
        const path = s.root?.currentPath || '/data/projects';
        return path === s.href || s.key === 'projects' && path === '/data' ? 'overlay' : 'transparent';
    },
    color: (el, s)=>{
        const path = s.root?.currentPath || '/data/projects';
        return path === s.href || s.key === 'projects' && path === '/data' ? 'title' : 'subtitle';
    }
};

});

parcelRegister("lSTjH", function(module, exports) {

$parcel$export(module.exports, "login", () => (parcelRequire("2ruDb")).login);
$parcel$export(module.exports, "signin", () => (parcelRequire("bRgwR")).signin);
$parcel$export(module.exports, "signup", () => (parcelRequire("4ciii")).signup);
$parcel$export(module.exports, "signupConfirmation", () => (parcelRequire("15Vhj")).signupConfirmation);
$parcel$export(module.exports, "resetPassword", () => (parcelRequire("hn0tZ")).resetPassword);
$parcel$export(module.exports, "profile", () => (parcelRequire("la1ZO")).profile);
$parcel$export(module.exports, "admin", () => (parcelRequire("5nhB0")).admin);
$parcel$export(module.exports, "adminTeams", () => (parcelRequire("64fWd")).adminTeams);
$parcel$export(module.exports, "adminPermissions", () => (parcelRequire("20yT1")).adminPermissions);
$parcel$export(module.exports, "adminActivityScoring", () => (parcelRequire("g7qnn")).adminActivityScoring);
$parcel$export(module.exports, "adminDanger", () => (parcelRequire("7U7d8")).adminDanger);
$parcel$export(module.exports, "adminLogs", () => (parcelRequire("9aGUO")).adminLogs);
$parcel$export(module.exports, "adminIntegrations", () => (parcelRequire("5yqCy")).adminIntegrations);
$parcel$export(module.exports, "adminIntegrationsSupabase", () => (parcelRequire("1NvTc")).adminIntegrationsSupabase);
$parcel$export(module.exports, "adminIntegrationsGithub", () => (parcelRequire("kHSc9")).adminIntegrationsGithub);
$parcel$export(module.exports, "adminIntegrationsGoogle", () => (parcelRequire("f9P05")).adminIntegrationsGoogle);
$parcel$export(module.exports, "adminIntegrationsNpm", () => (parcelRequire("aNbvv")).adminIntegrationsNpm);
$parcel$export(module.exports, "adminIntegrationsGeneric", () => (parcelRequire("fTOLm")).adminIntegrationsGeneric);
$parcel$export(module.exports, "adminIntegrationsMcp", () => (parcelRequire("8SCVM")).adminIntegrationsMcp);
$parcel$export(module.exports, "adminStatus", () => (parcelRequire("9wOaP")).adminStatus);
$parcel$export(module.exports, "capTable", () => (parcelRequire("dLzC2")).capTable);
// Identity pages — shared across workspace-project and future runner shell.
// Consumed via sharedLibraries mechanism; each app's pages/index.js imports
// from here rather than maintaining its own copy.

var $2ruDb = parcelRequire("2ruDb");

var $bRgwR = parcelRequire("bRgwR");

var $4ciii = parcelRequire("4ciii");

var $15Vhj = parcelRequire("15Vhj");

var $hn0tZ = parcelRequire("hn0tZ");

var $la1ZO = parcelRequire("la1ZO");

var $5nhB0 = parcelRequire("5nhB0");

var $64fWd = parcelRequire("64fWd");

var $20yT1 = parcelRequire("20yT1");

var $g7qnn = parcelRequire("g7qnn");

var $7U7d8 = parcelRequire("7U7d8");

var $9aGUO = parcelRequire("9aGUO");

var $5yqCy = parcelRequire("5yqCy");

var $1NvTc = parcelRequire("1NvTc");

var $kHSc9 = parcelRequire("kHSc9");

var $f9P05 = parcelRequire("f9P05");

var $aNbvv = parcelRequire("aNbvv");

var $fTOLm = parcelRequire("fTOLm");

var $8SCVM = parcelRequire("8SCVM");

var $9wOaP = parcelRequire("9wOaP");

var $dLzC2 = parcelRequire("dLzC2");
const $fee98ce5498df590$export$745f4dfb133ff3f8 = {
    '/login': (0, $2ruDb.login),
    '/signin': (0, $bRgwR.signin),
    '/signup': (0, $4ciii.signup),
    '/signup-confirmation': (0, $15Vhj.signupConfirmation),
    '/reset-password': (0, $hn0tZ.resetPassword),
    '/profile': (0, $la1ZO.profile),
    '/admin': (0, $5nhB0.admin),
    '/admin/teams': (0, $64fWd.adminTeams),
    '/admin/permissions': (0, $20yT1.adminPermissions),
    '/admin/activity-scoring': (0, $g7qnn.adminActivityScoring),
    '/admin/danger': (0, $7U7d8.adminDanger),
    '/admin/logs': (0, $9aGUO.adminLogs),
    '/admin/integrations': (0, $5yqCy.adminIntegrations),
    '/admin/integrations/supabase': (0, $1NvTc.adminIntegrationsSupabase),
    '/admin/integrations/github': (0, $kHSc9.adminIntegrationsGithub),
    '/admin/integrations/google': (0, $f9P05.adminIntegrationsGoogle),
    '/admin/integrations/npm': (0, $aNbvv.adminIntegrationsNpm),
    '/admin/cap-table': (0, $dLzC2.capTable),
    '/admin/status': (0, $9wOaP.adminStatus)
};

});
parcelRegister("2ruDb", function(module, exports) {

$parcel$export(module.exports, "login", () => $1c75dd130f737396$export$596d806903d1f59e);
// Real Supabase Auth — email + password. No magic link, no OTP, no
// sign-up. Admins provision accounts through the Supabase dashboard.
// The sign-in form itself lives in shared-gov as `AppLoginCard`.
const $1c75dd130f737396$export$596d806903d1f59e = {
    extends: 'Page',
    metadata: {
        title: 'Sign in / Symbols Workspace'
    },
    flow: 'y',
    align: 'center center',
    padding: 'D C',
    width: '100%',
    minHeight: '100dvh',
    maxWidth: 'none',
    LoginCard: {
        extends: 'AppLoginCard',
        eyebrow: 'Sign in',
        title: 'Welcome back',
        sub: 'Sign in to your workspace with your email and password.',
        redirectTo: '/'
    }
};

});

parcelRegister("bRgwR", function(module, exports) {

$parcel$export(module.exports, "signin", () => $8a217743561cb1e4$export$54f63e0bb65a6adc);

var $8RlGv = parcelRequire("8RlGv");

var $8x1wG = parcelRequire("8x1wG");
// Editor runs on SDK auth for its core surfaces. Governance + financials
// are both optional extensions that activate only when the user opens
// something that needs them (chat embed, grants page) OR when their
// claims match the extension's shouldActivate predicate (admin role,
// team-org membership). Default editor user — personal org, no team
// membership — triggers zero bridge calls at login.
(0, $8RlGv.configure)({
    required: [],
    optional: [
        'governance',
        'financials'
    ]
});
// Fan out to the Supabase federation after the Symbols SDK login
// succeeds. Governance (+ any enabled extensions) hydrate their own
// sessions so the editor can embed chat/meet/tickets UIs without a
// second auth step. Non-blocking and best-effort — if a bridge is
// unreachable, the editor still proceeds; the federated sessions are
// additive, not required.
const $8a217743561cb1e4$var$_fanOutBridgeLogin = async (email, password)=>{
    try {
        const result = await (0, $8RlGv.loginAll)({
            email: email,
            password: password
        });
        if (!result.ok) console.warn('[editor/signin] bridge login returned error:', result.error?.message);
        else {
            const failed = result.results.filter((r)=>r.status === 'error');
            if (failed.length) for (const r of failed)console.warn(`[editor/signin] bridge ${r.key} failed:`, r.error?.message);
        }
    } catch (err) {
        console.warn('[editor/signin] bridge login threw:', err?.message || err);
    }
};
const $8a217743561cb1e4$export$54f63e0bb65a6adc = {
    extends: 'Page',
    metadata: {
        title: 'Sign in / Symbols'
    },
    flow: 'y',
    align: 'center center',
    padding: 'D C',
    width: '100%',
    minHeight: '100dvh',
    maxWidth: 'none',
    SigninCard: {
        extends: 'AppLoginCard',
        eyebrow: 'Sign in',
        title: 'Welcome',
        sub: 'Use your email or username and password.',
        Form: {
            // Override email placeholder + name so the identifier field accepts
            // username or email (Symbols SDK accepts both).
            Email: {
                placeholder: 'Email or username',
                name: 'identifier',
                autocomplete: 'username'
            },
            // Replace the Supabase-direct submit with SDK login + bridge federation.
            onSubmit: async (ev, el, s)=>{
                ev.preventDefault();
                const root = el.node;
                const identifier = (root.querySelector('input[name="identifier"]')?.value || '').trim().toLowerCase();
                const password = root.querySelector('input[name="password"]')?.value || '';
                const errBox = root.querySelector('[data-lg-err]');
                if (errBox) errBox.textContent = '';
                if (!identifier || !password) {
                    if (errBox) errBox.textContent = 'Email and password are required.';
                    return;
                }
                try {
                    const pluginSession = el.call('getPluginSessionFromUrl');
                    const loginResult = pluginSession ? await el.sdk.login(identifier, password, {
                        session: pluginSession
                    }) : await el.sdk.login(identifier, password);
                    el.call('applyLoader', {
                        value: true,
                        force: true,
                        timeout: 1
                    });
                    const resolvedEmail = loginResult?.user?.email || identifier;
                    // Await federation BEFORE the redirect — otherwise the page
                    // navigates away mid-flight and the governance Supabase JWT
                    // never gets persisted (matches AppLoginCard pattern).
                    await $8a217743561cb1e4$var$_fanOutBridgeLogin(resolvedEmail, password);
                    await el.call('initializeUserSession', {
                        loginData: loginResult
                    });
                    // Cross-origin handoff: when `?redirect=<previewUrl>` is set
                    // AND the target is a trusted preview host, mint a fragment
                    // handoff and replace location instead of routing into the
                    // dashboard. This is what makes `https://<x>.preview.symbols.app/...`
                    // bounce through `my.symbols.app/signin` and come back signed-in.
                    const redirectParam = typeof window !== 'undefined' ? new URL(window.location.href).searchParams.get('redirect') : null;
                    if (redirectParam && (0, $8x1wG.isTrustedHandoffTarget)(redirectParam)) {
                        // SDK login returns `response.data` with `{ tokens: {accessToken,
                        // refreshToken, accessTokenExp: {expiresIn}} }`. Fall back to
                        // `getAuthToken()` if the shape changes — TokenManager has the
                        // freshly-persisted token regardless.
                        const tokens = loginResult?.tokens || loginResult?.data?.tokens || {};
                        const accessToken = tokens.accessToken || tokens.access_token || (typeof el.sdk.getAuthToken === 'function' ? el.sdk.getAuthToken() : null);
                        const refreshToken = tokens.refreshToken || tokens.refresh_token || '';
                        const expiresIn = tokens.accessTokenExp?.expiresIn || tokens.expiresIn || tokens.expires_in || 0;
                        const expiresAt = expiresIn ? Date.now() + expiresIn * 1000 : 0;
                        if (accessToken) {
                            const payload = (0, $8x1wG.encodeHandoffPayload)({
                                accessToken: accessToken,
                                refreshToken: refreshToken,
                                expiresAt: expiresAt,
                                expiresIn: expiresIn
                            });
                            const target = (0, $8x1wG.appendHandoffFragment)(redirectParam, payload);
                            window.location.replace(target);
                            return;
                        }
                    }
                    el.router('/dashboard', el.getRoot());
                } catch (error) {
                    console.error('Failed to sign in:', error);
                    if (errBox) errBox.textContent = error.message || 'Sign-in failed.';
                    el.call('openNotification', {
                        title: 'Failed to sign in',
                        message: error.message,
                        type: 'error'
                    });
                }
                el.call('applyLoader', {
                    value: false,
                    force: true,
                    timeout: 1
                });
            }
        }
    }
};

});
parcelRegister("8x1wG", function(module, exports) {

$parcel$export(module.exports, "isTrustedHandoffTarget", () => $636296da510916c2$export$3a8cb3eef899112f);
$parcel$export(module.exports, "buildLoginRedirectUrl", () => $636296da510916c2$export$539921d6ce495029);
$parcel$export(module.exports, "encodeHandoffPayload", () => $636296da510916c2$export$c7fbfc89b9bdfabd);
$parcel$export(module.exports, "appendHandoffFragment", () => $636296da510916c2$export$febc514a907d611e);
// Cross-origin auth handoff between workspace shell (my.symbols.app) and
// public preview surfaces (*.preview.symbols.app). The two origins do NOT
// share localStorage, so when a logged-in user lands on a preview URL for
// a PRIVATE project we have to:
//
//   1. Redirect the preview to my.symbols.app/signin?redirect=<previewUrl>
//   2. Workspace signs the user in normally (cookies + localStorage on
//      my.symbols.app)
//   3. Workspace mints a one-shot fragment payload and redirects back:
//      <previewUrl>#__symbols_auth=<base64(json{access,refresh,expiresAt})>
//   4. Preview reads the fragment BEFORE the SDK constructs its
//      TokenManager (which hydrates from localStorage in its constructor),
//      writes the tokens into preview-origin localStorage, then scrubs
//      the fragment from history so the credential never persists in
//      browser history or gets bookmarked.
//
// Fragment (not query) is used because (a) fragments aren't sent to
// the server (no access-log leak) and (b) they aren't part of any
// referer header. The payload itself is short-lived — it carries the
// SDK access token (already in the user's localStorage on
// my.symbols.app), not a freshly minted credential.
//
// Redirect targets are restricted to known preview hosts so a malicious
// page can't trick workspace into handing tokens to an attacker origin.

var $6ZWSX = parcelRequire("6ZWSX");
var $636296da510916c2$require$Buffer = $6ZWSX.Buffer;
const $636296da510916c2$export$fd5bdd00be53eb11 = /(^|\.)preview\.(symbols\.app|localhost)$/i;
const $636296da510916c2$export$f3bd101e26a81da = '__symbols_auth';
const $636296da510916c2$export$a1aebccae18ce236 = {
    accessToken: 'symbols_access_token',
    refreshToken: 'symbols_refresh_token',
    expiresAt: 'symbols_expires_at',
    expiresIn: 'symbols_expires_in'
};
const $636296da510916c2$export$3a8cb3eef899112f = (url)=>{
    try {
        const u = new URL(url, typeof window !== 'undefined' ? window.location.href : 'http://localhost');
        if (typeof window !== 'undefined' && u.origin === window.location.origin) return true;
        return $636296da510916c2$export$fd5bdd00be53eb11.test(u.hostname);
    } catch  {
        return false;
    }
};
const $636296da510916c2$export$539921d6ce495029 = (workspaceOrigin, returnTo)=>{
    const url = new URL('/signin', workspaceOrigin);
    url.searchParams.set('redirect', returnTo);
    return url.toString();
};
const $636296da510916c2$export$c7fbfc89b9bdfabd = ({ accessToken: accessToken, refreshToken: refreshToken, expiresAt: expiresAt, expiresIn: expiresIn })=>{
    const payload = {
        a: accessToken,
        r: refreshToken || '',
        x: expiresAt || 0,
        i: expiresIn || 0
    };
    // base64url so URL-safe without further escaping.
    const json = JSON.stringify(payload);
    if (typeof window !== 'undefined' && typeof window.btoa === 'function') return window.btoa(unescape(encodeURIComponent(json))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    return $636296da510916c2$require$Buffer.from(json, 'utf8').toString('base64url');
};
const $636296da510916c2$var$decodeHandoffPayload = (token)=>{
    try {
        const padded = token.replace(/-/g, '+').replace(/_/g, '/');
        const json = typeof window !== 'undefined' ? decodeURIComponent(escape(window.atob(padded))) : $636296da510916c2$require$Buffer.from(padded, 'base64').toString('utf8');
        return JSON.parse(json);
    } catch  {
        return null;
    }
};
const $636296da510916c2$export$febc514a907d611e = (url, encodedPayload)=>{
    const u = new URL(url);
    // Use a key=value fragment shape so the preview can scrub just our key
    // without nuking unrelated SPA state someone might have placed there.
    const existing = u.hash.replace(/^#/, '');
    const parts = existing ? existing.split('&').filter((p)=>!p.startsWith(`${$636296da510916c2$export$f3bd101e26a81da}=`)) : [];
    parts.push(`${$636296da510916c2$export$f3bd101e26a81da}=${encodedPayload}`);
    u.hash = parts.join('&');
    return u.toString();
};
const $636296da510916c2$export$fc47bddd72bfe65a = ()=>{
    if (typeof window === 'undefined') return false;
    const hash = window.location.hash || '';
    if (!hash.includes(`${$636296da510916c2$export$f3bd101e26a81da}=`)) return false;
    const params = new Map(hash.replace(/^#/, '').split('&').filter(Boolean).map((p)=>{
        const idx = p.indexOf('=');
        return idx === -1 ? [
            p,
            ''
        ] : [
            p.slice(0, idx),
            p.slice(idx + 1)
        ];
    }));
    const token = params.get($636296da510916c2$export$f3bd101e26a81da);
    if (!token) return false;
    const decoded = $636296da510916c2$var$decodeHandoffPayload(token);
    if (!decoded?.a) return false;
    try {
        window.localStorage.setItem($636296da510916c2$export$a1aebccae18ce236.accessToken, decoded.a);
        if (decoded.r) window.localStorage.setItem($636296da510916c2$export$a1aebccae18ce236.refreshToken, decoded.r);
        if (decoded.x) window.localStorage.setItem($636296da510916c2$export$a1aebccae18ce236.expiresAt, String(decoded.x));
        if (decoded.i) window.localStorage.setItem($636296da510916c2$export$a1aebccae18ce236.expiresIn, String(decoded.i));
    } catch (err) {
        console.warn('[authHandoff] failed to persist tokens:', err?.message || err);
        return false;
    }
    // Scrub the fragment so the credential doesn't sit in browser history
    // or the address bar. Keep any other fragment keys intact.
    params.delete($636296da510916c2$export$f3bd101e26a81da);
    const remaining = Array.from(params.entries()).map(([k, v])=>v ? `${k}=${v}` : k).join('&');
    const url = new URL(window.location.href);
    url.hash = remaining ? `#${remaining}` : '';
    try {
        window.history.replaceState(null, '', url.toString());
    } catch  {
    // history API unavailable; fragment will linger but tokens are persisted.
    }
    return true;
};

});


parcelRegister("4ciii", function(module, exports) {

$parcel$export(module.exports, "signup", () => $30e6793e7a7f199c$export$7200a869094fec36);
const $30e6793e7a7f199c$export$7200a869094fec36 = {
    extends: 'Page',
    metadata: {
        title: 'Create account / Symbols'
    },
    flow: 'y',
    align: 'center center',
    padding: 'D C',
    width: '100%',
    minHeight: '100dvh',
    maxWidth: 'none',
    onInit: (el, s)=>{
        const searchParams = new URLSearchParams(window.location.search);
        const hasToken = searchParams.has('token');
        if (hasToken) {
            const token = searchParams.get('token');
            const splittedToken = token.split('.');
            if (splittedToken.length > 1) try {
                const decodedToken = JSON.parse(atob(splittedToken[1]));
                s.quietUpdate({
                    email: decodedToken.email,
                    hasToken: hasToken
                });
            } catch (e) {
                console.error('Problem with Signup Token', e);
            }
        }
    },
    SignupCard: {
        flow: 'y',
        gap: 'C',
        padding: 'D',
        width: '100%',
        maxWidth: 'I',
        round: 'C',
        background: 'overlay',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'line',
        boxShadow: '0 24px 60px -24px var(--color-shadow)',
        Head: {
            flow: 'y',
            gap: 'A',
            Eyebrow: {
                tag: 'span',
                fontSize: 'Z2',
                fontWeight: '700',
                letterSpacing: '0.12em',
                textTransform: 'uppercase',
                color: 'blue',
                text: 'Sign up'
            },
            Title: {
                tag: 'h1',
                fontSize: 'D',
                fontWeight: '800',
                color: 'title',
                letterSpacing: '-0.02em',
                text: 'Create account'
            },
            Sub: {
                tag: 'p',
                color: 'caption',
                fontSize: 'A',
                text: 'Join Symbols. Enter your details below.'
            }
        },
        Form: {
            tag: 'form',
            flow: 'y',
            gap: 'A',
            onSubmit: async (ev, el, s)=>{
                ev.preventDefault();
                const root = el.node;
                const email = (root.querySelector('input[name="email"]')?.value || '').trim().toLowerCase();
                const password = root.querySelector('input[name="password"]')?.value || '';
                const name = (root.querySelector('input[name="name"]')?.value || '').trim();
                const errBox = root.querySelector('[data-lg-err]');
                if (errBox) errBox.textContent = '';
                if (!email || !password || !name) {
                    if (errBox) errBox.textContent = 'All fields are required.';
                    return;
                }
                s.update({
                    loading: true
                });
                const currentUrl = new URL(window.location.href);
                const token = currentUrl.searchParams.get('token');
                try {
                    const pluginSession = el.call('getPluginSessionFromUrl');
                    const payload = {
                        email: email,
                        password: password,
                        name: name,
                        callbackUrl: `${window.location.origin}/signup-confirmation`,
                        inviteToken: token
                    };
                    if (pluginSession) await el.sdk.register(payload, {
                        session: pluginSession
                    });
                    else await el.sdk.register(payload);
                } catch (ex) {
                    if (errBox) errBox.textContent = ex?.message || String(ex);
                    el.call('openNotification', {
                        title: 'Error message',
                        message: `${ex}`,
                        type: 'error'
                    });
                    s.update({
                        loading: false
                    });
                    el.call('applyLoader', {
                        value: false,
                        force: true,
                        timeout: 1
                    });
                    return;
                }
                s.update({
                    loading: false
                });
                if (el.isAuthorised?.()) await el.call('fetchUser');
                el.call('applyLoader', {
                    value: false,
                    force: true,
                    timeout: 1
                });
                if (window.plausible) window.plausible('Signup');
                el.call('openNotification', {
                    title: 'Success',
                    message: 'You will receive an email confirmation link on the email address you signed up with.',
                    type: 'success'
                });
                setTimeout(()=>el.router('/dashboard', el.getRoot()), 350);
            },
            Name: {
                tag: 'input',
                width: '100%',
                padding: 'A B',
                round: 'C',
                background: 'overlayStrong',
                border: 'none',
                outline: 'none',
                color: 'title',
                fontSize: 'A',
                boxSizing: 'border-box',
                type: 'text',
                name: 'name',
                placeholder: 'Full name',
                required: 'true',
                autocomplete: 'name'
            },
            Email: {
                tag: 'input',
                width: '100%',
                padding: 'A B',
                round: 'C',
                background: 'overlayStrong',
                border: 'none',
                outline: 'none',
                color: 'title',
                fontSize: 'A',
                boxSizing: 'border-box',
                type: 'email',
                name: 'email',
                placeholder: 'name@symbols.app',
                required: 'true',
                autocomplete: 'email'
            },
            Password: {
                tag: 'input',
                width: '100%',
                padding: 'A B',
                round: 'C',
                background: 'overlayStrong',
                border: 'none',
                outline: 'none',
                color: 'title',
                fontSize: 'A',
                boxSizing: 'border-box',
                type: 'password',
                name: 'password',
                placeholder: 'Password',
                required: 'true',
                autocomplete: 'new-password'
            },
            Error: {
                tag: 'span',
                'data-lg-err': 'true',
                fontSize: 'Z2',
                color: 'red',
                minHeight: 'A'
            },
            Submit: {
                tag: 'button',
                type: 'submit',
                width: '100%',
                padding: 'A B',
                round: 'C',
                background: 'blue',
                color: 'white',
                fontSize: 'A',
                fontWeight: '700',
                border: 'none',
                cursor: 'pointer',
                text: 'Create account'
            }
        },
        Footer: {
            tag: 'span',
            fontSize: 'Z2',
            color: 'caption',
            align: 'center',
            text: 'Already have an account?',
            SigninLink: {
                tag: 'a',
                href: '/signin',
                fontSize: 'Z2',
                color: 'blue',
                marginLeft: 'Y',
                text: 'Sign in'
            }
        }
    }
};

});

parcelRegister("15Vhj", function(module, exports) {

$parcel$export(module.exports, "signupConfirmation", () => $0cc2b0594c0e7cf5$export$9c079914996cc79c);
const $0cc2b0594c0e7cf5$export$9c079914996cc79c = {
    extends: 'Page',
    metadata: {
        title: 'Confirm email / Symbols'
    },
    flow: 'y',
    align: 'center center',
    padding: 'D C',
    width: '100%',
    minHeight: '100dvh',
    maxWidth: 'none',
    state: {
        loading: true,
        success: false,
        error: null
    },
    onInit: async (el, s)=>{
        await el.call('confirmEmail');
    },
    ConfirmCard: {
        flow: 'y',
        gap: 'C',
        padding: 'D',
        width: '100%',
        maxWidth: 'I',
        round: 'C',
        background: 'overlay',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'line',
        boxShadow: '0 24px 60px -24px var(--color-shadow)',
        Head: {
            flow: 'y',
            gap: 'A',
            Eyebrow: {
                tag: 'span',
                fontSize: 'Z2',
                fontWeight: '700',
                letterSpacing: '0.12em',
                textTransform: 'uppercase',
                color: 'blue',
                text: 'Email confirmation'
            },
            Title: {
                tag: 'h1',
                fontSize: 'D',
                fontWeight: '800',
                color: 'title',
                letterSpacing: '-0.02em',
                text: 'Verifying your email'
            }
        },
        Body: {
            flow: 'y',
            gap: 'B',
            align: 'center center',
            LoadingState: {
                if: (el, s)=>s.loading,
                flow: 'y',
                align: 'center center',
                gap: 'B',
                Spinner: {
                    size: 'D'
                },
                Text: {
                    text: 'Confirming your email...',
                    fontSize: 'B',
                    color: 'caption'
                }
            },
            EmailConfirmationSuccess: {
                if: (el, s)=>!s.loading && s.success
            },
            EmailConfirmationError: {
                if: (el, s)=>!s.loading && !s.success
            }
        }
    }
};

});

parcelRegister("hn0tZ", function(module, exports) {

$parcel$export(module.exports, "resetPassword", () => $ca54f581bdd48074$export$dc726c8e334dd814);
const $ca54f581bdd48074$export$dc726c8e334dd814 = {
    extends: 'Page',
    metadata: {
        title: 'Reset password / Symbols'
    },
    flow: 'y',
    align: 'center center',
    padding: 'D C',
    width: '100%',
    minHeight: '100dvh',
    maxWidth: 'none',
    onInit: (el, s)=>{
        const url = new URL(window.location.href);
        s.token = url.searchParams.get('token');
        s.email = url.searchParams.get('email') || '';
    },
    ResetCard: {
        flow: 'y',
        gap: 'C',
        padding: 'D',
        width: '100%',
        maxWidth: 'I',
        round: 'C',
        background: 'overlay',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'line',
        boxShadow: '0 24px 60px -24px var(--color-shadow)',
        Head: {
            flow: 'y',
            gap: 'A',
            Eyebrow: {
                tag: 'span',
                fontSize: 'Z2',
                fontWeight: '700',
                letterSpacing: '0.12em',
                textTransform: 'uppercase',
                color: 'blue',
                text: 'Account'
            },
            Title: {
                tag: 'h1',
                fontSize: 'D',
                fontWeight: '800',
                color: 'title',
                letterSpacing: '-0.02em',
                text: 'Reset password'
            },
            Sub: {
                tag: 'p',
                color: 'caption',
                fontSize: 'A',
                // Changes label based on whether a reset token is present in the URL.
                text: (el, s)=>s.token ? 'Enter your new password below.' : 'Enter your email to receive a reset link.'
            }
        },
        // Request-reset form — shown when no token is present.
        RequestForm: {
            tag: 'form',
            flow: 'y',
            gap: 'A',
            hide: (el, s)=>!!s.token,
            onSubmit: async (ev, el, s)=>{
                ev.preventDefault();
                const root = el.node;
                const email = (root.querySelector('input[name="email"]')?.value || '').trim().toLowerCase();
                const errBox = root.querySelector('[data-lg-err]');
                if (errBox) errBox.textContent = '';
                if (!email) {
                    if (errBox) errBox.textContent = 'Email is required.';
                    s.update({
                        touched: true
                    });
                    return;
                }
                s.update({
                    loading: true
                });
                try {
                    await el.sdk.requestPasswordReset(email);
                    s.update({
                        sent: true,
                        loading: false
                    });
                } catch (e) {
                    s.update({
                        loading: false
                    });
                    if (errBox) errBox.textContent = e?.message || String(e);
                    el.call('openNotification', {
                        title: 'Error message',
                        message: `${e}`,
                        type: 'error'
                    });
                }
            },
            Email: {
                tag: 'input',
                width: '100%',
                padding: 'A B',
                round: 'C',
                background: 'overlayStrong',
                border: 'none',
                outline: 'none',
                color: 'title',
                fontSize: 'A',
                boxSizing: 'border-box',
                type: 'email',
                name: 'email',
                placeholder: 'name@symbols.app',
                required: 'true',
                autocomplete: 'email'
            },
            Error: {
                tag: 'span',
                'data-lg-err': 'true',
                fontSize: 'Z2',
                color: 'red',
                minHeight: 'A'
            },
            Submit: {
                tag: 'button',
                type: 'submit',
                width: '100%',
                padding: 'A B',
                round: 'C',
                background: 'blue',
                color: 'white',
                fontSize: 'A',
                fontWeight: '700',
                border: 'none',
                cursor: 'pointer',
                text: 'Send reset link'
            }
        },
        // Sent confirmation message — shown after successful request-reset.
        SentMessage: {
            flow: 'y',
            gap: 'A',
            hide: (el, s)=>!s.sent,
            Notice: {
                tag: 'p',
                color: 'caption',
                fontSize: 'A',
                text: (el, s)=>`Check your inbox at ${s.email || 'your email'}. Follow the link to set a new password.`
            }
        },
        // New-password form — shown when a token is present in the URL.
        NewPasswordForm: {
            tag: 'form',
            flow: 'y',
            gap: 'A',
            hide: (el, s)=>!s.token,
            onSubmit: async (ev, el, s)=>{
                ev.preventDefault();
                const root = el.node;
                const password = root.querySelector('input[name="password"]')?.value || '';
                const repeatPassword = root.querySelector('input[name="repeatPassword"]')?.value || '';
                const errBox = root.querySelector('[data-lg-err]');
                if (errBox) errBox.textContent = '';
                if (password !== repeatPassword) {
                    if (errBox) errBox.textContent = 'Passwords do not match.';
                    s.update({
                        repeatPasswordTouched: true
                    });
                    el.call('openNotification', {
                        title: 'Failed to change password',
                        message: 'Passwords do not match',
                        type: 'error'
                    });
                    return;
                }
                s.update({
                    loading: true
                });
                try {
                    await el.sdk.confirmPasswordReset(s.token, password);
                    el.call('openNotification', {
                        title: 'Success',
                        message: 'Password has been successfully changed',
                        type: 'success'
                    });
                    setTimeout(()=>el.router('/signin', el.getRoot(), {}), 200);
                } catch (e) {
                    s.update({
                        loading: false
                    });
                    if (errBox) errBox.textContent = e?.message || String(e);
                    el.call('openNotification', {
                        title: 'Error message',
                        message: `${e}`,
                        type: 'error'
                    });
                }
            },
            NewPassword: {
                tag: 'input',
                width: '100%',
                padding: 'A B',
                round: 'C',
                background: 'overlayStrong',
                border: 'none',
                outline: 'none',
                color: 'title',
                fontSize: 'A',
                boxSizing: 'border-box',
                type: 'password',
                name: 'password',
                placeholder: 'New password',
                required: 'true',
                autocomplete: 'new-password'
            },
            RepeatPassword: {
                tag: 'input',
                width: '100%',
                padding: 'A B',
                round: 'C',
                background: 'overlayStrong',
                border: 'none',
                outline: 'none',
                color: 'title',
                fontSize: 'A',
                boxSizing: 'border-box',
                type: 'password',
                name: 'repeatPassword',
                placeholder: 'Repeat new password',
                required: 'true',
                autocomplete: 'new-password'
            },
            Error: {
                tag: 'span',
                'data-lg-err': 'true',
                fontSize: 'Z2',
                color: 'red',
                minHeight: 'A'
            },
            Submit: {
                tag: 'button',
                type: 'submit',
                width: '100%',
                padding: 'A B',
                round: 'C',
                background: 'blue',
                color: 'white',
                fontSize: 'A',
                fontWeight: '700',
                border: 'none',
                cursor: 'pointer',
                text: 'Set new password'
            }
        },
        Footer: {
            tag: 'span',
            fontSize: 'Z2',
            color: 'caption',
            align: 'center',
            text: 'Remember your password?',
            SigninLink: {
                tag: 'a',
                href: '/signin',
                fontSize: 'Z2',
                color: 'blue',
                marginLeft: 'Y',
                text: 'Sign in'
            }
        }
    }
};

});

parcelRegister("la1ZO", function(module, exports) {

$parcel$export(module.exports, "profile", () => $f67c147cc44fa4d4$export$4882ae973e0491e);
const $f67c147cc44fa4d4$export$4882ae973e0491e = {
    extends: 'ContentPage',
    metadata: (el, s)=>{
        const person = el.call('findMe', s);
        const name = person?.name || 'Profile';
        return {
            title: name + ' / People / Symbols Workspace'
        };
    },
    eyebrow: 'Account',
    title: 'Profile',
    sections: (el, s)=>{
        const person = el.call('findMe', s);
        const sections = [
            {
                label: 'Profile'
            },
            {
                label: 'Availability'
            }
        ];
        if (el.call('canAccessPrivate', person)) sections.push({
            label: 'Equity grant'
        }, {
            label: 'Documents'
        }, {
            label: 'Checklist'
        });
        if (el.call('isSelf')) sections.push({
            label: 'Security'
        }, {
            label: 'Notifications'
        }, {
            label: 'Sessions'
        }, {
            label: 'Danger zone'
        });
        return sections;
    },
    PageBody: {
        flow: 'y',
        gap: 'D',
        flex: '1',
        minWidth: '0',
        MemberProfile: {}
    }
};

});

parcelRegister("64fWd", function(module, exports) {

$parcel$export(module.exports, "adminTeams", () => $46af7abf2da7c8ef$export$7ccf2d9e5b41f81a);
// /admin/teams — team-centric permission management. Primary admin
// surface under the team + permissions model.
//
// Reads:
//   root.teams              — all teams across orgs the user belongs to
//                             (loaded by loadAllTeams). Filtered to the
//                             active workspace org in the UI.
//   root.teamsByEmail       — reverse index for per-team member counts
//   root.jwtClaims.workspace_org_id — active org (scoping filter)
//   root.jwtClaims.is_owner / org_role / permissions — gating UI actions
//
// Routes:
//   /admin/teams            → list (grouped by category)
//   /admin/teams?id=<id>    → detail (matrix + members + invite)
//
// Writes (SDK wrappers in functions/teams.js):
//   createTeam, addMemberToTeam, removeMemberFromTeam, updateTeamPermissions
//   inviteToTeam (new) — POST /organizations/:orgId/teams/:teamId/invitations

var $gMSeo = parcelRequire("gMSeo");

var $iikzf = parcelRequire("iikzf");
const $46af7abf2da7c8ef$var$_activeOrgId = (root)=>root?.jwtClaims?.workspace_org_id || null;
const $46af7abf2da7c8ef$var$_teamsInActiveOrg = (root)=>(root?.teams || []).filter((t)=>t.orgId === $46af7abf2da7c8ef$var$_activeOrgId(root));
// Selected team id from URL search. Reads `root.currentSearch` (kept in
// sync by installAppShellSync on popstate/locationchange) so `hide` +
// children factories react when the user clicks a team row.
const $46af7abf2da7c8ef$var$_selectedTeamId = (root)=>{
    const search = root?.currentSearch ?? (typeof window !== 'undefined' ? window.location.search : '');
    try {
        return new URLSearchParams(search).get('id') || null;
    } catch  {
        return null;
    }
};
const $46af7abf2da7c8ef$var$_findSelectedTeam = (root)=>{
    const id = $46af7abf2da7c8ef$var$_selectedTeamId(root);
    return id ? (root?.teams || []).find((t)=>t.id === id) || null : null;
};
// Members of a specific team, derived from teamsByEmail. Returns array
// of { email, role, userId } for use in both count (length) and list
// render — one pass, two consumers.
const $46af7abf2da7c8ef$var$_teamMembers = (teamId, teamsByEmail)=>{
    const rows = [];
    for(const email in teamsByEmail || {}){
        const entry = (teamsByEmail[email] || []).find((t)=>t.id === teamId);
        if (entry) rows.push({
            email: email,
            role: entry.role,
            userId: entry.userId
        });
    }
    return rows;
};
// ── Row in the team list ────────────────────────────────────────────
const $46af7abf2da7c8ef$var$_teamRow = {
    display: 'grid',
    gridTemplateColumns: '2fr auto auto',
    gap: 'Z',
    align: 'center',
    padding: 'Z1 A',
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: 'line',
    cursor: 'pointer',
    ':hover': {
        background: 'overlayStrong'
    },
    Left: {
        flow: 'y',
        gap: 'V',
        minWidth: '0',
        Name: {
            tag: 'span',
            fontSize: 'A',
            fontWeight: '600',
            color: 'title',
            text: (el, s)=>s.name || s.slug
        },
        Meta: {
            tag: 'span',
            fontSize: 'Z2',
            color: 'caption',
            text: (el, s)=>{
                const cat = s.category || 'active';
                const sys = s.isSystem ? " \u2022 system" : '';
                const permCount = (s.permissions || []).length;
                const perms = permCount ? ` \u{2022} ${permCount} perm${permCount === 1 ? '' : 's'}` : '';
                return `${cat}${sys}${perms}`;
            }
        }
    },
    Count: {
        tag: 'span',
        padding: 'V Z',
        round: 'Y',
        fontSize: 'Y1',
        fontWeight: '700',
        color: 'caption',
        background: 'overlayStrong',
        text: (el, s)=>{
            // Members are lazy-loaded on detail view open. Before a team has
            // been opened, teamsByEmail contains no entries for it — show a
            // neutral placeholder rather than misleading "0 members".
            const loaded = s.root?.teamMembersLoaded?.[s.id];
            if (!loaded) return "\u2014 members";
            const n = $46af7abf2da7c8ef$var$_teamMembers(s.id, s.root?.teamsByEmail).length;
            return `${n} ${n === 1 ? 'member' : 'members'}`;
        }
    },
    Chevron: {
        tag: 'span',
        fontSize: 'Z1',
        color: 'caption',
        text: "\u203A"
    },
    onClick: (e, el, s)=>{
        const root = el.call('findRouteRoot', el);
        if (root) {
            s.root.update({
                _teamInviteEmail: '',
                _teamInviteStatus: null
            });
            el.router(`/admin/teams?id=${encodeURIComponent(s.id)}`, root);
        }
    }
};
// ── Permission checkbox row (writable) ──────────────────────────────
const $46af7abf2da7c8ef$var$_permRow = {
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    gap: 'Z',
    padding: 'V Z',
    align: 'start',
    cursor: 'pointer',
    ':hover': {
        background: 'overlay'
    },
    Box: {
        tag: 'input',
        type: 'checkbox',
        marginTop: 'V',
        checked: (el, s)=>{
            const team = $46af7abf2da7c8ef$var$_findSelectedTeam(s.root);
            return !!team && (team.permissions || []).includes(s.key);
        },
        disabled: (el, s)=>!(0, $gMSeo.hasPerm)(s.root?.jwtClaims, 'admin.team_permissions'),
        onChange: async (e, el, s)=>{
            const team = $46af7abf2da7c8ef$var$_findSelectedTeam(s.root);
            if (!team) return;
            const current = new Set(team.permissions || []);
            if (e.target.checked) current.add(s.key);
            else current.delete(s.key);
            try {
                await el.call('updateTeamPermissions', s.root, {
                    orgId: team.orgId,
                    teamId: team.id,
                    permissions: [
                        ...current
                    ]
                });
            } catch (err) {
                console.warn('[admin/teams] permission toggle failed', err);
                e.target.checked = !e.target.checked;
            }
        }
    },
    Detail: {
        flow: 'y',
        gap: 'V',
        Label: {
            tag: 'span',
            fontSize: 'Z2',
            fontWeight: '600',
            color: 'title',
            text: (el, s)=>(0, $gMSeo.permLabel)(s.key)
        },
        Description: {
            tag: 'span',
            fontSize: 'Y1',
            color: 'caption',
            text: (el, s)=>(0, $gMSeo.permDescription)(s.key)
        }
    }
};
// ── Member row (detail pane) ────────────────────────────────────────
const $46af7abf2da7c8ef$var$_memberRow = {
    display: 'grid',
    gridTemplateColumns: '1fr auto auto',
    gap: 'Z',
    align: 'center',
    padding: 'V Z',
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: 'line',
    Info: {
        flow: 'y',
        gap: 'V',
        Email: {
            tag: 'span',
            fontSize: 'Z2',
            fontWeight: '600',
            color: 'title',
            text: (el, s)=>s.email || "\u2014"
        },
        Role: {
            tag: 'span',
            fontSize: 'Y1',
            color: 'caption',
            text: (el, s)=>s.role || 'member'
        }
    },
    Reinvite: {
        tag: 'button',
        text: 'Reinvite',
        title: 'Send a fresh invitation email so the user can activate / sign in',
        padding: 'V Z',
        round: 'Y',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'line',
        background: 'transparent',
        color: 'title',
        cursor: 'pointer',
        fontSize: 'Y1',
        ':hover': {
            background: 'overlay'
        },
        onClick: async (e, el, s)=>{
            const team = $46af7abf2da7c8ef$var$_findSelectedTeam(s.root);
            if (!team || !s.email) return;
            s.root.update({
                _teamInviteStatus: {
                    tone: 'pending',
                    message: `Re-inviting ${s.email}\u{2026}`
                }
            });
            try {
                await el.call('inviteToTeam', s.root, {
                    orgId: team.orgId,
                    teamId: team.id,
                    email: s.email
                });
                s.root.update({
                    _teamInviteStatus: {
                        tone: 'success',
                        message: `Invitation re-sent to ${s.email}.`
                    }
                });
            } catch (err) {
                console.warn('[admin/teams] reinvite failed', err);
                s.root.update({
                    _teamInviteStatus: {
                        tone: 'error',
                        message: `Reinvite failed: ${err?.message || err}`
                    }
                });
            }
        }
    },
    Remove: {
        tag: 'button',
        text: 'Remove',
        padding: 'V Z',
        round: 'Y',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'line',
        background: 'transparent',
        color: 'title',
        cursor: 'pointer',
        fontSize: 'Y1',
        ':hover': {
            background: 'overlay'
        },
        onClick: async (e, el, s)=>{
            const team = $46af7abf2da7c8ef$var$_findSelectedTeam(s.root);
            if (!team) return;
            if (!confirm(`Remove ${s.email} from ${team.name}?`)) return;
            try {
                await el.call('removeMemberFromTeam', s.root, {
                    orgId: team.orgId,
                    teamId: team.id,
                    userId: s.userId,
                    email: s.email
                });
            } catch (err) {
                console.warn('[admin/teams] remove member failed', err);
            }
        }
    }
};

const $46af7abf2da7c8ef$export$7ccf2d9e5b41f81a = {
    extends: 'AppPage',
    metadata: {
        title: 'Teams / Admin / Symbols Workspace'
    },
    onInit: (el, s)=>{
        // Fall back to readGovernanceClaims() so a fresh page load doesn't
        // race subscribeAuthSession and falsely redirect owners.
        const claims = s.root?.jwtClaims || (0, $iikzf.readGovernanceClaims)();
        if ((0, $gMSeo.isOwner)(claims) || claims?.org_role === 'admin') return;
        if (!el.call('shouldRedirectNoPerm', s, 'admin.pages.read')) return;
        const root = el.call('findRouteRoot', el);
        if (root) el.router('/', root, {}, {
            pushState: true
        });
    },
    AdminSidebar: {},
    TeamsMain: {
        extends: 'AppMain',
        padding: '0',
        Header: {
            extends: 'PageHeader',
            LeftGroup: {
                Title: {
                    text: 'Teams & Permissions'
                }
            },
            RightGroup: {
                BackBtn: {
                    tag: 'button',
                    text: "\u2190 All teams",
                    hide: (el, s)=>!$46af7abf2da7c8ef$var$_selectedTeamId(s.root),
                    padding: 'V Z1',
                    round: 'Y',
                    borderWidth: '1px',
                    borderStyle: 'solid',
                    borderColor: 'line',
                    background: 'transparent',
                    color: 'title',
                    cursor: 'pointer',
                    fontSize: 'Z2',
                    ':hover': {
                        background: 'overlay'
                    },
                    onClick: (e, el, s)=>{
                        const root = el.call('findRouteRoot', el);
                        if (root) {
                            s.root.update({
                                _teamInviteEmail: '',
                                _teamInviteStatus: null
                            });
                            el.router('/admin/teams', root);
                        }
                    }
                },
                RefreshBtn: {
                    tag: 'button',
                    text: "\u21BB Refresh perms",
                    padding: 'V Z1',
                    round: 'Y',
                    borderWidth: '1px',
                    borderStyle: 'solid',
                    borderColor: 'line',
                    background: 'transparent',
                    color: 'title',
                    cursor: 'pointer',
                    fontSize: 'Z2',
                    ':hover': {
                        background: 'overlay'
                    },
                    onClick: async (e, el, s)=>{
                        try {
                            const mod = await Promise.resolve((parcelRequire("8RlGv")));
                            await mod.refreshClaims?.();
                            window.location.reload();
                        } catch (err) {
                            console.warn('[admin/teams] refreshClaims failed', err);
                        }
                    }
                }
            }
        },
        Body: {
            overflow: 'auto',
            padding: 'B',
            flow: 'y',
            gap: 'A',
            // ── LIST VIEW ────────────────────────────────────────────────
            ListView: {
                hide: (el, s)=>!!$46af7abf2da7c8ef$var$_selectedTeamId(s.root),
                flow: 'y',
                gap: 'A',
                CreateTeamBar: {
                    display: 'grid',
                    gridTemplateColumns: '1fr auto',
                    gap: 'Z1',
                    align: 'center',
                    padding: 'Z1 A',
                    round: 'Z',
                    background: 'overlay',
                    borderWidth: '1px',
                    borderStyle: 'solid',
                    borderColor: 'line',
                    Hint: {
                        tag: 'span',
                        fontSize: 'Z2',
                        color: 'caption',
                        text: 'Create a new team for this org. System teams are seeded automatically.'
                    },
                    CreateBtn: {
                        tag: 'button',
                        text: '+ Create team',
                        padding: 'V Z1',
                        round: 'Y',
                        borderWidth: '1px',
                        borderStyle: 'solid',
                        borderColor: 'line',
                        background: 'brand',
                        color: 'onBrand',
                        cursor: 'pointer',
                        fontSize: 'Z2',
                        onClick: async (e, el, s)=>{
                            const orgId = $46af7abf2da7c8ef$var$_activeOrgId(s.root);
                            if (!orgId) return;
                            const name = prompt('Team name');
                            if (!name) return;
                            try {
                                await el.call('createTeam', s.root, {
                                    orgId: orgId,
                                    name: name
                                });
                            } catch (err) {
                                console.warn('[admin/teams] createTeam failed', err);
                            }
                        }
                    }
                },
                ActiveSection: {
                    flow: 'y',
                    gap: 'Z1',
                    Heading: {
                        tag: 'h2',
                        fontSize: 'A1',
                        fontWeight: '800',
                        color: 'title',
                        margin: '0',
                        text: 'Active teams'
                    },
                    List: {
                        round: 'Z2',
                        background: 'overlay',
                        borderWidth: '1px',
                        borderStyle: 'solid',
                        borderColor: 'line',
                        overflow: 'hidden',
                        childExtends: $46af7abf2da7c8ef$var$_teamRow,
                        childrenAs: 'state',
                        children: (el, s)=>$46af7abf2da7c8ef$var$_teamsInActiveOrg(s.root).filter((t)=>(t.category || 'active') === 'active')
                    },
                    Empty: {
                        tag: 'span',
                        hide: (el, s)=>$46af7abf2da7c8ef$var$_teamsInActiveOrg(s.root).filter((t)=>(t.category || 'active') === 'active').length > 0,
                        padding: 'Z1 A',
                        fontSize: 'Z2',
                        color: 'caption',
                        text: 'No active teams yet.'
                    }
                },
                ExternalSection: {
                    flow: 'y',
                    gap: 'Z1',
                    Heading: {
                        tag: 'h2',
                        fontSize: 'A1',
                        fontWeight: '800',
                        color: 'title',
                        margin: '0',
                        text: 'External'
                    },
                    List: {
                        round: 'Z2',
                        background: 'overlay',
                        borderWidth: '1px',
                        borderStyle: 'solid',
                        borderColor: 'line',
                        overflow: 'hidden',
                        childExtends: $46af7abf2da7c8ef$var$_teamRow,
                        childrenAs: 'state',
                        children: (el, s)=>$46af7abf2da7c8ef$var$_teamsInActiveOrg(s.root).filter((t)=>t.category === 'external')
                    },
                    Empty: {
                        tag: 'span',
                        hide: (el, s)=>$46af7abf2da7c8ef$var$_teamsInActiveOrg(s.root).filter((t)=>t.category === 'external').length > 0,
                        padding: 'Z1 A',
                        fontSize: 'Z2',
                        color: 'caption',
                        text: 'No external teams yet.'
                    }
                }
            },
            // ── DETAIL VIEW ──────────────────────────────────────────────
            DetailView: {
                hide: (el, s)=>!$46af7abf2da7c8ef$var$_selectedTeamId(s.root),
                flow: 'y',
                gap: 'A',
                TeamHeader: {
                    flow: 'y',
                    gap: 'V',
                    Name: {
                        tag: 'h2',
                        fontSize: 'B1',
                        fontWeight: '800',
                        color: 'title',
                        margin: '0',
                        text: (el, s)=>$46af7abf2da7c8ef$var$_findSelectedTeam(s.root)?.name || 'Team'
                    },
                    Meta: {
                        tag: 'span',
                        fontSize: 'Z2',
                        color: 'caption',
                        text: (el, s)=>{
                            const t = $46af7abf2da7c8ef$var$_findSelectedTeam(s.root);
                            if (!t) return '';
                            return `${t.category || 'active'}${t.isSystem ? " \u2022 system" : ''} \u{2022} slug: ${t.slug}`;
                        }
                    }
                },
                // Permissions matrix
                PermsCard: {
                    flow: 'y',
                    gap: 'Z1',
                    padding: 'A',
                    round: 'Z2',
                    background: 'overlay',
                    borderWidth: '1px',
                    borderStyle: 'solid',
                    borderColor: 'line',
                    Header: {
                        tag: 'h3',
                        fontSize: 'A1',
                        fontWeight: '700',
                        color: 'title',
                        margin: '0 0 V 0',
                        text: 'Permissions'
                    },
                    HintRow: {
                        tag: 'span',
                        fontSize: 'Y1',
                        color: 'caption',
                        margin: '0 0 Z 0',
                        text: (el, s)=>{
                            const claims = s.root?.jwtClaims;
                            if ((0, $gMSeo.isOwner)(claims)) return 'Owners bypass all permission checks. Toggles below affect non-owner members only.';
                            if ((0, $gMSeo.hasPerm)(claims, 'admin.team_permissions')) return 'Changes save on toggle.';
                            return "Read-only \u2014 requires admin.team_permissions.";
                        }
                    },
                    Groups: {
                        flow: 'y',
                        gap: 'Z1',
                        childrenAs: 'state',
                        childExtends: {
                            flow: 'y',
                            gap: 'V',
                            GroupHeading: {
                                tag: 'h4',
                                fontSize: 'Z2',
                                fontWeight: '700',
                                color: 'caption',
                                margin: 'Z 0 V 0',
                                text: (el, s)=>s.group
                            },
                            Rows: {
                                flow: 'y',
                                gap: 'V',
                                childExtends: $46af7abf2da7c8ef$var$_permRow,
                                childrenAs: 'state',
                                children: (el, s)=>(0, $gMSeo.PERMISSIONS_BY_GROUP)[s.group].map((key)=>({
                                            key: key
                                        }))
                            }
                        },
                        children: ()=>(0, $gMSeo.PERMISSION_GROUPS).map((group)=>({
                                    group: group
                                }))
                    }
                },
                // Members
                MembersCard: {
                    flow: 'y',
                    gap: 'Z1',
                    padding: 'A',
                    round: 'Z2',
                    background: 'overlay',
                    borderWidth: '1px',
                    borderStyle: 'solid',
                    borderColor: 'line',
                    // Kick off lazy member fetch when the card renders. The
                    // teamMembersLoaded guard in loadTeamMembers makes this
                    // idempotent — repeated renders won't re-fetch.
                    onInit: async (el, s)=>{
                        const team = $46af7abf2da7c8ef$var$_findSelectedTeam(s.root);
                        if (team) await el.call('loadTeamMembers', s.root, team);
                    },
                    Header: {
                        flow: 'y',
                        gap: 'Z1',
                        TopRow: {
                            display: 'grid',
                            gridTemplateColumns: '1fr auto',
                            gap: 'Z',
                            align: 'center',
                            Title: {
                                tag: 'h3',
                                fontSize: 'A1',
                                fontWeight: '700',
                                color: 'title',
                                margin: '0',
                                text: 'Members'
                            }
                        },
                        InviteForm: {
                            tag: 'form',
                            display: 'grid',
                            gridTemplateColumns: '1fr auto',
                            gap: 'Z',
                            onSubmit: async (e, el, s)=>{
                                e.preventDefault();
                                const team = $46af7abf2da7c8ef$var$_findSelectedTeam(s.root);
                                const email = (s.root?._teamInviteEmail || '').trim();
                                if (!team || !email) return;
                                s.root.update({
                                    _teamInviteStatus: {
                                        tone: 'pending',
                                        message: `Inviting ${email}\u{2026}`
                                    }
                                });
                                try {
                                    await el.call('inviteToTeam', s.root, {
                                        orgId: team.orgId,
                                        teamId: team.id,
                                        email: email
                                    });
                                    s.root.update({
                                        _teamInviteEmail: '',
                                        _teamInviteStatus: {
                                            tone: 'success',
                                            message: `Invitation sent to ${email}.`
                                        }
                                    });
                                } catch (err) {
                                    console.warn('[admin/teams] inviteToTeam failed', err);
                                    s.root.update({
                                        _teamInviteStatus: {
                                            tone: 'error',
                                            message: `Invite failed: ${err?.message || err}`
                                        }
                                    });
                                }
                            },
                            EmailInput: {
                                tag: 'input',
                                type: 'email',
                                name: 'email',
                                required: true,
                                placeholder: 'email@domain.com',
                                padding: 'V Z1',
                                round: 'Y',
                                borderWidth: '1px',
                                borderStyle: 'solid',
                                borderColor: 'line',
                                background: 'transparent',
                                color: 'title',
                                fontSize: 'Z2',
                                value: (el, s)=>s.root?._teamInviteEmail || '',
                                onInput: (e, el, s)=>{
                                    s.root.update({
                                        _teamInviteEmail: e.target.value
                                    });
                                }
                            },
                            SubmitBtn: {
                                tag: 'button',
                                type: 'submit',
                                text: 'Send invite',
                                padding: 'V Z1',
                                round: 'Y',
                                borderWidth: '1px',
                                borderStyle: 'solid',
                                borderColor: 'line',
                                background: 'brand',
                                color: 'onBrand',
                                cursor: 'pointer',
                                fontSize: 'Z2'
                            }
                        },
                        Status: {
                            tag: 'p',
                            margin: '0',
                            fontSize: 'Y1',
                            hide: (el, s)=>!s.root?._teamInviteStatus?.message,
                            color: (el, s)=>{
                                const tone = s.root?._teamInviteStatus?.tone;
                                if (tone === 'error') return 'red';
                                if (tone === 'success') return 'green';
                                return 'caption';
                            },
                            text: (el, s)=>s.root?._teamInviteStatus?.message || ''
                        }
                    },
                    // Loading indicator — visible while member fetch is in flight
                    // (team selected but not yet in teamMembersLoaded).
                    LoadingHint: {
                        tag: 'span',
                        fontSize: 'Z2',
                        color: 'caption',
                        padding: 'Z1 0',
                        hide: (el, s)=>{
                            const team = $46af7abf2da7c8ef$var$_findSelectedTeam(s.root);
                            // Trigger lazy fetch whenever team changes and isn't loaded.
                            // Running el.call here is a reactive side-effect — fires each
                            // time this factory re-evaluates with a new unloaded team.
                            if (team && !s.root?.teamMembersLoaded?.[team.id]) el.call('loadTeamMembers', s.root, team);
                            return !team || !!s.root?.teamMembersLoaded?.[team.id];
                        },
                        text: "Loading members\u2026"
                    },
                    List: {
                        flow: 'y',
                        childExtends: $46af7abf2da7c8ef$var$_memberRow,
                        childrenAs: 'state',
                        children: (el, s)=>{
                            const team = $46af7abf2da7c8ef$var$_findSelectedTeam(s.root);
                            if (!team || !s.root?.teamMembersLoaded?.[team.id]) return [];
                            return $46af7abf2da7c8ef$var$_teamMembers(team.id, s.root?.teamsByEmail);
                        }
                    },
                    Empty: {
                        tag: 'span',
                        hide: (el, s)=>{
                            const team = $46af7abf2da7c8ef$var$_findSelectedTeam(s.root);
                            if (!team || !s.root?.teamMembersLoaded?.[team.id]) return true;
                            return $46af7abf2da7c8ef$var$_teamMembers(team.id, s.root?.teamsByEmail).length > 0;
                        },
                        padding: 'Z1 0',
                        fontSize: 'Z2',
                        color: 'caption',
                        text: 'No members yet. Click + Invite to add someone.'
                    }
                }
            }
        }
    }
};

});

parcelRegister("20yT1", function(module, exports) {

$parcel$export(module.exports, "adminPermissions", () => $1766a49572926931$export$b1c204fae4cc4fe9);
// /admin/permissions — parallel tables for the two-layer permission model.
//
// Left panel  — Mongo team grants
//   Source:  root.teams  (loaded by loadAllTeams on session start)
//   Shows:   Every team in the active org with its assigned permission keys,
//            grouped by permission group. Read-only cross-reference — to
//            edit, click "Open in Teams" to navigate to /admin/teams?id=<id>.
//
// Right panel — Supabase governance roles
//   Source:  public.role_permissions  (legacy resource×action ACL table)
//   Shows:   role × resource matrix; each cell lists the allowed actions
//            (green badge) or blocked actions (red badge). Superadmin row is
//            highlighted. Table is currently read-only — write support is a
//            follow-up (§I10b).
//
// Access gate: admin.pages.read  (same as all other /admin/* pages).
// Scale-tier gate is intentionally NOT applied here — the scaffold needs to
// be visible during development so QA can verify layout. Gate will be
// re-added in the hardening ticket once the table is writable.
//
// §I10 — scaffold task

var $bfqVY = parcelRequire("bfqVY");

var $iikzf = parcelRequire("iikzf");

var $gMSeo = parcelRequire("gMSeo");
// ── Helpers ─────────────────────────────────────────────────────────
const $1766a49572926931$var$_activeOrgId = (root)=>root?.jwtClaims?.workspace_org_id || null;
const $1766a49572926931$var$_teamsInActiveOrg = (root)=>(root?.teams || []).filter((t)=>t.orgId === $1766a49572926931$var$_activeOrgId(root));
// Group the role_permissions rows into a matrix keyed by [role][resource].
// Returns { [role]: { [resource]: { allowed: string[], blocked: string[] } } }
const $1766a49572926931$var$_buildMatrix = (rows)=>{
    const m = {};
    for (const r of rows || []){
        if (!m[r.role]) m[r.role] = {};
        if (!m[r.role][r.resource]) m[r.role][r.resource] = {
            allowed: [],
            blocked: []
        };
        if (r.allowed) m[r.role][r.resource].allowed.push(r.action);
        else m[r.role][r.resource].blocked.push(r.action);
    }
    return m;
};
// Distinct roles + resources in display order.
const $1766a49572926931$var$_ROLE_ORDER = [
    'superadmin',
    'admin',
    'manager',
    'member',
    'advisor',
    'investor'
];
const $1766a49572926931$var$_RESOURCE_ORDER = [
    'People',
    'Tickets',
    'Chat',
    'Documents',
    'Announcements',
    'Calendar'
];
// ── Mongo team grant panel ───────────────────────────────────────────
const $1766a49572926931$var$_teamGrantRow = {
    display: 'grid',
    gridTemplateColumns: '1fr 2fr auto',
    gap: 'Z',
    align: 'start',
    padding: 'Z1 A',
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: 'line',
    ':hover': {
        background: 'overlayStrong'
    },
    TeamName: {
        flow: 'y',
        gap: 'V',
        Name: {
            tag: 'span',
            fontSize: 'Z2',
            fontWeight: '600',
            color: 'title',
            text: (el, s)=>s.name || s.slug || "\u2014"
        },
        Meta: {
            tag: 'span',
            fontSize: 'Y1',
            color: 'caption',
            text: (el, s)=>{
                const cat = s.category || 'active';
                const sys = s.isSystem ? " \xb7 system" : '';
                return `${cat}${sys}`;
            }
        }
    },
    Perms: {
        flow: 'x wrap',
        gap: 'V',
        children: (el, s)=>{
            const keys = s.permissions || [];
            if (!keys.length) return [
                {
                    tag: 'span',
                    fontSize: 'Y1',
                    color: 'caption',
                    fontStyle: 'italic',
                    text: 'no permissions'
                }
            ];
            return keys.map((k)=>({
                    tag: 'span',
                    padding: 'Y Z',
                    round: 'Y',
                    fontSize: 'Y1',
                    fontWeight: '600',
                    color: 'title',
                    background: 'overlayStrong',
                    title: k,
                    text: (0, $gMSeo.permLabel)(k)
                }));
        }
    },
    EditBtn: {
        tag: 'button',
        text: "\u2192 Teams",
        title: 'Open in Teams & Permissions editor',
        padding: 'V Z1',
        round: 'Y',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'line',
        background: 'transparent',
        color: 'caption',
        cursor: 'pointer',
        fontSize: 'Y1',
        ':hover': {
            background: 'overlay',
            color: 'title'
        },
        onClick: (e, el, s)=>{
            const root = el.call('findRouteRoot', el);
            if (root) el.router(`/admin/teams?id=${encodeURIComponent(s.id)}`, root);
        }
    }
};
const $1766a49572926931$var$_mongoPanel = {
    flex: '1',
    minWidth: '0',
    flow: 'y',
    gap: 'Z1',
    PanelTitle: {
        tag: 'h2',
        fontSize: 'A1',
        fontWeight: '800',
        color: 'title',
        margin: '0',
        text: 'Mongo team grants'
    },
    PanelHint: {
        tag: 'p',
        fontSize: 'Y2',
        color: 'caption',
        margin: '0',
        lineHeight: '1.5',
        text: "Permission keys assigned to each team in the active org. Effective access = team perms \u222A org-role perms \u222A owner bypass."
    },
    Card: {
        round: 'Z2',
        background: 'overlay',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'line',
        overflow: 'hidden',
        flow: 'y',
        HeaderRow: {
            display: 'grid',
            gridTemplateColumns: '1fr 2fr auto',
            gap: 'Z',
            padding: 'Z A',
            borderBottomWidth: '2px',
            borderBottomStyle: 'solid',
            borderBottomColor: 'line',
            childProps: {
                fontSize: 'Y1',
                fontWeight: '700',
                letterSpacing: '.04em',
                textTransform: 'uppercase',
                color: 'caption'
            },
            H01: {
                text: 'Team'
            },
            H02: {
                text: 'Permissions'
            },
            H03: {
                text: ''
            }
        },
        ActiveSection: {
            flow: 'y',
            SectionLabel: {
                padding: 'V A',
                fontSize: 'Y1',
                fontWeight: '700',
                letterSpacing: '.04em',
                textTransform: 'uppercase',
                color: 'caption',
                background: 'overlayStrong',
                borderBottomWidth: '1px',
                borderBottomStyle: 'solid',
                borderBottomColor: 'line',
                text: 'Active'
            },
            Rows: {
                flow: 'y',
                childExtends: $1766a49572926931$var$_teamGrantRow,
                childrenAs: 'state',
                children: (el, s)=>$1766a49572926931$var$_teamsInActiveOrg(s.root).filter((t)=>(t.category || 'active') === 'active')
            },
            Empty: {
                tag: 'span',
                hide: (el, s)=>$1766a49572926931$var$_teamsInActiveOrg(s.root).filter((t)=>(t.category || 'active') === 'active').length > 0,
                padding: 'Z A',
                fontSize: 'Z2',
                color: 'caption',
                text: 'No active teams yet.'
            }
        },
        ExternalSection: {
            flow: 'y',
            SectionLabel: {
                padding: 'V A',
                fontSize: 'Y1',
                fontWeight: '700',
                letterSpacing: '.04em',
                textTransform: 'uppercase',
                color: 'caption',
                background: 'overlayStrong',
                borderBottomWidth: '1px',
                borderBottomStyle: 'solid',
                borderBottomColor: 'line',
                borderTopWidth: '1px',
                borderTopStyle: 'solid',
                borderTopColor: 'line',
                text: 'External'
            },
            Rows: {
                flow: 'y',
                childExtends: $1766a49572926931$var$_teamGrantRow,
                childrenAs: 'state',
                children: (el, s)=>$1766a49572926931$var$_teamsInActiveOrg(s.root).filter((t)=>t.category === 'external')
            },
            Empty: {
                tag: 'span',
                hide: (el, s)=>$1766a49572926931$var$_teamsInActiveOrg(s.root).filter((t)=>t.category === 'external').length > 0,
                padding: 'Z A',
                fontSize: 'Z2',
                color: 'caption',
                text: 'No external teams.'
            }
        }
    }
};
// ── Supabase governance roles panel ─────────────────────────────────
// Cell showing allowed / blocked actions for a role×resource pair.
const $1766a49572926931$var$_matrixCell = (role, resource)=>({
        padding: 'V Z',
        flow: 'x wrap',
        gap: 'V',
        borderRightWidth: '1px',
        borderRightStyle: 'solid',
        borderRightColor: 'line',
        children: (el, s)=>{
            const matrix = s.root?._permMatrix || {};
            const cell = (matrix[role] || {})[resource] || {
                allowed: [],
                blocked: []
            };
            const children = [];
            for (const a of cell.allowed)children.push({
                tag: 'span',
                padding: 'Y Z',
                round: 'Y',
                fontSize: 'Y1',
                fontWeight: '600',
                color: 'white',
                background: 'green',
                text: a
            });
            for (const a of cell.blocked)children.push({
                tag: 'span',
                padding: 'Y Z',
                round: 'Y',
                fontSize: 'Y1',
                fontWeight: '600',
                color: 'white',
                background: 'red',
                text: a
            });
            if (!children.length) children.push({
                tag: 'span',
                fontSize: 'Y1',
                color: 'caption',
                text: "\u2014"
            });
            return children;
        }
    });
// Build the matrix table from the fetched role_permissions rows.
const $1766a49572926931$var$_supabasePanel = {
    flex: '1',
    minWidth: '0',
    flow: 'y',
    gap: 'Z1',
    PanelTitle: {
        tag: 'h2',
        fontSize: 'A1',
        fontWeight: '800',
        color: 'title',
        margin: '0',
        text: 'Supabase governance roles'
    },
    PanelHint: {
        tag: 'p',
        fontSize: 'Y2',
        color: 'caption',
        margin: '0',
        lineHeight: '1.5',
        text: "Legacy resource \xd7 action ACL from public.role_permissions. Green = allowed, Red = denied. Read-only scaffold \u2014 write support in \xa7I10b."
    },
    LoadingHint: {
        tag: 'span',
        hide: (el, s)=>!!s.root?._permMatrixLoaded,
        padding: 'Z A',
        fontSize: 'Z2',
        color: 'caption',
        text: "Loading role permissions\u2026"
    },
    Card: {
        hide: (el, s)=>!s.root?._permMatrixLoaded,
        round: 'Z2',
        background: 'overlay',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'line',
        overflow: 'auto',
        flow: 'y',
        // Header row: role columns
        HeaderRow: {
            display: 'grid',
            gridTemplateColumns: `120px repeat(${$1766a49572926931$var$_ROLE_ORDER.length}, 1fr)`,
            borderBottomWidth: '2px',
            borderBottomStyle: 'solid',
            borderBottomColor: 'line',
            background: 'overlayStrong',
            ResourceHeader: {
                padding: 'V Z1',
                fontSize: 'Y1',
                fontWeight: '700',
                letterSpacing: '.04em',
                textTransform: 'uppercase',
                color: 'caption',
                borderRightWidth: '1px',
                borderRightStyle: 'solid',
                borderRightColor: 'line',
                text: 'Resource'
            },
            RoleHeaders: {
                childrenAs: 'state',
                childExtends: {
                    padding: 'V Z1',
                    fontSize: 'Y1',
                    fontWeight: '700',
                    letterSpacing: '.04em',
                    textTransform: 'uppercase',
                    color: (el, s)=>s.r === 'superadmin' ? 'orange' : 'caption',
                    borderRightWidth: '1px',
                    borderRightStyle: 'solid',
                    borderRightColor: 'line',
                    text: (el, s)=>s.r
                },
                children: ()=>$1766a49572926931$var$_ROLE_ORDER.map((r)=>({
                            r: r
                        }))
            }
        },
        // One row per resource
        Rows: {
            flow: 'y',
            childrenAs: 'state',
            childExtends: {
                display: 'grid',
                gridTemplateColumns: `120px repeat(${$1766a49572926931$var$_ROLE_ORDER.length}, 1fr)`,
                borderBottomWidth: '1px',
                borderBottomStyle: 'solid',
                borderBottomColor: 'line',
                ':hover': {
                    background: 'overlayStrong'
                },
                ResourceLabel: {
                    padding: 'V Z1',
                    fontSize: 'Z2',
                    fontWeight: '600',
                    color: 'title',
                    borderRightWidth: '1px',
                    borderRightStyle: 'solid',
                    borderRightColor: 'line',
                    text: (el, s)=>s.resource
                },
                Cells: {
                    childrenAs: 'state',
                    childExtends: {
                        padding: 'V Z',
                        flow: 'x wrap',
                        gap: 'V',
                        borderRightWidth: '1px',
                        borderRightStyle: 'solid',
                        borderRightColor: 'line',
                        children: (el, s)=>{
                            const matrix = s.root?._permMatrix || {};
                            const cell = (matrix[s.role] || {})[s.resource] || {
                                allowed: [],
                                blocked: []
                            };
                            const items = [];
                            for (const a of cell.allowed)items.push({
                                tag: 'span',
                                padding: 'Y Z',
                                round: 'Y',
                                fontSize: 'Y1',
                                fontWeight: '600',
                                color: 'white',
                                background: 'green',
                                text: a
                            });
                            for (const a of cell.blocked)items.push({
                                tag: 'span',
                                padding: 'Y Z',
                                round: 'Y',
                                fontSize: 'Y1',
                                fontWeight: '600',
                                color: 'white',
                                background: 'red',
                                text: a
                            });
                            if (!items.length) items.push({
                                tag: 'span',
                                fontSize: 'Y1',
                                color: 'caption',
                                text: "\u2014"
                            });
                            return items;
                        }
                    },
                    children: (el, s)=>$1766a49572926931$var$_ROLE_ORDER.map((role)=>({
                                role: role,
                                resource: s.resource
                            }))
                }
            },
            children: ()=>$1766a49572926931$var$_RESOURCE_ORDER.map((resource)=>({
                        resource: resource
                    }))
        }
    }
};
const $1766a49572926931$export$b1c204fae4cc4fe9 = {
    extends: 'AppPage',
    metadata: {
        title: 'Permissions / Admin / Symbols Workspace'
    },
    onInit: async (el, s)=>{
        // Permission gate — same as all /admin/* pages. On fresh page load
        // (URL bar / refresh) `s.root.jwtClaims` is not yet populated by
        // `subscribeAuthSession`, so the gate would falsely redirect even
        // for owners. Fall back to `readGovernanceClaims()` which reads
        // the persisted JWT directly and is synchronously correct.
        const claims = s.root?.jwtClaims || (0, $iikzf.readGovernanceClaims)();
        if (!(0, $gMSeo.isOwner)(claims) && !(0, $gMSeo.hasPerm)(claims, 'admin.pages.read')) {
            const root = el.call('findRouteRoot', el);
            if (root) el.router('/', root, {}, {
                pushState: true
            });
            return;
        }
        // Lazy-load the role_permissions table if not yet fetched this session.
        if (s.root?._permMatrixLoaded) return;
        try {
            // migrated 2026-04-27 to SDK route workspaceProject.rolePermissions/list
            const result = await (0, $bfqVY.getSDK)().execute('workspaceProject.rolePermissions', 'list');
            const data = Array.isArray(result) ? result : result?.data || result?.rows || [];
            s.root.update({
                _permMatrix: $1766a49572926931$var$_buildMatrix(data || []),
                _permMatrixLoaded: true,
                _permMatrixRaw: data || []
            });
        } catch (err) {
            console.warn('[admin/permissions] role_permissions fetch failed', err);
            s.root.update({
                _permMatrix: {},
                _permMatrixLoaded: true,
                _permMatrixRaw: []
            });
        }
    },
    AdminSidebar: {},
    PermissionsMain: {
        extends: 'AppMain',
        padding: '0',
        Header: {
            extends: 'PageHeader',
            LeftGroup: {
                Title: {
                    text: 'Permissions Overview'
                }
            },
            RightGroup: {
                RefreshBtn: {
                    tag: 'button',
                    text: "\u21BB Refresh",
                    padding: 'V Z1',
                    round: 'Y',
                    borderWidth: '1px',
                    borderStyle: 'solid',
                    borderColor: 'line',
                    background: 'transparent',
                    color: 'title',
                    cursor: 'pointer',
                    fontSize: 'Z2',
                    ':hover': {
                        background: 'overlay'
                    },
                    onClick: async (e, el, s)=>{
                        s.root.update({
                            _permMatrixLoaded: false,
                            _permMatrix: {},
                            _permMatrixRaw: []
                        });
                        try {
                            // migrated 2026-04-27 to SDK route workspaceProject.rolePermissions/list
                            const result = await (0, $bfqVY.getSDK)().execute('workspaceProject.rolePermissions', 'list');
                            const data = Array.isArray(result) ? result : result?.data || result?.rows || [];
                            s.root.update({
                                _permMatrix: $1766a49572926931$var$_buildMatrix(data || []),
                                _permMatrixLoaded: true,
                                _permMatrixRaw: data || []
                            });
                        } catch (err) {
                            console.warn('[admin/permissions] refresh failed', err);
                            s.root.update({
                                _permMatrix: {},
                                _permMatrixLoaded: true
                            });
                        }
                    }
                }
            }
        },
        Body: {
            overflow: 'auto',
            padding: 'B',
            flow: 'y',
            gap: 'B',
            Intro: {
                tag: 'p',
                margin: '0',
                fontSize: 'Z2',
                color: 'caption',
                lineHeight: '1.6',
                maxWidth: 'M',
                text: "This page shows both layers of the permission system side by side. The Mongo team grants (left) define the fine-grained permission keys effective for each team member. The Supabase governance roles (right) control legacy resource-level access in the governance database. These two systems operate independently \u2014 JWT claims synthesize from Mongo; Supabase RLS reads from role_permissions."
            },
            Tables: {
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: 'B',
                alignItems: 'start',
                MongoPanel: $1766a49572926931$var$_mongoPanel,
                SupabasePanel: $1766a49572926931$var$_supabasePanel
            }
        }
    }
};

});

parcelRegister("7U7d8", function(module, exports) {

$parcel$export(module.exports, "adminDanger", () => $5c135b461a46a2a0$export$65789a11bcc2e7a0);

var $bfqVY = parcelRequire("bfqVY");

var $82gA2 = parcelRequire("82gA2");
const $5c135b461a46a2a0$var$_dangerBtn = (label, color, onConfirm)=>({
        tag: 'button',
        padding: 'Z A',
        round: 'Z',
        borderWidth: '1px',
        borderColor: color,
        borderStyle: 'solid',
        cursor: 'pointer',
        fontSize: 'Z2',
        fontWeight: '600',
        background: (el, s)=>s._confirming ? color : 'transparent',
        color: (el, s)=>s._confirming ? 'white' : color,
        text: (el, s)=>s._busy ? 'Working...' : s._confirming ? 'Confirm?' : s._done || label,
        ':hover': {
            opacity: '.85'
        },
        onClick: async (e, el, s)=>{
            if (s._busy) return;
            if (!s._confirming) {
                el.state.update({
                    _confirming: true
                });
                setTimeout(()=>el.state.update({
                        _confirming: false
                    }), 4000);
                return;
            }
            el.state.update({
                _confirming: false,
                _busy: true
            });
            try {
                await onConfirm(s);
                el.state.update({
                    _busy: false,
                    _done: 'Done'
                });
                setTimeout(()=>el.state.update({
                        _done: null
                    }), 2000);
            } catch (err) {
                console.error(err);
                el.state.update({
                    _busy: false,
                    _done: 'Failed'
                });
                setTimeout(()=>el.state.update({
                        _done: null
                    }), 2000);
            }
        }
    });
const $5c135b461a46a2a0$var$_dangerRow = (label, hint, btnLabel, color, onConfirm)=>({
        flow: 'x',
        align: 'center space-between',
        padding: 'A 0',
        borderBottomWidth: '1px',
        borderBottomStyle: 'solid',
        borderBottomColor: 'line',
        Left: {
            flow: 'y',
            gap: 'Y',
            flex: '1',
            Label: {
                tag: 'span',
                fontSize: 'A',
                fontWeight: '500',
                color: 'title',
                text: label
            },
            Hint: {
                tag: 'span',
                fontSize: 'Y2',
                color: 'caption',
                text: hint
            }
        },
        Btn: $5c135b461a46a2a0$var$_dangerBtn(btnLabel, color, onConfirm)
    });
const $5c135b461a46a2a0$export$65789a11bcc2e7a0 = {
    extends: 'AppPage',
    metadata: {
        title: 'Danger zone / Admin / Symbols Workspace'
    },
    onInit: (el, s)=>{
        if (s.root?.currentUserId && !el.call('isSuperAdmin')) {
            let root = el;
            while(root && !root.routes)root = root.parent;
            if (root) el.router('/admin', root, {}, {
                pushState: true
            });
        }
    },
    AdminSidebar: {},
    DangerMain: {
        extends: 'AppMain',
        padding: '0',
        Header: {
            extends: 'PageHeader',
            LeftGroup: {
                Title: {
                    text: 'Danger Zone'
                }
            }
        },
        Body: {
            overflow: 'auto',
            padding: 'B',
            flow: 'y',
            gap: 'B',
            DangerCard: {
                flow: 'y',
                gap: 'A',
                padding: 'B',
                round: 'Z2',
                background: 'overlay',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: 'red',
                DzTitle: {
                    tag: 'h2',
                    fontSize: 'B1',
                    fontWeight: '800',
                    color: 'red',
                    margin: '0',
                    text: 'Destructive Actions'
                },
                DzHint: {
                    tag: 'p',
                    fontSize: 'Z2',
                    color: 'caption',
                    margin: '0',
                    text: 'These actions are irreversible. Superadmin only.'
                },
                DzActions: {
                    flow: 'y',
                    gap: 'Z',
                    marginTop: 'A',
                    DzExport: $5c135b461a46a2a0$var$_dangerRow('Export all user data', 'Download all users, roles, and equity data as JSON', 'Export JSON', 'title', async (s)=>{
                        // migrated 2026-04-27 to SDK route workspaceProject.people/list
                        const result = await (0, $bfqVY.getSDK)().execute('workspaceProject.people', 'list');
                        const data = Array.isArray(result) ? result : result?.data || result?.people || result?.rows || [];
                        const blob = new Blob([
                            JSON.stringify(data, null, 2)
                        ], {
                            type: 'application/json'
                        });
                        const a = document.createElement('a');
                        a.href = URL.createObjectURL(blob);
                        a.download = `symbols-users-${new Date().toISOString().slice(0, 10)}.json`;
                        a.click();
                        URL.revokeObjectURL(a.href);
                    }),
                    DzDeactivateAll: $5c135b461a46a2a0$var$_dangerRow('Deactivate all non-core members', 'Set status to "left" for everyone without a core role', 'Deactivate', 'red', async (s)=>{
                        // CU-10 §90: roles now in root.roles.byUser (not p.roles)
                        const people = s.root?.people || [];
                        const byUser = s.root?.roles?.byUser || {};
                        const coreRoles = new Set([
                            'superadmin',
                            'admin',
                            'manager',
                            'member'
                        ]);
                        for (const p of people){
                            const legacyRoles = Array.isArray(p.roles) && p.roles.length > 0 ? p.roles : null;
                            const isCore = legacyRoles ? legacyRoles.some((r)=>coreRoles.has(r)) : coreRoles.has(byUser[p.userId] || 'member');
                            if (!isCore && p.status !== 'left') // migrated 2026-04-27 to SDK route workspaceProject.userProfiles/update
                            await (0, $bfqVY.getSDK)().execute('workspaceProject.userProfiles', 'update', {
                                id: p.userId,
                                payload: {
                                    status: 'left'
                                }
                            });
                        }
                    }),
                    // CU-10 §90: DzResetRoles removed — user_roles table is dropped.
                    // Role resets now require going through Mongo OrgMember.role
                    // (server endpoint: PATCH /auth/org/:orgId/member-roles).
                    // This danger action is disabled to prevent silent no-ops.
                    DzPurgeChat: $5c135b461a46a2a0$var$_dangerRow('Purge all chat messages', "Delete every message across all channels \u2014 channel structure is preserved", 'Purge messages', 'red', // TODO[sdk-bulk-delete]: no SDK route for bulk-delete on
                    // chat_messages — the per-id `chat.removeMessage` doesn't fit
                    // the "purge everything" use case. This admin danger-zone
                    // action requires a service-role key; once the workspace
                    // wrapper exposes a /chat/purge admin route guarded by org
                    // owner permissions, replace the raw fetch with
                    // `getSDK().execute('workspaceProject.chat.messages', 'purge', {})`.
                    async ()=>{
                        await fetch(`${(0, $82gA2.RAW_URL)}/rest/v1/chat_messages?id=not.is.null`, {
                            method: 'DELETE',
                            headers: {
                                apikey: (0, $82gA2.SUPABASE_KEY),
                                Authorization: `Bearer ${(0, $82gA2.SUPABASE_KEY)}`,
                                Prefer: 'return=minimal'
                            }
                        });
                    })
                }
            }
        }
    }
};

});

parcelRegister("5yqCy", function(module, exports) {

$parcel$export(module.exports, "adminIntegrations", () => $40b4c71025c7a7c6$export$79f1fcd0ccda7621);
$parcel$export(module.exports, "IntegrationCategoryGroup", () => $40b4c71025c7a7c6$export$c3b8a057805aa327);
$parcel$export(module.exports, "IntegrationCategoryCard", () => $40b4c71025c7a7c6$export$27ff713fca413d8d);
// Admin → Integrations hub. Renders a card grid of integration
// categories (data sources, dev tools, workspace, AI, messaging)
// driven by the `public.integration_kinds` catalogue. Clicking a card
// routes into a per-kind detail page where the admin can configure
// one or many instances (multi-slot kinds allow several, single-slot
// kinds allow only one).
//
// Data flow:
//   - `loadIntegrationCatalogue(orgId)` pulls the `integration_kinds`
//     rows (static catalogue) and `list_org_integrations(orgId)`
//     (configured instances) in one round-trip. Result stored on
//     `root._integrationHub` so detail pages can re-use without a
//     second fetch.
//   - Counts per kind derive from the returned `integrations` array.
//   - The sidebar lives in the shared AdminSidebar; the hub body is a
//     card grid.

var $e92gD = parcelRequire("e92gD");
const $40b4c71025c7a7c6$var$_loadHub = async (root)=>{
    const orgId = root?.jwtClaims?.workspace_org_id;
    if (!orgId) {
        // Claims may not be populated at first mount (auth session resolves
        // async on cold load). Poll until they are, then fire once.
        if (!root._integrationsHubWatcher) root._integrationsHubWatcher = setInterval(()=>{
            const id = root?.jwtClaims?.workspace_org_id;
            if (id) {
                clearInterval(root._integrationsHubWatcher);
                root._integrationsHubWatcher = null;
                $40b4c71025c7a7c6$var$_loadHub(root);
            }
        }, 300);
        return;
    }
    const data = await (0, $e92gD.loadIntegrationCatalogue)(orgId);
    root.update({
        _integrationHub: data
    });
};
// Detail-page slug for each kind (URL path segment after /admin/integrations/).
const $40b4c71025c7a7c6$var$_kindRoute = (kind)=>{
    // Everything maps 1:1 except the legacy google_workspace slug.
    if (kind === 'google_workspace') return 'google';
    if (kind === 'supabase_project') return 'supabase';
    return kind;
};
// Group integration_kinds rows by category for the card grid.
const $40b4c71025c7a7c6$var$_byCategory = (kinds, integrations)=>{
    const byKind = {};
    for (const i of integrations || []){
        if (!byKind[i.kind]) byKind[i.kind] = {
            count: 0,
            hasSecret: 0
        };
        byKind[i.kind].count += 1;
        if (i.has_secret) byKind[i.kind].hasSecret += 1;
    }
    const groups = {};
    for (const k of kinds || []){
        if (!groups[k.category]) groups[k.category] = {
            category: k.category,
            items: []
        };
        groups[k.category].items.push({
            ...k,
            count: byKind[k.kind]?.count || 0,
            configured: (byKind[k.kind]?.count || 0) > 0
        });
    }
    // Stable category order.
    const order = [
        'data',
        'dev',
        'workspace',
        'ai',
        'messaging'
    ];
    return order.filter((c)=>groups[c]).map((c)=>({
            ...groups[c],
            label: $40b4c71025c7a7c6$var$_categoryLabel(c)
        })).concat(Object.values(groups).filter((g)=>!order.includes(g.category)).map((g)=>({
            ...g,
            label: $40b4c71025c7a7c6$var$_categoryLabel(g.category)
        })));
};
const $40b4c71025c7a7c6$var$_categoryLabel = (c)=>({
        data: 'Data sources',
        dev: 'Developer tools',
        workspace: 'Workspace',
        ai: 'AI providers',
        messaging: 'Real-time & messaging',
        analytics: 'Analytics',
        automation: 'Automation',
        custom: 'Custom'
    })[c] || (c ? c.charAt(0).toUpperCase() + c.slice(1) : 'Other');
const $40b4c71025c7a7c6$export$79f1fcd0ccda7621 = {
    extends: 'AppPage',
    metadata: {
        title: 'Integrations / Admin / Symbols Workspace'
    },
    // Integration browsing + install lives on the canvas marketplace app.
    // Redirect there instead of rendering our own hub — the Symbols
    // marketplace is the canonical surface for integration install + catalogue.
    onInit: (el, s)=>{
        if (typeof window === 'undefined') return;
        if (el.call('shouldRedirectNonAdmin', s)) {
            const root = el.call('findRouteRoot', el);
            if (root) el.router('/', root, {}, {
                pushState: true
            });
            return;
        }
        const root = el.call('findRouteRoot', el);
        if (root) el.router('/marketplace?category=integration', root, {}, {
            pushState: true
        });
        else window.location.replace('/marketplace?category=integration');
    },
    onCreate: (el, s)=>$40b4c71025c7a7c6$var$_loadHub(s.root),
    AdminSidebar: {},
    AdminMain: {
        extends: 'AppMain',
        padding: '0',
        Header: {
            extends: 'PageHeader',
            LeftGroup: {
                Title: {
                    text: 'Integrations'
                }
            }
        },
        Body: {
            overflow: 'auto',
            padding: 'B',
            flow: 'y',
            gap: 'B',
            Hint: {
                tag: 'p',
                fontSize: 'Z2',
                color: 'caption',
                margin: '0',
                text: (el, s)=>{
                    const orgName = (s.root?.jwtClaims?.orgs || []).find((o)=>o.id === s.root?.jwtClaims?.workspace_org_id)?.name;
                    return `Connect external services to ${orgName || 'this org'}. Credentials live in Supabase Vault; governance and the editor CMS both read through the same integration registry.`;
                }
            },
            Categories: {
                flow: 'y',
                gap: 'B',
                childExtends: 'IntegrationCategoryGroup',
                childrenAs: 'state',
                children: (el, s)=>{
                    const hub = s.root?._integrationHub;
                    if (!hub?.kinds) return [];
                    return $40b4c71025c7a7c6$var$_byCategory(hub.kinds, hub.integrations);
                }
            }
        }
    }
};
const $40b4c71025c7a7c6$export$c3b8a057805aa327 = {
    flow: 'y',
    gap: 'Z1',
    CategoryHeader: {
        tag: 'h2',
        fontSize: 'B',
        fontWeight: '700',
        color: 'title',
        margin: '0',
        letterSpacing: '-0.02em',
        text: (el, s)=>s.label
    },
    Cards: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
        gap: 'A',
        childExtends: 'IntegrationCategoryCard',
        childrenAs: 'state',
        children: (el, s)=>s.items || []
    }
};
const $40b4c71025c7a7c6$export$27ff713fca413d8d = {
    tag: 'button',
    type: 'button',
    flow: 'y',
    gap: 'Z1',
    padding: 'A',
    round: 'Z1',
    background: 'overlay',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'line',
    cursor: 'pointer',
    textAlign: 'left',
    ':hover': {
        borderColor: 'title'
    },
    transition: 'border-color 150ms ease',
    onClick: (e, el, s)=>{
        const root = el.call('findRouteRoot', el);
        if (root) el.router(`/admin/integrations/${$40b4c71025c7a7c6$var$_kindRoute(s.kind)}`, root);
    },
    TopRow: {
        flow: 'x',
        align: 'center space-between',
        gap: 'Z',
        Name: {
            tag: 'span',
            fontSize: 'A',
            fontWeight: '700',
            color: 'title',
            text: (el, s)=>s.label
        },
        Pill: {
            padding: 'V Z',
            round: 'Y',
            fontSize: 'Y1',
            fontWeight: '700',
            background: (el, s)=>s.configured ? 'green' : 'overlayStrong',
            color: (el, s)=>s.configured ? 'white' : 'caption',
            text: (el, s)=>{
                if (!s.configured) return s.allows_multiple ? 'Add' : 'Not configured';
                if (s.allows_multiple) return `${s.count} connected`;
                return 'Configured';
            }
        }
    },
    Description: {
        tag: 'p',
        fontSize: 'Z2',
        color: 'caption',
        margin: '0',
        lineHeight: '1.4',
        text: (el, s)=>s.description || ''
    }
};

});

parcelRegister("1NvTc", function(module, exports) {

$parcel$export(module.exports, "adminIntegrationsSupabase", () => $14f31a983dffd70e$export$8c1b8fcc4ea3fe21);
$parcel$export(module.exports, "SupabaseNewForm", () => $14f31a983dffd70e$export$ca93a5e25521447c);
$parcel$export(module.exports, "SupabaseFormField", () => $14f31a983dffd70e$export$715328444d67477f);
$parcel$export(module.exports, "SupabaseInstanceList", () => $14f31a983dffd70e$export$3b9618f3d304b753);
$parcel$export(module.exports, "SupabaseInstanceCard", () => $14f31a983dffd70e$export$d215b52c14e3a660);
// Admin → Integrations → Supabase projects. Supports multiple slots
// (one row per connected external Supabase project, keyed by slug).
//
// UX:
//   - Top: "Add another project" button → expands a form.
//   - Body: one card per existing instance with config + enable toggle +
//           "Browse data" (routes to /data/external/:slug) + "Remove".
//   - Card header shows display_name, project_ref, and last updated.
//
// All writes go through saveIntegration()/deleteIntegration() from
// sdk-bridge, which signs via the Symbols server proxy and lets the
// edge function vault-write + upsert the row.

var $e92gD = parcelRequire("e92gD");
// resolveScope is a shared-library function; invoke via el.call('resolveScope', draft, defaultScopeType).
const $14f31a983dffd70e$var$KIND = 'supabase_project';
const $14f31a983dffd70e$var$DEFAULT_SCOPE = 'project' // supabase is per-project by nature
;
const $14f31a983dffd70e$var$_loadInstances = async (root)=>{
    const orgId = root?.jwtClaims?.workspace_org_id;
    if (!orgId) {
        if (!root._supabaseHubWatcher) root._supabaseHubWatcher = setInterval(()=>{
            if (root?.jwtClaims?.workspace_org_id) {
                clearInterval(root._supabaseHubWatcher);
                root._supabaseHubWatcher = null;
                $14f31a983dffd70e$var$_loadInstances(root);
            }
        }, 300);
        return;
    }
    const data = await (0, $e92gD.loadIntegrationCatalogue)(orgId);
    root.update({
        _integrationHub: data
    });
};
const $14f31a983dffd70e$var$_slugify = (s)=>String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-+|-+$)/g, '').slice(0, 40) || `slot-${Math.random().toString(36).slice(2, 6)}`;
const $14f31a983dffd70e$export$8c1b8fcc4ea3fe21 = {
    extends: 'AppPage',
    metadata: {
        title: 'Supabase / Integrations / Symbols Workspace'
    },
    onInit: (el, s)=>{
        if (!el.call('shouldRedirectNonAdmin', s)) return;
        const root = el.call('findRouteRoot', el);
        if (root) el.router('/', root, {}, {
            pushState: true
        });
    },
    onCreate: (el, s)=>$14f31a983dffd70e$var$_loadInstances(s.root),
    AdminSidebar: {},
    AdminMain: {
        extends: 'AppMain',
        padding: '0',
        Header: {
            extends: 'PageHeader',
            LeftGroup: {
                BackLink: {
                    tag: 'button',
                    type: 'button',
                    padding: '0',
                    background: 'transparent',
                    border: 'none',
                    color: 'caption',
                    fontSize: 'Z2',
                    cursor: 'pointer',
                    text: "\u2190 Integrations",
                    onClick: (e, el, s)=>{
                        const root = el.call('findRouteRoot', el);
                        if (root) el.router('/admin/integrations', root);
                    }
                },
                Title: {
                    text: 'Supabase projects'
                }
            },
            RightGroup: {
                AddBtn: {
                    tag: 'button',
                    type: 'button',
                    padding: 'Z A',
                    round: 'Y',
                    background: 'blue',
                    color: 'white',
                    fontSize: 'Z2',
                    fontWeight: '700',
                    cursor: 'pointer',
                    border: 'none',
                    text: '+ Connect another project',
                    onClick: (e, el, s)=>{
                        s.root.update({
                            _newSupabaseDraft: {
                                slug: '',
                                displayName: '',
                                url: '',
                                projectRef: '',
                                anonKey: '',
                                serviceKey: ''
                            },
                            _supabaseFormOpen: true
                        });
                    }
                }
            }
        },
        Body: {
            overflow: 'auto',
            padding: 'B',
            flow: 'y',
            gap: 'A',
            Hint: {
                tag: 'p',
                fontSize: 'Z2',
                color: 'caption',
                margin: '0',
                text: 'Every connected Supabase project becomes browsable in /data/external and editable in the editor CMS. Service-role keys live in Vault; they are never sent back to the browser after save.'
            },
            NewForm: {
                extends: 'SupabaseNewForm'
            },
            Instances: {
                extends: 'SupabaseInstanceList'
            }
        }
    }
};
const $14f31a983dffd70e$export$ca93a5e25521447c = {
    hide: (el, s)=>!s.root?._supabaseFormOpen,
    flow: 'y',
    gap: 'Z1',
    round: 'Z1',
    background: 'overlay',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'blue',
    padding: 'A',
    Title: {
        tag: 'h3',
        fontSize: 'A',
        fontWeight: '700',
        color: 'title',
        margin: '0',
        text: 'Connect a new Supabase project'
    },
    Fields: {
        flow: 'y',
        gap: 'Z1',
        childExtends: 'SupabaseFormField',
        childrenAs: 'state',
        children: ()=>[
                {
                    label: 'Display name',
                    placeholder: 'aihouse / hotcard / benefits',
                    draftKey: 'displayName'
                },
                {
                    label: "Slug (URL id \u2014 lowercase, hyphens)",
                    placeholder: 'aihouse',
                    draftKey: 'slug'
                },
                {
                    label: 'Project URL',
                    placeholder: 'https://xfzmadxocvkkxrdbonrx.supabase.co',
                    draftKey: 'url'
                },
                {
                    label: 'Project ref (ID from Supabase dashboard)',
                    placeholder: 'xfzmadxocvkkxrdbonrx',
                    draftKey: 'projectRef'
                },
                {
                    label: "Anon key (optional \u2014 enables realtime subscriptions)",
                    placeholder: 'eyJhbGciOiJI...',
                    draftKey: 'anonKey'
                }
            ]
    },
    ScopePicker: {
        extends: 'IntegrationScopePicker',
        draftKey: '_newSupabaseDraft',
        defaultScopeType: $14f31a983dffd70e$var$DEFAULT_SCOPE
    },
    ServiceKey: {
        flow: 'y',
        gap: 'V',
        Label: {
            tag: 'label',
            fontSize: 'Y2',
            color: 'caption',
            fontWeight: '700',
            text: "Service role key (required \u2014 written to Vault)"
        },
        Textarea: {
            tag: 'textarea',
            rows: '3',
            width: '100%',
            padding: 'Z',
            round: 'Y',
            background: 'document',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'line',
            color: 'title',
            fontFamily: 'mono',
            fontSize: 'Z2',
            placeholder: "eyJhbGciOi... (service_role key from Supabase dashboard \u2192 Settings \u2192 API)",
            onInput: (e, el, s)=>{
                s.root.update({
                    _newSupabaseDraft: {
                        ...s.root?._newSupabaseDraft || {},
                        serviceKey: e.target.value
                    }
                });
            }
        },
        Hint: {
            tag: 'p',
            fontSize: 'Y2',
            color: 'caption',
            margin: '0',
            text: 'Required. Bypasses RLS on the target project for admin reads/writes.'
        }
    },
    Actions: {
        flow: 'x',
        gap: 'Z',
        align: 'center flex-end',
        marginTop: 'Z',
        CancelBtn: {
            tag: 'button',
            type: 'button',
            padding: 'V Z',
            round: 'Y',
            background: 'transparent',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'line',
            color: 'title',
            cursor: 'pointer',
            fontSize: 'Y2',
            text: 'Cancel',
            onClick: (e, el, s)=>{
                s.root.update({
                    _supabaseFormOpen: false,
                    _newSupabaseDraft: null
                });
            }
        },
        SaveBtn: {
            tag: 'button',
            type: 'button',
            padding: 'V A',
            round: 'Y',
            background: 'blue',
            color: 'white',
            fontSize: 'Y2',
            fontWeight: '700',
            cursor: 'pointer',
            border: 'none',
            text: (el, s)=>s.root?._supabaseSaving ? "Saving\u2026" : 'Connect project',
            onClick: async (e, el, s)=>{
                const orgId = s.root?.jwtClaims?.workspace_org_id;
                const draft = s.root?._newSupabaseDraft || {};
                if (!orgId) {
                    el.call('openNotification', {
                        title: 'No active workspace',
                        type: 'error'
                    });
                    return;
                }
                if (!draft.displayName || !draft.url || !draft.projectRef || !draft.serviceKey) {
                    el.call('openNotification', {
                        title: 'Missing required fields',
                        message: 'Display name, URL, project ref, and service key are required.',
                        type: 'error'
                    });
                    return;
                }
                const slug = $14f31a983dffd70e$var$_slugify(draft.slug || draft.displayName);
                const scope = el.call('resolveScope', draft, $14f31a983dffd70e$var$DEFAULT_SCOPE);
                if (scope.scopeType !== 'org' && !scope.scopeId) {
                    el.call('openNotification', {
                        title: 'Scope target required',
                        message: `Select a ${scope.scopeType} or switch scope to Org.`,
                        type: 'error'
                    });
                    return;
                }
                s.root.update({
                    _supabaseSaving: true
                });
                const { ok: ok, body: body } = await (0, $e92gD.saveIntegration)({
                    orgId: orgId,
                    kind: $14f31a983dffd70e$var$KIND,
                    slug: slug,
                    scopeType: scope.scopeType,
                    scopeId: scope.scopeId,
                    displayName: draft.displayName,
                    secret: draft.serviceKey,
                    config: {
                        display_name: draft.displayName,
                        url: draft.url,
                        project_ref: draft.projectRef,
                        anon_key: draft.anonKey || undefined
                    },
                    enabled: true
                });
                s.root.update({
                    _supabaseSaving: false
                });
                if (ok) {
                    s.root.update({
                        _supabaseFormOpen: false,
                        _newSupabaseDraft: null
                    });
                    await $14f31a983dffd70e$var$_loadInstances(s.root);
                    el.call('openNotification', {
                        title: `Connected ${draft.displayName}`,
                        type: 'success'
                    });
                } else el.call('openNotification', {
                    title: 'Connect failed',
                    message: body?.error || 'Unable to save integration. Does the Symbols server proxy exist?',
                    type: 'error'
                });
            }
        }
    }
};
const $14f31a983dffd70e$export$715328444d67477f = {
    flow: 'y',
    gap: 'V',
    Label: {
        tag: 'label',
        fontSize: 'Y2',
        color: 'caption',
        fontWeight: '700',
        text: (el, s)=>s.label
    },
    Input: {
        tag: 'input',
        type: 'text',
        width: '100%',
        padding: 'Z',
        round: 'Y',
        background: 'document',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'line',
        color: 'title',
        fontSize: 'Z2',
        placeholder: (el, s)=>s.placeholder || '',
        value: (el, s)=>{
            const draft = s.root?._newSupabaseDraft || {};
            return draft[s.draftKey] || '';
        },
        onInput: (e, el, s)=>{
            s.root.update({
                _newSupabaseDraft: {
                    ...s.root?._newSupabaseDraft || {},
                    [s.draftKey]: e.target.value
                }
            });
        }
    }
};
const $14f31a983dffd70e$export$3b9618f3d304b753 = {
    flow: 'y',
    gap: 'A',
    childExtends: 'SupabaseInstanceCard',
    childrenAs: 'state',
    children: (el, s)=>{
        const list = s.root?._integrationHub?.integrations || [];
        return list.filter((i)=>i.kind === $14f31a983dffd70e$var$KIND);
    },
    EmptyState: {
        hide: (el, s)=>{
            const list = s.root?._integrationHub?.integrations || [];
            return list.filter((i)=>i.kind === $14f31a983dffd70e$var$KIND).length > 0;
        },
        padding: 'B',
        round: 'Z1',
        background: 'overlay',
        borderWidth: '1px',
        borderStyle: 'dashed',
        borderColor: 'line',
        textAlign: 'center',
        color: 'caption',
        fontSize: 'Z2',
        text: 'No Supabase projects connected yet. Click "Connect another project" to add the first one.'
    }
};
const $14f31a983dffd70e$export$d215b52c14e3a660 = {
    round: 'Z1',
    background: 'overlay',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'line',
    padding: 'A',
    flow: 'y',
    gap: 'Z1',
    TopRow: {
        flow: 'x',
        align: 'center space-between',
        gap: 'Z',
        Left: {
            flow: 'x',
            align: 'center',
            gap: 'Z1',
            Icon: {
                icon: 'database',
                boxSize: 'A'
            },
            Info: {
                flow: 'y',
                gap: 'V',
                Name: {
                    tag: 'span',
                    fontSize: 'A',
                    fontWeight: '700',
                    color: 'title',
                    text: (el, s)=>s.display_name || s.slug
                },
                Meta: {
                    tag: 'span',
                    fontSize: 'Y2',
                    color: 'caption',
                    text: (el, s)=>`${s.config?.project_ref || "\u2014"} \xb7 slug: ${s.slug}`
                }
            }
        },
        Right: {
            flow: 'x',
            gap: 'Z',
            align: 'center',
            ScopeBadge: {
                extends: 'IntegrationScopeBadge'
            },
            StatusPill: {
                tag: 'span',
                padding: 'V Z',
                round: 'Y',
                fontSize: 'Y1',
                fontWeight: '700',
                background: (el, s)=>s.enabled && s.has_secret ? 'green' : 'overlayStrong',
                color: (el, s)=>s.enabled && s.has_secret ? 'white' : 'caption',
                text: (el, s)=>{
                    if (!s.has_secret) return 'Missing secret';
                    if (!s.enabled) return 'Disabled';
                    return 'Live';
                }
            },
            BrowseBtn: {
                tag: 'button',
                type: 'button',
                padding: 'V Z',
                round: 'Y',
                background: 'blue',
                color: 'white',
                fontSize: 'Y2',
                fontWeight: '700',
                cursor: 'pointer',
                border: 'none',
                text: 'Browse data',
                onClick: (e, el, s)=>{
                    const root = el.call('findRouteRoot', el);
                    if (root) el.router(`/data/external?slug=${encodeURIComponent(s.slug)}`, root);
                }
            },
            RemoveBtn: {
                tag: 'button',
                type: 'button',
                padding: 'V Z',
                round: 'Y',
                background: 'transparent',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: 'line',
                color: 'red',
                fontSize: 'Y2',
                cursor: 'pointer',
                text: 'Remove',
                onClick: async (e, el, s)=>{
                    if (!window.confirm(`Disconnect ${s.display_name || s.slug}? The external project is not modified.`)) return;
                    const orgId = s.root?.jwtClaims?.workspace_org_id;
                    if (!orgId) return;
                    const { ok: ok, body: body } = await (0, $e92gD.deleteIntegration)({
                        orgId: orgId,
                        kind: $14f31a983dffd70e$var$KIND,
                        slug: s.slug,
                        scopeType: s.scope_type || 'org',
                        scopeId: s.scope_id || null
                    });
                    if (ok) {
                        await $14f31a983dffd70e$var$_loadInstances(s.root);
                        el.call('openNotification', {
                            title: 'Disconnected',
                            type: 'success'
                        });
                    } else el.call('openNotification', {
                        title: 'Remove failed',
                        message: body?.error || 'Server error',
                        type: 'error'
                    });
                }
            }
        }
    },
    ConfigRow: {
        flow: 'x',
        gap: 'B',
        fontSize: 'Y2',
        color: 'caption',
        flexWrap: 'wrap',
        Url: {
            text: (el, s)=>s.config?.url ? `URL: ${s.config.url}` : ''
        },
        HasAnon: {
            text: (el, s)=>s.config?.anon_key ? "\xb7 Anon: set" : "\xb7 Anon: not set (no realtime)"
        }
    }
};

});

parcelRegister("kHSc9", function(module, exports) {

$parcel$export(module.exports, "adminIntegrationsGithub", () => $f131dcc6dcc96ac5$export$a21f2b35a3c94148);
$parcel$export(module.exports, "GithubNewForm", () => $f131dcc6dcc96ac5$export$ca06d958e2c13032);
$parcel$export(module.exports, "GithubField", () => $f131dcc6dcc96ac5$export$7d5feefe87473d49);
$parcel$export(module.exports, "GithubInstanceList", () => $f131dcc6dcc96ac5$export$60cd230c7cec53a1);
$parcel$export(module.exports, "GithubInstanceCard", () => $f131dcc6dcc96ac5$export$f86ace193e53547e);
// Admin → Integrations → GitHub. Multi-slot (an org can wire several
// GitHub Projects v2 boards) with per-instance config + manual sync
// controls. Slots reuse the github-sync edge function (which already
// accepts an orgId via request body per migration 0053).

var $e92gD = parcelRequire("e92gD");
// resolveScope is a shared-library function; invoke via el.call('resolveScope', draft, defaultScopeType).
const $f131dcc6dcc96ac5$var$KIND = 'github';
const $f131dcc6dcc96ac5$var$DEFAULT_SCOPE = 'org';
const $f131dcc6dcc96ac5$var$_loadInstances = async (root)=>{
    const orgId = root?.jwtClaims?.workspace_org_id;
    if (!orgId) {
        if (!root._githubHubWatcher) root._githubHubWatcher = setInterval(()=>{
            if (root?.jwtClaims?.workspace_org_id) {
                clearInterval(root._githubHubWatcher);
                root._githubHubWatcher = null;
                $f131dcc6dcc96ac5$var$_loadInstances(root);
            }
        }, 300);
        return;
    }
    const data = await (0, $e92gD.loadIntegrationCatalogue)(orgId);
    root.update({
        _integrationHub: data
    });
};
const $f131dcc6dcc96ac5$var$_triggerSync = async (root, slug)=>{
    const orgId = root?.jwtClaims?.workspace_org_id;
    if (!orgId) return {
        ok: false,
        error: 'no active workspace'
    };
    // TODO[sdk-edge-invoke]: github-sync is a governance-tier Supabase edge
    // function (not a workspace wrapper route). The SDK has no flat method
    // for invoking arbitrary edge functions on the governance project; once
    // a /workspace/integrations/sync admin route or a callIntegrationOp
    // 'sync' op ships, replace with
    // `getSDK().execute('workspaceProject.integrations', 'sync', {...})`.
    // For now, surface a clear error rather than silently dropping the call.
    return {
        ok: false,
        error: "github-sync edge function invocation not yet routed through SDK; pending wrapper /integrations/sync endpoint"
    };
};
const $f131dcc6dcc96ac5$var$_slugify = (s)=>String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-+|-+$)/g, '').slice(0, 40) || 'default';
const $f131dcc6dcc96ac5$export$a21f2b35a3c94148 = {
    extends: 'AppPage',
    metadata: {
        title: 'GitHub / Integrations / Symbols Workspace'
    },
    onInit: (el, s)=>{
        if (!el.call('shouldRedirectNonAdmin', s)) return;
        const root = el.call('findRouteRoot', el);
        if (root) el.router('/', root, {}, {
            pushState: true
        });
    },
    onCreate: (el, s)=>$f131dcc6dcc96ac5$var$_loadInstances(s.root),
    AdminSidebar: {},
    AdminMain: {
        extends: 'AppMain',
        padding: '0',
        Header: {
            extends: 'PageHeader',
            LeftGroup: {
                BackLink: {
                    tag: 'button',
                    type: 'button',
                    padding: '0',
                    background: 'transparent',
                    border: 'none',
                    color: 'caption',
                    fontSize: 'Z2',
                    cursor: 'pointer',
                    text: "\u2190 Integrations",
                    onClick: (e, el, s)=>{
                        const root = el.call('findRouteRoot', el);
                        if (root) el.router('/admin/integrations', root);
                    }
                },
                Title: {
                    text: 'GitHub'
                }
            },
            RightGroup: {
                AddBtn: {
                    tag: 'button',
                    type: 'button',
                    padding: 'Z A',
                    round: 'Y',
                    background: 'blue',
                    color: 'white',
                    fontSize: 'Z2',
                    fontWeight: '700',
                    cursor: 'pointer',
                    border: 'none',
                    text: '+ Add a Projects board',
                    onClick: (e, el, s)=>{
                        s.root.update({
                            _newGithubDraft: {
                                slug: '',
                                displayName: '',
                                owner: '',
                                projectId: '',
                                token: ''
                            },
                            _githubFormOpen: true
                        });
                    }
                }
            }
        },
        Body: {
            overflow: 'auto',
            padding: 'B',
            flow: 'y',
            gap: 'A',
            Hint: {
                tag: 'p',
                fontSize: 'Z2',
                color: 'caption',
                margin: '0',
                text: "Tickets in governance stay in sync with GitHub Projects v2. Every board below is a separate slot \u2014 add one per team, per product, or per org you want to mirror."
            },
            NewForm: {
                extends: 'GithubNewForm'
            },
            Instances: {
                extends: 'GithubInstanceList'
            }
        }
    }
};
const $f131dcc6dcc96ac5$export$ca06d958e2c13032 = {
    hide: (el, s)=>!s.root?._githubFormOpen,
    flow: 'y',
    gap: 'Z1',
    round: 'Z1',
    background: 'overlay',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'blue',
    padding: 'A',
    Title: {
        tag: 'h3',
        fontSize: 'A',
        fontWeight: '700',
        color: 'title',
        margin: '0',
        text: 'Add a GitHub Projects v2 board'
    },
    Fields: {
        flow: 'y',
        gap: 'Z1',
        childExtends: 'GithubField',
        childrenAs: 'state',
        children: ()=>[
                {
                    label: 'Display name',
                    placeholder: 'symbols.app board',
                    draftKey: 'displayName'
                },
                {
                    label: 'Slug',
                    placeholder: 'symbols-main',
                    draftKey: 'slug'
                },
                {
                    label: 'Repo owner / org (required)',
                    placeholder: 'symbo-ls',
                    draftKey: 'owner'
                },
                {
                    label: 'Projects v2 ID (required)',
                    placeholder: '5',
                    draftKey: 'projectId'
                }
            ]
    },
    ScopePicker: {
        extends: 'IntegrationScopePicker',
        draftKey: '_newGithubDraft',
        defaultScopeType: $f131dcc6dcc96ac5$var$DEFAULT_SCOPE
    },
    Token: {
        flow: 'y',
        gap: 'V',
        Label: {
            tag: 'label',
            fontSize: 'Y2',
            color: 'caption',
            fontWeight: '700',
            text: "Personal access token (required \u2014 written to Vault)"
        },
        Textarea: {
            tag: 'textarea',
            rows: '3',
            width: '100%',
            padding: 'Z',
            round: 'Y',
            background: 'document',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'line',
            color: 'title',
            fontFamily: 'mono',
            fontSize: 'Z2',
            placeholder: 'ghp_... / github_pat_...',
            onInput: (e, el, s)=>{
                s.root.update({
                    _newGithubDraft: {
                        ...s.root?._newGithubDraft || {},
                        token: e.target.value
                    }
                });
            }
        },
        Hint: {
            tag: 'p',
            fontSize: 'Y2',
            color: 'caption',
            margin: '0',
            text: 'Classic: read:project, project, repo. Fine-grained: Projects (Read/Write) at the org level.'
        }
    },
    Actions: {
        flow: 'x',
        gap: 'Z',
        align: 'center flex-end',
        marginTop: 'Z',
        CancelBtn: {
            tag: 'button',
            type: 'button',
            padding: 'V Z',
            round: 'Y',
            background: 'transparent',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'line',
            color: 'title',
            cursor: 'pointer',
            fontSize: 'Y2',
            text: 'Cancel',
            onClick: (e, el, s)=>{
                s.root.update({
                    _githubFormOpen: false,
                    _newGithubDraft: null
                });
            }
        },
        SaveBtn: {
            tag: 'button',
            type: 'button',
            padding: 'V A',
            round: 'Y',
            background: 'blue',
            color: 'white',
            fontSize: 'Y2',
            fontWeight: '700',
            cursor: 'pointer',
            border: 'none',
            text: (el, s)=>s.root?._githubSaving ? "Saving\u2026" : 'Connect',
            onClick: async (e, el, s)=>{
                const orgId = s.root?.jwtClaims?.workspace_org_id;
                const draft = s.root?._newGithubDraft || {};
                if (!orgId) {
                    el.call('openNotification', {
                        title: 'No active workspace',
                        type: 'error'
                    });
                    return;
                }
                if (!draft.owner || !draft.projectId || !draft.token) {
                    el.call('openNotification', {
                        title: 'Missing required fields',
                        message: 'Owner, project ID, and token are required.',
                        type: 'error'
                    });
                    return;
                }
                const slug = $f131dcc6dcc96ac5$var$_slugify(draft.slug || draft.displayName || `${draft.owner}-${draft.projectId}`);
                const scope = el.call('resolveScope', draft, $f131dcc6dcc96ac5$var$DEFAULT_SCOPE);
                if (scope.scopeType !== 'org' && !scope.scopeId) {
                    el.call('openNotification', {
                        title: 'Scope target required',
                        message: `Select a ${scope.scopeType} or switch scope to Org.`,
                        type: 'error'
                    });
                    return;
                }
                s.root.update({
                    _githubSaving: true
                });
                const { ok: ok, body: body } = await (0, $e92gD.saveIntegration)({
                    orgId: orgId,
                    kind: $f131dcc6dcc96ac5$var$KIND,
                    slug: slug,
                    scopeType: scope.scopeType,
                    scopeId: scope.scopeId,
                    displayName: draft.displayName || `${draft.owner} / ${draft.projectId}`,
                    secret: draft.token,
                    config: {
                        owner: draft.owner,
                        project_id: draft.projectId,
                        display_name: draft.displayName || `${draft.owner} / ${draft.projectId}`
                    },
                    enabled: true
                });
                s.root.update({
                    _githubSaving: false
                });
                if (ok) {
                    s.root.update({
                        _githubFormOpen: false,
                        _newGithubDraft: null
                    });
                    await $f131dcc6dcc96ac5$var$_loadInstances(s.root);
                    el.call('openNotification', {
                        title: 'Connected',
                        type: 'success'
                    });
                } else el.call('openNotification', {
                    title: 'Connect failed',
                    message: body?.error || 'Server error',
                    type: 'error'
                });
            }
        }
    }
};
const $f131dcc6dcc96ac5$export$7d5feefe87473d49 = {
    flow: 'y',
    gap: 'V',
    Label: {
        tag: 'label',
        fontSize: 'Y2',
        color: 'caption',
        fontWeight: '700',
        text: (el, s)=>s.label
    },
    Input: {
        tag: 'input',
        type: 'text',
        width: '100%',
        padding: 'Z',
        round: 'Y',
        background: 'document',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'line',
        color: 'title',
        fontSize: 'Z2',
        placeholder: (el, s)=>s.placeholder || '',
        value: (el, s)=>{
            const draft = s.root?._newGithubDraft || {};
            return draft[s.draftKey] || '';
        },
        onInput: (e, el, s)=>{
            s.root.update({
                _newGithubDraft: {
                    ...s.root?._newGithubDraft || {},
                    [s.draftKey]: e.target.value
                }
            });
        }
    }
};
const $f131dcc6dcc96ac5$export$60cd230c7cec53a1 = {
    flow: 'y',
    gap: 'A',
    childExtends: 'GithubInstanceCard',
    childrenAs: 'state',
    children: (el, s)=>{
        const list = s.root?._integrationHub?.integrations || [];
        return list.filter((i)=>i.kind === $f131dcc6dcc96ac5$var$KIND);
    },
    EmptyState: {
        hide: (el, s)=>{
            const list = s.root?._integrationHub?.integrations || [];
            return list.filter((i)=>i.kind === $f131dcc6dcc96ac5$var$KIND).length > 0;
        },
        padding: 'B',
        round: 'Z1',
        background: 'overlay',
        borderWidth: '1px',
        borderStyle: 'dashed',
        borderColor: 'line',
        textAlign: 'center',
        color: 'caption',
        fontSize: 'Z2',
        text: 'No GitHub Projects boards connected. Add one to start syncing tickets.'
    }
};
const $f131dcc6dcc96ac5$export$f86ace193e53547e = {
    round: 'Z1',
    background: 'overlay',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'line',
    padding: 'A',
    flow: 'y',
    gap: 'Z1',
    TopRow: {
        flow: 'x',
        align: 'center space-between',
        gap: 'Z',
        Left: {
            flow: 'x',
            align: 'center',
            gap: 'Z1',
            Icon: {
                icon: 'github',
                boxSize: 'A'
            },
            Info: {
                flow: 'y',
                gap: 'V',
                Name: {
                    tag: 'span',
                    fontSize: 'A',
                    fontWeight: '700',
                    color: 'title',
                    text: (el, s)=>s.display_name || `${s.config?.owner || '?'} / ${s.config?.project_id || '?'}`
                },
                Meta: {
                    tag: 'span',
                    fontSize: 'Y2',
                    color: 'caption',
                    text: (el, s)=>`slug: ${s.slug} \xb7 owner: ${s.config?.owner || "\u2014"} \xb7 project: ${s.config?.project_id || "\u2014"}`
                }
            }
        },
        Right: {
            flow: 'x',
            gap: 'Z',
            align: 'center',
            StatusPill: {
                tag: 'span',
                padding: 'V Z',
                round: 'Y',
                fontSize: 'Y1',
                fontWeight: '700',
                background: (el, s)=>s.enabled && s.has_secret ? 'green' : 'overlayStrong',
                color: (el, s)=>s.enabled && s.has_secret ? 'white' : 'caption',
                text: (el, s)=>{
                    if (!s.has_secret) return 'Missing token';
                    if (!s.enabled) return 'Disabled';
                    return 'Live';
                }
            },
            SyncBtn: {
                tag: 'button',
                type: 'button',
                padding: 'V Z',
                round: 'Y',
                background: 'blue',
                color: 'white',
                fontSize: 'Y2',
                fontWeight: '700',
                cursor: 'pointer',
                border: 'none',
                text: (el, s)=>{
                    const syncing = s.root?._githubSyncing === s.slug;
                    return syncing ? "Syncing\u2026" : 'Pull now';
                },
                onClick: async (e, el, s)=>{
                    s.root.update({
                        _githubSyncing: s.slug
                    });
                    const { ok: ok, error: error } = await $f131dcc6dcc96ac5$var$_triggerSync(s.root, s.slug);
                    s.root.update({
                        _githubSyncing: null
                    });
                    if (ok) el.call('openNotification', {
                        title: 'Sync started',
                        type: 'success'
                    });
                    else el.call('openNotification', {
                        title: 'Sync failed',
                        message: error,
                        type: 'error'
                    });
                }
            },
            RemoveBtn: {
                tag: 'button',
                type: 'button',
                padding: 'V Z',
                round: 'Y',
                background: 'transparent',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: 'line',
                color: 'red',
                fontSize: 'Y2',
                cursor: 'pointer',
                text: 'Remove',
                onClick: async (e, el, s)=>{
                    if (!window.confirm(`Disconnect ${s.display_name || s.slug}? Tickets remain in governance but new sync stops.`)) return;
                    const orgId = s.root?.jwtClaims?.workspace_org_id;
                    if (!orgId) return;
                    const { ok: ok, body: body } = await (0, $e92gD.deleteIntegration)({
                        orgId: orgId,
                        kind: $f131dcc6dcc96ac5$var$KIND,
                        slug: s.slug,
                        scopeType: s.scope_type || 'org',
                        scopeId: s.scope_id || null
                    });
                    if (ok) {
                        await $f131dcc6dcc96ac5$var$_loadInstances(s.root);
                        el.call('openNotification', {
                            title: 'Disconnected',
                            type: 'success'
                        });
                    } else el.call('openNotification', {
                        title: 'Remove failed',
                        message: body?.error || 'Server error',
                        type: 'error'
                    });
                }
            }
        }
    }
};

});

parcelRegister("f9P05", function(module, exports) {

$parcel$export(module.exports, "adminIntegrationsGoogle", () => $b08f41df1e3254cf$export$4146aca3de6f5825);
$parcel$export(module.exports, "GoogleConfigCard", () => $b08f41df1e3254cf$export$6e63560d3e4c4d4d);
$parcel$export(module.exports, "GoogleField", () => $b08f41df1e3254cf$export$d42644e3f04e4f68);
// Admin → Integrations → Google Workspace. Single-slot (one workspace
// domain per org). UI lets the admin update domain + admin email,
// paste a new service account JSON (overwrites in vault), test the
// connection by listing delegated users, and trigger a calendar sync.

var $e92gD = parcelRequire("e92gD");
const $b08f41df1e3254cf$var$KIND = 'google_workspace';
const $b08f41df1e3254cf$var$SLUG = 'default';
const $b08f41df1e3254cf$var$_loadInstance = async (root)=>{
    const orgId = root?.jwtClaims?.workspace_org_id;
    if (!orgId) {
        if (!root._googleHubWatcher) root._googleHubWatcher = setInterval(()=>{
            if (root?.jwtClaims?.workspace_org_id) {
                clearInterval(root._googleHubWatcher);
                root._googleHubWatcher = null;
                $b08f41df1e3254cf$var$_loadInstance(root);
            }
        }, 300);
        return;
    }
    const data = await (0, $e92gD.loadIntegrationCatalogue)(orgId);
    root.update({
        _integrationHub: data
    });
};
const $b08f41df1e3254cf$var$_triggerCalendarSync = async (root)=>{
    const orgId = root?.jwtClaims?.workspace_org_id;
    if (!orgId) return {
        ok: false,
        error: 'no active workspace'
    };
    // TODO[sdk-edge-invoke]: calendar-sync is a governance-tier Supabase edge
    // function (not a workspace wrapper route). The SDK has no flat method
    // for invoking arbitrary edge functions on the governance project; once
    // a /workspace/integrations/sync admin route or a callIntegrationOp
    // 'sync' op ships, replace with
    // `getSDK().execute('workspaceProject.integrations', 'sync', {...})`.
    return {
        ok: false,
        error: "calendar-sync edge function invocation not yet routed through SDK; pending wrapper /integrations/sync endpoint"
    };
};
const $b08f41df1e3254cf$var$_currentInstance = (root)=>{
    const list = root?._integrationHub?.integrations || [];
    return list.find((i)=>i.kind === $b08f41df1e3254cf$var$KIND && i.slug === $b08f41df1e3254cf$var$SLUG);
};
const $b08f41df1e3254cf$export$4146aca3de6f5825 = {
    extends: 'AppPage',
    metadata: {
        title: 'Google Workspace / Integrations / Symbols Workspace'
    },
    onInit: (el, s)=>{
        if (!el.call('shouldRedirectNonAdmin', s)) return;
        const root = el.call('findRouteRoot', el);
        if (root) el.router('/', root, {}, {
            pushState: true
        });
    },
    onCreate: (el, s)=>$b08f41df1e3254cf$var$_loadInstance(s.root),
    AdminSidebar: {},
    AdminMain: {
        extends: 'AppMain',
        padding: '0',
        Header: {
            extends: 'PageHeader',
            LeftGroup: {
                BackLink: {
                    tag: 'button',
                    type: 'button',
                    padding: '0',
                    background: 'transparent',
                    border: 'none',
                    color: 'caption',
                    fontSize: 'Z2',
                    cursor: 'pointer',
                    text: "\u2190 Integrations",
                    onClick: (e, el, s)=>{
                        const root = el.call('findRouteRoot', el);
                        if (root) el.router('/admin/integrations', root);
                    }
                },
                Title: {
                    text: 'Google Workspace'
                }
            }
        },
        Body: {
            overflow: 'auto',
            padding: 'B',
            flow: 'y',
            gap: 'A',
            Hint: {
                tag: 'p',
                fontSize: 'Z2',
                color: 'caption',
                margin: '0',
                text: 'Domain-wide delegation authorizes governance to sync calendars on behalf of every user in the workspace. Rotate the service account JSON to revoke access.'
            },
            Card: {
                extends: 'GoogleConfigCard'
            }
        }
    }
};
const $b08f41df1e3254cf$export$6e63560d3e4c4d4d = {
    round: 'Z1',
    background: 'overlay',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'line',
    padding: 'A',
    flow: 'y',
    gap: 'Z1',
    StatusRow: {
        flow: 'x',
        align: 'center space-between',
        gap: 'Z',
        Left: {
            flow: 'x',
            align: 'center',
            gap: 'Z1',
            Icon: {
                icon: 'google',
                boxSize: 'A'
            },
            Info: {
                flow: 'y',
                gap: 'V',
                Name: {
                    tag: 'span',
                    fontSize: 'A',
                    fontWeight: '700',
                    color: 'title',
                    text: (el, s)=>{
                        const inst = $b08f41df1e3254cf$var$_currentInstance(s.root);
                        return inst?.config?.domain || 'Not configured';
                    }
                },
                Status: {
                    tag: 'span',
                    fontSize: 'Y2',
                    color: 'caption',
                    text: (el, s)=>{
                        const inst = $b08f41df1e3254cf$var$_currentInstance(s.root);
                        if (!inst) return 'Not configured';
                        if (!inst.has_secret) return 'Config only (no service account key)';
                        return inst.enabled ? "Configured \xb7 enabled" : "Configured \xb7 disabled";
                    }
                }
            }
        },
        Right: {
            flow: 'x',
            gap: 'Z',
            SyncBtn: {
                tag: 'button',
                type: 'button',
                hide: (el, s)=>!$b08f41df1e3254cf$var$_currentInstance(s.root)?.has_secret,
                padding: 'V Z',
                round: 'Y',
                background: 'blue',
                color: 'white',
                fontSize: 'Y2',
                fontWeight: '700',
                cursor: 'pointer',
                border: 'none',
                text: (el, s)=>s.root?._googleSyncing ? "Syncing\u2026" : 'Pull calendar',
                onClick: async (e, el, s)=>{
                    s.root.update({
                        _googleSyncing: true
                    });
                    const { ok: ok, error: error } = await $b08f41df1e3254cf$var$_triggerCalendarSync(s.root);
                    s.root.update({
                        _googleSyncing: false
                    });
                    if (ok) el.call('openNotification', {
                        title: 'Sync started',
                        type: 'success'
                    });
                    else el.call('openNotification', {
                        title: 'Sync failed',
                        message: error,
                        type: 'error'
                    });
                }
            }
        }
    },
    Fields: {
        flow: 'y',
        gap: 'Z1',
        childExtends: 'GoogleField',
        childrenAs: 'state',
        children: ()=>[
                {
                    label: 'Workspace domain',
                    placeholder: 'symbols.app',
                    configKey: 'domain'
                },
                {
                    label: 'Admin email (DWD subject)',
                    placeholder: 'nika@symbols.app',
                    configKey: 'admin_email'
                }
            ]
    },
    Secret: {
        flow: 'y',
        gap: 'V',
        Label: {
            tag: 'label',
            fontSize: 'Y2',
            color: 'caption',
            fontWeight: '700',
            text: "Service account JSON (paste new to rotate \u2014 leave empty to keep)"
        },
        Textarea: {
            tag: 'textarea',
            rows: '6',
            width: '100%',
            padding: 'Z',
            round: 'Y',
            background: 'document',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'line',
            color: 'title',
            fontFamily: 'mono',
            fontSize: 'Z2',
            placeholder: '{ "type": "service_account", ... }',
            onInput: (e, el, s)=>{
                s.root.update({
                    _googleDraft: {
                        ...s.root?._googleDraft || {},
                        secret: e.target.value
                    }
                });
            }
        },
        Hint: {
            tag: 'p',
            fontSize: 'Y2',
            color: 'caption',
            margin: '0',
            text: 'Must have domain-wide delegation and the calendar read/write scopes authorized in Google Admin.'
        }
    },
    Actions: {
        flow: 'x',
        gap: 'Z',
        align: 'center space-between',
        marginTop: 'Z',
        RemoveBtn: {
            tag: 'button',
            type: 'button',
            hide: (el, s)=>!$b08f41df1e3254cf$var$_currentInstance(s.root),
            padding: 'V Z',
            round: 'Y',
            background: 'transparent',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'line',
            color: 'red',
            fontSize: 'Y2',
            cursor: 'pointer',
            text: 'Remove integration',
            onClick: async (e, el, s)=>{
                if (!window.confirm('Remove Google Workspace integration? Calendar sync will stop.')) return;
                const orgId = s.root?.jwtClaims?.workspace_org_id;
                const { ok: ok } = await (0, $e92gD.deleteIntegration)({
                    orgId: orgId,
                    kind: $b08f41df1e3254cf$var$KIND,
                    slug: $b08f41df1e3254cf$var$SLUG
                });
                if (ok) {
                    await $b08f41df1e3254cf$var$_loadInstance(s.root);
                    el.call('openNotification', {
                        title: 'Removed',
                        type: 'success'
                    });
                }
            }
        },
        SaveBtn: {
            tag: 'button',
            type: 'button',
            padding: 'V A',
            round: 'Y',
            background: 'blue',
            color: 'white',
            fontSize: 'Y2',
            fontWeight: '700',
            cursor: 'pointer',
            border: 'none',
            text: 'Save',
            onClick: async (e, el, s)=>{
                const orgId = s.root?.jwtClaims?.workspace_org_id;
                if (!orgId) return;
                const inst = $b08f41df1e3254cf$var$_currentInstance(s.root);
                const draft = s.root?._googleDraft || {};
                const config = {
                    ...inst?.config || {},
                    ...draft.config || {}
                };
                if (!config.domain) {
                    el.call('openNotification', {
                        title: 'Domain required',
                        type: 'error'
                    });
                    return;
                }
                const { ok: ok, body: body } = await (0, $e92gD.saveIntegration)({
                    orgId: orgId,
                    kind: $b08f41df1e3254cf$var$KIND,
                    slug: $b08f41df1e3254cf$var$SLUG,
                    displayName: config.domain,
                    secret: draft.secret || undefined,
                    config: config,
                    enabled: true
                });
                if (ok) {
                    s.root.update({
                        _googleDraft: null
                    });
                    await $b08f41df1e3254cf$var$_loadInstance(s.root);
                    el.call('openNotification', {
                        title: 'Saved',
                        type: 'success'
                    });
                } else el.call('openNotification', {
                    title: 'Save failed',
                    message: body?.error || 'Server error',
                    type: 'error'
                });
            }
        }
    }
};
const $b08f41df1e3254cf$export$d42644e3f04e4f68 = {
    flow: 'y',
    gap: 'V',
    Label: {
        tag: 'label',
        fontSize: 'Y2',
        color: 'caption',
        fontWeight: '700',
        text: (el, s)=>s.label
    },
    Input: {
        tag: 'input',
        type: 'text',
        width: '100%',
        padding: 'Z',
        round: 'Y',
        background: 'document',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'line',
        color: 'title',
        fontSize: 'Z2',
        placeholder: (el, s)=>s.placeholder || '',
        value: (el, s)=>{
            const draft = s.root?._googleDraft?.config?.[s.configKey];
            if (draft != null) return draft;
            const inst = $b08f41df1e3254cf$var$_currentInstance(s.root);
            return inst?.config?.[s.configKey] || '';
        },
        onInput: (e, el, s)=>{
            s.root.update({
                _googleDraft: {
                    ...s.root?._googleDraft || {},
                    config: {
                        ...(s.root?._googleDraft || {}).config || {},
                        [s.configKey]: e.target.value
                    }
                }
            });
        }
    }
};

});

parcelRegister("aNbvv", function(module, exports) {

$parcel$export(module.exports, "adminIntegrationsNpm", () => $7db76810d7ffb9ae$export$1b55aa1ef8cf5955);
$parcel$export(module.exports, "NpmNewForm", () => $7db76810d7ffb9ae$export$a53afd0a98c97c9);
$parcel$export(module.exports, "NpmField", () => $7db76810d7ffb9ae$export$d420685026a9cc4d);
$parcel$export(module.exports, "NpmInstanceList", () => $7db76810d7ffb9ae$export$7a9e79820bc79fc7);
$parcel$export(module.exports, "NpmInstanceCard", () => $7db76810d7ffb9ae$export$3772e36ab95f18f);
// Admin → Integrations → npm. Multi-slot (org can configure several
// npm scopes / registry entries). Used by the editor's project-publish
// flow + the CI pipeline.
//
// Until the npm-publish edge function lands, this page only stores
// config; server-side publishes read (scope, registry, token) and
// assemble a valid .npmrc on the fly.

var $e92gD = parcelRequire("e92gD");
// resolveScope is a shared-library function; invoke via el.call('resolveScope', draft, defaultScopeType).
const $7db76810d7ffb9ae$var$KIND = 'npm';
const $7db76810d7ffb9ae$var$DEFAULT_SCOPE = 'org';
const $7db76810d7ffb9ae$var$_loadInstances = async (root)=>{
    const orgId = root?.jwtClaims?.workspace_org_id;
    if (!orgId) {
        if (!root._npmHubWatcher) root._npmHubWatcher = setInterval(()=>{
            if (root?.jwtClaims?.workspace_org_id) {
                clearInterval(root._npmHubWatcher);
                root._npmHubWatcher = null;
                $7db76810d7ffb9ae$var$_loadInstances(root);
            }
        }, 300);
        return;
    }
    const data = await (0, $e92gD.loadIntegrationCatalogue)(orgId);
    root.update({
        _integrationHub: data
    });
};
const $7db76810d7ffb9ae$var$_slugify = (s)=>String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-+|-+$)/g, '').slice(0, 40) || 'default';
const $7db76810d7ffb9ae$export$1b55aa1ef8cf5955 = {
    extends: 'AppPage',
    metadata: {
        title: 'npm / Integrations / Symbols Workspace'
    },
    onInit: (el, s)=>{
        if (!el.call('shouldRedirectNonAdmin', s)) return;
        const root = el.call('findRouteRoot', el);
        if (root) el.router('/', root, {}, {
            pushState: true
        });
    },
    onCreate: (el, s)=>$7db76810d7ffb9ae$var$_loadInstances(s.root),
    AdminSidebar: {},
    AdminMain: {
        extends: 'AppMain',
        padding: '0',
        Header: {
            extends: 'PageHeader',
            LeftGroup: {
                BackLink: {
                    tag: 'button',
                    type: 'button',
                    padding: '0',
                    background: 'transparent',
                    border: 'none',
                    color: 'caption',
                    fontSize: 'Z2',
                    cursor: 'pointer',
                    text: "\u2190 Integrations",
                    onClick: (e, el, s)=>{
                        const root = el.call('findRouteRoot', el);
                        if (root) el.router('/admin/integrations', root);
                    }
                },
                Title: {
                    text: 'npm registry'
                }
            },
            RightGroup: {
                AddBtn: {
                    tag: 'button',
                    type: 'button',
                    padding: 'Z A',
                    round: 'Y',
                    background: 'blue',
                    color: 'white',
                    fontSize: 'Z2',
                    fontWeight: '700',
                    cursor: 'pointer',
                    border: 'none',
                    text: '+ Add scope',
                    onClick: (e, el, s)=>{
                        s.root.update({
                            _newNpmDraft: {
                                slug: '',
                                displayName: '',
                                scope: '',
                                registryUrl: 'https://registry.npmjs.org',
                                alwaysAuth: 'true',
                                token: ''
                            },
                            _npmFormOpen: true
                        });
                    }
                }
            }
        },
        Body: {
            overflow: 'auto',
            padding: 'B',
            flow: 'y',
            gap: 'A',
            Hint: {
                tag: 'p',
                fontSize: 'Z2',
                color: 'caption',
                margin: '0',
                text: 'Store one publish token per scope. Editor CMS reads these when exporting/publishing projects; CI reads them when running `npm publish`.'
            },
            NewForm: {
                extends: 'NpmNewForm'
            },
            Instances: {
                extends: 'NpmInstanceList'
            }
        }
    }
};
const $7db76810d7ffb9ae$export$a53afd0a98c97c9 = {
    hide: (el, s)=>!s.root?._npmFormOpen,
    flow: 'y',
    gap: 'Z1',
    round: 'Z1',
    background: 'overlay',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'blue',
    padding: 'A',
    Title: {
        tag: 'h3',
        fontSize: 'A',
        fontWeight: '700',
        color: 'title',
        margin: '0',
        text: 'Add npm scope'
    },
    Fields: {
        flow: 'y',
        gap: 'Z1',
        childExtends: 'NpmField',
        childrenAs: 'state',
        children: ()=>[
                {
                    label: 'Display name',
                    placeholder: '@symbo.ls prod token',
                    draftKey: 'displayName'
                },
                {
                    label: 'Slug',
                    placeholder: 'symbols-prod',
                    draftKey: 'slug'
                },
                {
                    label: "Scope (@org \u2014 required)",
                    placeholder: '@symbo.ls',
                    draftKey: 'scope'
                },
                {
                    label: 'Registry URL',
                    placeholder: 'https://registry.npmjs.org',
                    draftKey: 'registryUrl'
                }
            ]
    },
    ScopePicker: {
        extends: 'IntegrationScopePicker',
        draftKey: '_newNpmDraft',
        defaultScopeType: $7db76810d7ffb9ae$var$DEFAULT_SCOPE
    },
    Token: {
        flow: 'y',
        gap: 'V',
        Label: {
            tag: 'label',
            fontSize: 'Y2',
            color: 'caption',
            fontWeight: '700',
            text: "npm token (required \u2014 written to Vault)"
        },
        Textarea: {
            tag: 'textarea',
            rows: '2',
            width: '100%',
            padding: 'Z',
            round: 'Y',
            background: 'document',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'line',
            color: 'title',
            fontFamily: 'mono',
            fontSize: 'Z2',
            placeholder: 'npm_...',
            onInput: (e, el, s)=>{
                s.root.update({
                    _newNpmDraft: {
                        ...s.root?._newNpmDraft || {},
                        token: e.target.value
                    }
                });
            }
        },
        Hint: {
            tag: 'p',
            fontSize: 'Y2',
            color: 'caption',
            margin: '0',
            text: 'Create with `npm token create --type=automation --cidr=0.0.0.0/0`. Scope tokens allow publishing to a specific org.'
        }
    },
    Actions: {
        flow: 'x',
        gap: 'Z',
        align: 'center flex-end',
        marginTop: 'Z',
        CancelBtn: {
            tag: 'button',
            type: 'button',
            padding: 'V Z',
            round: 'Y',
            background: 'transparent',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'line',
            color: 'title',
            cursor: 'pointer',
            fontSize: 'Y2',
            text: 'Cancel',
            onClick: (e, el, s)=>{
                s.root.update({
                    _npmFormOpen: false,
                    _newNpmDraft: null
                });
            }
        },
        SaveBtn: {
            tag: 'button',
            type: 'button',
            padding: 'V A',
            round: 'Y',
            background: 'blue',
            color: 'white',
            fontSize: 'Y2',
            fontWeight: '700',
            cursor: 'pointer',
            border: 'none',
            text: 'Save',
            onClick: async (e, el, s)=>{
                const orgId = s.root?.jwtClaims?.workspace_org_id;
                const draft = s.root?._newNpmDraft || {};
                if (!orgId) return;
                if (!draft.scope || !draft.token) {
                    el.call('openNotification', {
                        title: 'Scope and token required',
                        type: 'error'
                    });
                    return;
                }
                const slug = $7db76810d7ffb9ae$var$_slugify(draft.slug || draft.scope.replace(/^@/, ''));
                const scope = el.call('resolveScope', draft, $7db76810d7ffb9ae$var$DEFAULT_SCOPE);
                if (scope.scopeType !== 'org' && !scope.scopeId) {
                    el.call('openNotification', {
                        title: 'Scope target required',
                        message: `Select a ${scope.scopeType} or switch scope to Org.`,
                        type: 'error'
                    });
                    return;
                }
                const { ok: ok, body: body } = await (0, $e92gD.saveIntegration)({
                    orgId: orgId,
                    kind: $7db76810d7ffb9ae$var$KIND,
                    slug: slug,
                    scopeType: scope.scopeType,
                    scopeId: scope.scopeId,
                    displayName: draft.displayName || draft.scope,
                    secret: draft.token,
                    config: {
                        scope: draft.scope,
                        registry_url: draft.registryUrl || 'https://registry.npmjs.org',
                        always_auth: draft.alwaysAuth || 'true',
                        display_name: draft.displayName || draft.scope
                    },
                    enabled: true
                });
                if (ok) {
                    s.root.update({
                        _npmFormOpen: false,
                        _newNpmDraft: null
                    });
                    await $7db76810d7ffb9ae$var$_loadInstances(s.root);
                    el.call('openNotification', {
                        title: 'Scope added',
                        type: 'success'
                    });
                } else el.call('openNotification', {
                    title: 'Save failed',
                    message: body?.error || 'Server error',
                    type: 'error'
                });
            }
        }
    }
};
const $7db76810d7ffb9ae$export$d420685026a9cc4d = {
    flow: 'y',
    gap: 'V',
    Label: {
        tag: 'label',
        fontSize: 'Y2',
        color: 'caption',
        fontWeight: '700',
        text: (el, s)=>s.label
    },
    Input: {
        tag: 'input',
        type: 'text',
        width: '100%',
        padding: 'Z',
        round: 'Y',
        background: 'document',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'line',
        color: 'title',
        fontSize: 'Z2',
        placeholder: (el, s)=>s.placeholder || '',
        value: (el, s)=>{
            const draft = s.root?._newNpmDraft || {};
            return draft[s.draftKey] || '';
        },
        onInput: (e, el, s)=>{
            s.root.update({
                _newNpmDraft: {
                    ...s.root?._newNpmDraft || {},
                    [s.draftKey]: e.target.value
                }
            });
        }
    }
};
const $7db76810d7ffb9ae$export$7a9e79820bc79fc7 = {
    flow: 'y',
    gap: 'A',
    childExtends: 'NpmInstanceCard',
    childrenAs: 'state',
    children: (el, s)=>{
        const list = s.root?._integrationHub?.integrations || [];
        return list.filter((i)=>i.kind === $7db76810d7ffb9ae$var$KIND);
    },
    EmptyState: {
        hide: (el, s)=>{
            const list = s.root?._integrationHub?.integrations || [];
            return list.filter((i)=>i.kind === $7db76810d7ffb9ae$var$KIND).length > 0;
        },
        padding: 'B',
        round: 'Z1',
        background: 'overlay',
        borderWidth: '1px',
        borderStyle: 'dashed',
        borderColor: 'line',
        textAlign: 'center',
        color: 'caption',
        fontSize: 'Z2',
        text: 'No npm scopes configured. Add one to unlock publish in the editor and CI.'
    }
};
const $7db76810d7ffb9ae$export$3772e36ab95f18f = {
    round: 'Z1',
    background: 'overlay',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'line',
    padding: 'A',
    flow: 'x',
    align: 'center space-between',
    gap: 'Z',
    Left: {
        flow: 'x',
        align: 'center',
        gap: 'Z1',
        Icon: {
            icon: 'npm',
            boxSize: 'A'
        },
        Info: {
            flow: 'y',
            gap: 'V',
            Name: {
                tag: 'span',
                fontSize: 'A',
                fontWeight: '700',
                color: 'title',
                text: (el, s)=>s.display_name || s.config?.scope || s.slug
            },
            Meta: {
                tag: 'span',
                fontSize: 'Y2',
                color: 'caption',
                text: (el, s)=>`scope: ${s.config?.scope || "\u2014"} \xb7 registry: ${s.config?.registry_url || 'default'}`
            }
        }
    },
    Right: {
        flow: 'x',
        gap: 'Z',
        StatusPill: {
            tag: 'span',
            padding: 'V Z',
            round: 'Y',
            fontSize: 'Y1',
            fontWeight: '700',
            background: (el, s)=>s.enabled && s.has_secret ? 'green' : 'overlayStrong',
            color: (el, s)=>s.enabled && s.has_secret ? 'white' : 'caption',
            text: (el, s)=>{
                if (!s.has_secret) return 'Missing token';
                return s.enabled ? 'Live' : 'Disabled';
            }
        },
        RemoveBtn: {
            tag: 'button',
            type: 'button',
            padding: 'V Z',
            round: 'Y',
            background: 'transparent',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'line',
            color: 'red',
            fontSize: 'Y2',
            cursor: 'pointer',
            text: 'Remove',
            onClick: async (e, el, s)=>{
                if (!window.confirm(`Remove ${s.display_name || s.slug}? Publish from this scope will fail until re-added.`)) return;
                const orgId = s.root?.jwtClaims?.workspace_org_id;
                const { ok: ok } = await (0, $e92gD.deleteIntegration)({
                    orgId: orgId,
                    kind: $7db76810d7ffb9ae$var$KIND,
                    slug: s.slug,
                    scopeType: s.scope_type || 'org',
                    scopeId: s.scope_id || null
                });
                if (ok) {
                    await $7db76810d7ffb9ae$var$_loadInstances(s.root);
                    el.call('openNotification', {
                        title: 'Removed',
                        type: 'success'
                    });
                }
            }
        }
    }
};

});

parcelRegister("fTOLm", function(module, exports) {

$parcel$export(module.exports, "adminIntegrationsGeneric", () => $b9335e8b4fdfb23b$export$52a74edb3bf5070);
// Admin → Integrations → Generic kind detail page.
//
// Handles any integration kind that has a `config_schema.fields` spec in
// `integration_kinds` and doesn't need a hand-crafted page. Currently used
// for: google_analytics, n8n, custom_http, openai, livekit — and any
// future kind added to the catalogue.
//
// Kind is derived from the current route path:
//   /admin/integrations/n8n              → kind='n8n'
//   /admin/integrations/google_analytics → kind='google_analytics'
//   /admin/integrations/openai           → kind='openai'
//   /admin/integrations/livekit          → kind='livekit'
//   /admin/integrations/custom_http      → kind='custom_http'
//
// allows_multiple=true  → instances list + "Add" flow
// allows_multiple=false → single config card shown inline

var $e92gD = parcelRequire("e92gD");
// resolveScope, GenericIntNewForm, GenericIntConfigField, and
// GenericIntInstanceCard all live in workspace/packages/shared and are
// auto-picked-up via sharedLibraries. saveIntegration/deleteIntegration/
// callCapability moved into the shared form file with the components.
// Derive the integration kind string from the last segment of the
// current path. The only special-case reversal needed: the hand-crafted
// pages own 'supabase', 'github', 'google', 'npm' — this page handles
// everything else as a 1:1 slug↔kind mapping.
const $b9335e8b4fdfb23b$var$_kindFromRoot = (root)=>{
    const path = root?.currentPath || '';
    const m = path.match(/^\/admin\/integrations\/([^?#/]+)/);
    return m ? m[1] : null;
};
const $b9335e8b4fdfb23b$var$_kindRow = (root)=>{
    const kind = $b9335e8b4fdfb23b$var$_kindFromRoot(root);
    if (!kind) return null;
    return (root?._integrationHub?.kinds || []).find((k)=>k.kind === kind) || null;
};
// Human-readable overrides for kind slugs whose label needs brand casing
// that a simple title-case can't produce (OpenAI vs Openai, n8n vs N8N, etc.)
const $b9335e8b4fdfb23b$var$_KIND_LABEL_OVERRIDES = {
    openai: 'OpenAI',
    livekit: 'LiveKit',
    n8n: 'n8n',
    custom_http: 'Custom HTTP',
    google_analytics: 'Google Analytics'
};
// Prefer the catalogue's `label` when loaded; fall back to a formatted
// slug so the browser tab + page header never show the raw `google_analytics`.
// If the catalogue's label is missing OR equals the slug (bad data), use
// the override map / title-case the slug instead.
const $b9335e8b4fdfb23b$var$_kindLabel = (root)=>{
    const kind = $b9335e8b4fdfb23b$var$_kindFromRoot(root);
    const row = $b9335e8b4fdfb23b$var$_kindRow(root);
    const rowLabel = row?.label;
    if (rowLabel && rowLabel !== kind) return rowLabel;
    if (!kind) return 'Integration';
    if ($b9335e8b4fdfb23b$var$_KIND_LABEL_OVERRIDES[kind]) return $b9335e8b4fdfb23b$var$_KIND_LABEL_OVERRIDES[kind];
    return kind.split('_').map((w)=>w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
};
const $b9335e8b4fdfb23b$var$_instances = (root)=>{
    const kind = $b9335e8b4fdfb23b$var$_kindFromRoot(root);
    if (!kind) return [];
    return (root?._integrationHub?.integrations || []).filter((i)=>i.kind === kind);
};
// Fire once per path after the catalogue is loaded AND the install flag
// is in the URL. Guard keyed by kind slug so visiting `?install=1` for
// a different kind still triggers auto-open. The `_genericIntFormOpen`
// check prevents overwriting when the user already opened the form
// manually between navigation and catalogue load.
const $b9335e8b4fdfb23b$var$_applyInstallParamIfReady = (root)=>{
    if (typeof window === 'undefined') return;
    const kind = $b9335e8b4fdfb23b$var$_kindFromRoot(root);
    if (!kind || root._installAppliedFor === kind) return;
    const params = new URLSearchParams(window.location.search);
    if (params.get('install') !== '1') return;
    const row = $b9335e8b4fdfb23b$var$_kindRow(root);
    if (!row) return;
    if (root._genericIntFormOpen) {
        root._installAppliedFor = kind;
        return;
    }
    root.update({
        _installAppliedFor: kind,
        _genericIntFormOpen: true,
        [$b9335e8b4fdfb23b$var$_draftKey]: {
            scopeType: params.get('scopeType') || row.default_scope || 'org',
            scopeId: params.get('scopeId') || null
        }
    });
};
const $b9335e8b4fdfb23b$var$_loadInstances = async (root)=>{
    const orgId = root?.jwtClaims?.workspace_org_id;
    if (!orgId) {
        if (!root._genericIntWatcher) {
            const started = Date.now();
            root._genericIntWatcher = setInterval(()=>{
                if (root?.jwtClaims?.workspace_org_id) {
                    clearInterval(root._genericIntWatcher);
                    root._genericIntWatcher = null;
                    $b9335e8b4fdfb23b$var$_loadInstances(root);
                } else if (Date.now() - started > 30000) {
                    clearInterval(root._genericIntWatcher);
                    root._genericIntWatcher = null;
                }
            }, 1000);
        }
        return;
    }
    const data = await (0, $e92gD.loadIntegrationCatalogue)(orgId);
    root.update({
        _integrationHub: data
    });
    $b9335e8b4fdfb23b$var$_applyInstallParamIfReady(root);
};
const $b9335e8b4fdfb23b$var$_draftKey = '_genericIntDraft';
const $b9335e8b4fdfb23b$export$52a74edb3bf5070 = {
    extends: 'AppPage',
    metadata: (el, s)=>({
            title: $b9335e8b4fdfb23b$var$_kindLabel(s.root) + ' / Integrations / Symbols Workspace'
        }),
    onInit: (el, s)=>{
        if (el.call('shouldRedirectNonAdmin', s)) {
            const root = el.call('findRouteRoot', el);
            if (root) el.router('/', root, {}, {
                pushState: true
            });
        }
    },
    onCreate: (el, s)=>$b9335e8b4fdfb23b$var$_loadInstances(s.root),
    AdminSidebar: {},
    AdminMain: {
        extends: 'AppMain',
        padding: '0',
        Header: {
            extends: 'PageHeader',
            LeftGroup: {
                BackLink: {
                    tag: 'button',
                    type: 'button',
                    padding: '0',
                    background: 'transparent',
                    border: 'none',
                    color: 'caption',
                    fontSize: 'Z2',
                    cursor: 'pointer',
                    text: "\u2190 Integrations",
                    onClick: (e, el, s)=>{
                        const root = el.call('findRouteRoot', el);
                        if (root) el.router('/admin/integrations', root);
                    }
                },
                Title: {
                    text: (el, s)=>$b9335e8b4fdfb23b$var$_kindLabel(s.root)
                }
            },
            RightGroup: {
                AddBtn: {
                    tag: 'button',
                    type: 'button',
                    hide: (el, s)=>{
                        const kr = $b9335e8b4fdfb23b$var$_kindRow(s.root);
                        // Hide if single-slot and already configured
                        if (!kr?.allows_multiple && $b9335e8b4fdfb23b$var$_instances(s.root).length > 0) return true;
                        // Hide if form is already open
                        return !!s.root?._genericIntFormOpen;
                    },
                    padding: 'Z A',
                    round: 'Y',
                    background: 'blue',
                    color: 'white',
                    fontSize: 'Z2',
                    fontWeight: '700',
                    cursor: 'pointer',
                    border: 'none',
                    text: (el, s)=>$b9335e8b4fdfb23b$var$_kindRow(s.root)?.allows_multiple ? '+ Add another' : '+ Configure',
                    onClick: (e, el, s)=>{
                        s.root.update({
                            _genericIntFormOpen: true,
                            [$b9335e8b4fdfb23b$var$_draftKey]: {
                                scopeType: $b9335e8b4fdfb23b$var$_kindRow(s.root)?.default_scope || 'org',
                                scopeId: null
                            }
                        });
                    }
                }
            }
        },
        Body: {
            overflow: 'auto',
            padding: 'B',
            flow: 'y',
            gap: 'A',
            Hint: {
                tag: 'p',
                fontSize: 'Z2',
                color: 'caption',
                margin: '0',
                lineHeight: '1.5',
                text: (el, s)=>$b9335e8b4fdfb23b$var$_kindRow(s.root)?.description || ''
            },
            CapsBadges: {
                flow: 'x',
                gap: 'V',
                flexWrap: 'wrap',
                children: (el, s)=>{
                    const caps = $b9335e8b4fdfb23b$var$_kindRow(s.root)?.capabilities || [];
                    return caps.map((c)=>({
                            cap: c
                        }));
                },
                childrenAs: 'state',
                childExtends: {
                    tag: 'span',
                    padding: 'V Z',
                    round: 'Y',
                    fontSize: 'Y1',
                    fontWeight: '700',
                    background: 'overlayStrong',
                    color: 'caption',
                    text: (el, s)=>s.cap || ''
                }
            },
            GenericIntNewForm: {},
            SingleSlotHint: {
                hide: (el, s)=>{
                    const kr = $b9335e8b4fdfb23b$var$_kindRow(s.root);
                    if (!kr) return true;
                    // Show only for single-slot with no instances and form closed
                    return kr.allows_multiple || $b9335e8b4fdfb23b$var$_instances(s.root).length > 0 || !!s.root?._genericIntFormOpen;
                },
                tag: 'p',
                fontSize: 'Z2',
                color: 'caption',
                margin: '0',
                text: (el, s)=>{
                    const kr = $b9335e8b4fdfb23b$var$_kindRow(s.root);
                    return `No ${kr?.label || 'integration'} configured yet. Click "+ Configure" to set it up.`;
                }
            },
            InstanceList: {
                flow: 'y',
                gap: 'Z1',
                hide: (el, s)=>$b9335e8b4fdfb23b$var$_instances(s.root).length === 0,
                childExtends: 'GenericIntInstanceCard',
                childrenAs: 'state',
                children: (el, s)=>$b9335e8b4fdfb23b$var$_instances(s.root)
            }
        }
    }
};

});

parcelRegister("8SCVM", function(module, exports) {

$parcel$export(module.exports, "McpConnectorAdminCard", () => $677190bbde07bbe0$export$530bca6d0b1cc06d);
$parcel$export(module.exports, "AdminMcpConnectors", () => $677190bbde07bbe0$export$c135f1efbf077746);
$parcel$export(module.exports, "adminIntegrationsMcp", () => $677190bbde07bbe0$export$e1d36167d88de9ca);
// Admin → Integrations → MCP Connectors.
//
// Lists all MCP connectors scoped to the active workspace (from the
// mcp_connectors Supabase table). Supports install (opens MCPConnectorPickerOverlay
// state), disable / re-enable, capability re-discovery, and delete.
//
// Data flow:
//   - `_loadConnectors(root)` pulls mcp_connectors via sdk-bridge/mcp.js.
//   - Results stored in root._mcpConnectors.
//   - MCPConnectorPickerOverlay is mounted at the canvas root — we reuse
//     root._mcpConnectorPickerOpen + root._mcpConnectorDraft state keys.

var $arUsX = parcelRequire("arUsX");
const $677190bbde07bbe0$var$_loadConnectors = async (root)=>{
    if (!root?.jwtClaims?.workspace_org_id) {
        if (!root._mcpAdminWatcher) root._mcpAdminWatcher = setInterval(()=>{
            if (root?.jwtClaims?.workspace_org_id) {
                clearInterval(root._mcpAdminWatcher);
                root._mcpAdminWatcher = null;
                $677190bbde07bbe0$var$_loadConnectors(root);
            }
        }, 300);
        return;
    }
    const { data: data, error: error } = await (0, $arUsX.listConnectors)({});
    root.update({
        _mcpConnectors: data || [],
        _mcpConnectorsError: error || null
    });
};
const $677190bbde07bbe0$var$_toast = (el, payload)=>{
    try {
        el.call('openNotification', payload);
    } catch (err) {
        console.warn('[mcp-admin]', payload.title, err);
    }
};
const $677190bbde07bbe0$export$530bca6d0b1cc06d = {
    flow: 'y',
    gap: 'Z',
    padding: 'A',
    round: 'Z1',
    background: 'overlay',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'line',
    Header: {
        flow: 'x',
        align: 'center space-between',
        Left: {
            flow: 'x',
            gap: 'Z',
            align: 'center',
            Name: {
                tag: 'span',
                fontSize: 'A',
                fontWeight: '700',
                color: 'title',
                text: (el, s)=>s.name || s.url || ''
            },
            IntegrationScopeBadge: {
                scope_type: (el, s)=>s.scope_type,
                scope_id: (el, s)=>s.scope_id
            }
        },
        Right: {
            flow: 'x',
            gap: 'Z',
            align: 'center',
            StatusPill: {
                tag: 'span',
                padding: 'V Z',
                round: 'Y',
                fontSize: 'Y1',
                fontWeight: '700',
                background: (el, s)=>s.status === 'enabled' ? 'cerulean.1' : 'overlayStrong',
                color: (el, s)=>s.status === 'enabled' ? 'cerulean' : 'caption',
                text: (el, s)=>s.status === 'enabled' ? 'Live' : 'Disabled'
            },
            DiscoverBtn: {
                tag: 'button',
                type: 'button',
                padding: 'V Z',
                round: 'Y',
                background: 'transparent',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: 'line',
                color: 'title',
                fontSize: 'Y2',
                cursor: 'pointer',
                text: 'Re-discover',
                title: 'Re-run tools/list + resources/list',
                onClick: async (e, el, s)=>{
                    const { ok: ok, error: error } = await (0, $arUsX.discoverCapabilities)(s.id);
                    if (ok) {
                        await $677190bbde07bbe0$var$_loadConnectors(s.root);
                        $677190bbde07bbe0$var$_toast(el, {
                            title: 'Capabilities refreshed',
                            type: 'success'
                        });
                    } else $677190bbde07bbe0$var$_toast(el, {
                        title: 'Discovery failed',
                        message: error,
                        type: 'error'
                    });
                }
            },
            ToggleBtn: {
                tag: 'button',
                type: 'button',
                padding: 'V Z',
                round: 'Y',
                background: 'transparent',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: 'line',
                color: 'title',
                fontSize: 'Y2',
                cursor: 'pointer',
                text: (el, s)=>s.status === 'enabled' ? 'Disable' : 'Enable',
                onClick: async (e, el, s)=>{
                    const fn = s.status === 'enabled' ? (0, $arUsX.disableConnector) : (0, $arUsX.enableConnector);
                    const { ok: ok, error: error } = await fn(s.id);
                    if (ok) {
                        await $677190bbde07bbe0$var$_loadConnectors(s.root);
                        $677190bbde07bbe0$var$_toast(el, {
                            title: s.status === 'enabled' ? 'Disabled' : 'Enabled',
                            type: 'success'
                        });
                    } else $677190bbde07bbe0$var$_toast(el, {
                        title: 'Update failed',
                        message: error,
                        type: 'error'
                    });
                }
            },
            DeleteBtn: {
                tag: 'button',
                type: 'button',
                padding: 'V Z',
                round: 'Y',
                background: 'transparent',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: 'line',
                color: 'red',
                fontSize: 'Y2',
                cursor: 'pointer',
                text: 'Disconnect',
                onClick: async (e, el, s)=>{
                    if (!window.confirm(`Disconnect "${s.name || s.url}"?`)) return;
                    const { ok: ok, error: error } = await (0, $arUsX.deleteConnector)(s.id);
                    if (ok) {
                        await $677190bbde07bbe0$var$_loadConnectors(s.root);
                        $677190bbde07bbe0$var$_toast(el, {
                            title: 'Disconnected',
                            type: 'success'
                        });
                    } else $677190bbde07bbe0$var$_toast(el, {
                        title: 'Delete failed',
                        message: error,
                        type: 'error'
                    });
                }
            }
        }
    },
    Meta: {
        flow: 'y',
        gap: 'V',
        UrlRow: {
            flow: 'x',
            gap: 'Z',
            fontSize: 'Y2',
            Label: {
                color: 'caption',
                text: 'URL',
                minWidth: '80px'
            },
            Value: {
                color: 'title',
                text: (el, s)=>s.url || ''
            }
        },
        TransportRow: {
            flow: 'x',
            gap: 'Z',
            fontSize: 'Y2',
            Label: {
                color: 'caption',
                text: 'Transport',
                minWidth: '80px'
            },
            Value: {
                color: 'title',
                text: (el, s)=>s.transport || 'sse'
            }
        },
        AuthRow: {
            flow: 'x',
            gap: 'Z',
            fontSize: 'Y2',
            Label: {
                color: 'caption',
                text: 'Auth',
                minWidth: '80px'
            },
            Value: {
                color: 'title',
                text: (el, s)=>s.auth_kind || 'none'
            }
        }
    },
    CapabilitiesSection: {
        flow: 'y',
        gap: 'V',
        hide: (el, s)=>{
            const caps = s.capabilities || {};
            return !caps.tools?.length && !caps.resources?.length;
        },
        CapLabel: {
            tag: 'span',
            fontSize: 'Y2',
            fontWeight: '700',
            color: 'caption',
            text: 'Capabilities'
        },
        ToolsList: {
            flow: 'x',
            gap: 'V',
            flexWrap: 'wrap',
            hide: (el, s)=>!s.capabilities?.tools?.length,
            childrenAs: 'state',
            children: (el, s)=>(s.capabilities?.tools || []).map((t)=>({
                        name: t.name || t
                    })),
            childExtends: {
                tag: 'span',
                padding: 'V Z',
                round: 'Y',
                fontSize: 'Y1',
                background: 'cerulean.1',
                color: 'cerulean',
                text: (el, s)=>s.name
            }
        }
    }
};
const $677190bbde07bbe0$export$c135f1efbf077746 = {
    flow: 'y',
    gap: 'A',
    padding: 'A',
    onRender: (el, s)=>$677190bbde07bbe0$var$_loadConnectors(s.root),
    PageHeader: {
        flow: 'x',
        align: 'center space-between',
        marginBottom: 'V',
        Left: {
            flow: 'y',
            gap: 'V',
            Title: {
                tag: 'h2',
                fontSize: 'B',
                fontWeight: '700',
                color: 'title',
                margin: '0',
                text: 'MCP Connectors'
            },
            Subtitle: {
                tag: 'p',
                fontSize: 'Z2',
                color: 'caption',
                margin: '0',
                text: 'Remote MCP servers available to canvas AI agents as tool providers.'
            }
        },
        AddBtn: {
            tag: 'button',
            type: 'button',
            padding: 'V A',
            round: 'Y',
            background: 'blue',
            color: 'white',
            fontSize: 'Y2',
            fontWeight: '700',
            cursor: 'pointer',
            border: 'none',
            text: '+ New MCP connector',
            onClick: (e, el, s)=>{
                s.root?.update({
                    _mcpConnectorPickerOpen: true,
                    _mcpConnectorDraft: {
                        transport: 'sse',
                        authKind: 'none',
                        scopeType: 'workspace',
                        scopeId: null
                    }
                });
            }
        }
    },
    // MCP connector picker overlay — auto-extended by key name from the
    // canvas components package (MCPConnectorPickerOverlay).
    MCPConnectorPickerOverlay: {},
    ErrorBanner: {
        hide: (el, s)=>!s.root?._mcpConnectorsError,
        padding: 'V A',
        round: 'Y',
        background: 'red.1',
        color: 'red',
        fontSize: 'Z2',
        text: (el, s)=>`Could not load connectors: ${s.root?._mcpConnectorsError || ''}`
    },
    EmptyState: {
        hide: (el, s)=>!!(s.root?._mcpConnectors || []).length,
        flow: 'y',
        gap: 'A',
        align: 'center center',
        padding: 'E A',
        borderWidth: '1px',
        borderStyle: 'dashed',
        borderColor: 'line',
        round: 'Z1',
        Icon: {
            tag: 'span',
            fontSize: 'D',
            text: "\u26A1",
            opacity: '0.35'
        },
        EmptyTitle: {
            tag: 'h3',
            fontSize: 'A',
            fontWeight: '700',
            color: 'title',
            margin: '0',
            text: 'No MCP connectors yet'
        },
        EmptyHint: {
            tag: 'p',
            fontSize: 'Z2',
            color: 'caption',
            margin: '0',
            textAlign: 'center',
            text: 'Connect the Symbols MCP server or any other MCP-compatible server to give canvas AI agents access to tools and resources.'
        },
        ConnectSymbols: {
            tag: 'button',
            type: 'button',
            padding: 'V A',
            round: 'Y',
            background: 'cerulean',
            color: 'white',
            fontSize: 'Y2',
            fontWeight: '700',
            cursor: 'pointer',
            border: 'none',
            text: 'Connect Symbols MCP',
            onClick: (e, el, s)=>{
                s.root?.update({
                    _mcpConnectorPickerOpen: true,
                    _mcpConnectorDraft: {
                        name: 'Symbols MCP',
                        url: 'https://mcp.symbols.app',
                        transport: 'sse',
                        authKind: 'oauth',
                        scopeType: 'workspace',
                        scopeId: null
                    }
                });
            }
        }
    },
    ConnectorList: {
        flow: 'y',
        gap: 'A',
        childExtends: 'McpConnectorAdminCard',
        childrenAs: 'state',
        children: (el, s)=>(s.root?._mcpConnectors || []).map((c)=>({
                    ...c,
                    key: c.id
                }))
    }
};
const $677190bbde07bbe0$export$e1d36167d88de9ca = {
    extends: 'AppPage',
    metadata: {
        title: 'MCP Connectors / Integrations / Symbols Workspace'
    },
    onInit: (el, s)=>{
        if (!el.call('shouldRedirectNonAdmin', s)) return;
        const root = el.call('findRouteRoot', el);
        if (root) el.router('/', root, {}, {
            pushState: true
        });
    },
    onCreate: (el, s)=>$677190bbde07bbe0$var$_loadConnectors(s.root),
    AdminSidebar: {},
    AdminMain: {
        extends: 'AppMain',
        padding: '0',
        Header: {
            extends: 'PageHeader',
            LeftGroup: {
                BackLink: {
                    tag: 'button',
                    type: 'button',
                    padding: '0',
                    background: 'transparent',
                    border: 'none',
                    color: 'caption',
                    fontSize: 'Z2',
                    cursor: 'pointer',
                    text: "\u2190 Integrations",
                    onClick: (e, el, s)=>{
                        const root = el.call('findRouteRoot', el);
                        if (root) el.router('/admin/integrations', root, {}, {
                            pushState: true
                        });
                    }
                },
                Title: {
                    tag: 'h1',
                    text: 'MCP Connectors',
                    fontSize: 'B',
                    fontWeight: '700',
                    color: 'title',
                    margin: '0'
                }
            }
        },
        Body: {
            extends: 'AdminMcpConnectors'
        }
    }
};

});
parcelRegister("arUsX", function(module, exports) {

$parcel$export(module.exports, "listConnectors", () => $79b839ff50c2edaf$export$5c32629e639be49f);
$parcel$export(module.exports, "installConnector", () => $79b839ff50c2edaf$export$d9238261bf4fae2d);
$parcel$export(module.exports, "discoverCapabilities", () => $79b839ff50c2edaf$export$2624c843b5958ba7);
$parcel$export(module.exports, "enableConnector", () => $79b839ff50c2edaf$export$ee79419b4f8ae98c);
$parcel$export(module.exports, "disableConnector", () => $79b839ff50c2edaf$export$934ad11716cb70c8);
$parcel$export(module.exports, "deleteConnector", () => $79b839ff50c2edaf$export$8fc5777482cc8024);
// MCP connector SDK bridge — client-side wrappers for the mcp_connectors
// Supabase table. All writes go through the governance Supabase REST API;
// secrets (auth tokens) are written server-side via integration_secrets and
// referenced by auth_secret_id FK — they never travel through the browser
// in plain text.
//
// Runtime contract: JSON-RPC 2.0 over SSE / WebSocket / HTTP transport.
// Capability discovery (tools/list + resources/list) runs server-side on
// install and is cached in the `capabilities` jsonb column.
//
// Supabase RLS: every call requires the user's governance JWT; rows are
// filtered by jwt_active_workspace() so a user only ever sees their own
// workspace's connectors.

var $3WCJD = parcelRequire("3WCJD");

var $8RlGv = parcelRequire("8RlGv");
const $79b839ff50c2edaf$var$_gov = ()=>(0, $8RlGv.getClient)((0, $8RlGv.PROJECT_GOVERNANCE));
// ── Helpers ───────────────────────────────────────────────────────────────────
const $79b839ff50c2edaf$var$_getAccessToken = async ()=>{
    if (typeof window === 'undefined') return null;
    const token = window.localStorage.getItem('symbols_bridge_access_token') || window.localStorage.getItem('symbols_access_token') || null;
    return token;
};
// Resolves via @symbo.ls/channels: SYMBOLS_API_URL > channel name
// (NODE_ENV) > defaultChannel ('next').
const $79b839ff50c2edaf$var$_serverBase = ()=>{
    try {
        return (0, $3WCJD.apiUrl)().replace(/\/+$/, '');
    } catch  {
        return 'https://next.api.symbols.app';
    }
};
const $79b839ff50c2edaf$var$_serverFetch = async (path, { method: method = 'GET', body: body } = {})=>{
    const token = await $79b839ff50c2edaf$var$_getAccessToken();
    if (!token) return {
        error: 'not authenticated'
    };
    try {
        const res = await fetch(`${$79b839ff50c2edaf$var$_serverBase()}${path}`, {
            method: method,
            headers: {
                Authorization: `Bearer ${token}`,
                ...body ? {
                    'Content-Type': 'application/json'
                } : {}
            },
            body: body ? JSON.stringify(body) : undefined
        });
        const json = await res.json().catch(()=>null);
        if (!res.ok) return {
            error: json?.error || `HTTP ${res.status}`,
            status: res.status
        };
        return json || {
            error: 'empty response'
        };
    } catch (err) {
        return {
            error: err?.message || 'network error'
        };
    }
};
const $79b839ff50c2edaf$export$5c32629e639be49f = async ({ scopeType: scopeType, scopeId: scopeId } = {})=>{
    const client = $79b839ff50c2edaf$var$_gov();
    if (!client) return {
        data: [],
        error: 'sdk-bridge not configured'
    };
    let q = client.from('mcp_connectors').select('*').order('created_at', {
        ascending: true
    });
    if (scopeType) q = q.eq('scope_type', scopeType);
    if (scopeId != null) q = q.eq('scope_id', scopeId);
    const { data: data, error: error } = await q;
    return {
        data: data || [],
        error: error?.message || null
    };
};
const $79b839ff50c2edaf$export$d9238261bf4fae2d = async ({ workspaceId: workspaceId, scopeType: scopeType = 'workspace', scopeId: scopeId = null, name: name, url: url, transport: transport = 'sse', authKind: authKind = 'none', authToken: authToken })=>{
    if (!workspaceId) return {
        ok: false,
        error: 'workspaceId required'
    };
    if (!url) return {
        ok: false,
        error: 'url required'
    };
    if (!name) return {
        ok: false,
        error: 'name required'
    };
    // Route through the server endpoint so it can store the secret in Vault
    // and run capability discovery without exposing the token to the DB.
    const result = await $79b839ff50c2edaf$var$_serverFetch('/core/mcp-connectors', {
        method: 'POST',
        body: {
            workspaceId: workspaceId,
            scopeType: scopeType,
            scopeId: scopeId,
            name: name,
            url: url,
            transport: transport,
            authKind: authKind,
            authToken: authToken
        }
    });
    if (result.error) return {
        ok: false,
        error: result.error
    };
    return {
        ok: true,
        data: result
    };
};
const $79b839ff50c2edaf$export$2624c843b5958ba7 = async (connectorId)=>{
    if (!connectorId) return {
        ok: false,
        error: 'connectorId required'
    };
    const result = await $79b839ff50c2edaf$var$_serverFetch(`/core/mcp-connectors/${connectorId}/discover`, {
        method: 'POST'
    });
    if (result.error) return {
        ok: false,
        error: result.error
    };
    return {
        ok: true,
        capabilities: result.capabilities || result
    };
};
const $79b839ff50c2edaf$export$ee79419b4f8ae98c = async (connectorId)=>{
    const client = $79b839ff50c2edaf$var$_gov();
    if (!client) return {
        ok: false,
        error: 'sdk-bridge not configured'
    };
    const { error: error } = await client.from('mcp_connectors').update({
        status: 'enabled'
    }).eq('id', connectorId);
    return error ? {
        ok: false,
        error: error.message
    } : {
        ok: true
    };
};
const $79b839ff50c2edaf$export$934ad11716cb70c8 = async (connectorId)=>{
    const client = $79b839ff50c2edaf$var$_gov();
    if (!client) return {
        ok: false,
        error: 'sdk-bridge not configured'
    };
    const { error: error } = await client.from('mcp_connectors').update({
        status: 'disabled'
    }).eq('id', connectorId);
    return error ? {
        ok: false,
        error: error.message
    } : {
        ok: true
    };
};
const $79b839ff50c2edaf$export$8fc5777482cc8024 = async (connectorId)=>{
    const client = $79b839ff50c2edaf$var$_gov();
    if (!client) return {
        ok: false,
        error: 'sdk-bridge not configured'
    };
    const { error: error } = await client.from('mcp_connectors').delete().eq('id', connectorId);
    return error ? {
        ok: false,
        error: error.message
    } : {
        ok: true
    };
};

});


parcelRegister("9wOaP", function(module, exports) {

$parcel$export(module.exports, "adminStatus", () => $6efe05ab4d6c2eef$export$f8962bbdeaf05652);
$parcel$export(module.exports, "AdminStatusSection", () => $6efe05ab4d6c2eef$export$54cc9c3be24f7836);
$parcel$export(module.exports, "AdminStatusRow", () => $6efe05ab4d6c2eef$export$61dbfd7ac2d74eaf);
// Health dashboard — single-page operational view of the federation,
// feature flags, registered Supabase projects, vault status, and
// per-org integration config. First stop when rolling out a flip or
// tracking down a "why isn't X working" report.
//
// All checks are non-destructive and run once per mount. Status rows
// render red/green/neutral based on probe results; clicking any row
// copies its diagnostic payload to clipboard for sharing in a bug
// report.

var $82gA2 = parcelRequire("82gA2");

var $e92gD = parcelRequire("e92gD");

var $bfqVY = parcelRequire("bfqVY");

var $bdIjZ = parcelRequire("bdIjZ");
// ─── probes ────────────────────────────────────────────────────────────────
const $6efe05ab4d6c2eef$var$_probeEdgeFunction = async (projectUrl, fnName)=>{
    // OPTIONS returns 200 if the function exists + CORS preflight works,
    // 404 if the function isn't deployed, network error if the project is
    // unreachable entirely.
    //
    // TODO[sdk-edge-health]: there's no SDK method for direct CORS preflight
    // probes — this is admin-tooling that bypasses the auth/tenant model
    // intentionally to surface raw edge-function reachability. If/when the
    // workspace wrapper exposes a /system/edge-health admin route, replace
    // with `getSDK().execute('workspaceProject', 'rpc', { fn: fnName })`.
    try {
        const res = await fetch(`${projectUrl}/functions/v1/${fnName}`, {
            method: 'OPTIONS'
        });
        return {
            ok: res.status < 500,
            status: res.status
        };
    } catch (err) {
        return {
            ok: false,
            status: 0,
            error: err?.message
        };
    }
};
// migrated 2026-04-27 — was _probeTable(sb, 'profiles'). Routed through
// SDK system.status which returns aggregated reachability info for the
// workspace tenant tables (profiles, org_integrations, etc.).
const $6efe05ab4d6c2eef$var$_probeSystemStatus = async ()=>{
    try {
        const result = await (0, $bfqVY.getSDK)().execute('workspaceProject.system', 'status');
        const data = result?.data || result || {};
        // The wrapper returns { tables: { profiles: { count, ok, error } }, ... }
        // Surface the profiles slice for backwards-compat with the existing UI.
        const profiles = data?.tables?.profiles || data?.profiles || null;
        return profiles ? {
            ok: profiles.ok ?? !profiles.error,
            error: profiles.error,
            count: profiles.count ?? null
        } : {
            ok: true,
            error: null,
            count: data?.count ?? null
        };
    } catch (err) {
        return {
            ok: false,
            error: err?.message,
            count: null
        };
    }
};
// migrated 2026-04-27 — was _probeOrgIntegrations(sb, orgId). Routed through
// the existing sdk-bridge loadIntegrationCatalogue helper which calls Mongo
// /org-integrations.
const $6efe05ab4d6c2eef$var$_probeOrgIntegrations = async (orgId)=>{
    if (!orgId) return {
        ok: false,
        rows: [],
        error: 'no active org'
    };
    try {
        const data = await (0, $e92gD.loadIntegrationCatalogue)(orgId);
        const rows = (data?.integrations || []).map((i)=>({
                kind: i.kind,
                enabled: i.enabled,
                secrets_ref: i.has_secret ? 'present' : null,
                updated_at: i.updated_at
            }));
        return {
            ok: true,
            rows: rows,
            error: null
        };
    } catch (err) {
        return {
            ok: false,
            rows: [],
            error: err?.message
        };
    }
};
// Orchestrator. Fires all probes in parallel, hydrates root state once.
const $6efe05ab4d6c2eef$var$_runAllProbes = async (root)=>{
    const claims = root?.jwtClaims || {};
    const activeOrgId = claims.workspace_org_id || null;
    root.update({
        _statusProbingAt: new Date().toISOString()
    });
    const [govBridge, govAdminOps, govHook, finBridge, finAdminOps, profilesCount, orgIntegrations] = await Promise.all([
        $6efe05ab4d6c2eef$var$_probeEdgeFunction((0, $82gA2.RAW_URL), 'symbols-auth-bridge'),
        $6efe05ab4d6c2eef$var$_probeEdgeFunction((0, $82gA2.RAW_URL), 'symbols-admin-ops'),
        $6efe05ab4d6c2eef$var$_probeEdgeFunction((0, $82gA2.RAW_URL), 'custom-access-token-hook'),
        $6efe05ab4d6c2eef$var$_probeEdgeFunction('https://bxhdvzwmvptgksqfkgqp.supabase.co', 'symbols-auth-bridge'),
        $6efe05ab4d6c2eef$var$_probeEdgeFunction('https://bxhdvzwmvptgksqfkgqp.supabase.co', 'symbols-admin-ops'),
        $6efe05ab4d6c2eef$var$_probeSystemStatus(),
        $6efe05ab4d6c2eef$var$_probeOrgIntegrations(activeOrgId)
    ]);
    root.update({
        _statusProbes: {
            govBridge: govBridge,
            govAdminOps: govAdminOps,
            govHook: govHook,
            finBridge: finBridge,
            finAdminOps: finAdminOps,
            profilesCount: profilesCount,
            orgIntegrations: orgIntegrations
        },
        _statusProbingAt: null
    });
};
// ─── page ──────────────────────────────────────────────────────────────────
const $6efe05ab4d6c2eef$var$_flags = ()=>[
        {
            key: 'USE_MULTITENANT',
            value: (0, $bdIjZ.USE_MULTITENANT),
            unblocks: 'Phase 3 migrations + workspace RLS'
        },
        {
            key: 'USE_FINANCIALS_PROJECT',
            value: (0, $bdIjZ.USE_FINANCIALS_PROJECT),
            unblocks: 'reads grants from financials'
        },
        {
            key: 'DUAL_WRITE_FINANCIALS',
            value: (0, $bdIjZ.DUAL_WRITE_FINANCIALS),
            unblocks: 'mirrors grant writes to financials'
        },
        {
            key: 'USE_PROFILES_OVERLAY',
            value: (0, $bdIjZ.USE_PROFILES_OVERLAY),
            unblocks: 'profile writes mirror to public.profiles'
        },
        {
            key: 'USE_ONBOARDING_GATE',
            value: (0, $bdIjZ.USE_ONBOARDING_GATE),
            unblocks: 'no-team-org users see onboarding CTA'
        }
    ];
const $6efe05ab4d6c2eef$export$f8962bbdeaf05652 = {
    extends: 'AppPage',
    metadata: {
        title: 'Status / Admin / Symbols Workspace'
    },
    onInit: (el, s)=>{
        if (!el.call('shouldRedirectNoPerm', s, 'admin.pages.read')) return;
        const root = el.call('findRouteRoot', el);
        if (root) el.router('/', root, {}, {
            pushState: true
        });
    },
    onCreate: (el, s)=>$6efe05ab4d6c2eef$var$_runAllProbes(s.root),
    AdminSidebar: {},
    AdminMain: {
        extends: 'AppMain',
        padding: '0',
        Header: {
            extends: 'PageHeader',
            LeftGroup: {
                Title: {
                    text: 'Status'
                }
            },
            RightGroup: {
                Refresh: {
                    tag: 'button',
                    type: 'button',
                    padding: 'V Z',
                    round: 'Y',
                    border: 'none',
                    background: 'overlay',
                    color: 'title',
                    fontSize: 'Y2',
                    cursor: 'pointer',
                    text: (el, s)=>s.root._statusProbingAt ? "Probing\u2026" : 'Refresh',
                    onClick: (e, el, s)=>$6efe05ab4d6c2eef$var$_runAllProbes(s.root)
                }
            }
        },
        Body: {
            overflow: 'auto',
            padding: 'B',
            flow: 'y',
            gap: 'A',
            Section_Flags: {
                extends: 'AdminStatusSection',
                title: 'Feature flags',
                Rows: {
                    childExtends: 'AdminStatusRow',
                    childrenAs: 'state',
                    children: ()=>$6efe05ab4d6c2eef$var$_flags().map((f)=>({
                                label: f.key,
                                value: f.value ? 'on' : 'off',
                                tone: f.value ? 'green' : 'caption',
                                hint: f.unblocks
                            }))
                }
            },
            Section_Projects: {
                extends: 'AdminStatusSection',
                title: 'Supabase projects',
                Rows: {
                    childExtends: 'AdminStatusRow',
                    childrenAs: 'state',
                    children: (el, s)=>{
                        const p = s.root?._statusProbes || {};
                        return [
                            {
                                label: 'governance / symbols-auth-bridge',
                                value: p.govBridge ? `${p.govBridge.status}` : "\u2014",
                                tone: p.govBridge?.ok ? 'green' : 'red',
                                hint: 'Login fan-out endpoint'
                            },
                            {
                                label: 'governance / symbols-admin-ops',
                                value: p.govAdminOps ? `${p.govAdminOps.status}` : "\u2014",
                                tone: p.govAdminOps?.ok ? 'green' : 'red',
                                hint: 'HMAC-gated admin operations'
                            },
                            {
                                label: 'governance / custom-access-token-hook',
                                value: p.govHook ? `${p.govHook.status}` : "\u2014",
                                tone: p.govHook?.ok ? 'green' : 'caption',
                                hint: 'Dormant until Supabase Pro'
                            },
                            {
                                label: 'financials / symbols-auth-bridge',
                                value: p.finBridge ? `${p.finBridge.status}` : "\u2014",
                                tone: p.finBridge?.ok ? 'green' : 'red',
                                hint: 'Extension auth bridge'
                            },
                            {
                                label: 'financials / symbols-admin-ops',
                                value: p.finAdminOps ? `${p.finAdminOps.status}` : "\u2014",
                                tone: p.finAdminOps?.ok ? 'green' : 'red',
                                hint: 'Extension admin operations'
                            }
                        ];
                    }
                }
            },
            Section_Schema: {
                extends: 'AdminStatusSection',
                title: 'Schema / data',
                Rows: {
                    childExtends: 'AdminStatusRow',
                    childrenAs: 'state',
                    children: (el, s)=>{
                        const p = s.root?._statusProbes || {};
                        return [
                            {
                                label: 'public.profiles',
                                value: p.profilesCount ? `${p.profilesCount.count ?? '?'} rows` : "\u2014",
                                tone: p.profilesCount?.ok ? 'green' : 'red',
                                hint: p.profilesCount?.error || 'HR overlay (migration 0052)'
                            },
                            {
                                label: 'public.org_integrations (current org)',
                                value: p.orgIntegrations ? `${p.orgIntegrations.rows?.length ?? 0} entries` : "\u2014",
                                tone: p.orgIntegrations?.ok ? 'green' : 'caption',
                                hint: p.orgIntegrations?.error || 'Per-org integration rows'
                            }
                        ];
                    }
                }
            },
            Section_Claims: {
                extends: 'AdminStatusSection',
                title: 'Session claims',
                Rows: {
                    childExtends: 'AdminStatusRow',
                    childrenAs: 'state',
                    children: (el, s)=>{
                        const c = s.root?.jwtClaims || {};
                        return [
                            {
                                label: 'symbols_user_id',
                                value: c.symbols_user_id || "\u2014",
                                tone: c.symbols_user_id ? 'title' : 'caption'
                            },
                            {
                                label: 'symbols_role',
                                value: c.symbols_role || "\u2014",
                                tone: c.symbols_role ? 'green' : 'caption'
                            },
                            {
                                label: 'orgs',
                                value: `${(c.orgs || []).length} entries`,
                                tone: (c.orgs || []).length ? 'green' : 'red',
                                hint: "Server \xa7A populates this"
                            },
                            {
                                label: 'workspaces',
                                value: `${(c.workspaces || []).length} entries`,
                                tone: (c.workspaces || []).length ? 'green' : 'red',
                                hint: 'Drives workspace switcher'
                            },
                            {
                                label: 'active_workspace_id',
                                value: c.active_workspace_id || "\u2014",
                                tone: c.active_workspace_id ? 'title' : 'caption'
                            },
                            {
                                label: 'workspace_role',
                                value: c.workspace_role || "\u2014",
                                tone: c.workspace_role ? 'title' : 'caption'
                            },
                            {
                                label: 'workspace_tier',
                                value: c.workspace_tier || "\u2014",
                                tone: c.workspace_tier ? 'green' : 'caption',
                                hint: 'Drives tier gates'
                            }
                        ];
                    }
                }
            }
        }
    }
};
const $6efe05ab4d6c2eef$export$54cc9c3be24f7836 = {
    round: 'Z1',
    background: 'overlay',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'line',
    padding: 'A',
    flow: 'y',
    gap: 'Z',
    Title: {
        tag: 'h2',
        fontSize: 'Z',
        fontWeight: '700',
        color: 'title',
        margin: '0',
        text: (el)=>el.title || 'Section'
    },
    Rows: {
        flow: 'y',
        gap: 'V'
    }
};
const $6efe05ab4d6c2eef$export$61dbfd7ac2d74eaf = {
    flow: 'x',
    align: 'center space-between',
    gap: 'Z1',
    padding: 'V 0',
    borderBottom: '1px solid var(--color-line)',
    cursor: 'pointer',
    ':last-child': {
        borderBottom: 'none'
    },
    onClick: (e, el, s)=>{
        // Copy the label + value for bug reports.
        const line = `${s.label}: ${s.value}${s.hint ? ` (${s.hint})` : ''}`;
        try {
            navigator.clipboard?.writeText(line);
            el.call('openNotification', {
                title: 'Copied',
                message: line,
                type: 'success'
            });
        } catch  {}
    },
    Left: {
        flow: 'y',
        gap: 'V',
        Label: {
            tag: 'span',
            fontSize: 'Z2',
            fontWeight: '600',
            color: 'title',
            text: (el, s)=>s.label
        },
        Hint: {
            hide: (el, s)=>!s.hint,
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            text: (el, s)=>s.hint
        }
    },
    Value: {
        tag: 'span',
        fontSize: 'Z2',
        fontWeight: '600',
        color: (el, s)=>s.tone || 'title',
        text: (el, s)=>s.value
    }
};

});

parcelRegister("dLzC2", function(module, exports) {

$parcel$export(module.exports, "capTable", () => $a05b4a0bcaa4fa5b$export$1d170fc6e8125965);
parcelRequire("chzVb");

var $bfqVY = parcelRequire("bfqVY");
const $a05b4a0bcaa4fa5b$var$TOTAL = 10000000;
const $a05b4a0bcaa4fa5b$var$ROUNDS = {
    1250000: 'Founding',
    2500000: 'Pre-seed',
    12500000: 'Seed'
};
const $a05b4a0bcaa4fa5b$var$_valOf = (s)=>s?.root?.companySettings?.current_valuation || 12000000;
const $a05b4a0bcaa4fa5b$var$_pct = (n)=>n > 0 ? (n / $a05b4a0bcaa4fa5b$var$TOTAL * 100).toFixed(2) + '%' : '0%';
const $a05b4a0bcaa4fa5b$var$_valAt = (shares, s)=>shares > 0 ? '$' + Math.round(shares / $a05b4a0bcaa4fa5b$var$TOTAL * $a05b4a0bcaa4fa5b$var$_valOf(s)).toLocaleString() : "\u2014";
const $a05b4a0bcaa4fa5b$var$_fmt = (n)=>n != null && n > 0 ? Number(n).toLocaleString() : "\u2014";
const $a05b4a0bcaa4fa5b$var$_fetchCapData = async (s)=>{
    // Group grants by user. Users with a single grant collapse into one row
    // (parent = grant). Users with multiple grants get a summary parent row
    // + hidden sub-rows (one per grant) that expand on click.
    const people = s.root?.people || [];
    const grants = s.root?.userGrants || [];
    const rows = [];
    const grantsByUser = new Map();
    for (const g of grants){
        if (!grantsByUser.has(g.user_id)) grantsByUser.set(g.user_id, []);
        grantsByUser.get(g.user_id).push(g);
    }
    for (const p of people){
        const userGrants = grantsByUser.get(p.userId) || [];
        if (userGrants.length <= 1) {
            const g = userGrants[0] || {};
            rows.push({
                ...p,
                ...g,
                class: g.share_class || p.share_class || 'B',
                _profileEmail: p.email,
                _grantId: g.id
            });
            continue;
        }
        // Multi-grant user: emit a parent summary + sub-rows.
        const totals = userGrants.reduce((a, g)=>({
                shares: a.shares + (g.shares || 0),
                vested: a.vested + (g.vested_shares || 0),
                salary: a.salary + (Number(g.salary_monthly) || 0),
                investment: a.investment + (Number(g.investment) || 0)
            }), {
            shares: 0,
            vested: 0,
            salary: 0,
            investment: 0
        });
        const earliestStart = userGrants.map((g)=>g.vesting_start).filter(Boolean).sort()[0] || null;
        const latestEnd = userGrants.map((g)=>g.vesting_end).filter(Boolean).sort().slice(-1)[0] || null;
        // Parent status: 'left' only if every grant is 'left'; otherwise
        // 'active' (effective status — active vs completed — derives from the
        // aggregated end date in _effectiveStatus).
        const allLeft = userGrants.every((g)=>g.status === 'left');
        // Total span in months (earliest start → latest end) for the Vesting column
        const totalMonths = earliestStart && latestEnd ? Math.round((new Date(latestEnd) - new Date(earliestStart)) / 2630016000) : null;
        rows.push({
            ...p,
            class: userGrants[0].share_class || p.share_class || 'B',
            _profileEmail: p.email,
            _isParent: true,
            _grantCount: userGrants.length,
            shares: totals.shares,
            vested_shares: totals.vested,
            salary_monthly: totals.salary || null,
            investment: totals.investment || null,
            vesting_start: earliestStart,
            vesting_end: latestEnd,
            vesting_months: totalMonths,
            status: allLeft ? 'left' : 'active'
        });
        for (const g of userGrants)rows.push({
            ...p,
            ...g,
            class: g.share_class || p.share_class || 'B',
            _profileEmail: p.email,
            _grantId: g.id,
            _parentUserId: p.userId,
            _isSub: true
        });
    }
    // Two-phase sort: parents/singles sorted by shares desc; sub-rows stay
    // immediately after their parent (not shuffled by share count).
    const parents = rows.filter((r)=>!r._isSub).sort((a, b)=>(b.shares || 0) - (a.shares || 0));
    const subsByParent = new Map();
    for (const r of rows.filter((r)=>r._isSub)){
        if (!subsByParent.has(r._parentUserId)) subsByParent.set(r._parentUserId, []);
        subsByParent.get(r._parentUserId).push(r);
    }
    const ordered = [];
    for (const p of parents){
        ordered.push(p);
        if (p._isParent && subsByParent.has(p.userId)) ordered.push(...subsByParent.get(p.userId));
    }
    s.root.update({
        capTable: ordered,
        capLoaded: true,
        capEditMode: false
    });
};
const $a05b4a0bcaa4fa5b$var$_saveRow = async (row)=>{
    if (!row.user_id) return;
    await (0, $bfqVY.getSDK)().execute('workspaceProject.userProfiles', 'update', {
        id: row.user_id,
        payload: {
            shares: row.shares,
            salary_monthly: row.salary_monthly,
            vesting_start: row.vesting_start,
            vesting_end: row.vesting_end,
            vesting_months: row.vesting_months,
            status: row.status
        }
    });
};
const $a05b4a0bcaa4fa5b$var$_vestBar = (shares, vested)=>{
    if (!shares || shares <= 0) return "\u2014";
    const pct = Math.min(100, Math.round((vested || 0) / shares * 100));
    return `${$a05b4a0bcaa4fa5b$var$_fmt(vested)} (${pct}%)`;
};
// ── Shared row style — all rows use this base ──
const $a05b4a0bcaa4fa5b$var$_rowBase = {
    flow: 'x',
    align: 'center',
    gap: 'Z',
    childProps: {
        flex: '1',
        padding: 'Z V',
        fontSize: 'Z2',
        minWidth: '0'
    }
};
// Vested cell shared by _capRow and AdvisorSection — two-line readout:
// exact share count (green) + % of granted (caption). Returns '—' for rows
// that don't vest (investments; passed through as `isInv` check upstream).
const $a05b4a0bcaa4fa5b$var$_vestedCell = {
    textAlign: 'right',
    flow: 'y',
    gap: '0',
    align: 'center right',
    VestedShares: {
        tag: 'span',
        fontSize: 'Z2',
        fontWeight: '600',
        color: 'green',
        text: (el, s)=>$a05b4a0bcaa4fa5b$var$_fmt(s.vested_shares || 0)
    },
    VestedPct: {
        tag: 'span',
        fontSize: 'Y1',
        color: 'caption',
        text: (el, s)=>{
            if (!s.shares) return '';
            const pct = Math.min(100, Math.round((s.vested_shares || 0) / s.shares * 100));
            return `${pct}%`;
        }
    }
};
// ── Header row builder ──
const $a05b4a0bcaa4fa5b$var$_headerRow = (cols)=>{
    const obj = {
        ...$a05b4a0bcaa4fa5b$var$_rowBase,
        borderBottomWidth: '1px',
        borderBottomStyle: 'solid',
        borderBottomColor: 'line',
        childProps: {
            ...$a05b4a0bcaa4fa5b$var$_rowBase.childProps,
            fontWeight: '700',
            letterSpacing: '.04em',
            textTransform: 'uppercase',
            color: 'caption',
            fontSize: 'Y1'
        }
    };
    cols.forEach((c, i)=>{
        obj[`H${String(i).padStart(2, '0')}`] = {
            ...c === 'Name' ? {
                flex: '2'
            } : {},
            textAlign: [
                'Shares',
                'Equity',
                'Value',
                'Invested',
                'Monthly',
                'Vested',
                'Origin valuation'
            ].includes(c) ? 'right' : 'left',
            text: c
        };
    });
    return obj;
};
// Status derivation (end date wins over DB status):
//   end date in the past      → 'completed' — contract ran its course
//   DB status='left' (no date or future end) → 'ended' — terminated early
//   otherwise                 → 'active'
const $a05b4a0bcaa4fa5b$var$_effectiveStatus = (s)=>{
    const end = s.vesting_end;
    if (end) {
        const endTs = new Date(end).getTime();
        if (!Number.isNaN(endTs) && endTs < Date.now()) return 'completed';
    }
    if (s.status === 'left') return 'ended';
    return 'active';
};
const $a05b4a0bcaa4fa5b$var$_statusLabel = (v)=>v === 'active' ? 'Active' : v === 'ended' ? 'Ended' : v === 'completed' ? 'Completed' : v === 'left' ? 'Ended' : v || "\u2014";
const $a05b4a0bcaa4fa5b$var$_statusColor = (v)=>v === 'active' ? 'green' : v === 'completed' ? 'blue' : 'red';
const $a05b4a0bcaa4fa5b$var$_StatusPill = {
    tag: 'span',
    alignSelf: 'center',
    justifySelf: 'flex-start',
    padding: 'V Z',
    round: 'V',
    fontSize: 'Y2',
    fontWeight: '700',
    textTransform: 'uppercase',
    letterSpacing: '.04em',
    width: 'fit-content',
    background: (el, s)=>`${$a05b4a0bcaa4fa5b$var$_statusColor($a05b4a0bcaa4fa5b$var$_effectiveStatus(s))}.15`,
    color: (el, s)=>$a05b4a0bcaa4fa5b$var$_statusColor($a05b4a0bcaa4fa5b$var$_effectiveStatus(s)),
    text: (el, s)=>$a05b4a0bcaa4fa5b$var$_statusLabel($a05b4a0bcaa4fa5b$var$_effectiveStatus(s))
};
// ── Data row builder ──
const $a05b4a0bcaa4fa5b$var$_capRow = (classType)=>{
    const row = {
        ...$a05b4a0bcaa4fa5b$var$_rowBase,
        hide: (el, s)=>s._isSub && !(s.root?._capExpanded || {})[s._parentUserId],
        borderBottomWidth: '1px',
        borderBottomStyle: 'solid',
        borderBottomColor: 'line',
        background: (el, s)=>s._isSub ? 'overlay' : 'transparent',
        cursor: 'pointer',
        transition: 'background 100ms ease',
        ':hover': {
            background: 'white.04'
        },
        // Parent rows toggle expansion. Non-parent rows (singletons + sub-rows)
        // open the equity-detail modal showing the exact grant record clicked.
        // To view the full profile, use the "Open profile" button in the modal.
        onClick: (e, el, s)=>{
            if (s.root?.capEditMode) return;
            if (s._isParent) {
                const cur = s.root?._capExpanded || {};
                s.root.update({
                    _capExpanded: {
                        ...cur,
                        [s.userId]: !cur[s.userId]
                    }
                });
                return;
            }
            // Find the full grant record (row state spreads ...p, ...g — so the
            // row already has the grant fields plus the person). Pull the fresh
            // record from root.userGrants so we're not showing a stale snapshot.
            const grant = (s.root?.userGrants || []).find((g)=>g.id === s._grantId);
            if (grant) s.root.update({
                grantDetail: grant
            });
        },
        C01_Name: {
            flex: '2',
            flow: 'x',
            align: 'center left',
            gap: 'Z',
            minWidth: '0',
            paddingLeft: (el, s)=>s._isSub ? 'A1' : 'Z',
            Caret: {
                hide: (el, s)=>!s._isParent,
                tag: 'span',
                fontSize: 'Y2',
                color: 'caption',
                flexShrink: '0',
                transition: 'transform 120ms ease',
                transform: (el, s)=>(s.root?._capExpanded || {})[s.userId] ? 'rotate(90deg)' : 'rotate(0deg)',
                text: "\u25B8"
            },
            NameText: {
                hide: (el, s)=>!!s._isSub,
                tag: 'span',
                fontWeight: '600',
                color: 'title',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                text: (el, s)=>s.name || "\u2014"
            },
            GrantTag: {
                hide: (el, s)=>!s.label || !s._isSub,
                tag: 'span',
                padding: 'V Z',
                round: 'V',
                fontSize: 'Y1',
                fontWeight: '700',
                color: 'caption',
                background: 'overlayStrong',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: 'line',
                flexShrink: '0',
                text: (el, s)=>s.label || ''
            },
            GrantCount: {
                hide: (el, s)=>!s._isParent,
                tag: 'span',
                fontSize: 'Y2',
                color: 'caption',
                flexShrink: '0',
                text: (el, s)=>`\xb7 ${s._grantCount} grants`
            }
        },
        C02_Shares: {
            textAlign: 'right',
            text: (el, s)=>s.root?.capEditMode ? '' : $a05b4a0bcaa4fa5b$var$_fmt(s.shares),
            Input: {
                tag: 'input',
                type: 'number',
                hide: (el, s)=>!s.root?.capEditMode,
                padding: 'Y Z',
                round: 'Y',
                borderWidth: '1px',
                borderColor: 'line',
                borderStyle: 'solid',
                background: 'overlayStrong',
                color: 'title',
                fontSize: 'Y2',
                width: '100%',
                value: (el, s)=>s.shares || 0,
                onInput: (e, el, s)=>{
                    s.shares = parseInt(e.target.value) || 0;
                }
            }
        },
        C03_Equity: {
            textAlign: 'right',
            color: classType === 'A' ? 'blue' : classType === 'B' ? 'green' : classType === 'C' ? 'orange' : 'purple',
            text: (el, s)=>$a05b4a0bcaa4fa5b$var$_pct(s.shares)
        },
        C04_Value: {
            textAlign: 'right',
            color: 'caption',
            text: (el, s)=>$a05b4a0bcaa4fa5b$var$_valAt(s.shares, s)
        }
    };
    // Investment rows carry no vesting schedule — the money bought shares
    // outright. Show '—' across every vesting-related cell for those rows
    // so the table doesn't display bogus 0mo / missing date placeholders.
    const _isInv = (s)=>s.investment != null && !s._isParent;
    if (classType === 'A') {
        row.C05_Invested = {
            textAlign: 'right',
            color: 'caption',
            text: (el, s)=>s.investment ? '$' + $a05b4a0bcaa4fa5b$var$_fmt(s.investment) : "\u2014"
        };
        row.C06_Vesting = {
            color: 'caption',
            text: (el, s)=>_isInv(s) ? "\u2014" : `${s.vesting_months || 0}mo`
        };
    } else if (classType === 'B') row.C05_Monthly = {
        textAlign: 'right',
        color: 'caption',
        text: (el, s)=>s.salary_monthly ? '$' + $a05b4a0bcaa4fa5b$var$_fmt(Math.round(s.salary_monthly)) : "\u2014"
    };
    row.C07_Start = {
        color: 'caption',
        text: (el, s)=>s.root?.capEditMode ? '' : _isInv(s) ? "\u2014" : s.vesting_start?.slice(0, 10) || "\u2014",
        Input: {
            tag: 'input',
            type: 'date',
            hide: (el, s)=>!s.root?.capEditMode || _isInv(s),
            padding: 'Y Z',
            round: 'Y',
            borderWidth: '1px',
            borderColor: 'line',
            borderStyle: 'solid',
            background: 'overlayStrong',
            color: 'title',
            fontSize: 'Y2',
            width: '100%',
            value: (el, s)=>s.vesting_start?.slice(0, 10) || '',
            onInput: (e, el, s)=>{
                s.vesting_start = e.target.value || null;
            }
        }
    };
    row.C08_End = {
        color: 'caption',
        text: (el, s)=>s.root?.capEditMode ? '' : _isInv(s) ? "\u2014" : s.vesting_end?.slice(0, 10) || "\u2014",
        Input: {
            tag: 'input',
            type: 'date',
            hide: (el, s)=>!s.root?.capEditMode || _isInv(s),
            padding: 'Y Z',
            round: 'Y',
            borderWidth: '1px',
            borderColor: 'line',
            borderStyle: 'solid',
            background: 'overlayStrong',
            color: 'title',
            fontSize: 'Y2',
            width: '100%',
            value: (el, s)=>s.vesting_end?.slice(0, 10) || '',
            onInput: (e, el, s)=>{
                s.vesting_end = e.target.value || null;
            }
        }
    };
    row.C09_Vested = {
        ...$a05b4a0bcaa4fa5b$var$_vestedCell,
        VestedShares: {
            ...$a05b4a0bcaa4fa5b$var$_vestedCell.VestedShares,
            color: (el, s)=>_isInv(s) ? 'caption' : 'green',
            text: (el, s)=>_isInv(s) ? "\u2014" : $a05b4a0bcaa4fa5b$var$_fmt(s.vested_shares || 0)
        },
        VestedPct: {
            ...$a05b4a0bcaa4fa5b$var$_vestedCell.VestedPct,
            text: (el, s)=>{
                if (_isInv(s) || !s.shares) return '';
                const pct = Math.min(100, Math.round((s.vested_shares || 0) / s.shares * 100));
                return `${pct}%`;
            }
        }
    };
    row.C10_Status = {
        flow: 'x',
        align: 'center left',
        Pill: {
            hide: (el, s)=>!!s.root?.capEditMode,
            ...$a05b4a0bcaa4fa5b$var$_StatusPill
        },
        Select: {
            tag: 'select',
            hide: (el, s)=>!s.root?.capEditMode,
            padding: 'Y Z',
            round: 'Y',
            borderWidth: '1px',
            borderColor: 'line',
            borderStyle: 'solid',
            background: 'overlayStrong',
            color: 'title',
            fontSize: 'Y2',
            cursor: 'pointer',
            onRender: (el, s)=>{
                if (!el.node) return;
                el.node.innerHTML = '';
                for (const v of [
                    'active',
                    'left'
                ]){
                    const opt = document.createElement('option');
                    opt.value = v;
                    opt.textContent = $a05b4a0bcaa4fa5b$var$_statusLabel(v);
                    if (v === s.status) opt.selected = true;
                    el.node.appendChild(opt);
                }
            },
            onChange: (e, el, s)=>{
                s.status = e.target.value;
            }
        }
    };
    row.C11_Save = {
        hide: (el, s)=>!s.root?.capEditMode,
        SaveBtn: {
            tag: 'button',
            text: 'Save',
            padding: 'Y Z1',
            round: 'Y',
            border: 'none',
            theme: 'primary',
            cursor: 'pointer',
            fontSize: 'Y1',
            fontWeight: '600',
            onClick: async (e, el, s)=>{
                e.stopPropagation();
                await $a05b4a0bcaa4fa5b$var$_saveRow(s);
            }
        }
    };
    return row;
};
// ── Section builder ──
// classFilter may be a string (matches r.class) or a predicate function.
const $a05b4a0bcaa4fa5b$var$_section = (title, cols, classFilter, rowDef)=>{
    const match = typeof classFilter === 'function' ? classFilter : (r)=>r.class === classFilter;
    return {
        flow: 'y',
        round: 'Z2',
        background: 'overlay',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'line',
        padding: 'A',
        Title: {
            tag: 'h2',
            fontSize: 'B',
            fontWeight: '800',
            color: 'title',
            margin: '0 0 Z 0',
            text: (el, s)=>{
                const count = (s.root?.capTable || []).filter((r)=>match(r) && !r._isSub).length;
                return classFilter === 'A' ? title : `${title} (${count})`;
            }
        },
        Header: $a05b4a0bcaa4fa5b$var$_headerRow(cols),
        Rows: {
            flow: 'y',
            childExtends: rowDef,
            childrenAs: 'state',
            children: (el, s)=>(s.root?.capTable || []).filter(match)
        }
    };
};
const $a05b4a0bcaa4fa5b$var$_colsA = [
    'Name',
    'Shares',
    'Equity',
    'Value',
    'Invested',
    'Vesting',
    'Start',
    'End',
    'Vested',
    'Status'
];
const $a05b4a0bcaa4fa5b$var$_colsB = [
    'Name',
    'Shares',
    'Equity',
    'Value',
    'Monthly',
    'Start',
    'End',
    'Vested',
    'Status'
];
// Investors: no Status (all active by definition) — show Origin valuation instead
const $a05b4a0bcaa4fa5b$var$_colsInvestor = [
    'Name',
    'Shares',
    'Equity',
    'Value',
    'Origin valuation'
];
// Advisors vest like staff but without salary — show vesting schedule instead
const $a05b4a0bcaa4fa5b$var$_colsAdvisor = [
    'Name',
    'Shares',
    'Equity',
    'Value',
    'Start',
    'End',
    'Vested',
    'Status'
];
const $a05b4a0bcaa4fa5b$export$1d170fc6e8125965 = {
    extends: 'AppPage',
    metadata: {
        title: 'Cap table / Admin / Symbols Workspace'
    },
    onInit: (el, s)=>{
        if (s.root?.currentUserId && !el.call('isSuperAdmin')) {
            let root = el;
            while(root && !root.routes)root = root.parent;
            if (root) el.router('/admin', root, {}, {
                pushState: true
            });
        }
    },
    onCreate: (el, s)=>{
        let retries = 0;
        const tryLoad = ()=>{
            const hasPeople = (s.root?.people || []).length > 0;
            const hasGrants = (s.root?.userGrants || []).length > 0;
            if (hasPeople && hasGrants) return $a05b4a0bcaa4fa5b$var$_fetchCapData(s);
            if (++retries > 25) {
                if (hasPeople) $a05b4a0bcaa4fa5b$var$_fetchCapData(s);
                return;
            }
            setTimeout(tryLoad, 200);
        };
        tryLoad();
        // Expose the refetch on root so other components (e.g. the modal
        // Save handler) can explicitly rebuild the cap table after they
        // mutate userGrants. DOMQL doesn't auto-call onUpdate on a page
        // element when root state changes, so we need an explicit hook.
        if (s.root) s.root.__refetchCapTable = ()=>$a05b4a0bcaa4fa5b$var$_fetchCapData(s);
    },
    // Any time userGrants changes (e.g. after an edit from /profile) rebuild
    // the cap table so the staff rows reflect the latest grants without a
    // page reload. Gate on a version signature to avoid rebuild loops.
    onUpdate: (el, s)=>{
        if (!s.root?.people?.length) return;
        const grants = s.root?.userGrants || [];
        const sig = grants.length + ':' + grants.map((g)=>`${g.id}:${g.salary_monthly}:${g.vesting_start}:${g.vesting_end}:${g.origin_valuation}:${g.shares_manual}:${g.share_class}:${g.status}`).join('|');
        if (el._lastGrantsSig === sig) return;
        el._lastGrantsSig = sig;
        $a05b4a0bcaa4fa5b$var$_fetchCapData(s);
    },
    AdminSidebar: {},
    CapMain: {
        extends: 'AppMain',
        padding: '0',
        Header: {
            extends: 'PageHeader',
            LeftGroup: {
                Title: {
                    text: 'Cap Table'
                }
            },
            RightGroup: {
                EditToggle: {
                    tag: 'button',
                    type: 'button',
                    padding: 'Z A',
                    round: 'Z',
                    borderWidth: '1px',
                    borderColor: 'line',
                    borderStyle: 'solid',
                    cursor: 'pointer',
                    fontSize: 'Z2',
                    fontWeight: '500',
                    background: (el, s)=>s.root?.capEditMode ? 'blue' : 'overlay',
                    color: (el, s)=>s.root?.capEditMode ? 'white' : 'title',
                    text: (el, s)=>s.root?.capEditMode ? 'Done' : 'Edit',
                    onClick: async (e, el, s)=>{
                        if (s.root?.capEditMode) await $a05b4a0bcaa4fa5b$var$_fetchCapData(s);
                        else s.root.update({
                            capEditMode: true
                        });
                    }
                }
            }
        },
        Body: {
            overflow: 'auto',
            padding: 'B',
            flow: 'y',
            gap: 'B',
            SummaryCard: {
                round: 'Z2',
                background: 'overlay',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: 'line',
                padding: 'B',
                SumTitle: {
                    tag: 'h2',
                    fontSize: 'B',
                    fontWeight: '800',
                    color: 'title',
                    margin: '0 0 Z 0',
                    text: 'Capital Structure'
                },
                SumSub: {
                    tag: 'p',
                    fontSize: 'Y2',
                    color: 'caption',
                    margin: '0 0 A 0',
                    text: "SYMBOLSAPP, INC \u2014 Delaware C-Corp \xb7 10M shares \xb7 Rounds: $1.25M \u2192 $2.5M \u2192 $12.5M"
                },
                Stats: {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(3, 1fr)',
                    gap: 'A',
                    childrenAs: 'state',
                    children: (el, s)=>{
                        // Count parent rows + singletons only (sub-rows are already aggregated into parents)
                        const cap = (s.root?.capTable || []).filter((r)=>!r._isSub);
                        const sumBy = (cls)=>cap.filter((r)=>r.class === cls).reduce((a, r)=>a + (r.shares || 0), 0);
                        const alloc = cap.reduce((a, r)=>a + (r.shares || 0), 0);
                        const invested = cap.reduce((a, r)=>a + (Number(r.investment) || 0), 0);
                        const currentVal = s.root?.companySettings?.current_valuation || 0;
                        return [
                            {
                                label: 'Allocated',
                                value: `${$a05b4a0bcaa4fa5b$var$_fmt(alloc)} (${$a05b4a0bcaa4fa5b$var$_pct(alloc)})`
                            },
                            {
                                label: 'Class A',
                                value: `${$a05b4a0bcaa4fa5b$var$_fmt(sumBy('A'))} (${$a05b4a0bcaa4fa5b$var$_pct(sumBy('A'))})`
                            },
                            {
                                label: 'Class B',
                                value: `${$a05b4a0bcaa4fa5b$var$_fmt(sumBy('B'))} (${$a05b4a0bcaa4fa5b$var$_pct(sumBy('B'))})`
                            },
                            {
                                label: 'Class C',
                                value: `${$a05b4a0bcaa4fa5b$var$_fmt(sumBy('C'))} (${$a05b4a0bcaa4fa5b$var$_pct(sumBy('C'))})`
                            },
                            {
                                label: 'Invested',
                                value: '$' + $a05b4a0bcaa4fa5b$var$_fmt(invested)
                            },
                            {
                                label: 'Current valuation',
                                value: currentVal ? '$' + $a05b4a0bcaa4fa5b$var$_fmt(currentVal) : "\u2014"
                            }
                        ];
                    },
                    childExtends: {
                        flow: 'y',
                        gap: 'Y',
                        padding: 'Z1',
                        round: 'Z',
                        background: 'overlayStrong',
                        Val: {
                            tag: 'span',
                            fontSize: 'A',
                            fontWeight: '800',
                            color: 'title',
                            text: (el, s)=>s.value
                        },
                        Lab: {
                            tag: 'span',
                            fontSize: 'Y2',
                            color: 'caption',
                            fontWeight: '600',
                            text: (el, s)=>s.label
                        }
                    }
                }
            },
            ClassASection: $a05b4a0bcaa4fa5b$var$_section("Founders \xb7 Class A", $a05b4a0bcaa4fa5b$var$_colsA, 'A', $a05b4a0bcaa4fa5b$var$_capRow('A')),
            ClassBSection: $a05b4a0bcaa4fa5b$var$_section("Staff \xb7 Class B", $a05b4a0bcaa4fa5b$var$_colsB, 'B', $a05b4a0bcaa4fa5b$var$_capRow('B')),
            ClassCSection: $a05b4a0bcaa4fa5b$var$_section("Staff \xb7 Class C", $a05b4a0bcaa4fa5b$var$_colsB, 'C', $a05b4a0bcaa4fa5b$var$_capRow('C')),
            // Investor section: any grant with investment set (across all classes).
            // Parents aggregate both grants + investments, so we skip them here and
            // show the individual investment sub-row / singleton instead.
            InvestorSection: $a05b4a0bcaa4fa5b$var$_section('Investors', $a05b4a0bcaa4fa5b$var$_colsInvestor, (r)=>r.investment != null && !r._isParent, {
                ...$a05b4a0bcaa4fa5b$var$_rowBase,
                cursor: 'pointer',
                ':hover': {
                    background: 'overlay'
                },
                onClick: (e, el, s)=>{
                    const grant = (s.root?.userGrants || []).find((g)=>g.id === s._grantId);
                    if (grant) s.root.update({
                        grantDetail: grant
                    });
                },
                C01_Name: {
                    flex: '2',
                    fontWeight: '600',
                    color: 'title',
                    flow: 'x',
                    align: 'center left',
                    gap: 'Z',
                    NameText: {
                        tag: 'span',
                        text: (el, s)=>s.name
                    },
                    ClassTag: {
                        tag: 'span',
                        padding: 'V Z',
                        round: 'V',
                        fontSize: 'Y1',
                        fontWeight: '700',
                        color: 'caption',
                        background: 'overlayStrong',
                        borderWidth: '1px',
                        borderStyle: 'solid',
                        borderColor: 'line',
                        text: (el, s)=>s.share_class || ''
                    }
                },
                C02_Shares: {
                    textAlign: 'right',
                    text: (el, s)=>$a05b4a0bcaa4fa5b$var$_fmt(s.shares)
                },
                C03_Equity: {
                    textAlign: 'right',
                    color: 'purple',
                    text: (el, s)=>$a05b4a0bcaa4fa5b$var$_pct(s.shares)
                },
                C04_Value: {
                    textAlign: 'right',
                    color: 'caption',
                    text: (el, s)=>s.investment ? '$' + $a05b4a0bcaa4fa5b$var$_fmt(s.investment) : "\u2014"
                },
                C05_OriginValuation: {
                    textAlign: 'right',
                    color: 'caption',
                    text: (el, s)=>s.origin_valuation ? '$' + $a05b4a0bcaa4fa5b$var$_fmt(s.origin_valuation) : "\u2014"
                }
            }),
            AdvisorSection: $a05b4a0bcaa4fa5b$var$_section('Advisors', $a05b4a0bcaa4fa5b$var$_colsAdvisor, 'advisor', {
                ...$a05b4a0bcaa4fa5b$var$_rowBase,
                cursor: 'pointer',
                ':hover': {
                    background: 'overlay'
                },
                onClick: (e, el, s)=>{
                    const grant = (s.root?.userGrants || []).find((g)=>g.id === s._grantId);
                    if (grant) s.root.update({
                        grantDetail: grant
                    });
                },
                C01_Name: {
                    flex: '2',
                    fontWeight: '600',
                    color: 'title',
                    text: (el, s)=>s.name
                },
                C02_Shares: {
                    textAlign: 'right',
                    text: (el, s)=>$a05b4a0bcaa4fa5b$var$_fmt(s.shares)
                },
                C03_Equity: {
                    textAlign: 'right',
                    color: 'orange',
                    text: (el, s)=>$a05b4a0bcaa4fa5b$var$_pct(s.shares)
                },
                C04_Value: {
                    textAlign: 'right',
                    color: 'caption',
                    text: (el, s)=>$a05b4a0bcaa4fa5b$var$_valAt(s.shares, s)
                },
                C05_Start: {
                    color: 'caption',
                    text: (el, s)=>s.vesting_start?.slice(0, 10) || "\u2014"
                },
                C06_End: {
                    color: 'caption',
                    text: (el, s)=>s.vesting_end?.slice(0, 10) || "\u2014"
                },
                C07_Vested: $a05b4a0bcaa4fa5b$var$_vestedCell,
                C08_Status: {
                    flow: 'x',
                    align: 'center left',
                    Pill: $a05b4a0bcaa4fa5b$var$_StatusPill
                }
            })
        }
    }
};

});


parcelRegister("4kOC6", function(module, exports) {

$parcel$export(module.exports, "rowToEvent", () => $32804a74db47c68d$export$150323f4a3410297);
$parcel$export(module.exports, "home", () => $32804a74db47c68d$export$d12a05a2da93ee73);
// Convert a UTC instant → the viewer's local YYYY-MM-DD / HH:MM strings.
// All synced rows now carry start_at / end_at as canonical UTC timestamps;
// we shift them to the browser's local timezone here so the calendar grid
// renders the same wall clock the user would see in Google Calendar's web UI.

var $cxvtm = parcelRequire("cxvtm");
parcelRequire("UgXQ6");

var $kZOF8 = parcelRequire("kZOF8");
const $32804a74db47c68d$export$150323f4a3410297 = (r)=>{
    // Prefer the canonical UTC timestamps when present (synced rows). Fall
    // back to the legacy text fields for any rows created before migration
    // 0005 — those are stored in UTC strings already.
    let date = r.date;
    let startTime = r.start_time;
    let endTime = r.end_time;
    let endDate = r.end_date;
    if (r.start_at) {
        const s = new Date(r.start_at);
        date = (0, $cxvtm.localDate)(s);
        startTime = (0, $cxvtm.localTime)(s);
        if (r.end_at) {
            const e = new Date(r.end_at);
            endTime = (0, $cxvtm.localTime)(e);
            const ed = (0, $cxvtm.localDate)(e);
            if (ed !== date) endDate = ed;
        }
    }
    return {
        id: r.id,
        title: r.title,
        date: date,
        startTime: startTime,
        endTime: endTime,
        endDate: endDate,
        startAt: r.start_at || null,
        endAt: r.end_at || null,
        color: r.color,
        type: r.type || 'meeting',
        // `description` and `invitees` are lazy-loaded by fetchEventDetails
        // when the EventDetailModal opens. `r.description` / `r.invitees`
        // are present here when the row came from a detail fetch.
        description: r.description,
        invitees: r.invitees,
        creatorEmail: r.organizer_email,
        googleEventId: r.google_event_id,
        googleCalendarId: r.google_calendar_id
    };
};
// Multiple rows in calendar_events can carry the same google_event_id —
// each represents one attendee's calendar mirror of the same Google event.
// Collapse them so the UI only shows one card per real meeting. Prefer the
// row mirrored from the current user's calendar when available.
const $32804a74db47c68d$var$_dedupeEvents = (rows, currentUserEmail)=>{
    const byId = new Map();
    for (const r of rows){
        const key = r.google_event_id || `local-${r.id}`;
        const existing = byId.get(key);
        if (!existing) {
            byId.set(key, r);
            continue;
        }
        // If the current user owns one of the duplicates, prefer that row.
        if (r.google_calendar_id === currentUserEmail && existing.google_calendar_id !== currentUserEmail) byId.set(key, r);
    }
    return [
        ...byId.values()
    ];
};
const $32804a74db47c68d$export$d12a05a2da93ee73 = {
    extends: 'AppPage',
    metadata: {
        title: 'Calendar / Symbols Workspace'
    },
    // Pull people + events from Supabase on page mount. Both write to root
    // state via the `~/` prefix so all child views see the live data.
    fetch: [
        {
            method: 'select',
            from: 'workspaceProject.calendar',
            // Lean projection — drops `description` (16 KB) and `invitees`
            // (92 KB), which together account for 68% of payload. Both are
            // lazy-loaded by EventDetailModal when an event is opened.
            // The grid views filter by `google_calendar_id` (never fall back
            // to invitees in real data — every event has a sync ID).
            select: 'id,title,date,start_time,end_time,end_date,start_at,end_at,color,type,organizer_email,google_event_id,google_calendar_id',
            // Initial load: ±14 days for fast first paint. Wider window can be
            // fetched on demand when the user navigates to a distant week.
            params: (()=>{
                const min = new Date(Date.now() - 1209600000).toISOString();
                const max = new Date(Date.now() + 1209600000).toISOString();
                return {
                    deleted: false,
                    start_at: {
                        gte: min,
                        lte: max
                    }
                };
            })(),
            order: 'start_at',
            limit: 2000,
            as: '~/events',
            cache: '15s',
            // Element-aware transform: read currentUserEmail off root state so the
            // dedupe step can prefer the row from the viewer's own calendar.
            // Keep one row per (calendar × event). Per-view filters in WeekView /
            // TeamView / TeamNowView slice by `googleCalendarId` so each surface
            // shows the events that actually live on the relevant person's calendar
            // — deleting an event from your own calendar makes it disappear from
            // your "My week", even if the same meeting still lives on a coworker's
            // calendar (where it'll still show in their team-view column).
            transform: (rows)=>({
                    events: (rows || []).map($32804a74db47c68d$export$150323f4a3410297)
                })
        }
    ],
    // v3.14: onUpdate only fires on direct .update() calls, not on root state
    // changes. Hash sync + presence use a lightweight 200ms interval instead.
    // Each callback compares against the last-written value and bails when
    // nothing changed, so the interval is effectively free when idle.
    // Tick the "now" indicator every minute. Pulls from the local timezone so
    // the red line tracks the user's actual current time.
    // Also wires up document-level pointer handlers used for moving and
    // resizing events on the week grid (the per-element listeners only fire
    // when the cursor is still over the element — global capture is needed
    // for smooth drag past edges).
    onCreate: (el, s)=>{
        // Seed the calendar cursor to today on first mount. Without this,
        // `currentYear/Month/Day` are undefined, `getWeekDays(undefined, ...)`
        // resolves via `new Date(NaN)` and the week grid renders empty day
        // headers + empty columns until the user clicks "Today" or a nav arrow.
        const now = new Date();
        if (s.root.currentYear == null || s.root.currentMonth == null || s.root.currentDay == null) s.root.update({
            currentYear: now.getFullYear(),
            currentMonth: now.getMonth(),
            currentDay: now.getDate(),
            viewMode: s.root.viewMode || 'week'
        });
        const tick = ()=>{
            const t = new Date();
            const m = t.getHours() * 60 + t.getMinutes();
            if (s.root.currentMinutes !== m) s.root.update({
                currentMinutes: m
            });
        };
        el._nowTimer = setInterval(tick, 60000);
        // Join the shared online-presence channel. Needs the supabase client
        // wired AND currentUserEmail to have landed via the app_settings
        // fetch. Stash a tryJoinPresence closure on `el` so the page-level
        // onUpdate (which fires whenever any reactive root state lands) can
        // retry until both prerequisites are ready — no polling timer needed.
        el._tryJoinPresence = ()=>{
            if (el._presenceUnsub) return;
            const root = el.state.root;
            if (!root.currentUserEmail || !el.context?.fetch?.client) return;
            el._presenceUnsub = el.call('useOnlinePresence', {
                app: 'calendar'
            });
        };
        el._tryJoinPresence();
        // ── Deep-link state via location.hash ──────────────────────────────────
        // Hash format: #view=week&event=123 / #view=team-now&new=1 /
        // #view=week&profile=foo@bar.com — preserved across reloads.
        const VIEWS = new Set([
            'week',
            'month',
            'team',
            'team-now'
        ]);
        const _parseHash = ()=>{
            const h = (window.location.hash || '').replace(/^#/, '');
            const out = {};
            for (const part of h.split('&').filter(Boolean)){
                const [k, ...rest] = part.split('=');
                out[k] = decodeURIComponent(rest.join('=') || '');
            }
            return out;
        };
        const _writeHash = ()=>{
            const root = el.state.root;
            const parts = [];
            if (root.viewMode && root.viewMode !== 'week') parts.push(`view=${root.viewMode}`);
            else parts.push('view=week');
            // Include selected date so reloading lands on the same day
            const y = root.currentYear;
            const m = root.currentMonth;
            const d = root.currentDay;
            if (y != null && m != null && d != null) {
                const dateStr = `${y}-${String(m + 1).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
                const today = new Date();
                const todayStr = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
                if (dateStr !== todayStr) parts.push(`date=${dateStr}`);
            }
            if (root.showNewBooking) parts.push('new=1');
            else if (root.showEventDetail && root.selectedEvent?.id) parts.push(`event=${root.selectedEvent.id}`);
            else if (root.profileEmail) parts.push(`profile=${encodeURIComponent(root.profileEmail)}`);
            const next = '#' + parts.join('&');
            if (window.location.hash !== next) window.history.replaceState(null, '', next);
        };
        const _applyHash = ()=>{
            const root = el.state.root;
            const q = _parseHash();
            const patch = {};
            const view = q.view && VIEWS.has(q.view) ? q.view : 'week';
            if (root.viewMode !== view) patch.viewMode = view;
            // Restore date from hash
            if (q.date) {
                const [y, m, d] = q.date.split('-').map(Number);
                if (y && m && d) {
                    if (root.currentYear !== y) patch.currentYear = y;
                    if (root.currentMonth !== m - 1) patch.currentMonth = m - 1;
                    if (root.currentDay !== d) patch.currentDay = d;
                }
            }
            if (q.new === '1') {
                if (!root.showNewBooking) patch.showNewBooking = true;
            } else if (q.event) {
                const id = Number(q.event);
                const ev = (root.events || []).find((e)=>e.id === id);
                if (ev) {
                    patch.selectedEvent = ev;
                    patch.showEventDetail = true;
                    if (ev.invitees === undefined) (0, $kZOF8.fetchEventDetails)(id, root);
                } else if (!el._fetchingEvent && (root.events || []).length) {
                    // Event not in loaded ±14-day window — fetch it directly via SDK.
                    el._fetchingEvent = id;
                    const sdk = el.context?.methods?.sdk;
                    const fetchOne = sdk ? sdk.execute('workspaceProject.calendar', 'get', {
                        id: id
                    }).then((row)=>row ? [
                            row
                        ] : []) : Promise.resolve([]);
                    fetchOne.then((rows)=>{
                        el._fetchingEvent = null;
                        if (rows?.length) {
                            const mapped = $32804a74db47c68d$export$150323f4a3410297(rows[0]);
                            root.update({
                                events: [
                                    ...root.events || [],
                                    mapped
                                ],
                                selectedEvent: mapped,
                                showEventDetail: true
                            });
                        }
                    }).catch(()=>{
                        el._fetchingEvent = null;
                    });
                }
            } else if (q.profile) {
                if (root.profileEmail !== q.profile) patch.profileEmail = q.profile;
            } else {
                // No modal in hash → close any open modal that wasn't dismissed
                // through its own button.
                if (root.showNewBooking) patch.showNewBooking = false;
                if (root.showEventDetail) {
                    patch.showEventDetail = false;
                    patch.selectedEvent = null;
                }
                if (root.profileEmail) patch.profileEmail = null;
            }
            if (Object.keys(patch).length) root.update(patch);
        };
        // Initial restore — events haven't loaded yet on first call. Keep
        // re-applying every 200ms until either (a) the targeted event resolves
        // (modal opened), or (b) the hash has no pending modal, or (c) we've
        // tried for 10 seconds. Stops the moment the modal lands so we don't
        // burn CPU forever.
        el._hashRetryAttempts = 0;
        const hashRestoreTick = ()=>{
            _applyHash();
            const root = el.state.root;
            const q = _parseHash();
            const done = q.event && root.showEventDetail || q.new === '1' && root.showNewBooking || q.profile && root.profileEmail === q.profile || !q.event && !q.new && !q.profile;
            el._hashRetryAttempts++;
            if (done || el._hashRetryAttempts > 50) {
                clearInterval(el._hashRestoreTimer);
                el._hashRestoreTimer = null;
            }
        };
        hashRestoreTick();
        el._hashRestoreTimer = setInterval(hashRestoreTick, 200);
        // Browser back/forward → reapply.
        el._onHashChange = ()=>_applyHash();
        window.addEventListener('hashchange', el._onHashChange);
        el._writeHash = _writeHash;
        // v3.14: onUpdate doesn't fire on root state changes, so we poll at 200ms.
        // _writeHash bails immediately when the hash is unchanged, so cost is ~0.
        el._hashSyncTimer = setInterval(()=>{
            _writeHash();
            if (typeof el._tryJoinPresence === 'function') el._tryJoinPresence();
        }, 200);
        const HOUR_PX = 56;
        const findEventNode = (target)=>target?.closest?.('[data-cal-event-id]');
        const snap15 = (mins)=>Math.max(0, Math.min(1425, Math.round(mins / 15) * 15));
        const minsToTime = (m)=>`${String(Math.floor(m / 60)).padStart(2, '0')}:${String(m % 60).padStart(2, '0')}`;
        const timeToMins = (t)=>{
            const [h, m] = t.split(':').map(Number);
            return h * 60 + m;
        };
        // Debounced popover follow — while the user drags the pending slot, the
        // QuickCreate overlay tracks the cursor but no more than every ~50ms so we
        // don't thrash the reactive `top/left` writes on every mousemove tick.
        el._lastFollowAt = 0;
        const FOLLOW_INTERVAL_MS = 50;
        el._rafScheduled = false;
        el._lastEv = null;
        // Look up the column under the cursor without falling back to globals or
        // direct DOM lookups beyond the unavoidable hit-test (`elementFromPoint`).
        const columnDateAt = (clientX, clientY)=>{
            const node = document.elementFromPoint(clientX, clientY)?.closest?.('[data-cal-week-col-date]');
            return node?.dataset?.calWeekColDate || null;
        };
        el._docMousemove = (ev)=>{
            el._lastEv = ev;
            const root = el.state.root;
            // Nothing to do unless one of the three reactive drag flags is set on
            // root state — see WeekView/CalDragPreview/CalWeekEvent for the
            // mousedown handlers that set them.
            if (!root.activeMove && !root.activePendingMove) return;
            if (el._rafScheduled) return;
            el._rafScheduled = true;
            requestAnimationFrame(()=>{
                el._rafScheduled = false;
                const e2 = el._lastEv;
                if (!e2) return;
                _applyDragFrame(e2.clientX, e2.clientY);
            });
        };
        const _applyDragFrame = (clientX, clientY)=>{
            const root = el.state.root;
            // 1. Pending drag-create slot move (after mouseup, before save).
            const pm = root.activePendingMove;
            if (pm) {
                const dp = root.dragPreview;
                if (!dp) root.update({
                    activePendingMove: null
                });
                else {
                    const dyMins = Math.round((clientY - pm.startY) / HOUR_PX * 60);
                    const startMins = timeToMins(pm.origStart);
                    const endMins = timeToMins(pm.origEnd);
                    const duration = endMins - startMins;
                    const newStart = snap15(startMins + dyMins);
                    const newEnd = Math.min(1440, newStart + duration);
                    const newDate = columnDateAt(clientX, clientY) || pm.origDate;
                    const nextStart = minsToTime(newStart);
                    const nextEnd = minsToTime(newEnd);
                    const now = Date.now();
                    const canFollow = now - el._lastFollowAt > FOLLOW_INTERVAL_MS;
                    const timeChanged = dp.date !== newDate || dp.startTime !== nextStart || dp.endTime !== nextEnd;
                    if (timeChanged || canFollow) {
                        if (canFollow) el._lastFollowAt = now;
                        const qc = root.quickCreate;
                        const followedQC = qc && canFollow ? {
                            ...qc,
                            date: newDate,
                            startTime: nextStart,
                            endTime: nextEnd,
                            x: clientX + 12,
                            y: clientY + 12
                        } : qc && timeChanged ? {
                            ...qc,
                            date: newDate,
                            startTime: nextStart,
                            endTime: nextEnd
                        } : qc;
                        root.update({
                            dragPreview: timeChanged ? {
                                ...dp,
                                date: newDate,
                                startTime: nextStart,
                                endTime: nextEnd
                            } : dp,
                            quickCreate: followedQC
                        });
                    }
                }
            }
            // 2. Existing-event move/resize.
            const a = root.activeMove;
            if (!a) return;
            const dyMins = Math.round((clientY - a.startY) / HOUR_PX * 60);
            const startMins = timeToMins(a.origStart);
            const endMins = timeToMins(a.origEnd);
            let newStart, newEnd;
            if (a.mode === 'move') {
                const duration = endMins - startMins;
                newStart = snap15(startMins + dyMins);
                newEnd = Math.min(1440, newStart + duration);
            } else if (a.mode === 'resize-top') {
                newStart = Math.min(snap15(startMins + dyMins), endMins - 15);
                newEnd = endMins;
            } else if (a.mode === 'resize-bottom') {
                newStart = startMins;
                newEnd = Math.max(snap15(endMins + dyMins), startMins + 15);
            }
            const newStartStr = minsToTime(newStart);
            const newEndStr = minsToTime(newEnd);
            const newDate = a.mode === 'move' && columnDateAt(clientX, clientY) || a.origDate;
            const prev = root.dragMove;
            if (prev && prev.id === a.id && prev.date === newDate && prev.startTime === newStartStr && prev.endTime === newEndStr) return;
            // Reactive in-flight feedback. The original event dims via `dragMove`
            // and a per-column ghost (`CalDragMoveGhost`) renders the dashed
            // preview at the new position. No DOM queries, no inline styles.
            root.update({
                dragMove: {
                    id: a.id,
                    date: newDate,
                    startTime: newStartStr,
                    endTime: newEndStr,
                    mode: a.mode
                }
            });
        };
        el._docMouseup = ()=>{
            const root = el.state.root;
            const a = root.activeMove;
            if (root.activePendingMove) root.update({
                activePendingMove: null
            });
            document.body.style.cursor = '';
            if (!a) return;
            // Read the latest in-flight position from `dragMove` so we don't
            // duplicate the cursor math here.
            const dm = root.dragMove;
            const orig = {
                date: a.origDate,
                startTime: a.origStart,
                endTime: a.origEnd
            };
            const next = dm && dm.id === a.id ? {
                date: dm.date,
                startTime: dm.startTime,
                endTime: dm.endTime
            } : orig;
            const noChange = orig.date === next.date && orig.startTime === next.startTime && orig.endTime === next.endTime;
            if (noChange) {
                root.update({
                    activeMove: null,
                    dragMove: null
                });
                return;
            }
            // Clear the live drag flags — the reactive top/height getters on
            // CalWeekEvent take over once we commit to root.events below.
            root.update({
                activeMove: null,
                dragMove: null
            });
            const events = root.events || [];
            const idx = events.findIndex((x)=>x.id === a.id);
            if (idx === -1) return;
            const ev2 = events[idx];
            const me = root.currentUserEmail;
            // Proposals themselves: tweaking a proposal just updates it; commit
            // and skip the prompt logic.
            if (ev2.isProposal) {
                const updatedEvents = events.slice();
                updatedEvents[idx] = {
                    ...ev2,
                    ...next
                };
                root.update({
                    events: updatedEvents
                });
                return;
            }
            const otherInvitees = (ev2.invitees || []).filter((e)=>e && e !== me);
            const isCreator = !ev2.creatorEmail || ev2.creatorEmail === me;
            if (isCreator && otherInvitees.length === 0) {
                // Creator + nobody else involved → commit silently to local + Supabase.
                const updatedEvents = events.slice();
                const movedEv = {
                    ...ev2,
                    ...next
                };
                updatedEvents[idx] = movedEv;
                root.update({
                    events: updatedEvents
                });
                el.call('saveEventToSupabase', movedEv);
                return;
            }
            if (isCreator) {
                // Creator + other participants → ask whether to update outright or
                // propose. Do NOT commit the move yet; the modal's Update/Propose
                // buttons handle the commit so the original stays put until the
                // creator decides.
                root.update({
                    confirmMove: {
                        eventId: ev2.id,
                        orig: orig,
                        next: next
                    }
                });
                return;
            }
            // Non-creator: don't touch the original. Add a proposal duplicate at
            // the new position; it renders with reduced opacity until the creator
            // (or another invitee) accepts it from the event detail modal.
            const proposal = {
                ...ev2,
                ...next,
                id: Date.now(),
                isProposal: true,
                originalEventId: ev2.id,
                proposedBy: me
            };
            root.update({
                events: [
                    ...events,
                    proposal
                ]
            });
            el.call('saveEventToSupabase', proposal).then((realId)=>{
                if (!realId) return;
                root.update({
                    events: (root.events || []).map((e)=>e.id === proposal.id ? {
                            ...e,
                            id: realId
                        } : e)
                });
            });
        };
        document.addEventListener('mousemove', el._docMousemove);
        document.addEventListener('mouseup', el._docMouseup);
    },
    onRemove: (el)=>{
        if (el._nowTimer) clearInterval(el._nowTimer);
        if (el._hashSyncTimer) clearInterval(el._hashSyncTimer);
        if (typeof el._presenceUnsub === 'function') el._presenceUnsub();
        if (el._hashRestoreTimer) clearInterval(el._hashRestoreTimer);
        if (el._onHashChange) window.removeEventListener('hashchange', el._onHashChange);
        if (el._docMousemove) document.removeEventListener('mousemove', el._docMousemove);
        if (el._docMouseup) document.removeEventListener('mouseup', el._docMouseup);
    },
    CalSidebar: {},
    CalMain: {},
    // AI Assistant + ProfileModal are mounted at app level in app.js.
    CalNewBookingModal: {},
    CalConfirmMoveModal: {},
    CalEventDetailModal: {},
    // Person flyout — shared-gov's SharedPersonCard with calendar-
    // specific Actions (Book + Profile). The shared chrome handles
    // positioning + outside-click dismissal; we only customize the
    // bottom-row buttons.
    PersonCard: {
        extends: 'SharedPersonCard',
        Actions: {
            BookBtn: {
                tag: 'button',
                text: 'Book',
                flex: '1',
                padding: 'Z A',
                round: 'Z',
                border: 'none',
                theme: 'primary',
                cursor: 'pointer',
                fontSize: 'Z2',
                fontWeight: '600',
                ':hover': {
                    opacity: '.9'
                },
                onClick: (e, el, s)=>{
                    const person = s.root.selectedPerson;
                    if (!person) return;
                    s.root.update({
                        selectedPerson: null,
                        showNewBooking: true,
                        newBooking: (0, $kZOF8.freshBooking)({
                            title: `Meeting with ${person.name}`,
                            invitees: person.email,
                            type: 'meeting'
                        })
                    });
                }
            },
            ProfileBtn: {
                tag: 'button',
                text: 'Profile',
                flex: '1',
                padding: 'Z A',
                round: 'Z',
                theme: 'secondary',
                borderWidth: '1px',
                borderColor: 'line',
                borderStyle: 'solid',
                cursor: 'pointer',
                fontSize: 'Z2',
                fontWeight: '500',
                ':hover': {
                    background: 'overlay'
                },
                onClick: (e, el, s)=>{
                    const email = s.root.selectedPerson?.email;
                    s.root.update({
                        selectedPerson: null,
                        profileEmail: email
                    });
                }
            }
        }
    },
    CalQuickCreate: {}
};

});

parcelRegister("dqa5T", function(module, exports) {

$parcel$export(module.exports, "myView", () => $9c55888aab104f84$export$a71f1927824bb4cb);
// "My view" — personalised dashboard with the signed-in user's open work,
// recent activity, and a team presence row. Reuses StoriesSection from shared-gov.

var $7MNpT = parcelRequire("7MNpT");

var $2BDiG = parcelRequire("2BDiG");

var $jkGmz = parcelRequire("jkGmz");
const $9c55888aab104f84$export$a71f1927824bb4cb = {
    extends: 'AppPage',
    metadata: {
        title: 'My view / Tickets / Symbols Workspace'
    },
    onInit: (el, s)=>{
        if (el.call('redirectIfExternalOnly', s)) return;
    },
    fetch: (0, $7MNpT.pageBoilerplateFetch),
    onCreate: async (el, s)=>{
        // Wait for currentUserEmail to be populated by app.js auth
        let email = s.root.currentUserEmail;
        if (!email) await new Promise((resolve)=>{
            let attempts = 0;
            const check = setInterval(()=>{
                email = s.root.currentUserEmail;
                if (email || ++attempts > 30) {
                    clearInterval(check);
                    resolve();
                }
            }, 200);
        });
        // Never fall back to a hardcoded email — leaking another user's tickets
        // here was a real bug in earlier revisions of this file. If the auth
        // subscription never populated, skip the fetch and let the empty state
        // render instead.
        if (!email) {
            console.warn("[tickets/myView] currentUserEmail never populated \u2014 skipping myTickets fetch");
            return;
        }
        const rows = await (0, $2BDiG.fetchTicketsAssignedTo)(email, 100);
        s.root.update({
            myTickets: rows
        });
        // Realtime: refresh myTickets when ASK-USER decisions or awaiting-approval
        // tickets are filed / updated, so Nika sees them without a manual reload.
        el._rtUnsub = (0, $jkGmz.subscribeTicketsRealtime)({
            pageName: 'my-view',
            tables: [
                'tickets'
            ],
            onRefresh: async ()=>{
                const addr = s.root.currentUserEmail || email;
                const next = await (0, $2BDiG.fetchTicketsAssignedTo)(addr, 100);
                if (next.length) s.root.update({
                    myTickets: next
                });
            },
            // Optimistic patch: when a ticket assigned to the current user gains the
            // ASK-USER label or awaiting_approval state, splice it into myTickets
            // immediately so the "Awaiting your approval" section lights up in <150ms.
            onOptimisticPatch: (_table, eventType, row)=>{
                const addr = s.root.currentUserEmail || email;
                if (!addr || row.assignee_email !== addr) return;
                const isAskUser = row.state === 'awaiting_approval' || Array.isArray(row.labels) && row.labels.includes('ASK-USER');
                if (!isAskUser && eventType !== 'UPDATE') return;
                const existing = s.root.myTickets || [];
                const idx = existing.findIndex((t)=>t.id === row.id);
                if (idx >= 0) {
                    // Update in-place
                    const updated = [
                        ...existing
                    ];
                    updated[idx] = {
                        ...existing[idx],
                        ...row
                    };
                    s.root.update({
                        myTickets: updated
                    });
                } else if (eventType === 'INSERT' && isAskUser) s.root.update({
                    myTickets: [
                        row,
                        ...existing
                    ]
                });
            }
        });
    },
    onRemove: (el)=>{
        if (el._rtUnsub) {
            el._rtUnsub();
            el._rtUnsub = null;
        }
        const root = el.getRoot();
        if (root && root.selectedTicket) root.update({
            selectedTicket: null
        });
    },
    TicketsSidebar: {},
    TicketsMyViewMain: {},
    TicketsNewTicketModal: {},
    TicketsDetailModal: {},
    TicketMentionModal: {}
};

});

parcelRegister("jawME", function(module, exports) {

$parcel$export(module.exports, "home", () => $df4861ab75ec4d86$export$d12a05a2da93ee73);
// /tickets/board — kanban columns by workflow state.
// Column counts polled every 30s; realtime subscription on public.tickets
// triggers an immediate column-count refresh on any state/assignee change.

var $7MNpT = parcelRequire("7MNpT");

var $2BDiG = parcelRequire("2BDiG");

var $jkGmz = parcelRequire("jkGmz");
const $df4861ab75ec4d86$export$d12a05a2da93ee73 = {
    extends: 'AppPage',
    metadata: {
        title: 'Board / Tickets / Symbols Workspace'
    },
    fetch: (0, $7MNpT.pageBoilerplateFetch),
    onCreate: async (el, s)=>{
        el._presenceUnsub = el.call('useOnlinePresence', {
            app: 'tickets'
        });
        const colKeys = (s.root.columns || []).map((c)=>c.key);
        const totals = await (0, $2BDiG.fetchColumnCounts)({}, colKeys.length ? colKeys : null);
        s.root.update({
            totalByColumn: totals
        });
        const first = await Promise.all(Object.keys(totals).map(async (colKey)=>{
            if (!totals[colKey]) return {
                colKey: colKey,
                rows: []
            };
            const rows = await (0, $2BDiG.fetchColumnPage)(colKey, 0, (0, $2BDiG.INITIAL_PAGE_SIZE));
            return {
                colKey: colKey,
                rows: rows
            };
        }));
        const merged = [];
        const loaded = {};
        for (const { colKey: colKey, rows: rows } of first){
            merged.push(...rows.map((0, $7MNpT.rowToTicket)));
            loaded[colKey] = rows.length;
        }
        s.root.update({
            tickets: merged,
            loadedByColumn: loaded
        });
        // Realtime: refresh column counts on any ticket state change.
        el._rtUnsub = (0, $jkGmz.subscribeTicketsRealtime)({
            pageName: 'board',
            tables: [
                'tickets'
            ],
            onRefresh: async ()=>{
                const next = await (0, $2BDiG.fetchColumnCounts)({}, colKeys);
                const cur = s.root.totalByColumn || {};
                const changed = Object.keys(next).some((k)=>next[k] !== cur[k]) || Object.keys(cur).length !== Object.keys(next).length;
                if (changed) s.root.update({
                    totalByColumn: next
                });
            }
        });
        el._countTimer = setInterval(async ()=>{
            // Skip the count refresh entirely when the tab is hidden — there's
            // nothing to draw and we don't want to keep the connection warm.
            if (typeof document !== 'undefined' && document.visibilityState !== 'visible') return;
            try {
                const next = await (0, $2BDiG.fetchColumnCounts)({}, colKeys);
                // Skip the update when nothing actually changed — otherwise
                // every reactive consumer of totalByColumn re-fires on tick.
                const cur = s.root.totalByColumn || {};
                const changed = Object.keys(next).some((k)=>next[k] !== cur[k]) || Object.keys(cur).length !== Object.keys(next).length;
                if (changed) s.root.update({
                    totalByColumn: next
                });
            } catch (e) {}
        }, 30000);
    },
    onRemove: (el)=>{
        if (el._countTimer) clearInterval(el._countTimer);
        if (el._presenceUnsub) el._presenceUnsub();
        if (el._rtUnsub) {
            el._rtUnsub();
            el._rtUnsub = null;
        }
        const root = el.getRoot();
        if (root && root.selectedTicket) root.update({
            selectedTicket: null
        });
    },
    TicketsSidebar: {},
    TicketsMain: {},
    TicketsNewTicketModal: {},
    TicketsDetailModal: {}
};

});

parcelRegister("OZX3c", function(module, exports) {

$parcel$export(module.exports, "general", () => $0994b9e3b3f17bdc$export$78b80bc2f5d4953a);
// /tickets/general — workspace triage grouped by real-time activity.
// Three sections (Now / Ongoing / Upcoming) consuming
// fetchGeneralTriage via the shared ticketStore singleton.
// Filtered by the cross-page assignee tab
// (filterAssignee: null | 'team' | 'agents' | 'me') from TicketsHeader.
//
// Bucket definitions (from fetchGeneralTriage):
//   • now           — ticket.state='in_progress' AND assignee_email matches
//                     an active agent presence (heartbeat < 10m). OR
//                     agent_presence.current_ticket_id = ticket.id (explicit).
//   • ongoing       — state='in_progress' OR has a 'picked_up' activity log entry,
//                     but the assigned agent's heartbeat is older than 10m.
//   • upcoming      — state='not_started' / null, never picked up
//   • pendingApproval — state='awaiting_approval' (surfaced separately with Approve button)
//   • readyToTest   — state='ready_to_test' (right column; QA-pending lane)
//
// Perf (ticket #4498):
//   - Uses shared ticketStore singleton — one fetch + one realtime channel
//     regardless of how many bucket components are mounted.
//   - Initial fetch is limited (INITIAL_LIMIT = 200) for fast first paint;
//     background full-refresh runs 200ms later.
//   - Fetch timeout (10s) + retry CTA on failure (no more silent "Loading…").
//   - AbortController cancels the fetch on page unmount.
//
// Realtime: ticketStore manages the subscription internally.
// Optimistic patches are applied via ticketStore.patch().

var $7MNpT = parcelRequire("7MNpT");

var $8kTM7 = parcelRequire("8kTM7");

var $jkGmz = parcelRequire("jkGmz");

var $lB5wE = parcelRequire("lB5wE");
const $0994b9e3b3f17bdc$var$FETCH_TIMEOUT_MS = 10000 // 10s before showing retry CTA
;
// Apply a single ticket row update in-place across all triage buckets.
// Moves the ticket to a different bucket only if its state changed.
// Does NOT re-compute parent breadcrumbs or progress — leave that to
// the debounced full refetch. Returns the next triage object (or null
// if nothing changed).
const $0994b9e3b3f17bdc$var$_applyTicketPatch = (triage, newRow)=>{
    if (!triage || !newRow || !newRow.id) return null;
    const BUCKETS = [
        'now',
        'ongoing',
        'blocked',
        'upcoming',
        'pendingApproval',
        'readyToTest',
        'decisions'
    ];
    let found = null;
    let foundBucket = null;
    for (const bk of BUCKETS){
        const list = triage[bk] || [];
        const idx = list.findIndex((t)=>t.id === newRow.id);
        if (idx !== -1) {
            found = list[idx];
            foundBucket = bk;
            break;
        }
    }
    if (!found) return null // ticket not currently in triage (e.g. different type)
    ;
    const updated = {
        ...found,
        state: newRow.state ?? found.state,
        assignee_email: newRow.assignee_email ?? found.assignee_email,
        priority: newRow.priority ?? found.priority,
        labels: newRow.labels ?? found.labels,
        title: newRow.title ?? found.title,
        updatedAt: newRow.updated_at ?? found.updatedAt
    };
    const next = {
        ...triage
    };
    for (const bk of BUCKETS)next[bk] = [
        ...triage[bk] || []
    ];
    next[foundBucket] = next[foundBucket].filter((t)=>t.id !== newRow.id);
    const st = updated.state;
    if (st === 'done' || st === 'closed') ;
    else if (updated.type === 'decision') // Decision tickets always stay in the decisions bucket regardless of state.
    next.decisions = [
        updated,
        ...next.decisions
    ];
    else if (st === 'ready_to_test') next.readyToTest = [
        updated,
        ...next.readyToTest
    ];
    else if (st === 'awaiting_approval') next.pendingApproval = [
        updated,
        ...next.pendingApproval
    ];
    else if (st === 'in_progress') next.now = [
        {
            ...updated,
            progressPct: (0, $8kTM7.STATE_PROGRESS_PCT).in_progress || 33
        },
        ...next.now
    ];
    else if (st === 'blocked') next.blocked = [
        {
            ...updated,
            isBlocked: true
        },
        ...next.blocked
    ];
    else next.upcoming = [
        updated,
        ...next.upcoming
    ];
    return next;
};
// Apply an agent_presence row update in-place.
const $0994b9e3b3f17bdc$var$_applyPresencePatch = (triage, newRow)=>{
    if (!triage || !newRow) return null;
    const presence = triage.agentPresence || [];
    const idx = presence.findIndex((p)=>p.agent_name === newRow.agent_name || p.assignee_email === newRow.assignee_email);
    let nextPresence;
    if (idx !== -1) nextPresence = presence.map((p, i)=>i === idx ? {
            ...p,
            ...newRow
        } : p);
    else nextPresence = [
        ...presence,
        newRow
    ];
    return {
        ...triage,
        agentPresence: nextPresence
    };
};
const $0994b9e3b3f17bdc$export$78b80bc2f5d4953a = {
    extends: 'AppPage',
    metadata: {
        title: 'General / Tickets / Symbols Workspace'
    },
    fetch: (0, $7MNpT.pageBoilerplateFetch),
    onCreate: async (el, s)=>{
        // Mark loading start.
        s.root.update({
            triageLoading: true,
            triageError: null
        });
        // Read URL params.
        // Always clear filterEpic first so stale SPA state from a prior navigation
        // does not silently filter out tickets on the new load.
        const urlPatch = {
            filterEpic: null
        };
        if (typeof window !== 'undefined') {
            const url = new URL(window.location);
            const epic = url.searchParams.get('epic');
            if (epic) urlPatch.filterEpic = epic;
            const groupBy = url.searchParams.get('groupBy');
            if (groupBy) urlPatch.generalGroupBy = groupBy;
        }
        s.root.update(urlPatch);
        // If the store already has data (SPA page-switch back), use it immediately.
        const cached = (0, $lB5wE.ticketStore).current();
        if (cached) s.root.update({
            triage: cached,
            triageLoading: false
        });
        // Subscribe to store updates (handles future store refreshes).
        // Also serves as the first-data callback when no cached data is available.
        let _firstDataReceived = !!cached;
        el._storeUnsub = (0, $lB5wE.ticketStore).subscribe((triage)=>{
            _firstDataReceived = true;
            s.root.update({
                triage: triage,
                triageLoading: false,
                triageError: null
            });
        });
        // Timeout guard — if no data arrives within FETCH_TIMEOUT_MS, show retry CTA.
        if (!cached) {
            const timeoutId = setTimeout(()=>{
                if (!_firstDataReceived) s.root.update({
                    triageLoading: false,
                    triageError: 'timeout'
                });
            }, $0994b9e3b3f17bdc$var$FETCH_TIMEOUT_MS);
            // Store cleanup so we don't fire after page unmount.
            el._triageTimeoutId = timeoutId;
        }
        // Set up page-level realtime (optimistic patches + debounced refresh).
        // The ticketStore also has its own subscription for background refreshes;
        // the page-level one handles optimistic patches specific to this view.
        el._rtUnsub = (0, $jkGmz.subscribeTicketsRealtime)({
            pageName: 'general',
            tables: [
                'tickets',
                'agent_presence',
                'agent_activity_log'
            ],
            onOptimisticPatch: (table, eventType, row)=>{
                const current = s.root.triage;
                if (!current) return;
                let next = null;
                if (table === 'tickets' && eventType === 'UPDATE') next = $0994b9e3b3f17bdc$var$_applyTicketPatch(current, row);
                else if (table === 'agent_presence') next = $0994b9e3b3f17bdc$var$_applyPresencePatch(current, row);
                if (next) (0, $lB5wE.ticketStore).patch(next) // update store so all subscribers see it
                ;
            },
            onRefresh: async ()=>{
                await (0, $lB5wE.ticketStore).refresh() // store notifies all subscribers
                ;
            }
        });
    },
    onRemove: (el)=>{
        if (el._triageTimeoutId) {
            clearTimeout(el._triageTimeoutId);
            el._triageTimeoutId = null;
        }
        if (el._storeUnsub) {
            el._storeUnsub();
            el._storeUnsub = null;
        }
        if (el._rtUnsub) {
            el._rtUnsub();
            el._rtUnsub = null;
        }
        const root = el.getRoot();
        if (root && root.selectedTicket) root.update({
            selectedTicket: null
        });
    },
    TicketsSidebar: {},
    TicketsGeneralMain: {},
    TicketsNewTicketModal: {},
    TicketsDetailModal: {}
};

});

parcelRegister("9JY5k", function(module, exports) {

$parcel$export(module.exports, "feed", () => $7176eca7926fd799$export$93d5e4db1316498e);
// /tickets/feed — chronological activity feed. Merges
// `agent_activity_log` ship events with recently updated tickets,
// filtered by the same 4-axis tab (All / Team / Agents / Me) that
// /tickets/general uses.
//
// Realtime: subscribed to INSERT+UPDATE+DELETE on tickets and
// agent_activity_log via subscribeTicketsRealtime (shared helper).
// Channel name is unique per mount; reconnects with backoff on disconnect.

var $7MNpT = parcelRequire("7MNpT");

var $7TNEm = parcelRequire("7TNEm");

var $jkGmz = parcelRequire("jkGmz");
const $7176eca7926fd799$export$93d5e4db1316498e = {
    extends: 'AppPage',
    metadata: {
        title: 'Feed / Tickets / Symbols Workspace'
    },
    fetch: (0, $7MNpT.pageBoilerplateFetch),
    onCreate: async (el, s)=>{
        const items = await (0, $7TNEm.fetchActivityFeed)({
            limit: 80
        });
        const viewHash = (typeof window !== 'undefined' ? window.location.hash || '' : '').replace(/^#/, '').split('&').reduce((acc, kv)=>{
            const [k, v] = kv.split('=');
            if (k) acc[k] = v === undefined ? true : decodeURIComponent(v);
            return acc;
        }, {});
        const allowed = new Set([
            'team',
            'agents',
            'me'
        ]);
        const deeplink = allowed.has(viewHash.view) ? viewHash.view : null;
        const patch = {
            feedItems: items
        };
        // Only seed filterAssignee if the URL asks for one — otherwise
        // leave whatever the TicketsHeader switcher last set cross-page.
        if (deeplink) patch.filterAssignee = deeplink;
        s.root.update(patch);
        el._rtUnsub = (0, $jkGmz.subscribeTicketsRealtime)({
            pageName: 'feed',
            tables: [
                'agent_activity_log',
                'tickets'
            ],
            onRefresh: async ()=>{
                const next = await (0, $7TNEm.fetchActivityFeed)({
                    limit: 80
                });
                if (next.length) s.root.update({
                    feedItems: next
                });
            }
        });
    },
    onRemove: (el)=>{
        if (el._rtUnsub) {
            el._rtUnsub();
            el._rtUnsub = null;
        }
        const root = el.getRoot();
        if (root && root.selectedTicket) root.update({
            selectedTicket: null
        });
    },
    TicketsSidebar: {},
    TicketsFeedMain: {},
    TicketsNewTicketModal: {},
    TicketsDetailModal: {}
};

});
parcelRegister("7TNEm", function(module, exports) {

$parcel$export(module.exports, "fetchActivityFeed", () => $5c042eea6ad0a7aa$export$967c92ed76f908b6);
// Chronological activity feed for /tickets/feed.
//
// Merges two streams into a single time-sorted list:
//   1. public.agent_activity_log — agent ship/pick/block/ask-user events
//   2. public.tickets — most recently updated tickets (any assignee)
//
// Returns flat array of feed entries shaped as:
//   {
//     id,                  // stable key for DOMQL keyed render
//     kind,                // 'shipped' | 'picked_up' | 'blocked' | ...
//                          //   | 'ticket_update'   (fallback kind from tickets table)
//     tsISO,               // event time (agent_activity_log.created_at or tickets.updated_at)
//     actorEmail,          // agent_name if activity log; assignee_email otherwise
//     ticketId,            // when present
//     ticketExternalId,
//     ticketTitle,
//     ticketType,
//     ticketState,
//     commitSha,
//     note
//   }

var $ghHor = parcelRequire("ghHor");
const $5c042eea6ad0a7aa$var$WORKSPACE_ID = '69e5911201b0ef47b675463f';
const $5c042eea6ad0a7aa$export$967c92ed76f908b6 = async ({ limit: limit = 50 } = {})=>{
    const [logRes, ticketsRes] = await Promise.all([
        fetch(`${(0, $ghHor.SUPABASE_URL)}/rest/v1/agent_activity_log?select=id,agent_name,ticket_id,kind,commit_sha,note,metadata,created_at,agent_id&workspace_id=eq.${$5c042eea6ad0a7aa$var$WORKSPACE_ID}&order=created_at.desc&limit=${limit}`, {
            headers: (0, $ghHor.restHeaders)()
        }),
        fetch(`${(0, $ghHor.SUPABASE_URL)}/rest/v1/tickets?select=id,external_id,type,title,state,assignee_email,updated_at,metadata&workspace_id=eq.${$5c042eea6ad0a7aa$var$WORKSPACE_ID}&deleted=eq.false&order=updated_at.desc&limit=${limit}`, {
            headers: (0, $ghHor.restHeaders)()
        })
    ]);
    const logs = logRes.ok ? await logRes.json() : [];
    const tickets = ticketsRes.ok ? await ticketsRes.json() : [];
    // Build ticket lookup so we can enrich activity log rows.
    const tById = new Map();
    for (const t of tickets)tById.set(t.id, t);
    const feed = [];
    for (const l of logs){
        const t = l.ticket_id ? tById.get(l.ticket_id) : null;
        feed.push({
            id: `log:${l.id}`,
            kind: l.kind,
            tsISO: l.created_at,
            actorEmail: l.agent_name ? `${l.agent_name.toLowerCase()}-agent@symbols.app` : null,
            actorDisplay: l.agent_name || 'agent',
            ticketId: l.ticket_id,
            ticketExternalId: t?.external_id,
            ticketTitle: t?.title,
            ticketType: t?.type,
            ticketState: t?.state,
            commitSha: l.commit_sha,
            note: l.note
        });
    }
    // Fold in ticket updates that don't have a matching activity log entry
    // (human edits, external syncs, etc.) so humans aren't invisible.
    const loggedTicketIds = new Set(logs.filter((l)=>l.ticket_id).map((l)=>l.ticket_id));
    for (const t of tickets){
        if (loggedTicketIds.has(t.id)) continue;
        feed.push({
            id: `ticket:${t.id}`,
            kind: 'ticket_update',
            tsISO: t.updated_at,
            actorEmail: t.assignee_email,
            actorDisplay: t.assignee_email?.split('@')[0] || 'someone',
            ticketId: t.id,
            ticketExternalId: t.external_id,
            ticketTitle: t.title,
            ticketType: t.type,
            ticketState: t.state,
            commitSha: null,
            note: null
        });
    }
    feed.sort((a, b)=>new Date(b.tsISO || 0) - new Date(a.tsISO || 0));
    return feed.slice(0, limit);
};

});


parcelRegister("d8OdG", function(module, exports) {

$parcel$export(module.exports, "canvas", () => $9912fa4cb7d16824$export$67ea982130081db);
// /tickets/canvas — 3-pane board: left epic nav, center grouped board,
// right filters + selected-ticket detail.
//
// Replaces the old cytoscape graph with a real ticket board that reuses
// EpicsView/StoriesSection/StoryCard component patterns and the existing
// TicketCard visual language from /tickets/general and /tickets/my.
//
// URL params: ?groupBy=story|epic|status|priority|assignee|none
//             ?epic=<epicKey>
//
// Drag-to-bucket: pointer event delegation at board level. Limit
// pointermove updates via rAF. No per-card signal listeners. (see #4382)

var $7MNpT = parcelRequire("7MNpT");

var $l4iSc = parcelRequire("l4iSc");

var $jkGmz = parcelRequire("jkGmz");

var $ghHor = parcelRequire("ghHor");
const $9912fa4cb7d16824$var$_VALID_GROUP_BY = [
    'story',
    'epic',
    'status',
    'priority',
    'assignee',
    'none'
];
// Resolve the ?ticket=<id> URL param after the canvas data is ready.
// 1. Immediately set a partial selectedTicket from allTickets (fast path —
//    shows title/state/priority while the full fetch is in-flight).
// 2. Always fetch select=* to hydrate body + all fields.
// This runs AFTER fetchCanvasTriage() resolves so canvasAllTickets is
// guaranteed to be populated, avoiding the 5-second polling race in
// TicketsDetailModal.onRender (root cause of #4445 / #4417 follow-up).
const $9912fa4cb7d16824$var$_restoreTicketFromUrl = async (root, allTickets)=>{
    if (typeof window === 'undefined') return;
    let urlId;
    try {
        urlId = new URL(window.location).searchParams.get('ticket');
    } catch  {
        return;
    }
    if (!urlId) return;
    // Skip only if body is already populated — a plain {id} stub from the
    // modal's onRender polling should NOT block the select=* fetch.
    if (root?.selectedTicket?.body !== undefined) return;
    const numId = parseInt(urlId, 10);
    const matchId = !isNaN(numId) ? numId : null;
    // Fast-path: find partial ticket from already-loaded allTickets array.
    const partial = (allTickets || []).find((t)=>matchId && t.id === matchId || String(t.external_id) === urlId);
    if (partial) // Set immediately so the detail pane shows title/state while hydrating.
    root.update({
        selectedTicket: {
            ...partial
        }
    });
    // Always fetch the full row so body + all fields are present.
    try {
        const fetchIdParam = matchId ? `id=eq.${matchId}` : `external_id=eq.${encodeURIComponent(urlId)}`;
        const res = await fetch(`${(0, $ghHor.SUPABASE_URL)}/rest/v1/tickets?${fetchIdParam}&select=*&limit=1`, {
            headers: (0, $ghHor.restHeaders)()
        });
        if (!res.ok) return;
        const rows = await res.json();
        const t = rows[0];
        if (!t) return;
        root.update({
            selectedTicket: {
                ...root.selectedTicket || {},
                ...partial || {},
                ...t,
                columnKey: t.column_key,
                issueType: t.issue_type,
                epicName: t.epic_name,
                assigneeEmail: t.assignee_email,
                reporterEmail: t.reporter_email,
                updatedAt: t.updated_at,
                createdAt: t.created_at
            }
        });
    } catch (_) {}
};
const $9912fa4cb7d16824$var$_readUrlParams = ()=>{
    if (typeof window === 'undefined') return {};
    try {
        const p = new URLSearchParams(window.location.search);
        const groupBy = p.get('groupBy');
        const epic = p.get('epic');
        return {
            canvasGroupBy: $9912fa4cb7d16824$var$_VALID_GROUP_BY.includes(groupBy) ? groupBy : 'story',
            canvasEpicFilter: epic || null
        };
    } catch  {
        return {};
    }
};
const $9912fa4cb7d16824$export$67ea982130081db = {
    extends: 'AppPage',
    metadata: {
        title: 'Canvas / Tickets / Symbols Workspace'
    },
    fetch: (0, $7MNpT.pageBoilerplateFetch),
    onCreate: async (el, s)=>{
        // Initialise URL-driven state before data lands.
        const urlState = $9912fa4cb7d16824$var$_readUrlParams();
        s.root.update({
            canvasGroupBy: urlState.canvasGroupBy || 'story',
            canvasEpicFilter: urlState.canvasEpicFilter || null,
            canvasStateFilter: null,
            canvasPriorityFilter: null,
            canvasSelected: [],
            canvasAllTickets: null,
            canvasEpics: [],
            canvasStories: []
        });
        const { epics: epics, stories: stories, allTickets: allTickets } = await (0, $l4iSc.fetchCanvasTriage)();
        s.root.update({
            canvasAllTickets: allTickets,
            canvasEpics: epics,
            canvasStories: stories
        });
        // Resolve ?ticket=<id> AFTER canvas data is ready — bypasses the
        // TicketsDetailModal 5s polling race (fixes #4445 / #4417 follow-up).
        await $9912fa4cb7d16824$var$_restoreTicketFromUrl(s.root, allTickets);
        // Keyboard shortcut handler: g+e = epics, g+s = stories, g+c = canvas
        // Use el.router (SPA navigation) instead of window.location.href which
        // would force a full page reload + SDK reinit on every shortcut press.
        let _gPending = false;
        const _go = (path)=>el.router(path, el.getRoot());
        const _keyHandler = (e)=>{
            if (e.target && [
                'INPUT',
                'TEXTAREA',
                'SELECT'
            ].includes(e.target.tagName)) return;
            if (e.key === 'g') {
                _gPending = true;
                setTimeout(()=>{
                    _gPending = false;
                }, 500);
                return;
            }
            if (_gPending) {
                _gPending = false;
                if (e.key === 'e') {
                    _go('/tickets/epics');
                    return;
                }
                if (e.key === 's') {
                    _go('/tickets/stories');
                    return;
                }
                if (e.key === 'c') {
                    _go('/tickets/canvas');
                    return;
                }
            }
        // Arrow key navigation between cards: handled natively via tabindex.
        };
        document.addEventListener('keydown', _keyHandler);
        el._keyHandlerCleanup = ()=>document.removeEventListener('keydown', _keyHandler);
        // Realtime refresh
        el._rtUnsub = (0, $jkGmz.subscribeTicketsRealtime)({
            pageName: 'canvas',
            tables: [
                'tickets'
            ],
            onRefresh: async ()=>{
                const { epics: e2, stories: s2, allTickets: t2 } = await (0, $l4iSc.fetchCanvasTriage)();
                s.root.update({
                    canvasAllTickets: t2,
                    canvasEpics: e2,
                    canvasStories: s2
                });
            }
        });
    },
    onRemove: (el)=>{
        if (el._rtUnsub) {
            el._rtUnsub();
            el._rtUnsub = null;
        }
        if (el._keyHandlerCleanup) {
            el._keyHandlerCleanup();
            el._keyHandlerCleanup = null;
        }
        const root = el.getRoot();
        if (root && root.selectedTicket) root.update({
            selectedTicket: null
        });
    },
    TicketsSidebar: {},
    TicketsCanvasMain: {},
    TicketsNewTicketModal: {},
    TicketsDetailModal: {}
};

});
parcelRegister("l4iSc", function(module, exports) {

$parcel$export(module.exports, "fetchCanvasTriage", () => $f5689c8857e140f1$export$8aa54a351e39c06e);
$parcel$export(module.exports, "patchTicketField", () => $f5689c8857e140f1$export$5cc361def0d8e2da);
$parcel$export(module.exports, "groupTickets", () => $f5689c8857e140f1$export$dad2ad587017f01d);
// fetchCanvasTriage — loads all tickets for /tickets/canvas board.
// Returns: { epics, groups, allTickets }
//   epics      — same shape as fetchEpicsTree() for the left-pane nav rail
//   groups     — pre-grouped by the requested groupBy key
//   allTickets — flat array for client-side re-grouping without refetch
//
// groupBy: 'story' | 'epic' | 'status' | 'priority' | 'assignee' | 'none'

var $ghHor = parcelRequire("ghHor");
const $f5689c8857e140f1$var$WORKSPACE_ID = '69e5911201b0ef47b675463f';
const $f5689c8857e140f1$var$EPIC_ORDER = [
    'tickets',
    'framework',
    'canvas',
    'server',
    'integrations',
    'marketplace',
    'chat',
    'meet',
    'symbols-system',
    'documents',
    'pricing',
    'commercials'
];
const $f5689c8857e140f1$var$HIDDEN_EPICS = new Set([
    'simona',
    'user'
]);
const $f5689c8857e140f1$var$_isDone = (r)=>r.state === 'done' || r.state === 'CLOSED' || r.state === 'closed' || !!r.metadata?.struck;
const $f5689c8857e140f1$export$8aa54a351e39c06e = async ()=>{
    const url = `${(0, $ghHor.SUPABASE_URL)}/rest/v1/tickets?select=id,external_id,type,title,state,priority,assignee_email,column_key,parent_ticket_id,metadata,labels,updated_at&workspace_id=eq.${$f5689c8857e140f1$var$WORKSPACE_ID}&deleted=eq.false&limit=3000`;
    let rows = [];
    try {
        const ctrl = new AbortController();
        const to = setTimeout(()=>ctrl.abort(), 10000);
        const res = await fetch(url, {
            headers: (0, $ghHor.restHeaders)(),
            signal: ctrl.signal
        }).finally(()=>clearTimeout(to));
        if (res.ok) rows = await res.json();
    } catch (_) {}
    if (!Array.isArray(rows) || !rows.length) return {
        epics: [],
        stories: [],
        allTickets: []
    };
    // Index all rows by id.
    const byId = new Map();
    for (const r of rows)byId.set(r.id, r);
    // Build epic index.
    const epicByRowId = new Map();
    const epicByKey = new Map();
    for (const r of rows){
        if (r.type !== 'epic') continue;
        const key = r.metadata?.epicKey || r.external_id?.replace(/^EPIC#/, '');
        if (!key || $f5689c8857e140f1$var$HIDDEN_EPICS.has(key)) continue;
        const epicInfo = {
            id: r.id,
            epicKey: key,
            title: r.title || key.toUpperCase(),
            state: r.state || 'not_started',
            donePct: 0,
            storiesTotal: 0,
            storiesDone: 0,
            tasksTotal: 0,
            tasksDone: 0,
            bugsTotal: 0,
            bugsDone: 0
        };
        epicByRowId.set(r.id, epicInfo);
        epicByKey.set(key, epicInfo);
    }
    // Synthesize missing product epics so the rail is always complete.
    for (const key of $f5689c8857e140f1$var$EPIC_ORDER)if (!epicByKey.has(key)) epicByKey.set(key, {
        id: null,
        epicKey: key,
        title: key.toUpperCase(),
        state: 'not_started',
        donePct: 0,
        storiesTotal: 0,
        storiesDone: 0,
        tasksTotal: 0,
        tasksDone: 0,
        bugsTotal: 0,
        bugsDone: 0
    });
    // Build story index (only stories parented to a non-hidden epic).
    const storyByRowId = new Map();
    const storyByKey = new Map();
    for (const r of rows){
        if (r.type !== 'user_story') continue;
        const storyKey = r.metadata?.storyKey || r.external_id?.replace(/^STORY#/, '') || `#${r.id}`;
        const epicInfo = r.parent_ticket_id ? epicByRowId.get(r.parent_ticket_id) : null;
        if (!epicInfo) continue;
        const si = {
            id: r.id,
            storyKey: storyKey,
            title: r.title || storyKey,
            state: r.state || 'not_started',
            epicKey: epicInfo.epicKey,
            epicTitle: epicInfo.title,
            donePct: 0,
            tasksTotal: 0,
            tasksDone: 0,
            bugsTotal: 0,
            bugsDone: 0,
            tickets: []
        };
        storyByRowId.set(r.id, si);
        storyByKey.set(r.id, si);
        // Roll up to epic
        epicInfo.storiesTotal += 1;
        if ($f5689c8857e140f1$var$_isDone(r)) epicInfo.storiesDone += 1;
    }
    // Build flat ticket array (tasks + bugs only, open). Attach parent refs.
    const allTickets = [];
    for (const r of rows){
        if (r.type !== 'task' && r.type !== 'bug') continue;
        const parentStory = r.parent_ticket_id ? storyByRowId.get(r.parent_ticket_id) : null;
        const parentEpicInfo = parentStory ? epicByKey.get(parentStory.epicKey) : r.parent_ticket_id ? epicByRowId.get(r.parent_ticket_id) : null;
        const ticket = {
            id: r.id,
            external_id: r.external_id,
            type: r.type,
            title: r.title || '',
            state: r.state || 'not_started',
            priority: r.priority,
            assignee_email: r.assignee_email,
            column_key: r.column_key,
            labels: r.labels || [],
            metadata: r.metadata || {},
            updated_at: r.updated_at,
            parentStoryId: parentStory?.id || null,
            parentStoryTitle: parentStory?.title || '',
            parentStoryKey: parentStory?.storyKey || '',
            parentEpicKey: parentEpicInfo?.epicKey || '',
            parentEpicTitle: parentEpicInfo?.title || ''
        };
        allTickets.push(ticket);
        // Roll up counts.
        if (parentStory) {
            if (r.type === 'task') {
                parentStory.tasksTotal += 1;
                if ($f5689c8857e140f1$var$_isDone(r)) parentStory.tasksDone += 1;
            } else {
                parentStory.bugsTotal += 1;
                if ($f5689c8857e140f1$var$_isDone(r)) parentStory.bugsDone += 1;
            }
        }
        if (parentEpicInfo) {
            if (r.type === 'task') {
                parentEpicInfo.tasksTotal += 1;
                if ($f5689c8857e140f1$var$_isDone(r)) parentEpicInfo.tasksDone += 1;
            } else {
                parentEpicInfo.bugsTotal += 1;
                if ($f5689c8857e140f1$var$_isDone(r)) parentEpicInfo.bugsDone += 1;
            }
        }
    }
    // Compute donePct for stories and epics.
    for (const s of storyByRowId.values()){
        const total = s.tasksTotal + s.bugsTotal;
        s.donePct = total ? Math.round((s.tasksDone + s.bugsDone) / total * 100) : 0;
    }
    for (const e of epicByKey.values()){
        const total = e.tasksTotal + e.bugsTotal;
        e.donePct = total ? Math.round((e.tasksDone + e.bugsDone) / total * 100) : 0;
    }
    // Order epics by EPIC_ORDER.
    const orderedEpics = [];
    const seenEpics = new Set();
    for (const key of $f5689c8857e140f1$var$EPIC_ORDER)if (epicByKey.has(key)) {
        orderedEpics.push(epicByKey.get(key));
        seenEpics.add(key);
    }
    for (const [key, val] of epicByKey)if (!seenEpics.has(key)) orderedEpics.push(val);
    const orderedStories = Array.from(storyByRowId.values()).sort((a, b)=>{
        const ai = $f5689c8857e140f1$var$EPIC_ORDER.indexOf(a.epicKey);
        const bi = $f5689c8857e140f1$var$EPIC_ORDER.indexOf(b.epicKey);
        const ar = ai === -1 ? 999 : ai;
        const br = bi === -1 ? 999 : bi;
        if (ar !== br) return ar - br;
        return a.storyKey.localeCompare(b.storyKey);
    });
    return {
        epics: orderedEpics,
        stories: orderedStories,
        allTickets: allTickets
    };
};
const $f5689c8857e140f1$export$5cc361def0d8e2da = async (ticketId, field, value)=>{
    try {
        const res = await fetch(`${(0, $ghHor.SUPABASE_URL)}/rest/v1/tickets?id=eq.${ticketId}`, {
            method: 'PATCH',
            headers: {
                ...(0, $ghHor.restHeaders)(),
                'Content-Type': 'application/json',
                Prefer: 'return=minimal'
            },
            body: JSON.stringify({
                [field]: value,
                updated_at: new Date().toISOString()
            })
        });
        return res.ok;
    } catch (_) {
        return false;
    }
};
const $f5689c8857e140f1$export$dad2ad587017f01d = (tickets, groupBy)=>{
    if (!groupBy || groupBy === 'none') return [
        {
            groupKey: 'all',
            groupLabel: 'All Tickets',
            tickets: tickets
        }
    ];
    const groups = new Map();
    for (const t of tickets){
        let key, label;
        if (groupBy === 'story') {
            key = t.parentStoryId ? String(t.parentStoryId) : '_no_story';
            label = t.parentStoryTitle || 'No Story';
        } else if (groupBy === 'epic') {
            key = t.parentEpicKey || '_no_epic';
            label = t.parentEpicTitle || t.parentEpicKey?.toUpperCase() || 'No Epic';
        } else if (groupBy === 'status') {
            key = t.state || 'not_started';
            label = $f5689c8857e140f1$var$_stateLabel(t.state);
        } else if (groupBy === 'priority') {
            key = t.priority || '_none';
            label = t.priority || 'No Priority';
        } else if (groupBy === 'assignee') {
            key = t.assignee_email || '_unassigned';
            label = t.assignee_email || 'Unassigned';
        } else {
            key = 'all';
            label = 'All Tickets';
        }
        if (!groups.has(key)) groups.set(key, {
            groupKey: key,
            groupLabel: label,
            tickets: []
        });
        groups.get(key).tickets.push(t);
    }
    return Array.from(groups.values());
};
const $f5689c8857e140f1$var$_stateLabel = (s)=>({
        not_started: 'Not Started',
        in_progress: 'In Progress',
        blocked: 'Blocked',
        ready_to_test: 'Ready to Test',
        done: 'Done',
        closed: 'Closed',
        awaiting_approval: 'Awaiting Approval'
    })[s] || (s || 'Not Started').replace(/_/g, ' ').replace(/\b\w/g, (c)=>c.toUpperCase());

});


parcelRegister("84zNI", function(module, exports) {

$parcel$export(module.exports, "stories", () => $5e0a77bfaf77178b$export$417f05a13bd2667c);
// Stories index — reads post-B-117 user stories from `public.tickets`
// (type='user_story'). Replaces the legacy `public.stories` table.
// Groups by parent epic.

var $7MNpT = parcelRequire("7MNpT");

var $iUi81 = parcelRequire("iUi81");
const $5e0a77bfaf77178b$export$417f05a13bd2667c = {
    extends: 'AppPage',
    metadata: {
        title: 'Stories / Tickets / Symbols Workspace'
    },
    fetch: (0, $7MNpT.pageBoilerplateFetch),
    onCreate: async (el, s)=>{
        const tree = await (0, $iUi81.fetchStoriesTree)();
        s.root.update({
            storiesTree: tree
        });
    },
    onRemove: (el)=>{
        const root = el.getRoot();
        if (root && root.selectedTicket) root.update({
            selectedTicket: null
        });
    },
    TicketsSidebar: {},
    TicketsStoriesMain: {},
    TicketsNewTicketModal: {},
    TicketsDetailModal: {}
};

});
parcelRegister("iUi81", function(module, exports) {

$parcel$export(module.exports, "fetchEpicsTree", () => $dc3b84e61f3af25a$export$16efbe6115224ba8);
$parcel$export(module.exports, "fetchStoriesTree", () => $dc3b84e61f3af25a$export$2927cef350dc7590);
// Post-B-117 epics + stories reader — replaces the legacy GitHub-Projects
// `project_fields` / `ticket_epic_counts` path used by /tickets/epics and
// the legacy `public.stories` table used by /tickets/stories.
//
// Single query against `public.tickets` returns every epic / user_story
// / task / bug row in one round trip; shaped client-side into:
//
//   fetchEpicsTree() → [{
//     epicKey, id, title, state, metadata,
//     storiesTotal, storiesDone,
//     tasksTotal,   tasksDone,
//     bugsTotal,    bugsDone,
//     donePct
//   }]  — ordered by EPIC_ORDER
//
//   fetchStoriesTree() → [{
//     storyKey, id, title, state, metadata,
//     epicKey, epicTitle,
//     tasksTotal, tasksDone,
//     bugsTotal,  bugsDone,
//     donePct,
//     tasks: [...], bugs: [...]       // thin — just {id, title, state, metadata}
//   }]  — ordered by parent epic (EPIC_ORDER), then storyKey
//
// All reads are workspace-scoped via RLS + explicit workspace_id filter.

var $ghHor = parcelRequire("ghHor");
const $dc3b84e61f3af25a$var$WORKSPACE_ID = '69e5911201b0ef47b675463f';
// Matches fetchAgentHierarchy.js + fetchCanvasGraph.js ordering.
// `simona` (AI assistant role) is NOT a product epic per Nika 2026-04-24
// — it's a cross-cutting agent role that owns `/agents/*.md` methodology
// files. HIDDEN_EPICS filter keeps it off the epics + stories pages.
const $dc3b84e61f3af25a$var$EPIC_ORDER = [
    'tickets',
    'framework',
    'canvas',
    'server',
    'integrations',
    'marketplace',
    'chat',
    'meet',
    'symbols-system',
    'documents',
    'pricing',
    'commercials'
];
const $dc3b84e61f3af25a$var$HIDDEN_EPICS = new Set([
    'simona'
]);
const $dc3b84e61f3af25a$var$_fetchAllTicketRows = async ()=>{
    const url = `${(0, $ghHor.SUPABASE_URL)}/rest/v1/tickets?select=id,external_id,type,title,state,priority,assignee_email,column_key,parent_ticket_id,metadata,updated_at&workspace_id=eq.${$dc3b84e61f3af25a$var$WORKSPACE_ID}&type=in.(epic,user_story,task,bug)&deleted=eq.false&limit=3000`;
    const res = await fetch(url, {
        headers: (0, $ghHor.restHeaders)()
    });
    if (!res.ok) return [];
    const rows = await res.json();
    return Array.isArray(rows) ? rows : [];
};
const $dc3b84e61f3af25a$var$_isDone = (r)=>r.state === 'done' || r.state === 'CLOSED' || r.state === 'closed' || !!r.metadata?.struck;
const $dc3b84e61f3af25a$export$16efbe6115224ba8 = async ()=>{
    const rows = await $dc3b84e61f3af25a$var$_fetchAllTicketRows();
    if (!rows.length) return [];
    const byId = new Map();
    for (const r of rows)byId.set(r.id, r);
    // Index epics by their string key.
    const epicByKey = new Map();
    const epicRowIdToKey = new Map();
    for (const r of rows){
        if (r.type !== 'epic') continue;
        const key = r.metadata?.epicKey || r.external_id?.replace(/^EPIC#/, '');
        if (!key) continue;
        if ($dc3b84e61f3af25a$var$HIDDEN_EPICS.has(key)) continue;
        epicByKey.set(key, {
            epicKey: key,
            id: r.id,
            title: r.title || key.toUpperCase(),
            state: r.state || 'not_started',
            metadata: r.metadata || {},
            storiesTotal: 0,
            storiesDone: 0,
            tasksTotal: 0,
            tasksDone: 0,
            bugsTotal: 0,
            bugsDone: 0
        });
        epicRowIdToKey.set(r.id, key);
    }
    // Map stories → parent epic (via parent_ticket_id).
    const storyRowIdToEpicKey = new Map();
    for (const r of rows){
        if (r.type !== 'user_story') continue;
        const epicKey = r.metadata?.epicKey || (r.parent_ticket_id ? epicRowIdToKey.get(r.parent_ticket_id) : null);
        if (!epicKey) continue;
        storyRowIdToEpicKey.set(r.id, epicKey);
        const bucket = epicByKey.get(epicKey);
        if (!bucket) continue;
        bucket.storiesTotal += 1;
        if ($dc3b84e61f3af25a$var$_isDone(r)) bucket.storiesDone += 1;
    }
    // Tasks + bugs roll up through their story's epic (or directly if no story).
    for (const r of rows){
        if (r.type !== 'task' && r.type !== 'bug') continue;
        const parentKey = r.parent_ticket_id ? storyRowIdToEpicKey.get(r.parent_ticket_id) || epicRowIdToKey.get(r.parent_ticket_id) : null;
        if (!parentKey) continue;
        const bucket = epicByKey.get(parentKey);
        if (!bucket) continue;
        if (r.type === 'task') {
            bucket.tasksTotal += 1;
            if ($dc3b84e61f3af25a$var$_isDone(r)) bucket.tasksDone += 1;
        } else {
            bucket.bugsTotal += 1;
            if ($dc3b84e61f3af25a$var$_isDone(r)) bucket.bugsDone += 1;
        }
    }
    // Synthesize any epic in EPIC_ORDER that wasn't in the DB so the
    // page always renders the canonical 13 — matches fetchCanvasGraph.js.
    for (const key of $dc3b84e61f3af25a$var$EPIC_ORDER)if (!epicByKey.has(key)) epicByKey.set(key, {
        epicKey: key,
        id: null,
        title: key.toUpperCase(),
        state: 'not_started',
        metadata: {},
        storiesTotal: 0,
        storiesDone: 0,
        tasksTotal: 0,
        tasksDone: 0,
        bugsTotal: 0,
        bugsDone: 0
    });
    // Compute donePct = total ratio of done leaves (tasks + bugs).
    for (const e of epicByKey.values()){
        const total = e.tasksTotal + e.bugsTotal;
        const done = e.tasksDone + e.bugsDone;
        e.donePct = total ? Math.round(done / total * 100) : 0;
    }
    // Order: EPIC_ORDER first, then any leftover keys alphabetically.
    const ordered = [];
    const seen = new Set();
    for (const key of $dc3b84e61f3af25a$var$EPIC_ORDER)if (epicByKey.has(key)) {
        ordered.push(epicByKey.get(key));
        seen.add(key);
    }
    for (const [key, val] of epicByKey)if (!seen.has(key)) ordered.push(val);
    return ordered;
};
const $dc3b84e61f3af25a$export$2927cef350dc7590 = async ()=>{
    const rows = await $dc3b84e61f3af25a$var$_fetchAllTicketRows();
    if (!rows.length) return [];
    // Lookup epic titles for join display. Hidden epics tracked separately
    // so we can drop any story that resolves to one (avoids an UNCATEGORIZED
    // bucket for orphans under EPIC#simona).
    const epicTitleByKey = new Map();
    const epicRowIdToKey = new Map();
    const hiddenEpicRowIds = new Set();
    for (const r of rows){
        if (r.type !== 'epic') continue;
        const key = r.metadata?.epicKey || r.external_id?.replace(/^EPIC#/, '');
        if (!key) continue;
        if ($dc3b84e61f3af25a$var$HIDDEN_EPICS.has(key)) {
            hiddenEpicRowIds.add(r.id);
            continue;
        }
        epicTitleByKey.set(key, r.title || key.toUpperCase());
        epicRowIdToKey.set(r.id, key);
    }
    // Build stories first so we can attach children by story id.
    const storyById = new Map();
    for (const r of rows){
        if (r.type !== 'user_story') continue;
        const storyKey = r.metadata?.storyKey || r.external_id?.replace(/^STORY#/, '') || `#${r.id}`;
        // Skip stories whose parent_ticket_id points to a hidden epic row.
        if (r.parent_ticket_id && hiddenEpicRowIds.has(r.parent_ticket_id)) continue;
        const epicKey = r.metadata?.epicKey || (r.parent_ticket_id ? epicRowIdToKey.get(r.parent_ticket_id) : null);
        if (!epicKey) continue; // drop orphans rather than bucket them
        if ($dc3b84e61f3af25a$var$HIDDEN_EPICS.has(epicKey)) continue;
        storyById.set(r.id, {
            storyKey: storyKey,
            id: r.id,
            title: r.title || storyKey,
            state: r.state || 'not_started',
            metadata: r.metadata || {},
            epicKey: epicKey,
            epicTitle: epicTitleByKey.get(epicKey) || epicKey.toUpperCase(),
            tasksTotal: 0,
            tasksDone: 0,
            bugsTotal: 0,
            bugsDone: 0,
            tasks: [],
            bugs: []
        });
    }
    for (const r of rows){
        if (r.type !== 'task' && r.type !== 'bug') continue;
        const story = r.parent_ticket_id ? storyById.get(r.parent_ticket_id) : null;
        if (!story) continue;
        const bucket = r.type === 'task' ? 'tasks' : 'bugs';
        const totalKey = r.type === 'task' ? 'tasksTotal' : 'bugsTotal';
        const doneKey = r.type === 'task' ? 'tasksDone' : 'bugsDone';
        story[bucket].push({
            id: r.id,
            title: r.title,
            state: r.state,
            metadata: r.metadata
        });
        story[totalKey] += 1;
        if ($dc3b84e61f3af25a$var$_isDone(r)) story[doneKey] += 1;
    }
    for (const s of storyById.values()){
        const total = s.tasksTotal + s.bugsTotal;
        const done = s.tasksDone + s.bugsDone;
        s.donePct = total ? Math.round(done / total * 100) : 0;
    }
    const ordered = Array.from(storyById.values()).sort((a, b)=>{
        const ai = $dc3b84e61f3af25a$var$EPIC_ORDER.indexOf(a.epicKey);
        const bi = $dc3b84e61f3af25a$var$EPIC_ORDER.indexOf(b.epicKey);
        const aRank = ai === -1 ? 999 : ai;
        const bRank = bi === -1 ? 999 : bi;
        if (aRank !== bRank) return aRank - bRank;
        return a.storyKey.localeCompare(b.storyKey);
    });
    return ordered;
};

});


parcelRegister("9WPl1", function(module, exports) {

$parcel$export(module.exports, "epics", () => $73e15a833e51b7f6$export$e370b88a5502b131);
// Epics index — reads post-B-117 product epics from `public.tickets`
// (type='epic'). Replaces the legacy GitHub-Projects field-option
// index. Rolls up stories + tasks + bugs per epic for a quick overview.

var $7MNpT = parcelRequire("7MNpT");

var $iUi81 = parcelRequire("iUi81");
const $73e15a833e51b7f6$export$e370b88a5502b131 = {
    extends: 'AppPage',
    metadata: {
        title: 'Epics / Tickets / Symbols Workspace'
    },
    fetch: (0, $7MNpT.pageBoilerplateFetch),
    onCreate: async (el, s)=>{
        const tree = await (0, $iUi81.fetchEpicsTree)();
        s.root.update({
            epicsTree: tree
        });
    },
    onRemove: (el)=>{
        const root = el.getRoot();
        if (root && root.selectedTicket) root.update({
            selectedTicket: null
        });
    },
    TicketsSidebar: {},
    TicketsEpicsMain: {},
    TicketsNewTicketModal: {},
    TicketsDetailModal: {}
};

});

parcelRegister("7sHA6", function(module, exports) {

$parcel$export(module.exports, "standups", () => $56ecf4448087becf$export$e8bc12da5d7c67a2);
// Standup history page — shows past daily standup summaries.
// Data loading is handled by TicketsStandupsMain.onCreate.

var $7MNpT = parcelRequire("7MNpT");
const $56ecf4448087becf$export$e8bc12da5d7c67a2 = {
    extends: 'AppPage',
    metadata: {
        title: 'Standups / Tickets / Symbols Workspace'
    },
    fetch: (0, $7MNpT.pageBoilerplateFetch),
    onRemove: (el)=>{
        const root = el.getRoot();
        if (root && root.selectedTicket) root.update({
            selectedTicket: null
        });
    },
    TicketsSidebar: {},
    TicketsStandupsMain: {},
    TicketsDetailModal: {}
};

});

parcelRegister("hkANY", function(module, exports) {

$parcel$export(module.exports, "requests", () => $c9e0daa7995d1b02$export$5dd7af07b99bbd1e);
$parcel$export(module.exports, "requestsInbound", () => $c9e0daa7995d1b02$export$ba6f3026cf8ed34a);
$parcel$export(module.exports, "requestsOutbound", () => $c9e0daa7995d1b02$export$447e5e45d9235b93);
$parcel$export(module.exports, "requestsAudit", () => $c9e0daa7995d1b02$export$922bfd5fd25f26a2);

var $7MNpT = parcelRequire("7MNpT");
const $c9e0daa7995d1b02$export$5dd7af07b99bbd1e = {
    extends: 'AppPage',
    metadata: {
        title: 'Requests / Tickets / Symbols Workspace'
    },
    fetch: (0, $7MNpT.pageBoilerplateFetch),
    onRemove: (el)=>{
        const root = el.getRoot();
        if (root && root.selectedTicket) root.update({
            selectedTicket: null
        });
    },
    TicketsSidebar: {},
    RequestsMain: {},
    TicketsDetailModal: {}
};
const $c9e0daa7995d1b02$export$ba6f3026cf8ed34a = {
    extends: 'AppPage',
    metadata: {
        title: 'Inbound requests / Tickets / Symbols Workspace'
    },
    fetch: (0, $7MNpT.pageBoilerplateFetch),
    onRemove: (el)=>{
        const root = el.getRoot();
        if (root && root.selectedTicket) root.update({
            selectedTicket: null
        });
    },
    TicketsSidebar: {},
    RequestsInboundMain: {},
    TicketsDetailModal: {}
};
const $c9e0daa7995d1b02$export$447e5e45d9235b93 = {
    extends: 'AppPage',
    metadata: {
        title: 'Outbound requests / Tickets / Symbols Workspace'
    },
    fetch: (0, $7MNpT.pageBoilerplateFetch),
    onRemove: (el)=>{
        const root = el.getRoot();
        if (root && root.selectedTicket) root.update({
            selectedTicket: null
        });
    },
    TicketsSidebar: {},
    RequestsOutboundMain: {},
    TicketsDetailModal: {}
};
const $c9e0daa7995d1b02$export$922bfd5fd25f26a2 = {
    extends: 'AppPage',
    metadata: {
        title: 'Requests audit / Tickets / Symbols Workspace'
    },
    fetch: (0, $7MNpT.pageBoilerplateFetch),
    onRemove: (el)=>{
        const root = el.getRoot();
        if (root && root.selectedTicket) root.update({
            selectedTicket: null
        });
    },
    TicketsSidebar: {},
    RequestsAuditMain: {},
    TicketsDetailModal: {}
};

});

parcelRegister("e2MYa", function(module, exports) {

$parcel$export(module.exports, "resolutions", () => $a3973ce46a82ab3e$export$47ca0f3cafc31c27);
$parcel$export(module.exports, "resolutionsEditRequests", () => $a3973ce46a82ab3e$export$eb7c4391536c310a);
$parcel$export(module.exports, "resolutionsImprovements", () => $a3973ce46a82ab3e$export$e91885c45179992e);
// /tickets/resolutions — browse + link resolution tickets.
// Data source: GET /rest/v1/v_resolutions via fetchResolutions().
// Route also covers /improvements + /edit-requests sub-pages.

var $7MNpT = parcelRequire("7MNpT");

var $gcMIy = parcelRequire("gcMIy");
const $a3973ce46a82ab3e$export$47ca0f3cafc31c27 = {
    extends: 'AppPage',
    metadata: {
        title: 'Resolutions / Tickets / Symbols Workspace'
    },
    fetch: (0, $7MNpT.pageBoilerplateFetch),
    onCreate: async (el, s)=>{
        // Clear any stale filter state AND stale modal state from a prior visit.
        // Clearing selectedTicket here (in addition to onRemove) is belt-and-suspenders:
        // onRemove on the departing page handles the navigation case; this guard covers
        // any edge case where selectedTicket is truthy on first render (e.g. deep-link
        // URL without ?ticket= param, or a hot-reload that preserves stale state).
        // Without this clear, TicketsDetailModal.display returns 'flex' immediately and
        // renders a full-viewport black overlay (pointer-events:auto) that blocks all
        // page chrome (org switcher, profile menu, CreateTicket, sidebar nav).
        s.root.update({
            selectedTicket: null,
            ticketDraft: null,
            ticketEditMode: false,
            resolutions: null,
            resFilterQuery: null,
            resFilterAgent: null,
            resFilterDate: null
        });
        const data = await (0, $gcMIy.fetchResolutions)({
            limit: 100
        });
        s.root.update({
            resolutions: data
        });
    },
    onRemove: (el)=>{
        const root = el.getRoot();
        if (root && root.selectedTicket) root.update({
            selectedTicket: null
        });
    },
    TicketsSidebar: {},
    TicketsResolutionsMain: {},
    TicketsDetailModal: {}
};
const $a3973ce46a82ab3e$export$eb7c4391536c310a = {
    extends: 'AppPage',
    metadata: {
        title: 'Edit requests / Resolutions / Symbols Workspace'
    },
    fetch: (0, $7MNpT.pageBoilerplateFetch),
    onCreate: (el, s)=>{
        s.root.update({
            selectedTicket: null,
            ticketDraft: null,
            ticketEditMode: false
        });
    },
    onRemove: (el)=>{
        const root = el.getRoot();
        if (root && root.selectedTicket) root.update({
            selectedTicket: null
        });
    },
    TicketsSidebar: {},
    ResolutionsEditRequestsMain: {},
    TicketsDetailModal: {}
};
const $a3973ce46a82ab3e$export$e91885c45179992e = {
    extends: 'AppPage',
    metadata: {
        title: 'Improvements / Resolutions / Symbols Workspace'
    },
    fetch: (0, $7MNpT.pageBoilerplateFetch),
    onCreate: (el, s)=>{
        s.root.update({
            selectedTicket: null,
            ticketDraft: null,
            ticketEditMode: false
        });
    },
    onRemove: (el)=>{
        const root = el.getRoot();
        if (root && root.selectedTicket) root.update({
            selectedTicket: null
        });
    },
    TicketsSidebar: {},
    ResolutionsImprovementsMain: {},
    TicketsDetailModal: {}
};

});

parcelRegister("giliy", function(module, exports) {

$parcel$export(module.exports, "home", () => $bdced9287cefb390$export$d12a05a2da93ee73);
// Chat home page. AppPage shell + chat-specific fetch blocks +
// realtime subscription wiring in onCreate. Sidebar/Main slots are
// filled from components/*.

var $jg4vi = parcelRequire("jg4vi");
parcelRequire("UgXQ6");

var $7MNpT = parcelRequire("7MNpT");
const $bdced9287cefb390$export$d12a05a2da93ee73 = {
    extends: 'AppPage',
    metadata: {
        title: 'Chat / Symbols Workspace'
    },
    onInit: (el, s)=>{
        if (el.call('redirectIfExternalOnly', s)) return;
    },
    fetch: [
        (0, $7MNpT.ticketColumnsFetch),
        {
            method: 'select',
            from: 'workspaceProject.chat',
            order: 'updated_at',
            as: '~/channels',
            cache: '15s',
            transform: (rows)=>({
                    channels: (rows || []).map((0, $jg4vi.rowToChannel))
                })
        },
        {
            // migrated 2026-04-27 to workspaceProject.chat.members
            method: 'select',
            from: 'workspaceProject.chat.members',
            as: '~/channelMembers',
            cache: '30s',
            transform: (rows)=>({
                    channelMembers: rows || []
                })
        },
        {
            // Initial load: latest 500 messages across channels for fast first paint.
            // Realtime subscription delivers new messages live; older messages can
            // be lazy-loaded on scroll.
            // migrated 2026-04-27 to workspaceProject.chat.messages
            method: 'select',
            from: 'workspaceProject.chat.messages',
            order: 'created_at',
            ascending: false,
            limit: 500,
            as: '~/messagesByChannel',
            cache: '10s',
            transform: (rows)=>{
                const byCh = {};
                for (const r of rows || []){
                    const m = (0, $jg4vi.rowToMessage)(r);
                    if (!byCh[m.channelId]) byCh[m.channelId] = [];
                    byCh[m.channelId].push(m);
                }
                // Reverse each bucket so messages display oldest → newest
                for(const k in byCh)byCh[k].reverse();
                return byCh;
            }
        },
        {
            // Mentions of the current user. The chat_mentions table is populated
            // server-side by the chat_extract_mentions trigger on insert.
            // migrated 2026-04-27 to workspaceProject.chat.mentions
            method: 'select',
            from: 'workspaceProject.chat.mentions',
            order: 'created_at',
            as: '~/myMentions',
            cache: '15s',
            transform: (rows)=>rows || []
        }
    ],
    onCreate: (el, s)=>{
        const root = s.root;
        // Load pinned channels from localStorage
        el.call('loadPinnedChannels');
        // Hash sync — debounced replaceState so rapid state writes coalesce.
        el._syncHash = ()=>{
            if (typeof window === 'undefined') return;
            clearTimeout(el._hashTimer);
            el._hashTimer = setTimeout(()=>{
                const parts = [];
                if (root.activeChannelId) parts.push('channel=' + root.activeChannelId);
                if (root.activeTab && root.activeTab !== 'conversation') parts.push('tab=' + root.activeTab);
                if (root.activeThreadRootId) parts.push('thread=' + root.activeThreadRootId);
                const next = parts.join('&');
                if (window.location.hash.slice(1) !== next) history.replaceState(null, '', '#' + next);
            }, 50);
        };
        // Auto-pick: restore from URL hash or fall back to first channel.
        // Uses a polling timer because `onUpdate` on the page element
        // doesn't re-fire when root.channels populates from the fetch.
        let attempts = 0;
        el._autoPickTimer = setInterval(()=>{
            attempts++;
            if (root.activeChannelId || attempts > 50) {
                clearInterval(el._autoPickTimer);
                return;
            }
            if (!(root.channels || []).length || !(root.channelMembers || []).length) return;
            clearInterval(el._autoPickTimer);
            // Try URL hash first.
            const hash = window.location.hash.slice(1);
            const params = new URLSearchParams(hash);
            const urlChannel = params.get('channel');
            const urlTab = params.get('tab');
            const urlThread = params.get('thread');
            // Restore profile modal from query string (?profile=email)
            const qp = new URLSearchParams(window.location.search);
            const profileParam = qp.get('profile');
            if (profileParam && !root.profileEmail) root.update({
                profileEmail: profileParam
            });
            if (urlChannel) root.update({
                activeChannelId: urlChannel,
                activeTab: urlTab || 'conversation',
                activeThreadRootId: urlThread ? parseInt(urlThread, 10) : null
            });
            else {
                const me = root.currentUserEmail;
                const myIds = new Set(root.channelMembers.filter((m)=>m.member_email === me).map((m)=>m.channel_id));
                const first = root.channels.find((c)=>myIds.has(c.id));
                if (first) {
                    root.update({
                        activeChannelId: first.id,
                        activeTab: 'conversation'
                    });
                    el.call('markRead', first.id);
                }
            }
            if (el._syncHash) el._syncHash();
        }, 150);
        // Mention-pick: pointerdown fires BEFORE blur so mentionPicker state
        // is still populated. The DOM write runs in setTimeout(0) after DOMQL's
        // reactive flush from the mentionPicker→null state change.
        el._mentionPickHandler = (ev)=>{
            const pickEl = ev.target.closest('[data-mention-pick]');
            if (!pickEl) return;
            ev.preventDefault();
            ev.stopPropagation();
            const picker = root.mentionPicker;
            if (!picker) return;
            const value = pickEl.getAttribute('data-mention-pick');
            if (!value) return;
            // Determine insertion text based on picker type.
            const type = picker.type || 'person';
            let insert = '';
            if (type === 'person') insert = '@' + value.split('@')[0] + ' ';
            else if (type === 'channel') insert = '#' + value + ' ';
            else if (type === 'ticket') insert = '##' + value + ' ';
            else if (type === 'event') insert = '@@' + value + ' ';
            else if (type === 'reference') insert = '+' + value + ' ';
            // Snapshot trigger boundaries before nulling picker.
            const { start: start, end: end } = picker;
            root.update({
                mentionPicker: null
            });
            // Replace the trigger text in the editor after DOMQL flush.
            setTimeout(()=>{
                const editor = document.querySelector('[data-composer-input]');
                if (!editor) return;
                const walker = document.createTreeWalker(editor, NodeFilter.SHOW_TEXT);
                let textNode;
                let offset = 0;
                while(textNode = walker.nextNode()){
                    const len = textNode.textContent.length;
                    if (offset + len >= start) {
                        const localStart = start - offset;
                        const localEnd = Math.min(end - offset, len);
                        textNode.textContent = textNode.textContent.slice(0, localStart) + insert + textNode.textContent.slice(localEnd);
                        // Place caret after inserted text.
                        const sel = window.getSelection();
                        const r = document.createRange();
                        r.setStart(textNode, localStart + insert.length);
                        r.collapse(true);
                        sel.removeAllRanges();
                        sel.addRange(r);
                        break;
                    }
                    offset += len;
                }
            }, 0);
        };
        document.addEventListener('pointerdown', el._mentionPickHandler, true);
        // Open the realtime subscription.
        el._chatChannel = el.call('subscribeRealtime');
        // Lazy-resolve the WYSIWYG editor node for mention-pick. Can't
        // resolve at onCreate time because Footer mounts later. The getter
        // caches on first successful lookup.
        el._getEditor = ()=>{
            // Always re-query — the editor can remount across channel switches.
            return document.querySelector('[contenteditable="true"]');
        };
        // Document-level delegated click listener: any element with `data-cid`
        // anywhere in the chat tree becomes the active channel when clicked.
        // This bypasses an apparent v3.14 quirk where onClick on rows generated via
        // `childExtends` + reactive `children` does not get bound at all.
        el._cidClickHandler = (ev)=>{
            // Skip if clicking the MoreBtn or its portal — let the dropdown handle it
            if (ev.target.closest('[data-key="MoreBtn"]') || ev.target.closest('[data-sidebar-portal]')) return;
            const node = ev.target && ev.target.closest && ev.target.closest('[data-cid]');
            if (!node) return;
            const cid = node.getAttribute('data-cid');
            if (!cid) return;
            // Switching channels always resets to the Conversation tab —
            // landing on Files/Links/Tickets after a channel switch is jarring.
            root.update({
                activeChannelId: cid,
                activeThreadRootId: null,
                activeTab: 'conversation'
            });
            el.call('markRead', cid);
            el.call('markMentionsRead', cid);
            if (el._syncHash) el._syncHash();
        };
        document.addEventListener('click', el._cidClickHandler, true);
        // Same delegation pattern for AppPersonRow → SharedPersonCard. The row
        // tags itself with `data-email`; we look the email up against root.people
        // and write the full person card payload to root.selectedPerson with the
        // row's bounding rect for positioning.
        el._personClickHandler = (ev)=>{
            const node = ev.target && ev.target.closest && ev.target.closest('[data-personrow]');
            if (!node) return;
            const email = node.getAttribute('data-email');
            if (!email) return;
            const person = (root.people || []).find((p)=>p.email === email);
            if (!person) return;
            const rect = node.getBoundingClientRect();
            const CARD_W = 320;
            const CARD_H = 280;
            const M = 8;
            const vw = window.innerWidth;
            const vh = window.innerHeight;
            let x = rect.right + M;
            let y = rect.top;
            if (x + CARD_W > vw) x = Math.max(M, rect.left - CARD_W - M);
            if (y + CARD_H > vh) y = Math.max(M, vh - CARD_H - M);
            root.update({
                selectedPerson: {
                    name: person.name,
                    email: person.email,
                    avatar: person.avatar,
                    location: person.location,
                    timezone: person.timezone,
                    x: x,
                    y: y
                }
            });
        };
        document.addEventListener('click', el._personClickHandler, true);
        // Generic action delegation: every interactive bit in the chat tree
        // tags itself with `data-action`/`data-toggle-group`/etc. and the
        // listeners below resolve them. This avoids the v3.14 binding pitfall and
        // keeps event wiring in one place.
        el._actionClickHandler = (ev)=>{
            const t = ev.target;
            if (!t || !t.closest) return;
            // Action buttons (new-message, new-channel, open-search, close-search…).
            const actionNode = t.closest('[data-action]');
            if (actionNode) {
                const action = actionNode.getAttribute('data-action');
                if (action === 'new-message' || action === 'new-channel' || action === 'new-group') {
                    const kind = action === 'new-channel' ? 'channel' : action === 'new-group' ? 'group_dm' : 'dm';
                    root.update({
                        showNewChannel: true,
                        newChannelDraft: {
                            name: '',
                            topic: '',
                            kind: kind,
                            is_private: false,
                            members: []
                        }
                    });
                    ev.stopPropagation();
                    return;
                }
                if (action === 'open-search') {
                    root.update({
                        searchOpen: true,
                        searchQuery: '',
                        searchResults: []
                    });
                    // Focus the search input on the next tick.
                    requestAnimationFrame(()=>{
                        const inp = document.querySelector('[data-search-scrim] input');
                        if (inp) inp.focus();
                    });
                    ev.stopPropagation();
                    return;
                }
                if (action === 'close-search') {
                    root.update({
                        searchOpen: false,
                        searchQuery: '',
                        searchResults: []
                    });
                    ev.stopPropagation();
                    return;
                }
                if (action === 'toggle-filter-bar') {
                    root.update({
                        showFilterBar: !root.showFilterBar
                    });
                    ev.stopPropagation();
                    return;
                }
                if (action === 'close-thread') {
                    root.update({
                        activeThreadRootId: null
                    });
                    if (el._syncHash) el._syncHash();
                    ev.stopPropagation();
                    return;
                }
                if (action === 'filters-clear') {
                    root.update({
                        filters: {
                            authorEmail: null,
                            hasAttachments: false,
                            hasMentions: false,
                            query: ''
                        }
                    });
                    // Reset the uncontrolled search input + author select using the
                    // event delegate's actionNode as a stable anchor — no global
                    // querySelector required.
                    const bar = actionNode.closest && actionNode.closest('[data-filter-bar]');
                    if (bar) {
                        const inp = bar.querySelector('input');
                        if (inp) inp.value = '';
                        const sel = bar.querySelector('select');
                        if (sel) sel.value = '';
                    }
                    ev.stopPropagation();
                    return;
                }
                if (action === 'open-mentions') {
                    // Jump to the channel that owns the most recent unread mention.
                    const unread = (root.myMentions || []).filter((m)=>!m.read_at);
                    if (!unread.length) return;
                    const last = unread[unread.length - 1];
                    // Find which channel contains this message_id (search loaded buckets).
                    let cid = null;
                    for (const k of Object.keys(root.messagesByChannel || {}))if ((root.messagesByChannel[k] || []).some((m)=>m.id === last.message_id)) {
                        cid = k;
                        break;
                    }
                    if (cid) {
                        root.update({
                            activeChannelId: cid,
                            activeThreadRootId: null,
                            activeTab: 'conversation'
                        });
                        el.call('markRead', cid);
                        if (el._syncHash) el._syncHash();
                        el.call('markMentionsRead', cid);
                    }
                    ev.stopPropagation();
                    return;
                }
            }
            // Sidebar group caret toggles.
            const groupNode = t.closest('[data-toggle-group]');
            if (groupNode) {
                const name = groupNode.getAttribute('data-toggle-group');
                const cur = root.collapsedGroups || {};
                root.update({
                    collapsedGroups: {
                        ...cur,
                        [name]: !cur[name]
                    }
                });
                ev.stopPropagation();
                return;
            }
            // Tab selection (conversation / files / links / tickets).
            const tabNode = t.closest('[data-tab-select]');
            if (tabNode) {
                const tab = tabNode.getAttribute('data-tab-select');
                if (tab) {
                    root.update({
                        activeTab: tab
                    });
                    if (el._syncHash) el._syncHash();
                    ev.stopPropagation();
                }
                return;
            }
            // Filter toggle pills (hasAttachments, hasMentions).
            const filterNode = t.closest('[data-filter-toggle]');
            if (filterNode) {
                const field = filterNode.getAttribute('data-filter-toggle');
                if (field) {
                    root.update({
                        filters: {
                            ...root.filters,
                            [field]: !(root.filters && root.filters[field])
                        }
                    });
                    ev.stopPropagation();
                }
                return;
            }
            // Open thread for a message (from MessageList Reply or ThreadLink).
            const threadNode = t.closest('[data-thread-open]');
            if (threadNode) {
                const id = parseInt(threadNode.getAttribute('data-thread-open'), 10);
                if (!isNaN(id)) {
                    root.update({
                        activeThreadRootId: id
                    });
                    if (el._syncHash) el._syncHash();
                    ev.stopPropagation();
                    return;
                }
            }
            // Channel link click — navigate to the referenced channel.
            const channelLink = t.closest('[data-channel-link]');
            if (channelLink) {
                const cid = channelLink.getAttribute('data-channel-link');
                if (cid) {
                    root.update({
                        activeChannelId: cid,
                        activeTab: 'conversation'
                    });
                    el.call('markRead', cid);
                    if (el._syncHash) el._syncHash();
                    ev.stopPropagation();
                    return;
                }
            }
            // Ticket reference card click — navigate to ticket detail.
            const ticketRef = t.closest('[data-ref-ticket]');
            if (ticketRef) {
                const num = ticketRef.getAttribute('data-ref-ticket');
                if (num) {
                    let rootEl = el;
                    while(rootEl && !rootEl.routes)rootEl = rootEl.parent;
                    const router = el.context?.utils?.router;
                    if (router && rootEl) router('/tickets?ticket=' + num, rootEl, {}, {
                        pushState: true
                    });
                    ev.stopPropagation();
                    return;
                }
            }
            // Event reference card click — navigate to calendar.
            const eventRef = t.closest('[data-ref-event]');
            if (eventRef) {
                const title = eventRef.getAttribute('data-ref-event');
                if (title) {
                    let rootEl = el;
                    while(rootEl && !rootEl.routes)rootEl = rootEl.parent;
                    const router = el.context?.utils?.router;
                    if (router && rootEl) router('/calendar', rootEl, {}, {
                        pushState: true
                    });
                    ev.stopPropagation();
                    return;
                }
            }
            // Doc/note reference card click — navigate to documents.
            const docRef = t.closest('[data-ref-doc]');
            if (docRef) {
                const id = docRef.getAttribute('data-ref-doc');
                if (id) {
                    let rootEl = el;
                    while(rootEl && !rootEl.routes)rootEl = rootEl.parent;
                    const router = el.context?.utils?.router;
                    if (router && rootEl) router('/documents?doc=' + encodeURIComponent(id), rootEl, {}, {
                        pushState: true
                    });
                    ev.stopPropagation();
                    return;
                }
            }
            // Pending attachment chip remove.
            const removeNode = t.closest('[data-attachment-remove]');
            if (removeNode) {
                const aid = removeNode.getAttribute('data-attachment-remove');
                const ch = root.activeChannelId;
                if (aid && ch) {
                    const next = (root.pendingAttachments[ch] || []).filter((a)=>a.id !== aid);
                    root.update({
                        pendingAttachments: {
                            ...root.pendingAttachments,
                            [ch]: next
                        }
                    });
                    ev.stopPropagation();
                    return;
                }
            }
            // Search result jump.
            const jumpNode = t.closest('[data-search-jump]');
            if (jumpNode) {
                const msgId = parseInt(jumpNode.getAttribute('data-search-jump'), 10);
                if (!isNaN(msgId)) {
                    // Find which channel this message belongs to.
                    for (const r of root.searchResults || [])if (r.id === msgId) {
                        root.update({
                            activeChannelId: r.channel_id,
                            activeThreadRootId: null,
                            activeTab: 'conversation',
                            searchOpen: false,
                            searchQuery: '',
                            searchResults: []
                        });
                        break;
                    }
                    ev.stopPropagation();
                    return;
                }
            }
            // Inline link click — open in a new tab.
            const linkNode = t.closest('[data-link]');
            if (linkNode) {
                const url = linkNode.getAttribute('data-link');
                if (url) {
                    window.open(url, '_blank', 'noopener');
                    ev.preventDefault();
                    ev.stopPropagation();
                    return;
                }
            }
            // Click outside the search overlay → close.
            if (t.matches && t.matches('[data-search-scrim]')) root.update({
                searchOpen: false,
                searchQuery: '',
                searchResults: []
            });
        };
        document.addEventListener('click', el._actionClickHandler, true);
        // Global ⌘K / Ctrl+K opens search.
        el._keyHandler = (ev)=>{
            if ((ev.metaKey || ev.ctrlKey) && (ev.key === 'k' || ev.key === 'K')) {
                ev.preventDefault();
                root.update({
                    searchOpen: true,
                    searchQuery: '',
                    searchResults: []
                });
                requestAnimationFrame(()=>{
                    const inp = document.querySelector('[data-search-scrim] input');
                    if (inp) inp.focus();
                });
            }
            if (ev.key === 'Escape' && root.searchOpen) root.update({
                searchOpen: false,
                searchQuery: '',
                searchResults: []
            });
        };
        document.addEventListener('keydown', el._keyHandler, true);
    },
    onRemove: (el)=>{
        if (el._chatChannel) try {
            el._chatChannel.unsubscribe();
        } catch (_) {}
        if (el._cidClickHandler) document.removeEventListener('click', el._cidClickHandler, true);
        // sidebar-action handler removed — actions handled by ChatSidebarDropdownItem
        if (el._personClickHandler) document.removeEventListener('click', el._personClickHandler, true);
        if (el._actionClickHandler) document.removeEventListener('click', el._actionClickHandler, true);
        if (el._mentionPickHandler) document.removeEventListener('pointerdown', el._mentionPickHandler, true);
        if (el._keyHandler) document.removeEventListener('keydown', el._keyHandler, true);
    },
    ChatSidebar: {},
    ChatMain: {},
    ChatSidebarDropdown: {},
    ChatRenameModal: {},
    ChatNewChannelModal: {},
    ChatChannelSettingsModal: {},
    ChatSearchPanel: {},
    ChatMentionDropdown: {},
    TicketsNewTicketModal: {},
    TicketsDetailModal: {},
    // SharedPersonCard from shared-gov, with chat-specific Actions: a Message
    // button that opens (or creates) a 1:1 DM with the selected person, and a
    // Profile placeholder for parity with calendar's card.
    PersonCard: {
        extends: 'SharedPersonCard',
        Actions: {
            MessageBtn: {
                tag: 'button',
                text: 'Message',
                flex: '1',
                padding: 'Z A',
                round: 'Z',
                border: 'none',
                theme: 'primary',
                cursor: 'pointer',
                fontSize: 'Z2',
                fontWeight: '600',
                ':hover': {
                    opacity: '.9'
                },
                onClick: (e, el, s)=>{
                    const root = s && s.root;
                    const email = root && root.selectedPerson && root.selectedPerson.email;
                    if (!email) return;
                    el.call('messageUser', email);
                }
            },
            ProfileBtn: {
                tag: 'button',
                text: 'Profile',
                flex: '1',
                padding: 'Z A',
                round: 'Z',
                theme: 'secondary',
                borderWidth: '1px',
                borderColor: 'line',
                borderStyle: 'solid',
                cursor: 'pointer',
                fontSize: 'Z2',
                fontWeight: '500',
                ':hover': {
                    background: 'overlay'
                },
                onClick: (e, el, s)=>{
                    const root = s && s.root;
                    const email = root && root.selectedPerson && root.selectedPerson.email;
                    if (!root) return;
                    root.update({
                        selectedPerson: null,
                        profileEmail: email
                    });
                }
            }
        }
    }
};

});

parcelRegister("bHGYW", function(module, exports) {

$parcel$export(module.exports, "home", () => $88550d27086baae4$export$d12a05a2da93ee73);
parcelRequire("chzVb");
var $dDXET = parcelRequire("dDXET");
const $88550d27086baae4$export$d12a05a2da93ee73 = {
    extends: 'AppPage',
    metadata: {
        title: 'Documents / Symbols Workspace'
    },
    onInit: (el, s)=>{
        if (el.call('redirectIfExternalOnly', s)) return;
    },
    fetch: [
        (0, $dDXET.documentsFetch),
        (0, $dDXET.notesFetch),
        (0, $dDXET.kbArticlesFetch)
    ],
    onCreate: (el)=>{
        el._presenceUnsub = el.call('useOnlinePresence', {
            app: 'documents'
        });
    },
    onRemove: (el)=>{
        if (el._presenceUnsub) el._presenceUnsub();
    },
    DocsSidebar: {},
    DocsMain: {}
};

});

parcelRegister("jCCTJ", function(module, exports) {

$parcel$export(module.exports, "notes", () => $e48fbd3b2f1906f7$export$fff9cb9cb797a870);

var $dDXET = parcelRequire("dDXET");
const $e48fbd3b2f1906f7$export$fff9cb9cb797a870 = {
    extends: 'AppPage',
    metadata: {
        title: 'Notes / Documents / Symbols Workspace'
    },
    fetch: [
        (0, $dDXET.documentsFetch),
        (0, $dDXET.notesFetch),
        (0, $dDXET.kbArticlesFetch)
    ],
    DocsSidebar: {},
    NotesMain: {}
};

});

parcelRegister("72ZTw", function(module, exports) {

$parcel$export(module.exports, "knowledgeBase", () => $5218bb429e5cfd79$export$e8a23ad62a8e8cc6);

var $dDXET = parcelRequire("dDXET");
const $5218bb429e5cfd79$export$e8a23ad62a8e8cc6 = {
    extends: 'AppPage',
    metadata: {
        title: 'Knowledge base / Documents / Symbols Workspace'
    },
    fetch: [
        (0, $dDXET.documentsFetch),
        (0, $dDXET.notesFetch),
        (0, $dDXET.kbArticlesFetch)
    ],
    DocsSidebar: {},
    KnowledgeBaseMain: {}
};

});

parcelRegister("d9Ira", function(module, exports) {

$parcel$export(module.exports, "editor", () => $993e95ed603ea1ff$export$b5d042d2b680aed6);

var $dDXET = parcelRequire("dDXET");
const $993e95ed603ea1ff$var$_restoreFromHash = (el, s)=>{
    const root = s.root;
    if (root.editorDoc) return; // already loaded via click
    if (typeof window === 'undefined') return;
    const hash = window.location.hash.slice(1);
    if (!hash) return;
    const params = new URLSearchParams(hash);
    const docId = params.get('doc');
    const noteId = params.get('note');
    const kbId = params.get('kb');
    const tryRestore = ()=>{
        if (docId) {
            const doc = (root.documents || []).find((d)=>String(d.id) === docId);
            if (doc) {
                const content = doc.content && typeof doc.content === 'object' ? doc.content : {
                    blocks: []
                };
                root.update({
                    editorDoc: {
                        id: doc.id,
                        title: doc.title,
                        content: content
                    },
                    editorMode: 'view',
                    activeSection: 'editor'
                });
                return true;
            }
        }
        if (noteId) {
            const note = (root.notes || []).find((n)=>String(n.id) === noteId);
            if (note) {
                const content = note.content && typeof note.content === 'object' ? note.content : {
                    blocks: []
                };
                root.update({
                    selectedNoteId: note.id,
                    editorDoc: {
                        id: note.id,
                        title: note.title || 'Untitled note',
                        content: content,
                        source: note.source || 'member',
                        author: note.author
                    },
                    editorMode: 'view',
                    activeSection: 'editor'
                });
                return true;
            }
        }
        if (kbId) {
            const kb = (root.kbArticles || []).find((a)=>String(a.id) === kbId);
            if (kb) {
                const content = kb.content && typeof kb.content === 'object' ? kb.content : {
                    blocks: []
                };
                root.update({
                    editorDoc: {
                        id: kb.id,
                        title: kb.title,
                        content: content,
                        source: 'kb'
                    },
                    editorMode: 'view',
                    activeSection: 'editor'
                });
                return true;
            }
        }
        return false;
    };
    if (tryRestore()) return;
    // Data may not be fetched yet — retry a few times
    let attempts = 0;
    const t = setInterval(()=>{
        if (tryRestore() || ++attempts > 15) clearInterval(t);
    }, 300);
    el._editorRestoreTimer = t;
};
const $993e95ed603ea1ff$export$b5d042d2b680aed6 = {
    extends: 'AppPage',
    metadata: (el, s)=>{
        const doc = s.root?.editorDoc;
        const title = doc?.title || 'Editor';
        return {
            title: title + ' / Documents / Symbols Workspace'
        };
    },
    fetch: [
        (0, $dDXET.documentsFetch),
        (0, $dDXET.notesFetch),
        (0, $dDXET.kbArticlesFetch)
    ],
    onCreate: (el, s)=>$993e95ed603ea1ff$var$_restoreFromHash(el, s),
    onRemove: (el)=>{
        if (el._editorRestoreTimer) clearInterval(el._editorRestoreTimer);
    },
    DocsSidebar: {},
    EditorMain: {}
};

});

parcelRegister("6BYXL", function(module, exports) {

$parcel$export(module.exports, "home", () => $4d057cbdbc3b7bfa$export$d12a05a2da93ee73);
// /meet — single page that hosts list, in-call, and transcript views.
// Sub-views are state-driven via root.meetView ('list' | 'call' | 'transcript').
// URL hash mirrors state (#room=<uuid>&view=call|transcript) for share-link
// + back-button support. Same convention chat uses for #channel/#thread/#tab.
//
// **LiveKit Room lifecycle is imperative, not reactive.** Click handlers on
// MeetRoomRow / Main.Join / NewRoomModal submit call `connectCall`, and
// ControlBar.Leave calls `disconnectCall`. DOMQL v3.14 doesn't fire onUpdate
// reliably on root state changes and doesn't fire onCreate on `if:`/`extends:`
// children, so reactive lifecycle isn't an option. Chat / calendar follow
// the same pattern (imperative action functions driven by click handlers).

var $UgXQ6 = parcelRequire("UgXQ6");

var $fM8BY = parcelRequire("fM8BY");

var $7MNpT = parcelRequire("7MNpT");
const $4d057cbdbc3b7bfa$export$d12a05a2da93ee73 = {
    extends: 'AppPage',
    metadata: {
        title: 'Meet / Symbols Workspace'
    },
    fetch: [
        ...(0, $UgXQ6.appPageBoilerplateFetch),
        {
            method: 'select',
            from: 'workspaceProject.meet.rooms',
            order: 'created_at',
            ascending: false,
            as: '~/rooms',
            cache: '15s',
            transform: (rows)=>({
                    rooms: (rows || []).map((0, $fM8BY.rowToRoom))
                })
        },
        // Ticket columns — needed so TicketsDetailModal shows column labels
        // when the user creates a ticket from a meet suggestion. Lightweight
        // reference data; cached for 5 minutes.
        {
            method: 'select',
            from: 'workspaceProject.ticketColumns',
            order: 'position',
            as: '~/columns',
            cache: '5m',
            transform: (rows)=>({
                    columns: (rows || []).map((0, $7MNpT.rowToColumn))
                })
        },
        // Initial load of pending waiting-room rows so the host sees guests
        // who requested while the page was closed/reloading. Realtime keeps it
        // fresh after this. No filter — host may own multiple rooms.
        {
            method: 'select',
            from: 'workspaceProject.meet.waitingRoom',
            as: '~/waitingRoom',
            transform: (rows)=>{
                const map = {};
                for (const r of rows || []){
                    const g = {
                        id: r.id,
                        roomId: r.room_id,
                        guestName: r.guest_name || 'Guest',
                        guestEmail: r.guest_email || null,
                        requestedAt: r.requested_at,
                        admittedAt: r.admitted_at,
                        rejectedAt: r.rejected_at
                    };
                    if (!map[g.roomId]) map[g.roomId] = [];
                    map[g.roomId].push(g);
                }
                return {
                    waitingRoom: map
                };
            }
        }
    ],
    onCreate: (el, s)=>{
        const root = s.root;
        // Seed state from URL hash on mount. #room=<uuid>&view=call → activeRoomId
        // + meetView get set. If view=call and the hash is fresh (direct navigation
        // or reload while in a call), also fire connectCall to actually join.
        let seedView = 'list';
        let seedRoom = null;
        if (typeof window !== 'undefined') {
            const hash = window.location.hash.slice(1);
            const params = new URLSearchParams(hash);
            const r = params.get('room');
            seedRoom = r && r !== 'null' && r !== 'undefined' ? r : null;
            const viewParam = params.get('view');
            if (viewParam === 'call' || viewParam === 'transcript') seedView = viewParam;
        }
        root.update({
            activeRoomId: seedRoom,
            meetView: seedRoom ? seedView : 'list',
            // Default live captions to visible when transcription is on.
            // Undefined treated as true in the hide: check.
            showLiveCaptions: true,
            // Ensure utterances is an empty array (not undefined) so
            // realtime INSERT events can append without the appenders
            // needing to initialize it first.
            utterances: [],
            // Seed the new-room draft so MeetNewRoomModal's reactive getters
            // (value:, theme:, text:) don't hit `undefined.newRoomDraft` on
            // initial render. The modal stays hidden until showNewRoom=true
            // but its factories are still evaluated for dependency tracking.
            newRoomDraft: {
                name: '',
                kind: 'room',
                transcribeEnabled: true,
                isPrivate: false
            }
        });
        // Subscribe to meet_rooms AND meet_participants across ALL rooms (no
        // roomId filter) — the room list needs to show a "LIVE" badge on any
        // room that has unended participants, so we need participant events
        // for every room the user can see. The extra event volume is low:
        // participant insert/update fires only on join/leave.
        // Also subscribe to meet_waiting_room so the host sees pending guest
        // requests across every room they own — the banner needs to appear
        // even if the host isn't already in the call when the guest clicks.
        // TODO[sdk-realtime]: route through SDK realtime once entity subscribe
        // is wired (currently uses direct Supabase realtime channel).
        el.call('subscribeMeetRealtime', {
            tables: [
                'meet_rooms',
                'meet_participants',
                'meet_waiting_room'
            ]
        });
        if (seedView === 'call' && seedRoom) el.call('connectCall', seedRoom);
    },
    // Re-establish the broad (no-roomId) subscription when returning to the
    // list view. TranscriptPage.onUpdate may have narrowed the scope to a
    // specific roomId; going "Back to calls" doesn't reset it automatically
    // because pages/meet.js has no onUpdate. This ensures the host always
    // receives waiting-room events for ALL their rooms while on list view.
    //
    // Also drives transcript analysis: DOMQL storeUpdate fires onUpdate only
    // on state.__element (the page root), NOT on child components. So
    // TranscriptPage.onUpdate never fires from root state changes — we trigger
    // analysis here instead, mirroring the _tryJoinPresence pattern in
    // pages/calendar.js.
    onUpdate: (el, s)=>{
        if (s.root?.meetView === 'list') // TODO[sdk-realtime]: route through SDK realtime once entity subscribe
        // is wired (currently uses direct Supabase realtime channel).
        el.call('subscribeMeetRealtime', {
            tables: [
                'meet_rooms',
                'meet_participants',
                'meet_waiting_room'
            ]
        });
        if (s.root?.meetView === 'transcript') {
            const root = s.root;
            if (!root.activeRoomId) return;
            if (root.analysis || root._meetAnalyzeInFlight || root.analyzeError || root.analyzing) return;
            // Wait for the cached analysis fetch to resolve before hitting the edge
            // function. `analysis` is `undefined` while the fetch is in-flight and
            // `null` once resolved with no row — firing before resolution produces
            // a redundant round-trip.
            if (root.analysis === undefined) return;
            // Trust the server: analyzeTranscript returns 422 for the "no rows yet"
            // case. Don't gate on a client-side utterances filter — that race-
            // conditions against the TranscriptPage fetch resolving.
            root.update({
                analyzing: true,
                transcriptPending: false,
                _meetAnalyzeInFlight: true
            });
            el.call('analyzeTranscript', root.activeRoomId).then((res)=>root.update({
                    analyzing: false,
                    analysis: res,
                    _meetAnalyzeInFlight: false
                })).catch((err)=>{
                const reason = err?.message || 'analysis failed';
                const isPending = err?.status === 422 || /no transcript/i.test(reason);
                root.update({
                    analyzing: false,
                    _meetAnalyzeInFlight: false,
                    transcriptPending: isPending ? true : false,
                    analyzeError: isPending ? null : reason
                });
            });
        }
    },
    MeetSidebar: {},
    MeetMain: {},
    MeetNewRoomModal: {},
    MeetRoomSettingsModal: {},
    MeetSuggestionConfirmModal: {},
    // Native modals pre-filled by openSuggestionModal when the user clicks
    // a ticket or calendar suggestion on the transcript page.
    TicketsDetailModal: {},
    CalNewBookingModal: {}
};

});

parcelRegister("jHQvm", function(module, exports) {

$parcel$export(module.exports, "guest", () => $e58ac2d7f6d11479$export$95ea1694ae1caefc);
// /meet-guest — public entry point for external participants to join a
// PUBLIC meet room without a governance Supabase session. Excluded from
// redirectIfUnauthed via the publicPathPrefixes allowlist in app.js.
//
// Flow (waiting-room-gated):
//  1. User lands on /meet-guest#room=<uuid> (shareable link from a public
//     room's host).
//  2. Page fetches room metadata via a lightweight lookup and shows the
//     required fields (name, maybe email, maybe password) per guest_require_*
//     columns.
//  3. Submit calls meet-guest-request which writes a meet_waiting_room row
//     and returns { waitingId, autoAdmitted }. If guest_auto_admit is on,
//     the page skips directly to minting a token; otherwise it shows a
//     "waiting for host to admit you" spinner and polls meet-guest-status.
//  4. Once admitted, meet-guest-token is called with { roomId, waitingId }
//     and the page connects to LiveKit + renders the call area.
//  5. Rejected → show "access denied" screen with a retry button.
//
// The page does NOT extend AppPage — there's no header, no sidebar, no
// nav. It's a standalone call screen. The intranet's app.js fetches still
// fire on mount but RLS returns empty for anon users, so no crash.

var $lGaRB = parcelRequire("lGaRB");

var $8oZGw = parcelRequire("8oZGw");
const $e58ac2d7f6d11479$var$PROJECT_ID = 'becrzpqaiovbvfmrosro';
const $e58ac2d7f6d11479$var$PUBLISHABLE_KEY = 'sb_publishable_suMZ-1Crw-304sk_MY-VZA_8aU6ZFfa';
// Guest endpoints are anonymous — the user has not signed in (and may
// never sign in). The guest flow hits three edge functions:
//   - meet-guest-request: submit name/email/password, returns waitingId
//   - meet-guest-status: poll admission state for the host's decision
//   - meet-guest-token: mint LiveKit token after the host admits the guest
//
// Each takes a publishable Supabase key + waitingId — no Bearer JWT.
// The SDK can't carry this flow because every workspace SDK route requires
// an authenticated session. Once a dedicated /workspace/meet-guest/* surface
// is added to the wrapper (with anonymous capability + per-room secret
// validation), this _edgeFetch can be replaced with
// getSDK().execute('workspaceProject.meet.guest', op, payload). For now
// the raw fetch stays — guest auth fundamentally bypasses the SDK auth model.
const $e58ac2d7f6d11479$var$_edgeFetch = async (fn, body)=>{
    const res = await fetch(`https://${$e58ac2d7f6d11479$var$PROJECT_ID}.supabase.co/functions/v1/${fn}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            apikey: $e58ac2d7f6d11479$var$PUBLISHABLE_KEY,
            Authorization: `Bearer ${$e58ac2d7f6d11479$var$PUBLISHABLE_KEY}`
        },
        body: JSON.stringify(body)
    });
    const json = await res.json().catch(()=>({}));
    if (!res.ok) throw new Error(json.error || `HTTP ${res.status}`);
    return json;
};
// Read #room=<uuid> from the URL hash.
const $e58ac2d7f6d11479$var$_readRoomFromHash = ()=>{
    if (typeof window === 'undefined') return null;
    const params = new URLSearchParams(window.location.hash.slice(1));
    return params.get('room');
};
// Module-level live Room — state can't hold class instances with methods.
let $e58ac2d7f6d11479$var$_guestRoom = null;
let $e58ac2d7f6d11479$var$_pollTimer = null;
const $e58ac2d7f6d11479$var$_stopPolling = ()=>{
    if ($e58ac2d7f6d11479$var$_pollTimer) {
        clearInterval($e58ac2d7f6d11479$var$_pollTimer);
        $e58ac2d7f6d11479$var$_pollTimer = null;
    }
};
const $e58ac2d7f6d11479$var$_refreshGuestParticipants = (root, livekitRoom)=>{
    const local = livekitRoom.localParticipant;
    const remoteValues = typeof livekitRoom.remoteParticipants?.values === 'function' ? livekitRoom.remoteParticipants.values() : Object.values(livekitRoom.remoteParticipants || {});
    const remote = Array.from(remoteValues).filter((p)=>typeof p.identity === 'string' && !p.identity.startsWith('agent-'));
    root.update({
        livekitParticipants: [
            {
                identity: local.identity,
                name: local.name || local.identity,
                isLocal: true,
                isMicEnabled: local.isMicrophoneEnabled,
                isCameraEnabled: local.isCameraEnabled
            },
            ...remote.map((p)=>({
                    identity: p.identity,
                    name: p.name || p.identity,
                    isLocal: false,
                    isMicEnabled: p.isMicrophoneEnabled,
                    isCameraEnabled: p.isCameraEnabled
                }))
        ]
    });
};
const $e58ac2d7f6d11479$var$_connectGuest = async ({ roomId: roomId, waitingId: waitingId, root: root })=>{
    try {
        const tokenInfo = await $e58ac2d7f6d11479$var$_edgeFetch('meet-guest-token', {
            roomId: roomId,
            waitingId: waitingId
        });
        const livekitRoom = (0, $8oZGw.buildLivekitRoom)(1);
        const refresh = ()=>$e58ac2d7f6d11479$var$_refreshGuestParticipants(root, livekitRoom);
        livekitRoom.on((0, $lGaRB.RoomEvent).ParticipantConnected, refresh);
        livekitRoom.on((0, $lGaRB.RoomEvent).ParticipantDisconnected, refresh);
        livekitRoom.on((0, $lGaRB.RoomEvent).TrackSubscribed, refresh);
        livekitRoom.on((0, $lGaRB.RoomEvent).TrackUnsubscribed, refresh);
        livekitRoom.on((0, $lGaRB.RoomEvent).TrackMuted, refresh);
        livekitRoom.on((0, $lGaRB.RoomEvent).TrackUnmuted, refresh);
        livekitRoom.on((0, $lGaRB.RoomEvent).LocalTrackPublished, refresh);
        livekitRoom.on((0, $lGaRB.RoomEvent).LocalTrackUnpublished, refresh);
        livekitRoom.on((0, $lGaRB.RoomEvent).Disconnected, ()=>{
            $e58ac2d7f6d11479$var$_guestRoom = null;
            root.update({
                guestConnected: false,
                livekitParticipants: []
            });
        });
        await livekitRoom.connect(tokenInfo.livekitUrl, tokenInfo.livekitToken);
        try {
            await livekitRoom.localParticipant.setMicrophoneEnabled(true);
        } catch (err) {
            console.warn('mic', err);
        }
        try {
            await livekitRoom.localParticipant.setCameraEnabled(true);
        } catch (err) {
            console.warn('cam', err);
        }
        $e58ac2d7f6d11479$var$_guestRoom = livekitRoom;
        root.update({
            guestStatus: 'connected',
            guestConnected: true,
            guestError: null
        });
        $e58ac2d7f6d11479$var$_refreshGuestParticipants(root, livekitRoom);
    } catch (err) {
        console.error('[guest] connect failed', err);
        root.update({
            guestError: err?.message || 'connect failed',
            guestStatus: 'form'
        });
    }
};
const $e58ac2d7f6d11479$var$_startPolling = ({ waitingId: waitingId, roomId: roomId, root: root })=>{
    $e58ac2d7f6d11479$var$_stopPolling();
    $e58ac2d7f6d11479$var$_pollTimer = setInterval(async ()=>{
        try {
            const res = await $e58ac2d7f6d11479$var$_edgeFetch('meet-guest-status', {
                waitingId: waitingId
            });
            if (res.status === 'admitted') {
                $e58ac2d7f6d11479$var$_stopPolling();
                root.update({
                    guestStatus: 'connecting'
                });
                await $e58ac2d7f6d11479$var$_connectGuest({
                    roomId: roomId,
                    waitingId: waitingId,
                    root: root
                });
            } else if (res.status === 'rejected') {
                $e58ac2d7f6d11479$var$_stopPolling();
                root.update({
                    guestStatus: 'rejected'
                });
            }
        } catch (err) {
            console.warn('[guest] status poll failed', err);
        }
    }, 2000);
};
const $e58ac2d7f6d11479$var$_submitRequest = async ({ root: root })=>{
    const draft = root.guestForm || {};
    const roomId = root.activeRoomId;
    if (!roomId) return;
    root.update({
        guestError: null,
        guestStatus: 'submitting'
    });
    try {
        const res = await $e58ac2d7f6d11479$var$_edgeFetch('meet-guest-request', {
            roomId: roomId,
            guestName: draft.name,
            guestEmail: draft.email,
            password: draft.password
        });
        if (res.autoAdmitted) {
            root.update({
                guestStatus: 'connecting',
                waitingId: res.waitingId
            });
            await $e58ac2d7f6d11479$var$_connectGuest({
                roomId: roomId,
                waitingId: res.waitingId,
                root: root
            });
        } else {
            root.update({
                guestStatus: 'waiting',
                waitingId: res.waitingId
            });
            $e58ac2d7f6d11479$var$_startPolling({
                waitingId: res.waitingId,
                roomId: roomId,
                root: root
            });
        }
    } catch (err) {
        console.error('[guest] submit failed', err);
        root.update({
            guestError: err?.message || 'submit failed',
            guestStatus: 'form'
        });
    }
};
// Lookup the room's guest requirements so we know which form fields to
// show. Uses the anon key to hit the REST endpoint directly — the row is
// readable via the meet_rooms_select RLS policy's public branch.
const $e58ac2d7f6d11479$var$_loadRoomMeta = async ({ roomId: roomId, root: root })=>{
    try {
        const res = await fetch(`https://${$e58ac2d7f6d11479$var$PROJECT_ID}.supabase.co/rest/v1/meet_rooms?id=eq.${roomId}&select=name,is_private,ended_at,guest_require_name,guest_require_email,guest_password,guest_auto_admit`, {
            headers: {
                apikey: $e58ac2d7f6d11479$var$PUBLISHABLE_KEY,
                Authorization: `Bearer ${$e58ac2d7f6d11479$var$PUBLISHABLE_KEY}`
            }
        });
        const rows = await res.json().catch(()=>[]);
        const row = Array.isArray(rows) ? rows[0] : null;
        if (!row) {
            root.update({
                guestError: 'Room not found or not public.',
                guestStatus: 'form'
            });
            return;
        }
        root.update({
            guestRoomMeta: {
                name: row.name || 'Call',
                isPrivate: !!row.is_private,
                endedAt: row.ended_at,
                requireName: row.guest_require_name !== false,
                requireEmail: !!row.guest_require_email,
                requirePassword: !!row.guest_password,
                autoAdmit: !!row.guest_auto_admit
            }
        });
    } catch (err) {
        console.warn('[guest] room meta lookup failed', err);
        root.update({
            guestError: 'Room lookup failed.',
            guestStatus: 'form'
        });
    }
};
const $e58ac2d7f6d11479$export$6f490d18663a4ace = ()=>$e58ac2d7f6d11479$var$_guestRoom;
const $e58ac2d7f6d11479$export$95ea1694ae1caefc = {
    extends: 'Page',
    metadata: {
        title: 'Join meet / Symbols Workspace'
    },
    display: 'flex',
    flexFlow: 'column',
    width: '100%',
    minHeight: '100dvh',
    background: 'document',
    color: 'title',
    onCreate: (el, s)=>{
        const roomId = $e58ac2d7f6d11479$var$_readRoomFromHash();
        s.root.update({
            activeRoomId: roomId,
            guestConnected: false,
            guestError: null,
            guestStatus: 'form',
            guestForm: {
                name: '',
                email: '',
                password: ''
            },
            guestRoomMeta: null,
            waitingId: null
        });
        if (roomId) $e58ac2d7f6d11479$var$_loadRoomMeta({
            roomId: roomId,
            root: s.root
        });
    },
    Container: {
        flex: '1 1 0',
        flow: 'y',
        align: 'center center',
        padding: 'C',
        gap: 'B',
        // ── Form state ────────────────────────────────────────────────
        JoinForm: {
            hide: (el, s)=>s.root?.guestStatus !== 'form' && s.root?.guestStatus !== 'submitting',
            flow: 'y',
            gap: 'A',
            padding: 'B',
            round: 'A',
            maxWidth: 'I',
            width: '100%',
            borderWidth: '1px',
            borderColor: 'line',
            borderStyle: 'solid',
            background: 'overlayStrong',
            Title: {
                tag: 'h1',
                fontSize: 'C',
                fontWeight: '700',
                margin: '0',
                color: 'title',
                text: (el, s)=>s.root?.guestRoomMeta?.name || 'Join call as guest'
            },
            Subtitle: {
                tag: 'p',
                margin: '0',
                fontSize: 'Z2',
                color: 'caption',
                text: (el, s)=>{
                    if (!s.root?.activeRoomId) return "Missing room id \u2014 check the share link.";
                    const meta = s.root?.guestRoomMeta;
                    if (!meta) return "Loading\u2026";
                    if (meta.endedAt) return 'This call has ended.';
                    return meta.autoAdmit ? 'Fill in your details to join directly.' : 'Fill in your details. The host will need to admit you.';
                }
            },
            NameField: {
                hide: (el, s)=>!s.root?.activeRoomId || !s.root?.guestRoomMeta?.requireName,
                flow: 'y',
                gap: 'V',
                Label: {
                    tag: 'span',
                    fontSize: 'Y2',
                    color: 'caption',
                    text: 'YOUR NAME'
                },
                Input: {
                    tag: 'input',
                    padding: 'Z A',
                    round: 'Z',
                    borderWidth: '1px',
                    borderColor: 'line',
                    borderStyle: 'solid',
                    background: 'document',
                    color: 'title',
                    fontSize: 'Z2',
                    placeholder: 'e.g. Jane Doe',
                    value: (el, s)=>s.root?.guestForm?.name || '',
                    onInput: (e, el, s)=>s.root?.update({
                            guestForm: {
                                ...s.root?.guestForm || {},
                                name: e.target.value
                            }
                        })
                }
            },
            EmailField: {
                hide: (el, s)=>!s.root?.activeRoomId || !s.root?.guestRoomMeta?.requireEmail,
                flow: 'y',
                gap: 'V',
                Label: {
                    tag: 'span',
                    fontSize: 'Y2',
                    color: 'caption',
                    text: 'EMAIL'
                },
                Input: {
                    tag: 'input',
                    type: 'email',
                    padding: 'Z A',
                    round: 'Z',
                    borderWidth: '1px',
                    borderColor: 'line',
                    borderStyle: 'solid',
                    background: 'document',
                    color: 'title',
                    fontSize: 'Z2',
                    placeholder: 'jane@example.com',
                    value: (el, s)=>s.root?.guestForm?.email || '',
                    onInput: (e, el, s)=>s.root?.update({
                            guestForm: {
                                ...s.root?.guestForm || {},
                                email: e.target.value
                            }
                        })
                }
            },
            PasswordField: {
                hide: (el, s)=>!s.root?.activeRoomId || !s.root?.guestRoomMeta?.requirePassword,
                flow: 'y',
                gap: 'V',
                Label: {
                    tag: 'span',
                    fontSize: 'Y2',
                    color: 'caption',
                    text: 'PASSWORD'
                },
                Input: {
                    tag: 'input',
                    type: 'password',
                    padding: 'Z A',
                    round: 'Z',
                    borderWidth: '1px',
                    borderColor: 'line',
                    borderStyle: 'solid',
                    background: 'document',
                    color: 'title',
                    fontSize: 'Z2',
                    placeholder: 'Room password',
                    value: (el, s)=>s.root?.guestForm?.password || '',
                    onInput: (e, el, s)=>s.root?.update({
                            guestForm: {
                                ...s.root?.guestForm || {},
                                password: e.target.value
                            }
                        })
                }
            },
            ErrorMsg: {
                hide: (el, s)=>!s.root?.guestError,
                tag: 'p',
                margin: '0',
                padding: 'Z A',
                round: 'Z',
                background: 'red',
                color: 'white',
                fontSize: 'Y2',
                text: (el, s)=>s.root?.guestError || ''
            },
            JoinBtn: {
                tag: 'button',
                padding: 'Z B',
                round: 'Z',
                border: 'none',
                theme: 'primary',
                cursor: 'pointer',
                fontSize: 'Z2',
                fontWeight: '600',
                text: (el, s)=>{
                    if (s.root?.guestStatus === 'submitting') return "Requesting\u2026";
                    return s.root?.guestRoomMeta?.autoAdmit ? 'Join call' : 'Request to join';
                },
                disabled: (el, s)=>{
                    if (s.root?.guestStatus === 'submitting') return true;
                    if (!s.root?.activeRoomId) return true;
                    const meta = s.root?.guestRoomMeta;
                    if (!meta) return true;
                    if (meta.endedAt) return true;
                    const draft = s.root?.guestForm || {};
                    if (meta.requireName && !(draft.name || '').trim()) return true;
                    if (meta.requireEmail && !(draft.email || '').trim()) return true;
                    if (meta.requirePassword && !(draft.password || '').trim()) return true;
                    return false;
                },
                onClick: (e, el, s)=>$e58ac2d7f6d11479$var$_submitRequest({
                        root: s.root
                    })
            }
        },
        // ── Waiting state ─────────────────────────────────────────────
        WaitingScreen: {
            hide: (el, s)=>s.root?.guestStatus !== 'waiting' && s.root?.guestStatus !== 'connecting',
            flow: 'y',
            gap: 'A',
            padding: 'B',
            round: 'A',
            maxWidth: 'I',
            width: '100%',
            borderWidth: '1px',
            borderColor: 'line',
            borderStyle: 'solid',
            background: 'overlayStrong',
            align: 'center center',
            Spinner: {
                tag: 'span',
                fontSize: 'C',
                text: "\u23F3"
            },
            Title: {
                tag: 'h2',
                fontSize: 'B',
                fontWeight: '600',
                margin: '0',
                color: 'title',
                text: (el, s)=>s.root?.guestStatus === 'connecting' ? "Admitted \u2014 connecting\u2026" : 'Waiting for the host to let you in'
            },
            Subtitle: {
                tag: 'p',
                margin: '0',
                fontSize: 'Z2',
                color: 'caption',
                text: 'This usually takes a few seconds. Leave this tab open.'
            }
        },
        // ── Rejected ──────────────────────────────────────────────────
        RejectedScreen: {
            hide: (el, s)=>s.root?.guestStatus !== 'rejected',
            flow: 'y',
            gap: 'A',
            padding: 'B',
            round: 'A',
            maxWidth: 'I',
            width: '100%',
            borderWidth: '1px',
            borderColor: 'red',
            borderStyle: 'solid',
            background: 'overlayStrong',
            align: 'center center',
            Icon: {
                tag: 'span',
                fontSize: 'C',
                text: "\u26D4"
            },
            Title: {
                tag: 'h2',
                fontSize: 'B',
                fontWeight: '600',
                margin: '0',
                color: 'title',
                text: 'The host declined your request'
            },
            RetryBtn: {
                tag: 'button',
                text: 'Try again',
                padding: 'Z B',
                round: 'Z',
                border: 'none',
                theme: 'secondary',
                cursor: 'pointer',
                fontSize: 'Z2',
                fontWeight: '600',
                onClick: (e, el, s)=>{
                    $e58ac2d7f6d11479$var$_stopPolling();
                    s.root?.update({
                        guestStatus: 'form',
                        waitingId: null,
                        guestError: null
                    });
                }
            }
        },
        // ── Connected — video call area ───────────────────────────────
        CallArea: {
            hide: (el, s)=>s.root?.guestStatus !== 'connected',
            flow: 'y',
            flex: '1 1 0',
            minHeight: '0',
            maxWidth: 'J',
            width: '100%',
            background: 'black',
            round: 'A',
            overflow: 'hidden',
            position: 'relative',
            onRender: (el)=>{
                const node = el.node;
                if (!node) return;
                const videoEl = node.querySelector('video');
                if (!videoEl) return;
                const room = $e58ac2d7f6d11479$var$_guestRoom;
                if (!room) return;
                const pubs = typeof room.localParticipant?.videoTrackPublications?.values === 'function' ? [
                    ...room.localParticipant.videoTrackPublications.values()
                ] : Object.values(room.localParticipant?.videoTrackPublications || {});
                let targetPub = null;
                for (const pub of pubs)if (pub.track && (pub.source === 'camera' || pub.kind === 'video')) {
                    targetPub = pub;
                    break;
                }
                const currentSid = videoEl._lkTrackSid || null;
                const targetSid = targetPub?.trackSid || null;
                if (currentSid === targetSid) return;
                if (videoEl._lkTrack) try {
                    videoEl._lkTrack.detach(videoEl);
                } catch  {}
                if (targetPub?.track) try {
                    targetPub.track.attach(videoEl);
                    videoEl._lkTrack = targetPub.track;
                    videoEl._lkTrackSid = targetSid;
                } catch  {}
            },
            VideoEl: {
                tag: 'video',
                width: '100%',
                height: '100%',
                minHeight: 'H',
                objectFit: 'cover',
                attr: {
                    autoplay: 'autoplay',
                    playsinline: 'playsinline',
                    muted: 'muted'
                }
            },
            ControlRow: {
                position: 'absolute',
                bottom: 'A',
                left: '0',
                right: '0',
                flow: 'x',
                align: 'center center',
                gap: 'A',
                LeaveBtn: {
                    tag: 'button',
                    text: 'Leave call',
                    padding: 'Z B',
                    round: 'Z',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: 'Z2',
                    fontWeight: '600',
                    background: 'red',
                    color: 'white',
                    onClick: async (e, el, s)=>{
                        $e58ac2d7f6d11479$var$_stopPolling();
                        if ($e58ac2d7f6d11479$var$_guestRoom) {
                            try {
                                await $e58ac2d7f6d11479$var$_guestRoom.disconnect();
                            } catch  {}
                            $e58ac2d7f6d11479$var$_guestRoom = null;
                        }
                        s.root?.update({
                            guestConnected: false,
                            guestStatus: 'form',
                            livekitParticipants: [],
                            waitingId: null
                        });
                    }
                }
            }
        }
    }
};

});

parcelRegister("2h5R8", function(module, exports) {

$parcel$export(module.exports, "system", () => $1a81b62ed6c0e409$export$505f1cb98cb78c0d);

var $UgXQ6 = parcelRequire("UgXQ6");

var $lACiV = parcelRequire("lACiV");
const $1a81b62ed6c0e409$var$ENVS = [
    'prod',
    'staging',
    'testing',
    'dev',
    'upcoming',
    'next'
];
const $1a81b62ed6c0e409$var$_cell = (root, repo, env)=>{
    const m = root?.systemMatrix || {};
    return m[`${repo}:${env}`] || {
        version: "\u2014",
        status: 'none',
        commit: "\u2014",
        message: '',
        url: ''
    };
};
const $1a81b62ed6c0e409$var$STATUS = {
    healthy: {
        color: 'green',
        label: 'Healthy'
    },
    building: {
        color: 'orange',
        label: 'Building'
    },
    failed: {
        color: 'red',
        label: 'Failed'
    },
    pending: {
        color: 'caption',
        label: 'Pending'
    },
    none: {
        color: 'gray',
        label: 'No data'
    }
};
const $1a81b62ed6c0e409$var$_dotColor = (status)=>($1a81b62ed6c0e409$var$STATUS[status] || $1a81b62ed6c0e409$var$STATUS.none).color;
// ── Tooltip system ──
let $1a81b62ed6c0e409$var$_tooltip = null;
const $1a81b62ed6c0e409$var$_ensureTooltip = ()=>{
    if ($1a81b62ed6c0e409$var$_tooltip) return $1a81b62ed6c0e409$var$_tooltip;
    $1a81b62ed6c0e409$var$_tooltip = document.createElement('div');
    $1a81b62ed6c0e409$var$_tooltip.style.cssText = `
    position:fixed;z-index:9999;pointer-events:none;
    padding:8px 12px;border-radius:6px;
    background:var(--color-overlayStrong, #1a1a1e);
    border:1px solid var(--color-line, #333);
    box-shadow:0 8px 24px -4px rgba(0,0,0,0.5);
    opacity:0;transition:opacity 120ms ease;
    max-width:320px;font-size:12px;line-height:1.4;
  `;
    document.body.appendChild($1a81b62ed6c0e409$var$_tooltip);
    return $1a81b62ed6c0e409$var$_tooltip;
};
const $1a81b62ed6c0e409$var$_showTooltip = (anchor, content)=>{
    const tip = $1a81b62ed6c0e409$var$_ensureTooltip();
    tip.innerHTML = content;
    tip.style.opacity = '1';
    const rect = anchor.getBoundingClientRect();
    const tipW = tip.offsetWidth;
    let x = rect.left + rect.width / 2 - tipW / 2;
    let y = rect.bottom + 6;
    if (x < 8) x = 8;
    if (x + tipW > window.innerWidth - 8) x = window.innerWidth - tipW - 8;
    if (y + tip.offsetHeight > window.innerHeight - 8) y = rect.top - tip.offsetHeight - 6;
    tip.style.left = x + 'px';
    tip.style.top = y + 'px';
};
const $1a81b62ed6c0e409$var$_hideTooltip = ()=>{
    if ($1a81b62ed6c0e409$var$_tooltip) $1a81b62ed6c0e409$var$_tooltip.style.opacity = '0';
};
const $1a81b62ed6c0e409$var$_statusIcon = (status)=>{
    const s = $1a81b62ed6c0e409$var$STATUS[status] || $1a81b62ed6c0e409$var$STATUS.none;
    return `<span style="display:inline-block;width:8px;height:8px;border-radius:50%;background:var(--color-${s.color});vertical-align:middle;margin-right:4px;"></span>`;
};
const $1a81b62ed6c0e409$var$_tooltipHtml = (repo, env, c)=>{
    const s = $1a81b62ed6c0e409$var$STATUS[c.status] || $1a81b62ed6c0e409$var$STATUS.none;
    let html = `<div style="margin-bottom:4px;font-weight:700;color:var(--color-title);">${repo} <span style="color:var(--color-caption);font-weight:400;">/ ${env}</span></div>`;
    html += `<div style="margin-bottom:4px;">${$1a81b62ed6c0e409$var$_statusIcon(c.status)}<span style="color:var(--color-${s.color});font-weight:600;">${s.label}</span></div>`;
    if (c.version && c.version !== "\u2014") html += `<div style="color:var(--color-caption);">Version: <span style="color:var(--color-title);font-weight:500;">${c.version}</span></div>`;
    if (c.commit && c.commit !== "\u2014") html += `<div style="color:var(--color-caption);">Commit: <code style="color:var(--color-blue);font-size:11px;">${c.commit}</code></div>`;
    if (c.message) {
        const msgColor = c.status === 'failed' ? 'var(--color-red)' : 'var(--color-caption)';
        html += `<div style="margin-top:4px;padding-top:4px;border-top:1px solid var(--color-line);color:${msgColor};font-size:11px;">${c.message.replace(/</g, '&lt;')}</div>`;
    }
    return html;
};
// ── Grid builder ──
const $1a81b62ed6c0e409$var$_buildGrid = (el, s, repos, title)=>{
    if (!el.node) return;
    el.node.innerHTML = '';
    const root = s.root;
    const wrapper = document.createElement('div');
    wrapper.style.cssText = 'padding:16px;';
    const h2 = document.createElement('h2');
    h2.style.cssText = 'margin:0 0 12px 0;font-size:18px;font-weight:800;color:var(--color-title);letter-spacing:-0.01em;';
    h2.textContent = title;
    wrapper.appendChild(h2);
    const grid = document.createElement('div');
    grid.style.cssText = `display:grid;grid-template-columns:minmax(120px,auto) repeat(${$1a81b62ed6c0e409$var$ENVS.length},minmax(140px,1fr));`;
    const hdrStyle = 'padding:10px 16px;border-bottom:2px solid var(--color-line);font-size:10px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;color:var(--color-caption);';
    const cellStyle = 'padding:8px 12px;border-bottom:1px solid var(--color-line);text-align:center;';
    const repoStyle = 'padding:8px 16px;border-bottom:1px solid var(--color-line);font-weight:600;font-size:13px;color:var(--color-title);white-space:nowrap;display:flex;align-items:center;';
    const corner = document.createElement('div');
    corner.style.cssText = hdrStyle + 'text-align:left;';
    corner.textContent = title === 'Packages' ? 'Package' : 'Service';
    grid.appendChild(corner);
    for (const env of $1a81b62ed6c0e409$var$ENVS){
        const th = document.createElement('div');
        th.style.cssText = hdrStyle + 'text-align:center;';
        th.textContent = env;
        grid.appendChild(th);
    }
    for (const repo of repos){
        const label = document.createElement('div');
        label.style.cssText = repoStyle;
        label.textContent = repo;
        grid.appendChild(label);
        for (const env of $1a81b62ed6c0e409$var$ENVS){
            const c = $1a81b62ed6c0e409$var$_cell(root, repo, env);
            const td = document.createElement('div');
            td.style.cssText = cellStyle + 'display:flex;flex-direction:column;align-items:center;gap:2px;position:relative;cursor:default;';
            // Enhanced tooltip on hover
            td.onmouseenter = ()=>$1a81b62ed6c0e409$var$_showTooltip(td, $1a81b62ed6c0e409$var$_tooltipHtml(repo, env, c));
            td.onmouseleave = $1a81b62ed6c0e409$var$_hideTooltip;
            const dot = document.createElement('span');
            dot.style.cssText = `width:6px;height:6px;border-radius:50%;background:var(--color-${$1a81b62ed6c0e409$var$_dotColor(c.status)});`;
            const verEl = document.createElement('span');
            verEl.style.cssText = 'font-size:10px;font-weight:600;color:var(--color-title);';
            verEl.textContent = c.version;
            const commitEl = document.createElement(c.url ? 'a' : 'code');
            commitEl.style.cssText = `font-size:9px;font-family:monospace;color:var(--color-caption);${c.url ? 'text-decoration:none;cursor:pointer;' : ''}`;
            commitEl.textContent = c.commit;
            if (c.url) {
                commitEl.href = c.url;
                commitEl.target = '_blank';
                commitEl.onmouseenter = ()=>{
                    commitEl.style.color = 'var(--color-blue)';
                    commitEl.style.textDecoration = 'underline';
                };
                commitEl.onmouseleave = ()=>{
                    commitEl.style.color = 'var(--color-caption)';
                    commitEl.style.textDecoration = 'none';
                };
            }
            td.appendChild(dot);
            td.appendChild(verEl);
            td.appendChild(commitEl);
            grid.appendChild(td);
        }
    }
    wrapper.appendChild(grid);
    el.node.appendChild(wrapper);
};
// Infrastructure list derived from systemUptime data at render time — no static list
const $1a81b62ed6c0e409$var$_doFetch = async (s)=>{
    s.root.update({
        systemLoading: true
    });
    try {
        const [data, uptime] = await Promise.all([
            (0, $lACiV.fetchSystemStatus)(),
            (0, $lACiV.fetchUptime)()
        ]);
        s.root.update({
            systemMatrix: data.matrix || {},
            systemNpm: data.npm || {},
            systemServices: data.services || [],
            systemPackages: data.packages || [],
            systemUptime: uptime || {},
            systemLoading: false
        });
    } catch (err) {
        console.error('[system] fetch failed:', err);
        s.root.update({
            systemLoading: false
        });
    }
};
const $1a81b62ed6c0e409$var$_matrixCard = {
    round: 'Z2',
    background: 'overlay',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'line',
    overflow: 'visible',
    minHeight: 'fit-content'
};
const $1a81b62ed6c0e409$export$505f1cb98cb78c0d = {
    extends: 'AppPage',
    metadata: {
        title: 'System / Symbols Workspace'
    },
    fetch: (0, $UgXQ6.appPageBoilerplateFetch),
    onCreate: (el, s)=>$1a81b62ed6c0e409$var$_doFetch(s),
    SystemMain: {
        extends: 'AppMain',
        padding: '0',
        Header: {
            extends: 'PageHeader',
            LeftGroup: {
                Title: {
                    text: 'System'
                }
            },
            RightGroup: {
                RefreshBtn: {
                    tag: 'button',
                    type: 'button',
                    text: 'Refresh',
                    padding: 'Z A',
                    round: 'Z',
                    borderWidth: '1px',
                    borderColor: 'line',
                    borderStyle: 'solid',
                    background: 'overlay',
                    cursor: 'pointer',
                    fontSize: 'Z2',
                    fontWeight: '500',
                    color: 'title',
                    ':hover': {
                        background: 'overlayStrong'
                    },
                    onClick: (e, el, s)=>$1a81b62ed6c0e409$var$_doFetch(s)
                }
            }
        },
        Body: {
            overflow: 'auto',
            padding: 'B',
            flow: 'y',
            gap: 'B',
            maxWidth: 'J2',
            margin: '0 auto',
            width: '100%',
            Hero: {
                flow: 'y',
                gap: 'Z',
                padding: '0 Z',
                Eyebrow: {
                    tag: 'span',
                    fontSize: 'Z2',
                    fontWeight: '700',
                    letterSpacing: '0.12em',
                    textTransform: 'uppercase',
                    color: (el, s)=>s.root?.systemLoading ? 'orange' : 'green',
                    text: (el, s)=>s.root?.systemLoading ? 'Fetching status...' : 'All systems operational'
                },
                Title: {
                    tag: 'h1',
                    fontSize: 'E',
                    fontWeight: '800',
                    color: 'title',
                    letterSpacing: '-0.03em',
                    lineHeight: '1.1',
                    margin: '0',
                    text: 'System Status'
                }
            },
            Legend: {
                flow: 'x',
                gap: 'B',
                align: 'center left',
                padding: 'Z',
                childrenAs: 'state',
                children: ()=>Object.entries($1a81b62ed6c0e409$var$STATUS).map(([key, v])=>({
                            key: key,
                            ...v
                        })),
                childExtends: {
                    flow: 'x',
                    align: 'center left',
                    gap: 'Y',
                    Dot: {
                        width: 'X2',
                        height: 'X2',
                        round: '50%',
                        background: (el, s)=>s.color
                    },
                    Label: {
                        tag: 'span',
                        fontSize: 'Y2',
                        color: 'caption',
                        text: (el, s)=>s.label
                    }
                }
            },
            ServicesMatrix: {
                ...$1a81b62ed6c0e409$var$_matrixCard,
                onRender: (el, s)=>{
                    const build = ()=>{
                        const repos = s.root?.systemServices?.length ? s.root.systemServices : [
                            'canvas',
                            'preview',
                            'intranet',
                            'server',
                            'mermaid',
                            'mcp-https',
                            'platform',
                            'landing',
                            'docs'
                        ];
                        $1a81b62ed6c0e409$var$_buildGrid(el, s, repos, 'Services');
                    };
                    build();
                    el._interval = setInterval(()=>{
                        const k = Object.keys(s.root?.systemMatrix || {}).length;
                        if (k !== el._prevK) {
                            el._prevK = k;
                            build();
                        }
                    }, 500);
                },
                onRemove: (el)=>{
                    if (el._interval) clearInterval(el._interval);
                }
            },
            PackagesMatrix: {
                ...$1a81b62ed6c0e409$var$_matrixCard,
                onRender: (el, s)=>{
                    const build = ()=>{
                        const repos = s.root?.systemPackages?.length ? s.root.systemPackages : [
                            'smbls',
                            'sdk',
                            'mcp-local',
                            'vscode',
                            'chrome'
                        ];
                        $1a81b62ed6c0e409$var$_buildGrid(el, s, repos, 'Packages');
                    };
                    build();
                    el._interval = setInterval(()=>{
                        const k = Object.keys(s.root?.systemMatrix || {}).length;
                        if (k !== el._prevK) {
                            el._prevK = k;
                            build();
                        }
                    }, 500);
                },
                onRemove: (el)=>{
                    if (el._interval) clearInterval(el._interval);
                }
            },
            InfraCard: {
                flow: 'y',
                padding: 'B',
                round: 'Z2',
                background: 'overlay',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: 'line',
                InfraTitle: {
                    flow: 'x',
                    align: 'center space-between',
                    margin: '0 0 A 0',
                    H2: {
                        tag: 'h2',
                        fontSize: 'B1',
                        fontWeight: '800',
                        color: 'title',
                        margin: '0',
                        text: 'Infrastructure'
                    },
                    Period: {
                        tag: 'span',
                        fontSize: 'Y2',
                        color: 'caption',
                        text: '120 days'
                    }
                },
                InfraRows: {
                    flow: 'y',
                    onRender: (el, s)=>{
                        const build = ()=>{
                            if (!el.node) return;
                            el.node.innerHTML = '';
                            const uptimeData = s.root?.systemUptime || {};
                            const serviceNames = Object.keys(uptimeData);
                            if (!serviceNames.length) return;
                            for (const svcName of serviceNames){
                                const svc = {
                                    name: svcName
                                };
                                const row = document.createElement('div');
                                row.style.cssText = 'display:flex;align-items:center;gap:8px;padding:6px 0;border-bottom:1px solid var(--color-line);';
                                // Left: dot + name
                                const left = document.createElement('div');
                                left.style.cssText = 'display:flex;align-items:center;gap:6px;min-width:200px;width:200px;';
                                const days = uptimeData[svc.name] || [];
                                const latest = days.length ? days[days.length - 1] : null;
                                const currentStatus = latest?.status || 'healthy';
                                const dot = document.createElement('span');
                                dot.style.cssText = `width:8px;height:8px;border-radius:50%;flex-shrink:0;background:var(--color-${currentStatus === 'healthy' ? 'green' : currentStatus === 'degraded' ? 'orange' : 'red'});`;
                                const name = document.createElement('span');
                                name.style.cssText = 'font-size:12px;color:var(--color-title);';
                                name.textContent = svc.name;
                                left.appendChild(dot);
                                left.appendChild(name);
                                // Center: 120-day bar chart — bars flex to fill available space
                                const bars = document.createElement('div');
                                bars.style.cssText = 'flex:1;display:flex;align-items:center;gap:1px;justify-content:center;';
                                const dayCount = 120;
                                let healthyCount = 0;
                                for(let i = 0; i < dayCount; i++){
                                    const day = days[i] || {
                                        status: 'healthy',
                                        checked_at: '',
                                        message: ''
                                    };
                                    if (day.status === 'healthy') healthyCount++;
                                    const bar = document.createElement('span');
                                    const c = day.status === 'healthy' ? 'green' : day.status === 'degraded' ? 'orange' : 'red';
                                    bar.style.cssText = `flex:1;max-width:6px;min-width:2px;height:24px;border-radius:1px;background:var(--color-${c});opacity:0.85;cursor:default;transition:opacity 100ms, transform 100ms;`;
                                    bar.onmouseenter = ()=>{
                                        bar.style.opacity = '1';
                                        bar.style.transform = 'scaleY(1.3)';
                                        const dateStr = day.checked_at || `${dayCount - i} days ago`;
                                        const statusLabel = day.status === 'healthy' ? 'Operational' : day.status === 'degraded' ? 'Degraded' : 'Down';
                                        let html = `<div style="font-weight:700;color:var(--color-title);margin-bottom:2px;">${svc.name}</div>`;
                                        html += `<div style="color:var(--color-caption);font-size:11px;">${dateStr}</div>`;
                                        html += `<div>${$1a81b62ed6c0e409$var$_statusIcon(day.status === 'healthy' ? 'healthy' : day.status === 'degraded' ? 'building' : 'failed')}<span style="color:var(--color-${c});font-weight:600;">${statusLabel}</span></div>`;
                                        if (day.message) html += `<div style="margin-top:3px;font-size:11px;color:var(--color-${c});">${day.message}</div>`;
                                        if (day.latency_ms) html += `<div style="font-size:11px;color:var(--color-caption);">Latency: ${day.latency_ms}ms</div>`;
                                        $1a81b62ed6c0e409$var$_showTooltip(bar, html);
                                    };
                                    bar.onmouseleave = ()=>{
                                        bar.style.opacity = '0.85';
                                        bar.style.transform = 'scaleY(1)';
                                        $1a81b62ed6c0e409$var$_hideTooltip();
                                    };
                                    bars.appendChild(bar);
                                }
                                // Right: uptime percentage
                                const pct = dayCount > 0 ? (healthyCount / dayCount * 100).toFixed(2) + '%' : svc.uptime;
                                const uptimeEl = document.createElement('span');
                                uptimeEl.style.cssText = `font-size:12px;font-weight:600;color:var(--color-green);min-width:55px;text-align:right;`;
                                uptimeEl.textContent = pct;
                                row.appendChild(left);
                                row.appendChild(bars);
                                row.appendChild(uptimeEl);
                                el.node.appendChild(row);
                            }
                        };
                        build();
                        el._interval = setInterval(()=>{
                            const k = Object.keys(s.root?.systemUptime || {}).length;
                            if (k !== el._prevK) {
                                el._prevK = k;
                                build();
                            }
                        }, 500);
                    },
                    onRemove: (el)=>{
                        if (el._interval) clearInterval(el._interval);
                    }
                }
            }
        }
    }
};

});
parcelRegister("lACiV", function(module, exports) {

$parcel$export(module.exports, "fetchSystemStatus", () => $fb7aac3091a59381$export$7efb8bc0f2846c5c);
$parcel$export(module.exports, "fetchUptime", () => $fb7aac3091a59381$export$2e7a07f18668f0e5);
// Fetches system status from the system-status Supabase Edge Function.
// Tokens live server-side in the edge function — never exposed to the browser.

var $82gA2 = parcelRequire("82gA2");
const $fb7aac3091a59381$var$EDGE_URL = `${(0, $82gA2.RAW_URL)}/functions/v1/system-status`;
const $fb7aac3091a59381$var$REST_URL = `${(0, $82gA2.RAW_URL)}/rest/v1`;
async function $fb7aac3091a59381$export$7efb8bc0f2846c5c() {
    const res = await fetch($fb7aac3091a59381$var$EDGE_URL, {
        headers: {
            Authorization: `Bearer ${(0, $82gA2.SUPABASE_KEY)}`,
            'Content-Type': 'application/json'
        }
    });
    if (!res.ok) throw new Error(`system-status: ${res.status}`);
    return res.json();
}
async function $fb7aac3091a59381$export$2e7a07f18668f0e5() {
    const res = await fetch(`${$fb7aac3091a59381$var$REST_URL}/system_uptime?select=service,checked_at,status,latency_ms,message&order=checked_at.asc&limit=3000`, {
        headers: {
            apikey: (0, $82gA2.SUPABASE_KEY),
            Authorization: `Bearer ${(0, $82gA2.SUPABASE_KEY)}`
        }
    });
    if (!res.ok) return {};
    const rows = await res.json();
    // Group by service name → array of day records
    const byService = {};
    for (const r of rows){
        if (!byService[r.service]) byService[r.service] = [];
        byService[r.service].push(r);
    }
    return byService;
}

});


parcelRegister("3UggQ", function(module, exports) {

$parcel$export(module.exports, "features", () => $2d83391673168330$export$606190e461fe9031);
$parcel$export(module.exports, "ticketsStatus", () => $2d83391673168330$export$ebb14b9c934c93b8);

var $UgXQ6 = parcelRequire("UgXQ6");

var $7MNpT = parcelRequire("7MNpT");
const $2d83391673168330$var$ENVS = [
    'prod',
    'staging',
    'testing',
    'dev',
    'upcoming',
    'next'
];
const $2d83391673168330$var$STATUS = {
    pass: {
        color: 'green',
        label: 'Working'
    },
    fail: {
        color: 'red',
        label: 'Failure'
    },
    unchecked: {
        color: 'gray',
        label: 'Not checked'
    }
};
const $2d83391673168330$var$CHECK_TYPES = {
    crud: {
        subs: [
            'C',
            'R',
            'U',
            'D'
        ]
    },
    ditd: {
        columns: [
            'Designed',
            'Implemented',
            'Tested',
            'Documented'
        ]
    },
    sdk: {
        columns: [
            'Implemented',
            'Test-Auto',
            'Passing',
            'Documented'
        ]
    }
};
// ── QA categories ──
const $2d83391673168330$var$QA_GROUPS = [
    {
        key: 'manual-features',
        title: "Manual QA \u2014 Features",
        subtitle: 'UI features tested manually per environment'
    },
    {
        key: 'manual-sidebar',
        title: "Manual QA \u2014 Sidebar CRUD",
        subtitle: 'Sidebar panel operations: Create, Read, Update, Delete'
    },
    {
        key: 'auto-packages',
        title: "Automatic QA \u2014 Packages",
        subtitle: 'Package health checked via CI / tests'
    },
    {
        key: 'auto-sdk',
        title: "Automatic QA \u2014 SDK Functions",
        subtitle: 'Implemented, Test-Automated, Passing, Documented'
    },
    {
        key: 'auto-props',
        title: "Automatic QA \u2014 No-code Props",
        subtitle: 'Designed, Implemented, Tested, Documented'
    }
];
// ── Features data ──
const $2d83391673168330$var$FEATURES = [
    // ═══ manual-features ═══
    // Account
    {
        name: 'SSO - Google',
        epic: 'Account',
        priority: 'P0',
        qa: 'manual-features'
    },
    {
        name: 'Show my projects',
        epic: 'Account',
        priority: 'P0',
        qa: 'manual-features'
    },
    {
        name: 'Switch projects',
        epic: 'Account',
        priority: 'P0',
        qa: 'manual-features'
    },
    {
        name: 'User profile',
        epic: 'Account',
        priority: 'P0',
        qa: 'manual-features'
    },
    {
        name: 'Sign out',
        epic: 'Account',
        priority: 'P0',
        qa: 'manual-features'
    },
    {
        name: 'Settings',
        epic: 'Account',
        priority: 'P0',
        qa: 'manual-features'
    },
    {
        name: 'Plans & payment',
        epic: 'Account',
        priority: 'P0',
        qa: 'manual-features'
    },
    {
        name: 'SSO - Github',
        epic: 'Account',
        priority: 'P1',
        qa: 'manual-features'
    },
    {
        name: 'Removing Project',
        epic: 'Account',
        priority: 'P1',
        qa: 'manual-features'
    },
    {
        name: 'Permissions & IAM',
        epic: 'Account',
        priority: 'P1',
        qa: 'manual-features'
    },
    {
        name: 'Teams & invite',
        epic: 'Account',
        priority: 'P1',
        qa: 'manual-features'
    },
    {
        name: 'Access control',
        epic: 'Account',
        priority: 'P1',
        qa: 'manual-features'
    },
    {
        name: 'Email signing',
        epic: 'Account',
        priority: 'P2',
        qa: 'manual-features'
    },
    {
        name: 'Reset password & email',
        epic: 'Account',
        priority: 'P2',
        qa: 'manual-features'
    },
    // Landing
    {
        name: 'Landing + Responsive',
        epic: 'Landing',
        priority: 'P0',
        qa: 'manual-features'
    },
    {
        name: 'Features & benefits content',
        epic: 'Landing',
        priority: 'P2',
        qa: 'manual-features'
    },
    // Canvas
    {
        name: 'Component Editor',
        epic: 'Canvas',
        priority: 'P0',
        qa: 'manual-features'
    },
    {
        name: 'Component viewer',
        epic: 'Canvas',
        priority: 'P0',
        qa: 'manual-features'
    },
    {
        name: 'Builtin components',
        epic: 'Canvas',
        priority: 'P0',
        qa: 'manual-features'
    },
    {
        name: 'Components',
        epic: 'Canvas',
        priority: 'P0',
        qa: 'manual-features'
    },
    {
        name: 'Functions',
        epic: 'Canvas',
        priority: 'P0',
        qa: 'manual-features'
    },
    {
        name: 'Dependencies',
        epic: 'Canvas',
        priority: 'P0',
        qa: 'manual-features'
    },
    {
        name: 'Download panel',
        epic: 'Canvas',
        priority: 'P0',
        qa: 'manual-features'
    },
    {
        name: 'Components Library',
        epic: 'Canvas',
        priority: 'P0',
        qa: 'manual-features'
    },
    {
        name: 'Context menu',
        epic: 'Canvas',
        priority: 'P0',
        qa: 'manual-features'
    },
    {
        name: 'Share panel',
        epic: 'Canvas',
        priority: 'P0',
        qa: 'manual-features'
    },
    {
        name: 'URL to canvas',
        epic: 'Canvas',
        priority: 'P0',
        qa: 'manual-features'
    },
    {
        name: 'Copy/Paste',
        epic: 'Canvas',
        priority: 'P1',
        qa: 'manual-features'
    },
    {
        name: 'Libraries',
        epic: 'Canvas',
        priority: 'P1',
        qa: 'manual-features'
    },
    {
        name: 'Preview panel',
        epic: 'Canvas',
        priority: 'P1',
        qa: 'manual-features'
    },
    {
        name: 'Layers',
        epic: 'Canvas',
        priority: 'P1',
        qa: 'manual-features'
    },
    {
        name: 'Files',
        epic: 'Canvas',
        priority: 'P1',
        qa: 'manual-features'
    },
    {
        name: 'Layers panel',
        epic: 'Canvas',
        priority: 'P1',
        qa: 'manual-features'
    },
    {
        name: 'Layers and canvas interaction',
        epic: 'Canvas',
        priority: 'P1',
        qa: 'manual-features'
    },
    {
        name: 'Context menu on Canvas',
        epic: 'Canvas',
        priority: 'P1',
        qa: 'manual-features'
    },
    {
        name: 'Rename canvas page',
        epic: 'Canvas',
        priority: 'P1',
        qa: 'manual-features'
    },
    {
        name: 'Real-time cursor',
        epic: 'Canvas',
        priority: 'P2',
        qa: 'manual-features'
    },
    {
        name: 'Real-time changes',
        epic: 'Canvas',
        priority: 'P2',
        qa: 'manual-features'
    },
    {
        name: 'Methods',
        epic: 'Canvas',
        priority: 'P2',
        qa: 'manual-features'
    },
    {
        name: 'Snippets',
        epic: 'Canvas',
        priority: 'P2',
        qa: 'manual-features'
    },
    {
        name: 'Secrets',
        epic: 'Canvas',
        priority: 'P2',
        qa: 'manual-features'
    },
    {
        name: 'Shared library switching',
        epic: 'Canvas',
        priority: 'P2',
        qa: 'manual-features'
    },
    {
        name: 'Keyboard shortcuts',
        epic: 'Canvas',
        priority: 'P2',
        qa: 'manual-features'
    },
    {
        name: 'Canvas Pages',
        epic: 'Canvas',
        priority: 'P2',
        qa: 'manual-features'
    },
    {
        name: 'SEO on pages',
        epic: 'Canvas',
        priority: 'P2',
        qa: 'manual-features'
    },
    // Scratch
    {
        name: 'Scratch',
        epic: 'Canvas',
        priority: 'P0',
        qa: 'manual-features'
    },
    {
        name: 'Scratch: colours',
        epic: 'Canvas',
        priority: 'P0',
        qa: 'manual-features'
    },
    {
        name: 'Scratch: typography',
        epic: 'Canvas',
        priority: 'P0',
        qa: 'manual-features'
    },
    {
        name: 'Scratch: spacing',
        epic: 'Canvas',
        priority: 'P0',
        qa: 'manual-features'
    },
    {
        name: 'Scratch: icons',
        epic: 'Canvas',
        priority: 'P0',
        qa: 'manual-features'
    },
    {
        name: 'Scratch: fonts',
        epic: 'Canvas',
        priority: 'P0',
        qa: 'manual-features'
    },
    {
        name: 'Scratch: responsive',
        epic: 'Canvas',
        priority: 'P0',
        qa: 'manual-features'
    },
    {
        name: 'Scratch: timing',
        epic: 'Canvas',
        priority: 'P0',
        qa: 'manual-features'
    },
    {
        name: 'Scratch: cases',
        epic: 'Canvas',
        priority: 'P0',
        qa: 'manual-features'
    },
    {
        name: 'Scratch: shapes',
        epic: 'Canvas',
        priority: 'P2',
        qa: 'manual-features'
    },
    {
        name: 'Scratch: grids',
        epic: 'Canvas',
        priority: 'P2',
        qa: 'manual-features'
    },
    // DOMQL
    {
        name: 'DOMQL',
        epic: 'DOMQL',
        priority: 'P0',
        qa: 'manual-features'
    },
    {
        name: 'css-props',
        epic: 'DOMQL',
        priority: 'P0',
        qa: 'manual-features'
    },
    {
        name: 'Attr-in-props',
        epic: 'DOMQL',
        priority: 'P0',
        qa: 'manual-features'
    },
    {
        name: 'State',
        epic: 'DOMQL',
        priority: 'P0',
        qa: 'manual-features'
    },
    {
        name: 'Props',
        epic: 'DOMQL',
        priority: 'P0',
        qa: 'manual-features'
    },
    {
        name: 'If',
        epic: 'DOMQL',
        priority: 'P0',
        qa: 'manual-features'
    },
    {
        name: 'Content',
        epic: 'DOMQL',
        priority: 'P0',
        qa: 'manual-features'
    },
    {
        name: 'Children',
        epic: 'DOMQL',
        priority: 'P0',
        qa: 'manual-features'
    },
    {
        name: 'Extends',
        epic: 'DOMQL',
        priority: 'P0',
        qa: 'manual-features'
    },
    {
        name: 'Child Extends',
        epic: 'DOMQL',
        priority: 'P0',
        qa: 'manual-features'
    },
    {
        name: 'Child Props',
        epic: 'DOMQL',
        priority: 'P0',
        qa: 'manual-features'
    },
    {
        name: 'DOMQL Methods',
        epic: 'DOMQL',
        priority: 'P0',
        qa: 'manual-features'
    },
    {
        name: 'Router',
        epic: 'DOMQL',
        priority: 'P0',
        qa: 'manual-features'
    },
    // SDK
    {
        name: 'SDK',
        epic: 'SDK',
        priority: 'P0',
        qa: 'manual-features'
    },
    // Platform
    {
        name: 'Versioning',
        epic: 'Platform',
        priority: 'P0',
        qa: 'manual-features'
    },
    {
        name: 'React preview',
        epic: 'Platform',
        priority: 'P1',
        qa: 'manual-features'
    },
    {
        name: 'Realtime collaboration',
        epic: 'Platform',
        priority: 'P1',
        qa: 'manual-features'
    },
    {
        name: 'Branching',
        epic: 'Platform',
        priority: 'P2',
        qa: 'manual-features'
    },
    {
        name: 'Pull requests',
        epic: 'Platform',
        priority: 'P2',
        qa: 'manual-features'
    },
    // Design System
    {
        name: 'Colors',
        epic: 'Design System',
        priority: 'P0',
        qa: 'manual-features'
    },
    {
        name: 'Global themes',
        epic: 'Design System',
        priority: 'P0',
        qa: 'manual-features'
    },
    {
        name: 'Themes',
        epic: 'Design System',
        priority: 'P0',
        qa: 'manual-features'
    },
    {
        name: 'Typography',
        epic: 'Design System',
        priority: 'P0',
        qa: 'manual-features'
    },
    {
        name: 'Spacing',
        epic: 'Design System',
        priority: 'P0',
        qa: 'manual-features'
    },
    {
        name: 'Semantic Colors',
        epic: 'Design System',
        priority: 'P0',
        qa: 'manual-features'
    },
    {
        name: 'Cases',
        epic: 'Design System',
        priority: 'P1',
        qa: 'manual-features'
    },
    {
        name: 'Timing',
        epic: 'Design System',
        priority: 'P2',
        qa: 'manual-features'
    },
    // Integrations
    {
        name: 'Server preview',
        epic: 'Integrations',
        priority: 'P0',
        qa: 'manual-features'
    },
    {
        name: 'VS Code',
        epic: 'Integrations',
        priority: 'P0',
        qa: 'manual-features'
    },
    {
        name: 'Chrome extension',
        epic: 'Integrations',
        priority: 'P1',
        qa: 'manual-features'
    },
    {
        name: 'Custom domain',
        epic: 'Integrations',
        priority: 'P1',
        qa: 'manual-features'
    },
    {
        name: 'Download: Screenshot',
        epic: 'Integrations',
        priority: 'P1',
        qa: 'manual-features'
    },
    {
        name: 'Download: SVG',
        epic: 'Integrations',
        priority: 'P2',
        qa: 'manual-features'
    },
    {
        name: 'Download: HTML',
        epic: 'Integrations',
        priority: 'P2',
        qa: 'manual-features'
    },
    {
        name: 'Download: PDF',
        epic: 'Integrations',
        priority: 'P2',
        qa: 'manual-features'
    },
    {
        name: 'Download: CDN',
        epic: 'Integrations',
        priority: 'P2',
        qa: 'manual-features'
    },
    // smbls (manual)
    {
        name: 'Symbols fetch',
        epic: 'smbls',
        priority: 'P1',
        qa: 'manual-features'
    },
    {
        name: 'Symbols login',
        epic: 'smbls',
        priority: 'P1',
        qa: 'manual-features'
    },
    {
        name: 'Symbols push',
        epic: 'smbls',
        priority: 'P1',
        qa: 'manual-features'
    },
    {
        name: 'Symbols create',
        epic: 'smbls',
        priority: 'P0',
        qa: 'manual-features'
    },
    // Onboarding
    {
        name: 'Show 3x Templates',
        epic: 'Onboarding',
        priority: 'P0',
        qa: 'manual-features'
    },
    {
        name: 'Onboarding tutorials',
        epic: 'Onboarding',
        priority: 'P1',
        qa: 'manual-features'
    },
    {
        name: 'General tutorials',
        epic: 'Onboarding',
        priority: 'P1',
        qa: 'manual-features'
    },
    // ═══ manual-sidebar (CRUD) ═══
    {
        name: 'Selected Canvas',
        epic: 'Sidebar',
        priority: 'P0',
        qa: 'manual-sidebar',
        check: 'crud'
    },
    {
        name: 'Components',
        epic: 'Sidebar',
        priority: 'P0',
        qa: 'manual-sidebar',
        check: 'crud'
    },
    {
        name: 'Pages',
        epic: 'Sidebar',
        priority: 'P0',
        qa: 'manual-sidebar',
        check: 'crud'
    },
    {
        name: 'Functions',
        epic: 'Sidebar',
        priority: 'P0',
        qa: 'manual-sidebar',
        check: 'crud'
    },
    {
        name: 'Files',
        epic: 'Sidebar',
        priority: 'P0',
        qa: 'manual-sidebar',
        check: 'crud'
    },
    {
        name: 'Color',
        epic: 'Sidebar',
        priority: 'P0',
        qa: 'manual-sidebar',
        check: 'crud'
    },
    {
        name: 'Gradient',
        epic: 'Sidebar',
        priority: 'P0',
        qa: 'manual-sidebar',
        check: 'crud'
    },
    {
        name: 'Semantic Color',
        epic: 'Sidebar',
        priority: 'P0',
        qa: 'manual-sidebar',
        check: 'crud'
    },
    {
        name: 'Global Theme',
        epic: 'Sidebar',
        priority: 'P0',
        qa: 'manual-sidebar',
        check: 'crud'
    },
    {
        name: 'Themes',
        epic: 'Sidebar',
        priority: 'P0',
        qa: 'manual-sidebar',
        check: 'crud'
    },
    {
        name: 'Typography',
        epic: 'Sidebar',
        priority: 'P0',
        qa: 'manual-sidebar',
        check: 'crud'
    },
    {
        name: 'Font Families',
        epic: 'Sidebar',
        priority: 'P0',
        qa: 'manual-sidebar',
        check: 'crud'
    },
    {
        name: 'Text Styles',
        epic: 'Sidebar',
        priority: 'P0',
        qa: 'manual-sidebar',
        check: 'crud'
    },
    {
        name: 'Font',
        epic: 'Sidebar',
        priority: 'P0',
        qa: 'manual-sidebar',
        check: 'crud'
    },
    {
        name: 'Spacing',
        epic: 'Sidebar',
        priority: 'P0',
        qa: 'manual-sidebar',
        check: 'crud'
    },
    {
        name: 'Icons',
        epic: 'Sidebar',
        priority: 'P0',
        qa: 'manual-sidebar',
        check: 'crud'
    },
    {
        name: 'Cases',
        epic: 'Sidebar',
        priority: 'P0',
        qa: 'manual-sidebar',
        check: 'crud'
    },
    {
        name: 'Media',
        epic: 'Sidebar',
        priority: 'P0',
        qa: 'manual-sidebar',
        check: 'crud'
    },
    {
        name: 'Dependencies',
        epic: 'Sidebar',
        priority: 'P0',
        qa: 'manual-sidebar',
        check: 'crud'
    },
    {
        name: 'Branches',
        epic: 'Sidebar',
        priority: 'P1',
        qa: 'manual-sidebar',
        check: 'crud'
    },
    {
        name: 'Shared Libraries',
        epic: 'Sidebar',
        priority: 'P1',
        qa: 'manual-sidebar',
        check: 'crud'
    },
    // ═══ auto-packages ═══
    // Server
    {
        name: 'agent-runner',
        epic: 'Server',
        priority: 'P1',
        qa: 'auto-packages'
    },
    {
        name: 'ai-providers',
        epic: 'Server',
        priority: 'P1',
        qa: 'auto-packages'
    },
    {
        name: 'analyzed',
        epic: 'Server',
        priority: 'P1',
        qa: 'auto-packages'
    },
    {
        name: 'centauric',
        epic: 'Server',
        priority: 'P1',
        qa: 'auto-packages'
    },
    {
        name: 'cloudflare-dns',
        epic: 'Server',
        priority: 'P1',
        qa: 'auto-packages'
    },
    {
        name: 'config',
        epic: 'Server',
        priority: 'P1',
        qa: 'auto-packages'
    },
    {
        name: 'custom-domains',
        epic: 'Server',
        priority: 'P1',
        qa: 'auto-packages'
    },
    {
        name: 'gateway',
        epic: 'Server',
        priority: 'P0',
        qa: 'auto-packages'
    },
    {
        name: 'get-cdn-file',
        epic: 'Server',
        priority: 'P1',
        qa: 'auto-packages'
    },
    {
        name: 'kv',
        epic: 'Server',
        priority: 'P1',
        qa: 'auto-packages'
    },
    {
        name: 'logger',
        epic: 'Server',
        priority: 'P1',
        qa: 'auto-packages'
    },
    {
        name: 'mermaid-server',
        epic: 'Server',
        priority: 'P1',
        qa: 'auto-packages'
    },
    {
        name: 'puppeteer',
        epic: 'Server',
        priority: 'P1',
        qa: 'auto-packages'
    },
    {
        name: 'screenshot',
        epic: 'Server',
        priority: 'P1',
        qa: 'auto-packages'
    },
    {
        name: 'socket',
        epic: 'Server',
        priority: 'P0',
        qa: 'auto-packages'
    },
    {
        name: 'storage',
        epic: 'Server',
        priority: 'P1',
        qa: 'auto-packages'
    },
    {
        name: 'symbols-mcp',
        epic: 'Server',
        priority: 'P0',
        qa: 'auto-packages'
    },
    {
        name: 'symstory',
        epic: 'Server',
        priority: 'P1',
        qa: 'auto-packages'
    },
    {
        name: 'tauri',
        epic: 'Server',
        priority: 'P1',
        qa: 'auto-packages'
    },
    {
        name: 'versioning',
        epic: 'Server',
        priority: 'P1',
        qa: 'auto-packages'
    },
    // Symbolize
    {
        name: 'symbolize-cli',
        epic: 'Symbolize',
        priority: 'P1',
        qa: 'auto-packages'
    },
    {
        name: 'symbolize-core',
        epic: 'Symbolize',
        priority: 'P0',
        qa: 'auto-packages'
    },
    {
        name: 'symbolize-dompiler',
        epic: 'Symbolize',
        priority: 'P1',
        qa: 'auto-packages'
    },
    {
        name: 'symbolize-editorjs',
        epic: 'Symbolize',
        priority: 'P1',
        qa: 'auto-packages'
    },
    {
        name: 'symbolize-html',
        epic: 'Symbolize',
        priority: 'P1',
        qa: 'auto-packages'
    },
    {
        name: 'symbolize-markdown',
        epic: 'Symbolize',
        priority: 'P1',
        qa: 'auto-packages'
    },
    {
        name: 'symbolize-mcp',
        epic: 'Symbolize',
        priority: 'P1',
        qa: 'auto-packages'
    },
    {
        name: 'symbolize-react',
        epic: 'Symbolize',
        priority: 'P1',
        qa: 'auto-packages'
    },
    {
        name: 'symbolize-tailwind',
        epic: 'Symbolize',
        priority: 'P1',
        qa: 'auto-packages'
    },
    // smbls packages
    {
        name: 'attrs-in-props',
        epic: 'smbls',
        priority: 'P0',
        qa: 'auto-packages'
    },
    {
        name: 'cli',
        epic: 'smbls',
        priority: 'P0',
        qa: 'auto-packages'
    },
    {
        name: 'create',
        epic: 'smbls',
        priority: 'P0',
        qa: 'auto-packages'
    },
    {
        name: 'css',
        epic: 'smbls',
        priority: 'P0',
        qa: 'auto-packages'
    },
    {
        name: 'css-in-props',
        epic: 'smbls',
        priority: 'P0',
        qa: 'auto-packages'
    },
    {
        name: 'default-config',
        epic: 'smbls',
        priority: 'P1',
        qa: 'auto-packages'
    },
    {
        name: 'domql',
        epic: 'smbls',
        priority: 'P0',
        qa: 'auto-packages'
    },
    {
        name: 'element',
        epic: 'smbls',
        priority: 'P0',
        qa: 'auto-packages'
    },
    {
        name: 'fetch',
        epic: 'smbls',
        priority: 'P1',
        qa: 'auto-packages'
    },
    {
        name: 'icons',
        epic: 'smbls',
        priority: 'P1',
        qa: 'auto-packages'
    },
    {
        name: 'scratch',
        epic: 'smbls',
        priority: 'P0',
        qa: 'auto-packages'
    },
    {
        name: 'signal',
        epic: 'smbls',
        priority: 'P0',
        qa: 'auto-packages'
    },
    {
        name: 'smbls',
        epic: 'smbls',
        priority: 'P0',
        qa: 'auto-packages'
    },
    {
        name: 'smbls-utils',
        epic: 'smbls',
        priority: 'P1',
        qa: 'auto-packages'
    },
    {
        name: 'state',
        epic: 'smbls',
        priority: 'P0',
        qa: 'auto-packages'
    },
    {
        name: 'sync',
        epic: 'smbls',
        priority: 'P1',
        qa: 'auto-packages'
    },
    {
        name: 'utils',
        epic: 'smbls',
        priority: 'P1',
        qa: 'auto-packages'
    },
    {
        name: 'wasm',
        epic: 'smbls',
        priority: 'P1',
        qa: 'auto-packages'
    },
    // Plugins
    {
        name: 'brender',
        epic: 'Plugins',
        priority: 'P1',
        qa: 'auto-packages'
    },
    {
        name: 'capsize',
        epic: 'Plugins',
        priority: 'P1',
        qa: 'auto-packages'
    },
    {
        name: 'editorjs',
        epic: 'Plugins',
        priority: 'P1',
        qa: 'auto-packages'
    },
    {
        name: 'plugin-fetch',
        epic: 'Plugins',
        priority: 'P1',
        qa: 'auto-packages'
    },
    {
        name: 'frank',
        epic: 'Plugins',
        priority: 'P0',
        qa: 'auto-packages'
    },
    {
        name: 'freestyler',
        epic: 'Plugins',
        priority: 'P1',
        qa: 'auto-packages'
    },
    {
        name: 'funcql',
        epic: 'Plugins',
        priority: 'P1',
        qa: 'auto-packages'
    },
    {
        name: 'grabber-kid',
        epic: 'Plugins',
        priority: 'P1',
        qa: 'auto-packages'
    },
    {
        name: 'helmet',
        epic: 'Plugins',
        priority: 'P1',
        qa: 'auto-packages'
    },
    {
        name: 'keyflows',
        epic: 'Plugins',
        priority: 'P1',
        qa: 'auto-packages'
    },
    {
        name: 'mermaid',
        epic: 'Plugins',
        priority: 'P1',
        qa: 'auto-packages'
    },
    {
        name: 'parse',
        epic: 'Plugins',
        priority: 'P1',
        qa: 'auto-packages'
    },
    {
        name: 'performance',
        epic: 'Plugins',
        priority: 'P1',
        qa: 'auto-packages'
    },
    {
        name: 'polyglot',
        epic: 'Plugins',
        priority: 'P1',
        qa: 'auto-packages'
    },
    {
        name: 'qsql',
        epic: 'Plugins',
        priority: 'P1',
        qa: 'auto-packages'
    },
    {
        name: 'report',
        epic: 'Plugins',
        priority: 'P1',
        qa: 'auto-packages'
    },
    {
        name: 'router',
        epic: 'Plugins',
        priority: 'P0',
        qa: 'auto-packages'
    },
    {
        name: 'shorthand',
        epic: 'Plugins',
        priority: 'P1',
        qa: 'auto-packages'
    },
    {
        name: 'plugin-sync',
        epic: 'Plugins',
        priority: 'P1',
        qa: 'auto-packages'
    },
    // Editor
    {
        name: 'preview',
        epic: 'Editor',
        priority: 'P0',
        qa: 'auto-packages'
    },
    {
        name: 'convert',
        epic: 'Editor',
        priority: 'P0',
        qa: 'auto-packages'
    },
    {
        name: 'canvas',
        epic: 'Editor',
        priority: 'P0',
        qa: 'auto-packages'
    },
    {
        name: 'assistant',
        epic: 'Editor',
        priority: 'P1',
        qa: 'auto-packages'
    },
    {
        name: 'docs',
        epic: 'Editor',
        priority: 'P1',
        qa: 'auto-packages'
    },
    // Commercials / Docs / Dompiler / MCP
    {
        name: 'landing',
        epic: 'Commercials',
        priority: 'P0',
        qa: 'auto-packages'
    },
    {
        name: 'developers',
        epic: 'Docs',
        priority: 'P1',
        qa: 'auto-packages'
    },
    {
        name: 'dompiler',
        epic: 'Dompiler',
        priority: 'P0',
        qa: 'auto-packages'
    },
    {
        name: 'mcp-local',
        epic: 'MCP',
        priority: 'P0',
        qa: 'auto-packages'
    },
    {
        name: 'mcp-https',
        epic: 'MCP',
        priority: 'P0',
        qa: 'auto-packages'
    },
    // ═══ auto-sdk (SDK functions) ═══
    // P0
    {
        name: 'acceptInvite',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'addItem',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'addMultipleItems',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'auth',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'confirmPasswordChange',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'confirmPasswordReset',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'confirmRegistration',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'connect',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'createProject',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'createStorageBucket',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'deleteItem',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'duplicateProject',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'fetchUser',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'getChanges',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'getData',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'getItem',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'getProject',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'getProjectByKey',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'getProjectLibraries',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'getProjectMembers',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'getStorageBucket',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'getStoredAuthState',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'getUser',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'getUserByEmail',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'githubAuth',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'googleAuth',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'inviteMember',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'login',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'logout',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'publish',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'redo',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'register',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'removeMember',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'removeProject',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'removeStorageBucket',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'requestPasswordChange',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'requestPasswordReset',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'restoreVersion',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'setBucket',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'setProject',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'setUser',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'switchVersion',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'undo',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'updateData',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'updateItem',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'updateProject',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'updateProjectIcon',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'updateProjectName',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'updateUserProfile',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'updateUserRole',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'uploadFile',
        epic: 'SDK',
        priority: 'P0',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    // P1
    {
        name: 'acceptOwnerInvitation',
        epic: 'SDK',
        priority: 'P1',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'addProjectLibraries',
        epic: 'SDK',
        priority: 'P1',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'call',
        epic: 'SDK',
        priority: 'P1',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'cancelSubscription',
        epic: 'SDK',
        priority: 'P1',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'checkout',
        epic: 'SDK',
        priority: 'P1',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'checkSubscriptionStatus',
        epic: 'SDK',
        priority: 'P1',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'createBranch',
        epic: 'SDK',
        priority: 'P1',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'createDnsRecord',
        epic: 'SDK',
        priority: 'P1',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'deleteBranch',
        epic: 'SDK',
        priority: 'P1',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'downgradeSubscription',
        epic: 'SDK',
        priority: 'P1',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'editBranch',
        epic: 'SDK',
        priority: 'P1',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'getAvailableLibraries',
        epic: 'SDK',
        priority: 'P1',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'getBranches',
        epic: 'SDK',
        priority: 'P1',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'hasGlobalPermission',
        epic: 'SDK',
        priority: 'P1',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'hasPermission',
        epic: 'SDK',
        priority: 'P1',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'inviteAccountOwner',
        epic: 'SDK',
        priority: 'P1',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'mergeBranch',
        epic: 'SDK',
        priority: 'P1',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'removeProjectLibraries',
        epic: 'SDK',
        priority: 'P1',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'send',
        epic: 'SDK',
        priority: 'P1',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'set',
        epic: 'SDK',
        priority: 'P1',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'switchBranch',
        epic: 'SDK',
        priority: 'P1',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    // P2
    {
        name: 'removeDnsRecord',
        epic: 'SDK',
        priority: 'P2',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'getDnsRecord',
        epic: 'SDK',
        priority: 'P2',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'listFeatureFlags',
        epic: 'SDK',
        priority: 'P2',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'prompt',
        epic: 'SDK',
        priority: 'P2',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'removeFeatureFlag',
        epic: 'SDK',
        priority: 'P2',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'setProjectDomains',
        epic: 'SDK',
        priority: 'P2',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    // Unprioritized
    {
        name: 'batchUpdateFeatureFlags',
        epic: 'SDK',
        priority: 'P2',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'checkFeatureAccess',
        epic: 'SDK',
        priority: 'P2',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'checkProjectKeyAvailability',
        epic: 'SDK',
        priority: 'P2',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'checkResourceLimit',
        epic: 'SDK',
        priority: 'P2',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'generateInvoice',
        epic: 'SDK',
        priority: 'P2',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'getAvailableFeatures',
        epic: 'SDK',
        priority: 'P2',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'getSubscriptionDetails',
        epic: 'SDK',
        priority: 'P2',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'getUsageReport',
        epic: 'SDK',
        priority: 'P2',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'getUserFeatures',
        epic: 'SDK',
        priority: 'P2',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'listPlans',
        epic: 'SDK',
        priority: 'P2',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'query',
        epic: 'SDK',
        priority: 'P2',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'reactivateSubscription',
        epic: 'SDK',
        priority: 'P2',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'reconnect',
        epic: 'SDK',
        priority: 'P2',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'removeAccountOwner',
        epic: 'SDK',
        priority: 'P2',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'subscribe',
        epic: 'SDK',
        priority: 'P2',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'subscribeChannel',
        epic: 'SDK',
        priority: 'P2',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'subscribeToAuthChanges',
        epic: 'SDK',
        priority: 'P2',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'subscribeToPlan',
        epic: 'SDK',
        priority: 'P2',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'updateFeatureFlag',
        epic: 'SDK',
        priority: 'P2',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'updateMemberRole',
        epic: 'SDK',
        priority: 'P2',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'updatePlanDetails',
        epic: 'SDK',
        priority: 'P2',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'updatePlanStatus',
        epic: 'SDK',
        priority: 'P2',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'updateProjectComponents',
        epic: 'SDK',
        priority: 'P2',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'updateProjectPackage',
        epic: 'SDK',
        priority: 'P2',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'updateProjectSettings',
        epic: 'SDK',
        priority: 'P2',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'updateProjectTier',
        epic: 'SDK',
        priority: 'P2',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    {
        name: 'upgradeSubscription',
        epic: 'SDK',
        priority: 'P2',
        qa: 'auto-sdk',
        check: 'sdk'
    },
    // ═══ auto-props (DITD) ═══
    // DOMQL core
    {
        name: 'extends',
        epic: 'No-code Props',
        priority: 'P0',
        qa: 'auto-props',
        check: 'ditd',
        category: 'DOMQL'
    },
    {
        name: 'tag',
        epic: 'No-code Props',
        priority: 'P0',
        qa: 'auto-props',
        check: 'ditd',
        category: 'DOMQL'
    },
    {
        name: 'text',
        epic: 'No-code Props',
        priority: 'P0',
        qa: 'auto-props',
        check: 'ditd',
        category: 'DOMQL'
    },
    {
        name: 'html',
        epic: 'No-code Props',
        priority: 'P0',
        qa: 'auto-props',
        check: 'ditd',
        category: 'DOMQL'
    },
    {
        name: 'class',
        epic: 'No-code Props',
        priority: 'P0',
        qa: 'auto-props',
        check: 'ditd',
        category: 'DOMQL'
    },
    {
        name: 'state',
        epic: 'No-code Props',
        priority: 'P0',
        qa: 'auto-props',
        check: 'ditd',
        category: 'DOMQL'
    },
    {
        name: 'data',
        epic: 'No-code Props',
        priority: 'P0',
        qa: 'auto-props',
        check: 'ditd',
        category: 'DOMQL'
    },
    {
        name: 'scope',
        epic: 'No-code Props',
        priority: 'P0',
        qa: 'auto-props',
        check: 'ditd',
        category: 'DOMQL'
    },
    {
        name: 'children',
        epic: 'No-code Props',
        priority: 'P0',
        qa: 'auto-props',
        check: 'ditd',
        category: 'DOMQL'
    },
    {
        name: 'childrenAs',
        epic: 'No-code Props',
        priority: 'P0',
        qa: 'auto-props',
        check: 'ditd',
        category: 'DOMQL'
    },
    // Atoms
    {
        name: 'src',
        epic: 'No-code Props',
        priority: 'P0',
        qa: 'auto-props',
        check: 'ditd',
        category: 'Atoms'
    },
    {
        name: 'icon',
        epic: 'No-code Props',
        priority: 'P0',
        qa: 'auto-props',
        check: 'ditd',
        category: 'Icon'
    },
    {
        name: 'iconModifier',
        epic: 'No-code Props',
        priority: 'P0',
        qa: 'auto-props',
        check: 'ditd',
        category: 'Icon'
    },
    {
        name: 'shape',
        epic: 'No-code Props',
        priority: 'P0',
        qa: 'auto-props',
        check: 'ditd',
        category: 'Shape'
    },
    {
        name: 'shapeModifier',
        epic: 'No-code Props',
        priority: 'P0',
        qa: 'auto-props',
        check: 'ditd',
        category: 'Shape'
    },
    // Animation
    {
        name: 'animation',
        epic: 'No-code Props',
        priority: 'P0',
        qa: 'auto-props',
        check: 'ditd',
        category: 'Animation'
    },
    {
        name: 'transition',
        epic: 'No-code Props',
        priority: 'P0',
        qa: 'auto-props',
        check: 'ditd',
        category: 'Animation'
    },
    // Block
    {
        name: 'show',
        epic: 'No-code Props',
        priority: 'P0',
        qa: 'auto-props',
        check: 'ditd',
        category: 'Block'
    },
    {
        name: 'hide',
        epic: 'No-code Props',
        priority: 'P0',
        qa: 'auto-props',
        check: 'ditd',
        category: 'Block'
    },
    {
        name: 'height',
        epic: 'No-code Props',
        priority: 'P0',
        qa: 'auto-props',
        check: 'ditd',
        category: 'Block'
    },
    {
        name: 'width',
        epic: 'No-code Props',
        priority: 'P0',
        qa: 'auto-props',
        check: 'ditd',
        category: 'Block'
    },
    {
        name: 'size',
        epic: 'No-code Props',
        priority: 'P0',
        qa: 'auto-props',
        check: 'ditd',
        category: 'Block'
    },
    {
        name: 'boxSizing',
        epic: 'No-code Props',
        priority: 'P0',
        qa: 'auto-props',
        check: 'ditd',
        category: 'Block'
    },
    {
        name: 'padding',
        epic: 'No-code Props',
        priority: 'P0',
        qa: 'auto-props',
        check: 'ditd',
        category: 'Block'
    },
    {
        name: 'margin',
        epic: 'No-code Props',
        priority: 'P0',
        qa: 'auto-props',
        check: 'ditd',
        category: 'Block'
    },
    {
        name: 'gap',
        epic: 'No-code Props',
        priority: 'P0',
        qa: 'auto-props',
        check: 'ditd',
        category: 'Block'
    },
    {
        name: 'round',
        epic: 'No-code Props',
        priority: 'P0',
        qa: 'auto-props',
        check: 'ditd',
        category: 'Block'
    },
    {
        name: 'borderWidth',
        epic: 'No-code Props',
        priority: 'P0',
        qa: 'auto-props',
        check: 'ditd',
        category: 'Block'
    },
    // Flex
    {
        name: 'flow',
        epic: 'No-code Props',
        priority: 'P0',
        qa: 'auto-props',
        check: 'ditd',
        category: 'Flex'
    },
    {
        name: 'wrap',
        epic: 'No-code Props',
        priority: 'P0',
        qa: 'auto-props',
        check: 'ditd',
        category: 'Flex'
    },
    {
        name: 'align',
        epic: 'No-code Props',
        priority: 'P0',
        qa: 'auto-props',
        check: 'ditd',
        category: 'Flex'
    },
    // Font
    {
        name: 'fontSize',
        epic: 'No-code Props',
        priority: 'P0',
        qa: 'auto-props',
        check: 'ditd',
        category: 'Font'
    },
    {
        name: 'fontFamily',
        epic: 'No-code Props',
        priority: 'P0',
        qa: 'auto-props',
        check: 'ditd',
        category: 'Font'
    },
    {
        name: 'fontWeight',
        epic: 'No-code Props',
        priority: 'P0',
        qa: 'auto-props',
        check: 'ditd',
        category: 'Font'
    },
    // Grid
    {
        name: 'area',
        epic: 'No-code Props',
        priority: 'P0',
        qa: 'auto-props',
        check: 'ditd',
        category: 'Grid'
    },
    {
        name: 'template',
        epic: 'No-code Props',
        priority: 'P0',
        qa: 'auto-props',
        check: 'ditd',
        category: 'Grid'
    },
    {
        name: 'columns',
        epic: 'No-code Props',
        priority: 'P0',
        qa: 'auto-props',
        check: 'ditd',
        category: 'Grid'
    },
    {
        name: 'rows',
        epic: 'No-code Props',
        priority: 'P0',
        qa: 'auto-props',
        check: 'ditd',
        category: 'Grid'
    },
    // Position
    {
        name: 'inset',
        epic: 'No-code Props',
        priority: 'P0',
        qa: 'auto-props',
        check: 'ditd',
        category: 'Position'
    },
    {
        name: 'left',
        epic: 'No-code Props',
        priority: 'P0',
        qa: 'auto-props',
        check: 'ditd',
        category: 'Position'
    },
    {
        name: 'top',
        epic: 'No-code Props',
        priority: 'P0',
        qa: 'auto-props',
        check: 'ditd',
        category: 'Position'
    },
    {
        name: 'right',
        epic: 'No-code Props',
        priority: 'P0',
        qa: 'auto-props',
        check: 'ditd',
        category: 'Position'
    },
    {
        name: 'bottom',
        epic: 'No-code Props',
        priority: 'P0',
        qa: 'auto-props',
        check: 'ditd',
        category: 'Position'
    },
    // Theme
    {
        name: 'theme',
        epic: 'No-code Props',
        priority: 'P0',
        qa: 'auto-props',
        check: 'ditd',
        category: 'Theme'
    },
    {
        name: 'color',
        epic: 'No-code Props',
        priority: 'P0',
        qa: 'auto-props',
        check: 'ditd',
        category: 'Theme'
    },
    {
        name: 'background',
        epic: 'No-code Props',
        priority: 'P0',
        qa: 'auto-props',
        check: 'ditd',
        category: 'Theme'
    },
    {
        name: 'border',
        epic: 'No-code Props',
        priority: 'P0',
        qa: 'auto-props',
        check: 'ditd',
        category: 'Theme'
    },
    {
        name: 'borderColor',
        epic: 'No-code Props',
        priority: 'P0',
        qa: 'auto-props',
        check: 'ditd',
        category: 'Theme'
    },
    {
        name: 'shadow',
        epic: 'No-code Props',
        priority: 'P0',
        qa: 'auto-props',
        check: 'ditd',
        category: 'Theme'
    },
    {
        name: 'outline',
        epic: 'No-code Props',
        priority: 'P0',
        qa: 'auto-props',
        check: 'ditd',
        category: 'Theme'
    }
];
// ── Persistent state ──
let $2d83391673168330$var$_featureStatus = {};
// ticketId linked to a feature+col — tracks which ticket is assigned
let $2d83391673168330$var$_linkedTickets = {};
const $2d83391673168330$var$_key = (feature, col, sub)=>sub ? `${feature}:${col}:${sub}` : `${feature}:${col}`;
const $2d83391673168330$var$_getStatus = (feature, col, sub)=>$2d83391673168330$var$_featureStatus[$2d83391673168330$var$_key(feature, col, sub)] || 'unchecked';
const $2d83391673168330$var$_setStatus = (feature, col, status, sub)=>{
    $2d83391673168330$var$_featureStatus[$2d83391673168330$var$_key(feature, col, sub)] = status;
};
const $2d83391673168330$var$_getTicket = (feature, col, sub)=>$2d83391673168330$var$_linkedTickets[$2d83391673168330$var$_key(feature, col, sub)] || null;
const $2d83391673168330$var$_setTicket = (feature, col, ticketId, sub)=>{
    $2d83391673168330$var$_linkedTickets[$2d83391673168330$var$_key(feature, col, sub)] = ticketId;
};
const $2d83391673168330$var$_loadJson = (key)=>{
    try {
        const v = localStorage.getItem(key);
        return v ? JSON.parse(v) : null;
    } catch (e) {
        return null;
    }
};
$2d83391673168330$var$_featureStatus = $2d83391673168330$var$_loadJson('featuresMatrix') || {};
$2d83391673168330$var$_linkedTickets = $2d83391673168330$var$_loadJson('featuresTickets') || {};
const $2d83391673168330$var$_persist = ()=>{
    try {
        localStorage.setItem('featuresMatrix', JSON.stringify($2d83391673168330$var$_featureStatus));
        localStorage.setItem('featuresTickets', JSON.stringify($2d83391673168330$var$_linkedTickets));
    } catch (e) {}
};
// ── Tooltip ──
let $2d83391673168330$var$_tooltip = null;
const $2d83391673168330$var$_ensureTooltip = ()=>{
    if ($2d83391673168330$var$_tooltip) return $2d83391673168330$var$_tooltip;
    $2d83391673168330$var$_tooltip = document.createElement('div');
    $2d83391673168330$var$_tooltip.style.cssText = `
    position:fixed;z-index:9999;pointer-events:none;
    padding:8px 12px;border-radius:6px;
    background:var(--color-overlayStrong, #1a1a1e);
    border:1px solid var(--color-line, #333);
    box-shadow:0 8px 24px -4px rgba(0,0,0,0.5);
    opacity:0;transition:opacity 120ms ease;
    max-width:320px;font-size:12px;line-height:1.4;
  `;
    document.body.appendChild($2d83391673168330$var$_tooltip);
    return $2d83391673168330$var$_tooltip;
};
const $2d83391673168330$var$_showTooltip = (anchor, content)=>{
    const tip = $2d83391673168330$var$_ensureTooltip();
    tip.innerHTML = content;
    tip.style.opacity = '1';
    const rect = anchor.getBoundingClientRect();
    const tipW = tip.offsetWidth;
    let x = rect.left + rect.width / 2 - tipW / 2;
    let y = rect.bottom + 6;
    if (x < 8) x = 8;
    if (x + tipW > window.innerWidth - 8) x = window.innerWidth - tipW - 8;
    if (y + tip.offsetHeight > window.innerHeight - 8) y = rect.top - tip.offsetHeight - 6;
    tip.style.left = x + 'px';
    tip.style.top = y + 'px';
};
const $2d83391673168330$var$_hideTooltip = ()=>{
    if ($2d83391673168330$var$_tooltip) $2d83391673168330$var$_tooltip.style.opacity = '0';
};
const $2d83391673168330$var$_nextStatus = (current)=>{
    if (current === 'unchecked') return 'pass';
    if (current === 'pass') return 'fail';
    return 'unchecked';
};
// ── Ticket creation popup ──
let $2d83391673168330$var$_popup = null;
const $2d83391673168330$var$_removePopup = ()=>{
    if ($2d83391673168330$var$_popup && $2d83391673168330$var$_popup.parentNode) $2d83391673168330$var$_popup.parentNode.removeChild($2d83391673168330$var$_popup);
    $2d83391673168330$var$_popup = null;
};
const $2d83391673168330$var$_positionPopup = (popup, anchor)=>{
    const rect = anchor.getBoundingClientRect();
    const pw = 300;
    const ph = popup.offsetHeight || 280;
    // Try below-right first
    let x = rect.left + rect.width / 2 - pw / 2;
    let y = rect.bottom + 8;
    // Clamp horizontal
    if (x < 12) x = 12;
    if (x + pw > window.innerWidth - 12) x = window.innerWidth - pw - 12;
    // If overflows bottom, show above
    if (y + ph > window.innerHeight - 12) y = rect.top - ph - 8;
    // If still overflows top, center vertically
    if (y < 12) y = Math.max(12, (window.innerHeight - ph) / 2);
    popup.style.left = x + 'px';
    popup.style.top = y + 'px';
};
const $2d83391673168330$var$_showTicketPopup = (anchor, feat, col, sub, s, rebuild)=>{
    $2d83391673168330$var$_removePopup();
    const linked = $2d83391673168330$var$_getTicket(feat.name, col, sub);
    const label = col + (sub ? ' / ' + sub : '');
    // Backdrop
    const backdrop = document.createElement('div');
    backdrop.style.cssText = 'position:fixed;inset:0;z-index:9999;background:rgba(0,0,0,0.3);';
    document.body.appendChild(backdrop);
    $2d83391673168330$var$_popup = document.createElement('div');
    $2d83391673168330$var$_popup.style.cssText = `
    position:fixed;z-index:10000;
    padding:14px;border-radius:10px;width:300px;
    background:var(--color-overlayStrong, #1a1a1e);
    border:1px solid var(--color-line, #333);
    box-shadow:0 16px 48px -8px rgba(0,0,0,0.7);
    font-size:12px;color:var(--color-title);
  `;
    document.body.appendChild($2d83391673168330$var$_popup);
    const esc = (str)=>String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    $2d83391673168330$var$_popup.innerHTML = `
    <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:10px;">
      <div style="font-weight:700;color:var(--color-red);font-size:13px;">Bug Report</div>
      <button id="fp-close" style="background:none;border:none;color:var(--color-caption);cursor:pointer;font-size:16px;padding:0 2px;">\u{2715}</button>
    </div>
    <div style="color:var(--color-title);font-weight:600;margin-bottom:4px;">${esc(feat.name)}</div>
    <div style="color:var(--color-caption);margin-bottom:12px;font-size:11px;">${label} \xb7 ${feat.epic} \xb7 ${feat.priority}</div>

    <div style="display:flex;gap:4px;margin-bottom:12px;">
      <button id="fp-tab-new" class="fp-tab" style="flex:1;padding:6px;border-radius:6px;border:1px solid var(--color-red);background:var(--color-red);color:var(--color-white);font-size:11px;font-weight:700;cursor:pointer;">New ticket</button>
      <button id="fp-tab-assign" class="fp-tab" style="flex:1;padding:6px;border-radius:6px;border:1px solid var(--color-line);background:var(--color-overlay);color:var(--color-caption);font-size:11px;font-weight:600;cursor:pointer;">Assign existing</button>
    </div>

    <div id="fp-panel-new">
      <div style="display:flex;gap:4px;margin-bottom:8px;">
        <button class="fp-type" data-type="Bug" style="flex:1;padding:5px;border-radius:4px;border:2px solid var(--color-red);background:var(--color-red);color:var(--color-white);font-size:10px;font-weight:700;cursor:pointer;">Bug</button>
        <button class="fp-type" data-type="Feature" style="flex:1;padding:5px;border-radius:4px;border:2px solid var(--color-line);background:var(--color-overlay);color:var(--color-caption);font-size:10px;font-weight:700;cursor:pointer;">Feature</button>
        <button class="fp-type" data-type="Enhancement" style="flex:1;padding:5px;border-radius:4px;border:2px solid var(--color-line);background:var(--color-overlay);color:var(--color-caption);font-size:10px;font-weight:700;cursor:pointer;">Enhancement</button>
        <button class="fp-type" data-type="Task" style="flex:1;padding:5px;border-radius:4px;border:2px solid var(--color-line);background:var(--color-overlay);color:var(--color-caption);font-size:10px;font-weight:700;cursor:pointer;">Task</button>
      </div>
      <input id="fp-title" type="text" value="${esc(`[QA] ${feat.name} \u{2014} ${label}`)}" style="width:100%;box-sizing:border-box;padding:6px 8px;border:1px solid var(--color-line);border-radius:4px;background:var(--color-overlay);color:var(--color-title);font-size:11px;margin-bottom:6px;" />
      <textarea id="fp-desc" rows="3" style="width:100%;box-sizing:border-box;padding:6px 8px;border:1px solid var(--color-line);border-radius:4px;background:var(--color-overlay);color:var(--color-title);font-size:11px;margin-bottom:8px;resize:vertical;">${feat.name} (${feat.epic}, ${feat.priority}) failing on ${label}.\nReported from Features Matrix.</textarea>
      <button id="fp-create" style="width:100%;padding:8px;border:none;border-radius:6px;background:var(--color-red);color:var(--color-white);font-size:12px;font-weight:700;cursor:pointer;">Create ticket</button>
    </div>

    <div id="fp-panel-assign" style="display:none;">
      <input id="fp-ticket-id" type="text" placeholder="Enter ticket ID or title..." value="${linked || ''}" style="width:100%;box-sizing:border-box;padding:6px 8px;border:1px solid var(--color-line);border-radius:4px;background:var(--color-overlay);color:var(--color-title);font-size:11px;margin-bottom:8px;" />
      <button id="fp-assign" style="width:100%;padding:8px;border:none;border-radius:6px;background:var(--color-blue);color:var(--color-white);font-size:12px;font-weight:700;cursor:pointer;">Link ticket</button>
      ${linked ? `<button id="fp-unlink" style="width:100%;padding:6px;border:none;border-radius:4px;background:none;color:var(--color-caption);font-size:11px;cursor:pointer;margin-top:4px;">Unlink current ticket</button>` : ''}
    </div>
  `;
    $2d83391673168330$var$_positionPopup($2d83391673168330$var$_popup, anchor);
    const close = ()=>{
        $2d83391673168330$var$_removePopup();
        if (backdrop.parentNode) backdrop.parentNode.removeChild(backdrop);
    };
    backdrop.onclick = close;
    $2d83391673168330$var$_popup.querySelector('#fp-close').onclick = close;
    // Tab switching
    const tabNew = $2d83391673168330$var$_popup.querySelector('#fp-tab-new');
    const tabAssign = $2d83391673168330$var$_popup.querySelector('#fp-tab-assign');
    const panelNew = $2d83391673168330$var$_popup.querySelector('#fp-panel-new');
    const panelAssign = $2d83391673168330$var$_popup.querySelector('#fp-panel-assign');
    tabNew.onclick = ()=>{
        tabNew.style.background = 'var(--color-red)';
        tabNew.style.color = 'var(--color-white)';
        tabNew.style.borderColor = 'var(--color-red)';
        tabAssign.style.background = 'var(--color-overlay)';
        tabAssign.style.color = 'var(--color-caption)';
        tabAssign.style.borderColor = 'var(--color-line)';
        panelNew.style.display = '';
        panelAssign.style.display = 'none';
    };
    tabAssign.onclick = ()=>{
        tabAssign.style.background = 'var(--color-blue)';
        tabAssign.style.color = 'var(--color-white)';
        tabAssign.style.borderColor = 'var(--color-blue)';
        tabNew.style.background = 'var(--color-overlay)';
        tabNew.style.color = 'var(--color-caption)';
        tabNew.style.borderColor = 'var(--color-line)';
        panelNew.style.display = 'none';
        panelAssign.style.display = '';
    };
    // If already linked, show assign tab
    if (linked) tabAssign.onclick();
    // Type selector
    const TYPE_COLORS = {
        Bug: 'red',
        Feature: 'green',
        Enhancement: 'green',
        Task: 'blue'
    };
    let selectedType = 'Bug';
    const typeButtons = $2d83391673168330$var$_popup.querySelectorAll('.fp-type');
    const updateTypeButtons = ()=>{
        typeButtons.forEach((btn)=>{
            const t = btn.dataset.type;
            const active = t === selectedType;
            const c = TYPE_COLORS[t] || 'caption';
            btn.style.background = active ? `var(--color-${c})` : 'var(--color-overlay)';
            btn.style.color = active ? 'var(--color-white)' : 'var(--color-caption)';
            btn.style.borderColor = active ? `var(--color-${c})` : 'var(--color-line)';
        });
    };
    typeButtons.forEach((btn)=>{
        btn.onclick = ()=>{
            selectedType = btn.dataset.type;
            updateTypeButtons();
        };
    });
    // Create ticket — opens the real TicketDetailModal
    $2d83391673168330$var$_popup.querySelector('#fp-create').onclick = ()=>{
        const title = $2d83391673168330$var$_popup.querySelector('#fp-title').value;
        const desc = $2d83391673168330$var$_popup.querySelector('#fp-desc').value;
        const epicLabel = feat.epic.toLowerCase().replace(/\s+/g, '-');
        const root = s.root;
        if (root) root.update({
            selectedTicket: {
                _new: true
            },
            ticketEditMode: true,
            ticketDraft: {
                title: title,
                body: desc,
                columnKey: 'backlog',
                labels: [
                    selectedType,
                    epicLabel,
                    'QA'
                ].filter(Boolean),
                priority: feat.priority === 'P0' ? 'urgent' : feat.priority === 'P1' ? 'high' : 'medium',
                dueDate: '',
                assigneeEmail: ''
            }
        });
        close();
    };
    // Assign existing ticket
    $2d83391673168330$var$_popup.querySelector('#fp-assign').onclick = ()=>{
        const ticketId = $2d83391673168330$var$_popup.querySelector('#fp-ticket-id').value.trim();
        if (ticketId) {
            $2d83391673168330$var$_setTicket(feat.name, col, ticketId, sub);
            $2d83391673168330$var$_persist();
            rebuild();
        }
        close();
    };
    // Unlink
    const unlinkBtn = $2d83391673168330$var$_popup.querySelector('#fp-unlink');
    if (unlinkBtn) unlinkBtn.onclick = ()=>{
        $2d83391673168330$var$_setTicket(feat.name, col, null, sub);
        $2d83391673168330$var$_persist();
        rebuild();
        close();
    };
};
// ── Filter state ──
let $2d83391673168330$var$_activeEpic = null;
let $2d83391673168330$var$_activePriority = null;
let $2d83391673168330$var$_statsEl = null;
let $2d83391673168330$var$_collapsedGroups = $2d83391673168330$var$_loadJson('featuresCollapsed') || {};
const $2d83391673168330$var$_rebuildStats = ()=>{
    if ($2d83391673168330$var$_statsEl) $2d83391673168330$var$_buildStats($2d83391673168330$var$_statsEl);
};
// ── Cell builder ──
const $2d83391673168330$var$_makeCell = (el, s, feat, col, sub, rebuild)=>{
    const status = $2d83391673168330$var$_getStatus(feat.name, col, sub);
    const st = $2d83391673168330$var$STATUS[status] || $2d83391673168330$var$STATUS.unchecked;
    const ticket = $2d83391673168330$var$_getTicket(feat.name, col, sub);
    const td = document.createElement('div');
    td.style.cssText = 'padding:4px 2px;border-bottom:1px solid var(--color-line);display:flex;align-items:center;justify-content:center;cursor:pointer;position:relative;';
    const dot = document.createElement('span');
    const sz = sub ? '12px' : '16px';
    dot.style.cssText = `width:${sz};height:${sz};border-radius:3px;background:var(--color-${st.color});transition:transform 100ms,opacity 100ms;opacity:0.85;`;
    td.appendChild(dot);
    // Show ticket indicator if linked
    if (ticket && status === 'fail') {
        const badge = document.createElement('span');
        badge.style.cssText = 'position:absolute;top:1px;right:1px;width:5px;height:5px;border-radius:50%;background:var(--color-blue);';
        td.appendChild(badge);
    }
    td.onmouseenter = ()=>{
        dot.style.opacity = '1';
        dot.style.transform = 'scale(1.2)';
        let html = `<div style="font-weight:700;color:var(--color-title);">${feat.name}</div>`;
        html += `<div style="color:var(--color-caption);font-size:11px;margin:2px 0;">${col}${sub ? ' / ' + sub : ''}</div>`;
        html += `<div style="color:var(--color-${st.color});font-weight:600;">${st.label}</div>`;
        if (ticket) html += `<div style="color:var(--color-blue);font-size:10px;margin-top:2px;">Ticket: ${String(ticket).replace(/</g, '&lt;')}</div>`;
        html += `<div style="color:var(--color-caption);font-size:10px;margin-top:4px;">Click to cycle \u{2022} Right-click for ticket</div>`;
        $2d83391673168330$var$_showTooltip(td, html);
    };
    td.onmouseleave = ()=>{
        dot.style.opacity = '0.85';
        dot.style.transform = 'scale(1)';
        $2d83391673168330$var$_hideTooltip();
    };
    td.onclick = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        const current = $2d83391673168330$var$_getStatus(feat.name, col, sub);
        const next = $2d83391673168330$var$_nextStatus(current);
        $2d83391673168330$var$_setStatus(feat.name, col, next, sub);
        // When going to fail, show ticket popup
        if (next === 'fail') {
            $2d83391673168330$var$_persist();
            rebuild();
            $2d83391673168330$var$_rebuildStats();
            $2d83391673168330$var$_showTicketPopup(td, feat, col, sub, s, rebuild);
            return;
        }
        $2d83391673168330$var$_persist();
        rebuild();
        $2d83391673168330$var$_rebuildStats();
    };
    td.oncontextmenu = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        // Always show ticket popup on right-click
        if ($2d83391673168330$var$_getStatus(feat.name, col, sub) !== 'fail') {
            $2d83391673168330$var$_setStatus(feat.name, col, 'fail', sub);
            $2d83391673168330$var$_persist();
            rebuild();
            $2d83391673168330$var$_rebuildStats();
        }
        $2d83391673168330$var$_showTicketPopup(td, feat, col, sub, s, rebuild);
    };
    return td;
};
// ── Label cell ──
const $2d83391673168330$var$_makeLabel = (feat)=>{
    const label = document.createElement('div');
    label.style.cssText = 'padding:6px 8px;border-bottom:1px solid var(--color-line);font-size:12px;font-weight:500;color:var(--color-title);display:flex;align-items:center;gap:6px;white-space:nowrap;overflow:hidden;';
    const prioTag = document.createElement('span');
    prioTag.style.cssText = `font-size:9px;font-weight:700;padding:1px 4px;border-radius:3px;flex-shrink:0;color:var(--color-white);background:var(--color-${feat.priority === 'P0' ? 'red' : feat.priority === 'P1' ? 'orange' : 'caption'});`;
    prioTag.textContent = feat.priority;
    label.appendChild(prioTag);
    const nameSpan = document.createElement('span');
    nameSpan.style.cssText = 'overflow:hidden;text-overflow:ellipsis;';
    nameSpan.textContent = feat.name;
    if (feat.category) {
        const catSpan = document.createElement('span');
        catSpan.style.cssText = 'color:var(--color-caption);font-size:10px;font-weight:400;margin-left:4px;';
        catSpan.textContent = feat.category;
        nameSpan.appendChild(catSpan);
    }
    label.appendChild(nameSpan);
    // Show epic tag for mixed groups
    if (feat.epic && feat.qa !== 'manual-sidebar' && feat.qa !== 'auto-props') {
        const epicTag = document.createElement('span');
        epicTag.style.cssText = 'font-size:9px;padding:1px 4px;border-radius:3px;background:var(--color-line);color:var(--color-caption);flex-shrink:0;margin-left:auto;';
        epicTag.textContent = feat.epic;
        label.appendChild(epicTag);
    }
    return label;
};
// ── Grid builder ──
const $2d83391673168330$var$_buildMatrix = (el, s)=>{
    if (!el.node) return;
    el.node.innerHTML = '';
    const wrapper = document.createElement('div');
    wrapper.style.cssText = 'display:flex;flex-direction:column;gap:16px;';
    const rebuild = ()=>$2d83391673168330$var$_buildMatrix(el, s);
    for (const group of $2d83391673168330$var$QA_GROUPS){
        const groupFeatures = $2d83391673168330$var$FEATURES.filter((f)=>{
            if (f.qa !== group.key) return false;
            if ($2d83391673168330$var$_activeEpic && f.epic !== $2d83391673168330$var$_activeEpic) return false;
            if ($2d83391673168330$var$_activePriority && f.priority !== $2d83391673168330$var$_activePriority) return false;
            return true;
        });
        if (!groupFeatures.length) continue;
        const isCollapsed = $2d83391673168330$var$_collapsedGroups[group.key];
        // Group header
        const header = document.createElement('div');
        header.style.cssText = 'display:flex;align-items:center;gap:10px;cursor:pointer;padding:12px 16px;border-radius:10px;background:var(--color-overlay);border:1px solid var(--color-line);user-select:none;';
        header.onclick = ()=>{
            $2d83391673168330$var$_collapsedGroups[group.key] = !$2d83391673168330$var$_collapsedGroups[group.key];
            try {
                localStorage.setItem('featuresCollapsed', JSON.stringify($2d83391673168330$var$_collapsedGroups));
            } catch (e) {}
            rebuild();
        };
        const arrow = document.createElement('span');
        arrow.style.cssText = `font-size:10px;color:var(--color-caption);transition:transform 150ms;transform:rotate(${isCollapsed ? '0' : '90'}deg);`;
        arrow.textContent = "\u25B6";
        header.appendChild(arrow);
        const isManual = group.key.startsWith('manual');
        const badge = document.createElement('span');
        badge.style.cssText = `font-size:9px;font-weight:700;padding:2px 6px;border-radius:4px;letter-spacing:0.04em;text-transform:uppercase;background:var(--color-${isManual ? 'orange' : 'blue'});color:var(--color-white);`;
        badge.textContent = isManual ? 'Manual' : 'Auto';
        header.appendChild(badge);
        const titleEl = document.createElement('div');
        titleEl.style.cssText = 'flex:1;';
        titleEl.innerHTML = `<span style="font-weight:700;font-size:14px;color:var(--color-title);">${group.title}</span><br><span style="font-size:11px;color:var(--color-caption);">${group.subtitle}</span>`;
        header.appendChild(titleEl);
        const { total: gTotal, pass: gPass, fail: gFail } = $2d83391673168330$var$_countStatuses(groupFeatures);
        const statsEl = document.createElement('div');
        statsEl.style.cssText = 'display:flex;align-items:center;gap:8px;flex-shrink:0;';
        const gPct = gTotal > 0 ? Math.round(gPass / gTotal * 100) : 0;
        statsEl.innerHTML = `
      <span style="font-size:11px;color:var(--color-green);font-weight:700;">${gPass}</span>
      ${gFail ? `<span style="font-size:11px;color:var(--color-red);font-weight:700;">${gFail}</span>` : ''}
      <span style="font-size:10px;color:var(--color-caption);">/ ${gTotal}</span>
      <div style="width:60px;height:6px;border-radius:3px;background:var(--color-line);overflow:hidden;">
        <div style="height:100%;border-radius:3px;background:var(--color-green);width:${gPct}%;"></div>
      </div>
      <span style="font-size:11px;font-weight:700;color:var(--color-${gPct > 80 ? 'green' : gPct > 40 ? 'orange' : 'caption'});">${gPct}%</span>
    `;
        header.appendChild(statsEl);
        wrapper.appendChild(header);
        if (isCollapsed) continue;
        // Group by epic within the QA group
        const grouped = {};
        for (const f of groupFeatures){
            const gk = f.epic;
            if (!grouped[gk]) grouped[gk] = [];
            grouped[gk].push(f);
        }
        for (const [epic, features] of Object.entries(grouped)){
            const section = document.createElement('div');
            section.style.cssText = 'padding:12px 16px;border-radius:10px;background:var(--color-overlay);border:1px solid var(--color-line);overflow-x:auto;margin-left:24px;';
            const h4 = document.createElement('h4');
            h4.style.cssText = 'margin:0 0 10px 0;font-size:13px;font-weight:700;color:var(--color-title);';
            h4.textContent = epic;
            section.appendChild(h4);
            const checkType = features[0]?.check || 'env';
            if (checkType === 'crud') {
                const subs = $2d83391673168330$var$CHECK_TYPES.crud.subs;
                const totalCols = $2d83391673168330$var$ENVS.length * subs.length;
                const grid = document.createElement('div');
                grid.style.cssText = `display:grid;grid-template-columns:minmax(150px,1fr) repeat(${totalCols},28px);gap:0;min-width:fit-content;`;
                const corner = document.createElement('div');
                corner.style.cssText = 'padding:4px 8px;border-bottom:1px solid var(--color-line);font-size:10px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;color:var(--color-caption);grid-row:1/3;display:flex;align-items:end;';
                corner.textContent = 'Feature';
                grid.appendChild(corner);
                for (const env of $2d83391673168330$var$ENVS){
                    const th = document.createElement('div');
                    th.style.cssText = `padding:3px 2px;border-bottom:1px solid var(--color-line);font-size:9px;font-weight:700;letter-spacing:.04em;text-transform:uppercase;color:var(--color-caption);text-align:center;grid-column:span ${subs.length};`;
                    th.textContent = env;
                    grid.appendChild(th);
                }
                for (const env of $2d83391673168330$var$ENVS)for (const sub of subs){
                    const th = document.createElement('div');
                    th.style.cssText = 'padding:2px;border-bottom:2px solid var(--color-line);font-size:8px;font-weight:700;color:var(--color-caption);text-align:center;';
                    th.textContent = sub;
                    grid.appendChild(th);
                }
                for (const feat of features){
                    grid.appendChild($2d83391673168330$var$_makeLabel(feat));
                    for (const env of $2d83391673168330$var$ENVS)for (const sub of subs)grid.appendChild($2d83391673168330$var$_makeCell(el, s, feat, env, sub, rebuild));
                }
                section.appendChild(grid);
            } else if (checkType === 'ditd' || checkType === 'sdk') {
                const cols = $2d83391673168330$var$CHECK_TYPES[checkType].columns;
                const grid = document.createElement('div');
                grid.style.cssText = `display:grid;grid-template-columns:minmax(180px,1fr) repeat(${cols.length},72px);gap:0;`;
                const corner = document.createElement('div');
                corner.style.cssText = 'padding:4px 8px;border-bottom:2px solid var(--color-line);font-size:10px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;color:var(--color-caption);';
                corner.textContent = checkType === 'sdk' ? 'Function' : 'Prop';
                grid.appendChild(corner);
                for (const col of cols){
                    const th = document.createElement('div');
                    th.style.cssText = 'padding:4px;border-bottom:2px solid var(--color-line);font-size:9px;font-weight:700;letter-spacing:.04em;text-transform:uppercase;color:var(--color-caption);text-align:center;';
                    th.textContent = col.length > 6 ? col.slice(0, 5) : col;
                    grid.appendChild(th);
                }
                for (const feat of features){
                    grid.appendChild($2d83391673168330$var$_makeLabel(feat));
                    for (const col of cols)grid.appendChild($2d83391673168330$var$_makeCell(el, s, feat, col, null, rebuild));
                }
                section.appendChild(grid);
            } else {
                const grid = document.createElement('div');
                grid.style.cssText = `display:grid;grid-template-columns:minmax(180px,1fr) repeat(${$2d83391673168330$var$ENVS.length},72px);gap:0;`;
                const corner = document.createElement('div');
                corner.style.cssText = 'padding:4px 8px;border-bottom:2px solid var(--color-line);font-size:10px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;color:var(--color-caption);';
                corner.textContent = 'Feature';
                grid.appendChild(corner);
                for (const env of $2d83391673168330$var$ENVS){
                    const th = document.createElement('div');
                    th.style.cssText = 'padding:4px;border-bottom:2px solid var(--color-line);font-size:10px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;color:var(--color-caption);text-align:center;';
                    th.textContent = env;
                    grid.appendChild(th);
                }
                for (const feat of features){
                    grid.appendChild($2d83391673168330$var$_makeLabel(feat));
                    for (const env of $2d83391673168330$var$ENVS)grid.appendChild($2d83391673168330$var$_makeCell(el, s, feat, env, null, rebuild));
                }
                section.appendChild(grid);
            }
            wrapper.appendChild(section);
        }
    }
    el.node.appendChild(wrapper);
};
// ── Filters ──
const $2d83391673168330$var$_allEpics = [
    ...new Set($2d83391673168330$var$FEATURES.map((f)=>f.epic))
];
const $2d83391673168330$var$_buildFilters = (el, s, matrixEl)=>{
    if (!el.node) return;
    el.node.innerHTML = '';
    const bar = document.createElement('div');
    bar.style.cssText = 'display:flex;gap:6px;flex-wrap:wrap;align-items:center;';
    const mkBtn = (label, active, onClick)=>{
        const btn = document.createElement('button');
        btn.style.cssText = `padding:4px 10px;border-radius:6px;border:1px solid var(--color-line);font-size:11px;font-weight:600;cursor:pointer;background:${active ? 'var(--color-title)' : 'var(--color-overlay)'};color:${active ? 'var(--color-background)' : 'var(--color-caption)'};transition:all 100ms;`;
        btn.textContent = label;
        btn.onclick = onClick;
        return btn;
    };
    bar.appendChild(mkBtn('All', !$2d83391673168330$var$_activeEpic, ()=>{
        $2d83391673168330$var$_activeEpic = null;
        $2d83391673168330$var$_buildFilters(el, s, matrixEl);
        $2d83391673168330$var$_buildMatrix(matrixEl, s);
    }));
    for (const epic of $2d83391673168330$var$_allEpics)bar.appendChild(mkBtn(epic, $2d83391673168330$var$_activeEpic === epic, ()=>{
        $2d83391673168330$var$_activeEpic = $2d83391673168330$var$_activeEpic === epic ? null : epic;
        $2d83391673168330$var$_buildFilters(el, s, matrixEl);
        $2d83391673168330$var$_buildMatrix(matrixEl, s);
    }));
    const sep = document.createElement('span');
    sep.style.cssText = 'width:1px;height:20px;background:var(--color-line);margin:0 4px;';
    bar.appendChild(sep);
    for (const p of [
        'P0',
        'P1',
        'P2'
    ]){
        const active = $2d83391673168330$var$_activePriority === p;
        const pColor = p === 'P0' ? 'red' : p === 'P1' ? 'orange' : 'caption';
        const btn = document.createElement('button');
        btn.style.cssText = `padding:4px 8px;border-radius:6px;border:1px solid var(--color-${active ? pColor : 'line'});font-size:11px;font-weight:700;cursor:pointer;background:${active ? `var(--color-${pColor})` : 'var(--color-overlay)'};color:${active ? 'var(--color-white)' : `var(--color-${pColor})`};transition:all 100ms;`;
        btn.textContent = p;
        btn.onclick = ()=>{
            $2d83391673168330$var$_activePriority = active ? null : p;
            $2d83391673168330$var$_buildFilters(el, s, matrixEl);
            $2d83391673168330$var$_buildMatrix(matrixEl, s);
        };
        bar.appendChild(btn);
    }
    el.node.appendChild(bar);
};
// ── Stats ──
const $2d83391673168330$var$_countStatuses = (features)=>{
    let total = 0;
    let pass = 0;
    let fail = 0;
    let unchecked = 0;
    for (const f of features){
        const ct = f.check || 'env';
        if (ct === 'crud') {
            for (const env of $2d83391673168330$var$ENVS)for (const sub of $2d83391673168330$var$CHECK_TYPES.crud.subs){
                total++;
                const st = $2d83391673168330$var$_getStatus(f.name, env, sub);
                if (st === 'pass') pass++;
                else if (st === 'fail') fail++;
                else unchecked++;
            }
        } else if (ct === 'ditd' || ct === 'sdk') for (const col of $2d83391673168330$var$CHECK_TYPES[ct].columns){
            total++;
            const st = $2d83391673168330$var$_getStatus(f.name, col);
            if (st === 'pass') pass++;
            else if (st === 'fail') fail++;
            else unchecked++;
        }
        else for (const env of $2d83391673168330$var$ENVS){
            total++;
            const st = $2d83391673168330$var$_getStatus(f.name, env);
            if (st === 'pass') pass++;
            else if (st === 'fail') fail++;
            else unchecked++;
        }
    }
    return {
        total: total,
        pass: pass,
        fail: fail,
        unchecked: unchecked
    };
};
const $2d83391673168330$var$_buildStats = (el)=>{
    if (!el.node) return;
    el.node.innerHTML = '';
    const { total: total, pass: pass, fail: fail, unchecked: unchecked } = $2d83391673168330$var$_countStatuses($2d83391673168330$var$FEATURES);
    const bar = document.createElement('div');
    bar.style.cssText = 'display:flex;gap:20px;align-items:center;flex-wrap:wrap;';
    for (const item of [
        {
            label: 'Total',
            value: total,
            color: 'title'
        },
        {
            label: 'Passing',
            value: pass,
            color: 'green'
        },
        {
            label: 'Failing',
            value: fail,
            color: 'red'
        },
        {
            label: 'Unchecked',
            value: unchecked,
            color: 'gray'
        }
    ]){
        const d = document.createElement('div');
        d.style.cssText = 'display:flex;align-items:baseline;gap:4px;';
        const val = document.createElement('span');
        val.style.cssText = `font-size:20px;font-weight:800;color:var(--color-${item.color});`;
        val.textContent = item.value;
        const lbl = document.createElement('span');
        lbl.style.cssText = 'font-size:11px;color:var(--color-caption);';
        lbl.textContent = item.label;
        d.appendChild(val);
        d.appendChild(lbl);
        bar.appendChild(d);
    }
    const pct = total > 0 ? Math.round(pass / total * 100) : 0;
    const barWrap = document.createElement('div');
    barWrap.style.cssText = 'flex:1;max-width:200px;height:8px;border-radius:4px;background:var(--color-line);overflow:hidden;margin-left:8px;';
    const barFill = document.createElement('div');
    barFill.style.cssText = `height:100%;border-radius:4px;background:var(--color-green);width:${pct}%;transition:width 300ms;`;
    barWrap.appendChild(barFill);
    bar.appendChild(barWrap);
    const pctLabel = document.createElement('span');
    pctLabel.style.cssText = 'font-size:12px;font-weight:700;color:var(--color-green);';
    pctLabel.textContent = `${pct}%`;
    bar.appendChild(pctLabel);
    el.node.appendChild(bar);
};
const $2d83391673168330$var$_matrixCard = {
    round: 'Z2',
    background: 'overlay',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'line',
    overflow: 'visible',
    minHeight: 'fit-content'
};
const $2d83391673168330$export$606190e461fe9031 = {
    extends: 'AppPage',
    metadata: {
        title: 'Features / Symbols Workspace'
    },
    fetch: (0, $UgXQ6.appPageBoilerplateFetch),
    FeaturesMain: {
        extends: 'AppMain',
        padding: '0',
        Header: {
            extends: 'PageHeader',
            LeftGroup: {
                Title: {
                    text: 'Features'
                }
            },
            RightGroup: {
                ResetBtn: {
                    tag: 'button',
                    type: 'button',
                    text: 'Reset all',
                    padding: 'Z A',
                    round: 'Z',
                    borderWidth: '1px',
                    borderColor: 'line',
                    borderStyle: 'solid',
                    background: 'overlay',
                    cursor: 'pointer',
                    fontSize: 'Z2',
                    fontWeight: '500',
                    color: 'caption',
                    ':hover': {
                        background: 'overlayStrong',
                        color: 'red'
                    },
                    onClick: (e, el, s)=>{
                        $2d83391673168330$var$_featureStatus = {};
                        $2d83391673168330$var$_linkedTickets = {};
                        $2d83391673168330$var$_persist();
                        const body = el.parent?.parent?.Body;
                        if (body) {
                            if (body.MatrixGrid) $2d83391673168330$var$_buildMatrix(body.MatrixGrid, s);
                            if (body.StatsBar) $2d83391673168330$var$_buildStats(body.StatsBar);
                        }
                    }
                }
            }
        },
        Body: {
            overflow: 'auto',
            padding: 'B',
            flow: 'y',
            gap: 'A',
            maxWidth: '1400px',
            margin: '0 auto',
            width: '100%',
            Hero: {
                flow: 'y',
                gap: 'Z',
                padding: '0 Z',
                Eyebrow: {
                    tag: 'span',
                    fontSize: 'Z2',
                    fontWeight: '700',
                    letterSpacing: '0.12em',
                    textTransform: 'uppercase',
                    color: 'blue',
                    text: 'QA & Release tracking'
                },
                Title: {
                    tag: 'h1',
                    fontSize: 'E',
                    fontWeight: '800',
                    color: 'title',
                    letterSpacing: '-0.03em',
                    lineHeight: '1.1',
                    margin: '0',
                    text: 'Features Matrix'
                },
                Subtitle: {
                    tag: 'p',
                    fontSize: 'Z1',
                    color: 'caption',
                    margin: '0',
                    text: 'Click to cycle status. When failing, a ticket prompt appears. Right-click to force ticket creation.'
                }
            },
            StatsBar: {
                ...$2d83391673168330$var$_matrixCard,
                padding: 'A B',
                onRender: (el)=>{
                    $2d83391673168330$var$_statsEl = el;
                    $2d83391673168330$var$_buildStats(el);
                }
            },
            Legend: {
                flow: 'x',
                gap: 'B',
                align: 'center left',
                padding: 'Z',
                childrenAs: 'state',
                children: ()=>Object.entries($2d83391673168330$var$STATUS).map(([key, v])=>({
                            key: key,
                            ...v
                        })),
                childExtends: {
                    flow: 'x',
                    align: 'center left',
                    gap: 'Y',
                    Dot: {
                        width: 'A',
                        height: 'A',
                        round: 'Y',
                        background: (el, s)=>s.color
                    },
                    Label: {
                        tag: 'span',
                        fontSize: 'Y2',
                        color: 'caption',
                        text: (el, s)=>s.label
                    }
                }
            },
            FilterBar: {
                padding: '0 Z',
                onRender: (el, s)=>{
                    requestAnimationFrame(()=>{
                        const m = el.parent?.MatrixGrid;
                        if (m) $2d83391673168330$var$_buildFilters(el, s, m);
                    });
                }
            },
            MatrixGrid: {
                onRender: (el, s)=>$2d83391673168330$var$_buildMatrix(el, s)
            },
            onRemove: ()=>{
                $2d83391673168330$var$_removePopup();
                if ($2d83391673168330$var$_tooltip && $2d83391673168330$var$_tooltip.parentNode) $2d83391673168330$var$_tooltip.parentNode.removeChild($2d83391673168330$var$_tooltip);
                $2d83391673168330$var$_tooltip = null;
                $2d83391673168330$var$_statsEl = null;
            }
        }
    }
};
const $2d83391673168330$export$ebb14b9c934c93b8 = {
    extends: 'AppPage',
    metadata: {
        title: 'Tickets status / Symbols Workspace'
    },
    fetch: (0, $7MNpT.pageBoilerplateFetch),
    TicketsSidebar: {},
    FeaturesMain: $2d83391673168330$export$606190e461fe9031.FeaturesMain,
    TicketsDetailModal: {}
};

});

parcelRegister("iHT10", function(module, exports) {

$parcel$export(module.exports, "dataExternal", () => $d9e6eb095cf90d19$export$8bb8d9446244803e);
// Data → External Supabase projects. Thin assembly over the shared
// Remote* components in workspace/packages/shared/components/. All the
// sdk-bridge + realtime + schema logic lives in
// workspace/packages/shared/functions/remoteData.js so editor CMS and
// gov consume the same unit.
//
// URL shape (single route, query-driven):
//   /data/external                        → list connected projects
//   /data/external?slug=aihouse           → schema (tables) for one project
//   /data/external?slug=aihouse&t=rooms   → rows of one table
const $d9e6eb095cf90d19$export$8bb8d9446244803e = {
    extends: 'AppPage',
    metadata: (el, s)=>{
        const search = typeof window !== 'undefined' && window.location?.search || '';
        const params = new URLSearchParams(search);
        const slug = params.get('slug');
        const table = params.get('t');
        if (slug && table) return {
            title: `${table} \xb7 ${slug} / External data / Symbols Workspace`
        };
        if (slug) return {
            title: `${slug} / External data / Symbols Workspace`
        };
        return {
            title: 'External data / Symbols Workspace'
        };
    },
    onCreate: (el, s)=>{
        el.call('reactToRemotePath', s.root);
        const handler = ()=>el.call('reactToRemotePath', s.root);
        el._extPathSync = handler;
        window.addEventListener('popstate', handler);
        window.addEventListener('locationchange', handler);
    },
    onRemove: (el)=>{
        if (el._extPathSync) {
            window.removeEventListener('popstate', el._extPathSync);
            window.removeEventListener('locationchange', el._extPathSync);
        }
    },
    AppSidebar: {},
    AppMain: {
        extends: 'AppMain',
        padding: '0',
        Header: {
            extends: 'PageHeader',
            LeftGroup: {
                Breadcrumbs: {
                    flow: 'x',
                    align: 'center',
                    gap: 'Z',
                    fontSize: 'A',
                    color: 'title',
                    Home: {
                        tag: 'button',
                        type: 'button',
                        padding: '0',
                        background: 'transparent',
                        border: 'none',
                        color: 'caption',
                        fontSize: 'A',
                        cursor: 'pointer',
                        fontWeight: '600',
                        text: 'External data',
                        ':hover': {
                            color: 'title'
                        },
                        onClick: (e, el)=>{
                            const root = el.call('findRouteRoot', el) || el.getRoot();
                            if (root) el.router('/data/external', root);
                        }
                    },
                    Sep1: {
                        hide: (el)=>!el.call('parseRemotePath').slug,
                        color: 'caption',
                        text: ' / '
                    },
                    Project: {
                        hide: (el)=>!el.call('parseRemotePath').slug,
                        tag: 'button',
                        type: 'button',
                        padding: '0',
                        background: 'transparent',
                        border: 'none',
                        color: 'caption',
                        fontSize: 'A',
                        cursor: 'pointer',
                        fontWeight: '600',
                        ':hover': {
                            color: 'title'
                        },
                        text: (el, s)=>{
                            const { slug: slug } = el.call('parseRemotePath');
                            if (!slug) return '';
                            const list = s.root?._extProjects || [];
                            const p = list.find((x)=>x.slug === slug);
                            return p?.display_name || slug;
                        },
                        onClick: (e, el)=>{
                            const { slug: slug } = el.call('parseRemotePath');
                            const root = el.call('findRouteRoot', el) || el.getRoot();
                            if (root && slug) el.router(el.call('makeRemoteUrl', '/data/external', {
                                slug: slug
                            }), root);
                        }
                    },
                    Sep2: {
                        hide: (el)=>!el.call('parseRemotePath').table,
                        color: 'caption',
                        text: ' / '
                    },
                    Table: {
                        hide: (el)=>!el.call('parseRemotePath').table,
                        tag: 'span',
                        color: 'title',
                        fontWeight: '700',
                        text: (el)=>el.call('parseRemotePath').table || ''
                    }
                }
            },
            RightGroup: {
                ManageBtn: {
                    tag: 'button',
                    type: 'button',
                    padding: 'V Z',
                    round: 'Y',
                    background: 'transparent',
                    borderWidth: '1px',
                    borderStyle: 'solid',
                    borderColor: 'line',
                    color: 'title',
                    fontSize: 'Y2',
                    cursor: 'pointer',
                    text: 'Manage connections',
                    onClick: (e, el)=>{
                        const root = el.call('findRouteRoot', el) || el.getRoot();
                        if (root) el.router('/admin/integrations/supabase', root);
                    }
                }
            }
        },
        Body: {
            overflow: 'auto',
            padding: 'B',
            flow: 'y',
            gap: 'B',
            RemoteProjectPicker: {
                __remoteBasePath: '/data/external'
            },
            RemoteSchemaList: {},
            RemoteTableRows: {}
        }
    }
};

});

parcelRegister("abrJA", function(module, exports) {

$parcel$export(module.exports, "sessionBridge", () => $76a071eb02779f25$export$11ed4ec5dc76a106);
// Intranet-side postMessage endpoint. Forwards the governance Supabase
// session AND the SDK tokens stashed in localStorage so peer Symbols
// origins (canvas, marketplace, preview) can skip per-subdomain signin.
// Whitelisted origins only; page has no UI.

var $8RlGv = parcelRequire("8RlGv");
const $76a071eb02779f25$var$ALLOWED_ORIGIN_PATTERNS = [
    /^https?:\/\/canvas\.localhost(:\d+)?$/,
    /^https?:\/\/[^.]+\.symbols\.app$/,
    /^https?:\/\/preview\.localhost(:\d+)?$/,
    /^https?:\/\/marketplace\.localhost(:\d+)?$/
];
const $76a071eb02779f25$var$isAllowedOrigin = (origin)=>$76a071eb02779f25$var$ALLOWED_ORIGIN_PATTERNS.some((re)=>re.test(origin));
const $76a071eb02779f25$export$11ed4ec5dc76a106 = {
    metadata: {
        title: "Session bridge \xb7 Symbols"
    },
    background: '#0f1116',
    color: 'rgba(255,255,255,0.35)',
    fontFamily: 'system-ui',
    fontSize: 'Z2',
    padding: 'A',
    text: 'Session bridge. Hands off governance + SDK sessions to other Symbols subdomains.',
    onRender: (el)=>{
        if (el.__bridgeInit) return;
        el.__bridgeInit = true;
        window.addEventListener('message', async (ev)=>{
            if (!$76a071eb02779f25$var$isAllowedOrigin(ev.origin)) return;
            if (ev.data?.type !== 'symbols-session-request') return;
            const reply = (payload)=>ev.source?.postMessage({
                    type: 'symbols-session-response',
                    ...payload
                }, ev.origin);
            // Chrome's Third-Party Storage Partitioning gives this iframe an
            // empty, isolated localStorage by default. requestStorageAccess()
            // promotes us to first-party storage when Chrome's heuristics
            // approve (granted automatically when the user recently visited
            // intranet as a top-level page) so we can actually read the live
            // Supabase + SDK tokens we mean to forward.
            try {
                if (typeof document.requestStorageAccess === 'function') await document.requestStorageAccess();
            } catch  {
            // Heuristic refused — fall through and try the partitioned
            // store. Worst case we reply `no-session` and the peer surfaces
            // its existing "sign in via the intranet first" hint.
            }
            const client = (0, $8RlGv.getClient)((0, $8RlGv.PROJECT_GOVERNANCE));
            if (!client) return reply({
                ok: false,
                error: 'no-client'
            });
            let supabaseSession = null;
            try {
                const { data: data } = await client.auth.getSession();
                supabaseSession = data?.session || null;
            } catch (err) {
                return reply({
                    ok: false,
                    error: err?.message || 'error'
                });
            }
            const sdkTokens = (0, $8RlGv.collectSdkTokens)() || {};
            const supabaseSessions = (0, $8RlGv.collectSupabaseSessions)() || {};
            const hasSdk = !!sdkTokens.symbols_access_token || !!sdkTokens.symbols_bridge_access_token;
            const hasSb = Object.keys(supabaseSessions).length > 0;
            if (!supabaseSession?.access_token && !hasSdk && !hasSb) return reply({
                ok: false,
                error: 'no-session'
            });
            reply({
                ok: true,
                accessToken: supabaseSession?.access_token || null,
                refreshToken: supabaseSession?.refresh_token || null,
                expiresAt: supabaseSession?.expires_at || null,
                sdkTokens: sdkTokens,
                supabaseSessions: supabaseSessions
            });
        });
        // Parent waits for this handshake before posting its request so the
        // listener is guaranteed armed.
        try {
            if (window.parent && window.parent !== window) window.parent.postMessage({
                type: 'symbols-session-ready'
            }, '*');
        } catch  {}
    }
};

});


parcelRegister("9KJq4", function(module, exports) {

$parcel$export(module.exports, "default", () => $719ba44dc2f30dcc$export$2e2bcd8739ae039);

var $gIiOs = parcelRequire("gIiOs");

var $ecua9 = parcelRequire("ecua9");

var $3c42Q = parcelRequire("3c42Q");

var $ikIYt = parcelRequire("ikIYt");

var $03a5I = parcelRequire("03a5I");

var $iRx6m = parcelRequire("iRx6m");

var $7tPFF = parcelRequire("7tPFF");

var $bRgwR = parcelRequire("bRgwR");

var $4ciii = parcelRequire("4ciii");

var $15Vhj = parcelRequire("15Vhj");

var $hn0tZ = parcelRequire("hn0tZ");

var $lF9Ff = parcelRequire("lF9Ff");
const $719ba44dc2f30dcc$var$rootRedirect = {
    onRender: (el)=>{
        const sdk = el.context?.methods?.sdk;
        const token = sdk?.getAuthToken?.();
        el.router(token ? '/dashboard' : '/signin', el.getRoot());
    }
};
// Bare `/studios` has no slug — bounce to /dashboard so the user picks
// (or auto-selects) an active workspace, which is then deep-linked.
const $719ba44dc2f30dcc$var$studiosRedirect = {
    onRender: (el)=>el.router('/dashboard', el.getRoot())
};
var $719ba44dc2f30dcc$export$2e2bcd8739ae039 = {
    '/': $719ba44dc2f30dcc$var$rootRedirect,
    '/dashboard': (0, $3c42Q.dashboard),
    '/account': (0, $ikIYt.account),
    '/marketplace': (0, $03a5I.marketplace),
    '/_session-bridge': (0, $iRx6m.sessionBridge),
    '/studio': $719ba44dc2f30dcc$var$studiosRedirect,
    '/studio/*': (0, $ecua9.studios),
    '/signin': (0, $bRgwR.signin),
    '/signup': (0, $4ciii.signup),
    '/signup-confirmation': (0, $15Vhj.signupConfirmation),
    '/reset-password': (0, $hn0tZ.resetPassword),
    '/waitlist': (0, $lF9Ff.waitlist),
    '/404': (0, $7tPFF.notFound),
    '/*': (0, $gIiOs.main)
};

});
parcelRegister("gIiOs", function(module, exports) {

$parcel$export(module.exports, "main", () => $c2af593698db3432$export$f22da7240b7add18);
// The project page route. Hosts Canvas (the scene) + CanvasEditor
// (the overlay chrome). When the bootstrap in canvas/index.js sets
// `root.projectNotFound`, the NotFoundPage sibling takes over inline
// so the URL stays on the project path for retry-by-reload.
// Derive a human-readable project label from current state.
// Falls back to the URL slug so the title is never blank during load.
const $c2af593698db3432$var$projectTitle = (s)=>{
    const root = s.root || s;
    const data = root.data;
    if (data && !root.projectNotFound) return (data.name || data.key || '').trim() || null;
    // Fallback: read the second URL segment (/:owner/:projectSlug)
    const path = root.currentPath || (typeof window !== 'undefined' ? window.location.pathname : '');
    const segs = path.split('/').filter(Boolean);
    return segs[1] || segs[0] || null;
};
const $c2af593698db3432$export$f22da7240b7add18 = {
    tag: 'main',
    id: 'main-content',
    gridRow: '2',
    gridColumn: '1 / -1',
    position: 'relative',
    width: '100%',
    minHeight: '0',
    overflow: 'hidden',
    metadata: (el, s)=>{
        const root = s.root || s;
        if (root?.projectNotFound) return {
            title: 'Not found / Symbols.app'
        };
        // Dead single-segment routes (e.g. /notFound, /foo) land on this `/*`
        // handler before the async ensureProjectLoaded sets projectNotFound.
        // Detect them eagerly so the title is correct from the first paint.
        const path = typeof window !== 'undefined' ? window.location.pathname : root.currentPath || '';
        const segs = path.split('/').filter(Boolean);
        if (segs.length === 1) return {
            title: 'Not found / Symbols.app'
        };
        const label = $c2af593698db3432$var$projectTitle(s);
        const title = label ? `${label} / Canvas / Symbols.app` : 'Canvas / Symbols.app';
        return {
            title: title
        };
    },
    onRender: (el, s)=>el.call('ensureProjectLoaded', el, s),
    GridstackStyles: {
        tag: 'style',
        html: (el)=>el.context.gridstackCss || ''
    },
    NotFoundPage: {
        // Rendered inside this <main>, so strip the duplicate <main> tag and id
        // that notFound.js declares for its standalone /404 route usage.
        tag: 'div',
        id: null,
        if: (el, s)=>!!s.root?.projectNotFound
    },
    Canvas: {
        if: (el, s)=>!s.root?.projectNotFound
    },
    CanvasEditor: {
        if: (el, s)=>!s.root?.projectNotFound
    },
    LabsNavbar: {
        if: (el, s)=>!s.root?.projectNotFound
    },
    // Right-side floating island navbar — Pages, Modes, Publish, Envs, History,
    // Members, Sharing, Search. Only on /<owner>/<key> canvas project pages.
    // Auto-extended from CanvasMainNavbar in components/.
    CanvasMainNavbar: {
        if: (el, s)=>!s.root?.projectNotFound
    }
};

});

parcelRegister("ecua9", function(module, exports) {

$parcel$export(module.exports, "prependProjectToCache", () => $a569955e4f91ff1b$export$fdf2d64c97cb6b39);
$parcel$export(module.exports, "appendOrgToCache", () => $a569955e4f91ff1b$export$482845c065c9d77c);
$parcel$export(module.exports, "getAllProjectsCached", () => $a569955e4f91ff1b$export$3f49101abffe0b8c);
$parcel$export(module.exports, "ProjectNode", () => $a569955e4f91ff1b$export$a9f58aecf07b7b3e);
$parcel$export(module.exports, "IntegrationNode", () => $a569955e4f91ff1b$export$c8e5cd86b5e57b0a);
$parcel$export(module.exports, "LibraryNode", () => $a569955e4f91ff1b$export$dc7eeb553c6c04d8);
$parcel$export(module.exports, "MCPNode", () => $a569955e4f91ff1b$export$a609dcceef94efac);
$parcel$export(module.exports, "PluginNode", () => $a569955e4f91ff1b$export$d9af1ea83b1dc8b6);
$parcel$export(module.exports, "InstallableNode", () => $a569955e4f91ff1b$export$361e4d426758e4fe);
$parcel$export(module.exports, "LabEmptyTutorial", () => $a569955e4f91ff1b$export$68514f62f1898284);
$parcel$export(module.exports, "IntegrationChip", () => $a569955e4f91ff1b$export$d034e03442ed1979);
$parcel$export(module.exports, "ScopeRailChip", () => $a569955e4f91ff1b$export$891fc73fd7e64ebc);
$parcel$export(module.exports, "WorkspaceIntegrationRail", () => $a569955e4f91ff1b$export$907a96a28d3dcaa1);
$parcel$export(module.exports, "OrgIntegrationRail", () => $a569955e4f91ff1b$export$f79f23d351ad8485);
$parcel$export(module.exports, "MCPConnectorChip", () => $a569955e4f91ff1b$export$70442b23b8e724c7);
$parcel$export(module.exports, "MCPConnectorRail", () => $a569955e4f91ff1b$export$3652e949b492ebe7);
$parcel$export(module.exports, "IntegrationKindRow", () => $a569955e4f91ff1b$export$f016434f94824d08);
$parcel$export(module.exports, "IntegrationFormField", () => $a569955e4f91ff1b$export$2f99acc64e54270c);
$parcel$export(module.exports, "SettingsModal", () => $a569955e4f91ff1b$export$dfaef62a0892bd28);
$parcel$export(module.exports, "ProjectDeleteConfirmModal", () => $a569955e4f91ff1b$export$260fc82af66a6023);
$parcel$export(module.exports, "ProjectDuplicateModal", () => $a569955e4f91ff1b$export$bc25ee545e35c4c4);
$parcel$export(module.exports, "ProjectEditMetadataModal", () => $a569955e4f91ff1b$export$a8aa839ae0de97a6);
$parcel$export(module.exports, "LibraryPickerItem", () => $a569955e4f91ff1b$export$76dea0c3ad8844e8);
$parcel$export(module.exports, "IntegrationPickerOverlay", () => $a569955e4f91ff1b$export$7ab8b42c4cb35d1d);
$parcel$export(module.exports, "LibraryPickerOverlay", () => $a569955e4f91ff1b$export$ddc7cbe02dc480fc);
$parcel$export(module.exports, "NpTemplateCard", () => $a569955e4f91ff1b$export$e064f253df89e441);
$parcel$export(module.exports, "NpLibItem", () => $a569955e4f91ff1b$export$f6b2496a962587da);
$parcel$export(module.exports, "NewProjectPickerOverlay", () => $a569955e4f91ff1b$export$4747f91bc4bb4046);
$parcel$export(module.exports, "studios", () => $a569955e4f91ff1b$export$958e6f7ef093b4a6);

var $kN9I2 = parcelRequire("kN9I2");

var $bfqVY = parcelRequire("bfqVY");

var $aJaZ5 = parcelRequire("aJaZ5");

var $3HmWC = parcelRequire("3HmWC");
const $a569955e4f91ff1b$var$NODE_W = 320;
const $a569955e4f91ff1b$var$NODE_H = 256;
const $a569955e4f91ff1b$var$THUMBNAIL_H = 180;
// Per-projectType tile dimensions. App/desktop/tv/deck render landscape;
// mobile renders portrait; library uses a slimmer landscape distinct shape.
// COL_STRIDE/ROW_STRIDE use the LARGEST footprint so the auto-grid never
// overlaps regardless of which type lives in a slot.
const $a569955e4f91ff1b$var$TYPE_DIMS = {
    app: {
        w: 320,
        h: 224
    },
    website: {
        w: 320,
        h: 224
    },
    desktop: {
        w: 320,
        h: 224
    },
    tv: {
        w: 360,
        h: 220
    },
    deck: {
        w: 320,
        h: 200
    },
    mobile: {
        w: 200,
        h: 320
    },
    library: {
        w: 280,
        h: 168
    },
    platform: {
        w: 320,
        h: 224
    }
};
const $a569955e4f91ff1b$var$dimsFor = (projectType)=>$a569955e4f91ff1b$var$TYPE_DIMS[projectType] || {
        w: $a569955e4f91ff1b$var$NODE_W,
        h: $a569955e4f91ff1b$var$NODE_H
    };
const $a569955e4f91ff1b$var$COL_GAP = 64;
const $a569955e4f91ff1b$var$PER_ROW = 4;
const $a569955e4f91ff1b$var$BOARD_W = 2400;
const $a569955e4f91ff1b$var$BOARD_H = 2000;
// matches the Dots background size so snap = dot pitch
const $a569955e4f91ff1b$var$GRID_STEP = 24;
const $a569955e4f91ff1b$var$DRAG_THRESHOLD = 4;
const $a569955e4f91ff1b$var$snapUp = (n)=>Math.ceil(n / $a569955e4f91ff1b$var$GRID_STEP) * $a569955e4f91ff1b$var$GRID_STEP;
const $a569955e4f91ff1b$var$COL_STRIDE = $a569955e4f91ff1b$var$snapUp($a569955e4f91ff1b$var$NODE_W + $a569955e4f91ff1b$var$COL_GAP);
const $a569955e4f91ff1b$var$ROW_STRIDE = $a569955e4f91ff1b$var$snapUp($a569955e4f91ff1b$var$NODE_H + $a569955e4f91ff1b$var$COL_GAP);
// Extract the workspace slug ONLY when the current URL is actually on
// /workspaces/{slug}. Otherwise returns ''. Callers combine with
// `root.activeWorkspace` — on /workspaces/{slug} the URL wins so a
// direct navigation doesn't silently render a stale activeWorkspace.
const $a569955e4f91ff1b$var$ownerSlugFromUrl = ()=>{
    const segs = window.location.pathname.split('/').filter(Boolean);
    return segs[0] === 'workspaces' || segs[0] === 'studio' ? segs[1] || '' : '';
};
// Simpleicons slugs that 404 on cdn.simpleicons.org (trademark removals or
// slugs that never existed). Any DB `icon` value in this set is treated as
// absent so the letter-initials glyph renders instead of a broken <img>.
// Kept in sync with workspace/packages/marketplace/functions/index.js#SIMPLEICONS_404.
const $a569955e4f91ff1b$var$SIMPLEICONS_404 = new Set([
    'amazonwebservices',
    'amazons3',
    'openai',
    'slack',
    'twilio',
    'sendgrid',
    'segment',
    'neon',
    'workos',
    'pinecone',
    'logrocket',
    'uploadthing',
    'server',
    'mic' // generic, not in simpleicons (livekit placeholder)
]);
// Sanitise an icon slug from the DB before using as a simpleicons src.
// Returns null when the slug is blank, the string "undefined", or known-404.
function $a569955e4f91ff1b$var$sanitiseIcon(raw) {
    if (!raw || raw === 'undefined' || raw === 'null') return null;
    return $a569955e4f91ff1b$var$SIMPLEICONS_404.has(raw) ? null : raw;
}
// Category → accent color map. Canvas derives arrow + chip color from the
// kind's `category` (from `integration_kinds`) instead of hardcoding per
// kind. New kinds inherit their category's look automatically.
const $a569955e4f91ff1b$var$INTEGRATION_CATEGORY_COLOR = {
    data: '#3ecf8e',
    dev: '#d0d7de',
    workspace: '#f0b85a',
    ai: '#b88cff',
    messaging: '#54aeff',
    analytics: '#ff9f5a',
    automation: '#ff7a9c',
    custom: '#8ab4ff'
};
// Glyph fallbacks by kind prefix — used when `icon` is absent or when the
// icon name isn't a known token. One character, drawn inside a rounded
// color tile. Later we can swap these for real icon refs.
const $a569955e4f91ff1b$var$INTEGRATION_KIND_GLYPH = {
    supabase_project: 'S',
    github: 'G',
    google_workspace: 'W',
    google_analytics: 'A',
    npm: 'N',
    n8n: "\u2699",
    custom_http: "\u25C6"
};
const $a569955e4f91ff1b$var$INTEGRATION_NODE_W = 350;
const $a569955e4f91ff1b$var$INTEGRATION_NODE_H = 72;
// Installable canvas tiles — dimensions for non-integration domains.
// Libraries get a slightly taller card to hint at their "stack" visual.
// MCP connectors and plugins reuse the same compact height as integrations.
const $a569955e4f91ff1b$var$INSTALLABLE_W = 200;
const $a569955e4f91ff1b$var$INSTALLABLE_H = 80;
function $a569955e4f91ff1b$var$integrationColor(category) {
    return $a569955e4f91ff1b$var$INTEGRATION_CATEGORY_COLOR[category] || $a569955e4f91ff1b$var$INTEGRATION_CATEGORY_COLOR.custom;
}
function $a569955e4f91ff1b$var$integrationGlyph(kind) {
    if ($a569955e4f91ff1b$var$INTEGRATION_KIND_GLYPH[kind]) return $a569955e4f91ff1b$var$INTEGRATION_KIND_GLYPH[kind];
    return (kind || '?').charAt(0).toUpperCase();
}
// Map `kind` → slug used in the governance admin URL. Mirrors the helper
// in governance/.../admin-integrations.js so a canvas integration chip
// always lands on the correct per-kind configuration page.
function $a569955e4f91ff1b$var$integrationKindSlug(kind) {
    if (kind === 'google_workspace') return 'google';
    if (kind === 'supabase_project') return 'supabase';
    return kind;
}
function $a569955e4f91ff1b$var$integrationAdminUrl(kind) {
    const host = window.location.hostname.includes('localhost') ? 'http://workspace.localhost:1355' : 'https://us-at.symbols.app';
    const slug = $a569955e4f91ff1b$var$integrationKindSlug(kind);
    return `${host}/admin/integrations${slug ? '/' + slug : ''}`;
}
function $a569955e4f91ff1b$var$marketplaceUrl() {
    return window.location.hostname.includes('localhost') ? 'http://marketplace.localhost:1355' : 'https://marketplace.symbols.app';
}
// Factory for SettingsModal tabs — left-rail button that picks a section.
function $a569955e4f91ff1b$var$settingsTab(tabKey, label, hint) {
    return {
        tag: 'button',
        type: 'button',
        flow: 'y',
        gap: '2px',
        textAlign: 'left',
        padding: 'V A',
        round: 'Z',
        border: '0',
        cursor: 'pointer',
        background: (el, s)=>(s.root?.settingsTab || 'workspace') === tabKey ? 'rgba(255,255,255,0.1)' : 'transparent',
        color: 'white',
        ':hover': {
            background: 'rgba(255,255,255,0.06)'
        },
        Name: {
            tag: 'span',
            text: label,
            fontSize: 'Z2',
            fontWeight: '600'
        },
        Hint: {
            tag: 'span',
            text: hint,
            fontSize: 'Z',
            color: 'rgba(255,255,255,0.5)'
        },
        onClick: (e, el, s)=>{
            e.stopPropagation();
            s.root?.update({
                settingsTab: tabKey
            });
        }
    };
}
// Factory for canvas-scoped settings rows — only renders when a canvas
// context exists. Wraps `settingsBlockRow` with a checkbox that reads
// the canvas v2 state and dispatches `patchCanvas` / `patchSnap` so
// consumers don't need to duplicate the lifecycle plumbing.
function $a569955e4f91ff1b$var$settingsCanvasRow(label, hint, opts = {}) {
    const readChecked = (v2)=>{
        if (typeof opts.checked === 'function') return opts.checked(v2);
        if (typeof opts.checked === 'string') return !!v2?.[opts.checked];
        return false;
    };
    return {
        if: (el)=>!!el.call?.('getCanvasV2'),
        flow: 'x',
        align: 'center space-between',
        padding: 'V 0',
        Label: {
            flow: 'y',
            gap: 'V',
            flexGrow: '1',
            Name: {
                tag: 'span',
                text: label,
                fontWeight: '600'
            },
            Hint: {
                tag: 'span',
                text: hint,
                fontSize: 'Z',
                color: 'rgba(255,255,255,0.55)'
            }
        },
        Control: {
            tag: 'input',
            type: 'checkbox',
            checked: (el)=>readChecked(el.call?.('getCanvasV2')),
            onChange: (ev, el)=>{
                const v = !!ev.target.checked;
                if (opts.patchSnap) el.call?.('patchSnap', opts.patchSnap(v));
                else if (opts.patch) el.call?.('patchCanvas', opts.patch(v));
            }
        }
    };
}
// Factory for SettingsModal content rows — label + hint on the left, a
// control (toggle, button, input) on the right. Takes the control def
// directly so callers own its state/handlers.
function $a569955e4f91ff1b$var$settingsBlockRow(label, hint, control) {
    return {
        flow: 'x',
        align: 'center space-between',
        padding: 'V 0',
        Label: {
            flow: 'y',
            gap: 'V',
            flexGrow: '1',
            Name: {
                tag: 'span',
                text: label,
                fontWeight: '600'
            },
            Hint: {
                tag: 'span',
                text: hint,
                fontSize: 'Z',
                color: 'rgba(255,255,255,0.55)'
            }
        },
        Control: control
    };
}

// Cross-origin governance session is picked up via crossAppAuth.js —
// `hydrateAuthFromCookie()` mirrors every `sb-<ref>-auth-token` from the
// parent-domain cookie into this tab's localStorage, so the governance
// Supabase client reads the same session the user has on the intranet.
// Works in prod (shared `.symbols.app` cookie). In localhost dev, Chrome's
// public-suffix rule blocks `.localhost` cookies and iframe storage is
// partitioned — see workspace README for the dev-side workaround.
// Canvas renders integrations at org, workspace, AND project scope in the
// same board, so we query across every scope in one shot. `loadOrgIntegrations`
// pins `p_scope_type='org'` and hides project-scoped rows (e.g. Supabase
// projects with `default_scope='project'`) — not what we want here.
async function $a569955e4f91ff1b$var$loadIntegrationUnitsSafe(orgId) {
    if (!orgId) return [];
    try {
        const mod = await Promise.resolve((parcelRequire("8RlGv")));
        try {
            mod.hydrateSupabaseSessionsFromCookie?.();
        } catch  {}
        if (typeof mod.loadIntegrationUnits !== 'function') return [];
        const units = await mod.loadIntegrationUnits({
            orgId: orgId,
            type: null
        });
        return Array.isArray(units) ? units : [];
    } catch (err) {
        console.warn('[workspace] loadIntegrationUnits failed:', err?.message || err);
        return [];
    }
}
// Resolve an org's UUID from its slug via the SDK. Cached at module level
// AND in sessionStorage to survive reloads — `listOrganizations` is
// heavily rate-limited (HTTP 429) if hammered.
const $a569955e4f91ff1b$var$ORG_ID_BY_SLUG = new Map();
const $a569955e4f91ff1b$var$ORG_CACHE_KEY = '__canvas_orgs_v1';
const $a569955e4f91ff1b$var$ORG_CACHE_TTL_MS = 300000;
let $a569955e4f91ff1b$var$ORG_LIST_PROMISE = null;
function $a569955e4f91ff1b$var$readOrgCache() {
    try {
        const raw = sessionStorage.getItem($a569955e4f91ff1b$var$ORG_CACHE_KEY);
        if (!raw) return null;
        const entry = JSON.parse(raw);
        if (!entry?.at || !Array.isArray(entry.data)) return null;
        return entry;
    } catch  {
        return null;
    }
}
function $a569955e4f91ff1b$var$writeOrgCache(list) {
    try {
        sessionStorage.setItem($a569955e4f91ff1b$var$ORG_CACHE_KEY, JSON.stringify({
            at: Date.now(),
            data: list
        }));
    } catch  {}
}
async function $a569955e4f91ff1b$var$orgIdForSlug(slug) {
    if (!slug) return null;
    if ($a569955e4f91ff1b$var$ORG_ID_BY_SLUG.has(slug)) return $a569955e4f91ff1b$var$ORG_ID_BY_SLUG.get(slug);
    const cached = $a569955e4f91ff1b$var$readOrgCache();
    if (cached && Date.now() - cached.at < $a569955e4f91ff1b$var$ORG_CACHE_TTL_MS) {
        for (const o of cached.data)if (o?.slug) $a569955e4f91ff1b$var$ORG_ID_BY_SLUG.set(o.slug, o.id);
        if ($a569955e4f91ff1b$var$ORG_ID_BY_SLUG.has(slug)) return $a569955e4f91ff1b$var$ORG_ID_BY_SLUG.get(slug);
    }
    // Fallback: derive org id from cached project list's owner refs. Each
    // project carries `{ owner: { slug, id, type } }` — enough to recover
    // org UUIDs when `listOrganizations` is 429-throttled.
    try {
        const rawProjects = sessionStorage.getItem('__canvas_projects_v1');
        if (rawProjects) {
            const entry = JSON.parse(rawProjects);
            for (const p of entry?.data || []){
                const o = p?.owner;
                if (o?.slug && o?.id && o?.type === 'organization') $a569955e4f91ff1b$var$ORG_ID_BY_SLUG.set(o.slug, o.id);
            }
            if ($a569955e4f91ff1b$var$ORG_ID_BY_SLUG.has(slug)) return $a569955e4f91ff1b$var$ORG_ID_BY_SLUG.get(slug);
        }
    } catch  {}
    if (!$a569955e4f91ff1b$var$ORG_LIST_PROMISE) $a569955e4f91ff1b$var$ORG_LIST_PROMISE = (async ()=>{
        try {
            const sdk = (0, $bfqVY.getSDK)();
            if (!sdk.isReady?.()) await sdk.initialize({});
            const orgs = await sdk.listOrganizations();
            if (Array.isArray(orgs)) $a569955e4f91ff1b$var$writeOrgCache(orgs);
            return orgs || [];
        } catch (err) {
            console.warn('[workspace] orgIdForSlug failed:', err?.message || err);
            return cached?.data || [];
        }
    })();
    const orgs = await $a569955e4f91ff1b$var$ORG_LIST_PROMISE;
    for (const o of orgs || [])if (o?.slug) $a569955e4f91ff1b$var$ORG_ID_BY_SLUG.set(o.slug, o.id);
    return $a569955e4f91ff1b$var$ORG_ID_BY_SLUG.get(slug) || null;
}
// Fold the unit-shaped API response into flat per-instance records the
// canvas renderer consumes. Each record = one integration chip/card.
// scope_type='project' resolves scope_id against project UUID first, then
// falls back to project key — the admin picker stored `p.id || p.key`, so
// legacy rows carry the key rather than the UUID.
function $a569955e4f91ff1b$var$flattenIntegrationUnits(units, nodes, orgId) {
    const nodeByUuid = {};
    const nodeByKey = {};
    for (const n of nodes){
        if (n._id) nodeByUuid[n._id] = n;
        if (n.key) nodeByKey[n.key] = n;
    }
    const out = [];
    for (const unit of units || [])for (const inst of unit.instances || []){
        if (inst.enabled === false) continue;
        const scope = inst.scope_type || unit.default_scope || 'org';
        const config = inst.config && typeof inst.config === 'object' ? inst.config : {};
        const record = {
            id: `int:${scope}:${unit.kind}:${inst.slug}`,
            kind: unit.kind,
            category: unit.category,
            icon: $a569955e4f91ff1b$var$sanitiseIcon(unit.icon),
            label: inst.display_name || unit.label || unit.kind,
            kindLabel: unit.label || unit.kind,
            scope: scope,
            scopeId: inst.scope_id || null,
            slug: inst.slug,
            orgId: orgId,
            config: config,
            capabilities: unit.capabilities || [],
            authModel: unit.auth_model,
            hasSecret: inst.has_secret,
            enabled: inst.enabled !== false
        };
        if (scope === 'project') {
            const sid = inst.scope_id;
            const node = sid ? nodeByUuid[sid] || nodeByKey[sid] : null;
            if (!node) continue;
            record.projectId = node.id;
        }
        out.push(record);
    }
    return out;
}
// Cascades dev → prod screenshot URLs. Both null (CDN offline) → no-op,
// letter placeholder shows through. Ordered fallback with per-URL
// timeout because screenshots.symbo.ls sometimes hangs instead of 404.
function $a569955e4f91ff1b$var$mountThumbnailCascade(el, s) {
    const urls = [
        s.screenshotDev,
        s.screenshot
    ].filter(Boolean);
    if (!urls.length) return;
    const node = el.node;
    if (!node || node.__stackMounted) return;
    node.__stackMounted = true;
    const doc = el.context.document;
    const img = doc.createElement('img');
    img.alt = '';
    img.loading = 'lazy';
    img.decoding = 'async';
    img.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;display:block';
    let idx = 0;
    let timeoutId = null;
    const IMG_TIMEOUT_MS = 3500;
    const advance = ()=>{
        clearTimeout(timeoutId);
        idx += 1;
        if (idx < urls.length) {
            img.src = urls[idx];
            timeoutId = setTimeout(advance, IMG_TIMEOUT_MS);
            return;
        }
        try {
            img.remove();
        } catch  {}
    };
    img.addEventListener('error', advance);
    img.addEventListener('load', ()=>{
        clearTimeout(timeoutId);
    });
    img.src = urls[0];
    timeoutId = setTimeout(advance, IMG_TIMEOUT_MS);
    node.appendChild(img);
}
function $a569955e4f91ff1b$var$normalizeProject(p, localPositions, { page: page = 'root' } = {}) {
    const owner = (0, $aJaZ5.ownerSlug)(p);
    const key = (0, $aJaZ5.projectKey)(p);
    const explicitImage = p?.icon && typeof p.icon === 'object' && p.icon.src || p?.thumbnail || null;
    const screenshotDev = (0, $aJaZ5.SCREENSHOT_CDN_READY) ? (0, $aJaZ5.projectScreenshotUrl)(p, {
        page: page,
        env: 'development'
    }) : null;
    const screenshot = (0, $aJaZ5.SCREENSHOT_CDN_READY) ? (0, $aJaZ5.projectScreenshotUrl)(p, {
        page: page
    }) : null;
    // Real dependency graph lives on `useLibraries` (array of project _id refs)
    // returned by the list endpoint. Fall back to `sharedLibraries` for older
    // project shapes so seeded arrows still appear.
    const useLibraries = Array.isArray(p?.useLibraries) ? p.useLibraries : [];
    const legacySharedLibs = p?.sharedLibraries && typeof p.sharedLibraries === 'object' ? Object.keys(p.sharedLibraries) : Array.isArray(p?.sharedLibraries) ? p.sharedLibraries : [];
    // Position priority:
    //   1. canvasPosition from the list response (won't appear today because
    //      the server's getProjects projection drops it — but if the server
    //      ever starts including it, we pick it up transparently).
    //   2. locally-cached canvasPosition keyed by project _id (instant
    //      rehydrate on reload within the same origin).
    // The background refetch (`hydrateCanvasPositionsFromServer`) then fans
    // out `getProjectData` per owned project to sync from the source of
    // truth for multi-user correctness.
    const dbId = p?._id || p?.id || null;
    const fromPayload = p?.canvasPosition && typeof p.canvasPosition === 'object' ? {
        x: +p.canvasPosition.x,
        y: +p.canvasPosition.y
    } : null;
    const fromLocal = dbId && localPositions && localPositions[dbId] ? {
        x: +localPositions[dbId].x,
        y: +localPositions[dbId].y
    } : null;
    const canvasPosition = fromPayload && Number.isFinite(fromPayload.x) && Number.isFinite(fromPayload.y) ? fromPayload : fromLocal && Number.isFinite(fromLocal.x) && Number.isFinite(fromLocal.y) ? fromLocal : null;
    return {
        id: `${owner}/${key}`,
        _id: dbId,
        owner: owner,
        key: key,
        name: p?.name || key || 'Untitled',
        icon: explicitImage,
        screenshot: screenshot,
        screenshotDev: screenshotDev,
        useLibraries: useLibraries,
        legacySharedLibs: legacySharedLibs,
        canvasPosition: canvasPosition,
        type: p?.type || null,
        projectType: p?.projectType || null
    };
}
// Seed arrows from each project's declared library deps so reloading a
// workspace renders the same dependency graph stored in Mongo. Match by
// project _id (primary path via `useLibraries`), then fall back to bare
// project keys (legacy `sharedLibraries`). Also seeds integration→project
// arrows for project-scope integrations so e.g. a Supabase tied to a
// project renders as a link on load (no manual drag required).
function $a569955e4f91ff1b$var$initialConnections(nodes, integrations) {
    const byId = {};
    const byKey = {};
    nodes.forEach((n)=>{
        if (n._id) byId[n._id] = n.id;
        byKey[n.key] = byKey[n.key] || n.id;
    });
    const conns = [];
    nodes.forEach((n)=>{
        const seen = new Set();
        for (const libId of n.useLibraries || []){
            const from = byId[libId];
            if (!from || from === n.id || seen.has(from)) continue;
            seen.add(from);
            conns.push({
                id: from + "\u2192" + n.id,
                from: from,
                to: n.id
            });
        }
        for (const libKey of n.legacySharedLibs || []){
            const from = byKey[libKey];
            if (!from || from === n.id || seen.has(from)) continue;
            seen.add(from);
            conns.push({
                id: from + "\u2192" + n.id,
                from: from,
                to: n.id
            });
        }
    });
    // Project-scope integrations → their owning project.
    for (const it of integrations || []){
        if (it.scope !== 'project' || !it.projectId) continue;
        const to = it.projectId;
        if (!byId[it.scopeId] && !nodes.some((n)=>n.id === to)) continue;
        conns.push({
            id: it.id + "\u2192" + to,
            from: it.id,
            to: to,
            kind: 'integration'
        });
    }
    return conns;
}
// Compute the `useLibraries` array for one project node from the current
// connection graph — libraries are the `from` side (library → project edge).
function $a569955e4f91ff1b$var$computeSharedLibs(projectNodeId, connections, nodes) {
    const nodeById = Object.fromEntries(nodes.map((n)=>[
            n.id,
            n
        ]));
    const libs = [];
    for (const c of connections){
        if (c.to !== projectNodeId) continue;
        const libNode = nodeById[c.from];
        if (libNode?._id) libs.push(libNode._id);
    }
    return libs;
}
const $a569955e4f91ff1b$var$POSITION_DEBOUNCE_MS = 250;
const $a569955e4f91ff1b$var$POSITION_TIMERS = new Map();
const $a569955e4f91ff1b$var$POSITION_LAST = new Map();
// Pending writes indexed by node id so beforeunload / navigation can
// flush them synchronously. Each entry holds the exact payload the
// debounced timer would otherwise send.
const $a569955e4f91ff1b$var$POSITION_PENDING = new Map();
const $a569955e4f91ff1b$var$INT_POSITION_TIMERS = new Map();
const $a569955e4f91ff1b$var$INT_POSITION_LAST = new Map();
const $a569955e4f91ff1b$var$INT_SCOPE_PENDING = new Map();

async function $a569955e4f91ff1b$var$sdkBridge() {
    try {
        return await Promise.resolve((parcelRequire("8RlGv")));
    } catch  {
        return null;
    }
}
function $a569955e4f91ff1b$var$persistIntegrationPositions(root, ids) {
    const integrations = root?.integrations || [];
    const positions = root?.positions || {};
    for (const id of ids){
        const it = integrations.find((i)=>i.id === id);
        const pos = positions[id];
        if (!it?.orgId || !it?.kind || !it?.slug || !pos) continue;
        const sig = `${Math.round(pos.x)},${Math.round(pos.y)}`;
        if ($a569955e4f91ff1b$var$INT_POSITION_LAST.get(id) === sig) continue;
        clearTimeout($a569955e4f91ff1b$var$INT_POSITION_TIMERS.get(id));
        $a569955e4f91ff1b$var$INT_POSITION_TIMERS.set(id, setTimeout(async ()=>{
            $a569955e4f91ff1b$var$INT_POSITION_TIMERS.delete(id);
            $a569955e4f91ff1b$var$INT_POSITION_LAST.set(id, sig);
            const bridge = await $a569955e4f91ff1b$var$sdkBridge();
            if (!bridge?.saveIntegration) return;
            // Bug D fix: hydrate the governance Supabase session from cross-origin
            // cookie before the saveIntegration call. Without this, the governance
            // client has no active session when the canvas tab hasn't done its own
            // auth flow — `_adminCall` then returns 'not authenticated'.
            // Same pattern as loadIntegrationUnitsSafe (line ~246 above).
            try {
                bridge.hydrateSupabaseSessionsFromCookie?.();
            } catch  {}
            const nextConfig = {
                ...it.config || {},
                canvasPosition: {
                    x: Math.round(pos.x),
                    y: Math.round(pos.y)
                }
            };
            try {
                const res = await bridge.saveIntegration({
                    orgId: it.orgId,
                    kind: it.kind,
                    slug: it.slug,
                    scopeType: it.scope,
                    scopeId: it.scopeId,
                    config: nextConfig
                });
                if (!res?.ok) {
                    $a569955e4f91ff1b$var$INT_POSITION_LAST.delete(id);
                    console.warn('[workspace] persist int position failed:', id, res?.body?.error);
                    return;
                }
                // Mirror the saved config back into state so future saves merge
                // against fresh config instead of a stale snapshot.
                const updated = (root.integrations || []).map((r)=>r.id === id ? {
                        ...r,
                        config: nextConfig
                    } : r);
                root.update({
                    integrations: updated
                });
            } catch (err) {
                $a569955e4f91ff1b$var$INT_POSITION_LAST.delete(id);
                console.warn('[workspace] persist int position threw:', id, err?.message || err);
            }
        }, $a569955e4f91ff1b$var$POSITION_DEBOUNCE_MS));
    }
}

// Aggregate ALL workspace-scoped installable instances across every domain
// (integration, mcp, library, plugin). Returns a flat array in the common
// canvas installable shape:
//   { id, domain, name, kind, category, icon, scopeType, scopeId, status, _raw }
// The MCP path calls listConnectors from sdk-bridge. Library/plugin stubs
// return empty arrays until those SDK helpers are wired in Phase 6.
async function $a569955e4f91ff1b$var$loadWorkspaceInstallablesSafe(orgId) {
    const results = [];
    // 1. Integrations (already covered by flattenIntegrationUnits, but we need
    //    them again here as a flat list for the canvas nodes layer).
    try {
        const units = await $a569955e4f91ff1b$var$loadIntegrationUnitsSafe(orgId);
        for (const unit of units || [])for (const inst of unit.instances || []){
            if (inst.enabled === false) continue;
            const scopeType = inst.scope_type || unit.default_scope || 'org';
            const config = inst.config && typeof inst.config === 'object' ? inst.config : {};
            results.push({
                id: `int:${scopeType}:${unit.kind}:${inst.slug}`,
                domain: 'integration',
                name: inst.display_name || unit.label || unit.kind,
                kind: unit.kind,
                category: unit.category,
                icon: $a569955e4f91ff1b$var$sanitiseIcon(unit.icon),
                scopeType: scopeType,
                scopeId: inst.scope_id || null,
                slug: inst.slug,
                orgId: orgId,
                config: config,
                status: inst.enabled !== false ? 'enabled' : 'disabled',
                _raw: inst
            });
        }
    } catch (err) {
        console.warn('[workspace] loadWorkspaceInstallablesSafe integrations:', err?.message || err);
    }
    // 2. MCP connectors — loaded from sdk-bridge.listConnectors (RLS filters
    //    by jwt_active_workspace so no org scope needed).
    try {
        const mod = await Promise.resolve((parcelRequire("8RlGv")));
        mod.hydrateSupabaseSessionsFromCookie?.();
        if (typeof mod.listConnectors === 'function') {
            const { data: data, error: error } = await mod.listConnectors();
            if (!error && Array.isArray(data)) for (const c of data)results.push({
                id: `mcp:${c.scope_type || 'workspace'}:${c.id}`,
                domain: 'mcp',
                name: c.name || c.url || 'MCP',
                kind: 'mcp_connector',
                category: 'automation',
                icon: null,
                scopeType: c.scope_type || 'workspace',
                scopeId: c.scope_id || null,
                config: c.metadata || {},
                status: c.status || 'enabled',
                _raw: c
            });
        }
    } catch (err) {
        console.warn('[workspace] loadWorkspaceInstallablesSafe mcp:', err?.message || err);
    }
    // 3. Libraries stub — will be wired in Phase 6 when sdk-bridge exposes
    //    listWorkspaceLibraries. Returns empty for now so the canvas is ready.
    // 4. Plugins stub — same as libraries; deferred to Phase 6.
    return results;
}
// Persist canvas position for a non-project installable record. For
// MCP connectors this writes to `mcp_connectors.metadata.canvasPosition`
// via sdk-bridge.saveConnectorMetadata (fallback: direct Supabase PATCH).
// For integrations the existing `persistIntegrationPositions` covers it.
const $a569955e4f91ff1b$var$MCP_POSITION_TIMERS = new Map();
const $a569955e4f91ff1b$var$MCP_POSITION_LAST = new Map();
function $a569955e4f91ff1b$var$persistInstallableMCPPosition(root, ids) {
    const installables = root?._installables || [];
    const positions = root?.positions || {};
    for (const id of ids){
        const it = installables.find((i)=>i.id === id);
        if (!it || it.domain !== 'mcp') continue;
        const pos = positions[id];
        if (!pos) continue;
        const sig = `${Math.round(pos.x)},${Math.round(pos.y)}`;
        if ($a569955e4f91ff1b$var$MCP_POSITION_LAST.get(id) === sig) continue;
        clearTimeout($a569955e4f91ff1b$var$MCP_POSITION_TIMERS.get(id));
        $a569955e4f91ff1b$var$MCP_POSITION_TIMERS.set(id, setTimeout(async ()=>{
            $a569955e4f91ff1b$var$MCP_POSITION_TIMERS.delete(id);
            $a569955e4f91ff1b$var$MCP_POSITION_LAST.set(id, sig);
            const bridge = await $a569955e4f91ff1b$var$sdkBridge();
            if (!bridge) return;
            const canvasPosition = {
                x: Math.round(pos.x),
                y: Math.round(pos.y)
            };
            const connectorId = it._raw?.id;
            if (!connectorId) return;
            try {
                // Primary: use sdk-bridge.saveConnectorMetadata when available.
                if (typeof bridge.saveConnectorMetadata === 'function') {
                    await bridge.saveConnectorMetadata(connectorId, {
                        canvasPosition: canvasPosition
                    });
                    return;
                }
                // Fallback: direct Supabase PATCH on metadata JSONB column.
                const client = bridge.getClient?.();
                if (!client) return;
                const prev = it.config || {};
                await client.from('mcp_connectors').update({
                    metadata: {
                        ...prev,
                        canvasPosition: canvasPosition
                    }
                }).eq('id', connectorId);
            } catch (err) {
                $a569955e4f91ff1b$var$MCP_POSITION_LAST.delete(id);
                console.warn('[workspace] persist mcp position failed:', id, err?.message || err);
            }
        }, $a569955e4f91ff1b$var$POSITION_DEBOUNCE_MS));
    }
}
// Refresh all workspace-scoped installables (integrations + MCP + future
// domains) and update root._installables + positions. Called after install,
// delete, or scope change. Replaces the integrations-only refreshIntegrations()
// in the post-install path (refreshIntegrations is preserved for backward compat).
async function $a569955e4f91ff1b$var$refreshWorkspaceInstallables(root) {
    const slug = root?.slug;
    if (!slug) return;
    const orgId = await $a569955e4f91ff1b$var$orgIdForSlug(slug);
    if (!orgId) return;
    const all = await $a569955e4f91ff1b$var$loadWorkspaceInstallablesSafe(orgId);
    const positions = {
        ...root.positions || {}
    };
    let wsRowX = 24;
    const wsRowY = -$a569955e4f91ff1b$var$INSTALLABLE_H - 48;
    let mcpRowX = 24;
    const mcpRowY = wsRowY - $a569955e4f91ff1b$var$INSTALLABLE_H - 24;
    all.forEach((it)=>{
        if (positions[it.id]) return; // already positioned from previous load
        const saved = it.config?.canvasPosition || it._raw?.metadata?.canvasPosition;
        if (saved && Number.isFinite(saved.x) && Number.isFinite(saved.y)) {
            positions[it.id] = {
                x: +saved.x,
                y: +saved.y,
                w: $a569955e4f91ff1b$var$INSTALLABLE_W,
                h: $a569955e4f91ff1b$var$INSTALLABLE_H
            };
            return;
        }
        if (it.domain === 'mcp') {
            positions[it.id] = {
                x: mcpRowX,
                y: mcpRowY,
                w: $a569955e4f91ff1b$var$INSTALLABLE_W,
                h: $a569955e4f91ff1b$var$INSTALLABLE_H
            };
            mcpRowX += $a569955e4f91ff1b$var$INSTALLABLE_W + 24;
        } else {
            positions[it.id] = {
                x: wsRowX,
                y: wsRowY,
                w: $a569955e4f91ff1b$var$INSTALLABLE_W,
                h: $a569955e4f91ff1b$var$INSTALLABLE_H
            };
            wsRowX += $a569955e4f91ff1b$var$INSTALLABLE_W + 24;
        }
    });
    root.update({
        _installables: all,
        positions: positions
    });
    $a569955e4f91ff1b$var$redrawConnections();
}
// Arrow create/delete between an integration chip and a project reassigns
// the integration's scope via `integration-admin.assign_scope`. Creating
// an edge moves scope → project. Deleting it moves scope → org.
async function $a569955e4f91ff1b$var$saveIntegrationFromPicker(root) {
    const p = root?.integrationPicker;
    if (!p || p.saving) return;
    const kind = p.selectedKind;
    if (!kind) return;
    const orgId = await $a569955e4f91ff1b$var$orgIdForSlug(root.slug);
    if (!orgId) {
        root.update({
            integrationPicker: {
                ...p,
                error: 'No org id for ' + root.slug
            }
        });
        return;
    }
    const form = p.form || {};
    const slug = (form.__slug || '').trim() || 'default';
    const scope = form.__scope || kind.default_scope || 'org';
    const scopeId = scope === 'project' ? form.__scopeId : scope === 'workspace' ? form.__scopeId : null;
    if (scope === 'project' && !scopeId) {
        root.update({
            integrationPicker: {
                ...p,
                error: 'Pick a project for project scope'
            }
        });
        return;
    }
    const config = {};
    for (const [k, v] of Object.entries(form)){
        if (k.startsWith('__')) continue;
        config[k] = v;
    }
    root.update({
        integrationPicker: {
            ...p,
            saving: true,
            error: null
        }
    });
    try {
        const bridge = await $a569955e4f91ff1b$var$sdkBridge();
        if (!bridge?.saveIntegration) throw new Error('sdk-bridge not available');
        const res = await bridge.saveIntegration({
            orgId: orgId,
            kind: kind.kind,
            slug: slug,
            scopeType: scope,
            scopeId: scopeId,
            displayName: form.__displayName || config.display_name || null,
            config: config,
            secret: form.__secret || undefined
        });
        if (!res?.ok) {
            root.update({
                integrationPicker: {
                    ...p,
                    saving: false,
                    error: res?.body?.error || 'save failed'
                }
            });
            return;
        }
        root.update({
            integrationPicker: {
                open: false
            }
        });
        // Re-pull integrations so the new row is reflected on shelf / canvas.
        await $a569955e4f91ff1b$var$refreshIntegrations(root);
    } catch (err) {
        root.update({
            integrationPicker: {
                ...p,
                saving: false,
                error: err?.message || 'save failed'
            }
        });
    }
}
async function $a569955e4f91ff1b$var$refreshIntegrations(root) {
    const slug = root?.slug;
    if (!slug) return;
    const orgId = await $a569955e4f91ff1b$var$orgIdForSlug(slug);
    if (!orgId) return;
    const units = await $a569955e4f91ff1b$var$loadIntegrationUnitsSafe(orgId);
    const nodes = root.nodes || [];
    const integrations = $a569955e4f91ff1b$var$flattenIntegrationUnits(units, nodes, orgId);
    const positions = {
        ...root.positions || {}
    };
    integrations.forEach((it)=>{
        if (it.scope !== 'project' || !it.projectId) return;
        if (positions[it.id]) return;
        const saved = it.config?.canvasPosition;
        if (saved && Number.isFinite(saved.x) && Number.isFinite(saved.y)) {
            positions[it.id] = {
                x: +saved.x,
                y: +saved.y,
                w: $a569955e4f91ff1b$var$INTEGRATION_NODE_W,
                h: $a569955e4f91ff1b$var$INTEGRATION_NODE_H
            };
            return;
        }
        const anchor = positions[it.projectId];
        if (!anchor) return;
        positions[it.id] = {
            x: anchor.x,
            y: anchor.y + $a569955e4f91ff1b$var$NODE_H + 24,
            w: $a569955e4f91ff1b$var$INTEGRATION_NODE_W,
            h: $a569955e4f91ff1b$var$INTEGRATION_NODE_H
        };
    });
    root.update({
        integrations: integrations,
        positions: positions
    });
    $a569955e4f91ff1b$var$redrawConnections();
    // Phase 5: also refresh the full installables layer so new tiles appear.
    $a569955e4f91ff1b$var$refreshWorkspaceInstallables(root).catch(()=>{});
}
async function $a569955e4f91ff1b$var$persistIntegrationScope(root, integrationId, toScope, toProjectId) {
    const it = (root?.integrations || []).find((i)=>i.id === integrationId);
    if (!it?.orgId || !it?.kind || !it?.slug) return;
    if ($a569955e4f91ff1b$var$INT_SCOPE_PENDING.get(integrationId)) return;
    $a569955e4f91ff1b$var$INT_SCOPE_PENDING.set(integrationId, true);
    const bridge = await $a569955e4f91ff1b$var$sdkBridge();
    if (!bridge?.assignIntegrationScope) {
        $a569955e4f91ff1b$var$INT_SCOPE_PENDING.delete(integrationId);
        return;
    }
    const toProjectNode = toProjectId ? (root.nodes || []).find((n)=>n.id === toProjectId) : null;
    const toScopeId = toScope === 'project' ? toProjectNode?._id || null : null;
    try {
        const res = await bridge.assignIntegrationScope({
            orgId: it.orgId,
            kind: it.kind,
            slug: it.slug,
            fromScopeType: it.scope,
            fromScopeId: it.scopeId,
            toScopeType: toScope,
            toScopeId: toScopeId
        });
        if (!res?.ok) {
            console.warn('[workspace] assign_scope failed:', integrationId, res?.body?.error);
            return;
        }
        // Update the record in place so subsequent saves reference the new scope.
        const updated = (root.integrations || []).map((r)=>r.id === integrationId ? {
                ...r,
                scope: toScope,
                scopeId: toScopeId,
                projectId: toScope === 'project' ? toProjectId : undefined,
                id: `int:${toScope}:${r.kind}:${r.slug}`
            } : r);
        root.update({
            integrations: updated
        });
    } catch (err) {
        console.warn('[workspace] assign_scope threw:', integrationId, err?.message || err);
    } finally{
        $a569955e4f91ff1b$var$INT_SCOPE_PENDING.delete(integrationId);
    }
}
function $a569955e4f91ff1b$var$persistPositions(root, nodeIds) {
    const nodes = root?.nodes || [];
    const positions = root?.positions || {};
    const seen = new Set();
    for (const nodeId of nodeIds){
        if (seen.has(nodeId)) continue;
        seen.add(nodeId);
        const node = nodes.find((n)=>n.id === nodeId);
        const pos = positions[nodeId];
        if (!node?._id || !pos) continue;
        const canvasPosition = {
            x: Math.round(pos.x),
            y: Math.round(pos.y)
        };
        const sig = `${canvasPosition.x},${canvasPosition.y}`;
        if ($a569955e4f91ff1b$var$POSITION_LAST.get(nodeId) === sig) continue;
        clearTimeout($a569955e4f91ff1b$var$POSITION_TIMERS.get(nodeId));
        // Record pending write so beforeunload can flush it even if the
        // debounce hasn't fired yet.
        $a569955e4f91ff1b$var$POSITION_PENDING.set(nodeId, {
            nodeDbId: node._id,
            nodeLabel: node.id,
            canvasPosition: canvasPosition,
            sig: sig
        });
        $a569955e4f91ff1b$var$POSITION_TIMERS.set(nodeId, setTimeout(()=>$a569955e4f91ff1b$var$firePositionWrite(nodeId), $a569955e4f91ff1b$var$POSITION_DEBOUNCE_MS));
    }
}
// Write a canvasPosition to the server. `updateProject` silently strips
// unlisted fields (canvasPosition isn't in its allowed set), so we go
// through `setProjectValue` which accepts arbitrary top-level paths and
// stores the value verbatim — readable back via `getProjectData`.
async function $a569955e4f91ff1b$var$writeCanvasPositionToServer(projectDbId, canvasPosition) {
    const sdk = (0, $bfqVY.getSDK)();
    if (typeof sdk.setProjectValue !== 'function') // Fallback for older SDKs: still call updateProject (no-op on modern
    // server, but harmless).
    return sdk.updateProject(projectDbId, {
        canvasPosition: canvasPosition
    });
    return sdk.setProjectValue(projectDbId, [
        'canvasPosition'
    ], canvasPosition);
}
async function $a569955e4f91ff1b$var$firePositionWrite(nodeId) {
    const pending = $a569955e4f91ff1b$var$POSITION_PENDING.get(nodeId);
    if (!pending) return;
    $a569955e4f91ff1b$var$POSITION_PENDING.delete(nodeId);
    $a569955e4f91ff1b$var$POSITION_TIMERS.delete(nodeId);
    $a569955e4f91ff1b$var$POSITION_LAST.set(nodeId, pending.sig);
    // Always mirror to localStorage so reload is instant even before the
    // background refetch runs — and works across tabs within the origin.
    $a569955e4f91ff1b$var$writePositionToLocal(pending.nodeDbId, pending.canvasPosition);
    try {
        await $a569955e4f91ff1b$var$writeCanvasPositionToServer(pending.nodeDbId, pending.canvasPosition);
        $a569955e4f91ff1b$var$patchCachedProject(pending.nodeDbId, {
            canvasPosition: pending.canvasPosition
        });
    } catch (err) {
        $a569955e4f91ff1b$var$POSITION_LAST.delete(nodeId);
        console.error('[workspace] persist position failed:', pending.nodeLabel, err?.message || err);
        // One quick retry — covers transient 429s from bursty drags.
        setTimeout(async ()=>{
            try {
                await $a569955e4f91ff1b$var$writeCanvasPositionToServer(pending.nodeDbId, pending.canvasPosition);
                $a569955e4f91ff1b$var$patchCachedProject(pending.nodeDbId, {
                    canvasPosition: pending.canvasPosition
                });
                $a569955e4f91ff1b$var$POSITION_LAST.set(nodeId, pending.sig);
            } catch (err2) {
                console.error('[workspace] persist position retry failed:', pending.nodeLabel, err2?.message || err2);
            }
        }, 1500);
    }
}
// --- localStorage position fallback -----------------------------------------
// The server list endpoint (`getProjects`) returns a slim projection that
// doesn't include `canvasPosition`. `getProjectData` does, but it also
// ships components/pages and is heavy. To keep reloads feeling instant
// we snapshot positions in localStorage keyed by project id, and hydrate
// from there while the background refetch confirms with fresh server data.
const $a569955e4f91ff1b$var$LOCAL_POS_KEY = '__canvas_positions_v1';
function $a569955e4f91ff1b$var$readAllLocalPositions() {
    try {
        const raw = localStorage.getItem($a569955e4f91ff1b$var$LOCAL_POS_KEY);
        if (!raw) return {};
        const parsed = JSON.parse(raw);
        return parsed && typeof parsed === 'object' ? parsed : {};
    } catch  {
        return {};
    }
}
function $a569955e4f91ff1b$var$writePositionToLocal(projectDbId, canvasPosition) {
    try {
        const all = $a569955e4f91ff1b$var$readAllLocalPositions();
        all[projectDbId] = canvasPosition;
        localStorage.setItem($a569955e4f91ff1b$var$LOCAL_POS_KEY, JSON.stringify(all));
    } catch  {}
}
// Fetch authoritative positions from the server for the given project
// DB ids. Uses `getProjectData` because the list endpoint's projection
// doesn't include custom fields like `canvasPosition`. Runs concurrently
// with a small cap so large workspaces don't hammer the API. Emits an
// updated positions map for only the nodes that actually had a stored
// position — callers merge into `root.positions`.
const $a569955e4f91ff1b$var$POSITION_SYNC_CONCURRENCY = 3;
async function $a569955e4f91ff1b$var$fetchServerPositions(projectDbIds, onPositionResolved) {
    const sdk = (0, $bfqVY.getSDK)();
    if (typeof sdk.getProjectData !== 'function') return;
    const queue = [
        ...projectDbIds
    ];
    const runOne = async ()=>{
        while(queue.length){
            const id = queue.shift();
            try {
                const data = await sdk.getProjectData(id);
                const pos = data?.canvasPosition;
                if (pos && Number.isFinite(+pos.x) && Number.isFinite(+pos.y)) {
                    const clean = {
                        x: +pos.x,
                        y: +pos.y
                    };
                    $a569955e4f91ff1b$var$writePositionToLocal(id, clean);
                    onPositionResolved?.(id, clean);
                }
            } catch (err) {
            // Silent: transient failures aren't worth UI noise — next
            // drag/reload will retry. 429 in particular self-heals once
            // the server cools down.
            }
        }
    };
    await Promise.all(Array.from({
        length: Math.min($a569955e4f91ff1b$var$POSITION_SYNC_CONCURRENCY, queue.length)
    }, runOne));
}
// `fetch` may be cancelled by the browser on unload; `sendBeacon` is
// queued by the platform and survives the navigation. Falls back to
// the regular debounced write path when not on an unload boundary.
function $a569955e4f91ff1b$var$beaconCanvasPosition(projectDbId, canvasPosition) {
    if (typeof navigator === 'undefined' || typeof navigator.sendBeacon !== 'function') return false;
    const sdk = (0, $bfqVY.getSDK)();
    const apiUrl = sdk?.apiUrl;
    const token = sdk?.getAuthToken?.();
    if (!apiUrl || !token) return false;
    try {
        const blob = new Blob([
            JSON.stringify({
                path: [
                    'canvasPosition'
                ],
                value: canvasPosition,
                token: token
            })
        ], {
            type: 'application/json'
        });
        return navigator.sendBeacon(`${apiUrl}/projects/${projectDbId}/value`, blob);
    } catch  {
        return false;
    }
}
function $a569955e4f91ff1b$var$flushPendingPositions() {
    for (const nodeId of Array.from($a569955e4f91ff1b$var$POSITION_PENDING.keys())){
        const pending = $a569955e4f91ff1b$var$POSITION_PENDING.get(nodeId);
        clearTimeout($a569955e4f91ff1b$var$POSITION_TIMERS.get(nodeId));
        if (!pending) continue;
        $a569955e4f91ff1b$var$POSITION_PENDING.delete(nodeId);
        $a569955e4f91ff1b$var$POSITION_TIMERS.delete(nodeId);
        $a569955e4f91ff1b$var$POSITION_LAST.set(nodeId, pending.sig);
        $a569955e4f91ff1b$var$writePositionToLocal(pending.nodeDbId, pending.canvasPosition);
        if (!$a569955e4f91ff1b$var$beaconCanvasPosition(pending.nodeDbId, pending.canvasPosition)) $a569955e4f91ff1b$var$writeCanvasPositionToServer(pending.nodeDbId, pending.canvasPosition).catch(()=>{});
    }
}
// `storage` event fires only on OTHER tabs of the same origin (per spec).
function $a569955e4f91ff1b$var$onCrossTabPositionUpdate(ev) {
    if (ev.key !== $a569955e4f91ff1b$var$LOCAL_POS_KEY || !ev.newValue) return;
    const root = $a569955e4f91ff1b$var$WORKSPACE_ROOT;
    if (!root) return;
    let next, prev;
    try {
        next = JSON.parse(ev.newValue);
        prev = ev.oldValue ? JSON.parse(ev.oldValue) : {};
    } catch  {
        return;
    }
    if (!next || typeof next !== 'object') return;
    const nodes = root.nodes || [];
    const byDbId = new Map(nodes.filter((n)=>n._id).map((n)=>[
            n._id,
            n
        ]));
    const nextPositions = {
        ...root.positions || {}
    };
    let changed = false;
    for (const [dbId, pos] of Object.entries(next)){
        const old = prev?.[dbId];
        if (old && +old.x === +pos.x && +old.y === +pos.y) continue;
        if (!pos || !Number.isFinite(+pos.x) || !Number.isFinite(+pos.y)) continue;
        const node = byDbId.get(dbId);
        if (!node) continue;
        const nd = $a569955e4f91ff1b$var$dimsFor(node.projectType);
        nextPositions[node.id] = {
            x: +pos.x,
            y: +pos.y,
            w: nd.w,
            h: nd.h
        };
        changed = true;
    }
    if (!changed) return;
    root.update({
        positions: nextPositions
    });
    $a569955e4f91ff1b$var$redrawConnections();
}
if (typeof window !== 'undefined' && !window.__wsFlushHooked) {
    window.__wsFlushHooked = true;
    // `pagehide` fires on real unload and on bfcache stashing; `beforeunload`
    // doesn't fire on iOS. Covering both is safest.
    window.addEventListener('pagehide', $a569955e4f91ff1b$var$flushPendingPositions);
    window.addEventListener('beforeunload', $a569955e4f91ff1b$var$flushPendingPositions);
    window.addEventListener('storage', $a569955e4f91ff1b$var$onCrossTabPositionUpdate);
}
// Post-install refresh: governance fires `{ type: 'symbols:integration-installed' }`
// via postMessage after a successful marketplace install. The canvas receives it
// here and calls refreshIntegrations so the new row appears within ~2s without
// requiring a manual reload. Hoisted once; guard prevents duplicate listeners
// across hot-module-replacement reloads.
function $a569955e4f91ff1b$var$onInstallMessage(ev) {
    if (ev?.data?.type !== 'symbols:integration-installed') return;
    const root = $a569955e4f91ff1b$var$WORKSPACE_ROOT;
    if (!root) return;
    // Small delay so the server-side DB write completes before we re-fetch.
    // refreshIntegrations also triggers refreshWorkspaceInstallables (Phase 5).
    setTimeout(()=>$a569955e4f91ff1b$var$refreshIntegrations(root), 600);
}
if (typeof window !== 'undefined' && !window.__wsInstallMsgHooked) {
    window.__wsInstallMsgHooked = true;
    window.addEventListener('message', $a569955e4f91ff1b$var$onInstallMessage);
}
// Re-assert the live pz scale on ZoomInNavbar's Box, which DOMQL's
// reactive re-render keeps reverting to the static `text: '100%'`
// default. Node is resolved lazily and cached so the 250ms backstop
// doesn't re-scan the DOM every tick.
let $a569955e4f91ff1b$var$ZOOM_LABEL_NODE = null;
function $a569955e4f91ff1b$var$resolveZoomLabelNode() {
    if ($a569955e4f91ff1b$var$ZOOM_LABEL_NODE && document.contains($a569955e4f91ff1b$var$ZOOM_LABEL_NODE)) return $a569955e4f91ff1b$var$ZOOM_LABEL_NODE;
    const viewH = window.innerHeight;
    const viewW = window.innerWidth;
    for (const n of document.querySelectorAll('span, div')){
        const t = (n.innerText || '').trim();
        if (!/^\d+%$/.test(t)) continue;
        const r = n.getBoundingClientRect();
        if (r.bottom < viewH - 160 || r.right < viewW - 360) continue;
        $a569955e4f91ff1b$var$ZOOM_LABEL_NODE = n;
        return n;
    }
    return null;
}
function $a569955e4f91ff1b$var$writeZoomLabel(pz) {
    if (!pz || typeof pz.getTransform !== 'function') return;
    const pct = Math.round(pz.getTransform().scale * 100) + '%';
    const node = $a569955e4f91ff1b$var$resolveZoomLabelNode();
    if (!node) return;
    // DOMQL re-renders clobber this back to '100%' so we can't skip the
    // write just because pct is unchanged — always compare against the
    // actual DOM value.
    if (node.innerText === pct) return;
    node.innerText = pct;
}
const $a569955e4f91ff1b$var$PERSIST_DEBOUNCE_MS = 500;
const $a569955e4f91ff1b$var$PERSIST_TIMERS = new Map();
// `/projects/:id/libraries` validates that targets are active *shared*
// libraries and 404s otherwise — too strict for arbitrary project→project
// arrows on the workspace. `PATCH /projects/:id` with `useLibraries` just
// persists the ref list, which is what we want.
const $a569955e4f91ff1b$var$LAST_SIGNATURE = new Map();
function $a569955e4f91ff1b$var$persistSharedLibraries(root, projectNodeIds) {
    const nodes = root?.nodes || [];
    const connections = root?.connections || [];
    const ids = Array.from(new Set(projectNodeIds)).filter(Boolean);
    for (const nodeId of ids){
        const node = nodes.find((n)=>n.id === nodeId);
        if (!node?._id) continue;
        const libs = $a569955e4f91ff1b$var$computeSharedLibs(nodeId, connections, nodes);
        const signature = libs.slice().sort().join('|');
        if (!$a569955e4f91ff1b$var$LAST_SIGNATURE.has(nodeId)) $a569955e4f91ff1b$var$LAST_SIGNATURE.set(nodeId, (node.useLibraries || []).slice().sort().join('|'));
        if ($a569955e4f91ff1b$var$LAST_SIGNATURE.get(nodeId) === signature) continue;
        const prev = $a569955e4f91ff1b$var$LAST_SIGNATURE.get(nodeId);
        clearTimeout($a569955e4f91ff1b$var$PERSIST_TIMERS.get(nodeId));
        $a569955e4f91ff1b$var$PERSIST_TIMERS.set(nodeId, setTimeout(async ()=>{
            $a569955e4f91ff1b$var$PERSIST_TIMERS.delete(nodeId);
            $a569955e4f91ff1b$var$LAST_SIGNATURE.set(nodeId, signature);
            try {
                await (0, $bfqVY.getSDK)().updateProject(node._id, {
                    useLibraries: libs
                });
                $a569955e4f91ff1b$var$patchCachedProject(node._id, {
                    useLibraries: libs
                });
            } catch (err) {
                $a569955e4f91ff1b$var$LAST_SIGNATURE.set(nodeId, prev);
                console.warn('[workspace] persist sharedLibraries failed:', node.id, err?.message || err);
            }
        }, $a569955e4f91ff1b$var$PERSIST_DEBOUNCE_MS));
    }
}
function $a569955e4f91ff1b$var$anchorPoint(pos, side) {
    if (side === 'top') return {
        x: pos.x + pos.w / 2,
        y: pos.y
    };
    if (side === 'bottom') return {
        x: pos.x + pos.w / 2,
        y: pos.y + pos.h
    };
    if (side === 'left') return {
        x: pos.x,
        y: pos.y + pos.h / 2
    };
    return {
        x: pos.x + pos.w,
        y: pos.y + pos.h / 2
    };
}
function $a569955e4f91ff1b$var$pickSides(fromPos, toPos) {
    const dx = toPos.x + toPos.w / 2 - (fromPos.x + fromPos.w / 2);
    const dy = toPos.y + toPos.h / 2 - (fromPos.y + fromPos.h / 2);
    if (Math.abs(dx) >= Math.abs(dy)) return dx >= 0 ? [
        'right',
        'left'
    ] : [
        'left',
        'right'
    ];
    return dy >= 0 ? [
        'bottom',
        'top'
    ] : [
        'top',
        'bottom'
    ];
}
function $a569955e4f91ff1b$var$curvePath(fromPos, toPos) {
    const [fSide, tSide] = $a569955e4f91ff1b$var$pickSides(fromPos, toPos);
    const a = $a569955e4f91ff1b$var$anchorPoint(fromPos, fSide);
    const b = $a569955e4f91ff1b$var$anchorPoint(toPos, tSide);
    const vertical = fSide === 'top' || fSide === 'bottom';
    if (vertical) {
        const off = Math.max(40, Math.abs(b.y - a.y) * 0.5);
        const c1y = a.y + (fSide === 'bottom' ? off : -off);
        const c2y = b.y + (tSide === 'bottom' ? off : -off);
        return `M${a.x},${a.y} C${a.x},${c1y} ${b.x},${c2y} ${b.x},${b.y}`;
    }
    const off = Math.max(40, Math.abs(b.x - a.x) * 0.5);
    const c1x = a.x + (fSide === 'right' ? off : -off);
    const c2x = b.x + (tSide === 'right' ? off : -off);
    return `M${a.x},${a.y} C${c1x},${a.y} ${c2x},${b.y} ${b.x},${b.y}`;
}
// Approximate midpoint of the Bezier curve built by `curvePath`: use the
// mean of the two endpoints — close enough for placing a delete button.
function $a569955e4f91ff1b$var$curveMidpoint(fromPos, toPos) {
    const [fSide, tSide] = $a569955e4f91ff1b$var$pickSides(fromPos, toPos);
    const a = $a569955e4f91ff1b$var$anchorPoint(fromPos, fSide);
    const b = $a569955e4f91ff1b$var$anchorPoint(toPos, tSide);
    return {
        x: (a.x + b.x) / 2,
        y: (a.y + b.y) / 2
    };
}
function $a569955e4f91ff1b$var$buildConnectionsSVG(root) {
    const positions = root?.positions || {};
    const connections = root?.connections || [];
    const integrations = root?.integrations || [];
    const intById = Object.fromEntries(integrations.map((i)=>[
            i.id,
            i
        ]));
    const stroke = 'rgba(255,255,255,0.6)';
    const groups = connections.map((c)=>{
        const from = positions[c.from];
        const to = positions[c.to];
        if (!from || !to) return '';
        const d = $a569955e4f91ff1b$var$curvePath(from, to);
        const mid = $a569955e4f91ff1b$var$curveMidpoint(from, to);
        const isIntegration = c.kind === 'integration' || intById[c.from] || intById[c.to];
        const intCategory = intById[c.from]?.category || intById[c.to]?.category;
        const intColor = $a569955e4f91ff1b$var$integrationColor(intCategory);
        const pathStroke = isIntegration ? intColor : stroke;
        const dashAttr = isIntegration ? ' stroke-dasharray="6 4"' : '';
        const markerId = isIntegration ? 'ws-arrow-int' : 'ws-arrow';
        return `<g class="conn" data-connection-id="${c.id}">` + `<path d="${d}" stroke="${pathStroke}" stroke-width="1.5" fill="none" opacity="0.85"${dashAttr} marker-end="url(#${markerId})"/>` + // Wide invisible hit zone → easy click target along the whole path.
        `<path d="${d}" stroke="transparent" stroke-width="14" fill="none" style="pointer-events:stroke;cursor:pointer"><title>click to remove</title></path>` + // × button at the midpoint, revealed on hover of the whole <g>.
        `<g class="conn-x" transform="translate(${mid.x},${mid.y})" style="pointer-events:all;cursor:pointer" data-connection-id="${c.id}">` + `<circle r="8" fill="rgba(20,22,27,0.9)" stroke="rgba(255,255,255,0.25)" stroke-width="1"/>` + `<path d="M-3,-3 L3,3 M-3,3 L3,-3" stroke="rgba(255,255,255,0.85)" stroke-width="1.2" stroke-linecap="round"/>` + `</g>` + `</g>`;
    }).join('');
    const linking = root?.linking;
    let ghost = '';
    if (linking?.fromId) {
        const from = positions[linking.fromId];
        if (from) {
            const target = linking.toId ? positions[linking.toId] : null;
            let d;
            if (target) d = $a569955e4f91ff1b$var$curvePath(from, target);
            else {
                const cursorRect = {
                    x: linking.toX,
                    y: linking.toY,
                    w: 0,
                    h: 0
                };
                const [fSide] = $a569955e4f91ff1b$var$pickSides(from, cursorRect);
                const start = $a569955e4f91ff1b$var$anchorPoint(from, fSide);
                d = `M${start.x},${start.y} L${linking.toX},${linking.toY}`;
            }
            ghost = `<path d="${d}" stroke="rgba(255,255,255,0.95)" stroke-width="2.5" stroke-dasharray="8 5" fill="none" style="filter:drop-shadow(0 0 6px rgba(0,0,0,0.6))"/>`;
        }
    }
    const style = `<style>.conn-x{opacity:0;transition:opacity .12s ease}.conn:hover .conn-x{opacity:1}</style>`;
    return `<svg xmlns="http://www.w3.org/2000/svg" width="${$a569955e4f91ff1b$var$BOARD_W}" height="${$a569955e4f91ff1b$var$BOARD_H}" style="position:absolute;top:0;left:0;pointer-events:none;overflow:visible">${style}<defs><marker id="ws-arrow" viewBox="0 0 10 10" refX="9" refY="5" markerWidth="8" markerHeight="8" orient="auto-start-reverse"><path d="M0,0 L10,5 L0,10 z" fill="${stroke}"/></marker><marker id="ws-arrow-int" viewBox="0 0 10 10" refX="9" refY="5" markerWidth="7" markerHeight="7" orient="auto-start-reverse"><path d="M0,2 L10,5 L0,8 z" fill="#7aa2ff" opacity="0.9"/></marker></defs>${groups}${ghost}</svg>`;
}
function $a569955e4f91ff1b$var$layoutPositions(nodes) {
    const positions = {};
    let autoIndex = 0;
    nodes.forEach((n)=>{
        if (n.canvasPosition && Number.isFinite(n.canvasPosition.x) && Number.isFinite(n.canvasPosition.y)) {
            positions[n.id] = {
                x: n.canvasPosition.x,
                y: n.canvasPosition.y,
                w: $a569955e4f91ff1b$var$dimsFor(n.projectType).w,
                h: $a569955e4f91ff1b$var$dimsFor(n.projectType).h
            };
            return;
        }
        const col = autoIndex % $a569955e4f91ff1b$var$PER_ROW;
        const row = Math.floor(autoIndex / $a569955e4f91ff1b$var$PER_ROW);
        autoIndex++;
        positions[n.id] = {
            x: col * $a569955e4f91ff1b$var$COL_STRIDE,
            y: row * $a569955e4f91ff1b$var$ROW_STRIDE,
            w: $a569955e4f91ff1b$var$dimsFor(n.projectType).w,
            h: $a569955e4f91ff1b$var$dimsFor(n.projectType).h
        };
    });
    return positions;
}
let $a569955e4f91ff1b$var$PZ = null;
let $a569955e4f91ff1b$var$BOARD_EL = null;
let $a569955e4f91ff1b$var$CONNECTIONS_NODE = null;
let $a569955e4f91ff1b$var$WORKSPACE_ROOT = null;
const $a569955e4f91ff1b$var$ACTIVE_DRAG_IDS = new Set();
// Compute the live screen-space position of a tile's bottom-right anchor
// (where the project context-menu attaches). Reads board-coords from
// root.positions[id] and applies the current panzoom transform.
//
// Returns { tileTop, tileBottom, tileLeft, tileRight } in viewport CSS
// pixels, or null when position/transform aren't ready yet (initial mount,
// or stale openMenuId after a workspace switch).
function $a569955e4f91ff1b$var$computeMenuScreenPos(root, nodeId) {
    if (!root || !nodeId) return null;
    const pos = root.positions?.[nodeId];
    if (!pos) return null;
    // panzoom transform — fall back to identity when PZ hasn't initialized
    // yet (menu opens during the first paint before pz.zoomAbs runs).
    const t = $a569955e4f91ff1b$var$PZ?.getTransform?.() || {
        x: 0,
        y: 0,
        scale: 1
    };
    const w = pos.w || $a569955e4f91ff1b$var$NODE_W;
    const h = pos.h || $a569955e4f91ff1b$var$NODE_H;
    const tileLeft = pos.x * t.scale + t.x;
    const tileTop = pos.y * t.scale + t.y;
    const tileRight = tileLeft + w * t.scale;
    const tileBottom = tileTop + h * t.scale;
    return {
        tileTop: tileTop,
        tileBottom: tileBottom,
        tileLeft: tileLeft,
        tileRight: tileRight
    };
}
// During drag we move cards via direct DOM style writes (bypassing
// root.update) to avoid triggering the full reactive subtree on every
// mousemove. DRAG_DOM_NODES maps nodeId → DOM element for fast lookup.
// DRAG_RAF holds the pending rAF handle so we don't schedule more than
// one SVG redraw per frame.
const $a569955e4f91ff1b$var$DRAG_DOM_NODES = new Map();
let $a569955e4f91ff1b$var$DRAG_RAF = 0;
// Dropping a card onto another card / an existing workspace frame assigns
// it to a `workspaceN` slot — the visual "group" that wraps both.
const $a569955e4f91ff1b$var$GROUP_SLOTS = Array.from({
    length: 50
}, (_, i)=>'group' + (i + 1));
const $a569955e4f91ff1b$var$GROUP_PAD = 20;
function $a569955e4f91ff1b$var$currentGroup(node, state) {
    return state?.groupMap?.[node.id] || null;
}
function $a569955e4f91ff1b$var$nodesOfGroup(wsId, state) {
    return (state?.nodes || []).filter((n)=>$a569955e4f91ff1b$var$currentGroup(n, state) === wsId);
}
function $a569955e4f91ff1b$var$groupBbox(state, wsId) {
    const items = $a569955e4f91ff1b$var$nodesOfGroup(wsId, state).filter((n)=>!$a569955e4f91ff1b$var$ACTIVE_DRAG_IDS.has(n.id)).map((n)=>state.positions?.[n.id]).filter(Boolean);
    if (!items.length) return null;
    const minX = Math.min(...items.map((p)=>p.x));
    const minY = Math.min(...items.map((p)=>p.y));
    const maxX = Math.max(...items.map((p)=>p.x + p.w));
    const maxY = Math.max(...items.map((p)=>p.y + p.h));
    return {
        x: minX,
        y: minY,
        w: maxX - minX,
        h: maxY - minY
    };
}
function $a569955e4f91ff1b$var$nextGroupName(state) {
    const used = new Set(Object.values(state.groupMap || {}));
    for (const slot of $a569955e4f91ff1b$var$GROUP_SLOTS)if (!used.has(slot)) return slot;
    return 'group' + Date.now();
}
function $a569955e4f91ff1b$var$detectDropTarget(selfId, box, state) {
    const cx = box.x + box.w / 2;
    const cy = box.y + box.h / 2;
    for (const n of state.nodes || []){
        if (n.id === selfId) continue;
        const p = state.positions?.[n.id];
        if (!p) continue;
        if (cx >= p.x && cx <= p.x + p.w && cy >= p.y && cy <= p.y + p.h) {
            const ws = $a569955e4f91ff1b$var$currentGroup(n, state);
            if (ws) return {
                nodeId: null,
                nodeGroupId: ws,
                groupId: ws
            };
            return {
                nodeId: n.id,
                nodeGroupId: null,
                groupId: null
            };
        }
    }
    for (const ws of $a569955e4f91ff1b$var$GROUP_SLOTS){
        const bb = $a569955e4f91ff1b$var$groupBbox(state, ws);
        if (bb && cx >= bb.x && cx <= bb.x + bb.w && cy >= bb.y && cy <= bb.y + bb.h) return {
            nodeId: null,
            nodeGroupId: null,
            groupId: ws
        };
    }
    return {
        nodeId: null,
        nodeGroupId: null,
        groupId: null
    };
}
function $a569955e4f91ff1b$var$restackGroup(wsId, state) {
    const positions = {
        ...state.positions
    };
    const members = $a569955e4f91ff1b$var$nodesOfGroup(wsId, state).map((n)=>n.id).filter((id)=>positions[id]);
    if (!members.length) return state;
    const minX = Math.min(...members.map((id)=>positions[id].x));
    const minY = Math.min(...members.map((id)=>positions[id].y));
    members.forEach((id, i)=>{
        const col = i % $a569955e4f91ff1b$var$PER_ROW;
        const row = Math.floor(i / $a569955e4f91ff1b$var$PER_ROW);
        positions[id] = {
            ...positions[id],
            x: minX + col * $a569955e4f91ff1b$var$COL_STRIDE,
            y: minY + row * $a569955e4f91ff1b$var$ROW_STRIDE
        };
    });
    return {
        ...state,
        positions: positions
    };
}
function $a569955e4f91ff1b$var$currentScale() {
    return $a569955e4f91ff1b$var$PZ?.getTransform?.().scale || 1;
}
function $a569955e4f91ff1b$var$redrawConnections(override) {
    if (!$a569955e4f91ff1b$var$CONNECTIONS_NODE) return;
    const root = override || $a569955e4f91ff1b$var$WORKSPACE_ROOT;
    if (!root) return;
    $a569955e4f91ff1b$var$CONNECTIONS_NODE.innerHTML = $a569955e4f91ff1b$var$buildConnectionsSVG(root);
}
function $a569955e4f91ff1b$var$nodeIdAtPoint(doc, clientX, clientY, selfId) {
    const list = doc.elementsFromPoint(clientX, clientY);
    for (const el of list){
        const id = el.dataset?.nodeId;
        if (id && id !== selfId) return id;
    }
    return null;
}
function $a569955e4f91ff1b$var$snapToGrid(n) {
    return Math.round(n / $a569955e4f91ff1b$var$GRID_STEP) * $a569955e4f91ff1b$var$GRID_STEP;
}
function $a569955e4f91ff1b$var$getDragMode(root) {
    return root?.dragMode || 'grid';
}
function $a569955e4f91ff1b$var$startDrag(e, el, root, id, opts = {}) {
    if (e.button !== 0) return;
    e.stopPropagation();
    const doc = el.context.document;
    const pos = root.positions?.[id];
    if (!pos) return;
    const isGroupDrag = !!opts.group;
    const groupWs = opts.groupWs || null;
    const groupIds = isGroupDrag && groupWs ? $a569955e4f91ff1b$var$nodesOfGroup(groupWs, root).map((n)=>n.id) : [
        id
    ];
    const starts = {};
    for (const gid of groupIds){
        const p = root.positions?.[gid];
        if (p) starts[gid] = {
            x: p.x,
            y: p.y,
            w: p.w,
            h: p.h
        };
    }
    const start = {
        mx: e.clientX,
        my: e.clientY,
        px: pos.x,
        py: pos.y
    };
    let moved = false;
    const selfNode = (root.nodes || []).find((n)=>n.id === id);
    const originalWs = selfNode ? $a569955e4f91ff1b$var$currentGroup(selfNode, root) : null;
    if (!isGroupDrag) for (const gid of groupIds)$a569955e4f91ff1b$var$ACTIVE_DRAG_IDS.add(gid);
    // Only update draggingId in root state — NOT positions. Position updates
    // during drag bypass root.update() to prevent the reactive Nodes children
    // from re-evaluating (and state.replace()-ing) every ProjectNode on every
    // mousemove event. Direct DOM style writes are used instead; the final
    // position is committed to root.positions once on mouseup.
    root.update({
        draggingId: id
    });
    // Track live positions in a local map so drop-target detection reads the
    // current drag position without touching root state.
    const livePositions = {
        ...root.positions
    };
    const onMove = (ev)=>{
        const scale = $a569955e4f91ff1b$var$currentScale();
        const dx = (ev.clientX - start.mx) / scale;
        const dy = (ev.clientY - start.my) / scale;
        if (!moved && Math.abs(dx) + Math.abs(dy) > $a569955e4f91ff1b$var$DRAG_THRESHOLD) moved = true;
        if (!moved) return;
        const applyMode = (x, y)=>$a569955e4f91ff1b$var$getDragMode(root) === 'grid' ? {
                x: $a569955e4f91ff1b$var$snapToGrid(x),
                y: $a569955e4f91ff1b$var$snapToGrid(y)
            } : {
                x: x,
                y: y
            };
        const snapped = applyMode(start.px + dx, start.py + dy);
        const snappedDx = snapped.x - start.px;
        const snappedDy = snapped.y - start.py;
        // Move dragged DOM nodes directly — no root.update(), no reactive cascade.
        for (const gid of groupIds){
            const st = starts[gid];
            const nx = st.x + snappedDx;
            const ny = st.y + snappedDy;
            livePositions[gid] = {
                ...livePositions[gid],
                x: nx,
                y: ny
            };
            const domNode = $a569955e4f91ff1b$var$DRAG_DOM_NODES.get(gid);
            if (domNode) {
                domNode.style.left = nx + 'px';
                domNode.style.top = ny + 'px';
            }
        }
        let hoverGroup = null;
        let hoverNode = null;
        if (!isGroupDrag) {
            const t = $a569955e4f91ff1b$var$detectDropTarget(id, livePositions[id], {
                ...root,
                positions: livePositions
            });
            if (t.groupId && t.groupId !== originalWs) hoverGroup = t.groupId;
            if (t.nodeId && (!t.nodeGroupId || t.nodeGroupId !== originalWs)) hoverNode = t.nodeId;
        }
        // Only push hoverGroup/hoverNode into root state — not positions.
        // Schedule SVG redraw at most once per animation frame.
        root.update({
            hoverGroup: hoverGroup,
            hoverNode: hoverNode
        });
        if (!$a569955e4f91ff1b$var$DRAG_RAF) $a569955e4f91ff1b$var$DRAG_RAF = requestAnimationFrame(()=>{
            $a569955e4f91ff1b$var$DRAG_RAF = 0;
            $a569955e4f91ff1b$var$redrawConnections({
                ...root,
                positions: livePositions
            });
        });
    };
    const onUp = ()=>{
        doc.removeEventListener('mousemove', onMove);
        doc.removeEventListener('mouseup', onUp);
        if ($a569955e4f91ff1b$var$DRAG_RAF) {
            cancelAnimationFrame($a569955e4f91ff1b$var$DRAG_RAF);
            $a569955e4f91ff1b$var$DRAG_RAF = 0;
        }
        el.__didDrag = moved;
        if (!isGroupDrag && moved) {
            // Use livePositions (the positions we tracked locally during drag)
            // rather than root.positions (which was not updated during drag).
            const anchorPos = livePositions[id];
            if (anchorPos) {
                const t = $a569955e4f91ff1b$var$detectDropTarget(id, anchorPos, {
                    ...root,
                    positions: livePositions
                });
                const targetNodeWs = t.nodeGroupId;
                const dropWs = targetNodeWs || t.groupId;
                const newMap = {
                    ...root.groupMap || {}
                };
                const groupsToRestack = new Set();
                let newWs = null;
                if (dropWs && dropWs !== originalWs) {
                    newMap[id] = dropWs;
                    groupsToRestack.add(dropWs);
                } else if (t.nodeId && !targetNodeWs) {
                    newWs = $a569955e4f91ff1b$var$nextGroupName(root);
                    newMap[id] = newWs;
                    newMap[t.nodeId] = newWs;
                    groupsToRestack.add(newWs);
                } else if (!t.nodeId && !t.groupId && originalWs) delete newMap[id];
                if (originalWs && newMap[id] !== originalWs) groupsToRestack.add(originalWs);
                if (dropWs && dropWs === originalWs && t.nodeId) groupsToRestack.add(originalWs);
                let nextPositions = livePositions;
                for (const ws of groupsToRestack){
                    const snapshot = {
                        ...root,
                        groupMap: newMap,
                        positions: nextPositions
                    };
                    nextPositions = $a569955e4f91ff1b$var$restackGroup(ws, snapshot).positions;
                }
                // Single root.update() with final positions — one reactive cascade
                // instead of one per mousemove event.
                root.update({
                    positions: nextPositions,
                    groupMap: newMap
                });
            } else if (moved) // No drop-target logic needed but positions still changed — commit.
            root.update({
                positions: livePositions
            });
        } else if (moved) // Group drag: commit live positions to root in one shot.
        root.update({
            positions: livePositions
        });
        if (moved) {
            const integrations = root.integrations || [];
            const installables = root._installables || [];
            const intIds = groupIds.filter((id)=>integrations.some((i)=>i.id === id));
            const mcpIds = groupIds.filter((id)=>installables.some((i)=>i.id === id && i.domain === 'mcp'));
            const projectIds = groupIds.filter((id)=>!integrations.some((i)=>i.id === id) && !installables.some((i)=>i.id === id));
            if (projectIds.length) $a569955e4f91ff1b$var$persistPositions(root, projectIds);
            if (intIds.length) $a569955e4f91ff1b$var$persistIntegrationPositions(root, intIds);
            if (mcpIds.length) $a569955e4f91ff1b$var$persistInstallableMCPPosition(root, mcpIds);
        }
        root.update({
            draggingId: null,
            hoverGroup: null,
            hoverNode: null
        });
        $a569955e4f91ff1b$var$redrawConnections();
        if (!isGroupDrag) for (const gid of groupIds)$a569955e4f91ff1b$var$ACTIVE_DRAG_IDS.delete(gid);
        setTimeout(()=>{
            el.__didDrag = false;
        }, 0);
    };
    doc.addEventListener('mousemove', onMove);
    doc.addEventListener('mouseup', onUp);
}
function $a569955e4f91ff1b$var$startLink(e, el, root, fromId, opts = {}) {
    if (e.button !== 0) return;
    e.stopPropagation();
    e.preventDefault();
    const doc = el.context.document;
    const board = $a569955e4f91ff1b$var$BOARD_EL;
    if (!board) return;
    const toBoardCoords = (ev)=>{
        const r = board.getBoundingClientRect();
        const scale = $a569955e4f91ff1b$var$currentScale();
        return {
            toX: (ev.clientX - r.left) / scale,
            toY: (ev.clientY - r.top) / scale
        };
    };
    root.update({
        linking: {
            fromId: fromId,
            toId: null,
            ...toBoardCoords(e)
        }
    });
    $a569955e4f91ff1b$var$redrawConnections();
    const onMove = (ev)=>{
        const toId = $a569955e4f91ff1b$var$nodeIdAtPoint(doc, ev.clientX, ev.clientY, fromId);
        root.update({
            linking: {
                fromId: fromId,
                toId: toId,
                ...toBoardCoords(ev)
            }
        });
        $a569955e4f91ff1b$var$redrawConnections();
    };
    const onUp = (ev)=>{
        doc.removeEventListener('mousemove', onMove);
        doc.removeEventListener('mouseup', onUp);
        const toId = $a569955e4f91ff1b$var$nodeIdAtPoint(doc, ev.clientX, ev.clientY, fromId);
        if (toId) {
            const exists = (root.connections || []).some((c)=>c.from === fromId && c.to === toId);
            if (!exists) {
                const integrations = root.integrations || [];
                const isIntegration = opts.kind === 'integration' || integrations.some((i)=>i.id === fromId || i.id === toId);
                const conn = {
                    id: fromId + "\u2192" + toId + ':' + Date.now(),
                    from: fromId,
                    to: toId
                };
                if (isIntegration) conn.kind = 'integration';
                root.update({
                    connections: [
                        ...root.connections || [],
                        conn
                    ]
                });
                if (isIntegration) {
                    // Reassign the integration's scope: a drag from an integration
                    // to a project card means "this integration is now scoped to
                    // that project". Works in both directions.
                    const intSide = integrations.find((i)=>i.id === fromId) ? {
                        intId: fromId,
                        projectId: toId
                    } : {
                        intId: toId,
                        projectId: fromId
                    };
                    $a569955e4f91ff1b$var$persistIntegrationScope(root, intSide.intId, 'project', intSide.projectId);
                } else $a569955e4f91ff1b$var$persistSharedLibraries(root, [
                    toId
                ]);
            }
        }
        root.update({
            linking: null
        });
        $a569955e4f91ff1b$var$redrawConnections();
    };
    doc.addEventListener('mousemove', onMove);
    doc.addEventListener('mouseup', onUp);
}
let $a569955e4f91ff1b$var$LOAD_TOKEN = 0;
const $a569955e4f91ff1b$var$LOAD_IN_FLIGHT = new Map();
// Stale-load guard: a slow doLoadNodes finishing after the user has
// switched workspaces would clobber the new workspace's state with the
// old slug's nodes. Final commit compares `slug === LOAD_ACTIVE_SLUG`.
let $a569955e4f91ff1b$var$LOAD_ACTIVE_SLUG = null;
// Shared project-list cache — one `/projects?limit=1000` is heavy and
// filtering runs client-side per owner slug. Reuse across org switches
// and across dashboard ↔ workspace navigation; persist to sessionStorage
// so a reload still reuses the previous fetch (avoids HTTP 429).
const $a569955e4f91ff1b$var$PROJECT_LIST_TTL_MS = 300000;
const $a569955e4f91ff1b$var$PROJECT_LIST_KEY = '__canvas_projects_v1';
let $a569955e4f91ff1b$var$PROJECT_LIST_PROMISE = null;
function $a569955e4f91ff1b$var$readCacheEntry() {
    try {
        const raw = sessionStorage.getItem($a569955e4f91ff1b$var$PROJECT_LIST_KEY);
        if (!raw) return null;
        const entry = JSON.parse(raw);
        if (!entry?.at || !Array.isArray(entry.data)) return null;
        return entry;
    } catch  {
        return null;
    }
}
function $a569955e4f91ff1b$var$writeCache(list) {
    try {
        sessionStorage.setItem($a569955e4f91ff1b$var$PROJECT_LIST_KEY, JSON.stringify({
            at: Date.now(),
            data: list
        }));
    } catch  {}
}
// Patch a single project's fields inside the sessionStorage cache. Keeps
// the cache in sync with server-side mutations (canvasPosition,
// useLibraries, etc.) so a reload within the 5min TTL still reflects the
// latest state instead of reverting to the stale snapshot.
function $a569955e4f91ff1b$var$patchCachedProject(projectDbId, patch) {
    const entry = $a569955e4f91ff1b$var$readCacheEntry();
    if (!entry?.data) return;
    let changed = false;
    const next = entry.data.map((p)=>{
        if (p?._id !== projectDbId && p?.id !== projectDbId) return p;
        changed = true;
        return {
            ...p,
            ...patch
        };
    });
    if (!changed) return;
    try {
        sessionStorage.setItem($a569955e4f91ff1b$var$PROJECT_LIST_KEY, JSON.stringify({
            at: entry.at,
            data: next
        }));
    } catch  {}
}
function $a569955e4f91ff1b$export$fdf2d64c97cb6b39(rawProject) {
    if (!rawProject) return;
    try {
        const entry = $a569955e4f91ff1b$var$readCacheEntry();
        const existing = entry?.data || [];
        // De-dup: if a project with the same _id already landed (e.g. from a
        // concurrent background refetch) don't add a second copy.
        const id = rawProject._id || rawProject.id;
        if (id && existing.some((p)=>(p?._id || p?.id) === id)) return;
        const next = [
            rawProject,
            ...existing
        ];
        const serialised = JSON.stringify({
            at: Date.now(),
            data: next
        });
        sessionStorage.setItem($a569955e4f91ff1b$var$PROJECT_LIST_KEY, serialised);
        // Reset in-flight promise so the next getAllProjectsCached() call
        // triggers a fresh network fetch instead of resolving a stale promise.
        $a569955e4f91ff1b$var$PROJECT_LIST_PROMISE = null;
        // Cross-tab broadcast — other tabs listening to the `storage` event
        // will re-read the cache and can update their own in-memory state.
        try {
            window.dispatchEvent(new StorageEvent('storage', {
                key: $a569955e4f91ff1b$var$PROJECT_LIST_KEY,
                newValue: serialised,
                storageArea: sessionStorage
            }));
        } catch  {}
    } catch  {}
}
function $a569955e4f91ff1b$export$482845c065c9d77c(rawOrg) {
    if (!rawOrg) return;
    try {
        const entry = $a569955e4f91ff1b$var$readOrgCache();
        const existing = entry?.data || [];
        const id = rawOrg._id || rawOrg.id;
        if (id && existing.some((o)=>(o?._id || o?.id) === id)) return;
        const next = [
            rawOrg,
            ...existing
        ];
        sessionStorage.setItem($a569955e4f91ff1b$var$ORG_CACHE_KEY, JSON.stringify({
            at: Date.now(),
            data: next
        }));
        // Also warm the in-memory slug→id map so orgIdForSlug resolves
        // the new org immediately without a network round-trip.
        if (rawOrg.slug) $a569955e4f91ff1b$var$ORG_ID_BY_SLUG.set(rawOrg.slug, id);
        try {
            const serialised = JSON.stringify({
                at: Date.now(),
                data: next
            });
            window.dispatchEvent(new StorageEvent('storage', {
                key: $a569955e4f91ff1b$var$ORG_CACHE_KEY,
                newValue: serialised,
                storageArea: sessionStorage
            }));
        } catch  {}
    } catch  {}
}
async function $a569955e4f91ff1b$export$3f49101abffe0b8c() {
    const entry = $a569955e4f91ff1b$var$readCacheEntry();
    const fresh = entry && Date.now() - entry.at < $a569955e4f91ff1b$var$PROJECT_LIST_TTL_MS;
    if (fresh) return entry.data;
    if ($a569955e4f91ff1b$var$PROJECT_LIST_PROMISE) return $a569955e4f91ff1b$var$PROJECT_LIST_PROMISE;
    const sdk = (0, $bfqVY.getSDK)();
    if (!sdk.isReady?.()) await sdk.initialize({});
    $a569955e4f91ff1b$var$PROJECT_LIST_PROMISE = sdk.getProjects({
        limit: 1000
    }).then((r)=>{
        const list = r?.data || r || [];
        $a569955e4f91ff1b$var$writeCache(list);
        return list;
    }).catch((err)=>{
        // On 429 (or any error), keep whatever we have in sessionStorage —
        // stale data beats an empty board. Propagate the error only when
        // we have nothing cached at all.
        if (entry?.data) return entry.data;
        throw err;
    }).finally(()=>{
        $a569955e4f91ff1b$var$PROJECT_LIST_PROMISE = null;
    });
    return $a569955e4f91ff1b$var$PROJECT_LIST_PROMISE;
}
async function $a569955e4f91ff1b$var$doLoadNodes(root, slug) {
    const myToken = ++$a569955e4f91ff1b$var$LOAD_TOKEN;
    root.update({
        loading: true,
        error: null
    });
    try {
        const list = await $a569955e4f91ff1b$export$3f49101abffe0b8c();
        const localPositions = $a569955e4f91ff1b$var$readAllLocalPositions();
        const ownProjects = list.filter((p)=>(0, $aJaZ5.ownerMatches)(p, slug)).map((p)=>$a569955e4f91ff1b$var$normalizeProject(p, localPositions));
        // Pull in any project referenced as a library by nodes in this workspace
        // so incoming arrows from libraries outside the workspace (e.g. `brand`,
        // `shared`) render on load. Match by project `_id` (from useLibraries)
        // and falling back to bare key (legacy sharedLibraries).
        const referencedIds = new Set();
        const referencedKeys = new Set();
        ownProjects.forEach((n)=>{
            (n.useLibraries || []).forEach((id)=>referencedIds.add(id));
            (n.legacySharedLibs || []).forEach((k)=>referencedKeys.add(k));
        });
        const ownIds = new Set(ownProjects.map((n)=>n.id));
        // Narrow to referenced-library candidates BEFORE normalizing — the
        // full list (~150 projects) gets mapped otherwise, and most results
        // are thrown away by the filter downstream.
        const libraryNodes = list.filter((p)=>(referencedIds.has(p?._id) || referencedKeys.has((0, $aJaZ5.projectKey)(p))) && !(0, $aJaZ5.ownerMatches)(p, slug)).map((p)=>$a569955e4f91ff1b$var$normalizeProject(p, localPositions)).filter((n)=>!ownIds.has(n.id));
        const nodes = [
            ...ownProjects,
            ...libraryNodes
        ];
        if (myToken !== $a569955e4f91ff1b$var$LOAD_TOKEN) return;
        const orgId = await $a569955e4f91ff1b$var$orgIdForSlug(slug);
        const units = await $a569955e4f91ff1b$var$loadIntegrationUnitsSafe(orgId);
        if (myToken !== $a569955e4f91ff1b$var$LOAD_TOKEN) return;
        let integrations = $a569955e4f91ff1b$var$flattenIntegrationUnits(units, nodes, orgId);
        // Dev-only: `?demo=project-int` synthesises a project-scope record for
        // the first own project so on-canvas rendering + linking can be
        // verified against real UI code before any real row is migrated from
        // org→project scope.
        if (window.location.search.includes('demo=project-int') && ownProjects[0]) {
            const host = ownProjects[0];
            integrations = [
                ...integrations,
                {
                    id: 'int:project:custom_http:demo',
                    kind: 'custom_http',
                    category: 'custom',
                    label: 'Webhook (demo)',
                    kindLabel: 'Custom HTTP',
                    scope: 'project',
                    scopeId: host._id,
                    projectId: host.id,
                    capabilities: [
                        'http.request'
                    ],
                    enabled: true
                }
            ];
        }
        // Phase 5: load ALL workspace-scoped installables (integrations, MCP, …)
        // concurrently with the existing integration-unit load to avoid extra RTTs.
        const installablesPromise = $a569955e4f91ff1b$var$loadWorkspaceInstallablesSafe(orgId);
        const positions = $a569955e4f91ff1b$var$layoutPositions(nodes);
        // Canvas shows every configured integration so the full landscape at
        // /admin/integrations is visible. Saved `config.canvasPosition` wins;
        // otherwise:
        //   project → anchored below its owning project card
        //   workspace → auto-row just above the project grid
        //   org → auto-row above the workspace row (top-most infrastructure)
        let orgRowX = 24;
        const orgRowY = -($a569955e4f91ff1b$var$INTEGRATION_NODE_H + 24) * 2 - 24;
        let wsRowX = 24;
        const wsRowY = -$a569955e4f91ff1b$var$INTEGRATION_NODE_H - 48;
        integrations.forEach((it)=>{
            const saved = it.config?.canvasPosition;
            if (saved && Number.isFinite(saved.x) && Number.isFinite(saved.y)) {
                positions[it.id] = {
                    x: +saved.x,
                    y: +saved.y,
                    w: $a569955e4f91ff1b$var$INTEGRATION_NODE_W,
                    h: $a569955e4f91ff1b$var$INTEGRATION_NODE_H
                };
                return;
            }
            if (it.scope === 'project' && it.projectId) {
                const anchor = positions[it.projectId];
                if (!anchor) return;
                positions[it.id] = {
                    x: anchor.x,
                    y: anchor.y + $a569955e4f91ff1b$var$NODE_H + 24,
                    w: $a569955e4f91ff1b$var$INTEGRATION_NODE_W,
                    h: $a569955e4f91ff1b$var$INTEGRATION_NODE_H
                };
                return;
            }
            if (it.scope === 'workspace') {
                positions[it.id] = {
                    x: wsRowX,
                    y: wsRowY,
                    w: $a569955e4f91ff1b$var$INTEGRATION_NODE_W,
                    h: $a569955e4f91ff1b$var$INTEGRATION_NODE_H
                };
                wsRowX += $a569955e4f91ff1b$var$INTEGRATION_NODE_W + 24;
                return;
            }
            if (it.scope === 'org') {
                positions[it.id] = {
                    x: orgRowX,
                    y: orgRowY,
                    w: $a569955e4f91ff1b$var$INTEGRATION_NODE_W,
                    h: $a569955e4f91ff1b$var$INTEGRATION_NODE_H
                };
                orgRowX += $a569955e4f91ff1b$var$INTEGRATION_NODE_W + 24;
            }
        });
        // Await the Phase 5 installables load and seed canvas positions.
        // We use a row that sits between the project grid and the integration rows.
        const allInstallables = await installablesPromise;
        if (myToken !== $a569955e4f91ff1b$var$LOAD_TOKEN) return; // stale guard — don't clobber a newer load
        let instTileX = 24;
        const instTileY = -$a569955e4f91ff1b$var$INSTALLABLE_H - 120 // above the integration rows
        ;
        let mcpTileX = 24;
        const mcpTileY = instTileY - $a569955e4f91ff1b$var$INSTALLABLE_H - 28;
        allInstallables.forEach((it)=>{
            if (positions[it.id]) return; // already placed (integration positions seeded above)
            const savedPos = it.config?.canvasPosition || it._raw?.metadata?.canvasPosition || null;
            if (savedPos && Number.isFinite(savedPos.x) && Number.isFinite(savedPos.y)) {
                positions[it.id] = {
                    x: +savedPos.x,
                    y: +savedPos.y,
                    w: $a569955e4f91ff1b$var$INSTALLABLE_W,
                    h: $a569955e4f91ff1b$var$INSTALLABLE_H
                };
                return;
            }
            if (it.domain === 'mcp') {
                positions[it.id] = {
                    x: mcpTileX,
                    y: mcpTileY,
                    w: $a569955e4f91ff1b$var$INSTALLABLE_W,
                    h: $a569955e4f91ff1b$var$INSTALLABLE_H
                };
                mcpTileX += $a569955e4f91ff1b$var$INSTALLABLE_W + 24;
            } else {
                positions[it.id] = {
                    x: instTileX,
                    y: instTileY,
                    w: $a569955e4f91ff1b$var$INSTALLABLE_W,
                    h: $a569955e4f91ff1b$var$INSTALLABLE_H
                };
                instTileX += $a569955e4f91ff1b$var$INSTALLABLE_W + 24;
            }
        });
        if (slug !== $a569955e4f91ff1b$var$LOAD_ACTIVE_SLUG) return; // stale load — user switched
        root.update({
            slug: slug,
            orgId: orgId || null,
            nodes: nodes,
            integrations: integrations,
            _installables: allInstallables,
            positions: positions,
            connections: $a569955e4f91ff1b$var$initialConnections(nodes, integrations),
            groupMap: {},
            groupNames: {},
            hoverGroup: null,
            hoverNode: null,
            draggingId: null,
            linking: null,
            loading: false,
            error: null,
            // Sentinel: loadNodes has completed at least once for this workspace.
            // LabEmptyTutorial reads this so it doesn't flash during the initial
            // mount race (root.loading flips false before nodes hydrate).
            _labLoadedAt: Date.now()
        });
        $a569955e4f91ff1b$var$redrawConnections();
        if ($a569955e4f91ff1b$var$PZ) try {
            $a569955e4f91ff1b$var$PZ.zoomAbs(0, 0, 0.9);
            $a569955e4f91ff1b$var$PZ.moveTo(120, 120);
        } catch  {}
        // Background position sync. Reads authoritative canvasPositions from
        // the server for each own-workspace project via `getProjectData`. Any
        // that differ from the current render update `root.positions` and
        // the local snapshot. This is the multi-user "catch up" path — User
        // A moves a card in tab A, User B reloads tab B, background sync
        // pulls A's position into B. Own-only to cap fan-out.
        const ownDbIds = ownProjects.map((n)=>n._id).filter(Boolean);
        if (ownDbIds.length) $a569955e4f91ff1b$var$fetchServerPositions(ownDbIds, (projectDbId, serverPos)=>{
            if (slug !== $a569955e4f91ff1b$var$LOAD_ACTIVE_SLUG) return;
            const nodesNow = root.nodes || [];
            const match = nodesNow.find((n)=>n._id === projectDbId);
            if (!match) return;
            const curPos = root.positions?.[match.id];
            if (curPos && curPos.x === serverPos.x && curPos.y === serverPos.y) return;
            root.update({
                positions: {
                    ...root.positions || {},
                    [match.id]: {
                        x: serverPos.x,
                        y: serverPos.y,
                        w: $a569955e4f91ff1b$var$NODE_W,
                        h: $a569955e4f91ff1b$var$NODE_H
                    }
                }
            });
            $a569955e4f91ff1b$var$redrawConnections();
        }).catch(()=>{});
    } catch (err) {
        // Stale-load guard: if the user already switched away from this
        // slug, an error from the abandoned fetch must not clobber the
        // current workspace's nodes (that's what "items disappearing on
        // switch" bug reports trace back to).
        if (slug !== $a569955e4f91ff1b$var$LOAD_ACTIVE_SLUG) return;
        root.update({
            loading: false,
            error: err?.message || 'Failed to load workspace'
        });
    }
}
async function $a569955e4f91ff1b$export$fae8f4ef154badfa(root, slugOverride) {
    const slug = slugOverride || root?.activeWorkspace || $a569955e4f91ff1b$var$ownerSlugFromUrl();
    if (!slug) {
        root.update({
            loading: false,
            error: 'Missing owner slug',
            nodes: []
        });
        return;
    }
    $a569955e4f91ff1b$var$LOAD_ACTIVE_SLUG = slug;
    // De-dup concurrent calls for the same slug — dashboard onClick and the
    // embedded workspace's onUpdate both react to `activeWorkspace` changes.
    const existing = $a569955e4f91ff1b$var$LOAD_IN_FLIGHT.get(slug);
    if (existing) return existing;
    const p = $a569955e4f91ff1b$var$doLoadNodes(root, slug).finally(()=>{
        if ($a569955e4f91ff1b$var$LOAD_IN_FLIGHT.get(slug) === p) $a569955e4f91ff1b$var$LOAD_IN_FLIGHT.delete(slug);
    });
    $a569955e4f91ff1b$var$LOAD_IN_FLIGHT.set(slug, p);
    return p;
}
const $a569955e4f91ff1b$export$a9f58aecf07b7b3e = {
    position: 'absolute',
    // Libraries use a stadium/pill silhouette to stand apart from app/mobile/tv
    // tiles which keep the standard rounded-rect look.
    round: (el, s)=>s.projectType === 'library' ? 'C' : 'Z2',
    theme: 'canvas-card-glass',
    border: (el, s)=>s.projectType === 'library' ? '1px dashed rgba(180,140,255,0.45)' : '1px solid rgba(255,255,255,0.08)',
    flow: 'column',
    textDecoration: 'none',
    color: 'inherit',
    userSelect: 'none',
    cursor: 'grab',
    transition: 'B transform defaultBezier, B box-shadow defaultBezier',
    width: (el, s)=>$a569955e4f91ff1b$var$dimsFor(s.projectType).w + 'px',
    height: (el, s)=>$a569955e4f91ff1b$var$dimsFor(s.projectType).h + 'px',
    left: (el, s)=>(s.root?.positions?.[s.id]?.x ?? 0) + 'px',
    top: (el, s)=>(s.root?.positions?.[s.id]?.y ?? 0) + 'px',
    zIndex: (el, s)=>s.root?.draggingId === s.id ? 1000 : 1,
    boxShadow: (el, s)=>{
        if (s.root?.hoverNode === s.id) // iOS-style stacked-card preview: concentric ghost cards behind the
        // hovered target suggest a new workspace is about to form on drop.
        return [
            '0 0 0 10px rgba(20,22,27,0.92)',
            '0 0 0 11px rgba(255,255,255,0.16)',
            '0 0 0 20px rgba(20,22,27,0.82)',
            '0 0 0 21px rgba(255,255,255,0.1)',
            '0 26px 56px rgba(0,0,0,0.5)'
        ].join(', ');
        return '0 1px 2px rgba(0,0,0,0.35), 0 8px 24px rgba(0,0,0,0.28)';
    },
    ':hover': {
        transform: 'translateY(-2px)'
    },
    ':hover > [data-link-handle]': {
        opacity: '1',
        transform: 'scale(1)'
    },
    attr: {
        'data-node-id': (el, s)=>s.id
    },
    onRender: (el, s)=>{
        // onInit fires before el.node is created (v3.14 lifecycle order: Init →
        // cacheNode → Render). Use onRender so el.node is guaranteed to exist.
        if (s?.id && el.node) $a569955e4f91ff1b$var$DRAG_DOM_NODES.set(s.id, el.node);
    },
    onRemove: (el, s)=>{
        if (s?.id) $a569955e4f91ff1b$var$DRAG_DOM_NODES.delete(s.id);
    },
    onMousedown: (e, el, s)=>$a569955e4f91ff1b$var$startDrag(e, el, s.root, s.id),
    onClick: (e, el, s)=>{
        if (el.__didDrag) return;
        if (!s.owner || !s.key) return;
        const urls = (0, $3HmWC.buildProjectUrls)(s.owner, s.key);
        if (urls) el.router(`/${urls.safeOwner}/${urls.safeKey}`, el.getRoot());
    },
    Thumbnail: {
        position: 'relative',
        width: '100%',
        // Thumbnail occupies the upper portion of the tile; body holds title/path.
        // Mobile (portrait) gives more vertical space to the screen frame; library
        // is a chip-style strip with a thinner thumb.
        height: (el, s)=>{
            const t = s.projectType;
            if (t === 'mobile') return '232px';
            if (t === 'library') return '96px';
            if (t === 'tv') return '156px';
            return '160px';
        },
        flexShrink: '0',
        overflow: 'hidden',
        borderTopLeftRadius: 'inherit',
        borderTopRightRadius: 'inherit',
        // Gradient always paints first. Explicit icon paints over it via
        // `background`; screenshot-service URL is rendered as a sibling
        // <img> so a 404 leaves the gradient + letter placeholder visible.
        background: (el, s)=>s.icon ? `center / cover no-repeat url("${s.icon}"), linear-gradient(135deg,#2a2f38 0%,#1a1d24 55%,#0f1116 100%)` : 'linear-gradient(135deg,#2a2f38 0%,#1a1d24 55%,#0f1116 100%)',
        pointerEvents: 'none',
        // Screenshot / thumbnail — renders below the frame chrome so the
        // chrome overlay (browser bar, bezel, etc.) paints on top of the
        // screenshot image. mountThumbnailCascade appends an <img> with
        // position:absolute;inset:0 so it fills this container.
        ScreenshotStack: {
            if: (el, s)=>!s.icon && !!s.owner && !!s.key,
            tag: 'div',
            position: 'absolute',
            inset: '0',
            overflow: 'hidden',
            pointerEvents: 'none',
            zIndex: '1',
            onRender: (el, s)=>$a569955e4f91ff1b$var$mountThumbnailCascade(el, s)
        },
        // Type-aware visual frame — renders on top of screenshot/gradient.
        // Each projectType gets a distinct chrome (AppFrame, DeckFrame, etc.).
        // The frame components handle their own empty-content state glyphs.
        TypeFrame: {
            extends: 'ProjectTileFrame',
            position: 'absolute',
            inset: '0',
            pointerEvents: 'none',
            zIndex: '2'
        }
    },
    Body: {
        padding: 'Y2 A Y2',
        flow: 'column',
        gap: 'V',
        flexGrow: '1',
        justify: 'center',
        pointerEvents: 'none',
        borderTop: '1px solid rgba(255,255,255,0.05)',
        Title: {
            tag: 'h3',
            text: (el, s)=>s.name,
            fontSize: 'A',
            fontWeight: '600',
            color: 'white',
            lineHeight: '1.2',
            letterSpacing: '-0.01em'
        },
        Path: {
            tag: 'span',
            text: (el, s)=>s.id,
            fontSize: 'Z',
            color: 'rgba(255,255,255,0.42)',
            fontFamily: 'monospace',
            letterSpacing: '-0.02em'
        }
    },
    LinkHandle: {
        attr: {
            'data-link-handle': ''
        },
        position: 'absolute',
        right: '-10px',
        top: '50%',
        marginTop: '-10px',
        width: '20px',
        height: '20px',
        round: '50%',
        background: 'rgba(255,255,255,0.85)',
        border: '2px solid #14161b',
        cursor: 'crosshair',
        pointerEvents: 'auto',
        boxShadow: '0 2px 6px rgba(0,0,0,0.4)',
        opacity: '0',
        transform: 'scale(0.6)',
        transition: 'A opacity defaultBezier, A transform defaultBezier',
        ':hover': {
            transform: 'scale(1.3)'
        },
        onMousedown: (e, el, s)=>$a569955e4f91ff1b$var$startLink(e, el, s.root, s.id)
    },
    MenuButton: {
        tag: 'button',
        type: 'button',
        position: 'absolute',
        top: '8px',
        right: '8px',
        width: '24px',
        height: '24px',
        round: '50%',
        padding: '0',
        border: '0',
        background: 'rgba(0,0,0,0.55)',
        color: 'white',
        cursor: 'pointer',
        fontSize: '14px',
        lineHeight: '1',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        opacity: '1',
        transition: 'A opacity defaultBezier',
        boxShadow: '0 1px 3px rgba(0,0,0,0.5)',
        zIndex: '5',
        ':hover': {
            background: 'rgba(0,0,0,0.8)'
        },
        'aria-label': 'More options',
        text: "\u22EF",
        onPointerdown: (e)=>e.stopPropagation(),
        onMousedown: (e)=>e.stopPropagation(),
        onMouseup: (e)=>e.stopPropagation(),
        onClick: (e, el, s)=>{
            e.stopPropagation();
            e.preventDefault();
            const root = s.root;
            const isOpen = root.openMenuId === s.id;
            // No openMenuRect — Menu computes position LIVE from the tile's
            // board-coords + panzoom transform so it follows on pan/zoom.
            // _ctxMenuTick gives the menu a reactive signal to re-evaluate
            // its top/left when panzoom fires 'transform'.
            root.update({
                openMenuId: isOpen ? null : s.id,
                _ctxMenuTick: Date.now()
            });
        }
    },
    Menu: {
        display: (el, s)=>s.root?.openMenuId === s.id ? 'flex' : 'none',
        // Portal: position relative to viewport, then re-parent the rendered DOM to
        // document.body on first render so panzoom's transform on `Board` does NOT
        // scale or translate this menu. Menu logic and reactive lookups continue
        // to work because DOMQL holds the element ref by JS, not by DOM ancestry.
        //
        // Position is computed LIVE from the tile's current screen position
        // (board coords transformed by panzoom), so the menu follows when the
        // user pans or zooms. The transform-tick subscription in the studios
        // page's onRender re-evaluates these factories on every pz transform.
        position: 'fixed',
        top: (el, s)=>{
            s.root?._ctxMenuTick // reactive subscribe
            ;
            const pos = $a569955e4f91ff1b$var$computeMenuScreenPos(s.root, s.id);
            if (!pos) return '0px';
            const MENU_W = 232;
            const MENU_MAX_H = Math.min(480, window.innerHeight - 24);
            const want = pos.tileBottom + 6;
            const overflowY = want + MENU_MAX_H - window.innerHeight + 12;
            return (overflowY > 0 ? Math.max(12, want - overflowY) : want) + 'px';
        },
        left: (el, s)=>{
            s.root?._ctxMenuTick // reactive subscribe
            ;
            const pos = $a569955e4f91ff1b$var$computeMenuScreenPos(s.root, s.id);
            if (!pos) return '0px';
            const MENU_W = 232;
            const want = pos.tileRight - 220;
            return Math.max(12, Math.min(want, window.innerWidth - MENU_W)) + 'px';
        },
        minWidth: '220px',
        maxWidth: '232px',
        maxHeight: 'min(60vh, calc(100vh - 24px))',
        overflowX: 'hidden',
        overflowY: 'auto',
        padding: 'V 0',
        round: '10px',
        background: 'rgba(24,27,33,0.98)',
        border: '1px solid rgba(255,255,255,0.08)',
        boxShadow: '0 10px 28px rgba(0,0,0,0.5)',
        zIndex: '10000',
        flow: 'column',
        pointerEvents: 'auto',
        attr: {
            'data-project-menu': ''
        },
        onRender: (el)=>{
            if (el.__portaled || !el.node) return;
            el.__portaled = true;
            try {
                document.body.appendChild(el.node);
            } catch (_) {}
        },
        onRemove: (el)=>{
            if (el.node && el.node.parentNode === document.body) try {
                document.body.removeChild(el.node);
            } catch (_) {}
        },
        onPointerdown: (e)=>e.stopPropagation(),
        onMousedown: (e)=>e.stopPropagation(),
        onClick: (e)=>e.stopPropagation(),
        onKeydown: (e)=>{
            if (e.key === 'Escape') e.currentTarget.closest('[data-project-node]')?.querySelector('button')?.focus();
        },
        'aria-label': 'Project options',
        role: 'menu',
        // Child items default — buttons styled consistently.
        // Section headings and dividers override `tag` / role as needed.
        childExtends: 'Flex',
        childProps: {
            tag: 'button',
            type: 'button',
            role: 'menuitem',
            padding: 'Z X2',
            round: '0',
            background: 'transparent',
            border: '0',
            color: 'white',
            textAlign: 'left',
            fontSize: 'Z2',
            cursor: 'pointer',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 'Y',
            ':hover': {
                background: 'rgba(255,255,255,0.06)'
            },
            ':focus-visible': {
                outline: '2px solid rgba(100,160,255,0.7)',
                outlineOffset: '-2px'
            }
        },
        // ─── Section: Open ───────────────────────────────────────────────────
        SectionLabelOpen: {
            tag: 'div',
            role: 'presentation',
            text: 'Open',
            padding: 'V X2 W',
            fontSize: 'Z1',
            color: 'rgba(255,255,255,0.3)',
            fontWeight: '600',
            letterSpacing: '0.06em',
            textTransform: 'uppercase',
            cursor: 'default',
            background: 'transparent',
            border: '0',
            ':hover': {
                background: 'transparent'
            }
        },
        OpenCanvasItem: {
            'aria-label': "Open in App \u2014 equivalent to: smbls open",
            attr: {
                title: 'Equivalent to: smbls open'
            },
            onClick: (e, el, s)=>{
                e.stopPropagation();
                s.root?.update({
                    openMenuId: null
                });
                const urls = (0, $3HmWC.buildProjectUrls)(s.owner, s.key);
                if (urls) el.router(`/${urls.safeOwner}/${urls.safeKey}`, el.getRoot());
            },
            Label: {
                tag: 'span',
                text: 'Open in App'
            },
            Hint: {
                tag: 'span',
                text: "\u21B5",
                fontSize: 'Z1',
                color: 'rgba(255,255,255,0.3)',
                flexShrink: '0'
            }
        },
        OpenCloudCanvasItem: {
            'aria-label': 'Open Cloud Canvas',
            attr: {
                title: 'Opens the cloud editor for this project'
            },
            onClick: (e, el, s)=>{
                e.stopPropagation();
                s.root?.update({
                    openMenuId: null
                });
                const urls = (0, $3HmWC.buildProjectUrls)(s.owner, s.key, s.defaultEnv || 'development');
                if (urls) window.open(urls.canvas, '_blank', 'noopener,noreferrer');
            },
            Label: {
                tag: 'span',
                text: 'Open Cloud Canvas'
            },
            Hint: {
                tag: 'span',
                text: "\u2197",
                fontSize: 'Z1',
                color: 'rgba(255,255,255,0.3)',
                flexShrink: '0'
            }
        },
        OpenPreviewItem: {
            'aria-label': 'Open Preview',
            attr: {
                title: 'Opens the preview URL for this project'
            },
            onClick: (e, el, s)=>{
                e.stopPropagation();
                s.root?.update({
                    openMenuId: null
                });
                const urls = (0, $3HmWC.buildProjectUrls)(s.owner, s.key, s.defaultEnv || 'development');
                if (urls) window.open(urls.preview, '_blank', 'noopener,noreferrer');
            },
            Label: {
                tag: 'span',
                text: 'Open Preview'
            },
            Hint: {
                tag: 'span',
                text: "\u2197",
                fontSize: 'Z1',
                color: 'rgba(255,255,255,0.3)',
                flexShrink: '0'
            }
        },
        DirectDevItem: {
            'aria-label': 'Direct (dev)',
            attr: {
                title: 'Opens the dev subdomain URL'
            },
            onClick: (e, el, s)=>{
                e.stopPropagation();
                s.root?.update({
                    openMenuId: null
                });
                const urls = (0, $3HmWC.buildProjectUrls)(s.owner, s.key);
                if (urls) window.open(urls.directDev, '_blank', 'noopener,noreferrer');
            },
            Label: {
                tag: 'span',
                text: 'Direct (dev)'
            },
            Hint: {
                tag: 'span',
                text: "\u2197",
                fontSize: 'Z1',
                color: 'rgba(255,255,255,0.3)',
                flexShrink: '0'
            }
        },
        DirectProdItem: {
            'aria-label': 'Direct (prod)',
            attr: {
                title: 'Opens the production subdomain URL'
            },
            onClick: (e, el, s)=>{
                e.stopPropagation();
                s.root?.update({
                    openMenuId: null
                });
                const urls = (0, $3HmWC.buildProjectUrls)(s.owner, s.key);
                if (urls) window.open(urls.directProd, '_blank', 'noopener,noreferrer');
            },
            Label: {
                tag: 'span',
                text: 'Direct (prod)'
            },
            Hint: {
                tag: 'span',
                text: "\u2197",
                fontSize: 'Z1',
                color: 'rgba(255,255,255,0.3)',
                flexShrink: '0'
            }
        },
        CopyUrlItem: {
            'aria-label': 'Copy URL',
            attr: {
                title: "Copy the canonical project URL to clipboard \u2014 equivalent to: smbls project link"
            },
            onClick: (e, el, s)=>{
                e.stopPropagation();
                s.root?.update({
                    openMenuId: null
                });
                const urls = (0, $3HmWC.buildProjectUrls)(s.owner, s.key);
                if (urls && navigator.clipboard) navigator.clipboard.writeText(`https://symbols.app/${urls.safeOwner}/${urls.safeKey}`).catch(()=>{});
            },
            Label: {
                tag: 'span',
                text: 'Copy URL'
            },
            Hint: {
                tag: 'span',
                text: "\u2318\u21E7C",
                fontSize: 'Z1',
                color: 'rgba(255,255,255,0.3)',
                flexShrink: '0'
            }
        },
        // ─── Section: Manage ─────────────────────────────────────────────────
        DividerManage: {
            tag: 'div',
            role: 'separator',
            'aria-orientation': 'horizontal',
            height: '1px',
            background: 'rgba(255,255,255,0.07)',
            margin: 'V 0',
            cursor: 'default',
            border: '0',
            ':hover': {
                background: 'rgba(255,255,255,0.07)'
            }
        },
        SectionLabelManage: {
            tag: 'div',
            role: 'presentation',
            text: 'Manage',
            padding: 'V X2 W',
            fontSize: 'Z1',
            color: 'rgba(255,255,255,0.3)',
            fontWeight: '600',
            letterSpacing: '0.06em',
            textTransform: 'uppercase',
            cursor: 'default',
            background: 'transparent',
            border: '0',
            ':hover': {
                background: 'transparent'
            }
        },
        SettingsItem: {
            'aria-label': "Settings \u2014 equivalent to: smbls config",
            attr: {
                title: 'Equivalent to: smbls config'
            },
            onClick: (e, el, s)=>{
                e.stopPropagation();
                s.root?.update({
                    openMenuId: null,
                    settingsOpen: true,
                    settingsTab: s.root?.settingsTab || 'workspace'
                });
            },
            Label: {
                tag: 'span',
                text: "Settings\u2026"
            },
            Hint: {
                tag: 'span',
                text: "\u2318,",
                fontSize: 'Z1',
                color: 'rgba(255,255,255,0.3)',
                flexShrink: '0'
            }
        },
        EditMetadataItem: {
            'aria-label': "Edit metadata \u2014 equivalent to: smbls project update",
            attr: {
                title: 'Equivalent to: smbls project update'
            },
            onClick: (e, el, s)=>{
                e.stopPropagation();
                s.root?.update({
                    openMenuId: null,
                    projectEditMetadataModal: {
                        id: s.id,
                        name: s.name || '',
                        key: s.key || '',
                        owner: s.owner || ''
                    }
                });
            },
            Label: {
                tag: 'span',
                text: "Edit metadata\u2026"
            }
        },
        PublishItem: {
            'aria-label': "Publish \u2014 equivalent to: smbls push",
            attr: {
                title: 'Equivalent to: smbls push'
            },
            onClick: (e, el, s)=>{
                e.stopPropagation();
                s.root?.update({
                    openMenuId: null
                });
                const sdk = (0, $bfqVY.getSDK)();
                if (typeof sdk?.push === 'function') sdk.push(s._id || s.id).catch(()=>{});
            },
            Label: {
                tag: 'span',
                text: 'Publish'
            },
            Hint: {
                tag: 'span',
                text: "\u2318P",
                fontSize: 'Z1',
                color: 'rgba(255,255,255,0.3)',
                flexShrink: '0'
            }
        },
        DuplicateItem: {
            'aria-label': "Duplicate \u2014 equivalent to: smbls project duplicate",
            attr: {
                title: 'Equivalent to: smbls project duplicate'
            },
            onClick: (e, el, s)=>{
                e.stopPropagation();
                s.root?.update({
                    openMenuId: null,
                    projectDuplicateModal: {
                        sourceId: s._id || s.id,
                        sourceName: s.name || s.key || ''
                    }
                });
            },
            Label: {
                tag: 'span',
                text: "Duplicate\u2026"
            }
        },
        // ─── Section: Integrations ────────────────────────────────────────────
        DividerIntegrations: {
            tag: 'div',
            role: 'separator',
            'aria-orientation': 'horizontal',
            height: '1px',
            background: 'rgba(255,255,255,0.07)',
            margin: 'V 0',
            cursor: 'default',
            border: '0',
            ':hover': {
                background: 'rgba(255,255,255,0.07)'
            }
        },
        SectionLabelIntegrations: {
            tag: 'div',
            role: 'presentation',
            text: 'Integrations',
            padding: 'V X2 W',
            fontSize: 'Z1',
            color: 'rgba(255,255,255,0.3)',
            fontWeight: '600',
            letterSpacing: '0.06em',
            textTransform: 'uppercase',
            cursor: 'default',
            background: 'transparent',
            border: '0',
            ':hover': {
                background: 'transparent'
            }
        },
        AddLibraryItem: {
            'aria-label': "Import Library \u2014 link a shared component library",
            attr: {
                title: 'Link a shared library to this project'
            },
            onClick: (e, el, s)=>{
                e.stopPropagation();
                s.root?.update({
                    openMenuId: null,
                    libraryPickerFor: s.id,
                    libraryPickerQuery: ''
                });
            },
            Label: {
                tag: 'span',
                text: "Import Library\u2026"
            }
        },
        // ─── Section: Danger ─────────────────────────────────────────────────
        DividerDanger: {
            tag: 'div',
            role: 'separator',
            'aria-orientation': 'horizontal',
            height: '1px',
            background: 'rgba(255,255,255,0.07)',
            margin: 'V 0',
            cursor: 'default',
            border: '0',
            ':hover': {
                background: 'rgba(255,255,255,0.07)'
            }
        },
        SectionLabelDanger: {
            tag: 'div',
            role: 'presentation',
            text: 'Danger',
            padding: 'V X2 W',
            fontSize: 'Z1',
            color: 'rgba(255,255,255,0.3)',
            fontWeight: '600',
            letterSpacing: '0.06em',
            textTransform: 'uppercase',
            cursor: 'default',
            background: 'transparent',
            border: '0',
            ':hover': {
                background: 'transparent'
            }
        },
        DeleteItem: {
            'aria-label': "Delete project \u2014 equivalent to: smbls project delete",
            attr: {
                title: 'Equivalent to: smbls project delete'
            },
            color: 'rgb(255,90,90)',
            ':hover': {
                background: 'rgba(255,60,60,0.12)'
            },
            onClick: (e, el, s)=>{
                e.stopPropagation();
                s.root?.update({
                    openMenuId: null,
                    projectDeleteConfirm: {
                        id: s._id || s.id,
                        key: s.key || '',
                        name: s.name || s.key || ''
                    }
                });
            },
            Label: {
                tag: 'span',
                text: 'Delete project'
            }
        }
    }
};
const $a569955e4f91ff1b$export$c8e5cd86b5e57b0a = {
    position: 'absolute',
    round: '10px',
    flow: 'row',
    align: 'center start',
    gap: 'Z',
    padding: 'Z',
    userSelect: 'none',
    cursor: 'grab',
    width: $a569955e4f91ff1b$var$INTEGRATION_NODE_W + 'px',
    height: $a569955e4f91ff1b$var$INTEGRATION_NODE_H + 'px',
    background: 'rgba(20,22,27,0.85)',
    border: (el, s)=>`1px solid ${$a569955e4f91ff1b$var$integrationColor(s.category)}55`,
    boxShadow: '0 6px 18px rgba(0,0,0,0.35)',
    color: 'white',
    transition: 'B transform defaultBezier, B box-shadow defaultBezier',
    left: (el, s)=>(s.root?.positions?.[s.id]?.x ?? 0) + 'px',
    top: (el, s)=>(s.root?.positions?.[s.id]?.y ?? 0) + 'px',
    zIndex: (el, s)=>s.root?.draggingId === s.id ? 1000 : 2,
    ':hover': {
        transform: 'translateY(-1px)'
    },
    ':hover > [data-link-handle]': {
        opacity: '1',
        transform: 'scale(1)'
    },
    attr: {
        'data-node-id': (el, s)=>s.id
    },
    onRender: (el, s)=>{
        // onInit fires before el.node is created (v3.14 lifecycle order: Init →
        // cacheNode → Render). Use onRender so el.node is guaranteed to exist.
        if (s?.id && el.node) $a569955e4f91ff1b$var$DRAG_DOM_NODES.set(s.id, el.node);
    },
    onRemove: (el, s)=>{
        if (s?.id) $a569955e4f91ff1b$var$DRAG_DOM_NODES.delete(s.id);
    },
    onMousedown: (e, el, s)=>$a569955e4f91ff1b$var$startDrag(e, el, s.root, s.id),
    onClick: (e, el, s)=>{
        if (el.__didDrag) return;
        window.open($a569955e4f91ff1b$var$integrationAdminUrl(s.kind), '_blank', 'noopener,noreferrer');
    },
    Glyph: {
        width: '34px',
        height: '34px',
        round: '8px',
        flexShrink: '0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: (el, s)=>s.icon ? 'white' : $a569955e4f91ff1b$var$integrationColor(s.category),
        pointerEvents: 'none',
        overflow: 'hidden',
        Img: {
            hide: (el, s)=>!s.icon || el.parent._imgFailed,
            tag: 'img',
            src: (el, s)=>s.icon ? `https://cdn.simpleicons.org/${s.icon}` : '',
            alt: (el, s)=>s.kindLabel || s.kind,
            width: '60%',
            height: '60%',
            objectFit: 'contain',
            onRender: (el)=>{
                if (!el.node) return;
                el.node.onerror = ()=>{
                    if (!el.parent) return;
                    el.parent._imgFailed = true;
                    el.node.style.display = 'none';
                    const letter = el.parent.Letter;
                    if (letter?.node) letter.node.style.display = '';
                };
            }
        },
        Letter: {
            hide: (el, s)=>!!s.icon && !el.parent._imgFailed,
            tag: 'span',
            fontWeight: '700',
            fontSize: 'A',
            color: '#14161b',
            text: (el, s)=>$a569955e4f91ff1b$var$integrationGlyph(s.kind)
        }
    },
    Info: {
        flow: 'column',
        gap: '2px',
        flexGrow: '1',
        overflow: 'hidden',
        pointerEvents: 'none',
        Label: {
            tag: 'div',
            text: (el, s)=>s.label || s.kindLabel || s.kind,
            fontSize: 'Z2',
            fontWeight: '600',
            color: 'white',
            style: {
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            }
        },
        Kind: {
            tag: 'div',
            text: (el, s)=>s.kindLabel || s.kind,
            fontSize: 'Z',
            color: 'rgba(255,255,255,0.55)',
            textTransform: 'uppercase',
            letterSpacing: '0.06em'
        }
    },
    LinkHandle: {
        attr: {
            'data-link-handle': ''
        },
        position: 'absolute',
        right: '-10px',
        top: '50%',
        marginTop: '-10px',
        width: '20px',
        height: '20px',
        round: '50%',
        background: (el, s)=>$a569955e4f91ff1b$var$integrationColor(s.category),
        border: '2px solid #14161b',
        cursor: 'crosshair',
        pointerEvents: 'auto',
        boxShadow: '0 2px 6px rgba(0,0,0,0.4)',
        opacity: '0',
        transform: 'scale(0.6)',
        transition: 'A opacity defaultBezier, A transform defaultBezier',
        ':hover': {
            transform: 'scale(1.3)'
        },
        onMousedown: (e, el, s)=>$a569955e4f91ff1b$var$startLink(e, el, s.root, s.id, {
                kind: 'integration'
            })
    }
};
// ─── Phase 5 canvas tile variants ────────────────────────────────────────────
// Each domain renders a compact (INSTALLABLE_W × INSTALLABLE_H) positioned
// tile on the board. All share the same drag + position mechanics via the
// common DRAG_DOM_NODES map + startDrag. Click → openInstallableModal (Phase 4
// shared function registered in workspace/packages/shared/functions/installable.js).
// Shared base style for all installable tiles. Domain variants extend this by
// key name or override specific visual properties.
const $a569955e4f91ff1b$var$_installableNodeBase = {
    position: 'absolute',
    round: '10px',
    flow: 'column',
    gap: 'V',
    padding: 'Z',
    userSelect: 'none',
    cursor: 'grab',
    width: $a569955e4f91ff1b$var$INSTALLABLE_W + 'px',
    height: $a569955e4f91ff1b$var$INSTALLABLE_H + 'px',
    boxShadow: '0 6px 18px rgba(0,0,0,0.35)',
    color: 'white',
    transition: 'B transform defaultBezier, B box-shadow defaultBezier',
    left: (el, s)=>(s.root?.positions?.[s.id]?.x ?? 0) + 'px',
    top: (el, s)=>(s.root?.positions?.[s.id]?.y ?? 0) + 'px',
    zIndex: (el, s)=>s.root?.draggingId === s.id ? 1000 : 2,
    ':hover': {
        transform: 'translateY(-1px)'
    },
    attr: {
        'data-node-id': (el, s)=>s.id
    },
    onRender: (el, s)=>{
        if (s?.id && el.node) $a569955e4f91ff1b$var$DRAG_DOM_NODES.set(s.id, el.node);
    },
    onRemove: (el, s)=>{
        if (s?.id) $a569955e4f91ff1b$var$DRAG_DOM_NODES.delete(s.id);
    },
    onMousedown: (e, el, s)=>$a569955e4f91ff1b$var$startDrag(e, el, s.root, s.id),
    onClick: (e, el, s)=>{
        if (el.__didDrag) return;
        el.call('openInstallableModal', {
            domain: s.domain,
            kind: s.kind,
            installed: true,
            defaultScope: s.scopeType ? {
                type: s.scopeType,
                id: s.scopeId
            } : null
        });
    }
};
const $a569955e4f91ff1b$export$dc7eeb553c6c04d8 = {
    ...$a569955e4f91ff1b$var$_installableNodeBase,
    background: 'rgba(20,22,27,0.92)',
    border: '1px solid rgba(90,200,130,0.3)',
    // Ghost "stacked cards" behind to signal library/collection type.
    style: {
        boxShadow: [
            '0 0 0 4px rgba(20,22,27,0.72)',
            '0 0 0 5px rgba(90,200,130,0.18)',
            '0 0 0 9px rgba(20,22,27,0.52)',
            '0 0 0 10px rgba(90,200,130,0.1)',
            '0 6px 18px rgba(0,0,0,0.4)'
        ].join(', ')
    },
    Header: {
        flow: 'x',
        gap: 'V',
        align: 'center',
        pointerEvents: 'none',
        Glyph: {
            width: '28px',
            height: '28px',
            round: '6px',
            flexShrink: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'rgba(90,200,130,0.18)',
            fontSize: 'Z2',
            text: "\u25FB"
        },
        Name: {
            tag: 'div',
            text: (el, s)=>s.name || 'Library',
            fontSize: 'Z2',
            fontWeight: '600',
            color: 'white',
            style: {
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            }
        }
    },
    DomainBadge: {
        tag: 'span',
        text: 'Library',
        fontSize: 'Y1',
        fontWeight: '700',
        color: 'rgba(90,200,130,0.9)',
        textTransform: 'uppercase',
        letterSpacing: '0.06em',
        pointerEvents: 'none'
    }
};
const $a569955e4f91ff1b$export$a609dcceef94efac = {
    ...$a569955e4f91ff1b$var$_installableNodeBase,
    background: 'rgba(20,22,27,0.92)',
    border: '1px solid rgba(84,174,255,0.3)',
    Header: {
        flow: 'x',
        gap: 'V',
        align: 'center',
        pointerEvents: 'none',
        Glyph: {
            width: '28px',
            height: '28px',
            round: '6px',
            flexShrink: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'rgba(84,174,255,0.15)',
            fontSize: 'Z2',
            text: "\u2B21"
        },
        Name: {
            tag: 'div',
            text: (el, s)=>s.name || 'MCP',
            fontSize: 'Z2',
            fontWeight: '600',
            color: 'white',
            style: {
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            }
        }
    },
    StatusRow: {
        flow: 'x',
        gap: 'V',
        align: 'center',
        pointerEvents: 'none',
        Dot: {
            width: '8px',
            height: '8px',
            round: '50%',
            flexShrink: '0',
            background: (el, s)=>s.status === 'enabled' ? 'rgba(84,174,255,0.9)' : 'rgba(255,255,255,0.25)'
        },
        StatusLabel: {
            tag: 'span',
            fontSize: 'Y1',
            fontWeight: '700',
            textTransform: 'uppercase',
            letterSpacing: '0.06em',
            color: (el, s)=>s.status === 'enabled' ? 'rgba(84,174,255,0.9)' : 'rgba(255,255,255,0.3)',
            text: (el, s)=>s.status === 'enabled' ? 'Live' : 'Disabled'
        }
    }
};
const $a569955e4f91ff1b$export$d9af1ea83b1dc8b6 = {
    ...$a569955e4f91ff1b$var$_installableNodeBase,
    background: 'rgba(20,22,27,0.92)',
    border: '1px solid rgba(184,140,255,0.3)',
    Header: {
        flow: 'x',
        gap: 'V',
        align: 'center',
        pointerEvents: 'none',
        Glyph: {
            width: '28px',
            height: '28px',
            round: '6px',
            flexShrink: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'rgba(184,140,255,0.15)',
            fontSize: 'Z2',
            text: "\u2B26"
        },
        Name: {
            tag: 'div',
            text: (el, s)=>s.name || 'Plugin',
            fontSize: 'Z2',
            fontWeight: '600',
            color: 'white',
            style: {
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            }
        }
    },
    DomainBadge: {
        tag: 'span',
        text: 'Plugin',
        fontSize: 'Y1',
        fontWeight: '700',
        color: 'rgba(184,140,255,0.9)',
        textTransform: 'uppercase',
        letterSpacing: '0.06em',
        pointerEvents: 'none'
    }
};
const $a569955e4f91ff1b$export$361e4d426758e4fe = {
    ...$a569955e4f91ff1b$var$_installableNodeBase,
    // Delegate all rendering to the domain-specific sub-element. The containing
    // element is just the drag target; it carries no content itself.
    background: 'transparent',
    border: 'none',
    boxShadow: 'none',
    padding: '0',
    // Domain-specific frame rendered inside — auto-extends by matching key.
    // DOMQL v3.14 resolves 'LibraryNode', 'MCPNode', 'PluginNode', 'IntegrationNode'
    // as registered exports. We render only one at a time via `if`.
    LibraryFrame: {
        extends: 'LibraryNode',
        if: (el, s)=>s.domain === 'library',
        // Inherit all state from parent.
        position: 'relative',
        left: '0',
        top: '0',
        zIndex: 'auto',
        width: '100%',
        height: '100%',
        // Disable nested drag — parent handles it.
        onMousedown: null,
        onClick: null
    },
    MCPFrame: {
        extends: 'MCPNode',
        if: (el, s)=>s.domain === 'mcp',
        position: 'relative',
        left: '0',
        top: '0',
        zIndex: 'auto',
        width: '100%',
        height: '100%',
        onMousedown: null,
        onClick: null
    },
    PluginFrame: {
        extends: 'PluginNode',
        if: (el, s)=>s.domain === 'plugin',
        position: 'relative',
        left: '0',
        top: '0',
        zIndex: 'auto',
        width: '100%',
        height: '100%',
        onMousedown: null,
        onClick: null
    },
    IntegrationFrame: {
        extends: 'IntegrationNode',
        if: (el, s)=>s.domain === 'integration',
        position: 'relative',
        left: '0',
        top: '0',
        zIndex: 'auto',
        width: '100%',
        height: '100%',
        onMousedown: null,
        onClick: null
    }
};
const $a569955e4f91ff1b$export$68514f62f1898284 = {
    if: (el, s)=>{
        const root = s.root || s;
        if (root.loading || root.error) return false;
        if (!root._labLoadedAt) return false;
        const hasNodes = (root.nodes || []).length > 0;
        const hasInstallables = (root._installables || []).length > 0;
        return !hasNodes && !hasInstallables;
    },
    position: 'absolute',
    inset: '0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none',
    zIndex: 4,
    TutCard: {
        pointerEvents: 'auto',
        flow: 'column',
        align: 'center center',
        gap: 'A',
        padding: 'B C',
        round: 'A',
        background: 'rgba(20,22,27,0.72)',
        border: '1px solid rgba(255,255,255,0.08)',
        style: {
            backdropFilter: 'blur(12px)',
            maxWidth: '380px',
            textAlign: 'center'
        },
        TutIcon: {
            tag: 'div',
            text: "\u25C8",
            fontSize: 'D',
            color: 'rgba(255,255,255,0.18)',
            lineHeight: '1'
        },
        TutTitle: {
            tag: 'h3',
            text: 'Welcome to your lab',
            fontSize: 'A',
            fontWeight: '700',
            color: 'white',
            margin: '0'
        },
        TutBody: {
            tag: 'p',
            text: "Start by creating a new app \u2014 or pin an existing project from your dashboard. You can also install integrations, MCP connectors, libraries, and plugins as draggable tiles.",
            fontSize: 'Z2',
            color: 'rgba(255,255,255,0.5)',
            margin: '0',
            lineHeight: '1.55'
        },
        // Primary CTA: create new app — the most common first action.
        TutCTA: {
            tag: 'button',
            type: 'button',
            text: '+ Create your new app',
            padding: 'Y B',
            round: '999px',
            border: '0',
            background: 'rgba(80,120,255,0.85)',
            color: 'white',
            cursor: 'pointer',
            fontSize: 'Z2',
            fontWeight: '600',
            ':hover': {
                background: 'rgba(80,120,255,1)'
            },
            onClick: (e, el, s)=>{
                e.stopPropagation();
                s.root?.update({
                    newProjectPicker: {
                        open: true,
                        tab: 'featured',
                        templateId: 'blank',
                        templateProject: null,
                        projectType: 'app',
                        name: '',
                        creating: false,
                        error: null,
                        _libList: null,
                        _libQuery: ''
                    }
                });
            }
        },
        // Secondary action — small link below the primary CTA. Same picker
        // the rail toggle opens, but reachable from the welcome card too.
        TutSecondary: {
            tag: 'button',
            type: 'button',
            text: 'or install an integration',
            padding: 'Z 0',
            border: '0',
            background: 'transparent',
            color: 'rgba(255,255,255,0.55)',
            cursor: 'pointer',
            fontSize: 'Z',
            textDecoration: 'underline',
            textUnderlineOffset: '3px',
            ':hover': {
                color: 'rgba(255,255,255,0.85)'
            },
            onClick: (e, el, s)=>{
                e.stopPropagation();
                s.root?.update({
                    integrationPicker: {
                        open: true,
                        step: 'list',
                        form: {
                            __scope: 'workspace',
                            __scopeId: null,
                            __slug: 'default'
                        }
                    }
                });
            }
        }
    }
};
const $a569955e4f91ff1b$export$d034e03442ed1979 = {
    flow: 'row',
    align: 'center start',
    gap: 'V',
    padding: 'V X',
    round: '999px',
    background: 'rgba(255,255,255,0.04)',
    border: (el, s)=>`1px solid ${$a569955e4f91ff1b$var$integrationColor(s.category)}55`,
    color: 'white',
    fontSize: 'Z',
    cursor: 'default',
    pointerEvents: 'auto',
    Dot: {
        width: '10px',
        height: '10px',
        round: '50%',
        flexShrink: '0',
        background: (el, s)=>$a569955e4f91ff1b$var$integrationColor(s.category)
    },
    Label: {
        tag: 'span',
        text: (el, s)=>s.label || s.kindLabel || s.kind,
        fontSize: 'Z',
        color: 'rgba(255,255,255,0.9)'
    },
    Kind: {
        tag: 'span',
        text: (el, s)=>s.kindLabel || s.kind,
        fontSize: 'Z',
        color: 'rgba(255,255,255,0.45)'
    }
};
const $a569955e4f91ff1b$export$891fc73fd7e64ebc = {
    flow: 'row',
    align: 'center',
    gap: 'V',
    padding: 'V X',
    round: '999px',
    background: 'rgba(255,255,255,0.05)',
    border: (el, s)=>`1px solid ${$a569955e4f91ff1b$var$integrationColor(s.category)}44`,
    color: 'white',
    fontSize: 'Z',
    cursor: 'pointer',
    userSelect: 'none',
    transition: 'A background defaultBezier',
    ':hover': {
        background: 'rgba(255,255,255,0.09)'
    },
    onClick: (e, el, s)=>{
        window.open($a569955e4f91ff1b$var$integrationAdminUrl(s.kind), '_blank', 'noopener,noreferrer');
    },
    onContextmenu: (e, el, s)=>{
        // Right-click "Re-scope to project" — opens the integration picker pre-
        // loaded with this integration's kind so the user can assign it to a
        // specific project. Only relevant for workspace-scoped rows; org-scoped
        // re-scoping would require org admin rights handled in governance.
        if (s.scopeType !== 'workspace') return;
        e.preventDefault();
        const p = s.root?.integrationPicker || {};
        s.root?.update({
            integrationPicker: {
                ...p,
                open: true,
                step: 'form',
                selectedKind: {
                    kind: s.kind,
                    label: s.label || s.kindLabel || s.kind,
                    category: s.category,
                    default_scope: 'project'
                },
                form: {
                    __scope: 'project',
                    __scopeId: null,
                    __slug: s.slug || 'default'
                }
            }
        });
    },
    Glyph: {
        width: '22px',
        height: '22px',
        round: '6px',
        flexShrink: '0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: (el, s)=>s.icon ? 'white' : $a569955e4f91ff1b$var$integrationColor(s.category),
        overflow: 'hidden',
        Img: {
            hide: (el, s)=>!s.icon || el.parent._imgFailed,
            tag: 'img',
            src: (el, s)=>s.icon ? `https://cdn.simpleicons.org/${s.icon}` : '',
            alt: (el, s)=>s.kindLabel || s.kind,
            width: '65%',
            height: '65%',
            objectFit: 'contain',
            onRender: (el)=>{
                if (!el.node) return;
                el.node.onerror = ()=>{
                    if (!el.parent) return;
                    el.parent._imgFailed = true;
                    el.node.style.display = 'none';
                    const letter = el.parent.Letter;
                    if (letter?.node) letter.node.style.display = '';
                };
            }
        },
        Letter: {
            hide: (el, s)=>!!s.icon && !el.parent._imgFailed,
            tag: 'span',
            fontWeight: '700',
            fontSize: 'Z1',
            color: '#14161b',
            text: (el, s)=>$a569955e4f91ff1b$var$integrationGlyph(s.kind)
        }
    },
    Name: {
        tag: 'span',
        text: (el, s)=>s.label || s.kindLabel || s.kind,
        fontSize: 'Z',
        fontWeight: '500',
        color: 'rgba(255,255,255,0.9)',
        style: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: '120px'
        }
    },
    ScopePill: {
        tag: 'span',
        text: (el, s)=>s.scopeType === 'org' ? 'ORG' : 'WORKSPACE',
        fontSize: 'Z1',
        fontWeight: '700',
        letterSpacing: '0.06em',
        color: (el, s)=>s.scopeType === 'org' ? '#b88cff' : '#f0b85a',
        background: (el, s)=>s.scopeType === 'org' ? 'rgba(184,140,255,0.12)' : 'rgba(240,184,90,0.12)',
        padding: '1px 5px',
        round: '4px'
    }
};
const $a569955e4f91ff1b$export$907a96a28d3dcaa1 = {
    position: 'absolute',
    top: '0',
    left: '0',
    right: '0',
    zIndex: 20,
    flow: 'column',
    pointerEvents: 'none',
    // Reserve vertical space so board content never jumps when rail appears.
    // A single-line rail is ~44px; empty state is 0 (collapsed).
    Bar: {
        pointerEvents: 'auto',
        flow: 'row',
        align: 'center',
        gap: 'V',
        padding: '0 X',
        // Reserve height regardless of content — prevents board layout shift when
        // the first workspace integration is installed.
        minHeight: '44px',
        background: 'rgba(20,22,27,0.82)',
        borderBottom: '1px solid rgba(255,255,255,0.06)',
        style: {
            backdropFilter: 'blur(8px)'
        },
        // Rail is visible only when there are workspace-scoped integrations OR
        // we always show a slim affordance.
        display: (el, s)=>{
            const items = (s?.root?.integrations || []).filter((i)=>i.scope === 'workspace');
            return items.length ? 'flex' : 'flex';
        },
        HeaderLabel: {
            tag: 'span',
            text: 'Workspace',
            fontSize: 'Z1',
            fontWeight: '700',
            letterSpacing: '0.08em',
            color: '#f0b85a',
            textTransform: 'uppercase',
            flexShrink: '0',
            marginRight: 'V'
        },
        // Chips for each workspace-scoped integration
        Chips: {
            flow: 'row',
            gap: 'V',
            flexGrow: '1',
            flexWrap: 'nowrap',
            overflow: 'hidden',
            childrenAs: 'state',
            children: (el, s)=>(s?.root?.integrations || []).filter((i)=>i.scope === 'workspace').map((i)=>({
                        ...i,
                        key: i.id
                    })),
            childExtends: 'ScopeRailChip'
        },
        // Empty state — shown when there are no workspace integrations yet.
        Empty: {
            hide: (el, s)=>(s?.root?.integrations || []).some((i)=>i.scope === 'workspace'),
            tag: 'button',
            type: 'button',
            text: '+ Add workspace integration',
            fontSize: 'Z',
            color: 'rgba(255,255,255,0.35)',
            background: 'transparent',
            border: '1px dashed rgba(255,255,255,0.15)',
            round: '999px',
            padding: '3px 10px',
            cursor: 'pointer',
            ':hover': {
                color: 'rgba(255,255,255,0.65)',
                borderColor: 'rgba(255,255,255,0.3)'
            },
            onClick: (e, el, s)=>{
                e.stopPropagation();
                s.root?.update({
                    integrationPicker: {
                        open: true,
                        step: 'list',
                        form: {
                            __scope: 'workspace',
                            __scopeId: null,
                            __slug: 'default'
                        }
                    }
                });
            }
        }
    }
};
const $a569955e4f91ff1b$export$f79f23d351ad8485 = {
    position: 'absolute',
    // Sits above the workspace rail. Workspace rail is 44px; org rail slides in
    // above it. Uses CSS transform to animate open/close.
    top: '0',
    left: '0',
    right: '0',
    zIndex: 21,
    flow: 'column',
    pointerEvents: 'none',
    // Toggle strip — always visible; click expands/collapses the chip row.
    Toggle: {
        pointerEvents: 'auto',
        flow: 'row',
        align: 'center',
        gap: 'V',
        padding: '0 X',
        height: '28px',
        background: 'rgba(14,16,20,0.9)',
        borderBottom: '1px solid rgba(255,255,255,0.04)',
        style: {
            backdropFilter: 'blur(6px)'
        },
        // Only render the toggle when there are org integrations (or when the user
        // has previously opened the rail).
        display: (el, s)=>{
            const hasOrg = (s?.root?.integrations || []).some((i)=>i.scope === 'org');
            return hasOrg || s?.root?.orgRailOpen ? 'flex' : 'none';
        },
        cursor: 'pointer',
        ':hover': {
            background: 'rgba(20,22,27,0.96)'
        },
        onClick: (e, el, s)=>{
            e.stopPropagation();
            s.root?.update({
                orgRailOpen: !s.root?.orgRailOpen
            });
        },
        Caret: {
            tag: 'span',
            text: (el, s)=>s.root?.orgRailOpen ? "\u25BE" : "\u25B8",
            color: '#b88cff',
            fontSize: 'Z1',
            flexShrink: '0'
        },
        Label: {
            tag: 'span',
            text: 'Org integrations',
            fontSize: 'Z1',
            fontWeight: '700',
            letterSpacing: '0.07em',
            textTransform: 'uppercase',
            color: '#b88cff',
            flexGrow: '1'
        },
        Count: {
            tag: 'span',
            text: (el, s)=>{
                const n = (s?.root?.integrations || []).filter((i)=>i.scope === 'org').length;
                return n ? `${n}` : '';
            },
            fontSize: 'Z1',
            color: 'rgba(184,140,255,0.65)',
            background: 'rgba(184,140,255,0.12)',
            padding: '1px 5px',
            round: '4px'
        }
    },
    // Chip row — visible only when orgRailOpen.
    Bar: {
        pointerEvents: 'auto',
        flow: 'row',
        align: 'center',
        gap: 'V',
        padding: '0 X',
        minHeight: '40px',
        background: 'rgba(16,18,23,0.88)',
        borderBottom: '1px solid rgba(184,140,255,0.12)',
        style: {
            backdropFilter: 'blur(8px)'
        },
        display: (el, s)=>s?.root?.orgRailOpen ? 'flex' : 'none',
        Chips: {
            flow: 'row',
            gap: 'V',
            flexGrow: '1',
            flexWrap: 'nowrap',
            overflow: 'hidden',
            childrenAs: 'state',
            children: (el, s)=>(s?.root?.integrations || []).filter((i)=>i.scope === 'org').map((i)=>({
                        ...i,
                        key: i.id
                    })),
            childExtends: 'ScopeRailChip'
        },
        Empty: {
            hide: (el, s)=>(s?.root?.integrations || []).some((i)=>i.scope === 'org'),
            tag: 'span',
            text: 'No org-wide integrations installed.',
            fontSize: 'Z',
            color: 'rgba(255,255,255,0.3)',
            fontStyle: 'italic'
        }
    }
};
const $a569955e4f91ff1b$export$70442b23b8e724c7 = {
    flow: 'x',
    gap: 'Z',
    align: 'center',
    padding: 'V Z1',
    round: 'Y',
    theme: 'canvas-card-glass',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'cerulean',
    cursor: 'pointer',
    pointerEvents: 'auto',
    overflow: 'hidden',
    title: (el, s)=>`MCP connector: ${s.name || s.url || ''}`,
    'aria-label': (el, s)=>`MCP connector: ${s.name || s.url || ''}`,
    ':hover': {
        background: 'cerulean.1'
    },
    // Accent dot (cerulean for enabled, muted for disabled).
    Dot: {
        width: 'Y1',
        height: 'Y1',
        round: '50%',
        flexShrink: '0',
        background: (el, s)=>s.status === 'enabled' ? 'cerulean' : 'overlayStrong'
    },
    Name: {
        tag: 'span',
        text: (el, s)=>s.name || s.url || 'MCP',
        fontSize: 'Z',
        fontWeight: '500',
        color: 'white.9',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        maxWidth: 'E'
    },
    IntegrationScopeBadge: {
        scope_type: (el, s)=>s.scope_type,
        scope_id: (el, s)=>s.scope_id
    },
    // Status pill — text label so meaning is not conveyed by color alone.
    StatusPill: {
        tag: 'span',
        padding: 'V Z',
        round: 'Y',
        fontSize: 'Y1',
        fontWeight: '700',
        background: (el, s)=>s.status === 'enabled' ? 'cerulean.1' : 'overlayStrong',
        color: (el, s)=>s.status === 'enabled' ? 'cerulean' : 'caption',
        text: (el, s)=>s.status === 'enabled' ? 'Live' : 'Disabled'
    }
};
const $a569955e4f91ff1b$export$3652e949b492ebe7 = {
    position: 'absolute',
    style: {
        top: 'calc(var(--spacing-B) + var(--spacing-C) + var(--spacing-A))'
    },
    left: '0',
    right: '0',
    zIndex: 19,
    flow: 'column',
    pointerEvents: 'none',
    Bar: {
        pointerEvents: 'auto',
        flow: 'x',
        align: 'center',
        gap: 'V',
        padding: '0 X',
        minHeight: 'B1',
        background: 'gray2.8',
        borderBottom: '1px solid cerulean.08',
        style: {
            backdropFilter: 'blur(8px)'
        },
        hide: (el, s)=>!(s?.root?._mcpConnectors || []).length,
        HeaderLabel: {
            tag: 'span',
            text: 'MCP',
            fontSize: 'Z1',
            fontWeight: '700',
            letterSpacing: '0.08em',
            color: 'cerulean',
            textTransform: 'uppercase',
            flexShrink: '0',
            marginRight: 'V'
        },
        Chips: {
            flow: 'x',
            gap: 'V',
            flexGrow: '1',
            flexWrap: 'nowrap',
            overflow: 'hidden',
            childrenAs: 'state',
            children: (el, s)=>(s?.root?._mcpConnectors || []).map((c)=>({
                        ...c,
                        key: c.id
                    })),
            childExtends: 'MCPConnectorChip'
        },
        // Empty state — always hidden because Bar is hidden when empty.
        // Kept for future use (e.g. "Add MCP connector" affordance in empty rail).
        AddBtn: {
            hide: (el, s)=>(s?.root?._mcpConnectors || []).length > 0,
            tag: 'button',
            type: 'button',
            text: '+ Add MCP connector',
            fontSize: 'Z',
            color: 'cerulean.6',
            background: 'transparent',
            border: '1px dashed cerulean.3',
            round: 'D',
            padding: 'V2 Z',
            cursor: 'pointer',
            ':hover': {
                color: 'cerulean',
                borderColor: 'cerulean'
            },
            onClick: (e, el, s)=>{
                e.stopPropagation();
                s.root?.update({
                    _mcpConnectorPickerOpen: true,
                    _mcpConnectorDraft: {
                        transport: 'sse',
                        authKind: 'none',
                        scopeType: 'workspace',
                        scopeId: null
                    }
                });
            }
        }
    }
};
const $a569955e4f91ff1b$export$f016434f94824d08 = {
    flow: 'row',
    align: 'center start',
    gap: 'V',
    padding: 'V X',
    round: '8px',
    cursor: 'pointer',
    color: 'white',
    border: '1px solid transparent',
    ':hover': {
        background: 'rgba(255,255,255,0.05)',
        border: '1px solid rgba(255,255,255,0.08)'
    },
    Glyph: {
        width: '30px',
        height: '30px',
        round: '6px',
        flexShrink: '0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: (el, s)=>s.icon ? 'white' : $a569955e4f91ff1b$var$integrationColor(s.category),
        overflow: 'hidden',
        Img: {
            hide: (el, s)=>!s.icon || el.parent._imgFailed,
            tag: 'img',
            src: (el, s)=>s.icon ? `https://cdn.simpleicons.org/${s.icon}` : '',
            alt: (el, s)=>s.label || s.kind,
            width: '60%',
            height: '60%',
            objectFit: 'contain',
            onRender: (el)=>{
                if (!el.node) return;
                el.node.onerror = ()=>{
                    if (!el.parent) return;
                    el.parent._imgFailed = true;
                    el.node.style.display = 'none';
                    const letter = el.parent.Letter;
                    if (letter?.node) letter.node.style.display = '';
                };
            }
        },
        Letter: {
            hide: (el, s)=>!!s.icon && !el.parent._imgFailed,
            tag: 'span',
            fontWeight: '700',
            fontSize: 'Z2',
            color: '#14161b',
            text: (el, s)=>$a569955e4f91ff1b$var$integrationGlyph(s.kind)
        }
    },
    Info: {
        flow: 'column',
        flexGrow: '1',
        gap: '2px',
        Name: {
            tag: 'div',
            text: (el, s)=>s.label || s.kind,
            fontSize: 'Z2',
            fontWeight: '500'
        },
        Sub: {
            tag: 'div',
            text: (el, s)=>`${s.category} \xb7 ${s.auth_model || 'no auth'}`,
            fontSize: 'Z',
            color: 'rgba(255,255,255,0.5)',
            fontFamily: 'monospace'
        }
    },
    Chevron: {
        tag: 'span',
        text: "\u2192",
        color: 'rgba(255,255,255,0.35)'
    },
    onClick: (e, el, s)=>{
        e.stopPropagation();
        const p = s.root?.integrationPicker || {};
        s.root?.update({
            integrationPicker: {
                ...p,
                step: 'form',
                selectedKind: {
                    kind: s.kind,
                    label: s.label,
                    category: s.category,
                    auth_model: s.auth_model,
                    default_scope: s.default_scope,
                    config_schema: s.config_schema,
                    secret_label: s.secret_label,
                    secret_hint: s.secret_hint
                },
                form: {
                    __scope: s.default_scope || 'org',
                    __scopeId: null,
                    __slug: 'default'
                }
            }
        });
    }
};
const $a569955e4f91ff1b$export$2f99acc64e54270c = {
    flow: 'column',
    gap: 'W',
    Label: {
        tag: 'label',
        text: (el, s)=>{
            const f = typeof s.field === 'function' ? s.field(null, s) : s.field || el.field;
            return (f?.label || f?.key || '') + (f?.required ? ' *' : '');
        },
        fontSize: 'Z',
        color: 'rgba(255,255,255,0.7)',
        fontWeight: '600',
        textTransform: 'uppercase',
        letterSpacing: '0.06em'
    },
    Input: {
        tag: 'input',
        type: (el, s)=>{
            const f = typeof s.field === 'function' ? s.field(null, s) : s.field || el.field;
            return f?.type || 'text';
        },
        placeholder: (el, s)=>{
            const f = typeof s.field === 'function' ? s.field(null, s) : s.field || el.field;
            return f?.placeholder || '';
        },
        value: (el, s)=>{
            const f = typeof s.field === 'function' ? s.field(null, s) : s.field || el.field;
            return s.root?.integrationPicker?.form?.[f?.key] || '';
        },
        padding: 'V X',
        round: '6px',
        border: '1px solid rgba(255,255,255,0.12)',
        background: 'rgba(0,0,0,0.35)',
        color: 'white',
        fontSize: 'Z2',
        onInput: (e, el, s)=>{
            const f = typeof s.field === 'function' ? s.field(null, s) : s.field || el.field;
            if (!f?.key) return;
            const p = s.root?.integrationPicker || {};
            s.root?.update({
                integrationPicker: {
                    ...p,
                    form: {
                        ...p.form || {},
                        [f.key]: e.target.value
                    }
                }
            });
        }
    },
    Hint: {
        tag: 'div',
        if: (el, s)=>{
            const f = typeof s.field === 'function' ? s.field(null, s) : s.field || el.field;
            return !!f?.hint;
        },
        text: (el, s)=>{
            const f = typeof s.field === 'function' ? s.field(null, s) : s.field || el.field;
            return f?.hint;
        },
        fontSize: 'Z',
        color: 'rgba(255,255,255,0.4)'
    }
};
const $a569955e4f91ff1b$export$dfaef62a0892bd28 = {
    display: (el, s)=>s.root?.settingsOpen ? 'flex' : 'none',
    position: 'fixed',
    inset: '0',
    zIndex: 200,
    background: 'rgba(0,0,0,0.5)',
    align: 'center center',
    pointerEvents: 'auto',
    style: {
        backdropFilter: 'blur(4px)'
    },
    onPointerDown: (ev, el, s)=>{
        if (ev.target !== el.node) return;
        s.root?.update({
            settingsOpen: false
        });
    },
    // Keys prefixed with `Settings*` so DOMQL's key-based auto-extend
    // doesn't accidentally merge us with global `Card`, `Header`, `Body`,
    // `Content`, `ProjectSection`, etc. (ProjectSection in particular pulls
    // in ItemPreview whose href factory `.split()`s getAppKey() and crashes
    // on any route without an app key).
    SettingsCard: {
        position: 'relative',
        width: '640px',
        maxWidth: '92%',
        maxHeight: '80vh',
        background: '#1c1f24',
        color: 'white',
        round: 'A',
        flow: 'y',
        overflow: 'hidden',
        style: {
            boxShadow: '0 30px 80px rgba(0,0,0,0.6)'
        },
        onPointerDown: (ev)=>ev.stopPropagation(),
        SettingsHeader: {
            flow: 'x',
            align: 'center space-between',
            padding: 'A B',
            borderBottom: '1px solid rgba(255,255,255,0.08)',
            SettingsTitle: {
                tag: 'h3',
                text: 'Settings',
                fontSize: 'A',
                margin: '0'
            },
            SettingsClose: {
                tag: 'button',
                type: 'button',
                text: "\xd7",
                'aria-label': 'Close settings',
                cursor: 'pointer',
                background: 'transparent',
                border: '0',
                color: 'white',
                fontSize: 'B',
                padding: '0 W',
                onClick: (ev, el, s)=>{
                    ev.stopPropagation();
                    s.root?.update({
                        settingsOpen: false
                    });
                }
            }
        },
        SettingsBody: {
            flow: 'x',
            flexGrow: '1',
            overflow: 'hidden',
            WsSettingsNav: {
                flow: 'y',
                width: '180px',
                padding: 'A V',
                gap: 'V',
                borderRight: '1px solid rgba(255,255,255,0.08)',
                background: 'rgba(0,0,0,0.25)',
                NavItemWorkspace: $a569955e4f91ff1b$var$settingsTab('workspace', 'Workspace', 'Workspace-wide drag, layout and picker settings.'),
                NavItemProject: $a569955e4f91ff1b$var$settingsTab('project', 'Project', 'Canvas viewport, snap, grid and selection tools.')
            },
            SettingsContent: {
                flexGrow: '1',
                flow: 'y',
                padding: 'A B',
                overflow: 'auto',
                gap: 'A',
                WorkspacePane: {
                    display: (el, s)=>(s.root?.settingsTab || 'workspace') === 'workspace' ? 'flex' : 'none',
                    flow: 'y',
                    gap: 'A',
                    DragModeRow: $a569955e4f91ff1b$var$settingsBlockRow('Drag mode', 'Free lets you drop cards anywhere; Grid snaps to 24px increments.', {
                        flow: 'x',
                        gap: '0',
                        round: 'Z',
                        padding: 'W',
                        background: 'rgba(255,255,255,0.06)',
                        childExtends: 'Button',
                        childProps: {
                            padding: 'W Y',
                            fontSize: 'Z',
                            round: 'Z',
                            cursor: 'pointer',
                            border: '0'
                        },
                        FreeformBtn: {
                            text: 'Free',
                            background: (el, s)=>$a569955e4f91ff1b$var$getDragMode(s.root) === 'freeform' ? 'rgba(255,255,255,0.16)' : 'transparent',
                            color: (el, s)=>$a569955e4f91ff1b$var$getDragMode(s.root) === 'freeform' ? 'white' : 'rgba(255,255,255,0.55)',
                            onClick: (e, el, s)=>s.root.update({
                                    dragMode: 'freeform'
                                })
                        },
                        GridBtn: {
                            text: 'Grid',
                            background: (el, s)=>$a569955e4f91ff1b$var$getDragMode(s.root) === 'grid' ? 'rgba(255,255,255,0.16)' : 'transparent',
                            color: (el, s)=>$a569955e4f91ff1b$var$getDragMode(s.root) === 'grid' ? 'white' : 'rgba(255,255,255,0.55)',
                            onClick: (e, el, s)=>s.root.update({
                                    dragMode: 'grid'
                                })
                        }
                    }),
                    AutoLayoutRow: $a569955e4f91ff1b$var$settingsBlockRow('Auto layout', 'Rearranges all cards into a tidy grid and persists positions.', {
                        tag: 'button',
                        type: 'button',
                        padding: 'W A',
                        round: 'Z',
                        border: '0',
                        background: 'rgba(255,255,255,0.12)',
                        color: 'white',
                        fontSize: 'Z',
                        cursor: 'pointer',
                        text: 'Run now',
                        ':hover': {
                            background: 'rgba(255,255,255,0.2)'
                        },
                        onClick: (e, el, s)=>{
                            e.stopPropagation();
                            const root = s.root;
                            if (!Array.isArray(root?.nodes)) return;
                            const newPositions = $a569955e4f91ff1b$var$layoutPositions(root.nodes);
                            root.update({
                                positions: newPositions
                            });
                            $a569955e4f91ff1b$var$persistPositions({
                                nodes: root.nodes,
                                positions: newPositions
                            }, root.nodes.map((n)=>n.id));
                        }
                    })
                },
                ProjectPane: {
                    display: (el, s)=>(s.root?.settingsTab || 'workspace') === 'project' ? 'flex' : 'none',
                    flow: 'y',
                    gap: 'A',
                    SettingsPlaceholder: {
                        if: (el)=>!el.call?.('getCanvasV2'),
                        padding: 'B',
                        round: 'Z',
                        border: '1px dashed rgba(255,255,255,0.12)',
                        background: 'rgba(255,255,255,0.02)',
                        textAlign: 'center',
                        color: 'rgba(255,255,255,0.55)',
                        flow: 'y',
                        gap: 'V',
                        PlaceholderTitle: {
                            tag: 'span',
                            text: 'No project open',
                            fontWeight: '600',
                            color: 'white'
                        },
                        PlaceholderHint: {
                            tag: 'span',
                            text: 'Project-level canvas settings (snap, rulers, frame mode) appear here when you open a project.',
                            fontSize: 'Z'
                        }
                    },
                    // Canvas v2 settings — mirror the old CvCanvasSettingsModal body.
                    // Rendered inside an `if` so they only build when a canvas
                    // context exists (workspace page returns null from getCanvasV2
                    // and lands on the Placeholder above).
                    FrameModeRow: $a569955e4f91ff1b$var$settingsCanvasRow('Frame mode', 'Live iframe previews for each card.', {
                        checked: 'frameMode',
                        patch: (v)=>({
                                frameMode: v
                            })
                    }),
                    ShowRulersRow: $a569955e4f91ff1b$var$settingsCanvasRow('Show rulers', 'Screen-space rulers along the top and left edges.', {
                        checked: 'showRulers',
                        patch: (v)=>({
                                showRulers: v
                            })
                    }),
                    ShowMinimapRow: $a569955e4f91ff1b$var$settingsCanvasRow('Show minimap', 'Miniature overview at the bottom-right of the canvas.', {
                        checked: 'showMinimap',
                        patch: (v)=>({
                                showMinimap: v
                            })
                    }),
                    SnapRow: $a569955e4f91ff1b$var$settingsCanvasRow('Snap', 'Master toggle for all snapping behaviours.', {
                        checked: (v2)=>!!v2?.snap?.enabled,
                        patchSnap: (v)=>({
                                enabled: v
                            })
                    }),
                    SnapGridRow: $a569955e4f91ff1b$var$settingsCanvasRow('Snap to grid', 'Pins drags to the canvas grid step.', {
                        checked: (v2)=>!!v2?.snap?.toGrid,
                        patchSnap: (v)=>({
                                toGrid: v
                            })
                    }),
                    SnapItemsRow: $a569955e4f91ff1b$var$settingsCanvasRow('Snap to items', 'Pulls drags to other cards as they align.', {
                        checked: (v2)=>!!v2?.snap?.toItems,
                        patchSnap: (v)=>({
                                toItems: v
                            })
                    }),
                    SnapGuidesRow: $a569955e4f91ff1b$var$settingsCanvasRow('Snap to guides', 'Snaps drags onto user-placed rulers and guides.', {
                        checked: (v2)=>!!v2?.snap?.toGuides,
                        patchSnap: (v)=>({
                                toGuides: v
                            })
                    })
                }
            }
        }
    }
};
const $a569955e4f91ff1b$export$260fc82af66a6023 = {
    display: (el, s)=>s.root?.projectDeleteConfirm ? 'flex' : 'none',
    position: 'fixed',
    inset: '0',
    zIndex: 300,
    background: 'rgba(0,0,0,0.65)',
    align: 'center center',
    pointerEvents: 'auto',
    style: {
        backdropFilter: 'blur(4px)',
        outline: 'none'
    },
    tabindex: '-1',
    onRender: (el, s)=>{
        if (s.root?.projectDeleteConfirm) el.node?.focus?.();
    },
    onPointerDown: (ev, el, s)=>{
        if (ev.target !== el.node) return;
        s.root?.update({
            projectDeleteConfirm: null
        });
    },
    onKeydown: (ev, el, s)=>{
        if (ev.key === 'Escape') s.root?.update({
            projectDeleteConfirm: null
        });
    },
    DelCard: {
        position: 'relative',
        width: '420px',
        maxWidth: '92%',
        background: '#1c1f24',
        color: 'white',
        round: 'A',
        flow: 'y',
        overflow: 'hidden',
        style: {
            boxShadow: '0 30px 80px rgba(0,0,0,0.6)'
        },
        onPointerDown: (ev)=>ev.stopPropagation(),
        DelHeader: {
            padding: 'A B',
            borderBottom: '1px solid rgba(255,255,255,0.08)',
            flow: 'x',
            align: 'center space-between',
            DelTitle: {
                tag: 'h3',
                text: (el, s)=>`Delete "${s.root?.projectDeleteConfirm?.name}"?`,
                fontSize: 'A',
                margin: '0',
                color: 'rgb(255,90,90)'
            },
            DelClose: {
                tag: 'button',
                type: 'button',
                text: "\xd7",
                'aria-label': 'Cancel delete',
                cursor: 'pointer',
                background: 'transparent',
                border: '0',
                color: 'white',
                fontSize: 'B',
                padding: '0 W',
                onClick: (ev, el, s)=>{
                    ev.stopPropagation();
                    s.root?.update({
                        projectDeleteConfirm: null
                    });
                }
            }
        },
        DelBody: {
            padding: 'A B',
            flow: 'y',
            gap: 'A',
            DelWarning: {
                tag: 'p',
                text: 'This action cannot be undone. Type the project key below to confirm deletion.',
                fontSize: 'Z2',
                color: 'rgba(255,255,255,0.7)',
                margin: '0',
                lineHeight: '1.5'
            },
            DelConfirmLabel: {
                tag: 'label',
                text: (el, s)=>`Type "${s.root?.projectDeleteConfirm?.key}" to confirm:`,
                fontSize: 'Z2',
                color: 'rgba(255,255,255,0.55)',
                display: 'block'
            },
            DelInput: {
                tag: 'input',
                type: 'text',
                placeholder: (el, s)=>s.root?.projectDeleteConfirm?.key || '',
                'aria-label': 'Confirm project key',
                autocomplete: 'off',
                padding: 'Y X',
                round: 'Z',
                background: 'rgba(255,255,255,0.06)',
                border: '1px solid rgba(255,255,255,0.12)',
                color: 'white',
                fontSize: 'Z2',
                width: '100%',
                style: {
                    boxSizing: 'border-box'
                },
                onInput: (ev, el, s)=>{
                    const val = ev.target?.value || '';
                    s.root?.update({
                        _deleteConfirmTyped: val
                    });
                }
            },
            DelActions: {
                flow: 'x',
                gap: 'Y',
                justifyContent: 'flex-end',
                DelCancelBtn: {
                    tag: 'button',
                    type: 'button',
                    text: 'Cancel',
                    padding: 'Y A',
                    round: 'Z',
                    background: 'rgba(255,255,255,0.06)',
                    border: '1px solid rgba(255,255,255,0.12)',
                    color: 'white',
                    cursor: 'pointer',
                    fontSize: 'Z2',
                    ':hover': {
                        background: 'rgba(255,255,255,0.12)'
                    },
                    onClick: (ev, el, s)=>{
                        ev.stopPropagation();
                        s.root?.update({
                            projectDeleteConfirm: null,
                            _deleteConfirmTyped: ''
                        });
                    }
                },
                DelConfirmBtn: {
                    tag: 'button',
                    type: 'button',
                    text: 'Delete project',
                    padding: 'Y A',
                    round: 'Z',
                    border: '0',
                    cursor: 'pointer',
                    fontSize: 'Z2',
                    background: (el, s)=>{
                        const cfg = s.root?.projectDeleteConfirm;
                        const typed = s.root?._deleteConfirmTyped || '';
                        return cfg?.key && typed === cfg.key ? 'rgb(200,40,40)' : 'rgba(200,40,40,0.3)';
                    },
                    color: 'white',
                    ':hover': {},
                    onClick: async (ev, el, s)=>{
                        ev.stopPropagation();
                        const cfg = s.root?.projectDeleteConfirm;
                        const typed = s.root?._deleteConfirmTyped || '';
                        if (!cfg?.key || typed !== cfg.key) return;
                        const sdk = (0, $bfqVY.getSDK)();
                        if (typeof sdk?.deleteProject === 'function') try {
                            await sdk.deleteProject(cfg.id);
                        } catch (_) {}
                        // Remove from local canvas state regardless of server response
                        const nodes = (s.root?.nodes || []).filter((n)=>n._id !== cfg.id && n.id !== cfg.id);
                        s.root?.update({
                            nodes: nodes,
                            projectDeleteConfirm: null,
                            _deleteConfirmTyped: ''
                        });
                    }
                }
            }
        }
    }
};
const $a569955e4f91ff1b$export$bc25ee545e35c4c4 = {
    display: (el, s)=>s.root?.projectDuplicateModal ? 'flex' : 'none',
    position: 'fixed',
    inset: '0',
    zIndex: 300,
    background: 'rgba(0,0,0,0.65)',
    align: 'center center',
    pointerEvents: 'auto',
    style: {
        backdropFilter: 'blur(4px)',
        outline: 'none'
    },
    tabindex: '-1',
    onRender: (el, s)=>{
        if (s.root?.projectDuplicateModal) el.node?.focus?.();
    },
    onPointerDown: (ev, el, s)=>{
        if (ev.target !== el.node) return;
        s.root?.update({
            projectDuplicateModal: null
        });
    },
    onKeydown: (ev, el, s)=>{
        if (ev.key === 'Escape') s.root?.update({
            projectDuplicateModal: null
        });
    },
    DupCard: {
        position: 'relative',
        width: '420px',
        maxWidth: '92%',
        background: '#1c1f24',
        color: 'white',
        round: 'A',
        flow: 'y',
        overflow: 'hidden',
        style: {
            boxShadow: '0 30px 80px rgba(0,0,0,0.6)'
        },
        onPointerDown: (ev)=>ev.stopPropagation(),
        DupHeader: {
            padding: 'A B',
            borderBottom: '1px solid rgba(255,255,255,0.08)',
            flow: 'x',
            align: 'center space-between',
            DupTitle: {
                tag: 'h3',
                text: (el, s)=>`Duplicate "${s.root?.projectDuplicateModal?.sourceName}"`,
                fontSize: 'A',
                margin: '0'
            },
            DupClose: {
                tag: 'button',
                type: 'button',
                text: "\xd7",
                'aria-label': 'Cancel duplicate',
                cursor: 'pointer',
                background: 'transparent',
                border: '0',
                color: 'white',
                fontSize: 'B',
                padding: '0 W',
                onClick: (ev, el, s)=>{
                    ev.stopPropagation();
                    s.root?.update({
                        projectDuplicateModal: null
                    });
                }
            }
        },
        DupBody: {
            padding: 'A B',
            flow: 'y',
            gap: 'A',
            DupNameLabel: {
                tag: 'label',
                text: 'New project name',
                fontSize: 'Z2',
                color: 'rgba(255,255,255,0.55)'
            },
            DupNameInput: {
                tag: 'input',
                type: 'text',
                'aria-label': 'New project name',
                placeholder: (el, s)=>`Copy of ${s.root?.projectDuplicateModal?.sourceName || 'project'}`,
                autocomplete: 'off',
                padding: 'Y X',
                round: 'Z',
                background: 'rgba(255,255,255,0.06)',
                border: '1px solid rgba(255,255,255,0.12)',
                color: 'white',
                fontSize: 'Z2',
                width: '100%',
                style: {
                    boxSizing: 'border-box'
                },
                onInput: (ev, el, s)=>{
                    s.root?.update({
                        _dupName: ev.target?.value || ''
                    });
                }
            },
            DupKeyLabel: {
                tag: 'label',
                text: 'New project key (slug)',
                fontSize: 'Z2',
                color: 'rgba(255,255,255,0.55)'
            },
            DupKeyInput: {
                tag: 'input',
                type: 'text',
                'aria-label': 'New project key',
                placeholder: 'my-project-copy',
                autocomplete: 'off',
                padding: 'Y X',
                round: 'Z',
                background: 'rgba(255,255,255,0.06)',
                border: '1px solid rgba(255,255,255,0.12)',
                color: 'white',
                fontSize: 'Z2',
                fontFamily: 'monospace',
                width: '100%',
                style: {
                    boxSizing: 'border-box'
                },
                onInput: (ev, el, s)=>{
                    const raw = (ev.target?.value || '').toLowerCase().replace(/[^a-z0-9-]/g, '-');
                    s.root?.update({
                        _dupKey: raw
                    });
                }
            },
            DupError: {
                if: (el, s)=>!!s.root?._dupError,
                tag: 'p',
                text: (el, s)=>s.root?._dupError || '',
                fontSize: 'Z1',
                color: 'rgb(255,100,100)',
                margin: '0'
            },
            DupActions: {
                flow: 'x',
                gap: 'Y',
                justifyContent: 'flex-end',
                DupCancelBtn: {
                    tag: 'button',
                    type: 'button',
                    text: 'Cancel',
                    padding: 'Y A',
                    round: 'Z',
                    background: 'rgba(255,255,255,0.06)',
                    border: '1px solid rgba(255,255,255,0.12)',
                    color: 'white',
                    cursor: 'pointer',
                    fontSize: 'Z2',
                    ':hover': {
                        background: 'rgba(255,255,255,0.12)'
                    },
                    onClick: (ev, el, s)=>{
                        ev.stopPropagation();
                        s.root?.update({
                            projectDuplicateModal: null,
                            _dupName: '',
                            _dupKey: '',
                            _dupError: ''
                        });
                    }
                },
                DupSubmitBtn: {
                    tag: 'button',
                    type: 'button',
                    text: (el, s)=>s.root?._dupCreating ? "Duplicating\u2026" : 'Duplicate',
                    padding: 'Y A',
                    round: 'Z',
                    border: '0',
                    background: 'rgba(80,120,255,0.85)',
                    color: 'white',
                    cursor: 'pointer',
                    fontSize: 'Z2',
                    ':hover': {
                        background: 'rgba(80,120,255,1)'
                    },
                    onClick: async (ev, el, s)=>{
                        ev.stopPropagation();
                        const cfg = s.root?.projectDuplicateModal;
                        if (!cfg?.sourceId) return;
                        const name = (s.root?._dupName || '').trim() || `Copy of ${cfg.sourceName || 'project'}`;
                        const newKey = (s.root?._dupKey || '').trim();
                        if (!newKey) {
                            s.root?.update({
                                _dupError: 'Key is required.'
                            });
                            return;
                        }
                        const sdk = (0, $bfqVY.getSDK)();
                        if (typeof sdk?.duplicateProject !== 'function') {
                            s.root?.update({
                                _dupError: 'Duplicate not supported by this SDK version.'
                            });
                            return;
                        }
                        s.root?.update({
                            _dupCreating: true,
                            _dupError: ''
                        });
                        try {
                            const project = await sdk.duplicateProject({
                                sourceProjectId: cfg.sourceId,
                                name: name,
                                newKey: newKey
                            });
                            if (project) $a569955e4f91ff1b$export$fdf2d64c97cb6b39(project);
                            s.root?.update({
                                projectDuplicateModal: null,
                                _dupName: '',
                                _dupKey: '',
                                _dupError: '',
                                _dupCreating: false
                            });
                        } catch (err) {
                            s.root?.update({
                                _dupError: err?.message || 'Duplicate failed.',
                                _dupCreating: false
                            });
                        }
                    }
                }
            }
        }
    }
};
const $a569955e4f91ff1b$export$a8aa839ae0de97a6 = {
    display: (el, s)=>s.root?.projectEditMetadataModal ? 'flex' : 'none',
    position: 'fixed',
    inset: '0',
    zIndex: 300,
    background: 'rgba(0,0,0,0.65)',
    align: 'center center',
    pointerEvents: 'auto',
    style: {
        backdropFilter: 'blur(4px)',
        outline: 'none'
    },
    tabindex: '-1',
    onRender: (el, s)=>{
        if (s.root?.projectEditMetadataModal) el.node?.focus?.();
    },
    onPointerDown: (ev, el, s)=>{
        if (ev.target !== el.node) return;
        s.root?.update({
            projectEditMetadataModal: null
        });
    },
    onKeydown: (ev, el, s)=>{
        if (ev.key === 'Escape') s.root?.update({
            projectEditMetadataModal: null
        });
    },
    MetaCard: {
        position: 'relative',
        width: '420px',
        maxWidth: '92%',
        background: '#1c1f24',
        color: 'white',
        round: 'A',
        flow: 'y',
        overflow: 'hidden',
        style: {
            boxShadow: '0 30px 80px rgba(0,0,0,0.6)'
        },
        onPointerDown: (ev)=>ev.stopPropagation(),
        MetaHeader: {
            padding: 'A B',
            borderBottom: '1px solid rgba(255,255,255,0.08)',
            flow: 'x',
            align: 'center space-between',
            MetaTitle: {
                tag: 'h3',
                text: 'Edit project metadata',
                fontSize: 'A',
                margin: '0'
            },
            MetaClose: {
                tag: 'button',
                type: 'button',
                text: "\xd7",
                'aria-label': 'Close',
                cursor: 'pointer',
                background: 'transparent',
                border: '0',
                color: 'white',
                fontSize: 'B',
                padding: '0 W',
                onClick: (ev, el, s)=>{
                    ev.stopPropagation();
                    s.root?.update({
                        projectEditMetadataModal: null
                    });
                }
            }
        },
        MetaBody: {
            padding: 'A B',
            flow: 'y',
            gap: 'A',
            MetaNameLabel: {
                tag: 'label',
                text: 'Project name',
                fontSize: 'Z2',
                color: 'rgba(255,255,255,0.55)'
            },
            MetaNameInput: {
                tag: 'input',
                type: 'text',
                'aria-label': 'Project name',
                placeholder: 'My project',
                autocomplete: 'off',
                padding: 'Y X',
                round: 'Z',
                background: 'rgba(255,255,255,0.06)',
                border: '1px solid rgba(255,255,255,0.12)',
                color: 'white',
                fontSize: 'Z2',
                width: '100%',
                style: {
                    boxSizing: 'border-box'
                },
                value: (el, s)=>s.root?.projectEditMetadataModal?.name || '',
                onInput: (ev, el, s)=>{
                    const cfg = s.root?.projectEditMetadataModal;
                    if (cfg) s.root?.update({
                        projectEditMetadataModal: {
                            ...cfg,
                            _editName: ev.target?.value || ''
                        }
                    });
                }
            },
            MetaKeyLabel: {
                tag: 'label',
                text: 'Project key (slug)',
                fontSize: 'Z2',
                color: 'rgba(255,255,255,0.55)'
            },
            MetaKeyInput: {
                tag: 'input',
                type: 'text',
                'aria-label': 'Project key',
                placeholder: 'my-project',
                autocomplete: 'off',
                padding: 'Y X',
                round: 'Z',
                background: 'rgba(255,255,255,0.06)',
                border: '1px solid rgba(255,255,255,0.12)',
                color: 'white',
                fontSize: 'Z2',
                fontFamily: 'monospace',
                width: '100%',
                style: {
                    boxSizing: 'border-box'
                },
                value: (el, s)=>s.root?.projectEditMetadataModal?.key || '',
                onInput: (ev, el, s)=>{
                    const raw = (ev.target?.value || '').toLowerCase().replace(/[^a-z0-9-]/g, '-');
                    const cfg = s.root?.projectEditMetadataModal;
                    if (cfg) s.root?.update({
                        projectEditMetadataModal: {
                            ...cfg,
                            _editKey: raw
                        }
                    });
                }
            },
            MetaHint: {
                tag: 'p',
                text: 'Equivalent to: smbls project update',
                fontSize: 'Z1',
                color: 'rgba(255,255,255,0.3)',
                margin: '0',
                fontFamily: 'monospace'
            },
            MetaError: {
                if: (el, s)=>!!s.root?.projectEditMetadataModal?._error,
                tag: 'p',
                text: (el, s)=>s.root?.projectEditMetadataModal?._error || '',
                fontSize: 'Z1',
                color: 'rgb(255,100,100)',
                margin: '0'
            },
            MetaActions: {
                flow: 'x',
                gap: 'Y',
                justifyContent: 'flex-end',
                MetaCancelBtn: {
                    tag: 'button',
                    type: 'button',
                    text: 'Cancel',
                    padding: 'Y A',
                    round: 'Z',
                    background: 'rgba(255,255,255,0.06)',
                    border: '1px solid rgba(255,255,255,0.12)',
                    color: 'white',
                    cursor: 'pointer',
                    fontSize: 'Z2',
                    ':hover': {
                        background: 'rgba(255,255,255,0.12)'
                    },
                    onClick: (ev, el, s)=>{
                        ev.stopPropagation();
                        s.root?.update({
                            projectEditMetadataModal: null
                        });
                    }
                },
                MetaSaveBtn: {
                    tag: 'button',
                    type: 'button',
                    text: (el, s)=>s.root?.projectEditMetadataModal?._saving ? "Saving\u2026" : 'Save',
                    padding: 'Y A',
                    round: 'Z',
                    border: '0',
                    background: 'rgba(80,120,255,0.85)',
                    color: 'white',
                    cursor: 'pointer',
                    fontSize: 'Z2',
                    ':hover': {
                        background: 'rgba(80,120,255,1)'
                    },
                    onClick: async (ev, el, s)=>{
                        ev.stopPropagation();
                        const cfg = s.root?.projectEditMetadataModal;
                        if (!cfg?.id) return;
                        const name = (cfg._editName !== undefined ? cfg._editName : cfg.name || '').trim();
                        const key = (cfg._editKey !== undefined ? cfg._editKey : cfg.key || '').trim();
                        if (!name || !key) {
                            s.root?.update({
                                projectEditMetadataModal: {
                                    ...cfg,
                                    _error: 'Name and key are required.'
                                }
                            });
                            return;
                        }
                        const sdk = (0, $bfqVY.getSDK)();
                        if (typeof sdk?.updateProject !== 'function') {
                            s.root?.update({
                                projectEditMetadataModal: {
                                    ...cfg,
                                    _error: 'Update not supported by this SDK version.'
                                }
                            });
                            return;
                        }
                        s.root?.update({
                            projectEditMetadataModal: {
                                ...cfg,
                                _saving: true,
                                _error: ''
                            }
                        });
                        try {
                            await sdk.updateProject(cfg.id, {
                                name: name,
                                slug: key
                            });
                            // Refresh the local node in canvas state
                            const nodes = (s.root?.nodes || []).map((n)=>n._id === cfg.id || n.id === cfg.id ? {
                                    ...n,
                                    name: name,
                                    key: key
                                } : n);
                            s.root?.update({
                                nodes: nodes,
                                projectEditMetadataModal: null
                            });
                        } catch (err) {
                            const cur = s.root?.projectEditMetadataModal;
                            s.root?.update({
                                projectEditMetadataModal: {
                                    ...cur,
                                    _error: err?.message || 'Save failed.',
                                    _saving: false
                                }
                            });
                        }
                    }
                }
            }
        }
    }
};
const $a569955e4f91ff1b$export$76dea0c3ad8844e8 = {
    flow: 'row',
    align: 'center start',
    gap: 'V',
    padding: 'V X',
    round: '8px',
    cursor: 'pointer',
    color: 'white',
    border: '1px solid transparent',
    ':hover': {
        background: 'rgba(255,255,255,0.05)',
        border: '1px solid rgba(255,255,255,0.08)'
    },
    Info: {
        flow: 'column',
        flexGrow: '1',
        gap: '2px',
        Name: {
            tag: 'div',
            text: (el, s)=>s.name,
            fontSize: 'Z2',
            fontWeight: '500'
        },
        Path: {
            tag: 'div',
            text: (el, s)=>`${s.ownerSlug}/${s.key}`,
            fontSize: 'Z',
            color: 'rgba(255,255,255,0.5)',
            fontFamily: 'monospace'
        }
    },
    Visibility: {
        tag: 'span',
        text: (el, s)=>s.visibility === 'public' ? 'public' : 'org',
        fontSize: 'Z',
        padding: '2px 8px',
        round: '10px',
        background: (el, s)=>s.visibility === 'public' ? 'rgba(80,200,120,0.18)' : 'rgba(255,255,255,0.08)',
        color: (el, s)=>s.visibility === 'public' ? 'rgb(120,220,160)' : 'rgba(255,255,255,0.7)'
    },
    onClick: (e, el, s)=>{
        e.stopPropagation();
        const root = s.root;
        const targetNodeId = s.targetNodeId;
        const isStandalone = targetNodeId === '__standalone__';
        const targetNode = isStandalone ? null : (root?.nodes || []).find((n)=>n.id === targetNodeId);
        if (!s._id || !isStandalone && !targetNode?._id) return;
        const patch = {
            libraryPickerFor: null,
            libraryPickerQuery: ''
        };
        let nodes = root.nodes || [];
        let libNode = nodes.find((n)=>n._id === s._id);
        if (!libNode) {
            const raw = (root.libraryPickerList || []).find((p)=>p._id === s._id);
            if (!raw) return;
            libNode = $a569955e4f91ff1b$var$normalizeProject(raw);
            nodes = [
                ...nodes,
                libNode
            ];
            const anchor = isStandalone ? {
                x: 120,
                y: 120
            } : root.positions?.[targetNodeId] || {
                x: 120,
                y: 120
            };
            patch.nodes = nodes;
            patch.positions = {
                ...root.positions || {},
                [libNode.id]: {
                    x: anchor.x - (isStandalone ? 0 : $a569955e4f91ff1b$var$COL_STRIDE),
                    y: anchor.y + (isStandalone ? $a569955e4f91ff1b$var$ROW_STRIDE : 0),
                    w: $a569955e4f91ff1b$var$NODE_W,
                    h: $a569955e4f91ff1b$var$NODE_H
                }
            };
        }
        if (isStandalone) {
            root.update(patch);
            return;
        }
        const exists = (root.connections || []).some((c)=>c.from === libNode.id && c.to === targetNodeId);
        if (!exists) patch.connections = [
            ...root.connections || [],
            {
                id: libNode.id + "\u2192" + targetNodeId + ':' + Date.now(),
                from: libNode.id,
                to: targetNodeId
            }
        ];
        root.update(patch);
        if (!exists) {
            $a569955e4f91ff1b$var$persistSharedLibraries(root, [
                targetNodeId
            ]);
            $a569955e4f91ff1b$var$redrawConnections();
        }
    }
};
const $a569955e4f91ff1b$var$groupFrameChildren = $a569955e4f91ff1b$var$GROUP_SLOTS.reduce((acc, ws)=>{
    acc['GroupFrame_' + ws] = {
        attr: {
            'data-group-id': ws
        },
        position: 'absolute',
        left: (el, s)=>{
            const bb = $a569955e4f91ff1b$var$groupBbox(s.root, ws);
            return bb ? bb.x - $a569955e4f91ff1b$var$GROUP_PAD + 'px' : '-9999px';
        },
        top: (el, s)=>{
            const bb = $a569955e4f91ff1b$var$groupBbox(s.root, ws);
            return bb ? bb.y - $a569955e4f91ff1b$var$GROUP_PAD + 'px' : '-9999px';
        },
        width: (el, s)=>{
            const bb = $a569955e4f91ff1b$var$groupBbox(s.root, ws);
            return bb ? bb.w + $a569955e4f91ff1b$var$GROUP_PAD * 2 + 'px' : '0px';
        },
        height: (el, s)=>{
            const bb = $a569955e4f91ff1b$var$groupBbox(s.root, ws);
            return bb ? bb.h + $a569955e4f91ff1b$var$GROUP_PAD * 2 + 'px' : '0px';
        },
        display: (el, s)=>{
            const bb = $a569955e4f91ff1b$var$groupBbox(s.root, ws);
            return bb && $a569955e4f91ff1b$var$nodesOfGroup(ws, s.root).length >= 2 ? 'block' : 'none';
        },
        round: '16px',
        cursor: 'grab',
        border: (el, s)=>s.root?.hoverGroup === ws ? '2px solid rgba(255,255,255,0.8)' : '1px solid rgba(255,255,255,0.15)',
        background: (el, s)=>s.root?.hoverGroup === ws ? 'rgba(255,255,255,0.08)' : 'rgba(255,255,255,0.03)',
        transition: 'A background defaultBezier, A border defaultBezier',
        onMousedown: (e, el, s)=>{
            const root = s.root;
            const members = $a569955e4f91ff1b$var$nodesOfGroup(ws, root);
            if (!members.length) return;
            $a569955e4f91ff1b$var$startDrag(e, el, root, members[0].id, {
                group: true,
                groupWs: ws
            });
        },
        Label: {
            tag: 'span',
            position: 'absolute',
            top: '-28px',
            left: '4px',
            fontSize: 'Z',
            fontWeight: '600',
            letterSpacing: '0.08em',
            color: 'rgba(255,255,255,0.6)',
            textTransform: 'uppercase',
            pointerEvents: 'auto',
            cursor: 'text',
            padding: '2px 6px',
            round: '4px',
            style: {
                outline: 'none'
            },
            ':hover': {
                background: 'rgba(255,255,255,0.08)'
            },
            text: (el, s)=>s.root?.groupNames?.[ws] || ws,
            onMousedown: (e)=>e.stopPropagation(),
            onDblclick: (e, el)=>{
                e.stopPropagation();
                el.node.contentEditable = 'true';
                el.node.focus();
                const doc = el.context.document;
                const win = el.context.window;
                const range = doc.createRange();
                range.selectNodeContents(el.node);
                const sel = win.getSelection();
                sel.removeAllRanges();
                sel.addRange(range);
            },
            onBlur: (e, el, s)=>{
                el.node.contentEditable = 'false';
                const name = el.node.textContent.trim();
                s.root.update({
                    groupNames: {
                        ...s.root.groupNames || {},
                        [ws]: name || ws
                    }
                });
            },
            onKeydown: (e, el)=>{
                if (e.key === 'Enter' || e.key === 'Escape') {
                    e.preventDefault();
                    el.node.blur();
                }
            }
        }
    };
    return acc;
}, {});
const $a569955e4f91ff1b$export$7ab8b42c4cb35d1d = {
    display: (el, s)=>s.root?.integrationPicker?.open ? 'flex' : 'none',
    position: 'fixed',
    inset: '0',
    background: 'rgba(0,0,0,0.55)',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'B',
    zIndex: 210,
    style: {
        backdropFilter: 'blur(4px)'
    },
    onMousedown: (e, el, s)=>{
        if (e.target === el.node) s.root?.update({
            integrationPicker: {
                open: false
            }
        });
    },
    onRender: (el, s)=>{
        if (el.__kindsFetched) return;
        el.__kindsFetched = true;
        (async ()=>{
            const bridge = await $a569955e4f91ff1b$var$sdkBridge();
            if (!bridge?.listIntegrationKinds) return;
            try {
                const kinds = await bridge.listIntegrationKinds();
                const prev = s.root?.integrationPicker || {};
                s.root?.update({
                    integrationPicker: {
                        ...prev,
                        kinds: Array.isArray(kinds) ? kinds : []
                    }
                });
            } catch (err) {
                const prev = s.root?.integrationPicker || {};
                s.root?.update({
                    integrationPicker: {
                        ...prev,
                        error: err?.message || 'failed to load kinds'
                    }
                });
            }
        })();
    },
    // Renamed off-default keys (Panel/Header/Hint/Form) where they
    // collided with globally registered components via key-based
    // auto-extend. `IntegrationPanel`, `PickerHeader`, etc. are unique
    // so the auto-extend doesn't merge in unrelated subtrees.
    IntegrationPanel: {
        width: '560px',
        maxWidth: '100%',
        maxHeight: 'min(80vh, 700px)',
        background: 'rgba(24,27,33,0.98)',
        border: '1px solid rgba(255,255,255,0.08)',
        round: '12px',
        boxShadow: '0 30px 80px rgba(0,0,0,0.6)',
        flow: 'column',
        overflow: 'hidden',
        PickerHeader: {
            padding: 'A B',
            flow: 'column',
            gap: 'V',
            borderBottom: '1px solid rgba(255,255,255,0.06)',
            PickerRow: {
                flow: 'row',
                align: 'center space-between',
                gap: 'V',
                PickerTitle: {
                    tag: 'div',
                    text: (el, s)=>s.root?.integrationPicker?.step === 'form' ? 'Configure ' + (s.root.integrationPicker.selectedKind?.label || 'integration') : 'Add integration',
                    color: 'white',
                    fontSize: 'A',
                    fontWeight: '600'
                },
                PickerClose: {
                    tag: 'button',
                    type: 'button',
                    text: "\xd7",
                    'aria-label': 'Close integration picker',
                    padding: '0 W',
                    fontSize: 'B',
                    background: 'transparent',
                    border: '0',
                    color: 'rgba(255,255,255,0.7)',
                    cursor: 'pointer',
                    ':hover': {
                        color: 'white'
                    },
                    onClick: (e, el, s)=>{
                        e.stopPropagation();
                        s.root?.update({
                            integrationPicker: {
                                open: false
                            }
                        });
                    }
                }
            },
            PickerHint: {
                tag: 'div',
                color: 'rgba(255,255,255,0.5)',
                fontSize: 'Z',
                text: (el, s)=>s.root?.integrationPicker?.step === 'form' ? 'Fill in connection details. Secrets stay server-side.' : 'Choose a service to connect.'
            },
            SearchInput: {
                tag: 'input',
                type: 'text',
                placeholder: "Search integrations\u2026",
                if: (el, s)=>s.root?.integrationPicker?.step !== 'form',
                padding: 'V X',
                round: '8px',
                border: '1px solid rgba(255,255,255,0.1)',
                background: 'rgba(0,0,0,0.35)',
                color: 'white',
                fontSize: 'Z2',
                onInput: (e, el, s)=>{
                    const prev = s.root?.integrationPicker || {};
                    s.root?.update({
                        integrationPicker: {
                            ...prev,
                            query: e.target.value
                        }
                    });
                }
            }
        },
        PickerKindList: {
            flow: 'column',
            gap: 'V',
            padding: 'V A',
            overflow: 'auto',
            flexGrow: '1',
            if: (el, s)=>s.root?.integrationPicker?.step !== 'form',
            children: (el, s)=>{
                const p = s.root?.integrationPicker;
                if (!p) return [];
                const q = (p.query || '').toLowerCase().trim();
                return (p.kinds || []).filter((k)=>!q || `${k.kind} ${k.label} ${k.category}`.toLowerCase().includes(q)).map((k)=>({
                        ...k,
                        _pickerKey: k.kind
                    }));
            },
            childrenAs: 'state',
            childExtends: 'IntegrationKindRow'
        },
        PickerLoading: {
            if: (el, s)=>{
                const p = s.root?.integrationPicker;
                return p && p.step !== 'form' && p.kinds == null;
            },
            padding: 'A',
            text: "Loading integrations\u2026",
            color: 'rgba(255,255,255,0.55)',
            fontSize: 'Z2'
        },
        PickerForm: {
            flow: 'column',
            gap: 'A',
            padding: 'A B',
            overflow: 'auto',
            flexGrow: '1',
            if: (el, s)=>s.root?.integrationPicker?.step === 'form',
            ScopeBlock: {
                flow: 'column',
                gap: 'W',
                ScopeLabel: {
                    tag: 'div',
                    text: 'Scope',
                    fontSize: 'Z',
                    color: 'rgba(255,255,255,0.7)',
                    fontWeight: '600',
                    textTransform: 'uppercase',
                    letterSpacing: '0.06em'
                },
                ScopeButtons: {
                    flow: 'row',
                    gap: 'W',
                    childExtends: 'Button',
                    childProps: {
                        padding: 'W Y',
                        fontSize: 'Z2',
                        round: '6px',
                        border: '1px solid rgba(255,255,255,0.12)',
                        cursor: 'pointer',
                        background: 'transparent',
                        color: 'white'
                    },
                    OrgBtn: {
                        text: 'Org',
                        background: (el, s)=>(s.root?.integrationPicker?.form?.__scope || 'org') === 'org' ? 'rgba(255,255,255,0.16)' : 'transparent',
                        onClick: (e, el, s)=>{
                            const p = s.root?.integrationPicker || {};
                            s.root?.update({
                                integrationPicker: {
                                    ...p,
                                    form: {
                                        ...p.form || {},
                                        __scope: 'org',
                                        __scopeId: null
                                    }
                                }
                            });
                        }
                    },
                    WorkspaceBtn: {
                        text: 'Workspace',
                        background: (el, s)=>s.root?.integrationPicker?.form?.__scope === 'workspace' ? 'rgba(255,255,255,0.16)' : 'transparent',
                        onClick: (e, el, s)=>{
                            const p = s.root?.integrationPicker || {};
                            s.root?.update({
                                integrationPicker: {
                                    ...p,
                                    form: {
                                        ...p.form || {},
                                        __scope: 'workspace',
                                        __scopeId: null
                                    }
                                }
                            });
                        }
                    },
                    ProjectBtn: {
                        text: 'Project',
                        background: (el, s)=>s.root?.integrationPicker?.form?.__scope === 'project' ? 'rgba(255,255,255,0.16)' : 'transparent',
                        onClick: (e, el, s)=>{
                            const p = s.root?.integrationPicker || {};
                            s.root?.update({
                                integrationPicker: {
                                    ...p,
                                    form: {
                                        ...p.form || {},
                                        __scope: 'project'
                                    }
                                }
                            });
                        }
                    }
                },
                ProjectSelect: {
                    if: (el, s)=>s.root?.integrationPicker?.form?.__scope === 'project',
                    tag: 'select',
                    padding: 'V X',
                    round: '6px',
                    border: '1px solid rgba(255,255,255,0.12)',
                    background: 'rgba(0,0,0,0.35)',
                    color: 'white',
                    fontSize: 'Z2',
                    children: (el, s)=>{
                        const placeholder = [
                            {
                                _id: '',
                                name: "\u2014 pick project \u2014"
                            }
                        ];
                        const own = (s.root?.nodes || []).filter((n)=>n._id && n.owner === s.root?.slug);
                        return placeholder.concat(own);
                    },
                    childrenAs: 'state',
                    childProps: (el, s)=>({
                            tag: 'option',
                            attr: {
                                value: s._id || ''
                            },
                            text: s.name || s.key || "\u2014"
                        }),
                    onChange: (e, el, s)=>{
                        const p = s.root?.integrationPicker || {};
                        s.root?.update({
                            integrationPicker: {
                                ...p,
                                form: {
                                    ...p.form || {},
                                    __scopeId: e.target.value || null
                                }
                            }
                        });
                    }
                }
            },
            FormFields: {
                flow: 'column',
                gap: 'V',
                children: (el, s)=>{
                    const p = s.root?.integrationPicker;
                    const kind = p?.selectedKind;
                    const configFields = Array.isArray(kind?.config_schema?.fields) ? kind.config_schema.fields : [];
                    const hasDisplayName = configFields.some((f)=>f.key === 'display_name' || f.key === '__displayName');
                    const base = [
                        {
                            field: {
                                key: '__slug',
                                label: 'Slug',
                                placeholder: 'default',
                                required: true,
                                hint: 'Unique within scope.'
                            }
                        },
                        ...hasDisplayName ? [] : [
                            {
                                field: {
                                    key: '__displayName',
                                    label: 'Display name',
                                    placeholder: 'Human-readable label'
                                }
                            }
                        ],
                        ...configFields.map((f)=>({
                                field: f
                            }))
                    ];
                    const auth = kind?.auth_model;
                    if (auth && auth !== 'none') base.push({
                        field: {
                            key: '__secret',
                            label: kind?.secret_label || 'Secret',
                            placeholder: kind?.secret_hint || '',
                            type: 'password',
                            required: true
                        }
                    });
                    return base;
                },
                childrenAs: 'state',
                childExtends: 'IntegrationFormField'
            },
            ErrorLine: {
                tag: 'div',
                if: (el, s)=>!!s.root?.integrationPicker?.error,
                text: (el, s)=>s.root.integrationPicker.error,
                color: '#ff8a8a',
                fontSize: 'Z'
            },
            Buttons: {
                flow: 'row',
                gap: 'V',
                justify: 'flex-end',
                paddingTop: 'V',
                CancelBtn: {
                    tag: 'button',
                    type: 'button',
                    text: 'Cancel',
                    padding: 'V X',
                    fontSize: 'Z2',
                    round: '6px',
                    cursor: 'pointer',
                    border: '1px solid rgba(255,255,255,0.12)',
                    background: 'transparent',
                    color: 'rgba(255,255,255,0.8)',
                    onClick: (e, el, s)=>s.root?.update({
                            integrationPicker: {
                                open: false
                            }
                        })
                },
                SaveBtn: {
                    tag: 'button',
                    type: 'button',
                    text: (el, s)=>s.root?.integrationPicker?.saving ? "Saving\u2026" : 'Create',
                    padding: 'V X',
                    fontSize: 'Z2',
                    round: '6px',
                    cursor: 'pointer',
                    border: '1px solid rgba(255,255,255,0.12)',
                    background: 'rgba(255,255,255,0.16)',
                    color: 'white',
                    onClick: (e, el, s)=>{
                        e.stopPropagation();
                        $a569955e4f91ff1b$var$saveIntegrationFromPicker(s.root);
                    }
                }
            }
        }
    }
};
const $a569955e4f91ff1b$export$ddc7cbe02dc480fc = {
    display: (el, s)=>s.root?.libraryPickerFor ? 'flex' : 'none',
    position: 'fixed',
    inset: '0',
    background: 'rgba(0,0,0,0.55)',
    alignItems: 'flex-start',
    justifyContent: 'center',
    paddingTop: '80px',
    zIndex: 200,
    onMousedown: (e, el, s)=>{
        if (e.target === el.node) s.root?.update({
            libraryPickerFor: null,
            libraryPickerQuery: ''
        });
    },
    Panel: {
        width: '480px',
        maxHeight: '60vh',
        background: 'rgba(24,27,33,0.98)',
        border: '1px solid rgba(255,255,255,0.08)',
        round: '12px',
        boxShadow: '0 20px 60px rgba(0,0,0,0.55)',
        flow: 'column',
        overflow: 'hidden',
        Header: {
            padding: 'X A',
            flow: 'column',
            gap: 'V',
            borderBottom: '1px solid rgba(255,255,255,0.06)',
            Title: {
                tag: 'div',
                text: 'Import library',
                color: 'white',
                fontSize: 'A',
                fontWeight: '600'
            },
            Hint: {
                tag: 'div',
                color: 'rgba(255,255,255,0.5)',
                fontSize: 'Z',
                text: 'Search public libraries or projects in your orgs.'
            },
            SearchInput: {
                tag: 'input',
                type: 'text',
                placeholder: "Search libraries\u2026",
                padding: 'V X',
                round: '8px',
                border: '1px solid rgba(255,255,255,0.1)',
                background: 'rgba(0,0,0,0.35)',
                color: 'white',
                fontSize: 'Z2',
                onRender: (el, s)=>{
                    if (el.__autofocused) return;
                    el.__autofocused = true;
                    setTimeout(()=>el.node?.focus?.(), 50);
                },
                onInput: (e, el, s)=>{
                    s.root?.update({
                        libraryPickerQuery: e.target.value
                    });
                }
            }
        },
        Results: {
            flow: 'column',
            overflow: 'auto',
            flexGrow: '1',
            padding: 'V',
            onRender: (el, s)=>{
                if (el.__loadingInit) return;
                el.__loadingInit = true;
                (async ()=>{
                    try {
                        const list = await $a569955e4f91ff1b$export$3f49101abffe0b8c();
                        s.root?.update({
                            libraryPickerList: list || []
                        });
                    } catch  {}
                })();
            },
            List: {
                flow: 'column',
                gap: 'V',
                childrenAs: 'state',
                children: (el, s)=>{
                    const root = s.root;
                    if (!root?.libraryPickerFor) return [];
                    const isStandalone = root.libraryPickerFor === '__standalone__';
                    const q = (root.libraryPickerQuery || '').toLowerCase().trim();
                    const nodes = root.nodes || [];
                    const targetNode = isStandalone ? null : nodes.find((n)=>n.id === root.libraryPickerFor);
                    const meOwner = targetNode?.owner || root.slug;
                    const alreadyLibs = isStandalone ? new Set(nodes.map((n)=>n._id).filter(Boolean)) : new Set((root.connections || []).filter((c)=>c.to === root.libraryPickerFor).map((c)=>nodes.find((n)=>n.id === c.from)?._id).filter(Boolean));
                    const all = root.libraryPickerList || [];
                    const filtered = all.filter((p)=>{
                        if (!p?.key) return false;
                        if (targetNode && p._id === targetNode._id) return false;
                        if (alreadyLibs.has(p._id)) return false;
                        const isPublic = p.visibility === 'public';
                        const sameOwner = (p.owner?.slug || '') === meOwner;
                        if (!isPublic && !sameOwner) return false;
                        if (!q) return true;
                        const hay = `${p.key} ${p.name || ''} ${p.owner?.slug || ''}`.toLowerCase();
                        return hay.includes(q);
                    }).slice(0, 40).map((p)=>({
                            _id: p._id,
                            key: p.key,
                            name: p.name || p.key,
                            ownerSlug: p.owner?.slug || '',
                            visibility: p.visibility,
                            targetNodeId: root.libraryPickerFor
                        }));
                    return filtered;
                },
                childExtends: 'LibraryPickerItem'
            },
            Empty: {
                display: (el, s)=>{
                    const root = s.root;
                    if (!root?.libraryPickerFor) return 'none';
                    const list = root.libraryPickerList || [];
                    return list.length ? 'none' : 'block';
                },
                padding: 'A',
                text: "Loading\u2026",
                color: 'rgba(255,255,255,0.5)',
                fontSize: 'Z2'
            }
        }
    }
};
// ─── Featured template definitions ──────────────────────────────────────────
// Each entry defines page stubs passed as `pages` content when creating a
// project from a template. "blank" produces an empty project (no pages passed).
// The deck/landing stubs mirror the page-key structure of commercials/deck and
// commercials/landing so the newly created project is immediately navigable.
//
// `templateProjectKey` — when set, the server deep-clones pages/components/
// designSystem from that project's ProjectData instead of using the inline
// `pages` stub. Format: "owner/key" — e.g. "commercials/deck".
const $a569955e4f91ff1b$var$FEATURED_TEMPLATES = [
    {
        id: 'blank',
        label: 'Blank',
        hint: "Empty project \u2014 start from scratch.",
        emoji: "\u25FB",
        pages: null,
        projectType: 'project'
    },
    {
        id: 'deck',
        label: 'Deck',
        hint: '13-slide pitch deck sourced from commercials/deck.',
        emoji: "\uD83D\uDCD1",
        projectType: 'project',
        // templateProjectKey triggers server-side deep-clone from the live
        // commercials/deck project (pages, components, designSystem included).
        templateProjectKey: 'commercials/deck',
        // Fallback page stubs used when the server clone fails or the source
        // project is unavailable — keeps the create flow from silently breaking.
        pages: {
            index: {
                extends: 'slide0'
            },
            slide0: {
                tag: 'div',
                text: 'Slide 1'
            },
            slide1: {
                tag: 'div',
                text: 'Slide 2'
            },
            slide2: {
                tag: 'div',
                text: 'Slide 3'
            },
            slide3: {
                tag: 'div',
                text: 'Slide 4'
            },
            slide4: {
                tag: 'div',
                text: 'Slide 5'
            },
            slide5: {
                tag: 'div',
                text: 'Slide 6'
            },
            slide6: {
                tag: 'div',
                text: 'Slide 7'
            },
            slide7: {
                tag: 'div',
                text: 'Slide 8'
            },
            slide8: {
                tag: 'div',
                text: 'Slide 9'
            },
            slide9: {
                tag: 'div',
                text: 'Slide 10'
            },
            slide10: {
                tag: 'div',
                text: 'Slide 11'
            },
            slide11: {
                tag: 'div',
                text: 'Slide 12'
            },
            slide12: {
                tag: 'div',
                text: 'Slide 13'
            }
        }
    },
    {
        id: 'landing',
        label: 'Landing',
        hint: 'Marketing landing page sourced from commercials/landing.',
        emoji: "\uD83C\uDFE0",
        projectType: 'project',
        // templateProjectKey triggers server-side deep-clone from the live
        // commercials/landing project (all pages and design system included).
        templateProjectKey: 'commercials/landing',
        // Fallback page stubs used when the server clone fails or the source
        // project is unavailable.
        pages: {
            index: {
                extends: 'main'
            },
            main: {
                tag: 'div',
                text: 'Main'
            },
            pricing: {
                tag: 'div',
                text: 'Pricing'
            },
            signup: {
                tag: 'div',
                text: 'Sign up'
            },
            terms: {
                tag: 'div',
                text: 'Terms'
            },
            privacy: {
                tag: 'div',
                text: 'Privacy'
            }
        }
    },
    {
        id: 'app',
        label: 'App',
        hint: "Web app scaffold \u2014 dashboard, settings, auth.",
        emoji: "\uD83D\uDCF1",
        projectType: 'project',
        pages: {
            index: {
                extends: 'dashboard'
            },
            dashboard: {
                tag: 'div',
                text: 'Dashboard'
            },
            settings: {
                tag: 'div',
                text: 'Settings'
            },
            login: {
                tag: 'div',
                text: 'Login'
            }
        }
    },
    {
        id: 'library',
        label: 'Library',
        hint: 'Shared component library for your workspace.',
        emoji: "\uD83D\uDCDA",
        projectType: 'library',
        pages: null
    }
];
// ─── newProjectPicker state helpers ──────────────────────────────────────────
function $a569955e4f91ff1b$var$closeNewProjectPicker(root) {
    root?.update({
        newProjectPicker: {
            open: false
        }
    });
}
async function $a569955e4f91ff1b$var$submitNewProjectPicker(root, rootEl) {
    const p = root?.newProjectPicker;
    if (!p || p.creating) return;
    const name = (p.name || '').trim();
    if (!name) {
        root.update({
            newProjectPicker: {
                ...p,
                error: 'Please enter a project name.'
            }
        });
        return;
    }
    // Determine template source:
    //  - tab === 'library' → user picked a specific project key to scaffold from
    //  - tab === 'featured' → use FEATURED_TEMPLATES entry (may have templateProjectKey)
    const tab = p.tab || 'featured';
    const tpl = $a569955e4f91ff1b$var$FEATURED_TEMPLATES.find((t)=>t.id === p.templateId) || $a569955e4f91ff1b$var$FEATURED_TEMPLATES[0];
    // Library tab requires a project selection before submitting.
    if (tab === 'library' && !p.templateProject) {
        root.update({
            newProjectPicker: {
                ...p,
                error: 'Select a project to scaffold from.'
            }
        });
        return;
    }
    const slugRaw = String(name).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-+|-+$)/g, '').slice(0, 40) || `project-${Math.random().toString(36).slice(2, 6)}`;
    root.update({
        newProjectPicker: {
            ...p,
            creating: true,
            error: null
        }
    });
    const sdk = rootEl?.context?.methods?.sdk;
    if (!sdk?.createOrgProject) {
        root.update({
            newProjectPicker: {
                ...p,
                creating: false,
                error: 'SDK not available.'
            }
        });
        return;
    }
    // Resolve org id from slug caches (same logic as WorkspaceNavbar.orgIdFromCaches)
    const slug = root.slug || root.activeWorkspace || '';
    let orgId = null;
    try {
        const rawProjects = sessionStorage.getItem('__canvas_projects_v1');
        if (rawProjects) {
            const { data: data } = JSON.parse(rawProjects);
            for (const proj of data || []){
                const o = proj?.owner;
                if (o?.slug === slug && o?.id && o?.type === 'organization') {
                    orgId = o.id;
                    break;
                }
            }
        }
    } catch  {}
    if (!orgId) try {
        const rawOrgs = sessionStorage.getItem('__canvas_orgs_v1');
        if (rawOrgs) {
            const { data: data } = JSON.parse(rawOrgs);
            const match = (data || []).find((o)=>o?.slug === slug);
            if (match) orgId = match._id || match.id || null;
        }
    } catch  {}
    if (!orgId) {
        root.update({
            newProjectPicker: {
                ...p,
                creating: false,
                error: 'Could not resolve org for this workspace.'
            }
        });
        return;
    }
    try {
        const payload = {
            name: name,
            // Library tab always creates a project-type project regardless of which
            // featured template was last highlighted.
            projectType: tab === 'library' ? 'project' : tpl.projectType || 'project',
            slug: slugRaw
        };
        // Determine the templateProject key to send for server-side deep-clone:
        //  1. Library tab: user explicitly picked a project → p.templateProject (owner/key)
        //  2. Featured template with templateProjectKey → tpl.templateProjectKey
        //  3. Featured template without templateProjectKey → inline pages stub
        if (tab === 'library' && p.templateProject) // Server clones pages/components/designSystem from this project.
        payload.templateProject = p.templateProject;
        else if (tpl.templateProjectKey) {
            // Server clones from the canonical commercials template project.
            payload.templateProject = tpl.templateProjectKey;
            // Also include the page stubs as fallback — server ignores them when
            // templateProject clone succeeds.
            if (tpl.pages) payload.pages = tpl.pages;
        } else if (tpl.pages) // No server-side clone; use the inline page stubs as-is.
        payload.pages = tpl.pages;
        const project = await sdk.createOrgProject(orgId, payload);
        // Optimistically insert into the shared projects cache so the workspace
        // board and dashboard sidebar reflect the new project without a reload.
        $a569955e4f91ff1b$export$fdf2d64c97cb6b39(project);
        $a569955e4f91ff1b$var$closeNewProjectPicker(root);
        const owner = project?.owner?.slug || slug;
        const key = project?.key || slugRaw;
        const urls = (0, $3HmWC.buildProjectUrls)(owner, key);
        if (urls) rootEl.router(`/${urls.safeOwner}/${urls.safeKey}`, rootEl.getRoot());
    } catch (err) {
        root.update({
            newProjectPicker: {
                ...p,
                creating: false,
                error: err?.message || 'Create failed.'
            }
        });
    }
}
const $a569955e4f91ff1b$export$e064f253df89e441 = {
    tag: 'button',
    type: 'button',
    flow: 'column',
    gap: 'W',
    padding: 'X V',
    round: '10px',
    cursor: 'pointer',
    border: (el, s)=>(s.root?.newProjectPicker?.templateId || 'blank') === s._tplId ? '2px solid rgba(255,255,255,0.55)' : '2px solid rgba(255,255,255,0.07)',
    background: (el, s)=>(s.root?.newProjectPicker?.templateId || 'blank') === s._tplId ? 'rgba(255,255,255,0.08)' : 'rgba(255,255,255,0.02)',
    ':hover': {
        background: 'rgba(255,255,255,0.07)',
        border: '2px solid rgba(255,255,255,0.2)'
    },
    alignItems: 'center',
    textAlign: 'center',
    NpCardEmoji: {
        tag: 'span',
        text: (el, s)=>s._tplEmoji || "\u25FB",
        fontSize: 'B2',
        lineHeight: '1'
    },
    NpCardLabel: {
        tag: 'span',
        text: (el, s)=>s._tplLabel || '',
        fontSize: 'Z2',
        fontWeight: '600',
        color: 'white'
    },
    NpCardHint: {
        tag: 'span',
        text: (el, s)=>s._tplHint || '',
        fontSize: 'Z',
        color: 'rgba(255,255,255,0.45)',
        lineHeight: '1.4'
    },
    onClick: (e, el, s)=>{
        e.stopPropagation();
        const p = s.root?.newProjectPicker || {};
        s.root?.update({
            newProjectPicker: {
                ...p,
                templateId: s._tplId
            }
        });
    }
};
const $a569955e4f91ff1b$export$f6b2496a962587da = {
    tag: 'button',
    type: 'button',
    flow: 'row',
    gap: 'V',
    padding: 'V X',
    round: '6px',
    border: (el, s)=>{
        const sel = s.root?.newProjectPicker?.templateProject;
        const ownerKey = s._libOwner ? `${s._libOwner}/${s._libKey}` : s._libKey;
        return sel === ownerKey ? '1px solid rgba(255,255,255,0.4)' : '1px solid transparent';
    },
    background: (el, s)=>{
        const sel = s.root?.newProjectPicker?.templateProject;
        const ownerKey = s._libOwner ? `${s._libOwner}/${s._libKey}` : s._libKey;
        return sel === ownerKey ? 'rgba(255,255,255,0.1)' : 'transparent';
    },
    cursor: 'pointer',
    textAlign: 'left',
    ':hover': {
        background: 'rgba(255,255,255,0.06)'
    },
    alignItems: 'center',
    NpLibItemOwner: {
        tag: 'span',
        text: (el, s)=>s._libOwner ? `${s._libOwner}/` : '',
        fontSize: 'Z',
        color: 'rgba(255,255,255,0.45)',
        flexShrink: '0'
    },
    NpLibItemName: {
        tag: 'span',
        text: (el, s)=>s._libName || s._libKey || '',
        fontSize: 'Z2',
        fontWeight: '500',
        color: 'white',
        flexGrow: '1'
    },
    onClick: (e, el, s)=>{
        e.stopPropagation();
        const p = s.root?.newProjectPicker || {};
        const ownerKey = s._libOwner ? `${s._libOwner}/${s._libKey}` : s._libKey;
        s.root?.update({
            newProjectPicker: {
                ...p,
                templateProject: ownerKey,
                error: null
            }
        });
    }
};
const $a569955e4f91ff1b$export$4747f91bc4bb4046 = {
    display: (el, s)=>s.root?.newProjectPicker?.open ? 'flex' : 'none',
    position: 'fixed',
    inset: '0',
    background: 'rgba(0,0,0,0.55)',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'B',
    zIndex: 220,
    style: {
        backdropFilter: 'blur(4px)'
    },
    onMousedown: (e, el, s)=>{
        if (e.target === el.node) $a569955e4f91ff1b$var$closeNewProjectPicker(s.root);
    },
    NpPanel: {
        width: '560px',
        maxWidth: '100%',
        maxHeight: 'min(90vh, 700px)',
        background: 'rgba(18,20,26,0.99)',
        border: '1px solid rgba(255,255,255,0.08)',
        round: '14px',
        boxShadow: '0 30px 80px rgba(0,0,0,0.65)',
        flow: 'column',
        overflow: 'hidden',
        NpHeader: {
            padding: 'A B',
            borderBottom: '1px solid rgba(255,255,255,0.06)',
            flow: 'row',
            align: 'center space-between',
            NpTitle: {
                tag: 'div',
                text: 'New project',
                color: 'white',
                fontSize: 'A',
                fontWeight: '600'
            },
            NpClose: {
                tag: 'button',
                type: 'button',
                text: "\xd7",
                'aria-label': 'Close new-project picker',
                padding: '0 W',
                fontSize: 'B',
                background: 'transparent',
                border: '0',
                color: 'rgba(255,255,255,0.7)',
                cursor: 'pointer',
                ':hover': {
                    color: 'white'
                },
                onClick: (e, el, s)=>{
                    e.stopPropagation();
                    $a569955e4f91ff1b$var$closeNewProjectPicker(s.root);
                }
            }
        },
        NpNameRow: {
            padding: 'V B',
            paddingTop: 'X',
            flow: 'column',
            gap: 'W',
            NpNameLabel: {
                tag: 'label',
                text: 'Project name',
                fontSize: 'Z',
                fontWeight: '600',
                color: 'rgba(255,255,255,0.7)',
                textTransform: 'uppercase',
                letterSpacing: '0.06em'
            },
            NpNameInput: {
                tag: 'input',
                type: 'text',
                placeholder: "My project\u2026",
                padding: 'V X',
                round: '8px',
                border: '1px solid rgba(255,255,255,0.12)',
                background: 'rgba(0,0,0,0.4)',
                color: 'white',
                fontSize: 'Z2',
                onRender: (el, s)=>{
                    if (el.__npFocused) return;
                    el.__npFocused = true;
                    setTimeout(()=>el.node?.focus?.(), 60);
                },
                onInput: (e, el, s)=>{
                    const p = s.root?.newProjectPicker || {};
                    s.root?.update({
                        newProjectPicker: {
                            ...p,
                            name: e.target.value,
                            error: null
                        }
                    });
                },
                onKeydown: (e, el, s)=>{
                    if (e.key === 'Enter') $a569955e4f91ff1b$var$submitNewProjectPicker(s.root, el.getRoot());
                    if (e.key === 'Escape') $a569955e4f91ff1b$var$closeNewProjectPicker(s.root);
                }
            }
        },
        NpTabs: {
            flow: 'row',
            borderBottom: '1px solid rgba(255,255,255,0.06)',
            padding: '0 B',
            gap: '0',
            NpTabFeatured: {
                tag: 'button',
                type: 'button',
                text: 'Featured templates',
                padding: 'V W',
                fontSize: 'Z2',
                fontWeight: '500',
                background: 'transparent',
                border: '0',
                borderBottom: (el, s)=>(s.root?.newProjectPicker?.tab || 'featured') === 'featured' ? '2px solid white' : '2px solid transparent',
                color: (el, s)=>(s.root?.newProjectPicker?.tab || 'featured') === 'featured' ? 'white' : 'rgba(255,255,255,0.45)',
                cursor: 'pointer',
                marginBottom: '-1px',
                onClick: (e, el, s)=>{
                    const p = s.root?.newProjectPicker || {};
                    // Clear templateProject when switching away from library tab.
                    s.root?.update({
                        newProjectPicker: {
                            ...p,
                            tab: 'featured',
                            templateProject: null,
                            error: null
                        }
                    });
                }
            },
            NpTabLibrary: {
                tag: 'button',
                type: 'button',
                text: 'From library',
                padding: 'V W',
                fontSize: 'Z2',
                fontWeight: '500',
                background: 'transparent',
                border: '0',
                borderBottom: (el, s)=>s.root?.newProjectPicker?.tab === 'library' ? '2px solid white' : '2px solid transparent',
                color: (el, s)=>s.root?.newProjectPicker?.tab === 'library' ? 'white' : 'rgba(255,255,255,0.45)',
                cursor: 'pointer',
                marginBottom: '-1px',
                onClick: (e, el, s)=>{
                    const p = s.root?.newProjectPicker || {};
                    s.root?.update({
                        newProjectPicker: {
                            ...p,
                            tab: 'library'
                        }
                    });
                    // Trigger library list load on tab activation. onRender on NpLibSearch
                    // fires only once at mount and may not fire if the element was mounted
                    // while the modal was closed or the tab was inactive. Loading here
                    // guarantees the list is fetched whenever the user switches to this tab.
                    if (!p._libList || !p._libList.length) (async ()=>{
                        try {
                            const list = await $a569955e4f91ff1b$export$3f49101abffe0b8c();
                            const fresh = s.root?.newProjectPicker || {};
                            s.root?.update({
                                newProjectPicker: {
                                    ...fresh,
                                    _libList: list || []
                                }
                            });
                        } catch  {}
                    })();
                }
            }
        },
        // Featured templates grid — 3 columns, spans the middle body
        NpFeaturedGrid: {
            display: (el, s)=>(s.root?.newProjectPicker?.tab || 'featured') === 'featured' ? 'grid' : 'none',
            style: {
                gridTemplateColumns: 'repeat(3, 1fr)'
            },
            gap: 'V',
            padding: 'X B',
            overflow: 'auto',
            children: ()=>$a569955e4f91ff1b$var$FEATURED_TEMPLATES.map((tpl)=>({
                        _tplId: tpl.id,
                        _tplLabel: tpl.label,
                        _tplHint: tpl.hint,
                        _tplEmoji: tpl.emoji
                    })),
            childrenAs: 'state',
            childExtends: 'NpTemplateCard'
        },
        // Library tab — inline project search + selection to scaffold from.
        // Selecting a project sets newProjectPicker.templateProject = "owner/key".
        // Submit passes templateProject to the server for deep-clone.
        NpLibraryTab: {
            display: (el, s)=>s.root?.newProjectPicker?.tab === 'library' ? 'flex' : 'none',
            flow: 'column',
            gap: 'V',
            padding: 'X B',
            flexGrow: '1',
            minHeight: '0',
            NpLibHint: {
                tag: 'div',
                text: "Choose any project to scaffold from \u2014 its pages, components, and design system will be copied into the new project.",
                fontSize: 'Z2',
                color: 'rgba(255,255,255,0.55)',
                lineHeight: '1.5'
            },
            // Selected project badge — shows current selection with a clear button.
            NpLibSelected: {
                display: (el, s)=>s.root?.newProjectPicker?.templateProject ? 'flex' : 'none',
                flow: 'row',
                gap: 'V',
                align: 'center',
                padding: 'V X',
                round: '8px',
                background: 'rgba(255,255,255,0.08)',
                border: '1px solid rgba(255,255,255,0.2)',
                NpLibSelectedLabel: {
                    tag: 'span',
                    text: (el, s)=>{
                        const key = s.root?.newProjectPicker?.templateProject || '';
                        return `Template: ${key}`;
                    },
                    fontSize: 'Z2',
                    color: 'white',
                    flexGrow: '1'
                },
                NpLibSelectedClear: {
                    tag: 'button',
                    type: 'button',
                    text: "\xd7",
                    padding: '0 W',
                    fontSize: 'A',
                    background: 'transparent',
                    border: '0',
                    color: 'rgba(255,255,255,0.55)',
                    cursor: 'pointer',
                    ':hover': {
                        color: 'white'
                    },
                    onClick: (e, el, s)=>{
                        e.stopPropagation();
                        const p = s.root?.newProjectPicker || {};
                        s.root?.update({
                            newProjectPicker: {
                                ...p,
                                templateProject: null,
                                error: null
                            }
                        });
                    }
                }
            },
            // Search input — filters the project list.
            NpLibSearch: {
                tag: 'input',
                type: 'search',
                placeholder: "Search projects\u2026",
                padding: 'V X',
                round: '8px',
                border: '1px solid rgba(255,255,255,0.12)',
                background: 'rgba(0,0,0,0.4)',
                color: 'white',
                fontSize: 'Z2',
                onRender: (el, s)=>{
                    // Guard: skip if already loaded a non-empty list.
                    // Allow a retry if __npLibLoaded was set but the list came back empty
                    // (e.g. the fetch resolved before the SDK was ready).
                    const p = s.root?.newProjectPicker || {};
                    if (el.__npLibLoaded && p._libList && p._libList.length) return;
                    el.__npLibLoaded = true;
                    (async ()=>{
                        try {
                            const list = await $a569955e4f91ff1b$export$3f49101abffe0b8c();
                            const fresh = s.root?.newProjectPicker || {};
                            s.root?.update({
                                newProjectPicker: {
                                    ...fresh,
                                    _libList: list || []
                                }
                            });
                        } catch  {}
                    })();
                },
                onInput: (e, el, s)=>{
                    const p = s.root?.newProjectPicker || {};
                    s.root?.update({
                        newProjectPicker: {
                            ...p,
                            _libQuery: e.target.value,
                            error: null
                        }
                    });
                }
            },
            // Scrollable results list.
            NpLibResults: {
                flow: 'column',
                gap: '2px',
                overflow: 'auto',
                flexGrow: '1',
                minHeight: '120px',
                maxHeight: '260px',
                NpLibLoading: {
                    display: (el, s)=>{
                        const p = s.root?.newProjectPicker || {};
                        return !p._libList || !p._libList.length ? 'block' : 'none';
                    },
                    padding: 'X',
                    text: "Loading\u2026",
                    color: 'rgba(255,255,255,0.4)',
                    fontSize: 'Z2'
                },
                NpLibList: {
                    flow: 'column',
                    gap: '2px',
                    childrenAs: 'state',
                    children: (el, s)=>{
                        const p = s.root?.newProjectPicker || {};
                        const q = (p._libQuery || '').toLowerCase().trim();
                        const all = p._libList || [];
                        return all.filter((proj)=>{
                            if (!proj?.key) return false;
                            if (!q) return true;
                            const hay = `${proj.key} ${proj.name || ''} ${proj.owner?.slug || ''}`.toLowerCase();
                            return hay.includes(q);
                        }).slice(0, 50).map((proj)=>({
                                _libId: proj._id,
                                _libKey: proj.key,
                                _libName: proj.name || proj.key,
                                _libOwner: proj.owner?.slug || ''
                            }));
                    },
                    childExtends: 'NpLibItem'
                }
            }
        },
        NpFooter: {
            padding: 'V B',
            borderTop: '1px solid rgba(255,255,255,0.06)',
            flow: 'row',
            align: 'center space-between',
            gap: 'V',
            NpError: {
                tag: 'div',
                text: (el, s)=>s.root?.newProjectPicker?.error || '',
                fontSize: 'Z',
                color: '#ff7a7a',
                flexGrow: '1'
            },
            NpActions: {
                flow: 'row',
                gap: 'V',
                NpCancel: {
                    tag: 'button',
                    type: 'button',
                    text: 'Cancel',
                    padding: 'V X',
                    fontSize: 'Z2',
                    round: '8px',
                    cursor: 'pointer',
                    border: '1px solid rgba(255,255,255,0.12)',
                    background: 'transparent',
                    color: 'rgba(255,255,255,0.8)',
                    ':hover': {
                        background: 'rgba(255,255,255,0.06)'
                    },
                    onClick: (e, el, s)=>{
                        e.stopPropagation();
                        $a569955e4f91ff1b$var$closeNewProjectPicker(s.root);
                    }
                },
                NpCreate: {
                    tag: 'button',
                    type: 'button',
                    text: (el, s)=>{
                        const p = s.root?.newProjectPicker || {};
                        if (p.creating) return "Creating\u2026";
                        if (p.tab === 'library' && !p.templateProject) return 'Pick a template above';
                        return 'Create project';
                    },
                    disabled: (el, s)=>{
                        const p = s.root?.newProjectPicker || {};
                        if (p.creating) return true;
                        // Library tab requires a project selection before enabling create.
                        if (p.tab === 'library' && !p.templateProject) return true;
                        return false;
                    },
                    padding: 'V X',
                    fontSize: 'Z2',
                    round: '8px',
                    cursor: 'pointer',
                    border: '1px solid rgba(255,255,255,0.12)',
                    background: 'rgba(255,255,255,0.16)',
                    color: 'white',
                    ':hover': {
                        background: 'rgba(255,255,255,0.22)'
                    },
                    onClick: (e, el, s)=>{
                        e.stopPropagation();
                        $a569955e4f91ff1b$var$submitNewProjectPicker(s.root, el.getRoot());
                    }
                }
            }
        }
    }
};
const $a569955e4f91ff1b$export$958e6f7ef093b4a6 = {
    tag: 'main',
    id: 'main-content',
    // Default is fixed-to-viewport for the standalone `/workspaces/<slug>`
    // route. Dashboard's `WorkspaceEmbed` slot overrides `position: relative`
    // so the embedded workspace is constrained to the AppMain content area.
    metadata: (el, s)=>{
        const root = s.root || s;
        const slug = root.slug || root.activeWorkspace || '';
        const org = (root.orgs || []).find((o)=>o.slug === slug);
        const name = org?.name || slug || 'Workspace';
        return {
            title: name + " \xb7 Workspaces / Symbols.app"
        };
    },
    position: 'fixed',
    inset: '0',
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    background: '#14161b',
    color: 'white',
    fontFamily: 'system-ui',
    onRender: (el, s)=>{
        if (el.__wsLoaded) return;
        el.__wsLoaded = true;
        const root = s.root || s;
        // On re-entry (e.g. navigating /dashboard → /workspaces → /dashboard),
        // the element is a fresh instance but root already holds valid data from
        // the previous visit. Only seed keys that are truly absent — avoid a
        // blanket root.update() that resets every reactive consumer (nodes,
        // integrations, positions) and triggers a full-subtree re-mount.
        // Transient UI state (hover, linking, drag) is always cleared regardless.
        const patch = {};
        if (!root.slug) patch.slug = '';
        if (!root.nodes) patch.nodes = [];
        if (!root.integrations) patch.integrations = [];
        if (!root._installables) patch._installables = [];
        if (!root.positions) patch.positions = {};
        if (!root.connections) patch.connections = [];
        if (!root.groupMap) patch.groupMap = {};
        if (!root.groupNames) patch.groupNames = {};
        if (!root.dragMode) patch.dragMode = 'grid';
        // Org rail is collapsed by default on first load. The user can toggle it;
        // the value persists in root state for the session.
        if (root.orgRailOpen === undefined) patch.orgRailOpen = false;
        // Always reset transient UI state so stale drag/hover/link overlays
        // don't persist across route transitions.
        patch.hoverGroup = null;
        patch.hoverNode = null;
        patch.linking = null;
        patch.draggingId = null;
        // Only set loading=true when we have no nodes yet — avoids tearing down
        // the already-rendered board on re-entry while the fresh fetch runs.
        if (!root.nodes || root.nodes.length === 0) patch.loading = true;
        patch.error = null;
        if (Object.keys(patch).length) root.update(patch);
        $a569955e4f91ff1b$var$WORKSPACE_ROOT = root;
        // URL wins over stale `activeWorkspace` state when the user
        // navigated directly to /workspaces/{slug} (e.g. from history back,
        // URL bar, deep-link). `ownerSlugFromUrl` only returns a slug when
        // the path is actually /workspaces/{x}, so falling through to
        // activeWorkspace is still correct when embedded.
        el._loadedSlug = $a569955e4f91ff1b$var$ownerSlugFromUrl() || root.activeWorkspace || '';
        if (el._loadedSlug) $a569955e4f91ff1b$export$fae8f4ef154badfa(root, el._loadedSlug);
        // Close any open project tile menu when clicking outside it.
        // The Menu component stops propagation on its own mousedown so this
        // only fires for clicks that land outside an open menu.
        const closeMenuOnOutsideClick = (ev)=>{
            const r = $a569955e4f91ff1b$var$WORKSPACE_ROOT;
            if (!r?.openMenuId) return;
            // The Menu element is portaled into document.body so it lives outside
            // the [data-node-id] tile. Allow clicks landing inside a menu/dialog
            // through to their own handlers (item buttons stop propagation and
            // close the menu themselves). data-project-menu is the project
            // context menu's marker; role=menu/dialog covers other surfaces.
            if (ev.target?.closest?.('[data-project-menu], [role="menu"], [role="dialog"]')) return;
            // If the click is inside a [data-node-id] element that matches the
            // currently open menu, let the node's own handlers manage state.
            const nodeEl = ev.target?.closest?.('[data-node-id]');
            if (nodeEl && nodeEl.dataset.nodeId === r.openMenuId) return;
            r.update({
                openMenuId: null,
                _ctxMenuTick: Date.now()
            });
        };
        if (!window.__wsMenuCloseHooked) {
            window.__wsMenuCloseHooked = true;
            document.addEventListener('pointerdown', closeMenuOnOutsideClick, {
                capture: true
            });
        }
        // Defer panzoom init until the Board + Dots nodes have mounted. On
        // first onRender of a page with reactive children, they might not
        // exist yet (race between page mount and Nodes/Connections mount).
        const initPanzoom = ()=>{
            const scene = el.Board?.node;
            if (!scene) {
                requestAnimationFrame(initPanzoom);
                return;
            }
            // Guard against panzoom double-attach if onRender fires multiple
            // times for the same scene (smbls re-renders on reactive state
            // changes); a second panzoom() on the same element would leak event
            // listeners and fight the first instance for the transform.
            if (scene.__panzoomAttached) return;
            scene.__panzoomAttached = true;
            const BASE = 24;
            const dots = el.Dots?.node;
            const updateDots = ()=>{
                if (!dots) return;
                const { x: x, y: y, scale: scale } = pz.getTransform();
                const size = scale * BASE;
                dots.style.backgroundSize = size + 'px ' + size + 'px';
                dots.style.backgroundPosition = x % size + 'px ' + y % size + 'px';
            };
            const pz = (0, (/*@__PURE__*/$parcel$interopDefault($kN9I2)))(scene, {
                minZoom: 0.2,
                maxZoom: 2,
                zoomSpeed: 0.8,
                zoomDoubleClickSpeed: 1,
                beforeMouseDown: (e)=>!!e.target.closest?.('[data-node-id],[data-link-handle],[data-group-id]'),
                beforeWheel: (e)=>{
                    const isPinch = e.metaKey || e.ctrlKey;
                    if (isPinch) return false;
                    e.preventDefault();
                    const { x: x, y: y } = pz.getTransform();
                    pz.moveTo(x - e.deltaX, y - e.deltaY);
                    return true;
                }
            });
            $a569955e4f91ff1b$var$PZ = pz;
            $a569955e4f91ff1b$var$BOARD_EL = scene;
            $a569955e4f91ff1b$var$CONNECTIONS_NODE = el.Board?.Connections?.node || null;
            // Shared ZoomInNavbar reads `globalScope.panzoomInstance` +
            // `globalScope.positions` for its zoom buttons; without this
            // mirror, the Zoombar sits inert on the workspace page.
            const gs = el.context?.globalScope || (window.__canvasGlobalScope = window.__canvasGlobalScope || {});
            window.__canvasGlobalScope = gs;
            gs.panzoomInstance = pz;
            gs.positions = gs.positions || {
                x: 0,
                y: 0
            };
            const syncGsPos = ()=>{
                const t = pz.getTransform();
                gs.positions.x = t.x;
                gs.positions.y = t.y;
                $a569955e4f91ff1b$var$writeZoomLabel(pz);
            };
            syncGsPos();
            pz.on('transform', syncGsPos);
            // rAF is paused in background tabs but setInterval still fires —
            // guarantees the label catches up when the tab returns to fg.
            if (!window.__wsZoomInterval) window.__wsZoomInterval = setInterval(()=>{
                const p = window.__canvasGlobalScope?.panzoomInstance;
                if (p) $a569955e4f91ff1b$var$writeZoomLabel(p);
            }, 250);
            if ($a569955e4f91ff1b$var$CONNECTIONS_NODE) $a569955e4f91ff1b$var$CONNECTIONS_NODE.addEventListener('click', (ev)=>{
                const path = ev.target.closest?.('[data-connection-id]');
                if (!path) return;
                const cid = path.dataset.connectionId;
                const current = $a569955e4f91ff1b$var$WORKSPACE_ROOT?.connections || [];
                const removed = current.find((c)=>c.id === cid);
                $a569955e4f91ff1b$var$WORKSPACE_ROOT?.update({
                    connections: current.filter((c)=>c.id !== cid)
                });
                $a569955e4f91ff1b$var$redrawConnections();
                if (removed && $a569955e4f91ff1b$var$WORKSPACE_ROOT) {
                    if (removed.kind === 'integration') {
                        const integrations = $a569955e4f91ff1b$var$WORKSPACE_ROOT.integrations || [];
                        const intSide = integrations.find((i)=>i.id === removed.from) ? removed.from : integrations.find((i)=>i.id === removed.to) ? removed.to : null;
                        if (intSide) $a569955e4f91ff1b$var$persistIntegrationScope($a569955e4f91ff1b$var$WORKSPACE_ROOT, intSide, 'org', null);
                    } else $a569955e4f91ff1b$var$persistSharedLibraries($a569955e4f91ff1b$var$WORKSPACE_ROOT, [
                        removed.to
                    ]);
                }
            });
            pz.on('transform', updateDots);
            // Re-render the open project context menu on every transform tick
            // so it follows its anchor tile during pan/zoom. Bumping a tick
            // invalidates the menu's reactive top/left factories without
            // touching any other root state. Only writes when a menu is open
            // — pure pan/zoom with no menu open is free.
            pz.on('transform', ()=>{
                const r = $a569955e4f91ff1b$var$WORKSPACE_ROOT;
                if (r?.openMenuId) r.update({
                    _ctxMenuTick: Date.now()
                });
            });
            // Seed both panzoom's internal state AND the Board's DOMQL style so
            // the first paint is already at scale 0.9 / offset 120,120 — the
            // library's rAF loop otherwise defers the DOM transform write
            // until the user interacts, leaving the board at identity.
            pz.zoomAbs(0, 0, 0.9);
            pz.moveTo(120, 120);
            // DOMQL v3.14's CSS_PROPS registry doesn't include `transform` /
            // `transformOrigin`, so seed them via `style:` to reach the DOM.
            el.Board?.update({
                style: {
                    transformOrigin: '0 0',
                    transform: 'matrix(0.9, 0, 0, 0.9, 120, 120)'
                }
            });
            updateDots();
        };
        initPanzoom();
    },
    onRemove: ()=>{
        $a569955e4f91ff1b$var$WORKSPACE_ROOT = null;
        $a569955e4f91ff1b$var$DRAG_DOM_NODES.clear();
        if ($a569955e4f91ff1b$var$DRAG_RAF) {
            cancelAnimationFrame($a569955e4f91ff1b$var$DRAG_RAF);
            $a569955e4f91ff1b$var$DRAG_RAF = 0;
        }
        if (window.__wsZoomInterval) {
            clearInterval(window.__wsZoomInterval);
            window.__wsZoomInterval = null;
        }
    },
    onUpdate: (el, s)=>{
        const root = s.root || s;
        const slug = $a569955e4f91ff1b$var$ownerSlugFromUrl() || root.activeWorkspace;
        if (slug && slug !== el._loadedSlug) {
            el._loadedSlug = slug;
            $a569955e4f91ff1b$export$fae8f4ef154badfa(root, slug);
        }
    },
    Dots: {
        position: 'absolute',
        inset: '0',
        pointerEvents: 'none',
        style: {
            backgroundImage: 'radial-gradient(circle, rgba(255,255,255,0.08) 1px, transparent 1px)',
            backgroundSize: '24px 24px'
        }
    },
    // Slim status pill at bottom-left. Canvas actions (auto layout, drag
    // mode) moved into WorkspaceSettingsModal; creation actions moved into
    // WorkspaceNavbar's + menu.
    WorkspaceViews: {
        position: 'absolute',
        bottom: 'X2',
        left: 'X2',
        zIndex: 10,
        padding: 'Y A',
        round: 'C1',
        theme: 'canvas-card-glass',
        flow: 'x',
        gap: 'V',
        align: 'center',
        pointerEvents: 'auto',
        Title: {
            tag: 'span',
            text: (el, s)=>s.root?.slug || 'Workspace',
            fontSize: 'A',
            fontWeight: '600'
        },
        Subtitle: {
            tag: 'span',
            text: (el, s)=>{
                const root = s.root;
                if (root?.loading) return "loading\u2026";
                if (root?.error) return 'error: ' + root.error;
                const n = root?.nodes?.length || 0;
                const intCount = (root?.integrations || []).length;
                const intStr = intCount ? ` \xb7 ${intCount} integration${intCount === 1 ? '' : 's'}` : '';
                return `\xb7 ${n} project${n === 1 ? '' : 's'}${intStr}`;
            },
            fontSize: 'Z2',
            color: 'rgba(255,255,255,0.6)'
        }
    },
    // Floating create-menu navbar. Shared component — see
    // components/LabsNavbar.js. Auto-extended by key name.
    LabsNavbar: {},
    // OrgIntegrationRail intentionally NOT mounted on the studios canvas — it
    // would overlay the panzoom board and duplicate functionality that the
    // on-canvas InstallableNodes already provide (org-scoped integrations
    // can be dragged onto the board as positioned tiles). Component still
    // exported above for use elsewhere (settings, admin pages, etc).
    // Removed from studios canvas per Nika 2026-04-26.
    OrgIntegrationRail: null,
    // MCP connector rail — compact chip strip below the integration rail
    // (zIndex 19). Surfaces all MCP connectors scoped to this workspace.
    // Auto-extended by key name from MCPConnectorRail below.
    MCPConnectorRail: {},
    SettingsModal: {},
    // Project lifecycle modals — triggered from ProjectNode Menu items.
    // Auto-extended by key name → picks up the exported modal components above.
    ProjectDeleteConfirmModal: {},
    ProjectDuplicateModal: {},
    ProjectEditMetadataModal: {},
    CommandBar: null,
    Zoombar: {
        fontSize: 'Z1',
        position: 'absolute',
        bottom: 'X2',
        right: 'X2',
        top: 'auto',
        width: 'auto',
        pointerEvents: 'auto',
        zIndex: 10,
        NavbarButtonSet: {
            // Override the default /settings modal handoff — we open our own
            // unified SettingsModal instead.
            Settings: {
                onClick: (ev, el, s)=>{
                    ev.stopPropagation();
                    s.root?.update({
                        settingsOpen: true,
                        settingsTab: s.root?.settingsTab || 'workspace'
                    });
                }
            }
        }
    },
    CanvasPromptTextarea: {
        PromptButtons: {
            InspectBtn: null
        }
    },
    // Integrations now render on the canvas as draggable nodes, so the
    // side shelf is retired. Keep the key with `null` so the parent
    // component tree explicitly opts out of the legacy shelf slot.
    IntegrationShelf: null,
    ImportLibraryButton: null,
    // Auto-extends IntegrationPickerOverlay (exported above). The picker
    // component is now surface-agnostic — mounted here AND in CanvasEditor.
    IntegrationPicker: {
        extends: 'IntegrationPickerOverlay'
    },
    // Auto-extends LibraryPickerOverlay (exported above). Surface-agnostic
    // picker — mounted here AND in CanvasEditor.
    LibraryPicker: {
        extends: 'LibraryPickerOverlay'
    },
    // Auto-extends NewProjectPickerOverlay (exported above). Template-based
    // project creation modal opened from WorkspaceNavbar "New project" item.
    NewProjectPicker: {
        extends: 'NewProjectPickerOverlay'
    },
    Board: {
        position: 'absolute',
        top: '0',
        left: '0',
        width: $a569955e4f91ff1b$var$BOARD_W + 'px',
        height: $a569955e4f91ff1b$var$BOARD_H + 'px',
        Connections: {
            tag: 'div',
            position: 'absolute',
            inset: '0',
            pointerEvents: 'none',
            zIndex: 5,
            html: (el, s)=>$a569955e4f91ff1b$var$buildConnectionsSVG(s.root)
        },
        ...$a569955e4f91ff1b$var$groupFrameChildren,
        Nodes: {
            // Each child gets an explicit `key: n.id` so the v3.14 reconciler
            // uses stable project-key identity rather than positional index.
            // This means a workspace switch correctly removes orphan nodes
            // instead of reusing positional slots. `pos` is NOT inlined here
            // (the old approach that caused re-render storms): ProjectNode reads
            // position directly from `s.root.positions[s.id]` using v3.14 reactive
            // state. The children factory only re-runs when `nodes` changes
            // (workspace switch / load), not on every drag position update.
            // Guard `s` itself — v3.14 fires the effect once with undefined state
            // before the signal hydrates, which would throw on `s.root`.
            children: (el, s)=>{
                return (s?.root?.nodes || []).map((n)=>({
                        ...n,
                        key: n.id
                    }));
            },
            childrenAs: 'state',
            childExtends: 'ProjectNode'
        },
        IntegrationNodes: {
            // Project-scoped integrations rendered as canvas tiles (anchored below
            // their owning project card). Workspace/org integrations surface in the
            // overlay rails (WorkspaceIntegrationRail / OrgIntegrationRail) above.
            children: (el, s)=>{
                const positions = s?.root?.positions || {};
                return (s?.root?.integrations || []).filter((i)=>i.scope === 'project' && positions[i.id]).map((i)=>({
                        ...i,
                        key: i.id
                    }));
            },
            childrenAs: 'state',
            childExtends: 'IntegrationNode'
        },
        // Phase 5 — ALL workspace-scoped installables as positioned canvas tiles.
        // Covers every domain: integrations (non-project-scoped), MCP connectors,
        // libraries, plugins. Click → openInstallableModal (Phase 4).
        // Tiles use the generic InstallableNode which branches on `domain`.
        InstallableNodes: {
            children: (el, s)=>{
                const positions = s?.root?.positions || {};
                // De-dupe: project-scope integrations are already rendered by
                // IntegrationNodes above using the dedicated IntegrationNode chrome.
                // Without this exclusion every project-scope integration renders
                // twice (once 315×65 IntegrationNode, once 180×72 InstallableNode)
                // stacked at the same position. Exclude them here.
                const renderedIntegrationIds = new Set((s?.root?.integrations || []).filter((i)=>i.scope === 'project' && positions[i.id]).map((i)=>i.id));
                return (s?.root?._installables || []).filter((i)=>positions[i.id] && !renderedIntegrationIds.has(i.id)).map((i)=>({
                        ...i,
                        key: i.id
                    }));
            },
            childrenAs: 'state',
            childExtends: 'InstallableNode'
        },
        // Empty-canvas tutorial — visible when no nodes and no installables.
        LabEmptyTutorial: {}
    }
};

});
parcelRegister("kN9I2", function(module, exports) {
'use strict';

var $krYUM = parcelRequire("krYUM");

var $eKEF7 = parcelRequire("eKEF7");

var $hG6VV = parcelRequire("hG6VV");

var $n9wvq = parcelRequire("n9wvq");

var $l1vPM = parcelRequire("l1vPM");
var $f22fea531ee465de$var$domTextSelectionInterceptor = $l1vPM();
var $f22fea531ee465de$var$fakeTextSelectorInterceptor = $l1vPM(true);

var $dEYr4 = parcelRequire("dEYr4");

var $4kQhd = parcelRequire("4kQhd");

var $53cWy = parcelRequire("53cWy");
var $f22fea531ee465de$var$defaultZoomSpeed = 1;
var $f22fea531ee465de$var$defaultDoubleTapZoomSpeed = 1.75;
var $f22fea531ee465de$var$doubleTapSpeedInMS = 300;
var $f22fea531ee465de$var$clickEventTimeInMS = 200;
module.exports = $f22fea531ee465de$var$createPanZoom;
/**
 * Creates a new instance of panzoom, so that an object can be panned and zoomed
 *
 * @param {DOMElement} domElement where panzoom should be attached.
 * @param {Object} options that configure behavior.
 */ function $f22fea531ee465de$var$createPanZoom(domElement, options) {
    options = options || {};
    var panController = options.controller;
    if (!panController) {
        if ($4kQhd.canAttach(domElement)) panController = $4kQhd(domElement, options);
        else if ($53cWy.canAttach(domElement)) panController = $53cWy(domElement, options);
    }
    if (!panController) throw new Error('Cannot create panzoom for the current type of dom element');
    var owner = panController.getOwner();
    // just to avoid GC pressure, every time we do intermediate transform
    // we return this object. For internal use only. Never give it back to the consumer of this library
    var storedCTMResult = {
        x: 0,
        y: 0
    };
    var isDirty = false;
    var transform = new $dEYr4();
    if (panController.initTransform) panController.initTransform(transform);
    var filterKey = typeof options.filterKey === 'function' ? options.filterKey : $f22fea531ee465de$var$noop;
    // TODO: likely need to unite pinchSpeed with zoomSpeed
    var pinchSpeed = typeof options.pinchSpeed === 'number' ? options.pinchSpeed : 1;
    var bounds = options.bounds;
    var maxZoom = typeof options.maxZoom === 'number' ? options.maxZoom : Number.POSITIVE_INFINITY;
    var minZoom = typeof options.minZoom === 'number' ? options.minZoom : 0;
    var boundsPadding = typeof options.boundsPadding === 'number' ? options.boundsPadding : 0.05;
    var zoomDoubleClickSpeed = typeof options.zoomDoubleClickSpeed === 'number' ? options.zoomDoubleClickSpeed : $f22fea531ee465de$var$defaultDoubleTapZoomSpeed;
    var beforeWheel = options.beforeWheel || $f22fea531ee465de$var$noop;
    var beforeMouseDown = options.beforeMouseDown || $f22fea531ee465de$var$noop;
    var speed = typeof options.zoomSpeed === 'number' ? options.zoomSpeed : $f22fea531ee465de$var$defaultZoomSpeed;
    var transformOrigin = $f22fea531ee465de$var$parseTransformOrigin(options.transformOrigin);
    var textSelection = options.enableTextSelection ? $f22fea531ee465de$var$fakeTextSelectorInterceptor : $f22fea531ee465de$var$domTextSelectionInterceptor;
    $f22fea531ee465de$var$validateBounds(bounds);
    if (options.autocenter) autocenter();
    var frameAnimation;
    var lastTouchEndTime = 0;
    var lastTouchStartTime = 0;
    var pendingClickEventTimeout = 0;
    var lastMouseDownedEvent = null;
    var lastMouseDownTime = new Date();
    var lastSingleFingerOffset;
    var touchInProgress = false;
    // We only need to fire panstart when actual move happens
    var panstartFired = false;
    // cache mouse coordinates here
    var mouseX;
    var mouseY;
    // Where the first click has happened, so that we can differentiate
    // between pan and click
    var clickX;
    var clickY;
    var pinchZoomLength;
    var smoothScroll;
    if ('smoothScroll' in options && !options.smoothScroll) // If user explicitly asked us not to use smooth scrolling, we obey
    smoothScroll = $f22fea531ee465de$var$rigidScroll();
    else // otherwise we use forward smoothScroll settings to kinetic API
    // which makes scroll smoothing.
    smoothScroll = $n9wvq(getPoint, scroll, options.smoothScroll);
    var moveByAnimation;
    var zoomToAnimation;
    var multiTouch;
    var paused = false;
    listenForEvents();
    var api = {
        dispose: dispose,
        moveBy: internalMoveBy,
        moveTo: moveTo,
        smoothMoveTo: smoothMoveTo,
        centerOn: centerOn,
        zoomTo: publicZoomTo,
        zoomAbs: zoomAbs,
        smoothZoom: smoothZoom,
        smoothZoomAbs: smoothZoomAbs,
        showRectangle: showRectangle,
        pause: pause,
        resume: resume,
        isPaused: isPaused,
        getTransform: getTransformModel,
        getMinZoom: getMinZoom,
        setMinZoom: setMinZoom,
        getMaxZoom: getMaxZoom,
        setMaxZoom: setMaxZoom,
        getTransformOrigin: getTransformOrigin,
        setTransformOrigin: setTransformOrigin,
        getZoomSpeed: getZoomSpeed,
        setZoomSpeed: setZoomSpeed
    };
    $hG6VV(api);
    var initialX = typeof options.initialX === 'number' ? options.initialX : transform.x;
    var initialY = typeof options.initialY === 'number' ? options.initialY : transform.y;
    var initialZoom = typeof options.initialZoom === 'number' ? options.initialZoom : transform.scale;
    if (initialX != transform.x || initialY != transform.y || initialZoom != transform.scale) zoomAbs(initialX, initialY, initialZoom);
    return api;
    function pause() {
        releaseEvents();
        paused = true;
    }
    function resume() {
        if (paused) {
            listenForEvents();
            paused = false;
        }
    }
    function isPaused() {
        return paused;
    }
    function showRectangle(rect) {
        // TODO: this duplicates autocenter. I think autocenter should go.
        var clientRect = owner.getBoundingClientRect();
        var size = transformToScreen(clientRect.width, clientRect.height);
        var rectWidth = rect.right - rect.left;
        var rectHeight = rect.bottom - rect.top;
        if (!Number.isFinite(rectWidth) || !Number.isFinite(rectHeight)) throw new Error('Invalid rectangle');
        var dw = size.x / rectWidth;
        var dh = size.y / rectHeight;
        var scale = Math.min(dw, dh);
        transform.x = -(rect.left + rectWidth / 2) * scale + size.x / 2;
        transform.y = -(rect.top + rectHeight / 2) * scale + size.y / 2;
        transform.scale = scale;
    }
    function transformToScreen(x, y) {
        if (panController.getScreenCTM) {
            var parentCTM = panController.getScreenCTM();
            var parentScaleX = parentCTM.a;
            var parentScaleY = parentCTM.d;
            var parentOffsetX = parentCTM.e;
            var parentOffsetY = parentCTM.f;
            storedCTMResult.x = x * parentScaleX - parentOffsetX;
            storedCTMResult.y = y * parentScaleY - parentOffsetY;
        } else {
            storedCTMResult.x = x;
            storedCTMResult.y = y;
        }
        return storedCTMResult;
    }
    function autocenter() {
        var w; // width of the parent
        var h; // height of the parent
        var left = 0;
        var top = 0;
        var sceneBoundingBox = getBoundingBox();
        if (sceneBoundingBox) {
            // If we have bounding box - use it.
            left = sceneBoundingBox.left;
            top = sceneBoundingBox.top;
            w = sceneBoundingBox.right - sceneBoundingBox.left;
            h = sceneBoundingBox.bottom - sceneBoundingBox.top;
        } else {
            // otherwise just use whatever space we have
            var ownerRect = owner.getBoundingClientRect();
            w = ownerRect.width;
            h = ownerRect.height;
        }
        var bbox = panController.getBBox();
        if (bbox.width === 0 || bbox.height === 0) // we probably do not have any elements in the SVG
        // just bail out;
        return;
        var dh = h / bbox.height;
        var dw = w / bbox.width;
        var scale = Math.min(dw, dh);
        transform.x = -(bbox.left + bbox.width / 2) * scale + w / 2 + left;
        transform.y = -(bbox.top + bbox.height / 2) * scale + h / 2 + top;
        transform.scale = scale;
    }
    function getTransformModel() {
        // TODO: should this be read only?
        return transform;
    }
    function getMinZoom() {
        return minZoom;
    }
    function setMinZoom(newMinZoom) {
        minZoom = newMinZoom;
    }
    function getMaxZoom() {
        return maxZoom;
    }
    function setMaxZoom(newMaxZoom) {
        maxZoom = newMaxZoom;
    }
    function getTransformOrigin() {
        return transformOrigin;
    }
    function setTransformOrigin(newTransformOrigin) {
        transformOrigin = $f22fea531ee465de$var$parseTransformOrigin(newTransformOrigin);
    }
    function getZoomSpeed() {
        return speed;
    }
    function setZoomSpeed(newSpeed) {
        if (!Number.isFinite(newSpeed)) throw new Error('Zoom speed should be a number');
        speed = newSpeed;
    }
    function getPoint() {
        return {
            x: transform.x,
            y: transform.y
        };
    }
    function moveTo(x, y) {
        transform.x = x;
        transform.y = y;
        keepTransformInsideBounds();
        triggerEvent('pan');
        makeDirty();
    }
    function moveBy(dx, dy) {
        moveTo(transform.x + dx, transform.y + dy);
    }
    function keepTransformInsideBounds() {
        var boundingBox = getBoundingBox();
        if (!boundingBox) return;
        var adjusted = false;
        var clientRect = getClientRect();
        var diff = boundingBox.left - clientRect.right;
        if (diff > 0) {
            transform.x += diff;
            adjusted = true;
        }
        // check the other side:
        diff = boundingBox.right - clientRect.left;
        if (diff < 0) {
            transform.x += diff;
            adjusted = true;
        }
        // y axis:
        diff = boundingBox.top - clientRect.bottom;
        if (diff > 0) {
            // we adjust transform, so that it matches exactly our bounding box:
            // transform.y = boundingBox.top - (boundingBox.height + boundingBox.y) * transform.scale =>
            // transform.y = boundingBox.top - (clientRect.bottom - transform.y) =>
            // transform.y = diff + transform.y =>
            transform.y += diff;
            adjusted = true;
        }
        diff = boundingBox.bottom - clientRect.top;
        if (diff < 0) {
            transform.y += diff;
            adjusted = true;
        }
        return adjusted;
    }
    /**
   * Returns bounding box that should be used to restrict scene movement.
   */ function getBoundingBox() {
        if (!bounds) return; // client does not want to restrict movement
        if (typeof bounds === 'boolean') {
            // for boolean type we use parent container bounds
            var ownerRect = owner.getBoundingClientRect();
            var sceneWidth = ownerRect.width;
            var sceneHeight = ownerRect.height;
            return {
                left: sceneWidth * boundsPadding,
                top: sceneHeight * boundsPadding,
                right: sceneWidth * (1 - boundsPadding),
                bottom: sceneHeight * (1 - boundsPadding)
            };
        }
        return bounds;
    }
    function getClientRect() {
        var bbox = panController.getBBox();
        var leftTop = client(bbox.left, bbox.top);
        return {
            left: leftTop.x,
            top: leftTop.y,
            right: bbox.width * transform.scale + leftTop.x,
            bottom: bbox.height * transform.scale + leftTop.y
        };
    }
    function client(x, y) {
        return {
            x: x * transform.scale + transform.x,
            y: y * transform.scale + transform.y
        };
    }
    function makeDirty() {
        isDirty = true;
        frameAnimation = window.requestAnimationFrame(frame);
    }
    function zoomByRatio(clientX, clientY, ratio) {
        if ($f22fea531ee465de$var$isNaN(clientX) || $f22fea531ee465de$var$isNaN(clientY) || $f22fea531ee465de$var$isNaN(ratio)) throw new Error('zoom requires valid numbers');
        var newScale = transform.scale * ratio;
        if (newScale < minZoom) {
            if (transform.scale === minZoom) return;
            ratio = minZoom / transform.scale;
        }
        if (newScale > maxZoom) {
            if (transform.scale === maxZoom) return;
            ratio = maxZoom / transform.scale;
        }
        var size = transformToScreen(clientX, clientY);
        transform.x = size.x - ratio * (size.x - transform.x);
        transform.y = size.y - ratio * (size.y - transform.y);
        // TODO: https://github.com/anvaka/panzoom/issues/112
        if (bounds && boundsPadding === 1 && minZoom === 1) {
            transform.scale *= ratio;
            keepTransformInsideBounds();
        } else {
            var transformAdjusted = keepTransformInsideBounds();
            if (!transformAdjusted) transform.scale *= ratio;
        }
        triggerEvent('zoom');
        makeDirty();
    }
    function zoomAbs(clientX, clientY, zoomLevel) {
        var ratio = zoomLevel / transform.scale;
        zoomByRatio(clientX, clientY, ratio);
    }
    function centerOn(ui) {
        var parent = ui.ownerSVGElement;
        if (!parent) throw new Error('ui element is required to be within the scene');
        // TODO: should i use controller's screen CTM?
        var clientRect = ui.getBoundingClientRect();
        var cx = clientRect.left + clientRect.width / 2;
        var cy = clientRect.top + clientRect.height / 2;
        var container = parent.getBoundingClientRect();
        var dx = container.width / 2 - cx;
        var dy = container.height / 2 - cy;
        internalMoveBy(dx, dy, true);
    }
    function smoothMoveTo(x, y) {
        internalMoveBy(x - transform.x, y - transform.y, true);
    }
    function internalMoveBy(dx, dy, smooth) {
        if (!smooth) return moveBy(dx, dy);
        if (moveByAnimation) moveByAnimation.cancel();
        var from = {
            x: 0,
            y: 0
        };
        var to = {
            x: dx,
            y: dy
        };
        var lastX = 0;
        var lastY = 0;
        moveByAnimation = $eKEF7(from, to, {
            step: function(v) {
                moveBy(v.x - lastX, v.y - lastY);
                lastX = v.x;
                lastY = v.y;
            }
        });
    }
    function scroll(x, y) {
        cancelZoomAnimation();
        moveTo(x, y);
    }
    function dispose() {
        releaseEvents();
    }
    function listenForEvents() {
        owner.addEventListener('mousedown', onMouseDown, {
            passive: false
        });
        owner.addEventListener('dblclick', onDoubleClick, {
            passive: false
        });
        owner.addEventListener('touchstart', onTouch, {
            passive: false
        });
        owner.addEventListener('keydown', onKeyDown, {
            passive: false
        });
        // Need to listen on the owner container, so that we are not limited
        // by the size of the scrollable domElement
        $krYUM.addWheelListener(owner, onMouseWheel, {
            passive: false
        });
        makeDirty();
    }
    function releaseEvents() {
        $krYUM.removeWheelListener(owner, onMouseWheel);
        owner.removeEventListener('mousedown', onMouseDown);
        owner.removeEventListener('keydown', onKeyDown);
        owner.removeEventListener('dblclick', onDoubleClick);
        owner.removeEventListener('touchstart', onTouch);
        if (frameAnimation) {
            window.cancelAnimationFrame(frameAnimation);
            frameAnimation = 0;
        }
        smoothScroll.cancel();
        releaseDocumentMouse();
        releaseTouches();
        textSelection.release();
        triggerPanEnd();
    }
    function frame() {
        if (isDirty) applyTransform();
    }
    function applyTransform() {
        isDirty = false;
        // TODO: Should I allow to cancel this?
        panController.applyTransform(transform);
        triggerEvent('transform');
        frameAnimation = 0;
    }
    function onKeyDown(e) {
        var x = 0, y = 0, z = 0;
        if (e.keyCode === 38) y = 1; // up
        else if (e.keyCode === 40) y = -1; // down
        else if (e.keyCode === 37) x = 1; // left
        else if (e.keyCode === 39) x = -1; // right
        else if (e.keyCode === 189 || e.keyCode === 109) // DASH or SUBTRACT
        z = 1; // `-` -  zoom out
        else if (e.keyCode === 187 || e.keyCode === 107) // EQUAL SIGN or ADD
        z = -1; // `=` - zoom in (equal sign on US layout is under `+`)
        if (filterKey(e, x, y, z)) // They don't want us to handle the key: https://github.com/anvaka/panzoom/issues/45
        return;
        if (x || y) {
            e.preventDefault();
            e.stopPropagation();
            var clientRect = owner.getBoundingClientRect();
            // movement speed should be the same in both X and Y direction:
            var offset = Math.min(clientRect.width, clientRect.height);
            var moveSpeedRatio = 0.05;
            var dx = offset * moveSpeedRatio * x;
            var dy = offset * moveSpeedRatio * y;
            // TODO: currently we do not animate this. It could be better to have animation
            internalMoveBy(dx, dy);
        }
        if (z) {
            var scaleMultiplier = getScaleMultiplier(z * 100);
            var offset = transformOrigin ? getTransformOriginOffset() : midPoint();
            publicZoomTo(offset.x, offset.y, scaleMultiplier);
        }
    }
    function midPoint() {
        var ownerRect = owner.getBoundingClientRect();
        return {
            x: ownerRect.width / 2,
            y: ownerRect.height / 2
        };
    }
    function onTouch(e) {
        // let them override the touch behavior
        beforeTouch(e);
        clearPendingClickEventTimeout();
        if (e.touches.length === 1) return handleSingleFingerTouch(e, e.touches[0]);
        else if (e.touches.length === 2) {
            // handleTouchMove() will care about pinch zoom.
            pinchZoomLength = getPinchZoomLength(e.touches[0], e.touches[1]);
            multiTouch = true;
            startTouchListenerIfNeeded();
        }
    }
    function beforeTouch(e) {
        // TODO: Need to unify this filtering names. E.g. use `beforeTouch`
        if (options.onTouch && !options.onTouch(e)) // if they return `false` from onTouch, we don't want to stop
        // events propagation. Fixes https://github.com/anvaka/panzoom/issues/12
        return;
        e.stopPropagation();
        e.preventDefault();
    }
    function beforeDoubleClick(e) {
        clearPendingClickEventTimeout();
        // TODO: Need to unify this filtering names. E.g. use `beforeDoubleClick``
        if (options.onDoubleClick && !options.onDoubleClick(e)) // if they return `false` from onTouch, we don't want to stop
        // events propagation. Fixes https://github.com/anvaka/panzoom/issues/46
        return;
        e.preventDefault();
        e.stopPropagation();
    }
    function handleSingleFingerTouch(e) {
        lastTouchStartTime = new Date();
        var touch = e.touches[0];
        var offset = getOffsetXY(touch);
        lastSingleFingerOffset = offset;
        var point = transformToScreen(offset.x, offset.y);
        mouseX = point.x;
        mouseY = point.y;
        clickX = mouseX;
        clickY = mouseY;
        smoothScroll.cancel();
        startTouchListenerIfNeeded();
    }
    function startTouchListenerIfNeeded() {
        if (touchInProgress) // no need to do anything, as we already listen to events;
        return;
        touchInProgress = true;
        document.addEventListener('touchmove', handleTouchMove);
        document.addEventListener('touchend', handleTouchEnd);
        document.addEventListener('touchcancel', handleTouchEnd);
    }
    function handleTouchMove(e) {
        if (e.touches.length === 1) {
            e.stopPropagation();
            var touch = e.touches[0];
            var offset = getOffsetXY(touch);
            var point = transformToScreen(offset.x, offset.y);
            var dx = point.x - mouseX;
            var dy = point.y - mouseY;
            if (dx !== 0 && dy !== 0) triggerPanStart();
            mouseX = point.x;
            mouseY = point.y;
            internalMoveBy(dx, dy);
        } else if (e.touches.length === 2) {
            // it's a zoom, let's find direction
            multiTouch = true;
            var t1 = e.touches[0];
            var t2 = e.touches[1];
            var currentPinchLength = getPinchZoomLength(t1, t2);
            // since the zoom speed is always based on distance from 1, we need to apply
            // pinch speed only on that distance from 1:
            var scaleMultiplier = 1 + (currentPinchLength / pinchZoomLength - 1) * pinchSpeed;
            var firstTouchPoint = getOffsetXY(t1);
            var secondTouchPoint = getOffsetXY(t2);
            mouseX = (firstTouchPoint.x + secondTouchPoint.x) / 2;
            mouseY = (firstTouchPoint.y + secondTouchPoint.y) / 2;
            if (transformOrigin) {
                var offset = getTransformOriginOffset();
                mouseX = offset.x;
                mouseY = offset.y;
            }
            publicZoomTo(mouseX, mouseY, scaleMultiplier);
            pinchZoomLength = currentPinchLength;
            e.stopPropagation();
            e.preventDefault();
        }
    }
    function clearPendingClickEventTimeout() {
        if (pendingClickEventTimeout) {
            clearTimeout(pendingClickEventTimeout);
            pendingClickEventTimeout = 0;
        }
    }
    function handlePotentialClickEvent(e) {
        // we could still be in the double tap mode, let's wait until double tap expires,
        // and then notify:
        if (!options.onClick) return;
        clearPendingClickEventTimeout();
        var dx = mouseX - clickX;
        var dy = mouseY - clickY;
        var l = Math.sqrt(dx * dx + dy * dy);
        if (l > 5) return; // probably they are panning, ignore it
        pendingClickEventTimeout = setTimeout(function() {
            pendingClickEventTimeout = 0;
            options.onClick(e);
        }, $f22fea531ee465de$var$doubleTapSpeedInMS);
    }
    function handleTouchEnd(e) {
        clearPendingClickEventTimeout();
        if (e.touches.length > 0) {
            var offset = getOffsetXY(e.touches[0]);
            var point = transformToScreen(offset.x, offset.y);
            mouseX = point.x;
            mouseY = point.y;
        } else {
            var now = new Date();
            if (now - lastTouchEndTime < $f22fea531ee465de$var$doubleTapSpeedInMS) {
                // They did a double tap here
                if (transformOrigin) {
                    var offset = getTransformOriginOffset();
                    smoothZoom(offset.x, offset.y, zoomDoubleClickSpeed);
                } else // We want untransformed x/y here.
                smoothZoom(lastSingleFingerOffset.x, lastSingleFingerOffset.y, zoomDoubleClickSpeed);
            } else if (now - lastTouchStartTime < $f22fea531ee465de$var$clickEventTimeInMS) handlePotentialClickEvent(e);
            lastTouchEndTime = now;
            triggerPanEnd();
            releaseTouches();
        }
    }
    function getPinchZoomLength(finger1, finger2) {
        var dx = finger1.clientX - finger2.clientX;
        var dy = finger1.clientY - finger2.clientY;
        return Math.sqrt(dx * dx + dy * dy);
    }
    function onDoubleClick(e) {
        beforeDoubleClick(e);
        var offset = getOffsetXY(e);
        if (transformOrigin) // TODO: looks like this is duplicated in the file.
        // Need to refactor
        offset = getTransformOriginOffset();
        smoothZoom(offset.x, offset.y, zoomDoubleClickSpeed);
    }
    function onMouseDown(e) {
        clearPendingClickEventTimeout();
        // if client does not want to handle this event - just ignore the call
        if (beforeMouseDown(e)) return;
        lastMouseDownedEvent = e;
        lastMouseDownTime = new Date();
        if (touchInProgress) {
            // modern browsers will fire mousedown for touch events too
            // we do not want this: touch is handled separately.
            e.stopPropagation();
            return false;
        }
        // for IE, left click == 1
        // for Firefox, left click == 0
        var isLeftButton = e.button === 1 && window.event !== null || e.button === 0;
        if (!isLeftButton) return;
        smoothScroll.cancel();
        var offset = getOffsetXY(e);
        var point = transformToScreen(offset.x, offset.y);
        clickX = mouseX = point.x;
        clickY = mouseY = point.y;
        // We need to listen on document itself, since mouse can go outside of the
        // window, and we will loose it
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
        textSelection.capture(e.target || e.srcElement);
        return false;
    }
    function onMouseMove(e) {
        // no need to worry about mouse events when touch is happening
        if (touchInProgress) return;
        triggerPanStart();
        var offset = getOffsetXY(e);
        var point = transformToScreen(offset.x, offset.y);
        var dx = point.x - mouseX;
        var dy = point.y - mouseY;
        mouseX = point.x;
        mouseY = point.y;
        internalMoveBy(dx, dy);
    }
    function onMouseUp() {
        var now = new Date();
        if (now - lastMouseDownTime < $f22fea531ee465de$var$clickEventTimeInMS) handlePotentialClickEvent(lastMouseDownedEvent);
        textSelection.release();
        triggerPanEnd();
        releaseDocumentMouse();
    }
    function releaseDocumentMouse() {
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
        panstartFired = false;
    }
    function releaseTouches() {
        document.removeEventListener('touchmove', handleTouchMove);
        document.removeEventListener('touchend', handleTouchEnd);
        document.removeEventListener('touchcancel', handleTouchEnd);
        panstartFired = false;
        multiTouch = false;
        touchInProgress = false;
    }
    function onMouseWheel(e) {
        // if client does not want to handle this event - just ignore the call
        if (beforeWheel(e)) return;
        smoothScroll.cancel();
        var delta = e.deltaY;
        if (e.deltaMode > 0) delta *= 100;
        var scaleMultiplier = getScaleMultiplier(delta);
        if (scaleMultiplier !== 1) {
            var offset = transformOrigin ? getTransformOriginOffset() : getOffsetXY(e);
            publicZoomTo(offset.x, offset.y, scaleMultiplier);
            e.preventDefault();
        }
    }
    function getOffsetXY(e) {
        var offsetX, offsetY;
        // I tried using e.offsetX, but that gives wrong results for svg, when user clicks on a path.
        var ownerRect = owner.getBoundingClientRect();
        offsetX = e.clientX - ownerRect.left;
        offsetY = e.clientY - ownerRect.top;
        return {
            x: offsetX,
            y: offsetY
        };
    }
    function smoothZoom(clientX, clientY, scaleMultiplier) {
        var fromValue = transform.scale;
        var from = {
            scale: fromValue
        };
        var to = {
            scale: scaleMultiplier * fromValue
        };
        smoothScroll.cancel();
        cancelZoomAnimation();
        zoomToAnimation = $eKEF7(from, to, {
            step: function(v) {
                zoomAbs(clientX, clientY, v.scale);
            },
            done: triggerZoomEnd
        });
    }
    function smoothZoomAbs(clientX, clientY, toScaleValue) {
        var fromValue = transform.scale;
        var from = {
            scale: fromValue
        };
        var to = {
            scale: toScaleValue
        };
        smoothScroll.cancel();
        cancelZoomAnimation();
        zoomToAnimation = $eKEF7(from, to, {
            step: function(v) {
                zoomAbs(clientX, clientY, v.scale);
            }
        });
    }
    function getTransformOriginOffset() {
        var ownerRect = owner.getBoundingClientRect();
        return {
            x: ownerRect.width * transformOrigin.x,
            y: ownerRect.height * transformOrigin.y
        };
    }
    function publicZoomTo(clientX, clientY, scaleMultiplier) {
        smoothScroll.cancel();
        cancelZoomAnimation();
        return zoomByRatio(clientX, clientY, scaleMultiplier);
    }
    function cancelZoomAnimation() {
        if (zoomToAnimation) {
            zoomToAnimation.cancel();
            zoomToAnimation = null;
        }
    }
    function getScaleMultiplier(delta) {
        var sign = Math.sign(delta);
        var deltaAdjustedSpeed = Math.min(0.25, Math.abs(speed * delta / 128));
        return 1 - sign * deltaAdjustedSpeed;
    }
    function triggerPanStart() {
        if (!panstartFired) {
            triggerEvent('panstart');
            panstartFired = true;
            smoothScroll.start();
        }
    }
    function triggerPanEnd() {
        if (panstartFired) {
            // we should never run smooth scrolling if it was multiTouch (pinch zoom animation):
            if (!multiTouch) smoothScroll.stop();
            triggerEvent('panend');
        }
    }
    function triggerZoomEnd() {
        triggerEvent('zoomend');
    }
    function triggerEvent(name) {
        api.fire(name, api);
    }
}
function $f22fea531ee465de$var$parseTransformOrigin(options) {
    if (!options) return;
    if (typeof options === 'object') {
        if (!$f22fea531ee465de$var$isNumber(options.x) || !$f22fea531ee465de$var$isNumber(options.y)) $f22fea531ee465de$var$failTransformOrigin(options);
        return options;
    }
    $f22fea531ee465de$var$failTransformOrigin();
}
function $f22fea531ee465de$var$failTransformOrigin(options) {
    console.error(options);
    throw new Error([
        'Cannot parse transform origin.',
        'Some good examples:',
        '  "center center" can be achieved with {x: 0.5, y: 0.5}',
        '  "top center" can be achieved with {x: 0.5, y: 0}',
        '  "bottom right" can be achieved with {x: 1, y: 1}'
    ].join('\n'));
}
function $f22fea531ee465de$var$noop() {}
function $f22fea531ee465de$var$validateBounds(bounds) {
    var boundsType = typeof bounds;
    if (boundsType === 'undefined' || boundsType === 'boolean') return; // this is okay
    // otherwise need to be more thorough:
    var validBounds = $f22fea531ee465de$var$isNumber(bounds.left) && $f22fea531ee465de$var$isNumber(bounds.top) && $f22fea531ee465de$var$isNumber(bounds.bottom) && $f22fea531ee465de$var$isNumber(bounds.right);
    if (!validBounds) throw new Error("Bounds object is not valid. It can be: undefined, boolean (true|false) or an object {left, top, right, bottom}");
}
function $f22fea531ee465de$var$isNumber(x) {
    return Number.isFinite(x);
}
// IE 11 does not support isNaN:
function $f22fea531ee465de$var$isNaN(value) {
    if (Number.isNaN) return Number.isNaN(value);
    return value !== value;
}
function $f22fea531ee465de$var$rigidScroll() {
    return {
        start: $f22fea531ee465de$var$noop,
        stop: $f22fea531ee465de$var$noop,
        cancel: $f22fea531ee465de$var$noop
    };
}
function $f22fea531ee465de$var$autoRun() {
    if (typeof document === 'undefined') return;
    var scripts = document.getElementsByTagName('script');
    if (!scripts) return;
    var panzoomScript;
    for(var i = 0; i < scripts.length; ++i){
        var x = scripts[i];
        if (x.src && x.src.match(/\bpanzoom(\.min)?\.js/)) {
            panzoomScript = x;
            break;
        }
    }
    if (!panzoomScript) return;
    var query = panzoomScript.getAttribute('query');
    if (!query) return;
    var globalName = panzoomScript.getAttribute('name') || 'pz';
    var started = Date.now();
    tryAttach();
    function tryAttach() {
        var el = document.querySelector(query);
        if (!el) {
            var now = Date.now();
            var elapsed = now - started;
            if (elapsed < 2000) {
                // Let's wait a bit
                setTimeout(tryAttach, 100);
                return;
            }
            // If we don't attach within 2 seconds to the target element, consider it a failure
            console.error('Cannot find the panzoom element', globalName);
            return;
        }
        var options = collectOptions(panzoomScript);
        console.log(options);
        window[globalName] = $f22fea531ee465de$var$createPanZoom(el, options);
    }
    function collectOptions(script) {
        var attrs = script.attributes;
        var options = {};
        for(var j = 0; j < attrs.length; ++j){
            var attr = attrs[j];
            var nameValue = getPanzoomAttributeNameValue(attr);
            if (nameValue) options[nameValue.name] = nameValue.value;
        }
        return options;
    }
    function getPanzoomAttributeNameValue(attr) {
        if (!attr.name) return;
        var isPanZoomAttribute = attr.name[0] === 'p' && attr.name[1] === 'z' && attr.name[2] === '-';
        if (!isPanZoomAttribute) return;
        var name = attr.name.substr(3);
        var value = JSON.parse(attr.value);
        return {
            name: name,
            value: value
        };
    }
}
$f22fea531ee465de$var$autoRun();

});
parcelRegister("krYUM", function(module, exports) {
/**
 * This module used to unify mouse wheel behavior between different browsers in 2014
 * Now it's just a wrapper around addEventListener('wheel');
 *
 * Usage:
 *  var addWheelListener = require('wheel').addWheelListener;
 *  var removeWheelListener = require('wheel').removeWheelListener;
 *  addWheelListener(domElement, function (e) {
 *    // mouse wheel event
 *  });
 *  removeWheelListener(domElement, function);
 */ module.exports = $ee3594ab38f6167c$var$addWheelListener;
// But also expose "advanced" api with unsubscribe:
module.exports.addWheelListener = $ee3594ab38f6167c$var$addWheelListener;
module.exports.removeWheelListener = $ee3594ab38f6167c$var$removeWheelListener;
function $ee3594ab38f6167c$var$addWheelListener(element, listener, useCapture) {
    element.addEventListener('wheel', listener, useCapture);
}
function $ee3594ab38f6167c$var$removeWheelListener(element, listener, useCapture) {
    element.removeEventListener('wheel', listener, useCapture);
}

});

parcelRegister("eKEF7", function(module, exports) {

var $4GoXZ = parcelRequire("4GoXZ");
// Predefined set of animations. Similar to CSS easing functions
var $abd4e73c78068168$var$animations = {
    ease: $4GoXZ(0.25, 0.1, 0.25, 1),
    easeIn: $4GoXZ(0.42, 0, 1, 1),
    easeOut: $4GoXZ(0, 0, 0.58, 1),
    easeInOut: $4GoXZ(0.42, 0, 0.58, 1),
    linear: $4GoXZ(0, 0, 1, 1)
};
module.exports = $abd4e73c78068168$var$animate;
module.exports.makeAggregateRaf = $abd4e73c78068168$var$makeAggregateRaf;
module.exports.sharedScheduler = $abd4e73c78068168$var$makeAggregateRaf();
function $abd4e73c78068168$var$animate(source, target, options) {
    var start = Object.create(null);
    var diff = Object.create(null);
    options = options || {};
    // We let clients specify their own easing function
    var easing = typeof options.easing === 'function' ? options.easing : $abd4e73c78068168$var$animations[options.easing];
    // if nothing is specified, default to ease (similar to CSS animations)
    if (!easing) {
        if (options.easing) console.warn('Unknown easing function in amator: ' + options.easing);
        easing = $abd4e73c78068168$var$animations.ease;
    }
    var step = typeof options.step === 'function' ? options.step : $abd4e73c78068168$var$noop;
    var done = typeof options.done === 'function' ? options.done : $abd4e73c78068168$var$noop;
    var scheduler = $abd4e73c78068168$var$getScheduler(options.scheduler);
    var keys = Object.keys(target);
    keys.forEach(function(key) {
        start[key] = source[key];
        diff[key] = target[key] - source[key];
    });
    var durationInMs = typeof options.duration === 'number' ? options.duration : 400;
    var durationInFrames = Math.max(1, durationInMs * 0.06) // 0.06 because 60 frames pers 1,000 ms
    ;
    var previousAnimationId;
    var frame = 0;
    previousAnimationId = scheduler.next(loop);
    return {
        cancel: cancel
    };
    function cancel() {
        scheduler.cancel(previousAnimationId);
        previousAnimationId = 0;
    }
    function loop() {
        var t = easing(frame / durationInFrames);
        frame += 1;
        setValues(t);
        if (frame <= durationInFrames) {
            previousAnimationId = scheduler.next(loop);
            step(source);
        } else {
            previousAnimationId = 0;
            setTimeout(function() {
                done(source);
            }, 0);
        }
    }
    function setValues(t) {
        keys.forEach(function(key) {
            source[key] = diff[key] * t + start[key];
        });
    }
}
function $abd4e73c78068168$var$noop() {}
function $abd4e73c78068168$var$getScheduler(scheduler) {
    if (!scheduler) {
        var canRaf = typeof window !== 'undefined' && window.requestAnimationFrame;
        return canRaf ? $abd4e73c78068168$var$rafScheduler() : $abd4e73c78068168$var$timeoutScheduler();
    }
    if (typeof scheduler.next !== 'function') throw new Error('Scheduler is supposed to have next(cb) function');
    if (typeof scheduler.cancel !== 'function') throw new Error('Scheduler is supposed to have cancel(handle) function');
    return scheduler;
}
function $abd4e73c78068168$var$rafScheduler() {
    return {
        next: window.requestAnimationFrame.bind(window),
        cancel: window.cancelAnimationFrame.bind(window)
    };
}
function $abd4e73c78068168$var$timeoutScheduler() {
    return {
        next: function(cb) {
            return setTimeout(cb, 1000 / 60);
        },
        cancel: function(id) {
            return clearTimeout(id);
        }
    };
}
function $abd4e73c78068168$var$makeAggregateRaf() {
    var frontBuffer = new Set();
    var backBuffer = new Set();
    var frameToken = 0;
    return {
        next: next,
        cancel: next,
        clearAll: clearAll
    };
    function clearAll() {
        frontBuffer.clear();
        backBuffer.clear();
        cancelAnimationFrame(frameToken);
        frameToken = 0;
    }
    function next(callback) {
        backBuffer.add(callback);
        renderNextFrame();
    }
    function renderNextFrame() {
        if (!frameToken) frameToken = requestAnimationFrame(renderFrame);
    }
    function renderFrame() {
        frameToken = 0;
        var t = backBuffer;
        backBuffer = frontBuffer;
        frontBuffer = t;
        frontBuffer.forEach(function(callback) {
            callback();
        });
        frontBuffer.clear();
    }
    function cancel(callback) {
        backBuffer.delete(callback);
    }
}

});
parcelRegister("4GoXZ", function(module, exports) {
/**
 * https://github.com/gre/bezier-easing
 * BezierEasing - use bezier curve for transition easing function
 * by Gaëtan Renaudeau 2014 - 2015 – MIT License
 */ // These values are established by empiricism with tests (tradeoff: performance VS precision)
var $368e738781e188a9$var$NEWTON_ITERATIONS = 4;
var $368e738781e188a9$var$NEWTON_MIN_SLOPE = 0.001;
var $368e738781e188a9$var$SUBDIVISION_PRECISION = 0.0000001;
var $368e738781e188a9$var$SUBDIVISION_MAX_ITERATIONS = 10;
var $368e738781e188a9$var$kSplineTableSize = 11;
var $368e738781e188a9$var$kSampleStepSize = 1.0 / ($368e738781e188a9$var$kSplineTableSize - 1.0);
var $368e738781e188a9$var$float32ArraySupported = typeof Float32Array === 'function';
function $368e738781e188a9$var$A(aA1, aA2) {
    return 1.0 - 3.0 * aA2 + 3.0 * aA1;
}
function $368e738781e188a9$var$B(aA1, aA2) {
    return 3.0 * aA2 - 6.0 * aA1;
}
function $368e738781e188a9$var$C(aA1) {
    return 3.0 * aA1;
}
// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
function $368e738781e188a9$var$calcBezier(aT, aA1, aA2) {
    return (($368e738781e188a9$var$A(aA1, aA2) * aT + $368e738781e188a9$var$B(aA1, aA2)) * aT + $368e738781e188a9$var$C(aA1)) * aT;
}
// Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
function $368e738781e188a9$var$getSlope(aT, aA1, aA2) {
    return 3.0 * $368e738781e188a9$var$A(aA1, aA2) * aT * aT + 2.0 * $368e738781e188a9$var$B(aA1, aA2) * aT + $368e738781e188a9$var$C(aA1);
}
function $368e738781e188a9$var$binarySubdivide(aX, aA, aB, mX1, mX2) {
    var currentX, currentT, i = 0;
    do {
        currentT = aA + (aB - aA) / 2.0;
        currentX = $368e738781e188a9$var$calcBezier(currentT, mX1, mX2) - aX;
        if (currentX > 0.0) aB = currentT;
        else aA = currentT;
    }while (Math.abs(currentX) > $368e738781e188a9$var$SUBDIVISION_PRECISION && ++i < $368e738781e188a9$var$SUBDIVISION_MAX_ITERATIONS);
    return currentT;
}
function $368e738781e188a9$var$newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
    for(var i = 0; i < $368e738781e188a9$var$NEWTON_ITERATIONS; ++i){
        var currentSlope = $368e738781e188a9$var$getSlope(aGuessT, mX1, mX2);
        if (currentSlope === 0.0) return aGuessT;
        var currentX = $368e738781e188a9$var$calcBezier(aGuessT, mX1, mX2) - aX;
        aGuessT -= currentX / currentSlope;
    }
    return aGuessT;
}
function $368e738781e188a9$var$LinearEasing(x) {
    return x;
}
module.exports = function bezier(mX1, mY1, mX2, mY2) {
    if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) throw new Error('bezier x values must be in [0, 1] range');
    if (mX1 === mY1 && mX2 === mY2) return $368e738781e188a9$var$LinearEasing;
    // Precompute samples table
    var sampleValues = $368e738781e188a9$var$float32ArraySupported ? new Float32Array($368e738781e188a9$var$kSplineTableSize) : new Array($368e738781e188a9$var$kSplineTableSize);
    for(var i = 0; i < $368e738781e188a9$var$kSplineTableSize; ++i)sampleValues[i] = $368e738781e188a9$var$calcBezier(i * $368e738781e188a9$var$kSampleStepSize, mX1, mX2);
    function getTForX(aX) {
        var intervalStart = 0.0;
        var currentSample = 1;
        var lastSample = $368e738781e188a9$var$kSplineTableSize - 1;
        for(; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample)intervalStart += $368e738781e188a9$var$kSampleStepSize;
        --currentSample;
        // Interpolate to provide an initial guess for t
        var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
        var guessForT = intervalStart + dist * $368e738781e188a9$var$kSampleStepSize;
        var initialSlope = $368e738781e188a9$var$getSlope(guessForT, mX1, mX2);
        if (initialSlope >= $368e738781e188a9$var$NEWTON_MIN_SLOPE) return $368e738781e188a9$var$newtonRaphsonIterate(aX, guessForT, mX1, mX2);
        else if (initialSlope === 0.0) return guessForT;
        else return $368e738781e188a9$var$binarySubdivide(aX, intervalStart, intervalStart + $368e738781e188a9$var$kSampleStepSize, mX1, mX2);
    }
    return function BezierEasing(x) {
        // Because JavaScript number are imprecise, we should guarantee the extremes are right.
        if (x === 0) return 0;
        if (x === 1) return 1;
        return $368e738781e188a9$var$calcBezier(getTForX(x), mY1, mY2);
    };
};

});


parcelRegister("hG6VV", function(module, exports) {
"use strict";
function $7380e3a328899135$var$c(e) {
    $7380e3a328899135$var$s(e);
    const t = $7380e3a328899135$var$a(e);
    return e.on = t.on, e.off = t.off, e.fire = t.fire, e;
}
function $7380e3a328899135$var$a(e) {
    let t = Object.create(null);
    return {
        on: function(n, r, f) {
            if (typeof r != "function") throw new Error("callback is expected to be a function");
            let o = t[n];
            return o || (o = t[n] = []), o.push({
                callback: r,
                ctx: f
            }), e;
        },
        off: function(n, r) {
            if (typeof n > "u") return t = Object.create(null), e;
            if (t[n]) {
                if (typeof r != "function") delete t[n];
                else {
                    const l = t[n];
                    for(let i = 0; i < l.length; ++i)l[i].callback === r && l.splice(i, 1);
                }
            }
            return e;
        },
        fire: function(n) {
            const r = t[n];
            if (!r) return e;
            let f;
            arguments.length > 1 && (f = Array.prototype.slice.call(arguments, 1));
            for(let o = 0; o < r.length; ++o){
                const l = r[o];
                l.callback.apply(l.ctx, f);
            }
            return e;
        }
    };
}
function $7380e3a328899135$var$s(e) {
    if (!e) throw new Error("Eventify cannot use falsy object as events subject");
    const t = [
        "on",
        "fire",
        "off"
    ];
    for(let n = 0; n < t.length; ++n)if (e.hasOwnProperty(t[n])) throw new Error("Subject cannot be eventified, since it already has property '" + t[n] + "'");
}
module.exports = $7380e3a328899135$var$c; //# sourceMappingURL=ngraph.events.cjs.map

});

parcelRegister("n9wvq", function(module, exports) {
/**
 * Allows smooth kinetic scrolling of the surface
 */ module.exports = $045989394badc850$var$kinetic;
function $045989394badc850$var$kinetic(getPoint, scroll, settings) {
    if (typeof settings !== 'object') // setting could come as boolean, we should ignore it, and use an object.
    settings = {};
    var minVelocity = typeof settings.minVelocity === 'number' ? settings.minVelocity : 5;
    var amplitude = typeof settings.amplitude === 'number' ? settings.amplitude : 0.25;
    var cancelAnimationFrame1 = typeof settings.cancelAnimationFrame === 'function' ? settings.cancelAnimationFrame : $045989394badc850$var$getCancelAnimationFrame();
    var requestAnimationFrame1 = typeof settings.requestAnimationFrame === 'function' ? settings.requestAnimationFrame : $045989394badc850$var$getRequestAnimationFrame();
    var lastPoint;
    var timestamp;
    var timeConstant = 342;
    var ticker;
    var vx, targetX, ax;
    var vy, targetY, ay;
    var raf;
    return {
        start: start,
        stop: stop,
        cancel: dispose
    };
    function dispose() {
        cancelAnimationFrame1(ticker);
        cancelAnimationFrame1(raf);
    }
    function start() {
        lastPoint = getPoint();
        ax = ay = vx = vy = 0;
        timestamp = new Date();
        cancelAnimationFrame1(ticker);
        cancelAnimationFrame1(raf);
        // we start polling the point position to accumulate velocity
        // Once we stop(), we will use accumulated velocity to keep scrolling
        // an object.
        ticker = requestAnimationFrame1(track);
    }
    function track() {
        var now = Date.now();
        var elapsed = now - timestamp;
        timestamp = now;
        var currentPoint = getPoint();
        var dx = currentPoint.x - lastPoint.x;
        var dy = currentPoint.y - lastPoint.y;
        lastPoint = currentPoint;
        var dt = 1000 / (1 + elapsed);
        // moving average
        vx = 0.8 * dx * dt + 0.2 * vx;
        vy = 0.8 * dy * dt + 0.2 * vy;
        ticker = requestAnimationFrame1(track);
    }
    function stop() {
        cancelAnimationFrame1(ticker);
        cancelAnimationFrame1(raf);
        var currentPoint = getPoint();
        targetX = currentPoint.x;
        targetY = currentPoint.y;
        timestamp = Date.now();
        if (vx < -minVelocity || vx > minVelocity) {
            ax = amplitude * vx;
            targetX += ax;
        }
        if (vy < -minVelocity || vy > minVelocity) {
            ay = amplitude * vy;
            targetY += ay;
        }
        raf = requestAnimationFrame1(autoScroll);
    }
    function autoScroll() {
        var elapsed = Date.now() - timestamp;
        var moving = false;
        var dx = 0;
        var dy = 0;
        if (ax) {
            dx = -ax * Math.exp(-elapsed / timeConstant);
            if (dx > 0.5 || dx < -0.5) moving = true;
            else dx = ax = 0;
        }
        if (ay) {
            dy = -ay * Math.exp(-elapsed / timeConstant);
            if (dy > 0.5 || dy < -0.5) moving = true;
            else dy = ay = 0;
        }
        if (moving) {
            scroll(targetX + dx, targetY + dy);
            raf = requestAnimationFrame1(autoScroll);
        }
    }
}
function $045989394badc850$var$getCancelAnimationFrame() {
    if (typeof cancelAnimationFrame === 'function') return cancelAnimationFrame;
    return clearTimeout;
}
function $045989394badc850$var$getRequestAnimationFrame() {
    if (typeof requestAnimationFrame === 'function') return requestAnimationFrame;
    return function(handler) {
        return setTimeout(handler, 16);
    };
}

});

parcelRegister("l1vPM", function(module, exports) {
/**
 * Disallows selecting text.
 */ module.exports = $f4e2629871e48550$var$createTextSelectionInterceptor;
function $f4e2629871e48550$var$createTextSelectionInterceptor(useFake) {
    if (useFake) return {
        capture: $f4e2629871e48550$var$noop,
        release: $f4e2629871e48550$var$noop
    };
    var dragObject;
    var prevSelectStart;
    var prevDragStart;
    var wasCaptured = false;
    return {
        capture: capture,
        release: release
    };
    function capture(domObject) {
        wasCaptured = true;
        prevSelectStart = window.document.onselectstart;
        prevDragStart = window.document.ondragstart;
        window.document.onselectstart = $f4e2629871e48550$var$disabled;
        dragObject = domObject;
        dragObject.ondragstart = $f4e2629871e48550$var$disabled;
    }
    function release() {
        if (!wasCaptured) return;
        wasCaptured = false;
        window.document.onselectstart = prevSelectStart;
        if (dragObject) dragObject.ondragstart = prevDragStart;
    }
}
function $f4e2629871e48550$var$disabled(e) {
    e.stopPropagation();
    return false;
}
function $f4e2629871e48550$var$noop() {}

});

parcelRegister("dEYr4", function(module, exports) {
module.exports = $9f1de407a2889729$var$Transform;
function $9f1de407a2889729$var$Transform() {
    this.x = 0;
    this.y = 0;
    this.scale = 1;
}

});

parcelRegister("4kQhd", function(module, exports) {
module.exports = $328194bd245b8736$var$makeSvgController;
module.exports.canAttach = $328194bd245b8736$var$isSVGElement;
function $328194bd245b8736$var$makeSvgController(svgElement, options) {
    if (!$328194bd245b8736$var$isSVGElement(svgElement)) throw new Error('svg element is required for svg.panzoom to work');
    var owner = svgElement.ownerSVGElement;
    if (!owner) throw new Error("Do not apply panzoom to the root <svg> element. Use its child instead (e.g. <g></g>). As of March 2016 only FireFox supported transform on the root element");
    if (!options.disableKeyboardInteraction) owner.setAttribute('tabindex', 0);
    var api = {
        getBBox: getBBox,
        getScreenCTM: getScreenCTM,
        getOwner: getOwner,
        applyTransform: applyTransform,
        initTransform: initTransform
    };
    return api;
    function getOwner() {
        return owner;
    }
    function getBBox() {
        var bbox = svgElement.getBBox();
        return {
            left: bbox.x,
            top: bbox.y,
            width: bbox.width,
            height: bbox.height
        };
    }
    function getScreenCTM() {
        var ctm = owner.getCTM();
        if (!ctm) // This is likely firefox: https://bugzilla.mozilla.org/show_bug.cgi?id=873106
        // The code below is not entirely correct, but still better than nothing
        return owner.getScreenCTM();
        return ctm;
    }
    function initTransform(transform) {
        var screenCTM = svgElement.getCTM();
        // The above line returns null on Firefox
        if (screenCTM === null) screenCTM = document.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGMatrix();
        transform.x = screenCTM.e;
        transform.y = screenCTM.f;
        transform.scale = screenCTM.a;
        owner.removeAttributeNS(null, 'viewBox');
    }
    function applyTransform(transform) {
        svgElement.setAttribute('transform', 'matrix(' + transform.scale + ' 0 0 ' + transform.scale + ' ' + transform.x + ' ' + transform.y + ')');
    }
}
function $328194bd245b8736$var$isSVGElement(element) {
    return element && element.ownerSVGElement && element.getCTM;
}

});

parcelRegister("53cWy", function(module, exports) {
module.exports = $3ad745e165357d59$var$makeDomController;
module.exports.canAttach = $3ad745e165357d59$var$isDomElement;
function $3ad745e165357d59$var$makeDomController(domElement, options) {
    var elementValid = $3ad745e165357d59$var$isDomElement(domElement);
    if (!elementValid) throw new Error('panzoom requires DOM element to be attached to the DOM tree');
    var owner = domElement.parentElement;
    domElement.scrollTop = 0;
    if (!options.disableKeyboardInteraction) owner.setAttribute('tabindex', 0);
    var api = {
        getBBox: getBBox,
        getOwner: getOwner,
        applyTransform: applyTransform
    };
    return api;
    function getOwner() {
        return owner;
    }
    function getBBox() {
        // TODO: We should probably cache this?
        return {
            left: 0,
            top: 0,
            width: domElement.clientWidth,
            height: domElement.clientHeight
        };
    }
    function applyTransform(transform) {
        // TODO: Should we cache this?
        domElement.style.transformOrigin = '0 0 0';
        domElement.style.transform = 'matrix(' + transform.scale + ', 0, 0, ' + transform.scale + ', ' + transform.x + ', ' + transform.y + ')';
    }
}
function $3ad745e165357d59$var$isDomElement(element) {
    return element && element.parentElement && element.style;
}

});


parcelRegister("3HmWC", function(module, exports) {

$parcel$export(module.exports, "normalizeProjectKey", () => $2b172f90ee11971e$export$c5b3f7b0f9672b33);
$parcel$export(module.exports, "buildProjectUrls", () => $2b172f90ee11971e$export$9ad373d36e296158);
/**
 * Build canonical project preview/canvas URLs — canvas edition.
 *
 * Mirrors the logic in `smbls/packages/cli/bin/start.js:27-46` and
 * `smbls/packages/cli/helpers/projectKeyUtils.js` (§46.4 / §44 compat).
 *
 * The CLI is the authoritative reference. Keep this in sync with it.
 * Do NOT import the CLI package from canvas — it runs in the browser.
 *
 * normalizeProjectKey strips all legacy compound / slash / .symbo.ls-suffix
 * forms that pre-§45 installs may still carry. Required so we never compose
 * 4-level subdomains (the §44 "greenig.symbo.ls" malformation incident).
 */ /**
 * Normalize a raw project key to a bare slug, stripping:
 *   - `.symbo.ls` hostname suffix
 *   - slash-form (take last path segment)
 *   - owner-prefixed combined form (`owner--key` → `key`)
 *
 * Pass `owner` for owner-aware stripping; without it we fall back to
 * stripping everything up to the first `--` (safe for single-token owners).
 *
 * @param {string} raw   - raw key from state (may be any legacy form)
 * @param {string} [owner] - owner slug for owner-aware combined-form stripping
 * @returns {string} bare slug, or '' if empty
 */ function $2b172f90ee11971e$export$c5b3f7b0f9672b33(raw, owner) {
    let s = String(raw || '').trim();
    if (!s) return '';
    // Strip legacy .symbo.ls suffix first so suffix+prefix forms compose.
    if (/\.symbo\.ls$/i.test(s)) s = s.replace(/\.symbo\.ls$/i, '');
    // Slash form → take the part after the last slash.
    if (s.includes('/')) s = s.split('/').pop();
    // Owner-aware combined-form strip.
    const ownerStr = typeof owner === 'string' ? owner.trim() : '';
    if (ownerStr && s.startsWith(`${ownerStr}--`)) s = s.slice(ownerStr.length + 2);
    else if (!ownerStr && s.includes('--')) // Best-effort without owner context: strip up to and including first `--`.
    // Safe when the owner is a single token. Callers SHOULD pass owner.
    s = s.slice(s.indexOf('--') + 2);
    return s;
}
function $2b172f90ee11971e$export$9ad373d36e296158(owner, key, env = 'development') {
    const safeOwner = String(owner || '').trim().toLowerCase();
    const safeKey = $2b172f90ee11971e$export$c5b3f7b0f9672b33(key, safeOwner);
    if (!safeOwner || !safeKey) return null;
    return {
        safeOwner: safeOwner,
        safeKey: safeKey,
        // preview.symbols.app always uses path form + ?env param
        preview: `https://preview.symbols.app/${safeOwner}/${safeKey}?env=${env}`,
        // edit.symbols.app (cloud canvas)
        canvas: `https://edit.symbols.app/${safeOwner}/${safeKey}?env=${env}`,
        // direct subdomain: production has no env infix; others do
        directDev: `https://${safeKey}--development.${safeOwner}.symbo.ls`,
        directProd: `https://${safeKey}.${safeOwner}.symbo.ls`
    };
}

});


parcelRegister("3c42Q", function(module, exports) {

$parcel$export(module.exports, "dashboard", () => $2535a1544b0da584$export$a5f98448b9315739);
$parcel$export(module.exports, "WorkspaceRowButton", () => $2535a1544b0da584$export$baa01e64aa512438);
$parcel$export(module.exports, "OrgRow", () => $2535a1544b0da584$export$1c4cf8ca52e99afb);
$parcel$export(module.exports, "WorkspaceChip", () => $2535a1544b0da584$export$56e04c7e8c2b1c1a);
$parcel$export(module.exports, "OrgProjectRow", () => $2535a1544b0da584$export$31b0ed2a770c9221);
$parcel$export(module.exports, "MarketplaceKindLink", () => $2535a1544b0da584$export$4605b1bda9c939cb);
$parcel$export(module.exports, "OrgMemberRow", () => $2535a1544b0da584$export$7daf49340bc38a02);
$parcel$export(module.exports, "WorkspaceRow", () => $2535a1544b0da584$export$2f4ba8132e14ff17);
$parcel$export(module.exports, "WorkspaceThumb", () => $2535a1544b0da584$export$cd840286e45bca4b);

var $bfqVY = parcelRequire("bfqVY");

var $aJaZ5 = parcelRequire("aJaZ5");

var $82nyI = parcelRequire("82nyI");

var $ecua9 = parcelRequire("ecua9");
const $2535a1544b0da584$var$slugify = (name)=>(name || '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
// ── Slug availability helpers (AC1 + AC2) ──────────────────────────────────
// Module-level debounce timer so rapid name input coalesces into one check.
let $2535a1544b0da584$var$_slugDebounceTimer = null;
// Check whether a slug is available.
// Returns true = available, false = taken, null = check failed.
//
// Routes through the SDK adapter (`getSDK().checkOrganizationSlug`) which
// hits `/organizations?slug=X&_check=1` and threads the SDK's auth header
// + base URL (channel-resolved). Was a raw `fetch(\`<hardcoded next>/core/...\`)`
// — replacing with the SDK keeps every call honoring the
// `workspaceApiBase` / channels override (localNext for dev).
async function $2535a1544b0da584$var$_checkSlugAvailable(slug) {
    if (!slug) return null;
    try {
        return await (0, $bfqVY.getSDK)().checkOrganizationSlug(slug);
    } catch  {
        return null;
    }
}
// Find the first available slug: tries base, then base-2, base-3 … up to N.
async function $2535a1544b0da584$var$_findAvailableSlug(base, maxAttempts = 20) {
    for(let n = 0; n < maxAttempts; n++){
        const candidate = n === 0 ? base : `${base}-${n + 1}`;
        if (await $2535a1544b0da584$var$_checkSlugAvailable(candidate) === true) return candidate;
    }
    return null;
}
// Schedule a debounced slug availability check (350 ms).
// On slug_taken auto-advances to the first free -2/-3/-N suffix.
function $2535a1544b0da584$var$_scheduleSlugCheck(rawSlug, root) {
    if ($2535a1544b0da584$var$_slugDebounceTimer) clearTimeout($2535a1544b0da584$var$_slugDebounceTimer);
    const base = $2535a1544b0da584$var$slugify(rawSlug);
    if (!base) {
        root.update({
            newOrgSlug: '',
            newOrgSlugChecking: false,
            newOrgSlugStatus: null,
            newOrgSlugSuggestion: null
        });
        return;
    }
    root.update({
        newOrgSlugChecking: true,
        newOrgSlugStatus: null
    });
    $2535a1544b0da584$var$_slugDebounceTimer = setTimeout(async ()=>{
        $2535a1544b0da584$var$_slugDebounceTimer = null;
        const available = await $2535a1544b0da584$var$_checkSlugAvailable(base);
        if (available === true) root.update({
            newOrgSlug: base,
            newOrgSlugChecking: false,
            newOrgSlugStatus: 'available',
            newOrgSlugSuggestion: null
        });
        else if (available === false) {
            const suggestion = await $2535a1544b0da584$var$_findAvailableSlug(base);
            root.update({
                newOrgSlug: suggestion || base,
                newOrgSlugChecking: false,
                newOrgSlugStatus: suggestion ? 'suggested' : 'taken',
                newOrgSlugSuggestion: suggestion
            });
        } else // Network error — allow user to proceed; server is the final arbiter.
        root.update({
            newOrgSlugChecking: false,
            newOrgSlugStatus: 'error'
        });
    }, 350);
}
// ── createOrganization (AC3 + AC4) ─────────────────────────────────────────
async function $2535a1544b0da584$var$createOrganization(root) {
    const name = (root?.newOrgName || '').trim();
    // Use the live-check resolved slug when available; otherwise derive from name.
    const slug = (root?.newOrgSlug || $2535a1544b0da584$var$slugify(name)).trim();
    if (!name || !slug) {
        root.update({
            newOrgError: 'Name and slug are required'
        });
        return;
    }
    root.update({
        newOrgBusy: true,
        newOrgError: null,
        newOrgSlugConflict: null
    });
    try {
        const sdk = (0, $bfqVY.getSDK)();
        const org = await sdk.createOrganization({
            name: name,
            slug: slug
        });
        // Reload projects so the new workspace shows up in the sidebar, then
        // activate it (even though it has no projects yet — the workspace page
        // will just render an empty board).
        await $2535a1544b0da584$var$loadProjects({
            root: root
        });
        const newSlug = org?.slug || slug;
        (0, $82nyI.setPref)((0, $82nyI.ACTIVE_ORG), newSlug);
        root.update({
            activeWorkspace: newSlug,
            newOrgModalOpen: null,
            newOrgName: '',
            newOrgSlug: '',
            newOrgSlugDirty: false,
            newOrgSlugChecking: false,
            newOrgSlugStatus: null,
            newOrgSlugSuggestion: null,
            newOrgSlugConflict: null,
            newOrgBusy: false
        });
    } catch (err) {
        // AC4: detect slug_taken specifically — never swallow it as a generic error.
        const isSlugTaken = err?.message === 'slug_taken' || err?.message?.includes('slug_taken') || err?.message?.toLowerCase().includes('slug') && err?.message?.toLowerCase().includes('taken');
        if (isSlugTaken) {
            // AC2 / AC3: race-condition 409 after live check passed. Find next free
            // suffix and surface a one-click "Use <slug-N>" button (never silent).
            const suggestion = await $2535a1544b0da584$var$_findAvailableSlug(slug);
            root.update({
                newOrgBusy: false,
                newOrgError: `Slug "${slug}" was just taken.`,
                newOrgSlugConflict: slug,
                newOrgSlug: suggestion || slug,
                newOrgSlugSuggestion: suggestion,
                newOrgSlugStatus: suggestion ? 'suggested' : 'taken'
            });
            return;
        }
        root.update({
            newOrgBusy: false,
            newOrgError: err?.message || 'Failed to create organization'
        });
    }
}
const $2535a1544b0da584$var$VISIBLE_PER_ROW = 6;
async function $2535a1544b0da584$var$loadProjects(s, el) {
    const root = s.root || s;
    try {
        const sdk = (0, $bfqVY.getSDK)();
        // Wait for the first init promise — calling initialize() again would
        // wipe the auth session per sdk.js notes.
        await (0, $bfqVY.awaitSDKInit)();
        const token = sdk.getAuthToken?.();
        if (!token) {
            if (el?.router) el.router('/signin', el.getRoot());
            else root.update({
                projects: [],
                projectsError: 'Not signed in'
            });
            return;
        }
        // `/projects` has canonical owner info (user vs org); `getUserProjects()`
        // flattens every project onto a user-level owner even when it's org-owned
        // and that breaks workspace grouping. Let errors from these SDK calls
        // bubble to the outer catch so the UI surfaces a real reason instead of
        // silently rendering "0 workspaces". The profile + orgs fetches are
        // sessionStorage-cached to keep multi-tab reloads from hammering the API
        // past its rate limit.
        const [profile, orgs, all] = await Promise.all([
            (0, $bfqVY.getUserProfileCached)(),
            (0, $bfqVY.listOrganizationsCached)(),
            (0, $ecua9.getAllProjectsCached)()
        ]);
        const userSlug = profile?.username;
        // `listOrganizations` returns every org in the system (each user has
        // their own `type: 'personal'` shadow org). Filter down to orgs the
        // signed-in user actually owns or is a member of — and drop the user's
        // own `type: 'personal'` shadow org so it doesn't collide with the
        // real personal workspace row in the sidebar.
        const myOrgs = (orgs || []).filter((o)=>{
            const mine = o?.ownerUser?.username === userSlug || o?.owner?.username === userSlug || (o?.members || []).some((m)=>m?.user?.username === userSlug);
            if (!mine) return false;
            if (o?.type === 'personal' && o?.slug === userSlug) return false;
            return true;
        });
        const orgSlugs = new Set(myOrgs.map((o)=>o.slug).filter(Boolean));
        const projects = (all || []).filter((p)=>{
            const o = p?.owner;
            if (!o) return false;
            if (o.type === 'organization') return orgSlugs.has(o.slug);
            return o.username && o.username === userSlug;
        });
        // Default active workspace = first workspace (user's personal if present).
        const workspaces = (0, $aJaZ5.groupByOwner)(projects);
        const savedOrg = (0, $82nyI.getPref)((0, $82nyI.ACTIVE_ORG));
        const savedValid = savedOrg && (savedOrg === userSlug || myOrgs.some((o)=>o.slug === savedOrg) || workspaces.some((w)=>w.owner === savedOrg));
        const activeWorkspace = root.activeWorkspace || (savedValid ? savedOrg : null) || workspaces.find((w)=>w.owner === userSlug)?.owner || workspaces[0]?.owner || null;
        root.update({
            projects: projects,
            orgs: myOrgs,
            activeWorkspace: activeWorkspace,
            userSlug: userSlug,
            projectsError: null
        });
        // The dashboard renders only the sidebar + an empty StudiosEmbed
        // placeholder — it does NOT show the workspace board, so we avoid
        // pre-warming loadNodes here. doLoadNodes triggers fetchServerPositions
        // which fans out one full getProjectData call per own project (just to
        // read canvasPosition), which manifests as a request storm on dashboards
        // with even a handful of projects. The studios page calls loadNodes
        // itself once the user actually navigates to /studio/{slug}.
        if (activeWorkspace) $2535a1544b0da584$var$loadOrgMembers(root, activeWorkspace);
    } catch (err) {
        console.warn('[dashboard] loadProjects failed:', err);
        const msg = err?.message || '';
        const isAuthErr = /no token|log in|unauthorized|unauthenticated/i.test(msg);
        if (isAuthErr && el?.router) {
            // Clear the stale token so applyAuthGuard won't bounce back to /dashboard
            // on the next full page load while at /signin.
            try {
                (0, $bfqVY.getSDK)().logout();
            } catch  {}
            (0, $bfqVY.invalidateUserDataCache)();
            el.router('/signin', el.getRoot());
            return;
        }
        root.update({
            projects: [],
            projectsError: msg || 'Failed to load projects'
        });
    }
}
// Per MODEL.md an Organization owns 1..N Workspaces. Fetch the list on
// demand when the org row expands so the picker knows whether to show
// "default" (solo workspace) or a multi-pick strip.
async function $2535a1544b0da584$var$loadOrgWorkspaces(root, org) {
    if (!org?.id) return;
    const orgId = org.id;
    const existing = root?.workspacesByOrg || {};
    if (existing[orgId]) return;
    try {
        const sdk = (0, $bfqVY.getSDK)();
        const res = await sdk.listWorkspaces({
            organization: orgId
        });
        const list = Array.isArray(res) ? res : res?.data || res?.workspaces || [];
        root.update({
            workspacesByOrg: {
                ...root.workspacesByOrg || {},
                [orgId]: list
            }
        });
    } catch (err) {
        console.warn('[dashboard] loadOrgWorkspaces failed:', org.slug, err?.message || err);
        // Cache an empty array so we don't retry on every expand — user can
        // refresh to retry.
        root.update({
            workspacesByOrg: {
                ...root.workspacesByOrg || {},
                [orgId]: []
            }
        });
    }
}
async function $2535a1544b0da584$var$createOrgWorkspace(root, org, el) {
    if (!org?.id) return;
    const name = (window.prompt('Name for this workspace?', 'New workspace') || '').trim();
    if (!name) return;
    const slug = name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || null;
    try {
        const sdk = (0, $bfqVY.getSDK)();
        const created = await sdk.createWorkspace({
            organization: org.id,
            displayName: name,
            slug: slug
        });
        const ws = created?.data || created;
        const prev = root.workspacesByOrg?.[org.id] || [];
        root.update({
            workspacesByOrg: {
                ...root.workspacesByOrg || {},
                [org.id]: [
                    ...prev,
                    ws
                ]
            },
            activeWorkspaceId: ws?._id || ws?.id || null
        });
    } catch (err) {
        // Surface failures through the shared notification system instead of a
        // browser-modal alert(). Falls back to console.error if `el` isn't
        // available (e.g. legacy callers) so the user is never silently stuck.
        const message = err?.message || String(err);
        if (el?.call) el.call('openNotification', {
            title: 'Create workspace failed',
            message: message,
            type: 'error'
        });
        else console.error('[dashboard] createOrgWorkspace failed:', message);
    }
}
async function $2535a1544b0da584$var$loadOrgMembers(root, slug) {
    const org = (root?.orgs || []).find((o)=>o.slug === slug);
    if (!org) {
        // Slug isn't an org (it's the user's personal workspace) — clear the
        // stale member list so the PeopleSection hides.
        root.update({
            orgMembers: null,
            orgMembersSlug: slug
        });
        return;
    }
    if (root?.orgMembersSlug === slug && root?.orgMembers) return;
    root.update({
        orgMembers: null,
        orgMembersSlug: slug
    });
    try {
        const sdk = (0, $bfqVY.getSDK)();
        const members = await sdk.listOrgMembers(org.id);
        // `listOrgMembers` sometimes returns the bare array, sometimes `{data}`.
        const list = Array.isArray(members) ? members : members?.data || [];
        // Only commit if the active workspace hasn't changed in the meantime.
        if (root?.activeWorkspace === slug) root.update({
            orgMembers: list,
            orgMembersSlug: slug
        });
    } catch (err) {
        console.warn('[dashboard] loadOrgMembers failed:', err);
        if (root?.activeWorkspace === slug) root.update({
            orgMembers: [],
            orgMembersSlug: slug
        });
    }
}
const $2535a1544b0da584$var$workspaceSummary = (s)=>{
    if (s.root?.projectsError) return 'Error: ' + s.root.projectsError;
    if (!s.root?.projects) return "Loading your projects\u2026";
    const n = s.root.projects.length;
    return n ? `${n} project${n === 1 ? '' : 's'} across your workspaces` : 'No projects yet';
};
// The signed-in user's personal workspace — at most one entry. Returns an
// empty-items placeholder if the user has no personal projects yet so the
// row still renders.
const $2535a1544b0da584$var$personalWorkspaces = (root)=>{
    const userSlug = root?.userSlug;
    if (!userSlug) return [];
    const grouped = (0, $aJaZ5.groupByOwner)(root?.projects || []);
    const personal = grouped.find((w)=>w.owner === userSlug);
    return personal ? [
        personal
    ] : [
        {
            owner: userSlug,
            items: []
        }
    ];
};
// Orgs the user owns or is a member of. `root.orgs` is pre-filtered in
// `loadProjects`; we additionally drop any `type: 'personal'` shadow org
// whose slug matches the user's username so it doesn't duplicate the
// personal workspace row.
const $2535a1544b0da584$var$orgWorkspaces = (root)=>{
    const userSlug = root?.userSlug;
    const userOrgs = (root?.orgs || []).filter((o)=>!(o?.type === 'personal' && o?.slug === userSlug));
    const allowed = new Set(userOrgs.map((o)=>o.slug).filter(Boolean));
    const orgsWithProjects = (0, $aJaZ5.groupByOwner)(root?.projects || []).filter((w)=>w.owner !== userSlug && allowed.has(w.owner));
    const seen = new Set(orgsWithProjects.map((w)=>w.owner));
    const emptyOrgs = userOrgs.filter((o)=>o.slug && !seen.has(o.slug)).map((o)=>({
            owner: o.slug,
            items: []
        }));
    return [
        ...orgsWithProjects,
        ...emptyOrgs
    ];
};
const $2535a1544b0da584$var$activeOrg = (root)=>(root?.orgs || []).find((o)=>o.slug === root?.activeWorkspace) || null;
const $2535a1544b0da584$export$a5f98448b9315739 = {
    tag: 'main',
    id: 'main-content',
    extends: 'AppPage',
    metadata: {
        title: 'Dashboard / Symbols.app'
    },
    gridRow: '2',
    gridColumn: '1 / -1',
    minHeight: '0',
    height: '100%',
    overflow: 'hidden',
    color: 'title',
    onRender: (el, s)=>{
        if (el.__dashLoaded) return;
        el.__dashLoaded = true;
        $2535a1544b0da584$var$loadProjects(s, el);
    },
    AppSidebar: {
        WorkspacesSection: {
            flow: 'y',
            gap: 'Y',
            PersonalCaption: {
                extends: 'CaptionTitle',
                Text: {
                    text: 'Personal'
                }
            },
            PersonalList: {
                flow: 'y',
                gap: 'V',
                children: (el, s)=>$2535a1544b0da584$var$personalWorkspaces(s.root),
                childrenAs: 'state',
                childExtends: 'WorkspaceRowButton'
            },
            OrgsCaption: {
                extends: 'CaptionTitle',
                marginTop: 'Z',
                Text: {
                    text: 'Organizations'
                }
            },
            OrgsList: {
                flow: 'y',
                gap: 'V',
                children: (el, s)=>$2535a1544b0da584$var$orgWorkspaces(s.root),
                childrenAs: 'state',
                childExtends: 'OrgRow'
            },
            NewOrgButton: {
                tag: 'button',
                type: 'button',
                marginTop: 'Y',
                padding: 'Y Z1',
                round: 'Z',
                fontSize: 'Z1',
                fontWeight: '500',
                color: 'caption',
                flow: 'x',
                align: 'center center',
                gap: 'Y',
                cursor: 'pointer',
                border: '0',
                background: 'overlay',
                ':hover': {
                    background: 'overlayStrong',
                    color: 'title'
                },
                onClick: (e, el, s)=>s.root.update({
                        newOrgModalOpen: true,
                        newOrgError: null
                    }),
                PlusIcon: {
                    tag: 'span',
                    text: '+',
                    fontWeight: '600'
                },
                Label: {
                    tag: 'span',
                    text: 'New organization'
                }
            }
        },
        // Marketplace browse section. Mirrors MarketplaceSidebar's KINDS so
        // dashboard users can jump straight into a kind-filtered marketplace
        // view without first opening /marketplace and scanning the sidebar.
        // Each row deep-links to /marketplace?kind=X — the canvas marketplace
        // page reads the param on mount and seeds `root.activeKind`.
        MarketplaceSection: {
            flow: 'y',
            gap: 'Y',
            marginTop: 'Z',
            MarketplaceCaption: {
                extends: 'CaptionTitle',
                Text: {
                    text: 'Marketplace'
                }
            },
            MarketplaceList: {
                flow: 'y',
                gap: 'V',
                children: (el, s)=>[
                        {
                            kind: 'all',
                            label: 'Browse all'
                        },
                        {
                            kind: 'library',
                            label: 'Libraries'
                        },
                        {
                            kind: 'template',
                            label: 'Templates'
                        },
                        {
                            kind: 'integration',
                            label: 'Integrations'
                        },
                        {
                            kind: 'registrar',
                            label: 'Domain Registrars'
                        },
                        {
                            kind: 'plugin',
                            label: 'Plugins'
                        }
                    ],
                childrenAs: 'state',
                childExtends: 'MarketplaceKindLink'
            }
        },
        // People in the active org — shown only when `activeWorkspace` matches a
        // known organization slug. Extends the shared `PeopleSection` shell
        // (scrollable column) that governance uses for its own sidebar. We
        // override its `flex: 1` so when the member list is short the section
        // sits intrinsic-height near the top; when it's long enough to overflow,
        // the parent flex still lets it grow + scroll inside.
        PeopleSection: {
            extends: 'PeopleSection',
            hide: (el, s)=>!$2535a1544b0da584$var$activeOrg(s.root),
            flex: '0 1 auto',
            minHeight: '0',
            maxHeight: '50%',
            TeamGroup: {
                extends: 'PeopleGroup',
                groupName: 'team',
                CaptionTitle: {
                    Text: {
                        text: (el, s)=>($2535a1544b0da584$var$activeOrg(s.root)?.name || 'People').toUpperCase()
                    }
                },
                List: {
                    children: (el, s)=>s.root?.orgMembers || []
                }
            },
            Loading: {
                if: (el, s)=>$2535a1544b0da584$var$activeOrg(s.root) && s.root?.orgMembers == null,
                tag: 'span',
                padding: 'Y Z1',
                fontSize: 'Z',
                color: 'caption',
                text: "Loading\u2026"
            },
            Empty: {
                if: (el, s)=>$2535a1544b0da584$var$activeOrg(s.root) && Array.isArray(s.root?.orgMembers) && s.root.orgMembers.length === 0,
                tag: 'span',
                padding: 'Y Z1',
                fontSize: 'Z',
                color: 'caption',
                text: 'No members yet'
            }
        }
    },
    AppMain: {
        padding: '0',
        margin: '0',
        overflow: 'hidden',
        Body: {
            padding: '0',
            overflow: 'hidden',
            StudiosEmbed: {
                position: 'relative',
                width: '100%',
                height: '100%'
            }
        }
    },
    NewOrgModal: {
        extends: 'Modal',
        stateKey: 'newOrgModalOpen',
        // Reset all new-org state when modal is closed.
        extraClose: {
            newOrgError: null,
            newOrgName: '',
            newOrgSlug: '',
            newOrgSlugDirty: false,
            newOrgSlugChecking: false,
            newOrgSlugStatus: null,
            newOrgSlugSuggestion: null,
            newOrgSlugConflict: null
        },
        Window: {
            extends: 'ModalWindow',
            ModalHeader: {
                title: 'New organization'
            },
            Hint: {
                tag: 'p',
                text: 'Creates a new workspace you own. You can invite members and add projects afterwards.',
                fontSize: 'Z',
                color: 'caption',
                margin: '0'
            },
            NameField: {
                flow: 'y',
                gap: 'V',
                Label: {
                    tag: 'label',
                    text: 'Name',
                    fontSize: 'Z',
                    color: 'caption'
                },
                Input: {
                    tag: 'input',
                    type: 'text',
                    placeholder: 'Acme Inc',
                    padding: 'Y Z1',
                    round: 'Z',
                    border: '1px solid line',
                    background: 'overlay',
                    color: 'title',
                    fontSize: 'Z1',
                    value: (el, s)=>s.root?.newOrgName || '',
                    autofocus: true,
                    onInput: (e, el, s)=>{
                        const name = e.target.value;
                        const wasSlugDirty = !!s.root?.newOrgSlugDirty;
                        const patch = {
                            newOrgName: name,
                            newOrgError: null,
                            newOrgSlugConflict: null
                        };
                        // AC1: auto-derive slug from name and trigger live availability
                        // check as long as the user hasn't manually edited the slug field.
                        if (!wasSlugDirty) {
                            patch.newOrgSlug = $2535a1544b0da584$var$slugify(name);
                            patch.newOrgSlugDirty = false;
                        }
                        s.root.update(patch);
                        // Sync slug input DOM value immediately when auto-deriving — onRender
                        // only fires on explicit DOMQL re-renders so the input would otherwise
                        // keep showing the old/placeholder value until the next full render cycle.
                        if (!wasSlugDirty) {
                            const derivedSlug = $2535a1544b0da584$var$slugify(name);
                            const slugInput = el.getRoot()?.node?.querySelector('input[name="newOrgSlug"]');
                            if (slugInput) slugInput.value = derivedSlug;
                        }
                        // Schedule availability check using the resolved slug.
                        if (!wasSlugDirty) $2535a1544b0da584$var$_scheduleSlugCheck(name, s.root);
                    }
                }
            },
            // AC1: slug field with live availability indicator (debounced 350 ms).
            SlugField: {
                flow: 'y',
                gap: 'V',
                Label: {
                    tag: 'label',
                    text: 'Slug (used in URLs)',
                    fontSize: 'Z',
                    color: 'caption'
                },
                SlugRow: {
                    flow: 'x',
                    gap: 'Z',
                    align: 'center left',
                    Input: {
                        tag: 'input',
                        name: 'newOrgSlug',
                        type: 'text',
                        placeholder: 'acme',
                        padding: 'Y Z1',
                        round: 'Z',
                        border: (el, s)=>{
                            const st = s.root?.newOrgSlugStatus;
                            if (st === 'taken') return '1px solid red';
                            if (st === 'available') return '1px solid green';
                            return '1px solid line';
                        },
                        background: 'overlay',
                        color: 'title',
                        fontSize: 'Z1',
                        fontFamily: 'monospace',
                        flex: '1',
                        // Keep DOM value in sync when auto-derived slug changes.
                        onRender: (el, s)=>{
                            if (s.root?.newOrgSlugDirty) return;
                            const slug = s.root?.newOrgSlug || '';
                            if (el.node && el.node.value !== slug) el.node.value = slug;
                        },
                        onInput: (e, el, s)=>{
                            const val = $2535a1544b0da584$var$slugify(e.target.value);
                            e.target.value = val;
                            s.root.update({
                                newOrgSlug: val,
                                newOrgSlugDirty: true,
                                newOrgError: null,
                                newOrgSlugConflict: null
                            });
                            // AC1: trigger availability check on manual slug edit.
                            $2535a1544b0da584$var$_scheduleSlugCheck(val, s.root);
                        }
                    },
                    // AC1: inline status indicator (available / taken / auto-adjusted).
                    SlugStatus: {
                        tag: 'span',
                        fontSize: 'Y2',
                        whiteSpace: 'nowrap',
                        hide: (el, s)=>!s.root?.newOrgSlug,
                        color: (el, s)=>{
                            if (s.root?.newOrgSlugChecking) return 'caption';
                            const st = s.root?.newOrgSlugStatus;
                            if (st === 'available') return 'green';
                            if (st === 'taken') return 'red';
                            if (st === 'suggested') return 'yellow';
                            return 'caption';
                        },
                        text: (el, s)=>{
                            if (s.root?.newOrgSlugChecking) return "checking\u2026";
                            const st = s.root?.newOrgSlugStatus;
                            if (st === 'available') return 'available';
                            if (st === 'taken') return 'taken';
                            if (st === 'suggested') return 'auto-adjusted';
                            return '';
                        }
                    }
                },
                // AC2 / AC3: shown when live check or POST found slug taken.
                // Displays a one-click "Use <slug-N>" button for the auto-suffix.
                SlugHint: {
                    hide: (el, s)=>{
                        const st = s.root?.newOrgSlugStatus;
                        const conflict = s.root?.newOrgSlugConflict;
                        return st !== 'suggested' && st !== 'taken' && !conflict;
                    },
                    flow: 'x',
                    align: 'center left',
                    gap: 'Z',
                    margin: 'V 0 0',
                    HintText: {
                        tag: 'span',
                        fontSize: 'Y2',
                        color: 'caption',
                        flex: '1',
                        text: (el, s)=>{
                            const sug = s.root?.newOrgSlugSuggestion;
                            const conflict = s.root?.newOrgSlugConflict;
                            if (conflict && sug) return `"${conflict}" was just taken \u{2014} try "${sug}" instead.`;
                            if (conflict) return `"${conflict}" is taken. Edit the slug above to pick a different one.`;
                            if (sug) return `Slug auto-adjusted to "${sug}" \u{2014} available and ready.`;
                            return 'This slug is taken. Edit it above.';
                        }
                    },
                    // One-click: apply the suggested suffix directly.
                    UseSlugBtn: {
                        tag: 'button',
                        type: 'button',
                        hide: (el, s)=>!s.root?.newOrgSlugSuggestion,
                        padding: 'V Z1',
                        round: 'Y',
                        background: 'overlay',
                        color: 'title',
                        fontWeight: '600',
                        fontSize: 'Y2',
                        border: '1px solid line',
                        cursor: 'pointer',
                        ':hover': {
                            background: 'overlay'
                        },
                        text: (el, s)=>{
                            const sug = s.root?.newOrgSlugSuggestion;
                            return sug ? `Use "${sug}"` : '';
                        },
                        onClick: (e, el, s)=>{
                            e.preventDefault();
                            const sug = s.root?.newOrgSlugSuggestion;
                            if (!sug) return;
                            s.root.update({
                                newOrgSlug: sug,
                                newOrgSlugDirty: true,
                                newOrgSlugStatus: 'available',
                                newOrgSlugSuggestion: null,
                                newOrgSlugConflict: null,
                                newOrgError: null
                            });
                            // Sync DOM input value immediately.
                            const slugInput = el.getRoot()?.node?.querySelector('input[name="newOrgSlug"]');
                            if (slugInput) slugInput.value = sug;
                        }
                    }
                }
            },
            Error: {
                if: (el, s)=>!!s.root?.newOrgError,
                tag: 'p',
                text: (el, s)=>s.root?.newOrgError,
                color: 'red',
                fontSize: 'Z',
                margin: 'Z 0 0'
            },
            ModalFooter: {
                extends: 'ModalFooter',
                flow: 'x',
                gap: 'Y',
                align: 'center right',
                Cancel: {
                    tag: 'button',
                    type: 'button',
                    text: 'Cancel',
                    padding: 'Y A',
                    round: 'Z',
                    border: '1px solid line',
                    background: 'transparent',
                    color: 'title',
                    cursor: 'pointer',
                    ':hover': {
                        background: 'overlay'
                    },
                    onClick: (e, el, s)=>s.root.update({
                            newOrgModalOpen: null,
                            newOrgError: null,
                            newOrgName: '',
                            newOrgSlug: '',
                            newOrgSlugDirty: false,
                            newOrgSlugChecking: false,
                            newOrgSlugStatus: null,
                            newOrgSlugSuggestion: null,
                            newOrgSlugConflict: null
                        })
                },
                Create: {
                    tag: 'button',
                    type: 'submit',
                    text: (el, s)=>s.root?.newOrgBusy ? "Creating\u2026" : 'Create',
                    padding: 'Y A',
                    round: 'Z',
                    border: '0',
                    background: 'blue',
                    color: 'white',
                    cursor: 'pointer',
                    fontWeight: '500',
                    // AC1: disable while slug check is in flight so user can't race-submit.
                    disabled: (el, s)=>!!s.root?.newOrgBusy || !!s.root?.newOrgSlugChecking || s.root?.newOrgSlugStatus === 'taken' || !((s.root?.newOrgName || '').trim() && (s.root?.newOrgSlug || '').trim()),
                    ':hover': {
                        background: 'blue+8'
                    },
                    onClick: (e, el, s)=>$2535a1544b0da584$var$createOrganization(s.root)
                }
            }
        }
    }
};
const $2535a1544b0da584$var$selectWorkspace = (root, owner)=>{
    root.update({
        activeWorkspace: owner
    });
    (0, $82nyI.setPref)((0, $82nyI.ACTIVE_ORG), owner);
    // No pre-warm of loadNodes here — the dashboard sidebar doesn't render
    // workspace nodes/positions/integrations, and doLoadNodes triggers an
    // expensive getProjectData fan-out per own project (see comment in
    // loadProjects above). The studios page loads on demand when the user
    // navigates to /studio/{slug}.
    $2535a1544b0da584$var$loadOrgMembers(root, owner);
};
const $2535a1544b0da584$var$workspaceRowStyle = {
    tag: 'button',
    type: 'button',
    padding: 'Y Z1',
    round: 'Z',
    fontSize: 'Z1',
    color: 'title',
    flow: 'x',
    align: 'center space-between',
    gap: 'Z',
    cursor: 'pointer',
    border: '0',
    textAlign: 'left',
    background: (el, s)=>s.root?.activeWorkspace === s.owner ? 'white.1' : 'transparent',
    fontWeight: (el, s)=>s.root?.activeWorkspace === s.owner ? '600' : '500',
    ':hover': {
        background: 'overlay'
    }
};
const $2535a1544b0da584$export$baa01e64aa512438 = {
    ...$2535a1544b0da584$var$workspaceRowStyle,
    onClick: (e, el, s)=>$2535a1544b0da584$var$selectWorkspace(s.root, s.owner),
    Name: {
        tag: 'span',
        text: (el, s)=>s.owner,
        flex: '1'
    },
    Count: {
        tag: 'span',
        fontSize: 'Z',
        color: 'caption',
        text: (el, s)=>String(s.items?.length || 0)
    }
};
const $2535a1544b0da584$export$1c4cf8ca52e99afb = {
    flow: 'y',
    gap: 'V',
    Header: {
        ...$2535a1544b0da584$var$workspaceRowStyle,
        onClick: (e, el, s)=>$2535a1544b0da584$var$selectWorkspace(s.root, s.owner),
        Name: {
            tag: 'span',
            text: (el, s)=>s.owner,
            flex: '1'
        },
        Count: {
            tag: 'span',
            fontSize: 'Z',
            color: 'caption',
            text: (el, s)=>String(s.items?.length || 0)
        },
        Caret: {
            tag: 'span',
            padding: 'V',
            margin: '- -V - -',
            round: 'X',
            fontSize: 'Z',
            color: 'caption',
            cursor: 'pointer',
            transition: 'B transform defaultBezier',
            transform: (el, s)=>s.root?.expandedOrgs?.[s.owner] ? 'rotate(180deg)' : 'rotate(0deg)',
            ':hover': {
                color: 'title'
            },
            text: "\u25BE",
            onClick: (e, el, s)=>{
                e.stopPropagation();
                const cur = s.root?.expandedOrgs || {};
                const willOpen = !cur[s.owner];
                s.root.update({
                    expandedOrgs: {
                        ...cur,
                        [s.owner]: willOpen
                    }
                });
                if (willOpen) {
                    const org = (s.root?.orgs || []).find((o)=>o.slug === s.owner);
                    if (org) $2535a1544b0da584$var$loadOrgWorkspaces(s.root, org);
                }
            }
        }
    },
    // Workspace picker — hidden when org has 1 workspace (default only);
    // shown as chips + "+" when 2+. Per MODEL.md each Workspace = separate
    // subscription, so "+" triggers a create flow (Pro/Scale upgrade
    // required on personal orgs — surfaced by the API if not allowed).
    WorkspacesPicker: {
        if: (el, s)=>!!s.root?.expandedOrgs?.[s.owner],
        flow: 'x',
        gap: 'V',
        padding: 'V - V A',
        align: 'center left',
        flexWrap: 'wrap',
        DefaultChip: {
            if: (el, s)=>{
                const org = (s.root?.orgs || []).find((o)=>o.slug === s.owner);
                const list = org && s.root?.workspacesByOrg?.[org.id];
                return !list || list.length <= 1;
            },
            tag: 'span',
            padding: 'V Y',
            round: 'X',
            fontSize: 'Z',
            color: 'caption',
            background: 'overlay',
            text: 'default'
        },
        Chips: {
            if: (el, s)=>{
                const org = (s.root?.orgs || []).find((o)=>o.slug === s.owner);
                const list = org && s.root?.workspacesByOrg?.[org.id];
                return !!(list && list.length > 1);
            },
            flow: 'x',
            gap: 'V',
            flexWrap: 'wrap',
            children: (el, s)=>{
                const org = (s.root?.orgs || []).find((o)=>o.slug === s.owner);
                return org && s.root?.workspacesByOrg?.[org.id] || [];
            },
            childrenAs: 'state',
            childExtends: 'WorkspaceChip'
        },
        AddBtn: {
            tag: 'button',
            type: 'button',
            padding: 'V Y',
            round: 'X',
            fontSize: 'Z',
            color: 'caption',
            background: 'transparent',
            border: '1px dashed line',
            cursor: 'pointer',
            ':hover': {
                color: 'title',
                background: 'overlay'
            },
            title: 'Create workspace',
            text: '+',
            onClick: (e, el, s)=>{
                e.stopPropagation();
                const org = (s.root?.orgs || []).find((o)=>o.slug === s.owner);
                if (org) $2535a1544b0da584$var$createOrgWorkspace(s.root, org, el);
            }
        }
    },
    ProjectsList: {
        if: (el, s)=>!!s.root?.expandedOrgs?.[s.owner],
        flow: 'y',
        gap: 'V',
        padding: 'V - V A',
        children: (el, s)=>s.items || [],
        childrenAs: 'state',
        childExtends: 'OrgProjectRow'
    }
};
const $2535a1544b0da584$export$56e04c7e8c2b1c1a = {
    tag: 'button',
    type: 'button',
    padding: 'V Y',
    round: 'X',
    fontSize: 'Z',
    border: '0',
    cursor: 'pointer',
    background: (el, s)=>s.root?.activeWorkspaceId === (s._id || s.id) ? 'white.1' : 'overlay',
    color: (el, s)=>s.root?.activeWorkspaceId === (s._id || s.id) ? 'title' : 'caption',
    fontWeight: (el, s)=>s.root?.activeWorkspaceId === (s._id || s.id) ? '600' : '500',
    ':hover': {
        color: 'title',
        background: 'overlayStrong'
    },
    text: (el, s)=>s.displayName || s.slug || 'workspace',
    onClick: (e, el, s)=>{
        e.stopPropagation();
        s.root.update({
            activeWorkspaceId: s._id || s.id || null
        });
    }
};
const $2535a1544b0da584$export$31b0ed2a770c9221 = {
    tag: 'button',
    type: 'button',
    padding: 'V Z1',
    round: 'Z',
    fontSize: 'Z',
    color: 'caption',
    flow: 'x',
    align: 'center left',
    gap: 'Y',
    cursor: 'pointer',
    border: '0',
    textAlign: 'left',
    background: 'transparent',
    ':hover': {
        background: 'overlay',
        color: 'title'
    },
    onClick: (e, el, s)=>{
        const owner = (0, $aJaZ5.ownerSlug)(s);
        const key = (0, $aJaZ5.projectKey)(s);
        if (owner && key) el.router(`/${owner}/${key}`, el.getRoot());
    },
    Name: {
        tag: 'span',
        text: (el, s)=>s.name || s.key,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        flex: '1'
    }
};
const $2535a1544b0da584$export$4605b1bda9c939cb = {
    tag: 'button',
    type: 'button',
    padding: 'Y Z1',
    round: 'Z',
    fontSize: 'Z1',
    color: 'title',
    flow: 'x',
    align: 'center left',
    gap: 'Z',
    cursor: 'pointer',
    border: '0',
    textAlign: 'left',
    background: (el, s)=>{
        const path = s.root?.currentPath || '';
        if (path !== '/marketplace') return 'transparent';
        const search = s.root?.currentSearch || '';
        const kind = new URLSearchParams(search).get('kind') || 'all';
        return kind === s.kind ? 'white.1' : 'transparent';
    },
    fontWeight: (el, s)=>{
        const path = s.root?.currentPath || '';
        if (path !== '/marketplace') return '500';
        const search = s.root?.currentSearch || '';
        const kind = new URLSearchParams(search).get('kind') || 'all';
        return kind === s.kind ? '600' : '500';
    },
    ':hover': {
        background: 'overlay'
    },
    text: (el, s)=>s.label,
    onClick: (e, el, s)=>{
        const target = s.kind === 'all' ? '/marketplace' : `/marketplace?kind=${s.kind}`;
        el.router(target, el.getRoot());
    }
};
const $2535a1544b0da584$export$7daf49340bc38a02 = {
    tag: 'div',
    flow: 'x',
    gap: 'Y',
    align: 'center left',
    padding: 'Y Z1',
    round: 'Z',
    fontSize: 'Z',
    color: 'title',
    ':hover': {
        background: 'overlay'
    },
    Avatar: {
        extends: 'Avatar',
        avatarType: 'initials',
        boxSize: 'A A',
        src: (el, s)=>el.call('avatarUrlFor', s?.email || s?.user?.email)
    },
    Info: {
        flow: 'y',
        gap: '0',
        flex: '1',
        minWidth: '0',
        Name: {
            tag: 'span',
            fontSize: 'Z',
            fontWeight: '500',
            text: (el, s)=>s?.name || s?.user?.name || s?.email || s?.user?.email || "\u2014",
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        },
        Role: {
            if: (el, s)=>!!(s?.role || s?.membership?.role),
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            text: (el, s)=>s?.role || s?.membership?.role
        }
    }
};
const $2535a1544b0da584$export$2f4ba8132e14ff17 = {
    flow: 'column',
    gap: 'Y2',
    padding: 'A',
    round: 'C1',
    theme: 'canvas-card-glass',
    border: '1px solid rgba(255,255,255,0.08)',
    Head: {
        flow: 'x',
        align: 'center space-between',
        gap: 'Y',
        cursor: 'pointer',
        onClick: (e, el, s)=>el.router('/studio/' + s.owner, el.getRoot()),
        TitleRow: {
            flow: 'x',
            align: 'center',
            gap: 'Y',
            Name: {
                tag: 'h2',
                text: (el, s)=>s.owner,
                fontSize: 'B',
                fontWeight: '600',
                letterSpacing: '-0.01em'
            },
            Count: {
                tag: 'span',
                text: (el, s)=>(s.items?.length || 0) + ' project' + (s.items?.length === 1 ? '' : 's'),
                fontSize: 'Z',
                color: 'rgba(255,255,255,0.5)',
                padding: 'W Y',
                round: 'Z',
                background: 'rgba(255,255,255,0.06)'
            }
        },
        OpenBtn: {
            extends: 'Button',
            text: "Open workspace \u2192",
            padding: 'W Y',
            fontSize: 'Z',
            round: 'Z',
            border: '0',
            background: 'rgba(255,255,255,0.06)',
            color: 'white',
            ':hover': {
                background: 'rgba(255,255,255,0.12)'
            }
        }
    },
    Thumbs: {
        flow: 'x',
        gap: 'Y2',
        overflow: 'hidden',
        children: (el, s)=>(s.items || []).slice(0, $2535a1544b0da584$var$VISIBLE_PER_ROW),
        childrenAs: 'state',
        childExtends: 'WorkspaceThumb'
    },
    // Phase 3 — InstallableRail mounts replacing #4400 bespoke integration
    // list. scopeId resolves the org UUID from root.orgs by matching the
    // workspace owner slug.
    IntegrationsRail: {
        extends: 'InstallableRail',
        domain: 'integration',
        scopeType: 'org',
        scopeId: (el, s)=>{
            const org = (s.root?.orgs || []).find((o)=>o.slug === s.owner);
            return org?.id || org?._id || null;
        },
        title: 'Integrations',
        layout: 'grid',
        emptyHint: 'Add an integration available to your whole org',
        marginTop: 'Y'
    },
    TemplatesRail: {
        extends: 'InstallableRail',
        domain: 'template',
        scopeType: 'org',
        scopeId: (el, s)=>{
            const org = (s.root?.orgs || []).find((o)=>o.slug === s.owner);
            return org?.id || org?._id || null;
        },
        title: 'Featured templates',
        layout: 'grid',
        filter: {
            category: 'featured'
        },
        emptyHint: 'Browse and pin templates for quick access',
        marginTop: 'Y'
    }
};
const $2535a1544b0da584$export$cd840286e45bca4b = {
    flow: 'column',
    gap: 'W',
    flex: '1 1 0',
    minWidth: '0',
    cursor: 'pointer',
    textDecoration: 'none',
    color: 'inherit',
    round: 'A',
    overflow: 'hidden',
    border: '1px solid rgba(255,255,255,0.08)',
    background: 'rgba(255,255,255,0.03)',
    transition: 'B transform defaultBezier, B box-shadow defaultBezier',
    ':hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 12px 32px rgba(0,0,0,0.45)'
    },
    onClick: (e, el, s)=>{
        const owner = (0, $aJaZ5.ownerSlug)(s);
        const key = (s.key || '').split('.')[0];
        if (owner && key) el.router(`/${owner}/${key}`, el.getRoot());
    },
    Thumbnail: {
        width: '100%',
        aspectRatio: '16 / 10',
        // Image priority: explicit icon → stored thumbnail → rasterized
        // screenshot from `screenshots.symbo.ls` (prod only) → gradient
        // placeholder.
        background: (el, s)=>{
            const img = s.icon?.src || s.thumbnail || (0, $aJaZ5.projectScreenshotUrl)(s);
            return img ? `center / cover no-repeat url("${img}")` : 'linear-gradient(135deg,#2a2f38 0%,#1a1d24 55%,#0f1116 100%)';
        },
        position: 'relative',
        Placeholder: {
            // Always keep the letter fallback visible behind the image so a
            // failed screenshot fetch still shows something intelligible.
            if: (el, s)=>!(s.icon?.src || s.thumbnail),
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'rgba(255,255,255,0.5)',
            fontSize: 'B2',
            fontWeight: '700',
            text: (el, s)=>(s.name || s.key || '?').charAt(0).toUpperCase()
        }
    },
    Meta: {
        flow: 'column',
        gap: 'W',
        padding: 'Y2 Y2 A Y2',
        Name: {
            tag: 'span',
            text: (el, s)=>s.name || s.key,
            fontSize: 'Z1',
            fontWeight: '600',
            color: 'white',
            style: {
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            }
        },
        Key: {
            tag: 'span',
            text: (el, s)=>s.key || '',
            fontSize: 'Z',
            color: 'rgba(255,255,255,0.45)',
            fontFamily: 'monospace'
        }
    }
};

});
parcelRegister("82nyI", function(module, exports) {

$parcel$export(module.exports, "getPref", () => $5da0c8f70e8d9e9f$export$5a3d9fff44d1c4a0);
$parcel$export(module.exports, "setPref", () => $5da0c8f70e8d9e9f$export$e24d7c6b90493ae7);
$parcel$export(module.exports, "ACTIVE_ORG", () => $5da0c8f70e8d9e9f$export$d9ecd1289243d0da);
// Cross-app user preferences. Persisted in a parent-domain cookie so
// canvas (canvas.localhost / edit.symbols.app) and the workspace app
// (workspace.localhost / us-at.symbols.app) read the same value.
parcelRequire("cVasv");
var $bOdwG = parcelRequire("bOdwG");
const $5da0c8f70e8d9e9f$var$COOKIE_PREFIX = 'smbls_pref_';
const $5da0c8f70e8d9e9f$var$ONE_YEAR = 31536000;
function $5da0c8f70e8d9e9f$export$5a3d9fff44d1c4a0(key) {
    return (0, $bOdwG.readCookie)($5da0c8f70e8d9e9f$var$COOKIE_PREFIX + key);
}
function $5da0c8f70e8d9e9f$export$e24d7c6b90493ae7(key, value) {
    (0, $bOdwG.writeCookie)($5da0c8f70e8d9e9f$var$COOKIE_PREFIX + key, value, $5da0c8f70e8d9e9f$var$ONE_YEAR);
}
function $5da0c8f70e8d9e9f$export$40445c847c75de48(key) {
    (0, $bOdwG.writeCookie)($5da0c8f70e8d9e9f$var$COOKIE_PREFIX + key, null, 0);
}
const $5da0c8f70e8d9e9f$export$d9ecd1289243d0da = 'activeOrg';

});


parcelRegister("ikIYt", function(module, exports) {

$parcel$export(module.exports, "account", () => $d58cfb3ced40a24e$export$6b501c78a3684162);

var $bfqVY = parcelRequire("bfqVY");
async function $d58cfb3ced40a24e$var$loadProfile(root) {
    try {
        const profile = await (0, $bfqVY.getUserProfileCached)();
        root.update({
            accountProfile: profile || null,
            accountError: null,
            accountLoading: false
        });
    } catch (err) {
        root.update({
            accountProfile: null,
            accountError: err?.message || 'Failed to load profile',
            accountLoading: false
        });
    }
}
async function $d58cfb3ced40a24e$var$saveProfile(root) {
    const { accountDraft: accountDraft } = root;
    if (!accountDraft) return;
    root.update({
        accountSaving: true,
        accountSaveError: null,
        accountSaveOk: false
    });
    try {
        const sdk = (0, $bfqVY.getSDK)();
        await sdk.updateUser?.({
            name: accountDraft.name,
            email: accountDraft.email
        });
        (0, $bfqVY.invalidateUserDataCache)?.();
        root.update({
            accountSaving: false,
            accountSaveOk: true,
            accountProfile: {
                ...root.accountProfile || {},
                ...accountDraft
            }
        });
        // Clear success banner after 3 s
        setTimeout(()=>root.update({
                accountSaveOk: false
            }), 3000);
    } catch (err) {
        root.update({
            accountSaving: false,
            accountSaveError: err?.message || 'Failed to save changes'
        });
    }
}
async function $d58cfb3ced40a24e$var$changePassword(root) {
    const { accountCurrentPassword: accountCurrentPassword, accountNewPassword: accountNewPassword } = root;
    if (!accountCurrentPassword || !accountNewPassword) return;
    root.update({
        passwordSaving: true,
        passwordError: null,
        passwordOk: false
    });
    try {
        const sdk = (0, $bfqVY.getSDK)();
        await sdk.updatePassword?.({
            currentPassword: accountCurrentPassword,
            newPassword: accountNewPassword
        });
        root.update({
            passwordSaving: false,
            passwordOk: true,
            accountCurrentPassword: '',
            accountNewPassword: ''
        });
        setTimeout(()=>root.update({
                passwordOk: false
            }), 3000);
    } catch (err) {
        root.update({
            passwordSaving: false,
            passwordError: err?.message || 'Failed to change password'
        });
    }
}
const $d58cfb3ced40a24e$var$fieldRow = (labelText, inputConfig)=>{
    const inputId = inputConfig.id || 'account-' + (inputConfig.autocomplete || labelText).replace(/\s+/g, '-').replace(/[^a-z0-9-]/gi, '').toLowerCase();
    return {
        flow: 'y',
        gap: 'V',
        Label: {
            tag: 'label',
            text: labelText,
            fontSize: 'Z',
            color: 'caption',
            fontWeight: '500',
            attr: {
                for: inputId
            }
        },
        Input: {
            tag: 'input',
            id: inputId,
            padding: 'Y Z1',
            round: 'Z',
            border: '1px solid line',
            background: 'overlay',
            color: 'title',
            fontSize: 'Z1',
            width: '100%',
            ...inputConfig
        }
    };
};
const $d58cfb3ced40a24e$export$6b501c78a3684162 = {
    tag: 'main',
    id: 'main-content',
    extends: 'Flex',
    flow: 'y',
    align: 'start center',
    gridRow: '2',
    gridColumn: '1 / -1',
    minHeight: '0',
    height: '100%',
    overflowY: 'auto',
    background: 'document',
    padding: 'D C',
    metadata: {
        title: 'Account / Symbols.app'
    },
    onRender: (el, s)=>{
        if (el.__accountLoaded) return;
        el.__accountLoaded = true;
        const root = s.root || s;
        const sdk = (0, $bfqVY.getSDK)();
        const token = sdk?.getAuthToken?.();
        if (!token) {
            el.router('/signin', el.getRoot());
            return;
        }
        root.update({
            accountLoading: true
        });
        $d58cfb3ced40a24e$var$loadProfile(root);
    },
    Container: {
        flow: 'y',
        gap: 'C',
        width: '100%',
        maxWidth: '540px',
        TopBar: {
            flow: 'x',
            align: 'center space-between',
            gap: 'Y',
            BackBtn: {
                tag: 'button',
                type: 'button',
                padding: 'V Y',
                round: 'Z',
                border: '0',
                background: 'overlay',
                color: 'caption',
                fontSize: 'Z',
                cursor: 'pointer',
                ':hover': {
                    background: 'overlayStrong',
                    color: 'title'
                },
                text: "\u2190 Dashboard",
                onClick: (e, el, s)=>el.router('/dashboard', el.getRoot())
            }
        },
        PageHeading: {
            flow: 'y',
            gap: 'V',
            H1: {
                tag: 'h1',
                text: 'Account',
                fontSize: 'C',
                fontWeight: '700',
                margin: '0',
                color: 'title',
                letterSpacing: '-0.02em'
            },
            Subtitle: {
                tag: 'p',
                text: 'Manage your profile and account settings.',
                fontSize: 'Z1',
                color: 'caption',
                margin: '0'
            }
        },
        LoadingState: {
            if: (el, s)=>!!s.root?.accountLoading,
            tag: 'p',
            text: "Loading\u2026",
            color: 'caption',
            fontSize: 'Z1'
        },
        ErrorState: {
            if: (el, s)=>!!s.root?.accountError && !s.root?.accountLoading,
            tag: 'p',
            text: (el, s)=>s.root?.accountError,
            color: 'red',
            fontSize: 'Z'
        },
        ProfileSection: {
            if: (el, s)=>!!s.root?.accountProfile && !s.root?.accountLoading,
            flow: 'y',
            gap: 'B',
            padding: 'B',
            round: 'A',
            border: '1px solid line',
            background: 'overlay',
            ProfileSectionTitle: {
                tag: 'h2',
                text: 'Profile',
                fontSize: 'A',
                fontWeight: '600',
                margin: '0',
                color: 'title'
            },
            NameRow: {
                ...$d58cfb3ced40a24e$var$fieldRow('Full name', {
                    type: 'text',
                    autocomplete: 'name',
                    placeholder: 'Your name',
                    'aria-label': 'Full name',
                    value: (el, s)=>s.root?.accountDraft?.name ?? s.root?.accountProfile?.name ?? '',
                    onInput: (e, el, s)=>{
                        const root = s.root || s;
                        const draft = root.accountDraft || {
                            ...root.accountProfile
                        };
                        root.update({
                            accountDraft: {
                                ...draft,
                                name: e.target.value
                            }
                        });
                    }
                })
            },
            EmailRow: {
                ...$d58cfb3ced40a24e$var$fieldRow('Email address', {
                    type: 'email',
                    autocomplete: 'email',
                    placeholder: 'you@example.com',
                    'aria-label': 'Email address',
                    value: (el, s)=>s.root?.accountDraft?.email ?? s.root?.accountProfile?.email ?? '',
                    onInput: (e, el, s)=>{
                        const root = s.root || s;
                        const draft = root.accountDraft || {
                            ...root.accountProfile
                        };
                        root.update({
                            accountDraft: {
                                ...draft,
                                email: e.target.value
                            }
                        });
                    }
                })
            },
            SaveFeedback: {
                if: (el, s)=>!!s.root?.accountSaveOk,
                tag: 'p',
                text: 'Changes saved.',
                color: 'green',
                fontSize: 'Z',
                margin: '0',
                role: 'status'
            },
            SaveError: {
                if: (el, s)=>!!s.root?.accountSaveError,
                tag: 'p',
                text: (el, s)=>s.root?.accountSaveError,
                color: 'red',
                fontSize: 'Z',
                margin: '0',
                role: 'alert'
            },
            SaveBtn: {
                tag: 'button',
                type: 'submit',
                text: (el, s)=>s.root?.accountSaving ? "Saving\u2026" : 'Save changes',
                padding: 'Y A',
                round: 'Z',
                border: '0',
                background: 'blue',
                color: 'white',
                fontSize: 'Z1',
                fontWeight: '500',
                cursor: 'pointer',
                alignSelf: 'start',
                ':hover': {
                    background: 'blue+8'
                },
                disabled: (el, s)=>!!s.root?.accountSaving,
                onClick: (e, el, s)=>$d58cfb3ced40a24e$var$saveProfile(s.root || s)
            }
        },
        PasswordSection: {
            if: (el, s)=>!!s.root?.accountProfile && !s.root?.accountLoading,
            flow: 'y',
            gap: 'B',
            padding: 'B',
            round: 'A',
            border: '1px solid line',
            background: 'overlay',
            PasswordSectionTitle: {
                tag: 'h2',
                text: 'Change password',
                fontSize: 'A',
                fontWeight: '600',
                margin: '0',
                color: 'title'
            },
            CurrentPasswordRow: {
                ...$d58cfb3ced40a24e$var$fieldRow('Current password', {
                    type: 'password',
                    autocomplete: 'current-password',
                    placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022",
                    'aria-label': 'Current password',
                    value: (el, s)=>s.root?.accountCurrentPassword || '',
                    onInput: (e, el, s)=>(s.root || s).update({
                            accountCurrentPassword: e.target.value
                        })
                })
            },
            NewPasswordRow: {
                ...$d58cfb3ced40a24e$var$fieldRow('New password', {
                    type: 'password',
                    autocomplete: 'new-password',
                    placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022",
                    'aria-label': 'New password',
                    value: (el, s)=>s.root?.accountNewPassword || '',
                    onInput: (e, el, s)=>(s.root || s).update({
                            accountNewPassword: e.target.value
                        })
                })
            },
            PasswordFeedback: {
                if: (el, s)=>!!s.root?.passwordOk,
                tag: 'p',
                text: 'Password updated.',
                color: 'green',
                fontSize: 'Z',
                margin: '0',
                role: 'status'
            },
            PasswordError: {
                if: (el, s)=>!!s.root?.passwordError,
                tag: 'p',
                text: (el, s)=>s.root?.passwordError,
                color: 'red',
                fontSize: 'Z',
                margin: '0',
                role: 'alert'
            },
            PasswordBtn: {
                tag: 'button',
                type: 'submit',
                text: (el, s)=>s.root?.passwordSaving ? "Updating\u2026" : 'Update password',
                padding: 'Y A',
                round: 'Z',
                border: '1px solid line',
                background: 'overlay',
                color: 'title',
                fontSize: 'Z1',
                fontWeight: '500',
                cursor: 'pointer',
                alignSelf: 'start',
                ':hover': {
                    background: 'overlayStrong'
                },
                disabled: (el, s)=>!!s.root?.passwordSaving,
                onClick: (e, el, s)=>$d58cfb3ced40a24e$var$changePassword(s.root || s)
            }
        },
        SignOutSection: {
            if: (el, s)=>!!s.root?.accountProfile && !s.root?.accountLoading,
            flow: 'y',
            gap: 'B',
            padding: 'B',
            round: 'A',
            border: '1px solid line',
            background: 'overlay',
            SignOutTitle: {
                tag: 'h2',
                text: 'Sign out',
                fontSize: 'A',
                fontWeight: '600',
                margin: '0',
                color: 'title'
            },
            SignOutHint: {
                tag: 'p',
                text: 'Sign out of your account on this device.',
                fontSize: 'Z',
                color: 'caption',
                margin: '0'
            },
            SignOutBtn: {
                tag: 'button',
                type: 'button',
                text: 'Sign out',
                padding: 'Y A',
                round: 'Z',
                border: '1px solid line',
                background: 'transparent',
                color: 'title',
                fontSize: 'Z1',
                fontWeight: '500',
                cursor: 'pointer',
                alignSelf: 'start',
                ':hover': {
                    background: 'overlay',
                    color: 'red'
                },
                onClick: (e, el, s)=>{
                    const sdk = (0, $bfqVY.getSDK)();
                    sdk?.logout?.();
                    el.router('/signin', el.getRoot());
                }
            }
        }
    }
};

});

parcelRegister("03a5I", function(module, exports) {

$parcel$export(module.exports, "marketplace", () => $00981bd74fd747c8$export$be74dea0232279db);
// Canvas marketplace page — reuses components from the marketplace shared
// library (MarketplaceNavbar, MarketplaceSidebar, MarketplaceFilters,
// MarketplaceGrid, MarketplaceDetail) but wraps them in the same
// AppSidebar + AppMain chrome as /dashboard so the layout stays consistent
// across canvas routes.
//
// This page is flagged `_marketplaceHost: true` and carries its own
// marketplace state (catalog/selectedItem/installed/etc.) so `marketplaceHostOf`
// binds every marketplace component to THIS element — not canvas's app root.
// Without the flag, state falls through to canvas root (shared with
// assistant / command bar / workspace) and polluted-or-missing fields leave
// the grid empty. Seeds `catalog` from the static list so the grid renders
// immediately pre-hydration (signed-in users get merged DB kinds on top via
// `hydrateLiveCatalog` in MarketplaceGrid.onCreate).
//
// Deep-link: `/marketplace?kind=registrar&categories=dns,domains&q=porkbun&sort=name&pricing=free&item=int.plausible`
// pre-seeds the sidebar/filter/sort state AND opens the detail pane
// so a shared URL reproduces someone else's filtered view exactly.
// URL round-trip is bidirectional: reader on mount + popstate,
// writer on every state change via `writeFiltersToUrl` in onUpdate.
// Also see the in-Navbar `Copy link` button + the `S` shortcut for
// explicit share flows.
// Pull catalog + URL-filter parser from shared/ — both surfaces (canvas's
// /marketplace preview and the marketplace sub-app's main page) consume
// the same source, so cross-importing across sub-apps is no longer needed.

var $cNJPN = parcelRequire("cNJPN");

var $h5wPI = parcelRequire("h5wPI");
// Shallow array-equality for activeCategories diff detection.
const $00981bd74fd747c8$var$_arrEq = (a, b)=>Array.isArray(a) && Array.isArray(b) && a.length === b.length && a.every((x, i)=>x === b[i]);
// Reads `currentSearch` from canvas root (updated by AppShell's
// locationchange patch on pushState/replaceState), parses URL filters,
// and applies only the diffs to the island's state. Gated on
// `el._lastCurrentSearch` so in-session state changes (chip clicks,
// kind selections, etc.) don't trigger the reader — only actual URL
// changes (initial mount + popstate) do. Without this gate, the
// `activeKind → 'all'` default below would clobber user sidebar clicks
// every time onUpdate fires.
const $00981bd74fd747c8$var$_applyFiltersFromUrl = (el, s)=>{
    const root = s?.root;
    const host = el.state;
    if (!host) return;
    const currentSearch = root?.currentSearch || '';
    if (el._lastCurrentSearch === currentSearch) return;
    el._lastCurrentSearch = currentSearch;
    const next = (0, $h5wPI.parseFiltersFromSearch)(currentSearch);
    // Kind defaults to 'all' when not in URL so sidebar resets on
    // back/forward navigation to the base /marketplace URL.
    if (next.activeKind === undefined) next.activeKind = 'all';
    // `_itemId` is synthetic (not a real host state key) — resolve it
    // against the catalog and translate into selectedItem mutation.
    // Missing param → clear selectedItem so popstate back to /marketplace
    // closes any open detail. Pull the translated update out of the
    // generic diff loop since it's a two-field transaction.
    const itemId = next._itemId;
    delete next._itemId;
    const currentItemId = host.selectedItem?.id || null;
    let itemDiff = null;
    if (itemId && itemId !== currentItemId) {
        const found = (host.catalog || []).find((i)=>i.id === itemId);
        if (found) itemDiff = {
            selectedItem: found,
            selectedHistory: []
        };
    } else if (!itemId && currentItemId) itemDiff = {
        selectedItem: null,
        selectedHistory: []
    };
    const diff = {};
    for (const [k, v] of Object.entries(next)){
        if (k === 'activeCategories') {
            if (!$00981bd74fd747c8$var$_arrEq(v, host[k])) diff[k] = v;
        } else if (host[k] !== v) diff[k] = v;
    }
    const merged = {
        ...diff,
        ...itemDiff || {}
    };
    if (Object.keys(merged).length > 0) host.update(merged);
};
const $00981bd74fd747c8$export$be74dea0232279db = {
    tag: 'main',
    id: 'main-content',
    extends: 'AppPage',
    metadata: {
        title: 'Marketplace / Symbols.app'
    },
    gridRow: '2',
    gridColumn: '1 / -1',
    minHeight: '0',
    height: '100%',
    overflow: 'hidden',
    color: 'title',
    // Host marker: `marketplaceHostOf(el)` walks the parent chain looking
    // for this flag — first match wins. Isolates marketplace state from
    // canvas root state.
    _marketplaceHost: true,
    state: {
        // Multi-select categories (see MarketplaceIsland + toggleCategory).
        activeCategories: [],
        activeKind: 'all',
        activePricing: 'all',
        activeSort: 'name',
        gridDensity: 'comfortable',
        query: '',
        selectedItem: null,
        selectedHistory: [],
        sidebarMode: false,
        installing: null,
        installed: [],
        pinnedIds: [],
        recentIds: [],
        toastMessage: null,
        toastUndoItemId: null,
        shortcutsOpen: false,
        catalog: (0, $cNJPN.default),
        // Install modal state — null when closed, { item, step, draft } when open.
        installModal: null,
        _installModalSaving: false,
        _installModalError: null
    },
    onCreate: (el, s)=>{
        $00981bd74fd747c8$var$_applyFiltersFromUrl(el, s);
        // Bind global Esc → close detail pane for this host. Idempotent
        // (see `registerEscHandler` in marketplace/functions/index.js).
        el.call('registerEscHandler', el.state);
    },
    // `currentSearch` updates on history pushState/replaceState via
    // AppShell's locationchange patch — re-read so navigating between
    // `/marketplace?kind=A&q=x` and `/marketplace?kind=B` inside the same
    // SPA session keeps the filter UI in sync. Writer runs AFTER the
    // reader so chip/sidebar clicks that update state immediately sync
    // back to the URL — keeping the address bar shareable at all times.
    onUpdate: (el, s)=>{
        $00981bd74fd747c8$var$_applyFiltersFromUrl(el, s);
        el.call('writeFiltersToUrl', el.state);
    },
    AppSidebar: {
        MarketplaceSidebar: {
            width: 'auto',
            minWidth: 'auto',
            border: '0'
        }
    },
    AppMain: {
        padding: '0',
        overflow: 'hidden',
        // `minHeight: 0` lets Body actually respect the AppMain-provided
        // height cap; without it AppMain's grid-flex context lets children
        // overflow freely, breaking the row-4 `1fr` constraint below — the
        // Grid cell would then size to content, and `overflow: y auto` on
        // the Grid couldn't trigger because nothing was actually overflowing.
        minHeight: '0',
        Body: {
            padding: '0',
            overflow: 'hidden',
            display: 'grid',
            gridTemplateRows: 'auto auto auto 1fr',
            gridTemplateColumns: '1fr auto',
            minHeight: '0',
            height: '100%',
            // Positioning context for MarketplaceToast (absolute bottom-right).
            position: 'relative',
            MarketplaceNavbar: {
                gridRow: '1',
                gridColumn: '1 / -1'
            },
            MarketplaceFilters: {
                gridRow: '2',
                gridColumn: '1 / -1'
            },
            MarketplaceResultsBar: {
                gridRow: '3',
                gridColumn: '1 / -1'
            },
            MarketplaceGrid: {
                gridRow: '4',
                gridColumn: '1',
                overflow: 'y auto',
                alignContent: 'start',
                // Grid cells default to `min-content` — must set `minHeight: 0`
                // so `overflow: y auto` has a constrained box to scroll within.
                minHeight: '0'
            },
            MarketplaceDetail: {
                gridRow: '4',
                gridColumn: '2',
                minHeight: '0'
            },
            // Transient install-confirm toast. Absolute-positioned — doesn't
            // reflow the grid rows above. Hidden via `host.toastMessage`
            // gate when no toast is active.
            MarketplaceToast: {},
            // Help overlay (toggled by `?` key).
            MarketplaceShortcutsOverlay: {},
            // Install modal — fixed overlay, gated on host.installModal. Placed
            // inside the page Body so `marketplaceHostOf` walks up and finds
            // the _marketplaceHost flag on the canvas marketplace page element.
            MarketplaceInstallModal: {}
        }
    }
};

});
parcelRegister("cNJPN", function(module, exports) {

$parcel$export(module.exports, "default", () => $951d9d6721c23242$export$2e2bcd8739ae039);
// Marketplace seed catalog.
// Kinds: 'library' | 'template' | 'plugin' | 'registrar'
// Note: 'integration' entries have been removed — they are now served
// exclusively from the live `integration_kinds` Supabase table (migration 0063).
// At runtime `hydrateLiveCatalog` (functions/index.js) merges live rows on top
// of this static list, keyed by integration id.
//
// Price 0 = free.
// `thumbnail` — 16:9 preview URL (used by libraries/templates as card/detail
//               hero). Empty → the card renders a transparent-checker
//               placeholder until a real thumbnail is uploaded.
var $951d9d6721c23242$export$2e2bcd8739ae039 = [
    // ─── Libraries ────────────────────────────────────────────────────────────
    {
        id: 'lib.brand',
        kind: 'library',
        category: 'system',
        name: 'Brand',
        description: 'Shared brand components and design tokens.',
        price: 0,
        thumbnail: ''
    },
    {
        id: 'lib.shared',
        kind: 'library',
        category: 'system',
        name: 'Shared',
        description: 'Shared components across editor apps.',
        price: 0,
        thumbnail: ''
    },
    {
        id: 'lib.cms-ui',
        kind: 'library',
        category: 'ui',
        name: 'CMS UI Kit',
        description: 'Editable fields, rich text, media pickers.',
        price: 0,
        thumbnail: ''
    },
    {
        id: 'lib.charts',
        kind: 'library',
        category: 'ui',
        name: 'Charts Kit',
        description: 'Line, bar, area, sparkline, heatmap.',
        price: 12,
        thumbnail: ''
    },
    // ─── Templates ────────────────────────────────────────────────────────────
    {
        id: 'tpl.saas-starter',
        kind: 'template',
        category: 'starter',
        name: 'SaaS Starter',
        description: 'Auth, billing, dashboard, settings.',
        price: 0,
        thumbnail: ''
    },
    {
        id: 'tpl.landing',
        kind: 'template',
        category: 'marketing',
        name: 'Landing Page',
        description: 'Hero, features, pricing, CTA.',
        price: 0,
        thumbnail: ''
    },
    {
        id: 'tpl.docs',
        kind: 'template',
        category: 'docs',
        name: 'Docs Site',
        description: 'Sidebar nav, MDX content, search.',
        price: 0,
        thumbnail: ''
    },
    {
        id: 'tpl.ecommerce',
        kind: 'template',
        category: 'commerce',
        name: 'E-commerce',
        description: 'Catalog, cart, checkout.',
        price: 29,
        thumbnail: ''
    },
    // ─── Domain Registrars ───────────────────────────────────────────────────
    {
        id: 'reg.namecheap',
        kind: 'registrar',
        category: 'domains',
        name: 'Namecheap',
        description: 'Register and manage domains with WHOIS privacy.',
        price: 0,
        logo: 'namecheap'
    },
    {
        id: 'reg.godaddy',
        kind: 'registrar',
        category: 'domains',
        name: 'GoDaddy',
        description: 'Domain search, registration, transfers, DNS.',
        price: 0,
        logo: 'godaddy'
    },
    {
        id: 'reg.cloudflare-registrar',
        kind: 'registrar',
        category: 'domains',
        name: 'Cloudflare Registrar',
        description: 'At-cost domain registration with built-in DNS.',
        price: 0,
        logo: 'cloudflare'
    },
    {
        id: 'reg.porkbun',
        kind: 'registrar',
        category: 'domains',
        name: 'Porkbun',
        description: 'Developer-friendly registrar with free WHOIS privacy.',
        price: 0,
        logo: 'porkbun'
    },
    {
        id: 'reg.gandi',
        kind: 'registrar',
        category: 'domains',
        name: 'Gandi',
        description: 'Domains, DNS, and mailbox hosting.',
        price: 0,
        logo: 'gandi'
    },
    {
        id: 'reg.squarespace-domains',
        kind: 'registrar',
        category: 'domains',
        name: 'Squarespace Domains',
        description: 'Domains, DNS, and forwarding (formerly Google Domains).',
        price: 0,
        logo: 'squarespace'
    },
    {
        id: 'reg.namesilo',
        kind: 'registrar',
        category: 'domains',
        name: 'NameSilo',
        description: 'Low-cost domains with free privacy and API access.',
        price: 0
    },
    {
        id: 'reg.hover',
        kind: 'registrar',
        category: 'domains',
        name: 'Hover',
        description: 'Domains, email forwarding, and DNS without upsells.',
        price: 0
    },
    {
        id: 'reg.name',
        kind: 'registrar',
        category: 'domains',
        name: 'Name.com',
        description: 'Domains, DNS, and SSL with a developer API.',
        price: 0
    },
    // ─── MCP Connectors ───────────────────────────────────────────────────────
    // MCP (Model Context Protocol) servers that canvas AI agents can call into.
    // Separate from integrations — different runtime contract (JSON-RPC, tools/list, resources/list).
    {
        id: 'mcp.symbols',
        kind: 'mcp',
        category: 'system',
        name: 'Symbols MCP',
        description: "Symbols' own MCP server \u2014 projects, tickets, workspace tools.",
        price: 0,
        url: 'https://mcp.symbols.app',
        transport: 'sse',
        auth_kind: 'oauth'
    },
    // ─── Plugins ─────────────────────────────────────────────────────────────
    {
        id: 'plg.seo',
        kind: 'plugin',
        category: 'marketing',
        name: 'SEO Tools',
        description: 'Meta tags, sitemaps, OG images.',
        price: 0
    },
    {
        id: 'plg.i18n',
        kind: 'plugin',
        category: 'content',
        name: 'i18n Polyglot',
        description: 'Multi-language content.',
        price: 0
    },
    {
        id: 'plg.a11y',
        kind: 'plugin',
        category: 'quality',
        name: 'Accessibility Audit',
        description: 'WCAG checks in editor.',
        price: 0
    },
    {
        id: 'plg.gridstack',
        kind: 'plugin',
        category: 'editor',
        name: 'Gridstack Layout',
        description: 'Drag-and-drop grid layouts.',
        price: 0
    },
    {
        id: 'plg.monaco',
        kind: 'plugin',
        category: 'editor',
        name: 'Monaco Editor',
        description: 'In-browser code editing.',
        price: 0
    }
];

});

parcelRegister("h5wPI", function(module, exports) {

$parcel$export(module.exports, "parseFiltersFromSearch", () => $c70c5f46fd1cc9b8$export$f400f8b25c79b066);
// Marketplace URL-filter helpers — extracted from
// `marketplace/functions/index.js` so canvas's /marketplace deep-link
// surface and the marketplace sub-app pull from one source. Both call
// sites previously cross-imported across packages, which violated the
// Phase 10 no-restricted-imports rule.
//
// `parseFiltersFromSearch(searchString)` returns a partial diff to apply
// to the host root state — only keys that appear in the URL and pass the
// allowed-set guards are present in the output.
const $c70c5f46fd1cc9b8$var$_URL_ALLOWED_KINDS = [
    'library',
    'template',
    'integration',
    'registrar',
    'plugin',
    'mcp',
    'all'
];
const $c70c5f46fd1cc9b8$var$_URL_ALLOWED_PRICING = [
    'all',
    'free',
    'paid',
    'installed',
    'pinned'
];
const $c70c5f46fd1cc9b8$var$_URL_ALLOWED_SORTS = [
    'name',
    'priceAsc',
    'priceDesc'
];
const $c70c5f46fd1cc9b8$export$2face1fc6c66e83b = $c70c5f46fd1cc9b8$var$_URL_ALLOWED_KINDS;
const $c70c5f46fd1cc9b8$export$3ff3751e19032ce0 = $c70c5f46fd1cc9b8$var$_URL_ALLOWED_PRICING;
const $c70c5f46fd1cc9b8$export$a81d37b5cc86b234 = $c70c5f46fd1cc9b8$var$_URL_ALLOWED_SORTS;
const $c70c5f46fd1cc9b8$export$f400f8b25c79b066 = (search)=>{
    const sp = new URLSearchParams(search || '');
    const out = {};
    const kind = sp.get('kind');
    if (kind && $c70c5f46fd1cc9b8$var$_URL_ALLOWED_KINDS.includes(kind)) out.activeKind = kind;
    const pricing = sp.get('pricing');
    if (pricing && $c70c5f46fd1cc9b8$var$_URL_ALLOWED_PRICING.includes(pricing)) out.activePricing = pricing;
    const sort = sp.get('sort');
    if (sort && $c70c5f46fd1cc9b8$var$_URL_ALLOWED_SORTS.includes(sort)) out.activeSort = sort;
    const q = sp.get('q');
    if (typeof q === 'string') out.query = q;
    const cats = sp.get('categories');
    if (cats) out.activeCategories = cats.split(',').map((c)=>c.trim()).filter(Boolean);
    const itemId = sp.get('item');
    if (itemId) out._itemId = itemId;
    return out;
};

});


parcelRegister("iRx6m", function(module, exports) {

$parcel$export(module.exports, "sessionBridge", () => $dbb6da84b3b9355f$export$11ed4ec5dc76a106);
// Canvas-side postMessage endpoint. Lets peer Symbols origins iframe
// this page and read the SDK tokens held in canvas's localStorage so a
// user signed in on canvas doesn't have to sign in again on workspace /
// marketplace / preview. Whitelisted origins only; page has no UI.

var $8RlGv = parcelRequire("8RlGv");
const $dbb6da84b3b9355f$var$ALLOWED_ORIGIN_PATTERNS = [
    /^https?:\/\/workspace\.localhost(:\d+)?$/,
    /^https?:\/\/system-governance-intranet\.localhost(:\d+)?$/,
    /^https?:\/\/governance-intranet\.localhost(:\d+)?$/,
    /^https?:\/\/marketplace\.localhost(:\d+)?$/,
    /^https?:\/\/preview\.localhost(:\d+)?$/,
    /^https?:\/\/[^.]+\.symbols\.app$/
];
const $dbb6da84b3b9355f$var$isAllowedOrigin = (origin)=>$dbb6da84b3b9355f$var$ALLOWED_ORIGIN_PATTERNS.some((re)=>re.test(origin));
const $dbb6da84b3b9355f$export$11ed4ec5dc76a106 = {
    metadata: {
        title: "Session bridge \xb7 Symbols"
    },
    background: '#0f1116',
    color: 'rgba(255,255,255,0.35)',
    fontFamily: 'system-ui',
    fontSize: 'Z2',
    padding: 'A',
    text: 'Session bridge. Hands off the canvas session to other Symbols subdomains.',
    onRender: (el)=>{
        if (el.__bridgeInit) return;
        el.__bridgeInit = true;
        window.addEventListener('message', (ev)=>{
            if (!$dbb6da84b3b9355f$var$isAllowedOrigin(ev.origin)) return;
            if (ev.data?.type !== 'symbols-session-request') return;
            const sdkTokens = (0, $8RlGv.collectSdkTokens)() || {};
            const supabaseSessions = (0, $8RlGv.collectSupabaseSessions)() || {};
            const hasSdk = !!sdkTokens.symbols_access_token || !!sdkTokens.symbols_bridge_access_token;
            const hasSb = Object.keys(supabaseSessions).length > 0;
            ev.source?.postMessage(hasSdk || hasSb ? {
                type: 'symbols-session-response',
                ok: true,
                sdkTokens: sdkTokens,
                supabaseSessions: supabaseSessions
            } : {
                type: 'symbols-session-response',
                ok: false,
                error: 'no-session'
            }, ev.origin);
        });
        // Parent waits for this before sending its request so the
        // handshake can't race a listener that armed after postMessage.
        try {
            if (window.parent && window.parent !== window) window.parent.postMessage({
                type: 'symbols-session-ready'
            }, '*');
        } catch  {}
    }
};

});

parcelRegister("7tPFF", function(module, exports) {

$parcel$export(module.exports, "notFound", () => $572352a1aadef5be$export$a33e918cb4258370);
const $572352a1aadef5be$export$a33e918cb4258370 = {
    tag: 'main',
    id: 'main-content',
    extends: 'AppPage',
    flow: 'y',
    metadata: {
        title: 'Not found / Symbols.app'
    },
    align: 'center center',
    height: '100%',
    width: '100%',
    padding: 'C',
    color: 'title',
    textAlign: 'center',
    gap: 'A',
    StatusCode: {
        tag: 'h1',
        text: (el, s)=>String(s.root?.notFoundStatus || 404),
        fontSize: 'E',
        fontWeight: '700',
        letterSpacing: '-0.04em',
        margin: '0',
        color: 'title'
    },
    Title: {
        tag: 'h2',
        text: (el, s)=>s.root?.notFoundTitle || 'Page not found',
        fontSize: 'B',
        fontWeight: '600',
        margin: '0',
        color: 'title'
    },
    Message: {
        tag: 'p',
        text: (el, s)=>s.root?.notFoundMessage || "The page you're looking for doesn't exist. It may have been moved or the URL may be incorrect.",
        maxWidth: 'I',
        margin: '0 auto',
        color: 'caption',
        fontSize: 'Z1',
        lineHeight: '1.5em'
    },
    Actions: {
        flow: 'x',
        gap: 'Y',
        align: 'center',
        marginTop: 'A',
        // Shown only when the blocker is auth — the recovery is to sign in.
        SignIn: {
            extends: 'Button',
            if: (el, s)=>s.root?.notFoundStatus === 401,
            text: 'Sign in',
            padding: 'Y A',
            round: 'Z',
            cursor: 'pointer',
            border: '0',
            background: 'brand',
            color: 'title',
            ':hover': {
                background: 'brand+10'
            },
            onClick: (e, el)=>el.router('/signin', el.getRoot())
        },
        // Shown for any retryable error (5xx, 429, network) — reload re-runs
        // the bootstrap fetch without leaving the URL.
        Retry: {
            extends: 'Button',
            if: (el, s)=>{
                const code = s.root?.notFoundStatus;
                return code === 429 || code >= 500 && code < 600;
            },
            text: 'Retry',
            padding: 'Y A',
            round: 'Z',
            cursor: 'pointer',
            border: '0',
            background: 'overlayStrong',
            color: 'title',
            ':hover': {
                background: 'overlay'
            },
            onClick: (e, el)=>el.call('reloadPage')
        },
        Back: {
            extends: 'Link',
            href: '/dashboard',
            text: 'Back to dashboard',
            padding: 'Y A',
            round: 'Z',
            cursor: 'pointer',
            border: '0',
            background: 'overlayStrong',
            color: 'title',
            ':hover': {
                background: 'overlay'
            }
        }
    }
};

});

parcelRegister("lF9Ff", function(module, exports) {

$parcel$export(module.exports, "waitlist", () => $fc54ec695d9094be$export$4fd09d08b607c3f1);
const $fc54ec695d9094be$export$4fd09d08b607c3f1 = {
    extends: 'Flex',
    flow: 'column',
    align: 'center',
    height: '100%',
    flex: '1',
    onSubmit: async (ev, el, s)=>{
        ev.preventDefault();
        const { email: email, name: name } = s.parse ? s.parse() : s;
        await el.sdk.addToWaitlist({
            email: email,
            name: name
        });
        el.router('/', el.getRoot());
        if (window.plausible) window.plausible('Signup to Waitlist');
    },
    Content: {
        tag: 'form',
        maxWidth: 'H',
        width: '100%',
        margin: 'auto',
        Hgroup: {
            margin: '- - C1',
            H: {
                text: 'Get early access'
            },
            P: {
                text: `You're joining the waitlist. Knowing your preferences helps us customize your invitation.`
            }
        },
        WaitlistForm: {
            margin: '- - - -Y2',
            gap: 'Z2'
        },
        ContinueButton: {
            type: 'submit',
            margin: 'C1 - - -Y2',
            text: 'Sign up to waitlist',
            theme: 'primary'
        }
    },
    Footer: {}
};

});


parcelRegister("7rj4F", function(module, exports) {

$parcel$export(module.exports, "default", () => $56a9d9bfa3eff735$export$2e2bcd8739ae039);

var $5fAJK = parcelRequire("5fAJK");

var $8KMrq = parcelRequire("8KMrq");

var $kTpdU = parcelRequire("kTpdU");
var $56a9d9bfa3eff735$export$2e2bcd8739ae039 = {
    '/': (0, $5fAJK.main),
    '/installable-rail-demo': (0, $8KMrq.installableRailDemo),
    '/prompt-gallery': (0, $kTpdU.promptGallery)
};

});
parcelRegister("5fAJK", function(module, exports) {

$parcel$export(module.exports, "main", () => $3d2ad9a1ec449397$export$f22da7240b7add18);
// Main marketplace route. The app-level shell (grid, 100dvh, theme,
// fontSize, assistant margin-right transition) lives on the root
// component in `app.js`. This page renders a `MarketplaceIsland` —
// the same self-contained unit that canvas + landing embed, so
// standalone stays in sync with embeddable surfaces without
// duplicating layout or state wiring.
const $3d2ad9a1ec449397$export$f22da7240b7add18 = {
    extends: 'Page',
    display: 'grid',
    gridTemplateRows: '1fr',
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    MarketplaceIsland: {}
};

});

parcelRegister("8KMrq", function(module, exports) {

$parcel$export(module.exports, "installableRailDemo", () => $65f832061eb7324e$export$57fb19bf2271c8b2);
// installable-rail-demo — exercises all three InstallableRail layout variants.
//
// Route: /installable-rail-demo
//
// Acceptance Criterion 7 (TASK#4567 / TASK#4562):
// "Backed by a storybook-style demo page that exercises all combos."
//
// Covers:
//   - layout: 'rail'  (horizontal scrolling chip row)
//   - layout: 'grid'  (responsive auto-fill card grid)
//   - layout: 'list'  (bordered vertical management list)
//   - domain: 'integration', 'library', 'mcp' variants
//   - InstallableModalStub mounted so every click produces a visible
//     placeholder modal rather than silently no-opping
//
// Uses mock data injected via children state so no network call is needed
// for the demo. The mock data bypasses the onInit fetch by pre-populating
// the root state keys that InstallableRail reads.
//
// Mount InstallableModalStub at the page root so every
// el.call('openInstallableModal', ...) click renders the Phase 3 stub.
const $65f832061eb7324e$var$_MOCK_KINDS = [
    {
        kind: 'github',
        domain: 'integration',
        display: {
            icon: 'github',
            label: 'GitHub',
            tagline: 'Connect your repositories.'
        },
        enabled: true
    },
    {
        kind: 'slack',
        domain: 'integration',
        display: {
            icon: 'slack',
            label: 'Slack',
            tagline: 'Send notifications to channels.'
        },
        enabled: true
    },
    {
        kind: 'figma',
        domain: 'integration',
        display: {
            icon: 'figma',
            label: 'Figma',
            tagline: 'Import design tokens automatically.'
        },
        enabled: true
    },
    {
        kind: 'linear',
        domain: 'integration',
        display: {
            icon: 'linear',
            label: 'Linear',
            tagline: 'Sync issues and milestones.'
        },
        enabled: true
    },
    {
        kind: 'notion',
        domain: 'integration',
        display: {
            icon: 'notion',
            label: 'Notion',
            tagline: 'Publish docs from your workspace.'
        },
        enabled: true
    }
];
const $65f832061eb7324e$var$_MOCK_INSTANCES = [
    {
        kind: 'github',
        scope_type: 'workspace',
        scope_id: 'demo',
        enabled: true
    },
    {
        kind: 'slack',
        scope_type: 'workspace',
        scope_id: 'demo',
        enabled: true
    }
];
const $65f832061eb7324e$var$_MCP_MOCK_KINDS = [
    {
        kind: 'mcp-filesystem',
        domain: 'mcp',
        display: {
            icon: 'folder',
            label: 'Filesystem',
            tagline: 'Read and write local files via MCP.'
        },
        enabled: true
    },
    {
        kind: 'mcp-postgres',
        domain: 'mcp',
        display: {
            icon: 'database',
            label: 'Postgres',
            tagline: 'Query Postgres databases via MCP.'
        },
        enabled: true
    },
    {
        kind: 'mcp-github',
        domain: 'mcp',
        display: {
            icon: 'github',
            label: 'GitHub MCP',
            tagline: 'Manage repos and PRs via MCP.'
        },
        enabled: true
    }
];
const $65f832061eb7324e$export$57fb19bf2271c8b2 = {
    extends: 'Page',
    flow: 'y',
    gap: 'D',
    padding: 'C E',
    overflowY: 'auto',
    // Pre-populate root state keys so the rail renders without hitting the API.
    onInit: (el, s)=>{
        const root = s.root;
        root.update({
            // Integration rail (used by all three layout demos)
            '_installableRail_integration_workspace_kinds': $65f832061eb7324e$var$_MOCK_KINDS,
            '_installableRail_integration_workspace_instances': $65f832061eb7324e$var$_MOCK_INSTANCES,
            '_installableRail_integration_workspace_loading': false,
            // MCP rail
            '_installableRail_mcp_workspace_kinds': $65f832061eb7324e$var$_MCP_MOCK_KINDS,
            '_installableRail_mcp_workspace_instances': [],
            '_installableRail_mcp_workspace_loading': false
        });
    },
    // Mount stub modal so clicks produce visible feedback (Phase 3).
    InstallableModalStub: {},
    // ── Page header ─────────────────────────────────────────────────────────
    DemoHeader: {
        flow: 'y',
        gap: 'Y',
        DemoTitle: {
            tag: 'h1',
            margin: '0',
            fontSize: 'E',
            fontWeight: '800',
            color: 'title',
            text: 'InstallableRail Demo'
        },
        DemoSubtitle: {
            tag: 'p',
            margin: '0',
            fontSize: 'Z2',
            color: 'caption',
            text: "Exercises all three layout variants (rail / grid / list). Clicks open the Phase 3 InstallableModalStub stub modal \u2014 Phase 4 MarketplaceInstallModal will replace it."
        }
    },
    Divider_1: {
        borderTop: '1px',
        borderTopStyle: 'solid',
        borderTopColor: 'line'
    },
    // ── Section 1 — Rail layout ──────────────────────────────────────────────
    RailSection: {
        flow: 'y',
        gap: 'Z',
        SectionTitle: {
            tag: 'h2',
            margin: '0',
            fontSize: 'B',
            fontWeight: '700',
            color: 'title',
            text: 'layout: "rail"'
        },
        SectionHint: {
            tag: 'p',
            margin: '0',
            fontSize: 'Y2',
            color: 'caption',
            text: 'Horizontal scrolling chip row. Two items pre-installed (GitHub, Slack).'
        },
        InstallableRail: {
            domain: 'integration',
            scopeType: 'workspace',
            scopeId: 'demo',
            layout: 'rail',
            title: 'Integrations'
        }
    },
    Divider_2: {
        borderTop: '1px',
        borderTopStyle: 'solid',
        borderTopColor: 'line'
    },
    // ── Section 2 — Grid layout ──────────────────────────────────────────────
    GridSection: {
        flow: 'y',
        gap: 'Z',
        SectionTitle: {
            tag: 'h2',
            margin: '0',
            fontSize: 'B',
            fontWeight: '700',
            color: 'title',
            text: 'layout: "grid"'
        },
        SectionHint: {
            tag: 'p',
            margin: '0',
            fontSize: 'Y2',
            color: 'caption',
            text: 'Responsive auto-fill card grid. Same data source as the rail above.'
        },
        InstallableRail_grid: {
            extends: 'InstallableRail',
            domain: 'integration',
            scopeType: 'workspace',
            scopeId: 'demo',
            layout: 'grid',
            title: 'Integrations'
        }
    },
    Divider_3: {
        borderTop: '1px',
        borderTopStyle: 'solid',
        borderTopColor: 'line'
    },
    // ── Section 3 — List layout ──────────────────────────────────────────────
    ListSection: {
        flow: 'y',
        gap: 'Z',
        SectionTitle: {
            tag: 'h2',
            margin: '0',
            fontSize: 'B',
            fontWeight: '700',
            color: 'title',
            text: 'layout: "list"'
        },
        SectionHint: {
            tag: 'p',
            margin: '0',
            fontSize: 'Y2',
            color: 'caption',
            text: 'Bordered vertical management list with chevron + status badges.'
        },
        InstallableRail_list: {
            extends: 'InstallableRail',
            domain: 'integration',
            scopeType: 'workspace',
            scopeId: 'demo',
            layout: 'list',
            title: 'Integrations'
        }
    },
    Divider_4: {
        borderTop: '1px',
        borderTopStyle: 'solid',
        borderTopColor: 'line'
    },
    // ── Section 4 — MCP domain ───────────────────────────────────────────────
    McpSection: {
        flow: 'y',
        gap: 'Z',
        SectionTitle: {
            tag: 'h2',
            margin: '0',
            fontSize: 'B',
            fontWeight: '700',
            color: 'title',
            text: 'domain: "mcp" \xb7 layout: "grid"'
        },
        SectionHint: {
            tag: 'p',
            margin: '0',
            fontSize: 'Y2',
            color: 'caption',
            text: 'MCP connectors \u2014 none installed. Shows "Available" badge on all.'
        },
        InstallableRail_mcp: {
            extends: 'InstallableRail',
            domain: 'mcp',
            scopeType: 'workspace',
            scopeId: 'demo',
            layout: 'grid',
            title: 'MCP Connectors'
        }
    },
    Divider_5: {
        borderTop: '1px',
        borderTopStyle: 'solid',
        borderTopColor: 'line'
    },
    // ── Section 5 — Empty state ──────────────────────────────────────────────
    EmptySection: {
        flow: 'y',
        gap: 'Z',
        SectionTitle: {
            tag: 'h2',
            margin: '0',
            fontSize: 'B',
            fontWeight: '700',
            color: 'title',
            text: 'Empty state (no kinds)'
        },
        SectionHint: {
            tag: 'p',
            margin: '0',
            fontSize: 'Y2',
            color: 'caption',
            text: 'A "library" domain with no data pre-populated \u2014 shows InstallableRailEmpty.'
        },
        InstallableRail_empty: {
            extends: 'InstallableRail',
            domain: 'library',
            scopeType: 'workspace',
            scopeId: 'demo',
            layout: 'grid',
            title: 'Libraries',
            emptyHint: 'Add your first library'
        }
    }
};

});

parcelRegister("kTpdU", function(module, exports) {

$parcel$export(module.exports, "promptGallery", () => $f35c828cbbd7bc87$export$69f1ff2028df7c93);
// promptGallery — curated catalog of prompts tailored for Symbols projects.
//
// Route: /prompt-gallery
//
// Standalone Page (no MarketplaceIsland chrome). Mirrors the layout
// vocabulary of the rest of marketplace: header → filter chips →
// responsive card grid. Each card surfaces a copy-to-clipboard prompt
// the user can drop straight into Claude / the Symbols MCP / the
// editor’s AI tab.
//
// PROMPTS lives next to the page (rather than data/catalog.js) because
// gallery prompts evolve with the framework, not with the marketplace
// catalog table — this file is the single source of truth.
//
// State (`state.activeCategory`, `state._promptGalleryCopiedId`) is
// declared on the page so PromptGalleryChip + PromptGalleryCard can
// read/write via the `s` parameter without walking to the app root.
const $f35c828cbbd7bc87$export$1613a8bb42ebacf3 = [
    // ── Components ────────────────────────────────────────────────────────────
    {
        id: 'cmp.button-variants',
        category: 'components',
        title: 'Button with variants',
        tagline: 'Primary / secondary / ghost variants in v3.14 syntax.',
        prompt: "Create a Button component for a Symbols project using DOMQL v3.14. Support primary, secondary, and ghost variants via a `variant` prop. Use design system tokens for color, padding, and round. Hover and :focus-visible states should use DS tokens (no raw colors). No `attr:` wrapper for `disabled` / `type` \u2014 flat props only."
    },
    {
        id: 'cmp.card-collection',
        category: 'components',
        title: 'Card grid from data',
        tagline: 'children + childExtends pattern (no $collection).',
        prompt: 'Build a responsive card grid in Symbols v3.14 that renders cards from a `children` array (objects with title, description, thumbnail). Use `childExtends: "Card"` and design system tokens for spacing. Cards should expose a hover border state and an Enter/Space keyboard handler (tabindex + role="button"). No raw px values.'
    },
    {
        id: 'cmp.modal',
        category: 'components',
        title: 'Modal with backdrop',
        tagline: 'Esc-to-close, focus trap, design tokens only.',
        prompt: "Implement a Modal component in DOMQL v3.14 with a backdrop, Esc-to-close handling registered in onCreate / unregistered in onRemove, and a focus trap on the first interactive element. Use DS tokens for round, padding, background, and shadow. Mount via a state flag on the host."
    },
    // ── Pages ─────────────────────────────────────────────────────────────────
    {
        id: 'pg.dashboard',
        category: 'pages',
        title: 'Dashboard page scaffold',
        tagline: 'AppShell + AppSidebar + AppMain composition.',
        prompt: "Generate a dashboard page for a Symbols project that extends `Page`, composes `AppShell` chrome, has a left `AppSidebar` with a vertical nav, and an `AppMain` body with a header row + grid of stat cards. Use `el.router(path, el.getRoot())` for nav clicks (never `window.location`). Stick to v3.14 flat handlers (`onClick`, not `on.click`)."
    },
    {
        id: 'pg.settings',
        category: 'pages',
        title: 'Settings page with sections',
        tagline: 'Tabbed sub-routes, form fields, save bar.',
        prompt: "Build a settings page with tabbed sub-sections (Profile, Workspace, Integrations, Danger Zone). Each tab is its own sub-page reachable via `/settings/<slug>`. Forms use top-level HTML attribute props (`placeholder`, `type`, `name`, `value`) \u2014 never wrapped in `attr:`. Sticky save bar at the bottom that gates on a dirty-state flag."
    },
    {
        id: 'pg.empty-state',
        category: 'pages',
        title: 'Empty state with CTA',
        tagline: 'Onboarding-grade empty page with illustration and primary action.',
        prompt: 'Compose an empty-state page in DOMQL v3.14 \u2014 centered illustration (an Icon at 5\u20136 sizes), a heading, two-line caption, primary CTA button, and a "Browse examples" secondary link. Use DS color tokens (`title`, `caption`, `blue`) and spacing tokens only. No raw px.'
    },
    // ── Design system ─────────────────────────────────────────────────────────
    {
        id: 'ds.theme-extend',
        category: 'design-system',
        title: 'Extend the design system',
        tagline: 'Add a new color, type ramp step, or spacing token cleanly.',
        prompt: "I need to extend the design system in a Symbols project. Walk me through adding (a) a new color (with light/dark tokens and shading modifiers like `.7`, `+50`), (b) a typography step, and (c) a spacing token. Show me where each lives under `designSystem/` and confirm lowercase keys. No hex colors hardcoded in components afterwards."
    },
    {
        id: 'ds.dark-mode',
        category: 'design-system',
        title: 'Dark / light theme switch',
        tagline: 'Per-component @dark variants without raw selectors.',
        prompt: "Show how to apply per-component dark-mode overrides in DOMQL v3.14. Use the `'@dark': { ':hover': {...} }` nested syntax \u2014 never chained selectors like `'@dark :hover'`. Wire up a theme switcher that toggles via `el.call('toggleTheme', target)`."
    },
    {
        id: 'ds.audit',
        category: 'design-system',
        title: 'Audit a component for token compliance',
        tagline: 'Strip raw px / hex / Tailwind palettes; report violations.',
        prompt: "Audit this Symbols component (paste below) for design-system compliance: replace any raw px / rem / hex / rgba with DS tokens, remove `!important`, replace any Tailwind-style palette names (`blue-500`) with shading modifiers (`blue.7`), and confirm all spacing uses DS tokens (X, Y, Z, A, B\u2026). Report each violation with a one-line fix.\n\nComponent:\n```js\n// paste here\n```"
    },
    // ── Migration ─────────────────────────────────────────────────────────────
    {
        id: 'mig.v3-v3.14',
        category: 'migration',
        title: "Migrate v3 \u2192 v3.14 syntax",
        tagline: "el.props.X \u2192 el.X, on.click \u2192 onClick, attr \u2192 flat props.",
        prompt: "Migrate this DOMQL v3 component to v3.14 (paste below). Required transforms:\n  \u2022 `el.props.X` \u2192 `el.X` everywhere (declaration AND runtime)\n  \u2022 `{ on: { click: ... } }` \u2192 `{ onClick: ... }` (also `init`, `render`)\n  \u2022 Flatten `attr: { placeholder, type, name, value, disabled }` to top-level props\n  \u2022 Drop redundant `extends:` when the key already matches\n  \u2022 Replace any project file imports with `el.call('fnName', ...)`\nDo NOT leave any `el.props.` / `on.` / `attr:` patterns behind."
    },
    {
        id: 'mig.react-to-domql',
        category: 'migration',
        title: "Convert React \u2192 DOMQL",
        tagline: "JSX, useState, hooks \u2192 plain object component + state model.",
        prompt: "Convert this React component to DOMQL v3.14 for a Symbols project (paste below). Translate JSX to nested DOMQL keys, replace useState with state object + s.update, replace event handlers with `onClick` / `onInput` flat handlers receiving `(e, el, s)`, and replace any Tailwind classes with DS tokens. No imports between project files."
    },
    // ── Integrations ──────────────────────────────────────────────────────────
    {
        id: 'int.install-rail',
        category: 'integrations',
        title: 'Mount InstallableRail in a project',
        tagline: 'Drop a workspace integration rail into any page.',
        prompt: "Show me how to mount an `InstallableRail` in a Symbols workspace page. I want the integration domain, scoped to the current workspace, in the rail layout, with a custom title. List which state keys it reads from the root and how it dispatches install modal opens (`openInstallableModal`)."
    },
    {
        id: 'int.openid',
        category: 'integrations',
        title: 'Wire an OAuth integration',
        tagline: 'Register a kind, add post-install hook, expose to MarketplaceCard.',
        prompt: "I want to add a new OAuth integration to the Symbols marketplace. Walk me through (1) inserting the kind row in `integration_kinds`, (2) registering the kind in the static catalog, (3) the OAuth callback handler, and (4) the post-install `onInstalled` hook (which fires AFTER confirm, not optimistically)."
    },
    // ── Debugging ─────────────────────────────────────────────────────────────
    {
        id: 'dbg.blank-render',
        category: 'debugging',
        title: 'Component renders blank in v3.14',
        tagline: 'Most common cause: leftover el.props / el.on access after migration.',
        prompt: "My DOMQL v3.14 component silently renders blank. Diagnose by checking, in order: (1) leftover `el.props.X` reads (v3.14 removed them \u2014 use `el.X`), (2) `on.event` handlers (v3.14 uses `onEvent`), (3) `attr:` wrappers swallowing flat props, (4) extends key collisions, (5) state read from the wrong host (check `marketplaceHostOf` / `*HostOf` walkers). Paste the component below."
    },
    {
        id: 'dbg.iframe-leak',
        category: 'debugging',
        title: 'Canvas iframe sharing design system with parent',
        tagline: "Scratch singleton bleed \u2014 isolate via context.designSystem.",
        prompt: "My canvas-hosted iframe project app is leaking the canvas editor's design system (or vice versa). Help me trace the Scratch module-level singleton (`getActiveConfig` in scratch/src/factory.js) and show how to thread an isolated config via `element.context.designSystem` instead of relying on the global."
    },
    // ── Refactoring ───────────────────────────────────────────────────────────
    {
        id: 'rf.extract-component',
        category: 'refactoring',
        title: 'Extract a sub-tree into a registered component',
        tagline: 'Promote inline keys to a project-level component with PascalCase.',
        prompt: "Extract this inline DOMQL sub-tree (paste below) into a named project-level component. Place it in `components/<Name>.js`, export with the PascalCase key, and reference it from the consumer by key name (no import \u2014 the framework auto-extends by key). Drop any redundant `extends:` once the key matches."
    },
    {
        id: 'rf.shared-library',
        category: 'refactoring',
        title: 'Promote a component to shared library',
        tagline: 'Move a duplicated component into shared/ with the right export shape.',
        prompt: "I have the same component duplicated across two Symbols projects. Promote it into the appropriate `shared` package, ensure it is exported through the package context, confirm `sharedLibraries.js` in each consumer already includes that package, and remove the local copies. Do NOT re-export the component from the consumer."
    }
];
const $f35c828cbbd7bc87$export$7b30e387e09f0d1b = {
    all: {
        label: 'All'
    },
    components: {
        label: 'Components'
    },
    pages: {
        label: 'Pages'
    },
    'design-system': {
        label: 'Design System'
    },
    migration: {
        label: 'Migration'
    },
    integrations: {
        label: 'Integrations'
    },
    debugging: {
        label: 'Debugging'
    },
    refactoring: {
        label: 'Refactoring'
    }
};
const $f35c828cbbd7bc87$var$_filteredPrompts = (cat)=>cat === 'all' ? $f35c828cbbd7bc87$export$1613a8bb42ebacf3 : $f35c828cbbd7bc87$export$1613a8bb42ebacf3.filter((p)=>p.category === cat);
const $f35c828cbbd7bc87$export$69f1ff2028df7c93 = {
    extends: 'Page',
    flow: 'y',
    gap: 'D',
    padding: 'C E',
    overflowY: 'auto',
    background: 'document',
    state: {
        activeCategory: 'all',
        _promptGalleryCopiedId: null
    },
    // ── Header ────────────────────────────────────────────────────────────────
    Header: {
        flow: 'y',
        gap: 'Z',
        maxWidth: 'I3',
        Eyebrow: {
            tag: 'span',
            text: 'Prompt Gallery',
            fontSize: 'Y',
            fontWeight: '600',
            color: 'blue',
            textTransform: 'uppercase',
            letterSpacing: 'X'
        },
        Title: {
            tag: 'h1',
            margin: '0',
            fontSize: 'F',
            fontWeight: '800',
            color: 'title',
            lineHeight: '1.1',
            text: 'Prompts that work for Symbols projects'
        },
        Subtitle: {
            tag: 'p',
            margin: '0',
            fontSize: 'A',
            color: 'caption',
            lineHeight: '1.5',
            text: "Curated, copy-ready prompts for building, migrating, and debugging DOMQL v3.14 components, pages, and design systems. Tap any card to copy the full prompt \u2014 paste it into Claude, the Symbols MCP, or the editor\u2019s AI tab."
        }
    },
    // ── Filter chip rail ──────────────────────────────────────────────────────
    FilterRail: {
        flow: 'x',
        gap: 'Y',
        flexWrap: 'wrap',
        padding: 'Z 0',
        borderTop: '1px solid line',
        borderBottom: '1px solid line',
        childExtends: 'PromptGalleryChip',
        children: $f35c828cbbd7bc87$export$7b30e387e09f0d1b
    },
    // ── Results meta line ─────────────────────────────────────────────────────
    ResultsLine: {
        tag: 'p',
        margin: '0',
        fontSize: 'Y2',
        color: 'caption',
        text: (el, s)=>{
            const total = $f35c828cbbd7bc87$export$1613a8bb42ebacf3.length;
            const cat = s.activeCategory;
            if (cat === 'all') return `${total} prompts \xb7 all categories`;
            const filtered = $f35c828cbbd7bc87$var$_filteredPrompts(cat).length;
            const label = ($f35c828cbbd7bc87$export$7b30e387e09f0d1b[cat] || {}).label || cat;
            return `${filtered} of ${total} prompts \xb7 ${label}`;
        }
    },
    // ── Grid ──────────────────────────────────────────────────────────────────
    Grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
        gap: 'A',
        childExtends: 'PromptGalleryCard',
        children: (el, s)=>{
            const visible = $f35c828cbbd7bc87$var$_filteredPrompts(s.activeCategory);
            if (visible.length === 0) return [
                {
                    extends: 'Flex',
                    flow: 'y',
                    gap: 'Z',
                    align: 'center center',
                    padding: 'D',
                    gridColumn: '1 / -1',
                    EmptyTitle: {
                        tag: 'h3',
                        margin: '0',
                        fontSize: 'B',
                        color: 'title',
                        text: 'No prompts in this category yet'
                    },
                    EmptyHint: {
                        tag: 'p',
                        margin: '0',
                        fontSize: 'Z2',
                        color: 'caption',
                        text: 'Switch to All to see every prompt.'
                    }
                }
            ];
            return visible;
        }
    }
};

});


parcelRegister("1H7QU", function(module, exports) {

$parcel$export(module.exports, "default", () => $13bfe5e6de06a320$export$2e2bcd8739ae039);

var $bvnx6 = parcelRequire("bvnx6");
var $13bfe5e6de06a320$export$2e2bcd8739ae039 = {
    '/': (0, $bvnx6.main)
};

});
parcelRegister("bvnx6", function(module, exports) {

$parcel$export(module.exports, "main", () => $8604d817b8f6b308$export$f22da7240b7add18);
const $8604d817b8f6b308$export$f22da7240b7add18 = {
    extends: 'AppPage',
    // `AppPage` defaults to `flow: x; overflow: hidden` — override to the
    // column layout the preview chrome needs (navbar on top, Content row
    // filling the rest).
    flow: 'column',
    height: '100vh',
    width: '100vw',
    rowGap: 'X2',
    fontSize: 'Z2',
    // PreviewNavbar always mounts — even when project data is null or fetch
    // failed. Individual slots inside gate their reads with optional-chaining.
    PreviewNavbar: {},
    // FallbackBanner — shown when a fallback env was used instead of the
    // originally-requested one (e.g. "production" URL served "development" data).
    FallbackBanner: {
        hide: (el, s)=>!s.root?.usedFallback,
        flow: 'row',
        align: 'center center',
        gap: 'A',
        padding: 'X B',
        background: 'yellow.1',
        color: 'title',
        fontSize: 'Z2',
        textAlign: 'center',
        Icon: {
            icon: 'info',
            boxSize: 'A A',
            color: 'yellow'
        },
        Text: {
            tag: 'span',
            text: (el, s)=>{
                const resolved = s.root?.resolvedEnv || 'development';
                const requested = s.root?.requestedEnv || 'production';
                return `Showing ${resolved} env \u{2014} ${requested} not published yet.`;
            }
        }
    },
    AppPage: {
        flex: '1',
        flow: 'x',
        overflow: 'hidden',
        gap: 'X2',
        padding: '- X2 X2',
        // Error boundary — replaces Scene content when project fetch failed.
        // PreviewNavbar still mounts above (always rendered regardless of data).
        PreviewErrorBoundary: {
            hide: (el, s)=>!s.root?.fetchError
        },
        // Left-hand sidebar — inline with Scene so opening it shrinks the
        // Scene width instead of overlaying.
        PreviewSidebar: {
            hide: (el, s)=>!!s.root?.fetchError
        },
        CodePreviewWidget: {
            if: (_, s)=>s.isCodeOpen && !s.root?.fetchError,
            width: 'G2',
            minWidth: 'F',
            height: '100%',
            borderRight: '1px solid',
            borderColor: 'line'
        },
        Scene: {
            flex: '1',
            hide: (el, s)=>!!s.root?.fetchError
        }
    }
};

});


parcelRegister("88ocU", function(module, exports) {

$parcel$export(module.exports, "AdminSidebar", () => (parcelRequire("5nhB0")).AdminSidebar);
$parcel$export(module.exports, "AdminSidebarLink", () => (parcelRequire("5nhB0")).AdminSidebarLink);
$parcel$export(module.exports, "AdminUserRow", () => (parcelRequire("5nhB0")).AdminUserRow);
$parcel$export(module.exports, "AdminActivityScoringRow", () => (parcelRequire("g7qnn")).AdminActivityScoringRow);
$parcel$export(module.exports, "AdminLogDay", () => (parcelRequire("9aGUO")).AdminLogDay);
$parcel$export(module.exports, "AdminLogGroup", () => (parcelRequire("9aGUO")).AdminLogGroup);
$parcel$export(module.exports, "AdminLogRow", () => (parcelRequire("9aGUO")).AdminLogRow);
$parcel$export(module.exports, "AdminLogCalendar", () => (parcelRequire("9aGUO")).AdminLogCalendar);
$parcel$export(module.exports, "AdminLogCalendarCell", () => (parcelRequire("9aGUO")).AdminLogCalendarCell);
$parcel$export(module.exports, "IntegrationCategoryGroup", () => (parcelRequire("5yqCy")).IntegrationCategoryGroup);
$parcel$export(module.exports, "IntegrationCategoryCard", () => (parcelRequire("5yqCy")).IntegrationCategoryCard);
$parcel$export(module.exports, "SupabaseNewForm", () => (parcelRequire("1NvTc")).SupabaseNewForm);
$parcel$export(module.exports, "SupabaseFormField", () => (parcelRequire("1NvTc")).SupabaseFormField);
$parcel$export(module.exports, "SupabaseInstanceList", () => (parcelRequire("1NvTc")).SupabaseInstanceList);
$parcel$export(module.exports, "SupabaseInstanceCard", () => (parcelRequire("1NvTc")).SupabaseInstanceCard);
$parcel$export(module.exports, "GithubNewForm", () => (parcelRequire("kHSc9")).GithubNewForm);
$parcel$export(module.exports, "GithubField", () => (parcelRequire("kHSc9")).GithubField);
$parcel$export(module.exports, "GithubInstanceList", () => (parcelRequire("kHSc9")).GithubInstanceList);
$parcel$export(module.exports, "GithubInstanceCard", () => (parcelRequire("kHSc9")).GithubInstanceCard);
$parcel$export(module.exports, "GoogleConfigCard", () => (parcelRequire("f9P05")).GoogleConfigCard);
$parcel$export(module.exports, "GoogleField", () => (parcelRequire("f9P05")).GoogleField);
$parcel$export(module.exports, "NpmNewForm", () => (parcelRequire("aNbvv")).NpmNewForm);
$parcel$export(module.exports, "NpmField", () => (parcelRequire("aNbvv")).NpmField);
$parcel$export(module.exports, "NpmInstanceList", () => (parcelRequire("aNbvv")).NpmInstanceList);
$parcel$export(module.exports, "NpmInstanceCard", () => (parcelRequire("aNbvv")).NpmInstanceCard);
$parcel$export(module.exports, "AdminStatusSection", () => (parcelRequire("9wOaP")).AdminStatusSection);
$parcel$export(module.exports, "AdminStatusRow", () => (parcelRequire("9wOaP")).AdminStatusRow);
$parcel$export(module.exports, "McpConnectorAdminCard", () => (parcelRequire("8SCVM")).McpConnectorAdminCard);
$parcel$export(module.exports, "AdminMcpConnectors", () => (parcelRequire("8SCVM")).AdminMcpConnectors);
$parcel$export(module.exports, "DataSidebarLink", () => (parcelRequire("8IMAu")).DataSidebarLink);
$parcel$export(module.exports, "DataUserRow", () => (parcelRequire("8IMAu")).DataUserRow);
$parcel$export(module.exports, "DataProjectRow", () => (parcelRequire("8IMAu")).DataProjectRow);
$parcel$export(module.exports, "DataSubscriptionRow", () => (parcelRequire("8IMAu")).DataSubscriptionRow);
$parcel$export(module.exports, "DataPlanFeature", () => (parcelRequire("8IMAu")).DataPlanFeature);
$parcel$export(module.exports, "DataPlanFeatureRow", () => (parcelRequire("8IMAu")).DataPlanFeatureRow);

var $g9ESP = parcelRequire("g9ESP");

var $gA7rm = parcelRequire("gA7rm");

var $aYhKy = parcelRequire("aYhKy");

var $1VHA3 = parcelRequire("1VHA3");

var $1nf9Q = parcelRequire("1nf9Q");

var $i9uIC = parcelRequire("i9uIC");

var $fwZRT = parcelRequire("fwZRT");

var $7Y1ts = parcelRequire("7Y1ts");

var $8F2pQ = parcelRequire("8F2pQ");

var $60caI = parcelRequire("60caI");

var $1o8nJ = parcelRequire("1o8nJ");

var $92WQO = parcelRequire("92WQO");

var $8ijfH = parcelRequire("8ijfH");

var $aI4CX = parcelRequire("aI4CX");

var $lykpX = parcelRequire("lykpX");

var $2u2Du = parcelRequire("2u2Du");

var $5pzPy = parcelRequire("5pzPy");

var $9WkW5 = parcelRequire("9WkW5");

var $32MAk = parcelRequire("32MAk");

var $btLXS = parcelRequire("btLXS");

var $73QnC = parcelRequire("73QnC");

var $04mCb = parcelRequire("04mCb");

var $2EVKl = parcelRequire("2EVKl");

var $bokCg = parcelRequire("bokCg");

var $gLTua = parcelRequire("gLTua");

var $415Fs = parcelRequire("415Fs");

var $iGn5V = parcelRequire("iGn5V");

var $e7qqB = parcelRequire("e7qqB");

var $5nhB0 = parcelRequire("5nhB0");

var $g7qnn = parcelRequire("g7qnn");

var $9aGUO = parcelRequire("9aGUO");

var $5yqCy = parcelRequire("5yqCy");

var $1NvTc = parcelRequire("1NvTc");

var $kHSc9 = parcelRequire("kHSc9");

var $f9P05 = parcelRequire("f9P05");

var $aNbvv = parcelRequire("aNbvv");

var $9wOaP = parcelRequire("9wOaP");

var $8SCVM = parcelRequire("8SCVM");

var $8IMAu = parcelRequire("8IMAu");

var $gOurQ = parcelRequire("gOurQ");

var $f6T1d = parcelRequire("f6T1d");

var $hQlkx = parcelRequire("hQlkx");

var $bPy8R = parcelRequire("bPy8R");
$parcel$exportWildcard(module.exports, $g9ESP);
$parcel$exportWildcard(module.exports, $gA7rm);
$parcel$exportWildcard(module.exports, $aYhKy);
$parcel$exportWildcard(module.exports, $1VHA3);
$parcel$exportWildcard(module.exports, $1nf9Q);
$parcel$exportWildcard(module.exports, $i9uIC);
$parcel$exportWildcard(module.exports, $fwZRT);
$parcel$exportWildcard(module.exports, $7Y1ts);
$parcel$exportWildcard(module.exports, $8F2pQ);
$parcel$exportWildcard(module.exports, $60caI);
$parcel$exportWildcard(module.exports, $1o8nJ);
$parcel$exportWildcard(module.exports, $92WQO);
$parcel$exportWildcard(module.exports, $8ijfH);
$parcel$exportWildcard(module.exports, $aI4CX);
$parcel$exportWildcard(module.exports, $lykpX);
$parcel$exportWildcard(module.exports, $2u2Du);
$parcel$exportWildcard(module.exports, $5pzPy);
$parcel$exportWildcard(module.exports, $9WkW5);
$parcel$exportWildcard(module.exports, $32MAk);
$parcel$exportWildcard(module.exports, $btLXS);
$parcel$exportWildcard(module.exports, $73QnC);
$parcel$exportWildcard(module.exports, $04mCb);
$parcel$exportWildcard(module.exports, $2EVKl);
$parcel$exportWildcard(module.exports, $bokCg);
$parcel$exportWildcard(module.exports, $gLTua);
$parcel$exportWildcard(module.exports, $415Fs);
$parcel$exportWildcard(module.exports, $iGn5V);
$parcel$exportWildcard(module.exports, $e7qqB);
$parcel$exportWildcard(module.exports, $gOurQ);
$parcel$exportWildcard(module.exports, $f6T1d);
$parcel$exportWildcard(module.exports, $hQlkx);
$parcel$exportWildcard(module.exports, $bPy8R);

});
parcelRegister("g9ESP", function(module, exports) {

$parcel$export(module.exports, "PageHeader", () => $bc2d3333089c03cd$export$53f1cd6809577fc5);
const $bc2d3333089c03cd$export$53f1cd6809577fc5 = {
    flow: 'x',
    align: 'center space-between',
    padding: 'Z A',
    borderBottomWidth: '1px',
    borderBottomColor: 'line',
    borderBottomStyle: 'solid',
    minHeight: 'D',
    gap: 'A',
    background: 'overlayStrong',
    color: 'title',
    position: 'sticky',
    top: '0',
    zIndex: '20',
    LeftGroup: {
        flow: 'x',
        align: 'center left',
        gap: 'Z1',
        flex: '1',
        minWidth: '0'
    },
    CenterGroup: {
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)'
    },
    RightGroup: {
        flow: 'x',
        align: 'center right',
        gap: 'Z1'
    }
};

});

parcelRegister("gA7rm", function(module, exports) {

$parcel$export(module.exports, "PeopleGroup", () => $c125c79bca9474cc$export$7c7e61f64744b9);
$parcel$export(module.exports, "AppPersonRow", () => $c125c79bca9474cc$export$9ea2ed864c273f8b);
const $c125c79bca9474cc$export$7c7e61f64744b9 = {
    flow: 'y',
    gap: 'Z',
    marginBottom: 'Z1',
    CaptionTitle: {
        fontSize: 'Y2',
        Text: {
            text: (el)=>el.parent?.parent?.label || ''
        }
    },
    List: {
        flow: 'y',
        gap: 'Y',
        childExtends: 'AppPersonRow',
        childrenAs: 'state',
        children: (el, s)=>{
            const group = el.parent.groupName;
            if (group === 'team') return el.call('activeMembers');
            return el.call('peopleByShareClass', group);
        }
    }
};
const $c125c79bca9474cc$export$9ea2ed864c273f8b = {
    flow: 'x',
    align: 'center left',
    gap: 'Z',
    padding: 'Z Z1',
    margin: '- -Z1',
    round: 'Z',
    fontSize: 'Z1',
    cursor: 'pointer',
    attr: {
        'data-personrow': 'true',
        'data-email': (el, s)=>s && s.email || ''
    },
    ':hover': {
        background: 'overlay'
    },
    onClick: (e, el, s)=>{
        e.stopPropagation();
        const rect = el.node.getBoundingClientRect();
        const CARD_W = 320;
        const CARD_H = 280;
        const M = 8;
        const vw = window.innerWidth;
        const vh = window.innerHeight;
        let x = rect.right + M;
        let y = rect.top;
        if (x + CARD_W > vw) x = Math.max(M, rect.left - CARD_W - M);
        if (y + CARD_H > vh) y = Math.max(M, vh - CARD_H - M);
        s.root.update({
            selectedPerson: {
                name: s.name,
                email: s.email,
                avatar: s.avatar,
                location: s.location,
                timezone: s.timezone,
                x: x,
                y: y
            }
        });
    },
    Avatar: {
        avatarType: 'initials',
        boxSize: 'B1 B1',
        src: (el, s)=>el.call('avatarUrl', s && s.name)
    },
    Info: {
        flow: 'y',
        gap: 'V',
        flex: '1',
        minWidth: '0',
        overflow: 'hidden',
        Name: {
            tag: 'span',
            fontSize: 'Z2',
            color: 'title',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>s.name || ''
        },
        Caption: {
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>s.position || ''
        }
    }
};

});

parcelRegister("aYhKy", function(module, exports) {

$parcel$export(module.exports, "AppSidebarLink", () => $7fcd46b7b62fe23e$export$9315b0446c78d51c);
const $7fcd46b7b62fe23e$export$9315b0446c78d51c = {
    extends: 'Link',
    href: (el)=>el.href || '#',
    flow: 'x',
    align: 'center left',
    gap: 'Z1',
    padding: 'Z A',
    round: 'C',
    cursor: 'pointer',
    fontSize: 'A',
    textDecoration: 'none',
    fontWeight: (el, s)=>(s.root?.route || s.root?.currentPath || '/') === el.href ? '600' : '500',
    background: (el, s)=>(s.root?.route || s.root?.currentPath || '/') === el.href ? 'overlay' : 'transparent',
    color: (el, s)=>(s.root?.route || s.root?.currentPath || '/') === el.href ? 'title' : 'subtitle',
    ':hover': {
        background: 'overlay',
        color: 'title'
    },
    transition: 'background 120ms ease, color 120ms ease',
    Icon: {
        icon: (el)=>el.parent.icon || 'state',
        boxSize: 'A',
        color: (el, s)=>(s.root?.route || s.root?.currentPath || '/') === el.parent.href ? 'blue' : 'caption'
    },
    Label: {
        tag: 'span',
        text: (el)=>el.parent.label || ''
    },
    onClick: (e, el, s)=>{
        e.preventDefault();
        let rootEl = el;
        while(rootEl && !rootEl.routes)rootEl = rootEl.parent;
        const router = el.context?.utils?.router;
        if (router && rootEl) router(el.href, rootEl, {}, {
            pushState: true,
            scrollToTop: true
        });
    }
};

});

parcelRegister("1VHA3", function(module, exports) {

$parcel$export(module.exports, "SharedPersonCard", () => $167ceb7d3875828d$export$c6a87cc2b99bcb2e);
const $167ceb7d3875828d$export$c6a87cc2b99bcb2e = {
    hide: (el, s)=>!(s && s.root && s.root.selectedPerson),
    position: 'fixed',
    zIndex: 1500,
    flow: 'y',
    gap: 'Z1',
    padding: 'A',
    width: 'H',
    round: 'Z2',
    theme: 'modal',
    borderWidth: '1px',
    borderColor: 'line',
    borderStyle: 'solid',
    boxShadow: '0 8px 24px var(--color-shadow)',
    top: (el, s)=>s && s.root && s.root.selectedPerson ? `${s.root.selectedPerson.y}px` : '0',
    left: (el, s)=>s && s.root && s.root.selectedPerson ? `${s.root.selectedPerson.x}px` : '0',
    onCreate: (el, s)=>{
        el._closeOnOutside = (ev)=>{
            if (!el.node) return;
            if (el.node.contains(ev.target)) return;
            if (ev.target.closest && ev.target.closest('[data-personrow]')) return;
            if (s && s.root && s.root.update) s.root.update({
                selectedPerson: null
            });
        };
        setTimeout(()=>document.addEventListener('mousedown', el._closeOnOutside), 0);
    },
    onRemove: (el)=>{
        if (el._closeOnOutside) document.removeEventListener('mousedown', el._closeOnOutside);
    },
    Header: {
        flow: 'x',
        align: 'center left',
        gap: 'Z1',
        Avatar: {
            avatarType: 'initials',
            boxSize: 'C C',
            src: (el, s)=>el.call('avatarUrl', s && s.root && s.root.selectedPerson && s.root.selectedPerson.name)
        },
        Info: {
            flow: 'y',
            gap: 'Y2',
            flex: '1',
            Name: {
                tag: 'span',
                fontSize: 'A',
                fontWeight: '600',
                color: 'title',
                text: (el, s)=>s && s.root && s.root.selectedPerson && s.root.selectedPerson.name || ''
            },
            Email: {
                tag: 'span',
                fontSize: 'Z2',
                color: 'caption',
                text: (el, s)=>s && s.root && s.root.selectedPerson && s.root.selectedPerson.email || ''
            }
        }
    },
    Meta: {
        flow: 'y',
        gap: 'Y2',
        LocationRow: {
            flow: 'x',
            align: 'center left',
            gap: 'Z',
            Icon: {
                icon: 'pin',
                boxSize: 'Z2'
            },
            Text: {
                tag: 'span',
                fontSize: 'Z2',
                color: 'subtitle',
                text: (el, s)=>s && s.root && s.root.selectedPerson && s.root.selectedPerson.location || ''
            }
        },
        TimezoneRow: {
            flow: 'x',
            align: 'center left',
            gap: 'Z',
            Icon: {
                icon: 'clock',
                boxSize: 'Z2'
            },
            Text: {
                tag: 'span',
                fontSize: 'Z2',
                color: 'subtitle',
                text: (el, s)=>{
                    const p = s && s.root && s.root.selectedPerson;
                    if (!p || !p.timezone) return '';
                    try {
                        const localTime = new Intl.DateTimeFormat('en-US', {
                            timeZone: p.timezone,
                            hour: '2-digit',
                            minute: '2-digit',
                            hour12: false
                        }).format(new Date());
                        return `${p.timezone.split('/').pop().replace(/_/g, ' ')} \xb7 ${localTime}`;
                    } catch (_) {
                        return p.timezone;
                    }
                }
            }
        }
    },
    Actions: {
        flow: 'x',
        gap: 'Z'
    }
};

});

parcelRegister("1nf9Q", function(module, exports) {

$parcel$export(module.exports, "CalOnlineAvatar", () => $1003b2761a300315$export$e0031349d40660d7);
$parcel$export(module.exports, "CalOnlineUsersBar", () => $1003b2761a300315$export$7e81fd04cf684b73);
const $1003b2761a300315$export$e0031349d40660d7 = {
    position: 'relative',
    width: 'C',
    height: 'C',
    round: '50%',
    borderWidth: '2px',
    borderColor: 'overlayStrong',
    borderStyle: 'solid',
    flexShrink: '0',
    marginLeft: '-Z',
    background: (el, s)=>el.call('colorFromEmail', s.email || ''),
    align: 'center center',
    cursor: 'pointer',
    title: (el, s)=>s.name || s.email || '',
    onClick: (e, el, s)=>{
        if (s.email) el.state.root.update({
            profileEmail: s.email
        });
    },
    Initial: {
        tag: 'span',
        fontSize: 'Y2',
        fontWeight: '700',
        color: 'white',
        text: (el, s)=>{
            const n = s.name || s.email || '?';
            const parts = n.split(/[\s@.]+/).filter(Boolean);
            return ((parts[0]?.[0] || '') + (parts[1]?.[0] || '')).toUpperCase();
        }
    },
    OnlineDot: {
        position: 'absolute',
        bottom: '-1px',
        right: '-1px',
        width: 'Z',
        height: 'Z',
        round: '50%',
        background: 'green',
        borderWidth: '2px',
        borderColor: 'overlayStrong',
        borderStyle: 'solid'
    }
};
const $1003b2761a300315$export$7e81fd04cf684b73 = {
    flow: 'x',
    align: 'center right',
    paddingLeft: 'Z',
    childExtends: 'CalOnlineAvatar',
    childrenAs: 'state',
    children: (el, s)=>{
        const max = el.maxAvatars || 6;
        const online = s.root.onlineUsers || [];
        const me = s.root.currentUserEmail;
        const byEmail = el.call('peopleByEmail');
        const enriched = online.filter((u)=>u.email !== me).map((u)=>({
                email: u.email,
                name: byEmail[u.email]?.name || u.email
            })).slice(0, max);
        const overflow = online.length - 1 - enriched.length;
        if (overflow > 0) enriched.push({
            email: `+${overflow}`,
            name: `${overflow} more online`,
            _overflow: true
        });
        return enriched;
    }
};

});

parcelRegister("i9uIC", function(module, exports) {

$parcel$export(module.exports, "IconSection", () => $d370e552d8ee4358$export$5a1355295af96385);
$parcel$export(module.exports, "IntroRun", () => $d370e552d8ee4358$export$30f83fb4ef98f83e);
const $d370e552d8ee4358$export$5a1355295af96385 = {
    flow: 'x',
    align: 'flex-start',
    gap: 'A',
    IconCol: {
        align: 'flex-start center',
        color: 'caption',
        SectionIcon: {
            extends: 'Icon',
            margin: 'W2 - -',
            icon: (el)=>el.parent.parent.icon || 'state'
        }
    },
    Right: {
        flow: 'y',
        gap: 'A',
        flex: '1',
        minWidth: '0',
        Intro: {
            flow: 'x',
            gap: 'Z',
            align: 'baseline',
            flexWrap: 'wrap',
            childExtends: 'IntroRun',
            childrenAs: 'state',
            children: (el, s)=>{
                const intro = el.parent.parent.intro;
                return typeof intro === 'function' ? intro(s) : intro || [];
            }
        }
    }
};
const $d370e552d8ee4358$export$30f83fb4ef98f83e = {
    tag: 'span',
    fontSize: 'A',
    color: (el, s)=>s.color || 'caption',
    fontWeight: (el, s)=>s.weight || '500',
    text: (el, s)=>s.text
};

});

parcelRegister("fwZRT", function(module, exports) {

$parcel$export(module.exports, "StoryCard", () => $b4e9d5ea10e2756d$export$a4842f11451d38bd);
$parcel$export(module.exports, "StoryCardSegment", () => $b4e9d5ea10e2756d$export$4570288c49f54f14);
const $b4e9d5ea10e2756d$var$_isTicket = (s)=>!!(s && s.name && typeof s.name === 'string' && s.name.charAt(0) === '#');
const $b4e9d5ea10e2756d$var$_isEpic = (s)=>!!(s && (s.name || s._counts) && !$b4e9d5ea10e2756d$var$_isTicket(s));
const $b4e9d5ea10e2756d$var$_storyHref = (s)=>$b4e9d5ea10e2756d$var$_isEpic(s) ? `/tickets/board?epic=${encodeURIComponent(s.id || '')}` : '/tickets/stories';
let $b4e9d5ea10e2756d$var$_cssInjected = false;
const $b4e9d5ea10e2756d$var$_injectTicketCSS = ()=>{
    if ($b4e9d5ea10e2756d$var$_cssInjected) return;
    $b4e9d5ea10e2756d$var$_cssInjected = true;
    const style = document.createElement('style');
    style.textContent = '[data-card-type="ticket"] [data-story-only] { display: none !important; }';
    document.head.appendChild(style);
};
const $b4e9d5ea10e2756d$export$a4842f11451d38bd = {
    extends: 'Link',
    href: (el, s)=>$b4e9d5ea10e2756d$var$_storyHref(s),
    attr: {
        'data-card-type': (el, s)=>$b4e9d5ea10e2756d$var$_isTicket(s) ? 'ticket' : $b4e9d5ea10e2756d$var$_isEpic(s) ? 'epic' : 'story'
    },
    onCreate: ()=>$b4e9d5ea10e2756d$var$_injectTicketCSS(),
    flow: 'y',
    round: 'C2',
    background: 'overlay',
    backdropFilter: 'blur(8px)',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'line',
    overflow: 'hidden',
    textDecoration: 'none',
    cursor: 'pointer',
    position: 'relative',
    boxShadow: 'inset 0 1px 0 var(--color-line), 0 8px 32px -16px var(--color-shadow)',
    transition: 'transform 200ms cubic-bezier(.2,.8,.2,1), box-shadow 200ms ease, border-color 200ms ease, background 200ms ease',
    ':hover': {
        borderColor: 'overlayStrong',
        background: 'overlay',
        transform: 'translateY(-3px)',
        boxShadow: 'inset 0 1px 0 var(--color-line), 0 16px 48px -8px var(--color-shadow)'
    },
    onClick: (e, el, s)=>{
        if ($b4e9d5ea10e2756d$var$_isTicket(s)) return;
        e.preventDefault();
        el.router($b4e9d5ea10e2756d$var$_storyHref(s), el.getRoot(), {}, {
            pushState: true,
            scrollToTop: true
        });
    },
    ScHeader: {
        padding: 'B B1 A B1',
        flow: 'y',
        gap: 'Z',
        ScHeaderTitle: {
            tag: 'h3',
            margin: '0',
            fontSize: 'B1',
            fontWeight: '700',
            letterSpacing: '-.01em',
            lineHeight: '1.2',
            color: 'title',
            text: (el, s)=>s.title || s.name || ''
        },
        ScHeaderDescription: {
            display: (el, s)=>s.description ? '-webkit-box' : 'none',
            tag: 'p',
            margin: '0',
            fontSize: 'Z2',
            lineHeight: '1.45',
            color: 'caption',
            overflow: 'hidden',
            webkitLineClamp: '2',
            webkitBoxOrient: 'vertical',
            text: (el, s)=>s.description || ''
        }
    },
    ScBody: {
        flow: 'y',
        gap: 'A',
        padding: '0 B1 B1 B1',
        EpicStats: {
            hide: (el, s)=>!$b4e9d5ea10e2756d$var$_isEpic(s) || $b4e9d5ea10e2756d$var$_isTicket(s),
            flow: 'x',
            align: 'center space-between',
            gap: 'Z',
            Total: {
                flow: 'y',
                gap: 'V',
                Number: {
                    tag: 'span',
                    fontSize: 'D',
                    fontWeight: '700',
                    letterSpacing: '-.02em',
                    lineHeight: '1',
                    color: 'title',
                    text: (el, s)=>String(s._counts?.total || 0)
                },
                Label: {
                    tag: 'span',
                    fontSize: 'V',
                    fontWeight: '700',
                    letterSpacing: '.1em',
                    color: 'caption',
                    text: 'TICKETS'
                }
            },
            DoneBadge: {
                display: (el, s)=>{
                    const tot = s._counts?.total || 0;
                    return tot > 0 ? 'inline-flex' : 'none';
                },
                tag: 'span',
                padding: 'V Z1',
                round: 'C',
                fontSize: 'Y2',
                fontWeight: '700',
                letterSpacing: '.04em',
                color: 'green',
                background: 'color-mix(in srgb, var(--color-green) 16%, transparent)',
                text: (el, s)=>{
                    const c = s._counts?.byColumn || {};
                    const tot = s._counts?.total || 0;
                    const done = c.eede5560 || 0;
                    return tot ? `${Math.round(done / tot * 100)}% DONE` : '';
                }
            }
        },
        EpicBreakdown: {
            display: (el, s)=>$b4e9d5ea10e2756d$var$_isEpic(s) && (s._counts?.total || 0) > 0 ? 'flex' : 'none',
            flow: 'x',
            width: '100%',
            height: 'Z',
            round: 'C',
            overflow: 'hidden',
            background: 'overlay',
            childExtends: 'StoryCardSegment',
            childrenAs: 'state',
            children: (el, s)=>{
                // `el.parent.parent` is the card element whose state is the epic row.
                // During the first reactive pass the parent chain may not be fully
                // attached yet — DOMQL runs `children:` factories eagerly so it can
                // diff on the next pass, and at that moment `el.parent` can be null.
                // Guard with optional chaining instead of assuming a two-hop walk.
                const epic = el?.parent?.parent?.state;
                if (!epic) return [];
                const counts = epic._counts?.byColumn || {};
                const total = epic._counts?.total || 0;
                if (!total) return [];
                const cols = el?.state?.root?.columns || [];
                return cols.filter((c)=>counts[c.key] > 0).map((c)=>({
                        key: c.key,
                        label: c.label,
                        color: c.color,
                        count: counts[c.key],
                        pct: counts[c.key] / total * 100
                    }));
            }
        },
        TicketInfo: {
            display: 'none',
            onRender: (el, s)=>{
                if (el.node && $b4e9d5ea10e2756d$var$_isTicket(s)) el.node.style.display = 'flex';
            },
            flow: 'y',
            gap: 'Z',
            TicketDescription: {
                tag: 'p',
                margin: '0',
                fontSize: 'Z2',
                lineHeight: '1.45',
                color: 'caption',
                text: (el, s)=>s.description || ''
            }
        },
        ScMembers: {
            attr: {
                'data-story-only': 'true'
            },
            flow: 'y',
            gap: 'Z',
            ScStack: {
                extends: 'AvatarBundle',
                emails: (el, s)=>s.members || []
            },
            ScCaption: {
                tag: 'span',
                fontSize: 'Z2',
                color: 'caption',
                text: (el, s)=>`${(s.members || []).length} people joined`
            }
        },
        ScMeeting: {
            attr: {
                'data-story-only': 'true'
            },
            flow: 'y',
            gap: 'Y',
            ScMeetingTitle: {
                flow: 'x',
                align: 'center',
                gap: 'Z',
                ScMeetingIcon: {
                    extends: 'Icon',
                    icon: 'date',
                    boxSize: 'A',
                    color: 'green'
                },
                ScMeetingText: {
                    tag: 'span',
                    fontSize: 'A',
                    fontWeight: '700',
                    color: 'green',
                    text: (el, s)=>s.meeting_title || s.meetingTitle
                }
            },
            ScWhen: {
                flow: 'x',
                gap: 'Z',
                align: 'baseline',
                ScWhenSub: {
                    tag: 'span',
                    fontSize: 'Z2',
                    color: 'caption',
                    text: 'Planned for'
                },
                ScWhenDay: {
                    tag: 'span',
                    fontSize: 'Z2',
                    color: 'title',
                    fontWeight: '700',
                    text: (el, s)=>s.meeting_date || s.meetingDate || ''
                },
                ScWhenAt: {
                    tag: 'span',
                    fontSize: 'Z2',
                    color: 'caption',
                    text: (el, s)=>`\xb7 at ${s.meeting_time || s.meetingTime || ''}`
                }
            }
        }
    }
};
const $b4e9d5ea10e2756d$export$4570288c49f54f14 = {
    tag: 'span',
    height: '100%',
    background: (el, s)=>`var(--color-${el.call('githubColorTokenFromName', s.color)})`,
    opacity: '.85',
    width: (el, s)=>`${s.pct || 0}%`,
    title: (el, s)=>`${s.label || ''} \xb7 ${s.count || 0}`,
    ':hover': {
        opacity: '1'
    }
};

});

parcelRegister("7Y1ts", function(module, exports) {

$parcel$export(module.exports, "StoriesSection", () => $5ccf47b84ce207cb$export$2f43d8b2b67d66dc);
const $5ccf47b84ce207cb$export$2f43d8b2b67d66dc = {
    extends: 'IconSection',
    Right: {
        Body: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
            gap: 'B',
            childExtends: 'StoryCard',
            childrenAs: 'state',
            children: (el, s)=>{
                let n = el.parent;
                while(n && typeof n.items !== 'function')n = n.parent;
                if (!n) return [];
                return n.items(s) || [];
            }
        }
    }
};

});

parcelRegister("8F2pQ", function(module, exports) {

$parcel$export(module.exports, "SharedViewSwitcher", () => $64e406cb83e03ec6$export$1954168d8cb01f0a);
$parcel$export(module.exports, "SharedViewSwitcherBtn", () => $64e406cb83e03ec6$export$ad0cfc6a1b938cb0);
const $64e406cb83e03ec6$export$1954168d8cb01f0a = {
    flow: 'x',
    borderWidth: '1px',
    borderColor: 'line',
    borderStyle: 'solid',
    round: 'Z',
    overflow: 'hidden',
    stateKey: 'viewMode',
    mode: 'state'
};
const $64e406cb83e03ec6$var$_stateKey = (el)=>el.parent && el.parent.stateKey || 'viewMode';
const $64e406cb83e03ec6$var$_mode = (el)=>el.parent && el.parent.mode || 'state';
const $64e406cb83e03ec6$var$_isActive = (el, s)=>{
    const root = s && s.root;
    if (!root) return false;
    if ($64e406cb83e03ec6$var$_mode(el) === 'route') return root.route === el.value;
    return root[$64e406cb83e03ec6$var$_stateKey(el)] === el.value;
};
const $64e406cb83e03ec6$export$ad0cfc6a1b938cb0 = {
    tag: 'button',
    type: 'button',
    flow: 'x',
    align: 'center center',
    gap: 'Z',
    padding: 'Z A',
    border: 'none',
    cursor: 'pointer',
    fontSize: 'Z2',
    background: (el, s)=>$64e406cb83e03ec6$var$_isActive(el, s) ? 'overlayStrong' : 'transparent',
    color: (el, s)=>$64e406cb83e03ec6$var$_isActive(el, s) ? 'title' : 'caption',
    fontWeight: (el, s)=>$64e406cb83e03ec6$var$_isActive(el, s) ? '600' : '400',
    ':hover': {
        color: 'title',
        background: 'overlay'
    },
    Icon: {
        display: (el)=>el.parent && el.parent.icon ? 'inline-flex' : 'none',
        icon: (el)=>el.parent && el.parent.icon || 'state',
        boxSize: 'Z2'
    },
    Label: {
        tag: 'span',
        text: (el)=>el.parent && el.parent.label || ''
    },
    onClick: (e, el, s)=>{
        e.preventDefault();
        e.stopPropagation();
        if (!s || !s.root) return;
        if ($64e406cb83e03ec6$var$_mode(el) === 'route') {
            el.router(el.value, el.getRoot(), {}, {
                pushState: true,
                scrollToTop: true
            });
            return;
        }
        s.root.update({
            [$64e406cb83e03ec6$var$_stateKey(el)]: el.value
        });
    }
};

});

parcelRegister("60caI", function(module, exports) {

$parcel$export(module.exports, "PageHero", () => $45ec2f36d615d14b$export$4b2976b57d220ac6);
const $45ec2f36d615d14b$export$4b2976b57d220ac6 = {
    flow: 'y',
    gap: 'A',
    padding: 'C',
    maxWidth: 'L+L',
    width: '100%',
    margin: '0 auto',
    position: 'relative',
    borderBottomWidth: '1px',
    borderBottomColor: 'line',
    borderBottomStyle: 'solid',
    Eyebrow: {
        flow: 'x',
        align: 'center left',
        gap: 'Z',
        fontSize: 'V',
        fontWeight: '700',
        letterSpacing: '.18em',
        color: 'cyan',
        Dot: {
            width: 'V',
            height: 'V',
            round: '50%',
            background: 'cyan'
        },
        Text: {
            tag: 'span',
            text: (el)=>el.parent.parent.eyebrow || ''
        }
    },
    Headline: {
        tag: 'h1',
        margin: '0',
        fontSize: 'F1',
        fontWeight: '700',
        letterSpacing: '-.025em',
        lineHeight: '0.95',
        color: 'title',
        text: (el, s)=>{
            const h = el.parent.headline;
            return typeof h === 'function' ? h(el, s) : h || '';
        }
    },
    Lede: {
        tag: 'p',
        margin: '0',
        maxWidth: 'L',
        fontSize: 'B',
        lineHeight: '1.5',
        fontWeight: '400',
        color: 'subtitle',
        text: (el, s)=>{
            const l = el.parent.lede;
            return typeof l === 'function' ? l(el, s) : l || '';
        }
    }
};

});

parcelRegister("92WQO", function(module, exports) {

$parcel$export(module.exports, "UpgradeBanner", () => $6961f381344225cc$export$7d368097f6d36082);
// Upgrade CTA — shown when the current workspace's tier doesn't meet a
// surface's requirement. Wrap any tier-gated route with:
//
//   MyScaleOnlySurface: {
//     hide: (el, s) => el.call('isScale', s.root),
//     UpgradeBanner: { requires: 'scale' }
//   }
//
// Client-side gating is UX only — the server's credit meter + tier
// guards are authoritative.

var $bnIri = parcelRequire("bnIri");
const $6961f381344225cc$export$7d368097f6d36082 = {
    flow: 'y',
    align: 'center center',
    gap: 'Z1',
    padding: 'B',
    margin: 'A auto',
    maxWidth: 'H',
    background: 'overlay',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'line',
    round: 'Z1',
    textAlign: 'center',
    Icon: {
        icon: 'lock',
        boxSize: 'B',
        color: 'caption'
    },
    Title: {
        tag: 'h2',
        fontSize: 'A',
        fontWeight: '700',
        color: 'title',
        margin: '0',
        text: (el, s)=>{
            const req = el.requires || 'scale';
            return `${(0, $bnIri.tierLabel)(req)} required`;
        }
    },
    Body: {
        tag: 'p',
        fontSize: 'Z1',
        color: 'caption',
        lineHeight: '1.5',
        margin: '0',
        maxWidth: 'G',
        text: (el, s)=>{
            const cur = (0, $bnIri.tierLabel)((0, $bnIri.workspaceTier)(s.root));
            const req = el.requires || 'scale';
            return `This surface is included in ${(0, $bnIri.tierLabel)(req)}. Your workspace is on ${cur}. Upgrade to unlock.`;
        }
    },
    CTA: {
        extends: 'Link',
        href: '/admin/billing',
        padding: 'Z1 B',
        round: 'Z',
        background: 'blue',
        color: 'white',
        fontWeight: '600',
        fontSize: 'Z1',
        textDecoration: 'none',
        ':hover': {
            filter: 'brightness(1.1)'
        },
        text: 'Upgrade workspace'
    }
};

});

parcelRegister("8ijfH", function(module, exports) {

$parcel$export(module.exports, "NoOrgOverlay", () => $609ef0484267e5ea$export$9063c4d52ea90fec);
// Signed-in-but-has-no-team-org landing. Per MODEL.md, workspace is
// an org-level feature — every team-org user gets full collab access,
// and monetization runs through server-side credit metering (PRICING.md),
// not access gates. A user with no team-org has nothing to scope to:
// the workspace_id claim is empty, RLS returns zero rows on every
// tenant table, and the workspace has nothing to render.
//
// This overlay provides an inline "create organization" flow — POSTs
// to `/organizations` using the Symbols bridge access token, then
// refreshes JWT claims so the new org appears in the user's
// workspaces/orgs and the overlay self-dismisses. Toggled by
// USE_ONBOARDING_GATE.
//
// Slug UX (TASK#4407):
//   - Slug field auto-derives from name as user types.
//   - Debounced availability check (GET /organizations?slug=X, 350 ms delay).
//   - On slug_taken the field auto-advances to the first available -2/-3/-N
//     suffix (up to 20 attempts) without user intervention.
//   - If POST returns 409 slug_taken (race condition after passing the live
//     check), modal shows an inline error AND a "Use <slug-N> instead" button
//     — never silently swallows the error.

var $8RlGv = parcelRequire("8RlGv");

var $bfqVY = parcelRequire("bfqVY");

var $bdIjZ = parcelRequire("bdIjZ");
// Module-level debounce timer for slug availability checks.
let $609ef0484267e5ea$var$_slugDebounceTimer = null;
const $609ef0484267e5ea$var$_hasTeamOrg = (root)=>{
    const orgs = root?.jwtClaims?.orgs;
    if (!Array.isArray(orgs) || orgs.length === 0) return false;
    return orgs.some((o)=>o?.type == null || o.type === 'team');
};
// Slugify a name — lowercase, hyphenate whitespace, strip non-URL chars.
// Mirrors server-side slugifyName in OrganizationController.js.
const $609ef0484267e5ea$var$_slugify = (raw)=>String(raw || '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
// Check whether a slug is available (not taken by a non-deleted org).
// Returns true = available, false = taken, null = check failed (network).
// Replaces the raw fetch('/organizations?slug=X') call site — the SDK
// method threads the auth token + base URL through TokenManager.
const $609ef0484267e5ea$var$_checkSlugAvailable = async (slug)=>{
    if (!slug) return null;
    try {
        return await (0, $bfqVY.getSDK)().checkOrganizationSlug(slug);
    } catch  {
        return null;
    }
};
// Find the first available slug: tries base, then base-2, base-3, …, base-N.
// Returns the first available candidate, or null if all attempts fail.
const $609ef0484267e5ea$var$_findAvailableSlug = async (base, maxAttempts = 20)=>{
    for(let n = 0; n < maxAttempts; n++){
        const candidate = n === 0 ? base : `${base}-${n + 1}`;
        const available = await $609ef0484267e5ea$var$_checkSlugAvailable(candidate);
        if (available === true) return candidate;
    }
    return null;
};
// Schedule a debounced slug availability check (350 ms). Updates root state
// with _orgCreateSlug (the resolved candidate), _orgCreateSlugChecking, and
// _orgCreateSlugStatus ('available' | 'taken' | 'error').
const $609ef0484267e5ea$var$_scheduleSlugCheck = (rawName, root)=>{
    if ($609ef0484267e5ea$var$_slugDebounceTimer) clearTimeout($609ef0484267e5ea$var$_slugDebounceTimer);
    const base = $609ef0484267e5ea$var$_slugify(rawName);
    if (!base) {
        root.update({
            _orgCreateSlug: '',
            _orgCreateSlugChecking: false,
            _orgCreateSlugStatus: null,
            _orgCreateSlugSuggestion: null
        });
        return;
    }
    root.update({
        _orgCreateSlug: base,
        _orgCreateSlugChecking: true,
        _orgCreateSlugStatus: null
    });
    $609ef0484267e5ea$var$_slugDebounceTimer = setTimeout(async ()=>{
        $609ef0484267e5ea$var$_slugDebounceTimer = null;
        const available = await $609ef0484267e5ea$var$_checkSlugAvailable(base);
        if (available === true) root.update({
            _orgCreateSlug: base,
            _orgCreateSlugChecking: false,
            _orgCreateSlugStatus: 'available',
            _orgCreateSlugSuggestion: null
        });
        else if (available === false) {
            // Slug is taken — find the next free suffix automatically.
            const suggestion = await $609ef0484267e5ea$var$_findAvailableSlug(base);
            root.update({
                _orgCreateSlug: suggestion || base,
                _orgCreateSlugChecking: false,
                _orgCreateSlugStatus: suggestion ? 'suggested' : 'taken',
                _orgCreateSlugSuggestion: suggestion
            });
        } else // Network error — allow user to proceed; server is the final arbiter.
        root.update({
            _orgCreateSlugChecking: false,
            _orgCreateSlugStatus: 'error'
        });
    }, 350);
};
const $609ef0484267e5ea$export$9063c4d52ea90fec = {
    hide: (el, s)=>{
        if (!(0, $bdIjZ.USE_ONBOARDING_GATE)) return true;
        if (!s.root?.signedIn) return true;
        return $609ef0484267e5ea$var$_hasTeamOrg(s.root);
    },
    position: 'fixed',
    inset: '0',
    zIndex: '500',
    background: 'black.85',
    backdropFilter: 'blur(12px)',
    align: 'center center',
    flow: 'column',
    Card: {
        flow: 'y',
        align: 'center center',
        gap: 'A',
        padding: 'C',
        maxWidth: 'H',
        round: 'B',
        background: 'overlayStrong',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'line',
        textAlign: 'center',
        boxShadow: '0 16px 40px var(--color-shadow)',
        Icon: {
            icon: 'people',
            boxSize: 'B1',
            color: 'caption'
        },
        Title: {
            tag: 'h2',
            fontSize: 'A2',
            fontWeight: '700',
            color: 'title',
            margin: '0',
            text: 'Create a team'
        },
        Body: {
            tag: 'p',
            fontSize: 'Z',
            color: 'caption',
            lineHeight: '1.55',
            margin: '0',
            maxWidth: 'G',
            text: "Your workspace is a shared space for a team. Name your team to get started \u2014 you can invite teammates right after."
        },
        Form: {
            tag: 'form',
            flow: 'y',
            gap: 'Z1',
            width: '100%',
            margin: 'A 0 0',
            textAlign: 'left',
            onSubmit: async (e, el, s)=>{
                e.preventDefault();
                if (s.root?._orgCreateBusy) return;
                const name = String(s.root?._orgCreateName || '').trim();
                if (!name) {
                    s.root.update({
                        _orgCreateError: 'Name is required'
                    });
                    return;
                }
                if (!(0, $8RlGv.getSymbolsToken)()) {
                    s.root.update({
                        _orgCreateError: "Session expired \u2014 sign in again"
                    });
                    return;
                }
                // Use the resolved (possibly suffixed) slug from live check; fall back
                // to slugifying the name if the live check never ran.
                const slug = s.root?._orgCreateSlug || $609ef0484267e5ea$var$_slugify(name) || undefined;
                s.root.update({
                    _orgCreateBusy: true,
                    _orgCreateError: null,
                    _orgCreateSlugConflict: null
                });
                try {
                    await (0, $bfqVY.getSDK)().createOrganization({
                        name: name,
                        slug: slug,
                        type: 'team'
                    });
                    // Pull the refreshed claims so the new org shows up in
                    // root.jwtClaims.orgs. The overlay's `hide` predicate will
                    // then return true and the workspace renders scoped to the
                    // new org's home workspace.
                    await (0, $8RlGv.refreshClaims)();
                    // Hard reload so every `method: 'select'` state query
                    // re-runs under the new active_workspace_id.
                    if (typeof window !== 'undefined') window.location.href = '/';
                } catch (err) {
                    // Detect slug_taken specifically and offer a one-click fix.
                    // The SDK throws with the server's error message; we sniff for the
                    // 409/slug_taken signature in the message.
                    const msg = err?.message || '';
                    if (/409|slug_taken/iu.test(msg)) {
                        // Race condition: slug was available at check time but taken by
                        // the time we POSTed. Find the next free suffix and surface it.
                        const base = $609ef0484267e5ea$var$_slugify(name);
                        const suggestion = await $609ef0484267e5ea$var$_findAvailableSlug(base);
                        s.root.update({
                            _orgCreateBusy: false,
                            _orgCreateError: `Slug "${slug}" was just taken.`,
                            _orgCreateSlugConflict: slug,
                            _orgCreateSlug: suggestion || slug,
                            _orgCreateSlugSuggestion: suggestion,
                            _orgCreateSlugStatus: suggestion ? 'suggested' : 'taken'
                        });
                        return;
                    }
                    s.root.update({
                        _orgCreateBusy: false,
                        _orgCreateError: err?.message || 'Network error'
                    });
                }
            },
            NameLabel: {
                tag: 'label',
                fontSize: 'Y2',
                fontWeight: '600',
                color: 'caption',
                text: 'Team name'
            },
            NameField: {
                tag: 'input',
                type: 'text',
                name: 'name',
                placeholder: 'e.g. Acme Co',
                required: true,
                maxlength: 60,
                padding: 'Z1 A',
                round: 'Z',
                border: '1px solid var(--color-line)',
                background: 'overlay',
                color: 'title',
                fontSize: 'Z1',
                width: '100%',
                onInput: (e, el, s)=>{
                    const val = e.target.value;
                    s.root.update({
                        _orgCreateName: val,
                        _orgCreateError: null,
                        _orgCreateSlugConflict: null
                    });
                    // Trigger debounced availability check; also resets user-edited slug.
                    s.root.update({
                        _orgCreateSlugEdited: false
                    });
                    $609ef0484267e5ea$var$_scheduleSlugCheck(val, s.root);
                }
            },
            SlugLabel: {
                tag: 'label',
                fontSize: 'Y2',
                fontWeight: '600',
                color: 'caption',
                margin: 'Z 0 0',
                text: 'Slug (URL identifier)'
            },
            SlugRow: {
                flow: 'x',
                align: 'center left',
                gap: 'Z',
                width: '100%',
                SlugField: {
                    tag: 'input',
                    type: 'text',
                    name: 'slug',
                    placeholder: 'auto-derived from name',
                    maxlength: 60,
                    padding: 'Z1 A',
                    round: 'Z',
                    border: (el, s)=>{
                        const status = s.root?._orgCreateSlugStatus;
                        if (status === 'taken') return '1px solid var(--color-red)';
                        if (status === 'available') return '1px solid var(--color-green)';
                        return '1px solid var(--color-line)';
                    },
                    background: 'overlay',
                    color: 'title',
                    fontSize: 'Z1',
                    flex: '1',
                    // Keep the displayed value in sync with root._orgCreateSlug unless
                    // the user has manually edited the field.
                    onRender: (el, s)=>{
                        if (s.root?._orgCreateSlugEdited) return;
                        const slug = s.root?._orgCreateSlug || '';
                        if (el.node && el.node.value !== slug) el.node.value = slug;
                    },
                    onInput: (e, el, s)=>{
                        const val = $609ef0484267e5ea$var$_slugify(e.target.value);
                        // Reflect normalized value back into the input.
                        e.target.value = val;
                        s.root.update({
                            _orgCreateSlug: val,
                            _orgCreateSlugEdited: true,
                            _orgCreateError: null,
                            _orgCreateSlugConflict: null
                        });
                        $609ef0484267e5ea$var$_scheduleSlugCheck(val, s.root);
                    }
                },
                SlugStatus: {
                    tag: 'span',
                    fontSize: 'Y2',
                    whiteSpace: 'nowrap',
                    hide: (el, s)=>!s.root?._orgCreateSlug,
                    color: (el, s)=>{
                        const status = s.root?._orgCreateSlugStatus;
                        if (s.root?._orgCreateSlugChecking) return 'caption';
                        if (status === 'available') return 'green';
                        if (status === 'taken') return 'red';
                        if (status === 'suggested') return 'yellow';
                        return 'caption';
                    },
                    text: (el, s)=>{
                        if (s.root?._orgCreateSlugChecking) return "checking\u2026";
                        const status = s.root?._orgCreateSlugStatus;
                        if (status === 'available') return 'available';
                        if (status === 'taken') return 'taken';
                        if (status === 'suggested') return 'auto-adjusted';
                        if (status === 'error') return '';
                        return '';
                    }
                }
            },
            // Shown when the live check found the slug taken and picked a suffix.
            // Also shown after a 409 slug_taken POST response with a one-click fix.
            SlugHint: {
                hide: (el, s)=>{
                    const status = s.root?._orgCreateSlugStatus;
                    const conflict = s.root?._orgCreateSlugConflict;
                    return status !== 'suggested' && status !== 'taken' && !conflict;
                },
                flow: 'x',
                align: 'center left',
                gap: 'Z',
                margin: 'V 0 0',
                HintText: {
                    tag: 'span',
                    fontSize: 'Y2',
                    color: 'caption',
                    flex: '1',
                    text: (el, s)=>{
                        const suggestion = s.root?._orgCreateSlugSuggestion;
                        const conflict = s.root?._orgCreateSlugConflict;
                        if (conflict && suggestion) return `"${conflict}" was just taken \u{2014} try "${suggestion}" instead.`;
                        if (conflict) return `"${conflict}" is taken. Edit the slug above to pick a different one.`;
                        if (suggestion) return `Slug auto-adjusted to "${suggestion}" \u{2014} available and ready.`;
                        return 'This slug is taken. Edit it above.';
                    }
                },
                // One-click fix: apply the suggestion directly.
                UseSlugBtn: {
                    tag: 'button',
                    type: 'button',
                    hide: (el, s)=>!s.root?._orgCreateSlugSuggestion,
                    padding: 'V Z1',
                    round: 'Y',
                    background: 'overlay',
                    color: 'title',
                    fontWeight: '600',
                    fontSize: 'Y2',
                    border: '1px solid var(--color-line)',
                    cursor: 'pointer',
                    ':hover': {
                        background: 'overlayStrong'
                    },
                    text: (el, s)=>{
                        const sug = s.root?._orgCreateSlugSuggestion;
                        return sug ? `Use "${sug}"` : '';
                    },
                    onClick: (e, el, s)=>{
                        e.preventDefault();
                        const sug = s.root?._orgCreateSlugSuggestion;
                        if (!sug) return;
                        s.root.update({
                            _orgCreateSlug: sug,
                            _orgCreateSlugEdited: true,
                            _orgCreateSlugStatus: 'available',
                            _orgCreateSlugSuggestion: null,
                            _orgCreateSlugConflict: null,
                            _orgCreateError: null
                        });
                        // Reflect in DOM input.
                        const slugInput = el.getRoot()?.node?.querySelector('input[name="slug"]');
                        if (slugInput) slugInput.value = sug;
                    }
                }
            },
            Error: {
                hide: (el, s)=>!s.root?._orgCreateError,
                tag: 'p',
                color: 'red',
                fontSize: 'Y2',
                margin: 'Z 0 0',
                text: (el, s)=>s.root?._orgCreateError || ''
            },
            Actions: {
                flow: 'x',
                gap: 'Z1',
                margin: 'A 0 0',
                justifyContent: 'center',
                Submit: {
                    tag: 'button',
                    type: 'submit',
                    disabled: (el, s)=>!!s.root?._orgCreateBusy || s.root?._orgCreateSlugChecking === true,
                    padding: 'Z1 B',
                    round: 'Z',
                    background: 'blue',
                    color: 'white',
                    fontWeight: '600',
                    fontSize: 'Z1',
                    border: 'none',
                    cursor: 'pointer',
                    ':hover': {
                        filter: 'brightness(1.1)'
                    },
                    ':disabled': {
                        opacity: '.6',
                        cursor: 'wait'
                    },
                    text: (el, s)=>s.root?._orgCreateBusy ? "Creating\u2026" : 'Create organization'
                },
                SignOutLink: {
                    extends: 'Link',
                    href: '/login',
                    padding: 'Z1 B',
                    round: 'Z',
                    background: 'transparent',
                    color: 'caption',
                    fontWeight: '500',
                    fontSize: 'Z1',
                    textDecoration: 'none',
                    borderWidth: '1px',
                    borderStyle: 'solid',
                    borderColor: 'line',
                    ':hover': {
                        background: 'overlay',
                        color: 'title'
                    },
                    // migrated 2026-04-27 — flat sdk.logout() replaces sb.auth.signOut.
                    onClick: (e, el, s)=>{
                        el.sdk?.logout?.().catch(()=>{});
                    },
                    text: 'Sign out'
                }
            }
        }
    }
};

});

parcelRegister("aI4CX", function(module, exports) {

$parcel$export(module.exports, "AppLightbox", () => $7cc19a51f6846e79$export$7013195ddf256f4e);
const $7cc19a51f6846e79$export$7013195ddf256f4e = {
    hide: (el, s)=>!s.root.lightbox,
    position: 'fixed',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    zIndex: '200',
    flow: 'y',
    align: 'center center',
    background: 'black.85',
    cursor: 'pointer',
    tabindex: '0',
    onKeyDown: (e, el, s)=>{
        if (e.key === 'Escape' && s.root.lightbox) s.root.update({
            lightbox: null
        });
    },
    onCreate: (el)=>{
        if (el.node) el.node.focus();
    },
    onClick: (e, el, s)=>{
        if (e.target === el.node) s.root.update({
            lightbox: null
        });
    },
    CloseBtn: {
        tag: 'button',
        type: 'button',
        position: 'absolute',
        top: 'A',
        right: 'A',
        padding: 'Z',
        round: 'Z',
        background: 'white.15',
        borderWidth: '0',
        color: 'white',
        cursor: 'pointer',
        fontSize: 'B',
        fontWeight: '300',
        lineHeight: '1',
        ':hover': {
            background: 'white.3'
        },
        'aria-label': 'Close',
        text: '\u2715',
        onClick: (e, el, s)=>{
            e.stopPropagation();
            s.root.update({
                lightbox: null
            });
        }
    },
    Image: {
        tag: 'img',
        hide: (el, s)=>!(s.root.lightbox?.mime || '').startsWith('image/'),
        maxWidth: '90vw',
        maxHeight: '85vh',
        objectFit: 'contain',
        round: 'Z',
        cursor: 'default',
        src: (el, s)=>s.root.lightbox?.url || '',
        alt: (el, s)=>s.root.lightbox?.name || 'preview',
        onClick: (e)=>e.stopPropagation()
    },
    Video: {
        tag: 'video',
        hide: (el, s)=>!(s.root.lightbox?.mime || '').startsWith('video/'),
        maxWidth: '90vw',
        maxHeight: '85vh',
        round: 'Z',
        cursor: 'default',
        src: (el, s)=>s.root.lightbox?.url || '',
        controls: 'true',
        autoplay: 'true',
        onClick: (e)=>e.stopPropagation()
    },
    FileName: {
        position: 'absolute',
        bottom: 'A',
        left: '50%',
        transform: 'translateX(-50%)',
        color: 'white.7',
        fontSize: 'Z2',
        textAlign: 'center',
        pointerEvents: 'none',
        text: (el, s)=>s.root.lightbox?.name || ''
    }
};

});

parcelRegister("lykpX", function(module, exports) {

$parcel$export(module.exports, "SidebarItemMore", () => $fb0c9c73bfb6b035$export$1f5f275d1c461668);
$parcel$export(module.exports, "SidebarItemMenuItem", () => $fb0c9c73bfb6b035$export$5c545371b4b68de9);
// Three-dot sidebar menu button. Opens a shared dropdown via root state.
// The dropdown itself lives on the page level (ChatSidebarDropdown) to
// avoid parent opacity/overflow clipping issues.
const $fb0c9c73bfb6b035$export$1f5f275d1c461668 = {
    tag: 'button',
    type: 'button',
    'aria-label': 'More options',
    text: "\xb7\xb7\xb7",
    fontSize: 'A',
    fontWeight: '700',
    letterSpacing: '.1em',
    padding: '0 V',
    background: 'transparent',
    borderWidth: '0',
    color: 'caption',
    cursor: 'pointer',
    transition: 'opacity 120ms ease',
    flexShrink: '0',
    ':hover': {
        color: 'title'
    },
    onCreate: (el)=>{
        if (!el.node) return;
        el.node.style.opacity = '0';
        const row = el.node.closest('[data-sidebar-row]') || el.node.closest('[data-cid]');
        if (!row) return;
        el._row = row;
        el._onEnter = ()=>{
            if (el.node) el.node.style.opacity = '1';
        };
        el._onLeave = ()=>{
            if (!el.node) return;
            // Don't hide if dropdown is open for this row
            const root = el.state?.root;
            if (root?.sidebarDropdown?.open) return;
            el.node.style.opacity = '0';
        };
        row.addEventListener('mouseenter', el._onEnter);
        row.addEventListener('mouseleave', el._onLeave);
    },
    onRemove: (el)=>{
        if (el._row) {
            el._row.removeEventListener('mouseenter', el._onEnter);
            el._row.removeEventListener('mouseleave', el._onLeave);
        }
    },
    onClick: (e, el, s)=>{
        e.stopPropagation();
        e.stopImmediatePropagation();
        e.preventDefault();
        const root = s?.root;
        if (!root) return;
        // Get the channel id from the row
        const row = el.node.closest('[data-cid]');
        const cid = row?.getAttribute('data-cid');
        if (!cid) return;
        // Determine items from channel kind
        const ch = (root.channels || []).find((c)=>c.id === cid);
        const kind = ch?.kind || 'channel';
        let items;
        if (kind === 'channel') items = [
            {
                label: 'Invite',
                action: 'invite-channel'
            },
            {
                label: 'Rename',
                action: 'rename-channel'
            },
            {
                label: 'Settings',
                action: 'channel-settings'
            },
            {
                label: 'Pin to top',
                action: 'pin-to-top'
            }
        ];
        else if (kind === 'group_dm') items = [
            {
                label: 'Create channel',
                action: 'convert-to-channel'
            },
            {
                label: 'Rename',
                action: 'rename-channel'
            },
            {
                label: 'Pin to top',
                action: 'pin-to-top'
            },
            {
                label: 'Hide',
                action: 'hide-dm'
            },
            {
                label: 'Leave',
                action: 'leave-channel',
                color: 'red'
            }
        ];
        else items = [
            {
                label: 'Hide',
                action: 'hide-dm'
            },
            {
                label: 'Start group chat',
                action: 'start-group-chat'
            },
            {
                label: 'Pin to top',
                action: 'pin-to-top'
            }
        ];
        // Get position
        const rect = el.node.getBoundingClientRect();
        // Toggle — close if already open for this row, open otherwise
        const dd = root.sidebarDropdown;
        if (dd?.open && dd?.channelId === cid) root.update({
            sidebarDropdown: {
                open: false
            }
        });
        else root.update({
            sidebarDropdown: {
                open: true,
                channelId: cid,
                items: items,
                top: rect.bottom + 2,
                left: rect.right,
                btnTop: rect.top
            }
        });
    },
    // Hidden dropdown template — items rendered by the shared ChatSidebarDropdown
    Dropdown: {
        display: 'none'
    }
};
const $fb0c9c73bfb6b035$export$5c545371b4b68de9 = {
    tag: 'button',
    type: 'button',
    padding: 'Z A',
    round: 'V',
    background: 'transparent',
    borderWidth: '0',
    cursor: 'pointer',
    fontSize: 'Z2',
    fontWeight: '500',
    textAlign: 'left',
    whiteSpace: 'nowrap',
    color: (el, s)=>s.color || 'title',
    ':hover': {
        background: 'overlay'
    },
    text: (el, s)=>s.label || ''
};

});

parcelRegister("2u2Du", function(module, exports) {

$parcel$export(module.exports, "SidebarRow", () => $1cf06d8c405b1c24$export$dd577a7f84c0384e);
const $1cf06d8c405b1c24$export$dd577a7f84c0384e = {
    flow: 'x',
    align: 'center left',
    gap: 'Z1',
    padding: 'Z Z1',
    round: 'Z',
    cursor: 'pointer',
    transition: 'background 120ms ease',
    background: 'transparent',
    color: 'caption',
    attr: {
        'data-sidebar-row': 'true'
    },
    ':hover': {
        background: 'overlay'
    },
    Icon: {
        icon: (el)=>el.parent?.icon || 'state',
        boxSize: 'A1 A1'
    },
    Label: {
        tag: 'span',
        fontSize: 'Z2',
        fontWeight: '500',
        flex: '1',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        text: (el)=>el.parent?.label || ''
    },
    MoreBtn: {
        extends: 'SidebarItemMore'
    }
};

});

parcelRegister("5pzPy", function(module, exports) {

$parcel$export(module.exports, "ConfirmModal", () => $3f0b14c2d666b04f$export$8eec1a3a911975a4);
// Reusable confirmation dialog for destructive / irreversible actions.
//
// Open it by writing a `confirmAction` object to root state:
//   root.update({
//     confirmAction: {
//       title: 'Delete event?',
//       message: 'This permanently removes "Team standup" from everyone\'s calendar.',
//       confirmText: 'Delete',
//       confirmTheme: 'red',       // theme for the primary button (default: 'red')
//       icon: 'trash',             // header icon (default: 'warning')
//       onConfirm: () => el.call('deleteEventFromSupabase', id)
//     }
//   })
//
// Primary (confirm) button sits on the LEFT per the modal convention. There's
// no Cancel button — the X in the header and backdrop clicks dismiss.
//
// B-101 fixes (2026-04-24):
// - `zIndex: '3000'` so ConfirmModal always stacks ABOVE any originating
//   modal (base Modal is 2000). This is the terminal-confirmation layer;
//   must not be obscured by the action's source modal.
// - `Cancel` button added so both paths are clear. Primary "Confirm" button
//   on the RIGHT with strong visual treatment (filled + bold); Cancel on
//   the LEFT as an outlined secondary. Override `confirmText` with the
//   specific action ("Delete team", "Remove member") so the CTA is
//   self-documenting.
const $3f0b14c2d666b04f$var$_action = (root)=>root?.confirmAction || null;
const $3f0b14c2d666b04f$export$8eec1a3a911975a4 = {
    extends: 'Modal',
    stateKey: 'confirmAction',
    zIndex: '3000',
    Window: {
        width: 'H',
        maxWidth: '90vw',
        ModalHeader: {
            Hgroup: {
                H: {
                    text: (el, s)=>$3f0b14c2d666b04f$var$_action(s.root)?.title || 'Are you sure?'
                },
                P: {
                    text: (el, s)=>$3f0b14c2d666b04f$var$_action(s.root)?.message || 'This action cannot be undone. Confirm to proceed.'
                }
            },
            Icons: {
                Indicator: {
                    extends: 'IconButton',
                    disabled: true,
                    cursor: 'default',
                    opacity: '.85',
                    Icon: {
                        icon: (el, s)=>$3f0b14c2d666b04f$var$_action(s.root)?.icon || 'warning'
                    }
                }
            }
        },
        ModalFooter: {
            flow: 'x',
            gap: 'Z1',
            align: 'center end',
            CancelBtn: {
                extends: 'Button',
                theme: 'ghost',
                text: (el, s)=>$3f0b14c2d666b04f$var$_action(s.root)?.cancelText || 'Cancel',
                onClick: (e, el, s)=>{
                    s.root.update({
                        confirmAction: null
                    });
                }
            },
            ConfirmBtn: {
                extends: 'Button',
                theme: (el, s)=>$3f0b14c2d666b04f$var$_action(s.root)?.confirmTheme || 'red',
                fontWeight: '700',
                text: (el, s)=>$3f0b14c2d666b04f$var$_action(s.root)?.confirmText || 'Confirm',
                onClick: (e, el, s)=>{
                    const a = $3f0b14c2d666b04f$var$_action(s.root);
                    s.root.update({
                        confirmAction: null
                    });
                    if (typeof a?.onConfirm === 'function') a.onConfirm();
                }
            }
        }
    }
};

});

parcelRegister("9WkW5", function(module, exports) {

$parcel$export(module.exports, "CapTableGrantModal", () => $73c9c54645798e50$export$dff1fdc3d8a8d654);
// Grant / investment record detail modal — opened from the cap-table by
// clicking a non-parent row. Reuses the editable ProfileGrantCard so
// admins can tweak the 4 factors + share class right from the cap-table
// and have the change propagate via _patchGrant / _flushGrant to both
// the profile page and the cap table itself.
//
// State: root.grantDetail holds the current grant being edited (or null
// when the modal is closed). It mirrors a row from root.userGrants so
// ProfileGrantCard's `childrenAs: 'state'` wiring can reuse it verbatim.
parcelRequire("chzVb");

var $etEl1 = parcelRequire("etEl1");

var $9CXFX = parcelRequire("9CXFX");
const $73c9c54645798e50$var$_numberFmt = new Intl.NumberFormat('en-US');
const $73c9c54645798e50$var$_fmt = (n)=>n == null ? "\u2014" : $73c9c54645798e50$var$_numberFmt.format(n);
// Flush the current grant edits to Supabase, then reload the row so
// the generated `shares` / `equity_pct` columns + the vested-shares
// trigger output propagate back into `root.userGrants`. The cap-table
// page watches `userGrants` via its `onUpdate` signature and rebuilds
// whenever any tracked field (including shares_manual) changes, so
// merging the refreshed record here auto-refreshes the cap table.
const $73c9c54645798e50$var$_flushGrantFromModal = async (root, grantId)=>{
    if (!root || !grantId) return;
    const g = (root.userGrants || []).find((x)=>x.id === grantId);
    if (!g) return;
    root.update({
        _grantSaveStatus: {
            ...root._grantSaveStatus || {},
            [grantId]: 'saving'
        }
    });
    try {
        const patch = {
            label: g.label,
            share_class: g.share_class,
            vesting_start: g.vesting_start,
            vesting_end: g.vesting_end,
            vesting_months: g.vesting_months,
            origin_valuation: g.origin_valuation,
            salary_monthly: g.salary_monthly,
            hourly_rate: g.hourly_rate,
            weekly_hours: g.weekly_hours,
            investment: g.investment,
            investment_type: g.investment_type,
            discount: g.discount,
            shares_manual: g.shares_manual,
            status: g.status
        };
        const { data: data } = await $9CXFX.updateGrant(grantId, patch);
        if (data) {
            const merged = (root.userGrants || []).map((ug)=>ug.id === grantId ? data : ug);
            root.update({
                userGrants: merged
            });
        }
        // DOMQL doesn't call onUpdate on the cap-table page when root state
        // changes elsewhere, so the cap-table page exposes a refetch hook
        // we invoke explicitly. This rebuilds root.capTable from the fresh
        // userGrants, refreshing the rows the user sees behind the modal.
        if (typeof root.__refetchCapTable === 'function') try {
            root.__refetchCapTable();
        } catch (e) {
            console.warn('[cap refetch]', e);
        }
        root.update({
            _grantSaveStatus: {
                ...root._grantSaveStatus || {},
                [grantId]: 'saved'
            }
        });
        setTimeout(()=>{
            root.update({
                _grantSaveStatus: {
                    ...root._grantSaveStatus || {},
                    [grantId]: null
                }
            });
        }, 2000);
    } catch (e) {
        console.warn('[grant flush]', e);
        root.update({
            _grantSaveStatus: {
                ...root._grantSaveStatus || {},
                [grantId]: 'error'
            }
        });
    }
};
// Resolve the grant being shown. Pull the fresh record from
// root.userGrants so edits from elsewhere flow through instead of
// freezing a snapshot at open time.
const $73c9c54645798e50$var$_g = (s)=>{
    const open = s.root?.grantDetail;
    if (!open?.id) return null;
    return (s.root?.userGrants || []).find((ug)=>ug.id === open.id) || open;
};
// Owner person record — for name in the header subtitle.
const $73c9c54645798e50$var$_owner = (s)=>{
    const g = $73c9c54645798e50$var$_g(s);
    if (!g?.user_id) return {};
    return (s.root?.people || []).find((p)=>p.userId === g.user_id) || {};
};
const $73c9c54645798e50$export$dff1fdc3d8a8d654 = {
    extends: 'Modal',
    stateKey: 'grantDetail',
    Window: {
        extends: 'ModalWindow',
        width: '100%',
        maxWidth: 'I1',
        maxHeight: '90dvh',
        padding: 'C',
        gap: 'B',
        overflow: 'auto',
        // Use the platform ModalHeader slot so Close + action icons align with
        // every other modal (ConfirmModal, EventDetailModal, etc.).
        ModalHeader: {
            Hgroup: {
                H: {
                    text: (el, s)=>$73c9c54645798e50$var$_owner(s).name || 'Grant'
                },
                P: {
                    text: null,
                    flow: 'x',
                    align: 'center left',
                    gap: 'Z1',
                    Eyebrow: {
                        tag: 'span',
                        fontSize: 'Y2',
                        fontWeight: '700',
                        letterSpacing: '.12em',
                        textTransform: 'uppercase',
                        color: (el, s)=>$73c9c54645798e50$var$_g(s)?.investment != null ? 'purple' : 'green',
                        text: (el, s)=>$73c9c54645798e50$var$_g(s)?.investment != null ? 'Investment' : 'Equity grant'
                    },
                    Dot: {
                        tag: 'span',
                        color: 'caption',
                        text: "\xb7"
                    },
                    Summary: {
                        tag: 'span',
                        color: 'caption',
                        text: (el, s)=>{
                            const g = $73c9c54645798e50$var$_g(s);
                            if (!g) return '';
                            if (g.investment != null) return `$${$73c9c54645798e50$var$_fmt(g.investment)} @ $${$73c9c54645798e50$var$_fmt(g.origin_valuation || 0)}`;
                            return `${$73c9c54645798e50$var$_fmt(g.shares || 0)} shares \xb7 ${((g.shares || 0) / 10000000 * 100).toFixed(2)}%`;
                        }
                    }
                }
            },
            Icons: {
                // "Expand to profile" — jumps to the owner's full profile page.
                OpenProfile: {
                    extends: 'IconButton',
                    title: 'Open profile',
                    aria: {
                        label: 'Open profile'
                    },
                    Icon: {
                        icon: 'link'
                    },
                    onClick: (e, el, s)=>{
                        const owner = $73c9c54645798e50$var$_owner(s);
                        s.root.update({
                            grantDetail: null,
                            profileEmail: owner.email || null
                        });
                    }
                },
                // Remove (trash) — confirm, delete the grant, close the modal.
                // Ordered just before the base Close button (order: 10) so it
                // sits immediately left of the X in the header.
                DeleteGrant: {
                    extends: 'IconButton',
                    order: 9,
                    title: 'Remove grant',
                    aria: {
                        label: 'Remove grant'
                    },
                    Icon: {
                        icon: 'trash'
                    },
                    onClick: (e, el, s)=>{
                        const g = $73c9c54645798e50$var$_g(s);
                        if (!g) return;
                        const label = g.label || (g.investment != null ? 'this investment' : 'this grant');
                        if (!window.confirm(`Remove ${label}?`)) return;
                        s.root.update({
                            userGrants: (s.root?.userGrants || []).filter((ug)=>ug.id !== g.id),
                            grantDetail: null
                        });
                        // Fire off the DB delete in the background.
                        try {
                            $9CXFX.deleteGrant(g.id).catch(()=>{});
                        } catch  {}
                    }
                }
            }
        },
        // Editable card — reuses ProfileGrantCard which already handles all
        // 4 factors + share class + save status. `childrenAs: 'state'` feeds
        // each child the grant record as its own state (same pattern as the
        // GrantsList inside MemberProfile).
        EditableCardWrap: {
            flow: 'y',
            childExtends: 'ProfileGrantCard',
            childrenAs: 'state',
            // `childProps` factory lifts the grant's id to `key` at the top
            // level of the child definition. With childrenAs='state' the
            // children array items are wrapped into `{ state: item }`, which
            // hides any inline `key` — so we have to route it through
            // childProps to surface it as the stable reconciliation id. This
            // prevents DOMQL from tearing down the card (and its focused
            // inputs) on every keystroke patch.
            childProps: (el, grant)=>({
                    key: grant?.id || 'none'
                }),
            children: (el, s)=>{
                const g = $73c9c54645798e50$var$_g(s);
                return g ? [
                    g
                ] : [];
            }
        },
        // Read-only totals below the editable card — value at current
        // valuation and company-wide %.
        TotalsBlock: {
            flow: 'y',
            padding: 'A 0 0 0',
            gap: 'Y',
            RowValueAtCurrent: {
                flow: 'x',
                align: 'center space-between',
                padding: 'Z 0',
                borderBottomWidth: '1px',
                borderBottomStyle: 'solid',
                borderBottomColor: 'line',
                Label: {
                    tag: 'span',
                    fontSize: 'Z2',
                    color: 'caption',
                    text: 'Value at current valuation'
                },
                Val: {
                    tag: 'span',
                    fontSize: 'A',
                    fontWeight: '700',
                    color: 'green',
                    text: (el, s)=>{
                        const g = $73c9c54645798e50$var$_g(s);
                        const v = s.root?.companySettings?.current_valuation;
                        if (!g || !v) return "\u2014";
                        // Use live shares so this tracks shares_manual edits without
                        // waiting for a DB save + refetch to refresh `g.shares`.
                        const shares = (0, $etEl1.liveShares)(g);
                        if (!shares) return "\u2014";
                        return `$${$73c9c54645798e50$var$_fmt(Math.round(shares / 10000000 * v))}`;
                    }
                }
            },
            RowEquityPct: {
                flow: 'x',
                align: 'center space-between',
                padding: 'Z 0',
                borderBottomWidth: '1px',
                borderBottomStyle: 'solid',
                borderBottomColor: 'line',
                Label: {
                    tag: 'span',
                    fontSize: 'Z2',
                    color: 'caption',
                    text: '% of company'
                },
                Val: {
                    tag: 'span',
                    fontSize: 'A',
                    fontWeight: '700',
                    color: 'blue',
                    text: (el, s)=>{
                        const g = $73c9c54645798e50$var$_g(s);
                        if (!g) return "\u2014";
                        const shares = (0, $etEl1.liveShares)(g);
                        if (!shares) return "\u2014";
                        return `${(shares / 10000000 * 100).toFixed(4)}%`;
                    }
                }
            },
            // Vested readout with a progress bar — label on the left, value +
            // bar grouped on the right for a cleaner label/value rhythm that
            // matches the other totals rows above it.
            RowVested: {
                hide: (el, s)=>$73c9c54645798e50$var$_g(s)?.investment != null,
                flow: 'x',
                align: 'center space-between',
                gap: 'A',
                padding: 'Z 0',
                borderBottomWidth: '1px',
                borderBottomStyle: 'solid',
                borderBottomColor: 'line',
                Label: {
                    tag: 'span',
                    fontSize: 'Z2',
                    color: 'caption',
                    text: 'Vested'
                },
                // Right cluster — value text + visual progress bar, right-aligned.
                ValueGroup: {
                    flow: 'x',
                    align: 'center',
                    gap: 'A',
                    flex: '1',
                    justifyContent: 'flex-end',
                    Val: {
                        tag: 'span',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'green',
                        text: (el, s)=>{
                            const g = $73c9c54645798e50$var$_g(s);
                            if (!g?.shares) return "\u2014";
                            const pct = Math.round((g.vested_shares || 0) / g.shares * 100);
                            return `${$73c9c54645798e50$var$_fmt(g.vested_shares || 0)} \xb7 ${pct}%`;
                        }
                    },
                    VestedBar: {
                        width: 'E',
                        maxWidth: 'E',
                        height: 'Y',
                        round: 'Y',
                        background: 'line',
                        overflow: 'hidden',
                        flexShrink: '0',
                        Fill: {
                            height: '100%',
                            round: 'Y',
                            background: 'green',
                            width: (el, s)=>{
                                const g = $73c9c54645798e50$var$_g(s);
                                if (!g?.shares) return '0%';
                                const pct = Math.min(100, Math.round((g.vested_shares || 0) / g.shares * 100));
                                return `${pct}%`;
                            }
                        }
                    }
                }
            }
        },
        // Footer — Save action + status chip. Dirty state lights up the
        // button blue; saving/saved/error feedback appears beside it.
        ModalFooter: {
            flow: 'x',
            align: 'center space-between',
            gap: 'A',
            padding: 'A 0 0 0',
            StatusChip: {
                hide: (el, s)=>{
                    const g = $73c9c54645798e50$var$_g(s);
                    return !g || !(s.root?._grantSaveStatus || {})[g.id];
                },
                tag: 'span',
                fontSize: 'Y2',
                fontWeight: '600',
                padding: 'V Z',
                round: 'V',
                background: (el, s)=>{
                    const g = $73c9c54645798e50$var$_g(s);
                    if (!g) return 'overlay';
                    const st = (s.root?._grantSaveStatus || {})[g.id];
                    if (st === 'saved') return 'green.12';
                    if (st === 'error') return 'red.12';
                    if (st === 'dirty') return 'yellow.12';
                    return 'blue.12';
                },
                color: (el, s)=>{
                    const g = $73c9c54645798e50$var$_g(s);
                    if (!g) return 'caption';
                    const st = (s.root?._grantSaveStatus || {})[g.id];
                    if (st === 'saved') return 'green';
                    if (st === 'error') return 'red';
                    if (st === 'dirty') return 'yellow';
                    return 'blue';
                },
                text: (el, s)=>{
                    const g = $73c9c54645798e50$var$_g(s);
                    if (!g) return '';
                    const st = (s.root?._grantSaveStatus || {})[g.id];
                    if (st === 'saved') return "\u2713 Saved";
                    if (st === 'error') return 'Save failed';
                    if (st === 'dirty') return "\u25CF Unsaved";
                    return "Saving\u2026";
                }
            },
            SaveBtn: {
                marginLeft: 'auto',
                tag: 'button',
                type: 'button',
                padding: 'Z A1',
                round: 'Z',
                border: 'none',
                background: (el, s)=>{
                    const g = $73c9c54645798e50$var$_g(s);
                    if (!g) return 'overlayStrong';
                    return (s.root?._grantSaveStatus || {})[g.id] === 'dirty' ? 'blue' : 'overlayStrong';
                },
                color: (el, s)=>{
                    const g = $73c9c54645798e50$var$_g(s);
                    if (!g) return 'subtitle';
                    return (s.root?._grantSaveStatus || {})[g.id] === 'dirty' ? 'white' : 'subtitle';
                },
                fontSize: 'Z2',
                fontWeight: '700',
                cursor: 'pointer',
                text: 'Save',
                ':hover': {
                    opacity: '.9'
                },
                onClick: (e, el, s)=>{
                    const g = $73c9c54645798e50$var$_g(s);
                    if (g) $73c9c54645798e50$var$_flushGrantFromModal(s.root, g.id);
                }
            }
        }
    }
};

});
parcelRegister("etEl1", function(module, exports) {

$parcel$export(module.exports, "SHARE_CLASS_ADVISOR", () => $a8a3106c5eaa6efc$export$76e527d25bfec374);
$parcel$export(module.exports, "SHARE_CLASS_OPTIONS", () => $a8a3106c5eaa6efc$export$4462bf3764c31209);
$parcel$export(module.exports, "valuationOptions", () => $a8a3106c5eaa6efc$export$b268e11192dd3ef9);
$parcel$export(module.exports, "liveShares", () => $a8a3106c5eaa6efc$export$d41bc3a11a9acfc6);
$parcel$export(module.exports, "liveEquityPct", () => $a8a3106c5eaa6efc$export$f9bdd672369ea1d9);
// Client-side mirrors of the DB's generated `shares` / `equity_pct`
// columns. Used wherever the UI needs to reflect an edit instantly
// rather than waiting for a save + refetch.
const $a8a3106c5eaa6efc$export$539f06f382753bcc = 10000000;
const $a8a3106c5eaa6efc$export$76e527d25bfec374 = 'advisor';
const $a8a3106c5eaa6efc$export$4462bf3764c31209 = [
    {
        value: 'A',
        text: 'A'
    },
    {
        value: 'B',
        text: 'B'
    },
    {
        value: 'C',
        text: 'C'
    },
    {
        value: 'Preferred',
        text: 'Preferred'
    },
    {
        value: 'Common',
        text: 'Common'
    },
    {
        value: $a8a3106c5eaa6efc$export$76e527d25bfec374,
        text: 'Advisor'
    }
];
const $a8a3106c5eaa6efc$export$b268e11192dd3ef9 = (root)=>{
    const rows = root?.valuations;
    if (rows?.length) return rows.map((r)=>({
            value: String(r.amount),
            text: `${r.label} \u{2014} $${Number(r.amount).toLocaleString()}`
        }));
    return [
        {
            value: '1250000',
            text: "Bootstrap 1 \u2014 $1,250,000"
        },
        {
            value: '2500000',
            text: "Bootstrap 2 \u2014 $2,500,000"
        },
        {
            value: '12000000',
            text: "Bootstrap 3 \u2014 $12,000,000"
        },
        {
            value: '15000000',
            text: "Pre-seed \u2014 $15,000,000"
        }
    ];
};
const $a8a3106c5eaa6efc$export$d41bc3a11a9acfc6 = (g)=>{
    if (g?.shares_manual != null) return Number(g.shares_manual);
    const ov = Number(g?.origin_valuation) || 0;
    const mo = Number(g?.salary_monthly) || 0;
    if (!ov || !mo || !g?.vesting_start || !g?.vesting_end) return Number(g?.shares) || 0;
    const months = (new Date(g.vesting_end) - new Date(g.vesting_start)) / 2629800000;
    if (months <= 0) return Number(g?.shares) || 0;
    return Math.round(mo * months / ov * $a8a3106c5eaa6efc$export$539f06f382753bcc);
};
const $a8a3106c5eaa6efc$export$f9bdd672369ea1d9 = (g)=>{
    const s = $a8a3106c5eaa6efc$export$d41bc3a11a9acfc6(g);
    return s ? s / $a8a3106c5eaa6efc$export$539f06f382753bcc * 100 : 0;
};

});

parcelRegister("9CXFX", function(module, exports) {

$parcel$export(module.exports, "updateGrant", () => $7025f3ffcea5847f$export$7ca8e357bb905203);
$parcel$export(module.exports, "insertGrant", () => $7025f3ffcea5847f$export$9780b1d2f37bd104);
$parcel$export(module.exports, "deleteGrant", () => $7025f3ffcea5847f$export$3102db4c37b3ad67);
// Centralised grant write helper. Every grant write in the intranet
// goes through here so governance (legacy, source of truth today) and
// financials (new home, read target under USE_FINANCIALS_PROJECT) stay
// in sync during the cutover window.
//
// Flip `DUAL_WRITE_FINANCIALS` true once intranet reads from financials
// are validated. Writes keep landing in governance first — financials
// mirror is a best-effort side effect. If the mirror fails we log and
// continue; governance remains authoritative until the teardown phase.
//
// Identity map: financials.grants rows migrated from governance carry
// `source='user_grants'` + `source_id=<governance.user_grants.id>`. The
// unique index `(source, source_id) where source_id is not null` makes
// upserts idempotent, so an accidental double-write is harmless.
//
// migrated 2026-04-27 to SDK route workspaceProject.userGrants /
// workspaceProject.people (governance writes flow through the workspace
// REST wrapper; financials mirror keeps using grantsClient because the
// financials project is on a separate Supabase tenant managed by
// @symbo.ls/finance-features).

var $bfqVY = parcelRequire("bfqVY");
parcelRequire("g3lIy");
var $7m9HM = parcelRequire("7m9HM");

var $bdIjZ = parcelRequire("bdIjZ");
const $7025f3ffcea5847f$var$SYMBOLS_ORG_ID = '69b77a61e0e0de1aa47d01cb';
// Map governance user_grants columns → financials.grants columns.
// Identity; governance.user_grants and financials.grants share the
// same conceptual shape by design. Keep here to isolate any future
// schema drift.
const $7025f3ffcea5847f$var$_toFinancials = (row, granteeEmail)=>({
        org_id: $7025f3ffcea5847f$var$SYMBOLS_ORG_ID,
        grantee_email: granteeEmail,
        share_class: row.share_class ?? null,
        shares_manual: row.shares_manual ?? null,
        shares: row.shares ?? null,
        equity_pct: row.equity_pct ?? null,
        vested_shares: row.vested_shares ?? null,
        vesting_start: row.vesting_start ?? null,
        vesting_end: row.vesting_end ?? null,
        vesting_months: row.vesting_months ?? null,
        cliff_months: row.cliff_months ?? null,
        salary_monthly: row.salary_monthly ?? null,
        hourly_rate: row.hourly_rate ?? null,
        weekly_hours: row.weekly_hours != null ? String(row.weekly_hours) : null,
        contract_length: row.contract_length ?? null,
        investment: row.investment ?? null,
        investment_type: row.investment_type ?? null,
        origin_valuation: row.origin_valuation ?? null,
        discount: row.discount ?? null,
        status: row.status ?? 'active',
        label: row.label ?? null,
        notes: row.notes ?? null,
        source: 'user_grants',
        source_id: String(row.id),
        updated_at: new Date().toISOString()
    });
// Resolve the grantee email for a given user_id. user_grants is keyed
// by user_id; financials.grants is keyed by grantee_email. Looked up
// via the SDK's workspaceProject.people endpoint (server-side join over
// user_profiles + auth.users — same canonical source as the legacy
// public.people view).
const $7025f3ffcea5847f$var$_emailFor = async (userId)=>{
    try {
        const list = await (0, $bfqVY.getSDK)().execute('workspaceProject.people', 'list', {
            filter: {
                user_id: userId
            },
            limit: 1,
            single: true
        });
        if (Array.isArray(list)) return list[0]?.email || null;
        return list?.email || null;
    } catch (e) {
        console.warn('[grantsWriter] people lookup failed', e?.message || e);
        return null;
    }
};
// Mirror a governance upsert/update into financials. Best effort —
// failures warn but do not throw.
const $7025f3ffcea5847f$var$_mirror = async (row, granteeEmail)=>{
    if (!(0, $bdIjZ.DUAL_WRITE_FINANCIALS)) return;
    if (!granteeEmail) {
        console.warn('[grantsWriter] no grantee email; skipping financials mirror', row?.id);
        return;
    }
    const fin = $7025f3ffcea5847f$var$_toFinancials(row, granteeEmail);
    const client = (0, $7m9HM).grantsClient();
    if (!client) return;
    const { error: error } = await client.from('grants').upsert(fin, {
        onConflict: 'source,source_id'
    });
    if (error) console.warn('[grantsWriter] financials mirror failed', error.message);
};
// Mirror a delete as a soft-void on financials. Hard deletes violate
// audit chain-of-custody; the financials schema keeps the row with
// status='void' so cap-table history stays auditable.
const $7025f3ffcea5847f$var$_mirrorDelete = async (governanceId)=>{
    if (!(0, $bdIjZ.DUAL_WRITE_FINANCIALS)) return;
    const client = (0, $7m9HM).grantsClient();
    if (!client) return;
    const { error: error } = await client.from('grants').update({
        status: 'void',
        updated_at: new Date().toISOString()
    }).eq('source', 'user_grants').eq('source_id', String(governanceId));
    if (error) console.warn('[grantsWriter] financials void-mirror failed', error.message);
};
const $7025f3ffcea5847f$export$7ca8e357bb905203 = async (grantId, patch)=>{
    try {
        const data = await (0, $bfqVY.getSDK)().execute('workspaceProject.userGrants', 'update', {
            id: grantId,
            payload: patch
        });
        if (!data) return {
            data: null,
            error: new Error('grant update returned empty')
        };
        const email = await $7025f3ffcea5847f$var$_emailFor(data.user_id);
        await $7025f3ffcea5847f$var$_mirror(data, email);
        return {
            data: data,
            error: null
        };
    } catch (error) {
        return {
            data: null,
            error: error
        };
    }
};
const $7025f3ffcea5847f$export$9780b1d2f37bd104 = async (row)=>{
    try {
        const data = await (0, $bfqVY.getSDK)().execute('workspaceProject.userGrants', 'create', {
            payload: row
        });
        if (!data) return {
            data: null,
            error: new Error('grant insert returned empty')
        };
        const email = await $7025f3ffcea5847f$var$_emailFor(data.user_id);
        await $7025f3ffcea5847f$var$_mirror(data, email);
        return {
            data: data,
            error: null
        };
    } catch (error) {
        return {
            data: null,
            error: error
        };
    }
};
const $7025f3ffcea5847f$export$3102db4c37b3ad67 = async (grantId)=>{
    // Capture grantee info before the governance row disappears so the
    // financials void-mirror can keep the row attributable.
    await (0, $bfqVY.getSDK)().execute('workspaceProject.userGrants', 'remove', {
        id: grantId
    });
    await $7025f3ffcea5847f$var$_mirrorDelete(grantId);
};

});


parcelRegister("32MAk", function(module, exports) {

$parcel$export(module.exports, "LinkedResources", () => $23773ef553eb1325$export$e574f09dbdb296dd);
$parcel$export(module.exports, "LinkedResourcePill", () => $23773ef553eb1325$export$3107e033991c94e4);
// Inline pill row that surfaces linked cross-resource references for the
// current chat channel / calendar event / meet room. Clicking a pill
// navigates to the linked resource so users can hop between the
// conversation, the meeting, and the event that tied them together.
//
// Usage: mount inside the header/detail area of a resource view and set
// local state `type` + `id`:
//
//   LinkedResources: { state: { type: 'chat_channel', id: root.activeChannelId } }
//
// Renders nothing when there are no links (collapses to `display: none`).
const $23773ef553eb1325$var$TYPE_META = {
    chat_channel: {
        icon: 'chat',
        label: (root, id)=>{
            const ch = (root.channels || []).find((c)=>String(c.id) === String(id));
            if (!ch) return 'Conversation';
            if (ch.kind === 'channel') return '# ' + (ch.name || '');
            if (ch.kind === 'group_dm') return 'Group';
            return 'DM';
        }
    },
    meet_room: {
        icon: 'video',
        label: (root, id)=>{
            const r = (root.rooms || []).find((x)=>String(x.id) === String(id));
            return r?.name || 'Call';
        }
    },
    calendar_event: {
        icon: 'clock',
        label: (root, id)=>{
            const ev = (root.events || []).find((e)=>String(e.id) === String(id));
            return ev?.title || 'Event';
        }
    }
};
const $23773ef553eb1325$var$_navigateTo = (el, type, id)=>{
    const root = el.state?.root;
    if (!root) return;
    let rootEl = el;
    while(rootEl && !rootEl.routes)rootEl = rootEl.parent;
    if (type === 'chat_channel') {
        root.update({
            activeChannelId: id,
            activeThreadRootId: null
        });
        if (rootEl) el.router('/chat', rootEl);
    } else if (type === 'meet_room') {
        root.update({
            activeRoomId: id,
            meetView: 'call'
        });
        if (typeof window !== 'undefined') window.location.hash = `room=${id}&view=call`;
        if (rootEl) el.router('/meet', rootEl);
    } else if (type === 'calendar_event') {
        const ev = (root.events || []).find((e)=>String(e.id) === String(id));
        if (ev) root.update({
            selectedEvent: ev,
            showEventDetail: true
        });
        if (rootEl) el.router('/calendar', rootEl);
    }
};
const $23773ef553eb1325$export$e574f09dbdb296dd = {
    flow: 'x',
    gap: 'Z',
    align: 'center left',
    flexWrap: 'wrap',
    display: (el, s)=>{
        const root = s?.root;
        if (!root || !el.type || el.id == null) return 'none';
        return el.call('getLinkedResources', root, el.type, el.id).length ? 'flex' : 'none';
    },
    Label: {
        tag: 'span',
        fontSize: 'Y2',
        color: 'caption',
        text: 'Linked:'
    },
    childExtends: 'LinkedResourcePill',
    childrenAs: 'state',
    children: (el, s)=>{
        const root = s?.root;
        if (!root || !el.type || el.id == null) return [];
        return el.call('getLinkedResources', root, el.type, el.id);
    }
};
const $23773ef553eb1325$export$3107e033991c94e4 = {
    tag: 'button',
    type: 'button',
    flow: 'x',
    align: 'center left',
    gap: 'Y',
    padding: 'Y Z',
    round: 'C',
    border: 'none',
    background: 'overlay',
    color: 'title',
    cursor: 'pointer',
    fontSize: 'Y2',
    fontWeight: '500',
    ':hover': {
        background: 'overlayStrong'
    },
    transition: 'background 120ms ease',
    Icon: {
        icon: (el, s)=>$23773ef553eb1325$var$TYPE_META[s.type]?.icon || 'link'
    },
    Text: {
        tag: 'span',
        text: (el, s)=>{
            const root = el.state?.root;
            const meta = $23773ef553eb1325$var$TYPE_META[s.type];
            if (!root || !meta) return '';
            return meta.label(root, s.id);
        }
    },
    onClick: (e, el, s)=>{
        e.preventDefault();
        e.stopPropagation();
        $23773ef553eb1325$var$_navigateTo(el, s.type, s.id);
    }
};

});

parcelRegister("btLXS", function(module, exports) {

$parcel$export(module.exports, "NotificationBell", () => $85b79bf00eff8c71$export$da43598a51abd858);
$parcel$export(module.exports, "NotificationPanel", () => $85b79bf00eff8c71$export$20171ad88b646892);
const $85b79bf00eff8c71$var$_unread = (root)=>(root?.notifications || []).filter((n)=>!n.read).length;
const $85b79bf00eff8c71$var$ICON_BY_TYPE = {
    mention: 'chat',
    ticket_assign: 'check',
    calendar_invite: 'date',
    doc_share: 'document',
    system: 'settings'
};
const $85b79bf00eff8c71$var$COLOR_BY_TYPE = {
    mention: 'blue',
    ticket_assign: 'green',
    calendar_invite: 'purple',
    doc_share: 'orange',
    system: 'caption'
};
const $85b79bf00eff8c71$var$_timeAgo = (iso)=>{
    if (!iso) return '';
    const ms = Date.now() - new Date(iso).getTime();
    const mins = Math.floor(ms / 60000);
    if (mins < 1) return 'now';
    if (mins < 60) return `${mins}m`;
    const hrs = Math.floor(mins / 60);
    if (hrs < 24) return `${hrs}h`;
    const days = Math.floor(hrs / 24);
    return `${days}d`;
};
const $85b79bf00eff8c71$export$da43598a51abd858 = {
    tag: 'button',
    type: 'button',
    title: 'Notifications',
    'aria-label': 'Notifications',
    position: 'relative',
    padding: 'Z',
    round: 'Z',
    cursor: 'pointer',
    borderWidth: '0',
    background: 'transparent',
    color: 'caption',
    ':hover': {
        background: 'overlay',
        color: 'title'
    },
    onClick: (e, el, s)=>{
        e.stopPropagation();
        s.root.update({
            notificationsPanelOpen: !s.root.notificationsPanelOpen
        });
    },
    Icon: {
        icon: 'bell',
        boxSize: 'A A'
    },
    UnreadBadge: {
        if: (el, s)=>$85b79bf00eff8c71$var$_unread(s.root) > 0,
        position: 'absolute',
        top: '0',
        right: '0',
        minWidth: 'Z',
        height: 'Z',
        padding: '0 V',
        round: 'C',
        background: 'red',
        color: 'white',
        fontSize: 'W',
        fontWeight: '700',
        lineHeight: '1',
        align: 'center center',
        pointerEvents: 'none',
        text: (el, s)=>{
            const n = $85b79bf00eff8c71$var$_unread(s.root);
            return n > 99 ? '99+' : String(n);
        }
    }
};
const $85b79bf00eff8c71$export$20171ad88b646892 = {
    extends: 'CommonCard',
    display: (el, s)=>s.root?.notificationsPanelOpen ? 'flex' : 'none',
    position: 'absolute',
    top: 'B1',
    right: '0',
    width: '360px',
    maxHeight: '480px',
    overflow: 'hidden',
    padding: '0',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'line',
    boxShadow: '0 16px 48px -8px rgba(0,0,0,0.5)',
    zIndex: '3000',
    flow: 'y',
    onRender: (el)=>{
        const handler = (e)=>{
            if (!el.node?.contains(e.target) && !el.parent?.node?.contains(e.target)) {
                el.state.root.update({
                    notificationsPanelOpen: false
                });
                document.removeEventListener('mousedown', handler);
            }
        };
        setTimeout(()=>document.addEventListener('mousedown', handler), 0);
        el._closeHandler = handler;
    },
    onRemove: (el)=>{
        if (el._closeHandler) document.removeEventListener('mousedown', el._closeHandler);
    },
    Header: {
        flow: 'x',
        align: 'center space-between',
        padding: 'Z1 A',
        borderBottomWidth: '1px',
        borderBottomStyle: 'solid',
        borderBottomColor: 'line',
        Title: {
            tag: 'span',
            text: 'Notifications',
            fontWeight: '700',
            fontSize: 'Z1',
            color: 'title'
        },
        MarkAllBtn: {
            tag: 'button',
            type: 'button',
            text: 'Mark all read',
            background: 'none',
            borderWidth: '0',
            color: 'blue',
            fontSize: 'Y2',
            fontWeight: '600',
            cursor: 'pointer',
            padding: '0',
            if: (el, s)=>$85b79bf00eff8c71$var$_unread(s.root) > 0,
            onClick: (e, el, s)=>{
                e.stopPropagation();
                el.call('markAllNotificationsRead');
            }
        }
    },
    List: {
        overflow: 'auto',
        maxHeight: '420px',
        flow: 'y',
        Empty: {
            if: (el, s)=>!(s.root?.notifications || []).length,
            padding: 'C A',
            textAlign: 'center',
            color: 'caption',
            fontSize: 'Z1',
            text: 'No notifications yet'
        },
        childrenAs: 'state',
        children: (el, s)=>(s.root?.notifications || []).slice(0, 30),
        childExtends: {
            flow: 'x',
            gap: 'Z',
            padding: 'Z1 A',
            cursor: 'pointer',
            borderBottomWidth: '1px',
            borderBottomStyle: 'solid',
            borderBottomColor: 'line',
            background: (el, s)=>s.read ? 'transparent' : 'overlay',
            ':hover': {
                background: 'overlayStrong'
            },
            onClick: (e, el, s)=>{
                e.stopPropagation();
                el.call('markNotificationRead', s.id);
                if (s.href) {
                    el.state.root.update({
                        notificationsPanelOpen: false
                    });
                    let rootEl = el;
                    while(rootEl && !rootEl.routes)rootEl = rootEl.parent;
                    if (rootEl) el.router(s.href, rootEl);
                }
            },
            UnreadDot: {
                if: (el, s)=>!s.read,
                width: 'V',
                height: 'V',
                round: '50%',
                background: 'blue',
                flexShrink: '0',
                marginTop: 'Z'
            },
            TypeIcon: {
                Icon: {
                    icon: (el, s)=>$85b79bf00eff8c71$var$ICON_BY_TYPE[s.parent?.state?.type] || 'star',
                    boxSize: 'A',
                    color: (el, s)=>$85b79bf00eff8c71$var$COLOR_BY_TYPE[s.parent?.state?.type] || 'caption'
                }
            },
            Body: {
                flex: '1',
                flow: 'y',
                gap: 'W',
                minWidth: '0',
                NTitle: {
                    tag: 'span',
                    fontSize: 'Z',
                    fontWeight: '600',
                    color: 'title',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    text: (el, s)=>s.parent?.state?.title || ''
                },
                NBody: {
                    if: (el, s)=>s.parent?.state?.body,
                    tag: 'span',
                    fontSize: 'Y2',
                    color: 'caption',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    text: (el, s)=>s.parent?.state?.body || ''
                }
            },
            Time: {
                tag: 'span',
                fontSize: 'Y2',
                color: 'caption',
                flexShrink: '0',
                whiteSpace: 'nowrap',
                text: (el, s)=>$85b79bf00eff8c71$var$_timeAgo(s.createdAt)
            }
        }
    }
};

});

parcelRegister("73QnC", function(module, exports) {

$parcel$export(module.exports, "NavSearchResultGroup", () => $524171c2b9f1da33$export$6364b8b5fb4fcb45);
$parcel$export(module.exports, "NavSearchResultItem", () => $524171c2b9f1da33$export$445f2ee16b8daca7);
// NavSearchDropdown — populates SearchBar > Dropdown with grouped global
// search results. The parent SearchBar extends DropdownParentFocus, which
// shows [dropdown] children on :focus-within via CSS.
const $524171c2b9f1da33$export$6364b8b5fb4fcb45 = {
    flow: 'y',
    GroupHeader: {
        flow: 'x',
        align: 'center left',
        gap: 'Y',
        padding: 'Y1 A',
        Icon: {
            name: (el, s)=>s.icon || 'search',
            boxSize: 'Z2 Z2',
            color: 'caption'
        },
        GroupLabel: {
            text: (el, s)=>s.label || '',
            fontSize: 'Y2',
            fontWeight: '600',
            color: 'caption',
            textTransform: 'uppercase',
            letterSpacing: '0.05em'
        }
    },
    Items: {
        flow: 'y',
        children: (el, s)=>s.items || [],
        childExtends: 'NavSearchResultItem',
        childrenAs: 'state'
    }
};
const $524171c2b9f1da33$export$445f2ee16b8daca7 = {
    extends: 'Link',
    flow: 'x',
    align: 'center left',
    gap: 'Z',
    padding: 'Y1 A',
    cursor: 'pointer',
    textDecoration: 'none',
    round: 'Y',
    ':hover': {
        background: 'gray.05'
    },
    href: (el, s)=>s._href || '#',
    onClick: (e, el, s)=>{
        e.preventDefault();
        el.call('navigateSearchResult', s._href);
    },
    ResultTitle: {
        flex: '1',
        fontSize: 'Z2',
        fontWeight: '500',
        color: 'title',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        text: (el, s)=>s._title || ''
    },
    ResultSubtitle: {
        fontSize: 'Y2',
        color: 'caption',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        maxWidth: 'F',
        text: (el, s)=>s._subtitle || '',
        hide: (el, s)=>!s._subtitle
    }
};

});

parcelRegister("04mCb", function(module, exports) {

$parcel$export(module.exports, "IntranetAppHeader", () => $00d1eab2b939f36c$export$53f67462767adfc9);

var $jg4vi = parcelRequire("jg4vi");

var $dELsh = parcelRequire("dELsh");
// Local page-title map for all /tickets/* (and other) routes that
// IntranetAppHeader must label correctly. Mirrors the TITLES map in
// editor/packages/shared/components/AppHeader.js — kept here so the
// intranet bundle is self-sufficient regardless of how Parcel resolves
// the shared AppHeader at build time.
const $00d1eab2b939f36c$var$INTRANET_TITLES = {
    '/calendar': 'Calendar',
    '/chat': 'Chat',
    '/tickets': 'My view',
    '/tickets/my': 'My view',
    '/tickets/general': 'General',
    '/tickets/feed': 'Feed',
    '/tickets/canvas': 'Canvas',
    '/tickets/stories': 'Stories',
    '/tickets/epics': 'Epics',
    '/tickets/board': 'Board',
    '/tickets/standups': 'Standups',
    '/tickets/requests': 'Requests',
    '/tickets/requests/inbound': 'Inbound',
    '/tickets/requests/outbound': 'Outbound',
    '/tickets/requests/audit': 'Audit / Reports',
    '/tickets/resolutions': 'Resolutions',
    '/meet': 'Meet',
    '/system': 'System',
    '/dashboard': 'Dashboard'
};
const $00d1eab2b939f36c$var$INTRANET_PREFIX_TITLES = [
    [
        '/tickets/requests',
        'Requests'
    ],
    [
        '/tickets/resolutions',
        'Resolutions'
    ],
    [
        '/tickets',
        'Tickets'
    ],
    [
        '/meet/',
        'Call'
    ],
    [
        '/documents/',
        'Documents'
    ],
    [
        '/documents',
        'Documents'
    ],
    [
        '/workspaces',
        'Workspaces'
    ],
    [
        '/admin',
        'Admin'
    ]
];
const $00d1eab2b939f36c$var$intranetPageTitle = (path)=>{
    if (!path) return '';
    if ($00d1eab2b939f36c$var$INTRANET_TITLES[path]) return $00d1eab2b939f36c$var$INTRANET_TITLES[path];
    if (path.startsWith('/meet/') && path.endsWith('/transcript')) return 'Transcript';
    for (const [prefix, label] of $00d1eab2b939f36c$var$INTRANET_PREFIX_TITLES){
        if (path.startsWith(prefix)) return label;
    }
    return 'Canvas';
};
const $00d1eab2b939f36c$var$NAV_LINKS = [
    {
        label: 'Main',
        href: '/'
    },
    {
        label: 'People',
        href: '/people'
    },
    {
        label: 'My',
        href: '/my'
    },
    {
        label: 'Announcements',
        href: '/announcements'
    },
    {
        label: 'Company',
        href: '/company'
    }
];
const $00d1eab2b939f36c$var$totalUnread = (root)=>{
    if (!root) return 0;
    const me = root.currentUserEmail;
    const members = root.channelMembers || [];
    let total = 0;
    for (const mm of members){
        if (mm.member_email !== me) continue;
        const msgs = root.messagesByChannel?.[mm.channel_id] || [];
        total += (0, $jg4vi.unreadCount)(msgs, mm.last_read_at, me);
    }
    return total;
};
const $00d1eab2b939f36c$export$53f67462767adfc9 = {
    extends: 'AppHeader',
    onRender: (el, s)=>{
        if (!el._notifInit && s.root?.currentUserEmail) {
            el._notifInit = true;
            el.call('requestBrowserPermission');
            el.call('subscribeNotifications');
            el.call('fetchNotifications');
        }
    },
    // Recompute chat unread only when the underlying data changed — otherwise
    // every unrelated root update would loop through all memberships.
    onUpdate: (el, s)=>{
        const root = s.root;
        const members = root.channelMembers;
        const msgs = root.messagesByChannel;
        if (el._lastMembers === members && el._lastMsgs === msgs) return;
        el._lastMembers = members;
        el._lastMsgs = msgs;
        const next = $00d1eab2b939f36c$var$totalUnread(root);
        const cur = root.navUnreadCounts?.chat || 0;
        if (next !== cur) root.update({
            navUnreadCounts: {
                ...root.navUnreadCounts || {},
                chat: next
            }
        });
    },
    // Override the shared AppHeader PageTitle so the intranet bundle resolves
    // the correct sub-page label from its own TITLES map rather than the
    // shared one (which may not reflect the latest keys when Parcel caches
    // an older build of AppHeader.js). All /tickets/* routes that were
    // previously falling through to the PREFIX_TITLES catch-all are handled
    // by INTRANET_TITLES above.
    PageTitle: {
        text: (el, s)=>$00d1eab2b939f36c$var$intranetPageTitle(s.root?.currentPath || s.root?.route || '')
    },
    Links: {
        hide: (el, s)=>!(0, $dELsh.checkActiveMember)(el) || !(0, $dELsh.isIntranetRoute)(s),
        theme: 'document',
        background: 'overlayStrong',
        round: 'D',
        flow: 'x',
        gap: 'X',
        padding: 'X',
        align: 'center center',
        margin: '- auto',
        childExtends: 'AppNavLink',
        childrenAs: 'state',
        children: ()=>$00d1eab2b939f36c$var$NAV_LINKS
    },
    SearchBar: {
        hide: (el, s)=>!(0, $dELsh.checkActiveMember)(el) || (0, $dELsh.isIntranetRoute)(s),
        Form: {
            Input: {
                placeholder: "Search across everything\u2026",
                onInput: (e, el)=>el.call('globalSearch', e.target.value),
                onKeydown: (e, el)=>{
                    if (e.key === 'Escape') {
                        el.call('closeNavSearch');
                        el.node.blur();
                    }
                }
            }
        },
        Dropdown: {
            ResultGroups: {
                flow: 'y',
                if: (el, s)=>!!s.root?._navSearchGrouped?.length,
                children: (el, s)=>s.root?._navSearchGrouped || [],
                childExtends: 'NavSearchResultGroup',
                childrenAs: 'state'
            }
        }
    },
    // Shared AppHeader already lays out the icon/button slots
    // (AppWorkspaceSwitcher, CalOnlineUsersBar, Messenger, NotificationWrapper,
    // AppAssistantToggle, MeWrapper) — intranet just gates the whole rail on
    // membership and customises the avatar menu.
    UserActions: {
        hide: (el)=>!(0, $dELsh.checkActiveMember)(el),
        MeWrapper: {
            MeMenu: {
                AdminItem: {
                    order: -1,
                    extends: 'Link',
                    text: 'Admin',
                    color: 'title',
                    href: '/admin',
                    hide: (el)=>!el.call('currentUserIsAdmin')
                },
                SignOutItem: {
                    // migrated 2026-04-27 — flat sdk.logout() handles token clearing,
                    // emits SIGNED_OUT to subscribers, and triggers the SDK's own
                    // bridge teardown (federated logoutAll lives in functions/auth.js).
                    // After logout, redirect to /login so the user lands on a fresh
                    // sign-in page rather than on the now-tokenless intranet (which
                    // would only flash empty data before its own auth gate kicks in).
                    href: '/login',
                    onClick: async (e, el)=>{
                        e.preventDefault();
                        try {
                            await el.sdk?.logout?.();
                        } catch  {}
                        el.router('/login', el.getRoot());
                    }
                }
            }
        }
    }
};

});

parcelRegister("2EVKl", function(module, exports) {

$parcel$export(module.exports, "ContentPage", () => $1efc1c75132fb1e1$export$4b236baf42ce0734);
$parcel$export(module.exports, "ContentPageSectionLink", () => $1efc1c75132fb1e1$export$7c310db2033cd93b);
// Stripe-Atlas-style content shell. Pages extend it and provide
// `eyebrow`, `title`, `sections`, and a `PageBody` child.
//
// v3 has no `props` bag — fields are flattened on the element itself,
// so children read them via `el.parent.parent.eyebrow`.
const $1efc1c75132fb1e1$export$4b236baf42ce0734 = {
    extends: 'Page',
    flow: 'x',
    align: 'flex-start',
    gap: 'D',
    padding: 'D C',
    maxWidth: 'none',
    margin: '0 auto',
    width: '100%',
    PageRail: {
        flow: 'y',
        gap: 'C',
        width: 'G',
        minWidth: 'G',
        flex: '0 0 auto',
        position: 'sticky',
        top: 'D',
        PageHeading: {
            flow: 'y',
            gap: 'A',
            Eyebrow: {
                tag: 'span',
                fontSize: 'Z2',
                fontWeight: '700',
                letterSpacing: '0.12em',
                textTransform: 'uppercase',
                color: 'blue',
                text: (el, s)=>el.parent.parent.parent.eyebrow || ''
            },
            PageTitle: {
                tag: 'h1',
                fontSize: 'D',
                fontWeight: '800',
                color: 'title',
                letterSpacing: '-0.03em',
                lineHeight: '1.1',
                margin: '0',
                text: (el, s)=>el.parent.parent.parent.title || ''
            }
        },
        SectionList: {
            flow: 'y',
            gap: 'Z',
            paddingTop: 'B',
            borderTopWidth: '1px',
            borderTopStyle: 'solid',
            borderTopColor: 'line',
            childExtends: 'ContentPageSectionLink',
            childrenAs: 'state',
            children: (el, s)=>{
                const page = el.parent?.parent;
                if (!page) return [];
                const sections = page.sections;
                return typeof sections === 'function' ? sections(el, s) : sections || [];
            }
        }
    }
};
const $1efc1c75132fb1e1$export$7c310db2033cd93b = {
    tag: 'button',
    border: 'none',
    fontSize: 'Z2',
    fontWeight: '600',
    padding: 'Z A',
    margin: '- -A',
    round: 'C',
    cursor: 'pointer',
    textAlign: 'left',
    background: (el, s)=>(s.root?.contentSection || null) === (s.label || null) ? 'overlay' : 'transparent',
    color: (el, s)=>(s.root?.contentSection || null) === (s.label || null) ? 'title' : 'caption',
    ':hover': {
        color: 'title',
        background: 'overlay'
    },
    text: (el, s)=>s.label,
    onClick: (e, el, s)=>{
        e.preventDefault();
        s.root.update({
            contentSection: s.label
        });
        setTimeout(()=>{
            try {
                const target = document.querySelector(`[data-content-section="${(s.label || '').replace(/"/g, '\\"')}"]`);
                if (!target) return;
                let scroller = target.parentElement;
                while(scroller){
                    const cs = getComputedStyle(scroller);
                    if ((cs.overflowY === 'auto' || cs.overflowY === 'scroll') && scroller.scrollHeight > scroller.clientHeight + 5) break;
                    scroller = scroller.parentElement;
                }
                if (scroller) {
                    const offset = target.getBoundingClientRect().top - scroller.getBoundingClientRect().top;
                    scroller.scrollTop = scroller.scrollTop + offset - 16;
                } else target.scrollIntoView({
                    block: 'start'
                });
            } catch  {}
        }, 0);
    }
};

});

parcelRegister("bokCg", function(module, exports) {

$parcel$export(module.exports, "PersonCard", () => $84b1ed8bc0fe2498$export$4c094c8f61edecb4);
$parcel$export(module.exports, "RoleManagerRow", () => $84b1ed8bc0fe2498$export$881ee33189e5d697);
$parcel$export(module.exports, "DocumentRow", () => $84b1ed8bc0fe2498$export$161a5fbbcd1ed67f);
$parcel$export(module.exports, "PeopleFilterLink", () => $84b1ed8bc0fe2498$export$9092f9bddf899731);
$parcel$export(module.exports, "CompanyInfoRow", () => $84b1ed8bc0fe2498$export$85b9fbf91bef48b4);
$parcel$export(module.exports, "PeopleGroupBlock", () => $84b1ed8bc0fe2498$export$c9af2366c191bfef);

var $chzVb = parcelRequire("chzVb");
const $84b1ed8bc0fe2498$export$4c094c8f61edecb4 = {
    extends: 'Link',
    href: (el, s)=>`/profile?u=${encodeURIComponent(s.email || '')}`,
    flow: 'y',
    gap: 'B',
    padding: 'B',
    round: 'C',
    background: 'overlay',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'line',
    position: 'relative',
    overflow: 'hidden',
    cursor: 'pointer',
    textDecoration: 'none',
    color: 'title',
    ':hover': {
        borderColor: 'blue'
    },
    PcHeader: {
        flow: 'x',
        align: 'center',
        gap: 'A',
        marginTop: 'Z',
        PcAvatar: {
            align: 'center center',
            width: 'D',
            height: 'D',
            round: '50%',
            color: 'white',
            fontSize: 'B',
            fontWeight: '800',
            background: (el, s)=>(0, $chzVb.colorFromEmail)(s.email),
            text: (el, s)=>s.avatar || ''
        },
        PcName: {
            flow: 'y',
            gap: 'Y',
            flex: '1',
            PcTitle: {
                tag: 'span',
                fontSize: 'B',
                fontWeight: '700',
                color: 'title',
                text: (el, s)=>s.name
            },
            PcPosition: {
                tag: 'span',
                fontSize: 'Z2',
                color: 'caption',
                text: (el, s)=>s.position
            }
        }
    },
    PcDept: {
        tag: 'span',
        alignSelf: 'flex-start',
        padding: 'Y A',
        round: 'B',
        fontSize: 'Y2',
        fontWeight: '700',
        color: 'title',
        background: 'overlayStrong',
        border: 'none',
        textTransform: 'uppercase',
        letterSpacing: '0.06em',
        text: (el, s)=>{
            const email = String(s.email || '').toLowerCase();
            const teams = s.root?.teamsByEmail?.[email] || [];
            return teams[0]?.name || 'Member';
        }
    },
    PcMeta: {
        flow: 'y',
        gap: 'Z',
        fontSize: 'Z2',
        color: 'paragraph',
        PcLoc: {
            tag: 'span',
            text: (el, s)=>`${s.location || "\u2014"}`
        },
        PcTz: {
            tag: 'span',
            color: 'caption',
            text: (el, s)=>s.timezone || ''
        },
        PcMail: {
            tag: 'span',
            color: 'caption',
            text: (el, s)=>s.email
        }
    },
    // Read-only role badge. Editing happens in the dedicated Role manager
    // panel on the People page (superadmin only).
    PcRole: {
        hide: (el)=>!el.call('isSuperAdmin'),
        flow: 'x',
        align: 'center space-between',
        gap: 'Z',
        paddingTop: 'A',
        PcRoleLabel: {
            tag: 'span',
            fontSize: 'Y2',
            fontWeight: '700',
            color: 'caption',
            textTransform: 'uppercase',
            letterSpacing: '0.08em',
            text: 'Role'
        },
        PcRoleBadge: {
            tag: 'span',
            padding: 'Y A',
            round: 'B',
            fontSize: 'Y2',
            fontWeight: '700',
            color: 'white',
            textTransform: 'uppercase',
            letterSpacing: '0.06em',
            background: (el, s)=>(0, $chzVb.roleColor)(s, (0, $chzVb.roleOf)(s, s.userId) || 'member'),
            text: (el, s)=>(0, $chzVb.roleLabel)(s, (0, $chzVb.roleOf)(s, s.userId) || 'member')
        }
    }
};
const $84b1ed8bc0fe2498$export$881ee33189e5d697 = {
    flow: 'x',
    align: 'center space-between',
    gap: 'B',
    padding: 'Z A',
    round: 'C',
    ':hover': {
        background: 'overlayStrong'
    },
    RmLeft: {
        flow: 'x',
        align: 'center',
        gap: 'A',
        flex: '1',
        minWidth: '0',
        RmDot: {
            width: 'Z',
            height: 'Z',
            round: '50%',
            flex: '0 0 auto',
            background: (el, s)=>(0, $chzVb.roleColor)(s, (0, $chzVb.roleOf)(s, s.userId) || 'member')
        },
        RmName: {
            flow: 'y',
            gap: 'Y',
            flex: '1',
            minWidth: '0',
            RmNameTitle: {
                tag: 'span',
                fontSize: 'A',
                fontWeight: '700',
                color: 'title',
                text: (el, s)=>s.name
            },
            RmNameSub: {
                tag: 'span',
                fontSize: 'Z2',
                color: 'caption',
                text: (el, s)=>s.email
            }
        }
    },
    RmSelect: {
        tag: 'select',
        padding: 'Y A',
        round: 'B',
        background: 'overlayStrong',
        border: 'none',
        color: 'title',
        fontSize: 'Z2',
        fontWeight: '700',
        cursor: 'pointer',
        onChange: async (ev, el, s)=>{
            const newRole = ev.target.value;
            if (!s.userId) return;
            const prev = s.root.roles || {
                available: [],
                byUser: {},
                version: 0
            };
            s.root.update({
                roles: {
                    ...prev,
                    byUser: {
                        ...prev.byUser || {},
                        [s.userId]: newRole
                    },
                    version: (prev.version || 0) + 1
                }
            });
            try {
                await (0, $chzVb.sb)().from('user_roles').upsert({
                    user_id: s.userId,
                    role: newRole
                }, {
                    onConflict: 'user_id'
                });
            } catch (e) {
                console.warn('[intranet] role update failed', e);
            }
        },
        onRender: (el, s)=>{
            if (!el.node) return;
            const fill = ()=>{
                el.node.innerHTML = '';
                const current = (0, $chzVb.roleOf)(s, s.userId) || 'member';
                const roles = (0, $chzVb.allRoles)(s);
                const list = roles.length ? roles : [
                    {
                        name: 'member',
                        label: 'Member'
                    }
                ];
                for (const r of list){
                    const opt = document.createElement('option');
                    opt.value = r.name;
                    opt.textContent = r.label || r.name;
                    if (r.name === current) opt.selected = true;
                    el.node.appendChild(opt);
                }
            };
            fill();
            // The roles fetch may resolve after first render. Re-fill once
            // more when the data lands.
            let tries = 0;
            const t = setInterval(()=>{
                if ((0, $chzVb.allRoles)(s).length) {
                    fill();
                    clearInterval(t);
                    return;
                }
                if (++tries > 10) clearInterval(t);
            }, 200);
            el._rmTimer = t;
        },
        onRemove: (el)=>{
            if (el._rmTimer) clearInterval(el._rmTimer);
        }
    }
};
const $84b1ed8bc0fe2498$export$161a5fbbcd1ed67f = {
    extends: 'Link',
    href: (el, s)=>s.url || '/documents',
    textDecoration: 'none',
    color: 'inherit',
    flow: 'x',
    align: 'center',
    gap: 'B',
    padding: 'B 0',
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: 'line',
    cursor: 'pointer',
    ':hover': {
        background: 'overlayStrong'
    },
    DrIcon: {
        extends: 'Icon',
        icon: 'document',
        boxSize: 'C',
        color: 'blue'
    },
    DrBody: {
        flow: 'y',
        gap: 'Y',
        flex: '1',
        minWidth: '0',
        DrTitle: {
            tag: 'span',
            fontSize: 'A',
            fontWeight: '700',
            color: 'title',
            text: (el, s)=>s.title
        },
        DrMeta: {
            tag: 'span',
            fontSize: 'Z2',
            color: 'caption',
            text: (el, s)=>{
                const parts = [];
                if (s.type) parts.push(s.type);
                if (s.size) parts.push(s.size);
                if (s.signedAt) parts.push(`signed ${s.signedAt}`);
                return parts.join(" \xb7 ");
            }
        }
    },
    DrAction: {
        tag: 'span',
        fontSize: 'Z2',
        fontWeight: '700',
        color: 'blue',
        textTransform: 'uppercase',
        letterSpacing: '0.06em',
        text: 'Open'
    }
};
// Sidebar filter row on the People page. State carries `kind` ('group' |
// 'role'), `name` (the value to filter by, null = clear), `label`, and
// optional `count`. Click toggles the matching root-state filter.
// Resolves which `root.selected*` field corresponds to a given filter kind.
const $84b1ed8bc0fe2498$var$_selField = (kind)=>{
    if (kind === 'role') return 'selectedRole';
    if (kind === 'category') return 'selectedTeamCategory';
    return 'selectedGroup';
};
const $84b1ed8bc0fe2498$export$9092f9bddf899731 = {
    tag: 'button',
    flow: 'x',
    align: 'center space-between',
    gap: 'A',
    padding: 'Z A',
    round: 'C',
    border: 'none',
    cursor: 'pointer',
    textAlign: 'left',
    background: (el, s)=>s.root[$84b1ed8bc0fe2498$var$_selField(s.kind)] === s.name ? 'blue.2' : 'transparent',
    color: (el, s)=>s.root[$84b1ed8bc0fe2498$var$_selField(s.kind)] === s.name ? 'title' : 'caption',
    fontWeight: (el, s)=>s.root[$84b1ed8bc0fe2498$var$_selField(s.kind)] === s.name ? '700' : '500',
    ':hover': {
        color: 'title'
    },
    onClick: (ev, el, s)=>{
        ev.preventDefault();
        s.root.update({
            [$84b1ed8bc0fe2498$var$_selField(s.kind)]: s.name
        });
    },
    PflLabel: {
        tag: 'span',
        fontSize: 'Z2',
        text: (el, s)=>s.label
    },
    PflCount: {
        tag: 'span',
        fontSize: 'Y2',
        color: 'caption',
        text: (el, s)=>s.count != null ? String(s.count) : ''
    }
};
const $84b1ed8bc0fe2498$export$85b9fbf91bef48b4 = {
    flow: 'y',
    gap: 'Z',
    padding: 'B 0',
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: 'line',
    CiLabel: {
        tag: 'span',
        fontSize: 'Z2',
        fontWeight: '700',
        color: 'caption',
        textTransform: 'uppercase',
        letterSpacing: '0.08em',
        text: (el, s)=>s.label || s.key
    },
    CiValue: {
        tag: 'span',
        fontSize: 'B',
        color: 'title',
        lineHeight: '1.55',
        text: (el, s)=>s.value
    }
};
const $84b1ed8bc0fe2498$export$c9af2366c191bfef = {
    flow: 'y',
    gap: 'B',
    PgHead: {
        flow: 'x',
        align: 'baseline',
        gap: 'A',
        paddingBottom: 'Z',
        borderBottomWidth: '1px',
        borderBottomStyle: 'solid',
        borderBottomColor: 'line',
        PgTitle: {
            tag: 'h2',
            fontSize: 'C',
            fontWeight: '800',
            color: 'title',
            letterSpacing: '-0.01em',
            text: (el, s)=>s.name
        },
        PgCount: {
            tag: 'span',
            fontSize: 'Z2',
            color: 'caption',
            text: (el, s)=>`${(s.people || []).length}`
        }
    },
    PgGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
        gap: 'B',
        childExtends: 'PersonCard',
        childrenAs: 'state',
        children: (el, s)=>s.people || []
    }
};

});

parcelRegister("gLTua", function(module, exports) {

$parcel$export(module.exports, "AnnouncementCard", () => $c35c136868dfb566$export$fc09cf535d7ce857);
$parcel$export(module.exports, "ReactionPill", () => $c35c136868dfb566$export$44ce21f6a88f8431);
$parcel$export(module.exports, "AddReactionPicker", () => $c35c136868dfb566$export$2d4705842fbee2a6);
$parcel$export(module.exports, "AddReactionEmoji", () => $c35c136868dfb566$export$9acb05c432b24cc1);
$parcel$export(module.exports, "AnnouncementDetailModal", () => $c35c136868dfb566$export$9bf24fc3bca1c6e);
$parcel$export(module.exports, "AdmParagraph", () => $c35c136868dfb566$export$e38ab6dfda165f43);
$parcel$export(module.exports, "IntroRun", () => $c35c136868dfb566$export$30f83fb4ef98f83e);
$parcel$export(module.exports, "AvatarBundle", () => $c35c136868dfb566$export$5822eaed382932db);
$parcel$export(module.exports, "AvatarBundleItem", () => $c35c136868dfb566$export$c76390ffeae9f71c);
$parcel$export(module.exports, "BirthdayItem", () => $c35c136868dfb566$export$63066481d0925ed3);
$parcel$export(module.exports, "UpcomingEventCard", () => $c35c136868dfb566$export$e688e868b522f98c);
$parcel$export(module.exports, "CityCluster", () => $c35c136868dfb566$export$f81d5938d8ae44a);

var $chzVb = parcelRequire("chzVb");
const $c35c136868dfb566$var$_toggleReaction = (el, s, postId, emoji)=>{
    const me = el.call('findMe', s);
    const myName = me?.name || 'You';
    const next = (s.root.announcements || []).map((post)=>{
        if (post.id !== postId) return post;
        const reactions = {
            ...post.reactions || {}
        };
        const list = reactions[emoji] ? [
            ...reactions[emoji]
        ] : [];
        const i = list.indexOf(myName);
        if (i === -1) list.push(myName);
        else list.splice(i, 1);
        if (list.length) reactions[emoji] = list;
        else delete reactions[emoji];
        return {
            ...post,
            reactions: reactions
        };
    });
    s.root.update({
        announcements: next
    });
};
const $c35c136868dfb566$export$fc09cf535d7ce857 = {
    tag: 'article',
    flow: 'y',
    round: 'C',
    background: 'overlay',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'line',
    overflow: 'visible',
    position: 'relative',
    cursor: 'pointer',
    transition: 'all 220ms ease',
    ':hover': {
        borderColor: 'blue',
        transform: 'translateY(-3px)',
        boxShadow: '0 24px 48px -24px rgba(0, 133, 255, 0.35)'
    },
    onClick: (e, el, s)=>{
        // Ignore clicks that originated inside an interactive child (reactions, buttons, links)
        const t = e.target;
        if (t && (t.closest('button') || t.closest('a'))) return;
        s.root.update({
            selectedAnnouncement: s
        });
    },
    AcCover: {
        height: 'F',
        background: (el, s)=>s.cover || 'linear-gradient(135deg, #0085FF 0%, #50E1FF 100%)',
        position: 'relative',
        overflow: 'hidden',
        borderTopLeftRadius: 'C',
        borderTopRightRadius: 'C',
        AcTagPill: {
            position: 'absolute',
            top: 'A',
            left: 'A',
            padding: 'Z A',
            round: 'B',
            fontSize: 'Y2',
            fontWeight: '700',
            letterSpacing: '0.06em',
            textTransform: 'uppercase',
            color: '#0a0a0b',
            background: '#ffffff',
            text: (el, s)=>s.tag || 'news'
        }
    },
    AcBody: {
        flow: 'y',
        gap: 'B',
        padding: 'C',
        AcHeader: {
            flow: 'y',
            gap: 'A',
            AcTitle: {
                tag: 'h2',
                fontSize: 'D',
                fontWeight: '800',
                color: 'title',
                letterSpacing: '-0.025em',
                lineHeight: '1.15',
                text: (el, s)=>s.title
            },
            AcExcerpt: {
                tag: 'p',
                color: 'paragraph',
                fontSize: 'A',
                lineHeight: '1.55',
                text: (el, s)=>s.excerpt
            }
        },
        AcAuthor: {
            flow: 'x',
            align: 'center',
            gap: 'A',
            paddingTop: 'A',
            borderTopWidth: '1px',
            borderTopStyle: 'solid',
            borderTopColor: 'line',
            AcAvatar: {
                align: 'center center',
                width: 'C',
                height: 'C',
                round: '50%',
                color: 'white',
                fontSize: 'Z2',
                fontWeight: '700',
                background: (el, s)=>(0, $chzVb.colorFromEmail)(s.author),
                text: (el, s)=>s.authorAvatar || ''
            },
            AcMeta: {
                flow: 'y',
                gap: 'Y',
                flex: '1',
                AcName: {
                    tag: 'span',
                    fontSize: 'A',
                    fontWeight: '700',
                    color: 'title',
                    text: (el, s)=>s.author
                },
                AcSub: {
                    tag: 'span',
                    fontSize: 'Z2',
                    color: 'caption',
                    text: (el, s)=>{
                        const parts = [];
                        if (s.authorRole) parts.push(s.authorRole);
                        if (s.date) try {
                            parts.push(new Date(s.date).toLocaleDateString('en', {
                                month: 'short',
                                day: 'numeric'
                            }));
                        } catch  {}
                        if (s.readTime) parts.push(s.readTime);
                        return parts.join(" \xb7 ");
                    }
                }
            }
        },
        AcReactions: {
            flow: 'x',
            align: 'center',
            gap: 'Z',
            flexWrap: 'wrap',
            AcExisting: {
                flow: 'x',
                align: 'center',
                gap: 'Z',
                flexWrap: 'wrap',
                ':empty': {
                    display: 'none'
                },
                childExtends: 'ReactionPill',
                childrenAs: 'state',
                children: (el, s)=>Object.entries(s.reactions || {}).map(([emoji, names])=>({
                            emoji: emoji,
                            names: names,
                            postId: s.id
                        }))
            },
            AcAddReaction: {
                extends: 'AddReactionPicker'
            }
        }
    }
};
const $c35c136868dfb566$export$44ce21f6a88f8431 = {
    tag: 'button',
    flow: 'x',
    align: 'center',
    gap: 'Z',
    padding: 'Y A',
    round: 'C',
    background: 'overlayStrong',
    borderWidth: '1px',
    borderStyle: 'solid',
    fontSize: 'Z2',
    fontWeight: '700',
    color: 'title',
    cursor: 'pointer',
    title: (el, s)=>(s.names || []).join(', '),
    onClick: (ev, el, s)=>{
        ev.preventDefault();
        $c35c136868dfb566$var$_toggleReaction(el, s, s.postId, s.emoji);
    },
    // Border highlights when the signed-in user has reacted with this emoji.
    borderColor: (el, s)=>{
        const myName = el.call('findMe', s)?.name;
        return myName && (s.names || []).includes(myName) ? 'blue' : 'transparent';
    },
    RpEmoji: {
        tag: 'span',
        fontSize: 'A',
        text: (el, s)=>s.emoji
    },
    RpCount: {
        tag: 'span',
        text: (el, s)=>String((s.names || []).length)
    }
};
const $c35c136868dfb566$var$POPULAR_EMOJIS = [
    "\uD83D\uDC4D",
    "\u2764\uFE0F",
    "\uD83C\uDF89",
    "\uD83D\uDE80",
    "\uD83D\uDD25",
    "\uD83D\uDC4F",
    "\uD83D\uDC40",
    "\uD83D\uDE02"
];
const $c35c136868dfb566$var$ALL_EMOJIS = [
    "\uD83D\uDC4D",
    "\uD83D\uDC4E",
    "\u2764\uFE0F",
    "\uD83E\uDDE1",
    "\uD83D\uDC9B",
    "\uD83D\uDC9A",
    "\uD83D\uDC99",
    "\uD83D\uDC9C",
    "\uD83C\uDF89",
    "\uD83C\uDF8A",
    "\uD83D\uDE80",
    "\uD83D\uDD25",
    "\u26A1",
    "\u2728",
    "\uD83D\uDCAF",
    "\u2B50",
    "\uD83D\uDC4F",
    "\uD83D\uDE4C",
    "\uD83E\uDD1D",
    "\uD83D\uDCAA",
    "\uD83D\uDE4F",
    "\uD83D\uDC40",
    "\uD83D\uDE02",
    "\uD83D\uDE05",
    "\uD83D\uDE0D",
    "\uD83E\uDD29",
    "\uD83D\uDE0E",
    "\uD83E\uDD2F",
    "\uD83E\uDD73",
    "\uD83E\uDD14",
    "\uD83D\uDE22",
    "\uD83D\uDE21",
    "\u2705",
    "\u274C",
    "\u26A0\uFE0F",
    "\uD83D\uDCA1",
    "\uD83D\uDCC8",
    "\uD83D\uDCC9",
    "\uD83D\uDCFA",
    "\uD83C\uDF55"
];
const $c35c136868dfb566$export$2d4705842fbee2a6 = {
    position: 'relative',
    ArpButton: {
        tag: 'button',
        align: 'center center',
        padding: 'Y A',
        round: 'C',
        background: 'overlayStrong',
        border: 'none',
        fontSize: 'A',
        fontWeight: '700',
        color: 'caption',
        cursor: 'pointer',
        text: '+',
        ':hover': {
            color: 'title'
        },
        // Imperative open. Each card creates its own stacking context, so we
        // also bump the open card's z-index above its siblings — otherwise
        // the popover is hidden behind the next row's cards.
        onClick: (ev, el)=>{
            ev.preventDefault();
            ev.stopPropagation();
            const all = document.querySelectorAll('[data-arp-popover]');
            const mine = el.node.parentElement.querySelector('[data-arp-popover]');
            document.querySelectorAll('article').forEach((c)=>{
                c.style.zIndex = '';
            });
            all.forEach((p)=>{
                if (p !== mine) {
                    p.style.opacity = '0';
                    p.style.pointerEvents = 'none';
                }
            });
            const isOpen = mine.style.opacity === '1';
            mine.style.opacity = isOpen ? '0' : '1';
            mine.style.pointerEvents = isOpen ? 'none' : 'auto';
            const myCard = el.node.closest('article');
            if (myCard) myCard.style.zIndex = isOpen ? '' : '1000';
        }
    },
    // Toggle visibility instead of display: DOMQL prunes subtrees of
    // `display: none` on initial render, which would never mount the picker.
    ArpPopover: {
        flow: 'y',
        gap: 'A',
        position: 'absolute',
        top: 'D',
        left: 'auto',
        right: '0',
        zIndex: '100',
        width: 'H',
        maxWidth: '90vw',
        padding: 'B',
        round: 'C',
        background: 'overlayStrong',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'line',
        boxShadow: '0 24px 48px -16px rgba(0, 0, 0, 0.5)',
        opacity: '0',
        pointerEvents: 'none',
        transition: 'opacity 160ms ease',
        attr: {
            'data-arp-popover': 'true'
        },
        ArpPopular: {
            flow: 'y',
            gap: 'Z',
            ArpPopHead: {
                tag: 'span',
                fontSize: 'Y2',
                fontWeight: '700',
                color: 'caption',
                textTransform: 'uppercase',
                letterSpacing: '0.08em',
                text: 'Popular'
            },
            ArpPopGrid: {
                display: 'grid',
                gridTemplateColumns: 'repeat(8, 1fr)',
                gap: 'Z',
                childExtends: 'AddReactionEmoji',
                childrenAs: 'state',
                children: (el, s)=>$c35c136868dfb566$var$POPULAR_EMOJIS.map((e)=>({
                            emoji: e,
                            postId: s.id
                        }))
            }
        },
        ArpAll: {
            flow: 'y',
            gap: 'Z',
            paddingTop: 'A',
            borderTopWidth: '1px',
            borderTopStyle: 'solid',
            borderTopColor: 'line',
            ArpAllHead: {
                tag: 'span',
                fontSize: 'Y2',
                fontWeight: '700',
                color: 'caption',
                textTransform: 'uppercase',
                letterSpacing: '0.08em',
                text: 'All'
            },
            ArpAllGrid: {
                display: 'grid',
                gridTemplateColumns: 'repeat(8, 1fr)',
                gap: 'Z',
                childExtends: 'AddReactionEmoji',
                childrenAs: 'state',
                children: (el, s)=>$c35c136868dfb566$var$ALL_EMOJIS.map((e)=>({
                            emoji: e,
                            postId: s.id
                        }))
            }
        }
    }
};
const $c35c136868dfb566$export$9acb05c432b24cc1 = {
    tag: 'button',
    align: 'center center',
    width: 'C',
    height: 'C',
    round: 'B',
    background: 'transparent',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'transparent',
    fontSize: 'B',
    cursor: 'pointer',
    text: (el, s)=>s.emoji,
    ':hover': {
        background: 'overlay',
        borderColor: 'line'
    },
    onClick: (ev, el, s)=>{
        ev.preventDefault();
        ev.stopPropagation();
        $c35c136868dfb566$var$_toggleReaction(el, s, s.postId, s.emoji);
        document.querySelectorAll('[data-arp-popover]').forEach((p)=>{
            p.style.opacity = '0';
            p.style.pointerEvents = 'none';
        });
        document.querySelectorAll('article').forEach((c)=>{
            c.style.zIndex = '';
        });
    }
};
const $c35c136868dfb566$export$9bf24fc3bca1c6e = {
    extends: 'Modal',
    stateKey: 'selectedAnnouncement',
    Window: {
        extends: 'ModalWindow',
        maxWidth: '760px',
        width: '100%',
        maxHeight: '85vh',
        overflow: 'auto',
        AdmCover: {
            hide: (el, s)=>!s.root?.selectedAnnouncement?.cover,
            height: 'G',
            flexShrink: '0',
            background: (el, s)=>s.root?.selectedAnnouncement?.cover || 'linear-gradient(135deg, #0085FF 0%, #50E1FF 100%)',
            borderTopLeftRadius: 'C',
            borderTopRightRadius: 'C'
        },
        AdmBody: {
            flow: 'y',
            gap: 'B',
            padding: 'D',
            AdmTagPill: {
                tag: 'span',
                alignSelf: 'flex-start',
                padding: 'Y A',
                round: 'C',
                fontSize: 'Y2',
                fontWeight: '700',
                letterSpacing: '0.06em',
                textTransform: 'uppercase',
                color: 'blue',
                background: 'blue.2',
                text: (el, s)=>s.root?.selectedAnnouncement?.tag || ''
            },
            AdmTitle: {
                tag: 'h1',
                margin: '0',
                fontSize: 'E',
                fontWeight: '800',
                letterSpacing: '-0.025em',
                lineHeight: '1.1',
                color: 'title',
                text: (el, s)=>s.root?.selectedAnnouncement?.title || ''
            },
            AdmAuthor: {
                flow: 'x',
                align: 'center',
                gap: 'A',
                paddingBottom: 'B',
                borderBottomWidth: '1px',
                borderBottomStyle: 'solid',
                borderBottomColor: 'line',
                AdmAvatar: {
                    align: 'center center',
                    width: 'C',
                    height: 'C',
                    round: '50%',
                    color: 'white',
                    fontSize: 'Z2',
                    fontWeight: '700',
                    background: (el, s)=>(0, $chzVb.colorFromEmail)(s.root?.selectedAnnouncement?.author),
                    text: (el, s)=>s.root?.selectedAnnouncement?.authorAvatar || ''
                },
                AdmMeta: {
                    flow: 'y',
                    gap: 'Y',
                    flex: '1',
                    AdmAuthorName: {
                        tag: 'span',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'title',
                        text: (el, s)=>s.root?.selectedAnnouncement?.author || ''
                    },
                    AdmAuthorSub: {
                        tag: 'span',
                        fontSize: 'Z2',
                        color: 'caption',
                        text: (el, s)=>{
                            const a = s.root?.selectedAnnouncement;
                            if (!a) return '';
                            const parts = [];
                            if (a.authorRole) parts.push(a.authorRole);
                            if (a.date) try {
                                parts.push(new Date(a.date).toLocaleDateString('en', {
                                    month: 'short',
                                    day: 'numeric',
                                    year: 'numeric'
                                }));
                            } catch  {}
                            if (a.readTime) parts.push(a.readTime);
                            return parts.join(" \xb7 ");
                        }
                    }
                }
            },
            AdmExcerpt: {
                tag: 'p',
                margin: '0',
                fontSize: 'B',
                lineHeight: '1.55',
                color: 'paragraph',
                fontWeight: '500',
                text: (el, s)=>s.root?.selectedAnnouncement?.excerpt || ''
            },
            AdmContent: {
                flow: 'y',
                gap: 'A',
                childExtends: 'AdmParagraph',
                childrenAs: 'state',
                children: (el, s)=>{
                    const body = s.root?.selectedAnnouncement?.body;
                    if (!body) return [];
                    if (Array.isArray(body)) return body.map((p)=>({
                            text: p
                        }));
                    if (typeof body === 'string') return [
                        {
                            text: body
                        }
                    ];
                    return [];
                }
            }
        }
    }
};
const $c35c136868dfb566$export$e38ab6dfda165f43 = {
    tag: 'p',
    margin: '0',
    fontSize: 'A',
    lineHeight: '1.65',
    color: 'paragraph',
    text: (el, s)=>s.text || ''
};
const $c35c136868dfb566$export$30f83fb4ef98f83e = {
    tag: 'span',
    fontSize: 'A',
    color: (el, s)=>s.color || 'caption',
    fontWeight: (el, s)=>s.weight || '500',
    text: (el, s)=>s.text
};
const $c35c136868dfb566$export$5822eaed382932db = {
    display: 'flex',
    flexFlow: 'row',
    align: 'center',
    childExtends: 'AvatarBundleItem',
    childrenAs: 'state',
    children: (el, s)=>{
        let emails = el.emails || [];
        if (typeof emails === 'function') emails = emails(el, s) || [];
        const lookup = el.call('peopleByEmail');
        const out = [];
        for (const e of emails){
            const p = lookup[e];
            if (p) out.push(p);
            if (out.length === 3) break;
        }
        return out;
    }
};
const $c35c136868dfb566$export$c76390ffeae9f71c = {
    position: 'relative',
    zIndex: '1',
    marginInlineEnd: '-Z1',
    cursor: 'default',
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: 'overlay',
    round: '50%',
    Avatar: {
        avatarType: 'initials',
        boxSize: 'A1 A1',
        src: (el, s)=>el.call('avatarUrl', s && s.name || s && s.email)
    },
    onRender: (el, s)=>{
        if (!el.node) return;
        el.node.setAttribute('title', s.name || s.email || '');
        el.node.addEventListener('mouseenter', ()=>{
            el.node.style.zIndex = '50';
        });
        el.node.addEventListener('mouseleave', ()=>{
            el.node.style.zIndex = '';
        });
    }
};
const $c35c136868dfb566$var$_emailByName = (s, name)=>{
    if (!name) return null;
    const list = s && s.root && s.root.people || [];
    const lc = String(name).toLowerCase();
    for (const p of list){
        if ((p.name || '').toLowerCase() === lc) return p.email;
    }
    return null;
};
const $c35c136868dfb566$export$63066481d0925ed3 = {
    flow: 'x',
    align: 'center',
    gap: 'A',
    cursor: 'pointer',
    transition: 'transform 160ms ease',
    ':hover': {
        transform: 'translateY(-2px)'
    },
    onClick: (e, el, s)=>{
        e.preventDefault();
        const email = $c35c136868dfb566$var$_emailByName(s, s.name);
        if (email) s.root.update({
            profileEmail: email
        });
    },
    BdAvatar: {
        align: 'center center',
        width: 'C',
        height: 'C',
        round: '50%',
        color: 'white',
        fontSize: 'Z2',
        fontWeight: '700',
        background: (el, s)=>s.color || 'blue',
        text: (el, s)=>s.initials || '',
        onRender: (el, s)=>{
            if (el.node) el.node.setAttribute('title', s.name || '');
        }
    },
    BdName: {
        tag: 'span',
        fontSize: 'A',
        color: 'title',
        fontWeight: '600',
        text: (el, s)=>s.name
    }
};
const $c35c136868dfb566$export$e688e868b522f98c = {
    extends: 'Link',
    href: (el, s)=>`/calendar#event=${encodeURIComponent(s.id || '')}`,
    textDecoration: 'none',
    color: 'inherit',
    cursor: 'pointer',
    flow: 'x',
    align: 'center',
    gap: 'A',
    padding: 'Z A',
    round: 'C',
    background: 'overlay',
    border: 'none',
    transition: 'all 200ms ease',
    ':hover': {
        background: 'overlayStrong',
        transform: 'translateY(-2px)'
    },
    UeDate: {
        flow: 'y',
        align: 'center center',
        width: 'C',
        minWidth: 'C',
        padding: 'Z',
        round: 'C',
        background: 'blue.2',
        UeDay: {
            tag: 'span',
            fontSize: 'B',
            fontWeight: '800',
            color: 'title',
            lineHeight: '1',
            text: (el, s)=>{
                try {
                    return String(new Date(s.startAt).getDate());
                } catch  {
                    return '';
                }
            }
        },
        UeMonth: {
            tag: 'span',
            fontSize: 'Y2',
            fontWeight: '700',
            color: 'blue',
            textTransform: 'uppercase',
            text: (el, s)=>{
                try {
                    return new Date(s.startAt).toLocaleString('en', {
                        month: 'short'
                    });
                } catch  {
                    return '';
                }
            }
        }
    },
    UeBody: {
        flow: 'y',
        gap: 'Y',
        flex: '1',
        minWidth: '0',
        UeTitle: {
            tag: 'span',
            fontSize: 'A',
            fontWeight: '700',
            color: 'title',
            text: (el, s)=>s.title
        },
        UeMeta: {
            tag: 'span',
            fontSize: 'Z2',
            color: 'caption',
            text: (el, s)=>{
                let t = '';
                try {
                    t = new Date(s.startAt).toLocaleTimeString('en', {
                        hour: '2-digit',
                        minute: '2-digit'
                    });
                } catch  {}
                return `${t}${t && s.location ? " \xb7 " : ''}${s.location || ''}`;
            }
        }
    }
};
const $c35c136868dfb566$export$f81d5938d8ae44a = {
    extends: 'Link',
    href: '/people',
    textDecoration: 'none',
    color: 'inherit',
    flow: 'y',
    gap: 'Z1',
    minWidth: 'G',
    cursor: 'pointer',
    transition: 'transform 160ms ease',
    ':hover': {
        transform: 'translateY(-2px)'
    },
    CcStack: {
        extends: 'AvatarBundle',
        emails: (el, s)=>(s.members || []).map((m)=>m.email)
    },
    CcTime: {
        tag: 'span',
        fontSize: 'B',
        fontWeight: '700',
        color: 'title',
        text: (el, s)=>{
            try {
                return new Date().toLocaleTimeString('en-US', {
                    hour: 'numeric',
                    minute: '2-digit',
                    timeZone: s.timezone,
                    hour12: true
                }).toLowerCase().replace(' ', '');
            } catch  {
                return '';
            }
        }
    },
    CcCity: {
        tag: 'span',
        fontSize: 'A',
        color: 'caption',
        text: (el, s)=>s.city
    },
    CcDate: {
        tag: 'span',
        fontSize: 'Z2',
        color: 'caption',
        text: ()=>{
            return new Date().toLocaleDateString('en-US', {
                weekday: 'long',
                day: 'numeric',
                month: 'long'
            });
        }
    }
};

});

parcelRegister("415Fs", function(module, exports) {

$parcel$export(module.exports, "WysiwygToolbar", () => $2ecba6e469d1f99c$export$255a85f258b25a1b);
// Reusable WYSIWYG formatting toolbar for contenteditable editors.
// Uses document.execCommand for bold, italic, strike, underline, code, link, lists.
// Usage: WysiwygToolbar: {} — place near a contenteditable element.
// smbls 3.14.x — FA-L11 fix landed; top-level `title` + `aria: { label }`
// now reach the <button>. No more `attr: { ... }` wrapper needed for
// icon-only buttons.
const $2ecba6e469d1f99c$var$_btn = (icon, title, cmd)=>({
        extends: 'NavbarButton',
        padding: 'Y2',
        title: title,
        aria: {
            label: title
        },
        color: 'caption',
        ':hover': {
            color: 'title',
            background: 'overlay'
        },
        Icon: {
            icon: icon
        },
        onMouseDown: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            document.execCommand(cmd);
        },
        onClick: (e)=>e.preventDefault()
    });
const $2ecba6e469d1f99c$export$255a85f258b25a1b = {
    flow: 'x',
    gap: 'V',
    align: 'center left',
    Bold: $2ecba6e469d1f99c$var$_btn('bold', 'Bold', 'bold'),
    Italic: $2ecba6e469d1f99c$var$_btn('italic', 'Italic', 'italic'),
    Strike: $2ecba6e469d1f99c$var$_btn('strikethrough', 'Strikethrough', 'strikeThrough'),
    Underline: $2ecba6e469d1f99c$var$_btn('underline', 'Underline', 'underline'),
    Code: {
        extends: 'NavbarButton',
        padding: 'Y2',
        title: 'Code',
        aria: {
            label: 'Code'
        },
        color: 'caption',
        ':hover': {
            color: 'title',
            background: 'overlay'
        },
        Icon: {
            icon: 'code'
        },
        onMouseDown: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            const sel = window.getSelection();
            if (!sel || !sel.rangeCount || sel.isCollapsed) return;
            try {
                const code = document.createElement('code');
                code.style.cssText = 'font-family:monospace;background:rgba(255,255,255,0.08);padding:1px 4px;border-radius:3px';
                sel.getRangeAt(0).surroundContents(code);
                sel.collapseToEnd();
            } catch  {}
        },
        onClick: (e)=>e.preventDefault()
    },
    Link: {
        extends: 'NavbarButton',
        padding: 'Y2',
        title: 'Link',
        aria: {
            label: 'Link'
        },
        color: 'caption',
        ':hover': {
            color: 'title',
            background: 'overlay'
        },
        Icon: {
            icon: 'link'
        },
        onMouseDown: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            const sel = window.getSelection();
            const saved = sel?.rangeCount ? sel.getRangeAt(0).cloneRange() : null;
            const url = prompt('URL:');
            if (!url) return;
            if (saved) {
                sel.removeAllRanges();
                sel.addRange(saved);
            }
            document.execCommand('createLink', false, url);
        },
        onClick: (e)=>e.preventDefault()
    },
    Quote: $2ecba6e469d1f99c$var$_btn('quote', 'Blockquote', 'formatBlock'),
    BulletList: $2ecba6e469d1f99c$var$_btn('menu', 'Bullet list', 'insertUnorderedList'),
    NumberList: $2ecba6e469d1f99c$var$_btn('listOrdered', 'Numbered list', 'insertOrderedList'),
    Divider: $2ecba6e469d1f99c$var$_btn('minus', 'Divider', 'insertHorizontalRule')
};

});

parcelRegister("iGn5V", function(module, exports) {

$parcel$export(module.exports, "MemberProfile", () => $d99e1053ed981212$export$70752ed3eb71b053);
$parcel$export(module.exports, "MemberProfileCheckItem", () => $d99e1053ed981212$export$5e443b08c7b93dd6);
$parcel$export(module.exports, "ProfileGrantCard", () => $d99e1053ed981212$export$a73d92b4aa3052ce);
// MemberProfile — shared profile component used by /my and /profile pages.
// Reads from findMe(s) which resolves to the viewed person (via ?u= query
// or current user). Sections: Hero, Details, Equity, Documents, Checklist.
//
// Config via parent element props:
//   editable  — whether fields are editable (boolean fn or static)
//   showPrivate — whether equity/docs/checklist are visible
parcelRequire("chzVb");
var $bglB6 = parcelRequire("bglB6");
var $chzVb = parcelRequire("chzVb");

var $bfqVY = parcelRequire("bfqVY");

var $9CXFX = parcelRequire("9CXFX");

var $erP2O = parcelRequire("erP2O");

var $bdIjZ = parcelRequire("bdIjZ");

var $etEl1 = parcelRequire("etEl1");
// Map user_profiles column name → profiles column name. Columns absent
// from the map are user_profiles-only (financial) and are not mirrored.
// `department` and `group_name` used to live here; removed with §I10 —
// team membership is now Mongo-backed via `functions/teams.js`.
const $d99e1053ed981212$var$_HR_TO_PROFILES = {
    name: 'display_name',
    position: 'title',
    github: 'github_username',
    location: 'location',
    timezone: 'timezone',
    weekly_hours: 'weekly_target_hours',
    working_hours_start: 'working_hours_start',
    working_hours_end: 'working_hours_end'
};
// Translate a user_profiles patch to a profiles patch. Returns null if
// no HR fields touched (e.g., pure financial edits) — skip the mirror.
const $d99e1053ed981212$var$_toProfilesPatch = (patch)=>{
    const out = {};
    for (const [k, v] of Object.entries(patch)){
        const mapped = $d99e1053ed981212$var$_HR_TO_PROFILES[k];
        if (!mapped) continue;
        // profiles.weekly_target_hours is numeric; coerce.
        if (mapped === 'weekly_target_hours') {
            const n = Number(String(v ?? '').replace(/[^0-9.]/g, ''));
            out[mapped] = Number.isFinite(n) ? n : null;
        } else out[mapped] = v;
    }
    return Object.keys(out).length ? out : null;
};
const $d99e1053ed981212$var$_me = (0, $chzVb.findMe);
const $d99e1053ed981212$var$_numberFmt = new Intl.NumberFormat('en-US');
const $d99e1053ed981212$var$_fmt = (n)=>n == null ? "\u2014" : $d99e1053ed981212$var$_numberFmt.format(n);
const $d99e1053ed981212$var$_timezoneOptions = ()=>{
    try {
        const list = typeof Intl !== 'undefined' && Intl.supportedValuesOf ? Intl.supportedValuesOf('timeZone') : null;
        if (list && list.length) return list;
    } catch  {}
    return [
        'UTC',
        'Europe/London',
        'Europe/Paris',
        'Europe/Berlin',
        'Europe/Moscow',
        'Asia/Tbilisi',
        'Asia/Dubai',
        'Asia/Kolkata',
        'Asia/Shanghai',
        'Asia/Tokyo',
        'Australia/Sydney',
        'America/New_York',
        'America/Chicago',
        'America/Denver',
        'America/Los_Angeles',
        'America/Sao_Paulo'
    ];
};
const $d99e1053ed981212$var$_countryOptions = [
    'Georgia',
    'United States',
    'United Kingdom',
    'Germany',
    'France',
    'Spain',
    'Netherlands',
    'Sweden',
    'Norway',
    'Denmark',
    'Poland',
    'Ukraine',
    'Turkey',
    'UAE',
    'India',
    'China',
    'Japan',
    'Australia',
    'Brazil',
    'Canada',
    'Mexico',
    'Argentina',
    'Ireland',
    'Portugal',
    'Italy',
    'Greece',
    'Czech Republic',
    'Hungary',
    'Romania',
    'Bulgaria',
    'Estonia',
    'Latvia',
    'Lithuania'
];
// Legacy `location` field is a "City, CC" string. Extract country for the
// Country select; everything before the last comma becomes City.
const $d99e1053ed981212$var$_countryCodes = {
    GE: 'Georgia',
    US: 'United States',
    UK: 'United Kingdom',
    GB: 'United Kingdom',
    DE: 'Germany',
    FR: 'France',
    ES: 'Spain',
    NL: 'Netherlands',
    SE: 'Sweden',
    NO: 'Norway',
    DK: 'Denmark',
    PL: 'Poland',
    UA: 'Ukraine',
    TR: 'Turkey',
    AE: 'UAE',
    IN: 'India',
    CN: 'China',
    JP: 'Japan',
    AU: 'Australia',
    BR: 'Brazil',
    CA: 'Canada',
    MX: 'Mexico',
    AR: 'Argentina',
    IE: 'Ireland',
    PT: 'Portugal',
    IT: 'Italy',
    GR: 'Greece',
    CZ: 'Czech Republic',
    HU: 'Hungary',
    RO: 'Romania',
    BG: 'Bulgaria',
    EE: 'Estonia',
    LV: 'Latvia',
    LT: 'Lithuania'
};
const $d99e1053ed981212$var$_countryOf = (person)=>{
    if (person?.country) return person.country;
    const loc = person?.location || '';
    const parts = loc.split(',').map((s)=>s.trim()).filter(Boolean);
    const tail = parts[parts.length - 1] || '';
    if ($d99e1053ed981212$var$_countryCodes[tail.toUpperCase()]) return $d99e1053ed981212$var$_countryCodes[tail.toUpperCase()];
    if ($d99e1053ed981212$var$_countryOptions.includes(tail)) return tail;
    return '';
};
const $d99e1053ed981212$var$_cityOf = (person)=>{
    if (person?.city) return person.city;
    const loc = person?.location || '';
    const parts = loc.split(',').map((s)=>s.trim()).filter(Boolean);
    if (parts.length >= 2) return parts.slice(0, -1).join(', ');
    return '';
};
const $d99e1053ed981212$var$_tenure = (start)=>{
    if (!start) return "\u2014";
    const ms = Date.now() - new Date(start).getTime();
    const totalMonths = Math.floor(ms / 2630016000);
    const years = Math.floor(totalMonths / 12);
    const months = totalMonths % 12;
    if (years === 0) return `${months} month${months !== 1 ? 's' : ''}`;
    if (months === 0) return `${years} year${years !== 1 ? 's' : ''}`;
    return `${years} year${years !== 1 ? 's' : ''} and ${months} month${months !== 1 ? 's' : ''}`;
};
// Debounced Supabase write — per-field timers prevent cross-field cancellation
const $d99e1053ed981212$var$_patchTimers = {};
const $d99e1053ed981212$var$_patchUser = (s, patch)=>{
    const person = $d99e1053ed981212$var$_me(s);
    if (!person?.userId) return;
    const next = (s.root.people || []).map((p)=>p.userId === person.userId ? {
            ...p,
            ...patch
        } : p);
    s.root.update({
        people: next
    });
    const field = Object.keys(patch)[0];
    clearTimeout($d99e1053ed981212$var$_patchTimers[field]);
    $d99e1053ed981212$var$_patchTimers[field] = setTimeout(async ()=>{
        try {
            // Legacy write — user_profiles stays source of truth until the
            // profiles-overlay cutover completes.
            await (0, $bfqVY.getSDK)().execute('workspaceProject.userProfiles', 'update', {
                id: person.userId,
                payload: patch
            });
            // Dual-write to public.profiles when the overlay flag is on.
            // profiles is email-keyed; upsert so a first-time edit creates
            // the row if the backfill hadn't run (defensive).
            // TODO[sdk-profiles-mirror]: no SDK route for the public.profiles
            // overlay yet — leave a Supabase fallback once the route lands.
            if ((0, $bdIjZ.USE_PROFILES_OVERLAY) && person.email) {
                const mapped = $d99e1053ed981212$var$_toProfilesPatch(patch);
                if (mapped) try {
                    await (0, $bfqVY.getSDK)().execute('workspaceProject.userProfiles', 'update', {
                        id: person.userId,
                        payload: {
                            email: person.email,
                            ...mapped,
                            updated_at: new Date().toISOString()
                        }
                    });
                } catch (error) {
                    console.warn('[MemberProfile] profiles mirror failed', error?.message);
                }
            }
        } catch (e) {
            console.warn('patch failed', e);
        }
    }, 400);
};
// ── Grant CRUD helpers ─────────────────────────────────────────────
const $d99e1053ed981212$var$_grantSaveTimers = {};
const $d99e1053ed981212$var$_flushGrant = async (root, grantId)=>{
    const patch = $d99e1053ed981212$var$_pendingPatches[grantId];
    if (!patch || !Object.keys(patch).length) return;
    delete $d99e1053ed981212$var$_pendingPatches[grantId];
    root.update({
        _grantSaveStatus: {
            ...root._grantSaveStatus || {},
            [grantId]: 'saving'
        }
    });
    try {
        const { data: data } = await $9CXFX.updateGrant(grantId, patch);
        if (data) {
            const merged = (root.userGrants || []).map((g)=>g.id === grantId ? data : g);
            root.update({
                userGrants: merged
            });
        }
        root.update({
            _grantSaveStatus: {
                ...root._grantSaveStatus || {},
                [grantId]: 'saved'
            }
        });
        clearTimeout($d99e1053ed981212$var$_grantSaveTimers[grantId]);
        $d99e1053ed981212$var$_grantSaveTimers[grantId] = setTimeout(()=>{
            root.update({
                _grantSaveStatus: {
                    ...root._grantSaveStatus || {},
                    [grantId]: null
                }
            });
        }, 2000);
    } catch (e) {
        console.warn('[grant flush]', e);
        root.update({
            _grantSaveStatus: {
                ...root._grantSaveStatus || {},
                [grantId]: 'error'
            }
        });
    }
};
// Stage a change against root.userGrants (so inputs stay controlled) and
// record the pending patch against this grant id. NO auto-save here — the
// user must click the grant's Save button to flush. Status flips to
// 'dirty' so the Save button can highlight.
const $d99e1053ed981212$var$_pendingPatches = {};
const $d99e1053ed981212$var$_patchGrant = (root, grantId, patch)=>{
    const current = (root.userGrants || []).find((g)=>g.id === grantId);
    if (!current) return;
    const changed = Object.keys(patch).some((k)=>current[k] !== patch[k]);
    if (!changed) return;
    const next = (root.userGrants || []).map((g)=>g.id === grantId ? {
            ...g,
            ...patch
        } : g);
    $d99e1053ed981212$var$_pendingPatches[grantId] = {
        ...$d99e1053ed981212$var$_pendingPatches[grantId] || {},
        ...patch
    };
    root.update({
        userGrants: next,
        _grantSaveStatus: {
            ...root._grantSaveStatus || {},
            [grantId]: 'dirty'
        }
    });
};
const $d99e1053ed981212$var$_addGrant = async (root, userId)=>{
    const currentValuation = root.companySettings?.current_valuation || 12000000;
    // Sensible defaults so a freshly added grant already has every factor
    // populated and the computed shares/equity render immediately.
    const today = new Date();
    const oneYearOut = new Date(today);
    oneYearOut.setFullYear(oneYearOut.getFullYear() + 1);
    const iso = (d)=>d.toISOString().slice(0, 10);
    try {
        const { data: data } = await $9CXFX.insertGrant({
            user_id: userId,
            share_class: 'B',
            vesting_months: 12,
            vesting_start: iso(today),
            vesting_end: iso(oneYearOut),
            origin_valuation: currentValuation,
            status: 'active',
            weekly_hours: '40',
            label: `Grant ${(root.userGrants || []).filter((g)=>g.user_id === userId).length + 1}`
        });
        if (data) root.update({
            userGrants: [
                ...root.userGrants || [],
                data
            ]
        });
    } catch (e) {
        console.warn('[grant add]', e);
    }
};
// Investment record — investor stake calculated as (amount / valuation)
// × 10M pool. Stored as a grant row with `investment` set (the only
// field that flags this as an investment) and a real stock class the
// user can re-pick later (defaults to 'Preferred').
const $d99e1053ed981212$var$_addInvestment = async (root, userId)=>{
    const currentValuation = root.companySettings?.current_valuation || 12000000;
    const raw = window.prompt('Investment amount ($):', '50000');
    if (raw == null) return;
    const amount = Number(String(raw).replace(/[^0-9.]/g, ''));
    if (!amount || amount <= 0) return;
    const shares = Math.round(amount / currentValuation * 10000000);
    try {
        const { data: data } = await $9CXFX.insertGrant({
            user_id: userId,
            share_class: 'Preferred',
            investment: amount,
            origin_valuation: currentValuation,
            shares_manual: shares,
            status: 'active',
            label: `Investment ${(root.userGrants || []).filter((g)=>g.user_id === userId && g.investment != null).length + 1}`
        });
        if (data) root.update({
            userGrants: [
                ...root.userGrants || [],
                data
            ]
        });
    } catch (e) {
        console.warn('[investment add]', e);
    }
};
const $d99e1053ed981212$var$_deleteGrant = async (root, grantId)=>{
    try {
        await $9CXFX.deleteGrant(grantId);
        root.update({
            userGrants: (root.userGrants || []).filter((g)=>g.id !== grantId)
        });
        delete $d99e1053ed981212$var$_pendingPatches[grantId];
        clearTimeout($d99e1053ed981212$var$_grantSaveTimers[grantId]);
        delete $d99e1053ed981212$var$_grantSaveTimers[grantId];
    } catch (e) {
        console.warn('[grant delete]', e);
    }
};
// Sum of shares + vested across all of this user's grants + investments.
// Total `shares` includes everything the user owns (grants + investments).
// `vested` counts grants by their vested_shares; investments are fully
// owned at purchase, so their full share count counts toward vested.
const $d99e1053ed981212$var$_userShareTotals = (s)=>{
    const me = $d99e1053ed981212$var$_me(s);
    const grants = (s.root?.userGrants || []).filter((g)=>g.user_id === me.userId);
    return grants.reduce((a, g)=>{
        const shares = Number(g.shares) || 0;
        const vested = g.investment != null ? shares : Number(g.vested_shares) || 0;
        return {
            shares: a.shares + shares,
            vested: a.vested + vested
        };
    }, {
        shares: 0,
        vested: 0
    });
};
// 3-state status derivation: end date in the past → 'completed', status
// 'left' → 'ended', otherwise 'active'. Matches the cap-table pill logic.
const $d99e1053ed981212$var$_grantEffectiveStatus = (g)=>{
    const end = g.vesting_end ? new Date(g.vesting_end) : null;
    if (end && end < new Date()) return 'completed';
    if (g.status === 'left') return 'ended';
    return g.status || 'active';
};
// Contract value = salary_monthly × months(start, end)
const $d99e1053ed981212$var$_contractValue = (g)=>{
    if (!g?.salary_monthly || !g?.vesting_start || !g?.vesting_end) return 0;
    const months = (new Date(g.vesting_end) - new Date(g.vesting_start)) / 2629800000;
    return Math.round((Number(g.salary_monthly) || 0) * months);
};
// Derive hourly rate from salary_monthly / (weekly_hours × 4.33). Returns
// null when either is missing. Used to backfill the Hourly input when the
// DB has monthly + hours but no explicit hourly.
const $d99e1053ed981212$var$_deriveHourly = (g)=>{
    const mo = Number(g?.salary_monthly) || 0;
    const wh = Number(String(g?.weekly_hours || '').replace(/[^0-9.]/g, '')) || 0;
    if (!mo || !wh) return null;
    return Math.round(mo / (wh * 4.33) * 100) / 100;
};
// Derive monthly from hourly × weekly_hours × 4.33. Returns null when
// either is missing. Used to backfill the Monthly input when the DB has
// hourly + hours but no explicit monthly.
const $d99e1053ed981212$var$_deriveMonthly = (g)=>{
    const hr = Number(g?.hourly_rate) || 0;
    const wh = Number(String(g?.weekly_hours || '').replace(/[^0-9.]/g, '')) || 0;
    if (!hr || !wh) return null;
    return Math.round(hr * wh * 4.33);
};
// DOMQL's reactive update cycle briefly detaches and re-attaches input
// elements, which blurs them. Inputs that dispatch _patchGrant on every
// keystroke therefore lose focus after each character. This helper
// re-focuses the same node (and restores caret where possible) after
// the update settles, so typing feels uninterrupted.
//
// We retry across several microtasks + rAF frames because DOMQL may
// run multiple render passes for a single state update, each one
// potentially detaching the element — a single setTimeout(0) only
// catches the first blur.
const $d99e1053ed981212$var$_keepFocus = (target)=>{
    if (!target) return;
    const supportsSel = target.type === 'text' || target.type === 'search' || target.tagName === 'TEXTAREA';
    const selStart = supportsSel ? target.selectionStart : null;
    let attempts = 0;
    const refocus = ()=>{
        if (!document.body.contains(target)) return;
        if (document.activeElement !== target) {
            target.focus();
            if (selStart != null) try {
                target.setSelectionRange(selStart, selStart);
            } catch  {}
        }
        if (attempts++ < 6) setTimeout(refocus, 20);
    };
    // Fire on microtask + next frame so we catch the earliest possible
    // re-attach point.
    Promise.resolve().then(refocus);
    requestAnimationFrame(refocus);
};
// Row builder — label/value with optional inline editing
const $d99e1053ed981212$var$_row = (label, valueFn, opts = {})=>({
        flow: 'x',
        align: 'center space-between',
        gap: 'B',
        padding: 'B 0',
        borderBottomWidth: '1px',
        borderBottomStyle: 'solid',
        borderBottomColor: 'line',
        hide: opts.hide || null,
        RowLabel: opts.hint ? {
            flow: 'y',
            gap: 'Y',
            LabelText: {
                tag: 'span',
                fontSize: 'A',
                fontWeight: '600',
                color: 'title',
                text: label
            },
            Hint: {
                tag: 'span',
                fontSize: 'Z2',
                color: 'caption',
                text: opts.hint
            }
        } : {
            tag: 'span',
            fontSize: 'A',
            color: 'caption',
            text: label
        },
        // Editable rows render two views side-by-side: a static span shown when
        // not in edit mode, and an input/select shown when editing.
        RowValue: opts.editable ? {
            flow: 'x',
            align: 'center right',
            ReadView: {
                hide: (el, s)=>!!s.root?._profileEditing && el.call('canEditProfile', $d99e1053ed981212$var$_me(s)),
                tag: 'span',
                fontSize: 'A',
                fontWeight: '700',
                color: opts.accent || 'title',
                text: valueFn
            },
            EditView: opts.options ? {
                hide: (el, s)=>!s.root?._profileEditing || !el.call('canEditProfile', $d99e1053ed981212$var$_me(s)),
                tag: 'select',
                fontSize: 'A',
                fontWeight: '700',
                color: opts.accent || 'title',
                background: 'overlayStrong',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: 'line',
                round: 'Y',
                padding: 'V Z',
                cursor: 'pointer',
                width: 'F',
                ':focus': {
                    borderColor: 'blue',
                    outline: 'none'
                },
                value: (el, s)=>{
                    const v = valueFn(el, s);
                    return v === "\u2014" ? '' : v || '';
                },
                onCreate: (el, s)=>{
                    const v = valueFn(el, s);
                    if (el.node) el.node.value = v === "\u2014" ? '' : v || '';
                },
                childExtends: {
                    tag: 'option',
                    text: (el, s)=>s.text || s.value || ''
                },
                childrenAs: 'state',
                children: (el, s)=>{
                    const list = typeof opts.options === 'function' ? opts.options() : opts.options;
                    return [
                        {
                            value: '',
                            text: "\u2014 none \u2014"
                        },
                        ...list.map((v)=>({
                                value: v,
                                text: v
                            }))
                    ];
                },
                onChange: (e, el, s)=>{
                    if (opts.field) $d99e1053ed981212$var$_patchUser(s, {
                        [opts.field]: e.target.value || null
                    });
                }
            } : {
                hide: (el, s)=>!s.root?._profileEditing || !el.call('canEditProfile', $d99e1053ed981212$var$_me(s)),
                tag: 'input',
                type: opts.type || 'text',
                fontSize: 'A',
                fontWeight: '700',
                color: opts.accent || 'title',
                background: 'overlayStrong',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: 'line',
                round: 'Y',
                textAlign: 'right',
                padding: 'V Z',
                width: 'F',
                placeholder: opts.placeholder || '',
                ':focus': {
                    borderColor: 'blue',
                    outline: 'none'
                },
                value: opts.editValueFn || valueFn,
                onInput: (e, el, s)=>{
                    if (!opts.field) return;
                    const parsed = opts.parse ? opts.parse(e.target.value) : e.target.value;
                    $d99e1053ed981212$var$_patchUser(s, {
                        [opts.field]: parsed
                    });
                }
            }
        } : {
            tag: 'span',
            fontSize: 'A',
            fontWeight: '700',
            color: opts.accent || 'title',
            text: valueFn
        }
    });
// Card wrapper shorthand
const $d99e1053ed981212$var$_card = (content)=>({
        flow: 'y',
        padding: 'C',
        round: 'C',
        background: 'overlay',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'line',
        ...content
    });
const $d99e1053ed981212$export$70752ed3eb71b053 = {
    flow: 'y',
    gap: 'D',
    ProfileHero: $d99e1053ed981212$var$_card({
        attr: {
            'data-content-section': 'Profile'
        },
        flow: 'x',
        align: 'center',
        gap: 'C',
        padding: 'C',
        HeroAvatar: {
            align: 'center center',
            boxSize: 'D2',
            round: '50%',
            color: 'white',
            fontSize: 'C',
            fontWeight: '800',
            background: 'blue',
            text: (el, s)=>$d99e1053ed981212$var$_me(s).avatar || ''
        },
        HeroInfo: {
            flow: 'y',
            gap: 'Y',
            flex: '1',
            HeroName: {
                tag: 'h2',
                fontSize: 'D',
                fontWeight: '800',
                color: 'title',
                letterSpacing: '-0.02em',
                text: (el, s)=>$d99e1053ed981212$var$_me(s).name || 'Unknown'
            },
            HeroPosition: {
                tag: 'span',
                fontSize: 'A',
                color: 'paragraph',
                text: (el, s)=>$d99e1053ed981212$var$_me(s).position || ''
            },
            HeroEmail: {
                tag: 'span',
                fontSize: 'Z2',
                color: 'caption',
                text: (el, s)=>$d99e1053ed981212$var$_me(s).email || s.root.currentUserEmail || ''
            }
        },
        HeroActions: {
            hide: (el, s)=>!el.call('canEditProfile', $d99e1053ed981212$var$_me(s)),
            flow: 'x',
            gap: 'Z',
            align: 'center right',
            EditBtn: {
                hide: (el, s)=>!!s.root?._profileEditing,
                tag: 'button',
                type: 'button',
                padding: 'Z A1',
                round: 'Z',
                border: 'none',
                cursor: 'pointer',
                fontSize: 'Z2',
                fontWeight: '600',
                background: 'overlayStrong',
                color: 'title',
                ':hover': {
                    background: 'blue',
                    color: 'white'
                },
                text: 'Edit',
                onClick: (e, el, s)=>s.root.update({
                        _profileEditing: true
                    })
            },
            CancelBtn: {
                hide: (el, s)=>!s.root?._profileEditing,
                tag: 'button',
                type: 'button',
                padding: 'Z A1',
                round: 'Z',
                border: 'none',
                cursor: 'pointer',
                fontSize: 'Z2',
                fontWeight: '600',
                background: 'transparent',
                color: 'caption',
                ':hover': {
                    color: 'title'
                },
                text: 'Done',
                onClick: (e, el, s)=>s.root.update({
                        _profileEditing: false
                    })
            },
            SaveBtn: {
                hide: (el, s)=>!s.root?._profileEditing,
                tag: 'button',
                type: 'button',
                padding: 'Z A1',
                round: 'Z',
                border: 'none',
                cursor: 'pointer',
                fontSize: 'Z2',
                fontWeight: '700',
                background: 'blue',
                color: 'white',
                ':hover': {
                    opacity: '.9'
                },
                text: 'Save',
                onClick: (e, el, s)=>s.root.update({
                        _profileEditing: false
                    })
            }
        }
    }),
    ProfileDetails: $d99e1053ed981212$var$_card({
        FullName: $d99e1053ed981212$var$_row('Full name', (el, s)=>$d99e1053ed981212$var$_me(s).name || "\u2014", {
            editable: true,
            field: 'name',
            placeholder: 'Your name'
        }),
        Position: $d99e1053ed981212$var$_row('Position', (el, s)=>$d99e1053ed981212$var$_me(s).position || "\u2014", {
            editable: true,
            field: 'position',
            placeholder: 'e.g. Frontend Engineer'
        }),
        // Team picker — reads from `root.teamsByEmail` (Mongo-sourced via
        // `functions/teams.js`). Writes go through SDK (add/remove Team
        // members). No user_profiles text fallback — legacy columns dropped.
        Team: {
            flow: 'x',
            align: 'center space-between',
            gap: 'B',
            padding: 'B 0',
            borderBottomWidth: '1px',
            borderBottomStyle: 'solid',
            borderBottomColor: 'line',
            RowLabel: {
                tag: 'span',
                fontSize: 'A',
                color: 'caption',
                text: 'Team'
            },
            RowValue: {
                flow: 'x',
                align: 'center right',
                gap: 'Z',
                ReadView: {
                    hide: (el, s)=>!!s.root?._profileEditing && el.call('canEditProfile', $d99e1053ed981212$var$_me(s)),
                    tag: 'span',
                    fontSize: 'A',
                    fontWeight: '700',
                    color: 'title',
                    text: (el, s)=>$erP2O.primaryTeamName($d99e1053ed981212$var$_me(s)?.email, s.root) || "\u2014"
                },
                EditSelect: {
                    hide: (el, s)=>!s.root?._profileEditing || !el.call('canEditProfile', $d99e1053ed981212$var$_me(s)),
                    tag: 'select',
                    fontSize: 'A',
                    fontWeight: '700',
                    color: 'title',
                    background: 'overlayStrong',
                    borderWidth: '1px',
                    borderStyle: 'solid',
                    borderColor: 'line',
                    round: 'Y',
                    padding: 'V Z',
                    cursor: 'pointer',
                    minWidth: 'F',
                    ':focus': {
                        borderColor: 'blue',
                        outline: 'none'
                    },
                    onCreate: (el, s)=>{
                        const current = $erP2O.primaryTeamName($d99e1053ed981212$var$_me(s)?.email, s.root) || '';
                        if (el.node) el.node.value = current;
                    },
                    childExtends: {
                        tag: 'option',
                        value: (el, s)=>s.value,
                        text: (el, s)=>s.text
                    },
                    childrenAs: 'state',
                    children: (el, s)=>{
                        const orgId = s.root?.jwtClaims?.workspace_org_id || (s.root?.jwtClaims?.orgs || [])[0]?.id;
                        const list = $erP2O.teamsInOrg(orgId, s.root);
                        return [
                            {
                                value: '',
                                text: "\u2014 none \u2014"
                            },
                            ...list.map((t)=>({
                                    value: t.name,
                                    text: t.name
                                })),
                            {
                                value: '__create__',
                                text: "+ Create team\u2026"
                            }
                        ];
                    },
                    onChange: async (e, el, s)=>{
                        const me = $d99e1053ed981212$var$_me(s);
                        if (!me?.userId || !me?.email) return;
                        const root = s.root;
                        const orgId = root?.jwtClaims?.workspace_org_id || (root?.jwtClaims?.orgs || [])[0]?.id;
                        if (!orgId) return;
                        const value = e.target.value;
                        const current = (root.teamsByEmail?.[me.email.toLowerCase()] || [])[0];
                        try {
                            if (value === '__create__') {
                                const name = typeof window !== 'undefined' ? window.prompt('New team name') : null;
                                if (!name) {
                                    if (el.node) el.node.value = current?.name || '';
                                    return;
                                }
                                const team = await $erP2O.createTeam(root, {
                                    orgId: orgId,
                                    name: name.trim()
                                });
                                if (current && current.orgId === orgId) await $erP2O.removeMemberFromTeam(root, {
                                    orgId: orgId,
                                    teamId: current.id,
                                    userId: me.userId,
                                    email: me.email
                                });
                                await $erP2O.addMemberToTeam(root, {
                                    orgId: orgId,
                                    teamId: team.id,
                                    userId: me.userId,
                                    email: me.email
                                });
                                if (el.node) el.node.value = team.name;
                                return;
                            }
                            if (current && current.orgId === orgId) await $erP2O.removeMemberFromTeam(root, {
                                orgId: orgId,
                                teamId: current.id,
                                userId: me.userId,
                                email: me.email
                            });
                            if (value) {
                                const target = $erP2O.teamsInOrg(orgId, root).find((t)=>t.name === value);
                                if (target) await $erP2O.addMemberToTeam(root, {
                                    orgId: orgId,
                                    teamId: target.id,
                                    userId: me.userId,
                                    email: me.email
                                });
                            }
                        } catch (err) {
                            console.warn('[MemberProfile] team update failed', err);
                            if (el.node) el.node.value = current?.name || '';
                        }
                    }
                }
            }
        },
        Country: $d99e1053ed981212$var$_row('Country', (el, s)=>$d99e1053ed981212$var$_countryOf($d99e1053ed981212$var$_me(s)) || "\u2014", {
            editable: true,
            field: 'country',
            options: $d99e1053ed981212$var$_countryOptions
        }),
        City: $d99e1053ed981212$var$_row('City', (el, s)=>$d99e1053ed981212$var$_cityOf($d99e1053ed981212$var$_me(s)) || "\u2014", {
            editable: true,
            field: 'city',
            placeholder: 'City'
        }),
        Timezone: $d99e1053ed981212$var$_row('Timezone', (el, s)=>$d99e1053ed981212$var$_me(s).timezone || "\u2014", {
            editable: true,
            field: 'timezone',
            options: $d99e1053ed981212$var$_timezoneOptions
        }),
        GitHub: $d99e1053ed981212$var$_row('GitHub', (el, s)=>$d99e1053ed981212$var$_me(s).github || "\u2014", {
            editable: true,
            field: 'github',
            placeholder: 'username'
        }),
        Tenure: $d99e1053ed981212$var$_row('Tenure', (el, s)=>$d99e1053ed981212$var$_tenure($d99e1053ed981212$var$_me(s).startDate)),
        Role: $d99e1053ed981212$var$_row('Role', (el, s)=>{
            // CU-10 §90: roles no longer on person. Look up from root.roles.byUser.
            const me = $d99e1053ed981212$var$_me(s);
            const userId = me?.userId;
            const byUser = s.root?.roles?.byUser || {};
            const role = userId && byUser[userId] || me?.roles?.[0] || 'member';
            return role;
        }, {
            hide: (el)=>!el.call('isSuperAdmin')
        })
    }),
    ProfileAvailability: {
        ...$d99e1053ed981212$var$_card({}),
        attr: {
            'data-content-section': 'Availability'
        },
        // Availability only applies to people currently on the team
        hide: (el, s)=>{
            const me = $d99e1053ed981212$var$_me(s);
            if (!me?.email) return true;
            if (me.status === 'left') return true;
            // CU-10 §90: role from root.roles.byUser or legacy me.roles fallback
            const coreRoles = new Set([
                'superadmin',
                'admin',
                'manager',
                'member'
            ]);
            const byUser = s.root?.roles?.byUser || {};
            const legacyRoles = Array.isArray(me.roles) && me.roles.length > 0 ? me.roles : null;
            if (legacyRoles) return !legacyRoles.some((r)=>coreRoles.has(r));
            const assignedRole = me.userId && byUser[me.userId] || 'member';
            return !coreRoles.has(assignedRole);
        },
        gap: 'Z',
        AvailHeader: {
            flow: 'x',
            align: 'center space-between',
            AvailTitle: {
                tag: 'span',
                text: 'Availability',
                fontSize: 'Z2',
                fontWeight: '600',
                color: 'subtitle'
            },
            AvailHint: {
                tag: 'span',
                fontSize: 'Y2',
                color: 'caption',
                text: (el, s)=>{
                    if (!s.root?.currentUserEmail) return 'Read only';
                    // CU-10 §90: use canAdmin() — unions JWT perm + legacy byUser role.
                    const admin = (0, $bglB6.canAdmin)(s);
                    return admin ? 'Click to toggle (admin)' : 'Read only';
                }
            }
        },
        ProfileAvailabilityGrid: {}
    },
    ProfileEquity: {
        ...$d99e1053ed981212$var$_card({}),
        attr: {
            'data-content-section': 'Equity grant'
        },
        hide: (el, s)=>!el.call('canAccessPrivate', $d99e1053ed981212$var$_me(s)),
        gap: 'C',
        position: 'relative',
        overflow: 'hidden',
        EqGlow: {
            position: 'absolute',
            top: '-50%',
            right: '-10%',
            width: '420px',
            height: '420px',
            round: '50%',
            background: 'green',
            opacity: '0.12',
            filter: 'blur(80px)'
        },
        EqHead: {
            flow: 'y',
            gap: 'Z',
            EqEyebrow: {
                tag: 'span',
                fontSize: 'Z2',
                fontWeight: '700',
                letterSpacing: '0.12em',
                textTransform: 'uppercase',
                color: 'green',
                text: 'Equity grant'
            },
            EqTitle: {
                tag: 'h2',
                fontSize: 'C',
                fontWeight: '800',
                color: 'title',
                letterSpacing: '-0.02em',
                text: 'Stocks'
            }
        },
        EqBig: {
            flow: 'x',
            align: 'baseline',
            gap: 'A',
            EqVal: {
                tag: 'span',
                fontSize: 'F',
                fontWeight: '800',
                color: 'title',
                letterSpacing: '-0.04em',
                lineHeight: '1',
                text: (el, s)=>$d99e1053ed981212$var$_fmt($d99e1053ed981212$var$_userShareTotals(s).shares)
            },
            EqUnit: {
                tag: 'span',
                fontSize: 'A',
                color: 'caption',
                fontWeight: '600',
                text: 'shares granted'
            }
        },
        VestingBar: {
            flow: 'y',
            gap: 'Y',
            padding: 'Z 0',
            BarLabel: {
                flow: 'x',
                align: 'center space-between',
                VestLabel: {
                    tag: 'span',
                    fontSize: 'Z2',
                    color: 'caption',
                    text: (el, s)=>{
                        const t = $d99e1053ed981212$var$_userShareTotals(s);
                        if (!t.shares) return 'No vesting data';
                        const pct = Math.min(100, Math.round(t.vested / t.shares * 100));
                        return `${pct}% vested`;
                    }
                },
                VestRemain: {
                    tag: 'span',
                    fontSize: 'Z2',
                    color: 'caption',
                    text: (el, s)=>{
                        const t = $d99e1053ed981212$var$_userShareTotals(s);
                        const remaining = Math.max(0, t.shares - t.vested);
                        return remaining > 0 ? `${$d99e1053ed981212$var$_fmt(remaining)} remaining` : 'Fully vested';
                    }
                }
            },
            BarTrack: {
                height: 'Y',
                round: 'Y',
                background: 'line',
                overflow: 'hidden',
                BarFill: {
                    height: '100%',
                    round: 'Y',
                    background: 'green',
                    width: (el, s)=>{
                        const t = $d99e1053ed981212$var$_userShareTotals(s);
                        if (!t.shares) return '0%';
                        return `${Math.min(100, Math.round(t.vested / t.shares * 100))}%`;
                    }
                }
            }
        },
        // Column headers — one line identifying what each column of the rows below means.
        GrantsHeader: {
            display: 'grid',
            gridTemplateColumns: '1.4fr 0.8fr 1.6fr 1fr 0.8fr 1fr',
            gap: 'Z',
            padding: 'Z 0',
            borderBottomWidth: '1px',
            borderBottomStyle: 'solid',
            borderBottomColor: 'line',
            H00_Label: {
                fontSize: 'Y1',
                fontWeight: '700',
                letterSpacing: '.04em',
                textTransform: 'uppercase',
                color: 'caption',
                text: 'Grant'
            },
            H01_Class: {
                fontSize: 'Y1',
                fontWeight: '700',
                letterSpacing: '.04em',
                textTransform: 'uppercase',
                color: 'caption',
                text: 'Class'
            },
            H02_Period: {
                fontSize: 'Y1',
                fontWeight: '700',
                letterSpacing: '.04em',
                textTransform: 'uppercase',
                color: 'caption',
                text: 'Period'
            },
            H03_Shares: {
                fontSize: 'Y1',
                fontWeight: '700',
                letterSpacing: '.04em',
                textTransform: 'uppercase',
                color: 'caption',
                textAlign: 'right',
                text: 'Shares'
            },
            H04_Equity: {
                fontSize: 'Y1',
                fontWeight: '700',
                letterSpacing: '.04em',
                textTransform: 'uppercase',
                color: 'caption',
                textAlign: 'right',
                text: 'Equity'
            },
            H05_Value: {
                fontSize: 'Y1',
                fontWeight: '700',
                letterSpacing: '.04em',
                textTransform: 'uppercase',
                color: 'caption',
                textAlign: 'right',
                text: 'Value'
            }
        },
        // One row per grant (including share_class='investor' records).
        // Row renders shares, equity %, and — for investments — origin valuation
        // & amount. Uses `childrenAs: 'state'` so each row's state = the grant.
        GrantsRows: {
            flow: 'y',
            childrenAs: 'state',
            children: (el, s)=>{
                const me = $d99e1053ed981212$var$_me(s);
                return (s.root?.userGrants || []).filter((g)=>g.user_id === me.userId).slice().sort((a, b)=>(b.shares || 0) - (a.shares || 0));
            },
            childExtends: {
                display: 'grid',
                gridTemplateColumns: '1.4fr 0.8fr 1.6fr 1fr 0.8fr 1fr',
                gap: 'Z',
                padding: 'Z 0',
                borderBottomWidth: '1px',
                borderBottomStyle: 'solid',
                borderBottomColor: 'line',
                C00_Label: {
                    flow: 'y',
                    gap: 'V',
                    Name: {
                        tag: 'span',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'title',
                        text: (el, s)=>s.label || (s.investment != null ? 'Investment' : 'Grant')
                    },
                    Sub: {
                        tag: 'span',
                        fontSize: 'Y2',
                        color: 'caption',
                        text: (el, s)=>{
                            if (s.investment != null) return `$${$d99e1053ed981212$var$_fmt(s.investment)} invested`;
                            if (s.salary_monthly) return `$${$d99e1053ed981212$var$_fmt(Math.round(s.salary_monthly))}/mo`;
                            return '';
                        }
                    }
                },
                C01_Class: {
                    tag: 'span',
                    fontSize: 'Z2',
                    fontWeight: '700',
                    color: (el, s)=>{
                        const cls = (s.share_class || '').toLowerCase();
                        if (cls === 'a') return 'green';
                        if (cls === 'b') return 'blue';
                        if (cls === 'c') return 'orange';
                        if (cls === 'preferred') return 'purple';
                        if (cls === 'common') return 'subtitle';
                        return 'subtitle';
                    },
                    textTransform: 'uppercase',
                    text: (el, s)=>s.share_class || "\u2014"
                },
                C02_Period: {
                    flow: 'y',
                    gap: 'V',
                    Range: {
                        tag: 'span',
                        fontSize: 'Z2',
                        color: 'title',
                        text: (el, s)=>{
                            if (s.investment != null) return s.origin_valuation ? `@ $${$d99e1053ed981212$var$_fmt(s.origin_valuation)}` : "\u2014";
                            const a = s.vesting_start || "\u2014";
                            const b = s.vesting_end || "\u2014";
                            return `${a} \u{2192} ${b}`;
                        }
                    },
                    Status: {
                        tag: 'span',
                        fontSize: 'Y2',
                        color: (el, s)=>{
                            if (s.investment != null) return 'caption';
                            const st = $d99e1053ed981212$var$_grantEffectiveStatus(s);
                            if (st === 'active') return 'green';
                            if (st === 'completed') return 'blue';
                            return 'caption';
                        },
                        fontWeight: '600',
                        // Investments are paid-up at purchase — no status timeline.
                        text: (el, s)=>s.investment != null ? '' : $d99e1053ed981212$var$_grantEffectiveStatus(s)
                    }
                },
                C03_Shares: {
                    tag: 'span',
                    fontSize: 'A',
                    fontWeight: '700',
                    color: 'title',
                    textAlign: 'right',
                    text: (el, s)=>$d99e1053ed981212$var$_fmt(s.shares)
                },
                C04_Equity: {
                    tag: 'span',
                    fontSize: 'A',
                    fontWeight: '700',
                    color: 'blue',
                    textAlign: 'right',
                    text: (el, s)=>s.shares ? `${(s.shares / 10000000 * 100).toFixed(2)}%` : "\u2014"
                },
                C05_Value: {
                    flow: 'y',
                    gap: 'V',
                    ValMain: {
                        tag: 'span',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'title',
                        textAlign: 'right',
                        text: (el, s)=>{
                            const v = s.root?.companySettings?.current_valuation;
                            if (!v || !s.shares) return "\u2014";
                            return `$${$d99e1053ed981212$var$_fmt(Math.round(s.shares / 10000000 * v))}`;
                        }
                    },
                    ValVested: {
                        tag: 'span',
                        fontSize: 'Y2',
                        color: 'caption',
                        textAlign: 'right',
                        // Investments are fully owned at purchase — no vesting figure.
                        text: (el, s)=>s.investment != null ? '' : `${$d99e1053ed981212$var$_fmt(s.vested_shares || 0)} vested`
                    }
                }
            }
        },
        // No grants placeholder — shown only when the user has no records yet.
        GrantsEmpty: {
            hide: (el, s)=>{
                const me = $d99e1053ed981212$var$_me(s);
                return (s.root?.userGrants || []).some((g)=>g.user_id === me.userId);
            },
            tag: 'span',
            padding: 'B 0',
            fontSize: 'Z2',
            color: 'caption',
            text: 'No grants or investments yet.'
        },
        // Aggregate totals — valuation + % of company across all of user's grants.
        EqTotals: {
            flow: 'y',
            padding: 'A 0 0 0',
            EqCurrentValuation: $d99e1053ed981212$var$_row('Current valuation', (el, s)=>{
                const v = s.root?.companySettings?.current_valuation;
                return v ? `$${$d99e1053ed981212$var$_fmt(v)}` : "\u2014";
            }, {
                accent: 'blue'
            }),
            EqEquityPct: $d99e1053ed981212$var$_row('% of company', (el, s)=>{
                const shares = $d99e1053ed981212$var$_userShareTotals(s).shares;
                if (!shares) return "\u2014";
                return `${(shares / 10000000 * 100).toFixed(4)}%`;
            }, {
                accent: 'blue'
            }),
            EqInvestedTotal: $d99e1053ed981212$var$_row('Total invested', (el, s)=>{
                const me = $d99e1053ed981212$var$_me(s);
                const total = (s.root?.userGrants || []).filter((g)=>g.user_id === me.userId).reduce((a, g)=>a + (Number(g.investment) || 0), 0);
                return total > 0 ? `$${$d99e1053ed981212$var$_fmt(total)}` : "\u2014";
            }, {
                accent: 'purple',
                hide: (el, s)=>{
                    const me = $d99e1053ed981212$var$_me(s);
                    return !(s.root?.userGrants || []).some((g)=>g.user_id === me.userId && g.investment);
                }
            }),
            EqMonthlyStock: $d99e1053ed981212$var$_row('Monthly stock earnings', (el, s)=>{
                const me = $d99e1053ed981212$var$_me(s);
                const grants = (s.root?.userGrants || []).filter((g)=>g.user_id === me.userId && g.share_class !== 'investor');
                const perMo = grants.reduce((a, g)=>{
                    if (!g.vesting_start || !g.vesting_end || !g.shares) return a;
                    const months = (new Date(g.vesting_end) - new Date(g.vesting_start)) / 2629800000;
                    return a + (months > 0 ? g.shares / months : 0);
                }, 0);
                return perMo > 0 ? `${$d99e1053ed981212$var$_fmt(Math.round(perMo))}/mo` : "\u2014";
            }, {
                accent: 'green',
                hide: (el, s)=>{
                    const me = $d99e1053ed981212$var$_me(s);
                    return !(s.root?.userGrants || []).some((g)=>g.user_id === me.userId && g.share_class !== 'investor');
                }
            }),
            EqMonthlySalary: $d99e1053ed981212$var$_row('Monthly salary', (el, s)=>{
                const me = $d99e1053ed981212$var$_me(s);
                const total = (s.root?.userGrants || []).filter((g)=>g.user_id === me.userId).reduce((a, g)=>a + (Number(g.salary_monthly) || 0), 0);
                return total > 0 ? `$${$d99e1053ed981212$var$_fmt(Math.round(total))}` : "\u2014";
            }, {
                hide: (el, s)=>{
                    const me = $d99e1053ed981212$var$_me(s);
                    return !(s.root?.userGrants || []).some((g)=>g.user_id === me.userId && g.salary_monthly);
                }
            })
        }
    },
    // ── Grants editor — 4 key factors per grant, multi-grant support ──
    // Only visible in edit mode; profile view stays clean.
    ProfileGrants: {
        ...$d99e1053ed981212$var$_card({}),
        attr: {
            'data-content-section': 'Grants'
        },
        hide: (el, s)=>!s.root?._profileEditing || !el.call('canEditProfile', $d99e1053ed981212$var$_me(s)),
        gap: 'B',
        GrantsHead: {
            flow: 'x',
            align: 'baseline space-between',
            gap: 'A',
            Title: {
                tag: 'h3',
                margin: '0',
                fontSize: 'B',
                fontWeight: '800',
                color: 'title',
                text: 'Equity grants'
            },
            Subtitle: {
                tag: 'span',
                fontSize: 'Z2',
                color: 'caption',
                text: "Start, End, Origin valuation, and Monthly salary \u2014 shares + equity % compute automatically."
            }
        },
        GrantsList: {
            flow: 'y',
            gap: 'B',
            childExtends: 'ProfileGrantCard',
            childrenAs: 'state',
            // Stable `key` per grant so DOMQL reconciles children by id instead
            // of rebuilding the whole card tree on every keystroke. Because
            // childrenAs='state' wraps each array item into `{ state: item }`,
            // a `key` sitting on the item itself never bubbles up to the
            // top-level child definition — so we route it through childProps,
            // which is merged at the top level before the reconciler reads
            // `childDef.key`.
            childProps: (el, grant)=>({
                    key: grant?.id || 'none'
                }),
            children: (el, s)=>{
                const me = $d99e1053ed981212$var$_me(s);
                return (s.root?.userGrants || []).filter((g)=>g.user_id === me.userId);
            }
        },
        AddButtons: {
            flow: 'x',
            gap: 'Z',
            align: 'center left',
            AddGrantBtn: {
                tag: 'button',
                type: 'button',
                padding: 'Z A1',
                round: 'Z',
                border: 'none',
                background: 'overlayStrong',
                color: 'title',
                fontSize: 'Z2',
                fontWeight: '600',
                cursor: 'pointer',
                text: '+ Add grant',
                ':hover': {
                    background: 'blue',
                    color: 'white'
                },
                onClick: (e, el, s)=>$d99e1053ed981212$var$_addGrant(s.root, $d99e1053ed981212$var$_me(s).userId)
            },
            AddInvestmentBtn: {
                tag: 'button',
                type: 'button',
                padding: 'Z A1',
                round: 'Z',
                border: 'none',
                background: 'overlayStrong',
                color: 'title',
                fontSize: 'Z2',
                fontWeight: '600',
                cursor: 'pointer',
                text: '+ Add investment',
                ':hover': {
                    background: 'purple',
                    color: 'white'
                },
                onClick: (e, el, s)=>$d99e1053ed981212$var$_addInvestment(s.root, $d99e1053ed981212$var$_me(s).userId)
            }
        }
    },
    ProfileDocuments: {
        ...$d99e1053ed981212$var$_card({}),
        attr: {
            'data-content-section': 'Documents'
        },
        hide: (el, s)=>!el.call('canAccessPrivate', $d99e1053ed981212$var$_me(s)),
        gap: 'C',
        DocHead: {
            flow: 'y',
            gap: 'Z',
            DocEyebrow: {
                tag: 'span',
                fontSize: 'Z2',
                fontWeight: '700',
                letterSpacing: '0.12em',
                textTransform: 'uppercase',
                color: 'blue',
                text: 'Documents'
            },
            DocTitle: {
                tag: 'h2',
                fontSize: 'C',
                fontWeight: '800',
                color: 'title',
                letterSpacing: '-0.02em',
                text: 'Signed'
            }
        },
        onCreate: async (el, s)=>{
            const person = $d99e1053ed981212$var$_me(s);
            if (!person?.userId) return;
            // Skip fetch when viewing self — app.js already loads into root.userDocs
            if (person.userId === s.root?.currentUserId) return;
            try {
                const data = await el.sdk.execute('workspaceProject.documents.userDocuments', 'list', {
                    userId: person.userId
                });
                if (data) el.state.update({
                    _docs: data
                });
            } catch (e) {}
        },
        DocList: {
            flow: 'y',
            childExtends: {
                flow: 'x',
                align: 'center',
                gap: 'A',
                padding: 'Z1 0',
                borderBottomWidth: '1px',
                borderBottomStyle: 'solid',
                borderBottomColor: 'line',
                cursor: (el, s)=>s.storagePath ? 'pointer' : 'default',
                ':hover': {
                    background: 'overlayStrong'
                },
                // migrated 2026-04-27 to SDK route workspaceProject.storage.signedUrl
                // (replaces sb().storage.from('contracts').createSignedUrl(path, 300)).
                onClick: async (e, el, s)=>{
                    if (!s.storagePath) return;
                    try {
                        const result = await el.sdk.execute('workspaceProject.storage', 'signedUrl', {
                            bucket: 'contracts',
                            path: s.storagePath,
                            ttl: 300
                        });
                        const url = result?.url || result?.signedUrl;
                        if (url) window.open(url, '_blank');
                        else console.warn('[MemberProfile] signed URL response missing url field', result);
                    } catch (err) {
                        console.warn('[MemberProfile] signed url failed', err?.message || err);
                    }
                },
                DocIcon: {
                    tag: 'span',
                    fontSize: 'B',
                    text: '\uD83D\uDCC4'
                },
                DocInfo: {
                    flow: 'y',
                    gap: 'V',
                    flex: '1',
                    DocTitle: {
                        tag: 'span',
                        fontSize: 'A',
                        fontWeight: '600',
                        color: 'title',
                        text: (el, s)=>s.title
                    },
                    DocMeta: {
                        tag: 'span',
                        fontSize: 'Z2',
                        color: 'caption',
                        text: (el, s)=>[
                                s.type,
                                s.size,
                                s.signedAt ? `signed ${s.signedAt}` : ''
                            ].filter(Boolean).join(" \xb7 ")
                    }
                },
                DocAction: {
                    tag: 'span',
                    fontSize: 'Z2',
                    fontWeight: '700',
                    color: 'blue',
                    textTransform: 'uppercase',
                    text: (el, s)=>s.storagePath ? 'Open' : ''
                }
            },
            childrenAs: 'state',
            children: (el, s)=>{
                const docs = s._docs || s.root?.userDocs || [];
                return docs.length ? docs.map((d)=>({
                        id: d.id,
                        title: d.title,
                        type: 'PDF',
                        size: d.file_size ? `${Math.round(d.file_size / 1024)} KB` : "\u2014",
                        signedAt: d.signed_at || "\u2014",
                        storagePath: d.storage_path
                    })) : [
                    {
                        id: 'empty',
                        title: 'No documents yet',
                        type: '',
                        size: '',
                        signedAt: ''
                    }
                ];
            }
        }
    },
    ProfileChecklist: {
        ...$d99e1053ed981212$var$_card({}),
        attr: {
            'data-content-section': 'Checklist'
        },
        hide: (el, s)=>!el.call('canAccessPrivate', $d99e1053ed981212$var$_me(s)),
        gap: 'B',
        CheckHead: {
            flow: 'y',
            gap: 'Z',
            CheckEyebrow: {
                tag: 'span',
                fontSize: 'Z2',
                fontWeight: '700',
                letterSpacing: '0.12em',
                textTransform: 'uppercase',
                color: 'orange',
                text: 'Onboarding'
            },
            CheckTitle: {
                tag: 'h2',
                fontSize: 'C',
                fontWeight: '800',
                color: 'title',
                letterSpacing: '-0.02em',
                text: 'Profile Checklist'
            }
        },
        CheckList: {
            flow: 'y',
            gap: 'Y',
            childExtends: 'MemberProfileCheckItem',
            childrenAs: 'state',
            children: (el, s)=>{
                const p = $d99e1053ed981212$var$_me(s);
                const docs = s.root?.userDocs || [];
                return [
                    {
                        label: 'Freelance Contractor Agreement',
                        done: docs.some((d)=>d.type === 'contract')
                    },
                    {
                        label: 'Equity Grant Agreement',
                        done: !!(p.shares || p.stocks)
                    },
                    {
                        label: 'Non-Disclosure Agreement',
                        done: docs.some((d)=>d.type === 'nda')
                    },
                    {
                        label: 'Code of Conduct',
                        done: docs.some((d)=>d.type === 'coc')
                    },
                    {
                        label: 'IP Assignment',
                        done: docs.some((d)=>d.type === 'ip')
                    },
                    {
                        label: 'Location & Timezone set',
                        done: !!(p.location && p.timezone)
                    },
                    {
                        label: 'Availability configured',
                        done: !!p.workingDays
                    },
                    {
                        label: 'GitHub connected',
                        done: !!p.github
                    }
                ];
            }
        }
    }
};
const $d99e1053ed981212$var$_selfCard = (content)=>({
        ...$d99e1053ed981212$var$_card(content),
        hide: (el)=>!el.call('isSelf')
    });
const $d99e1053ed981212$var$_savePrefs = async (root, patch)=>{
    if (!root?.currentUserId) return;
    const prefs = {
        ...root.userPrefs || {},
        ...patch,
        user_id: root.currentUserId
    };
    root.update({
        userPrefs: prefs
    });
    try {
        await (0, $bfqVY.getSDK)().execute('workspaceProject.userPreferences', 'update', {
            payload: prefs
        });
    } catch (e) {
        console.warn('prefs save failed', e);
    }
};
// ── Security (self only) ──
$d99e1053ed981212$export$70752ed3eb71b053.ProfileSecurity = $d99e1053ed981212$var$_selfCard({
    attr: {
        'data-content-section': 'Security'
    },
    gap: 'B',
    SecurityTitle: {
        tag: 'h2',
        fontSize: 'B',
        fontWeight: '700',
        color: 'title',
        text: 'Security'
    },
    SecurityRows: {
        flow: 'y',
        PwdRow: {
            flow: 'x',
            align: 'flex-start space-between',
            gap: 'B',
            padding: 'B 0',
            borderBottomWidth: '1px',
            borderBottomStyle: 'solid',
            borderBottomColor: 'line',
            RowLabel: {
                flow: 'y',
                gap: 'Y',
                LabelText: {
                    tag: 'span',
                    fontSize: 'A',
                    fontWeight: '600',
                    color: 'title',
                    text: 'Password'
                },
                Hint: {
                    tag: 'span',
                    fontSize: 'Z2',
                    color: 'caption',
                    text: 'Change your login password.'
                }
            },
            PwdAction: {
                flow: 'x',
                gap: 'Z',
                align: 'center',
                PwdInput: {
                    tag: 'input',
                    type: 'password',
                    placeholder: 'New password',
                    fontSize: 'Z2',
                    padding: 'Y Z1',
                    round: 'Y',
                    borderWidth: '1px',
                    borderColor: 'line',
                    borderStyle: 'solid',
                    background: 'overlay',
                    color: 'title',
                    width: 'F'
                },
                PwdBtn: {
                    tag: 'button',
                    padding: 'Y Z1',
                    round: 'Y',
                    border: 'none',
                    background: 'blue',
                    color: 'white',
                    fontSize: 'Z2',
                    fontWeight: '600',
                    cursor: 'pointer',
                    text: (el, s)=>s._pwdStatus || 'Update',
                    onClick: async (e, el, s)=>{
                        const input = el.parent.PwdInput?.node;
                        const pw = input?.value;
                        if (!pw || pw.length < 6) return;
                        try {
                            // TODO[password-update]: SDK updateMe currently routes profile
                            // edits — confirm server-side handles password rotation via this
                            // path; if a dedicated flow is required, replace with that call.
                            await el.sdk.updateMe({
                                password: pw
                            });
                            input.value = '';
                            el.state.update({
                                _pwdStatus: 'Updated!'
                            });
                            setTimeout(()=>el.state.update({
                                    _pwdStatus: null
                                }), 2000);
                        } catch (err) {
                            el.state.update({
                                _pwdStatus: 'Failed'
                            });
                            setTimeout(()=>el.state.update({
                                    _pwdStatus: null
                                }), 2000);
                        }
                    }
                }
            }
        },
        TwoFa: $d99e1053ed981212$var$_row('Two-factor auth', 'Coming soon', {
            hint: 'TOTP authenticator support planned.'
        }),
        BackupCodes: $d99e1053ed981212$var$_row('Backup codes', 'Coming soon', {})
    }
});
// ── Notifications (self only) ──
$d99e1053ed981212$export$70752ed3eb71b053.ProfileNotifications = $d99e1053ed981212$var$_selfCard({
    attr: {
        'data-content-section': 'Notifications'
    },
    gap: 'B',
    NotifTitle: {
        tag: 'h2',
        fontSize: 'B',
        fontWeight: '700',
        color: 'title',
        text: 'Notifications'
    },
    NotifRows: {
        flow: 'y',
        EmailDigest: {
            flow: 'x',
            align: 'center space-between',
            padding: 'B 0',
            borderBottomWidth: '1px',
            borderBottomStyle: 'solid',
            borderBottomColor: 'line',
            RowLabel: {
                flow: 'y',
                gap: 'Y',
                LabelText: {
                    tag: 'span',
                    fontSize: 'A',
                    fontWeight: '600',
                    color: 'title',
                    text: 'Email digest'
                },
                Hint: {
                    tag: 'span',
                    fontSize: 'Z2',
                    color: 'caption',
                    text: 'Summary of announcements and meetings.'
                }
            },
            DigestSelect: {
                tag: 'select',
                padding: 'Y Z1',
                round: 'Y',
                borderWidth: '1px',
                borderColor: 'line',
                borderStyle: 'solid',
                background: 'overlay',
                color: 'title',
                fontSize: 'Z2',
                cursor: 'pointer',
                childExtends: {
                    tag: 'option',
                    text: (el, s)=>s.text || s.value || ''
                },
                childrenAs: 'state',
                children: (el, s)=>{
                    const cur = s.root?.userPrefs?.email_digest || 'daily';
                    return [
                        'off',
                        'daily',
                        'weekly'
                    ].map((v)=>({
                            value: v,
                            text: v.charAt(0).toUpperCase() + v.slice(1),
                            selected: v === cur
                        }));
                },
                onChange: (e, el, s)=>$d99e1053ed981212$var$_savePrefs(s.root, {
                        email_digest: e.target.value
                    })
            }
        },
        Mentions: {
            flow: 'x',
            align: 'center space-between',
            padding: 'B 0',
            borderBottomWidth: '1px',
            borderBottomStyle: 'solid',
            borderBottomColor: 'line',
            RowLabel: {
                flow: 'y',
                gap: 'Y',
                LabelText: {
                    tag: 'span',
                    fontSize: 'A',
                    fontWeight: '600',
                    color: 'title',
                    text: 'Mentions'
                },
                Hint: {
                    tag: 'span',
                    fontSize: 'Z2',
                    color: 'caption',
                    text: 'How you receive mention notifications.'
                }
            },
            MentionSelect: {
                tag: 'select',
                padding: 'Y Z1',
                round: 'Y',
                borderWidth: '1px',
                borderColor: 'line',
                borderStyle: 'solid',
                background: 'overlay',
                color: 'title',
                fontSize: 'Z2',
                cursor: 'pointer',
                childExtends: {
                    tag: 'option',
                    text: (el, s)=>s.text || s.value || ''
                },
                childrenAs: 'state',
                children: (el, s)=>{
                    const cur = s.root?.userPrefs?.mention_notifications || 'realtime';
                    return [
                        'off',
                        'realtime',
                        'daily'
                    ].map((v)=>({
                            value: v,
                            text: v === 'realtime' ? 'Realtime' : v.charAt(0).toUpperCase() + v.slice(1),
                            selected: v === cur
                        }));
                },
                onChange: (e, el, s)=>$d99e1053ed981212$var$_savePrefs(s.root, {
                        mention_notifications: e.target.value
                    })
            }
        },
        Birthdays: {
            flow: 'x',
            align: 'center space-between',
            padding: 'B 0',
            borderBottomWidth: '1px',
            borderBottomStyle: 'solid',
            borderBottomColor: 'line',
            RowLabel: {
                tag: 'span',
                fontSize: 'A',
                fontWeight: '600',
                color: 'title',
                text: 'Birthday reminders'
            },
            BirthdayToggle: {
                tag: 'button',
                padding: 'Y Z1',
                round: 'Y',
                border: 'none',
                cursor: 'pointer',
                fontSize: 'Z2',
                fontWeight: '600',
                background: (el, s)=>s.root?.userPrefs?.birthday_reminders !== false ? 'green' : 'overlay',
                color: (el, s)=>s.root?.userPrefs?.birthday_reminders !== false ? 'white' : 'caption',
                text: (el, s)=>s.root?.userPrefs?.birthday_reminders !== false ? 'On' : 'Off',
                onClick: (e, el, s)=>{
                    const cur = s.root?.userPrefs?.birthday_reminders !== false;
                    $d99e1053ed981212$var$_savePrefs(s.root, {
                        birthday_reminders: !cur
                    });
                }
            }
        }
    }
});
// ── Sessions (self only) ──
$d99e1053ed981212$export$70752ed3eb71b053.ProfileSessions = $d99e1053ed981212$var$_selfCard({
    attr: {
        'data-content-section': 'Sessions'
    },
    gap: 'A',
    SessTitle: {
        tag: 'h2',
        fontSize: 'B',
        fontWeight: '700',
        color: 'title',
        text: 'Current session'
    },
    SessionInfo: {
        flow: 'y',
        gap: 'Z',
        padding: 'Z 0',
        Browser: {
            flow: 'x',
            align: 'center space-between',
            padding: 'Z 0',
            RowLabel: {
                tag: 'span',
                fontSize: 'A',
                fontWeight: '600',
                color: 'title',
                text: 'Browser'
            },
            RowValue: {
                tag: 'span',
                fontSize: 'A',
                color: 'paragraph',
                text: (el)=>{
                    if (typeof navigator === 'undefined') return "\u2014";
                    const ua = navigator.userAgent;
                    if (ua.includes('Chrome')) return 'Chrome';
                    if (ua.includes('Firefox')) return 'Firefox';
                    if (ua.includes('Safari')) return 'Safari';
                    return 'Unknown';
                }
            }
        },
        Platform: {
            flow: 'x',
            align: 'center space-between',
            padding: 'Z 0',
            borderBottomWidth: '1px',
            borderBottomStyle: 'solid',
            borderBottomColor: 'line',
            RowLabel: {
                tag: 'span',
                fontSize: 'A',
                fontWeight: '600',
                color: 'title',
                text: 'Platform'
            },
            RowValue: {
                tag: 'span',
                fontSize: 'A',
                color: 'paragraph',
                text: (el)=>{
                    if (typeof navigator === 'undefined') return "\u2014";
                    const p = navigator.platform || '';
                    if (p.includes('Mac')) return 'macOS';
                    if (p.includes('Win')) return 'Windows';
                    if (p.includes('Linux')) return 'Linux';
                    return p || 'Unknown';
                }
            }
        },
        SignedIn: {
            flow: 'x',
            align: 'center space-between',
            padding: 'Z 0',
            RowLabel: {
                tag: 'span',
                fontSize: 'A',
                fontWeight: '600',
                color: 'title',
                text: 'Status'
            },
            RowValue: {
                tag: 'span',
                fontSize: 'A',
                fontWeight: '600',
                color: 'green',
                text: 'Active now'
            }
        }
    }
});
// ── Danger zone (self only) ──
$d99e1053ed981212$export$70752ed3eb71b053.ProfileDanger = {
    ...$d99e1053ed981212$var$_card({}),
    attr: {
        'data-content-section': 'Danger zone'
    },
    hide: (el)=>!el.call('isSelf'),
    gap: 'B',
    borderColor: 'red',
    DangerTitle: {
        tag: 'h2',
        fontSize: 'B',
        fontWeight: '700',
        color: 'red',
        text: 'Danger zone'
    },
    DangerHint: {
        tag: 'p',
        fontSize: 'Z2',
        color: 'caption',
        text: 'These actions are irreversible. Please be sure before proceeding.'
    },
    SignOutRow: {
        flow: 'x',
        align: 'center space-between',
        padding: 'B 0',
        borderBottomWidth: '1px',
        borderBottomStyle: 'solid',
        borderBottomColor: 'line',
        RowLabel: {
            flow: 'y',
            gap: 'Y',
            LabelText: {
                tag: 'span',
                fontSize: 'A',
                fontWeight: '600',
                color: 'title',
                text: 'Sign out'
            },
            Hint: {
                tag: 'span',
                fontSize: 'Z2',
                color: 'caption',
                text: 'End your current session.'
            }
        },
        SignOutBtn: {
            tag: 'button',
            padding: 'Y A',
            round: 'Y',
            borderWidth: '1px',
            borderColor: (el, s)=>s._confirming ? 'transparent' : 'red',
            borderStyle: 'solid',
            background: (el, s)=>s._confirming ? 'red' : 'transparent',
            color: (el, s)=>s._confirming ? 'white' : 'red',
            fontSize: 'Z2',
            fontWeight: '600',
            cursor: 'pointer',
            text: (el, s)=>s._confirming ? 'Confirm sign out?' : 'Sign out',
            onClick: async (e, el, s)=>{
                if (!s._confirming) {
                    el.state.update({
                        _confirming: true
                    });
                    setTimeout(()=>el.state.update({
                            _confirming: false
                        }), 3000);
                    return;
                }
                await el.sdk.logout();
                let root = el;
                while(root && !root.routes)root = root.parent;
                const router = el.context?.utils?.router;
                if (router && root) router('/login', root, {}, {
                    pushState: true
                });
            }
        }
    },
    DeactivateRow: {
        flow: 'x',
        align: 'center space-between',
        padding: 'B 0',
        RowLabel: {
            flow: 'y',
            gap: 'Y',
            LabelText: {
                tag: 'span',
                fontSize: 'A',
                fontWeight: '600',
                color: 'title',
                text: 'Deactivate account'
            },
            Hint: {
                tag: 'span',
                fontSize: 'Z2',
                color: 'caption',
                text: 'Hides your profile and revokes access. Contact admin to reactivate.'
            }
        },
        DeactivateBtn: {
            tag: 'button',
            padding: 'Y A',
            round: 'Y',
            borderWidth: '1px',
            borderColor: (el, s)=>s._confirming ? 'transparent' : 'red',
            borderStyle: 'solid',
            background: (el, s)=>s._confirming ? 'red' : 'transparent',
            color: (el, s)=>s._confirming ? 'white' : 'red',
            fontSize: 'Z2',
            fontWeight: '600',
            cursor: 'pointer',
            text: (el, s)=>s._confirming ? 'Confirm deactivation?' : 'Deactivate',
            onClick: async (e, el, s)=>{
                if (!s._confirming) {
                    el.state.update({
                        _confirming: true
                    });
                    setTimeout(()=>el.state.update({
                            _confirming: false
                        }), 3000);
                    return;
                }
                try {
                    await el.sdk.execute('workspaceProject.userProfiles', 'update', {
                        id: s.root.currentUserId,
                        payload: {
                            status: 'left'
                        }
                    });
                    await el.sdk.logout();
                    let root = el;
                    while(root && !root.routes)root = root.parent;
                    const router = el.context?.utils?.router;
                    if (router && root) router('/login', root, {}, {
                        pushState: true
                    });
                } catch (err) {
                    console.warn('deactivate failed', err);
                }
            }
        }
    }
};
const $d99e1053ed981212$export$5e443b08c7b93dd6 = {
    flow: 'x',
    align: 'center',
    gap: 'Z1',
    padding: 'Z1 0',
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: 'line',
    CheckIcon: {
        tag: 'span',
        fontSize: 'A',
        width: 'B',
        textAlign: 'center',
        color: (el, s)=>s.done ? 'green' : 'caption',
        text: (el, s)=>s.done ? "\u2713" : "\u25CB"
    },
    CheckLabel: {
        tag: 'span',
        fontSize: 'A',
        flex: '1',
        color: (el, s)=>s.done ? 'title' : 'caption',
        text: (el, s)=>s.label
    },
    CheckStatus: {
        tag: 'span',
        fontSize: 'Z2',
        fontWeight: '600',
        color: (el, s)=>s.done ? 'green' : 'orange',
        text: (el, s)=>s.done ? 'Done' : 'Pending'
    }
};
// Shared input styling for every grant-card field — keeps the row
// chrome consistent and keeps each field definition compact.
const $d99e1053ed981212$var$_grantInputBase = {
    padding: 'Z Z1',
    round: 'Y',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'line',
    background: 'overlay',
    color: 'title',
    fontSize: 'Z2',
    width: '100%',
    boxSizing: 'border-box',
    ':focus': {
        borderColor: 'blue',
        outline: 'none'
    }
};
const $d99e1053ed981212$export$a73d92b4aa3052ce = {
    flow: 'y',
    gap: 'A',
    padding: 'A',
    round: 'A',
    background: 'overlayStrong',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'line',
    GrantHead: {
        flow: 'x',
        align: 'center',
        gap: 'Z',
        // Grant name sits flush-left, auto-sized to its content so the share
        // class dropdown lands right beside it rather than being stretched
        // across the row by a flex:1 on the input.
        LabelInput: {
            tag: 'input',
            type: 'text',
            fontSize: 'A',
            fontWeight: '700',
            color: 'title',
            background: 'transparent',
            border: 'none',
            padding: '0',
            minWidth: '0',
            width: 'D2',
            placeholder: 'Grant name',
            onCreate: (el, s)=>{
                el.node.value = s.label || '';
            },
            // Focus-guard sync: when root state updates elsewhere (e.g. after
            // a save), refresh the DOM value but never overwrite while the
            // user is actively typing here.
            onUpdate: (el, s)=>{
                if (!el.node || el.node === document.activeElement) return;
                const v = s.label || '';
                if (el.node.value !== v) el.node.value = v;
            },
            onInput: (e, el, s)=>{
                $d99e1053ed981212$var$_patchGrant(s.root, s.id, {
                    label: e.target.value
                });
                $d99e1053ed981212$var$_keepFocus(e.target);
            }
        },
        // Stock class selector — A / B / C / Preferred / Common. Applies
        // to any grant (including investments, which carry a real class).
        // Direct sibling of LabelInput so the layout reads as
        // "Grant 1 [B ▾]" with the dropdown right next to the title.
        ShareClassSelect: {
            tag: 'select',
            padding: 'V Z',
            round: 'Y',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'line',
            background: 'overlay',
            color: 'title',
            fontSize: 'Y2',
            fontWeight: '700',
            cursor: 'pointer',
            flexShrink: '0',
            ':focus': {
                borderColor: 'blue',
                outline: 'none'
            },
            childExtends: {
                tag: 'option',
                attr: {
                    value: (el, s)=>s.value
                },
                text: (el, s)=>s.text || s.value || ''
            },
            childrenAs: 'state',
            children: (el, s)=>(0, $etEl1.SHARE_CLASS_OPTIONS),
            onCreate: (el, s)=>{
                if (el.node) el.node.value = s.share_class || '';
            },
            onUpdate: (el, s)=>{
                if (!el.node || el.node === document.activeElement) return;
                const v = s.share_class || '';
                if (String(el.node.value) !== String(v)) el.node.value = v;
            },
            onChange: (e, el, s)=>$d99e1053ed981212$var$_patchGrant(s.root, s.id, {
                    share_class: e.target.value
                })
        },
        SaveStatus: {
            flexShrink: '0',
            // Hidden inside the cap-table modal (CapTableGrantModal renders its
            // own save chip + buttons in the ModalFooter so the card stays
            // focused on the editable fields).
            hide: (el, s)=>s.root?.grantDetail?.id === s.id || !(s.root?._grantSaveStatus || {})[s.id],
            tag: 'span',
            fontSize: 'Y2',
            fontWeight: '600',
            padding: 'V Z',
            round: 'V',
            background: (el, s)=>{
                const st = (s.root?._grantSaveStatus || {})[s.id];
                if (st === 'saved') return 'green.12';
                if (st === 'error') return 'red.12';
                if (st === 'dirty') return 'yellow.12';
                return 'blue.12';
            },
            color: (el, s)=>{
                const st = (s.root?._grantSaveStatus || {})[s.id];
                if (st === 'saved') return 'green';
                if (st === 'error') return 'red';
                if (st === 'dirty') return 'yellow';
                return 'blue';
            },
            text: (el, s)=>{
                const st = (s.root?._grantSaveStatus || {})[s.id];
                if (st === 'saved') return "\u2713 Saved";
                if (st === 'error') return 'Save failed';
                if (st === 'dirty') return "\u25CF Unsaved";
                return "Saving\u2026";
            }
        },
        SaveBtn: {
            // Inside the cap-table modal, Save lives in the ModalFooter — so
            // hide this inline button there to keep the card uncluttered.
            hide: (el, s)=>s.root?.grantDetail?.id === s.id,
            // `margin-left: auto` pushes the Save + Remove cluster to the
            // right edge regardless of whether SaveStatus is visible.
            marginLeft: 'auto',
            flexShrink: '0',
            tag: 'button',
            type: 'button',
            padding: 'V Z1',
            round: 'Z',
            border: 'none',
            background: (el, s)=>(s.root?._grantSaveStatus || {})[s.id] === 'dirty' ? 'blue' : 'overlayStrong',
            color: (el, s)=>(s.root?._grantSaveStatus || {})[s.id] === 'dirty' ? 'white' : 'subtitle',
            fontSize: 'Y2',
            fontWeight: '700',
            cursor: 'pointer',
            text: 'Save',
            ':hover': {
                opacity: '.9'
            },
            onClick: (e, el, s)=>$d99e1053ed981212$var$_flushGrant(s.root, s.id)
        },
        DeleteBtn: {
            // Same rationale as SaveBtn — the modal renders a trash icon in
            // its ModalHeader, so the inline Remove is hidden there.
            hide: (el, s)=>s.root?.grantDetail?.id === s.id,
            tag: 'button',
            type: 'button',
            padding: 'V Z',
            round: 'Z',
            border: 'none',
            background: 'transparent',
            color: 'caption',
            fontSize: 'Z2',
            cursor: 'pointer',
            text: "\xd7 Remove",
            ':hover': {
                color: 'red'
            },
            onClick: async (e, el, s)=>{
                if (!window.confirm(`Remove ${s.label || 'this grant'}?`)) return;
                await $d99e1053ed981212$var$_deleteGrant(s.root, s.id);
            }
        }
    },
    // Row 1 — for grants: dates + valuation; for investments: investment
    // amount + valuation (no dates — investments are paid up-front).
    // Grid collapses from 3 cols to 2 cols when the record is an
    // investment so the fields fill the width cleanly.
    FactorsGrid: {
        display: 'grid',
        gridTemplateColumns: (el, s)=>s.investment != null ? 'repeat(2, minmax(0, 1fr))' : 'repeat(3, minmax(0, 1fr))',
        gap: 'A',
        StartField: {
            hide: (el, s)=>s.investment != null,
            flow: 'y',
            gap: 'V',
            Label: {
                tag: 'span',
                fontSize: 'Y2',
                color: 'caption',
                fontWeight: '600',
                textTransform: 'uppercase',
                letterSpacing: '.04em',
                text: 'Start date'
            },
            Input: {
                ...$d99e1053ed981212$var$_grantInputBase,
                tag: 'input',
                type: 'date',
                onCreate: (el, s)=>{
                    el.node.value = s.vesting_start || '';
                },
                onUpdate: (el, s)=>{
                    if (!el.node || el.node === document.activeElement) return;
                    const v = s.vesting_start || '';
                    if (el.node.value !== v) el.node.value = v;
                },
                onInput: (e, el, s)=>{
                    $d99e1053ed981212$var$_patchGrant(s.root, s.id, {
                        vesting_start: e.target.value || null
                    });
                    $d99e1053ed981212$var$_keepFocus(e.target);
                }
            }
        },
        EndField: {
            hide: (el, s)=>s.investment != null,
            flow: 'y',
            gap: 'V',
            Label: {
                flow: 'x',
                align: 'center space-between',
                gap: 'Z',
                Text: {
                    tag: 'span',
                    fontSize: 'Y2',
                    color: 'caption',
                    fontWeight: '600',
                    textTransform: 'uppercase',
                    letterSpacing: '.04em',
                    text: 'End date'
                },
                // `_incomplete` is a pure UI-only toggle on the grant state.
                // When ticked, the card reveals an "Actual end date" input
                // that overwrites `vesting_end` with the day the contract
                // was cancelled/terminated early. Not persisted to the DB —
                // the user's intent flows through to the DB via the
                // overwritten `vesting_end`.
                IncompleteToggle: {
                    flow: 'x',
                    align: 'center',
                    gap: 'V',
                    cursor: 'pointer',
                    Check: {
                        tag: 'input',
                        type: 'checkbox',
                        margin: '0',
                        cursor: 'pointer',
                        onCreate: (el, s)=>{
                            el.node.checked = false;
                            el._lastGrantId = s.id;
                        },
                        onUpdate: (el, s)=>{
                            if (!el.node || el._lastGrantId === s.id) return;
                            el._lastGrantId = s.id;
                            el.node.checked = false;
                            const wrap = el.node.closest('[data-key="EndField"]')?.querySelector('[data-key="ActualEndWrap"]');
                            wrap?.style.setProperty('display', 'none', 'important');
                        },
                        onChange: (e, el)=>{
                            const wrap = el.node.closest('[data-key="EndField"]')?.querySelector('[data-key="ActualEndWrap"]');
                            wrap?.style.setProperty('display', e.target.checked ? 'flex' : 'none', 'important');
                        }
                    },
                    CheckLabel: {
                        tag: 'span',
                        fontSize: 'Y2',
                        color: 'caption',
                        fontWeight: '600',
                        text: 'Incomplete'
                    }
                }
            },
            Input: {
                ...$d99e1053ed981212$var$_grantInputBase,
                tag: 'input',
                type: 'date',
                onCreate: (el, s)=>{
                    el.node.value = s.vesting_end || '';
                },
                onUpdate: (el, s)=>{
                    if (!el.node || el.node === document.activeElement) return;
                    const v = s.vesting_end || '';
                    if (el.node.value !== v) el.node.value = v;
                },
                onInput: (e, el, s)=>{
                    $d99e1053ed981212$var$_patchGrant(s.root, s.id, {
                        vesting_end: e.target.value || null
                    });
                    $d99e1053ed981212$var$_keepFocus(e.target);
                }
            },
            // Actual end date — only visible when Incomplete is ticked.
            // Writing to this field overwrites `vesting_end` directly so the
            // DB-generated `shares` column (and the vested-shares trigger)
            // recompute from the true contract duration.
            ActualEndWrap: {
                style: {
                    display: 'none'
                },
                flow: 'y',
                gap: 'V',
                padding: 'V 0 0 0',
                SubLabel: {
                    tag: 'span',
                    fontSize: 'Y1',
                    color: 'orange',
                    fontWeight: '600',
                    letterSpacing: '.04em',
                    textTransform: 'uppercase',
                    text: 'Actual end (overrides)'
                },
                ActualInput: {
                    ...$d99e1053ed981212$var$_grantInputBase,
                    tag: 'input',
                    type: 'date',
                    onCreate: (el, s)=>{
                        el.node.value = s.vesting_end || '';
                    },
                    onUpdate: (el, s)=>{
                        if (!el.node || el.node === document.activeElement) return;
                        const v = s.vesting_end || '';
                        if (el.node.value !== v) el.node.value = v;
                    },
                    onInput: (e, el, s)=>{
                        $d99e1053ed981212$var$_patchGrant(s.root, s.id, {
                            vesting_end: e.target.value || null
                        });
                        $d99e1053ed981212$var$_keepFocus(e.target);
                    }
                }
            }
        },
        // Investment amount — only shown for investment records. Edits
        // cascade to shares_manual using the origin_valuation at the time
        // of purchase (investment / valuation × 10M pool).
        InvestmentAmountField: {
            hide: (el, s)=>s.investment == null,
            flow: 'y',
            gap: 'V',
            Label: {
                tag: 'span',
                fontSize: 'Y2',
                color: 'caption',
                fontWeight: '600',
                textTransform: 'uppercase',
                letterSpacing: '.04em',
                text: 'Investment amount ($)'
            },
            Input: {
                ...$d99e1053ed981212$var$_grantInputBase,
                tag: 'input',
                type: 'number',
                min: '0',
                step: '100',
                placeholder: '0',
                onCreate: (el, s)=>{
                    el.node.value = s.investment ?? '';
                },
                onUpdate: (el, s)=>{
                    if (!el.node || el.node === document.activeElement) return;
                    const v = s.investment ?? '';
                    if (String(el.node.value) !== String(v)) el.node.value = v;
                },
                onInput: (e, el, s)=>{
                    const raw = e.target.value;
                    const amount = raw === '' ? null : Number(raw);
                    const patch = {
                        investment: amount
                    };
                    // Recalculate the share count from the origin valuation.
                    // Writes to shares_manual so the generated `shares` column
                    // matches once it hits the DB.
                    if (amount != null && amount > 0 && s.origin_valuation && s.origin_valuation > 0) patch.shares_manual = Math.round(amount / s.origin_valuation * 10000000);
                    $d99e1053ed981212$var$_patchGrant(s.root, s.id, patch);
                    $d99e1053ed981212$var$_keepFocus(e.target);
                }
            }
        },
        ValuationField: {
            flow: 'y',
            gap: 'V',
            Label: {
                tag: 'span',
                fontSize: 'Y2',
                color: 'caption',
                fontWeight: '600',
                textTransform: 'uppercase',
                letterSpacing: '.04em',
                text: 'Origin valuation'
            },
            Select: {
                ...$d99e1053ed981212$var$_grantInputBase,
                tag: 'select',
                cursor: 'pointer',
                childExtends: {
                    tag: 'option',
                    text: (el, s)=>s.text || s.value || ''
                },
                childrenAs: 'state',
                children: (el, s)=>(0, $etEl1.valuationOptions)(s.root),
                onCreate: (el, s)=>{
                    if (!el.node) return;
                    // Set option values imperatively since DOMQL's attr doesn't
                    // support function-valued entries on childExtends options.
                    const opts = (0, $etEl1.valuationOptions)(s.root);
                    Array.from(el.node.options).forEach((opt, i)=>{
                        if (opts[i]) opt.value = opts[i].value;
                    });
                    el.node.value = String(s.origin_valuation || '');
                },
                onUpdate: (el, s)=>{
                    if (!el.node || el.node === document.activeElement) return;
                    const v = String(s.origin_valuation || '');
                    if (el.node.value !== v) el.node.value = v;
                },
                onChange: (e, el, s)=>{
                    const ov = e.target.value === '' ? null : Number(e.target.value);
                    const patch = {
                        origin_valuation: ov
                    };
                    if (s.investment != null && s.investment > 0 && ov && ov > 0) patch.shares_manual = Math.round(s.investment / ov * 10000000);
                    $d99e1053ed981212$var$_patchGrant(s.root, s.id, patch);
                }
            }
        }
    },
    // Investment metadata — type + discount. Informational only, does NOT
    // change share/equity calculations.
    InvestmentMetaRow: {
        hide: (el, s)=>s.investment == null,
        display: 'grid',
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
        gap: 'A',
        InvestmentTypeField: {
            flow: 'y',
            gap: 'V',
            Label: {
                tag: 'span',
                fontSize: 'Y2',
                color: 'caption',
                fontWeight: '600',
                textTransform: 'uppercase',
                letterSpacing: '.04em',
                text: 'Investment type'
            },
            Select: {
                ...$d99e1053ed981212$var$_grantInputBase,
                tag: 'select',
                cursor: 'pointer',
                childExtends: {
                    tag: 'option',
                    attr: {
                        value: (el, s)=>s.value
                    },
                    text: (el, s)=>s.text || s.value || ''
                },
                childrenAs: 'state',
                children: (el, s)=>[
                        {
                            value: '',
                            text: "\u2014 select \u2014"
                        },
                        {
                            value: 'post-money-safe',
                            text: 'Post-money SAFE'
                        },
                        {
                            value: 'pre-money-safe',
                            text: 'Pre-money SAFE'
                        },
                        {
                            value: 'convertible-note',
                            text: 'Convertible Note'
                        },
                        {
                            value: 'priced-round',
                            text: 'Priced Round'
                        },
                        {
                            value: 'kiss',
                            text: 'KISS'
                        }
                    ],
                onCreate: (el, s)=>{
                    if (el.node) el.node.value = s.investment_type || '';
                },
                onUpdate: (el, s)=>{
                    if (!el.node || el.node === document.activeElement) return;
                    const v = s.investment_type || '';
                    if (el.node.value !== v) el.node.value = v;
                },
                onChange: (e, el, s)=>$d99e1053ed981212$var$_patchGrant(s.root, s.id, {
                        investment_type: e.target.value || null
                    })
            }
        },
        DiscountField: {
            flow: 'y',
            gap: 'V',
            Label: {
                tag: 'span',
                fontSize: 'Y2',
                color: 'caption',
                fontWeight: '600',
                textTransform: 'uppercase',
                letterSpacing: '.04em',
                text: 'Discount (%)'
            },
            Input: {
                ...$d99e1053ed981212$var$_grantInputBase,
                tag: 'input',
                type: 'number',
                min: '0',
                max: '100',
                step: '1',
                placeholder: '0',
                onCreate: (el, s)=>{
                    el.node.value = s.discount ?? '';
                },
                onUpdate: (el, s)=>{
                    if (!el.node || el.node === document.activeElement) return;
                    const v = s.discount ?? '';
                    if (String(el.node.value) !== String(v)) el.node.value = v;
                },
                onInput: (e, el, s)=>{
                    $d99e1053ed981212$var$_patchGrant(s.root, s.id, {
                        discount: e.target.value === '' ? null : Number(e.target.value)
                    });
                    $d99e1053ed981212$var$_keepFocus(e.target);
                }
            }
        }
    },
    // Row 2 — compensation: monthly ↔ hourly auto-compute via hours/week.
    // Hidden for investments since money was paid as a lump sum, not via
    // a salary stream.
    CompRow: {
        hide: (el, s)=>s.investment != null || s.share_class === (0, $etEl1.SHARE_CLASS_ADVISOR),
        display: 'grid',
        gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
        gap: 'A',
        // Monthly ↔ hourly are codependent via weekly_hours. When one side is
        // missing but the others exist, derive it for display so the field
        // never shows 0/empty while the partner value is present.
        SalaryField: {
            flow: 'y',
            gap: 'V',
            Label: {
                tag: 'span',
                fontSize: 'Y2',
                color: 'caption',
                fontWeight: '600',
                textTransform: 'uppercase',
                letterSpacing: '.04em',
                text: '$ per month'
            },
            Input: {
                ...$d99e1053ed981212$var$_grantInputBase,
                tag: 'input',
                type: 'number',
                min: '0',
                step: '100',
                placeholder: '0',
                value: (el, s)=>s.salary_monthly ?? $d99e1053ed981212$var$_deriveMonthly(s) ?? '',
                onCreate: (el, s)=>{
                    el.node.value = s.salary_monthly ?? $d99e1053ed981212$var$_deriveMonthly(s) ?? '';
                },
                onUpdate: (el, s)=>{
                    if (!el.node || el.node === document.activeElement) return;
                    const v = s.salary_monthly ?? $d99e1053ed981212$var$_deriveMonthly(s) ?? '';
                    if (String(el.node.value) !== String(v)) el.node.value = v;
                },
                onInput: (e, el, s)=>{
                    const monthly = e.target.value === '' ? null : Number(e.target.value);
                    const patch = {
                        salary_monthly: monthly
                    };
                    const wh = Number(String(s.weekly_hours || '').replace(/[^0-9.]/g, '')) || 0;
                    // If hours/week is set, back-calc the hourly rate so the two stay
                    // in sync. 4.33 weeks/month is the standard approximation.
                    if (monthly != null && wh > 0) patch.hourly_rate = Math.round(monthly / (wh * 4.33) * 100) / 100;
                    $d99e1053ed981212$var$_patchGrant(s.root, s.id, patch);
                    $d99e1053ed981212$var$_keepFocus(e.target);
                }
            }
        },
        HourlyField: {
            flow: 'y',
            gap: 'V',
            Label: {
                tag: 'span',
                fontSize: 'Y2',
                color: 'caption',
                fontWeight: '600',
                textTransform: 'uppercase',
                letterSpacing: '.04em',
                text: 'Hourly rate ($)'
            },
            Input: {
                ...$d99e1053ed981212$var$_grantInputBase,
                tag: 'input',
                type: 'number',
                min: '0',
                step: '1',
                placeholder: '0',
                value: (el, s)=>s.hourly_rate ?? $d99e1053ed981212$var$_deriveHourly(s) ?? '',
                onCreate: (el, s)=>{
                    el.node.value = s.hourly_rate ?? $d99e1053ed981212$var$_deriveHourly(s) ?? '';
                },
                onUpdate: (el, s)=>{
                    if (!el.node || el.node === document.activeElement) return;
                    const v = s.hourly_rate ?? $d99e1053ed981212$var$_deriveHourly(s) ?? '';
                    if (String(el.node.value) !== String(v)) el.node.value = v;
                },
                onInput: (e, el, s)=>{
                    const hourly = e.target.value === '' ? null : Number(e.target.value);
                    const patch = {
                        hourly_rate: hourly
                    };
                    const wh = Number(String(s.weekly_hours || '').replace(/[^0-9.]/g, '')) || 0;
                    // Hourly × hours/week × 4.33 → derived monthly
                    if (hourly != null && wh > 0) patch.salary_monthly = Math.round(hourly * wh * 4.33);
                    $d99e1053ed981212$var$_patchGrant(s.root, s.id, patch);
                    $d99e1053ed981212$var$_keepFocus(e.target);
                }
            }
        },
        WeeklyField: {
            flow: 'y',
            gap: 'V',
            Label: {
                tag: 'span',
                fontSize: 'Y2',
                color: 'caption',
                fontWeight: '600',
                textTransform: 'uppercase',
                letterSpacing: '.04em',
                text: 'Hours / week'
            },
            Input: {
                ...$d99e1053ed981212$var$_grantInputBase,
                tag: 'input',
                type: 'text',
                placeholder: '40',
                onCreate: (el, s)=>{
                    el.node.value = s.weekly_hours ?? '';
                },
                onUpdate: (el, s)=>{
                    if (!el.node || el.node === document.activeElement) return;
                    const v = s.weekly_hours ?? '';
                    if (el.node.value !== String(v)) el.node.value = v;
                },
                // When hours/week changes, recompute whichever of monthly/hourly
                // is derivable so both fields reflect the new relationship.
                onInput: (e, el, s)=>{
                    const raw = e.target.value;
                    const wh = Number(String(raw || '').replace(/[^0-9.]/g, '')) || 0;
                    const patch = {
                        weekly_hours: raw || null
                    };
                    if (wh > 0) {
                        if (s.salary_monthly && !s.hourly_rate) patch.hourly_rate = Math.round(s.salary_monthly / (wh * 4.33) * 100) / 100;
                        else if (s.hourly_rate && !s.salary_monthly) patch.salary_monthly = Math.round(s.hourly_rate * wh * 4.33);
                    }
                    $d99e1053ed981212$var$_patchGrant(s.root, s.id, patch);
                    $d99e1053ed981212$var$_keepFocus(e.target);
                }
            }
        }
    },
    // ── Computed totals — editable contract total rewires salary_monthly ─
    // For investments: ContractTotal drops out (no salary stream) and the
    // grid collapses to 2 cols so Shares + Equity fill the width.
    TotalsRow: {
        display: 'grid',
        gridTemplateColumns: (el, s)=>s.investment != null || s.share_class === (0, $etEl1.SHARE_CLASS_ADVISOR) ? 'repeat(2, minmax(0, 1fr))' : 'repeat(3, minmax(0, 1fr))',
        gap: 'A',
        padding: 'A 0 0 0',
        borderTopWidth: '1px',
        borderTopStyle: 'solid',
        borderTopColor: 'line',
        ContractTotal: {
            hide: (el, s)=>s.investment != null || s.share_class === (0, $etEl1.SHARE_CLASS_ADVISOR),
            flow: 'y',
            gap: 'V',
            Label: {
                tag: 'span',
                fontSize: 'Y2',
                color: 'caption',
                fontWeight: '600',
                textTransform: 'uppercase',
                letterSpacing: '.04em',
                text: 'Contract total'
            },
            Input: {
                ...$d99e1053ed981212$var$_grantInputBase,
                tag: 'input',
                type: 'number',
                min: '0',
                step: '100',
                fontSize: 'A',
                fontWeight: '700',
                onCreate: (el, s)=>{
                    el.node.value = $d99e1053ed981212$var$_contractValue(s) || '';
                },
                onUpdate: (el, s)=>{
                    const v = $d99e1053ed981212$var$_contractValue(s) || '';
                    if (el.node && el.node !== document.activeElement && String(el.node.value) !== String(v)) el.node.value = v;
                },
                onInput: (e, el, s)=>{
                    const total = Number(e.target.value) || 0;
                    if (!s.vesting_start || !s.vesting_end) return;
                    const months = (new Date(s.vesting_end) - new Date(s.vesting_start)) / 2629800000;
                    if (months <= 0) return;
                    $d99e1053ed981212$var$_patchGrant(s.root, s.id, {
                        salary_monthly: Math.round(total / months)
                    });
                    $d99e1053ed981212$var$_keepFocus(e.target);
                }
            }
        },
        // Shares cell — editable. Writes to `shares_manual`, which overrides
        // the generated `shares` column. Editing this back-calculates the
        // other derived money fields (salary, hourly, contract total) so the
        // record stays internally consistent. Hours/week stays untouched —
        // it's a user-defined factor, not a derived one.
        SharesCell: {
            flow: 'y',
            gap: 'V',
            Label: {
                flow: 'x',
                align: 'center',
                gap: 'V',
                Text: {
                    tag: 'span',
                    fontSize: 'Y2',
                    color: 'caption',
                    fontWeight: '600',
                    textTransform: 'uppercase',
                    letterSpacing: '.04em',
                    text: 'Shares'
                },
                // Little visual cue when the value is a manual override (so admins
                // can tell at a glance it's not the derived number).
                OverrideTag: {
                    hide: (el, s)=>s.shares_manual == null,
                    tag: 'span',
                    fontSize: 'Y1',
                    padding: 'V V',
                    round: 'V',
                    fontWeight: '700',
                    color: 'orange',
                    background: 'orange.12',
                    text: 'MANUAL'
                }
            },
            Input: {
                ...$d99e1053ed981212$var$_grantInputBase,
                tag: 'input',
                type: 'number',
                min: '0',
                step: '1',
                fontSize: 'A',
                fontWeight: '700',
                placeholder: (el, s)=>String((0, $etEl1.liveShares)(s) || 0),
                // Reactive `value` binding — subscribes the element to
                // `shares_manual` so DOMQL re-runs onUpdate whenever another
                // field (Investment Amount, Origin valuation, etc.) cascades
                // a new share count into it.
                value: (el, s)=>s.shares_manual ?? '',
                // Show the override value when set; otherwise leave empty so the
                // placeholder (= derived shares) hints at the value that will
                // apply if left blank.
                onCreate: (el, s)=>{
                    el.node.value = s.shares_manual ?? '';
                },
                onUpdate: (el, s)=>{
                    if (!el.node || el.node === document.activeElement) return;
                    const v = s.shares_manual ?? '';
                    if (String(el.node.value) !== String(v)) el.node.value = v;
                },
                onInput: (e, el, s)=>{
                    const raw = e.target.value;
                    const sharesManual = raw === '' ? null : Number(raw);
                    const patch = {
                        shares_manual: sharesManual
                    };
                    // Cascade shares → salary → hourly. Keep hours/week fixed per
                    // user requirement. Formula: salary = shares × valuation ÷
                    // (months × 10M_pool).
                    if (sharesManual != null && sharesManual > 0 && s.origin_valuation && s.origin_valuation > 0 && s.vesting_start && s.vesting_end) {
                        const months = (new Date(s.vesting_end) - new Date(s.vesting_start)) / 2629800000;
                        if (months > 0) {
                            const newSalary = Math.round(sharesManual * s.origin_valuation / (10000000 * months));
                            patch.salary_monthly = newSalary;
                            const wh = Number(String(s.weekly_hours || '').replace(/[^0-9.]/g, '')) || 0;
                            if (wh > 0) patch.hourly_rate = Math.round(newSalary / (wh * 4.33) * 100) / 100;
                        }
                    }
                    $d99e1053ed981212$var$_patchGrant(s.root, s.id, patch);
                    $d99e1053ed981212$var$_keepFocus(e.target);
                }
            }
        },
        EquityCell: {
            flow: 'y',
            gap: 'V',
            Label: {
                tag: 'span',
                fontSize: 'Y2',
                color: 'caption',
                fontWeight: '600',
                textTransform: 'uppercase',
                letterSpacing: '.04em',
                text: 'Equity'
            },
            Value: {
                tag: 'span',
                fontSize: 'A',
                fontWeight: '700',
                color: 'green',
                // Compute live from current factors so the display stays in
                // sync as the user edits shares / salary / valuation. The DB
                // generated column (`s.equity_pct`) only refreshes on save.
                text: (el, s)=>{
                    const pct = (0, $etEl1.liveEquityPct)(s);
                    return pct > 0 ? `${pct.toFixed(2)}%` : "\u2014";
                }
            }
        }
    },
    // ── Vested — its own row below the totals grid so the main grid can
    // stay 3-col wide and the vesting readout gets visual breathing room.
    // Hidden inside the cap-table modal (modal renders its own vested row
    // in the TotalsBlock) and for investments (no vesting schedule).
    VestedRow: {
        hide: (el, s)=>s.root?.grantDetail?.id === s.id || s.investment != null,
        flow: 'x',
        align: 'center space-between',
        padding: 'A 0 0 0',
        gap: 'A',
        VestedCell: {
            flow: 'x',
            gap: 'Z',
            align: 'center',
            Label: {
                tag: 'span',
                fontSize: 'Y2',
                color: 'caption',
                fontWeight: '600',
                textTransform: 'uppercase',
                letterSpacing: '.04em',
                text: 'Vested'
            },
            Value: {
                tag: 'span',
                fontSize: 'A',
                fontWeight: '700',
                color: 'title',
                text: (el, s)=>{
                    const pct = s.shares ? Math.round((s.vested_shares || 0) / s.shares * 100) : 0;
                    return `${$d99e1053ed981212$var$_numberFmt.format(s.vested_shares || 0)} \xb7 ${pct}%`;
                }
            }
        },
        // Visual progress bar for vested portion — gives the section weight
        // once it's on its own row rather than squeezed into a 4-col grid.
        VestedBar: {
            flex: '1',
            maxWidth: 'E',
            height: 'Y',
            round: 'Y',
            background: 'line',
            overflow: 'hidden',
            Fill: {
                height: '100%',
                round: 'Y',
                background: 'green',
                width: (el, s)=>{
                    if (!s.shares) return '0%';
                    const pct = Math.min(100, Math.round((s.vested_shares || 0) / s.shares * 100));
                    return `${pct}%`;
                }
            }
        }
    }
};

});

parcelRegister("e7qqB", function(module, exports) {

$parcel$export(module.exports, "ProfileAvailabilityCell", () => $a47638304483d26c$export$5bc2dfb247a1ef80);
$parcel$export(module.exports, "ProfileAvailabilityGrid", () => $a47638304483d26c$export$9c49f3715ff4d771);
// Standalone availability grid for the profile page.
// Uses event delegation on the grid container for click handling
// since DOMQL lifecycle hooks don't fire on deeply nested childExtends cells.
parcelRequire("chzVb");
var $bglB6 = parcelRequire("bglB6");
var $chzVb = parcelRequire("chzVb");
const $a47638304483d26c$var$DAYS = [
    'Mon',
    'Tue',
    'Wed',
    'Thu',
    'Fri',
    'Sat',
    'Sun'
];
const $a47638304483d26c$var$_hhmmToMin = (s)=>{
    if (!s) return 0;
    const [h, m] = s.split(':').map(Number);
    return h * 60 + m;
};
const $a47638304483d26c$var$_isAvailableDefault = (user, hour)=>{
    const wh = user?.workingHours;
    if (!wh) return true;
    const minute = hour * 60;
    const start = $a47638304483d26c$var$_hhmmToMin(wh.start);
    const end = $a47638304483d26c$var$_hhmmToMin(wh.end);
    return start < end ? minute >= start && minute < end : minute >= start || minute < end;
};
const $a47638304483d26c$var$_isAvailableAt = (user, day, hour)=>{
    if (!user) return false;
    const grid = user.availabilityGrid;
    if (grid && grid[day] && typeof grid[day][hour] === 'boolean') return grid[day][hour];
    return $a47638304483d26c$var$_isAvailableDefault(user, hour);
};
const $a47638304483d26c$var$_me = (0, $chzVb.findMe);
// CU-10 §90: roles/isAdmin removed from person object. Use canAdmin() which
// unions JWT perm check (admin.pages.read) with legacy role fallback.
const $a47638304483d26c$var$_currentUserIsAdmin = (root)=>{
    if (!root) return false;
    // canAdmin uses Phase E JWT claim as primary path; falls back to userIsAdmin
    // which reads root.roles.byUser (populated from server member-roles endpoint).
    return (0, $bglB6.canAdmin)({
        root: root
    });
};
const $a47638304483d26c$export$5bc2dfb247a1ef80 = {
    tag: 'button',
    border: 'none',
    padding: '0',
    height: 'A',
    minHeight: 'A',
    background: (el, s)=>{
        const u = $a47638304483d26c$var$_me(el.state);
        return $a47638304483d26c$var$_isAvailableAt(u, s.day, s.h) ? 'green' : 'red.15';
    },
    cursor: (el)=>$a47638304483d26c$var$_currentUserIsAdmin(el.state?.root) ? 'pointer' : 'not-allowed',
    ':hover': {
        opacity: '.85'
    }
};
const $a47638304483d26c$export$9c49f3715ff4d771 = {
    display: 'grid',
    gridTemplateColumns: 'auto repeat(24, 1fr)',
    gridTemplateRows: 'auto repeat(7, auto)',
    gap: '1px',
    background: 'line',
    padding: '1px',
    round: 'Z',
    overflow: 'hidden',
    userSelect: 'none',
    // Event delegation: single click handler on the grid container
    onCreate: (el, s)=>{
        if (!el.node) return;
        el.node.addEventListener('click', (e)=>{
            const btn = e.target.closest('button');
            if (!btn) return;
            const root = s.root || el.state?.root;
            if (!$a47638304483d26c$var$_currentUserIsAdmin(root)) return;
            // Find day/hour from the button's data attributes
            const day = parseInt(btn.dataset.day);
            const hour = parseInt(btn.dataset.hour);
            if (isNaN(day) || isNaN(hour)) return;
            const user = $a47638304483d26c$var$_me(el.state);
            if (!user) return;
            const grid = user.availabilityGrid ? user.availabilityGrid.map((row)=>row.slice()) : Array.from({
                length: 7
            }, ()=>Array.from({
                    length: 24
                }, (_, h)=>$a47638304483d26c$var$_isAvailableDefault(user, h)));
            grid[day][hour] = !grid[day][hour];
            const next = (root.people || []).map((p)=>p.email === user.email ? {
                    ...p,
                    availabilityGrid: grid
                } : p);
            root.update({
                people: next
            });
            // Immediate visual feedback
            btn.style.background = grid[day][hour] ? 'var(--color-green)' : 'rgba(235, 102, 80, 0.15)';
        });
    },
    Corner: {
        background: 'modal',
        padding: 'Y'
    },
    HourHeaders: {
        display: 'contents',
        childExtends: {
            tag: 'span',
            background: 'modal',
            fontSize: 'Y2',
            color: 'caption',
            fontFamily: 'monospace',
            textAlign: 'center',
            padding: 'Y 0',
            text: (el, s)=>String(s.h).padStart(2, '0')
        },
        childrenAs: 'state',
        children: ()=>Array.from({
                length: 24
            }, (_, h)=>({
                    h: h
                }))
    },
    DayRows: {
        display: 'contents',
        childExtends: {
            display: 'contents',
            Label: {
                tag: 'span',
                background: 'modal',
                fontSize: 'Y2',
                color: 'caption',
                fontWeight: '600',
                padding: 'Y Z',
                align: 'center right',
                text: (el, s)=>s.label
            },
            Cells: {
                display: 'contents',
                childExtends: {
                    tag: 'button',
                    border: 'none',
                    padding: '0',
                    height: 'A',
                    minHeight: 'A',
                    background: (el, s)=>{
                        const u = $a47638304483d26c$var$_me(el.state);
                        return $a47638304483d26c$var$_isAvailableAt(u, s.day, s.h) ? 'green' : 'red.15';
                    },
                    cursor: (el)=>$a47638304483d26c$var$_currentUserIsAdmin(el.state?.root) ? 'pointer' : 'not-allowed',
                    ':hover': {
                        opacity: '.85'
                    },
                    // Store day/hour as data attributes for the delegated click handler
                    attr: {
                        'data-day': (el, s)=>s.day,
                        'data-hour': (el, s)=>s.h
                    }
                },
                childrenAs: 'state',
                children: (el, s)=>Array.from({
                        length: 24
                    }, (_, h)=>({
                            day: s.day,
                            h: h
                        }))
            }
        },
        childrenAs: 'state',
        children: ()=>$a47638304483d26c$var$DAYS.map((label, day)=>({
                    day: day,
                    label: label
                }))
    }
};

});

parcelRegister("gOurQ", function(module, exports) {

var $882e4 = parcelRequire("882e4");

var $TY0kT = parcelRequire("TY0kT");

var $13fWJ = parcelRequire("13fWJ");

var $7E5wc = parcelRequire("7E5wc");

var $7N5GO = parcelRequire("7N5GO");

var $aMq03 = parcelRequire("aMq03");

var $cZ4KY = parcelRequire("cZ4KY");

var $jzV4w = parcelRequire("jzV4w");

var $7jyv3 = parcelRequire("7jyv3");

var $lz0XA = parcelRequire("lz0XA");

var $cAMTN = parcelRequire("cAMTN");
$parcel$exportWildcard(module.exports, $882e4);
$parcel$exportWildcard(module.exports, $TY0kT);
$parcel$exportWildcard(module.exports, $13fWJ);
$parcel$exportWildcard(module.exports, $7E5wc);
$parcel$exportWildcard(module.exports, $7N5GO);
$parcel$exportWildcard(module.exports, $aMq03);
$parcel$exportWildcard(module.exports, $cZ4KY);
$parcel$exportWildcard(module.exports, $jzV4w);
$parcel$exportWildcard(module.exports, $7jyv3);
$parcel$exportWildcard(module.exports, $lz0XA);
$parcel$exportWildcard(module.exports, $cAMTN);

});
parcelRegister("882e4", function(module, exports) {

$parcel$export(module.exports, "CalSidebar", () => $5eb0cc1972812942$export$e64f3dfd54d10b92);
const $5eb0cc1972812942$export$e64f3dfd54d10b92 = {
    extends: 'AppSidebar',
    Top: null,
    Middle: {
        padding: '0',
        CalMiniCalendar: {}
    },
    PeopleSection: {
        TeamGroup: {
            extends: 'PeopleGroup',
            label: 'TEAM',
            groupName: 'team'
        },
        AdvisorsGroup: {
            extends: 'PeopleGroup',
            label: 'ADVISORS',
            groupName: 'advisor',
            display: (el)=>el.call('currentUserIsSuperadmin') ? 'flex' : 'none'
        },
        InvestorsGroup: {
            extends: 'PeopleGroup',
            label: 'INVESTORS',
            groupName: 'investor',
            display: (el)=>el.call('currentUserIsSuperadmin') ? 'flex' : 'none'
        }
    }
};

});

parcelRegister("TY0kT", function(module, exports) {

$parcel$export(module.exports, "CalMiniCalendar", () => $0a83aecc07254d6d$export$3cdbcb0c920cb0a7);
$parcel$export(module.exports, "CalMiniDayLabel", () => $0a83aecc07254d6d$export$ea934e2803c382b);
$parcel$export(module.exports, "CalMiniDayCell", () => $0a83aecc07254d6d$export$ed65dfbe1d5ee06f);
const $0a83aecc07254d6d$export$3cdbcb0c920cb0a7 = {
    flow: 'y',
    padding: 'A',
    gap: 'Z1',
    userSelect: 'none',
    Header: {
        flow: 'x',
        align: 'center space-between',
        marginBottom: 'Z1',
        Label: {
            tag: 'span',
            fontSize: 'Z2',
            fontWeight: '600',
            color: 'title',
            text: (el, s)=>{
                const root = s.root;
                return el.call('getMonthLabel', root.currentYear, root.currentMonth);
            }
        },
        NavBtns: {
            flow: 'x',
            gap: 'Z',
            PrevBtn: {
                extends: 'IconButton',
                Icon: {
                    icon: 'arrowAngleLeft'
                },
                onClick: (e, el, s)=>{
                    const root = s.root;
                    const { year: year, month: month } = el.call('prevMonth', root.currentYear, root.currentMonth);
                    root.update({
                        currentYear: year,
                        currentMonth: month
                    });
                }
            },
            NextBtn: {
                extends: 'IconButton',
                Icon: {
                    icon: 'arrowAngleRight'
                },
                onClick: (e, el, s)=>{
                    const root = s.root;
                    const { year: year, month: month } = el.call('nextMonth', root.currentYear, root.currentMonth);
                    root.update({
                        currentYear: year,
                        currentMonth: month
                    });
                }
            }
        }
    },
    DayLabels: {
        display: 'grid',
        gridTemplateColumns: 'repeat(7, 1fr)',
        marginBottom: 'Z',
        childExtends: 'CalMiniDayLabel',
        childrenAs: 'state',
        children: (el)=>el.call('getDayNames').map((d)=>({
                    label: d[0]
                }))
    },
    Grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(7, 1fr)',
        gap: '2px',
        childExtends: 'CalMiniDayCell',
        childrenAs: 'state',
        children: (el, s)=>{
            const root = s.root;
            return el.call('getMonthDays', root.currentYear, root.currentMonth);
        }
    }
};
const $0a83aecc07254d6d$export$ea934e2803c382b = {
    align: 'center center',
    padding: 'Z 0',
    fontSize: 'Y2',
    fontWeight: '600',
    color: 'caption',
    text: (el, s)=>s.label || ''
};
const $0a83aecc07254d6d$export$ed65dfbe1d5ee06f = {
    tag: 'button',
    align: 'center center',
    padding: '0',
    width: 'B',
    height: 'B',
    round: '50%',
    fontSize: 'Y2',
    fontWeight: '500',
    border: 'none',
    cursor: 'pointer',
    background: (el, s)=>{
        const root = el.state.root;
        if (!s.isOtherMonth && el.call('isToday', s.year, s.month, s.day)) return 'blue';
        if (!s.isOtherMonth && root.currentDay === s.day && root.currentMonth === s.month) return 'selectedDay';
        return 'transparent';
    },
    color: (el, s)=>{
        if (!s.isOtherMonth && el.call('isToday', s.year, s.month, s.day)) return 'white';
        return s.isOtherMonth ? 'caption' : 'title';
    },
    opacity: (el, s)=>s.isOtherMonth ? '.4' : '1',
    ':hover': {
        background: 'overlay'
    },
    text: (el, s)=>String(s.day),
    onClick: (e, el, s)=>{
        const root = el.state.root;
        root.update({
            currentDay: s.day,
            currentMonth: s.month,
            currentYear: s.year
        });
    }
};

});

parcelRegister("13fWJ", function(module, exports) {

$parcel$export(module.exports, "CalMain", () => $0c4270d6b8fe5001$export$a7bf04a2f43e4a69);
$parcel$export(module.exports, "CalHeader", () => $0c4270d6b8fe5001$export$35e79f86e8e62acd);
$parcel$export(module.exports, "CalViewBtn", () => $0c4270d6b8fe5001$export$a66857fbcdd49e78);
$parcel$export(module.exports, "CalOnlineAvatar", () => (parcelRequire("1nf9Q")).CalOnlineAvatar);
$parcel$export(module.exports, "CalOnlineUsersBar", () => (parcelRequire("1nf9Q")).CalOnlineUsersBar);

var $ac7NT = parcelRequire("ac7NT");

var $4kOC6 = parcelRequire("4kOC6");

var $kZOF8 = parcelRequire("kZOF8");

var $1nf9Q = parcelRequire("1nf9Q");
const $0c4270d6b8fe5001$export$a7bf04a2f43e4a69 = {
    extends: 'AppMain',
    padding: '0',
    Header: {
        extends: 'CalHeader'
    },
    Body: {
        CalMonthView: {},
        CalWeekView: {},
        CalTeamView: {},
        CalTeamNowView: {}
    }
};
const $0c4270d6b8fe5001$export$35e79f86e8e62acd = {
    extends: 'PageHeader',
    LeftGroup: {
        TodayBtn: {
            tag: 'button',
            text: 'Today',
            padding: 'Z A',
            round: 'Z',
            borderWidth: '1px',
            borderColor: 'line',
            borderStyle: 'solid',
            theme: 'secondary',
            cursor: 'pointer',
            fontSize: 'Z2',
            fontWeight: '500',
            onClick: (e, el, s)=>{
                const t = new Date();
                s.root.update({
                    currentYear: t.getFullYear(),
                    currentMonth: t.getMonth(),
                    currentDay: t.getDate()
                });
            }
        },
        NavGroup: {
            flow: 'x',
            childExtends: 'IconButton',
            PrevBtn: {
                Icon: {
                    icon: 'arrowAngleLeft'
                },
                onClick: (e, el, s)=>{
                    const root = s.root;
                    if (root.viewMode === 'month') {
                        const { year: year, month: month } = el.call('prevMonth', root.currentYear, root.currentMonth);
                        root.update({
                            currentYear: year,
                            currentMonth: month
                        });
                    } else if (root.viewMode === 'team') {
                        const d = new Date(root.currentYear, root.currentMonth, root.currentDay - 1);
                        root.update({
                            currentYear: d.getFullYear(),
                            currentMonth: d.getMonth(),
                            currentDay: d.getDate()
                        });
                    } else {
                        const d = new Date(root.currentYear, root.currentMonth, root.currentDay - 7);
                        root.update({
                            currentYear: d.getFullYear(),
                            currentMonth: d.getMonth(),
                            currentDay: d.getDate()
                        });
                    }
                }
            },
            NextBtn: {
                Icon: {
                    icon: 'arrowAngleRight'
                },
                onClick: (e, el, s)=>{
                    const root = s.root;
                    if (root.viewMode === 'month') {
                        const { year: year, month: month } = el.call('nextMonth', root.currentYear, root.currentMonth);
                        root.update({
                            currentYear: year,
                            currentMonth: month
                        });
                    } else if (root.viewMode === 'team') {
                        const d = new Date(root.currentYear, root.currentMonth, root.currentDay + 1);
                        root.update({
                            currentYear: d.getFullYear(),
                            currentMonth: d.getMonth(),
                            currentDay: d.getDate()
                        });
                    } else {
                        const d = new Date(root.currentYear, root.currentMonth, root.currentDay + 7);
                        root.update({
                            currentYear: d.getFullYear(),
                            currentMonth: d.getMonth(),
                            currentDay: d.getDate()
                        });
                    }
                }
            }
        },
        DateLabel: {
            tag: 'h2',
            fontSize: 'B1',
            fontWeight: '400',
            margin: '0',
            color: 'title',
            text: (el, s)=>{
                const root = s.root;
                if (root.viewMode === 'team-now') return 'Team Now';
                if (root.viewMode === 'team') {
                    const d = new Date(root.currentYear, root.currentMonth, root.currentDay);
                    return d.toLocaleDateString(undefined, {
                        weekday: 'long',
                        month: 'long',
                        day: 'numeric',
                        year: 'numeric'
                    });
                }
                return el.call('getMonthLabel', root.currentYear, root.currentMonth);
            }
        },
        // Manual refetch — pokes the calendar-sync Edge Function (pull+push pass
        // against Google), then reactively re-fetches calendar_events from
        // Supabase and overwrites root.events in place. No page reload, no
        // browser cache to fight, the UI updates the moment the round-trip lands.
        ResyncBtn: {
            extends: 'IconButton',
            Icon: {
                icon: 'refresh'
            },
            title: 'Resync from Google',
            transform: (el, s)=>s.root.syncing ? 'rotate(360deg)' : 'rotate(0deg)',
            transition: 'transform 1s linear',
            onClick: async (e, el, s)=>{
                const root = s.root;
                if (root.syncing) return;
                root.update({
                    syncing: true
                });
                try {
                    await fetch((0, $ac7NT.CALENDAR_SYNC_URL), {
                        method: 'POST',
                        headers: (0, $ac7NT.CALENDAR_SYNC_HEADERS)
                    });
                } catch (_) {
                /* sync down — still re-fetch so the user gets fresh DB rows */ }
                try {
                    // migrated 2026-04-27 to entity route workspaceProject.calendar
                    const min = new Date(Date.now() - 2592000000).toISOString();
                    const max = new Date(Date.now() + 31536000000).toISOString();
                    const result = await el.context.fetch.select({
                        from: 'workspaceProject.calendar',
                        params: {
                            deleted: false,
                            start_at: {
                                gte: min,
                                lte: max
                            }
                        },
                        order: 'start_at',
                        limit: 5000
                    });
                    if (result?.data) root.update({
                        events: result.data.map((0, $4kOC6.rowToEvent))
                    });
                } catch (err) {
                    console.error('[resync] re-fetch failed:', err);
                }
                root.update({
                    syncing: false
                });
            }
        }
    },
    CenterGroup: {
        // Driven by shared-gov's SharedViewSwitcher so calendar and chat
        // share the same segmented switcher chrome + click + active state
        // logic. Each child is a SharedViewSwitcherBtn keyed by `value`
        // which matches the parent's `stateKey` field on root state
        // (`viewMode`).
        ViewSwitcher: {
            extends: 'SharedViewSwitcher',
            childExtends: 'SharedViewSwitcherBtn',
            children: [
                {
                    value: 'month',
                    label: 'Month'
                },
                {
                    value: 'week',
                    label: 'Week'
                },
                {
                    value: 'team',
                    label: 'Team'
                },
                {
                    value: 'team-now',
                    label: 'Team Now'
                }
            ]
        }
    },
    RightGroup: {
        // OnlineBar/AiToggle/Profile already live in the global AppHeader.
        // Calendar-only action: New booking button.
        NewBookingBtn: {
            tag: 'button',
            flow: 'x',
            align: 'center center',
            gap: 'Z',
            padding: 'Z A',
            round: 'C',
            border: 'none',
            theme: 'primary',
            cursor: 'pointer',
            fontSize: 'Z2',
            fontWeight: '500',
            ':hover': {
                opacity: '.9'
            },
            onClick: (e, el, s)=>{
                s.root.update({
                    showNewBooking: true,
                    newBooking: (0, $kZOF8.freshBooking)({
                        date: el.call('todayISO')
                    })
                });
            },
            Icon: {
                icon: 'plus'
            },
            Label: {
                tag: 'span',
                text: 'New booking'
            }
        }
    }
};
const $0c4270d6b8fe5001$export$a66857fbcdd49e78 = {
    tag: 'button',
    padding: 'Z A',
    border: 'none',
    cursor: 'pointer',
    fontSize: 'Z2'
};

});

parcelRegister("7E5wc", function(module, exports) {

$parcel$export(module.exports, "CalMonthView", () => $59108ca4128ea207$export$2a66f62fd1599058);
$parcel$export(module.exports, "CalMonthDayHeader", () => $59108ca4128ea207$export$e2e0d9f59cf7cc83);
$parcel$export(module.exports, "CalMonthDayCell", () => $59108ca4128ea207$export$637f1acf6404a040);
$parcel$export(module.exports, "CalEventChip", () => $59108ca4128ea207$export$983e5546d5de7e4c);

var $kZOF8 = parcelRequire("kZOF8");
const $59108ca4128ea207$export$2a66f62fd1599058 = {
    flow: 'y',
    flex: '1',
    overflow: 'hidden',
    userSelect: 'none',
    display: (el, s)=>s.root.viewMode === 'month' ? 'flex' : 'none',
    DayHeaders: {
        display: 'grid',
        gridTemplateColumns: 'repeat(7, 1fr)',
        borderBottomWidth: '1px',
        borderBottomColor: 'line',
        borderBottomStyle: 'solid',
        childExtends: 'CalMonthDayHeader',
        childrenAs: 'state',
        children: (el)=>el.call('getDayNames').map((d)=>({
                    label: d
                }))
    },
    Grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(7, 1fr)',
        gridTemplateRows: 'repeat(6, 1fr)',
        flex: '1',
        overflow: 'hidden',
        childExtends: 'CalMonthDayCell',
        childrenAs: 'state',
        children: (el, s)=>{
            const root = s.root;
            return el.call('getMonthDays', root.currentYear, root.currentMonth);
        }
    }
};
const $59108ca4128ea207$export$e2e0d9f59cf7cc83 = {
    tag: 'span',
    padding: 'Z1 A',
    fontSize: 'Y2',
    fontWeight: '500',
    color: 'caption',
    align: 'center left',
    text: (el, s)=>s.label || ''
};
const $59108ca4128ea207$export$637f1acf6404a040 = {
    flow: 'y',
    borderRightWidth: '1px',
    borderRightColor: 'line',
    borderRightStyle: 'solid',
    borderBottomWidth: '1px',
    borderBottomColor: 'line',
    borderBottomStyle: 'solid',
    padding: 'Z',
    overflow: 'hidden',
    cursor: 'pointer',
    minHeight: '0',
    background: (el, s)=>{
        if (!s.isOtherMonth && el.call('isToday', s.year, s.month, s.day)) return 'selectedDay';
        return 'transparent';
    },
    ':hover': {
        background: 'overlay'
    },
    onClick: (e, el, s)=>{
        const root = el.state.root;
        root.update({
            currentDay: s.day,
            currentMonth: s.month,
            currentYear: s.year,
            showNewBooking: true,
            newBooking: (0, $kZOF8.freshBooking)({
                date: el.call('formatDate', s.year, s.month, s.day)
            })
        });
    },
    DayNum: {
        tag: 'span',
        width: 'B',
        height: 'B',
        round: '50%',
        align: 'center center',
        fontSize: 'Z2',
        fontWeight: (el, s)=>el.call('isToday', s.year, s.month, s.day) ? '700' : '400',
        background: (el, s)=>el.call('isToday', s.year, s.month, s.day) ? 'blue' : 'transparent',
        color: (el, s)=>{
            if (s.isOtherMonth) return 'caption';
            if (el.call('isToday', s.year, s.month, s.day)) return 'white';
            return 'title';
        },
        opacity: (el, s)=>s.isOtherMonth ? '.35' : '1',
        text: (el, s)=>String(s.day),
        marginBottom: 'Y2'
    },
    Events: {
        flow: 'y',
        gap: 'Y2',
        overflow: 'hidden',
        flex: '1',
        childExtends: 'CalEventChip',
        childrenAs: 'state',
        children: (el, s)=>{
            const root = el.state.root;
            return el.call('getEventsForDay', root.events, s.year, s.month, s.day).filter((ev)=>!ev.type || ev.type === 'meeting' || ev.type === 'general').slice(0, 3);
        }
    }
};
const $59108ca4128ea207$export$983e5546d5de7e4c = {
    tag: 'button',
    flow: 'x',
    align: 'center left',
    padding: 'Y2 Z',
    round: 'Y',
    border: 'none',
    cursor: 'pointer',
    fontSize: 'Y2',
    fontWeight: '500',
    overflow: 'hidden',
    width: '100%',
    color: 'white',
    background: (el, s)=>s.type === 'general' ? 'blue' : 'green',
    ':hover': {
        opacity: '.85'
    },
    onClick: (e, el, s)=>{
        e.stopPropagation();
        const root = el.state.root;
        root.update({
            selectedEvent: s,
            showEventDetail: true
        });
        if (s.invitees === undefined || s.description === undefined) (0, $kZOF8.fetchEventDetails)(s.id, root);
    },
    Time: {
        tag: 'span',
        text: (el, s)=>s.startTime || '',
        opacity: '.8',
        marginRight: 'Y2',
        whiteSpace: 'nowrap'
    },
    Title: {
        tag: 'span',
        text: (el, s)=>s.title || '',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }
};

});

parcelRegister("7N5GO", function(module, exports) {

$parcel$export(module.exports, "CalWeekView", () => $5ac185d2be3acc71$export$22f6fb067c652c9e);
$parcel$export(module.exports, "CalWeekDayHeader", () => $5ac185d2be3acc71$export$a6c02739e83d6990);
$parcel$export(module.exports, "CalTimeLabel", () => $5ac185d2be3acc71$export$b55025dde18bd4d8);
$parcel$export(module.exports, "CalWeekDayColumn", () => $5ac185d2be3acc71$export$30aa2dfcc64fc0cd);
$parcel$export(module.exports, "CalDragOverlayGhost", () => $5ac185d2be3acc71$export$f1a9595e1b5ec2db);
$parcel$export(module.exports, "CalDragMoveGhost", () => $5ac185d2be3acc71$export$b2ed4c7458cdcf1e);
$parcel$export(module.exports, "CalHourLine", () => $5ac185d2be3acc71$export$9cf2422321a6b177);
$parcel$export(module.exports, "CalDragPreview", () => $5ac185d2be3acc71$export$b8903578ca936760);
$parcel$export(module.exports, "CalWeekEvent", () => $5ac185d2be3acc71$export$c8bdb7a59b586d41);

var $cAMTN = parcelRequire("cAMTN");

var $kZOF8 = parcelRequire("kZOF8");
var $bglB6 = parcelRequire("bglB6");
const $5ac185d2be3acc71$export$22f6fb067c652c9e = {
    flow: 'y',
    flex: '1',
    overflow: 'hidden',
    userSelect: 'none',
    display: (el, s)=>s.root.viewMode === 'week' ? 'flex' : 'none',
    // Banner shown when the week view is scoped to another user (via the
    // profile modal "Open week view" action). Clearing it returns to the
    // current user's own week.
    ViewingAsBanner: {
        display: (el, s)=>s.root.viewOnlyEmail ? 'flex' : 'none',
        flow: 'x',
        align: 'center space-between',
        gap: 'Z',
        padding: 'Z A',
        background: 'overlay',
        borderBottomWidth: '1px',
        borderBottomColor: 'line',
        borderBottomStyle: 'solid',
        Text: {
            tag: 'span',
            fontSize: 'Z2',
            color: 'title',
            text: (el, s)=>{
                const email = s.root.viewOnlyEmail;
                if (!email) return '';
                const target = el.call('findPerson', email);
                return `Viewing ${target?.name || email}'s week`;
            }
        },
        ClearBtn: {
            tag: 'button',
            text: 'Back to my week',
            padding: 'Y Z',
            round: 'Z',
            theme: 'secondary',
            borderWidth: '1px',
            borderColor: 'line',
            borderStyle: 'solid',
            cursor: 'pointer',
            fontSize: 'Y2',
            ':hover': {
                background: 'overlay'
            },
            onClick: (e, el, s)=>s.root.update({
                    viewOnlyEmail: null
                })
        }
    },
    DayHeaders: {
        flow: 'x',
        borderBottomWidth: '1px',
        borderBottomColor: 'line',
        borderBottomStyle: 'solid',
        minHeight: 'D',
        TimeGutter: {
            width: 'E',
            minWidth: 'E',
            borderRightWidth: '1px',
            borderRightColor: 'line',
            borderRightStyle: 'solid',
            userSelect: 'none'
        },
        Days: {
            flex: '1',
            display: 'grid',
            gridTemplateColumns: 'repeat(7, 1fr)',
            childExtends: 'CalWeekDayHeader',
            childrenAs: 'state',
            children: (el, s)=>{
                const root = s.root;
                return el.call('getWeekDays', root.currentYear, root.currentMonth, root.currentDay);
            }
        }
    },
    ScrollBody: {
        flex: '1',
        overflow: 'auto',
        position: 'relative',
        flow: 'x',
        userSelect: 'none',
        // Don't stretch flex items to viewport height — let TimeGutter and
        // DayColumns expand to their intrinsic 24*hour-row content height so
        // their borders span the full scrollable area.
        alignItems: 'flex-start',
        TimeGutter: {
            width: 'E',
            minWidth: 'E',
            borderRightWidth: '1px',
            borderRightColor: 'line',
            borderRightStyle: 'solid',
            flow: 'y',
            userSelect: 'none',
            childExtends: 'CalTimeLabel',
            childrenAs: 'state',
            children: (el)=>el.call('getHours').map((h)=>({
                        label: h.label,
                        h: h.h
                    }))
        },
        DayColumns: {
            flex: '1',
            display: 'grid',
            gridTemplateColumns: 'repeat(7, 1fr)',
            position: 'relative',
            childExtends: 'CalWeekDayColumn',
            childrenAs: 'state',
            children: (el, s)=>{
                const root = s.root;
                return el.call('getWeekDays', root.currentYear, root.currentMonth, root.currentDay);
            }
        }
    }
};
const $5ac185d2be3acc71$export$a6c02739e83d6990 = {
    flow: 'y',
    align: 'center center',
    padding: 'Z1',
    borderRightWidth: '1px',
    borderRightColor: 'line',
    borderRightStyle: 'solid',
    gap: 'Y2',
    cursor: 'pointer',
    ':hover': {
        background: 'overlay'
    },
    // Click the header → open the booking modal pre-set as a whole-day event
    // for that date. Useful for holidays and OOO blocks.
    onClick: (e, el, s)=>{
        const date = el.call('formatDate', s.year, s.month, s.day);
        s.root.update({
            showNewBooking: true,
            newBooking: (0, $kZOF8.freshBooking)({
                date: date,
                startTime: '00:00',
                endTime: '23:59',
                allDay: true,
                type: 'busy'
            })
        });
    },
    DayName: {
        tag: 'span',
        fontSize: 'Y2',
        fontWeight: '500',
        color: 'caption',
        text: (el, s)=>s.dayName || ''
    },
    DayNum: {
        tag: 'span',
        width: 'B1',
        height: 'B1',
        round: '50%',
        align: 'center center',
        fontSize: 'B',
        fontWeight: '400',
        background: (el, s)=>el.call('isToday', s.year, s.month, s.day) ? 'blue' : 'transparent',
        color: (el, s)=>el.call('isToday', s.year, s.month, s.day) ? 'white' : 'title',
        text: (el, s)=>String(s.day)
    }
};
const $5ac185d2be3acc71$export$b55025dde18bd4d8 = {
    height: '56px',
    minHeight: '56px',
    padding: 'Y 0 0 Z',
    fontSize: 'Y2',
    color: 'caption',
    align: 'flex-start right',
    paddingRight: 'Z1',
    text: (el, s)=>s.h === 0 ? '' : s.label
};
const $5ac185d2be3acc71$export$30aa2dfcc64fc0cd = {
    position: 'relative',
    borderRightWidth: '1px',
    borderRightColor: 'line',
    borderRightStyle: 'solid',
    cursor: 'cell',
    attr: {
        'data-cal-week-col-date': (el, s)=>el.call('formatDate', s.year, s.month, s.day)
    },
    // Click / double-click / drag to create. Drag also paints a live preview
    // (CalDragPreview) that follows the cursor in real time.
    onDblClick: (e, el, s)=>{
        if (e.target.closest('button')) return;
        const rect = el.node.getBoundingClientRect();
        const offsetY = e.clientY - rect.top;
        const startTime = el.call('pxToTime', offsetY);
        const endTime = el.call('addMinutes', startTime, 60);
        const root = s.root;
        root.update({
            showNewBooking: true,
            newBooking: (0, $kZOF8.freshBooking)({
                date: el.call('formatDate', s.year, s.month, s.day),
                startTime: startTime,
                endTime: endTime,
                type: 'meeting'
            })
        });
    },
    onMousedown: (e, el, s)=>{
        if (e.target.closest('button')) return;
        const rect = el.node.getBoundingClientRect();
        el._dragStartY = e.clientY - rect.top;
        el._dragMoved = false;
        const startTime = el.call('pxToTime', el._dragStartY);
        s.root.update({
            dragPreview: {
                date: el.call('formatDate', s.year, s.month, s.day),
                startTime: startTime,
                endTime: el.call('addMinutes', startTime, 30),
                color: s.root.newBooking?.color || 'blue'
            }
        });
    },
    onMousemove: (e, el, s)=>{
        if (el._dragStartY == null) return;
        const rect = el.node.getBoundingClientRect();
        const curY = e.clientY - rect.top;
        if (Math.abs(curY - el._dragStartY) > 5) el._dragMoved = true;
        const y0 = Math.min(el._dragStartY, curY);
        const y1 = Math.max(el._dragStartY, curY);
        const startTime = el.call('pxToTime', y0);
        const endTime = el.call('pxToTime', y1);
        const finalEnd = endTime > startTime ? endTime : el.call('addMinutes', startTime, 30);
        s.root.update({
            dragPreview: {
                date: el.call('formatDate', s.year, s.month, s.day),
                startTime: startTime,
                endTime: finalEnd,
                color: s.root.newBooking?.color || 'blue'
            }
        });
    },
    onMouseup: (e, el, s)=>{
        if (el._dragStartY == null) return;
        const rect = el.node.getBoundingClientRect();
        const startY = el._dragStartY;
        const endY = e.clientY - rect.top;
        const dragMoved = el._dragMoved;
        el._dragStartY = null;
        el._dragMoved = false;
        // A plain click (no drag) should NOT create a slot — only drag-out
        // selections open the quick-create overlay.
        if (!dragMoved) return;
        const y0 = Math.min(startY, endY);
        const y1 = Math.max(startY, endY);
        const startTime = el.call('pxToTime', y0);
        const endTime = el.call('pxToTime', y1);
        const root = s.root;
        // Keep the dragPreview alive as a pending slot the user can still drag
        // around while the QuickCreate popover is showing.
        const dateStr = el.call('formatDate', s.year, s.month, s.day);
        const colRect = el.node.getBoundingClientRect();
        // Anchor the popover at the TOP of the slot (not the cursor) so it
        // visually aligns with the start of the dragged-out time block.
        const slotTop = colRect.top + el.call('eventToTop', startTime);
        const pos = (0, $cAMTN.clampToViewport)(colRect.right + 8, slotTop);
        root.update({
            dragPreview: {
                date: dateStr,
                startTime: startTime,
                endTime: endTime,
                color: 'green',
                pending: true
            },
            quickCreate: {
                date: dateStr,
                startTime: startTime,
                endTime: endTime,
                memberEmails: [],
                title: '',
                x: pos.x,
                y: pos.y
            }
        });
    },
    onMouseleave: (e, el, s)=>{
        if (el._dragStartY != null) {
            el._dragStartY = null;
            el._dragMoved = false;
            s.root.update({
                dragPreview: null
            });
        }
    },
    // HourLines flows naturally (not absolute) so the column has intrinsic
    // height = 24 * hour-row-height. Without this the column collapses to the
    // visible viewport and the right border ends mid-scroll.
    HourLines: {
        flow: 'y',
        pointerEvents: 'none',
        childExtends: 'CalHourLine',
        childrenAs: 'state',
        children: (el)=>el.call('getHours').map((h, i)=>({
                    h: i
                }))
    },
    // Show the CURRENT user's own unavailable bands (off-hours + busy/ooo
    // events from events array), tz-aware, on every visible day.
    Unavailable: {
        position: 'absolute',
        inset: '0',
        pointerEvents: 'none',
        childExtends: 'CalUnavailableSlot',
        childrenAs: 'state',
        children: (el, s)=>{
            const root = s.root;
            if (!root) return [];
            root.currentMinutes;
            const me = (0, $bglB6.currentUser)(root);
            if (!me) return [];
            const baseMs = new Date(s.year, s.month, s.day, 0, 0).getTime();
            const myEvents = (root.events || []).filter((ev)=>ev.googleCalendarId === root.currentUserEmail || !ev.googleCalendarId && ev.creatorEmail === root.currentUserEmail);
            return el.call('getUnavailableRanges', me, baseMs, 1440, 15, myEvents);
        }
    },
    Events: {
        position: 'absolute',
        inset: '0',
        padding: '0 2px',
        pointerEvents: 'none',
        childExtends: 'CalWeekEvent',
        childrenAs: 'state',
        children: (el, s)=>{
            const root = s.root;
            if (!root) return [];
            // Only meetings render as event chips. Busy/ooo show via the
            // Unavailable layer above as red bands. `viewOnlyEmail` is set when the
            // user opens "Open week view" from a person profile modal.
            const me = root.viewOnlyEmail || root.currentUserEmail;
            const mine = (root.events || []).filter((ev)=>ev.googleCalendarId === me || !ev.googleCalendarId && ev.creatorEmail === me);
            const dayEvents = el.call('getEventsForDay', mine, s.year, s.month, s.day).filter((ev)=>!ev.type || ev.type === 'meeting' || ev.type === 'busy' || ev.type === 'general');
            return (0, $kZOF8.assignLanes)(dayEvents);
        }
    },
    CalDragPreview: {},
    CalDragMoveGhost: {},
    // "Now" indicator — only renders in today's column. Line spans the column
    // width; the dot is centered on the line at the column's left edge.
    // NOTE: child keys are NowBar/NowDot (not Line/Dot) to avoid implicit
    // extension of brand's `Line` component which has its own margin/height.
    NowIndicator: {
        display: (el, s)=>el.call('isToday', s.year, s.month, s.day) ? 'block' : 'none',
        position: 'absolute',
        left: '0',
        right: '0',
        height: '0',
        zIndex: 5,
        pointerEvents: 'none',
        top: (el, s)=>`${(s?.root?.currentMinutes || 0) / 60 * 56}px`,
        NowBar: {
            position: 'absolute',
            left: '0',
            right: '0',
            top: '0',
            height: '2px',
            transform: 'translateY(-50%)',
            background: 'red'
        },
        NowDot: {
            position: 'absolute',
            left: '0',
            top: '0',
            width: '12px',
            height: '12px',
            transform: 'translate(-50%, -50%)',
            round: '50%',
            background: 'red'
        }
    }
};
const $5ac185d2be3acc71$export$f1a9595e1b5ec2db = {
    display: (el, s)=>{
        const ov = s?.root?.dragOverlay;
        if (!ov) return 'none';
        const colDate = el.call('formatDate', s.year, s.month, s.day);
        return ov.date === colDate ? 'flex' : 'none';
    },
    position: 'absolute',
    left: '2px',
    right: '2px',
    round: 'Z',
    padding: 'Y2 Z',
    zIndex: 3,
    flow: 'y',
    color: 'white',
    fontSize: 'Y2',
    fontWeight: '500',
    opacity: '.85',
    borderWidth: '2px',
    borderStyle: 'dashed',
    borderColor: 'white.6',
    pointerEvents: 'none',
    background: 'green',
    top: (el, s)=>`${el.call('eventToTop', s?.root?.dragOverlay?.startTime || '00:00')}px`,
    height: (el, s)=>`${el.call('eventToHeight', s?.root?.dragOverlay?.startTime || '00:00', s?.root?.dragOverlay?.endTime || '00:30')}px`,
    Time: {
        tag: 'span',
        text: (el, s)=>`${s?.root?.dragOverlay?.startTime || ''} \u{2013} ${s?.root?.dragOverlay?.endTime || ''}`
    }
};
const $5ac185d2be3acc71$export$b2ed4c7458cdcf1e = {
    display: (el, s)=>{
        const dm = s?.root?.dragMove;
        if (!dm) return 'none';
        return dm.date === el.call('formatDate', s.year, s.month, s.day) ? 'flex' : 'none';
    },
    position: 'absolute',
    left: '2px',
    right: '2px',
    round: 'Z',
    padding: 'Y2 Z',
    zIndex: 6,
    flow: 'y',
    color: 'white',
    fontSize: 'Y2',
    fontWeight: '500',
    opacity: '.85',
    borderWidth: '2px',
    borderStyle: 'dashed',
    borderColor: 'white.6',
    pointerEvents: 'none',
    background: 'green',
    top: (el, s)=>`${el.call('eventToTop', s?.root?.dragMove?.startTime || '00:00')}px`,
    height: (el, s)=>`${el.call('eventToHeight', s?.root?.dragMove?.startTime || '00:00', s?.root?.dragMove?.endTime || '00:30')}px`,
    Time: {
        tag: 'span',
        text: (el, s)=>`${s?.root?.dragMove?.startTime || ''} \u{2013} ${s?.root?.dragMove?.endTime || ''}`
    }
};
const $5ac185d2be3acc71$export$9cf2422321a6b177 = {
    height: '56px',
    minHeight: '56px',
    borderBottomWidth: '1px',
    borderBottomColor: 'line',
    borderBottomStyle: 'solid'
};
const $5ac185d2be3acc71$export$b8903578ca936760 = {
    display: (el, s)=>{
        const dp = s?.root?.dragPreview;
        if (!dp) return 'none';
        return dp.date === el.call('formatDate', s.year, s.month, s.day) ? 'flex' : 'none';
    },
    position: 'absolute',
    left: '2px',
    right: '2px',
    round: 'Z',
    padding: 'Y2 Z',
    zIndex: 4,
    flow: 'y',
    color: 'white',
    fontSize: 'Y2',
    fontWeight: '500',
    opacity: '.85',
    borderWidth: '2px',
    borderStyle: 'dashed',
    borderColor: 'white.5',
    // Slot color reflects the currently-selected event type — meeting=green, general=blue, busy=red.
    background: (el, s)=>{
        const t = s?.root?.quickCreate?.type || s?.root?.newBooking?.type || 'meeting';
        if (t === 'general') return 'blue';
        if (t === 'busy') return 'red';
        return 'green';
    },
    top: (el, s)=>`${el.call('eventToTop', s?.root?.dragPreview?.startTime || '00:00')}px`,
    height: (el, s)=>`${el.call('eventToHeight', s?.root?.dragPreview?.startTime || '00:00', s?.root?.dragPreview?.endTime || '00:30')}px`,
    // Pending mode is interactive (grab to move). Active drag is non-interactive.
    pointerEvents: (el, s)=>s?.root?.dragPreview?.pending ? 'auto' : 'none',
    cursor: 'grab',
    onMousedown: (e, el, s)=>{
        const root = s?.root;
        const dp = root?.dragPreview;
        if (!dp?.pending) return;
        e.stopPropagation();
        root.update({
            activePendingMove: {
                startX: e.clientX,
                startY: e.clientY,
                origDate: dp.date,
                origStart: dp.startTime,
                origEnd: dp.endTime
            }
        });
    },
    Time: {
        tag: 'span',
        text: (el, s)=>`${s?.root?.dragPreview?.startTime || ''} \u{2013} ${s?.root?.dragPreview?.endTime || ''}`,
        opacity: '.95'
    }
};
const $5ac185d2be3acc71$export$c8bdb7a59b586d41 = {
    tag: 'div',
    position: 'absolute',
    // Cascaded stack layout for overlapping events. Each successive lane is
    // offset horizontally, and later lanes extend to the column's right edge
    // so they sit on top of prior ones while still leaving a clickable sliver
    // of each earlier event exposed on the left.
    left: (el, s)=>{
        const lanes = s._lanes || 1;
        const lane = s._lane || 0;
        if (lanes <= 1) return '2px';
        return `calc(${lane / lanes * 100}% + 2px)`;
    },
    width: (el, s)=>{
        const lanes = s._lanes || 1;
        const lane = s._lane || 0;
        if (lanes <= 1) return 'calc(100% - 4px)';
        // Extend every stacked card to the column's right edge; the higher lane
        // sits on top (zIndex below) and earlier cards peek out from behind.
        return `calc(${(1 - lane / lanes) * 100}% - 4px)`;
    },
    zIndex: (el, s)=>{
        // Later lanes sit on top so the stack cascades front-to-back naturally.
        // Hover / focus bumps above the rest via the existing :hover rule.
        return 2 + (s._lane || 0);
    },
    // Stacked-event left separator. v3.14 DOMQL doesn't honor reactive
    // border* longhands here, so we draw the slit with a `boxShadow` inset
    // which always paints. Dark translucent for contrast against any of the
    // event background colors (green / blue / red).
    boxShadow: (el, s)=>(s._lanes || 1) > 1 && (s._lane || 0) > 0 ? 'inset 2px 0 0 var(--color-shadow)' : 'none',
    round: 'Z',
    padding: 'Y2 Z',
    cursor: 'grab',
    overflow: 'hidden',
    color: 'white',
    fontSize: 'Y2',
    fontWeight: '500',
    flow: 'y',
    align: 'flex-start flex-start',
    pointerEvents: 'auto',
    userSelect: 'none',
    // 3-type color scheme:
    //   - meeting (default)        → green (booked, ad-hoc)
    //   - general (company-wide)   → blue
    //   - busy/ooo                 → never reach this container (filtered out)
    background: (el, s)=>{
        // Private events (superadmin meetings, external creators) render as a
        // plain green "Meeting" chip for non-creators — no detail leak.
        if ((0, $kZOF8.eventIsPrivateFor)(s, (0, $bglB6.currentUser)(s?.root))) return 'green';
        if (s.type === 'general') return 'blue';
        if (s.type === 'busy') return 'red';
        return 'green';
    },
    // Proposal events (a participant has suggested a new time/day) render with
    // reduced opacity + dashed border until the creator confirms. Live drag
    // also dims the source while a ghost shows the new position.
    opacity: (el, s)=>{
        const dm = s?.root?.dragMove;
        if (dm && dm.id === s.id) return '.35';
        return s.isProposal ? '.55' : '1';
    },
    borderWidth: (el, s)=>s.isProposal ? '2px' : '0',
    borderStyle: (el, s)=>s.isProposal ? 'dashed' : 'none',
    borderColor: 'white.6',
    // Position is reactive against the canonical event state. During a drag
    // the move handler writes directly to this node's inline style.top/height
    // (bypassing reactivity) for smooth per-frame motion, then commits the
    // final position to root.events on mouseup so this getter takes over.
    top: (el, s)=>`${el.call('eventToTop', s.startTime)}px`,
    height: (el, s)=>`${el.call('eventToHeight', s.startTime, s.endTime)}px`,
    attr: {
        'data-cal-event-id': (el, s)=>String(s.id || '')
    },
    ':hover': {
        opacity: '.95',
        zIndex: 1
    },
    ':active': {
        cursor: 'grabbing'
    },
    // Drag the body to move. Resize handles below stop propagation to prevent
    // this from also kicking in. Distinguish click vs drag with a 5px threshold.
    onMousedown: (e, el, s)=>{
        e.stopPropagation();
        el._downY = e.clientY;
        el._moved = false;
        el.state.root.update({
            activeMove: {
                id: s.id,
                mode: 'move',
                startY: e.clientY,
                origStart: s.startTime,
                origEnd: s.endTime,
                origDate: s.date
            }
        });
    },
    // Lock the team-view hover preview to this event's start time while the
    // cursor is over the event. stopPropagation prevents the parent column /
    // ScrollBody mousemove from overwriting hoverTime with the cursor's Y.
    onMouseenter: (e, el, s)=>{
        el.state.root.update({
            hoverTime: s.startTime
        });
    },
    onMousemove: (e, el)=>{
        e.stopPropagation();
        if (el._downY != null && Math.abs(e.clientY - el._downY) > 5) el._moved = true;
    },
    onMouseleave: (e, el, s)=>{
        // Clear so the next ScrollBody mousemove can resume cursor-tracking.
        if (el.state.root.hoverTime != null) el.state.root.update({
            hoverTime: null
        });
    },
    onClick: (e, el, s)=>{
        e.stopPropagation();
        if (el._moved) {
            el._moved = false;
            el._downY = null;
            return;
        }
        el._downY = null;
        const root = s.root;
        root.update({
            selectedEvent: s,
            showEventDetail: true
        });
        if (s.invitees === undefined || s.description === undefined) (0, $kZOF8.fetchEventDetails)(s.id, root);
    },
    Title: {
        tag: 'span',
        text: (el, s)=>{
            if ((0, $kZOF8.eventIsPrivateFor)(s, (0, $bglB6.currentUser)(s.root))) return 'Meeting';
            return s.title || '';
        },
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        width: '100%',
        lineHeight: '1.2',
        flexShrink: '0'
    },
    // Hide the time row on slot-sized events (≤30 min) so the title gets the
    // limited vertical space instead of being clipped behind the time string.
    Time: {
        tag: 'span',
        text: (el, s)=>`${s.startTime} \u{2013} ${s.endTime}`,
        opacity: '.8',
        display: (el, s)=>{
            const [sh, sm] = (s.startTime || '00:00').split(':').map(Number);
            const [eh, em] = (s.endTime || '00:00').split(':').map(Number);
            let mins = eh * 60 + em - (sh * 60 + sm);
            if (mins <= 0) mins += 1440;
            return mins <= 30 ? 'none' : 'block';
        }
    },
    // Top resize handle — drag to change start time
    ResizeTop: {
        position: 'absolute',
        top: '0',
        left: '0',
        right: '0',
        height: '6px',
        cursor: 'ns-resize',
        background: 'transparent',
        onMousedown: (e, el, s)=>{
            e.stopPropagation();
            const ev = el.parent;
            ev._moved = true // prevent click-as-open after resize
            ;
            el.state.root.update({
                activeMove: {
                    id: s.id,
                    mode: 'resize-top',
                    startY: e.clientY,
                    origStart: s.startTime,
                    origEnd: s.endTime,
                    origDate: s.date
                }
            });
        }
    },
    // Bottom resize handle — drag to change end time
    ResizeBottom: {
        position: 'absolute',
        bottom: '0',
        left: '0',
        right: '0',
        height: '6px',
        cursor: 'ns-resize',
        background: 'transparent',
        onMousedown: (e, el, s)=>{
            e.stopPropagation();
            const ev = el.parent;
            ev._moved = true;
            el.state.root.update({
                activeMove: {
                    id: s.id,
                    mode: 'resize-bottom',
                    startY: e.clientY,
                    origStart: s.startTime,
                    origEnd: s.endTime,
                    origDate: s.date
                }
            });
        }
    }
};

});
parcelRegister("cAMTN", function(module, exports) {

$parcel$export(module.exports, "clampToViewport", () => $92aec725d2604064$export$4971382a7dbeb94a);
$parcel$export(module.exports, "CalQuickCreate", () => $92aec725d2604064$export$d90f5a9035f8d1ed);
$parcel$export(module.exports, "CalQuickTypeBtn", () => $92aec725d2604064$export$3f81d8b8ea84c8e0);
$parcel$export(module.exports, "CalQuickInvitee", () => $92aec725d2604064$export$cf506c05ee8539bf);
// Quick-create popover — shown after a drag-create on the grid instead of
// the full NewBookingModal. Lets the user name the event inline; "More
// options" promotes to the full modal. Saving commits the event directly.
//
// Position is computed at open time and CLAMPED to the viewport (so it
// never falls off the bottom or right edge).
parcelRequire("kZOF8");
var $bglB6 = parcelRequire("bglB6");
var $kZOF8 = parcelRequire("kZOF8");
// Mirrors the EVENT_TYPES list in NewBookingModal so the slot overlay offers
// the same picker without importing across files.
const $92aec725d2604064$var$QC_EVENT_TYPES = [
    {
        type: 'meeting',
        label: 'Meeting',
        color: 'green'
    },
    {
        type: 'general',
        label: 'Company event',
        color: 'blue'
    },
    {
        type: 'busy',
        label: 'Unavailable',
        color: 'red'
    }
];
const $92aec725d2604064$var$_qcIsAdmin = (0, $bglB6.currentUserIsAdmin);
const $92aec725d2604064$var$POPOVER_W = 380;
const $92aec725d2604064$var$POPOVER_H = 300;
const $92aec725d2604064$var$MARGIN = 8;
const $92aec725d2604064$export$4971382a7dbeb94a = (x, y)=>{
    const vw = typeof window !== 'undefined' ? window.innerWidth : 1920;
    const vh = typeof window !== 'undefined' ? window.innerHeight : 1080;
    let nx = x, ny = y;
    if (nx + $92aec725d2604064$var$POPOVER_W > vw) nx = Math.max($92aec725d2604064$var$MARGIN, vw - $92aec725d2604064$var$POPOVER_W - $92aec725d2604064$var$MARGIN);
    if (nx < $92aec725d2604064$var$MARGIN) nx = $92aec725d2604064$var$MARGIN;
    if (ny + $92aec725d2604064$var$POPOVER_H > vh) ny = Math.max($92aec725d2604064$var$MARGIN, vh - $92aec725d2604064$var$POPOVER_H - $92aec725d2604064$var$MARGIN);
    if (ny < $92aec725d2604064$var$MARGIN) ny = $92aec725d2604064$var$MARGIN;
    return {
        x: nx,
        y: ny
    };
};
const $92aec725d2604064$export$d90f5a9035f8d1ed = {
    display: (el, s)=>s.root.quickCreate ? 'flex' : 'none',
    position: 'fixed',
    zIndex: 1800,
    flow: 'y',
    gap: 'Z',
    padding: 'A',
    width: `${$92aec725d2604064$var$POPOVER_W}px`,
    round: 'Z2',
    theme: 'modal',
    borderWidth: '1px',
    borderColor: 'line',
    borderStyle: 'solid',
    boxShadow: '0 8px 24px var(--color-shadow)',
    top: (el, s)=>s.root.quickCreate ? `${s.root.quickCreate.y}px` : '0',
    left: (el, s)=>s.root.quickCreate ? `${s.root.quickCreate.x}px` : '0',
    onCreate: (el, s)=>{
        el._closeOnOutside = (ev)=>{
            if (!el.node) return;
            if (!el.node.contains(ev.target)) s.root.update({
                quickCreate: null,
                dragPreview: null
            });
        };
        setTimeout(()=>document.addEventListener('mousedown', el._closeOnOutside), 0);
    },
    onRemove: (el)=>{
        if (el._closeOnOutside) document.removeEventListener('mousedown', el._closeOnOutside);
    },
    Header: {
        flow: 'x',
        align: 'center space-between',
        Time: {
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            fontFamily: 'monospace',
            text: (el, s)=>{
                const qc = s.root.quickCreate;
                if (!qc) return '';
                return `${qc.date} \xb7 ${qc.startTime}\u{2013}${qc.endTime}`;
            }
        },
        CloseBtn: {
            extends: 'IconButton',
            Icon: {
                icon: 'crossmark'
            },
            onClick: (e, el, s)=>s.root.update({
                    quickCreate: null,
                    dragPreview: null
                })
        }
    },
    TitleField: {
        extends: 'InputField',
        Title: {
            text: 'Title'
        },
        Input: {
            tag: 'input',
            type: 'text',
            placeholder: 'Add a title',
            autofocus: true,
            value: (el, s)=>s.root.quickCreate?.title || '',
            onInput: (e, el, s)=>{
                s.root.update({
                    quickCreate: {
                        ...s.root.quickCreate,
                        title: e.target.value
                    }
                });
            },
            onKeydown: (e, el, s)=>{
                if (e.key === 'Enter') {
                    e.preventDefault();
                    $92aec725d2604064$var$_saveQuickCreate(s.root, el);
                }
            }
        }
    },
    // Event-type picker — same row of pills as the full modal but bound to
    // the quickCreate state slice.
    TypePicker: {
        flow: 'x',
        gap: 'Y',
        flexWrap: 'wrap',
        align: 'center left',
        childExtends: 'CalQuickTypeBtn',
        childrenAs: 'state',
        children: (el, s)=>{
            const admin = $92aec725d2604064$var$_qcIsAdmin(s.root);
            return $92aec725d2604064$var$QC_EVENT_TYPES.filter((t)=>admin || !t.adminOnly);
        }
    },
    // Per-invitee local time strip — same data as the modal's pills, but
    // only the first 3 fit here.
    Invitees: {
        display: (el, s)=>{
            const qc = s.root.quickCreate;
            return (qc?.memberEmails?.length || 0) > 0 ? 'flex' : 'none';
        },
        flow: 'x',
        gap: 'Y',
        flexWrap: 'wrap',
        childExtends: 'CalQuickInvitee',
        childrenAs: 'state',
        children: (el, s)=>{
            const qc = s.root.quickCreate;
            if (!qc?.memberEmails) return [];
            const set = new Set(qc.memberEmails);
            return (s.root.people || []).filter((p)=>set.has(p.email)).slice(0, 4);
        }
    },
    Footer: {
        flow: 'x',
        align: 'center space-between',
        gap: 'Z',
        MoreBtn: {
            tag: 'button',
            text: 'More options',
            padding: 'Y Z',
            round: 'Z',
            theme: 'secondary',
            borderWidth: '1px',
            borderColor: 'line',
            borderStyle: 'solid',
            cursor: 'pointer',
            fontSize: 'Y2',
            onClick: (e, el, s)=>{
                // Promote to the full booking modal with the quick-create payload.
                const qc = s.root.quickCreate;
                if (!qc) return;
                s.root.update({
                    quickCreate: null,
                    dragPreview: null,
                    showNewBooking: true,
                    newBooking: (0, $kZOF8.freshBooking)({
                        title: qc.title || '',
                        date: qc.date,
                        startTime: qc.startTime,
                        endTime: qc.endTime,
                        invitees: (qc.memberEmails || []).join(', '),
                        type: qc.type || 'meeting'
                    })
                });
            }
        },
        SaveBtn: {
            tag: 'button',
            text: 'Save',
            padding: 'Y A',
            round: 'Z',
            theme: 'primary',
            border: 'none',
            cursor: 'pointer',
            fontSize: 'Z2',
            fontWeight: '600',
            onClick: (e, el, s)=>$92aec725d2604064$var$_saveQuickCreate(s.root, el)
        }
    }
};
const $92aec725d2604064$var$_saveQuickCreate = (root, el)=>{
    const qc = root.quickCreate;
    if (!qc) return;
    const ev = {
        id: Date.now(),
        title: qc.title || 'Untitled',
        date: qc.date,
        startTime: qc.startTime,
        endTime: qc.endTime,
        type: qc.type || 'meeting',
        invitees: qc.memberEmails || [],
        description: '',
        creatorEmail: root.currentUserEmail
    };
    root.update({
        events: [
            ...root.events || [],
            ev
        ],
        quickCreate: null,
        dragPreview: null
    });
    // Persist to Supabase + trigger Google sync. Patch the optimistic id with
    // the real autoincrement id once the upsert resolves.
    if (el) el.call('saveEventToSupabase', ev).then((realId)=>{
        if (!realId) return;
        root.update({
            events: (root.events || []).map((e)=>e.id === ev.id ? {
                    ...e,
                    id: realId
                } : e)
        });
    });
};
const $92aec725d2604064$export$3f81d8b8ea84c8e0 = {
    tag: 'button',
    flow: 'x',
    align: 'center center',
    gap: 'Y',
    padding: 'Y Z',
    round: 'C',
    borderWidth: '1px',
    borderStyle: 'solid',
    cursor: 'pointer',
    fontSize: 'Y2',
    fontWeight: '500',
    height: 'B1',
    minHeight: 'B1',
    borderColor: (el, s)=>{
        const cur = el.state.root.quickCreate?.type || 'meeting';
        return cur === s.type ? 'transparent' : 'line';
    },
    background: (el, s)=>{
        const cur = el.state.root.quickCreate?.type || 'meeting';
        return cur === s.type ? 'line' : 'transparent';
    },
    color: (el, s)=>{
        const cur = el.state.root.quickCreate?.type || 'meeting';
        return cur === s.type ? s.color : 'title';
    },
    ':hover': {
        opacity: '.9'
    },
    onClick: (e, el, s)=>{
        e.preventDefault();
        el.state.root.update({
            quickCreate: {
                ...el.state.root.quickCreate,
                type: s.type
            }
        });
    },
    Dot: {
        width: 'Y2',
        height: 'Y2',
        round: '50%',
        background: (el, s)=>s.color
    },
    Label: {
        tag: 'span',
        text: (el, s)=>s.label
    }
};
const $92aec725d2604064$export$cf506c05ee8539bf = {
    flow: 'x',
    align: 'center left',
    gap: 'Y',
    padding: 'Y Z',
    round: 'C',
    background: 'overlay',
    Avatar: {
        avatarType: 'initials',
        boxSize: 'Z2 Z2',
        src: (el, s)=>el.call('avatarUrl', s.name)
    },
    Name: {
        tag: 'span',
        fontSize: 'Y2',
        color: 'title',
        text: (el, s)=>(s.name || '').split(' ')[0]
    },
    LocalTime: {
        tag: 'span',
        fontSize: 'Y2',
        color: 'caption',
        fontFamily: 'monospace',
        text: (el, s)=>{
            const qc = el.state.root.quickCreate;
            if (!qc || !s.timezone) return '';
            const sMs = (0, $kZOF8.eventUtcMs)(qc.date, qc.startTime || '00:00');
            return (0, $kZOF8.formatTzTime)(sMs, s.timezone);
        }
    }
};

});


parcelRegister("aMq03", function(module, exports) {

$parcel$export(module.exports, "CalTeamView", () => $7d928e19513f6e24$export$83533f33331fb172);
$parcel$export(module.exports, "CalUnavailableSlot", () => $7d928e19513f6e24$export$698e5c8d823b8ca3);
$parcel$export(module.exports, "CalTeamMemberHeader", () => $7d928e19513f6e24$export$60b4ff76aeb19d28);
$parcel$export(module.exports, "CalTeamMemberColumn", () => $7d928e19513f6e24$export$74d9d52333ff3c2b);
// Team view: a single-day view with one column per active team member.
// Events render in their owner's column based on the invitees list.
// Drag-create in a column auto-fills the booking modal's invitees with that
// member's email so the new event lands in the right column.

var $kZOF8 = parcelRequire("kZOF8");
const $7d928e19513f6e24$var$HOUR_PX = 56;
const $7d928e19513f6e24$export$83533f33331fb172 = {
    flow: 'y',
    flex: '1',
    overflow: 'hidden',
    userSelect: 'none',
    display: (el, s)=>s.root.viewMode === 'team' ? 'flex' : 'none',
    DayHeaders: {
        flow: 'x',
        borderBottomWidth: '1px',
        borderBottomColor: 'line',
        borderBottomStyle: 'solid',
        minHeight: 'D1',
        TimeGutter: {
            width: 'E',
            minWidth: 'E',
            borderRightWidth: '1px',
            borderRightColor: 'line',
            borderRightStyle: 'solid',
            userSelect: 'none'
        },
        Members: {
            flex: '1',
            flow: 'x',
            overflow: 'hidden',
            childExtends: 'CalTeamMemberHeader',
            childrenAs: 'state',
            children: (el, s)=>{
                const root = s.root;
                // Always exclude advisors from the calendar team views.
                const all = el.call('activeMembers');
                const sel = root.teamMembers || [];
                // Empty teamMembers list = "show everyone" (no per-user filter set yet).
                if (!sel.length) return all;
                const visible = new Set(sel);
                return all.filter((p)=>visible.has(p.email));
            }
        }
    },
    ScrollBody: {
        flex: '1',
        overflow: 'auto',
        position: 'relative',
        flow: 'x',
        userSelect: 'none',
        alignItems: 'flex-start',
        // Live time-on-hover: derive the hovered HH:MM from cursor Y inside the
        // scroll body and write it into root.hoverTime. Member-column headers
        // reactively re-format that into each person's local timezone.
        onMousemove: (e, el, s)=>{
            const rect = el.node.getBoundingClientRect();
            // Account for the parent's scrollTop because we want grid-relative Y
            const offsetY = e.clientY - rect.top + el.node.scrollTop;
            const t = el.call('pxToTime', offsetY);
            if (s.root.hoverTime !== t) s.root.update({
                hoverTime: t
            });
        },
        onMouseleave: (e, el, s)=>{
            if (s.root.hoverTime != null) s.root.update({
                hoverTime: null
            });
        },
        TimeGutter: {
            width: 'E',
            minWidth: 'E',
            borderRightWidth: '1px',
            borderRightColor: 'line',
            borderRightStyle: 'solid',
            flow: 'y',
            cursor: 'cell',
            userSelect: 'none',
            // Drag in the time gutter → company-wide event spanning all visible
            // team members. We attach the move/up listeners to the document on
            // mousedown so the gesture survives the cursor leaving the narrow
            // gutter mid-drag (a real-world hand wobble used to kill the drag).
            onMousedown: (e, el, s)=>{
                if (e.target.closest('button')) return;
                const node = el.node;
                const rect = node.getBoundingClientRect();
                const root = s.root;
                let dragMoved = false;
                const startY = e.clientY - rect.top + node.scrollTop;
                // Resolve "all visible team members" once — falls back to every
                // non-advisor person when teamMembers is empty (matches the column
                // children getter so the preview slot lights up the same set).
                const allTeam = el.call('activeMembers').map((p)=>p.email);
                const memberEmails = root.teamMembers && root.teamMembers.length ? root.teamMembers.slice() : allTeam;
                const updatePreview = (curY)=>{
                    const y0 = Math.min(startY, curY);
                    const y1 = Math.max(startY, curY);
                    const startTime = el.call('pxToTime', y0);
                    const endTime = el.call('pxToTime', y1);
                    const finalEnd = endTime > startTime ? endTime : el.call('addMinutes', startTime, 30);
                    root.update({
                        dragPreview: {
                            date: el.call('formatDate', root.currentYear, root.currentMonth, root.currentDay),
                            startTime: startTime,
                            endTime: finalEnd,
                            color: 'blue',
                            memberEmails: memberEmails
                        }
                    });
                };
                // Seed the preview at the click point.
                updatePreview(startY);
                const onMove = (ev)=>{
                    // Recompute curY relative to the gutter, not the cursor target —
                    // works whether the pointer is inside or outside the gutter.
                    const curY = ev.clientY - rect.top + node.scrollTop;
                    if (Math.abs(curY - startY) > 5) dragMoved = true;
                    updatePreview(curY);
                };
                const onUp = (ev)=>{
                    document.removeEventListener('mousemove', onMove);
                    document.removeEventListener('mouseup', onUp);
                    if (!dragMoved) {
                        root.update({
                            dragPreview: null
                        });
                        return;
                    }
                    const endY = ev.clientY - rect.top + node.scrollTop;
                    const y0 = Math.min(startY, endY);
                    const y1 = Math.max(startY, endY);
                    const startTime = el.call('pxToTime', y0);
                    const endTimeRaw = el.call('pxToTime', y1);
                    const endTime = endTimeRaw > startTime ? endTimeRaw : el.call('addMinutes', startTime, 30);
                    const allTeam = el.call('activeMembers').map((p)=>p.email);
                    const sel = root.teamMembers && root.teamMembers.length ? root.teamMembers : allTeam;
                    root.update({
                        dragPreview: null,
                        showNewBooking: true,
                        newBooking: (0, $kZOF8.freshBooking)({
                            date: el.call('formatDate', root.currentYear, root.currentMonth, root.currentDay),
                            startTime: startTime,
                            endTime: endTime,
                            invitees: sel.join(', '),
                            type: 'general'
                        })
                    });
                };
                document.addEventListener('mousemove', onMove);
                document.addEventListener('mouseup', onUp);
            },
            childExtends: 'CalTimeLabel',
            childrenAs: 'state',
            children: (el)=>el.call('getHours').map((h, i)=>({
                        label: h.label,
                        h: h.h
                    }))
        },
        // Wrapper holds the iterated columns + a non-iterated NowLineWrap.
        // (childrenAs would otherwise clobber any named child here.)
        MemberColumnsWrap: {
            flex: '1',
            flow: 'y',
            position: 'relative',
            MemberColumns: {
                flex: '1',
                flow: 'x',
                position: 'relative',
                // Horizontal drag-create across multiple member columns.
                // - Tracks start + current column INDEX via the dataset attribute
                //   each CalTeamMemberColumn writes (`data-cal-team-col-email`).
                // - Drag preview lights up every column whose email is in the
                //   spanned range.
                // - On mouseup, opens NewBookingModal with invitees = comma-joined
                //   emails of the spanned members.
                onMousedown: (e, el, s)=>{
                    if (e.target.closest('button, [data-cal-event-id]')) return;
                    const colNode = e.target.closest('[data-cal-team-col-email]');
                    if (!colNode) return;
                    const cols = Array.from(el.node.querySelectorAll('[data-cal-team-col-email]'));
                    const idx = cols.indexOf(colNode);
                    if (idx === -1) return;
                    const colRect = colNode.getBoundingClientRect();
                    el._cols = cols;
                    el._startIdx = idx;
                    el._curIdx = idx;
                    el._startY = e.clientY - colRect.top;
                    el._curY = el._startY;
                    el._dragMoved = false;
                    const startTime = el.call('pxToTime', el._startY);
                    const root = s.root;
                    root.update({
                        dragPreview: {
                            date: el.call('formatDate', root.currentYear, root.currentMonth, root.currentDay),
                            startTime: startTime,
                            endTime: el.call('addMinutes', startTime, 30),
                            color: root.newBooking?.color || 'blue',
                            memberEmails: [
                                colNode.dataset.calTeamColEmail
                            ]
                        }
                    });
                },
                onMousemove: (e, el, s)=>{
                    if (el._cols == null) return;
                    // Find current column under cursor (snap to existing one if outside)
                    let curCol = document.elementFromPoint(e.clientX, e.clientY);
                    curCol = curCol?.closest?.('[data-cal-team-col-email]');
                    if (curCol && el._cols.indexOf(curCol) !== -1) el._curIdx = el._cols.indexOf(curCol);
                    const startCol = el._cols[el._startIdx];
                    const startRect = startCol.getBoundingClientRect();
                    el._curY = e.clientY - startRect.top;
                    if (Math.abs(el._curY - el._startY) > 5 || el._curIdx !== el._startIdx) el._dragMoved = true;
                    const y0 = Math.min(el._startY, el._curY);
                    const y1 = Math.max(el._startY, el._curY);
                    const startTime = el.call('pxToTime', y0);
                    const endTime = el.call('pxToTime', y1);
                    const finalEnd = endTime > startTime ? endTime : el.call('addMinutes', startTime, 30);
                    const lo = Math.min(el._startIdx, el._curIdx);
                    const hi = Math.max(el._startIdx, el._curIdx);
                    const emails = el._cols.slice(lo, hi + 1).map((n)=>n.dataset.calTeamColEmail);
                    s.root.update({
                        dragPreview: {
                            date: el.call('formatDate', s.root.currentYear, s.root.currentMonth, s.root.currentDay),
                            startTime: startTime,
                            endTime: finalEnd,
                            color: s.root.newBooking?.color || 'blue',
                            memberEmails: emails
                        }
                    });
                },
                onMouseup: (e, el, s)=>{
                    if (el._cols == null) return;
                    const startCol = el._cols[el._startIdx];
                    const startRect = startCol.getBoundingClientRect();
                    const startY = el._startY;
                    const endY = e.clientY - startRect.top;
                    const dragMoved = el._dragMoved;
                    const lo = Math.min(el._startIdx, el._curIdx);
                    const hi = Math.max(el._startIdx, el._curIdx);
                    const emails = el._cols.slice(lo, hi + 1).map((n)=>n.dataset.calTeamColEmail);
                    el._cols = null;
                    el._startIdx = null;
                    el._curIdx = null;
                    el._dragMoved = false;
                    const y0 = Math.min(startY, endY);
                    const y1 = Math.max(startY, endY);
                    const startTime = el.call('pxToTime', y0);
                    const endTimeRaw = el.call('pxToTime', y1);
                    const endTime = dragMoved && endTimeRaw > startTime ? endTimeRaw : el.call('addMinutes', startTime, 30);
                    const root = s.root;
                    root.update({
                        dragPreview: null,
                        showNewBooking: true,
                        newBooking: (0, $kZOF8.freshBooking)({
                            date: el.call('formatDate', root.currentYear, root.currentMonth, root.currentDay),
                            startTime: startTime,
                            endTime: endTime,
                            invitees: emails.join(', '),
                            type: 'meeting'
                        })
                    });
                },
                onMouseleave: (e, el, s)=>{
                    if (el._cols != null) {
                        el._cols = null;
                        el._startIdx = null;
                        el._curIdx = null;
                        el._dragMoved = false;
                        s.root.update({
                            dragPreview: null
                        });
                    }
                },
                childExtends: 'CalTeamMemberColumn',
                childrenAs: 'state',
                children: (el, s)=>{
                    const root = s.root;
                    root.currentMinutes;
                    const all = el.call('activeMembers');
                    const sel = root.teamMembers || [];
                    if (!sel.length) return all;
                    const visible = new Set(sel);
                    return all.filter((p)=>visible.has(p.email));
                }
            },
            // Horizontal NOW line spanning all member columns at user's local
            // current minute. Sibling of MemberColumns so it isn't clobbered by
            // childrenAs iteration.
            NowLineWrap: {
                position: 'absolute',
                left: '0',
                right: '0',
                height: '0',
                zIndex: 5,
                pointerEvents: 'none',
                top: (el, s)=>`${s.root.currentMinutes / 60 * 56}px`,
                NowBar: {
                    position: 'absolute',
                    left: '0',
                    right: '0',
                    top: '0',
                    height: '2px',
                    transform: 'translateY(-50%)',
                    background: 'red'
                },
                NowDot: {
                    position: 'absolute',
                    left: '0',
                    top: '0',
                    width: '12px',
                    height: '12px',
                    transform: 'translate(-50%, -50%)',
                    round: '50%',
                    background: 'red'
                }
            }
        }
    }
};
const $7d928e19513f6e24$export$698e5c8d823b8ca3 = {
    position: 'absolute',
    left: '0',
    right: '0',
    pointerEvents: 'none',
    background: 'red.12',
    top: (el, s)=>`${s.startMin / 60 * 56}px`,
    height: (el, s)=>`${(s.endMin - s.startMin) / 60 * 56}px`
};
const $7d928e19513f6e24$export$60b4ff76aeb19d28 = {
    flex: '1',
    flow: 'y',
    align: 'center center',
    gap: 'Y',
    padding: 'Y Z',
    borderRightWidth: '1px',
    borderRightColor: 'line',
    borderRightStyle: 'solid',
    minWidth: '0',
    overflow: 'hidden',
    position: 'relative',
    Avatar: {
        avatarType: 'initials',
        boxSize: 'B1 B1',
        src: (el, s)=>el.call('avatarUrl', s.name)
    },
    Name: {
        tag: 'span',
        fontSize: 'Y2',
        fontWeight: '600',
        color: 'title',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        width: '100%',
        textAlign: 'center',
        text: (el, s)=>(s.name || '').split(' ')[0]
    },
    LocalTime: {
        tag: 'span',
        fontSize: 'Y2',
        fontFamily: 'monospace',
        // Highlights when hovering — different color so the user can see this is
        // the converted hover time, not the live current time.
        color: (el, s)=>el.state.root.hoverTime ? 'title' : 'caption',
        fontWeight: (el, s)=>el.state.root.hoverTime ? '600' : '400',
        text: (el, s)=>{
            if (!s.timezone) return '';
            const root = el.state.root;
            let ref;
            if (root.hoverTime) {
                // Treat the hovered HH:MM as the user's LOCAL wall-clock time on the
                // currently-viewed day, then format it in the member's timezone.
                const [h, m] = root.hoverTime.split(':').map(Number);
                ref = new Date(root.currentYear, root.currentMonth, root.currentDay, h, m);
            } else ref = new Date();
            return new Intl.DateTimeFormat('en-US', {
                timeZone: s.timezone,
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
            }).format(ref);
        }
    },
    RemoveBtn: {
        tag: 'button',
        position: 'absolute',
        top: 'Y',
        right: 'Y',
        width: 'A',
        height: 'A',
        padding: '0',
        round: '50%',
        border: 'none',
        background: 'transparent',
        color: 'caption',
        cursor: 'pointer',
        fontSize: 'Y2',
        align: 'center center',
        ':hover': {
            background: 'overlay',
            color: 'title'
        },
        Icon: {
            icon: 'crossmark',
            boxSize: 'Z2'
        },
        onClick: (e, el, s)=>{
            e.stopPropagation();
            const root = el.state.root;
            const current = root.teamMembers || [];
            // When teamMembers is empty it means "show everyone" — materialise
            // the full list first so removing one entry actually hides a column.
            const base = current.length ? current : el.call('activeMembers').map((p)=>p.email);
            const next = base.filter((em)=>em !== s.email);
            root.update({
                teamMembers: next
            });
        }
    }
};
const $7d928e19513f6e24$export$74d9d52333ff3c2b = {
    flex: '1',
    position: 'relative',
    borderRightWidth: '1px',
    borderRightColor: 'line',
    borderRightStyle: 'solid',
    minWidth: '0',
    cursor: 'cell',
    // Used by the parent MemberColumns drag handler to identify which member
    // each column belongs to without having to iterate state.
    attr: {
        'data-cal-team-col-email': (el, s)=>s.email || ''
    },
    // Double-click still creates a 60-min single-attendee booking.
    // (Single-column / horizontal drag is handled by the parent MemberColumns.)
    onDblClick: (e, el, s)=>{
        if (e.target.closest('button, [data-cal-event-id]')) return;
        const rect = el.node.getBoundingClientRect();
        const offsetY = e.clientY - rect.top;
        const startTime = el.call('pxToTime', offsetY);
        const endTime = el.call('addMinutes', startTime, 60);
        const root = s.root;
        root.update({
            showNewBooking: true,
            newBooking: (0, $kZOF8.freshBooking)({
                date: el.call('formatDate', root.currentYear, root.currentMonth, root.currentDay),
                startTime: startTime,
                endTime: endTime,
                invitees: s.email,
                type: 'meeting'
            })
        });
    },
    HourLines: {
        flow: 'y',
        pointerEvents: 'none',
        childExtends: 'CalHourLine',
        childrenAs: 'state',
        children: (el)=>el.call('getHours').map((h, i)=>({
                    h: i
                }))
    },
    // Unavailable bands (timezone-aware): converts each user-local minute back
    // to UTC, then to the member's local time/date in their tz, and checks
    // their workingHours / outOfOffice. Bands are tagged with their type so
    // CalUnavailableSlot can use a different color for OOO vs off-hours.
    Unavailable: {
        position: 'absolute',
        inset: '0',
        pointerEvents: 'none',
        childExtends: 'CalUnavailableSlot',
        childrenAs: 'state',
        children: (el, s)=>{
            const root = el.state?.root;
            // Touch the reactive fields we depend on up-front so the signal graph
            // subscribes even on the first run when some fields may be transient.
            const events = root?.events || [];
            const cy = root?.currentYear;
            const cm = root?.currentMonth;
            const cd = root?.currentDay;
            if (cy == null) return [];
            const baseMs = new Date(cy, cm, cd, 0, 0).getTime();
            // Same per-column scoping as the Events layer below.
            const colEvents = events.filter((ev)=>ev.googleCalendarId === s.email || !ev.googleCalendarId && (ev.invitees || []).includes(s.email));
            return el.call('getUnavailableRanges', s, baseMs, 1440, 15, colEvents);
        }
    },
    Events: {
        position: 'absolute',
        inset: '0',
        padding: '0 2px',
        pointerEvents: 'none',
        childExtends: 'CalWeekEvent',
        childrenAs: 'state',
        children: (el, s)=>{
            const root = el.state.root;
            const dateStr = el.call('formatDate', root.currentYear, root.currentMonth, root.currentDay);
            // Per-column scoping: show events that actually live on this column's
            // calendar (googleCalendarId === s.email) so deleting from one person's
            // calendar removes the chip from their column without affecting others.
            // Local-only events (no googleCalendarId yet) fall back to invitees.
            return (root.events || []).filter((ev)=>ev.date === dateStr && (ev.googleCalendarId === s.email || !ev.googleCalendarId && (ev.invitees || []).includes(s.email)) && (!ev.type || ev.type === 'meeting' || ev.type === 'general' || ev.type === 'busy'));
        }
    },
    // Live drag preview — visible in this member's column when their email is
    // in the dragPreview's memberEmails array (single column or horizontal
    // drag span). Group events from the time gutter set memberEmails to all
    // visible members, so the preview lights up everywhere.
    DragPreview: {
        display: (el, s)=>{
            const dp = s.root?.dragPreview;
            if (!dp) return 'none';
            const list = dp.memberEmails || [];
            return list.includes(s.email) ? 'flex' : 'none';
        },
        position: 'absolute',
        left: '2px',
        right: '2px',
        round: 'Z',
        padding: 'Y2 Z',
        pointerEvents: 'none',
        zIndex: 4,
        flow: 'y',
        color: 'white',
        fontSize: 'Y2',
        fontWeight: '500',
        opacity: '.7',
        borderWidth: '2px',
        borderStyle: 'dashed',
        borderColor: 'white',
        background: (el, s)=>s.root?.dragPreview?.color || 'blue',
        top: (el, s)=>`${el.call('eventToTop', s.root?.dragPreview?.startTime || '00:00')}px`,
        height: (el, s)=>`${el.call('eventToHeight', s.root?.dragPreview?.startTime || '00:00', s.root?.dragPreview?.endTime || '00:30')}px`,
        Time: {
            tag: 'span',
            text: (el, s)=>`${s.root?.dragPreview?.startTime || ''} \u{2013} ${s.root?.dragPreview?.endTime || ''}`,
            opacity: '.95'
        }
    }
};

});

parcelRegister("cZ4KY", function(module, exports) {

$parcel$export(module.exports, "CalTeamNowView", () => $973edf1e1d5a13cb$export$302743621c3faa19);
$parcel$export(module.exports, "CalTeamNowGutterTick", () => $973edf1e1d5a13cb$export$3730b754d8341e0a);
$parcel$export(module.exports, "CalTeamNowHeaderCell", () => $973edf1e1d5a13cb$export$4d1ae53da06578f1);
$parcel$export(module.exports, "CalTeamNowColumn", () => $973edf1e1d5a13cb$export$fe9a0264a1ff19d2);
$parcel$export(module.exports, "CalTeamNowHourLine", () => $973edf1e1d5a13cb$export$997534937aeea37b);
$parcel$export(module.exports, "CalTeamNowEvent", () => $973edf1e1d5a13cb$export$f88965a717586d75);
parcelRequire("kZOF8");
var $bglB6 = parcelRequire("bglB6");
var $kZOF8 = parcelRequire("kZOF8");
// Team Now view (aligned to user's local time):
//
// One shared time axis on the left, in the USER's own timezone, covering
// ±12 hours from "now". Each visible team member is a column that just
// holds events + unavailable bands — both positioned by their UTC offset
// from the visible window's top, so they line up across columns and against
// the user's time gutter.
//
// A horizontal red NOW line is rendered at the center (UTC = Date.now()).
//
// Unavailable bands are derived per-member: at each minute of the visible
// window, look up that minute's local time in the member's tz and mark it
// "unavailable" if outside their working hours OR during an OOO date. The
// resulting contiguous unavailable ranges are rendered as `red.07` overlays.
const $973edf1e1d5a13cb$var$TOTAL_HOURS = 24;
const $973edf1e1d5a13cb$var$HOUR_PX = 56;
const $973edf1e1d5a13cb$var$HOUR_MS = 3600000;
const $973edf1e1d5a13cb$var$TOTAL_PX = $973edf1e1d5a13cb$var$TOTAL_HOURS * $973edf1e1d5a13cb$var$HOUR_PX;
// Anchor the visible window's top to the CURRENT round hour (UTC), so the
// view shows the next 24 hours starting from the current hour. The NOW
// indicator floats just below the top label by however many minutes have
// elapsed since the hour rolled over.
const $973edf1e1d5a13cb$var$topMsAtHourBoundary = ()=>{
    const nowMs = Date.now();
    return Math.floor(nowMs / $973edf1e1d5a13cb$var$HOUR_MS) * $973edf1e1d5a13cb$var$HOUR_MS;
};
// Y position of the actual "now" inside the visible window — between 0 and
// HOUR_PX since the top is the current hour boundary.
const $973edf1e1d5a13cb$var$nowYPx = ()=>{
    const nowMs = Date.now();
    return (nowMs - $973edf1e1d5a13cb$var$topMsAtHourBoundary()) / $973edf1e1d5a13cb$var$HOUR_MS * $973edf1e1d5a13cb$var$HOUR_PX;
};
const $973edf1e1d5a13cb$export$302743621c3faa19 = {
    display: (el, s)=>s.root.viewMode === 'team-now' ? 'flex' : 'none',
    flow: 'y',
    flex: '1',
    overflow: 'hidden',
    userSelect: 'none',
    Header: {
        flow: 'x',
        borderBottomWidth: '1px',
        borderBottomColor: 'line',
        borderBottomStyle: 'solid',
        minHeight: 'D1',
        // Spacer aligned with the time gutter below so member headers line up
        // with their columns.
        GutterSpacer: {
            width: 'E',
            minWidth: 'E',
            borderRightWidth: '1px',
            borderRightColor: 'line',
            borderRightStyle: 'solid'
        },
        Members: {
            flex: '1',
            flow: 'x',
            overflow: 'hidden',
            childExtends: 'CalTeamNowHeaderCell',
            childrenAs: 'state',
            children: (el, s)=>{
                const all = el.call('activeMembers');
                const sel = s.root.teamMembers || [];
                if (!sel.length) return all;
                const visible = new Set(sel);
                return all.filter((p)=>visible.has(p.email));
            }
        }
    },
    ScrollBody: {
        flex: '1',
        overflow: 'auto',
        position: 'relative',
        flow: 'x',
        userSelect: 'none',
        alignItems: 'flex-start',
        onCreate: (el)=>{
            requestAnimationFrame(()=>{
                if (!el.node) return;
                // Start at the top — the current hour is the first row.
                el.node.scrollTop = 0;
            });
        },
        TimeGutter: {
            width: 'E',
            minWidth: 'E',
            borderRightWidth: '1px',
            borderRightColor: 'line',
            borderRightStyle: 'solid',
            flow: 'y',
            userSelect: 'none',
            position: 'relative',
            height: `${$973edf1e1d5a13cb$var$TOTAL_PX}px`,
            childExtends: 'CalTeamNowGutterTick',
            childrenAs: 'state',
            // 24 hourly tick labels showing the user's LOCAL time at each row.
            // Anchored to round-hour boundaries so labels read 08:00, 09:00, etc.
            children: (el, s)=>{
                s.root.currentMinutes;
                const topMs = $973edf1e1d5a13cb$var$topMsAtHourBoundary();
                return Array.from({
                    length: $973edf1e1d5a13cb$var$TOTAL_HOURS + 1
                }, (_, i)=>{
                    const ms = topMs + i * $973edf1e1d5a13cb$var$HOUR_MS;
                    const label = new Date(ms).toLocaleTimeString(undefined, {
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: false
                    });
                    return {
                        idx: i,
                        label: label
                    };
                });
            }
        },
        // Wrap so the NOW line can be a sibling of Columns (childrenAs would
        // otherwise clobber any named child).
        ColumnsWrap: {
            flex: '1',
            position: 'relative',
            height: `${$973edf1e1d5a13cb$var$TOTAL_PX}px`,
            Columns: {
                flow: 'x',
                position: 'absolute',
                inset: '0',
                childExtends: 'CalTeamNowColumn',
                childrenAs: 'state',
                children: (el, s)=>{
                    s.root.currentMinutes;
                    const all = el.call('activeMembers');
                    const sel = s.root.teamMembers || [];
                    if (!sel.length) return all;
                    const visible = new Set(sel);
                    return all.filter((p)=>visible.has(p.email));
                }
            },
            // Horizontal NOW line at the actual current minute. The grid rows
            // (hour rectangles) sit on round hour boundaries, but this line
            // floats freely between them showing the precise current moment.
            NowLineWrap: {
                position: 'absolute',
                left: '0',
                right: '0',
                height: '0',
                zIndex: 5,
                pointerEvents: 'none',
                top: (el, s)=>{
                    s.root.currentMinutes;
                    return `${$973edf1e1d5a13cb$var$nowYPx()}px`;
                },
                NowBar: {
                    position: 'absolute',
                    left: '0',
                    right: '0',
                    top: '0',
                    height: '2px',
                    transform: 'translateY(-50%)',
                    background: 'red'
                },
                NowDot: {
                    position: 'absolute',
                    left: '0',
                    top: '0',
                    width: '12px',
                    height: '12px',
                    transform: 'translate(-50%, -50%)',
                    round: '50%',
                    background: 'red'
                }
            }
        }
    }
};
const $973edf1e1d5a13cb$export$3730b754d8341e0a = {
    position: 'absolute',
    left: '0',
    right: '0',
    height: `${$973edf1e1d5a13cb$var$HOUR_PX}px`,
    padding: 'Y Z',
    fontSize: 'Y2',
    color: 'caption',
    fontFamily: 'monospace',
    align: 'flex-start right',
    paddingRight: 'Z1',
    borderTopWidth: '1px',
    borderTopColor: 'line',
    borderTopStyle: 'solid',
    top: (el, s)=>`${s.idx * $973edf1e1d5a13cb$var$HOUR_PX}px`,
    text: (el, s)=>s.label || ''
};
const $973edf1e1d5a13cb$export$4d1ae53da06578f1 = {
    flex: '1',
    flow: 'y',
    align: 'center center',
    gap: 'Y',
    padding: 'Y Z',
    borderRightWidth: '1px',
    borderRightColor: 'line',
    borderRightStyle: 'solid',
    minWidth: '0',
    overflow: 'hidden',
    Avatar: {
        avatarType: 'initials',
        boxSize: 'B1 B1',
        src: (el, s)=>el.call('avatarUrl', s.name)
    },
    Name: {
        tag: 'span',
        fontSize: 'Y2',
        fontWeight: '600',
        color: 'title',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        width: '100%',
        textAlign: 'center',
        text: (el, s)=>(s.name || '').split(' ')[0]
    },
    LocalTime: {
        tag: 'span',
        fontSize: 'Y2',
        color: 'caption',
        fontFamily: 'monospace',
        text: (el, s)=>{
            el.state.root.currentMinutes;
            return s.timezone ? (0, $kZOF8.formatTzTime)(Date.now(), s.timezone) : '';
        }
    }
};
const $973edf1e1d5a13cb$export$fe9a0264a1ff19d2 = {
    flex: '1',
    position: 'relative',
    borderRightWidth: '1px',
    borderRightColor: 'line',
    borderRightStyle: 'solid',
    minWidth: '0',
    height: `${$973edf1e1d5a13cb$var$TOTAL_PX}px`,
    // Hour grid lines so the column has visual rows even without inner cells.
    HourLines: {
        position: 'absolute',
        inset: '0',
        pointerEvents: 'none',
        childExtends: 'CalTeamNowHourLine',
        childrenAs: 'state',
        children: ()=>Array.from({
                length: $973edf1e1d5a13cb$var$TOTAL_HOURS + 1
            }, (_, i)=>({
                    idx: i
                }))
    },
    Unavailable: {
        position: 'absolute',
        inset: '0',
        pointerEvents: 'none',
        childExtends: 'CalUnavailableSlot',
        childrenAs: 'state',
        children: (el, s)=>{
            const root = el.state?.root;
            // Touch reactive deps up-front so the signal graph subscribes.
            const events = root?.events || [];
            const cm = root?.currentMinutes;
            const topMs = $973edf1e1d5a13cb$var$topMsAtHourBoundary();
            // Same per-column scoping as the Events layer below.
            const colEvents = events.filter((ev)=>ev.googleCalendarId === s.email || !ev.googleCalendarId && (ev.invitees || []).includes(s.email));
            return el.call('getUnavailableRanges', s, topMs, $973edf1e1d5a13cb$var$TOTAL_HOURS * 60, 15, colEvents);
        }
    },
    Events: {
        position: 'absolute',
        inset: '0',
        pointerEvents: 'none',
        childExtends: 'CalTeamNowEvent',
        childrenAs: 'state',
        children: (el, s)=>{
            const root = el.state.root;
            root.currentMinutes;
            const topMs = $973edf1e1d5a13cb$var$topMsAtHourBoundary();
            const bottomMs = topMs + $973edf1e1d5a13cb$var$TOTAL_HOURS * $973edf1e1d5a13cb$var$HOUR_MS;
            const DAY_MS = 86400000;
            return (root.events || []).filter((ev)=>(!ev.type || ev.type === 'meeting' || ev.type === 'general' || ev.type === 'busy') && (ev.googleCalendarId === s.email || !ev.googleCalendarId && (ev.invitees || []).includes(s.email))).map((ev)=>{
                const startMs = (0, $kZOF8.eventUtcMs)(ev.date, ev.startTime);
                let endMs = (0, $kZOF8.eventUtcMs)(ev.date, ev.endTime);
                // Cross-midnight: end <= start means the event wraps into the next
                // calendar day. Add 24h so the chip renders with positive height.
                if (endMs <= startMs) endMs += DAY_MS;
                return {
                    ...ev,
                    _startMs: startMs,
                    _endMs: endMs,
                    _topMs: topMs
                };
            }).filter((ev)=>ev._endMs > topMs && ev._startMs < bottomMs);
        }
    }
};
const $973edf1e1d5a13cb$export$997534937aeea37b = {
    position: 'absolute',
    left: '0',
    right: '0',
    height: '0',
    borderTopWidth: '1px',
    borderTopColor: 'line',
    borderTopStyle: 'solid',
    top: (el, s)=>`${s.idx * $973edf1e1d5a13cb$var$HOUR_PX}px`
};
const $973edf1e1d5a13cb$export$f88965a717586d75 = {
    tag: 'button',
    position: 'absolute',
    left: '2px',
    right: '2px',
    round: 'Z',
    padding: 'Y2 Z',
    border: 'none',
    cursor: 'pointer',
    overflow: 'hidden',
    color: 'white',
    fontSize: 'Y2',
    fontWeight: '500',
    pointerEvents: 'auto',
    flow: 'y',
    align: 'flex-start flex-start',
    gap: 'Y2',
    // Same color rules as CalWeekEvent: meeting=green, general=blue, busy=red,
    // private mask = green (so superadmin meetings look like normal meetings to
    // others without leaking details).
    background: (el, s)=>{
        if ((0, $kZOF8.eventIsPrivateFor)(s, (0, $bglB6.currentUser)(s.root))) return 'green';
        if (s.type === 'general') return 'blue';
        if (s.type === 'busy') return 'red';
        return 'green';
    },
    top: (el, s)=>`${Math.max(0, (s._startMs - s._topMs) / 3600000 * $973edf1e1d5a13cb$var$HOUR_PX)}px`,
    height: (el, s)=>{
        const start = Math.max(s._startMs, s._topMs);
        const end = Math.min(s._endMs, s._topMs + $973edf1e1d5a13cb$var$TOTAL_HOURS * 3600000);
        return `${Math.max(20, (end - start) / 3600000 * $973edf1e1d5a13cb$var$HOUR_PX)}px`;
    },
    onClick: (e, el, s)=>{
        const root = el.state.root;
        root.update({
            selectedEvent: s,
            showEventDetail: true
        });
        if (s.invitees === undefined || s.description === undefined) (0, $kZOF8.fetchEventDetails)(s.id, root);
    },
    Title: {
        tag: 'span',
        fontWeight: '600',
        text: (el, s)=>s.title || '',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        width: '100%',
        display: 'block'
    },
    Time: {
        tag: 'span',
        fontFamily: 'monospace',
        text: (el, s)=>`${s.startTime} \u{2013} ${s.endTime}`,
        opacity: '.85',
        display: 'block',
        width: '100%'
    }
};

});

parcelRegister("jzV4w", function(module, exports) {

$parcel$export(module.exports, "CalNewBookingModal", () => $e40d8e7c00d0e3ed$export$c2d401d9c416097e);
$parcel$export(module.exports, "CalInviteePill", () => $e40d8e7c00d0e3ed$export$acc6bf04a7c29c01);
$parcel$export(module.exports, "CalInviteeSuggestion", () => $e40d8e7c00d0e3ed$export$41615fa952c1c359);
$parcel$export(module.exports, "CalVisibilityBtn", () => $e40d8e7c00d0e3ed$export$b9957715013c29f9);
$parcel$export(module.exports, "CalRecurringBtn", () => $e40d8e7c00d0e3ed$export$4f357a2a359e39e2);
$parcel$export(module.exports, "CalRecurringDayBtn", () => $e40d8e7c00d0e3ed$export$a34c15ffbdceb0e0);
$parcel$export(module.exports, "CalEventTypeBtn", () => $e40d8e7c00d0e3ed$export$6c0e414e73929102);
$parcel$export(module.exports, "CalConfirmMoveModal", () => $e40d8e7c00d0e3ed$export$3751014e41a4a015);
$parcel$export(module.exports, "CalMeetingModeBtn", () => $e40d8e7c00d0e3ed$export$508fbd55d4b2b137);
$parcel$export(module.exports, "_genMeetLink", () => $e40d8e7c00d0e3ed$export$2a59fa0458407049);
parcelRequire("kZOF8");
var $bglB6 = parcelRequire("bglB6");
var $kZOF8 = parcelRequire("kZOF8");

var $jlK4b = parcelRequire("jlK4b");
// Event types shown in the picker. `adminOnly` types are filtered out for
// non-admin users. The picker uses a colored dot (not the full pill bg) so
// it doesn't visually compete with the form fields.
const $e40d8e7c00d0e3ed$var$EVENT_TYPES = [
    {
        type: 'meeting',
        label: 'Meeting',
        color: 'green'
    },
    // Company event ("general") used to be admin-only in the picker, but the
    // role data isn't flowing into root.people yet — gating it here makes the
    // type invisible to everyone, including superadmin. RLS on the calendar
    // table is the real enforcement layer.
    {
        type: 'general',
        label: 'Company event',
        color: 'blue'
    },
    {
        type: 'busy',
        label: 'Unavailable',
        color: 'red'
    }
];
// --- Invitees autocomplete helpers -----------------------------------------
// `invitees` is the comma-separated list of accepted emails (each one a pill).
// `inviteeQuery` is the in-progress text in the input — drives suggestions
// but is NOT yet committed.
const $e40d8e7c00d0e3ed$var$_selectedEmails = (root)=>{
    const inv = root?.newBooking?.invitees || '';
    return inv.split(',').map((x)=>x.trim()).filter(Boolean);
};
const $e40d8e7c00d0e3ed$var$_selectedPeople = (root)=>{
    if (!root) return [];
    const emails = new Set($e40d8e7c00d0e3ed$var$_selectedEmails(root));
    return (root.people || []).filter((p)=>emails.has(p.email));
};
// Filter people by the current query text, excluding already-selected ones.
const $e40d8e7c00d0e3ed$var$_filterPeople = (root)=>{
    const q = (root?.newBooking?.inviteeQuery || '').trim().toLowerCase();
    if (!q) return [];
    const selected = new Set($e40d8e7c00d0e3ed$var$_selectedEmails(root));
    const me = root.currentUserEmail;
    return (root.people || []).filter((p)=>p.email !== me && !selected.has(p.email) && (p.name.toLowerCase().includes(q) || p.email.toLowerCase().includes(q))).slice(0, 6);
};
// Append a person's email as a pill, clear the in-progress query, keep focus.
const $e40d8e7c00d0e3ed$var$_addInvitee = (root, person)=>{
    if (!person?.email) return;
    const cur = $e40d8e7c00d0e3ed$var$_selectedEmails(root);
    if (cur.includes(person.email)) return;
    const next = [
        ...cur,
        person.email
    ].join(', ');
    root.update({
        newBooking: {
            ...root.newBooking,
            invitees: next,
            inviteeQuery: ''
        }
    });
};
// Loose RFC-5322-ish email check — strict enough to reject typos, lax enough
// to accept anything postmaster-shaped.
const $e40d8e7c00d0e3ed$var$_EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const $e40d8e7c00d0e3ed$var$_isEmail = (s)=>$e40d8e7c00d0e3ed$var$_EMAIL_RE.test(s.trim());
// Remove a pill by email.
const $e40d8e7c00d0e3ed$var$_removeInvitee = (root, email)=>{
    const next = $e40d8e7c00d0e3ed$var$_selectedEmails(root).filter((e)=>e !== email).join(', ');
    root.update({
        newBooking: {
            ...root.newBooking,
            invitees: next
        }
    });
};
// Backspace on empty input removes the last pill.
const $e40d8e7c00d0e3ed$var$_popInvitee = (root)=>{
    const cur = $e40d8e7c00d0e3ed$var$_selectedEmails(root);
    if (!cur.length) return;
    cur.pop();
    root.update({
        newBooking: {
            ...root.newBooking,
            invitees: cur.join(', ')
        }
    });
};
const $e40d8e7c00d0e3ed$export$c2d401d9c416097e = {
    extends: 'Modal',
    stateKey: 'showNewBooking',
    extraClose: {
        pendingSuggestion: null
    },
    Window: {
        width: '100%',
        maxWidth: 'I',
        maxHeight: '90dvh',
        gap: 'Z1',
        ModalHeader: {
            Hgroup: {
                H: {
                    text: (el, s)=>s.root?.newBooking?.editingEventId ? 'Edit Booking' : 'New Booking'
                },
                P: {
                    text: (el, s)=>s.root?.newBooking?.editingEventId ? 'Update the meeting time, attendees, or description' : 'Schedule a meeting and invite teammates'
                }
            }
        },
        Fields: {
            flow: 'y',
            gap: 'B',
            TitleField: {
                extends: 'InputField',
                Title: {
                    text: 'Title'
                },
                Input: {
                    tag: 'input',
                    type: 'text',
                    placeholder: 'Add a title',
                    autofocus: true,
                    value: (el, s)=>s.root?.newBooking?.title || '',
                    // The DOM autofocus attribute only fires once on first mount —
                    // when the modal re-opens (display flips none→flex) the existing
                    // element doesn't refocus. Refocus only on the false→true edge of
                    // `showNewBooking` so we don't fight the user when they click out
                    // of the title field mid-edit.
                    onCreate: (el)=>{
                        el._wasOpen = false;
                        requestAnimationFrame(()=>{
                            el.node?.focus?.();
                        });
                    },
                    onUpdate: (el, s)=>{
                        const open = !!s.root?.showNewBooking;
                        if (open && !el._wasOpen) requestAnimationFrame(()=>{
                            el.node?.focus?.();
                        });
                        el._wasOpen = open;
                    },
                    onInput: (e, el, s)=>{
                        s.root.update({
                            newBooking: {
                                ...s.root?.newBooking,
                                title: e.target.value
                            }
                        });
                    }
                }
            },
            TypePicker: {
                flow: 'x',
                gap: 'Y',
                align: 'center left',
                flexWrap: 'wrap',
                childExtends: 'CalEventTypeBtn',
                childrenAs: 'state',
                children: (el, s)=>{
                    const admin = el.call('isAdmin');
                    return $e40d8e7c00d0e3ed$var$EVENT_TYPES.filter((t)=>admin || !t.adminOnly);
                }
            },
            DateRow: {
                flow: 'x',
                gap: 'Z',
                colorScheme: 'dark',
                childExtends: 'InputField',
                DateField: {
                    flex: '2',
                    Title: {
                        text: 'Date'
                    },
                    Input: {
                        tag: 'input',
                        type: 'date',
                        value: (el, s)=>s.root?.newBooking?.date || '',
                        onInput: (e, el, s)=>{
                            s.root.update({
                                newBooking: {
                                    ...s.root?.newBooking,
                                    date: e.target.value
                                }
                            });
                        }
                    }
                },
                StartField: {
                    flex: '1',
                    Title: {
                        text: 'Start'
                    },
                    Input: {
                        tag: 'input',
                        type: 'time',
                        value: (el, s)=>s.root?.newBooking?.startTime || '09:00',
                        onInput: (e, el, s)=>{
                            s.root.update({
                                newBooking: {
                                    ...s.root?.newBooking,
                                    startTime: e.target.value
                                }
                            });
                        }
                    }
                },
                EndField: {
                    flex: '1',
                    Title: {
                        text: 'End'
                    },
                    Input: {
                        tag: 'input',
                        type: 'time',
                        value: (el, s)=>s.root?.newBooking?.endTime || '10:00',
                        onInput: (e, el, s)=>{
                            s.root.update({
                                newBooking: {
                                    ...s.root?.newBooking,
                                    endTime: e.target.value
                                }
                            });
                        }
                    }
                }
            },
            // Meeting location row — only shown for meeting/general events.
            // Three-option picker: Symbols Meet, External URL, Offline.
            MeetingModeRow: {
                flow: 'y',
                gap: 'Z',
                display: (el, s)=>{
                    const t = s.root?.newBooking?.type || 'meeting';
                    return t === 'meeting' || t === 'general' ? 'flex' : 'none';
                },
                ModePicker: {
                    flow: 'x',
                    gap: 'Y',
                    flexWrap: 'wrap',
                    childExtends: 'CalMeetingModeBtn',
                    childrenAs: 'state',
                    children: [
                        {
                            mode: 'symbols-meet',
                            label: 'Symbols Meet',
                            icon: 'video'
                        },
                        {
                            mode: 'external-url',
                            label: 'External URL',
                            icon: 'link'
                        },
                        {
                            mode: 'offline',
                            label: 'Offline',
                            icon: 'mapPin'
                        }
                    ]
                },
                UrlField: {
                    extends: 'InputField',
                    display: (el, s)=>{
                        const m = s.root?.newBooking?.meetingMode || 'symbols-meet';
                        return m === 'external-url' ? 'flex' : 'none';
                    },
                    Title: {
                        text: 'Meeting URL'
                    },
                    Input: {
                        tag: 'input',
                        type: 'url',
                        placeholder: 'Paste Zoom, Google Meet, or other link',
                        value: (el, s)=>s.root?.newBooking?.meetUrl || '',
                        onInput: (e, el, s)=>{
                            s.root.update({
                                newBooking: {
                                    ...s.root?.newBooking,
                                    meetUrl: e.target.value
                                }
                            });
                        }
                    }
                }
            },
            VisibilityRow: null,
            // Invitees: a plain text input on top, and the selected invitees rendered
            // as a separate grid of cards below. The input never holds pills — picking
            // a suggestion (or pressing Enter) adds the person to the grid and clears
            // the input. The suggestions dropdown is anchored to the input field.
            InviteesField: {
                extends: 'InputField',
                position: 'relative',
                Title: {
                    text: 'Invitees'
                },
                Input: {
                    tag: 'input',
                    type: 'text',
                    placeholder: (el, s)=>$e40d8e7c00d0e3ed$var$_selectedEmails(s.root).length ? '' : "Type a name\u2026",
                    attr: {
                        autocomplete: 'off',
                        spellcheck: 'false'
                    },
                    value: (el, s)=>s.root?.newBooking?.inviteeQuery || '',
                    onFocus: (e)=>{
                        try {
                            e.target.select();
                        } catch (_) {}
                    },
                    onInput: (e, el, s)=>{
                        s.root.update({
                            newBooking: {
                                ...s.root?.newBooking,
                                inviteeQuery: e.target.value
                            }
                        });
                    },
                    onKeydown: (e, el, s)=>{
                        const root = s.root;
                        const q = (root.newBooking?.inviteeQuery || '').trim();
                        if ((e.key === 'Backspace' || e.key === 'Delete') && q === '') {
                            e.preventDefault();
                            $e40d8e7c00d0e3ed$var$_popInvitee(root);
                            return;
                        }
                        if (e.key === 'Tab' || e.key === 'Enter' || e.key === ',') {
                            // Prefer the first autocomplete suggestion (known team member),
                            // otherwise fall back to the raw query if it's a valid email —
                            // that's how external attendees get added.
                            const matches = $e40d8e7c00d0e3ed$var$_filterPeople(root);
                            if (matches.length) {
                                e.preventDefault();
                                $e40d8e7c00d0e3ed$var$_addInvitee(root, matches[0]);
                            } else if ($e40d8e7c00d0e3ed$var$_isEmail(q)) {
                                e.preventDefault();
                                $e40d8e7c00d0e3ed$var$_addInvitee(root, {
                                    email: q
                                });
                            }
                        }
                    },
                    onBlur: (e, el, s)=>{
                        // Commit a pending external email when the user clicks away
                        // without pressing Enter.
                        const q = (s.root?.newBooking?.inviteeQuery || '').trim();
                        if ($e40d8e7c00d0e3ed$var$_isEmail(q) && !$e40d8e7c00d0e3ed$var$_filterPeople(s.root).length) $e40d8e7c00d0e3ed$var$_addInvitee(s.root, {
                            email: q
                        });
                    }
                },
                // Selected invitees rendered as a grid of cards (not as inline pills
                // inside the input). Lets several invitees breathe and shows the per-
                // person local time without crowding the typing area.
                SelectedGrid: {
                    display: (el, s)=>$e40d8e7c00d0e3ed$var$_selectedPeople(s.root).length ? 'grid' : 'none',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(F, 1fr))',
                    gap: 'Y',
                    marginTop: 'Y',
                    childExtends: 'CalInviteePill',
                    childrenAs: 'state',
                    children: (el, s)=>$e40d8e7c00d0e3ed$var$_selectedPeople(s.root)
                },
                Suggestions: {
                    display: (el, s)=>$e40d8e7c00d0e3ed$var$_filterPeople(s.root).length ? 'flex' : 'none',
                    position: 'absolute',
                    top: '100%',
                    left: '0',
                    right: '0',
                    marginTop: 'Y',
                    flow: 'y',
                    theme: 'modal',
                    borderWidth: '1px',
                    borderColor: 'line',
                    borderStyle: 'solid',
                    round: 'Z2',
                    boxShadow: '0 8px 24px var(--color-shadow)',
                    maxHeight: 'G',
                    overflowY: 'auto',
                    zIndex: 10,
                    childExtends: 'CalInviteeSuggestion',
                    childrenAs: 'state',
                    children: (el, s)=>$e40d8e7c00d0e3ed$var$_filterPeople(s.root)
                }
            },
            DescriptionField: {
                extends: 'InputField',
                Title: {
                    text: 'Description'
                },
                Input: {
                    tag: 'textarea',
                    placeholder: 'Optional notes',
                    fontFamily: 'inherit',
                    fontSize: 'Z2',
                    rows: 4,
                    resize: 'vertical',
                    value: (el, s)=>s.root?.newBooking?.description || '',
                    onInput: (e, el, s)=>{
                        s.root.update({
                            newBooking: {
                                ...s.root?.newBooking,
                                description: e.target.value
                            }
                        });
                    }
                }
            },
            // Apple-style recurring picker — segmented presets + day toggles
            // when "Weekly" is selected.
            RecurringSection: {
                flow: 'y',
                gap: 'Z',
                Label: {
                    tag: 'span',
                    text: 'Repeat',
                    fontSize: 'Z2',
                    color: 'caption'
                },
                Presets: {
                    flow: 'x',
                    gap: 'Y',
                    flexWrap: 'wrap',
                    childExtends: 'CalRecurringBtn',
                    childrenAs: 'state',
                    children: [
                        {
                            value: 'none',
                            label: 'Never'
                        },
                        {
                            value: 'daily',
                            label: 'Daily'
                        },
                        {
                            value: 'weekly',
                            label: 'Weekly'
                        },
                        {
                            value: 'biweekly',
                            label: 'Every 2 weeks'
                        },
                        {
                            value: 'monthly',
                            label: 'Monthly'
                        },
                        {
                            value: 'yearly',
                            label: 'Yearly'
                        }
                    ]
                },
                // Day-of-week toggles, only visible when Weekly is picked. Allows
                // multi-select like Apple Calendar's custom rule (e.g. Mon/Wed/Fri).
                DayToggles: {
                    display: (el, s)=>s.root?.newBooking?.recurring === 'weekly' ? 'flex' : 'none',
                    flow: 'x',
                    gap: 'Y',
                    marginTop: 'Y',
                    childExtends: 'CalRecurringDayBtn',
                    childrenAs: 'state',
                    children: [
                        {
                            dow: 1,
                            label: 'M'
                        },
                        {
                            dow: 2,
                            label: 'T'
                        },
                        {
                            dow: 3,
                            label: 'W'
                        },
                        {
                            dow: 4,
                            label: 'T'
                        },
                        {
                            dow: 5,
                            label: 'F'
                        },
                        {
                            dow: 6,
                            label: 'S'
                        },
                        {
                            dow: 0,
                            label: 'S'
                        }
                    ]
                }
            }
        },
        ModalFooter: {
            flow: 'x',
            gap: 'Z1',
            childExtends: 'Button',
            SaveBtn: {
                theme: 'primary',
                text: (el, s)=>s.root?.newBooking?.editingEventId ? 'Update' : 'Save',
                onClick: (e, el, s)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    const root = s.root;
                    // For recurring events, show scope picker before saving
                    const nb = root.newBooking || {};
                    if (nb.editingEventId) {
                        const orig = (root.events || []).find((ev)=>ev.id === nb.editingEventId);
                        const baseId = orig?.googleEventId?.replace(/_\d{8}T\d{6}Z$/, '');
                        const hasSiblings = baseId && (root.events || []).some((ev)=>ev.id !== nb.editingEventId && ev.googleEventId?.replace(/_\d{8}T\d{6}Z$/, '') === baseId);
                        if (hasSiblings && !nb._saveScope) {
                            root.update({
                                newBooking: {
                                    ...nb,
                                    _showScopePicker: true
                                }
                            });
                            return;
                        }
                    }
                    // Date is the only hard requirement; title is optional (e.g. for
                    // a quick "busy" block where the type is enough context).
                    if (!nb.date) return;
                    const inviteesArr = (nb.invitees || '').split(',').map((x)=>x.trim()).filter(Boolean);
                    const type = nb.type || 'meeting';
                    // Busy/unavailable blocks render via the per-user unavailable layer
                    // (`getUnavailableRanges`), which only picks up an event if the
                    // viewer is in its invitees list. Stamp the creator so the event
                    // shows up on their own column without manual self-invite.
                    if (type === 'busy' && root.currentUserEmail && !inviteesArr.includes(root.currentUserEmail)) inviteesArr.push(root.currentUserEmail);
                    const recurring = nb.recurring || 'none';
                    const meetingMode = nb.meetingMode || 'symbols-meet';
                    // External URL meetings: append the provided link to description.
                    // Symbols Meet rooms are created asynchronously after Supabase save.
                    let description = nb.description || '';
                    if ((type === 'meeting' || type === 'general') && meetingMode === 'external-url') {
                        const link = nb.meetUrl && nb.meetUrl.trim();
                        if (link && !description.includes(link)) description = description ? `${description}\n${link}` : link;
                    }
                    const resetBooking = {
                        title: '',
                        date: nb.date,
                        startTime: '09:00',
                        endTime: '10:00',
                        invitees: '',
                        inviteeQuery: '',
                        description: '',
                        type: 'meeting',
                        meetingMode: 'symbols-meet',
                        meetUrl: '',
                        recurring: 'none',
                        recurringDays: [],
                        editingEventId: null
                    };
                    const payload = {
                        title: nb.title || '',
                        date: nb.date,
                        startTime: nb.startTime || '09:00',
                        endTime: nb.endTime || '10:00',
                        allDay: !!nb.allDay,
                        type: type,
                        meetingMode: meetingMode,
                        recurring: recurring,
                        recurringDays: recurring === 'weekly' ? nb.recurringDays || [] : [],
                        description: description,
                        invitees: inviteesArr,
                        // Stamp the creator on first save so the move/resize permission
                        // model can tell creator from participant later. Edits keep the
                        // existing creator.
                        creatorEmail: nb.editingEventId ? root.events?.find((ev)=>ev.id === nb.editingEventId)?.creatorEmail || root.currentUserEmail : root.currentUserEmail,
                        // Privacy stamp: superadmin events (except company-wide) and
                        // anything created by an external party are marked private so
                        // other viewers see them as a generic Unavailable block.
                        isPrivate: (0, $kZOF8.shouldStampPrivate)((0, $bglB6.currentUser)(root) || {
                            email: root.currentUserEmail
                        }, type, root.people || []),
                        // Superadmin "Share with team" override — explicitly publishes
                        // a private event to the team. Defaults to whatever the user
                        // toggled in the modal (false otherwise).
                        isTeamShared: !!nb.isTeamShared
                    };
                    if (nb.editingEventId) {
                        const editedOriginal = (root.events || []).find((ev)=>ev.id === nb.editingEventId);
                        const geid = editedOriginal?.googleEventId;
                        const baseId = geid?.replace(/_\d{8}T\d{6}Z$/, '');
                        const scope = nb._saveScope || 'this';
                        const sharedFields = {
                            type: payload.type,
                            description: payload.description,
                            invitees: payload.invitees
                        };
                        const shouldUpdate = (ev)=>{
                            if (ev.id === nb.editingEventId) return true;
                            if (scope === 'this') return false;
                            const evBase = ev.googleEventId?.replace(/_\d{8}T\d{6}Z$/, '');
                            if (evBase !== baseId) return false;
                            if (scope === 'all') return true;
                            // 'future': only events on or after the edited event's date
                            return ev.date >= editedOriginal.date;
                        };
                        const updated = (root.events || []).map((ev)=>{
                            if (ev.id === nb.editingEventId) return {
                                ...ev,
                                ...payload
                            };
                            if (shouldUpdate(ev)) return {
                                ...ev,
                                ...sharedFields
                            };
                            return ev;
                        });
                        root.update({
                            events: updated,
                            showNewBooking: false,
                            newBooking: resetBooking
                        });
                        const edited = updated.find((ev)=>ev.id === nb.editingEventId);
                        if (edited) el.call('saveEventToSupabase', edited);
                        // Propagate shared fields to siblings in DB based on scope
                        if (scope !== 'this' && edited) el.call('updateSharedEventFields', edited, sharedFields);
                    } else {
                        const newEv = {
                            id: Date.now(),
                            ...payload
                        };
                        // Capture before clearing so the .then closure can reference it.
                        const pending = root.pendingSuggestion;
                        const _meetingMode = meetingMode;
                        root.update({
                            events: [
                                ...root.events || [],
                                newEv
                            ],
                            showNewBooking: false,
                            newBooking: resetBooking,
                            pendingSuggestion: null
                        });
                        // Persist to Supabase, then patch the optimistic id with the
                        // real autoincrement id once the upsert returns.
                        el.call('saveEventToSupabase', newEv).then(async (realId)=>{
                            if (!realId) return;
                            root.update({
                                events: (root.events || []).map((ev)=>ev.id === newEv.id ? {
                                        ...ev,
                                        id: realId
                                    } : ev)
                            });
                            // Symbols Meet: create a room and attach link to event description
                            if (_meetingMode === 'symbols-meet' && (type === 'meeting' || type === 'general')) {
                                const roomId = await el.call('createRoom', {
                                    name: payload.title || 'Calendar call',
                                    kind: 'scheduled',
                                    calendarEventId: realId,
                                    transcribeEnabled: true
                                });
                                if (roomId) {
                                    const meetLink = `${window.location.origin}/meet#room=${roomId}`;
                                    const updatedDesc = payload.description ? `${payload.description}\n${meetLink}` : meetLink;
                                    const patched = {
                                        ...payload,
                                        id: realId,
                                        description: updatedDesc
                                    };
                                    root.update({
                                        events: (root.events || []).map((ev)=>ev.id === realId ? {
                                                ...ev,
                                                description: updatedDesc
                                            } : ev)
                                    });
                                    el.call('saveEventToSupabase', patched);
                                }
                            }
                            // If this save originated from a meet transcript suggestion,
                            // mark it applied so the card shows a checkmark on next visit.
                            if (pending?.bucket === 'calendar_events' && pending?.item) el.call('markSuggestionApplied', pending.bucket, pending.item, realId);
                        });
                    }
                }
            }
        },
        // Scope picker overlay — shown when editing a recurring event
        ScopePicker: {
            if: (el, s)=>s.root?.newBooking?._showScopePicker,
            position: 'absolute',
            inset: '0',
            zIndex: '10',
            background: 'black.65',
            backdropFilter: 'blur(4px)',
            align: 'center center',
            round: 'Z2',
            Dialog: {
                padding: 'B1',
                round: 'A',
                background: 'overlay',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: 'line',
                flow: 'y',
                gap: 'A',
                width: '320px',
                boxShadow: '0 16px 48px -8px rgba(0,0,0,0.5)',
                Title: {
                    tag: 'h3',
                    text: 'Edit recurring event',
                    fontSize: 'A',
                    fontWeight: '700',
                    color: 'title',
                    margin: '0'
                },
                Subtitle: {
                    tag: 'p',
                    text: 'Apply changes to:',
                    fontSize: 'Z1',
                    color: 'caption',
                    margin: '0'
                },
                Options: {
                    flow: 'y',
                    gap: 'Z',
                    childExtends: {
                        tag: 'button',
                        type: 'button',
                        padding: 'Z1 A',
                        round: 'Z',
                        borderWidth: '1px',
                        borderStyle: 'solid',
                        borderColor: 'line',
                        background: 'overlay',
                        color: 'title',
                        fontSize: 'Z1',
                        fontWeight: '600',
                        cursor: 'pointer',
                        textAlign: 'left',
                        text: (el, s)=>s.label,
                        ':hover': {
                            background: 'overlayStrong',
                            borderColor: 'caption'
                        }
                    },
                    childrenAs: 'state',
                    children: [
                        {
                            key: 'this',
                            label: 'This event only'
                        },
                        {
                            key: 'future',
                            label: 'This and future events'
                        },
                        {
                            key: 'all',
                            label: 'All events in series'
                        }
                    ],
                    onClick: (e, el, s)=>{
                        const root = s.root;
                        const nb = root.newBooking || {};
                        root.update({
                            newBooking: {
                                ...nb,
                                _showScopePicker: false,
                                _saveScope: s.key
                            }
                        });
                        // Trigger the save by clicking the SaveBtn programmatically
                        const win = el.parent?.parent?.parent;
                        const saveBtn = win?.ModalFooter?.SaveBtn;
                        if (saveBtn?.node) saveBtn.node.click();
                    }
                },
                CancelScopeBtn: {
                    tag: 'button',
                    type: 'button',
                    text: 'Cancel',
                    padding: 'Z A',
                    background: 'none',
                    borderWidth: '0',
                    color: 'caption',
                    fontSize: 'Z1',
                    cursor: 'pointer',
                    textAlign: 'center',
                    onClick: (e, el, s)=>{
                        const root = s.root;
                        const nb = root.newBooking || {};
                        root.update({
                            newBooking: {
                                ...nb,
                                _showScopePicker: false
                            }
                        });
                    }
                }
            }
        }
    }
};
const $e40d8e7c00d0e3ed$export$acc6bf04a7c29c01 = {
    flow: 'x',
    align: 'center left',
    gap: 'Z',
    padding: 'Y Z',
    round: 'C',
    background: 'overlay',
    borderWidth: '1px',
    borderColor: 'line',
    borderStyle: 'solid',
    Avatar: {
        avatarType: 'initials',
        boxSize: 'B B',
        src: (el, s)=>(0, $jlK4b.avatarUrl)(s.name)
    },
    Name: {
        tag: 'span',
        fontSize: 'Z2',
        color: 'title',
        text: (el, s)=>(s.name || '').split(' ')[0]
    },
    // Live local time for this invitee, in their timezone, derived from the
    // current newBooking date+startTime+endTime.
    LocalTime: {
        tag: 'span',
        fontSize: 'Y2',
        color: 'caption',
        fontFamily: 'monospace',
        text: (el, s)=>{
            const nb = el.state.root.newBooking;
            if (!nb || !s.timezone) return '';
            const sMs = (0, $kZOF8.eventUtcMs)(nb.date, nb.startTime || '00:00');
            const eMs = (0, $kZOF8.eventUtcMs)(nb.date, nb.endTime || '00:00');
            if (!sMs) return '';
            return `${(0, $kZOF8.formatTzTime)(sMs, s.timezone)}\u{2013}${(0, $kZOF8.formatTzTime)(eMs, s.timezone)}`;
        }
    },
    RemoveBtn: {
        tag: 'button',
        text: "\xd7",
        border: 'none',
        background: 'transparent',
        color: 'caption',
        cursor: 'pointer',
        padding: '0',
        fontSize: 'A',
        lineHeight: '1',
        ':hover': {
            color: 'title'
        },
        onClick: (e, el, s)=>{
            e.preventDefault();
            e.stopPropagation();
            $e40d8e7c00d0e3ed$var$_removeInvitee(el.state.root, s.email);
        }
    }
};
const $e40d8e7c00d0e3ed$export$41615fa952c1c359 = {
    tag: 'button',
    flow: 'x',
    align: 'center left',
    gap: 'Z',
    padding: 'Z A',
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    width: '100%',
    textAlign: 'left',
    ':hover': {
        background: 'overlay'
    },
    onMousedown: (e, el, s)=>{
        // Add the invitee on mousedown (before blur fires) so the click works
        // even though the input would normally lose focus.
        e.preventDefault();
        e.stopPropagation();
        $e40d8e7c00d0e3ed$var$_addInvitee(el.state.root, s);
        // Force-clear the input DOM value too, in case the reactive `value`
        // binding doesn't push the empty string back to a focused input.
        const root = el.state?.root;
        const wrap = el.parent?.parent?.node || document;
        const input = wrap.querySelector && wrap.querySelector('input[type="text"]');
        if (input) input.value = '';
    },
    Avatar: {
        avatarType: 'initials',
        boxSize: 'B B',
        src: (el, s)=>(0, $jlK4b.avatarUrl)(s.name)
    },
    Info: {
        flow: 'y',
        gap: 'Y2',
        flex: '1',
        minWidth: '0',
        overflow: 'hidden',
        Name: {
            tag: 'span',
            fontSize: 'Z2',
            fontWeight: '600',
            color: 'title',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>s.name || ''
        },
        Email: {
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            fontFamily: 'monospace',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>s.email || ''
        }
    }
};
const $e40d8e7c00d0e3ed$export$b9957715013c29f9 = {
    tag: 'button',
    flow: 'x',
    align: 'center center',
    gap: 'Y',
    padding: 'Y2 Z',
    round: 'C',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'line',
    cursor: 'pointer',
    fontSize: 'Z2',
    fontWeight: '500',
    background: (el, s)=>{
        const cur = !!el.state.root.newBooking?.isTeamShared;
        return cur === s.value ? 'line' : 'transparent';
    },
    color: 'title',
    text: (el, s)=>s.label,
    ':hover': {
        background: 'overlay'
    },
    onClick: (e, el, s)=>{
        e.preventDefault();
        el.state.root.update({
            newBooking: {
                ...el.state.root.newBooking,
                isTeamShared: s.value
            }
        });
    }
};
const $e40d8e7c00d0e3ed$export$4f357a2a359e39e2 = {
    tag: 'button',
    flow: 'x',
    align: 'center center',
    padding: 'Y2 A',
    round: 'C',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'line',
    cursor: 'pointer',
    fontSize: 'Z2',
    fontWeight: '500',
    background: (el, s)=>{
        const cur = el.state.root.newBooking?.recurring || 'none';
        return cur === s.value ? 'line' : 'transparent';
    },
    color: 'title',
    text: (el, s)=>s.label,
    ':hover': {
        background: 'overlay'
    },
    onClick: (e, el, s)=>{
        e.preventDefault();
        const root = el.state.root;
        const patch = {
            recurring: s.value
        };
        // Switching to Weekly seeds the day-toggles with the event's own day.
        if (s.value === 'weekly' && !root.newBooking?.recurringDays?.length) {
            const d = root.newBooking?.date;
            if (d) {
                const [y, m, dy] = d.split('-').map(Number);
                patch.recurringDays = [
                    new Date(y, m - 1, dy).getDay()
                ];
            }
        }
        root.update({
            newBooking: {
                ...root.newBooking,
                ...patch
            }
        });
    }
};
const $e40d8e7c00d0e3ed$export$a34c15ffbdceb0e0 = {
    tag: 'button',
    width: 'B1',
    height: 'B1',
    padding: '0',
    round: '50%',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'line',
    cursor: 'pointer',
    fontSize: 'Y2',
    fontWeight: '600',
    align: 'center center',
    background: (el, s)=>{
        const days = el.state.root.newBooking?.recurringDays || [];
        return days.includes(s.dow) ? 'blue' : 'transparent';
    },
    color: (el, s)=>{
        const days = el.state.root.newBooking?.recurringDays || [];
        return days.includes(s.dow) ? 'white' : 'caption';
    },
    text: (el, s)=>s.label,
    onClick: (e, el, s)=>{
        e.preventDefault();
        const root = el.state.root;
        const cur = new Set(root.newBooking?.recurringDays || []);
        if (cur.has(s.dow)) cur.delete(s.dow);
        else cur.add(s.dow);
        root.update({
            newBooking: {
                ...root.newBooking,
                recurringDays: Array.from(cur).sort()
            }
        });
    }
};
const $e40d8e7c00d0e3ed$export$6c0e414e73929102 = {
    tag: 'button',
    flow: 'x',
    align: 'center center',
    gap: 'Z',
    padding: 'Y2 Z',
    round: 'C',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: (el, s)=>{
        const cur = el.state.root.newBooking?.type || 'meeting';
        return cur === s.type ? 'transparent' : 'line';
    },
    cursor: 'pointer',
    fontSize: 'Z2',
    fontWeight: '500',
    minWidth: 'F',
    background: (el, s)=>{
        const cur = el.state.root.newBooking?.type || 'meeting';
        return cur === s.type ? 'line' : 'transparent';
    },
    color: (el, s)=>{
        const cur = el.state.root.newBooking?.type || 'meeting';
        return cur === s.type ? s.color : 'title';
    },
    ':hover': {
        opacity: '.9'
    },
    onClick: (e, el, s)=>{
        e.preventDefault();
        el.state.root.update({
            newBooking: {
                ...el.state.root.newBooking,
                type: s.type
            }
        });
    },
    Dot: {
        width: 'Z',
        height: 'Z',
        round: '50%',
        background: (el, s)=>s.color
    },
    Label: {
        tag: 'span',
        text: (el, s)=>s.label || s.type
    }
};
const $e40d8e7c00d0e3ed$export$3751014e41a4a015 = {
    display: (el, s)=>s.root?.confirmMove ? 'flex' : 'none',
    position: 'fixed',
    inset: '0',
    zIndex: 2100,
    align: 'center center',
    theme: 'modalFade',
    onClick: (e, el, s)=>{
        if (e.target === el.node) $e40d8e7c00d0e3ed$var$_cancelConfirmMove(s.root);
    },
    Panel: {
        flow: 'y',
        gap: 'Z1',
        padding: 'A B',
        width: '100%',
        maxWidth: 'H',
        theme: 'modal',
        round: 'Z2',
        boxShadow: '0 8px 40px var(--color-shadow)',
        Title: {
            tag: 'h3',
            margin: '0',
            fontSize: 'A',
            fontWeight: '600',
            color: 'title',
            text: 'This event has participants'
        },
        Body: {
            tag: 'p',
            margin: '0',
            fontSize: 'Z2',
            color: 'caption',
            lineHeight: '1.5',
            text: 'Update the time directly, or propose the change and wait for participants to confirm.'
        },
        ModalFooter: {
            flow: 'x',
            align: 'center flex-end',
            gap: 'Z1',
            flexWrap: 'wrap',
            childExtends: 'Button',
            CancelBtn: {
                theme: 'secondary',
                text: 'Cancel',
                onClick: (e, el, s)=>$e40d8e7c00d0e3ed$var$_cancelConfirmMove(s.root)
            },
            ProposeBtn: {
                theme: 'secondary',
                text: 'Propose',
                onClick: (e, el, s)=>$e40d8e7c00d0e3ed$var$_proposeFromConfirm(s.root, el)
            },
            UpdateBtn: {
                theme: 'primary',
                text: 'Update',
                onClick: (e, el, s)=>{
                    // Commit the proposed move directly to the original event +
                    // persist to Supabase + push to Google.
                    const cm = s.root?.confirmMove;
                    if (!cm) return;
                    const events = s.root?.events || [];
                    const idx = events.findIndex((x)=>x.id === cm.eventId);
                    if (idx === -1) {
                        s.root.update({
                            confirmMove: null
                        });
                        return;
                    }
                    const updated = events.slice();
                    const movedEv = {
                        ...events[idx],
                        ...cm.next
                    };
                    updated[idx] = movedEv;
                    s.root.update({
                        events: updated,
                        confirmMove: null
                    });
                    el.call('saveEventToSupabase', movedEv);
                }
            }
        }
    }
};
const $e40d8e7c00d0e3ed$var$_cancelConfirmMove = (root)=>{
    // The original event was never mutated — just dismiss.
    root.update({
        confirmMove: null
    });
};
const $e40d8e7c00d0e3ed$var$_proposeFromConfirm = (root, el)=>{
    const cm = root.confirmMove;
    if (!cm) return;
    const events = root.events || [];
    const orig = events.find((x)=>x.id === cm.eventId);
    if (!orig) {
        root.update({
            confirmMove: null
        });
        return;
    }
    // Add a proposal duplicate at the dragged-to position. The original is
    // untouched. Proposals are persisted to Supabase too so other tabs / Google
    // see the same shadow event until it's accepted or declined.
    const proposal = {
        ...orig,
        ...cm.next,
        id: Date.now(),
        isProposal: true,
        originalEventId: orig.id,
        proposedBy: root.currentUserEmail
    };
    root.update({
        events: [
            ...events,
            proposal
        ],
        confirmMove: null
    });
    if (el) el.call('saveEventToSupabase', proposal).then((realId)=>{
        if (!realId) return;
        root.update({
            events: (root.events || []).map((ev)=>ev.id === proposal.id ? {
                    ...ev,
                    id: realId
                } : ev)
        });
    });
};
const $e40d8e7c00d0e3ed$export$508fbd55d4b2b137 = {
    tag: 'button',
    flow: 'x',
    align: 'center center',
    gap: 'Z',
    padding: 'Y2 Z',
    round: 'C',
    borderWidth: '1px',
    borderStyle: 'solid',
    cursor: 'pointer',
    fontSize: 'Z2',
    fontWeight: '500',
    minWidth: 'F',
    background: (el, s)=>{
        const cur = el.state.root.newBooking?.meetingMode || 'symbols-meet';
        return cur === s.mode ? 'green' : 'transparent';
    },
    borderColor: (el, s)=>{
        const cur = el.state.root.newBooking?.meetingMode || 'symbols-meet';
        return cur === s.mode ? 'green' : 'line';
    },
    color: (el, s)=>{
        const cur = el.state.root.newBooking?.meetingMode || 'symbols-meet';
        return cur === s.mode ? 'white' : 'title';
    },
    text: (el, s)=>s.label,
    ':hover': {
        background: 'overlay'
    },
    onClick: (e, el, s)=>{
        e.preventDefault();
        el.state.root.update({
            newBooking: {
                ...el.state.root.newBooking,
                meetingMode: s.mode
            }
        });
    }
};
// Generate a fake but plausible Google Meet link. We don't talk to a real
// backend here, but the format matches Meet's xxx-yyyy-zzz pattern so it
// reads correctly in the description field.
const $e40d8e7c00d0e3ed$export$2a59fa0458407049 = ()=>{
    const seg = (n)=>Math.random().toString(36).slice(2, 2 + n);
    return `https://meet.google.com/${seg(3)}-${seg(4)}-${seg(3)}`;
};

});

parcelRegister("7jyv3", function(module, exports) {

$parcel$export(module.exports, "CalEventDetailModal", () => $553511b129c7ab4e$export$1faf52b39b4958b4);
$parcel$export(module.exports, "CalInviteeRow", () => $553511b129c7ab4e$export$9d4d43d039f34fc8);
parcelRequire("kZOF8");
var $bglB6 = parcelRequire("bglB6");
var $kZOF8 = parcelRequire("kZOF8");
// For recurring events, inherit missing fields from a sibling instance
const $553511b129c7ab4e$var$_inheritFromSeries = (ev, events)=>{
    if (!ev || ev.invitees?.length && ev.description !== undefined) return ev;
    const baseId = ev.googleEventId?.replace(/_\d{8}T\d{6}Z$/, '');
    if (!baseId) return ev;
    const sibling = (events || []).find((e)=>e.id !== ev.id && e.googleEventId?.replace(/_\d{8}T\d{6}Z$/, '') === baseId && (e.invitees?.length || e.description));
    if (!sibling) return ev;
    return {
        ...ev,
        invitees: ev.invitees?.length ? ev.invitees : sibling.invitees,
        description: ev.description ?? sibling.description,
        type: ev.type || sibling.type
    };
};
const $553511b129c7ab4e$var$_clearEventHash = ()=>{
    if (typeof window === 'undefined') return;
    const hash = window.location.hash || '';
    if (hash.includes('event=')) {
        const next = '#view=' + (hash.match(/view=([^&]*)/)?.[1] || 'week');
        window.history.replaceState(null, '', next);
    }
};
const $553511b129c7ab4e$export$1faf52b39b4958b4 = {
    extends: 'Modal',
    stateKey: 'showEventDetail',
    extraClose: {
        selectedEvent: null
    },
    display: (el, s)=>{
        const show = s.root?.showEventDetail;
        if (show) {
            const ev = s.root?.selectedEvent;
            if (ev && ev.invitees === undefined) {
                // Try inheriting from a sibling immediately for instant display
                const enriched = $553511b129c7ab4e$var$_inheritFromSeries(ev, s.root?.events);
                if (enriched !== ev && enriched.invitees?.length) s.root.update({
                    selectedEvent: enriched
                });
                // Also fire the lazy-load for this specific instance
                if (el._lastDetailId !== ev.id) {
                    el._lastDetailId = ev.id;
                    (0, $kZOF8.fetchEventDetails)(ev.id, s.root);
                }
            }
            return 'flex';
        }
        if (el._lastDetailId) {
            el._lastDetailId = null;
            $553511b129c7ab4e$var$_clearEventHash();
        }
        return 'none';
    },
    Window: {
        width: '100%',
        maxWidth: 'I',
        maxHeight: '90dvh',
        ModalHeader: {
            Hgroup: {
                H: {
                    text: (el, s)=>{
                        const ev = s.root?.selectedEvent;
                        if (!ev) return '';
                        if ((0, $kZOF8.eventIsPrivateFor)(ev, (0, $bglB6.currentUser)(s.root))) return 'Meeting';
                        return ev.title || '';
                    }
                },
                P: {
                    text: null,
                    flow: 'x',
                    align: 'center left',
                    gap: 'Z1',
                    Icon: {
                        icon: 'clock'
                    },
                    Text: {
                        tag: 'span',
                        text: (el, s)=>{
                            const ev = s.root?.selectedEvent;
                            if (!ev) return '';
                            return `${ev.date} \xb7 ${ev.startTime} \u{2013} ${ev.endTime}`;
                        }
                    }
                }
            },
            Icons: {
                EditBtn: {
                    extends: 'IconButton',
                    Icon: {
                        icon: 'edit'
                    },
                    onClick: (e, el, s)=>{
                        const raw = s.root?.selectedEvent;
                        if (!raw) return;
                        const ev = $553511b129c7ab4e$var$_inheritFromSeries(raw, s.root?.events);
                        // Infer recurrence from sibling instances for Google-synced events
                        const inferred = (0, $kZOF8.inferRecurrence)(s.root?.events, ev);
                        // Detect meeting mode from existing event data
                        const desc = ev.description || '';
                        let meetingMode = ev.meetingMode || 'symbols-meet';
                        let meetUrl = ev.meetUrl || '';
                        if (!ev.meetingMode || ev.meetingMode === 'online') {
                            if (desc.includes('/meet#room=')) meetingMode = 'symbols-meet';
                            else if (ev.meetUrl || desc.match(/https?:\/\//)) {
                                meetingMode = 'external-url';
                                if (!meetUrl && desc.match(/https?:\/\/\S+/)) meetUrl = desc.match(/https?:\/\/\S+/)[0];
                            } else meetingMode = 'symbols-meet';
                        }
                        s.root.update({
                            showEventDetail: false,
                            selectedEvent: null,
                            showNewBooking: true,
                            newBooking: (0, $kZOF8.freshBooking)({
                                title: ev.title,
                                date: ev.date,
                                startTime: ev.startTime,
                                endTime: ev.endTime,
                                startAt: ev.startAt,
                                endAt: ev.endAt,
                                invitees: (ev.invitees || []).join(', '),
                                description: ev.description || '',
                                type: ev.type || 'meeting',
                                meetingMode: meetingMode,
                                meetUrl: meetUrl,
                                recurring: inferred.recurring,
                                recurringDays: inferred.recurringDays,
                                editingEventId: ev.id
                            })
                        });
                    }
                },
                DeleteBtn: {
                    extends: 'IconButton',
                    Icon: {
                        icon: 'trash'
                    },
                    onClick: (e, el, s)=>{
                        const ev = s.root?.selectedEvent;
                        if (!ev) return;
                        s.root.update({
                            confirmAction: {
                                title: `Delete "${ev.title || 'event'}"?`,
                                message: 'This permanently removes the event from the calendar.',
                                confirmText: 'Delete',
                                icon: 'trash',
                                onConfirm: ()=>{
                                    s.root.update({
                                        events: (s.root.events || []).filter((x)=>x.id !== ev.id),
                                        showEventDetail: false,
                                        selectedEvent: null
                                    });
                                    el.call('deleteEventFromSupabase', ev.id);
                                }
                            }
                        });
                    }
                }
            }
        },
        Body: {
            flow: 'y',
            gap: 'A',
            // Linked resources — chat channel(s) / meet room(s) that reference
            // this event. Hidden when there are no links.
            Links: {
                extends: 'LinkedResources',
                type: 'calendar_event',
                id: (el, s)=>s?.root?.selectedEvent?.id || null
            },
            // Edit/Delete actions are in the ModalFooter at the bottom of the Window.
            // Proposal banner — visible only when the open event is a pending
            // proposal. Lets the original creator (or any other invitee) accept,
            // which moves the original event to the proposed time and removes the
            // proposal duplicate, or decline, which just removes the proposal.
            ProposalBanner: {
                display: (el, s)=>s.root?.selectedEvent?.isProposal ? 'flex' : 'none',
                flow: 'x',
                align: 'center space-between',
                gap: 'Z',
                padding: 'Z A',
                round: 'Z',
                background: 'overlay',
                flexWrap: 'wrap',
                Text: {
                    tag: 'span',
                    fontSize: 'Z2',
                    color: 'title',
                    flex: '1',
                    text: (el, s)=>{
                        const ev = s.root?.selectedEvent;
                        if (!ev) return '';
                        return `Proposed by ${ev.proposedBy || 'a participant'} \u{2014} awaiting confirmation`;
                    }
                },
                Actions: {
                    flow: 'x',
                    gap: 'Y',
                    DeclineBtn: {
                        extends: 'Button',
                        theme: 'secondary',
                        text: 'Decline',
                        onClick: (e, el, s)=>{
                            const ev = s.root?.selectedEvent;
                            if (!ev) return;
                            s.root.update({
                                events: (s.root.events || []).filter((x)=>x.id !== ev.id),
                                showEventDetail: false,
                                selectedEvent: null
                            });
                            el.call('deleteEventFromSupabase', ev.id);
                        }
                    },
                    AcceptBtn: {
                        extends: 'Button',
                        theme: 'primary',
                        text: 'Accept',
                        onClick: (e, el, s)=>{
                            const ev = s.root?.selectedEvent;
                            if (!ev) return;
                            const events = s.root.events || [];
                            // Apply the proposal to the original and drop the duplicate.
                            const newEvents = events.filter((x)=>x.id !== ev.id).map((x)=>x.id === ev.originalEventId ? {
                                    ...x,
                                    date: ev.date,
                                    startTime: ev.startTime,
                                    endTime: ev.endTime
                                } : x);
                            s.root.update({
                                events: newEvents,
                                showEventDetail: false,
                                selectedEvent: null
                            });
                            // Persist: original event moves to the proposed time, the
                            // proposal duplicate is deleted. Both push to Google.
                            const movedOrig = newEvents.find((x)=>x.id === ev.originalEventId);
                            if (movedOrig) el.call('saveEventToSupabase', movedOrig);
                            el.call('deleteEventFromSupabase', ev.id);
                        }
                    }
                }
            },
            // Creator / organizer row — resolves the creatorEmail to the person's
            // display name (and avatar) via root.people, falls back to the raw
            // email if no profile is loaded.
            CreatorRow: {
                display: (el, s)=>{
                    const ev = s.root?.selectedEvent;
                    if (!ev?.creatorEmail) return 'none';
                    if ((0, $kZOF8.eventIsPrivateFor)(ev, (0, $bglB6.currentUser)(s.root))) return 'none';
                    return 'flex';
                },
                flow: 'x',
                align: 'center left',
                gap: 'Z1',
                Avatar: {
                    avatarType: 'initials',
                    boxSize: 'B B',
                    src: (el, s)=>{
                        const ev = s.root?.selectedEvent;
                        if (!ev) return el.call('avatarUrl', null);
                        const creator = el.call('findPerson', ev.creatorEmail);
                        return el.call('avatarUrl', creator && creator.name || ev.creatorEmail);
                    }
                },
                Text: {
                    tag: 'span',
                    fontSize: 'Z2',
                    color: 'subtitle',
                    text: (el, s)=>{
                        const ev = s.root?.selectedEvent;
                        if (!ev) return '';
                        const creator = el.call('findPerson', ev.creatorEmail);
                        return `Created by ${creator && creator.name || ev.creatorEmail}`;
                    }
                }
            },
            // Description and Invitees are lazy-loaded by fetchEventDetails when
            // the modal opens. While loading, both show a skeleton; once loaded,
            // empty/undefined fields hide normally.
            Description: {
                display: (el, s)=>{
                    const ev = s.root?.selectedEvent;
                    if (!ev) return 'none';
                    if ((0, $kZOF8.eventIsPrivateFor)(ev, (0, $bglB6.currentUser)(s.root))) return 'none';
                    // Loading: description is undefined (not yet fetched)
                    if (ev.description === undefined) return 'flex';
                    // Loaded: only show if there's content
                    return ev.description ? 'flex' : 'none';
                },
                flow: 'x',
                align: 'flex-start left',
                gap: 'Z1',
                Icon: {
                    icon: 'menu',
                    opacity: '.5'
                },
                Text: {
                    tag: 'p',
                    margin: '0',
                    fontSize: 'Z2',
                    color: 'subtitle',
                    lineHeight: '1.6',
                    text: (el, s)=>s.root?.selectedEvent?.description || ''
                },
                Skeleton: {
                    hide: (el, s)=>s.root?.selectedEvent?.description !== undefined,
                    flex: '1',
                    height: 'A',
                    round: 'V',
                    background: 'overlay',
                    opacity: '.6'
                }
            },
            InviteesSection: {
                display: (el, s)=>{
                    const ev = s.root?.selectedEvent;
                    if (!ev) return 'none';
                    if ((0, $kZOF8.eventIsPrivateFor)(ev, (0, $bglB6.currentUser)(s.root))) return 'none';
                    // Loading: invitees is undefined
                    if (ev.invitees === undefined) return 'flex';
                    // Loaded: only show if there are invitees
                    return ev.invitees.length ? 'flex' : 'none';
                },
                flow: 'y',
                gap: 'Z1',
                HeaderRow: {
                    flow: 'x',
                    align: 'center left',
                    gap: 'Z1',
                    Icon: {
                        icon: 'user'
                    },
                    Label: {
                        tag: 'span',
                        fontSize: 'Z2',
                        fontWeight: '600',
                        color: 'title',
                        text: (el, s)=>{
                            const ev = s.root?.selectedEvent;
                            if (!ev || ev.invitees === undefined) return 'Loading guests...';
                            const count = ev.invitees.length;
                            return `${count} guest${count !== 1 ? 's' : ''}`;
                        }
                    }
                },
                List: {
                    hide: (el, s)=>s.root?.selectedEvent?.invitees === undefined,
                    flow: 'y',
                    gap: 'Z',
                    paddingLeft: 'C',
                    childExtends: 'CalInviteeRow',
                    childrenAs: 'state',
                    children: (el, s)=>(s.root?.selectedEvent?.invitees || []).map((email)=>({
                                email: email
                            }))
                },
                SkeletonList: {
                    hide: (el, s)=>s.root?.selectedEvent?.invitees !== undefined,
                    flow: 'y',
                    gap: 'Z',
                    paddingLeft: 'C',
                    Row1: {
                        height: 'B',
                        round: 'V',
                        background: 'overlay',
                        opacity: '.6'
                    },
                    Row2: {
                        height: 'B',
                        round: 'V',
                        background: 'overlay',
                        opacity: '.4'
                    },
                    Row3: {
                        height: 'B',
                        round: 'V',
                        background: 'overlay',
                        opacity: '.3'
                    }
                }
            }
        },
        ModalFooter: {
            flow: 'x',
            gap: 'Z1',
            // Cross-app: launch a meet call linked to this calendar event. The
            // event id (bigint) flows into meet_rooms.calendar_event_id, which the
            // meet RLS policies treat as a normal owned room.
            SaveBtn: {
                extends: 'Button',
                theme: 'primary',
                text: 'Save event',
                onClick: async (e, el, s)=>{
                    const ev = s.root?.selectedEvent;
                    if (!ev) return;
                    // Reuse an existing meet_room for this event if present, otherwise
                    // create a new one.
                    const existing = (s.root.rooms || []).find((r)=>r.calendarEventId === ev.id);
                    let id = existing?.id;
                    if (!id) id = await el.call('createRoom', {
                        name: ev.title || 'Calendar call',
                        kind: 'scheduled',
                        calendarEventId: ev.id,
                        transcribeEnabled: true
                    });
                    if (!id) return;
                    s.root.update({
                        showEventDetail: false,
                        selectedEvent: null,
                        activeRoomId: id,
                        meetView: 'call'
                    });
                    if (typeof window !== 'undefined') window.location.hash = `room=${id}&view=call`;
                    // Walk up to the page root with the `routes` prop — el.getRoot()
                    // doesn't exist in DOMQL v3.14.
                    let __root = el;
                    while(__root && !__root.routes)__root = __root.parent;
                    if (__root) el.router('/meet', __root);
                    await el.call('connectCall', id);
                }
            },
            Spacer: {
                flex: '1'
            },
            AskAIBtn: {
                extends: 'Button',
                theme: 'secondary',
                flow: 'x',
                gap: 'Z',
                align: 'center center',
                Icon: {
                    icon: 'magicstar',
                    boxSize: 'Z2'
                },
                text: 'Ask AI',
                onClick: (e, el, s)=>{
                    const ev = s.root?.selectedEvent;
                    if (!ev) return;
                    s.root.update({
                        assistantOpen: true,
                        assistantAttachment: {
                            type: 'event',
                            id: ev.id,
                            title: ev.title || '',
                            body: `${ev.date || ''} ${ev.startTime || ''} \u{2013} ${ev.endTime || ''}`,
                            meta: {
                                date: ev.date,
                                startTime: ev.startTime,
                                endTime: ev.endTime
                            }
                        }
                    });
                }
            }
        }
    }
};
const $553511b129c7ab4e$export$9d4d43d039f34fc8 = {
    flow: 'x',
    align: 'center left',
    gap: 'Z1',
    padding: 'Y2 0',
    Avatar: {
        avatarType: 'initials',
        boxSize: 'B1 B1',
        src: (el, s)=>el.call('avatarUrl', s.email)
    },
    Email: {
        tag: 'span',
        fontSize: 'Z2',
        color: 'subtitle',
        text: (el, s)=>s.email || ''
    }
};

});

parcelRegister("lz0XA", function(module, exports) {

$parcel$export(module.exports, "CalProfileModal", () => $fb2d9c86d28a34d4$export$4798162861403ca4);
$parcel$export(module.exports, "CalProfileTabBtn", () => $fb2d9c86d28a34d4$export$8e04fb1b2685d773);
$parcel$export(module.exports, "CalProfileDetailRow", () => $fb2d9c86d28a34d4$export$254e27c8362214eb);
$parcel$export(module.exports, "CalProfileUnavailRow", () => $fb2d9c86d28a34d4$export$f1d2d1fdf29c68e4);
$parcel$export(module.exports, "CalAvailabilityGrid", () => $fb2d9c86d28a34d4$export$fc88702b5e91882b);
$parcel$export(module.exports, "CalAvailabilityHourHeader", () => $fb2d9c86d28a34d4$export$fce0794b4ecf8225);
$parcel$export(module.exports, "CalAvailabilityDayRow", () => $fb2d9c86d28a34d4$export$d96962d9aac01c25);
$parcel$export(module.exports, "CalAvailabilityCell", () => $fb2d9c86d28a34d4$export$1b163d240ec28289);
// Profile modal — unified Profile / Availability / Settings tabs.
// Opens via `root.profileEmail`. Settings + Availability tabs are only
// editable when viewing your own profile (and gated to admin for some
// fields). Profile tab works for any team member.
parcelRequire("kZOF8");
var $bglB6 = parcelRequire("bglB6");
var $kZOF8 = parcelRequire("kZOF8");
const $fb2d9c86d28a34d4$var$_isViewingSelf = (root)=>root?.profileEmail && root.profileEmail === root.currentUserEmail;
const $fb2d9c86d28a34d4$var$_canEditModal = (root)=>$fb2d9c86d28a34d4$var$_isViewingSelf(root) || (0, $bglB6.currentUserIsAdmin)(root);
const $fb2d9c86d28a34d4$var$_formatTime = (tz)=>tz ? (0, $kZOF8.formatTzTime)(Date.now(), tz) : '';
const $fb2d9c86d28a34d4$var$_writeUser = (root, patch)=>{
    const next = (root.people || []).map((p)=>p.email === root.currentUserEmail ? {
            ...p,
            ...patch
        } : p);
    root.update({
        people: next
    });
};
// 7×24 availability grid helpers
const $fb2d9c86d28a34d4$var$DAYS = [
    'Mon',
    'Tue',
    'Wed',
    'Thu',
    'Fri',
    'Sat',
    'Sun'
];
const $fb2d9c86d28a34d4$var$_hhmmToMin = (s)=>{
    if (!s) return 0;
    const [h, m] = s.split(':').map(Number);
    return h * 60 + m;
};
const $fb2d9c86d28a34d4$var$_isAvailableDefault = (user, hour)=>{
    const wh = user?.workingHours;
    if (!wh) return true;
    const minute = hour * 60;
    const start = $fb2d9c86d28a34d4$var$_hhmmToMin(wh.start);
    const end = $fb2d9c86d28a34d4$var$_hhmmToMin(wh.end);
    return start < end ? minute >= start && minute < end : minute >= start || minute < end;
};
const $fb2d9c86d28a34d4$var$_isAvailableAt = (user, day, hour)=>{
    if (!user) return false;
    const grid = user.availabilityGrid;
    if (grid && grid[day] && typeof grid[day][hour] === 'boolean') return grid[day][hour];
    return $fb2d9c86d28a34d4$var$_isAvailableDefault(user, hour);
};
const $fb2d9c86d28a34d4$var$_toggleCell = (root, day, hour)=>{
    const u = (root.people || []).find((p)=>p.email === root.profileEmail) || null;
    if (!u || !userIsAdmin(u)) return;
    const grid = u.availabilityGrid ? u.availabilityGrid.map((row)=>row.slice()) : Array.from({
        length: 7
    }, ()=>Array.from({
            length: 24
        }, (_, h)=>$fb2d9c86d28a34d4$var$_isAvailableDefault(u, h)));
    grid[day][hour] = !grid[day][hour];
    $fb2d9c86d28a34d4$var$_writeUser(root, {
        availabilityGrid: grid
    });
};
const $fb2d9c86d28a34d4$var$_setTab = (root, tab)=>root.update({
        profileModalTab: tab
    });
const $fb2d9c86d28a34d4$export$4798162861403ca4 = {
    extends: 'Modal',
    stateKey: 'profileEmail',
    extraClose: {
        profileModalTab: 'profile'
    },
    Window: {
        width: '100%',
        maxWidth: 'I',
        maxHeight: '90dvh',
        gap: 'A',
        ModalHeader: {
            Avatar: {
                order: -1,
                avatarType: 'initials',
                boxSize: 'D D',
                src: (el, s)=>el.call('avatarUrl', el.call('findPerson', s.root.profileEmail)?.name)
            },
            Hgroup: {
                gap: '0',
                H: {
                    margin: '0',
                    text: (el, s)=>el.call('findPerson', s.root.profileEmail)?.name || 'Profile'
                },
                P: {
                    text: (el, s)=>{
                        const p = el.call('findPerson', s.root.profileEmail);
                        if (!p) return '';
                        const email = String(p.email || s.root.profileEmail || '').toLowerCase();
                        const team = (s.root?.teamsByEmail?.[email] || [])[0]?.name;
                        return [
                            p.position,
                            team
                        ].filter(Boolean).join(" \xb7 ");
                    }
                },
                Email: {
                    tag: 'span',
                    fontSize: 'Z2',
                    color: 'caption',
                    fontFamily: 'monospace',
                    text: (el, s)=>el.call('findPerson', s.root.profileEmail)?.email || ''
                }
            },
            Icons: {
                ExpandBtn: {
                    Icon: {
                        icon: 'expand'
                    },
                    title: 'Open as full page',
                    onClick: (e, el, s)=>{
                        e.stopPropagation();
                        const email = s.root.profileEmail;
                        if (!email) return;
                        s.root.update({
                            profileEmail: null,
                            profileModalTab: 'profile'
                        });
                        let rootEl = el;
                        while(rootEl && !rootEl.routes)rootEl = rootEl.parent;
                        const router = el.context?.utils?.router;
                        if (router && rootEl) router(`/profile?u=${encodeURIComponent(email)}`, rootEl, {}, {
                            pushState: true,
                            scrollToTop: true
                        });
                    }
                }
            }
        },
        Tabs: {
            flow: 'x',
            gap: 'V',
            borderBottomWidth: '1px',
            borderBottomColor: 'line',
            borderBottomStyle: 'solid',
            childExtends: 'CalProfileTabBtn',
            children: [
                {
                    tab: 'profile',
                    label: 'Profile'
                },
                {
                    tab: 'availability',
                    label: 'Availability'
                },
                {
                    tab: 'settings',
                    label: 'Settings',
                    hide: (el, s)=>!$fb2d9c86d28a34d4$var$_isViewingSelf(s.root)
                }
            ]
        },
        // ── Profile tab ──
        ProfilePane: {
            hide: (el, s)=>(s.root.profileModalTab || 'profile') !== 'profile',
            flow: 'y',
            gap: 'A',
            DetailGrid: {
                flow: 'y',
                gap: 'Z',
                padding: 'Z 0',
                childExtends: 'CalProfileDetailRow',
                children: [
                    {
                        label: 'Their local time',
                        valueGetter: (p)=>$fb2d9c86d28a34d4$var$_formatTime(p?.timezone)
                    },
                    {
                        label: 'GitHub',
                        valueGetter: (p)=>p?.github || "\u2014"
                    },
                    {
                        label: 'Weekly target',
                        valueGetter: (p)=>String(p?.weeklyHours ?? "\u2014")
                    },
                    {
                        label: 'Working days',
                        valueGetter: (p)=>p?.workingDays || "\u2014"
                    },
                    {
                        label: 'Working hours',
                        valueGetter: (p)=>{
                            if (!p?.workingHours) return "\u2014";
                            return `${p.workingHours.start} \u{2013} ${p.workingHours.end}`;
                        }
                    }
                ]
            }
        },
        // ── Availability tab ──
        AvailabilityPane: {
            hide: (el, s)=>s.root.profileModalTab !== 'availability',
            flow: 'y',
            gap: 'Z',
            Header: {
                flow: 'x',
                align: 'center space-between',
                Title: {
                    tag: 'span',
                    text: 'General availability',
                    fontSize: 'Z2',
                    fontWeight: '600',
                    color: 'subtitle'
                },
                Hint: {
                    tag: 'span',
                    fontSize: 'Y2',
                    color: 'caption',
                    text: (el, s)=>(0, $bglB6.currentUserIsAdmin)(s.root) ? 'Click to toggle (admin)' : 'Read only'
                }
            },
            CalAvailabilityGrid: {},
            AvailFields: {
                flow: 'y',
                gap: 'Z1',
                padding: 'Z 0',
                childExtends: 'InputField',
                LocationField: {
                    Title: {
                        text: 'Location'
                    },
                    Input: {
                        tag: 'input',
                        type: 'text',
                        placeholder: 'City, Country',
                        readonly: (el, s)=>$fb2d9c86d28a34d4$var$_canEditModal(s.root) ? null : true,
                        value: (el, s)=>el.call('findPerson', s.root.profileEmail)?.location || '',
                        onInput: (e, el, s)=>{
                            if (!$fb2d9c86d28a34d4$var$_canEditModal(s.root)) return;
                            $fb2d9c86d28a34d4$var$_writeUser(s.root, {
                                location: e.target.value
                            });
                        }
                    }
                },
                TimezoneField: {
                    Title: {
                        text: 'Timezone (IANA)'
                    },
                    Input: {
                        tag: 'input',
                        type: 'text',
                        placeholder: 'e.g. Asia/Tbilisi',
                        readonly: (el, s)=>$fb2d9c86d28a34d4$var$_canEditModal(s.root) ? null : true,
                        value: (el, s)=>el.call('findPerson', s.root.profileEmail)?.timezone || '',
                        onInput: (e, el, s)=>{
                            if (!$fb2d9c86d28a34d4$var$_canEditModal(s.root)) return;
                            $fb2d9c86d28a34d4$var$_writeUser(s.root, {
                                timezone: e.target.value
                            });
                        }
                    }
                },
                WeeklyHoursField: {
                    Title: {
                        text: 'Weekly hours (auto from grid)'
                    },
                    Input: {
                        tag: 'input',
                        type: 'text',
                        readonly: true,
                        value: (el, s)=>{
                            const u = el.call('findPerson', s.root.profileEmail);
                            if (!u) return '0';
                            let count = 0;
                            for(let day = 0; day < 7; day++){
                                for(let h = 0; h < 24; h++)if ($fb2d9c86d28a34d4$var$_isAvailableAt(u, day, h)) count++;
                            }
                            return `${count} h / week`;
                        }
                    }
                }
            }
        },
        // ── Settings tab (self only) ──
        SettingsPane: {
            hide: (el, s)=>s.root.profileModalTab !== 'settings',
            flow: 'y',
            gap: 'Z1',
            childExtends: 'InputField',
            NameField: {
                Title: {
                    text: 'Display name'
                },
                Input: {
                    tag: 'input',
                    type: 'text',
                    placeholder: 'Your name',
                    value: (el, s)=>el.call('findPerson', s.root.profileEmail)?.name || '',
                    onInput: (e, el, s)=>$fb2d9c86d28a34d4$var$_writeUser(s.root, {
                            name: e.target.value
                        })
                }
            },
            PositionField: {
                Title: {
                    text: 'Position / Title'
                },
                Input: {
                    tag: 'input',
                    type: 'text',
                    placeholder: 'e.g. Frontend Engineer',
                    value: (el, s)=>el.call('findPerson', s.root.profileEmail)?.position || '',
                    onInput: (e, el, s)=>$fb2d9c86d28a34d4$var$_writeUser(s.root, {
                            position: e.target.value
                        })
                }
            },
            // Read-only team display. Team membership is managed from the
            // profile editor in MemberProfile (with a real picker); the
            // calendar profile popover surfaces it but doesn't edit.
            TeamField: {
                Title: {
                    text: 'Team'
                },
                Input: {
                    tag: 'div',
                    padding: 'Z A',
                    fontSize: 'A',
                    color: 'title',
                    text: (el, s)=>{
                        const p = el.call('findPerson', s.root.profileEmail);
                        const email = String(p?.email || s.root.profileEmail || '').toLowerCase();
                        return (s.root?.teamsByEmail?.[email] || [])[0]?.name || "\u2014";
                    }
                }
            },
            GitHubField: {
                Title: {
                    text: 'GitHub username'
                },
                Input: {
                    tag: 'input',
                    type: 'text',
                    placeholder: 'e.g. nikoloza',
                    value: (el, s)=>el.call('findPerson', s.root.profileEmail)?.github || '',
                    onInput: (e, el, s)=>$fb2d9c86d28a34d4$var$_writeUser(s.root, {
                            github: e.target.value
                        })
                }
            }
        },
        // ── Footer (always visible) ──
        ModalFooter: {}
    }
};
const $fb2d9c86d28a34d4$export$8e04fb1b2685d773 = {
    tag: 'button',
    type: 'button',
    padding: 'Z A',
    borderWidth: '0',
    borderBottomWidth: '2px',
    borderBottomStyle: 'solid',
    borderBottomColor: (el, s)=>(s.root.profileModalTab || 'profile') === el.tab ? 'blue' : 'transparent',
    background: 'transparent',
    cursor: 'pointer',
    fontSize: 'Z2',
    fontWeight: (el, s)=>(s.root.profileModalTab || 'profile') === el.tab ? '600' : '500',
    color: (el, s)=>(s.root.profileModalTab || 'profile') === el.tab ? 'title' : 'caption',
    text: (el)=>el.label || '',
    marginBottom: '-1px',
    ':hover': {
        color: 'title'
    },
    onClick: (e, el, s)=>$fb2d9c86d28a34d4$var$_setTab(s.root, el.tab)
};
const $fb2d9c86d28a34d4$export$254e27c8362214eb = {
    flow: 'x',
    align: 'center left',
    gap: 'Z',
    padding: 'Y 0',
    Label: {
        tag: 'span',
        fontSize: 'Z2',
        color: 'caption',
        width: 'F',
        minWidth: 'F',
        text: (el)=>el.parent.label || ''
    },
    Value: {
        tag: 'span',
        fontSize: 'Z2',
        color: 'title',
        flex: '1',
        text: (el, s)=>{
            const fn = el.parent.valueGetter;
            const p = el.call('findPerson', s.root.profileEmail);
            return typeof fn === 'function' ? fn(p) : '';
        }
    }
};
const $fb2d9c86d28a34d4$export$f1d2d1fdf29c68e4 = {
    flow: 'x',
    gap: 'Z',
    align: 'center left',
    padding: 'Y Z',
    round: 'Z',
    background: 'red.10',
    TypeBadge: {
        tag: 'span',
        fontSize: 'Y2',
        fontWeight: '700',
        textTransform: 'uppercase',
        color: 'red',
        text: (el, s)=>s.type || ''
    },
    Title: {
        tag: 'span',
        fontSize: 'Z2',
        color: 'title',
        flex: '1',
        text: (el, s)=>s.title || '(no title)'
    },
    Range: {
        tag: 'span',
        fontSize: 'Y2',
        color: 'caption',
        fontFamily: 'monospace',
        text: (el, s)=>{
            if (s.endDate && s.endDate !== s.date) return `${s.date} \u{2192} ${s.endDate}`;
            return `${s.date} ${s.startTime || ''}\u{2013}${s.endTime || ''}`;
        }
    }
};
const $fb2d9c86d28a34d4$export$fc88702b5e91882b = {
    display: 'grid',
    gridTemplateColumns: 'auto repeat(24, 1fr)',
    gridTemplateRows: 'auto repeat(7, auto)',
    gap: '1px',
    background: 'line',
    padding: '1px',
    round: 'Z',
    overflow: 'hidden',
    userSelect: 'none',
    Corner: {
        background: 'modal',
        padding: 'Y'
    },
    HourHeaders: {
        display: 'contents',
        childExtends: 'CalAvailabilityHourHeader',
        childrenAs: 'state',
        children: ()=>Array.from({
                length: 24
            }, (_, h)=>({
                    h: h
                }))
    },
    DayRows: {
        display: 'contents',
        childExtends: 'CalAvailabilityDayRow',
        childrenAs: 'state',
        children: ()=>$fb2d9c86d28a34d4$var$DAYS.map((label, day)=>({
                    day: day,
                    label: label
                }))
    }
};
const $fb2d9c86d28a34d4$export$fce0794b4ecf8225 = {
    tag: 'span',
    background: 'modal',
    fontSize: 'Y2',
    color: 'caption',
    fontFamily: 'monospace',
    textAlign: 'center',
    padding: 'Y 0',
    text: (el, s)=>String(s.h).padStart(2, '0')
};
const $fb2d9c86d28a34d4$export$d96962d9aac01c25 = {
    display: 'contents',
    Label: {
        tag: 'span',
        background: 'modal',
        fontSize: 'Y2',
        color: 'caption',
        fontWeight: '600',
        padding: 'Y Z',
        align: 'center right',
        text: (el, s)=>s.label
    },
    Cells: {
        display: 'contents',
        childExtends: 'CalAvailabilityCell',
        childrenAs: 'state',
        children: (el, s)=>Array.from({
                length: 24
            }, (_, h)=>({
                    day: s.day,
                    h: h
                }))
    }
};
const $fb2d9c86d28a34d4$export$1b163d240ec28289 = {
    tag: 'button',
    border: 'none',
    padding: '0',
    height: 'A',
    minHeight: 'A',
    background: (el, s)=>{
        const u = el.call('findPerson', el.state.root.profileEmail);
        return $fb2d9c86d28a34d4$var$_isAvailableAt(u, s.day, s.h) ? 'green' : 'red.15';
    },
    cursor: (el, s)=>(0, $bglB6.currentUserIsAdmin)(el.state.root) ? 'pointer' : 'not-allowed',
    ':hover': {
        opacity: '.85'
    },
    onClick: (e, el, s)=>{
        e.preventDefault();
        $fb2d9c86d28a34d4$var$_toggleCell(el.state.root, s.day, s.h);
    }
};

});


parcelRegister("f6T1d", function(module, exports) {

var $hN8Qe = parcelRequire("hN8Qe");

var $kms8P = parcelRequire("kms8P");

var $k4q9g = parcelRequire("k4q9g");

var $2InEd = parcelRequire("2InEd");

var $lFIvM = parcelRequire("lFIvM");

var $e5Lqn = parcelRequire("e5Lqn");

var $fbO43 = parcelRequire("fbO43");

var $c4gr5 = parcelRequire("c4gr5");

var $1xVWB = parcelRequire("1xVWB");

var $kRbaA = parcelRequire("kRbaA");

var $8H5bb = parcelRequire("8H5bb");

var $2F4Cy = parcelRequire("2F4Cy");

var $hO1ab = parcelRequire("hO1ab");

var $eD2nt = parcelRequire("eD2nt");

var $dpIWN = parcelRequire("dpIWN");

var $ksjO3 = parcelRequire("ksjO3");

var $bZEqU = parcelRequire("bZEqU");
$parcel$exportWildcard(module.exports, $hN8Qe);
$parcel$exportWildcard(module.exports, $kms8P);
$parcel$exportWildcard(module.exports, $k4q9g);
$parcel$exportWildcard(module.exports, $2InEd);
$parcel$exportWildcard(module.exports, $lFIvM);
$parcel$exportWildcard(module.exports, $e5Lqn);
$parcel$exportWildcard(module.exports, $fbO43);
$parcel$exportWildcard(module.exports, $c4gr5);
$parcel$exportWildcard(module.exports, $1xVWB);
$parcel$exportWildcard(module.exports, $kRbaA);
$parcel$exportWildcard(module.exports, $8H5bb);
$parcel$exportWildcard(module.exports, $2F4Cy);
$parcel$exportWildcard(module.exports, $hO1ab);
$parcel$exportWildcard(module.exports, $eD2nt);
$parcel$exportWildcard(module.exports, $dpIWN);
$parcel$exportWildcard(module.exports, $ksjO3);
$parcel$exportWildcard(module.exports, $bZEqU);

});
parcelRegister("hN8Qe", function(module, exports) {

$parcel$export(module.exports, "TicketsSidebar", () => $cf3ddf046a629aa4$export$c790f45a111bc062);
$parcel$export(module.exports, "TicketsSidebarItem", () => $cf3ddf046a629aa4$export$29ab116f87e5a68f);
$parcel$export(module.exports, "TicketsSidebarGroup", () => $cf3ddf046a629aa4$export$cff5571d7e1f7a50);
$parcel$export(module.exports, "TicketsFilterBtn", () => $cf3ddf046a629aa4$export$a980b092b76376cf);
const $cf3ddf046a629aa4$export$c790f45a111bc062 = {
    extends: 'AppSidebar',
    tag: 'nav',
    attr: {
        'aria-label': 'Tickets navigation'
    },
    // No PeopleSection on tickets
    PeopleSection: null,
    Top: null,
    Middle: {
        overflow: 'auto',
        flex: '1',
        // ── Tickets ──
        TicketsGroup: {
            extends: 'TicketsSidebarGroup',
            label: 'TICKETS',
            List: {
                flow: 'y',
                gap: 'V',
                childExtends: 'TicketsSidebarItem',
                children: [
                    {
                        href: '/tickets',
                        label: 'My view',
                        icon: 'user'
                    },
                    {
                        href: '/tickets/general',
                        label: 'General',
                        icon: 'state'
                    },
                    {
                        href: '/tickets/feed',
                        label: 'Feed',
                        icon: 'clock'
                    },
                    {
                        href: '/tickets/canvas',
                        label: 'Canvas',
                        icon: 'magicstar'
                    },
                    {
                        href: '/tickets/epics',
                        label: 'Epics',
                        icon: 'magicstar'
                    },
                    {
                        href: '/tickets/stories',
                        label: 'Stories',
                        icon: 'star'
                    },
                    {
                        href: '/tickets/board',
                        label: 'Board',
                        icon: 'borderRadius'
                    },
                    {
                        href: '/tickets/status',
                        label: 'Status',
                        icon: 'check'
                    }
                ]
            }
        },
        // ── Requests (sales + feedback) ──
        RequestsGroup: {
            extends: 'TicketsSidebarGroup',
            label: 'REQUESTS',
            List: {
                flow: 'y',
                gap: 'V',
                childExtends: 'TicketsSidebarItem',
                children: [
                    {
                        href: '/tickets/requests',
                        label: 'Customer requests',
                        icon: 'chat'
                    },
                    {
                        href: '/tickets/requests/inbound',
                        label: 'Inbound',
                        icon: 'arrowDown'
                    },
                    {
                        href: '/tickets/requests/outbound',
                        label: 'Outbound',
                        icon: 'arrowUp'
                    }
                ]
            }
        },
        // ── Resolutions (PR-like) ──
        ResolutionsGroup: {
            extends: 'TicketsSidebarGroup',
            label: 'RESOLUTIONS',
            List: {
                flow: 'y',
                gap: 'V',
                childExtends: 'TicketsSidebarItem',
                children: [
                    {
                        href: '/tickets/resolutions',
                        label: 'Resolutions',
                        icon: 'check'
                    },
                    {
                        href: '/tickets/resolutions/improvements',
                        label: 'Improvement requests',
                        icon: 'magicstar'
                    },
                    {
                        href: '/tickets/resolutions/edit-requests',
                        label: 'Edit requests',
                        icon: 'edit'
                    },
                    {
                        href: '/tickets/requests/audit',
                        label: 'Audit / Reports',
                        icon: 'document'
                    }
                ]
            }
        }
    }
};
const $cf3ddf046a629aa4$export$29ab116f87e5a68f = {
    extends: 'SidebarRow',
    padding: 'Z A',
    round: 'C',
    fontSize: 'A',
    background: (el, s)=>(s.root?.currentPath || s.root?.route || '/') === el.href ? 'overlay' : 'transparent',
    color: (el, s)=>(s.root?.currentPath || s.root?.route || '/') === el.href ? 'title' : 'subtitle',
    fontWeight: (el, s)=>(s.root?.currentPath || s.root?.route || '/') === el.href ? '600' : '500',
    Icon: {
        boxSize: 'A',
        color: (el, s)=>(s.root?.currentPath || s.root?.route || '/') === el.parent?.href ? 'blue' : 'caption'
    },
    onClick: (e, el)=>{
        let rootEl = el;
        while(rootEl && !rootEl.routes)rootEl = rootEl.parent;
        const router = el.context?.utils?.router;
        if (router && rootEl) router(el.href, rootEl, {}, {
            pushState: true,
            scrollToTop: true
        });
    },
    MoreBtn: {
        items: [
            {
                label: 'Pin to top',
                action: 'pin'
            },
            {
                label: 'Customize view',
                action: 'customize-view'
            }
        ]
    }
};
const $cf3ddf046a629aa4$export$cff5571d7e1f7a50 = {
    flow: 'y',
    gap: 'Z',
    marginBottom: 'A',
    Header: {
        flow: 'x',
        align: 'center left',
        padding: 'V 0',
        CaptionTitle: {
            flex: '1',
            fontSize: 'Y2',
            Text: {
                text: (el)=>el.parent?.parent?.parent?.label || ''
            }
        }
    }
};
const $cf3ddf046a629aa4$export$a980b092b76376cf = {
    tag: 'button',
    type: 'button',
    flow: 'x',
    align: 'center left',
    gap: 'Z1',
    padding: 'Z A',
    round: 'C',
    cursor: 'pointer',
    fontSize: 'A',
    textDecoration: 'none',
    fontWeight: (el, s)=>(s.root?.filterAssignee || 'all') === el.value ? '600' : '500',
    background: (el, s)=>(s.root?.filterAssignee || 'all') === el.value ? 'overlay' : 'transparent',
    color: (el, s)=>(s.root?.filterAssignee || 'all') === el.value ? 'title' : 'subtitle',
    borderWidth: '0',
    ':hover': {
        background: 'overlay',
        color: 'title'
    },
    transition: 'background 120ms ease',
    onClick: (e, el, s)=>{
        s.root.update({
            filterAssignee: el.value === 'all' ? null : el.value
        });
        try {
            el.call('reloadTickets');
        } catch (err) {
            console.error(err);
        }
    },
    Icon: {
        icon: (el)=>el.parent?.icon || 'state',
        boxSize: 'A'
    },
    Label: {
        tag: 'span',
        text: (el)=>el.parent?.label || ''
    }
};

});

parcelRegister("kms8P", function(module, exports) {

$parcel$export(module.exports, "TicketsMain", () => $ed2bb1072742ca86$export$ad8d35e6881da78);
$parcel$export(module.exports, "TicketsHeader", () => $ed2bb1072742ca86$export$25fa58875b0debe9);
$parcel$export(module.exports, "TicketsHeaderFilter", () => $ed2bb1072742ca86$export$c384db83b720f6b);
// Tickets main pane — header (page title + new ticket + sync) + body.

var $ac7NT = parcelRequire("ac7NT");

var $7MNpT = parcelRequire("7MNpT");
const $ed2bb1072742ca86$var$PAGE_TITLES = {
    '/tickets': 'My view',
    '/tickets/my': 'My view',
    '/tickets/general': 'General',
    '/tickets/feed': 'Feed',
    '/tickets/canvas': 'Canvas',
    '/tickets/epics': 'Epics',
    '/tickets/stories': 'Stories',
    '/tickets/board': 'Board',
    '/tickets/standups': 'Standups',
    '/tickets/requests': 'Requests',
    '/tickets/requests/inbound': 'Inbound',
    '/tickets/requests/outbound': 'Outbound',
    '/tickets/requests/audit': 'Audit / Reports',
    '/tickets/resolutions': 'Resolutions',
    '/tickets/resolutions/improvements': 'Improvement Requests',
    '/tickets/resolutions/edit-requests': 'Edit Requests'
};
const $ed2bb1072742ca86$export$ad8d35e6881da78 = {
    extends: 'AppMain',
    Header: {
        extends: 'TicketsHeader'
    },
    Body: {
        // Board page title — provides the required H1 landmark for screen readers.
        // Visually matches the compact top-bar style used by CanvasMain.
        BoardTitleBar: {
            flow: 'x',
            align: 'center left',
            padding: 'Z A',
            borderBottomWidth: 'V',
            borderBottomStyle: 'solid',
            borderBottomColor: 'line',
            PageTitle: {
                tag: 'h1',
                margin: '0',
                fontSize: 'B',
                fontWeight: '700',
                letterSpacing: '-.02em',
                color: 'title',
                text: 'Board'
            }
        },
        TicketsBoardView: {}
    }
};
const $ed2bb1072742ca86$export$25fa58875b0debe9 = {
    extends: 'PageHeader',
    backdropFilter: 'blur(20px)',
    LeftGroup: {
        PageTitle: {
            tag: 'span',
            fontSize: 'B',
            fontWeight: '600',
            letterSpacing: '-.015em',
            color: 'title',
            text: (el, s)=>$ed2bb1072742ca86$var$PAGE_TITLES[s.root.currentPath || s.root.route] || 'Tickets'
        }
    },
    CenterGroup: {
        // Cross-page assignee filter — reused by every /tickets/* page.
        // State: root.filterAssignee ∈ { null | 'team' | 'agents' | 'me' }.
        // null = All (default); 'team' = humans except current user; 'agents'
        // = *-agent@symbols.app; 'me' = current user.
        FilterSwitcher: {
            extends: 'SharedViewSwitcher',
            stateKey: 'filterAssignee',
            All: {
                extends: 'SharedViewSwitcherBtn',
                value: null,
                label: 'All'
            },
            Team: {
                extends: 'SharedViewSwitcherBtn',
                value: 'team',
                label: 'Team'
            },
            Agents: {
                extends: 'SharedViewSwitcherBtn',
                value: 'agents',
                label: 'Agents'
            },
            Mine: {
                extends: 'SharedViewSwitcherBtn',
                value: 'me',
                label: 'Me'
            }
        }
    },
    RightGroup: {
        // OnlineBar / AiToggle / Profile already live in the global AppHeader.
        // Tickets-only actions: new-ticket button + GitHub resync.
        NewBtn: {
            tag: 'button',
            flow: 'x',
            align: 'center center',
            gap: 'Z',
            padding: 'Z A',
            round: 'C',
            border: 'none',
            cursor: 'pointer',
            fontSize: 'Z2',
            fontWeight: '600',
            theme: 'primary',
            onClick: (e, el, s)=>{
                s.root.update({
                    selectedTicket: {
                        _new: true
                    },
                    ticketDraft: (0, $7MNpT.freshTicket)()
                });
            },
            Icon: {
                icon: 'plus',
                boxSize: 'A'
            },
            Label: {
                tag: 'span',
                text: 'New ticket'
            }
        },
        // Manual GitHub Projects resync — pokes the github-sync Edge Function
        // (pull + push pass) and reloads. Spins the icon while in flight.
        ResyncBtn: {
            extends: 'IconButton',
            Icon: {
                icon: 'refresh'
            },
            title: 'Resync with GitHub Projects',
            transform: (el, s)=>s.root.syncing ? 'rotate(360deg)' : 'rotate(0deg)',
            transition: 'transform 1s linear',
            onClick: async (e, el, s)=>{
                const root = s.root;
                if (root.syncing) return;
                root.update({
                    syncing: true
                });
                try {
                    await fetch((0, $ac7NT.GITHUB_SYNC_URL), {
                        method: 'POST',
                        headers: (0, $ac7NT.GITHUB_SYNC_HEADERS)
                    });
                } catch (_) {
                /* still reload to pick up any partial pull */ }
                if (typeof window !== 'undefined') window.location.reload();
            }
        }
    }
};
const $ed2bb1072742ca86$export$c384db83b720f6b = {
    tag: 'button',
    type: 'button',
    padding: 'Z A',
    round: 'C',
    border: 'none',
    cursor: 'pointer',
    fontSize: 'Z2',
    fontWeight: (el, s)=>(s.root?.filterAssignee || 'all') === el.value ? '600' : '400',
    theme: (el, s)=>(s.root?.filterAssignee || 'all') === el.value ? 'secondary' : 'tertiary',
    onClick: (e, el, s)=>{
        s.root.update({
            filterAssignee: el.value === 'all' ? null : el.value
        });
        try {
            el.call('reloadTickets');
        } catch (err) {
            console.error(err);
        }
    }
};

});

parcelRegister("k4q9g", function(module, exports) {

$parcel$export(module.exports, "TicketsBoardView", () => $e9c876e6a2c43258$export$fddef6f59d7c059a);
$parcel$export(module.exports, "TicketsBoardColumn", () => $e9c876e6a2c43258$export$23c5ef11bc5cd43d);
// Kanban board — one column per `ticket_columns` row, each rendering the
// tickets that belong to it via getTicketsForColumn(). Drag-and-drop is
// HTML5-native (draggable + dragstart/over/drop events) — keeping this
// minimal until we need touch support.

var $7MNpT = parcelRequire("7MNpT");
var $1ALAp = parcelRequire("1ALAp");
const $e9c876e6a2c43258$export$fddef6f59d7c059a = {
    flow: 'x',
    flex: '1',
    overflow: 'auto',
    padding: 'A1 A1 A1 A',
    gap: 'A',
    align: 'stretch left',
    attr: {
        'data-tickets-board': 'true'
    },
    childExtends: 'TicketsBoardColumn',
    childrenAs: 'state',
    // Pull the columns straight from root.columns — they were mirrored from
    // GitHub's Status field options on the last sync pass, so the board's
    // shape (count, order, names, colours) matches the upstream project 1:1.
    children: (el, s)=>(s.root.columns || []).slice().sort((a, b)=>a.position - b.position)
};
const $e9c876e6a2c43258$export$23c5ef11bc5cd43d = {
    flow: 'y',
    width: 'I',
    minWidth: 'I',
    height: '100%',
    minHeight: '0',
    background: 'gray.05',
    borderWidth: '1px',
    borderColor: 'line',
    borderStyle: 'solid',
    round: 'Z1',
    overflow: 'hidden',
    // Drop target — drop a ticket card on the column body and we move it to
    // the end of this column. Per-card insertion happens on the card itself.
    attr: {
        'data-col-key': (el, s)=>s.key
    },
    onDragover: (e, el, s)=>{
        e.preventDefault();
    },
    onDrop: async (e, el, s)=>{
        e.preventDefault();
        const ticketId = Number(e.dataTransfer.getData('text/ticket-id'));
        if (!ticketId) return;
        const root = el.state.root;
        const colKey = s.key;
        const inCol = (root.tickets || []).filter((t)=>t.columnKey === colKey);
        const lastPos = inCol.length ? Math.max(...inCol.map((t)=>t.position || 0)) : 0;
        const nextPos = (0, $7MNpT.positionBetween)(lastPos, null);
        root.update({
            tickets: (root.tickets || []).map((t)=>t.id === ticketId ? {
                    ...t,
                    columnKey: colKey,
                    position: nextPos
                } : t)
        });
        el.call('moveTicket', {
            ticketId: ticketId,
            columnKey: colKey,
            position: nextPos
        });
    },
    Header: {
        flow: 'x',
        align: 'center space-between',
        padding: 'Z A',
        Left: {
            flow: 'x',
            align: 'center left',
            gap: 'Z',
            Dot: {
                width: 'Z',
                height: 'Z',
                round: '50%',
                background: (el, s)=>(0, $1ALAp.githubColorTokenFromName)(s.color),
                boxShadow: (el, s)=>`0 0 8px color-mix(in srgb, ${(0, $1ALAp.githubColorTokenFromName)(s.color)} 60%, transparent)`
            },
            Label: {
                tag: 'span',
                fontSize: 'Z2',
                fontWeight: '600',
                letterSpacing: '-.005em',
                color: 'title',
                text: (el, s)=>s.label,
                title: (el, s)=>s.description || ''
            },
            Count: {
                tag: 'span',
                padding: 'V Y',
                round: 'C',
                fontSize: 'V',
                fontWeight: '600',
                color: 'caption',
                background: 'overlay',
                text: (el, s)=>{
                    let n = el;
                    while(n && !Array.isArray(n.state?.tickets))n = n.parent;
                    const root = n?.state || {};
                    const colKey = el.parent.parent.state?.key;
                    const list = (0, $7MNpT.getTicketsForColumn)(root, colKey);
                    return String(list.length);
                }
            }
        },
        AddBtn: {
            extends: 'IconButton',
            Icon: {
                icon: 'plus'
            },
            onClick: (e, el, s)=>{
                el.state.root.update({
                    selectedTicket: {
                        _new: true
                    },
                    ticketDraft: {
                        title: '',
                        body: '',
                        columnKey: s.key,
                        assigneeEmail: '',
                        labels: [],
                        priority: 'medium',
                        dueDate: ''
                    }
                });
            }
        }
    },
    // Card list — incremental pagination via IntersectionObserver. Each
    // column's bottom Sentinel triggers el.call('pageColumn', colKey) when
    // it scrolls into view, fetching the next PAGE_SIZE rows of just that
    // column from Supabase. Combined with content-visibility:auto on the
    // cards, this keeps initial mount cheap (50 cards × 12 columns = 600
    // total) and only loads more when the user actually scrolls down.
    List: {
        flow: 'y',
        gap: 'Z',
        padding: 'Z A',
        flex: '1 1 0',
        minHeight: '0',
        overflowY: 'auto',
        position: 'relative',
        Items: {
            flow: 'y',
            gap: 'Z',
            childExtends: 'TicketsCard',
            childrenAs: 'state',
            children: (el, s)=>{
                let n = el;
                while(n && !Array.isArray(n.state?.tickets))n = n.parent;
                const root = n?.state || {};
                return (0, $7MNpT.getTicketsForColumn)(root, el.parent.parent.state.key);
            }
        },
        // Sentinel — sits at the bottom of the column. When it intersects
        // the column's scroll viewport (rootMargin gives a 200px lookahead
        // so we start loading just before the user reaches the end), call
        // pageColumn to fetch more rows for this column.
        Sentinel: {
            tag: 'div',
            display: (el, s)=>{
                let n = el;
                while(n && !n.state?.totalByColumn)n = n.parent;
                const root = n?.state || {};
                const colKey = el.parent.parent.state.key;
                const loaded = (root.loadedByColumn || {})[colKey] || 0;
                const total = (root.totalByColumn || {})[colKey] || 0;
                return loaded < total ? 'flex' : 'none';
            },
            align: 'center center',
            padding: 'A',
            fontSize: 'Y2',
            color: 'caption',
            text: (el, s)=>{
                let n = el;
                while(n && !n.state?.totalByColumn)n = n.parent;
                const root = n?.state || {};
                const colKey = el.parent.parent.state.key;
                const loaded = (root.loadedByColumn || {})[colKey] || 0;
                const total = (root.totalByColumn || {})[colKey] || 0;
                const loading = (root.loadingColumn || {})[colKey];
                return loading ? "Loading\u2026" : `Load more \xb7 ${loaded} / ${total}`;
            },
            onCreate: (el, s)=>{
                const colKey = el.parent.parent.state.key;
                // root: null = browser viewport. Sentinel only triggers when
                // the column is BOTH horizontally on screen AND its own scroll
                // has reached the bottom (= sentinel becomes visible). The
                // generous rootMargin starts loading just before the user
                // physically reaches the end of the list.
                el._io = new IntersectionObserver((entries)=>{
                    for (const entry of entries)if (entry.isIntersecting) {
                        el.call('pageColumn', colKey);
                        break;
                    }
                }, {
                    root: null,
                    rootMargin: '400px 200px',
                    threshold: 0
                });
                el._io.observe(el.node);
            },
            onRemove: (el)=>{
                if (el._io) el._io.disconnect();
            }
        }
    }
};

});

parcelRegister("2InEd", function(module, exports) {

$parcel$export(module.exports, "TicketsCard", () => $1fa208c48043782b$export$ea1becc3bb67a61c);
$parcel$export(module.exports, "TicketsAssigneeAvatar", () => $1fa208c48043782b$export$f68773e89e3ca316);
$parcel$export(module.exports, "TicketsLabelChip", () => $1fa208c48043782b$export$7f09028533cf18cd);

var $7MNpT = parcelRequire("7MNpT");
const $1fa208c48043782b$var$MAX_VISIBLE_LABELS = 3;
const $1fa208c48043782b$var$MAX_VISIBLE_ASSIGNEES = 3;
// Strip markdown noise from issue body so the card preview reads like
// plain prose. Light-touch — full markdown rendering belongs in the detail
// modal, not on the board.
const $1fa208c48043782b$var$_previewText = (body)=>{
    if (!body) return '';
    return body.replace(/```[\s\S]*?```/g, '') // fenced code
    .replace(/`([^`]+)`/g, '$1') // inline code
    .replace(/!\[[^\]]*\]\([^)]*\)/g, '') // images
    .replace(/\[([^\]]+)\]\([^)]*\)/g, '$1') // links → text
    .replace(/^#{1,6}\s+/gm, '') // headings
    .replace(/[*_~]{1,3}([^*_~]+)[*_~]{1,3}/g, '$1') // emphasis
    .replace(/^\s*[-*+]\s+/gm, '') // bullets
    .replace(/<[^>]+>/g, '') // html tags
    .replace(/\r?\n+/g, ' ') // collapse newlines
    .replace(/\s+/g, ' ').trim();
};
const $1fa208c48043782b$export$ea1becc3bb67a61c = {
    flow: 'y',
    gap: 'Y',
    padding: 'Z A',
    // Browser-native viewport culling — `auto` skips rendering off-screen
    // cards, `contain-intrinsic-size` reserves a slot so layout + scrollbar
    // remain stable. We give a generous range so the dynamic content
    // (variable label/description sizes) never gets clipped before the
    // browser actually paints.
    contentVisibility: 'auto',
    containIntrinsicSize: 'auto 180px',
    round: 'Z1',
    background: 'overlay',
    borderWidth: 'V',
    borderColor: 'line',
    borderStyle: 'solid',
    cursor: 'pointer',
    position: 'relative',
    boxShadow: '0 1px 2px var(--color-shadow)',
    ':hover': {
        borderColor: 'overlayStrong',
        transform: 'translateY(-1px)',
        boxShadow: '0 3px 12px var(--color-shadow)'
    },
    ':active': {
        transform: 'translateY(0)'
    },
    transition: 'transform 120ms ease, box-shadow 120ms ease, border-color 120ms ease',
    draggable: 'true',
    'data-ticket-id': (el, s)=>s.id,
    onDragstart: (e, el, s)=>{
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text/ticket-id', String(s.id));
        el.state.root.update({
            activeDrag: {
                id: s.id
            }
        });
    },
    onDragend: (e, el, s)=>{
        el.state.root.update({
            activeDrag: null
        });
    },
    onClick: (e, el, s)=>{
        el.state.root.update({
            selectedTicket: {
                ...s
            }
        });
    },
    // Top tag row — issue type, epic, state. Compact pills with subtle
    // tinted backgrounds (10% opacity of the tag colour) instead of raw
    // borders, giving a softer, more modern look.
    TagRow: {
        display: (el, s)=>s.issueType || s.epicName || s.state ? 'flex' : 'none',
        flow: 'x',
        align: 'center left',
        gap: 'Y',
        flexWrap: 'wrap',
        IssueType: {
            display: (el, s)=>s.issueType ? 'inline-flex' : 'none',
            tag: 'span',
            align: 'center center',
            padding: 'V Z',
            round: 'C',
            fontSize: 'V',
            fontWeight: '700',
            letterSpacing: '.06em',
            color: (el, s)=>(0, $7MNpT.ISSUE_TYPE_COLOR)[s.issueType] || 'caption',
            background: (el, s)=>`color-mix(in srgb, var(--color-${(0, $7MNpT.ISSUE_TYPE_COLOR)[s.issueType] || 'caption'}) 14%, transparent)`,
            text: (el, s)=>(s.issueType || '').toUpperCase()
        },
        Epic: {
            display: (el, s)=>s.epicName ? 'inline-flex' : 'none',
            tag: 'span',
            align: 'center center',
            gap: 'V',
            padding: 'V Z',
            round: 'C',
            fontSize: 'V',
            fontWeight: '600',
            letterSpacing: '.04em',
            color: 'magenta',
            background: 'color-mix(in srgb, var(--color-magenta) 14%, transparent)',
            EpicLabel: {
                tag: 'span',
                fontWeight: '700',
                text: 'EPIC'
            },
            Sep: {
                tag: 'span',
                opacity: '.5',
                text: "\xb7"
            },
            Name: {
                tag: 'span',
                text: (el, s)=>(el.parent.parent.state.epicName || '').toUpperCase()
            }
        },
        State: {
            display: (el, s)=>s.state ? 'inline-flex' : 'none',
            tag: 'span',
            align: 'center center',
            gap: 'V',
            padding: 'V Z',
            round: 'C',
            fontSize: 'V',
            fontWeight: '700',
            letterSpacing: '.06em',
            color: (el, s)=>(0, $7MNpT.TICKET_STATE_COLOR)[s.state] || (0, $7MNpT.STATE_COLOR)[s.state] || 'caption',
            background: (el, s)=>`color-mix(in srgb, var(--color-${(0, $7MNpT.TICKET_STATE_COLOR)[s.state] || (0, $7MNpT.STATE_COLOR)[s.state] || 'caption'}) 14%, transparent)`,
            Dot: {
                width: 'V',
                height: 'V',
                round: '50%',
                background: 'currentColor'
            },
            Text: {
                tag: 'span',
                text: (el, s)=>(0, $7MNpT.formatStateLabel)(el.parent.parent.state.state)
            }
        },
        PriorityDot: {
            display: (el, s)=>s.priority ? 'inline-flex' : 'none',
            title: (el, s)=>`Priority: ${s.priority || ''}`,
            width: 'Z',
            height: 'Z',
            round: '50%',
            marginLeft: 'auto',
            alignSelf: 'center',
            background: (el, s)=>(0, $7MNpT.PRIORITY_COLOR)[s.priority] || 'caption',
            boxShadow: (el, s)=>`0 0 8px color-mix(in srgb, var(--color-${(0, $7MNpT.PRIORITY_COLOR)[s.priority] || 'caption'}) 40%, transparent)`
        }
    },
    // Title — up to 2 lines, ellipsised. Editorial feel with tight
    // letter-spacing and a comfortable line-height. Uses raw `style:` for
    // line-clamp because DOMQL doesn't translate webkit-prefixed props.
    Title: {
        tag: 'h3',
        fontSize: 'Z2',
        fontWeight: '500',
        letterSpacing: '-.01em',
        color: 'title',
        margin: '0',
        lineHeight: '1.35',
        style: {
            display: '-webkit-box',
            overflow: 'hidden',
            '-webkit-line-clamp': '2',
            '-webkit-box-orient': 'vertical'
        },
        text: (el, s)=>s.title || '(no title)'
    },
    // Description preview — markdown stripped, 2 lines max. Hidden when
    // body is empty so the card collapses cleanly.
    Description: {
        display: (el, s)=>$1fa208c48043782b$var$_previewText(s.body) ? '-webkit-box' : 'none',
        tag: 'p',
        margin: '0',
        fontSize: 'Y2',
        lineHeight: '1.5',
        color: 'caption',
        style: {
            overflow: 'hidden',
            '-webkit-line-clamp': '2',
            '-webkit-box-orient': 'vertical'
        },
        text: (el, s)=>$1fa208c48043782b$var$_previewText(s.body)
    },
    // Label chips with overflow indicator. The +N chip clicks through to the
    // detail modal like the rest of the card.
    Labels: {
        display: (el, s)=>(s.labels || []).length ? 'flex' : 'none',
        flow: 'x',
        flexWrap: 'wrap',
        gap: 'Y',
        childExtends: 'TicketsLabelChip',
        childrenAs: 'state',
        children: (el, s)=>{
            const labels = el.parent.state.labels || [];
            const visible = labels.slice(0, $1fa208c48043782b$var$MAX_VISIBLE_LABELS).map((label)=>({
                    label: label,
                    more: 0
                }));
            const remaining = labels.length - $1fa208c48043782b$var$MAX_VISIBLE_LABELS;
            if (remaining > 0) visible.push({
                label: `+${remaining}`,
                more: remaining
            });
            return visible;
        }
    },
    // Field chips — story points, severity, environment, review status,
    // size, estimate. Each one only renders if the value is set, so cards
    // collapse cleanly when fields are empty.
    Fields: {
        display: (el, s)=>s.storyPoints || s.severity || s.environment || s.reviewStatus || s.size || s.estimate ? 'flex' : 'none',
        flow: 'x',
        flexWrap: 'wrap',
        gap: 'Y',
        StoryPoints: {
            display: (el, s)=>s.storyPoints != null ? 'inline-flex' : 'none',
            tag: 'span',
            align: 'center center',
            padding: 'V Z',
            round: 'C',
            fontSize: 'V',
            fontWeight: '700',
            color: 'cyan',
            background: 'color-mix(in srgb, var(--color-cyan) 14%, transparent)',
            text: (el, s)=>`${s.storyPoints} SP`
        },
        Estimate: {
            display: (el, s)=>s.estimate != null && s.storyPoints == null ? 'inline-flex' : 'none',
            tag: 'span',
            align: 'center center',
            padding: 'V Z',
            round: 'C',
            fontSize: 'V',
            fontWeight: '600',
            color: 'cyan',
            background: 'color-mix(in srgb, var(--color-cyan) 14%, transparent)',
            text: (el, s)=>`~${s.estimate}h`
        },
        Size: {
            display: (el, s)=>s.size ? 'inline-flex' : 'none',
            tag: 'span',
            align: 'center center',
            padding: 'V Z',
            round: 'C',
            fontSize: 'V',
            fontWeight: '600',
            color: 'subtitle',
            background: 'overlay',
            text: (el, s)=>`Size ${s.size}`
        },
        Severity: {
            display: (el, s)=>s.severity ? 'inline-flex' : 'none',
            tag: 'span',
            align: 'center center',
            padding: 'V Z',
            round: 'C',
            fontSize: 'V',
            fontWeight: '700',
            letterSpacing: '.04em',
            color: 'red',
            background: 'color-mix(in srgb, var(--color-red) 14%, transparent)',
            text: (el, s)=>(s.severity || '').toUpperCase()
        },
        Environment: {
            display: (el, s)=>s.environment ? 'inline-flex' : 'none',
            align: 'center center',
            gap: 'V',
            padding: 'V Z',
            round: 'C',
            fontSize: 'V',
            fontWeight: '500',
            color: 'subtitle',
            background: 'overlay',
            Icon: {
                icon: 'globe',
                boxSize: 'V'
            },
            Text: {
                tag: 'span',
                text: (el, s)=>el.parent.parent.state.environment || ''
            }
        },
        ReviewStatus: {
            display: (el, s)=>s.reviewStatus ? 'inline-flex' : 'none',
            tag: 'span',
            align: 'center center',
            padding: 'V Z',
            round: 'C',
            fontSize: 'V',
            fontWeight: '600',
            color: 'yellow',
            background: 'color-mix(in srgb, var(--color-yellow) 14%, transparent)',
            text: (el, s)=>`Review \xb7 ${s.reviewStatus}`
        }
    },
    // Iteration + milestone + sub-issue progress + due date + parent +
    // tracked-by — the secondary metadata row. Hidden entirely when none
    // of these are populated.
    MetaRow: {
        display: (el, s)=>s.iterationTitle || s.milestone || s.subIssuesTotal > 0 || s.dueDate || s.parentIssueUrl || s.trackedByCount > 0 ? 'flex' : 'none',
        flow: 'x',
        flexWrap: 'wrap',
        gap: 'Z',
        fontSize: 'Y2',
        color: 'caption',
        Iteration: {
            display: (el, s)=>s.iterationTitle ? 'inline-flex' : 'none',
            align: 'center left',
            gap: 'V',
            Icon: {
                icon: 'clock',
                boxSize: 'Z'
            },
            Text: {
                tag: 'span',
                text: (el, s)=>el.parent.parent.state.iterationTitle || ''
            }
        },
        Milestone: {
            display: (el, s)=>s.milestone ? 'inline-flex' : 'none',
            align: 'center left',
            gap: 'V',
            Icon: {
                icon: 'target',
                boxSize: 'Z'
            },
            Text: {
                tag: 'span',
                text: (el, s)=>el.parent.parent.state.milestone || ''
            }
        },
        DueDate: {
            display: (el, s)=>s.dueDate ? 'inline-flex' : 'none',
            align: 'center left',
            gap: 'V',
            Icon: {
                icon: 'clockOutline',
                boxSize: 'Z'
            },
            Text: {
                tag: 'span',
                text: (el, s)=>el.parent.parent.state.dueDate || ''
            }
        },
        Parent: {
            display: (el, s)=>s.parentIssueUrl ? 'inline-flex' : 'none',
            align: 'center left',
            gap: 'V',
            title: (el, s)=>`Parent: ${s.parentIssueUrl}`,
            Icon: {
                icon: 'arrowAngleUp',
                boxSize: 'Z'
            },
            Text: {
                tag: 'span',
                text: 'parent'
            }
        },
        SubIssues: {
            display: (el, s)=>s.subIssuesTotal > 0 ? 'inline-flex' : 'none',
            align: 'center left',
            gap: 'V',
            Icon: {
                icon: 'checkCircle',
                boxSize: 'Z'
            },
            Text: {
                tag: 'span',
                text: (el, s)=>`${el.parent.parent.parent.state.subIssuesCompleted || 0}/${el.parent.parent.parent.state.subIssuesTotal}`
            }
        },
        TrackedBy: {
            display: (el, s)=>s.trackedByCount > 0 ? 'inline-flex' : 'none',
            align: 'center left',
            gap: 'V',
            Icon: {
                icon: 'bookmark',
                boxSize: 'Z'
            },
            Text: {
                tag: 'span',
                text: (el, s)=>`${el.parent.parent.state.trackedByCount}`
            }
        }
    },
    // Footer — divider then repo line + assignee + GH link. Sticks to the
    // bottom regardless of card content above.
    Footer: {
        flow: 'x',
        align: 'center space-between',
        gap: 'Z',
        marginTop: 'auto',
        paddingTop: 'Z',
        RepoLine: {
            flow: 'x',
            align: 'center left',
            gap: 'Y',
            flex: '1',
            minWidth: '0',
            fontSize: 'V',
            color: 'caption',
            opacity: '.7',
            Repo: {
                display: (el, s)=>s.repository ? 'inline' : 'none',
                tag: 'span',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                text: (el, s)=>s.repository || ''
            },
            Number: {
                display: (el, s)=>s.number ? 'inline' : 'none',
                tag: 'span',
                color: 'subtitle',
                text: (el, s)=>s.number ? `#${s.number}` : ''
            }
        },
        // Avatar stack — up to MAX_VISIBLE_ASSIGNEES avatars overlapped left
        // → right, plus a "+N" pill if more remain. Falls back to GitHub
        // login when the email isn't on file (most external contributors
        // hide their email).
        Assignees: {
            display: (el, s)=>{
                const root = el.state?.root;
                if (!root) return 'none';
                return (0, $7MNpT.resolveAssignees)(s, root.people || []).length > 0 ? 'flex' : 'none';
            },
            flow: 'x',
            align: 'center left',
            childExtends: 'TicketsAssigneeAvatar',
            childrenAs: 'state',
            children: (el, s)=>{
                const ticket = el.parent?.parent?.state;
                const root = el.state?.root;
                if (!root || !ticket) return [];
                const all = (0, $7MNpT.resolveAssignees)(ticket, root.people || []);
                const visible = all.slice(0, $1fa208c48043782b$var$MAX_VISIBLE_ASSIGNEES).map((a, i)=>({
                        ...a,
                        _i: i,
                        _more: 0
                    }));
                const remaining = all.length - $1fa208c48043782b$var$MAX_VISIBLE_ASSIGNEES;
                if (remaining > 0) visible.push({
                    key: '_more',
                    name: `+${remaining} more`,
                    _i: visible.length,
                    _more: remaining
                });
                return visible;
            }
        },
        Github: {
            display: (el, s)=>s.githubUrl ? 'inline-flex' : 'none',
            extends: 'Link',
            href: (el, s)=>s.githubUrl,
            target: '_blank',
            rel: 'noopener',
            onClick: (e)=>e.stopPropagation(),
            align: 'center center',
            color: 'caption',
            opacity: '.6',
            ':hover': {
                color: 'title',
                opacity: '1'
            },
            Icon: {
                icon: 'github',
                boxSize: 'Z2'
            }
        }
    }
};
const $1fa208c48043782b$export$f68773e89e3ca316 = {
    position: 'relative',
    width: 'B',
    height: 'B',
    marginLeft: (el, s)=>s._i > 0 ? '-Y' : '0',
    zIndex: (el, s)=>10 - (s._i || 0),
    Img: {
        display: (el, s)=>s._more ? 'none' : 'flex',
        tag: 'img',
        title: (el, s)=>s.name || '',
        width: '100%',
        height: '100%',
        round: '50%',
        background: 'line',
        borderWidth: 'V',
        borderColor: 'document',
        borderStyle: 'solid',
        boxShadow: '0 1px 3px var(--color-shadow)',
        src: (el, s)=>s.avatar,
        alt: (el, s)=>s.name || ''
    },
    Badge: {
        display: (el, s)=>s._more ? 'flex' : 'none',
        align: 'center center',
        width: '100%',
        height: '100%',
        round: '50%',
        fontSize: 'V',
        fontWeight: '700',
        color: 'subtitle',
        background: 'line',
        borderWidth: 'V',
        borderColor: 'document',
        borderStyle: 'solid',
        title: (el, s)=>s.name || '',
        text: (el, s)=>`+${s._more || 0}`
    }
};
const $1fa208c48043782b$export$7f09028533cf18cd = {
    tag: 'span',
    padding: 'V Z',
    round: 'C',
    fontSize: 'V',
    fontWeight: (el, s)=>s.more ? '700' : '500',
    letterSpacing: '.02em',
    color: (el, s)=>s.more ? 'caption' : 'subtitle',
    background: 'overlay',
    borderWidth: '1px',
    borderColor: 'line',
    borderStyle: 'solid',
    text: (el, s)=>s.label
};

});

parcelRegister("lFIvM", function(module, exports) {

$parcel$export(module.exports, "TicketsDetailModal", () => $fc6ff45cb7441317$export$a1cac5cabad89002);
$parcel$export(module.exports, "TicketMentionModal", () => $fc6ff45cb7441317$export$b52d0c837d0ecf61);
$parcel$export(module.exports, "TicketsDetailField", () => $fc6ff45cb7441317$export$154e819e1412a55);
$parcel$export(module.exports, "TicketsDetailAssignee", () => $fc6ff45cb7441317$export$e7805e4e42226a28);
$parcel$export(module.exports, "TicketCommentRow", () => $fc6ff45cb7441317$export$5b24ab0b199ad5a3);
$parcel$export(module.exports, "TicketDependenciesPanel", () => $fc6ff45cb7441317$export$a30217802e1895a9);
$parcel$export(module.exports, "TicketDependencyRow", () => $fc6ff45cb7441317$export$625eba299d225744);
$parcel$export(module.exports, "TicketDependencyMainRow", () => $fc6ff45cb7441317$export$1ad85cd16d3a0f65);

var $7MNpT = parcelRequire("7MNpT");

var $bfqVY = parcelRequire("bfqVY");

var $8f98e = parcelRequire("8f98e");
// Ticket surfaces use demoteHeadings:true — page chrome owns h1/h2/h3.
const $fc6ff45cb7441317$var$renderMarkdown = (el, body, emptyNode, people)=>(0, $8f98e.applyMarkdownToElement)(el, body, emptyNode, {
        demoteHeadings: true,
        people: people
    });
// Fetch ticket_dependencies for one ticket + resolve both sides into
// thin display rows. Returns { outgoing, incoming } where:
//   outgoing = what THIS ticket depends on (blocked_by / waits_on_ship / blocks=out / related)
//   incoming = what depends on THIS ticket (other side of the edge)
const $fc6ff45cb7441317$var$_fetchTicketDeps = async (ticketId)=>{
    if (!ticketId) return {
        outgoing: [],
        incoming: []
    };
    try {
        // SDK route returns either:
        //   1. Pre-shaped { outgoing, incoming } (preferred — server resolves both sides)
        //   2. A flat list of dependency rows that we shape locally (legacy fallback)
        const sdk = (0, $bfqVY.getSDK)();
        const result = await sdk.execute('workspaceProject.ticketDependencies', 'list', {
            ticketId: ticketId
        });
        if (result && Array.isArray(result.outgoing) && Array.isArray(result.incoming)) return {
            outgoing: result.outgoing,
            incoming: result.incoming
        };
        // Fallback: server returned the raw rows; resolve other-side ticket details
        // via the tickets list route.
        const rows = Array.isArray(result) ? result : result?.rows || result?.data || [];
        const outRows = rows.filter((r)=>String(r.ticket_id) === String(ticketId));
        const inRows = rows.filter((r)=>String(r.depends_on_ticket_id) === String(ticketId));
        const ids = new Set();
        for (const r of outRows)if (r.depends_on_ticket_id) ids.add(r.depends_on_ticket_id);
        for (const r of inRows)if (r.ticket_id) ids.add(r.ticket_id);
        if (!ids.size) return {
            outgoing: [],
            incoming: []
        };
        const tickets = await sdk.execute('workspaceProject.tickets', 'list', {
            filter: {
                id_in: Array.from(ids)
            },
            limit: 200
        });
        const ticketRows = Array.isArray(tickets) ? tickets : tickets?.rows || tickets?.data || [];
        const byId = new Map();
        for (const t of ticketRows)byId.set(t.id, t);
        const shape = (row, side)=>{
            const otherId = side === 'out' ? row.depends_on_ticket_id : row.ticket_id;
            const t = byId.get(otherId);
            return t ? {
                id: t.id,
                external_id: t.external_id,
                type: t.type,
                title: t.title,
                state: t.state,
                priority: t.priority,
                assignee_email: t.assignee_email,
                kind: row.kind
            } : null;
        };
        return {
            outgoing: outRows.map((r)=>shape(r, 'out')).filter(Boolean),
            incoming: inRows.map((r)=>shape(r, 'in')).filter(Boolean)
        };
    } catch (err) {
        console.error('[fetchTicketDeps]', err);
        return {
            outgoing: [],
            incoming: []
        };
    }
};
// Guard: track IDs currently being hydrated to prevent reactive loops.
const $fc6ff45cb7441317$var$_hydrating = new Set();
// Hydrate a selectedTicket that is missing body (opened from a list that used a
// partial select). Merges the full row into the existing selectedTicket so
// already-visible metadata (title, state, priority) stays on screen while the
// fetch is in-flight. Does NOT clobber with an optimistic stub.
const $fc6ff45cb7441317$var$_hydrateBody = async (root, id)=>{
    if (!root || !id) return;
    try {
        const result = await (0, $bfqVY.getSDK)().execute('workspaceProject.tickets', 'get', {
            id: id
        });
        const t = result?.data || result?.row || result;
        if (!t || !t.id) return;
        root.update({
            selectedTicket: {
                ...root.selectedTicket,
                ...t,
                columnKey: t.column_key,
                issueType: t.issue_type,
                epicName: t.epic_name,
                assigneeEmail: t.assignee_email,
                reporterEmail: t.reporter_email,
                updatedAt: t.updated_at,
                createdAt: t.created_at
            }
        });
    } catch (_) {} finally{
        $fc6ff45cb7441317$var$_hydrating.delete(id);
    }
};
// Propagate root state update to child elements with imperative onUpdate hooks.
// v3.14 storeUpdate only fires onUpdate on the element attached to the store root;
// DependenciesSection and the sidebar Dependencies panel are not auto-notified
// when selectedTicket changes via a setInterval or async path (#4620).
const $fc6ff45cb7441317$var$_propagateDepsUpdate = (modalEl)=>{
    const depSection = modalEl?.Window?.ViewContent?.Content?.Main?.DependenciesSection;
    if (depSection && typeof depSection.update === 'function') depSection.update({});
    const sidebarDeps = modalEl?.Window?.ViewContent?.Content?.Sidebar?.Dependencies;
    if (sidebarDeps && typeof sidebarDeps.update === 'function') sidebarDeps.update({});
};
// Walk up the parent chain to find the TicketsDetailModal element from any
// descendant (e.g. a TicketDependencyRow click handler). Returns null if the
// element's root does not have a modal in the expected position.
const $fc6ff45cb7441317$var$_findModalFromEl = (el)=>{
    try {
        // Try via root element (fastest path when modal is rooted at app root)
        const rootEl = el.getRoot?.();
        if (rootEl?.TicketsDetailModal) return rootEl.TicketsDetailModal;
        // Fallback: walk __parent chain looking for the modal key
        let cur = el.__parent;
        while(cur){
            if (cur.__name === 'TicketsDetailModal' || cur.key === 'TicketsDetailModal') return cur;
            cur = cur.__parent;
        }
    } catch (_) {}
    return null;
};
const $fc6ff45cb7441317$var$_openTicketInModal = async (root, id, modalEl)=>{
    if (!root || !id) return;
    // Optimistic stub so modal swaps immediately; the select=* fetch fills
    // the rest.
    root.update({
        selectedTicket: {
            id: id
        }
    });
    // v3.14 gap: propagate to child onUpdate hooks (#4620).
    if (modalEl) setTimeout(()=>$fc6ff45cb7441317$var$_propagateDepsUpdate(modalEl), 0);
    // Snapshot the intent so we can guard against close-mid-flight:
    // if the user closes the modal while the fetch is in-flight,
    // root.selectedTicket becomes null. After the await we must not
    // re-open the modal by overwriting null with the stale hydrated row.
    const openedId = id;
    try {
        const result = await (0, $bfqVY.getSDK)().execute('workspaceProject.tickets', 'get', {
            id: id
        });
        const t = result?.data || result?.row || result;
        if (!t || !t.id) return;
        // Close-mid-flight guard: abort if user closed the modal during fetch.
        if (!root.selectedTicket || String(root.selectedTicket.id) !== String(openedId)) return;
        root.update({
            selectedTicket: {
                ...t,
                columnKey: t.column_key,
                issueType: t.issue_type,
                epicName: t.epic_name,
                assigneeEmail: t.assignee_email,
                reporterEmail: t.reporter_email,
                updatedAt: t.updated_at,
                createdAt: t.created_at
            }
        });
        // After full hydration, propagate again so dep-fetch sees the real id.
        if (modalEl) setTimeout(()=>$fc6ff45cb7441317$var$_propagateDepsUpdate(modalEl), 0);
    } catch (_) {}
};
// Credit metering for ticket-ai operations now happens server-side
// inside the ai-chat / ticket-ai edge functions — see
// server/packages/credit-meter. This stub keeps the call sites
// (refId/prompt/response capture for telemetry) intact for now.
const $fc6ff45cb7441317$var$_burnTicketAi = (_root, _payload)=>{};
// --- mode helpers ---
const $fc6ff45cb7441317$var$_isNew = (root)=>root?.selectedTicket?._new === true;
const $fc6ff45cb7441317$var$_isEditing = (root)=>root?.ticketEditMode === true || $fc6ff45cb7441317$var$_isNew(root);
// The real ticket object (null when creating new)
const $fc6ff45cb7441317$var$_ticket = (root)=>{
    if ($fc6ff45cb7441317$var$_isNew(root)) return null;
    const t = root?.selectedTicket;
    if (!t) return null;
    // Normalize snake_case API fields to camelCase if needed
    if (t.column_key !== undefined && t.columnKey === undefined) {
        t.columnKey = t.column_key;
        t.issueType = t.issue_type;
        t.epicName = t.epic_name;
        t.assigneeEmail = t.assignee_email;
        t.reporterEmail = t.reporter_email;
        t.updatedAt = t.updated_at;
        t.createdAt = t.created_at;
    }
    return t;
};
const $fc6ff45cb7441317$var$_draft = (root)=>root?.ticketDraft || {};
// ── URL sync: ?ticket=<id> ──
// Set to true while _close() is executing so that the display reactive prop
// (which fires synchronously inside root.update via v3.14 flushEffects) cannot
// re-write ?ticket=N after _clearTicketUrl already stripped it.
let $fc6ff45cb7441317$var$_suppressPush = false;
const $fc6ff45cb7441317$var$_pushTicketUrl = (id)=>{
    if (!id || typeof window === 'undefined') return;
    // Guard 1: closing in progress — _clearTicketUrl already ran; do not
    // re-write the URL with the stale selectedTicket value that flushEffects
    // may still see before the null update propagates.
    if ($fc6ff45cb7441317$var$_suppressPush) return;
    // Guard 2: idempotent — URL already carries the exact target ticket;
    // skip replaceState to avoid spurious history entries on re-renders.
    if (new URL(window.location).searchParams.get('ticket') === String(id)) return;
    const url = new URL(window.location);
    url.searchParams.set('ticket', id);
    window.history.replaceState(null, '', url);
};
const $fc6ff45cb7441317$var$_clearTicketUrl = ()=>{
    if (typeof window === 'undefined') return;
    const url = new URL(window.location);
    if (url.searchParams.has('ticket')) {
        url.searchParams.delete('ticket');
        window.history.replaceState(null, '', url);
    }
};
const $fc6ff45cb7441317$var$_getTicketIdFromUrl = ()=>{
    if (typeof window === 'undefined') return null;
    return new URL(window.location).searchParams.get('ticket');
};
const $fc6ff45cb7441317$var$_close = (root)=>{
    $fc6ff45cb7441317$var$_suppressPush = true;
    $fc6ff45cb7441317$var$_clearTicketUrl();
    root.update({
        selectedTicket: null,
        ticketDraft: null,
        ticketEditMode: false
    });
    // Release the push-suppress after the synchronous flushEffects cycle
    // completes inside root.update. Any re-open after this point must push.
    Promise.resolve().then(()=>{
        $fc6ff45cb7441317$var$_suppressPush = false;
    });
};
const $fc6ff45cb7441317$var$_cancelEdit = (root)=>{
    if ($fc6ff45cb7441317$var$_isNew(root)) $fc6ff45cb7441317$var$_close(root);
    else root.update({
        ticketEditMode: false,
        ticketDraft: null
    });
};
// Fields relevant per issue type. Unlisted fields always show in view mode;
// in edit mode only the fields for the selected type appear.
const $fc6ff45cb7441317$var$_TYPE_FIELDS = {
    bug: [
        'priority',
        'assignee',
        'column',
        'labels',
        'reporter',
        'dueDate'
    ],
    feature: [
        'priority',
        'assignee',
        'column',
        'labels',
        'reporter',
        'dueDate',
        'acceptance',
        'storyPoints'
    ],
    'user-story': [
        'priority',
        'assignee',
        'column',
        'labels',
        'dueDate',
        'acceptance',
        'storyPoints'
    ],
    subtask: [
        'assignee',
        'column',
        'storyPoints'
    ],
    marketplace: [
        'assignee',
        'labels',
        'acceptance'
    ]
};
const $fc6ff45cb7441317$var$_showField = (root, field)=>{
    if (!$fc6ff45cb7441317$var$_isEditing(root)) return true // view mode: show if value present
    ;
    const type = $fc6ff45cb7441317$var$_draft(root).issueType || '';
    if (!type) return true // no type selected: show all
    ;
    const fields = $fc6ff45cb7441317$var$_TYPE_FIELDS[type];
    return fields ? fields.includes(field) : true;
};
// AI prompt → update ticket draft via SDK ai-chat route.
const $fc6ff45cb7441317$var$_aiUpdateTicket = async (root, prompt, el)=>{
    const draft = $fc6ff45cb7441317$var$_draft(root);
    root.update({
        _aiTicketLoading: true
    });
    const systemPrompt = `You update ticket fields based on the user prompt. Return ONLY a valid JSON object with the fields to update. Valid fields: title, body, priority (low/medium/high/urgent/critical), issueType (bug/feature/user-story/subtask/marketplace), acceptanceCriteria, stepsToReproduce, expectedResult, storyPoints (string 0-13), dueDate (YYYY-MM-DD), columnKey, assigneeEmail. Only include fields you want to change. Do NOT include unchanged fields.`;
    const userMsg = `Current ticket draft:\n${JSON.stringify(draft, null, 2)}\n\nUser prompt: ${prompt}`;
    // Hoisted so the trailing _burnTicketAi() call can read it after the try.
    let full = '';
    try {
        // SDK route forwards to /workspace/ai/chat which returns parsed JSON
        // (non-streaming). Pull the text from common shapes — { text }, { content },
        // { message }, or a plain string — and feed it into the same JSON-extract
        // path we used for the SSE stream.
        const result = await (el?.sdk || (0, $bfqVY.getSDK)()).execute('workspaceProject.aiChat', 'rpc', {
            payload: {
                messages: [
                    {
                        role: 'system',
                        content: systemPrompt
                    },
                    {
                        role: 'user',
                        content: userMsg
                    }
                ]
            }
        });
        if (typeof result === 'string') full = result;
        else if (result?.text) full = result.text;
        else if (result?.content) full = String(result.content);
        else if (result?.message) full = typeof result.message === 'string' ? result.message : result.message.content || '';
        else if (result?.data?.text) full = result.data.text;
        else if (result?.data) full = typeof result.data === 'string' ? result.data : JSON.stringify(result.data);
        // Parse JSON from AI response (balance braces to handle trailing text)
        const jsonMatch = full.match(/\{[\s\S]*\}/);
        if (jsonMatch) {
            let parsed = null;
            try {
                parsed = JSON.parse(jsonMatch[0]);
            } catch  {
                let depth = 0, end = 0;
                for(let i = 0; i < jsonMatch[0].length; i++){
                    if (jsonMatch[0][i] === '{') depth++;
                    if (jsonMatch[0][i] === '}') {
                        depth--;
                        if (depth === 0) {
                            end = i + 1;
                            break;
                        }
                    }
                }
                try {
                    parsed = JSON.parse(jsonMatch[0].slice(0, end));
                } catch  {}
            }
            if (parsed) {
                $fc6ff45cb7441317$var$_patchDraft(root, parsed);
                console.log('[_aiUpdateTicket] applied:', Object.keys(parsed));
            }
        } else console.warn('[_aiUpdateTicket] no JSON in response:', full.slice(0, 200));
    } catch (err) {
        console.error('[_aiUpdateTicket]', err);
    }
    $fc6ff45cb7441317$var$_burnTicketAi(root, {
        refId: `ticket-update:${root?.selectedTicket?.id || 'new'}:${Date.now()}`,
        prompt: userMsg,
        response: full
    });
    root.update({
        _aiTicketLoading: false
    });
};
const $fc6ff45cb7441317$var$_patchDraft = (root, patch)=>root.update({
        ticketDraft: {
            ...$fc6ff45cb7441317$var$_draft(root),
            ...patch
        }
    });
// Factory: rich-text editor field replicating the comment ComposerRow pattern.
// Shows contenteditable with WysiwygToolbar on focus, saves to draft on blur.
const $fc6ff45cb7441317$var$_richField = (title, draftKey, placeholder, minH, showFn)=>({
        display: (el, s)=>showFn(s) ? 'flex' : 'none',
        flow: 'y',
        gap: 'Z',
        CaptionTitle: {
            Text: {
                text: title
            }
        },
        EditorRow: {
            display: (el, s)=>$fc6ff45cb7441317$var$_isEditing(s.root) ? 'flex' : 'none',
            flow: 'y',
            gap: '0',
            round: 'A',
            overflow: 'hidden',
            theme: 'field',
            Editor: {
                tag: 'div',
                contenteditable: 'true',
                spellcheck: 'true',
                minHeight: minH,
                maxHeight: 'G',
                width: '100%',
                padding: 'A',
                fontSize: 'Z2',
                lineHeight: '1.5',
                color: 'title',
                background: 'transparent',
                outline: 'none',
                overflow: 'auto',
                wordBreak: 'break-word',
                attr: {
                    'data-rt-editor': draftKey,
                    'data-placeholder': placeholder
                },
                text: (el, s)=>$fc6ff45cb7441317$var$_draft(s.root)[draftKey] || '',
                onCreate: (el)=>{
                    if (!el.node) return;
                    if (!document.querySelector('style[data-rt-ph]')) {
                        const st = document.createElement('style');
                        st.textContent = '[data-rt-editor]:empty::before { content: attr(data-placeholder); color: var(--color-caption); pointer-events: none; }';
                        st.setAttribute('data-rt-ph', '');
                        document.head.appendChild(st);
                    }
                },
                onFocus: (e, el)=>{
                    const tb = el.parent?.BottomBar?.Toolbar?.node;
                    if (tb) tb.style.display = 'flex';
                },
                onBlur: (e, el, s)=>{
                    setTimeout(()=>{
                        if (document.activeElement === el.node) return;
                        const tb = el.parent?.BottomBar?.Toolbar?.node;
                        if (tb) tb.style.display = 'none';
                        $fc6ff45cb7441317$var$_patchDraft(s.root, {
                            [draftKey]: (el.node.innerText || '').trim()
                        });
                    }, 200);
                }
            },
            BottomBar: {
                flow: 'x',
                align: 'center space-between',
                padding: '0 Z Z Z',
                Toolbar: {
                    extends: 'WysiwygToolbar',
                    display: 'none',
                    flex: '1',
                    padding: 'V 0 0 V'
                }
            }
        },
        Body: {
            display: (el, s)=>$fc6ff45cb7441317$var$_isEditing(s.root) ? 'none' : 'block',
            tag: 'div',
            padding: 'A',
            round: 'Z2',
            background: 'white.04',
            borderWidth: '1px',
            borderColor: 'line',
            borderStyle: 'solid',
            fontSize: 'Z2',
            lineHeight: '1.6',
            wordBreak: 'break-word',
            // Reactive text prop drives two distinct states:
            //   1. "Loading…" — only when selectedTicket.body is undefined, meaning the
            //      partial-select fetch is still in-flight (_hydrateBody not yet done).
            //   2. renderMarkdown path — once body is defined, treat draftKey as '' when
            //      the column doesn't exist in the DB (e.g. acceptanceCriteria is not a
            //      real column — undefined means empty, not loading).
            //
            // IMPORTANT (v3.14): after renderMarkdown calls el.set() to mount child nodes,
            // we return null (not ''). In v3.14 the text effect only writes textContent when
            // val != null; returning '' would write an empty string and wipe the children
            // that el.set() just mounted. null skips the write and leaves children intact.
            color: (el, s)=>{
                const t = s.root.selectedTicket;
                return !t || draftKey === 'body' && t.body === undefined ? 'caption' : 'subtitle';
            },
            text: (el, s)=>{
                const t = s.root.selectedTicket;
                // Ticket not yet loaded at all — show Loading…
                if (!t) {
                    el._lastMd = undefined;
                    return "Loading\u2026";
                }
                // body column is undefined → hydration still in-flight (partial list fetch)
                if (draftKey === 'body' && t.body === undefined) {
                    el._lastMd = undefined;
                    return "Loading\u2026";
                }
                // For structured fields that have no DB column (e.g. acceptanceCriteria),
                // t[draftKey] is undefined after hydration — treat as empty string.
                const val = t[draftKey] !== undefined ? t[draftKey] : '';
                // Only clear the stale "Loading…" text node when the markdown content has
                // actually changed.  Unconditional clearing caused a race: textContent was
                // wiped to '' and then renderMarkdown returned early (el._lastMd === body)
                // leaving the description visually empty (TASK#4477 / QA fail #2).
                // Guard: clear only when renderMarkdown will actually re-render (new value).
                if (el.node && el._lastMd !== (val || '')) el.node.textContent = '';
                $fc6ff45cb7441317$var$renderMarkdown(el, val || '', {
                    tag: 'span',
                    text: ''
                }, s.root.people);
                // Return null so v3.14 does NOT overwrite textContent and wipe el.set() children.
                return null;
            }
        }
    });
// Multi-assignee helpers — stores comma-separated emails in assigneeEmail
const $fc6ff45cb7441317$var$_draftAssignees = (root)=>{
    const raw = $fc6ff45cb7441317$var$_draft(root).assigneeEmail || '';
    return raw.split(',').map((e)=>e.trim()).filter(Boolean);
};
const $fc6ff45cb7441317$var$_ticketAssigneeEmails = (root)=>{
    const t = root?.selectedTicket;
    if (!t) return [];
    const raw = t.assigneeEmail || '';
    return raw.split(',').map((e)=>e.trim()).filter(Boolean);
};
const $fc6ff45cb7441317$var$_addAssignee = (root, email)=>{
    const cur = $fc6ff45cb7441317$var$_draftAssignees(root);
    if (cur.includes(email)) return;
    $fc6ff45cb7441317$var$_patchDraft(root, {
        assigneeEmail: [
            ...cur,
            email
        ].join(', ')
    });
    root.update({
        _assigneeQuery: ''
    });
};
const $fc6ff45cb7441317$var$_popAssignee = (root)=>{
    const cur = $fc6ff45cb7441317$var$_draftAssignees(root);
    if (!cur.length) return;
    cur.pop();
    $fc6ff45cb7441317$var$_patchDraft(root, {
        assigneeEmail: cur.join(', ')
    });
};
// ── Approval helpers ──────────────────────────────────────────────────────────
// Ticket needs a human approval decision when:
//   • state === 'awaiting_approval', OR
//   • labels[] includes 'human-approval-needed'
const $fc6ff45cb7441317$var$_isAwaitingApproval = (root)=>{
    const t = $fc6ff45cb7441317$var$_ticket(root);
    if (!t) return false;
    return t.state === 'awaiting_approval' || Array.isArray(t.labels) && t.labels.includes('human-approval-needed');
};
// Remove a label value from a labels array (returns new array).
const $fc6ff45cb7441317$var$_removeLabel = (labels, value)=>(Array.isArray(labels) ? labels : []).filter((l)=>l !== value);
// Add a label value if not already present (returns new array).
const $fc6ff45cb7441317$var$_addLabel = (labels, value)=>{
    const arr = Array.isArray(labels) ? labels : [];
    return arr.includes(value) ? arr : [
        ...arr,
        value
    ];
};
// Optimistically patch the selectedTicket + myTickets arrays in root state.
const $fc6ff45cb7441317$var$_optimisticTicketPatch = (root, patch)=>{
    const t = $fc6ff45cb7441317$var$_ticket(root);
    if (!t) return;
    const updated = {
        ...root.selectedTicket,
        ...patch
    };
    root.update({
        selectedTicket: updated,
        myTickets: (root.myTickets || []).map((x)=>x.id === t.id ? {
                ...x,
                ...patch
            } : x)
    });
};
// Full approval flow:
//   1. Insert ticket_comment (audit trail — audit first)
//   2. PATCH ticket state + labels + metadata
// Optimistic: button shows spinner immediately; reverts on any error.
const $fc6ff45cb7441317$var$_approveTicket = async (root, note)=>{
    const t = $fc6ff45cb7441317$var$_ticket(root);
    if (!t) return;
    const email = root.currentUserEmail || 'nika.tomadze@gmail.com';
    const body = (note || 'Approved.').trim() || 'Approved.';
    const now = new Date().toISOString();
    // Idempotence guard: disable button while pending
    if (root._approvalPending) return;
    root.update({
        _approvalPending: true
    });
    // Optimistic UI update
    const prevState = {
        state: t.state,
        labels: t.labels,
        metadata: t.metadata
    };
    const newLabels = $fc6ff45cb7441317$var$_addLabel($fc6ff45cb7441317$var$_removeLabel(t.labels, 'human-approval-needed'), 'human-approval-given');
    $fc6ff45cb7441317$var$_optimisticTicketPatch(root, {
        state: 'in_progress',
        labels: newLabels,
        metadata: {
            ...t.metadata || {},
            approvedAt: now,
            approvedBy: email
        }
    });
    // Optimistic comment
    const optimisticComment = {
        ticket_id: t.id,
        author_email: email,
        body: body,
        created_at: now,
        _optimistic: true
    };
    root.update({
        _ticketComments: [
            ...root._ticketComments || [],
            optimisticComment
        ]
    });
    try {
        // Step 1: insert comment (audit trail first) — migrated 2026-04-27 to
        // SDK route workspaceProject.ticketComments.create
        await (0, $bfqVY.getSDK)().execute('workspaceProject.ticketComments', 'create', {
            ticketId: t.id,
            payload: {
                author_email: email,
                body: body,
                created_at: now
            }
        });
        // Step 2: PATCH ticket
        const patchBody = {
            state: 'in_progress',
            labels: newLabels,
            metadata: {
                ...t.metadata || {},
                approvedAt: now,
                approvedBy: email
            },
            updated_at: now
        };
        await (0, $bfqVY.getSDK)().execute('workspaceProject.tickets', 'update', {
            id: t.id,
            payload: patchBody
        });
        // Replace optimistic comment with confirmed one (remove _optimistic flag)
        root.update({
            _ticketComments: (root._ticketComments || []).map((c)=>c === optimisticComment ? {
                    ...c,
                    _optimistic: false
                } : c),
            _approvalPending: false,
            _approvalDoneAt: now,
            _approvalKind: 'approved'
        });
    } catch (err) {
        console.error('[approveTicket]', err);
        // Revert optimistic changes
        $fc6ff45cb7441317$var$_optimisticTicketPatch(root, prevState);
        root.update({
            _ticketComments: (root._ticketComments || []).filter((c)=>c !== optimisticComment),
            _approvalPending: false,
            _approvalError: err?.message || 'Approval failed'
        });
        // Auto-clear error toast after 4 s
        setTimeout(()=>root.update({
                _approvalError: null
            }), 4000);
    }
};
// Reject flow — same structure; state stays in_progress, labels get 'human-approval-rejected'.
const $fc6ff45cb7441317$var$_rejectTicket = async (root, note)=>{
    const t = $fc6ff45cb7441317$var$_ticket(root);
    if (!t) return;
    const email = root.currentUserEmail || 'nika.tomadze@gmail.com';
    const body = (note || 'Needs changes.').trim() || 'Needs changes.';
    const now = new Date().toISOString();
    if (root._approvalPending) return;
    root.update({
        _approvalPending: true
    });
    const prevState = {
        state: t.state,
        labels: t.labels,
        metadata: t.metadata
    };
    const newLabels = $fc6ff45cb7441317$var$_addLabel($fc6ff45cb7441317$var$_removeLabel($fc6ff45cb7441317$var$_removeLabel(t.labels, 'human-approval-needed'), 'human-approval-given'), 'human-approval-rejected');
    $fc6ff45cb7441317$var$_optimisticTicketPatch(root, {
        state: 'in_progress',
        labels: newLabels,
        metadata: {
            ...t.metadata || {},
            rejectedAt: now,
            rejectedBy: email
        }
    });
    const optimisticComment = {
        ticket_id: t.id,
        author_email: email,
        body: body,
        created_at: now,
        _optimistic: true
    };
    root.update({
        _ticketComments: [
            ...root._ticketComments || [],
            optimisticComment
        ]
    });
    try {
        // Step 1: comment first — migrated 2026-04-27 to SDK route
        // workspaceProject.ticketComments.create
        await (0, $bfqVY.getSDK)().execute('workspaceProject.ticketComments', 'create', {
            ticketId: t.id,
            payload: {
                author_email: email,
                body: body,
                created_at: now
            }
        });
        // Step 2: PATCH
        const patchBody = {
            state: 'in_progress',
            labels: newLabels,
            metadata: {
                ...t.metadata || {},
                rejectedAt: now,
                rejectedBy: email
            },
            updated_at: now
        };
        await (0, $bfqVY.getSDK)().execute('workspaceProject.tickets', 'update', {
            id: t.id,
            payload: patchBody
        });
        root.update({
            _ticketComments: (root._ticketComments || []).map((c)=>c === optimisticComment ? {
                    ...c,
                    _optimistic: false
                } : c),
            _approvalPending: false,
            _approvalDoneAt: now,
            _approvalKind: 'rejected'
        });
    } catch (err) {
        console.error('[rejectTicket]', err);
        $fc6ff45cb7441317$var$_optimisticTicketPatch(root, prevState);
        root.update({
            _ticketComments: (root._ticketComments || []).filter((c)=>c !== optimisticComment),
            _approvalPending: false,
            _approvalError: err?.message || 'Rejection failed'
        });
        setTimeout(()=>root.update({
                _approvalError: null
            }), 4000);
    }
};
// --- comment posting (shared by Comment + AI Update modes) ---
const $fc6ff45cb7441317$var$_postComment = async (root, body, el)=>{
    const t = $fc6ff45cb7441317$var$_ticket(root);
    if (!t || !body) return;
    const email = root.currentUserEmail;
    const mode = root._commentTab || 'comment';
    const userName = root._standupUserName || email?.split('@')[0];
    const now = new Date().toISOString();
    if (mode === 'update') {
        // ── Real AI update via Gemini (ai-chat endpoint) ──
        const userComment = {
            ticket_id: t.id,
            author_email: email,
            body: `> ${body}`,
            created_at: now
        };
        const aiPlaceholder = {
            ticket_id: t.id,
            author_email: 'ai@symbols.app',
            body: "\u2726 Thinking...",
            created_at: new Date(Date.now() + 500).toISOString(),
            _name: 'AI'
        };
        const prev = root._ticketComments || [];
        root.update({
            _ticketComments: [
                ...prev,
                {
                    ...userComment,
                    _name: userName
                },
                aiPlaceholder
            ]
        });
        const people = (root.people || []).map((p)=>`${p.name} <${p.email}>`).join(', ');
        const columns = (root.columns || []).map((c)=>`${c.key}="${c.label}"`).join(', ');
        const currentUser = (root.people || []).find((p)=>p.email === email);
        const currentUserName = currentUser?.name || email;
        const prompt = `You are a ticket management AI. Given a ticket and a user instruction, return ONLY a valid JSON object with updates.

CURRENT USER: ${currentUserName} <${email}>

TICKET:
- ID: #${t.number || t.id}
- Title: "${t.title || ''}"
- Description: "${(t.body || '').slice(0, 500)}"
- Status column_key: ${t.columnKey || t.column_key || 'unknown'}
- Priority: ${t.priority || 'none'}
- Assignee: ${t.assigneeEmail || t.assignee_email || 'unassigned'}

AVAILABLE COLUMNS: ${columns}
TEAM MEMBERS: ${people}

USER SAYS: "${body}"

Return ONLY valid JSON with fields to change (omit or set null for unchanged):
{"body":"new description or null","column_key":"column key or null","priority":"low/medium/high/critical or null","assignee_email":"email or null","title":"new title or null","summary":"one line what you did"}

Rules:
- "me" or "myself" = the CURRENT USER (${email})
- "assign to X" = find the matching person's SINGLE email from TEAM MEMBERS. Only ONE assignee allowed \u{2014} pick the first if multiple requested.
- "enhance/improve description" = rewrite the current description to be more detailed and clear
- "mark as done/complete" = set column_key to the Done column
- "move to review" = set column_key to the In Review column
- "add to description: X" = append X to existing description (keep old content)
- Only return fields that actually change. Do NOT return null fields.
- ALWAYS include "summary" field`;
        try {
            // SDK route forwards to /workspace/ai/chat which returns parsed JSON
            // (non-streaming). Normalize the result into `full` so the JSON-extract
            // path below stays unchanged.
            const result = await (el?.sdk || (0, $bfqVY.getSDK)()).execute('workspaceProject.aiChat', 'rpc', {
                payload: {
                    messages: [
                        {
                            role: 'user',
                            content: prompt
                        }
                    ]
                }
            });
            let full = '';
            if (typeof result === 'string') full = result;
            else if (result?.text) full = result.text;
            else if (result?.content) full = String(result.content);
            else if (result?.message) full = typeof result.message === 'string' ? result.message : result.message.content || '';
            else if (result?.data?.text) full = result.data.text;
            else if (result?.data) full = typeof result.data === 'string' ? result.data : JSON.stringify(result.data);
            // Credit burn — inline ticket AI prompt (comments bar). Server
            // ledger is authoritative; this is a heartbeat.
            $fc6ff45cb7441317$var$_burnTicketAi(root, {
                refId: `ticket-ai-comment:${t.id || t.number || 'new'}:${Date.now()}`,
                prompt: prompt,
                response: full
            });
            // Parse JSON from AI
            let ai;
            try {
                const m = full.match(/\{[\s\S]*\}/);
                ai = m ? JSON.parse(m[0]) : null;
            } catch  {
                ai = null;
            }
            if (!ai) {
                const comments = root._ticketComments || [];
                root.update({
                    _ticketComments: comments.map((c)=>c === aiPlaceholder ? {
                            ...c,
                            body: full || 'Could not parse AI response.'
                        } : c)
                });
                return;
            }
            // Apply updates
            const updates = {};
            const actions = [];
            if (ai.body != null) {
                updates.body = ai.body;
                actions.push('Updated description');
            }
            if (ai.title != null) {
                updates.title = ai.title;
                actions.push(`Title \u{2192} "${ai.title}"`);
            }
            if (ai.column_key != null) {
                updates.columnKey = ai.column_key;
                updates.column_key = ai.column_key;
                const col = (root.columns || []).find((c)=>c.key === ai.column_key);
                actions.push(`Moved to ${col?.label || ai.column_key}`);
            }
            if (ai.priority != null) {
                updates.priority = ai.priority;
                actions.push(`Priority \u{2192} ${ai.priority}`);
            }
            if (ai.assignee_email != null) {
                // Only single assignee supported — take first email if comma-separated
                let assignEmail = ai.assignee_email;
                if (assignEmail.includes(',')) assignEmail = assignEmail.split(',')[0].trim();
                updates.assigneeEmail = assignEmail;
                updates.assignee_email = assignEmail;
                const person = (root.people || []).find((p)=>p.email === assignEmail);
                actions.push(`Assigned to ${person?.name || assignEmail}`);
            }
            // Apply to state — include updated timestamp
            updates.updated_at = now;
            updates.updatedAt = now;
            root.update({
                selectedTicket: {
                    ...root.selectedTicket,
                    ...updates
                },
                myTickets: (root.myTickets || []).map((x)=>x.id === t.id ? {
                        ...x,
                        ...updates
                    } : x)
            });
            // Save to Supabase — direct update (reliable)
            {
                const row = {
                    updated_at: now
                };
                if (updates.body !== undefined) row.body = updates.body;
                if (updates.title !== undefined) row.title = updates.title;
                if (updates.column_key) row.column_key = updates.column_key;
                if (updates.priority) row.priority = updates.priority;
                if (updates.assignee_email) row.assignee_email = updates.assignee_email;
                // migrated 2026-04-27 to SDK route workspaceProject.tickets.update
                try {
                    await (0, $bfqVY.getSDK)().execute('workspaceProject.tickets', 'update', {
                        id: t.id,
                        payload: row
                    });
                } catch (err) {
                    console.error('[AI Update] ticket save error:', err?.message || err);
                }
            }
            if (updates.column_key) try {
                el.call('moveTicket', {
                    ticketId: t.id,
                    columnKey: updates.column_key,
                    position: 0
                });
            } catch  {}
            // Update AI comment
            const summary = ai.summary || actions.join(', ');
            const aiBody = `\u{2726} **Done.** ${summary}\n${actions.map((a)=>`\u{2022} ${a}`).join('\n')}`;
            const comments = root._ticketComments || [];
            root.update({
                _ticketComments: comments.map((c)=>c === aiPlaceholder ? {
                        ...c,
                        body: aiBody
                    } : c)
            });
            // migrated 2026-04-27 to SDK route workspaceProject.ticketComments.create
            // (AI comment + user comment posted together — fire-and-forget; failures
            // are tolerated since the in-memory state already reflects the updates).
            try {
                (0, $bfqVY.getSDK)().execute('workspaceProject.ticketComments', 'create', {
                    ticketId: t.id,
                    payload: userComment
                }).catch(()=>{});
                (0, $bfqVY.getSDK)().execute('workspaceProject.ticketComments', 'create', {
                    ticketId: t.id,
                    payload: {
                        author_email: 'ai@symbols.app',
                        body: aiBody,
                        created_at: now
                    }
                }).catch(()=>{});
            } catch  {}
        } catch (err) {
            console.error('[AI Update]', err?.message || err);
            const comments = root._ticketComments || [];
            root.update({
                _ticketComments: comments.map((c)=>c === aiPlaceholder ? {
                        ...c,
                        body: `AI update failed: ${err?.message || 'Unknown error'}`
                    } : c)
            });
        }
        return;
    }
    var x;
    // Regular comment mode
    const userComment = {
        ticket_id: t.id,
        author_email: email,
        body: body,
        created_at: now
    };
    const prev = root._ticketComments || [];
    root.update({
        _ticketComments: [
            ...prev,
            {
                ...userComment,
                _name: userName
            }
        ]
    });
    // migrated 2026-04-27 to SDK route workspaceProject.ticketComments.create
    try {
        await (0, $bfqVY.getSDK)().execute('workspaceProject.ticketComments', 'create', {
            ticketId: t.id,
            payload: userComment
        });
    } catch (err) {
        console.error('[postComment] insert failed:', err?.message || err);
    }
};
// --- formatting ---
const $fc6ff45cb7441317$var$_formatDate = (d)=>{
    if (!d) return '';
    try {
        return new Date(d).toLocaleDateString(undefined, {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    } catch (_) {
        return String(d);
    }
};
const $fc6ff45cb7441317$var$_columnLabel = (root)=>{
    const t = $fc6ff45cb7441317$var$_ticket(root);
    if (!t) return '';
    const col = (root.columns || []).find((c)=>c.key === t.columnKey);
    return col?.label || t.columnKey || '';
};
// --- save (handles both create and update) ---
const $fc6ff45cb7441317$var$_save = (root, el)=>{
    const d = $fc6ff45cb7441317$var$_draft(root);
    // For new tickets using inline editing, grab description from contenteditable
    if ($fc6ff45cb7441317$var$_isNew(root)) {
        const descEl = document.querySelector('[data-desc-body]');
        if (descEl && descEl.innerText?.trim()) d.body = descEl.innerText.trim();
    }
    if (!(d.title || '').trim()) return;
    if ($fc6ff45cb7441317$var$_isNew(root)) {
        const sameCol = (root.tickets || []).filter((t)=>t.columnKey === d.columnKey);
        const lastPos = sameCol.length ? Math.max(...sameCol.map((t)=>t.position || 0)) : 0;
        const t = {
            id: Date.now(),
            title: d.title.trim(),
            body: d.body || '',
            columnKey: d.columnKey || 'backlog',
            position: (0, $7MNpT.positionBetween)(lastPos, null),
            assigneeEmail: d.assigneeEmail || null,
            reporterEmail: root.currentUserEmail,
            labels: d.labels || [],
            priority: d.priority || 'medium',
            issueType: d.issueType || null,
            storyPoints: d.storyPoints || null,
            acceptanceCriteria: d.acceptanceCriteria || null,
            dueDate: d.dueDate || null,
            agentTest: d.agentTest !== false // default true
        };
        const pending = root.pendingSuggestion;
        root.update({
            tickets: [
                ...root.tickets || [],
                t
            ],
            selectedTicket: null,
            ticketDraft: null,
            ticketEditMode: false,
            pendingSuggestion: null
        });
        el.call('saveTicketToSupabase', t).then((realId)=>{
            if (!realId) return;
            root.update({
                tickets: (root.tickets || []).map((x)=>x.id === t.id ? {
                        ...x,
                        id: realId
                    } : x)
            });
            if (pending?.bucket === 'tickets' && pending?.item) el.call('markSuggestionApplied', pending.bucket, pending.item, realId);
        });
    } else {
        const t = $fc6ff45cb7441317$var$_ticket(root);
        if (!t) return;
        const updated = {
            ...t,
            title: d.title.trim(),
            body: d.body || '',
            columnKey: d.columnKey || t.columnKey,
            priority: d.priority || t.priority,
            assigneeEmail: d.assigneeEmail || null
        };
        root.update({
            tickets: (root.tickets || []).map((x)=>x.id === t.id ? updated : x),
            selectedTicket: updated,
            ticketDraft: null,
            ticketEditMode: false
        });
        el.call('saveTicketToSupabase', updated);
    }
};
const $fc6ff45cb7441317$export$a1cac5cabad89002 = {
    extends: 'Modal',
    stateKey: 'selectedTicket',
    background: 'black.65',
    backdropFilter: 'blur(8px)',
    // Defense-in-depth: even if the `display` reactive prop evaluates to 'flex'
    // before selectedTicket is set (DOMQL first-render race), pointer-events:none
    // prevents the full-viewport overlay from blocking page chrome.
    // When selectedTicket is truthy (modal intentionally open) we restore pe:auto.
    pointerEvents: (el, s)=>s.root?.selectedTicket ? 'auto' : 'none',
    onClick: (e, el, s)=>{
        if (e.target !== el.node) return;
        $fc6ff45cb7441317$var$_close(s.root);
    },
    onCreate: (el, s)=>{
        // URL-restore: open the modal when the page is loaded with ?ticket=<id>.
        // Runs ONCE on mount (onCreate, not onRender) so we never spawn more than
        // one setInterval per mount — the root cause of the renderer freeze (#4594).
        const urlId = $fc6ff45cb7441317$var$_getTicketIdFromUrl();
        if (!urlId || s.root?.selectedTicket) return;
        // Normalize snake_case API fields to camelCase if needed
        const _norm = (t)=>{
            if (!t || t.columnKey !== undefined) return t // already normalized
            ;
            return {
                ...t,
                columnKey: t.column_key ?? t.columnKey,
                issueType: t.issue_type ?? t.issueType,
                epicName: t.epic_name ?? t.epicName,
                assigneeEmail: t.assignee_email ?? t.assigneeEmail,
                updatedAt: t.updated_at ?? t.updatedAt,
                createdAt: t.created_at ?? t.createdAt,
                reporterEmail: t.reporter_email ?? t.reporterEmail
            };
        };
        const tryRestore = ()=>{
            try {
                const root = s.root || {};
                // Expand triage buckets (used on /tickets/general) alongside the flat
                // arrays used on other pages. Defensive defaults for every bucket so
                // a missing key never throws and we fall through cleanly.
                const triage = root.triage || {};
                const allTickets = [
                    ...root.tickets || [],
                    ...root.recentTickets || [],
                    ...root.myTickets || [],
                    // canvas page stores tickets in canvasAllTickets — include it so that
                    // ?ticket=N deep-links work on /tickets/canvas (fix for #4417)
                    ...root.canvasAllTickets || [],
                    // /tickets/general triage buckets — fix for #4594 freeze
                    ...triage.now || [],
                    ...triage.ongoing || [],
                    ...triage.blocked || [],
                    ...triage.upcoming || [],
                    ...triage.pendingApproval || [],
                    ...triage.readyToTest || [],
                    // decisions bucket — type=decision ASK-USER tickets (#4637)
                    ...triage.decisions || []
                ];
                const found = allTickets.find((t)=>String(t.number) === urlId || String(t.id) === urlId);
                if (found) {
                    s.root.update({
                        selectedTicket: _norm({
                            ...found
                        })
                    });
                    // v3.14 reactive gap: storeUpdate only fires onUpdate on the element
                    // directly attached to the state store (the root). Child elements
                    // like DependenciesSection and the sidebar Dependencies panel have
                    // imperative onUpdate hooks that are NOT auto-called when root state
                    // changes via a setInterval closure. Explicitly propagate so the
                    // dep-fetch fires and DependenciesSection becomes visible (#4620).
                    setTimeout(()=>$fc6ff45cb7441317$var$_propagateDepsUpdate(el), 0);
                    return true;
                }
            } catch (err) {
                console.warn('[TicketsDetailModal] tryRestore error (safe):', err);
            }
            return false;
        };
        if (!tryRestore()) {
            // Guard: clear any previous interval from a prior mount (should not happen,
            // but protects against hot-reload / SSR double-mount edge cases).
            if (el._restoreInterval) {
                clearInterval(el._restoreInterval);
                el._restoreInterval = null;
            }
            let attempts = 0;
            el._restoreInterval = setInterval(()=>{
                if (tryRestore() || ++attempts > 20) {
                    clearInterval(el._restoreInterval);
                    el._restoreInterval = null;
                    // If no local array contained the ticket after 5 s, fetch it
                    // directly rather than silently clearing the URL — this handles the
                    // case where the page's own data store (e.g. canvasAllTickets) is
                    // still null/empty because the async fetch hasn't resolved yet, or
                    // the ticket is not in any currently-loaded list.
                    if (attempts > 20 && !s.root?.selectedTicket) {
                        const numId = parseInt(urlId, 10);
                        const fetchId = !isNaN(numId) ? numId : urlId;
                        $fc6ff45cb7441317$var$_openTicketInModal(s.root || el.getRoot(), fetchId, el);
                    }
                }
            }, 250);
        }
    },
    onDestroy: (el)=>{
        // Always clear the restore interval on unmount so it cannot fire
        // after the element is gone (stale closure → renderer hang).
        if (el._restoreInterval) {
            clearInterval(el._restoreInterval);
            el._restoreInterval = null;
        }
    },
    // Override display to also sync URL (runs reactively on selectedTicket changes)
    display: (el, s)=>{
        const ticket = s.root?.selectedTicket;
        if (ticket) {
            if (!ticket._new && (ticket.number || ticket.id)) $fc6ff45cb7441317$var$_pushTicketUrl(ticket.number || ticket.id);
            // Hydrate body when ticket was opened from a list fetch that omitted body.
            // body===undefined means the field was not in the select; null/'' = truly empty.
            // _hydrating guard prevents reactive loops (display fires again on each update).
            if (ticket.id && !ticket._new && ticket.body === undefined && !$fc6ff45cb7441317$var$_hydrating.has(ticket.id)) {
                $fc6ff45cb7441317$var$_hydrating.add(ticket.id);
                const root = s.root || el.getRoot();
                $fc6ff45cb7441317$var$_hydrateBody(root, ticket.id);
            }
            return 'flex';
        }
        // Only clear URL if no pending restore (check URL directly)
        if (!$fc6ff45cb7441317$var$_getTicketIdFromUrl()) $fc6ff45cb7441317$var$_clearTicketUrl();
        return 'none';
    },
    Window: {
        width: '1080px',
        maxWidth: '95vw',
        height: '88vh',
        maxHeight: '88vh',
        minHeight: '640px',
        overflow: 'hidden',
        position: 'relative',
        // Animated inner-shadow glow when AI is loading
        AiLoadingOverlay: {
            position: 'absolute',
            inset: '0',
            zIndex: '50',
            pointerEvents: 'none',
            round: 'inherit',
            display: (el, s)=>s.root?._aiTicketLoading ? 'block' : 'none',
            onCreate: (el)=>{
                if (!el.node) return;
                if (!document.querySelector('style[data-ai-glow]')) {
                    const st = document.createElement('style');
                    st.setAttribute('data-ai-glow', '');
                    st.textContent = `
            @keyframes ai-glow-pulse {
              0%, 100% { box-shadow: inset 0 0 60px 10px var(--color-blue); opacity: 0.2; }
              50% { box-shadow: inset 0 0 120px 30px var(--color-cyan); opacity: 0.5; }
            }
            [data-key="AiLoadingOverlay"] { animation: ai-glow-pulse 2s ease-in-out infinite; }
          `;
                    document.head.appendChild(st);
                }
            }
        },
        ModalHeader: {
            Icons: {
                Close: {
                    extends: 'IconButton',
                    zIndex: '10',
                    Icon: {
                        icon: 'x'
                    },
                    onClick: (e, el, s)=>$fc6ff45cb7441317$var$_close(s.root)
                },
                EditBtn: {
                    extends: 'IconButton',
                    hide: (el, s)=>$fc6ff45cb7441317$var$_isEditing(s.root) || $fc6ff45cb7441317$var$_isNew(s.root),
                    title: 'Edit ticket',
                    Icon: {
                        icon: 'edit'
                    },
                    onClick: (e, el, s)=>{
                        const t = $fc6ff45cb7441317$var$_ticket(s.root);
                        if (!t) return;
                        s.root.update({
                            ticketEditMode: true,
                            ticketDraft: {
                                title: t.title || '',
                                body: t.body || '',
                                columnKey: t.columnKey || t.column_key || 'backlog',
                                priority: t.priority || 'medium',
                                assigneeEmail: t.assigneeEmail || t.assignee_email || ''
                            }
                        });
                    }
                },
                DeleteBtn: {
                    extends: 'IconButton',
                    hide: (el, s)=>$fc6ff45cb7441317$var$_isEditing(s.root) || $fc6ff45cb7441317$var$_isNew(s.root),
                    title: 'Delete ticket',
                    Icon: {
                        icon: 'trash'
                    },
                    onClick: (e, el, s)=>{
                        const t = $fc6ff45cb7441317$var$_ticket(s.root);
                        if (!t) return;
                        s.root.update({
                            confirmAction: {
                                title: `Delete "${t.title || 'ticket'}"?`,
                                message: 'This permanently removes the ticket. This cannot be undone.',
                                confirmText: 'Delete',
                                icon: 'trash',
                                onConfirm: ()=>{
                                    s.root.update({
                                        tickets: (s.root.tickets || []).filter((x)=>x.id !== t.id),
                                        selectedTicket: null,
                                        ticketDraft: null,
                                        ticketEditMode: false
                                    });
                                    el.call('deleteTicketFromSupabase', t.id);
                                }
                            }
                        });
                    }
                }
            },
            Hgroup: {
                TitleInput: {
                    if: (el, s)=>$fc6ff45cb7441317$var$_isEditing(s.root),
                    tag: 'input',
                    type: 'text',
                    placeholder: 'What needs to be done?',
                    fontSize: 'B',
                    fontWeight: '600',
                    color: 'title',
                    fontFamily: 'inherit',
                    width: '100%',
                    background: 'transparent',
                    borderWidth: '0',
                    outline: 'none',
                    value: (el, s)=>$fc6ff45cb7441317$var$_draft(s.root).title || '',
                    onInput: (e, el, s)=>$fc6ff45cb7441317$var$_patchDraft(s.root, {
                            title: e.target.value
                        })
                },
                H: {
                    if: (el, s)=>!$fc6ff45cb7441317$var$_isEditing(s.root),
                    tag: 'h6',
                    fontWeight: '600',
                    color: 'title',
                    fontFamily: 'inherit',
                    width: '100%',
                    text: (el, s)=>$fc6ff45cb7441317$var$_ticket(s.root)?.title || 'Ticket'
                },
                P: {
                    if: (el, s)=>!$fc6ff45cb7441317$var$_isNew(s.root) && ($fc6ff45cb7441317$var$_isEditing(s.root) || !!$fc6ff45cb7441317$var$_ticket(s.root)),
                    flow: 'x',
                    align: 'center left',
                    gap: 'Z',
                    flexWrap: 'wrap',
                    text: (el, s)=>$fc6ff45cb7441317$var$_isEditing(s.root) ? $fc6ff45cb7441317$var$_ticket(s.root)?.title || '' : '',
                    RepoLink: {
                        if: (el, s)=>!$fc6ff45cb7441317$var$_isEditing(s.root) && s.root.selectedTicket?.repository,
                        flow: 'x',
                        align: 'center left',
                        gap: 'Y',
                        Icon: {
                            icon: 'github',
                            boxSize: 'Z2'
                        },
                        Text: {
                            tag: 'span',
                            text: (el, s)=>s.root.selectedTicket?.repository || ''
                        }
                    },
                    NumberSep: {
                        if: (el, s)=>!$fc6ff45cb7441317$var$_isEditing(s.root) && s.root.selectedTicket?.repository && s.root.selectedTicket?.number,
                        tag: 'span',
                        opacity: '.5',
                        text: "\xb7"
                    },
                    NumberLabel: {
                        if: (el, s)=>!$fc6ff45cb7441317$var$_isEditing(s.root) && s.root.selectedTicket?.number,
                        tag: 'span',
                        color: 'subtitle',
                        fontWeight: '500',
                        text: (el, s)=>s.root.selectedTicket?.number ? `#${s.root.selectedTicket.number}` : ''
                    },
                    UpdatedSep: {
                        if: (el, s)=>!$fc6ff45cb7441317$var$_isEditing(s.root) && s.root.selectedTicket?.updatedAt && (s.root.selectedTicket?.repository || s.root.selectedTicket?.number),
                        tag: 'span',
                        opacity: '.5',
                        text: "\xb7"
                    },
                    Updated: {
                        if: (el, s)=>!$fc6ff45cb7441317$var$_isEditing(s.root) && s.root.selectedTicket?.updatedAt,
                        tag: 'span',
                        text: (el, s)=>`updated ${$fc6ff45cb7441317$var$_formatDate(s.root.selectedTicket?.updatedAt)}`
                    }
                }
            }
        },
        // ── View content — also used for new tickets (inline editing) ──
        ViewContent: {
            flex: '1 1 0',
            flow: 'y',
            minHeight: '0',
            overflow: 'hidden',
            Hero: null,
            Content_Chips: {
                flow: 'x',
                gap: 'Z',
                flexWrap: 'wrap',
                align: 'center left',
                padding: '0 0 Z 0',
                flex: '0 0 auto',
                IssueTypeSelect: {
                    display: (el, s)=>$fc6ff45cb7441317$var$_isEditing(s?.root) ? 'inline-flex' : 'none',
                    tag: 'select',
                    padding: 'Y Z1',
                    round: 'C',
                    fontSize: 'Y2',
                    fontWeight: '700',
                    letterSpacing: '.06em',
                    border: 'none',
                    cursor: 'pointer',
                    color: (el, s)=>(0, $7MNpT.ISSUE_TYPE_COLOR)[$fc6ff45cb7441317$var$_draft(s.root).issueType] || 'caption',
                    background: (el, s)=>`color-mix(in srgb, var(--color-${(0, $7MNpT.ISSUE_TYPE_COLOR)[$fc6ff45cb7441317$var$_draft(s.root).issueType] || 'caption'}) 16%, transparent)`,
                    value: (el, s)=>$fc6ff45cb7441317$var$_draft(s.root).issueType || '',
                    onInput: (e, el, s)=>$fc6ff45cb7441317$var$_patchDraft(s.root, {
                            issueType: e.target.value
                        }),
                    children: [
                        {
                            tag: 'option',
                            value: '',
                            text: "Type\u2026"
                        },
                        {
                            tag: 'option',
                            value: 'bug',
                            text: 'BUG'
                        },
                        {
                            tag: 'option',
                            value: 'feature',
                            text: 'FEATURE'
                        },
                        {
                            tag: 'option',
                            value: 'user-story',
                            text: 'USER STORY'
                        },
                        {
                            tag: 'option',
                            value: 'subtask',
                            text: 'SUBTASK'
                        },
                        {
                            tag: 'option',
                            value: 'marketplace',
                            text: 'MARKETPLACE'
                        }
                    ]
                },
                IssueType: {
                    display: (el, s)=>!$fc6ff45cb7441317$var$_isEditing(s?.root) && s?.root?.selectedTicket?.issueType ? 'inline-flex' : 'none',
                    tag: 'span',
                    padding: 'Y Z1',
                    round: 'C',
                    fontSize: 'Y2',
                    fontWeight: '700',
                    letterSpacing: '.06em',
                    color: (el, s)=>(0, $7MNpT.ISSUE_TYPE_COLOR)[s.root.selectedTicket?.issueType] || 'caption',
                    background: (el, s)=>`color-mix(in srgb, var(--color-${(0, $7MNpT.ISSUE_TYPE_COLOR)[s.root.selectedTicket?.issueType] || 'caption'}) 16%, transparent)`,
                    text: (el, s)=>(s.root.selectedTicket?.issueType || '').toUpperCase()
                },
                Epic: {
                    display: (el, s)=>s.root.selectedTicket?.epicName ? 'inline-flex' : 'none',
                    tag: 'span',
                    padding: 'Y Z1',
                    round: 'C',
                    fontSize: 'Y2',
                    fontWeight: '600',
                    color: 'blue',
                    background: 'color-mix(in srgb, var(--color-blue) 16%, transparent)',
                    text: (el, s)=>`EPIC \xb7 ${(s.root.selectedTicket?.epicName || '').toUpperCase()}`
                },
                State: {
                    display: (el, s)=>s.root.selectedTicket?.state ? 'inline-flex' : 'none',
                    flow: 'x',
                    align: 'center center',
                    gap: 'V',
                    padding: 'Y Z1',
                    round: 'C',
                    fontSize: 'Y2',
                    fontWeight: '700',
                    letterSpacing: '.06em',
                    color: (el, s)=>(0, $7MNpT.TICKET_STATE_COLOR)[s.root.selectedTicket?.state] || (0, $7MNpT.STATE_COLOR)[s.root.selectedTicket?.state] || 'caption',
                    background: (el, s)=>`color-mix(in srgb, var(--color-${(0, $7MNpT.TICKET_STATE_COLOR)[s.root.selectedTicket?.state] || (0, $7MNpT.STATE_COLOR)[s.root.selectedTicket?.state] || 'caption'}) 16%, transparent)`,
                    Dot: null,
                    Text: {
                        tag: 'span',
                        text: (el, s)=>(0, $7MNpT.formatStateLabel)(s.root.selectedTicket?.state)
                    }
                },
                PrioritySelect: {
                    display: (el, s)=>$fc6ff45cb7441317$var$_isEditing(s?.root) ? 'inline-flex' : 'none',
                    tag: 'select',
                    padding: 'Y Z1',
                    round: 'C',
                    fontSize: 'Y2',
                    fontWeight: '700',
                    border: 'none',
                    cursor: 'pointer',
                    color: (el, s)=>(0, $7MNpT.PRIORITY_COLOR)[$fc6ff45cb7441317$var$_draft(s.root).priority] || 'caption',
                    background: (el, s)=>`color-mix(in srgb, var(--color-${(0, $7MNpT.PRIORITY_COLOR)[$fc6ff45cb7441317$var$_draft(s.root).priority] || 'caption'}) 16%, transparent)`,
                    value: (el, s)=>$fc6ff45cb7441317$var$_draft(s.root).priority || 'medium',
                    onInput: (e, el, s)=>$fc6ff45cb7441317$var$_patchDraft(s.root, {
                            priority: e.target.value
                        }),
                    children: [
                        {
                            tag: 'option',
                            value: 'low',
                            text: 'LOW'
                        },
                        {
                            tag: 'option',
                            value: 'medium',
                            text: 'MEDIUM'
                        },
                        {
                            tag: 'option',
                            value: 'high',
                            text: 'HIGH'
                        },
                        {
                            tag: 'option',
                            value: 'urgent',
                            text: 'URGENT'
                        },
                        {
                            tag: 'option',
                            value: 'critical',
                            text: 'CRITICAL'
                        }
                    ]
                },
                PriorityChip: {
                    display: (el, s)=>{
                        const p = !$fc6ff45cb7441317$var$_isEditing(s?.root) && s?.root?.selectedTicket?.priority;
                        return p ? 'inline-flex' : 'none';
                    },
                    tag: 'span',
                    padding: 'Y Z1',
                    round: 'C',
                    fontSize: 'Y2',
                    fontWeight: '700',
                    letterSpacing: '.04em',
                    color: (el, s)=>(0, $7MNpT.PRIORITY_COLOR)[s.root.selectedTicket?.priority] || 'caption',
                    background: (el, s)=>`color-mix(in srgb, var(--color-${(0, $7MNpT.PRIORITY_COLOR)[s.root.selectedTicket?.priority] || 'caption'}) 16%, transparent)`,
                    text: (el, s)=>(s.root.selectedTicket?.priority || '').toUpperCase()
                },
                // ── Approval banner ─────────────────────────────────────────────────────
                // Visible only when ticket is awaiting human approval.
                // Shows Approve + Reject buttons with an optional note textarea.
                // Sequence: comment INSERT (audit trail) → state PATCH.
                ApprovalBar: {
                    display: (el, s)=>$fc6ff45cb7441317$var$_isAwaitingApproval(s.root) && !$fc6ff45cb7441317$var$_isEditing(s.root) && !s.root._approvalDoneAt ? 'flex' : 'none',
                    flow: 'x',
                    gap: 'Z',
                    align: 'center left',
                    flexWrap: 'wrap',
                    padding: 'Z A',
                    round: 'A',
                    background: 'orange.08',
                    borderWidth: '1px',
                    borderColor: 'orange.3',
                    borderStyle: 'solid',
                    width: '100%',
                    marginTop: 'Z',
                    Icon: {
                        icon: 'warning',
                        boxSize: 'Z2',
                        color: 'orange',
                        flexShrink: '0'
                    },
                    Label: {
                        tag: 'span',
                        fontSize: 'Z2',
                        fontWeight: '600',
                        color: 'orange',
                        flex: '1',
                        minWidth: '120px',
                        text: 'Awaiting your approval'
                    },
                    NoteInput: {
                        tag: 'input',
                        type: 'text',
                        'aria-label': 'Approval note',
                        fontSize: 'Z2',
                        color: 'title',
                        background: 'overlay',
                        borderWidth: '1px',
                        borderColor: 'line',
                        borderStyle: 'solid',
                        round: 'Z',
                        padding: 'V Z',
                        flex: '1',
                        minWidth: '160px',
                        maxWidth: '280px',
                        placeholder: 'Approval note (default: Approved.)',
                        value: (el, s)=>s.root._approvalNote || '',
                        onInput: (e, el, s)=>s.root.update({
                                _approvalNote: e.target.value
                            })
                    },
                    ApproveBtn: {
                        tag: 'button',
                        type: 'button',
                        padding: 'V A',
                        round: 'Z',
                        border: 'none',
                        cursor: (el, s)=>s.root._approvalPending ? 'not-allowed' : 'pointer',
                        fontSize: 'Z2',
                        fontWeight: '700',
                        fontFamily: 'inherit',
                        background: (el, s)=>s.root._approvalPending ? 'green.08' : 'green.15',
                        // green+20 lightens the base #59AC56 to ~#7ac677, achieving ≥4.5:1 on dark green bg (WCAG AA)
                        color: 'green+20',
                        transition: 'all 120ms ease',
                        ':hover': {
                            background: 'green',
                            color: 'white'
                        },
                        text: (el, s)=>s.root._approvalPending ? "Approving\u2026" : 'Approve',
                        disabled: (el, s)=>!!s.root._approvalPending,
                        onClick: async (e, el, s)=>{
                            e.stopPropagation();
                            const note = (s.root._approvalNote || '').trim() || 'Approved.';
                            await $fc6ff45cb7441317$var$_approveTicket(s.root, note);
                            s.root.update({
                                _approvalNote: ''
                            });
                        }
                    },
                    RejectBtn: {
                        tag: 'button',
                        type: 'button',
                        padding: 'V A',
                        round: 'Z',
                        border: 'none',
                        cursor: (el, s)=>s.root._approvalPending ? 'not-allowed' : 'pointer',
                        fontSize: 'Z2',
                        fontWeight: '700',
                        fontFamily: 'inherit',
                        background: (el, s)=>s.root._approvalPending ? 'red.06' : 'red.12',
                        // red+15 lightens the base #EB6650 to ~#f08070, achieving ≥4.5:1 on dark red bg (WCAG AA)
                        color: 'red+15',
                        transition: 'all 120ms ease',
                        ':hover': {
                            background: 'red',
                            color: 'white'
                        },
                        text: (el, s)=>s.root._approvalPending ? "Rejecting\u2026" : 'Reject',
                        disabled: (el, s)=>!!s.root._approvalPending,
                        onClick: async (e, el, s)=>{
                            e.stopPropagation();
                            const note = (s.root._approvalNote || '').trim() || 'Needs changes.';
                            await $fc6ff45cb7441317$var$_rejectTicket(s.root, note);
                            s.root.update({
                                _approvalNote: ''
                            });
                        }
                    }
                },
                // ── Post-approval confirmation pill ──────────────────────────────────
                ApprovedPill: {
                    display: (el, s)=>s.root._approvalDoneAt && !$fc6ff45cb7441317$var$_isEditing(s.root) ? 'inline-flex' : 'none',
                    flow: 'x',
                    align: 'center center',
                    gap: 'Y',
                    padding: 'Y Z1',
                    round: 'C',
                    background: (el, s)=>s.root._approvalKind === 'rejected' ? 'red.08' : 'green.08',
                    color: (el, s)=>s.root._approvalKind === 'rejected' ? 'red' : 'green',
                    fontSize: 'Y2',
                    fontWeight: '700',
                    letterSpacing: '.04em',
                    text: (el, s)=>{
                        const when = s.root._approvalDoneAt ? new Date(s.root._approvalDoneAt).toLocaleTimeString('en-US', {
                            hour: '2-digit',
                            minute: '2-digit'
                        }) : '';
                        return s.root._approvalKind === 'rejected' ? `REJECTED \xb7 ${when}` : `APPROVED \xb7 ${when}`;
                    }
                },
                // ── Error toast ───────────────────────────────────────────────────────
                ApprovalErrorToast: {
                    display: (el, s)=>s.root._approvalError ? 'inline-flex' : 'none',
                    flow: 'x',
                    align: 'center center',
                    gap: 'Y',
                    padding: 'Y Z1',
                    round: 'C',
                    background: 'red.08',
                    color: 'red',
                    fontSize: 'Y2',
                    fontWeight: '600',
                    text: (el, s)=>s.root._approvalError || ''
                },
                StatusSelect: {
                    display: (el, s)=>$fc6ff45cb7441317$var$_isEditing(s?.root) ? 'inline-flex' : 'none',
                    tag: 'select',
                    padding: 'Y Z1',
                    round: 'C',
                    fontSize: 'Y2',
                    fontWeight: '600',
                    border: 'none',
                    cursor: 'pointer',
                    color: 'subtitle',
                    background: 'overlay',
                    value: (el, s)=>$fc6ff45cb7441317$var$_draft(s.root).columnKey || 'backlog',
                    onInput: (e, el, s)=>$fc6ff45cb7441317$var$_patchDraft(s.root, {
                            columnKey: e.target.value
                        }),
                    childExtends: {
                        tag: 'option',
                        value: (el, s)=>s.value,
                        text: (el, s)=>s.text
                    },
                    childrenAs: 'state',
                    children: (el, s)=>{
                        const cols = s.root.columns || [];
                        return cols.length ? cols.map((c)=>({
                                value: c.key,
                                text: c.label
                            })) : [
                            {
                                value: 'backlog',
                                text: 'Backlog'
                            },
                            {
                                value: 'todo',
                                text: 'To do'
                            },
                            {
                                value: 'done',
                                text: 'Done'
                            }
                        ];
                    }
                },
                Status: {
                    display: (el, s)=>!$fc6ff45cb7441317$var$_isEditing(s?.root) && $fc6ff45cb7441317$var$_columnLabel(s.root) ? 'inline-flex' : 'none',
                    flow: 'x',
                    align: 'center center',
                    gap: 'Z',
                    padding: 'Y Z1',
                    round: 'C',
                    fontSize: 'Y2',
                    fontWeight: '600',
                    color: 'subtitle',
                    background: 'overlay',
                    borderWidth: '1px',
                    borderColor: 'line',
                    borderStyle: 'solid',
                    StatusLabel: {
                        tag: 'span',
                        opacity: '.7',
                        text: 'STATUS'
                    },
                    Sep: {
                        tag: 'span',
                        opacity: '.4',
                        text: "\xb7"
                    },
                    Value: {
                        tag: 'span',
                        color: 'title',
                        fontWeight: '700',
                        text: (el, s)=>$fc6ff45cb7441317$var$_columnLabel(s.root)
                    }
                }
            },
            Content: {
                flow: 'x',
                flex: '1 1 0',
                minHeight: '0',
                overflow: 'hidden',
                Main: {
                    flow: 'y',
                    gap: 'A1',
                    padding: 'A1 B1 - -',
                    flex: '1 1 0',
                    minWidth: '0',
                    overflow: 'hidden auto',
                    SubIssues: {
                        display: (el, s)=>(s.root.selectedTicket?.subIssuesTotal || 0) > 0 ? 'flex' : 'none',
                        flow: 'y',
                        gap: 'Z',
                        padding: 'A',
                        round: 'Z2',
                        background: 'overlay',
                        borderWidth: '1px',
                        borderColor: 'line',
                        borderStyle: 'solid',
                        Header: {
                            flow: 'x',
                            align: 'center space-between',
                            gap: 'Z',
                            Label: {
                                flow: 'x',
                                align: 'center left',
                                gap: 'Z',
                                Icon: {
                                    icon: 'checkCircle',
                                    boxSize: 'Z2',
                                    color: 'caption'
                                },
                                Text: {
                                    tag: 'span',
                                    fontSize: 'Z2',
                                    color: 'subtitle',
                                    text: (el, s)=>{
                                        const t = s.root.selectedTicket;
                                        return `Sub-issues \xb7 ${t?.subIssuesCompleted || 0} of ${t?.subIssuesTotal || 0}`;
                                    }
                                }
                            },
                            Percent: {
                                tag: 'span',
                                fontSize: 'Y2',
                                fontWeight: '600',
                                color: 'caption',
                                text: (el, s)=>{
                                    const t = s.root.selectedTicket;
                                    const tot = t?.subIssuesTotal || 0;
                                    const done = t?.subIssuesCompleted || 0;
                                    return tot ? `${Math.round(done / tot * 100)}%` : '';
                                }
                            }
                        },
                        Track: {
                            position: 'relative',
                            width: '100%',
                            height: 'Z',
                            round: 'C',
                            background: 'overlay',
                            overflow: 'hidden',
                            Fill: {
                                position: 'absolute',
                                top: '0',
                                left: '0',
                                height: '100%',
                                round: 'C',
                                background: 'linear-gradient(90deg, var(--color-green), var(--color-cyan))',
                                transition: 'width 200ms ease',
                                width: (el, s)=>{
                                    const t = s.root.selectedTicket;
                                    const tot = t?.subIssuesTotal || 0;
                                    const done = t?.subIssuesCompleted || 0;
                                    return tot ? `${done / tot * 100}%` : '0%';
                                }
                            }
                        }
                    },
                    Description: $fc6ff45cb7441317$var$_richField('Description', 'body', "Add a description\u2026", 'D', ()=>true),
                    AcceptanceCriteria: $fc6ff45cb7441317$var$_richField('Acceptance Criteria', 'acceptanceCriteria', 'Checklist of conditions that must be met', 'C', (s)=>$fc6ff45cb7441317$var$_showField(s.root, 'acceptance') && ($fc6ff45cb7441317$var$_isEditing(s.root) || s.root.selectedTicket?.acceptanceCriteria)),
                    StepsToReproduce: $fc6ff45cb7441317$var$_richField('Steps to Reproduce', 'stepsToReproduce', '1. Go to page X\n2. Click here\n3. See error', 'B1', (s)=>{
                        const type = $fc6ff45cb7441317$var$_isEditing(s.root) ? $fc6ff45cb7441317$var$_draft(s.root).issueType || '' : s.root.selectedTicket?.issueType || '';
                        return type === 'bug' && $fc6ff45cb7441317$var$_isEditing(s.root) || s.root.selectedTicket?.stepsToReproduce;
                    }),
                    ExpectedResult: $fc6ff45cb7441317$var$_richField('Expected Result', 'expectedResult', 'What should have happened?', 'B1', (s)=>{
                        const type = $fc6ff45cb7441317$var$_isEditing(s.root) ? $fc6ff45cb7441317$var$_draft(s.root).issueType || '' : s.root.selectedTicket?.issueType || '';
                        return type === 'bug' && $fc6ff45cb7441317$var$_isEditing(s.root) || s.root.selectedTicket?.expectedResult;
                    }),
                    Labels: null,
                    CustomFields: {
                        display: (el, s)=>{
                            const cf = s.root.selectedTicket?.customFields || {};
                            const known = new Set([
                                'Title',
                                'Status',
                                'Priority',
                                'Story Points',
                                'Estimate',
                                'Size',
                                'Severity',
                                'Environment',
                                'Review Status',
                                'Iteration',
                                'Epic',
                                'Due Date'
                            ]);
                            return Object.keys(cf).some((k)=>!known.has(k)) ? 'flex' : 'none';
                        },
                        flow: 'y',
                        gap: 'Z',
                        CFLabel: {
                            tag: 'span',
                            fontSize: 'Y2',
                            fontWeight: '600',
                            letterSpacing: '.06em',
                            color: 'caption',
                            text: 'OTHER FIELDS'
                        },
                        Grid: {
                            display: 'grid',
                            gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
                            gap: 'Z1',
                            childExtends: 'TicketsDetailField',
                            childrenAs: 'state',
                            children: (el, s)=>{
                                const cf = s.root.selectedTicket?.customFields || {};
                                const known = new Set([
                                    'Title',
                                    'Status',
                                    'Priority',
                                    'Story Points',
                                    'Estimate',
                                    'Size',
                                    'Severity',
                                    'Environment',
                                    'Review Status',
                                    'Iteration',
                                    'Epic',
                                    'Due Date'
                                ]);
                                return Object.entries(cf).filter(([k])=>!known.has(k)).map(([label, value])=>({
                                        label: label,
                                        value: String(value)
                                    }));
                            }
                        }
                    },
                    // ── AI Prompt — edit mode: AI updates ticket fields from prompt ──
                    AiPrompt: {
                        display: (el, s)=>$fc6ff45cb7441317$var$_isEditing(s.root) ? 'flex' : 'none',
                        flow: 'y',
                        gap: 'Z',
                        marginTop: 'auto',
                        padding: 'A 0 0 0',
                        borderTopWidth: '1px',
                        borderTopColor: 'line',
                        borderTopStyle: 'solid',
                        CaptionTitle: {
                            Text: {
                                text: 'AI Assistant'
                            }
                        },
                        PromptRow: {
                            flow: 'y',
                            gap: '0',
                            round: 'A',
                            overflow: 'hidden',
                            theme: 'field',
                            position: 'relative',
                            Editor: {
                                tag: 'div',
                                contenteditable: 'true',
                                spellcheck: 'true',
                                minHeight: 'B1',
                                maxHeight: 'D',
                                width: '100%',
                                padding: 'Z1 A',
                                fontSize: 'Z2',
                                lineHeight: '1.5',
                                color: 'title',
                                background: 'transparent',
                                outline: 'none',
                                overflow: 'auto',
                                wordBreak: 'break-word',
                                attr: {
                                    'data-ai-prompt': 'true',
                                    'data-placeholder': "Ask AI to fill fields, improve description, add acceptance criteria\u2026"
                                },
                                onCreate: (el)=>{
                                    if (!el.node) return;
                                    if (!document.querySelector('style[data-ai-prompt-ph]')) {
                                        const style = document.createElement('style');
                                        style.textContent = '[data-ai-prompt]:empty::before { content: attr(data-placeholder); color: var(--color-caption); pointer-events: none; }';
                                        style.setAttribute('data-ai-prompt-ph', '');
                                        document.head.appendChild(style);
                                    }
                                },
                                onKeydown: (e, el, s)=>{
                                    if (e.key === 'Enter' && !e.shiftKey) {
                                        e.preventDefault();
                                        const prompt = (el.node.innerText || '').trim();
                                        if (!prompt) return;
                                        el.node.innerHTML = '';
                                        $fc6ff45cb7441317$var$_aiUpdateTicket(s.root, prompt, el);
                                    }
                                }
                            },
                            BottomBar: {
                                flow: 'x',
                                align: 'center flex-end',
                                padding: '0 Z Z Z',
                                SendBtn: {
                                    extends: 'CircleButton',
                                    padding: 'Z',
                                    icon: 'magicstar',
                                    title: 'Send to AI',
                                    onClick: (e, el, s)=>{
                                        const editor = el.parent?.parent?.Editor?.node;
                                        if (!editor) return;
                                        const prompt = (editor.innerText || '').trim();
                                        if (!prompt) return;
                                        editor.innerHTML = '';
                                        $fc6ff45cb7441317$var$_aiUpdateTicket(s.root, prompt, el);
                                    }
                                }
                            }
                        }
                    },
                    // ── Dependencies in main column — below description, above comments ──
                    // Mirrors the sidebar TicketDependenciesPanel data but renders in the
                    // scrollable main column with "Blocked by" / "Blocks" sub-headings.
                    // Visible only when current ticket has at least one dependency row.
                    // Data is fetched/cached via the same _ticketDeps root cache used by
                    // the sidebar panel (populated via TicketDependenciesPanel.onUpdate).
                    DependenciesSection: {
                        display: (el, s)=>{
                            if ($fc6ff45cb7441317$var$_isEditing(s.root)) return 'none';
                            const id = s.root?.selectedTicket?.id;
                            const d = s.root?._ticketDeps?.[id];
                            return d && !d._loading && (d.outgoing.length || d.incoming.length) ? 'flex' : 'none';
                        },
                        flow: 'y',
                        gap: 'Z',
                        padding: 'A',
                        round: 'Z2',
                        background: 'white.03',
                        borderWidth: '1px',
                        borderColor: 'line',
                        borderStyle: 'solid',
                        // Trigger the dep fetch reactively on selectedTicket changes.
                        // onRender is one-shot (fires at element creation before selectedTicket is
                        // set by the async setInterval URL-restore in TicketsDetailModal.onCreate).
                        // onUpdate fires on every root state change, so it catches the moment
                        // selectedTicket becomes truthy. el._fetchedForId deduplicates per ticket id.
                        onUpdate: (el, s)=>{
                            const id = s.root?.selectedTicket?.id;
                            if (!id || el._fetchedForId === id) return;
                            el._fetchedForId = id;
                            const cache = s.root._ticketDeps || {};
                            if (cache[id] && !cache[id]._loading) return;
                            s.root._ticketDeps = {
                                ...cache,
                                [id]: {
                                    outgoing: [],
                                    incoming: [],
                                    _loading: true
                                }
                            };
                            $fc6ff45cb7441317$var$_fetchTicketDeps(id).then((deps)=>{
                                if (s.root?.selectedTicket?.id !== id) return;
                                s.root.update({
                                    _ticketDeps: {
                                        ...s.root._ticketDeps || {},
                                        [id]: deps
                                    }
                                });
                            });
                        },
                        SectionHeader: {
                            flow: 'x',
                            align: 'center left',
                            gap: 'Z',
                            Icon: {
                                icon: 'link',
                                boxSize: 'Z2',
                                color: 'caption'
                            },
                            Label: {
                                tag: 'span',
                                fontSize: 'Y2',
                                fontWeight: '700',
                                color: 'caption',
                                letterSpacing: '.06em',
                                textTransform: 'uppercase',
                                text: 'Dependencies'
                            },
                            Count: {
                                tag: 'span',
                                fontSize: 'Y2',
                                fontWeight: '600',
                                color: 'caption',
                                opacity: '.6',
                                text: (el, s)=>{
                                    const id = s.root?.selectedTicket?.id;
                                    const d = s.root?._ticketDeps?.[id];
                                    const n = (d?.outgoing?.length || 0) + (d?.incoming?.length || 0);
                                    return n ? `\xb7 ${n}` : '';
                                }
                            }
                        },
                        // "Blocked by" — rows where THIS ticket depends on another
                        // (ticket_id = current.id in ticket_dependencies)
                        BlockedBy: {
                            display: (el, s)=>{
                                const d = s.root?._ticketDeps?.[s.root.selectedTicket?.id];
                                return d?.outgoing?.length ? 'flex' : 'none';
                            },
                            flow: 'y',
                            gap: 'Y',
                            marginTop: 'Z',
                            Label: {
                                tag: 'span',
                                fontSize: 'Y2',
                                fontWeight: '600',
                                color: 'red.7',
                                letterSpacing: '.04em',
                                textTransform: 'uppercase',
                                text: (el, s)=>{
                                    const d = s.root?._ticketDeps?.[s.root.selectedTicket?.id];
                                    return `Blocked by \xb7 ${d?.outgoing?.length || 0}`;
                                }
                            },
                            List: {
                                flow: 'y',
                                gap: 'V',
                                childExtends: 'TicketDependencyMainRow',
                                childrenAs: 'state',
                                children: (el, s)=>s.root?._ticketDeps?.[s.root.selectedTicket?.id]?.outgoing || []
                            }
                        },
                        // "Blocks" — rows where THIS ticket blocks another
                        // (depends_on_ticket_id = current.id in ticket_dependencies)
                        Blocks: {
                            display: (el, s)=>{
                                const d = s.root?._ticketDeps?.[s.root.selectedTicket?.id];
                                return d?.incoming?.length ? 'flex' : 'none';
                            },
                            flow: 'y',
                            gap: 'Y',
                            marginTop: (el, s)=>{
                                const d = s.root?._ticketDeps?.[s.root.selectedTicket?.id];
                                return d?.outgoing?.length ? 'Z' : '0';
                            },
                            Label: {
                                tag: 'span',
                                fontSize: 'Y2',
                                fontWeight: '600',
                                color: 'orange.8',
                                letterSpacing: '.04em',
                                textTransform: 'uppercase',
                                text: (el, s)=>{
                                    const d = s.root?._ticketDeps?.[s.root.selectedTicket?.id];
                                    return `Blocks \xb7 ${d?.incoming?.length || 0}`;
                                }
                            },
                            List: {
                                flow: 'y',
                                gap: 'V',
                                childExtends: 'TicketDependencyMainRow',
                                childrenAs: 'state',
                                children: (el, s)=>s.root?._ticketDeps?.[s.root.selectedTicket?.id]?.incoming || []
                            }
                        }
                    },
                    // ── Comments — pinned to bottom of content area ──
                    Comments: {
                        hide: (el, s)=>$fc6ff45cb7441317$var$_isEditing(s.root),
                        flow: 'y',
                        gap: 'Z',
                        marginTop: 'auto',
                        padding: '0',
                        // Comment list — no scroll, grows with content
                        CommentList: {
                            flow: 'y',
                            gap: 'Z',
                            padding: 'Z 0',
                            childExtends: 'TicketCommentRow',
                            childrenAs: 'state',
                            children: (el, s)=>s.root?._ticketComments || []
                        },
                        // Composer with mode tabs + toolbar inside
                        ComposerRow: {
                            flow: 'y',
                            gap: '0',
                            round: 'A',
                            overflow: 'hidden',
                            theme: 'field',
                            position: 'relative',
                            // Mode tabs — top right, matching send button position
                            Tabs: {
                                position: 'absolute',
                                top: 'Z',
                                right: 'Z',
                                zIndex: '2',
                                flow: 'x',
                                gap: 'V',
                                UpdateTab: {
                                    tag: 'button',
                                    type: 'button',
                                    padding: 'V Z',
                                    round: 'C',
                                    border: 'none',
                                    cursor: 'pointer',
                                    fontSize: 'Y1',
                                    fontWeight: '600',
                                    fontFamily: 'inherit',
                                    background: (el, s)=>(s.root?._commentTab || 'comment') === 'update' ? 'blue.15' : 'transparent',
                                    color: (el, s)=>(s.root?._commentTab || 'comment') === 'update' ? 'blue' : 'caption',
                                    text: 'Update',
                                    onClick: (e, el, s)=>s.root.update({
                                            _commentTab: 'update'
                                        })
                                },
                                CommentTab: {
                                    tag: 'button',
                                    type: 'button',
                                    padding: 'V Z',
                                    round: 'C',
                                    border: 'none',
                                    cursor: 'pointer',
                                    fontSize: 'Y1',
                                    fontWeight: '600',
                                    fontFamily: 'inherit',
                                    background: (el, s)=>(s.root?._commentTab || 'comment') === 'comment' ? 'blue.15' : 'transparent',
                                    color: (el, s)=>(s.root?._commentTab || 'comment') === 'comment' ? 'blue' : 'caption',
                                    text: 'Comment',
                                    onClick: (e, el, s)=>s.root.update({
                                            _commentTab: 'comment'
                                        })
                                }
                            },
                            // Contenteditable editor
                            Editor: {
                                tag: 'div',
                                contenteditable: 'true',
                                spellcheck: 'true',
                                minHeight: 'C',
                                maxHeight: 'E',
                                width: '100%',
                                padding: 'A',
                                fontSize: 'Z2',
                                lineHeight: '1.5',
                                color: 'title',
                                background: 'transparent',
                                outline: 'none',
                                overflow: 'auto',
                                wordBreak: 'break-word',
                                attr: {
                                    'data-comment-editor': 'true',
                                    'data-placeholder': (el, s)=>(s.root?._commentTab || 'comment') === 'update' ? 'Describe what changed (AI will summarize)...' : 'Add a comment...'
                                },
                                onCreate: (el)=>{
                                    if (!el.node) return;
                                    const style = document.createElement('style');
                                    style.textContent = '[data-comment-editor]:empty::before { content: attr(data-placeholder); color: var(--color-caption); pointer-events: none; }';
                                    if (!document.querySelector('style[data-comment-editor-ph]')) {
                                        style.setAttribute('data-comment-editor-ph', '');
                                        document.head.appendChild(style);
                                    }
                                },
                                onFocus: (e, el, s)=>{
                                    // Only show toolbar in Comment mode, not Update mode
                                    if ((s.root?._commentTab || 'comment') === 'comment') {
                                        const toolbar = el.parent?.BottomBar?.CommentToolbar?.node;
                                        if (toolbar) toolbar.style.display = 'flex';
                                    }
                                },
                                onBlur: (e, el)=>{
                                    setTimeout(()=>{
                                        if (document.activeElement === el.node) return;
                                        const toolbar = el.parent?.BottomBar?.CommentToolbar?.node;
                                        if (toolbar) toolbar.style.display = 'none';
                                    }, 200);
                                },
                                onKeydown: (e, el, s)=>{
                                    if (e.key === 'Enter' && !e.shiftKey) {
                                        e.preventDefault();
                                        const body = (el.node.innerText || '').trim();
                                        if (!body) return;
                                        el.node.innerHTML = '';
                                        $fc6ff45cb7441317$var$_postComment(s.root, body, el);
                                    }
                                }
                            },
                            // Bottom bar: toolbar + send button
                            BottomBar: {
                                flow: 'x',
                                align: 'center space-between',
                                padding: '0 Z Z Z',
                                CommentToolbar: {
                                    extends: 'WysiwygToolbar',
                                    display: 'none',
                                    flex: '1',
                                    padding: 'V 0 0 V'
                                },
                                SendBtn: {
                                    extends: 'CircleButton',
                                    padding: 'Z',
                                    marginLeft: 'auto',
                                    icon: 'chevronUp',
                                    Icon: {
                                        transform: 'rotate(45deg)'
                                    },
                                    '@dark': {
                                        background: 'white',
                                        color: 'title',
                                        ':hover': {
                                            background: 'gray14',
                                            color: 'gray1'
                                        },
                                        ':active': {
                                            background: 'gray13',
                                            color: 'gray1'
                                        }
                                    },
                                    onClick: (e, el, s)=>{
                                        const editor = el.parent?.parent?.Editor?.node;
                                        if (!editor) return;
                                        const body = (editor.innerText || '').trim();
                                        if (!body) return;
                                        editor.innerHTML = '';
                                        $fc6ff45cb7441317$var$_postComment(s.root, body, el);
                                    }
                                }
                            }
                        },
                        onUpdate: async (el, s)=>{
                            const t = s.root?.selectedTicket;
                            if (!t || el._lastTicketId === t.id) return;
                            el._lastTicketId = t.id;
                            // migrated 2026-04-27 to SDK route workspaceProject.ticketComments.list
                            try {
                                const data = await (el.sdk || (0, $bfqVY.getSDK)()).execute('workspaceProject.ticketComments', 'list', {
                                    ticketId: t.id,
                                    order: 'created_at.asc'
                                });
                                if (data) {
                                    const people = s.root.people || [];
                                    s.root.update({
                                        _ticketComments: data.map((c)=>({
                                                ...c,
                                                _name: (people.find((p)=>p.email === c.author_email)?.name || c.author_email || '').split(' ')[0]
                                            }))
                                    });
                                }
                            } catch  {}
                        }
                    }
                },
                Sidebar: {
                    flow: 'y',
                    gap: 'A1',
                    padding: 'A1 - - A1',
                    width: '280px',
                    minWidth: '240px',
                    flex: '0 0 auto',
                    background: 'overlay',
                    borderLeftWidth: '1px',
                    borderLeftColor: 'line',
                    borderLeftStyle: 'solid',
                    overflowY: 'auto',
                    // Type, Priority, Column are in Content_Chips — no duplicates here.
                    // ── Priority (slider in edit, badge in view) ──
                    Priority: {
                        display: (el, s)=>$fc6ff45cb7441317$var$_showField(s.root, 'priority') && ($fc6ff45cb7441317$var$_isEditing(s.root) || s.root.selectedTicket?.priority) ? 'flex' : 'none',
                        flow: 'y',
                        gap: 'Z',
                        CaptionTitle: {
                            Text: {
                                text: (el, s)=>{
                                    const v = $fc6ff45cb7441317$var$_isEditing(s.root) ? $fc6ff45cb7441317$var$_draft(s.root).priority : s.root.selectedTicket?.priority;
                                    return `Priority \xb7 ${(v || 'medium').charAt(0).toUpperCase() + (v || 'medium').slice(1)}`;
                                }
                            }
                        },
                        Input: {
                            display: (el, s)=>$fc6ff45cb7441317$var$_isEditing(s.root) ? 'block' : 'none',
                            tag: 'input',
                            type: 'range',
                            min: '0',
                            max: '4',
                            step: '1',
                            width: '100%',
                            height: 'Y',
                            cursor: 'pointer',
                            border: 'none',
                            outline: 'none',
                            value: (el, s)=>String([
                                    'low',
                                    'medium',
                                    'high',
                                    'urgent',
                                    'critical'
                                ].indexOf($fc6ff45cb7441317$var$_draft(s.root).priority || 'medium')),
                            onInput: (e, el, s)=>{
                                const vals = [
                                    'low',
                                    'medium',
                                    'high',
                                    'urgent',
                                    'critical'
                                ];
                                const colors = [
                                    'var(--color-green)',
                                    'var(--color-blue)',
                                    'var(--color-orange)',
                                    'var(--color-red)',
                                    'var(--color-pink)'
                                ];
                                $fc6ff45cb7441317$var$_patchDraft(s.root, {
                                    priority: vals[parseInt(e.target.value)] || 'medium'
                                });
                                e.target.style.accentColor = colors[parseInt(e.target.value)] || '';
                            },
                            onCreate: (el, s)=>{
                                if (!el.node) return;
                                const idx = [
                                    'low',
                                    'medium',
                                    'high',
                                    'urgent',
                                    'critical'
                                ].indexOf($fc6ff45cb7441317$var$_draft(s.root).priority || 'medium');
                                const colors = [
                                    'var(--color-green)',
                                    'var(--color-blue)',
                                    'var(--color-orange)',
                                    'var(--color-red)',
                                    'var(--color-pink)'
                                ];
                                el.node.style.accentColor = colors[idx] || '';
                            }
                        },
                        Value: {
                            display: (el, s)=>$fc6ff45cb7441317$var$_isEditing(s.root) ? 'none' : 'block',
                            tag: 'span',
                            width: 'fit-content',
                            padding: 'V Z',
                            round: 'C',
                            fontSize: 'Y2',
                            fontWeight: '700',
                            letterSpacing: '.04em',
                            color: (el, s)=>(0, $7MNpT.PRIORITY_COLOR)[s.root.selectedTicket?.priority] || 'caption',
                            background: (el, s)=>`color-mix(in srgb, var(--color-${(0, $7MNpT.PRIORITY_COLOR)[s.root.selectedTicket?.priority] || 'caption'}) 16%, transparent)`,
                            text: (el, s)=>(s.root.selectedTicket?.priority || '').toUpperCase()
                        }
                    },
                    // ── Assignees — multi-select with chips ──
                    Assignees: {
                        display: (el, s)=>$fc6ff45cb7441317$var$_showField(s.root, 'assignee') || !$fc6ff45cb7441317$var$_isEditing(s.root) ? 'flex' : 'none',
                        extends: 'InputField',
                        position: 'relative',
                        Title: {
                            text: 'Assignees'
                        },
                        Input: {
                            display: (el, s)=>$fc6ff45cb7441317$var$_isEditing(s.root) ? 'block' : 'none',
                            placeholder: (el, s)=>$fc6ff45cb7441317$var$_draftAssignees(s.root).length ? '' : "Type a name\u2026",
                            value: (el, s)=>s.root._assigneeQuery || '',
                            onInput: (e, el, s)=>s.root.update({
                                    _assigneeQuery: e.target.value
                                }),
                            onKeydown: (e, el, s)=>{
                                if (e.key === 'Enter' || e.key === 'Tab') {
                                    const q = (s.root._assigneeQuery || '').trim().toLowerCase();
                                    if (!q) return;
                                    e.preventDefault();
                                    const existing = new Set($fc6ff45cb7441317$var$_draftAssignees(s.root));
                                    const match = (s.root.people || []).find((p)=>!existing.has(p.email) && (p.name.toLowerCase().includes(q) || p.email.toLowerCase().includes(q)));
                                    if (match) $fc6ff45cb7441317$var$_addAssignee(s.root, match.email);
                                }
                                if (e.key === 'Backspace' && !e.target.value) $fc6ff45cb7441317$var$_popAssignee(s.root);
                            }
                        },
                        SelectedChips: {
                            display: (el, s)=>{
                                const list = $fc6ff45cb7441317$var$_isEditing(s.root) ? $fc6ff45cb7441317$var$_draftAssignees(s.root) : $fc6ff45cb7441317$var$_ticketAssigneeEmails(s.root);
                                return list.length ? 'flex' : 'none';
                            },
                            flow: 'x',
                            flexWrap: 'wrap',
                            gap: 'Y',
                            padding: 'Z 0 0 0',
                            childExtends: 'TicketsDetailAssignee',
                            childrenAs: 'state',
                            children: (el, s)=>{
                                const emails = $fc6ff45cb7441317$var$_isEditing(s.root) ? $fc6ff45cb7441317$var$_draftAssignees(s.root) : $fc6ff45cb7441317$var$_ticketAssigneeEmails(s.root);
                                return emails.map((email)=>{
                                    const p = (s.root.people || []).find((pp)=>pp.email === email);
                                    return {
                                        key: email,
                                        name: p?.name || email,
                                        avatar: el.call('avatarUrl', p?.name || email)
                                    };
                                });
                            }
                        },
                        Suggestions: {
                            display: (el, s)=>{
                                const q = (s.root._assigneeQuery || '').trim();
                                return $fc6ff45cb7441317$var$_isEditing(s.root) && q ? 'flex' : 'none';
                            },
                            position: 'absolute',
                            top: '100%',
                            left: '0',
                            zIndex: '200',
                            flow: 'y',
                            gap: '0',
                            width: '100%',
                            background: 'overlayStrong',
                            round: 'Z',
                            padding: 'V',
                            borderWidth: '1px',
                            borderColor: 'line',
                            borderStyle: 'solid',
                            boxShadow: '0 4px 12px var(--color-shadow)',
                            maxHeight: 'E',
                            overflow: 'auto',
                            textAlign: 'left',
                            childExtends: {
                                tag: 'button',
                                type: 'button',
                                flow: 'x',
                                align: 'center left',
                                gap: 'Z',
                                padding: 'Z A',
                                round: 'V',
                                border: 'none',
                                background: 'transparent',
                                color: 'title',
                                cursor: 'pointer',
                                width: '100%',
                                fontSize: 'Z2',
                                ':hover': {
                                    background: 'line'
                                },
                                Avatar: {
                                    avatarType: 'initials',
                                    boxSize: 'B',
                                    round: '50%',
                                    src: (el, s)=>el.call('avatarUrl', s.name)
                                },
                                Info: {
                                    flow: 'y',
                                    gap: 'V',
                                    flex: '1',
                                    minWidth: '0',
                                    Name: {
                                        tag: 'span',
                                        fontWeight: '500',
                                        text: (el, s)=>s.name
                                    },
                                    Email: {
                                        tag: 'span',
                                        fontSize: 'Y2',
                                        color: 'caption',
                                        text: (el, s)=>s.email
                                    }
                                },
                                onMousedown: (e, el, s)=>{
                                    e.preventDefault();
                                    $fc6ff45cb7441317$var$_addAssignee(s.root, s.email);
                                }
                            },
                            childrenAs: 'state',
                            children: (el, s)=>{
                                const q = (s.root._assigneeQuery || '').trim().toLowerCase();
                                if (!q) return [];
                                const existing = new Set($fc6ff45cb7441317$var$_draftAssignees(s.root));
                                return (s.root.people || []).filter((p)=>!existing.has(p.email) && (p.name.toLowerCase().includes(q) || p.email.toLowerCase().includes(q))).slice(0, 6);
                            }
                        }
                    },
                    // Column is in Content_Chips StatusSelect
                    // ── Story Points (slider) ──
                    StoryPointsField: {
                        display: (el, s)=>$fc6ff45cb7441317$var$_showField(s.root, 'storyPoints') && ($fc6ff45cb7441317$var$_isEditing(s.root) || s.root.selectedTicket?.storyPoints != null) ? 'flex' : 'none',
                        flow: 'y',
                        gap: 'Z',
                        CaptionTitle: {
                            Text: {
                                text: (el, s)=>{
                                    const SP = [
                                        '0',
                                        '1',
                                        '2',
                                        '3',
                                        '5',
                                        '8',
                                        '13'
                                    ];
                                    const v = $fc6ff45cb7441317$var$_isEditing(s.root) ? $fc6ff45cb7441317$var$_draft(s.root).storyPoints || '' : s.root.selectedTicket?.storyPoints || '';
                                    return `Story Points \xb7 ${v || "\u2014"}`;
                                }
                            }
                        },
                        Input: {
                            display: (el, s)=>$fc6ff45cb7441317$var$_isEditing(s.root) ? 'block' : 'none',
                            tag: 'input',
                            type: 'range',
                            min: '0',
                            max: '6',
                            step: '1',
                            width: '100%',
                            height: 'Y',
                            cursor: 'pointer',
                            border: 'none',
                            outline: 'none',
                            value: (el, s)=>{
                                const SP = [
                                    '0',
                                    '1',
                                    '2',
                                    '3',
                                    '5',
                                    '8',
                                    '13'
                                ];
                                return String(SP.indexOf($fc6ff45cb7441317$var$_draft(s.root).storyPoints || '0'));
                            },
                            onInput: (e, el, s)=>{
                                const SP = [
                                    '0',
                                    '1',
                                    '2',
                                    '3',
                                    '5',
                                    '8',
                                    '13'
                                ];
                                const colors = [
                                    'var(--color-caption)',
                                    'var(--color-green)',
                                    'var(--color-cyan)',
                                    'var(--color-blue)',
                                    'var(--color-purple)',
                                    'var(--color-orange)',
                                    'var(--color-red)'
                                ];
                                $fc6ff45cb7441317$var$_patchDraft(s.root, {
                                    storyPoints: SP[parseInt(e.target.value)] || '0'
                                });
                                e.target.style.accentColor = colors[parseInt(e.target.value)] || '';
                            },
                            onCreate: (el, s)=>{
                                if (!el.node) return;
                                const SP = [
                                    '0',
                                    '1',
                                    '2',
                                    '3',
                                    '5',
                                    '8',
                                    '13'
                                ];
                                const colors = [
                                    'var(--color-caption)',
                                    'var(--color-green)',
                                    'var(--color-cyan)',
                                    'var(--color-blue)',
                                    'var(--color-purple)',
                                    'var(--color-orange)',
                                    'var(--color-red)'
                                ];
                                const idx = SP.indexOf($fc6ff45cb7441317$var$_draft(s.root).storyPoints || '0');
                                el.node.style.accentColor = colors[idx] || '';
                            }
                        },
                        Value: {
                            display: (el, s)=>$fc6ff45cb7441317$var$_isEditing(s.root) ? 'none' : 'block',
                            tag: 'span',
                            color: 'cyan',
                            fontSize: 'B',
                            fontWeight: '700',
                            text: (el, s)=>String(s.root.selectedTicket?.storyPoints || '')
                        }
                    },
                    // ── Due Date ──
                    DueDateField: {
                        display: (el, s)=>$fc6ff45cb7441317$var$_showField(s.root, 'dueDate') && ($fc6ff45cb7441317$var$_isEditing(s.root) || s.root.selectedTicket?.dueDate) ? 'flex' : 'none',
                        extends: 'InputField',
                        Title: {
                            text: 'Due date'
                        },
                        Input: {
                            display: (el, s)=>$fc6ff45cb7441317$var$_isEditing(s.root) ? 'block' : 'none',
                            type: 'date',
                            value: (el, s)=>$fc6ff45cb7441317$var$_draft(s.root).dueDate || s.root.selectedTicket?.dueDate || '',
                            onInput: (e, el, s)=>$fc6ff45cb7441317$var$_patchDraft(s.root, {
                                    dueDate: e.target.value
                                })
                        },
                        Value: {
                            display: (el, s)=>$fc6ff45cb7441317$var$_isEditing(s.root) ? 'none' : 'flex',
                            flow: 'x',
                            align: 'center left',
                            gap: 'Y',
                            Icon: {
                                icon: 'clockOutline',
                                boxSize: 'Z2',
                                color: 'caption'
                            },
                            Text: {
                                tag: 'span',
                                fontSize: 'Z2',
                                color: 'title',
                                text: (el, s)=>$fc6ff45cb7441317$var$_formatDate(s.root.selectedTicket?.dueDate)
                            }
                        }
                    },
                    // ── Reporter (autocomplete) ──
                    ReporterField: {
                        display: (el, s)=>$fc6ff45cb7441317$var$_showField(s.root, 'reporter') && ($fc6ff45cb7441317$var$_isEditing(s.root) || s.root.selectedTicket?.reporterEmail) ? 'flex' : 'none',
                        extends: 'InputField',
                        position: 'relative',
                        Title: {
                            text: 'Reporter'
                        },
                        Input: {
                            display: (el, s)=>$fc6ff45cb7441317$var$_isEditing(s.root) ? 'block' : 'none',
                            placeholder: "Type a name\u2026",
                            value: (el, s)=>{
                                const q = s.root._reporterQuery;
                                if (q != null) return q;
                                const email = $fc6ff45cb7441317$var$_draft(s.root).reporterEmail || s.root.currentUserEmail || '';
                                const p = (s.root.people || []).find((pp)=>pp.email === email);
                                return p?.name || email;
                            },
                            onInput: (e, el, s)=>s.root.update({
                                    _reporterQuery: e.target.value
                                }),
                            onFocus: (e, el, s)=>{
                                const email = $fc6ff45cb7441317$var$_draft(s.root).reporterEmail || s.root.currentUserEmail || '';
                                const p = (s.root.people || []).find((pp)=>pp.email === email);
                                s.root.update({
                                    _reporterQuery: p?.name || email
                                });
                                e.target.select();
                            },
                            onBlur: (e, el, s)=>{
                                setTimeout(()=>s.root.update({
                                        _reporterQuery: null
                                    }), 200);
                            }
                        },
                        Suggestions: {
                            display: (el, s)=>{
                                const q = s.root._reporterQuery;
                                return $fc6ff45cb7441317$var$_isEditing(s.root) && q && q.length > 0 ? 'flex' : 'none';
                            },
                            position: 'absolute',
                            top: '100%',
                            left: '0',
                            zIndex: '200',
                            flow: 'y',
                            gap: '0',
                            width: '100%',
                            background: 'overlayStrong',
                            round: 'Z',
                            padding: 'V',
                            borderWidth: '1px',
                            borderColor: 'line',
                            borderStyle: 'solid',
                            boxShadow: '0 4px 12px var(--color-shadow)',
                            maxHeight: 'E',
                            overflow: 'auto',
                            textAlign: 'left',
                            childExtends: {
                                tag: 'button',
                                type: 'button',
                                flow: 'x',
                                align: 'center left',
                                gap: 'Z',
                                padding: 'Z A',
                                round: 'V',
                                border: 'none',
                                background: 'transparent',
                                color: 'title',
                                cursor: 'pointer',
                                width: '100%',
                                fontSize: 'Z2',
                                ':hover': {
                                    background: 'line'
                                },
                                Name: {
                                    tag: 'span',
                                    fontWeight: '500',
                                    text: (el, s)=>s.name
                                },
                                onMousedown: (e, el, s)=>{
                                    e.preventDefault();
                                    $fc6ff45cb7441317$var$_patchDraft(s.root, {
                                        reporterEmail: s.email
                                    });
                                    s.root.update({
                                        _reporterQuery: null
                                    });
                                }
                            },
                            childrenAs: 'state',
                            children: (el, s)=>{
                                const q = (s.root._reporterQuery || '').trim().toLowerCase();
                                if (!q) return [];
                                return (s.root.people || []).filter((p)=>p.name?.toLowerCase().includes(q) || p.email?.toLowerCase().includes(q)).slice(0, 6);
                            }
                        },
                        Value: {
                            display: (el, s)=>$fc6ff45cb7441317$var$_isEditing(s.root) ? 'none' : 'block',
                            tag: 'span',
                            fontSize: 'Z2',
                            color: 'subtitle',
                            text: (el, s)=>{
                                const email = s.root.selectedTicket?.reporterEmail;
                                if (!email) return '';
                                const p = (s.root.people || []).find((pp)=>pp.email === email);
                                return p?.name || email;
                            }
                        }
                    },
                    // ── View-only metadata (shown when values exist) ──
                    Severity: {
                        display: (el, s)=>s.root.selectedTicket?.severity ? 'flex' : 'none',
                        CaptionTitle: {
                            Text: {
                                text: 'Severity'
                            }
                        },
                        Value: {
                            tag: 'span',
                            color: 'red',
                            fontSize: 'Z2',
                            fontWeight: '600',
                            text: (el, s)=>s.root.selectedTicket?.severity || ''
                        }
                    },
                    Size: {
                        display: (el, s)=>s.root.selectedTicket?.size ? 'flex' : 'none',
                        CaptionTitle: {
                            Text: {
                                text: 'Size'
                            }
                        },
                        Value: {
                            tag: 'span',
                            color: 'subtitle',
                            fontSize: 'Z2',
                            text: (el, s)=>s.root.selectedTicket?.size || ''
                        }
                    },
                    Estimate: {
                        // Guard against a stringified "undefined" reaching us from
                        // upstream (GitHub sync sometimes serializes missing
                        // estimates as the literal string "undefined").
                        display: (el, s)=>{
                            const e = s.root.selectedTicket?.estimate;
                            return e != null && e !== '' && e !== 'undefined' ? 'flex' : 'none';
                        },
                        CaptionTitle: {
                            Text: {
                                text: 'Estimate'
                            }
                        },
                        Value: {
                            tag: 'span',
                            color: 'cyan',
                            fontSize: 'Z2',
                            fontWeight: '600',
                            text: (el, s)=>{
                                const e = s.root.selectedTicket?.estimate;
                                return e == null || e === '' || e === 'undefined' ? '' : `${e}h`;
                            }
                        }
                    },
                    Iteration: {
                        display: (el, s)=>s.root.selectedTicket?.iterationTitle ? 'flex' : 'none',
                        CaptionTitle: {
                            Text: {
                                text: 'Iteration'
                            }
                        },
                        Value: {
                            tag: 'span',
                            fontSize: 'Z2',
                            fontWeight: '600',
                            color: 'title',
                            text: (el, s)=>s.root.selectedTicket?.iterationTitle || ''
                        }
                    },
                    Milestone: {
                        display: (el, s)=>s.root.selectedTicket?.milestone ? 'flex' : 'none',
                        CaptionTitle: {
                            Text: {
                                text: 'Milestone'
                            }
                        },
                        Value: {
                            tag: 'span',
                            fontSize: 'Z2',
                            color: 'title',
                            text: (el, s)=>s.root.selectedTicket?.milestone || ''
                        }
                    },
                    Environment: {
                        display: (el, s)=>s.root.selectedTicket?.environment ? 'flex' : 'none',
                        CaptionTitle: {
                            Text: {
                                text: 'Environment'
                            }
                        },
                        Value: {
                            tag: 'span',
                            fontSize: 'Z2',
                            color: 'title',
                            text: (el, s)=>s.root.selectedTicket?.environment || ''
                        }
                    },
                    ReviewStatus: {
                        display: (el, s)=>s.root.selectedTicket?.reviewStatus ? 'flex' : 'none',
                        CaptionTitle: {
                            Text: {
                                text: 'Review'
                            }
                        },
                        Value: {
                            tag: 'span',
                            fontSize: 'Z2',
                            color: 'yellow',
                            fontWeight: '600',
                            text: (el, s)=>s.root.selectedTicket?.reviewStatus || ''
                        }
                    },
                    Dependencies: {
                        extends: 'TicketDependenciesPanel'
                    },
                    Parent: {
                        display: (el, s)=>s.root.selectedTicket?.parentIssueUrl ? 'flex' : 'none',
                        CaptionTitle: {
                            Text: {
                                text: 'Parent issue'
                            }
                        },
                        Value: {
                            tag: 'a',
                            attr: {
                                href: (el, s)=>s.root.selectedTicket?.parentIssueUrl,
                                target: '_blank',
                                rel: 'noopener'
                            },
                            flow: 'x',
                            align: 'center left',
                            gap: 'Y',
                            color: 'cyan',
                            ':hover': {
                                color: 'title'
                            },
                            Icon: {
                                icon: 'arrowAngleUp',
                                boxSize: 'Z2'
                            },
                            Text: {
                                tag: 'span',
                                fontSize: 'Z2',
                                text: "Open parent \u2192"
                            }
                        }
                    },
                    TrackedBy: {
                        display: (el, s)=>(s.root.selectedTicket?.trackedByCount || 0) > 0 ? 'flex' : 'none',
                        CaptionTitle: {
                            Text: {
                                text: 'Tracked by'
                            }
                        },
                        Value: {
                            tag: 'span',
                            fontSize: 'Z2',
                            color: 'title',
                            text: (el, s)=>`${s.root.selectedTicket?.trackedByCount || 0} issue${s.root.selectedTicket?.trackedByCount === 1 ? '' : 's'}`
                        }
                    },
                    Updated: {
                        display: (el, s)=>s.root.selectedTicket?.updatedAt || s.root.selectedTicket?.updated_at ? 'flex' : 'none',
                        CaptionTitle: {
                            Text: {
                                text: 'Last updated'
                            }
                        },
                        Value: {
                            tag: 'span',
                            color: 'caption',
                            text: (el, s)=>$fc6ff45cb7441317$var$_formatDate(s.root.selectedTicket?.updatedAt || s.root.selectedTicket?.updated_at)
                        }
                    },
                    Created: {
                        display: (el, s)=>s.root.selectedTicket?.createdAt || s.root.selectedTicket?.created_at ? 'flex' : 'none',
                        CaptionTitle: {
                            Text: {
                                text: 'Created'
                            }
                        },
                        Value: {
                            tag: 'span',
                            color: 'caption',
                            text: (el, s)=>$fc6ff45cb7441317$var$_formatDate(s.root.selectedTicket?.createdAt || s.root.selectedTicket?.created_at)
                        }
                    }
                }
            }
        },
        // ── Footer ────────────────────────────────────────────────────────────────
        ModalFooter: {
            borderTopWidth: '1px',
            borderTopColor: 'line',
            borderTopStyle: 'solid',
            background: 'transparent',
            flex: '0 0 auto',
            flow: 'x',
            gap: 'Z1',
            align: 'center left',
            // ── Editing mode: Save/Cancel ──
            SaveBtn: {
                hide: (el, s)=>!$fc6ff45cb7441317$var$_isEditing(s.root),
                extends: 'Button',
                theme: 'primary',
                text: (el, s)=>$fc6ff45cb7441317$var$_isNew(s.root) ? 'Create ticket' : 'Save changes',
                onClick: (e, el, s)=>$fc6ff45cb7441317$var$_save(s.root, el)
            },
            CancelEditBtn: {
                hide: (el, s)=>!$fc6ff45cb7441317$var$_isEditing(s.root) || $fc6ff45cb7441317$var$_isNew(s.root),
                extends: 'Button',
                theme: 'secondary',
                text: 'Cancel',
                onClick: (e, el, s)=>{
                    s.root.update({
                        ticketEditMode: false,
                        ticketDraft: null
                    });
                }
            },
            // ── QA agent auto-test toggle (new-ticket form only) ──
            // Writes metadata.agent_test on submit. Default on.
            AgentTestToggle: {
                hide: (el, s)=>!$fc6ff45cb7441317$var$_isNew(s.root),
                flow: 'x',
                gap: 'Z',
                align: 'center left',
                marginLeft: 'auto',
                cursor: 'pointer',
                onClick: (e, el, s)=>{
                    const cur = $fc6ff45cb7441317$var$_draft(s.root).agentTest !== false;
                    $fc6ff45cb7441317$var$_patchDraft(s.root, {
                        agentTest: !cur
                    });
                },
                Checkbox: {
                    tag: 'input',
                    type: 'checkbox',
                    cursor: 'pointer',
                    flexShrink: '0',
                    checked: (el, s)=>$fc6ff45cb7441317$var$_draft(s.root).agentTest !== false,
                    onChange: (e, el, s)=>{
                        $fc6ff45cb7441317$var$_patchDraft(s.root, {
                            agentTest: e.target.checked
                        });
                    }
                },
                Label: {
                    tag: 'label',
                    fontSize: 'Y2',
                    color: 'caption',
                    cursor: 'pointer',
                    userSelect: 'none',
                    text: 'Auto-test by QA agent'
                }
            },
            // ── View mode: State-aware CTA buttons ──
            PrimaryAction: {
                hide: (el, s)=>$fc6ff45cb7441317$var$_isEditing(s.root),
                extends: 'Button',
                theme: 'primary',
                text: (el, s)=>{
                    const t = $fc6ff45cb7441317$var$_ticket(s.root);
                    if (!t) return '';
                    const col = t.columnKey || t.column_key;
                    if (col === '4d6ab783') return 'Mark as ready to test' // In Progress
                    ;
                    if (col === '821cd85d') return 'Approve review' // In Review
                    ;
                    if (col === '20f135e3') return 'Start QA' // Ready For QA
                    ;
                    if (col === 'd677f7ee') return 'Mark as done' // In QA
                    ;
                    return 'Start working' // Backlog/Todo
                    ;
                },
                onClick: (e, el, s)=>{
                    const t = $fc6ff45cb7441317$var$_ticket(s.root);
                    if (!t) return;
                    const col = t.columnKey || t.column_key;
                    let nextCol;
                    if (col === '4d6ab783') nextCol = '20f135e3' // In Progress → Ready For QA
                    ;
                    else if (col === '821cd85d') nextCol = '20f135e3' // In Review → Ready For QA
                    ;
                    else if (col === '20f135e3') nextCol = 'd677f7ee' // Ready For QA → In QA
                    ;
                    else if (col === 'd677f7ee') nextCol = 'eede5560' // In QA → Done
                    ;
                    else nextCol = '4d6ab783' // Backlog/Todo → In Progress
                    ;
                    el.call('moveTicket', {
                        ticketId: t.id,
                        columnKey: nextCol,
                        position: 0
                    });
                    s.root.update({
                        selectedTicket: {
                            ...s.root.selectedTicket,
                            column_key: nextCol,
                            columnKey: nextCol
                        },
                        myTickets: (s.root.myTickets || []).map((x)=>x.id === t.id ? {
                                ...x,
                                column_key: nextCol
                            } : x)
                    });
                }
            },
            SecondaryAction: {
                hide: (el, s)=>{
                    if ($fc6ff45cb7441317$var$_isEditing(s.root)) return true;
                    const t = $fc6ff45cb7441317$var$_ticket(s.root);
                    const col = t?.columnKey || t?.column_key;
                    // Only show "Move for later" on active columns
                    return !col || col === 'backlog' || col === 'eede5560';
                },
                extends: 'Button',
                theme: 'secondary',
                text: 'Move for later',
                onClick: (e, el, s)=>{
                    const t = $fc6ff45cb7441317$var$_ticket(s.root);
                    if (!t) return;
                    el.call('moveTicket', {
                        ticketId: t.id,
                        columnKey: 'backlog',
                        position: 0
                    });
                    s.root.update({
                        selectedTicket: {
                            ...s.root.selectedTicket,
                            column_key: 'backlog',
                            columnKey: 'backlog'
                        },
                        myTickets: (s.root.myTickets || []).map((x)=>x.id === t.id ? {
                                ...x,
                                column_key: 'backlog'
                            } : x)
                    });
                }
            },
            GithubLink: {
                hide: (el, s)=>$fc6ff45cb7441317$var$_isEditing(s.root) || !s.root.selectedTicket?.githubUrl,
                tag: 'a',
                attr: {
                    href: (el, s)=>s.root.selectedTicket?.githubUrl,
                    target: '_blank',
                    rel: 'noopener'
                },
                flow: 'x',
                align: 'center left',
                gap: 'Z',
                padding: 'Z A',
                round: 'C',
                background: 'overlay',
                color: 'subtitle',
                ':hover': {
                    background: 'line',
                    color: 'title'
                },
                transition: 'all 120ms ease',
                Icon: {
                    icon: 'github',
                    boxSize: 'Z2'
                },
                Text: {
                    tag: 'span',
                    fontSize: 'Z2',
                    fontWeight: '500',
                    text: 'Open in GitHub'
                }
            },
            Spacer: {
                flex: '1'
            },
            AskAIBtn: {
                hide: (el, s)=>$fc6ff45cb7441317$var$_isEditing(s.root),
                extends: 'Button',
                theme: 'secondary',
                flow: 'x',
                gap: 'Z',
                align: 'center center',
                Icon: {
                    icon: 'magicstar',
                    boxSize: 'Z2'
                },
                text: 'Ask AI',
                onClick: (e, el, s)=>{
                    const t = $fc6ff45cb7441317$var$_ticket(s.root);
                    if (!t) return;
                    s.root.update({
                        assistantOpen: true,
                        assistantAttachment: {
                            type: 'ticket',
                            id: t.id,
                            title: `#${t.number || t.id} \xb7 ${t.title || ''}`,
                            body: t.body || '',
                            meta: {
                                status: t.columnKey || t.column_key,
                                assignee: t.assigneeEmail || t.assignee_email,
                                epic: t.epicName || t.epic_name,
                                repository: t.repository
                            }
                        }
                    });
                }
            },
            MentionBtn: {
                hide: (el, s)=>$fc6ff45cb7441317$var$_isEditing(s.root),
                extends: 'Button',
                theme: 'secondary',
                flow: 'x',
                gap: 'Z',
                align: 'center center',
                Icon: {
                    icon: 'chat',
                    boxSize: 'Z2'
                },
                text: 'Mention',
                onClick: async (e, el, s)=>{
                    const t = $fc6ff45cb7441317$var$_ticket(s.root);
                    if (!t) return;
                    // Load channels if not already loaded (tickets page doesn't fetch them)
                    // migrated 2026-04-27 to SDK routes workspaceProject.chat (channels)
                    // and workspaceProject.chat.members (channel_members across all channels).
                    if (!(s.root.channels || []).length) {
                        try {
                            const data = await (0, $bfqVY.getSDK)().execute('workspaceProject.chat', 'list', {
                                order: 'updated_at.desc'
                            });
                            if (data) s.root.update({
                                channels: data
                            });
                        } catch  {}
                        try {
                            const data = await (0, $bfqVY.getSDK)().execute('workspaceProject.chat.members', 'list');
                            if (data) s.root.update({
                                channelMembers: data
                            });
                        } catch  {}
                    }
                    s.root.update({
                        _mentionModal: {
                            open: true,
                            ticketId: t.id,
                            ticketNumber: t.number || t.id,
                            ticketTitle: t.title || '',
                            message: `Check out ticket ##${t.number || t.id} \u{2014} ${t.title || ''}`,
                            channelId: null
                        }
                    });
                }
            }
        }
    }
};
const $fc6ff45cb7441317$export$b52d0c837d0ecf61 = {
    show: (el, s)=>!!s.root?._mentionModal?.open,
    position: 'fixed',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    zIndex: 10001,
    align: 'center center',
    background: 'black.5',
    onClick: (e, el, s)=>{
        if (e.target === el.node) s.root.update({
            _mentionModal: {
                open: false
            }
        });
    },
    Card: {
        flow: 'y',
        gap: 'A',
        padding: 'B',
        round: 'A',
        background: 'overlayStrong',
        borderWidth: '1px',
        borderColor: 'line',
        borderStyle: 'solid',
        width: 'H',
        maxWidth: '90vw',
        boxShadow: '0 16px 48px -8px rgba(0, 0, 0, 0.6)',
        Title: {
            tag: 'h3',
            margin: '0',
            fontSize: 'A',
            fontWeight: '600',
            color: 'title',
            text: 'Share in chat'
        },
        // Channel/DM selector
        ChannelField: {
            flow: 'y',
            gap: 'V',
            CaptionTitle: {
                fontSize: 'Y2',
                Text: {
                    text: 'SEND TO'
                }
            },
            Select: {
                tag: 'select',
                padding: 'Z A',
                round: 'Z',
                borderWidth: '1px',
                borderColor: 'line',
                borderStyle: 'solid',
                background: 'overlay',
                color: 'title',
                fontSize: 'Z2',
                fontFamily: 'inherit',
                width: '100%',
                value: (el, s)=>s.root?._mentionModal?.channelId || '',
                onInput: (e, el, s)=>{
                    s.root.update({
                        _mentionModal: {
                            ...s.root._mentionModal,
                            channelId: e.target.value
                        }
                    });
                },
                children: (el, s)=>{
                    const root = s.root;
                    if (!root) return [];
                    const me = root.currentUserEmail;
                    const channels = (root.channels || []).filter((c)=>c.kind === 'channel');
                    const dms = (root.channels || []).filter((c)=>c.kind === 'dm' || c.kind === 'group_dm');
                    const opts = [
                        {
                            tag: 'option',
                            value: '',
                            text: 'Select channel or DM...'
                        }
                    ];
                    if (channels.length) {
                        opts.push({
                            tag: 'option',
                            disabled: true,
                            text: "\u2500\u2500 Channels \u2500\u2500"
                        });
                        for (const c of channels)opts.push({
                            tag: 'option',
                            value: c.id,
                            text: `# ${c.name}`
                        });
                    }
                    if (dms.length) {
                        opts.push({
                            tag: 'option',
                            disabled: true,
                            text: "\u2500\u2500 Direct Messages \u2500\u2500"
                        });
                        for (const c of dms){
                            const members = (root.channelMembers || []).filter((m)=>m.channel_id === c.id && m.member_email !== me).map((m)=>{
                                const p = (root.people || []).find((pp)=>pp.email === m.member_email);
                                return p?.name || m.member_email?.split('@')[0] || '';
                            });
                            opts.push({
                                tag: 'option',
                                value: c.id,
                                text: members.join(', ') || 'DM'
                            });
                        }
                    }
                    return opts;
                }
            }
        },
        // Message editor
        MessageField: {
            flow: 'y',
            gap: 'V',
            CaptionTitle: {
                fontSize: 'Y2',
                Text: {
                    text: 'MESSAGE'
                }
            },
            Editor: {
                tag: 'textarea',
                rows: '3',
                padding: 'Z A',
                round: 'Z',
                borderWidth: '1px',
                borderColor: 'line',
                borderStyle: 'solid',
                background: 'overlay',
                color: 'title',
                fontSize: 'Z2',
                fontFamily: 'inherit',
                resize: 'vertical',
                width: '100%',
                value: (el, s)=>s.root?._mentionModal?.message || '',
                onInput: (e, el, s)=>{
                    s.root.update({
                        _mentionModal: {
                            ...s.root._mentionModal,
                            message: e.target.value
                        }
                    });
                }
            }
        },
        // Actions
        Actions: {
            flow: 'x',
            gap: 'Z',
            align: 'center right',
            CancelBtn: {
                extends: 'Button',
                theme: 'secondary',
                text: 'Cancel',
                onClick: (e, el, s)=>s.root.update({
                        _mentionModal: {
                            open: false
                        }
                    })
            },
            SendBtn: {
                extends: 'Button',
                theme: 'primary',
                text: 'Send message',
                onClick: async (e, el, s)=>{
                    const modal = s.root?._mentionModal;
                    if (!modal?.channelId || !modal?.message?.trim()) return;
                    try {
                        // migrated 2026-04-27 to SDK route workspaceProject.chat.messages.create
                        await (0, $bfqVY.getSDK)().execute('workspaceProject.chat.messages', 'create', {
                            channelId: modal.channelId,
                            payload: {
                                author_email: s.root.currentUserEmail,
                                body: modal.message.trim(),
                                created_at: new Date().toISOString()
                            }
                        });
                        // Close modals and navigate to chat
                        s.root.update({
                            _mentionModal: {
                                open: false
                            },
                            selectedTicket: null,
                            ticketDraft: null,
                            ticketEditMode: false,
                            activeChannelId: modal.channelId,
                            activeTab: 'conversation'
                        });
                        let root = el;
                        while(root && !root.routes)root = root.parent;
                        if (root) el.router('/chat', root);
                    } catch (err) {
                        console.error('[Mention] Send failed:', err);
                    }
                }
            }
        }
    }
};
const $fc6ff45cb7441317$export$154e819e1412a55 = {
    flow: 'y',
    gap: 'Z',
    paddingBottom: 'A',
    borderBottomWidth: '1px',
    borderBottomColor: 'overlay',
    borderBottomStyle: 'solid',
    ':last-child': {
        borderBottom: 'none',
        paddingBottom: '0'
    },
    CaptionTitle: {
        fontSize: 'Y2',
        Text: {
            text: (el)=>el.parent?.parent?.label || ''
        }
    },
    Value: {
        tag: 'span',
        fontSize: 'Z2',
        color: 'title',
        text: (el, s)=>el.parent?.value || ''
    }
};
const $fc6ff45cb7441317$export$e7805e4e42226a28 = {
    flow: 'x',
    align: 'center left',
    gap: 'Z',
    Avatar: {
        display: (el, s)=>s._empty ? 'none' : 'flex',
        tag: 'img',
        width: 'B',
        height: 'B',
        round: '50%',
        borderWidth: '1.5px',
        borderColor: 'overlayStrong',
        borderStyle: 'solid',
        background: 'overlay',
        attr: {
            src: (el, s)=>s.avatar,
            alt: (el, s)=>s.name || ''
        }
    },
    Info: {
        flow: 'y',
        gap: 'V',
        flex: '1',
        minWidth: '0',
        Name: {
            tag: 'span',
            fontSize: 'Z2',
            fontWeight: '500',
            color: (el, s)=>s._empty ? 'caption' : 'title',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>s.name || ''
        },
        Login: {
            display: (el, s)=>s.login ? 'inline' : 'none',
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            text: (el, s)=>`@${s.login || ''}`
        }
    }
};
const $fc6ff45cb7441317$export$5b24ab0b199ad5a3 = {
    flow: 'x',
    gap: 'Z',
    align: 'flex-start',
    padding: 'Z 0',
    borderBottomWidth: '1px',
    borderBottomColor: 'line',
    borderBottomStyle: 'solid',
    ':last-child': {
        borderBottom: 'none'
    },
    Avatar: {
        avatarType: 'initials',
        boxSize: 'A1 A1',
        flexShrink: '0',
        src: (el, s)=>el.call('avatarUrl', s._name || s.author_email)
    },
    Content: {
        flow: 'y',
        gap: 'V',
        flex: '1',
        minWidth: '0',
        Header: {
            flow: 'x',
            gap: 'Z',
            align: 'center left',
            Name: {
                tag: 'span',
                fontSize: 'Y2',
                fontWeight: '600',
                color: 'title',
                text: (el, s)=>s._name || s.author_email?.split('@')[0] || ''
            },
            Time: {
                tag: 'span',
                fontSize: 'Y1',
                color: 'caption',
                text: (el, s)=>{
                    if (!s.created_at) return '';
                    const d = new Date(s.created_at);
                    return d.toLocaleDateString('en-US', {
                        month: 'short',
                        day: 'numeric'
                    }) + ' ' + d.toLocaleTimeString('en-US', {
                        hour: '2-digit',
                        minute: '2-digit'
                    });
                }
            }
        },
        Body: {
            tag: 'div',
            margin: '0',
            fontSize: 'Z2',
            color: 'title',
            lineHeight: '1.5',
            wordBreak: 'break-word',
            onCreate: (el, s)=>$fc6ff45cb7441317$var$renderMarkdown(el, s.body || '', null, s.root && s.root.people),
            onUpdate: (el, s)=>$fc6ff45cb7441317$var$renderMarkdown(el, s.body || '', null, s.root && s.root.people)
        }
    }
};
// ── Dependencies panel ──────────────────────────────────────────
// Two lists in the modal sidebar:
//   • "Depends on"  — what this ticket is waiting for (blocks_by / waits_on_ship)
//   • "Blocks"      — tickets that depend on this one (inverse)
// Fetches via onUpdate when the currently-selected ticket id changes,
// caches result in `root._ticketDeps` keyed by ticket id to avoid
// re-fetching on every tick.
const $fc6ff45cb7441317$var$_kindColor = (kind)=>({
        blocked_by: 'red',
        blocks: 'orange',
        waits_on_ship: 'magenta',
        related: 'cyan'
    })[kind] || 'caption';
const $fc6ff45cb7441317$var$_kindLabel = (kind)=>({
        blocked_by: 'blocked by',
        blocks: 'blocks',
        waits_on_ship: 'waits-on-ship',
        related: 'related'
    })[kind] || kind;
const $fc6ff45cb7441317$var$_stateColor = (st)=>{
    if (st === 'done' || st === 'CLOSED' || st === 'closed') return 'green';
    if (st === 'in_progress') return 'yellow';
    if (st === 'blocked') return 'red';
    return 'caption';
};
const $fc6ff45cb7441317$export$a30217802e1895a9 = {
    display: (el, s)=>{
        const d = s.root._ticketDeps?.[s.root.selectedTicket?.id];
        return d && (d.outgoing.length || d.incoming.length) ? 'flex' : 'none';
    },
    flow: 'y',
    gap: 'Z',
    // onRender is one-shot and fires before selectedTicket is set (async URL-restore
    // race — see TicketsDetailModal.onCreate setInterval). onUpdate fires reactively
    // on every root state change. el._fetchedForId deduplicates per ticket id so we
    // never issue redundant requests when the root re-renders for unrelated updates.
    onUpdate: (el, s)=>{
        const id = s.root?.selectedTicket?.id;
        if (!id || el._fetchedForId === id) return;
        el._fetchedForId = id;
        const cache = s.root._ticketDeps || {};
        if (cache[id] && !cache[id]._loading) return;
        // Mark loading synchronously to de-dupe concurrent renders.
        s.root._ticketDeps = {
            ...cache,
            [id]: {
                outgoing: [],
                incoming: [],
                _loading: true
            }
        };
        $fc6ff45cb7441317$var$_fetchTicketDeps(id).then((deps)=>{
            // Only commit if still looking at the same ticket.
            if (s.root?.selectedTicket?.id !== id) return;
            s.root.update({
                _ticketDeps: {
                    ...s.root._ticketDeps || {},
                    [id]: deps
                }
            });
        });
    },
    CaptionTitle: {
        Text: {
            text: 'Dependencies'
        }
    },
    DependsOn: {
        display: (el, s)=>{
            const d = s.root._ticketDeps?.[s.root.selectedTicket?.id];
            return d?.outgoing?.length ? 'flex' : 'none';
        },
        flow: 'y',
        gap: 'Y',
        Label: {
            tag: 'span',
            fontSize: 'Y2',
            fontWeight: '600',
            color: 'caption',
            letterSpacing: '.04em',
            textTransform: 'uppercase',
            text: (el, s)=>{
                const d = s.root._ticketDeps?.[s.root.selectedTicket?.id];
                return `Depends on (${d?.outgoing?.length || 0})`;
            }
        },
        List: {
            flow: 'y',
            gap: 'V',
            childExtends: 'TicketDependencyRow',
            childrenAs: 'state',
            children: (el, s)=>s.root._ticketDeps?.[s.root.selectedTicket?.id]?.outgoing || []
        }
    },
    Blocks: {
        display: (el, s)=>{
            const d = s.root._ticketDeps?.[s.root.selectedTicket?.id];
            return d?.incoming?.length ? 'flex' : 'none';
        },
        flow: 'y',
        gap: 'Y',
        marginTop: 'Z',
        Label: {
            tag: 'span',
            fontSize: 'Y2',
            fontWeight: '600',
            color: 'caption',
            letterSpacing: '.04em',
            textTransform: 'uppercase',
            text: (el, s)=>{
                const d = s.root._ticketDeps?.[s.root.selectedTicket?.id];
                return `Blocks (${d?.incoming?.length || 0})`;
            }
        },
        List: {
            flow: 'y',
            gap: 'V',
            childExtends: 'TicketDependencyRow',
            childrenAs: 'state',
            children: (el, s)=>s.root._ticketDeps?.[s.root.selectedTicket?.id]?.incoming || []
        }
    }
};
const $fc6ff45cb7441317$var$_isDone = (state)=>state === 'done' || state === 'CLOSED' || state === 'closed';
const $fc6ff45cb7441317$export$625eba299d225744 = {
    flow: 'x',
    gap: 'Y',
    align: 'center left',
    padding: 'V Z',
    round: 'V',
    background: 'overlay',
    borderLeftWidth: '3px',
    borderLeftStyle: 'solid',
    borderLeftColor: (el, s)=>`var(--color-${$fc6ff45cb7441317$var$_kindColor(s.kind)})`,
    cursor: 'pointer',
    transition: 'background 0.12s ease',
    ':hover': {
        background: 'overlayStrong'
    },
    onClick: (e, el, s)=>{
        $fc6ff45cb7441317$var$_openTicketInModal(s.root || el.getRoot(), s.id, $fc6ff45cb7441317$var$_findModalFromEl(el));
    },
    Kind: {
        tag: 'span',
        flexShrink: '0',
        fontSize: 'Y2',
        fontWeight: '700',
        color: (el, s)=>$fc6ff45cb7441317$var$_kindColor(s.kind),
        text: (el, s)=>$fc6ff45cb7441317$var$_kindLabel(s.kind)
    },
    Ref: {
        tag: 'span',
        flexShrink: '0',
        fontSize: 'Y2',
        fontFamily: 'monospace',
        color: 'caption',
        text: (el, s)=>s.external_id || `#${s.id}`
    },
    Title: {
        tag: 'span',
        flex: '1',
        fontSize: 'Y2',
        color: (el, s)=>$fc6ff45cb7441317$var$_isDone(s.state) ? 'caption' : 'title',
        textDecoration: (el, s)=>$fc6ff45cb7441317$var$_isDone(s.state) ? 'line-through' : 'none',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        text: (el, s)=>(s.title || '').replace(/^B-\d+\s*·\s*/, '')
    },
    State: {
        tag: 'span',
        flexShrink: '0',
        fontSize: 'Y2',
        fontWeight: '600',
        color: (el, s)=>$fc6ff45cb7441317$var$_stateColor(s.state),
        text: (el, s)=>$fc6ff45cb7441317$var$_isDone(s.state) ? 'resolved' : (0, $7MNpT.formatStateLabel)(s.state)
    }
};
const $fc6ff45cb7441317$export$1ad85cd16d3a0f65 = {
    flow: 'x',
    gap: 'Z',
    align: 'center left',
    padding: 'Z A',
    round: 'Z2',
    background: 'overlay',
    borderLeftWidth: '3px',
    borderLeftStyle: 'solid',
    borderLeftColor: (el, s)=>`var(--color-${$fc6ff45cb7441317$var$_kindColor(s.kind)})`,
    cursor: 'pointer',
    transition: 'background 0.12s ease',
    ':hover': {
        background: 'overlayStrong'
    },
    onClick: (e, el, s)=>{
        $fc6ff45cb7441317$var$_openTicketInModal(s.root || el.getRoot(), s.id, $fc6ff45cb7441317$var$_findModalFromEl(el));
    },
    Ref: {
        tag: 'span',
        flexShrink: '0',
        fontSize: 'Y2',
        fontFamily: 'monospace',
        fontWeight: '600',
        color: 'caption',
        text: (el, s)=>s.external_id || `#${s.id}`
    },
    Title: {
        tag: 'span',
        flex: '1',
        fontSize: 'Z2',
        color: (el, s)=>$fc6ff45cb7441317$var$_isDone(s.state) ? 'caption' : 'title',
        textDecoration: (el, s)=>$fc6ff45cb7441317$var$_isDone(s.state) ? 'line-through' : 'none',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        text: (el, s)=>(s.title || '').replace(/^B-\d+\s*·\s*/, '')
    },
    KindChip: {
        tag: 'span',
        flexShrink: '0',
        fontSize: 'Y1',
        fontWeight: '700',
        letterSpacing: '.04em',
        padding: 'V Y',
        round: 'C',
        color: (el, s)=>$fc6ff45cb7441317$var$_kindColor(s.kind),
        background: (el, s)=>`color-mix(in srgb, var(--color-${$fc6ff45cb7441317$var$_kindColor(s.kind)}) 14%, transparent)`,
        text: (el, s)=>$fc6ff45cb7441317$var$_kindLabel(s.kind).toUpperCase()
    },
    StatePill: {
        tag: 'span',
        flexShrink: '0',
        fontSize: 'Y1',
        fontWeight: '700',
        letterSpacing: '.04em',
        padding: 'V Y',
        round: 'C',
        color: (el, s)=>$fc6ff45cb7441317$var$_stateColor(s.state),
        background: (el, s)=>`color-mix(in srgb, var(--color-${$fc6ff45cb7441317$var$_stateColor(s.state)}) 14%, transparent)`,
        text: (el, s)=>$fc6ff45cb7441317$var$_isDone(s.state) ? 'RESOLVED' : (0, $7MNpT.formatStateLabel)(s.state).toUpperCase()
    }
};

});

parcelRegister("e5Lqn", function(module, exports) {

$parcel$export(module.exports, "TicketsEpicsMain", () => $a42651d57546a80a$export$c635991d8cdf488f);
$parcel$export(module.exports, "TicketsEpicHeroStat", () => $a42651d57546a80a$export$39ca7ed6142fd03e);
$parcel$export(module.exports, "TicketsEpicCard", () => $a42651d57546a80a$export$3292953bc51e8c58);
// Epics index — renders s.root.epicsTree (from fetchEpicsTree).
// One card per post-B-117 product epic with rolled-up story / task /
// bug counts + a done-% progress bar.
const $a42651d57546a80a$export$c635991d8cdf488f = {
    extends: 'AppMain',
    Header: {
        extends: 'TicketsHeader'
    },
    Body: {
        overflow: 'auto',
        Hero: {
            extends: 'PageHero',
            eyebrow: "ROADMAP \xb7 PRODUCT EPICS \xb7 12 OF 13",
            headline: 'Epics',
            lede: (el, s)=>{
                const tree = s.root.epicsTree || [];
                if (!tree.length) return "Loading epics from public.tickets\u2026";
                const withContent = tree.filter((e)=>e.storiesTotal > 0).length;
                const leafCount = tree.reduce((a, e)=>a + e.tasksTotal + e.bugsTotal, 0);
                return `${tree.length} product epics \xb7 ${withContent} active \xb7 rolling up ${leafCount} tasks + bugs. (1 system epic hidden \u{2014} simona is an AI-assistant role, not a product category.)`;
            },
            Stats: {
                flow: 'x',
                gap: 'B',
                marginTop: 'Z',
                flexWrap: 'wrap',
                childExtends: 'TicketsEpicHeroStat',
                childrenAs: 'state',
                children: (el, s)=>{
                    const tree = s.root.epicsTree || [];
                    const tasks = tree.reduce((a, e)=>a + e.tasksTotal, 0);
                    const bugs = tree.reduce((a, e)=>a + e.bugsTotal, 0);
                    const total = tasks + bugs;
                    const done = tree.reduce((a, e)=>a + e.tasksDone + e.bugsDone, 0);
                    return [
                        {
                            label: 'epics (of 13)',
                            color: 'cyan',
                            value: tree.length
                        },
                        {
                            label: 'tasks',
                            color: 'magenta',
                            value: tasks
                        },
                        {
                            label: 'bugs',
                            color: 'red',
                            value: bugs
                        },
                        {
                            label: '% done',
                            color: 'green',
                            value: total ? Math.round(done / total * 100) : 0
                        }
                    ];
                }
            }
        },
        Grid: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
            gap: 'A',
            padding: 'C B1 D B1',
            maxWidth: 'L+L',
            width: '100%',
            margin: '0 auto',
            childExtends: 'TicketsEpicCard',
            childrenAs: 'state',
            children: (el, s)=>s.root.epicsTree || []
        },
        Empty: {
            hide: (el, s)=>(s.root.epicsTree || []).length > 0,
            flow: 'y',
            align: 'center center',
            gap: 'Z1',
            padding: 'D',
            color: 'caption',
            Text: {
                tag: 'p',
                text: 'No epics in public.tickets. Run seed-tickets-from-md.mjs to populate.'
            }
        }
    }
};
const $a42651d57546a80a$export$39ca7ed6142fd03e = {
    flow: 'x',
    gap: 'A',
    align: 'center left',
    paddingLeft: 'A',
    position: 'relative',
    Bar: {
        position: 'absolute',
        top: 'V',
        bottom: 'V',
        left: '0',
        width: '3px',
        round: 'V',
        background: (el, s)=>`var(--color-${s.color || 'cyan'})`,
        boxShadow: (el, s)=>`0 0 12px color-mix(in srgb, var(--color-${s.color || 'cyan'}) 50%, transparent)`
    },
    Stack: {
        flow: 'y',
        gap: 'V',
        Value: {
            tag: 'span',
            fontSize: 'D',
            fontWeight: '700',
            letterSpacing: '-.02em',
            lineHeight: '1',
            color: 'title',
            text: (el, s)=>String(s.value ?? 0)
        },
        Label: {
            tag: 'span',
            fontSize: 'V',
            fontWeight: '700',
            letterSpacing: '.12em',
            color: 'caption',
            text: (el, s)=>(s.label || '').toUpperCase()
        }
    }
};
const $a42651d57546a80a$export$3292953bc51e8c58 = {
    tag: 'div',
    flow: 'y',
    gap: 'V',
    padding: 'A',
    background: 'overlay',
    round: 'A',
    borderWidth: 'V',
    borderStyle: 'solid',
    borderColor: 'line',
    cursor: 'pointer',
    transition: 'border-color 0.15s ease, transform 0.15s ease',
    ':hover': {
        borderColor: 'title',
        transform: 'translateY(-2px)'
    },
    onClick: (e, el, s)=>{
        const root = s.root || el.getRoot();
        const path = `/tickets/general?epic=${encodeURIComponent(s.epicKey || '')}`;
        if (root && typeof root.update === 'function') root.update({
            filterEpic: s.epicKey || null
        });
        // Prefer SPA nav via root.router (el.router on a deep child fails
        // when context isn't fully threaded). Fall back to full nav.
        try {
            if (root && typeof root.router === 'function') {
                const p = root.router(path, root);
                if (p && typeof p.catch === 'function') p.catch(()=>{
                    window.location.href = path;
                });
                return;
            }
        } catch (_) {}
        if (typeof window !== 'undefined') window.location.href = path;
    },
    Head: {
        flow: 'x',
        align: 'center space-between',
        gap: 'V',
        Title: {
            tag: 'span',
            fontSize: 'A',
            fontWeight: '700',
            color: 'title',
            letterSpacing: '-.01em',
            text: (el, s)=>s.title || s.epicKey?.toUpperCase() || '?'
        },
        DonePct: {
            tag: 'span',
            flexShrink: '0',
            fontSize: 'Y2',
            fontWeight: '700',
            color: (el, s)=>(s.donePct || 0) >= 100 ? 'green' : 'caption',
            text: (el, s)=>`${s.donePct || 0}%`
        }
    },
    Key: {
        tag: 'span',
        fontSize: 'Y2',
        color: 'caption',
        fontWeight: '600',
        letterSpacing: '.06em',
        textTransform: 'uppercase',
        text: (el, s)=>s.epicKey || ''
    },
    Counts: {
        flow: 'x',
        gap: 'Z',
        marginTop: 'V',
        flexWrap: 'wrap',
        Stories: {
            hide: (el, s)=>!s.storiesTotal,
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            text: (el, s)=>`${s.storiesDone}/${s.storiesTotal} stories`
        },
        Tasks: {
            hide: (el, s)=>!s.tasksTotal,
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            text: (el, s)=>`${s.tasksDone}/${s.tasksTotal} tasks`
        },
        Bugs: {
            hide: (el, s)=>!s.bugsTotal,
            tag: 'span',
            fontSize: 'Y2',
            color: 'red',
            text: (el, s)=>`${s.bugsDone}/${s.bugsTotal} bugs`
        },
        EmptyNote: {
            hide: (el, s)=>s.tasksTotal + s.bugsTotal + s.storiesTotal > 0,
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            fontStyle: 'italic',
            text: 'no stories yet'
        }
    },
    Progress: {
        hide: (el, s)=>!(s.tasksTotal + s.bugsTotal),
        height: '4px',
        round: 'V',
        background: 'line',
        overflow: 'hidden',
        marginTop: 'V',
        Bar: {
            height: '100%',
            round: 'V',
            background: (el, s)=>(s.donePct || 0) >= 100 ? 'var(--color-green)' : 'var(--color-cyan)',
            width: (el, s)=>`${s.donePct || 0}%`,
            transition: 'width 0.25s ease'
        }
    }
};

});

parcelRegister("fbO43", function(module, exports) {

$parcel$export(module.exports, "TicketsMyViewMain", () => $b0eeb7d67fbf2e25$export$b7526de93a281572);
$parcel$export(module.exports, "TicketCardGrid", () => $b0eeb7d67fbf2e25$export$b739a736ddd01331);
$parcel$export(module.exports, "TicketCard", () => $b0eeb7d67fbf2e25$export$df9785630e217954);
$parcel$export(module.exports, "AwaitingApprovalRow", () => $b0eeb7d67fbf2e25$export$9d98439a03387e2a);
$parcel$export(module.exports, "TicketCardRequested", () => $b0eeb7d67fbf2e25$export$bbe78b91d7228b14);
// "My view" page main pane — ticket dashboard with two-column layout,
// toggleable queue, activity heatmap, and daily update prompt.

var $7MNpT = parcelRequire("7MNpT");
const $b0eeb7d67fbf2e25$var$_firstName = (el, root)=>{
    const me = el.call('findPerson', root.currentUserEmail);
    return (me?.name || '').split(' ')[0] || 'there';
};
const $b0eeb7d67fbf2e25$var$_me = (root)=>root?.currentUserEmail;
// Awaiting your approval: state='awaiting_approval' OR labels contains 'ASK-USER'
const $b0eeb7d67fbf2e25$var$_awaitingTickets = (root)=>(root.myTickets || []).filter((t)=>t.state === 'awaiting_approval' || Array.isArray(t.labels) && t.labels.includes('ASK-USER'));
// Working on: assigned to me + in an active column
const $b0eeb7d67fbf2e25$var$_workingTickets = (root)=>(root.myTickets || []).filter((t)=>(0, $7MNpT.isActiveColumn)(t.column_key) && t.assignee_email === $b0eeb7d67fbf2e25$var$_me(root));
// Requested: assigned to me by someone else, not yet active (backlog/todo)
const $b0eeb7d67fbf2e25$var$_requestedTickets = (root)=>(root.myTickets || []).filter((t)=>!(0, $7MNpT.isActiveColumn)(t.column_key) && t.column_key !== (0, $7MNpT.DONE_COLUMN_KEY) && t.reporter_email && t.reporter_email !== $b0eeb7d67fbf2e25$var$_me(root));
// Backlog: everything else not active and not done
const $b0eeb7d67fbf2e25$var$_backlogTickets = (root)=>(root.myTickets || []).filter((t)=>!(0, $7MNpT.isActiveColumn)(t.column_key) && t.column_key !== (0, $7MNpT.DONE_COLUMN_KEY));
// Relative age string — e.g. "3h ago", "2d ago", "just now"
const $b0eeb7d67fbf2e25$var$_relativeAge = (dateStr)=>{
    if (!dateStr) return '';
    const diff = Math.max(0, Date.now() - new Date(dateStr).getTime());
    const secs = Math.floor(diff / 1000);
    if (secs < 60) return 'just now';
    const mins = Math.floor(secs / 60);
    if (mins < 60) return `${mins}m ago`;
    const hours = Math.floor(mins / 60);
    if (hours < 24) return `${hours}h ago`;
    const days = Math.floor(hours / 24);
    return `${days}d ago`;
};
// Priority color token — mirrors the card helper but used in list rows
const $b0eeb7d67fbf2e25$var$_rowPriorityColor = (p)=>({
        critical: 'red',
        P0: 'red',
        urgent: 'red',
        high: 'orange',
        P1: 'orange',
        medium: 'blue',
        P2: 'blue',
        low: 'caption',
        P3: 'caption'
    })[p] || 'caption';
const $b0eeb7d67fbf2e25$export$b7526de93a281572 = {
    extends: 'AppMain',
    padding: '0',
    // Inject ASK-USER pulse keyframes once on mount.
    // Two named keyframes are registered so DOMQL's @media CSS prop pattern can
    // select the appropriate one: full opacity+scale pulse for users with no
    // motion preference, opacity-only fade for prefers-reduced-motion: reduce.
    onInit: (el)=>{
        if (typeof document === 'undefined') return;
        if (!document.querySelector('style[data-ask-user-kf]')) {
            const st = document.createElement('style');
            st.setAttribute('data-ask-user-kf', '');
            st.textContent = [
                '@keyframes askUserPulse {',
                '  0%, 100% { opacity: 1; transform: scale(1); }',
                '  50% { opacity: 0.35; transform: scale(0.97); }',
                '}',
                '@keyframes askUserPulseFade {',
                '  0%, 100% { opacity: 1; }',
                '  50% { opacity: 0.35; }',
                '}'
            ].join('\n');
            document.head.appendChild(st);
        }
    },
    Header: {
        extends: 'TicketsHeader'
    },
    Body: {
        overflow: 'auto',
        Hero: {
            extends: 'PageHero',
            eyebrow: "YOUR WORK \xb7 TODAY",
            headline: (el, s)=>`Hi ${$b0eeb7d67fbf2e25$var$_firstName(el, s.root)}.`,
            lede: (el, s)=>{
                const n = (s.root.myTickets || []).length;
                if (!n) return 'No open tickets assigned to you. Nice!';
                return `You have ${n} ticket${n === 1 ? '' : 's'} on your plate.`;
            }
        },
        Sections: {
            flow: 'y',
            gap: 'C',
            padding: 'C B1 D B1',
            maxWidth: 'L+L',
            width: '100%',
            margin: '0 auto',
            // ── Awaiting your approval (ASK-USER / awaiting_approval) ──
            // Always rendered so the empty-state confirmation is visible.
            // Border dims to a subtle line when nothing is pending.
            AwaitingApproval: {
                flow: 'y',
                gap: 'Z',
                round: 'A',
                padding: 'B',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: (el, s)=>$b0eeb7d67fbf2e25$var$_awaitingTickets(s.root).length ? 'yellow' : 'line',
                background: (el, s)=>$b0eeb7d67fbf2e25$var$_awaitingTickets(s.root).length ? 'yellow.06' : 'transparent',
                Header: {
                    flow: 'x',
                    align: 'center space-between',
                    gap: 'Z',
                    Left: {
                        flow: 'x',
                        align: 'center left',
                        gap: 'Z',
                        // "ASK USER" chip — visible only when decisions are pending
                        Chip: {
                            tag: 'span',
                            hide: (el, s)=>!$b0eeb7d67fbf2e25$var$_awaitingTickets(s.root).length,
                            fontSize: 'Y2',
                            fontWeight: '700',
                            padding: 'V Z',
                            round: 'C',
                            letterSpacing: '.04em',
                            background: 'yellow.15',
                            color: 'yellow',
                            text: 'ASK USER'
                        },
                        Title: {
                            fontSize: 'A',
                            fontWeight: '700',
                            color: (el, s)=>$b0eeb7d67fbf2e25$var$_awaitingTickets(s.root).length ? 'title' : 'caption',
                            text: 'Awaiting your approval'
                        }
                    },
                    Count: {
                        tag: 'span',
                        hide: (el, s)=>!$b0eeb7d67fbf2e25$var$_awaitingTickets(s.root).length,
                        fontSize: 'Y2',
                        color: 'yellow',
                        fontWeight: '600',
                        text: (el, s)=>{
                            const n = $b0eeb7d67fbf2e25$var$_awaitingTickets(s.root).length;
                            return `${n} pending`;
                        }
                    }
                },
                // Row list — one per pending decision (hidden when empty)
                Rows: {
                    flow: 'y',
                    gap: 'V',
                    hide: (el, s)=>!$b0eeb7d67fbf2e25$var$_awaitingTickets(s.root).length,
                    childExtends: 'AwaitingApprovalRow',
                    children: (el, s)=>$b0eeb7d67fbf2e25$var$_awaitingTickets(s.root),
                    childrenAs: 'state'
                },
                // Empty state — always rendered but hidden when rows exist
                Empty: {
                    hide: (el, s)=>!!$b0eeb7d67fbf2e25$var$_awaitingTickets(s.root).length,
                    padding: 'Z 0',
                    color: 'caption',
                    fontSize: 'Z2',
                    text: 'No decisions waiting on you'
                }
            },
            // ── Working on + Requested sections (full width, stacked) ──
            TopRow: {
                flow: 'y',
                gap: 'C',
                Working: {
                    extends: 'IconSection',
                    icon: 'animations',
                    intro: (s)=>{
                        const n = $b0eeb7d67fbf2e25$var$_workingTickets(s.root).length;
                        return [
                            {
                                text: 'Currently ',
                                color: 'caption'
                            },
                            {
                                text: 'working on',
                                color: 'cyan',
                                weight: '700'
                            },
                            {
                                text: ` \xb7 ${n} ticket${n === 1 ? '' : 's'}`,
                                color: 'caption'
                            }
                        ];
                    },
                    // Drop target — accept dragged tickets from queue
                    onDragOver: (e)=>{
                        e.preventDefault();
                        e.dataTransfer.dropEffect = 'move';
                    },
                    onDragEnter: (e, el)=>{
                        if (!el.node) return;
                        el.node.style.outline = '2px solid var(--color-blue)';
                        el.node.style.background = 'rgba(0, 133, 255, 0.06)';
                        el.node.style.borderRadius = 'var(--spacing-A)';
                    },
                    onDragLeave: (e, el)=>{
                        if (!el.node) return;
                        // Only clear if leaving the container entirely (not entering a child)
                        if (el.node.contains(e.relatedTarget)) return;
                        el.node.style.outline = '';
                        el.node.style.background = '';
                        el.node.style.borderRadius = '';
                    },
                    onDrop: (e, el, s)=>{
                        e.preventDefault();
                        if (el.node) {
                            el.node.style.outline = '';
                            el.node.style.background = '';
                            el.node.style.borderRadius = '';
                        }
                        const ticketId = parseInt(e.dataTransfer.getData('text/plain'), 10);
                        if (!ticketId) return;
                        el.call('moveTicket', {
                            ticketId: ticketId,
                            columnKey: '4d6ab783',
                            position: 0
                        });
                        const root = s.root;
                        root.update({
                            _dragTicketId: null,
                            myTickets: (root.myTickets || []).map((t)=>t.id === ticketId ? {
                                    ...t,
                                    column_key: '4d6ab783'
                                } : t)
                        });
                    },
                    Right: {
                        Body: {
                            extends: 'TicketCardGrid',
                            children: (el, s)=>$b0eeb7d67fbf2e25$var$_workingTickets(s.root),
                            childProps: {
                                background: 'white.06'
                            }
                        },
                        // Empty state when no tickets are in progress
                        Empty: {
                            hide: (el, s)=>$b0eeb7d67fbf2e25$var$_workingTickets(s.root).length > 0,
                            padding: 'B',
                            align: 'center center',
                            round: 'A',
                            borderWidth: '1px',
                            borderStyle: 'dashed',
                            borderColor: 'blue',
                            color: 'caption',
                            background: 'blue.04',
                            fontSize: 'Z2',
                            text: 'Drag a ticket here to start working'
                        }
                    }
                },
                Requested: {
                    extends: 'IconSection',
                    hide: (el, s)=>!$b0eeb7d67fbf2e25$var$_requestedTickets(s.root).length,
                    icon: 'bell',
                    intro: (s)=>{
                        const n = $b0eeb7d67fbf2e25$var$_requestedTickets(s.root).length;
                        return [
                            {
                                text: 'Others ',
                                color: 'caption'
                            },
                            {
                                text: 'asked you',
                                color: 'orange',
                                weight: '700'
                            },
                            {
                                text: ` \xb7 ${n} ticket${n === 1 ? '' : 's'}`,
                                color: 'caption'
                            }
                        ];
                    },
                    Right: {
                        Body: {
                            extends: 'TicketCardGrid',
                            childExtends: 'TicketCardRequested',
                            children: (el, s)=>$b0eeb7d67fbf2e25$var$_requestedTickets(s.root)
                        }
                    }
                }
            },
            // ── Toggleable queue ──
            Queue: {
                flow: 'y',
                gap: 'Z1',
                // Drop target — accept dragged tickets from Working on
                onDragOver: (e)=>{
                    e.preventDefault();
                    e.dataTransfer.dropEffect = 'move';
                },
                onDragEnter: (e, el)=>{
                    if (!el.node) return;
                    el.node.style.outline = '2px solid var(--color-blue)';
                    el.node.style.background = 'rgba(0, 133, 255, 0.06)';
                    el.node.style.borderRadius = 'var(--spacing-A)';
                },
                onDragLeave: (e, el)=>{
                    if (!el.node) return;
                    if (el.node.contains(e.relatedTarget)) return;
                    el.node.style.outline = '';
                    el.node.style.background = '';
                    el.node.style.borderRadius = '';
                },
                onDrop: (e, el, s)=>{
                    e.preventDefault();
                    if (el.node) {
                        el.node.style.outline = '';
                        el.node.style.background = '';
                        el.node.style.borderRadius = '';
                    }
                    const ticketId = parseInt(e.dataTransfer.getData('text/plain'), 10);
                    if (!ticketId) return;
                    el.call('moveTicket', {
                        ticketId: ticketId,
                        columnKey: 'backlog',
                        position: 0
                    });
                    s.root.update({
                        _dragTicketId: null,
                        myViewQueueOpen: true,
                        myTickets: (s.root.myTickets || []).map((t)=>t.id === ticketId ? {
                                ...t,
                                column_key: 'backlog'
                            } : t)
                    });
                },
                QueueHeader: {
                    flow: 'x',
                    align: 'center left',
                    gap: 'Z',
                    cursor: 'pointer',
                    padding: 'Z 0',
                    Caret: {
                        extends: 'Icon',
                        icon: 'arrowAngleDown',
                        boxSize: 'A',
                        color: 'caption',
                        transition: 'transform 120ms ease',
                        transform: (el, s)=>s.root?.myViewQueueOpen ? 'rotate(0deg)' : 'rotate(-90deg)'
                    },
                    CaptionTitle: {
                        fontSize: 'Y2',
                        Text: {
                            text: (el, s)=>{
                                const n = $b0eeb7d67fbf2e25$var$_backlogTickets(s.root).length;
                                return `UP NEXT \xb7 ${n} ticket${n === 1 ? '' : 's'}`;
                            }
                        }
                    },
                    onClick: (e, el, s)=>{
                        s.root.update({
                            myViewQueueOpen: !s.root.myViewQueueOpen
                        });
                    }
                },
                QueueBody: {
                    extends: 'TicketCardGrid',
                    show: (el, s)=>!!s.root?.myViewQueueOpen,
                    children: (el, s)=>$b0eeb7d67fbf2e25$var$_backlogTickets(s.root)
                }
            },
            Backlog: {
                flow: 'y',
                gap: 'Z1',
                BacklogHeader: {
                    flow: 'x',
                    align: 'center left',
                    gap: 'Z',
                    cursor: 'pointer',
                    padding: 'Z 0',
                    Caret: {
                        extends: 'Icon',
                        icon: 'arrowAngleDown',
                        boxSize: 'A',
                        color: 'caption',
                        transition: 'transform 120ms ease',
                        transform: (el, s)=>s.root?.myViewBacklogOpen ? 'rotate(0deg)' : 'rotate(-90deg)'
                    },
                    CaptionTitle: {
                        fontSize: 'Y2',
                        Text: {
                            text: (el, s)=>{
                                const n = $b0eeb7d67fbf2e25$var$_backlogTickets(s.root).length;
                                return `BACKLOG \xb7 ${n} ticket${n === 1 ? '' : 's'}`;
                            }
                        }
                    },
                    onClick: (e, el, s)=>{
                        s.root.update({
                            myViewBacklogOpen: !s.root.myViewBacklogOpen
                        });
                    }
                },
                BacklogBody: {
                    extends: 'TicketCardGrid',
                    show: (el, s)=>!!s.root?.myViewBacklogOpen,
                    children: (el, s)=>$b0eeb7d67fbf2e25$var$_backlogTickets(s.root)
                }
            },
            // ── Daily update ──
            TicketsDailyUpdate: {},
            // ── Activity heatmap ──
            TicketsActivityHeatmap: {}
        }
    }
};
const $b0eeb7d67fbf2e25$export$b739a736ddd01331 = {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: 'A',
    '@tabletS': {
        gridTemplateColumns: 'repeat(2, 1fr)'
    },
    '@mobileL': {
        gridTemplateColumns: '1fr'
    },
    childExtends: 'TicketCard',
    childrenAs: 'state'
};
const $b0eeb7d67fbf2e25$var$_priorityColor = (p)=>({
        critical: 'red',
        high: 'orange',
        medium: 'blue',
        low: 'caption'
    })[p] || 'caption';
// Column color overrides — user-preferred colors for key statuses
const $b0eeb7d67fbf2e25$var$_COLUMN_COLORS = {
    '4d6ab783': 'blue',
    '821cd85d': 'yellow',
    '20f135e3': 'cyan',
    'd677f7ee': 'orange',
    '2ea8dd8b': 'red',
    'eede5560': 'green' // Done → green
};
const $b0eeb7d67fbf2e25$var$_colColor = (el, s)=>{
    const override = $b0eeb7d67fbf2e25$var$_COLUMN_COLORS[s.column_key];
    if (override) return override;
    const col = (el.state?.root?.columns || []).find((c)=>c.key === s.column_key);
    return el.call('githubColorTokenFromName', col?.color || 'GRAY');
};
const $b0eeb7d67fbf2e25$export$df9785630e217954 = {
    flow: 'y',
    round: 'A',
    background: 'overlay',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'line',
    overflow: 'hidden',
    cursor: 'grab',
    draggable: 'true',
    onDragStart: (e, el, s)=>{
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text/plain', String(s.id));
        if (s.root) s.root.update({
            _dragTicketId: s.id
        });
    },
    onDragEnd: (e, el, s)=>{
        if (s.root) s.root.update({
            _dragTicketId: null
        });
    },
    transition: 'transform 200ms ease, border-color 200ms ease, box-shadow 200ms ease',
    ':hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 8px 24px -8px var(--color-shadow)'
    },
    attr: {
        'data-ticket-id': (el, s)=>String(s.id || '')
    },
    onClick: (e, el, s)=>{
        if (s.root) s.root.update({
            selectedTicket: s
        });
    },
    Content: {
        padding: 'A',
        flow: 'y',
        gap: 'Z',
        position: 'relative',
        flex: '1',
        Top: {
            flow: 'x',
            align: 'flex-start space-between',
            gap: 'Z',
            Title: {
                tag: 'h3',
                margin: '0',
                fontSize: 'A',
                fontWeight: '700',
                lineHeight: '1.3',
                color: 'title',
                flex: '1',
                text: (el, s)=>`#${s.number || s.id} \xb7 ${s.title || ''}`
            },
            Priority: {
                hide: (el, s)=>!s.priority,
                width: 'Y',
                height: 'Y',
                round: '100%',
                flexShrink: '0',
                marginTop: 'Z',
                background: (el, s)=>$b0eeb7d67fbf2e25$var$_priorityColor(s.priority),
                title: (el, s)=>s.priority || ''
            }
        },
        Meta: {
            flow: 'x',
            gap: 'Z',
            align: 'center left',
            wrap: 'wrap',
            Column: {
                tag: 'span',
                fontSize: 'Y1',
                fontWeight: '700',
                padding: 'V Z',
                round: 'C',
                letterSpacing: '.03em',
                background: (el, s)=>{
                    const color = $b0eeb7d67fbf2e25$var$_colColor(el, s);
                    return `color-mix(in srgb, var(--color-${color}) 20%, transparent)`;
                },
                color: (el, s)=>`var(--color-${$b0eeb7d67fbf2e25$var$_colColor(el, s)})`,
                text: (el, s)=>{
                    const col = (el.state?.root?.columns || []).find((c)=>c.key === s.column_key);
                    return col?.label || '';
                }
            },
            Repo: {
                hide: (el, s)=>!s.repository,
                tag: 'span',
                fontSize: 'Y2',
                color: 'caption',
                text: (el, s)=>s.repository || ''
            },
            Epic: {
                hide: (el, s)=>!s.epic_name,
                tag: 'span',
                fontSize: 'Y2',
                color: 'blue',
                fontWeight: '600',
                text: (el, s)=>s.epic_name || ''
            },
            IssueType: {
                hide: (el, s)=>!s.issue_type,
                tag: 'span',
                fontSize: 'Y2',
                color: 'caption',
                text: (el, s)=>s.issue_type || ''
            }
        },
        // Actions removed from Content — moved to card bottom edge
        Actions: null,
        Footer: {
            hide: (el, s)=>!s.assignee_email && !s.updated_at,
            flow: 'x',
            align: 'center space-between',
            marginTop: 'V',
            People: {
                flow: 'x',
                gap: 'Z',
                align: 'center left',
                flex: '1',
                Assignee: {
                    hide: (el, s)=>!s.assignee_email,
                    flow: 'x',
                    align: 'center left',
                    gap: 'V',
                    Avatar: {
                        tag: 'img',
                        width: 'Z1',
                        height: 'Z1',
                        round: '100%',
                        src: (el, s)=>{
                            const person = el.call('findPerson', s.assignee_email);
                            return el.call('avatarUrl', person?.name || s.assignee_email);
                        },
                        alt: (el, s)=>{
                            const person = el.call('findPerson', s.assignee_email);
                            return person?.name || s.assignee_email || '';
                        }
                    },
                    Name: {
                        tag: 'span',
                        fontSize: 'Y2',
                        color: 'caption',
                        text: (el, s)=>{
                            const person = el.call('findPerson', s.assignee_email);
                            return (person?.name || s.assignee_email || '').split(' ')[0];
                        }
                    }
                },
                RequesterSep: {
                    hide: (el, s)=>!s.reporter_email || s.reporter_email === s.assignee_email,
                    tag: 'span',
                    fontSize: 'Y2',
                    color: 'caption',
                    opacity: '.4',
                    text: "\u2190"
                },
                Requester: {
                    hide: (el, s)=>!s.reporter_email || s.reporter_email === s.assignee_email,
                    flow: 'x',
                    align: 'center left',
                    gap: 'V',
                    Avatar: {
                        tag: 'img',
                        width: 'Z1',
                        height: 'Z1',
                        round: '100%',
                        src: (el, s)=>{
                            const person = el.call('findPerson', s.reporter_email);
                            return el.call('avatarUrl', person?.name || s.reporter_email);
                        },
                        alt: (el, s)=>{
                            const person = el.call('findPerson', s.reporter_email);
                            return person?.name || s.reporter_email || '';
                        }
                    },
                    Name: {
                        tag: 'span',
                        fontSize: 'Y2',
                        color: 'caption',
                        text: (el, s)=>{
                            const person = el.call('findPerson', s.reporter_email);
                            return (person?.name || s.reporter_email || '').split(' ')[0];
                        }
                    }
                }
            },
            Updated: {
                hide: (el, s)=>!s.updated_at,
                tag: 'span',
                fontSize: 'Y2',
                color: 'caption',
                text: (el, s)=>s.updated_at ? s.updated_at.slice(0, 10) : ''
            }
        }
    },
    // Action bar — "Ready to Review" + "Later"
    ActionBar: {
        display: (el, s)=>(0, $7MNpT.isActiveColumn)(s.column_key) ? 'flex' : 'none',
        flow: 'x',
        width: '100%',
        marginTop: 'auto',
        borderTop: '1px solid var(--color-line)',
        ReviewBtn: {
            tag: 'button',
            type: 'button',
            flex: '1',
            align: 'center center',
            padding: 'Z1 0',
            fontSize: 'Y2',
            fontWeight: '600',
            border: 'none',
            cursor: 'pointer',
            round: '0',
            background: 'yellow.08',
            color: 'yellow',
            text: 'Ready to Review',
            ':hover': {
                background: 'yellow.15'
            },
            onClick: (e, el, s)=>{
                e.stopPropagation();
                el.call('moveTicket', {
                    ticketId: s.id,
                    columnKey: '821cd85d',
                    position: 0
                });
                s.root.update({
                    myTickets: (s.root.myTickets || []).map((t)=>t.id === s.id ? {
                            ...t,
                            column_key: '821cd85d'
                        } : t)
                });
            }
        },
        LaterBtn: {
            tag: 'button',
            type: 'button',
            flex: '1',
            align: 'center center',
            padding: 'Z1 0',
            fontSize: 'Y2',
            fontWeight: '600',
            border: 'none',
            borderLeft: '1px solid var(--color-line)',
            cursor: 'pointer',
            round: '0',
            background: 'transparent',
            color: 'caption',
            text: 'Later',
            ':hover': {
                background: 'overlay'
            },
            onClick: (e, el, s)=>{
                e.stopPropagation();
                el.call('moveTicket', {
                    ticketId: s.id,
                    columnKey: 'backlog',
                    position: 0
                });
                s.root.update({
                    myTickets: (s.root.myTickets || []).map((t)=>t.id === s.id ? {
                            ...t,
                            column_key: 'backlog'
                        } : t)
                });
            }
        }
    },
    // Start on — flush bottom edge button
    StartBtn: {
        tag: 'button',
        type: 'button',
        display: (el, s)=>(0, $7MNpT.isActiveColumn)(s.column_key) ? 'none' : 'flex',
        align: 'center center',
        width: '100%',
        padding: 'Z1 0',
        marginTop: 'auto',
        fontSize: 'Y2',
        fontWeight: '600',
        border: 'none',
        borderTop: '1px solid var(--color-line)',
        cursor: 'pointer',
        round: '0',
        background: 'blue.08',
        color: 'blue',
        text: 'Start on',
        ':hover': {
            background: 'blue.15'
        },
        transition: 'background 120ms ease',
        onClick: (e, el, s)=>{
            e.stopPropagation();
            el.call('moveTicket', {
                ticketId: s.id,
                columnKey: '4d6ab783',
                position: 0
            });
            const root = s.root;
            root.update({
                myTickets: (root.myTickets || []).map((t)=>t.id === s.id ? {
                        ...t,
                        column_key: '4d6ab783'
                    } : t)
            });
        }
    }
};
const $b0eeb7d67fbf2e25$export$9d98439a03387e2a = {
    tag: 'a',
    flow: 'x',
    align: 'center left',
    gap: 'Z',
    padding: 'Z1 B',
    round: 'A',
    background: 'yellow.04',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'yellow.2',
    cursor: 'pointer',
    textDecoration: 'none',
    transition: 'background 120ms ease, border-color 120ms ease',
    ':hover': {
        background: 'yellow.1',
        borderColor: 'yellow.4'
    },
    href: (el, s)=>`/tickets/canvas?ticket=${s.id || ''}`,
    // Pulsing amber left accent bar
    // animationName is split across two @media props (canonical pattern from GeneralMain.js:1434-1435)
    // to avoid the CSS source-order bug where a flat prop class wins over the compound @media class.
    // The @keyframes injection above registers both askUserPulse (full) and askUserPulseFade (reduced).
    Accent: {
        width: 'V',
        alignSelf: 'stretch',
        flexShrink: '0',
        round: 'V',
        background: 'yellow',
        animationDuration: '2s',
        animationTimingFunction: 'ease-in-out',
        animationIterationCount: 'infinite',
        animationFillMode: 'none',
        '@media (prefers-reduced-motion: no-preference)': {
            animationName: 'askUserPulse'
        },
        '@media (prefers-reduced-motion: reduce)': {
            animationName: 'askUserPulseFade'
        }
    },
    // Priority dot
    PriorityDot: {
        hide: (el, s)=>!s.priority,
        width: 'Z',
        height: 'Z',
        round: '100%',
        flexShrink: '0',
        background: (el, s)=>$b0eeb7d67fbf2e25$var$_rowPriorityColor(s.priority),
        title: (el, s)=>s.priority || ''
    },
    // Ticket number + title
    TitleText: {
        flex: '1',
        fontSize: 'A',
        fontWeight: '600',
        color: 'title',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        text: (el, s)=>`#${s.number || s.id} \xb7 ${s.title || ''}`
    },
    // Age timestamp
    Age: {
        tag: 'span',
        fontSize: 'Y2',
        color: 'yellow',
        fontWeight: '500',
        flexShrink: '0',
        text: (el, s)=>$b0eeb7d67fbf2e25$var$_relativeAge(s.updated_at || s.created_at)
    },
    // Open icon
    Arrow: {
        extends: 'Icon',
        icon: 'arrowAngleRight',
        boxSize: 'Z1',
        color: 'yellow',
        flexShrink: '0'
    }
};
const $b0eeb7d67fbf2e25$export$bbe78b91d7228b14 = {
    extends: 'TicketCard',
    Content: {
        Actions: {
            display: 'flex',
            ClaimBtn: {
                tag: 'button',
                type: 'button',
                fontSize: 'Y2',
                fontWeight: '600',
                padding: 'V Z',
                round: 'V',
                border: 'none',
                cursor: 'pointer',
                background: 'blue.15',
                color: 'blue',
                text: "Claim \xb7 Start working",
                ':hover': {
                    background: 'blue.25'
                },
                onClick: (e, el, s)=>{
                    e.stopPropagation();
                    // Move to In Progress column
                    el.call('moveTicket', {
                        ticketId: s.id,
                        columnKey: '4d6ab783',
                        position: 0
                    });
                    const root = s.root;
                    root.update({
                        myTickets: (root.myTickets || []).map((t)=>t.id === s.id ? {
                                ...t,
                                column_key: '4d6ab783'
                            } : t)
                    });
                }
            },
            DoneBtn: null,
            ReviewBtn: null
        }
    }
};

});

parcelRegister("c4gr5", function(module, exports) {

$parcel$export(module.exports, "GROUP_BY_OPTIONS", () => $8c929b926840afcd$export$eb59487232790c50);
$parcel$export(module.exports, "TriageSkeleton", () => $8c929b926840afcd$export$223b9332a80c0b26);
$parcel$export(module.exports, "TriageSectionSkeleton", () => $8c929b926840afcd$export$4ea17530b1dc5f65);
$parcel$export(module.exports, "TriageRetryCTA", () => $8c929b926840afcd$export$6d364ab09ed5fca5);
$parcel$export(module.exports, "VirtualSentinel", () => $8c929b926840afcd$export$35eb1d5daa3b0f46);
$parcel$export(module.exports, "TicketsGeneralMain", () => $8c929b926840afcd$export$54281b3c0e62f7c2);
$parcel$export(module.exports, "GroupByControl", () => $8c929b926840afcd$export$105069bf943db069);
$parcel$export(module.exports, "GroupByChip", () => $8c929b926840afcd$export$d03ad533fac309a4);
$parcel$export(module.exports, "TriageSection", () => $8c929b926840afcd$export$19c7979068c9f4b8);
$parcel$export(module.exports, "TriageGroup", () => $8c929b926840afcd$export$15a238f5a11579b2);
$parcel$export(module.exports, "TriageFlatGroup", () => $8c929b926840afcd$export$2f2bf9b4f2bd2231);
$parcel$export(module.exports, "TriageCard", () => $8c929b926840afcd$export$935638f8e4f19674);
$parcel$export(module.exports, "TriageLabelChip", () => $8c929b926840afcd$export$d97b03bc05f73e43);
$parcel$export(module.exports, "BlockerChip", () => $8c929b926840afcd$export$9e0710b47cbb3746);
$parcel$export(module.exports, "ReadyToTestRail", () => $8c929b926840afcd$export$f91a7245ef818879);
$parcel$export(module.exports, "ReadyToTestRow", () => $8c929b926840afcd$export$99fd3149661f48c0);
$parcel$export(module.exports, "AgentPulseRail", () => $8c929b926840afcd$export$91ed19f70e23011a);
$parcel$export(module.exports, "AgentPulseRow", () => $8c929b926840afcd$export$2baaea63f3b7002b);
$parcel$export(module.exports, "AgentIdleRow", () => $8c929b926840afcd$export$4f57016d3f6bcf02);
$parcel$export(module.exports, "BlockedSection", () => $8c929b926840afcd$export$9460b1684d6ad4d3);
$parcel$export(module.exports, "PendingApprovalsSection", () => $8c929b926840afcd$export$267665bd0441ca00);
$parcel$export(module.exports, "ApprovalRow", () => $8c929b926840afcd$export$dfab156867750a02);
$parcel$export(module.exports, "DecisionsSection", () => $8c929b926840afcd$export$ac89289774e0f7ef);
$parcel$export(module.exports, "DecisionRow", () => $8c929b926840afcd$export$c21fc1bdcf2cf87c);
$parcel$export(module.exports, "FilterChip", () => $8c929b926840afcd$export$4ebb06a5f191b0a9);
$parcel$export(module.exports, "TriageDensityToggle", () => $8c929b926840afcd$export$60985738ca283b0b);
$parcel$export(module.exports, "TriageQuickCreate", () => $8c929b926840afcd$export$1aeb75242765623);
$parcel$export(module.exports, "TriageSelectionActionBar", () => $8c929b926840afcd$export$89d86c8bd3903b20);
// Workspace triage page — three sections grouped by live activity,
// with optional groupBy modes (state/epic/assignee/priority/story/none).
// Right-hand rails: ReadyToTestRail + AgentPulseRail (live presence).
//
// Layer 1: TriageCard — full card with state/priority pills, assignee avatar,
//          parent breadcrumb, labels, last-activity, active indicator.
// Layer 2: Progress bar per card (state mapping + child-task ratio).
// Layer 3: GroupByControl segmented-control + keyboard shortcuts 1–6.
// Layer 4: AgentPulseRail — live presence rail with pulsing dots.
// Layer 5: Keyboard nav ↑/↓/←/→/Enter/Esc + multi-select + quick-create.
// Layer 6: Density toggle (Compact / Comfortable).
//
// Reads:
//   s.root.triage              { now, ongoing, upcoming, readyToTest, agentPresence }
//   s.root.filterAssignee      null | 'team' | 'agents' | 'me'
//   s.root.filterEpic          null | epicKey
//   s.root.generalGroupBy      'state'|'epic'|'assignee'|'priority'|'story'|'none'
//   s.root.densityMode         'comfortable' | 'compact'   (AC12)
//   s.root.selectedTicketIds   Array of selected ticket ids  (AC6 — stored as Array, Set used only locally)
//   s.root.kbFocusBucket       null | 'now'|'ongoing'|'upcoming'|'pendingApproval'
//   s.root.kbFocusIndex        number (index within bucket)

var $bfqVY = parcelRequire("bfqVY");

var $7MNpT = parcelRequire("7MNpT");

var $lB5wE = parcelRequire("lB5wE");
// ─── Shared helpers ───────────────────────────────────────────────────────────
const $8c929b926840afcd$var$_isAgentEmail = (e)=>/-agent@symbols\.app$/.test(e || '');
const $8c929b926840afcd$var$_isHumanApprovalNeeded = (t)=>!!(t && (t.labels || []).includes('human-approval-needed'));
const $8c929b926840afcd$var$_approveTicket = async (ticketId)=>{
    try {
        await (0, $bfqVY.getSDK)().execute('workspaceProject.tickets', 'update', {
            id: ticketId,
            payload: {
                state: 'in_progress',
                updated_at: new Date().toISOString()
            }
        });
    } catch (err) {
        console.error('[approveTicket]', err);
    }
};
const $8c929b926840afcd$var$_actorLabel = (t)=>{
    if (t.liveAgent) return t.liveAgent;
    if ($8c929b926840afcd$var$_isAgentEmail(t.assignee_email)) return (t.assignee_email || '').split('-agent')[0].toUpperCase();
    if (t.assignee_email) return t.assignee_email.split('@')[0];
    return 'unassigned';
};
const $8c929b926840afcd$var$_applyAssigneeFilter = (rows, filter, me)=>{
    if (!filter) return rows;
    const meLC = (me || '').toLowerCase();
    return rows.filter((t)=>{
        const e = (t.assignee_email || '').toLowerCase();
        if (filter === 'me') return meLC && e === meLC;
        if (filter === 'agents') return $8c929b926840afcd$var$_isAgentEmail(e);
        if (filter === 'team') return e && !$8c929b926840afcd$var$_isAgentEmail(e) && e !== meLC;
        return true;
    });
};
const $8c929b926840afcd$var$_applyEpicFilter = (rows, epicKey)=>{
    if (!epicKey) return rows;
    const wanted = String(epicKey).toLowerCase();
    return rows.filter((t)=>{
        const title = (t.parentEpicTitle || '').toLowerCase();
        return title === wanted || title.startsWith(wanted);
    });
};
const $8c929b926840afcd$var$_sectionRows = (s, key)=>{
    const raw = s.root.triage && s.root.triage[key] || [];
    const byAssignee = $8c929b926840afcd$var$_applyAssigneeFilter(raw, s.root.filterAssignee, s.root.me?.email);
    return $8c929b926840afcd$var$_applyEpicFilter(byAssignee, s.root.filterEpic);
};
const $8c929b926840afcd$var$_blockedRows = (s)=>{
    const raw = s.root.triage && s.root.triage.blocked || [];
    const byAssignee = $8c929b926840afcd$var$_applyAssigneeFilter(raw, s.root.filterAssignee, s.root.me?.email);
    return $8c929b926840afcd$var$_applyEpicFilter(byAssignee, s.root.filterEpic);
};
const $8c929b926840afcd$var$_pendingApprovalRows = (s)=>{
    const raw = s.root.triage && s.root.triage.pendingApproval || [];
    const byAssignee = $8c929b926840afcd$var$_applyAssigneeFilter(raw, s.root.filterAssignee, s.root.me?.email);
    return $8c929b926840afcd$var$_applyEpicFilter(byAssignee, s.root.filterEpic);
};
const $8c929b926840afcd$var$_decisionRows = (s)=>{
    const raw = s.root.triage && s.root.triage.decisions || [];
    const byAssignee = $8c929b926840afcd$var$_applyAssigneeFilter(raw, s.root.filterAssignee, s.root.me?.email);
    return $8c929b926840afcd$var$_applyEpicFilter(byAssignee, s.root.filterEpic);
};
const $8c929b926840afcd$var$_readyToTestRows = (s)=>{
    const raw = s.root.triage && s.root.triage.readyToTest || [];
    const byAssignee = $8c929b926840afcd$var$_applyAssigneeFilter(raw, s.root.filterAssignee, s.root.me?.email);
    return $8c929b926840afcd$var$_applyEpicFilter(byAssignee, s.root.filterEpic);
};
// Collect all triage rows across buckets for flat groupBy view.
const $8c929b926840afcd$var$_allRows = (s)=>{
    const all = [];
    for (const k of [
        'now',
        'ongoing',
        'blocked',
        'upcoming'
    ])for (const r of $8c929b926840afcd$var$_sectionRows(s, k))all.push({
        ...r,
        _bucket: k
    });
    return all;
};
// ─── Grouping logic ───────────────────────────────────────────────────────────
const $8c929b926840afcd$var$_groupByAssignee = (rows)=>{
    const groups = new Map();
    for (const t of rows){
        const key = t.liveAgent && `live:${t.liveAgent}` || t.assignee_email || 'unassigned';
        if (!groups.has(key)) groups.set(key, {
            groupKey: key,
            actor: $8c929b926840afcd$var$_actorLabel(t),
            groupLabel: $8c929b926840afcd$var$_actorLabel(t),
            isLive: !!t.liveAgent,
            isAgent: $8c929b926840afcd$var$_isAgentEmail(t.assignee_email),
            rows: []
        });
        groups.get(key).rows.push(t);
    }
    return Array.from(groups.values());
};
const $8c929b926840afcd$var$PRIORITY_ORDER = {
    P0: 0,
    P1: 1,
    P2: 2,
    P3: 3
};
const $8c929b926840afcd$var$_buildFlatGroups = (rows, groupBy)=>{
    if (!groupBy || groupBy === 'assignee') return $8c929b926840afcd$var$_groupByAssignee(rows);
    const groups = new Map();
    for (const t of rows){
        let key, label;
        if (groupBy === 'epic') {
            key = t.parentEpicTitle || 'unassigned-epic';
            label = t.parentEpicTitle || 'Unassigned to epic';
        } else if (groupBy === 'story') {
            key = t.parentStoryTitle || 'unassigned-story';
            label = t.parentStoryTitle || 'Unassigned to story';
        } else if (groupBy === 'priority') {
            key = t.priority || 'none';
            label = t.priority || 'No priority';
        } else {
            // 'none' — single flat group
            key = '__all__';
            label = 'All tickets';
        }
        if (!groups.has(key)) groups.set(key, {
            groupKey: key,
            groupLabel: label,
            actor: label,
            isLive: false,
            isAgent: false,
            rows: []
        });
        groups.get(key).rows.push(t);
    }
    const arr = Array.from(groups.values());
    if (groupBy === 'priority') arr.sort((a, b)=>($8c929b926840afcd$var$PRIORITY_ORDER[a.groupKey] ?? 9) - ($8c929b926840afcd$var$PRIORITY_ORDER[b.groupKey] ?? 9));
    return arr;
};
// ─── Agent pulse helpers ──────────────────────────────────────────────────────
const $8c929b926840afcd$var$PULSE_ACTIVE_MS = 300000 // < 5 min = pulsing
;
const $8c929b926840afcd$var$PULSE_IDLE_MS = 3600000 // 5–60 min = idle; > 60 min = stale
;
const $8c929b926840afcd$var$_agentAgeMs = (p)=>{
    if (!p.last_heartbeat) return Infinity;
    return Date.now() - new Date(p.last_heartbeat).getTime();
};
const $8c929b926840afcd$var$_pulsingAgents = (s)=>(s.root.triage && s.root.triage.agentPresence || []).filter((p)=>$8c929b926840afcd$var$_agentAgeMs(p) < $8c929b926840afcd$var$PULSE_ACTIVE_MS);
const $8c929b926840afcd$var$_idleAgents = (s)=>(s.root.triage && s.root.triage.agentPresence || []).filter((p)=>{
        const a = $8c929b926840afcd$var$_agentAgeMs(p);
        return a >= $8c929b926840afcd$var$PULSE_ACTIVE_MS && a < $8c929b926840afcd$var$PULSE_IDLE_MS;
    });
const $8c929b926840afcd$var$_staleAgents = (s)=>(s.root.triage && s.root.triage.agentPresence || []).filter((p)=>$8c929b926840afcd$var$_agentAgeMs(p) >= $8c929b926840afcd$var$PULSE_IDLE_MS);
const $8c929b926840afcd$var$_relativeTime = (isoStr)=>{
    if (!isoStr) return '';
    const ms = Date.now() - new Date(isoStr).getTime();
    const sec = Math.floor(ms / 1000);
    if (sec < 10) return 'just now';
    if (sec < 60) return `${sec}s ago`;
    const m = Math.floor(sec / 60);
    if (m < 60) return `${m}m ago`;
    const h = Math.floor(m / 60);
    if (h < 24) return `${h}h ago`;
    return `${Math.floor(h / 24)}d ago`;
};
const $8c929b926840afcd$export$eb59487232790c50 = [
    {
        groupKey: 'state',
        label: 'State'
    },
    {
        groupKey: 'epic',
        label: 'Epic'
    },
    {
        groupKey: 'assignee',
        label: 'Assignee'
    },
    {
        groupKey: 'priority',
        label: 'Priority'
    },
    {
        groupKey: 'story',
        label: 'Story'
    },
    {
        groupKey: 'none',
        label: 'None'
    }
];
const $8c929b926840afcd$var$_setGroupBy = (root, key)=>{
    root.update({
        generalGroupBy: key
    });
    if (typeof window !== 'undefined') {
        const u = new URL(window.location);
        u.searchParams.set('groupBy', key);
        window.history.replaceState(null, '', u);
    }
};
const $8c929b926840afcd$export$223b9332a80c0b26 = {
    flow: 'y',
    gap: 'Y',
    padding: 'Z A',
    background: 'overlay',
    round: 'Z1',
    borderWidth: 'V',
    borderStyle: 'solid',
    borderColor: 'line',
    opacity: '0',
    animation: 'triageFadeIn 0.15s ease forwards',
    onInit: (el)=>{
        if (typeof document === 'undefined') return;
        if (document.querySelector('style[data-triage-skeleton-kf]')) return;
        const st = document.createElement('style');
        st.setAttribute('data-triage-skeleton-kf', '');
        st.textContent = [
            '@keyframes triageFadeIn { from { opacity: 0 } to { opacity: 1 } }',
            '@keyframes skeletonShimmer {',
            '  0% { background-position: -200% 0 }',
            '  100% { background-position: 200% 0 }',
            '}'
        ].join('\n');
        document.head.appendChild(st);
    },
    TopRow: {
        flow: 'x',
        gap: 'Z',
        align: 'center left',
        // Pill widths as %/em values — skeleton proportions, not absolute dimensions
        Pill_1: {
            width: '3.5em',
            height: 'Z',
            round: 'C',
            background: 'line',
            animation: 'skeletonShimmer 1.5s linear infinite',
            backgroundSize: '200% 100%',
            backgroundImage: 'linear-gradient(90deg, var(--color-line) 25%, var(--color-overlay) 50%, var(--color-line) 75%)'
        },
        Pill_2: {
            width: '2.5em',
            height: 'Z',
            round: 'C',
            background: 'line',
            animation: 'skeletonShimmer 1.5s linear infinite 0.2s',
            backgroundSize: '200% 100%',
            backgroundImage: 'linear-gradient(90deg, var(--color-line) 25%, var(--color-overlay) 50%, var(--color-line) 75%)'
        }
    },
    TitleLine: {
        height: 'Z1',
        round: 'Y2',
        width: '80%',
        background: 'line',
        animation: 'skeletonShimmer 1.5s linear infinite 0.1s',
        backgroundSize: '200% 100%',
        backgroundImage: 'linear-gradient(90deg, var(--color-line) 25%, var(--color-overlay) 50%, var(--color-line) 75%)'
    },
    TitleLine2: {
        height: 'Z1',
        round: 'Y2',
        width: '55%',
        background: 'line',
        animation: 'skeletonShimmer 1.5s linear infinite 0.15s',
        backgroundSize: '200% 100%',
        backgroundImage: 'linear-gradient(90deg, var(--color-line) 25%, var(--color-overlay) 50%, var(--color-line) 75%)'
    },
    MetaLine: {
        height: 'Y1',
        round: 'Y2',
        width: '40%',
        background: 'line',
        animation: 'skeletonShimmer 1.5s linear infinite 0.25s',
        backgroundSize: '200% 100%',
        backgroundImage: 'linear-gradient(90deg, var(--color-line) 25%, var(--color-overlay) 50%, var(--color-line) 75%)'
    }
};
const $8c929b926840afcd$export$4ea17530b1dc5f65 = {
    flow: 'y',
    gap: 'A',
    // Ensure keyframes exist before any child references them.
    onInit: (el)=>{
        if (typeof document === 'undefined') return;
        if (document.querySelector('style[data-triage-skeleton-kf]')) return;
        const st = document.createElement('style');
        st.setAttribute('data-triage-skeleton-kf', '');
        st.textContent = [
            '@keyframes triageFadeIn { from { opacity: 0 } to { opacity: 1 } }',
            '@keyframes skeletonShimmer {',
            '  0% { background-position: -200% 0 }',
            '  100% { background-position: 200% 0 }',
            '}'
        ].join('\n');
        document.head.appendChild(st);
    },
    Header: {
        flow: 'x',
        gap: 'V',
        align: 'baseline left',
        paddingBottom: 'V',
        borderBottomWidth: 'V',
        borderBottomStyle: 'solid',
        borderBottomColor: 'line',
        Dot: {
            tag: 'span',
            width: 'Z',
            height: 'Z',
            round: 'round',
            flexShrink: '0',
            background: 'line'
        },
        TitleLine: {
            width: '5em',
            height: 'Z1',
            round: 'Y2',
            background: 'line',
            animation: 'skeletonShimmer 1.5s linear infinite',
            backgroundSize: '200% 100%',
            backgroundImage: 'linear-gradient(90deg, var(--color-line) 25%, var(--color-overlay) 50%, var(--color-line) 75%)'
        }
    },
    Cards: {
        flow: 'y',
        gap: 'V',
        SkeletonCard_1: {
            extends: 'TriageSkeleton'
        },
        SkeletonCard_2: {
            extends: 'TriageSkeleton'
        },
        SkeletonCard_3: {
            extends: 'TriageSkeleton'
        }
    }
};
const $8c929b926840afcd$export$6d364ab09ed5fca5 = {
    flow: 'y',
    gap: 'A',
    align: 'center center',
    padding: 'C B1',
    textAlign: 'center',
    Icon: {
        tag: 'span',
        fontSize: 'C',
        text: '!'
    },
    Message: {
        tag: 'p',
        margin: '0',
        fontSize: 'A',
        fontWeight: '600',
        color: 'title',
        text: 'Couldn\'t load tickets'
    },
    Sub: {
        tag: 'p',
        margin: '0',
        fontSize: 'Y1',
        color: 'caption',
        text: 'The request timed out. Check your connection and try again.'
    },
    RetryBtn: {
        tag: 'button',
        padding: 'Z A',
        round: 'Y2',
        border: 'none',
        cursor: 'pointer',
        fontSize: 'A',
        fontWeight: '700',
        background: 'cyan',
        color: 'white',
        text: 'Retry',
        onClick: (e, el, s)=>{
            const root = s.root || el.getRoot();
            if (!root) return;
            root.update({
                triageLoading: true,
                triageError: null
            });
            (0, $lB5wE.ticketStore).refresh().catch(()=>{
                root.update({
                    triageLoading: false,
                    triageError: 'timeout'
                });
            });
        }
    }
};
// ─── Virtualized card list ─────────────────────────────────────────────────────
//
// For buckets with many tickets, renders only VIRTUAL_BATCH visible cards
// initially. An IntersectionObserver on a sentinel at the bottom of the list
// triggers mounting the next batch when the user scrolls near the end.
//
// DOMQL-native: no third-party lib.
//
// v3.14 Reactive pattern (QA fix #4498):
//   Each TriageSection instance owns `state: { visN: VIRTUAL_INITIAL }`.
//   Groups.children reads `el.parent.state.visN` — a proper reactive signal —
//   so the createEffect in DOMQL v3.14 creates a live subscription. When
//   _expandSection updates `sectionEl.state.update({ visN: newVal })`, the
//   effect re-fires and reconciles the children array in place (keyed
//   childrenAs:'state' path in create.js).
//
//   The previous approach stored visN on root state under a dynamic key
//   (_visN_<sectionKey>). Because these keys did not exist at effect-creation
//   time, DOMQL's signal tracker had no subscription to trigger, so the
//   children factory never re-ran on expand — all rows rendered at once.
const $8c929b926840afcd$var$VIRTUAL_BATCH = 20 // cards to add per scroll event
;
const $8c929b926840afcd$var$VIRTUAL_INITIAL = 20 // cards to render on first paint
;
// Walk up from any descendant element to find the nearest TriageSection ancestor.
// Used by VirtualSentinel and MoreBtn which sit 2 levels below TriageSection.
const $8c929b926840afcd$var$_findTriageSection = (el)=>{
    // el = Sentinel  → el.parent = Footer  → el.parent.parent = TriageSection
    let cur = el.parent;
    while(cur){
        if (cur._isTriageSection) return cur;
        cur = cur.parent;
    }
    return null;
};
// Expand the visible window for a TriageSection by VIRTUAL_BATCH.
// Operates on the section element's own reactive state (not root state).
const $8c929b926840afcd$var$_expandSection = (sectionEl)=>{
    if (!sectionEl || !sectionEl.state) return;
    const cur = sectionEl.state.visN || $8c929b926840afcd$var$VIRTUAL_INITIAL;
    sectionEl.state.update({
        visN: cur + $8c929b926840afcd$var$VIRTUAL_BATCH
    });
};
const $8c929b926840afcd$export$35eb1d5daa3b0f46 = {
    height: '1px',
    width: '100%',
    flexShrink: '0',
    onInit: (el)=>{
        if (typeof IntersectionObserver === 'undefined') return;
        const sectionEl = $8c929b926840afcd$var$_findTriageSection(el);
        if (!sectionEl) return;
        el._observer = new IntersectionObserver((entries)=>{
            for (const entry of entries)if (entry.isIntersecting) $8c929b926840afcd$var$_expandSection(sectionEl);
        }, {
            rootMargin: '200px'
        });
        if (el.node) el._observer.observe(el.node);
    },
    onRemove: (el)=>{
        if (el._observer) {
            el._observer.disconnect();
            el._observer = null;
        }
    }
};
const $8c929b926840afcd$export$54281b3c0e62f7c2 = {
    extends: 'AppMain',
    // Inject @keyframes for agent-dot pulse + count-chip scale animations once on mount.
    onInit: (el, s)=>{
        if (typeof document === 'undefined') return;
        if (!document.querySelector('style[data-agent-dot-keyframes]')) {
            const st = document.createElement('style');
            st.setAttribute('data-agent-dot-keyframes', '');
            st.textContent = [
                '@keyframes agentDotPulse {',
                '  0%, 100% { transform: scale(1); opacity: 1; }',
                '  50% { transform: scale(1.4); opacity: 0.6; }',
                '}',
                '@keyframes agentDotFade {',
                '  0%, 100% { opacity: 1; }',
                '  50% { opacity: 0.4; }',
                '}'
            ].join('\n');
            document.head.appendChild(st);
        }
        // AC12: Inject density CSS rules so [data-density=compact] attribute
        // on the Layout container reduces card padding/gap regardless of whether
        // the reactive padding prop re-evaluates on childrenAs:state cards.
        if (!document.querySelector('style[data-density-rules]')) {
            const st3 = document.createElement('style');
            st3.setAttribute('data-density-rules', '');
            // AC12: target .triage-card class — DOMQL assigns data-key using the
            // sibling index ("0","1",...) for unkeyed childExtends children, so
            // [data-key="TriageCard"] never matches at runtime.  The explicit
            // class added to TriageCard is stable regardless of render position.
            st3.textContent = [
                '[data-density="compact"] .triage-card {',
                '  padding-top: var(--spacing-Y) !important;',
                '  padding-bottom: var(--spacing-Y) !important;',
                '  gap: var(--spacing-Y) !important;',
                '}',
                '[data-density="compact"] .triage-card [data-key="ProgressBar"] {',
                '  margin-top: var(--spacing-V) !important;',
                '}',
                '[data-density="compact"] .triage-card [data-key="Labels"] {',
                '  display: none !important;',
                '}'
            ].join('\n');
            document.head.appendChild(st3);
        }
        // Keyframes for AC7/AC13: count chip scale bump on realtime delta.
        if (!document.querySelector('style[data-count-bump-kf]')) {
            const st2 = document.createElement('style');
            st2.setAttribute('data-count-bump-kf', '');
            st2.textContent = [
                '@keyframes countBump {',
                '  0% { transform: scale(1); }',
                '  40% { transform: scale(1.1); }',
                '  100% { transform: scale(1); }',
                '}',
                '@keyframes countBumpReduced {',
                '  0% { opacity: 1; }',
                '  50% { opacity: 0.7; }',
                '  100% { opacity: 1; }',
                '}'
            ].join('\n');
            document.head.appendChild(st2);
        }
        // Initialise density + selection state
        const root = s.root || el.getRoot();
        if (root && !root.densityMode) root.update({
            densityMode: 'comfortable'
        });
        if (root && !root.selectedTicketIds) root.update({
            selectedTicketIds: []
        });
        if (root && root.kbFocusBucket === undefined) root.update({
            kbFocusBucket: null,
            kbFocusIndex: 0
        });
        // Global keyboard shortcuts — 'c' for quick-create, Esc to clear selection/focus
        if (typeof window !== 'undefined' && !window.__smblsTriageKbGlobal) {
            window.__smblsTriageKbGlobal = true;
            const globalHandler = (e)=>{
                const tag = (e.target?.tagName || '').toLowerCase();
                const isInput = tag === 'input' || tag === 'textarea' || tag === 'select' || e.target?.contentEditable === 'true';
                if (isInput) return;
                if (e.key === 'c' && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
                    // AC11: Focus quick-create input in active bucket
                    const qc = document.querySelector('[data-quick-create-input]');
                    if (qc) {
                        e.preventDefault();
                        qc.focus();
                    }
                    return;
                }
                if (e.key === 'Escape') {
                    const rootEl = el.getRoot();
                    if (rootEl) rootEl.update({
                        selectedTicketIds: [],
                        selectedTicket: null,
                        kbFocusBucket: null,
                        kbFocusIndex: 0
                    });
                    // AC5: clear ?ticket= URL param unconditionally — safe no-op when absent.
                    // Do NOT gate on rootEl.selectedTicket: when the modal was opened via
                    // ?ticket= URL param, selectedTicket may be falsy in this closure even
                    // though the modal is visible (sibling subtree updated root.selectedTicket
                    // after this handler was registered).
                    if (typeof window !== 'undefined') {
                        const _u = new URL(window.location);
                        if (_u.searchParams.has('ticket')) {
                            _u.searchParams.delete('ticket');
                            window.history.replaceState(null, '', _u);
                        }
                    }
                    return;
                }
                // Arrow-key navigation — only when not in an input
                const rootEl = el.getRoot();
                if (!rootEl) return;
                const BUCKETS_ORDER = [
                    'pendingApproval',
                    'now',
                    'ongoing',
                    'blocked',
                    'upcoming'
                ];
                const triage = rootEl.triage;
                if (!triage) return;
                const _getBucketRows = (bk)=>{
                    const raw = triage[bk] || [];
                    return raw;
                };
                let bk = rootEl.kbFocusBucket || 'now';
                let idx = rootEl.kbFocusIndex || 0;
                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    const rows = _getBucketRows(bk);
                    idx = Math.min(idx + 1, rows.length - 1);
                    rootEl.update({
                        kbFocusBucket: bk,
                        kbFocusIndex: idx
                    });
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    idx = Math.max(idx - 1, 0);
                    rootEl.update({
                        kbFocusBucket: bk,
                        kbFocusIndex: idx
                    });
                } else if (e.key === 'ArrowRight') {
                    e.preventDefault();
                    const cur = BUCKETS_ORDER.indexOf(bk);
                    const next = BUCKETS_ORDER[Math.min(cur + 1, BUCKETS_ORDER.length - 1)];
                    rootEl.update({
                        kbFocusBucket: next,
                        kbFocusIndex: 0
                    });
                } else if (e.key === 'ArrowLeft') {
                    e.preventDefault();
                    const cur = BUCKETS_ORDER.indexOf(bk);
                    const prev = BUCKETS_ORDER[Math.max(cur - 1, 0)];
                    rootEl.update({
                        kbFocusBucket: prev,
                        kbFocusIndex: 0
                    });
                } else if (e.key === 'Enter') {
                    e.preventDefault();
                    const rows = _getBucketRows(bk);
                    const ticket = rows[idx];
                    if (ticket) rootEl.update({
                        selectedTicket: {
                            ...ticket
                        }
                    });
                }
            };
            window.addEventListener('keydown', globalHandler);
            el._globalKbHandler = globalHandler;
        }
    },
    onRemove: (el)=>{
        if (typeof window !== 'undefined' && el._globalKbHandler) {
            window.removeEventListener('keydown', el._globalKbHandler);
            el._globalKbHandler = null;
            window.__smblsTriageKbGlobal = false;
        }
    },
    Header: {
        extends: 'TicketsHeader'
    },
    Body: {
        overflow: 'auto',
        Hero: {
            extends: 'PageHero',
            eyebrow: "WORKSPACE \xb7 LIVE TRIAGE",
            headline: 'General',
            lede: (el, s)=>{
                const t = s.root.triage;
                if (s.root.triageLoading && !t) return "Loading triage\u2026";
                if (s.root.triageError) return "Failed to load triage \u2014 see retry below";
                if (!t) return "Loading triage\u2026";
                const n = (key)=>$8c929b926840afcd$var$_sectionRows(s, key).length;
                const ready = $8c929b926840afcd$var$_readyToTestRows(s).length;
                const pending = $8c929b926840afcd$var$_pendingApprovalRows(s).length;
                const blocked = $8c929b926840afcd$var$_blockedRows(s).length;
                const decisions = $8c929b926840afcd$var$_decisionRows(s).length;
                const scope = s.root.filterEpic ? `epic:${s.root.filterEpic}` : s.root.filterAssignee || 'all';
                const pendingStr = pending > 0 ? ` \xb7 ${pending} pending approval` : '';
                const blockedStr = blocked > 0 ? ` \xb7 ${blocked} blocked` : '';
                const decisionsStr = decisions > 0 ? ` \xb7 ${decisions} decisions` : '';
                return `${n('now')} now \xb7 ${n('ongoing')} ongoing${blockedStr} \xb7 ${n('upcoming')} upcoming \xb7 ${ready} ready-to-test${pendingStr}${decisionsStr} (scope: ${scope})`;
            },
            EpicChip: {
                hide: (el, s)=>!s.root.filterEpic,
                flow: 'x',
                gap: 'Z',
                align: 'center left',
                marginTop: 'Z',
                fontSize: 'Y1',
                Label: {
                    tag: 'span',
                    padding: 'V Z',
                    round: 'V',
                    background: 'cyan.15',
                    color: 'cyan',
                    fontWeight: '700',
                    text: (el, s)=>`epic: ${s.root.filterEpic}`
                },
                Clear: {
                    tag: 'button',
                    padding: 'V Z',
                    round: 'V',
                    border: 'none',
                    cursor: 'pointer',
                    background: 'line',
                    color: 'title',
                    fontSize: 'Y2',
                    fontWeight: '600',
                    text: 'clear',
                    onClick: (e, el, s)=>{
                        const root = s.root || el.getRoot();
                        if (!root) return;
                        root.update({
                            filterEpic: null
                        });
                        if (typeof window !== 'undefined') {
                            const u = new URL(window.location);
                            u.searchParams.delete('epic');
                            window.history.replaceState(null, '', u);
                        }
                    }
                }
            }
        },
        // AC12: Density toggle + Layer 3: Group-by control bar
        ControlRow: {
            flow: 'x',
            align: 'center space-between',
            padding: 'Z B1',
            gap: 'A',
            borderBottomWidth: 'V',
            borderBottomStyle: 'solid',
            borderBottomColor: 'line',
            maxWidth: 'L+L',
            width: '100%',
            margin: '0 auto',
            GroupByBar: {
                extends: 'GroupByControl',
                padding: '0',
                border: 'none',
                margin: '0',
                maxWidth: 'none'
            },
            DensityToggle: {
                extends: 'TriageDensityToggle'
            }
        },
        Layout: {
            display: 'grid',
            gap: 'B',
            padding: 'C B1 D B1',
            maxWidth: 'L+L',
            width: '100%',
            margin: '0 auto',
            alignItems: 'flex-start',
            // AC12: propagate density as a DOM attribute so CSS rules injected in
            // onInit (data-density-rules) can target cards regardless of whether
            // their reactive padding prop re-evaluates on childrenAs:state children.
            'data-density': (el, s)=>s.root.densityMode || 'comfortable',
            // Two-column layout at >=1280px: main content + 280px right rail.
            // Implemented via JS-driven state (viewportWidth) rather than @media CSS
            // because DOMQL's atomic CSS engine does not reliably emit @media compound
            // classes when a same-property flat class exists in the stylesheet
            // (source-order bug confirmed across QA failures #1 and #2, tickets 4386/4455).
            // Framework fix tracked in ticket 4472; this workaround is the app-side guard.
            gridTemplateColumns: (el, s)=>(s.root.viewportWidth || (typeof window !== 'undefined' ? window.innerWidth : 0)) >= 1280 ? '1fr 280px' : '1fr',
            onInit: (el, s)=>{
                if (typeof window === 'undefined') return;
                const handler = ()=>{
                    const root = s.root || el.getRoot();
                    if (root && typeof root.update === 'function') root.update({
                        viewportWidth: window.innerWidth
                    });
                };
                // Set initial value immediately
                handler();
                window.addEventListener('resize', handler, {
                    passive: true
                });
                el._layoutResizeHandler = handler;
            },
            onRemove: (el)=>{
                if (typeof window !== 'undefined' && el._layoutResizeHandler) {
                    window.removeEventListener('resize', el._layoutResizeHandler);
                    el._layoutResizeHandler = null;
                }
            },
            Sections: {
                flow: 'y',
                gap: 'C',
                minWidth: '0',
                // Loading skeleton — shown while first fetch is in-flight.
                // Fades out when triage data arrives. Per spec E: no page-wide spinner.
                LoadingSkeleton: {
                    hide: (el, s)=>!!(s.root.triage || s.root.triageError),
                    flow: 'y',
                    gap: 'C',
                    SkeletonNow: {
                        extends: 'TriageSectionSkeleton'
                    },
                    SkeletonOngoing: {
                        extends: 'TriageSectionSkeleton'
                    }
                },
                // Retry CTA — shown when fetch times out (spec F).
                RetryCTA: {
                    hide: (el, s)=>!s.root.triageError,
                    extends: 'TriageRetryCTA'
                },
                // Main content — hidden until triage is available.
                TriageContent: {
                    hide: (el, s)=>!s.root.triage,
                    flow: 'y',
                    gap: 'C',
                    // AC11: Quick-create input at top of sections
                    QuickCreate: {
                        extends: 'TriageQuickCreate'
                    },
                    PendingApprovals: {
                        extends: 'PendingApprovalsSection'
                    },
                    Decisions: {
                        extends: 'DecisionsSection'
                    },
                    // State-grouped view (default)
                    StateSections: {
                        flow: 'y',
                        gap: 'C',
                        hide: (el, s)=>!!(s.root.generalGroupBy && s.root.generalGroupBy !== 'state'),
                        Now: {
                            extends: 'TriageSection',
                            sectionKey: 'now',
                            accent: 'green',
                            title: 'Now',
                            subtitle: "Agents actively working right now \xb7 live heartbeat < 10m"
                        },
                        Ongoing: {
                            extends: 'TriageSection',
                            sectionKey: 'ongoing',
                            accent: 'yellow',
                            title: 'Ongoing',
                            subtitle: "Picked up but no live heartbeat \xb7 agent paused or between ticks"
                        },
                        Blocked: {
                            extends: 'BlockedSection'
                        },
                        Upcoming: {
                            extends: 'TriageSection',
                            sectionKey: 'upcoming',
                            accent: 'cyan',
                            title: 'Upcoming',
                            subtitle: "Assigned but not yet picked up \xb7 ranked by priority"
                        }
                    },
                    // Flat grouped view (non-state groupings)
                    FlatView: {
                        flow: 'y',
                        gap: 'C',
                        hide: (el, s)=>!s.root.generalGroupBy || s.root.generalGroupBy === 'state',
                        Groups: {
                            flow: 'y',
                            gap: 'C',
                            childExtends: 'TriageFlatGroup',
                            childrenAs: 'state',
                            children: (el, s)=>$8c929b926840afcd$var$_buildFlatGroups($8c929b926840afcd$var$_allRows(s), s.root.generalGroupBy || 'none')
                        }
                    }
                }
            },
            RightRails: {
                flow: 'y',
                gap: 'B',
                minWidth: '0',
                // AC4: sticky-top alignment — alignSelf flex-start ensures sticky context is the grid cell
                alignSelf: 'flex-start',
                position: (el, s)=>(s.root.viewportWidth || (typeof window !== 'undefined' ? window.innerWidth : 0)) >= 1280 ? 'sticky' : 'static',
                top: (el, s)=>(s.root.viewportWidth || (typeof window !== 'undefined' ? window.innerWidth : 0)) >= 1280 ? 'var(--spacing-A)' : 'auto',
                // Right rails hidden below 1280px via parent grid collapse
                ReadyRail: {
                    extends: 'ReadyToTestRail'
                },
                AgentRail: {
                    extends: 'AgentPulseRail'
                }
            }
        }
    },
    // AC6: Multi-select action bar — fixed at viewport bottom when tickets selected
    SelectionBar: {
        extends: 'TriageSelectionActionBar'
    }
};
const $8c929b926840afcd$export$105069bf943db069 = {
    flow: 'x',
    gap: 'Z',
    align: 'center left',
    padding: 'Z B1',
    borderBottomWidth: 'V',
    borderBottomStyle: 'solid',
    borderBottomColor: 'line',
    flexWrap: 'wrap',
    maxWidth: 'L+L',
    width: '100%',
    margin: '0 auto',
    onInit: (el, s)=>{
        if (typeof window === 'undefined') return;
        const handler = (e)=>{
            const tag = (e.target?.tagName || '').toLowerCase();
            if (tag === 'input' || tag === 'textarea' || tag === 'select') return;
            const idx = parseInt(e.key, 10) - 1;
            if (idx >= 0 && idx < $8c929b926840afcd$export$eb59487232790c50.length) {
                const root = s.root || el.getRoot();
                if (root) $8c929b926840afcd$var$_setGroupBy(root, $8c929b926840afcd$export$eb59487232790c50[idx].groupKey);
            }
        };
        window.addEventListener('keydown', handler);
        el._groupByKbHandler = handler;
    },
    onRemove: (el)=>{
        if (typeof window !== 'undefined' && el._groupByKbHandler) {
            window.removeEventListener('keydown', el._groupByKbHandler);
            el._groupByKbHandler = null;
        }
    },
    Label: {
        tag: 'span',
        fontSize: 'Y2',
        color: 'caption',
        fontWeight: '500',
        letterSpacing: '.04em',
        text: 'Group by'
    },
    // Segmented control container — single rounded pill wrapping all options.
    // Borders between segments are created via right-border on each non-last item.
    SegmentedGroup: {
        flow: 'x',
        round: 'Z',
        overflow: 'hidden',
        borderWidth: 'V',
        borderStyle: 'solid',
        borderColor: 'line',
        childExtends: 'GroupByChip',
        childrenAs: 'state',
        children: (el, s)=>$8c929b926840afcd$export$eb59487232790c50.map((opt, i)=>({
                    ...opt,
                    _index: i + 1,
                    _isLast: i === $8c929b926840afcd$export$eb59487232790c50.length - 1,
                    isActive: (s.root.generalGroupBy || 'state') === opt.groupKey
                }))
    }
};
const $8c929b926840afcd$export$d03ad533fac309a4 = {
    tag: 'button',
    flow: 'x',
    gap: 'Y',
    align: 'center center',
    padding: 'Y Z',
    fontSize: 'Y2',
    fontWeight: (el, s)=>s.isActive ? '700' : '500',
    cursor: 'pointer',
    border: 'none',
    borderRightWidth: (el, s)=>s._isLast ? '0' : 'V',
    borderRightStyle: 'solid',
    borderRightColor: 'line',
    background: (el, s)=>s.isActive ? 'cyan.15' : 'transparent',
    color: (el, s)=>s.isActive ? 'cyan' : 'caption',
    transition: 'background 0.12s ease, color 0.12s ease',
    ':hover': {
        background: (el, s)=>s.isActive ? 'cyan.15' : 'overlay',
        color: (el, s)=>s.isActive ? 'cyan' : 'title'
    },
    title: (el, s)=>`Group by ${s.label} (press ${s._index})`,
    Text: {
        tag: 'span',
        text: (el, s)=>s.label
    },
    // Keyboard shortcut rendered as a styled kbd badge — separate from label text
    Shortcut: {
        tag: 'kbd',
        fontSize: 'V',
        fontWeight: '600',
        padding: 'V Y',
        round: 'Y',
        lineHeight: '1',
        color: (el, s)=>s.isActive ? 'cyan' : 'caption',
        background: (el, s)=>s.isActive ? 'cyan.08' : 'line',
        borderWidth: 'V',
        borderStyle: 'solid',
        borderColor: (el, s)=>s.isActive ? 'cyan.3' : 'overlayStrong',
        fontFamily: 'monospace',
        text: (el, s)=>`${s._index}`
    },
    onClick: (e, el, s)=>{
        const root = s.root || el.getRoot();
        if (root) $8c929b926840afcd$var$_setGroupBy(root, s.groupKey);
    }
};
const $8c929b926840afcd$export$19c7979068c9f4b8 = {
    flow: 'y',
    gap: 'A',
    // Each instance owns its own reactive state for virtualization.
    // visN is the visible-card count; initialized to VIRTUAL_INITIAL.
    // Groups.children reads el.parent.state.visN — this creates a proper
    // reactive subscription in DOMQL v3.14's createEffect so expand triggers re-render.
    state: {
        visN: $8c929b926840afcd$var$VIRTUAL_INITIAL
    },
    // Marker flag so _findTriageSection can locate this element imperatively.
    _isTriageSection: true,
    onInit: (el)=>{
        // Ensure visN is set (defensive: state may already be initialized from
        // extends chain; only set if missing so we don't clobber an expansion).
        if (el.state && el.state.visN === undefined) el.state.update({
            visN: $8c929b926840afcd$var$VIRTUAL_INITIAL
        });
    },
    hide: (el, s)=>$8c929b926840afcd$var$_sectionRows(s, el.sectionKey).length === 0,
    // Semantic left-border accent stripe per bucket (token-based, no raw px).
    // The accent color is passed as a prop from the parent bucket definition:
    //   Now → green, Ongoing → yellow, Upcoming → cyan (see TicketsGeneralMain).
    borderLeftWidth: 'V',
    borderLeftStyle: 'solid',
    borderLeftColor: (el, s)=>`var(--color-${el.accent || 'line'})`,
    paddingLeft: 'A',
    Header: {
        flow: 'x',
        gap: 'Z',
        align: 'center left',
        paddingBottom: 'Z',
        marginBottom: 'V',
        borderBottomWidth: 'V',
        borderBottomStyle: 'solid',
        borderBottomColor: 'line',
        // Accent dot — sized with spacing token Z (≈8px in golden ratio scale at base:17)
        Dot: {
            tag: 'span',
            width: 'Z',
            height: 'Z',
            round: 'round',
            flexShrink: '0',
            alignSelf: 'center',
            background: (el, s)=>`var(--color-${el.parent.parent.accent || 'cyan'})`,
            boxShadow: (el, s)=>`0 0 10px color-mix(in srgb, var(--color-${el.parent.parent.accent || 'cyan'}) 55%, transparent)`
        },
        Title: {
            tag: 'h2',
            fontSize: 'A',
            fontWeight: '700',
            letterSpacing: '-.02em',
            color: 'title',
            margin: '0',
            lineHeight: '1.2',
            text: (el, s)=>el.parent.parent.title || ''
        },
        // AC7/AC13: Count chip with scale-bump animation on realtime delta.
        // Tracks previous count on el._prevCount; on change, fires a CSS animation
        // via node.style (one-time transient, cleared after animation).
        // prefers-reduced-motion guard: use opacity fade instead of scale.
        Count: {
            tag: 'span',
            fontSize: 'Y2',
            fontWeight: '700',
            padding: 'V Y',
            round: 'C',
            display: 'inline-block',
            transformOrigin: 'center center',
            color: (el, s)=>`var(--color-${el.parent.parent.accent || 'cyan'})`,
            background: (el, s)=>`color-mix(in srgb, var(--color-${el.parent.parent.accent || 'cyan'}) 12%, transparent)`,
            text: (el, s)=>{
                const n = $8c929b926840afcd$var$_sectionRows(s, el.parent.parent.sectionKey).length;
                // Trigger bump animation when count changes
                if (typeof el._prevCount === 'number' && el._prevCount !== n && el.node) {
                    const prefersReduced = typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
                    const animName = prefersReduced ? 'countBumpReduced' : 'countBump';
                    el.node.style.animation = 'none';
                    // Reflow to restart animation
                    el.node.offsetWidth;
                    el.node.style.animation = `${animName} 0.3s ease`;
                    el.node.addEventListener('animationend', ()=>{
                        if (el.node) el.node.style.animation = '';
                    }, {
                        once: true
                    });
                }
                el._prevCount = n;
                return `${n}`;
            }
        },
        Subtitle: {
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            fontStyle: 'italic',
            marginLeft: 'V',
            flex: '1',
            text: (el, s)=>el.parent.parent.subtitle || ''
        }
    },
    // Virtualized assignee groups: render only VIRTUAL_BATCH cards per section.
    // Groups are always rendered (the header + count are always visible); only the
    // per-group card lists are sliced to the visible window.
    //
    // v3.14 reactive fix: reads el.parent.state.visN (the TriageSection's own signal)
    // instead of s.root._visN_<key>. DOMQL v3.14 createEffect tracks el.parent.state.visN
    // as a reactive dependency so children reconcile when _expandSection fires.
    Groups: {
        flow: 'y',
        gap: 'Z',
        childExtends: 'TriageGroup',
        childrenAs: 'state',
        children: (el, s)=>{
            const sectionEl = el.parent;
            const sectionKey = sectionEl.sectionKey;
            // Read visN from section's OWN reactive state so createEffect subscribes.
            const vis = sectionEl.state && sectionEl.state.visN || $8c929b926840afcd$var$VIRTUAL_INITIAL;
            const allRows = $8c929b926840afcd$var$_sectionRows(s, sectionKey);
            // Slice to visible window BEFORE grouping to keep grouping computation
            // cheap for large buckets.
            const sliced = allRows.slice(0, vis);
            return $8c929b926840afcd$var$_groupByAssignee(sliced);
        }
    },
    // Load-more: IntersectionObserver sentinel + explicit button.
    Footer: {
        flow: 'y',
        gap: 'V',
        hide: (el, s)=>{
            const sectionEl = el.parent;
            const key = sectionEl.sectionKey;
            const vis = sectionEl.state && sectionEl.state.visN || $8c929b926840afcd$var$VIRTUAL_INITIAL;
            return $8c929b926840afcd$var$_sectionRows(s, key).length <= vis;
        },
        // IntersectionObserver sentinel — triggers auto-expand on scroll near end.
        // Uses _findTriageSection to locate the ancestor (no sectionKey prop needed).
        Sentinel: {
            extends: 'VirtualSentinel'
        },
        // Explicit load-more button (redundant with sentinel but good for a11y).
        MoreBtn: {
            tag: 'button',
            padding: 'V A',
            round: 'Y2',
            border: 'none',
            cursor: 'pointer',
            fontSize: 'Y2',
            fontWeight: '600',
            background: 'overlay',
            color: 'caption',
            borderWidth: 'V',
            borderStyle: 'solid',
            borderColor: 'line',
            transition: 'border-color 0.12s ease, color 0.12s ease',
            ':hover': {
                borderColor: 'cyan',
                color: 'cyan'
            },
            text: (el, s)=>{
                const sectionEl = el.parent.parent;
                const key = sectionEl.sectionKey;
                const total = $8c929b926840afcd$var$_sectionRows(s, key).length;
                const vis = sectionEl.state && sectionEl.state.visN || $8c929b926840afcd$var$VIRTUAL_INITIAL;
                const remaining = Math.max(0, total - vis);
                return `Load ${Math.min(remaining, $8c929b926840afcd$var$VIRTUAL_BATCH)} more (${remaining} remaining)`;
            },
            onClick: (e, el, s)=>{
                const sectionEl = $8c929b926840afcd$var$_findTriageSection(el);
                $8c929b926840afcd$var$_expandSection(sectionEl);
            }
        }
    }
};
const $8c929b926840afcd$export$15a238f5a11579b2 = {
    flow: 'y',
    gap: 'V',
    Head: {
        flow: 'x',
        gap: 'Z',
        align: 'center left',
        paddingLeft: 'V',
        Avatar: {
            tag: 'span',
            width: 'B',
            height: 'B',
            round: 'round',
            flexShrink: '0',
            align: 'center center',
            fontSize: 'Y2',
            fontWeight: '700',
            color: (el, s)=>s.isLive ? 'green' : s.isAgent ? 'cyan' : 'title',
            background: (el, s)=>s.isLive ? 'color-mix(in srgb, var(--color-green) 15%, transparent)' : s.isAgent ? 'color-mix(in srgb, var(--color-cyan) 15%, transparent)' : 'line',
            boxShadow: (el, s)=>s.isLive ? '0 0 10px color-mix(in srgb, var(--color-green) 50%, transparent)' : 'none',
            text: (el, s)=>(s.actor || '?').slice(0, 1).toUpperCase()
        },
        Actor: {
            tag: 'span',
            fontSize: 'Y1',
            fontWeight: '700',
            color: (el, s)=>s.isLive ? 'green' : s.isAgent ? 'cyan' : 'title',
            letterSpacing: '.02em',
            text: (el, s)=>s.actor || '?'
        },
        LiveTag: {
            hide: (el, s)=>!s.isLive,
            tag: 'span',
            fontSize: 'Y2',
            fontWeight: '700',
            padding: 'V Z',
            round: 'V',
            background: 'var(--color-green-15, var(--color-green))',
            color: 'green',
            text: 'LIVE'
        },
        Count: {
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            text: (el, s)=>`${(s.rows || []).length}`
        }
    },
    List: {
        flow: 'y',
        gap: 'V',
        paddingLeft: 'A',
        borderLeftWidth: 'V',
        borderLeftStyle: 'solid',
        borderLeftColor: 'line',
        childExtends: 'TriageCard',
        childrenAs: 'state',
        children: (el, s)=>s.rows || []
    }
};
const $8c929b926840afcd$export$2f2bf9b4f2bd2231 = {
    flow: 'y',
    gap: 'A',
    Header: {
        flow: 'x',
        gap: 'V',
        align: 'baseline left',
        paddingBottom: 'V',
        borderBottomWidth: 'V',
        borderBottomStyle: 'solid',
        borderBottomColor: 'line',
        cursor: 'pointer',
        CollapseBtn: {
            tag: 'button',
            border: 'none',
            background: 'transparent',
            cursor: 'pointer',
            padding: '0',
            fontSize: 'Y1',
            color: 'caption',
            transition: 'transform 0.12s ease',
            transform: (el, s)=>{
                const root = s.root || el.getRoot();
                return root && root[`_groupCollapsed_${s.groupKey}`] ? 'rotate(-90deg)' : 'rotate(0deg)';
            },
            text: "\u25BE",
            onClick: (e, el, s)=>{
                e.stopPropagation();
                const root = s.root || el.getRoot();
                if (!root) return;
                const key = `_groupCollapsed_${s.groupKey}`;
                root.update({
                    [key]: !root[key]
                });
            }
        },
        Title: {
            tag: 'h2',
            fontSize: 'B',
            fontWeight: '700',
            letterSpacing: '-.02em',
            color: 'title',
            margin: '0',
            text: (el, s)=>s.groupLabel || s.actor || s.groupKey || '?'
        },
        Count: {
            tag: 'span',
            fontSize: 'Y1',
            fontWeight: '600',
            color: 'caption',
            text: (el, s)=>{
                const n = (s.rows || []).length;
                return `${n} ticket${n === 1 ? '' : 's'}`;
            }
        }
    },
    List: {
        flow: 'y',
        gap: 'V',
        hide: (el, s)=>{
            const root = s.root || el.getRoot();
            return !!(root && root[`_groupCollapsed_${s.groupKey}`]);
        },
        childExtends: 'TriageCard',
        childrenAs: 'state',
        children: (el, s)=>s.rows || []
    }
};
const $8c929b926840afcd$export$935638f8e4f19674 = {
    // AC12: stable class for CSS density rules — data-key is the sibling index
    // ("0","1",...) for unkeyed childExtends children, so it cannot be targeted
    // reliably from injected CSS.  This class is always present on the DOM node.
    class: 'triage-card',
    flow: 'y',
    // AC1/AC12: density-responsive gap and padding (compact halves vertical space)
    gap: 'Y',
    padding: (el, s)=>s.root && s.root.densityMode === 'compact' ? 'Y A' : 'Z A',
    round: 'Z1',
    borderWidth: 'V',
    borderStyle: 'solid',
    // AC6: selected state border highlight
    borderColor: (el, s)=>{
        const selectedIds = s.root && s.root.selectedTicketIds;
        if (Array.isArray(selectedIds) && selectedIds.includes(s.id)) return 'cyan';
        if (s.liveAgent) return 'var(--color-green-a+30, var(--color-green))';
        if (s.isBlocked) return 'var(--color-red-a+20, var(--color-red))';
        return 'line';
    },
    // AC6: selected state background highlight + base overlay
    background: (el, s)=>{
        const selectedIds = s.root && s.root.selectedTicketIds;
        if (Array.isArray(selectedIds) && selectedIds.includes(s.id)) return 'color-mix(in srgb, var(--color-cyan) 8%, var(--color-overlay))';
        return 'overlay';
    },
    cursor: 'pointer',
    position: 'relative',
    overflow: 'hidden',
    transition: 'border-color 0.12s ease, transform 0.14s ease, box-shadow 0.14s ease, background 0.12s ease',
    // AC5: keyboard focus ring
    outline: (el, s)=>{
        const bk = s.root && s.root.kbFocusBucket;
        const idx = s.root && s.root.kbFocusIndex;
        if (!bk || idx === undefined) return 'none';
        // Match by bucket + index — el._kbBucket and el._kbIndex are set when cards render
        if (el._kbBucket === bk && el._kbIndex === idx) return '2px solid var(--color-cyan)';
        return 'none';
    },
    outlineOffset: '2px',
    ':hover': {
        transform: 'translateY(-1px)',
        boxShadow: '0 3px 12px var(--color-shadow)',
        borderColor: (el, s)=>s.liveAgent ? 'green' : s.isBlocked ? 'red' : 'overlayStrong'
    },
    ':active': {
        transform: 'translateY(0)'
    },
    draggable: 'true',
    'data-triage-card-id': (el, s)=>s.id,
    // AC6: test-observable selected state — QA reads via
    //   card.dataset.testSelected === 'true'
    'data-test-selected': (el, s)=>{
        const selectedIds = s.root && s.root.selectedTicketIds;
        return Array.isArray(selectedIds) && selectedIds.includes(s.id) ? 'true' : 'false';
    },
    onClick: (e, el, s)=>{
        const root = s.root || el.getRoot();
        if (!root || typeof root.update !== 'function') return;
        // AC6: Cmd/Ctrl+click — toggle individual selection
        // selectedTicketIds is stored as an Array (DOMQL v3.14 state serialises Sets
        // to plain objects which are not iterable — always use Array in root state).
        if (e.metaKey || e.ctrlKey) {
            e.preventDefault();
            const rawCur = root.selectedTicketIds;
            const cur = Array.isArray(rawCur) ? rawCur : [];
            const next = cur.includes(s.id) ? cur.filter((id)=>id !== s.id) : [
                ...cur,
                s.id
            ];
            root.update({
                selectedTicketIds: next
            });
            return;
        }
        // AC6: Shift+click — range select from last selected to this
        if (e.shiftKey) {
            e.preventDefault();
            const rawCur = root.selectedTicketIds;
            const cur = Array.isArray(rawCur) ? rawCur : [];
            if (cur.length === 0) {
                root.update({
                    selectedTicketIds: [
                        s.id
                    ]
                });
                return;
            }
            // Build ordered list of all visible cards by iterating DOM order
            const allCards = document.querySelectorAll('[data-triage-card-id]');
            const ids = Array.from(allCards).map((c)=>Number(c.dataset.triageCardId));
            const lastId = cur[cur.length - 1];
            const a = ids.indexOf(lastId);
            const b = ids.indexOf(s.id);
            if (a === -1 || b === -1) {
                const next = cur.includes(s.id) ? cur : [
                    ...cur,
                    s.id
                ];
                root.update({
                    selectedTicketIds: next
                });
                return;
            }
            const [lo, hi] = a < b ? [
                a,
                b
            ] : [
                b,
                a
            ];
            const rangeIds = ids.slice(lo, hi + 1).filter((id)=>id != null);
            const merged = [
                ...new Set([
                    ...cur,
                    ...rangeIds
                ])
            ];
            root.update({
                selectedTicketIds: merged
            });
            return;
        }
        // Normal click — open detail modal (clear selection)
        root.update({
            selectedTicket: {
                ...s
            }
        });
    },
    onDragstart: (e, el, s)=>{
        try {
            e.dataTransfer.setData('text/ticket-id', String(s.id));
            e.dataTransfer.effectAllowed = 'move';
        } catch (_) {}
    },
    // Top row: id · active dot · state pill · priority pill
    TopRow: {
        flow: 'x',
        gap: 'Z',
        align: 'center left',
        flexWrap: 'wrap',
        Ref: {
            tag: 'span',
            flexShrink: '0',
            fontSize: 'Y2',
            fontWeight: '600',
            color: 'caption',
            fontFamily: 'monospace',
            text: (el, s)=>s.external_id || `#${s.id}`
        },
        // Pulsing dot — shown when a live agent is on this ticket
        ActiveDot: {
            display: (el, s)=>s.liveAgent ? 'inline-block' : 'none',
            tag: 'span',
            width: 'Z',
            height: 'Z',
            round: 'round',
            flexShrink: '0',
            background: 'green',
            title: (el, s)=>s.liveAgent ? `${s.liveAgent} is working on this` : '',
            // Deliver animation via DOMQL CSS class props, not style:{} inline.
            // animationName is split across two @media queries (both compound classes)
            // rather than a flat prop + @media override — this avoids the CSS source-order
            // bug where a flat prop class is inserted after the compound @media class,
            // causing the flat rule to always win regardless of viewport/OS preference.
            animationDuration: '1.4s',
            animationTimingFunction: 'ease-in-out',
            animationIterationCount: 'infinite',
            animationFillMode: 'none',
            '@media (prefers-reduced-motion: no-preference)': {
                animationName: 'agentDotPulse'
            },
            '@media (prefers-reduced-motion: reduce)': {
                animationName: 'agentDotFade'
            }
        },
        StatePill: {
            display: (el, s)=>s.state ? 'inline-flex' : 'none',
            tag: 'span',
            align: 'center center',
            padding: 'V Z',
            round: 'C',
            fontSize: 'V',
            fontWeight: '700',
            letterSpacing: '.04em',
            color: (el, s)=>{
                if (s.liveAgent) return 'green';
                return (0, $7MNpT.TICKET_STATE_COLOR)[s.state] || 'caption';
            },
            background: (el, s)=>{
                const c = s.liveAgent ? 'green' : (0, $7MNpT.TICKET_STATE_COLOR)[s.state] || 'caption';
                return `color-mix(in srgb, var(--color-${c}) 14%, transparent)`;
            },
            text: (el, s)=>{
                if (s.liveAgent) {
                    const age = s.liveAgentHeartbeat ? Math.max(0, Math.floor((Date.now() - new Date(s.liveAgentHeartbeat).getTime()) / 60000)) : 0;
                    return `live \xb7 ${age}m`;
                }
                return (0, $7MNpT.formatStateLabel)(s.state || 'not_started');
            }
        },
        PriorityPill: {
            display: (el, s)=>s.priority ? 'inline-flex' : 'none',
            tag: 'span',
            padding: 'V Z',
            round: 'C',
            fontSize: 'V',
            fontWeight: '700',
            letterSpacing: '.04em',
            color: (el, s)=>{
                if (s.priority === 'P0') return 'red';
                if (s.priority === 'P1') return 'orange';
                if (s.priority === 'P2') return 'yellow';
                return 'caption';
            },
            background: (el, s)=>{
                const c = s.priority === 'P0' ? 'red' : s.priority === 'P1' ? 'orange' : s.priority === 'P2' ? 'yellow' : 'caption';
                return `color-mix(in srgb, var(--color-${c}) 14%, transparent)`;
            },
            text: (el, s)=>s.priority || ''
        }
    },
    // Title row — H3, 2-line clamp. Tighter font size (Z2) vs old A for density.
    Title: {
        tag: 'h3',
        fontSize: 'Z2',
        fontWeight: '600',
        letterSpacing: '-.01em',
        lineHeight: '1.3',
        color: 'title',
        margin: '0',
        overflow: 'hidden',
        // 2-line clamp via webkit — applied inline after mount to avoid
        // conflicting with DOMQL's display management.
        onInit: (el)=>{
            if (!el.node) return;
            el.node.style.display = '-webkit-box';
            el.node.style['-webkit-line-clamp'] = '2';
            el.node.style['-webkit-box-orient'] = 'vertical';
            el.node.style.overflow = 'hidden';
        },
        text: (el, s)=>(s.title || '').replace(/^B-\d+\s*·\s*/, '')
    },
    // Meta row: parent path (epic › story) + assignee avatar
    MetaRow: {
        flow: 'x',
        gap: 'Z',
        align: 'center left',
        flexWrap: 'wrap',
        // Renamed from 'Breadcrumb' to avoid auto-extending the brand Breadcrumb
        // component (which calls el.getData("pages") and throws in the intranet
        // context, crashing every TriageCard creation inside createEffect).
        ParentPath: {
            display: (el, s)=>s.parentEpicTitle || s.parentStoryTitle ? 'flex' : 'none',
            flow: 'x',
            gap: 'V',
            align: 'center left',
            fontSize: 'Y2',
            color: 'caption',
            flex: '1',
            minWidth: '0',
            overflow: 'hidden',
            Epic: {
                display: (el, s)=>s.parentEpicTitle ? 'inline' : 'none',
                tag: 'span',
                color: 'cyan',
                fontWeight: '600',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                text: (el, s)=>s.parentEpicTitle || ''
            },
            Sep: {
                display: (el, s)=>s.parentEpicTitle && s.parentStoryTitle ? 'inline' : 'none',
                tag: 'span',
                opacity: '.4',
                text: "\u203A"
            },
            Story: {
                display: (el, s)=>s.parentStoryTitle ? 'inline' : 'none',
                tag: 'span',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                text: (el, s)=>s.parentStoryTitle || ''
            }
        },
        Assignee: {
            display: (el, s)=>s.assignee_email ? 'flex' : 'none',
            flow: 'x',
            gap: 'V',
            align: 'center left',
            flexShrink: '0',
            marginLeft: 'auto',
            Avatar: {
                tag: 'span',
                width: 'B',
                height: 'B',
                round: 'round',
                flexShrink: '0',
                align: 'center center',
                fontSize: 'Y2',
                fontWeight: '700',
                color: 'title',
                background: (el, s)=>$8c929b926840afcd$var$_isAgentEmail(s.assignee_email) ? 'cyan.15' : 'line',
                title: (el, s)=>s.assignee_email || '',
                text: (el, s)=>{
                    const e = s.assignee_email || '';
                    if ($8c929b926840afcd$var$_isAgentEmail(e)) return e.split('-agent')[0].slice(0, 1).toUpperCase();
                    return e.split('@')[0].slice(0, 1).toUpperCase();
                }
            },
            Name: {
                tag: 'span',
                fontSize: 'Y2',
                color: (el, s)=>$8c929b926840afcd$var$_isAgentEmail(s.assignee_email) ? 'cyan' : 'caption',
                text: (el, s)=>{
                    const e = s.assignee_email || '';
                    if ($8c929b926840afcd$var$_isAgentEmail(e)) return e.split('-agent')[0].toUpperCase();
                    return e.split('@')[0];
                }
            }
        }
    },
    // Labels row — up to 3 visible + "+N more" indicator
    Labels: {
        display: (el, s)=>(s.labels || []).length ? 'flex' : 'none',
        flow: 'x',
        gap: 'Y',
        flexWrap: 'wrap',
        childExtends: 'TriageLabelChip',
        childrenAs: 'state',
        children: (el, s)=>{
            const labels = s.labels || [];
            const MAX = 3;
            const visible = labels.slice(0, MAX).map((label)=>({
                    label: label,
                    _more: 0
                }));
            const remaining = labels.length - MAX;
            if (remaining > 0) visible.push({
                label: `+${remaining}`,
                _more: remaining
            });
            return visible;
        }
    },
    // Last-activity line
    LastActivity: {
        display: (el, s)=>s.lastActivityAt || s.updatedAt ? 'flex' : 'none',
        flow: 'x',
        gap: 'V',
        align: 'center left',
        fontSize: 'Y2',
        color: 'caption',
        Icon: {
            tag: 'span',
            text: (el, s)=>s.liveAgent ? "\u25CF" : "\u25CB"
        },
        Text: {
            tag: 'span',
            title: (el, s)=>s.lastActivityAt || s.updatedAt || '',
            text: (el, s)=>{
                if (s.liveAgent) return `${s.liveAgent} is working on this`;
                if (s.lastActivityAgent && s.lastActivityAt) return `${s.lastActivityAgent} \xb7 ${$8c929b926840afcd$var$_relativeTime(s.lastActivityAt)}`;
                if (s.updatedAt) return `updated ${$8c929b926840afcd$var$_relativeTime(s.updatedAt)}`;
                return '';
            }
        }
    },
    // Blocker info — shown only on blocked tickets (s.isBlocked && s.blockedByIds.length > 0).
    // Lists each blocker as "blocked by #N" with a link to open that ticket's detail.
    BlockerInfo: {
        display: (el, s)=>s.isBlocked && s.blockedByIds && s.blockedByIds.length > 0 ? 'flex' : 'none',
        flow: 'x',
        gap: 'V',
        align: 'center left',
        flexWrap: 'wrap',
        fontSize: 'Y2',
        color: 'red',
        Icon: {
            tag: 'span',
            flexShrink: '0',
            text: "\u2298",
            title: 'Blocked by'
        },
        Label: {
            tag: 'span',
            flexShrink: '0',
            fontWeight: '600',
            color: 'red',
            opacity: '.7',
            text: 'blocked by'
        },
        Blockers: {
            flow: 'x',
            gap: 'Y',
            flexWrap: 'wrap',
            align: 'center left',
            childExtends: 'BlockerChip',
            childrenAs: 'state',
            children: (el, s)=>s.blockedByIds || []
        }
    },
    // Layer 2: Progress bar — thin track at card bottom, no label text (spec)
    ProgressBar: {
        position: 'relative',
        width: '100%',
        height: 'Y',
        round: 'V',
        background: (el, s)=>s.isBlocked ? 'color-mix(in srgb, var(--color-red) 15%, transparent)' : 'line',
        overflow: 'hidden',
        marginTop: 'Y',
        Fill: {
            position: 'absolute',
            top: '0',
            left: '0',
            height: '100%',
            round: 'V',
            transition: 'width 0.4s ease',
            width: (el, s)=>`${s.progressPct || 0}%`,
            background: (el, s)=>{
                if (s.isBlocked) return 'var(--color-red)';
                if (s.liveAgent) return 'var(--color-green)';
                const pct = s.progressPct || 0;
                if (pct >= 100) return 'var(--color-green)';
                if (pct >= 66) return 'var(--color-magenta)';
                if (pct >= 33) return 'var(--color-yellow)';
                return 'var(--color-cyan)';
            }
        }
    }
};
const $8c929b926840afcd$export$d97b03bc05f73e43 = {
    tag: 'span',
    padding: 'V Z',
    round: 'C',
    fontSize: 'V',
    fontWeight: (el, s)=>s._more ? '700' : '500',
    letterSpacing: '.02em',
    color: (el, s)=>s._more ? 'caption' : 'subtitle',
    background: 'overlay',
    borderWidth: 'V',
    borderColor: 'line',
    borderStyle: 'solid',
    text: (el, s)=>s.label
};
const $8c929b926840afcd$export$9e0710b47cbb3746 = {
    tag: 'button',
    padding: 'V Z',
    round: 'C',
    fontSize: 'V',
    fontWeight: '700',
    letterSpacing: '.02em',
    color: 'red',
    background: 'color-mix(in srgb, var(--color-red) 10%, transparent)',
    borderWidth: 'V',
    borderColor: 'color-mix(in srgb, var(--color-red) 25%, transparent)',
    borderStyle: 'solid',
    cursor: 'pointer',
    transition: 'background 0.12s ease, border-color 0.12s ease',
    ':hover': {
        background: 'color-mix(in srgb, var(--color-red) 20%, transparent)',
        borderColor: 'red'
    },
    title: (el, s)=>s.title ? `Blocked by: ${s.title}` : `Blocked by ticket #${s.id}`,
    text: (el, s)=>s.external_id ? `#${s.external_id}` : `#${s.id}`,
    onClick: (e, el, s)=>{
        e.stopPropagation();
        const root = s.root || el.getRoot();
        if (!root || typeof root.update !== 'function') return;
        // Open the blocker ticket's detail modal.
        root.update({
            selectedTicket: {
                id: s.id,
                external_id: s.external_id,
                title: s.title
            }
        });
    }
};
const $8c929b926840afcd$export$f91a7245ef818879 = {
    flow: 'y',
    gap: 'A',
    padding: 'A',
    round: 'A',
    background: 'overlay',
    borderWidth: 'V',
    borderStyle: 'solid',
    borderColor: 'line',
    overflow: 'auto',
    // Wide viewport (>=1280px): sticky + capped height so the rail tracks scroll.
    // Implemented via reactive JS prop (same workaround as Layout grid — see comment there).
    position: (el, s)=>(s.root.viewportWidth || (typeof window !== 'undefined' ? window.innerWidth : 0)) >= 1280 ? 'sticky' : 'static',
    top: (el, s)=>(s.root.viewportWidth || (typeof window !== 'undefined' ? window.innerWidth : 0)) >= 1280 ? 'var(--spacing-A)' : 'auto',
    maxHeight: (el, s)=>(s.root.viewportWidth || (typeof window !== 'undefined' ? window.innerWidth : 0)) >= 1280 ? 'calc(50vh - 80px)' : 'none',
    Header: {
        flow: 'x',
        gap: 'Z',
        align: 'center left',
        paddingBottom: 'Z',
        marginBottom: 'V',
        borderBottomWidth: 'V',
        borderBottomStyle: 'solid',
        borderBottomColor: 'line',
        Dot: {
            tag: 'span',
            width: 'Z',
            height: 'Z',
            round: 'round',
            flexShrink: '0',
            alignSelf: 'center',
            background: 'magenta',
            boxShadow: '0 0 10px color-mix(in srgb, var(--color-magenta) 55%, transparent)'
        },
        Title: {
            tag: 'h2',
            fontSize: 'Z2',
            fontWeight: '700',
            letterSpacing: '-.01em',
            color: 'title',
            margin: '0',
            lineHeight: '1.2',
            text: 'Ready to test'
        },
        Count: {
            tag: 'span',
            fontSize: 'Y2',
            fontWeight: '700',
            padding: 'V Y',
            round: 'C',
            marginLeft: 'auto',
            display: 'inline-block',
            transformOrigin: 'center center',
            color: 'magenta',
            background: 'color-mix(in srgb, var(--color-magenta) 12%, transparent)',
            text: (el, s)=>{
                const n = $8c929b926840afcd$var$_readyToTestRows(s).length;
                if (typeof el._prevCount === 'number' && el._prevCount !== n && el.node) {
                    const prefersReduced = typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
                    const animName = prefersReduced ? 'countBumpReduced' : 'countBump';
                    el.node.style.animation = 'none';
                    el.node.offsetWidth;
                    el.node.style.animation = `${animName} 0.3s ease`;
                    el.node.addEventListener('animationend', ()=>{
                        if (el.node) el.node.style.animation = '';
                    }, {
                        once: true
                    });
                }
                el._prevCount = n;
                return `${n}`;
            }
        }
    },
    Hint: {
        hide: (el, s)=>$8c929b926840afcd$var$_readyToTestRows(s).length > 0,
        tag: 'p',
        margin: '0',
        padding: 'Z',
        textAlign: 'center',
        fontSize: 'Y2',
        color: 'caption',
        fontStyle: 'italic',
        text: 'No tickets ready to test'
    },
    List: {
        flow: 'y',
        gap: 'V',
        childExtends: 'TriageCard',
        childrenAs: 'state',
        children: (el, s)=>$8c929b926840afcd$var$_readyToTestRows(s)
    }
};
const $8c929b926840afcd$export$99fd3149661f48c0 = {
    flow: 'x',
    align: 'center left',
    gap: 'V',
    padding: 'V A',
    background: 'magenta.08',
    round: 'V',
    borderWidth: 'V',
    borderStyle: 'solid',
    borderColor: 'magenta.a+20',
    cursor: 'pointer',
    transition: 'border-color 0.12s ease, transform 0.12s ease',
    ':hover': {
        borderColor: 'magenta',
        transform: 'translateX(2px)'
    },
    onClick: (e, el, s)=>{
        const root = s.root || el.getRoot();
        if (root && typeof root.update === 'function') root.update({
            selectedTicket: {
                ...s
            }
        });
    },
    Ref: {
        tag: 'span',
        flexShrink: '0',
        fontSize: 'Y2',
        fontWeight: '600',
        color: 'magenta',
        fontFamily: 'monospace',
        text: (el, s)=>s.external_id || `#${s.id}`
    },
    Title: {
        tag: 'span',
        flex: '1',
        fontSize: 'Y1',
        color: 'title',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        text: (el, s)=>(s.title || '').replace(/^B-\d+\s*·\s*/, '')
    },
    EpicChip: {
        hide: (el, s)=>!s.parentEpicTitle,
        tag: 'span',
        flexShrink: '0',
        fontSize: 'Y2',
        fontWeight: '600',
        padding: 'V Z',
        round: 'V',
        background: 'cyan.15',
        color: 'cyan',
        text: (el, s)=>s.parentEpicTitle || ''
    },
    Priority: {
        hide: (el, s)=>!s.priority || s.priority === 'P2',
        tag: 'span',
        flexShrink: '0',
        fontSize: 'Y2',
        fontWeight: '700',
        color: (el, s)=>s.priority === 'P0' ? 'red' : s.priority === 'P1' ? 'orange' : 'caption',
        text: (el, s)=>s.priority || ''
    },
    StateChip: {
        tag: 'span',
        flexShrink: '0',
        fontSize: 'Y2',
        fontWeight: '600',
        color: 'magenta',
        text: 'ready to test'
    }
};
const $8c929b926840afcd$export$91ed19f70e23011a = {
    flow: 'y',
    gap: 'A',
    padding: 'A',
    round: 'A',
    // Stronger background for the rail — distinguishes it from cards
    background: (el, s)=>$8c929b926840afcd$var$_pulsingAgents(s).length > 0 ? 'color-mix(in srgb, var(--color-green) 4%, var(--color-overlay))' : 'overlay',
    borderWidth: 'V',
    borderStyle: 'solid',
    borderColor: (el, s)=>$8c929b926840afcd$var$_pulsingAgents(s).length > 0 ? 'color-mix(in srgb, var(--color-green) 20%, transparent)' : 'line',
    maxHeight: 'calc(50vh - 80px)',
    overflow: 'auto',
    transition: 'background 0.3s ease, border-color 0.3s ease',
    Header: {
        flow: 'x',
        gap: 'Z',
        align: 'center left',
        paddingBottom: 'Z',
        marginBottom: 'V',
        borderBottomWidth: 'V',
        borderBottomStyle: 'solid',
        borderBottomColor: 'line',
        // Pulsing dot — token-sized (Z ≈ 8px), animated for live presence
        PulsingDot: {
            tag: 'span',
            width: 'Z',
            height: 'Z',
            round: 'round',
            flexShrink: '0',
            alignSelf: 'center',
            background: 'green',
            boxShadow: '0 0 10px color-mix(in srgb, var(--color-green) 60%, transparent)',
            animationDuration: '1.6s',
            animationTimingFunction: 'ease-in-out',
            animationIterationCount: 'infinite',
            animationFillMode: 'none',
            '@media (prefers-reduced-motion: no-preference)': {
                animationName: 'agentDotPulse'
            },
            '@media (prefers-reduced-motion: reduce)': {
                animationName: 'agentDotFade'
            }
        },
        Title: {
            tag: 'h2',
            fontSize: 'Z2',
            fontWeight: '700',
            letterSpacing: '-.01em',
            color: 'title',
            margin: '0',
            lineHeight: '1.2',
            text: 'Agents pulsing now'
        },
        // Count as a tinted green chip when agents are active
        Count: {
            tag: 'span',
            fontSize: 'Y2',
            fontWeight: '700',
            padding: 'V Y',
            round: 'C',
            marginLeft: 'auto',
            color: (el, s)=>$8c929b926840afcd$var$_pulsingAgents(s).length > 0 ? 'green' : 'caption',
            background: (el, s)=>$8c929b926840afcd$var$_pulsingAgents(s).length > 0 ? 'color-mix(in srgb, var(--color-green) 15%, transparent)' : 'overlay',
            text: (el, s)=>`${$8c929b926840afcd$var$_pulsingAgents(s).length}`
        }
    },
    ActiveList: {
        flow: 'y',
        gap: 'V',
        EmptyNote: {
            hide: (el, s)=>$8c929b926840afcd$var$_pulsingAgents(s).length > 0,
            tag: 'p',
            margin: '0',
            padding: 'V 0',
            fontSize: 'Y2',
            color: 'caption',
            fontStyle: 'italic',
            text: 'No agents pulsing in the last 5 minutes'
        },
        Agents: {
            flow: 'y',
            gap: 'V',
            childExtends: 'AgentPulseRow',
            childrenAs: 'state',
            children: (el, s)=>$8c929b926840afcd$var$_pulsingAgents(s)
        }
    },
    // Idle section (5–60min)
    IdleSection: {
        flow: 'y',
        gap: 'V',
        hide: (el, s)=>$8c929b926840afcd$var$_idleAgents(s).length === 0,
        IdleHeader: {
            flow: 'x',
            gap: 'V',
            align: 'center left',
            cursor: 'pointer',
            padding: 'V 0',
            borderTopWidth: 'V',
            borderTopStyle: 'solid',
            borderTopColor: 'line',
            onClick: (e, el, s)=>{
                const root = s.root || el.getRoot();
                if (root) root.update({
                    _idleSectionOpen: !root._idleSectionOpen
                });
            },
            Caret: {
                tag: 'span',
                fontSize: 'Y2',
                color: 'caption',
                transition: 'transform 0.12s ease',
                transform: (el, s)=>s.root._idleSectionOpen ? 'rotate(0deg)' : 'rotate(-90deg)',
                text: "\u25BE"
            },
            Label: {
                tag: 'span',
                fontSize: 'Y2',
                fontWeight: '600',
                color: 'caption',
                text: (el, s)=>`Idle (${$8c929b926840afcd$var$_idleAgents(s).length})`
            }
        },
        IdleAgents: {
            flow: 'y',
            gap: 'V',
            hide: (el, s)=>!s.root._idleSectionOpen,
            childExtends: 'AgentIdleRow',
            childrenAs: 'state',
            children: (el, s)=>$8c929b926840afcd$var$_idleAgents(s)
        }
    },
    // Stale section (>60min)
    StaleSection: {
        flow: 'y',
        gap: 'V',
        hide: (el, s)=>$8c929b926840afcd$var$_staleAgents(s).length === 0,
        StaleToggle: {
            tag: 'button',
            border: 'none',
            background: 'transparent',
            cursor: 'pointer',
            padding: 'V 0',
            fontSize: 'Y2',
            color: 'caption',
            textAlign: 'left',
            borderTopWidth: 'V',
            borderTopStyle: 'solid',
            borderTopColor: 'line',
            text: (el, s)=>{
                const n = $8c929b926840afcd$var$_staleAgents(s).length;
                return s.root._staleSectionOpen ? `Hide stale (${n})` : `Show stale (${n})`;
            },
            onClick: (e, el, s)=>{
                const root = s.root || el.getRoot();
                if (root) root.update({
                    _staleSectionOpen: !root._staleSectionOpen
                });
            }
        },
        StaleAgents: {
            flow: 'y',
            gap: 'V',
            hide: (el, s)=>!s.root._staleSectionOpen,
            childExtends: 'AgentIdleRow',
            childrenAs: 'state',
            children: (el, s)=>$8c929b926840afcd$var$_staleAgents(s)
        }
    }
};
const $8c929b926840afcd$export$2baaea63f3b7002b = {
    flow: 'y',
    gap: 'Y',
    padding: 'Z',
    round: 'V',
    background: 'color-mix(in srgb, var(--color-green) 4%, transparent)',
    borderWidth: 'V',
    borderStyle: 'solid',
    borderColor: 'color-mix(in srgb, var(--color-green) 15%, transparent)',
    transition: 'background 0.12s ease',
    ':hover': {
        background: 'color-mix(in srgb, var(--color-green) 8%, transparent)'
    },
    TopLine: {
        flow: 'x',
        gap: 'Z',
        align: 'center left',
        AvatarWrap: {
            position: 'relative',
            flexShrink: '0',
            width: 'C',
            height: 'C',
            AgentAvatar: {
                tag: 'span',
                width: 'C',
                height: 'C',
                round: 'round',
                align: 'center center',
                fontSize: 'Y1',
                fontWeight: '700',
                color: 'green',
                background: 'color-mix(in srgb, var(--color-green) 15%, transparent)',
                text: (el, s)=>(s.agent_name || '?').slice(0, 1)
            },
            PulseDot: {
                position: 'absolute',
                bottom: '0',
                right: '0',
                width: 'Z',
                height: 'Z',
                round: 'round',
                background: 'green',
                borderWidth: 'V',
                borderStyle: 'solid',
                borderColor: 'overlay',
                animationDuration: '1.4s',
                animationTimingFunction: 'ease-in-out',
                animationIterationCount: 'infinite',
                animationFillMode: 'none',
                '@media (prefers-reduced-motion: no-preference)': {
                    animationName: 'agentDotPulse'
                },
                '@media (prefers-reduced-motion: reduce)': {
                    animationName: 'agentDotFade'
                }
            }
        },
        Info: {
            flow: 'y',
            gap: 'Y',
            flex: '1',
            minWidth: '0',
            Name: {
                tag: 'span',
                fontSize: 'Y1',
                fontWeight: '700',
                color: 'green',
                letterSpacing: '.02em',
                text: (el, s)=>s.agent_name || '?'
            },
            Status: {
                tag: 'span',
                fontSize: 'Y2',
                color: 'caption',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                text: (el, s)=>{
                    if (s.current_ticket_id) return `shipping ticket #${s.current_ticket_id}`;
                    if (s.lastActivity && s.lastActivity.kind === 'picked_up') return `picked up #${s.lastActivity.ticket_id} \xb7 ${$8c929b926840afcd$var$_relativeTime(s.lastActivity.created_at)}`;
                    return 'active';
                }
            }
        },
        HeartbeatAge: {
            tag: 'span',
            flexShrink: '0',
            fontSize: 'Y2',
            color: 'caption',
            title: (el, s)=>s.last_heartbeat || '',
            text: (el, s)=>$8c929b926840afcd$var$_relativeTime(s.last_heartbeat)
        }
    },
    // "Last shipped" sub-line
    LastShipped: {
        display: (el, s)=>s.lastActivity && s.lastActivity.kind === 'shipped' ? 'flex' : 'none',
        flow: 'x',
        gap: 'V',
        align: 'center left',
        paddingLeft: 'calc(var(--spacing-C) + var(--spacing-Z))',
        fontSize: 'Y2',
        color: 'caption',
        Icon: {
            tag: 'span',
            text: "\u25B8",
            flexShrink: '0'
        },
        Text: {
            tag: 'span',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>{
                const a = s.lastActivity;
                if (!a) return '';
                return `shipped #${a.ticket_id} \xb7 ${$8c929b926840afcd$var$_relativeTime(a.created_at)}`;
            }
        }
    }
};
const $8c929b926840afcd$export$4f57016d3f6bcf02 = {
    flow: 'x',
    gap: 'Z',
    align: 'center left',
    padding: 'V Z',
    Avatar: {
        tag: 'span',
        width: 'C',
        height: 'C',
        round: 'round',
        flexShrink: '0',
        align: 'center center',
        fontSize: 'Y2',
        fontWeight: '700',
        color: 'caption',
        background: 'line',
        text: (el, s)=>(s.agent_name || '?').slice(0, 1)
    },
    Name: {
        tag: 'span',
        fontSize: 'Y2',
        fontWeight: '600',
        color: 'caption',
        flex: '1',
        text: (el, s)=>s.agent_name || '?'
    },
    Age: {
        tag: 'span',
        fontSize: 'Y2',
        color: 'caption',
        opacity: '.6',
        title: (el, s)=>s.last_heartbeat || '',
        text: (el, s)=>$8c929b926840afcd$var$_relativeTime(s.last_heartbeat)
    }
};
const $8c929b926840afcd$export$9460b1684d6ad4d3 = {
    flow: 'y',
    gap: 'A',
    hide: (el, s)=>$8c929b926840afcd$var$_blockedRows(s).length === 0,
    // Red left-border accent — visually distinct from ongoing (yellow) and upcoming (cyan)
    borderLeftWidth: 'V',
    borderLeftStyle: 'solid',
    borderLeftColor: 'red',
    paddingLeft: 'A',
    Header: {
        flow: 'x',
        gap: 'Z',
        align: 'center left',
        paddingBottom: 'Z',
        marginBottom: 'V',
        borderBottomWidth: 'V',
        borderBottomStyle: 'solid',
        borderBottomColor: 'color-mix(in srgb, var(--color-red) 20%, transparent)',
        Dot: {
            tag: 'span',
            width: 'Z',
            height: 'Z',
            round: 'round',
            flexShrink: '0',
            alignSelf: 'center',
            background: 'red',
            boxShadow: '0 0 10px color-mix(in srgb, var(--color-red) 55%, transparent)'
        },
        Title: {
            tag: 'h2',
            fontSize: 'A',
            fontWeight: '700',
            letterSpacing: '-.02em',
            color: 'red',
            margin: '0',
            lineHeight: '1.2',
            text: 'Blocked'
        },
        Count: {
            tag: 'span',
            fontSize: 'Y2',
            fontWeight: '700',
            padding: 'V Y',
            round: 'C',
            color: 'red',
            background: 'color-mix(in srgb, var(--color-red) 14%, transparent)',
            text: (el, s)=>{
                const n = $8c929b926840afcd$var$_blockedRows(s).length;
                return `${n}`;
            }
        },
        Subtitle: {
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            fontStyle: 'italic',
            marginLeft: 'V',
            flex: '1',
            text: 'Waiting on external dependency or approval before work can resume'
        }
    },
    // Virtualized card list — uses same approach as TriageSection.
    // BlockedSection owns its own state for the visible window.
    state: {
        visN: 20
    },
    _isTriageSection: true,
    Groups: {
        flow: 'y',
        gap: 'V',
        childExtends: 'TriageCard',
        childrenAs: 'state',
        children: (el, s)=>{
            const sectionEl = el.parent;
            const vis = sectionEl.state && sectionEl.state.visN || 20;
            return $8c929b926840afcd$var$_blockedRows(s).slice(0, vis);
        }
    },
    Footer: {
        flow: 'y',
        gap: 'V',
        hide: (el, s)=>{
            const sectionEl = el.parent;
            const vis = sectionEl.state && sectionEl.state.visN || 20;
            return $8c929b926840afcd$var$_blockedRows(s).length <= vis;
        },
        Sentinel: {
            extends: 'VirtualSentinel'
        },
        MoreBtn: {
            tag: 'button',
            padding: 'V A',
            round: 'Y2',
            border: 'none',
            cursor: 'pointer',
            fontSize: 'Y2',
            fontWeight: '600',
            background: 'overlay',
            color: 'caption',
            borderWidth: 'V',
            borderStyle: 'solid',
            borderColor: 'line',
            transition: 'border-color 0.12s ease, color 0.12s ease',
            ':hover': {
                borderColor: 'red',
                color: 'red'
            },
            text: (el, s)=>{
                const sectionEl = el.parent.parent;
                const total = $8c929b926840afcd$var$_blockedRows(s).length;
                const vis = sectionEl.state && sectionEl.state.visN || 20;
                const remaining = Math.max(0, total - vis);
                return `Load ${Math.min(remaining, 20)} more (${remaining} remaining)`;
            },
            onClick: (e, el, s)=>{
                const sectionEl = $8c929b926840afcd$var$_findTriageSection(el);
                $8c929b926840afcd$var$_expandSection(sectionEl);
            }
        }
    }
};
const $8c929b926840afcd$export$267665bd0441ca00 = {
    flow: 'y',
    gap: 'A',
    hide: (el, s)=>$8c929b926840afcd$var$_pendingApprovalRows(s).length === 0,
    // Amber left-border accent — action-needed urgency signal
    borderLeftWidth: 'Z',
    borderLeftStyle: 'solid',
    borderLeftColor: 'orange',
    paddingLeft: 'A',
    round: 'V',
    background: 'color-mix(in srgb, var(--color-orange) 3%, transparent)',
    Header: {
        flow: 'x',
        gap: 'Z',
        align: 'center left',
        paddingBottom: 'Z',
        marginBottom: 'V',
        borderBottomWidth: 'V',
        borderBottomStyle: 'solid',
        borderBottomColor: 'color-mix(in srgb, var(--color-orange) 20%, transparent)',
        // Amber dot — token-sized
        Dot: {
            tag: 'span',
            width: 'Z',
            height: 'Z',
            round: 'round',
            flexShrink: '0',
            alignSelf: 'center',
            background: 'orange',
            boxShadow: '0 0 10px color-mix(in srgb, var(--color-orange) 55%, transparent)'
        },
        Title: {
            tag: 'h2',
            fontSize: 'A',
            fontWeight: '700',
            letterSpacing: '-.02em',
            color: 'orange',
            margin: '0',
            lineHeight: '1.2',
            text: 'Pending approvals'
        },
        // Count chip in amber
        Count: {
            tag: 'span',
            fontSize: 'Y2',
            fontWeight: '700',
            padding: 'V Y',
            round: 'C',
            color: 'orange',
            background: 'color-mix(in srgb, var(--color-orange) 15%, transparent)',
            text: (el, s)=>{
                const n = $8c929b926840afcd$var$_pendingApprovalRows(s).length;
                return `${n}`;
            }
        },
        Subtitle: {
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            fontStyle: 'italic',
            marginLeft: 'V',
            flex: '1',
            text: 'Waiting for human approval before agents can proceed'
        }
    },
    List: {
        flow: 'y',
        gap: 'V',
        childExtends: 'ApprovalRow',
        childrenAs: 'state',
        children: (el, s)=>$8c929b926840afcd$var$_pendingApprovalRows(s)
    }
};
const $8c929b926840afcd$export$dfab156867750a02 = {
    flow: 'x',
    align: 'center left',
    gap: 'V',
    padding: 'V A',
    background: (el, s)=>$8c929b926840afcd$var$_isHumanApprovalNeeded(s) ? 'orange.08' : 'overlay',
    round: 'V',
    borderWidth: 'V',
    borderStyle: 'solid',
    borderColor: (el, s)=>$8c929b926840afcd$var$_isHumanApprovalNeeded(s) ? 'orange.a+30' : 'line',
    transition: 'border-color 0.12s ease',
    ':hover': {
        borderColor: 'orange'
    },
    cursor: 'pointer',
    onClick: (e, el, s)=>{
        if (e.target?.dataset?.approveBtn) return;
        const root = s.root || el.getRoot();
        if (root && typeof root.update === 'function') root.update({
            selectedTicket: {
                ...s
            }
        });
    },
    LockIcon: {
        hide: (el, s)=>!$8c929b926840afcd$var$_isHumanApprovalNeeded(s),
        tag: 'span',
        flexShrink: '0',
        fontSize: 'Y1',
        color: 'orange',
        text: "\uD83D\uDD12",
        title: 'Requires human approval before agents can proceed'
    },
    Ref: {
        tag: 'span',
        flexShrink: '0',
        fontSize: 'Y2',
        fontWeight: '600',
        color: 'orange',
        fontFamily: 'monospace',
        text: (el, s)=>s.external_id || `#${s.id}`
    },
    Title: {
        tag: 'span',
        flex: '1',
        fontSize: 'Y1',
        color: 'title',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        text: (el, s)=>(s.title || '').replace(/^B-\d+\s*·\s*/, '')
    },
    Priority: {
        hide: (el, s)=>!s.priority || s.priority === 'P2',
        tag: 'span',
        flexShrink: '0',
        fontSize: 'Y2',
        fontWeight: '700',
        color: (el, s)=>s.priority === 'P0' ? 'red' : s.priority === 'P1' ? 'orange' : 'caption',
        text: (el, s)=>s.priority || ''
    },
    Assignee: {
        hide: (el, s)=>!s.assignee_email,
        tag: 'span',
        flexShrink: '0',
        fontSize: 'Y2',
        color: 'caption',
        text: (el, s)=>{
            const e = s.assignee_email || '';
            if ($8c929b926840afcd$var$_isAgentEmail(e)) return e.split('-agent')[0].toUpperCase();
            return e.split('@')[0];
        }
    },
    ApproveBtn: {
        tag: 'button',
        flexShrink: '0',
        padding: 'V Z',
        round: 'Y2',
        border: 'none',
        cursor: 'pointer',
        fontSize: 'Y2',
        fontWeight: '700',
        background: 'orange.15',
        color: 'orange',
        transition: 'background 0.12s ease, color 0.12s ease',
        ':hover': {
            background: 'orange',
            color: 'white'
        },
        text: 'Approve',
        'data-approve-btn': 'true',
        onClick: async (e, el, s)=>{
            e.stopPropagation();
            const id = s.id;
            if (!id) return;
            const root = s.root || el.getRoot();
            if (root && root.triage) {
                const next = {
                    ...root.triage,
                    pendingApproval: (root.triage.pendingApproval || []).filter((t)=>t.id !== id)
                };
                root.update({
                    triage: next
                });
            }
            await $8c929b926840afcd$var$_approveTicket(id);
        }
    }
};
const $8c929b926840afcd$export$ac89289774e0f7ef = {
    flow: 'y',
    gap: 'A',
    hide: (el, s)=>$8c929b926840afcd$var$_decisionRows(s).length === 0,
    // Purple left-border accent — decision / ASK-USER signal
    borderLeftWidth: 'Z',
    borderLeftStyle: 'solid',
    borderLeftColor: 'purple',
    paddingLeft: 'A',
    round: 'V',
    background: 'color-mix(in srgb, var(--color-purple) 3%, transparent)',
    Header: {
        flow: 'x',
        gap: 'Z',
        align: 'center left',
        paddingBottom: 'Z',
        marginBottom: 'V',
        borderBottomWidth: 'V',
        borderBottomStyle: 'solid',
        borderBottomColor: 'color-mix(in srgb, var(--color-purple) 20%, transparent)',
        Dot: {
            tag: 'span',
            width: 'Z',
            height: 'Z',
            round: 'round',
            flexShrink: '0',
            alignSelf: 'center',
            background: 'purple',
            boxShadow: '0 0 10px color-mix(in srgb, var(--color-purple) 55%, transparent)'
        },
        Title: {
            tag: 'h2',
            fontSize: 'A',
            fontWeight: '700',
            letterSpacing: '-.02em',
            color: 'purple',
            margin: '0',
            lineHeight: '1.2',
            text: 'Decisions needed'
        },
        Count: {
            tag: 'span',
            fontSize: 'Y2',
            fontWeight: '700',
            padding: 'V Y',
            round: 'C',
            color: 'purple',
            background: 'color-mix(in srgb, var(--color-purple) 15%, transparent)',
            text: (el, s)=>{
                const n = $8c929b926840afcd$var$_decisionRows(s).length;
                return `${n}`;
            }
        },
        Subtitle: {
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            fontStyle: 'italic',
            marginLeft: 'V',
            flex: '1',
            text: 'ASK-USER tickets awaiting a decision before agents can proceed'
        }
    },
    List: {
        flow: 'y',
        gap: 'V',
        childExtends: 'DecisionRow',
        childrenAs: 'state',
        children: (el, s)=>$8c929b926840afcd$var$_decisionRows(s)
    }
};
const $8c929b926840afcd$export$c21fc1bdcf2cf87c = {
    flow: 'x',
    align: 'center left',
    gap: 'V',
    padding: 'V A',
    background: 'overlay',
    round: 'V',
    borderWidth: 'V',
    borderStyle: 'solid',
    borderColor: 'line',
    transition: 'border-color 0.12s ease',
    ':hover': {
        borderColor: 'purple'
    },
    cursor: 'pointer',
    onClick: (e, el, s)=>{
        const root = s.root || el.getRoot();
        if (root && typeof root.update === 'function') root.update({
            selectedTicket: {
                ...s
            }
        });
    },
    DecisionIcon: {
        tag: 'span',
        flexShrink: '0',
        fontSize: 'Y1',
        color: 'purple',
        text: '?',
        title: "Decision ticket \u2014 awaiting user input"
    },
    Ref: {
        tag: 'span',
        flexShrink: '0',
        fontSize: 'Y2',
        fontWeight: '600',
        color: 'purple',
        fontFamily: 'monospace',
        text: (el, s)=>s.external_id || `#${s.id}`
    },
    Title: {
        tag: 'span',
        flex: '1',
        fontSize: 'Y1',
        color: 'title',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        text: (el, s)=>(s.title || '').replace(/^[^\s·]+\s*·\s*/, '')
    },
    Priority: {
        hide: (el, s)=>!s.priority || s.priority === 'P2',
        tag: 'span',
        flexShrink: '0',
        fontSize: 'Y2',
        fontWeight: '700',
        color: (el, s)=>s.priority === 'P0' ? 'red' : s.priority === 'P1' ? 'orange' : 'caption',
        text: (el, s)=>s.priority || ''
    },
    Assignee: {
        hide: (el, s)=>!s.assignee_email,
        tag: 'span',
        flexShrink: '0',
        fontSize: 'Y2',
        color: 'caption',
        text: (el, s)=>{
            const e = s.assignee_email || '';
            if ($8c929b926840afcd$var$_isAgentEmail(e)) return e.split('-agent')[0].toUpperCase();
            return e.split('@')[0];
        }
    },
    Labels: {
        hide: (el, s)=>!(s.labels && s.labels.length),
        flow: 'x',
        gap: 'Y',
        flexWrap: 'wrap',
        flexShrink: '0',
        children: (el, s)=>(s.labels || []).filter((l)=>l === 'ASK-USER').map((l)=>({
                    tag: 'span',
                    fontSize: 'Y2',
                    fontWeight: '700',
                    padding: 'V Y',
                    round: 'C',
                    background: 'color-mix(in srgb, var(--color-purple) 15%, transparent)',
                    color: 'purple',
                    text: l
                }))
    }
};
const $8c929b926840afcd$export$4ebb06a5f191b0a9 = {
    tag: 'button',
    padding: 'Y Z',
    round: 'Z',
    fontSize: 'Y2',
    fontWeight: (el, s)=>s.active ? '700' : '500',
    cursor: 'pointer',
    borderWidth: 'V',
    borderStyle: 'solid',
    // Active: solid cyan border + strong tinted background + bold
    // Inactive: subtle line border + transparent bg — maximum contrast delta
    borderColor: (el, s)=>s.active ? 'cyan' : 'line',
    background: (el, s)=>s.active ? 'cyan.15' : 'overlay',
    color: (el, s)=>s.active ? 'cyan' : 'caption',
    transition: 'all 0.12s ease',
    boxShadow: (el, s)=>s.active ? '0 0 0 2px color-mix(in srgb, var(--color-cyan) 15%, transparent)' : 'none',
    ':hover': {
        borderColor: (el, s)=>s.active ? 'cyan' : 'title',
        color: (el, s)=>s.active ? 'cyan' : 'title'
    },
    text: (el, s)=>s.label || s.key,
    onClick: (e, el, s)=>{
        const root = s.root || el.getRoot();
        if (root && typeof root.update === 'function') {
            const key = s.filterKey || 'filterAssignee';
            root.update({
                [key]: s.key
            });
        }
    }
};
const $8c929b926840afcd$export$60985738ca283b0b = {
    flow: 'x',
    align: 'center right',
    gap: 'Y',
    flexShrink: '0',
    Label: {
        tag: 'span',
        fontSize: 'Y2',
        color: 'caption',
        fontWeight: '500',
        text: 'View'
    },
    SegGroup: {
        flow: 'x',
        round: 'Z',
        overflow: 'hidden',
        borderWidth: 'V',
        borderStyle: 'solid',
        borderColor: 'line',
        Compact: {
            tag: 'button',
            padding: 'V Z',
            fontSize: 'Y2',
            fontWeight: (el, s)=>s.root.densityMode === 'compact' ? '700' : '500',
            cursor: 'pointer',
            border: 'none',
            borderRightWidth: 'V',
            borderRightStyle: 'solid',
            borderRightColor: 'line',
            background: (el, s)=>s.root.densityMode === 'compact' ? 'cyan.15' : 'transparent',
            color: (el, s)=>s.root.densityMode === 'compact' ? 'cyan' : 'caption',
            transition: 'background 0.12s ease, color 0.12s ease',
            ':hover': {
                background: (el, s)=>s.root.densityMode === 'compact' ? 'cyan.15' : 'overlay',
                color: (el, s)=>s.root.densityMode === 'compact' ? 'cyan' : 'title'
            },
            title: "Compact view \u2014 tighter card padding",
            text: 'Compact',
            onClick: (e, el, s)=>{
                const root = s.root || el.getRoot();
                if (root) root.update({
                    densityMode: 'compact'
                });
            }
        },
        Comfortable: {
            tag: 'button',
            padding: 'V Z',
            fontSize: 'Y2',
            fontWeight: (el, s)=>(s.root.densityMode || 'comfortable') === 'comfortable' ? '700' : '500',
            cursor: 'pointer',
            border: 'none',
            background: (el, s)=>(s.root.densityMode || 'comfortable') === 'comfortable' ? 'cyan.15' : 'transparent',
            color: (el, s)=>(s.root.densityMode || 'comfortable') === 'comfortable' ? 'cyan' : 'caption',
            transition: 'background 0.12s ease, color 0.12s ease',
            ':hover': {
                background: (el, s)=>(s.root.densityMode || 'comfortable') === 'comfortable' ? 'cyan.15' : 'overlay',
                color: (el, s)=>(s.root.densityMode || 'comfortable') === 'comfortable' ? 'cyan' : 'title'
            },
            title: "Comfortable view \u2014 standard card padding",
            text: 'Comfortable',
            onClick: (e, el, s)=>{
                const root = s.root || el.getRoot();
                if (root) root.update({
                    densityMode: 'comfortable'
                });
            }
        }
    }
};
const $8c929b926840afcd$export$1aeb75242765623 = {
    flow: 'x',
    gap: 'Z',
    align: 'center left',
    padding: 'Z A',
    round: 'Z1',
    background: 'overlay',
    borderWidth: 'V',
    borderStyle: 'solid',
    borderColor: 'line',
    transition: 'border-color 0.12s ease',
    onInit: (el)=>{
        // Store reference for global 'c' key handler to find
        const input = el.node && el.node.querySelector('[data-quick-create-input]');
        if (input) el._quickCreateInput = input;
    },
    Icon: {
        tag: 'span',
        fontSize: 'Y1',
        color: 'caption',
        flexShrink: '0',
        text: '+'
    },
    Input: {
        tag: 'input',
        flex: '1',
        border: 'none',
        background: 'transparent',
        fontSize: 'Y1',
        color: 'title',
        outline: 'none',
        placeholder: "Quick-create ticket in active bucket\u2026 (press c)",
        'data-quick-create-input': 'true',
        onFocus: (e, el, s)=>{
            const parent = el.parent;
            if (parent && parent.node) parent.node.style.borderColor = 'var(--color-cyan)';
        },
        onBlur: (e, el, s)=>{
            const parent = el.parent;
            if (parent && parent.node) parent.node.style.borderColor = '';
        },
        onKeydown: async (e, el, s)=>{
            if (e.key === 'Escape') {
                e.preventDefault();
                if (el.node) {
                    el.node.value = '';
                    el.node.blur();
                }
                return;
            }
            if (e.key === 'Enter') {
                e.preventDefault();
                const title = el.node ? el.node.value.trim() : '';
                if (!title) return;
                // Determine target bucket state from active kbFocusBucket or 'now'
                const root = s.root || el.getRoot();
                const bk = root && root.kbFocusBucket || 'now';
                const stateMap = {
                    now: 'in_progress',
                    ongoing: 'in_progress',
                    upcoming: 'not_started',
                    pendingApproval: 'awaiting_approval'
                };
                const ticketState = stateMap[bk] || 'not_started';
                try {
                    await (el.sdk || (0, $bfqVY.getSDK)()).execute('workspaceProject.tickets', 'create', {
                        payload: {
                            title: title,
                            state: ticketState,
                            type: 'task'
                        }
                    });
                    if (el.node) {
                        el.node.value = '';
                        el.node.blur();
                    }
                    // Trigger store refresh so new ticket appears in the bucket.
                    (0, $lB5wE.ticketStore).refresh().catch(()=>{});
                } catch (err) {
                    console.error('[QuickCreate]', err);
                }
            }
        }
    },
    Hint: {
        tag: 'kbd',
        fontSize: 'Y2',
        padding: 'V Y',
        round: 'Y',
        flexShrink: '0',
        color: 'caption',
        background: 'line',
        borderWidth: 'V',
        borderStyle: 'solid',
        borderColor: 'overlayStrong',
        fontFamily: 'monospace',
        title: 'Press c to focus',
        text: 'c'
    }
};
const $8c929b926840afcd$export$89d86c8bd3903b20 = {
    position: 'fixed',
    bottom: 'A',
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: '200',
    hide: (el, s)=>{
        const ids = s.root && s.root.selectedTicketIds;
        return !Array.isArray(ids) || ids.length === 0;
    },
    // AC6: expose selection state as DOM attributes so automated tests can
    // verify multiselect without triggering synthetic click events that hit
    // the DOMQL state boundary. Tests read:
    //   document.querySelector('[data-test-selection-bar]').dataset.testSelectedCount
    //   document.querySelector('[data-test-selection-bar]').dataset.testSelectedIds
    'data-test-selection-bar': 'true',
    'data-test-selected-count': (el, s)=>{
        const ids = s.root && s.root.selectedTicketIds;
        return Array.isArray(ids) && ids.length ? String(ids.length) : '0';
    },
    'data-test-selected-ids': (el, s)=>{
        const ids = s.root && s.root.selectedTicketIds;
        return Array.isArray(ids) && ids.length ? ids.join(',') : '';
    },
    flow: 'x',
    gap: 'Z',
    align: 'center center',
    padding: 'Z B',
    round: 'A',
    background: 'title',
    boxShadow: '0 4px 24px var(--color-shadow)',
    borderWidth: 'V',
    borderStyle: 'solid',
    borderColor: 'line',
    Count: {
        tag: 'span',
        fontSize: 'Y1',
        fontWeight: '700',
        color: 'document',
        text: (el, s)=>{
            const ids = s.root && s.root.selectedTicketIds;
            const n = Array.isArray(ids) ? ids.length : 0;
            return `${n} selected`;
        }
    },
    Sep_1: {
        tag: 'span',
        width: 'V',
        height: 'A',
        background: 'line',
        opacity: '.3'
    },
    MoveBtn: {
        tag: 'button',
        padding: 'Y Z',
        round: 'Z',
        border: 'none',
        cursor: 'pointer',
        fontSize: 'Y2',
        fontWeight: '600',
        background: 'transparent',
        color: 'document',
        transition: 'background 0.1s ease',
        ':hover': {
            background: 'color-mix(in srgb, var(--color-white) 15%, transparent)'
        },
        text: "Move to\u2026",
        onClick: (e, el, s)=>{
            // Stub: future — open a bucket-picker popover
            console.log('[SelectionBar] Move:', s.root.selectedTicketIds || []);
        }
    },
    AssignBtn: {
        tag: 'button',
        padding: 'Y Z',
        round: 'Z',
        border: 'none',
        cursor: 'pointer',
        fontSize: 'Y2',
        fontWeight: '600',
        background: 'transparent',
        color: 'document',
        transition: 'background 0.1s ease',
        ':hover': {
            background: 'color-mix(in srgb, var(--color-white) 15%, transparent)'
        },
        text: "Assign\u2026",
        onClick: (e, el, s)=>{
            console.log('[SelectionBar] Assign:', s.root.selectedTicketIds || []);
        }
    },
    Sep_2: {
        tag: 'span',
        width: 'V',
        height: 'A',
        background: 'line',
        opacity: '.3'
    },
    ClearBtn: {
        tag: 'button',
        padding: 'Y Z',
        round: 'Z',
        border: 'none',
        cursor: 'pointer',
        fontSize: 'Y2',
        fontWeight: '600',
        background: 'transparent',
        color: 'caption',
        transition: 'background 0.1s ease',
        ':hover': {
            background: 'color-mix(in srgb, var(--color-white) 15%, transparent)'
        },
        text: 'Clear selection',
        onClick: (e, el, s)=>{
            const root = s.root || el.getRoot();
            if (root) root.update({
                selectedTicketIds: []
            });
        }
    }
};

});

parcelRegister("1xVWB", function(module, exports) {

$parcel$export(module.exports, "TicketsCanvasMain", () => $1205d20a38cd2806$export$5198511f0fb0b18a);
$parcel$export(module.exports, "CanvasEpicRailItem", () => $1205d20a38cd2806$export$7373f270e66962e7);
$parcel$export(module.exports, "CanvasBoardGroup", () => $1205d20a38cd2806$export$e7b10a7e10ec8d8f);
$parcel$export(module.exports, "CanvasTicketCard", () => $1205d20a38cd2806$export$ae335a2b64b05b26);
$parcel$export(module.exports, "CanvasFilterChip", () => $1205d20a38cd2806$export$2ad62b86aa534df5);
$parcel$export(module.exports, "CanvasDepthTab", () => $1205d20a38cd2806$export$6fe56b4989d60828);
// /tickets/canvas — 3-pane board: left epic nav, center grouped board,
// right filters + selected-ticket detail.
//
// Grouping is stored in s.root.canvasGroupBy (default 'story').
// Active epic filter in s.root.canvasEpicFilter (null = all).
// Selected ticket in s.root.selectedTicket (opens right-pane detail).
// Drag-to-bucket: pointer events delegated at board level, not per-card.
// URL state: ?groupBy=story&epic=<key>
//
// Drag mutation map:
//   status   → PATCH state
//   priority → PATCH priority
//   assignee → PATCH assignee_email
//   epic     → PATCH parent_ticket_id (epic row id)
//   story    → PATCH parent_ticket_id (story row id)

var $l4iSc = parcelRequire("l4iSc");

var $7MNpT = parcelRequire("7MNpT");
// ── Helpers ──────────────────────────────────────────────────────────────────
const $1205d20a38cd2806$var$_groupOptions = [
    {
        key: 'story',
        label: 'Story'
    },
    {
        key: 'epic',
        label: 'Epic'
    },
    {
        key: 'status',
        label: 'Status'
    },
    {
        key: 'priority',
        label: 'Priority'
    },
    {
        key: 'assignee',
        label: 'Assignee'
    },
    {
        key: 'none',
        label: 'None'
    }
];
const $1205d20a38cd2806$var$_getGroupBy = (root)=>root?.canvasGroupBy || 'story';
const $1205d20a38cd2806$var$_getActiveEpic = (root)=>root?.canvasEpicFilter || null;
// Filter + re-group canvasAllTickets based on current root settings.
const $1205d20a38cd2806$var$_computeGroups = (root)=>{
    const all = root?.canvasAllTickets || [];
    const epicFilter = $1205d20a38cd2806$var$_getActiveEpic(root);
    const stateFilter = root?.canvasStateFilter || null;
    const priorityFilter = root?.canvasPriorityFilter || null;
    const groupBy = $1205d20a38cd2806$var$_getGroupBy(root);
    let filtered = all;
    if (epicFilter) filtered = filtered.filter((t)=>t.parentEpicKey === epicFilter);
    if (stateFilter) filtered = filtered.filter((t)=>t.state === stateFilter);
    if (priorityFilter) filtered = filtered.filter((t)=>t.priority === priorityFilter);
    return (0, $l4iSc.groupTickets)(filtered, groupBy);
};
// Persist ?groupBy= + ?epic= to the URL without a page reload.
const $1205d20a38cd2806$var$_syncUrl = (root)=>{
    if (typeof window === 'undefined') return;
    try {
        const u = new URL(window.location);
        const g = $1205d20a38cd2806$var$_getGroupBy(root);
        if (g && g !== 'story') u.searchParams.set('groupBy', g);
        else u.searchParams.delete('groupBy');
        const e = $1205d20a38cd2806$var$_getActiveEpic(root);
        if (e) u.searchParams.set('epic', e);
        else u.searchParams.delete('epic');
        window.history.replaceState(null, '', u);
    } catch (_) {}
};
// Board-level drag handler — attached once to the center pane container.
// Avoids per-card listener attachment (prevents #4382-style tree cascade).
let $1205d20a38cd2806$var$_rafId = null;
const $1205d20a38cd2806$var$_onBoardPointerMove = (e)=>{
    if ($1205d20a38cd2806$var$_rafId) cancelAnimationFrame($1205d20a38cd2806$var$_rafId);
    $1205d20a38cd2806$var$_rafId = requestAnimationFrame(()=>{
        $1205d20a38cd2806$var$_rafId = null;
        // Highlight drop targets via CSS data attribute
        document.querySelectorAll('[data-drop-group]').forEach((el)=>{
            const rect = el.getBoundingClientRect();
            const over = e.clientX >= rect.left && e.clientX <= rect.right && e.clientY >= rect.top && e.clientY <= rect.bottom;
            el.dataset.dragOver = over ? 'true' : '';
        });
    });
};
// Toast helper — post to root.canvasToast for a 2.5s flash.
const $1205d20a38cd2806$var$_toast = (root, msg, ok = true)=>{
    if (!root || typeof root.update !== 'function') return;
    root.update({
        canvasToast: {
            msg: msg,
            ok: ok,
            ts: Date.now()
        }
    });
    setTimeout(()=>root.update({
            canvasToast: null
        }), 2500);
};
// Mutation key for drop target (what field + value to PATCH).
const $1205d20a38cd2806$var$_dropMutation = (groupBy, groupKey, root)=>{
    if (groupBy === 'status') return {
        field: 'state',
        value: groupKey
    };
    if (groupBy === 'priority') return {
        field: 'priority',
        value: groupKey === '_none' ? null : groupKey
    };
    if (groupBy === 'assignee') return {
        field: 'assignee_email',
        value: groupKey === '_unassigned' ? null : groupKey
    };
    if (groupBy === 'epic') {
        const epics = root?.canvasEpics || [];
        const ep = epics.find((e)=>e.epicKey === groupKey);
        return {
            field: 'parent_ticket_id',
            value: ep?.id || null
        };
    }
    if (groupBy === 'story') {
        const stories = root?.canvasStories || [];
        const st = stories.find((s)=>String(s.id) === groupKey);
        return {
            field: 'parent_ticket_id',
            value: st?.id || null
        };
    }
    return null;
};
// Accent colour for a group header based on groupBy + groupKey.
const $1205d20a38cd2806$var$_groupAccent = (groupBy, groupKey)=>{
    if (groupBy === 'status') return (0, $7MNpT.TICKET_STATE_COLOR)[groupKey] || 'caption';
    if (groupBy === 'priority') return (0, $7MNpT.PRIORITY_COLOR)[groupKey] || 'caption';
    if (groupBy === 'epic') return 'cyan';
    if (groupBy === 'story') return 'blue';
    return 'caption';
};
const $1205d20a38cd2806$export$5198511f0fb0b18a = {
    extends: 'AppMain',
    padding: '0',
    Header: {
        extends: 'TicketsHeader'
    },
    Body: {
        overflow: 'auto',
        flow: 'y',
        // ── Top bar ─────────────────────────────────────────────────────────────
        TopBar: {
            flow: 'x',
            align: 'center left',
            gap: 'A',
            padding: 'Z A',
            borderBottomWidth: 'V',
            borderBottomStyle: 'solid',
            borderBottomColor: 'line',
            flexWrap: 'wrap',
            PageTitle: {
                tag: 'h1',
                margin: '0',
                fontSize: 'B',
                fontWeight: '700',
                letterSpacing: '-.02em',
                color: 'title',
                text: 'Canvas'
            },
            Sep: {
                tag: 'span',
                color: 'caption',
                opacity: '.3',
                fontSize: 'B',
                text: '/'
            },
            // Breadcrumb epic chip (shown when epic filter is active)
            EpicBreadcrumb: {
                hide: (el, s)=>!$1205d20a38cd2806$var$_getActiveEpic(s.root),
                flow: 'x',
                gap: 'V',
                align: 'center left',
                EpicLabel: {
                    tag: 'span',
                    padding: 'V Z',
                    round: 'Y2',
                    fontSize: 'Y2',
                    fontWeight: '700',
                    background: 'cyan.15',
                    color: 'cyan',
                    text: (el, s)=>{
                        const e = $1205d20a38cd2806$var$_getActiveEpic(s.root);
                        const epics = s.root?.canvasEpics || [];
                        const ep = epics.find((x)=>x.epicKey === e);
                        return ep?.title || (e || '').toUpperCase();
                    }
                },
                ClearEpic: {
                    tag: 'button',
                    type: 'button',
                    padding: 'V Z',
                    round: 'Y2',
                    border: 'none',
                    cursor: 'pointer',
                    background: 'line',
                    color: 'caption',
                    fontSize: 'Y2',
                    text: "\xd7",
                    title: 'Clear epic filter',
                    onClick: (e, el, s)=>{
                        s.root.update({
                            canvasEpicFilter: null
                        });
                        $1205d20a38cd2806$var$_syncUrl(s.root);
                    }
                }
            },
            Spacer: {
                flex: '1'
            },
            // Group-by selector
            GroupByLabel: {
                tag: 'label',
                fontSize: 'Y2',
                color: 'caption',
                fontWeight: '600',
                for: 'canvas-groupby',
                text: 'Group by'
            },
            GroupBySelect: {
                tag: 'select',
                id: 'canvas-groupby',
                fontSize: 'Y2',
                fontWeight: '600',
                padding: 'V Z',
                round: 'Y2',
                borderWidth: 'V',
                borderStyle: 'solid',
                borderColor: 'line',
                background: 'overlay',
                color: 'title',
                cursor: 'pointer',
                onRender: (el, s)=>{
                    if (!el.node) return;
                    const val = $1205d20a38cd2806$var$_getGroupBy(s.root);
                    el.node.innerHTML = $1205d20a38cd2806$var$_groupOptions.map((o)=>`<option value="${o.key}"${o.key === val ? ' selected' : ''}>${o.label}</option>`).join('');
                },
                onChange: (e, el, s)=>{
                    const val = el.node?.value || 'story';
                    s.root.update({
                        canvasGroupBy: val
                    });
                    $1205d20a38cd2806$var$_syncUrl(s.root);
                }
            },
            // State filter pill strip
            StateFilters: {
                flow: 'x',
                gap: 'V',
                align: 'center left',
                flexWrap: 'wrap',
                childExtends: 'CanvasFilterChip',
                childrenAs: 'state',
                children: (el, s)=>{
                    const active = s.root?.canvasStateFilter || null;
                    return [
                        {
                            key: null,
                            label: 'All',
                            filterKey: 'canvasStateFilter',
                            active: !active
                        },
                        {
                            key: 'in_progress',
                            label: 'In Progress',
                            filterKey: 'canvasStateFilter',
                            active: active === 'in_progress'
                        },
                        {
                            key: 'not_started',
                            label: 'Not Started',
                            filterKey: 'canvasStateFilter',
                            active: active === 'not_started'
                        },
                        {
                            key: 'done',
                            label: 'Done',
                            filterKey: 'canvasStateFilter',
                            active: active === 'done'
                        }
                    ];
                }
            },
            // Count badge
            CountBadge: {
                tag: 'span',
                fontSize: 'Y2',
                color: 'caption',
                text: (el, s)=>{
                    const groups = $1205d20a38cd2806$var$_computeGroups(s.root);
                    const total = groups.reduce((a, g)=>a + g.tickets.length, 0);
                    return `${total} ticket${total === 1 ? '' : 's'}`;
                }
            }
        },
        // ── 3-pane layout ────────────────────────────────────────────────────────
        Panes: {
            flow: 'x',
            flex: '1',
            overflow: 'hidden',
            minHeight: '0',
            alignItems: 'stretch',
            // ── LEFT: Epic navigation rail ─────────────────────────────────────────
            EpicRail: {
                width: '220px',
                minWidth: '180px',
                maxWidth: '260px',
                flexShrink: '0',
                flow: 'y',
                borderRightWidth: 'V',
                borderRightStyle: 'solid',
                borderRightColor: 'line',
                overflow: 'auto',
                RailHeader: {
                    padding: 'A A V A',
                    flow: 'x',
                    align: 'baseline space-between',
                    borderBottomWidth: 'V',
                    borderBottomStyle: 'solid',
                    borderBottomColor: 'line',
                    RailTitle: {
                        tag: 'h2',
                        margin: '0',
                        fontSize: 'Y1',
                        fontWeight: '700',
                        letterSpacing: '.1em',
                        color: 'caption',
                        text: 'EPICS'
                    },
                    EpicCount: {
                        tag: 'span',
                        fontSize: 'Y2',
                        color: 'caption',
                        text: (el, s)=>`${(s.root?.canvasEpics || []).length}`
                    }
                },
                AllEpicBtn: {
                    flow: 'x',
                    gap: 'V',
                    align: 'center left',
                    padding: 'Z A',
                    cursor: 'pointer',
                    transition: 'background 100ms ease',
                    borderLeftWidth: '3px',
                    borderLeftStyle: 'solid',
                    borderLeftColor: (el, s)=>!$1205d20a38cd2806$var$_getActiveEpic(s.root) ? 'cyan' : 'transparent',
                    background: (el, s)=>!$1205d20a38cd2806$var$_getActiveEpic(s.root) ? 'cyan.06' : 'transparent',
                    ':hover': {
                        background: 'overlay'
                    },
                    onClick: (e, el, s)=>{
                        s.root.update({
                            canvasEpicFilter: null
                        });
                        $1205d20a38cd2806$var$_syncUrl(s.root);
                    },
                    AllLabel: {
                        tag: 'span',
                        fontSize: 'Y2',
                        fontWeight: (el, s)=>!$1205d20a38cd2806$var$_getActiveEpic(s.root) ? '700' : '400',
                        color: (el, s)=>!$1205d20a38cd2806$var$_getActiveEpic(s.root) ? 'cyan' : 'title',
                        text: 'All Epics'
                    }
                },
                EpicList: {
                    flow: 'y',
                    padding: 'V 0',
                    childExtends: 'CanvasEpicRailItem',
                    childrenAs: 'state',
                    children: (el, s)=>s.root?.canvasEpics || []
                }
            },
            // ── CENTER: Board ───────────────────────────────────────────────────────
            BoardPane: {
                flex: '1',
                flow: 'y',
                overflow: 'auto',
                minWidth: '0',
                // Loading state
                Loading: {
                    hide: (el, s)=>s.root?.canvasAllTickets != null,
                    flow: 'y',
                    align: 'center center',
                    gap: 'A',
                    padding: 'D',
                    flex: '1',
                    Spinner: {
                        boxSize: 'C',
                        round: '50%',
                        borderWidth: '2px',
                        borderStyle: 'solid',
                        borderColor: 'caption.2',
                        borderTopColor: 'cyan',
                        animation: 'canvas-spin 0.9s linear infinite',
                        '@keyframes canvas-spin': {
                            from: {
                                transform: 'rotate(0deg)'
                            },
                            to: {
                                transform: 'rotate(360deg)'
                            }
                        }
                    },
                    Label: {
                        tag: 'p',
                        margin: '0',
                        fontSize: 'A',
                        color: 'caption',
                        text: "Loading board\u2026"
                    }
                },
                // Empty state per current filter
                BoardEmpty: {
                    hide: (el, s)=>{
                        const all = s.root?.canvasAllTickets;
                        if (all == null) return true;
                        return $1205d20a38cd2806$var$_computeGroups(s.root).some((g)=>g.tickets.length > 0);
                    },
                    flow: 'y',
                    align: 'center center',
                    gap: 'A',
                    padding: 'D',
                    flex: '1',
                    textAlign: 'center',
                    Icon: {
                        extends: 'Icon',
                        icon: 'magicstar',
                        boxSize: 'D',
                        color: 'caption',
                        opacity: '.4'
                    },
                    Title: {
                        tag: 'h3',
                        margin: '0',
                        fontSize: 'B',
                        fontWeight: '600',
                        color: 'title',
                        text: 'No tickets to show'
                    },
                    Lede: {
                        tag: 'p',
                        margin: '0',
                        fontSize: 'A',
                        color: 'caption',
                        lineHeight: '1.5',
                        text: 'Try removing filters or choosing a different grouping.'
                    }
                },
                // Multi-select action bar (bottom of center pane)
                MultiSelectBar: {
                    hide: (el, s)=>!(s.root?.canvasSelected?.length > 0),
                    position: 'sticky',
                    bottom: '0',
                    flow: 'x',
                    align: 'center space-between',
                    gap: 'A',
                    padding: 'Z A',
                    background: 'overlay',
                    borderTopWidth: 'V',
                    borderTopStyle: 'solid',
                    borderTopColor: 'line',
                    backdropFilter: 'blur(12px)',
                    zIndex: '10',
                    SelCount: {
                        tag: 'span',
                        fontSize: 'Y1',
                        fontWeight: '700',
                        color: 'title',
                        text: (el, s)=>{
                            const n = (s.root?.canvasSelected || []).length;
                            return `${n} ticket${n === 1 ? '' : 's'} selected`;
                        }
                    },
                    Actions: {
                        flow: 'x',
                        gap: 'V',
                        ClearSel: {
                            tag: 'button',
                            type: 'button',
                            padding: 'V Z',
                            round: 'Y2',
                            border: 'none',
                            cursor: 'pointer',
                            background: 'line',
                            color: 'caption',
                            fontSize: 'Y2',
                            fontWeight: '600',
                            text: 'Clear',
                            onClick: (e, el, s)=>{
                                s.root.update({
                                    canvasSelected: []
                                });
                            }
                        }
                    }
                },
                // Board groups container — pointer events for drag delegated here.
                BoardGroups: {
                    flow: 'y',
                    gap: 'B',
                    padding: 'B A D A',
                    // Attach board-level pointer listener once.
                    onInit: (el)=>{
                        if (!el.node) return;
                        el.node.addEventListener('pointermove', $1205d20a38cd2806$var$_onBoardPointerMove, {
                            passive: true
                        });
                    },
                    onRemove: (el)=>{
                        if (!el.node) return;
                        el.node.removeEventListener('pointermove', $1205d20a38cd2806$var$_onBoardPointerMove);
                    },
                    childExtends: 'CanvasBoardGroup',
                    childrenAs: 'state',
                    children: (el, s)=>{
                        const all = s.root?.canvasAllTickets;
                        if (all == null) return [];
                        return $1205d20a38cd2806$var$_computeGroups(s.root);
                    }
                }
            },
            // ── RIGHT: Filters + detail ────────────────────────────────────────────
            RightPane: {
                width: '280px',
                minWidth: '220px',
                maxWidth: '320px',
                flexShrink: '0',
                flow: 'y',
                borderLeftWidth: 'V',
                borderLeftStyle: 'solid',
                borderLeftColor: 'line',
                overflow: 'auto',
                // Collapse below 1280px via CSS media query approach
                '@maxWidth1280': {
                    display: 'none'
                },
                // Detail view for selected ticket
                TicketDetail: {
                    hide: (el, s)=>!s.root?.selectedTicket,
                    flow: 'y',
                    gap: 'V',
                    DetailHeader: {
                        flow: 'x',
                        align: 'center space-between',
                        padding: 'A A V A',
                        borderBottomWidth: 'V',
                        borderBottomStyle: 'solid',
                        borderBottomColor: 'line',
                        DetailTitle: {
                            tag: 'h3',
                            margin: '0',
                            fontSize: 'Y1',
                            fontWeight: '700',
                            letterSpacing: '.1em',
                            color: 'caption',
                            text: 'SELECTED'
                        },
                        CloseDetail: {
                            tag: 'button',
                            type: 'button',
                            padding: 'V Z',
                            border: 'none',
                            background: 'transparent',
                            color: 'caption',
                            cursor: 'pointer',
                            fontSize: 'Y1',
                            fontWeight: '700',
                            text: "\xd7",
                            onClick: (e, el, s)=>{
                                s.root.update({
                                    selectedTicket: null
                                });
                            }
                        }
                    },
                    DetailBody: {
                        flow: 'y',
                        gap: 'Z',
                        padding: 'A',
                        DetailId: {
                            tag: 'span',
                            fontSize: 'Y2',
                            fontWeight: '700',
                            color: 'caption',
                            fontFamily: 'monospace',
                            text: (el, s)=>s.root?.selectedTicket?.external_id || `#${s.root?.selectedTicket?.id || ''}`
                        },
                        DetailTitleText: {
                            tag: 'h4',
                            margin: '0',
                            fontSize: 'A',
                            fontWeight: '600',
                            lineHeight: '1.3',
                            color: 'title',
                            text: (el, s)=>s.root?.selectedTicket?.title || ''
                        },
                        StatePill: {
                            hide: (el, s)=>!s.root?.selectedTicket?.state,
                            tag: 'span',
                            display: 'inline-flex',
                            padding: 'V Z',
                            round: 'Y2',
                            fontSize: 'Y2',
                            fontWeight: '700',
                            color: (el, s)=>(0, $7MNpT.TICKET_STATE_COLOR)[s.root?.selectedTicket?.state] || 'caption',
                            background: (el, s)=>{
                                const c = (0, $7MNpT.TICKET_STATE_COLOR)[s.root?.selectedTicket?.state] || 'caption';
                                return `color-mix(in srgb, var(--color-${c}) 16%, transparent)`;
                            },
                            text: (el, s)=>{
                                const t = s.root?.selectedTicket;
                                return (t?.state || '').replace(/_/g, ' ').replace(/\b\w/g, (c)=>c.toUpperCase());
                            }
                        },
                        PriorityPill: {
                            hide: (el, s)=>!s.root?.selectedTicket?.priority,
                            tag: 'span',
                            display: 'inline-flex',
                            padding: 'V Z',
                            round: 'Y2',
                            fontSize: 'Y2',
                            fontWeight: '700',
                            color: (el, s)=>(0, $7MNpT.PRIORITY_COLOR)[s.root?.selectedTicket?.priority] || 'caption',
                            background: (el, s)=>{
                                const c = (0, $7MNpT.PRIORITY_COLOR)[s.root?.selectedTicket?.priority] || 'caption';
                                return `color-mix(in srgb, var(--color-${c}) 16%, transparent)`;
                            },
                            text: (el, s)=>s.root?.selectedTicket?.priority || ''
                        },
                        AssigneeRow: {
                            hide: (el, s)=>!s.root?.selectedTicket?.assignee_email,
                            flow: 'x',
                            gap: 'V',
                            align: 'center left',
                            AvatarImg: {
                                tag: 'img',
                                width: 'Z1',
                                height: 'Z1',
                                round: '100%',
                                src: (el, s)=>{
                                    const person = el.call('findPerson', s.root?.selectedTicket?.assignee_email);
                                    return el.call('avatarUrl', person?.name || s.root?.selectedTicket?.assignee_email);
                                },
                                alt: (el, s)=>{
                                    const person = el.call('findPerson', s.root?.selectedTicket?.assignee_email);
                                    return person?.name || s.root?.selectedTicket?.assignee_email || '';
                                }
                            },
                            AssigneeName: {
                                tag: 'span',
                                fontSize: 'Y2',
                                color: 'caption',
                                text: (el, s)=>{
                                    const person = el.call('findPerson', s.root?.selectedTicket?.assignee_email);
                                    return person?.name || (s.root?.selectedTicket?.assignee_email || '').split('@')[0];
                                }
                            }
                        },
                        EpicRow: {
                            hide: (el, s)=>!s.root?.selectedTicket?.parentEpicTitle,
                            flow: 'x',
                            gap: 'V',
                            align: 'center left',
                            EpicChip: {
                                tag: 'span',
                                padding: 'V Z',
                                round: 'Y2',
                                fontSize: 'Y2',
                                fontWeight: '600',
                                background: 'cyan.15',
                                color: 'cyan',
                                text: (el, s)=>s.root?.selectedTicket?.parentEpicTitle || ''
                            }
                        },
                        StoryRow: {
                            hide: (el, s)=>!s.root?.selectedTicket?.parentStoryTitle,
                            flow: 'x',
                            gap: 'V',
                            align: 'center left',
                            StoryChip: {
                                tag: 'span',
                                padding: 'V Z',
                                round: 'Y2',
                                fontSize: 'Y2',
                                fontWeight: '600',
                                background: 'blue.15',
                                color: 'blue',
                                text: (el, s)=>s.root?.selectedTicket?.parentStoryTitle || ''
                            }
                        },
                        OpenDetailLink: {
                            tag: 'button',
                            type: 'button',
                            marginTop: 'Z',
                            align: 'center center',
                            width: '100%',
                            padding: 'Z',
                            round: 'Y2',
                            border: 'none',
                            cursor: 'pointer',
                            background: 'blue.15',
                            color: 'blue',
                            fontSize: 'Y2',
                            fontWeight: '700',
                            text: 'Open full detail',
                            onClick: (e, el, s)=>{
                            // TicketDetailModal reads from s.root.selectedTicket
                            // so just ensure it's set (it already is) and the modal
                            // will open via its own show binding.
                            }
                        }
                    }
                },
                // Placeholder when nothing is selected
                DetailEmpty: {
                    hide: (el, s)=>!!s.root?.selectedTicket,
                    flow: 'y',
                    align: 'center center',
                    gap: 'A',
                    padding: 'C A',
                    textAlign: 'center',
                    flex: '1',
                    EmptyIcon: {
                        extends: 'Icon',
                        icon: 'ticket',
                        boxSize: 'C',
                        color: 'caption',
                        opacity: '.25'
                    },
                    EmptyText: {
                        tag: 'p',
                        margin: '0',
                        fontSize: 'Y1',
                        color: 'caption',
                        lineHeight: '1.5',
                        text: 'Click a ticket card to see its details here.'
                    }
                },
                // Priority filter section
                PriorityFilters: {
                    flow: 'y',
                    gap: 'V',
                    padding: 'A',
                    borderTopWidth: 'V',
                    borderTopStyle: 'solid',
                    borderTopColor: 'line',
                    marginTop: 'auto',
                    PriorityFilterLabel: {
                        tag: 'span',
                        fontSize: 'Y2',
                        fontWeight: '700',
                        letterSpacing: '.1em',
                        color: 'caption',
                        marginBottom: 'V',
                        text: 'PRIORITY'
                    },
                    PriorityChips: {
                        flow: 'x',
                        gap: 'V',
                        flexWrap: 'wrap',
                        childExtends: 'CanvasFilterChip',
                        childrenAs: 'state',
                        children: (el, s)=>{
                            const active = s.root?.canvasPriorityFilter || null;
                            return [
                                {
                                    key: null,
                                    label: 'All',
                                    filterKey: 'canvasPriorityFilter',
                                    active: !active
                                },
                                {
                                    key: 'P0',
                                    label: 'P0',
                                    filterKey: 'canvasPriorityFilter',
                                    active: active === 'P0'
                                },
                                {
                                    key: 'P1',
                                    label: 'P1',
                                    filterKey: 'canvasPriorityFilter',
                                    active: active === 'P1'
                                },
                                {
                                    key: 'P2',
                                    label: 'P2',
                                    filterKey: 'canvasPriorityFilter',
                                    active: active === 'P2'
                                }
                            ];
                        }
                    }
                }
            }
        }
    },
    // ── Toast overlay ────────────────────────────────────────────────────────────
    Toast: {
        hide: (el, s)=>!s.root?.canvasToast,
        position: 'fixed',
        bottom: 'B',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: '99',
        padding: 'Z A',
        round: 'A',
        background: (el, s)=>s.root?.canvasToast?.ok ? 'green.15' : 'red.15',
        borderWidth: 'V',
        borderStyle: 'solid',
        borderColor: (el, s)=>s.root?.canvasToast?.ok ? 'green.a+30' : 'red.a+30',
        color: (el, s)=>s.root?.canvasToast?.ok ? 'green' : 'red',
        fontSize: 'Y1',
        fontWeight: '600',
        pointerEvents: 'none',
        text: (el, s)=>s.root?.canvasToast?.msg || ''
    }
};
const $1205d20a38cd2806$export$7373f270e66962e7 = {
    flow: 'y',
    gap: 'V',
    padding: 'Z A',
    cursor: 'pointer',
    transition: 'background 100ms ease',
    borderLeftWidth: '3px',
    borderLeftStyle: 'solid',
    borderLeftColor: (el, s)=>{
        const active = el?.state?.root?.canvasEpicFilter;
        return active === s.epicKey ? 'cyan' : 'transparent';
    },
    background: (el, s)=>{
        const active = el?.state?.root?.canvasEpicFilter;
        return active === s.epicKey ? 'cyan.06' : 'transparent';
    },
    ':hover': {
        background: 'overlay'
    },
    onClick: (e, el, s)=>{
        const root = s.root || el.getRoot();
        const newKey = root?.canvasEpicFilter === s.epicKey ? null : s.epicKey;
        root.update({
            canvasEpicFilter: newKey
        });
        $1205d20a38cd2806$var$_syncUrl(root);
    },
    Row: {
        flow: 'x',
        gap: 'V',
        align: 'center space-between',
        EpicName: {
            tag: 'span',
            fontSize: 'Y2',
            fontWeight: (el, s)=>{
                const active = el?.state?.root?.canvasEpicFilter;
                return active === el?.parent?.parent?.state?.epicKey ? '700' : '500';
            },
            color: (el, s)=>{
                const active = el?.state?.root?.canvasEpicFilter;
                return active === el?.parent?.parent?.state?.epicKey ? 'cyan' : 'title';
            },
            flex: '1',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>el.parent.parent.state.title || el.parent.parent.state.epicKey?.toUpperCase() || ''
        },
        DonePct: {
            tag: 'span',
            flexShrink: '0',
            fontSize: 'Y2',
            fontWeight: '600',
            color: (el, s)=>(el.parent.parent.state.donePct || 0) >= 100 ? 'green' : 'caption',
            text: (el, s)=>{
                const d = el.parent.parent.state.donePct || 0;
                return d > 0 ? `${d}%` : '';
            }
        }
    },
    ProgBar: {
        hide: (el, s)=>!(s.tasksTotal + s.bugsTotal),
        height: '3px',
        round: 'V',
        background: 'line',
        overflow: 'hidden',
        Fill: {
            height: '100%',
            round: 'V',
            background: (el, s)=>{
                const d = el.parent.parent.state.donePct || 0;
                return d >= 100 ? 'var(--color-green)' : 'var(--color-cyan)';
            },
            width: (el, s)=>`${el.parent.parent.state.donePct || 0}%`,
            transition: 'width 0.2s ease'
        }
    }
};
const $1205d20a38cd2806$export$e7b10a7e10ec8d8f = {
    flow: 'y',
    gap: 'A',
    // Group header — reuses StoriesSection header treatment for story grouping,
    // and EpicsView epic-row treatment for epic grouping.
    GroupHeader: {
        flow: 'x',
        gap: 'V',
        align: 'baseline left',
        paddingBottom: 'V',
        borderBottomWidth: 'V',
        borderBottomStyle: 'solid',
        borderBottomColor: 'line',
        AccentDot: {
            width: '10px',
            height: '10px',
            round: 'round',
            flexShrink: '0',
            alignSelf: 'center',
            background: (el, s)=>`var(--color-${$1205d20a38cd2806$var$_groupAccent($1205d20a38cd2806$var$_getGroupBy(el?.state?.root), s.groupKey)})`,
            boxShadow: (el, s)=>{
                const c = $1205d20a38cd2806$var$_groupAccent($1205d20a38cd2806$var$_getGroupBy(el?.state?.root), s.groupKey);
                return `0 0 10px color-mix(in srgb, var(--color-${c}) 55%, transparent)`;
            }
        },
        GroupTitle: {
            tag: 'h2',
            margin: '0',
            fontSize: 'B',
            fontWeight: '700',
            letterSpacing: '-.02em',
            color: 'title',
            text: (el, s)=>s.groupLabel || s.groupKey || '?'
        },
        TicketCount: {
            tag: 'span',
            fontSize: 'Y1',
            fontWeight: '600',
            color: 'caption',
            text: (el, s)=>{
                const n = (s.tickets || []).length;
                return `${n} ticket${n === 1 ? '' : 's'}`;
            }
        },
        // Story meta (donePct) when grouping by story
        StoryMeta: {
            hide: (el, s)=>$1205d20a38cd2806$var$_getGroupBy(el?.state?.root) !== 'story',
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            fontStyle: 'italic',
            text: (el, s)=>{
                const storyId = s.groupKey;
                const stories = el?.state?.root?.canvasStories || [];
                const st = stories.find((x)=>String(x.id) === storyId);
                if (!st) return '';
                const ep = st.epicTitle || st.epicKey?.toUpperCase() || '';
                return ep ? `${ep}` : '';
            }
        }
    },
    // Ticket card grid — drop zone for drag-to-bucket.
    CardGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
        gap: 'A',
        minHeight: 'B1',
        padding: 'Z',
        round: 'A',
        transition: 'background 120ms ease, border-color 120ms ease',
        borderWidth: 'V',
        borderStyle: 'dashed',
        borderColor: 'transparent',
        attr: {
            'data-drop-group': (el, s)=>s.groupKey,
            'data-drag-over': ''
        },
        onDragover: (e, el, s)=>{
            e.preventDefault();
            if (el.node) el.node.dataset.dragOver = 'true';
        },
        onDragleave: (e, el, s)=>{
            if (el.node && !el.node.contains(e.relatedTarget)) el.node.dataset.dragOver = '';
        },
        onDrop: async (e, el, s)=>{
            e.preventDefault();
            if (el.node) el.node.dataset.dragOver = '';
            const ticketId = parseInt(e.dataTransfer.getData('text/plain') || e.dataTransfer.getData('text/ticket-id'), 10);
            if (!ticketId) return;
            const root = s.root || el.getRoot();
            const groupBy = $1205d20a38cd2806$var$_getGroupBy(root);
            const mutation = $1205d20a38cd2806$var$_dropMutation(groupBy, s.groupKey, root);
            if (!mutation) return;
            // Optimistic update
            const prev = (root.canvasAllTickets || []).find((t)=>t.id === ticketId);
            if (!prev) return;
            const nextTickets = (root.canvasAllTickets || []).map((t)=>{
                if (t.id !== ticketId) return t;
                const updated = {
                    ...t
                };
                if (groupBy === 'status') updated.state = mutation.value;
                else if (groupBy === 'priority') updated.priority = mutation.value;
                else if (groupBy === 'assignee') updated.assignee_email = mutation.value;
                else if (groupBy === 'epic') {
                    updated.parentEpicKey = s.groupKey === '_no_epic' ? '' : s.groupKey;
                    updated.parentEpicTitle = s.groupLabel || '';
                } else if (groupBy === 'story') {
                    const stories = root.canvasStories || [];
                    const st = stories.find((x)=>String(x.id) === s.groupKey);
                    updated.parentStoryId = st?.id || null;
                    updated.parentStoryTitle = st?.title || '';
                    updated.parentStoryKey = st?.storyKey || '';
                }
                return updated;
            });
            root.update({
                canvasAllTickets: nextTickets
            });
            const ok = await (0, $l4iSc.patchTicketField)(ticketId, mutation.field, mutation.value);
            $1205d20a38cd2806$var$_toast(root, ok ? 'Ticket moved.' : "Move failed \u2014 reverting.", ok);
            if (!ok) root.update({
                canvasAllTickets: root.canvasAllTickets.map((t)=>t.id === ticketId ? prev : t)
            });
        },
        // Empty-group drop placeholder
        DropPlaceholder: {
            hide: (el, s)=>(s.tickets || []).length > 0,
            gridColumn: '1 / -1',
            padding: 'A',
            align: 'center center',
            round: 'A',
            borderWidth: 'V',
            borderStyle: 'dashed',
            borderColor: 'caption.3',
            color: 'caption',
            fontSize: 'Y2',
            fontStyle: 'italic',
            text: 'Drop tickets here'
        },
        childExtends: 'CanvasTicketCard',
        childrenAs: 'state',
        children: (el, s)=>s.tickets || []
    }
};
const $1205d20a38cd2806$export$ae335a2b64b05b26 = {
    flow: 'y',
    gap: 'Z',
    padding: 'A',
    round: 'Z1',
    background: 'overlay',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'line',
    overflow: 'hidden',
    cursor: 'grab',
    transition: 'transform 160ms ease, border-color 160ms ease, box-shadow 160ms ease',
    ':hover': {
        transform: 'translateY(-2px)',
        borderColor: 'overlayStrong',
        boxShadow: '0 8px 24px -8px var(--color-shadow)'
    },
    ':active': {
        cursor: 'grabbing'
    },
    // Selected visual highlight
    onRender: (el, s)=>{
        if (!el.node) return;
        const sel = el?.state?.root?.canvasSelected || [];
        const isSelected = sel.includes(s.id);
        el.node.style.borderColor = isSelected ? 'var(--color-cyan)' : '';
        el.node.style.background = isSelected ? 'color-mix(in srgb, var(--color-cyan) 8%, var(--color-overlay))' : '';
    },
    attr: {
        draggable: 'true',
        'data-ticket-id': (el, s)=>String(s.id || '')
    },
    onDragstart: (e, el, s)=>{
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text/plain', String(s.id));
        e.dataTransfer.setData('text/ticket-id', String(s.id));
        if (s.root) s.root.update({
            _canvasDragging: s.id
        });
    },
    onDragend: (e, el, s)=>{
        if (s.root) s.root.update({
            _canvasDragging: null
        });
        document.querySelectorAll('[data-drop-group]').forEach((el)=>{
            el.dataset.dragOver = '';
        });
    },
    // Click: select (cmd/shift for multi), else open detail
    onClick: (e, el, s)=>{
        const root = s.root || el.getRoot();
        if (!root) return;
        if (e.metaKey || e.ctrlKey) {
            // Toggle individual selection
            const sel = root.canvasSelected || [];
            const next = sel.includes(s.id) ? sel.filter((x)=>x !== s.id) : [
                ...sel,
                s.id
            ];
            root.update({
                canvasSelected: next
            });
        } else if (e.shiftKey) {
            // Range select — add to selection without replacing
            const sel = root.canvasSelected || [];
            if (!sel.includes(s.id)) root.update({
                canvasSelected: [
                    ...sel,
                    s.id
                ]
            });
        } else root.update({
            selectedTicket: {
                ...s
            },
            canvasSelected: []
        });
    },
    // Keyboard: arrow navigation handled by CanvasBoardGroup
    onKeydown: (e, el, s)=>{
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            const root = s.root || el.getRoot();
            if (root) root.update({
                selectedTicket: {
                    ...s
                }
            });
        }
    },
    tabindex: '0',
    role: 'button',
    // Tag row — issue type + epic + state pills
    TagRow: {
        display: (el, s)=>s.type || s.parentEpicTitle || s.state ? 'flex' : 'none',
        flow: 'x',
        align: 'center left',
        gap: 'Y',
        flexWrap: 'wrap',
        TypePill: {
            display: (el, s)=>s.type ? 'inline-flex' : 'none',
            tag: 'span',
            align: 'center center',
            padding: 'V Z',
            round: 'C',
            fontSize: 'V',
            fontWeight: '700',
            letterSpacing: '.06em',
            color: (el, s)=>s.type === 'bug' ? 'red' : 'blue',
            background: (el, s)=>s.type === 'bug' ? 'color-mix(in srgb, var(--color-red) 14%, transparent)' : 'color-mix(in srgb, var(--color-blue) 14%, transparent)',
            text: (el, s)=>(s.type || '').toUpperCase()
        },
        StatePill: {
            display: (el, s)=>s.state ? 'inline-flex' : 'none',
            tag: 'span',
            align: 'center center',
            padding: 'V Z',
            round: 'C',
            fontSize: 'V',
            fontWeight: '700',
            letterSpacing: '.06em',
            color: (el, s)=>(0, $7MNpT.TICKET_STATE_COLOR)[s.state] || 'caption',
            background: (el, s)=>{
                const c = (0, $7MNpT.TICKET_STATE_COLOR)[s.state] || 'caption';
                return `color-mix(in srgb, var(--color-${c}) 14%, transparent)`;
            },
            text: (el, s)=>(s.state || '').replace(/_/g, ' ').replace(/\b\w/g, (c)=>c.toUpperCase())
        },
        PriorityDot: {
            display: (el, s)=>s.priority ? 'inline-flex' : 'none',
            title: (el, s)=>`Priority: ${s.priority || ''}`,
            width: 'Z',
            height: 'Z',
            round: '50%',
            marginLeft: 'auto',
            alignSelf: 'center',
            background: (el, s)=>(0, $7MNpT.PRIORITY_COLOR)[s.priority] || 'caption',
            boxShadow: (el, s)=>`0 0 6px color-mix(in srgb, var(--color-${(0, $7MNpT.PRIORITY_COLOR)[s.priority] || 'caption'}) 40%, transparent)`
        }
    },
    // Title
    CardTitle: {
        tag: 'h3',
        fontSize: 'Y2',
        fontWeight: '600',
        letterSpacing: '-.01em',
        color: 'title',
        margin: '0',
        lineHeight: '1.35',
        style: {
            display: '-webkit-box',
            overflow: 'hidden',
            '-webkit-line-clamp': '2',
            '-webkit-box-orient': 'vertical'
        },
        text: (el, s)=>`#${s.external_id || s.id} \xb7 ${s.title || ''}`
    },
    // Footer — assignee + age
    CardFooter: {
        flow: 'x',
        gap: 'V',
        align: 'center space-between',
        marginTop: 'V',
        Assignee: {
            hide: (el, s)=>!s.assignee_email,
            flow: 'x',
            align: 'center left',
            gap: 'V',
            Avi: {
                tag: 'img',
                width: 'Z1',
                height: 'Z1',
                round: '100%',
                src: (el, s)=>{
                    const person = el.call('findPerson', el.parent.parent.state.assignee_email);
                    return el.call('avatarUrl', person?.name || el.parent.parent.state.assignee_email);
                },
                alt: (el, s)=>{
                    const person = el.call('findPerson', el.parent.parent.state.assignee_email);
                    return person?.name || el.parent.parent.state.assignee_email || '';
                }
            },
            AviName: {
                tag: 'span',
                fontSize: 'Y2',
                color: 'caption',
                text: (el, s)=>{
                    const person = el.call('findPerson', el.parent.parent.state.assignee_email);
                    return (person?.name || el.parent.parent.state.assignee_email || '').split(' ')[0].split('@')[0];
                }
            }
        },
        Age: {
            hide: (el, s)=>!s.updated_at,
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            text: (el, s)=>s.updated_at ? s.updated_at.slice(0, 10) : ''
        }
    }
};
const $1205d20a38cd2806$export$2ad62b86aa534df5 = {
    tag: 'button',
    type: 'button',
    padding: 'V Z',
    round: 'Y2',
    fontSize: 'Y2',
    fontWeight: '600',
    cursor: 'pointer',
    borderWidth: 'V',
    borderStyle: 'solid',
    borderColor: (el, s)=>s.active ? 'cyan' : 'line',
    background: (el, s)=>s.active ? 'cyan.a+10' : 'transparent',
    color: (el, s)=>s.active ? 'cyan' : 'caption',
    transition: 'all 0.12s ease',
    text: (el, s)=>s.label || s.key,
    onClick: (e, el, s)=>{
        const root = s.root || el.getRoot();
        if (root && typeof root.update === 'function') {
            const filterKey = s.filterKey || 'canvasStateFilter';
            root.update({
                [filterKey]: s.key
            });
        }
    }
};
const $1205d20a38cd2806$export$6fe56b4989d60828 = {
    tag: 'a',
    padding: 'V Z',
    round: 'Y2',
    fontSize: 'Y2',
    fontWeight: '600',
    textDecoration: 'none',
    cursor: 'pointer',
    borderWidth: 'V',
    borderStyle: 'solid',
    borderColor: (el, s)=>s.active ? 'cyan' : 'line',
    background: (el, s)=>s.active ? 'cyan.a+10' : 'transparent',
    color: (el, s)=>s.active ? 'cyan' : 'caption',
    transition: 'all 0.12s ease',
    href: (el, s)=>`/tickets/canvas?depth=${encodeURIComponent(s.key || 'full')}`,
    text: (el, s)=>s.label || s.key
};

});

parcelRegister("kRbaA", function(module, exports) {

$parcel$export(module.exports, "TicketsStoriesMain", () => $f2f16bf8896d35cb$export$11183d5510beac9d);
$parcel$export(module.exports, "TicketsStoriesEpicGroup", () => $f2f16bf8896d35cb$export$5ceac002730fe737);
$parcel$export(module.exports, "TicketsStoryCard", () => $f2f16bf8896d35cb$export$921e8043756c4267);
// Stories index — renders s.root.storiesTree (from fetchStoriesTree).
// Groups by parent epic; each story card shows task / bug rollups +
// progress. Click opens the story in TicketDetailModal.

var $bfqVY = parcelRequire("bfqVY");
const $f2f16bf8896d35cb$var$_openStoryById = async (root, s)=>{
    if (!root || typeof root.update !== 'function') return;
    // Optimistic open so the modal appears instantly.
    root.update({
        selectedTicket: {
            id: s.id,
            external_id: `STORY#${s.storyKey}`,
            title: s.title,
            issueType: 'user-story',
            body: ''
        }
    });
    if (!s.id) return;
    // migrated 2026-04-27 to SDK route workspaceProject.tickets.get
    try {
        const t = await (0, $bfqVY.getSDK)().execute('workspaceProject.tickets', 'get', {
            id: s.id
        });
        if (!t) return;
        root.update({
            selectedTicket: {
                ...t,
                columnKey: t.column_key,
                issueType: t.issue_type || 'user-story',
                epicName: t.epic_name,
                assigneeEmail: t.assignee_email,
                reporterEmail: t.reporter_email,
                updatedAt: t.updated_at,
                createdAt: t.created_at
            }
        });
    } catch (_) {}
};
const $f2f16bf8896d35cb$export$11183d5510beac9d = {
    extends: 'AppMain',
    Header: {
        extends: 'TicketsHeader'
    },
    Body: {
        overflow: 'auto',
        Hero: {
            extends: 'PageHero',
            eyebrow: "ROADMAP \xb7 USER STORIES",
            headline: 'Stories',
            lede: (el, s)=>{
                const tree = s.root.storiesTree || [];
                if (!tree.length) return "Loading stories from public.tickets\u2026";
                const tasks = tree.reduce((a, x)=>a + x.tasksTotal, 0);
                const bugs = tree.reduce((a, x)=>a + x.bugsTotal, 0);
                return `${tree.length} stories across ${new Set(tree.map((x)=>x.epicKey)).size} epics \xb7 ${tasks} tasks + ${bugs} bugs.`;
            },
            Stats: {
                flow: 'x',
                gap: 'B',
                marginTop: 'Z',
                flexWrap: 'wrap',
                childExtends: 'TicketsEpicHeroStat',
                childrenAs: 'state',
                children: (el, s)=>{
                    const tree = s.root.storiesTree || [];
                    const tasks = tree.reduce((a, x)=>a + x.tasksTotal, 0);
                    const bugs = tree.reduce((a, x)=>a + x.bugsTotal, 0);
                    const total = tasks + bugs;
                    const done = tree.reduce((a, x)=>a + x.tasksDone + x.bugsDone, 0);
                    return [
                        {
                            label: 'stories',
                            color: 'cyan',
                            value: tree.length
                        },
                        {
                            label: 'tasks',
                            color: 'magenta',
                            value: tasks
                        },
                        {
                            label: 'bugs',
                            color: 'red',
                            value: bugs
                        },
                        {
                            label: '% done',
                            color: 'green',
                            value: total ? Math.round(done / total * 100) : 0
                        }
                    ];
                }
            }
        },
        Groups: {
            flow: 'y',
            gap: 'C',
            padding: 'C B1 D B1',
            maxWidth: 'L+L',
            width: '100%',
            margin: '0 auto',
            childExtends: 'TicketsStoriesEpicGroup',
            childrenAs: 'state',
            children: (el, s)=>{
                // Collapse the flat list into {epicKey, epicTitle, stories[]}
                // groups, preserving the input order (already EPIC_ORDER-first).
                const tree = s.root.storiesTree || [];
                const seen = new Map();
                for (const s of tree){
                    if (!seen.has(s.epicKey)) seen.set(s.epicKey, {
                        epicKey: s.epicKey,
                        epicTitle: s.epicTitle,
                        stories: []
                    });
                    seen.get(s.epicKey).stories.push(s);
                }
                return Array.from(seen.values());
            }
        },
        Empty: {
            hide: (el, s)=>(s.root.storiesTree || []).length > 0,
            flow: 'y',
            align: 'center center',
            gap: 'Z1',
            padding: 'D',
            color: 'caption',
            Text: {
                tag: 'p',
                text: 'No stories in public.tickets. Run seed-tickets-from-md.mjs to populate.'
            }
        }
    }
};
const $f2f16bf8896d35cb$export$5ceac002730fe737 = {
    flow: 'y',
    gap: 'A',
    Head: {
        flow: 'x',
        gap: 'V',
        align: 'baseline left',
        paddingBottom: 'V',
        borderBottomWidth: 'V',
        borderBottomStyle: 'solid',
        borderBottomColor: 'line',
        EpicTitle: {
            tag: 'h2',
            fontSize: 'B',
            fontWeight: '700',
            color: 'title',
            letterSpacing: '-.02em',
            margin: '0',
            text: (el, s)=>s.epicTitle || s.epicKey?.toUpperCase() || '?'
        },
        Count: {
            tag: 'span',
            fontSize: 'Y1',
            color: 'caption',
            fontWeight: '600',
            text: (el, s)=>`${(s.stories || []).length} stor${(s.stories || []).length === 1 ? 'y' : 'ies'}`
        }
    },
    Grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
        gap: 'A',
        childExtends: 'TicketsStoryCard',
        childrenAs: 'state',
        children: (el, s)=>s.stories || []
    }
};
const $f2f16bf8896d35cb$export$921e8043756c4267 = {
    tag: 'div',
    flow: 'y',
    gap: 'V',
    padding: 'A',
    background: 'overlay',
    round: 'A',
    borderWidth: 'V',
    borderStyle: 'solid',
    borderColor: 'line',
    cursor: 'pointer',
    transition: 'border-color 0.15s ease',
    ':hover': {
        borderColor: 'title'
    },
    onClick: (e, el, s)=>{
        $f2f16bf8896d35cb$var$_openStoryById(s.root || el.getRoot(), s);
    },
    Head: {
        flow: 'x',
        align: 'center space-between',
        gap: 'V',
        Title: {
            tag: 'span',
            fontSize: 'Y1',
            fontWeight: '700',
            color: 'title',
            text: (el, s)=>s.title || s.storyKey || '?'
        },
        DonePct: {
            tag: 'span',
            flexShrink: '0',
            fontSize: 'Y2',
            fontWeight: '700',
            color: (el, s)=>(s.donePct || 0) >= 100 ? 'green' : 'caption',
            text: (el, s)=>`${s.donePct || 0}%`
        }
    },
    Key: {
        tag: 'span',
        fontSize: 'Y2',
        color: 'caption',
        fontWeight: '600',
        letterSpacing: '.06em',
        textTransform: 'uppercase',
        text: (el, s)=>s.storyKey || ''
    },
    Counts: {
        flow: 'x',
        gap: 'Z',
        marginTop: 'V',
        flexWrap: 'wrap',
        Tasks: {
            hide: (el, s)=>!s.tasksTotal,
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            text: (el, s)=>`${s.tasksDone}/${s.tasksTotal} tasks`
        },
        Bugs: {
            hide: (el, s)=>!s.bugsTotal,
            tag: 'span',
            fontSize: 'Y2',
            color: 'red',
            text: (el, s)=>`${s.bugsDone}/${s.bugsTotal} bugs`
        },
        EmptyNote: {
            hide: (el, s)=>s.tasksTotal + s.bugsTotal > 0,
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            fontStyle: 'italic',
            text: 'no tasks yet'
        }
    },
    Progress: {
        hide: (el, s)=>!(s.tasksTotal + s.bugsTotal),
        height: '4px',
        round: 'V',
        background: 'line',
        overflow: 'hidden',
        marginTop: 'V',
        Bar: {
            height: '100%',
            round: 'V',
            background: (el, s)=>(s.donePct || 0) >= 100 ? 'var(--color-green)' : 'var(--color-cyan)',
            width: (el, s)=>`${s.donePct || 0}%`,
            transition: 'width 0.25s ease'
        }
    }
};

});

parcelRegister("8H5bb", function(module, exports) {

$parcel$export(module.exports, "RequestsMain", () => $65465b6468acf8df$export$ff896e0ae0e253ed);
$parcel$export(module.exports, "RequestsInboundMain", () => $65465b6468acf8df$export$2c674c5a17955958);
$parcel$export(module.exports, "RequestsOutboundMain", () => $65465b6468acf8df$export$ebf7525263f348b5);
$parcel$export(module.exports, "RequestsAuditMain", () => $65465b6468acf8df$export$7e38964ba6b2fc88);
// Requests section — sales + feedback flow pages with real card grids.
const $65465b6468acf8df$var$_cardGrid = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
    gap: 'A'
};
const $65465b6468acf8df$export$ff896e0ae0e253ed = {
    extends: 'AppMain',
    Header: {
        extends: 'TicketsHeader'
    },
    Body: {
        overflow: 'auto',
        Hero: {
            extends: 'PageHero',
            eyebrow: 'REQUESTS',
            headline: 'Customer Requests',
            lede: (el, s)=>{
                const n = (s.root.customerRequests || []).length;
                return `${n} request${n === 1 ? '' : 's'} from customers, partners, and community.`;
            }
        },
        Content: {
            padding: 'B B1',
            maxWidth: 'L+L',
            width: '100%',
            margin: '0 auto',
            ...$65465b6468acf8df$var$_cardGrid,
            childExtends: 'RequestCard',
            childrenAs: 'state',
            children: (el, s)=>s.root.customerRequests || []
        }
    }
};
const $65465b6468acf8df$export$2c674c5a17955958 = {
    extends: 'AppMain',
    padding: '0',
    Header: {
        extends: 'TicketsHeader'
    },
    Body: {
        overflow: 'auto',
        Hero: {
            extends: 'PageHero',
            eyebrow: "REQUESTS \xb7 INBOUND",
            headline: 'Inbound',
            lede: (el, s)=>{
                const n = (s.root.inboundRequests || []).length;
                return `${n} incoming request${n === 1 ? '' : 's'} from customers, partners, and prospects.`;
            }
        },
        Content: {
            padding: 'B B1',
            maxWidth: 'L+L',
            width: '100%',
            margin: '0 auto',
            ...$65465b6468acf8df$var$_cardGrid,
            childExtends: 'RequestCard',
            childrenAs: 'state',
            children: (el, s)=>s.root.inboundRequests || []
        }
    }
};
const $65465b6468acf8df$export$ebf7525263f348b5 = {
    extends: 'AppMain',
    Header: {
        extends: 'TicketsHeader'
    },
    Body: {
        overflow: 'auto',
        Hero: {
            extends: 'PageHero',
            eyebrow: "REQUESTS \xb7 OUTBOUND",
            headline: 'Outbound',
            lede: (el, s)=>{
                const n = (s.root.outboundRequests || []).length;
                return `${n} outreach item${n === 1 ? '' : 's'} \u{2014} proposals, follow-ups, and communications.`;
            }
        },
        Content: {
            padding: 'B B1',
            maxWidth: 'L+L',
            width: '100%',
            margin: '0 auto',
            ...$65465b6468acf8df$var$_cardGrid,
            childExtends: 'RequestCard',
            childrenAs: 'state',
            children: (el, s)=>s.root.outboundRequests || []
        }
    }
};
const $65465b6468acf8df$export$7e38964ba6b2fc88 = {
    extends: 'AppMain',
    Header: {
        extends: 'TicketsHeader'
    },
    Body: {
        overflow: 'auto',
        Hero: {
            extends: 'PageHero',
            eyebrow: "REQUESTS \xb7 AUDIT",
            headline: 'Audit / Reports',
            lede: (el, s)=>{
                const n = (s.root.auditReports || []).length;
                return `${n} audit${n === 1 ? '' : 's'} and report${n === 1 ? '' : 's'}.`;
            }
        },
        Content: {
            padding: 'B B1',
            maxWidth: 'L+L',
            width: '100%',
            margin: '0 auto',
            ...$65465b6468acf8df$var$_cardGrid,
            childExtends: 'AuditCard',
            childrenAs: 'state',
            children: (el, s)=>s.root.auditReports || []
        }
    }
};

});

parcelRegister("2F4Cy", function(module, exports) {

$parcel$export(module.exports, "ResolutionRow", () => $1f02feb5d0d2d8c4$export$2ca20403f8169f20);
$parcel$export(module.exports, "ResolutionFileChip", () => $1f02feb5d0d2d8c4$export$23e868a66a447668);
$parcel$export(module.exports, "ResolutionsFilterBar", () => $1f02feb5d0d2d8c4$export$d40e7e21b892cbd9);
$parcel$export(module.exports, "TicketsResolutionsMain", () => $1f02feb5d0d2d8c4$export$57d97b649d357ea1);
$parcel$export(module.exports, "ResolutionsMain", () => $1f02feb5d0d2d8c4$export$dbffeaf7611cb31a);
$parcel$export(module.exports, "ResolutionsImprovementsMain", () => $1f02feb5d0d2d8c4$export$ca61fdd19f97833f);
$parcel$export(module.exports, "ResolutionsEditRequestsMain", () => $1f02feb5d0d2d8c4$export$364c9de89b823d98);
// ResolutionsMain.js
// /tickets/resolutions — browse type='resolution' tickets backed by v_resolutions.
//
// Each row shows: resolution title, linked original ticket, summary, resolved_by,
// resolved_at. Expanding the row reveals: root_cause, fix, files_touched,
// prevention, commit_sha. Clicking the original-ticket link navigates to
// /tickets/canvas?ticket=<original_id>. Search/filter: keyword + agent + date.

var $ghHor = parcelRequire("ghHor");
// ─── helpers ─────────────────────────────────────────────────────────────────
const $1f02feb5d0d2d8c4$var$_relTime = (isoStr)=>{
    if (!isoStr) return '';
    const diffS = Math.floor((Date.now() - new Date(isoStr).getTime()) / 1000);
    if (diffS < 60) return `${diffS}s ago`;
    if (diffS < 3600) return `${Math.floor(diffS / 60)}m ago`;
    if (diffS < 86400) return `${Math.floor(diffS / 3600)}h ago`;
    return `${Math.floor(diffS / 86400)}d ago`;
};
const $1f02feb5d0d2d8c4$var$_agentLabel = (email)=>{
    if (!email) return "\u2014";
    // "tickets-agent@symbols.app" → "TICKETS"
    // Also handles bare labels ("DESIGN" → "DESIGN") gracefully.
    if (!email.includes('@')) return email.toUpperCase();
    const local = email.split('@')[0].replace(/-agent$/, '').toUpperCase();
    return local;
};
// Normalise a resolvedBy value to an email address.
// Handles legacy rows where agents stored a bare label instead of email
// (e.g. "DESIGN" → "design-agent@symbols.app").
const $1f02feb5d0d2d8c4$var$_normaliseEmail = (val)=>{
    if (!val) return null;
    if (val.includes('@')) return val;
    // bare label — convert to canonical agent email
    return `${val.toLowerCase()}-agent@symbols.app`;
};
// Navigate to /tickets/canvas?ticket=<id> using SPA router where available.
const $1f02feb5d0d2d8c4$var$_openOriginal = (root, id)=>{
    if (!id) return;
    const path = `/tickets/canvas?ticket=${id}`;
    try {
        if (root && typeof root.router === 'function') {
            const p = root.router(path, root);
            if (p && typeof p.catch === 'function') p.catch(()=>{
                window.location.href = path;
            });
            return;
        }
    } catch (_) {}
    if (typeof window !== 'undefined') window.location.href = path;
};
// Fetch a single original ticket for the detail panel when we need full body.
const $1f02feb5d0d2d8c4$var$_fetchOriginal = async (ticketId)=>{
    if (!ticketId) return null;
    try {
        const res = await fetch(`${(0, $ghHor.SUPABASE_URL)}/rest/v1/tickets?id=eq.${ticketId}&select=*&limit=1`, {
            headers: (0, $ghHor.restHeaders)()
        });
        if (!res.ok) return null;
        const rows = await res.json();
        return Array.isArray(rows) ? rows[0] || null : null;
    } catch (_) {
        return null;
    }
};
// ─── filter helpers ──────────────────────────────────────────────────────────
// Applies root.resFilterQuery (keyword), root.resFilterAgent, root.resFilterDate
// to s.root.resolutions[]. Returns matching subset.
const $1f02feb5d0d2d8c4$var$_filtered = (root)=>{
    const all = root.resolutions || [];
    const q = (root.resFilterQuery || '').trim().toLowerCase();
    const agent = root.resFilterAgent || null;
    const since = root.resFilterDate ? new Date(root.resFilterDate).getTime() : 0;
    return all.filter((r)=>{
        // Normalise resolvedBy so legacy label-only rows ("DESIGN") still match
        // the email-keyed filter value ("design-agent@symbols.app").
        if (agent && $1f02feb5d0d2d8c4$var$_normaliseEmail(r.resolvedBy) !== agent) return false;
        if (since && r.resolvedAt && new Date(r.resolvedAt).getTime() < since) return false;
        if (q) {
            const haystack = [
                r.resolutionTitle,
                r.originalTitle,
                r.summary,
                r.fix,
                r.rootCause,
                r.resolvedBy
            ].filter(Boolean).join(' ').toLowerCase();
            if (!haystack.includes(q)) return false;
        }
        return true;
    });
};
const $1f02feb5d0d2d8c4$export$2ca20403f8169f20 = {
    tag: 'div',
    flow: 'y',
    background: 'overlay',
    round: 'A',
    borderWidth: 'V',
    borderStyle: 'solid',
    borderColor: 'line',
    transition: 'border-color 0.15s ease',
    overflow: 'hidden',
    // ── Header ─────────────────────────────────────────────────────────────────
    Head: {
        flow: 'x',
        align: 'center left',
        gap: 'A',
        padding: 'Z A',
        cursor: 'pointer',
        ':hover': {
            background: 'surface'
        },
        // Expand indicator
        Chevron: {
            tag: 'span',
            flexShrink: '0',
            fontSize: 'Y2',
            color: 'caption',
            transition: 'transform 0.2s ease',
            transform: (el, s)=>s.expanded ? 'rotate(90deg)' : 'rotate(0deg)',
            text: "\u203A"
        },
        Info: {
            flow: 'y',
            gap: 'V',
            flex: '1',
            overflow: 'hidden',
            TitleLine: {
                flow: 'x',
                align: 'center left',
                gap: 'V',
                flexWrap: 'wrap',
                Title: {
                    tag: 'span',
                    fontSize: 'A',
                    fontWeight: '700',
                    color: 'title',
                    letterSpacing: '-.01em',
                    // Strip "Resolution: " prefix for cleaner display
                    text: (el, s)=>(s.resolutionTitle || '').replace(/^Resolution:\s*/i, '') || '(untitled)'
                },
                OriginalLink: {
                    hide: (el, s)=>!s.originalTicketId,
                    tag: 'span',
                    fontSize: 'Y2',
                    fontWeight: '600',
                    color: 'blue',
                    cursor: 'pointer',
                    textDecoration: 'underline',
                    textDecorationColor: 'transparent',
                    ':hover': {
                        textDecorationColor: 'var(--color-blue)'
                    },
                    text: (el, s)=>{
                        const ref = s.originalExternalId || (s.originalTicketId ? `#${s.originalTicketId}` : '');
                        return ref ? `\u{2190} ${ref}` : '';
                    },
                    onClick: (e, el, s)=>{
                        e.stopPropagation();
                        $1f02feb5d0d2d8c4$var$_openOriginal(s.root || el.getRoot(), s.originalTicketId);
                    }
                }
            },
            Summary: {
                hide: (el, s)=>!s.summary,
                tag: 'span',
                fontSize: 'Y1',
                color: 'subtitle',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                text: (el, s)=>s.summary || ''
            }
        },
        Meta: {
            flow: 'y',
            gap: 'V',
            align: 'center right',
            flexShrink: '0',
            textAlign: 'right',
            Agent: {
                tag: 'span',
                fontSize: 'Y2',
                fontWeight: '700',
                color: 'cyan',
                letterSpacing: '.04em',
                text: (el, s)=>$1f02feb5d0d2d8c4$var$_agentLabel(s.resolvedBy)
            },
            Time: {
                tag: 'span',
                fontSize: 'Y2',
                color: 'caption',
                text: (el, s)=>$1f02feb5d0d2d8c4$var$_relTime(s.resolvedAt)
            }
        },
        onClick: (e, el, s)=>{
            s.update({
                expanded: !s.expanded
            });
        }
    },
    // ── Expanded detail panel ───────────────────────────────────────────────────
    Detail: {
        hide: (el, s)=>!s.expanded,
        flow: 'y',
        gap: 'A',
        padding: 'Z A A A',
        borderTopWidth: 'V',
        borderTopStyle: 'solid',
        borderTopColor: 'line',
        // Summary row
        SummaryBlock: {
            hide: (el, s)=>!s.summary,
            flow: 'y',
            gap: 'V',
            SummaryLabel: {
                tag: 'span',
                fontSize: 'Y2',
                fontWeight: '700',
                letterSpacing: '.08em',
                color: 'caption',
                textTransform: 'uppercase',
                text: 'Summary'
            },
            SummaryText: {
                tag: 'p',
                margin: '0',
                fontSize: 'Y1',
                color: 'subtitle',
                lineHeight: '1.5',
                text: (el, s)=>s.summary || ''
            }
        },
        RootCauseBlock: {
            hide: (el, s)=>!s.rootCause,
            flow: 'y',
            gap: 'V',
            RcLabel: {
                tag: 'span',
                fontSize: 'Y2',
                fontWeight: '700',
                letterSpacing: '.08em',
                color: 'caption',
                textTransform: 'uppercase',
                text: 'Root Cause'
            },
            RcText: {
                tag: 'p',
                margin: '0',
                fontSize: 'Y1',
                color: 'subtitle',
                lineHeight: '1.5',
                text: (el, s)=>s.rootCause || ''
            }
        },
        FixBlock: {
            hide: (el, s)=>!s.fix,
            flow: 'y',
            gap: 'V',
            FixLabel: {
                tag: 'span',
                fontSize: 'Y2',
                fontWeight: '700',
                letterSpacing: '.08em',
                color: 'caption',
                textTransform: 'uppercase',
                text: 'Fix'
            },
            FixText: {
                tag: 'p',
                margin: '0',
                fontSize: 'Y1',
                color: 'green',
                lineHeight: '1.5',
                text: (el, s)=>s.fix || ''
            }
        },
        FilesBlock: {
            hide: (el, s)=>!(s.filesTouched || []).length,
            flow: 'y',
            gap: 'V',
            FilesLabel: {
                tag: 'span',
                fontSize: 'Y2',
                fontWeight: '700',
                letterSpacing: '.08em',
                color: 'caption',
                textTransform: 'uppercase',
                text: 'Files Touched'
            },
            FilesList: {
                flow: 'y',
                gap: 'V',
                childExtends: 'ResolutionFileChip',
                childrenAs: 'state',
                children: (el, s)=>(s.filesTouched || []).map((f)=>({
                            file: f
                        }))
            }
        },
        PreventionBlock: {
            hide: (el, s)=>!s.prevention,
            flow: 'y',
            gap: 'V',
            PrevLabel: {
                tag: 'span',
                fontSize: 'Y2',
                fontWeight: '700',
                letterSpacing: '.08em',
                color: 'caption',
                textTransform: 'uppercase',
                text: 'Prevention'
            },
            PrevText: {
                tag: 'p',
                margin: '0',
                fontSize: 'Y1',
                color: 'subtitle',
                lineHeight: '1.5',
                text: (el, s)=>s.prevention || ''
            }
        },
        // Bottom meta bar: commit sha + link to original
        FooterBar: {
            flow: 'x',
            align: 'center space-between',
            gap: 'A',
            marginTop: 'V',
            flexWrap: 'wrap',
            CommitSha: {
                hide: (el, s)=>!s.commitSha,
                tag: 'span',
                fontSize: 'Y2',
                fontFamily: 'monospace',
                color: 'caption',
                text: (el, s)=>`commit ${(s.commitSha || '').slice(0, 12)}`
            },
            ViewOriginalBtn: {
                hide: (el, s)=>!s.originalTicketId,
                tag: 'button',
                type: 'button',
                fontSize: 'Y2',
                fontWeight: '600',
                color: 'blue',
                background: 'transparent',
                borderWidth: '0',
                padding: '0',
                cursor: 'pointer',
                text: (el, s)=>{
                    const ref = s.originalExternalId || (s.originalTicketId ? `#${s.originalTicketId}` : '');
                    const t = s.originalTitle ? `${ref} \xb7 ${s.originalTitle}`.slice(0, 60) : ref;
                    return `View original: ${t}`;
                },
                onClick: (e, el, s)=>{
                    $1f02feb5d0d2d8c4$var$_openOriginal(s.root || el.getRoot(), s.originalTicketId);
                }
            }
        }
    }
};
const $1f02feb5d0d2d8c4$export$23e868a66a447668 = {
    tag: 'span',
    fontSize: 'Y2',
    fontFamily: 'monospace',
    color: 'caption',
    background: 'surface',
    round: 'V',
    padding: 'V Z',
    display: 'inline-block',
    text: (el, s)=>s.file || ''
};
const $1f02feb5d0d2d8c4$export$d40e7e21b892cbd9 = {
    flow: 'x',
    align: 'center left',
    gap: 'A',
    padding: 'V 0 A 0',
    flexWrap: 'wrap',
    // Keyword search
    SearchInput: {
        tag: 'input',
        type: 'text',
        placeholder: "Search resolutions\u2026",
        fontSize: 'Y1',
        padding: 'Z A',
        round: 'V',
        background: 'surface',
        borderWidth: 'V',
        borderStyle: 'solid',
        borderColor: 'line',
        color: 'title',
        width: '240px',
        ':focus': {
            borderColor: 'blue',
            outline: 'none'
        },
        onInput: (e, el, s)=>{
            s.root.update({
                resFilterQuery: e.target.value
            });
        }
    },
    // Agent filter — populated from distinct resolvedBy values.
    // Fix (QA fail #3 / TASK#4488):
    //   A) AllOption lives inside the children factory array — static named
    //      child keys are ignored when childrenAs:'state' + children factory is
    //      active in DOMQL v3.14.
    //   B) Native <option> value attribute uses attr: { value } (not top-level
    //      value:) so that DOMQL's attribute-effect path (element.attr) handles
    //      it.  The value-effect path (definition.value) only fires when value
    //      is directly on the child definition, not inherited via childExtends.
    //      attr: { value } correctly calls node.setAttribute('value', ...) and
    //      handles empty string '' for the AllOption sentinel.
    AgentSelect: {
        tag: 'select',
        fontSize: 'Y1',
        padding: 'Z A',
        round: 'V',
        background: 'surface',
        borderWidth: 'V',
        borderStyle: 'solid',
        borderColor: 'line',
        color: 'title',
        cursor: 'pointer',
        childExtends: {
            tag: 'option',
            // Bind the native <option> value attribute via attr: { value } so that
            // DOMQL's attribute-effect path (element.attr) handles it rather than the
            // value-effect path (definition.value).  The value-effect only fires when
            // `value` is directly on the child definition, not inherited from extends —
            // which is exactly the childrenAs:'state' + childExtends pattern we use here.
            // attr: { value } calls node.setAttribute('value', ...) reactively, which is
            // the correct mechanism for <option> elements. Empty string '' for the
            // AllOption sentinel; email string for agent items.
            attr: {
                value: (el, s)=>s.agentEmail == null ? '' : s.agentEmail
            },
            text: (el, s)=>s.agentEmail == null ? 'All agents' : $1f02feb5d0d2d8c4$var$_agentLabel(s.agentEmail)
        },
        childrenAs: 'state',
        // AllOption is the FIRST element in the factory output (sentinel).
        // Agent items follow, keyed by normalised email (labels coerced to email).
        children: (el, s)=>{
            const agents = [
                ...new Set((s.root.resolutions || []).map((r)=>$1f02feb5d0d2d8c4$var$_normaliseEmail(r.resolvedBy)).filter(Boolean))
            ];
            return [
                {
                    agentEmail: null
                },
                ...agents.map((a)=>({
                        agentEmail: a
                    }))
            ];
        },
        onChange: (e, el, s)=>{
            s.root.update({
                resFilterAgent: e.target.value || null
            });
        }
    },
    // Date range — "since"
    DateInput: {
        tag: 'input',
        type: 'date',
        fontSize: 'Y1',
        padding: 'Z A',
        round: 'V',
        background: 'surface',
        borderWidth: 'V',
        borderStyle: 'solid',
        borderColor: 'line',
        color: 'title',
        cursor: 'pointer',
        title: 'Show resolutions from this date onwards',
        onChange: (e, el, s)=>{
            s.root.update({
                resFilterDate: e.target.value || null
            });
        }
    },
    // Clear filters
    ClearBtn: {
        hide: (el, s)=>!s.root.resFilterQuery && !s.root.resFilterAgent && !s.root.resFilterDate,
        tag: 'button',
        type: 'button',
        fontSize: 'Y2',
        fontWeight: '600',
        color: 'caption',
        background: 'transparent',
        borderWidth: '0',
        padding: 'Z V',
        cursor: 'pointer',
        ':hover': {
            color: 'title'
        },
        text: 'Clear',
        onClick: (e, el, s)=>{
            s.root.update({
                resFilterQuery: null,
                resFilterAgent: null,
                resFilterDate: null
            });
            // Reset DOM inputs
            const bar = el.parent;
            if (bar?.SearchInput?.node) bar.SearchInput.node.value = '';
            if (bar?.AgentSelect?.node) bar.AgentSelect.node.value = '';
            if (bar?.DateInput?.node) bar.DateInput.node.value = '';
        }
    }
};
const $1f02feb5d0d2d8c4$export$57d97b649d357ea1 = {
    extends: 'AppMain',
    Header: {
        extends: 'TicketsHeader'
    },
    Body: {
        overflow: 'auto',
        Hero: {
            extends: 'PageHero',
            eyebrow: "AGENT MEMORY \xb7 RESOLUTIONS",
            headline: 'Resolutions',
            lede: (el, s)=>{
                const all = s.root.resolutions;
                if (all == null) return "Loading resolutions\u2026";
                const n = all.length;
                const shown = $1f02feb5d0d2d8c4$var$_filtered(s.root).length;
                if (!n) return 'No resolution tickets yet. Agents will populate this as they ship fixes.';
                return shown < n ? `${shown} of ${n} resolution${n === 1 ? '' : 's'} \xb7 filtered.` : `${n} agent resolution${n === 1 ? '' : 's'} \xb7 newest first.`;
            }
        },
        Container: {
            flow: 'y',
            gap: '0',
            padding: 'Z B1 D B1',
            maxWidth: 'L+L',
            width: '100%',
            margin: '0 auto',
            ResolutionsFilterBar: {},
            // Resolved list
            List: {
                flow: 'y',
                gap: 'V',
                childExtends: 'ResolutionRow',
                childrenAs: 'state',
                children: (el, s)=>$1f02feb5d0d2d8c4$var$_filtered(s.root)
            },
            // Empty state
            Empty: {
                hide: (el, s)=>{
                    const all = s.root.resolutions;
                    // Hide when not yet loaded (null) or when there are results
                    if (all == null) return true;
                    return $1f02feb5d0d2d8c4$var$_filtered(s.root).length > 0;
                },
                flow: 'y',
                align: 'center center',
                gap: 'A',
                padding: 'D',
                textAlign: 'center',
                Icon: {
                    extends: 'Icon',
                    icon: 'check',
                    boxSize: 'D',
                    color: 'caption',
                    opacity: '.3'
                },
                Title: {
                    tag: 'h3',
                    margin: '0',
                    fontSize: 'B',
                    fontWeight: '600',
                    color: 'title',
                    text: (el, s)=>{
                        const all = s.root.resolutions || [];
                        const hasFilter = s.root.resFilterQuery || s.root.resFilterAgent || s.root.resFilterDate;
                        return all.length && hasFilter ? 'No matches' : 'No resolutions yet';
                    }
                },
                Body: {
                    tag: 'p',
                    margin: '0',
                    fontSize: 'A',
                    color: 'caption',
                    lineHeight: '1.5',
                    text: (el, s)=>{
                        const all = s.root.resolutions || [];
                        const hasFilter = s.root.resFilterQuery || s.root.resFilterAgent || s.root.resFilterDate;
                        return all.length && hasFilter ? 'Try broadening the search or clearing filters.' : 'Agents populate this list when they ship fixes using open_resolution_ticket().';
                    }
                }
            }
        }
    }
};
// ─── Suggestions / Improvements / EditRequests — legacy sub-pages ────────────
// These exist as nav targets. They no longer share the ResolutionsMain label
// to avoid collision with the new TicketsResolutionsMain above.
const $1f02feb5d0d2d8c4$var$_cardGrid = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
    gap: 'A'
};
const $1f02feb5d0d2d8c4$export$dbffeaf7611cb31a = {
    extends: 'AppMain',
    Header: {
        extends: 'TicketsHeader'
    },
    Body: {
        overflow: 'auto',
        Hero: {
            extends: 'PageHero',
            eyebrow: 'RESOLUTIONS',
            headline: 'Suggestions',
            lede: (el, s)=>{
                const n = (s.root.suggestions || []).length;
                return `${n} AI-generated suggestion${n === 1 ? '' : 's'} from usage analytics.`;
            }
        },
        Content: {
            padding: 'B B1',
            maxWidth: 'L+L',
            width: '100%',
            margin: '0 auto',
            ...$1f02feb5d0d2d8c4$var$_cardGrid,
            childExtends: 'SuggestionCard',
            childrenAs: 'state',
            children: (el, s)=>s.root.suggestions || []
        }
    }
};
const $1f02feb5d0d2d8c4$export$ca61fdd19f97833f = {
    extends: 'AppMain',
    Header: {
        extends: 'TicketsHeader'
    },
    Body: {
        overflow: 'auto',
        Hero: {
            extends: 'PageHero',
            eyebrow: "RESOLUTIONS \xb7 IMPROVEMENTS",
            headline: 'Improvement Requests',
            lede: (el, s)=>{
                const n = (s.root.improvementRequests || []).length;
                return `${n} AI-generated page${n === 1 ? '' : 's'} from Freestyler awaiting review.`;
            }
        },
        Content: {
            padding: 'B B1',
            maxWidth: 'L+L',
            width: '100%',
            margin: '0 auto',
            ...$1f02feb5d0d2d8c4$var$_cardGrid,
            childExtends: 'ImprovementCard',
            childrenAs: 'state',
            children: (el, s)=>s.root.improvementRequests || []
        }
    }
};
const $1f02feb5d0d2d8c4$export$364c9de89b823d98 = {
    extends: 'AppMain',
    Header: {
        extends: 'TicketsHeader'
    },
    Body: {
        overflow: 'auto',
        Hero: {
            extends: 'PageHero',
            eyebrow: "RESOLUTIONS \xb7 EDIT REQUESTS",
            headline: 'Edit Requests',
            lede: (el, s)=>{
                const n = (s.root.editRequests || []).length;
                const open = (s.root.editRequests || []).filter((r)=>r.status === 'open').length;
                return `${n} pull request${n === 1 ? '' : 's'}${open ? ` \xb7 ${open} open` : ''}.`;
            }
        },
        Content: {
            padding: 'B B1',
            maxWidth: 'L+L',
            width: '100%',
            margin: '0 auto',
            ...$1f02feb5d0d2d8c4$var$_cardGrid,
            childExtends: 'EditRequestCard',
            childrenAs: 'state',
            children: (el, s)=>s.root.editRequests || []
        }
    }
};

});

parcelRegister("hO1ab", function(module, exports) {

$parcel$export(module.exports, "RequestCard", () => $03586321b863905c$export$b939eb04f6650d8);
$parcel$export(module.exports, "RequestTag", () => $03586321b863905c$export$3b7e91c2a289a64c);
$parcel$export(module.exports, "SuggestionCard", () => $03586321b863905c$export$5864b77b647e728c);
$parcel$export(module.exports, "ImprovementCard", () => $03586321b863905c$export$1571f429caacc6b8);
$parcel$export(module.exports, "EditRequestCard", () => $03586321b863905c$export$d417a38469e47e73);
$parcel$export(module.exports, "AuditCard", () => $03586321b863905c$export$f190aa27c10d11e);
// Distinct card types for the tickets section.
// Each type has its own visual identity and data shape.
// ── Request Card (customer requests, inbound, outbound) ──
const $03586321b863905c$var$_statusColor = (status)=>({
        open: 'blue',
        new: 'blue',
        'in-progress': 'green',
        scheduled: 'green',
        triaged: 'orange',
        sent: 'caption',
        draft: 'caption',
        resolved: 'green',
        published: 'green',
        'in-review': 'orange'
    })[status] || 'caption';
const $03586321b863905c$export$b939eb04f6650d8 = {
    flow: 'y',
    gap: 'Z',
    padding: 'A',
    round: 'A',
    borderWidth: '1px',
    borderColor: 'line',
    borderStyle: 'solid',
    background: 'overlay',
    cursor: 'pointer',
    transition: 'border-color 150ms ease, transform 150ms ease, box-shadow 150ms ease',
    ':hover': {
        borderColor: 'title',
        transform: 'translateY(-2px)',
        boxShadow: '0 8px 24px -8px var(--color-shadow)'
    },
    onClick: (e, el, s)=>{
        if (s.root) s.root.update({
            selectedTicket: s
        });
    },
    Top: {
        flow: 'x',
        align: 'flex-start space-between',
        gap: 'Z',
        Title: {
            tag: 'h3',
            margin: '0',
            fontSize: 'A',
            fontWeight: '600',
            lineHeight: '1.3',
            color: 'title',
            flex: '1',
            text: (el, s)=>s.title || ''
        },
        StatusBadge: {
            tag: 'span',
            fontSize: 'Y1',
            fontWeight: '700',
            padding: 'V Z',
            round: 'C',
            textTransform: 'uppercase',
            letterSpacing: '.04em',
            color: (el, s)=>$03586321b863905c$var$_statusColor(s.status),
            background: (el, s)=>`color-mix(in srgb, var(--color-${$03586321b863905c$var$_statusColor(s.status)}) 15%, transparent)`,
            text: (el, s)=>(s.status || '').replace('-', ' ')
        }
    },
    Summary: {
        hide: (el, s)=>!s.summary,
        tag: 'p',
        margin: '0',
        fontSize: 'Z2',
        lineHeight: '1.5',
        color: 'caption',
        overflow: 'hidden',
        webkitLineClamp: '2',
        webkitBoxOrient: 'vertical',
        display: '-webkit-box',
        text: (el, s)=>s.summary || ''
    },
    Meta: {
        flow: 'x',
        gap: 'Z',
        align: 'center',
        wrap: 'wrap',
        marginTop: 'V',
        Author: {
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            text: (el, s)=>s.author || s.recipient || ''
        },
        Channel: {
            hide: (el, s)=>!s.channel,
            tag: 'span',
            fontSize: 'Y1',
            fontWeight: '600',
            padding: 'V Z',
            round: 'C',
            background: 'overlay',
            color: 'caption',
            text: (el, s)=>s.channel || ''
        },
        Votes: {
            hide: (el, s)=>!s.votes,
            tag: 'span',
            fontSize: 'Y2',
            color: 'blue',
            fontWeight: '600',
            text: (el, s)=>s.votes ? `${s.votes} votes` : ''
        },
        Date: {
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            text: (el, s)=>s.createdAt || ''
        }
    },
    Tags: {
        hide: (el, s)=>!(s.tags && s.tags.length),
        flow: 'x',
        gap: 'Y',
        wrap: 'wrap',
        marginTop: 'V',
        childExtends: 'RequestTag',
        childrenAs: 'state',
        children: (el, s)=>(s.tags || []).map((t)=>({
                    label: t
                }))
    }
};
const $03586321b863905c$export$3b7e91c2a289a64c = {
    tag: 'span',
    fontSize: 'Y1',
    fontWeight: '600',
    padding: 'V Z',
    round: 'C',
    background: 'blue.1',
    color: 'blue',
    text: (el, s)=>s.label || ''
};
const $03586321b863905c$export$5864b77b647e728c = {
    flow: 'y',
    gap: 'Z',
    padding: 'A',
    round: 'A',
    borderWidth: '1px',
    borderColor: 'line',
    borderStyle: 'solid',
    borderLeftWidth: '3px',
    borderLeftColor: (el, s)=>s.impact === 'high' ? 'green' : s.impact === 'medium' ? 'orange' : 'caption',
    background: 'overlay',
    cursor: 'pointer',
    transition: 'border-color 150ms ease',
    ':hover': {
        borderColor: 'title',
        boxShadow: '0 8px 24px -8px var(--color-shadow)'
    },
    onClick: (e, el, s)=>{
        if (s.root) s.root.update({
            selectedTicket: s
        });
    },
    Top: {
        flow: 'x',
        align: 'flex-start space-between',
        gap: 'Z',
        Title: {
            tag: 'h3',
            margin: '0',
            fontSize: 'A',
            fontWeight: '600',
            lineHeight: '1.3',
            color: 'title',
            flex: '1',
            text: (el, s)=>s.title || ''
        },
        Confidence: {
            tag: 'span',
            fontSize: 'Y2',
            fontWeight: '700',
            color: 'green',
            text: (el, s)=>s.confidence ? `${Math.round(s.confidence * 100)}% conf.` : ''
        }
    },
    Summary: {
        tag: 'p',
        margin: '0',
        fontSize: 'Z2',
        lineHeight: '1.5',
        color: 'caption',
        text: (el, s)=>s.summary || ''
    },
    Meta: {
        flow: 'x',
        gap: 'Z',
        align: 'center',
        marginTop: 'V',
        Impact: {
            tag: 'span',
            fontSize: 'Y1',
            fontWeight: '700',
            padding: 'V Z',
            round: 'C',
            textTransform: 'uppercase',
            color: (el, s)=>s.impact === 'high' ? 'green' : s.impact === 'medium' ? 'orange' : 'caption',
            background: (el, s)=>{
                const c = s.impact === 'high' ? 'green' : s.impact === 'medium' ? 'orange' : 'caption';
                return `color-mix(in srgb, var(--color-${c}) 15%, transparent)`;
            },
            text: (el, s)=>`${s.impact || 'low'} impact`
        },
        Source: {
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            text: (el, s)=>s.source || ''
        },
        Date: {
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            text: (el, s)=>s.createdAt || ''
        }
    }
};
// ── Improvement Request Card (Freestyler) ──
const $03586321b863905c$var$_modelLabel = (m)=>({
        'claude-haiku': 'Claude',
        'gemini-3.1': 'Gemini'
    })[m] || m || '';
const $03586321b863905c$export$1571f429caacc6b8 = {
    flow: 'y',
    gap: 'Z',
    padding: 'A',
    round: 'A',
    borderWidth: '1px',
    borderColor: 'line',
    borderStyle: 'solid',
    background: 'overlay',
    cursor: 'pointer',
    transition: 'border-color 150ms ease',
    ':hover': {
        borderColor: 'title',
        boxShadow: '0 8px 24px -8px var(--color-shadow)'
    },
    onClick: (e, el, s)=>{
        if (s.root) s.root.update({
            selectedTicket: s
        });
    },
    Top: {
        flow: 'x',
        align: 'flex-start space-between',
        gap: 'Z',
        Title: {
            tag: 'h3',
            margin: '0',
            fontSize: 'A',
            fontWeight: '600',
            lineHeight: '1.3',
            color: 'title',
            flex: '1',
            text: (el, s)=>s.title || ''
        },
        StatusBadge: {
            tag: 'span',
            fontSize: 'Y1',
            fontWeight: '700',
            padding: 'V Z',
            round: 'C',
            textTransform: 'uppercase',
            color: (el, s)=>s.status === 'approved' ? 'green' : s.status === 'rejected' ? 'red' : 'orange',
            background: (el, s)=>{
                const c = s.status === 'approved' ? 'green' : s.status === 'rejected' ? 'red' : 'orange';
                return `color-mix(in srgb, var(--color-${c}) 15%, transparent)`;
            },
            text: (el, s)=>s.status || ''
        }
    },
    Prompt: {
        tag: 'p',
        margin: '0',
        fontSize: 'Z2',
        lineHeight: '1.5',
        color: 'caption',
        fontStyle: 'italic',
        text: (el, s)=>s.prompt ? `"${s.prompt}"` : ''
    },
    Meta: {
        flow: 'x',
        gap: 'Z',
        align: 'center',
        marginTop: 'V',
        Model: {
            tag: 'span',
            fontSize: 'Y1',
            fontWeight: '600',
            padding: 'V Z',
            round: 'C',
            background: 'overlay',
            color: 'caption',
            text: (el, s)=>$03586321b863905c$var$_modelLabel(s.model)
        },
        Author: {
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            text: (el, s)=>s.author || ''
        },
        Date: {
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            text: (el, s)=>s.createdAt || ''
        }
    }
};
const $03586321b863905c$export$d417a38469e47e73 = {
    flow: 'y',
    gap: 'Z',
    padding: 'A',
    round: 'A',
    borderWidth: '1px',
    borderColor: 'line',
    borderStyle: 'solid',
    background: 'overlay',
    cursor: 'pointer',
    transition: 'border-color 150ms ease',
    ':hover': {
        borderColor: 'title',
        boxShadow: '0 8px 24px -8px var(--color-shadow)'
    },
    onClick: (e, el, s)=>{
        if (s.root) s.root.update({
            selectedTicket: s
        });
    },
    Top: {
        flow: 'x',
        align: 'flex-start space-between',
        gap: 'Z',
        Title: {
            tag: 'h3',
            margin: '0',
            fontSize: 'A',
            fontWeight: '600',
            lineHeight: '1.3',
            color: 'title',
            flex: '1',
            text: (el, s)=>s.title || ''
        },
        StatusBadge: {
            tag: 'span',
            fontSize: 'Y1',
            fontWeight: '700',
            padding: 'V Z',
            round: 'C',
            textTransform: 'uppercase',
            color: (el, s)=>s.status === 'merged' ? 'purple' : s.status === 'open' ? 'green' : 'caption',
            background: (el, s)=>{
                const c = s.status === 'merged' ? 'purple' : s.status === 'open' ? 'green' : 'caption';
                return `color-mix(in srgb, var(--color-${c}) 15%, transparent)`;
            },
            text: (el, s)=>s.status || ''
        }
    },
    Branch: {
        flow: 'x',
        gap: 'Z',
        align: 'center',
        Repo: {
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            text: (el, s)=>s.repo || ''
        },
        BranchName: {
            tag: 'code',
            fontSize: 'Y2',
            color: 'blue',
            fontWeight: '600',
            padding: 'V Z',
            round: 'Y',
            background: 'blue.08',
            text: (el, s)=>s.branch || ''
        }
    },
    Meta: {
        flow: 'x',
        gap: 'Z',
        align: 'center',
        marginTop: 'V',
        Diff: {
            flow: 'x',
            gap: 'Y',
            Additions: {
                tag: 'span',
                fontSize: 'Y2',
                color: 'green',
                fontWeight: '600',
                text: (el, s)=>s.additions ? `+${s.additions}` : ''
            },
            Deletions: {
                tag: 'span',
                fontSize: 'Y2',
                color: 'red',
                fontWeight: '600',
                text: (el, s)=>s.deletions ? `-${s.deletions}` : ''
            }
        },
        Author: {
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            text: (el, s)=>s.author || ''
        },
        Reviewers: {
            hide: (el, s)=>!(s.reviewers && s.reviewers.length),
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            text: (el, s)=>`${(s.reviewers || []).length} reviewer${(s.reviewers || []).length === 1 ? '' : 's'}`
        },
        Date: {
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            text: (el, s)=>s.createdAt || ''
        }
    }
};
const $03586321b863905c$export$f190aa27c10d11e = {
    flow: 'y',
    gap: 'Z',
    padding: 'A',
    round: 'A',
    borderWidth: '1px',
    borderColor: 'line',
    borderStyle: 'solid',
    background: 'overlay',
    cursor: 'pointer',
    transition: 'border-color 150ms ease',
    ':hover': {
        borderColor: 'title',
        boxShadow: '0 8px 24px -8px var(--color-shadow)'
    },
    onClick: (e, el, s)=>{
        if (s.root) s.root.update({
            selectedTicket: s
        });
    },
    Top: {
        flow: 'x',
        align: 'flex-start space-between',
        gap: 'Z',
        Title: {
            tag: 'h3',
            margin: '0',
            fontSize: 'A',
            fontWeight: '600',
            lineHeight: '1.3',
            color: 'title',
            flex: '1',
            text: (el, s)=>s.title || ''
        },
        TypeBadge: {
            tag: 'span',
            fontSize: 'Y1',
            fontWeight: '700',
            padding: 'V Z',
            round: 'C',
            textTransform: 'uppercase',
            letterSpacing: '.04em',
            background: 'overlay',
            color: 'caption',
            text: (el, s)=>s.type || ''
        }
    },
    Summary: {
        tag: 'p',
        margin: '0',
        fontSize: 'Z2',
        lineHeight: '1.5',
        color: 'caption',
        text: (el, s)=>s.summary || ''
    },
    Meta: {
        flow: 'x',
        gap: 'Z',
        align: 'center',
        marginTop: 'V',
        StatusBadge: {
            tag: 'span',
            fontSize: 'Y1',
            fontWeight: '700',
            padding: 'V Z',
            round: 'C',
            textTransform: 'uppercase',
            color: (el, s)=>$03586321b863905c$var$_statusColor(s.status),
            background: (el, s)=>`color-mix(in srgb, var(--color-${$03586321b863905c$var$_statusColor(s.status)}) 15%, transparent)`,
            text: (el, s)=>s.status || ''
        },
        Date: {
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            text: (el, s)=>s.createdAt || ''
        }
    }
};

});

parcelRegister("eD2nt", function(module, exports) {

$parcel$export(module.exports, "TicketsActivityHeatmap", () => $aa668d59dbfdf988$export$352781c272fbebca);
$parcel$export(module.exports, "TicketsHeatmapCell", () => $aa668d59dbfdf988$export$52a5c40ae49b3f97);
$parcel$export(module.exports, "TicketsActivityRow", () => $aa668d59dbfdf988$export$93b233bf25ccedc5);
// Activity heatmap — shows daily scored activity for the last year.
// Reads `activity_events` (standups, ticket updates, note/KB edits, meet
// calls). Intensity keyed on SUM(score) per day. Standup days keep a ✦
// marker in the tooltip so "did standup today" stays explicit even when
// bundled with other activity.

var $bfqVY = parcelRequire("bfqVY");
const $aa668d59dbfdf988$var$WEEKS = 52;
const $aa668d59dbfdf988$var$DAYS = 7;
const $aa668d59dbfdf988$var$TOTAL = $aa668d59dbfdf988$var$WEEKS * $aa668d59dbfdf988$var$DAYS;
// Scored buckets: intensity ramps on summed points, not raw row count,
// so a single meet call (4pt) outshines two note edits (2pt).
const $aa668d59dbfdf988$var$_intensity = (score, hasStandup)=>{
    if (!score && !hasStandup) return 'transparent';
    if (hasStandup && !score) return 'green.15';
    if (score <= 2) return 'green.15';
    if (score <= 5) return 'green.3';
    if (score <= 10) return 'green.5';
    return 'green.7';
};
const $aa668d59dbfdf988$export$352781c272fbebca = {
    flow: 'y',
    gap: 'Z',
    CaptionTitle: {
        fontSize: 'Y2',
        Text: {
            text: "ACTIVITY \xb7 LAST YEAR"
        }
    },
    Grid: {
        display: 'grid',
        gridTemplateColumns: `repeat(${$aa668d59dbfdf988$var$WEEKS}, 1fr)`,
        gridTemplateRows: `repeat(${$aa668d59dbfdf988$var$DAYS}, 1fr)`,
        gridAutoFlow: 'column',
        gap: 'X',
        padding: 'Z 0',
        childExtends: 'TicketsHeatmapCell',
        childrenAs: 'state',
        children: (el, s)=>{
            const data = s.root?._activityData || {};
            const today = new Date();
            const cells = [];
            for(let i = $aa668d59dbfdf988$var$TOTAL - 1; i >= 0; i--){
                const d = new Date(today);
                d.setDate(d.getDate() - i);
                const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
                const entry = data[key] || {};
                cells.push({
                    date: key,
                    score: entry.score || 0,
                    standups: entry.standups || 0,
                    breakdown: entry.breakdown || {}
                });
            }
            return cells;
        }
    },
    Legend: {
        flow: 'x',
        gap: 'Z',
        align: 'center right',
        fontSize: 'Y1',
        color: 'caption',
        Less: {
            tag: 'span',
            text: 'Less'
        },
        Box_1: {
            width: 'Y',
            height: 'Y',
            round: 'X',
            background: 'transparent',
            borderWidth: '1px',
            borderColor: 'line',
            borderStyle: 'solid'
        },
        Box_2: {
            width: 'Y',
            height: 'Y',
            round: 'X',
            background: 'green.15'
        },
        Box_3: {
            width: 'Y',
            height: 'Y',
            round: 'X',
            background: 'green.3'
        },
        Box_4: {
            width: 'Y',
            height: 'Y',
            round: 'X',
            background: 'green.5'
        },
        Box_5: {
            width: 'Y',
            height: 'Y',
            round: 'X',
            background: 'green.7'
        },
        More: {
            tag: 'span',
            text: 'More'
        }
    },
    DetailsCard: {
        hide: (el, s)=>!s.root?._activitySelectedDate,
        flow: 'y',
        gap: 'Z1',
        marginTop: 'Z',
        padding: 'A',
        round: 'A',
        background: 'white.04',
        borderWidth: '1px',
        borderColor: 'line',
        borderStyle: 'solid',
        Header: {
            flow: 'x',
            align: 'center space-between',
            gap: 'Z',
            Title: {
                tag: 'span',
                fontSize: 'Z2',
                fontWeight: '700',
                color: 'title',
                text: (el, s)=>{
                    const date = s.root?._activitySelectedDate;
                    if (!date) return '';
                    const d = new Date(date + 'T00:00:00');
                    return d.toLocaleDateString(undefined, {
                        weekday: 'long',
                        month: 'short',
                        day: 'numeric',
                        year: 'numeric'
                    });
                }
            },
            CloseBtn: {
                tag: 'button',
                type: 'button',
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                color: 'caption',
                fontSize: 'A',
                padding: 'V Z',
                text: "\xd7",
                ':hover': {
                    color: 'title'
                },
                onClick: (e, el, s)=>s.root?.update({
                        _activitySelectedDate: null,
                        _activityDetails: null
                    })
            }
        },
        Loading: {
            hide: (el, s)=>!s.root?._activitySelectedDate || !!s.root?._activityDetails,
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            text: "Loading\u2026"
        },
        Empty: {
            hide: (el, s)=>{
                const list = s.root?._activityDetails;
                return !Array.isArray(list) || list.length > 0;
            },
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            fontStyle: 'italic',
            text: 'No activity recorded for this day.'
        },
        List: {
            hide: (el, s)=>!(s.root?._activityDetails || []).length,
            flow: 'y',
            gap: 'V',
            childExtends: 'TicketsActivityRow',
            childrenAs: 'state',
            children: (el, s)=>s.root?._activityDetails || []
        }
    },
    // Fetch real activity data — ticket updates + standup completions
    onCreate: async (el, s)=>{
        const root = s.root;
        if (!root) return;
        let email = root.currentUserEmail;
        if (!email) await new Promise((resolve)=>{
            let attempts = 0;
            const check = setInterval(()=>{
                email = root.currentUserEmail;
                if (email || ++attempts > 30) {
                    clearInterval(check);
                    resolve();
                }
            }, 200);
        });
        if (!email) return;
        try {
            // migrated 2026-04-27 to SDK route workspaceProject.activity heatmap
            const since = new Date();
            since.setDate(since.getDate() - 365);
            const sinceDate = since.toISOString().slice(0, 10);
            // Single RPC — wrapper aggregates every activity type and scopes
            // by caller's user_email + workspace_id from the JWT.
            const result = await (0, $bfqVY.getSDK)().execute('workspaceProject.activity', 'heatmap', {
                filter: {
                    user_email: email,
                    since: sinceDate,
                    select: 'activity_type, score, occurred_on'
                }
            });
            const data = Array.isArray(result?.data) ? result.data : result?.data || result || [];
            const counts = {};
            for (const row of data || []){
                const day = row.occurred_on;
                if (!day) continue;
                if (!counts[day]) counts[day] = {
                    score: 0,
                    standups: 0,
                    breakdown: {}
                };
                counts[day].score += row.score || 0;
                counts[day].breakdown[row.activity_type] = (counts[day].breakdown[row.activity_type] || 0) + 1;
                if (row.activity_type === 'standup') counts[day].standups++;
            }
            root.update({
                _activityData: counts
            });
        } catch (err) {
            console.error('[ActivityHeatmap]', err);
        }
    }
};
const $aa668d59dbfdf988$var$_typeLabel = {
    standup: 'standup',
    ticket_update: 'ticket update',
    note_edit: 'note edit',
    kb_edit: 'KB edit',
    meet_call: 'meet call'
};
const $aa668d59dbfdf988$var$_loadDetails = async (root, date)=>{
    root.update({
        _activitySelectedDate: date,
        _activityDetails: null
    });
    try {
        // migrated 2026-04-27 to SDK route workspaceProject.activity listEvents
        const result = await (0, $bfqVY.getSDK)().execute('workspaceProject.activity', 'listEvents', {
            filter: {
                user_email: root.currentUserEmail,
                occurred_on: date,
                select: 'activity_type, score, source_table, source_id, metadata, created_at'
            },
            order: {
                column: 'created_at',
                ascending: true
            }
        });
        const data = Array.isArray(result?.data) ? result.data : result?.data || result || [];
        root.update({
            _activityDetails: data || []
        });
    } catch (err) {
        console.error('[ActivityHeatmap details]', err);
        root.update({
            _activityDetails: []
        });
    }
};
const $aa668d59dbfdf988$export$52a5c40ae49b3f97 = {
    width: '100%',
    aspectRatio: '1',
    round: 'X',
    background: (el, s)=>$aa668d59dbfdf988$var$_intensity(s.score, s.standups > 0),
    borderWidth: (el, s)=>s.score || s.standups ? '0' : '1px',
    borderColor: 'line',
    borderStyle: 'solid',
    cursor: (el, s)=>s.score || s.standups ? 'pointer' : 'default',
    transition: 'background 120ms ease',
    ':hover': {
        outline: '1px solid var(--color-title)'
    },
    title: (el, s)=>{
        if (!s.score && !s.standups) return s.date;
        const parts = [];
        if (s.standups) parts.push("\u2726 standup");
        const bd = s.breakdown || {};
        for (const [k, n] of Object.entries(bd)){
            if (k === 'standup') continue;
            parts.push(`${n} ${$aa668d59dbfdf988$var$_typeLabel[k] || k}${n > 1 ? 's' : ''}`);
        }
        return `${s.date} \xb7 ${s.score}pt${s.score === 1 ? '' : 's'}${parts.length ? " \u2014 " + parts.join(', ') : ''}`;
    },
    onClick: (e, el, s)=>{
        if (!s.score && !s.standups) return;
        $aa668d59dbfdf988$var$_loadDetails(s.root, s.date);
    }
};
const $aa668d59dbfdf988$var$_typeColor = (t)=>t === 'standup' ? 'green' : t === 'meet_call' ? 'purple' : t === 'kb_edit' || t === 'note_edit' ? 'cerulean' : 'blue';
const $aa668d59dbfdf988$var$_hhmmss = (ts)=>{
    try {
        return new Date(ts).toLocaleTimeString(undefined, {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false
        });
    } catch  {
        return '';
    }
};
const $aa668d59dbfdf988$var$_detailFor = (s)=>{
    const md = s.metadata || {};
    return md.title || md.summary || md.body || (s.source_id ? `${s.source_table || 'item'}\xb7${s.source_id}` : '');
};
const $aa668d59dbfdf988$export$93b233bf25ccedc5 = {
    flow: 'x',
    gap: 'Z',
    align: 'baseline left',
    padding: 'X Z',
    fontFamily: 'mono',
    fontSize: 'Y2',
    lineHeight: '1.5',
    ':hover': {
        background: 'overlay'
    },
    Time: {
        tag: 'span',
        color: 'caption',
        flexShrink: '0',
        text: (el, s)=>$aa668d59dbfdf988$var$_hhmmss(s.created_at)
    },
    Type: {
        tag: 'span',
        flexShrink: '0',
        minWidth: 'C',
        fontWeight: '700',
        color: (el, s)=>$aa668d59dbfdf988$var$_typeColor(s.activity_type),
        text: (el, s)=>($aa668d59dbfdf988$var$_typeLabel[s.activity_type] || s.activity_type || '').toUpperCase()
    },
    Detail: {
        tag: 'span',
        flex: '1',
        color: 'title',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        text: (el, s)=>$aa668d59dbfdf988$var$_detailFor(s)
    }
};

});

parcelRegister("dpIWN", function(module, exports) {

$parcel$export(module.exports, "TicketsDailyUpdate", () => $9c4079bf1e70f184$export$3d3ec81f2dd34d1a);
$parcel$export(module.exports, "StandupActionCard", () => $9c4079bf1e70f184$export$64463ce6c7e1d256);
$parcel$export(module.exports, "StandupQuickFill", () => $9c4079bf1e70f184$export$b45d90c3c14f7683);
$parcel$export(module.exports, "StandupAppliedCard", () => $9c4079bf1e70f184$export$d0703e3c584d7e4);
$parcel$export(module.exports, "StandupFollowUp", () => $9c4079bf1e70f184$export$504cc65707e69316);
// Daily standup — structured flow with AI summary + action items.
//
// Phases:
//   idle      → Textarea for user's daily update
//   analyzing → AI reads update + ticket data, generates summary + actions
//   review    → Summary card + action cards with Confirm / Skip
//   complete  → "Saved. Thank you for today's update."
//
// Actions are NEVER auto-executed. Each proposed change (create ticket,
// move ticket, update ticket) gets a preview card. User confirms or skips
// each one individually. Once all are resolved the summary is persisted
// as a `standup_summary` note row and the phase flips to `complete`.

var $82gA2 = parcelRequire("82gA2");

var $bfqVY = parcelRequire("bfqVY");
// Credit metering for standup AI now happens server-side inside the
// ai-chat edge function — see server/packages/credit-meter.
const $9c4079bf1e70f184$var$AI_URL = `${(0, $82gA2.RAW_URL)}/functions/v1/ai-chat`;
// Local date (not UTC) — avoids day mismatch when user is ahead of UTC
const $9c4079bf1e70f184$var$_today = ()=>{
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};
const $9c4079bf1e70f184$var$_streamAnalysis = async (updateText, onChunk, onDone)=>{
    const prompt = `[DAILY STANDUP MODE] My update: ${updateText}

Write a standup summary in FIRST PERSON as if I wrote it myself. Example: "Worked on the API fix and got it close to done. Updated the KB article. Blocked on QA feedback for auth changes."

Rules:
1. Write 2-3 sentences in first person ("I worked on...", "Fixed...", "Blocked on...") \u{2014} NOT as an AI ("I have noted...", "I will keep an eye...")
2. No headers, no bullets, no "Follow-ups" section
3. Add ACTION tags for ticket changes. Each ACTION MUST include:
   - "summary": WHY this change (e.g. "Reported finishing this work")
   - "change": what exactly changes (e.g. "Status: Backlog \u{2192} In Review")
   - "followUps": 2 suggested next questions
4. For move_ticket: include "from" and "to" column labels
5. For update_ticket: include "field" and "value"
6. For create_ticket: include "title" and "body"
7. If no actions: <!--ACTION:{"type":"info","followUps":["question1","question2"]}-->`;
    try {
        const res = await fetch($9c4079bf1e70f184$var$AI_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                apikey: (0, $82gA2.SUPABASE_ANON_KEY),
                Authorization: `Bearer ${(0, $82gA2.SUPABASE_ANON_KEY)}`
            },
            body: JSON.stringify({
                messages: [
                    {
                        role: 'user',
                        content: prompt
                    }
                ]
            })
        });
        if (!res.ok || !res.body) {
            const errText = await res.text().catch(()=>'');
            console.error('[Standup AI]', res.status, errText.slice(0, 200));
            onDone('AI analysis failed. Try again.');
            return;
        }
        const reader = res.body.getReader();
        const decoder = new TextDecoder();
        let buffer = '';
        let full = '';
        while(true){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            buffer += decoder.decode(value, {
                stream: true
            });
            const lines = buffer.split('\n');
            buffer = lines.pop() || '';
            for (const line of lines){
                if (!line.startsWith('data: ')) continue;
                const json = line.slice(6).trim();
                if (json === '[DONE]') continue;
                try {
                    const parsed = JSON.parse(json);
                    if (parsed.text) {
                        full += parsed.text;
                        onChunk(full);
                    }
                } catch  {}
            }
        }
        onDone(full || 'No response from AI.');
    } catch (e) {
        console.error('[Standup] stream error:', e);
        onDone("Connection error \u2014 please try again.");
    }
};
const $9c4079bf1e70f184$var$_parseResponse = (text)=>{
    const actions = [];
    const followUps = [];
    const re = /<!--ACTION:(.*?)-->/g;
    let m;
    while((m = re.exec(text)) !== null)try {
        const data = JSON.parse(m[1]);
        if (data.followUps) followUps.push(...data.followUps);
        if (data.type && data.type !== 'info') actions.push({
            ...data,
            _status: 'pending',
            _id: Math.random().toString(36).slice(2)
        });
    } catch  {}
    const display = text.replace(/<!--ACTION:.*?-->/g, '').replace(/\*\*Summary\*\*/gi, '').replace(/\*\*Suggested Actions\*\*/gi, '').replace(/\*\*Today'?s Summary\*\*/gi, '').replace(/\*\*Follow-ups?\*\*/gi, '').replace(/\*\*/g, '').replace(/^- .*follow.up.*$/gim, '').replace(/^- Would you like.*$/gim, '').replace(/^- Do you need.*$/gim, '').replace(/\n{3,}/g, '\n\n').trim();
    return {
        summary: display,
        actions: actions,
        followUps: [
            ...new Set(followUps)
        ]
    };
};
const $9c4079bf1e70f184$var$_executeAction = async (action, root)=>{
    // migrated 2026-04-27 to SDK route workspaceProject.tickets
    const sdk = (0, $bfqVY.getSDK)();
    const email = root.currentUserEmail;
    try {
        if (action.type === 'create_ticket') {
            const result = await sdk.execute('workspaceProject.tickets', 'create', {
                payload: {
                    title: action.title || 'New ticket',
                    body: action.body || '',
                    column_key: action.column_key || 'backlog',
                    priority: action.priority || 'medium',
                    assignee_email: (action.assignee || email).split(',')[0].trim(),
                    reporter_email: email,
                    deleted: false,
                    updated_at: new Date().toISOString()
                }
            });
            const created = Array.isArray(result?.data) ? result.data[0] : result?.data || result;
            if (created) {
                root.update({
                    myTickets: [
                        created,
                        ...root.myTickets || []
                    ]
                });
                return `Created #${created.number || created.id}`;
            }
        } else if (action.type === 'update_ticket' && action.number) {
            const row = {};
            if (action.body) row.body = action.body;
            if (action.column_key) row.column_key = action.column_key;
            if (action.priority) row.priority = action.priority;
            if (action.title) row.title = action.title;
            row.updated_at = new Date().toISOString();
            await sdk.execute('workspaceProject.tickets', 'update', {
                number: action.number,
                payload: row
            });
            root.update({
                myTickets: (root.myTickets || []).map((t)=>(t.number || t.id) === action.number ? {
                        ...t,
                        ...row
                    } : t)
            });
            return `Updated #${action.number}`;
        } else if (action.type === 'move_ticket' && action.number) {
            await sdk.execute('workspaceProject.tickets', 'update', {
                number: action.number,
                payload: {
                    column_key: action.column_key,
                    updated_at: new Date().toISOString()
                }
            });
            root.update({
                myTickets: (root.myTickets || []).map((t)=>(t.number || t.id) === action.number ? {
                        ...t,
                        column_key: action.column_key
                    } : t)
            });
            return `Moved #${action.number}`;
        }
        return null;
    } catch (e) {
        console.error('[Standup action]', e);
        return null;
    }
};
// ─── Persist completed standup ────────────────────────────────────────────
// Upserts on (author, date) so re-submits overwrite the row instead of
// stacking duplicates. Backed by the unique index in migration 0033.
const $9c4079bf1e70f184$var$_saveStandup = async (root, userUpdate, summary, actions)=>{
    try {
        // migrated 2026-04-27 to SDK route workspaceProject.standups upsert
        await (0, $bfqVY.getSDK)().execute('workspaceProject.standups', 'upsert', {
            payload: {
                author: root.currentUserEmail,
                date: $9c4079bf1e70f184$var$_today(),
                update_text: userUpdate,
                summary: summary,
                actions: actions.map((a)=>({
                        type: a.type,
                        title: a.title,
                        number: a.number,
                        summary: a.summary,
                        status: a._status,
                        result: a._result
                    }))
            }
        });
    } catch (e) {
        console.error('[Standup save]', e);
    }
};
const $9c4079bf1e70f184$var$_submitUpdate = async (root, text)=>{
    if (!text?.trim()) return;
    root.update({
        _standupPhase: 'analyzing',
        _dailyDraft: text,
        _standupSummary: '',
        _standupActions: []
    });
    await $9c4079bf1e70f184$var$_streamAnalysis(text, (partial)=>{
        const { summary: summary } = $9c4079bf1e70f184$var$_parseResponse(partial);
        root.update({
            _standupSummary: summary
        });
    }, (final)=>{
        const { summary: summary, actions: actions, followUps: followUps } = $9c4079bf1e70f184$var$_parseResponse(final);
        const hasActions = actions.length > 0;
        root.update({
            _standupPhase: hasActions ? 'review' : 'complete',
            _standupSummary: summary,
            _standupActions: actions,
            _standupFollowUps: followUps || []
        });
        if (!hasActions) $9c4079bf1e70f184$var$_saveStandup(root, text, summary, []);
    });
};
const $9c4079bf1e70f184$var$_confirmAction = async (actionId, root)=>{
    const actions = root._standupActions || [];
    const action = actions.find((a)=>a._id === actionId);
    if (!action) return;
    root.update({
        _standupActions: actions.map((a)=>a._id === actionId ? {
                ...a,
                _status: 'executing'
            } : a)
    });
    const result = await $9c4079bf1e70f184$var$_executeAction(action, root);
    const updated = (root._standupActions || []).map((a)=>a._id === actionId ? {
            ...a,
            _status: 'confirmed',
            _result: result || 'Done'
        } : a);
    root.update({
        _standupActions: updated
    });
    $9c4079bf1e70f184$var$_maybeComplete(root);
};
const $9c4079bf1e70f184$var$_skipAction = (actionId, root)=>{
    root.update({
        _standupActions: (root._standupActions || []).map((a)=>a._id === actionId ? {
                ...a,
                _status: 'skipped'
            } : a)
    });
    $9c4079bf1e70f184$var$_maybeComplete(root);
};
const $9c4079bf1e70f184$var$_maybeComplete = (root)=>{
    const actions = root._standupActions || [];
    if (!actions.length) return;
    if (actions.every((a)=>a._status === 'confirmed' || a._status === 'skipped')) {
        root.update({
            _standupPhase: 'complete'
        });
        $9c4079bf1e70f184$var$_saveStandup(root, root._dailyDraft, root._standupSummary, actions);
    }
};
const $9c4079bf1e70f184$export$3d3ec81f2dd34d1a = {
    flow: 'y',
    gap: 'Z1',
    HeaderRow: {
        flow: 'x',
        align: 'center space-between',
        HistoryLink: {
            tag: 'button',
            type: 'button',
            fontSize: 'Y2',
            fontWeight: '600',
            color: 'blue',
            background: 'transparent',
            borderWidth: '0',
            cursor: 'pointer',
            padding: '0',
            text: "Previous standups \u2192",
            ':hover': {
                opacity: '.7'
            },
            onClick: (e, el)=>{
                let root = el;
                while(root && !root.routes)root = root.parent;
                if (root) el.router('/tickets/standups', root);
            }
        }
    },
    CompletedCard: {
        hide: (el, s)=>s.root?._standupPhase !== 'complete',
        flow: 'y',
        gap: 'Z1',
        padding: 'A',
        round: 'A',
        background: 'green.06',
        borderWidth: '1px',
        borderColor: 'green.2',
        borderStyle: 'solid',
        TopRow: {
            flow: 'x',
            align: 'center left',
            gap: 'Z',
            Icon: {
                name: 'check',
                color: 'green',
                boxSize: 'A1'
            },
            Label: {
                tag: 'span',
                fontSize: 'A',
                fontWeight: '700',
                color: 'green',
                text: "Standup complete \u2014 thank you for today's update!"
            }
        },
        Summary: {
            tag: 'p',
            margin: '0',
            fontSize: 'Z2',
            color: 'title',
            lineHeight: '1.6',
            whiteSpace: 'pre-wrap',
            text: (el, s)=>s.root?._standupSummary || ''
        },
        Applied: {
            hide: (el, s)=>!(s.root?._standupActions || []).some((a)=>a._status === 'confirmed'),
            flow: 'y',
            gap: 'Z',
            marginTop: 'Z',
            Label: {
                tag: 'span',
                fontSize: 'Y2',
                fontWeight: '700',
                color: 'green',
                text: 'Applied changes:'
            },
            List: {
                flow: 'y',
                gap: 'Z',
                childExtends: 'StandupAppliedCard',
                childrenAs: 'state',
                children: (el, s)=>(s.root?._standupActions || []).filter((a)=>a._status === 'confirmed').map((a)=>({
                            _type: a.type,
                            _number: a.number,
                            _title: a.title,
                            _result: a._result || a.summary,
                            _ticketId: a.number ? (s.root?.myTickets || []).find((t)=>(t.number || t.id) === a.number)?.id : null
                        }))
            }
        }
    },
    ActionRow: {
        hide: (el, s)=>s.root?._standupPhase !== 'complete',
        flow: 'x wrap',
        gap: 'Z',
        childExtends: 'StandupFollowUp',
        childrenAs: 'state',
        children: (el, s)=>{
            const followUps = (s.root?._standupFollowUps || []).map((text)=>({
                    _label: text
                }));
            return [
                ...followUps,
                {
                    _label: '+ Submit another update',
                    _isNew: true
                }
            ];
        }
    },
    InputSection: {
        hide: (el, s)=>(s.root?._standupPhase || 'idle') !== 'idle',
        flow: 'y',
        gap: 'Z1',
        Greeting: {
            tag: 'p',
            margin: '0',
            fontSize: 'Z2',
            color: 'caption',
            lineHeight: '1.5',
            text: (el, s)=>{
                const me = el.call('findMe', s);
                const name = (me?.name || '').split(' ')[0] || 'there';
                return `Hi ${name} \u{2014} what did you work on today?`;
            }
        },
        InputBox: {
            position: 'relative',
            round: 'A',
            overflow: 'hidden',
            theme: 'field',
            Textarea: {
                tag: 'textarea',
                placeholder: 'What did you work on today?',
                rows: '4',
                resize: 'vertical',
                width: '100%',
                boxSizing: 'border-box',
                padding: 'A A2 C1',
                border: 'none',
                outline: 'none',
                background: 'transparent',
                color: 'title',
                fontSize: 'Z2',
                lineHeight: '1.5',
                fontFamily: 'inherit',
                onCreate: (el, s)=>{
                    if (s.root?._dailyDraft) el.node.value = s.root._dailyDraft;
                },
                onKeyDown: (e, el, s)=>{
                    if (e.key === 'Enter' && (e.ctrlKey || e.metaKey)) {
                        const text = el.node.value?.trim();
                        if (text) $9c4079bf1e70f184$var$_submitUpdate(s.root, text);
                    }
                }
            },
            SendBtn: {
                extends: 'CircleButton',
                position: 'absolute',
                bottom: 'Z',
                right: 'Z',
                zIndex: '1',
                padding: 'Z',
                icon: 'chevronUp',
                Icon: {
                    transform: 'rotate(45deg)'
                },
                '@dark': {
                    background: 'white',
                    color: 'title',
                    ':hover': {
                        background: 'gray14',
                        color: 'gray1'
                    },
                    ':active': {
                        background: 'gray13',
                        color: 'gray1'
                    }
                },
                onClick: (e, el, s)=>{
                    e.preventDefault();
                    const ta = el.parent?.Textarea?.node;
                    const draft = ta?.value?.trim();
                    if (draft) $9c4079bf1e70f184$var$_submitUpdate(s.root, draft);
                }
            }
        },
        QuickFills: {
            flow: 'x wrap',
            gap: 'Z',
            childExtends: 'StandupQuickFill',
            childrenAs: 'state',
            children: (el, s)=>{
                const tickets = s.root?.myTickets || [];
                const fills = [];
                const active = tickets.filter((t)=>t.column_key === '4d6ab783');
                for (const t of active.slice(0, 2))fills.push({
                    label: `#${t.number || t.id} progress`,
                    _text: `Made progress on #${t.number || t.id} (${t.title}). `
                });
                const review = tickets.filter((t)=>t.column_key === '821cd85d');
                if (review.length) {
                    const t = review[0];
                    fills.push({
                        label: `#${t.number || t.id} done`,
                        _text: `Finished #${t.number || t.id} (${t.title}), ready to close. `
                    });
                }
                if (fills.length < 4) {
                    const backlog = tickets.filter((t)=>t.column_key !== '4d6ab783' && t.column_key !== '821cd85d' && t.column_key !== 'eede5560');
                    if (backlog.length) {
                        const t = backlog[0];
                        fills.push({
                            label: `Started #${t.number || t.id}`,
                            _text: `Started working on #${t.number || t.id} (${t.title}). `
                        });
                    }
                }
                if (fills.length < 3) fills.push({
                    label: 'Code review',
                    _text: 'Reviewed PRs and gave feedback. '
                });
                if (fills.length < 4) fills.push({
                    label: 'Blocked',
                    _text: 'Blocked on '
                });
                if (fills.length < 5) fills.push({
                    label: 'Meetings',
                    _text: 'Attended meetings about '
                });
                return fills.slice(0, 5);
            }
        }
    },
    AnalyzingCard: {
        hide: (el, s)=>s.root?._standupPhase !== 'analyzing',
        flow: 'y',
        gap: 'Z1',
        padding: 'A',
        round: 'A',
        background: 'blue.06',
        borderWidth: '1px',
        borderColor: 'blue.15',
        borderStyle: 'solid',
        TopRow: {
            flow: 'x',
            align: 'center left',
            gap: 'Z',
            Spinner: {
                boxSize: 'A1',
                flexShrink: '0',
                round: '50%',
                borderWidth: '2px',
                borderStyle: 'solid',
                borderColor: 'blue.2',
                borderTopColor: 'blue',
                animation: 'spin 0.9s linear infinite',
                '@keyframes spin': {
                    from: {
                        transform: 'rotate(0deg)'
                    },
                    to: {
                        transform: 'rotate(360deg)'
                    }
                }
            },
            Label: {
                tag: 'span',
                fontSize: 'A',
                fontWeight: '700',
                color: 'blue',
                text: "Analyzing your update\u2026"
            }
        },
        Preview: {
            tag: 'p',
            margin: '0',
            fontSize: 'Z2',
            color: 'title',
            lineHeight: '1.6',
            whiteSpace: 'pre-wrap',
            opacity: '.6',
            text: (el, s)=>s.root?._standupSummary || "Reading your update and comparing with your tickets\u2026"
        }
    },
    ReviewSection: {
        hide: (el, s)=>s.root?._standupPhase !== 'review',
        flow: 'y',
        gap: 'A',
        OriginalCard: {
            flow: 'y',
            gap: 'V',
            InputBox: {
                position: 'relative',
                round: 'A',
                overflow: 'hidden',
                theme: 'field',
                Textarea: {
                    tag: 'textarea',
                    rows: '4',
                    resize: 'vertical',
                    width: '100%',
                    boxSizing: 'border-box',
                    padding: 'A A2 C1',
                    border: 'none',
                    outline: 'none',
                    background: 'transparent',
                    color: 'title',
                    fontSize: 'Z2',
                    lineHeight: '1.5',
                    fontFamily: 'inherit',
                    onCreate: (el, s)=>{
                        if (s.root?._dailyDraft) el.node.value = s.root._dailyDraft;
                    },
                    onKeyDown: (e, el, s)=>{
                        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey)) {
                            const text = el.node.value?.trim();
                            if (text && text !== s.root?._dailyDraft) $9c4079bf1e70f184$var$_submitUpdate(s.root, text);
                        }
                    }
                },
                ResubmitBtn: {
                    extends: 'CircleButton',
                    position: 'absolute',
                    bottom: 'Z',
                    right: 'Z',
                    zIndex: '1',
                    padding: 'Z',
                    icon: 'chevronUp',
                    Icon: {
                        transform: 'rotate(45deg)'
                    },
                    title: 'Re-analyze update',
                    onClick: (e, el, s)=>{
                        e.preventDefault();
                        const ta = el.parent?.Textarea?.node;
                        const draft = ta?.value?.trim();
                        if (draft) $9c4079bf1e70f184$var$_submitUpdate(s.root, draft);
                    }
                }
            }
        },
        SummaryCard: {
            flow: 'y',
            gap: 'Z1',
            padding: 'A',
            round: 'A',
            background: 'white.06',
            borderWidth: '1px',
            borderColor: 'line',
            borderStyle: 'solid',
            Header: {
                flow: 'x',
                align: 'center left',
                gap: 'Z',
                Icon: {
                    name: 'magicstar',
                    color: 'purple',
                    boxSize: 'A1'
                },
                Label: {
                    tag: 'span',
                    fontSize: 'Z2',
                    fontWeight: '700',
                    color: 'purple',
                    text: 'AI-generated summary'
                }
            },
            Body: {
                tag: 'p',
                margin: '0',
                fontSize: 'Z2',
                color: 'title',
                lineHeight: '1.6',
                whiteSpace: 'pre-wrap',
                text: (el, s)=>s.root?._standupSummary || ''
            }
        },
        ActionsHeader: {
            hide: (el, s)=>!(s.root?._standupActions || []).length,
            flow: 'x',
            align: 'center space-between',
            Label: {
                fontSize: 'Z2',
                fontWeight: '600',
                color: 'title',
                text: (el, s)=>{
                    const actions = s.root?._standupActions || [];
                    const pending = actions.filter((a)=>a._status === 'pending').length;
                    if (!pending) return 'All actions addressed';
                    return `${pending} suggested action${pending === 1 ? '' : 's'} \u{2014} confirm or skip each:`;
                }
            },
            SkipAllBtn: {
                hide: (el, s)=>!(s.root?._standupActions || []).some((a)=>a._status === 'pending'),
                tag: 'button',
                type: 'button',
                fontSize: 'Y2',
                fontWeight: '600',
                padding: 'V Z',
                round: 'Z',
                border: 'none',
                cursor: 'pointer',
                background: 'transparent',
                color: 'caption',
                text: 'Skip all',
                ':hover': {
                    color: 'title'
                },
                onClick: (e, el, s)=>{
                    s.root.update({
                        _standupActions: (s.root._standupActions || []).map((a)=>a._status === 'pending' ? {
                                ...a,
                                _status: 'skipped'
                            } : a)
                    });
                    $9c4079bf1e70f184$var$_maybeComplete(s.root);
                }
            }
        },
        ActionCards: {
            flow: 'y',
            gap: 'Z',
            childExtends: 'StandupActionCard',
            childrenAs: 'state',
            children: (el, s)=>s.root?._standupActions || []
        },
        ConfirmAllBtn: {
            hide: (el, s)=>!(s.root?._standupActions || []).some((a)=>a._status === 'pending'),
            tag: 'button',
            type: 'button',
            position: 'sticky',
            bottom: 'Z',
            zIndex: '2',
            padding: 'Z1 B',
            round: 'Z',
            fontSize: 'Z2',
            fontWeight: '700',
            border: 'none',
            cursor: 'pointer',
            background: 'blue',
            color: 'white',
            alignSelf: 'stretch',
            text: 'Confirm All & Save',
            ':hover': {
                opacity: '.9'
            },
            onClick: async (e, el, s)=>{
                const actions = s.root._standupActions || [];
                for (const action of actions)if (action._status === 'pending') await $9c4079bf1e70f184$var$_confirmAction(action._id, s.root);
            }
        }
    },
    onCreate: async (el, s)=>{
        const root = s.root;
        if (!root) return;
        let email = root.currentUserEmail;
        if (!email) await new Promise((resolve)=>{
            let attempts = 0;
            const check = setInterval(()=>{
                email = root.currentUserEmail;
                if (email || ++attempts > 30) {
                    clearInterval(check);
                    resolve();
                }
            }, 200);
        });
        if (!email) return;
        try {
            // migrated 2026-04-27 to SDK route workspaceProject.standups list (single row)
            const result = await (0, $bfqVY.getSDK)().execute('workspaceProject.standups', 'list', {
                filter: {
                    author: email,
                    date: $9c4079bf1e70f184$var$_today()
                },
                single: true,
                limit: 1,
                options: {
                    columns: 'summary, actions'
                }
            });
            const data = Array.isArray(result?.data) ? result.data[0] : result?.data ?? result ?? null;
            if (data) {
                const actions = (data.actions || []).map((a)=>({
                        ...a,
                        _status: a.status || 'confirmed',
                        _id: Math.random().toString(36).slice(2)
                    }));
                root.update({
                    _standupPhase: 'complete',
                    _standupSummary: data.summary || '',
                    _standupActions: actions
                });
            } else root.update({
                _standupPhase: 'idle'
            });
        } catch  {}
    }
};
const $9c4079bf1e70f184$var$_actionColor = (s)=>{
    if (s._status === 'confirmed') return 'green';
    if (s._status === 'skipped') return 'caption';
    if (s._status === 'executing') return 'blue';
    if (s.type === 'create_ticket') return 'orange';
    if (s.type === 'move_ticket') return 'blue';
    return 'yellow';
};
const $9c4079bf1e70f184$export$64463ce6c7e1d256 = {
    flow: 'x',
    gap: 'Z1',
    align: 'center left',
    padding: 'Z1 A',
    round: 'Z1',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: (el, s)=>`${$9c4079bf1e70f184$var$_actionColor(s)}.2`,
    background: (el, s)=>`${$9c4079bf1e70f184$var$_actionColor(s)}.06`,
    opacity: (el, s)=>s._status === 'skipped' ? '.5' : '1',
    transition: 'all 200ms ease',
    Icon: {
        boxSize: 'A1',
        flexShrink: '0',
        name: (el, s)=>{
            if (s._status === 'confirmed') return 'check';
            if (s.type === 'create_ticket') return 'add';
            if (s.type === 'move_ticket') return 'arrowRight';
            return 'document';
        },
        color: (el, s)=>$9c4079bf1e70f184$var$_actionColor(s)
    },
    Content: {
        flow: 'y',
        gap: 'V',
        flex: '1',
        minWidth: '0',
        TicketRef: {
            flow: 'x',
            gap: 'Z',
            align: 'center left',
            Chip: {
                hide: (el, s)=>!s.number && s.type === 'create_ticket',
                tag: 'button',
                type: 'button',
                padding: 'V Z',
                round: 'V',
                border: 'none',
                fontSize: 'Y2',
                fontWeight: '700',
                cursor: 'pointer',
                background: (el, s)=>`${$9c4079bf1e70f184$var$_actionColor(s)}.15`,
                color: (el, s)=>$9c4079bf1e70f184$var$_actionColor(s),
                ':hover': {
                    background: (el, s)=>`${$9c4079bf1e70f184$var$_actionColor(s)}.25`
                },
                text: (el, s)=>s.number ? `#${s.number}` : '',
                onClick: (e, el, s)=>{
                    e.stopPropagation();
                    if (!s.number) return;
                    const ticket = (s.root?.myTickets || []).find((t)=>(t.number || t.id) === s.number);
                    if (ticket) s.root?.update({
                        selectedTicket: ticket
                    });
                }
            },
            TypeLabel: {
                tag: 'span',
                fontSize: 'Y2',
                fontWeight: '600',
                color: (el, s)=>$9c4079bf1e70f184$var$_actionColor(s),
                text: (el, s)=>{
                    if (s._status === 'confirmed') return 'Applied';
                    if (s._status === 'skipped') return 'Skipped';
                    if (s._status === 'executing') return "Applying\u2026";
                    if (s.type === 'create_ticket') return '+ New ticket';
                    if (s.type === 'move_ticket') return 'Move';
                    return 'Update';
                }
            }
        },
        Change: {
            hide: (el, s)=>!s.change && !s.from,
            tag: 'span',
            fontSize: 'Z2',
            fontWeight: '600',
            color: 'title',
            text: (el, s)=>{
                if (s.change) return s.change;
                if (s.from && s.to) return `Status: ${s.from} \u{2192} ${s.to}`;
                return '';
            }
        },
        Detail: {
            tag: 'p',
            margin: '0',
            fontSize: 'Y2',
            color: 'caption',
            lineHeight: '1.4',
            text: (el, s)=>{
                if (s.type === 'create_ticket') return s.title || 'New ticket';
                return s.summary || s.body || '';
            }
        }
    },
    Actions: {
        hide: (el, s)=>s._status !== 'pending',
        flow: 'x',
        gap: 'Z',
        flexShrink: '0',
        ConfirmBtn: {
            tag: 'button',
            type: 'button',
            fontSize: 'Y2',
            fontWeight: '700',
            padding: 'V Z1',
            round: 'Z',
            border: 'none',
            cursor: 'pointer',
            background: 'blue.15',
            color: 'blue',
            text: 'Confirm',
            ':hover': {
                background: 'blue.25'
            },
            onClick: (e, el, s)=>{
                e.stopPropagation();
                $9c4079bf1e70f184$var$_confirmAction(s._id, s.root);
            }
        },
        SkipBtn: {
            tag: 'button',
            type: 'button',
            fontSize: 'Y2',
            fontWeight: '600',
            padding: 'V Z1',
            round: 'Z',
            border: 'none',
            cursor: 'pointer',
            background: 'blue.06',
            color: 'blue+50',
            text: 'Skip',
            ':hover': {
                color: 'blue',
                background: 'blue.12'
            },
            onClick: (e, el, s)=>{
                e.stopPropagation();
                $9c4079bf1e70f184$var$_skipAction(s._id, s.root);
            }
        }
    },
    ResultBadge: {
        hide: (el, s)=>s._status !== 'confirmed',
        tag: 'span',
        fontSize: 'Y2',
        color: 'green',
        fontWeight: '600',
        flexShrink: '0',
        text: (el, s)=>s._result || 'Done'
    }
};
const $9c4079bf1e70f184$export$b45d90c3c14f7683 = {
    tag: 'button',
    type: 'button',
    padding: 'Y2 Z1',
    round: 'C',
    fontSize: 'Y2',
    fontWeight: '600',
    border: 'none',
    cursor: 'pointer',
    background: 'blue.12',
    color: 'blue',
    ':hover': {
        background: 'blue.2'
    },
    transition: 'background 100ms ease',
    text: (el, s)=>s.label || '',
    onClick: (e, el, s)=>{
        e.stopPropagation();
        const ta = el.parent?.parent?.InputBox?.Textarea?.node;
        if (!ta) return;
        const next = (ta.value || '') + s._text;
        ta.value = next;
        ta.focus();
        ta.setSelectionRange(next.length, next.length);
    }
};
const $9c4079bf1e70f184$export$d0703e3c584d7e4 = {
    flow: 'x',
    gap: 'Z',
    align: 'center left',
    padding: 'Z Z1',
    round: 'Z',
    background: 'white.04',
    transition: 'background 100ms ease',
    StatusIcon: {
        tag: 'span',
        fontSize: 'Z2',
        color: 'green',
        text: "\u2713",
        flexShrink: '0'
    },
    TicketChip: {
        hide: (el, s)=>!s._number && !s._title,
        tag: 'button',
        type: 'button',
        padding: 'V Z',
        round: 'V',
        border: 'none',
        fontSize: 'Y2',
        fontWeight: '700',
        flexShrink: '0',
        cursor: (el, s)=>s._ticketId ? 'pointer' : 'default',
        background: (el, s)=>s._type === 'create_ticket' ? 'orange.15' : s._type === 'move_ticket' ? 'blue.15' : 'yellow.15',
        color: (el, s)=>s._type === 'create_ticket' ? 'orange' : s._type === 'move_ticket' ? 'blue' : 'yellow',
        ':hover': {
            background: (el, s)=>s._type === 'create_ticket' ? 'orange.25' : s._type === 'move_ticket' ? 'blue.25' : 'yellow.25'
        },
        text: (el, s)=>{
            if (s._number) return `#${s._number}`;
            if (s._title) return s._title;
            return '';
        },
        onClick: (e, el, s)=>{
            e.stopPropagation();
            if (!s._ticketId) return;
            const ticket = (s.root?.myTickets || []).find((t)=>t.id === s._ticketId);
            if (ticket) s.root?.update({
                selectedTicket: ticket
            });
        }
    },
    Detail: {
        tag: 'span',
        fontSize: 'Y2',
        color: 'caption',
        flex: '1',
        text: (el, s)=>s._result || ''
    }
};
const $9c4079bf1e70f184$export$504cc65707e69316 = {
    tag: 'button',
    type: 'button',
    padding: 'Y2 Z1',
    round: 'C',
    fontSize: 'Y2',
    fontWeight: '600',
    border: 'none',
    cursor: 'pointer',
    background: 'blue.12',
    color: 'blue',
    ':hover': {
        background: 'blue.2'
    },
    transition: 'background 100ms ease',
    text: (el, s)=>s._label || '',
    onClick: (e, el, s)=>{
        e.stopPropagation();
        if (s._isNew) s.root?.update({
            _standupPhase: 'idle',
            _dailyDraft: '',
            _standupSummary: '',
            _standupActions: [],
            _standupFollowUps: []
        });
        else s.root?.update({
            assistantOpen: true,
            assistantMessages: [
                ...s.root?.assistantMessages || [],
                {
                    role: 'user',
                    body: s._label
                }
            ]
        });
    }
};

});

parcelRegister("ksjO3", function(module, exports) {

$parcel$export(module.exports, "TicketsStandupsMain", () => $ee45c94a9eb0d91e$export$cc66e82e780b5dd1);
$parcel$export(module.exports, "StandupDayCard", () => $ee45c94a9eb0d91e$export$7d8812c8196da738);
$parcel$export(module.exports, "StandupHistoryAction", () => $ee45c94a9eb0d91e$export$2cade7a5017e5b2c);
// Standup history page — shows past standup summaries grouped by date.
// Each entry is a completed standup with summary text + action outcomes.

var $bfqVY = parcelRequire("bfqVY");
const $ee45c94a9eb0d91e$export$cc66e82e780b5dd1 = {
    extends: 'AppMain',
    padding: '0',
    Header: {
        extends: 'TicketsHeader'
    },
    Body: {
        overflow: 'auto',
        Hero: {
            extends: 'PageHero',
            eyebrow: 'STANDUPS',
            headline: 'Daily Standup History',
            lede: 'Your past standup summaries and action items.'
        },
        Content: {
            flow: 'y',
            gap: 'B',
            padding: 'B B1 D B1',
            maxWidth: 'L+L',
            width: '100%',
            margin: '0 auto',
            Empty: {
                hide: (el, s)=>(s.root?._dailyUpdates || []).length > 0,
                padding: 'C',
                align: 'center center',
                color: 'caption',
                fontSize: 'Z2',
                text: 'No standup history yet. Submit your first daily update!'
            },
            childExtends: 'StandupDayCard',
            childrenAs: 'state',
            children: (el, s)=>s.root?._dailyUpdates || []
        },
        // Load standup history on mount
        onCreate: async (el, s)=>{
            const root = s.root;
            if (!root) return;
            const email = root.currentUserEmail;
            if (!email) return;
            try {
                // migrated 2026-04-27 to SDK route workspaceProject.standups list
                const result = await (0, $bfqVY.getSDK)().execute('workspaceProject.standups', 'list', {
                    filter: {
                        author: email,
                        select: 'date, update_text, summary, actions, created_at'
                    },
                    order: {
                        column: 'date',
                        ascending: false
                    },
                    limit: 30
                });
                const data = Array.isArray(result?.data) ? result.data : result?.data || result || [];
                if (data?.length) {
                    const updates = data.map((row)=>({
                            _date: row.date,
                            _summary: row.summary || '',
                            _userUpdate: row.update_text || '',
                            _actions: row.actions || [],
                            _createdAt: row.created_at
                        }));
                    root.update({
                        _dailyUpdates: updates
                    });
                }
            } catch  {}
        }
    }
};
const $ee45c94a9eb0d91e$export$7d8812c8196da738 = {
    flow: 'y',
    gap: 'Z',
    padding: 'A',
    round: 'A',
    background: 'overlay',
    borderWidth: '1px',
    borderColor: 'line',
    borderStyle: 'solid',
    Header: {
        flow: 'x',
        align: 'center space-between',
        cursor: 'pointer',
        onClick: (e, el, s)=>{
            const key = '_standupOpen_' + (s._createdAt || s._date);
            s.root.update({
                [key]: !s.root[key]
            });
        },
        Left: {
            flow: 'x',
            align: 'center left',
            gap: 'Z',
            Icon: {
                extends: 'Icon',
                name: 'check',
                color: 'green',
                boxSize: 'A'
            },
            DateTitle: {
                tag: 'h3',
                margin: '0',
                fontSize: 'A',
                fontWeight: '600',
                color: 'title',
                text: (el, s)=>{
                    if (!s._date) return '';
                    const d = new Date(s._date + 'T00:00:00');
                    const dateStr = d.toLocaleDateString('en-US', {
                        weekday: 'long',
                        month: 'long',
                        day: 'numeric',
                        year: 'numeric'
                    });
                    // Add time if multiple standups on same day
                    if (s._createdAt) {
                        const t = new Date(s._createdAt);
                        const time = t.toLocaleTimeString('en-US', {
                            hour: 'numeric',
                            minute: '2-digit'
                        });
                        return `${dateStr} \xb7 ${time}`;
                    }
                    return dateStr;
                }
            }
        },
        Stats: {
            flow: 'x',
            gap: 'Z',
            align: 'center right',
            ActionCount: {
                hide: (el, s)=>!(s._actions || []).length,
                tag: 'span',
                fontSize: 'Y2',
                fontWeight: '600',
                color: 'green',
                text: (el, s)=>{
                    const confirmed = (s._actions || []).filter((a)=>a.status === 'confirmed').length;
                    return confirmed ? `${confirmed} applied` : '';
                }
            },
            Caret: {
                extends: 'Icon',
                name: 'chevronDown',
                boxSize: 'A',
                color: 'caption',
                transition: 'transform 120ms ease',
                transform: (el, s)=>s.root?.['_standupOpen_' + (s._createdAt || s._date)] ? 'rotate(0)' : 'rotate(-90deg)'
            }
        }
    },
    // Collapsed preview — first line of summary
    Preview: {
        hide: (el, s)=>!!s.root?.['_standupOpen_' + (s._createdAt || s._date)],
        tag: 'p',
        margin: '0',
        fontSize: 'Z2',
        color: 'caption',
        lineHeight: '1.4',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        text: (el, s)=>{
            const raw = s._summary || '';
            // Strip markdown formatting for preview
            return raw.replace(/\*\*/g, '').replace(/\n/g, ' ').slice(0, 120);
        }
    },
    // Expanded detail
    Detail: {
        show: (el, s)=>!!s.root?.['_standupOpen_' + (s._createdAt || s._date)],
        flow: 'y',
        gap: 'Z1',
        // User's original update
        UserUpdate: {
            hide: (el, s)=>!s._userUpdate,
            flow: 'y',
            gap: 'V',
            padding: 'Z1 A',
            round: 'Z1',
            background: 'blue.04',
            borderWidth: '1px',
            borderColor: 'blue.1',
            borderStyle: 'solid',
            Label: {
                tag: 'span',
                fontSize: 'Y2',
                fontWeight: '700',
                color: 'blue',
                text: 'YOUR UPDATE'
            },
            Body: {
                tag: 'p',
                margin: '0',
                fontSize: 'Z2',
                color: 'title',
                lineHeight: '1.5',
                whiteSpace: 'pre-wrap',
                text: (el, s)=>s._userUpdate || ''
            }
        },
        // AI summary
        Summary: {
            flow: 'y',
            gap: 'V',
            Label: {
                tag: 'span',
                fontSize: 'Y2',
                fontWeight: '700',
                color: 'purple',
                text: 'AI SUMMARY'
            },
            Body: {
                tag: 'p',
                margin: '0',
                fontSize: 'Z2',
                color: 'title',
                lineHeight: '1.6',
                whiteSpace: 'pre-wrap',
                text: (el, s)=>s._summary || ''
            }
        },
        // Action outcomes
        Actions: {
            hide: (el, s)=>!(s._actions || []).length,
            flow: 'y',
            gap: 'V',
            Label: {
                tag: 'span',
                fontSize: 'Y2',
                fontWeight: '700',
                color: 'caption',
                text: 'ACTIONS'
            },
            List: {
                flow: 'y',
                gap: 'V',
                childExtends: 'StandupHistoryAction',
                childrenAs: 'state',
                children: (el, s)=>(s._actions || []).map((a, i)=>({
                            ...a,
                            _idx: i
                        }))
            }
        }
    }
};
const $ee45c94a9eb0d91e$export$2cade7a5017e5b2c = {
    flow: 'x',
    gap: 'Z',
    align: 'center left',
    padding: 'V 0',
    StatusIcon: {
        tag: 'span',
        fontSize: 'Z2',
        text: (el, s)=>s.status === 'confirmed' ? "\u2713" : "\u2014",
        color: (el, s)=>s.status === 'confirmed' ? 'green' : 'caption'
    },
    TypeBadge: {
        tag: 'span',
        fontSize: 'Y1',
        fontWeight: '700',
        letterSpacing: '.03em',
        padding: 'V Z',
        round: 'V',
        background: (el, s)=>{
            if (s.status === 'skipped') return 'white.04';
            if (s.type === 'create_ticket') return 'orange.1';
            if (s.type === 'move_ticket') return 'blue.1';
            return 'yellow.1';
        },
        color: (el, s)=>{
            if (s.status === 'skipped') return 'caption';
            if (s.type === 'create_ticket') return 'orange';
            if (s.type === 'move_ticket') return 'blue';
            return 'yellow';
        },
        text: (el, s)=>{
            if (s.type === 'create_ticket') return 'CREATE';
            if (s.type === 'move_ticket') return 'MOVE';
            return 'UPDATE';
        }
    },
    Description: {
        tag: 'span',
        fontSize: 'Z2',
        color: (el, s)=>s.status === 'skipped' ? 'caption' : 'title',
        textDecoration: (el, s)=>s.status === 'skipped' ? 'line-through' : 'none',
        text: (el, s)=>s.summary || s.title || s.result || ''
    }
};

});

parcelRegister("bZEqU", function(module, exports) {

$parcel$export(module.exports, "TicketsFeedMain", () => $8bb4c16080910d5d$export$52828525879d35e8);
$parcel$export(module.exports, "FeedItemRow", () => $8bb4c16080910d5d$export$be28a0ce479cd2);
// /tickets/feed Main pane. Chronological stream of ship events +
// ticket updates, filterable by the 4-axis tab (All / Team / Agents /
// Me). Realtime — items appear as they land.

var $ghHor = parcelRequire("ghHor");
const $8bb4c16080910d5d$var$_openTicketById = async (root, id, fallback)=>{
    if (!root || typeof root.update !== 'function') return;
    // Optimistic open with what we have so the modal appears immediately.
    root.update({
        selectedTicket: {
            id: id,
            ...fallback || {}
        }
    });
    try {
        const res = await fetch(`${(0, $ghHor.SUPABASE_URL)}/rest/v1/tickets?id=eq.${id}&select=*&limit=1`, {
            headers: (0, $ghHor.restHeaders)()
        });
        if (!res.ok) return;
        const rows = await res.json();
        const t = Array.isArray(rows) ? rows[0] : null;
        if (!t) return;
        root.update({
            selectedTicket: {
                ...t,
                columnKey: t.column_key,
                issueType: t.issue_type,
                epicName: t.epic_name,
                assigneeEmail: t.assignee_email,
                reporterEmail: t.reporter_email,
                updatedAt: t.updated_at,
                createdAt: t.created_at
            }
        });
    } catch (_) {}
};
const $8bb4c16080910d5d$var$KIND_LABEL = {
    shipped: 'shipped',
    picked_up: 'picked up',
    blocked: 'blocked',
    handed_off: 'handed off',
    asked_user: 'asked user',
    heartbeat: 'heartbeat',
    ticket_update: 'updated'
};
const $8bb4c16080910d5d$var$KIND_COLOR = {
    shipped: 'green',
    picked_up: 'cyan',
    blocked: 'red',
    handed_off: 'magenta',
    asked_user: 'yellow',
    heartbeat: 'caption',
    ticket_update: 'caption'
};
const $8bb4c16080910d5d$export$52828525879d35e8 = {
    extends: 'AppMain',
    Header: {
        extends: 'TicketsHeader'
    },
    Body: {
        overflow: 'auto',
        Hero: {
            extends: 'PageHero',
            eyebrow: "WORKSPACE \xb7 ACTIVITY FEED",
            headline: 'Feed',
            lede: (el, s)=>{
                const items = s.root.feedItems;
                if (items == null) return "Loading recent activity\u2026";
                const n = items.length;
                return n ? `${n} recent events \xb7 updates stream live from Supabase realtime.` : 'No recent activity yet.';
            }
        },
        Container: {
            flow: 'y',
            gap: 'A',
            padding: 'C B1 D B1',
            maxWidth: 'L+L',
            width: '100%',
            margin: '0 auto',
            List: {
                flow: 'y',
                gap: 'V',
                childExtends: 'FeedItemRow',
                childrenAs: 'state',
                children: (el, s)=>{
                    const filter = s.root.filterAssignee || null;
                    const me = (s.root.me?.email || '').toLowerCase();
                    const isAgent = (e)=>/-agent@symbols\.app$/.test(e || '');
                    const items = s.root.feedItems || [];
                    return items.filter((x)=>{
                        const e = (x.actorEmail || '').toLowerCase();
                        if (!filter) return true;
                        if (filter === 'me') return me && e === me;
                        if (filter === 'agents') return isAgent(e);
                        if (filter === 'team') return e && !isAgent(e) && e !== me;
                        return true;
                    });
                }
            },
            Empty: {
                hide: (el, s)=>{
                    const items = s.root.feedItems;
                    // Hide when items not yet loaded (null/undefined) or when items exist
                    if (items == null) return true;
                    return items.length > 0;
                },
                flow: 'y',
                align: 'center center',
                gap: 'A',
                padding: 'D',
                textAlign: 'center',
                Icon: {
                    extends: 'Icon',
                    icon: 'clock',
                    boxSize: 'D',
                    color: 'caption',
                    opacity: '.4'
                },
                Title: {
                    tag: 'h3',
                    margin: '0',
                    fontSize: 'B',
                    fontWeight: '600',
                    color: 'title',
                    text: 'No activity yet'
                },
                Body: {
                    tag: 'p',
                    margin: '0',
                    fontSize: 'A',
                    color: 'caption',
                    lineHeight: '1.5',
                    text: 'Ship events and ticket updates will stream here in real time.'
                }
            }
        }
    }
};
const $8bb4c16080910d5d$export$be28a0ce479cd2 = {
    flow: 'x',
    align: 'center left',
    gap: 'V',
    padding: 'Z A',
    background: 'overlay',
    round: 'V',
    borderWidth: 'V',
    borderStyle: 'solid',
    borderColor: 'line',
    cursor: (el, s)=>s.ticketId ? 'pointer' : 'default',
    transition: 'border-color 0.12s ease, transform 0.12s ease',
    ':hover': {
        borderColor: 'title'
    },
    onClick: (e, el, s)=>{
        if (!s.ticketId) return;
        const root = s.root || el.getRoot();
        $8bb4c16080910d5d$var$_openTicketById(root, s.ticketId, {
            external_id: s.ticketExternalId,
            title: s.ticketTitle
        });
    },
    Actor: {
        tag: 'span',
        flexShrink: '0',
        fontSize: 'Y1',
        fontWeight: '700',
        color: (el, s)=>/-agent@symbols\.app$/.test(s.actorEmail || '') ? 'cyan' : 'title',
        text: (el, s)=>{
            const label = s.actorDisplay || (s.actorEmail || '').split('@')[0] || "\u2014";
            const isAgent = /-agent@symbols\.app$/.test(s.actorEmail || '');
            return isAgent ? `\u{1F916} ${label.toUpperCase()}` : label;
        }
    },
    Kind: {
        tag: 'span',
        flexShrink: '0',
        fontSize: 'Y2',
        fontWeight: '600',
        color: (el, s)=>$8bb4c16080910d5d$var$KIND_COLOR[s.kind] || 'caption',
        text: (el, s)=>$8bb4c16080910d5d$var$KIND_LABEL[s.kind] || s.kind || ''
    },
    Ticket: {
        tag: 'span',
        flex: '1',
        fontSize: 'Y1',
        color: 'title',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        text: (el, s)=>{
            const ref = s.ticketExternalId || (s.ticketId ? `#${s.ticketId}` : '');
            const title = (s.ticketTitle || '').replace(/^B-\d+\s*·\s*/, '');
            return [
                ref,
                title
            ].filter(Boolean).join(" \xb7 ");
        }
    },
    Sha: {
        hide: (el, s)=>!s.commitSha,
        tag: 'span',
        flexShrink: '0',
        fontSize: 'Y2',
        fontFamily: 'monospace',
        color: 'caption',
        text: (el, s)=>(s.commitSha || '').slice(0, 8)
    },
    Time: {
        tag: 'span',
        flexShrink: '0',
        fontSize: 'Y2',
        color: 'caption',
        text: (el, s)=>{
            const ts = s.tsISO ? new Date(s.tsISO).getTime() : 0;
            if (!ts) return '';
            const diffS = Math.floor((Date.now() - ts) / 1000);
            if (diffS < 60) return `${diffS}s`;
            if (diffS < 3600) return `${Math.floor(diffS / 60)}m`;
            if (diffS < 86400) return `${Math.floor(diffS / 3600)}h`;
            return `${Math.floor(diffS / 86400)}d`;
        }
    }
};

});


parcelRegister("hQlkx", function(module, exports) {

var $hrMC9 = parcelRequire("hrMC9");

var $6zlBP = parcelRequire("6zlBP");

var $9AmgV = parcelRequire("9AmgV");

var $8fwbA = parcelRequire("8fwbA");

var $csKGB = parcelRequire("csKGB");

var $1Bm7R = parcelRequire("1Bm7R");
$parcel$exportWildcard(module.exports, $hrMC9);
$parcel$exportWildcard(module.exports, $6zlBP);
$parcel$exportWildcard(module.exports, $9AmgV);
$parcel$exportWildcard(module.exports, $8fwbA);
$parcel$exportWildcard(module.exports, $csKGB);
$parcel$exportWildcard(module.exports, $1Bm7R);

});
parcelRegister("hrMC9", function(module, exports) {

$parcel$export(module.exports, "DocsSidebar", () => $cb3aab18055c91c9$export$8751c016a98a6ee);
$parcel$export(module.exports, "DocsSectionNav", () => $cb3aab18055c91c9$export$4a44e8bf20fac92f);
$parcel$export(module.exports, "DocsSectionRow", () => $cb3aab18055c91c9$export$9613741b5d35c689);
$parcel$export(module.exports, "DocsSubNav", () => $cb3aab18055c91c9$export$14e88ff1b9aaad8d);
$parcel$export(module.exports, "DocsFolderList", () => $cb3aab18055c91c9$export$70c33907be3b2177);
$parcel$export(module.exports, "DocsFolderRow", () => $cb3aab18055c91c9$export$c707b150d6ff3f70);
$parcel$export(module.exports, "DocsNotesFilterList", () => $cb3aab18055c91c9$export$a7103a18e6c2873c);
$parcel$export(module.exports, "DocsNotesFilterRow", () => $cb3aab18055c91c9$export$63b12fdecf0ad03a);
$parcel$export(module.exports, "DocsKbCategoryList", () => $cb3aab18055c91c9$export$b4273f6b069f0b7d);
$parcel$export(module.exports, "DocsKbCategoryRow", () => $cb3aab18055c91c9$export$84ad1e2dd937b41a);
// Documents sidebar — extends shared-gov's AppSidebar.
// Top: AppNavbar (cross-app switcher)
// Middle: section nav (Documents, Notes, Knowledge Base) + contextual sub-nav

var $3ihxA = parcelRequire("3ihxA");
const $cb3aab18055c91c9$var$_navigate = (el, path)=>{
    let rootEl = el;
    while(rootEl && !rootEl.routes)rootEl = rootEl.parent;
    const router = el.context?.utils?.router;
    if (router && rootEl) router(path, rootEl, {}, {
        pushState: true,
        scrollToTop: true
    });
};
const $cb3aab18055c91c9$export$8751c016a98a6ee = {
    extends: 'AppSidebar',
    Top: null,
    Middle: {
        gap: 'X2',
        flow: 'y',
        padding: '0',
        SectionNav: {
            extends: 'DocsSectionNav',
            padding: 'X2'
        },
        Line: {
            height: '1px',
            background: 'line',
            margin: '0'
        },
        DocsSubNav: {
            padding: 'X2'
        }
    },
    // Scrollable people rail at the bottom of the sidebar — same groups
    // calendar uses so collaborators are one click away while browsing docs.
    // Key-based auto-extend resolves `PeopleSection` against the registered
    // component, so no explicit `extends:` is needed.
    PeopleSection: {
        TeamGroup: {
            extends: 'PeopleGroup',
            label: 'TEAM',
            groupName: 'team'
        },
        AdvisorsGroup: {
            extends: 'PeopleGroup',
            label: 'ADVISORS',
            groupName: 'advisor',
            display: (el)=>el.call('currentUserIsSuperadmin') ? 'flex' : 'none'
        },
        InvestorsGroup: {
            extends: 'PeopleGroup',
            label: 'INVESTORS',
            groupName: 'investor',
            display: (el)=>el.call('currentUserIsSuperadmin') ? 'flex' : 'none'
        }
    }
};
// ── Section switcher: Documents / Notes / Knowledge Base ──
const $cb3aab18055c91c9$var$_sections = [
    {
        key: 'documents',
        label: 'Documents',
        icon: 'document'
    },
    {
        key: 'notes',
        label: 'Notes',
        icon: 'edit'
    },
    {
        key: 'knowledge-base',
        label: 'Knowledge Base',
        icon: 'document'
    }
];
const $cb3aab18055c91c9$export$4a44e8bf20fac92f = {
    flow: 'y',
    gap: 'V',
    childExtends: 'DocsSectionRow',
    childrenAs: 'state',
    children: ()=>$cb3aab18055c91c9$var$_sections
};
const $cb3aab18055c91c9$export$9613741b5d35c689 = {
    extends: 'SidebarRow',
    fontWeight: '600',
    background: (el, s)=>s.root.activeSection === s.key ? 'overlay' : 'transparent',
    color: (el, s)=>s.root.activeSection === s.key ? 'title' : 'caption',
    onClick: (e, el, s)=>{
        s.root.update({
            activeSection: s.key,
            selectedDocument: null,
            editorDoc: null,
            editorPreview: false
        });
        $cb3aab18055c91c9$var$_navigate(el, '/documents' + (s.key === 'documents' ? '' : '/' + s.key));
    },
    Icon: {
        icon: (el, s)=>s.icon || 'document'
    },
    Label: {
        text: (el, s)=>s.label || s.key
    },
    // Section nav doesn't need three-dot menu
    MoreBtn: null
};
const $cb3aab18055c91c9$export$14e88ff1b9aaad8d = {
    flow: 'y',
    gap: 'V',
    FolderList: {
        extends: 'DocsFolderList',
        if: (el, s)=>s.root.activeSection === 'documents'
    },
    NotesFilterList: {
        extends: 'DocsNotesFilterList',
        if: (el, s)=>s.root.activeSection === 'notes'
    },
    KbCategoryList: {
        extends: 'DocsKbCategoryList',
        if: (el, s)=>s.root.activeSection === 'knowledge-base'
    }
};
const $cb3aab18055c91c9$export$70c33907be3b2177 = {
    flow: 'y',
    gap: 'V',
    childExtends: 'DocsFolderRow',
    childrenAs: 'state',
    children: (el, s)=>(0, $3ihxA.DOC_FOLDERS)
};
const $cb3aab18055c91c9$export$c707b150d6ff3f70 = {
    extends: 'SidebarRow',
    background: (el, s)=>s.root.selectedFolder === s.key ? 'overlay' : 'transparent',
    color: (el, s)=>s.root.selectedFolder === s.key ? 'title' : 'caption',
    onClick: (e, el, s)=>{
        s.root.update({
            selectedFolder: s.key,
            selectedDocument: null
        });
    },
    Icon: {
        icon: (el, s)=>s.icon || 'document'
    },
    Label: {
        text: (el, s)=>s.label || s.key
    },
    Count: {
        tag: 'span',
        fontSize: 'Y2',
        color: 'caption',
        text: (el, s)=>{
            const all = s.root.documents || [];
            const n = s.key === 'all' ? all.length : all.filter((d)=>d.folder === s.key).length;
            return String(n);
        }
    },
    MoreBtn: {
        items: [
            {
                label: 'Rename folder',
                action: 'rename-folder'
            },
            {
                label: 'Delete folder',
                action: 'delete-folder',
                color: 'red'
            }
        ]
    }
};
// ── Notes filters ──
const $cb3aab18055c91c9$var$_notesFilters = [
    {
        key: 'all',
        label: 'All notes',
        icon: 'edit'
    },
    {
        key: 'member',
        label: 'Member notes',
        icon: 'user'
    },
    {
        key: 'ai',
        label: 'AI notes',
        icon: 'star'
    }
];
const $cb3aab18055c91c9$export$a7103a18e6c2873c = {
    flow: 'y',
    gap: 'V',
    childExtends: 'DocsNotesFilterRow',
    childrenAs: 'state',
    children: ()=>$cb3aab18055c91c9$var$_notesFilters
};
const $cb3aab18055c91c9$export$63b12fdecf0ad03a = {
    extends: 'SidebarRow',
    background: (el, s)=>s.root.notesFilter === s.key ? 'overlay' : 'transparent',
    color: (el, s)=>s.root.notesFilter === s.key ? 'title' : 'caption',
    onClick: (e, el, s)=>{
        s.root.update({
            notesFilter: s.key,
            selectedNoteId: null
        });
    },
    Icon: {
        icon: (el, s)=>s.icon || 'edit'
    },
    Label: {
        text: (el, s)=>s.label || s.key
    },
    Count: {
        tag: 'span',
        fontSize: 'Y2',
        color: 'caption',
        text: (el, s)=>{
            const all = s.root.notes || [];
            if (s.key === 'all') return String(all.length);
            return String(all.filter((n)=>n.source === s.key).length);
        }
    },
    MoreBtn: {
        items: [
            {
                label: 'Customize filter',
                action: 'customize-filter'
            }
        ]
    }
};
const $cb3aab18055c91c9$export$b4273f6b069f0b7d = {
    flow: 'y',
    gap: 'V',
    childExtends: 'DocsKbCategoryRow',
    childrenAs: 'state',
    children: (el, s)=>(0, $3ihxA.KB_CATEGORIES)
};
const $cb3aab18055c91c9$export$84ad1e2dd937b41a = {
    extends: 'SidebarRow',
    background: (el, s)=>s.root.selectedCategory === s.key ? 'overlay' : 'transparent',
    color: (el, s)=>s.root.selectedCategory === s.key ? 'title' : 'caption',
    onClick: (e, el, s)=>{
        s.root.update({
            selectedCategory: s.key
        });
    },
    Icon: {
        icon: (el, s)=>s.icon || 'book'
    },
    Label: {
        text: (el, s)=>s.label || s.key
    },
    Count: {
        tag: 'span',
        fontSize: 'Y2',
        color: 'caption',
        text: (el, s)=>{
            const all = s.root.kbArticles || [];
            if (s.key === 'all') return String(all.length);
            return String(all.filter((a)=>a.category === s.key).length);
        }
    },
    MoreBtn: {
        items: [
            {
                label: 'Rename category',
                action: 'rename-category'
            },
            {
                label: 'Delete category',
                action: 'delete-category',
                color: 'red'
            }
        ]
    }
};

});

parcelRegister("6zlBP", function(module, exports) {

$parcel$export(module.exports, "_ensureContent", () => $4c86c612586213bd$export$f707d728a8118ae3);
$parcel$export(module.exports, "_navigate", () => $4c86c612586213bd$export$ac6d98819411f285);
$parcel$export(module.exports, "DocsMain", () => $4c86c612586213bd$export$d0cf38993c3357d1);
$parcel$export(module.exports, "DocsContentHeader", () => $4c86c612586213bd$export$90bd9dd0f0f41464);
$parcel$export(module.exports, "DocsHeader", () => $4c86c612586213bd$export$2ea6699ecf75660f);
$parcel$export(module.exports, "DocsGrid", () => $4c86c612586213bd$export$dc9c7cf648f44269);
$parcel$export(module.exports, "DocsCard", () => $4c86c612586213bd$export$6c42484c8bc0bedf);
// Documents main pane — extends AppMain. Header carries folder title +
// search; Body renders a card grid filtered by selectedFolder and query.

var $3ihxA = parcelRequire("3ihxA");
const $4c86c612586213bd$export$f707d728a8118ae3 = (c)=>c && typeof c === 'object' ? c : {
        blocks: []
    };
const $4c86c612586213bd$export$ac6d98819411f285 = (el, path)=>{
    let rootEl = el;
    while(rootEl && !rootEl.routes)rootEl = rootEl.parent;
    const router = el.context?.utils?.router;
    if (router && rootEl) router(path, rootEl, {}, {
        pushState: true,
        scrollToTop: true
    });
};
const $4c86c612586213bd$var$_fileTypeIcon = (type)=>{
    const map = {
        pdf: 'document',
        spreadsheet: 'chart',
        doc: 'document',
        image: 'image'
    };
    return map[type] || 'document';
};
const $4c86c612586213bd$var$_fileTypeLabel = (type)=>{
    const map = {
        pdf: 'PDF',
        spreadsheet: 'Spreadsheet',
        doc: 'Document',
        image: 'Image'
    };
    return map[type] || 'File';
};
const $4c86c612586213bd$var$_filtered = (s)=>{
    const folder = s.root.selectedFolder || 'all';
    const q = (s.root.docsQuery || '').toLowerCase().trim();
    let docs = s.root.documents || [];
    if (folder !== 'all') docs = docs.filter((d)=>d.folder === folder);
    if (q) docs = docs.filter((d)=>(d.title || '').toLowerCase().includes(q) || (d.summary || '').toLowerCase().includes(q) || (d.author || '').toLowerCase().includes(q));
    return docs;
};
const $4c86c612586213bd$export$d0cf38993c3357d1 = {
    extends: 'AppMain',
    padding: '0',
    Header: {
        extends: 'DocsHeader'
    },
    Body: {
        padding: 'B C',
        overflow: 'auto',
        DocsGrid: {}
    }
};
const $4c86c612586213bd$export$90bd9dd0f0f41464 = {
    extends: 'PageHeader',
    LeftGroup: {
        flow: 'y',
        gap: 'V',
        alignItems: 'flex-start',
        flex: '1',
        Title: {
            tag: 'h2',
            margin: '0',
            fontSize: 'C',
            fontWeight: '700',
            color: 'title',
            text: ''
        },
        Count: {
            tag: 'span',
            fontSize: 'Z2',
            color: 'caption',
            text: ''
        }
    },
    RightGroup: {
        // OnlineBar / AiToggle already live in the global AppHeader.
        Search: {
            tag: 'input',
            type: 'search',
            placeholder: 'Search...',
            padding: 'Z A',
            round: 'Z',
            borderWidth: '1px',
            borderColor: 'line',
            borderStyle: 'solid',
            background: 'overlay',
            color: 'title',
            fontSize: 'Z2',
            width: 'F'
        },
        PrimaryBtn: {
            tag: 'button',
            type: 'button',
            padding: 'Z A',
            round: 'Z',
            borderWidth: '1px',
            borderColor: 'line',
            borderStyle: 'solid',
            theme: 'primary',
            cursor: 'pointer',
            fontSize: 'Z2',
            fontWeight: '600',
            ':hover': {
                opacity: '.9'
            }
        }
    }
};
const $4c86c612586213bd$export$2ea6699ecf75660f = {
    extends: 'DocsContentHeader',
    LeftGroup: {
        Title: {
            text: (el, s)=>{
                const f = (0, $3ihxA.DOC_FOLDERS).find((x)=>x.key === s.root.selectedFolder);
                return f?.label || 'Documents';
            }
        },
        Count: {
            text: (el, s)=>{
                const n = $4c86c612586213bd$var$_filtered(s).length;
                return `${n} document${n === 1 ? '' : 's'}`;
            }
        }
    },
    RightGroup: {
        Search: {
            placeholder: 'Search documents...',
            value: (el, s)=>s.root.docsQuery || '',
            onInput: (e, el, s)=>{
                s.root.update({
                    query: e.target.value
                });
            }
        },
        UploadBtn: {
            tag: 'button',
            type: 'button',
            text: 'Upload file',
            padding: 'Z A',
            round: 'Z',
            borderWidth: '1px',
            borderColor: 'line',
            borderStyle: 'solid',
            background: 'overlay',
            cursor: 'pointer',
            fontSize: 'Z2',
            fontWeight: '500',
            color: 'title',
            ':hover': {
                background: 'overlayStrong'
            },
            onClick: (e, el, s)=>{
                const input = document.createElement('input');
                input.type = 'file';
                input.accept = '.pdf,.doc,.docx,.xls,.xlsx,.md,.txt,.png,.jpg';
                input.onchange = async ()=>{
                    const file = input.files[0];
                    if (!file) return;
                    const folder = s.root.selectedFolder === 'all' ? 'company' : s.root.selectedFolder;
                    const ext = file.name.split('.').pop().toLowerCase();
                    const typeMap = {
                        pdf: 'pdf',
                        doc: 'doc',
                        docx: 'doc',
                        xls: 'spreadsheet',
                        xlsx: 'spreadsheet',
                        png: 'image',
                        jpg: 'image',
                        md: 'doc',
                        txt: 'doc'
                    };
                    const row = {
                        title: file.name.replace(/\.[^.]+$/, ''),
                        folder: folder,
                        type: typeMap[ext] || 'doc',
                        author: s.root.currentUserEmail || 'Unknown',
                        // Populate `author_email` for Phase E ownership-gated RLS (0069).
                        author_email: s.root.currentUserEmail || null,
                        summary: `Uploaded file: ${file.name}`
                    };
                    // migrated 2026-04-27 to SDK route workspaceProject.documents.create
                    let data = null;
                    try {
                        data = await el.sdk.execute('workspaceProject.documents', 'create', {
                            payload: row
                        });
                    } catch (err) {
                        console.error('[Documents] Upload insert failed:', err?.message || err);
                        return;
                    }
                    if (!data?.id) {
                        console.error('[Documents] Upload insert returned no id');
                        return;
                    }
                    const docs = s.root.documents || [];
                    s.root.update({
                        documents: [
                            ...docs,
                            {
                                id: data.id,
                                ...row,
                                updatedAt: new Date().toISOString().slice(0, 10),
                                content: ''
                            }
                        ]
                    });
                };
                input.click();
            }
        },
        PrimaryBtn: {
            text: '+ New document',
            onClick: (e, el, s)=>{
                const folder = s.root.selectedFolder === 'all' ? 'company' : s.root.selectedFolder;
                // Create a draft locally — don't save to DB until the user edits
                const docs = s.root.documents || [];
                const draftId = 'draft-' + Date.now();
                const me = (s.root.people || []).find((p)=>p.email === s.root.currentUserEmail);
                const doc = {
                    id: draftId,
                    title: 'Untitled document',
                    folder: folder,
                    type: 'doc',
                    author: me?.name || s.root.currentUserEmail || 'Unknown',
                    summary: '',
                    content: {
                        blocks: []
                    },
                    isDraft: true,
                    updatedAt: new Date().toISOString().slice(0, 10)
                };
                s.root.update({
                    documents: [
                        ...docs,
                        doc
                    ],
                    editorDoc: {
                        id: draftId,
                        title: doc.title,
                        content: {
                            blocks: []
                        },
                        isDraft: true
                    },
                    editorMode: 'edit',
                    activeSection: 'editor'
                });
                $4c86c612586213bd$export$ac6d98819411f285(el, '/documents/editor');
            }
        }
    }
};
const $4c86c612586213bd$export$dc9c7cf648f44269 = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(380px, 1fr))',
    gap: 'A',
    childExtends: 'DocsCard',
    childrenAs: 'state',
    children: (el, s)=>$4c86c612586213bd$var$_filtered(s)
};
const $4c86c612586213bd$export$6c42484c8bc0bedf = {
    extends: 'Link',
    href: (el, s)=>`/documents/editor#doc=${encodeURIComponent(s.id || '')}`,
    textDecoration: 'none',
    color: 'inherit',
    flow: 'y',
    gap: 'Z1',
    padding: 'B',
    round: 'A',
    borderWidth: '1px',
    borderColor: 'line',
    borderStyle: 'solid',
    background: 'overlayStrong',
    cursor: 'pointer',
    transition: 'A defaultBezier',
    ':hover': {
        borderColor: 'title',
        transform: 'translateY(-2px)'
    },
    onClick: (e, el, s)=>{
        e.preventDefault();
        s.root.update({
            editorDoc: {
                id: s.id,
                title: s.title,
                content: $4c86c612586213bd$export$f707d728a8118ae3(s.content)
            },
            editorMode: 'view',
            activeSection: 'editor'
        });
        $4c86c612586213bd$export$ac6d98819411f285(el, `/documents/editor#doc=${encodeURIComponent(s.id || '')}`);
    },
    Top: {
        flow: 'x',
        align: 'center left',
        gap: 'Z1',
        Icon: {
            icon: (el, s)=>$4c86c612586213bd$var$_fileTypeIcon(s.type),
            boxSize: 'A2 A2',
            color: 'caption'
        },
        Title: {
            tag: 'h3',
            margin: '0',
            fontSize: 'A',
            fontWeight: '600',
            color: 'title',
            flex: '1',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>s.title || 'Untitled'
        },
        TypeBadge: {
            tag: 'span',
            fontSize: 'Y1',
            fontWeight: '600',
            padding: 'V Z',
            round: 'Y',
            background: 'overlay',
            color: 'caption',
            textTransform: 'uppercase',
            letterSpacing: '.05em',
            text: (el, s)=>$4c86c612586213bd$var$_fileTypeLabel(s.type)
        }
    },
    Summary: {
        tag: 'p',
        margin: '0',
        fontSize: 'Z2',
        lineHeight: '1.5',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        color: (el, s)=>{
            if (s.summary) return 'caption';
            const blocks = s.content?.blocks || [];
            const text = blocks.map((b)=>b.data?.text || '').filter(Boolean).join(' ');
            return text ? 'caption' : 'caption.5';
        },
        fontStyle: (el, s)=>{
            if (s.summary) return 'normal';
            const blocks = s.content?.blocks || [];
            return blocks.some((b)=>b.data?.text) ? 'normal' : 'italic';
        },
        text: (el, s)=>{
            if (s.summary) return s.summary;
            const blocks = s.content?.blocks || [];
            const text = blocks.map((b)=>b.data?.text || '').filter(Boolean).join(' ').replace(/<[^>]+>/g, '');
            return text || 'No description';
        }
    },
    Meta: {
        flow: 'x',
        align: 'center space-between',
        gap: 'Z',
        marginTop: 'Z',
        fontSize: 'Y2',
        color: 'caption',
        Author: {
            flow: 'x',
            align: 'center',
            gap: 'Y',
            Avatar: {
                avatarType: 'initials',
                boxSize: 'A1',
                src: (el, s)=>el.call('avatarUrlFor', s.author)
            },
            AuthorName: {
                tag: 'span',
                text: (el, s)=>{
                    const author = s.author || '';
                    if (!author.includes('@')) return author;
                    const person = (s.root?.people || []).find((p)=>p.email === author);
                    return person?.name || author;
                }
            }
        },
        Updated: {
            tag: 'span',
            text: (el, s)=>{
                if (!s.updatedAt) return '';
                const ms = Date.now() - new Date(s.updatedAt).getTime();
                const mins = Math.floor(ms / 60000);
                if (mins < 1) return 'just now';
                if (mins < 60) return `${mins} min ago`;
                const hrs = Math.floor(mins / 60);
                if (hrs < 24) return `${hrs} hour${hrs > 1 ? 's' : ''} ago`;
                const days = Math.floor(hrs / 24);
                if (days < 30) return `${days} day${days > 1 ? 's' : ''} ago`;
                const months = Math.floor(days / 30);
                return `${months} month${months > 1 ? 's' : ''} ago`;
            }
        }
    }
};

});

parcelRegister("9AmgV", function(module, exports) {

$parcel$export(module.exports, "NotesMain", () => $6fa8c09d8b4ca7d0$export$b7483e6ecc3f222c);
$parcel$export(module.exports, "NotesHeader", () => $6fa8c09d8b4ca7d0$export$8ac29daa0ba82130);
$parcel$export(module.exports, "NotesList", () => $6fa8c09d8b4ca7d0$export$53e4fd4e0e3d986);
$parcel$export(module.exports, "NoteCard", () => $6fa8c09d8b4ca7d0$export$f49abf8d39e4c10);
$parcel$export(module.exports, "NoteTag", () => $6fa8c09d8b4ca7d0$export$636c8bbb4e207d2a);
// Notes view — member notes and AI-generated notes with filtering and creation.
// migrated 2026-04-27 to SDK route workspaceProject.documents.notes

var $6zlBP = parcelRequire("6zlBP");

var $bfqVY = parcelRequire("bfqVY");
const $6fa8c09d8b4ca7d0$var$_filteredNotes = (s)=>{
    const filter = s.root.notesFilter || 'all';
    const q = (s.root.query || '').toLowerCase().trim();
    let notes = s.root.notes || [];
    if (filter !== 'all') notes = notes.filter((n)=>n.source === filter);
    if (q) notes = notes.filter((n)=>(n.title || '').toLowerCase().includes(q) || (n.content || '').toLowerCase().includes(q) || (n.author || '').toLowerCase().includes(q) || (n.tags || []).some((t)=>t.toLowerCase().includes(q)));
    return notes;
};
const $6fa8c09d8b4ca7d0$export$b7483e6ecc3f222c = {
    extends: 'AppMain',
    padding: '0',
    Header: {
        extends: 'NotesHeader'
    },
    Body: {
        padding: 'B C',
        overflow: 'auto',
        flow: 'y',
        gap: 'A',
        NotesList: {}
    }
};
const $6fa8c09d8b4ca7d0$export$8ac29daa0ba82130 = {
    extends: 'DocsContentHeader',
    LeftGroup: {
        Title: {
            text: 'Notes'
        },
        Count: {
            text: (el, s)=>{
                const n = $6fa8c09d8b4ca7d0$var$_filteredNotes(s).length;
                const filter = s.root.notesFilter || 'all';
                const label = filter === 'ai' ? 'AI note' : filter === 'member' ? 'member note' : 'note';
                return `${n} ${label}${n === 1 ? '' : 's'}`;
            }
        }
    },
    RightGroup: {
        Search: {
            placeholder: 'Search notes...',
            value: (el, s)=>s.root.query || '',
            onInput: (e, el, s)=>{
                s.root.update({
                    query: e.target.value
                });
            }
        },
        PrimaryBtn: {
            text: '+ New note',
            onClick: async (e, el, s)=>{
                const row = {
                    title: 'Untitled note',
                    content: '',
                    author: s.root.currentUserEmail || 'Unknown',
                    source: 'member',
                    tags: []
                };
                let data;
                try {
                    // migrated 2026-04-27 to SDK route workspaceProject.documents.notes
                    const result = await (0, $bfqVY.getSDK)().execute('workspaceProject.documents.notes', 'create', {
                        payload: row
                    });
                    data = result?.data || result;
                } catch (err) {
                    console.error('[Notes] Insert failed:', err);
                    return;
                }
                if (!data?.id) return;
                const notes = s.root.notes || [];
                s.root.update({
                    notes: [
                        ...notes,
                        {
                            id: data.id,
                            ...row,
                            createdAt: new Date().toISOString().slice(0, 10)
                        }
                    ],
                    selectedNoteId: data.id
                });
            }
        }
    }
};
const $6fa8c09d8b4ca7d0$export$53e4fd4e0e3d986 = {
    flow: 'y',
    gap: 'Z1',
    childExtends: 'NoteCard',
    childrenAs: 'state',
    children: (el, s)=>$6fa8c09d8b4ca7d0$var$_filteredNotes(s)
};
const $6fa8c09d8b4ca7d0$export$f49abf8d39e4c10 = {
    extends: 'Link',
    href: (el, s)=>`/documents/editor#note=${encodeURIComponent(s.id || '')}`,
    textDecoration: 'none',
    color: 'inherit',
    flow: 'y',
    gap: 'Z',
    padding: 'A',
    round: 'A',
    borderWidth: '1px',
    borderColor: (el, s)=>s.root.selectedNoteId === s.id ? 'title' : 'line',
    borderStyle: 'solid',
    background: 'overlayStrong',
    cursor: 'pointer',
    transition: 'A defaultBezier',
    ':hover': {
        borderColor: 'title'
    },
    onClick: (e, el, s)=>{
        e.preventDefault();
        const content = s.content && typeof s.content === 'object' ? s.content : {
            blocks: []
        };
        s.root.update({
            selectedNoteId: s.id,
            editorDoc: {
                id: s.id,
                title: s.title || 'Untitled note',
                content: content,
                source: s.source || 'member',
                author: s.author
            },
            editorMode: 'view',
            activeSection: 'editor'
        });
        (0, $6zlBP._navigate)(el, `/documents/editor#note=${encodeURIComponent(s.id || '')}`);
    },
    Top: {
        flow: 'x',
        align: 'center space-between',
        gap: 'Z1',
        TitleGroup: {
            flow: 'x',
            align: 'center left',
            gap: 'Z1',
            flex: '1',
            minWidth: '0',
            Icon: {
                icon: (el, s)=>s.source === 'ai' ? 'star' : 'edit',
                boxSize: 'A1 A1',
                color: (el, s)=>s.source === 'ai' ? 'cyan' : 'caption'
            },
            Title: {
                tag: 'h3',
                margin: '0',
                fontSize: 'A',
                fontWeight: '600',
                color: 'title',
                flex: '1',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                text: (el, s)=>s.title || 'Untitled'
            }
        },
        SourceBadge: {
            tag: 'span',
            fontSize: 'Y1',
            fontWeight: '600',
            padding: 'V Z',
            round: 'Y',
            background: (el, s)=>s.source === 'ai' ? 'cyan' : 'overlay',
            color: (el, s)=>s.source === 'ai' ? 'white' : 'caption',
            textTransform: 'uppercase',
            letterSpacing: '.05em',
            text: (el, s)=>s.source === 'ai' ? 'AI' : 'Member'
        }
    },
    Content: {
        tag: 'p',
        margin: '0',
        fontSize: 'Z2',
        color: 'caption',
        lineHeight: '1.5',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        text: (el, s)=>s.content || 'Empty note'
    },
    Bottom: {
        flow: 'x',
        align: 'center space-between',
        gap: 'Z',
        marginTop: 'Z',
        Tags: {
            flow: 'x',
            gap: 'V',
            childExtends: 'NoteTag',
            childrenAs: 'state',
            children: (el, s)=>(s.tags || []).map((t)=>({
                        label: t
                    }))
        },
        Meta: {
            flow: 'x',
            gap: 'Z',
            fontSize: 'Y2',
            color: 'caption',
            Author: {
                tag: 'span',
                text: (el, s)=>s.author || ''
            },
            Date: {
                tag: 'span',
                text: (el, s)=>s.createdAt || ''
            }
        }
    }
};
const $6fa8c09d8b4ca7d0$export$636c8bbb4e207d2a = {
    tag: 'span',
    fontSize: 'Y1',
    padding: 'V Z',
    round: 'Y',
    background: 'overlay',
    color: 'caption',
    text: (el, s)=>s.label || ''
};

});

parcelRegister("8fwbA", function(module, exports) {

$parcel$export(module.exports, "EditorMain", () => $6018b0e4ee26ff58$export$4a1fe064357e4803);
$parcel$export(module.exports, "EditorHeader", () => $6018b0e4ee26ff58$export$a6d9b5be9e50b115);
$parcel$export(module.exports, "EditorArea", () => $6018b0e4ee26ff58$export$73548283a6d821a8);
$parcel$export(module.exports, "ArticleView", () => $6018b0e4ee26ff58$export$68b42be44c53c91b);
// Document editor — uses @symbo.ls/symbolize-editorjs for Editor.js
// integration, dark theming, and block-to-DOMQL conversion.

var $92O5A = parcelRequire("92O5A");

var $4GQZE = parcelRequire("4GQZE");
parcelRequire("3zNqF");
var $bvL1f = parcelRequire("bvL1f");

var $9kiGF = parcelRequire("9kiGF");

var $6zlBP = parcelRequire("6zlBP");
// ── Export helpers ──
const $6018b0e4ee26ff58$var$_getBlocks = async (s)=>{
    const doc = s.root.editorDoc;
    if (!doc) return [];
    const editor = (0, $92O5A.getEditor)();
    if (editor) {
        const saved = await editor.save();
        return saved.blocks || [];
    }
    return doc.content && doc.content.blocks || [];
};
const $6018b0e4ee26ff58$var$_downloadFile = (content, filename, mime)=>{
    const blob = new Blob([
        content
    ], {
        type: mime
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
};
const $6018b0e4ee26ff58$var$_exportMarkdown = async (s)=>{
    const blocks = await $6018b0e4ee26ff58$var$_getBlocks(s);
    const md = (0, $9kiGF.default).toMarkdown(blocks);
    $6018b0e4ee26ff58$var$_downloadFile(md, `${s.root.editorDoc?.title || 'document'}.md`, 'text/markdown');
};
const $6018b0e4ee26ff58$var$_exportHtml = async (s, ext)=>{
    const blocks = await $6018b0e4ee26ff58$var$_getBlocks(s);
    const title = s.root.editorDoc?.title || 'Document';
    const body = blocks.map((b)=>{
        const { type: type, data: data } = b;
        switch(type){
            case 'header':
                return `<h${data.level || 2}>${data.text || ''}</h${data.level || 2}>`;
            case 'paragraph':
                return `<p>${data.text || ''}</p>`;
            case 'list':
                {
                    const tag = data.style === 'ordered' ? 'ol' : 'ul';
                    const items = (data.items || []).map((i)=>`<li>${typeof i === 'string' ? i : i.content || ''}</li>`).join('');
                    return `<${tag}>${items}</${tag}>`;
                }
            case 'quote':
                return `<blockquote>${data.text || ''}</blockquote>`;
            case 'code':
                return `<pre><code>${data.code || ''}</code></pre>`;
            case 'delimiter':
                return '<hr>';
            default:
                return data?.text ? `<p>${data.text}</p>` : '';
        }
    }).join('\n');
    const html = `<!DOCTYPE html><html><head><meta charset="utf-8"><title>${title}</title></head><body>${body}</body></html>`;
    $6018b0e4ee26ff58$var$_downloadFile(html, `${title}.${ext || 'html'}`, 'text/html');
};
const $6018b0e4ee26ff58$export$4a1fe064357e4803 = {
    extends: 'AppMain',
    padding: '0',
    Header: {
        extends: 'EditorHeader'
    },
    Body: {
        padding: '0',
        overflow: 'hidden',
        flow: 'y',
        flex: '1',
        EditorArea: {
            if: (el, s)=>s.root.editorMode === 'edit'
        },
        ArticleView: {
            if: (el, s)=>s.root.editorMode === 'view'
        }
    }
};

const $6018b0e4ee26ff58$export$a6d9b5be9e50b115 = {
    extends: 'PageHeader',
    LeftGroup: {
        flow: 'x',
        align: 'center left',
        gap: 'Z',
        flex: '1',
        minWidth: '0',
        BackBtn: {
            extends: 'IconButton',
            Icon: {
                icon: 'arrow angle left'
            },
            onClick: (e, el, s)=>{
                if (s.root.editorMode === 'edit') {
                    (0, $92O5A.destroyEditor)();
                    s.root.update({
                        editorMode: 'view'
                    });
                    return;
                }
                (0, $92O5A.destroyEditor)();
                s.root.update({
                    activeSection: 'documents',
                    editorDoc: null,
                    editorMode: null
                });
                (0, $6zlBP._navigate)(el, '/documents');
            }
        },
        TitleInput: {
            tag: 'input',
            type: 'text',
            placeholder: 'Document title...',
            if: (el, s)=>s.root.editorMode === 'edit',
            padding: '0',
            margin: '0',
            fontSize: 'A',
            fontWeight: '600',
            color: 'title',
            background: 'transparent',
            borderWidth: '0',
            outline: 'none',
            flex: '1',
            minWidth: '0',
            lineHeight: '1',
            onCreate: (el, s)=>{
                setTimeout(()=>{
                    if (el.node) el.node.value = s.root.editorDoc && s.root.editorDoc.title || '';
                }, 60);
            },
            onInput: (e, el, s)=>{
                const doc = s.root.editorDoc;
                if (!doc) return;
                s.root.update({
                    editorDoc: {
                        ...doc,
                        title: e.target.value
                    }
                });
            }
        },
        TitleText: {
            tag: 'span',
            if: (el, s)=>s.root.editorMode === 'view',
            fontSize: 'A',
            fontWeight: '600',
            color: 'title',
            lineHeight: '1',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>s.root.editorDoc && s.root.editorDoc.title || 'Untitled'
        }
    },
    RightGroup: {
        flow: 'x',
        align: 'center right',
        gap: 'Z1',
        EditBtn: {
            tag: 'button',
            type: 'button',
            text: 'Edit',
            if: (el, s)=>s.root.editorMode === 'view',
            padding: 'Z A',
            round: 'Z',
            borderWidth: '1px',
            borderColor: 'line',
            borderStyle: 'solid',
            background: 'overlay',
            cursor: 'pointer',
            fontSize: 'Z2',
            fontWeight: '500',
            color: 'title',
            ':hover': {
                background: 'overlayStrong'
            },
            onClick: (e, el, s)=>{
                let doc = s.root.editorDoc;
                if (!doc || !doc.content?.blocks?.length) {
                    const hash = typeof window !== 'undefined' ? window.location.hash.slice(1) : '';
                    const docId = new URLSearchParams(hash).get('doc');
                    if (docId) {
                        const match = (s.root.documents || []).find((d)=>String(d.id) === docId);
                        if (match) {
                            const content = match.content && typeof match.content === 'object' ? match.content : {
                                blocks: []
                            };
                            doc = {
                                ...match,
                                content: content
                            };
                        }
                    }
                }
                s.root.update({
                    editorDoc: doc,
                    editorMode: 'edit'
                });
                setTimeout(()=>{
                    const inp = document.querySelector('input[placeholder="Document title..."]');
                    if (inp && doc) inp.value = doc.title || '';
                }, 100);
            }
        },
        ExportDropdown: {
            if: (el, s)=>s.root.editorMode === 'edit',
            position: 'relative',
            ExportBtn: {
                tag: 'button',
                type: 'button',
                text: 'Export',
                padding: 'Z A',
                round: 'Z',
                borderWidth: '1px',
                borderColor: 'line',
                borderStyle: 'solid',
                background: 'overlay',
                cursor: 'pointer',
                fontSize: 'Z2',
                fontWeight: '500',
                color: 'title',
                ':hover': {
                    background: 'overlayStrong'
                },
                onClick: (e, el, s)=>{
                    const menu = el.parent.Menu;
                    if (menu && menu.node) menu.node.style.display = menu.node.style.display === 'flex' ? 'none' : 'flex';
                }
            },
            Menu: {
                flow: 'y',
                position: 'absolute',
                top: '100%',
                right: '0',
                marginTop: 'V',
                padding: 'V',
                round: 'Z',
                background: 'overlayStrong',
                borderWidth: '1px',
                borderColor: 'line',
                borderStyle: 'solid',
                zIndex: '100',
                minWidth: 'E',
                display: 'none',
                boxShadow: '0 4px 16px rgba(0,0,0,.3)',
                MdOption: {
                    tag: 'button',
                    type: 'button',
                    text: 'Markdown (.md)',
                    padding: 'Z Z1',
                    round: 'Y',
                    background: 'transparent',
                    borderWidth: '0',
                    cursor: 'pointer',
                    fontSize: 'Z2',
                    color: 'title',
                    textAlign: 'left',
                    ':hover': {
                        background: 'overlay'
                    },
                    onClick: async (e, el, s)=>{
                        el.parent.node.style.display = 'none';
                        await $6018b0e4ee26ff58$var$_exportMarkdown(s);
                    }
                },
                HtmlOption: {
                    tag: 'button',
                    type: 'button',
                    text: 'HTML (.html)',
                    padding: 'Z Z1',
                    round: 'Y',
                    background: 'transparent',
                    borderWidth: '0',
                    cursor: 'pointer',
                    fontSize: 'Z2',
                    color: 'title',
                    textAlign: 'left',
                    ':hover': {
                        background: 'overlay'
                    },
                    onClick: async (e, el, s)=>{
                        el.parent.node.style.display = 'none';
                        await $6018b0e4ee26ff58$var$_exportHtml(s, 'html');
                    }
                },
                PdfOption: {
                    tag: 'button',
                    type: 'button',
                    text: 'PDF (.pdf)',
                    padding: 'Z Z1',
                    round: 'Y',
                    background: 'transparent',
                    borderWidth: '0',
                    cursor: 'pointer',
                    fontSize: 'Z2',
                    color: 'caption',
                    textAlign: 'left',
                    ':hover': {
                        background: 'overlay'
                    },
                    onClick: (e, el)=>{
                        el.parent.node.style.display = 'none';
                        window.print();
                    }
                },
                DocxOption: {
                    tag: 'button',
                    type: 'button',
                    text: 'Word (.docx)',
                    padding: 'Z Z1',
                    round: 'Y',
                    background: 'transparent',
                    borderWidth: '0',
                    cursor: 'pointer',
                    fontSize: 'Z2',
                    color: 'caption',
                    textAlign: 'left',
                    ':hover': {
                        background: 'overlay'
                    },
                    onClick: async (e, el, s)=>{
                        el.parent.node.style.display = 'none';
                        await $6018b0e4ee26ff58$var$_exportHtml(s, 'doc');
                    }
                }
            }
        },
        SaveBtn: {
            tag: 'button',
            type: 'button',
            text: 'Save',
            if: (el, s)=>s.root.editorMode === 'edit',
            padding: 'Z A',
            round: 'Z',
            borderWidth: '1px',
            borderColor: 'line',
            borderStyle: 'solid',
            theme: 'primary',
            cursor: 'pointer',
            fontSize: 'Z2',
            fontWeight: '600',
            ':hover': {
                opacity: '.9'
            },
            onClick: async (e, el, s)=>{
                const doc = s.root.editorDoc;
                if (!doc) return;
                let content = doc.content;
                try {
                    const editor = (0, $92O5A.getEditor)();
                    if (editor) content = await editor.save();
                } catch (err) {
                    console.error('[Save] Editor.js save failed:', err);
                }
                // Don't save empty drafts — require title change or content
                const hasContent = content?.blocks?.length > 0;
                const hasTitle = doc.title && doc.title !== 'Untitled document';
                if (doc.isDraft && !hasContent && !hasTitle) return;
                const today = new Date().toISOString().slice(0, 10);
                // migrated 2026-04-27 — upsert via SDK route. doc.source === 'kb'
                // routes through documents.kb (knowledge base articles); otherwise
                // documents.notes (personal/team notes). isUUID heuristic preserved
                // so existing saved docs update by id; new docs let the server mint.
                const isUUID = typeof doc.id === 'string' && doc.id.includes('-');
                const row = {
                    title: doc.title,
                    content: content,
                    updated_at: new Date().toISOString(),
                    ...isUUID ? {
                        id: doc.id
                    } : {}
                };
                const route = doc.source === 'kb' ? 'workspaceProject.documents.kb' : 'workspaceProject.documents.notes';
                let savedId = doc.id;
                try {
                    // create handles upsert server-side when row.id is set
                    const data = await (el.sdk || (await Promise.resolve((parcelRequire("bfqVY")))).getSDK()).execute(route, 'create', {
                        payload: row
                    });
                    if (data?.id) savedId = data.id;
                } catch (err) {
                    console.warn('[Save] SDK upsert failed, local-only:', err?.message || err);
                }
                (0, $92O5A.destroyEditor)();
                if (doc.source === 'kb') {
                    const kbArticles = (s.root.kbArticles || []).map((a)=>a.id === savedId ? {
                            ...a,
                            title: doc.title,
                            content: content,
                            updatedAt: today
                        } : a);
                    s.root.update({
                        kbArticles: kbArticles,
                        editorDoc: {
                            ...doc,
                            id: savedId,
                            content: content
                        },
                        editorMode: 'view'
                    });
                } else {
                    const documents = (s.root.documents || []).map((d)=>d.id === savedId ? {
                            ...d,
                            title: doc.title,
                            content: content,
                            updatedAt: today
                        } : d);
                    s.root.update({
                        documents: documents,
                        editorDoc: {
                            ...doc,
                            id: savedId,
                            content: content
                        },
                        editorMode: 'view'
                    });
                }
            }
        }
    }
};
const $6018b0e4ee26ff58$export$73548283a6d821a8 = {
    flex: '1',
    overflow: 'auto',
    padding: 'A2',
    position: 'relative',
    color: 'title',
    borderColor: 'line',
    ...(0, $4GQZE.editorDarkStyles),
    EditorHolder: {
        attr: {
            id: 'editorjs'
        },
        maxWidth: 'J',
        width: '100%',
        margin: '0 auto',
        minHeight: 'G',
        flex: '1',
        position: 'relative',
        padding: 'Y',
        onCreate: (el, s)=>{
            let doc = s.root.editorDoc;
            if (!doc || !doc.content || !doc.content.blocks?.length) {
                const hash = typeof window !== 'undefined' ? window.location.hash.slice(1) : '';
                const docId = new URLSearchParams(hash).get('doc');
                if (docId) {
                    const match = (s.root.documents || []).find((d)=>String(d.id) === docId);
                    if (match) {
                        const content = match.content && typeof match.content === 'object' ? match.content : {
                            blocks: []
                        };
                        doc = {
                            ...match,
                            content: content
                        };
                        s.root.update({
                            editorDoc: doc
                        });
                    }
                }
            }
            const data = doc && doc.content && typeof doc.content === 'object' ? doc.content : {
                blocks: []
            };
            setTimeout(()=>{
                (0, $92O5A.createEditor)(el.node, data, {
                    onChange: (saved)=>{
                        const current = s.root.editorDoc;
                        if (current) s.root.update({
                            editorDoc: {
                                ...current,
                                content: saved
                            }
                        });
                    }
                });
            }, 50);
        },
        onDestroy: ()=>{
            (0, $92O5A.destroyEditor)();
        }
    }
};
const $6018b0e4ee26ff58$export$68b42be44c53c91b = {
    flex: '1',
    overflow: 'auto',
    padding: 'A',
    color: 'title',
    Article: {
        maxWidth: 'J',
        width: '100%',
        margin: '0 auto',
        flow: 'y',
        gap: 'A',
        Title: {
            tag: 'h1',
            fontSize: 'D',
            fontWeight: '700',
            color: 'title',
            text: (el, s)=>s.root.editorDoc && s.root.editorDoc.title || 'Untitled'
        },
        P: {
            flow: 'x',
            align: 'center left',
            gap: 'Z1',
            fontSize: 'Y2',
            color: 'caption',
            marginBottom: 'A',
            AuthorAvatar: {
                extends: 'Avatar',
                avatarType: 'initials',
                boxSize: 'B B',
                src: (el, s)=>{
                    const email = s.root.currentUserEmail;
                    const person = el.call('findPerson', email);
                    return el.call('avatarUrl', person && person.name || email);
                }
            },
            AuthorName: {
                tag: 'span',
                fontWeight: '500',
                color: 'subtitle',
                text: (el, s)=>{
                    const email = s.root.currentUserEmail;
                    const person = el.call('findPerson', email);
                    return person && person.name || email || '';
                }
            },
            Sep: {
                tag: 'span',
                text: "\xb7"
            },
            Date: {
                tag: 'span',
                text: (el, s)=>{
                    const doc = s.root.editorDoc;
                    if (!doc) return '';
                    const d = (s.root.documents || []).find((x)=>x.id === doc.id);
                    return d?.updatedAt ? `Updated ${d.updatedAt}` : '';
                }
            }
        },
        Divider: {
            height: '1px',
            background: 'line',
            margin: '0 0 Z 0'
        },
        ContentBlocks: {
            flow: 'y',
            gap: 'Z1',
            onRender: (el, s)=>{
                const doc = s.root.editorDoc;
                if (!doc?.content) return;
                const domqlObj = (0, $bvL1f.transformEditorJS)(doc.content);
                // Render the DOMQL component tree
                if (el.node) el.node.innerHTML = '';
                const keys = Object.keys(domqlObj);
                if (keys.length) {
                    const update = {};
                    keys.forEach((key)=>{
                        update[key] = domqlObj[key];
                    });
                    el.set(update);
                }
            }
        }
    }
};

});
parcelRegister("92O5A", function(module, exports) {

$parcel$export(module.exports, "destroyEditor", () => $695b279d9da0b504$export$1408eafb9ed4e92c);
$parcel$export(module.exports, "createEditor", () => $695b279d9da0b504$export$eb02d1ee0d3cac30);
$parcel$export(module.exports, "getEditor", () => $695b279d9da0b504$export$d193da8733a2af56);
// Editor.js initialization helper for DOMQL apps.
// Creates and manages a singleton EditorJS instance with standard tools.

var $7DWMC = parcelRequire("7DWMC");

var $a2piW = parcelRequire("a2piW");

var $63Cxr = parcelRequire("63Cxr");

var $eNX2h = parcelRequire("eNX2h");

var $74N1Y = parcelRequire("74N1Y");

var $lVxB8 = parcelRequire("lVxB8");

var $e1Kt7 = parcelRequire("e1Kt7");

var $3yt7c = parcelRequire("3yt7c");

var $1FAXH = parcelRequire("1FAXH");

var $f5PtS = parcelRequire("f5PtS");

var $2DADN = parcelRequire("2DADN");

var $4GQZE = parcelRequire("4GQZE");
let $695b279d9da0b504$var$_instance = null;
const $695b279d9da0b504$export$1408eafb9ed4e92c = ()=>{
    if ($695b279d9da0b504$var$_instance) {
        $695b279d9da0b504$var$_instance.destroy();
        $695b279d9da0b504$var$_instance = null;
    }
};
const $695b279d9da0b504$export$eb02d1ee0d3cac30 = (holder, data, options = {})=>{
    $695b279d9da0b504$export$1408eafb9ed4e92c();
    if (options.dark !== false) (0, $4GQZE.ensureDarkCSS)();
    const defaultTools = {
        header: {
            class: (0, $a2piW.default),
            config: {
                levels: [
                    1,
                    2,
                    3,
                    4
                ],
                defaultLevel: 2
            }
        },
        list: {
            class: (0, $63Cxr.default),
            inlineToolbar: true,
            config: {
                defaultStyle: 'unordered'
            }
        },
        quote: {
            class: (0, $eNX2h.default),
            inlineToolbar: true
        },
        code: (0, $74N1Y.default),
        delimiter: (0, $lVxB8.default),
        marker: {
            class: (0, $e1Kt7.default),
            shortcut: 'CMD+SHIFT+M'
        },
        table: {
            class: (0, $3yt7c.default),
            inlineToolbar: true
        },
        linkTool: (0, $1FAXH.default),
        drawing: {
            class: (0, $f5PtS.default)
        },
        domql: {
            class: (0, $2DADN.default)
        }
    };
    const tools = options.tools ? {
        ...defaultTools,
        ...options.tools
    } : defaultTools;
    $695b279d9da0b504$var$_instance = new (0, $7DWMC.default)({
        holder: holder,
        placeholder: options.placeholder || 'Start writing...',
        data: data || {
            blocks: []
        },
        tools: tools,
        onChange: async ()=>{
            if (!$695b279d9da0b504$var$_instance || !options.onChange) return;
            const saved = await $695b279d9da0b504$var$_instance.save();
            options.onChange(saved);
        }
    });
    return $695b279d9da0b504$var$_instance;
};
const $695b279d9da0b504$export$d193da8733a2af56 = ()=>$695b279d9da0b504$var$_instance;

});
parcelRegister("7DWMC", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2ab202322af4e74$export$2e2bcd8739ae039);
(function() {
    "use strict";
    try {
        if (typeof document < "u") {
            var e = document.createElement("style");
            e.appendChild(document.createTextNode(".ce-hint--align-start{text-align:left}.ce-hint--align-center{text-align:center}.ce-hint__description{opacity:.6;margin-top:3px}")), document.head.appendChild(e);
        }
    } catch (t1) {
        console.error("vite-plugin-css-injected-by-js", t1);
    }
})();
var $e2ab202322af4e74$var$Ce = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof $parcel$global < "u" ? $parcel$global : typeof self < "u" ? self : {};
function $e2ab202322af4e74$var$Ke(n) {
    return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
function $e2ab202322af4e74$var$Xn(n) {
    if (n.__esModule) return n;
    var e = n.default;
    if (typeof e == "function") {
        var t1 = function o() {
            return this instanceof o ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
        };
        t1.prototype = e.prototype;
    } else t1 = {};
    return Object.defineProperty(t1, "__esModule", {
        value: !0
    }), Object.keys(n).forEach(function(o) {
        var i = Object.getOwnPropertyDescriptor(n, o);
        Object.defineProperty(t1, o, i.get ? i : {
            enumerable: !0,
            get: function() {
                return n[o];
            }
        });
    }), t1;
}
function $e2ab202322af4e74$var$ot() {}
Object.assign($e2ab202322af4e74$var$ot, {
    default: $e2ab202322af4e74$var$ot,
    register: $e2ab202322af4e74$var$ot,
    revert: function() {},
    __esModule: !0
});
Element.prototype.matches || (Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function(n) {
    const e = (this.document || this.ownerDocument).querySelectorAll(n);
    let t1 = e.length;
    for(; --t1 >= 0 && e.item(t1) !== this;);
    return t1 > -1;
});
Element.prototype.closest || (Element.prototype.closest = function(n) {
    let e = this;
    if (!document.documentElement.contains(e)) return null;
    do {
        if (e.matches(n)) return e;
        e = e.parentElement || e.parentNode;
    }while (e !== null);
    return null;
});
Element.prototype.prepend || (Element.prototype.prepend = function(e) {
    const t1 = document.createDocumentFragment();
    Array.isArray(e) || (e = [
        e
    ]), e.forEach((o)=>{
        const i = o instanceof Node;
        t1.appendChild(i ? o : document.createTextNode(o));
    }), this.insertBefore(t1, this.firstChild);
});
Element.prototype.scrollIntoViewIfNeeded || (Element.prototype.scrollIntoViewIfNeeded = function(n) {
    n = arguments.length === 0 ? !0 : !!n;
    const e = this.parentNode, t1 = window.getComputedStyle(e, null), o = parseInt(t1.getPropertyValue("border-top-width")), i = parseInt(t1.getPropertyValue("border-left-width")), s = this.offsetTop - e.offsetTop < e.scrollTop, r = this.offsetTop - e.offsetTop + this.clientHeight - o > e.scrollTop + e.clientHeight, a = this.offsetLeft - e.offsetLeft < e.scrollLeft, l = this.offsetLeft - e.offsetLeft + this.clientWidth - i > e.scrollLeft + e.clientWidth, c = s && !r;
    (s || r) && n && (e.scrollTop = this.offsetTop - e.offsetTop - e.clientHeight / 2 - o + this.clientHeight / 2), (a || l) && n && (e.scrollLeft = this.offsetLeft - e.offsetLeft - e.clientWidth / 2 - i + this.clientWidth / 2), (s || r || a || l) && !n && this.scrollIntoView(c);
});
window.requestIdleCallback = window.requestIdleCallback || function(n) {
    const e = Date.now();
    return setTimeout(function() {
        n({
            didTimeout: !1,
            timeRemaining: function() {
                return Math.max(0, 50 - (Date.now() - e));
            }
        });
    }, 1);
};
window.cancelIdleCallback = window.cancelIdleCallback || function(n) {
    clearTimeout(n);
};
let $e2ab202322af4e74$var$Vn = (n = 21)=>crypto.getRandomValues(new Uint8Array(n)).reduce((e, t1)=>(t1 &= 63, t1 < 36 ? e += t1.toString(36) : t1 < 62 ? e += (t1 - 26).toString(36).toUpperCase() : t1 > 62 ? e += "-" : e += "_", e), "");
var $e2ab202322af4e74$var$Lo = /* @__PURE__ */ ((n)=>(n.VERBOSE = "VERBOSE", n.INFO = "INFO", n.WARN = "WARN", n.ERROR = "ERROR", n))($e2ab202322af4e74$var$Lo || {});
const $e2ab202322af4e74$var$y = {
    BACKSPACE: 8,
    TAB: 9,
    ENTER: 13,
    SHIFT: 16,
    CTRL: 17,
    ALT: 18,
    ESC: 27,
    SPACE: 32,
    LEFT: 37,
    UP: 38,
    DOWN: 40,
    RIGHT: 39,
    DELETE: 46,
    META: 91,
    SLASH: 191
}, $e2ab202322af4e74$var$qn = {
    LEFT: 0,
    WHEEL: 1,
    RIGHT: 2,
    BACKWARD: 3,
    FORWARD: 4
};
function $e2ab202322af4e74$var$Ie(n, e, t1 = "log", o, i = "color: inherit") {
    if (!("console" in window) || !window.console[t1]) return;
    const s = [
        "info",
        "log",
        "warn",
        "error"
    ].includes(t1), r = [];
    switch($e2ab202322af4e74$var$Ie.logLevel){
        case "ERROR":
            if (t1 !== "error") return;
            break;
        case "WARN":
            if (![
                "error",
                "warn"
            ].includes(t1)) return;
            break;
        case "INFO":
            if (!s || n) return;
            break;
    }
    o && r.push(o);
    const a = "Editor.js 2.31.6", l = `line-height: 1em;
            color: #006FEA;
            display: inline-block;
            font-size: 11px;
            line-height: 1em;
            background-color: #fff;
            padding: 4px 9px;
            border-radius: 30px;
            border: 1px solid rgba(56, 138, 229, 0.16);
            margin: 4px 5px 4px 0;`;
    n && (s ? (r.unshift(l, i), e = `%c${a}%c ${e}`) : e = `( ${a} )${e}`);
    try {
        s ? o ? console[t1](`${e} %o`, ...r) : console[t1](e, ...r) : console[t1](e);
    } catch  {}
}
$e2ab202322af4e74$var$Ie.logLevel = "VERBOSE";
function $e2ab202322af4e74$var$Zn(n) {
    $e2ab202322af4e74$var$Ie.logLevel = n;
}
const $e2ab202322af4e74$var$S = $e2ab202322af4e74$var$Ie.bind(window, !1), $e2ab202322af4e74$var$X = $e2ab202322af4e74$var$Ie.bind(window, !0);
function $e2ab202322af4e74$var$le(n) {
    return Object.prototype.toString.call(n).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
}
function $e2ab202322af4e74$var$A(n) {
    return $e2ab202322af4e74$var$le(n) === "function" || $e2ab202322af4e74$var$le(n) === "asyncfunction";
}
function $e2ab202322af4e74$var$D(n) {
    return $e2ab202322af4e74$var$le(n) === "object";
}
function $e2ab202322af4e74$var$te(n) {
    return $e2ab202322af4e74$var$le(n) === "string";
}
function $e2ab202322af4e74$var$Gn(n) {
    return $e2ab202322af4e74$var$le(n) === "boolean";
}
function $e2ab202322af4e74$var$yo(n) {
    return $e2ab202322af4e74$var$le(n) === "number";
}
function $e2ab202322af4e74$var$wo(n) {
    return $e2ab202322af4e74$var$le(n) === "undefined";
}
function $e2ab202322af4e74$var$V(n) {
    return n ? Object.keys(n).length === 0 && n.constructor === Object : !0;
}
function $e2ab202322af4e74$var$Po(n) {
    return n > 47 && n < 58 || // number keys
    n === 32 || n === 13 || // Space bar & return key(s)
    n === 229 || // processing key input for certain languages — Chinese, Japanese, etc.
    n > 64 && n < 91 || // letter keys
    n > 95 && n < 112 || // Numpad keys
    n > 185 && n < 193 || // ;=,-./` (in order)
    n > 218 && n < 223;
}
async function $e2ab202322af4e74$var$Qn(n, e = ()=>{}, t1 = ()=>{}) {
    async function o(i, s, r) {
        try {
            await i.function(i.data), await s($e2ab202322af4e74$var$wo(i.data) ? {} : i.data);
        } catch  {
            r($e2ab202322af4e74$var$wo(i.data) ? {} : i.data);
        }
    }
    return n.reduce(async (i, s)=>(await i, o(s, e, t1)), Promise.resolve());
}
function $e2ab202322af4e74$var$No(n) {
    return Array.prototype.slice.call(n);
}
function $e2ab202322af4e74$var$Fe(n, e) {
    return function() {
        const t1 = this, o = arguments;
        window.setTimeout(()=>n.apply(t1, o), e);
    };
}
function $e2ab202322af4e74$var$Jn(n) {
    return n.name.split(".").pop();
}
function $e2ab202322af4e74$var$ei(n) {
    return /^[-\w]+\/([-+\w]+|\*)$/.test(n);
}
function $e2ab202322af4e74$var$Eo(n, e, t1) {
    let o;
    return (...i)=>{
        const s = this, r = ()=>{
            o = null, t1 || n.apply(s, i);
        }, a = t1 && !o;
        window.clearTimeout(o), o = window.setTimeout(r, e), a && n.apply(s, i);
    };
}
function $e2ab202322af4e74$var$dt(n, e, t1) {
    let o, i, s, r = null, a = 0;
    t1 || (t1 = {});
    const l = function() {
        a = t1.leading === !1 ? 0 : Date.now(), r = null, s = n.apply(o, i), r || (o = i = null);
    };
    return function() {
        const c = Date.now();
        !a && t1.leading === !1 && (a = c);
        const d = e - (c - a);
        return o = this, i = arguments, d <= 0 || d > e ? (r && (clearTimeout(r), r = null), a = c, s = n.apply(o, i), r || (o = i = null)) : !r && t1.trailing !== !1 && (r = setTimeout(l, d)), s;
    };
}
function $e2ab202322af4e74$var$ti() {
    const n = {
        win: !1,
        mac: !1,
        x11: !1,
        linux: !1
    }, e = Object.keys(n).find((t1)=>window.navigator.appVersion.toLowerCase().indexOf(t1) !== -1);
    return e && (n[e] = !0), n;
}
function $e2ab202322af4e74$var$je(n) {
    return n[0].toUpperCase() + n.slice(1);
}
function $e2ab202322af4e74$var$ut(n, ...e) {
    if (!e.length) return n;
    const t1 = e.shift();
    if ($e2ab202322af4e74$var$D(n) && $e2ab202322af4e74$var$D(t1)) for(const o in t1)$e2ab202322af4e74$var$D(t1[o]) ? (n[o] || Object.assign(n, {
        [o]: {}
    }), $e2ab202322af4e74$var$ut(n[o], t1[o])) : Object.assign(n, {
        [o]: t1[o]
    });
    return $e2ab202322af4e74$var$ut(n, ...e);
}
function $e2ab202322af4e74$var$vt(n) {
    const e = $e2ab202322af4e74$var$ti();
    return n = n.replace(/shift/gi, "\u21E7").replace(/backspace/gi, "\u232B").replace(/enter/gi, "\u23CE").replace(/up/gi, "\u2191").replace(/left/gi, "\u2192").replace(/down/gi, "\u2193").replace(/right/gi, "\u2190").replace(/escape/gi, "\u238B").replace(/insert/gi, "Ins").replace(/delete/gi, "\u2421").replace(/\+/gi, " + "), e.mac ? n = n.replace(/ctrl|cmd/gi, "\u2318").replace(/alt/gi, "\u2325") : n = n.replace(/cmd/gi, "Ctrl").replace(/windows/gi, "WIN"), n;
}
function $e2ab202322af4e74$var$oi(n) {
    try {
        return new URL(n).href;
    } catch  {}
    return n.substring(0, 2) === "//" ? window.location.protocol + n : window.location.origin + n;
}
function $e2ab202322af4e74$var$ni() {
    return $e2ab202322af4e74$var$Vn(10);
}
function $e2ab202322af4e74$var$ii(n) {
    window.open(n, "_blank");
}
function $e2ab202322af4e74$var$si(n = "") {
    return `${n}${Math.floor(Math.random() * 1e8).toString(16)}`;
}
function $e2ab202322af4e74$var$ht(n, e, t1) {
    const o = `\xab${e}\xbb is deprecated and will be removed in the next major release. Please use the \xab${t1}\xbb instead.`;
    n && $e2ab202322af4e74$var$X(o, "warn");
}
function $e2ab202322af4e74$var$me(n, e, t1) {
    const o = t1.value ? "value" : "get", i = t1[o], s = `#${e}Cache`;
    if (t1[o] = function(...r) {
        return this[s] === void 0 && (this[s] = i.apply(this, ...r)), this[s];
    }, o === "get" && t1.set) {
        const r = t1.set;
        t1.set = function(a) {
            delete n[s], r.apply(this, a);
        };
    }
    return t1;
}
const $e2ab202322af4e74$var$Ro = 650;
function $e2ab202322af4e74$var$be() {
    return window.matchMedia(`(max-width: ${$e2ab202322af4e74$var$Ro}px)`).matches;
}
const $e2ab202322af4e74$var$pt = typeof window < "u" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);
function $e2ab202322af4e74$var$ri(n, e) {
    const t1 = Array.isArray(n) || $e2ab202322af4e74$var$D(n), o = Array.isArray(e) || $e2ab202322af4e74$var$D(e);
    return t1 || o ? JSON.stringify(n) === JSON.stringify(e) : n === e;
}
class $e2ab202322af4e74$var$u {
    /**
   * Check if passed tag has no closed tag
   *
   * @param {HTMLElement} tag - element to check
   * @returns {boolean}
   */ static isSingleTag(e) {
        return e.tagName && [
            "AREA",
            "BASE",
            "BR",
            "COL",
            "COMMAND",
            "EMBED",
            "HR",
            "IMG",
            "INPUT",
            "KEYGEN",
            "LINK",
            "META",
            "PARAM",
            "SOURCE",
            "TRACK",
            "WBR"
        ].includes(e.tagName);
    }
    /**
   * Check if element is BR or WBR
   *
   * @param {HTMLElement} element - element to check
   * @returns {boolean}
   */ static isLineBreakTag(e) {
        return e && e.tagName && [
            "BR",
            "WBR"
        ].includes(e.tagName);
    }
    /**
   * Helper for making Elements with class name and attributes
   *
   * @param  {string} tagName - new Element tag name
   * @param  {string[]|string} [classNames] - list or name of CSS class name(s)
   * @param  {object} [attributes] - any attributes
   * @returns {HTMLElement}
   */ static make(e, t1 = null, o = {}) {
        const i = document.createElement(e);
        if (Array.isArray(t1)) {
            const s = t1.filter((r)=>r !== void 0);
            i.classList.add(...s);
        } else t1 && i.classList.add(t1);
        for(const s in o)Object.prototype.hasOwnProperty.call(o, s) && (i[s] = o[s]);
        return i;
    }
    /**
   * Creates Text Node with the passed content
   *
   * @param {string} content - text content
   * @returns {Text}
   */ static text(e) {
        return document.createTextNode(e);
    }
    /**
   * Append one or several elements to the parent
   *
   * @param  {Element|DocumentFragment} parent - where to append
   * @param  {Element|Element[]|DocumentFragment|Text|Text[]} elements - element or elements list
   */ static append(e, t1) {
        Array.isArray(t1) ? t1.forEach((o)=>e.appendChild(o)) : e.appendChild(t1);
    }
    /**
   * Append element or a couple to the beginning of the parent elements
   *
   * @param {Element} parent - where to append
   * @param {Element|Element[]} elements - element or elements list
   */ static prepend(e, t1) {
        Array.isArray(t1) ? (t1 = t1.reverse(), t1.forEach((o)=>e.prepend(o))) : e.prepend(t1);
    }
    /**
   * Swap two elements in parent
   *
   * @param {HTMLElement} el1 - from
   * @param {HTMLElement} el2 - to
   * @deprecated
   */ static swap(e, t1) {
        const o = document.createElement("div"), i = e.parentNode;
        i.insertBefore(o, e), i.insertBefore(e, t1), i.insertBefore(t1, o), i.removeChild(o);
    }
    /**
   * Selector Decorator
   *
   * Returns first match
   *
   * @param {Element} el - element we searching inside. Default - DOM Document
   * @param {string} selector - searching string
   * @returns {Element}
   */ static find(e = document, t1) {
        return e.querySelector(t1);
    }
    /**
   * Get Element by Id
   *
   * @param {string} id - id to find
   * @returns {HTMLElement | null}
   */ static get(e) {
        return document.getElementById(e);
    }
    /**
   * Selector Decorator.
   *
   * Returns all matches
   *
   * @param {Element|Document} el - element we searching inside. Default - DOM Document
   * @param {string} selector - searching string
   * @returns {NodeList}
   */ static findAll(e = document, t1) {
        return e.querySelectorAll(t1);
    }
    /**
   * Returns CSS selector for all text inputs
   */ static get allInputsSelector() {
        return "[contenteditable=true], textarea, input:not([type]), " + [
            "text",
            "password",
            "email",
            "number",
            "search",
            "tel",
            "url"
        ].map((t1)=>`input[type="${t1}"]`).join(", ");
    }
    /**
   * Find all contenteditable, textarea and editable input elements passed holder contains
   *
   * @param holder - element where to find inputs
   */ static findAllInputs(e) {
        return $e2ab202322af4e74$var$No(e.querySelectorAll($e2ab202322af4e74$var$u.allInputsSelector)).reduce((t1, o)=>$e2ab202322af4e74$var$u.isNativeInput(o) || $e2ab202322af4e74$var$u.containsOnlyInlineElements(o) ? [
                ...t1,
                o
            ] : [
                ...t1,
                ...$e2ab202322af4e74$var$u.getDeepestBlockElements(o)
            ], []);
    }
    /**
   * Search for deepest node which is Leaf.
   * Leaf is the vertex that doesn't have any child nodes
   *
   * @description Method recursively goes throw the all Node until it finds the Leaf
   * @param {Node} node - root Node. From this vertex we start Deep-first search
   *                      {@link https://en.wikipedia.org/wiki/Depth-first_search}
   * @param {boolean} [atLast] - find last text node
   * @returns - it can be text Node or Element Node, so that caret will able to work with it
   *            Can return null if node is Document or DocumentFragment, or node is not attached to the DOM
   */ static getDeepestNode(e, t1 = !1) {
        const o = t1 ? "lastChild" : "firstChild", i = t1 ? "previousSibling" : "nextSibling";
        if (e && e.nodeType === Node.ELEMENT_NODE && e[o]) {
            let s = e[o];
            if ($e2ab202322af4e74$var$u.isSingleTag(s) && !$e2ab202322af4e74$var$u.isNativeInput(s) && !$e2ab202322af4e74$var$u.isLineBreakTag(s)) {
                if (s[i]) s = s[i];
                else if (s.parentNode[i]) s = s.parentNode[i];
                else return s.parentNode;
            }
            return this.getDeepestNode(s, t1);
        }
        return e;
    }
    /**
   * Check if object is DOM node
   *
   * @param {*} node - object to check
   * @returns {boolean}
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static isElement(e) {
        return $e2ab202322af4e74$var$yo(e) ? !1 : e && e.nodeType && e.nodeType === Node.ELEMENT_NODE;
    }
    /**
   * Check if object is DocumentFragment node
   *
   * @param {object} node - object to check
   * @returns {boolean}
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static isFragment(e) {
        return $e2ab202322af4e74$var$yo(e) ? !1 : e && e.nodeType && e.nodeType === Node.DOCUMENT_FRAGMENT_NODE;
    }
    /**
   * Check if passed element is contenteditable
   *
   * @param {HTMLElement} element - html element to check
   * @returns {boolean}
   */ static isContentEditable(e) {
        return e.contentEditable === "true";
    }
    /**
   * Checks target if it is native input
   *
   * @param {*} target - HTML element or string
   * @returns {boolean}
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static isNativeInput(e) {
        const t1 = [
            "INPUT",
            "TEXTAREA"
        ];
        return e && e.tagName ? t1.includes(e.tagName) : !1;
    }
    /**
   * Checks if we can set caret
   *
   * @param {HTMLElement} target - target to check
   * @returns {boolean}
   */ static canSetCaret(e) {
        let t1 = !0;
        if ($e2ab202322af4e74$var$u.isNativeInput(e)) switch(e.type){
            case "file":
            case "checkbox":
            case "radio":
            case "hidden":
            case "submit":
            case "button":
            case "image":
            case "reset":
                t1 = !1;
                break;
        }
        else t1 = $e2ab202322af4e74$var$u.isContentEditable(e);
        return t1;
    }
    /**
   * Checks node if it is empty
   *
   * @description Method checks simple Node without any childs for emptiness
   * If you have Node with 2 or more children id depth, you better use {@link Dom#isEmpty} method
   * @param {Node} node - node to check
   * @param {string} [ignoreChars] - char or substring to treat as empty
   * @returns {boolean} true if it is empty
   */ static isNodeEmpty(e, t1) {
        let o;
        return this.isSingleTag(e) && !this.isLineBreakTag(e) ? !1 : (this.isElement(e) && this.isNativeInput(e) ? o = e.value : o = e.textContent.replace("\u200B", ""), t1 && (o = o.replace(new RegExp(t1, "g"), "")), o.length === 0);
    }
    /**
   * checks node if it is doesn't have any child nodes
   *
   * @param {Node} node - node to check
   * @returns {boolean}
   */ static isLeaf(e) {
        return e ? e.childNodes.length === 0 : !1;
    }
    /**
   * breadth-first search (BFS)
   * {@link https://en.wikipedia.org/wiki/Breadth-first_search}
   *
   * @description Pushes to stack all DOM leafs and checks for emptiness
   * @param {Node} node - node to check
   * @param {string} [ignoreChars] - char or substring to treat as empty
   * @returns {boolean}
   */ static isEmpty(e, t1) {
        const o = [
            e
        ];
        for(; o.length > 0;)if (e = o.shift(), !!e) {
            if (this.isLeaf(e) && !this.isNodeEmpty(e, t1)) return !1;
            e.childNodes && o.push(...Array.from(e.childNodes));
        }
        return !0;
    }
    /**
   * Check if string contains html elements
   *
   * @param {string} str - string to check
   * @returns {boolean}
   */ static isHTMLString(e) {
        const t1 = $e2ab202322af4e74$var$u.make("div");
        return t1.innerHTML = e, t1.childElementCount > 0;
    }
    /**
   * Return length of node`s text content
   *
   * @param {Node} node - node with content
   * @returns {number}
   */ static getContentLength(e) {
        return $e2ab202322af4e74$var$u.isNativeInput(e) ? e.value.length : e.nodeType === Node.TEXT_NODE ? e.length : e.textContent.length;
    }
    /**
   * Return array of names of block html elements
   *
   * @returns {string[]}
   */ static get blockElements() {
        return [
            "address",
            "article",
            "aside",
            "blockquote",
            "canvas",
            "div",
            "dl",
            "dt",
            "fieldset",
            "figcaption",
            "figure",
            "footer",
            "form",
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "header",
            "hgroup",
            "hr",
            "li",
            "main",
            "nav",
            "noscript",
            "ol",
            "output",
            "p",
            "pre",
            "ruby",
            "section",
            "table",
            "tbody",
            "thead",
            "tr",
            "tfoot",
            "ul",
            "video"
        ];
    }
    /**
   * Check if passed content includes only inline elements
   *
   * @param {string|HTMLElement} data - element or html string
   * @returns {boolean}
   */ static containsOnlyInlineElements(e) {
        let t1;
        $e2ab202322af4e74$var$te(e) ? (t1 = document.createElement("div"), t1.innerHTML = e) : t1 = e;
        const o = (i)=>!$e2ab202322af4e74$var$u.blockElements.includes(i.tagName.toLowerCase()) && Array.from(i.children).every(o);
        return Array.from(t1.children).every(o);
    }
    /**
   * Find and return all block elements in the passed parent (including subtree)
   *
   * @param {HTMLElement} parent - root element
   * @returns {HTMLElement[]}
   */ static getDeepestBlockElements(e) {
        return $e2ab202322af4e74$var$u.containsOnlyInlineElements(e) ? [
            e
        ] : Array.from(e.children).reduce((t1, o)=>[
                ...t1,
                ...$e2ab202322af4e74$var$u.getDeepestBlockElements(o)
            ], []);
    }
    /**
   * Helper for get holder from {string} or return HTMLElement
   *
   * @param {string | HTMLElement} element - holder's id or holder's HTML Element
   * @returns {HTMLElement}
   */ static getHolder(e) {
        return $e2ab202322af4e74$var$te(e) ? document.getElementById(e) : e;
    }
    /**
   * Returns true if element is anchor (is A tag)
   *
   * @param {Element} element - element to check
   * @returns {boolean}
   */ static isAnchor(e) {
        return e.tagName.toLowerCase() === "a";
    }
    /**
   * Returns the closest ancestor anchor (A tag) of the given element (including itself)
   * 
   * @param element - element to check
   * @returns {HTMLAnchorElement | null}
   */ static getClosestAnchor(e) {
        return e.closest("a");
    }
    /**
   * Return element's offset related to the document
   *
   * @todo handle case when editor initialized in scrollable popup
   * @param el - element to compute offset
   */ static offset(e) {
        const t1 = e.getBoundingClientRect(), o = window.pageXOffset || document.documentElement.scrollLeft, i = window.pageYOffset || document.documentElement.scrollTop, s = t1.top + i, r = t1.left + o;
        return {
            top: s,
            left: r,
            bottom: s + t1.height,
            right: r + t1.width
        };
    }
    /**
   * Find text node and offset by total content offset
   *
   * @param {Node} root - root node to start search from
   * @param {number} totalOffset - offset relative to the root node content
   * @returns {{node: Node | null, offset: number}} - node and offset inside node
   */ static getNodeByOffset(e, t1) {
        let o = 0, i = null;
        const s = document.createTreeWalker(e, NodeFilter.SHOW_TEXT, null);
        let r = s.nextNode();
        for(; r;){
            const c = r.textContent, d = c === null ? 0 : c.length;
            if (i = r, o + d >= t1) break;
            o += d, r = s.nextNode();
        }
        if (!i) return {
            node: null,
            offset: 0
        };
        const a = i.textContent;
        if (a === null || a.length === 0) return {
            node: null,
            offset: 0
        };
        const l = Math.min(t1 - o, a.length);
        return {
            node: i,
            offset: l
        };
    }
}
function $e2ab202322af4e74$var$ai(n) {
    return !/[^\t\n\r ]/.test(n);
}
function $e2ab202322af4e74$var$li(n) {
    const e = window.getComputedStyle(n), t1 = parseFloat(e.fontSize), o = parseFloat(e.lineHeight) || t1 * 1.2, i = parseFloat(e.paddingTop), s = parseFloat(e.borderTopWidth), r = parseFloat(e.marginTop), a = t1 * 0.8, l = (o - t1) / 2;
    return r + s + i + l + a;
}
function $e2ab202322af4e74$var$Do(n) {
    n.dataset.empty = $e2ab202322af4e74$var$u.isEmpty(n) ? "true" : "false";
}
const $e2ab202322af4e74$var$ci = {
    blockTunes: {
        toggler: {
            "Click to tune": "",
            "or drag to move": ""
        }
    },
    inlineToolbar: {
        converter: {
            "Convert to": ""
        }
    },
    toolbar: {
        toolbox: {
            Add: ""
        }
    },
    popover: {
        Filter: "",
        "Nothing found": "",
        "Convert to": ""
    }
}, $e2ab202322af4e74$var$di = {
    Text: "",
    Link: "",
    Bold: "",
    Italic: ""
}, $e2ab202322af4e74$var$ui = {
    link: {
        "Add a link": ""
    },
    stub: {
        "The block can not be displayed correctly.": ""
    }
}, $e2ab202322af4e74$var$hi = {
    delete: {
        Delete: "",
        "Click to delete": ""
    },
    moveUp: {
        "Move up": ""
    },
    moveDown: {
        "Move down": ""
    }
}, $e2ab202322af4e74$var$Fo = {
    ui: $e2ab202322af4e74$var$ci,
    toolNames: $e2ab202322af4e74$var$di,
    tools: $e2ab202322af4e74$var$ui,
    blockTunes: $e2ab202322af4e74$var$hi
}, $e2ab202322af4e74$var$jo = class he {
    /**
   * Type-safe translation for internal UI texts:
   * Perform translation of the string by namespace and a key
   *
   * @example I18n.ui(I18nInternalNS.ui.blockTunes.toggler, 'Click to tune')
   * @param internalNamespace - path to translated string in dictionary
   * @param dictKey - dictionary key. Better to use default locale original text
   */ static ui(e, t1) {
        return he._t(e, t1);
    }
    /**
   * Translate for external strings that is not presented in default dictionary.
   * For example, for user-specified tool names
   *
   * @param namespace - path to translated string in dictionary
   * @param dictKey - dictionary key. Better to use default locale original text
   */ static t(e, t1) {
        return he._t(e, t1);
    }
    /**
   * Adjust module for using external dictionary
   *
   * @param dictionary - new messages list to override default
   */ static setDictionary(e) {
        he.currentDictionary = e;
    }
    /**
   * Perform translation both for internal and external namespaces
   * If there is no translation found, returns passed key as a translated message
   *
   * @param namespace - path to translated string in dictionary
   * @param dictKey - dictionary key. Better to use default locale original text
   */ static _t(e, t1) {
        const o = he.getNamespace(e);
        return !o || !o[t1] ? t1 : o[t1];
    }
    /**
   * Find messages section by namespace path
   *
   * @param namespace - path to section
   */ static getNamespace(e) {
        return e.split(".").reduce((o, i)=>!o || !Object.keys(o).length ? {} : o[i], he.currentDictionary);
    }
};
$e2ab202322af4e74$var$jo.currentDictionary = $e2ab202322af4e74$var$Fo;
let $e2ab202322af4e74$var$z = $e2ab202322af4e74$var$jo;
class $e2ab202322af4e74$var$Ho extends Error {
}
class $e2ab202322af4e74$var$Oe {
    constructor(){
        this.subscribers = {};
    }
    /**
   * Subscribe any event on callback
   *
   * @param eventName - event name
   * @param callback - subscriber
   */ on(e, t1) {
        e in this.subscribers || (this.subscribers[e] = []), this.subscribers[e].push(t1);
    }
    /**
   * Subscribe any event on callback. Callback will be called once and be removed from subscribers array after call.
   *
   * @param eventName - event name
   * @param callback - subscriber
   */ once(e, t1) {
        e in this.subscribers || (this.subscribers[e] = []);
        const o = (i)=>{
            const s = t1(i), r = this.subscribers[e].indexOf(o);
            return r !== -1 && this.subscribers[e].splice(r, 1), s;
        };
        this.subscribers[e].push(o);
    }
    /**
   * Emit callbacks with passed data
   *
   * @param eventName - event name
   * @param data - subscribers get this data when they were fired
   */ emit(e, t1) {
        $e2ab202322af4e74$var$V(this.subscribers) || !this.subscribers[e] || this.subscribers[e].reduce((o, i)=>{
            const s = i(o);
            return s !== void 0 ? s : o;
        }, t1);
    }
    /**
   * Unsubscribe callback from event
   *
   * @param eventName - event name
   * @param callback - event handler
   */ off(e, t1) {
        if (this.subscribers[e] === void 0) {
            console.warn(`EventDispatcher .off(): there is no subscribers for event "${e.toString()}". Probably, .off() called before .on()`);
            return;
        }
        for(let o = 0; o < this.subscribers[e].length; o++)if (this.subscribers[e][o] === t1) {
            delete this.subscribers[e][o];
            break;
        }
    }
    /**
   * Destroyer
   * clears subscribers list
   */ destroy() {
        this.subscribers = {};
    }
}
function $e2ab202322af4e74$var$J(n) {
    Object.setPrototypeOf(this, {
        /**
     * Block id
     *
     * @returns {string}
     */ get id () {
            return n.id;
        },
        /**
     * Tool name
     *
     * @returns {string}
     */ get name () {
            return n.name;
        },
        /**
     * Tool config passed on Editor's initialization
     *
     * @returns {ToolConfig}
     */ get config () {
            return n.config;
        },
        /**
     * .ce-block element, that wraps plugin contents
     *
     * @returns {HTMLElement}
     */ get holder () {
            return n.holder;
        },
        /**
     * True if Block content is empty
     *
     * @returns {boolean}
     */ get isEmpty () {
            return n.isEmpty;
        },
        /**
     * True if Block is selected with Cross-Block selection
     *
     * @returns {boolean}
     */ get selected () {
            return n.selected;
        },
        /**
     * Set Block's stretch state
     *
     * @param {boolean} state — state to set
     */ set stretched (t){
            n.stretched = t;
        },
        /**
     * True if Block is stretched
     *
     * @returns {boolean}
     */ get stretched () {
            return n.stretched;
        },
        /**
     * True if Block has inputs to be focused
     */ get focusable () {
            return n.focusable;
        },
        /**
     * Call Tool method with errors handler under-the-hood
     *
     * @param {string} methodName - method to call
     * @param {object} param - object with parameters
     * @returns {unknown}
     */ call (t1, o) {
            return n.call(t1, o);
        },
        /**
     * Save Block content
     *
     * @returns {Promise<void|SavedData>}
     */ save () {
            return n.save();
        },
        /**
     * Validate Block data
     *
     * @param {BlockToolData} data - data to validate
     * @returns {Promise<boolean>}
     */ validate (t1) {
            return n.validate(t1);
        },
        /**
     * Allows to say Editor that Block was changed. Used to manually trigger Editor's 'onChange' callback
     * Can be useful for block changes invisible for editor core.
     */ dispatchChange () {
            n.dispatchChange();
        },
        /**
     * Tool could specify several entries to be displayed at the Toolbox (for example, "Heading 1", "Heading 2", "Heading 3")
     * This method returns the entry that is related to the Block (depended on the Block data)
     */ getActiveToolboxEntry () {
            return n.getActiveToolboxEntry();
        }
    });
}
class $e2ab202322af4e74$var$_e {
    constructor(){
        this.allListeners = [];
    }
    /**
   * Assigns event listener on element and returns unique identifier
   *
   * @param {EventTarget} element - DOM element that needs to be listened
   * @param {string} eventType - event type
   * @param {Function} handler - method that will be fired on event
   * @param {boolean|AddEventListenerOptions} options - useCapture or {capture, passive, once}
   */ on(e, t1, o, i = !1) {
        const s = $e2ab202322af4e74$var$si("l"), r = {
            id: s,
            element: e,
            eventType: t1,
            handler: o,
            options: i
        };
        if (!this.findOne(e, t1, o)) return this.allListeners.push(r), e.addEventListener(t1, o, i), s;
    }
    /**
   * Removes event listener from element
   *
   * @param {EventTarget} element - DOM element that we removing listener
   * @param {string} eventType - event type
   * @param {Function} handler - remove handler, if element listens several handlers on the same event type
   * @param {boolean|AddEventListenerOptions} options - useCapture or {capture, passive, once}
   */ off(e, t1, o, i) {
        const s = this.findAll(e, t1, o);
        s.forEach((r, a)=>{
            const l = this.allListeners.indexOf(s[a]);
            l > -1 && (this.allListeners.splice(l, 1), r.element.removeEventListener(r.eventType, r.handler, r.options));
        });
    }
    /**
   * Removes listener by id
   *
   * @param {string} id - listener identifier
   */ offById(e) {
        const t1 = this.findById(e);
        t1 && t1.element.removeEventListener(t1.eventType, t1.handler, t1.options);
    }
    /**
   * Finds and returns first listener by passed params
   *
   * @param {EventTarget} element - event target
   * @param {string} [eventType] - event type
   * @param {Function} [handler] - event handler
   * @returns {ListenerData|null}
   */ findOne(e, t1, o) {
        const i = this.findAll(e, t1, o);
        return i.length > 0 ? i[0] : null;
    }
    /**
   * Return all stored listeners by passed params
   *
   * @param {EventTarget} element - event target
   * @param {string} eventType - event type
   * @param {Function} handler - event handler
   * @returns {ListenerData[]}
   */ findAll(e, t1, o) {
        let i;
        const s = e ? this.findByEventTarget(e) : [];
        return e && t1 && o ? i = s.filter((r)=>r.eventType === t1 && r.handler === o) : e && t1 ? i = s.filter((r)=>r.eventType === t1) : i = s, i;
    }
    /**
   * Removes all listeners
   */ removeAll() {
        this.allListeners.map((e)=>{
            e.element.removeEventListener(e.eventType, e.handler, e.options);
        }), this.allListeners = [];
    }
    /**
   * Module cleanup on destruction
   */ destroy() {
        this.removeAll();
    }
    /**
   * Search method: looks for listener by passed element
   *
   * @param {EventTarget} element - searching element
   * @returns {Array} listeners that found on element
   */ findByEventTarget(e) {
        return this.allListeners.filter((t1)=>{
            if (t1.element === e) return t1;
        });
    }
    /**
   * Search method: looks for listener by passed event type
   *
   * @param {string} eventType - event type
   * @returns {ListenerData[]} listeners that found on element
   */ findByType(e) {
        return this.allListeners.filter((t1)=>{
            if (t1.eventType === e) return t1;
        });
    }
    /**
   * Search method: looks for listener by passed handler
   *
   * @param {Function} handler - event handler
   * @returns {ListenerData[]} listeners that found on element
   */ findByHandler(e) {
        return this.allListeners.filter((t1)=>{
            if (t1.handler === e) return t1;
        });
    }
    /**
   * Returns listener data found by id
   *
   * @param {string} id - listener identifier
   * @returns {ListenerData}
   */ findById(e) {
        return this.allListeners.find((t1)=>t1.id === e);
    }
}
class $e2ab202322af4e74$var$E {
    /**
   * @class
   * @param options - Module options
   * @param options.config - Module config
   * @param options.eventsDispatcher - Common event bus
   */ constructor({ config: e, eventsDispatcher: t1 }){
        if (this.nodes = {}, this.listeners = new $e2ab202322af4e74$var$_e(), this.readOnlyMutableListeners = {
            /**
       * Assigns event listener on DOM element and pushes into special array that might be removed
       *
       * @param {EventTarget} element - DOM Element
       * @param {string} eventType - Event name
       * @param {Function} handler - Event handler
       * @param {boolean|AddEventListenerOptions} options - Listening options
       */ on: (o, i, s, r = !1)=>{
                this.mutableListenerIds.push(this.listeners.on(o, i, s, r));
            },
            /**
       * Clears all mutable listeners
       */ clearAll: ()=>{
                for (const o of this.mutableListenerIds)this.listeners.offById(o);
                this.mutableListenerIds = [];
            }
        }, this.mutableListenerIds = [], new.target === $e2ab202322af4e74$var$E) throw new TypeError("Constructors for abstract class Module are not allowed.");
        this.config = e, this.eventsDispatcher = t1;
    }
    /**
   * Editor modules setter
   *
   * @param {EditorModules} Editor - Editor's Modules
   */ set state(e) {
        this.Editor = e;
    }
    /**
   * Remove memorized nodes
   */ removeAllNodes() {
        for(const e in this.nodes){
            const t1 = this.nodes[e];
            t1 instanceof HTMLElement && t1.remove();
        }
    }
    /**
   * Returns true if current direction is RTL (Right-To-Left)
   */ get isRtl() {
        return this.config.i18n.direction === "rtl";
    }
}
class $e2ab202322af4e74$var$b {
    constructor(){
        this.instance = null, this.selection = null, this.savedSelectionRange = null, this.isFakeBackgroundEnabled = !1, this.commandBackground = "backColor";
    }
    /**
   * Editor styles
   *
   * @returns {{editorWrapper: string, editorZone: string}}
   */ static get CSS() {
        return {
            editorWrapper: "codex-editor",
            editorZone: "codex-editor__redactor"
        };
    }
    /**
   * Returns selected anchor
   * {@link https://developer.mozilla.org/ru/docs/Web/API/Selection/anchorNode}
   *
   * @returns {Node|null}
   */ static get anchorNode() {
        const e = window.getSelection();
        return e ? e.anchorNode : null;
    }
    /**
   * Returns selected anchor element
   *
   * @returns {Element|null}
   */ static get anchorElement() {
        const e = window.getSelection();
        if (!e) return null;
        const t1 = e.anchorNode;
        return t1 ? $e2ab202322af4e74$var$u.isElement(t1) ? t1 : t1.parentElement : null;
    }
    /**
   * Returns selection offset according to the anchor node
   * {@link https://developer.mozilla.org/ru/docs/Web/API/Selection/anchorOffset}
   *
   * @returns {number|null}
   */ static get anchorOffset() {
        const e = window.getSelection();
        return e ? e.anchorOffset : null;
    }
    /**
   * Is current selection range collapsed
   *
   * @returns {boolean|null}
   */ static get isCollapsed() {
        const e = window.getSelection();
        return e ? e.isCollapsed : null;
    }
    /**
   * Check current selection if it is at Editor's zone
   *
   * @returns {boolean}
   */ static get isAtEditor() {
        return this.isSelectionAtEditor($e2ab202322af4e74$var$b.get());
    }
    /**
   * Check if passed selection is at Editor's zone
   *
   * @param selection - Selection object to check
   */ static isSelectionAtEditor(e) {
        if (!e) return !1;
        let t1 = e.anchorNode || e.focusNode;
        t1 && t1.nodeType === Node.TEXT_NODE && (t1 = t1.parentNode);
        let o = null;
        return t1 && t1 instanceof Element && (o = t1.closest(`.${$e2ab202322af4e74$var$b.CSS.editorZone}`)), o ? o.nodeType === Node.ELEMENT_NODE : !1;
    }
    /**
   * Check if passed range at Editor zone
   *
   * @param range - range to check
   */ static isRangeAtEditor(e) {
        if (!e) return;
        let t1 = e.startContainer;
        t1 && t1.nodeType === Node.TEXT_NODE && (t1 = t1.parentNode);
        let o = null;
        return t1 && t1 instanceof Element && (o = t1.closest(`.${$e2ab202322af4e74$var$b.CSS.editorZone}`)), o ? o.nodeType === Node.ELEMENT_NODE : !1;
    }
    /**
   * Methods return boolean that true if selection exists on the page
   */ static get isSelectionExists() {
        return !!$e2ab202322af4e74$var$b.get().anchorNode;
    }
    /**
   * Return first range
   *
   * @returns {Range|null}
   */ static get range() {
        return this.getRangeFromSelection(this.get());
    }
    /**
   * Returns range from passed Selection object
   *
   * @param selection - Selection object to get Range from
   */ static getRangeFromSelection(e) {
        return e && e.rangeCount ? e.getRangeAt(0) : null;
    }
    /**
   * Calculates position and size of selected text
   *
   * @returns {DOMRect | ClientRect}
   */ static get rect() {
        let e = document.selection, t1, o = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
        if (e && e.type !== "Control") return e, t1 = e.createRange(), o.x = t1.boundingLeft, o.y = t1.boundingTop, o.width = t1.boundingWidth, o.height = t1.boundingHeight, o;
        if (!window.getSelection) return $e2ab202322af4e74$var$S("Method window.getSelection is not supported", "warn"), o;
        if (e = window.getSelection(), e.rangeCount === null || isNaN(e.rangeCount)) return $e2ab202322af4e74$var$S("Method SelectionUtils.rangeCount is not supported", "warn"), o;
        if (e.rangeCount === 0) return o;
        if (t1 = e.getRangeAt(0).cloneRange(), t1.getBoundingClientRect && (o = t1.getBoundingClientRect()), o.x === 0 && o.y === 0) {
            const i = document.createElement("span");
            if (i.getBoundingClientRect) {
                i.appendChild(document.createTextNode("\u200B")), t1.insertNode(i), o = i.getBoundingClientRect();
                const s = i.parentNode;
                s.removeChild(i), s.normalize();
            }
        }
        return o;
    }
    /**
   * Returns selected text as String
   *
   * @returns {string}
   */ static get text() {
        return window.getSelection ? window.getSelection().toString() : "";
    }
    /**
   * Returns window SelectionUtils
   * {@link https://developer.mozilla.org/ru/docs/Web/API/Window/getSelection}
   *
   * @returns {Selection}
   */ static get() {
        return window.getSelection();
    }
    /**
   * Set focus to contenteditable or native input element
   *
   * @param element - element where to set focus
   * @param offset - offset of cursor
   */ static setCursor(e, t1 = 0) {
        const o = document.createRange(), i = window.getSelection();
        return $e2ab202322af4e74$var$u.isNativeInput(e) ? $e2ab202322af4e74$var$u.canSetCaret(e) ? (e.focus(), e.selectionStart = e.selectionEnd = t1, e.getBoundingClientRect()) : void 0 : (o.setStart(e, t1), o.setEnd(e, t1), i.removeAllRanges(), i.addRange(o), o.getBoundingClientRect());
    }
    /**
   * Check if current range exists and belongs to container
   *
   * @param container - where range should be
   */ static isRangeInsideContainer(e) {
        const t1 = $e2ab202322af4e74$var$b.range;
        return t1 === null ? !1 : e.contains(t1.startContainer);
    }
    /**
   * Adds fake cursor to the current range
   */ static addFakeCursor() {
        const e = $e2ab202322af4e74$var$b.range;
        if (e === null) return;
        const t1 = $e2ab202322af4e74$var$u.make("span", "codex-editor__fake-cursor");
        t1.dataset.mutationFree = "true", e.collapse(), e.insertNode(t1);
    }
    /**
   * Check if passed element contains a fake cursor
   *
   * @param el - where to check
   */ static isFakeCursorInsideContainer(e) {
        return $e2ab202322af4e74$var$u.find(e, ".codex-editor__fake-cursor") !== null;
    }
    /**
   * Removes fake cursor from a container
   *
   * @param container - container to look for
   */ static removeFakeCursor(e = document.body) {
        const t1 = $e2ab202322af4e74$var$u.find(e, ".codex-editor__fake-cursor");
        t1 && t1.remove();
    }
    /**
   * Removes fake background
   */ removeFakeBackground() {
        this.isFakeBackgroundEnabled && (document.execCommand(this.commandBackground, !1, "transparent"), this.isFakeBackgroundEnabled = !1);
    }
    /**
   * Sets fake background
   */ setFakeBackground() {
        document.execCommand(this.commandBackground, !1, "#a8d6ff"), this.isFakeBackgroundEnabled = !0;
    }
    /**
   * Save SelectionUtils's range
   */ save() {
        this.savedSelectionRange = $e2ab202322af4e74$var$b.range;
    }
    /**
   * Restore saved SelectionUtils's range
   */ restore() {
        if (!this.savedSelectionRange) return;
        const e = window.getSelection();
        e.removeAllRanges(), e.addRange(this.savedSelectionRange);
    }
    /**
   * Clears saved selection
   */ clearSaved() {
        this.savedSelectionRange = null;
    }
    /**
   * Collapse current selection
   */ collapseToEnd() {
        const e = window.getSelection(), t1 = document.createRange();
        t1.selectNodeContents(e.focusNode), t1.collapse(!1), e.removeAllRanges(), e.addRange(t1);
    }
    /**
   * Looks ahead to find passed tag from current selection
   *
   * @param  {string} tagName       - tag to found
   * @param  {string} [className]   - tag's class name
   * @param  {number} [searchDepth] - count of tags that can be included. For better performance.
   * @returns {HTMLElement|null}
   */ findParentTag(e, t1, o = 10) {
        const i = window.getSelection();
        let s = null;
        return !i || !i.anchorNode || !i.focusNode ? null : ([
            /** the Node in which the selection begins */ i.anchorNode,
            /** the Node in which the selection ends */ i.focusNode
        ].forEach((a)=>{
            let l = o;
            for(; l > 0 && a.parentNode && !(a.tagName === e && (s = a, t1 && a.classList && !a.classList.contains(t1) && (s = null), s));)a = a.parentNode, l--;
        }), s);
    }
    /**
   * Expands selection range to the passed parent node
   *
   * @param {HTMLElement} element - element which contents should be selected
   */ expandToTag(e) {
        const t1 = window.getSelection();
        t1.removeAllRanges();
        const o = document.createRange();
        o.selectNodeContents(e), t1.addRange(o);
    }
}
function $e2ab202322af4e74$var$pi(n, e) {
    const { type: t1, target: o, addedNodes: i, removedNodes: s } = n;
    return n.type === "attributes" && n.attributeName === "data-empty" ? !1 : !!(e.contains(o) || t1 === "childList" && (Array.from(i).some((l)=>l === e) || Array.from(s).some((l)=>l === e)));
}
const $e2ab202322af4e74$var$ft = "redactor dom changed", $e2ab202322af4e74$var$$o = "block changed", $e2ab202322af4e74$var$zo = "fake cursor is about to be toggled", $e2ab202322af4e74$var$Uo = "fake cursor have been set", $e2ab202322af4e74$var$Te = "editor mobile layout toggled";
function $e2ab202322af4e74$var$gt(n, e) {
    if (!n.conversionConfig) return !1;
    const t1 = n.conversionConfig[e];
    return $e2ab202322af4e74$var$A(t1) || $e2ab202322af4e74$var$te(t1);
}
function $e2ab202322af4e74$var$He(n, e) {
    return $e2ab202322af4e74$var$gt(n.tool, e);
}
function $e2ab202322af4e74$var$Wo(n, e) {
    return Object.entries(n).some(([t1, o])=>e[t1] && $e2ab202322af4e74$var$ri(e[t1], o));
}
async function $e2ab202322af4e74$var$Yo(n, e) {
    const o = (await n.save()).data, i = e.find((s)=>s.name === n.name);
    return i !== void 0 && !$e2ab202322af4e74$var$gt(i, "export") ? [] : e.reduce((s, r)=>{
        if (!$e2ab202322af4e74$var$gt(r, "import") || r.toolbox === void 0) return s;
        const a = r.toolbox.filter((l)=>{
            if ($e2ab202322af4e74$var$V(l) || l.icon === void 0) return !1;
            if (l.data !== void 0) {
                if ($e2ab202322af4e74$var$Wo(l.data, o)) return !1;
            } else if (r.name === n.name) return !1;
            return !0;
        });
        return s.push({
            ...r,
            toolbox: a
        }), s;
    }, []);
}
function $e2ab202322af4e74$var$xo(n, e) {
    return n.mergeable ? n.name === e.name ? !0 : $e2ab202322af4e74$var$He(e, "export") && $e2ab202322af4e74$var$He(n, "import") : !1;
}
function $e2ab202322af4e74$var$fi(n, e) {
    const t1 = e == null ? void 0 : e.export;
    return $e2ab202322af4e74$var$A(t1) ? t1(n) : $e2ab202322af4e74$var$te(t1) ? n[t1] : (t1 !== void 0 && $e2ab202322af4e74$var$S("Conversion \xabexport\xbb property must be a string or function. String means key of saved data object to export. Function should export processed string to export."), "");
}
function $e2ab202322af4e74$var$Bo(n, e, t1) {
    const o = e == null ? void 0 : e.import;
    return $e2ab202322af4e74$var$A(o) ? o(n, t1) : $e2ab202322af4e74$var$te(o) ? {
        [o]: n
    } : (o !== void 0 && $e2ab202322af4e74$var$S("Conversion \xabimport\xbb property must be a string or function. String means key of tool data to import. Function accepts a imported string and return composed tool data."), {});
}
var $e2ab202322af4e74$var$_ = /* @__PURE__ */ ((n)=>(n.Default = "default", n.Separator = "separator", n.Html = "html", n))($e2ab202322af4e74$var$_ || {}), $e2ab202322af4e74$var$ee = /* @__PURE__ */ ((n)=>(n.APPEND_CALLBACK = "appendCallback", n.RENDERED = "rendered", n.MOVED = "moved", n.UPDATED = "updated", n.REMOVED = "removed", n.ON_PASTE = "onPaste", n))($e2ab202322af4e74$var$ee || {});
class $e2ab202322af4e74$var$R extends $e2ab202322af4e74$var$Oe {
    /**
   * @param options - block constructor options
   * @param [options.id] - block's id. Will be generated if omitted.
   * @param options.data - Tool's initial data
   * @param options.tool — block's tool
   * @param options.api - Editor API module for pass it to the Block Tunes
   * @param options.readOnly - Read-Only flag
   * @param [eventBus] - Editor common event bus. Allows to subscribe on some Editor events. Could be omitted when "virtual" Block is created. See BlocksAPI@composeBlockData.
   */ constructor({ id: e = $e2ab202322af4e74$var$ni(), data: t1, tool: o, readOnly: i, tunesData: s }, r){
        super(), this.cachedInputs = [], this.toolRenderedElement = null, this.tunesInstances = /* @__PURE__ */ new Map(), this.defaultTunesInstances = /* @__PURE__ */ new Map(), this.unavailableTunesData = {}, this.inputIndex = 0, this.editorEventBus = null, this.handleFocus = ()=>{
            this.dropInputsCache(), this.updateCurrentInput();
        }, this.didMutated = (a)=>{
            const l = a === void 0, c = a instanceof InputEvent;
            !l && !c && this.detectToolRootChange(a);
            let d;
            l || c ? d = !0 : d = !(a.length > 0 && a.every((p)=>{
                const { addedNodes: g, removedNodes: f, target: v } = p;
                return [
                    ...Array.from(g),
                    ...Array.from(f),
                    v
                ].some((T)=>($e2ab202322af4e74$var$u.isElement(T) || (T = T.parentElement), T && T.closest('[data-mutation-free="true"]') !== null));
            })), d && (this.dropInputsCache(), this.updateCurrentInput(), this.toggleInputsEmptyMark(), this.call("updated"), this.emit("didMutated", this));
        }, this.name = o.name, this.id = e, this.settings = o.settings, this.config = o.settings.config || {}, this.editorEventBus = r || null, this.blockAPI = new $e2ab202322af4e74$var$J(this), this.tool = o, this.toolInstance = o.create(t1, this.blockAPI, i), this.tunes = o.tunes, this.composeTunes(s), this.holder = this.compose(), window.requestIdleCallback(()=>{
            this.watchBlockMutations(), this.addInputEvents(), this.toggleInputsEmptyMark();
        });
    }
    /**
   * CSS classes for the Block
   *
   * @returns {{wrapper: string, content: string}}
   */ static get CSS() {
        return {
            wrapper: "ce-block",
            wrapperStretched: "ce-block--stretched",
            content: "ce-block__content",
            selected: "ce-block--selected",
            dropTarget: "ce-block--drop-target"
        };
    }
    /**
   * Find and return all editable elements (contenteditable and native inputs) in the Tool HTML
   */ get inputs() {
        if (this.cachedInputs.length !== 0) return this.cachedInputs;
        const e = $e2ab202322af4e74$var$u.findAllInputs(this.holder);
        return this.inputIndex > e.length - 1 && (this.inputIndex = e.length - 1), this.cachedInputs = e, e;
    }
    /**
   * Return current Tool`s input
   * If Block doesn't contain inputs, return undefined
   */ get currentInput() {
        return this.inputs[this.inputIndex];
    }
    /**
   * Set input index to the passed element
   *
   * @param element - HTML Element to set as current input
   */ set currentInput(e) {
        const t1 = this.inputs.findIndex((o)=>o === e || o.contains(e));
        t1 !== -1 && (this.inputIndex = t1);
    }
    /**
   * Return first Tool`s input
   * If Block doesn't contain inputs, return undefined
   */ get firstInput() {
        return this.inputs[0];
    }
    /**
   * Return first Tool`s input
   * If Block doesn't contain inputs, return undefined
   */ get lastInput() {
        const e = this.inputs;
        return e[e.length - 1];
    }
    /**
   * Return next Tool`s input or undefined if it doesn't exist
   * If Block doesn't contain inputs, return undefined
   */ get nextInput() {
        return this.inputs[this.inputIndex + 1];
    }
    /**
   * Return previous Tool`s input or undefined if it doesn't exist
   * If Block doesn't contain inputs, return undefined
   */ get previousInput() {
        return this.inputs[this.inputIndex - 1];
    }
    /**
   * Get Block's JSON data
   *
   * @returns {object}
   */ get data() {
        return this.save().then((e)=>e && !$e2ab202322af4e74$var$V(e.data) ? e.data : {});
    }
    /**
   * Returns tool's sanitizer config
   *
   * @returns {object}
   */ get sanitize() {
        return this.tool.sanitizeConfig;
    }
    /**
   * is block mergeable
   * We plugin have merge function then we call it mergeable
   *
   * @returns {boolean}
   */ get mergeable() {
        return $e2ab202322af4e74$var$A(this.toolInstance.merge);
    }
    /**
   * If Block contains inputs, it is focusable
   */ get focusable() {
        return this.inputs.length !== 0;
    }
    /**
   * Check block for emptiness
   *
   * @returns {boolean}
   */ get isEmpty() {
        const e = $e2ab202322af4e74$var$u.isEmpty(this.pluginsContent, "/"), t1 = !this.hasMedia;
        return e && t1;
    }
    /**
   * Check if block has a media content such as images, iframe and other
   *
   * @returns {boolean}
   */ get hasMedia() {
        const e = [
            "img",
            "iframe",
            "video",
            "audio",
            "source",
            "input",
            "textarea",
            "twitterwidget"
        ];
        return !!this.holder.querySelector(e.join(","));
    }
    /**
   * Set selected state
   * We don't need to mark Block as Selected when it is empty
   *
   * @param {boolean} state - 'true' to select, 'false' to remove selection
   */ set selected(e) {
        var i, s;
        this.holder.classList.toggle($e2ab202322af4e74$var$R.CSS.selected, e);
        const t1 = e === !0 && $e2ab202322af4e74$var$b.isRangeInsideContainer(this.holder), o = e === !1 && $e2ab202322af4e74$var$b.isFakeCursorInsideContainer(this.holder);
        (t1 || o) && ((i = this.editorEventBus) == null || i.emit($e2ab202322af4e74$var$zo, {
            state: e
        }), t1 ? $e2ab202322af4e74$var$b.addFakeCursor() : $e2ab202322af4e74$var$b.removeFakeCursor(this.holder), (s = this.editorEventBus) == null || s.emit($e2ab202322af4e74$var$Uo, {
            state: e
        }));
    }
    /**
   * Returns True if it is Selected
   *
   * @returns {boolean}
   */ get selected() {
        return this.holder.classList.contains($e2ab202322af4e74$var$R.CSS.selected);
    }
    /**
   * Set stretched state
   *
   * @param {boolean} state - 'true' to enable, 'false' to disable stretched state
   */ set stretched(e) {
        this.holder.classList.toggle($e2ab202322af4e74$var$R.CSS.wrapperStretched, e);
    }
    /**
   * Return Block's stretched state
   *
   * @returns {boolean}
   */ get stretched() {
        return this.holder.classList.contains($e2ab202322af4e74$var$R.CSS.wrapperStretched);
    }
    /**
   * Toggle drop target state
   *
   * @param {boolean} state - 'true' if block is drop target, false otherwise
   */ set dropTarget(e) {
        this.holder.classList.toggle($e2ab202322af4e74$var$R.CSS.dropTarget, e);
    }
    /**
   * Returns Plugins content
   *
   * @returns {HTMLElement}
   */ get pluginsContent() {
        return this.toolRenderedElement;
    }
    /**
   * Calls Tool's method
   *
   * Method checks tool property {MethodName}. Fires method with passes params If it is instance of Function
   *
   * @param {string} methodName - method to call
   * @param {object} params - method argument
   */ call(e, t1) {
        if ($e2ab202322af4e74$var$A(this.toolInstance[e])) {
            e === "appendCallback" && $e2ab202322af4e74$var$S("`appendCallback` hook is deprecated and will be removed in the next major release. Use `rendered` hook instead", "warn");
            try {
                this.toolInstance[e].call(this.toolInstance, t1);
            } catch (o) {
                $e2ab202322af4e74$var$S(`Error during '${e}' call: ${o.message}`, "error");
            }
        }
    }
    /**
   * Call plugins merge method
   *
   * @param {BlockToolData} data - data to merge
   */ async mergeWith(e) {
        await this.toolInstance.merge(e);
    }
    /**
   * Extracts data from Block
   * Groups Tool's save processing time
   *
   * @returns {object}
   */ async save() {
        const e = await this.toolInstance.save(this.pluginsContent), t1 = this.unavailableTunesData;
        [
            ...this.tunesInstances.entries(),
            ...this.defaultTunesInstances.entries()
        ].forEach(([s, r])=>{
            if ($e2ab202322af4e74$var$A(r.save)) try {
                t1[s] = r.save();
            } catch (a) {
                $e2ab202322af4e74$var$S(`Tune ${r.constructor.name} save method throws an Error %o`, "warn", a);
            }
        });
        const o = window.performance.now();
        let i;
        return Promise.resolve(e).then((s)=>(i = window.performance.now(), {
                id: this.id,
                tool: this.name,
                data: s,
                tunes: t1,
                time: i - o
            })).catch((s)=>{
            $e2ab202322af4e74$var$S(`Saving process for ${this.name} tool failed due to the ${s}`, "log", "red");
        });
    }
    /**
   * Uses Tool's validation method to check the correctness of output data
   * Tool's validation method is optional
   *
   * @description Method returns true|false whether data passed the validation or not
   * @param {BlockToolData} data - data to validate
   * @returns {Promise<boolean>} valid
   */ async validate(e) {
        let t1 = !0;
        return this.toolInstance.validate instanceof Function && (t1 = await this.toolInstance.validate(e)), t1;
    }
    /**
   * Returns data to render in Block Tunes menu.
   * Splits block tunes into 2 groups: block specific tunes and common tunes
   */ getTunes() {
        const e = [], t1 = [], o = typeof this.toolInstance.renderSettings == "function" ? this.toolInstance.renderSettings() : [];
        return $e2ab202322af4e74$var$u.isElement(o) ? e.push({
            type: $e2ab202322af4e74$var$_.Html,
            element: o
        }) : Array.isArray(o) ? e.push(...o) : e.push(o), [
            ...this.tunesInstances.values(),
            ...this.defaultTunesInstances.values()
        ].map((s)=>s.render()).forEach((s)=>{
            $e2ab202322af4e74$var$u.isElement(s) ? t1.push({
                type: $e2ab202322af4e74$var$_.Html,
                element: s
            }) : Array.isArray(s) ? t1.push(...s) : t1.push(s);
        }), {
            toolTunes: e,
            commonTunes: t1
        };
    }
    /**
   * Update current input index with selection anchor node
   */ updateCurrentInput() {
        this.currentInput = $e2ab202322af4e74$var$u.isNativeInput(document.activeElement) || !$e2ab202322af4e74$var$b.anchorNode ? document.activeElement : $e2ab202322af4e74$var$b.anchorNode;
    }
    /**
   * Allows to say Editor that Block was changed. Used to manually trigger Editor's 'onChange' callback
   * Can be useful for block changes invisible for editor core.
   */ dispatchChange() {
        this.didMutated();
    }
    /**
   * Call Tool instance destroy method
   */ destroy() {
        this.unwatchBlockMutations(), this.removeInputEvents(), super.destroy(), $e2ab202322af4e74$var$A(this.toolInstance.destroy) && this.toolInstance.destroy();
    }
    /**
   * Tool could specify several entries to be displayed at the Toolbox (for example, "Heading 1", "Heading 2", "Heading 3")
   * This method returns the entry that is related to the Block (depended on the Block data)
   */ async getActiveToolboxEntry() {
        const e = this.tool.toolbox;
        if (e.length === 1) return Promise.resolve(this.tool.toolbox[0]);
        const t1 = await this.data, o = e;
        return o == null ? void 0 : o.find((i)=>$e2ab202322af4e74$var$Wo(i.data, t1));
    }
    /**
   * Exports Block data as string using conversion config
   */ async exportDataAsString() {
        const e = await this.data;
        return $e2ab202322af4e74$var$fi(e, this.tool.conversionConfig);
    }
    /**
   * Make default Block wrappers and put Tool`s content there
   *
   * @returns {HTMLDivElement}
   */ compose() {
        const e = $e2ab202322af4e74$var$u.make("div", $e2ab202322af4e74$var$R.CSS.wrapper), t1 = $e2ab202322af4e74$var$u.make("div", $e2ab202322af4e74$var$R.CSS.content), o = this.toolInstance.render();
        e.dataset.id = this.id, this.toolRenderedElement = o, t1.appendChild(this.toolRenderedElement);
        let i = t1;
        return [
            ...this.tunesInstances.values(),
            ...this.defaultTunesInstances.values()
        ].forEach((s)=>{
            if ($e2ab202322af4e74$var$A(s.wrap)) try {
                i = s.wrap(i);
            } catch (r) {
                $e2ab202322af4e74$var$S(`Tune ${s.constructor.name} wrap method throws an Error %o`, "warn", r);
            }
        }), e.appendChild(i), e;
    }
    /**
   * Instantiate Block Tunes
   *
   * @param tunesData - current Block tunes data
   * @private
   */ composeTunes(e) {
        Array.from(this.tunes.values()).forEach((t1)=>{
            (t1.isInternal ? this.defaultTunesInstances : this.tunesInstances).set(t1.name, t1.create(e[t1.name], this.blockAPI));
        }), Object.entries(e).forEach(([t1, o])=>{
            this.tunesInstances.has(t1) || (this.unavailableTunesData[t1] = o);
        });
    }
    /**
   * Adds focus event listeners to all inputs and contenteditable
   */ addInputEvents() {
        this.inputs.forEach((e)=>{
            e.addEventListener("focus", this.handleFocus), $e2ab202322af4e74$var$u.isNativeInput(e) && e.addEventListener("input", this.didMutated);
        });
    }
    /**
   * removes focus event listeners from all inputs and contenteditable
   */ removeInputEvents() {
        this.inputs.forEach((e)=>{
            e.removeEventListener("focus", this.handleFocus), $e2ab202322af4e74$var$u.isNativeInput(e) && e.removeEventListener("input", this.didMutated);
        });
    }
    /**
   * Listen common editor Dom Changed event and detect mutations related to the  Block
   */ watchBlockMutations() {
        var e;
        this.redactorDomChangedCallback = (t1)=>{
            const { mutations: o } = t1;
            o.some((s)=>$e2ab202322af4e74$var$pi(s, this.toolRenderedElement)) && this.didMutated(o);
        }, (e = this.editorEventBus) == null || e.on($e2ab202322af4e74$var$ft, this.redactorDomChangedCallback);
    }
    /**
   * Remove redactor dom change event listener
   */ unwatchBlockMutations() {
        var e;
        (e = this.editorEventBus) == null || e.off($e2ab202322af4e74$var$ft, this.redactorDomChangedCallback);
    }
    /**
   * Sometimes Tool can replace own main element, for example H2 -> H4 or UL -> OL
   * We need to detect such changes and update a link to tools main element with the new one
   *
   * @param mutations - records of block content mutations
   */ detectToolRootChange(e) {
        e.forEach((t1)=>{
            if (Array.from(t1.removedNodes).includes(this.toolRenderedElement)) {
                const i = t1.addedNodes[t1.addedNodes.length - 1];
                this.toolRenderedElement = i;
            }
        });
    }
    /**
   * Clears inputs cached value
   */ dropInputsCache() {
        this.cachedInputs = [];
    }
    /**
   * Mark inputs with 'data-empty' attribute with the empty state
   */ toggleInputsEmptyMark() {
        this.inputs.forEach($e2ab202322af4e74$var$Do);
    }
}
class $e2ab202322af4e74$var$gi extends $e2ab202322af4e74$var$E {
    constructor(){
        super(...arguments), this.insert = (e = this.config.defaultBlock, t1 = {}, o = {}, i, s, r, a)=>{
            const l = this.Editor.BlockManager.insert({
                id: a,
                tool: e,
                data: t1,
                index: i,
                needToFocus: s,
                replace: r
            });
            return new $e2ab202322af4e74$var$J(l);
        }, this.composeBlockData = async (e)=>{
            const t1 = this.Editor.Tools.blockTools.get(e);
            return new $e2ab202322af4e74$var$R({
                tool: t1,
                api: this.Editor.API,
                readOnly: !0,
                data: {},
                tunesData: {}
            }).data;
        }, this.update = async (e, t1, o)=>{
            const { BlockManager: i } = this.Editor, s = i.getBlockById(e);
            if (s === void 0) throw new Error(`Block with id "${e}" not found`);
            const r = await i.update(s, t1, o);
            return new $e2ab202322af4e74$var$J(r);
        }, this.convert = async (e, t1, o)=>{
            var h, p;
            const { BlockManager: i, Tools: s } = this.Editor, r = i.getBlockById(e);
            if (!r) throw new Error(`Block with id "${e}" not found`);
            const a = s.blockTools.get(r.name), l = s.blockTools.get(t1);
            if (!l) throw new Error(`Block Tool with type "${t1}" not found`);
            const c = ((h = a == null ? void 0 : a.conversionConfig) == null ? void 0 : h.export) !== void 0, d = ((p = l.conversionConfig) == null ? void 0 : p.import) !== void 0;
            if (c && d) {
                const g = await i.convert(r, t1, o);
                return new $e2ab202322af4e74$var$J(g);
            } else {
                const g = [
                    c ? !1 : $e2ab202322af4e74$var$je(r.name),
                    d ? !1 : $e2ab202322af4e74$var$je(t1)
                ].filter(Boolean).join(" and ");
                throw new Error(`Conversion from "${r.name}" to "${t1}" is not possible. ${g} tool(s) should provide a "conversionConfig"`);
            }
        }, this.insertMany = (e, t1 = this.Editor.BlockManager.blocks.length - 1)=>{
            this.validateIndex(t1);
            const o = e.map(({ id: i, type: s, data: r })=>this.Editor.BlockManager.composeBlock({
                    id: i,
                    tool: s || this.config.defaultBlock,
                    data: r
                }));
            return this.Editor.BlockManager.insertMany(o, t1), o.map((i)=>new $e2ab202322af4e74$var$J(i));
        };
    }
    /**
   * Available methods
   *
   * @returns {Blocks}
   */ get methods() {
        return {
            clear: ()=>this.clear(),
            render: (e)=>this.render(e),
            renderFromHTML: (e)=>this.renderFromHTML(e),
            delete: (e)=>this.delete(e),
            swap: (e, t1)=>this.swap(e, t1),
            move: (e, t1)=>this.move(e, t1),
            getBlockByIndex: (e)=>this.getBlockByIndex(e),
            getById: (e)=>this.getById(e),
            getCurrentBlockIndex: ()=>this.getCurrentBlockIndex(),
            getBlockIndex: (e)=>this.getBlockIndex(e),
            getBlocksCount: ()=>this.getBlocksCount(),
            getBlockByElement: (e)=>this.getBlockByElement(e),
            stretchBlock: (e, t1 = !0)=>this.stretchBlock(e, t1),
            insertNewBlock: ()=>this.insertNewBlock(),
            insert: this.insert,
            insertMany: this.insertMany,
            update: this.update,
            composeBlockData: this.composeBlockData,
            convert: this.convert
        };
    }
    /**
   * Returns Blocks count
   *
   * @returns {number}
   */ getBlocksCount() {
        return this.Editor.BlockManager.blocks.length;
    }
    /**
   * Returns current block index
   *
   * @returns {number}
   */ getCurrentBlockIndex() {
        return this.Editor.BlockManager.currentBlockIndex;
    }
    /**
   * Returns the index of Block by id;
   *
   * @param id - block id
   */ getBlockIndex(e) {
        const t1 = this.Editor.BlockManager.getBlockById(e);
        if (!t1) {
            $e2ab202322af4e74$var$X("There is no block with id `" + e + "`", "warn");
            return;
        }
        return this.Editor.BlockManager.getBlockIndex(t1);
    }
    /**
   * Returns BlockAPI object by Block index
   *
   * @param {number} index - index to get
   */ getBlockByIndex(e) {
        const t1 = this.Editor.BlockManager.getBlockByIndex(e);
        if (t1 === void 0) {
            $e2ab202322af4e74$var$X("There is no block at index `" + e + "`", "warn");
            return;
        }
        return new $e2ab202322af4e74$var$J(t1);
    }
    /**
   * Returns BlockAPI object by Block id
   *
   * @param id - id of block to get
   */ getById(e) {
        const t1 = this.Editor.BlockManager.getBlockById(e);
        return t1 === void 0 ? ($e2ab202322af4e74$var$X("There is no block with id `" + e + "`", "warn"), null) : new $e2ab202322af4e74$var$J(t1);
    }
    /**
   * Get Block API object by any child html element
   *
   * @param element - html element to get Block by
   */ getBlockByElement(e) {
        const t1 = this.Editor.BlockManager.getBlock(e);
        if (t1 === void 0) {
            $e2ab202322af4e74$var$X("There is no block corresponding to element `" + e + "`", "warn");
            return;
        }
        return new $e2ab202322af4e74$var$J(t1);
    }
    /**
   * Call Block Manager method that swap Blocks
   *
   * @param {number} fromIndex - position of first Block
   * @param {number} toIndex - position of second Block
   * @deprecated — use 'move' instead
   */ swap(e, t1) {
        $e2ab202322af4e74$var$S("`blocks.swap()` method is deprecated and will be removed in the next major release. Use `block.move()` method instead", "info"), this.Editor.BlockManager.swap(e, t1);
    }
    /**
   * Move block from one index to another
   *
   * @param {number} toIndex - index to move to
   * @param {number} fromIndex - index to move from
   */ move(e, t1) {
        this.Editor.BlockManager.move(e, t1);
    }
    /**
   * Deletes Block
   *
   * @param {number} blockIndex - index of Block to delete
   */ delete(e = this.Editor.BlockManager.currentBlockIndex) {
        try {
            const t1 = this.Editor.BlockManager.getBlockByIndex(e);
            this.Editor.BlockManager.removeBlock(t1);
        } catch (t1) {
            $e2ab202322af4e74$var$X(t1, "warn");
            return;
        }
        this.Editor.BlockManager.blocks.length === 0 && this.Editor.BlockManager.insert(), this.Editor.BlockManager.currentBlock && this.Editor.Caret.setToBlock(this.Editor.BlockManager.currentBlock, this.Editor.Caret.positions.END), this.Editor.Toolbar.close();
    }
    /**
   * Clear Editor's area
   */ async clear() {
        await this.Editor.BlockManager.clear(!0), this.Editor.InlineToolbar.close();
    }
    /**
   * Fills Editor with Blocks data
   *
   * @param {OutputData} data — Saved Editor data
   */ async render(e) {
        if (e === void 0 || e.blocks === void 0) throw new Error("Incorrect data passed to the render() method");
        this.Editor.ModificationsObserver.disable(), await this.Editor.BlockManager.clear(), await this.Editor.Renderer.render(e.blocks), this.Editor.ModificationsObserver.enable();
    }
    /**
   * Render passed HTML string
   *
   * @param {string} data - HTML string to render
   * @returns {Promise<void>}
   */ async renderFromHTML(e) {
        return await this.Editor.BlockManager.clear(), this.Editor.Paste.processText(e, !0);
    }
    /**
   * Stretch Block's content
   *
   * @param {number} index - index of Block to stretch
   * @param {boolean} status - true to enable, false to disable
   * @deprecated Use BlockAPI interface to stretch Blocks
   */ stretchBlock(e, t1 = !0) {
        $e2ab202322af4e74$var$ht(!0, "blocks.stretchBlock()", "BlockAPI");
        const o = this.Editor.BlockManager.getBlockByIndex(e);
        o && (o.stretched = t1);
    }
    /**
   * Insert new Block
   * After set caret to this Block
   *
   * @todo remove in 3.0.0
   * @deprecated with insert() method
   */ insertNewBlock() {
        $e2ab202322af4e74$var$S("Method blocks.insertNewBlock() is deprecated and it will be removed in the next major release. Use blocks.insert() instead.", "warn"), this.insert();
    }
    /**
   * Validated block index and throws an error if it's invalid
   *
   * @param index - index to validate
   */ validateIndex(e) {
        if (typeof e != "number") throw new Error("Index should be a number");
        if (e < 0) throw new Error("Index should be greater than or equal to 0");
        if (e === null) throw new Error("Index should be greater than or equal to 0");
    }
}
function $e2ab202322af4e74$var$mi(n, e) {
    return typeof n == "number" ? e.BlockManager.getBlockByIndex(n) : typeof n == "string" ? e.BlockManager.getBlockById(n) : e.BlockManager.getBlockById(n.id);
}
class $e2ab202322af4e74$var$bi extends $e2ab202322af4e74$var$E {
    constructor(){
        super(...arguments), this.setToFirstBlock = (e = this.Editor.Caret.positions.DEFAULT, t1 = 0)=>this.Editor.BlockManager.firstBlock ? (this.Editor.Caret.setToBlock(this.Editor.BlockManager.firstBlock, e, t1), !0) : !1, this.setToLastBlock = (e = this.Editor.Caret.positions.DEFAULT, t1 = 0)=>this.Editor.BlockManager.lastBlock ? (this.Editor.Caret.setToBlock(this.Editor.BlockManager.lastBlock, e, t1), !0) : !1, this.setToPreviousBlock = (e = this.Editor.Caret.positions.DEFAULT, t1 = 0)=>this.Editor.BlockManager.previousBlock ? (this.Editor.Caret.setToBlock(this.Editor.BlockManager.previousBlock, e, t1), !0) : !1, this.setToNextBlock = (e = this.Editor.Caret.positions.DEFAULT, t1 = 0)=>this.Editor.BlockManager.nextBlock ? (this.Editor.Caret.setToBlock(this.Editor.BlockManager.nextBlock, e, t1), !0) : !1, this.setToBlock = (e, t1 = this.Editor.Caret.positions.DEFAULT, o = 0)=>{
            const i = $e2ab202322af4e74$var$mi(e, this.Editor);
            return i === void 0 ? !1 : (this.Editor.Caret.setToBlock(i, t1, o), !0);
        }, this.focus = (e = !1)=>e ? this.setToLastBlock(this.Editor.Caret.positions.END) : this.setToFirstBlock(this.Editor.Caret.positions.START);
    }
    /**
   * Available methods
   *
   * @returns {Caret}
   */ get methods() {
        return {
            setToFirstBlock: this.setToFirstBlock,
            setToLastBlock: this.setToLastBlock,
            setToPreviousBlock: this.setToPreviousBlock,
            setToNextBlock: this.setToNextBlock,
            setToBlock: this.setToBlock,
            focus: this.focus
        };
    }
}
class $e2ab202322af4e74$var$vi extends $e2ab202322af4e74$var$E {
    /**
   * Available methods
   *
   * @returns {Events}
   */ get methods() {
        return {
            emit: (e, t1)=>this.emit(e, t1),
            off: (e, t1)=>this.off(e, t1),
            on: (e, t1)=>this.on(e, t1)
        };
    }
    /**
   * Subscribe on Events
   *
   * @param {string} eventName - event name to subscribe
   * @param {Function} callback - event handler
   */ on(e, t1) {
        this.eventsDispatcher.on(e, t1);
    }
    /**
   * Emit event with data
   *
   * @param {string} eventName - event to emit
   * @param {object} data - event's data
   */ emit(e, t1) {
        this.eventsDispatcher.emit(e, t1);
    }
    /**
   * Unsubscribe from Event
   *
   * @param {string} eventName - event to unsubscribe
   * @param {Function} callback - event handler
   */ off(e, t1) {
        this.eventsDispatcher.off(e, t1);
    }
}
class $e2ab202322af4e74$var$kt extends $e2ab202322af4e74$var$E {
    /**
   * Return namespace section for tool or block tune
   *
   * @param toolName - tool name
   * @param isTune - is tool a block tune
   */ static getNamespace(e, t1) {
        return t1 ? `blockTunes.${e}` : `tools.${e}`;
    }
    /**
   * Return I18n API methods with global dictionary access
   */ get methods() {
        return {
            t: ()=>{
                $e2ab202322af4e74$var$X("I18n.t() method can be accessed only from Tools", "warn");
            }
        };
    }
    /**
   * Return I18n API methods with tool namespaced dictionary
   *
   * @param toolName - tool name
   * @param isTune - is tool a block tune
   */ getMethodsForTool(e, t1) {
        return Object.assign(this.methods, {
            t: (o)=>$e2ab202322af4e74$var$z.t($e2ab202322af4e74$var$kt.getNamespace(e, t1), o)
        });
    }
}
class $e2ab202322af4e74$var$ki extends $e2ab202322af4e74$var$E {
    /**
   * Editor.js Core API modules
   */ get methods() {
        return {
            blocks: this.Editor.BlocksAPI.methods,
            caret: this.Editor.CaretAPI.methods,
            tools: this.Editor.ToolsAPI.methods,
            events: this.Editor.EventsAPI.methods,
            listeners: this.Editor.ListenersAPI.methods,
            notifier: this.Editor.NotifierAPI.methods,
            sanitizer: this.Editor.SanitizerAPI.methods,
            saver: this.Editor.SaverAPI.methods,
            selection: this.Editor.SelectionAPI.methods,
            styles: this.Editor.StylesAPI.classes,
            toolbar: this.Editor.ToolbarAPI.methods,
            inlineToolbar: this.Editor.InlineToolbarAPI.methods,
            tooltip: this.Editor.TooltipAPI.methods,
            i18n: this.Editor.I18nAPI.methods,
            readOnly: this.Editor.ReadOnlyAPI.methods,
            ui: this.Editor.UiAPI.methods
        };
    }
    /**
   * Returns Editor.js Core API methods for passed tool
   *
   * @param toolName - tool name
   * @param isTune - is tool a block tune
   */ getMethodsForTool(e, t1) {
        return Object.assign(this.methods, {
            i18n: this.Editor.I18nAPI.getMethodsForTool(e, t1)
        });
    }
}
class $e2ab202322af4e74$var$yi extends $e2ab202322af4e74$var$E {
    /**
   * Available methods
   *
   * @returns {InlineToolbar}
   */ get methods() {
        return {
            close: ()=>this.close(),
            open: ()=>this.open()
        };
    }
    /**
   * Open Inline Toolbar
   */ open() {
        this.Editor.InlineToolbar.tryToShow();
    }
    /**
   * Close Inline Toolbar
   */ close() {
        this.Editor.InlineToolbar.close();
    }
}
class $e2ab202322af4e74$var$wi extends $e2ab202322af4e74$var$E {
    /**
   * Available methods
   *
   * @returns {Listeners}
   */ get methods() {
        return {
            on: (e, t1, o, i)=>this.on(e, t1, o, i),
            off: (e, t1, o, i)=>this.off(e, t1, o, i),
            offById: (e)=>this.offById(e)
        };
    }
    /**
   * Ads a DOM event listener. Return it's id.
   *
   * @param {HTMLElement} element - Element to set handler to
   * @param {string} eventType - event type
   * @param {() => void} handler - event handler
   * @param {boolean} useCapture - capture event or not
   */ on(e, t1, o, i) {
        return this.listeners.on(e, t1, o, i);
    }
    /**
   * Removes DOM listener from element
   *
   * @param {Element} element - Element to remove handler from
   * @param eventType - event type
   * @param handler - event handler
   * @param {boolean} useCapture - capture event or not
   */ off(e, t1, o, i) {
        this.listeners.off(e, t1, o, i);
    }
    /**
   * Removes DOM listener by the listener id
   *
   * @param id - id of the listener to remove
   */ offById(e) {
        this.listeners.offById(e);
    }
}
var $e2ab202322af4e74$var$Ko = {
    exports: {}
};
(function(n, e) {
    (function(t1, o) {
        n.exports = o();
    })(window, function() {
        return function(t1) {
            var o = {};
            function i(s) {
                if (o[s]) return o[s].exports;
                var r = o[s] = {
                    i: s,
                    l: !1,
                    exports: {}
                };
                return t1[s].call(r.exports, r, r.exports, i), r.l = !0, r.exports;
            }
            return i.m = t1, i.c = o, i.d = function(s, r, a) {
                i.o(s, r) || Object.defineProperty(s, r, {
                    enumerable: !0,
                    get: a
                });
            }, i.r = function(s) {
                typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, {
                    value: "Module"
                }), Object.defineProperty(s, "__esModule", {
                    value: !0
                });
            }, i.t = function(s, r) {
                if (1 & r && (s = i(s)), 8 & r || 4 & r && typeof s == "object" && s && s.__esModule) return s;
                var a = /* @__PURE__ */ Object.create(null);
                if (i.r(a), Object.defineProperty(a, "default", {
                    enumerable: !0,
                    value: s
                }), 2 & r && typeof s != "string") for(var l in s)i.d(a, l, (function(c) {
                    return s[c];
                }).bind(null, l));
                return a;
            }, i.n = function(s) {
                var r = s && s.__esModule ? function() {
                    return s.default;
                } : function() {
                    return s;
                };
                return i.d(r, "a", r), r;
            }, i.o = function(s, r) {
                return Object.prototype.hasOwnProperty.call(s, r);
            }, i.p = "/", i(i.s = 0);
        }([
            function(t1, o, i) {
                i(1), /*!
       * Codex JavaScript Notification module
       * https://github.com/codex-team/js-notifier
       */ t1.exports = function() {
                    var s = i(6), r = "cdx-notify--bounce-in", a = null;
                    return {
                        show: function(l) {
                            if (l.message) {
                                (function() {
                                    if (a) return !0;
                                    a = s.getWrapper(), document.body.appendChild(a);
                                })();
                                var c = null, d = l.time || 8e3;
                                switch(l.type){
                                    case "confirm":
                                        c = s.confirm(l);
                                        break;
                                    case "prompt":
                                        c = s.prompt(l);
                                        break;
                                    default:
                                        c = s.alert(l), window.setTimeout(function() {
                                            c.remove();
                                        }, d);
                                }
                                a.appendChild(c), c.classList.add(r);
                            }
                        }
                    };
                }();
            },
            function(t1, o, i) {
                var s = i(2);
                typeof s == "string" && (s = [
                    [
                        t1.i,
                        s,
                        ""
                    ]
                ]);
                var r = {
                    hmr: !0,
                    transform: void 0,
                    insertInto: void 0
                };
                i(4)(s, r), s.locals && (t1.exports = s.locals);
            },
            function(t1, o, i) {
                (t1.exports = i(3)(!1)).push([
                    t1.i,
                    `.cdx-notify--error{background:#fffbfb!important}.cdx-notify--error::before{background:#fb5d5d!important}.cdx-notify__input{max-width:130px;padding:5px 10px;background:#f7f7f7;border:0;border-radius:3px;font-size:13px;color:#656b7c;outline:0}.cdx-notify__input:-ms-input-placeholder{color:#656b7c}.cdx-notify__input::placeholder{color:#656b7c}.cdx-notify__input:focus:-ms-input-placeholder{color:rgba(101,107,124,.3)}.cdx-notify__input:focus::placeholder{color:rgba(101,107,124,.3)}.cdx-notify__button{border:none;border-radius:3px;font-size:13px;padding:5px 10px;cursor:pointer}.cdx-notify__button:last-child{margin-left:10px}.cdx-notify__button--cancel{background:#f2f5f7;box-shadow:0 2px 1px 0 rgba(16,19,29,0);color:#656b7c}.cdx-notify__button--cancel:hover{background:#eee}.cdx-notify__button--confirm{background:#34c992;box-shadow:0 1px 1px 0 rgba(18,49,35,.05);color:#fff}.cdx-notify__button--confirm:hover{background:#33b082}.cdx-notify__btns-wrapper{display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap;margin-top:5px}.cdx-notify__cross{position:absolute;top:5px;right:5px;width:10px;height:10px;padding:5px;opacity:.54;cursor:pointer}.cdx-notify__cross::after,.cdx-notify__cross::before{content:'';position:absolute;left:9px;top:5px;height:12px;width:2px;background:#575d67}.cdx-notify__cross::before{transform:rotate(-45deg)}.cdx-notify__cross::after{transform:rotate(45deg)}.cdx-notify__cross:hover{opacity:1}.cdx-notifies{position:fixed;z-index:2;bottom:20px;left:20px;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen,Ubuntu,Cantarell,"Fira Sans","Droid Sans","Helvetica Neue",sans-serif}.cdx-notify{position:relative;width:220px;margin-top:15px;padding:13px 16px;background:#fff;box-shadow:0 11px 17px 0 rgba(23,32,61,.13);border-radius:5px;font-size:14px;line-height:1.4em;word-wrap:break-word}.cdx-notify::before{content:'';position:absolute;display:block;top:0;left:0;width:3px;height:calc(100% - 6px);margin:3px;border-radius:5px;background:0 0}@keyframes bounceIn{0%{opacity:0;transform:scale(.3)}50%{opacity:1;transform:scale(1.05)}70%{transform:scale(.9)}100%{transform:scale(1)}}.cdx-notify--bounce-in{animation-name:bounceIn;animation-duration:.6s;animation-iteration-count:1}.cdx-notify--success{background:#fafffe!important}.cdx-notify--success::before{background:#41ffb1!important}`,
                    ""
                ]);
            },
            function(t1, o) {
                t1.exports = function(i) {
                    var s = [];
                    return s.toString = function() {
                        return this.map(function(r) {
                            var a = function(l, c) {
                                var d = l[1] || "", h = l[3];
                                if (!h) return d;
                                if (c && typeof btoa == "function") {
                                    var p = (f = h, "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(f)))) + " */"), g = h.sources.map(function(v) {
                                        return "/*# sourceURL=" + h.sourceRoot + v + " */";
                                    });
                                    return [
                                        d
                                    ].concat(g).concat([
                                        p
                                    ]).join(`
`);
                                }
                                var f;
                                return [
                                    d
                                ].join(`
`);
                            }(r, i);
                            return r[2] ? "@media " + r[2] + "{" + a + "}" : a;
                        }).join("");
                    }, s.i = function(r, a) {
                        typeof r == "string" && (r = [
                            [
                                null,
                                r,
                                ""
                            ]
                        ]);
                        for(var l = {}, c = 0; c < this.length; c++){
                            var d = this[c][0];
                            typeof d == "number" && (l[d] = !0);
                        }
                        for(c = 0; c < r.length; c++){
                            var h = r[c];
                            typeof h[0] == "number" && l[h[0]] || (a && !h[2] ? h[2] = a : a && (h[2] = "(" + h[2] + ") and (" + a + ")"), s.push(h));
                        }
                    }, s;
                };
            },
            function(t1, o, i) {
                var s, r, a = {}, l = (s = function() {
                    return window && document && document.all && !window.atob;
                }, function() {
                    return r === void 0 && (r = s.apply(this, arguments)), r;
                }), c = function(k) {
                    var m = {};
                    return function(w) {
                        if (typeof w == "function") return w();
                        if (m[w] === void 0) {
                            var x = (function(I) {
                                return document.querySelector(I);
                            }).call(this, w);
                            if (window.HTMLIFrameElement && x instanceof window.HTMLIFrameElement) try {
                                x = x.contentDocument.head;
                            } catch  {
                                x = null;
                            }
                            m[w] = x;
                        }
                        return m[w];
                    };
                }(), d = null, h = 0, p = [], g = i(5);
                function f(k, m) {
                    for(var w = 0; w < k.length; w++){
                        var x = k[w], I = a[x.id];
                        if (I) {
                            I.refs++;
                            for(var C = 0; C < I.parts.length; C++)I.parts[C](x.parts[C]);
                            for(; C < x.parts.length; C++)I.parts.push(F(x.parts[C], m));
                        } else {
                            var N = [];
                            for(C = 0; C < x.parts.length; C++)N.push(F(x.parts[C], m));
                            a[x.id] = {
                                id: x.id,
                                refs: 1,
                                parts: N
                            };
                        }
                    }
                }
                function v(k, m) {
                    for(var w = [], x = {}, I = 0; I < k.length; I++){
                        var C = k[I], N = m.base ? C[0] + m.base : C[0], B = {
                            css: C[1],
                            media: C[2],
                            sourceMap: C[3]
                        };
                        x[N] ? x[N].parts.push(B) : w.push(x[N] = {
                            id: N,
                            parts: [
                                B
                            ]
                        });
                    }
                    return w;
                }
                function O(k, m) {
                    var w = c(k.insertInto);
                    if (!w) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
                    var x = p[p.length - 1];
                    if (k.insertAt === "top") x ? x.nextSibling ? w.insertBefore(m, x.nextSibling) : w.appendChild(m) : w.insertBefore(m, w.firstChild), p.push(m);
                    else if (k.insertAt === "bottom") w.appendChild(m);
                    else {
                        if (typeof k.insertAt != "object" || !k.insertAt.before) throw new Error(`[Style Loader]

 Invalid value for parameter 'insertAt' ('options.insertAt') found.
 Must be 'top', 'bottom', or Object.
 (https://github.com/webpack-contrib/style-loader#insertat)
`);
                        var I = c(k.insertInto + " " + k.insertAt.before);
                        w.insertBefore(m, I);
                    }
                }
                function T(k) {
                    if (k.parentNode === null) return !1;
                    k.parentNode.removeChild(k);
                    var m = p.indexOf(k);
                    m >= 0 && p.splice(m, 1);
                }
                function M(k) {
                    var m = document.createElement("style");
                    return k.attrs.type === void 0 && (k.attrs.type = "text/css"), q(m, k.attrs), O(k, m), m;
                }
                function q(k, m) {
                    Object.keys(m).forEach(function(w) {
                        k.setAttribute(w, m[w]);
                    });
                }
                function F(k, m) {
                    var w, x, I, C;
                    if (m.transform && k.css) {
                        if (!(C = m.transform(k.css))) return function() {};
                        k.css = C;
                    }
                    if (m.singleton) {
                        var N = h++;
                        w = d || (d = M(m)), x = ie.bind(null, w, N, !1), I = ie.bind(null, w, N, !0);
                    } else k.sourceMap && typeof URL == "function" && typeof URL.createObjectURL == "function" && typeof URL.revokeObjectURL == "function" && typeof Blob == "function" && typeof btoa == "function" ? (w = function(B) {
                        var W = document.createElement("link");
                        return B.attrs.type === void 0 && (B.attrs.type = "text/css"), B.attrs.rel = "stylesheet", q(W, B.attrs), O(B, W), W;
                    }(m), x = (function(B, W, ve) {
                        var se = ve.css, tt = ve.sourceMap, Yn = W.convertToAbsoluteUrls === void 0 && tt;
                        (W.convertToAbsoluteUrls || Yn) && (se = g(se)), tt && (se += `
/*# sourceMappingURL=data:application/json;base64,` + btoa(unescape(encodeURIComponent(JSON.stringify(tt)))) + " */");
                        var Kn = new Blob([
                            se
                        ], {
                            type: "text/css"
                        }), ko = B.href;
                        B.href = URL.createObjectURL(Kn), ko && URL.revokeObjectURL(ko);
                    }).bind(null, w, m), I = function() {
                        T(w), w.href && URL.revokeObjectURL(w.href);
                    }) : (w = M(m), x = (function(B, W) {
                        var ve = W.css, se = W.media;
                        if (se && B.setAttribute("media", se), B.styleSheet) B.styleSheet.cssText = ve;
                        else {
                            for(; B.firstChild;)B.removeChild(B.firstChild);
                            B.appendChild(document.createTextNode(ve));
                        }
                    }).bind(null, w), I = function() {
                        T(w);
                    });
                    return x(k), function(B) {
                        if (B) {
                            if (B.css === k.css && B.media === k.media && B.sourceMap === k.sourceMap) return;
                            x(k = B);
                        } else I();
                    };
                }
                t1.exports = function(k, m) {
                    if (typeof DEBUG < "u" && DEBUG && typeof document != "object") throw new Error("The style-loader cannot be used in a non-browser environment");
                    (m = m || {}).attrs = typeof m.attrs == "object" ? m.attrs : {}, m.singleton || typeof m.singleton == "boolean" || (m.singleton = l()), m.insertInto || (m.insertInto = "head"), m.insertAt || (m.insertAt = "bottom");
                    var w = v(k, m);
                    return f(w, m), function(x) {
                        for(var I = [], C = 0; C < w.length; C++){
                            var N = w[C];
                            (B = a[N.id]).refs--, I.push(B);
                        }
                        for(x && f(v(x, m), m), C = 0; C < I.length; C++){
                            var B;
                            if ((B = I[C]).refs === 0) {
                                for(var W = 0; W < B.parts.length; W++)B.parts[W]();
                                delete a[B.id];
                            }
                        }
                    };
                };
                var H, Q = (H = [], function(k, m) {
                    return H[k] = m, H.filter(Boolean).join(`
`);
                });
                function ie(k, m, w, x) {
                    var I = w ? "" : x.css;
                    if (k.styleSheet) k.styleSheet.cssText = Q(m, I);
                    else {
                        var C = document.createTextNode(I), N = k.childNodes;
                        N[m] && k.removeChild(N[m]), N.length ? k.insertBefore(C, N[m]) : k.appendChild(C);
                    }
                }
            },
            function(t1, o) {
                t1.exports = function(i) {
                    var s = typeof window < "u" && window.location;
                    if (!s) throw new Error("fixUrls requires window.location");
                    if (!i || typeof i != "string") return i;
                    var r = s.protocol + "//" + s.host, a = r + s.pathname.replace(/\/[^\/]*$/, "/");
                    return i.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(l, c) {
                        var d, h = c.trim().replace(/^"(.*)"$/, function(p, g) {
                            return g;
                        }).replace(/^'(.*)'$/, function(p, g) {
                            return g;
                        });
                        return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(h) ? l : (d = h.indexOf("//") === 0 ? h : h.indexOf("/") === 0 ? r + h : a + h.replace(/^\.\//, ""), "url(" + JSON.stringify(d) + ")");
                    });
                };
            },
            function(t1, o, i) {
                var s, r, a, l, c, d, h, p, g;
                t1.exports = (s = "cdx-notifies", r = "cdx-notify", a = "cdx-notify__cross", l = "cdx-notify__button--confirm", c = "cdx-notify__button--cancel", d = "cdx-notify__input", h = "cdx-notify__button", p = "cdx-notify__btns-wrapper", {
                    alert: g = function(f) {
                        var v = document.createElement("DIV"), O = document.createElement("DIV"), T = f.message, M = f.style;
                        return v.classList.add(r), M && v.classList.add(r + "--" + M), v.innerHTML = T, O.classList.add(a), O.addEventListener("click", v.remove.bind(v)), v.appendChild(O), v;
                    },
                    confirm: function(f) {
                        var v = g(f), O = document.createElement("div"), T = document.createElement("button"), M = document.createElement("button"), q = v.querySelector("." + a), F = f.cancelHandler, H = f.okHandler;
                        return O.classList.add(p), T.innerHTML = f.okText || "Confirm", M.innerHTML = f.cancelText || "Cancel", T.classList.add(h), M.classList.add(h), T.classList.add(l), M.classList.add(c), F && typeof F == "function" && (M.addEventListener("click", F), q.addEventListener("click", F)), H && typeof H == "function" && T.addEventListener("click", H), T.addEventListener("click", v.remove.bind(v)), M.addEventListener("click", v.remove.bind(v)), O.appendChild(T), O.appendChild(M), v.appendChild(O), v;
                    },
                    prompt: function(f) {
                        var v = g(f), O = document.createElement("div"), T = document.createElement("button"), M = document.createElement("input"), q = v.querySelector("." + a), F = f.cancelHandler, H = f.okHandler;
                        return O.classList.add(p), T.innerHTML = f.okText || "Ok", T.classList.add(h), T.classList.add(l), M.classList.add(d), f.placeholder && M.setAttribute("placeholder", f.placeholder), f.default && (M.value = f.default), f.inputType && (M.type = f.inputType), F && typeof F == "function" && q.addEventListener("click", F), H && typeof H == "function" && T.addEventListener("click", function() {
                            H(M.value);
                        }), T.addEventListener("click", v.remove.bind(v)), O.appendChild(M), O.appendChild(T), v.appendChild(O), v;
                    },
                    getWrapper: function() {
                        var f = document.createElement("DIV");
                        return f.classList.add(s), f;
                    }
                });
            }
        ]);
    });
})($e2ab202322af4e74$var$Ko);
var $e2ab202322af4e74$var$Ei = $e2ab202322af4e74$var$Ko.exports;
const $e2ab202322af4e74$var$xi = /* @__PURE__ */ $e2ab202322af4e74$var$Ke($e2ab202322af4e74$var$Ei);
class $e2ab202322af4e74$var$Bi {
    /**
   * Show web notification
   *
   * @param {NotifierOptions | ConfirmNotifierOptions | PromptNotifierOptions} options - notification options
   */ show(e) {
        $e2ab202322af4e74$var$xi.show(e);
    }
}
class $e2ab202322af4e74$var$Ci extends $e2ab202322af4e74$var$E {
    /**
   * @param moduleConfiguration - Module Configuration
   * @param moduleConfiguration.config - Editor's config
   * @param moduleConfiguration.eventsDispatcher - Editor's event dispatcher
   */ constructor({ config: e, eventsDispatcher: t1 }){
        super({
            config: e,
            eventsDispatcher: t1
        }), this.notifier = new $e2ab202322af4e74$var$Bi();
    }
    /**
   * Available methods
   */ get methods() {
        return {
            show: (e)=>this.show(e)
        };
    }
    /**
   * Show notification
   *
   * @param {NotifierOptions} options - message option
   */ show(e) {
        return this.notifier.show(e);
    }
}
class $e2ab202322af4e74$var$Ti extends $e2ab202322af4e74$var$E {
    /**
   * Available methods
   */ get methods() {
        const e = ()=>this.isEnabled;
        return {
            toggle: (t1)=>this.toggle(t1),
            get isEnabled () {
                return e();
            }
        };
    }
    /**
   * Set or toggle read-only state
   *
   * @param {boolean|undefined} state - set or toggle state
   * @returns {boolean} current value
   */ toggle(e) {
        return this.Editor.ReadOnly.toggle(e);
    }
    /**
   * Returns current read-only state
   */ get isEnabled() {
        return this.Editor.ReadOnly.isEnabled;
    }
}
var $e2ab202322af4e74$var$Xo = {
    exports: {}
};
(function(n, e) {
    (function(t1, o) {
        n.exports = o();
    })($e2ab202322af4e74$var$Ce, function() {
        function t1(h) {
            var p = h.tags, g = Object.keys(p), f = g.map(function(v) {
                return typeof p[v];
            }).every(function(v) {
                return v === "object" || v === "boolean" || v === "function";
            });
            if (!f) throw new Error("The configuration was invalid");
            this.config = h;
        }
        var o = [
            "P",
            "LI",
            "TD",
            "TH",
            "DIV",
            "H1",
            "H2",
            "H3",
            "H4",
            "H5",
            "H6",
            "PRE"
        ];
        function i(h) {
            return o.indexOf(h.nodeName) !== -1;
        }
        var s = [
            "A",
            "B",
            "STRONG",
            "I",
            "EM",
            "SUB",
            "SUP",
            "U",
            "STRIKE"
        ];
        function r(h) {
            return s.indexOf(h.nodeName) !== -1;
        }
        t1.prototype.clean = function(h) {
            const p = document.implementation.createHTMLDocument(), g = p.createElement("div");
            return g.innerHTML = h, this._sanitize(p, g), g.innerHTML;
        }, t1.prototype._sanitize = function(h, p) {
            var g = a(h, p), f = g.firstChild();
            if (f) do {
                if (f.nodeType === Node.TEXT_NODE) {
                    if (f.data.trim() === "" && (f.previousElementSibling && i(f.previousElementSibling) || f.nextElementSibling && i(f.nextElementSibling))) {
                        p.removeChild(f), this._sanitize(h, p);
                        break;
                    } else continue;
                }
                if (f.nodeType === Node.COMMENT_NODE) {
                    p.removeChild(f), this._sanitize(h, p);
                    break;
                }
                var v = r(f), O;
                v && (O = Array.prototype.some.call(f.childNodes, i));
                var T = !!p.parentNode, M = i(p) && i(f) && T, q = f.nodeName.toLowerCase(), F = l(this.config, q, f), H = v && O;
                if (H || c(f, F) || !this.config.keepNestedBlockElements && M) {
                    if (!(f.nodeName === "SCRIPT" || f.nodeName === "STYLE")) for(; f.childNodes.length > 0;)p.insertBefore(f.childNodes[0], f);
                    p.removeChild(f), this._sanitize(h, p);
                    break;
                }
                for(var Q = 0; Q < f.attributes.length; Q += 1){
                    var ie = f.attributes[Q];
                    d(ie, F, f) && (f.removeAttribute(ie.name), Q = Q - 1);
                }
                this._sanitize(h, f);
            }while (f = g.nextSibling());
        };
        function a(h, p) {
            return h.createTreeWalker(p, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT, null, !1);
        }
        function l(h, p, g) {
            return typeof h.tags[p] == "function" ? h.tags[p](g) : h.tags[p];
        }
        function c(h, p) {
            return typeof p > "u" ? !0 : typeof p == "boolean" ? !p : !1;
        }
        function d(h, p, g) {
            var f = h.name.toLowerCase();
            return p === !0 ? !1 : typeof p[f] == "function" ? !p[f](h.value, g) : typeof p[f] > "u" || p[f] === !1 ? !0 : typeof p[f] == "string" ? p[f] !== h.value : !1;
        }
        return t1;
    });
})($e2ab202322af4e74$var$Xo);
var $e2ab202322af4e74$var$Si = $e2ab202322af4e74$var$Xo.exports;
const $e2ab202322af4e74$var$Ii = /* @__PURE__ */ $e2ab202322af4e74$var$Ke($e2ab202322af4e74$var$Si);
function $e2ab202322af4e74$var$yt(n, e) {
    return n.map((t1)=>{
        const o = $e2ab202322af4e74$var$A(e) ? e(t1.tool) : e;
        return $e2ab202322af4e74$var$V(o) || (t1.data = $e2ab202322af4e74$var$wt(t1.data, o)), t1;
    });
}
function $e2ab202322af4e74$var$Z(n, e = {}) {
    const t1 = {
        tags: e
    };
    return new $e2ab202322af4e74$var$Ii(t1).clean(n);
}
function $e2ab202322af4e74$var$wt(n, e) {
    return Array.isArray(n) ? $e2ab202322af4e74$var$Oi(n, e) : $e2ab202322af4e74$var$D(n) ? $e2ab202322af4e74$var$_i(n, e) : $e2ab202322af4e74$var$te(n) ? $e2ab202322af4e74$var$Mi(n, e) : n;
}
function $e2ab202322af4e74$var$Oi(n, e) {
    return n.map((t1)=>$e2ab202322af4e74$var$wt(t1, e));
}
function $e2ab202322af4e74$var$_i(n, e) {
    const t1 = {};
    for(const o in n){
        if (!Object.prototype.hasOwnProperty.call(n, o)) continue;
        const i = n[o], s = $e2ab202322af4e74$var$Ai(e[o]) ? e[o] : e;
        t1[o] = $e2ab202322af4e74$var$wt(i, s);
    }
    return t1;
}
function $e2ab202322af4e74$var$Mi(n, e) {
    return $e2ab202322af4e74$var$D(e) ? $e2ab202322af4e74$var$Z(n, e) : e === !1 ? $e2ab202322af4e74$var$Z(n, {}) : n;
}
function $e2ab202322af4e74$var$Ai(n) {
    return $e2ab202322af4e74$var$D(n) || $e2ab202322af4e74$var$Gn(n) || $e2ab202322af4e74$var$A(n);
}
class $e2ab202322af4e74$var$Li extends $e2ab202322af4e74$var$E {
    /**
   * Available methods
   *
   * @returns {SanitizerConfig}
   */ get methods() {
        return {
            clean: (e, t1)=>this.clean(e, t1)
        };
    }
    /**
   * Perform sanitizing of a string
   *
   * @param {string} taintString - what to sanitize
   * @param {SanitizerConfig} config - sanitizer config
   * @returns {string}
   */ clean(e, t1) {
        return $e2ab202322af4e74$var$Z(e, t1);
    }
}
class $e2ab202322af4e74$var$Pi extends $e2ab202322af4e74$var$E {
    /**
   * Available methods
   *
   * @returns {Saver}
   */ get methods() {
        return {
            save: ()=>this.save()
        };
    }
    /**
   * Return Editor's data
   *
   * @returns {OutputData}
   */ save() {
        const e = "Editor's content can not be saved in read-only mode";
        return this.Editor.ReadOnly.isEnabled ? ($e2ab202322af4e74$var$X(e, "warn"), Promise.reject(new Error(e))) : this.Editor.Saver.save();
    }
}
class $e2ab202322af4e74$var$Ni extends $e2ab202322af4e74$var$E {
    constructor(){
        super(...arguments), this.selectionUtils = new $e2ab202322af4e74$var$b();
    }
    /**
   * Available methods
   *
   * @returns {SelectionAPIInterface}
   */ get methods() {
        return {
            findParentTag: (e, t1)=>this.findParentTag(e, t1),
            expandToTag: (e)=>this.expandToTag(e),
            save: ()=>this.selectionUtils.save(),
            restore: ()=>this.selectionUtils.restore(),
            setFakeBackground: ()=>this.selectionUtils.setFakeBackground(),
            removeFakeBackground: ()=>this.selectionUtils.removeFakeBackground()
        };
    }
    /**
   * Looks ahead from selection and find passed tag with class name
   *
   * @param {string} tagName - tag to find
   * @param {string} className - tag's class name
   * @returns {HTMLElement|null}
   */ findParentTag(e, t1) {
        return this.selectionUtils.findParentTag(e, t1);
    }
    /**
   * Expand selection to passed tag
   *
   * @param {HTMLElement} node - tag that should contain selection
   */ expandToTag(e) {
        this.selectionUtils.expandToTag(e);
    }
}
class $e2ab202322af4e74$var$Ri extends $e2ab202322af4e74$var$E {
    /**
   * Available methods
   */ get methods() {
        return {
            getBlockTools: ()=>Array.from(this.Editor.Tools.blockTools.values())
        };
    }
}
class $e2ab202322af4e74$var$Di extends $e2ab202322af4e74$var$E {
    /**
   * Exported classes
   */ get classes() {
        return {
            /**
       * Base Block styles
       */ block: "cdx-block",
            /**
       * Inline Tools styles
       */ inlineToolButton: "ce-inline-tool",
            inlineToolButtonActive: "ce-inline-tool--active",
            /**
       * UI elements
       */ input: "cdx-input",
            loader: "cdx-loader",
            button: "cdx-button",
            /**
       * Settings styles
       */ settingsButton: "cdx-settings-button",
            settingsButtonActive: "cdx-settings-button--active"
        };
    }
}
class $e2ab202322af4e74$var$Fi extends $e2ab202322af4e74$var$E {
    /**
   * Available methods
   *
   * @returns {Toolbar}
   */ get methods() {
        return {
            close: ()=>this.close(),
            open: ()=>this.open(),
            toggleBlockSettings: (e)=>this.toggleBlockSettings(e),
            toggleToolbox: (e)=>this.toggleToolbox(e)
        };
    }
    /**
   * Open toolbar
   */ open() {
        this.Editor.Toolbar.moveAndOpen();
    }
    /**
   * Close toolbar and all included elements
   */ close() {
        this.Editor.Toolbar.close();
    }
    /**
   * Toggles Block Setting of the current block
   *
   * @param {boolean} openingState —  opening state of Block Setting
   */ toggleBlockSettings(e) {
        if (this.Editor.BlockManager.currentBlockIndex === -1) {
            $e2ab202322af4e74$var$X("Could't toggle the Toolbar because there is no block selected ", "warn");
            return;
        }
        e ?? !this.Editor.BlockSettings.opened ? (this.Editor.Toolbar.moveAndOpen(), this.Editor.BlockSettings.open()) : this.Editor.BlockSettings.close();
    }
    /**
   * Open toolbox
   *
   * @param {boolean} openingState - Opening state of toolbox
   */ toggleToolbox(e) {
        if (this.Editor.BlockManager.currentBlockIndex === -1) {
            $e2ab202322af4e74$var$X("Could't toggle the Toolbox because there is no block selected ", "warn");
            return;
        }
        e ?? !this.Editor.Toolbar.toolbox.opened ? (this.Editor.Toolbar.moveAndOpen(), this.Editor.Toolbar.toolbox.open()) : this.Editor.Toolbar.toolbox.close();
    }
}
var $e2ab202322af4e74$var$Vo = {
    exports: {}
};
/*!
 * CodeX.Tooltips
 * 
 * @version 1.0.5
 * 
 * @licence MIT
 * @author CodeX <https://codex.so>
 * 
 * 
 */ (function(n, e) {
    (function(t1, o) {
        n.exports = o();
    })(window, function() {
        return function(t1) {
            var o = {};
            function i(s) {
                if (o[s]) return o[s].exports;
                var r = o[s] = {
                    i: s,
                    l: !1,
                    exports: {}
                };
                return t1[s].call(r.exports, r, r.exports, i), r.l = !0, r.exports;
            }
            return i.m = t1, i.c = o, i.d = function(s, r, a) {
                i.o(s, r) || Object.defineProperty(s, r, {
                    enumerable: !0,
                    get: a
                });
            }, i.r = function(s) {
                typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, {
                    value: "Module"
                }), Object.defineProperty(s, "__esModule", {
                    value: !0
                });
            }, i.t = function(s, r) {
                if (1 & r && (s = i(s)), 8 & r || 4 & r && typeof s == "object" && s && s.__esModule) return s;
                var a = /* @__PURE__ */ Object.create(null);
                if (i.r(a), Object.defineProperty(a, "default", {
                    enumerable: !0,
                    value: s
                }), 2 & r && typeof s != "string") for(var l in s)i.d(a, l, (function(c) {
                    return s[c];
                }).bind(null, l));
                return a;
            }, i.n = function(s) {
                var r = s && s.__esModule ? function() {
                    return s.default;
                } : function() {
                    return s;
                };
                return i.d(r, "a", r), r;
            }, i.o = function(s, r) {
                return Object.prototype.hasOwnProperty.call(s, r);
            }, i.p = "", i(i.s = 0);
        }([
            function(t1, o, i) {
                t1.exports = i(1);
            },
            function(t1, o, i) {
                i.r(o), i.d(o, "default", function() {
                    return s;
                });
                class s {
                    constructor(){
                        this.nodes = {
                            wrapper: null,
                            content: null
                        }, this.showed = !1, this.offsetTop = 10, this.offsetLeft = 10, this.offsetRight = 10, this.hidingDelay = 0, this.handleWindowScroll = ()=>{
                            this.showed && this.hide(!0);
                        }, this.loadStyles(), this.prepare(), window.addEventListener("scroll", this.handleWindowScroll, {
                            passive: !0
                        });
                    }
                    get CSS() {
                        return {
                            tooltip: "ct",
                            tooltipContent: "ct__content",
                            tooltipShown: "ct--shown",
                            placement: {
                                left: "ct--left",
                                bottom: "ct--bottom",
                                right: "ct--right",
                                top: "ct--top"
                            }
                        };
                    }
                    show(a, l, c) {
                        this.nodes.wrapper || this.prepare(), this.hidingTimeout && clearTimeout(this.hidingTimeout);
                        const d = Object.assign({
                            placement: "bottom",
                            marginTop: 0,
                            marginLeft: 0,
                            marginRight: 0,
                            marginBottom: 0,
                            delay: 70,
                            hidingDelay: 0
                        }, c);
                        if (d.hidingDelay && (this.hidingDelay = d.hidingDelay), this.nodes.content.innerHTML = "", typeof l == "string") this.nodes.content.appendChild(document.createTextNode(l));
                        else {
                            if (!(l instanceof Node)) throw Error("[CodeX Tooltip] Wrong type of \xabcontent\xbb passed. It should be an instance of Node or String. But " + typeof l + " given.");
                            this.nodes.content.appendChild(l);
                        }
                        switch(this.nodes.wrapper.classList.remove(...Object.values(this.CSS.placement)), d.placement){
                            case "top":
                                this.placeTop(a, d);
                                break;
                            case "left":
                                this.placeLeft(a, d);
                                break;
                            case "right":
                                this.placeRight(a, d);
                                break;
                            case "bottom":
                            default:
                                this.placeBottom(a, d);
                        }
                        d && d.delay ? this.showingTimeout = setTimeout(()=>{
                            this.nodes.wrapper.classList.add(this.CSS.tooltipShown), this.showed = !0;
                        }, d.delay) : (this.nodes.wrapper.classList.add(this.CSS.tooltipShown), this.showed = !0);
                    }
                    hide(a = !1) {
                        if (this.hidingDelay && !a) return this.hidingTimeout && clearTimeout(this.hidingTimeout), void (this.hidingTimeout = setTimeout(()=>{
                            this.hide(!0);
                        }, this.hidingDelay));
                        this.nodes.wrapper.classList.remove(this.CSS.tooltipShown), this.showed = !1, this.showingTimeout && clearTimeout(this.showingTimeout);
                    }
                    onHover(a, l, c) {
                        a.addEventListener("mouseenter", ()=>{
                            this.show(a, l, c);
                        }), a.addEventListener("mouseleave", ()=>{
                            this.hide();
                        });
                    }
                    destroy() {
                        this.nodes.wrapper.remove(), window.removeEventListener("scroll", this.handleWindowScroll);
                    }
                    prepare() {
                        this.nodes.wrapper = this.make("div", this.CSS.tooltip), this.nodes.content = this.make("div", this.CSS.tooltipContent), this.append(this.nodes.wrapper, this.nodes.content), this.append(document.body, this.nodes.wrapper);
                    }
                    loadStyles() {
                        const a = "codex-tooltips-style";
                        if (document.getElementById(a)) return;
                        const l = i(2), c = this.make("style", null, {
                            textContent: l.toString(),
                            id: a
                        });
                        this.prepend(document.head, c);
                    }
                    placeBottom(a, l) {
                        const c = a.getBoundingClientRect(), d = c.left + a.clientWidth / 2 - this.nodes.wrapper.offsetWidth / 2, h = c.bottom + window.pageYOffset + this.offsetTop + l.marginTop;
                        this.applyPlacement("bottom", d, h);
                    }
                    placeTop(a, l) {
                        const c = a.getBoundingClientRect(), d = c.left + a.clientWidth / 2 - this.nodes.wrapper.offsetWidth / 2, h = c.top + window.pageYOffset - this.nodes.wrapper.clientHeight - this.offsetTop;
                        this.applyPlacement("top", d, h);
                    }
                    placeLeft(a, l) {
                        const c = a.getBoundingClientRect(), d = c.left - this.nodes.wrapper.offsetWidth - this.offsetLeft - l.marginLeft, h = c.top + window.pageYOffset + a.clientHeight / 2 - this.nodes.wrapper.offsetHeight / 2;
                        this.applyPlacement("left", d, h);
                    }
                    placeRight(a, l) {
                        const c = a.getBoundingClientRect(), d = c.right + this.offsetRight + l.marginRight, h = c.top + window.pageYOffset + a.clientHeight / 2 - this.nodes.wrapper.offsetHeight / 2;
                        this.applyPlacement("right", d, h);
                    }
                    applyPlacement(a, l, c) {
                        this.nodes.wrapper.classList.add(this.CSS.placement[a]), this.nodes.wrapper.style.left = l + "px", this.nodes.wrapper.style.top = c + "px";
                    }
                    make(a, l = null, c = {}) {
                        const d = document.createElement(a);
                        Array.isArray(l) ? d.classList.add(...l) : l && d.classList.add(l);
                        for(const h in c)c.hasOwnProperty(h) && (d[h] = c[h]);
                        return d;
                    }
                    append(a, l) {
                        Array.isArray(l) ? l.forEach((c)=>a.appendChild(c)) : a.appendChild(l);
                    }
                    prepend(a, l) {
                        Array.isArray(l) ? (l = l.reverse()).forEach((c)=>a.prepend(c)) : a.prepend(l);
                    }
                }
            },
            function(t1, o) {
                t1.exports = `.ct{z-index:999;opacity:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;pointer-events:none;-webkit-transition:opacity 50ms ease-in,-webkit-transform 70ms cubic-bezier(.215,.61,.355,1);transition:opacity 50ms ease-in,-webkit-transform 70ms cubic-bezier(.215,.61,.355,1);transition:opacity 50ms ease-in,transform 70ms cubic-bezier(.215,.61,.355,1);transition:opacity 50ms ease-in,transform 70ms cubic-bezier(.215,.61,.355,1),-webkit-transform 70ms cubic-bezier(.215,.61,.355,1);will-change:opacity,top,left;-webkit-box-shadow:0 8px 12px 0 rgba(29,32,43,.17),0 4px 5px -3px rgba(5,6,12,.49);box-shadow:0 8px 12px 0 rgba(29,32,43,.17),0 4px 5px -3px rgba(5,6,12,.49);border-radius:9px}.ct,.ct:before{position:absolute;top:0;left:0}.ct:before{content:"";bottom:0;right:0;background-color:#1d202b;z-index:-1;border-radius:4px}@supports(-webkit-mask-box-image:url("")){.ct:before{border-radius:0;-webkit-mask-box-image:url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M10.71 0h2.58c3.02 0 4.64.42 6.1 1.2a8.18 8.18 0 013.4 3.4C23.6 6.07 24 7.7 24 10.71v2.58c0 3.02-.42 4.64-1.2 6.1a8.18 8.18 0 01-3.4 3.4c-1.47.8-3.1 1.21-6.11 1.21H10.7c-3.02 0-4.64-.42-6.1-1.2a8.18 8.18 0 01-3.4-3.4C.4 17.93 0 16.3 0 13.29V10.7c0-3.02.42-4.64 1.2-6.1a8.18 8.18 0 013.4-3.4C6.07.4 7.7 0 10.71 0z"/></svg>') 48% 41% 37.9% 53.3%}}@media (--mobile){.ct{display:none}}.ct__content{padding:6px 10px;color:#cdd1e0;font-size:12px;text-align:center;letter-spacing:.02em;line-height:1em}.ct:after{content:"";width:8px;height:8px;position:absolute;background-color:#1d202b;z-index:-1}.ct--bottom{-webkit-transform:translateY(5px);transform:translateY(5px)}.ct--bottom:after{top:-3px;left:50%;-webkit-transform:translateX(-50%) rotate(-45deg);transform:translateX(-50%) rotate(-45deg)}.ct--top{-webkit-transform:translateY(-5px);transform:translateY(-5px)}.ct--top:after{top:auto;bottom:-3px;left:50%;-webkit-transform:translateX(-50%) rotate(-45deg);transform:translateX(-50%) rotate(-45deg)}.ct--left{-webkit-transform:translateX(-5px);transform:translateX(-5px)}.ct--left:after{top:50%;left:auto;right:0;-webkit-transform:translate(41.6%,-50%) rotate(-45deg);transform:translate(41.6%,-50%) rotate(-45deg)}.ct--right{-webkit-transform:translateX(5px);transform:translateX(5px)}.ct--right:after{top:50%;left:0;-webkit-transform:translate(-41.6%,-50%) rotate(-45deg);transform:translate(-41.6%,-50%) rotate(-45deg)}.ct--shown{opacity:1;-webkit-transform:none;transform:none}`;
            }
        ]).default;
    });
})($e2ab202322af4e74$var$Vo);
var $e2ab202322af4e74$var$ji = $e2ab202322af4e74$var$Vo.exports;
const $e2ab202322af4e74$var$Hi = /* @__PURE__ */ $e2ab202322af4e74$var$Ke($e2ab202322af4e74$var$ji);
let $e2ab202322af4e74$var$U = null;
function $e2ab202322af4e74$var$Et() {
    $e2ab202322af4e74$var$U || ($e2ab202322af4e74$var$U = new $e2ab202322af4e74$var$Hi());
}
function $e2ab202322af4e74$var$$i(n, e, t1) {
    $e2ab202322af4e74$var$Et(), $e2ab202322af4e74$var$U == null || $e2ab202322af4e74$var$U.show(n, e, t1);
}
function $e2ab202322af4e74$var$$e(n = !1) {
    $e2ab202322af4e74$var$Et(), $e2ab202322af4e74$var$U == null || $e2ab202322af4e74$var$U.hide(n);
}
function $e2ab202322af4e74$var$ze(n, e, t1) {
    $e2ab202322af4e74$var$Et(), $e2ab202322af4e74$var$U == null || $e2ab202322af4e74$var$U.onHover(n, e, t1);
}
function $e2ab202322af4e74$var$zi() {
    $e2ab202322af4e74$var$U == null || $e2ab202322af4e74$var$U.destroy(), $e2ab202322af4e74$var$U = null;
}
class $e2ab202322af4e74$var$Ui extends $e2ab202322af4e74$var$E {
    /**
   * @class
   * @param moduleConfiguration - Module Configuration
   * @param moduleConfiguration.config - Editor's config
   * @param moduleConfiguration.eventsDispatcher - Editor's event dispatcher
   */ constructor({ config: e, eventsDispatcher: t1 }){
        super({
            config: e,
            eventsDispatcher: t1
        });
    }
    /**
   * Available methods
   */ get methods() {
        return {
            show: (e, t1, o)=>this.show(e, t1, o),
            hide: ()=>this.hide(),
            onHover: (e, t1, o)=>this.onHover(e, t1, o)
        };
    }
    /**
   * Method show tooltip on element with passed HTML content
   *
   * @param {HTMLElement} element - element on which tooltip should be shown
   * @param {TooltipContent} content - tooltip content
   * @param {TooltipOptions} options - tooltip options
   */ show(e, t1, o) {
        $e2ab202322af4e74$var$$i(e, t1, o);
    }
    /**
   * Method hides tooltip on HTML page
   */ hide() {
        $e2ab202322af4e74$var$$e();
    }
    /**
   * Decorator for showing Tooltip by mouseenter/mouseleave
   *
   * @param {HTMLElement} element - element on which tooltip should be shown
   * @param {TooltipContent} content - tooltip content
   * @param {TooltipOptions} options - tooltip options
   */ onHover(e, t1, o) {
        $e2ab202322af4e74$var$ze(e, t1, o);
    }
}
class $e2ab202322af4e74$var$Wi extends $e2ab202322af4e74$var$E {
    /**
   * Available methods / getters
   */ get methods() {
        return {
            nodes: this.editorNodes
        };
    }
    /**
   * Exported classes
   */ get editorNodes() {
        return {
            /**
       * Top-level editor instance wrapper
       */ wrapper: this.Editor.UI.nodes.wrapper,
            /**
       * Element that holds all the Blocks
       */ redactor: this.Editor.UI.nodes.redactor
        };
    }
}
function $e2ab202322af4e74$var$qo(n, e) {
    const t1 = {};
    return Object.entries(n).forEach(([o, i])=>{
        if ($e2ab202322af4e74$var$D(i)) {
            const s = e ? `${e}.${o}` : o;
            Object.values(i).every((a)=>$e2ab202322af4e74$var$te(a)) ? t1[o] = s : t1[o] = $e2ab202322af4e74$var$qo(i, s);
            return;
        }
        t1[o] = i;
    }), t1;
}
const $e2ab202322af4e74$var$K = $e2ab202322af4e74$var$qo($e2ab202322af4e74$var$Fo);
function $e2ab202322af4e74$var$Yi(n, e) {
    const t1 = {};
    return Object.keys(n).forEach((o)=>{
        const i = e[o];
        i !== void 0 ? t1[i] = n[o] : t1[o] = n[o];
    }), t1;
}
const $e2ab202322af4e74$var$Zo = class Ee {
    /**
   * @param {HTMLElement[]} nodeList — the list of iterable HTML-items
   * @param {string} focusedCssClass - user-provided CSS-class that will be set in flipping process
   */ constructor(e, t1){
        this.cursor = -1, this.items = [], this.items = e || [], this.focusedCssClass = t1;
    }
    /**
   * Returns Focused button Node
   *
   * @returns {HTMLElement}
   */ get currentItem() {
        return this.cursor === -1 ? null : this.items[this.cursor];
    }
    /**
   * Sets cursor to specified position
   *
   * @param cursorPosition - new cursor position
   */ setCursor(e) {
        e < this.items.length && e >= -1 && (this.dropCursor(), this.cursor = e, this.items[this.cursor].classList.add(this.focusedCssClass));
    }
    /**
   * Sets items. Can be used when iterable items changed dynamically
   *
   * @param {HTMLElement[]} nodeList - nodes to iterate
   */ setItems(e) {
        this.items = e;
    }
    /**
   * Sets cursor next to the current
   */ next() {
        this.cursor = this.leafNodesAndReturnIndex(Ee.directions.RIGHT);
    }
    /**
   * Sets cursor before current
   */ previous() {
        this.cursor = this.leafNodesAndReturnIndex(Ee.directions.LEFT);
    }
    /**
   * Sets cursor to the default position and removes CSS-class from previously focused item
   */ dropCursor() {
        this.cursor !== -1 && (this.items[this.cursor].classList.remove(this.focusedCssClass), this.cursor = -1);
    }
    /**
   * Leafs nodes inside the target list from active element
   *
   * @param {string} direction - leaf direction. Can be 'left' or 'right'
   * @returns {number} index of focused node
   */ leafNodesAndReturnIndex(e) {
        if (this.items.length === 0) return this.cursor;
        let t1 = this.cursor;
        return t1 === -1 ? t1 = e === Ee.directions.RIGHT ? -1 : 0 : this.items[t1].classList.remove(this.focusedCssClass), e === Ee.directions.RIGHT ? t1 = (t1 + 1) % this.items.length : t1 = (this.items.length + t1 - 1) % this.items.length, $e2ab202322af4e74$var$u.canSetCaret(this.items[t1]) && $e2ab202322af4e74$var$Fe(()=>$e2ab202322af4e74$var$b.setCursor(this.items[t1]), 50)(), this.items[t1].classList.add(this.focusedCssClass), t1;
    }
};
$e2ab202322af4e74$var$Zo.directions = {
    RIGHT: "right",
    LEFT: "left"
};
let $e2ab202322af4e74$var$ke = $e2ab202322af4e74$var$Zo;
class $e2ab202322af4e74$var$ce {
    /**
   * @param options - different constructing settings
   */ constructor(e){
        this.iterator = null, this.activated = !1, this.flipCallbacks = [], this.onKeyDown = (t1)=>{
            if (!(!this.isEventReadyForHandling(t1) || t1.shiftKey === !0)) switch($e2ab202322af4e74$var$ce.usedKeys.includes(t1.keyCode) && t1.preventDefault(), t1.keyCode){
                case $e2ab202322af4e74$var$y.TAB:
                    this.handleTabPress(t1);
                    break;
                case $e2ab202322af4e74$var$y.LEFT:
                case $e2ab202322af4e74$var$y.UP:
                    this.flipLeft();
                    break;
                case $e2ab202322af4e74$var$y.RIGHT:
                case $e2ab202322af4e74$var$y.DOWN:
                    this.flipRight();
                    break;
                case $e2ab202322af4e74$var$y.ENTER:
                    this.handleEnterPress(t1);
                    break;
            }
        }, this.iterator = new $e2ab202322af4e74$var$ke(e.items, e.focusedItemClass), this.activateCallback = e.activateCallback, this.allowedKeys = e.allowedKeys || $e2ab202322af4e74$var$ce.usedKeys;
    }
    /**
   * True if flipper is currently activated
   */ get isActivated() {
        return this.activated;
    }
    /**
   * Array of keys (codes) that is handled by Flipper
   * Used to:
   *  - preventDefault only for this keys, not all keydowns (@see constructor)
   *  - to skip external behaviours only for these keys, when filler is activated (@see BlockEvents@arrowRightAndDown)
   */ static get usedKeys() {
        return [
            $e2ab202322af4e74$var$y.TAB,
            $e2ab202322af4e74$var$y.LEFT,
            $e2ab202322af4e74$var$y.RIGHT,
            $e2ab202322af4e74$var$y.ENTER,
            $e2ab202322af4e74$var$y.UP,
            $e2ab202322af4e74$var$y.DOWN
        ];
    }
    /**
   * Active tab/arrows handling by flipper
   *
   * @param items - Some modules (like, InlineToolbar, BlockSettings) might refresh buttons dynamically
   * @param cursorPosition - index of the item that should be focused once flipper is activated
   */ activate(e, t1) {
        this.activated = !0, e && this.iterator.setItems(e), t1 !== void 0 && this.iterator.setCursor(t1), document.addEventListener("keydown", this.onKeyDown, !0);
    }
    /**
   * Disable tab/arrows handling by flipper
   */ deactivate() {
        this.activated = !1, this.dropCursor(), document.removeEventListener("keydown", this.onKeyDown);
    }
    /**
   * Focus first item
   */ focusFirst() {
        this.dropCursor(), this.flipRight();
    }
    /**
   * Focuses previous flipper iterator item
   */ flipLeft() {
        this.iterator.previous(), this.flipCallback();
    }
    /**
   * Focuses next flipper iterator item
   */ flipRight() {
        this.iterator.next(), this.flipCallback();
    }
    /**
   * Return true if some button is focused
   */ hasFocus() {
        return !!this.iterator.currentItem;
    }
    /**
   * Registeres function that should be executed on each navigation action
   *
   * @param cb - function to execute
   */ onFlip(e) {
        this.flipCallbacks.push(e);
    }
    /**
   * Unregisteres function that is executed on each navigation action
   *
   * @param cb - function to stop executing
   */ removeOnFlip(e) {
        this.flipCallbacks = this.flipCallbacks.filter((t1)=>t1 !== e);
    }
    /**
   * Drops flipper's iterator cursor
   *
   * @see DomIterator#dropCursor
   */ dropCursor() {
        this.iterator.dropCursor();
    }
    /**
   * This function is fired before handling flipper keycodes
   * The result of this function defines if it is need to be handled or not
   *
   * @param {KeyboardEvent} event - keydown keyboard event
   * @returns {boolean}
   */ isEventReadyForHandling(e) {
        return this.activated && this.allowedKeys.includes(e.keyCode);
    }
    /**
   * When flipper is activated tab press will leaf the items
   *
   * @param {KeyboardEvent} event - tab keydown event
   */ handleTabPress(e) {
        switch(e.shiftKey ? $e2ab202322af4e74$var$ke.directions.LEFT : $e2ab202322af4e74$var$ke.directions.RIGHT){
            case $e2ab202322af4e74$var$ke.directions.RIGHT:
                this.flipRight();
                break;
            case $e2ab202322af4e74$var$ke.directions.LEFT:
                this.flipLeft();
                break;
        }
    }
    /**
   * Enter press will click current item if flipper is activated
   *
   * @param {KeyboardEvent} event - enter keydown event
   */ handleEnterPress(e) {
        this.activated && (this.iterator.currentItem && (e.stopPropagation(), e.preventDefault(), this.iterator.currentItem.click()), $e2ab202322af4e74$var$A(this.activateCallback) && this.activateCallback(this.iterator.currentItem));
    }
    /**
   * Fired after flipping in any direction
   */ flipCallback() {
        this.iterator.currentItem && this.iterator.currentItem.scrollIntoViewIfNeeded(), this.flipCallbacks.forEach((e)=>e());
    }
}
const $e2ab202322af4e74$var$Ki = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M9 12L9 7.1C9 7.04477 9.04477 7 9.1 7H10.4C11.5 7 14 7.1 14 9.5C14 9.5 14 12 11 12M9 12V16.8C9 16.9105 9.08954 17 9.2 17H12.5C14 17 15 16 15 14.5C15 11.7046 11 12 11 12M9 12H11"/></svg>', $e2ab202322af4e74$var$Xi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M7 10L11.8586 14.8586C11.9367 14.9367 12.0633 14.9367 12.1414 14.8586L17 10"/></svg>', $e2ab202322af4e74$var$Vi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M14.5 17.5L9.64142 12.6414C9.56331 12.5633 9.56331 12.4367 9.64142 12.3586L14.5 7.5"/></svg>', $e2ab202322af4e74$var$qi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M9.58284 17.5L14.4414 12.6414C14.5195 12.5633 14.5195 12.4367 14.4414 12.3586L9.58284 7.5"/></svg>', $e2ab202322af4e74$var$Zi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M7 15L11.8586 10.1414C11.9367 10.0633 12.0633 10.0633 12.1414 10.1414L17 15"/></svg>', $e2ab202322af4e74$var$Gi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M8 8L12 12M12 12L16 16M12 12L16 8M12 12L8 16"/></svg>', $e2ab202322af4e74$var$Qi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="12" r="4" stroke="currentColor" stroke-width="2"/></svg>', $e2ab202322af4e74$var$Ji = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M13.34 10C12.4223 12.7337 11 17 11 17"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M14.21 7H14.2"/></svg>', $e2ab202322af4e74$var$Co = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M7.69998 12.6L7.67896 12.62C6.53993 13.7048 6.52012 15.5155 7.63516 16.625V16.625C8.72293 17.7073 10.4799 17.7102 11.5712 16.6314L13.0263 15.193C14.0703 14.1609 14.2141 12.525 13.3662 11.3266L13.22 11.12"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M16.22 11.12L16.3564 10.9805C17.2895 10.0265 17.3478 8.5207 16.4914 7.49733V7.49733C15.5691 6.39509 13.9269 6.25143 12.8271 7.17675L11.3901 8.38588C10.0935 9.47674 9.95706 11.4241 11.0888 12.6852L11.12 12.72"/></svg>', $e2ab202322af4e74$var$es = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M9.40999 7.29999H9.4"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M14.6 7.29999H14.59"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M9.30999 12H9.3"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M14.6 12H14.59"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M9.40999 16.7H9.4"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M14.6 16.7H14.59"/></svg>', $e2ab202322af4e74$var$ts = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M12 7V12M12 17V12M17 12H12M12 12H7"/></svg>', $e2ab202322af4e74$var$Go = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M11.5 17.5L5 11M5 11V15.5M5 11H9.5"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M12.5 6.5L19 13M19 13V8.5M19 13H14.5"/></svg>', $e2ab202322af4e74$var$os = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><circle cx="10.5" cy="10.5" r="5.5" stroke="currentColor" stroke-width="2"/><line x1="15.4142" x2="19" y1="15" y2="18.5858" stroke="currentColor" stroke-linecap="round" stroke-width="2"/></svg>', $e2ab202322af4e74$var$ns = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M15.7795 11.5C15.7795 11.5 16.053 11.1962 16.5497 10.6722C17.4442 9.72856 17.4701 8.2475 16.5781 7.30145V7.30145C15.6482 6.31522 14.0873 6.29227 13.1288 7.25073L11.8796 8.49999"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M8.24517 12.3883C8.24517 12.3883 7.97171 12.6922 7.47504 13.2161C6.58051 14.1598 6.55467 15.6408 7.44666 16.5869V16.5869C8.37653 17.5731 9.93744 17.5961 10.8959 16.6376L12.1452 15.3883"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M17.7802 15.1032L16.597 14.9422C16.0109 14.8624 15.4841 15.3059 15.4627 15.8969L15.4199 17.0818"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M6.39064 9.03238L7.58432 9.06668C8.17551 9.08366 8.6522 8.58665 8.61056 7.99669L8.5271 6.81397"/><line x1="12.1142" x2="11.7" y1="12.2" y2="11.7858" stroke="currentColor" stroke-linecap="round" stroke-width="2"/></svg>', $e2ab202322af4e74$var$is = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><rect width="14" height="14" x="5" y="5" stroke="currentColor" stroke-width="2" rx="4"/><line x1="12" x2="12" y1="9" y2="12" stroke="currentColor" stroke-linecap="round" stroke-width="2"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M12 15.02V15.01"/></svg>', $e2ab202322af4e74$var$ss = "__", $e2ab202322af4e74$var$rs = "--";
function $e2ab202322af4e74$var$ne(n) {
    return (e, t1)=>[
            [
                n,
                e
            ].filter((i)=>!!i).join($e2ab202322af4e74$var$ss),
            t1
        ].filter((i)=>!!i).join($e2ab202322af4e74$var$rs);
}
const $e2ab202322af4e74$var$ye = $e2ab202322af4e74$var$ne("ce-hint"), $e2ab202322af4e74$var$we = {
    root: $e2ab202322af4e74$var$ye(),
    alignedStart: $e2ab202322af4e74$var$ye(null, "align-left"),
    alignedCenter: $e2ab202322af4e74$var$ye(null, "align-center"),
    title: $e2ab202322af4e74$var$ye("title"),
    description: $e2ab202322af4e74$var$ye("description")
};
class $e2ab202322af4e74$var$as {
    /**
   * Constructs the hint content instance
   *
   * @param params - hint content parameters
   */ constructor(e){
        this.nodes = {
            root: $e2ab202322af4e74$var$u.make("div", [
                $e2ab202322af4e74$var$we.root,
                e.alignment === "center" ? $e2ab202322af4e74$var$we.alignedCenter : $e2ab202322af4e74$var$we.alignedStart
            ]),
            title: $e2ab202322af4e74$var$u.make("div", $e2ab202322af4e74$var$we.title, {
                textContent: e.title
            })
        }, this.nodes.root.appendChild(this.nodes.title), e.description !== void 0 && (this.nodes.description = $e2ab202322af4e74$var$u.make("div", $e2ab202322af4e74$var$we.description, {
            textContent: e.description
        }), this.nodes.root.appendChild(this.nodes.description));
    }
    /**
   * Returns the root element of the hint content
   */ getElement() {
        return this.nodes.root;
    }
}
class $e2ab202322af4e74$var$xt {
    /**
   * Constructs the instance
   *
   * @param params - instance parameters
   */ constructor(e){
        this.params = e;
    }
    /**
   * Item name if exists
   */ get name() {
        if (this.params !== void 0 && "name" in this.params) return this.params.name;
    }
    /**
   * Destroys the instance
   */ destroy() {
        $e2ab202322af4e74$var$$e();
    }
    /**
   * Called when children popover is opened (if exists)
   */ onChildrenOpen() {
        var e;
        this.params !== void 0 && "children" in this.params && typeof ((e = this.params.children) == null ? void 0 : e.onOpen) == "function" && this.params.children.onOpen();
    }
    /**
   * Called when children popover is closed (if exists)
   */ onChildrenClose() {
        var e;
        this.params !== void 0 && "children" in this.params && typeof ((e = this.params.children) == null ? void 0 : e.onClose) == "function" && this.params.children.onClose();
    }
    /**
   * Called on popover item click
   */ handleClick() {
        var e, t1;
        this.params !== void 0 && "onActivate" in this.params && ((t1 = (e = this.params).onActivate) == null || t1.call(e, this.params));
    }
    /**
   * Adds hint to the item element if hint data is provided
   *
   * @param itemElement - popover item root element to add hint to
   * @param hintData - hint data
   */ addHint(e, t1) {
        const o = new $e2ab202322af4e74$var$as(t1);
        $e2ab202322af4e74$var$ze(e, o.getElement(), {
            placement: t1.position,
            hidingDelay: 100
        });
    }
    /**
   * Returns item children that are represented as popover items
   */ get children() {
        var e;
        return this.params !== void 0 && "children" in this.params && ((e = this.params.children) == null ? void 0 : e.items) !== void 0 ? this.params.children.items : [];
    }
    /**
   * Returns true if item has any type of children
   */ get hasChildren() {
        return this.children.length > 0;
    }
    /**
   * Returns true if item children should be open instantly after popover is opened and not on item click/hover
   */ get isChildrenOpen() {
        var e;
        return this.params !== void 0 && "children" in this.params && ((e = this.params.children) == null ? void 0 : e.isOpen) === !0;
    }
    /**
   * True if item children items should be navigatable via keyboard
   */ get isChildrenFlippable() {
        var e;
        return !(this.params === void 0 || !("children" in this.params) || ((e = this.params.children) == null ? void 0 : e.isFlippable) === !1);
    }
    /**
   * Returns true if item has children that should be searchable
   */ get isChildrenSearchable() {
        var e;
        return this.params !== void 0 && "children" in this.params && ((e = this.params.children) == null ? void 0 : e.searchable) === !0;
    }
    /**
   * True if popover should close once item is activated
   */ get closeOnActivate() {
        return this.params !== void 0 && "closeOnActivate" in this.params && this.params.closeOnActivate;
    }
    /**
   * True if item is active
   */ get isActive() {
        return this.params === void 0 || !("isActive" in this.params) ? !1 : typeof this.params.isActive == "function" ? this.params.isActive() : this.params.isActive === !0;
    }
}
const $e2ab202322af4e74$var$Y = $e2ab202322af4e74$var$ne("ce-popover-item"), $e2ab202322af4e74$var$L = {
    container: $e2ab202322af4e74$var$Y(),
    active: $e2ab202322af4e74$var$Y(null, "active"),
    disabled: $e2ab202322af4e74$var$Y(null, "disabled"),
    focused: $e2ab202322af4e74$var$Y(null, "focused"),
    hidden: $e2ab202322af4e74$var$Y(null, "hidden"),
    confirmationState: $e2ab202322af4e74$var$Y(null, "confirmation"),
    noHover: $e2ab202322af4e74$var$Y(null, "no-hover"),
    noFocus: $e2ab202322af4e74$var$Y(null, "no-focus"),
    title: $e2ab202322af4e74$var$Y("title"),
    secondaryTitle: $e2ab202322af4e74$var$Y("secondary-title"),
    icon: $e2ab202322af4e74$var$Y("icon"),
    iconTool: $e2ab202322af4e74$var$Y("icon", "tool"),
    iconChevronRight: $e2ab202322af4e74$var$Y("icon", "chevron-right"),
    wobbleAnimation: $e2ab202322af4e74$var$ne("wobble")()
};
class $e2ab202322af4e74$var$re extends $e2ab202322af4e74$var$xt {
    /**
   * Constructs popover item instance
   *
   * @param params - popover item construction params
   * @param renderParams - popover item render params.
   * The parameters that are not set by user via popover api but rather depend on technical implementation
   */ constructor(e, t1){
        super(e), this.params = e, this.nodes = {
            root: null,
            icon: null
        }, this.confirmationState = null, this.removeSpecialFocusBehavior = ()=>{
            var o;
            (o = this.nodes.root) == null || o.classList.remove($e2ab202322af4e74$var$L.noFocus);
        }, this.removeSpecialHoverBehavior = ()=>{
            var o;
            (o = this.nodes.root) == null || o.classList.remove($e2ab202322af4e74$var$L.noHover);
        }, this.onErrorAnimationEnd = ()=>{
            var o, i;
            (o = this.nodes.icon) == null || o.classList.remove($e2ab202322af4e74$var$L.wobbleAnimation), (i = this.nodes.icon) == null || i.removeEventListener("animationend", this.onErrorAnimationEnd);
        }, this.nodes.root = this.make(e, t1);
    }
    /**
   * True if item is disabled and hence not clickable
   */ get isDisabled() {
        return this.params.isDisabled === !0;
    }
    /**
   * Exposes popover item toggle parameter
   */ get toggle() {
        return this.params.toggle;
    }
    /**
   * Item title
   */ get title() {
        return this.params.title;
    }
    /**
   * True if confirmation state is enabled for popover item
   */ get isConfirmationStateEnabled() {
        return this.confirmationState !== null;
    }
    /**
   * True if item is focused in keyboard navigation process
   */ get isFocused() {
        return this.nodes.root === null ? !1 : this.nodes.root.classList.contains($e2ab202322af4e74$var$L.focused);
    }
    /**
   * Returns popover item root element
   */ getElement() {
        return this.nodes.root;
    }
    /**
   * Called on popover item click
   */ handleClick() {
        if (this.isConfirmationStateEnabled && this.confirmationState !== null) {
            this.activateOrEnableConfirmationMode(this.confirmationState);
            return;
        }
        this.activateOrEnableConfirmationMode(this.params);
    }
    /**
   * Toggles item active state
   *
   * @param isActive - true if item should strictly should become active
   */ toggleActive(e) {
        var t1;
        (t1 = this.nodes.root) == null || t1.classList.toggle($e2ab202322af4e74$var$L.active, e);
    }
    /**
   * Toggles item hidden state
   *
   * @param isHidden - true if item should be hidden
   */ toggleHidden(e) {
        var t1;
        (t1 = this.nodes.root) == null || t1.classList.toggle($e2ab202322af4e74$var$L.hidden, e);
    }
    /**
   * Resets popover item to its original state
   */ reset() {
        this.isConfirmationStateEnabled && this.disableConfirmationMode();
    }
    /**
   * Method called once item becomes focused during keyboard navigation
   */ onFocus() {
        this.disableSpecialHoverAndFocusBehavior();
    }
    /**
   * Constructs HTML element corresponding to popover item params
   *
   * @param params - item construction params
   * @param renderParams - popover item render params
   */ make(e, t1) {
        var s, r;
        const o = (t1 == null ? void 0 : t1.wrapperTag) || "div", i = $e2ab202322af4e74$var$u.make(o, $e2ab202322af4e74$var$L.container, {
            type: o === "button" ? "button" : void 0
        });
        return e.name && (i.dataset.itemName = e.name), this.nodes.icon = $e2ab202322af4e74$var$u.make("div", [
            $e2ab202322af4e74$var$L.icon,
            $e2ab202322af4e74$var$L.iconTool
        ], {
            innerHTML: e.icon || $e2ab202322af4e74$var$Qi
        }), i.appendChild(this.nodes.icon), e.title !== void 0 && i.appendChild($e2ab202322af4e74$var$u.make("div", $e2ab202322af4e74$var$L.title, {
            innerHTML: e.title || ""
        })), e.secondaryLabel && i.appendChild($e2ab202322af4e74$var$u.make("div", $e2ab202322af4e74$var$L.secondaryTitle, {
            textContent: e.secondaryLabel
        })), this.hasChildren && i.appendChild($e2ab202322af4e74$var$u.make("div", [
            $e2ab202322af4e74$var$L.icon,
            $e2ab202322af4e74$var$L.iconChevronRight
        ], {
            innerHTML: $e2ab202322af4e74$var$qi
        })), this.isActive && i.classList.add($e2ab202322af4e74$var$L.active), e.isDisabled && i.classList.add($e2ab202322af4e74$var$L.disabled), e.hint !== void 0 && ((s = t1 == null ? void 0 : t1.hint) == null ? void 0 : s.enabled) !== !1 && this.addHint(i, {
            ...e.hint,
            position: ((r = t1 == null ? void 0 : t1.hint) == null ? void 0 : r.position) || "right"
        }), i;
    }
    /**
   * Activates confirmation mode for the item.
   *
   * @param newState - new popover item params that should be applied
   */ enableConfirmationMode(e) {
        if (this.nodes.root === null) return;
        const t1 = {
            ...this.params,
            ...e,
            confirmation: "confirmation" in e ? e.confirmation : void 0
        }, o = this.make(t1);
        this.nodes.root.innerHTML = o.innerHTML, this.nodes.root.classList.add($e2ab202322af4e74$var$L.confirmationState), this.confirmationState = e, this.enableSpecialHoverAndFocusBehavior();
    }
    /**
   * Returns item to its original state
   */ disableConfirmationMode() {
        if (this.nodes.root === null) return;
        const e = this.make(this.params);
        this.nodes.root.innerHTML = e.innerHTML, this.nodes.root.classList.remove($e2ab202322af4e74$var$L.confirmationState), this.confirmationState = null, this.disableSpecialHoverAndFocusBehavior();
    }
    /**
   * Enables special focus and hover behavior for item in confirmation state.
   * This is needed to prevent item from being highlighted as hovered/focused just after click.
   */ enableSpecialHoverAndFocusBehavior() {
        var e, t1, o;
        (e = this.nodes.root) == null || e.classList.add($e2ab202322af4e74$var$L.noHover), (t1 = this.nodes.root) == null || t1.classList.add($e2ab202322af4e74$var$L.noFocus), (o = this.nodes.root) == null || o.addEventListener("mouseleave", this.removeSpecialHoverBehavior, {
            once: !0
        });
    }
    /**
   * Disables special focus and hover behavior
   */ disableSpecialHoverAndFocusBehavior() {
        var e;
        this.removeSpecialFocusBehavior(), this.removeSpecialHoverBehavior(), (e = this.nodes.root) == null || e.removeEventListener("mouseleave", this.removeSpecialHoverBehavior);
    }
    /**
   * Executes item's onActivate callback if the item has no confirmation configured
   *
   * @param item - item to activate or bring to confirmation mode
   */ activateOrEnableConfirmationMode(e) {
        var t1;
        if (!("confirmation" in e) || e.confirmation === void 0) try {
            (t1 = e.onActivate) == null || t1.call(e, e), this.disableConfirmationMode();
        } catch  {
            this.animateError();
        }
        else this.enableConfirmationMode(e.confirmation);
    }
    /**
   * Animates item which symbolizes that error occured while executing 'onActivate()' callback
   */ animateError() {
        var e, t1, o;
        (e = this.nodes.icon) != null && e.classList.contains($e2ab202322af4e74$var$L.wobbleAnimation) || ((t1 = this.nodes.icon) == null || t1.classList.add($e2ab202322af4e74$var$L.wobbleAnimation), (o = this.nodes.icon) == null || o.addEventListener("animationend", this.onErrorAnimationEnd));
    }
}
const $e2ab202322af4e74$var$nt = $e2ab202322af4e74$var$ne("ce-popover-item-separator"), $e2ab202322af4e74$var$it = {
    container: $e2ab202322af4e74$var$nt(),
    line: $e2ab202322af4e74$var$nt("line"),
    hidden: $e2ab202322af4e74$var$nt(null, "hidden")
};
class $e2ab202322af4e74$var$Qo extends $e2ab202322af4e74$var$xt {
    /**
   * Constructs the instance
   */ constructor(){
        super(), this.nodes = {
            root: $e2ab202322af4e74$var$u.make("div", $e2ab202322af4e74$var$it.container),
            line: $e2ab202322af4e74$var$u.make("div", $e2ab202322af4e74$var$it.line)
        }, this.nodes.root.appendChild(this.nodes.line);
    }
    /**
   * Returns popover separator root element
   */ getElement() {
        return this.nodes.root;
    }
    /**
   * Toggles item hidden state
   *
   * @param isHidden - true if item should be hidden
   */ toggleHidden(e) {
        var t1;
        (t1 = this.nodes.root) == null || t1.classList.toggle($e2ab202322af4e74$var$it.hidden, e);
    }
}
var $e2ab202322af4e74$var$G = /* @__PURE__ */ ((n)=>(n.Closed = "closed", n.ClosedOnActivate = "closed-on-activate", n))($e2ab202322af4e74$var$G || {});
const $e2ab202322af4e74$var$$ = $e2ab202322af4e74$var$ne("ce-popover"), $e2ab202322af4e74$var$P = {
    popover: $e2ab202322af4e74$var$$(),
    popoverContainer: $e2ab202322af4e74$var$$("container"),
    popoverOpenTop: $e2ab202322af4e74$var$$(null, "open-top"),
    popoverOpenLeft: $e2ab202322af4e74$var$$(null, "open-left"),
    popoverOpened: $e2ab202322af4e74$var$$(null, "opened"),
    search: $e2ab202322af4e74$var$$("search"),
    nothingFoundMessage: $e2ab202322af4e74$var$$("nothing-found-message"),
    nothingFoundMessageDisplayed: $e2ab202322af4e74$var$$("nothing-found-message", "displayed"),
    items: $e2ab202322af4e74$var$$("items"),
    overlay: $e2ab202322af4e74$var$$("overlay"),
    overlayHidden: $e2ab202322af4e74$var$$("overlay", "hidden"),
    popoverNested: $e2ab202322af4e74$var$$(null, "nested"),
    getPopoverNestedClass: (n)=>$e2ab202322af4e74$var$$(null, `nested-level-${n.toString()}`),
    popoverInline: $e2ab202322af4e74$var$$(null, "inline"),
    popoverHeader: $e2ab202322af4e74$var$$("header")
};
var $e2ab202322af4e74$var$fe = /* @__PURE__ */ ((n)=>(n.NestingLevel = "--nesting-level", n.PopoverHeight = "--popover-height", n.InlinePopoverWidth = "--inline-popover-width", n.TriggerItemLeft = "--trigger-item-left", n.TriggerItemTop = "--trigger-item-top", n))($e2ab202322af4e74$var$fe || {});
const $e2ab202322af4e74$var$To = $e2ab202322af4e74$var$ne("ce-popover-item-html"), $e2ab202322af4e74$var$So = {
    root: $e2ab202322af4e74$var$To(),
    hidden: $e2ab202322af4e74$var$To(null, "hidden")
};
class $e2ab202322af4e74$var$Se extends $e2ab202322af4e74$var$xt {
    /**
   * Constructs the instance
   *
   * @param params – instance parameters
   * @param renderParams – popover item render params.
   * The parameters that are not set by user via popover api but rather depend on technical implementation
   */ constructor(e, t1){
        var o, i;
        super(e), this.nodes = {
            root: $e2ab202322af4e74$var$u.make("div", $e2ab202322af4e74$var$So.root)
        }, this.nodes.root.appendChild(e.element), e.name && (this.nodes.root.dataset.itemName = e.name), e.hint !== void 0 && ((o = t1 == null ? void 0 : t1.hint) == null ? void 0 : o.enabled) !== !1 && this.addHint(this.nodes.root, {
            ...e.hint,
            position: ((i = t1 == null ? void 0 : t1.hint) == null ? void 0 : i.position) || "right"
        });
    }
    /**
   * Returns popover item root element
   */ getElement() {
        return this.nodes.root;
    }
    /**
   * Toggles item hidden state
   *
   * @param isHidden - true if item should be hidden
   */ toggleHidden(e) {
        var t1;
        (t1 = this.nodes.root) == null || t1.classList.toggle($e2ab202322af4e74$var$So.hidden, e);
    }
    /**
   * Returns list of buttons and inputs inside custom content
   */ getControls() {
        const e = this.nodes.root.querySelectorAll(`button, ${$e2ab202322af4e74$var$u.allInputsSelector}`);
        return Array.from(e);
    }
}
class $e2ab202322af4e74$var$Jo extends $e2ab202322af4e74$var$Oe {
    /**
   * Constructs the instance
   *
   * @param params - popover construction params
   * @param itemsRenderParams - popover item render params.
   * The parameters that are not set by user via popover api but rather depend on technical implementation
   */ constructor(e, t1 = {}){
        super(), this.params = e, this.itemsRenderParams = t1, this.listeners = new $e2ab202322af4e74$var$_e(), this.messages = {
            nothingFound: "Nothing found",
            search: "Search"
        }, this.items = this.buildItems(e.items), e.messages && (this.messages = {
            ...this.messages,
            ...e.messages
        }), this.nodes = {}, this.nodes.popoverContainer = $e2ab202322af4e74$var$u.make("div", [
            $e2ab202322af4e74$var$P.popoverContainer
        ]), this.nodes.nothingFoundMessage = $e2ab202322af4e74$var$u.make("div", [
            $e2ab202322af4e74$var$P.nothingFoundMessage
        ], {
            textContent: this.messages.nothingFound
        }), this.nodes.popoverContainer.appendChild(this.nodes.nothingFoundMessage), this.nodes.items = $e2ab202322af4e74$var$u.make("div", [
            $e2ab202322af4e74$var$P.items
        ]), this.items.forEach((o)=>{
            const i = o.getElement();
            i !== null && this.nodes.items.appendChild(i);
        }), this.nodes.popoverContainer.appendChild(this.nodes.items), this.listeners.on(this.nodes.popoverContainer, "click", (o)=>this.handleClick(o)), this.nodes.popover = $e2ab202322af4e74$var$u.make("div", [
            $e2ab202322af4e74$var$P.popover,
            this.params.class
        ]), this.nodes.popover.appendChild(this.nodes.popoverContainer);
    }
    /**
   * List of default popover items that are searchable and may have confirmation state
   */ get itemsDefault() {
        return this.items.filter((e)=>e instanceof $e2ab202322af4e74$var$re);
    }
    /**
   * Returns HTML element corresponding to the popover
   */ getElement() {
        return this.nodes.popover;
    }
    /**
   * Open popover
   */ show() {
        this.nodes.popover.classList.add($e2ab202322af4e74$var$P.popoverOpened), this.search !== void 0 && this.search.focus();
    }
    /**
   * Closes popover
   */ hide() {
        this.nodes.popover.classList.remove($e2ab202322af4e74$var$P.popoverOpened), this.nodes.popover.classList.remove($e2ab202322af4e74$var$P.popoverOpenTop), this.itemsDefault.forEach((e)=>e.reset()), this.search !== void 0 && this.search.clear(), this.emit($e2ab202322af4e74$var$G.Closed);
    }
    /**
   * Clears memory
   */ destroy() {
        var e;
        this.items.forEach((t1)=>t1.destroy()), this.nodes.popover.remove(), this.listeners.removeAll(), (e = this.search) == null || e.destroy();
    }
    /**
   * Looks for the item by name and imitates click on it
   *
   * @param name - name of the item to activate
   */ activateItemByName(e) {
        const t1 = this.items.find((o)=>o.name === e);
        this.handleItemClick(t1);
    }
    /**
   * Factory method for creating popover items
   *
   * @param items - list of items params
   */ buildItems(e) {
        return e.map((t1)=>{
            switch(t1.type){
                case $e2ab202322af4e74$var$_.Separator:
                    return new $e2ab202322af4e74$var$Qo();
                case $e2ab202322af4e74$var$_.Html:
                    return new $e2ab202322af4e74$var$Se(t1, this.itemsRenderParams[$e2ab202322af4e74$var$_.Html]);
                default:
                    return new $e2ab202322af4e74$var$re(t1, this.itemsRenderParams[$e2ab202322af4e74$var$_.Default]);
            }
        });
    }
    /**
   * Retrieves popover item that is the target of the specified event
   *
   * @param event - event to retrieve popover item from
   */ getTargetItem(e) {
        return this.items.filter((t1)=>t1 instanceof $e2ab202322af4e74$var$re || t1 instanceof $e2ab202322af4e74$var$Se).find((t1)=>{
            const o = t1.getElement();
            return o === null ? !1 : e.composedPath().includes(o);
        });
    }
    /**
   * Handles popover item click
   *
   * @param item - item to handle click of
   */ handleItemClick(e) {
        if (!("isDisabled" in e && e.isDisabled)) {
            if (e.hasChildren) {
                this.showNestedItems(e), "handleClick" in e && typeof e.handleClick == "function" && e.handleClick();
                return;
            }
            this.itemsDefault.filter((t1)=>t1 !== e).forEach((t1)=>t1.reset()), "handleClick" in e && typeof e.handleClick == "function" && e.handleClick(), this.toggleItemActivenessIfNeeded(e), e.closeOnActivate && (this.hide(), this.emit($e2ab202322af4e74$var$G.ClosedOnActivate));
        }
    }
    /**
   * Handles clicks inside popover
   *
   * @param event - item to handle click of
   */ handleClick(e) {
        const t1 = this.getTargetItem(e);
        t1 !== void 0 && this.handleItemClick(t1);
    }
    /**
   * - Toggles item active state, if clicked popover item has property 'toggle' set to true.
   *
   * - Performs radiobutton-like behavior if the item has property 'toggle' set to string key.
   * (All the other items with the same key get inactive, and the item gets active)
   *
   * @param clickedItem - popover item that was clicked
   */ toggleItemActivenessIfNeeded(e) {
        if (e instanceof $e2ab202322af4e74$var$re && (e.toggle === !0 && e.toggleActive(), typeof e.toggle == "string")) {
            const t1 = this.itemsDefault.filter((o)=>o.toggle === e.toggle);
            if (t1.length === 1) {
                e.toggleActive();
                return;
            }
            t1.forEach((o)=>{
                o.toggleActive(o === e);
            });
        }
    }
}
var $e2ab202322af4e74$var$Ue = /* @__PURE__ */ ((n)=>(n.Search = "search", n))($e2ab202322af4e74$var$Ue || {});
const $e2ab202322af4e74$var$st = $e2ab202322af4e74$var$ne("cdx-search-field"), $e2ab202322af4e74$var$rt = {
    wrapper: $e2ab202322af4e74$var$st(),
    icon: $e2ab202322af4e74$var$st("icon"),
    input: $e2ab202322af4e74$var$st("input")
};
class $e2ab202322af4e74$var$ls extends $e2ab202322af4e74$var$Oe {
    /**
   * @param options - available config
   * @param options.items - searchable items list
   * @param options.placeholder - input placeholder
   */ constructor({ items: e, placeholder: t1 }){
        super(), this.listeners = new $e2ab202322af4e74$var$_e(), this.items = e, this.wrapper = $e2ab202322af4e74$var$u.make("div", $e2ab202322af4e74$var$rt.wrapper);
        const o = $e2ab202322af4e74$var$u.make("div", $e2ab202322af4e74$var$rt.icon, {
            innerHTML: $e2ab202322af4e74$var$os
        });
        this.input = $e2ab202322af4e74$var$u.make("input", $e2ab202322af4e74$var$rt.input, {
            placeholder: t1,
            /**
       * Used to prevent focusing on the input by Tab key
       * (Popover in the Toolbar lays below the blocks,
       * so Tab in the last block will focus this hidden input if this property is not set)
       */ tabIndex: -1
        }), this.wrapper.appendChild(o), this.wrapper.appendChild(this.input), this.listeners.on(this.input, "input", ()=>{
            this.searchQuery = this.input.value, this.emit($e2ab202322af4e74$var$Ue.Search, {
                query: this.searchQuery,
                items: this.foundItems
            });
        });
    }
    /**
   * Returns search field element
   */ getElement() {
        return this.wrapper;
    }
    /**
   * Sets focus to the input
   */ focus() {
        this.input.focus();
    }
    /**
   * Clears search query and results
   */ clear() {
        this.input.value = "", this.searchQuery = "", this.emit($e2ab202322af4e74$var$Ue.Search, {
            query: "",
            items: this.foundItems
        });
    }
    /**
   * Clears memory
   */ destroy() {
        this.listeners.removeAll();
    }
    /**
   * Returns list of found items for the current search query
   */ get foundItems() {
        return this.items.filter((e)=>this.checkItem(e));
    }
    /**
   * Contains logic for checking whether passed item conforms the search query
   *
   * @param item - item to be checked
   */ checkItem(e) {
        var i, s;
        const t1 = ((i = e.title) == null ? void 0 : i.toLowerCase()) || "", o = (s = this.searchQuery) == null ? void 0 : s.toLowerCase();
        return o !== void 0 ? t1.includes(o) : !1;
    }
}
var $e2ab202322af4e74$var$cs = Object.defineProperty, $e2ab202322af4e74$var$ds = Object.getOwnPropertyDescriptor, $e2ab202322af4e74$var$us = (n, e, t1, o)=>{
    for(var i = o > 1 ? void 0 : o ? $e2ab202322af4e74$var$ds(e, t1) : e, s = n.length - 1, r; s >= 0; s--)(r = n[s]) && (i = (o ? r(e, t1, i) : r(i)) || i);
    return o && i && $e2ab202322af4e74$var$cs(e, t1, i), i;
};
const $e2ab202322af4e74$var$en = class tn extends $e2ab202322af4e74$var$Jo {
    /**
   * Construct the instance
   *
   * @param params - popover params
   * @param itemsRenderParams – popover item render params.
   * The parameters that are not set by user via popover api but rather depend on technical implementation
   */ constructor(e, t1){
        super(e, t1), this.nestingLevel = 0, this.nestedPopoverTriggerItem = null, this.previouslyHoveredItem = null, this.scopeElement = document.body, this.hide = ()=>{
            var o;
            super.hide(), this.destroyNestedPopoverIfExists(), (o = this.flipper) == null || o.deactivate(), this.previouslyHoveredItem = null;
        }, this.onFlip = ()=>{
            const o = this.itemsDefault.find((i)=>i.isFocused);
            o == null || o.onFocus();
        }, this.onSearch = (o)=>{
            var a;
            const i = o.query === "", s = o.items.length === 0;
            this.items.forEach((l)=>{
                let c = !1;
                l instanceof $e2ab202322af4e74$var$re ? c = !o.items.includes(l) : (l instanceof $e2ab202322af4e74$var$Qo || l instanceof $e2ab202322af4e74$var$Se) && (c = s || !i), l.toggleHidden(c);
            }), this.toggleNothingFoundMessage(s);
            const r = o.query === "" ? this.flippableElements : o.items.map((l)=>l.getElement());
            (a = this.flipper) != null && a.isActivated && (this.flipper.deactivate(), this.flipper.activate(r));
        }, e.nestingLevel !== void 0 && (this.nestingLevel = e.nestingLevel), this.nestingLevel > 0 && this.nodes.popover.classList.add($e2ab202322af4e74$var$P.popoverNested), e.scopeElement !== void 0 && (this.scopeElement = e.scopeElement), this.nodes.popoverContainer !== null && this.listeners.on(this.nodes.popoverContainer, "mouseover", (o)=>this.handleHover(o)), e.searchable && this.addSearch(), e.flippable !== !1 && (this.flipper = new $e2ab202322af4e74$var$ce({
            items: this.flippableElements,
            focusedItemClass: $e2ab202322af4e74$var$L.focused,
            allowedKeys: [
                $e2ab202322af4e74$var$y.TAB,
                $e2ab202322af4e74$var$y.UP,
                $e2ab202322af4e74$var$y.DOWN,
                $e2ab202322af4e74$var$y.ENTER
            ]
        }), this.flipper.onFlip(this.onFlip));
    }
    /**
   * Returns true if some item inside popover is focused
   */ hasFocus() {
        return this.flipper === void 0 ? !1 : this.flipper.hasFocus();
    }
    /**
   * Scroll position inside items container of the popover
   */ get scrollTop() {
        return this.nodes.items === null ? 0 : this.nodes.items.scrollTop;
    }
    /**
   * Returns visible element offset top
   */ get offsetTop() {
        return this.nodes.popoverContainer === null ? 0 : this.nodes.popoverContainer.offsetTop;
    }
    /**
   * Open popover
   */ show() {
        var e;
        this.nodes.popover.style.setProperty($e2ab202322af4e74$var$fe.PopoverHeight, this.size.height + "px"), this.shouldOpenBottom || this.nodes.popover.classList.add($e2ab202322af4e74$var$P.popoverOpenTop), this.shouldOpenRight || this.nodes.popover.classList.add($e2ab202322af4e74$var$P.popoverOpenLeft), super.show(), (e = this.flipper) == null || e.activate(this.flippableElements);
    }
    /**
   * Clears memory
   */ destroy() {
        this.hide(), super.destroy();
    }
    /**
   * Handles displaying nested items for the item.
   *
   * @param item – item to show nested popover for
   */ showNestedItems(e) {
        this.nestedPopover !== null && this.nestedPopover !== void 0 || (this.nestedPopoverTriggerItem = e, this.showNestedPopoverForItem(e));
    }
    /**
   * Handles hover events inside popover items container
   *
   * @param event - hover event data
   */ handleHover(e) {
        const t1 = this.getTargetItem(e);
        t1 !== void 0 && this.previouslyHoveredItem !== t1 && (this.destroyNestedPopoverIfExists(), this.previouslyHoveredItem = t1, t1.hasChildren && this.showNestedPopoverForItem(t1));
    }
    /**
   * Sets CSS variable with position of item near which nested popover should be displayed.
   * Is used for correct positioning of the nested popover
   *
   * @param nestedPopoverEl - nested popover element
   * @param item – item near which nested popover should be displayed
   */ setTriggerItemPosition(e, t1) {
        const o = t1.getElement(), i = (o ? o.offsetTop : 0) - this.scrollTop, s = this.offsetTop + i;
        e.style.setProperty($e2ab202322af4e74$var$fe.TriggerItemTop, s + "px");
    }
    /**
   * Destroys existing nested popover
   */ destroyNestedPopoverIfExists() {
        var e, t1;
        this.nestedPopover === void 0 || this.nestedPopover === null || (this.nestedPopover.off($e2ab202322af4e74$var$G.ClosedOnActivate, this.hide), this.nestedPopover.hide(), this.nestedPopover.destroy(), this.nestedPopover.getElement().remove(), this.nestedPopover = null, (e = this.flipper) == null || e.activate(this.flippableElements), (t1 = this.nestedPopoverTriggerItem) == null || t1.onChildrenClose());
    }
    /**
   * Creates and displays nested popover for specified item.
   * Is used only on desktop
   *
   * @param item - item to display nested popover by
   */ showNestedPopoverForItem(e) {
        var o;
        this.nestedPopover = new tn({
            searchable: e.isChildrenSearchable,
            items: e.children,
            nestingLevel: this.nestingLevel + 1,
            flippable: e.isChildrenFlippable,
            messages: this.messages
        }), e.onChildrenOpen(), this.nestedPopover.on($e2ab202322af4e74$var$G.ClosedOnActivate, this.hide);
        const t1 = this.nestedPopover.getElement();
        return this.nodes.popover.appendChild(t1), this.setTriggerItemPosition(t1, e), t1.style.setProperty($e2ab202322af4e74$var$fe.NestingLevel, this.nestedPopover.nestingLevel.toString()), this.nestedPopover.show(), (o = this.flipper) == null || o.deactivate(), this.nestedPopover;
    }
    /**
   * Checks if popover should be opened bottom.
   * It should happen when there is enough space below or not enough space above
   */ get shouldOpenBottom() {
        if (this.nodes.popover === void 0 || this.nodes.popover === null) return !1;
        const e = this.nodes.popoverContainer.getBoundingClientRect(), t1 = this.scopeElement.getBoundingClientRect(), o = this.size.height, i = e.top + o, s = e.top - o, r = Math.min(window.innerHeight, t1.bottom);
        return s < t1.top || i <= r;
    }
    /**
   * Checks if popover should be opened left.
   * It should happen when there is enough space in the right or not enough space in the left
   */ get shouldOpenRight() {
        if (this.nodes.popover === void 0 || this.nodes.popover === null) return !1;
        const e = this.nodes.popover.getBoundingClientRect(), t1 = this.scopeElement.getBoundingClientRect(), o = this.size.width, i = e.right + o, s = e.left - o, r = Math.min(window.innerWidth, t1.right);
        return s < t1.left || i <= r;
    }
    get size() {
        var i;
        const e = {
            height: 0,
            width: 0
        };
        if (this.nodes.popover === null) return e;
        const t1 = this.nodes.popover.cloneNode(!0);
        t1.style.visibility = "hidden", t1.style.position = "absolute", t1.style.top = "-1000px", t1.classList.add($e2ab202322af4e74$var$P.popoverOpened), (i = t1.querySelector("." + $e2ab202322af4e74$var$P.popoverNested)) == null || i.remove(), document.body.appendChild(t1);
        const o = t1.querySelector("." + $e2ab202322af4e74$var$P.popoverContainer);
        return e.height = o.offsetHeight, e.width = o.offsetWidth, t1.remove(), e;
    }
    /**
   * Returns list of elements available for keyboard navigation.
   */ get flippableElements() {
        return this.items.map((t1)=>{
            if (t1 instanceof $e2ab202322af4e74$var$re) return t1.getElement();
            if (t1 instanceof $e2ab202322af4e74$var$Se) return t1.getControls();
        }).flat().filter((t1)=>t1 != null);
    }
    /**
   * Adds search to the popover
   */ addSearch() {
        this.search = new $e2ab202322af4e74$var$ls({
            items: this.itemsDefault,
            placeholder: this.messages.search
        }), this.search.on($e2ab202322af4e74$var$Ue.Search, this.onSearch);
        const e = this.search.getElement();
        e.classList.add($e2ab202322af4e74$var$P.search), this.nodes.popoverContainer.insertBefore(e, this.nodes.popoverContainer.firstChild);
    }
    /**
   * Toggles nothing found message visibility
   *
   * @param isDisplayed - true if the message should be displayed
   */ toggleNothingFoundMessage(e) {
        this.nodes.nothingFoundMessage.classList.toggle($e2ab202322af4e74$var$P.nothingFoundMessageDisplayed, e);
    }
};
$e2ab202322af4e74$var$us([
    $e2ab202322af4e74$var$me
], $e2ab202322af4e74$var$en.prototype, "size", 1);
let $e2ab202322af4e74$var$Bt = $e2ab202322af4e74$var$en;
class $e2ab202322af4e74$var$hs extends $e2ab202322af4e74$var$Bt {
    /**
   * Constructs the instance
   *
   * @param params - instance parameters
   */ constructor(e){
        const t1 = !$e2ab202322af4e74$var$be();
        super({
            ...e,
            class: $e2ab202322af4e74$var$P.popoverInline
        }, {
            [$e2ab202322af4e74$var$_.Default]: {
                /**
           * We use button instead of div here to fix bug associated with focus loss (which leads to selection change) on click in safari
           *
           * @todo figure out better way to solve the issue
           */ wrapperTag: "button",
                hint: {
                    position: "top",
                    alignment: "center",
                    enabled: t1
                }
            },
            [$e2ab202322af4e74$var$_.Html]: {
                hint: {
                    position: "top",
                    alignment: "center",
                    enabled: t1
                }
            }
        }), this.items.forEach((o)=>{
            !(o instanceof $e2ab202322af4e74$var$re) && !(o instanceof $e2ab202322af4e74$var$Se) || o.hasChildren && o.isChildrenOpen && this.showNestedItems(o);
        });
    }
    /**
   * Returns visible element offset top
   */ get offsetLeft() {
        return this.nodes.popoverContainer === null ? 0 : this.nodes.popoverContainer.offsetLeft;
    }
    /**
   * Open popover
   */ show() {
        this.nestingLevel === 0 && this.nodes.popover.style.setProperty($e2ab202322af4e74$var$fe.InlinePopoverWidth, this.size.width + "px"), super.show();
    }
    /**
   * Disable hover event handling.
   * Overrides parent's class behavior
   */ handleHover() {}
    /**
   * Sets CSS variable with position of item near which nested popover should be displayed.
   * Is used to position nested popover right below clicked item
   *
   * @param nestedPopoverEl - nested popover element
   * @param item – item near which nested popover should be displayed
   */ setTriggerItemPosition(e, t1) {
        const o = t1.getElement(), i = o ? o.offsetLeft : 0, s = this.offsetLeft + i;
        e.style.setProperty($e2ab202322af4e74$var$fe.TriggerItemLeft, s + "px");
    }
    /**
   * Handles displaying nested items for the item.
   * Overriding in order to add toggling behaviour
   *
   * @param item – item to toggle nested popover for
   */ showNestedItems(e) {
        if (this.nestedPopoverTriggerItem === e) {
            this.destroyNestedPopoverIfExists(), this.nestedPopoverTriggerItem = null;
            return;
        }
        super.showNestedItems(e);
    }
    /**
   * Creates and displays nested popover for specified item.
   * Is used only on desktop
   *
   * @param item - item to display nested popover by
   */ showNestedPopoverForItem(e) {
        const t1 = super.showNestedPopoverForItem(e);
        return t1.getElement().classList.add($e2ab202322af4e74$var$P.getPopoverNestedClass(t1.nestingLevel)), t1;
    }
    /**
   * Overrides default item click handling.
   * Helps to close nested popover once other item is clicked.
   *
   * @param item - clicked item
   */ handleItemClick(e) {
        var t1;
        e !== this.nestedPopoverTriggerItem && ((t1 = this.nestedPopoverTriggerItem) == null || t1.handleClick(), super.destroyNestedPopoverIfExists()), super.handleItemClick(e);
    }
}
const $e2ab202322af4e74$var$on = class xe {
    constructor(){
        this.scrollPosition = null;
    }
    /**
   * Locks body element scroll
   */ lock() {
        $e2ab202322af4e74$var$pt ? this.lockHard() : document.body.classList.add(xe.CSS.scrollLocked);
    }
    /**
   * Unlocks body element scroll
   */ unlock() {
        $e2ab202322af4e74$var$pt ? this.unlockHard() : document.body.classList.remove(xe.CSS.scrollLocked);
    }
    /**
   * Locks scroll in a hard way (via setting fixed position to body element)
   */ lockHard() {
        this.scrollPosition = window.pageYOffset, document.documentElement.style.setProperty("--window-scroll-offset", `${this.scrollPosition}px`), document.body.classList.add(xe.CSS.scrollLockedHard);
    }
    /**
   * Unlocks hard scroll lock
   */ unlockHard() {
        document.body.classList.remove(xe.CSS.scrollLockedHard), this.scrollPosition !== null && window.scrollTo(0, this.scrollPosition), this.scrollPosition = null;
    }
};
$e2ab202322af4e74$var$on.CSS = {
    scrollLocked: "ce-scroll-locked",
    scrollLockedHard: "ce-scroll-locked--hard"
};
let $e2ab202322af4e74$var$ps = $e2ab202322af4e74$var$on;
const $e2ab202322af4e74$var$at = $e2ab202322af4e74$var$ne("ce-popover-header"), $e2ab202322af4e74$var$lt = {
    root: $e2ab202322af4e74$var$at(),
    text: $e2ab202322af4e74$var$at("text"),
    backButton: $e2ab202322af4e74$var$at("back-button")
};
class $e2ab202322af4e74$var$fs {
    /**
   * Constructs the instance
   *
   * @param params - popover header params
   */ constructor({ text: e, onBackButtonClick: t1 }){
        this.listeners = new $e2ab202322af4e74$var$_e(), this.text = e, this.onBackButtonClick = t1, this.nodes = {
            root: $e2ab202322af4e74$var$u.make("div", [
                $e2ab202322af4e74$var$lt.root
            ]),
            backButton: $e2ab202322af4e74$var$u.make("button", [
                $e2ab202322af4e74$var$lt.backButton
            ]),
            text: $e2ab202322af4e74$var$u.make("div", [
                $e2ab202322af4e74$var$lt.text
            ])
        }, this.nodes.backButton.innerHTML = $e2ab202322af4e74$var$Vi, this.nodes.root.appendChild(this.nodes.backButton), this.listeners.on(this.nodes.backButton, "click", this.onBackButtonClick), this.nodes.text.innerText = this.text, this.nodes.root.appendChild(this.nodes.text);
    }
    /**
   * Returns popover header root html element
   */ getElement() {
        return this.nodes.root;
    }
    /**
   * Destroys the instance
   */ destroy() {
        this.nodes.root.remove(), this.listeners.destroy();
    }
}
class $e2ab202322af4e74$var$gs {
    constructor(){
        this.history = [];
    }
    /**
   * Push new popover state
   *
   * @param state - new state
   */ push(e) {
        this.history.push(e);
    }
    /**
   * Pop last popover state
   */ pop() {
        return this.history.pop();
    }
    /**
   * Title retrieved from the current state
   */ get currentTitle() {
        return this.history.length === 0 ? "" : this.history[this.history.length - 1].title;
    }
    /**
   * Items list retrieved from the current state
   */ get currentItems() {
        return this.history.length === 0 ? [] : this.history[this.history.length - 1].items;
    }
    /**
   * Returns history to initial popover state
   */ reset() {
        for(; this.history.length > 1;)this.pop();
    }
}
class $e2ab202322af4e74$var$nn extends $e2ab202322af4e74$var$Jo {
    /**
   * Construct the instance
   *
   * @param params - popover params
   */ constructor(e){
        super(e, {
            [$e2ab202322af4e74$var$_.Default]: {
                hint: {
                    enabled: !1
                }
            },
            [$e2ab202322af4e74$var$_.Html]: {
                hint: {
                    enabled: !1
                }
            }
        }), this.scrollLocker = new $e2ab202322af4e74$var$ps(), this.history = new $e2ab202322af4e74$var$gs(), this.isHidden = !0, this.nodes.overlay = $e2ab202322af4e74$var$u.make("div", [
            $e2ab202322af4e74$var$P.overlay,
            $e2ab202322af4e74$var$P.overlayHidden
        ]), this.nodes.popover.insertBefore(this.nodes.overlay, this.nodes.popover.firstChild), this.listeners.on(this.nodes.overlay, "click", ()=>{
            this.hide();
        }), this.history.push({
            items: e.items
        });
    }
    /**
   * Open popover
   */ show() {
        this.nodes.overlay.classList.remove($e2ab202322af4e74$var$P.overlayHidden), super.show(), this.scrollLocker.lock(), this.isHidden = !1;
    }
    /**
   * Closes popover
   */ hide() {
        this.isHidden || (super.hide(), this.nodes.overlay.classList.add($e2ab202322af4e74$var$P.overlayHidden), this.scrollLocker.unlock(), this.history.reset(), this.isHidden = !0);
    }
    /**
   * Clears memory
   */ destroy() {
        super.destroy(), this.scrollLocker.unlock();
    }
    /**
   * Handles displaying nested items for the item
   *
   * @param item – item to show nested popover for
   */ showNestedItems(e) {
        this.updateItemsAndHeader(e.children, e.title), this.history.push({
            title: e.title,
            items: e.children
        });
    }
    /**
   * Removes rendered popover items and header and displays new ones
   *
   * @param items - new popover items
   * @param title - new popover header text
   */ updateItemsAndHeader(e, t1) {
        if (this.header !== null && this.header !== void 0 && (this.header.destroy(), this.header = null), t1 !== void 0) {
            this.header = new $e2ab202322af4e74$var$fs({
                text: t1,
                onBackButtonClick: ()=>{
                    this.history.pop(), this.updateItemsAndHeader(this.history.currentItems, this.history.currentTitle);
                }
            });
            const o = this.header.getElement();
            o !== null && this.nodes.popoverContainer.insertBefore(o, this.nodes.popoverContainer.firstChild);
        }
        this.items.forEach((o)=>{
            var i;
            return (i = o.getElement()) == null ? void 0 : i.remove();
        }), this.items = this.buildItems(e), this.items.forEach((o)=>{
            var s;
            const i = o.getElement();
            i !== null && ((s = this.nodes.items) == null || s.appendChild(i));
        });
    }
}
class $e2ab202322af4e74$var$ms extends $e2ab202322af4e74$var$E {
    constructor(){
        super(...arguments), this.opened = !1, this.hasMobileLayoutToggleListener = !1, this.selection = new $e2ab202322af4e74$var$b(), this.popover = null, this.close = ()=>{
            this.opened && (this.opened = !1, $e2ab202322af4e74$var$b.isAtEditor || this.selection.restore(), this.selection.clearSaved(), !this.Editor.CrossBlockSelection.isCrossBlockSelectionStarted && this.Editor.BlockManager.currentBlock && this.Editor.BlockSelection.unselectBlock(this.Editor.BlockManager.currentBlock), this.eventsDispatcher.emit(this.events.closed), this.popover && (this.popover.off($e2ab202322af4e74$var$G.Closed, this.onPopoverClose), this.popover.destroy(), this.popover.getElement().remove(), this.popover = null));
        }, this.onPopoverClose = ()=>{
            this.close();
        };
    }
    /**
   * Module Events
   */ get events() {
        return {
            opened: "block-settings-opened",
            closed: "block-settings-closed"
        };
    }
    /**
   * Block Settings CSS
   */ get CSS() {
        return {
            settings: "ce-settings"
        };
    }
    /**
   * Getter for inner popover's flipper instance
   *
   * @todo remove once BlockSettings becomes standalone non-module class
   */ get flipper() {
        var e;
        if (this.popover !== null) return "flipper" in this.popover ? (e = this.popover) == null ? void 0 : e.flipper : void 0;
    }
    /**
   * Panel with block settings with 2 sections:
   *  - Tool's Settings
   *  - Default Settings [Move, Remove, etc]
   */ make() {
        this.nodes.wrapper = $e2ab202322af4e74$var$u.make("div", [
            this.CSS.settings
        ]), this.eventsDispatcher.on($e2ab202322af4e74$var$Te, this.close), this.hasMobileLayoutToggleListener = !0;
    }
    /**
   * Destroys module
   */ destroy() {
        this.removeAllNodes(), this.listeners.destroy(), this.hasMobileLayoutToggleListener && (this.eventsDispatcher.off($e2ab202322af4e74$var$Te, this.close), this.hasMobileLayoutToggleListener = !1);
    }
    /**
   * Open Block Settings pane
   *
   * @param targetBlock - near which Block we should open BlockSettings
   */ async open(e = this.Editor.BlockManager.currentBlock) {
        var s;
        this.opened = !0, this.selection.save(), this.Editor.BlockSelection.selectBlock(e), this.Editor.BlockSelection.clearCache();
        const { toolTunes: t1, commonTunes: o } = e.getTunes();
        this.eventsDispatcher.emit(this.events.opened);
        const i = $e2ab202322af4e74$var$be() ? $e2ab202322af4e74$var$nn : $e2ab202322af4e74$var$Bt;
        this.popover = new i({
            searchable: !0,
            items: await this.getTunesItems(e, o, t1),
            scopeElement: this.Editor.API.methods.ui.nodes.redactor,
            messages: {
                nothingFound: $e2ab202322af4e74$var$z.ui($e2ab202322af4e74$var$K.ui.popover, "Nothing found"),
                search: $e2ab202322af4e74$var$z.ui($e2ab202322af4e74$var$K.ui.popover, "Filter")
            }
        }), this.popover.on($e2ab202322af4e74$var$G.Closed, this.onPopoverClose), (s = this.nodes.wrapper) == null || s.append(this.popover.getElement()), this.popover.show();
    }
    /**
   * Returns root block settings element
   */ getElement() {
        return this.nodes.wrapper;
    }
    /**
   * Returns list of items to be displayed in block tunes menu.
   * Merges tool specific tunes, conversion menu and common tunes in one list in predefined order
   *
   * @param currentBlock –  block we are about to open block tunes for
   * @param commonTunes – common tunes
   * @param toolTunes - tool specific tunes
   */ async getTunesItems(e, t1, o) {
        const i = [];
        o !== void 0 && o.length > 0 && (i.push(...o), i.push({
            type: $e2ab202322af4e74$var$_.Separator
        }));
        const s = Array.from(this.Editor.Tools.blockTools.values()), a = (await $e2ab202322af4e74$var$Yo(e, s)).reduce((l, c)=>(c.toolbox.forEach((d)=>{
                l.push({
                    icon: d.icon,
                    title: $e2ab202322af4e74$var$z.t($e2ab202322af4e74$var$K.toolNames, d.title),
                    name: c.name,
                    closeOnActivate: !0,
                    onActivate: async ()=>{
                        const { BlockManager: h, Caret: p, Toolbar: g } = this.Editor, f = await h.convert(e, c.name, d.data);
                        g.close(), p.setToBlock(f, p.positions.END);
                    }
                });
            }), l), []);
        return a.length > 0 && (i.push({
            icon: $e2ab202322af4e74$var$Go,
            name: "convert-to",
            title: $e2ab202322af4e74$var$z.ui($e2ab202322af4e74$var$K.ui.popover, "Convert to"),
            children: {
                searchable: !0,
                items: a
            }
        }), i.push({
            type: $e2ab202322af4e74$var$_.Separator
        })), i.push(...t1), i.map((l)=>this.resolveTuneAliases(l));
    }
    /**
   * Resolves aliases in tunes menu items
   *
   * @param item - item with resolved aliases
   */ resolveTuneAliases(e) {
        if (e.type === $e2ab202322af4e74$var$_.Separator || e.type === $e2ab202322af4e74$var$_.Html) return e;
        const t1 = $e2ab202322af4e74$var$Yi(e, {
            label: "title"
        });
        return e.confirmation && (t1.confirmation = this.resolveTuneAliases(e.confirmation)), t1;
    }
}
var $e2ab202322af4e74$var$sn = {
    exports: {}
};
/*!
 * Library for handling keyboard shortcuts
 * @copyright CodeX (https://codex.so)
 * @license MIT
 * @author CodeX (https://codex.so)
 * @version 1.2.0
 */ (function(n, e) {
    (function(t1, o) {
        n.exports = o();
    })(window, function() {
        return function(t1) {
            var o = {};
            function i(s) {
                if (o[s]) return o[s].exports;
                var r = o[s] = {
                    i: s,
                    l: !1,
                    exports: {}
                };
                return t1[s].call(r.exports, r, r.exports, i), r.l = !0, r.exports;
            }
            return i.m = t1, i.c = o, i.d = function(s, r, a) {
                i.o(s, r) || Object.defineProperty(s, r, {
                    enumerable: !0,
                    get: a
                });
            }, i.r = function(s) {
                typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, {
                    value: "Module"
                }), Object.defineProperty(s, "__esModule", {
                    value: !0
                });
            }, i.t = function(s, r) {
                if (1 & r && (s = i(s)), 8 & r || 4 & r && typeof s == "object" && s && s.__esModule) return s;
                var a = /* @__PURE__ */ Object.create(null);
                if (i.r(a), Object.defineProperty(a, "default", {
                    enumerable: !0,
                    value: s
                }), 2 & r && typeof s != "string") for(var l in s)i.d(a, l, (function(c) {
                    return s[c];
                }).bind(null, l));
                return a;
            }, i.n = function(s) {
                var r = s && s.__esModule ? function() {
                    return s.default;
                } : function() {
                    return s;
                };
                return i.d(r, "a", r), r;
            }, i.o = function(s, r) {
                return Object.prototype.hasOwnProperty.call(s, r);
            }, i.p = "", i(i.s = 0);
        }([
            function(t1, o, i) {
                function s(l, c) {
                    for(var d = 0; d < c.length; d++){
                        var h = c[d];
                        h.enumerable = h.enumerable || !1, h.configurable = !0, "value" in h && (h.writable = !0), Object.defineProperty(l, h.key, h);
                    }
                }
                function r(l, c, d) {
                    return c && s(l.prototype, c), d && s(l, d), l;
                }
                i.r(o);
                var a = function() {
                    function l(c) {
                        var d = this;
                        (function(h, p) {
                            if (!(h instanceof p)) throw new TypeError("Cannot call a class as a function");
                        })(this, l), this.commands = {}, this.keys = {}, this.name = c.name, this.parseShortcutName(c.name), this.element = c.on, this.callback = c.callback, this.executeShortcut = function(h) {
                            d.execute(h);
                        }, this.element.addEventListener("keydown", this.executeShortcut, !1);
                    }
                    return r(l, null, [
                        {
                            key: "supportedCommands",
                            get: function() {
                                return {
                                    SHIFT: [
                                        "SHIFT"
                                    ],
                                    CMD: [
                                        "CMD",
                                        "CONTROL",
                                        "COMMAND",
                                        "WINDOWS",
                                        "CTRL"
                                    ],
                                    ALT: [
                                        "ALT",
                                        "OPTION"
                                    ]
                                };
                            }
                        },
                        {
                            key: "keyCodes",
                            get: function() {
                                return {
                                    0: 48,
                                    1: 49,
                                    2: 50,
                                    3: 51,
                                    4: 52,
                                    5: 53,
                                    6: 54,
                                    7: 55,
                                    8: 56,
                                    9: 57,
                                    A: 65,
                                    B: 66,
                                    C: 67,
                                    D: 68,
                                    E: 69,
                                    F: 70,
                                    G: 71,
                                    H: 72,
                                    I: 73,
                                    J: 74,
                                    K: 75,
                                    L: 76,
                                    M: 77,
                                    N: 78,
                                    O: 79,
                                    P: 80,
                                    Q: 81,
                                    R: 82,
                                    S: 83,
                                    T: 84,
                                    U: 85,
                                    V: 86,
                                    W: 87,
                                    X: 88,
                                    Y: 89,
                                    Z: 90,
                                    BACKSPACE: 8,
                                    ENTER: 13,
                                    ESCAPE: 27,
                                    LEFT: 37,
                                    UP: 38,
                                    RIGHT: 39,
                                    DOWN: 40,
                                    INSERT: 45,
                                    DELETE: 46,
                                    ".": 190
                                };
                            }
                        }
                    ]), r(l, [
                        {
                            key: "parseShortcutName",
                            value: function(c) {
                                c = c.split("+");
                                for(var d = 0; d < c.length; d++){
                                    c[d] = c[d].toUpperCase();
                                    var h = !1;
                                    for(var p in l.supportedCommands)if (l.supportedCommands[p].includes(c[d])) {
                                        h = this.commands[p] = !0;
                                        break;
                                    }
                                    h || (this.keys[c[d]] = !0);
                                }
                                for(var g in l.supportedCommands)this.commands[g] || (this.commands[g] = !1);
                            }
                        },
                        {
                            key: "execute",
                            value: function(c) {
                                var d, h = {
                                    CMD: c.ctrlKey || c.metaKey,
                                    SHIFT: c.shiftKey,
                                    ALT: c.altKey
                                }, p = !0;
                                for(d in this.commands)this.commands[d] !== h[d] && (p = !1);
                                var g, f = !0;
                                for(g in this.keys)f = f && c.keyCode === l.keyCodes[g];
                                p && f && this.callback(c);
                            }
                        },
                        {
                            key: "remove",
                            value: function() {
                                this.element.removeEventListener("keydown", this.executeShortcut);
                            }
                        }
                    ]), l;
                }();
                o.default = a;
            }
        ]).default;
    });
})($e2ab202322af4e74$var$sn);
var $e2ab202322af4e74$var$bs = $e2ab202322af4e74$var$sn.exports;
const $e2ab202322af4e74$var$vs = /* @__PURE__ */ $e2ab202322af4e74$var$Ke($e2ab202322af4e74$var$bs);
class $e2ab202322af4e74$var$ks {
    constructor(){
        this.registeredShortcuts = /* @__PURE__ */ new Map();
    }
    /**
   * Register shortcut
   *
   * @param shortcut - shortcut options
   */ add(e) {
        if (this.findShortcut(e.on, e.name)) throw Error(`Shortcut ${e.name} is already registered for ${e.on}. Please remove it before add a new handler.`);
        const o = new $e2ab202322af4e74$var$vs({
            name: e.name,
            on: e.on,
            callback: e.handler
        }), i = this.registeredShortcuts.get(e.on) || [];
        this.registeredShortcuts.set(e.on, [
            ...i,
            o
        ]);
    }
    /**
   * Remove shortcut
   *
   * @param element - Element shortcut is set for
   * @param name - shortcut name
   */ remove(e, t1) {
        const o = this.findShortcut(e, t1);
        if (!o) return;
        o.remove();
        const s = this.registeredShortcuts.get(e).filter((r)=>r !== o);
        if (s.length === 0) {
            this.registeredShortcuts.delete(e);
            return;
        }
        this.registeredShortcuts.set(e, s);
    }
    /**
   * Get Shortcut instance if exist
   *
   * @param element - Element shorcut is set for
   * @param shortcut - shortcut name
   * @returns {number} index - shortcut index if exist
   */ findShortcut(e, t1) {
        return (this.registeredShortcuts.get(e) || []).find(({ name: i })=>i === t1);
    }
}
const $e2ab202322af4e74$var$ge = new $e2ab202322af4e74$var$ks();
var $e2ab202322af4e74$var$ys = Object.defineProperty, $e2ab202322af4e74$var$ws = Object.getOwnPropertyDescriptor, $e2ab202322af4e74$var$rn = (n, e, t1, o)=>{
    for(var i = o > 1 ? void 0 : o ? $e2ab202322af4e74$var$ws(e, t1) : e, s = n.length - 1, r; s >= 0; s--)(r = n[s]) && (i = (o ? r(e, t1, i) : r(i)) || i);
    return o && i && $e2ab202322af4e74$var$ys(e, t1, i), i;
}, $e2ab202322af4e74$var$Le = /* @__PURE__ */ ((n)=>(n.Opened = "toolbox-opened", n.Closed = "toolbox-closed", n.BlockAdded = "toolbox-block-added", n))($e2ab202322af4e74$var$Le || {});
const $e2ab202322af4e74$var$Ct = class an extends $e2ab202322af4e74$var$Oe {
    /**
   * Toolbox constructor
   *
   * @param options - available parameters
   * @param options.api - Editor API methods
   * @param options.tools - Tools available to check whether some of them should be displayed at the Toolbox or not
   */ constructor({ api: e, tools: t1, i18nLabels: o }){
        super(), this.opened = !1, this.listeners = new $e2ab202322af4e74$var$_e(), this.popover = null, this.handleMobileLayoutToggle = ()=>{
            this.destroyPopover(), this.initPopover();
        }, this.onPopoverClose = ()=>{
            this.opened = !1, this.emit("toolbox-closed");
        }, this.api = e, this.tools = t1, this.i18nLabels = o, this.enableShortcuts(), this.nodes = {
            toolbox: $e2ab202322af4e74$var$u.make("div", an.CSS.toolbox)
        }, this.initPopover(), this.api.events.on($e2ab202322af4e74$var$Te, this.handleMobileLayoutToggle);
    }
    /**
   * Returns True if Toolbox is Empty and nothing to show
   *
   * @returns {boolean}
   */ get isEmpty() {
        return this.toolsToBeDisplayed.length === 0;
    }
    /**
   * CSS styles
   */ static get CSS() {
        return {
            toolbox: "ce-toolbox"
        };
    }
    /**
   * Returns root block settings element
   */ getElement() {
        return this.nodes.toolbox;
    }
    /**
   * Returns true if the Toolbox has the Flipper activated and the Flipper has selected button
   */ hasFocus() {
        if (this.popover !== null) return "hasFocus" in this.popover ? this.popover.hasFocus() : void 0;
    }
    /**
   * Destroy Module
   */ destroy() {
        var e;
        super.destroy(), this.nodes && this.nodes.toolbox && this.nodes.toolbox.remove(), this.removeAllShortcuts(), (e = this.popover) == null || e.off($e2ab202322af4e74$var$G.Closed, this.onPopoverClose), this.listeners.destroy(), this.api.events.off($e2ab202322af4e74$var$Te, this.handleMobileLayoutToggle);
    }
    /**
   * Toolbox Tool's button click handler
   *
   * @param toolName - tool type to be activated
   * @param blockDataOverrides - Block data predefined by the activated Toolbox item
   */ toolButtonActivated(e, t1) {
        this.insertNewBlock(e, t1);
    }
    /**
   * Open Toolbox with Tools
   */ open() {
        var e;
        this.isEmpty || ((e = this.popover) == null || e.show(), this.opened = !0, this.emit("toolbox-opened"));
    }
    /**
   * Close Toolbox
   */ close() {
        var e;
        (e = this.popover) == null || e.hide(), this.opened = !1, this.emit("toolbox-closed");
    }
    /**
   * Close Toolbox
   */ toggle() {
        this.opened ? this.close() : this.open();
    }
    /**
   * Creates toolbox popover and appends it inside wrapper element
   */ initPopover() {
        var t1;
        const e = $e2ab202322af4e74$var$be() ? $e2ab202322af4e74$var$nn : $e2ab202322af4e74$var$Bt;
        this.popover = new e({
            scopeElement: this.api.ui.nodes.redactor,
            searchable: !0,
            messages: {
                nothingFound: this.i18nLabels.nothingFound,
                search: this.i18nLabels.filter
            },
            items: this.toolboxItemsToBeDisplayed
        }), this.popover.on($e2ab202322af4e74$var$G.Closed, this.onPopoverClose), (t1 = this.nodes.toolbox) == null || t1.append(this.popover.getElement());
    }
    /**
   * Destroys popover instance and removes it from DOM
   */ destroyPopover() {
        this.popover !== null && (this.popover.hide(), this.popover.off($e2ab202322af4e74$var$G.Closed, this.onPopoverClose), this.popover.destroy(), this.popover = null), this.nodes.toolbox !== null && (this.nodes.toolbox.innerHTML = "");
    }
    get toolsToBeDisplayed() {
        const e = [];
        return this.tools.forEach((t1)=>{
            t1.toolbox && e.push(t1);
        }), e;
    }
    get toolboxItemsToBeDisplayed() {
        const e = (t1, o, i = !0)=>({
                icon: t1.icon,
                title: $e2ab202322af4e74$var$z.t($e2ab202322af4e74$var$K.toolNames, t1.title || $e2ab202322af4e74$var$je(o.name)),
                name: o.name,
                onActivate: ()=>{
                    this.toolButtonActivated(o.name, t1.data);
                },
                secondaryLabel: o.shortcut && i ? $e2ab202322af4e74$var$vt(o.shortcut) : ""
            });
        return this.toolsToBeDisplayed.reduce((t1, o)=>(Array.isArray(o.toolbox) ? o.toolbox.forEach((i, s)=>{
                t1.push(e(i, o, s === 0));
            }) : o.toolbox !== void 0 && t1.push(e(o.toolbox, o)), t1), []);
    }
    /**
   * Iterate all tools and enable theirs shortcuts if specified
   */ enableShortcuts() {
        this.toolsToBeDisplayed.forEach((e)=>{
            const t1 = e.shortcut;
            t1 && this.enableShortcutForTool(e.name, t1);
        });
    }
    /**
   * Enable shortcut Block Tool implemented shortcut
   *
   * @param {string} toolName - Tool name
   * @param {string} shortcut - shortcut according to the ShortcutData Module format
   */ enableShortcutForTool(e, t1) {
        $e2ab202322af4e74$var$ge.add({
            name: t1,
            on: this.api.ui.nodes.redactor,
            handler: async (o)=>{
                o.preventDefault();
                const i = this.api.blocks.getCurrentBlockIndex(), s = this.api.blocks.getBlockByIndex(i);
                if (s) try {
                    const r = await this.api.blocks.convert(s.id, e);
                    this.api.caret.setToBlock(r, "end");
                    return;
                } catch  {}
                this.insertNewBlock(e);
            }
        });
    }
    /**
   * Removes all added shortcuts
   * Fired when the Read-Only mode is activated
   */ removeAllShortcuts() {
        this.toolsToBeDisplayed.forEach((e)=>{
            const t1 = e.shortcut;
            t1 && $e2ab202322af4e74$var$ge.remove(this.api.ui.nodes.redactor, t1);
        });
    }
    /**
   * Inserts new block
   * Can be called when button clicked on Toolbox or by ShortcutData
   *
   * @param {string} toolName - Tool name
   * @param blockDataOverrides - predefined Block data
   */ async insertNewBlock(e, t1) {
        const o = this.api.blocks.getCurrentBlockIndex(), i = this.api.blocks.getBlockByIndex(o);
        if (!i) return;
        const s = i.isEmpty ? o : o + 1;
        let r;
        if (t1) {
            const l = await this.api.blocks.composeBlockData(e);
            r = Object.assign(l, t1);
        }
        const a = this.api.blocks.insert(e, r, void 0, s, void 0, i.isEmpty);
        a.call($e2ab202322af4e74$var$ee.APPEND_CALLBACK), this.api.caret.setToBlock(s), this.emit("toolbox-block-added", {
            block: a
        }), this.api.toolbar.close();
    }
};
$e2ab202322af4e74$var$rn([
    $e2ab202322af4e74$var$me
], $e2ab202322af4e74$var$Ct.prototype, "toolsToBeDisplayed", 1);
$e2ab202322af4e74$var$rn([
    $e2ab202322af4e74$var$me
], $e2ab202322af4e74$var$Ct.prototype, "toolboxItemsToBeDisplayed", 1);
let $e2ab202322af4e74$var$Es = $e2ab202322af4e74$var$Ct;
const $e2ab202322af4e74$var$ln = "block hovered";
async function $e2ab202322af4e74$var$xs(n, e) {
    const t1 = navigator.keyboard;
    if (!t1) return e;
    try {
        return (await t1.getLayoutMap()).get(n) || e;
    } catch (o) {
        return console.error(o), e;
    }
}
class $e2ab202322af4e74$var$Bs extends $e2ab202322af4e74$var$E {
    /**
   * @class
   * @param moduleConfiguration - Module Configuration
   * @param moduleConfiguration.config - Editor's config
   * @param moduleConfiguration.eventsDispatcher - Editor's event dispatcher
   */ constructor({ config: e, eventsDispatcher: t1 }){
        super({
            config: e,
            eventsDispatcher: t1
        }), this.toolboxInstance = null;
    }
    /**
   * CSS styles
   *
   * @returns {object}
   */ get CSS() {
        return {
            toolbar: "ce-toolbar",
            content: "ce-toolbar__content",
            actions: "ce-toolbar__actions",
            actionsOpened: "ce-toolbar__actions--opened",
            toolbarOpened: "ce-toolbar--opened",
            openedToolboxHolderModifier: "codex-editor--toolbox-opened",
            plusButton: "ce-toolbar__plus",
            plusButtonShortcut: "ce-toolbar__plus-shortcut",
            settingsToggler: "ce-toolbar__settings-btn",
            settingsTogglerHidden: "ce-toolbar__settings-btn--hidden"
        };
    }
    /**
   * Returns the Toolbar opening state
   *
   * @returns {boolean}
   */ get opened() {
        return this.nodes.wrapper.classList.contains(this.CSS.toolbarOpened);
    }
    /**
   * Public interface for accessing the Toolbox
   */ get toolbox() {
        var e;
        return {
            opened: (e = this.toolboxInstance) == null ? void 0 : e.opened,
            close: ()=>{
                var t1;
                (t1 = this.toolboxInstance) == null || t1.close();
            },
            open: ()=>{
                if (this.toolboxInstance === null) {
                    $e2ab202322af4e74$var$S("toolbox.open() called before initialization is finished", "warn");
                    return;
                }
                this.Editor.BlockManager.currentBlock = this.hoveredBlock, this.toolboxInstance.open();
            },
            toggle: ()=>{
                if (this.toolboxInstance === null) {
                    $e2ab202322af4e74$var$S("toolbox.toggle() called before initialization is finished", "warn");
                    return;
                }
                this.toolboxInstance.toggle();
            },
            hasFocus: ()=>{
                var t1;
                return (t1 = this.toolboxInstance) == null ? void 0 : t1.hasFocus();
            }
        };
    }
    /**
   * Block actions appearance manipulations
   */ get blockActions() {
        return {
            hide: ()=>{
                this.nodes.actions.classList.remove(this.CSS.actionsOpened);
            },
            show: ()=>{
                this.nodes.actions.classList.add(this.CSS.actionsOpened);
            }
        };
    }
    /**
   * Methods for working with Block Tunes toggler
   */ get blockTunesToggler() {
        return {
            hide: ()=>this.nodes.settingsToggler.classList.add(this.CSS.settingsTogglerHidden),
            show: ()=>this.nodes.settingsToggler.classList.remove(this.CSS.settingsTogglerHidden)
        };
    }
    /**
   * Toggles read-only mode
   *
   * @param {boolean} readOnlyEnabled - read-only mode
   */ toggleReadOnly(e) {
        e ? (this.destroy(), this.Editor.BlockSettings.destroy(), this.disableModuleBindings()) : window.requestIdleCallback(()=>{
            this.drawUI(), this.enableModuleBindings();
        }, {
            timeout: 2e3
        });
    }
    /**
   * Move Toolbar to the passed (or current) Block
   *
   * @param block - block to move Toolbar near it
   */ moveAndOpen(e = this.Editor.BlockManager.currentBlock) {
        if (this.toolboxInstance === null) {
            $e2ab202322af4e74$var$S("Can't open Toolbar since Editor initialization is not finished yet", "warn");
            return;
        }
        if (this.toolboxInstance.opened && this.toolboxInstance.close(), this.Editor.BlockSettings.opened && this.Editor.BlockSettings.close(), !e) return;
        this.hoveredBlock = e;
        const t1 = e.holder, { isMobile: o } = this.Editor.UI;
        let i;
        const s = 20, r = e.firstInput, a = t1.getBoundingClientRect(), l = r !== void 0 ? r.getBoundingClientRect() : null, c = l !== null ? l.top - a.top : null, d = c !== null ? c > s : void 0;
        if (o) i = t1.offsetTop + t1.offsetHeight;
        else if (r === void 0 || d) {
            const h = parseInt(window.getComputedStyle(e.pluginsContent).paddingTop);
            i = t1.offsetTop + h;
        } else {
            const h = $e2ab202322af4e74$var$li(r), p = parseInt(window.getComputedStyle(this.nodes.plusButton).height, 10), g = 8;
            i = t1.offsetTop + h - p + g + c;
        }
        this.nodes.wrapper.style.top = `${Math.floor(i)}px`, this.Editor.BlockManager.blocks.length === 1 && e.isEmpty ? this.blockTunesToggler.hide() : this.blockTunesToggler.show(), this.open();
    }
    /**
   * Close the Toolbar
   */ close() {
        var e, t1;
        this.Editor.ReadOnly.isEnabled || ((e = this.nodes.wrapper) == null || e.classList.remove(this.CSS.toolbarOpened), this.blockActions.hide(), (t1 = this.toolboxInstance) == null || t1.close(), this.Editor.BlockSettings.close(), this.reset());
    }
    /**
   * Reset the Toolbar position to prevent DOM height growth, for example after blocks deletion
   */ reset() {
        this.nodes.wrapper.style.top = "unset";
    }
    /**
   * Open Toolbar with Plus Button and Actions
   *
   * @param {boolean} withBlockActions - by default, Toolbar opens with Block Actions.
   *                                     This flag allows to open Toolbar without Actions.
   */ open(e = !0) {
        this.nodes.wrapper.classList.add(this.CSS.toolbarOpened), e ? this.blockActions.show() : this.blockActions.hide();
    }
    /**
   * Draws Toolbar elements
   */ async make() {
        this.nodes.wrapper = $e2ab202322af4e74$var$u.make("div", this.CSS.toolbar), [
            "content",
            "actions"
        ].forEach((s)=>{
            this.nodes[s] = $e2ab202322af4e74$var$u.make("div", this.CSS[s]);
        }), $e2ab202322af4e74$var$u.append(this.nodes.wrapper, this.nodes.content), $e2ab202322af4e74$var$u.append(this.nodes.content, this.nodes.actions), this.nodes.plusButton = $e2ab202322af4e74$var$u.make("div", this.CSS.plusButton, {
            innerHTML: $e2ab202322af4e74$var$ts
        }), $e2ab202322af4e74$var$u.append(this.nodes.actions, this.nodes.plusButton), this.readOnlyMutableListeners.on(this.nodes.plusButton, "click", ()=>{
            $e2ab202322af4e74$var$$e(!0), this.plusButtonClicked();
        }, !1);
        const e = $e2ab202322af4e74$var$u.make("div");
        e.appendChild(document.createTextNode($e2ab202322af4e74$var$z.ui($e2ab202322af4e74$var$K.ui.toolbar.toolbox, "Add"))), e.appendChild($e2ab202322af4e74$var$u.make("div", this.CSS.plusButtonShortcut, {
            textContent: "/"
        })), $e2ab202322af4e74$var$ze(this.nodes.plusButton, e, {
            hidingDelay: 400
        }), this.nodes.settingsToggler = $e2ab202322af4e74$var$u.make("span", this.CSS.settingsToggler, {
            innerHTML: $e2ab202322af4e74$var$es
        }), $e2ab202322af4e74$var$u.append(this.nodes.actions, this.nodes.settingsToggler);
        const t1 = $e2ab202322af4e74$var$u.make("div"), o = $e2ab202322af4e74$var$u.text($e2ab202322af4e74$var$z.ui($e2ab202322af4e74$var$K.ui.blockTunes.toggler, "Click to tune")), i = await $e2ab202322af4e74$var$xs("Slash", "/");
        t1.appendChild(o), t1.appendChild($e2ab202322af4e74$var$u.make("div", this.CSS.plusButtonShortcut, {
            textContent: $e2ab202322af4e74$var$vt(`CMD + ${i}`)
        })), $e2ab202322af4e74$var$ze(this.nodes.settingsToggler, t1, {
            hidingDelay: 400
        }), $e2ab202322af4e74$var$u.append(this.nodes.actions, this.makeToolbox()), $e2ab202322af4e74$var$u.append(this.nodes.actions, this.Editor.BlockSettings.getElement()), $e2ab202322af4e74$var$u.append(this.Editor.UI.nodes.wrapper, this.nodes.wrapper);
    }
    /**
   * Creates the Toolbox instance and return it's rendered element
   */ makeToolbox() {
        return this.toolboxInstance = new $e2ab202322af4e74$var$Es({
            api: this.Editor.API.methods,
            tools: this.Editor.Tools.blockTools,
            i18nLabels: {
                filter: $e2ab202322af4e74$var$z.ui($e2ab202322af4e74$var$K.ui.popover, "Filter"),
                nothingFound: $e2ab202322af4e74$var$z.ui($e2ab202322af4e74$var$K.ui.popover, "Nothing found")
            }
        }), this.toolboxInstance.on($e2ab202322af4e74$var$Le.Opened, ()=>{
            this.Editor.UI.nodes.wrapper.classList.add(this.CSS.openedToolboxHolderModifier);
        }), this.toolboxInstance.on($e2ab202322af4e74$var$Le.Closed, ()=>{
            this.Editor.UI.nodes.wrapper.classList.remove(this.CSS.openedToolboxHolderModifier);
        }), this.toolboxInstance.on($e2ab202322af4e74$var$Le.BlockAdded, ({ block: e })=>{
            const { BlockManager: t1, Caret: o } = this.Editor, i = t1.getBlockById(e.id);
            i.inputs.length === 0 && (i === t1.lastBlock ? (t1.insertAtEnd(), o.setToBlock(t1.lastBlock)) : o.setToBlock(t1.nextBlock));
        }), this.toolboxInstance.getElement();
    }
    /**
   * Handler for Plus Button
   */ plusButtonClicked() {
        var e;
        this.Editor.BlockManager.currentBlock = this.hoveredBlock, (e = this.toolboxInstance) == null || e.toggle();
    }
    /**
   * Enable bindings
   */ enableModuleBindings() {
        this.readOnlyMutableListeners.on(this.nodes.settingsToggler, "mousedown", (e)=>{
            var t1;
            e.stopPropagation(), this.settingsTogglerClicked(), (t1 = this.toolboxInstance) != null && t1.opened && this.toolboxInstance.close(), $e2ab202322af4e74$var$$e(!0);
        }, !0), $e2ab202322af4e74$var$be() || this.eventsDispatcher.on($e2ab202322af4e74$var$ln, (e)=>{
            var t1;
            this.Editor.BlockSettings.opened || (t1 = this.toolboxInstance) != null && t1.opened || this.moveAndOpen(e.block);
        });
    }
    /**
   * Disable bindings
   */ disableModuleBindings() {
        this.readOnlyMutableListeners.clearAll();
    }
    /**
   * Clicks on the Block Settings toggler
   */ settingsTogglerClicked() {
        this.Editor.BlockManager.currentBlock = this.hoveredBlock, this.Editor.BlockSettings.opened ? this.Editor.BlockSettings.close() : this.Editor.BlockSettings.open(this.hoveredBlock);
    }
    /**
   * Draws Toolbar UI
   *
   * Toolbar contains BlockSettings and Toolbox.
   * That's why at first we draw its components and then Toolbar itself
   *
   * Steps:
   *  - Make Toolbar dependent components like BlockSettings, Toolbox and so on
   *  - Make itself and append dependent nodes to itself
   *
   */ drawUI() {
        this.Editor.BlockSettings.make(), this.make();
    }
    /**
   * Removes all created and saved HTMLElements
   * It is used in Read-Only mode
   */ destroy() {
        this.removeAllNodes(), this.toolboxInstance && this.toolboxInstance.destroy();
    }
}
var $e2ab202322af4e74$var$ae = /* @__PURE__ */ ((n)=>(n[n.Block = 0] = "Block", n[n.Inline = 1] = "Inline", n[n.Tune = 2] = "Tune", n))($e2ab202322af4e74$var$ae || {}), $e2ab202322af4e74$var$Pe = /* @__PURE__ */ ((n)=>(n.Shortcut = "shortcut", n.Toolbox = "toolbox", n.EnabledInlineTools = "inlineToolbar", n.EnabledBlockTunes = "tunes", n.Config = "config", n))($e2ab202322af4e74$var$Pe || {}), $e2ab202322af4e74$var$cn = /* @__PURE__ */ ((n)=>(n.Shortcut = "shortcut", n.SanitizeConfig = "sanitize", n))($e2ab202322af4e74$var$cn || {}), $e2ab202322af4e74$var$pe = /* @__PURE__ */ ((n)=>(n.IsEnabledLineBreaks = "enableLineBreaks", n.Toolbox = "toolbox", n.ConversionConfig = "conversionConfig", n.IsReadOnlySupported = "isReadOnlySupported", n.PasteConfig = "pasteConfig", n))($e2ab202322af4e74$var$pe || {}), $e2ab202322af4e74$var$We = /* @__PURE__ */ ((n)=>(n.IsInline = "isInline", n.Title = "title", n.IsReadOnlySupported = "isReadOnlySupported", n))($e2ab202322af4e74$var$We || {}), $e2ab202322af4e74$var$mt = /* @__PURE__ */ ((n)=>(n.IsTune = "isTune", n))($e2ab202322af4e74$var$mt || {});
class $e2ab202322af4e74$var$Tt {
    /**
   * @class
   * @param {ConstructorOptions} options - Constructor options
   */ constructor({ name: e, constructable: t1, config: o, api: i, isDefault: s, isInternal: r = !1, defaultPlaceholder: a }){
        this.api = i, this.name = e, this.constructable = t1, this.config = o, this.isDefault = s, this.isInternal = r, this.defaultPlaceholder = a;
    }
    /**
   * Returns Tool user configuration
   */ get settings() {
        const e = this.config.config || {};
        return this.isDefault && !("placeholder" in e) && this.defaultPlaceholder && (e.placeholder = this.defaultPlaceholder), e;
    }
    /**
   * Calls Tool's reset method
   */ reset() {
        if ($e2ab202322af4e74$var$A(this.constructable.reset)) return this.constructable.reset();
    }
    /**
   * Calls Tool's prepare method
   */ prepare() {
        if ($e2ab202322af4e74$var$A(this.constructable.prepare)) return this.constructable.prepare({
            toolName: this.name,
            config: this.settings
        });
    }
    /**
   * Returns shortcut for Tool (internal or specified by user)
   */ get shortcut() {
        const e = this.constructable.shortcut;
        return this.config.shortcut || e;
    }
    /**
   * Returns Tool's sanitizer configuration
   */ get sanitizeConfig() {
        return this.constructable.sanitize || {};
    }
    /**
   * Returns true if Tools is inline
   */ isInline() {
        return this.type === $e2ab202322af4e74$var$ae.Inline;
    }
    /**
   * Returns true if Tools is block
   */ isBlock() {
        return this.type === $e2ab202322af4e74$var$ae.Block;
    }
    /**
   * Returns true if Tools is tune
   */ isTune() {
        return this.type === $e2ab202322af4e74$var$ae.Tune;
    }
}
class $e2ab202322af4e74$var$Cs extends $e2ab202322af4e74$var$E {
    /**
   * @param moduleConfiguration - Module Configuration
   * @param moduleConfiguration.config - Editor's config
   * @param moduleConfiguration.eventsDispatcher - Editor's event dispatcher
   */ constructor({ config: e, eventsDispatcher: t1 }){
        super({
            config: e,
            eventsDispatcher: t1
        }), this.CSS = {
            inlineToolbar: "ce-inline-toolbar"
        }, this.opened = !1, this.popover = null, this.toolbarVerticalMargin = $e2ab202322af4e74$var$be() ? 20 : 6, this.tools = /* @__PURE__ */ new Map(), window.requestIdleCallback(()=>{
            this.make();
        }, {
            timeout: 2e3
        });
    }
    /**
   *  Moving / appearance
   *  ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
   */ /**
   * Shows Inline Toolbar if something is selected
   *
   * @param [needToClose] - pass true to close toolbar if it is not allowed.
   *                                  Avoid to use it just for closing IT, better call .close() clearly.
   */ async tryToShow(e = !1) {
        e && this.close(), this.allowedToShow() && (await this.open(), this.Editor.Toolbar.close());
    }
    /**
   * Hides Inline Toolbar
   */ close() {
        var e, t1;
        if (this.opened) {
            for (const [o, i] of this.tools){
                const s = this.getToolShortcut(o.name);
                s !== void 0 && $e2ab202322af4e74$var$ge.remove(this.Editor.UI.nodes.redactor, s), $e2ab202322af4e74$var$A(i.clear) && i.clear();
            }
            this.tools = /* @__PURE__ */ new Map(), this.reset(), this.opened = !1, (e = this.popover) == null || e.hide(), (t1 = this.popover) == null || t1.destroy(), this.popover = null;
        }
    }
    /**
   * Check if node is contained by Inline Toolbar
   *
   * @param {Node} node — node to check
   */ containsNode(e) {
        return this.nodes.wrapper === void 0 ? !1 : this.nodes.wrapper.contains(e);
    }
    /**
   * Removes UI and its components
   */ destroy() {
        var e;
        this.removeAllNodes(), (e = this.popover) == null || e.destroy(), this.popover = null;
    }
    /**
   * Making DOM
   */ make() {
        this.nodes.wrapper = $e2ab202322af4e74$var$u.make("div", [
            this.CSS.inlineToolbar,
            ...this.isRtl ? [
                this.Editor.UI.CSS.editorRtlFix
            ] : []
        ]), $e2ab202322af4e74$var$u.append(this.Editor.UI.nodes.wrapper, this.nodes.wrapper);
    }
    /**
   * Shows Inline Toolbar
   */ async open() {
        var t1;
        if (this.opened) return;
        this.opened = !0, this.popover !== null && this.popover.destroy(), this.createToolsInstances();
        const e = await this.getPopoverItems();
        this.popover = new $e2ab202322af4e74$var$hs({
            items: e,
            scopeElement: this.Editor.API.methods.ui.nodes.redactor,
            messages: {
                nothingFound: $e2ab202322af4e74$var$z.ui($e2ab202322af4e74$var$K.ui.popover, "Nothing found"),
                search: $e2ab202322af4e74$var$z.ui($e2ab202322af4e74$var$K.ui.popover, "Filter")
            }
        }), this.move(this.popover.size.width), (t1 = this.nodes.wrapper) == null || t1.append(this.popover.getElement()), this.popover.show();
    }
    /**
   * Move Toolbar to the selected text
   *
   * @param popoverWidth - width of the toolbar popover
   */ move(e) {
        const t1 = $e2ab202322af4e74$var$b.rect, o = this.Editor.UI.nodes.wrapper.getBoundingClientRect(), i = {
            x: t1.x - o.x,
            y: t1.y + t1.height - // + window.scrollY
            o.top + this.toolbarVerticalMargin
        };
        i.x + e + o.x > this.Editor.UI.contentRect.right && (i.x = this.Editor.UI.contentRect.right - e - o.x), this.nodes.wrapper.style.left = Math.floor(i.x) + "px", this.nodes.wrapper.style.top = Math.floor(i.y) + "px";
    }
    /**
   * Clear orientation classes and reset position
   */ reset() {
        this.nodes.wrapper.style.left = "0", this.nodes.wrapper.style.top = "0";
    }
    /**
   * Need to show Inline Toolbar or not
   */ allowedToShow() {
        const e = [
            "IMG",
            "INPUT"
        ], t1 = $e2ab202322af4e74$var$b.get(), o = $e2ab202322af4e74$var$b.text;
        if (!t1 || !t1.anchorNode || t1.isCollapsed || o.length < 1) return !1;
        const i = $e2ab202322af4e74$var$u.isElement(t1.anchorNode) ? t1.anchorNode : t1.anchorNode.parentElement;
        if (i === null || t1 !== null && e.includes(i.tagName)) return !1;
        const s = this.Editor.BlockManager.getBlock(t1.anchorNode);
        return !s || this.getTools().some((c)=>s.tool.inlineTools.has(c.name)) === !1 ? !1 : i.closest("[contenteditable]") !== null;
    }
    /**
   *  Working with Tools
   *  ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
   */ /**
   * Returns tools that are available for current block
   *
   * Used to check if Inline Toolbar could be shown
   * and to render tools in the Inline Toolbar
   */ getTools() {
        const e = this.Editor.BlockManager.currentBlock;
        return e ? Array.from(e.tool.inlineTools.values()).filter((o)=>!(this.Editor.ReadOnly.isEnabled && o.isReadOnlySupported !== !0)) : [];
    }
    /**
   * Constructs tools instances and saves them to this.tools
   */ createToolsInstances() {
        this.tools = /* @__PURE__ */ new Map(), this.getTools().forEach((t1)=>{
            const o = t1.create();
            this.tools.set(t1, o);
        });
    }
    /**
   * Returns Popover Items for tools segregated by their appearance type: regular items and custom html elements.
   */ async getPopoverItems() {
        const e = [];
        let t1 = 0;
        for (const [o, i] of this.tools){
            const s = await i.render(), r = this.getToolShortcut(o.name);
            if (r !== void 0) try {
                this.enableShortcuts(o.name, r);
            } catch  {}
            const a = r !== void 0 ? $e2ab202322af4e74$var$vt(r) : void 0, l = $e2ab202322af4e74$var$z.t($e2ab202322af4e74$var$K.toolNames, o.title || $e2ab202322af4e74$var$je(o.name));
            [
                s
            ].flat().forEach((c)=>{
                var h, p;
                const d = {
                    name: o.name,
                    onActivate: ()=>{
                        this.toolClicked(i);
                    },
                    hint: {
                        title: l,
                        description: a
                    }
                };
                if ($e2ab202322af4e74$var$u.isElement(c)) {
                    const g = {
                        ...d,
                        element: c,
                        type: $e2ab202322af4e74$var$_.Html
                    };
                    if ($e2ab202322af4e74$var$A(i.renderActions)) {
                        const f = i.renderActions();
                        g.children = {
                            isOpen: (h = i.checkState) == null ? void 0 : h.call(i, $e2ab202322af4e74$var$b.get()),
                            /** Disable keyboard navigation in actions, as it might conflict with enter press handling */ isFlippable: !1,
                            items: [
                                {
                                    type: $e2ab202322af4e74$var$_.Html,
                                    element: f
                                }
                            ]
                        };
                    } else (p = i.checkState) == null || p.call(i, $e2ab202322af4e74$var$b.get());
                    e.push(g);
                } else if (c.type === $e2ab202322af4e74$var$_.Html) e.push({
                    ...d,
                    ...c,
                    type: $e2ab202322af4e74$var$_.Html
                });
                else if (c.type === $e2ab202322af4e74$var$_.Separator) e.push({
                    type: $e2ab202322af4e74$var$_.Separator
                });
                else {
                    const g = {
                        ...d,
                        ...c,
                        type: $e2ab202322af4e74$var$_.Default
                    };
                    "children" in g && t1 !== 0 && e.push({
                        type: $e2ab202322af4e74$var$_.Separator
                    }), e.push(g), "children" in g && t1 < this.tools.size - 1 && e.push({
                        type: $e2ab202322af4e74$var$_.Separator
                    });
                }
            }), t1++;
        }
        return e;
    }
    /**
   * Get shortcut name for tool
   *
   * @param toolName — Tool name
   */ getToolShortcut(e) {
        const { Tools: t1 } = this.Editor, o = t1.inlineTools.get(e), i = t1.internal.inlineTools;
        return Array.from(i.keys()).includes(e) ? this.inlineTools[e][$e2ab202322af4e74$var$cn.Shortcut] : o == null ? void 0 : o.shortcut;
    }
    /**
   * Enable Tool shortcut with Editor Shortcuts Module
   *
   * @param toolName - tool name
   * @param shortcut - shortcut according to the ShortcutData Module format
   */ enableShortcuts(e, t1) {
        $e2ab202322af4e74$var$ge.add({
            name: t1,
            handler: (o)=>{
                var s;
                const { currentBlock: i } = this.Editor.BlockManager;
                i && i.tool.enabledInlineTools && (o.preventDefault(), (s = this.popover) == null || s.activateItemByName(e));
            },
            /**
       * We need to bind shortcut to the document to make it work in read-only mode
       */ on: document
        });
    }
    /**
   * Inline Tool button clicks
   *
   * @param tool - Tool's instance
   */ toolClicked(e) {
        var o;
        const t1 = $e2ab202322af4e74$var$b.range;
        (o = e.surround) == null || o.call(e, t1), this.checkToolsState();
    }
    /**
   * Check Tools` state by selection
   */ checkToolsState() {
        var e;
        (e = this.tools) == null || e.forEach((t1)=>{
            var o;
            (o = t1.checkState) == null || o.call(t1, $e2ab202322af4e74$var$b.get());
        });
    }
    /**
   * Get inline tools tools
   * Tools that has isInline is true
   */ get inlineTools() {
        const e = {};
        return Array.from(this.Editor.Tools.inlineTools.entries()).forEach(([t1, o])=>{
            e[t1] = o.create();
        }), e;
    }
}
function $e2ab202322af4e74$var$dn() {
    const n = window.getSelection();
    if (n === null) return [
        null,
        0
    ];
    let e = n.focusNode, t1 = n.focusOffset;
    return e === null ? [
        null,
        0
    ] : (e.nodeType !== Node.TEXT_NODE && e.childNodes.length > 0 && (e.childNodes[t1] ? (e = e.childNodes[t1], t1 = 0) : (e = e.childNodes[t1 - 1], t1 = e.textContent.length)), [
        e,
        t1
    ]);
}
function $e2ab202322af4e74$var$un(n, e, t1, o) {
    const i = document.createRange();
    o === "left" ? (i.setStart(n, 0), i.setEnd(e, t1)) : (i.setStart(e, t1), i.setEnd(n, n.childNodes.length));
    const s = i.cloneContents(), r = document.createElement("div");
    r.appendChild(s);
    const a = r.textContent || "";
    return $e2ab202322af4e74$var$ai(a);
}
function $e2ab202322af4e74$var$Ne(n) {
    const e = $e2ab202322af4e74$var$u.getDeepestNode(n);
    if (e === null || $e2ab202322af4e74$var$u.isEmpty(n)) return !0;
    if ($e2ab202322af4e74$var$u.isNativeInput(e)) return e.selectionEnd === 0;
    if ($e2ab202322af4e74$var$u.isEmpty(n)) return !0;
    const [t1, o] = $e2ab202322af4e74$var$dn();
    return t1 === null ? !1 : $e2ab202322af4e74$var$un(n, t1, o, "left");
}
function $e2ab202322af4e74$var$Re(n) {
    const e = $e2ab202322af4e74$var$u.getDeepestNode(n, !0);
    if (e === null) return !0;
    if ($e2ab202322af4e74$var$u.isNativeInput(e)) return e.selectionEnd === e.value.length;
    const [t1, o] = $e2ab202322af4e74$var$dn();
    return t1 === null ? !1 : $e2ab202322af4e74$var$un(n, t1, o, "right");
}
var $e2ab202322af4e74$var$hn = {}, $e2ab202322af4e74$var$St = {}, $e2ab202322af4e74$var$Xe = {}, $e2ab202322af4e74$var$de = {}, $e2ab202322af4e74$var$It = {}, $e2ab202322af4e74$var$Ot = {};
Object.defineProperty($e2ab202322af4e74$var$Ot, "__esModule", {
    value: !0
});
$e2ab202322af4e74$var$Ot.allInputsSelector = $e2ab202322af4e74$var$Ts;
function $e2ab202322af4e74$var$Ts() {
    var n = [
        "text",
        "password",
        "email",
        "number",
        "search",
        "tel",
        "url"
    ];
    return "[contenteditable=true], textarea, input:not([type]), " + n.map(function(e) {
        return 'input[type="'.concat(e, '"]');
    }).join(", ");
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.allInputsSelector = void 0;
    var e = $e2ab202322af4e74$var$Ot;
    Object.defineProperty(n, "allInputsSelector", {
        enumerable: !0,
        get: function() {
            return e.allInputsSelector;
        }
    });
})($e2ab202322af4e74$var$It);
var $e2ab202322af4e74$var$ue = {}, $e2ab202322af4e74$var$_t = {};
Object.defineProperty($e2ab202322af4e74$var$_t, "__esModule", {
    value: !0
});
$e2ab202322af4e74$var$_t.isNativeInput = $e2ab202322af4e74$var$Ss;
function $e2ab202322af4e74$var$Ss(n) {
    var e = [
        "INPUT",
        "TEXTAREA"
    ];
    return n && n.tagName ? e.includes(n.tagName) : !1;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isNativeInput = void 0;
    var e = $e2ab202322af4e74$var$_t;
    Object.defineProperty(n, "isNativeInput", {
        enumerable: !0,
        get: function() {
            return e.isNativeInput;
        }
    });
})($e2ab202322af4e74$var$ue);
var $e2ab202322af4e74$var$pn = {}, $e2ab202322af4e74$var$Mt = {};
Object.defineProperty($e2ab202322af4e74$var$Mt, "__esModule", {
    value: !0
});
$e2ab202322af4e74$var$Mt.append = $e2ab202322af4e74$var$Is;
function $e2ab202322af4e74$var$Is(n, e) {
    Array.isArray(e) ? e.forEach(function(t1) {
        n.appendChild(t1);
    }) : n.appendChild(e);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.append = void 0;
    var e = $e2ab202322af4e74$var$Mt;
    Object.defineProperty(n, "append", {
        enumerable: !0,
        get: function() {
            return e.append;
        }
    });
})($e2ab202322af4e74$var$pn);
var $e2ab202322af4e74$var$At = {}, $e2ab202322af4e74$var$Lt = {};
Object.defineProperty($e2ab202322af4e74$var$Lt, "__esModule", {
    value: !0
});
$e2ab202322af4e74$var$Lt.blockElements = $e2ab202322af4e74$var$Os;
function $e2ab202322af4e74$var$Os() {
    return [
        "address",
        "article",
        "aside",
        "blockquote",
        "canvas",
        "div",
        "dl",
        "dt",
        "fieldset",
        "figcaption",
        "figure",
        "footer",
        "form",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "header",
        "hgroup",
        "hr",
        "li",
        "main",
        "nav",
        "noscript",
        "ol",
        "output",
        "p",
        "pre",
        "ruby",
        "section",
        "table",
        "tbody",
        "thead",
        "tr",
        "tfoot",
        "ul",
        "video"
    ];
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.blockElements = void 0;
    var e = $e2ab202322af4e74$var$Lt;
    Object.defineProperty(n, "blockElements", {
        enumerable: !0,
        get: function() {
            return e.blockElements;
        }
    });
})($e2ab202322af4e74$var$At);
var $e2ab202322af4e74$var$fn = {}, $e2ab202322af4e74$var$Pt = {};
Object.defineProperty($e2ab202322af4e74$var$Pt, "__esModule", {
    value: !0
});
$e2ab202322af4e74$var$Pt.calculateBaseline = $e2ab202322af4e74$var$_s;
function $e2ab202322af4e74$var$_s(n) {
    var e = window.getComputedStyle(n), t1 = parseFloat(e.fontSize), o = parseFloat(e.lineHeight) || t1 * 1.2, i = parseFloat(e.paddingTop), s = parseFloat(e.borderTopWidth), r = parseFloat(e.marginTop), a = t1 * 0.8, l = (o - t1) / 2, c = r + s + i + l + a;
    return c;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.calculateBaseline = void 0;
    var e = $e2ab202322af4e74$var$Pt;
    Object.defineProperty(n, "calculateBaseline", {
        enumerable: !0,
        get: function() {
            return e.calculateBaseline;
        }
    });
})($e2ab202322af4e74$var$fn);
var $e2ab202322af4e74$var$gn = {}, $e2ab202322af4e74$var$Nt = {}, $e2ab202322af4e74$var$Rt = {}, $e2ab202322af4e74$var$Dt = {};
Object.defineProperty($e2ab202322af4e74$var$Dt, "__esModule", {
    value: !0
});
$e2ab202322af4e74$var$Dt.isContentEditable = $e2ab202322af4e74$var$Ms;
function $e2ab202322af4e74$var$Ms(n) {
    return n.contentEditable === "true";
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isContentEditable = void 0;
    var e = $e2ab202322af4e74$var$Dt;
    Object.defineProperty(n, "isContentEditable", {
        enumerable: !0,
        get: function() {
            return e.isContentEditable;
        }
    });
})($e2ab202322af4e74$var$Rt);
Object.defineProperty($e2ab202322af4e74$var$Nt, "__esModule", {
    value: !0
});
$e2ab202322af4e74$var$Nt.canSetCaret = $e2ab202322af4e74$var$Ps;
var $e2ab202322af4e74$var$As = $e2ab202322af4e74$var$ue, $e2ab202322af4e74$var$Ls = $e2ab202322af4e74$var$Rt;
function $e2ab202322af4e74$var$Ps(n) {
    var e = !0;
    if ((0, $e2ab202322af4e74$var$As.isNativeInput)(n)) switch(n.type){
        case "file":
        case "checkbox":
        case "radio":
        case "hidden":
        case "submit":
        case "button":
        case "image":
        case "reset":
            e = !1;
            break;
    }
    else e = (0, $e2ab202322af4e74$var$Ls.isContentEditable)(n);
    return e;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.canSetCaret = void 0;
    var e = $e2ab202322af4e74$var$Nt;
    Object.defineProperty(n, "canSetCaret", {
        enumerable: !0,
        get: function() {
            return e.canSetCaret;
        }
    });
})($e2ab202322af4e74$var$gn);
var $e2ab202322af4e74$var$Ve = {}, $e2ab202322af4e74$var$Ft = {};
function $e2ab202322af4e74$var$Ns(n, e, t1) {
    const o = t1.value !== void 0 ? "value" : "get", i = t1[o], s = `#${e}Cache`;
    if (t1[o] = function(...r) {
        return this[s] === void 0 && (this[s] = i.apply(this, r)), this[s];
    }, o === "get" && t1.set) {
        const r = t1.set;
        t1.set = function(a) {
            delete n[s], r.apply(this, a);
        };
    }
    return t1;
}
function $e2ab202322af4e74$var$mn() {
    const n = {
        win: !1,
        mac: !1,
        x11: !1,
        linux: !1
    }, e = Object.keys(n).find((t1)=>window.navigator.appVersion.toLowerCase().indexOf(t1) !== -1);
    return e !== void 0 && (n[e] = !0), n;
}
function $e2ab202322af4e74$var$jt(n) {
    return n != null && n !== "" && (typeof n != "object" || Object.keys(n).length > 0);
}
function $e2ab202322af4e74$var$Rs(n) {
    return !$e2ab202322af4e74$var$jt(n);
}
const $e2ab202322af4e74$var$Ds = ()=>typeof window < "u" && window.navigator !== null && $e2ab202322af4e74$var$jt(window.navigator.platform) && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);
function $e2ab202322af4e74$var$Fs(n) {
    const e = $e2ab202322af4e74$var$mn();
    return n = n.replace(/shift/gi, "\u21E7").replace(/backspace/gi, "\u232B").replace(/enter/gi, "\u23CE").replace(/up/gi, "\u2191").replace(/left/gi, "\u2192").replace(/down/gi, "\u2193").replace(/right/gi, "\u2190").replace(/escape/gi, "\u238B").replace(/insert/gi, "Ins").replace(/delete/gi, "\u2421").replace(/\+/gi, "+"), e.mac ? n = n.replace(/ctrl|cmd/gi, "\u2318").replace(/alt/gi, "\u2325") : n = n.replace(/cmd/gi, "Ctrl").replace(/windows/gi, "WIN"), n;
}
function $e2ab202322af4e74$var$js(n) {
    return n[0].toUpperCase() + n.slice(1);
}
function $e2ab202322af4e74$var$Hs(n) {
    const e = document.createElement("div");
    e.style.position = "absolute", e.style.left = "-999px", e.style.bottom = "-999px", e.innerHTML = n, document.body.appendChild(e);
    const t1 = window.getSelection(), o = document.createRange();
    if (o.selectNode(e), t1 === null) throw new Error("Cannot copy text to clipboard");
    t1.removeAllRanges(), t1.addRange(o), document.execCommand("copy"), document.body.removeChild(e);
}
function $e2ab202322af4e74$var$$s(n, e, t1) {
    let o;
    return (...i)=>{
        const s = this, r = ()=>{
            o = void 0, t1 !== !0 && n.apply(s, i);
        }, a = t1 === !0 && o !== void 0;
        window.clearTimeout(o), o = window.setTimeout(r, e), a && n.apply(s, i);
    };
}
function $e2ab202322af4e74$var$oe(n) {
    return Object.prototype.toString.call(n).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
}
function $e2ab202322af4e74$var$zs(n) {
    return $e2ab202322af4e74$var$oe(n) === "boolean";
}
function $e2ab202322af4e74$var$bn(n) {
    return $e2ab202322af4e74$var$oe(n) === "function" || $e2ab202322af4e74$var$oe(n) === "asyncfunction";
}
function $e2ab202322af4e74$var$Us(n) {
    return $e2ab202322af4e74$var$bn(n) && /^\s*class\s+/.test(n.toString());
}
function $e2ab202322af4e74$var$Ws(n) {
    return $e2ab202322af4e74$var$oe(n) === "number";
}
function $e2ab202322af4e74$var$De(n) {
    return $e2ab202322af4e74$var$oe(n) === "object";
}
function $e2ab202322af4e74$var$Ys(n) {
    return Promise.resolve(n) === n;
}
function $e2ab202322af4e74$var$Ks(n) {
    return $e2ab202322af4e74$var$oe(n) === "string";
}
function $e2ab202322af4e74$var$Xs(n) {
    return $e2ab202322af4e74$var$oe(n) === "undefined";
}
function $e2ab202322af4e74$var$bt(n, ...e) {
    if (!e.length) return n;
    const t1 = e.shift();
    if ($e2ab202322af4e74$var$De(n) && $e2ab202322af4e74$var$De(t1)) for(const o in t1)$e2ab202322af4e74$var$De(t1[o]) ? (n[o] === void 0 && Object.assign(n, {
        [o]: {}
    }), $e2ab202322af4e74$var$bt(n[o], t1[o])) : Object.assign(n, {
        [o]: t1[o]
    });
    return $e2ab202322af4e74$var$bt(n, ...e);
}
function $e2ab202322af4e74$var$Vs(n, e, t1) {
    const o = `\xab${e}\xbb is deprecated and will be removed in the next major release. Please use the \xab${t1}\xbb instead.`;
    n && console.warn(o);
}
function $e2ab202322af4e74$var$qs(n) {
    try {
        return new URL(n).href;
    } catch  {}
    return n.substring(0, 2) === "//" ? window.location.protocol + n : window.location.origin + n;
}
function $e2ab202322af4e74$var$Zs(n) {
    return n > 47 && n < 58 || n === 32 || n === 13 || n === 229 || n > 64 && n < 91 || n > 95 && n < 112 || n > 185 && n < 193 || n > 218 && n < 223;
}
const $e2ab202322af4e74$var$Gs = {
    BACKSPACE: 8,
    TAB: 9,
    ENTER: 13,
    SHIFT: 16,
    CTRL: 17,
    ALT: 18,
    ESC: 27,
    SPACE: 32,
    LEFT: 37,
    UP: 38,
    DOWN: 40,
    RIGHT: 39,
    DELETE: 46,
    META: 91,
    SLASH: 191
}, $e2ab202322af4e74$var$Qs = {
    LEFT: 0,
    WHEEL: 1,
    RIGHT: 2,
    BACKWARD: 3,
    FORWARD: 4
};
let $e2ab202322af4e74$var$Js = class {
    constructor(){
        this.completed = Promise.resolve();
    }
    /**
   * Add new promise to queue
   * @param operation - promise should be added to queue
   */ add(e) {
        return new Promise((t1, o)=>{
            this.completed = this.completed.then(e).then(t1).catch(o);
        });
    }
};
function $e2ab202322af4e74$var$er(n, e, t1) {
    let o, i, s, r = null, a = 0;
    t1 || (t1 = {});
    const l = function() {
        a = t1.leading === !1 ? 0 : Date.now(), r = null, s = n.apply(o, i), r === null && (o = i = null);
    };
    return function() {
        const c = Date.now();
        !a && t1.leading === !1 && (a = c);
        const d = e - (c - a);
        return o = this, i = arguments, d <= 0 || d > e ? (r && (clearTimeout(r), r = null), a = c, s = n.apply(o, i), r === null && (o = i = null)) : !r && t1.trailing !== !1 && (r = setTimeout(l, d)), s;
    };
}
const $e2ab202322af4e74$var$tr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    PromiseQueue: $e2ab202322af4e74$var$Js,
    beautifyShortcut: $e2ab202322af4e74$var$Fs,
    cacheable: $e2ab202322af4e74$var$Ns,
    capitalize: $e2ab202322af4e74$var$js,
    copyTextToClipboard: $e2ab202322af4e74$var$Hs,
    debounce: $e2ab202322af4e74$var$$s,
    deepMerge: $e2ab202322af4e74$var$bt,
    deprecationAssert: $e2ab202322af4e74$var$Vs,
    getUserOS: $e2ab202322af4e74$var$mn,
    getValidUrl: $e2ab202322af4e74$var$qs,
    isBoolean: $e2ab202322af4e74$var$zs,
    isClass: $e2ab202322af4e74$var$Us,
    isEmpty: $e2ab202322af4e74$var$Rs,
    isFunction: $e2ab202322af4e74$var$bn,
    isIosDevice: $e2ab202322af4e74$var$Ds,
    isNumber: $e2ab202322af4e74$var$Ws,
    isObject: $e2ab202322af4e74$var$De,
    isPrintableKey: $e2ab202322af4e74$var$Zs,
    isPromise: $e2ab202322af4e74$var$Ys,
    isString: $e2ab202322af4e74$var$Ks,
    isUndefined: $e2ab202322af4e74$var$Xs,
    keyCodes: $e2ab202322af4e74$var$Gs,
    mouseButtons: $e2ab202322af4e74$var$Qs,
    notEmpty: $e2ab202322af4e74$var$jt,
    throttle: $e2ab202322af4e74$var$er,
    typeOf: $e2ab202322af4e74$var$oe
}, Symbol.toStringTag, {
    value: "Module"
})), $e2ab202322af4e74$var$Ht = /* @__PURE__ */ $e2ab202322af4e74$var$Xn($e2ab202322af4e74$var$tr);
Object.defineProperty($e2ab202322af4e74$var$Ft, "__esModule", {
    value: !0
});
$e2ab202322af4e74$var$Ft.containsOnlyInlineElements = $e2ab202322af4e74$var$ir;
var $e2ab202322af4e74$var$or = $e2ab202322af4e74$var$Ht, $e2ab202322af4e74$var$nr = $e2ab202322af4e74$var$At;
function $e2ab202322af4e74$var$ir(n) {
    var e;
    (0, $e2ab202322af4e74$var$or.isString)(n) ? (e = document.createElement("div"), e.innerHTML = n) : e = n;
    var t1 = function(o) {
        return !(0, $e2ab202322af4e74$var$nr.blockElements)().includes(o.tagName.toLowerCase()) && Array.from(o.children).every(t1);
    };
    return Array.from(e.children).every(t1);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.containsOnlyInlineElements = void 0;
    var e = $e2ab202322af4e74$var$Ft;
    Object.defineProperty(n, "containsOnlyInlineElements", {
        enumerable: !0,
        get: function() {
            return e.containsOnlyInlineElements;
        }
    });
})($e2ab202322af4e74$var$Ve);
var $e2ab202322af4e74$var$vn = {}, $e2ab202322af4e74$var$$t = {}, $e2ab202322af4e74$var$qe = {}, $e2ab202322af4e74$var$zt = {};
Object.defineProperty($e2ab202322af4e74$var$zt, "__esModule", {
    value: !0
});
$e2ab202322af4e74$var$zt.make = $e2ab202322af4e74$var$sr;
function $e2ab202322af4e74$var$sr(n, e, t1) {
    var o;
    e === void 0 && (e = null), t1 === void 0 && (t1 = {});
    var i = document.createElement(n);
    if (Array.isArray(e)) {
        var s = e.filter(function(a) {
            return a !== void 0;
        });
        (o = i.classList).add.apply(o, s);
    } else e !== null && i.classList.add(e);
    for(var r in t1)Object.prototype.hasOwnProperty.call(t1, r) && (i[r] = t1[r]);
    return i;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.make = void 0;
    var e = $e2ab202322af4e74$var$zt;
    Object.defineProperty(n, "make", {
        enumerable: !0,
        get: function() {
            return e.make;
        }
    });
})($e2ab202322af4e74$var$qe);
Object.defineProperty($e2ab202322af4e74$var$$t, "__esModule", {
    value: !0
});
$e2ab202322af4e74$var$$t.fragmentToString = $e2ab202322af4e74$var$ar;
var $e2ab202322af4e74$var$rr = $e2ab202322af4e74$var$qe;
function $e2ab202322af4e74$var$ar(n) {
    var e = (0, $e2ab202322af4e74$var$rr.make)("div");
    return e.appendChild(n), e.innerHTML;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.fragmentToString = void 0;
    var e = $e2ab202322af4e74$var$$t;
    Object.defineProperty(n, "fragmentToString", {
        enumerable: !0,
        get: function() {
            return e.fragmentToString;
        }
    });
})($e2ab202322af4e74$var$vn);
var $e2ab202322af4e74$var$kn = {}, $e2ab202322af4e74$var$Ut = {};
Object.defineProperty($e2ab202322af4e74$var$Ut, "__esModule", {
    value: !0
});
$e2ab202322af4e74$var$Ut.getContentLength = $e2ab202322af4e74$var$cr;
var $e2ab202322af4e74$var$lr = $e2ab202322af4e74$var$ue;
function $e2ab202322af4e74$var$cr(n) {
    var e, t1;
    return (0, $e2ab202322af4e74$var$lr.isNativeInput)(n) ? n.value.length : n.nodeType === Node.TEXT_NODE ? n.length : (t1 = (e = n.textContent) === null || e === void 0 ? void 0 : e.length) !== null && t1 !== void 0 ? t1 : 0;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.getContentLength = void 0;
    var e = $e2ab202322af4e74$var$Ut;
    Object.defineProperty(n, "getContentLength", {
        enumerable: !0,
        get: function() {
            return e.getContentLength;
        }
    });
})($e2ab202322af4e74$var$kn);
var $e2ab202322af4e74$var$Wt = {}, $e2ab202322af4e74$var$Yt = {}, $e2ab202322af4e74$var$Io = $e2ab202322af4e74$var$Ce && $e2ab202322af4e74$var$Ce.__spreadArray || function(n, e, t1) {
    if (t1 || arguments.length === 2) for(var o = 0, i = e.length, s; o < i; o++)(s || !(o in e)) && (s || (s = Array.prototype.slice.call(e, 0, o)), s[o] = e[o]);
    return n.concat(s || Array.prototype.slice.call(e));
};
Object.defineProperty($e2ab202322af4e74$var$Yt, "__esModule", {
    value: !0
});
$e2ab202322af4e74$var$Yt.getDeepestBlockElements = $e2ab202322af4e74$var$yn;
var $e2ab202322af4e74$var$dr = $e2ab202322af4e74$var$Ve;
function $e2ab202322af4e74$var$yn(n) {
    return (0, $e2ab202322af4e74$var$dr.containsOnlyInlineElements)(n) ? [
        n
    ] : Array.from(n.children).reduce(function(e, t1) {
        return $e2ab202322af4e74$var$Io($e2ab202322af4e74$var$Io([], e, !0), $e2ab202322af4e74$var$yn(t1), !0);
    }, []);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.getDeepestBlockElements = void 0;
    var e = $e2ab202322af4e74$var$Yt;
    Object.defineProperty(n, "getDeepestBlockElements", {
        enumerable: !0,
        get: function() {
            return e.getDeepestBlockElements;
        }
    });
})($e2ab202322af4e74$var$Wt);
var $e2ab202322af4e74$var$wn = {}, $e2ab202322af4e74$var$Kt = {}, $e2ab202322af4e74$var$Ze = {}, $e2ab202322af4e74$var$Xt = {};
Object.defineProperty($e2ab202322af4e74$var$Xt, "__esModule", {
    value: !0
});
$e2ab202322af4e74$var$Xt.isLineBreakTag = $e2ab202322af4e74$var$ur;
function $e2ab202322af4e74$var$ur(n) {
    return [
        "BR",
        "WBR"
    ].includes(n.tagName);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isLineBreakTag = void 0;
    var e = $e2ab202322af4e74$var$Xt;
    Object.defineProperty(n, "isLineBreakTag", {
        enumerable: !0,
        get: function() {
            return e.isLineBreakTag;
        }
    });
})($e2ab202322af4e74$var$Ze);
var $e2ab202322af4e74$var$Ge = {}, $e2ab202322af4e74$var$Vt = {};
Object.defineProperty($e2ab202322af4e74$var$Vt, "__esModule", {
    value: !0
});
$e2ab202322af4e74$var$Vt.isSingleTag = $e2ab202322af4e74$var$hr;
function $e2ab202322af4e74$var$hr(n) {
    return [
        "AREA",
        "BASE",
        "BR",
        "COL",
        "COMMAND",
        "EMBED",
        "HR",
        "IMG",
        "INPUT",
        "KEYGEN",
        "LINK",
        "META",
        "PARAM",
        "SOURCE",
        "TRACK",
        "WBR"
    ].includes(n.tagName);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isSingleTag = void 0;
    var e = $e2ab202322af4e74$var$Vt;
    Object.defineProperty(n, "isSingleTag", {
        enumerable: !0,
        get: function() {
            return e.isSingleTag;
        }
    });
})($e2ab202322af4e74$var$Ge);
Object.defineProperty($e2ab202322af4e74$var$Kt, "__esModule", {
    value: !0
});
$e2ab202322af4e74$var$Kt.getDeepestNode = $e2ab202322af4e74$var$En;
var $e2ab202322af4e74$var$pr = $e2ab202322af4e74$var$ue, $e2ab202322af4e74$var$fr = $e2ab202322af4e74$var$Ze, $e2ab202322af4e74$var$gr = $e2ab202322af4e74$var$Ge;
function $e2ab202322af4e74$var$En(n, e) {
    e === void 0 && (e = !1);
    var t1 = e ? "lastChild" : "firstChild", o = e ? "previousSibling" : "nextSibling";
    if (n.nodeType === Node.ELEMENT_NODE && n[t1]) {
        var i = n[t1];
        if ((0, $e2ab202322af4e74$var$gr.isSingleTag)(i) && !(0, $e2ab202322af4e74$var$pr.isNativeInput)(i) && !(0, $e2ab202322af4e74$var$fr.isLineBreakTag)(i)) {
            if (i[o]) i = i[o];
            else if (i.parentNode !== null && i.parentNode[o]) i = i.parentNode[o];
            else return i.parentNode;
        }
        return $e2ab202322af4e74$var$En(i, e);
    }
    return n;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.getDeepestNode = void 0;
    var e = $e2ab202322af4e74$var$Kt;
    Object.defineProperty(n, "getDeepestNode", {
        enumerable: !0,
        get: function() {
            return e.getDeepestNode;
        }
    });
})($e2ab202322af4e74$var$wn);
var $e2ab202322af4e74$var$xn = {}, $e2ab202322af4e74$var$qt = {}, $e2ab202322af4e74$var$Me = $e2ab202322af4e74$var$Ce && $e2ab202322af4e74$var$Ce.__spreadArray || function(n, e, t1) {
    if (t1 || arguments.length === 2) for(var o = 0, i = e.length, s; o < i; o++)(s || !(o in e)) && (s || (s = Array.prototype.slice.call(e, 0, o)), s[o] = e[o]);
    return n.concat(s || Array.prototype.slice.call(e));
};
Object.defineProperty($e2ab202322af4e74$var$qt, "__esModule", {
    value: !0
});
$e2ab202322af4e74$var$qt.findAllInputs = $e2ab202322af4e74$var$yr;
var $e2ab202322af4e74$var$mr = $e2ab202322af4e74$var$Ve, $e2ab202322af4e74$var$br = $e2ab202322af4e74$var$Wt, $e2ab202322af4e74$var$vr = $e2ab202322af4e74$var$It, $e2ab202322af4e74$var$kr = $e2ab202322af4e74$var$ue;
function $e2ab202322af4e74$var$yr(n) {
    return Array.from(n.querySelectorAll((0, $e2ab202322af4e74$var$vr.allInputsSelector)())).reduce(function(e, t1) {
        return (0, $e2ab202322af4e74$var$kr.isNativeInput)(t1) || (0, $e2ab202322af4e74$var$mr.containsOnlyInlineElements)(t1) ? $e2ab202322af4e74$var$Me($e2ab202322af4e74$var$Me([], e, !0), [
            t1
        ], !1) : $e2ab202322af4e74$var$Me($e2ab202322af4e74$var$Me([], e, !0), (0, $e2ab202322af4e74$var$br.getDeepestBlockElements)(t1), !0);
    }, []);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.findAllInputs = void 0;
    var e = $e2ab202322af4e74$var$qt;
    Object.defineProperty(n, "findAllInputs", {
        enumerable: !0,
        get: function() {
            return e.findAllInputs;
        }
    });
})($e2ab202322af4e74$var$xn);
var $e2ab202322af4e74$var$Bn = {}, $e2ab202322af4e74$var$Zt = {};
Object.defineProperty($e2ab202322af4e74$var$Zt, "__esModule", {
    value: !0
});
$e2ab202322af4e74$var$Zt.isCollapsedWhitespaces = $e2ab202322af4e74$var$wr;
function $e2ab202322af4e74$var$wr(n) {
    return !/[^\t\n\r ]/.test(n);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isCollapsedWhitespaces = void 0;
    var e = $e2ab202322af4e74$var$Zt;
    Object.defineProperty(n, "isCollapsedWhitespaces", {
        enumerable: !0,
        get: function() {
            return e.isCollapsedWhitespaces;
        }
    });
})($e2ab202322af4e74$var$Bn);
var $e2ab202322af4e74$var$Gt = {}, $e2ab202322af4e74$var$Qt = {};
Object.defineProperty($e2ab202322af4e74$var$Qt, "__esModule", {
    value: !0
});
$e2ab202322af4e74$var$Qt.isElement = $e2ab202322af4e74$var$xr;
var $e2ab202322af4e74$var$Er = $e2ab202322af4e74$var$Ht;
function $e2ab202322af4e74$var$xr(n) {
    return (0, $e2ab202322af4e74$var$Er.isNumber)(n) ? !1 : !!n && !!n.nodeType && n.nodeType === Node.ELEMENT_NODE;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isElement = void 0;
    var e = $e2ab202322af4e74$var$Qt;
    Object.defineProperty(n, "isElement", {
        enumerable: !0,
        get: function() {
            return e.isElement;
        }
    });
})($e2ab202322af4e74$var$Gt);
var $e2ab202322af4e74$var$Cn = {}, $e2ab202322af4e74$var$Jt = {}, $e2ab202322af4e74$var$eo = {}, $e2ab202322af4e74$var$to = {};
Object.defineProperty($e2ab202322af4e74$var$to, "__esModule", {
    value: !0
});
$e2ab202322af4e74$var$to.isLeaf = $e2ab202322af4e74$var$Br;
function $e2ab202322af4e74$var$Br(n) {
    return n === null ? !1 : n.childNodes.length === 0;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isLeaf = void 0;
    var e = $e2ab202322af4e74$var$to;
    Object.defineProperty(n, "isLeaf", {
        enumerable: !0,
        get: function() {
            return e.isLeaf;
        }
    });
})($e2ab202322af4e74$var$eo);
var $e2ab202322af4e74$var$oo = {}, $e2ab202322af4e74$var$no = {};
Object.defineProperty($e2ab202322af4e74$var$no, "__esModule", {
    value: !0
});
$e2ab202322af4e74$var$no.isNodeEmpty = $e2ab202322af4e74$var$Or;
var $e2ab202322af4e74$var$Cr = $e2ab202322af4e74$var$Ze, $e2ab202322af4e74$var$Tr = $e2ab202322af4e74$var$Gt, $e2ab202322af4e74$var$Sr = $e2ab202322af4e74$var$ue, $e2ab202322af4e74$var$Ir = $e2ab202322af4e74$var$Ge;
function $e2ab202322af4e74$var$Or(n, e) {
    var t1 = "";
    return (0, $e2ab202322af4e74$var$Ir.isSingleTag)(n) && !(0, $e2ab202322af4e74$var$Cr.isLineBreakTag)(n) ? !1 : ((0, $e2ab202322af4e74$var$Tr.isElement)(n) && (0, $e2ab202322af4e74$var$Sr.isNativeInput)(n) ? t1 = n.value : n.textContent !== null && (t1 = n.textContent.replace("\u200B", "")), e !== void 0 && (t1 = t1.replace(new RegExp(e, "g"), "")), t1.trim().length === 0);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isNodeEmpty = void 0;
    var e = $e2ab202322af4e74$var$no;
    Object.defineProperty(n, "isNodeEmpty", {
        enumerable: !0,
        get: function() {
            return e.isNodeEmpty;
        }
    });
})($e2ab202322af4e74$var$oo);
Object.defineProperty($e2ab202322af4e74$var$Jt, "__esModule", {
    value: !0
});
$e2ab202322af4e74$var$Jt.isEmpty = $e2ab202322af4e74$var$Ar;
var $e2ab202322af4e74$var$_r = $e2ab202322af4e74$var$eo, $e2ab202322af4e74$var$Mr = $e2ab202322af4e74$var$oo;
function $e2ab202322af4e74$var$Ar(n, e) {
    n.normalize();
    for(var t1 = [
        n
    ]; t1.length > 0;){
        var o = t1.shift();
        if (o) {
            if (n = o, (0, $e2ab202322af4e74$var$_r.isLeaf)(n) && !(0, $e2ab202322af4e74$var$Mr.isNodeEmpty)(n, e)) return !1;
            t1.push.apply(t1, Array.from(n.childNodes));
        }
    }
    return !0;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isEmpty = void 0;
    var e = $e2ab202322af4e74$var$Jt;
    Object.defineProperty(n, "isEmpty", {
        enumerable: !0,
        get: function() {
            return e.isEmpty;
        }
    });
})($e2ab202322af4e74$var$Cn);
var $e2ab202322af4e74$var$Tn = {}, $e2ab202322af4e74$var$io = {};
Object.defineProperty($e2ab202322af4e74$var$io, "__esModule", {
    value: !0
});
$e2ab202322af4e74$var$io.isFragment = $e2ab202322af4e74$var$Pr;
var $e2ab202322af4e74$var$Lr = $e2ab202322af4e74$var$Ht;
function $e2ab202322af4e74$var$Pr(n) {
    return (0, $e2ab202322af4e74$var$Lr.isNumber)(n) ? !1 : !!n && !!n.nodeType && n.nodeType === Node.DOCUMENT_FRAGMENT_NODE;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isFragment = void 0;
    var e = $e2ab202322af4e74$var$io;
    Object.defineProperty(n, "isFragment", {
        enumerable: !0,
        get: function() {
            return e.isFragment;
        }
    });
})($e2ab202322af4e74$var$Tn);
var $e2ab202322af4e74$var$Sn = {}, $e2ab202322af4e74$var$so = {};
Object.defineProperty($e2ab202322af4e74$var$so, "__esModule", {
    value: !0
});
$e2ab202322af4e74$var$so.isHTMLString = $e2ab202322af4e74$var$Rr;
var $e2ab202322af4e74$var$Nr = $e2ab202322af4e74$var$qe;
function $e2ab202322af4e74$var$Rr(n) {
    var e = (0, $e2ab202322af4e74$var$Nr.make)("div");
    return e.innerHTML = n, e.childElementCount > 0;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isHTMLString = void 0;
    var e = $e2ab202322af4e74$var$so;
    Object.defineProperty(n, "isHTMLString", {
        enumerable: !0,
        get: function() {
            return e.isHTMLString;
        }
    });
})($e2ab202322af4e74$var$Sn);
var $e2ab202322af4e74$var$In = {}, $e2ab202322af4e74$var$ro = {};
Object.defineProperty($e2ab202322af4e74$var$ro, "__esModule", {
    value: !0
});
$e2ab202322af4e74$var$ro.offset = $e2ab202322af4e74$var$Dr;
function $e2ab202322af4e74$var$Dr(n) {
    var e = n.getBoundingClientRect(), t1 = window.pageXOffset || document.documentElement.scrollLeft, o = window.pageYOffset || document.documentElement.scrollTop, i = e.top + o, s = e.left + t1;
    return {
        top: i,
        left: s,
        bottom: i + e.height,
        right: s + e.width
    };
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.offset = void 0;
    var e = $e2ab202322af4e74$var$ro;
    Object.defineProperty(n, "offset", {
        enumerable: !0,
        get: function() {
            return e.offset;
        }
    });
})($e2ab202322af4e74$var$In);
var $e2ab202322af4e74$var$On = {}, $e2ab202322af4e74$var$ao = {};
Object.defineProperty($e2ab202322af4e74$var$ao, "__esModule", {
    value: !0
});
$e2ab202322af4e74$var$ao.prepend = $e2ab202322af4e74$var$Fr;
function $e2ab202322af4e74$var$Fr(n, e) {
    Array.isArray(e) ? (e = e.reverse(), e.forEach(function(t1) {
        return n.prepend(t1);
    })) : n.prepend(e);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.prepend = void 0;
    var e = $e2ab202322af4e74$var$ao;
    Object.defineProperty(n, "prepend", {
        enumerable: !0,
        get: function() {
            return e.prepend;
        }
    });
})($e2ab202322af4e74$var$On);
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.prepend = n.offset = n.make = n.isLineBreakTag = n.isSingleTag = n.isNodeEmpty = n.isLeaf = n.isHTMLString = n.isFragment = n.isEmpty = n.isElement = n.isContentEditable = n.isCollapsedWhitespaces = n.findAllInputs = n.isNativeInput = n.allInputsSelector = n.getDeepestNode = n.getDeepestBlockElements = n.getContentLength = n.fragmentToString = n.containsOnlyInlineElements = n.canSetCaret = n.calculateBaseline = n.blockElements = n.append = void 0;
    var e = $e2ab202322af4e74$var$It;
    Object.defineProperty(n, "allInputsSelector", {
        enumerable: !0,
        get: function() {
            return e.allInputsSelector;
        }
    });
    var t1 = $e2ab202322af4e74$var$ue;
    Object.defineProperty(n, "isNativeInput", {
        enumerable: !0,
        get: function() {
            return t1.isNativeInput;
        }
    });
    var o = $e2ab202322af4e74$var$pn;
    Object.defineProperty(n, "append", {
        enumerable: !0,
        get: function() {
            return o.append;
        }
    });
    var i = $e2ab202322af4e74$var$At;
    Object.defineProperty(n, "blockElements", {
        enumerable: !0,
        get: function() {
            return i.blockElements;
        }
    });
    var s = $e2ab202322af4e74$var$fn;
    Object.defineProperty(n, "calculateBaseline", {
        enumerable: !0,
        get: function() {
            return s.calculateBaseline;
        }
    });
    var r = $e2ab202322af4e74$var$gn;
    Object.defineProperty(n, "canSetCaret", {
        enumerable: !0,
        get: function() {
            return r.canSetCaret;
        }
    });
    var a = $e2ab202322af4e74$var$Ve;
    Object.defineProperty(n, "containsOnlyInlineElements", {
        enumerable: !0,
        get: function() {
            return a.containsOnlyInlineElements;
        }
    });
    var l = $e2ab202322af4e74$var$vn;
    Object.defineProperty(n, "fragmentToString", {
        enumerable: !0,
        get: function() {
            return l.fragmentToString;
        }
    });
    var c = $e2ab202322af4e74$var$kn;
    Object.defineProperty(n, "getContentLength", {
        enumerable: !0,
        get: function() {
            return c.getContentLength;
        }
    });
    var d = $e2ab202322af4e74$var$Wt;
    Object.defineProperty(n, "getDeepestBlockElements", {
        enumerable: !0,
        get: function() {
            return d.getDeepestBlockElements;
        }
    });
    var h = $e2ab202322af4e74$var$wn;
    Object.defineProperty(n, "getDeepestNode", {
        enumerable: !0,
        get: function() {
            return h.getDeepestNode;
        }
    });
    var p = $e2ab202322af4e74$var$xn;
    Object.defineProperty(n, "findAllInputs", {
        enumerable: !0,
        get: function() {
            return p.findAllInputs;
        }
    });
    var g = $e2ab202322af4e74$var$Bn;
    Object.defineProperty(n, "isCollapsedWhitespaces", {
        enumerable: !0,
        get: function() {
            return g.isCollapsedWhitespaces;
        }
    });
    var f = $e2ab202322af4e74$var$Rt;
    Object.defineProperty(n, "isContentEditable", {
        enumerable: !0,
        get: function() {
            return f.isContentEditable;
        }
    });
    var v = $e2ab202322af4e74$var$Gt;
    Object.defineProperty(n, "isElement", {
        enumerable: !0,
        get: function() {
            return v.isElement;
        }
    });
    var O = $e2ab202322af4e74$var$Cn;
    Object.defineProperty(n, "isEmpty", {
        enumerable: !0,
        get: function() {
            return O.isEmpty;
        }
    });
    var T = $e2ab202322af4e74$var$Tn;
    Object.defineProperty(n, "isFragment", {
        enumerable: !0,
        get: function() {
            return T.isFragment;
        }
    });
    var M = $e2ab202322af4e74$var$Sn;
    Object.defineProperty(n, "isHTMLString", {
        enumerable: !0,
        get: function() {
            return M.isHTMLString;
        }
    });
    var q = $e2ab202322af4e74$var$eo;
    Object.defineProperty(n, "isLeaf", {
        enumerable: !0,
        get: function() {
            return q.isLeaf;
        }
    });
    var F = $e2ab202322af4e74$var$oo;
    Object.defineProperty(n, "isNodeEmpty", {
        enumerable: !0,
        get: function() {
            return F.isNodeEmpty;
        }
    });
    var H = $e2ab202322af4e74$var$Ze;
    Object.defineProperty(n, "isLineBreakTag", {
        enumerable: !0,
        get: function() {
            return H.isLineBreakTag;
        }
    });
    var Q = $e2ab202322af4e74$var$Ge;
    Object.defineProperty(n, "isSingleTag", {
        enumerable: !0,
        get: function() {
            return Q.isSingleTag;
        }
    });
    var ie = $e2ab202322af4e74$var$qe;
    Object.defineProperty(n, "make", {
        enumerable: !0,
        get: function() {
            return ie.make;
        }
    });
    var k = $e2ab202322af4e74$var$In;
    Object.defineProperty(n, "offset", {
        enumerable: !0,
        get: function() {
            return k.offset;
        }
    });
    var m = $e2ab202322af4e74$var$On;
    Object.defineProperty(n, "prepend", {
        enumerable: !0,
        get: function() {
            return m.prepend;
        }
    });
})($e2ab202322af4e74$var$de);
var $e2ab202322af4e74$var$Qe = {};
Object.defineProperty($e2ab202322af4e74$var$Qe, "__esModule", {
    value: !0
});
$e2ab202322af4e74$var$Qe.getContenteditableSlice = $e2ab202322af4e74$var$Hr;
var $e2ab202322af4e74$var$jr = $e2ab202322af4e74$var$de;
function $e2ab202322af4e74$var$Hr(n, e, t1, o, i) {
    var s;
    i === void 0 && (i = !1);
    var r = document.createRange();
    if (o === "left" ? (r.setStart(n, 0), r.setEnd(e, t1)) : (r.setStart(e, t1), r.setEnd(n, n.childNodes.length)), i === !0) {
        var a = r.extractContents();
        return (0, $e2ab202322af4e74$var$jr.fragmentToString)(a);
    }
    var l = r.cloneContents(), c = document.createElement("div");
    c.appendChild(l);
    var d = (s = c.textContent) !== null && s !== void 0 ? s : "";
    return d;
}
Object.defineProperty($e2ab202322af4e74$var$Xe, "__esModule", {
    value: !0
});
$e2ab202322af4e74$var$Xe.checkContenteditableSliceForEmptiness = $e2ab202322af4e74$var$Ur;
var $e2ab202322af4e74$var$$r = $e2ab202322af4e74$var$de, $e2ab202322af4e74$var$zr = $e2ab202322af4e74$var$Qe;
function $e2ab202322af4e74$var$Ur(n, e, t1, o) {
    var i = (0, $e2ab202322af4e74$var$zr.getContenteditableSlice)(n, e, t1, o);
    return (0, $e2ab202322af4e74$var$$r.isCollapsedWhitespaces)(i);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.checkContenteditableSliceForEmptiness = void 0;
    var e = $e2ab202322af4e74$var$Xe;
    Object.defineProperty(n, "checkContenteditableSliceForEmptiness", {
        enumerable: !0,
        get: function() {
            return e.checkContenteditableSliceForEmptiness;
        }
    });
})($e2ab202322af4e74$var$St);
var $e2ab202322af4e74$var$_n = {};
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.getContenteditableSlice = void 0;
    var e = $e2ab202322af4e74$var$Qe;
    Object.defineProperty(n, "getContenteditableSlice", {
        enumerable: !0,
        get: function() {
            return e.getContenteditableSlice;
        }
    });
})($e2ab202322af4e74$var$_n);
var $e2ab202322af4e74$var$Mn = {}, $e2ab202322af4e74$var$lo = {};
Object.defineProperty($e2ab202322af4e74$var$lo, "__esModule", {
    value: !0
});
$e2ab202322af4e74$var$lo.focus = $e2ab202322af4e74$var$Yr;
var $e2ab202322af4e74$var$Wr = $e2ab202322af4e74$var$de;
function $e2ab202322af4e74$var$Yr(n, e) {
    var t1, o;
    if (e === void 0 && (e = !0), (0, $e2ab202322af4e74$var$Wr.isNativeInput)(n)) {
        n.focus();
        var i = e ? 0 : n.value.length;
        n.setSelectionRange(i, i);
    } else {
        var s = document.createRange(), r = window.getSelection();
        if (!r) return;
        var a = function(p) {
            var g = document.createTextNode("");
            p.appendChild(g), s.setStart(g, 0), s.setEnd(g, 0);
        }, l = function(p) {
            return p != null;
        }, c = n.childNodes, d = e ? c[0] : c[c.length - 1];
        if (l(d)) {
            for(; l(d) && d.nodeType !== Node.TEXT_NODE;)d = e ? d.firstChild : d.lastChild;
            if (l(d) && d.nodeType === Node.TEXT_NODE) {
                var h = (o = (t1 = d.textContent) === null || t1 === void 0 ? void 0 : t1.length) !== null && o !== void 0 ? o : 0, i = e ? 0 : h;
                s.setStart(d, i), s.setEnd(d, i);
            } else a(n);
        } else a(n);
        r.removeAllRanges(), r.addRange(s);
    }
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.focus = void 0;
    var e = $e2ab202322af4e74$var$lo;
    Object.defineProperty(n, "focus", {
        enumerable: !0,
        get: function() {
            return e.focus;
        }
    });
})($e2ab202322af4e74$var$Mn);
var $e2ab202322af4e74$var$co = {}, $e2ab202322af4e74$var$Je = {};
Object.defineProperty($e2ab202322af4e74$var$Je, "__esModule", {
    value: !0
});
$e2ab202322af4e74$var$Je.getCaretNodeAndOffset = $e2ab202322af4e74$var$Kr;
function $e2ab202322af4e74$var$Kr() {
    var n = window.getSelection();
    if (n === null) return [
        null,
        0
    ];
    var e = n.focusNode, t1 = n.focusOffset;
    return e === null ? [
        null,
        0
    ] : (e.nodeType !== Node.TEXT_NODE && e.childNodes.length > 0 && (e.childNodes[t1] !== void 0 ? (e = e.childNodes[t1], t1 = 0) : (e = e.childNodes[t1 - 1], e.textContent !== null && (t1 = e.textContent.length))), [
        e,
        t1
    ]);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.getCaretNodeAndOffset = void 0;
    var e = $e2ab202322af4e74$var$Je;
    Object.defineProperty(n, "getCaretNodeAndOffset", {
        enumerable: !0,
        get: function() {
            return e.getCaretNodeAndOffset;
        }
    });
})($e2ab202322af4e74$var$co);
var $e2ab202322af4e74$var$An = {}, $e2ab202322af4e74$var$et = {};
Object.defineProperty($e2ab202322af4e74$var$et, "__esModule", {
    value: !0
});
$e2ab202322af4e74$var$et.getRange = $e2ab202322af4e74$var$Xr;
function $e2ab202322af4e74$var$Xr() {
    var n = window.getSelection();
    return n && n.rangeCount ? n.getRangeAt(0) : null;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.getRange = void 0;
    var e = $e2ab202322af4e74$var$et;
    Object.defineProperty(n, "getRange", {
        enumerable: !0,
        get: function() {
            return e.getRange;
        }
    });
})($e2ab202322af4e74$var$An);
var $e2ab202322af4e74$var$Ln = {}, $e2ab202322af4e74$var$uo = {};
Object.defineProperty($e2ab202322af4e74$var$uo, "__esModule", {
    value: !0
});
$e2ab202322af4e74$var$uo.isCaretAtEndOfInput = $e2ab202322af4e74$var$Zr;
var $e2ab202322af4e74$var$Oo = $e2ab202322af4e74$var$de, $e2ab202322af4e74$var$Vr = $e2ab202322af4e74$var$co, $e2ab202322af4e74$var$qr = $e2ab202322af4e74$var$St;
function $e2ab202322af4e74$var$Zr(n) {
    var e = (0, $e2ab202322af4e74$var$Oo.getDeepestNode)(n, !0);
    if (e === null) return !0;
    if ((0, $e2ab202322af4e74$var$Oo.isNativeInput)(e)) return e.selectionEnd === e.value.length;
    var t1 = (0, $e2ab202322af4e74$var$Vr.getCaretNodeAndOffset)(), o = t1[0], i = t1[1];
    return o === null ? !1 : (0, $e2ab202322af4e74$var$qr.checkContenteditableSliceForEmptiness)(n, o, i, "right");
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isCaretAtEndOfInput = void 0;
    var e = $e2ab202322af4e74$var$uo;
    Object.defineProperty(n, "isCaretAtEndOfInput", {
        enumerable: !0,
        get: function() {
            return e.isCaretAtEndOfInput;
        }
    });
})($e2ab202322af4e74$var$Ln);
var $e2ab202322af4e74$var$Pn = {}, $e2ab202322af4e74$var$ho = {};
Object.defineProperty($e2ab202322af4e74$var$ho, "__esModule", {
    value: !0
});
$e2ab202322af4e74$var$ho.isCaretAtStartOfInput = $e2ab202322af4e74$var$Jr;
var $e2ab202322af4e74$var$Ae = $e2ab202322af4e74$var$de, $e2ab202322af4e74$var$Gr = $e2ab202322af4e74$var$Je, $e2ab202322af4e74$var$Qr = $e2ab202322af4e74$var$Xe;
function $e2ab202322af4e74$var$Jr(n) {
    var e = (0, $e2ab202322af4e74$var$Ae.getDeepestNode)(n);
    if (e === null || (0, $e2ab202322af4e74$var$Ae.isEmpty)(n)) return !0;
    if ((0, $e2ab202322af4e74$var$Ae.isNativeInput)(e)) return e.selectionEnd === 0;
    if ((0, $e2ab202322af4e74$var$Ae.isEmpty)(n)) return !0;
    var t1 = (0, $e2ab202322af4e74$var$Gr.getCaretNodeAndOffset)(), o = t1[0], i = t1[1];
    return o === null ? !1 : (0, $e2ab202322af4e74$var$Qr.checkContenteditableSliceForEmptiness)(n, o, i, "left");
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isCaretAtStartOfInput = void 0;
    var e = $e2ab202322af4e74$var$ho;
    Object.defineProperty(n, "isCaretAtStartOfInput", {
        enumerable: !0,
        get: function() {
            return e.isCaretAtStartOfInput;
        }
    });
})($e2ab202322af4e74$var$Pn);
var $e2ab202322af4e74$var$Nn = {}, $e2ab202322af4e74$var$po = {};
Object.defineProperty($e2ab202322af4e74$var$po, "__esModule", {
    value: !0
});
$e2ab202322af4e74$var$po.save = $e2ab202322af4e74$var$oa;
var $e2ab202322af4e74$var$ea = $e2ab202322af4e74$var$de, $e2ab202322af4e74$var$ta = $e2ab202322af4e74$var$et;
function $e2ab202322af4e74$var$oa() {
    var n = (0, $e2ab202322af4e74$var$ta.getRange)(), e = (0, $e2ab202322af4e74$var$ea.make)("span");
    if (e.id = "cursor", e.hidden = !0, !!n) return n.insertNode(e), function() {
        var o = window.getSelection();
        o && (n.setStartAfter(e), n.setEndAfter(e), o.removeAllRanges(), o.addRange(n), setTimeout(function() {
            e.remove();
        }, 150));
    };
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.save = void 0;
    var e = $e2ab202322af4e74$var$po;
    Object.defineProperty(n, "save", {
        enumerable: !0,
        get: function() {
            return e.save;
        }
    });
})($e2ab202322af4e74$var$Nn);
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.save = n.isCaretAtStartOfInput = n.isCaretAtEndOfInput = n.getRange = n.getCaretNodeAndOffset = n.focus = n.getContenteditableSlice = n.checkContenteditableSliceForEmptiness = void 0;
    var e = $e2ab202322af4e74$var$St;
    Object.defineProperty(n, "checkContenteditableSliceForEmptiness", {
        enumerable: !0,
        get: function() {
            return e.checkContenteditableSliceForEmptiness;
        }
    });
    var t1 = $e2ab202322af4e74$var$_n;
    Object.defineProperty(n, "getContenteditableSlice", {
        enumerable: !0,
        get: function() {
            return t1.getContenteditableSlice;
        }
    });
    var o = $e2ab202322af4e74$var$Mn;
    Object.defineProperty(n, "focus", {
        enumerable: !0,
        get: function() {
            return o.focus;
        }
    });
    var i = $e2ab202322af4e74$var$co;
    Object.defineProperty(n, "getCaretNodeAndOffset", {
        enumerable: !0,
        get: function() {
            return i.getCaretNodeAndOffset;
        }
    });
    var s = $e2ab202322af4e74$var$An;
    Object.defineProperty(n, "getRange", {
        enumerable: !0,
        get: function() {
            return s.getRange;
        }
    });
    var r = $e2ab202322af4e74$var$Ln;
    Object.defineProperty(n, "isCaretAtEndOfInput", {
        enumerable: !0,
        get: function() {
            return r.isCaretAtEndOfInput;
        }
    });
    var a = $e2ab202322af4e74$var$Pn;
    Object.defineProperty(n, "isCaretAtStartOfInput", {
        enumerable: !0,
        get: function() {
            return a.isCaretAtStartOfInput;
        }
    });
    var l = $e2ab202322af4e74$var$Nn;
    Object.defineProperty(n, "save", {
        enumerable: !0,
        get: function() {
            return l.save;
        }
    });
})($e2ab202322af4e74$var$hn);
class $e2ab202322af4e74$var$na extends $e2ab202322af4e74$var$E {
    /**
   * All keydowns on Block
   *
   * @param {KeyboardEvent} event - keydown
   */ keydown(e) {
        switch(this.beforeKeydownProcessing(e), e.keyCode){
            case $e2ab202322af4e74$var$y.BACKSPACE:
                this.backspace(e);
                break;
            case $e2ab202322af4e74$var$y.DELETE:
                this.delete(e);
                break;
            case $e2ab202322af4e74$var$y.ENTER:
                this.enter(e);
                break;
            case $e2ab202322af4e74$var$y.DOWN:
            case $e2ab202322af4e74$var$y.RIGHT:
                this.arrowRightAndDown(e);
                break;
            case $e2ab202322af4e74$var$y.UP:
            case $e2ab202322af4e74$var$y.LEFT:
                this.arrowLeftAndUp(e);
                break;
            case $e2ab202322af4e74$var$y.TAB:
                this.tabPressed(e);
                break;
        }
        e.key === "/" && !e.ctrlKey && !e.metaKey && this.slashPressed(e), e.code === "Slash" && (e.ctrlKey || e.metaKey) && (e.preventDefault(), this.commandSlashPressed());
    }
    /**
   * Fires on keydown before event processing
   *
   * @param {KeyboardEvent} event - keydown
   */ beforeKeydownProcessing(e) {
        this.needToolbarClosing(e) && $e2ab202322af4e74$var$Po(e.keyCode) && (this.Editor.Toolbar.close(), e.ctrlKey || e.metaKey || e.altKey || e.shiftKey || this.Editor.BlockSelection.clearSelection(e));
    }
    /**
   * Key up on Block:
   * - shows Inline Toolbar if something selected
   * - shows conversion toolbar with 85% of block selection
   *
   * @param {KeyboardEvent} event - keyup event
   */ keyup(e) {
        e.shiftKey || this.Editor.UI.checkEmptiness();
    }
    /**
   * Add drop target styles
   *
   * @param {DragEvent} event - drag over event
   */ dragOver(e) {
        const t1 = this.Editor.BlockManager.getBlockByChildNode(e.target);
        t1.dropTarget = !0;
    }
    /**
   * Remove drop target style
   *
   * @param {DragEvent} event - drag leave event
   */ dragLeave(e) {
        const t1 = this.Editor.BlockManager.getBlockByChildNode(e.target);
        t1.dropTarget = !1;
    }
    /**
   * Copying selected blocks
   * Before putting to the clipboard we sanitize all blocks and then copy to the clipboard
   *
   * @param {ClipboardEvent} event - clipboard event
   */ handleCommandC(e) {
        const { BlockSelection: t1 } = this.Editor;
        t1.anyBlockSelected && t1.copySelectedBlocks(e);
    }
    /**
   * Copy and Delete selected Blocks
   *
   * @param {ClipboardEvent} event - clipboard event
   */ handleCommandX(e) {
        const { BlockSelection: t1, BlockManager: o, Caret: i } = this.Editor;
        t1.anyBlockSelected && t1.copySelectedBlocks(e).then(()=>{
            const s = o.removeSelectedBlocks(), r = o.insertDefaultBlockAtIndex(s, !0);
            i.setToBlock(r, i.positions.START), t1.clearSelection(e);
        });
    }
    /**
   * Tab pressed inside a Block.
   *
   * @param {KeyboardEvent} event - keydown
   */ tabPressed(e) {
        const { InlineToolbar: t1, Caret: o } = this.Editor;
        if (t1.opened) return;
        (e.shiftKey ? o.navigatePrevious(!0) : o.navigateNext(!0)) && e.preventDefault();
    }
    /**
   * '/' + 'command' keydown inside a Block
   */ commandSlashPressed() {
        this.Editor.BlockSelection.selectedBlocks.length > 1 || this.activateBlockSettings();
    }
    /**
   * '/' keydown inside a Block
   *
   * @param event - keydown
   */ slashPressed(e) {
        !this.Editor.UI.nodes.wrapper.contains(e.target) || !this.Editor.BlockManager.currentBlock.isEmpty || (e.preventDefault(), this.Editor.Caret.insertContentAtCaretPosition("/"), this.activateToolbox());
    }
    /**
   * ENTER pressed on block
   *
   * @param {KeyboardEvent} event - keydown
   */ enter(e) {
        const { BlockManager: t1, UI: o } = this.Editor, i = t1.currentBlock;
        if (i === void 0 || i.tool.isLineBreaksEnabled || o.someToolbarOpened && o.someFlipperButtonFocused || e.shiftKey && !$e2ab202322af4e74$var$pt) return;
        let s = i;
        i.currentInput !== void 0 && $e2ab202322af4e74$var$Ne(i.currentInput) && !i.hasMedia ? this.Editor.BlockManager.insertDefaultBlockAtIndex(this.Editor.BlockManager.currentBlockIndex) : i.currentInput && $e2ab202322af4e74$var$Re(i.currentInput) ? s = this.Editor.BlockManager.insertDefaultBlockAtIndex(this.Editor.BlockManager.currentBlockIndex + 1) : s = this.Editor.BlockManager.split(), this.Editor.Caret.setToBlock(s), this.Editor.Toolbar.moveAndOpen(s), e.preventDefault();
    }
    /**
   * Handle backspace keydown on Block
   *
   * @param {KeyboardEvent} event - keydown
   */ backspace(e) {
        const { BlockManager: t1, Caret: o } = this.Editor, { currentBlock: i, previousBlock: s } = t1;
        if (i === void 0 || !$e2ab202322af4e74$var$b.isCollapsed || !i.currentInput || !$e2ab202322af4e74$var$Ne(i.currentInput)) return;
        if (e.preventDefault(), this.Editor.Toolbar.close(), !(i.currentInput === i.firstInput)) {
            o.navigatePrevious();
            return;
        }
        if (s === null) return;
        if (s.isEmpty) {
            t1.removeBlock(s);
            return;
        }
        if (i.isEmpty) {
            t1.removeBlock(i);
            const l = t1.currentBlock;
            o.setToBlock(l, o.positions.END);
            return;
        }
        $e2ab202322af4e74$var$xo(s, i) ? this.mergeBlocks(s, i) : o.setToBlock(s, o.positions.END);
    }
    /**
   * Handles delete keydown on Block
   * Removes char after the caret.
   * If caret is at the end of the block, merge next block with current
   *
   * @param {KeyboardEvent} event - keydown
   */ delete(e) {
        const { BlockManager: t1, Caret: o } = this.Editor, { currentBlock: i, nextBlock: s } = t1;
        if (!$e2ab202322af4e74$var$b.isCollapsed || !$e2ab202322af4e74$var$Re(i.currentInput)) return;
        if (e.preventDefault(), this.Editor.Toolbar.close(), !(i.currentInput === i.lastInput)) {
            o.navigateNext();
            return;
        }
        if (s === null) return;
        if (s.isEmpty) {
            t1.removeBlock(s);
            return;
        }
        if (i.isEmpty) {
            t1.removeBlock(i), o.setToBlock(s, o.positions.START);
            return;
        }
        $e2ab202322af4e74$var$xo(i, s) ? this.mergeBlocks(i, s) : o.setToBlock(s, o.positions.START);
    }
    /**
   * Merge passed Blocks
   *
   * @param targetBlock - to which Block we want to merge
   * @param blockToMerge - what Block we want to merge
   */ mergeBlocks(e, t1) {
        const { BlockManager: o, Toolbar: i } = this.Editor;
        e.lastInput !== void 0 && ($e2ab202322af4e74$var$hn.focus(e.lastInput, !1), o.mergeBlocks(e, t1).then(()=>{
            i.close();
        }));
    }
    /**
   * Handle right and down keyboard keys
   *
   * @param {KeyboardEvent} event - keyboard event
   */ arrowRightAndDown(e) {
        const t1 = $e2ab202322af4e74$var$ce.usedKeys.includes(e.keyCode) && (!e.shiftKey || e.keyCode === $e2ab202322af4e74$var$y.TAB);
        if (this.Editor.UI.someToolbarOpened && t1) return;
        this.Editor.Toolbar.close();
        const { currentBlock: o } = this.Editor.BlockManager, s = ((o == null ? void 0 : o.currentInput) !== void 0 ? $e2ab202322af4e74$var$Re(o.currentInput) : void 0) || this.Editor.BlockSelection.anyBlockSelected;
        if (e.shiftKey && e.keyCode === $e2ab202322af4e74$var$y.DOWN && s) {
            this.Editor.CrossBlockSelection.toggleBlockSelectedState();
            return;
        }
        if (e.keyCode === $e2ab202322af4e74$var$y.DOWN || e.keyCode === $e2ab202322af4e74$var$y.RIGHT && !this.isRtl ? this.Editor.Caret.navigateNext() : this.Editor.Caret.navigatePrevious()) {
            e.preventDefault();
            return;
        }
        $e2ab202322af4e74$var$Fe(()=>{
            this.Editor.BlockManager.currentBlock && this.Editor.BlockManager.currentBlock.updateCurrentInput();
        }, 20)(), this.Editor.BlockSelection.clearSelection(e);
    }
    /**
   * Handle left and up keyboard keys
   *
   * @param {KeyboardEvent} event - keyboard event
   */ arrowLeftAndUp(e) {
        if (this.Editor.UI.someToolbarOpened) {
            if ($e2ab202322af4e74$var$ce.usedKeys.includes(e.keyCode) && (!e.shiftKey || e.keyCode === $e2ab202322af4e74$var$y.TAB)) return;
            this.Editor.UI.closeAllToolbars();
        }
        this.Editor.Toolbar.close();
        const { currentBlock: t1 } = this.Editor.BlockManager, i = ((t1 == null ? void 0 : t1.currentInput) !== void 0 ? $e2ab202322af4e74$var$Ne(t1.currentInput) : void 0) || this.Editor.BlockSelection.anyBlockSelected;
        if (e.shiftKey && e.keyCode === $e2ab202322af4e74$var$y.UP && i) {
            this.Editor.CrossBlockSelection.toggleBlockSelectedState(!1);
            return;
        }
        if (e.keyCode === $e2ab202322af4e74$var$y.UP || e.keyCode === $e2ab202322af4e74$var$y.LEFT && !this.isRtl ? this.Editor.Caret.navigatePrevious() : this.Editor.Caret.navigateNext()) {
            e.preventDefault();
            return;
        }
        $e2ab202322af4e74$var$Fe(()=>{
            this.Editor.BlockManager.currentBlock && this.Editor.BlockManager.currentBlock.updateCurrentInput();
        }, 20)(), this.Editor.BlockSelection.clearSelection(e);
    }
    /**
   * Cases when we need to close Toolbar
   *
   * @param {KeyboardEvent} event - keyboard event
   */ needToolbarClosing(e) {
        const t1 = e.keyCode === $e2ab202322af4e74$var$y.ENTER && this.Editor.Toolbar.toolbox.opened, o = e.keyCode === $e2ab202322af4e74$var$y.ENTER && this.Editor.BlockSettings.opened, i = e.keyCode === $e2ab202322af4e74$var$y.ENTER && this.Editor.InlineToolbar.opened, s = e.keyCode === $e2ab202322af4e74$var$y.TAB;
        return !(e.shiftKey || s || t1 || o || i);
    }
    /**
   * If Toolbox is not open, then just open it and show plus button
   */ activateToolbox() {
        this.Editor.Toolbar.opened || this.Editor.Toolbar.moveAndOpen(), this.Editor.Toolbar.toolbox.open();
    }
    /**
   * Open Toolbar and show BlockSettings before flipping Tools
   */ activateBlockSettings() {
        this.Editor.Toolbar.opened || this.Editor.Toolbar.moveAndOpen(), this.Editor.BlockSettings.opened || this.Editor.BlockSettings.open();
    }
}
class $e2ab202322af4e74$var$ct {
    /**
   * @class
   * @param {HTMLElement} workingArea — editor`s working node
   */ constructor(e){
        this.blocks = [], this.workingArea = e;
    }
    /**
   * Get length of Block instances array
   *
   * @returns {number}
   */ get length() {
        return this.blocks.length;
    }
    /**
   * Get Block instances array
   *
   * @returns {Block[]}
   */ get array() {
        return this.blocks;
    }
    /**
   * Get blocks html elements array
   *
   * @returns {HTMLElement[]}
   */ get nodes() {
        return $e2ab202322af4e74$var$No(this.workingArea.children);
    }
    /**
   * Proxy trap to implement array-like setter
   *
   * @example
   * blocks[0] = new Block(...)
   * @param {Blocks} instance — Blocks instance
   * @param {PropertyKey} property — block index or any Blocks class property key to set
   * @param {Block} value — value to set
   * @returns {boolean}
   */ static set(e, t1, o) {
        return isNaN(Number(t1)) ? (Reflect.set(e, t1, o), !0) : (e.insert(+t1, o), !0);
    }
    /**
   * Proxy trap to implement array-like getter
   *
   * @param {Blocks} instance — Blocks instance
   * @param {PropertyKey} property — Blocks class property key
   * @returns {Block|*}
   */ static get(e, t1) {
        return isNaN(Number(t1)) ? Reflect.get(e, t1) : e.get(+t1);
    }
    /**
   * Push new Block to the blocks array and append it to working area
   *
   * @param {Block} block - Block to add
   */ push(e) {
        this.blocks.push(e), this.insertToDOM(e);
    }
    /**
   * Swaps blocks with indexes first and second
   *
   * @param {number} first - first block index
   * @param {number} second - second block index
   * @deprecated — use 'move' instead
   */ swap(e, t1) {
        const o = this.blocks[t1];
        $e2ab202322af4e74$var$u.swap(this.blocks[e].holder, o.holder), this.blocks[t1] = this.blocks[e], this.blocks[e] = o;
    }
    /**
   * Move a block from one to another index
   *
   * @param {number} toIndex - new index of the block
   * @param {number} fromIndex - block to move
   */ move(e, t1) {
        const o = this.blocks.splice(t1, 1)[0], i = e - 1, s = Math.max(0, i), r = this.blocks[s];
        e > 0 ? this.insertToDOM(o, "afterend", r) : this.insertToDOM(o, "beforebegin", r), this.blocks.splice(e, 0, o);
        const a = this.composeBlockEvent("move", {
            fromIndex: t1,
            toIndex: e
        });
        o.call($e2ab202322af4e74$var$ee.MOVED, a);
    }
    /**
   * Insert new Block at passed index
   *
   * @param {number} index — index to insert Block
   * @param {Block} block — Block to insert
   * @param {boolean} replace — it true, replace block on given index
   */ insert(e, t1, o = !1) {
        if (!this.length) {
            this.push(t1);
            return;
        }
        e > this.length && (e = this.length), o && (this.blocks[e].holder.remove(), this.blocks[e].call($e2ab202322af4e74$var$ee.REMOVED));
        const i = o ? 1 : 0;
        if (this.blocks.splice(e, i, t1), e > 0) {
            const s = this.blocks[e - 1];
            this.insertToDOM(t1, "afterend", s);
        } else {
            const s = this.blocks[e + 1];
            s ? this.insertToDOM(t1, "beforebegin", s) : this.insertToDOM(t1);
        }
    }
    /**
   * Replaces block under passed index with passed block
   *
   * @param index - index of existed block
   * @param block - new block
   */ replace(e, t1) {
        if (this.blocks[e] === void 0) throw Error("Incorrect index");
        this.blocks[e].holder.replaceWith(t1.holder), this.blocks[e] = t1;
    }
    /**
   * Inserts several blocks at once
   *
   * @param blocks - blocks to insert
   * @param index - index to insert blocks at
   */ insertMany(e, t1) {
        const o = new DocumentFragment();
        for (const i of e)o.appendChild(i.holder);
        if (this.length > 0) {
            if (t1 > 0) {
                const i = Math.min(t1 - 1, this.length - 1);
                this.blocks[i].holder.after(o);
            } else t1 === 0 && this.workingArea.prepend(o);
            this.blocks.splice(t1, 0, ...e);
        } else this.blocks.push(...e), this.workingArea.appendChild(o);
        e.forEach((i)=>i.call($e2ab202322af4e74$var$ee.RENDERED));
    }
    /**
   * Remove block
   *
   * @param {number} index - index of Block to remove
   */ remove(e) {
        isNaN(e) && (e = this.length - 1), this.blocks[e].holder.remove(), this.blocks[e].call($e2ab202322af4e74$var$ee.REMOVED), this.blocks.splice(e, 1);
    }
    /**
   * Remove all blocks
   */ removeAll() {
        this.workingArea.innerHTML = "", this.blocks.forEach((e)=>e.call($e2ab202322af4e74$var$ee.REMOVED)), this.blocks.length = 0;
    }
    /**
   * Insert Block after passed target
   *
   * @todo decide if this method is necessary
   * @param {Block} targetBlock — target after which Block should be inserted
   * @param {Block} newBlock — Block to insert
   */ insertAfter(e, t1) {
        const o = this.blocks.indexOf(e);
        this.insert(o + 1, t1);
    }
    /**
   * Get Block by index
   *
   * @param {number} index — Block index
   * @returns {Block}
   */ get(e) {
        return this.blocks[e];
    }
    /**
   * Return index of passed Block
   *
   * @param {Block} block - Block to find
   * @returns {number}
   */ indexOf(e) {
        return this.blocks.indexOf(e);
    }
    /**
   * Insert new Block into DOM
   *
   * @param {Block} block - Block to insert
   * @param {InsertPosition} position — insert position (if set, will use insertAdjacentElement)
   * @param {Block} target — Block related to position
   */ insertToDOM(e, t1, o) {
        t1 ? o.holder.insertAdjacentElement(t1, e.holder) : this.workingArea.appendChild(e.holder), e.call($e2ab202322af4e74$var$ee.RENDERED);
    }
    /**
   * Composes Block event with passed type and details
   *
   * @param {string} type - event type
   * @param {object} detail - event detail
   */ composeBlockEvent(e, t1) {
        return new CustomEvent(e, {
            detail: t1
        });
    }
}
const $e2ab202322af4e74$var$_o = "block-removed", $e2ab202322af4e74$var$Mo = "block-added", $e2ab202322af4e74$var$ia = "block-moved", $e2ab202322af4e74$var$Ao = "block-changed";
class $e2ab202322af4e74$var$sa {
    constructor(){
        this.completed = Promise.resolve();
    }
    /**
   * Add new promise to queue
   *
   * @param operation - promise should be added to queue
   */ add(e) {
        return new Promise((t1, o)=>{
            this.completed = this.completed.then(e).then(t1).catch(o);
        });
    }
}
class $e2ab202322af4e74$var$ra extends $e2ab202322af4e74$var$E {
    constructor(){
        super(...arguments), this._currentBlockIndex = -1, this._blocks = null;
    }
    /**
   * Returns current Block index
   *
   * @returns {number}
   */ get currentBlockIndex() {
        return this._currentBlockIndex;
    }
    /**
   * Set current Block index and fire Block lifecycle callbacks
   *
   * @param {number} newIndex - index of Block to set as current
   */ set currentBlockIndex(e) {
        this._currentBlockIndex = e;
    }
    /**
   * returns first Block
   *
   * @returns {Block}
   */ get firstBlock() {
        return this._blocks[0];
    }
    /**
   * returns last Block
   *
   * @returns {Block}
   */ get lastBlock() {
        return this._blocks[this._blocks.length - 1];
    }
    /**
   * Get current Block instance
   *
   * @returns {Block}
   */ get currentBlock() {
        return this._blocks[this.currentBlockIndex];
    }
    /**
   * Set passed Block as a current
   *
   * @param block - block to set as a current
   */ set currentBlock(e) {
        this.currentBlockIndex = this.getBlockIndex(e);
    }
    /**
   * Returns next Block instance
   *
   * @returns {Block|null}
   */ get nextBlock() {
        return this.currentBlockIndex === this._blocks.length - 1 ? null : this._blocks[this.currentBlockIndex + 1];
    }
    /**
   * Return first Block with inputs after current Block
   *
   * @returns {Block | undefined}
   */ get nextContentfulBlock() {
        return this.blocks.slice(this.currentBlockIndex + 1).find((t1)=>!!t1.inputs.length);
    }
    /**
   * Return first Block with inputs before current Block
   *
   * @returns {Block | undefined}
   */ get previousContentfulBlock() {
        return this.blocks.slice(0, this.currentBlockIndex).reverse().find((t1)=>!!t1.inputs.length);
    }
    /**
   * Returns previous Block instance
   *
   * @returns {Block|null}
   */ get previousBlock() {
        return this.currentBlockIndex === 0 ? null : this._blocks[this.currentBlockIndex - 1];
    }
    /**
   * Get array of Block instances
   *
   * @returns {Block[]} {@link Blocks#array}
   */ get blocks() {
        return this._blocks.array;
    }
    /**
   * Check if each Block is empty
   *
   * @returns {boolean}
   */ get isEditorEmpty() {
        return this.blocks.every((e)=>e.isEmpty);
    }
    /**
   * Should be called after Editor.UI preparation
   * Define this._blocks property
   */ prepare() {
        const e = new $e2ab202322af4e74$var$ct(this.Editor.UI.nodes.redactor);
        this._blocks = new Proxy(e, {
            set: $e2ab202322af4e74$var$ct.set,
            get: $e2ab202322af4e74$var$ct.get
        }), this.listeners.on(document, "copy", (t1)=>this.Editor.BlockEvents.handleCommandC(t1));
    }
    /**
   * Toggle read-only state
   *
   * If readOnly is true:
   *  - Unbind event handlers from created Blocks
   *
   * if readOnly is false:
   *  - Bind event handlers to all existing Blocks
   *
   * @param {boolean} readOnlyEnabled - "read only" state
   */ toggleReadOnly(e) {
        e ? this.disableModuleBindings() : this.enableModuleBindings();
    }
    /**
   * Creates Block instance by tool name
   *
   * @param {object} options - block creation options
   * @param {string} options.tool - tools passed in editor config {@link EditorConfig#tools}
   * @param {string} [options.id] - unique id for this block
   * @param {BlockToolData} [options.data] - constructor params
   * @returns {Block}
   */ composeBlock({ tool: e, data: t1 = {}, id: o, tunes: i = {} }) {
        const s = this.Editor.ReadOnly.isEnabled, r = this.Editor.Tools.blockTools.get(e), a = new $e2ab202322af4e74$var$R({
            id: o,
            data: t1,
            tool: r,
            api: this.Editor.API,
            readOnly: s,
            tunesData: i
        }, this.eventsDispatcher);
        return s || window.requestIdleCallback(()=>{
            this.bindBlockEvents(a);
        }, {
            timeout: 2e3
        }), a;
    }
    /**
   * Insert new block into _blocks
   *
   * @param {object} options - insert options
   * @param {string} [options.id] - block's unique id
   * @param {string} [options.tool] - plugin name, by default method inserts the default block type
   * @param {object} [options.data] - plugin data
   * @param {number} [options.index] - index where to insert new Block
   * @param {boolean} [options.needToFocus] - flag shows if needed to update current Block index
   * @param {boolean} [options.replace] - flag shows if block by passed index should be replaced with inserted one
   * @returns {Block}
   */ insert({ id: e, tool: t1 = this.config.defaultBlock, data: o = {}, index: i, needToFocus: s = !0, replace: r = !1, tunes: a = {} } = {}) {
        let l = i;
        l === void 0 && (l = this.currentBlockIndex + (r ? 0 : 1));
        const c = this.composeBlock({
            id: e,
            tool: t1,
            data: o,
            tunes: a
        });
        return r && this.blockDidMutated($e2ab202322af4e74$var$_o, this.getBlockByIndex(l), {
            index: l
        }), this._blocks.insert(l, c, r), this.blockDidMutated($e2ab202322af4e74$var$Mo, c, {
            index: l
        }), s ? this.currentBlockIndex = l : l <= this.currentBlockIndex && this.currentBlockIndex++, c;
    }
    /**
   * Inserts several blocks at once
   *
   * @param blocks - blocks to insert
   * @param index - index where to insert
   */ insertMany(e, t1 = 0) {
        this._blocks.insertMany(e, t1);
    }
    /**
   * Update Block data.
   *
   * Currently we don't have an 'update' method in the Tools API, so we just create a new block with the same id and type
   * Should not trigger 'block-removed' or 'block-added' events.
   *
   * If neither data nor tunes is provided, return the provided block instead.
   *
   * @param block - block to update
   * @param data - (optional) new data
   * @param tunes - (optional) tune data
   */ async update(e, t1, o) {
        if (!t1 && !o) return e;
        const i = await e.data, s = this.composeBlock({
            id: e.id,
            tool: e.name,
            data: Object.assign({}, i, t1 ?? {}),
            tunes: o ?? e.tunes
        }), r = this.getBlockIndex(e);
        return this._blocks.replace(r, s), this.blockDidMutated($e2ab202322af4e74$var$Ao, s, {
            index: r
        }), s;
    }
    /**
   * Replace passed Block with the new one with specified Tool and data
   *
   * @param block - block to replace
   * @param newTool - new Tool name
   * @param data - new Tool data
   */ replace(e, t1, o) {
        const i = this.getBlockIndex(e);
        return this.insert({
            tool: t1,
            data: o,
            index: i,
            replace: !0
        });
    }
    /**
   * Insert pasted content. Call onPaste callback after insert.
   *
   * @param {string} toolName - name of Tool to insert
   * @param {PasteEvent} pasteEvent - pasted data
   * @param {boolean} replace - should replace current block
   */ paste(e, t1, o = !1) {
        const i = this.insert({
            tool: e,
            replace: o
        });
        try {
            window.requestIdleCallback(()=>{
                i.call($e2ab202322af4e74$var$ee.ON_PASTE, t1);
            });
        } catch (s) {
            $e2ab202322af4e74$var$S(`${e}: onPaste callback call is failed`, "error", s);
        }
        return i;
    }
    /**
   * Insert new default block at passed index
   *
   * @param {number} index - index where Block should be inserted
   * @param {boolean} needToFocus - if true, updates current Block index
   *
   * TODO: Remove method and use insert() with index instead (?)
   * @returns {Block} inserted Block
   */ insertDefaultBlockAtIndex(e, t1 = !1) {
        const o = this.composeBlock({
            tool: this.config.defaultBlock
        });
        return this._blocks[e] = o, this.blockDidMutated($e2ab202322af4e74$var$Mo, o, {
            index: e
        }), t1 ? this.currentBlockIndex = e : e <= this.currentBlockIndex && this.currentBlockIndex++, o;
    }
    /**
   * Always inserts at the end
   *
   * @returns {Block}
   */ insertAtEnd() {
        return this.currentBlockIndex = this.blocks.length - 1, this.insert();
    }
    /**
   * Merge two blocks
   *
   * @param {Block} targetBlock - previous block will be append to this block
   * @param {Block} blockToMerge - block that will be merged with target block
   * @returns {Promise} - the sequence that can be continued
   */ async mergeBlocks(e, t1) {
        let o;
        if (e.name === t1.name && e.mergeable) {
            const i = await t1.data;
            if ($e2ab202322af4e74$var$V(i)) {
                console.error("Could not merge Block. Failed to extract original Block data.");
                return;
            }
            const [s] = $e2ab202322af4e74$var$yt([
                i
            ], e.tool.sanitizeConfig);
            o = s;
        } else if (e.mergeable && $e2ab202322af4e74$var$He(t1, "export") && $e2ab202322af4e74$var$He(e, "import")) {
            const i = await t1.exportDataAsString(), s = $e2ab202322af4e74$var$Z(i, e.tool.sanitizeConfig);
            o = $e2ab202322af4e74$var$Bo(s, e.tool.conversionConfig);
        }
        o !== void 0 && (await e.mergeWith(o), this.removeBlock(t1), this.currentBlockIndex = this._blocks.indexOf(e));
    }
    /**
   * Remove passed Block
   *
   * @param block - Block to remove
   * @param addLastBlock - if true, adds new default block at the end. @todo remove this logic and use event-bus instead
   */ removeBlock(e, t1 = !0) {
        return new Promise((o)=>{
            const i = this._blocks.indexOf(e);
            if (!this.validateIndex(i)) throw new Error("Can't find a Block to remove");
            this._blocks.remove(i), e.destroy(), this.blockDidMutated($e2ab202322af4e74$var$_o, e, {
                index: i
            }), this.currentBlockIndex >= i && this.currentBlockIndex--, this.blocks.length ? i === 0 && (this.currentBlockIndex = 0) : (this.unsetCurrentBlock(), t1 && this.insert()), o();
        });
    }
    /**
   * Remove only selected Blocks
   * and returns first Block index where started removing...
   *
   * @returns {number|undefined}
   */ removeSelectedBlocks() {
        let e;
        for(let t1 = this.blocks.length - 1; t1 >= 0; t1--)this.blocks[t1].selected && (this.removeBlock(this.blocks[t1]), e = t1);
        return e;
    }
    /**
   * Attention!
   * After removing insert the new default typed Block and focus on it
   * Removes all blocks
   */ removeAllBlocks() {
        for(let e = this.blocks.length - 1; e >= 0; e--)this._blocks.remove(e);
        this.unsetCurrentBlock(), this.insert(), this.currentBlock.firstInput.focus();
    }
    /**
   * Split current Block
   * 1. Extract content from Caret position to the Block`s end
   * 2. Insert a new Block below current one with extracted content
   *
   * @returns {Block}
   */ split() {
        const e = this.Editor.Caret.extractFragmentFromCaretPosition(), t1 = $e2ab202322af4e74$var$u.make("div");
        t1.appendChild(e);
        const o = {
            text: $e2ab202322af4e74$var$u.isEmpty(t1) ? "" : t1.innerHTML
        };
        return this.insert({
            data: o
        });
    }
    /**
   * Returns Block by passed index
   *
   * @param {number} index - index to get. -1 to get last
   * @returns {Block}
   */ getBlockByIndex(e) {
        return e === -1 && (e = this._blocks.length - 1), this._blocks[e];
    }
    /**
   * Returns an index for passed Block
   *
   * @param block - block to find index
   */ getBlockIndex(e) {
        return this._blocks.indexOf(e);
    }
    /**
   * Returns the Block by passed id
   *
   * @param id - id of block to get
   * @returns {Block}
   */ getBlockById(e) {
        return this._blocks.array.find((t1)=>t1.id === e);
    }
    /**
   * Get Block instance by html element
   *
   * @param {Node} element - html element to get Block by
   */ getBlock(e) {
        $e2ab202322af4e74$var$u.isElement(e) || (e = e.parentNode);
        const t1 = this._blocks.nodes, o = e.closest(`.${$e2ab202322af4e74$var$R.CSS.wrapper}`), i = t1.indexOf(o);
        if (i >= 0) return this._blocks[i];
    }
    /**
   * 1) Find first-level Block from passed child Node
   * 2) Mark it as current
   *
   * @param {Node} childNode - look ahead from this node.
   * @returns {Block | undefined} can return undefined in case when the passed child note is not a part of the current editor instance
   */ setCurrentBlockByChildNode(e) {
        $e2ab202322af4e74$var$u.isElement(e) || (e = e.parentNode);
        const t1 = e.closest(`.${$e2ab202322af4e74$var$R.CSS.wrapper}`);
        if (!t1) return;
        const o = t1.closest(`.${this.Editor.UI.CSS.editorWrapper}`);
        if (o != null && o.isEqualNode(this.Editor.UI.nodes.wrapper)) return this.currentBlockIndex = this._blocks.nodes.indexOf(t1), this.currentBlock.updateCurrentInput(), this.currentBlock;
    }
    /**
   * Return block which contents passed node
   *
   * @param {Node} childNode - node to get Block by
   * @returns {Block}
   */ getBlockByChildNode(e) {
        if (!e || !(e instanceof Node)) return;
        $e2ab202322af4e74$var$u.isElement(e) || (e = e.parentNode);
        const t1 = e.closest(`.${$e2ab202322af4e74$var$R.CSS.wrapper}`);
        return this.blocks.find((o)=>o.holder === t1);
    }
    /**
   * Swap Blocks Position
   *
   * @param {number} fromIndex - index of first block
   * @param {number} toIndex - index of second block
   * @deprecated — use 'move' instead
   */ swap(e, t1) {
        this._blocks.swap(e, t1), this.currentBlockIndex = t1;
    }
    /**
   * Move a block to a new index
   *
   * @param {number} toIndex - index where to move Block
   * @param {number} fromIndex - index of Block to move
   */ move(e, t1 = this.currentBlockIndex) {
        if (isNaN(e) || isNaN(t1)) {
            $e2ab202322af4e74$var$S("Warning during 'move' call: incorrect indices provided.", "warn");
            return;
        }
        if (!this.validateIndex(e) || !this.validateIndex(t1)) {
            $e2ab202322af4e74$var$S("Warning during 'move' call: indices cannot be lower than 0 or greater than the amount of blocks.", "warn");
            return;
        }
        this._blocks.move(e, t1), this.currentBlockIndex = e, this.blockDidMutated($e2ab202322af4e74$var$ia, this.currentBlock, {
            fromIndex: t1,
            toIndex: e
        });
    }
    /**
   * Converts passed Block to the new Tool
   * Uses Conversion Config
   *
   * @param blockToConvert - Block that should be converted
   * @param targetToolName - name of the Tool to convert to
   * @param blockDataOverrides - optional new Block data overrides
   */ async convert(e, t1, o) {
        if (!await e.save()) throw new Error("Could not convert Block. Failed to extract original Block data.");
        const s = this.Editor.Tools.blockTools.get(t1);
        if (!s) throw new Error(`Could not convert Block. Tool \xab${t1}\xbb not found.`);
        const r = await e.exportDataAsString(), a = $e2ab202322af4e74$var$Z(r, s.sanitizeConfig);
        let l = $e2ab202322af4e74$var$Bo(a, s.conversionConfig, s.settings);
        return o && (l = Object.assign(l, o)), this.replace(e, s.name, l);
    }
    /**
   * Sets current Block Index -1 which means unknown
   * and clear highlights
   */ unsetCurrentBlock() {
        this.currentBlockIndex = -1;
    }
    /**
   * Clears Editor
   *
   * @param {boolean} needToAddDefaultBlock - 1) in internal calls (for example, in api.blocks.render)
   *                                             we don't need to add an empty default block
   *                                        2) in api.blocks.clear we should add empty block
   */ async clear(e = !1) {
        const t1 = new $e2ab202322af4e74$var$sa();
        [
            ...this.blocks
        ].forEach((i)=>{
            t1.add(async ()=>{
                await this.removeBlock(i, !1);
            });
        }), await t1.completed, this.unsetCurrentBlock(), e && this.insert(), this.Editor.UI.checkEmptiness();
    }
    /**
   * Cleans up all the block tools' resources
   * This is called when editor is destroyed
   */ async destroy() {
        await Promise.all(this.blocks.map((e)=>e.destroy()));
    }
    /**
   * Bind Block events
   *
   * @param {Block} block - Block to which event should be bound
   */ bindBlockEvents(e) {
        const { BlockEvents: t1 } = this.Editor;
        this.readOnlyMutableListeners.on(e.holder, "keydown", (o)=>{
            t1.keydown(o);
        }), this.readOnlyMutableListeners.on(e.holder, "keyup", (o)=>{
            t1.keyup(o);
        }), this.readOnlyMutableListeners.on(e.holder, "dragover", (o)=>{
            t1.dragOver(o);
        }), this.readOnlyMutableListeners.on(e.holder, "dragleave", (o)=>{
            t1.dragLeave(o);
        }), e.on("didMutated", (o)=>this.blockDidMutated($e2ab202322af4e74$var$Ao, o, {
                index: this.getBlockIndex(o)
            }));
    }
    /**
   * Disable mutable handlers and bindings
   */ disableModuleBindings() {
        this.readOnlyMutableListeners.clearAll();
    }
    /**
   * Enables all module handlers and bindings for all Blocks
   */ enableModuleBindings() {
        this.readOnlyMutableListeners.on(document, "cut", (e)=>this.Editor.BlockEvents.handleCommandX(e)), this.blocks.forEach((e)=>{
            this.bindBlockEvents(e);
        });
    }
    /**
   * Validates that the given index is not lower than 0 or higher than the amount of blocks
   *
   * @param {number} index - index of blocks array to validate
   * @returns {boolean}
   */ validateIndex(e) {
        return !(e < 0 || e >= this._blocks.length);
    }
    /**
   * Block mutation callback
   *
   * @param mutationType - what happened with block
   * @param block - mutated block
   * @param detailData - additional data to pass with change event
   */ blockDidMutated(e, t1, o) {
        const i = new CustomEvent(e, {
            detail: {
                target: new $e2ab202322af4e74$var$J(t1),
                ...o
            }
        });
        return this.eventsDispatcher.emit($e2ab202322af4e74$var$$o, {
            event: i
        }), t1;
    }
}
class $e2ab202322af4e74$var$aa extends $e2ab202322af4e74$var$E {
    constructor(){
        super(...arguments), this.anyBlockSelectedCache = null, this.needToSelectAll = !1, this.nativeInputSelected = !1, this.readyToBlockSelection = !1;
    }
    /**
   * Sanitizer Config
   *
   * @returns {SanitizerConfig}
   */ get sanitizerConfig() {
        return {
            p: {},
            h1: {},
            h2: {},
            h3: {},
            h4: {},
            h5: {},
            h6: {},
            ol: {},
            ul: {},
            li: {},
            br: !0,
            img: {
                src: !0,
                width: !0,
                height: !0
            },
            a: {
                href: !0
            },
            b: {},
            i: {},
            u: {}
        };
    }
    /**
   * Flag that identifies all Blocks selection
   *
   * @returns {boolean}
   */ get allBlocksSelected() {
        const { BlockManager: e } = this.Editor;
        return e.blocks.every((t1)=>t1.selected === !0);
    }
    /**
   * Set selected all blocks
   *
   * @param {boolean} state - state to set
   */ set allBlocksSelected(e) {
        const { BlockManager: t1 } = this.Editor;
        t1.blocks.forEach((o)=>{
            o.selected = e;
        }), this.clearCache();
    }
    /**
   * Flag that identifies any Block selection
   *
   * @returns {boolean}
   */ get anyBlockSelected() {
        const { BlockManager: e } = this.Editor;
        return this.anyBlockSelectedCache === null && (this.anyBlockSelectedCache = e.blocks.some((t1)=>t1.selected === !0)), this.anyBlockSelectedCache;
    }
    /**
   * Return selected Blocks array
   *
   * @returns {Block[]}
   */ get selectedBlocks() {
        return this.Editor.BlockManager.blocks.filter((e)=>e.selected);
    }
    /**
   * Module Preparation
   * Registers Shortcuts CMD+A and CMD+C
   * to select all and copy them
   */ prepare() {
        this.selection = new $e2ab202322af4e74$var$b(), $e2ab202322af4e74$var$ge.add({
            name: "CMD+A",
            handler: (e)=>{
                const { BlockManager: t1, ReadOnly: o } = this.Editor;
                if (o.isEnabled) {
                    e.preventDefault(), this.selectAllBlocks();
                    return;
                }
                t1.currentBlock && this.handleCommandA(e);
            },
            on: this.Editor.UI.nodes.redactor
        });
    }
    /**
   * Toggle read-only state
   *
   *  - Remove all ranges
   *  - Unselect all Blocks
   */ toggleReadOnly() {
        $e2ab202322af4e74$var$b.get().removeAllRanges(), this.allBlocksSelected = !1;
    }
    /**
   * Remove selection of Block
   *
   * @param {number?} index - Block index according to the BlockManager's indexes
   */ unSelectBlockByIndex(e) {
        const { BlockManager: t1 } = this.Editor;
        let o;
        isNaN(e) ? o = t1.currentBlock : o = t1.getBlockByIndex(e), o.selected = !1, this.clearCache();
    }
    /**
   * Clear selection from Blocks
   *
   * @param {Event} reason - event caused clear of selection
   * @param {boolean} restoreSelection - if true, restore saved selection
   */ clearSelection(e, t1 = !1) {
        const { BlockManager: o, Caret: i, RectangleSelection: s } = this.Editor;
        this.needToSelectAll = !1, this.nativeInputSelected = !1, this.readyToBlockSelection = !1;
        const r = e && e instanceof KeyboardEvent, a = r && $e2ab202322af4e74$var$Po(e.keyCode);
        if (this.anyBlockSelected && r && a && !$e2ab202322af4e74$var$b.isSelectionExists) {
            const l = o.removeSelectedBlocks();
            o.insertDefaultBlockAtIndex(l, !0), i.setToBlock(o.currentBlock), $e2ab202322af4e74$var$Fe(()=>{
                const c = e.key;
                i.insertContentAtCaretPosition(c.length > 1 ? "" : c);
            }, 20)();
        }
        if (this.Editor.CrossBlockSelection.clear(e), !this.anyBlockSelected || s.isRectActivated()) {
            this.Editor.RectangleSelection.clearSelection();
            return;
        }
        t1 && this.selection.restore(), this.allBlocksSelected = !1;
    }
    /**
   * Reduce each Block and copy its content
   *
   * @param {ClipboardEvent} e - copy/cut event
   * @returns {Promise<void>}
   */ copySelectedBlocks(e) {
        e.preventDefault();
        const t1 = $e2ab202322af4e74$var$u.make("div");
        this.selectedBlocks.forEach((s)=>{
            const r = $e2ab202322af4e74$var$Z(s.holder.innerHTML, this.sanitizerConfig), a = $e2ab202322af4e74$var$u.make("p");
            a.innerHTML = r, t1.appendChild(a);
        });
        const o = Array.from(t1.childNodes).map((s)=>s.textContent).join(`

`), i = t1.innerHTML;
        return e.clipboardData.setData("text/plain", o), e.clipboardData.setData("text/html", i), Promise.all(this.selectedBlocks.map((s)=>s.save())).then((s)=>{
            try {
                e.clipboardData.setData(this.Editor.Paste.MIME_TYPE, JSON.stringify(s));
            } catch  {}
        });
    }
    /**
   * Select Block by its index
   *
   * @param {number?} index - Block index according to the BlockManager's indexes
   */ selectBlockByIndex(e) {
        const { BlockManager: t1 } = this.Editor, o = t1.getBlockByIndex(e);
        o !== void 0 && this.selectBlock(o);
    }
    /**
   * Select passed Block
   *
   * @param {Block} block - Block to select
   */ selectBlock(e) {
        this.selection.save(), $e2ab202322af4e74$var$b.get().removeAllRanges(), e.selected = !0, this.clearCache(), this.Editor.InlineToolbar.close();
    }
    /**
   * Remove selection from passed Block
   *
   * @param {Block} block - Block to unselect
   */ unselectBlock(e) {
        e.selected = !1, this.clearCache();
    }
    /**
   * Clear anyBlockSelected cache
   */ clearCache() {
        this.anyBlockSelectedCache = null;
    }
    /**
   * Module destruction
   * De-registers Shortcut CMD+A
   */ destroy() {
        $e2ab202322af4e74$var$ge.remove(this.Editor.UI.nodes.redactor, "CMD+A");
    }
    /**
   * First CMD+A selects all input content by native behaviour,
   * next CMD+A keypress selects all blocks
   *
   * @param {KeyboardEvent} event - keyboard event
   */ handleCommandA(e) {
        if (this.Editor.RectangleSelection.clearSelection(), $e2ab202322af4e74$var$u.isNativeInput(e.target) && !this.readyToBlockSelection) {
            this.readyToBlockSelection = !0;
            return;
        }
        const t1 = this.Editor.BlockManager.getBlock(e.target), o = t1.inputs;
        if (o.length > 1 && !this.readyToBlockSelection) {
            this.readyToBlockSelection = !0;
            return;
        }
        if (o.length === 1 && !this.needToSelectAll) {
            this.needToSelectAll = !0;
            return;
        }
        this.needToSelectAll ? (e.preventDefault(), this.selectAllBlocks(), this.needToSelectAll = !1, this.readyToBlockSelection = !1) : this.readyToBlockSelection && (e.preventDefault(), this.selectBlock(t1), this.needToSelectAll = !0);
    }
    /**
   * Select All Blocks
   * Each Block has selected setter that makes Block copyable
   */ selectAllBlocks() {
        this.selection.save(), $e2ab202322af4e74$var$b.get().removeAllRanges(), this.allBlocksSelected = !0, this.Editor.InlineToolbar.close();
    }
}
class $e2ab202322af4e74$var$Ye extends $e2ab202322af4e74$var$E {
    /**
   * Allowed caret positions in input
   *
   * @static
   * @returns {{START: string, END: string, DEFAULT: string}}
   */ get positions() {
        return {
            START: "start",
            END: "end",
            DEFAULT: "default"
        };
    }
    /**
   * Elements styles that can be useful for Caret Module
   */ static get CSS() {
        return {
            shadowCaret: "cdx-shadow-caret"
        };
    }
    /**
   * Method gets Block instance and puts caret to the text node with offset
   * There two ways that method applies caret position:
   *   - first found text node: sets at the beginning, but you can pass an offset
   *   - last found text node: sets at the end of the node. Also, you can customize the behaviour
   *
   * @param {Block} block - Block class
   * @param {string} position - position where to set caret.
   *                            If default - leave default behaviour and apply offset if it's passed
   * @param {number} offset - caret offset regarding to the block content
   */ setToBlock(e, t1 = this.positions.DEFAULT, o = 0) {
        var c;
        const { BlockManager: i, BlockSelection: s } = this.Editor;
        if (s.clearSelection(), !e.focusable) {
            (c = window.getSelection()) == null || c.removeAllRanges(), s.selectBlock(e), i.currentBlock = e;
            return;
        }
        let r;
        switch(t1){
            case this.positions.START:
                r = e.firstInput;
                break;
            case this.positions.END:
                r = e.lastInput;
                break;
            default:
                r = e.currentInput;
        }
        if (!r) return;
        let a, l = o;
        if (t1 === this.positions.START) a = $e2ab202322af4e74$var$u.getDeepestNode(r, !1), l = 0;
        else if (t1 === this.positions.END) a = $e2ab202322af4e74$var$u.getDeepestNode(r, !0), l = $e2ab202322af4e74$var$u.getContentLength(a);
        else {
            const { node: d, offset: h } = $e2ab202322af4e74$var$u.getNodeByOffset(r, o);
            d ? (a = d, l = h) : (a = $e2ab202322af4e74$var$u.getDeepestNode(r, !1), l = 0);
        }
        this.set(a, l), i.setCurrentBlockByChildNode(e.holder), i.currentBlock.currentInput = r;
    }
    /**
   * Set caret to the current input of current Block.
   *
   * @param {HTMLElement} input - input where caret should be set
   * @param {string} position - position of the caret.
   *                            If default - leave default behaviour and apply offset if it's passed
   * @param {number} offset - caret offset regarding to the text node
   */ setToInput(e, t1 = this.positions.DEFAULT, o = 0) {
        const { currentBlock: i } = this.Editor.BlockManager, s = $e2ab202322af4e74$var$u.getDeepestNode(e);
        switch(t1){
            case this.positions.START:
                this.set(s, 0);
                break;
            case this.positions.END:
                this.set(s, $e2ab202322af4e74$var$u.getContentLength(s));
                break;
            default:
                o && this.set(s, o);
        }
        i.currentInput = e;
    }
    /**
   * Creates Document Range and sets caret to the element with offset
   *
   * @param {HTMLElement} element - target node.
   * @param {number} offset - offset
   */ set(e, t1 = 0) {
        const { top: i, bottom: s } = $e2ab202322af4e74$var$b.setCursor(e, t1), { innerHeight: r } = window;
        i < 0 ? window.scrollBy(0, i - 30) : s > r && window.scrollBy(0, s - r + 30);
    }
    /**
   * Set Caret to the last Block
   * If last block is not empty, append another empty block
   */ setToTheLastBlock() {
        const e = this.Editor.BlockManager.lastBlock;
        if (e) {
            if (e.tool.isDefault && e.isEmpty) this.setToBlock(e);
            else {
                const t1 = this.Editor.BlockManager.insertAtEnd();
                this.setToBlock(t1);
            }
        }
    }
    /**
   * Extract content fragment of current Block from Caret position to the end of the Block
   */ extractFragmentFromCaretPosition() {
        const e = $e2ab202322af4e74$var$b.get();
        if (e.rangeCount) {
            const t1 = e.getRangeAt(0), o = this.Editor.BlockManager.currentBlock.currentInput;
            if (t1.deleteContents(), o) {
                if ($e2ab202322af4e74$var$u.isNativeInput(o)) {
                    const i = o, s = document.createDocumentFragment(), r = i.value.substring(0, i.selectionStart), a = i.value.substring(i.selectionStart);
                    return s.textContent = a, i.value = r, s;
                } else {
                    const i = t1.cloneRange();
                    return i.selectNodeContents(o), i.setStart(t1.endContainer, t1.endOffset), i.extractContents();
                }
            }
        }
    }
    /**
   * Set's caret to the next Block or Tool`s input
   * Before moving caret, we should check if caret position is at the end of Plugins node
   * Using {@link Dom#getDeepestNode} to get a last node and match with current selection
   *
   * @param {boolean} force - pass true to skip check for caret position
   */ navigateNext(e = !1) {
        const { BlockManager: t1 } = this.Editor, { currentBlock: o, nextBlock: i } = t1;
        if (o === void 0) return !1;
        const { nextInput: s, currentInput: r } = o, a = r !== void 0 ? $e2ab202322af4e74$var$Re(r) : void 0;
        let l = i;
        const c = e || a || !o.focusable;
        if (s && c) return this.setToInput(s, this.positions.START), !0;
        if (l === null) {
            if (o.tool.isDefault || !c) return !1;
            l = t1.insertAtEnd();
        }
        return c ? (this.setToBlock(l, this.positions.START), !0) : !1;
    }
    /**
   * Set's caret to the previous Tool`s input or Block
   * Before moving caret, we should check if caret position is start of the Plugins node
   * Using {@link Dom#getDeepestNode} to get a last node and match with current selection
   *
   * @param {boolean} force - pass true to skip check for caret position
   */ navigatePrevious(e = !1) {
        const { currentBlock: t1, previousBlock: o } = this.Editor.BlockManager;
        if (!t1) return !1;
        const { previousInput: i, currentInput: s } = t1, r = s !== void 0 ? $e2ab202322af4e74$var$Ne(s) : void 0, a = e || r || !t1.focusable;
        return i && a ? (this.setToInput(i, this.positions.END), !0) : o !== null && a ? (this.setToBlock(o, this.positions.END), !0) : !1;
    }
    /**
   * Inserts shadow element after passed element where caret can be placed
   *
   * @param {Element} element - element after which shadow caret should be inserted
   */ createShadow(e) {
        const t1 = document.createElement("span");
        t1.classList.add($e2ab202322af4e74$var$Ye.CSS.shadowCaret), e.insertAdjacentElement("beforeend", t1);
    }
    /**
   * Restores caret position
   *
   * @param {HTMLElement} element - element where caret should be restored
   */ restoreCaret(e) {
        const t1 = e.querySelector(`.${$e2ab202322af4e74$var$Ye.CSS.shadowCaret}`);
        if (!t1) return;
        new $e2ab202322af4e74$var$b().expandToTag(t1);
        const i = document.createRange();
        i.selectNode(t1), i.extractContents();
    }
    /**
   * Inserts passed content at caret position
   *
   * @param {string} content - content to insert
   */ insertContentAtCaretPosition(e) {
        const t1 = document.createDocumentFragment(), o = document.createElement("div"), i = $e2ab202322af4e74$var$b.get(), s = $e2ab202322af4e74$var$b.range;
        o.innerHTML = e, Array.from(o.childNodes).forEach((c)=>t1.appendChild(c)), t1.childNodes.length === 0 && t1.appendChild(new Text());
        const r = t1.lastChild;
        s.deleteContents(), s.insertNode(t1);
        const a = document.createRange(), l = r.nodeType === Node.TEXT_NODE ? r : r.firstChild;
        l !== null && l.textContent !== null && a.setStart(l, l.textContent.length), i.removeAllRanges(), i.addRange(a);
    }
}
class $e2ab202322af4e74$var$la extends $e2ab202322af4e74$var$E {
    constructor(){
        super(...arguments), this.onMouseUp = ()=>{
            this.listeners.off(document, "mouseover", this.onMouseOver), this.listeners.off(document, "mouseup", this.onMouseUp);
        }, this.onMouseOver = (e)=>{
            const { BlockManager: t1, BlockSelection: o } = this.Editor;
            if (e.relatedTarget === null && e.target === null) return;
            const i = t1.getBlockByChildNode(e.relatedTarget) || this.lastSelectedBlock, s = t1.getBlockByChildNode(e.target);
            if (!(!i || !s) && s !== i) {
                if (i === this.firstSelectedBlock) {
                    $e2ab202322af4e74$var$b.get().removeAllRanges(), i.selected = !0, s.selected = !0, o.clearCache();
                    return;
                }
                if (s === this.firstSelectedBlock) {
                    i.selected = !1, s.selected = !1, o.clearCache();
                    return;
                }
                this.Editor.InlineToolbar.close(), this.toggleBlocksSelectedState(i, s), this.lastSelectedBlock = s;
            }
        };
    }
    /**
   * Module preparation
   *
   * @returns {Promise}
   */ async prepare() {
        this.listeners.on(document, "mousedown", (e)=>{
            this.enableCrossBlockSelection(e);
        });
    }
    /**
   * Sets up listeners
   *
   * @param {MouseEvent} event - mouse down event
   */ watchSelection(e) {
        if (e.button !== $e2ab202322af4e74$var$qn.LEFT) return;
        const { BlockManager: t1 } = this.Editor;
        this.firstSelectedBlock = t1.getBlock(e.target), this.lastSelectedBlock = this.firstSelectedBlock, this.listeners.on(document, "mouseover", this.onMouseOver), this.listeners.on(document, "mouseup", this.onMouseUp);
    }
    /**
   * Return boolean is cross block selection started:
   * there should be at least 2 selected blocks
   */ get isCrossBlockSelectionStarted() {
        return !!this.firstSelectedBlock && !!this.lastSelectedBlock && this.firstSelectedBlock !== this.lastSelectedBlock;
    }
    /**
   * Change selection state of the next Block
   * Used for CBS via Shift + arrow keys
   *
   * @param {boolean} next - if true, toggle next block. Previous otherwise
   */ toggleBlockSelectedState(e = !0) {
        const { BlockManager: t1, BlockSelection: o } = this.Editor;
        this.lastSelectedBlock || (this.lastSelectedBlock = this.firstSelectedBlock = t1.currentBlock), this.firstSelectedBlock === this.lastSelectedBlock && (this.firstSelectedBlock.selected = !0, o.clearCache(), $e2ab202322af4e74$var$b.get().removeAllRanges());
        const i = t1.blocks.indexOf(this.lastSelectedBlock) + (e ? 1 : -1), s = t1.blocks[i];
        s && (this.lastSelectedBlock.selected !== s.selected ? (s.selected = !0, o.clearCache()) : (this.lastSelectedBlock.selected = !1, o.clearCache()), this.lastSelectedBlock = s, this.Editor.InlineToolbar.close(), s.holder.scrollIntoView({
            block: "nearest"
        }));
    }
    /**
   * Clear saved state
   *
   * @param {Event} reason - event caused clear of selection
   */ clear(e) {
        const { BlockManager: t1, BlockSelection: o, Caret: i } = this.Editor, s = t1.blocks.indexOf(this.firstSelectedBlock), r = t1.blocks.indexOf(this.lastSelectedBlock);
        if (o.anyBlockSelected && s > -1 && r > -1 && e && e instanceof KeyboardEvent) switch(e.keyCode){
            case $e2ab202322af4e74$var$y.DOWN:
            case $e2ab202322af4e74$var$y.RIGHT:
                i.setToBlock(t1.blocks[Math.max(s, r)], i.positions.END);
                break;
            case $e2ab202322af4e74$var$y.UP:
            case $e2ab202322af4e74$var$y.LEFT:
                i.setToBlock(t1.blocks[Math.min(s, r)], i.positions.START);
                break;
            default:
                i.setToBlock(t1.blocks[Math.max(s, r)], i.positions.END);
        }
        this.firstSelectedBlock = this.lastSelectedBlock = null;
    }
    /**
   * Enables Cross Block Selection
   *
   * @param {MouseEvent} event - mouse down event
   */ enableCrossBlockSelection(e) {
        const { UI: t1 } = this.Editor;
        $e2ab202322af4e74$var$b.isCollapsed || this.Editor.BlockSelection.clearSelection(e), t1.nodes.redactor.contains(e.target) ? this.watchSelection(e) : this.Editor.BlockSelection.clearSelection(e);
    }
    /**
   * Change blocks selection state between passed two blocks.
   *
   * @param {Block} firstBlock - first block in range
   * @param {Block} lastBlock - last block in range
   */ toggleBlocksSelectedState(e, t1) {
        const { BlockManager: o, BlockSelection: i } = this.Editor, s = o.blocks.indexOf(e), r = o.blocks.indexOf(t1), a = e.selected !== t1.selected;
        for(let l = Math.min(s, r); l <= Math.max(s, r); l++){
            const c = o.blocks[l];
            c !== this.firstSelectedBlock && c !== (a ? e : t1) && (o.blocks[l].selected = !o.blocks[l].selected, i.clearCache());
        }
    }
}
class $e2ab202322af4e74$var$ca extends $e2ab202322af4e74$var$E {
    constructor(){
        super(...arguments), this.isStartedAtEditor = !1;
    }
    /**
   * Toggle read-only state
   *
   * if state is true:
   *  - disable all drag-n-drop event handlers
   *
   * if state is false:
   *  - restore drag-n-drop event handlers
   *
   * @param {boolean} readOnlyEnabled - "read only" state
   */ toggleReadOnly(e) {
        e ? this.disableModuleBindings() : this.enableModuleBindings();
    }
    /**
   * Add drag events listeners to editor zone
   */ enableModuleBindings() {
        const { UI: e } = this.Editor;
        this.readOnlyMutableListeners.on(e.nodes.holder, "drop", async (t1)=>{
            await this.processDrop(t1);
        }, !0), this.readOnlyMutableListeners.on(e.nodes.holder, "dragstart", ()=>{
            this.processDragStart();
        }), this.readOnlyMutableListeners.on(e.nodes.holder, "dragover", (t1)=>{
            this.processDragOver(t1);
        }, !0);
    }
    /**
   * Unbind drag-n-drop event handlers
   */ disableModuleBindings() {
        this.readOnlyMutableListeners.clearAll();
    }
    /**
   * Handle drop event
   *
   * @param {DragEvent} dropEvent - drop event
   */ async processDrop(e) {
        const { BlockManager: t1, Paste: o, Caret: i } = this.Editor;
        e.preventDefault(), t1.blocks.forEach((r)=>{
            r.dropTarget = !1;
        }), $e2ab202322af4e74$var$b.isAtEditor && !$e2ab202322af4e74$var$b.isCollapsed && this.isStartedAtEditor && document.execCommand("delete"), this.isStartedAtEditor = !1;
        const s = t1.setCurrentBlockByChildNode(e.target);
        if (s) this.Editor.Caret.setToBlock(s, i.positions.END);
        else {
            const r = t1.setCurrentBlockByChildNode(t1.lastBlock.holder);
            this.Editor.Caret.setToBlock(r, i.positions.END);
        }
        await o.processDataTransfer(e.dataTransfer, !0);
    }
    /**
   * Handle drag start event
   */ processDragStart() {
        $e2ab202322af4e74$var$b.isAtEditor && !$e2ab202322af4e74$var$b.isCollapsed && (this.isStartedAtEditor = !0), this.Editor.InlineToolbar.close();
    }
    /**
   * @param {DragEvent} dragEvent - drag event
   */ processDragOver(e) {
        e.preventDefault();
    }
}
const $e2ab202322af4e74$var$da = 180, $e2ab202322af4e74$var$ua = 400;
class $e2ab202322af4e74$var$ha extends $e2ab202322af4e74$var$E {
    /**
   * Prepare the module
   *
   * @param options - options used by the modification observer module
   * @param options.config - Editor configuration object
   * @param options.eventsDispatcher - common Editor event bus
   */ constructor({ config: e, eventsDispatcher: t1 }){
        super({
            config: e,
            eventsDispatcher: t1
        }), this.disabled = !1, this.batchingTimeout = null, this.batchingOnChangeQueue = /* @__PURE__ */ new Map(), this.batchTime = $e2ab202322af4e74$var$ua, this.mutationObserver = new MutationObserver((o)=>{
            this.redactorChanged(o);
        }), this.eventsDispatcher.on($e2ab202322af4e74$var$$o, (o)=>{
            this.particularBlockChanged(o.event);
        }), this.eventsDispatcher.on($e2ab202322af4e74$var$zo, ()=>{
            this.disable();
        }), this.eventsDispatcher.on($e2ab202322af4e74$var$Uo, ()=>{
            this.enable();
        });
    }
    /**
   * Enables onChange event
   */ enable() {
        this.mutationObserver.observe(this.Editor.UI.nodes.redactor, {
            childList: !0,
            subtree: !0,
            characterData: !0,
            attributes: !0
        }), this.disabled = !1;
    }
    /**
   * Disables onChange event
   */ disable() {
        this.mutationObserver.disconnect(), this.disabled = !0;
    }
    /**
   * Call onChange event passed to Editor.js configuration
   *
   * @param event - some of our custom change events
   */ particularBlockChanged(e) {
        this.disabled || !$e2ab202322af4e74$var$A(this.config.onChange) || (this.batchingOnChangeQueue.set(`block:${e.detail.target.id}:event:${e.type}`, e), this.batchingTimeout && clearTimeout(this.batchingTimeout), this.batchingTimeout = setTimeout(()=>{
            let t1;
            this.batchingOnChangeQueue.size === 1 ? t1 = this.batchingOnChangeQueue.values().next().value : t1 = Array.from(this.batchingOnChangeQueue.values()), this.config.onChange && this.config.onChange(this.Editor.API.methods, t1), this.batchingOnChangeQueue.clear();
        }, this.batchTime));
    }
    /**
   * Fired on every blocks wrapper dom change
   *
   * @param mutations - mutations happened
   */ redactorChanged(e) {
        this.eventsDispatcher.emit($e2ab202322af4e74$var$ft, {
            mutations: e
        });
    }
}
const $e2ab202322af4e74$var$Rn = class Dn extends $e2ab202322af4e74$var$E {
    constructor(){
        super(...arguments), this.MIME_TYPE = "application/x-editor-js", this.toolsTags = {}, this.tagsByTool = {}, this.toolsPatterns = [], this.toolsFiles = {}, this.exceptionList = [], this.processTool = (e)=>{
            try {
                const t1 = e.create({}, {}, !1);
                if (e.pasteConfig === !1) {
                    this.exceptionList.push(e.name);
                    return;
                }
                if (!$e2ab202322af4e74$var$A(t1.onPaste)) return;
                this.getTagsConfig(e), this.getFilesConfig(e), this.getPatternsConfig(e);
            } catch (t1) {
                $e2ab202322af4e74$var$S(`Paste handling for \xab${e.name}\xbb Tool hasn't been set up because of the error`, "warn", t1);
            }
        }, this.handlePasteEvent = async (e)=>{
            const { BlockManager: t1, Toolbar: o } = this.Editor, i = t1.setCurrentBlockByChildNode(e.target);
            !i || this.isNativeBehaviour(e.target) && !e.clipboardData.types.includes("Files") || i && this.exceptionList.includes(i.name) || (e.preventDefault(), this.processDataTransfer(e.clipboardData), o.close());
        };
    }
    /**
   * Set onPaste callback and collect tools` paste configurations
   */ async prepare() {
        this.processTools();
    }
    /**
   * Set read-only state
   *
   * @param {boolean} readOnlyEnabled - read only flag value
   */ toggleReadOnly(e) {
        e ? this.unsetCallback() : this.setCallback();
    }
    /**
   * Handle pasted or dropped data transfer object
   *
   * @param {DataTransfer} dataTransfer - pasted or dropped data transfer object
   * @param {boolean} isDragNDrop - true if data transfer comes from drag'n'drop events
   */ async processDataTransfer(e, t1 = !1) {
        const { Tools: o } = this.Editor, i = e.types;
        if ((i.includes ? i.includes("Files") : i.contains("Files")) && !$e2ab202322af4e74$var$V(this.toolsFiles)) {
            await this.processFiles(e.files);
            return;
        }
        const r = e.getData(this.MIME_TYPE), a = e.getData("text/plain");
        let l = e.getData("text/html");
        if (r) try {
            this.insertEditorJSData(JSON.parse(r));
            return;
        } catch  {}
        t1 && a.trim() && l.trim() && (l = "<p>" + (l.trim() ? l : a) + "</p>");
        const c = Object.keys(this.toolsTags).reduce((p, g)=>(p[g.toLowerCase()] = this.toolsTags[g].sanitizationConfig ?? {}, p), {}), d = Object.assign({}, c, o.getAllInlineToolsSanitizeConfig(), {
            br: {}
        }), h = $e2ab202322af4e74$var$Z(l, d);
        !h.trim() || h.trim() === a || !$e2ab202322af4e74$var$u.isHTMLString(h) ? await this.processText(a) : await this.processText(h, !0);
    }
    /**
   * Process pasted text and divide them into Blocks
   *
   * @param {string} data - text to process. Can be HTML or plain.
   * @param {boolean} isHTML - if passed string is HTML, this parameter should be true
   */ async processText(e, t1 = !1) {
        const { Caret: o, BlockManager: i } = this.Editor, s = t1 ? this.processHTML(e) : this.processPlain(e);
        if (!s.length) return;
        if (s.length === 1) {
            s[0].isBlock ? this.processSingleBlock(s.pop()) : this.processInlinePaste(s.pop());
            return;
        }
        const a = i.currentBlock && i.currentBlock.tool.isDefault && i.currentBlock.isEmpty;
        s.map(async (l, c)=>this.insertBlock(l, c === 0 && a)), i.currentBlock && o.setToBlock(i.currentBlock, o.positions.END);
    }
    /**
   * Set onPaste callback handler
   */ setCallback() {
        this.listeners.on(this.Editor.UI.nodes.holder, "paste", this.handlePasteEvent);
    }
    /**
   * Unset onPaste callback handler
   */ unsetCallback() {
        this.listeners.off(this.Editor.UI.nodes.holder, "paste", this.handlePasteEvent);
    }
    /**
   * Get and process tool`s paste configs
   */ processTools() {
        const e = this.Editor.Tools.blockTools;
        Array.from(e.values()).forEach(this.processTool);
    }
    /**
   * Get tags name list from either tag name or sanitization config.
   *
   * @param {string | object} tagOrSanitizeConfig - tag name or sanitize config object.
   * @returns {string[]} array of tags.
   */ collectTagNames(e) {
        return $e2ab202322af4e74$var$te(e) ? [
            e
        ] : $e2ab202322af4e74$var$D(e) ? Object.keys(e) : [];
    }
    /**
   * Get tags to substitute by Tool
   *
   * @param tool - BlockTool object
   */ getTagsConfig(e) {
        if (e.pasteConfig === !1) return;
        const t1 = e.pasteConfig.tags || [], o = [];
        t1.forEach((i)=>{
            const s = this.collectTagNames(i);
            o.push(...s), s.forEach((r)=>{
                if (Object.prototype.hasOwnProperty.call(this.toolsTags, r)) {
                    $e2ab202322af4e74$var$S(`Paste handler for \xab${e.name}\xbb Tool on \xab${r}\xbb tag is skipped because it is already used by \xab${this.toolsTags[r].tool.name}\xbb Tool.`, "warn");
                    return;
                }
                const a = $e2ab202322af4e74$var$D(i) ? i[r] : null;
                this.toolsTags[r.toUpperCase()] = {
                    tool: e,
                    sanitizationConfig: a
                };
            });
        }), this.tagsByTool[e.name] = o.map((i)=>i.toUpperCase());
    }
    /**
   * Get files` types and extensions to substitute by Tool
   *
   * @param tool - BlockTool object
   */ getFilesConfig(e) {
        if (e.pasteConfig === !1) return;
        const { files: t1 = {} } = e.pasteConfig;
        let { extensions: o, mimeTypes: i } = t1;
        !o && !i || (o && !Array.isArray(o) && ($e2ab202322af4e74$var$S(`\xabextensions\xbb property of the onDrop config for \xab${e.name}\xbb Tool should be an array`), o = []), i && !Array.isArray(i) && ($e2ab202322af4e74$var$S(`\xabmimeTypes\xbb property of the onDrop config for \xab${e.name}\xbb Tool should be an array`), i = []), i && (i = i.filter((s)=>$e2ab202322af4e74$var$ei(s) ? !0 : ($e2ab202322af4e74$var$S(`MIME type value \xab${s}\xbb for the \xab${e.name}\xbb Tool is not a valid MIME type`, "warn"), !1))), this.toolsFiles[e.name] = {
            extensions: o || [],
            mimeTypes: i || []
        });
    }
    /**
   * Get RegExp patterns to substitute by Tool
   *
   * @param tool - BlockTool object
   */ getPatternsConfig(e) {
        e.pasteConfig === !1 || !e.pasteConfig.patterns || $e2ab202322af4e74$var$V(e.pasteConfig.patterns) || Object.entries(e.pasteConfig.patterns).forEach(([t1, o])=>{
            o instanceof RegExp || $e2ab202322af4e74$var$S(`Pattern ${o} for \xab${e.name}\xbb Tool is skipped because it should be a Regexp instance.`, "warn"), this.toolsPatterns.push({
                key: t1,
                pattern: o,
                tool: e
            });
        });
    }
    /**
   * Check if browser behavior suits better
   *
   * @param {EventTarget} element - element where content has been pasted
   * @returns {boolean}
   */ isNativeBehaviour(e) {
        return $e2ab202322af4e74$var$u.isNativeInput(e);
    }
    /**
   * Get files from data transfer object and insert related Tools
   *
   * @param {FileList} items - pasted or dropped items
   */ async processFiles(e) {
        const { BlockManager: t1 } = this.Editor;
        let o;
        o = await Promise.all(Array.from(e).map((r)=>this.processFile(r))), o = o.filter((r)=>!!r);
        const s = t1.currentBlock.tool.isDefault && t1.currentBlock.isEmpty;
        o.forEach((r, a)=>{
            t1.paste(r.type, r.event, a === 0 && s);
        });
    }
    /**
   * Get information about file and find Tool to handle it
   *
   * @param {File} file - file to process
   */ async processFile(e) {
        const t1 = $e2ab202322af4e74$var$Jn(e), o = Object.entries(this.toolsFiles).find(([r, { mimeTypes: a, extensions: l }])=>{
            const [c, d] = e.type.split("/"), h = l.find((g)=>g.toLowerCase() === t1.toLowerCase()), p = a.find((g)=>{
                const [f, v] = g.split("/");
                return f === c && (v === d || v === "*");
            });
            return !!h || !!p;
        });
        if (!o) return;
        const [i] = o;
        return {
            event: this.composePasteEvent("file", {
                file: e
            }),
            type: i
        };
    }
    /**
   * Split HTML string to blocks and return it as array of Block data
   *
   * @param {string} innerHTML - html string to process
   * @returns {PasteData[]}
   */ processHTML(e) {
        const { Tools: t1 } = this.Editor, o = $e2ab202322af4e74$var$u.make("DIV");
        return o.innerHTML = e, this.getNodes(o).map((s)=>{
            let r, a = t1.defaultTool, l = !1;
            switch(s.nodeType){
                case Node.DOCUMENT_FRAGMENT_NODE:
                    r = $e2ab202322af4e74$var$u.make("div"), r.appendChild(s);
                    break;
                case Node.ELEMENT_NODE:
                    r = s, l = !0, this.toolsTags[r.tagName] && (a = this.toolsTags[r.tagName].tool);
                    break;
            }
            const { tags: c } = a.pasteConfig || {
                tags: []
            }, d = c.reduce((g, f)=>(this.collectTagNames(f).forEach((O)=>{
                    const T = $e2ab202322af4e74$var$D(f) ? f[O] : null;
                    g[O.toLowerCase()] = T || {};
                }), g), {}), h = Object.assign({}, d, a.baseSanitizeConfig);
            if (r.tagName.toLowerCase() === "table") {
                const g = $e2ab202322af4e74$var$Z(r.outerHTML, h);
                r = $e2ab202322af4e74$var$u.make("div", void 0, {
                    innerHTML: g
                }).firstChild;
            } else r.innerHTML = $e2ab202322af4e74$var$Z(r.innerHTML, h);
            const p = this.composePasteEvent("tag", {
                data: r
            });
            return {
                content: r,
                isBlock: l,
                tool: a.name,
                event: p
            };
        }).filter((s)=>{
            const r = $e2ab202322af4e74$var$u.isEmpty(s.content), a = $e2ab202322af4e74$var$u.isSingleTag(s.content);
            return !r || a;
        });
    }
    /**
   * Split plain text by new line symbols and return it as array of Block data
   *
   * @param {string} plain - string to process
   * @returns {PasteData[]}
   */ processPlain(e) {
        const { defaultBlock: t1 } = this.config;
        if (!e) return [];
        const o = t1;
        return e.split(/\r?\n/).filter((i)=>i.trim()).map((i)=>{
            const s = $e2ab202322af4e74$var$u.make("div");
            s.textContent = i;
            const r = this.composePasteEvent("tag", {
                data: s
            });
            return {
                content: s,
                tool: o,
                isBlock: !1,
                event: r
            };
        });
    }
    /**
   * Process paste of single Block tool content
   *
   * @param {PasteData} dataToInsert - data of Block to insert
   */ async processSingleBlock(e) {
        const { Caret: t1, BlockManager: o } = this.Editor, { currentBlock: i } = o;
        if (!i || e.tool !== i.name || !$e2ab202322af4e74$var$u.containsOnlyInlineElements(e.content.innerHTML)) {
            this.insertBlock(e, (i == null ? void 0 : i.tool.isDefault) && i.isEmpty);
            return;
        }
        t1.insertContentAtCaretPosition(e.content.innerHTML);
    }
    /**
   * Process paste to single Block:
   * 1. Find patterns` matches
   * 2. Insert new block if it is not the same type as current one
   * 3. Just insert text if there is no substitutions
   *
   * @param {PasteData} dataToInsert - data of Block to insert
   */ async processInlinePaste(e) {
        const { BlockManager: t1, Caret: o } = this.Editor, { content: i } = e;
        if (t1.currentBlock && t1.currentBlock.tool.isDefault && i.textContent.length < Dn.PATTERN_PROCESSING_MAX_LENGTH) {
            const r = await this.processPattern(i.textContent);
            if (r) {
                const a = t1.currentBlock && t1.currentBlock.tool.isDefault && t1.currentBlock.isEmpty, l = t1.paste(r.tool, r.event, a);
                o.setToBlock(l, o.positions.END);
                return;
            }
        }
        if (t1.currentBlock && t1.currentBlock.currentInput) {
            const r = t1.currentBlock.tool.baseSanitizeConfig;
            document.execCommand("insertHTML", !1, $e2ab202322af4e74$var$Z(i.innerHTML, r));
        } else this.insertBlock(e);
    }
    /**
   * Get patterns` matches
   *
   * @param {string} text - text to process
   * @returns {Promise<{event: PasteEvent, tool: string}>}
   */ async processPattern(e) {
        const t1 = this.toolsPatterns.find((i)=>{
            const s = i.pattern.exec(e);
            return s ? e === s.shift() : !1;
        });
        return t1 ? {
            event: this.composePasteEvent("pattern", {
                key: t1.key,
                data: e
            }),
            tool: t1.tool.name
        } : void 0;
    }
    /**
   * Insert pasted Block content to Editor
   *
   * @param {PasteData} data - data to insert
   * @param {boolean} canReplaceCurrentBlock - if true and is current Block is empty, will replace current Block
   * @returns {void}
   */ insertBlock(e, t1 = !1) {
        const { BlockManager: o, Caret: i } = this.Editor, { currentBlock: s } = o;
        let r;
        if (t1 && s && s.isEmpty) {
            r = o.paste(e.tool, e.event, !0), i.setToBlock(r, i.positions.END);
            return;
        }
        r = o.paste(e.tool, e.event), i.setToBlock(r, i.positions.END);
    }
    /**
   * Insert data passed as application/x-editor-js JSON
   *
   * @param {Array} blocks — Blocks' data to insert
   * @returns {void}
   */ insertEditorJSData(e) {
        const { BlockManager: t1, Caret: o, Tools: i } = this.Editor;
        $e2ab202322af4e74$var$yt(e, (r)=>i.blockTools.get(r).sanitizeConfig).forEach(({ tool: r, data: a }, l)=>{
            let c = !1;
            l === 0 && (c = t1.currentBlock && t1.currentBlock.tool.isDefault && t1.currentBlock.isEmpty);
            const d = t1.insert({
                tool: r,
                data: a,
                replace: c
            });
            o.setToBlock(d, o.positions.END);
        });
    }
    /**
   * Fetch nodes from Element node
   *
   * @param {Node} node - current node
   * @param {Node[]} nodes - processed nodes
   * @param {Node} destNode - destination node
   */ processElementNode(e, t1, o) {
        const i = Object.keys(this.toolsTags), s = e, { tool: r } = this.toolsTags[s.tagName] || {}, a = this.tagsByTool[r == null ? void 0 : r.name] || [], l = i.includes(s.tagName), c = $e2ab202322af4e74$var$u.blockElements.includes(s.tagName.toLowerCase()), d = Array.from(s.children).some(({ tagName: p })=>i.includes(p) && !a.includes(p)), h = Array.from(s.children).some(({ tagName: p })=>$e2ab202322af4e74$var$u.blockElements.includes(p.toLowerCase()));
        if (!c && !l && !d) return o.appendChild(s), [
            ...t1,
            o
        ];
        if (l && !d || c && !h && !d) return [
            ...t1,
            o,
            s
        ];
    }
    /**
   * Recursively divide HTML string to two types of nodes:
   * 1. Block element
   * 2. Document Fragments contained text and markup tags like a, b, i etc.
   *
   * @param {Node} wrapper - wrapper of paster HTML content
   * @returns {Node[]}
   */ getNodes(e) {
        const t1 = Array.from(e.childNodes);
        let o;
        const i = (s, r)=>{
            if ($e2ab202322af4e74$var$u.isEmpty(r) && !$e2ab202322af4e74$var$u.isSingleTag(r)) return s;
            const a = s[s.length - 1];
            let l = new DocumentFragment();
            switch(a && $e2ab202322af4e74$var$u.isFragment(a) && (l = s.pop()), r.nodeType){
                case Node.ELEMENT_NODE:
                    if (o = this.processElementNode(r, s, l), o) return o;
                    break;
                case Node.TEXT_NODE:
                    return l.appendChild(r), [
                        ...s,
                        l
                    ];
                default:
                    return [
                        ...s,
                        l
                    ];
            }
            return [
                ...s,
                ...Array.from(r.childNodes).reduce(i, [])
            ];
        };
        return t1.reduce(i, []);
    }
    /**
   * Compose paste event with passed type and detail
   *
   * @param {string} type - event type
   * @param {PasteEventDetail} detail - event detail
   */ composePasteEvent(e, t1) {
        return new CustomEvent(e, {
            detail: t1
        });
    }
};
$e2ab202322af4e74$var$Rn.PATTERN_PROCESSING_MAX_LENGTH = 450;
let $e2ab202322af4e74$var$pa = $e2ab202322af4e74$var$Rn;
class $e2ab202322af4e74$var$fa extends $e2ab202322af4e74$var$E {
    constructor(){
        super(...arguments), this.toolsDontSupportReadOnly = [], this.readOnlyEnabled = !1;
    }
    /**
   * Returns state of read only mode
   */ get isEnabled() {
        return this.readOnlyEnabled;
    }
    /**
   * Set initial state
   */ async prepare() {
        const { Tools: e } = this.Editor, { blockTools: t1 } = e, o = [];
        Array.from(t1.entries()).forEach(([i, s])=>{
            s.isReadOnlySupported || o.push(i);
        }), this.toolsDontSupportReadOnly = o, this.config.readOnly && o.length > 0 && this.throwCriticalError(), this.toggle(this.config.readOnly, !0);
    }
    /**
   * Set read-only mode or toggle current state
   * Call all Modules `toggleReadOnly` method and re-render Editor
   *
   * @param state - (optional) read-only state or toggle
   * @param isInitial - (optional) true when editor is initializing
   */ async toggle(e = !this.readOnlyEnabled, t1 = !1) {
        e && this.toolsDontSupportReadOnly.length > 0 && this.throwCriticalError();
        const o = this.readOnlyEnabled;
        this.readOnlyEnabled = e;
        for(const s in this.Editor)this.Editor[s].toggleReadOnly && this.Editor[s].toggleReadOnly(e);
        if (o === e) return this.readOnlyEnabled;
        if (t1) return this.readOnlyEnabled;
        this.Editor.ModificationsObserver.disable();
        const i = await this.Editor.Saver.save();
        return await this.Editor.BlockManager.clear(), await this.Editor.Renderer.render(i.blocks), this.Editor.ModificationsObserver.enable(), this.readOnlyEnabled;
    }
    /**
   * Throws an error about tools which don't support read-only mode
   */ throwCriticalError() {
        throw new $e2ab202322af4e74$var$Ho(`To enable read-only mode all connected tools should support it. Tools ${this.toolsDontSupportReadOnly.join(", ")} don't support read-only mode.`);
    }
}
class $e2ab202322af4e74$var$Be extends $e2ab202322af4e74$var$E {
    constructor(){
        super(...arguments), this.isRectSelectionActivated = !1, this.SCROLL_SPEED = 3, this.HEIGHT_OF_SCROLL_ZONE = 40, this.BOTTOM_SCROLL_ZONE = 1, this.TOP_SCROLL_ZONE = 2, this.MAIN_MOUSE_BUTTON = 0, this.mousedown = !1, this.isScrolling = !1, this.inScrollZone = null, this.startX = 0, this.startY = 0, this.mouseX = 0, this.mouseY = 0, this.stackOfSelected = [], this.listenerIds = [];
    }
    /**
   * CSS classes for the Block
   *
   * @returns {{wrapper: string, content: string}}
   */ static get CSS() {
        return {
            overlay: "codex-editor-overlay",
            overlayContainer: "codex-editor-overlay__container",
            rect: "codex-editor-overlay__rectangle",
            topScrollZone: "codex-editor-overlay__scroll-zone--top",
            bottomScrollZone: "codex-editor-overlay__scroll-zone--bottom"
        };
    }
    /**
   * Module Preparation
   * Creating rect and hang handlers
   */ prepare() {
        this.enableModuleBindings();
    }
    /**
   * Init rect params
   *
   * @param {number} pageX - X coord of mouse
   * @param {number} pageY - Y coord of mouse
   */ startSelection(e, t1) {
        const o = document.elementFromPoint(e - window.pageXOffset, t1 - window.pageYOffset);
        o.closest(`.${this.Editor.Toolbar.CSS.toolbar}`) || (this.Editor.BlockSelection.allBlocksSelected = !1, this.clearSelection(), this.stackOfSelected = []);
        const s = [
            `.${$e2ab202322af4e74$var$R.CSS.content}`,
            `.${this.Editor.Toolbar.CSS.toolbar}`,
            `.${this.Editor.InlineToolbar.CSS.inlineToolbar}`
        ], r = o.closest("." + this.Editor.UI.CSS.editorWrapper), a = s.some((l)=>!!o.closest(l));
        !r || a || (this.mousedown = !0, this.startX = e, this.startY = t1);
    }
    /**
   * Clear all params to end selection
   */ endSelection() {
        this.mousedown = !1, this.startX = 0, this.startY = 0, this.overlayRectangle.style.display = "none";
    }
    /**
   * is RectSelection Activated
   */ isRectActivated() {
        return this.isRectSelectionActivated;
    }
    /**
   * Mark that selection is end
   */ clearSelection() {
        this.isRectSelectionActivated = !1;
    }
    /**
   * Sets Module necessary event handlers
   */ enableModuleBindings() {
        const { container: e } = this.genHTML();
        this.listeners.on(e, "mousedown", (t1)=>{
            this.processMouseDown(t1);
        }, !1), this.listeners.on(document.body, "mousemove", $e2ab202322af4e74$var$dt((t1)=>{
            this.processMouseMove(t1);
        }, 10), {
            passive: !0
        }), this.listeners.on(document.body, "mouseleave", ()=>{
            this.processMouseLeave();
        }), this.listeners.on(window, "scroll", $e2ab202322af4e74$var$dt((t1)=>{
            this.processScroll(t1);
        }, 10), {
            passive: !0
        }), this.listeners.on(document.body, "mouseup", ()=>{
            this.processMouseUp();
        }, !1);
    }
    /**
   * Handle mouse down events
   *
   * @param {MouseEvent} mouseEvent - mouse event payload
   */ processMouseDown(e) {
        if (e.button !== this.MAIN_MOUSE_BUTTON) return;
        e.target.closest($e2ab202322af4e74$var$u.allInputsSelector) !== null || this.startSelection(e.pageX, e.pageY);
    }
    /**
   * Handle mouse move events
   *
   * @param {MouseEvent} mouseEvent - mouse event payload
   */ processMouseMove(e) {
        this.changingRectangle(e), this.scrollByZones(e.clientY);
    }
    /**
   * Handle mouse leave
   */ processMouseLeave() {
        this.clearSelection(), this.endSelection();
    }
    /**
   * @param {MouseEvent} mouseEvent - mouse event payload
   */ processScroll(e) {
        this.changingRectangle(e);
    }
    /**
   * Handle mouse up
   */ processMouseUp() {
        this.clearSelection(), this.endSelection();
    }
    /**
   * Scroll If mouse in scroll zone
   *
   * @param {number} clientY - Y coord of mouse
   */ scrollByZones(e) {
        if (this.inScrollZone = null, e <= this.HEIGHT_OF_SCROLL_ZONE && (this.inScrollZone = this.TOP_SCROLL_ZONE), document.documentElement.clientHeight - e <= this.HEIGHT_OF_SCROLL_ZONE && (this.inScrollZone = this.BOTTOM_SCROLL_ZONE), !this.inScrollZone) {
            this.isScrolling = !1;
            return;
        }
        this.isScrolling || (this.scrollVertical(this.inScrollZone === this.TOP_SCROLL_ZONE ? -this.SCROLL_SPEED : this.SCROLL_SPEED), this.isScrolling = !0);
    }
    /**
   * Generates required HTML elements
   *
   * @returns {Object<string, Element>}
   */ genHTML() {
        const { UI: e } = this.Editor, t1 = e.nodes.holder.querySelector("." + e.CSS.editorWrapper), o = $e2ab202322af4e74$var$u.make("div", $e2ab202322af4e74$var$Be.CSS.overlay, {}), i = $e2ab202322af4e74$var$u.make("div", $e2ab202322af4e74$var$Be.CSS.overlayContainer, {}), s = $e2ab202322af4e74$var$u.make("div", $e2ab202322af4e74$var$Be.CSS.rect, {});
        return i.appendChild(s), o.appendChild(i), t1.appendChild(o), this.overlayRectangle = s, {
            container: t1,
            overlay: o
        };
    }
    /**
   * Activates scrolling if blockSelection is active and mouse is in scroll zone
   *
   * @param {number} speed - speed of scrolling
   */ scrollVertical(e) {
        if (!(this.inScrollZone && this.mousedown)) return;
        const t1 = window.pageYOffset;
        window.scrollBy(0, e), this.mouseY += window.pageYOffset - t1, setTimeout(()=>{
            this.scrollVertical(e);
        }, 0);
    }
    /**
   * Handles the change in the rectangle and its effect
   *
   * @param {MouseEvent} event - mouse event
   */ changingRectangle(e) {
        if (!this.mousedown) return;
        e.pageY !== void 0 && (this.mouseX = e.pageX, this.mouseY = e.pageY);
        const { rightPos: t1, leftPos: o, index: i } = this.genInfoForMouseSelection(), s = this.startX > t1 && this.mouseX > t1, r = this.startX < o && this.mouseX < o;
        this.rectCrossesBlocks = !(s || r), this.isRectSelectionActivated || (this.rectCrossesBlocks = !1, this.isRectSelectionActivated = !0, this.shrinkRectangleToPoint(), this.overlayRectangle.style.display = "block"), this.updateRectangleSize(), this.Editor.Toolbar.close(), i !== void 0 && (this.trySelectNextBlock(i), this.inverseSelection(), $e2ab202322af4e74$var$b.get().removeAllRanges());
    }
    /**
   * Shrink rect to singular point
   */ shrinkRectangleToPoint() {
        this.overlayRectangle.style.left = `${this.startX - window.pageXOffset}px`, this.overlayRectangle.style.top = `${this.startY - window.pageYOffset}px`, this.overlayRectangle.style.bottom = `calc(100% - ${this.startY - window.pageYOffset}px`, this.overlayRectangle.style.right = `calc(100% - ${this.startX - window.pageXOffset}px`;
    }
    /**
   * Select or unselect all of blocks in array if rect is out or in selectable area
   */ inverseSelection() {
        const t1 = this.Editor.BlockManager.getBlockByIndex(this.stackOfSelected[0]).selected;
        if (this.rectCrossesBlocks && !t1) for (const o of this.stackOfSelected)this.Editor.BlockSelection.selectBlockByIndex(o);
        if (!this.rectCrossesBlocks && t1) for (const o of this.stackOfSelected)this.Editor.BlockSelection.unSelectBlockByIndex(o);
    }
    /**
   * Updates size of rectangle
   */ updateRectangleSize() {
        this.mouseY >= this.startY ? (this.overlayRectangle.style.top = `${this.startY - window.pageYOffset}px`, this.overlayRectangle.style.bottom = `calc(100% - ${this.mouseY - window.pageYOffset}px`) : (this.overlayRectangle.style.bottom = `calc(100% - ${this.startY - window.pageYOffset}px`, this.overlayRectangle.style.top = `${this.mouseY - window.pageYOffset}px`), this.mouseX >= this.startX ? (this.overlayRectangle.style.left = `${this.startX - window.pageXOffset}px`, this.overlayRectangle.style.right = `calc(100% - ${this.mouseX - window.pageXOffset}px`) : (this.overlayRectangle.style.right = `calc(100% - ${this.startX - window.pageXOffset}px`, this.overlayRectangle.style.left = `${this.mouseX - window.pageXOffset}px`);
    }
    /**
   * Collects information needed to determine the behavior of the rectangle
   *
   * @returns {object} index - index next Block, leftPos - start of left border of Block, rightPos - right border
   */ genInfoForMouseSelection() {
        const t1 = document.body.offsetWidth / 2, o = this.mouseY - window.pageYOffset, i = document.elementFromPoint(t1, o), s = this.Editor.BlockManager.getBlockByChildNode(i);
        let r;
        s !== void 0 && (r = this.Editor.BlockManager.blocks.findIndex((h)=>h.holder === s.holder));
        const a = this.Editor.BlockManager.lastBlock.holder.querySelector("." + $e2ab202322af4e74$var$R.CSS.content), l = Number.parseInt(window.getComputedStyle(a).width, 10) / 2, c = t1 - l, d = t1 + l;
        return {
            index: r,
            leftPos: c,
            rightPos: d
        };
    }
    /**
   * Select block with index index
   *
   * @param index - index of block in redactor
   */ addBlockInSelection(e) {
        this.rectCrossesBlocks && this.Editor.BlockSelection.selectBlockByIndex(e), this.stackOfSelected.push(e);
    }
    /**
   * Adds a block to the selection and determines which blocks should be selected
   *
   * @param {object} index - index of new block in the reactor
   */ trySelectNextBlock(e) {
        const t1 = this.stackOfSelected[this.stackOfSelected.length - 1] === e, o = this.stackOfSelected.length, i = 1, s = -1, r = 0;
        if (t1) return;
        const a = this.stackOfSelected[o - 1] - this.stackOfSelected[o - 2] > 0;
        let l = r;
        o > 1 && (l = a ? i : s);
        const c = e > this.stackOfSelected[o - 1] && l === i, d = e < this.stackOfSelected[o - 1] && l === s, p = !(c || d || l === r);
        if (!p && (e > this.stackOfSelected[o - 1] || this.stackOfSelected[o - 1] === void 0)) {
            let v = this.stackOfSelected[o - 1] + 1 || e;
            for(v; v <= e; v++)this.addBlockInSelection(v);
            return;
        }
        if (!p && e < this.stackOfSelected[o - 1]) {
            for(let v = this.stackOfSelected[o - 1] - 1; v >= e; v--)this.addBlockInSelection(v);
            return;
        }
        if (!p) return;
        let g = o - 1, f;
        for(e > this.stackOfSelected[o - 1] ? f = ()=>e > this.stackOfSelected[g] : f = ()=>e < this.stackOfSelected[g]; f();)this.rectCrossesBlocks && this.Editor.BlockSelection.unSelectBlockByIndex(this.stackOfSelected[g]), this.stackOfSelected.pop(), g--;
    }
}
class $e2ab202322af4e74$var$ga extends $e2ab202322af4e74$var$E {
    /**
   * Renders passed blocks as one batch
   *
   * @param blocksData - blocks to render
   */ async render(e) {
        return new Promise((t1)=>{
            const { Tools: o, BlockManager: i } = this.Editor;
            if (e.length === 0) i.insert();
            else {
                const s = e.map(({ type: r, data: a, tunes: l, id: c })=>{
                    o.available.has(r) === !1 && ($e2ab202322af4e74$var$X(`Tool \xab${r}\xbb is not found. Check 'tools' property at the Editor.js config.`, "warn"), a = this.composeStubDataForTool(r, a, c), r = o.stubTool);
                    let d;
                    try {
                        d = i.composeBlock({
                            id: c,
                            tool: r,
                            data: a,
                            tunes: l
                        });
                    } catch (h) {
                        $e2ab202322af4e74$var$S(`Block \xab${r}\xbb skipped because of plugins error`, "error", {
                            data: a,
                            error: h
                        }), a = this.composeStubDataForTool(r, a, c), r = o.stubTool, d = i.composeBlock({
                            id: c,
                            tool: r,
                            data: a,
                            tunes: l
                        });
                    }
                    return d;
                });
                i.insertMany(s);
            }
            window.requestIdleCallback(()=>{
                t1();
            }, {
                timeout: 2e3
            });
        });
    }
    /**
   * Create data for the Stub Tool that will be used instead of unavailable tool
   *
   * @param tool - unavailable tool name to stub
   * @param data - data of unavailable block
   * @param [id] - id of unavailable block
   */ composeStubDataForTool(e, t1, o) {
        const { Tools: i } = this.Editor;
        let s = e;
        if (i.unavailable.has(e)) {
            const r = i.unavailable.get(e).toolbox;
            r !== void 0 && r[0].title !== void 0 && (s = r[0].title);
        }
        return {
            savedData: {
                id: o,
                type: e,
                data: t1
            },
            title: s
        };
    }
}
class $e2ab202322af4e74$var$ma extends $e2ab202322af4e74$var$E {
    /**
   * Composes new chain of Promises to fire them alternatelly
   *
   * @returns {OutputData}
   */ async save() {
        const { BlockManager: e, Tools: t1 } = this.Editor, o = e.blocks, i = [];
        try {
            o.forEach((a)=>{
                i.push(this.getSavedData(a));
            });
            const s = await Promise.all(i), r = await $e2ab202322af4e74$var$yt(s, (a)=>t1.blockTools.get(a).sanitizeConfig);
            return this.makeOutput(r);
        } catch (s) {
            $e2ab202322af4e74$var$X("Saving failed due to the Error %o", "error", s);
        }
    }
    /**
   * Saves and validates
   *
   * @param {Block} block - Editor's Tool
   * @returns {ValidatedData} - Tool's validated data
   */ async getSavedData(e) {
        const t1 = await e.save(), o = t1 && await e.validate(t1.data);
        return {
            ...t1,
            isValid: o
        };
    }
    /**
   * Creates output object with saved data, time and version of editor
   *
   * @param {ValidatedData} allExtractedData - data extracted from Blocks
   * @returns {OutputData}
   */ makeOutput(e) {
        const t1 = [];
        return e.forEach(({ id: o, tool: i, data: s, tunes: r, isValid: a })=>{
            if (!a) {
                $e2ab202322af4e74$var$S(`Block \xab${i}\xbb skipped because saved data is invalid`);
                return;
            }
            if (i === this.Editor.Tools.stubTool) {
                t1.push(s);
                return;
            }
            const l = {
                id: o,
                type: i,
                data: s,
                ...!$e2ab202322af4e74$var$V(r) && {
                    tunes: r
                }
            };
            t1.push(l);
        }), {
            time: +/* @__PURE__ */ new Date(),
            blocks: t1,
            version: "2.31.6"
        };
    }
}
(function() {
    try {
        if (typeof document < "u") {
            var n = document.createElement("style");
            n.appendChild(document.createTextNode(".ce-paragraph{line-height:1.6em;outline:none}.ce-block:only-of-type .ce-paragraph[data-placeholder-active]:empty:before,.ce-block:only-of-type .ce-paragraph[data-placeholder-active][data-empty=true]:before{content:attr(data-placeholder-active)}.ce-paragraph p:first-of-type{margin-top:0}.ce-paragraph p:last-of-type{margin-bottom:0}")), document.head.appendChild(n);
        }
    } catch (e) {
        console.error("vite-plugin-css-injected-by-js", e);
    }
})();
const $e2ab202322af4e74$var$ba = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M8 9V7.2C8 7.08954 8.08954 7 8.2 7L12 7M16 9V7.2C16 7.08954 15.9105 7 15.8 7L12 7M12 7L12 17M12 17H10M12 17H14"/></svg>';
function $e2ab202322af4e74$var$va(n) {
    const e = document.createElement("div");
    e.innerHTML = n.trim();
    const t1 = document.createDocumentFragment();
    return t1.append(...Array.from(e.childNodes)), t1;
}
/**
 * Base Paragraph Block for the Editor.js.
 * Represents a regular text block
 *
 * @author CodeX (team@codex.so)
 * @copyright CodeX 2018
 * @license The MIT License (MIT)
 */ class $e2ab202322af4e74$var$fo {
    /**
   * Default placeholder for Paragraph Tool
   *
   * @returns {string}
   * @class
   */ static get DEFAULT_PLACEHOLDER() {
        return "";
    }
    /**
   * Render plugin`s main Element and fill it with saved data
   *
   * @param {object} params - constructor params
   * @param {ParagraphData} params.data - previously saved data
   * @param {ParagraphConfig} params.config - user config for Tool
   * @param {object} params.api - editor.js api
   * @param {boolean} readOnly - read only mode flag
   */ constructor({ data: e, config: t1, api: o, readOnly: i }){
        this.api = o, this.readOnly = i, this._CSS = {
            block: this.api.styles.block,
            wrapper: "ce-paragraph"
        }, this.readOnly || (this.onKeyUp = this.onKeyUp.bind(this)), this._placeholder = t1.placeholder ? t1.placeholder : $e2ab202322af4e74$var$fo.DEFAULT_PLACEHOLDER, this._data = e ?? {}, this._element = null, this._preserveBlank = t1.preserveBlank ?? !1;
    }
    /**
   * Check if text content is empty and set empty string to inner html.
   * We need this because some browsers (e.g. Safari) insert <br> into empty contenteditanle elements
   *
   * @param {KeyboardEvent} e - key up event
   */ onKeyUp(e) {
        if (e.code !== "Backspace" && e.code !== "Delete" || !this._element) return;
        const { textContent: t1 } = this._element;
        t1 === "" && (this._element.innerHTML = "");
    }
    /**
   * Create Tool's view
   *
   * @returns {HTMLDivElement}
   * @private
   */ drawView() {
        const e = document.createElement("DIV");
        return e.classList.add(this._CSS.wrapper, this._CSS.block), e.contentEditable = "false", e.dataset.placeholderActive = this.api.i18n.t(this._placeholder), this._data.text && (e.innerHTML = this._data.text), this.readOnly || (e.contentEditable = "true", e.addEventListener("keyup", this.onKeyUp)), e;
    }
    /**
   * Return Tool's view
   *
   * @returns {HTMLDivElement}
   */ render() {
        return this._element = this.drawView(), this._element;
    }
    /**
   * Method that specified how to merge two Text blocks.
   * Called by Editor.js by backspace at the beginning of the Block
   *
   * @param {ParagraphData} data
   * @public
   */ merge(e) {
        if (!this._element) return;
        this._data.text += e.text;
        const t1 = $e2ab202322af4e74$var$va(e.text);
        this._element.appendChild(t1), this._element.normalize();
    }
    /**
   * Validate Paragraph block data:
   * - check for emptiness
   *
   * @param {ParagraphData} savedData — data received after saving
   * @returns {boolean} false if saved data is not correct, otherwise true
   * @public
   */ validate(e) {
        return !(e.text.trim() === "" && !this._preserveBlank);
    }
    /**
   * Extract Tool's data from the view
   *
   * @param {HTMLDivElement} toolsContent - Paragraph tools rendered view
   * @returns {ParagraphData} - saved data
   * @public
   */ save(e) {
        return {
            text: e.innerHTML
        };
    }
    /**
   * On paste callback fired from Editor.
   *
   * @param {HTMLPasteEvent} event - event with pasted data
   */ onPaste(e) {
        const t1 = {
            text: e.detail.data.innerHTML
        };
        this._data = t1, window.requestAnimationFrame(()=>{
            this._element && (this._element.innerHTML = this._data.text || "");
        });
    }
    /**
   * Enable Conversion Toolbar. Paragraph can be converted to/from other tools
   * @returns {ConversionConfig}
   */ static get conversionConfig() {
        return {
            export: "text",
            // to convert Paragraph to other block, use 'text' property of saved data
            import: "text"
        };
    }
    /**
   * Sanitizer rules
   * @returns {SanitizerConfig} - Edtior.js sanitizer config
   */ static get sanitize() {
        return {
            text: {
                br: !0
            }
        };
    }
    /**
   * Returns true to notify the core that read-only mode is supported
   *
   * @returns {boolean}
   */ static get isReadOnlySupported() {
        return !0;
    }
    /**
   * Used by Editor paste handling API.
   * Provides configuration to handle P tags.
   *
   * @returns {PasteConfig} - Paragraph Paste Setting
   */ static get pasteConfig() {
        return {
            tags: [
                "P"
            ]
        };
    }
    /**
   * Icon and title for displaying at the Toolbox
   *
   * @returns {ToolboxConfig} - Paragraph Toolbox Setting
   */ static get toolbox() {
        return {
            icon: $e2ab202322af4e74$var$ba,
            title: "Text"
        };
    }
}
class $e2ab202322af4e74$var$go {
    constructor(){
        this.commandName = "bold";
    }
    /**
   * Sanitizer Rule
   * Leave <b> tags
   *
   * @returns {object}
   */ static get sanitize() {
        return {
            b: {}
        };
    }
    /**
   * Create button for Inline Toolbar
   */ render() {
        return {
            icon: $e2ab202322af4e74$var$Ki,
            name: "bold",
            onActivate: ()=>{
                document.execCommand(this.commandName);
            },
            isActive: ()=>document.queryCommandState(this.commandName)
        };
    }
    /**
   * Set a shortcut
   *
   * @returns {boolean}
   */ get shortcut() {
        return "CMD+B";
    }
}
$e2ab202322af4e74$var$go.isInline = !0;
$e2ab202322af4e74$var$go.title = "Bold";
class $e2ab202322af4e74$var$mo {
    constructor(){
        this.commandName = "italic", this.CSS = {
            button: "ce-inline-tool",
            buttonActive: "ce-inline-tool--active",
            buttonModifier: "ce-inline-tool--italic"
        }, this.nodes = {
            button: null
        };
    }
    /**
   * Sanitizer Rule
   * Leave <i> tags
   *
   * @returns {object}
   */ static get sanitize() {
        return {
            i: {}
        };
    }
    /**
   * Create button for Inline Toolbar
   */ render() {
        return this.nodes.button = document.createElement("button"), this.nodes.button.type = "button", this.nodes.button.classList.add(this.CSS.button, this.CSS.buttonModifier), this.nodes.button.innerHTML = $e2ab202322af4e74$var$Ji, this.nodes.button;
    }
    /**
   * Wrap range with <i> tag
   */ surround() {
        document.execCommand(this.commandName);
    }
    /**
   * Check selection and set activated state to button if there are <i> tag
   */ checkState() {
        const e = document.queryCommandState(this.commandName);
        return this.nodes.button.classList.toggle(this.CSS.buttonActive, e), e;
    }
    /**
   * Set a shortcut
   */ get shortcut() {
        return "CMD+I";
    }
}
$e2ab202322af4e74$var$mo.isInline = !0;
$e2ab202322af4e74$var$mo.title = "Italic";
class $e2ab202322af4e74$var$bo {
    /**
   * @param api - Editor.js API
   */ constructor({ api: e }){
        this.commandLink = "createLink", this.commandUnlink = "unlink", this.ENTER_KEY = 13, this.CSS = {
            button: "ce-inline-tool",
            buttonActive: "ce-inline-tool--active",
            buttonModifier: "ce-inline-tool--link",
            buttonUnlink: "ce-inline-tool--unlink",
            input: "ce-inline-tool-input",
            inputShowed: "ce-inline-tool-input--showed"
        }, this.nodes = {
            button: null,
            input: null
        }, this.inputOpened = !1, this.toolbar = e.toolbar, this.inlineToolbar = e.inlineToolbar, this.notifier = e.notifier, this.i18n = e.i18n, this.selection = new $e2ab202322af4e74$var$b();
    }
    /**
   * Sanitizer Rule
   * Leave <a> tags
   *
   * @returns {object}
   */ static get sanitize() {
        return {
            a: {
                href: !0,
                target: "_blank",
                rel: "nofollow"
            }
        };
    }
    /**
   * Create button for Inline Toolbar
   */ render() {
        return this.nodes.button = document.createElement("button"), this.nodes.button.type = "button", this.nodes.button.classList.add(this.CSS.button, this.CSS.buttonModifier), this.nodes.button.innerHTML = $e2ab202322af4e74$var$Co, this.nodes.button;
    }
    /**
   * Input for the link
   */ renderActions() {
        return this.nodes.input = document.createElement("input"), this.nodes.input.placeholder = this.i18n.t("Add a link"), this.nodes.input.enterKeyHint = "done", this.nodes.input.classList.add(this.CSS.input), this.nodes.input.addEventListener("keydown", (e)=>{
            e.keyCode === this.ENTER_KEY && this.enterPressed(e);
        }), this.nodes.input;
    }
    /**
   * Handle clicks on the Inline Toolbar icon
   *
   * @param {Range} range - range to wrap with link
   */ surround(e) {
        if (e) {
            this.inputOpened ? (this.selection.restore(), this.selection.removeFakeBackground()) : (this.selection.setFakeBackground(), this.selection.save());
            const t1 = this.selection.findParentTag("A");
            if (t1) {
                this.inputOpened ? (this.closeActions(!1), this.checkState()) : (this.selection.expandToTag(t1), this.unlink(), this.closeActions(), this.checkState(), this.toolbar.close());
                return;
            }
        }
        this.toggleActions();
    }
    /**
   * Check selection and set activated state to button if there are <a> tag
   */ checkState() {
        const e = this.selection.findParentTag("A");
        if (e) {
            this.nodes.button.innerHTML = $e2ab202322af4e74$var$ns, this.nodes.button.classList.add(this.CSS.buttonUnlink), this.nodes.button.classList.add(this.CSS.buttonActive), this.openActions();
            const t1 = e.getAttribute("href");
            this.nodes.input.defaultValue = t1 !== "null" ? t1 : "", this.selection.save();
        } else this.nodes.button.innerHTML = $e2ab202322af4e74$var$Co, this.nodes.button.classList.remove(this.CSS.buttonUnlink), this.nodes.button.classList.remove(this.CSS.buttonActive);
        return !!e;
    }
    /**
   * Function called with Inline Toolbar closing
   */ clear() {
        this.closeActions();
    }
    /**
   * Set a shortcut
   */ get shortcut() {
        return "CMD+K";
    }
    /**
   * Show/close link input
   */ toggleActions() {
        this.inputOpened ? this.closeActions(!1) : this.openActions(!0);
    }
    /**
   * @param {boolean} needFocus - on link creation we need to focus input. On editing - nope.
   */ openActions(e = !1) {
        this.nodes.input.classList.add(this.CSS.inputShowed), e && this.nodes.input.focus(), this.inputOpened = !0;
    }
    /**
   * Close input
   *
   * @param {boolean} clearSavedSelection — we don't need to clear saved selection
   *                                        on toggle-clicks on the icon of opened Toolbar
   */ closeActions(e = !0) {
        if (this.selection.isFakeBackgroundEnabled) {
            const t1 = new $e2ab202322af4e74$var$b();
            t1.save(), this.selection.restore(), this.selection.removeFakeBackground(), t1.restore();
        }
        this.nodes.input.classList.remove(this.CSS.inputShowed), this.nodes.input.value = "", e && this.selection.clearSaved(), this.inputOpened = !1;
    }
    /**
   * Enter pressed on input
   *
   * @param {KeyboardEvent} event - enter keydown event
   */ enterPressed(e) {
        let t1 = this.nodes.input.value || "";
        if (!t1.trim()) {
            this.selection.restore(), this.unlink(), e.preventDefault(), this.closeActions();
            return;
        }
        if (!this.validateURL(t1)) {
            this.notifier.show({
                message: "Pasted link is not valid.",
                style: "error"
            }), $e2ab202322af4e74$var$S("Incorrect Link pasted", "warn", t1);
            return;
        }
        t1 = this.prepareLink(t1), this.selection.restore(), this.selection.removeFakeBackground(), this.insertLink(t1), e.preventDefault(), e.stopPropagation(), e.stopImmediatePropagation(), this.selection.collapseToEnd(), this.inlineToolbar.close();
    }
    /**
   * Detects if passed string is URL
   *
   * @param {string} str - string to validate
   * @returns {boolean}
   */ validateURL(e) {
        return !/\s/.test(e);
    }
    /**
   * Process link before injection
   * - sanitize
   * - add protocol for links like 'google.com'
   *
   * @param {string} link - raw user input
   */ prepareLink(e) {
        return e = e.trim(), e = this.addProtocol(e), e;
    }
    /**
   * Add 'http' protocol to the links like 'vc.ru', 'google.com'
   *
   * @param {string} link - string to process
   */ addProtocol(e) {
        if (/^(\w+):(\/\/)?/.test(e)) return e;
        const t1 = /^\/[^/\s]/.test(e), o = e.substring(0, 1) === "#", i = /^\/\/[^/\s]/.test(e);
        return !t1 && !o && !i && (e = "http://" + e), e;
    }
    /**
   * Inserts <a> tag with "href"
   *
   * @param {string} link - "href" value
   */ insertLink(e) {
        const t1 = this.selection.findParentTag("A");
        t1 && this.selection.expandToTag(t1), document.execCommand(this.commandLink, !1, e);
    }
    /**
   * Removes <a> tag
   */ unlink() {
        document.execCommand(this.commandUnlink);
    }
}
$e2ab202322af4e74$var$bo.isInline = !0;
$e2ab202322af4e74$var$bo.title = "Link";
class $e2ab202322af4e74$var$Fn {
    /**
   * @param api - Editor.js API
   */ constructor({ api: e }){
        this.i18nAPI = e.i18n, this.blocksAPI = e.blocks, this.selectionAPI = e.selection, this.toolsAPI = e.tools, this.caretAPI = e.caret;
    }
    /**
   * Returns tool's UI config
   */ async render() {
        const e = $e2ab202322af4e74$var$b.get(), t1 = this.blocksAPI.getBlockByElement(e.anchorNode);
        if (t1 === void 0) return [];
        const o = this.toolsAPI.getBlockTools(), i = await $e2ab202322af4e74$var$Yo(t1, o);
        if (i.length === 0) return [];
        const s = i.reduce((c, d)=>{
            var h;
            return (h = d.toolbox) == null || h.forEach((p)=>{
                c.push({
                    icon: p.icon,
                    title: $e2ab202322af4e74$var$z.t($e2ab202322af4e74$var$K.toolNames, p.title),
                    name: d.name,
                    closeOnActivate: !0,
                    onActivate: async ()=>{
                        const g = await this.blocksAPI.convert(t1.id, d.name, p.data);
                        this.caretAPI.setToBlock(g, "end");
                    }
                });
            }), c;
        }, []), r = await t1.getActiveToolboxEntry(), a = r !== void 0 ? r.icon : $e2ab202322af4e74$var$Go, l = !$e2ab202322af4e74$var$be();
        return {
            icon: a,
            name: "convert-to",
            hint: {
                title: this.i18nAPI.t("Convert to")
            },
            children: {
                searchable: l,
                items: s,
                onOpen: ()=>{
                    l && (this.selectionAPI.setFakeBackground(), this.selectionAPI.save());
                },
                onClose: ()=>{
                    l && (this.selectionAPI.restore(), this.selectionAPI.removeFakeBackground());
                }
            }
        };
    }
}
$e2ab202322af4e74$var$Fn.isInline = !0;
class $e2ab202322af4e74$var$jn {
    /**
   * @param options - constructor options
   * @param options.data - stub tool data
   * @param options.api - Editor.js API
   */ constructor({ data: e, api: t1 }){
        this.CSS = {
            wrapper: "ce-stub",
            info: "ce-stub__info",
            title: "ce-stub__title",
            subtitle: "ce-stub__subtitle"
        }, this.api = t1, this.title = e.title || this.api.i18n.t("Error"), this.subtitle = this.api.i18n.t("The block can not be displayed correctly."), this.savedData = e.savedData, this.wrapper = this.make();
    }
    /**
   * Returns stub holder
   *
   * @returns {HTMLElement}
   */ render() {
        return this.wrapper;
    }
    /**
   * Return original Tool data
   *
   * @returns {BlockToolData}
   */ save() {
        return this.savedData;
    }
    /**
   * Create Tool html markup
   *
   * @returns {HTMLElement}
   */ make() {
        const e = $e2ab202322af4e74$var$u.make("div", this.CSS.wrapper), t1 = $e2ab202322af4e74$var$is, o = $e2ab202322af4e74$var$u.make("div", this.CSS.info), i = $e2ab202322af4e74$var$u.make("div", this.CSS.title, {
            textContent: this.title
        }), s = $e2ab202322af4e74$var$u.make("div", this.CSS.subtitle, {
            textContent: this.subtitle
        });
        return e.innerHTML = t1, o.appendChild(i), o.appendChild(s), e.appendChild(o), e;
    }
}
$e2ab202322af4e74$var$jn.isReadOnlySupported = !0;
class $e2ab202322af4e74$var$ka extends $e2ab202322af4e74$var$Tt {
    constructor(){
        super(...arguments), this.type = $e2ab202322af4e74$var$ae.Inline;
    }
    /**
   * Returns title for Inline Tool if specified by user
   */ get title() {
        return this.constructable[$e2ab202322af4e74$var$We.Title];
    }
    /**
   * Constructs new InlineTool instance from constructable
   */ create() {
        return new this.constructable({
            api: this.api,
            config: this.settings
        });
    }
    /**
   * Allows inline tool to be available in read-only mode
   * Can be used, for example, by comments tool
   */ get isReadOnlySupported() {
        return this.constructable[$e2ab202322af4e74$var$We.IsReadOnlySupported] ?? !1;
    }
}
class $e2ab202322af4e74$var$ya extends $e2ab202322af4e74$var$Tt {
    constructor(){
        super(...arguments), this.type = $e2ab202322af4e74$var$ae.Tune;
    }
    /**
   * Constructs new BlockTune instance from constructable
   *
   * @param data - Tune data
   * @param block - Block API object
   */ create(e, t1) {
        return new this.constructable({
            api: this.api,
            config: this.settings,
            block: t1,
            data: e
        });
    }
}
class $e2ab202322af4e74$var$j extends Map {
    /**
   * Returns Block Tools collection
   */ get blockTools() {
        const e = Array.from(this.entries()).filter(([, t1])=>t1.isBlock());
        return new $e2ab202322af4e74$var$j(e);
    }
    /**
   * Returns Inline Tools collection
   */ get inlineTools() {
        const e = Array.from(this.entries()).filter(([, t1])=>t1.isInline());
        return new $e2ab202322af4e74$var$j(e);
    }
    /**
   * Returns Block Tunes collection
   */ get blockTunes() {
        const e = Array.from(this.entries()).filter(([, t1])=>t1.isTune());
        return new $e2ab202322af4e74$var$j(e);
    }
    /**
   * Returns internal Tools collection
   */ get internalTools() {
        const e = Array.from(this.entries()).filter(([, t1])=>t1.isInternal);
        return new $e2ab202322af4e74$var$j(e);
    }
    /**
   * Returns Tools collection provided by user
   */ get externalTools() {
        const e = Array.from(this.entries()).filter(([, t1])=>!t1.isInternal);
        return new $e2ab202322af4e74$var$j(e);
    }
}
var $e2ab202322af4e74$var$wa = Object.defineProperty, $e2ab202322af4e74$var$Ea = Object.getOwnPropertyDescriptor, $e2ab202322af4e74$var$Hn = (n, e, t1, o)=>{
    for(var i = o > 1 ? void 0 : o ? $e2ab202322af4e74$var$Ea(e, t1) : e, s = n.length - 1, r; s >= 0; s--)(r = n[s]) && (i = (o ? r(e, t1, i) : r(i)) || i);
    return o && i && $e2ab202322af4e74$var$wa(e, t1, i), i;
};
class $e2ab202322af4e74$var$vo extends $e2ab202322af4e74$var$Tt {
    constructor(){
        super(...arguments), this.type = $e2ab202322af4e74$var$ae.Block, this.inlineTools = new $e2ab202322af4e74$var$j(), this.tunes = new $e2ab202322af4e74$var$j();
    }
    /**
   * Creates new Tool instance
   *
   * @param data - Tool data
   * @param block - BlockAPI for current Block
   * @param readOnly - True if Editor is in read-only mode
   */ create(e, t1, o) {
        return new this.constructable({
            data: e,
            block: t1,
            readOnly: o,
            api: this.api,
            config: this.settings
        });
    }
    /**
   * Returns true if read-only mode is supported by Tool
   */ get isReadOnlySupported() {
        return this.constructable[$e2ab202322af4e74$var$pe.IsReadOnlySupported] === !0;
    }
    /**
   * Returns true if Tool supports linebreaks
   */ get isLineBreaksEnabled() {
        return this.constructable[$e2ab202322af4e74$var$pe.IsEnabledLineBreaks];
    }
    /**
   * Returns Tool toolbox configuration (internal or user-specified).
   *
   * Merges internal and user-defined toolbox configs based on the following rules:
   *
   * - If both internal and user-defined toolbox configs are arrays their items are merged.
   * Length of the second one is kept.
   *
   * - If both are objects their properties are merged.
   *
   * - If one is an object and another is an array than internal config is replaced with user-defined
   * config. This is made to allow user to override default tool's toolbox representation (single/multiple entries)
   */ get toolbox() {
        const e = this.constructable[$e2ab202322af4e74$var$pe.Toolbox], t1 = this.config[$e2ab202322af4e74$var$Pe.Toolbox];
        if (!$e2ab202322af4e74$var$V(e) && t1 !== !1) return t1 ? Array.isArray(e) ? Array.isArray(t1) ? t1.map((o, i)=>{
            const s = e[i];
            return s ? {
                ...s,
                ...o
            } : o;
        }) : [
            t1
        ] : Array.isArray(t1) ? t1 : [
            {
                ...e,
                ...t1
            }
        ] : Array.isArray(e) ? e : [
            e
        ];
    }
    /**
   * Returns Tool conversion configuration
   */ get conversionConfig() {
        return this.constructable[$e2ab202322af4e74$var$pe.ConversionConfig];
    }
    /**
   * Returns enabled inline tools for Tool
   */ get enabledInlineTools() {
        return this.config[$e2ab202322af4e74$var$Pe.EnabledInlineTools] || !1;
    }
    /**
   * Returns enabled tunes for Tool
   */ get enabledBlockTunes() {
        return this.config[$e2ab202322af4e74$var$Pe.EnabledBlockTunes];
    }
    /**
   * Returns Tool paste configuration
   */ get pasteConfig() {
        return this.constructable[$e2ab202322af4e74$var$pe.PasteConfig] ?? {};
    }
    get sanitizeConfig() {
        const e = super.sanitizeConfig, t1 = this.baseSanitizeConfig;
        if ($e2ab202322af4e74$var$V(e)) return t1;
        const o = {};
        for(const i in e)if (Object.prototype.hasOwnProperty.call(e, i)) {
            const s = e[i];
            $e2ab202322af4e74$var$D(s) ? o[i] = Object.assign({}, t1, s) : o[i] = s;
        }
        return o;
    }
    get baseSanitizeConfig() {
        const e = {};
        return Array.from(this.inlineTools.values()).forEach((t1)=>Object.assign(e, t1.sanitizeConfig)), Array.from(this.tunes.values()).forEach((t1)=>Object.assign(e, t1.sanitizeConfig)), e;
    }
}
$e2ab202322af4e74$var$Hn([
    $e2ab202322af4e74$var$me
], $e2ab202322af4e74$var$vo.prototype, "sanitizeConfig", 1);
$e2ab202322af4e74$var$Hn([
    $e2ab202322af4e74$var$me
], $e2ab202322af4e74$var$vo.prototype, "baseSanitizeConfig", 1);
class $e2ab202322af4e74$var$xa {
    /**
   * @class
   * @param config - tools config
   * @param editorConfig - EditorJS config
   * @param api - EditorJS API module
   */ constructor(e, t1, o){
        this.api = o, this.config = e, this.editorConfig = t1;
    }
    /**
   * Returns Tool object based on it's type
   *
   * @param name - tool name
   */ get(e) {
        const { class: t1, isInternal: o = !1, ...i } = this.config[e], s = this.getConstructor(t1), r = t1[$e2ab202322af4e74$var$mt.IsTune];
        return new s({
            name: e,
            constructable: t1,
            config: i,
            api: this.api.getMethodsForTool(e, r),
            isDefault: e === this.editorConfig.defaultBlock,
            defaultPlaceholder: this.editorConfig.placeholder,
            isInternal: o
        });
    }
    /**
   * Find appropriate Tool object constructor for Tool constructable
   *
   * @param constructable - Tools constructable
   */ getConstructor(e) {
        switch(!0){
            case e[$e2ab202322af4e74$var$We.IsInline]:
                return $e2ab202322af4e74$var$ka;
            case e[$e2ab202322af4e74$var$mt.IsTune]:
                return $e2ab202322af4e74$var$ya;
            default:
                return $e2ab202322af4e74$var$vo;
        }
    }
}
class $e2ab202322af4e74$var$$n {
    /**
   * MoveDownTune constructor
   *
   * @param {API} api — Editor's API
   */ constructor({ api: e }){
        this.CSS = {
            animation: "wobble"
        }, this.api = e;
    }
    /**
   * Tune's appearance in block settings menu
   */ render() {
        return {
            icon: $e2ab202322af4e74$var$Xi,
            title: this.api.i18n.t("Move down"),
            onActivate: ()=>this.handleClick(),
            name: "move-down"
        };
    }
    /**
   * Handle clicks on 'move down' button
   */ handleClick() {
        const e = this.api.blocks.getCurrentBlockIndex(), t1 = this.api.blocks.getBlockByIndex(e + 1);
        if (!t1) throw new Error("Unable to move Block down since it is already the last");
        const o = t1.holder, i = o.getBoundingClientRect();
        let s = Math.abs(window.innerHeight - o.offsetHeight);
        i.top < window.innerHeight && (s = window.scrollY + o.offsetHeight), window.scrollTo(0, s), this.api.blocks.move(e + 1), this.api.toolbar.toggleBlockSettings(!0);
    }
}
$e2ab202322af4e74$var$$n.isTune = !0;
class $e2ab202322af4e74$var$zn {
    /**
   * DeleteTune constructor
   *
   * @param {API} api - Editor's API
   */ constructor({ api: e }){
        this.api = e;
    }
    /**
   * Tune's appearance in block settings menu
   */ render() {
        return {
            icon: $e2ab202322af4e74$var$Gi,
            title: this.api.i18n.t("Delete"),
            name: "delete",
            confirmation: {
                title: this.api.i18n.t("Click to delete"),
                onActivate: ()=>this.handleClick()
            }
        };
    }
    /**
   * Delete block conditions passed
   */ handleClick() {
        this.api.blocks.delete();
    }
}
$e2ab202322af4e74$var$zn.isTune = !0;
class $e2ab202322af4e74$var$Un {
    /**
   * MoveUpTune constructor
   *
   * @param {API} api - Editor's API
   */ constructor({ api: e }){
        this.CSS = {
            animation: "wobble"
        }, this.api = e;
    }
    /**
   * Tune's appearance in block settings menu
   */ render() {
        return {
            icon: $e2ab202322af4e74$var$Zi,
            title: this.api.i18n.t("Move up"),
            onActivate: ()=>this.handleClick(),
            name: "move-up"
        };
    }
    /**
   * Move current block up
   */ handleClick() {
        const e = this.api.blocks.getCurrentBlockIndex(), t1 = this.api.blocks.getBlockByIndex(e), o = this.api.blocks.getBlockByIndex(e - 1);
        if (e === 0 || !t1 || !o) throw new Error("Unable to move Block up since it is already the first");
        const i = t1.holder, s = o.holder, r = i.getBoundingClientRect(), a = s.getBoundingClientRect();
        let l;
        a.top > 0 ? l = Math.abs(r.top) - Math.abs(a.top) : l = Math.abs(r.top) + a.height, window.scrollBy(0, -1 * l), this.api.blocks.move(e - 1), this.api.toolbar.toggleBlockSettings(!0);
    }
}
$e2ab202322af4e74$var$Un.isTune = !0;
var $e2ab202322af4e74$var$Ba = Object.defineProperty, $e2ab202322af4e74$var$Ca = Object.getOwnPropertyDescriptor, $e2ab202322af4e74$var$Ta = (n, e, t1, o)=>{
    for(var i = o > 1 ? void 0 : o ? $e2ab202322af4e74$var$Ca(e, t1) : e, s = n.length - 1, r; s >= 0; s--)(r = n[s]) && (i = (o ? r(e, t1, i) : r(i)) || i);
    return o && i && $e2ab202322af4e74$var$Ba(e, t1, i), i;
};
class $e2ab202322af4e74$var$Wn extends $e2ab202322af4e74$var$E {
    constructor(){
        super(...arguments), this.stubTool = "stub", this.toolsAvailable = new $e2ab202322af4e74$var$j(), this.toolsUnavailable = new $e2ab202322af4e74$var$j();
    }
    /**
   * Returns available Tools
   */ get available() {
        return this.toolsAvailable;
    }
    /**
   * Returns unavailable Tools
   */ get unavailable() {
        return this.toolsUnavailable;
    }
    /**
   * Return Tools for the Inline Toolbar
   */ get inlineTools() {
        return this.available.inlineTools;
    }
    /**
   * Return editor block tools
   */ get blockTools() {
        return this.available.blockTools;
    }
    /**
   * Return available Block Tunes
   *
   * @returns {object} - object of Inline Tool's classes
   */ get blockTunes() {
        return this.available.blockTunes;
    }
    /**
   * Returns default Tool object
   */ get defaultTool() {
        return this.blockTools.get(this.config.defaultBlock);
    }
    /**
   * Returns internal tools
   */ get internal() {
        return this.available.internalTools;
    }
    /**
   * Creates instances via passed or default configuration
   *
   * @returns {Promise<void>}
   */ async prepare() {
        if (this.validateTools(), this.config.tools = $e2ab202322af4e74$var$ut({}, this.internalTools, this.config.tools), !Object.prototype.hasOwnProperty.call(this.config, "tools") || Object.keys(this.config.tools).length === 0) throw Error("Can't start without tools");
        const e = this.prepareConfig();
        this.factory = new $e2ab202322af4e74$var$xa(e, this.config, this.Editor.API);
        const t1 = this.getListOfPrepareFunctions(e);
        if (t1.length === 0) return Promise.resolve();
        await $e2ab202322af4e74$var$Qn(t1, (o)=>{
            this.toolPrepareMethodSuccess(o);
        }, (o)=>{
            this.toolPrepareMethodFallback(o);
        }), this.prepareBlockTools();
    }
    getAllInlineToolsSanitizeConfig() {
        const e = {};
        return Array.from(this.inlineTools.values()).forEach((t1)=>{
            Object.assign(e, t1.sanitizeConfig);
        }), e;
    }
    /**
   * Calls each Tool reset method to clean up anything set by Tool
   */ destroy() {
        Object.values(this.available).forEach(async (e)=>{
            $e2ab202322af4e74$var$A(e.reset) && await e.reset();
        });
    }
    /**
   * Returns internal tools
   * Includes Bold, Italic, Link and Paragraph
   */ get internalTools() {
        return {
            convertTo: {
                class: $e2ab202322af4e74$var$Fn,
                isInternal: !0
            },
            link: {
                class: $e2ab202322af4e74$var$bo,
                isInternal: !0
            },
            bold: {
                class: $e2ab202322af4e74$var$go,
                isInternal: !0
            },
            italic: {
                class: $e2ab202322af4e74$var$mo,
                isInternal: !0
            },
            paragraph: {
                class: $e2ab202322af4e74$var$fo,
                inlineToolbar: !0,
                isInternal: !0
            },
            stub: {
                class: $e2ab202322af4e74$var$jn,
                isInternal: !0
            },
            moveUp: {
                class: $e2ab202322af4e74$var$Un,
                isInternal: !0
            },
            delete: {
                class: $e2ab202322af4e74$var$zn,
                isInternal: !0
            },
            moveDown: {
                class: $e2ab202322af4e74$var$$n,
                isInternal: !0
            }
        };
    }
    /**
   * Tool prepare method success callback
   *
   * @param {object} data - append tool to available list
   */ toolPrepareMethodSuccess(e) {
        const t1 = this.factory.get(e.toolName);
        if (t1.isInline()) {
            const i = [
                "render"
            ].filter((s)=>!t1.create()[s]);
            if (i.length) {
                $e2ab202322af4e74$var$S(`Incorrect Inline Tool: ${t1.name}. Some of required methods is not implemented %o`, "warn", i), this.toolsUnavailable.set(t1.name, t1);
                return;
            }
        }
        this.toolsAvailable.set(t1.name, t1);
    }
    /**
   * Tool prepare method fail callback
   *
   * @param {object} data - append tool to unavailable list
   */ toolPrepareMethodFallback(e) {
        this.toolsUnavailable.set(e.toolName, this.factory.get(e.toolName));
    }
    /**
   * Binds prepare function of plugins with user or default config
   *
   * @returns {Array} list of functions that needs to be fired sequentially
   * @param config - tools config
   */ getListOfPrepareFunctions(e) {
        const t1 = [];
        return Object.entries(e).forEach(([o, i])=>{
            t1.push({
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                function: $e2ab202322af4e74$var$A(i.class.prepare) ? i.class.prepare : ()=>{},
                data: {
                    toolName: o,
                    config: i.config
                }
            });
        }), t1;
    }
    /**
   * Assign enabled Inline Tools and Block Tunes for Block Tool
   */ prepareBlockTools() {
        Array.from(this.blockTools.values()).forEach((e)=>{
            this.assignInlineToolsToBlockTool(e), this.assignBlockTunesToBlockTool(e);
        });
    }
    /**
   * Assign enabled Inline Tools for Block Tool
   *
   * @param tool - Block Tool
   */ assignInlineToolsToBlockTool(e) {
        if (this.config.inlineToolbar !== !1) {
            if (e.enabledInlineTools === !0) {
                e.inlineTools = new $e2ab202322af4e74$var$j(Array.isArray(this.config.inlineToolbar) ? this.config.inlineToolbar.map((t1)=>[
                        t1,
                        this.inlineTools.get(t1)
                    ]) : Array.from(this.inlineTools.entries()));
                return;
            }
            Array.isArray(e.enabledInlineTools) && (e.inlineTools = new $e2ab202322af4e74$var$j(/** Prepend ConvertTo Inline Tool */ [
                "convertTo",
                ...e.enabledInlineTools
            ].map((t1)=>[
                    t1,
                    this.inlineTools.get(t1)
                ])));
        }
    }
    /**
   * Assign enabled Block Tunes for Block Tool
   *
   * @param tool — Block Tool
   */ assignBlockTunesToBlockTool(e) {
        if (e.enabledBlockTunes !== !1) {
            if (Array.isArray(e.enabledBlockTunes)) {
                const t1 = new $e2ab202322af4e74$var$j(e.enabledBlockTunes.map((o)=>[
                        o,
                        this.blockTunes.get(o)
                    ]));
                e.tunes = new $e2ab202322af4e74$var$j([
                    ...t1,
                    ...this.blockTunes.internalTools
                ]);
                return;
            }
            if (Array.isArray(this.config.tunes)) {
                const t1 = new $e2ab202322af4e74$var$j(this.config.tunes.map((o)=>[
                        o,
                        this.blockTunes.get(o)
                    ]));
                e.tunes = new $e2ab202322af4e74$var$j([
                    ...t1,
                    ...this.blockTunes.internalTools
                ]);
                return;
            }
            e.tunes = this.blockTunes.internalTools;
        }
    }
    /**
   * Validate Tools configuration objects and throw Error for user if it is invalid
   */ validateTools() {
        for(const e in this.config.tools)if (Object.prototype.hasOwnProperty.call(this.config.tools, e)) {
            if (e in this.internalTools) return;
            const t1 = this.config.tools[e];
            if (!$e2ab202322af4e74$var$A(t1) && !$e2ab202322af4e74$var$A(t1.class)) throw Error(`Tool \xab${e}\xbb must be a constructor function or an object with function in the \xabclass\xbb property`);
        }
    }
    /**
   * Unify tools config
   */ prepareConfig() {
        const e = {};
        for(const t1 in this.config.tools)$e2ab202322af4e74$var$D(this.config.tools[t1]) ? e[t1] = this.config.tools[t1] : e[t1] = {
            class: this.config.tools[t1]
        };
        return e;
    }
}
$e2ab202322af4e74$var$Ta([
    $e2ab202322af4e74$var$me
], $e2ab202322af4e74$var$Wn.prototype, "getAllInlineToolsSanitizeConfig", 1);
const $e2ab202322af4e74$var$Sa = `:root{--selectionColor: #e1f2ff;--inlineSelectionColor: #d4ecff;--bg-light: #eff2f5;--grayText: #707684;--color-dark: #1D202B;--color-active-icon: #388AE5;--color-gray-border: rgba(201, 201, 204, .48);--content-width: 650px;--narrow-mode-right-padding: 50px;--toolbox-buttons-size: 26px;--toolbox-buttons-size--mobile: 36px;--icon-size: 20px;--icon-size--mobile: 28px;--block-padding-vertical: .4em;--color-line-gray: #EFF0F1 }.codex-editor{position:relative;-webkit-box-sizing:border-box;box-sizing:border-box;z-index:1}.codex-editor .hide{display:none}.codex-editor__redactor [contenteditable]:empty:after{content:"\\feff"}@media (min-width: 651px){.codex-editor--narrow .codex-editor__redactor{margin-right:50px}}@media (min-width: 651px){.codex-editor--narrow.codex-editor--rtl .codex-editor__redactor{margin-left:50px;margin-right:0}}@media (min-width: 651px){.codex-editor--narrow .ce-toolbar__actions{right:-5px}}.codex-editor-copyable{position:absolute;height:1px;width:1px;top:-400%;opacity:.001}.codex-editor-overlay{position:fixed;top:0;left:0;right:0;bottom:0;z-index:999;pointer-events:none;overflow:hidden}.codex-editor-overlay__container{position:relative;pointer-events:auto;z-index:0}.codex-editor-overlay__rectangle{position:absolute;pointer-events:none;background-color:#2eaadc33;border:1px solid transparent}.codex-editor svg{max-height:100%}.codex-editor path{stroke:currentColor}.codex-editor ::-moz-selection{background-color:#d4ecff}.codex-editor ::selection{background-color:#d4ecff}.codex-editor--toolbox-opened [contentEditable=true][data-placeholder]:focus:before{opacity:0!important}.ce-scroll-locked{overflow:hidden}.ce-scroll-locked--hard{overflow:hidden;top:calc(-1 * var(--window-scroll-offset));position:fixed;width:100%}.ce-toolbar{position:absolute;left:0;right:0;top:0;-webkit-transition:opacity .1s ease;transition:opacity .1s ease;will-change:opacity,top;display:none}.ce-toolbar--opened{display:block}.ce-toolbar__content{max-width:650px;margin:0 auto;position:relative}.ce-toolbar__plus{color:#1d202b;cursor:pointer;width:26px;height:26px;border-radius:7px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-ms-flex-negative:0;flex-shrink:0}@media (max-width: 650px){.ce-toolbar__plus{width:36px;height:36px}}@media (hover: hover){.ce-toolbar__plus:hover{background-color:#eff2f5}}.ce-toolbar__plus--active{background-color:#eff2f5;-webkit-animation:bounceIn .75s 1;animation:bounceIn .75s 1;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards}.ce-toolbar__plus-shortcut{opacity:.6;word-spacing:-2px;margin-top:5px}@media (max-width: 650px){.ce-toolbar__plus{position:absolute;background-color:#fff;border:1px solid #E8E8EB;-webkit-box-shadow:0 3px 15px -3px rgba(13,20,33,.13);box-shadow:0 3px 15px -3px #0d142121;border-radius:6px;z-index:2;position:static}.ce-toolbar__plus--left-oriented:before{left:15px;margin-left:0}.ce-toolbar__plus--right-oriented:before{left:auto;right:15px;margin-left:0}}.ce-toolbar__actions{position:absolute;right:100%;opacity:0;display:-webkit-box;display:-ms-flexbox;display:flex;padding-right:5px}.ce-toolbar__actions--opened{opacity:1}@media (max-width: 650px){.ce-toolbar__actions{right:auto}}.ce-toolbar__settings-btn{color:#1d202b;width:26px;height:26px;border-radius:7px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;margin-left:3px;cursor:pointer;user-select:none}@media (max-width: 650px){.ce-toolbar__settings-btn{width:36px;height:36px}}@media (hover: hover){.ce-toolbar__settings-btn:hover{background-color:#eff2f5}}.ce-toolbar__settings-btn--active{background-color:#eff2f5;-webkit-animation:bounceIn .75s 1;animation:bounceIn .75s 1;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards}@media (min-width: 651px){.ce-toolbar__settings-btn{width:24px}}.ce-toolbar__settings-btn--hidden{display:none}@media (max-width: 650px){.ce-toolbar__settings-btn{position:absolute;background-color:#fff;border:1px solid #E8E8EB;-webkit-box-shadow:0 3px 15px -3px rgba(13,20,33,.13);box-shadow:0 3px 15px -3px #0d142121;border-radius:6px;z-index:2;position:static}.ce-toolbar__settings-btn--left-oriented:before{left:15px;margin-left:0}.ce-toolbar__settings-btn--right-oriented:before{left:auto;right:15px;margin-left:0}}.ce-toolbar__plus svg,.ce-toolbar__settings-btn svg{width:24px;height:24px}@media (min-width: 651px){.codex-editor--narrow .ce-toolbar__plus{left:5px}}@media (min-width: 651px){.codex-editor--narrow .ce-toolbox .ce-popover{right:0;left:auto;left:initial}}.ce-inline-toolbar{--y-offset: 8px;--color-background-icon-active: rgba(56, 138, 229, .1);--color-text-icon-active: #388AE5;--color-text-primary: black;position:absolute;visibility:hidden;-webkit-transition:opacity .25s ease;transition:opacity .25s ease;will-change:opacity,left,top;top:0;left:0;z-index:3;opacity:1;visibility:visible}.ce-inline-toolbar [hidden]{display:none!important}.ce-inline-toolbar__toggler-and-button-wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;padding:0 6px}.ce-inline-toolbar__buttons{display:-webkit-box;display:-ms-flexbox;display:flex}.ce-inline-toolbar__dropdown{display:-webkit-box;display:-ms-flexbox;display:flex;padding:6px;margin:0 6px 0 -6px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;cursor:pointer;border-right:1px solid rgba(201,201,204,.48);-webkit-box-sizing:border-box;box-sizing:border-box}@media (hover: hover){.ce-inline-toolbar__dropdown:hover{background:#eff2f5}}.ce-inline-toolbar__dropdown--hidden{display:none}.ce-inline-toolbar__dropdown-content,.ce-inline-toolbar__dropdown-arrow{display:-webkit-box;display:-ms-flexbox;display:flex}.ce-inline-toolbar__dropdown-content svg,.ce-inline-toolbar__dropdown-arrow svg{width:20px;height:20px}.ce-inline-toolbar__shortcut{opacity:.6;word-spacing:-3px;margin-top:3px}.ce-inline-tool{color:var(--color-text-primary);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;border:0;border-radius:4px;line-height:normal;height:100%;padding:0;width:28px;background-color:transparent;cursor:pointer}@media (max-width: 650px){.ce-inline-tool{width:36px;height:36px}}@media (hover: hover){.ce-inline-tool:hover{background-color:#f8f8f8}}.ce-inline-tool svg{display:block;width:20px;height:20px}@media (max-width: 650px){.ce-inline-tool svg{width:28px;height:28px}}.ce-inline-tool--link .icon--unlink,.ce-inline-tool--unlink .icon--link{display:none}.ce-inline-tool--unlink .icon--unlink{display:inline-block;margin-bottom:-1px}.ce-inline-tool-input{background:#F8F8F8;border:1px solid rgba(226,226,229,.2);border-radius:6px;padding:4px 8px;font-size:14px;line-height:22px;outline:none;margin:0;width:100%;-webkit-box-sizing:border-box;box-sizing:border-box;display:none;font-weight:500;-webkit-appearance:none;font-family:inherit}@media (max-width: 650px){.ce-inline-tool-input{font-size:15px;font-weight:500}}.ce-inline-tool-input::-webkit-input-placeholder{color:#707684}.ce-inline-tool-input::-moz-placeholder{color:#707684}.ce-inline-tool-input:-ms-input-placeholder{color:#707684}.ce-inline-tool-input::-ms-input-placeholder{color:#707684}.ce-inline-tool-input::placeholder{color:#707684}.ce-inline-tool-input--showed{display:block}.ce-inline-tool--active{background:var(--color-background-icon-active);color:var(--color-text-icon-active)}@-webkit-keyframes fade-in{0%{opacity:0}to{opacity:1}}@keyframes fade-in{0%{opacity:0}to{opacity:1}}.ce-block{-webkit-animation:fade-in .3s ease;animation:fade-in .3s ease;-webkit-animation-fill-mode:none;animation-fill-mode:none;-webkit-animation-fill-mode:initial;animation-fill-mode:initial}.ce-block:first-of-type{margin-top:0}.ce-block--selected .ce-block__content{background:#e1f2ff}.ce-block--selected .ce-block__content [contenteditable]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ce-block--selected .ce-block__content img,.ce-block--selected .ce-block__content .ce-stub{opacity:.55}.ce-block--stretched .ce-block__content{max-width:none}.ce-block__content{position:relative;max-width:650px;margin:0 auto;-webkit-transition:background-color .15s ease;transition:background-color .15s ease}.ce-block--drop-target .ce-block__content:before{content:"";position:absolute;top:100%;left:-20px;margin-top:-1px;height:8px;width:8px;border:solid #388AE5;border-width:1px 1px 0 0;-webkit-transform-origin:right;transform-origin:right;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.ce-block--drop-target .ce-block__content:after{content:"";position:absolute;top:100%;height:1px;width:100%;color:#388ae5;background:repeating-linear-gradient(90deg,#388AE5,#388AE5 1px,#fff 1px,#fff 6px)}.ce-block a{cursor:pointer;-webkit-text-decoration:underline;text-decoration:underline}.ce-block b{font-weight:700}.ce-block i{font-style:italic}@-webkit-keyframes bounceIn{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}20%{-webkit-transform:scale3d(1.03,1.03,1.03);transform:scale3d(1.03,1.03,1.03)}60%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}@keyframes bounceIn{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}20%{-webkit-transform:scale3d(1.03,1.03,1.03);transform:scale3d(1.03,1.03,1.03)}60%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}@-webkit-keyframes selectionBounce{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}50%{-webkit-transform:scale3d(1.01,1.01,1.01);transform:scale3d(1.01,1.01,1.01)}70%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}@keyframes selectionBounce{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}50%{-webkit-transform:scale3d(1.01,1.01,1.01);transform:scale3d(1.01,1.01,1.01)}70%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}@-webkit-keyframes buttonClicked{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{-webkit-transform:scale3d(.95,.95,.95);transform:scale3d(.95,.95,.95)}60%{-webkit-transform:scale3d(1.02,1.02,1.02);transform:scale3d(1.02,1.02,1.02)}80%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}@keyframes buttonClicked{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{-webkit-transform:scale3d(.95,.95,.95);transform:scale3d(.95,.95,.95)}60%{-webkit-transform:scale3d(1.02,1.02,1.02);transform:scale3d(1.02,1.02,1.02)}80%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}.cdx-block{padding:.4em 0}.cdx-block::-webkit-input-placeholder{line-height:normal!important}.cdx-input{border:1px solid rgba(201,201,204,.48);-webkit-box-shadow:inset 0 1px 2px 0 rgba(35,44,72,.06);box-shadow:inset 0 1px 2px #232c480f;border-radius:3px;padding:10px 12px;outline:none;width:100%;-webkit-box-sizing:border-box;box-sizing:border-box}.cdx-input[data-placeholder]:before{position:static!important}.cdx-input[data-placeholder]:before{display:inline-block;width:0;white-space:nowrap;pointer-events:none}.cdx-settings-button{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;border-radius:3px;cursor:pointer;border:0;outline:none;background-color:transparent;vertical-align:bottom;color:inherit;margin:0;min-width:26px;min-height:26px}.cdx-settings-button--focused{background:rgba(34,186,255,.08)!important}.cdx-settings-button--focused{-webkit-box-shadow:inset 0 0 0px 1px rgba(7,161,227,.08);box-shadow:inset 0 0 0 1px #07a1e314}.cdx-settings-button--focused-animated{-webkit-animation-name:buttonClicked;animation-name:buttonClicked;-webkit-animation-duration:.25s;animation-duration:.25s}.cdx-settings-button--active{color:#388ae5}.cdx-settings-button svg{width:auto;height:auto}@media (max-width: 650px){.cdx-settings-button svg{width:28px;height:28px}}@media (max-width: 650px){.cdx-settings-button{width:36px;height:36px;border-radius:8px}}@media (hover: hover){.cdx-settings-button:hover{background-color:#eff2f5}}.cdx-loader{position:relative;border:1px solid rgba(201,201,204,.48)}.cdx-loader:before{content:"";position:absolute;left:50%;top:50%;width:18px;height:18px;margin:-11px 0 0 -11px;border:2px solid rgba(201,201,204,.48);border-left-color:#388ae5;border-radius:50%;-webkit-animation:cdxRotation 1.2s infinite linear;animation:cdxRotation 1.2s infinite linear}@-webkit-keyframes cdxRotation{0%{-webkit-transform:rotate(0deg);transform:rotate(0)}to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes cdxRotation{0%{-webkit-transform:rotate(0deg);transform:rotate(0)}to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}.cdx-button{padding:13px;border-radius:3px;border:1px solid rgba(201,201,204,.48);font-size:14.9px;background:#fff;-webkit-box-shadow:0 2px 2px 0 rgba(18,30,57,.04);box-shadow:0 2px 2px #121e390a;color:#707684;text-align:center;cursor:pointer}@media (hover: hover){.cdx-button:hover{background:#FBFCFE;-webkit-box-shadow:0 1px 3px 0 rgba(18,30,57,.08);box-shadow:0 1px 3px #121e3914}}.cdx-button svg{height:20px;margin-right:.2em;margin-top:-2px}.ce-stub{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:12px 18px;margin:10px 0;border-radius:10px;background:#eff2f5;border:1px solid #EFF0F1;color:#707684;font-size:14px}.ce-stub svg{width:20px;height:20px}.ce-stub__info{margin-left:14px}.ce-stub__title{font-weight:500;text-transform:capitalize}.codex-editor.codex-editor--rtl{direction:rtl}.codex-editor.codex-editor--rtl .cdx-list{padding-left:0;padding-right:40px}.codex-editor.codex-editor--rtl .ce-toolbar__plus{right:-26px;left:auto}.codex-editor.codex-editor--rtl .ce-toolbar__actions{right:auto;left:-26px}@media (max-width: 650px){.codex-editor.codex-editor--rtl .ce-toolbar__actions{margin-left:0;margin-right:auto;padding-right:0;padding-left:10px}}.codex-editor.codex-editor--rtl .ce-settings{left:5px;right:auto}.codex-editor.codex-editor--rtl .ce-settings:before{right:auto;left:25px}.codex-editor.codex-editor--rtl .ce-settings__button:not(:nth-child(3n+3)){margin-left:3px;margin-right:0}.codex-editor.codex-editor--rtl .ce-conversion-tool__icon{margin-right:0;margin-left:10px}.codex-editor.codex-editor--rtl .ce-inline-toolbar__dropdown{border-right:0px solid transparent;border-left:1px solid rgba(201,201,204,.48);margin:0 -6px 0 6px}.codex-editor.codex-editor--rtl .ce-inline-toolbar__dropdown .icon--toggler-down{margin-left:0;margin-right:4px}@media (min-width: 651px){.codex-editor--narrow.codex-editor--rtl .ce-toolbar__plus{left:0;right:5px}}@media (min-width: 651px){.codex-editor--narrow.codex-editor--rtl .ce-toolbar__actions{left:-5px}}.cdx-search-field{--icon-margin-right: 10px;background:#F8F8F8;border:1px solid rgba(226,226,229,.2);border-radius:6px;padding:2px;display:grid;grid-template-columns:auto auto 1fr;grid-template-rows:auto}.cdx-search-field__icon{width:26px;height:26px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-right:var(--icon-margin-right)}.cdx-search-field__icon svg{width:20px;height:20px;color:#707684}.cdx-search-field__input{font-size:14px;outline:none;font-weight:500;font-family:inherit;border:0;background:transparent;margin:0;padding:0;line-height:22px;min-width:calc(100% - 26px - var(--icon-margin-right))}.cdx-search-field__input::-webkit-input-placeholder{color:#707684;font-weight:500}.cdx-search-field__input::-moz-placeholder{color:#707684;font-weight:500}.cdx-search-field__input:-ms-input-placeholder{color:#707684;font-weight:500}.cdx-search-field__input::-ms-input-placeholder{color:#707684;font-weight:500}.cdx-search-field__input::placeholder{color:#707684;font-weight:500}.ce-popover{--border-radius: 6px;--width: 200px;--max-height: 270px;--padding: 6px;--offset-from-target: 8px;--color-border: #EFF0F1;--color-shadow: rgba(13, 20, 33, .1);--color-background: white;--color-text-primary: black;--color-text-secondary: #707684;--color-border-icon: rgba(201, 201, 204, .48);--color-border-icon-disabled: #EFF0F1;--color-text-icon-active: #388AE5;--color-background-icon-active: rgba(56, 138, 229, .1);--color-background-item-focus: rgba(34, 186, 255, .08);--color-shadow-item-focus: rgba(7, 161, 227, .08);--color-background-item-hover: #F8F8F8;--color-background-item-confirm: #E24A4A;--color-background-item-confirm-hover: #CE4343;--popover-top: calc(100% + var(--offset-from-target));--popover-left: 0;--nested-popover-overlap: 4px;--icon-size: 20px;--item-padding: 3px;--item-height: calc(var(--icon-size) + 2 * var(--item-padding))}.ce-popover__container{min-width:var(--width);width:var(--width);max-height:var(--max-height);border-radius:var(--border-radius);overflow:hidden;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-box-shadow:0px 3px 15px -3px var(--color-shadow);box-shadow:0 3px 15px -3px var(--color-shadow);position:absolute;left:var(--popover-left);top:var(--popover-top);background:var(--color-background);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;z-index:4;opacity:0;max-height:0;pointer-events:none;padding:0;border:none}.ce-popover--opened>.ce-popover__container{opacity:1;padding:var(--padding);max-height:var(--max-height);pointer-events:auto;-webkit-animation:panelShowing .1s ease;animation:panelShowing .1s ease;border:1px solid var(--color-border)}@media (max-width: 650px){.ce-popover--opened>.ce-popover__container{-webkit-animation:panelShowingMobile .25s ease;animation:panelShowingMobile .25s ease}}.ce-popover--open-top .ce-popover__container{--popover-top: calc(-1 * (var(--offset-from-target) + var(--popover-height)))}.ce-popover--open-left .ce-popover__container{--popover-left: calc(-1 * var(--width) + 100%)}.ce-popover__items{overflow-y:auto;-ms-scroll-chaining:none;overscroll-behavior:contain}@media (max-width: 650px){.ce-popover__overlay{position:fixed;top:0;bottom:0;left:0;right:0;background:#1D202B;z-index:3;opacity:.5;-webkit-transition:opacity .12s ease-in;transition:opacity .12s ease-in;will-change:opacity;visibility:visible}}.ce-popover__overlay--hidden{display:none}@media (max-width: 650px){.ce-popover .ce-popover__container{--offset: 5px;position:fixed;max-width:none;min-width:calc(100% - var(--offset) * 2);left:var(--offset);right:var(--offset);bottom:calc(var(--offset) + env(safe-area-inset-bottom));top:auto;border-radius:10px}}.ce-popover__search{margin-bottom:5px}.ce-popover__nothing-found-message{color:#707684;display:none;cursor:default;padding:3px;font-size:14px;line-height:20px;font-weight:500;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ce-popover__nothing-found-message--displayed{display:block}.ce-popover--nested .ce-popover__container{--popover-left: calc(var(--nesting-level) * (var(--width) - var(--nested-popover-overlap)));top:calc(var(--trigger-item-top) - var(--nested-popover-overlap));position:absolute}.ce-popover--open-top.ce-popover--nested .ce-popover__container{top:calc(var(--trigger-item-top) - var(--popover-height) + var(--item-height) + var(--offset-from-target) + var(--nested-popover-overlap))}.ce-popover--open-left .ce-popover--nested .ce-popover__container{--popover-left: calc(-1 * (var(--nesting-level) + 1) * var(--width) + 100%)}.ce-popover-item-separator{padding:4px 3px}.ce-popover-item-separator--hidden{display:none}.ce-popover-item-separator__line{height:1px;background:var(--color-border);width:100%}.ce-popover-item-html--hidden{display:none}.ce-popover-item{--border-radius: 6px;border-radius:var(--border-radius);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:var(--item-padding);color:var(--color-text-primary);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border:none;background:transparent}@media (max-width: 650px){.ce-popover-item{padding:4px}}.ce-popover-item:not(:last-of-type){margin-bottom:1px}.ce-popover-item__icon{width:26px;height:26px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.ce-popover-item__icon svg{width:20px;height:20px}@media (max-width: 650px){.ce-popover-item__icon{width:36px;height:36px;border-radius:8px}.ce-popover-item__icon svg{width:28px;height:28px}}.ce-popover-item__icon--tool{margin-right:4px}.ce-popover-item__title{font-size:14px;line-height:20px;font-weight:500;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;margin-right:auto}@media (max-width: 650px){.ce-popover-item__title{font-size:16px}}.ce-popover-item__secondary-title{color:var(--color-text-secondary);font-size:12px;white-space:nowrap;letter-spacing:-.1em;padding-right:5px;opacity:.6}@media (max-width: 650px){.ce-popover-item__secondary-title{display:none}}.ce-popover-item--active{background:var(--color-background-icon-active);color:var(--color-text-icon-active)}.ce-popover-item--disabled{color:var(--color-text-secondary);cursor:default;pointer-events:none}.ce-popover-item--focused:not(.ce-popover-item--no-focus){background:var(--color-background-item-focus)!important}.ce-popover-item--hidden{display:none}@media (hover: hover){.ce-popover-item:hover{cursor:pointer}.ce-popover-item:hover:not(.ce-popover-item--no-hover){background-color:var(--color-background-item-hover)}}.ce-popover-item--confirmation{background:var(--color-background-item-confirm)}.ce-popover-item--confirmation .ce-popover-item__title,.ce-popover-item--confirmation .ce-popover-item__icon{color:#fff}@media (hover: hover){.ce-popover-item--confirmation:not(.ce-popover-item--no-hover):hover{background:var(--color-background-item-confirm-hover)}}.ce-popover-item--confirmation:not(.ce-popover-item--no-focus).ce-popover-item--focused{background:var(--color-background-item-confirm-hover)!important}@-webkit-keyframes panelShowing{0%{opacity:0;-webkit-transform:translateY(-8px) scale(.9);transform:translateY(-8px) scale(.9)}70%{opacity:1;-webkit-transform:translateY(2px);transform:translateY(2px)}to{-webkit-transform:translateY(0);transform:translateY(0)}}@keyframes panelShowing{0%{opacity:0;-webkit-transform:translateY(-8px) scale(.9);transform:translateY(-8px) scale(.9)}70%{opacity:1;-webkit-transform:translateY(2px);transform:translateY(2px)}to{-webkit-transform:translateY(0);transform:translateY(0)}}@-webkit-keyframes panelShowingMobile{0%{opacity:0;-webkit-transform:translateY(14px) scale(.98);transform:translateY(14px) scale(.98)}70%{opacity:1;-webkit-transform:translateY(-4px);transform:translateY(-4px)}to{-webkit-transform:translateY(0);transform:translateY(0)}}@keyframes panelShowingMobile{0%{opacity:0;-webkit-transform:translateY(14px) scale(.98);transform:translateY(14px) scale(.98)}70%{opacity:1;-webkit-transform:translateY(-4px);transform:translateY(-4px)}to{-webkit-transform:translateY(0);transform:translateY(0)}}.wobble{-webkit-animation-name:wobble;animation-name:wobble;-webkit-animation-duration:.4s;animation-duration:.4s}@-webkit-keyframes wobble{0%{-webkit-transform:translate3d(0,0,0);transform:translateZ(0)}15%{-webkit-transform:translate3d(-9%,0,0);transform:translate3d(-9%,0,0)}30%{-webkit-transform:translate3d(9%,0,0);transform:translate3d(9%,0,0)}45%{-webkit-transform:translate3d(-4%,0,0);transform:translate3d(-4%,0,0)}60%{-webkit-transform:translate3d(4%,0,0);transform:translate3d(4%,0,0)}75%{-webkit-transform:translate3d(-1%,0,0);transform:translate3d(-1%,0,0)}to{-webkit-transform:translate3d(0,0,0);transform:translateZ(0)}}@keyframes wobble{0%{-webkit-transform:translate3d(0,0,0);transform:translateZ(0)}15%{-webkit-transform:translate3d(-9%,0,0);transform:translate3d(-9%,0,0)}30%{-webkit-transform:translate3d(9%,0,0);transform:translate3d(9%,0,0)}45%{-webkit-transform:translate3d(-4%,0,0);transform:translate3d(-4%,0,0)}60%{-webkit-transform:translate3d(4%,0,0);transform:translate3d(4%,0,0)}75%{-webkit-transform:translate3d(-1%,0,0);transform:translate3d(-1%,0,0)}to{-webkit-transform:translate3d(0,0,0);transform:translateZ(0)}}.ce-popover-header{margin-bottom:8px;margin-top:4px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ce-popover-header__text{font-size:18px;font-weight:600}.ce-popover-header__back-button{border:0;background:transparent;width:36px;height:36px;color:var(--color-text-primary)}.ce-popover-header__back-button svg{display:block;width:28px;height:28px}.ce-popover--inline{--height: 38px;--height-mobile: 46px;--container-padding: 4px;position:relative}.ce-popover--inline .ce-popover__custom-content{margin-bottom:0}.ce-popover--inline .ce-popover__items{display:-webkit-box;display:-ms-flexbox;display:flex}.ce-popover--inline .ce-popover__container{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;padding:var(--container-padding);height:var(--height);top:0;min-width:-webkit-max-content;min-width:-moz-max-content;min-width:max-content;width:-webkit-max-content;width:-moz-max-content;width:max-content;-webkit-animation:none;animation:none}@media (max-width: 650px){.ce-popover--inline .ce-popover__container{height:var(--height-mobile);position:absolute}}.ce-popover--inline .ce-popover-item-separator{padding:0 4px}.ce-popover--inline .ce-popover-item-separator__line{height:100%;width:1px}.ce-popover--inline .ce-popover-item{border-radius:4px;padding:4px}.ce-popover--inline .ce-popover-item__icon--tool{-webkit-box-shadow:none;box-shadow:none;background:transparent;margin-right:0}.ce-popover--inline .ce-popover-item__icon{width:auto;width:initial;height:auto;height:initial}.ce-popover--inline .ce-popover-item__icon svg{width:20px;height:20px}@media (max-width: 650px){.ce-popover--inline .ce-popover-item__icon svg{width:28px;height:28px}}.ce-popover--inline .ce-popover-item:not(:last-of-type){margin-bottom:0;margin-bottom:initial}.ce-popover--inline .ce-popover-item-html{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ce-popover--inline .ce-popover-item__icon--chevron-right{-webkit-transform:rotate(90deg);transform:rotate(90deg)}.ce-popover--inline .ce-popover--nested-level-1 .ce-popover__container{--offset: 3px;left:0;top:calc(var(--height) + var(--offset))}@media (max-width: 650px){.ce-popover--inline .ce-popover--nested-level-1 .ce-popover__container{top:calc(var(--height-mobile) + var(--offset))}}.ce-popover--inline .ce-popover--nested .ce-popover__container{min-width:var(--width);width:var(--width);height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;padding:6px;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.ce-popover--inline .ce-popover--nested .ce-popover__items{display:block;width:100%}.ce-popover--inline .ce-popover--nested .ce-popover-item{border-radius:6px;padding:3px}@media (max-width: 650px){.ce-popover--inline .ce-popover--nested .ce-popover-item{padding:4px}}.ce-popover--inline .ce-popover--nested .ce-popover-item__icon--tool{margin-right:4px}.ce-popover--inline .ce-popover--nested .ce-popover-item__icon{width:26px;height:26px}.ce-popover--inline .ce-popover--nested .ce-popover-item-separator{padding:4px 3px}.ce-popover--inline .ce-popover--nested .ce-popover-item-separator__line{width:100%;height:1px}.codex-editor [data-placeholder]:empty:before,.codex-editor [data-placeholder][data-empty=true]:before{pointer-events:none;color:#707684;cursor:text;content:attr(data-placeholder)}.codex-editor [data-placeholder-active]:empty:before,.codex-editor [data-placeholder-active][data-empty=true]:before{pointer-events:none;color:#707684;cursor:text}.codex-editor [data-placeholder-active]:empty:focus:before,.codex-editor [data-placeholder-active][data-empty=true]:focus:before{content:attr(data-placeholder-active)}
`;
class $e2ab202322af4e74$var$Ia extends $e2ab202322af4e74$var$E {
    constructor(){
        super(...arguments), this.isMobile = !1, this.contentRectCache = null, this.resizeDebouncer = $e2ab202322af4e74$var$Eo(()=>{
            this.windowResize();
        }, 200), this.selectionChangeDebounced = $e2ab202322af4e74$var$Eo(()=>{
            this.selectionChanged();
        }, $e2ab202322af4e74$var$da), this.documentTouchedListener = (e)=>{
            this.documentTouched(e);
        };
    }
    /**
   * Editor.js UI CSS class names
   *
   * @returns {{editorWrapper: string, editorZone: string}}
   */ get CSS() {
        return {
            editorWrapper: "codex-editor",
            editorWrapperNarrow: "codex-editor--narrow",
            editorZone: "codex-editor__redactor",
            editorZoneHidden: "codex-editor__redactor--hidden",
            editorEmpty: "codex-editor--empty",
            editorRtlFix: "codex-editor--rtl"
        };
    }
    /**
   * Return Width of center column of Editor
   *
   * @returns {DOMRect}
   */ get contentRect() {
        if (this.contentRectCache !== null) return this.contentRectCache;
        const e = this.nodes.wrapper.querySelector(`.${$e2ab202322af4e74$var$R.CSS.content}`);
        return e ? (this.contentRectCache = e.getBoundingClientRect(), this.contentRectCache) : {
            width: 650,
            left: 0,
            right: 0
        };
    }
    /**
   * Making main interface
   */ async prepare() {
        this.setIsMobile(), this.make(), this.loadStyles();
    }
    /**
   * Toggle read-only state
   *
   * If readOnly is true:
   *  - removes all listeners from main UI module elements
   *
   * if readOnly is false:
   *  - enables all listeners to UI module elements
   *
   * @param {boolean} readOnlyEnabled - "read only" state
   */ toggleReadOnly(e) {
        e ? this.unbindReadOnlySensitiveListeners() : window.requestIdleCallback(()=>{
            this.bindReadOnlySensitiveListeners();
        }, {
            timeout: 2e3
        });
    }
    /**
   * Check if Editor is empty and set CSS class to wrapper
   */ checkEmptiness() {
        const { BlockManager: e } = this.Editor;
        this.nodes.wrapper.classList.toggle(this.CSS.editorEmpty, e.isEditorEmpty);
    }
    /**
   * Check if one of Toolbar is opened
   * Used to prevent global keydowns (for example, Enter) conflicts with Enter-on-toolbar
   *
   * @returns {boolean}
   */ get someToolbarOpened() {
        const { Toolbar: e, BlockSettings: t1, InlineToolbar: o } = this.Editor;
        return !!(t1.opened || o.opened || e.toolbox.opened);
    }
    /**
   * Check for some Flipper-buttons is under focus
   */ get someFlipperButtonFocused() {
        return this.Editor.Toolbar.toolbox.hasFocus() ? !0 : Object.entries(this.Editor).filter(([e, t1])=>t1.flipper instanceof $e2ab202322af4e74$var$ce).some(([e, t1])=>t1.flipper.hasFocus());
    }
    /**
   * Clean editor`s UI
   */ destroy() {
        this.nodes.holder.innerHTML = "", this.unbindReadOnlyInsensitiveListeners();
    }
    /**
   * Close all Editor's toolbars
   */ closeAllToolbars() {
        const { Toolbar: e, BlockSettings: t1, InlineToolbar: o } = this.Editor;
        t1.close(), o.close(), e.toolbox.close();
    }
    /**
   * Check for mobile mode and save the result
   */ setIsMobile() {
        const e = window.innerWidth < $e2ab202322af4e74$var$Ro;
        e !== this.isMobile && this.eventsDispatcher.emit($e2ab202322af4e74$var$Te, {
            isEnabled: this.isMobile
        }), this.isMobile = e;
    }
    /**
   * Makes Editor.js interface
   */ make() {
        this.nodes.holder = $e2ab202322af4e74$var$u.getHolder(this.config.holder), this.nodes.wrapper = $e2ab202322af4e74$var$u.make("div", [
            this.CSS.editorWrapper,
            ...this.isRtl ? [
                this.CSS.editorRtlFix
            ] : []
        ]), this.nodes.redactor = $e2ab202322af4e74$var$u.make("div", this.CSS.editorZone), this.nodes.holder.offsetWidth < this.contentRect.width && this.nodes.wrapper.classList.add(this.CSS.editorWrapperNarrow), this.nodes.redactor.style.paddingBottom = this.config.minHeight + "px", this.nodes.wrapper.appendChild(this.nodes.redactor), this.nodes.holder.appendChild(this.nodes.wrapper), this.bindReadOnlyInsensitiveListeners();
    }
    /**
   * Appends CSS
   */ loadStyles() {
        const e = "editor-js-styles";
        if ($e2ab202322af4e74$var$u.get(e)) return;
        const t1 = $e2ab202322af4e74$var$u.make("style", null, {
            id: e,
            textContent: $e2ab202322af4e74$var$Sa.toString()
        });
        this.config.style && !$e2ab202322af4e74$var$V(this.config.style) && this.config.style.nonce && t1.setAttribute("nonce", this.config.style.nonce), $e2ab202322af4e74$var$u.prepend(document.head, t1);
    }
    /**
   * Adds listeners that should work both in read-only and read-write modes
   */ bindReadOnlyInsensitiveListeners() {
        this.listeners.on(document, "selectionchange", this.selectionChangeDebounced), this.listeners.on(window, "resize", this.resizeDebouncer, {
            passive: !0
        }), this.listeners.on(this.nodes.redactor, "mousedown", this.documentTouchedListener, {
            capture: !0,
            passive: !0
        }), this.listeners.on(this.nodes.redactor, "touchstart", this.documentTouchedListener, {
            capture: !0,
            passive: !0
        });
    }
    /**
   * Removes listeners that should work both in read-only and read-write modes
   */ unbindReadOnlyInsensitiveListeners() {
        this.listeners.off(document, "selectionchange", this.selectionChangeDebounced), this.listeners.off(window, "resize", this.resizeDebouncer), this.listeners.off(this.nodes.redactor, "mousedown", this.documentTouchedListener), this.listeners.off(this.nodes.redactor, "touchstart", this.documentTouchedListener);
    }
    /**
   * Adds listeners that should work only in read-only mode
   */ bindReadOnlySensitiveListeners() {
        this.readOnlyMutableListeners.on(this.nodes.redactor, "click", (e)=>{
            this.redactorClicked(e);
        }, !1), this.readOnlyMutableListeners.on(document, "keydown", (e)=>{
            this.documentKeydown(e);
        }, !0), this.readOnlyMutableListeners.on(document, "mousedown", (e)=>{
            this.documentClicked(e);
        }, !0), this.watchBlockHoveredEvents(), this.enableInputsEmptyMark();
    }
    /**
   * Listen redactor mousemove to emit 'block-hovered' event
   */ watchBlockHoveredEvents() {
        let e;
        this.readOnlyMutableListeners.on(this.nodes.redactor, "mousemove", $e2ab202322af4e74$var$dt((t1)=>{
            const o = t1.target.closest(".ce-block");
            this.Editor.BlockSelection.anyBlockSelected || o && e !== o && (e = o, this.eventsDispatcher.emit($e2ab202322af4e74$var$ln, {
                block: this.Editor.BlockManager.getBlockByChildNode(o)
            }));
        }, 20), {
            passive: !0
        });
    }
    /**
   * Unbind events that should work only in read-only mode
   */ unbindReadOnlySensitiveListeners() {
        this.readOnlyMutableListeners.clearAll();
    }
    /**
   * Resize window handler
   */ windowResize() {
        this.contentRectCache = null, this.setIsMobile();
    }
    /**
   * All keydowns on document
   *
   * @param {KeyboardEvent} event - keyboard event
   */ documentKeydown(e) {
        switch(e.keyCode){
            case $e2ab202322af4e74$var$y.ENTER:
                this.enterPressed(e);
                break;
            case $e2ab202322af4e74$var$y.BACKSPACE:
            case $e2ab202322af4e74$var$y.DELETE:
                this.backspacePressed(e);
                break;
            case $e2ab202322af4e74$var$y.ESC:
                this.escapePressed(e);
                break;
            default:
                this.defaultBehaviour(e);
                break;
        }
    }
    /**
   * Ignore all other document's keydown events
   *
   * @param {KeyboardEvent} event - keyboard event
   */ defaultBehaviour(e) {
        const { currentBlock: t1 } = this.Editor.BlockManager, o = e.target.closest(`.${this.CSS.editorWrapper}`), i = e.altKey || e.ctrlKey || e.metaKey || e.shiftKey;
        if (t1 !== void 0 && o === null) {
            this.Editor.BlockEvents.keydown(e);
            return;
        }
        o || t1 && i || (this.Editor.BlockManager.unsetCurrentBlock(), this.Editor.Toolbar.close());
    }
    /**
   * @param {KeyboardEvent} event - keyboard event
   */ backspacePressed(e) {
        const { BlockManager: t1, BlockSelection: o, Caret: i } = this.Editor;
        if (o.anyBlockSelected && !$e2ab202322af4e74$var$b.isSelectionExists) {
            const s = t1.removeSelectedBlocks(), r = t1.insertDefaultBlockAtIndex(s, !0);
            i.setToBlock(r, i.positions.START), o.clearSelection(e), e.preventDefault(), e.stopPropagation(), e.stopImmediatePropagation();
        }
    }
    /**
   * Escape pressed
   * If some of Toolbar components are opened, then close it otherwise close Toolbar
   *
   * @param {Event} event - escape keydown event
   */ escapePressed(e) {
        this.Editor.BlockSelection.clearSelection(e), this.Editor.Toolbar.toolbox.opened ? (this.Editor.Toolbar.toolbox.close(), this.Editor.Caret.setToBlock(this.Editor.BlockManager.currentBlock, this.Editor.Caret.positions.END)) : this.Editor.BlockSettings.opened ? this.Editor.BlockSettings.close() : this.Editor.InlineToolbar.opened ? this.Editor.InlineToolbar.close() : this.Editor.Toolbar.close();
    }
    /**
   * Enter pressed on document
   *
   * @param {KeyboardEvent} event - keyboard event
   */ enterPressed(e) {
        const { BlockManager: t1, BlockSelection: o } = this.Editor;
        if (this.someToolbarOpened) return;
        const i = t1.currentBlockIndex >= 0;
        if (o.anyBlockSelected && !$e2ab202322af4e74$var$b.isSelectionExists) {
            o.clearSelection(e), e.preventDefault(), e.stopImmediatePropagation(), e.stopPropagation();
            return;
        }
        if (!this.someToolbarOpened && i && e.target.tagName === "BODY") {
            const s = this.Editor.BlockManager.insert();
            e.preventDefault(), this.Editor.Caret.setToBlock(s), this.Editor.Toolbar.moveAndOpen(s);
        }
        this.Editor.BlockSelection.clearSelection(e);
    }
    /**
   * All clicks on document
   *
   * @param {MouseEvent} event - Click event
   */ documentClicked(e) {
        var a, l;
        if (!e.isTrusted) return;
        const t1 = e.target;
        this.nodes.holder.contains(t1) || $e2ab202322af4e74$var$b.isAtEditor || (this.Editor.BlockManager.unsetCurrentBlock(), this.Editor.Toolbar.close());
        const i = (a = this.Editor.BlockSettings.nodes.wrapper) == null ? void 0 : a.contains(t1), s = (l = this.Editor.Toolbar.nodes.settingsToggler) == null ? void 0 : l.contains(t1), r = i || s;
        if (this.Editor.BlockSettings.opened && !r) {
            this.Editor.BlockSettings.close();
            const c = this.Editor.BlockManager.getBlockByChildNode(t1);
            this.Editor.Toolbar.moveAndOpen(c);
        }
        this.Editor.BlockSelection.clearSelection(e);
    }
    /**
   * First touch on editor
   * Fired before click
   *
   * Used to change current block — we need to do it before 'selectionChange' event.
   * Also:
   * - Move and show the Toolbar
   * - Set a Caret
   *
   * @param event - touch or mouse event
   */ documentTouched(e) {
        let t1 = e.target;
        if (t1 === this.nodes.redactor) {
            const o = e instanceof MouseEvent ? e.clientX : e.touches[0].clientX, i = e instanceof MouseEvent ? e.clientY : e.touches[0].clientY;
            t1 = document.elementFromPoint(o, i);
        }
        try {
            this.Editor.BlockManager.setCurrentBlockByChildNode(t1);
        } catch  {
            this.Editor.RectangleSelection.isRectActivated() || this.Editor.Caret.setToTheLastBlock();
        }
        this.Editor.ReadOnly.isEnabled || this.Editor.Toolbar.moveAndOpen();
    }
    /**
   * All clicks on the redactor zone
   *
   * @param {MouseEvent} event - click event
   * @description
   * - By clicks on the Editor's bottom zone:
   *      - if last Block is empty, set a Caret to this
   *      - otherwise, add a new empty Block and set a Caret to that
   */ redactorClicked(e) {
        if (!$e2ab202322af4e74$var$b.isCollapsed) return;
        const t1 = e.target, o = e.metaKey || e.ctrlKey, i = $e2ab202322af4e74$var$u.getClosestAnchor(t1);
        if (i && o) {
            e.stopImmediatePropagation(), e.stopPropagation();
            const s = i.getAttribute("href"), r = $e2ab202322af4e74$var$oi(s);
            $e2ab202322af4e74$var$ii(r);
            return;
        }
        this.processBottomZoneClick(e);
    }
    /**
   * Check if user clicks on the Editor's bottom zone:
   *  - set caret to the last block
   *  - or add new empty block
   *
   * @param event - click event
   */ processBottomZoneClick(e) {
        const t1 = this.Editor.BlockManager.getBlockByIndex(-1), o = $e2ab202322af4e74$var$u.offset(t1.holder).bottom, i = e.pageY, { BlockSelection: s } = this.Editor;
        if (e.target instanceof Element && e.target.isEqualNode(this.nodes.redactor) && /**
    * If there is cross block selection started, target will be equal to redactor so we need additional check
    */ !s.anyBlockSelected && /**
    * Prevent caret jumping (to last block) when clicking between blocks
    */ o < i) {
            e.stopImmediatePropagation(), e.stopPropagation();
            const { BlockManager: a, Caret: l, Toolbar: c } = this.Editor;
            (!a.lastBlock.tool.isDefault || !a.lastBlock.isEmpty) && a.insertAtEnd(), l.setToTheLastBlock(), c.moveAndOpen(a.lastBlock);
        }
    }
    /**
   * Handle selection changes on mobile devices
   * Uses for showing the Inline Toolbar
   */ selectionChanged() {
        const { CrossBlockSelection: e, BlockSelection: t1 } = this.Editor, o = $e2ab202322af4e74$var$b.anchorElement;
        if (e.isCrossBlockSelectionStarted && t1.anyBlockSelected && $e2ab202322af4e74$var$b.get().removeAllRanges(), !o) {
            $e2ab202322af4e74$var$b.range || this.Editor.InlineToolbar.close();
            return;
        }
        const i = o.closest(`.${$e2ab202322af4e74$var$R.CSS.content}`);
        (i === null || i.closest(`.${$e2ab202322af4e74$var$b.CSS.editorWrapper}`) !== this.nodes.wrapper) && (this.Editor.InlineToolbar.containsNode(o) || this.Editor.InlineToolbar.close(), !(o.dataset.inlineToolbar === "true")) || (this.Editor.BlockManager.currentBlock || this.Editor.BlockManager.setCurrentBlockByChildNode(o), this.Editor.InlineToolbar.tryToShow(!0));
    }
    /**
   * Editor.js provides and ability to show placeholders for empty contenteditable elements
   *
   * This method watches for input and focus events and toggles 'data-empty' attribute
   * to workaroud the case, when inputs contains only <br>s and has no visible content
   * Then, CSS could rely on this attribute to show placeholders
   */ enableInputsEmptyMark() {
        function e(t1) {
            const o = t1.target;
            $e2ab202322af4e74$var$Do(o);
        }
        this.readOnlyMutableListeners.on(this.nodes.wrapper, "input", e), this.readOnlyMutableListeners.on(this.nodes.wrapper, "focusin", e), this.readOnlyMutableListeners.on(this.nodes.wrapper, "focusout", e);
    }
}
const $e2ab202322af4e74$var$Oa = {
    // API Modules
    BlocksAPI: $e2ab202322af4e74$var$gi,
    CaretAPI: $e2ab202322af4e74$var$bi,
    EventsAPI: $e2ab202322af4e74$var$vi,
    I18nAPI: $e2ab202322af4e74$var$kt,
    API: $e2ab202322af4e74$var$ki,
    InlineToolbarAPI: $e2ab202322af4e74$var$yi,
    ListenersAPI: $e2ab202322af4e74$var$wi,
    NotifierAPI: $e2ab202322af4e74$var$Ci,
    ReadOnlyAPI: $e2ab202322af4e74$var$Ti,
    SanitizerAPI: $e2ab202322af4e74$var$Li,
    SaverAPI: $e2ab202322af4e74$var$Pi,
    SelectionAPI: $e2ab202322af4e74$var$Ni,
    ToolsAPI: $e2ab202322af4e74$var$Ri,
    StylesAPI: $e2ab202322af4e74$var$Di,
    ToolbarAPI: $e2ab202322af4e74$var$Fi,
    TooltipAPI: $e2ab202322af4e74$var$Ui,
    UiAPI: $e2ab202322af4e74$var$Wi,
    // Toolbar Modules
    BlockSettings: $e2ab202322af4e74$var$ms,
    Toolbar: $e2ab202322af4e74$var$Bs,
    InlineToolbar: $e2ab202322af4e74$var$Cs,
    // Modules
    BlockEvents: $e2ab202322af4e74$var$na,
    BlockManager: $e2ab202322af4e74$var$ra,
    BlockSelection: $e2ab202322af4e74$var$aa,
    Caret: $e2ab202322af4e74$var$Ye,
    CrossBlockSelection: $e2ab202322af4e74$var$la,
    DragNDrop: $e2ab202322af4e74$var$ca,
    ModificationsObserver: $e2ab202322af4e74$var$ha,
    Paste: $e2ab202322af4e74$var$pa,
    ReadOnly: $e2ab202322af4e74$var$fa,
    RectangleSelection: $e2ab202322af4e74$var$Be,
    Renderer: $e2ab202322af4e74$var$ga,
    Saver: $e2ab202322af4e74$var$ma,
    Tools: $e2ab202322af4e74$var$Wn,
    UI: $e2ab202322af4e74$var$Ia
};
class $e2ab202322af4e74$var$_a {
    /**
   * @param {EditorConfig} config - user configuration
   */ constructor(e){
        this.moduleInstances = {}, this.eventsDispatcher = new $e2ab202322af4e74$var$Oe();
        let t1, o;
        this.isReady = new Promise((i, s)=>{
            t1 = i, o = s;
        }), Promise.resolve().then(async ()=>{
            this.configuration = e, this.validate(), this.init(), await this.start(), await this.render();
            const { BlockManager: i, Caret: s, UI: r, ModificationsObserver: a } = this.moduleInstances;
            r.checkEmptiness(), a.enable(), this.configuration.autofocus === !0 && this.configuration.readOnly !== !0 && s.setToBlock(i.blocks[0], s.positions.START), t1();
        }).catch((i)=>{
            $e2ab202322af4e74$var$S(`Editor.js is not ready because of ${i}`, "error"), o(i);
        });
    }
    /**
   * Setting for configuration
   *
   * @param {EditorConfig|string} config - Editor's config to set
   */ set configuration(e) {
        var o, i;
        $e2ab202322af4e74$var$D(e) ? this.config = {
            ...e
        } : this.config = {
            holder: e
        }, $e2ab202322af4e74$var$ht(!!this.config.holderId, "config.holderId", "config.holder"), this.config.holderId && !this.config.holder && (this.config.holder = this.config.holderId, this.config.holderId = null), this.config.holder == null && (this.config.holder = "editorjs"), this.config.logLevel || (this.config.logLevel = $e2ab202322af4e74$var$Lo.VERBOSE), $e2ab202322af4e74$var$Zn(this.config.logLevel), $e2ab202322af4e74$var$ht(!!this.config.initialBlock, "config.initialBlock", "config.defaultBlock"), this.config.defaultBlock = this.config.defaultBlock || this.config.initialBlock || "paragraph", this.config.minHeight = this.config.minHeight !== void 0 ? this.config.minHeight : 300;
        const t1 = {
            type: this.config.defaultBlock,
            data: {}
        };
        this.config.placeholder = this.config.placeholder || !1, this.config.sanitizer = this.config.sanitizer || {
            p: !0,
            b: !0,
            a: !0
        }, this.config.hideToolbar = this.config.hideToolbar ? this.config.hideToolbar : !1, this.config.tools = this.config.tools || {}, this.config.i18n = this.config.i18n || {}, this.config.data = this.config.data || {
            blocks: []
        }, this.config.onReady = this.config.onReady || (()=>{}), this.config.onChange = this.config.onChange || (()=>{}), this.config.inlineToolbar = this.config.inlineToolbar !== void 0 ? this.config.inlineToolbar : !0, ($e2ab202322af4e74$var$V(this.config.data) || !this.config.data.blocks || this.config.data.blocks.length === 0) && (this.config.data = {
            blocks: [
                t1
            ]
        }), this.config.readOnly = this.config.readOnly || !1, (o = this.config.i18n) != null && o.messages && $e2ab202322af4e74$var$z.setDictionary(this.config.i18n.messages), this.config.i18n.direction = ((i = this.config.i18n) == null ? void 0 : i.direction) || "ltr";
    }
    /**
   * Returns private property
   *
   * @returns {EditorConfig}
   */ get configuration() {
        return this.config;
    }
    /**
   * Checks for required fields in Editor's config
   */ validate() {
        const { holderId: e, holder: t1 } = this.config;
        if (e && t1) throw Error("\xabholderId\xbb and \xabholder\xbb param can't assign at the same time.");
        if ($e2ab202322af4e74$var$te(t1) && !$e2ab202322af4e74$var$u.get(t1)) throw Error(`element with ID \xab${t1}\xbb is missing. Pass correct holder's ID.`);
        if (t1 && $e2ab202322af4e74$var$D(t1) && !$e2ab202322af4e74$var$u.isElement(t1)) throw Error("\xabholder\xbb value must be an Element node");
    }
    /**
   * Initializes modules:
   *  - make and save instances
   *  - configure
   */ init() {
        this.constructModules(), this.configureModules();
    }
    /**
   * Start Editor!
   *
   * Get list of modules that needs to be prepared and return a sequence (Promise)
   *
   * @returns {Promise<void>}
   */ async start() {
        await [
            "Tools",
            "UI",
            "BlockManager",
            "Paste",
            "BlockSelection",
            "RectangleSelection",
            "CrossBlockSelection",
            "ReadOnly"
        ].reduce((t1, o)=>t1.then(async ()=>{
                try {
                    await this.moduleInstances[o].prepare();
                } catch (i) {
                    if (i instanceof $e2ab202322af4e74$var$Ho) throw new Error(i.message);
                    $e2ab202322af4e74$var$S(`Module ${o} was skipped because of %o`, "warn", i);
                }
            }), Promise.resolve());
    }
    /**
   * Render initial data
   */ render() {
        return this.moduleInstances.Renderer.render(this.config.data.blocks);
    }
    /**
   * Make modules instances and save it to the @property this.moduleInstances
   */ constructModules() {
        Object.entries($e2ab202322af4e74$var$Oa).forEach(([e, t1])=>{
            try {
                this.moduleInstances[e] = new t1({
                    config: this.configuration,
                    eventsDispatcher: this.eventsDispatcher
                });
            } catch (o) {
                $e2ab202322af4e74$var$S("[constructModules]", `Module ${e} skipped because`, "error", o);
            }
        });
    }
    /**
   * Modules instances configuration:
   *  - pass other modules to the 'state' property
   *  - ...
   */ configureModules() {
        for(const e in this.moduleInstances)Object.prototype.hasOwnProperty.call(this.moduleInstances, e) && (this.moduleInstances[e].state = this.getModulesDiff(e));
    }
    /**
   * Return modules without passed name
   *
   * @param {string} name - module for witch modules difference should be calculated
   */ getModulesDiff(e) {
        const t1 = {};
        for(const o in this.moduleInstances)o !== e && (t1[o] = this.moduleInstances[o]);
        return t1;
    }
}
/**
 * Editor.js
 *
 * @license Apache-2.0
 * @see Editor.js <https://editorjs.io>
 * @author CodeX Team <https://codex.so>
 */ class $e2ab202322af4e74$export$2e2bcd8739ae039 {
    /** Editor version */ static get version() {
        return "2.31.6";
    }
    /**
   * @param {EditorConfig|string|undefined} [configuration] - user configuration
   */ constructor(e){
        let t1 = ()=>{};
        $e2ab202322af4e74$var$D(e) && $e2ab202322af4e74$var$A(e.onReady) && (t1 = e.onReady);
        const o = new $e2ab202322af4e74$var$_a(e);
        this.isReady = o.isReady.then(()=>{
            this.exportAPI(o), t1();
        });
    }
    /**
   * Export external API methods
   *
   * @param {Core} editor — Editor's instance
   */ exportAPI(e) {
        const t1 = [
            "configuration"
        ], o = ()=>{
            Object.values(e.moduleInstances).forEach((s)=>{
                $e2ab202322af4e74$var$A(s.destroy) && s.destroy(), s.listeners.removeAll();
            }), $e2ab202322af4e74$var$zi(), e = null;
            for(const s in this)Object.prototype.hasOwnProperty.call(this, s) && delete this[s];
            Object.setPrototypeOf(this, null);
        };
        t1.forEach((s)=>{
            this[s] = e[s];
        }), this.destroy = o, Object.setPrototypeOf(this, e.moduleInstances.API.methods), delete this.exportAPI, Object.entries({
            blocks: {
                clear: "clear",
                render: "render"
            },
            caret: {
                focus: "focus"
            },
            events: {
                on: "on",
                off: "off",
                emit: "emit"
            },
            saver: {
                save: "save"
            }
        }).forEach(([s, r])=>{
            Object.entries(r).forEach(([a, l])=>{
                this[l] = e.moduleInstances.API.methods[s][a];
            });
        });
    }
}

});

parcelRegister("a2piW", function(module, exports) {

$parcel$export(module.exports, "default", () => $00742e7335549138$export$2e2bcd8739ae039);
(function() {
    "use strict";
    try {
        if (typeof document < "u") {
            var e = document.createElement("style");
            e.appendChild(document.createTextNode(".ce-header{padding:.6em 0 3px;margin:0;line-height:1.25em;outline:none}.ce-header p,.ce-header div{padding:0!important;margin:0!important}")), document.head.appendChild(e);
        }
    } catch (n) {
        console.error("vite-plugin-css-injected-by-js", n);
    }
})();
const $00742e7335549138$var$a = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M6 7L6 12M6 17L6 12M6 12L12 12M12 7V12M12 17L12 12"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M19 17V10.2135C19 10.1287 18.9011 10.0824 18.836 10.1367L16 12.5"/></svg>', $00742e7335549138$var$l = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M6 7L6 12M6 17L6 12M6 12L12 12M12 7V12M12 17L12 12"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M16 11C16 10 19 9.5 19 12C19 13.9771 16.0684 13.9997 16.0012 16.8981C15.9999 16.9533 16.0448 17 16.1 17L19.3 17"/></svg>', $00742e7335549138$var$o = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M6 7L6 12M6 17L6 12M6 12L12 12M12 7V12M12 17L12 12"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M16 11C16 10.5 16.8323 10 17.6 10C18.3677 10 19.5 10.311 19.5 11.5C19.5 12.5315 18.7474 12.9022 18.548 12.9823C18.5378 12.9864 18.5395 13.0047 18.5503 13.0063C18.8115 13.0456 20 13.3065 20 14.8C20 16 19.5 17 17.8 17C17.8 17 16 17 16 16.3"/></svg>', $00742e7335549138$var$h = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M6 7L6 12M6 17L6 12M6 12L12 12M12 7V12M12 17L12 12"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M18 10L15.2834 14.8511C15.246 14.9178 15.294 15 15.3704 15C16.8489 15 18.7561 15 20.2 15M19 17C19 15.7187 19 14.8813 19 13.6"/></svg>', $00742e7335549138$var$d = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M6 7L6 12M6 17L6 12M6 12L12 12M12 7V12M12 17L12 12"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M16 15.9C16 15.9 16.3768 17 17.8 17C19.5 17 20 15.6199 20 14.7C20 12.7323 17.6745 12.0486 16.1635 12.9894C16.094 13.0327 16 12.9846 16 12.9027V10.1C16 10.0448 16.0448 10 16.1 10H19.8"/></svg>', $00742e7335549138$var$u = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M6 7L6 12M6 17L6 12M6 12L12 12M12 7V12M12 17L12 12"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M19.5 10C16.5 10.5 16 13.3285 16 15M16 15V15C16 16.1046 16.8954 17 18 17H18.3246C19.3251 17 20.3191 16.3492 20.2522 15.3509C20.0612 12.4958 16 12.6611 16 15Z"/></svg>', $00742e7335549138$var$g = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M9 7L9 12M9 17V12M9 12L15 12M15 7V12M15 17L15 12"/></svg>';
/**
 * Header block for the Editor.js.
 *
 * @author CodeX (team@ifmo.su)
 * @copyright CodeX 2018
 * @license MIT
 * @version 2.0.0
 */ class $00742e7335549138$export$2e2bcd8739ae039 {
    constructor({ data: e, config: t, api: s, readOnly: r }){
        this.api = s, this.readOnly = r, this._settings = t, this._data = this.normalizeData(e), this._element = this.getTag();
    }
    /**
   * Styles
   */ get _CSS() {
        return {
            block: this.api.styles.block,
            wrapper: "ce-header"
        };
    }
    /**
   * Check if data is valid
   * 
   * @param {any} data - data to check
   * @returns {data is HeaderData}
   * @private
   */ isHeaderData(e) {
        return e.text !== void 0;
    }
    /**
   * Normalize input data
   *
   * @param {HeaderData} data - saved data to process
   *
   * @returns {HeaderData}
   * @private
   */ normalizeData(e) {
        const t = {
            text: "",
            level: this.defaultLevel.number
        };
        return this.isHeaderData(e) && (t.text = e.text || "", e.level !== void 0 && !isNaN(parseInt(e.level.toString())) && (t.level = parseInt(e.level.toString()))), t;
    }
    /**
   * Return Tool's view
   *
   * @returns {HTMLHeadingElement}
   * @public
   */ render() {
        return this._element;
    }
    /**
   * Returns header block tunes config
   *
   * @returns {Array}
   */ renderSettings() {
        return this.levels.map((e)=>({
                icon: e.svg,
                label: this.api.i18n.t(`Heading ${e.number}`),
                onActivate: ()=>this.setLevel(e.number),
                closeOnActivate: !0,
                isActive: this.currentLevel.number === e.number,
                render: ()=>document.createElement("div")
            }));
    }
    /**
   * Callback for Block's settings buttons
   *
   * @param {number} level - level to set
   */ setLevel(e) {
        this.data = {
            level: e,
            text: this.data.text
        };
    }
    /**
   * Method that specified how to merge two Text blocks.
   * Called by Editor.js by backspace at the beginning of the Block
   *
   * @param {HeaderData} data - saved data to merger with current block
   * @public
   */ merge(e) {
        this._element.insertAdjacentHTML("beforeend", e.text);
    }
    /**
   * Validate Text block data:
   * - check for emptiness
   *
   * @param {HeaderData} blockData — data received after saving
   * @returns {boolean} false if saved data is not correct, otherwise true
   * @public
   */ validate(e) {
        return e.text.trim() !== "";
    }
    /**
   * Extract Tool's data from the view
   *
   * @param {HTMLHeadingElement} toolsContent - Text tools rendered view
   * @returns {HeaderData} - saved data
   * @public
   */ save(e) {
        return {
            text: e.innerHTML,
            level: this.currentLevel.number
        };
    }
    /**
   * Allow Header to be converted to/from other blocks
   */ static get conversionConfig() {
        return {
            export: "text",
            // use 'text' property for other blocks
            import: "text"
        };
    }
    /**
   * Sanitizer Rules
   */ static get sanitize() {
        return {
            level: !1,
            text: {}
        };
    }
    /**
   * Returns true to notify core that read-only is supported
   *
   * @returns {boolean}
   */ static get isReadOnlySupported() {
        return !0;
    }
    /**
   * Get current Tools`s data
   *
   * @returns {HeaderData} Current data
   * @private
   */ get data() {
        return this._data.text = this._element.innerHTML, this._data.level = this.currentLevel.number, this._data;
    }
    /**
   * Store data in plugin:
   * - at the this._data property
   * - at the HTML
   *
   * @param {HeaderData} data — data to set
   * @private
   */ set data(e) {
        if (this._data = this.normalizeData(e), e.level !== void 0 && this._element.parentNode) {
            const t = this.getTag();
            t.innerHTML = this._element.innerHTML, this._element.parentNode.replaceChild(t, this._element), this._element = t;
        }
        e.text !== void 0 && (this._element.innerHTML = this._data.text || "");
    }
    /**
   * Get tag for target level
   * By default returns second-leveled header
   *
   * @returns {HTMLElement}
   */ getTag() {
        const e = document.createElement(this.currentLevel.tag);
        return e.innerHTML = this._data.text || "", e.classList.add(this._CSS.wrapper), e.contentEditable = this.readOnly ? "false" : "true", e.dataset.placeholder = this.api.i18n.t(this._settings.placeholder || ""), e;
    }
    /**
   * Get current level
   *
   * @returns {level}
   */ get currentLevel() {
        let e = this.levels.find((t)=>t.number === this._data.level);
        return e || (e = this.defaultLevel), e;
    }
    /**
   * Return default level
   *
   * @returns {level}
   */ get defaultLevel() {
        if (this._settings.defaultLevel) {
            const e = this.levels.find((t)=>t.number === this._settings.defaultLevel);
            if (e) return e;
            console.warn("(\u0E07'\u0300-'\u0301)\u0E07 Heading Tool: the default level specified was not found in available levels");
        }
        return this.levels[1];
    }
    /**
   * @typedef {object} level
   * @property {number} number - level number
   * @property {string} tag - tag corresponds with level number
   * @property {string} svg - icon
   */ /**
   * Available header levels
   *
   * @returns {level[]}
   */ get levels() {
        const e = [
            {
                number: 1,
                tag: "H1",
                svg: $00742e7335549138$var$a
            },
            {
                number: 2,
                tag: "H2",
                svg: $00742e7335549138$var$l
            },
            {
                number: 3,
                tag: "H3",
                svg: $00742e7335549138$var$o
            },
            {
                number: 4,
                tag: "H4",
                svg: $00742e7335549138$var$h
            },
            {
                number: 5,
                tag: "H5",
                svg: $00742e7335549138$var$d
            },
            {
                number: 6,
                tag: "H6",
                svg: $00742e7335549138$var$u
            }
        ];
        return this._settings.levels ? e.filter((t)=>this._settings.levels.includes(t.number)) : e;
    }
    /**
   * Handle H1-H6 tags on paste to substitute it with header Tool
   *
   * @param {PasteEvent} event - event with pasted content
   */ onPaste(e) {
        const t = e.detail;
        if ("data" in t) {
            const s = t.data;
            let r = this.defaultLevel.number;
            switch(s.tagName){
                case "H1":
                    r = 1;
                    break;
                case "H2":
                    r = 2;
                    break;
                case "H3":
                    r = 3;
                    break;
                case "H4":
                    r = 4;
                    break;
                case "H5":
                    r = 5;
                    break;
                case "H6":
                    r = 6;
                    break;
            }
            this._settings.levels && (r = this._settings.levels.reduce((n, i)=>Math.abs(i - r) < Math.abs(n - r) ? i : n)), this.data = {
                level: r,
                text: s.innerHTML
            };
        }
    }
    /**
   * Used by Editor.js paste handling API.
   * Provides configuration to handle H1-H6 tags.
   *
   * @returns {{handler: (function(HTMLElement): {text: string}), tags: string[]}}
   */ static get pasteConfig() {
        return {
            tags: [
                "H1",
                "H2",
                "H3",
                "H4",
                "H5",
                "H6"
            ]
        };
    }
    /**
   * Get Tool toolbox settings
   * icon - Tool icon's SVG
   * title - title to show in toolbox
   *
   * @returns {{icon: string, title: string}}
   */ static get toolbox() {
        return {
            icon: $00742e7335549138$var$g,
            title: "Heading"
        };
    }
}

});

parcelRegister("63Cxr", function(module, exports) {

$parcel$export(module.exports, "default", () => $1187c7534b2d5d03$export$2e2bcd8739ae039);
(function() {
    "use strict";
    try {
        if (typeof document < "u") {
            var e = document.createElement("style");
            e.appendChild(document.createTextNode(".cdx-list{margin:0;padding-left:40px;outline:none}.cdx-list__item{padding:5.5px 0 5.5px 3px;line-height:1.6em}.cdx-list--unordered{list-style:disc}.cdx-list--ordered{list-style:decimal}.cdx-list-settings{display:flex}.cdx-list-settings .cdx-settings-button{width:50%}")), document.head.appendChild(e);
        }
    } catch (t) {
        console.error("vite-plugin-css-injected-by-js", t);
    }
})();
const $1187c7534b2d5d03$var$a = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><line x1="9" x2="19" y1="7" y2="7" stroke="currentColor" stroke-linecap="round" stroke-width="2"/><line x1="9" x2="19" y1="12" y2="12" stroke="currentColor" stroke-linecap="round" stroke-width="2"/><line x1="9" x2="19" y1="17" y2="17" stroke="currentColor" stroke-linecap="round" stroke-width="2"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M5.00001 17H4.99002"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M5.00001 12H4.99002"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M5.00001 7H4.99002"/></svg>', $1187c7534b2d5d03$var$o = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><line x1="12" x2="19" y1="7" y2="7" stroke="currentColor" stroke-linecap="round" stroke-width="2"/><line x1="12" x2="19" y1="12" y2="12" stroke="currentColor" stroke-linecap="round" stroke-width="2"/><line x1="12" x2="19" y1="17" y2="17" stroke="currentColor" stroke-linecap="round" stroke-width="2"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M7.79999 14L7.79999 7.2135C7.79999 7.12872 7.7011 7.0824 7.63597 7.13668L4.79999 9.5"/></svg>';
class $1187c7534b2d5d03$export$2e2bcd8739ae039 {
    /**
   * Notify core that read-only mode is supported
   *
   * @returns {boolean}
   */ static get isReadOnlySupported() {
        return !0;
    }
    /**
   * Allow to use native Enter behaviour
   *
   * @returns {boolean}
   * @public
   */ static get enableLineBreaks() {
        return !0;
    }
    /**
   * Get Tool toolbox settings
   * icon - Tool icon's SVG
   * title - title to show in toolbox
   *
   * @returns {{icon: string, title: string}}
   */ static get toolbox() {
        return {
            icon: $1187c7534b2d5d03$var$a,
            title: "List"
        };
    }
    /**
   * Render plugin`s main Element and fill it with saved data
   *
   * @param {object} params - tool constructor options
   * @param {ListData} params.data - previously saved data
   * @param {object} params.config - user config for Tool
   * @param {object} params.api - Editor.js API
   * @param {boolean} params.readOnly - read-only mode flag
   */ constructor({ data: e, config: t, api: r, readOnly: s }){
        this._elements = {
            wrapper: null
        }, this.api = r, this.readOnly = s, this.settings = [
            {
                name: "unordered",
                label: this.api.i18n.t("Unordered"),
                icon: $1187c7534b2d5d03$var$a,
                default: t.defaultStyle === "unordered" || !1
            },
            {
                name: "ordered",
                label: this.api.i18n.t("Ordered"),
                icon: $1187c7534b2d5d03$var$o,
                default: t.defaultStyle === "ordered" || !0
            }
        ], this._data = {
            style: this.settings.find((i)=>i.default === !0).name,
            items: []
        }, this.data = e;
    }
    /**
   * Returns list tag with items
   *
   * @returns {Element}
   * @public
   */ render() {
        return this._elements.wrapper = this.makeMainTag(this._data.style), this._data.items.length ? this._data.items.forEach((e)=>{
            this._elements.wrapper.appendChild(this._make("li", this.CSS.item, {
                innerHTML: e
            }));
        }) : this._elements.wrapper.appendChild(this._make("li", this.CSS.item)), this.readOnly || this._elements.wrapper.addEventListener("keydown", (e)=>{
            const [t, r] = [
                13,
                8
            ];
            switch(e.keyCode){
                case t:
                    this.getOutofList(e);
                    break;
                case r:
                    this.backspace(e);
                    break;
            }
        }, !1), this._elements.wrapper;
    }
    /**
   * @returns {ListData}
   * @public
   */ save() {
        return this.data;
    }
    /**
   * Allow List Tool to be converted to/from other block
   *
   * @returns {{export: Function, import: Function}}
   */ static get conversionConfig() {
        return {
            /**
       * To create exported string from list, concatenate items by dot-symbol.
       *
       * @param {ListData} data - list data to create a string from thats
       * @returns {string}
       */ export: (e)=>e.items.join(". "),
            /**
       * To create a list from other block's string, just put it at the first item
       *
       * @param {string} string - string to create list tool data from that
       * @returns {ListData}
       */ import: (e)=>({
                    items: [
                        e
                    ],
                    style: "unordered"
                })
        };
    }
    /**
   * Sanitizer rules
   *
   * @returns {object}
   */ static get sanitize() {
        return {
            style: {},
            items: {
                br: !0
            }
        };
    }
    /**
   * Settings
   *
   * @public
   * @returns {Array}
   */ renderSettings() {
        return this.settings.map((e)=>({
                ...e,
                isActive: this._data.style === e.name,
                closeOnActivate: !0,
                onActivate: ()=>this.toggleTune(e.name)
            }));
    }
    /**
   * On paste callback that is fired from Editor
   *
   * @param {PasteEvent} event - event with pasted data
   */ onPaste(e) {
        const t = e.detail.data;
        this.data = this.pasteHandler(t);
    }
    /**
   * List Tool on paste configuration
   *
   * @public
   */ static get pasteConfig() {
        return {
            tags: [
                "OL",
                "UL",
                "LI"
            ]
        };
    }
    /**
   * Creates main <ul> or <ol> tag depended on style
   *
   * @param {string} style - 'ordered' or 'unordered'
   * @returns {HTMLOListElement|HTMLUListElement}
   */ makeMainTag(e) {
        const t = e === "ordered" ? this.CSS.wrapperOrdered : this.CSS.wrapperUnordered, r = e === "ordered" ? "ol" : "ul";
        return this._make(r, [
            this.CSS.baseBlock,
            this.CSS.wrapper,
            t
        ], {
            contentEditable: !this.readOnly
        });
    }
    /**
   * Toggles List style
   *
   * @param {string} style - 'ordered'|'unordered'
   */ toggleTune(e) {
        const t = this.makeMainTag(e);
        for(; this._elements.wrapper.hasChildNodes();)t.appendChild(this._elements.wrapper.firstChild);
        this._elements.wrapper.replaceWith(t), this._elements.wrapper = t, this._data.style = e;
    }
    /**
   * Styles
   *
   * @private
   */ get CSS() {
        return {
            baseBlock: this.api.styles.block,
            wrapper: "cdx-list",
            wrapperOrdered: "cdx-list--ordered",
            wrapperUnordered: "cdx-list--unordered",
            item: "cdx-list__item"
        };
    }
    /**
   * List data setter
   *
   * @param {ListData} listData
   */ set data(e) {
        e || (e = {}), this._data.style = e.style || this.settings.find((r)=>r.default === !0).name, this._data.items = e.items || [];
        const t = this._elements.wrapper;
        t && t.parentNode.replaceChild(this.render(), t);
    }
    /**
   * Return List data
   *
   * @returns {ListData}
   */ get data() {
        this._data.items = [];
        const e = this._elements.wrapper.querySelectorAll(`.${this.CSS.item}`);
        for(let t = 0; t < e.length; t++)e[t].innerHTML.replace("<br>", " ").trim() && this._data.items.push(e[t].innerHTML);
        return this._data;
    }
    /**
   * Helper for making Elements with attributes
   *
   * @param  {string} tagName           - new Element tag name
   * @param  {Array|string} classNames  - list or name of CSS classname(s)
   * @param  {object} attributes        - any attributes
   * @returns {Element}
   */ _make(e, t = null, r = {}) {
        const s = document.createElement(e);
        Array.isArray(t) ? s.classList.add(...t) : t && s.classList.add(t);
        for(const i in r)s[i] = r[i];
        return s;
    }
    /**
   * Returns current List item by the caret position
   *
   * @returns {Element}
   */ get currentItem() {
        let e = window.getSelection().anchorNode;
        return e.nodeType !== Node.ELEMENT_NODE && (e = e.parentNode), e.closest(`.${this.CSS.item}`);
    }
    /**
   * Get out from List Tool
   * by Enter on the empty last item
   *
   * @param {KeyboardEvent} event
   */ getOutofList(e) {
        const t = this._elements.wrapper.querySelectorAll("." + this.CSS.item);
        if (t.length < 2) return;
        const r = t[t.length - 1], s = this.currentItem;
        s === r && !r.textContent.trim().length && (s.parentElement.removeChild(s), this.api.blocks.insert(), this.api.caret.setToBlock(this.api.blocks.getCurrentBlockIndex()), e.preventDefault(), e.stopPropagation());
    }
    /**
   * Handle backspace
   *
   * @param {KeyboardEvent} event
   */ backspace(e) {
        const t = this._elements.wrapper.querySelectorAll("." + this.CSS.item), r = t[0];
        r && t.length < 2 && !r.innerHTML.replace("<br>", " ").trim() && e.preventDefault();
    }
    /**
   * Select LI content by CMD+A
   *
   * @param {KeyboardEvent} event
   */ selectItem(e) {
        e.preventDefault();
        const t = window.getSelection(), r = t.anchorNode.parentNode, s = r.closest("." + this.CSS.item), i = new Range();
        i.selectNodeContents(s), t.removeAllRanges(), t.addRange(i);
    }
    /**
   * Handle UL, OL and LI tags paste and returns List data
   *
   * @param {HTMLUListElement|HTMLOListElement|HTMLLIElement} element
   * @returns {ListData}
   */ pasteHandler(e) {
        const { tagName: t } = e;
        let r;
        switch(t){
            case "OL":
                r = "ordered";
                break;
            case "UL":
            case "LI":
                r = "unordered";
        }
        const s = {
            style: r,
            items: []
        };
        if (t === "LI") s.items = [
            e.innerHTML
        ];
        else {
            const i = Array.from(e.querySelectorAll("LI"));
            s.items = i.map((n)=>n.innerHTML).filter((n)=>!!n.trim());
        }
        return s;
    }
}

});

parcelRegister("eNX2h", function(module, exports) {

$parcel$export(module.exports, "default", () => $50b3a6088573c50b$export$2e2bcd8739ae039);
(function() {
    "use strict";
    try {
        if (typeof document < "u") {
            var t = document.createElement("style");
            t.appendChild(document.createTextNode(".cdx-quote-icon svg{transform:rotate(180deg)}.cdx-quote{margin:0}.cdx-quote__text{min-height:158px;margin-bottom:10px}.cdx-quote [contentEditable=true][data-placeholder]:before{position:absolute;content:attr(data-placeholder);color:#707684;font-weight:400;opacity:0}.cdx-quote [contentEditable=true][data-placeholder]:empty:before{opacity:1}.cdx-quote [contentEditable=true][data-placeholder]:empty:focus:before{opacity:0}.cdx-quote-settings{display:flex}.cdx-quote-settings .cdx-settings-button{width:50%}")), document.head.appendChild(t);
        }
    } catch (e) {
        console.error("vite-plugin-css-injected-by-js", e);
    }
})();
const $50b3a6088573c50b$var$De = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M18 7L6 7"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M18 17H6"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M16 12L8 12"/></svg>', $50b3a6088573c50b$var$He = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M17 7L5 7"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M17 17H5"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M13 12L5 12"/></svg>', $50b3a6088573c50b$var$Re = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 10.8182L9 10.8182C8.80222 10.8182 8.60888 10.7649 8.44443 10.665C8.27998 10.5651 8.15181 10.4231 8.07612 10.257C8.00043 10.0909 7.98063 9.90808 8.01922 9.73174C8.0578 9.55539 8.15304 9.39341 8.29289 9.26627C8.43275 9.13913 8.61093 9.05255 8.80491 9.01747C8.99889 8.98239 9.19996 9.00039 9.38268 9.0692C9.56541 9.13801 9.72159 9.25453 9.83147 9.40403C9.94135 9.55353 10 9.72929 10 9.90909L10 12.1818C10 12.664 9.78929 13.1265 9.41421 13.4675C9.03914 13.8084 8.53043 14 8 14"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 10.8182L15 10.8182C14.8022 10.8182 14.6089 10.7649 14.4444 10.665C14.28 10.5651 14.1518 10.4231 14.0761 10.257C14.0004 10.0909 13.9806 9.90808 14.0192 9.73174C14.0578 9.55539 14.153 9.39341 14.2929 9.26627C14.4327 9.13913 14.6109 9.05255 14.8049 9.01747C14.9989 8.98239 15.2 9.00039 15.3827 9.0692C15.5654 9.13801 15.7216 9.25453 15.8315 9.40403C15.9414 9.55353 16 9.72929 16 9.90909L16 12.1818C16 12.664 15.7893 13.1265 15.4142 13.4675C15.0391 13.8084 14.5304 14 14 14"/></svg>';
var $50b3a6088573c50b$var$b = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof $parcel$global < "u" ? $parcel$global : typeof self < "u" ? self : {};
function $50b3a6088573c50b$var$Fe(e) {
    if (e.__esModule) return e;
    var t = e.default;
    if (typeof t == "function") {
        var n = function r() {
            return this instanceof r ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
        };
        n.prototype = t.prototype;
    } else n = {};
    return Object.defineProperty(n, "__esModule", {
        value: !0
    }), Object.keys(e).forEach(function(r) {
        var i = Object.getOwnPropertyDescriptor(e, r);
        Object.defineProperty(n, r, i.get ? i : {
            enumerable: !0,
            get: function() {
                return e[r];
            }
        });
    }), n;
}
var $50b3a6088573c50b$var$v = {}, $50b3a6088573c50b$var$P = {}, $50b3a6088573c50b$var$j = {};
Object.defineProperty($50b3a6088573c50b$var$j, "__esModule", {
    value: !0
});
$50b3a6088573c50b$var$j.allInputsSelector = $50b3a6088573c50b$var$We;
function $50b3a6088573c50b$var$We() {
    var e = [
        "text",
        "password",
        "email",
        "number",
        "search",
        "tel",
        "url"
    ];
    return "[contenteditable=true], textarea, input:not([type]), " + e.map(function(t) {
        return 'input[type="'.concat(t, '"]');
    }).join(", ");
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.allInputsSelector = void 0;
    var t = $50b3a6088573c50b$var$j;
    Object.defineProperty(e, "allInputsSelector", {
        enumerable: !0,
        get: function() {
            return t.allInputsSelector;
        }
    });
})($50b3a6088573c50b$var$P);
var $50b3a6088573c50b$var$c = {}, $50b3a6088573c50b$var$T = {};
Object.defineProperty($50b3a6088573c50b$var$T, "__esModule", {
    value: !0
});
$50b3a6088573c50b$var$T.isNativeInput = $50b3a6088573c50b$var$Ue;
function $50b3a6088573c50b$var$Ue(e) {
    var t = [
        "INPUT",
        "TEXTAREA"
    ];
    return e && e.tagName ? t.includes(e.tagName) : !1;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isNativeInput = void 0;
    var t = $50b3a6088573c50b$var$T;
    Object.defineProperty(e, "isNativeInput", {
        enumerable: !0,
        get: function() {
            return t.isNativeInput;
        }
    });
})($50b3a6088573c50b$var$c);
var $50b3a6088573c50b$var$ie = {}, $50b3a6088573c50b$var$C = {};
Object.defineProperty($50b3a6088573c50b$var$C, "__esModule", {
    value: !0
});
$50b3a6088573c50b$var$C.append = $50b3a6088573c50b$var$qe;
function $50b3a6088573c50b$var$qe(e, t) {
    Array.isArray(t) ? t.forEach(function(n) {
        e.appendChild(n);
    }) : e.appendChild(t);
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.append = void 0;
    var t = $50b3a6088573c50b$var$C;
    Object.defineProperty(e, "append", {
        enumerable: !0,
        get: function() {
            return t.append;
        }
    });
})($50b3a6088573c50b$var$ie);
var $50b3a6088573c50b$var$L = {}, $50b3a6088573c50b$var$S = {};
Object.defineProperty($50b3a6088573c50b$var$S, "__esModule", {
    value: !0
});
$50b3a6088573c50b$var$S.blockElements = $50b3a6088573c50b$var$ze;
function $50b3a6088573c50b$var$ze() {
    return [
        "address",
        "article",
        "aside",
        "blockquote",
        "canvas",
        "div",
        "dl",
        "dt",
        "fieldset",
        "figcaption",
        "figure",
        "footer",
        "form",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "header",
        "hgroup",
        "hr",
        "li",
        "main",
        "nav",
        "noscript",
        "ol",
        "output",
        "p",
        "pre",
        "ruby",
        "section",
        "table",
        "tbody",
        "thead",
        "tr",
        "tfoot",
        "ul",
        "video"
    ];
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.blockElements = void 0;
    var t = $50b3a6088573c50b$var$S;
    Object.defineProperty(e, "blockElements", {
        enumerable: !0,
        get: function() {
            return t.blockElements;
        }
    });
})($50b3a6088573c50b$var$L);
var $50b3a6088573c50b$var$ae = {}, $50b3a6088573c50b$var$M = {};
Object.defineProperty($50b3a6088573c50b$var$M, "__esModule", {
    value: !0
});
$50b3a6088573c50b$var$M.calculateBaseline = $50b3a6088573c50b$var$Ge;
function $50b3a6088573c50b$var$Ge(e) {
    var t = window.getComputedStyle(e), n = parseFloat(t.fontSize), r = parseFloat(t.lineHeight) || n * 1.2, i = parseFloat(t.paddingTop), a = parseFloat(t.borderTopWidth), l = parseFloat(t.marginTop), u = n * 0.8, d = (r - n) / 2, s = l + a + i + d + u;
    return s;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.calculateBaseline = void 0;
    var t = $50b3a6088573c50b$var$M;
    Object.defineProperty(e, "calculateBaseline", {
        enumerable: !0,
        get: function() {
            return t.calculateBaseline;
        }
    });
})($50b3a6088573c50b$var$ae);
var $50b3a6088573c50b$var$le = {}, $50b3a6088573c50b$var$k = {}, $50b3a6088573c50b$var$w = {}, $50b3a6088573c50b$var$N = {};
Object.defineProperty($50b3a6088573c50b$var$N, "__esModule", {
    value: !0
});
$50b3a6088573c50b$var$N.isContentEditable = $50b3a6088573c50b$var$Ke;
function $50b3a6088573c50b$var$Ke(e) {
    return e.contentEditable === "true";
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isContentEditable = void 0;
    var t = $50b3a6088573c50b$var$N;
    Object.defineProperty(e, "isContentEditable", {
        enumerable: !0,
        get: function() {
            return t.isContentEditable;
        }
    });
})($50b3a6088573c50b$var$w);
Object.defineProperty($50b3a6088573c50b$var$k, "__esModule", {
    value: !0
});
$50b3a6088573c50b$var$k.canSetCaret = $50b3a6088573c50b$var$Qe;
var $50b3a6088573c50b$var$Xe = $50b3a6088573c50b$var$c, $50b3a6088573c50b$var$Ye = $50b3a6088573c50b$var$w;
function $50b3a6088573c50b$var$Qe(e) {
    var t = !0;
    if ((0, $50b3a6088573c50b$var$Xe.isNativeInput)(e)) switch(e.type){
        case "file":
        case "checkbox":
        case "radio":
        case "hidden":
        case "submit":
        case "button":
        case "image":
        case "reset":
            t = !1;
            break;
    }
    else t = (0, $50b3a6088573c50b$var$Ye.isContentEditable)(e);
    return t;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.canSetCaret = void 0;
    var t = $50b3a6088573c50b$var$k;
    Object.defineProperty(e, "canSetCaret", {
        enumerable: !0,
        get: function() {
            return t.canSetCaret;
        }
    });
})($50b3a6088573c50b$var$le);
var $50b3a6088573c50b$var$y = {}, $50b3a6088573c50b$var$I = {};
function $50b3a6088573c50b$var$Ve(e, t, n) {
    const r = n.value !== void 0 ? "value" : "get", i = n[r], a = `#${t}Cache`;
    if (n[r] = function(...l) {
        return this[a] === void 0 && (this[a] = i.apply(this, l)), this[a];
    }, r === "get" && n.set) {
        const l = n.set;
        n.set = function(u) {
            delete e[a], l.apply(this, u);
        };
    }
    return n;
}
function $50b3a6088573c50b$var$ue() {
    const e = {
        win: !1,
        mac: !1,
        x11: !1,
        linux: !1
    }, t = Object.keys(e).find((n)=>window.navigator.appVersion.toLowerCase().indexOf(n) !== -1);
    return t !== void 0 && (e[t] = !0), e;
}
function $50b3a6088573c50b$var$A(e) {
    return e != null && e !== "" && (typeof e != "object" || Object.keys(e).length > 0);
}
function $50b3a6088573c50b$var$Ze(e) {
    return !$50b3a6088573c50b$var$A(e);
}
const $50b3a6088573c50b$var$Je = ()=>typeof window < "u" && window.navigator !== null && $50b3a6088573c50b$var$A(window.navigator.platform) && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);
function $50b3a6088573c50b$var$xe(e) {
    const t = $50b3a6088573c50b$var$ue();
    return e = e.replace(/shift/gi, "\u21E7").replace(/backspace/gi, "\u232B").replace(/enter/gi, "\u23CE").replace(/up/gi, "\u2191").replace(/left/gi, "\u2192").replace(/down/gi, "\u2193").replace(/right/gi, "\u2190").replace(/escape/gi, "\u238B").replace(/insert/gi, "Ins").replace(/delete/gi, "\u2421").replace(/\+/gi, "+"), t.mac ? e = e.replace(/ctrl|cmd/gi, "\u2318").replace(/alt/gi, "\u2325") : e = e.replace(/cmd/gi, "Ctrl").replace(/windows/gi, "WIN"), e;
}
function $50b3a6088573c50b$var$et(e) {
    return e[0].toUpperCase() + e.slice(1);
}
function $50b3a6088573c50b$var$tt(e) {
    const t = document.createElement("div");
    t.style.position = "absolute", t.style.left = "-999px", t.style.bottom = "-999px", t.innerHTML = e, document.body.appendChild(t);
    const n = window.getSelection(), r = document.createRange();
    if (r.selectNode(t), n === null) throw new Error("Cannot copy text to clipboard");
    n.removeAllRanges(), n.addRange(r), document.execCommand("copy"), document.body.removeChild(t);
}
function $50b3a6088573c50b$var$nt(e, t, n) {
    let r;
    return (...i)=>{
        const a = this, l = ()=>{
            r = void 0, n !== !0 && e.apply(a, i);
        }, u = n === !0 && r !== void 0;
        window.clearTimeout(r), r = window.setTimeout(l, t), u && e.apply(a, i);
    };
}
function $50b3a6088573c50b$var$o(e) {
    return Object.prototype.toString.call(e).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
}
function $50b3a6088573c50b$var$rt(e) {
    return $50b3a6088573c50b$var$o(e) === "boolean";
}
function $50b3a6088573c50b$var$oe(e) {
    return $50b3a6088573c50b$var$o(e) === "function" || $50b3a6088573c50b$var$o(e) === "asyncfunction";
}
function $50b3a6088573c50b$var$it(e) {
    return $50b3a6088573c50b$var$oe(e) && /^\s*class\s+/.test(e.toString());
}
function $50b3a6088573c50b$var$at(e) {
    return $50b3a6088573c50b$var$o(e) === "number";
}
function $50b3a6088573c50b$var$g(e) {
    return $50b3a6088573c50b$var$o(e) === "object";
}
function $50b3a6088573c50b$var$lt(e) {
    return Promise.resolve(e) === e;
}
function $50b3a6088573c50b$var$ut(e) {
    return $50b3a6088573c50b$var$o(e) === "string";
}
function $50b3a6088573c50b$var$ot(e) {
    return $50b3a6088573c50b$var$o(e) === "undefined";
}
function $50b3a6088573c50b$var$O(e, ...t) {
    if (!t.length) return e;
    const n = t.shift();
    if ($50b3a6088573c50b$var$g(e) && $50b3a6088573c50b$var$g(n)) for(const r in n)$50b3a6088573c50b$var$g(n[r]) ? (e[r] === void 0 && Object.assign(e, {
        [r]: {}
    }), $50b3a6088573c50b$var$O(e[r], n[r])) : Object.assign(e, {
        [r]: n[r]
    });
    return $50b3a6088573c50b$var$O(e, ...t);
}
function $50b3a6088573c50b$var$st(e, t, n) {
    const r = `\xab${t}\xbb is deprecated and will be removed in the next major release. Please use the \xab${n}\xbb instead.`;
    e && console.warn(r);
}
function $50b3a6088573c50b$var$ct(e) {
    try {
        return new URL(e).href;
    } catch  {}
    return e.substring(0, 2) === "//" ? window.location.protocol + e : window.location.origin + e;
}
function $50b3a6088573c50b$var$dt(e) {
    return e > 47 && e < 58 || e === 32 || e === 13 || e === 229 || e > 64 && e < 91 || e > 95 && e < 112 || e > 185 && e < 193 || e > 218 && e < 223;
}
const $50b3a6088573c50b$var$ft = {
    BACKSPACE: 8,
    TAB: 9,
    ENTER: 13,
    SHIFT: 16,
    CTRL: 17,
    ALT: 18,
    ESC: 27,
    SPACE: 32,
    LEFT: 37,
    UP: 38,
    DOWN: 40,
    RIGHT: 39,
    DELETE: 46,
    META: 91,
    SLASH: 191
}, $50b3a6088573c50b$var$pt = {
    LEFT: 0,
    WHEEL: 1,
    RIGHT: 2,
    BACKWARD: 3,
    FORWARD: 4
};
class $50b3a6088573c50b$var$vt {
    constructor(){
        this.completed = Promise.resolve();
    }
    /**
   * Add new promise to queue
   * @param operation - promise should be added to queue
   */ add(t) {
        return new Promise((n, r)=>{
            this.completed = this.completed.then(t).then(n).catch(r);
        });
    }
}
function $50b3a6088573c50b$var$gt(e, t, n) {
    let r, i, a, l = null, u = 0;
    n || (n = {});
    const d = function() {
        u = n.leading === !1 ? 0 : Date.now(), l = null, a = e.apply(r, i), l === null && (r = i = null);
    };
    return function() {
        const s = Date.now();
        !u && n.leading === !1 && (u = s);
        const f = t - (s - u);
        return r = this, i = arguments, f <= 0 || f > t ? (l && (clearTimeout(l), l = null), u = s, a = e.apply(r, i), l === null && (r = i = null)) : !l && n.trailing !== !1 && (l = setTimeout(d, f)), a;
    };
}
const $50b3a6088573c50b$var$mt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    PromiseQueue: $50b3a6088573c50b$var$vt,
    beautifyShortcut: $50b3a6088573c50b$var$xe,
    cacheable: $50b3a6088573c50b$var$Ve,
    capitalize: $50b3a6088573c50b$var$et,
    copyTextToClipboard: $50b3a6088573c50b$var$tt,
    debounce: $50b3a6088573c50b$var$nt,
    deepMerge: $50b3a6088573c50b$var$O,
    deprecationAssert: $50b3a6088573c50b$var$st,
    getUserOS: $50b3a6088573c50b$var$ue,
    getValidUrl: $50b3a6088573c50b$var$ct,
    isBoolean: $50b3a6088573c50b$var$rt,
    isClass: $50b3a6088573c50b$var$it,
    isEmpty: $50b3a6088573c50b$var$Ze,
    isFunction: $50b3a6088573c50b$var$oe,
    isIosDevice: $50b3a6088573c50b$var$Je,
    isNumber: $50b3a6088573c50b$var$at,
    isObject: $50b3a6088573c50b$var$g,
    isPrintableKey: $50b3a6088573c50b$var$dt,
    isPromise: $50b3a6088573c50b$var$lt,
    isString: $50b3a6088573c50b$var$ut,
    isUndefined: $50b3a6088573c50b$var$ot,
    keyCodes: $50b3a6088573c50b$var$ft,
    mouseButtons: $50b3a6088573c50b$var$pt,
    notEmpty: $50b3a6088573c50b$var$A,
    throttle: $50b3a6088573c50b$var$gt,
    typeOf: $50b3a6088573c50b$var$o
}, Symbol.toStringTag, {
    value: "Module"
})), $50b3a6088573c50b$var$$ = /* @__PURE__ */ $50b3a6088573c50b$var$Fe($50b3a6088573c50b$var$mt);
Object.defineProperty($50b3a6088573c50b$var$I, "__esModule", {
    value: !0
});
$50b3a6088573c50b$var$I.containsOnlyInlineElements = $50b3a6088573c50b$var$_t;
var $50b3a6088573c50b$var$bt = $50b3a6088573c50b$var$$, $50b3a6088573c50b$var$yt = $50b3a6088573c50b$var$L;
function $50b3a6088573c50b$var$_t(e) {
    var t;
    (0, $50b3a6088573c50b$var$bt.isString)(e) ? (t = document.createElement("div"), t.innerHTML = e) : t = e;
    var n = function(r) {
        return !(0, $50b3a6088573c50b$var$yt.blockElements)().includes(r.tagName.toLowerCase()) && Array.from(r.children).every(n);
    };
    return Array.from(t.children).every(n);
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.containsOnlyInlineElements = void 0;
    var t = $50b3a6088573c50b$var$I;
    Object.defineProperty(e, "containsOnlyInlineElements", {
        enumerable: !0,
        get: function() {
            return t.containsOnlyInlineElements;
        }
    });
})($50b3a6088573c50b$var$y);
var $50b3a6088573c50b$var$se = {}, $50b3a6088573c50b$var$B = {}, $50b3a6088573c50b$var$_ = {}, $50b3a6088573c50b$var$D = {};
Object.defineProperty($50b3a6088573c50b$var$D, "__esModule", {
    value: !0
});
$50b3a6088573c50b$var$D.make = $50b3a6088573c50b$var$ht;
function $50b3a6088573c50b$var$ht(e, t, n) {
    var r;
    t === void 0 && (t = null), n === void 0 && (n = {});
    var i = document.createElement(e);
    if (Array.isArray(t)) {
        var a = t.filter(function(u) {
            return u !== void 0;
        });
        (r = i.classList).add.apply(r, a);
    } else t !== null && i.classList.add(t);
    for(var l in n)Object.prototype.hasOwnProperty.call(n, l) && (i[l] = n[l]);
    return i;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.make = void 0;
    var t = $50b3a6088573c50b$var$D;
    Object.defineProperty(e, "make", {
        enumerable: !0,
        get: function() {
            return t.make;
        }
    });
})($50b3a6088573c50b$var$_);
Object.defineProperty($50b3a6088573c50b$var$B, "__esModule", {
    value: !0
});
$50b3a6088573c50b$var$B.fragmentToString = $50b3a6088573c50b$var$Ot;
var $50b3a6088573c50b$var$Et = $50b3a6088573c50b$var$_;
function $50b3a6088573c50b$var$Ot(e) {
    var t = (0, $50b3a6088573c50b$var$Et.make)("div");
    return t.appendChild(e), t.innerHTML;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.fragmentToString = void 0;
    var t = $50b3a6088573c50b$var$B;
    Object.defineProperty(e, "fragmentToString", {
        enumerable: !0,
        get: function() {
            return t.fragmentToString;
        }
    });
})($50b3a6088573c50b$var$se);
var $50b3a6088573c50b$var$ce = {}, $50b3a6088573c50b$var$H = {};
Object.defineProperty($50b3a6088573c50b$var$H, "__esModule", {
    value: !0
});
$50b3a6088573c50b$var$H.getContentLength = $50b3a6088573c50b$var$jt;
var $50b3a6088573c50b$var$Pt = $50b3a6088573c50b$var$c;
function $50b3a6088573c50b$var$jt(e) {
    var t, n;
    return (0, $50b3a6088573c50b$var$Pt.isNativeInput)(e) ? e.value.length : e.nodeType === Node.TEXT_NODE ? e.length : (n = (t = e.textContent) === null || t === void 0 ? void 0 : t.length) !== null && n !== void 0 ? n : 0;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.getContentLength = void 0;
    var t = $50b3a6088573c50b$var$H;
    Object.defineProperty(e, "getContentLength", {
        enumerable: !0,
        get: function() {
            return t.getContentLength;
        }
    });
})($50b3a6088573c50b$var$ce);
var $50b3a6088573c50b$var$R = {}, $50b3a6088573c50b$var$F = {}, $50b3a6088573c50b$var$re = $50b3a6088573c50b$var$b && $50b3a6088573c50b$var$b.__spreadArray || function(e, t, n) {
    if (n || arguments.length === 2) for(var r = 0, i = t.length, a; r < i; r++)(a || !(r in t)) && (a || (a = Array.prototype.slice.call(t, 0, r)), a[r] = t[r]);
    return e.concat(a || Array.prototype.slice.call(t));
};
Object.defineProperty($50b3a6088573c50b$var$F, "__esModule", {
    value: !0
});
$50b3a6088573c50b$var$F.getDeepestBlockElements = $50b3a6088573c50b$var$de;
var $50b3a6088573c50b$var$Tt = $50b3a6088573c50b$var$y;
function $50b3a6088573c50b$var$de(e) {
    return (0, $50b3a6088573c50b$var$Tt.containsOnlyInlineElements)(e) ? [
        e
    ] : Array.from(e.children).reduce(function(t, n) {
        return $50b3a6088573c50b$var$re($50b3a6088573c50b$var$re([], t, !0), $50b3a6088573c50b$var$de(n), !0);
    }, []);
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.getDeepestBlockElements = void 0;
    var t = $50b3a6088573c50b$var$F;
    Object.defineProperty(e, "getDeepestBlockElements", {
        enumerable: !0,
        get: function() {
            return t.getDeepestBlockElements;
        }
    });
})($50b3a6088573c50b$var$R);
var $50b3a6088573c50b$var$fe = {}, $50b3a6088573c50b$var$W = {}, $50b3a6088573c50b$var$h = {}, $50b3a6088573c50b$var$U = {};
Object.defineProperty($50b3a6088573c50b$var$U, "__esModule", {
    value: !0
});
$50b3a6088573c50b$var$U.isLineBreakTag = $50b3a6088573c50b$var$Ct;
function $50b3a6088573c50b$var$Ct(e) {
    return [
        "BR",
        "WBR"
    ].includes(e.tagName);
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isLineBreakTag = void 0;
    var t = $50b3a6088573c50b$var$U;
    Object.defineProperty(e, "isLineBreakTag", {
        enumerable: !0,
        get: function() {
            return t.isLineBreakTag;
        }
    });
})($50b3a6088573c50b$var$h);
var $50b3a6088573c50b$var$E = {}, $50b3a6088573c50b$var$q = {};
Object.defineProperty($50b3a6088573c50b$var$q, "__esModule", {
    value: !0
});
$50b3a6088573c50b$var$q.isSingleTag = $50b3a6088573c50b$var$Lt;
function $50b3a6088573c50b$var$Lt(e) {
    return [
        "AREA",
        "BASE",
        "BR",
        "COL",
        "COMMAND",
        "EMBED",
        "HR",
        "IMG",
        "INPUT",
        "KEYGEN",
        "LINK",
        "META",
        "PARAM",
        "SOURCE",
        "TRACK",
        "WBR"
    ].includes(e.tagName);
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isSingleTag = void 0;
    var t = $50b3a6088573c50b$var$q;
    Object.defineProperty(e, "isSingleTag", {
        enumerable: !0,
        get: function() {
            return t.isSingleTag;
        }
    });
})($50b3a6088573c50b$var$E);
Object.defineProperty($50b3a6088573c50b$var$W, "__esModule", {
    value: !0
});
$50b3a6088573c50b$var$W.getDeepestNode = $50b3a6088573c50b$var$pe;
var $50b3a6088573c50b$var$St = $50b3a6088573c50b$var$c, $50b3a6088573c50b$var$Mt = $50b3a6088573c50b$var$h, $50b3a6088573c50b$var$kt = $50b3a6088573c50b$var$E;
function $50b3a6088573c50b$var$pe(e, t) {
    t === void 0 && (t = !1);
    var n = t ? "lastChild" : "firstChild", r = t ? "previousSibling" : "nextSibling";
    if (e.nodeType === Node.ELEMENT_NODE && e[n]) {
        var i = e[n];
        if ((0, $50b3a6088573c50b$var$kt.isSingleTag)(i) && !(0, $50b3a6088573c50b$var$St.isNativeInput)(i) && !(0, $50b3a6088573c50b$var$Mt.isLineBreakTag)(i)) {
            if (i[r]) i = i[r];
            else if (i.parentNode !== null && i.parentNode[r]) i = i.parentNode[r];
            else return i.parentNode;
        }
        return $50b3a6088573c50b$var$pe(i, t);
    }
    return e;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.getDeepestNode = void 0;
    var t = $50b3a6088573c50b$var$W;
    Object.defineProperty(e, "getDeepestNode", {
        enumerable: !0,
        get: function() {
            return t.getDeepestNode;
        }
    });
})($50b3a6088573c50b$var$fe);
var $50b3a6088573c50b$var$ve = {}, $50b3a6088573c50b$var$z = {}, $50b3a6088573c50b$var$p = $50b3a6088573c50b$var$b && $50b3a6088573c50b$var$b.__spreadArray || function(e, t, n) {
    if (n || arguments.length === 2) for(var r = 0, i = t.length, a; r < i; r++)(a || !(r in t)) && (a || (a = Array.prototype.slice.call(t, 0, r)), a[r] = t[r]);
    return e.concat(a || Array.prototype.slice.call(t));
};
Object.defineProperty($50b3a6088573c50b$var$z, "__esModule", {
    value: !0
});
$50b3a6088573c50b$var$z.findAllInputs = $50b3a6088573c50b$var$$t;
var $50b3a6088573c50b$var$wt = $50b3a6088573c50b$var$y, $50b3a6088573c50b$var$Nt = $50b3a6088573c50b$var$R, $50b3a6088573c50b$var$It = $50b3a6088573c50b$var$P, $50b3a6088573c50b$var$At = $50b3a6088573c50b$var$c;
function $50b3a6088573c50b$var$$t(e) {
    return Array.from(e.querySelectorAll((0, $50b3a6088573c50b$var$It.allInputsSelector)())).reduce(function(t, n) {
        return (0, $50b3a6088573c50b$var$At.isNativeInput)(n) || (0, $50b3a6088573c50b$var$wt.containsOnlyInlineElements)(n) ? $50b3a6088573c50b$var$p($50b3a6088573c50b$var$p([], t, !0), [
            n
        ], !1) : $50b3a6088573c50b$var$p($50b3a6088573c50b$var$p([], t, !0), (0, $50b3a6088573c50b$var$Nt.getDeepestBlockElements)(n), !0);
    }, []);
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.findAllInputs = void 0;
    var t = $50b3a6088573c50b$var$z;
    Object.defineProperty(e, "findAllInputs", {
        enumerable: !0,
        get: function() {
            return t.findAllInputs;
        }
    });
})($50b3a6088573c50b$var$ve);
var $50b3a6088573c50b$var$ge = {}, $50b3a6088573c50b$var$G = {};
Object.defineProperty($50b3a6088573c50b$var$G, "__esModule", {
    value: !0
});
$50b3a6088573c50b$var$G.isCollapsedWhitespaces = $50b3a6088573c50b$var$Bt;
function $50b3a6088573c50b$var$Bt(e) {
    return !/[^\t\n\r ]/.test(e);
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isCollapsedWhitespaces = void 0;
    var t = $50b3a6088573c50b$var$G;
    Object.defineProperty(e, "isCollapsedWhitespaces", {
        enumerable: !0,
        get: function() {
            return t.isCollapsedWhitespaces;
        }
    });
})($50b3a6088573c50b$var$ge);
var $50b3a6088573c50b$var$K = {}, $50b3a6088573c50b$var$X = {};
Object.defineProperty($50b3a6088573c50b$var$X, "__esModule", {
    value: !0
});
$50b3a6088573c50b$var$X.isElement = $50b3a6088573c50b$var$Ht;
var $50b3a6088573c50b$var$Dt = $50b3a6088573c50b$var$$;
function $50b3a6088573c50b$var$Ht(e) {
    return (0, $50b3a6088573c50b$var$Dt.isNumber)(e) ? !1 : !!e && !!e.nodeType && e.nodeType === Node.ELEMENT_NODE;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isElement = void 0;
    var t = $50b3a6088573c50b$var$X;
    Object.defineProperty(e, "isElement", {
        enumerable: !0,
        get: function() {
            return t.isElement;
        }
    });
})($50b3a6088573c50b$var$K);
var $50b3a6088573c50b$var$me = {}, $50b3a6088573c50b$var$Y = {}, $50b3a6088573c50b$var$Q = {}, $50b3a6088573c50b$var$V = {};
Object.defineProperty($50b3a6088573c50b$var$V, "__esModule", {
    value: !0
});
$50b3a6088573c50b$var$V.isLeaf = $50b3a6088573c50b$var$Rt;
function $50b3a6088573c50b$var$Rt(e) {
    return e === null ? !1 : e.childNodes.length === 0;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isLeaf = void 0;
    var t = $50b3a6088573c50b$var$V;
    Object.defineProperty(e, "isLeaf", {
        enumerable: !0,
        get: function() {
            return t.isLeaf;
        }
    });
})($50b3a6088573c50b$var$Q);
var $50b3a6088573c50b$var$Z = {}, $50b3a6088573c50b$var$J = {};
Object.defineProperty($50b3a6088573c50b$var$J, "__esModule", {
    value: !0
});
$50b3a6088573c50b$var$J.isNodeEmpty = $50b3a6088573c50b$var$zt;
var $50b3a6088573c50b$var$Ft = $50b3a6088573c50b$var$h, $50b3a6088573c50b$var$Wt = $50b3a6088573c50b$var$K, $50b3a6088573c50b$var$Ut = $50b3a6088573c50b$var$c, $50b3a6088573c50b$var$qt = $50b3a6088573c50b$var$E;
function $50b3a6088573c50b$var$zt(e, t) {
    var n = "";
    return (0, $50b3a6088573c50b$var$qt.isSingleTag)(e) && !(0, $50b3a6088573c50b$var$Ft.isLineBreakTag)(e) ? !1 : ((0, $50b3a6088573c50b$var$Wt.isElement)(e) && (0, $50b3a6088573c50b$var$Ut.isNativeInput)(e) ? n = e.value : e.textContent !== null && (n = e.textContent.replace("\u200B", "")), t !== void 0 && (n = n.replace(new RegExp(t, "g"), "")), n.trim().length === 0);
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isNodeEmpty = void 0;
    var t = $50b3a6088573c50b$var$J;
    Object.defineProperty(e, "isNodeEmpty", {
        enumerable: !0,
        get: function() {
            return t.isNodeEmpty;
        }
    });
})($50b3a6088573c50b$var$Z);
Object.defineProperty($50b3a6088573c50b$var$Y, "__esModule", {
    value: !0
});
$50b3a6088573c50b$var$Y.isEmpty = $50b3a6088573c50b$var$Xt;
var $50b3a6088573c50b$var$Gt = $50b3a6088573c50b$var$Q, $50b3a6088573c50b$var$Kt = $50b3a6088573c50b$var$Z;
function $50b3a6088573c50b$var$Xt(e, t) {
    e.normalize();
    for(var n = [
        e
    ]; n.length > 0;){
        var r = n.shift();
        if (r) {
            if (e = r, (0, $50b3a6088573c50b$var$Gt.isLeaf)(e) && !(0, $50b3a6088573c50b$var$Kt.isNodeEmpty)(e, t)) return !1;
            n.push.apply(n, Array.from(e.childNodes));
        }
    }
    return !0;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isEmpty = void 0;
    var t = $50b3a6088573c50b$var$Y;
    Object.defineProperty(e, "isEmpty", {
        enumerable: !0,
        get: function() {
            return t.isEmpty;
        }
    });
})($50b3a6088573c50b$var$me);
var $50b3a6088573c50b$var$be = {}, $50b3a6088573c50b$var$x = {};
Object.defineProperty($50b3a6088573c50b$var$x, "__esModule", {
    value: !0
});
$50b3a6088573c50b$var$x.isFragment = $50b3a6088573c50b$var$Qt;
var $50b3a6088573c50b$var$Yt = $50b3a6088573c50b$var$$;
function $50b3a6088573c50b$var$Qt(e) {
    return (0, $50b3a6088573c50b$var$Yt.isNumber)(e) ? !1 : !!e && !!e.nodeType && e.nodeType === Node.DOCUMENT_FRAGMENT_NODE;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isFragment = void 0;
    var t = $50b3a6088573c50b$var$x;
    Object.defineProperty(e, "isFragment", {
        enumerable: !0,
        get: function() {
            return t.isFragment;
        }
    });
})($50b3a6088573c50b$var$be);
var $50b3a6088573c50b$var$ye = {}, $50b3a6088573c50b$var$ee = {};
Object.defineProperty($50b3a6088573c50b$var$ee, "__esModule", {
    value: !0
});
$50b3a6088573c50b$var$ee.isHTMLString = $50b3a6088573c50b$var$Zt;
var $50b3a6088573c50b$var$Vt = $50b3a6088573c50b$var$_;
function $50b3a6088573c50b$var$Zt(e) {
    var t = (0, $50b3a6088573c50b$var$Vt.make)("div");
    return t.innerHTML = e, t.childElementCount > 0;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isHTMLString = void 0;
    var t = $50b3a6088573c50b$var$ee;
    Object.defineProperty(e, "isHTMLString", {
        enumerable: !0,
        get: function() {
            return t.isHTMLString;
        }
    });
})($50b3a6088573c50b$var$ye);
var $50b3a6088573c50b$var$_e = {}, $50b3a6088573c50b$var$te = {};
Object.defineProperty($50b3a6088573c50b$var$te, "__esModule", {
    value: !0
});
$50b3a6088573c50b$var$te.offset = $50b3a6088573c50b$var$Jt;
function $50b3a6088573c50b$var$Jt(e) {
    var t = e.getBoundingClientRect(), n = window.pageXOffset || document.documentElement.scrollLeft, r = window.pageYOffset || document.documentElement.scrollTop, i = t.top + r, a = t.left + n;
    return {
        top: i,
        left: a,
        bottom: i + t.height,
        right: a + t.width
    };
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.offset = void 0;
    var t = $50b3a6088573c50b$var$te;
    Object.defineProperty(e, "offset", {
        enumerable: !0,
        get: function() {
            return t.offset;
        }
    });
})($50b3a6088573c50b$var$_e);
var $50b3a6088573c50b$var$he = {}, $50b3a6088573c50b$var$ne = {};
Object.defineProperty($50b3a6088573c50b$var$ne, "__esModule", {
    value: !0
});
$50b3a6088573c50b$var$ne.prepend = $50b3a6088573c50b$var$xt;
function $50b3a6088573c50b$var$xt(e, t) {
    Array.isArray(t) ? (t = t.reverse(), t.forEach(function(n) {
        return e.prepend(n);
    })) : e.prepend(t);
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.prepend = void 0;
    var t = $50b3a6088573c50b$var$ne;
    Object.defineProperty(e, "prepend", {
        enumerable: !0,
        get: function() {
            return t.prepend;
        }
    });
})($50b3a6088573c50b$var$he);
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.prepend = e.offset = e.make = e.isLineBreakTag = e.isSingleTag = e.isNodeEmpty = e.isLeaf = e.isHTMLString = e.isFragment = e.isEmpty = e.isElement = e.isContentEditable = e.isCollapsedWhitespaces = e.findAllInputs = e.isNativeInput = e.allInputsSelector = e.getDeepestNode = e.getDeepestBlockElements = e.getContentLength = e.fragmentToString = e.containsOnlyInlineElements = e.canSetCaret = e.calculateBaseline = e.blockElements = e.append = void 0;
    var t = $50b3a6088573c50b$var$P;
    Object.defineProperty(e, "allInputsSelector", {
        enumerable: !0,
        get: function() {
            return t.allInputsSelector;
        }
    });
    var n = $50b3a6088573c50b$var$c;
    Object.defineProperty(e, "isNativeInput", {
        enumerable: !0,
        get: function() {
            return n.isNativeInput;
        }
    });
    var r = $50b3a6088573c50b$var$ie;
    Object.defineProperty(e, "append", {
        enumerable: !0,
        get: function() {
            return r.append;
        }
    });
    var i = $50b3a6088573c50b$var$L;
    Object.defineProperty(e, "blockElements", {
        enumerable: !0,
        get: function() {
            return i.blockElements;
        }
    });
    var a = $50b3a6088573c50b$var$ae;
    Object.defineProperty(e, "calculateBaseline", {
        enumerable: !0,
        get: function() {
            return a.calculateBaseline;
        }
    });
    var l = $50b3a6088573c50b$var$le;
    Object.defineProperty(e, "canSetCaret", {
        enumerable: !0,
        get: function() {
            return l.canSetCaret;
        }
    });
    var u = $50b3a6088573c50b$var$y;
    Object.defineProperty(e, "containsOnlyInlineElements", {
        enumerable: !0,
        get: function() {
            return u.containsOnlyInlineElements;
        }
    });
    var d = $50b3a6088573c50b$var$se;
    Object.defineProperty(e, "fragmentToString", {
        enumerable: !0,
        get: function() {
            return d.fragmentToString;
        }
    });
    var s = $50b3a6088573c50b$var$ce;
    Object.defineProperty(e, "getContentLength", {
        enumerable: !0,
        get: function() {
            return s.getContentLength;
        }
    });
    var f = $50b3a6088573c50b$var$R;
    Object.defineProperty(e, "getDeepestBlockElements", {
        enumerable: !0,
        get: function() {
            return f.getDeepestBlockElements;
        }
    });
    var Oe = $50b3a6088573c50b$var$fe;
    Object.defineProperty(e, "getDeepestNode", {
        enumerable: !0,
        get: function() {
            return Oe.getDeepestNode;
        }
    });
    var Pe = $50b3a6088573c50b$var$ve;
    Object.defineProperty(e, "findAllInputs", {
        enumerable: !0,
        get: function() {
            return Pe.findAllInputs;
        }
    });
    var je = $50b3a6088573c50b$var$ge;
    Object.defineProperty(e, "isCollapsedWhitespaces", {
        enumerable: !0,
        get: function() {
            return je.isCollapsedWhitespaces;
        }
    });
    var Te = $50b3a6088573c50b$var$w;
    Object.defineProperty(e, "isContentEditable", {
        enumerable: !0,
        get: function() {
            return Te.isContentEditable;
        }
    });
    var Ce = $50b3a6088573c50b$var$K;
    Object.defineProperty(e, "isElement", {
        enumerable: !0,
        get: function() {
            return Ce.isElement;
        }
    });
    var Le = $50b3a6088573c50b$var$me;
    Object.defineProperty(e, "isEmpty", {
        enumerable: !0,
        get: function() {
            return Le.isEmpty;
        }
    });
    var Se = $50b3a6088573c50b$var$be;
    Object.defineProperty(e, "isFragment", {
        enumerable: !0,
        get: function() {
            return Se.isFragment;
        }
    });
    var Me = $50b3a6088573c50b$var$ye;
    Object.defineProperty(e, "isHTMLString", {
        enumerable: !0,
        get: function() {
            return Me.isHTMLString;
        }
    });
    var ke = $50b3a6088573c50b$var$Q;
    Object.defineProperty(e, "isLeaf", {
        enumerable: !0,
        get: function() {
            return ke.isLeaf;
        }
    });
    var we = $50b3a6088573c50b$var$Z;
    Object.defineProperty(e, "isNodeEmpty", {
        enumerable: !0,
        get: function() {
            return we.isNodeEmpty;
        }
    });
    var Ne = $50b3a6088573c50b$var$h;
    Object.defineProperty(e, "isLineBreakTag", {
        enumerable: !0,
        get: function() {
            return Ne.isLineBreakTag;
        }
    });
    var Ie = $50b3a6088573c50b$var$E;
    Object.defineProperty(e, "isSingleTag", {
        enumerable: !0,
        get: function() {
            return Ie.isSingleTag;
        }
    });
    var Ae = $50b3a6088573c50b$var$_;
    Object.defineProperty(e, "make", {
        enumerable: !0,
        get: function() {
            return Ae.make;
        }
    });
    var $e = $50b3a6088573c50b$var$_e;
    Object.defineProperty(e, "offset", {
        enumerable: !0,
        get: function() {
            return $e.offset;
        }
    });
    var Be = $50b3a6088573c50b$var$he;
    Object.defineProperty(e, "prepend", {
        enumerable: !0,
        get: function() {
            return Be.prepend;
        }
    });
})($50b3a6088573c50b$var$v);
var $50b3a6088573c50b$var$Ee = /* @__PURE__ */ ((e)=>(e.Left = "left", e.Center = "center", e))($50b3a6088573c50b$var$Ee || {});
class $50b3a6088573c50b$export$2e2bcd8739ae039 {
    /**
   * Render plugin`s main Element and fill it with saved data
   * @param params - Quote Tool constructor params
   * @param params.data - previously saved data
   * @param params.config - user config for Tool
   * @param params.api - editor.js api
   * @param params.readOnly - read only mode flag
   */ constructor({ data: t, config: n, api: r, readOnly: i, block: a }){
        const { DEFAULT_ALIGNMENT: l } = $50b3a6088573c50b$export$2e2bcd8739ae039;
        this.api = r, this.readOnly = i, this.quotePlaceholder = r.i18n.t((n == null ? void 0 : n.quotePlaceholder) ?? $50b3a6088573c50b$export$2e2bcd8739ae039.DEFAULT_QUOTE_PLACEHOLDER), this.captionPlaceholder = r.i18n.t((n == null ? void 0 : n.captionPlaceholder) ?? $50b3a6088573c50b$export$2e2bcd8739ae039.DEFAULT_CAPTION_PLACEHOLDER), this.data = {
            text: t.text || "",
            caption: t.caption || "",
            alignment: Object.values($50b3a6088573c50b$var$Ee).includes(t.alignment) ? t.alignment : (n == null ? void 0 : n.defaultAlignment) ?? l
        }, this.css = {
            baseClass: this.api.styles.block,
            wrapper: "cdx-quote",
            text: "cdx-quote__text",
            input: this.api.styles.input,
            caption: "cdx-quote__caption"
        }, this.block = a;
    }
    /**
   * Notify core that read-only mode is supported
   * @returns true
   */ static get isReadOnlySupported() {
        return !0;
    }
    /**
   * Get Tool toolbox settings
   * icon - Tool icon's SVG
   * title - title to show in toolbox
   * @returns icon and title of the toolbox
   */ static get toolbox() {
        return {
            icon: $50b3a6088573c50b$var$Re,
            title: "Quote"
        };
    }
    /**
   * Empty Quote is not empty Block
   * @returns true
   */ static get contentless() {
        return !0;
    }
    /**
   * Allow to press Enter inside the Quote
   * @returns true
   */ static get enableLineBreaks() {
        return !0;
    }
    /**
   * Default placeholder for quote text
   * @returns 'Enter a quote'
   */ static get DEFAULT_QUOTE_PLACEHOLDER() {
        return "Enter a quote";
    }
    /**
   * Default placeholder for quote caption
   * @returns 'Enter a caption'
   */ static get DEFAULT_CAPTION_PLACEHOLDER() {
        return "Enter a caption";
    }
    /**
   * Default quote alignment
   * @returns Alignment.Left
   */ static get DEFAULT_ALIGNMENT() {
        return "left";
    }
    /**
   * Allow Quote to be converted to/from other blocks
   * @returns conversion config object
   */ static get conversionConfig() {
        return {
            /**
       * To create Quote data from string, simple fill 'text' property
       */ import: "text",
            /**
       * To create string from Quote data, concatenate text and caption
       * @param quoteData - Quote data object
       * @returns string
       */ export: function(t) {
                return t.caption ? `${t.text} \u{2014} ${t.caption}` : t.text;
            }
        };
    }
    /**
   * Tool`s styles
   * @returns CSS classes names
   */ get CSS() {
        return {
            baseClass: this.api.styles.block,
            wrapper: "cdx-quote",
            text: "cdx-quote__text",
            input: this.api.styles.input,
            caption: "cdx-quote__caption"
        };
    }
    /**
   * Tool`s settings properties
   * @returns settings properties
   */ get settings() {
        return [
            {
                name: "left",
                icon: $50b3a6088573c50b$var$He
            },
            {
                name: "center",
                icon: $50b3a6088573c50b$var$De
            }
        ];
    }
    /**
   * Create Quote Tool container with inputs
   * @returns blockquote DOM element - Quote Tool container
   */ render() {
        const t = $50b3a6088573c50b$var$v.make("blockquote", [
            this.css.baseClass,
            this.css.wrapper
        ]), n = $50b3a6088573c50b$var$v.make("div", [
            this.css.input,
            this.css.text
        ], {
            contentEditable: !this.readOnly,
            innerHTML: this.data.text
        }), r = $50b3a6088573c50b$var$v.make("div", [
            this.css.input,
            this.css.caption
        ], {
            contentEditable: !this.readOnly,
            innerHTML: this.data.caption
        });
        return n.dataset.placeholder = this.quotePlaceholder, r.dataset.placeholder = this.captionPlaceholder, t.appendChild(n), t.appendChild(r), t;
    }
    /**
   * Extract Quote data from Quote Tool element
   * @param quoteElement - Quote DOM element to save
   * @returns Quote data object
   */ save(t) {
        const n = t.querySelector(`.${this.css.text}`), r = t.querySelector(`.${this.css.caption}`);
        return Object.assign(this.data, {
            text: (n == null ? void 0 : n.innerHTML) ?? "",
            caption: (r == null ? void 0 : r.innerHTML) ?? ""
        });
    }
    /**
   * Sanitizer rules
   * @returns sanitizer rules
   */ static get sanitize() {
        return {
            text: {
                br: !0
            },
            caption: {
                br: !0
            },
            alignment: {}
        };
    }
    /**
   * Create wrapper for Tool`s settings buttons:
   * 1. Left alignment
   * 2. Center alignment
   * @returns settings menu
   */ renderSettings() {
        const t = (n)=>n && n[0].toUpperCase() + n.slice(1);
        return this.settings.map((n)=>({
                icon: n.icon,
                label: this.api.i18n.t(`Align ${t(n.name)}`),
                onActivate: ()=>this._toggleTune(n.name),
                isActive: this.data.alignment === n.name,
                closeOnActivate: !0
            }));
    }
    /**
   * Toggle quote`s alignment
   * @param tune - alignment
   */ _toggleTune(t) {
        this.data.alignment = t, this.block.dispatchChange();
    }
}

});

parcelRegister("74N1Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $73caaef2353b812d$export$2e2bcd8739ae039);
(function() {
    "use strict";
    try {
        if (typeof document < "u") {
            var e = document.createElement("style");
            e.appendChild(document.createTextNode(".ce-code__textarea{min-height:200px;font-family:Menlo,Monaco,Consolas,Courier New,monospace;color:#41314e;line-height:1.6em;font-size:12px;background:#f8f7fa;border:1px solid #f1f1f4;box-shadow:none;white-space:pre;word-wrap:normal;overflow-x:auto;resize:vertical}")), document.head.appendChild(e);
        }
    } catch (o) {
        console.error("vite-plugin-css-injected-by-js", o);
    }
})();
function $73caaef2353b812d$var$c(l, t) {
    let a = "";
    for(; a !== `
` && t > 0;)t = t - 1, a = l.substr(t, 1);
    return a === `
` && (t += 1), t;
}
const $73caaef2353b812d$var$h = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 8L5 12L9 16"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 8L19 12L15 16"/></svg>';
/**
 * CodeTool for Editor.js
 * @version 2.0.0
 * @license MIT
 */ class $73caaef2353b812d$export$2e2bcd8739ae039 {
    /**
   * Notify core that read-only mode is supported
   * @returns true if read-only mode is supported
   */ static get isReadOnlySupported() {
        return !0;
    }
    /**
   * Allows pressing Enter key to create line breaks inside the CodeTool textarea
   * This enables multi-line input within the code editor.
   * @returns true if line breaks are allowed in the textarea
   */ static get enableLineBreaks() {
        return !0;
    }
    /**
   * Render plugin`s main Element and fill it with saved data
   * @param options - tool constricting options
   * @param options.data — previously saved plugin code
   * @param options.config - user config for Tool
   * @param options.api - Editor.js API
   * @param options.readOnly - read only mode flag
   */ constructor({ data: t, config: e, api: a, readOnly: s }){
        this.api = a, this.readOnly = s, this.placeholder = this.api.i18n.t(e.placeholder || $73caaef2353b812d$export$2e2bcd8739ae039.DEFAULT_PLACEHOLDER), this.CSS = {
            baseClass: this.api.styles.block,
            input: this.api.styles.input,
            wrapper: "ce-code",
            textarea: "ce-code__textarea"
        }, this.nodes = {
            holder: null,
            textarea: null
        }, this.data = {
            code: t.code ?? ""
        }, this.nodes.holder = this.drawView();
    }
    /**
   * Return Tool's view
   * @returns this.nodes.holder - Code's wrapper
   */ render() {
        return this.nodes.holder;
    }
    /**
   * Extract Tool's data from the view
   * @param codeWrapper - CodeTool's wrapper, containing textarea with code
   * @returns - saved plugin code
   */ save(t) {
        return {
            code: t.querySelector("textarea").value
        };
    }
    /**
   * onPaste callback fired from Editor`s core
   * @param event - event with pasted content
   */ onPaste(t) {
        switch(t.type){
            case "tag":
                {
                    const e = t.detail.data;
                    this.handleHTMLPaste(e);
                    break;
                }
        }
    }
    /**
   * Returns Tool`s data from private property
   * @returns
   */ get data() {
        return this._data;
    }
    /**
   * Set Tool`s data to private property and update view
   * @param data - saved tool data
   */ set data(t) {
        this._data = t, this.nodes.textarea && (this.nodes.textarea.value = t.code);
    }
    /**
   * Get Tool toolbox settings.
   * Provides the icon and title to display in the toolbox for the CodeTool.
   * @returns An object containing:
   * - icon: SVG representation of the Tool's icon
   * - title: Title to show in the toolbox
   */ static get toolbox() {
        return {
            icon: $73caaef2353b812d$var$h,
            title: "Code"
        };
    }
    /**
   * Default placeholder for CodeTool's textarea
   * @returns
   */ static get DEFAULT_PLACEHOLDER() {
        return "Enter a code";
    }
    /**
   *  Used by Editor.js paste handling API.
   *  Provides configuration to handle CODE tag.
   * @returns
   */ static get pasteConfig() {
        return {
            tags: [
                "pre"
            ]
        };
    }
    /**
   * Automatic sanitize config
   * @returns
   */ static get sanitize() {
        return {
            code: !0
        };
    }
    /**
   * Handles Tab key pressing (adds/removes indentations)
   * @param event - keydown
   */ tabHandler(t) {
        t.stopPropagation(), t.preventDefault();
        const e = t.target, a = t.shiftKey, s = e.selectionStart, r = e.value, n = "  ";
        let i;
        if (!a) i = s + n.length, e.value = r.substring(0, s) + n + r.substring(s);
        else {
            const o = $73caaef2353b812d$var$c(r, s);
            if (r.substr(o, n.length) !== n) return;
            e.value = r.substring(0, o) + r.substring(o + n.length), i = s - n.length;
        }
        e.setSelectionRange(i, i);
    }
    /**
   * Create Tool's view
   * @returns
   */ drawView() {
        const t = document.createElement("div"), e = document.createElement("textarea");
        return t.classList.add(this.CSS.baseClass, this.CSS.wrapper), e.classList.add(this.CSS.textarea, this.CSS.input), e.value = this.data.code, e.placeholder = this.placeholder, this.readOnly && (e.disabled = !0), t.appendChild(e), e.addEventListener("keydown", (a)=>{
            switch(a.code){
                case "Tab":
                    this.tabHandler(a);
                    break;
            }
        }), this.nodes.textarea = e, t;
    }
    /**
   * Extracts the code content from the pasted element's innerHTML and populates the tool's data.
   * @param element - pasted HTML element
   */ handleHTMLPaste(t) {
        this.data = {
            code: t.innerHTML
        };
    }
}

});

parcelRegister("lVxB8", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfed5c7fc8ade99a$export$2e2bcd8739ae039);
(function() {
    "use strict";
    try {
        if (typeof document < "u") {
            var e = document.createElement("style");
            e.appendChild(document.createTextNode('.ce-delimiter{line-height:1.6em;width:100%;text-align:center}.ce-delimiter:before{display:inline-block;content:"***";font-size:30px;line-height:65px;height:30px;letter-spacing:.2em}')), document.head.appendChild(e);
        }
    } catch (t) {
        console.error("vite-plugin-css-injected-by-js", t);
    }
})();
const $bfed5c7fc8ade99a$var$r = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><line x1="6" x2="10" y1="12" y2="12" stroke="currentColor" stroke-linecap="round" stroke-width="2"/><line x1="14" x2="18" y1="12" y2="12" stroke="currentColor" stroke-linecap="round" stroke-width="2"/></svg>';
/**
 * Delimiter Block for the Editor.js.
 *
 * @author CodeX (team@ifmo.su)
 * @copyright CodeX 2018
 * @license The MIT License (MIT)
 * @version 2.0.0
 */ class $bfed5c7fc8ade99a$export$2e2bcd8739ae039 {
    /**
   * Notify core that read-only mode is supported
   * @return {boolean}
   */ static get isReadOnlySupported() {
        return !0;
    }
    /**
   * Allow Tool to have no content
   * @return {boolean}
   */ static get contentless() {
        return !0;
    }
    /**
   * Render plugin`s main Element and fill it with saved data
   *
   * @param {{data: DelimiterData, config: object, api: object}}
   *   data — previously saved data
   *   config - user config for Tool
   *   api - Editor.js API
   */ constructor({ data: t, config: s, api: e }){
        this.api = e, this._CSS = {
            block: this.api.styles.block,
            wrapper: "ce-delimiter"
        }, this._element = this.drawView(), this.data = t;
    }
    /**
   * Create Tool's view
   * @return {HTMLDivElement}
   * @private
   */ drawView() {
        let t = document.createElement("div");
        return t.classList.add(this._CSS.wrapper, this._CSS.block), t;
    }
    /**
   * Return Tool's view
   * @returns {HTMLDivElement}
   * @public
   */ render() {
        return this._element;
    }
    /**
   * Extract Tool's data from the view
   * @param {HTMLDivElement} toolsContent - Paragraph tools rendered view
   * @returns {DelimiterData} - saved data
   * @public
   */ save(t) {
        return {};
    }
    /**
   * Get Tool toolbox settings
   * icon - Tool icon's SVG
   * title - title to show in toolbox
   *
   * @return {{icon: string, title: string}}
   */ static get toolbox() {
        return {
            icon: $bfed5c7fc8ade99a$var$r,
            title: "Delimiter"
        };
    }
    /**
   * Delimiter onPaste configuration
   *
   * @public
   */ static get pasteConfig() {
        return {
            tags: [
                "HR"
            ]
        };
    }
    /**
   * On paste callback that is fired from Editor
   *
   * @param {PasteEvent} event - event with pasted data
   */ onPaste(t) {
        this.data = {};
    }
}

});

parcelRegister("e1Kt7", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6b5b6a7488170d7$export$2e2bcd8739ae039);
(function() {
    "use strict";
    try {
        if (typeof document < "u") {
            var e = document.createElement("style");
            e.appendChild(document.createTextNode(".cdx-marker{background:rgba(245,235,111,.29);padding:3px 0}")), document.head.appendChild(e);
        }
    } catch (d) {
        console.error("vite-plugin-css-injected-by-js", d);
    }
})();
const $e6b5b6a7488170d7$var$o = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-width="2" d="M11.3536 9.31802L12.7678 7.90381C13.5488 7.12276 14.8151 7.12276 15.5962 7.90381C16.3772 8.68486 16.3772 9.95119 15.5962 10.7322L14.182 12.1464M11.3536 9.31802L7.96729 12.7043C7.40889 13.2627 7.02827 13.9739 6.8734 14.7482L6.69798 15.6253C6.55804 16.325 7.17496 16.942 7.87468 16.802L8.75176 16.6266C9.52612 16.4717 10.2373 16.0911 10.7957 15.5327L14.182 12.1464M11.3536 9.31802L14.182 12.1464"/><line x1="15" x2="19" y1="17" y2="17" stroke="currentColor" stroke-linecap="round" stroke-width="2"/></svg>';
class $e6b5b6a7488170d7$export$2e2bcd8739ae039 {
    /**
   * Class name for term-tag
   *
   * @type {string}
   */ static get CSS() {
        return "cdx-marker";
    }
    /**
   * @param {{api: object}}  - Editor.js API
   */ constructor({ api: t }){
        this.api = t, this.button = null, this.tag = "MARK", this.iconClasses = {
            base: this.api.styles.inlineToolButton,
            active: this.api.styles.inlineToolButtonActive
        };
    }
    /**
   * Specifies Tool as Inline Toolbar Tool
   *
   * @return {boolean}
   */ static get isInline() {
        return !0;
    }
    /**
   * Create button element for Toolbar
   *
   * @return {HTMLElement}
   */ render() {
        return this.button = document.createElement("button"), this.button.type = "button", this.button.classList.add(this.iconClasses.base), this.button.innerHTML = this.toolboxIcon, this.button;
    }
    /**
   * Wrap/Unwrap selected fragment
   *
   * @param {Range} range - selected fragment
   */ surround(t) {
        if (!t) return;
        let e = this.api.selection.findParentTag(this.tag, $e6b5b6a7488170d7$export$2e2bcd8739ae039.CSS);
        e ? this.unwrap(e) : this.wrap(t);
    }
    /**
   * Wrap selection with term-tag
   *
   * @param {Range} range - selected fragment
   */ wrap(t) {
        let e = document.createElement(this.tag);
        e.classList.add($e6b5b6a7488170d7$export$2e2bcd8739ae039.CSS), e.appendChild(t.extractContents()), t.insertNode(e), this.api.selection.expandToTag(e);
    }
    /**
   * Unwrap term-tag
   *
   * @param {HTMLElement} termWrapper - term wrapper tag
   */ unwrap(t) {
        this.api.selection.expandToTag(t);
        let e = window.getSelection(), n = e.getRangeAt(0), i = n.extractContents();
        t.parentNode.removeChild(t), n.insertNode(i), e.removeAllRanges(), e.addRange(n);
    }
    /**
   * Check and change Term's state for current selection
   */ checkState() {
        const t = this.api.selection.findParentTag(this.tag, $e6b5b6a7488170d7$export$2e2bcd8739ae039.CSS);
        this.button.classList.toggle(this.iconClasses.active, !!t);
    }
    /**
   * Get Tool icon's SVG
   * @return {string}
   */ get toolboxIcon() {
        return $e6b5b6a7488170d7$var$o;
    }
    /**
   * Sanitizer rule
   * @return {{mark: {class: string}}}
   */ static get sanitize() {
        return {
            mark: {
                class: $e6b5b6a7488170d7$export$2e2bcd8739ae039.CSS
            }
        };
    }
}

});

parcelRegister("3yt7c", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc5da5e9381479b5$export$2e2bcd8739ae039);
(function() {
    var r;
    "use strict";
    try {
        if (typeof document < "u") {
            var o = document.createElement("style");
            o.nonce = (r = document.head.querySelector("meta[property=csp-nonce]")) == null ? void 0 : r.content, o.appendChild(document.createTextNode('.tc-wrap{--color-background:#f9f9fb;--color-text-secondary:#7b7e89;--color-border:#e8e8eb;--cell-size:34px;--toolbox-icon-size:18px;--toolbox-padding:6px;--toolbox-aiming-field-size:calc(var(--toolbox-icon-size) + var(--toolbox-padding)*2);border-left:0;position:relative;height:100%;width:100%;margin-top:var(--toolbox-icon-size);box-sizing:border-box;display:grid;grid-template-columns:calc(100% - var(--cell-size)) var(--cell-size);z-index:0}.tc-wrap--readonly{grid-template-columns:100% var(--cell-size)}.tc-wrap svg{vertical-align:top}@media print{.tc-wrap{border-left-color:var(--color-border);border-left-style:solid;border-left-width:1px;grid-template-columns:100% var(--cell-size)}}@media print{.tc-wrap .tc-row:after{display:none}}.tc-table{position:relative;width:100%;height:100%;display:grid;font-size:14px;border-top:1px solid var(--color-border);line-height:1.4}.tc-table:after{width:calc(var(--cell-size));height:100%;left:calc(var(--cell-size)*-1);top:0}.tc-table:after,.tc-table:before{position:absolute;content:""}.tc-table:before{width:100%;height:var(--toolbox-aiming-field-size);top:calc(var(--toolbox-aiming-field-size)*-1);left:0}.tc-table--heading .tc-row:first-child{font-weight:600;border-bottom:2px solid var(--color-border);position:sticky;top:0;z-index:2;background:var(--color-background)}.tc-table--heading .tc-row:first-child [contenteditable]:empty:before{content:attr(heading);color:var(--color-text-secondary)}.tc-table--heading .tc-row:first-child:after{bottom:-2px;border-bottom:2px solid var(--color-border)}.tc-add-column,.tc-add-row{display:flex;color:var(--color-text-secondary)}@media print{.tc-add{display:none}}.tc-add-column{display:grid;border-top:1px solid var(--color-border);grid-template-columns:var(--cell-size);grid-auto-rows:var(--cell-size);place-items:center}.tc-add-column svg{padding:5px;position:sticky;top:0;background-color:var(--color-background)}.tc-add-column--disabled{visibility:hidden}@media print{.tc-add-column{display:none}}.tc-add-row{height:var(--cell-size);align-items:center;padding-left:4px;position:relative}.tc-add-row--disabled{display:none}.tc-add-row:before{content:"";position:absolute;right:calc(var(--cell-size)*-1);width:var(--cell-size);height:100%}@media print{.tc-add-row{display:none}}.tc-add-column,.tc-add-row{transition:0s;cursor:pointer;will-change:background-color}.tc-add-column:hover,.tc-add-row:hover{transition:background-color .1s ease;background-color:var(--color-background)}.tc-add-row{margin-top:1px}.tc-add-row:hover:before{transition:.1s;background-color:var(--color-background)}.tc-row{display:grid;grid-template-columns:repeat(auto-fit,minmax(10px,1fr));position:relative;border-bottom:1px solid var(--color-border)}.tc-row:after{content:"";pointer-events:none;position:absolute;width:var(--cell-size);height:100%;bottom:-1px;right:calc(var(--cell-size)*-1);border-bottom:1px solid var(--color-border)}.tc-row--selected{background:var(--color-background)}.tc-row--selected:after{background:var(--color-background)}.tc-cell{border-right:1px solid var(--color-border);padding:6px 12px;overflow:hidden;outline:none;line-break:normal}.tc-cell--selected{background:var(--color-background)}.tc-wrap--readonly .tc-row:after{display:none}.tc-toolbox{--toolbox-padding:6px;--popover-margin:30px;--toggler-click-zone-size:30px;--toggler-dots-color:#7b7e89;--toggler-dots-color-hovered:#1d202b;position:absolute;cursor:pointer;z-index:1;opacity:0;transition:opacity .1s;will-change:left,opacity}.tc-toolbox--column{top:calc(var(--toggler-click-zone-size)*-1);transform:translate(calc(var(--toggler-click-zone-size)*-1/2));will-change:left,opacity}.tc-toolbox--row{left:calc(var(--popover-margin)*-1);transform:translateY(calc(var(--toggler-click-zone-size)*-1/2));margin-top:-1px;will-change:top,opacity}.tc-toolbox--showed{opacity:1}.tc-toolbox .tc-popover{position:absolute;top:0;left:var(--popover-margin)}.tc-toolbox__toggler{display:flex;align-items:center;justify-content:center;width:var(--toggler-click-zone-size);height:var(--toggler-click-zone-size);color:var(--toggler-dots-color);opacity:0;transition:opacity .15s ease;will-change:opacity}.tc-toolbox__toggler:hover{color:var(--toggler-dots-color-hovered)}.tc-toolbox__toggler svg{fill:currentColor}.tc-wrap:hover .tc-toolbox__toggler{opacity:1}.tc-settings .cdx-settings-button{width:50%;margin:0}.tc-popover{--color-border:#eaeaea;--color-background:#fff;--color-background-hover:rgba(232,232,235,.49);--color-background-confirm:#e24a4a;--color-background-confirm-hover:#d54040;--color-text-confirm:#fff;background:var(--color-background);border:1px solid var(--color-border);box-shadow:0 3px 15px -3px #0d142121;border-radius:6px;padding:6px;display:none;will-change:opacity,transform}.tc-popover--opened{display:block;animation:menuShowing .1s cubic-bezier(.215,.61,.355,1) forwards}.tc-popover__item{display:flex;align-items:center;padding:2px 14px 2px 2px;border-radius:5px;cursor:pointer;white-space:nowrap;-webkit-user-select:none;-moz-user-select:none;user-select:none}.tc-popover__item:hover{background:var(--color-background-hover)}.tc-popover__item:not(:last-of-type){margin-bottom:2px}.tc-popover__item-icon{display:inline-flex;width:26px;height:26px;align-items:center;justify-content:center;background:var(--color-background);border-radius:5px;border:1px solid var(--color-border);margin-right:8px}.tc-popover__item-label{line-height:22px;font-size:14px;font-weight:500}.tc-popover__item--confirm{background:var(--color-background-confirm);color:var(--color-text-confirm)}.tc-popover__item--confirm:hover{background-color:var(--color-background-confirm-hover)}.tc-popover__item--confirm .tc-popover__item-icon{background:var(--color-background-confirm);border-color:#0000001a}.tc-popover__item--confirm .tc-popover__item-icon svg{transition:transform .2s ease-in;transform:rotate(90deg) scale(1.2)}.tc-popover__item--hidden{display:none}@keyframes menuShowing{0%{opacity:0;transform:translateY(-8px) scale(.9)}70%{opacity:1;transform:translateY(2px)}to{transform:translateY(0)}}')), document.head.appendChild(o);
        }
    } catch (e) {
        console.error("vite-plugin-css-injected-by-js", e);
    }
})();
function $fc5da5e9381479b5$var$c(d, t, e = {}) {
    const o = document.createElement(d);
    Array.isArray(t) ? o.classList.add(...t) : t && o.classList.add(t);
    for(const i in e)Object.prototype.hasOwnProperty.call(e, i) && (o[i] = e[i]);
    return o;
}
function $fc5da5e9381479b5$var$f(d) {
    const t = d.getBoundingClientRect();
    return {
        y1: Math.floor(t.top + window.pageYOffset),
        x1: Math.floor(t.left + window.pageXOffset),
        x2: Math.floor(t.right + window.pageXOffset),
        y2: Math.floor(t.bottom + window.pageYOffset)
    };
}
function $fc5da5e9381479b5$var$g(d, t) {
    const e = $fc5da5e9381479b5$var$f(d), o = $fc5da5e9381479b5$var$f(t);
    return {
        fromTopBorder: o.y1 - e.y1,
        fromLeftBorder: o.x1 - e.x1,
        fromRightBorder: e.x2 - o.x2,
        fromBottomBorder: e.y2 - o.y2
    };
}
function $fc5da5e9381479b5$var$k(d, t) {
    const e = d.getBoundingClientRect(), { width: o, height: i, x: n, y: r } = e, { clientX: h, clientY: l } = t;
    return {
        width: o,
        height: i,
        x: h - n,
        y: l - r
    };
}
function $fc5da5e9381479b5$var$m(d, t) {
    return t.parentNode.insertBefore(d, t);
}
function $fc5da5e9381479b5$var$C(d, t = !0) {
    const e = document.createRange(), o = window.getSelection();
    e.selectNodeContents(d), e.collapse(t), o.removeAllRanges(), o.addRange(e);
}
class $fc5da5e9381479b5$var$a {
    /**
   * @param {object} options - constructor options
   * @param {PopoverItem[]} options.items - constructor options
   */ constructor({ items: t }){
        this.items = t, this.wrapper = void 0, this.itemEls = [];
    }
    /**
   * Set of CSS classnames used in popover
   *
   * @returns {object}
   */ static get CSS() {
        return {
            popover: "tc-popover",
            popoverOpened: "tc-popover--opened",
            item: "tc-popover__item",
            itemHidden: "tc-popover__item--hidden",
            itemConfirmState: "tc-popover__item--confirm",
            itemIcon: "tc-popover__item-icon",
            itemLabel: "tc-popover__item-label"
        };
    }
    /**
   * Returns the popover element
   *
   * @returns {Element}
   */ render() {
        return this.wrapper = $fc5da5e9381479b5$var$c("div", $fc5da5e9381479b5$var$a.CSS.popover), this.items.forEach((t, e)=>{
            const o = $fc5da5e9381479b5$var$c("div", $fc5da5e9381479b5$var$a.CSS.item), i = $fc5da5e9381479b5$var$c("div", $fc5da5e9381479b5$var$a.CSS.itemIcon, {
                innerHTML: t.icon
            }), n = $fc5da5e9381479b5$var$c("div", $fc5da5e9381479b5$var$a.CSS.itemLabel, {
                textContent: t.label
            });
            o.dataset.index = e, o.appendChild(i), o.appendChild(n), this.wrapper.appendChild(o), this.itemEls.push(o);
        }), this.wrapper.addEventListener("click", (t)=>{
            this.popoverClicked(t);
        }), this.wrapper;
    }
    /**
   * Popover wrapper click listener
   * Used to delegate clicks in items
   *
   * @returns {void}
   */ popoverClicked(t) {
        const e = t.target.closest(`.${$fc5da5e9381479b5$var$a.CSS.item}`);
        if (!e) return;
        const o = e.dataset.index, i = this.items[o];
        if (i.confirmationRequired && !this.hasConfirmationState(e)) {
            this.setConfirmationState(e);
            return;
        }
        i.onClick();
    }
    /**
   * Enable the confirmation state on passed item
   *
   * @returns {void}
   */ setConfirmationState(t) {
        t.classList.add($fc5da5e9381479b5$var$a.CSS.itemConfirmState);
    }
    /**
   * Disable the confirmation state on passed item
   *
   * @returns {void}
   */ clearConfirmationState(t) {
        t.classList.remove($fc5da5e9381479b5$var$a.CSS.itemConfirmState);
    }
    /**
   * Check if passed item has the confirmation state
   *
   * @returns {boolean}
   */ hasConfirmationState(t) {
        return t.classList.contains($fc5da5e9381479b5$var$a.CSS.itemConfirmState);
    }
    /**
   * Return an opening state
   *
   * @returns {boolean}
   */ get opened() {
        return this.wrapper.classList.contains($fc5da5e9381479b5$var$a.CSS.popoverOpened);
    }
    /**
   * Opens the popover
   *
   * @returns {void}
   */ open() {
        this.items.forEach((t, e)=>{
            typeof t.hideIf == "function" && this.itemEls[e].classList.toggle($fc5da5e9381479b5$var$a.CSS.itemHidden, t.hideIf());
        }), this.wrapper.classList.add($fc5da5e9381479b5$var$a.CSS.popoverOpened);
    }
    /**
   * Closes the popover
   *
   * @returns {void}
   */ close() {
        this.wrapper.classList.remove($fc5da5e9381479b5$var$a.CSS.popoverOpened), this.itemEls.forEach((t)=>{
            this.clearConfirmationState(t);
        });
    }
}
const $fc5da5e9381479b5$var$R = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 9L10 12M10 12L7 15M10 12H4"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 9L14 12M14 12L17 15M14 12H20"/></svg>', $fc5da5e9381479b5$var$b = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M8 8L12 12M12 12L16 16M12 12L16 8M12 12L8 16"/></svg>', $fc5da5e9381479b5$var$x = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.8833 9.16666L18.2167 12.5M18.2167 12.5L14.8833 15.8333M18.2167 12.5H10.05C9.16594 12.5 8.31809 12.1488 7.69297 11.5237C7.06785 10.8986 6.71666 10.0507 6.71666 9.16666"/></svg>', $fc5da5e9381479b5$var$S = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.9167 14.9167L11.5833 18.25M11.5833 18.25L8.25 14.9167M11.5833 18.25L11.5833 10.0833C11.5833 9.19928 11.9345 8.35143 12.5596 7.72631C13.1848 7.10119 14.0326 6.75 14.9167 6.75"/></svg>', $fc5da5e9381479b5$var$y = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.13333 14.9167L12.4667 18.25M12.4667 18.25L15.8 14.9167M12.4667 18.25L12.4667 10.0833C12.4667 9.19928 12.1155 8.35143 11.4904 7.72631C10.8652 7.10119 10.0174 6.75 9.13333 6.75"/></svg>', $fc5da5e9381479b5$var$L = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.8833 15.8333L18.2167 12.5M18.2167 12.5L14.8833 9.16667M18.2167 12.5L10.05 12.5C9.16595 12.5 8.31811 12.8512 7.69299 13.4763C7.06787 14.1014 6.71667 14.9493 6.71667 15.8333"/></svg>', $fc5da5e9381479b5$var$M = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M9.41 9.66H9.4"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M14.6 9.66H14.59"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M9.31 14.36H9.3"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M14.6 14.36H14.59"/></svg>', $fc5da5e9381479b5$var$v = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M12 7V12M12 17V12M17 12H12M12 12H7"/></svg>', $fc5da5e9381479b5$var$O = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 9L20 12L17 15"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 12H20"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 9L4 12L7 15"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 12H10"/></svg>', $fc5da5e9381479b5$var$T = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-width="2" d="M5 10H19"/><rect width="14" height="14" x="5" y="5" stroke="currentColor" stroke-width="2" rx="4"/></svg>', $fc5da5e9381479b5$var$H = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-width="2" d="M10 5V18.5"/><path stroke="currentColor" stroke-width="2" d="M14 5V18.5"/><path stroke="currentColor" stroke-width="2" d="M5 10H19"/><path stroke="currentColor" stroke-width="2" d="M5 14H19"/><rect width="14" height="14" x="5" y="5" stroke="currentColor" stroke-width="2" rx="4"/></svg>', $fc5da5e9381479b5$var$A = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-width="2" d="M10 5V18.5"/><path stroke="currentColor" stroke-width="2" d="M5 10H19"/><rect width="14" height="14" x="5" y="5" stroke="currentColor" stroke-width="2" rx="4"/></svg>';
class $fc5da5e9381479b5$var$w {
    /**
   * Creates toolbox buttons and toolbox menus
   *
   * @param {Object} config
   * @param {any} config.api - Editor.js api
   * @param {PopoverItem[]} config.items - Editor.js api
   * @param {function} config.onOpen - callback fired when the Popover is opening
   * @param {function} config.onClose - callback fired when the Popover is closing
   * @param {string} config.cssModifier - the modifier for the Toolbox. Allows to add some specific styles.
   */ constructor({ api: t, items: e, onOpen: o, onClose: i, cssModifier: n = "" }){
        this.api = t, this.items = e, this.onOpen = o, this.onClose = i, this.cssModifier = n, this.popover = null, this.wrapper = this.createToolbox();
    }
    /**
   * Style classes
   */ static get CSS() {
        return {
            toolbox: "tc-toolbox",
            toolboxShowed: "tc-toolbox--showed",
            toggler: "tc-toolbox__toggler"
        };
    }
    /**
   * Returns rendered Toolbox element
   */ get element() {
        return this.wrapper;
    }
    /**
   * Creating a toolbox to open menu for a manipulating columns
   *
   * @returns {Element}
   */ createToolbox() {
        const t = $fc5da5e9381479b5$var$c("div", [
            $fc5da5e9381479b5$var$w.CSS.toolbox,
            this.cssModifier ? `${$fc5da5e9381479b5$var$w.CSS.toolbox}--${this.cssModifier}` : ""
        ]);
        t.dataset.mutationFree = "true";
        const e = this.createPopover(), o = this.createToggler();
        return t.appendChild(o), t.appendChild(e), t;
    }
    /**
   * Creates the Toggler
   *
   * @returns {Element}
   */ createToggler() {
        const t = $fc5da5e9381479b5$var$c("div", $fc5da5e9381479b5$var$w.CSS.toggler, {
            innerHTML: $fc5da5e9381479b5$var$M
        });
        return t.addEventListener("click", ()=>{
            this.togglerClicked();
        }), t;
    }
    /**
   * Creates the Popover instance and render it
   *
   * @returns {Element}
   */ createPopover() {
        return this.popover = new $fc5da5e9381479b5$var$a({
            items: this.items
        }), this.popover.render();
    }
    /**
   * Toggler click handler. Opens/Closes the popover
   *
   * @returns {void}
   */ togglerClicked() {
        this.popover.opened ? (this.popover.close(), this.onClose()) : (this.popover.open(), this.onOpen());
    }
    /**
   * Shows the Toolbox
   *
   * @param {function} computePositionMethod - method that returns the position coordinate
   * @returns {void}
   */ show(t) {
        const e = t();
        Object.entries(e).forEach(([o, i])=>{
            this.wrapper.style[o] = i;
        }), this.wrapper.classList.add($fc5da5e9381479b5$var$w.CSS.toolboxShowed);
    }
    /**
   * Hides the Toolbox
   *
   * @returns {void}
   */ hide() {
        this.popover.close(), this.wrapper.classList.remove($fc5da5e9381479b5$var$w.CSS.toolboxShowed);
    }
}
function $fc5da5e9381479b5$var$B(d, t) {
    let e = 0;
    return function(...o) {
        const i = /* @__PURE__ */ new Date().getTime();
        if (!(i - e < d)) return e = i, t(...o);
    };
}
const $fc5da5e9381479b5$var$s = {
    wrapper: "tc-wrap",
    wrapperReadOnly: "tc-wrap--readonly",
    table: "tc-table",
    row: "tc-row",
    withHeadings: "tc-table--heading",
    rowSelected: "tc-row--selected",
    cell: "tc-cell",
    cellSelected: "tc-cell--selected",
    addRow: "tc-add-row",
    addRowDisabled: "tc-add-row--disabled",
    addColumn: "tc-add-column",
    addColumnDisabled: "tc-add-column--disabled"
};
class $fc5da5e9381479b5$var$E {
    /**
   * Creates
   *
   * @constructor
   * @param {boolean} readOnly - read-only mode flag
   * @param {object} api - Editor.js API
   * @param {TableData} data - Editor.js API
   * @param {TableConfig} config - Editor.js API
   */ constructor(t, e, o, i){
        this.readOnly = t, this.api = e, this.data = o, this.config = i, this.wrapper = null, this.table = null, this.toolboxColumn = this.createColumnToolbox(), this.toolboxRow = this.createRowToolbox(), this.createTableWrapper(), this.hoveredRow = 0, this.hoveredColumn = 0, this.selectedRow = 0, this.selectedColumn = 0, this.tunes = {
            withHeadings: !1
        }, this.resize(), this.fill(), this.focusedCell = {
            row: 0,
            column: 0
        }, this.documentClicked = (n)=>{
            const r = n.target.closest(`.${$fc5da5e9381479b5$var$s.table}`) !== null, h = n.target.closest(`.${$fc5da5e9381479b5$var$s.wrapper}`) === null;
            (r || h) && this.hideToolboxes();
            const u = n.target.closest(`.${$fc5da5e9381479b5$var$s.addRow}`), p = n.target.closest(`.${$fc5da5e9381479b5$var$s.addColumn}`);
            u && u.parentNode === this.wrapper ? (this.addRow(void 0, !0), this.hideToolboxes()) : p && p.parentNode === this.wrapper && (this.addColumn(void 0, !0), this.hideToolboxes());
        }, this.readOnly || this.bindEvents();
    }
    /**
   * Returns the rendered table wrapper
   *
   * @returns {Element}
   */ getWrapper() {
        return this.wrapper;
    }
    /**
   * Hangs the necessary handlers to events
   */ bindEvents() {
        document.addEventListener("click", this.documentClicked), this.table.addEventListener("mousemove", $fc5da5e9381479b5$var$B(150, (t)=>this.onMouseMoveInTable(t)), {
            passive: !0
        }), this.table.onkeypress = (t)=>this.onKeyPressListener(t), this.table.addEventListener("keydown", (t)=>this.onKeyDownListener(t)), this.table.addEventListener("focusin", (t)=>this.focusInTableListener(t));
    }
    /**
   * Configures and creates the toolbox for manipulating with columns
   *
   * @returns {Toolbox}
   */ createColumnToolbox() {
        return new $fc5da5e9381479b5$var$w({
            api: this.api,
            cssModifier: "column",
            items: [
                {
                    label: this.api.i18n.t("Add column to left"),
                    icon: $fc5da5e9381479b5$var$S,
                    hideIf: ()=>this.numberOfColumns === this.config.maxcols,
                    onClick: ()=>{
                        this.addColumn(this.selectedColumn, !0), this.hideToolboxes();
                    }
                },
                {
                    label: this.api.i18n.t("Add column to right"),
                    icon: $fc5da5e9381479b5$var$y,
                    hideIf: ()=>this.numberOfColumns === this.config.maxcols,
                    onClick: ()=>{
                        this.addColumn(this.selectedColumn + 1, !0), this.hideToolboxes();
                    }
                },
                {
                    label: this.api.i18n.t("Delete column"),
                    icon: $fc5da5e9381479b5$var$b,
                    hideIf: ()=>this.numberOfColumns === 1,
                    confirmationRequired: !0,
                    onClick: ()=>{
                        this.deleteColumn(this.selectedColumn), this.hideToolboxes();
                    }
                }
            ],
            onOpen: ()=>{
                this.selectColumn(this.hoveredColumn), this.hideRowToolbox();
            },
            onClose: ()=>{
                this.unselectColumn();
            }
        });
    }
    /**
   * Configures and creates the toolbox for manipulating with rows
   *
   * @returns {Toolbox}
   */ createRowToolbox() {
        return new $fc5da5e9381479b5$var$w({
            api: this.api,
            cssModifier: "row",
            items: [
                {
                    label: this.api.i18n.t("Add row above"),
                    icon: $fc5da5e9381479b5$var$L,
                    hideIf: ()=>this.numberOfRows === this.config.maxrows,
                    onClick: ()=>{
                        this.addRow(this.selectedRow, !0), this.hideToolboxes();
                    }
                },
                {
                    label: this.api.i18n.t("Add row below"),
                    icon: $fc5da5e9381479b5$var$x,
                    hideIf: ()=>this.numberOfRows === this.config.maxrows,
                    onClick: ()=>{
                        this.addRow(this.selectedRow + 1, !0), this.hideToolboxes();
                    }
                },
                {
                    label: this.api.i18n.t("Delete row"),
                    icon: $fc5da5e9381479b5$var$b,
                    hideIf: ()=>this.numberOfRows === 1,
                    confirmationRequired: !0,
                    onClick: ()=>{
                        this.deleteRow(this.selectedRow), this.hideToolboxes();
                    }
                }
            ],
            onOpen: ()=>{
                this.selectRow(this.hoveredRow), this.hideColumnToolbox();
            },
            onClose: ()=>{
                this.unselectRow();
            }
        });
    }
    /**
   * When you press enter it moves the cursor down to the next row
   * or creates it if the click occurred on the last one
   */ moveCursorToNextRow() {
        this.focusedCell.row !== this.numberOfRows ? (this.focusedCell.row += 1, this.focusCell(this.focusedCell)) : (this.addRow(), this.focusedCell.row += 1, this.focusCell(this.focusedCell), this.updateToolboxesPosition(0, 0));
    }
    /**
   * Get table cell by row and col index
   *
   * @param {number} row - cell row coordinate
   * @param {number} column - cell column coordinate
   * @returns {HTMLElement}
   */ getCell(t, e) {
        return this.table.querySelectorAll(`.${$fc5da5e9381479b5$var$s.row}:nth-child(${t}) .${$fc5da5e9381479b5$var$s.cell}`)[e - 1];
    }
    /**
   * Get table row by index
   *
   * @param {number} row - row coordinate
   * @returns {HTMLElement}
   */ getRow(t) {
        return this.table.querySelector(`.${$fc5da5e9381479b5$var$s.row}:nth-child(${t})`);
    }
    /**
   * The parent of the cell which is the row
   *
   * @param {HTMLElement} cell - cell element
   * @returns {HTMLElement}
   */ getRowByCell(t) {
        return t.parentElement;
    }
    /**
   * Ger row's first cell
   *
   * @param {Element} row - row to find its first cell
   * @returns {Element}
   */ getRowFirstCell(t) {
        return t.querySelector(`.${$fc5da5e9381479b5$var$s.cell}:first-child`);
    }
    /**
   * Set the sell's content by row and column numbers
   *
   * @param {number} row - cell row coordinate
   * @param {number} column - cell column coordinate
   * @param {string} content - cell HTML content
   */ setCellContent(t, e, o) {
        const i = this.getCell(t, e);
        i.innerHTML = o;
    }
    /**
   * Add column in table on index place
   * Add cells in each row
   *
   * @param {number} columnIndex - number in the array of columns, where new column to insert, -1 if insert at the end
   * @param {boolean} [setFocus] - pass true to focus the first cell
   */ addColumn(t = -1, e = !1) {
        var n;
        let o = this.numberOfColumns;
        if (this.config && this.config.maxcols && this.numberOfColumns >= this.config.maxcols) return;
        for(let r = 1; r <= this.numberOfRows; r++){
            let h;
            const l = this.createCell();
            if (t > 0 && t <= o ? (h = this.getCell(r, t), $fc5da5e9381479b5$var$m(l, h)) : h = this.getRow(r).appendChild(l), r === 1) {
                const u = this.getCell(r, t > 0 ? t : o + 1);
                u && e && $fc5da5e9381479b5$var$C(u);
            }
        }
        const i = this.wrapper.querySelector(`.${$fc5da5e9381479b5$var$s.addColumn}`);
        (n = this.config) != null && n.maxcols && this.numberOfColumns > this.config.maxcols - 1 && i && i.classList.add($fc5da5e9381479b5$var$s.addColumnDisabled), this.addHeadingAttrToFirstRow();
    }
    /**
   * Add row in table on index place
   *
   * @param {number} index - number in the array of rows, where new column to insert, -1 if insert at the end
   * @param {boolean} [setFocus] - pass true to focus the inserted row
   * @returns {HTMLElement} row
   */ addRow(t = -1, e = !1) {
        let o, i = $fc5da5e9381479b5$var$c("div", $fc5da5e9381479b5$var$s.row);
        this.tunes.withHeadings && this.removeHeadingAttrFromFirstRow();
        let n = this.numberOfColumns;
        if (this.config && this.config.maxrows && this.numberOfRows >= this.config.maxrows && h) return;
        if (t > 0 && t <= this.numberOfRows) {
            let l = this.getRow(t);
            o = $fc5da5e9381479b5$var$m(i, l);
        } else o = this.table.appendChild(i);
        this.fillRow(o, n), this.tunes.withHeadings && this.addHeadingAttrToFirstRow();
        const r = this.getRowFirstCell(o);
        r && e && $fc5da5e9381479b5$var$C(r);
        const h = this.wrapper.querySelector(`.${$fc5da5e9381479b5$var$s.addRow}`);
        return this.config && this.config.maxrows && this.numberOfRows >= this.config.maxrows && h && h.classList.add($fc5da5e9381479b5$var$s.addRowDisabled), o;
    }
    /**
   * Delete a column by index
   *
   * @param {number} index
   */ deleteColumn(t) {
        for(let o = 1; o <= this.numberOfRows; o++){
            const i = this.getCell(o, t);
            if (!i) return;
            i.remove();
        }
        const e = this.wrapper.querySelector(`.${$fc5da5e9381479b5$var$s.addColumn}`);
        e && e.classList.remove($fc5da5e9381479b5$var$s.addColumnDisabled);
    }
    /**
   * Delete a row by index
   *
   * @param {number} index
   */ deleteRow(t) {
        this.getRow(t).remove();
        const e = this.wrapper.querySelector(`.${$fc5da5e9381479b5$var$s.addRow}`);
        e && e.classList.remove($fc5da5e9381479b5$var$s.addRowDisabled), this.addHeadingAttrToFirstRow();
    }
    /**
   * Create a wrapper containing a table, toolboxes
   * and buttons for adding rows and columns
   *
   * @returns {HTMLElement} wrapper - where all buttons for a table and the table itself will be
   */ createTableWrapper() {
        if (this.wrapper = $fc5da5e9381479b5$var$c("div", $fc5da5e9381479b5$var$s.wrapper), this.table = $fc5da5e9381479b5$var$c("div", $fc5da5e9381479b5$var$s.table), this.readOnly && this.wrapper.classList.add($fc5da5e9381479b5$var$s.wrapperReadOnly), this.wrapper.appendChild(this.toolboxRow.element), this.wrapper.appendChild(this.toolboxColumn.element), this.wrapper.appendChild(this.table), !this.readOnly) {
            const t = $fc5da5e9381479b5$var$c("div", $fc5da5e9381479b5$var$s.addColumn, {
                innerHTML: $fc5da5e9381479b5$var$v
            }), e = $fc5da5e9381479b5$var$c("div", $fc5da5e9381479b5$var$s.addRow, {
                innerHTML: $fc5da5e9381479b5$var$v
            });
            this.wrapper.appendChild(t), this.wrapper.appendChild(e);
        }
    }
    /**
   * Returns the size of the table based on initial data or config "size" property
   *
   * @return {{rows: number, cols: number}} - number of cols and rows
   */ computeInitialSize() {
        const t = this.data && this.data.content, e = Array.isArray(t), o = e ? t.length : !1, i = e ? t.length : void 0, n = o ? t[0].length : void 0, r = Number.parseInt(this.config && this.config.rows), h = Number.parseInt(this.config && this.config.cols), l = !isNaN(r) && r > 0 ? r : void 0, u = !isNaN(h) && h > 0 ? h : void 0;
        return {
            rows: i || l || 2,
            cols: n || u || 2
        };
    }
    /**
   * Resize table to match config size or transmitted data size
   *
   * @return {{rows: number, cols: number}} - number of cols and rows
   */ resize() {
        const { rows: t, cols: e } = this.computeInitialSize();
        for(let o = 0; o < t; o++)this.addRow();
        for(let o = 0; o < e; o++)this.addColumn();
    }
    /**
   * Fills the table with data passed to the constructor
   *
   * @returns {void}
   */ fill() {
        const t = this.data;
        if (t && t.content) for(let e = 0; e < t.content.length; e++)for(let o = 0; o < t.content[e].length; o++)this.setCellContent(e + 1, o + 1, t.content[e][o]);
    }
    /**
   * Fills a row with cells
   *
   * @param {HTMLElement} row - row to fill
   * @param {number} numberOfColumns - how many cells should be in a row
   */ fillRow(t, e) {
        for(let o = 1; o <= e; o++){
            const i = this.createCell();
            t.appendChild(i);
        }
    }
    /**
   * Creating a cell element
   *
   * @return {Element}
   */ createCell() {
        return $fc5da5e9381479b5$var$c("div", $fc5da5e9381479b5$var$s.cell, {
            contentEditable: !this.readOnly
        });
    }
    /**
   * Get number of rows in the table
   */ get numberOfRows() {
        return this.table.childElementCount;
    }
    /**
   * Get number of columns in the table
   */ get numberOfColumns() {
        return this.numberOfRows ? this.table.querySelectorAll(`.${$fc5da5e9381479b5$var$s.row}:first-child .${$fc5da5e9381479b5$var$s.cell}`).length : 0;
    }
    /**
   * Is the column toolbox menu displayed or not
   *
   * @returns {boolean}
   */ get isColumnMenuShowing() {
        return this.selectedColumn !== 0;
    }
    /**
   * Is the row toolbox menu displayed or not
   *
   * @returns {boolean}
   */ get isRowMenuShowing() {
        return this.selectedRow !== 0;
    }
    /**
   * Recalculate position of toolbox icons
   *
   * @param {Event} event - mouse move event
   */ onMouseMoveInTable(t) {
        const { row: e, column: o } = this.getHoveredCell(t);
        this.hoveredColumn = o, this.hoveredRow = e, this.updateToolboxesPosition();
    }
    /**
   * Prevents default Enter behaviors
   * Adds Shift+Enter processing
   *
   * @param {KeyboardEvent} event - keypress event
   */ onKeyPressListener(t) {
        if (t.key === "Enter") {
            if (t.shiftKey) return !0;
            this.moveCursorToNextRow();
        }
        return t.key !== "Enter";
    }
    /**
   * Prevents tab keydown event from bubbling
   * so that it only works inside the table
   *
   * @param {KeyboardEvent} event - keydown event
   */ onKeyDownListener(t) {
        t.key === "Tab" && t.stopPropagation();
    }
    /**
   * Set the coordinates of the cell that the focus has moved to
   *
   * @param {FocusEvent} event - focusin event
   */ focusInTableListener(t) {
        const e = t.target, o = this.getRowByCell(e);
        this.focusedCell = {
            row: Array.from(this.table.querySelectorAll(`.${$fc5da5e9381479b5$var$s.row}`)).indexOf(o) + 1,
            column: Array.from(o.querySelectorAll(`.${$fc5da5e9381479b5$var$s.cell}`)).indexOf(e) + 1
        };
    }
    /**
   * Unselect row/column
   * Close toolbox menu
   * Hide toolboxes
   *
   * @returns {void}
   */ hideToolboxes() {
        this.hideRowToolbox(), this.hideColumnToolbox(), this.updateToolboxesPosition();
    }
    /**
   * Unselect row, close toolbox
   *
   * @returns {void}
   */ hideRowToolbox() {
        this.unselectRow(), this.toolboxRow.hide();
    }
    /**
   * Unselect column, close toolbox
   *
   * @returns {void}
   */ hideColumnToolbox() {
        this.unselectColumn(), this.toolboxColumn.hide();
    }
    /**
   * Set the cursor focus to the focused cell
   *
   * @returns {void}
   */ focusCell() {
        this.focusedCellElem.focus();
    }
    /**
   * Get current focused element
   *
   * @returns {HTMLElement} - focused cell
   */ get focusedCellElem() {
        const { row: t, column: e } = this.focusedCell;
        return this.getCell(t, e);
    }
    /**
   * Update toolboxes position
   *
   * @param {number} row - hovered row
   * @param {number} column - hovered column
   */ updateToolboxesPosition(t = this.hoveredRow, e = this.hoveredColumn) {
        this.isColumnMenuShowing || e > 0 && e <= this.numberOfColumns && this.toolboxColumn.show(()=>({
                left: `calc((100% - var(--cell-size)) / (${this.numberOfColumns} * 2) * (1 + (${e} - 1) * 2))`
            })), this.isRowMenuShowing || t > 0 && t <= this.numberOfRows && this.toolboxRow.show(()=>{
            const o = this.getRow(t), { fromTopBorder: i } = $fc5da5e9381479b5$var$g(this.table, o), { height: n } = o.getBoundingClientRect();
            return {
                top: `${Math.ceil(i + n / 2)}px`
            };
        });
    }
    /**
   * Makes the first row headings
   *
   * @param {boolean} withHeadings - use headings row or not
   */ setHeadingsSetting(t) {
        this.tunes.withHeadings = t, t ? (this.table.classList.add($fc5da5e9381479b5$var$s.withHeadings), this.addHeadingAttrToFirstRow()) : (this.table.classList.remove($fc5da5e9381479b5$var$s.withHeadings), this.removeHeadingAttrFromFirstRow());
    }
    /**
   * Adds an attribute for displaying the placeholder in the cell
   */ addHeadingAttrToFirstRow() {
        for(let t = 1; t <= this.numberOfColumns; t++){
            let e = this.getCell(1, t);
            e && e.setAttribute("heading", this.api.i18n.t("Heading"));
        }
    }
    /**
   * Removes an attribute for displaying the placeholder in the cell
   */ removeHeadingAttrFromFirstRow() {
        for(let t = 1; t <= this.numberOfColumns; t++){
            let e = this.getCell(1, t);
            e && e.removeAttribute("heading");
        }
    }
    /**
   * Add effect of a selected row
   *
   * @param {number} index
   */ selectRow(t) {
        const e = this.getRow(t);
        e && (this.selectedRow = t, e.classList.add($fc5da5e9381479b5$var$s.rowSelected));
    }
    /**
   * Remove effect of a selected row
   */ unselectRow() {
        if (this.selectedRow <= 0) return;
        const t = this.table.querySelector(`.${$fc5da5e9381479b5$var$s.rowSelected}`);
        t && t.classList.remove($fc5da5e9381479b5$var$s.rowSelected), this.selectedRow = 0;
    }
    /**
   * Add effect of a selected column
   *
   * @param {number} index
   */ selectColumn(t) {
        for(let e = 1; e <= this.numberOfRows; e++){
            const o = this.getCell(e, t);
            o && o.classList.add($fc5da5e9381479b5$var$s.cellSelected);
        }
        this.selectedColumn = t;
    }
    /**
   * Remove effect of a selected column
   */ unselectColumn() {
        if (this.selectedColumn <= 0) return;
        let t = this.table.querySelectorAll(`.${$fc5da5e9381479b5$var$s.cellSelected}`);
        Array.from(t).forEach((e)=>{
            e.classList.remove($fc5da5e9381479b5$var$s.cellSelected);
        }), this.selectedColumn = 0;
    }
    /**
   * Calculates the row and column that the cursor is currently hovering over
   * The search was optimized from O(n) to O (log n) via bin search to reduce the number of calculations
   *
   * @param {Event} event - mousemove event
   * @returns hovered cell coordinates as an integer row and column
   */ getHoveredCell(t) {
        let e = this.hoveredRow, o = this.hoveredColumn;
        const { width: i, height: n, x: r, y: h } = $fc5da5e9381479b5$var$k(this.table, t);
        return r >= 0 && (o = this.binSearch(this.numberOfColumns, (l)=>this.getCell(1, l), ({ fromLeftBorder: l })=>r < l, ({ fromRightBorder: l })=>r > i - l)), h >= 0 && (e = this.binSearch(this.numberOfRows, (l)=>this.getCell(l, 1), ({ fromTopBorder: l })=>h < l, ({ fromBottomBorder: l })=>h > n - l)), {
            row: e || this.hoveredRow,
            column: o || this.hoveredColumn
        };
    }
    /**
   * Looks for the index of the cell the mouse is hovering over.
   * Cells can be represented as ordered intervals with left and
   * right (upper and lower for rows) borders inside the table, if the mouse enters it, then this is our index
   *
   * @param {number} numberOfCells - upper bound of binary search
   * @param {function} getCell - function to take the currently viewed cell
   * @param {function} beforeTheLeftBorder - determines the cursor position, to the left of the cell or not
   * @param {function} afterTheRightBorder - determines the cursor position, to the right of the cell or not
   * @returns {number}
   */ binSearch(t, e, o, i) {
        let n = 0, r = t + 1, h = 0, l;
        for(; n < r - 1 && h < 10;){
            l = Math.ceil((n + r) / 2);
            const u = e(l), p = $fc5da5e9381479b5$var$g(this.table, u);
            if (o(p)) r = l;
            else if (i(p)) n = l;
            else break;
            h++;
        }
        return l;
    }
    /**
   * Collects data from cells into a two-dimensional array
   *
   * @returns {string[][]}
   */ getData() {
        const t = [];
        for(let e = 1; e <= this.numberOfRows; e++){
            const o = this.table.querySelector(`.${$fc5da5e9381479b5$var$s.row}:nth-child(${e})`), i = Array.from(o.querySelectorAll(`.${$fc5da5e9381479b5$var$s.cell}`));
            i.every((r)=>!r.textContent.trim()) || t.push(i.map((r)=>r.innerHTML));
        }
        return t;
    }
    /**
   * Remove listeners on the document
   */ destroy() {
        document.removeEventListener("click", this.documentClicked);
    }
}
class $fc5da5e9381479b5$export$2e2bcd8739ae039 {
    /**
   * Notify core that read-only mode is supported
   *
   * @returns {boolean}
   */ static get isReadOnlySupported() {
        return !0;
    }
    /**
   * Allow to press Enter inside the CodeTool textarea
   *
   * @returns {boolean}
   * @public
   */ static get enableLineBreaks() {
        return !0;
    }
    /**
   * Render plugin`s main Element and fill it with saved data
   *
   * @param {TableConstructor} init
   */ constructor({ data: t, config: e, api: o, readOnly: i, block: n }){
        this.api = o, this.readOnly = i, this.config = e, this.data = {
            withHeadings: this.getConfig("withHeadings", !1, t),
            stretched: this.getConfig("stretched", !1, t),
            content: t && t.content ? t.content : []
        }, this.table = null, this.block = n;
    }
    /**
   * Get Tool toolbox settings
   * icon - Tool icon's SVG
   * title - title to show in toolbox
   *
   * @returns {{icon: string, title: string}}
   */ static get toolbox() {
        return {
            icon: $fc5da5e9381479b5$var$A,
            title: "Table"
        };
    }
    /**
   * Return Tool's view
   *
   * @returns {HTMLDivElement}
   */ render() {
        return this.table = new $fc5da5e9381479b5$var$E(this.readOnly, this.api, this.data, this.config), this.container = $fc5da5e9381479b5$var$c("div", this.api.styles.block), this.container.appendChild(this.table.getWrapper()), this.table.setHeadingsSetting(this.data.withHeadings), this.container;
    }
    /**
   * Returns plugin settings
   *
   * @returns {Array}
   */ renderSettings() {
        return [
            {
                label: this.api.i18n.t("With headings"),
                icon: $fc5da5e9381479b5$var$T,
                isActive: this.data.withHeadings,
                closeOnActivate: !0,
                toggle: !0,
                onActivate: ()=>{
                    this.data.withHeadings = !0, this.table.setHeadingsSetting(this.data.withHeadings);
                }
            },
            {
                label: this.api.i18n.t("Without headings"),
                icon: $fc5da5e9381479b5$var$H,
                isActive: !this.data.withHeadings,
                closeOnActivate: !0,
                toggle: !0,
                onActivate: ()=>{
                    this.data.withHeadings = !1, this.table.setHeadingsSetting(this.data.withHeadings);
                }
            },
            {
                label: this.data.stretched ? this.api.i18n.t("Collapse") : this.api.i18n.t("Stretch"),
                icon: this.data.stretched ? $fc5da5e9381479b5$var$R : $fc5da5e9381479b5$var$O,
                closeOnActivate: !0,
                toggle: !0,
                onActivate: ()=>{
                    this.data.stretched = !this.data.stretched, this.block.stretched = this.data.stretched;
                }
            }
        ];
    }
    /**
   * Extract table data from the view
   *
   * @returns {TableData} - saved data
   */ save() {
        const t = this.table.getData();
        return {
            withHeadings: this.data.withHeadings,
            stretched: this.data.stretched,
            content: t
        };
    }
    /**
   * Plugin destroyer
   *
   * @returns {void}
   */ destroy() {
        this.table.destroy();
    }
    /**
   * A helper to get config value.
   *
   * @param {string} configName - the key to get from the config.
   * @param {any} defaultValue - default value if config doesn't have passed key
   * @param {object} savedData - previously saved data. If passed, the key will be got from there, otherwise from the config
   * @returns {any} - config value.
   */ getConfig(t, e, o) {
        const i = this.data || o;
        return i ? i[t] ? i[t] : e : this.config && this.config[t] ? this.config[t] : e;
    }
    /**
   * Table onPaste configuration
   *
   * @public
   */ static get pasteConfig() {
        return {
            tags: [
                "TABLE",
                "TR",
                "TH",
                "TD"
            ]
        };
    }
    /**
   * On paste callback that is fired from Editor
   *
   * @param {PasteEvent} event - event with pasted data
   */ onPaste(t) {
        const e = t.detail.data, o = e.querySelector(":scope > thead, tr:first-of-type th"), n = Array.from(e.querySelectorAll("tr")).map((r)=>Array.from(r.querySelectorAll("th, td")).map((l)=>l.innerHTML));
        this.data = {
            withHeadings: o !== null,
            content: n
        }, this.table.wrapper && this.table.wrapper.replaceWith(this.render());
    }
}

});

parcelRegister("1FAXH", function(module, exports) {

$parcel$export(module.exports, "default", () => $9185db81b0545c88$export$2e2bcd8739ae039);
(function() {
    "use strict";
    try {
        if (typeof document < "u") {
            var o = document.createElement("style");
            o.appendChild(document.createTextNode(`.link-tool{position:relative}.link-tool__input{padding-left:38px;background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath stroke='%23707684' stroke-linecap='round' stroke-width='2' d='m7.7 12.6-.021.02a2.795 2.795 0 0 0-.044 4.005v0a2.795 2.795 0 0 0 3.936.006l1.455-1.438a3 3 0 0 0 .34-3.866l-.146-.207'/%3E%3Cpath stroke='%23707684' stroke-linecap='round' stroke-width='2' d='m16.22 11.12.136-.14c.933-.954.992-2.46.135-3.483v0a2.597 2.597 0 0 0-3.664-.32L11.39 8.386a3 3 0 0 0-.301 4.3l.031.034'/%3E%3C/svg%3E");background-repeat:no-repeat;background-position:10px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.link-tool__input-holder{position:relative}.link-tool__input-holder--error .link-tool__input{background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath stroke='rgb(224, 147, 147)' stroke-linecap='round' stroke-width='2' d='m7.7 12.6-.021.02a2.795 2.795 0 0 0-.044 4.005v0a2.795 2.795 0 0 0 3.936.006l1.455-1.438a3 3 0 0 0 .34-3.866l-.146-.207'/%3E%3Cpath stroke='rgb(224, 147, 147)' stroke-linecap='round' stroke-width='2' d='m16.22 11.12.136-.14c.933-.954.992-2.46.135-3.483v0a2.597 2.597 0 0 0-3.664-.32L11.39 8.386a3 3 0 0 0-.301 4.3l.031.034'/%3E%3C/svg%3E");background-color:#fff3f6;border-color:#f3e0e0;color:#a95a5a;box-shadow:inset 0 1px 3px #923e3e0d}.link-tool__input[contentEditable=true][data-placeholder]:before{position:absolute;content:attr(data-placeholder);color:#707684;font-weight:400;opacity:0}.link-tool__input[contentEditable=true][data-placeholder]:empty:before{opacity:1}.link-tool__input[contentEditable=true][data-placeholder]:empty:focus:before{opacity:0}.link-tool__progress{position:absolute;box-shadow:inset 0 1px 3px #66556b0a;height:100%;width:0;background-color:#f4f5f7;z-index:-1}.link-tool__progress--loading{-webkit-animation:progress .5s ease-in;-webkit-animation-fill-mode:forwards}.link-tool__progress--loaded{width:100%}.link-tool__content{display:block;padding:25px;border-radius:2px;box-shadow:0 0 0 2px #fff;color:initial!important;text-decoration:none!important}.link-tool__content:after{content:"";clear:both;display:table}.link-tool__content--rendered{background:#fff;border:1px solid rgba(201,201,204,.48);box-shadow:0 1px 3px #0000001a;border-radius:6px;will-change:filter;animation:link-in .45s 1 cubic-bezier(.215,.61,.355,1)}.link-tool__content--rendered:hover{box-shadow:0 0 3px #00000029}.link-tool__image{background-position:center center;background-repeat:no-repeat;background-size:cover;margin:0 0 0 30px;width:65px;height:65px;border-radius:3px;float:right}.link-tool__title{font-size:17px;font-weight:600;line-height:1.5em;margin:0 0 10px}.link-tool__title+.link-tool__anchor{margin-top:25px}.link-tool__description{margin:0 0 20px;font-size:15px;line-height:1.55em;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden}.link-tool__anchor{display:block;font-size:15px;line-height:1em;color:#888!important;border:0!important;padding:0!important}@keyframes link-in{0%{filter:blur(5px)}to{filter:none}}.codex-editor--narrow .link-tool__image{display:none}@-webkit-keyframes progress{0%{width:0}to{width:85%}}`)), document.head.appendChild(o);
        }
    } catch (t) {
        console.error("vite-plugin-css-injected-by-js", t);
    }
})();
var $9185db81b0545c88$var$C = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof $parcel$global < "u" ? $parcel$global : typeof self < "u" ? self : {};
function $9185db81b0545c88$var$O(k) {
    return k && k.__esModule && Object.prototype.hasOwnProperty.call(k, "default") ? k.default : k;
}
(function(k) {
    var w = function() {
        try {
            return !!Symbol.iterator;
        } catch  {
            return !1;
        }
    }, d = w(), v = function(n) {
        var o = {
            next: function() {
                var e = n.shift();
                return {
                    done: e === void 0,
                    value: e
                };
            }
        };
        return d && (o[Symbol.iterator] = function() {
            return o;
        }), o;
    }, c = function(n) {
        return encodeURIComponent(n).replace(/%20/g, "+");
    }, i = function(n) {
        return decodeURIComponent(String(n).replace(/\+/g, " "));
    }, a = function() {
        var n = function(e) {
            Object.defineProperty(this, "_entries", {
                writable: !0,
                value: {}
            });
            var s = typeof e;
            if (s !== "undefined") {
                if (s === "string") e !== "" && this._fromString(e);
                else if (e instanceof n) {
                    var h = this;
                    e.forEach(function(u, f) {
                        h.append(f, u);
                    });
                } else if (e !== null && s === "object") {
                    if (Object.prototype.toString.call(e) === "[object Array]") for(var t = 0; t < e.length; t++){
                        var y = e[t];
                        if (Object.prototype.toString.call(y) === "[object Array]" || y.length !== 2) this.append(y[0], y[1]);
                        else throw new TypeError("Expected [string, any] as entry at index " + t + " of URLSearchParams's input");
                    }
                    else for(var r in e)e.hasOwnProperty(r) && this.append(r, e[r]);
                } else throw new TypeError("Unsupported input's type for URLSearchParams");
            }
        }, o = n.prototype;
        o.append = function(e, s) {
            e in this._entries ? this._entries[e].push(String(s)) : this._entries[e] = [
                String(s)
            ];
        }, o.delete = function(e) {
            delete this._entries[e];
        }, o.get = function(e) {
            return e in this._entries ? this._entries[e][0] : null;
        }, o.getAll = function(e) {
            return e in this._entries ? this._entries[e].slice(0) : [];
        }, o.has = function(e) {
            return e in this._entries;
        }, o.set = function(e, s) {
            this._entries[e] = [
                String(s)
            ];
        }, o.forEach = function(e, s) {
            var h;
            for(var t in this._entries)if (this._entries.hasOwnProperty(t)) {
                h = this._entries[t];
                for(var y = 0; y < h.length; y++)e.call(s, h[y], t, this);
            }
        }, o.keys = function() {
            var e = [];
            return this.forEach(function(s, h) {
                e.push(h);
            }), v(e);
        }, o.values = function() {
            var e = [];
            return this.forEach(function(s) {
                e.push(s);
            }), v(e);
        }, o.entries = function() {
            var e = [];
            return this.forEach(function(s, h) {
                e.push([
                    h,
                    s
                ]);
            }), v(e);
        }, d && (o[Symbol.iterator] = o.entries), o.toString = function() {
            var e = [];
            return this.forEach(function(s, h) {
                e.push(c(h) + "=" + c(s));
            }), e.join("&");
        }, k.URLSearchParams = n;
    }, p = function() {
        try {
            var n = k.URLSearchParams;
            return new n("?a=1").toString() === "a=1" && typeof n.prototype.set == "function";
        } catch  {
            return !1;
        }
    };
    p() || a();
    var l = k.URLSearchParams.prototype;
    typeof l.sort != "function" && (l.sort = function() {
        var n = this, o = [];
        this.forEach(function(s, h) {
            o.push([
                h,
                s
            ]), n._entries || n.delete(h);
        }), o.sort(function(s, h) {
            return s[0] < h[0] ? -1 : s[0] > h[0] ? 1 : 0;
        }), n._entries && (n._entries = {});
        for(var e = 0; e < o.length; e++)this.append(o[e][0], o[e][1]);
    }), typeof l._fromString != "function" && Object.defineProperty(l, "_fromString", {
        enumerable: !1,
        configurable: !1,
        writable: !1,
        value: function(n) {
            if (this._entries) this._entries = {};
            else {
                var o = [];
                this.forEach(function(t, y) {
                    o.push(y);
                });
                for(var e = 0; e < o.length; e++)this.delete(o[e]);
            }
            n = n.replace(/^\?/, "");
            for(var s = n.split("&"), h, e = 0; e < s.length; e++)h = s[e].split("="), this.append(i(h[0]), h.length > 1 ? i(h[1]) : "");
        }
    });
})(typeof $9185db81b0545c88$var$C < "u" ? $9185db81b0545c88$var$C : typeof window < "u" ? window : typeof self < "u" ? self : $9185db81b0545c88$var$C);
(function(k) {
    var w = function() {
        try {
            var c = new k.URL("b", "http://a");
            return c.pathname = "c d", c.href === "http://a/c%20d" && c.searchParams;
        } catch  {
            return !1;
        }
    }, d = function() {
        var c = k.URL, i = function(l, n) {
            typeof l != "string" && (l = String(l));
            var o = document, e;
            if (n && (k.location === void 0 || n !== k.location.href)) {
                o = document.implementation.createHTMLDocument(""), e = o.createElement("base"), e.href = n, o.head.appendChild(e);
                try {
                    if (e.href.indexOf(n) !== 0) throw new Error(e.href);
                } catch (m) {
                    throw new Error("URL unable to set base " + n + " due to " + m);
                }
            }
            var s = o.createElement("a");
            s.href = l, e && (o.body.appendChild(s), s.href = s.href);
            var h = o.createElement("input");
            if (h.type = "url", h.value = l, s.protocol === ":" || !/:/.test(s.href) || !h.checkValidity() && !n) throw new TypeError("Invalid URL");
            Object.defineProperty(this, "_anchorElement", {
                value: s
            });
            var t = new k.URLSearchParams(this.search), y = !0, r = !0, u = this;
            [
                "append",
                "delete",
                "set"
            ].forEach(function(m) {
                var b = t[m];
                t[m] = function() {
                    b.apply(t, arguments), y && (r = !1, u.search = t.toString(), r = !0);
                };
            }), Object.defineProperty(this, "searchParams", {
                value: t,
                enumerable: !0
            });
            var f = void 0;
            Object.defineProperty(this, "_updateSearchParams", {
                enumerable: !1,
                configurable: !1,
                writable: !1,
                value: function() {
                    this.search !== f && (f = this.search, r && (y = !1, this.searchParams._fromString(this.search), y = !0));
                }
            });
        }, a = i.prototype, p = function(l) {
            Object.defineProperty(a, l, {
                get: function() {
                    return this._anchorElement[l];
                },
                set: function(n) {
                    this._anchorElement[l] = n;
                },
                enumerable: !0
            });
        };
        [
            "hash",
            "host",
            "hostname",
            "port",
            "protocol"
        ].forEach(function(l) {
            p(l);
        }), Object.defineProperty(a, "search", {
            get: function() {
                return this._anchorElement.search;
            },
            set: function(l) {
                this._anchorElement.search = l, this._updateSearchParams();
            },
            enumerable: !0
        }), Object.defineProperties(a, {
            toString: {
                get: function() {
                    var l = this;
                    return function() {
                        return l.href;
                    };
                }
            },
            href: {
                get: function() {
                    return this._anchorElement.href.replace(/\?$/, "");
                },
                set: function(l) {
                    this._anchorElement.href = l, this._updateSearchParams();
                },
                enumerable: !0
            },
            pathname: {
                get: function() {
                    return this._anchorElement.pathname.replace(/(^\/?)/, "/");
                },
                set: function(l) {
                    this._anchorElement.pathname = l;
                },
                enumerable: !0
            },
            origin: {
                get: function() {
                    var l = {
                        "http:": 80,
                        "https:": 443,
                        "ftp:": 21
                    }[this._anchorElement.protocol], n = this._anchorElement.port != l && this._anchorElement.port !== "";
                    return this._anchorElement.protocol + "//" + this._anchorElement.hostname + (n ? ":" + this._anchorElement.port : "");
                },
                enumerable: !0
            },
            password: {
                // TODO
                get: function() {
                    return "";
                },
                set: function(l) {},
                enumerable: !0
            },
            username: {
                // TODO
                get: function() {
                    return "";
                },
                set: function(l) {},
                enumerable: !0
            }
        }), i.createObjectURL = function(l) {
            return c.createObjectURL.apply(c, arguments);
        }, i.revokeObjectURL = function(l) {
            return c.revokeObjectURL.apply(c, arguments);
        }, k.URL = i;
    };
    if (w() || d(), k.location !== void 0 && !("origin" in k.location)) {
        var v = function() {
            return k.location.protocol + "//" + k.location.hostname + (k.location.port ? ":" + k.location.port : "");
        };
        try {
            Object.defineProperty(k.location, "origin", {
                get: v,
                enumerable: !0
            });
        } catch  {
            setInterval(function() {
                k.location.origin = v();
            }, 100);
        }
    }
})(typeof $9185db81b0545c88$var$C < "u" ? $9185db81b0545c88$var$C : typeof window < "u" ? window : typeof self < "u" ? self : $9185db81b0545c88$var$C);
var $9185db81b0545c88$var$j = {
    exports: {}
};
(function(k, w) {
    (function(d, v) {
        k.exports = v();
    })(window, function() {
        return function(d) {
            var v = {};
            function c(i) {
                if (v[i]) return v[i].exports;
                var a = v[i] = {
                    i: i,
                    l: !1,
                    exports: {}
                };
                return d[i].call(a.exports, a, a.exports, c), a.l = !0, a.exports;
            }
            return c.m = d, c.c = v, c.d = function(i, a, p) {
                c.o(i, a) || Object.defineProperty(i, a, {
                    enumerable: !0,
                    get: p
                });
            }, c.r = function(i) {
                typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(i, Symbol.toStringTag, {
                    value: "Module"
                }), Object.defineProperty(i, "__esModule", {
                    value: !0
                });
            }, c.t = function(i, a) {
                if (1 & a && (i = c(i)), 8 & a || 4 & a && typeof i == "object" && i && i.__esModule) return i;
                var p = /* @__PURE__ */ Object.create(null);
                if (c.r(p), Object.defineProperty(p, "default", {
                    enumerable: !0,
                    value: i
                }), 2 & a && typeof i != "string") for(var l in i)c.d(p, l, (function(n) {
                    return i[n];
                }).bind(null, l));
                return p;
            }, c.n = function(i) {
                var a = i && i.__esModule ? function() {
                    return i.default;
                } : function() {
                    return i;
                };
                return c.d(a, "a", a), a;
            }, c.o = function(i, a) {
                return Object.prototype.hasOwnProperty.call(i, a);
            }, c.p = "", c(c.s = 3);
        }([
            function(d, v) {
                var c;
                c = function() {
                    return this;
                }();
                try {
                    c = c || new Function("return this")();
                } catch  {
                    typeof window == "object" && (c = window);
                }
                d.exports = c;
            },
            function(d, v, c) {
                (function(i) {
                    var a = c(2), p = setTimeout;
                    function l() {}
                    function n(r) {
                        if (!(this instanceof n)) throw new TypeError("Promises must be constructed via new");
                        if (typeof r != "function") throw new TypeError("not a function");
                        this._state = 0, this._handled = !1, this._value = void 0, this._deferreds = [], y(r, this);
                    }
                    function o(r, u) {
                        for(; r._state === 3;)r = r._value;
                        r._state !== 0 ? (r._handled = !0, n._immediateFn(function() {
                            var f = r._state === 1 ? u.onFulfilled : u.onRejected;
                            if (f !== null) {
                                var m;
                                try {
                                    m = f(r._value);
                                } catch (b) {
                                    return void s(u.promise, b);
                                }
                                e(u.promise, m);
                            } else (r._state === 1 ? e : s)(u.promise, r._value);
                        })) : r._deferreds.push(u);
                    }
                    function e(r, u) {
                        try {
                            if (u === r) throw new TypeError("A promise cannot be resolved with itself.");
                            if (u && (typeof u == "object" || typeof u == "function")) {
                                var f = u.then;
                                if (u instanceof n) return r._state = 3, r._value = u, void h(r);
                                if (typeof f == "function") return void y((m = f, b = u, function() {
                                    m.apply(b, arguments);
                                }), r);
                            }
                            r._state = 1, r._value = u, h(r);
                        } catch (g) {
                            s(r, g);
                        }
                        var m, b;
                    }
                    function s(r, u) {
                        r._state = 2, r._value = u, h(r);
                    }
                    function h(r) {
                        r._state === 2 && r._deferreds.length === 0 && n._immediateFn(function() {
                            r._handled || n._unhandledRejectionFn(r._value);
                        });
                        for(var u = 0, f = r._deferreds.length; u < f; u++)o(r, r._deferreds[u]);
                        r._deferreds = null;
                    }
                    function t(r, u, f) {
                        this.onFulfilled = typeof r == "function" ? r : null, this.onRejected = typeof u == "function" ? u : null, this.promise = f;
                    }
                    function y(r, u) {
                        var f = !1;
                        try {
                            r(function(m) {
                                f || (f = !0, e(u, m));
                            }, function(m) {
                                f || (f = !0, s(u, m));
                            });
                        } catch (m) {
                            if (f) return;
                            f = !0, s(u, m);
                        }
                    }
                    n.prototype.catch = function(r) {
                        return this.then(null, r);
                    }, n.prototype.then = function(r, u) {
                        var f = new this.constructor(l);
                        return o(this, new t(r, u, f)), f;
                    }, n.prototype.finally = a.a, n.all = function(r) {
                        return new n(function(u, f) {
                            if (!r || r.length === void 0) throw new TypeError("Promise.all accepts an array");
                            var m = Array.prototype.slice.call(r);
                            if (m.length === 0) return u([]);
                            var b = m.length;
                            function g(T, E) {
                                try {
                                    if (E && (typeof E == "object" || typeof E == "function")) {
                                        var S = E.then;
                                        if (typeof S == "function") return void S.call(E, function(L) {
                                            g(T, L);
                                        }, f);
                                    }
                                    m[T] = E, --b == 0 && u(m);
                                } catch (L) {
                                    f(L);
                                }
                            }
                            for(var _ = 0; _ < m.length; _++)g(_, m[_]);
                        });
                    }, n.resolve = function(r) {
                        return r && typeof r == "object" && r.constructor === n ? r : new n(function(u) {
                            u(r);
                        });
                    }, n.reject = function(r) {
                        return new n(function(u, f) {
                            f(r);
                        });
                    }, n.race = function(r) {
                        return new n(function(u, f) {
                            for(var m = 0, b = r.length; m < b; m++)r[m].then(u, f);
                        });
                    }, n._immediateFn = typeof i == "function" && function(r) {
                        i(r);
                    } || function(r) {
                        p(r, 0);
                    }, n._unhandledRejectionFn = function(r) {
                        typeof console < "u" && console && console.warn("Possible Unhandled Promise Rejection:", r);
                    }, v.a = n;
                }).call(this, c(5).setImmediate);
            },
            function(d, v, c) {
                v.a = function(i) {
                    var a = this.constructor;
                    return this.then(function(p) {
                        return a.resolve(i()).then(function() {
                            return p;
                        });
                    }, function(p) {
                        return a.resolve(i()).then(function() {
                            return a.reject(p);
                        });
                    });
                };
            },
            function(d, v, c) {
                function i(t) {
                    return (i = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(y) {
                        return typeof y;
                    } : function(y) {
                        return y && typeof Symbol == "function" && y.constructor === Symbol && y !== Symbol.prototype ? "symbol" : typeof y;
                    })(t);
                }
                c(4);
                var a, p, l, n, o, e, s = c(8), h = (p = function(t) {
                    return new Promise(function(y, r) {
                        t = n(t), t = o(t);
                        var u = window.XMLHttpRequest ? new window.XMLHttpRequest() : new window.ActiveXObject("Microsoft.XMLHTTP");
                        u.open(t.method, t.url), u.setRequestHeader("X-Requested-With", "XMLHttpRequest"), Object.keys(t.headers).forEach(function(m) {
                            var b = t.headers[m];
                            u.setRequestHeader(m, b);
                        });
                        var f = t.ratio;
                        u.upload.addEventListener("progress", function(m) {
                            var b = Math.round(m.loaded / m.total * 100), g = Math.ceil(b * f / 100);
                            t.progress(g);
                        }, !1), u.addEventListener("progress", function(m) {
                            var b = Math.round(m.loaded / m.total * 100), g = Math.ceil(b * (100 - f) / 100) + f;
                            t.progress(g);
                        }, !1), u.onreadystatechange = function() {
                            if (u.readyState === 4) {
                                var m = u.response;
                                try {
                                    m = JSON.parse(m);
                                } catch  {}
                                var b = s.parseHeaders(u.getAllResponseHeaders()), g = {
                                    body: m,
                                    code: u.status,
                                    headers: b
                                };
                                u.status === 200 ? y(g) : r(g);
                            }
                        }, u.send(t.data);
                    });
                }, l = function(t) {
                    return t.method = "POST", p(t);
                }, n = function() {
                    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                    if (t.url && typeof t.url != "string") throw new Error("Url must be a string");
                    if (t.url = t.url || "", t.method && typeof t.method != "string") throw new Error("`method` must be a string or null");
                    if (t.method = t.method ? t.method.toUpperCase() : "GET", t.headers && i(t.headers) !== "object") throw new Error("`headers` must be an object or null");
                    if (t.headers = t.headers || {}, t.type && (typeof t.type != "string" || !Object.values(a).includes(t.type))) throw new Error("`type` must be taken from module's \xabcontentType\xbb library");
                    if (t.progress && typeof t.progress != "function") throw new Error("`progress` must be a function or null");
                    if (t.progress = t.progress || function(y) {}, t.beforeSend = t.beforeSend || function(y) {}, t.ratio && typeof t.ratio != "number") throw new Error("`ratio` must be a number");
                    if (t.ratio < 0 || t.ratio > 100) throw new Error("`ratio` must be in a 0-100 interval");
                    if (t.ratio = t.ratio || 90, t.accept && typeof t.accept != "string") throw new Error("`accept` must be a string with a list of allowed mime-types");
                    if (t.accept = t.accept || "*/*", t.multiple && typeof t.multiple != "boolean") throw new Error("`multiple` must be a true or false");
                    if (t.multiple = t.multiple || !1, t.fieldName && typeof t.fieldName != "string") throw new Error("`fieldName` must be a string");
                    return t.fieldName = t.fieldName || "files", t;
                }, o = function(t) {
                    switch(t.method){
                        case "GET":
                            var y = e(t.data, a.URLENCODED);
                            delete t.data, t.url = /\?/.test(t.url) ? t.url + "&" + y : t.url + "?" + y;
                            break;
                        case "POST":
                        case "PUT":
                        case "DELETE":
                        case "UPDATE":
                            var r = function() {
                                return (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).type || a.JSON;
                            }(t);
                            (s.isFormData(t.data) || s.isFormElement(t.data)) && (r = a.FORM), t.data = e(t.data, r), r !== h.contentType.FORM && (t.headers["content-type"] = r);
                    }
                    return t;
                }, e = function() {
                    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                    switch(arguments.length > 1 ? arguments[1] : void 0){
                        case a.URLENCODED:
                            return s.urlEncode(t);
                        case a.JSON:
                            return s.jsonEncode(t);
                        case a.FORM:
                            return s.formEncode(t);
                        default:
                            return t;
                    }
                }, {
                    contentType: a = {
                        URLENCODED: "application/x-www-form-urlencoded; charset=utf-8",
                        FORM: "multipart/form-data",
                        JSON: "application/json; charset=utf-8"
                    },
                    request: p,
                    get: function(t) {
                        return t.method = "GET", p(t);
                    },
                    post: l,
                    transport: function(t) {
                        return t = n(t), s.selectFiles(t).then(function(y) {
                            for(var r = new FormData(), u = 0; u < y.length; u++)r.append(t.fieldName, y[u], y[u].name);
                            return s.isObject(t.data) && Object.keys(t.data).forEach(function(f) {
                                var m = t.data[f];
                                r.append(f, m);
                            }), t.beforeSend && t.beforeSend(y), t.data = r, l(t);
                        });
                    },
                    selectFiles: function(t) {
                        return delete (t = n(t)).beforeSend, s.selectFiles(t);
                    }
                });
                d.exports = h;
            },
            function(d, v, c) {
                c.r(v);
                var i = c(1);
                window.Promise = window.Promise || i.a;
            },
            function(d, v, c) {
                (function(i) {
                    var a = i !== void 0 && i || typeof self < "u" && self || window, p = Function.prototype.apply;
                    function l(n, o) {
                        this._id = n, this._clearFn = o;
                    }
                    v.setTimeout = function() {
                        return new l(p.call(setTimeout, a, arguments), clearTimeout);
                    }, v.setInterval = function() {
                        return new l(p.call(setInterval, a, arguments), clearInterval);
                    }, v.clearTimeout = v.clearInterval = function(n) {
                        n && n.close();
                    }, l.prototype.unref = l.prototype.ref = function() {}, l.prototype.close = function() {
                        this._clearFn.call(a, this._id);
                    }, v.enroll = function(n, o) {
                        clearTimeout(n._idleTimeoutId), n._idleTimeout = o;
                    }, v.unenroll = function(n) {
                        clearTimeout(n._idleTimeoutId), n._idleTimeout = -1;
                    }, v._unrefActive = v.active = function(n) {
                        clearTimeout(n._idleTimeoutId);
                        var o = n._idleTimeout;
                        o >= 0 && (n._idleTimeoutId = setTimeout(function() {
                            n._onTimeout && n._onTimeout();
                        }, o));
                    }, c(6), v.setImmediate = typeof self < "u" && self.setImmediate || i !== void 0 && i.setImmediate || this && this.setImmediate, v.clearImmediate = typeof self < "u" && self.clearImmediate || i !== void 0 && i.clearImmediate || this && this.clearImmediate;
                }).call(this, c(0));
            },
            function(d, v, c) {
                (function(i, a) {
                    (function(p, l) {
                        if (!p.setImmediate) {
                            var n, o, e, s, h, t = 1, y = {}, r = !1, u = p.document, f = Object.getPrototypeOf && Object.getPrototypeOf(p);
                            f = f && f.setTimeout ? f : p, ({}).toString.call(p.process) === "[object process]" ? n = function(g) {
                                a.nextTick(function() {
                                    b(g);
                                });
                            } : function() {
                                if (p.postMessage && !p.importScripts) {
                                    var g = !0, _ = p.onmessage;
                                    return p.onmessage = function() {
                                        g = !1;
                                    }, p.postMessage("", "*"), p.onmessage = _, g;
                                }
                            }() ? (s = "setImmediate$" + Math.random() + "$", h = function(g) {
                                g.source === p && typeof g.data == "string" && g.data.indexOf(s) === 0 && b(+g.data.slice(s.length));
                            }, p.addEventListener ? p.addEventListener("message", h, !1) : p.attachEvent("onmessage", h), n = function(g) {
                                p.postMessage(s + g, "*");
                            }) : p.MessageChannel ? ((e = new MessageChannel()).port1.onmessage = function(g) {
                                b(g.data);
                            }, n = function(g) {
                                e.port2.postMessage(g);
                            }) : u && "onreadystatechange" in u.createElement("script") ? (o = u.documentElement, n = function(g) {
                                var _ = u.createElement("script");
                                _.onreadystatechange = function() {
                                    b(g), _.onreadystatechange = null, o.removeChild(_), _ = null;
                                }, o.appendChild(_);
                            }) : n = function(g) {
                                setTimeout(b, 0, g);
                            }, f.setImmediate = function(g) {
                                typeof g != "function" && (g = new Function("" + g));
                                for(var _ = new Array(arguments.length - 1), T = 0; T < _.length; T++)_[T] = arguments[T + 1];
                                var E = {
                                    callback: g,
                                    args: _
                                };
                                return y[t] = E, n(t), t++;
                            }, f.clearImmediate = m;
                        }
                        function m(g) {
                            delete y[g];
                        }
                        function b(g) {
                            if (r) setTimeout(b, 0, g);
                            else {
                                var _ = y[g];
                                if (_) {
                                    r = !0;
                                    try {
                                        (function(T) {
                                            var E = T.callback, S = T.args;
                                            switch(S.length){
                                                case 0:
                                                    E();
                                                    break;
                                                case 1:
                                                    E(S[0]);
                                                    break;
                                                case 2:
                                                    E(S[0], S[1]);
                                                    break;
                                                case 3:
                                                    E(S[0], S[1], S[2]);
                                                    break;
                                                default:
                                                    E.apply(l, S);
                                            }
                                        })(_);
                                    } finally{
                                        m(g), r = !1;
                                    }
                                }
                            }
                        }
                    })(typeof self > "u" ? i === void 0 ? this : i : self);
                }).call(this, c(0), c(7));
            },
            function(d, v) {
                var c, i, a = d.exports = {};
                function p() {
                    throw new Error("setTimeout has not been defined");
                }
                function l() {
                    throw new Error("clearTimeout has not been defined");
                }
                function n(f) {
                    if (c === setTimeout) return setTimeout(f, 0);
                    if ((c === p || !c) && setTimeout) return c = setTimeout, setTimeout(f, 0);
                    try {
                        return c(f, 0);
                    } catch  {
                        try {
                            return c.call(null, f, 0);
                        } catch  {
                            return c.call(this, f, 0);
                        }
                    }
                }
                (function() {
                    try {
                        c = typeof setTimeout == "function" ? setTimeout : p;
                    } catch  {
                        c = p;
                    }
                    try {
                        i = typeof clearTimeout == "function" ? clearTimeout : l;
                    } catch  {
                        i = l;
                    }
                })();
                var o, e = [], s = !1, h = -1;
                function t() {
                    s && o && (s = !1, o.length ? e = o.concat(e) : h = -1, e.length && y());
                }
                function y() {
                    if (!s) {
                        var f = n(t);
                        s = !0;
                        for(var m = e.length; m;){
                            for(o = e, e = []; ++h < m;)o && o[h].run();
                            h = -1, m = e.length;
                        }
                        o = null, s = !1, function(b) {
                            if (i === clearTimeout) return clearTimeout(b);
                            if ((i === l || !i) && clearTimeout) return i = clearTimeout, clearTimeout(b);
                            try {
                                i(b);
                            } catch  {
                                try {
                                    return i.call(null, b);
                                } catch  {
                                    return i.call(this, b);
                                }
                            }
                        }(f);
                    }
                }
                function r(f, m) {
                    this.fun = f, this.array = m;
                }
                function u() {}
                a.nextTick = function(f) {
                    var m = new Array(arguments.length - 1);
                    if (arguments.length > 1) for(var b = 1; b < arguments.length; b++)m[b - 1] = arguments[b];
                    e.push(new r(f, m)), e.length !== 1 || s || n(y);
                }, r.prototype.run = function() {
                    this.fun.apply(null, this.array);
                }, a.title = "browser", a.browser = !0, a.env = {}, a.argv = [], a.version = "", a.versions = {}, a.on = u, a.addListener = u, a.once = u, a.off = u, a.removeListener = u, a.removeAllListeners = u, a.emit = u, a.prependListener = u, a.prependOnceListener = u, a.listeners = function(f) {
                    return [];
                }, a.binding = function(f) {
                    throw new Error("process.binding is not supported");
                }, a.cwd = function() {
                    return "/";
                }, a.chdir = function(f) {
                    throw new Error("process.chdir is not supported");
                }, a.umask = function() {
                    return 0;
                };
            },
            function(d, v, c) {
                function i(p, l) {
                    for(var n = 0; n < l.length; n++){
                        var o = l[n];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(p, o.key, o);
                    }
                }
                var a = c(9);
                d.exports = function() {
                    function p() {
                        (function(e, s) {
                            if (!(e instanceof s)) throw new TypeError("Cannot call a class as a function");
                        })(this, p);
                    }
                    var l, n, o;
                    return l = p, o = [
                        {
                            key: "urlEncode",
                            value: function(e) {
                                return a(e);
                            }
                        },
                        {
                            key: "jsonEncode",
                            value: function(e) {
                                return JSON.stringify(e);
                            }
                        },
                        {
                            key: "formEncode",
                            value: function(e) {
                                if (this.isFormData(e)) return e;
                                if (this.isFormElement(e)) return new FormData(e);
                                if (this.isObject(e)) {
                                    var s = new FormData();
                                    return Object.keys(e).forEach(function(h) {
                                        var t = e[h];
                                        s.append(h, t);
                                    }), s;
                                }
                                throw new Error("`data` must be an instance of Object, FormData or <FORM> HTMLElement");
                            }
                        },
                        {
                            key: "isObject",
                            value: function(e) {
                                return Object.prototype.toString.call(e) === "[object Object]";
                            }
                        },
                        {
                            key: "isFormData",
                            value: function(e) {
                                return e instanceof FormData;
                            }
                        },
                        {
                            key: "isFormElement",
                            value: function(e) {
                                return e instanceof HTMLFormElement;
                            }
                        },
                        {
                            key: "selectFiles",
                            value: function() {
                                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                                return new Promise(function(s, h) {
                                    var t = document.createElement("INPUT");
                                    t.type = "file", e.multiple && t.setAttribute("multiple", "multiple"), e.accept && t.setAttribute("accept", e.accept), t.style.display = "none", document.body.appendChild(t), t.addEventListener("change", function(y) {
                                        var r = y.target.files;
                                        s(r), document.body.removeChild(t);
                                    }, !1), t.click();
                                });
                            }
                        },
                        {
                            key: "parseHeaders",
                            value: function(e) {
                                var s = e.trim().split(/[\r\n]+/), h = {};
                                return s.forEach(function(t) {
                                    var y = t.split(": "), r = y.shift(), u = y.join(": ");
                                    r && (h[r] = u);
                                }), h;
                            }
                        }
                    ], n = null, o && i(l, o), p;
                }();
            },
            function(d, v) {
                var c = function(a) {
                    return encodeURIComponent(a).replace(/[!'()*]/g, escape).replace(/%20/g, "+");
                }, i = function(a, p, l, n) {
                    return p = p || null, l = l || "&", n = n || null, a ? (function(o) {
                        for(var e = new Array(), s = 0; s < o.length; s++)o[s] && e.push(o[s]);
                        return e;
                    })(Object.keys(a).map(function(o) {
                        var e, s, h = o;
                        if (n && (h = n + "[" + h + "]"), typeof a[o] == "object" && a[o] !== null) e = i(a[o], null, l, h);
                        else {
                            p && (s = h, h = !isNaN(parseFloat(s)) && isFinite(s) ? p + Number(h) : h);
                            var t = a[o];
                            t = (t = (t = (t = t === !0 ? "1" : t) === !1 ? "0" : t) === 0 ? "0" : t) || "", e = c(h) + "=" + c(t);
                        }
                        return e;
                    })).join(l).replace(/[!'()*]/g, "") : "";
                };
                d.exports = i;
            }
        ]);
    });
})($9185db81b0545c88$var$j);
var $9185db81b0545c88$var$P = $9185db81b0545c88$var$j.exports;
const $9185db81b0545c88$var$R = /* @__PURE__ */ $9185db81b0545c88$var$O($9185db81b0545c88$var$P), $9185db81b0545c88$var$F = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M7.69998 12.6L7.67896 12.62C6.53993 13.7048 6.52012 15.5155 7.63516 16.625V16.625C8.72293 17.7073 10.4799 17.7102 11.5712 16.6314L13.0263 15.193C14.0703 14.1609 14.2141 12.525 13.3662 11.3266L13.22 11.12"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M16.22 11.12L16.3564 10.9805C17.2895 10.0265 17.3478 8.5207 16.4914 7.49733V7.49733C15.569 6.39509 13.9269 6.25143 12.8271 7.17675L11.39 8.38588C10.0935 9.47674 9.95704 11.4241 11.0887 12.6852L11.12 12.72"/></svg>';
class $9185db81b0545c88$export$2e2bcd8739ae039 {
    /**
   * Notify core that read-only mode supported
   *
   * @returns {boolean}
   */ static get isReadOnlySupported() {
        return !0;
    }
    /**
   * Get Tool toolbox settings
   * icon - Tool icon's SVG
   * title - title to show in toolbox
   *
   * @returns {{icon: string, title: string}}
   */ static get toolbox() {
        return {
            icon: $9185db81b0545c88$var$F,
            title: "Link"
        };
    }
    /**
   * Allow to press Enter inside the LinkTool input
   *
   * @returns {boolean}
   * @public
   */ static get enableLineBreaks() {
        return !0;
    }
    /**
   * @param {object} options - Tool constructor options fot from Editor.js
   * @param {LinkToolData} options.data - previously saved data
   * @param {LinkToolConfig} options.config - user config for Tool
   * @param {object} options.api - Editor.js API
   * @param {boolean} options.readOnly - read-only mode flag
   */ constructor({ data: w, config: d, api: v, readOnly: c }){
        this.api = v, this.readOnly = c, this.config = {
            endpoint: d.endpoint || "",
            headers: d.headers || {}
        }, this.nodes = {
            wrapper: null,
            container: null,
            progress: null,
            input: null,
            inputHolder: null,
            linkContent: null,
            linkImage: null,
            linkTitle: null,
            linkDescription: null,
            linkText: null
        }, this._data = {
            link: "",
            meta: {}
        }, this.data = w;
    }
    /**
   * Renders Block content
   *
   * @public
   *
   * @returns {HTMLDivElement}
   */ render() {
        return this.nodes.wrapper = this.make("div", this.CSS.baseClass), this.nodes.container = this.make("div", this.CSS.container), this.nodes.inputHolder = this.makeInputHolder(), this.nodes.linkContent = this.prepareLinkPreview(), Object.keys(this.data.meta).length ? (this.nodes.container.appendChild(this.nodes.linkContent), this.showLinkPreview(this.data.meta)) : this.nodes.container.appendChild(this.nodes.inputHolder), this.nodes.wrapper.appendChild(this.nodes.container), this.nodes.wrapper;
    }
    /**
   * Return Block data
   *
   * @public
   *
   * @returns {LinkToolData}
   */ save() {
        return this.data;
    }
    /**
   * Validate Block data
   * - check if given link is an empty string or not.
   *
   * @public
   *
   * @returns {boolean} false if saved data is incorrect, otherwise true
   */ validate() {
        return this.data.link.trim() !== "";
    }
    /**
   * Stores all Tool's data
   *
   * @param {LinkToolData} data - data to store
   */ set data(w) {
        this._data = Object.assign({}, {
            link: w.link || this._data.link,
            meta: w.meta || this._data.meta
        });
    }
    /**
   * Return Tool data
   *
   * @returns {LinkToolData}
   */ get data() {
        return this._data;
    }
    /**
   * @returns {object} - Link Tool styles
   */ get CSS() {
        return {
            baseClass: this.api.styles.block,
            input: this.api.styles.input,
            /**
       * Tool's classes
       */ container: "link-tool",
            inputEl: "link-tool__input",
            inputHolder: "link-tool__input-holder",
            inputError: "link-tool__input-holder--error",
            linkContent: "link-tool__content",
            linkContentRendered: "link-tool__content--rendered",
            linkImage: "link-tool__image",
            linkTitle: "link-tool__title",
            linkDescription: "link-tool__description",
            linkText: "link-tool__anchor",
            progress: "link-tool__progress",
            progressLoading: "link-tool__progress--loading",
            progressLoaded: "link-tool__progress--loaded"
        };
    }
    /**
   * Prepare input holder
   *
   * @returns {HTMLElement}
   */ makeInputHolder() {
        const w = this.make("div", this.CSS.inputHolder);
        return this.nodes.progress = this.make("label", this.CSS.progress), this.nodes.input = this.make("div", [
            this.CSS.input,
            this.CSS.inputEl
        ], {
            contentEditable: !this.readOnly
        }), this.nodes.input.dataset.placeholder = this.api.i18n.t("Link"), this.readOnly || (this.nodes.input.addEventListener("paste", (d)=>{
            this.startFetching(d);
        }), this.nodes.input.addEventListener("keydown", (d)=>{
            const [v, c] = [
                13,
                65
            ], i = d.ctrlKey || d.metaKey;
            switch(d.keyCode){
                case v:
                    d.preventDefault(), d.stopPropagation(), this.startFetching(d);
                    break;
                case c:
                    i && this.selectLinkUrl(d);
                    break;
            }
        })), w.appendChild(this.nodes.progress), w.appendChild(this.nodes.input), w;
    }
    /**
   * Activates link data fetching by url
   *
   * @param {PasteEvent|KeyboardEvent} event - fetching could be fired by a pase or keydown events
   */ startFetching(w) {
        let d = this.nodes.input.textContent;
        w.type === "paste" && (d = (w.clipboardData || window.clipboardData).getData("text")), this.removeErrorStyle(), this.fetchLinkData(d);
    }
    /**
   * If previous link data fetching failed, remove error styles
   */ removeErrorStyle() {
        this.nodes.inputHolder.classList.remove(this.CSS.inputError), this.nodes.inputHolder.insertBefore(this.nodes.progress, this.nodes.input);
    }
    /**
   * Select LinkTool input content by CMD+A
   *
   * @param {KeyboardEvent} event - keydown
   */ selectLinkUrl(w) {
        w.preventDefault(), w.stopPropagation();
        const d = window.getSelection(), v = new Range(), a = d.anchorNode.parentNode.closest(`.${this.CSS.inputHolder}`).querySelector(`.${this.CSS.inputEl}`);
        v.selectNodeContents(a), d.removeAllRanges(), d.addRange(v);
    }
    /**
   * Prepare link preview holder
   *
   * @returns {HTMLElement}
   */ prepareLinkPreview() {
        const w = this.make("a", this.CSS.linkContent, {
            target: "_blank",
            rel: "nofollow noindex noreferrer"
        });
        return this.nodes.linkImage = this.make("div", this.CSS.linkImage), this.nodes.linkTitle = this.make("div", this.CSS.linkTitle), this.nodes.linkDescription = this.make("p", this.CSS.linkDescription), this.nodes.linkText = this.make("span", this.CSS.linkText), w;
    }
    /**
   * Compose link preview from fetched data
   *
   * @param {metaData} meta - link meta data
   */ showLinkPreview({ image: w, title: d, description: v }) {
        this.nodes.container.appendChild(this.nodes.linkContent), w && w.url && (this.nodes.linkImage.style.backgroundImage = "url(" + w.url + ")", this.nodes.linkContent.appendChild(this.nodes.linkImage)), d && (this.nodes.linkTitle.textContent = d, this.nodes.linkContent.appendChild(this.nodes.linkTitle)), v && (this.nodes.linkDescription.textContent = v, this.nodes.linkContent.appendChild(this.nodes.linkDescription)), this.nodes.linkContent.classList.add(this.CSS.linkContentRendered), this.nodes.linkContent.setAttribute("href", this.data.link), this.nodes.linkContent.appendChild(this.nodes.linkText);
        try {
            this.nodes.linkText.textContent = new URL(this.data.link).hostname;
        } catch  {
            this.nodes.linkText.textContent = this.data.link;
        }
    }
    /**
   * Show loading progress bar
   */ showProgress() {
        this.nodes.progress.classList.add(this.CSS.progressLoading);
    }
    /**
   * Hide loading progress bar
   *
   * @returns {Promise<void>}
   */ hideProgress() {
        return new Promise((w)=>{
            this.nodes.progress.classList.remove(this.CSS.progressLoading), this.nodes.progress.classList.add(this.CSS.progressLoaded), setTimeout(w, 500);
        });
    }
    /**
   * If data fetching failed, set input error style
   */ applyErrorStyle() {
        this.nodes.inputHolder.classList.add(this.CSS.inputError), this.nodes.progress.remove();
    }
    /**
   * Sends to backend pasted url and receives link data
   *
   * @param {string} url - link source url
   */ async fetchLinkData(w) {
        this.showProgress(), this.data = {
            link: w
        };
        try {
            const { body: d } = await $9185db81b0545c88$var$R.get({
                url: this.config.endpoint,
                headers: this.config.headers,
                data: {
                    url: w
                }
            });
            this.onFetch(d);
        } catch  {
            this.fetchingFailed(this.api.i18n.t("Couldn't fetch the link data"));
        }
    }
    /**
   * Link data fetching callback
   *
   * @param {UploadResponseFormat} response - backend response
   */ onFetch(w) {
        if (!w || !w.success) {
            this.fetchingFailed(this.api.i18n.t("Couldn't get this link data, try the other one"));
            return;
        }
        const d = w.meta, v = w.link || this.data.link;
        if (this.data = {
            meta: d,
            link: v
        }, !d) {
            this.fetchingFailed(this.api.i18n.t("Wrong response format from the server"));
            return;
        }
        this.hideProgress().then(()=>{
            this.nodes.inputHolder.remove(), this.showLinkPreview(d);
        });
    }
    /**
   * Handle link fetching errors
   *
   * @private
   *
   * @param {string} errorMessage - message to explain user what he should do
   */ fetchingFailed(w) {
        this.api.notifier.show({
            message: w,
            style: "error"
        }), this.applyErrorStyle();
    }
    /**
   * Helper method for elements creation
   *
   * @param {string} tagName - name of creating element
   * @param {string|string[]} [classNames] - list of CSS classes to add
   * @param {object} [attributes] - object with attributes to add
   * @returns {HTMLElement}
   */ make(w, d = null, v = {}) {
        const c = document.createElement(w);
        Array.isArray(d) ? c.classList.add(...d) : d && c.classList.add(d);
        for(const i in v)c[i] = v[i];
        return c;
    }
}

});

parcelRegister("f5PtS", function(module, exports) {

$parcel$export(module.exports, "default", () => $47a4b45281b81a8b$export$2e2bcd8739ae039);
var $47a4b45281b81a8b$var$pn = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof $parcel$global < "u" ? $parcel$global : typeof self < "u" ? self : {};
function $47a4b45281b81a8b$var$Zn(l) {
    return l && l.__esModule && Object.prototype.hasOwnProperty.call(l, "default") ? l.default : l;
}
var $47a4b45281b81a8b$var$Qi = {
    exports: {}
}, $47a4b45281b81a8b$var$Ue = {}, $47a4b45281b81a8b$var$tr = {}, $47a4b45281b81a8b$var$H = {};
(function(l) {
    Object.defineProperty(l, "__esModule", {
        value: !0
    }), l._registerNode = l.Konva = l.glob = void 0;
    const t = Math.PI / 180;
    function e() {
        return typeof window < "u" && (({}).toString.call(window) === "[object Window]" || ({}).toString.call(window) === "[object global]");
    }
    l.glob = typeof $47a4b45281b81a8b$var$pn < "u" ? $47a4b45281b81a8b$var$pn : typeof window < "u" ? window : typeof WorkerGlobalScope < "u" ? self : {}, l.Konva = {
        _global: l.glob,
        version: "9.3.18",
        isBrowser: e(),
        isUnminified: /param/.test((function(n) {}).toString()),
        dblClickWindow: 400,
        getAngle (n) {
            return l.Konva.angleDeg ? n * t : n;
        },
        enableTrace: !1,
        pointerEventsEnabled: !0,
        autoDrawEnabled: !0,
        hitOnDragEnabled: !1,
        capturePointerEventsEnabled: !1,
        _mouseListenClick: !1,
        _touchListenClick: !1,
        _pointerListenClick: !1,
        _mouseInDblClickWindow: !1,
        _touchInDblClickWindow: !1,
        _pointerInDblClickWindow: !1,
        _mouseDblClickPointerId: null,
        _touchDblClickPointerId: null,
        _pointerDblClickPointerId: null,
        _fixTextRendering: !1,
        pixelRatio: typeof window < "u" && window.devicePixelRatio || 1,
        dragDistance: 3,
        angleDeg: !0,
        showWarnings: !0,
        dragButtons: [
            0,
            1
        ],
        isDragging () {
            return l.Konva.DD.isDragging;
        },
        isTransforming () {
            var n;
            return (n = l.Konva.Transformer) === null || n === void 0 ? void 0 : n.isTransforming();
        },
        isDragReady () {
            return !!l.Konva.DD.node;
        },
        releaseCanvasOnDestroy: !0,
        document: l.glob.document,
        _injectGlobal (n) {
            l.glob.Konva = n;
        }
    };
    const i = (n)=>{
        l.Konva[n.prototype.getClassName()] = n;
    };
    l._registerNode = i, l.Konva._injectGlobal(l.Konva);
})($47a4b45281b81a8b$var$H);
var $47a4b45281b81a8b$var$nt = {};
(function(l) {
    Object.defineProperty(l, "__esModule", {
        value: !0
    }), l.Util = l.Transform = void 0;
    const t = $47a4b45281b81a8b$var$H;
    class e {
        constructor(p = [
            1,
            0,
            0,
            1,
            0,
            0
        ]){
            this.dirty = !1, this.m = p && p.slice() || [
                1,
                0,
                0,
                1,
                0,
                0
            ];
        }
        reset() {
            this.m[0] = 1, this.m[1] = 0, this.m[2] = 0, this.m[3] = 1, this.m[4] = 0, this.m[5] = 0;
        }
        copy() {
            return new e(this.m);
        }
        copyInto(p) {
            p.m[0] = this.m[0], p.m[1] = this.m[1], p.m[2] = this.m[2], p.m[3] = this.m[3], p.m[4] = this.m[4], p.m[5] = this.m[5];
        }
        point(p) {
            const b = this.m;
            return {
                x: b[0] * p.x + b[2] * p.y + b[4],
                y: b[1] * p.x + b[3] * p.y + b[5]
            };
        }
        translate(p, b) {
            return this.m[4] += this.m[0] * p + this.m[2] * b, this.m[5] += this.m[1] * p + this.m[3] * b, this;
        }
        scale(p, b) {
            return this.m[0] *= p, this.m[1] *= p, this.m[2] *= b, this.m[3] *= b, this;
        }
        rotate(p) {
            const b = Math.cos(p), w = Math.sin(p), P = this.m[0] * b + this.m[2] * w, S = this.m[1] * b + this.m[3] * w, E = this.m[0] * -w + this.m[2] * b, m = this.m[1] * -w + this.m[3] * b;
            return this.m[0] = P, this.m[1] = S, this.m[2] = E, this.m[3] = m, this;
        }
        getTranslation() {
            return {
                x: this.m[4],
                y: this.m[5]
            };
        }
        skew(p, b) {
            const w = this.m[0] + this.m[2] * b, P = this.m[1] + this.m[3] * b, S = this.m[2] + this.m[0] * p, E = this.m[3] + this.m[1] * p;
            return this.m[0] = w, this.m[1] = P, this.m[2] = S, this.m[3] = E, this;
        }
        multiply(p) {
            const b = this.m[0] * p.m[0] + this.m[2] * p.m[1], w = this.m[1] * p.m[0] + this.m[3] * p.m[1], P = this.m[0] * p.m[2] + this.m[2] * p.m[3], S = this.m[1] * p.m[2] + this.m[3] * p.m[3], E = this.m[0] * p.m[4] + this.m[2] * p.m[5] + this.m[4], m = this.m[1] * p.m[4] + this.m[3] * p.m[5] + this.m[5];
            return this.m[0] = b, this.m[1] = w, this.m[2] = P, this.m[3] = S, this.m[4] = E, this.m[5] = m, this;
        }
        invert() {
            const p = 1 / (this.m[0] * this.m[3] - this.m[1] * this.m[2]), b = this.m[3] * p, w = -this.m[1] * p, P = -this.m[2] * p, S = this.m[0] * p, E = p * (this.m[2] * this.m[5] - this.m[3] * this.m[4]), m = p * (this.m[1] * this.m[4] - this.m[0] * this.m[5]);
            return this.m[0] = b, this.m[1] = w, this.m[2] = P, this.m[3] = S, this.m[4] = E, this.m[5] = m, this;
        }
        getMatrix() {
            return this.m;
        }
        decompose() {
            const p = this.m[0], b = this.m[1], w = this.m[2], P = this.m[3], S = this.m[4], E = this.m[5], m = p * P - b * w, T = {
                x: S,
                y: E,
                rotation: 0,
                scaleX: 0,
                scaleY: 0,
                skewX: 0,
                skewY: 0
            };
            if (p != 0 || b != 0) {
                const A = Math.sqrt(p * p + b * b);
                T.rotation = b > 0 ? Math.acos(p / A) : -Math.acos(p / A), T.scaleX = A, T.scaleY = m / A, T.skewX = (p * w + b * P) / m, T.skewY = 0;
            } else if (w != 0 || P != 0) {
                const A = Math.sqrt(w * w + P * P);
                T.rotation = Math.PI / 2 - (P > 0 ? Math.acos(-w / A) : -Math.acos(w / A)), T.scaleX = m / A, T.scaleY = A, T.skewX = 0, T.skewY = (p * w + b * P) / m;
            }
            return T.rotation = l.Util._getRotation(T.rotation), T;
        }
    }
    l.Transform = e;
    const i = "[object Array]", n = "[object Number]", r = "[object String]", s = "[object Boolean]", a = Math.PI / 180, o = 180 / Math.PI, h = "#", c = "", y = "0", g = "Konva warning: ", u = "Konva error: ", f = "rgb(", _ = {
        aliceblue: [
            240,
            248,
            255
        ],
        antiquewhite: [
            250,
            235,
            215
        ],
        aqua: [
            0,
            255,
            255
        ],
        aquamarine: [
            127,
            255,
            212
        ],
        azure: [
            240,
            255,
            255
        ],
        beige: [
            245,
            245,
            220
        ],
        bisque: [
            255,
            228,
            196
        ],
        black: [
            0,
            0,
            0
        ],
        blanchedalmond: [
            255,
            235,
            205
        ],
        blue: [
            0,
            0,
            255
        ],
        blueviolet: [
            138,
            43,
            226
        ],
        brown: [
            165,
            42,
            42
        ],
        burlywood: [
            222,
            184,
            135
        ],
        cadetblue: [
            95,
            158,
            160
        ],
        chartreuse: [
            127,
            255,
            0
        ],
        chocolate: [
            210,
            105,
            30
        ],
        coral: [
            255,
            127,
            80
        ],
        cornflowerblue: [
            100,
            149,
            237
        ],
        cornsilk: [
            255,
            248,
            220
        ],
        crimson: [
            220,
            20,
            60
        ],
        cyan: [
            0,
            255,
            255
        ],
        darkblue: [
            0,
            0,
            139
        ],
        darkcyan: [
            0,
            139,
            139
        ],
        darkgoldenrod: [
            184,
            132,
            11
        ],
        darkgray: [
            169,
            169,
            169
        ],
        darkgreen: [
            0,
            100,
            0
        ],
        darkgrey: [
            169,
            169,
            169
        ],
        darkkhaki: [
            189,
            183,
            107
        ],
        darkmagenta: [
            139,
            0,
            139
        ],
        darkolivegreen: [
            85,
            107,
            47
        ],
        darkorange: [
            255,
            140,
            0
        ],
        darkorchid: [
            153,
            50,
            204
        ],
        darkred: [
            139,
            0,
            0
        ],
        darksalmon: [
            233,
            150,
            122
        ],
        darkseagreen: [
            143,
            188,
            143
        ],
        darkslateblue: [
            72,
            61,
            139
        ],
        darkslategray: [
            47,
            79,
            79
        ],
        darkslategrey: [
            47,
            79,
            79
        ],
        darkturquoise: [
            0,
            206,
            209
        ],
        darkviolet: [
            148,
            0,
            211
        ],
        deeppink: [
            255,
            20,
            147
        ],
        deepskyblue: [
            0,
            191,
            255
        ],
        dimgray: [
            105,
            105,
            105
        ],
        dimgrey: [
            105,
            105,
            105
        ],
        dodgerblue: [
            30,
            144,
            255
        ],
        firebrick: [
            178,
            34,
            34
        ],
        floralwhite: [
            255,
            255,
            240
        ],
        forestgreen: [
            34,
            139,
            34
        ],
        fuchsia: [
            255,
            0,
            255
        ],
        gainsboro: [
            220,
            220,
            220
        ],
        ghostwhite: [
            248,
            248,
            255
        ],
        gold: [
            255,
            215,
            0
        ],
        goldenrod: [
            218,
            165,
            32
        ],
        gray: [
            128,
            128,
            128
        ],
        green: [
            0,
            128,
            0
        ],
        greenyellow: [
            173,
            255,
            47
        ],
        grey: [
            128,
            128,
            128
        ],
        honeydew: [
            240,
            255,
            240
        ],
        hotpink: [
            255,
            105,
            180
        ],
        indianred: [
            205,
            92,
            92
        ],
        indigo: [
            75,
            0,
            130
        ],
        ivory: [
            255,
            255,
            240
        ],
        khaki: [
            240,
            230,
            140
        ],
        lavender: [
            230,
            230,
            250
        ],
        lavenderblush: [
            255,
            240,
            245
        ],
        lawngreen: [
            124,
            252,
            0
        ],
        lemonchiffon: [
            255,
            250,
            205
        ],
        lightblue: [
            173,
            216,
            230
        ],
        lightcoral: [
            240,
            128,
            128
        ],
        lightcyan: [
            224,
            255,
            255
        ],
        lightgoldenrodyellow: [
            250,
            250,
            210
        ],
        lightgray: [
            211,
            211,
            211
        ],
        lightgreen: [
            144,
            238,
            144
        ],
        lightgrey: [
            211,
            211,
            211
        ],
        lightpink: [
            255,
            182,
            193
        ],
        lightsalmon: [
            255,
            160,
            122
        ],
        lightseagreen: [
            32,
            178,
            170
        ],
        lightskyblue: [
            135,
            206,
            250
        ],
        lightslategray: [
            119,
            136,
            153
        ],
        lightslategrey: [
            119,
            136,
            153
        ],
        lightsteelblue: [
            176,
            196,
            222
        ],
        lightyellow: [
            255,
            255,
            224
        ],
        lime: [
            0,
            255,
            0
        ],
        limegreen: [
            50,
            205,
            50
        ],
        linen: [
            250,
            240,
            230
        ],
        magenta: [
            255,
            0,
            255
        ],
        maroon: [
            128,
            0,
            0
        ],
        mediumaquamarine: [
            102,
            205,
            170
        ],
        mediumblue: [
            0,
            0,
            205
        ],
        mediumorchid: [
            186,
            85,
            211
        ],
        mediumpurple: [
            147,
            112,
            219
        ],
        mediumseagreen: [
            60,
            179,
            113
        ],
        mediumslateblue: [
            123,
            104,
            238
        ],
        mediumspringgreen: [
            0,
            250,
            154
        ],
        mediumturquoise: [
            72,
            209,
            204
        ],
        mediumvioletred: [
            199,
            21,
            133
        ],
        midnightblue: [
            25,
            25,
            112
        ],
        mintcream: [
            245,
            255,
            250
        ],
        mistyrose: [
            255,
            228,
            225
        ],
        moccasin: [
            255,
            228,
            181
        ],
        navajowhite: [
            255,
            222,
            173
        ],
        navy: [
            0,
            0,
            128
        ],
        oldlace: [
            253,
            245,
            230
        ],
        olive: [
            128,
            128,
            0
        ],
        olivedrab: [
            107,
            142,
            35
        ],
        orange: [
            255,
            165,
            0
        ],
        orangered: [
            255,
            69,
            0
        ],
        orchid: [
            218,
            112,
            214
        ],
        palegoldenrod: [
            238,
            232,
            170
        ],
        palegreen: [
            152,
            251,
            152
        ],
        paleturquoise: [
            175,
            238,
            238
        ],
        palevioletred: [
            219,
            112,
            147
        ],
        papayawhip: [
            255,
            239,
            213
        ],
        peachpuff: [
            255,
            218,
            185
        ],
        peru: [
            205,
            133,
            63
        ],
        pink: [
            255,
            192,
            203
        ],
        plum: [
            221,
            160,
            203
        ],
        powderblue: [
            176,
            224,
            230
        ],
        purple: [
            128,
            0,
            128
        ],
        rebeccapurple: [
            102,
            51,
            153
        ],
        red: [
            255,
            0,
            0
        ],
        rosybrown: [
            188,
            143,
            143
        ],
        royalblue: [
            65,
            105,
            225
        ],
        saddlebrown: [
            139,
            69,
            19
        ],
        salmon: [
            250,
            128,
            114
        ],
        sandybrown: [
            244,
            164,
            96
        ],
        seagreen: [
            46,
            139,
            87
        ],
        seashell: [
            255,
            245,
            238
        ],
        sienna: [
            160,
            82,
            45
        ],
        silver: [
            192,
            192,
            192
        ],
        skyblue: [
            135,
            206,
            235
        ],
        slateblue: [
            106,
            90,
            205
        ],
        slategray: [
            119,
            128,
            144
        ],
        slategrey: [
            119,
            128,
            144
        ],
        snow: [
            255,
            255,
            250
        ],
        springgreen: [
            0,
            255,
            127
        ],
        steelblue: [
            70,
            130,
            180
        ],
        tan: [
            210,
            180,
            140
        ],
        teal: [
            0,
            128,
            128
        ],
        thistle: [
            216,
            191,
            216
        ],
        transparent: [
            255,
            255,
            255,
            0
        ],
        tomato: [
            255,
            99,
            71
        ],
        turquoise: [
            64,
            224,
            208
        ],
        violet: [
            238,
            130,
            238
        ],
        wheat: [
            245,
            222,
            179
        ],
        white: [
            255,
            255,
            255
        ],
        whitesmoke: [
            245,
            245,
            245
        ],
        yellow: [
            255,
            255,
            0
        ],
        yellowgreen: [
            154,
            205,
            5
        ]
    }, v = /rgb\((\d{1,3}),(\d{1,3}),(\d{1,3})\)/;
    let C = [];
    const k = typeof requestAnimationFrame < "u" && requestAnimationFrame || function(d) {
        setTimeout(d, 60);
    };
    l.Util = {
        _isElement (d) {
            return !!(d && d.nodeType == 1);
        },
        _isFunction (d) {
            return !!(d && d.constructor && d.call && d.apply);
        },
        _isPlainObject (d) {
            return !!d && d.constructor === Object;
        },
        _isArray (d) {
            return Object.prototype.toString.call(d) === i;
        },
        _isNumber (d) {
            return Object.prototype.toString.call(d) === n && !isNaN(d) && isFinite(d);
        },
        _isString (d) {
            return Object.prototype.toString.call(d) === r;
        },
        _isBoolean (d) {
            return Object.prototype.toString.call(d) === s;
        },
        isObject (d) {
            return d instanceof Object;
        },
        isValidSelector (d) {
            if (typeof d != "string") return !1;
            const p = d[0];
            return p === "#" || p === "." || p === p.toUpperCase();
        },
        _sign (d) {
            return d === 0 || d > 0 ? 1 : -1;
        },
        requestAnimFrame (d) {
            C.push(d), C.length === 1 && k(function() {
                const p = C;
                C = [], p.forEach(function(b) {
                    b();
                });
            });
        },
        createCanvasElement () {
            const d = document.createElement("canvas");
            try {
                d.style = d.style || {};
            } catch  {}
            return d;
        },
        createImageElement () {
            return document.createElement("img");
        },
        _isInDocument (d) {
            for(; d = d.parentNode;)if (d == document) return !0;
            return !1;
        },
        _urlToImage (d, p) {
            const b = l.Util.createImageElement();
            b.onload = function() {
                p(b);
            }, b.src = d;
        },
        _rgbToHex (d, p, b) {
            return (16777216 + (d << 16) + (p << 8) + b).toString(16).slice(1);
        },
        _hexToRgb (d) {
            d = d.replace(h, c);
            const p = parseInt(d, 16);
            return {
                r: p >> 16 & 255,
                g: p >> 8 & 255,
                b: p & 255
            };
        },
        getRandomColor () {
            let d = (Math.random() * 16777215 << 0).toString(16);
            for(; d.length < 6;)d = y + d;
            return h + d;
        },
        getRGB (d) {
            let p;
            return d in _ ? (p = _[d], {
                r: p[0],
                g: p[1],
                b: p[2]
            }) : d[0] === h ? this._hexToRgb(d.substring(1)) : d.substr(0, 4) === f ? (p = v.exec(d.replace(/ /g, "")), {
                r: parseInt(p[1], 10),
                g: parseInt(p[2], 10),
                b: parseInt(p[3], 10)
            }) : {
                r: 0,
                g: 0,
                b: 0
            };
        },
        colorToRGBA (d) {
            return d = d || "black", l.Util._namedColorToRBA(d) || l.Util._hex3ColorToRGBA(d) || l.Util._hex4ColorToRGBA(d) || l.Util._hex6ColorToRGBA(d) || l.Util._hex8ColorToRGBA(d) || l.Util._rgbColorToRGBA(d) || l.Util._rgbaColorToRGBA(d) || l.Util._hslColorToRGBA(d);
        },
        _namedColorToRBA (d) {
            const p = _[d.toLowerCase()];
            return p ? {
                r: p[0],
                g: p[1],
                b: p[2],
                a: 1
            } : null;
        },
        _rgbColorToRGBA (d) {
            if (d.indexOf("rgb(") === 0) {
                d = d.match(/rgb\(([^)]+)\)/)[1];
                const p = d.split(/ *, */).map(Number);
                return {
                    r: p[0],
                    g: p[1],
                    b: p[2],
                    a: 1
                };
            }
        },
        _rgbaColorToRGBA (d) {
            if (d.indexOf("rgba(") === 0) {
                d = d.match(/rgba\(([^)]+)\)/)[1];
                const p = d.split(/ *, */).map((b, w)=>b.slice(-1) === "%" ? w === 3 ? parseInt(b) / 100 : parseInt(b) / 100 * 255 : Number(b));
                return {
                    r: p[0],
                    g: p[1],
                    b: p[2],
                    a: p[3]
                };
            }
        },
        _hex8ColorToRGBA (d) {
            if (d[0] === "#" && d.length === 9) return {
                r: parseInt(d.slice(1, 3), 16),
                g: parseInt(d.slice(3, 5), 16),
                b: parseInt(d.slice(5, 7), 16),
                a: parseInt(d.slice(7, 9), 16) / 255
            };
        },
        _hex6ColorToRGBA (d) {
            if (d[0] === "#" && d.length === 7) return {
                r: parseInt(d.slice(1, 3), 16),
                g: parseInt(d.slice(3, 5), 16),
                b: parseInt(d.slice(5, 7), 16),
                a: 1
            };
        },
        _hex4ColorToRGBA (d) {
            if (d[0] === "#" && d.length === 5) return {
                r: parseInt(d[1] + d[1], 16),
                g: parseInt(d[2] + d[2], 16),
                b: parseInt(d[3] + d[3], 16),
                a: parseInt(d[4] + d[4], 16) / 255
            };
        },
        _hex3ColorToRGBA (d) {
            if (d[0] === "#" && d.length === 4) return {
                r: parseInt(d[1] + d[1], 16),
                g: parseInt(d[2] + d[2], 16),
                b: parseInt(d[3] + d[3], 16),
                a: 1
            };
        },
        _hslColorToRGBA (d) {
            if (/hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.test(d)) {
                const [p, ...b] = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(d), w = Number(b[0]) / 360, P = Number(b[1]) / 100, S = Number(b[2]) / 100;
                let E, m, T;
                if (P === 0) return T = S * 255, {
                    r: Math.round(T),
                    g: Math.round(T),
                    b: Math.round(T),
                    a: 1
                };
                S < 0.5 ? E = S * (1 + P) : E = S + P - S * P;
                const A = 2 * S - E, F = [
                    0,
                    0,
                    0
                ];
                for(let O = 0; O < 3; O++)m = w + 1 / 3 * -(O - 1), m < 0 && m++, m > 1 && m--, 6 * m < 1 ? T = A + (E - A) * 6 * m : 2 * m < 1 ? T = E : 3 * m < 2 ? T = A + (E - A) * (2 / 3 - m) * 6 : T = A, F[O] = T * 255;
                return {
                    r: Math.round(F[0]),
                    g: Math.round(F[1]),
                    b: Math.round(F[2]),
                    a: 1
                };
            }
        },
        haveIntersection (d, p) {
            return !(p.x > d.x + d.width || p.x + p.width < d.x || p.y > d.y + d.height || p.y + p.height < d.y);
        },
        cloneObject (d) {
            const p = {};
            for(const b in d)this._isPlainObject(d[b]) ? p[b] = this.cloneObject(d[b]) : this._isArray(d[b]) ? p[b] = this.cloneArray(d[b]) : p[b] = d[b];
            return p;
        },
        cloneArray (d) {
            return d.slice(0);
        },
        degToRad (d) {
            return d * a;
        },
        radToDeg (d) {
            return d * o;
        },
        _degToRad (d) {
            return l.Util.warn("Util._degToRad is removed. Please use public Util.degToRad instead."), l.Util.degToRad(d);
        },
        _radToDeg (d) {
            return l.Util.warn("Util._radToDeg is removed. Please use public Util.radToDeg instead."), l.Util.radToDeg(d);
        },
        _getRotation (d) {
            return t.Konva.angleDeg ? l.Util.radToDeg(d) : d;
        },
        _capitalize (d) {
            return d.charAt(0).toUpperCase() + d.slice(1);
        },
        throw (d) {
            throw new Error(u + d);
        },
        error (d) {
            console.error(u + d);
        },
        warn (d) {
            t.Konva.showWarnings && console.warn(g + d);
        },
        each (d, p) {
            for(const b in d)p(b, d[b]);
        },
        _inRange (d, p, b) {
            return p <= d && d < b;
        },
        _getProjectionToSegment (d, p, b, w, P, S) {
            let E, m, T;
            const A = (d - b) * (d - b) + (p - w) * (p - w);
            if (A == 0) E = d, m = p, T = (P - b) * (P - b) + (S - w) * (S - w);
            else {
                const F = ((P - d) * (b - d) + (S - p) * (w - p)) / A;
                F < 0 ? (E = d, m = p, T = (d - P) * (d - P) + (p - S) * (p - S)) : F > 1 ? (E = b, m = w, T = (b - P) * (b - P) + (w - S) * (w - S)) : (E = d + F * (b - d), m = p + F * (w - p), T = (E - P) * (E - P) + (m - S) * (m - S));
            }
            return [
                E,
                m,
                T
            ];
        },
        _getProjectionToLine (d, p, b) {
            const w = l.Util.cloneObject(d);
            let P = Number.MAX_VALUE;
            return p.forEach(function(S, E) {
                if (!b && E === p.length - 1) return;
                const m = p[(E + 1) % p.length], T = l.Util._getProjectionToSegment(S.x, S.y, m.x, m.y, d.x, d.y), A = T[0], F = T[1], O = T[2];
                O < P && (w.x = A, w.y = F, P = O);
            }), w;
        },
        _prepareArrayForTween (d, p, b) {
            const w = [], P = [];
            if (d.length > p.length) {
                const E = p;
                p = d, d = E;
            }
            for(let E = 0; E < d.length; E += 2)w.push({
                x: d[E],
                y: d[E + 1]
            });
            for(let E = 0; E < p.length; E += 2)P.push({
                x: p[E],
                y: p[E + 1]
            });
            const S = [];
            return P.forEach(function(E) {
                const m = l.Util._getProjectionToLine(E, w, b);
                S.push(m.x), S.push(m.y);
            }), S;
        },
        _prepareToStringify (d) {
            let p;
            d.visitedByCircularReferenceRemoval = !0;
            for(const b in d)if (d.hasOwnProperty(b) && d[b] && typeof d[b] == "object") {
                if (p = Object.getOwnPropertyDescriptor(d, b), d[b].visitedByCircularReferenceRemoval || l.Util._isElement(d[b])) {
                    if (p.configurable) delete d[b];
                    else return null;
                } else if (l.Util._prepareToStringify(d[b]) === null) {
                    if (p.configurable) delete d[b];
                    else return null;
                }
            }
            return delete d.visitedByCircularReferenceRemoval, d;
        },
        _assign (d, p) {
            for(const b in p)d[b] = p[b];
            return d;
        },
        _getFirstPointerId (d) {
            return d.touches ? d.changedTouches[0].identifier : d.pointerId || 999;
        },
        releaseCanvas (...d) {
            t.Konva.releaseCanvasOnDestroy && d.forEach((p)=>{
                p.width = 0, p.height = 0;
            });
        },
        drawRoundedRectPath (d, p, b, w) {
            let P = 0, S = 0, E = 0, m = 0;
            typeof w == "number" ? P = S = E = m = Math.min(w, p / 2, b / 2) : (P = Math.min(w[0] || 0, p / 2, b / 2), S = Math.min(w[1] || 0, p / 2, b / 2), m = Math.min(w[2] || 0, p / 2, b / 2), E = Math.min(w[3] || 0, p / 2, b / 2)), d.moveTo(P, 0), d.lineTo(p - S, 0), d.arc(p - S, S, S, Math.PI * 3 / 2, 0, !1), d.lineTo(p, b - m), d.arc(p - m, b - m, m, 0, Math.PI / 2, !1), d.lineTo(E, b), d.arc(E, b - E, E, Math.PI / 2, Math.PI, !1), d.lineTo(0, P), d.arc(P, P, P, Math.PI, Math.PI * 3 / 2, !1);
        }
    };
})($47a4b45281b81a8b$var$nt);
var $47a4b45281b81a8b$var$et = {}, $47a4b45281b81a8b$var$V = {}, $47a4b45281b81a8b$var$L = {};
Object.defineProperty($47a4b45281b81a8b$var$L, "__esModule", {
    value: !0
});
$47a4b45281b81a8b$var$L.RGBComponent = $47a4b45281b81a8b$var$Ir;
$47a4b45281b81a8b$var$L.alphaComponent = $47a4b45281b81a8b$var$Nr;
$47a4b45281b81a8b$var$L.getNumberValidator = $47a4b45281b81a8b$var$Ur;
$47a4b45281b81a8b$var$L.getNumberOrArrayOfNumbersValidator = $47a4b45281b81a8b$var$Br;
$47a4b45281b81a8b$var$L.getNumberOrAutoValidator = $47a4b45281b81a8b$var$Hr;
$47a4b45281b81a8b$var$L.getStringValidator = $47a4b45281b81a8b$var$Vr;
$47a4b45281b81a8b$var$L.getStringOrGradientValidator = $47a4b45281b81a8b$var$$r;
$47a4b45281b81a8b$var$L.getFunctionValidator = $47a4b45281b81a8b$var$zr;
$47a4b45281b81a8b$var$L.getNumberArrayValidator = $47a4b45281b81a8b$var$Wr;
$47a4b45281b81a8b$var$L.getBooleanValidator = $47a4b45281b81a8b$var$Xr;
$47a4b45281b81a8b$var$L.getComponentValidator = $47a4b45281b81a8b$var$Kr;
const $47a4b45281b81a8b$var$Pt = $47a4b45281b81a8b$var$H, $47a4b45281b81a8b$var$st = $47a4b45281b81a8b$var$nt;
function $47a4b45281b81a8b$var$Mt(l) {
    return $47a4b45281b81a8b$var$st.Util._isString(l) ? '"' + l + '"' : Object.prototype.toString.call(l) === "[object Number]" || $47a4b45281b81a8b$var$st.Util._isBoolean(l) ? l : Object.prototype.toString.call(l);
}
function $47a4b45281b81a8b$var$Ir(l) {
    return l > 255 ? 255 : l < 0 ? 0 : Math.round(l);
}
function $47a4b45281b81a8b$var$Nr(l) {
    return l > 1 ? 1 : l < 1e-4 ? 1e-4 : l;
}
function $47a4b45281b81a8b$var$Ur() {
    if ($47a4b45281b81a8b$var$Pt.Konva.isUnminified) return function(l, t) {
        return $47a4b45281b81a8b$var$st.Util._isNumber(l) || $47a4b45281b81a8b$var$st.Util.warn($47a4b45281b81a8b$var$Mt(l) + ' is a not valid value for "' + t + '" attribute. The value should be a number.'), l;
    };
}
function $47a4b45281b81a8b$var$Br(l) {
    if ($47a4b45281b81a8b$var$Pt.Konva.isUnminified) return function(t, e) {
        let i = $47a4b45281b81a8b$var$st.Util._isNumber(t), n = $47a4b45281b81a8b$var$st.Util._isArray(t) && t.length == l;
        return !i && !n && $47a4b45281b81a8b$var$st.Util.warn($47a4b45281b81a8b$var$Mt(t) + ' is a not valid value for "' + e + '" attribute. The value should be a number or Array<number>(' + l + ")"), t;
    };
}
function $47a4b45281b81a8b$var$Hr() {
    if ($47a4b45281b81a8b$var$Pt.Konva.isUnminified) return function(l, t) {
        var e = $47a4b45281b81a8b$var$st.Util._isNumber(l), i = l === "auto";
        return e || i || $47a4b45281b81a8b$var$st.Util.warn($47a4b45281b81a8b$var$Mt(l) + ' is a not valid value for "' + t + '" attribute. The value should be a number or "auto".'), l;
    };
}
function $47a4b45281b81a8b$var$Vr() {
    if ($47a4b45281b81a8b$var$Pt.Konva.isUnminified) return function(l, t) {
        return $47a4b45281b81a8b$var$st.Util._isString(l) || $47a4b45281b81a8b$var$st.Util.warn($47a4b45281b81a8b$var$Mt(l) + ' is a not valid value for "' + t + '" attribute. The value should be a string.'), l;
    };
}
function $47a4b45281b81a8b$var$$r() {
    if ($47a4b45281b81a8b$var$Pt.Konva.isUnminified) return function(l, t) {
        const e = $47a4b45281b81a8b$var$st.Util._isString(l), i = Object.prototype.toString.call(l) === "[object CanvasGradient]" || l && l.addColorStop;
        return e || i || $47a4b45281b81a8b$var$st.Util.warn($47a4b45281b81a8b$var$Mt(l) + ' is a not valid value for "' + t + '" attribute. The value should be a string or a native gradient.'), l;
    };
}
function $47a4b45281b81a8b$var$zr() {
    if ($47a4b45281b81a8b$var$Pt.Konva.isUnminified) return function(l, t) {
        return $47a4b45281b81a8b$var$st.Util._isFunction(l) || $47a4b45281b81a8b$var$st.Util.warn($47a4b45281b81a8b$var$Mt(l) + ' is a not valid value for "' + t + '" attribute. The value should be a function.'), l;
    };
}
function $47a4b45281b81a8b$var$Wr() {
    if ($47a4b45281b81a8b$var$Pt.Konva.isUnminified) return function(l, t) {
        const e = Int8Array ? Object.getPrototypeOf(Int8Array) : null;
        return e && l instanceof e || ($47a4b45281b81a8b$var$st.Util._isArray(l) ? l.forEach(function(i) {
            $47a4b45281b81a8b$var$st.Util._isNumber(i) || $47a4b45281b81a8b$var$st.Util.warn('"' + t + '" attribute has non numeric element ' + i + ". Make sure that all elements are numbers.");
        }) : $47a4b45281b81a8b$var$st.Util.warn($47a4b45281b81a8b$var$Mt(l) + ' is a not valid value for "' + t + '" attribute. The value should be a array of numbers.')), l;
    };
}
function $47a4b45281b81a8b$var$Xr() {
    if ($47a4b45281b81a8b$var$Pt.Konva.isUnminified) return function(l, t) {
        var e = l === !0 || l === !1;
        return e || $47a4b45281b81a8b$var$st.Util.warn($47a4b45281b81a8b$var$Mt(l) + ' is a not valid value for "' + t + '" attribute. The value should be a boolean.'), l;
    };
}
function $47a4b45281b81a8b$var$Kr(l) {
    if ($47a4b45281b81a8b$var$Pt.Konva.isUnminified) return function(t, e) {
        return t == null || $47a4b45281b81a8b$var$st.Util.isObject(t) || $47a4b45281b81a8b$var$st.Util.warn($47a4b45281b81a8b$var$Mt(t) + ' is a not valid value for "' + e + '" attribute. The value should be an object with properties ' + l), t;
    };
}
(function(l) {
    Object.defineProperty(l, "__esModule", {
        value: !0
    }), l.Factory = void 0;
    const t = $47a4b45281b81a8b$var$nt, e = $47a4b45281b81a8b$var$L, i = "get", n = "set";
    l.Factory = {
        addGetterSetter (r, s, a, o, h) {
            l.Factory.addGetter(r, s, a), l.Factory.addSetter(r, s, o, h), l.Factory.addOverloadedGetterSetter(r, s);
        },
        addGetter (r, s, a) {
            var o = i + t.Util._capitalize(s);
            r.prototype[o] = r.prototype[o] || function() {
                const h = this.attrs[s];
                return h === void 0 ? a : h;
            };
        },
        addSetter (r, s, a, o) {
            var h = n + t.Util._capitalize(s);
            r.prototype[h] || l.Factory.overWriteSetter(r, s, a, o);
        },
        overWriteSetter (r, s, a, o) {
            var h = n + t.Util._capitalize(s);
            r.prototype[h] = function(c) {
                return a && c !== void 0 && c !== null && (c = a.call(this, c, s)), this._setAttr(s, c), o && o.call(this), this;
            };
        },
        addComponentsGetterSetter (r, s, a, o, h) {
            const c = a.length, y = t.Util._capitalize, g = i + y(s), u = n + y(s);
            r.prototype[g] = function() {
                const _ = {};
                for(let v = 0; v < c; v++){
                    const C = a[v];
                    _[C] = this.getAttr(s + y(C));
                }
                return _;
            };
            const f = (0, e.getComponentValidator)(a);
            r.prototype[u] = function(_) {
                const v = this.attrs[s];
                o && (_ = o.call(this, _, s)), f && f.call(this, _, s);
                for(const C in _)_.hasOwnProperty(C) && this._setAttr(s + y(C), _[C]);
                return _ || a.forEach((C)=>{
                    this._setAttr(s + y(C), void 0);
                }), this._fireChangeEvent(s, v, _), h && h.call(this), this;
            }, l.Factory.addOverloadedGetterSetter(r, s);
        },
        addOverloadedGetterSetter (r, s) {
            var a = t.Util._capitalize(s), o = n + a, h = i + a;
            r.prototype[s] = function() {
                return arguments.length ? (this[o](arguments[0]), this) : this[h]();
            };
        },
        addDeprecatedGetterSetter (r, s, a, o) {
            t.Util.error("Adding deprecated " + s);
            const h = i + t.Util._capitalize(s), c = s + " property is deprecated and will be removed soon. Look at Konva change log for more information.";
            r.prototype[h] = function() {
                t.Util.error(c);
                const y = this.attrs[s];
                return y === void 0 ? a : y;
            }, l.Factory.addSetter(r, s, o, function() {
                t.Util.error(c);
            }), l.Factory.addOverloadedGetterSetter(r, s);
        },
        backCompat (r, s) {
            t.Util.each(s, function(a, o) {
                const h = r.prototype[o], c = i + t.Util._capitalize(a), y = n + t.Util._capitalize(a);
                function g() {
                    h.apply(this, arguments), t.Util.error('"' + a + '" method is deprecated and will be removed soon. Use ""' + o + '" instead.');
                }
                r.prototype[a] = g, r.prototype[c] = g, r.prototype[y] = g;
            });
        },
        afterSetFilter () {
            this._filterUpToDate = !1;
        }
    };
})($47a4b45281b81a8b$var$V);
var $47a4b45281b81a8b$var$bt = {}, $47a4b45281b81a8b$var$At = {};
Object.defineProperty($47a4b45281b81a8b$var$At, "__esModule", {
    value: !0
});
$47a4b45281b81a8b$var$At.HitContext = $47a4b45281b81a8b$var$At.SceneContext = $47a4b45281b81a8b$var$At.Context = void 0;
const $47a4b45281b81a8b$var$er = $47a4b45281b81a8b$var$nt, $47a4b45281b81a8b$var$Yr = $47a4b45281b81a8b$var$H;
function $47a4b45281b81a8b$var$jr(l) {
    const t = [], e = l.length, i = $47a4b45281b81a8b$var$er.Util;
    for(let n = 0; n < e; n++){
        let r = l[n];
        i._isNumber(r) ? r = Math.round(r * 1e3) / 1e3 : i._isString(r) || (r = r + ""), t.push(r);
    }
    return t;
}
const $47a4b45281b81a8b$var$mn = ",", $47a4b45281b81a8b$var$qr = "(", $47a4b45281b81a8b$var$Jr = ")", $47a4b45281b81a8b$var$Qr = "([", $47a4b45281b81a8b$var$Zr = "])", $47a4b45281b81a8b$var$ts = ";", $47a4b45281b81a8b$var$es = "()", $47a4b45281b81a8b$var$is = "=", $47a4b45281b81a8b$var$yn = [
    "arc",
    "arcTo",
    "beginPath",
    "bezierCurveTo",
    "clearRect",
    "clip",
    "closePath",
    "createLinearGradient",
    "createPattern",
    "createRadialGradient",
    "drawImage",
    "ellipse",
    "fill",
    "fillText",
    "getImageData",
    "createImageData",
    "lineTo",
    "moveTo",
    "putImageData",
    "quadraticCurveTo",
    "rect",
    "roundRect",
    "restore",
    "rotate",
    "save",
    "scale",
    "setLineDash",
    "setTransform",
    "stroke",
    "strokeText",
    "transform",
    "translate"
], $47a4b45281b81a8b$var$ns = [
    "fillStyle",
    "strokeStyle",
    "shadowColor",
    "shadowBlur",
    "shadowOffsetX",
    "shadowOffsetY",
    "letterSpacing",
    "lineCap",
    "lineDashOffset",
    "lineJoin",
    "lineWidth",
    "miterLimit",
    "direction",
    "font",
    "textAlign",
    "textBaseline",
    "globalAlpha",
    "globalCompositeOperation",
    "imageSmoothingEnabled"
], $47a4b45281b81a8b$var$rs = 100;
class $47a4b45281b81a8b$var$Be {
    constructor(t){
        this.canvas = t, $47a4b45281b81a8b$var$Yr.Konva.enableTrace && (this.traceArr = [], this._enableTrace());
    }
    fillShape(t) {
        t.fillEnabled() && this._fill(t);
    }
    _fill(t) {}
    strokeShape(t) {
        t.hasStroke() && this._stroke(t);
    }
    _stroke(t) {}
    fillStrokeShape(t) {
        t.attrs.fillAfterStrokeEnabled ? (this.strokeShape(t), this.fillShape(t)) : (this.fillShape(t), this.strokeShape(t));
    }
    getTrace(t, e) {
        let i = this.traceArr, n = i.length, r = "", s, a, o, h;
        for(s = 0; s < n; s++)a = i[s], o = a.method, o ? (h = a.args, r += o, t ? r += $47a4b45281b81a8b$var$es : $47a4b45281b81a8b$var$er.Util._isArray(h[0]) ? r += $47a4b45281b81a8b$var$Qr + h.join($47a4b45281b81a8b$var$mn) + $47a4b45281b81a8b$var$Zr : (e && (h = h.map((c)=>typeof c == "number" ? Math.floor(c) : c)), r += $47a4b45281b81a8b$var$qr + h.join($47a4b45281b81a8b$var$mn) + $47a4b45281b81a8b$var$Jr)) : (r += a.property, t || (r += $47a4b45281b81a8b$var$is + a.val)), r += $47a4b45281b81a8b$var$ts;
        return r;
    }
    clearTrace() {
        this.traceArr = [];
    }
    _trace(t) {
        let e = this.traceArr, i;
        e.push(t), i = e.length, i >= $47a4b45281b81a8b$var$rs && e.shift();
    }
    reset() {
        const t = this.getCanvas().getPixelRatio();
        this.setTransform(1 * t, 0, 0, 1 * t, 0, 0);
    }
    getCanvas() {
        return this.canvas;
    }
    clear(t) {
        const e = this.getCanvas();
        t ? this.clearRect(t.x || 0, t.y || 0, t.width || 0, t.height || 0) : this.clearRect(0, 0, e.getWidth() / e.pixelRatio, e.getHeight() / e.pixelRatio);
    }
    _applyLineCap(t) {
        const e = t.attrs.lineCap;
        e && this.setAttr("lineCap", e);
    }
    _applyOpacity(t) {
        const e = t.getAbsoluteOpacity();
        e !== 1 && this.setAttr("globalAlpha", e);
    }
    _applyLineJoin(t) {
        const e = t.attrs.lineJoin;
        e && this.setAttr("lineJoin", e);
    }
    setAttr(t, e) {
        this._context[t] = e;
    }
    arc(t, e, i, n, r, s) {
        this._context.arc(t, e, i, n, r, s);
    }
    arcTo(t, e, i, n, r) {
        this._context.arcTo(t, e, i, n, r);
    }
    beginPath() {
        this._context.beginPath();
    }
    bezierCurveTo(t, e, i, n, r, s) {
        this._context.bezierCurveTo(t, e, i, n, r, s);
    }
    clearRect(t, e, i, n) {
        this._context.clearRect(t, e, i, n);
    }
    clip(...t) {
        this._context.clip.apply(this._context, t);
    }
    closePath() {
        this._context.closePath();
    }
    createImageData(t, e) {
        const i = arguments;
        if (i.length === 2) return this._context.createImageData(t, e);
        if (i.length === 1) return this._context.createImageData(t);
    }
    createLinearGradient(t, e, i, n) {
        return this._context.createLinearGradient(t, e, i, n);
    }
    createPattern(t, e) {
        return this._context.createPattern(t, e);
    }
    createRadialGradient(t, e, i, n, r, s) {
        return this._context.createRadialGradient(t, e, i, n, r, s);
    }
    drawImage(t, e, i, n, r, s, a, o, h) {
        const c = arguments, y = this._context;
        c.length === 3 ? y.drawImage(t, e, i) : c.length === 5 ? y.drawImage(t, e, i, n, r) : c.length === 9 && y.drawImage(t, e, i, n, r, s, a, o, h);
    }
    ellipse(t, e, i, n, r, s, a, o) {
        this._context.ellipse(t, e, i, n, r, s, a, o);
    }
    isPointInPath(t, e, i, n) {
        return i ? this._context.isPointInPath(i, t, e, n) : this._context.isPointInPath(t, e, n);
    }
    fill(...t) {
        this._context.fill.apply(this._context, t);
    }
    fillRect(t, e, i, n) {
        this._context.fillRect(t, e, i, n);
    }
    strokeRect(t, e, i, n) {
        this._context.strokeRect(t, e, i, n);
    }
    fillText(t, e, i, n) {
        n ? this._context.fillText(t, e, i, n) : this._context.fillText(t, e, i);
    }
    measureText(t) {
        return this._context.measureText(t);
    }
    getImageData(t, e, i, n) {
        return this._context.getImageData(t, e, i, n);
    }
    lineTo(t, e) {
        this._context.lineTo(t, e);
    }
    moveTo(t, e) {
        this._context.moveTo(t, e);
    }
    rect(t, e, i, n) {
        this._context.rect(t, e, i, n);
    }
    roundRect(t, e, i, n, r) {
        this._context.roundRect(t, e, i, n, r);
    }
    putImageData(t, e, i) {
        this._context.putImageData(t, e, i);
    }
    quadraticCurveTo(t, e, i, n) {
        this._context.quadraticCurveTo(t, e, i, n);
    }
    restore() {
        this._context.restore();
    }
    rotate(t) {
        this._context.rotate(t);
    }
    save() {
        this._context.save();
    }
    scale(t, e) {
        this._context.scale(t, e);
    }
    setLineDash(t) {
        this._context.setLineDash ? this._context.setLineDash(t) : "mozDash" in this._context ? this._context.mozDash = t : "webkitLineDash" in this._context && (this._context.webkitLineDash = t);
    }
    getLineDash() {
        return this._context.getLineDash();
    }
    setTransform(t, e, i, n, r, s) {
        this._context.setTransform(t, e, i, n, r, s);
    }
    stroke(t) {
        t ? this._context.stroke(t) : this._context.stroke();
    }
    strokeText(t, e, i, n) {
        this._context.strokeText(t, e, i, n);
    }
    transform(t, e, i, n, r, s) {
        this._context.transform(t, e, i, n, r, s);
    }
    translate(t, e) {
        this._context.translate(t, e);
    }
    _enableTrace() {
        let t = this, e = $47a4b45281b81a8b$var$yn.length, i = this.setAttr, n, r;
        const s = function(a) {
            let o = t[a], h;
            t[a] = function() {
                return r = $47a4b45281b81a8b$var$jr(Array.prototype.slice.call(arguments, 0)), h = o.apply(t, arguments), t._trace({
                    method: a,
                    args: r
                }), h;
            };
        };
        for(n = 0; n < e; n++)s($47a4b45281b81a8b$var$yn[n]);
        t.setAttr = function() {
            i.apply(t, arguments);
            const a = arguments[0];
            let o = arguments[1];
            (a === "shadowOffsetX" || a === "shadowOffsetY" || a === "shadowBlur") && (o = o / this.canvas.getPixelRatio()), t._trace({
                property: a,
                val: o
            });
        };
    }
    _applyGlobalCompositeOperation(t) {
        const e = t.attrs.globalCompositeOperation;
        !e || e === "source-over" || this.setAttr("globalCompositeOperation", e);
    }
}
$47a4b45281b81a8b$var$At.Context = $47a4b45281b81a8b$var$Be;
$47a4b45281b81a8b$var$ns.forEach(function(l) {
    Object.defineProperty($47a4b45281b81a8b$var$Be.prototype, l, {
        get () {
            return this._context[l];
        },
        set (t) {
            this._context[l] = t;
        }
    });
});
class $47a4b45281b81a8b$var$ss extends $47a4b45281b81a8b$var$Be {
    constructor(t, { willReadFrequently: e = !1 } = {}){
        super(t), this._context = t._canvas.getContext("2d", {
            willReadFrequently: e
        });
    }
    _fillColor(t) {
        const e = t.fill();
        this.setAttr("fillStyle", e), t._fillFunc(this);
    }
    _fillPattern(t) {
        this.setAttr("fillStyle", t._getFillPattern()), t._fillFunc(this);
    }
    _fillLinearGradient(t) {
        const e = t._getLinearGradient();
        e && (this.setAttr("fillStyle", e), t._fillFunc(this));
    }
    _fillRadialGradient(t) {
        const e = t._getRadialGradient();
        e && (this.setAttr("fillStyle", e), t._fillFunc(this));
    }
    _fill(t) {
        const e = t.fill(), i = t.getFillPriority();
        if (e && i === "color") {
            this._fillColor(t);
            return;
        }
        const n = t.getFillPatternImage();
        if (n && i === "pattern") {
            this._fillPattern(t);
            return;
        }
        const r = t.getFillLinearGradientColorStops();
        if (r && i === "linear-gradient") {
            this._fillLinearGradient(t);
            return;
        }
        const s = t.getFillRadialGradientColorStops();
        if (s && i === "radial-gradient") {
            this._fillRadialGradient(t);
            return;
        }
        e ? this._fillColor(t) : n ? this._fillPattern(t) : r ? this._fillLinearGradient(t) : s && this._fillRadialGradient(t);
    }
    _strokeLinearGradient(t) {
        const e = t.getStrokeLinearGradientStartPoint(), i = t.getStrokeLinearGradientEndPoint(), n = t.getStrokeLinearGradientColorStops(), r = this.createLinearGradient(e.x, e.y, i.x, i.y);
        if (n) {
            for(let s = 0; s < n.length; s += 2)r.addColorStop(n[s], n[s + 1]);
            this.setAttr("strokeStyle", r);
        }
    }
    _stroke(t) {
        const e = t.dash(), i = t.getStrokeScaleEnabled();
        if (t.hasStroke()) {
            if (!i) {
                this.save();
                const r = this.getCanvas().getPixelRatio();
                this.setTransform(r, 0, 0, r, 0, 0);
            }
            this._applyLineCap(t), e && t.dashEnabled() && (this.setLineDash(e), this.setAttr("lineDashOffset", t.dashOffset())), this.setAttr("lineWidth", t.strokeWidth()), t.getShadowForStrokeEnabled() || this.setAttr("shadowColor", "rgba(0,0,0,0)"), t.getStrokeLinearGradientColorStops() ? this._strokeLinearGradient(t) : this.setAttr("strokeStyle", t.stroke()), t._strokeFunc(this), i || this.restore();
        }
    }
    _applyShadow(t) {
        var e, i, n;
        const r = (e = t.getShadowRGBA()) !== null && e !== void 0 ? e : "black", s = (i = t.getShadowBlur()) !== null && i !== void 0 ? i : 5, a = (n = t.getShadowOffset()) !== null && n !== void 0 ? n : {
            x: 0,
            y: 0
        }, o = t.getAbsoluteScale(), h = this.canvas.getPixelRatio(), c = o.x * h, y = o.y * h;
        this.setAttr("shadowColor", r), this.setAttr("shadowBlur", s * Math.min(Math.abs(c), Math.abs(y))), this.setAttr("shadowOffsetX", a.x * c), this.setAttr("shadowOffsetY", a.y * y);
    }
}
$47a4b45281b81a8b$var$At.SceneContext = $47a4b45281b81a8b$var$ss;
class $47a4b45281b81a8b$var$as extends $47a4b45281b81a8b$var$Be {
    constructor(t){
        super(t), this._context = t._canvas.getContext("2d", {
            willReadFrequently: !0
        });
    }
    _fill(t) {
        this.save(), this.setAttr("fillStyle", t.colorKey), t._fillFuncHit(this), this.restore();
    }
    strokeShape(t) {
        t.hasHitStroke() && this._stroke(t);
    }
    _stroke(t) {
        if (t.hasHitStroke()) {
            const e = t.getStrokeScaleEnabled();
            if (!e) {
                this.save();
                const r = this.getCanvas().getPixelRatio();
                this.setTransform(r, 0, 0, r, 0, 0);
            }
            this._applyLineCap(t);
            const i = t.hitStrokeWidth(), n = i === "auto" ? t.strokeWidth() : i;
            this.setAttr("lineWidth", n), this.setAttr("strokeStyle", t.colorKey), t._strokeFuncHit(this), e || this.restore();
        }
    }
}
$47a4b45281b81a8b$var$At.HitContext = $47a4b45281b81a8b$var$as;
Object.defineProperty($47a4b45281b81a8b$var$bt, "__esModule", {
    value: !0
});
$47a4b45281b81a8b$var$bt.HitCanvas = $47a4b45281b81a8b$var$bt.SceneCanvas = $47a4b45281b81a8b$var$bt.Canvas = void 0;
const $47a4b45281b81a8b$var$Le = $47a4b45281b81a8b$var$nt, $47a4b45281b81a8b$var$ir = $47a4b45281b81a8b$var$At, $47a4b45281b81a8b$var$nr = $47a4b45281b81a8b$var$H, $47a4b45281b81a8b$var$os = $47a4b45281b81a8b$var$V, $47a4b45281b81a8b$var$ls = $47a4b45281b81a8b$var$L;
let $47a4b45281b81a8b$var$Ae;
function $47a4b45281b81a8b$var$hs() {
    if ($47a4b45281b81a8b$var$Ae) return $47a4b45281b81a8b$var$Ae;
    const l = $47a4b45281b81a8b$var$Le.Util.createCanvasElement(), t = l.getContext("2d");
    return $47a4b45281b81a8b$var$Ae = function() {
        const e = $47a4b45281b81a8b$var$nr.Konva._global.devicePixelRatio || 1, i = t.webkitBackingStorePixelRatio || t.mozBackingStorePixelRatio || t.msBackingStorePixelRatio || t.oBackingStorePixelRatio || t.backingStorePixelRatio || 1;
        return e / i;
    }(), $47a4b45281b81a8b$var$Le.Util.releaseCanvas(l), $47a4b45281b81a8b$var$Ae;
}
class $47a4b45281b81a8b$var$He {
    constructor(t){
        this.pixelRatio = 1, this.width = 0, this.height = 0, this.isCache = !1;
        const i = (t || {}).pixelRatio || $47a4b45281b81a8b$var$nr.Konva.pixelRatio || $47a4b45281b81a8b$var$hs();
        this.pixelRatio = i, this._canvas = $47a4b45281b81a8b$var$Le.Util.createCanvasElement(), this._canvas.style.padding = "0", this._canvas.style.margin = "0", this._canvas.style.border = "0", this._canvas.style.background = "transparent", this._canvas.style.position = "absolute", this._canvas.style.top = "0", this._canvas.style.left = "0";
    }
    getContext() {
        return this.context;
    }
    getPixelRatio() {
        return this.pixelRatio;
    }
    setPixelRatio(t) {
        const e = this.pixelRatio;
        this.pixelRatio = t, this.setSize(this.getWidth() / e, this.getHeight() / e);
    }
    setWidth(t) {
        this.width = this._canvas.width = t * this.pixelRatio, this._canvas.style.width = t + "px";
        const e = this.pixelRatio;
        this.getContext()._context.scale(e, e);
    }
    setHeight(t) {
        this.height = this._canvas.height = t * this.pixelRatio, this._canvas.style.height = t + "px";
        const e = this.pixelRatio;
        this.getContext()._context.scale(e, e);
    }
    getWidth() {
        return this.width;
    }
    getHeight() {
        return this.height;
    }
    setSize(t, e) {
        this.setWidth(t || 0), this.setHeight(e || 0);
    }
    toDataURL(t, e) {
        try {
            return this._canvas.toDataURL(t, e);
        } catch  {
            try {
                return this._canvas.toDataURL();
            } catch (n) {
                return $47a4b45281b81a8b$var$Le.Util.error("Unable to get data URL. " + n.message + " For more info read https://konvajs.org/docs/posts/Tainted_Canvas.html."), "";
            }
        }
    }
}
$47a4b45281b81a8b$var$bt.Canvas = $47a4b45281b81a8b$var$He;
$47a4b45281b81a8b$var$os.Factory.addGetterSetter($47a4b45281b81a8b$var$He, "pixelRatio", void 0, (0, $47a4b45281b81a8b$var$ls.getNumberValidator)());
class $47a4b45281b81a8b$var$cs extends $47a4b45281b81a8b$var$He {
    constructor(t = {
        width: 0,
        height: 0,
        willReadFrequently: !1
    }){
        super(t), this.context = new $47a4b45281b81a8b$var$ir.SceneContext(this, {
            willReadFrequently: t.willReadFrequently
        }), this.setSize(t.width, t.height);
    }
}
$47a4b45281b81a8b$var$bt.SceneCanvas = $47a4b45281b81a8b$var$cs;
class $47a4b45281b81a8b$var$ds extends $47a4b45281b81a8b$var$He {
    constructor(t = {
        width: 0,
        height: 0
    }){
        super(t), this.hitCanvas = !0, this.context = new $47a4b45281b81a8b$var$ir.HitContext(this), this.setSize(t.width, t.height);
    }
}
$47a4b45281b81a8b$var$bt.HitCanvas = $47a4b45281b81a8b$var$ds;
var $47a4b45281b81a8b$var$Ve = {};
(function(l) {
    Object.defineProperty(l, "__esModule", {
        value: !0
    }), l.DD = void 0;
    const t = $47a4b45281b81a8b$var$H, e = $47a4b45281b81a8b$var$nt;
    l.DD = {
        get isDragging () {
            let i = !1;
            return l.DD._dragElements.forEach((n)=>{
                n.dragStatus === "dragging" && (i = !0);
            }), i;
        },
        justDragged: !1,
        get node () {
            let i;
            return l.DD._dragElements.forEach((n)=>{
                i = n.node;
            }), i;
        },
        _dragElements: /* @__PURE__ */ new Map(),
        _drag (i) {
            const n = [];
            l.DD._dragElements.forEach((r, s)=>{
                const { node: a } = r, o = a.getStage();
                o.setPointersPositions(i), r.pointerId === void 0 && (r.pointerId = e.Util._getFirstPointerId(i));
                const h = o._changedPointerPositions.find((c)=>c.id === r.pointerId);
                if (h) {
                    if (r.dragStatus !== "dragging") {
                        const c = a.dragDistance();
                        if (Math.max(Math.abs(h.x - r.startPointerPos.x), Math.abs(h.y - r.startPointerPos.y)) < c || (a.startDrag({
                            evt: i
                        }), !a.isDragging())) return;
                    }
                    a._setDragPosition(i, r), n.push(a);
                }
            }), n.forEach((r)=>{
                r.fire("dragmove", {
                    type: "dragmove",
                    target: r,
                    evt: i
                }, !0);
            });
        },
        _endDragBefore (i) {
            const n = [];
            l.DD._dragElements.forEach((r)=>{
                const { node: s } = r, a = s.getStage();
                if (i && a.setPointersPositions(i), !a._changedPointerPositions.find((c)=>c.id === r.pointerId)) return;
                (r.dragStatus === "dragging" || r.dragStatus === "stopped") && (l.DD.justDragged = !0, t.Konva._mouseListenClick = !1, t.Konva._touchListenClick = !1, t.Konva._pointerListenClick = !1, r.dragStatus = "stopped");
                const h = r.node.getLayer() || r.node instanceof t.Konva.Stage && r.node;
                h && n.indexOf(h) === -1 && n.push(h);
            }), n.forEach((r)=>{
                r.draw();
            });
        },
        _endDragAfter (i) {
            l.DD._dragElements.forEach((n, r)=>{
                n.dragStatus === "stopped" && n.node.fire("dragend", {
                    type: "dragend",
                    target: n.node,
                    evt: i
                }, !0), n.dragStatus !== "dragging" && l.DD._dragElements.delete(r);
            });
        }
    }, t.Konva.isBrowser && (window.addEventListener("mouseup", l.DD._endDragBefore, !0), window.addEventListener("touchend", l.DD._endDragBefore, !0), window.addEventListener("touchcancel", l.DD._endDragBefore, !0), window.addEventListener("mousemove", l.DD._drag), window.addEventListener("touchmove", l.DD._drag), window.addEventListener("mouseup", l.DD._endDragAfter, !1), window.addEventListener("touchend", l.DD._endDragAfter, !1), window.addEventListener("touchcancel", l.DD._endDragAfter, !1));
})($47a4b45281b81a8b$var$Ve);
Object.defineProperty($47a4b45281b81a8b$var$et, "__esModule", {
    value: !0
});
$47a4b45281b81a8b$var$et.Node = void 0;
const $47a4b45281b81a8b$var$$ = $47a4b45281b81a8b$var$nt, $47a4b45281b81a8b$var$we = $47a4b45281b81a8b$var$V, $47a4b45281b81a8b$var$me = $47a4b45281b81a8b$var$bt, $47a4b45281b81a8b$var$Dt = $47a4b45281b81a8b$var$H, $47a4b45281b81a8b$var$_t = $47a4b45281b81a8b$var$Ve, $47a4b45281b81a8b$var$lt = $47a4b45281b81a8b$var$L, $47a4b45281b81a8b$var$Oe = "absoluteOpacity", $47a4b45281b81a8b$var$Pe = "allEventListeners", $47a4b45281b81a8b$var$Et = "absoluteTransform", $47a4b45281b81a8b$var$_n = "absoluteScale", $47a4b45281b81a8b$var$$t = "canvas", $47a4b45281b81a8b$var$us = "Change", $47a4b45281b81a8b$var$gs = "children", $47a4b45281b81a8b$var$fs = "konva", $47a4b45281b81a8b$var$$i = "listening", $47a4b45281b81a8b$var$vn = "mouseenter", $47a4b45281b81a8b$var$bn = "mouseleave", $47a4b45281b81a8b$var$Sn = "set", $47a4b45281b81a8b$var$Cn = "Shape", $47a4b45281b81a8b$var$De = " ", $47a4b45281b81a8b$var$wn = "stage", $47a4b45281b81a8b$var$Lt = "transform", $47a4b45281b81a8b$var$ps = "Stage", $47a4b45281b81a8b$var$zi = "visible", $47a4b45281b81a8b$var$ms = [
    "xChange.konva",
    "yChange.konva",
    "scaleXChange.konva",
    "scaleYChange.konva",
    "skewXChange.konva",
    "skewYChange.konva",
    "rotationChange.konva",
    "offsetXChange.konva",
    "offsetYChange.konva",
    "transformsEnabledChange.konva"
].join($47a4b45281b81a8b$var$De);
let $47a4b45281b81a8b$var$ys = 1;
class $47a4b45281b81a8b$var$G {
    constructor(t){
        this._id = $47a4b45281b81a8b$var$ys++, this.eventListeners = {}, this.attrs = {}, this.index = 0, this._allEventListeners = null, this.parent = null, this._cache = /* @__PURE__ */ new Map(), this._attachedDepsListeners = /* @__PURE__ */ new Map(), this._lastPos = null, this._batchingTransformChange = !1, this._needClearTransformCache = !1, this._filterUpToDate = !1, this._isUnderCache = !1, this._dragEventId = null, this._shouldFireChangeEvents = !1, this.setAttrs(t), this._shouldFireChangeEvents = !0;
    }
    hasChildren() {
        return !1;
    }
    _clearCache(t) {
        (t === $47a4b45281b81a8b$var$Lt || t === $47a4b45281b81a8b$var$Et) && this._cache.get(t) ? this._cache.get(t).dirty = !0 : t ? this._cache.delete(t) : this._cache.clear();
    }
    _getCache(t, e) {
        let i = this._cache.get(t);
        return (i === void 0 || (t === $47a4b45281b81a8b$var$Lt || t === $47a4b45281b81a8b$var$Et) && i.dirty === !0) && (i = e.call(this), this._cache.set(t, i)), i;
    }
    _calculate(t, e, i) {
        if (!this._attachedDepsListeners.get(t)) {
            const n = e.map((r)=>r + "Change.konva").join($47a4b45281b81a8b$var$De);
            this.on(n, ()=>{
                this._clearCache(t);
            }), this._attachedDepsListeners.set(t, !0);
        }
        return this._getCache(t, i);
    }
    _getCanvasCache() {
        return this._cache.get($47a4b45281b81a8b$var$$t);
    }
    _clearSelfAndDescendantCache(t) {
        this._clearCache(t), t === $47a4b45281b81a8b$var$Et && this.fire("absoluteTransformChange");
    }
    clearCache() {
        if (this._cache.has($47a4b45281b81a8b$var$$t)) {
            const { scene: t, filter: e, hit: i } = this._cache.get($47a4b45281b81a8b$var$$t);
            $47a4b45281b81a8b$var$$.Util.releaseCanvas(t, e, i), this._cache.delete($47a4b45281b81a8b$var$$t);
        }
        return this._clearSelfAndDescendantCache(), this._requestDraw(), this;
    }
    cache(t) {
        const e = t || {};
        let i = {};
        (e.x === void 0 || e.y === void 0 || e.width === void 0 || e.height === void 0) && (i = this.getClientRect({
            skipTransform: !0,
            relativeTo: this.getParent() || void 0
        }));
        let n = Math.ceil(e.width || i.width), r = Math.ceil(e.height || i.height), s = e.pixelRatio, a = e.x === void 0 ? Math.floor(i.x) : e.x, o = e.y === void 0 ? Math.floor(i.y) : e.y, h = e.offset || 0, c = e.drawBorder || !1, y = e.hitCanvasPixelRatio || 1;
        if (!n || !r) {
            $47a4b45281b81a8b$var$$.Util.error("Can not cache the node. Width or height of the node equals 0. Caching is skipped.");
            return;
        }
        const g = Math.abs(Math.round(i.x) - a) > 0.5 ? 1 : 0, u = Math.abs(Math.round(i.y) - o) > 0.5 ? 1 : 0;
        n += h * 2 + g, r += h * 2 + u, a -= h, o -= h;
        const f = new $47a4b45281b81a8b$var$me.SceneCanvas({
            pixelRatio: s,
            width: n,
            height: r
        }), _ = new $47a4b45281b81a8b$var$me.SceneCanvas({
            pixelRatio: s,
            width: 0,
            height: 0,
            willReadFrequently: !0
        }), v = new $47a4b45281b81a8b$var$me.HitCanvas({
            pixelRatio: y,
            width: n,
            height: r
        }), C = f.getContext(), k = v.getContext();
        return v.isCache = !0, f.isCache = !0, this._cache.delete($47a4b45281b81a8b$var$$t), this._filterUpToDate = !1, e.imageSmoothingEnabled === !1 && (f.getContext()._context.imageSmoothingEnabled = !1, _.getContext()._context.imageSmoothingEnabled = !1), C.save(), k.save(), C.translate(-a, -o), k.translate(-a, -o), this._isUnderCache = !0, this._clearSelfAndDescendantCache($47a4b45281b81a8b$var$Oe), this._clearSelfAndDescendantCache($47a4b45281b81a8b$var$_n), this.drawScene(f, this), this.drawHit(v, this), this._isUnderCache = !1, C.restore(), k.restore(), c && (C.save(), C.beginPath(), C.rect(0, 0, n, r), C.closePath(), C.setAttr("strokeStyle", "red"), C.setAttr("lineWidth", 5), C.stroke(), C.restore()), this._cache.set($47a4b45281b81a8b$var$$t, {
            scene: f,
            filter: _,
            hit: v,
            x: a,
            y: o
        }), this._requestDraw(), this;
    }
    isCached() {
        return this._cache.has($47a4b45281b81a8b$var$$t);
    }
    getClientRect(t) {
        throw new Error('abstract "getClientRect" method call');
    }
    _transformedRect(t, e) {
        const i = [
            {
                x: t.x,
                y: t.y
            },
            {
                x: t.x + t.width,
                y: t.y
            },
            {
                x: t.x + t.width,
                y: t.y + t.height
            },
            {
                x: t.x,
                y: t.y + t.height
            }
        ];
        let n = 1 / 0, r = 1 / 0, s = -1 / 0, a = -1 / 0;
        const o = this.getAbsoluteTransform(e);
        return i.forEach(function(h) {
            const c = o.point(h);
            n === void 0 && (n = s = c.x, r = a = c.y), n = Math.min(n, c.x), r = Math.min(r, c.y), s = Math.max(s, c.x), a = Math.max(a, c.y);
        }), {
            x: n,
            y: r,
            width: s - n,
            height: a - r
        };
    }
    _drawCachedSceneCanvas(t) {
        t.save(), t._applyOpacity(this), t._applyGlobalCompositeOperation(this);
        const e = this._getCanvasCache();
        t.translate(e.x, e.y);
        const i = this._getCachedSceneCanvas(), n = i.pixelRatio;
        t.drawImage(i._canvas, 0, 0, i.width / n, i.height / n), t.restore();
    }
    _drawCachedHitCanvas(t) {
        const e = this._getCanvasCache(), i = e.hit;
        t.save(), t.translate(e.x, e.y), t.drawImage(i._canvas, 0, 0, i.width / i.pixelRatio, i.height / i.pixelRatio), t.restore();
    }
    _getCachedSceneCanvas() {
        let t = this.filters(), e = this._getCanvasCache(), i = e.scene, n = e.filter, r = n.getContext(), s, a, o, h;
        if (t) {
            if (!this._filterUpToDate) {
                const c = i.pixelRatio;
                n.setSize(i.width / i.pixelRatio, i.height / i.pixelRatio);
                try {
                    for(s = t.length, r.clear(), r.drawImage(i._canvas, 0, 0, i.getWidth() / c, i.getHeight() / c), a = r.getImageData(0, 0, n.getWidth(), n.getHeight()), o = 0; o < s; o++){
                        if (h = t[o], typeof h != "function") {
                            $47a4b45281b81a8b$var$$.Util.error("Filter should be type of function, but got " + typeof h + " instead. Please check correct filters");
                            continue;
                        }
                        h.call(this, a), r.putImageData(a, 0, 0);
                    }
                } catch (y) {
                    $47a4b45281b81a8b$var$$.Util.error("Unable to apply filter. " + y.message + " This post my help you https://konvajs.org/docs/posts/Tainted_Canvas.html.");
                }
                this._filterUpToDate = !0;
            }
            return n;
        }
        return i;
    }
    on(t, e) {
        if (this._cache && this._cache.delete($47a4b45281b81a8b$var$Pe), arguments.length === 3) return this._delegate.apply(this, arguments);
        let i = t.split($47a4b45281b81a8b$var$De), n = i.length, r, s, a, o, h;
        for(r = 0; r < n; r++)s = i[r], a = s.split("."), o = a[0], h = a[1] || "", this.eventListeners[o] || (this.eventListeners[o] = []), this.eventListeners[o].push({
            name: h,
            handler: e
        });
        return this;
    }
    off(t, e) {
        let i = (t || "").split($47a4b45281b81a8b$var$De), n = i.length, r, s, a, o, h, c;
        if (this._cache && this._cache.delete($47a4b45281b81a8b$var$Pe), !t) for(s in this.eventListeners)this._off(s);
        for(r = 0; r < n; r++)if (a = i[r], o = a.split("."), h = o[0], c = o[1], h) this.eventListeners[h] && this._off(h, c, e);
        else for(s in this.eventListeners)this._off(s, c, e);
        return this;
    }
    dispatchEvent(t) {
        const e = {
            target: this,
            type: t.type,
            evt: t
        };
        return this.fire(t.type, e), this;
    }
    addEventListener(t, e) {
        return this.on(t, function(i) {
            e.call(this, i.evt);
        }), this;
    }
    removeEventListener(t) {
        return this.off(t), this;
    }
    _delegate(t, e, i) {
        const n = this;
        this.on(t, function(r) {
            const s = r.target.findAncestors(e, !0, n);
            for(let a = 0; a < s.length; a++)r = $47a4b45281b81a8b$var$$.Util.cloneObject(r), r.currentTarget = s[a], i.call(s[a], r);
        });
    }
    remove() {
        return this.isDragging() && this.stopDrag(), $47a4b45281b81a8b$var$_t.DD._dragElements.delete(this._id), this._remove(), this;
    }
    _clearCaches() {
        this._clearSelfAndDescendantCache($47a4b45281b81a8b$var$Et), this._clearSelfAndDescendantCache($47a4b45281b81a8b$var$Oe), this._clearSelfAndDescendantCache($47a4b45281b81a8b$var$_n), this._clearSelfAndDescendantCache($47a4b45281b81a8b$var$wn), this._clearSelfAndDescendantCache($47a4b45281b81a8b$var$zi), this._clearSelfAndDescendantCache($47a4b45281b81a8b$var$$i);
    }
    _remove() {
        this._clearCaches();
        const t = this.getParent();
        t && t.children && (t.children.splice(this.index, 1), t._setChildrenIndices(), this.parent = null);
    }
    destroy() {
        return this.remove(), this.clearCache(), this;
    }
    getAttr(t) {
        const e = "get" + $47a4b45281b81a8b$var$$.Util._capitalize(t);
        return $47a4b45281b81a8b$var$$.Util._isFunction(this[e]) ? this[e]() : this.attrs[t];
    }
    getAncestors() {
        let t = this.getParent(), e = [];
        for(; t;)e.push(t), t = t.getParent();
        return e;
    }
    getAttrs() {
        return this.attrs || {};
    }
    setAttrs(t) {
        return this._batchTransformChanges(()=>{
            let e, i;
            if (!t) return this;
            for(e in t)e !== $47a4b45281b81a8b$var$gs && (i = $47a4b45281b81a8b$var$Sn + $47a4b45281b81a8b$var$$.Util._capitalize(e), $47a4b45281b81a8b$var$$.Util._isFunction(this[i]) ? this[i](t[e]) : this._setAttr(e, t[e]));
        }), this;
    }
    isListening() {
        return this._getCache($47a4b45281b81a8b$var$$i, this._isListening);
    }
    _isListening(t) {
        if (!this.listening()) return !1;
        const i = this.getParent();
        return i && i !== t && this !== t ? i._isListening(t) : !0;
    }
    isVisible() {
        return this._getCache($47a4b45281b81a8b$var$zi, this._isVisible);
    }
    _isVisible(t) {
        if (!this.visible()) return !1;
        const i = this.getParent();
        return i && i !== t && this !== t ? i._isVisible(t) : !0;
    }
    shouldDrawHit(t, e = !1) {
        if (t) return this._isVisible(t) && this._isListening(t);
        const i = this.getLayer();
        let n = !1;
        $47a4b45281b81a8b$var$_t.DD._dragElements.forEach((s)=>{
            s.dragStatus === "dragging" && (s.node.nodeType === "Stage" || s.node.getLayer() === i) && (n = !0);
        });
        const r = !e && !$47a4b45281b81a8b$var$Dt.Konva.hitOnDragEnabled && (n || $47a4b45281b81a8b$var$Dt.Konva.isTransforming());
        return this.isListening() && this.isVisible() && !r;
    }
    show() {
        return this.visible(!0), this;
    }
    hide() {
        return this.visible(!1), this;
    }
    getZIndex() {
        return this.index || 0;
    }
    getAbsoluteZIndex() {
        let t = this.getDepth(), e = this, i = 0, n, r, s, a;
        function o(c) {
            for(n = [], r = c.length, s = 0; s < r; s++)a = c[s], i++, a.nodeType !== $47a4b45281b81a8b$var$Cn && (n = n.concat(a.getChildren().slice())), a._id === e._id && (s = r);
            n.length > 0 && n[0].getDepth() <= t && o(n);
        }
        const h = this.getStage();
        return e.nodeType !== $47a4b45281b81a8b$var$ps && h && o(h.getChildren()), i;
    }
    getDepth() {
        let t = 0, e = this.parent;
        for(; e;)t++, e = e.parent;
        return t;
    }
    _batchTransformChanges(t) {
        this._batchingTransformChange = !0, t(), this._batchingTransformChange = !1, this._needClearTransformCache && (this._clearCache($47a4b45281b81a8b$var$Lt), this._clearSelfAndDescendantCache($47a4b45281b81a8b$var$Et)), this._needClearTransformCache = !1;
    }
    setPosition(t) {
        return this._batchTransformChanges(()=>{
            this.x(t.x), this.y(t.y);
        }), this;
    }
    getPosition() {
        return {
            x: this.x(),
            y: this.y()
        };
    }
    getRelativePointerPosition() {
        const t = this.getStage();
        if (!t) return null;
        const e = t.getPointerPosition();
        if (!e) return null;
        const i = this.getAbsoluteTransform().copy();
        return i.invert(), i.point(e);
    }
    getAbsolutePosition(t) {
        let e = !1, i = this.parent;
        for(; i;){
            if (i.isCached()) {
                e = !0;
                break;
            }
            i = i.parent;
        }
        e && !t && (t = !0);
        const n = this.getAbsoluteTransform(t).getMatrix(), r = new $47a4b45281b81a8b$var$$.Transform(), s = this.offset();
        return r.m = n.slice(), r.translate(s.x, s.y), r.getTranslation();
    }
    setAbsolutePosition(t) {
        const { x: e, y: i, ...n } = this._clearTransform();
        this.attrs.x = e, this.attrs.y = i, this._clearCache($47a4b45281b81a8b$var$Lt);
        const r = this._getAbsoluteTransform().copy();
        return r.invert(), r.translate(t.x, t.y), t = {
            x: this.attrs.x + r.getTranslation().x,
            y: this.attrs.y + r.getTranslation().y
        }, this._setTransform(n), this.setPosition({
            x: t.x,
            y: t.y
        }), this._clearCache($47a4b45281b81a8b$var$Lt), this._clearSelfAndDescendantCache($47a4b45281b81a8b$var$Et), this;
    }
    _setTransform(t) {
        let e;
        for(e in t)this.attrs[e] = t[e];
    }
    _clearTransform() {
        const t = {
            x: this.x(),
            y: this.y(),
            rotation: this.rotation(),
            scaleX: this.scaleX(),
            scaleY: this.scaleY(),
            offsetX: this.offsetX(),
            offsetY: this.offsetY(),
            skewX: this.skewX(),
            skewY: this.skewY()
        };
        return this.attrs.x = 0, this.attrs.y = 0, this.attrs.rotation = 0, this.attrs.scaleX = 1, this.attrs.scaleY = 1, this.attrs.offsetX = 0, this.attrs.offsetY = 0, this.attrs.skewX = 0, this.attrs.skewY = 0, t;
    }
    move(t) {
        let e = t.x, i = t.y, n = this.x(), r = this.y();
        return e !== void 0 && (n += e), i !== void 0 && (r += i), this.setPosition({
            x: n,
            y: r
        }), this;
    }
    _eachAncestorReverse(t, e) {
        let i = [], n = this.getParent(), r, s;
        if (!(e && e._id === this._id)) {
            for(i.unshift(this); n && (!e || n._id !== e._id);)i.unshift(n), n = n.parent;
            for(r = i.length, s = 0; s < r; s++)t(i[s]);
        }
    }
    rotate(t) {
        return this.rotation(this.rotation() + t), this;
    }
    moveToTop() {
        if (!this.parent) return $47a4b45281b81a8b$var$$.Util.warn("Node has no parent. moveToTop function is ignored."), !1;
        const t = this.index, e = this.parent.getChildren().length;
        return t < e - 1 ? (this.parent.children.splice(t, 1), this.parent.children.push(this), this.parent._setChildrenIndices(), !0) : !1;
    }
    moveUp() {
        if (!this.parent) return $47a4b45281b81a8b$var$$.Util.warn("Node has no parent. moveUp function is ignored."), !1;
        const t = this.index, e = this.parent.getChildren().length;
        return t < e - 1 ? (this.parent.children.splice(t, 1), this.parent.children.splice(t + 1, 0, this), this.parent._setChildrenIndices(), !0) : !1;
    }
    moveDown() {
        if (!this.parent) return $47a4b45281b81a8b$var$$.Util.warn("Node has no parent. moveDown function is ignored."), !1;
        const t = this.index;
        return t > 0 ? (this.parent.children.splice(t, 1), this.parent.children.splice(t - 1, 0, this), this.parent._setChildrenIndices(), !0) : !1;
    }
    moveToBottom() {
        if (!this.parent) return $47a4b45281b81a8b$var$$.Util.warn("Node has no parent. moveToBottom function is ignored."), !1;
        const t = this.index;
        return t > 0 ? (this.parent.children.splice(t, 1), this.parent.children.unshift(this), this.parent._setChildrenIndices(), !0) : !1;
    }
    setZIndex(t) {
        if (!this.parent) return $47a4b45281b81a8b$var$$.Util.warn("Node has no parent. zIndex parameter is ignored."), this;
        (t < 0 || t >= this.parent.children.length) && $47a4b45281b81a8b$var$$.Util.warn("Unexpected value " + t + " for zIndex property. zIndex is just index of a node in children of its parent. Expected value is from 0 to " + (this.parent.children.length - 1) + ".");
        const e = this.index;
        return this.parent.children.splice(e, 1), this.parent.children.splice(t, 0, this), this.parent._setChildrenIndices(), this;
    }
    getAbsoluteOpacity() {
        return this._getCache($47a4b45281b81a8b$var$Oe, this._getAbsoluteOpacity);
    }
    _getAbsoluteOpacity() {
        let t = this.opacity();
        const e = this.getParent();
        return e && !e._isUnderCache && (t *= e.getAbsoluteOpacity()), t;
    }
    moveTo(t) {
        return this.getParent() !== t && (this._remove(), t.add(this)), this;
    }
    toObject() {
        let t = this.getAttrs(), e, i, n, r, s;
        const a = {
            attrs: {},
            className: this.getClassName()
        };
        for(e in t)i = t[e], s = $47a4b45281b81a8b$var$$.Util.isObject(i) && !$47a4b45281b81a8b$var$$.Util._isPlainObject(i) && !$47a4b45281b81a8b$var$$.Util._isArray(i), !s && (n = typeof this[e] == "function" && this[e], delete t[e], r = n ? n.call(this) : null, t[e] = i, r !== i && (a.attrs[e] = i));
        return $47a4b45281b81a8b$var$$.Util._prepareToStringify(a);
    }
    toJSON() {
        return JSON.stringify(this.toObject());
    }
    getParent() {
        return this.parent;
    }
    findAncestors(t, e, i) {
        const n = [];
        e && this._isMatch(t) && n.push(this);
        let r = this.parent;
        for(; r;){
            if (r === i) return n;
            r._isMatch(t) && n.push(r), r = r.parent;
        }
        return n;
    }
    isAncestorOf(t) {
        return !1;
    }
    findAncestor(t, e, i) {
        return this.findAncestors(t, e, i)[0];
    }
    _isMatch(t) {
        if (!t) return !1;
        if (typeof t == "function") return t(this);
        let e = t.replace(/ /g, "").split(","), i = e.length, n, r;
        for(n = 0; n < i; n++)if (r = e[n], $47a4b45281b81a8b$var$$.Util.isValidSelector(r) || ($47a4b45281b81a8b$var$$.Util.warn('Selector "' + r + '" is invalid. Allowed selectors examples are "#foo", ".bar" or "Group".'), $47a4b45281b81a8b$var$$.Util.warn('If you have a custom shape with such className, please change it to start with upper letter like "Triangle".'), $47a4b45281b81a8b$var$$.Util.warn("Konva is awesome, right?")), r.charAt(0) === "#") {
            if (this.id() === r.slice(1)) return !0;
        } else if (r.charAt(0) === ".") {
            if (this.hasName(r.slice(1))) return !0;
        } else if (this.className === r || this.nodeType === r) return !0;
        return !1;
    }
    getLayer() {
        const t = this.getParent();
        return t ? t.getLayer() : null;
    }
    getStage() {
        return this._getCache($47a4b45281b81a8b$var$wn, this._getStage);
    }
    _getStage() {
        const t = this.getParent();
        return t ? t.getStage() : null;
    }
    fire(t, e = {}, i) {
        return e.target = e.target || this, i ? this._fireAndBubble(t, e) : this._fire(t, e), this;
    }
    getAbsoluteTransform(t) {
        return t ? this._getAbsoluteTransform(t) : this._getCache($47a4b45281b81a8b$var$Et, this._getAbsoluteTransform);
    }
    _getAbsoluteTransform(t) {
        let e;
        if (t) return e = new $47a4b45281b81a8b$var$$.Transform(), this._eachAncestorReverse(function(i) {
            const n = i.transformsEnabled();
            n === "all" ? e.multiply(i.getTransform()) : n === "position" && e.translate(i.x() - i.offsetX(), i.y() - i.offsetY());
        }, t), e;
        {
            e = this._cache.get($47a4b45281b81a8b$var$Et) || new $47a4b45281b81a8b$var$$.Transform(), this.parent ? this.parent.getAbsoluteTransform().copyInto(e) : e.reset();
            const i = this.transformsEnabled();
            if (i === "all") e.multiply(this.getTransform());
            else if (i === "position") {
                const n = this.attrs.x || 0, r = this.attrs.y || 0, s = this.attrs.offsetX || 0, a = this.attrs.offsetY || 0;
                e.translate(n - s, r - a);
            }
            return e.dirty = !1, e;
        }
    }
    getAbsoluteScale(t) {
        let e = this;
        for(; e;)e._isUnderCache && (t = e), e = e.getParent();
        const n = this.getAbsoluteTransform(t).decompose();
        return {
            x: n.scaleX,
            y: n.scaleY
        };
    }
    getAbsoluteRotation() {
        return this.getAbsoluteTransform().decompose().rotation;
    }
    getTransform() {
        return this._getCache($47a4b45281b81a8b$var$Lt, this._getTransform);
    }
    _getTransform() {
        var t, e;
        const i = this._cache.get($47a4b45281b81a8b$var$Lt) || new $47a4b45281b81a8b$var$$.Transform();
        i.reset();
        const n = this.x(), r = this.y(), s = $47a4b45281b81a8b$var$Dt.Konva.getAngle(this.rotation()), a = (t = this.attrs.scaleX) !== null && t !== void 0 ? t : 1, o = (e = this.attrs.scaleY) !== null && e !== void 0 ? e : 1, h = this.attrs.skewX || 0, c = this.attrs.skewY || 0, y = this.attrs.offsetX || 0, g = this.attrs.offsetY || 0;
        return (n !== 0 || r !== 0) && i.translate(n, r), s !== 0 && i.rotate(s), (h !== 0 || c !== 0) && i.skew(h, c), (a !== 1 || o !== 1) && i.scale(a, o), (y !== 0 || g !== 0) && i.translate(-1 * y, -1 * g), i.dirty = !1, i;
    }
    clone(t) {
        let e = $47a4b45281b81a8b$var$$.Util.cloneObject(this.attrs), i, n, r, s, a;
        for(i in t)e[i] = t[i];
        const o = new this.constructor(e);
        for(i in this.eventListeners)for(n = this.eventListeners[i], r = n.length, s = 0; s < r; s++)a = n[s], a.name.indexOf($47a4b45281b81a8b$var$fs) < 0 && (o.eventListeners[i] || (o.eventListeners[i] = []), o.eventListeners[i].push(a));
        return o;
    }
    _toKonvaCanvas(t) {
        t = t || {};
        const e = this.getClientRect(), i = this.getStage(), n = t.x !== void 0 ? t.x : Math.floor(e.x), r = t.y !== void 0 ? t.y : Math.floor(e.y), s = t.pixelRatio || 1, a = new $47a4b45281b81a8b$var$me.SceneCanvas({
            width: t.width || Math.ceil(e.width) || (i ? i.width() : 0),
            height: t.height || Math.ceil(e.height) || (i ? i.height() : 0),
            pixelRatio: s
        }), o = a.getContext(), h = new $47a4b45281b81a8b$var$me.SceneCanvas({
            width: a.width / a.pixelRatio + Math.abs(n),
            height: a.height / a.pixelRatio + Math.abs(r),
            pixelRatio: a.pixelRatio
        });
        return t.imageSmoothingEnabled === !1 && (o._context.imageSmoothingEnabled = !1), o.save(), (n || r) && o.translate(-1 * n, -1 * r), this.drawScene(a, void 0, h), o.restore(), a;
    }
    toCanvas(t) {
        return this._toKonvaCanvas(t)._canvas;
    }
    toDataURL(t) {
        t = t || {};
        const e = t.mimeType || null, i = t.quality || null, n = this._toKonvaCanvas(t).toDataURL(e, i);
        return t.callback && t.callback(n), n;
    }
    toImage(t) {
        return new Promise((e, i)=>{
            try {
                const n = t == null ? void 0 : t.callback;
                n && delete t.callback, $47a4b45281b81a8b$var$$.Util._urlToImage(this.toDataURL(t), function(r) {
                    e(r), n == null || n(r);
                });
            } catch (n) {
                i(n);
            }
        });
    }
    toBlob(t) {
        return new Promise((e, i)=>{
            try {
                const n = t == null ? void 0 : t.callback;
                n && delete t.callback, this.toCanvas(t).toBlob((r)=>{
                    e(r), n == null || n(r);
                }, t == null ? void 0 : t.mimeType, t == null ? void 0 : t.quality);
            } catch (n) {
                i(n);
            }
        });
    }
    setSize(t) {
        return this.width(t.width), this.height(t.height), this;
    }
    getSize() {
        return {
            width: this.width(),
            height: this.height()
        };
    }
    getClassName() {
        return this.className || this.nodeType;
    }
    getType() {
        return this.nodeType;
    }
    getDragDistance() {
        return this.attrs.dragDistance !== void 0 ? this.attrs.dragDistance : this.parent ? this.parent.getDragDistance() : $47a4b45281b81a8b$var$Dt.Konva.dragDistance;
    }
    _off(t, e, i) {
        let n = this.eventListeners[t], r, s, a;
        for(r = 0; r < n.length; r++)if (s = n[r].name, a = n[r].handler, (s !== "konva" || e === "konva") && (!e || s === e) && (!i || i === a)) {
            if (n.splice(r, 1), n.length === 0) {
                delete this.eventListeners[t];
                break;
            }
            r--;
        }
    }
    _fireChangeEvent(t, e, i) {
        this._fire(t + $47a4b45281b81a8b$var$us, {
            oldVal: e,
            newVal: i
        });
    }
    addName(t) {
        if (!this.hasName(t)) {
            const e = this.name(), i = e ? e + " " + t : t;
            this.name(i);
        }
        return this;
    }
    hasName(t) {
        if (!t) return !1;
        const e = this.name();
        return e ? (e || "").split(/\s/g).indexOf(t) !== -1 : !1;
    }
    removeName(t) {
        const e = (this.name() || "").split(/\s/g), i = e.indexOf(t);
        return i !== -1 && (e.splice(i, 1), this.name(e.join(" "))), this;
    }
    setAttr(t, e) {
        const i = this[$47a4b45281b81a8b$var$Sn + $47a4b45281b81a8b$var$$.Util._capitalize(t)];
        return $47a4b45281b81a8b$var$$.Util._isFunction(i) ? i.call(this, e) : this._setAttr(t, e), this;
    }
    _requestDraw() {
        if ($47a4b45281b81a8b$var$Dt.Konva.autoDrawEnabled) {
            const t = this.getLayer() || this.getStage();
            t == null || t.batchDraw();
        }
    }
    _setAttr(t, e) {
        const i = this.attrs[t];
        i === e && !$47a4b45281b81a8b$var$$.Util.isObject(e) || (e == null ? delete this.attrs[t] : this.attrs[t] = e, this._shouldFireChangeEvents && this._fireChangeEvent(t, i, e), this._requestDraw());
    }
    _setComponentAttr(t, e, i) {
        let n;
        i !== void 0 && (n = this.attrs[t], n || (this.attrs[t] = this.getAttr(t)), this.attrs[t][e] = i, this._fireChangeEvent(t, n, i));
    }
    _fireAndBubble(t, e, i) {
        if (e && this.nodeType === $47a4b45281b81a8b$var$Cn && (e.target = this), !((t === $47a4b45281b81a8b$var$vn || t === $47a4b45281b81a8b$var$bn) && (i && (this === i || this.isAncestorOf && this.isAncestorOf(i)) || this.nodeType === "Stage" && !i))) {
            this._fire(t, e);
            const r = (t === $47a4b45281b81a8b$var$vn || t === $47a4b45281b81a8b$var$bn) && i && i.isAncestorOf && i.isAncestorOf(this) && !i.isAncestorOf(this.parent);
            (e && !e.cancelBubble || !e) && this.parent && this.parent.isListening() && !r && (i && i.parent ? this._fireAndBubble.call(this.parent, t, e, i) : this._fireAndBubble.call(this.parent, t, e));
        }
    }
    _getProtoListeners(t) {
        var e, i, n;
        const r = (e = this._cache.get($47a4b45281b81a8b$var$Pe)) !== null && e !== void 0 ? e : {};
        let s = r == null ? void 0 : r[t];
        if (s === void 0) {
            s = [];
            let a = Object.getPrototypeOf(this);
            for(; a;){
                const o = (n = (i = a.eventListeners) === null || i === void 0 ? void 0 : i[t]) !== null && n !== void 0 ? n : [];
                s.push(...o), a = Object.getPrototypeOf(a);
            }
            r[t] = s, this._cache.set($47a4b45281b81a8b$var$Pe, r);
        }
        return s;
    }
    _fire(t, e) {
        e = e || {}, e.currentTarget = this, e.type = t;
        const i = this._getProtoListeners(t);
        if (i) for(var n = 0; n < i.length; n++)i[n].handler.call(this, e);
        const r = this.eventListeners[t];
        if (r) for(var n = 0; n < r.length; n++)r[n].handler.call(this, e);
    }
    draw() {
        return this.drawScene(), this.drawHit(), this;
    }
    _createDragElement(t) {
        const e = t ? t.pointerId : void 0, i = this.getStage(), n = this.getAbsolutePosition();
        if (!i) return;
        const r = i._getPointerById(e) || i._changedPointerPositions[0] || n;
        $47a4b45281b81a8b$var$_t.DD._dragElements.set(this._id, {
            node: this,
            startPointerPos: r,
            offset: {
                x: r.x - n.x,
                y: r.y - n.y
            },
            dragStatus: "ready",
            pointerId: e
        });
    }
    startDrag(t, e = !0) {
        $47a4b45281b81a8b$var$_t.DD._dragElements.has(this._id) || this._createDragElement(t);
        const i = $47a4b45281b81a8b$var$_t.DD._dragElements.get(this._id);
        i.dragStatus = "dragging", this.fire("dragstart", {
            type: "dragstart",
            target: this,
            evt: t && t.evt
        }, e);
    }
    _setDragPosition(t, e) {
        const i = this.getStage()._getPointerById(e.pointerId);
        if (!i) return;
        let n = {
            x: i.x - e.offset.x,
            y: i.y - e.offset.y
        };
        const r = this.dragBoundFunc();
        if (r !== void 0) {
            const s = r.call(this, n, t);
            s ? n = s : $47a4b45281b81a8b$var$$.Util.warn("dragBoundFunc did not return any value. That is unexpected behavior. You must return new absolute position from dragBoundFunc.");
        }
        (!this._lastPos || this._lastPos.x !== n.x || this._lastPos.y !== n.y) && (this.setAbsolutePosition(n), this._requestDraw()), this._lastPos = n;
    }
    stopDrag(t) {
        const e = $47a4b45281b81a8b$var$_t.DD._dragElements.get(this._id);
        e && (e.dragStatus = "stopped"), $47a4b45281b81a8b$var$_t.DD._endDragBefore(t), $47a4b45281b81a8b$var$_t.DD._endDragAfter(t);
    }
    setDraggable(t) {
        this._setAttr("draggable", t), this._dragChange();
    }
    isDragging() {
        const t = $47a4b45281b81a8b$var$_t.DD._dragElements.get(this._id);
        return t ? t.dragStatus === "dragging" : !1;
    }
    _listenDrag() {
        this._dragCleanup(), this.on("mousedown.konva touchstart.konva", function(t) {
            if (!(!(t.evt.button !== void 0) || $47a4b45281b81a8b$var$Dt.Konva.dragButtons.indexOf(t.evt.button) >= 0) || this.isDragging()) return;
            let n = !1;
            $47a4b45281b81a8b$var$_t.DD._dragElements.forEach((r)=>{
                this.isAncestorOf(r.node) && (n = !0);
            }), n || this._createDragElement(t);
        });
    }
    _dragChange() {
        if (this.attrs.draggable) this._listenDrag();
        else {
            if (this._dragCleanup(), !this.getStage()) return;
            const e = $47a4b45281b81a8b$var$_t.DD._dragElements.get(this._id), i = e && e.dragStatus === "dragging", n = e && e.dragStatus === "ready";
            i ? this.stopDrag() : n && $47a4b45281b81a8b$var$_t.DD._dragElements.delete(this._id);
        }
    }
    _dragCleanup() {
        this.off("mousedown.konva"), this.off("touchstart.konva");
    }
    isClientRectOnScreen(t = {
        x: 0,
        y: 0
    }) {
        const e = this.getStage();
        if (!e) return !1;
        const i = {
            x: -t.x,
            y: -t.y,
            width: e.width() + 2 * t.x,
            height: e.height() + 2 * t.y
        };
        return $47a4b45281b81a8b$var$$.Util.haveIntersection(i, this.getClientRect());
    }
    static create(t, e) {
        return $47a4b45281b81a8b$var$$.Util._isString(t) && (t = JSON.parse(t)), this._createNode(t, e);
    }
    static _createNode(t, e) {
        let i = $47a4b45281b81a8b$var$G.prototype.getClassName.call(t), n = t.children, r, s, a;
        e && (t.attrs.container = e), $47a4b45281b81a8b$var$Dt.Konva[i] || ($47a4b45281b81a8b$var$$.Util.warn('Can not find a node with class name "' + i + '". Fallback to "Shape".'), i = "Shape");
        const o = $47a4b45281b81a8b$var$Dt.Konva[i];
        if (r = new o(t.attrs), n) for(s = n.length, a = 0; a < s; a++)r.add($47a4b45281b81a8b$var$G._createNode(n[a]));
        return r;
    }
}
$47a4b45281b81a8b$var$et.Node = $47a4b45281b81a8b$var$G;
$47a4b45281b81a8b$var$G.prototype.nodeType = "Node";
$47a4b45281b81a8b$var$G.prototype._attrsAffectingSize = [];
$47a4b45281b81a8b$var$G.prototype.eventListeners = {};
$47a4b45281b81a8b$var$G.prototype.on.call($47a4b45281b81a8b$var$G.prototype, $47a4b45281b81a8b$var$ms, function() {
    if (this._batchingTransformChange) {
        this._needClearTransformCache = !0;
        return;
    }
    this._clearCache($47a4b45281b81a8b$var$Lt), this._clearSelfAndDescendantCache($47a4b45281b81a8b$var$Et);
});
$47a4b45281b81a8b$var$G.prototype.on.call($47a4b45281b81a8b$var$G.prototype, "visibleChange.konva", function() {
    this._clearSelfAndDescendantCache($47a4b45281b81a8b$var$zi);
});
$47a4b45281b81a8b$var$G.prototype.on.call($47a4b45281b81a8b$var$G.prototype, "listeningChange.konva", function() {
    this._clearSelfAndDescendantCache($47a4b45281b81a8b$var$$i);
});
$47a4b45281b81a8b$var$G.prototype.on.call($47a4b45281b81a8b$var$G.prototype, "opacityChange.konva", function() {
    this._clearSelfAndDescendantCache($47a4b45281b81a8b$var$Oe);
});
const $47a4b45281b81a8b$var$J = $47a4b45281b81a8b$var$we.Factory.addGetterSetter;
$47a4b45281b81a8b$var$J($47a4b45281b81a8b$var$G, "zIndex");
$47a4b45281b81a8b$var$J($47a4b45281b81a8b$var$G, "absolutePosition");
$47a4b45281b81a8b$var$J($47a4b45281b81a8b$var$G, "position");
$47a4b45281b81a8b$var$J($47a4b45281b81a8b$var$G, "x", 0, (0, $47a4b45281b81a8b$var$lt.getNumberValidator)());
$47a4b45281b81a8b$var$J($47a4b45281b81a8b$var$G, "y", 0, (0, $47a4b45281b81a8b$var$lt.getNumberValidator)());
$47a4b45281b81a8b$var$J($47a4b45281b81a8b$var$G, "globalCompositeOperation", "source-over", (0, $47a4b45281b81a8b$var$lt.getStringValidator)());
$47a4b45281b81a8b$var$J($47a4b45281b81a8b$var$G, "opacity", 1, (0, $47a4b45281b81a8b$var$lt.getNumberValidator)());
$47a4b45281b81a8b$var$J($47a4b45281b81a8b$var$G, "name", "", (0, $47a4b45281b81a8b$var$lt.getStringValidator)());
$47a4b45281b81a8b$var$J($47a4b45281b81a8b$var$G, "id", "", (0, $47a4b45281b81a8b$var$lt.getStringValidator)());
$47a4b45281b81a8b$var$J($47a4b45281b81a8b$var$G, "rotation", 0, (0, $47a4b45281b81a8b$var$lt.getNumberValidator)());
$47a4b45281b81a8b$var$we.Factory.addComponentsGetterSetter($47a4b45281b81a8b$var$G, "scale", [
    "x",
    "y"
]);
$47a4b45281b81a8b$var$J($47a4b45281b81a8b$var$G, "scaleX", 1, (0, $47a4b45281b81a8b$var$lt.getNumberValidator)());
$47a4b45281b81a8b$var$J($47a4b45281b81a8b$var$G, "scaleY", 1, (0, $47a4b45281b81a8b$var$lt.getNumberValidator)());
$47a4b45281b81a8b$var$we.Factory.addComponentsGetterSetter($47a4b45281b81a8b$var$G, "skew", [
    "x",
    "y"
]);
$47a4b45281b81a8b$var$J($47a4b45281b81a8b$var$G, "skewX", 0, (0, $47a4b45281b81a8b$var$lt.getNumberValidator)());
$47a4b45281b81a8b$var$J($47a4b45281b81a8b$var$G, "skewY", 0, (0, $47a4b45281b81a8b$var$lt.getNumberValidator)());
$47a4b45281b81a8b$var$we.Factory.addComponentsGetterSetter($47a4b45281b81a8b$var$G, "offset", [
    "x",
    "y"
]);
$47a4b45281b81a8b$var$J($47a4b45281b81a8b$var$G, "offsetX", 0, (0, $47a4b45281b81a8b$var$lt.getNumberValidator)());
$47a4b45281b81a8b$var$J($47a4b45281b81a8b$var$G, "offsetY", 0, (0, $47a4b45281b81a8b$var$lt.getNumberValidator)());
$47a4b45281b81a8b$var$J($47a4b45281b81a8b$var$G, "dragDistance", void 0, (0, $47a4b45281b81a8b$var$lt.getNumberValidator)());
$47a4b45281b81a8b$var$J($47a4b45281b81a8b$var$G, "width", 0, (0, $47a4b45281b81a8b$var$lt.getNumberValidator)());
$47a4b45281b81a8b$var$J($47a4b45281b81a8b$var$G, "height", 0, (0, $47a4b45281b81a8b$var$lt.getNumberValidator)());
$47a4b45281b81a8b$var$J($47a4b45281b81a8b$var$G, "listening", !0, (0, $47a4b45281b81a8b$var$lt.getBooleanValidator)());
$47a4b45281b81a8b$var$J($47a4b45281b81a8b$var$G, "preventDefault", !0, (0, $47a4b45281b81a8b$var$lt.getBooleanValidator)());
$47a4b45281b81a8b$var$J($47a4b45281b81a8b$var$G, "filters", void 0, function(l) {
    return this._filterUpToDate = !1, l;
});
$47a4b45281b81a8b$var$J($47a4b45281b81a8b$var$G, "visible", !0, (0, $47a4b45281b81a8b$var$lt.getBooleanValidator)());
$47a4b45281b81a8b$var$J($47a4b45281b81a8b$var$G, "transformsEnabled", "all", (0, $47a4b45281b81a8b$var$lt.getStringValidator)());
$47a4b45281b81a8b$var$J($47a4b45281b81a8b$var$G, "size");
$47a4b45281b81a8b$var$J($47a4b45281b81a8b$var$G, "dragBoundFunc");
$47a4b45281b81a8b$var$J($47a4b45281b81a8b$var$G, "draggable", !1, (0, $47a4b45281b81a8b$var$lt.getBooleanValidator)());
$47a4b45281b81a8b$var$we.Factory.backCompat($47a4b45281b81a8b$var$G, {
    rotateDeg: "rotate",
    setRotationDeg: "setRotation",
    getRotationDeg: "getRotation"
});
var $47a4b45281b81a8b$var$Wt = {};
Object.defineProperty($47a4b45281b81a8b$var$Wt, "__esModule", {
    value: !0
});
$47a4b45281b81a8b$var$Wt.Container = void 0;
const $47a4b45281b81a8b$var$he = $47a4b45281b81a8b$var$V, $47a4b45281b81a8b$var$Ri = $47a4b45281b81a8b$var$et, $47a4b45281b81a8b$var$$e = $47a4b45281b81a8b$var$L;
class $47a4b45281b81a8b$var$Xt extends $47a4b45281b81a8b$var$Ri.Node {
    constructor(){
        super(...arguments), this.children = [];
    }
    getChildren(t) {
        if (!t) return this.children || [];
        const e = this.children || [], i = [];
        return e.forEach(function(n) {
            t(n) && i.push(n);
        }), i;
    }
    hasChildren() {
        return this.getChildren().length > 0;
    }
    removeChildren() {
        return this.getChildren().forEach((t)=>{
            t.parent = null, t.index = 0, t.remove();
        }), this.children = [], this._requestDraw(), this;
    }
    destroyChildren() {
        return this.getChildren().forEach((t)=>{
            t.parent = null, t.index = 0, t.destroy();
        }), this.children = [], this._requestDraw(), this;
    }
    add(...t) {
        if (t.length === 0) return this;
        if (t.length > 1) {
            for(let i = 0; i < t.length; i++)this.add(t[i]);
            return this;
        }
        const e = t[0];
        return e.getParent() ? (e.moveTo(this), this) : (this._validateAdd(e), e.index = this.getChildren().length, e.parent = this, e._clearCaches(), this.getChildren().push(e), this._fire("add", {
            child: e
        }), this._requestDraw(), this);
    }
    destroy() {
        return this.hasChildren() && this.destroyChildren(), super.destroy(), this;
    }
    find(t) {
        return this._generalFind(t, !1);
    }
    findOne(t) {
        const e = this._generalFind(t, !0);
        return e.length > 0 ? e[0] : void 0;
    }
    _generalFind(t, e) {
        const i = [];
        return this._descendants((n)=>{
            const r = n._isMatch(t);
            return r && i.push(n), !!(r && e);
        }), i;
    }
    _descendants(t) {
        let e = !1;
        const i = this.getChildren();
        for (const n of i){
            if (e = t(n), e) return !0;
            if (n.hasChildren() && (e = n._descendants(t), e)) return !0;
        }
        return !1;
    }
    toObject() {
        const t = $47a4b45281b81a8b$var$Ri.Node.prototype.toObject.call(this);
        return t.children = [], this.getChildren().forEach((e)=>{
            t.children.push(e.toObject());
        }), t;
    }
    isAncestorOf(t) {
        let e = t.getParent();
        for(; e;){
            if (e._id === this._id) return !0;
            e = e.getParent();
        }
        return !1;
    }
    clone(t) {
        const e = $47a4b45281b81a8b$var$Ri.Node.prototype.clone.call(this, t);
        return this.getChildren().forEach(function(i) {
            e.add(i.clone());
        }), e;
    }
    getAllIntersections(t) {
        const e = [];
        return this.find("Shape").forEach((i)=>{
            i.isVisible() && i.intersects(t) && e.push(i);
        }), e;
    }
    _clearSelfAndDescendantCache(t) {
        var e;
        super._clearSelfAndDescendantCache(t), !this.isCached() && ((e = this.children) === null || e === void 0 || e.forEach(function(i) {
            i._clearSelfAndDescendantCache(t);
        }));
    }
    _setChildrenIndices() {
        var t;
        (t = this.children) === null || t === void 0 || t.forEach(function(e, i) {
            e.index = i;
        }), this._requestDraw();
    }
    drawScene(t, e, i) {
        const n = this.getLayer(), r = t || n && n.getCanvas(), s = r && r.getContext(), a = this._getCanvasCache(), o = a && a.scene, h = r && r.isCache;
        if (!this.isVisible() && !h) return this;
        if (o) {
            s.save();
            const c = this.getAbsoluteTransform(e).getMatrix();
            s.transform(c[0], c[1], c[2], c[3], c[4], c[5]), this._drawCachedSceneCanvas(s), s.restore();
        } else this._drawChildren("drawScene", r, e, i);
        return this;
    }
    drawHit(t, e) {
        if (!this.shouldDrawHit(e)) return this;
        const i = this.getLayer(), n = t || i && i.hitCanvas, r = n && n.getContext(), s = this._getCanvasCache();
        if (s && s.hit) {
            r.save();
            const o = this.getAbsoluteTransform(e).getMatrix();
            r.transform(o[0], o[1], o[2], o[3], o[4], o[5]), this._drawCachedHitCanvas(r), r.restore();
        } else this._drawChildren("drawHit", n, e);
        return this;
    }
    _drawChildren(t, e, i, n) {
        var r;
        const s = e && e.getContext(), a = this.clipWidth(), o = this.clipHeight(), h = this.clipFunc(), c = typeof a == "number" && typeof o == "number" || h, y = i === this;
        if (c) {
            s.save();
            const u = this.getAbsoluteTransform(i);
            let f = u.getMatrix();
            s.transform(f[0], f[1], f[2], f[3], f[4], f[5]), s.beginPath();
            let _;
            if (h) _ = h.call(this, s, this);
            else {
                const v = this.clipX(), C = this.clipY();
                s.rect(v || 0, C || 0, a, o);
            }
            s.clip.apply(s, _), f = u.copy().invert().getMatrix(), s.transform(f[0], f[1], f[2], f[3], f[4], f[5]);
        }
        const g = !y && this.globalCompositeOperation() !== "source-over" && t === "drawScene";
        g && (s.save(), s._applyGlobalCompositeOperation(this)), (r = this.children) === null || r === void 0 || r.forEach(function(u) {
            u[t](e, i, n);
        }), g && s.restore(), c && s.restore();
    }
    getClientRect(t = {}) {
        var e;
        const i = t.skipTransform, n = t.relativeTo;
        let r, s, a, o, h = {
            x: 1 / 0,
            y: 1 / 0,
            width: 0,
            height: 0
        };
        const c = this;
        (e = this.children) === null || e === void 0 || e.forEach(function(u) {
            if (!u.visible()) return;
            const f = u.getClientRect({
                relativeTo: c,
                skipShadow: t.skipShadow,
                skipStroke: t.skipStroke
            });
            f.width === 0 && f.height === 0 || (r === void 0 ? (r = f.x, s = f.y, a = f.x + f.width, o = f.y + f.height) : (r = Math.min(r, f.x), s = Math.min(s, f.y), a = Math.max(a, f.x + f.width), o = Math.max(o, f.y + f.height)));
        });
        const y = this.find("Shape");
        let g = !1;
        for(let u = 0; u < y.length; u++)if (y[u]._isVisible(this)) {
            g = !0;
            break;
        }
        return g && r !== void 0 ? h = {
            x: r,
            y: s,
            width: a - r,
            height: o - s
        } : h = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        }, i ? h : this._transformedRect(h, n);
    }
}
$47a4b45281b81a8b$var$Wt.Container = $47a4b45281b81a8b$var$Xt;
$47a4b45281b81a8b$var$he.Factory.addComponentsGetterSetter($47a4b45281b81a8b$var$Xt, "clip", [
    "x",
    "y",
    "width",
    "height"
]);
$47a4b45281b81a8b$var$he.Factory.addGetterSetter($47a4b45281b81a8b$var$Xt, "clipX", void 0, (0, $47a4b45281b81a8b$var$$e.getNumberValidator)());
$47a4b45281b81a8b$var$he.Factory.addGetterSetter($47a4b45281b81a8b$var$Xt, "clipY", void 0, (0, $47a4b45281b81a8b$var$$e.getNumberValidator)());
$47a4b45281b81a8b$var$he.Factory.addGetterSetter($47a4b45281b81a8b$var$Xt, "clipWidth", void 0, (0, $47a4b45281b81a8b$var$$e.getNumberValidator)());
$47a4b45281b81a8b$var$he.Factory.addGetterSetter($47a4b45281b81a8b$var$Xt, "clipHeight", void 0, (0, $47a4b45281b81a8b$var$$e.getNumberValidator)());
$47a4b45281b81a8b$var$he.Factory.addGetterSetter($47a4b45281b81a8b$var$Xt, "clipFunc");
var $47a4b45281b81a8b$var$rr = {}, $47a4b45281b81a8b$var$It = {};
Object.defineProperty($47a4b45281b81a8b$var$It, "__esModule", {
    value: !0
});
$47a4b45281b81a8b$var$It.getCapturedShape = $47a4b45281b81a8b$var$vs;
$47a4b45281b81a8b$var$It.createEvent = $47a4b45281b81a8b$var$Zi;
$47a4b45281b81a8b$var$It.hasPointerCapture = $47a4b45281b81a8b$var$bs;
$47a4b45281b81a8b$var$It.setPointerCapture = $47a4b45281b81a8b$var$Ss;
$47a4b45281b81a8b$var$It.releaseCapture = $47a4b45281b81a8b$var$ar;
const $47a4b45281b81a8b$var$_s = $47a4b45281b81a8b$var$H, $47a4b45281b81a8b$var$Se = /* @__PURE__ */ new Map(), $47a4b45281b81a8b$var$sr = $47a4b45281b81a8b$var$_s.Konva._global.PointerEvent !== void 0;
function $47a4b45281b81a8b$var$vs(l) {
    return $47a4b45281b81a8b$var$Se.get(l);
}
function $47a4b45281b81a8b$var$Zi(l) {
    return {
        evt: l,
        pointerId: l.pointerId
    };
}
function $47a4b45281b81a8b$var$bs(l, t) {
    return $47a4b45281b81a8b$var$Se.get(l) === t;
}
function $47a4b45281b81a8b$var$Ss(l, t) {
    $47a4b45281b81a8b$var$ar(l), t.getStage() && ($47a4b45281b81a8b$var$Se.set(l, t), $47a4b45281b81a8b$var$sr && t._fire("gotpointercapture", $47a4b45281b81a8b$var$Zi(new PointerEvent("gotpointercapture"))));
}
function $47a4b45281b81a8b$var$ar(l, t) {
    const e = $47a4b45281b81a8b$var$Se.get(l);
    if (!e) return;
    const i = e.getStage();
    i && i.content, $47a4b45281b81a8b$var$Se.delete(l), $47a4b45281b81a8b$var$sr && e._fire("lostpointercapture", $47a4b45281b81a8b$var$Zi(new PointerEvent("lostpointercapture")));
}
(function(l) {
    Object.defineProperty(l, "__esModule", {
        value: !0
    }), l.Stage = l.stages = void 0;
    const t = $47a4b45281b81a8b$var$nt, e = $47a4b45281b81a8b$var$V, i = $47a4b45281b81a8b$var$Wt, n = $47a4b45281b81a8b$var$H, r = $47a4b45281b81a8b$var$bt, s = $47a4b45281b81a8b$var$Ve, a = $47a4b45281b81a8b$var$H, o = $47a4b45281b81a8b$var$It, h = "Stage", c = "string", y = "px", g = "mouseout", u = "mouseleave", f = "mouseover", _ = "mouseenter", v = "mousemove", C = "mousedown", k = "mouseup", d = "pointermove", p = "pointerdown", b = "pointerup", w = "pointercancel", P = "lostpointercapture", S = "pointerout", E = "pointerleave", m = "pointerover", T = "pointerenter", A = "contextmenu", F = "touchstart", O = "touchend", R = "touchmove", N = "touchcancel", z = "wheel", Q = 5, ut = [
        [
            _,
            "_pointerenter"
        ],
        [
            C,
            "_pointerdown"
        ],
        [
            v,
            "_pointermove"
        ],
        [
            k,
            "_pointerup"
        ],
        [
            u,
            "_pointerleave"
        ],
        [
            F,
            "_pointerdown"
        ],
        [
            R,
            "_pointermove"
        ],
        [
            O,
            "_pointerup"
        ],
        [
            N,
            "_pointercancel"
        ],
        [
            f,
            "_pointerover"
        ],
        [
            z,
            "_wheel"
        ],
        [
            A,
            "_contextmenu"
        ],
        [
            p,
            "_pointerdown"
        ],
        [
            d,
            "_pointermove"
        ],
        [
            b,
            "_pointerup"
        ],
        [
            w,
            "_pointercancel"
        ],
        [
            P,
            "_lostpointercapture"
        ]
    ], U = {
        mouse: {
            [S]: g,
            [E]: u,
            [m]: f,
            [T]: _,
            [d]: v,
            [p]: C,
            [b]: k,
            [w]: "mousecancel",
            pointerclick: "click",
            pointerdblclick: "dblclick"
        },
        touch: {
            [S]: "touchout",
            [E]: "touchleave",
            [m]: "touchover",
            [T]: "touchenter",
            [d]: R,
            [p]: F,
            [b]: O,
            [w]: N,
            pointerclick: "tap",
            pointerdblclick: "dbltap"
        },
        pointer: {
            [S]: S,
            [E]: E,
            [m]: m,
            [T]: T,
            [d]: d,
            [p]: p,
            [b]: b,
            [w]: w,
            pointerclick: "pointerclick",
            pointerdblclick: "pointerdblclick"
        }
    }, it = (pt)=>pt.indexOf("pointer") >= 0 ? "pointer" : pt.indexOf("touch") >= 0 ? "touch" : "mouse", I = (pt)=>{
        const x = it(pt);
        if (x === "pointer") return n.Konva.pointerEventsEnabled && U.pointer;
        if (x === "touch") return U.touch;
        if (x === "mouse") return U.mouse;
    };
    function B(pt = {}) {
        return (pt.clipFunc || pt.clipWidth || pt.clipHeight) && t.Util.warn("Stage does not support clipping. Please use clip for Layers or Groups."), pt;
    }
    const X = "Pointer position is missing and not registered by the stage. Looks like it is outside of the stage container. You can set it manually from event: stage.setPointersPositions(event);";
    l.stages = [];
    class mt extends i.Container {
        constructor(x){
            super(B(x)), this._pointerPositions = [], this._changedPointerPositions = [], this._buildDOM(), this._bindContentEvents(), l.stages.push(this), this.on("widthChange.konva heightChange.konva", this._resizeDOM), this.on("visibleChange.konva", this._checkVisibility), this.on("clipWidthChange.konva clipHeightChange.konva clipFuncChange.konva", ()=>{
                B(this.attrs);
            }), this._checkVisibility();
        }
        _validateAdd(x) {
            const M = x.getType() === "Layer", D = x.getType() === "FastLayer";
            M || D || t.Util.throw("You may only add layers to the stage.");
        }
        _checkVisibility() {
            if (!this.content) return;
            const x = this.visible() ? "" : "none";
            this.content.style.display = x;
        }
        setContainer(x) {
            if (typeof x === c) {
                if (x.charAt(0) === ".") {
                    const D = x.slice(1);
                    x = document.getElementsByClassName(D)[0];
                } else {
                    var M;
                    x.charAt(0) !== "#" ? M = x : M = x.slice(1), x = document.getElementById(M);
                }
                if (!x) throw "Can not find container in document with id " + M;
            }
            return this._setAttr("container", x), this.content && (this.content.parentElement && this.content.parentElement.removeChild(this.content), x.appendChild(this.content)), this;
        }
        shouldDrawHit() {
            return !0;
        }
        clear() {
            const x = this.children, M = x.length;
            for(let D = 0; D < M; D++)x[D].clear();
            return this;
        }
        clone(x) {
            return x || (x = {}), x.container = typeof document < "u" && document.createElement("div"), i.Container.prototype.clone.call(this, x);
        }
        destroy() {
            super.destroy();
            const x = this.content;
            x && t.Util._isInDocument(x) && this.container().removeChild(x);
            const M = l.stages.indexOf(this);
            return M > -1 && l.stages.splice(M, 1), t.Util.releaseCanvas(this.bufferCanvas._canvas, this.bufferHitCanvas._canvas), this;
        }
        getPointerPosition() {
            const x = this._pointerPositions[0] || this._changedPointerPositions[0];
            return x ? {
                x: x.x,
                y: x.y
            } : (t.Util.warn(X), null);
        }
        _getPointerById(x) {
            return this._pointerPositions.find((M)=>M.id === x);
        }
        getPointersPositions() {
            return this._pointerPositions;
        }
        getStage() {
            return this;
        }
        getContent() {
            return this.content;
        }
        _toKonvaCanvas(x) {
            x = x || {}, x.x = x.x || 0, x.y = x.y || 0, x.width = x.width || this.width(), x.height = x.height || this.height();
            const M = new r.SceneCanvas({
                width: x.width,
                height: x.height,
                pixelRatio: x.pixelRatio || 1
            }), D = M.getContext()._context, tt = this.children;
            return (x.x || x.y) && D.translate(-1 * x.x, -1 * x.y), tt.forEach(function(j) {
                if (!j.isVisible()) return;
                const ot = j._toKonvaCanvas(x);
                D.drawImage(ot._canvas, x.x, x.y, ot.getWidth() / ot.getPixelRatio(), ot.getHeight() / ot.getPixelRatio());
            }), M;
        }
        getIntersection(x) {
            if (!x) return null;
            const M = this.children, D = M.length, tt = D - 1;
            for(let j = tt; j >= 0; j--){
                const ot = M[j].getIntersection(x);
                if (ot) return ot;
            }
            return null;
        }
        _resizeDOM() {
            const x = this.width(), M = this.height();
            this.content && (this.content.style.width = x + y, this.content.style.height = M + y), this.bufferCanvas.setSize(x, M), this.bufferHitCanvas.setSize(x, M), this.children.forEach((D)=>{
                D.setSize({
                    width: x,
                    height: M
                }), D.draw();
            });
        }
        add(x, ...M) {
            if (arguments.length > 1) {
                for(let tt = 0; tt < arguments.length; tt++)this.add(arguments[tt]);
                return this;
            }
            super.add(x);
            const D = this.children.length;
            return D > Q && t.Util.warn("The stage has " + D + " layers. Recommended maximum number of layers is 3-5. Adding more layers into the stage may drop the performance. Rethink your tree structure, you can use Konva.Group."), x.setSize({
                width: this.width(),
                height: this.height()
            }), x.draw(), n.Konva.isBrowser && this.content.appendChild(x.canvas._canvas), this;
        }
        getParent() {
            return null;
        }
        getLayer() {
            return null;
        }
        hasPointerCapture(x) {
            return o.hasPointerCapture(x, this);
        }
        setPointerCapture(x) {
            o.setPointerCapture(x, this);
        }
        releaseCapture(x) {
            o.releaseCapture(x, this);
        }
        getLayers() {
            return this.children;
        }
        _bindContentEvents() {
            n.Konva.isBrowser && ut.forEach(([x, M])=>{
                this.content.addEventListener(x, (D)=>{
                    this[M](D);
                }, {
                    passive: !1
                });
            });
        }
        _pointerenter(x) {
            this.setPointersPositions(x);
            const M = I(x.type);
            M && this._fire(M.pointerenter, {
                evt: x,
                target: this,
                currentTarget: this
            });
        }
        _pointerover(x) {
            this.setPointersPositions(x);
            const M = I(x.type);
            M && this._fire(M.pointerover, {
                evt: x,
                target: this,
                currentTarget: this
            });
        }
        _getTargetShape(x) {
            let M = this[x + "targetShape"];
            return M && !M.getStage() && (M = null), M;
        }
        _pointerleave(x) {
            const M = I(x.type), D = it(x.type);
            if (!M) return;
            this.setPointersPositions(x);
            const tt = this._getTargetShape(D), j = !(n.Konva.isDragging() || n.Konva.isTransforming()) || n.Konva.hitOnDragEnabled;
            tt && j ? (tt._fireAndBubble(M.pointerout, {
                evt: x
            }), tt._fireAndBubble(M.pointerleave, {
                evt: x
            }), this._fire(M.pointerleave, {
                evt: x,
                target: this,
                currentTarget: this
            }), this[D + "targetShape"] = null) : j && (this._fire(M.pointerleave, {
                evt: x,
                target: this,
                currentTarget: this
            }), this._fire(M.pointerout, {
                evt: x,
                target: this,
                currentTarget: this
            })), this.pointerPos = null, this._pointerPositions = [];
        }
        _pointerdown(x) {
            const M = I(x.type), D = it(x.type);
            if (!M) return;
            this.setPointersPositions(x);
            let tt = !1;
            this._changedPointerPositions.forEach((j)=>{
                const ot = this.getIntersection(j);
                if (s.DD.justDragged = !1, n.Konva["_" + D + "ListenClick"] = !0, !ot || !ot.isListening()) {
                    this[D + "ClickStartShape"] = void 0;
                    return;
                }
                n.Konva.capturePointerEventsEnabled && ot.setPointerCapture(j.id), this[D + "ClickStartShape"] = ot, ot._fireAndBubble(M.pointerdown, {
                    evt: x,
                    pointerId: j.id
                }), tt = !0;
                const yt = x.type.indexOf("touch") >= 0;
                ot.preventDefault() && x.cancelable && yt && x.preventDefault();
            }), tt || this._fire(M.pointerdown, {
                evt: x,
                target: this,
                currentTarget: this,
                pointerId: this._pointerPositions[0].id
            });
        }
        _pointermove(x) {
            const M = I(x.type), D = it(x.type);
            if (!M || (n.Konva.isDragging() && s.DD.node.preventDefault() && x.cancelable && x.preventDefault(), this.setPointersPositions(x), !(!(n.Konva.isDragging() || n.Konva.isTransforming()) || n.Konva.hitOnDragEnabled))) return;
            const j = {};
            let ot = !1;
            const yt = this._getTargetShape(D);
            this._changedPointerPositions.forEach((Ot)=>{
                const Z = o.getCapturedShape(Ot.id) || this.getIntersection(Ot), te = Ot.id, Tt = {
                    evt: x,
                    pointerId: te
                }, ee = yt !== Z;
                if (ee && yt && (yt._fireAndBubble(M.pointerout, {
                    ...Tt
                }, Z), yt._fireAndBubble(M.pointerleave, {
                    ...Tt
                }, Z)), Z) {
                    if (j[Z._id]) return;
                    j[Z._id] = !0;
                }
                Z && Z.isListening() ? (ot = !0, ee && (Z._fireAndBubble(M.pointerover, {
                    ...Tt
                }, yt), Z._fireAndBubble(M.pointerenter, {
                    ...Tt
                }, yt), this[D + "targetShape"] = Z), Z._fireAndBubble(M.pointermove, {
                    ...Tt
                })) : yt && (this._fire(M.pointerover, {
                    evt: x,
                    target: this,
                    currentTarget: this,
                    pointerId: te
                }), this[D + "targetShape"] = null);
            }), ot || this._fire(M.pointermove, {
                evt: x,
                target: this,
                currentTarget: this,
                pointerId: this._changedPointerPositions[0].id
            });
        }
        _pointerup(x) {
            const M = I(x.type), D = it(x.type);
            if (!M) return;
            this.setPointersPositions(x);
            const tt = this[D + "ClickStartShape"], j = this[D + "ClickEndShape"], ot = {};
            let yt = !1;
            this._changedPointerPositions.forEach((Ot)=>{
                const Z = o.getCapturedShape(Ot.id) || this.getIntersection(Ot);
                if (Z) {
                    if (Z.releaseCapture(Ot.id), ot[Z._id]) return;
                    ot[Z._id] = !0;
                }
                const te = Ot.id, Tt = {
                    evt: x,
                    pointerId: te
                };
                let ee = !1;
                n.Konva["_" + D + "InDblClickWindow"] ? (ee = !0, clearTimeout(this[D + "DblTimeout"])) : s.DD.justDragged || (n.Konva["_" + D + "InDblClickWindow"] = !0, clearTimeout(this[D + "DblTimeout"])), this[D + "DblTimeout"] = setTimeout(function() {
                    n.Konva["_" + D + "InDblClickWindow"] = !1;
                }, n.Konva.dblClickWindow), Z && Z.isListening() ? (yt = !0, this[D + "ClickEndShape"] = Z, Z._fireAndBubble(M.pointerup, {
                    ...Tt
                }), n.Konva["_" + D + "ListenClick"] && tt && tt === Z && (Z._fireAndBubble(M.pointerclick, {
                    ...Tt
                }), ee && j && j === Z && Z._fireAndBubble(M.pointerdblclick, {
                    ...Tt
                }))) : (this[D + "ClickEndShape"] = null, n.Konva["_" + D + "ListenClick"] && this._fire(M.pointerclick, {
                    evt: x,
                    target: this,
                    currentTarget: this,
                    pointerId: te
                }), ee && this._fire(M.pointerdblclick, {
                    evt: x,
                    target: this,
                    currentTarget: this,
                    pointerId: te
                }));
            }), yt || this._fire(M.pointerup, {
                evt: x,
                target: this,
                currentTarget: this,
                pointerId: this._changedPointerPositions[0].id
            }), n.Konva["_" + D + "ListenClick"] = !1, x.cancelable && D !== "touch" && D !== "pointer" && x.preventDefault();
        }
        _contextmenu(x) {
            this.setPointersPositions(x);
            const M = this.getIntersection(this.getPointerPosition());
            M && M.isListening() ? M._fireAndBubble(A, {
                evt: x
            }) : this._fire(A, {
                evt: x,
                target: this,
                currentTarget: this
            });
        }
        _wheel(x) {
            this.setPointersPositions(x);
            const M = this.getIntersection(this.getPointerPosition());
            M && M.isListening() ? M._fireAndBubble(z, {
                evt: x
            }) : this._fire(z, {
                evt: x,
                target: this,
                currentTarget: this
            });
        }
        _pointercancel(x) {
            this.setPointersPositions(x);
            const M = o.getCapturedShape(x.pointerId) || this.getIntersection(this.getPointerPosition());
            M && M._fireAndBubble(b, o.createEvent(x)), o.releaseCapture(x.pointerId);
        }
        _lostpointercapture(x) {
            o.releaseCapture(x.pointerId);
        }
        setPointersPositions(x) {
            const M = this._getContentPosition();
            let D = null, tt = null;
            x = x || window.event, x.touches !== void 0 ? (this._pointerPositions = [], this._changedPointerPositions = [], Array.prototype.forEach.call(x.touches, (j)=>{
                this._pointerPositions.push({
                    id: j.identifier,
                    x: (j.clientX - M.left) / M.scaleX,
                    y: (j.clientY - M.top) / M.scaleY
                });
            }), Array.prototype.forEach.call(x.changedTouches || x.touches, (j)=>{
                this._changedPointerPositions.push({
                    id: j.identifier,
                    x: (j.clientX - M.left) / M.scaleX,
                    y: (j.clientY - M.top) / M.scaleY
                });
            })) : (D = (x.clientX - M.left) / M.scaleX, tt = (x.clientY - M.top) / M.scaleY, this.pointerPos = {
                x: D,
                y: tt
            }, this._pointerPositions = [
                {
                    x: D,
                    y: tt,
                    id: t.Util._getFirstPointerId(x)
                }
            ], this._changedPointerPositions = [
                {
                    x: D,
                    y: tt,
                    id: t.Util._getFirstPointerId(x)
                }
            ]);
        }
        _setPointerPosition(x) {
            t.Util.warn('Method _setPointerPosition is deprecated. Use "stage.setPointersPositions(event)" instead.'), this.setPointersPositions(x);
        }
        _getContentPosition() {
            if (!this.content || !this.content.getBoundingClientRect) return {
                top: 0,
                left: 0,
                scaleX: 1,
                scaleY: 1
            };
            const x = this.content.getBoundingClientRect();
            return {
                top: x.top,
                left: x.left,
                scaleX: x.width / this.content.clientWidth || 1,
                scaleY: x.height / this.content.clientHeight || 1
            };
        }
        _buildDOM() {
            if (this.bufferCanvas = new r.SceneCanvas({
                width: this.width(),
                height: this.height()
            }), this.bufferHitCanvas = new r.HitCanvas({
                pixelRatio: 1,
                width: this.width(),
                height: this.height()
            }), !n.Konva.isBrowser) return;
            const x = this.container();
            if (!x) throw "Stage has no container. A container is required.";
            x.innerHTML = "", this.content = document.createElement("div"), this.content.style.position = "relative", this.content.style.userSelect = "none", this.content.className = "konvajs-content", this.content.setAttribute("role", "presentation"), x.appendChild(this.content), this._resizeDOM();
        }
        cache() {
            return t.Util.warn("Cache function is not allowed for stage. You may use cache only for layers, groups and shapes."), this;
        }
        clearCache() {
            return this;
        }
        batchDraw() {
            return this.getChildren().forEach(function(x) {
                x.batchDraw();
            }), this;
        }
    }
    l.Stage = mt, mt.prototype.nodeType = h, (0, a._registerNode)(mt), e.Factory.addGetterSetter(mt, "container"), n.Konva.isBrowser && document.addEventListener("visibilitychange", ()=>{
        l.stages.forEach((pt)=>{
            pt.batchDraw();
        });
    });
})($47a4b45281b81a8b$var$rr);
var $47a4b45281b81a8b$var$xe = {}, $47a4b45281b81a8b$var$ct = {};
(function(l) {
    Object.defineProperty(l, "__esModule", {
        value: !0
    }), l.Shape = l.shapes = void 0;
    const t = $47a4b45281b81a8b$var$H, e = $47a4b45281b81a8b$var$nt, i = $47a4b45281b81a8b$var$V, n = $47a4b45281b81a8b$var$et, r = $47a4b45281b81a8b$var$L, s = $47a4b45281b81a8b$var$H, a = $47a4b45281b81a8b$var$It, o = "hasShadow", h = "shadowRGBA", c = "patternImage", y = "linearGradient", g = "radialGradient";
    let u;
    function f() {
        return u || (u = e.Util.createCanvasElement().getContext("2d"), u);
    }
    l.shapes = {};
    function _(E) {
        const m = this.attrs.fillRule;
        m ? E.fill(m) : E.fill();
    }
    function v(E) {
        E.stroke();
    }
    function C(E) {
        const m = this.attrs.fillRule;
        m ? E.fill(m) : E.fill();
    }
    function k(E) {
        E.stroke();
    }
    function d() {
        this._clearCache(o);
    }
    function p() {
        this._clearCache(h);
    }
    function b() {
        this._clearCache(c);
    }
    function w() {
        this._clearCache(y);
    }
    function P() {
        this._clearCache(g);
    }
    class S extends n.Node {
        constructor(m){
            super(m);
            let T;
            for(; T = e.Util.getRandomColor(), !(T && !(T in l.shapes)););
            this.colorKey = T, l.shapes[T] = this;
        }
        getContext() {
            return e.Util.warn("shape.getContext() method is deprecated. Please do not use it."), this.getLayer().getContext();
        }
        getCanvas() {
            return e.Util.warn("shape.getCanvas() method is deprecated. Please do not use it."), this.getLayer().getCanvas();
        }
        getSceneFunc() {
            return this.attrs.sceneFunc || this._sceneFunc;
        }
        getHitFunc() {
            return this.attrs.hitFunc || this._hitFunc;
        }
        hasShadow() {
            return this._getCache(o, this._hasShadow);
        }
        _hasShadow() {
            return this.shadowEnabled() && this.shadowOpacity() !== 0 && !!(this.shadowColor() || this.shadowBlur() || this.shadowOffsetX() || this.shadowOffsetY());
        }
        _getFillPattern() {
            return this._getCache(c, this.__getFillPattern);
        }
        __getFillPattern() {
            if (this.fillPatternImage()) {
                const T = f().createPattern(this.fillPatternImage(), this.fillPatternRepeat() || "repeat");
                if (T && T.setTransform) {
                    const A = new e.Transform();
                    A.translate(this.fillPatternX(), this.fillPatternY()), A.rotate(t.Konva.getAngle(this.fillPatternRotation())), A.scale(this.fillPatternScaleX(), this.fillPatternScaleY()), A.translate(-1 * this.fillPatternOffsetX(), -1 * this.fillPatternOffsetY());
                    const F = A.getMatrix(), O = typeof DOMMatrix > "u" ? {
                        a: F[0],
                        b: F[1],
                        c: F[2],
                        d: F[3],
                        e: F[4],
                        f: F[5]
                    } : new DOMMatrix(F);
                    T.setTransform(O);
                }
                return T;
            }
        }
        _getLinearGradient() {
            return this._getCache(y, this.__getLinearGradient);
        }
        __getLinearGradient() {
            const m = this.fillLinearGradientColorStops();
            if (m) {
                const T = f(), A = this.fillLinearGradientStartPoint(), F = this.fillLinearGradientEndPoint(), O = T.createLinearGradient(A.x, A.y, F.x, F.y);
                for(let R = 0; R < m.length; R += 2)O.addColorStop(m[R], m[R + 1]);
                return O;
            }
        }
        _getRadialGradient() {
            return this._getCache(g, this.__getRadialGradient);
        }
        __getRadialGradient() {
            const m = this.fillRadialGradientColorStops();
            if (m) {
                const T = f(), A = this.fillRadialGradientStartPoint(), F = this.fillRadialGradientEndPoint(), O = T.createRadialGradient(A.x, A.y, this.fillRadialGradientStartRadius(), F.x, F.y, this.fillRadialGradientEndRadius());
                for(let R = 0; R < m.length; R += 2)O.addColorStop(m[R], m[R + 1]);
                return O;
            }
        }
        getShadowRGBA() {
            return this._getCache(h, this._getShadowRGBA);
        }
        _getShadowRGBA() {
            if (!this.hasShadow()) return;
            const m = e.Util.colorToRGBA(this.shadowColor());
            if (m) return "rgba(" + m.r + "," + m.g + "," + m.b + "," + m.a * (this.shadowOpacity() || 1) + ")";
        }
        hasFill() {
            return this._calculate("hasFill", [
                "fillEnabled",
                "fill",
                "fillPatternImage",
                "fillLinearGradientColorStops",
                "fillRadialGradientColorStops"
            ], ()=>this.fillEnabled() && !!(this.fill() || this.fillPatternImage() || this.fillLinearGradientColorStops() || this.fillRadialGradientColorStops()));
        }
        hasStroke() {
            return this._calculate("hasStroke", [
                "strokeEnabled",
                "strokeWidth",
                "stroke",
                "strokeLinearGradientColorStops"
            ], ()=>this.strokeEnabled() && this.strokeWidth() && !!(this.stroke() || this.strokeLinearGradientColorStops()));
        }
        hasHitStroke() {
            const m = this.hitStrokeWidth();
            return m === "auto" ? this.hasStroke() : this.strokeEnabled() && !!m;
        }
        intersects(m) {
            const T = this.getStage();
            if (!T) return !1;
            const A = T.bufferHitCanvas;
            return A.getContext().clear(), this.drawHit(A, void 0, !0), A.context.getImageData(Math.round(m.x), Math.round(m.y), 1, 1).data[3] > 0;
        }
        destroy() {
            return n.Node.prototype.destroy.call(this), delete l.shapes[this.colorKey], delete this.colorKey, this;
        }
        _useBufferCanvas(m) {
            var T;
            if (!((T = this.attrs.perfectDrawEnabled) !== null && T !== void 0 ? T : !0)) return !1;
            const F = m || this.hasFill(), O = this.hasStroke(), R = this.getAbsoluteOpacity() !== 1;
            if (F && O && R) return !0;
            const N = this.hasShadow(), z = this.shadowForStrokeEnabled();
            return !!(F && O && N && z);
        }
        setStrokeHitEnabled(m) {
            e.Util.warn("strokeHitEnabled property is deprecated. Please use hitStrokeWidth instead."), m ? this.hitStrokeWidth("auto") : this.hitStrokeWidth(0);
        }
        getStrokeHitEnabled() {
            return this.hitStrokeWidth() !== 0;
        }
        getSelfRect() {
            const m = this.size();
            return {
                x: this._centroid ? -m.width / 2 : 0,
                y: this._centroid ? -m.height / 2 : 0,
                width: m.width,
                height: m.height
            };
        }
        getClientRect(m = {}) {
            let T = !1, A = this.getParent();
            for(; A;){
                if (A.isCached()) {
                    T = !0;
                    break;
                }
                A = A.getParent();
            }
            const F = m.skipTransform, O = m.relativeTo || T && this.getStage() || void 0, R = this.getSelfRect(), z = !m.skipStroke && this.hasStroke() && this.strokeWidth() || 0, Q = R.width + z, ut = R.height + z, U = !m.skipShadow && this.hasShadow(), it = U ? this.shadowOffsetX() : 0, I = U ? this.shadowOffsetY() : 0, B = Q + Math.abs(it), X = ut + Math.abs(I), mt = U && this.shadowBlur() || 0, pt = B + mt * 2, x = X + mt * 2, M = {
                width: pt,
                height: x,
                x: -(z / 2 + mt) + Math.min(it, 0) + R.x,
                y: -(z / 2 + mt) + Math.min(I, 0) + R.y
            };
            return F ? M : this._transformedRect(M, O);
        }
        drawScene(m, T, A) {
            const F = this.getLayer();
            let O = m || F.getCanvas(), R = O.getContext(), N = this._getCanvasCache(), z = this.getSceneFunc(), Q = this.hasShadow(), ut, U;
            const it = O.isCache, I = T === this;
            if (!this.isVisible() && !I) return this;
            if (N) {
                R.save();
                const X = this.getAbsoluteTransform(T).getMatrix();
                return R.transform(X[0], X[1], X[2], X[3], X[4], X[5]), this._drawCachedSceneCanvas(R), R.restore(), this;
            }
            if (!z) return this;
            if (R.save(), this._useBufferCanvas() && !it) {
                ut = this.getStage();
                const X = A || ut.bufferCanvas;
                U = X.getContext(), U.clear(), U.save(), U._applyLineJoin(this);
                var B = this.getAbsoluteTransform(T).getMatrix();
                U.transform(B[0], B[1], B[2], B[3], B[4], B[5]), z.call(this, U, this), U.restore();
                const mt = X.pixelRatio;
                Q && R._applyShadow(this), R._applyOpacity(this), R._applyGlobalCompositeOperation(this), R.drawImage(X._canvas, 0, 0, X.width / mt, X.height / mt);
            } else {
                if (R._applyLineJoin(this), !I) {
                    var B = this.getAbsoluteTransform(T).getMatrix();
                    R.transform(B[0], B[1], B[2], B[3], B[4], B[5]), R._applyOpacity(this), R._applyGlobalCompositeOperation(this);
                }
                Q && R._applyShadow(this), z.call(this, R, this);
            }
            return R.restore(), this;
        }
        drawHit(m, T, A = !1) {
            if (!this.shouldDrawHit(T, A)) return this;
            const F = this.getLayer(), O = m || F.hitCanvas, R = O && O.getContext(), N = this.hitFunc() || this.sceneFunc(), z = this._getCanvasCache(), Q = z && z.hit;
            if (this.colorKey || e.Util.warn("Looks like your canvas has a destroyed shape in it. Do not reuse shape after you destroyed it. If you want to reuse shape you should call remove() instead of destroy()"), Q) {
                R.save();
                const U = this.getAbsoluteTransform(T).getMatrix();
                return R.transform(U[0], U[1], U[2], U[3], U[4], U[5]), this._drawCachedHitCanvas(R), R.restore(), this;
            }
            if (!N) return this;
            if (R.save(), R._applyLineJoin(this), !(this === T)) {
                const U = this.getAbsoluteTransform(T).getMatrix();
                R.transform(U[0], U[1], U[2], U[3], U[4], U[5]);
            }
            return N.call(this, R, this), R.restore(), this;
        }
        drawHitFromCache(m = 0) {
            const T = this._getCanvasCache(), A = this._getCachedSceneCanvas(), F = T.hit, O = F.getContext(), R = F.getWidth(), N = F.getHeight();
            O.clear(), O.drawImage(A._canvas, 0, 0, R, N);
            try {
                const z = O.getImageData(0, 0, R, N), Q = z.data, ut = Q.length, U = e.Util._hexToRgb(this.colorKey);
                for(let it = 0; it < ut; it += 4)Q[it + 3] > m ? (Q[it] = U.r, Q[it + 1] = U.g, Q[it + 2] = U.b, Q[it + 3] = 255) : Q[it + 3] = 0;
                O.putImageData(z, 0, 0);
            } catch (z) {
                e.Util.error("Unable to draw hit graph from cached scene canvas. " + z.message);
            }
            return this;
        }
        hasPointerCapture(m) {
            return a.hasPointerCapture(m, this);
        }
        setPointerCapture(m) {
            a.setPointerCapture(m, this);
        }
        releaseCapture(m) {
            a.releaseCapture(m, this);
        }
    }
    l.Shape = S, S.prototype._fillFunc = _, S.prototype._strokeFunc = v, S.prototype._fillFuncHit = C, S.prototype._strokeFuncHit = k, S.prototype._centroid = !1, S.prototype.nodeType = "Shape", (0, s._registerNode)(S), S.prototype.eventListeners = {}, S.prototype.on.call(S.prototype, "shadowColorChange.konva shadowBlurChange.konva shadowOffsetChange.konva shadowOpacityChange.konva shadowEnabledChange.konva", d), S.prototype.on.call(S.prototype, "shadowColorChange.konva shadowOpacityChange.konva shadowEnabledChange.konva", p), S.prototype.on.call(S.prototype, "fillPriorityChange.konva fillPatternImageChange.konva fillPatternRepeatChange.konva fillPatternScaleXChange.konva fillPatternScaleYChange.konva fillPatternOffsetXChange.konva fillPatternOffsetYChange.konva fillPatternXChange.konva fillPatternYChange.konva fillPatternRotationChange.konva", b), S.prototype.on.call(S.prototype, "fillPriorityChange.konva fillLinearGradientColorStopsChange.konva fillLinearGradientStartPointXChange.konva fillLinearGradientStartPointYChange.konva fillLinearGradientEndPointXChange.konva fillLinearGradientEndPointYChange.konva", w), S.prototype.on.call(S.prototype, "fillPriorityChange.konva fillRadialGradientColorStopsChange.konva fillRadialGradientStartPointXChange.konva fillRadialGradientStartPointYChange.konva fillRadialGradientEndPointXChange.konva fillRadialGradientEndPointYChange.konva fillRadialGradientStartRadiusChange.konva fillRadialGradientEndRadiusChange.konva", P), i.Factory.addGetterSetter(S, "stroke", void 0, (0, r.getStringOrGradientValidator)()), i.Factory.addGetterSetter(S, "strokeWidth", 2, (0, r.getNumberValidator)()), i.Factory.addGetterSetter(S, "fillAfterStrokeEnabled", !1), i.Factory.addGetterSetter(S, "hitStrokeWidth", "auto", (0, r.getNumberOrAutoValidator)()), i.Factory.addGetterSetter(S, "strokeHitEnabled", !0, (0, r.getBooleanValidator)()), i.Factory.addGetterSetter(S, "perfectDrawEnabled", !0, (0, r.getBooleanValidator)()), i.Factory.addGetterSetter(S, "shadowForStrokeEnabled", !0, (0, r.getBooleanValidator)()), i.Factory.addGetterSetter(S, "lineJoin"), i.Factory.addGetterSetter(S, "lineCap"), i.Factory.addGetterSetter(S, "sceneFunc"), i.Factory.addGetterSetter(S, "hitFunc"), i.Factory.addGetterSetter(S, "dash"), i.Factory.addGetterSetter(S, "dashOffset", 0, (0, r.getNumberValidator)()), i.Factory.addGetterSetter(S, "shadowColor", void 0, (0, r.getStringValidator)()), i.Factory.addGetterSetter(S, "shadowBlur", 0, (0, r.getNumberValidator)()), i.Factory.addGetterSetter(S, "shadowOpacity", 1, (0, r.getNumberValidator)()), i.Factory.addComponentsGetterSetter(S, "shadowOffset", [
        "x",
        "y"
    ]), i.Factory.addGetterSetter(S, "shadowOffsetX", 0, (0, r.getNumberValidator)()), i.Factory.addGetterSetter(S, "shadowOffsetY", 0, (0, r.getNumberValidator)()), i.Factory.addGetterSetter(S, "fillPatternImage"), i.Factory.addGetterSetter(S, "fill", void 0, (0, r.getStringOrGradientValidator)()), i.Factory.addGetterSetter(S, "fillPatternX", 0, (0, r.getNumberValidator)()), i.Factory.addGetterSetter(S, "fillPatternY", 0, (0, r.getNumberValidator)()), i.Factory.addGetterSetter(S, "fillLinearGradientColorStops"), i.Factory.addGetterSetter(S, "strokeLinearGradientColorStops"), i.Factory.addGetterSetter(S, "fillRadialGradientStartRadius", 0), i.Factory.addGetterSetter(S, "fillRadialGradientEndRadius", 0), i.Factory.addGetterSetter(S, "fillRadialGradientColorStops"), i.Factory.addGetterSetter(S, "fillPatternRepeat", "repeat"), i.Factory.addGetterSetter(S, "fillEnabled", !0), i.Factory.addGetterSetter(S, "strokeEnabled", !0), i.Factory.addGetterSetter(S, "shadowEnabled", !0), i.Factory.addGetterSetter(S, "dashEnabled", !0), i.Factory.addGetterSetter(S, "strokeScaleEnabled", !0), i.Factory.addGetterSetter(S, "fillPriority", "color"), i.Factory.addComponentsGetterSetter(S, "fillPatternOffset", [
        "x",
        "y"
    ]), i.Factory.addGetterSetter(S, "fillPatternOffsetX", 0, (0, r.getNumberValidator)()), i.Factory.addGetterSetter(S, "fillPatternOffsetY", 0, (0, r.getNumberValidator)()), i.Factory.addComponentsGetterSetter(S, "fillPatternScale", [
        "x",
        "y"
    ]), i.Factory.addGetterSetter(S, "fillPatternScaleX", 1, (0, r.getNumberValidator)()), i.Factory.addGetterSetter(S, "fillPatternScaleY", 1, (0, r.getNumberValidator)()), i.Factory.addComponentsGetterSetter(S, "fillLinearGradientStartPoint", [
        "x",
        "y"
    ]), i.Factory.addComponentsGetterSetter(S, "strokeLinearGradientStartPoint", [
        "x",
        "y"
    ]), i.Factory.addGetterSetter(S, "fillLinearGradientStartPointX", 0), i.Factory.addGetterSetter(S, "strokeLinearGradientStartPointX", 0), i.Factory.addGetterSetter(S, "fillLinearGradientStartPointY", 0), i.Factory.addGetterSetter(S, "strokeLinearGradientStartPointY", 0), i.Factory.addComponentsGetterSetter(S, "fillLinearGradientEndPoint", [
        "x",
        "y"
    ]), i.Factory.addComponentsGetterSetter(S, "strokeLinearGradientEndPoint", [
        "x",
        "y"
    ]), i.Factory.addGetterSetter(S, "fillLinearGradientEndPointX", 0), i.Factory.addGetterSetter(S, "strokeLinearGradientEndPointX", 0), i.Factory.addGetterSetter(S, "fillLinearGradientEndPointY", 0), i.Factory.addGetterSetter(S, "strokeLinearGradientEndPointY", 0), i.Factory.addComponentsGetterSetter(S, "fillRadialGradientStartPoint", [
        "x",
        "y"
    ]), i.Factory.addGetterSetter(S, "fillRadialGradientStartPointX", 0), i.Factory.addGetterSetter(S, "fillRadialGradientStartPointY", 0), i.Factory.addComponentsGetterSetter(S, "fillRadialGradientEndPoint", [
        "x",
        "y"
    ]), i.Factory.addGetterSetter(S, "fillRadialGradientEndPointX", 0), i.Factory.addGetterSetter(S, "fillRadialGradientEndPointY", 0), i.Factory.addGetterSetter(S, "fillPatternRotation", 0), i.Factory.addGetterSetter(S, "fillRule", void 0, (0, r.getStringValidator)()), i.Factory.backCompat(S, {
        dashArray: "dash",
        getDashArray: "getDash",
        setDashArray: "getDash",
        drawFunc: "sceneFunc",
        getDrawFunc: "getSceneFunc",
        setDrawFunc: "setSceneFunc",
        drawHitFunc: "hitFunc",
        getDrawHitFunc: "getHitFunc",
        setDrawHitFunc: "setHitFunc"
    });
})($47a4b45281b81a8b$var$ct);
Object.defineProperty($47a4b45281b81a8b$var$xe, "__esModule", {
    value: !0
});
$47a4b45281b81a8b$var$xe.Layer = void 0;
const $47a4b45281b81a8b$var$kt = $47a4b45281b81a8b$var$nt, $47a4b45281b81a8b$var$Fi = $47a4b45281b81a8b$var$Wt, $47a4b45281b81a8b$var$ie = $47a4b45281b81a8b$var$et, $47a4b45281b81a8b$var$tn = $47a4b45281b81a8b$var$V, $47a4b45281b81a8b$var$xn = $47a4b45281b81a8b$var$bt, $47a4b45281b81a8b$var$Cs = $47a4b45281b81a8b$var$L, $47a4b45281b81a8b$var$ws = $47a4b45281b81a8b$var$ct, $47a4b45281b81a8b$var$xs = $47a4b45281b81a8b$var$H, $47a4b45281b81a8b$var$Ts = "#", $47a4b45281b81a8b$var$ks = "beforeDraw", $47a4b45281b81a8b$var$Es = "draw", $47a4b45281b81a8b$var$or = [
    {
        x: 0,
        y: 0
    },
    {
        x: -1,
        y: -1
    },
    {
        x: 1,
        y: -1
    },
    {
        x: 1,
        y: 1
    },
    {
        x: -1,
        y: 1
    }
], $47a4b45281b81a8b$var$As = $47a4b45281b81a8b$var$or.length;
class $47a4b45281b81a8b$var$ce extends $47a4b45281b81a8b$var$Fi.Container {
    constructor(t){
        super(t), this.canvas = new $47a4b45281b81a8b$var$xn.SceneCanvas(), this.hitCanvas = new $47a4b45281b81a8b$var$xn.HitCanvas({
            pixelRatio: 1
        }), this._waitingForDraw = !1, this.on("visibleChange.konva", this._checkVisibility), this._checkVisibility(), this.on("imageSmoothingEnabledChange.konva", this._setSmoothEnabled), this._setSmoothEnabled();
    }
    createPNGStream() {
        return this.canvas._canvas.createPNGStream();
    }
    getCanvas() {
        return this.canvas;
    }
    getNativeCanvasElement() {
        return this.canvas._canvas;
    }
    getHitCanvas() {
        return this.hitCanvas;
    }
    getContext() {
        return this.getCanvas().getContext();
    }
    clear(t) {
        return this.getContext().clear(t), this.getHitCanvas().getContext().clear(t), this;
    }
    setZIndex(t) {
        super.setZIndex(t);
        const e = this.getStage();
        return e && e.content && (e.content.removeChild(this.getNativeCanvasElement()), t < e.children.length - 1 ? e.content.insertBefore(this.getNativeCanvasElement(), e.children[t + 1].getCanvas()._canvas) : e.content.appendChild(this.getNativeCanvasElement())), this;
    }
    moveToTop() {
        $47a4b45281b81a8b$var$ie.Node.prototype.moveToTop.call(this);
        const t = this.getStage();
        return t && t.content && (t.content.removeChild(this.getNativeCanvasElement()), t.content.appendChild(this.getNativeCanvasElement())), !0;
    }
    moveUp() {
        if (!$47a4b45281b81a8b$var$ie.Node.prototype.moveUp.call(this)) return !1;
        const e = this.getStage();
        return !e || !e.content ? !1 : (e.content.removeChild(this.getNativeCanvasElement()), this.index < e.children.length - 1 ? e.content.insertBefore(this.getNativeCanvasElement(), e.children[this.index + 1].getCanvas()._canvas) : e.content.appendChild(this.getNativeCanvasElement()), !0);
    }
    moveDown() {
        if ($47a4b45281b81a8b$var$ie.Node.prototype.moveDown.call(this)) {
            const t = this.getStage();
            if (t) {
                const e = t.children;
                t.content && (t.content.removeChild(this.getNativeCanvasElement()), t.content.insertBefore(this.getNativeCanvasElement(), e[this.index + 1].getCanvas()._canvas));
            }
            return !0;
        }
        return !1;
    }
    moveToBottom() {
        if ($47a4b45281b81a8b$var$ie.Node.prototype.moveToBottom.call(this)) {
            const t = this.getStage();
            if (t) {
                const e = t.children;
                t.content && (t.content.removeChild(this.getNativeCanvasElement()), t.content.insertBefore(this.getNativeCanvasElement(), e[1].getCanvas()._canvas));
            }
            return !0;
        }
        return !1;
    }
    getLayer() {
        return this;
    }
    remove() {
        const t = this.getNativeCanvasElement();
        return $47a4b45281b81a8b$var$ie.Node.prototype.remove.call(this), t && t.parentNode && $47a4b45281b81a8b$var$kt.Util._isInDocument(t) && t.parentNode.removeChild(t), this;
    }
    getStage() {
        return this.parent;
    }
    setSize({ width: t, height: e }) {
        return this.canvas.setSize(t, e), this.hitCanvas.setSize(t, e), this._setSmoothEnabled(), this;
    }
    _validateAdd(t) {
        const e = t.getType();
        e !== "Group" && e !== "Shape" && $47a4b45281b81a8b$var$kt.Util.throw("You may only add groups and shapes to a layer.");
    }
    _toKonvaCanvas(t) {
        return t = t || {}, t.width = t.width || this.getWidth(), t.height = t.height || this.getHeight(), t.x = t.x !== void 0 ? t.x : this.x(), t.y = t.y !== void 0 ? t.y : this.y(), $47a4b45281b81a8b$var$ie.Node.prototype._toKonvaCanvas.call(this, t);
    }
    _checkVisibility() {
        this.visible() ? this.canvas._canvas.style.display = "block" : this.canvas._canvas.style.display = "none";
    }
    _setSmoothEnabled() {
        this.getContext()._context.imageSmoothingEnabled = this.imageSmoothingEnabled();
    }
    getWidth() {
        if (this.parent) return this.parent.width();
    }
    setWidth() {
        $47a4b45281b81a8b$var$kt.Util.warn('Can not change width of layer. Use "stage.width(value)" function instead.');
    }
    getHeight() {
        if (this.parent) return this.parent.height();
    }
    setHeight() {
        $47a4b45281b81a8b$var$kt.Util.warn('Can not change height of layer. Use "stage.height(value)" function instead.');
    }
    batchDraw() {
        return this._waitingForDraw || (this._waitingForDraw = !0, $47a4b45281b81a8b$var$kt.Util.requestAnimFrame(()=>{
            this.draw(), this._waitingForDraw = !1;
        })), this;
    }
    getIntersection(t) {
        if (!this.isListening() || !this.isVisible()) return null;
        let e = 1, i = !1;
        for(;;){
            for(let n = 0; n < $47a4b45281b81a8b$var$As; n++){
                const r = $47a4b45281b81a8b$var$or[n], s = this._getIntersection({
                    x: t.x + r.x * e,
                    y: t.y + r.y * e
                }), a = s.shape;
                if (a) return a;
                if (i = !!s.antialiased, !s.antialiased) break;
            }
            if (i) e += 1;
            else return null;
        }
    }
    _getIntersection(t) {
        const e = this.hitCanvas.pixelRatio, i = this.hitCanvas.context.getImageData(Math.round(t.x * e), Math.round(t.y * e), 1, 1).data, n = i[3];
        if (n === 255) {
            const r = $47a4b45281b81a8b$var$kt.Util._rgbToHex(i[0], i[1], i[2]), s = $47a4b45281b81a8b$var$ws.shapes[$47a4b45281b81a8b$var$Ts + r];
            return s ? {
                shape: s
            } : {
                antialiased: !0
            };
        } else if (n > 0) return {
            antialiased: !0
        };
        return {};
    }
    drawScene(t, e) {
        const i = this.getLayer(), n = t || i && i.getCanvas();
        return this._fire($47a4b45281b81a8b$var$ks, {
            node: this
        }), this.clearBeforeDraw() && n.getContext().clear(), $47a4b45281b81a8b$var$Fi.Container.prototype.drawScene.call(this, n, e), this._fire($47a4b45281b81a8b$var$Es, {
            node: this
        }), this;
    }
    drawHit(t, e) {
        const i = this.getLayer(), n = t || i && i.hitCanvas;
        return i && i.clearBeforeDraw() && i.getHitCanvas().getContext().clear(), $47a4b45281b81a8b$var$Fi.Container.prototype.drawHit.call(this, n, e), this;
    }
    enableHitGraph() {
        return this.hitGraphEnabled(!0), this;
    }
    disableHitGraph() {
        return this.hitGraphEnabled(!1), this;
    }
    setHitGraphEnabled(t) {
        $47a4b45281b81a8b$var$kt.Util.warn("hitGraphEnabled method is deprecated. Please use layer.listening() instead."), this.listening(t);
    }
    getHitGraphEnabled(t) {
        return $47a4b45281b81a8b$var$kt.Util.warn("hitGraphEnabled method is deprecated. Please use layer.listening() instead."), this.listening();
    }
    toggleHitCanvas() {
        if (!this.parent || !this.parent.content) return;
        const t = this.parent;
        !!this.hitCanvas._canvas.parentNode ? t.content.removeChild(this.hitCanvas._canvas) : t.content.appendChild(this.hitCanvas._canvas);
    }
    destroy() {
        return $47a4b45281b81a8b$var$kt.Util.releaseCanvas(this.getNativeCanvasElement(), this.getHitCanvas()._canvas), super.destroy();
    }
}
$47a4b45281b81a8b$var$xe.Layer = $47a4b45281b81a8b$var$ce;
$47a4b45281b81a8b$var$ce.prototype.nodeType = "Layer";
(0, $47a4b45281b81a8b$var$xs._registerNode)($47a4b45281b81a8b$var$ce);
$47a4b45281b81a8b$var$tn.Factory.addGetterSetter($47a4b45281b81a8b$var$ce, "imageSmoothingEnabled", !0);
$47a4b45281b81a8b$var$tn.Factory.addGetterSetter($47a4b45281b81a8b$var$ce, "clearBeforeDraw", !0);
$47a4b45281b81a8b$var$tn.Factory.addGetterSetter($47a4b45281b81a8b$var$ce, "hitGraphEnabled", !0, (0, $47a4b45281b81a8b$var$Cs.getBooleanValidator)());
var $47a4b45281b81a8b$var$ze = {};
Object.defineProperty($47a4b45281b81a8b$var$ze, "__esModule", {
    value: !0
});
$47a4b45281b81a8b$var$ze.FastLayer = void 0;
const $47a4b45281b81a8b$var$Ps = $47a4b45281b81a8b$var$nt, $47a4b45281b81a8b$var$Ms = $47a4b45281b81a8b$var$xe, $47a4b45281b81a8b$var$Rs = $47a4b45281b81a8b$var$H;
class $47a4b45281b81a8b$var$en extends $47a4b45281b81a8b$var$Ms.Layer {
    constructor(t){
        super(t), this.listening(!1), $47a4b45281b81a8b$var$Ps.Util.warn('Konva.Fast layer is deprecated. Please use "new Konva.Layer({ listening: false })" instead.');
    }
}
$47a4b45281b81a8b$var$ze.FastLayer = $47a4b45281b81a8b$var$en;
$47a4b45281b81a8b$var$en.prototype.nodeType = "FastLayer";
(0, $47a4b45281b81a8b$var$Rs._registerNode)($47a4b45281b81a8b$var$en);
var $47a4b45281b81a8b$var$de = {};
Object.defineProperty($47a4b45281b81a8b$var$de, "__esModule", {
    value: !0
});
$47a4b45281b81a8b$var$de.Group = void 0;
const $47a4b45281b81a8b$var$Fs = $47a4b45281b81a8b$var$nt, $47a4b45281b81a8b$var$Os = $47a4b45281b81a8b$var$Wt, $47a4b45281b81a8b$var$Ds = $47a4b45281b81a8b$var$H;
class $47a4b45281b81a8b$var$nn extends $47a4b45281b81a8b$var$Os.Container {
    _validateAdd(t) {
        const e = t.getType();
        e !== "Group" && e !== "Shape" && $47a4b45281b81a8b$var$Fs.Util.throw("You may only add groups and shapes to groups.");
    }
}
$47a4b45281b81a8b$var$de.Group = $47a4b45281b81a8b$var$nn;
$47a4b45281b81a8b$var$nn.prototype.nodeType = "Group";
(0, $47a4b45281b81a8b$var$Ds._registerNode)($47a4b45281b81a8b$var$nn);
var $47a4b45281b81a8b$var$ue = {};
Object.defineProperty($47a4b45281b81a8b$var$ue, "__esModule", {
    value: !0
});
$47a4b45281b81a8b$var$ue.Animation = void 0;
const $47a4b45281b81a8b$var$Oi = $47a4b45281b81a8b$var$H, $47a4b45281b81a8b$var$Tn = $47a4b45281b81a8b$var$nt, $47a4b45281b81a8b$var$Di = function() {
    return $47a4b45281b81a8b$var$Oi.glob.performance && $47a4b45281b81a8b$var$Oi.glob.performance.now ? function() {
        return $47a4b45281b81a8b$var$Oi.glob.performance.now();
    } : function() {
        return /* @__PURE__ */ new Date().getTime();
    };
}();
class $47a4b45281b81a8b$var$Ct {
    constructor(t, e){
        this.id = $47a4b45281b81a8b$var$Ct.animIdCounter++, this.frame = {
            time: 0,
            timeDiff: 0,
            lastTime: $47a4b45281b81a8b$var$Di(),
            frameRate: 0
        }, this.func = t, this.setLayers(e);
    }
    setLayers(t) {
        let e = [];
        return t && (e = Array.isArray(t) ? t : [
            t
        ]), this.layers = e, this;
    }
    getLayers() {
        return this.layers;
    }
    addLayer(t) {
        const e = this.layers, i = e.length;
        for(let n = 0; n < i; n++)if (e[n]._id === t._id) return !1;
        return this.layers.push(t), !0;
    }
    isRunning() {
        const e = $47a4b45281b81a8b$var$Ct.animations, i = e.length;
        for(let n = 0; n < i; n++)if (e[n].id === this.id) return !0;
        return !1;
    }
    start() {
        return this.stop(), this.frame.timeDiff = 0, this.frame.lastTime = $47a4b45281b81a8b$var$Di(), $47a4b45281b81a8b$var$Ct._addAnimation(this), this;
    }
    stop() {
        return $47a4b45281b81a8b$var$Ct._removeAnimation(this), this;
    }
    _updateFrameObject(t) {
        this.frame.timeDiff = t - this.frame.lastTime, this.frame.lastTime = t, this.frame.time += this.frame.timeDiff, this.frame.frameRate = 1e3 / this.frame.timeDiff;
    }
    static _addAnimation(t) {
        this.animations.push(t), this._handleAnimation();
    }
    static _removeAnimation(t) {
        const e = t.id, i = this.animations, n = i.length;
        for(let r = 0; r < n; r++)if (i[r].id === e) {
            this.animations.splice(r, 1);
            break;
        }
    }
    static _runFrames() {
        const t = {}, e = this.animations;
        for(let i = 0; i < e.length; i++){
            const n = e[i], r = n.layers, s = n.func;
            n._updateFrameObject($47a4b45281b81a8b$var$Di());
            const a = r.length;
            let o;
            if (s ? o = s.call(n, n.frame) !== !1 : o = !0, !!o) for(let h = 0; h < a; h++){
                const c = r[h];
                c._id !== void 0 && (t[c._id] = c);
            }
        }
        for(const i in t)t.hasOwnProperty(i) && t[i].batchDraw();
    }
    static _animationLoop() {
        const t = $47a4b45281b81a8b$var$Ct;
        t.animations.length ? (t._runFrames(), $47a4b45281b81a8b$var$Tn.Util.requestAnimFrame(t._animationLoop)) : t.animRunning = !1;
    }
    static _handleAnimation() {
        this.animRunning || (this.animRunning = !0, $47a4b45281b81a8b$var$Tn.Util.requestAnimFrame(this._animationLoop));
    }
}
$47a4b45281b81a8b$var$ue.Animation = $47a4b45281b81a8b$var$Ct;
$47a4b45281b81a8b$var$Ct.animations = [];
$47a4b45281b81a8b$var$Ct.animIdCounter = 0;
$47a4b45281b81a8b$var$Ct.animRunning = !1;
var $47a4b45281b81a8b$var$lr = {};
(function(l) {
    Object.defineProperty(l, "__esModule", {
        value: !0
    }), l.Easings = l.Tween = void 0;
    const t = $47a4b45281b81a8b$var$nt, e = $47a4b45281b81a8b$var$ue, i = $47a4b45281b81a8b$var$et, n = $47a4b45281b81a8b$var$H, r = {
        node: 1,
        duration: 1,
        easing: 1,
        onFinish: 1,
        yoyo: 1
    }, s = 1, a = 2, o = 3, h = [
        "fill",
        "stroke",
        "shadowColor"
    ];
    let c = 0;
    class y {
        constructor(f, _, v, C, k, d, p){
            this.prop = f, this.propFunc = _, this.begin = C, this._pos = C, this.duration = d, this._change = 0, this.prevPos = 0, this.yoyo = p, this._time = 0, this._position = 0, this._startTime = 0, this._finish = 0, this.func = v, this._change = k - this.begin, this.pause();
        }
        fire(f) {
            const _ = this[f];
            _ && _();
        }
        setTime(f) {
            f > this.duration ? this.yoyo ? (this._time = this.duration, this.reverse()) : this.finish() : f < 0 ? this.yoyo ? (this._time = 0, this.play()) : this.reset() : (this._time = f, this.update());
        }
        getTime() {
            return this._time;
        }
        setPosition(f) {
            this.prevPos = this._pos, this.propFunc(f), this._pos = f;
        }
        getPosition(f) {
            return f === void 0 && (f = this._time), this.func(f, this.begin, this._change, this.duration);
        }
        play() {
            this.state = a, this._startTime = this.getTimer() - this._time, this.onEnterFrame(), this.fire("onPlay");
        }
        reverse() {
            this.state = o, this._time = this.duration - this._time, this._startTime = this.getTimer() - this._time, this.onEnterFrame(), this.fire("onReverse");
        }
        seek(f) {
            this.pause(), this._time = f, this.update(), this.fire("onSeek");
        }
        reset() {
            this.pause(), this._time = 0, this.update(), this.fire("onReset");
        }
        finish() {
            this.pause(), this._time = this.duration, this.update(), this.fire("onFinish");
        }
        update() {
            this.setPosition(this.getPosition(this._time)), this.fire("onUpdate");
        }
        onEnterFrame() {
            const f = this.getTimer() - this._startTime;
            this.state === a ? this.setTime(f) : this.state === o && this.setTime(this.duration - f);
        }
        pause() {
            this.state = s, this.fire("onPause");
        }
        getTimer() {
            return /* @__PURE__ */ new Date().getTime();
        }
    }
    class g {
        constructor(f){
            const _ = this, v = f.node, C = v._id, k = f.easing || l.Easings.Linear, d = !!f.yoyo;
            let p, b;
            typeof f.duration > "u" ? p = 0.3 : f.duration === 0 ? p = 1e-3 : p = f.duration, this.node = v, this._id = c++;
            const w = v.getLayer() || (v instanceof n.Konva.Stage ? v.getLayers() : null);
            w || t.Util.error("Tween constructor have `node` that is not in a layer. Please add node into layer first."), this.anim = new e.Animation(function() {
                _.tween.onEnterFrame();
            }, w), this.tween = new y(b, function(P) {
                _._tweenFunc(P);
            }, k, 0, 1, p * 1e3, d), this._addListeners(), g.attrs[C] || (g.attrs[C] = {}), g.attrs[C][this._id] || (g.attrs[C][this._id] = {}), g.tweens[C] || (g.tweens[C] = {});
            for(b in f)r[b] === void 0 && this._addAttr(b, f[b]);
            this.reset(), this.onFinish = f.onFinish, this.onReset = f.onReset, this.onUpdate = f.onUpdate;
        }
        _addAttr(f, _) {
            const v = this.node, C = v._id;
            let k, d, p, b, w;
            const P = g.tweens[C][f];
            P && delete g.attrs[C][P][f];
            let S = v.getAttr(f);
            if (t.Util._isArray(_)) {
                if (k = [], d = Math.max(_.length, S.length), f === "points" && _.length !== S.length && (_.length > S.length ? (b = S, S = t.Util._prepareArrayForTween(S, _, v.closed())) : (p = _, _ = t.Util._prepareArrayForTween(_, S, v.closed()))), f.indexOf("fill") === 0) for(let E = 0; E < d; E++)if (E % 2 === 0) k.push(_[E] - S[E]);
                else {
                    const m = t.Util.colorToRGBA(S[E]);
                    w = t.Util.colorToRGBA(_[E]), S[E] = m, k.push({
                        r: w.r - m.r,
                        g: w.g - m.g,
                        b: w.b - m.b,
                        a: w.a - m.a
                    });
                }
                else for(let E = 0; E < d; E++)k.push(_[E] - S[E]);
            } else h.indexOf(f) !== -1 ? (S = t.Util.colorToRGBA(S), w = t.Util.colorToRGBA(_), k = {
                r: w.r - S.r,
                g: w.g - S.g,
                b: w.b - S.b,
                a: w.a - S.a
            }) : k = _ - S;
            g.attrs[C][this._id][f] = {
                start: S,
                diff: k,
                end: _,
                trueEnd: p,
                trueStart: b
            }, g.tweens[C][f] = this._id;
        }
        _tweenFunc(f) {
            const _ = this.node, v = g.attrs[_._id][this._id];
            let C, k, d, p, b, w, P, S;
            for(C in v){
                if (k = v[C], d = k.start, p = k.diff, S = k.end, t.Util._isArray(d)) {
                    if (b = [], P = Math.max(d.length, S.length), C.indexOf("fill") === 0) for(w = 0; w < P; w++)w % 2 === 0 ? b.push((d[w] || 0) + p[w] * f) : b.push("rgba(" + Math.round(d[w].r + p[w].r * f) + "," + Math.round(d[w].g + p[w].g * f) + "," + Math.round(d[w].b + p[w].b * f) + "," + (d[w].a + p[w].a * f) + ")");
                    else for(w = 0; w < P; w++)b.push((d[w] || 0) + p[w] * f);
                } else h.indexOf(C) !== -1 ? b = "rgba(" + Math.round(d.r + p.r * f) + "," + Math.round(d.g + p.g * f) + "," + Math.round(d.b + p.b * f) + "," + (d.a + p.a * f) + ")" : b = d + p * f;
                _.setAttr(C, b);
            }
        }
        _addListeners() {
            this.tween.onPlay = ()=>{
                this.anim.start();
            }, this.tween.onReverse = ()=>{
                this.anim.start();
            }, this.tween.onPause = ()=>{
                this.anim.stop();
            }, this.tween.onFinish = ()=>{
                const f = this.node, _ = g.attrs[f._id][this._id];
                _.points && _.points.trueEnd && f.setAttr("points", _.points.trueEnd), this.onFinish && this.onFinish.call(this);
            }, this.tween.onReset = ()=>{
                const f = this.node, _ = g.attrs[f._id][this._id];
                _.points && _.points.trueStart && f.points(_.points.trueStart), this.onReset && this.onReset();
            }, this.tween.onUpdate = ()=>{
                this.onUpdate && this.onUpdate.call(this);
            };
        }
        play() {
            return this.tween.play(), this;
        }
        reverse() {
            return this.tween.reverse(), this;
        }
        reset() {
            return this.tween.reset(), this;
        }
        seek(f) {
            return this.tween.seek(f * 1e3), this;
        }
        pause() {
            return this.tween.pause(), this;
        }
        finish() {
            return this.tween.finish(), this;
        }
        destroy() {
            const f = this.node._id, _ = this._id, v = g.tweens[f];
            this.pause();
            for(const C in v)delete g.tweens[f][C];
            delete g.attrs[f][_];
        }
    }
    l.Tween = g, g.attrs = {}, g.tweens = {}, i.Node.prototype.to = function(u) {
        const f = u.onFinish;
        u.node = this, u.onFinish = function() {
            this.destroy(), f && f();
        }, new g(u).play();
    }, l.Easings = {
        BackEaseIn (u, f, _, v) {
            return _ * (u /= v) * u * (2.70158 * u - 1.70158) + f;
        },
        BackEaseOut (u, f, _, v) {
            return _ * ((u = u / v - 1) * u * (2.70158 * u + 1.70158) + 1) + f;
        },
        BackEaseInOut (u, f, _, v) {
            let C = 1.70158;
            return (u /= v / 2) < 1 ? _ / 2 * (u * u * (((C *= 1.525) + 1) * u - C)) + f : _ / 2 * ((u -= 2) * u * (((C *= 1.525) + 1) * u + C) + 2) + f;
        },
        ElasticEaseIn (u, f, _, v, C, k) {
            let d = 0;
            return u === 0 ? f : (u /= v) === 1 ? f + _ : (k || (k = v * 0.3), !C || C < Math.abs(_) ? (C = _, d = k / 4) : d = k / (2 * Math.PI) * Math.asin(_ / C), -(C * Math.pow(2, 10 * (u -= 1)) * Math.sin((u * v - d) * (2 * Math.PI) / k)) + f);
        },
        ElasticEaseOut (u, f, _, v, C, k) {
            let d = 0;
            return u === 0 ? f : (u /= v) === 1 ? f + _ : (k || (k = v * 0.3), !C || C < Math.abs(_) ? (C = _, d = k / 4) : d = k / (2 * Math.PI) * Math.asin(_ / C), C * Math.pow(2, -10 * u) * Math.sin((u * v - d) * (2 * Math.PI) / k) + _ + f);
        },
        ElasticEaseInOut (u, f, _, v, C, k) {
            let d = 0;
            return u === 0 ? f : (u /= v / 2) === 2 ? f + _ : (k || (k = v * (0.3 * 1.5)), !C || C < Math.abs(_) ? (C = _, d = k / 4) : d = k / (2 * Math.PI) * Math.asin(_ / C), u < 1 ? -0.5 * (C * Math.pow(2, 10 * (u -= 1)) * Math.sin((u * v - d) * (2 * Math.PI) / k)) + f : C * Math.pow(2, -10 * (u -= 1)) * Math.sin((u * v - d) * (2 * Math.PI) / k) * 0.5 + _ + f);
        },
        BounceEaseOut (u, f, _, v) {
            return (u /= v) < 1 / 2.75 ? _ * (7.5625 * u * u) + f : u < 2 / 2.75 ? _ * (7.5625 * (u -= 1.5 / 2.75) * u + 0.75) + f : u < 2.5 / 2.75 ? _ * (7.5625 * (u -= 2.25 / 2.75) * u + 0.9375) + f : _ * (7.5625 * (u -= 2.625 / 2.75) * u + 0.984375) + f;
        },
        BounceEaseIn (u, f, _, v) {
            return _ - l.Easings.BounceEaseOut(v - u, 0, _, v) + f;
        },
        BounceEaseInOut (u, f, _, v) {
            return u < v / 2 ? l.Easings.BounceEaseIn(u * 2, 0, _, v) * 0.5 + f : l.Easings.BounceEaseOut(u * 2 - v, 0, _, v) * 0.5 + _ * 0.5 + f;
        },
        EaseIn (u, f, _, v) {
            return _ * (u /= v) * u + f;
        },
        EaseOut (u, f, _, v) {
            return -_ * (u /= v) * (u - 2) + f;
        },
        EaseInOut (u, f, _, v) {
            return (u /= v / 2) < 1 ? _ / 2 * u * u + f : -_ / 2 * (--u * (u - 2) - 1) + f;
        },
        StrongEaseIn (u, f, _, v) {
            return _ * (u /= v) * u * u * u * u + f;
        },
        StrongEaseOut (u, f, _, v) {
            return _ * ((u = u / v - 1) * u * u * u * u + 1) + f;
        },
        StrongEaseInOut (u, f, _, v) {
            return (u /= v / 2) < 1 ? _ / 2 * u * u * u * u * u + f : _ / 2 * ((u -= 2) * u * u * u * u + 2) + f;
        },
        Linear (u, f, _, v) {
            return _ * u / v + f;
        }
    };
})($47a4b45281b81a8b$var$lr);
(function(l) {
    Object.defineProperty(l, "__esModule", {
        value: !0
    }), l.Konva = void 0;
    const t = $47a4b45281b81a8b$var$H, e = $47a4b45281b81a8b$var$nt, i = $47a4b45281b81a8b$var$et, n = $47a4b45281b81a8b$var$Wt, r = $47a4b45281b81a8b$var$rr, s = $47a4b45281b81a8b$var$xe, a = $47a4b45281b81a8b$var$ze, o = $47a4b45281b81a8b$var$de, h = $47a4b45281b81a8b$var$Ve, c = $47a4b45281b81a8b$var$ct, y = $47a4b45281b81a8b$var$ue, g = $47a4b45281b81a8b$var$lr, u = $47a4b45281b81a8b$var$At, f = $47a4b45281b81a8b$var$bt;
    l.Konva = e.Util._assign(t.Konva, {
        Util: e.Util,
        Transform: e.Transform,
        Node: i.Node,
        Container: n.Container,
        Stage: r.Stage,
        stages: r.stages,
        Layer: s.Layer,
        FastLayer: a.FastLayer,
        Group: o.Group,
        DD: h.DD,
        Shape: c.Shape,
        shapes: c.shapes,
        Animation: y.Animation,
        Tween: g.Tween,
        Easings: g.Easings,
        Context: u.Context,
        Canvas: f.Canvas
    }), l.default = l.Konva;
})($47a4b45281b81a8b$var$tr);
var $47a4b45281b81a8b$var$We = {};
Object.defineProperty($47a4b45281b81a8b$var$We, "__esModule", {
    value: !0
});
$47a4b45281b81a8b$var$We.Arc = void 0;
const $47a4b45281b81a8b$var$Xe = $47a4b45281b81a8b$var$V, $47a4b45281b81a8b$var$Ls = $47a4b45281b81a8b$var$ct, $47a4b45281b81a8b$var$kn = $47a4b45281b81a8b$var$H, $47a4b45281b81a8b$var$Ke = $47a4b45281b81a8b$var$L, $47a4b45281b81a8b$var$Gs = $47a4b45281b81a8b$var$H;
class $47a4b45281b81a8b$var$Rt extends $47a4b45281b81a8b$var$Ls.Shape {
    _sceneFunc(t) {
        const e = $47a4b45281b81a8b$var$kn.Konva.getAngle(this.angle()), i = this.clockwise();
        t.beginPath(), t.arc(0, 0, this.outerRadius(), 0, e, i), t.arc(0, 0, this.innerRadius(), e, 0, !i), t.closePath(), t.fillStrokeShape(this);
    }
    getWidth() {
        return this.outerRadius() * 2;
    }
    getHeight() {
        return this.outerRadius() * 2;
    }
    setWidth(t) {
        this.outerRadius(t / 2);
    }
    setHeight(t) {
        this.outerRadius(t / 2);
    }
    getSelfRect() {
        const t = this.innerRadius(), e = this.outerRadius(), i = this.clockwise(), n = $47a4b45281b81a8b$var$kn.Konva.getAngle(i ? 360 - this.angle() : this.angle()), r = Math.cos(Math.min(n, Math.PI)), s = 1, a = Math.sin(Math.min(Math.max(Math.PI, n), 3 * Math.PI / 2)), o = Math.sin(Math.min(n, Math.PI / 2)), h = r * (r > 0 ? t : e), c = s * e, y = a * (a > 0 ? t : e), g = o * (o > 0 ? e : t);
        return {
            x: h,
            y: i ? -1 * g : y,
            width: c - h,
            height: g - y
        };
    }
}
$47a4b45281b81a8b$var$We.Arc = $47a4b45281b81a8b$var$Rt;
$47a4b45281b81a8b$var$Rt.prototype._centroid = !0;
$47a4b45281b81a8b$var$Rt.prototype.className = "Arc";
$47a4b45281b81a8b$var$Rt.prototype._attrsAffectingSize = [
    "innerRadius",
    "outerRadius"
];
(0, $47a4b45281b81a8b$var$Gs._registerNode)($47a4b45281b81a8b$var$Rt);
$47a4b45281b81a8b$var$Xe.Factory.addGetterSetter($47a4b45281b81a8b$var$Rt, "innerRadius", 0, (0, $47a4b45281b81a8b$var$Ke.getNumberValidator)());
$47a4b45281b81a8b$var$Xe.Factory.addGetterSetter($47a4b45281b81a8b$var$Rt, "outerRadius", 0, (0, $47a4b45281b81a8b$var$Ke.getNumberValidator)());
$47a4b45281b81a8b$var$Xe.Factory.addGetterSetter($47a4b45281b81a8b$var$Rt, "angle", 0, (0, $47a4b45281b81a8b$var$Ke.getNumberValidator)());
$47a4b45281b81a8b$var$Xe.Factory.addGetterSetter($47a4b45281b81a8b$var$Rt, "clockwise", !1, (0, $47a4b45281b81a8b$var$Ke.getBooleanValidator)());
var $47a4b45281b81a8b$var$Ye = {}, $47a4b45281b81a8b$var$Te = {};
Object.defineProperty($47a4b45281b81a8b$var$Te, "__esModule", {
    value: !0
});
$47a4b45281b81a8b$var$Te.Line = void 0;
const $47a4b45281b81a8b$var$je = $47a4b45281b81a8b$var$V, $47a4b45281b81a8b$var$Is = $47a4b45281b81a8b$var$H, $47a4b45281b81a8b$var$Ns = $47a4b45281b81a8b$var$ct, $47a4b45281b81a8b$var$hr = $47a4b45281b81a8b$var$L;
function $47a4b45281b81a8b$var$Wi(l, t, e, i, n, r, s) {
    const a = Math.sqrt(Math.pow(e - l, 2) + Math.pow(i - t, 2)), o = Math.sqrt(Math.pow(n - e, 2) + Math.pow(r - i, 2)), h = s * a / (a + o), c = s * o / (a + o), y = e - h * (n - l), g = i - h * (r - t), u = e + c * (n - l), f = i + c * (r - t);
    return [
        y,
        g,
        u,
        f
    ];
}
function $47a4b45281b81a8b$var$En(l, t) {
    const e = l.length, i = [];
    for(let n = 2; n < e - 2; n += 2){
        const r = $47a4b45281b81a8b$var$Wi(l[n - 2], l[n - 1], l[n], l[n + 1], l[n + 2], l[n + 3], t);
        isNaN(r[0]) || (i.push(r[0]), i.push(r[1]), i.push(l[n]), i.push(l[n + 1]), i.push(r[2]), i.push(r[3]));
    }
    return i;
}
class $47a4b45281b81a8b$var$Nt extends $47a4b45281b81a8b$var$Ns.Shape {
    constructor(t){
        super(t), this.on("pointsChange.konva tensionChange.konva closedChange.konva bezierChange.konva", function() {
            this._clearCache("tensionPoints");
        });
    }
    _sceneFunc(t) {
        let e = this.points(), i = e.length, n = this.tension(), r = this.closed(), s = this.bezier(), a, o, h;
        if (i) {
            if (t.beginPath(), t.moveTo(e[0], e[1]), n !== 0 && i > 4) {
                for(a = this.getTensionPoints(), o = a.length, h = r ? 0 : 4, r || t.quadraticCurveTo(a[0], a[1], a[2], a[3]); h < o - 2;)t.bezierCurveTo(a[h++], a[h++], a[h++], a[h++], a[h++], a[h++]);
                r || t.quadraticCurveTo(a[o - 2], a[o - 1], e[i - 2], e[i - 1]);
            } else if (s) for(h = 2; h < i;)t.bezierCurveTo(e[h++], e[h++], e[h++], e[h++], e[h++], e[h++]);
            else for(h = 2; h < i; h += 2)t.lineTo(e[h], e[h + 1]);
            r ? (t.closePath(), t.fillStrokeShape(this)) : t.strokeShape(this);
        }
    }
    getTensionPoints() {
        return this._getCache("tensionPoints", this._getTensionPoints);
    }
    _getTensionPoints() {
        return this.closed() ? this._getTensionPointsClosed() : $47a4b45281b81a8b$var$En(this.points(), this.tension());
    }
    _getTensionPointsClosed() {
        const t = this.points(), e = t.length, i = this.tension(), n = $47a4b45281b81a8b$var$Wi(t[e - 2], t[e - 1], t[0], t[1], t[2], t[3], i), r = $47a4b45281b81a8b$var$Wi(t[e - 4], t[e - 3], t[e - 2], t[e - 1], t[0], t[1], i), s = $47a4b45281b81a8b$var$En(t, i);
        return [
            n[2],
            n[3]
        ].concat(s).concat([
            r[0],
            r[1],
            t[e - 2],
            t[e - 1],
            r[2],
            r[3],
            n[0],
            n[1],
            t[0],
            t[1]
        ]);
    }
    getWidth() {
        return this.getSelfRect().width;
    }
    getHeight() {
        return this.getSelfRect().height;
    }
    getSelfRect() {
        let t = this.points();
        if (t.length < 4) return {
            x: t[0] || 0,
            y: t[1] || 0,
            width: 0,
            height: 0
        };
        this.tension() !== 0 ? t = [
            t[0],
            t[1],
            ...this._getTensionPoints(),
            t[t.length - 2],
            t[t.length - 1]
        ] : t = this.points();
        let e = t[0], i = t[0], n = t[1], r = t[1], s, a;
        for(let o = 0; o < t.length / 2; o++)s = t[o * 2], a = t[o * 2 + 1], e = Math.min(e, s), i = Math.max(i, s), n = Math.min(n, a), r = Math.max(r, a);
        return {
            x: e,
            y: n,
            width: i - e,
            height: r - n
        };
    }
}
$47a4b45281b81a8b$var$Te.Line = $47a4b45281b81a8b$var$Nt;
$47a4b45281b81a8b$var$Nt.prototype.className = "Line";
$47a4b45281b81a8b$var$Nt.prototype._attrsAffectingSize = [
    "points",
    "bezier",
    "tension"
];
(0, $47a4b45281b81a8b$var$Is._registerNode)($47a4b45281b81a8b$var$Nt);
$47a4b45281b81a8b$var$je.Factory.addGetterSetter($47a4b45281b81a8b$var$Nt, "closed", !1);
$47a4b45281b81a8b$var$je.Factory.addGetterSetter($47a4b45281b81a8b$var$Nt, "bezier", !1);
$47a4b45281b81a8b$var$je.Factory.addGetterSetter($47a4b45281b81a8b$var$Nt, "tension", 0, (0, $47a4b45281b81a8b$var$hr.getNumberValidator)());
$47a4b45281b81a8b$var$je.Factory.addGetterSetter($47a4b45281b81a8b$var$Nt, "points", [], (0, $47a4b45281b81a8b$var$hr.getNumberArrayValidator)());
var $47a4b45281b81a8b$var$ge = {}, $47a4b45281b81a8b$var$cr = {};
(function(l) {
    Object.defineProperty(l, "__esModule", {
        value: !0
    }), l.t2length = l.getQuadraticArcLength = l.getCubicArcLength = l.binomialCoefficients = l.cValues = l.tValues = void 0, l.tValues = [
        [],
        [],
        [
            -0.5773502691896257,
            0.5773502691896257
        ],
        [
            0,
            -0.7745966692414834,
            0.7745966692414834
        ],
        [
            -0.33998104358485626,
            0.33998104358485626,
            -0.8611363115940526,
            0.8611363115940526
        ],
        [
            0,
            -0.5384693101056831,
            0.5384693101056831,
            -0.906179845938664,
            0.906179845938664
        ],
        [
            0.6612093864662645,
            -0.6612093864662645,
            -0.2386191860831969,
            0.2386191860831969,
            -0.932469514203152,
            0.932469514203152
        ],
        [
            0,
            0.4058451513773972,
            -0.4058451513773972,
            -0.7415311855993945,
            0.7415311855993945,
            -0.9491079123427585,
            0.9491079123427585
        ],
        [
            -0.1834346424956498,
            0.1834346424956498,
            -0.525532409916329,
            0.525532409916329,
            -0.7966664774136267,
            0.7966664774136267,
            -0.9602898564975363,
            0.9602898564975363
        ],
        [
            0,
            -0.8360311073266358,
            0.8360311073266358,
            -0.9681602395076261,
            0.9681602395076261,
            -0.3242534234038089,
            0.3242534234038089,
            -0.6133714327005904,
            0.6133714327005904
        ],
        [
            -0.14887433898163122,
            0.14887433898163122,
            -0.4333953941292472,
            0.4333953941292472,
            -0.6794095682990244,
            0.6794095682990244,
            -0.8650633666889845,
            0.8650633666889845,
            -0.9739065285171717,
            0.9739065285171717
        ],
        [
            0,
            -0.26954315595234496,
            0.26954315595234496,
            -0.5190961292068118,
            0.5190961292068118,
            -0.7301520055740494,
            0.7301520055740494,
            -0.8870625997680953,
            0.8870625997680953,
            -0.978228658146057,
            0.978228658146057
        ],
        [
            -0.1252334085114689,
            0.1252334085114689,
            -0.3678314989981802,
            0.3678314989981802,
            -0.5873179542866175,
            0.5873179542866175,
            -0.7699026741943047,
            0.7699026741943047,
            -0.9041172563704749,
            0.9041172563704749,
            -0.9815606342467192,
            0.9815606342467192
        ],
        [
            0,
            -0.2304583159551348,
            0.2304583159551348,
            -0.44849275103644687,
            0.44849275103644687,
            -0.6423493394403402,
            0.6423493394403402,
            -0.8015780907333099,
            0.8015780907333099,
            -0.9175983992229779,
            0.9175983992229779,
            -0.9841830547185881,
            0.9841830547185881
        ],
        [
            -0.10805494870734367,
            0.10805494870734367,
            -0.31911236892788974,
            0.31911236892788974,
            -0.5152486363581541,
            0.5152486363581541,
            -0.6872929048116855,
            0.6872929048116855,
            -0.827201315069765,
            0.827201315069765,
            -0.9284348836635735,
            0.9284348836635735,
            -0.9862838086968123,
            0.9862838086968123
        ],
        [
            0,
            -0.20119409399743451,
            0.20119409399743451,
            -0.3941513470775634,
            0.3941513470775634,
            -0.5709721726085388,
            0.5709721726085388,
            -0.7244177313601701,
            0.7244177313601701,
            -0.8482065834104272,
            0.8482065834104272,
            -0.937273392400706,
            0.937273392400706,
            -0.9879925180204854,
            0.9879925180204854
        ],
        [
            -0.09501250983763744,
            0.09501250983763744,
            -0.2816035507792589,
            0.2816035507792589,
            -0.45801677765722737,
            0.45801677765722737,
            -0.6178762444026438,
            0.6178762444026438,
            -0.755404408355003,
            0.755404408355003,
            -0.8656312023878318,
            0.8656312023878318,
            -0.9445750230732326,
            0.9445750230732326,
            -0.9894009349916499,
            0.9894009349916499
        ],
        [
            0,
            -0.17848418149584785,
            0.17848418149584785,
            -0.3512317634538763,
            0.3512317634538763,
            -0.5126905370864769,
            0.5126905370864769,
            -0.6576711592166907,
            0.6576711592166907,
            -0.7815140038968014,
            0.7815140038968014,
            -0.8802391537269859,
            0.8802391537269859,
            -0.9506755217687678,
            0.9506755217687678,
            -0.9905754753144174,
            0.9905754753144174
        ],
        [
            -0.0847750130417353,
            0.0847750130417353,
            -0.2518862256915055,
            0.2518862256915055,
            -0.41175116146284263,
            0.41175116146284263,
            -0.5597708310739475,
            0.5597708310739475,
            -0.6916870430603532,
            0.6916870430603532,
            -0.8037049589725231,
            0.8037049589725231,
            -0.8926024664975557,
            0.8926024664975557,
            -0.9558239495713977,
            0.9558239495713977,
            -0.9915651684209309,
            0.9915651684209309
        ],
        [
            0,
            -0.16035864564022537,
            0.16035864564022537,
            -0.31656409996362983,
            0.31656409996362983,
            -0.46457074137596094,
            0.46457074137596094,
            -0.600545304661681,
            0.600545304661681,
            -0.7209661773352294,
            0.7209661773352294,
            -0.8227146565371428,
            0.8227146565371428,
            -0.9031559036148179,
            0.9031559036148179,
            -0.96020815213483,
            0.96020815213483,
            -0.9924068438435844,
            0.9924068438435844
        ],
        [
            -0.07652652113349734,
            0.07652652113349734,
            -0.22778585114164507,
            0.22778585114164507,
            -0.37370608871541955,
            0.37370608871541955,
            -0.5108670019508271,
            0.5108670019508271,
            -0.636053680726515,
            0.636053680726515,
            -0.7463319064601508,
            0.7463319064601508,
            -0.8391169718222188,
            0.8391169718222188,
            -0.912234428251326,
            0.912234428251326,
            -0.9639719272779138,
            0.9639719272779138,
            -0.9931285991850949,
            0.9931285991850949
        ],
        [
            0,
            -0.1455618541608951,
            0.1455618541608951,
            -0.2880213168024011,
            0.2880213168024011,
            -0.4243421202074388,
            0.4243421202074388,
            -0.5516188358872198,
            0.5516188358872198,
            -0.6671388041974123,
            0.6671388041974123,
            -0.7684399634756779,
            0.7684399634756779,
            -0.8533633645833173,
            0.8533633645833173,
            -0.9200993341504008,
            0.9200993341504008,
            -0.9672268385663063,
            0.9672268385663063,
            -0.9937521706203895,
            0.9937521706203895
        ],
        [
            -0.06973927331972223,
            0.06973927331972223,
            -0.20786042668822127,
            0.20786042668822127,
            -0.34193582089208424,
            0.34193582089208424,
            -0.469355837986757,
            0.469355837986757,
            -0.5876404035069116,
            0.5876404035069116,
            -0.6944872631866827,
            0.6944872631866827,
            -0.7878168059792081,
            0.7878168059792081,
            -0.8658125777203002,
            0.8658125777203002,
            -0.926956772187174,
            0.926956772187174,
            -0.9700604978354287,
            0.9700604978354287,
            -0.9942945854823992,
            0.9942945854823992
        ],
        [
            0,
            -0.1332568242984661,
            0.1332568242984661,
            -0.26413568097034495,
            0.26413568097034495,
            -0.3903010380302908,
            0.3903010380302908,
            -0.5095014778460075,
            0.5095014778460075,
            -0.6196098757636461,
            0.6196098757636461,
            -0.7186613631319502,
            0.7186613631319502,
            -0.8048884016188399,
            0.8048884016188399,
            -0.8767523582704416,
            0.8767523582704416,
            -0.9329710868260161,
            0.9329710868260161,
            -0.9725424712181152,
            0.9725424712181152,
            -0.9947693349975522,
            0.9947693349975522
        ],
        [
            -0.06405689286260563,
            0.06405689286260563,
            -0.1911188674736163,
            0.1911188674736163,
            -0.3150426796961634,
            0.3150426796961634,
            -0.4337935076260451,
            0.4337935076260451,
            -0.5454214713888396,
            0.5454214713888396,
            -0.6480936519369755,
            0.6480936519369755,
            -0.7401241915785544,
            0.7401241915785544,
            -0.820001985973903,
            0.820001985973903,
            -0.8864155270044011,
            0.8864155270044011,
            -0.9382745520027328,
            0.9382745520027328,
            -0.9747285559713095,
            0.9747285559713095,
            -0.9951872199970213,
            0.9951872199970213
        ]
    ], l.cValues = [
        [],
        [],
        [
            1,
            1
        ],
        [
            0.8888888888888888,
            0.5555555555555556,
            0.5555555555555556
        ],
        [
            0.6521451548625461,
            0.6521451548625461,
            0.34785484513745385,
            0.34785484513745385
        ],
        [
            0.5688888888888889,
            0.47862867049936647,
            0.47862867049936647,
            0.23692688505618908,
            0.23692688505618908
        ],
        [
            0.3607615730481386,
            0.3607615730481386,
            0.46791393457269104,
            0.46791393457269104,
            0.17132449237917036,
            0.17132449237917036
        ],
        [
            0.4179591836734694,
            0.3818300505051189,
            0.3818300505051189,
            0.27970539148927664,
            0.27970539148927664,
            0.1294849661688697,
            0.1294849661688697
        ],
        [
            0.362683783378362,
            0.362683783378362,
            0.31370664587788727,
            0.31370664587788727,
            0.22238103445337448,
            0.22238103445337448,
            0.10122853629037626,
            0.10122853629037626
        ],
        [
            0.3302393550012598,
            0.1806481606948574,
            0.1806481606948574,
            0.08127438836157441,
            0.08127438836157441,
            0.31234707704000286,
            0.31234707704000286,
            0.26061069640293544,
            0.26061069640293544
        ],
        [
            0.29552422471475287,
            0.29552422471475287,
            0.26926671930999635,
            0.26926671930999635,
            0.21908636251598204,
            0.21908636251598204,
            0.1494513491505806,
            0.1494513491505806,
            0.06667134430868814,
            0.06667134430868814
        ],
        [
            0.2729250867779006,
            0.26280454451024665,
            0.26280454451024665,
            0.23319376459199048,
            0.23319376459199048,
            0.18629021092773426,
            0.18629021092773426,
            0.1255803694649046,
            0.1255803694649046,
            0.05566856711617366,
            0.05566856711617366
        ],
        [
            0.24914704581340277,
            0.24914704581340277,
            0.2334925365383548,
            0.2334925365383548,
            0.20316742672306592,
            0.20316742672306592,
            0.16007832854334622,
            0.16007832854334622,
            0.10693932599531843,
            0.10693932599531843,
            0.04717533638651183,
            0.04717533638651183
        ],
        [
            0.2325515532308739,
            0.22628318026289723,
            0.22628318026289723,
            0.2078160475368885,
            0.2078160475368885,
            0.17814598076194574,
            0.17814598076194574,
            0.13887351021978725,
            0.13887351021978725,
            0.09212149983772845,
            0.09212149983772845,
            0.04048400476531588,
            0.04048400476531588
        ],
        [
            0.2152638534631578,
            0.2152638534631578,
            0.2051984637212956,
            0.2051984637212956,
            0.18553839747793782,
            0.18553839747793782,
            0.15720316715819355,
            0.15720316715819355,
            0.12151857068790319,
            0.12151857068790319,
            0.08015808715976021,
            0.08015808715976021,
            0.03511946033175186,
            0.03511946033175186
        ],
        [
            0.2025782419255613,
            0.19843148532711158,
            0.19843148532711158,
            0.1861610000155622,
            0.1861610000155622,
            0.16626920581699392,
            0.16626920581699392,
            0.13957067792615432,
            0.13957067792615432,
            0.10715922046717194,
            0.10715922046717194,
            0.07036604748810812,
            0.07036604748810812,
            0.03075324199611727,
            0.03075324199611727
        ],
        [
            0.1894506104550685,
            0.1894506104550685,
            0.18260341504492358,
            0.18260341504492358,
            0.16915651939500254,
            0.16915651939500254,
            0.14959598881657674,
            0.14959598881657674,
            0.12462897125553388,
            0.12462897125553388,
            0.09515851168249279,
            0.09515851168249279,
            0.062253523938647894,
            0.062253523938647894,
            0.027152459411754096,
            0.027152459411754096
        ],
        [
            0.17944647035620653,
            0.17656270536699264,
            0.17656270536699264,
            0.16800410215645004,
            0.16800410215645004,
            0.15404576107681028,
            0.15404576107681028,
            0.13513636846852548,
            0.13513636846852548,
            0.11188384719340397,
            0.11188384719340397,
            0.08503614831717918,
            0.08503614831717918,
            0.0554595293739872,
            0.0554595293739872,
            0.02414830286854793,
            0.02414830286854793
        ],
        [
            0.1691423829631436,
            0.1691423829631436,
            0.16427648374583273,
            0.16427648374583273,
            0.15468467512626524,
            0.15468467512626524,
            0.14064291467065065,
            0.14064291467065065,
            0.12255520671147846,
            0.12255520671147846,
            0.10094204410628717,
            0.10094204410628717,
            0.07642573025488905,
            0.07642573025488905,
            0.0497145488949698,
            0.0497145488949698,
            0.02161601352648331,
            0.02161601352648331
        ],
        [
            0.1610544498487837,
            0.15896884339395434,
            0.15896884339395434,
            0.15276604206585967,
            0.15276604206585967,
            0.1426067021736066,
            0.1426067021736066,
            0.12875396253933621,
            0.12875396253933621,
            0.11156664554733399,
            0.11156664554733399,
            0.09149002162245,
            0.09149002162245,
            0.06904454273764123,
            0.06904454273764123,
            0.0448142267656996,
            0.0448142267656996,
            0.019461788229726478,
            0.019461788229726478
        ],
        [
            0.15275338713072584,
            0.15275338713072584,
            0.14917298647260374,
            0.14917298647260374,
            0.14209610931838204,
            0.14209610931838204,
            0.13168863844917664,
            0.13168863844917664,
            0.11819453196151841,
            0.11819453196151841,
            0.10193011981724044,
            0.10193011981724044,
            0.08327674157670475,
            0.08327674157670475,
            0.06267204833410907,
            0.06267204833410907,
            0.04060142980038694,
            0.04060142980038694,
            0.017614007139152118,
            0.017614007139152118
        ],
        [
            0.14608113364969041,
            0.14452440398997005,
            0.14452440398997005,
            0.13988739479107315,
            0.13988739479107315,
            0.13226893863333747,
            0.13226893863333747,
            0.12183141605372853,
            0.12183141605372853,
            0.10879729916714838,
            0.10879729916714838,
            0.09344442345603386,
            0.09344442345603386,
            0.0761001136283793,
            0.0761001136283793,
            0.057134425426857205,
            0.057134425426857205,
            0.036953789770852494,
            0.036953789770852494,
            0.016017228257774335,
            0.016017228257774335
        ],
        [
            0.13925187285563198,
            0.13925187285563198,
            0.13654149834601517,
            0.13654149834601517,
            0.13117350478706238,
            0.13117350478706238,
            0.12325237681051242,
            0.12325237681051242,
            0.11293229608053922,
            0.11293229608053922,
            0.10041414444288096,
            0.10041414444288096,
            0.08594160621706773,
            0.08594160621706773,
            0.06979646842452049,
            0.06979646842452049,
            0.052293335152683286,
            0.052293335152683286,
            0.03377490158481415,
            0.03377490158481415,
            0.0146279952982722,
            0.0146279952982722
        ],
        [
            0.13365457218610619,
            0.1324620394046966,
            0.1324620394046966,
            0.12890572218808216,
            0.12890572218808216,
            0.12304908430672953,
            0.12304908430672953,
            0.11499664022241136,
            0.11499664022241136,
            0.10489209146454141,
            0.10489209146454141,
            0.09291576606003515,
            0.09291576606003515,
            0.07928141177671895,
            0.07928141177671895,
            0.06423242140852585,
            0.06423242140852585,
            0.04803767173108467,
            0.04803767173108467,
            0.030988005856979445,
            0.030988005856979445,
            0.013411859487141771,
            0.013411859487141771
        ],
        [
            0.12793819534675216,
            0.12793819534675216,
            0.1258374563468283,
            0.1258374563468283,
            0.12167047292780339,
            0.12167047292780339,
            0.1155056680537256,
            0.1155056680537256,
            0.10744427011596563,
            0.10744427011596563,
            0.09761865210411388,
            0.09761865210411388,
            0.08619016153195327,
            0.08619016153195327,
            0.0733464814110803,
            0.0733464814110803,
            0.05929858491543678,
            0.05929858491543678,
            0.04427743881741981,
            0.04427743881741981,
            0.028531388628933663,
            0.028531388628933663,
            0.0123412297999872,
            0.0123412297999872
        ]
    ], l.binomialCoefficients = [
        [
            1
        ],
        [
            1,
            1
        ],
        [
            1,
            2,
            1
        ],
        [
            1,
            3,
            3,
            1
        ]
    ];
    const t = (s, a, o)=>{
        let h, c;
        const g = o / 2;
        h = 0;
        for(let u = 0; u < 20; u++)c = g * l.tValues[20][u] + g, h += l.cValues[20][u] * i(s, a, c);
        return g * h;
    };
    l.getCubicArcLength = t;
    const e = (s, a, o)=>{
        o === void 0 && (o = 1);
        const h = s[0] - 2 * s[1] + s[2], c = a[0] - 2 * a[1] + a[2], y = 2 * s[1] - 2 * s[0], g = 2 * a[1] - 2 * a[0], u = 4 * (h * h + c * c), f = 4 * (h * y + c * g), _ = y * y + g * g;
        if (u === 0) return o * Math.sqrt(Math.pow(s[2] - s[0], 2) + Math.pow(a[2] - a[0], 2));
        const v = f / (2 * u), C = _ / u, k = o + v, d = C - v * v, p = k * k + d > 0 ? Math.sqrt(k * k + d) : 0, b = v * v + d > 0 ? Math.sqrt(v * v + d) : 0, w = v + Math.sqrt(v * v + d) !== 0 ? d * Math.log(Math.abs((k + p) / (v + b))) : 0;
        return Math.sqrt(u) / 2 * (k * p - v * b + w);
    };
    l.getQuadraticArcLength = e;
    function i(s, a, o) {
        const h = n(1, o, s), c = n(1, o, a), y = h * h + c * c;
        return Math.sqrt(y);
    }
    const n = (s, a, o)=>{
        const h = o.length - 1;
        let c, y;
        if (h === 0) return 0;
        if (s === 0) {
            y = 0;
            for(let g = 0; g <= h; g++)y += l.binomialCoefficients[h][g] * Math.pow(1 - a, h - g) * Math.pow(a, g) * o[g];
            return y;
        } else {
            c = new Array(h);
            for(let g = 0; g < h; g++)c[g] = h * (o[g + 1] - o[g]);
            return n(s - 1, a, c);
        }
    }, r = (s, a, o)=>{
        let h = 1, c = s / a, y = (s - o(c)) / a, g = 0;
        for(; h > 1e-3;){
            const u = o(c + y), f = Math.abs(s - u) / a;
            if (f < h) h = f, c += y;
            else {
                const _ = o(c - y), v = Math.abs(s - _) / a;
                v < h ? (h = v, c -= y) : y /= 2;
            }
            if (g++, g > 500) break;
        }
        return c;
    };
    l.t2length = r;
})($47a4b45281b81a8b$var$cr);
Object.defineProperty($47a4b45281b81a8b$var$ge, "__esModule", {
    value: !0
});
$47a4b45281b81a8b$var$ge.Path = void 0;
const $47a4b45281b81a8b$var$Us = $47a4b45281b81a8b$var$V, $47a4b45281b81a8b$var$Bs = $47a4b45281b81a8b$var$ct, $47a4b45281b81a8b$var$Hs = $47a4b45281b81a8b$var$H, $47a4b45281b81a8b$var$ne = $47a4b45281b81a8b$var$cr;
class $47a4b45281b81a8b$var$ht extends $47a4b45281b81a8b$var$Bs.Shape {
    constructor(t){
        super(t), this.dataArray = [], this.pathLength = 0, this._readDataAttribute(), this.on("dataChange.konva", function() {
            this._readDataAttribute();
        });
    }
    _readDataAttribute() {
        this.dataArray = $47a4b45281b81a8b$var$ht.parsePathData(this.data()), this.pathLength = $47a4b45281b81a8b$var$ht.getPathLength(this.dataArray);
    }
    _sceneFunc(t) {
        const e = this.dataArray;
        t.beginPath();
        let i = !1;
        for(let _ = 0; _ < e.length; _++){
            const v = e[_].command, C = e[_].points;
            switch(v){
                case "L":
                    t.lineTo(C[0], C[1]);
                    break;
                case "M":
                    t.moveTo(C[0], C[1]);
                    break;
                case "C":
                    t.bezierCurveTo(C[0], C[1], C[2], C[3], C[4], C[5]);
                    break;
                case "Q":
                    t.quadraticCurveTo(C[0], C[1], C[2], C[3]);
                    break;
                case "A":
                    var n = C[0], r = C[1], s = C[2], a = C[3], o = C[4], h = C[5], c = C[6], y = C[7], g = s > a ? s : a, u = s > a ? 1 : s / a, f = s > a ? a / s : 1;
                    t.translate(n, r), t.rotate(c), t.scale(u, f), t.arc(0, 0, g, o, o + h, 1 - y), t.scale(1 / u, 1 / f), t.rotate(-c), t.translate(-n, -r);
                    break;
                case "z":
                    i = !0, t.closePath();
                    break;
            }
        }
        !i && !this.hasFill() ? t.strokeShape(this) : t.fillStrokeShape(this);
    }
    getSelfRect() {
        let t = [];
        this.dataArray.forEach(function(o) {
            if (o.command === "A") {
                const h = o.points[4], c = o.points[5], y = o.points[4] + c;
                let g = Math.PI / 180;
                if (Math.abs(h - y) < g && (g = Math.abs(h - y)), c < 0) for(let u = h - g; u > y; u -= g){
                    const f = $47a4b45281b81a8b$var$ht.getPointOnEllipticalArc(o.points[0], o.points[1], o.points[2], o.points[3], u, 0);
                    t.push(f.x, f.y);
                }
                else for(let u = h + g; u < y; u += g){
                    const f = $47a4b45281b81a8b$var$ht.getPointOnEllipticalArc(o.points[0], o.points[1], o.points[2], o.points[3], u, 0);
                    t.push(f.x, f.y);
                }
            } else if (o.command === "C") for(let h = 0; h <= 1; h += 0.01){
                const c = $47a4b45281b81a8b$var$ht.getPointOnCubicBezier(h, o.start.x, o.start.y, o.points[0], o.points[1], o.points[2], o.points[3], o.points[4], o.points[5]);
                t.push(c.x, c.y);
            }
            else t = t.concat(o.points);
        });
        let e = t[0], i = t[0], n = t[1], r = t[1], s, a;
        for(let o = 0; o < t.length / 2; o++)s = t[o * 2], a = t[o * 2 + 1], isNaN(s) || (e = Math.min(e, s), i = Math.max(i, s)), isNaN(a) || (n = Math.min(n, a), r = Math.max(r, a));
        return {
            x: e,
            y: n,
            width: i - e,
            height: r - n
        };
    }
    getLength() {
        return this.pathLength;
    }
    getPointAtLength(t) {
        return $47a4b45281b81a8b$var$ht.getPointAtLengthOfDataArray(t, this.dataArray);
    }
    static getLineLength(t, e, i, n) {
        return Math.sqrt((i - t) * (i - t) + (n - e) * (n - e));
    }
    static getPathLength(t) {
        let e = 0;
        for(let i = 0; i < t.length; ++i)e += t[i].pathLength;
        return e;
    }
    static getPointAtLengthOfDataArray(t, e) {
        let i, n = 0, r = e.length;
        if (!r) return null;
        for(; n < r && t > e[n].pathLength;)t -= e[n].pathLength, ++n;
        if (n === r) return i = e[n - 1].points.slice(-2), {
            x: i[0],
            y: i[1]
        };
        if (t < 0.01) return i = e[n].points.slice(0, 2), {
            x: i[0],
            y: i[1]
        };
        const s = e[n], a = s.points;
        switch(s.command){
            case "L":
                return $47a4b45281b81a8b$var$ht.getPointOnLine(t, s.start.x, s.start.y, a[0], a[1]);
            case "C":
                return $47a4b45281b81a8b$var$ht.getPointOnCubicBezier((0, $47a4b45281b81a8b$var$ne.t2length)(t, $47a4b45281b81a8b$var$ht.getPathLength(e), (_)=>(0, $47a4b45281b81a8b$var$ne.getCubicArcLength)([
                        s.start.x,
                        a[0],
                        a[2],
                        a[4]
                    ], [
                        s.start.y,
                        a[1],
                        a[3],
                        a[5]
                    ], _)), s.start.x, s.start.y, a[0], a[1], a[2], a[3], a[4], a[5]);
            case "Q":
                return $47a4b45281b81a8b$var$ht.getPointOnQuadraticBezier((0, $47a4b45281b81a8b$var$ne.t2length)(t, $47a4b45281b81a8b$var$ht.getPathLength(e), (_)=>(0, $47a4b45281b81a8b$var$ne.getQuadraticArcLength)([
                        s.start.x,
                        a[0],
                        a[2]
                    ], [
                        s.start.y,
                        a[1],
                        a[3]
                    ], _)), s.start.x, s.start.y, a[0], a[1], a[2], a[3]);
            case "A":
                var o = a[0], h = a[1], c = a[2], y = a[3], g = a[4], u = a[5], f = a[6];
                return g += u * t / s.pathLength, $47a4b45281b81a8b$var$ht.getPointOnEllipticalArc(o, h, c, y, g, f);
        }
        return null;
    }
    static getPointOnLine(t, e, i, n, r, s, a) {
        s = s ?? e, a = a ?? i;
        const o = this.getLineLength(e, i, n, r);
        if (o < 1e-10) return {
            x: e,
            y: i
        };
        if (n === e) return {
            x: s,
            y: a + (r > i ? t : -t)
        };
        const h = (r - i) / (n - e), c = Math.sqrt(t * t / (1 + h * h)) * (n < e ? -1 : 1), y = h * c;
        if (Math.abs(a - i - h * (s - e)) < 1e-10) return {
            x: s + c,
            y: a + y
        };
        const g = ((s - e) * (n - e) + (a - i) * (r - i)) / (o * o), u = e + g * (n - e), f = i + g * (r - i), _ = this.getLineLength(s, a, u, f), v = Math.sqrt(t * t - _ * _), C = Math.sqrt(v * v / (1 + h * h)) * (n < e ? -1 : 1), k = h * C;
        return {
            x: u + C,
            y: f + k
        };
    }
    static getPointOnCubicBezier(t, e, i, n, r, s, a, o, h) {
        function c(v) {
            return v * v * v;
        }
        function y(v) {
            return 3 * v * v * (1 - v);
        }
        function g(v) {
            return 3 * v * (1 - v) * (1 - v);
        }
        function u(v) {
            return (1 - v) * (1 - v) * (1 - v);
        }
        const f = o * c(t) + s * y(t) + n * g(t) + e * u(t), _ = h * c(t) + a * y(t) + r * g(t) + i * u(t);
        return {
            x: f,
            y: _
        };
    }
    static getPointOnQuadraticBezier(t, e, i, n, r, s, a) {
        function o(u) {
            return u * u;
        }
        function h(u) {
            return 2 * u * (1 - u);
        }
        function c(u) {
            return (1 - u) * (1 - u);
        }
        const y = s * o(t) + n * h(t) + e * c(t), g = a * o(t) + r * h(t) + i * c(t);
        return {
            x: y,
            y: g
        };
    }
    static getPointOnEllipticalArc(t, e, i, n, r, s) {
        const a = Math.cos(s), o = Math.sin(s), h = {
            x: i * Math.cos(r),
            y: n * Math.sin(r)
        };
        return {
            x: t + (h.x * a - h.y * o),
            y: e + (h.x * o + h.y * a)
        };
    }
    static parsePathData(t) {
        if (!t) return [];
        let e = t;
        const i = [
            "m",
            "M",
            "l",
            "L",
            "v",
            "V",
            "h",
            "H",
            "z",
            "Z",
            "c",
            "C",
            "q",
            "Q",
            "t",
            "T",
            "s",
            "S",
            "a",
            "A"
        ];
        e = e.replace(new RegExp(" ", "g"), ",");
        for(var n = 0; n < i.length; n++)e = e.replace(new RegExp(i[n], "g"), "|" + i[n]);
        const r = e.split("|"), s = [], a = [];
        let o = 0, h = 0;
        const c = /([-+]?((\d+\.\d+)|((\d+)|(\.\d+)))(?:e[-+]?\d+)?)/gi;
        let y;
        for(n = 1; n < r.length; n++){
            let S = r[n], E = S.charAt(0);
            for(S = S.slice(1), a.length = 0; y = c.exec(S);)a.push(y[0]);
            const m = [];
            for(let T = 0, A = a.length; T < A; T++){
                if (a[T] === "00") {
                    m.push(0, 0);
                    continue;
                }
                const F = parseFloat(a[T]);
                isNaN(F) ? m.push(0) : m.push(F);
            }
            for(; m.length > 0 && !isNaN(m[0]);){
                let T = "", A = [];
                const F = o, O = h;
                var g, u, f, _, v, C, k, d, p, b;
                switch(E){
                    case "l":
                        o += m.shift(), h += m.shift(), T = "L", A.push(o, h);
                        break;
                    case "L":
                        o = m.shift(), h = m.shift(), A.push(o, h);
                        break;
                    case "m":
                        var w = m.shift(), P = m.shift();
                        if (o += w, h += P, T = "M", s.length > 2 && s[s.length - 1].command === "z") {
                            for(let R = s.length - 2; R >= 0; R--)if (s[R].command === "M") {
                                o = s[R].points[0] + w, h = s[R].points[1] + P;
                                break;
                            }
                        }
                        A.push(o, h), E = "l";
                        break;
                    case "M":
                        o = m.shift(), h = m.shift(), T = "M", A.push(o, h), E = "L";
                        break;
                    case "h":
                        o += m.shift(), T = "L", A.push(o, h);
                        break;
                    case "H":
                        o = m.shift(), T = "L", A.push(o, h);
                        break;
                    case "v":
                        h += m.shift(), T = "L", A.push(o, h);
                        break;
                    case "V":
                        h = m.shift(), T = "L", A.push(o, h);
                        break;
                    case "C":
                        A.push(m.shift(), m.shift(), m.shift(), m.shift()), o = m.shift(), h = m.shift(), A.push(o, h);
                        break;
                    case "c":
                        A.push(o + m.shift(), h + m.shift(), o + m.shift(), h + m.shift()), o += m.shift(), h += m.shift(), T = "C", A.push(o, h);
                        break;
                    case "S":
                        u = o, f = h, g = s[s.length - 1], g.command === "C" && (u = o + (o - g.points[2]), f = h + (h - g.points[3])), A.push(u, f, m.shift(), m.shift()), o = m.shift(), h = m.shift(), T = "C", A.push(o, h);
                        break;
                    case "s":
                        u = o, f = h, g = s[s.length - 1], g.command === "C" && (u = o + (o - g.points[2]), f = h + (h - g.points[3])), A.push(u, f, o + m.shift(), h + m.shift()), o += m.shift(), h += m.shift(), T = "C", A.push(o, h);
                        break;
                    case "Q":
                        A.push(m.shift(), m.shift()), o = m.shift(), h = m.shift(), A.push(o, h);
                        break;
                    case "q":
                        A.push(o + m.shift(), h + m.shift()), o += m.shift(), h += m.shift(), T = "Q", A.push(o, h);
                        break;
                    case "T":
                        u = o, f = h, g = s[s.length - 1], g.command === "Q" && (u = o + (o - g.points[0]), f = h + (h - g.points[1])), o = m.shift(), h = m.shift(), T = "Q", A.push(u, f, o, h);
                        break;
                    case "t":
                        u = o, f = h, g = s[s.length - 1], g.command === "Q" && (u = o + (o - g.points[0]), f = h + (h - g.points[1])), o += m.shift(), h += m.shift(), T = "Q", A.push(u, f, o, h);
                        break;
                    case "A":
                        _ = m.shift(), v = m.shift(), C = m.shift(), k = m.shift(), d = m.shift(), p = o, b = h, o = m.shift(), h = m.shift(), T = "A", A = this.convertEndpointToCenterParameterization(p, b, o, h, k, d, _, v, C);
                        break;
                    case "a":
                        _ = m.shift(), v = m.shift(), C = m.shift(), k = m.shift(), d = m.shift(), p = o, b = h, o += m.shift(), h += m.shift(), T = "A", A = this.convertEndpointToCenterParameterization(p, b, o, h, k, d, _, v, C);
                        break;
                }
                s.push({
                    command: T || E,
                    points: A,
                    start: {
                        x: F,
                        y: O
                    },
                    pathLength: this.calcLength(F, O, T || E, A)
                });
            }
            (E === "z" || E === "Z") && s.push({
                command: "z",
                points: [],
                start: void 0,
                pathLength: 0
            });
        }
        return s;
    }
    static calcLength(t, e, i, n) {
        let r, s, a, o;
        const h = $47a4b45281b81a8b$var$ht;
        switch(i){
            case "L":
                return h.getLineLength(t, e, n[0], n[1]);
            case "C":
                return (0, $47a4b45281b81a8b$var$ne.getCubicArcLength)([
                    t,
                    n[0],
                    n[2],
                    n[4]
                ], [
                    e,
                    n[1],
                    n[3],
                    n[5]
                ], 1);
            case "Q":
                return (0, $47a4b45281b81a8b$var$ne.getQuadraticArcLength)([
                    t,
                    n[0],
                    n[2]
                ], [
                    e,
                    n[1],
                    n[3]
                ], 1);
            case "A":
                r = 0;
                var c = n[4], y = n[5], g = n[4] + y, u = Math.PI / 180;
                if (Math.abs(c - g) < u && (u = Math.abs(c - g)), s = h.getPointOnEllipticalArc(n[0], n[1], n[2], n[3], c, 0), y < 0) for(o = c - u; o > g; o -= u)a = h.getPointOnEllipticalArc(n[0], n[1], n[2], n[3], o, 0), r += h.getLineLength(s.x, s.y, a.x, a.y), s = a;
                else for(o = c + u; o < g; o += u)a = h.getPointOnEllipticalArc(n[0], n[1], n[2], n[3], o, 0), r += h.getLineLength(s.x, s.y, a.x, a.y), s = a;
                return a = h.getPointOnEllipticalArc(n[0], n[1], n[2], n[3], g, 0), r += h.getLineLength(s.x, s.y, a.x, a.y), r;
        }
        return 0;
    }
    static convertEndpointToCenterParameterization(t, e, i, n, r, s, a, o, h) {
        const c = h * (Math.PI / 180), y = Math.cos(c) * (t - i) / 2 + Math.sin(c) * (e - n) / 2, g = -1 * Math.sin(c) * (t - i) / 2 + Math.cos(c) * (e - n) / 2, u = y * y / (a * a) + g * g / (o * o);
        u > 1 && (a *= Math.sqrt(u), o *= Math.sqrt(u));
        let f = Math.sqrt((a * a * (o * o) - a * a * (g * g) - o * o * (y * y)) / (a * a * (g * g) + o * o * (y * y)));
        r === s && (f *= -1), isNaN(f) && (f = 0);
        const _ = f * a * g / o, v = f * -o * y / a, C = (t + i) / 2 + Math.cos(c) * _ - Math.sin(c) * v, k = (e + n) / 2 + Math.sin(c) * _ + Math.cos(c) * v, d = function(m) {
            return Math.sqrt(m[0] * m[0] + m[1] * m[1]);
        }, p = function(m, T) {
            return (m[0] * T[0] + m[1] * T[1]) / (d(m) * d(T));
        }, b = function(m, T) {
            return (m[0] * T[1] < m[1] * T[0] ? -1 : 1) * Math.acos(p(m, T));
        }, w = b([
            1,
            0
        ], [
            (y - _) / a,
            (g - v) / o
        ]), P = [
            (y - _) / a,
            (g - v) / o
        ], S = [
            (-1 * y - _) / a,
            (-1 * g - v) / o
        ];
        let E = b(P, S);
        return p(P, S) <= -1 && (E = Math.PI), p(P, S) >= 1 && (E = 0), s === 0 && E > 0 && (E = E - 2 * Math.PI), s === 1 && E < 0 && (E = E + 2 * Math.PI), [
            C,
            k,
            a,
            o,
            w,
            E,
            c,
            s
        ];
    }
}
$47a4b45281b81a8b$var$ge.Path = $47a4b45281b81a8b$var$ht;
$47a4b45281b81a8b$var$ht.prototype.className = "Path";
$47a4b45281b81a8b$var$ht.prototype._attrsAffectingSize = [
    "data"
];
(0, $47a4b45281b81a8b$var$Hs._registerNode)($47a4b45281b81a8b$var$ht);
$47a4b45281b81a8b$var$Us.Factory.addGetterSetter($47a4b45281b81a8b$var$ht, "data");
Object.defineProperty($47a4b45281b81a8b$var$Ye, "__esModule", {
    value: !0
});
$47a4b45281b81a8b$var$Ye.Arrow = void 0;
const $47a4b45281b81a8b$var$qe = $47a4b45281b81a8b$var$V, $47a4b45281b81a8b$var$Vs = $47a4b45281b81a8b$var$Te, $47a4b45281b81a8b$var$dr = $47a4b45281b81a8b$var$L, $47a4b45281b81a8b$var$$s = $47a4b45281b81a8b$var$H, $47a4b45281b81a8b$var$An = $47a4b45281b81a8b$var$ge;
class $47a4b45281b81a8b$var$Kt extends $47a4b45281b81a8b$var$Vs.Line {
    _sceneFunc(t) {
        super._sceneFunc(t);
        const e = Math.PI * 2, i = this.points();
        let n = i;
        const r = this.tension() !== 0 && i.length > 4;
        r && (n = this.getTensionPoints());
        const s = this.pointerLength(), a = i.length;
        let o, h;
        if (r) {
            const g = [
                n[n.length - 4],
                n[n.length - 3],
                n[n.length - 2],
                n[n.length - 1],
                i[a - 2],
                i[a - 1]
            ], u = $47a4b45281b81a8b$var$An.Path.calcLength(n[n.length - 4], n[n.length - 3], "C", g), f = $47a4b45281b81a8b$var$An.Path.getPointOnQuadraticBezier(Math.min(1, 1 - s / u), g[0], g[1], g[2], g[3], g[4], g[5]);
            o = i[a - 2] - f.x, h = i[a - 1] - f.y;
        } else o = i[a - 2] - i[a - 4], h = i[a - 1] - i[a - 3];
        const c = (Math.atan2(h, o) + e) % e, y = this.pointerWidth();
        this.pointerAtEnding() && (t.save(), t.beginPath(), t.translate(i[a - 2], i[a - 1]), t.rotate(c), t.moveTo(0, 0), t.lineTo(-s, y / 2), t.lineTo(-s, -y / 2), t.closePath(), t.restore(), this.__fillStroke(t)), this.pointerAtBeginning() && (t.save(), t.beginPath(), t.translate(i[0], i[1]), r ? (o = (n[0] + n[2]) / 2 - i[0], h = (n[1] + n[3]) / 2 - i[1]) : (o = i[2] - i[0], h = i[3] - i[1]), t.rotate((Math.atan2(-h, -o) + e) % e), t.moveTo(0, 0), t.lineTo(-s, y / 2), t.lineTo(-s, -y / 2), t.closePath(), t.restore(), this.__fillStroke(t));
    }
    __fillStroke(t) {
        const e = this.dashEnabled();
        e && (this.attrs.dashEnabled = !1, t.setLineDash([])), t.fillStrokeShape(this), e && (this.attrs.dashEnabled = !0);
    }
    getSelfRect() {
        const t = super.getSelfRect(), e = this.pointerWidth() / 2;
        return {
            x: t.x,
            y: t.y - e,
            width: t.width,
            height: t.height + e * 2
        };
    }
}
$47a4b45281b81a8b$var$Ye.Arrow = $47a4b45281b81a8b$var$Kt;
$47a4b45281b81a8b$var$Kt.prototype.className = "Arrow";
(0, $47a4b45281b81a8b$var$$s._registerNode)($47a4b45281b81a8b$var$Kt);
$47a4b45281b81a8b$var$qe.Factory.addGetterSetter($47a4b45281b81a8b$var$Kt, "pointerLength", 10, (0, $47a4b45281b81a8b$var$dr.getNumberValidator)());
$47a4b45281b81a8b$var$qe.Factory.addGetterSetter($47a4b45281b81a8b$var$Kt, "pointerWidth", 10, (0, $47a4b45281b81a8b$var$dr.getNumberValidator)());
$47a4b45281b81a8b$var$qe.Factory.addGetterSetter($47a4b45281b81a8b$var$Kt, "pointerAtBeginning", !1);
$47a4b45281b81a8b$var$qe.Factory.addGetterSetter($47a4b45281b81a8b$var$Kt, "pointerAtEnding", !0);
var $47a4b45281b81a8b$var$Je = {};
Object.defineProperty($47a4b45281b81a8b$var$Je, "__esModule", {
    value: !0
});
$47a4b45281b81a8b$var$Je.Circle = void 0;
const $47a4b45281b81a8b$var$zs = $47a4b45281b81a8b$var$V, $47a4b45281b81a8b$var$Ws = $47a4b45281b81a8b$var$ct, $47a4b45281b81a8b$var$Xs = $47a4b45281b81a8b$var$L, $47a4b45281b81a8b$var$Ks = $47a4b45281b81a8b$var$H;
class $47a4b45281b81a8b$var$fe extends $47a4b45281b81a8b$var$Ws.Shape {
    _sceneFunc(t) {
        t.beginPath(), t.arc(0, 0, this.attrs.radius || 0, 0, Math.PI * 2, !1), t.closePath(), t.fillStrokeShape(this);
    }
    getWidth() {
        return this.radius() * 2;
    }
    getHeight() {
        return this.radius() * 2;
    }
    setWidth(t) {
        this.radius() !== t / 2 && this.radius(t / 2);
    }
    setHeight(t) {
        this.radius() !== t / 2 && this.radius(t / 2);
    }
}
$47a4b45281b81a8b$var$Je.Circle = $47a4b45281b81a8b$var$fe;
$47a4b45281b81a8b$var$fe.prototype._centroid = !0;
$47a4b45281b81a8b$var$fe.prototype.className = "Circle";
$47a4b45281b81a8b$var$fe.prototype._attrsAffectingSize = [
    "radius"
];
(0, $47a4b45281b81a8b$var$Ks._registerNode)($47a4b45281b81a8b$var$fe);
$47a4b45281b81a8b$var$zs.Factory.addGetterSetter($47a4b45281b81a8b$var$fe, "radius", 0, (0, $47a4b45281b81a8b$var$Xs.getNumberValidator)());
var $47a4b45281b81a8b$var$Qe = {};
Object.defineProperty($47a4b45281b81a8b$var$Qe, "__esModule", {
    value: !0
});
$47a4b45281b81a8b$var$Qe.Ellipse = void 0;
const $47a4b45281b81a8b$var$rn = $47a4b45281b81a8b$var$V, $47a4b45281b81a8b$var$Ys = $47a4b45281b81a8b$var$ct, $47a4b45281b81a8b$var$ur = $47a4b45281b81a8b$var$L, $47a4b45281b81a8b$var$js = $47a4b45281b81a8b$var$H;
class $47a4b45281b81a8b$var$Ut extends $47a4b45281b81a8b$var$Ys.Shape {
    _sceneFunc(t) {
        const e = this.radiusX(), i = this.radiusY();
        t.beginPath(), t.save(), e !== i && t.scale(1, i / e), t.arc(0, 0, e, 0, Math.PI * 2, !1), t.restore(), t.closePath(), t.fillStrokeShape(this);
    }
    getWidth() {
        return this.radiusX() * 2;
    }
    getHeight() {
        return this.radiusY() * 2;
    }
    setWidth(t) {
        this.radiusX(t / 2);
    }
    setHeight(t) {
        this.radiusY(t / 2);
    }
}
$47a4b45281b81a8b$var$Qe.Ellipse = $47a4b45281b81a8b$var$Ut;
$47a4b45281b81a8b$var$Ut.prototype.className = "Ellipse";
$47a4b45281b81a8b$var$Ut.prototype._centroid = !0;
$47a4b45281b81a8b$var$Ut.prototype._attrsAffectingSize = [
    "radiusX",
    "radiusY"
];
(0, $47a4b45281b81a8b$var$js._registerNode)($47a4b45281b81a8b$var$Ut);
$47a4b45281b81a8b$var$rn.Factory.addComponentsGetterSetter($47a4b45281b81a8b$var$Ut, "radius", [
    "x",
    "y"
]);
$47a4b45281b81a8b$var$rn.Factory.addGetterSetter($47a4b45281b81a8b$var$Ut, "radiusX", 0, (0, $47a4b45281b81a8b$var$ur.getNumberValidator)());
$47a4b45281b81a8b$var$rn.Factory.addGetterSetter($47a4b45281b81a8b$var$Ut, "radiusY", 0, (0, $47a4b45281b81a8b$var$ur.getNumberValidator)());
var $47a4b45281b81a8b$var$Ze = {};
Object.defineProperty($47a4b45281b81a8b$var$Ze, "__esModule", {
    value: !0
});
$47a4b45281b81a8b$var$Ze.Image = void 0;
const $47a4b45281b81a8b$var$Li = $47a4b45281b81a8b$var$nt, $47a4b45281b81a8b$var$Yt = $47a4b45281b81a8b$var$V, $47a4b45281b81a8b$var$qs = $47a4b45281b81a8b$var$ct, $47a4b45281b81a8b$var$Js = $47a4b45281b81a8b$var$H, $47a4b45281b81a8b$var$ke = $47a4b45281b81a8b$var$L;
let $47a4b45281b81a8b$var$wt = class gr extends $47a4b45281b81a8b$var$qs.Shape {
    constructor(t){
        super(t), this.on("imageChange.konva", ()=>{
            this._setImageLoad();
        }), this._setImageLoad();
    }
    _setImageLoad() {
        const t = this.image();
        t && t.complete || t && t.readyState === 4 || t && t.addEventListener && t.addEventListener("load", ()=>{
            this._requestDraw();
        });
    }
    _useBufferCanvas() {
        const t = !!this.cornerRadius(), e = this.hasShadow();
        return t && e ? !0 : super._useBufferCanvas(!0);
    }
    _sceneFunc(t) {
        const e = this.getWidth(), i = this.getHeight(), n = this.cornerRadius(), r = this.attrs.image;
        let s;
        if (r) {
            const a = this.attrs.cropWidth, o = this.attrs.cropHeight;
            a && o ? s = [
                r,
                this.cropX(),
                this.cropY(),
                a,
                o,
                0,
                0,
                e,
                i
            ] : s = [
                r,
                0,
                0,
                e,
                i
            ];
        }
        (this.hasFill() || this.hasStroke() || n) && (t.beginPath(), n ? $47a4b45281b81a8b$var$Li.Util.drawRoundedRectPath(t, e, i, n) : t.rect(0, 0, e, i), t.closePath(), t.fillStrokeShape(this)), r && (n && t.clip(), t.drawImage.apply(t, s));
    }
    _hitFunc(t) {
        const e = this.width(), i = this.height(), n = this.cornerRadius();
        t.beginPath(), n ? $47a4b45281b81a8b$var$Li.Util.drawRoundedRectPath(t, e, i, n) : t.rect(0, 0, e, i), t.closePath(), t.fillStrokeShape(this);
    }
    getWidth() {
        var t, e;
        return (t = this.attrs.width) !== null && t !== void 0 ? t : (e = this.image()) === null || e === void 0 ? void 0 : e.width;
    }
    getHeight() {
        var t, e;
        return (t = this.attrs.height) !== null && t !== void 0 ? t : (e = this.image()) === null || e === void 0 ? void 0 : e.height;
    }
    static fromURL(t, e, i = null) {
        const n = $47a4b45281b81a8b$var$Li.Util.createImageElement();
        n.onload = function() {
            const r = new gr({
                image: n
            });
            e(r);
        }, n.onerror = i, n.crossOrigin = "Anonymous", n.src = t;
    }
};
$47a4b45281b81a8b$var$Ze.Image = $47a4b45281b81a8b$var$wt;
$47a4b45281b81a8b$var$wt.prototype.className = "Image";
(0, $47a4b45281b81a8b$var$Js._registerNode)($47a4b45281b81a8b$var$wt);
$47a4b45281b81a8b$var$Yt.Factory.addGetterSetter($47a4b45281b81a8b$var$wt, "cornerRadius", 0, (0, $47a4b45281b81a8b$var$ke.getNumberOrArrayOfNumbersValidator)(4));
$47a4b45281b81a8b$var$Yt.Factory.addGetterSetter($47a4b45281b81a8b$var$wt, "image");
$47a4b45281b81a8b$var$Yt.Factory.addComponentsGetterSetter($47a4b45281b81a8b$var$wt, "crop", [
    "x",
    "y",
    "width",
    "height"
]);
$47a4b45281b81a8b$var$Yt.Factory.addGetterSetter($47a4b45281b81a8b$var$wt, "cropX", 0, (0, $47a4b45281b81a8b$var$ke.getNumberValidator)());
$47a4b45281b81a8b$var$Yt.Factory.addGetterSetter($47a4b45281b81a8b$var$wt, "cropY", 0, (0, $47a4b45281b81a8b$var$ke.getNumberValidator)());
$47a4b45281b81a8b$var$Yt.Factory.addGetterSetter($47a4b45281b81a8b$var$wt, "cropWidth", 0, (0, $47a4b45281b81a8b$var$ke.getNumberValidator)());
$47a4b45281b81a8b$var$Yt.Factory.addGetterSetter($47a4b45281b81a8b$var$wt, "cropHeight", 0, (0, $47a4b45281b81a8b$var$ke.getNumberValidator)());
var $47a4b45281b81a8b$var$ae = {};
Object.defineProperty($47a4b45281b81a8b$var$ae, "__esModule", {
    value: !0
});
$47a4b45281b81a8b$var$ae.Tag = $47a4b45281b81a8b$var$ae.Label = void 0;
const $47a4b45281b81a8b$var$ti = $47a4b45281b81a8b$var$V, $47a4b45281b81a8b$var$Qs = $47a4b45281b81a8b$var$ct, $47a4b45281b81a8b$var$Zs = $47a4b45281b81a8b$var$de, $47a4b45281b81a8b$var$sn = $47a4b45281b81a8b$var$L, $47a4b45281b81a8b$var$fr = $47a4b45281b81a8b$var$H, $47a4b45281b81a8b$var$pr = [
    "fontFamily",
    "fontSize",
    "fontStyle",
    "padding",
    "lineHeight",
    "text",
    "width",
    "height",
    "pointerDirection",
    "pointerWidth",
    "pointerHeight"
], $47a4b45281b81a8b$var$ta = "Change.konva", $47a4b45281b81a8b$var$ea = "none", $47a4b45281b81a8b$var$Xi = "up", $47a4b45281b81a8b$var$Ki = "right", $47a4b45281b81a8b$var$Yi = "down", $47a4b45281b81a8b$var$ji = "left", $47a4b45281b81a8b$var$ia = $47a4b45281b81a8b$var$pr.length;
class $47a4b45281b81a8b$var$an extends $47a4b45281b81a8b$var$Zs.Group {
    constructor(t){
        super(t), this.on("add.konva", function(e) {
            this._addListeners(e.child), this._sync();
        });
    }
    getText() {
        return this.find("Text")[0];
    }
    getTag() {
        return this.find("Tag")[0];
    }
    _addListeners(t) {
        let e = this, i;
        const n = function() {
            e._sync();
        };
        for(i = 0; i < $47a4b45281b81a8b$var$ia; i++)t.on($47a4b45281b81a8b$var$pr[i] + $47a4b45281b81a8b$var$ta, n);
    }
    getWidth() {
        return this.getText().width();
    }
    getHeight() {
        return this.getText().height();
    }
    _sync() {
        let t = this.getText(), e = this.getTag(), i, n, r, s, a, o, h;
        if (t && e) {
            switch(i = t.width(), n = t.height(), r = e.pointerDirection(), s = e.pointerWidth(), h = e.pointerHeight(), a = 0, o = 0, r){
                case $47a4b45281b81a8b$var$Xi:
                    a = i / 2, o = -1 * h;
                    break;
                case $47a4b45281b81a8b$var$Ki:
                    a = i + s, o = n / 2;
                    break;
                case $47a4b45281b81a8b$var$Yi:
                    a = i / 2, o = n + h;
                    break;
                case $47a4b45281b81a8b$var$ji:
                    a = -1 * s, o = n / 2;
                    break;
            }
            e.setAttrs({
                x: -1 * a,
                y: -1 * o,
                width: i,
                height: n
            }), t.setAttrs({
                x: -1 * a,
                y: -1 * o
            });
        }
    }
}
$47a4b45281b81a8b$var$ae.Label = $47a4b45281b81a8b$var$an;
$47a4b45281b81a8b$var$an.prototype.className = "Label";
(0, $47a4b45281b81a8b$var$fr._registerNode)($47a4b45281b81a8b$var$an);
class $47a4b45281b81a8b$var$jt extends $47a4b45281b81a8b$var$Qs.Shape {
    _sceneFunc(t) {
        const e = this.width(), i = this.height(), n = this.pointerDirection(), r = this.pointerWidth(), s = this.pointerHeight(), a = this.cornerRadius();
        let o = 0, h = 0, c = 0, y = 0;
        typeof a == "number" ? o = h = c = y = Math.min(a, e / 2, i / 2) : (o = Math.min(a[0] || 0, e / 2, i / 2), h = Math.min(a[1] || 0, e / 2, i / 2), y = Math.min(a[2] || 0, e / 2, i / 2), c = Math.min(a[3] || 0, e / 2, i / 2)), t.beginPath(), t.moveTo(o, 0), n === $47a4b45281b81a8b$var$Xi && (t.lineTo((e - r) / 2, 0), t.lineTo(e / 2, -1 * s), t.lineTo((e + r) / 2, 0)), t.lineTo(e - h, 0), t.arc(e - h, h, h, Math.PI * 3 / 2, 0, !1), n === $47a4b45281b81a8b$var$Ki && (t.lineTo(e, (i - s) / 2), t.lineTo(e + r, i / 2), t.lineTo(e, (i + s) / 2)), t.lineTo(e, i - y), t.arc(e - y, i - y, y, 0, Math.PI / 2, !1), n === $47a4b45281b81a8b$var$Yi && (t.lineTo((e + r) / 2, i), t.lineTo(e / 2, i + s), t.lineTo((e - r) / 2, i)), t.lineTo(c, i), t.arc(c, i - c, c, Math.PI / 2, Math.PI, !1), n === $47a4b45281b81a8b$var$ji && (t.lineTo(0, (i + s) / 2), t.lineTo(-1 * r, i / 2), t.lineTo(0, (i - s) / 2)), t.lineTo(0, o), t.arc(o, o, o, Math.PI, Math.PI * 3 / 2, !1), t.closePath(), t.fillStrokeShape(this);
    }
    getSelfRect() {
        let t = 0, e = 0, i = this.pointerWidth(), n = this.pointerHeight(), r = this.pointerDirection(), s = this.width(), a = this.height();
        return r === $47a4b45281b81a8b$var$Xi ? (e -= n, a += n) : r === $47a4b45281b81a8b$var$Yi ? a += n : r === $47a4b45281b81a8b$var$ji ? (t -= i * 1.5, s += i) : r === $47a4b45281b81a8b$var$Ki && (s += i * 1.5), {
            x: t,
            y: e,
            width: s,
            height: a
        };
    }
}
$47a4b45281b81a8b$var$ae.Tag = $47a4b45281b81a8b$var$jt;
$47a4b45281b81a8b$var$jt.prototype.className = "Tag";
(0, $47a4b45281b81a8b$var$fr._registerNode)($47a4b45281b81a8b$var$jt);
$47a4b45281b81a8b$var$ti.Factory.addGetterSetter($47a4b45281b81a8b$var$jt, "pointerDirection", $47a4b45281b81a8b$var$ea);
$47a4b45281b81a8b$var$ti.Factory.addGetterSetter($47a4b45281b81a8b$var$jt, "pointerWidth", 0, (0, $47a4b45281b81a8b$var$sn.getNumberValidator)());
$47a4b45281b81a8b$var$ti.Factory.addGetterSetter($47a4b45281b81a8b$var$jt, "pointerHeight", 0, (0, $47a4b45281b81a8b$var$sn.getNumberValidator)());
$47a4b45281b81a8b$var$ti.Factory.addGetterSetter($47a4b45281b81a8b$var$jt, "cornerRadius", 0, (0, $47a4b45281b81a8b$var$sn.getNumberOrArrayOfNumbersValidator)(4));
var $47a4b45281b81a8b$var$Ee = {};
Object.defineProperty($47a4b45281b81a8b$var$Ee, "__esModule", {
    value: !0
});
$47a4b45281b81a8b$var$Ee.Rect = void 0;
const $47a4b45281b81a8b$var$na = $47a4b45281b81a8b$var$V, $47a4b45281b81a8b$var$ra = $47a4b45281b81a8b$var$ct, $47a4b45281b81a8b$var$sa = $47a4b45281b81a8b$var$H, $47a4b45281b81a8b$var$aa = $47a4b45281b81a8b$var$nt, $47a4b45281b81a8b$var$oa = $47a4b45281b81a8b$var$L;
class $47a4b45281b81a8b$var$ei extends $47a4b45281b81a8b$var$ra.Shape {
    _sceneFunc(t) {
        const e = this.cornerRadius(), i = this.width(), n = this.height();
        t.beginPath(), e ? $47a4b45281b81a8b$var$aa.Util.drawRoundedRectPath(t, i, n, e) : t.rect(0, 0, i, n), t.closePath(), t.fillStrokeShape(this);
    }
}
$47a4b45281b81a8b$var$Ee.Rect = $47a4b45281b81a8b$var$ei;
$47a4b45281b81a8b$var$ei.prototype.className = "Rect";
(0, $47a4b45281b81a8b$var$sa._registerNode)($47a4b45281b81a8b$var$ei);
$47a4b45281b81a8b$var$na.Factory.addGetterSetter($47a4b45281b81a8b$var$ei, "cornerRadius", 0, (0, $47a4b45281b81a8b$var$oa.getNumberOrArrayOfNumbersValidator)(4));
var $47a4b45281b81a8b$var$ii = {};
Object.defineProperty($47a4b45281b81a8b$var$ii, "__esModule", {
    value: !0
});
$47a4b45281b81a8b$var$ii.RegularPolygon = void 0;
const $47a4b45281b81a8b$var$mr = $47a4b45281b81a8b$var$V, $47a4b45281b81a8b$var$la = $47a4b45281b81a8b$var$ct, $47a4b45281b81a8b$var$yr = $47a4b45281b81a8b$var$L, $47a4b45281b81a8b$var$ha = $47a4b45281b81a8b$var$H;
class $47a4b45281b81a8b$var$qt extends $47a4b45281b81a8b$var$la.Shape {
    _sceneFunc(t) {
        const e = this._getPoints();
        t.beginPath(), t.moveTo(e[0].x, e[0].y);
        for(let i = 1; i < e.length; i++)t.lineTo(e[i].x, e[i].y);
        t.closePath(), t.fillStrokeShape(this);
    }
    _getPoints() {
        const t = this.attrs.sides, e = this.attrs.radius || 0, i = [];
        for(let n = 0; n < t; n++)i.push({
            x: e * Math.sin(n * 2 * Math.PI / t),
            y: -1 * e * Math.cos(n * 2 * Math.PI / t)
        });
        return i;
    }
    getSelfRect() {
        const t = this._getPoints();
        let e = t[0].x, i = t[0].y, n = t[0].x, r = t[0].y;
        return t.forEach((s)=>{
            e = Math.min(e, s.x), i = Math.max(i, s.x), n = Math.min(n, s.y), r = Math.max(r, s.y);
        }), {
            x: e,
            y: n,
            width: i - e,
            height: r - n
        };
    }
    getWidth() {
        return this.radius() * 2;
    }
    getHeight() {
        return this.radius() * 2;
    }
    setWidth(t) {
        this.radius(t / 2);
    }
    setHeight(t) {
        this.radius(t / 2);
    }
}
$47a4b45281b81a8b$var$ii.RegularPolygon = $47a4b45281b81a8b$var$qt;
$47a4b45281b81a8b$var$qt.prototype.className = "RegularPolygon";
$47a4b45281b81a8b$var$qt.prototype._centroid = !0;
$47a4b45281b81a8b$var$qt.prototype._attrsAffectingSize = [
    "radius"
];
(0, $47a4b45281b81a8b$var$ha._registerNode)($47a4b45281b81a8b$var$qt);
$47a4b45281b81a8b$var$mr.Factory.addGetterSetter($47a4b45281b81a8b$var$qt, "radius", 0, (0, $47a4b45281b81a8b$var$yr.getNumberValidator)());
$47a4b45281b81a8b$var$mr.Factory.addGetterSetter($47a4b45281b81a8b$var$qt, "sides", 0, (0, $47a4b45281b81a8b$var$yr.getNumberValidator)());
var $47a4b45281b81a8b$var$ni = {};
Object.defineProperty($47a4b45281b81a8b$var$ni, "__esModule", {
    value: !0
});
$47a4b45281b81a8b$var$ni.Ring = void 0;
const $47a4b45281b81a8b$var$_r = $47a4b45281b81a8b$var$V, $47a4b45281b81a8b$var$ca = $47a4b45281b81a8b$var$ct, $47a4b45281b81a8b$var$vr = $47a4b45281b81a8b$var$L, $47a4b45281b81a8b$var$da = $47a4b45281b81a8b$var$H, $47a4b45281b81a8b$var$Pn = Math.PI * 2;
class $47a4b45281b81a8b$var$Jt extends $47a4b45281b81a8b$var$ca.Shape {
    _sceneFunc(t) {
        t.beginPath(), t.arc(0, 0, this.innerRadius(), 0, $47a4b45281b81a8b$var$Pn, !1), t.moveTo(this.outerRadius(), 0), t.arc(0, 0, this.outerRadius(), $47a4b45281b81a8b$var$Pn, 0, !0), t.closePath(), t.fillStrokeShape(this);
    }
    getWidth() {
        return this.outerRadius() * 2;
    }
    getHeight() {
        return this.outerRadius() * 2;
    }
    setWidth(t) {
        this.outerRadius(t / 2);
    }
    setHeight(t) {
        this.outerRadius(t / 2);
    }
}
$47a4b45281b81a8b$var$ni.Ring = $47a4b45281b81a8b$var$Jt;
$47a4b45281b81a8b$var$Jt.prototype.className = "Ring";
$47a4b45281b81a8b$var$Jt.prototype._centroid = !0;
$47a4b45281b81a8b$var$Jt.prototype._attrsAffectingSize = [
    "innerRadius",
    "outerRadius"
];
(0, $47a4b45281b81a8b$var$da._registerNode)($47a4b45281b81a8b$var$Jt);
$47a4b45281b81a8b$var$_r.Factory.addGetterSetter($47a4b45281b81a8b$var$Jt, "innerRadius", 0, (0, $47a4b45281b81a8b$var$vr.getNumberValidator)());
$47a4b45281b81a8b$var$_r.Factory.addGetterSetter($47a4b45281b81a8b$var$Jt, "outerRadius", 0, (0, $47a4b45281b81a8b$var$vr.getNumberValidator)());
var $47a4b45281b81a8b$var$ri = {};
Object.defineProperty($47a4b45281b81a8b$var$ri, "__esModule", {
    value: !0
});
$47a4b45281b81a8b$var$ri.Sprite = void 0;
const $47a4b45281b81a8b$var$Qt = $47a4b45281b81a8b$var$V, $47a4b45281b81a8b$var$ua = $47a4b45281b81a8b$var$ct, $47a4b45281b81a8b$var$ga = $47a4b45281b81a8b$var$ue, $47a4b45281b81a8b$var$br = $47a4b45281b81a8b$var$L, $47a4b45281b81a8b$var$fa = $47a4b45281b81a8b$var$H;
class $47a4b45281b81a8b$var$xt extends $47a4b45281b81a8b$var$ua.Shape {
    constructor(t){
        super(t), this._updated = !0, this.anim = new $47a4b45281b81a8b$var$ga.Animation(()=>{
            const e = this._updated;
            return this._updated = !1, e;
        }), this.on("animationChange.konva", function() {
            this.frameIndex(0);
        }), this.on("frameIndexChange.konva", function() {
            this._updated = !0;
        }), this.on("frameRateChange.konva", function() {
            this.anim.isRunning() && (clearInterval(this.interval), this._setInterval());
        });
    }
    _sceneFunc(t) {
        const e = this.animation(), i = this.frameIndex(), n = i * 4, r = this.animations()[e], s = this.frameOffsets(), a = r[n + 0], o = r[n + 1], h = r[n + 2], c = r[n + 3], y = this.image();
        if ((this.hasFill() || this.hasStroke()) && (t.beginPath(), t.rect(0, 0, h, c), t.closePath(), t.fillStrokeShape(this)), y) {
            if (s) {
                const g = s[e], u = i * 2;
                t.drawImage(y, a, o, h, c, g[u + 0], g[u + 1], h, c);
            } else t.drawImage(y, a, o, h, c, 0, 0, h, c);
        }
    }
    _hitFunc(t) {
        const e = this.animation(), i = this.frameIndex(), n = i * 4, r = this.animations()[e], s = this.frameOffsets(), a = r[n + 2], o = r[n + 3];
        if (t.beginPath(), s) {
            const h = s[e], c = i * 2;
            t.rect(h[c + 0], h[c + 1], a, o);
        } else t.rect(0, 0, a, o);
        t.closePath(), t.fillShape(this);
    }
    _useBufferCanvas() {
        return super._useBufferCanvas(!0);
    }
    _setInterval() {
        const t = this;
        this.interval = setInterval(function() {
            t._updateIndex();
        }, 1e3 / this.frameRate());
    }
    start() {
        if (this.isRunning()) return;
        const t = this.getLayer();
        this.anim.setLayers(t), this._setInterval(), this.anim.start();
    }
    stop() {
        this.anim.stop(), clearInterval(this.interval);
    }
    isRunning() {
        return this.anim.isRunning();
    }
    _updateIndex() {
        const t = this.frameIndex(), e = this.animation(), i = this.animations(), n = i[e], r = n.length / 4;
        t < r - 1 ? this.frameIndex(t + 1) : this.frameIndex(0);
    }
}
$47a4b45281b81a8b$var$ri.Sprite = $47a4b45281b81a8b$var$xt;
$47a4b45281b81a8b$var$xt.prototype.className = "Sprite";
(0, $47a4b45281b81a8b$var$fa._registerNode)($47a4b45281b81a8b$var$xt);
$47a4b45281b81a8b$var$Qt.Factory.addGetterSetter($47a4b45281b81a8b$var$xt, "animation");
$47a4b45281b81a8b$var$Qt.Factory.addGetterSetter($47a4b45281b81a8b$var$xt, "animations");
$47a4b45281b81a8b$var$Qt.Factory.addGetterSetter($47a4b45281b81a8b$var$xt, "frameOffsets");
$47a4b45281b81a8b$var$Qt.Factory.addGetterSetter($47a4b45281b81a8b$var$xt, "image");
$47a4b45281b81a8b$var$Qt.Factory.addGetterSetter($47a4b45281b81a8b$var$xt, "frameIndex", 0, (0, $47a4b45281b81a8b$var$br.getNumberValidator)());
$47a4b45281b81a8b$var$Qt.Factory.addGetterSetter($47a4b45281b81a8b$var$xt, "frameRate", 17, (0, $47a4b45281b81a8b$var$br.getNumberValidator)());
$47a4b45281b81a8b$var$Qt.Factory.backCompat($47a4b45281b81a8b$var$xt, {
    index: "frameIndex",
    getIndex: "getFrameIndex",
    setIndex: "setFrameIndex"
});
var $47a4b45281b81a8b$var$si = {};
Object.defineProperty($47a4b45281b81a8b$var$si, "__esModule", {
    value: !0
});
$47a4b45281b81a8b$var$si.Star = void 0;
const $47a4b45281b81a8b$var$on = $47a4b45281b81a8b$var$V, $47a4b45281b81a8b$var$pa = $47a4b45281b81a8b$var$ct, $47a4b45281b81a8b$var$ln = $47a4b45281b81a8b$var$L, $47a4b45281b81a8b$var$ma = $47a4b45281b81a8b$var$H;
class $47a4b45281b81a8b$var$Bt extends $47a4b45281b81a8b$var$pa.Shape {
    _sceneFunc(t) {
        const e = this.innerRadius(), i = this.outerRadius(), n = this.numPoints();
        t.beginPath(), t.moveTo(0, 0 - i);
        for(let r = 1; r < n * 2; r++){
            const s = r % 2 === 0 ? i : e, a = s * Math.sin(r * Math.PI / n), o = -1 * s * Math.cos(r * Math.PI / n);
            t.lineTo(a, o);
        }
        t.closePath(), t.fillStrokeShape(this);
    }
    getWidth() {
        return this.outerRadius() * 2;
    }
    getHeight() {
        return this.outerRadius() * 2;
    }
    setWidth(t) {
        this.outerRadius(t / 2);
    }
    setHeight(t) {
        this.outerRadius(t / 2);
    }
}
$47a4b45281b81a8b$var$si.Star = $47a4b45281b81a8b$var$Bt;
$47a4b45281b81a8b$var$Bt.prototype.className = "Star";
$47a4b45281b81a8b$var$Bt.prototype._centroid = !0;
$47a4b45281b81a8b$var$Bt.prototype._attrsAffectingSize = [
    "innerRadius",
    "outerRadius"
];
(0, $47a4b45281b81a8b$var$ma._registerNode)($47a4b45281b81a8b$var$Bt);
$47a4b45281b81a8b$var$on.Factory.addGetterSetter($47a4b45281b81a8b$var$Bt, "numPoints", 5, (0, $47a4b45281b81a8b$var$ln.getNumberValidator)());
$47a4b45281b81a8b$var$on.Factory.addGetterSetter($47a4b45281b81a8b$var$Bt, "innerRadius", 0, (0, $47a4b45281b81a8b$var$ln.getNumberValidator)());
$47a4b45281b81a8b$var$on.Factory.addGetterSetter($47a4b45281b81a8b$var$Bt, "outerRadius", 0, (0, $47a4b45281b81a8b$var$ln.getNumberValidator)());
var $47a4b45281b81a8b$var$pe = {};
Object.defineProperty($47a4b45281b81a8b$var$pe, "__esModule", {
    value: !0
});
$47a4b45281b81a8b$var$pe.Text = void 0;
$47a4b45281b81a8b$var$pe.stringToArray = $47a4b45281b81a8b$var$zt;
const $47a4b45281b81a8b$var$qi = $47a4b45281b81a8b$var$nt, $47a4b45281b81a8b$var$ft = $47a4b45281b81a8b$var$V, $47a4b45281b81a8b$var$ya = $47a4b45281b81a8b$var$ct, $47a4b45281b81a8b$var$Gi = $47a4b45281b81a8b$var$H, $47a4b45281b81a8b$var$Ht = $47a4b45281b81a8b$var$L, $47a4b45281b81a8b$var$_a = $47a4b45281b81a8b$var$H;
function $47a4b45281b81a8b$var$zt(l) {
    return [
        ...l
    ].reduce((t, e, i, n)=>{
        if (/\p{Emoji}/u.test(e)) {
            const r = n[i + 1];
            r && /\p{Emoji_Modifier}|\u200D/u.test(r) ? (t.push(e + r), n[i + 1] = "") : t.push(e);
        } else /\p{Regional_Indicator}{2}/u.test(e + (n[i + 1] || "")) ? t.push(e + n[i + 1]) : i > 0 && /\p{Mn}|\p{Me}|\p{Mc}/u.test(e) ? t[t.length - 1] += e : e && t.push(e);
        return t;
    }, []);
}
const $47a4b45281b81a8b$var$re = "auto", $47a4b45281b81a8b$var$va = "center", $47a4b45281b81a8b$var$Sr = "inherit", $47a4b45281b81a8b$var$ye = "justify", $47a4b45281b81a8b$var$ba = "Change.konva", $47a4b45281b81a8b$var$Sa = "2d", $47a4b45281b81a8b$var$Mn = "-", $47a4b45281b81a8b$var$Cr = "left", $47a4b45281b81a8b$var$Ca = "text", $47a4b45281b81a8b$var$wa = "Text", $47a4b45281b81a8b$var$xa = "top", $47a4b45281b81a8b$var$Ta = "bottom", $47a4b45281b81a8b$var$Rn = "middle", $47a4b45281b81a8b$var$wr = "normal", $47a4b45281b81a8b$var$ka = "px ", $47a4b45281b81a8b$var$Me = " ", $47a4b45281b81a8b$var$Ea = "right", $47a4b45281b81a8b$var$Fn = "rtl", $47a4b45281b81a8b$var$Aa = "word", $47a4b45281b81a8b$var$Pa = "char", $47a4b45281b81a8b$var$On = "none", $47a4b45281b81a8b$var$Ii = "\u2026", $47a4b45281b81a8b$var$xr = [
    "direction",
    "fontFamily",
    "fontSize",
    "fontStyle",
    "fontVariant",
    "padding",
    "align",
    "verticalAlign",
    "lineHeight",
    "text",
    "width",
    "height",
    "wrap",
    "ellipsis",
    "letterSpacing"
], $47a4b45281b81a8b$var$Ma = $47a4b45281b81a8b$var$xr.length;
function $47a4b45281b81a8b$var$Ra(l) {
    return l.split(",").map((t)=>{
        t = t.trim();
        const e = t.indexOf(" ") >= 0, i = t.indexOf('"') >= 0 || t.indexOf("'") >= 0;
        return e && !i && (t = `"${t}"`), t;
    }).join(", ");
}
let $47a4b45281b81a8b$var$Re;
function $47a4b45281b81a8b$var$Ni() {
    return $47a4b45281b81a8b$var$Re || ($47a4b45281b81a8b$var$Re = $47a4b45281b81a8b$var$qi.Util.createCanvasElement().getContext($47a4b45281b81a8b$var$Sa), $47a4b45281b81a8b$var$Re);
}
function $47a4b45281b81a8b$var$Fa(l) {
    l.fillText(this._partialText, this._partialTextX, this._partialTextY);
}
function $47a4b45281b81a8b$var$Oa(l) {
    l.setAttr("miterLimit", 2), l.strokeText(this._partialText, this._partialTextX, this._partialTextY);
}
function $47a4b45281b81a8b$var$Da(l) {
    return l = l || {}, !l.fillLinearGradientColorStops && !l.fillRadialGradientColorStops && !l.fillPatternImage && (l.fill = l.fill || "black"), l;
}
class $47a4b45281b81a8b$var$at extends $47a4b45281b81a8b$var$ya.Shape {
    constructor(t){
        super($47a4b45281b81a8b$var$Da(t)), this._partialTextX = 0, this._partialTextY = 0;
        for(let e = 0; e < $47a4b45281b81a8b$var$Ma; e++)this.on($47a4b45281b81a8b$var$xr[e] + $47a4b45281b81a8b$var$ba, this._setTextData);
        this._setTextData();
    }
    _sceneFunc(t) {
        const e = this.textArr, i = e.length;
        if (!this.text()) return;
        let n = this.padding(), r = this.fontSize(), s = this.lineHeight() * r, a = this.verticalAlign(), o = this.direction(), h = 0, c = this.align(), y = this.getWidth(), g = this.letterSpacing(), u = this.fill(), f = this.textDecoration(), _ = f.indexOf("underline") !== -1, v = f.indexOf("line-through") !== -1, C;
        o = o === $47a4b45281b81a8b$var$Sr ? t.direction : o;
        let k = s / 2, d = $47a4b45281b81a8b$var$Rn;
        if ($47a4b45281b81a8b$var$Gi.Konva._fixTextRendering) {
            const A = this.measureSize("M");
            d = "alphabetic", k = (A.fontBoundingBoxAscent - A.fontBoundingBoxDescent) / 2 + s / 2;
        }
        var p = 0, b = 0;
        for(o === $47a4b45281b81a8b$var$Fn && t.setAttr("direction", o), t.setAttr("font", this._getContextFont()), t.setAttr("textBaseline", d), t.setAttr("textAlign", $47a4b45281b81a8b$var$Cr), a === $47a4b45281b81a8b$var$Rn ? h = (this.getHeight() - i * s - n * 2) / 2 : a === $47a4b45281b81a8b$var$Ta && (h = this.getHeight() - i * s - n * 2), t.translate(n, h + n), C = 0; C < i; C++){
            var p = 0, b = 0, w = e[C], P = w.text, S = w.width, E = w.lastInParagraph, m, T;
            if (t.save(), c === $47a4b45281b81a8b$var$Ea ? p += y - S - n * 2 : c === $47a4b45281b81a8b$var$va && (p += (y - S - n * 2) / 2), _) {
                t.save(), t.beginPath();
                const O = $47a4b45281b81a8b$var$Gi.Konva._fixTextRendering ? Math.round(r / 4) : Math.round(r / 2), R = p, N = k + b + O;
                t.moveTo(R, N), m = P.split(" ").length - 1, T = c === $47a4b45281b81a8b$var$ye && !E ? y - n * 2 : S, t.lineTo(R + Math.round(T), N), t.lineWidth = r / 15;
                const z = this._getLinearGradient();
                t.strokeStyle = z || u, t.stroke(), t.restore();
            }
            if (v) {
                t.save(), t.beginPath();
                const O = $47a4b45281b81a8b$var$Gi.Konva._fixTextRendering ? -Math.round(r / 4) : 0;
                t.moveTo(p, k + b + O), m = P.split(" ").length - 1, T = c === $47a4b45281b81a8b$var$ye && !E ? y - n * 2 : S, t.lineTo(p + Math.round(T), k + b + O), t.lineWidth = r / 15;
                const R = this._getLinearGradient();
                t.strokeStyle = R || u, t.stroke(), t.restore();
            }
            if (o !== $47a4b45281b81a8b$var$Fn && (g !== 0 || c === $47a4b45281b81a8b$var$ye)) {
                m = P.split(" ").length - 1;
                const O = $47a4b45281b81a8b$var$zt(P);
                for(let R = 0; R < O.length; R++){
                    const N = O[R];
                    N === " " && !E && c === $47a4b45281b81a8b$var$ye && (p += (y - n * 2 - S) / m), this._partialTextX = p, this._partialTextY = k + b, this._partialText = N, t.fillStrokeShape(this), p += this.measureSize(N).width + g;
                }
            } else g !== 0 && t.setAttr("letterSpacing", `${g}px`), this._partialTextX = p, this._partialTextY = k + b, this._partialText = P, t.fillStrokeShape(this);
            t.restore(), i > 1 && (k += s);
        }
    }
    _hitFunc(t) {
        const e = this.getWidth(), i = this.getHeight();
        t.beginPath(), t.rect(0, 0, e, i), t.closePath(), t.fillStrokeShape(this);
    }
    setText(t) {
        const e = $47a4b45281b81a8b$var$qi.Util._isString(t) ? t : t == null ? "" : t + "";
        return this._setAttr($47a4b45281b81a8b$var$Ca, e), this;
    }
    getWidth() {
        return this.attrs.width === $47a4b45281b81a8b$var$re || this.attrs.width === void 0 ? this.getTextWidth() + this.padding() * 2 : this.attrs.width;
    }
    getHeight() {
        return this.attrs.height === $47a4b45281b81a8b$var$re || this.attrs.height === void 0 ? this.fontSize() * this.textArr.length * this.lineHeight() + this.padding() * 2 : this.attrs.height;
    }
    getTextWidth() {
        return this.textWidth;
    }
    getTextHeight() {
        return $47a4b45281b81a8b$var$qi.Util.warn("text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height."), this.textHeight;
    }
    measureSize(t) {
        var e, i, n, r, s, a, o, h, c, y, g;
        let u = $47a4b45281b81a8b$var$Ni(), f = this.fontSize(), _;
        u.save(), u.font = this._getContextFont(), _ = u.measureText(t), u.restore();
        const v = f / 100;
        return {
            actualBoundingBoxAscent: (e = _.actualBoundingBoxAscent) !== null && e !== void 0 ? e : 71.58203125 * v,
            actualBoundingBoxDescent: (i = _.actualBoundingBoxDescent) !== null && i !== void 0 ? i : 0,
            actualBoundingBoxLeft: (n = _.actualBoundingBoxLeft) !== null && n !== void 0 ? n : -7.421875 * v,
            actualBoundingBoxRight: (r = _.actualBoundingBoxRight) !== null && r !== void 0 ? r : 75.732421875 * v,
            alphabeticBaseline: (s = _.alphabeticBaseline) !== null && s !== void 0 ? s : 0,
            emHeightAscent: (a = _.emHeightAscent) !== null && a !== void 0 ? a : 100 * v,
            emHeightDescent: (o = _.emHeightDescent) !== null && o !== void 0 ? o : -20 * v,
            fontBoundingBoxAscent: (h = _.fontBoundingBoxAscent) !== null && h !== void 0 ? h : 91 * v,
            fontBoundingBoxDescent: (c = _.fontBoundingBoxDescent) !== null && c !== void 0 ? c : 21 * v,
            hangingBaseline: (y = _.hangingBaseline) !== null && y !== void 0 ? y : 72.80000305175781 * v,
            ideographicBaseline: (g = _.ideographicBaseline) !== null && g !== void 0 ? g : -21 * v,
            width: _.width,
            height: f
        };
    }
    _getContextFont() {
        return this.fontStyle() + $47a4b45281b81a8b$var$Me + this.fontVariant() + $47a4b45281b81a8b$var$Me + (this.fontSize() + $47a4b45281b81a8b$var$ka) + $47a4b45281b81a8b$var$Ra(this.fontFamily());
    }
    _addTextLine(t) {
        this.align() === $47a4b45281b81a8b$var$ye && (t = t.trim());
        const i = this._getTextWidth(t);
        return this.textArr.push({
            text: t,
            width: i,
            lastInParagraph: !1
        });
    }
    _getTextWidth(t) {
        const e = this.letterSpacing(), i = t.length;
        return $47a4b45281b81a8b$var$Ni().measureText(t).width + e * i;
    }
    _setTextData() {
        let t = this.text().split(`
`), e = +this.fontSize(), i = 0, n = this.lineHeight() * e, r = this.attrs.width, s = this.attrs.height, a = r !== $47a4b45281b81a8b$var$re && r !== void 0, o = s !== $47a4b45281b81a8b$var$re && s !== void 0, h = this.padding(), c = r - h * 2, y = s - h * 2, g = 0, u = this.wrap(), f = u !== $47a4b45281b81a8b$var$On, _ = u !== $47a4b45281b81a8b$var$Pa && f, v = this.ellipsis();
        this.textArr = [], $47a4b45281b81a8b$var$Ni().font = this._getContextFont();
        const C = v ? this._getTextWidth($47a4b45281b81a8b$var$Ii) : 0;
        for(let k = 0, d = t.length; k < d; ++k){
            let p = t[k], b = this._getTextWidth(p);
            if (a && b > c) for(; p.length > 0;){
                let w = 0, P = $47a4b45281b81a8b$var$zt(p).length, S = "", E = 0;
                for(; w < P;){
                    const m = w + P >>> 1, T = $47a4b45281b81a8b$var$zt(p), A = T.slice(0, m + 1).join(""), F = this._getTextWidth(A) + C;
                    F <= c ? (w = m + 1, S = A, E = F) : P = m;
                }
                if (S) {
                    if (_) {
                        const A = $47a4b45281b81a8b$var$zt(p), F = $47a4b45281b81a8b$var$zt(S), O = A[F.length], R = O === $47a4b45281b81a8b$var$Me || O === $47a4b45281b81a8b$var$Mn;
                        let N;
                        if (R && E <= c) N = F.length;
                        else {
                            const z = F.lastIndexOf($47a4b45281b81a8b$var$Me), Q = F.lastIndexOf($47a4b45281b81a8b$var$Mn);
                            N = Math.max(z, Q) + 1;
                        }
                        N > 0 && (w = N, S = A.slice(0, w).join(""), E = this._getTextWidth(S));
                    }
                    if (S = S.trimRight(), this._addTextLine(S), i = Math.max(i, E), g += n, this._shouldHandleEllipsis(g)) {
                        this._tryToAddEllipsisToLastLine();
                        break;
                    }
                    if (p = $47a4b45281b81a8b$var$zt(p).slice(w).join("").trimLeft(), p.length > 0 && (b = this._getTextWidth(p), b <= c)) {
                        this._addTextLine(p), g += n, i = Math.max(i, b);
                        break;
                    }
                } else break;
            }
            else this._addTextLine(p), g += n, i = Math.max(i, b), this._shouldHandleEllipsis(g) && k < d - 1 && this._tryToAddEllipsisToLastLine();
            if (this.textArr[this.textArr.length - 1] && (this.textArr[this.textArr.length - 1].lastInParagraph = !0), o && g + n > y) break;
        }
        this.textHeight = e, this.textWidth = i;
    }
    _shouldHandleEllipsis(t) {
        const e = +this.fontSize(), i = this.lineHeight() * e, n = this.attrs.height, r = n !== $47a4b45281b81a8b$var$re && n !== void 0, s = this.padding(), a = n - s * 2;
        return !(this.wrap() !== $47a4b45281b81a8b$var$On) || r && t + i > a;
    }
    _tryToAddEllipsisToLastLine() {
        const t = this.attrs.width, e = t !== $47a4b45281b81a8b$var$re && t !== void 0, i = this.padding(), n = t - i * 2, r = this.ellipsis(), s = this.textArr[this.textArr.length - 1];
        !s || !r || (e && (this._getTextWidth(s.text + $47a4b45281b81a8b$var$Ii) < n || (s.text = s.text.slice(0, s.text.length - 3))), this.textArr.splice(this.textArr.length - 1, 1), this._addTextLine(s.text + $47a4b45281b81a8b$var$Ii));
    }
    getStrokeScaleEnabled() {
        return !0;
    }
    _useBufferCanvas() {
        const t = this.textDecoration().indexOf("underline") !== -1 || this.textDecoration().indexOf("line-through") !== -1, e = this.hasShadow();
        return t && e ? !0 : super._useBufferCanvas();
    }
}
$47a4b45281b81a8b$var$pe.Text = $47a4b45281b81a8b$var$at;
$47a4b45281b81a8b$var$at.prototype._fillFunc = $47a4b45281b81a8b$var$Fa;
$47a4b45281b81a8b$var$at.prototype._strokeFunc = $47a4b45281b81a8b$var$Oa;
$47a4b45281b81a8b$var$at.prototype.className = $47a4b45281b81a8b$var$wa;
$47a4b45281b81a8b$var$at.prototype._attrsAffectingSize = [
    "text",
    "fontSize",
    "padding",
    "wrap",
    "lineHeight",
    "letterSpacing"
];
(0, $47a4b45281b81a8b$var$_a._registerNode)($47a4b45281b81a8b$var$at);
$47a4b45281b81a8b$var$ft.Factory.overWriteSetter($47a4b45281b81a8b$var$at, "width", (0, $47a4b45281b81a8b$var$Ht.getNumberOrAutoValidator)());
$47a4b45281b81a8b$var$ft.Factory.overWriteSetter($47a4b45281b81a8b$var$at, "height", (0, $47a4b45281b81a8b$var$Ht.getNumberOrAutoValidator)());
$47a4b45281b81a8b$var$ft.Factory.addGetterSetter($47a4b45281b81a8b$var$at, "direction", $47a4b45281b81a8b$var$Sr);
$47a4b45281b81a8b$var$ft.Factory.addGetterSetter($47a4b45281b81a8b$var$at, "fontFamily", "Arial");
$47a4b45281b81a8b$var$ft.Factory.addGetterSetter($47a4b45281b81a8b$var$at, "fontSize", 12, (0, $47a4b45281b81a8b$var$Ht.getNumberValidator)());
$47a4b45281b81a8b$var$ft.Factory.addGetterSetter($47a4b45281b81a8b$var$at, "fontStyle", $47a4b45281b81a8b$var$wr);
$47a4b45281b81a8b$var$ft.Factory.addGetterSetter($47a4b45281b81a8b$var$at, "fontVariant", $47a4b45281b81a8b$var$wr);
$47a4b45281b81a8b$var$ft.Factory.addGetterSetter($47a4b45281b81a8b$var$at, "padding", 0, (0, $47a4b45281b81a8b$var$Ht.getNumberValidator)());
$47a4b45281b81a8b$var$ft.Factory.addGetterSetter($47a4b45281b81a8b$var$at, "align", $47a4b45281b81a8b$var$Cr);
$47a4b45281b81a8b$var$ft.Factory.addGetterSetter($47a4b45281b81a8b$var$at, "verticalAlign", $47a4b45281b81a8b$var$xa);
$47a4b45281b81a8b$var$ft.Factory.addGetterSetter($47a4b45281b81a8b$var$at, "lineHeight", 1, (0, $47a4b45281b81a8b$var$Ht.getNumberValidator)());
$47a4b45281b81a8b$var$ft.Factory.addGetterSetter($47a4b45281b81a8b$var$at, "wrap", $47a4b45281b81a8b$var$Aa);
$47a4b45281b81a8b$var$ft.Factory.addGetterSetter($47a4b45281b81a8b$var$at, "ellipsis", !1, (0, $47a4b45281b81a8b$var$Ht.getBooleanValidator)());
$47a4b45281b81a8b$var$ft.Factory.addGetterSetter($47a4b45281b81a8b$var$at, "letterSpacing", 0, (0, $47a4b45281b81a8b$var$Ht.getNumberValidator)());
$47a4b45281b81a8b$var$ft.Factory.addGetterSetter($47a4b45281b81a8b$var$at, "text", "", (0, $47a4b45281b81a8b$var$Ht.getStringValidator)());
$47a4b45281b81a8b$var$ft.Factory.addGetterSetter($47a4b45281b81a8b$var$at, "textDecoration", "");
var $47a4b45281b81a8b$var$ai = {};
Object.defineProperty($47a4b45281b81a8b$var$ai, "__esModule", {
    value: !0
});
$47a4b45281b81a8b$var$ai.TextPath = void 0;
const $47a4b45281b81a8b$var$Ui = $47a4b45281b81a8b$var$nt, $47a4b45281b81a8b$var$St = $47a4b45281b81a8b$var$V, $47a4b45281b81a8b$var$La = $47a4b45281b81a8b$var$ct, $47a4b45281b81a8b$var$_e = $47a4b45281b81a8b$var$ge, $47a4b45281b81a8b$var$Bi = $47a4b45281b81a8b$var$pe, $47a4b45281b81a8b$var$Tr = $47a4b45281b81a8b$var$L, $47a4b45281b81a8b$var$Ga = $47a4b45281b81a8b$var$H, $47a4b45281b81a8b$var$Ia = "", $47a4b45281b81a8b$var$kr = "normal";
function $47a4b45281b81a8b$var$Er(l) {
    l.fillText(this.partialText, 0, 0);
}
function $47a4b45281b81a8b$var$Ar(l) {
    l.strokeText(this.partialText, 0, 0);
}
class $47a4b45281b81a8b$var$dt extends $47a4b45281b81a8b$var$La.Shape {
    constructor(t){
        super(t), this.dummyCanvas = $47a4b45281b81a8b$var$Ui.Util.createCanvasElement(), this.dataArray = [], this._readDataAttribute(), this.on("dataChange.konva", function() {
            this._readDataAttribute(), this._setTextData();
        }), this.on("textChange.konva alignChange.konva letterSpacingChange.konva kerningFuncChange.konva fontSizeChange.konva fontFamilyChange.konva", this._setTextData), this._setTextData();
    }
    _getTextPathLength() {
        return $47a4b45281b81a8b$var$_e.Path.getPathLength(this.dataArray);
    }
    _getPointAtLength(t) {
        if (!this.attrs.data) return null;
        const e = this.pathLength;
        return t - 1 > e ? null : $47a4b45281b81a8b$var$_e.Path.getPointAtLengthOfDataArray(t, this.dataArray);
    }
    _readDataAttribute() {
        this.dataArray = $47a4b45281b81a8b$var$_e.Path.parsePathData(this.attrs.data), this.pathLength = this._getTextPathLength();
    }
    _sceneFunc(t) {
        t.setAttr("font", this._getContextFont()), t.setAttr("textBaseline", this.textBaseline()), t.setAttr("textAlign", "left"), t.save();
        const e = this.textDecoration(), i = this.fill(), n = this.fontSize(), r = this.glyphInfo;
        e === "underline" && t.beginPath();
        for(let s = 0; s < r.length; s++){
            t.save();
            const a = r[s].p0;
            t.translate(a.x, a.y), t.rotate(r[s].rotation), this.partialText = r[s].text, t.fillStrokeShape(this), e === "underline" && (s === 0 && t.moveTo(0, n / 2 + 1), t.lineTo(n, n / 2 + 1)), t.restore();
        }
        e === "underline" && (t.strokeStyle = i, t.lineWidth = n / 20, t.stroke()), t.restore();
    }
    _hitFunc(t) {
        t.beginPath();
        const e = this.glyphInfo;
        if (e.length >= 1) {
            const i = e[0].p0;
            t.moveTo(i.x, i.y);
        }
        for(let i = 0; i < e.length; i++){
            const n = e[i].p1;
            t.lineTo(n.x, n.y);
        }
        t.setAttr("lineWidth", this.fontSize()), t.setAttr("strokeStyle", this.colorKey), t.stroke();
    }
    getTextWidth() {
        return this.textWidth;
    }
    getTextHeight() {
        return $47a4b45281b81a8b$var$Ui.Util.warn("text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height."), this.textHeight;
    }
    setText(t) {
        return $47a4b45281b81a8b$var$Bi.Text.prototype.setText.call(this, t);
    }
    _getContextFont() {
        return $47a4b45281b81a8b$var$Bi.Text.prototype._getContextFont.call(this);
    }
    _getTextSize(t) {
        const i = this.dummyCanvas.getContext("2d");
        i.save(), i.font = this._getContextFont();
        const n = i.measureText(t);
        return i.restore(), {
            width: n.width,
            height: parseInt(`${this.fontSize()}`, 10)
        };
    }
    _setTextData() {
        const { width: t, height: e } = this._getTextSize(this.attrs.text);
        if (this.textWidth = t, this.textHeight = e, this.glyphInfo = [], !this.attrs.data) return null;
        const i = this.letterSpacing(), n = this.align(), r = this.kerningFunc(), s = Math.max(this.textWidth + ((this.attrs.text || "").length - 1) * i, 0);
        let a = 0;
        n === "center" && (a = Math.max(0, this.pathLength / 2 - s / 2)), n === "right" && (a = Math.max(0, this.pathLength - s));
        const o = (0, $47a4b45281b81a8b$var$Bi.stringToArray)(this.text());
        let h = a;
        for(let c = 0; c < o.length; c++){
            const y = this._getPointAtLength(h);
            if (!y) return;
            let g = this._getTextSize(o[c]).width + i;
            if (o[c] === " " && n === "justify") {
                const k = this.text().split(" ").length - 1;
                g += (this.pathLength - s) / k;
            }
            const u = this._getPointAtLength(h + g);
            if (!u) return;
            const f = $47a4b45281b81a8b$var$_e.Path.getLineLength(y.x, y.y, u.x, u.y);
            let _ = 0;
            if (r) try {
                _ = r(o[c - 1], o[c]) * this.fontSize();
            } catch  {
                _ = 0;
            }
            y.x += _, u.x += _, this.textWidth += _;
            const v = $47a4b45281b81a8b$var$_e.Path.getPointOnLine(_ + f / 2, y.x, y.y, u.x, u.y), C = Math.atan2(u.y - y.y, u.x - y.x);
            this.glyphInfo.push({
                transposeX: v.x,
                transposeY: v.y,
                text: o[c],
                rotation: C,
                p0: y,
                p1: u
            }), h += g;
        }
    }
    getSelfRect() {
        if (!this.glyphInfo.length) return {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
        const t = [];
        this.glyphInfo.forEach(function(h) {
            t.push(h.p0.x), t.push(h.p0.y), t.push(h.p1.x), t.push(h.p1.y);
        });
        let e = t[0] || 0, i = t[0] || 0, n = t[1] || 0, r = t[1] || 0, s, a;
        for(let h = 0; h < t.length / 2; h++)s = t[h * 2], a = t[h * 2 + 1], e = Math.min(e, s), i = Math.max(i, s), n = Math.min(n, a), r = Math.max(r, a);
        const o = this.fontSize();
        return {
            x: e - o / 2,
            y: n - o / 2,
            width: i - e + o,
            height: r - n + o
        };
    }
    destroy() {
        return $47a4b45281b81a8b$var$Ui.Util.releaseCanvas(this.dummyCanvas), super.destroy();
    }
}
$47a4b45281b81a8b$var$ai.TextPath = $47a4b45281b81a8b$var$dt;
$47a4b45281b81a8b$var$dt.prototype._fillFunc = $47a4b45281b81a8b$var$Er;
$47a4b45281b81a8b$var$dt.prototype._strokeFunc = $47a4b45281b81a8b$var$Ar;
$47a4b45281b81a8b$var$dt.prototype._fillFuncHit = $47a4b45281b81a8b$var$Er;
$47a4b45281b81a8b$var$dt.prototype._strokeFuncHit = $47a4b45281b81a8b$var$Ar;
$47a4b45281b81a8b$var$dt.prototype.className = "TextPath";
$47a4b45281b81a8b$var$dt.prototype._attrsAffectingSize = [
    "text",
    "fontSize",
    "data"
];
(0, $47a4b45281b81a8b$var$Ga._registerNode)($47a4b45281b81a8b$var$dt);
$47a4b45281b81a8b$var$St.Factory.addGetterSetter($47a4b45281b81a8b$var$dt, "data");
$47a4b45281b81a8b$var$St.Factory.addGetterSetter($47a4b45281b81a8b$var$dt, "fontFamily", "Arial");
$47a4b45281b81a8b$var$St.Factory.addGetterSetter($47a4b45281b81a8b$var$dt, "fontSize", 12, (0, $47a4b45281b81a8b$var$Tr.getNumberValidator)());
$47a4b45281b81a8b$var$St.Factory.addGetterSetter($47a4b45281b81a8b$var$dt, "fontStyle", $47a4b45281b81a8b$var$kr);
$47a4b45281b81a8b$var$St.Factory.addGetterSetter($47a4b45281b81a8b$var$dt, "align", "left");
$47a4b45281b81a8b$var$St.Factory.addGetterSetter($47a4b45281b81a8b$var$dt, "letterSpacing", 0, (0, $47a4b45281b81a8b$var$Tr.getNumberValidator)());
$47a4b45281b81a8b$var$St.Factory.addGetterSetter($47a4b45281b81a8b$var$dt, "textBaseline", "middle");
$47a4b45281b81a8b$var$St.Factory.addGetterSetter($47a4b45281b81a8b$var$dt, "fontVariant", $47a4b45281b81a8b$var$kr);
$47a4b45281b81a8b$var$St.Factory.addGetterSetter($47a4b45281b81a8b$var$dt, "text", $47a4b45281b81a8b$var$Ia);
$47a4b45281b81a8b$var$St.Factory.addGetterSetter($47a4b45281b81a8b$var$dt, "textDecoration", "");
$47a4b45281b81a8b$var$St.Factory.addGetterSetter($47a4b45281b81a8b$var$dt, "kerningFunc", void 0);
var $47a4b45281b81a8b$var$oi = {};
Object.defineProperty($47a4b45281b81a8b$var$oi, "__esModule", {
    value: !0
});
$47a4b45281b81a8b$var$oi.Transformer = void 0;
const $47a4b45281b81a8b$var$Y = $47a4b45281b81a8b$var$nt, $47a4b45281b81a8b$var$K = $47a4b45281b81a8b$var$V, $47a4b45281b81a8b$var$Dn = $47a4b45281b81a8b$var$et, $47a4b45281b81a8b$var$Na = $47a4b45281b81a8b$var$ct, $47a4b45281b81a8b$var$Ua = $47a4b45281b81a8b$var$Ee, $47a4b45281b81a8b$var$Ln = $47a4b45281b81a8b$var$de, $47a4b45281b81a8b$var$vt = $47a4b45281b81a8b$var$H, $47a4b45281b81a8b$var$Vt = $47a4b45281b81a8b$var$L, $47a4b45281b81a8b$var$Ba = $47a4b45281b81a8b$var$H, $47a4b45281b81a8b$var$Pr = "tr-konva", $47a4b45281b81a8b$var$Ha = [
    "resizeEnabledChange",
    "rotateAnchorOffsetChange",
    "rotateEnabledChange",
    "enabledAnchorsChange",
    "anchorSizeChange",
    "borderEnabledChange",
    "borderStrokeChange",
    "borderStrokeWidthChange",
    "borderDashChange",
    "anchorStrokeChange",
    "anchorStrokeWidthChange",
    "anchorFillChange",
    "anchorCornerRadiusChange",
    "ignoreStrokeChange",
    "anchorStyleFuncChange"
].map((l)=>l + `.${$47a4b45281b81a8b$var$Pr}`).join(" "), $47a4b45281b81a8b$var$Gn = "nodesRect", $47a4b45281b81a8b$var$Va = [
    "widthChange",
    "heightChange",
    "scaleXChange",
    "scaleYChange",
    "skewXChange",
    "skewYChange",
    "rotationChange",
    "offsetXChange",
    "offsetYChange",
    "transformsEnabledChange",
    "strokeWidthChange"
], $47a4b45281b81a8b$var$$a = {
    "top-left": -45,
    "top-center": 0,
    "top-right": 45,
    "middle-right": -90,
    "middle-left": 90,
    "bottom-left": -135,
    "bottom-center": 180,
    "bottom-right": 135
}, $47a4b45281b81a8b$var$za = "ontouchstart" in $47a4b45281b81a8b$var$vt.Konva._global;
function $47a4b45281b81a8b$var$Wa(l, t, e) {
    if (l === "rotater") return e;
    t += $47a4b45281b81a8b$var$Y.Util.degToRad($47a4b45281b81a8b$var$$a[l] || 0);
    const i = ($47a4b45281b81a8b$var$Y.Util.radToDeg(t) % 360 + 360) % 360;
    return $47a4b45281b81a8b$var$Y.Util._inRange(i, 337.5, 360) || $47a4b45281b81a8b$var$Y.Util._inRange(i, 0, 22.5) ? "ns-resize" : $47a4b45281b81a8b$var$Y.Util._inRange(i, 22.5, 67.5) ? "nesw-resize" : $47a4b45281b81a8b$var$Y.Util._inRange(i, 67.5, 112.5) ? "ew-resize" : $47a4b45281b81a8b$var$Y.Util._inRange(i, 112.5, 157.5) ? "nwse-resize" : $47a4b45281b81a8b$var$Y.Util._inRange(i, 157.5, 202.5) ? "ns-resize" : $47a4b45281b81a8b$var$Y.Util._inRange(i, 202.5, 247.5) ? "nesw-resize" : $47a4b45281b81a8b$var$Y.Util._inRange(i, 247.5, 292.5) ? "ew-resize" : $47a4b45281b81a8b$var$Y.Util._inRange(i, 292.5, 337.5) ? "nwse-resize" : ($47a4b45281b81a8b$var$Y.Util.error("Transformer has unknown angle for cursor detection: " + i), "pointer");
}
const $47a4b45281b81a8b$var$Ge = [
    "top-left",
    "top-center",
    "top-right",
    "middle-right",
    "middle-left",
    "bottom-left",
    "bottom-center",
    "bottom-right"
], $47a4b45281b81a8b$var$In = 1e8;
function $47a4b45281b81a8b$var$Xa(l) {
    return {
        x: l.x + l.width / 2 * Math.cos(l.rotation) + l.height / 2 * Math.sin(-l.rotation),
        y: l.y + l.height / 2 * Math.cos(l.rotation) + l.width / 2 * Math.sin(l.rotation)
    };
}
function $47a4b45281b81a8b$var$Mr(l, t, e) {
    const i = e.x + (l.x - e.x) * Math.cos(t) - (l.y - e.y) * Math.sin(t), n = e.y + (l.x - e.x) * Math.sin(t) + (l.y - e.y) * Math.cos(t);
    return {
        ...l,
        rotation: l.rotation + t,
        x: i,
        y: n
    };
}
function $47a4b45281b81a8b$var$Ka(l, t) {
    const e = $47a4b45281b81a8b$var$Xa(l);
    return $47a4b45281b81a8b$var$Mr(l, t, e);
}
function $47a4b45281b81a8b$var$Ya(l, t, e) {
    let i = t;
    for(let n = 0; n < l.length; n++){
        const r = $47a4b45281b81a8b$var$vt.Konva.getAngle(l[n]), s = Math.abs(r - t) % (Math.PI * 2);
        Math.min(s, Math.PI * 2 - s) < e && (i = r);
    }
    return i;
}
let $47a4b45281b81a8b$var$Ji = 0;
class $47a4b45281b81a8b$var$W extends $47a4b45281b81a8b$var$Ln.Group {
    constructor(t){
        super(t), this._movingAnchorName = null, this._transforming = !1, this._createElements(), this._handleMouseMove = this._handleMouseMove.bind(this), this._handleMouseUp = this._handleMouseUp.bind(this), this.update = this.update.bind(this), this.on($47a4b45281b81a8b$var$Ha, this.update), this.getNode() && this.update();
    }
    attachTo(t) {
        return this.setNode(t), this;
    }
    setNode(t) {
        return $47a4b45281b81a8b$var$Y.Util.warn("tr.setNode(shape), tr.node(shape) and tr.attachTo(shape) methods are deprecated. Please use tr.nodes(nodesArray) instead."), this.setNodes([
            t
        ]);
    }
    getNode() {
        return this._nodes && this._nodes[0];
    }
    _getEventNamespace() {
        return $47a4b45281b81a8b$var$Pr + this._id;
    }
    setNodes(t = []) {
        this._nodes && this._nodes.length && this.detach();
        const e = t.filter((n)=>n.isAncestorOf(this) ? ($47a4b45281b81a8b$var$Y.Util.error("Konva.Transformer cannot be an a child of the node you are trying to attach"), !1) : !0);
        return this._nodes = t = e, t.length === 1 && this.useSingleNodeRotation() ? this.rotation(t[0].getAbsoluteRotation()) : this.rotation(0), this._nodes.forEach((n)=>{
            const r = ()=>{
                this.nodes().length === 1 && this.useSingleNodeRotation() && this.rotation(this.nodes()[0].getAbsoluteRotation()), this._resetTransformCache(), !this._transforming && !this.isDragging() && this.update();
            }, s = n._attrsAffectingSize.map((a)=>a + "Change." + this._getEventNamespace()).join(" ");
            n.on(s, r), n.on($47a4b45281b81a8b$var$Va.map((a)=>a + `.${this._getEventNamespace()}`).join(" "), r), n.on(`absoluteTransformChange.${this._getEventNamespace()}`, r), this._proxyDrag(n);
        }), this._resetTransformCache(), !!this.findOne(".top-left") && this.update(), this;
    }
    _proxyDrag(t) {
        let e;
        t.on(`dragstart.${this._getEventNamespace()}`, (i)=>{
            e = t.getAbsolutePosition(), !this.isDragging() && t !== this.findOne(".back") && this.startDrag(i, !1);
        }), t.on(`dragmove.${this._getEventNamespace()}`, (i)=>{
            if (!e) return;
            const n = t.getAbsolutePosition(), r = n.x - e.x, s = n.y - e.y;
            this.nodes().forEach((a)=>{
                if (a === t || a.isDragging()) return;
                const o = a.getAbsolutePosition();
                a.setAbsolutePosition({
                    x: o.x + r,
                    y: o.y + s
                }), a.startDrag(i);
            }), e = null;
        });
    }
    getNodes() {
        return this._nodes || [];
    }
    getActiveAnchor() {
        return this._movingAnchorName;
    }
    detach() {
        this._nodes && this._nodes.forEach((t)=>{
            t.off("." + this._getEventNamespace());
        }), this._nodes = [], this._resetTransformCache();
    }
    _resetTransformCache() {
        this._clearCache($47a4b45281b81a8b$var$Gn), this._clearCache("transform"), this._clearSelfAndDescendantCache("absoluteTransform");
    }
    _getNodeRect() {
        return this._getCache($47a4b45281b81a8b$var$Gn, this.__getNodeRect);
    }
    __getNodeShape(t, e = this.rotation(), i) {
        const n = t.getClientRect({
            skipTransform: !0,
            skipShadow: !0,
            skipStroke: this.ignoreStroke()
        }), r = t.getAbsoluteScale(i), s = t.getAbsolutePosition(i), a = n.x * r.x - t.offsetX() * r.x, o = n.y * r.y - t.offsetY() * r.y, h = ($47a4b45281b81a8b$var$vt.Konva.getAngle(t.getAbsoluteRotation()) + Math.PI * 2) % (Math.PI * 2), c = {
            x: s.x + a * Math.cos(h) + o * Math.sin(-h),
            y: s.y + o * Math.cos(h) + a * Math.sin(h),
            width: n.width * r.x,
            height: n.height * r.y,
            rotation: h
        };
        return $47a4b45281b81a8b$var$Mr(c, -$47a4b45281b81a8b$var$vt.Konva.getAngle(e), {
            x: 0,
            y: 0
        });
    }
    __getNodeRect() {
        if (!this.getNode()) return {
            x: -$47a4b45281b81a8b$var$In,
            y: -$47a4b45281b81a8b$var$In,
            width: 0,
            height: 0,
            rotation: 0
        };
        const e = [];
        this.nodes().map((h)=>{
            const c = h.getClientRect({
                skipTransform: !0,
                skipShadow: !0,
                skipStroke: this.ignoreStroke()
            }), y = [
                {
                    x: c.x,
                    y: c.y
                },
                {
                    x: c.x + c.width,
                    y: c.y
                },
                {
                    x: c.x + c.width,
                    y: c.y + c.height
                },
                {
                    x: c.x,
                    y: c.y + c.height
                }
            ], g = h.getAbsoluteTransform();
            y.forEach(function(u) {
                const f = g.point(u);
                e.push(f);
            });
        });
        const i = new $47a4b45281b81a8b$var$Y.Transform();
        i.rotate(-$47a4b45281b81a8b$var$vt.Konva.getAngle(this.rotation()));
        let n = 1 / 0, r = 1 / 0, s = -1 / 0, a = -1 / 0;
        e.forEach(function(h) {
            const c = i.point(h);
            n === void 0 && (n = s = c.x, r = a = c.y), n = Math.min(n, c.x), r = Math.min(r, c.y), s = Math.max(s, c.x), a = Math.max(a, c.y);
        }), i.invert();
        const o = i.point({
            x: n,
            y: r
        });
        return {
            x: o.x,
            y: o.y,
            width: s - n,
            height: a - r,
            rotation: $47a4b45281b81a8b$var$vt.Konva.getAngle(this.rotation())
        };
    }
    getX() {
        return this._getNodeRect().x;
    }
    getY() {
        return this._getNodeRect().y;
    }
    getWidth() {
        return this._getNodeRect().width;
    }
    getHeight() {
        return this._getNodeRect().height;
    }
    _createElements() {
        this._createBack(), $47a4b45281b81a8b$var$Ge.forEach((t)=>{
            this._createAnchor(t);
        }), this._createAnchor("rotater");
    }
    _createAnchor(t) {
        const e = new $47a4b45281b81a8b$var$Ua.Rect({
            stroke: "rgb(0, 161, 255)",
            fill: "white",
            strokeWidth: 1,
            name: t + " _anchor",
            dragDistance: 0,
            draggable: !0,
            hitStrokeWidth: $47a4b45281b81a8b$var$za ? 10 : "auto"
        }), i = this;
        e.on("mousedown touchstart", function(n) {
            i._handleMouseDown(n);
        }), e.on("dragstart", (n)=>{
            e.stopDrag(), n.cancelBubble = !0;
        }), e.on("dragend", (n)=>{
            n.cancelBubble = !0;
        }), e.on("mouseenter", ()=>{
            const n = $47a4b45281b81a8b$var$vt.Konva.getAngle(this.rotation()), r = this.rotateAnchorCursor(), s = $47a4b45281b81a8b$var$Wa(t, n, r);
            e.getStage().content && (e.getStage().content.style.cursor = s), this._cursorChange = !0;
        }), e.on("mouseout", ()=>{
            e.getStage().content && (e.getStage().content.style.cursor = ""), this._cursorChange = !1;
        }), this.add(e);
    }
    _createBack() {
        const t = new $47a4b45281b81a8b$var$Na.Shape({
            name: "back",
            width: 0,
            height: 0,
            draggable: !0,
            sceneFunc (e, i) {
                const n = i.getParent(), r = n.padding();
                e.beginPath(), e.rect(-r, -r, i.width() + r * 2, i.height() + r * 2), e.moveTo(i.width() / 2, -r), n.rotateEnabled() && n.rotateLineVisible() && e.lineTo(i.width() / 2, -n.rotateAnchorOffset() * $47a4b45281b81a8b$var$Y.Util._sign(i.height()) - r), e.fillStrokeShape(i);
            },
            hitFunc: (e, i)=>{
                if (!this.shouldOverdrawWholeArea()) return;
                const n = this.padding();
                e.beginPath(), e.rect(-n, -n, i.width() + n * 2, i.height() + n * 2), e.fillStrokeShape(i);
            }
        });
        this.add(t), this._proxyDrag(t), t.on("dragstart", (e)=>{
            e.cancelBubble = !0;
        }), t.on("dragmove", (e)=>{
            e.cancelBubble = !0;
        }), t.on("dragend", (e)=>{
            e.cancelBubble = !0;
        }), this.on("dragmove", (e)=>{
            this.update();
        });
    }
    _handleMouseDown(t) {
        if (this._transforming) return;
        this._movingAnchorName = t.target.name().split(" ")[0];
        const e = this._getNodeRect(), i = e.width, n = e.height, r = Math.sqrt(Math.pow(i, 2) + Math.pow(n, 2));
        this.sin = Math.abs(n / r), this.cos = Math.abs(i / r), typeof window < "u" && (window.addEventListener("mousemove", this._handleMouseMove), window.addEventListener("touchmove", this._handleMouseMove), window.addEventListener("mouseup", this._handleMouseUp, !0), window.addEventListener("touchend", this._handleMouseUp, !0)), this._transforming = !0;
        const s = t.target.getAbsolutePosition(), a = t.target.getStage().getPointerPosition();
        this._anchorDragOffset = {
            x: a.x - s.x,
            y: a.y - s.y
        }, $47a4b45281b81a8b$var$Ji++, this._fire("transformstart", {
            evt: t.evt,
            target: this.getNode()
        }), this._nodes.forEach((o)=>{
            o._fire("transformstart", {
                evt: t.evt,
                target: o
            });
        });
    }
    _handleMouseMove(t) {
        let e, i, n;
        const r = this.findOne("." + this._movingAnchorName), s = r.getStage();
        s.setPointersPositions(t);
        const a = s.getPointerPosition();
        let o = {
            x: a.x - this._anchorDragOffset.x,
            y: a.y - this._anchorDragOffset.y
        };
        const h = r.getAbsolutePosition();
        this.anchorDragBoundFunc() && (o = this.anchorDragBoundFunc()(h, o, t)), r.setAbsolutePosition(o);
        const c = r.getAbsolutePosition();
        if (h.x === c.x && h.y === c.y) return;
        if (this._movingAnchorName === "rotater") {
            const b = this._getNodeRect();
            e = r.x() - b.width / 2, i = -r.y() + b.height / 2;
            let w = Math.atan2(-i, e) + Math.PI / 2;
            b.height < 0 && (w -= Math.PI);
            const S = $47a4b45281b81a8b$var$vt.Konva.getAngle(this.rotation()) + w, E = $47a4b45281b81a8b$var$vt.Konva.getAngle(this.rotationSnapTolerance()), T = $47a4b45281b81a8b$var$Ya(this.rotationSnaps(), S, E) - b.rotation, A = $47a4b45281b81a8b$var$Ka(b, T);
            this._fitNodesInto(A, t);
            return;
        }
        const y = this.shiftBehavior();
        let g;
        y === "inverted" ? g = this.keepRatio() && !t.shiftKey : y === "none" ? g = this.keepRatio() : g = this.keepRatio() || t.shiftKey;
        var C = this.centeredScaling() || t.altKey;
        if (this._movingAnchorName === "top-left") {
            if (g) {
                var u = C ? {
                    x: this.width() / 2,
                    y: this.height() / 2
                } : {
                    x: this.findOne(".bottom-right").x(),
                    y: this.findOne(".bottom-right").y()
                };
                n = Math.sqrt(Math.pow(u.x - r.x(), 2) + Math.pow(u.y - r.y(), 2));
                var f = this.findOne(".top-left").x() > u.x ? -1 : 1, _ = this.findOne(".top-left").y() > u.y ? -1 : 1;
                e = n * this.cos * f, i = n * this.sin * _, this.findOne(".top-left").x(u.x - e), this.findOne(".top-left").y(u.y - i);
            }
        } else if (this._movingAnchorName === "top-center") this.findOne(".top-left").y(r.y());
        else if (this._movingAnchorName === "top-right") {
            if (g) {
                var u = C ? {
                    x: this.width() / 2,
                    y: this.height() / 2
                } : {
                    x: this.findOne(".bottom-left").x(),
                    y: this.findOne(".bottom-left").y()
                };
                n = Math.sqrt(Math.pow(r.x() - u.x, 2) + Math.pow(u.y - r.y(), 2));
                var f = this.findOne(".top-right").x() < u.x ? -1 : 1, _ = this.findOne(".top-right").y() > u.y ? -1 : 1;
                e = n * this.cos * f, i = n * this.sin * _, this.findOne(".top-right").x(u.x + e), this.findOne(".top-right").y(u.y - i);
            }
            var v = r.position();
            this.findOne(".top-left").y(v.y), this.findOne(".bottom-right").x(v.x);
        } else if (this._movingAnchorName === "middle-left") this.findOne(".top-left").x(r.x());
        else if (this._movingAnchorName === "middle-right") this.findOne(".bottom-right").x(r.x());
        else if (this._movingAnchorName === "bottom-left") {
            if (g) {
                var u = C ? {
                    x: this.width() / 2,
                    y: this.height() / 2
                } : {
                    x: this.findOne(".top-right").x(),
                    y: this.findOne(".top-right").y()
                };
                n = Math.sqrt(Math.pow(u.x - r.x(), 2) + Math.pow(r.y() - u.y, 2));
                var f = u.x < r.x() ? -1 : 1, _ = r.y() < u.y ? -1 : 1;
                e = n * this.cos * f, i = n * this.sin * _, r.x(u.x - e), r.y(u.y + i);
            }
            v = r.position(), this.findOne(".top-left").x(v.x), this.findOne(".bottom-right").y(v.y);
        } else if (this._movingAnchorName === "bottom-center") this.findOne(".bottom-right").y(r.y());
        else if (this._movingAnchorName === "bottom-right") {
            if (g) {
                var u = C ? {
                    x: this.width() / 2,
                    y: this.height() / 2
                } : {
                    x: this.findOne(".top-left").x(),
                    y: this.findOne(".top-left").y()
                };
                n = Math.sqrt(Math.pow(r.x() - u.x, 2) + Math.pow(r.y() - u.y, 2));
                var f = this.findOne(".bottom-right").x() < u.x ? -1 : 1, _ = this.findOne(".bottom-right").y() < u.y ? -1 : 1;
                e = n * this.cos * f, i = n * this.sin * _, this.findOne(".bottom-right").x(u.x + e), this.findOne(".bottom-right").y(u.y + i);
            }
        } else console.error(new Error("Wrong position argument of selection resizer: " + this._movingAnchorName));
        var C = this.centeredScaling() || t.altKey;
        if (C) {
            const b = this.findOne(".top-left"), w = this.findOne(".bottom-right"), P = b.x(), S = b.y(), E = this.getWidth() - w.x(), m = this.getHeight() - w.y();
            w.move({
                x: -P,
                y: -S
            }), b.move({
                x: E,
                y: m
            });
        }
        const k = this.findOne(".top-left").getAbsolutePosition();
        e = k.x, i = k.y;
        const d = this.findOne(".bottom-right").x() - this.findOne(".top-left").x(), p = this.findOne(".bottom-right").y() - this.findOne(".top-left").y();
        this._fitNodesInto({
            x: e,
            y: i,
            width: d,
            height: p,
            rotation: $47a4b45281b81a8b$var$vt.Konva.getAngle(this.rotation())
        }, t);
    }
    _handleMouseUp(t) {
        this._removeEvents(t);
    }
    getAbsoluteTransform() {
        return this.getTransform();
    }
    _removeEvents(t) {
        var e;
        if (this._transforming) {
            this._transforming = !1, typeof window < "u" && (window.removeEventListener("mousemove", this._handleMouseMove), window.removeEventListener("touchmove", this._handleMouseMove), window.removeEventListener("mouseup", this._handleMouseUp, !0), window.removeEventListener("touchend", this._handleMouseUp, !0));
            const i = this.getNode();
            $47a4b45281b81a8b$var$Ji--, this._fire("transformend", {
                evt: t,
                target: i
            }), (e = this.getLayer()) === null || e === void 0 || e.batchDraw(), i && this._nodes.forEach((n)=>{
                var r;
                n._fire("transformend", {
                    evt: t,
                    target: n
                }), (r = n.getLayer()) === null || r === void 0 || r.batchDraw();
            }), this._movingAnchorName = null;
        }
    }
    _fitNodesInto(t, e) {
        const i = this._getNodeRect(), n = 1;
        if ($47a4b45281b81a8b$var$Y.Util._inRange(t.width, -this.padding() * 2 - n, n)) {
            this.update();
            return;
        }
        if ($47a4b45281b81a8b$var$Y.Util._inRange(t.height, -this.padding() * 2 - n, n)) {
            this.update();
            return;
        }
        const r = new $47a4b45281b81a8b$var$Y.Transform();
        if (r.rotate($47a4b45281b81a8b$var$vt.Konva.getAngle(this.rotation())), this._movingAnchorName && t.width < 0 && this._movingAnchorName.indexOf("left") >= 0) {
            const g = r.point({
                x: -this.padding() * 2,
                y: 0
            });
            t.x += g.x, t.y += g.y, t.width += this.padding() * 2, this._movingAnchorName = this._movingAnchorName.replace("left", "right"), this._anchorDragOffset.x -= g.x, this._anchorDragOffset.y -= g.y;
        } else if (this._movingAnchorName && t.width < 0 && this._movingAnchorName.indexOf("right") >= 0) {
            const g = r.point({
                x: this.padding() * 2,
                y: 0
            });
            this._movingAnchorName = this._movingAnchorName.replace("right", "left"), this._anchorDragOffset.x -= g.x, this._anchorDragOffset.y -= g.y, t.width += this.padding() * 2;
        }
        if (this._movingAnchorName && t.height < 0 && this._movingAnchorName.indexOf("top") >= 0) {
            const g = r.point({
                x: 0,
                y: -this.padding() * 2
            });
            t.x += g.x, t.y += g.y, this._movingAnchorName = this._movingAnchorName.replace("top", "bottom"), this._anchorDragOffset.x -= g.x, this._anchorDragOffset.y -= g.y, t.height += this.padding() * 2;
        } else if (this._movingAnchorName && t.height < 0 && this._movingAnchorName.indexOf("bottom") >= 0) {
            const g = r.point({
                x: 0,
                y: this.padding() * 2
            });
            this._movingAnchorName = this._movingAnchorName.replace("bottom", "top"), this._anchorDragOffset.x -= g.x, this._anchorDragOffset.y -= g.y, t.height += this.padding() * 2;
        }
        if (this.boundBoxFunc()) {
            const g = this.boundBoxFunc()(i, t);
            g ? t = g : $47a4b45281b81a8b$var$Y.Util.warn("boundBoxFunc returned falsy. You should return new bound rect from it!");
        }
        const s = 1e7, a = new $47a4b45281b81a8b$var$Y.Transform();
        a.translate(i.x, i.y), a.rotate(i.rotation), a.scale(i.width / s, i.height / s);
        const o = new $47a4b45281b81a8b$var$Y.Transform(), h = t.width / s, c = t.height / s;
        this.flipEnabled() === !1 ? (o.translate(t.x, t.y), o.rotate(t.rotation), o.translate(t.width < 0 ? t.width : 0, t.height < 0 ? t.height : 0), o.scale(Math.abs(h), Math.abs(c))) : (o.translate(t.x, t.y), o.rotate(t.rotation), o.scale(h, c));
        const y = o.multiply(a.invert());
        this._nodes.forEach((g)=>{
            var u;
            const f = g.getParent().getAbsoluteTransform(), _ = g.getTransform().copy();
            _.translate(g.offsetX(), g.offsetY());
            const v = new $47a4b45281b81a8b$var$Y.Transform();
            v.multiply(f.copy().invert()).multiply(y).multiply(f).multiply(_);
            const C = v.decompose();
            g.setAttrs(C), (u = g.getLayer()) === null || u === void 0 || u.batchDraw();
        }), this.rotation($47a4b45281b81a8b$var$Y.Util._getRotation(t.rotation)), this._nodes.forEach((g)=>{
            this._fire("transform", {
                evt: e,
                target: g
            }), g._fire("transform", {
                evt: e,
                target: g
            });
        }), this._resetTransformCache(), this.update(), this.getLayer().batchDraw();
    }
    forceUpdate() {
        this._resetTransformCache(), this.update();
    }
    _batchChangeChild(t, e) {
        this.findOne(t).setAttrs(e);
    }
    update() {
        var t;
        const e = this._getNodeRect();
        this.rotation($47a4b45281b81a8b$var$Y.Util._getRotation(e.rotation));
        const i = e.width, n = e.height, r = this.enabledAnchors(), s = this.resizeEnabled(), a = this.padding(), o = this.anchorSize(), h = this.find("._anchor");
        h.forEach((y)=>{
            y.setAttrs({
                width: o,
                height: o,
                offsetX: o / 2,
                offsetY: o / 2,
                stroke: this.anchorStroke(),
                strokeWidth: this.anchorStrokeWidth(),
                fill: this.anchorFill(),
                cornerRadius: this.anchorCornerRadius()
            });
        }), this._batchChangeChild(".top-left", {
            x: 0,
            y: 0,
            offsetX: o / 2 + a,
            offsetY: o / 2 + a,
            visible: s && r.indexOf("top-left") >= 0
        }), this._batchChangeChild(".top-center", {
            x: i / 2,
            y: 0,
            offsetY: o / 2 + a,
            visible: s && r.indexOf("top-center") >= 0
        }), this._batchChangeChild(".top-right", {
            x: i,
            y: 0,
            offsetX: o / 2 - a,
            offsetY: o / 2 + a,
            visible: s && r.indexOf("top-right") >= 0
        }), this._batchChangeChild(".middle-left", {
            x: 0,
            y: n / 2,
            offsetX: o / 2 + a,
            visible: s && r.indexOf("middle-left") >= 0
        }), this._batchChangeChild(".middle-right", {
            x: i,
            y: n / 2,
            offsetX: o / 2 - a,
            visible: s && r.indexOf("middle-right") >= 0
        }), this._batchChangeChild(".bottom-left", {
            x: 0,
            y: n,
            offsetX: o / 2 + a,
            offsetY: o / 2 - a,
            visible: s && r.indexOf("bottom-left") >= 0
        }), this._batchChangeChild(".bottom-center", {
            x: i / 2,
            y: n,
            offsetY: o / 2 - a,
            visible: s && r.indexOf("bottom-center") >= 0
        }), this._batchChangeChild(".bottom-right", {
            x: i,
            y: n,
            offsetX: o / 2 - a,
            offsetY: o / 2 - a,
            visible: s && r.indexOf("bottom-right") >= 0
        }), this._batchChangeChild(".rotater", {
            x: i / 2,
            y: -this.rotateAnchorOffset() * $47a4b45281b81a8b$var$Y.Util._sign(n) - a,
            visible: this.rotateEnabled()
        }), this._batchChangeChild(".back", {
            width: i,
            height: n,
            visible: this.borderEnabled(),
            stroke: this.borderStroke(),
            strokeWidth: this.borderStrokeWidth(),
            dash: this.borderDash(),
            x: 0,
            y: 0
        });
        const c = this.anchorStyleFunc();
        c && h.forEach((y)=>{
            c(y);
        }), (t = this.getLayer()) === null || t === void 0 || t.batchDraw();
    }
    isTransforming() {
        return this._transforming;
    }
    stopTransform() {
        if (this._transforming) {
            this._removeEvents();
            const t = this.findOne("." + this._movingAnchorName);
            t && t.stopDrag();
        }
    }
    destroy() {
        return this.getStage() && this._cursorChange && this.getStage().content && (this.getStage().content.style.cursor = ""), $47a4b45281b81a8b$var$Ln.Group.prototype.destroy.call(this), this.detach(), this._removeEvents(), this;
    }
    toObject() {
        return $47a4b45281b81a8b$var$Dn.Node.prototype.toObject.call(this);
    }
    clone(t) {
        return $47a4b45281b81a8b$var$Dn.Node.prototype.clone.call(this, t);
    }
    getClientRect() {
        return this.nodes().length > 0 ? super.getClientRect() : {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
    }
}
$47a4b45281b81a8b$var$oi.Transformer = $47a4b45281b81a8b$var$W;
$47a4b45281b81a8b$var$W.isTransforming = ()=>$47a4b45281b81a8b$var$Ji > 0;
function $47a4b45281b81a8b$var$ja(l) {
    return l instanceof Array || $47a4b45281b81a8b$var$Y.Util.warn("enabledAnchors value should be an array"), l instanceof Array && l.forEach(function(t) {
        $47a4b45281b81a8b$var$Ge.indexOf(t) === -1 && $47a4b45281b81a8b$var$Y.Util.warn("Unknown anchor name: " + t + ". Available names are: " + $47a4b45281b81a8b$var$Ge.join(", "));
    }), l || [];
}
$47a4b45281b81a8b$var$W.prototype.className = "Transformer";
(0, $47a4b45281b81a8b$var$Ba._registerNode)($47a4b45281b81a8b$var$W);
$47a4b45281b81a8b$var$K.Factory.addGetterSetter($47a4b45281b81a8b$var$W, "enabledAnchors", $47a4b45281b81a8b$var$Ge, $47a4b45281b81a8b$var$ja);
$47a4b45281b81a8b$var$K.Factory.addGetterSetter($47a4b45281b81a8b$var$W, "flipEnabled", !0, (0, $47a4b45281b81a8b$var$Vt.getBooleanValidator)());
$47a4b45281b81a8b$var$K.Factory.addGetterSetter($47a4b45281b81a8b$var$W, "resizeEnabled", !0);
$47a4b45281b81a8b$var$K.Factory.addGetterSetter($47a4b45281b81a8b$var$W, "anchorSize", 10, (0, $47a4b45281b81a8b$var$Vt.getNumberValidator)());
$47a4b45281b81a8b$var$K.Factory.addGetterSetter($47a4b45281b81a8b$var$W, "rotateEnabled", !0);
$47a4b45281b81a8b$var$K.Factory.addGetterSetter($47a4b45281b81a8b$var$W, "rotateLineVisible", !0);
$47a4b45281b81a8b$var$K.Factory.addGetterSetter($47a4b45281b81a8b$var$W, "rotationSnaps", []);
$47a4b45281b81a8b$var$K.Factory.addGetterSetter($47a4b45281b81a8b$var$W, "rotateAnchorOffset", 50, (0, $47a4b45281b81a8b$var$Vt.getNumberValidator)());
$47a4b45281b81a8b$var$K.Factory.addGetterSetter($47a4b45281b81a8b$var$W, "rotateAnchorCursor", "crosshair");
$47a4b45281b81a8b$var$K.Factory.addGetterSetter($47a4b45281b81a8b$var$W, "rotationSnapTolerance", 5, (0, $47a4b45281b81a8b$var$Vt.getNumberValidator)());
$47a4b45281b81a8b$var$K.Factory.addGetterSetter($47a4b45281b81a8b$var$W, "borderEnabled", !0);
$47a4b45281b81a8b$var$K.Factory.addGetterSetter($47a4b45281b81a8b$var$W, "anchorStroke", "rgb(0, 161, 255)");
$47a4b45281b81a8b$var$K.Factory.addGetterSetter($47a4b45281b81a8b$var$W, "anchorStrokeWidth", 1, (0, $47a4b45281b81a8b$var$Vt.getNumberValidator)());
$47a4b45281b81a8b$var$K.Factory.addGetterSetter($47a4b45281b81a8b$var$W, "anchorFill", "white");
$47a4b45281b81a8b$var$K.Factory.addGetterSetter($47a4b45281b81a8b$var$W, "anchorCornerRadius", 0, (0, $47a4b45281b81a8b$var$Vt.getNumberValidator)());
$47a4b45281b81a8b$var$K.Factory.addGetterSetter($47a4b45281b81a8b$var$W, "borderStroke", "rgb(0, 161, 255)");
$47a4b45281b81a8b$var$K.Factory.addGetterSetter($47a4b45281b81a8b$var$W, "borderStrokeWidth", 1, (0, $47a4b45281b81a8b$var$Vt.getNumberValidator)());
$47a4b45281b81a8b$var$K.Factory.addGetterSetter($47a4b45281b81a8b$var$W, "borderDash");
$47a4b45281b81a8b$var$K.Factory.addGetterSetter($47a4b45281b81a8b$var$W, "keepRatio", !0);
$47a4b45281b81a8b$var$K.Factory.addGetterSetter($47a4b45281b81a8b$var$W, "shiftBehavior", "default");
$47a4b45281b81a8b$var$K.Factory.addGetterSetter($47a4b45281b81a8b$var$W, "centeredScaling", !1);
$47a4b45281b81a8b$var$K.Factory.addGetterSetter($47a4b45281b81a8b$var$W, "ignoreStroke", !1);
$47a4b45281b81a8b$var$K.Factory.addGetterSetter($47a4b45281b81a8b$var$W, "padding", 0, (0, $47a4b45281b81a8b$var$Vt.getNumberValidator)());
$47a4b45281b81a8b$var$K.Factory.addGetterSetter($47a4b45281b81a8b$var$W, "nodes");
$47a4b45281b81a8b$var$K.Factory.addGetterSetter($47a4b45281b81a8b$var$W, "node");
$47a4b45281b81a8b$var$K.Factory.addGetterSetter($47a4b45281b81a8b$var$W, "boundBoxFunc");
$47a4b45281b81a8b$var$K.Factory.addGetterSetter($47a4b45281b81a8b$var$W, "anchorDragBoundFunc");
$47a4b45281b81a8b$var$K.Factory.addGetterSetter($47a4b45281b81a8b$var$W, "anchorStyleFunc");
$47a4b45281b81a8b$var$K.Factory.addGetterSetter($47a4b45281b81a8b$var$W, "shouldOverdrawWholeArea", !1);
$47a4b45281b81a8b$var$K.Factory.addGetterSetter($47a4b45281b81a8b$var$W, "useSingleNodeRotation", !0);
$47a4b45281b81a8b$var$K.Factory.backCompat($47a4b45281b81a8b$var$W, {
    lineEnabled: "borderEnabled",
    rotateHandlerOffset: "rotateAnchorOffset",
    enabledHandlers: "enabledAnchors"
});
var $47a4b45281b81a8b$var$li = {};
Object.defineProperty($47a4b45281b81a8b$var$li, "__esModule", {
    value: !0
});
$47a4b45281b81a8b$var$li.Wedge = void 0;
const $47a4b45281b81a8b$var$hi = $47a4b45281b81a8b$var$V, $47a4b45281b81a8b$var$qa = $47a4b45281b81a8b$var$ct, $47a4b45281b81a8b$var$Ja = $47a4b45281b81a8b$var$H, $47a4b45281b81a8b$var$Rr = $47a4b45281b81a8b$var$L, $47a4b45281b81a8b$var$Qa = $47a4b45281b81a8b$var$H;
class $47a4b45281b81a8b$var$Ft extends $47a4b45281b81a8b$var$qa.Shape {
    _sceneFunc(t) {
        t.beginPath(), t.arc(0, 0, this.radius(), 0, $47a4b45281b81a8b$var$Ja.Konva.getAngle(this.angle()), this.clockwise()), t.lineTo(0, 0), t.closePath(), t.fillStrokeShape(this);
    }
    getWidth() {
        return this.radius() * 2;
    }
    getHeight() {
        return this.radius() * 2;
    }
    setWidth(t) {
        this.radius(t / 2);
    }
    setHeight(t) {
        this.radius(t / 2);
    }
}
$47a4b45281b81a8b$var$li.Wedge = $47a4b45281b81a8b$var$Ft;
$47a4b45281b81a8b$var$Ft.prototype.className = "Wedge";
$47a4b45281b81a8b$var$Ft.prototype._centroid = !0;
$47a4b45281b81a8b$var$Ft.prototype._attrsAffectingSize = [
    "radius"
];
(0, $47a4b45281b81a8b$var$Qa._registerNode)($47a4b45281b81a8b$var$Ft);
$47a4b45281b81a8b$var$hi.Factory.addGetterSetter($47a4b45281b81a8b$var$Ft, "radius", 0, (0, $47a4b45281b81a8b$var$Rr.getNumberValidator)());
$47a4b45281b81a8b$var$hi.Factory.addGetterSetter($47a4b45281b81a8b$var$Ft, "angle", 0, (0, $47a4b45281b81a8b$var$Rr.getNumberValidator)());
$47a4b45281b81a8b$var$hi.Factory.addGetterSetter($47a4b45281b81a8b$var$Ft, "clockwise", !1);
$47a4b45281b81a8b$var$hi.Factory.backCompat($47a4b45281b81a8b$var$Ft, {
    angleDeg: "angle",
    getAngleDeg: "getAngle",
    setAngleDeg: "setAngle"
});
var $47a4b45281b81a8b$var$ci = {};
Object.defineProperty($47a4b45281b81a8b$var$ci, "__esModule", {
    value: !0
});
$47a4b45281b81a8b$var$ci.Blur = void 0;
const $47a4b45281b81a8b$var$Nn = $47a4b45281b81a8b$var$V, $47a4b45281b81a8b$var$Za = $47a4b45281b81a8b$var$et, $47a4b45281b81a8b$var$to = $47a4b45281b81a8b$var$L;
function $47a4b45281b81a8b$var$Un() {
    this.r = 0, this.g = 0, this.b = 0, this.a = 0, this.next = null;
}
const $47a4b45281b81a8b$var$eo = [
    512,
    512,
    456,
    512,
    328,
    456,
    335,
    512,
    405,
    328,
    271,
    456,
    388,
    335,
    292,
    512,
    454,
    405,
    364,
    328,
    298,
    271,
    496,
    456,
    420,
    388,
    360,
    335,
    312,
    292,
    273,
    512,
    482,
    454,
    428,
    405,
    383,
    364,
    345,
    328,
    312,
    298,
    284,
    271,
    259,
    496,
    475,
    456,
    437,
    420,
    404,
    388,
    374,
    360,
    347,
    335,
    323,
    312,
    302,
    292,
    282,
    273,
    265,
    512,
    497,
    482,
    468,
    454,
    441,
    428,
    417,
    405,
    394,
    383,
    373,
    364,
    354,
    345,
    337,
    328,
    320,
    312,
    305,
    298,
    291,
    284,
    278,
    271,
    265,
    259,
    507,
    496,
    485,
    475,
    465,
    456,
    446,
    437,
    428,
    420,
    412,
    404,
    396,
    388,
    381,
    374,
    367,
    360,
    354,
    347,
    341,
    335,
    329,
    323,
    318,
    312,
    307,
    302,
    297,
    292,
    287,
    282,
    278,
    273,
    269,
    265,
    261,
    512,
    505,
    497,
    489,
    482,
    475,
    468,
    461,
    454,
    447,
    441,
    435,
    428,
    422,
    417,
    411,
    405,
    399,
    394,
    389,
    383,
    378,
    373,
    368,
    364,
    359,
    354,
    350,
    345,
    341,
    337,
    332,
    328,
    324,
    320,
    316,
    312,
    309,
    305,
    301,
    298,
    294,
    291,
    287,
    284,
    281,
    278,
    274,
    271,
    268,
    265,
    262,
    259,
    257,
    507,
    501,
    496,
    491,
    485,
    480,
    475,
    470,
    465,
    460,
    456,
    451,
    446,
    442,
    437,
    433,
    428,
    424,
    420,
    416,
    412,
    408,
    404,
    400,
    396,
    392,
    388,
    385,
    381,
    377,
    374,
    370,
    367,
    363,
    360,
    357,
    354,
    350,
    347,
    344,
    341,
    338,
    335,
    332,
    329,
    326,
    323,
    320,
    318,
    315,
    312,
    310,
    307,
    304,
    302,
    299,
    297,
    294,
    292,
    289,
    287,
    285,
    282,
    280,
    278,
    275,
    273,
    271,
    269,
    267,
    265,
    263,
    261,
    259
], $47a4b45281b81a8b$var$io = [
    9,
    11,
    12,
    13,
    13,
    14,
    14,
    15,
    15,
    15,
    15,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24
];
function $47a4b45281b81a8b$var$no(l, t) {
    const e = l.data, i = l.width, n = l.height;
    let r, s, a, o, h, c, y, g, u, f, _, v, C, k, d, p, b, w, P, S, E, m, T, A;
    const F = t + t + 1, O = i - 1, R = n - 1, N = t + 1, z = N * (N + 1) / 2, Q = new $47a4b45281b81a8b$var$Un(), ut = $47a4b45281b81a8b$var$eo[t], U = $47a4b45281b81a8b$var$io[t];
    let it = null, I = Q, B = null, X = null;
    for(a = 1; a < F; a++)I = I.next = new $47a4b45281b81a8b$var$Un(), a === N && (it = I);
    for(I.next = Q, y = c = 0, s = 0; s < n; s++){
        for(p = b = w = P = g = u = f = _ = 0, v = N * (S = e[c]), C = N * (E = e[c + 1]), k = N * (m = e[c + 2]), d = N * (T = e[c + 3]), g += z * S, u += z * E, f += z * m, _ += z * T, I = Q, a = 0; a < N; a++)I.r = S, I.g = E, I.b = m, I.a = T, I = I.next;
        for(a = 1; a < N; a++)o = c + ((O < a ? O : a) << 2), g += (I.r = S = e[o]) * (A = N - a), u += (I.g = E = e[o + 1]) * A, f += (I.b = m = e[o + 2]) * A, _ += (I.a = T = e[o + 3]) * A, p += S, b += E, w += m, P += T, I = I.next;
        for(B = Q, X = it, r = 0; r < i; r++)e[c + 3] = T = _ * ut >> U, T !== 0 ? (T = 255 / T, e[c] = (g * ut >> U) * T, e[c + 1] = (u * ut >> U) * T, e[c + 2] = (f * ut >> U) * T) : e[c] = e[c + 1] = e[c + 2] = 0, g -= v, u -= C, f -= k, _ -= d, v -= B.r, C -= B.g, k -= B.b, d -= B.a, o = y + ((o = r + t + 1) < O ? o : O) << 2, p += B.r = e[o], b += B.g = e[o + 1], w += B.b = e[o + 2], P += B.a = e[o + 3], g += p, u += b, f += w, _ += P, B = B.next, v += S = X.r, C += E = X.g, k += m = X.b, d += T = X.a, p -= S, b -= E, w -= m, P -= T, X = X.next, c += 4;
        y += i;
    }
    for(r = 0; r < i; r++){
        for(b = w = P = p = u = f = _ = g = 0, c = r << 2, v = N * (S = e[c]), C = N * (E = e[c + 1]), k = N * (m = e[c + 2]), d = N * (T = e[c + 3]), g += z * S, u += z * E, f += z * m, _ += z * T, I = Q, a = 0; a < N; a++)I.r = S, I.g = E, I.b = m, I.a = T, I = I.next;
        for(h = i, a = 1; a <= t; a++)c = h + r << 2, g += (I.r = S = e[c]) * (A = N - a), u += (I.g = E = e[c + 1]) * A, f += (I.b = m = e[c + 2]) * A, _ += (I.a = T = e[c + 3]) * A, p += S, b += E, w += m, P += T, I = I.next, a < R && (h += i);
        for(c = r, B = Q, X = it, s = 0; s < n; s++)o = c << 2, e[o + 3] = T = _ * ut >> U, T > 0 ? (T = 255 / T, e[o] = (g * ut >> U) * T, e[o + 1] = (u * ut >> U) * T, e[o + 2] = (f * ut >> U) * T) : e[o] = e[o + 1] = e[o + 2] = 0, g -= v, u -= C, f -= k, _ -= d, v -= B.r, C -= B.g, k -= B.b, d -= B.a, o = r + ((o = s + N) < R ? o : R) * i << 2, g += p += B.r = e[o], u += b += B.g = e[o + 1], f += w += B.b = e[o + 2], _ += P += B.a = e[o + 3], B = B.next, v += S = X.r, C += E = X.g, k += m = X.b, d += T = X.a, p -= S, b -= E, w -= m, P -= T, X = X.next, c += i;
    }
}
const $47a4b45281b81a8b$var$ro = function(t) {
    const e = Math.round(this.blurRadius());
    e > 0 && $47a4b45281b81a8b$var$no(t, e);
};
$47a4b45281b81a8b$var$ci.Blur = $47a4b45281b81a8b$var$ro;
$47a4b45281b81a8b$var$Nn.Factory.addGetterSetter($47a4b45281b81a8b$var$Za.Node, "blurRadius", 0, (0, $47a4b45281b81a8b$var$to.getNumberValidator)(), $47a4b45281b81a8b$var$Nn.Factory.afterSetFilter);
var $47a4b45281b81a8b$var$di = {};
Object.defineProperty($47a4b45281b81a8b$var$di, "__esModule", {
    value: !0
});
$47a4b45281b81a8b$var$di.Brighten = void 0;
const $47a4b45281b81a8b$var$Bn = $47a4b45281b81a8b$var$V, $47a4b45281b81a8b$var$so = $47a4b45281b81a8b$var$et, $47a4b45281b81a8b$var$ao = $47a4b45281b81a8b$var$L, $47a4b45281b81a8b$var$oo = function(l) {
    const t = this.brightness() * 255, e = l.data, i = e.length;
    for(let n = 0; n < i; n += 4)e[n] += t, e[n + 1] += t, e[n + 2] += t;
};
$47a4b45281b81a8b$var$di.Brighten = $47a4b45281b81a8b$var$oo;
$47a4b45281b81a8b$var$Bn.Factory.addGetterSetter($47a4b45281b81a8b$var$so.Node, "brightness", 0, (0, $47a4b45281b81a8b$var$ao.getNumberValidator)(), $47a4b45281b81a8b$var$Bn.Factory.afterSetFilter);
var $47a4b45281b81a8b$var$ui = {};
Object.defineProperty($47a4b45281b81a8b$var$ui, "__esModule", {
    value: !0
});
$47a4b45281b81a8b$var$ui.Contrast = void 0;
const $47a4b45281b81a8b$var$Hn = $47a4b45281b81a8b$var$V, $47a4b45281b81a8b$var$lo = $47a4b45281b81a8b$var$et, $47a4b45281b81a8b$var$ho = $47a4b45281b81a8b$var$L, $47a4b45281b81a8b$var$co = function(l) {
    const t = Math.pow((this.contrast() + 100) / 100, 2), e = l.data, i = e.length;
    let n = 150, r = 150, s = 150;
    for(let a = 0; a < i; a += 4)n = e[a], r = e[a + 1], s = e[a + 2], n /= 255, n -= 0.5, n *= t, n += 0.5, n *= 255, r /= 255, r -= 0.5, r *= t, r += 0.5, r *= 255, s /= 255, s -= 0.5, s *= t, s += 0.5, s *= 255, n = n < 0 ? 0 : n > 255 ? 255 : n, r = r < 0 ? 0 : r > 255 ? 255 : r, s = s < 0 ? 0 : s > 255 ? 255 : s, e[a] = n, e[a + 1] = r, e[a + 2] = s;
};
$47a4b45281b81a8b$var$ui.Contrast = $47a4b45281b81a8b$var$co;
$47a4b45281b81a8b$var$Hn.Factory.addGetterSetter($47a4b45281b81a8b$var$lo.Node, "contrast", 0, (0, $47a4b45281b81a8b$var$ho.getNumberValidator)(), $47a4b45281b81a8b$var$Hn.Factory.afterSetFilter);
var $47a4b45281b81a8b$var$gi = {};
Object.defineProperty($47a4b45281b81a8b$var$gi, "__esModule", {
    value: !0
});
$47a4b45281b81a8b$var$gi.Emboss = void 0;
const $47a4b45281b81a8b$var$Gt = $47a4b45281b81a8b$var$V, $47a4b45281b81a8b$var$fi = $47a4b45281b81a8b$var$et, $47a4b45281b81a8b$var$uo = $47a4b45281b81a8b$var$nt, $47a4b45281b81a8b$var$Fr = $47a4b45281b81a8b$var$L, $47a4b45281b81a8b$var$go = function(l) {
    const t = this.embossStrength() * 10, e = this.embossWhiteLevel() * 255, i = this.embossDirection(), n = this.embossBlend(), r = l.data, s = l.width, a = l.height, o = s * 4;
    let h = 0, c = 0, y = a;
    switch(i){
        case "top-left":
            h = -1, c = -1;
            break;
        case "top":
            h = -1, c = 0;
            break;
        case "top-right":
            h = -1, c = 1;
            break;
        case "right":
            h = 0, c = 1;
            break;
        case "bottom-right":
            h = 1, c = 1;
            break;
        case "bottom":
            h = 1, c = 0;
            break;
        case "bottom-left":
            h = 1, c = -1;
            break;
        case "left":
            h = 0, c = -1;
            break;
        default:
            $47a4b45281b81a8b$var$uo.Util.error("Unknown emboss direction: " + i);
    }
    do {
        const g = (y - 1) * o;
        let u = h;
        y + u < 1 && (u = 0), y + u > a && (u = 0);
        const f = (y - 1 + u) * s * 4;
        let _ = s;
        do {
            const v = g + (_ - 1) * 4;
            let C = c;
            _ + C < 1 && (C = 0), _ + C > s && (C = 0);
            const k = f + (_ - 1 + C) * 4, d = r[v] - r[k], p = r[v + 1] - r[k + 1], b = r[v + 2] - r[k + 2];
            let w = d;
            const P = w > 0 ? w : -w, S = p > 0 ? p : -p, E = b > 0 ? b : -b;
            if (S > P && (w = p), E > P && (w = b), w *= t, n) {
                const m = r[v] + w, T = r[v + 1] + w, A = r[v + 2] + w;
                r[v] = m > 255 ? 255 : m < 0 ? 0 : m, r[v + 1] = T > 255 ? 255 : T < 0 ? 0 : T, r[v + 2] = A > 255 ? 255 : A < 0 ? 0 : A;
            } else {
                let m = e - w;
                m < 0 ? m = 0 : m > 255 && (m = 255), r[v] = r[v + 1] = r[v + 2] = m;
            }
        }while (--_);
    }while (--y);
};
$47a4b45281b81a8b$var$gi.Emboss = $47a4b45281b81a8b$var$go;
$47a4b45281b81a8b$var$Gt.Factory.addGetterSetter($47a4b45281b81a8b$var$fi.Node, "embossStrength", 0.5, (0, $47a4b45281b81a8b$var$Fr.getNumberValidator)(), $47a4b45281b81a8b$var$Gt.Factory.afterSetFilter);
$47a4b45281b81a8b$var$Gt.Factory.addGetterSetter($47a4b45281b81a8b$var$fi.Node, "embossWhiteLevel", 0.5, (0, $47a4b45281b81a8b$var$Fr.getNumberValidator)(), $47a4b45281b81a8b$var$Gt.Factory.afterSetFilter);
$47a4b45281b81a8b$var$Gt.Factory.addGetterSetter($47a4b45281b81a8b$var$fi.Node, "embossDirection", "top-left", void 0, $47a4b45281b81a8b$var$Gt.Factory.afterSetFilter);
$47a4b45281b81a8b$var$Gt.Factory.addGetterSetter($47a4b45281b81a8b$var$fi.Node, "embossBlend", !1, void 0, $47a4b45281b81a8b$var$Gt.Factory.afterSetFilter);
var $47a4b45281b81a8b$var$pi = {};
Object.defineProperty($47a4b45281b81a8b$var$pi, "__esModule", {
    value: !0
});
$47a4b45281b81a8b$var$pi.Enhance = void 0;
const $47a4b45281b81a8b$var$Vn = $47a4b45281b81a8b$var$V, $47a4b45281b81a8b$var$fo = $47a4b45281b81a8b$var$et, $47a4b45281b81a8b$var$po = $47a4b45281b81a8b$var$L;
function $47a4b45281b81a8b$var$Hi(l, t, e, i, n) {
    const r = e - t, s = n - i;
    if (r === 0) return i + s / 2;
    if (s === 0) return i;
    let a = (l - t) / r;
    return a = s * a + i, a;
}
const $47a4b45281b81a8b$var$mo = function(l) {
    const t = l.data, e = t.length;
    let i = t[0], n = i, r, s = t[1], a = s, o, h = t[2], c = h, y;
    const g = this.enhance();
    if (g === 0) return;
    for(let w = 0; w < e; w += 4)r = t[w + 0], r < i ? i = r : r > n && (n = r), o = t[w + 1], o < s ? s = o : o > a && (a = o), y = t[w + 2], y < h ? h = y : y > c && (c = y);
    n === i && (n = 255, i = 0), a === s && (a = 255, s = 0), c === h && (c = 255, h = 0);
    let u, f, _, v, C, k, d, p, b;
    g > 0 ? (f = n + g * (255 - n), _ = i - g * (i - 0), C = a + g * (255 - a), k = s - g * (s - 0), p = c + g * (255 - c), b = h - g * (h - 0)) : (u = (n + i) * 0.5, f = n + g * (n - u), _ = i + g * (i - u), v = (a + s) * 0.5, C = a + g * (a - v), k = s + g * (s - v), d = (c + h) * 0.5, p = c + g * (c - d), b = h + g * (h - d));
    for(let w = 0; w < e; w += 4)t[w + 0] = $47a4b45281b81a8b$var$Hi(t[w + 0], i, n, _, f), t[w + 1] = $47a4b45281b81a8b$var$Hi(t[w + 1], s, a, k, C), t[w + 2] = $47a4b45281b81a8b$var$Hi(t[w + 2], h, c, b, p);
};
$47a4b45281b81a8b$var$pi.Enhance = $47a4b45281b81a8b$var$mo;
$47a4b45281b81a8b$var$Vn.Factory.addGetterSetter($47a4b45281b81a8b$var$fo.Node, "enhance", 0, (0, $47a4b45281b81a8b$var$po.getNumberValidator)(), $47a4b45281b81a8b$var$Vn.Factory.afterSetFilter);
var $47a4b45281b81a8b$var$mi = {};
Object.defineProperty($47a4b45281b81a8b$var$mi, "__esModule", {
    value: !0
});
$47a4b45281b81a8b$var$mi.Grayscale = void 0;
const $47a4b45281b81a8b$var$yo = function(l) {
    const t = l.data, e = t.length;
    for(let i = 0; i < e; i += 4){
        const n = 0.34 * t[i] + 0.5 * t[i + 1] + 0.16 * t[i + 2];
        t[i] = n, t[i + 1] = n, t[i + 2] = n;
    }
};
$47a4b45281b81a8b$var$mi.Grayscale = $47a4b45281b81a8b$var$yo;
var $47a4b45281b81a8b$var$yi = {};
Object.defineProperty($47a4b45281b81a8b$var$yi, "__esModule", {
    value: !0
});
$47a4b45281b81a8b$var$yi.HSL = void 0;
const $47a4b45281b81a8b$var$oe = $47a4b45281b81a8b$var$V, $47a4b45281b81a8b$var$hn = $47a4b45281b81a8b$var$et, $47a4b45281b81a8b$var$cn = $47a4b45281b81a8b$var$L;
$47a4b45281b81a8b$var$oe.Factory.addGetterSetter($47a4b45281b81a8b$var$hn.Node, "hue", 0, (0, $47a4b45281b81a8b$var$cn.getNumberValidator)(), $47a4b45281b81a8b$var$oe.Factory.afterSetFilter);
$47a4b45281b81a8b$var$oe.Factory.addGetterSetter($47a4b45281b81a8b$var$hn.Node, "saturation", 0, (0, $47a4b45281b81a8b$var$cn.getNumberValidator)(), $47a4b45281b81a8b$var$oe.Factory.afterSetFilter);
$47a4b45281b81a8b$var$oe.Factory.addGetterSetter($47a4b45281b81a8b$var$hn.Node, "luminance", 0, (0, $47a4b45281b81a8b$var$cn.getNumberValidator)(), $47a4b45281b81a8b$var$oe.Factory.afterSetFilter);
const $47a4b45281b81a8b$var$_o = function(l) {
    const t = l.data, e = t.length, i = 1, n = Math.pow(2, this.saturation()), r = Math.abs(this.hue() + 360) % 360, s = this.luminance() * 127, a = i * n * Math.cos(r * Math.PI / 180), o = i * n * Math.sin(r * Math.PI / 180), h = 0.299 * i + 0.701 * a + 0.167 * o, c = 0.587 * i - 0.587 * a + 0.33 * o, y = 0.114 * i - 0.114 * a - 0.497 * o, g = 0.299 * i - 0.299 * a - 0.328 * o, u = 0.587 * i + 0.413 * a + 0.035 * o, f = 0.114 * i - 0.114 * a + 0.293 * o, _ = 0.299 * i - 0.3 * a + 1.25 * o, v = 0.587 * i - 0.586 * a - 1.05 * o, C = 0.114 * i + 0.886 * a - 0.2 * o;
    let k, d, p, b;
    for(let w = 0; w < e; w += 4)k = t[w + 0], d = t[w + 1], p = t[w + 2], b = t[w + 3], t[w + 0] = h * k + c * d + y * p + s, t[w + 1] = g * k + u * d + f * p + s, t[w + 2] = _ * k + v * d + C * p + s, t[w + 3] = b;
};
$47a4b45281b81a8b$var$yi.HSL = $47a4b45281b81a8b$var$_o;
var $47a4b45281b81a8b$var$_i = {};
Object.defineProperty($47a4b45281b81a8b$var$_i, "__esModule", {
    value: !0
});
$47a4b45281b81a8b$var$_i.HSV = void 0;
const $47a4b45281b81a8b$var$le = $47a4b45281b81a8b$var$V, $47a4b45281b81a8b$var$dn = $47a4b45281b81a8b$var$et, $47a4b45281b81a8b$var$un = $47a4b45281b81a8b$var$L, $47a4b45281b81a8b$var$vo = function(l) {
    const t = l.data, e = t.length, i = Math.pow(2, this.value()), n = Math.pow(2, this.saturation()), r = Math.abs(this.hue() + 360) % 360, s = i * n * Math.cos(r * Math.PI / 180), a = i * n * Math.sin(r * Math.PI / 180), o = 0.299 * i + 0.701 * s + 0.167 * a, h = 0.587 * i - 0.587 * s + 0.33 * a, c = 0.114 * i - 0.114 * s - 0.497 * a, y = 0.299 * i - 0.299 * s - 0.328 * a, g = 0.587 * i + 0.413 * s + 0.035 * a, u = 0.114 * i - 0.114 * s + 0.293 * a, f = 0.299 * i - 0.3 * s + 1.25 * a, _ = 0.587 * i - 0.586 * s - 1.05 * a, v = 0.114 * i + 0.886 * s - 0.2 * a;
    let C, k, d, p;
    for(let b = 0; b < e; b += 4)C = t[b + 0], k = t[b + 1], d = t[b + 2], p = t[b + 3], t[b + 0] = o * C + h * k + c * d, t[b + 1] = y * C + g * k + u * d, t[b + 2] = f * C + _ * k + v * d, t[b + 3] = p;
};
$47a4b45281b81a8b$var$_i.HSV = $47a4b45281b81a8b$var$vo;
$47a4b45281b81a8b$var$le.Factory.addGetterSetter($47a4b45281b81a8b$var$dn.Node, "hue", 0, (0, $47a4b45281b81a8b$var$un.getNumberValidator)(), $47a4b45281b81a8b$var$le.Factory.afterSetFilter);
$47a4b45281b81a8b$var$le.Factory.addGetterSetter($47a4b45281b81a8b$var$dn.Node, "saturation", 0, (0, $47a4b45281b81a8b$var$un.getNumberValidator)(), $47a4b45281b81a8b$var$le.Factory.afterSetFilter);
$47a4b45281b81a8b$var$le.Factory.addGetterSetter($47a4b45281b81a8b$var$dn.Node, "value", 0, (0, $47a4b45281b81a8b$var$un.getNumberValidator)(), $47a4b45281b81a8b$var$le.Factory.afterSetFilter);
var $47a4b45281b81a8b$var$vi = {};
Object.defineProperty($47a4b45281b81a8b$var$vi, "__esModule", {
    value: !0
});
$47a4b45281b81a8b$var$vi.Invert = void 0;
const $47a4b45281b81a8b$var$bo = function(l) {
    const t = l.data, e = t.length;
    for(let i = 0; i < e; i += 4)t[i] = 255 - t[i], t[i + 1] = 255 - t[i + 1], t[i + 2] = 255 - t[i + 2];
};
$47a4b45281b81a8b$var$vi.Invert = $47a4b45281b81a8b$var$bo;
var $47a4b45281b81a8b$var$bi = {};
Object.defineProperty($47a4b45281b81a8b$var$bi, "__esModule", {
    value: !0
});
$47a4b45281b81a8b$var$bi.Kaleidoscope = void 0;
const $47a4b45281b81a8b$var$Ie = $47a4b45281b81a8b$var$V, $47a4b45281b81a8b$var$Or = $47a4b45281b81a8b$var$et, $47a4b45281b81a8b$var$$n = $47a4b45281b81a8b$var$nt, $47a4b45281b81a8b$var$Dr = $47a4b45281b81a8b$var$L, $47a4b45281b81a8b$var$So = function(l, t, e) {
    const i = l.data, n = t.data, r = l.width, s = l.height, a = e.polarCenterX || r / 2, o = e.polarCenterY || s / 2;
    let h = Math.sqrt(a * a + o * o), c = r - a, y = s - o;
    const g = Math.sqrt(c * c + y * y);
    h = g > h ? g : h;
    const u = s, f = r, _ = 360 / f * Math.PI / 180;
    for(let v = 0; v < f; v += 1){
        const C = Math.sin(v * _), k = Math.cos(v * _);
        for(let d = 0; d < u; d += 1){
            c = Math.floor(a + h * d / u * k), y = Math.floor(o + h * d / u * C);
            let p = (y * r + c) * 4;
            const b = i[p + 0], w = i[p + 1], P = i[p + 2], S = i[p + 3];
            p = (v + d * r) * 4, n[p + 0] = b, n[p + 1] = w, n[p + 2] = P, n[p + 3] = S;
        }
    }
}, $47a4b45281b81a8b$var$Co = function(l, t, e) {
    const i = l.data, n = t.data, r = l.width, s = l.height, a = e.polarCenterX || r / 2, o = e.polarCenterY || s / 2;
    let h = Math.sqrt(a * a + o * o), c = r - a, y = s - o;
    const g = Math.sqrt(c * c + y * y);
    h = g > h ? g : h;
    const u = s, f = r, _ = e.polarRotation || 0;
    let v, C;
    for(c = 0; c < r; c += 1)for(y = 0; y < s; y += 1){
        const k = c - a, d = y - o, p = Math.sqrt(k * k + d * d) * u / h;
        let b = (Math.atan2(d, k) * 180 / Math.PI + 360 + _) % 360;
        b = b * f / 360, v = Math.floor(b), C = Math.floor(p);
        let w = (C * r + v) * 4;
        const P = i[w + 0], S = i[w + 1], E = i[w + 2], m = i[w + 3];
        w = (y * r + c) * 4, n[w + 0] = P, n[w + 1] = S, n[w + 2] = E, n[w + 3] = m;
    }
}, $47a4b45281b81a8b$var$wo = function(l) {
    const t = l.width, e = l.height;
    let i, n, r, s, a, o, h, c, y, g, u = Math.round(this.kaleidoscopePower());
    const f = Math.round(this.kaleidoscopeAngle()), _ = Math.floor(t * (f % 360) / 360);
    if (u < 1) return;
    const v = $47a4b45281b81a8b$var$$n.Util.createCanvasElement();
    v.width = t, v.height = e;
    const C = v.getContext("2d").getImageData(0, 0, t, e);
    $47a4b45281b81a8b$var$$n.Util.releaseCanvas(v), $47a4b45281b81a8b$var$So(l, C, {
        polarCenterX: t / 2,
        polarCenterY: e / 2
    });
    let k = t / Math.pow(2, u);
    for(; k <= 8;)k = k * 2, u -= 1;
    k = Math.ceil(k);
    let d = k, p = 0, b = d, w = 1;
    for(_ + k > t && (p = d, b = 0, w = -1), n = 0; n < e; n += 1)for(i = p; i !== b; i += w)r = Math.round(i + _) % t, y = (t * n + r) * 4, a = C.data[y + 0], o = C.data[y + 1], h = C.data[y + 2], c = C.data[y + 3], g = (t * n + i) * 4, C.data[g + 0] = a, C.data[g + 1] = o, C.data[g + 2] = h, C.data[g + 3] = c;
    for(n = 0; n < e; n += 1)for(d = Math.floor(k), s = 0; s < u; s += 1){
        for(i = 0; i < d + 1; i += 1)y = (t * n + i) * 4, a = C.data[y + 0], o = C.data[y + 1], h = C.data[y + 2], c = C.data[y + 3], g = (t * n + d * 2 - i - 1) * 4, C.data[g + 0] = a, C.data[g + 1] = o, C.data[g + 2] = h, C.data[g + 3] = c;
        d *= 2;
    }
    $47a4b45281b81a8b$var$Co(C, l, {
        polarRotation: 0
    });
};
$47a4b45281b81a8b$var$bi.Kaleidoscope = $47a4b45281b81a8b$var$wo;
$47a4b45281b81a8b$var$Ie.Factory.addGetterSetter($47a4b45281b81a8b$var$Or.Node, "kaleidoscopePower", 2, (0, $47a4b45281b81a8b$var$Dr.getNumberValidator)(), $47a4b45281b81a8b$var$Ie.Factory.afterSetFilter);
$47a4b45281b81a8b$var$Ie.Factory.addGetterSetter($47a4b45281b81a8b$var$Or.Node, "kaleidoscopeAngle", 0, (0, $47a4b45281b81a8b$var$Dr.getNumberValidator)(), $47a4b45281b81a8b$var$Ie.Factory.afterSetFilter);
var $47a4b45281b81a8b$var$Si = {};
Object.defineProperty($47a4b45281b81a8b$var$Si, "__esModule", {
    value: !0
});
$47a4b45281b81a8b$var$Si.Mask = void 0;
const $47a4b45281b81a8b$var$zn = $47a4b45281b81a8b$var$V, $47a4b45281b81a8b$var$xo = $47a4b45281b81a8b$var$et, $47a4b45281b81a8b$var$To = $47a4b45281b81a8b$var$L;
function $47a4b45281b81a8b$var$Fe(l, t, e) {
    let i = (e * l.width + t) * 4;
    const n = [];
    return n.push(l.data[i++], l.data[i++], l.data[i++], l.data[i++]), n;
}
function $47a4b45281b81a8b$var$ve(l, t) {
    return Math.sqrt(Math.pow(l[0] - t[0], 2) + Math.pow(l[1] - t[1], 2) + Math.pow(l[2] - t[2], 2));
}
function $47a4b45281b81a8b$var$ko(l) {
    const t = [
        0,
        0,
        0
    ];
    for(let e = 0; e < l.length; e++)t[0] += l[e][0], t[1] += l[e][1], t[2] += l[e][2];
    return t[0] /= l.length, t[1] /= l.length, t[2] /= l.length, t;
}
function $47a4b45281b81a8b$var$Eo(l, t) {
    const e = $47a4b45281b81a8b$var$Fe(l, 0, 0), i = $47a4b45281b81a8b$var$Fe(l, l.width - 1, 0), n = $47a4b45281b81a8b$var$Fe(l, 0, l.height - 1), r = $47a4b45281b81a8b$var$Fe(l, l.width - 1, l.height - 1), s = t || 10;
    if ($47a4b45281b81a8b$var$ve(e, i) < s && $47a4b45281b81a8b$var$ve(i, r) < s && $47a4b45281b81a8b$var$ve(r, n) < s && $47a4b45281b81a8b$var$ve(n, e) < s) {
        const a = $47a4b45281b81a8b$var$ko([
            i,
            e,
            r,
            n
        ]), o = [];
        for(let h = 0; h < l.width * l.height; h++){
            const c = $47a4b45281b81a8b$var$ve(a, [
                l.data[h * 4],
                l.data[h * 4 + 1],
                l.data[h * 4 + 2]
            ]);
            o[h] = c < s ? 0 : 255;
        }
        return o;
    }
}
function $47a4b45281b81a8b$var$Ao(l, t) {
    for(let e = 0; e < l.width * l.height; e++)l.data[4 * e + 3] = t[e];
}
function $47a4b45281b81a8b$var$Po(l, t, e) {
    const i = [
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1
    ], n = Math.round(Math.sqrt(i.length)), r = Math.floor(n / 2), s = [];
    for(let a = 0; a < e; a++)for(let o = 0; o < t; o++){
        const h = a * t + o;
        let c = 0;
        for(let y = 0; y < n; y++)for(let g = 0; g < n; g++){
            const u = a + y - r, f = o + g - r;
            if (u >= 0 && u < e && f >= 0 && f < t) {
                const _ = u * t + f, v = i[y * n + g];
                c += l[_] * v;
            }
        }
        s[h] = c === 2040 ? 255 : 0;
    }
    return s;
}
function $47a4b45281b81a8b$var$Mo(l, t, e) {
    const i = [
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
    ], n = Math.round(Math.sqrt(i.length)), r = Math.floor(n / 2), s = [];
    for(let a = 0; a < e; a++)for(let o = 0; o < t; o++){
        const h = a * t + o;
        let c = 0;
        for(let y = 0; y < n; y++)for(let g = 0; g < n; g++){
            const u = a + y - r, f = o + g - r;
            if (u >= 0 && u < e && f >= 0 && f < t) {
                const _ = u * t + f, v = i[y * n + g];
                c += l[_] * v;
            }
        }
        s[h] = c >= 1020 ? 255 : 0;
    }
    return s;
}
function $47a4b45281b81a8b$var$Ro(l, t, e) {
    const i = [
        0.1111111111111111,
        0.1111111111111111,
        0.1111111111111111,
        0.1111111111111111,
        0.1111111111111111,
        0.1111111111111111,
        0.1111111111111111,
        0.1111111111111111,
        0.1111111111111111
    ], n = Math.round(Math.sqrt(i.length)), r = Math.floor(n / 2), s = [];
    for(let a = 0; a < e; a++)for(let o = 0; o < t; o++){
        const h = a * t + o;
        let c = 0;
        for(let y = 0; y < n; y++)for(let g = 0; g < n; g++){
            const u = a + y - r, f = o + g - r;
            if (u >= 0 && u < e && f >= 0 && f < t) {
                const _ = u * t + f, v = i[y * n + g];
                c += l[_] * v;
            }
        }
        s[h] = c;
    }
    return s;
}
const $47a4b45281b81a8b$var$Fo = function(l) {
    const t = this.threshold();
    let e = $47a4b45281b81a8b$var$Eo(l, t);
    return e && (e = $47a4b45281b81a8b$var$Po(e, l.width, l.height), e = $47a4b45281b81a8b$var$Mo(e, l.width, l.height), e = $47a4b45281b81a8b$var$Ro(e, l.width, l.height), $47a4b45281b81a8b$var$Ao(l, e)), l;
};
$47a4b45281b81a8b$var$Si.Mask = $47a4b45281b81a8b$var$Fo;
$47a4b45281b81a8b$var$zn.Factory.addGetterSetter($47a4b45281b81a8b$var$xo.Node, "threshold", 0, (0, $47a4b45281b81a8b$var$To.getNumberValidator)(), $47a4b45281b81a8b$var$zn.Factory.afterSetFilter);
var $47a4b45281b81a8b$var$Ci = {};
Object.defineProperty($47a4b45281b81a8b$var$Ci, "__esModule", {
    value: !0
});
$47a4b45281b81a8b$var$Ci.Noise = void 0;
const $47a4b45281b81a8b$var$Wn = $47a4b45281b81a8b$var$V, $47a4b45281b81a8b$var$Oo = $47a4b45281b81a8b$var$et, $47a4b45281b81a8b$var$Do = $47a4b45281b81a8b$var$L, $47a4b45281b81a8b$var$Lo = function(l) {
    const t = this.noise() * 255, e = l.data, i = e.length, n = t / 2;
    for(let r = 0; r < i; r += 4)e[r + 0] += n - 2 * n * Math.random(), e[r + 1] += n - 2 * n * Math.random(), e[r + 2] += n - 2 * n * Math.random();
};
$47a4b45281b81a8b$var$Ci.Noise = $47a4b45281b81a8b$var$Lo;
$47a4b45281b81a8b$var$Wn.Factory.addGetterSetter($47a4b45281b81a8b$var$Oo.Node, "noise", 0.2, (0, $47a4b45281b81a8b$var$Do.getNumberValidator)(), $47a4b45281b81a8b$var$Wn.Factory.afterSetFilter);
var $47a4b45281b81a8b$var$wi = {};
Object.defineProperty($47a4b45281b81a8b$var$wi, "__esModule", {
    value: !0
});
$47a4b45281b81a8b$var$wi.Pixelate = void 0;
const $47a4b45281b81a8b$var$Xn = $47a4b45281b81a8b$var$V, $47a4b45281b81a8b$var$Go = $47a4b45281b81a8b$var$nt, $47a4b45281b81a8b$var$Io = $47a4b45281b81a8b$var$et, $47a4b45281b81a8b$var$No = $47a4b45281b81a8b$var$L, $47a4b45281b81a8b$var$Uo = function(l) {
    let t = Math.ceil(this.pixelSize()), e = l.width, i = l.height, n, r, s, a, o, h, c, y = Math.ceil(e / t), g = Math.ceil(i / t), u, f, _, v, C, k, d, p = l.data;
    if (t <= 0) {
        $47a4b45281b81a8b$var$Go.Util.error("pixelSize value can not be <= 0");
        return;
    }
    for(C = 0; C < y; C += 1)for(k = 0; k < g; k += 1){
        for(a = 0, o = 0, h = 0, c = 0, u = C * t, f = u + t, _ = k * t, v = _ + t, d = 0, n = u; n < f; n += 1)if (!(n >= e)) for(r = _; r < v; r += 1)r >= i || (s = (e * r + n) * 4, a += p[s + 0], o += p[s + 1], h += p[s + 2], c += p[s + 3], d += 1);
        for(a = a / d, o = o / d, h = h / d, c = c / d, n = u; n < f; n += 1)if (!(n >= e)) for(r = _; r < v; r += 1)r >= i || (s = (e * r + n) * 4, p[s + 0] = a, p[s + 1] = o, p[s + 2] = h, p[s + 3] = c);
    }
};
$47a4b45281b81a8b$var$wi.Pixelate = $47a4b45281b81a8b$var$Uo;
$47a4b45281b81a8b$var$Xn.Factory.addGetterSetter($47a4b45281b81a8b$var$Io.Node, "pixelSize", 8, (0, $47a4b45281b81a8b$var$No.getNumberValidator)(), $47a4b45281b81a8b$var$Xn.Factory.afterSetFilter);
var $47a4b45281b81a8b$var$xi = {};
Object.defineProperty($47a4b45281b81a8b$var$xi, "__esModule", {
    value: !0
});
$47a4b45281b81a8b$var$xi.Posterize = void 0;
const $47a4b45281b81a8b$var$Kn = $47a4b45281b81a8b$var$V, $47a4b45281b81a8b$var$Bo = $47a4b45281b81a8b$var$et, $47a4b45281b81a8b$var$Ho = $47a4b45281b81a8b$var$L, $47a4b45281b81a8b$var$Vo = function(l) {
    const t = Math.round(this.levels() * 254) + 1, e = l.data, i = e.length, n = 255 / t;
    for(let r = 0; r < i; r += 1)e[r] = Math.floor(e[r] / n) * n;
};
$47a4b45281b81a8b$var$xi.Posterize = $47a4b45281b81a8b$var$Vo;
$47a4b45281b81a8b$var$Kn.Factory.addGetterSetter($47a4b45281b81a8b$var$Bo.Node, "levels", 0.5, (0, $47a4b45281b81a8b$var$Ho.getNumberValidator)(), $47a4b45281b81a8b$var$Kn.Factory.afterSetFilter);
var $47a4b45281b81a8b$var$Ti = {};
Object.defineProperty($47a4b45281b81a8b$var$Ti, "__esModule", {
    value: !0
});
$47a4b45281b81a8b$var$Ti.RGB = void 0;
const $47a4b45281b81a8b$var$Ne = $47a4b45281b81a8b$var$V, $47a4b45281b81a8b$var$gn = $47a4b45281b81a8b$var$et, $47a4b45281b81a8b$var$$o = $47a4b45281b81a8b$var$L, $47a4b45281b81a8b$var$zo = function(l) {
    const t = l.data, e = t.length, i = this.red(), n = this.green(), r = this.blue();
    for(let s = 0; s < e; s += 4){
        const a = (0.34 * t[s] + 0.5 * t[s + 1] + 0.16 * t[s + 2]) / 255;
        t[s] = a * i, t[s + 1] = a * n, t[s + 2] = a * r, t[s + 3] = t[s + 3];
    }
};
$47a4b45281b81a8b$var$Ti.RGB = $47a4b45281b81a8b$var$zo;
$47a4b45281b81a8b$var$Ne.Factory.addGetterSetter($47a4b45281b81a8b$var$gn.Node, "red", 0, function(l) {
    return this._filterUpToDate = !1, l > 255 ? 255 : l < 0 ? 0 : Math.round(l);
});
$47a4b45281b81a8b$var$Ne.Factory.addGetterSetter($47a4b45281b81a8b$var$gn.Node, "green", 0, function(l) {
    return this._filterUpToDate = !1, l > 255 ? 255 : l < 0 ? 0 : Math.round(l);
});
$47a4b45281b81a8b$var$Ne.Factory.addGetterSetter($47a4b45281b81a8b$var$gn.Node, "blue", 0, $47a4b45281b81a8b$var$$o.RGBComponent, $47a4b45281b81a8b$var$Ne.Factory.afterSetFilter);
var $47a4b45281b81a8b$var$ki = {};
Object.defineProperty($47a4b45281b81a8b$var$ki, "__esModule", {
    value: !0
});
$47a4b45281b81a8b$var$ki.RGBA = void 0;
const $47a4b45281b81a8b$var$Ce = $47a4b45281b81a8b$var$V, $47a4b45281b81a8b$var$Ei = $47a4b45281b81a8b$var$et, $47a4b45281b81a8b$var$Wo = $47a4b45281b81a8b$var$L, $47a4b45281b81a8b$var$Xo = function(l) {
    const t = l.data, e = t.length, i = this.red(), n = this.green(), r = this.blue(), s = this.alpha();
    for(let a = 0; a < e; a += 4){
        const o = 1 - s;
        t[a] = i * s + t[a] * o, t[a + 1] = n * s + t[a + 1] * o, t[a + 2] = r * s + t[a + 2] * o;
    }
};
$47a4b45281b81a8b$var$ki.RGBA = $47a4b45281b81a8b$var$Xo;
$47a4b45281b81a8b$var$Ce.Factory.addGetterSetter($47a4b45281b81a8b$var$Ei.Node, "red", 0, function(l) {
    return this._filterUpToDate = !1, l > 255 ? 255 : l < 0 ? 0 : Math.round(l);
});
$47a4b45281b81a8b$var$Ce.Factory.addGetterSetter($47a4b45281b81a8b$var$Ei.Node, "green", 0, function(l) {
    return this._filterUpToDate = !1, l > 255 ? 255 : l < 0 ? 0 : Math.round(l);
});
$47a4b45281b81a8b$var$Ce.Factory.addGetterSetter($47a4b45281b81a8b$var$Ei.Node, "blue", 0, $47a4b45281b81a8b$var$Wo.RGBComponent, $47a4b45281b81a8b$var$Ce.Factory.afterSetFilter);
$47a4b45281b81a8b$var$Ce.Factory.addGetterSetter($47a4b45281b81a8b$var$Ei.Node, "alpha", 1, function(l) {
    return this._filterUpToDate = !1, l > 1 ? 1 : l < 0 ? 0 : l;
});
var $47a4b45281b81a8b$var$Ai = {};
Object.defineProperty($47a4b45281b81a8b$var$Ai, "__esModule", {
    value: !0
});
$47a4b45281b81a8b$var$Ai.Sepia = void 0;
const $47a4b45281b81a8b$var$Ko = function(l) {
    const t = l.data, e = t.length;
    for(let i = 0; i < e; i += 4){
        const n = t[i + 0], r = t[i + 1], s = t[i + 2];
        t[i + 0] = Math.min(255, n * 0.393 + r * 0.769 + s * 0.189), t[i + 1] = Math.min(255, n * 0.349 + r * 0.686 + s * 0.168), t[i + 2] = Math.min(255, n * 0.272 + r * 0.534 + s * 0.131);
    }
};
$47a4b45281b81a8b$var$Ai.Sepia = $47a4b45281b81a8b$var$Ko;
var $47a4b45281b81a8b$var$Pi = {};
Object.defineProperty($47a4b45281b81a8b$var$Pi, "__esModule", {
    value: !0
});
$47a4b45281b81a8b$var$Pi.Solarize = void 0;
const $47a4b45281b81a8b$var$Yo = function(l) {
    const t = l.data, e = l.width, i = l.height, n = e * 4;
    let r = i;
    do {
        const s = (r - 1) * n;
        let a = e;
        do {
            const o = s + (a - 1) * 4;
            let h = t[o], c = t[o + 1], y = t[o + 2];
            h > 127 && (h = 255 - h), c > 127 && (c = 255 - c), y > 127 && (y = 255 - y), t[o] = h, t[o + 1] = c, t[o + 2] = y;
        }while (--a);
    }while (--r);
};
$47a4b45281b81a8b$var$Pi.Solarize = $47a4b45281b81a8b$var$Yo;
var $47a4b45281b81a8b$var$Mi = {};
Object.defineProperty($47a4b45281b81a8b$var$Mi, "__esModule", {
    value: !0
});
$47a4b45281b81a8b$var$Mi.Threshold = void 0;
const $47a4b45281b81a8b$var$Yn = $47a4b45281b81a8b$var$V, $47a4b45281b81a8b$var$jo = $47a4b45281b81a8b$var$et, $47a4b45281b81a8b$var$qo = $47a4b45281b81a8b$var$L, $47a4b45281b81a8b$var$Jo = function(l) {
    const t = this.threshold() * 255, e = l.data, i = e.length;
    for(let n = 0; n < i; n += 1)e[n] = e[n] < t ? 0 : 255;
};
$47a4b45281b81a8b$var$Mi.Threshold = $47a4b45281b81a8b$var$Jo;
$47a4b45281b81a8b$var$Yn.Factory.addGetterSetter($47a4b45281b81a8b$var$jo.Node, "threshold", 0.5, (0, $47a4b45281b81a8b$var$qo.getNumberValidator)(), $47a4b45281b81a8b$var$Yn.Factory.afterSetFilter);
Object.defineProperty($47a4b45281b81a8b$var$Ue, "__esModule", {
    value: !0
});
$47a4b45281b81a8b$var$Ue.Konva = void 0;
const $47a4b45281b81a8b$var$jn = $47a4b45281b81a8b$var$tr, $47a4b45281b81a8b$var$Qo = $47a4b45281b81a8b$var$We, $47a4b45281b81a8b$var$Zo = $47a4b45281b81a8b$var$Ye, $47a4b45281b81a8b$var$tl = $47a4b45281b81a8b$var$Je, $47a4b45281b81a8b$var$el = $47a4b45281b81a8b$var$Qe, $47a4b45281b81a8b$var$il = $47a4b45281b81a8b$var$Ze, $47a4b45281b81a8b$var$qn = $47a4b45281b81a8b$var$ae, $47a4b45281b81a8b$var$nl = $47a4b45281b81a8b$var$Te, $47a4b45281b81a8b$var$rl = $47a4b45281b81a8b$var$ge, $47a4b45281b81a8b$var$sl = $47a4b45281b81a8b$var$Ee, $47a4b45281b81a8b$var$al = $47a4b45281b81a8b$var$ii, $47a4b45281b81a8b$var$ol = $47a4b45281b81a8b$var$ni, $47a4b45281b81a8b$var$ll = $47a4b45281b81a8b$var$ri, $47a4b45281b81a8b$var$hl = $47a4b45281b81a8b$var$si, $47a4b45281b81a8b$var$cl = $47a4b45281b81a8b$var$pe, $47a4b45281b81a8b$var$dl = $47a4b45281b81a8b$var$ai, $47a4b45281b81a8b$var$ul = $47a4b45281b81a8b$var$oi, $47a4b45281b81a8b$var$gl = $47a4b45281b81a8b$var$li, $47a4b45281b81a8b$var$fl = $47a4b45281b81a8b$var$ci, $47a4b45281b81a8b$var$pl = $47a4b45281b81a8b$var$di, $47a4b45281b81a8b$var$ml = $47a4b45281b81a8b$var$ui, $47a4b45281b81a8b$var$yl = $47a4b45281b81a8b$var$gi, $47a4b45281b81a8b$var$_l = $47a4b45281b81a8b$var$pi, $47a4b45281b81a8b$var$vl = $47a4b45281b81a8b$var$mi, $47a4b45281b81a8b$var$bl = $47a4b45281b81a8b$var$yi, $47a4b45281b81a8b$var$Sl = $47a4b45281b81a8b$var$_i, $47a4b45281b81a8b$var$Cl = $47a4b45281b81a8b$var$vi, $47a4b45281b81a8b$var$wl = $47a4b45281b81a8b$var$bi, $47a4b45281b81a8b$var$xl = $47a4b45281b81a8b$var$Si, $47a4b45281b81a8b$var$Tl = $47a4b45281b81a8b$var$Ci, $47a4b45281b81a8b$var$kl = $47a4b45281b81a8b$var$wi, $47a4b45281b81a8b$var$El = $47a4b45281b81a8b$var$xi, $47a4b45281b81a8b$var$Al = $47a4b45281b81a8b$var$Ti, $47a4b45281b81a8b$var$Pl = $47a4b45281b81a8b$var$ki, $47a4b45281b81a8b$var$Ml = $47a4b45281b81a8b$var$Ai, $47a4b45281b81a8b$var$Rl = $47a4b45281b81a8b$var$Pi, $47a4b45281b81a8b$var$Fl = $47a4b45281b81a8b$var$Mi;
$47a4b45281b81a8b$var$Ue.Konva = $47a4b45281b81a8b$var$jn.Konva.Util._assign($47a4b45281b81a8b$var$jn.Konva, {
    Arc: $47a4b45281b81a8b$var$Qo.Arc,
    Arrow: $47a4b45281b81a8b$var$Zo.Arrow,
    Circle: $47a4b45281b81a8b$var$tl.Circle,
    Ellipse: $47a4b45281b81a8b$var$el.Ellipse,
    Image: $47a4b45281b81a8b$var$il.Image,
    Label: $47a4b45281b81a8b$var$qn.Label,
    Tag: $47a4b45281b81a8b$var$qn.Tag,
    Line: $47a4b45281b81a8b$var$nl.Line,
    Path: $47a4b45281b81a8b$var$rl.Path,
    Rect: $47a4b45281b81a8b$var$sl.Rect,
    RegularPolygon: $47a4b45281b81a8b$var$al.RegularPolygon,
    Ring: $47a4b45281b81a8b$var$ol.Ring,
    Sprite: $47a4b45281b81a8b$var$ll.Sprite,
    Star: $47a4b45281b81a8b$var$hl.Star,
    Text: $47a4b45281b81a8b$var$cl.Text,
    TextPath: $47a4b45281b81a8b$var$dl.TextPath,
    Transformer: $47a4b45281b81a8b$var$ul.Transformer,
    Wedge: $47a4b45281b81a8b$var$gl.Wedge,
    Filters: {
        Blur: $47a4b45281b81a8b$var$fl.Blur,
        Brighten: $47a4b45281b81a8b$var$pl.Brighten,
        Contrast: $47a4b45281b81a8b$var$ml.Contrast,
        Emboss: $47a4b45281b81a8b$var$yl.Emboss,
        Enhance: $47a4b45281b81a8b$var$_l.Enhance,
        Grayscale: $47a4b45281b81a8b$var$vl.Grayscale,
        HSL: $47a4b45281b81a8b$var$bl.HSL,
        HSV: $47a4b45281b81a8b$var$Sl.HSV,
        Invert: $47a4b45281b81a8b$var$Cl.Invert,
        Kaleidoscope: $47a4b45281b81a8b$var$wl.Kaleidoscope,
        Mask: $47a4b45281b81a8b$var$xl.Mask,
        Noise: $47a4b45281b81a8b$var$Tl.Noise,
        Pixelate: $47a4b45281b81a8b$var$kl.Pixelate,
        Posterize: $47a4b45281b81a8b$var$El.Posterize,
        RGB: $47a4b45281b81a8b$var$Al.RGB,
        RGBA: $47a4b45281b81a8b$var$Pl.RGBA,
        Sepia: $47a4b45281b81a8b$var$Ml.Sepia,
        Solarize: $47a4b45281b81a8b$var$Rl.Solarize,
        Threshold: $47a4b45281b81a8b$var$Fl.Threshold
    }
});
var $47a4b45281b81a8b$var$Ol = $47a4b45281b81a8b$var$Qi.exports;
Object.defineProperty($47a4b45281b81a8b$var$Ol, "__esModule", {
    value: !0
});
const $47a4b45281b81a8b$var$Dl = $47a4b45281b81a8b$var$Ue;
$47a4b45281b81a8b$var$Qi.exports = $47a4b45281b81a8b$var$Dl.Konva;
var $47a4b45281b81a8b$var$Ll = $47a4b45281b81a8b$var$Qi.exports;
const $47a4b45281b81a8b$var$rt = /* @__PURE__ */ $47a4b45281b81a8b$var$Zn($47a4b45281b81a8b$var$Ll);
var $47a4b45281b81a8b$var$fn = {
    exports: {}
};
function $47a4b45281b81a8b$var$Lr(l, t = 100, e = {}) {
    if (typeof l != "function") throw new TypeError(`Expected the first parameter to be a function, got \`${typeof l}\`.`);
    if (t < 0) throw new RangeError("`wait` must not be negative.");
    const { immediate: i } = typeof e == "boolean" ? {
        immediate: e
    } : e;
    let n, r, s, a, o;
    function h() {
        const g = n, u = r;
        return n = void 0, r = void 0, o = l.apply(g, u), o;
    }
    function c() {
        const g = Date.now() - a;
        g < t && g >= 0 ? s = setTimeout(c, t - g) : (s = void 0, i || (o = h()));
    }
    const y = function(...g) {
        if (n && this !== n && Object.getPrototypeOf(this) === Object.getPrototypeOf(n)) throw new Error("Debounced method called with different contexts of the same prototype.");
        n = this, r = g, a = Date.now();
        const u = i && !s;
        return s || (s = setTimeout(c, t)), u && (o = h()), o;
    };
    return Object.defineProperty(y, "isPending", {
        get () {
            return s !== void 0;
        }
    }), y.clear = ()=>{
        s && (clearTimeout(s), s = void 0);
    }, y.flush = ()=>{
        s && y.trigger();
    }, y.trigger = ()=>{
        o = h(), y.clear();
    }, y;
}
$47a4b45281b81a8b$var$fn.exports.debounce = $47a4b45281b81a8b$var$Lr;
$47a4b45281b81a8b$var$fn.exports = $47a4b45281b81a8b$var$Lr;
var $47a4b45281b81a8b$var$Gl = $47a4b45281b81a8b$var$fn.exports;
const $47a4b45281b81a8b$var$Gr = /* @__PURE__ */ $47a4b45281b81a8b$var$Zn($47a4b45281b81a8b$var$Gl), $47a4b45281b81a8b$var$gt = [];
for(let l = 0; l < 256; ++l)$47a4b45281b81a8b$var$gt.push((l + 256).toString(16).slice(1));
function $47a4b45281b81a8b$var$Il(l, t = 0) {
    return ($47a4b45281b81a8b$var$gt[l[t + 0]] + $47a4b45281b81a8b$var$gt[l[t + 1]] + $47a4b45281b81a8b$var$gt[l[t + 2]] + $47a4b45281b81a8b$var$gt[l[t + 3]] + "-" + $47a4b45281b81a8b$var$gt[l[t + 4]] + $47a4b45281b81a8b$var$gt[l[t + 5]] + "-" + $47a4b45281b81a8b$var$gt[l[t + 6]] + $47a4b45281b81a8b$var$gt[l[t + 7]] + "-" + $47a4b45281b81a8b$var$gt[l[t + 8]] + $47a4b45281b81a8b$var$gt[l[t + 9]] + "-" + $47a4b45281b81a8b$var$gt[l[t + 10]] + $47a4b45281b81a8b$var$gt[l[t + 11]] + $47a4b45281b81a8b$var$gt[l[t + 12]] + $47a4b45281b81a8b$var$gt[l[t + 13]] + $47a4b45281b81a8b$var$gt[l[t + 14]] + $47a4b45281b81a8b$var$gt[l[t + 15]]).toLowerCase();
}
let $47a4b45281b81a8b$var$Vi;
const $47a4b45281b81a8b$var$Nl = new Uint8Array(16);
function $47a4b45281b81a8b$var$Ul() {
    if (!$47a4b45281b81a8b$var$Vi) {
        if (typeof crypto > "u" || !crypto.getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
        $47a4b45281b81a8b$var$Vi = crypto.getRandomValues.bind(crypto);
    }
    return $47a4b45281b81a8b$var$Vi($47a4b45281b81a8b$var$Nl);
}
const $47a4b45281b81a8b$var$Bl = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), $47a4b45281b81a8b$var$Jn = {
    randomUUID: $47a4b45281b81a8b$var$Bl
};
function $47a4b45281b81a8b$var$Qn(l, t, e) {
    var n;
    if ($47a4b45281b81a8b$var$Jn.randomUUID && !t && !l) return $47a4b45281b81a8b$var$Jn.randomUUID();
    l = l || {};
    const i = l.random ?? ((n = l.rng) == null ? void 0 : n.call(l)) ?? $47a4b45281b81a8b$var$Ul();
    if (i.length < 16) throw new Error("Random bytes length must be >= 16");
    if (i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, t) {
        if (e = e || 0, e < 0 || e + 16 > t.length) throw new RangeError(`UUID byte range ${e}:${e + 15} is out of buffer bounds`);
        for(let r = 0; r < 16; ++r)t[e + r] = i[r];
        return t;
    }
    return $47a4b45281b81a8b$var$Il(i);
}
const $47a4b45281b81a8b$var$q = {
    FONT_SIZE: 16,
    FONT: "Open Sans, sans-serif",
    TEXT_COLOR: "#000000",
    TEXT_WIDTH: 150,
    TEXT_ALIGN: "left",
    TEXT_WRAP: "word",
    TEXT_DRAGGABLE: !0,
    TEXT_NAME: "object",
    TEXT_SCALE: 1,
    TEXT_LINE_HEIGHT: 1.6,
    CANVAS_HEIGHT_PX: 500,
    CANVAS_WIDTH_PX: 1050,
    TEXTAREA_PADDING: 5,
    IMAGE_SCALE_FACTOR: 0.8,
    GUIDELINE_OFFSET: 5,
    AUTO_SAVE_DELAY: 1e3,
    LINK_COLOR: "#0000EE",
    LINK_TEXT_DECORATION: "underline"
}, $47a4b45281b81a8b$var$be = {
    ENTER: "Enter",
    ESCAPE: "Escape",
    DELETE: "Delete",
    BACKSPACE: "Backspace"
}, $47a4b45281b81a8b$var$Hl = [
    {
        label: "Small (250px)",
        value: "250"
    },
    {
        label: "Medium (500px)",
        value: "500"
    },
    {
        label: "Large (700px)",
        value: "700"
    },
    {
        label: "xLarge (900px)",
        value: "900"
    }
], $47a4b45281b81a8b$var$se = {
    WIDTH: 20,
    HEIGHT: 20
};
class $47a4b45281b81a8b$var$Zt {
    constructor(t, e = {}){
        this.stage = t.stage, this.layer = t.layer, this.blockId = t.blockId, this.readOnly = t.readOnly, this.onDirty = t.onDirty, this.notifier = t.notifier, this.callbacks = e;
    }
    safeDraw() {
        var t;
        try {
            (t = this.layer) == null || t.batchDraw();
        } catch (e) {
            console.error("Error in safeDraw:", e);
        }
    }
    isNodeInCurrentEditor(t) {
        if (!t || !this.stage) return !1;
        const e = t.getStage();
        return (e == null ? void 0 : e.container().id) === this.stage.container().id;
    }
    getDefaultTextProps() {
        return {
            fontSize: $47a4b45281b81a8b$var$q.FONT_SIZE,
            fontFamily: $47a4b45281b81a8b$var$q.FONT,
            fill: $47a4b45281b81a8b$var$q.TEXT_COLOR,
            fontStyle: "normal",
            width: $47a4b45281b81a8b$var$q.TEXT_WIDTH,
            draggable: $47a4b45281b81a8b$var$q.TEXT_DRAGGABLE,
            align: $47a4b45281b81a8b$var$q.TEXT_ALIGN,
            name: $47a4b45281b81a8b$var$q.TEXT_NAME,
            wrap: $47a4b45281b81a8b$var$q.TEXT_WRAP,
            scaleX: $47a4b45281b81a8b$var$q.TEXT_SCALE,
            scaleY: $47a4b45281b81a8b$var$q.TEXT_SCALE,
            lineHeight: $47a4b45281b81a8b$var$q.TEXT_LINE_HEIGHT
        };
    }
    destroy() {}
}
const $47a4b45281b81a8b$var$Vl = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M18 7L6 7"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M18 17H6"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M16 12L8 12"/></svg>', $47a4b45281b81a8b$var$$l = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M17 7L5 7"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M17 17H5"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M13 12L5 12"/></svg>', $47a4b45281b81a8b$var$zl = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M19 7L7 7"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M19 17H7"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M19 12L11 12"/></svg>', $47a4b45281b81a8b$var$Wl = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M9 12L9 7.1C9 7.04477 9.04477 7 9.1 7H10.4C11.5 7 14 7.1 14 9.5C14 9.5 14 12 11 12M9 12V16.8C9 16.9105 9.08954 17 9.2 17H12.5C14 17 15 16 15 14.5C15 11.7046 11 12 11 12M9 12H11"/></svg>', $47a4b45281b81a8b$var$Xl = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-width="2" d="M11.3535 9.31802L12.7678 7.90381C13.5488 7.12276 14.8151 7.12276 15.5962 7.90381C16.3772 8.68486 16.3772 9.95119 15.5962 10.7322L14.182 12.1464M11.3535 9.31802L7.96729 12.7043C7.40889 13.2627 7.02826 13.9739 6.87339 14.7482L6.69798 15.6253C6.55803 16.325 7.17495 16.942 7.87467 16.802L8.75175 16.6266C9.52612 16.4717 10.2373 16.0911 10.7957 15.5327L14.182 12.1464M11.3535 9.31802L14.182 12.1464"/><line x1="15" x2="19" y1="17" y2="17" stroke="currentColor" stroke-linecap="round" stroke-width="2"/></svg>', $47a4b45281b81a8b$var$Kl = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><rect width="14" height="14" x="5" y="5" stroke="currentColor" stroke-width="2" rx="4"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5.13968 15.32L8.69058 11.5661C9.02934 11.2036 9.48873 11 9.96774 11C10.4467 11 10.9061 11.2036 11.2449 11.5661L15.3871 16M13.5806 14.0664L15.0132 12.533C15.3519 12.1705 15.8113 11.9668 16.2903 11.9668C16.7693 11.9668 17.2287 12.1705 17.5675 12.533L18.841 13.9634"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.7778 9.33331H13.7867"/></svg>', $47a4b45281b81a8b$var$Yl = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M8 9V7.2C8 7.08954 8.08954 7 8.2 7L12 7M16 9V7.2C16 7.08954 15.9105 7 15.8 7L12 7M12 7L12 17M12 17H10M12 17H14"/></svg>', $47a4b45281b81a8b$var$jl = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.1328 7.7234C18.423 7.7634 18.7115 7.80571 19 7.85109M18.1328 7.7234L17.2267 17.4023C17.1897 17.8371 16.973 18.2432 16.62 18.5394C16.267 18.8356 15.8037 19.0001 15.3227 19H8.67733C8.19632 19.0001 7.73299 18.8356 7.37998 18.5394C7.02698 18.2432 6.81032 17.8371 6.77333 17.4023L5.86715 7.7234M18.1328 7.7234C17.1536 7.58919 16.1693 7.48733 15.1818 7.41803M5.86715 7.7234C5.57697 7.76263 5.28848 7.80494 5 7.85032M5.86715 7.7234C6.84642 7.58919 7.83074 7.48733 8.81818 7.41803M15.1818 7.41803C13.0638 7.26963 10.9362 7.26963 8.81818 7.41803M15.1818 7.41803C15.1818 5.30368 13.7266 4.34834 12 4.34834C10.2734 4.34834 8.81818 5.43945 8.81818 7.41803"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.5 15.5L10 11"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 11L13.5 15.5"/></svg>';
class $47a4b45281b81a8b$var$ql extends $47a4b45281b81a8b$var$Zt {
    constructor(t, e = {}){
        super(t, e), this.mainToolbar = null, this.textToolbar = null, this.saveIndicator = null, this.imageInput = null, this.linkDialog = null, this.linkInput = null, this.dialogOverlay = null, this.selectedText = null, this.currentTextProps = this.getDefaultTextProps(), this.initializeStyles();
    }
    initializeStyles() {
        const t = document.createElement("style");
        t.textContent = `
            .konva-toolbar {
                display: flex;
                align-items: center;
                padding: 8px;
                background: #fff;
                border-bottom: 1px solid #eee;
                gap: 8px;
            }

            .konva-toolbar button {
                padding: 6px;
                border: 1px solid #ddd;
                background: white;
                border-radius: 4px;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                transition: all 0.2s ease;
            }

            .konva-toolbar button:hover:not(:disabled) {
                background: #f5f5f5;
                border-color: #bbb;
            }

            .konva-toolbar button:disabled {
                opacity: 0.5;
                cursor: not-allowed;
            }

            .konva-toolbar button.active {
                background: #e0e0e0;
                border-color: #999;
            }

            .konva-toolbar select,
            .konva-toolbar input[type="color"] {
                padding: 4px;
                border: 1px solid #ddd;
                border-radius: 4px;
                background: white;
            }

            .konva-toolbar input[type="color"] {
                width: 32px;
                height: 32px;
                padding: 2px;
            }

            .konva-toolbar .separator {
                width: 1px;
                height: 24px;
                background: #ddd;
                margin: 0 8px;
            }

            .konva-save-indicator {
                font-size: 12px;
                font-style: italic;
                margin-left: auto;
                padding: 4px 8px;
                border-radius: 4px;
            }
        `, document.head.appendChild(t);
    }
    createMainToolbar(t) {
        this.mainToolbar = document.createElement("div"), this.mainToolbar.classList.add("konva-toolbar", "konva-main-toolbar");
        const e = this.createToolsContainer();
        this.saveIndicator = this.createSaveIndicator(), this.imageInput = this.createImageInput();
        const i = document.createElement("div");
        i.style.display = "flex", i.style.alignItems = "center", i.style.gap = "8px", i.appendChild(e), i.appendChild(this.createSeparator()), i.appendChild(this.createSizeSelector(t));
        const n = document.createElement("div");
        return n.style.display = "flex", n.style.alignItems = "center", n.style.marginLeft = "auto", n.appendChild(this.saveIndicator), this.mainToolbar.appendChild(i), this.mainToolbar.appendChild(n), this.mainToolbar.appendChild(this.imageInput), this.mainToolbar;
    }
    createToolsContainer() {
        const t = document.createElement("div");
        return t.style.display = "flex", t.style.gap = "4px", t.style.alignItems = "center", [
            {
                name: "text",
                icon: $47a4b45281b81a8b$var$Yl,
                action: ()=>{
                    var i, n;
                    return (n = (i = this.callbacks).onAddText) == null ? void 0 : n.call(i);
                },
                tooltip: "Add Text (T)"
            },
            {
                name: "image",
                icon: $47a4b45281b81a8b$var$Kl,
                action: ()=>{
                    var i;
                    return (i = this.imageInput) == null ? void 0 : i.click();
                },
                tooltip: "Add Image"
            },
            {
                name: "delete",
                icon: $47a4b45281b81a8b$var$jl,
                action: ()=>{
                    var i, n;
                    (n = (i = this.callbacks).onDelete) == null || n.call(i);
                },
                tooltip: "Delete (Del)",
                disabled: !0
            }
        ].forEach((i)=>{
            const n = this.createToolButton(i);
            t.appendChild(n);
        }), t;
    }
    createToolButton(t) {
        const e = document.createElement("button");
        return e.innerHTML = t.icon, e.title = t.tooltip || t.name, e.disabled = t.disabled || !1, e.dataset.tool = t.name, e.addEventListener("click", t.action), e;
    }
    createSeparator() {
        const t = document.createElement("div");
        return t.classList.add("separator"), t;
    }
    createImageInput() {
        const t = document.createElement("input");
        return t.type = "file", t.accept = "image/*", t.style.display = "none", t.addEventListener("change", (e)=>{
            var i, n;
            (n = (i = this.callbacks).onImageUpload) == null || n.call(i, e);
        }), t;
    }
    createSizeSelector(t) {
        const e = document.createElement("select");
        return e.classList.add("konva-size-selector"), $47a4b45281b81a8b$var$Hl.forEach((i)=>{
            const n = document.createElement("option");
            n.value = i.value, n.text = i.label, t === parseInt(i.value) && (n.selected = !0), e.appendChild(n);
        }), e.addEventListener("change", (i)=>{
            var r, s;
            const n = parseInt(i.target.value);
            (s = (r = this.callbacks).onCanvasResize) == null || s.call(r, n);
        }), e;
    }
    createSaveIndicator() {
        const t = document.createElement("span");
        return t.classList.add("konva-save-indicator"), t;
    }
    createTextToolbar() {
        this.textToolbar = document.createElement("div"), this.textToolbar.classList.add("konva-toolbar", "konva-text-toolbar");
        const t = this.createFontSizeSelector(), e = this.createStyleControls(), i = this.createAlignmentControls(), n = this.createColorPicker(), r = this.createLinkControls(), s = document.createElement("div");
        s.style.position = "relative", s.appendChild(n);
        const a = document.createElement("div");
        return a.textContent = "Links are always blue", a.style.cssText = `
    display: none;
    position: absolute;
    bottom: 120%;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(0,0,0,0.7);
    color: white;
    padding: 5px 10px;
    border-radius: 3px;
    white-space: nowrap;
    font-size: 11px;
    pointer-events: none;
  `, s.appendChild(a), n.addEventListener("mouseover", ()=>{
            n.disabled && (a.style.display = "block");
        }), n.addEventListener("mouseout", ()=>{
            a.style.display = "none";
        }), this.textToolbar.appendChild(t), this.textToolbar.appendChild(this.createSeparator()), this.textToolbar.appendChild(e), this.textToolbar.appendChild(this.createSeparator()), this.textToolbar.appendChild(i), this.textToolbar.appendChild(this.createSeparator()), this.textToolbar.appendChild(s), this.textToolbar.appendChild(this.createSeparator()), this.textToolbar.appendChild(r), this.textToolbar;
    }
    createFontSizeSelector() {
        const t = document.createElement("select");
        return t.classList.add("konva-font-size"), [
            8,
            10,
            12,
            14,
            16,
            18,
            20,
            24,
            28,
            32,
            36,
            48,
            72
        ].forEach((i)=>{
            const n = document.createElement("option");
            n.value = i.toString(), n.text = `${i}px`, i === this.currentTextProps.fontSize && (n.selected = !0), t.appendChild(n);
        }), t.addEventListener("change", (i)=>{
            const n = parseInt(i.target.value);
            this.updateTextProperty({
                fontSize: n
            });
        }), t;
    }
    createStyleControls() {
        const t = document.createElement("div");
        t.style.display = "flex", t.style.gap = "4px";
        const e = this.createToolButton({
            name: "bold",
            icon: $47a4b45281b81a8b$var$Wl,
            action: ()=>{
                const i = this.currentTextProps.fontStyle === "bold" ? "normal" : "bold";
                this.updateTextProperty({
                    fontStyle: i
                }), e.classList.toggle("active");
            },
            tooltip: "Bold (Ctrl+B)"
        });
        return t.appendChild(e), t;
    }
    createAlignmentControls() {
        const t = document.createElement("div");
        return t.style.display = "flex", t.style.gap = "4px", [
            {
                value: "left",
                icon: $47a4b45281b81a8b$var$$l
            },
            {
                value: "center",
                icon: $47a4b45281b81a8b$var$Vl
            },
            {
                value: "right",
                icon: $47a4b45281b81a8b$var$zl
            }
        ].forEach((i)=>{
            const n = this.createToolButton({
                name: `align-${i.value}`,
                icon: i.icon,
                action: ()=>{
                    this.updateTextProperty({
                        align: i.value
                    }), t.querySelectorAll("button").forEach((r)=>r.classList.remove("active")), n.classList.add("active");
                },
                tooltip: `Align ${i.value}`
            });
            t.appendChild(n);
        }), t;
    }
    createColorPicker() {
        const t = document.createElement("input");
        return t.type = "color", t.value = this.currentTextProps.fill, t.title = "Text Color", t.addEventListener("change", (e)=>{
            var n;
            const i = e.target.value;
            this.selectedText && !this.selectedText.getAttr("link") ? this.updateTextProperty({
                fill: i
            }) : this.selectedText && this.selectedText.getAttr("link") && (t.value = $47a4b45281b81a8b$var$q.LINK_COLOR, (n = this.notifier) == null || n.show({
                message: "Link color cannot be changed. Remove the link to change the color.",
                style: "info"
            }));
        }), t;
    }
    updateTextProperty(t) {
        var e, i;
        this.currentTextProps = {
            ...this.currentTextProps,
            ...t
        }, (i = (e = this.callbacks).onTextPropertyChange) == null || i.call(e, this.currentTextProps);
    }
    updateToolbarState(t) {
        if (!this.mainToolbar || !this.textToolbar) return;
        const e = this.mainToolbar.querySelector('[data-tool="delete"]');
        e && (e.disabled = !t);
        const i = t instanceof $47a4b45281b81a8b$var$rt.Text;
        this.textToolbar.querySelectorAll("button, select, input").forEach((n)=>{
            (n instanceof HTMLButtonElement || n instanceof HTMLSelectElement || n instanceof HTMLInputElement) && (n.disabled = !i);
        }), this.selectedText = i ? t : null, i && this.updateTextToolbarValues(t);
    }
    updateTextToolbarValues(t) {
        if (!this.textToolbar) return;
        this.currentTextProps = {
            ...t.getAttrs(),
            align: t.getAttr("align")
        };
        const e = this.textToolbar.querySelector(".konva-font-size");
        e && (e.value = t.fontSize().toString());
        const i = this.textToolbar.querySelector('[data-tool="bold"]');
        i && i.classList.toggle("active", t.fontStyle() === "bold");
        const n = this.textToolbar.querySelector('input[type="color"]');
        n && (n.value = t.fill(), n.disabled = !!t.getAttr("link"), t.getAttr("link") ? (n.style.opacity = "0.5", n.title = "Color cannot be changed for linked text") : (n.style.opacity = "1", n.title = "Text Color")), this.textToolbar.querySelectorAll('[data-tool^="align-"]').forEach((a)=>{
            var h;
            const o = (h = a.getAttribute("data-tool")) == null ? void 0 : h.replace("align-", "");
            a.classList.toggle("active", o === t.align());
        });
        const s = this.textToolbar.querySelector('[data-tool="link"]');
        s && s.classList.toggle("active", !!t.getAttr("link"));
    }
    createLinkControls() {
        const t = document.createElement("div");
        t.style.display = "flex", t.style.gap = "4px";
        const e = this.createToolButton({
            name: "link",
            icon: '<svg width="18" height="18" viewBox="0 0 24 24"><path fill="currentColor" d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"/></svg>',
            action: ()=>this.showLinkDialog(),
            tooltip: "Add Link (Ctrl+K)"
        });
        return t.appendChild(e), t;
    }
    createLinkDialog() {
        if (!this.linkDialog) {
            this.dialogOverlay = document.createElement("div"), this.dialogOverlay.style.position = "fixed", this.dialogOverlay.style.top = "0", this.dialogOverlay.style.left = "0", this.dialogOverlay.style.right = "0", this.dialogOverlay.style.bottom = "0", this.dialogOverlay.style.backgroundColor = "rgba(0, 0, 0, 0.3)", this.dialogOverlay.style.zIndex = "9999", this.dialogOverlay.style.display = "none", this.dialogOverlay.onclick = ()=>this.hideLinkDialog(), document.body.appendChild(this.dialogOverlay), this.linkDialog = document.createElement("div"), this.linkDialog.classList.add("konva-link-dialog"), this.linkDialog.style.display = "none", this.linkDialog.style.position = "fixed", this.linkDialog.style.backgroundColor = "white", this.linkDialog.style.padding = "20px", this.linkDialog.style.borderRadius = "6px", this.linkDialog.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.15)", this.linkDialog.style.zIndex = "10000", this.linkDialog.style.minWidth = "320px", this.linkDialog.style.maxWidth = "400px";
            const t = document.createElement("h3");
            t.textContent = "Link Settings", t.style.margin = "0 0 16px 0", t.style.color = "#333", t.style.fontSize = "16px";
            const e = document.createElement("label");
            e.textContent = "URL:", e.htmlFor = "konva-link-url", e.style.display = "block", e.style.marginBottom = "8px", e.style.fontWeight = "bold", this.linkInput = document.createElement("input"), this.linkInput.type = "text", this.linkInput.id = "konva-link-url", this.linkInput.placeholder = "https://example.com", this.linkInput.style.width = "100%", this.linkInput.style.padding = "8px", this.linkInput.style.boxSizing = "border-box", this.linkInput.style.border = "1px solid #ddd", this.linkInput.style.borderRadius = "4px", this.linkInput.style.marginBottom = "16px";
            const i = document.createElement("p");
            i.textContent = "Ctrl+Click (or Cmd+Click) on linked text to open the URL.", i.style.margin = "0 0 16px 0", i.style.fontSize = "12px", i.style.color = "#666";
            const n = document.createElement("div");
            n.style.display = "flex", n.style.gap = "8px", n.style.justifyContent = "flex-end";
            const r = document.createElement("button");
            r.textContent = "Apply", r.style.padding = "8px 16px", r.style.background = "#4CAF50", r.style.color = "white", r.style.border = "none", r.style.borderRadius = "4px", r.style.cursor = "pointer", r.onclick = ()=>this.applyLink();
            const s = document.createElement("button");
            s.textContent = "Remove Link", s.style.padding = "8px 16px", s.style.background = "#f44336", s.style.color = "white", s.style.border = "none", s.style.borderRadius = "4px", s.style.cursor = "pointer", s.onclick = ()=>this.removeLink();
            const a = document.createElement("button");
            a.textContent = "Cancel", a.style.padding = "8px 16px", a.style.background = "#ddd", a.style.border = "none", a.style.borderRadius = "4px", a.style.cursor = "pointer", a.onclick = ()=>this.hideLinkDialog(), n.appendChild(r), n.appendChild(s), n.appendChild(a), this.linkDialog.appendChild(t), this.linkDialog.appendChild(e), this.linkDialog.appendChild(this.linkInput), this.linkDialog.appendChild(i), this.linkDialog.appendChild(n), document.body.appendChild(this.linkDialog);
        }
        return this.linkDialog;
    }
    showLinkDialog() {
        if (this.linkDialog || this.createLinkDialog(), this.selectedText) {
            const t = window.innerWidth, e = window.innerHeight, i = 400;
            this.linkDialog.style.left = `${(t - i) / 2}px`, this.linkDialog.style.top = `${Math.max(50, e / 4)}px`, this.linkInput && (this.linkInput.value = this.selectedText.getAttr("link") || ""), this.dialogOverlay && (this.dialogOverlay.style.display = "block"), this.linkDialog.style.display = "block", this.linkInput.focus();
        }
    }
    hideLinkDialog() {
        this.linkDialog && (this.linkDialog.style.display = "none", this.dialogOverlay && (this.dialogOverlay.style.display = "none"));
    }
    applyLink() {
        if (this.selectedText && this.linkInput) {
            const t = this.linkInput.value.trim();
            t && this.updateTextProperty({
                link: t,
                fill: $47a4b45281b81a8b$var$q.LINK_COLOR,
                textDecoration: $47a4b45281b81a8b$var$q.LINK_TEXT_DECORATION
            }), this.hideLinkDialog();
        }
    }
    removeLink() {
        if (this.selectedText) {
            const t = this.selectedText.getAttr("originalFill") || $47a4b45281b81a8b$var$q.TEXT_COLOR;
            this.updateTextProperty({
                link: void 0,
                textDecoration: void 0,
                fill: t
            }), this.selectedText.setAttr("originalFill", void 0), this.hideLinkDialog();
        }
    }
    updateSaveIndicator(t) {
        this.saveIndicator && (this.saveIndicator.textContent = t ? "Unsaved changes" : "All changes saved", this.saveIndicator.style.color = t ? "#ff4444" : "#44aa44", this.saveIndicator.style.background = t ? "#ffeeee" : "#eeffee");
    }
    destroy() {
        this.mainToolbar && this.mainToolbar.remove(), this.textToolbar && this.textToolbar.remove(), this.linkDialog && this.linkDialog.remove(), this.dialogOverlay && this.dialogOverlay.remove();
    }
}
class $47a4b45281b81a8b$var$Jl extends $47a4b45281b81a8b$var$Zt {
    constructor(t, e = {}){
        super(t, e), this.handleKeyDown = (i)=>{
            var s, a, o, h, c, y;
            if (this.readOnly) return;
            const n = i.target, r = n.tagName.toLowerCase() === "textarea" || n.tagName.toLowerCase() === "input" || n.classList.contains("konva-textarea");
            if (!r) {
                if (i.ctrlKey || i.metaKey) switch(i.key.toLowerCase()){
                    case "z":
                        i.shiftKey;
                        break;
                    case "c":
                        break;
                    case "v":
                        break;
                    case "x":
                        break;
                    case "s":
                        (a = (s = this.callbacks).onCanvasSave) == null || a.call(s);
                        break;
                }
                else switch(i.key){
                    case $47a4b45281b81a8b$var$be.DELETE:
                    case $47a4b45281b81a8b$var$be.BACKSPACE:
                        r || (h = (o = this.callbacks).onDelete) == null || h.call(o);
                        break;
                    case $47a4b45281b81a8b$var$be.ESCAPE:
                        (y = (c = this.callbacks).onSelect) == null || y.call(c, null);
                        break;
                }
            }
        }, this.handlePaste = (i)=>{
            var n;
            if (!this.readOnly && (n = i.clipboardData) != null && n.items) for(let r = 0; r < i.clipboardData.items.length; r++){
                const s = i.clipboardData.items[r];
                if (s.type.indexOf("image") !== -1) {
                    i.preventDefault();
                    const a = s.getAsFile();
                    if (a) {
                        const o = new FileReader();
                        o.onload = (h)=>{
                            var y;
                            const c = new Image();
                            c.onload = ()=>{
                                var g, u;
                                (u = (g = this.callbacks).onImageAdd) == null || u.call(g, new $47a4b45281b81a8b$var$rt.Image({
                                    image: c,
                                    draggable: !0,
                                    name: "object"
                                }));
                            }, c.src = (y = h.target) == null ? void 0 : y.result;
                        }, o.readAsDataURL(a);
                    }
                    break;
                }
            }
        }, this.initializeEvents();
    }
    initializeEvents() {
        !this.stage || !this.layer || (this.attachBasicEvents(), this.readOnly || (this.attachEditingEvents(), this.attachWindowEvents()));
    }
    attachBasicEvents() {
        this.stage.on(`click.${this.blockId} tap.${this.blockId}`, (t)=>{
            if (this.isNodeInCurrentEditor(t.target)) {
                if (t.target === this.stage) {
                    this.readOnly || this.handleStageClick();
                    return;
                }
                (!this.readOnly || t.target instanceof $47a4b45281b81a8b$var$rt.Text && t.target.getAttr("link")) && this.handleNodeClick(t.target);
            }
        }), this.stage.on("mouseover touchstart", (t)=>{
            this.isNodeInCurrentEditor(t.target) && (!this.readOnly || t.target instanceof $47a4b45281b81a8b$var$rt.Text && t.target.getAttr("link")) && (this.stage.container().style.cursor = "pointer");
        }), this.stage.on("mouseout touchend", ()=>{
            this.stage.container().style.cursor = "default";
        }), this.stage.on("contextmenu", (t)=>{
            t.evt.preventDefault();
        });
    }
    attachEditingEvents() {
        this.readOnly || !this.layer || (this.layer.on("dragstart", (t)=>{
            var e, i;
            if (this.readOnly || !this.isNodeInCurrentEditor(t.target)) {
                t.cancelBubble = !0;
                return;
            }
            (i = (e = this.callbacks).onDragStart) == null || i.call(e, t.target);
        }), this.layer.on("dragmove", (t)=>{
            var e, i;
            if (this.readOnly || !this.isNodeInCurrentEditor(t.target)) {
                t.cancelBubble = !0;
                return;
            }
            (i = (e = this.callbacks).onDragMove) == null || i.call(e, t.target);
        }), this.layer.on("dragend", (t)=>{
            var e, i;
            if (this.readOnly || !this.isNodeInCurrentEditor(t.target)) {
                t.cancelBubble = !0;
                return;
            }
            (i = (e = this.callbacks).onDragEnd) == null || i.call(e, t.target);
        }), this.layer.on("transformstart", (t)=>{
            var e, i;
            this.readOnly || !this.isNodeInCurrentEditor(t.target) || (i = (e = this.callbacks).onTransformStart) == null || i.call(e, t.target);
        }), this.layer.on("transform", (t)=>{
            var e, i;
            this.readOnly || !this.isNodeInCurrentEditor(t.target) || (i = (e = this.callbacks).onChange) == null || i.call(e);
        }), this.layer.on("transformend", (t)=>{
            var e, i;
            this.readOnly || !this.isNodeInCurrentEditor(t.target) || (i = (e = this.callbacks).onTransformEnd) == null || i.call(e, t.target);
        }));
    }
    attachWindowEvents() {
        window.addEventListener("keydown", this.handleKeyDown), window.addEventListener("paste", this.handlePaste);
    }
    handleStageClick() {
        var t, e;
        (e = (t = this.callbacks).onSelect) == null || e.call(t, null);
    }
    handleNodeClick(t) {
        var e, i;
        if (!(this.readOnly && !(t instanceof $47a4b45281b81a8b$var$rt.Text && t.getAttr("link"))) && !t.hasName("guid-line")) {
            if (t instanceof $47a4b45281b81a8b$var$rt.Text && t.getAttr("link") && (this.readOnly || window.event && window.event.ctrlKey || window.event && window.event.metaKey)) {
                const n = t.getAttr("link");
                if (n) {
                    window.open(n, "_blank", "noopener,noreferrer");
                    return;
                }
            }
            this.readOnly || (i = (e = this.callbacks).onSelect) == null || i.call(e, t);
        }
    }
    destroy() {
        var t, e, i, n, r, s;
        (t = this.stage) == null || t.off(`click.${this.blockId} tap.${this.blockId}`), (e = this.stage) == null || e.off("mouseover touchstart"), (i = this.stage) == null || i.off("mouseout touchend"), (n = this.stage) == null || n.off("contextmenu"), (r = this.layer) == null || r.off("dragstart dragmove dragend"), (s = this.layer) == null || s.off("transformstart transform transformend"), window.removeEventListener("keydown", this.handleKeyDown), window.removeEventListener("paste", this.handlePaste);
    }
    updateEventListeners() {
        this.destroy(), this.initializeEvents();
    }
}
class $47a4b45281b81a8b$var$Ql extends $47a4b45281b81a8b$var$Zt {
    constructor(t, e = {}){
        super(t, e);
    }
    addText() {
        var e, i;
        if (this.readOnly) return;
        const t = new $47a4b45281b81a8b$var$rt.Text({
            x: this.stage.width() / 2 - 100,
            y: this.stage.height() / 2 - 10,
            text: "Click to edit",
            ...this.getDefaultTextProps(),
            id: `text-${this.blockId}-${Date.now()}`,
            draggable: !this.readOnly
        });
        this.attachDoubleClickHandler(t), this.attachClickHandler(t), this.layer.add(t), (i = (e = this.callbacks).onSelect) == null || i.call(e, t), this.safeDraw(), this.onDirty();
    }
    createTextEditor(t) {
        var r, s, a;
        if (this.readOnly) return;
        const e = document.querySelector(".konva-textarea");
        e && ((r = e.parentNode) == null || r.removeChild(e));
        const i = t.getAttr("link");
        t.hide(), (a = (s = this.callbacks).onHideTransformer) == null || a.call(s);
        const n = this.createTextarea(t);
        this.setupTextareaEvents(n, t, {
            onFinish: ()=>{
                i && (t.setAttr("link", i), t.setAttr("textDecoration", $47a4b45281b81a8b$var$q.LINK_TEXT_DECORATION), t.fill($47a4b45281b81a8b$var$q.LINK_COLOR));
            }
        });
    }
    attachDoubleClickHandler(t) {
        t.off("dblclick dbltap"), t.on("dblclick dbltap", ()=>{
            this.createTextEditor(t);
        });
    }
    attachClickHandler(t) {
        t.off("click tap"), t.on("click tap", (e)=>{
            const i = t.getAttr("link");
            i && (this.readOnly || e.evt.ctrlKey || e.evt.metaKey) && (window.open(i, "_blank", "noopener,noreferrer"), e.cancelBubble = !0);
        }), t.off("mouseover mouseout"), t.on("mouseover", ()=>{
            t.getAttr("link") && (this.stage.container().style.cursor = "pointer");
        }), t.on("mouseout", ()=>{
            this.stage.container().style.cursor = "default";
        });
    }
    createTextarea(t) {
        const e = this.calculateTextareaPosition(t), i = document.createElement("textarea");
        return i.classList.add("konva-textarea"), i.setAttribute("data-editor-id", this.blockId), i.value = t.text(), document.body.appendChild(i), this.applyTextareaStyles(i, t, e), i.focus(), i;
    }
    calculateTextareaPosition(t) {
        const e = this.stage.container().getBoundingClientRect(), i = t.absolutePosition(), n = window.scrollX || document.documentElement.scrollLeft, r = window.scrollY || document.documentElement.scrollTop;
        return {
            x: e.left + i.x + n,
            y: e.top + i.y + r
        };
    }
    applyTextareaStyles(t, e, i) {
        const n = {
            position: "absolute",
            top: `${i.y}px`,
            left: `${i.x}px`,
            width: `${e.width() - e.padding() * 2}px`,
            height: `${e.height() - e.padding() * 2 + $47a4b45281b81a8b$var$q.TEXTAREA_PADDING}px`,
            fontSize: `${e.fontSize()}px`,
            border: "none",
            padding: "0px",
            margin: "0px",
            overflow: "hidden",
            background: "none",
            outline: "none",
            resize: "none",
            lineHeight: e.lineHeight().toString(),
            fontFamily: e.fontFamily(),
            transformOrigin: "left top",
            textAlign: e.align(),
            color: e.fill(),
            zIndex: "1000"
        };
        Object.assign(t.style, n), this.applyRotationTransform(t, e);
    }
    applyRotationTransform(t, e) {
        const i = e.rotation();
        let n = i ? `rotateZ(${i}deg)` : "";
        if (navigator.userAgent.toLowerCase().indexOf("firefox") > -1) {
            const s = 2 + Math.round(e.fontSize() / 20);
            n += `translateY(-${s}px)`;
        }
        t.style.transform = n, t.style.height = "auto", t.style.height = `${t.scrollHeight + 3}px`;
    }
    setupTextareaEvents(t, e, i = {}) {
        const n = ()=>{
            var s, a, o, h, c;
            (s = t.parentNode) == null || s.removeChild(t), window.removeEventListener("click", r), e.show(), (o = (a = this.callbacks).onShowTransformer) == null || o.call(a), this.attachDoubleClickHandler(e), this.attachClickHandler(e), this.safeDraw(), i.onFinish && i.onFinish(), (c = (h = this.callbacks).onTransformEnd) == null || c.call(h, e);
        }, r = (s)=>{
            s.target !== t && (e.text(t.value), n());
        };
        t.addEventListener("keydown", (s)=>{
            s.key === $47a4b45281b81a8b$var$be.ENTER && !s.shiftKey && (e.text(t.value), n()), s.key === $47a4b45281b81a8b$var$be.ESCAPE && n();
        }), t.addEventListener("input", ()=>{
            this.updateTextareaSize(t, e);
        }), t.addEventListener("input", ()=>{
            e.text(t.value), this.safeDraw();
        }), setTimeout(()=>{
            window.addEventListener("click", r);
        }, 0);
    }
    updateTextareaSize(t, e) {
        const i = e.getAbsoluteScale().x;
        let n = e.width() * i;
        n || (n = e.text().length * e.fontSize());
        const r = /^((?!chrome|android).)*safari/i.test(navigator.userAgent), s = navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
        (r || s) && (n = Math.ceil(n)), t.style.width = `${n}px`, t.style.height = "auto", t.style.height = `${t.scrollHeight + e.fontSize()}px`;
    }
    updateTextProperties(t, e) {
        t instanceof $47a4b45281b81a8b$var$rt.Text && (e.link !== void 0 && (e.link ? (t.getAttr("originalFill") || t.setAttr("originalFill", t.fill()), e.fill = $47a4b45281b81a8b$var$q.LINK_COLOR, e.textDecoration = $47a4b45281b81a8b$var$q.LINK_TEXT_DECORATION) : (e.fill = t.getAttr("originalFill") || $47a4b45281b81a8b$var$q.TEXT_COLOR, e.textDecoration = void 0, t.setAttr("originalFill", void 0))), e.fill && t.getAttr("link") && e.link === void 0 && delete e.fill, t.setAttrs({
            ...t.getAttrs(),
            ...e
        }), this.safeDraw(), this.onDirty());
    }
}
class $47a4b45281b81a8b$var$Zl extends $47a4b45281b81a8b$var$Zt {
    constructor(t, e = {}, i){
        super(t, e), this.imageUploader = i;
    }
    handleImageUpload(t) {
        var r, s, a;
        if (this.readOnly) return;
        const e = t.target, i = (r = e.files) == null ? void 0 : r[0];
        (!i || !i.type.startsWith("image/")) && (console.warn("Invalid file type"), this.uploadingFailed()), (a = (s = this.callbacks).onShowLoading) == null || a.call(s);
        const n = new FileReader();
        n.onload = (o)=>this.handleImageLoad(o), n.onerror = ()=>{
            var o, h;
            console.error("Error reading file"), (h = (o = this.callbacks) == null ? void 0 : o.onHideLoading) == null || h.call(o);
        }, n.readAsDataURL(i), e.value = "";
    }
    handleImageLoad(t) {
        var n, r, s;
        const e = (n = t.target) == null ? void 0 : n.result;
        if (!e || typeof e != "string") {
            (s = (r = this.callbacks) == null ? void 0 : r.onHideLoading) == null || s.call(r);
            return;
        }
        (async ()=>this.imageUploader ? await this.imageUploader(e) : e)().then((a)=>{
            const o = new Image();
            o.onload = ()=>{
                var h, c;
                this.createKonvaImage(o), (c = (h = this.callbacks) == null ? void 0 : h.onHideLoading) == null || c.call(h);
            }, o.onerror = ()=>{
                var h, c;
                console.error("Failed to load image"), (c = (h = this.callbacks) == null ? void 0 : h.onHideLoading) == null || c.call(h);
            }, o.src = a;
        }).catch((a)=>{
            var o, h;
            console.error("Error uploading image:", a), this.uploadingFailed(), (h = (o = this.callbacks) == null ? void 0 : o.onHideLoading) == null || h.call(o);
        });
    }
    createKonvaImage(t) {
        var e, i;
        try {
            const n = this.calculateImageDimensions(t), r = new $47a4b45281b81a8b$var$rt.Image({
                x: (this.stage.width() - n.width) / 2,
                y: (this.stage.height() - n.height) / 2,
                image: t,
                width: n.width,
                height: n.height,
                draggable: !this.readOnly,
                name: "object",
                id: `image-${this.blockId}-${Date.now()}`
            });
            this.layer.add(r), this.setHighQualityRendering(), (i = (e = this.callbacks).onSelect) == null || i.call(e, r), this.safeDraw(), this.onDirty();
        } catch (n) {
            console.error("Error creating image:", n);
        }
    }
    calculateImageDimensions(t) {
        const e = this.stage.width() * $47a4b45281b81a8b$var$q.IMAGE_SCALE_FACTOR, i = this.stage.height() * $47a4b45281b81a8b$var$q.IMAGE_SCALE_FACTOR;
        let { width: n, height: r } = t;
        const s = n / r;
        return n > e && (n = e, r = n / s), r > i && (r = i, n = r * s), {
            width: n,
            height: r
        };
    }
    setHighQualityRendering() {
        const e = this.layer.getCanvas()._canvas.getContext("2d");
        e && (e.imageSmoothingEnabled = !0, e.imageSmoothingQuality = "high");
    }
    uploadingFailed() {
        this.notifier.show({
            message: "Couldn\u2019t upload image. Please try another.",
            style: "Error"
        });
    }
}
class $47a4b45281b81a8b$var$th extends $47a4b45281b81a8b$var$Zt {
    constructor(t, e = {}){
        super(t, e), this.transformer = null, this.initializeTransformer();
    }
    initializeTransformer() {
        if (this.layer) try {
            this.transformer && (this.transformer.destroy(), this.transformer = null), this.transformer = new $47a4b45281b81a8b$var$rt.Transformer(), this.layer.add(this.transformer), this.layer.batchDraw();
        } catch (t) {
            console.error("Error initializing transformer:", t);
        }
    }
    createTransformerForNode(t) {
        if (!this.transformer || !this.layer || !t) {
            console.warn("Transformer, layer, or node is not initialized");
            return;
        }
        try {
            this.transformer.nodes([]), this.transformer.detach();
            const e = this.getTransformerConfig(t);
            this.transformer.destroy(), this.transformer = new $47a4b45281b81a8b$var$rt.Transformer(e), this.layer.add(this.transformer), this.transformer.setZIndex(t.getZIndex()), this.transformer.nodes([
                t
            ]), t instanceof $47a4b45281b81a8b$var$rt.Text ? this.attachTextTransformHandler(t) : t instanceof $47a4b45281b81a8b$var$rt.Image ? this.attachImageTransformHandler(t) : this.attachDefaultTransformHandler(t), this.layer.batchDraw();
        } catch (e) {
            console.error("Error creating transformer for node:", e);
        }
    }
    getTransformerConfig(t) {
        return t instanceof $47a4b45281b81a8b$var$rt.Text ? {
            enabledAnchors: [
                "middle-left",
                "middle-right"
            ],
            rotateEnabled: !1,
            keepRatio: !1,
            padding: 5,
            boundBoxFunc: (e, i)=>i.width < $47a4b45281b81a8b$var$se.WIDTH ? e : i
        } : t instanceof $47a4b45281b81a8b$var$rt.Image ? {
            enabledAnchors: [
                "top-left",
                "top-right",
                "bottom-left",
                "bottom-right"
            ],
            rotateEnabled: !0,
            keepRatio: !0,
            padding: 5,
            borderStroke: "#00ff00",
            anchorStroke: "#00ff00",
            anchorFill: "#ffffff",
            boundBoxFunc: (e, i)=>i.width < $47a4b45281b81a8b$var$se.WIDTH || i.height < $47a4b45281b81a8b$var$se.HEIGHT ? e : i
        } : {
            enabledAnchors: [
                "top-left",
                "top-right",
                "bottom-left",
                "bottom-right"
            ],
            rotateEnabled: !0,
            keepRatio: !1,
            padding: 5,
            borderStroke: "#0000ff",
            anchorStroke: "#0000ff",
            anchorFill: "#ffffff"
        };
    }
    attachTextTransformHandler(t) {
        t.off("transform"), t.on("transform", ()=>{
            const e = Math.max($47a4b45281b81a8b$var$se.WIDTH, t.width() * t.scaleX());
            t.setAttrs({
                width: e,
                scaleX: 1,
                scaleY: 1
            }), this.safeDraw();
        }), t.on("transformend", ()=>{
            var e, i;
            (i = (e = this.callbacks).onTransformEnd) == null || i.call(e, t);
        });
    }
    attachImageTransformHandler(t) {
        t.off("transform transformend"), t.on("transform", ()=>{
            const e = t.scaleX(), i = t.scaleY(), n = Math.max($47a4b45281b81a8b$var$se.WIDTH, t.width() * e), r = Math.max($47a4b45281b81a8b$var$se.HEIGHT, t.height() * i);
            t.setAttrs({
                width: n,
                height: r,
                scaleX: 1,
                scaleY: 1
            }), this.safeDraw();
        }), t.on("transformend", ()=>{
            var e, i;
            (i = (e = this.callbacks).onTransformEnd) == null || i.call(e, t);
        });
    }
    attachDefaultTransformHandler(t) {
        t.off("transform transformend"), t.on("transform", ()=>{
            this.safeDraw();
        }), t.on("transformend", ()=>{
            var e, i;
            (i = (e = this.callbacks).onTransformEnd) == null || i.call(e, t);
        });
    }
    clearTransformer() {
        if (!(!this.transformer || !this.layer)) try {
            this.transformer.nodes([]), this.transformer.detach(), this.layer.batchDraw();
        } catch (t) {
            console.error("Error clearing transformer:", t);
        }
    }
    hideTransformer() {
        this.transformer && (this.transformer.hide(), this.layer.batchDraw());
    }
    showTransformer() {
        this.transformer && (this.transformer.show(), this.transformer.forceUpdate(), this.layer.batchDraw());
    }
    destroy() {
        if (this.transformer) {
            try {
                this.transformer.destroy();
            } catch (t) {
                console.error("Error destroying transformer:", t);
            }
            this.transformer = null;
        }
    }
}
class $47a4b45281b81a8b$var$eh extends $47a4b45281b81a8b$var$Zt {
    constructor(t, e = {}){
        super(t, e), this.guides = [];
    }
    getLineGuideStops(t) {
        const e = [
            0,
            this.stage.width() / 2,
            this.stage.width()
        ], i = [
            0,
            this.stage.height() / 2,
            this.stage.height()
        ];
        return this.stage.find(".object").forEach((n)=>{
            if (n === t) return;
            const r = n.getClientRect();
            e.push(r.x, r.x + r.width / 2, r.x + r.width), i.push(r.y, r.y + r.height / 2, r.y + r.height);
        }), {
            vertical: e.filter((n, r, s)=>s.indexOf(n) === r),
            horizontal: i.filter((n, r, s)=>s.indexOf(n) === r)
        };
    }
    getObjectSnappingEdges(t) {
        const e = t.getClientRect(), i = t.absolutePosition();
        return {
            vertical: [
                {
                    guide: Math.round(e.x),
                    offset: Math.round(i.x - e.x),
                    snap: "start"
                },
                {
                    guide: Math.round(e.x + e.width / 2),
                    offset: Math.round(i.x - e.x - e.width / 2),
                    snap: "center"
                },
                {
                    guide: Math.round(e.x + e.width),
                    offset: Math.round(i.x - e.x - e.width),
                    snap: "end"
                }
            ],
            horizontal: [
                {
                    guide: Math.round(e.y),
                    offset: Math.round(i.y - e.y),
                    snap: "start"
                },
                {
                    guide: Math.round(e.y + e.height / 2),
                    offset: Math.round(i.y - e.y - e.height / 2),
                    snap: "center"
                },
                {
                    guide: Math.round(e.y + e.height),
                    offset: Math.round(i.y - e.y - e.height),
                    snap: "end"
                }
            ]
        };
    }
    getGuides(t, e) {
        const i = [], n = [];
        t.vertical.forEach((o)=>{
            e.vertical.forEach((h)=>{
                const c = Math.abs(o - h.guide);
                c < $47a4b45281b81a8b$var$q.GUIDELINE_OFFSET && i.push({
                    lineGuide: o,
                    diff: c,
                    snap: h.snap,
                    offset: h.offset
                });
            });
        }), t.horizontal.forEach((o)=>{
            e.horizontal.forEach((h)=>{
                const c = Math.abs(o - h.guide);
                c < $47a4b45281b81a8b$var$q.GUIDELINE_OFFSET && n.push({
                    lineGuide: o,
                    diff: c,
                    snap: h.snap,
                    offset: h.offset
                });
            });
        });
        const r = [], s = i.sort((o, h)=>o.diff - h.diff)[0];
        s && r.push({
            lineGuide: s.lineGuide,
            offset: s.offset,
            orientation: "V",
            snap: s.snap
        });
        const a = n.sort((o, h)=>o.diff - h.diff)[0];
        return a && r.push({
            lineGuide: a.lineGuide,
            offset: a.offset,
            orientation: "H",
            snap: a.snap
        }), r;
    }
    drawGuides(t) {
        this.cleanupGuides(), t.forEach((e)=>{
            const i = new $47a4b45281b81a8b$var$rt.Line({
                stroke: "rgb(0, 161, 255)",
                strokeWidth: 1,
                name: "guid-line",
                dash: [
                    4,
                    6
                ],
                listening: !1
            });
            e.orientation === "H" ? (i.points([
                -6000,
                0,
                6e3,
                0
            ]), i.absolutePosition({
                x: 0,
                y: e.lineGuide
            })) : (i.points([
                0,
                -6000,
                0,
                6e3
            ]), i.absolutePosition({
                x: e.lineGuide,
                y: 0
            })), this.layer.add(i), this.guides.push(i);
        }), this.layer.batchDraw();
    }
    cleanupGuides() {
        this.guides.forEach((t)=>{
            t.destroy();
        }), this.guides = [], this.layer.find(".guid-line").forEach((t)=>{
            t.destroy();
        }), this.safeDraw();
    }
    snapToGuides(t) {
        if (!this.readOnly) try {
            this.cleanupGuides();
            const e = this.getLineGuideStops(t), i = this.getObjectSnappingEdges(t), n = this.getGuides(e, i);
            if (!n.length) return;
            this.drawGuides(n);
            const r = t.absolutePosition();
            n.forEach((s)=>{
                switch(s.orientation){
                    case "V":
                        r.x = s.lineGuide + s.offset;
                        break;
                    case "H":
                        r.y = s.lineGuide + s.offset;
                        break;
                }
            }), t.absolutePosition(r);
        } catch (e) {
            console.error("Error in snapToGuides:", e), this.handleDragEnd();
        }
    }
    handleDragEnd() {
        var t, e;
        this.cleanupGuides(), (e = (t = this.callbacks).onChange) == null || e.call(t);
    }
    destroy() {
        this.cleanupGuides();
    }
    hasVisibleGuides() {
        return this.guides.length > 0;
    }
    disableGuides() {
        this.cleanupGuides();
    }
    enableGuides() {}
    updateGuideStyle(t) {
        this.guides.forEach((e)=>{
            e.setAttrs(t);
        }), this.layer.batchDraw();
    }
}
class $47a4b45281b81a8b$var$ih extends $47a4b45281b81a8b$var$Zt {
    constructor(t, e = {}){
        super(t, e), this.RESIZE_DEBOUNCE_TIME = 10, this.originalWidth = $47a4b45281b81a8b$var$q.CANVAS_WIDTH_PX, this.initializeResizeHandler();
    }
    setCanvasHeight(t) {
        this.canvasHeight = t, this.handleResize();
    }
    initializeResizeHandler() {
        window.addEventListener("resize", $47a4b45281b81a8b$var$Gr(()=>this.handleResize(), this.RESIZE_DEBOUNCE_TIME));
    }
    handleResize() {
        if (!this.stage || !this.layer) return;
        const t = this.stage.container();
        if (t) try {
            this.setListening(!1);
            const e = t.offsetWidth, i = e / this.originalWidth;
            this.stage.width(this.originalWidth), this.stage.height(this.canvasHeight), this.stage.scale({
                x: i,
                y: i
            }), t.style.height = `${this.canvasHeight * i}px`, this.stage.size({
                width: e,
                height: this.canvasHeight * i
            }), this.layer.batchDraw();
        } catch (e) {
            console.error("Error during resize:", e);
        } finally{
            setTimeout(()=>{
                this.setListening(!0);
            }, 100);
        }
    }
    setListening(t) {
        var e;
        (e = this.layer) == null || e.getChildren().forEach((i)=>{
            i.setAttr("listening", t);
        });
    }
    getCurrentScale() {
        var t;
        return (t = this.stage) != null && t.container() ? this.stage.container().offsetWidth / this.originalWidth : 1;
    }
    toOriginalPosition(t, e) {
        const i = this.getCurrentScale();
        return {
            x: t / i,
            y: e / i
        };
    }
    toScaledPosition(t, e) {
        const i = this.getCurrentScale();
        return {
            x: t * i,
            y: e * i
        };
    }
    destroy() {
        window.removeEventListener("resize", this.handleResize);
    }
}
class $47a4b45281b81a8b$export$2e2bcd8739ae039 {
    constructor({ data: t, readOnly: e, block: i, api: n, config: r }){
        this.stage = null, this.layer = null, this.toolbarManager = null, this.eventManager = null, this.textEditor = null, this.imageHandler = null, this.transformerManager = null, this.guidelineManager = null, this.responsiveStageManager = null, this.selectedNode = null, this.isDirty = !1, this.isDestroyed = !1, this.loadingOverlay = null, this.AUTO_SAVE_DELAY = 2e3, this.api = n, this.blockId = i.id, this.readOnly = e || !1, this.data = this.initializeData(t), this.config = r, this.wrapper = this.createWrapper(), this.container = this.createContainer(), this.wrapper.appendChild(this.container), this.debouncedAutoSave = $47a4b45281b81a8b$var$Gr(this.saveCanvas.bind(this), this.AUTO_SAVE_DELAY), setTimeout(()=>{
            this.initKonva();
        }, 0);
    }
    static get toolbox() {
        return {
            title: "Drawing",
            icon: $47a4b45281b81a8b$var$Xl
        };
    }
    static get isReadOnlySupported() {
        return !0;
    }
    initializeData(t) {
        return {
            canvasJson: t.canvasJson || null,
            canvasImages: Array.isArray(t.canvasImages) ? t.canvasImages : [],
            canvasHeight: t.canvasHeight ? parseInt(t.canvasHeight.toString(), 10) : $47a4b45281b81a8b$var$q.CANVAS_HEIGHT_PX
        };
    }
    createWrapper() {
        const t = document.createElement("div");
        return t.classList.add("konva-editor-wrapper"), t.style.width = "100%", t.style.position = "relative", this.readOnly ? t.style.border = "none" : (t.style.border = "1px solid #e0e0e0", t.style.borderRadius = "4px"), t;
    }
    createContainer() {
        const t = document.createElement("div");
        return t.id = `konva-container-${this.blockId}`, t.classList.add("konva-editor-container"), t.style.width = "100%", t.style.height = `${this.data.canvasHeight}px`, t.style.position = "relative", t.style.overflow = "hidden", t;
    }
    initKonva() {
        try {
            this.stage = new $47a4b45281b81a8b$var$rt.Stage({
                container: this.container,
                width: this.container.offsetWidth,
                height: parseInt(this.data.canvasHeight.toString(), 10)
            }), this.layer = new $47a4b45281b81a8b$var$rt.Layer(), this.stage.add(this.layer), this.initializeModules(), this.loadCanvas(this.data), this.layer.batchDraw();
        } catch (t) {
            throw console.error("Error initializing Konva:", t), new Error("Failed to initialize canvas editor");
        }
    }
    initializeModules() {
        var i, n;
        if (!this.stage || !this.layer) return;
        const t = {
            stage: this.stage,
            layer: this.layer,
            blockId: this.blockId,
            readOnly: this.readOnly,
            onDirty: ()=>this.setDirty(!0),
            notifier: this.api.notifier
        }, e = {
            onSelect: (r)=>{
                this.handleSelection(r);
            },
            onChange: ()=>{
                this.setDirty(!0);
            },
            onDelete: ()=>{
                this.deleteNode();
            },
            onAddText: ()=>{
                var r;
                (r = this.textEditor) == null || r.addText();
            },
            onTextPropertyChange: (r)=>{
                var s;
                (s = this.textEditor) == null || s.updateTextProperties(this.selectedNode, r);
            },
            onTextEdit: (r)=>{
                var s;
                (s = this.textEditor) == null || s.createTextEditor(r);
            },
            onImageUpload: (r)=>{
                var s;
                (s = this.imageHandler) == null || s.handleImageUpload(r);
            },
            onImageAdd: (r)=>{
                this.addImage(r);
            },
            onCanvasResize: (r)=>{
                this.resizeCanvas(r);
            },
            onCanvasSave: ()=>{
                this.saveCanvas();
            },
            onTransformStart: ()=>{
                this.setDirty(!0);
            },
            onTransformEnd: ()=>{
                this.setDirty(!0), this.debouncedAutoSave();
            },
            onHideTransformer: ()=>{
                var r;
                (r = this.transformerManager) == null || r.hideTransformer();
            },
            onShowTransformer: ()=>{
                var r;
                (r = this.transformerManager) == null || r.showTransformer();
            },
            onDragStart: ()=>{
                var r;
                (r = this.guidelineManager) == null || r.cleanupGuides();
            },
            onDragMove: (r)=>{
                var s;
                (s = this.guidelineManager) == null || s.snapToGuides(r);
            },
            onDragEnd: ()=>{
                var r;
                (r = this.guidelineManager) == null || r.cleanupGuides(), this.setDirty(!0), this.debouncedAutoSave();
            },
            onShowLoading: ()=>this.showLoading(),
            onHideLoading: ()=>this.hideLoading()
        };
        this.toolbarManager = new $47a4b45281b81a8b$var$ql(t, e), this.eventManager = new $47a4b45281b81a8b$var$Jl(t, e), this.textEditor = new $47a4b45281b81a8b$var$Ql(t, e), this.imageHandler = new $47a4b45281b81a8b$var$Zl(t, e, (n = (i = this.config) == null ? void 0 : i.uploader) == null ? void 0 : n.uploadImage), this.transformerManager = new $47a4b45281b81a8b$var$th(t, e), this.guidelineManager = new $47a4b45281b81a8b$var$eh(t, e), this.responsiveStageManager = new $47a4b45281b81a8b$var$ih(t, e), this.responsiveStageManager.setCanvasHeight(this.data.canvasHeight), this.readOnly || (this.wrapper.insertBefore(this.toolbarManager.createMainToolbar(this.data.canvasHeight), this.container), this.wrapper.insertBefore(this.toolbarManager.createTextToolbar(), this.container));
    }
    createLoadingOverlay() {
        const t = document.createElement("div");
        t.classList.add("konva-editor-loading"), t.style.cssText = `
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.7);
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.3s;
    pointer-events: none;
  `;
        const e = document.createElement("div");
        e.classList.add("konva-editor-spinner"), e.style.cssText = `
    width: 40px;
    height: 40px;
    border: 4px solid #f3f3f3;
    border-top: 4px solid #3498db;
    border-radius: 50%;
    animation: konva-editor-spin 2s linear infinite;
  `;
        const i = document.createElement("style");
        return i.textContent = `
    @keyframes konva-editor-spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `, document.head.appendChild(i), t.appendChild(e), t;
    }
    showLoading() {
        this.loadingOverlay || (this.loadingOverlay = this.createLoadingOverlay(), this.wrapper.appendChild(this.loadingOverlay), this.loadingOverlay.offsetWidth), this.loadingOverlay.style.opacity = "1", this.loadingOverlay.style.pointerEvents = "auto";
    }
    hideLoading() {
        this.loadingOverlay && (this.loadingOverlay.style.opacity = "0", this.loadingOverlay.style.pointerEvents = "none");
    }
    loadCanvas(t) {
        try {
            if (!this.layer) return;
            if (this.showLoading(), this.layer.destroyChildren(), t.canvasJson) {
                const e = JSON.parse(t.canvasJson);
                t.canvasImages.length === 0 && this.hideLoading();
                const i = t.canvasImages.map((n)=>new Promise((r, s)=>{
                        const a = new Image();
                        a.onload = ()=>{
                            var h;
                            const o = new $47a4b45281b81a8b$var$rt.Image({
                                ...n.attrs,
                                image: a,
                                draggable: !this.readOnly,
                                name: "object"
                            });
                            (h = this.layer) == null || h.add(o), r();
                        }, a.onerror = s, a.src = n.src;
                    }));
                Promise.all(i).then(()=>{
                    var n;
                    e.children.forEach((r)=>{
                        var s, a, o;
                        if (r.className !== "Image") {
                            const h = $47a4b45281b81a8b$var$rt.Node.create(r);
                            h instanceof $47a4b45281b81a8b$var$rt.Text && ((s = this.textEditor) == null || s.attachDoubleClickHandler(h), (a = this.textEditor) == null || a.attachClickHandler(h)), h.draggable(!this.readOnly), (o = this.layer) == null || o.add(h);
                        }
                    }), (n = this.layer) == null || n.batchDraw();
                }).catch((n)=>{
                    console.error("Error loading images:", n);
                }).finally(()=>{
                    this.hideLoading();
                });
            } else this.hideLoading();
        } catch (e) {
            console.error("Error loading canvas:", e), this.hideLoading();
        }
    }
    async saveCanvas() {
        var t;
        if (!this.layer || !this.isDirty) return this.data;
        try {
            (t = this.guidelineManager) == null || t.cleanupGuides();
            const e = this.layer.toJSON(), i = [], n = this.layer.find("Image");
            return n.length === 0 ? this.handleSaveComplete(e, i) : (n.forEach((r)=>{
                const s = r.image();
                s && (async ()=>{
                    var o, h;
                    return !s.src.startsWith("http") && (h = (o = this.config) == null ? void 0 : o.uploader) != null && h.uploadImage ? await this.config.uploader.uploadImage(s.src) : s.src;
                })().then((o)=>{
                    i.push({
                        id: r.id() || $47a4b45281b81a8b$var$Qn(),
                        src: o,
                        attrs: r.attrs
                    });
                }).catch((o)=>{
                    console.error("Error uploading image:", o), this.uploadingFailed();
                });
            }), this.handleSaveComplete(e, i));
        } catch (e) {
            console.error("Error saving canvas:", e);
        }
    }
    handleSaveComplete(t, e) {
        return this.data = {
            ...this.data,
            canvasJson: t,
            canvasImages: e
        }, this.setDirty(!1), this.data;
    }
    handleSelection(t) {
        var e, i, n, r, s;
        if (!this.readOnly) try {
            this.selectedNode && (!t || t !== this.selectedNode) && ((e = this.transformerManager) == null || e.clearTransformer()), this.selectedNode = t, t && this.isNodeInCurrentEditor(t) ? ((i = this.transformerManager) == null || i.createTransformerForNode(t), (n = this.toolbarManager) == null || n.updateToolbarState(t)) : ((r = this.transformerManager) == null || r.clearTransformer(), (s = this.toolbarManager) == null || s.updateToolbarState(null));
        } catch (a) {
            console.error("Error handling selection:", a);
        }
    }
    deleteNode() {
        var t, e, i;
        if (!(this.readOnly || !this.isNodeInCurrentEditor(this.selectedNode))) try {
            if (this.selectedNode instanceof $47a4b45281b81a8b$var$rt.Image) {
                const n = this.selectedNode.id();
                n && (this.data.canvasImages = this.data.canvasImages.filter((s)=>s.id !== n));
                const r = this.selectedNode.image();
                r && (r.src = "", this.selectedNode.clearCache());
            }
            (t = this.transformerManager) == null || t.clearTransformer(), this.selectedNode.destroy(), this.selectedNode = null, (e = this.toolbarManager) == null || e.updateToolbarState(null), (i = this.layer) == null || i.batchDraw(), this.setDirty(!0), this.debouncedAutoSave();
        } catch (n) {
            console.error("Error deleting node:", n);
        }
    }
    addImage(t) {
        var e;
        if (!this.readOnly) try {
            t.draggable(!0), t.name("object"), t.id($47a4b45281b81a8b$var$Qn()), (e = this.layer) == null || e.add(t), this.handleSelection(t), this.setDirty(!0), this.debouncedAutoSave();
        } catch (i) {
            console.error("Error adding image:", i);
        }
    }
    resizeCanvas(t) {
        var e;
        if (!(!this.stage || !this.container)) try {
            (e = this.responsiveStageManager) == null || e.setCanvasHeight(t), this.data.canvasHeight = t, this.setDirty(!0), this.debouncedAutoSave();
        } catch (i) {
            console.error("Error resizing canvas:", i);
        }
    }
    setDirty(t) {
        var e;
        this.isDirty = t, (e = this.toolbarManager) == null || e.updateSaveIndicator(t);
    }
    isNodeInCurrentEditor(t) {
        var e;
        return t && ((e = t.getStage()) == null ? void 0 : e.container().id) === this.container.id;
    }
    render() {
        return this.wrapper;
    }
    save() {
        return this.saveCanvas();
    }
    validate(t) {
        try {
            return t.canvasJson && JSON.parse(t.canvasJson), !0;
        } catch (e) {
            return console.debug(e), !1;
        }
    }
    destroy() {
        var t, e, i, n, r, s, a, o, h;
        if (!this.isDestroyed) try {
            this.isDirty && this.saveCanvas(), (t = this.eventManager) == null || t.destroy(), (e = this.toolbarManager) == null || e.destroy(), (i = this.guidelineManager) == null || i.destroy(), (n = this.transformerManager) == null || n.destroy(), (r = this.textEditor) == null || r.destroy(), (s = this.imageHandler) == null || s.destroy(), (a = this.responsiveStageManager) == null || a.destroy(), (o = this.layer) == null || o.destroy(), (h = this.stage) == null || h.destroy(), this.wrapper.remove(), this.stage = null, this.layer = null, this.selectedNode = null, this.isDestroyed = !0;
        } catch (c) {
            console.error("Error destroying editor:", c);
        }
    }
    uploadingFailed() {
        this.api.notifier.show({
            message: this.api.i18n.t("Couldn\u2019t upload image. Please try another."),
            style: "error"
        });
    }
}

});

parcelRegister("2DADN", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ebba565b88b35cb$export$2e2bcd8739ae039);
// Custom Editor.js block tool for embedding DOMQL/Symbols components.
// Users write a DOMQL component definition as JSON, and it renders live
// inside the editor block.
class $1ebba565b88b35cb$export$2e2bcd8739ae039 {
    static get toolbox() {
        return {
            title: 'DOMQL Component',
            icon: '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M16 18l6-6-6-6"/><path d="M8 6l-6 6 6 6"/></svg>'
        };
    }
    static get isReadOnlySupported() {
        return true;
    }
    constructor({ data: data, api: api, readOnly: readOnly }){
        this.api = api;
        this.readOnly = readOnly;
        this.data = {
            code: data.code || '{\n  text: "Hello from Symbols"\n}',
            caption: data.caption || ''
        };
        this.wrapper = null;
        this.codeEl = null;
        this.previewEl = null;
    }
    render() {
        this.wrapper = document.createElement('div');
        this.wrapper.style.cssText = 'border: 1px solid rgba(255,255,255,0.1); border-radius: 8px; overflow: hidden; margin: 4px 0;';
        // Header bar
        const header = document.createElement('div');
        header.style.cssText = 'display: flex; align-items: center; justify-content: space-between; padding: 6px 12px; background: rgba(255,255,255,0.05); border-bottom: 1px solid rgba(255,255,255,0.1); font-size: 12px; color: rgba(255,255,255,0.5);';
        header.innerHTML = '<span>&lt;/&gt; DOMQL Component</span>';
        // Toggle button
        const toggleBtn = document.createElement('button');
        toggleBtn.textContent = 'Preview';
        toggleBtn.style.cssText = 'background: rgba(255,255,255,0.1); border: none; color: rgba(255,255,255,0.7); padding: 2px 8px; border-radius: 4px; cursor: pointer; font-size: 11px;';
        toggleBtn.addEventListener('click', ()=>this._togglePreview());
        header.appendChild(toggleBtn);
        this.toggleBtn = toggleBtn;
        this.wrapper.appendChild(header);
        // Code editor area
        this.codeEl = document.createElement('textarea');
        this.codeEl.value = this.data.code;
        this.codeEl.style.cssText = 'width: 100%; min-height: 120px; padding: 12px; background: rgba(0,0,0,0.3); color: #e0e0e0; border: none; outline: none; resize: vertical; font-family: monospace; font-size: 13px; line-height: 1.5; tab-size: 2;';
        this.codeEl.spellcheck = false;
        if (this.readOnly) this.codeEl.readOnly = true;
        this.codeEl.addEventListener('input', ()=>{
            this.data.code = this.codeEl.value;
        });
        // Tab key support
        this.codeEl.addEventListener('keydown', (e)=>{
            if (e.key === 'Tab') {
                e.preventDefault();
                const start = this.codeEl.selectionStart;
                const end = this.codeEl.selectionEnd;
                this.codeEl.value = this.codeEl.value.substring(0, start) + '  ' + this.codeEl.value.substring(end);
                this.codeEl.selectionStart = this.codeEl.selectionEnd = start + 2;
                this.data.code = this.codeEl.value;
            }
        });
        this.wrapper.appendChild(this.codeEl);
        // Preview area (hidden by default)
        this.previewEl = document.createElement('div');
        this.previewEl.style.cssText = 'padding: 16px; background: rgba(0,0,0,0.2); display: none; min-height: 60px;';
        this.wrapper.appendChild(this.previewEl);
        // Caption
        const caption = document.createElement('input');
        caption.value = this.data.caption;
        caption.placeholder = 'Component caption (optional)';
        caption.style.cssText = 'width: 100%; padding: 6px 12px; background: transparent; border: none; border-top: 1px solid rgba(255,255,255,0.05); color: rgba(255,255,255,0.4); font-size: 12px; outline: none;';
        if (this.readOnly) caption.readOnly = true;
        caption.addEventListener('input', ()=>{
            this.data.caption = caption.value;
        });
        this.wrapper.appendChild(caption);
        return this.wrapper;
    }
    _togglePreview() {
        const showing = this.previewEl.style.display !== 'none';
        if (showing) {
            this.previewEl.style.display = 'none';
            this.codeEl.style.display = 'block';
            this.toggleBtn.textContent = 'Preview';
        } else {
            this.previewEl.style.display = 'block';
            this.codeEl.style.display = 'none';
            this.toggleBtn.textContent = 'Code';
            this._renderPreview();
        }
    }
    _renderPreview() {
        this.previewEl.innerHTML = '';
        try {
            // Try to evaluate the code as a DOMQL-like object
            // eslint-disable-next-line no-new-func
            const fn = new Function(`return (${this.data.code})`);
            const obj = fn();
            // Render a simplified preview
            const pre = document.createElement('pre');
            pre.style.cssText = 'margin: 0; font-size: 12px; color: #a0e0a0; white-space: pre-wrap;';
            pre.textContent = JSON.stringify(obj, null, 2);
            this.previewEl.appendChild(pre);
            const note = document.createElement('div');
            note.style.cssText = 'margin-top: 8px; font-size: 11px; color: rgba(255,255,255,0.3);';
            note.textContent = 'Full DOMQL rendering available in article view';
            this.previewEl.appendChild(note);
        } catch (err) {
            const errEl = document.createElement('div');
            errEl.style.cssText = 'color: #ff6b6b; font-size: 12px;';
            errEl.textContent = `Error: ${err.message}`;
            this.previewEl.appendChild(errEl);
        }
    }
    save() {
        return {
            code: this.data.code,
            caption: this.data.caption
        };
    }
    validate(savedData) {
        return savedData.code && savedData.code.trim().length > 0;
    }
}

});

parcelRegister("4GQZE", function(module, exports) {

$parcel$export(module.exports, "editorDarkStyles", () => $36a43106f6280a04$export$785a97118d2e08a5);
$parcel$export(module.exports, "ensureDarkCSS", () => $36a43106f6280a04$export$687152044f1f9bc3);
// Editor.js dark theme for DOMQL — adapted from
// platform/.legacy/StateEditorjs/style.js
// Uses design system tokens (gray3-6, blue.35, etc.)
const $36a43106f6280a04$export$785a97118d2e08a5 = {
    '@dark': {
        '& a': {
            color: 'white'
        },
        '& .ce-popover, & .ce-popover__container, & .ce-conversion-toolbar': {
            background: 'gray5.95',
            border: 'none'
        },
        '& .ce-popover__items': {
            background: 'transparent'
        },
        '& .ce-popover__item-label': {
            color: 'white'
        },
        '& .ce-popover__item-description': {
            color: 'white.5'
        },
        '& .ce-conversion-toolbar__label': {
            color: 'currentColor'
        },
        '& .cdx-search-field': {
            background: 'gray6.95',
            color: 'white',
            border: 'none'
        },
        '& .ce-conversion-tool:hover': {
            background: 'gray3'
        },
        '& .cdx-search-field__icon svg': {
            color: 'currentColor',
            border: 'none'
        },
        '& .ce-popover__item': {
            ':hover': {
                background: 'gray3',
                color: 'currentColor'
            }
        },
        '& .ce-popover__item-icon, & .ce-conversion-tool__icon': {
            border: 'none',
            boxShadow: 'none',
            margin: '- X2 - -',
            background: 'transparent',
            color: 'currentColor'
        },
        '& .ce-popover__item:hover:not(.ce-popover__item--no-visible-hover)': {
            '&': {
                background: 'gray3'
            }
        },
        '& .ce-inline-tool': {
            color: 'currentColor',
            ':hover': {
                background: 'gray6',
                color: 'currentColor'
            }
        },
        '& .ce-toolbar': {
            color: 'currentColor !important'
        },
        '& .ce-toolbar__actions': {
            color: 'currentColor'
        },
        '& .ce-inline-toolbar': {
            border: 'transparent',
            background: 'gray5.95',
            backdropFilter: 'blur(10px)'
        },
        '& .ce-inline-toolbar__dropdown': {
            ':hover': {
                background: 'gray5',
                color: 'currentColor'
            }
        },
        '& .tc-toolbox__toggler svg': {
            color: 'currentColor'
        },
        '& .ce-inline-toolbar__buttons': {
            color: 'currentColor'
        },
        '& .ce-toolbar__plus': {
            color: 'currentColor',
            ':hover': {
                background: 'gray4',
                color: 'currentColor'
            }
        },
        '& .cdx-search-field__input': {
            '::placeholder': {
                color: 'white.5'
            }
        },
        '& .tc-table': {
            borderTop: '1px solid gray5'
        },
        '& .tc-add-column': {
            borderTop: '1px solid gray5'
        },
        '& .tc-row': {
            borderBottom: '1px solid gray5'
        },
        '& .tc-cell': {
            borderRight: '1px solid gray5'
        },
        '& .inline-image__search, & .inline-image__caption': {
            marginInline: '0'
        },
        '& .inline-image__tab-wrapper': {
            gap: 'Z',
            borderBottom: '1px solid gray5'
        },
        '& .ce-inline-tool-hyperlink--input': {
            background: 'gray4'
        },
        '& .ce-inline-tool-hyperlink--select-target': {
            background: 'gray4'
        },
        '& .ce-inline-tool-hyperlink--button': {
            background: 'gray5'
        },
        '& .cdx-marker': {
            background: 'blue.35',
            color: 'currentColor',
            round: 'Y'
        },
        '& .ce-paragraph': {
            '::selection': {
                background: 'blue.35',
                color: 'currentColor',
                round: 'Y'
            }
        },
        '& .inline-image__tab': {
            '&.active': {
                background: 'gray4',
                borderBottom: '3px solid blue'
            },
            ':hover': {
                background: 'gray4'
            }
        },
        '& .inline-image__control-panel': {
            padding: 'A 0'
        },
        '& .cdx-input': {
            border: 'none',
            background: 'gray4',
            color: 'currentColor',
            '::before': {
                color: 'white.5'
            }
        },
        '& .cdx-warning:before': {
            background: 'url("data:image/svg+xml,%3Csvg width=\'24\' height=\'24\' viewBox=\'0 0 24 24\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Crect x=\'5\' y=\'5\' width=\'14\' height=\'14\' rx=\'4\' stroke=\'white\' stroke-width=\'2\'/%3E%3Cline x1=\'12\' y1=\'9\' x2=\'12\' y2=\'12\' stroke=\'white\' stroke-width=\'2\' stroke-linecap=\'round\'/%3E%3Cpath d=\'M12 15.02V15.01\' stroke=\'white\' stroke-width=\'2\' stroke-linecap=\'round\'/%3E%3C/svg%3E")'
        },
        '& .cdx-warning__title': {
            theme: 'transparentPattern'
        },
        '& .ce-toolbar__settings-btn': {
            color: 'currentColor',
            ':hover': {
                background: 'gray4',
                color: 'currentColor'
            }
        },
        '& .ce-block__content': {
            color: 'currentColor'
        },
        '& .ce-block--selected .ce-block__content': {
            background: 'gray4'
        },
        '& .ce-inline-toolbar__toggler-and-button-wrapper': {
            color: 'currentColor'
        },
        '& .ce-popover__item--focused:not(.ce-popover__item--no-focus)': {
            background: 'gray3',
            boxShadow: 'none'
        },
        '& .ce-popover__item-icon svg': {
            color: 'currentColor'
        }
    }
};
// Injected CSS fallback for deeply nested Editor.js DOM
const $36a43106f6280a04$var$_DARK_CSS = `
.codex-editor, .codex-editor *, .ce-paragraph, .ce-header, .cdx-block { color: currentColor !important; }
.codex-editor a { color: #60a5fa !important; }
.codex-editor ::selection { background: rgba(59,130,246,.35); }
.ce-popover, .ce-popover--opened, .ce-popover__container, .ce-conversion-toolbar {
  background: rgba(20,20,20,.95) !important; border: none !important;
  color: currentColor !important; box-shadow: 0 4px 16px rgba(0,0,0,.5) !important;
}
.ce-popover__container { border-radius: 8px !important; }
.ce-popover__items { background: transparent !important; }
.ce-popover__item-label { color: rgba(255,255,255,.85) !important; }
.ce-popover__item-description { color: rgba(255,255,255,.4) !important; }
.ce-conversion-toolbar__label { color: currentColor !important; }
.cdx-search-field { background: rgba(30,30,30,.95) !important; color: white !important; border: none !important; }
.cdx-search-field__icon svg { color: currentColor !important; }
.cdx-search-field__input { color: white !important; }
.cdx-search-field__input::placeholder { color: rgba(255,255,255,.5) !important; }
.ce-conversion-tool:hover { background: rgba(60,60,60,.8) !important; }
.ce-popover__item { color: currentColor !important; }
.ce-popover__item:hover, .ce-popover__item:hover:not(.ce-popover__item--no-visible-hover) {
  background: rgba(60,60,60,.8) !important;
}
.ce-popover__item-icon, .ce-conversion-tool__icon {
  border: none !important; box-shadow: none !important;
  background: transparent !important; color: currentColor !important;
}
.ce-inline-tool { color: currentColor !important; }
.ce-inline-tool:hover { background: rgba(40,40,40,.8) !important; }
.ce-toolbar { color: currentColor !important; }
.ce-toolbar__actions { color: currentColor !important; }
.ce-inline-toolbar {
  border: transparent !important; background: rgba(20,20,20,.95) !important;
  backdrop-filter: blur(10px) !important;
}
.ce-inline-toolbar__dropdown:hover { background: rgba(40,40,40,.8) !important; }
.ce-inline-toolbar__buttons { color: currentColor !important; }
.ce-toolbar__plus { color: currentColor !important; }
.ce-toolbar__plus:hover { background: rgba(50,50,50,.8) !important; }
.ce-toolbar__settings-btn { color: currentColor !important; }
.ce-toolbar__settings-btn:hover { background: rgba(50,50,50,.8) !important; }
.ce-block__content { color: currentColor !important; }
.ce-block--selected .ce-block__content { background: rgba(50,50,50,.6) !important; }
.ce-inline-toolbar__toggler-and-button-wrapper { color: currentColor !important; }
.ce-popover__item--focused:not(.ce-popover__item--no-focus) { background: rgba(60,60,60,.8) !important; box-shadow: none !important; }
.ce-popover__item-icon svg { color: currentColor !important; }
.cdx-input { border: none !important; background: rgba(50,50,50,.6) !important; color: currentColor !important; }
.cdx-marker { background: rgba(59,130,246,.35) !important; border-radius: 2px; }
.tc-table { border-top: 1px solid rgba(80,80,80,.6) !important; }
.tc-row { border-bottom: 1px solid rgba(80,80,80,.6) !important; }
.tc-cell { border-right: 1px solid rgba(80,80,80,.6) !important; }
.ce-code__textarea { background: rgba(20,20,20,.95) !important; color: currentColor !important; border: none !important; }
`;
let $36a43106f6280a04$var$_injected = false;
const $36a43106f6280a04$export$687152044f1f9bc3 = ()=>{
    if ($36a43106f6280a04$var$_injected) return;
    const style = document.createElement('style');
    style.id = 'smbls-editorjs-dark';
    style.textContent = $36a43106f6280a04$var$_DARK_CSS;
    document.head.appendChild(style);
    $36a43106f6280a04$var$_injected = true;
};

});


parcelRegister("3zNqF", function(module, exports) {

$parcel$export(module.exports, "transformEditorJS", () => (parcelRequire("bvL1f")).transformEditorJS);
// Editor.js → DOMQL v3 transpiler
// Converts Editor.js block data into DOMQL v3 component objects
// via the shared Symbolize IR layer.
// Same pattern as symbolize-markdown and symbolize-html.

var $bvL1f = parcelRequire("bvL1f");

});
parcelRegister("bvL1f", function(module, exports) {

$parcel$export(module.exports, "transformEditorJS", () => $86170ffd0f7491a4$export$4180072156ffe3d9);
// Editor.js blocks → DOMQL v3 converter
// Follows the same IR pattern as symbolize-markdown and symbolize-html.
parcelRequire("3YaVL");
var $l5F2G = parcelRequire("l5F2G");
var $1wHA0 = parcelRequire("1wHA0");
const $86170ffd0f7491a4$export$71abc632aa29e6fe = {
    h1: 'H1',
    h2: 'H2',
    h3: 'H3',
    h4: 'H4',
    h5: 'H5',
    h6: 'H6',
    paragraph: 'P',
    pre: 'CodeExample',
    code: 'CodeExample',
    inlineCode: 'Span',
    blockquote: 'Blockquote',
    ul: 'UL',
    ol: 'OL',
    li: 'LI',
    hr: 'Hr',
    table: 'Table',
    tr: 'Tr',
    td: 'Td',
    link: 'Link',
    img: 'Img',
    span: 'Span',
    strong: 'Strong',
    em: 'Em',
    del: 'Del',
    mark: 'Mark'
};
let $86170ffd0f7491a4$var$currentComponents = $86170ffd0f7491a4$export$71abc632aa29e6fe;
function $86170ffd0f7491a4$var$c(key) {
    return $86170ffd0f7491a4$var$currentComponents[key] || $86170ffd0f7491a4$export$71abc632aa29e6fe[key];
}
function $86170ffd0f7491a4$export$4180072156ffe3d9(editorData, options = {}) {
    $86170ffd0f7491a4$var$currentComponents = options.components ? {
        ...$86170ffd0f7491a4$export$71abc632aa29e6fe,
        ...options.components
    } : $86170ffd0f7491a4$export$71abc632aa29e6fe;
    const blocks = editorData?.blocks || [];
    const irNodes = blocks.map($86170ffd0f7491a4$var$blockToIR).filter(Boolean);
    return (0, $1wHA0.toSymbols)(irNodes);
}
const $86170ffd0f7491a4$export$705cfdab62a7fa6a = $86170ffd0f7491a4$export$4180072156ffe3d9;
// ── Block → IR ────────────────────────────────────────────────────
function $86170ffd0f7491a4$var$blockToIR(block) {
    const { type: type, data: data } = block;
    if (!data) return null;
    switch(type){
        case 'header':
            return $86170ffd0f7491a4$var$headerToIR(data);
        case 'paragraph':
            return $86170ffd0f7491a4$var$paragraphToIR(data);
        case 'list':
            return $86170ffd0f7491a4$var$listToIR(data);
        case 'quote':
            return $86170ffd0f7491a4$var$quoteToIR(data);
        case 'code':
            return $86170ffd0f7491a4$var$codeToIR(data);
        case 'delimiter':
            return (0, $l5F2G.createIRNode)($86170ffd0f7491a4$var$c('hr'), {
                tag: 'hr'
            });
        case 'table':
            return $86170ffd0f7491a4$var$tableToIR(data);
        case 'linkTool':
            return $86170ffd0f7491a4$var$linkToIR(data);
        case 'image':
            return $86170ffd0f7491a4$var$imageToIR(data);
        case 'drawing':
            return $86170ffd0f7491a4$var$drawingToIR(data);
        case 'warning':
            return $86170ffd0f7491a4$var$warningToIR(data);
        case 'domql':
            return $86170ffd0f7491a4$var$domqlBlockToIR(data);
        default:
            // Unknown block — render as paragraph if it has text
            if (data.text) return $86170ffd0f7491a4$var$paragraphToIR(data);
            return null;
    }
}
function $86170ffd0f7491a4$var$headerToIR(data) {
    const level = data.level || 2;
    const inlineChildren = $86170ffd0f7491a4$var$parseInlineHTML(data.text || '');
    if (inlineChildren.length === 1 && typeof inlineChildren[0] === 'string') return (0, $l5F2G.createIRNode)($86170ffd0f7491a4$var$c(`h${level}`), {
        tag: `h${level}`,
        text: inlineChildren[0]
    });
    return (0, $l5F2G.createIRNode)($86170ffd0f7491a4$var$c(`h${level}`), {
        tag: `h${level}`,
        children: $86170ffd0f7491a4$var$inlineToIR(inlineChildren)
    });
}
function $86170ffd0f7491a4$var$paragraphToIR(data) {
    const inlineChildren = $86170ffd0f7491a4$var$parseInlineHTML(data.text || '');
    if (inlineChildren.length === 1 && typeof inlineChildren[0] === 'string') return (0, $l5F2G.createIRNode)($86170ffd0f7491a4$var$c('paragraph'), {
        tag: 'p',
        text: inlineChildren[0]
    });
    return (0, $l5F2G.createIRNode)($86170ffd0f7491a4$var$c('paragraph'), {
        tag: 'p',
        children: $86170ffd0f7491a4$var$inlineToIR(inlineChildren)
    });
}
function $86170ffd0f7491a4$var$listToIR(data) {
    const isOrdered = data.style === 'ordered';
    const tag = isOrdered ? 'ol' : 'ul';
    const type = isOrdered ? $86170ffd0f7491a4$var$c('ol') : $86170ffd0f7491a4$var$c('ul');
    const items = (data.items || []).map((item)=>{
        const text = typeof item === 'string' ? item : item.content || '';
        const inlineChildren = $86170ffd0f7491a4$var$parseInlineHTML(text);
        const nestedItems = item.items || [];
        const liProps = {};
        if (inlineChildren.length === 1 && typeof inlineChildren[0] === 'string') liProps.text = inlineChildren[0];
        else liProps.children = $86170ffd0f7491a4$var$inlineToIR(inlineChildren);
        // Nested list
        if (nestedItems.length) {
            const nestedIR = $86170ffd0f7491a4$var$listToIR({
                ...data,
                items: nestedItems
            });
            if (!liProps.children) liProps.children = [];
            liProps.children.push(nestedIR);
        }
        return (0, $l5F2G.createIRNode)($86170ffd0f7491a4$var$c('li'), {
            tag: 'li',
            ...liProps
        });
    });
    return (0, $l5F2G.createIRNode)(type, {
        tag: tag,
        children: items
    });
}
function $86170ffd0f7491a4$var$quoteToIR(data) {
    const inlineChildren = $86170ffd0f7491a4$var$parseInlineHTML(data.text || '');
    const quoteProps = {};
    if (inlineChildren.length === 1 && typeof inlineChildren[0] === 'string') quoteProps.text = inlineChildren[0];
    else quoteProps.children = $86170ffd0f7491a4$var$inlineToIR(inlineChildren);
    return (0, $l5F2G.createIRNode)($86170ffd0f7491a4$var$c('blockquote'), {
        tag: 'blockquote',
        ...quoteProps
    });
}
function $86170ffd0f7491a4$var$codeToIR(data) {
    return (0, $l5F2G.createIRNode)($86170ffd0f7491a4$var$c('code'), {
        props: {
            value: data.code || ''
        }
    });
}
function $86170ffd0f7491a4$var$tableToIR(data) {
    const rows = (data.content || []).map((row)=>{
        const cells = row.map((cell)=>{
            const inlineChildren = $86170ffd0f7491a4$var$parseInlineHTML(cell || '');
            if (inlineChildren.length === 1 && typeof inlineChildren[0] === 'string') return (0, $l5F2G.createIRNode)($86170ffd0f7491a4$var$c('td'), {
                tag: 'td',
                text: inlineChildren[0]
            });
            return (0, $l5F2G.createIRNode)($86170ffd0f7491a4$var$c('td'), {
                tag: 'td',
                children: $86170ffd0f7491a4$var$inlineToIR(inlineChildren)
            });
        });
        return (0, $l5F2G.createIRNode)($86170ffd0f7491a4$var$c('tr'), {
            tag: 'tr',
            children: cells
        });
    });
    return (0, $l5F2G.createIRNode)($86170ffd0f7491a4$var$c('table'), {
        tag: 'table',
        children: rows
    });
}
function $86170ffd0f7491a4$var$linkToIR(data) {
    const text = data.meta?.title || data.link || '';
    return (0, $l5F2G.createIRNode)($86170ffd0f7491a4$var$c('link'), {
        tag: 'a',
        text: text,
        props: {
            href: data.link || '#',
            target: '_blank',
            rel: 'noopener'
        }
    });
}
function $86170ffd0f7491a4$var$imageToIR(data) {
    return (0, $l5F2G.createIRNode)($86170ffd0f7491a4$var$c('img'), {
        tag: 'img',
        props: {
            src: data.url || data.file?.url || '',
            alt: data.caption || ''
        }
    });
}
function $86170ffd0f7491a4$var$drawingToIR(data) {
    // Drawing tool saves SVG data as a base64 image
    if (data.data) return (0, $l5F2G.createIRNode)($86170ffd0f7491a4$var$c('img'), {
        tag: 'img',
        props: {
            src: data.data,
            alt: 'Drawing'
        }
    });
    return null;
}
function $86170ffd0f7491a4$var$domqlBlockToIR(data) {
    // The DOMQL tool stores raw component code as a string.
    // Parse it and return as-is — it's already a DOMQL component definition.
    // We wrap it in a special IR node that toSymbols will pass through.
    try {
        // eslint-disable-next-line no-new-func
        const fn = new Function(`return (${data.code || '{}'})`);
        const component = fn();
        // Return a wrapper node; the component itself is the child
        const node = (0, $l5F2G.createIRNode)('DomqlEmbed', {
            tag: 'div'
        });
        node.__domqlRaw = component;
        node.__caption = data.caption || '';
        return node;
    } catch (err) {
        return (0, $l5F2G.createIRNode)($86170ffd0f7491a4$var$c('code'), {
            tag: 'code',
            text: data.code || ''
        });
    }
}
function $86170ffd0f7491a4$var$warningToIR(data) {
    const titleNode = (0, $l5F2G.createIRNode)($86170ffd0f7491a4$var$c('strong'), {
        tag: 'strong',
        text: data.title || 'Warning'
    });
    const messageNode = (0, $l5F2G.createIRNode)($86170ffd0f7491a4$var$c('paragraph'), {
        tag: 'p',
        text: data.message || ''
    });
    return (0, $l5F2G.createIRNode)($86170ffd0f7491a4$var$c('blockquote'), {
        tag: 'blockquote',
        children: [
            titleNode,
            messageNode
        ]
    });
}
// ── Inline HTML parsing ───────────────────────────────────────────
// Editor.js stores inline formatting as HTML tags (<b>, <i>, <a>, <mark>, etc.)
function $86170ffd0f7491a4$var$parseInlineHTML(html) {
    if (!html) return [
        ''
    ];
    // If no HTML tags, return as plain text
    if (!/<[a-z][\s\S]*>/i.test(html)) return [
        html
    ];
    const result = [];
    let current = '';
    let i = 0;
    while(i < html.length)if (html[i] === '<') {
        const tagEnd = html.indexOf('>', i);
        if (tagEnd === -1) {
            current += html[i];
            i++;
            continue;
        }
        const tagContent = html.substring(i + 1, tagEnd);
        // Closing tag — skip
        if (tagContent.startsWith('/')) {
            i = tagEnd + 1;
            continue;
        }
        // Self-closing tags (<br />, <img />)
        if (tagContent.endsWith('/') || tagContent.startsWith('br') || tagContent.startsWith('img')) {
            if (current) {
                result.push(current);
                current = '';
            }
            if (tagContent.startsWith('img')) {
                const srcMatch = tagContent.match(/src="([^"]*)"/);
                const altMatch = tagContent.match(/alt="([^"]*)"/);
                result.push({
                    type: 'img',
                    src: srcMatch?.[1] || '',
                    alt: altMatch?.[1] || ''
                });
            }
            i = tagEnd + 1;
            continue;
        }
        // Extract tag name
        const tagName = tagContent.split(/[\s/]/)[0].toLowerCase();
        // Find closing tag
        const closingTag = `</${tagName}>`;
        const closeIdx = html.indexOf(closingTag, tagEnd + 1);
        if (closeIdx === -1) {
            current += html.substring(i, tagEnd + 1);
            i = tagEnd + 1;
            continue;
        }
        if (current) {
            result.push(current);
            current = '';
        }
        const innerContent = html.substring(tagEnd + 1, closeIdx);
        switch(tagName){
            case 'b':
            case 'strong':
                result.push({
                    type: 'bold',
                    text: innerContent
                });
                break;
            case 'i':
            case 'em':
                result.push({
                    type: 'italic',
                    text: innerContent
                });
                break;
            case 'u':
                result.push({
                    type: 'underline',
                    text: innerContent
                });
                break;
            case 's':
            case 'del':
            case 'strike':
                result.push({
                    type: 'strikethrough',
                    text: innerContent
                });
                break;
            case 'code':
                result.push({
                    type: 'code',
                    text: innerContent
                });
                break;
            case 'mark':
                result.push({
                    type: 'mark',
                    text: innerContent
                });
                break;
            case 'a':
                {
                    const hrefMatch = tagContent.match(/href="([^"]*)"/);
                    result.push({
                        type: 'link',
                        text: innerContent,
                        href: hrefMatch?.[1] || '#'
                    });
                    break;
                }
            default:
                result.push(innerContent);
        }
        i = closeIdx + closingTag.length;
    } else {
        current += html[i];
        i++;
    }
    if (current) result.push(current);
    return result;
}
function $86170ffd0f7491a4$var$inlineToIR(tokens) {
    return tokens.map((token)=>{
        if (typeof token === 'string') return (0, $l5F2G.createIRNode)($86170ffd0f7491a4$var$c('span'), {
            tag: 'span',
            text: token
        });
        switch(token.type){
            case 'bold':
                return (0, $l5F2G.createIRNode)($86170ffd0f7491a4$var$c('strong'), {
                    tag: 'strong',
                    text: token.text
                });
            case 'italic':
                return (0, $l5F2G.createIRNode)($86170ffd0f7491a4$var$c('em'), {
                    tag: 'em',
                    text: token.text
                });
            case 'underline':
                return (0, $l5F2G.createIRNode)($86170ffd0f7491a4$var$c('span'), {
                    tag: 'span',
                    text: token.text,
                    style: {
                        textDecoration: 'underline'
                    }
                });
            case 'strikethrough':
                return (0, $l5F2G.createIRNode)($86170ffd0f7491a4$var$c('del'), {
                    tag: 'del',
                    text: token.text
                });
            case 'code':
                return (0, $l5F2G.createIRNode)($86170ffd0f7491a4$var$c('inlineCode'), {
                    tag: 'code',
                    text: token.text
                });
            case 'mark':
                return (0, $l5F2G.createIRNode)($86170ffd0f7491a4$var$c('mark'), {
                    tag: 'mark',
                    text: token.text
                });
            case 'link':
                return (0, $l5F2G.createIRNode)($86170ffd0f7491a4$var$c('link'), {
                    tag: 'a',
                    text: token.text,
                    props: {
                        href: token.href
                    }
                });
            case 'img':
                return (0, $l5F2G.createIRNode)($86170ffd0f7491a4$var$c('img'), {
                    tag: 'img',
                    props: {
                        src: token.src,
                        alt: token.alt
                    }
                });
            default:
                return (0, $l5F2G.createIRNode)($86170ffd0f7491a4$var$c('span'), {
                    tag: 'span',
                    text: String(token)
                });
        }
    });
}

});


parcelRegister("9kiGF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef053115c0f9207e$export$2e2bcd8739ae039);
function $ef053115c0f9207e$var$Dr(e) {
    if (e) throw e;
}
function $ef053115c0f9207e$var$tr(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ var $ef053115c0f9207e$var$Ua = function(t) {
    return t != null && t.constructor != null && typeof t.constructor.isBuffer == "function" && t.constructor.isBuffer(t);
};
const $ef053115c0f9207e$var$zs = /* @__PURE__ */ $ef053115c0f9207e$var$tr($ef053115c0f9207e$var$Ua);
var $ef053115c0f9207e$var$Ut = Object.prototype.hasOwnProperty, $ef053115c0f9207e$var$Ys = Object.prototype.toString, $ef053115c0f9207e$var$wr = Object.defineProperty, $ef053115c0f9207e$var$Fr = Object.getOwnPropertyDescriptor, $ef053115c0f9207e$var$Hr = function(t) {
    return typeof Array.isArray == "function" ? Array.isArray(t) : $ef053115c0f9207e$var$Ys.call(t) === "[object Array]";
}, $ef053115c0f9207e$var$Br = function(t) {
    if (!t || $ef053115c0f9207e$var$Ys.call(t) !== "[object Object]") return !1;
    var n = $ef053115c0f9207e$var$Ut.call(t, "constructor"), r = t.constructor && t.constructor.prototype && $ef053115c0f9207e$var$Ut.call(t.constructor.prototype, "isPrototypeOf");
    if (t.constructor && !n && !r) return !1;
    var i;
    for(i in t);
    return typeof i > "u" || $ef053115c0f9207e$var$Ut.call(t, i);
}, $ef053115c0f9207e$var$Ur = function(t, n) {
    $ef053115c0f9207e$var$wr && n.name === "__proto__" ? $ef053115c0f9207e$var$wr(t, n.name, {
        enumerable: !0,
        configurable: !0,
        value: n.newValue,
        writable: !0
    }) : t[n.name] = n.newValue;
}, $ef053115c0f9207e$var$vr = function(t, n) {
    if (n === "__proto__") {
        if ($ef053115c0f9207e$var$Ut.call(t, n)) {
            if ($ef053115c0f9207e$var$Fr) return $ef053115c0f9207e$var$Fr(t, n).value;
        } else return;
    }
    return t[n];
}, $ef053115c0f9207e$var$va = function e() {
    var t, n, r, i, s, o, l = arguments[0], u = 1, c = arguments.length, h = !1;
    for(typeof l == "boolean" && (h = l, l = arguments[1] || {}, u = 2), (l == null || typeof l != "object" && typeof l != "function") && (l = {}); u < c; ++u)if (t = arguments[u], t != null) for(n in t)r = $ef053115c0f9207e$var$vr(l, n), i = $ef053115c0f9207e$var$vr(t, n), l !== i && (h && i && ($ef053115c0f9207e$var$Br(i) || (s = $ef053115c0f9207e$var$Hr(i))) ? (s ? (s = !1, o = r && $ef053115c0f9207e$var$Hr(r) ? r : []) : o = r && $ef053115c0f9207e$var$Br(r) ? r : {}, $ef053115c0f9207e$var$Ur(l, {
        name: n,
        newValue: e(h, o, i)
    })) : typeof i < "u" && $ef053115c0f9207e$var$Ur(l, {
        name: n,
        newValue: i
    }));
    return l;
};
const $ef053115c0f9207e$var$jt = /* @__PURE__ */ $ef053115c0f9207e$var$tr($ef053115c0f9207e$var$va);
function $ef053115c0f9207e$var$zn(e) {
    if (typeof e != "object" || e === null) return !1;
    const t = Object.getPrototypeOf(e);
    return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function $ef053115c0f9207e$var$Ga() {
    const e = [], t = {
        run: n,
        use: r
    };
    return t;
    function n(...i) {
        let s = -1;
        const o = i.pop();
        if (typeof o != "function") throw new TypeError("Expected function as last argument, not " + o);
        l(null, ...i);
        function l(u, ...c) {
            const h = e[++s];
            let p = -1;
            if (u) {
                o(u);
                return;
            }
            for(; ++p < i.length;)(c[p] === null || c[p] === void 0) && (c[p] = i[p]);
            i = c, h ? $ef053115c0f9207e$var$Ka(h, l)(...c) : o(null, ...c);
        }
    }
    function r(i) {
        if (typeof i != "function") throw new TypeError("Expected `middelware` to be a function, not " + i);
        return e.push(i), t;
    }
}
function $ef053115c0f9207e$var$Ka(e, t) {
    let n;
    return r;
    function r(...o) {
        const l = e.length > o.length;
        let u;
        l && o.push(i);
        try {
            u = e.apply(this, o);
        } catch (c) {
            const h = /** @type {Error} */ c;
            if (l && n) throw h;
            return i(h);
        }
        l || (u instanceof Promise ? u.then(s, i) : u instanceof Error ? i(u) : s(u));
    }
    function i(o, ...l) {
        n || (n = !0, t(o, ...l));
    }
    function s(o) {
        i(null, o);
    }
}
function $ef053115c0f9207e$var$at(e) {
    return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? $ef053115c0f9207e$var$Gr(e.position) : "start" in e || "end" in e ? $ef053115c0f9207e$var$Gr(e) : "line" in e || "column" in e ? $ef053115c0f9207e$var$Yn(e) : "";
}
function $ef053115c0f9207e$var$Yn(e) {
    return $ef053115c0f9207e$var$Kr(e && e.line) + ":" + $ef053115c0f9207e$var$Kr(e && e.column);
}
function $ef053115c0f9207e$var$Gr(e) {
    return $ef053115c0f9207e$var$Yn(e && e.start) + "-" + $ef053115c0f9207e$var$Yn(e && e.end);
}
function $ef053115c0f9207e$var$Kr(e) {
    return e && typeof e == "number" ? e : 1;
}
class $ef053115c0f9207e$var$Fe extends Error {
    /**
   * Constructor of a message for `reason` at `place` from `origin`.
   * When an error is passed in as `reason`, copies the `stack`.
   *
   * @param {string|Error} reason Reason for message (`string` or `Error`). Uses the stack and message of the error if given.
   * @param {Node|NodeLike|Position|Point} [place] Place at which the message occurred in a file (`Node`, `Position`, or `Point`, optional).
   * @param {string} [origin] Place in code the message originates from (`string`, optional).
   */ constructor(t, n, r){
        const i = [
            null,
            null
        ];
        let s = {
            // @ts-expect-error: we always follows the structure of `position`.
            start: {
                line: null,
                column: null
            },
            // @ts-expect-error: "
            end: {
                line: null,
                column: null
            }
        };
        if (super(), typeof n == "string" && (r = n, n = void 0), typeof r == "string") {
            const o = r.indexOf(":");
            o === -1 ? i[1] = r : (i[0] = r.slice(0, o), i[1] = r.slice(o + 1));
        }
        n && ("type" in n || "position" in n ? n.position && (s = n.position) : "start" in n || "end" in n ? s = n : ("line" in n || "column" in n) && (s.start = n)), this.name = $ef053115c0f9207e$var$at(n) || "1:1", this.message = typeof t == "object" ? t.message : t, this.stack = typeof t == "object" ? t.stack : "", this.reason = this.message, this.fatal, this.line = s.start.line, this.column = s.start.column, this.source = i[0], this.ruleId = i[1], this.position = s, this.actual, this.expected, this.file, this.url, this.note;
    }
}
$ef053115c0f9207e$var$Fe.prototype.file = "";
$ef053115c0f9207e$var$Fe.prototype.name = "";
$ef053115c0f9207e$var$Fe.prototype.reason = "";
$ef053115c0f9207e$var$Fe.prototype.message = "";
$ef053115c0f9207e$var$Fe.prototype.stack = "";
$ef053115c0f9207e$var$Fe.prototype.fatal = null;
$ef053115c0f9207e$var$Fe.prototype.column = null;
$ef053115c0f9207e$var$Fe.prototype.line = null;
$ef053115c0f9207e$var$Fe.prototype.source = null;
$ef053115c0f9207e$var$Fe.prototype.ruleId = null;
$ef053115c0f9207e$var$Fe.prototype.position = null;
const $ef053115c0f9207e$var$qe = {
    basename: $ef053115c0f9207e$var$za,
    dirname: $ef053115c0f9207e$var$Ya,
    extname: $ef053115c0f9207e$var$ja,
    join: $ef053115c0f9207e$var$$a,
    sep: "/"
};
function $ef053115c0f9207e$var$za(e, t) {
    if (t !== void 0 && typeof t != "string") throw new TypeError('"ext" argument must be a string');
    $ef053115c0f9207e$var$Et(e);
    let n = 0, r = -1, i = e.length, s;
    if (t === void 0 || t.length === 0 || t.length > e.length) {
        for(; i--;)if (e.charCodeAt(i) === 47) {
            if (s) {
                n = i + 1;
                break;
            }
        } else r < 0 && (s = !0, r = i + 1);
        return r < 0 ? "" : e.slice(n, r);
    }
    if (t === e) return "";
    let o = -1, l = t.length - 1;
    for(; i--;)if (e.charCodeAt(i) === 47) {
        if (s) {
            n = i + 1;
            break;
        }
    } else o < 0 && (s = !0, o = i + 1), l > -1 && (e.charCodeAt(i) === t.charCodeAt(l--) ? l < 0 && (r = i) : (l = -1, r = o));
    return n === r ? r = o : r < 0 && (r = e.length), e.slice(n, r);
}
function $ef053115c0f9207e$var$Ya(e) {
    if ($ef053115c0f9207e$var$Et(e), e.length === 0) return ".";
    let t = -1, n = e.length, r;
    for(; --n;)if (e.charCodeAt(n) === 47) {
        if (r) {
            t = n;
            break;
        }
    } else r || (r = !0);
    return t < 0 ? e.charCodeAt(0) === 47 ? "/" : "." : t === 1 && e.charCodeAt(0) === 47 ? "//" : e.slice(0, t);
}
function $ef053115c0f9207e$var$ja(e) {
    $ef053115c0f9207e$var$Et(e);
    let t = e.length, n = -1, r = 0, i = -1, s = 0, o;
    for(; t--;){
        const l = e.charCodeAt(t);
        if (l === 47) {
            if (o) {
                r = t + 1;
                break;
            }
            continue;
        }
        n < 0 && (o = !0, n = t + 1), l === 46 ? i < 0 ? i = t : s !== 1 && (s = 1) : i > -1 && (s = -1);
    }
    return i < 0 || n < 0 || // We saw a non-dot character immediately before the dot.
    s === 0 || // The (right-most) trimmed path component is exactly `..`.
    s === 1 && i === n - 1 && i === r + 1 ? "" : e.slice(i, n);
}
function $ef053115c0f9207e$var$$a(...e) {
    let t = -1, n;
    for(; ++t < e.length;)$ef053115c0f9207e$var$Et(e[t]), e[t] && (n = n === void 0 ? e[t] : n + "/" + e[t]);
    return n === void 0 ? "." : $ef053115c0f9207e$var$Qa(n);
}
function $ef053115c0f9207e$var$Qa(e) {
    $ef053115c0f9207e$var$Et(e);
    const t = e.charCodeAt(0) === 47;
    let n = $ef053115c0f9207e$var$Wa(e, !t);
    return n.length === 0 && !t && (n = "."), n.length > 0 && e.charCodeAt(e.length - 1) === 47 && (n += "/"), t ? "/" + n : n;
}
function $ef053115c0f9207e$var$Wa(e, t) {
    let n = "", r = 0, i = -1, s = 0, o = -1, l, u;
    for(; ++o <= e.length;){
        if (o < e.length) l = e.charCodeAt(o);
        else {
            if (l === 47) break;
            l = 47;
        }
        if (l === 47) {
            if (!(i === o - 1 || s === 1)) {
                if (i !== o - 1 && s === 2) {
                    if (n.length < 2 || r !== 2 || n.charCodeAt(n.length - 1) !== 46 || n.charCodeAt(n.length - 2) !== 46) {
                        if (n.length > 2) {
                            if (u = n.lastIndexOf("/"), u !== n.length - 1) {
                                u < 0 ? (n = "", r = 0) : (n = n.slice(0, u), r = n.length - 1 - n.lastIndexOf("/")), i = o, s = 0;
                                continue;
                            }
                        } else if (n.length > 0) {
                            n = "", r = 0, i = o, s = 0;
                            continue;
                        }
                    }
                    t && (n = n.length > 0 ? n + "/.." : "..", r = 2);
                } else n.length > 0 ? n += "/" + e.slice(i + 1, o) : n = e.slice(i + 1, o), r = o - i - 1;
            }
            i = o, s = 0;
        } else l === 46 && s > -1 ? s++ : s = -1;
    }
    return n;
}
function $ef053115c0f9207e$var$Et(e) {
    if (typeof e != "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(e));
}
const $ef053115c0f9207e$var$qa = {
    cwd: $ef053115c0f9207e$var$Va
};
function $ef053115c0f9207e$var$Va() {
    return "/";
}
function $ef053115c0f9207e$var$jn(e) {
    return e !== null && typeof e == "object" && // @ts-expect-error: indexable.
    e.href && // @ts-expect-error: indexable.
    e.origin;
}
function $ef053115c0f9207e$var$Xa(e) {
    if (typeof e == "string") e = new URL(e);
    else if (!$ef053115c0f9207e$var$jn(e)) {
        const t = new TypeError('The "path" argument must be of type string or an instance of URL. Received `' + e + "`");
        throw t.code = "ERR_INVALID_ARG_TYPE", t;
    }
    if (e.protocol !== "file:") {
        const t = new TypeError("The URL must be of scheme file");
        throw t.code = "ERR_INVALID_URL_SCHEME", t;
    }
    return $ef053115c0f9207e$var$Ja(e);
}
function $ef053115c0f9207e$var$Ja(e) {
    if (e.hostname !== "") {
        const r = new TypeError('File URL host must be "localhost" or empty on darwin');
        throw r.code = "ERR_INVALID_FILE_URL_HOST", r;
    }
    const t = e.pathname;
    let n = -1;
    for(; ++n < t.length;)if (t.charCodeAt(n) === 37 && t.charCodeAt(n + 1) === 50) {
        const r = t.charCodeAt(n + 2);
        if (r === 70 || r === 102) {
            const i = new TypeError("File URL path must not include encoded / characters");
            throw i.code = "ERR_INVALID_FILE_URL_PATH", i;
        }
    }
    return decodeURIComponent(t);
}
const $ef053115c0f9207e$var$dn = [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
];
class $ef053115c0f9207e$var$Za {
    /**
   * Create a new virtual file.
   *
   * If `options` is `string` or `Buffer`, it’s treated as `{value: options}`.
   * If `options` is a `URL`, it’s treated as `{path: options}`.
   * If `options` is a `VFile`, shallow copies its data over to the new file.
   * All fields in `options` are set on the newly created `VFile`.
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * It’s not possible to set either `dirname` or `extname` without setting
   * either `history`, `path`, `basename`, or `stem` as well.
   *
   * @param {Compatible} [value]
   */ constructor(t){
        let n;
        t ? typeof t == "string" || $ef053115c0f9207e$var$zs(t) ? n = {
            value: t
        } : $ef053115c0f9207e$var$jn(t) ? n = {
            path: t
        } : n = t : n = {}, this.data = {}, this.messages = [], this.history = [], this.cwd = $ef053115c0f9207e$var$qa.cwd(), this.value, this.stored, this.result, this.map;
        let r = -1;
        for(; ++r < $ef053115c0f9207e$var$dn.length;){
            const s = $ef053115c0f9207e$var$dn[r];
            s in n && n[s] !== void 0 && (this[s] = s === "history" ? [
                ...n[s]
            ] : n[s]);
        }
        let i;
        for(i in n)$ef053115c0f9207e$var$dn.includes(i) || (this[i] = n[i]);
    }
    /**
   * Get the full path (example: `'~/index.min.js'`).
   * @returns {string}
   */ get path() {
        return this.history[this.history.length - 1];
    }
    /**
   * Set the full path (example: `'~/index.min.js'`).
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   * @param {string|URL} path
   */ set path(t) {
        $ef053115c0f9207e$var$jn(t) && (t = $ef053115c0f9207e$var$Xa(t)), $ef053115c0f9207e$var$pn(t, "path"), this.path !== t && this.history.push(t);
    }
    /**
   * Get the parent path (example: `'~'`).
   */ get dirname() {
        return typeof this.path == "string" ? $ef053115c0f9207e$var$qe.dirname(this.path) : void 0;
    }
    /**
   * Set the parent path (example: `'~'`).
   * Cannot be set if there’s no `path` yet.
   */ set dirname(t) {
        $ef053115c0f9207e$var$zr(this.basename, "dirname"), this.path = $ef053115c0f9207e$var$qe.join(t || "", this.basename);
    }
    /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   */ get basename() {
        return typeof this.path == "string" ? $ef053115c0f9207e$var$qe.basename(this.path) : void 0;
    }
    /**
   * Set basename (including extname) (`'index.min.js'`).
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */ set basename(t) {
        $ef053115c0f9207e$var$pn(t, "basename"), $ef053115c0f9207e$var$mn(t, "basename"), this.path = $ef053115c0f9207e$var$qe.join(this.dirname || "", t);
    }
    /**
   * Get the extname (including dot) (example: `'.js'`).
   */ get extname() {
        return typeof this.path == "string" ? $ef053115c0f9207e$var$qe.extname(this.path) : void 0;
    }
    /**
   * Set the extname (including dot) (example: `'.js'`).
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   */ set extname(t) {
        if ($ef053115c0f9207e$var$mn(t, "extname"), $ef053115c0f9207e$var$zr(this.dirname, "extname"), t) {
            if (t.charCodeAt(0) !== 46) throw new Error("`extname` must start with `.`");
            if (t.includes(".", 1)) throw new Error("`extname` cannot contain multiple dots");
        }
        this.path = $ef053115c0f9207e$var$qe.join(this.dirname, this.stem + (t || ""));
    }
    /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   */ get stem() {
        return typeof this.path == "string" ? $ef053115c0f9207e$var$qe.basename(this.path, this.extname) : void 0;
    }
    /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */ set stem(t) {
        $ef053115c0f9207e$var$pn(t, "stem"), $ef053115c0f9207e$var$mn(t, "stem"), this.path = $ef053115c0f9207e$var$qe.join(this.dirname || "", t + (this.extname || ""));
    }
    /**
   * Serialize the file.
   *
   * @param {BufferEncoding} [encoding='utf8']
   *   When `value` is a `Buffer`, `encoding` is a character encoding to
   *   understand it as (default: `'utf8'`).
   * @returns {string}
   *   Serialized file.
   */ toString(t) {
        return (this.value || "").toString(t);
    }
    /**
   * Constructs a new `VFileMessage`, where `fatal` is set to `false`, and
   * associates it with the file by adding it to `vfile.messages` and setting
   * `message.file` to the current filepath.
   *
   * @param {string|Error} reason
   *   Human readable reason for the message, uses the stack and message of the error if given.
   * @param {Node|NodeLike|Position|Point} [place]
   *   Place where the message occurred in the file.
   * @param {string} [origin]
   *   Computer readable reason for the message
   * @returns {VFileMessage}
   *   Message.
   */ message(t, n, r) {
        const i = new $ef053115c0f9207e$var$Fe(t, n, r);
        return this.path && (i.name = this.path + ":" + i.name, i.file = this.path), i.fatal = !1, this.messages.push(i), i;
    }
    /**
   * Like `VFile#message()`, but associates an informational message where
   * `fatal` is set to `null`.
   *
   * @param {string|Error} reason
   *   Human readable reason for the message, uses the stack and message of the error if given.
   * @param {Node|NodeLike|Position|Point} [place]
   *   Place where the message occurred in the file.
   * @param {string} [origin]
   *   Computer readable reason for the message
   * @returns {VFileMessage}
   *   Message.
   */ info(t, n, r) {
        const i = this.message(t, n, r);
        return i.fatal = null, i;
    }
    /**
   * Like `VFile#message()`, but associates a fatal message where `fatal` is
   * set to `true`, and then immediately throws it.
   *
   * > 👉 **Note**: a fatal error means that a file is no longer processable.
   *
   * @param {string|Error} reason
   *   Human readable reason for the message, uses the stack and message of the error if given.
   * @param {Node|NodeLike|Position|Point} [place]
   *   Place where the message occurred in the file.
   * @param {string} [origin]
   *   Computer readable reason for the message
   * @returns {never}
   *   Message.
   */ fail(t, n, r) {
        const i = this.message(t, n, r);
        throw i.fatal = !0, i;
    }
}
function $ef053115c0f9207e$var$mn(e, t) {
    if (e && e.includes($ef053115c0f9207e$var$qe.sep)) throw new Error("`" + t + "` cannot be a path: did not expect `" + $ef053115c0f9207e$var$qe.sep + "`");
}
function $ef053115c0f9207e$var$pn(e, t) {
    if (!e) throw new Error("`" + t + "` cannot be empty");
}
function $ef053115c0f9207e$var$zr(e, t) {
    if (!e) throw new Error("Setting `" + t + "` requires `path` to be set too");
}
const $ef053115c0f9207e$var$nr = $ef053115c0f9207e$var$$s().freeze(), $ef053115c0f9207e$var$js = {}.hasOwnProperty;
function $ef053115c0f9207e$var$$s() {
    const e = $ef053115c0f9207e$var$Ga(), t = [];
    let n = {}, r, i = -1;
    return s.data = o, s.Parser = void 0, s.Compiler = void 0, s.freeze = l, s.attachers = t, s.use = u, s.parse = c, s.stringify = h, s.run = p, s.runSync = _, s.process = E, s.processSync = S, s;
    function s() {
        const R = $ef053115c0f9207e$var$$s();
        let b = -1;
        for(; ++b < t.length;)R.use(...t[b]);
        return R.data($ef053115c0f9207e$var$jt(!0, {}, n)), R;
    }
    function o(R, b) {
        return typeof R == "string" ? arguments.length === 2 ? ($ef053115c0f9207e$var$gn("data", r), n[R] = b, s) : $ef053115c0f9207e$var$js.call(n, R) && n[R] || null : R ? ($ef053115c0f9207e$var$gn("data", r), n = R, s) : n;
    }
    function l() {
        if (r) return s;
        for(; ++i < t.length;){
            const [R, ...b] = t[i];
            if (b[0] === !1) continue;
            b[0] === !0 && (b[0] = void 0);
            const N = R.call(s, ...b);
            typeof N == "function" && e.use(N);
        }
        return r = !0, i = Number.POSITIVE_INFINITY, s;
    }
    function u(R, ...b) {
        let N;
        if ($ef053115c0f9207e$var$gn("use", r), R != null) {
            if (typeof R == "function") K(R, ...b);
            else if (typeof R == "object") Array.isArray(R) ? v(R) : k(R);
            else throw new TypeError("Expected usable value, not `" + R + "`");
        }
        return N && (n.settings = Object.assign(n.settings || {}, N)), s;
        function U(A) {
            if (typeof A == "function") K(A);
            else if (typeof A == "object") {
                if (Array.isArray(A)) {
                    const [F, ...$] = A;
                    K(F, ...$);
                } else k(A);
            } else throw new TypeError("Expected usable value, not `" + A + "`");
        }
        function k(A) {
            v(A.plugins), A.settings && (N = Object.assign(N || {}, A.settings));
        }
        function v(A) {
            let F = -1;
            if (A != null) {
                if (Array.isArray(A)) for(; ++F < A.length;){
                    const $ = A[F];
                    U($);
                }
                else throw new TypeError("Expected a list of plugins, not `" + A + "`");
            }
        }
        function K(A, F) {
            let $ = -1, q;
            for(; ++$ < t.length;)if (t[$][0] === A) {
                q = t[$];
                break;
            }
            q ? ($ef053115c0f9207e$var$zn(q[1]) && $ef053115c0f9207e$var$zn(F) && (F = $ef053115c0f9207e$var$jt(!0, q[1], F)), q[1] = F) : t.push([
                ...arguments
            ]);
        }
    }
    function c(R) {
        s.freeze();
        const b = $ef053115c0f9207e$var$X1(R), N = s.Parser;
        return $ef053115c0f9207e$var$En("parse", N), $ef053115c0f9207e$var$Yr(N, "parse") ? new N(String(b), b).parse() : N(String(b), b);
    }
    function h(R, b) {
        s.freeze();
        const N = $ef053115c0f9207e$var$X1(b), U = s.Compiler;
        return $ef053115c0f9207e$var$_n("stringify", U), $ef053115c0f9207e$var$jr(R), $ef053115c0f9207e$var$Yr(U, "compile") ? new U(R, N).compile() : U(R, N);
    }
    function p(R, b, N) {
        if ($ef053115c0f9207e$var$jr(R), s.freeze(), !N && typeof b == "function" && (N = b, b = void 0), !N) return new Promise(U);
        U(null, N);
        function U(k, v) {
            e.run(R, $ef053115c0f9207e$var$X1(b), K);
            function K(A, F, $) {
                F = F || R, A ? v(A) : k ? k(F) : N(null, F, $);
            }
        }
    }
    function _(R, b) {
        let N, U;
        return s.run(R, b, k), $ef053115c0f9207e$var$$r("runSync", "run", U), N;
        function k(v, K) {
            $ef053115c0f9207e$var$Dr(v), N = K, U = !0;
        }
    }
    function E(R, b) {
        if (s.freeze(), $ef053115c0f9207e$var$En("process", s.Parser), $ef053115c0f9207e$var$_n("process", s.Compiler), !b) return new Promise(N);
        N(null, b);
        function N(U, k) {
            const v = $ef053115c0f9207e$var$X1(R);
            s.run(s.parse(v), v, (A, F, $)=>{
                if (A || !F || !$) K(A);
                else {
                    const q = s.stringify(F, $);
                    q == null || ($ef053115c0f9207e$var$nl(q) ? $.value = q : $.result = q), K(A, $);
                }
            });
            function K(A, F) {
                A || !F ? k(A) : U ? U(F) : b(null, F);
            }
        }
    }
    function S(R) {
        let b;
        s.freeze(), $ef053115c0f9207e$var$En("processSync", s.Parser), $ef053115c0f9207e$var$_n("processSync", s.Compiler);
        const N = $ef053115c0f9207e$var$X1(R);
        return s.process(N, U), $ef053115c0f9207e$var$$r("processSync", "process", b), N;
        function U(k) {
            b = !0, $ef053115c0f9207e$var$Dr(k);
        }
    }
}
function $ef053115c0f9207e$var$Yr(e, t) {
    return typeof e == "function" && // Prototypes do exist.
    // type-coverage:ignore-next-line
    e.prototype && // A function with keys in its prototype is probably a constructor.
    // Classes’ prototype methods are not enumerable, so we check if some value
    // exists in the prototype.
    // type-coverage:ignore-next-line
    ($ef053115c0f9207e$var$el(e.prototype) || t in e.prototype);
}
function $ef053115c0f9207e$var$el(e) {
    let t;
    for(t in e)if ($ef053115c0f9207e$var$js.call(e, t)) return !0;
    return !1;
}
function $ef053115c0f9207e$var$En(e, t) {
    if (typeof t != "function") throw new TypeError("Cannot `" + e + "` without `Parser`");
}
function $ef053115c0f9207e$var$_n(e, t) {
    if (typeof t != "function") throw new TypeError("Cannot `" + e + "` without `Compiler`");
}
function $ef053115c0f9207e$var$gn(e, t) {
    if (t) throw new Error("Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`.");
}
function $ef053115c0f9207e$var$jr(e) {
    if (!$ef053115c0f9207e$var$zn(e) || typeof e.type != "string") throw new TypeError("Expected node, got `" + e + "`");
}
function $ef053115c0f9207e$var$$r(e, t, n) {
    if (!n) throw new Error("`" + e + "` finished async. Use `" + t + "` instead");
}
function $ef053115c0f9207e$var$X1(e) {
    return $ef053115c0f9207e$var$tl(e) ? e : new $ef053115c0f9207e$var$Za(e);
}
function $ef053115c0f9207e$var$tl(e) {
    return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function $ef053115c0f9207e$var$nl(e) {
    return typeof e == "string" || $ef053115c0f9207e$var$zs(e);
}
function $ef053115c0f9207e$var$Jt(e, t) {
    var { includeImageAlt: n = !0 } = t || {};
    return $ef053115c0f9207e$var$Qs(e, n);
}
function $ef053115c0f9207e$var$Qs(e, t) {
    return e && typeof e == "object" && // @ts-ignore looks like a literal.
    (e.value || // @ts-ignore looks like an image.
    (t ? e.alt : "") || // @ts-ignore looks like a parent.
    "children" in e && $ef053115c0f9207e$var$Qr(e.children, t) || Array.isArray(e) && $ef053115c0f9207e$var$Qr(e, t)) || "";
}
function $ef053115c0f9207e$var$Qr(e, t) {
    for(var n = [], r = -1; ++r < e.length;)n[r] = $ef053115c0f9207e$var$Qs(e[r], t);
    return n.join("");
}
function $ef053115c0f9207e$var$Ze(e, t, n, r) {
    const i = e.length;
    let s = 0, o;
    if (t < 0 ? t = -t > i ? 0 : i + t : t = t > i ? i : t, n = n > 0 ? n : 0, r.length < 1e4) o = Array.from(r), o.unshift(t, n), [].splice.apply(e, o);
    else for(n && [].splice.apply(e, [
        t,
        n
    ]); s < r.length;)o = r.slice(s, s + 1e4), o.unshift(t, 0), [].splice.apply(e, o), s += 1e4, t += 1e4;
}
function $ef053115c0f9207e$var$Pe(e, t) {
    return e.length > 0 ? ($ef053115c0f9207e$var$Ze(e, e.length, 0, t), e) : t;
}
const $ef053115c0f9207e$var$Wr = {}.hasOwnProperty;
function $ef053115c0f9207e$var$rl(e) {
    const t = {};
    let n = -1;
    for(; ++n < e.length;)$ef053115c0f9207e$var$il(t, e[n]);
    return t;
}
function $ef053115c0f9207e$var$il(e, t) {
    let n;
    for(n in t){
        const i = ($ef053115c0f9207e$var$Wr.call(e, n) ? e[n] : void 0) || (e[n] = {}), s = t[n];
        let o;
        for(o in s){
            $ef053115c0f9207e$var$Wr.call(i, o) || (i[o] = []);
            const l = s[o];
            $ef053115c0f9207e$var$sl(// @ts-expect-error Looks like a list.
            i[o], Array.isArray(l) ? l : l ? [
                l
            ] : []);
        }
    }
}
function $ef053115c0f9207e$var$sl(e, t) {
    let n = -1;
    const r = [];
    for(; ++n < t.length;)(t[n].add === "after" ? e : r).push(t[n]);
    $ef053115c0f9207e$var$Ze(e, 0, 0, r);
}
const $ef053115c0f9207e$var$ol = /[!-/:-@[-`{-~\u00A1\u00A7\u00AB\u00B6\u00B7\u00BB\u00BF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/, $ef053115c0f9207e$var$Ve = $ef053115c0f9207e$var$_1(/[A-Za-z]/), $ef053115c0f9207e$var$$n = $ef053115c0f9207e$var$_1(/\d/), $ef053115c0f9207e$var$al = $ef053115c0f9207e$var$_1(/[\dA-Fa-f]/), $ef053115c0f9207e$var$ze = $ef053115c0f9207e$var$_1(/[\dA-Za-z]/), $ef053115c0f9207e$var$ll = $ef053115c0f9207e$var$_1(/[!-/:-@[-`{-~]/), $ef053115c0f9207e$var$qr = $ef053115c0f9207e$var$_1(/[#-'*+\--9=?A-Z^-~]/);
function $ef053115c0f9207e$var$Qn(e) {
    return(// Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127));
}
function $ef053115c0f9207e$var$De(e) {
    return e !== null && (e < 0 || e === 32);
}
function $ef053115c0f9207e$var$H(e) {
    return e !== null && e < -2;
}
function $ef053115c0f9207e$var$le(e) {
    return e === -2 || e === -1 || e === 32;
}
const $ef053115c0f9207e$var$ul = $ef053115c0f9207e$var$_1(/\s/), $ef053115c0f9207e$var$cl = $ef053115c0f9207e$var$_1($ef053115c0f9207e$var$ol);
function $ef053115c0f9207e$var$_1(e) {
    return t;
    function t(n) {
        return n !== null && e.test(String.fromCharCode(n));
    }
}
function $ef053115c0f9207e$var$Z(e, t, n, r) {
    const i = r ? r - 1 : Number.POSITIVE_INFINITY;
    let s = 0;
    return o;
    function o(u) {
        return $ef053115c0f9207e$var$le(u) ? (e.enter(n), l(u)) : t(u);
    }
    function l(u) {
        return $ef053115c0f9207e$var$le(u) && s++ < i ? (e.consume(u), l) : (e.exit(n), t(u));
    }
}
const $ef053115c0f9207e$var$hl = {
    tokenize: $ef053115c0f9207e$var$fl
};
function $ef053115c0f9207e$var$fl(e) {
    const t = e.attempt(this.parser.constructs.contentInitial, r, i);
    let n;
    return t;
    function r(l) {
        if (l === null) {
            e.consume(l);
            return;
        }
        return e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), $ef053115c0f9207e$var$Z(e, t, "linePrefix");
    }
    function i(l) {
        return e.enter("paragraph"), s(l);
    }
    function s(l) {
        const u = e.enter("chunkText", {
            contentType: "text",
            previous: n
        });
        return n && (n.next = u), n = u, o(l);
    }
    function o(l) {
        if (l === null) {
            e.exit("chunkText"), e.exit("paragraph"), e.consume(l);
            return;
        }
        return $ef053115c0f9207e$var$H(l) ? (e.consume(l), e.exit("chunkText"), s) : (e.consume(l), o);
    }
}
const $ef053115c0f9207e$var$Tl = {
    tokenize: $ef053115c0f9207e$var$dl
}, $ef053115c0f9207e$var$Vr = {
    tokenize: $ef053115c0f9207e$var$ml
};
function $ef053115c0f9207e$var$dl(e) {
    const t = this, n = [];
    let r = 0, i, s, o;
    return l;
    function l(k) {
        if (r < n.length) {
            const v = n[r];
            return t.containerState = v[1], e.attempt(v[0].continuation, u, c)(k);
        }
        return c(k);
    }
    function u(k) {
        if (r++, t.containerState._closeFlow) {
            t.containerState._closeFlow = void 0, i && U();
            const v = t.events.length;
            let K = v, A;
            for(; K--;)if (t.events[K][0] === "exit" && t.events[K][1].type === "chunkFlow") {
                A = t.events[K][1].end;
                break;
            }
            N(r);
            let F = v;
            for(; F < t.events.length;)t.events[F][1].end = Object.assign({}, A), F++;
            return $ef053115c0f9207e$var$Ze(t.events, K + 1, 0, t.events.slice(v)), t.events.length = F, c(k);
        }
        return l(k);
    }
    function c(k) {
        if (r === n.length) {
            if (!i) return _(k);
            if (i.currentConstruct && i.currentConstruct.concrete) return S(k);
            t.interrupt = !!(i.currentConstruct && !i._gfmTableDynamicInterruptHack);
        }
        return t.containerState = {}, e.check($ef053115c0f9207e$var$Vr, h, p)(k);
    }
    function h(k) {
        return i && U(), N(r), _(k);
    }
    function p(k) {
        return t.parser.lazy[t.now().line] = r !== n.length, o = t.now().offset, S(k);
    }
    function _(k) {
        return t.containerState = {}, e.attempt($ef053115c0f9207e$var$Vr, E, S)(k);
    }
    function E(k) {
        return r++, n.push([
            t.currentConstruct,
            t.containerState
        ]), _(k);
    }
    function S(k) {
        if (k === null) {
            i && U(), N(0), e.consume(k);
            return;
        }
        return i = i || t.parser.flow(t.now()), e.enter("chunkFlow", {
            contentType: "flow",
            previous: s,
            _tokenizer: i
        }), R(k);
    }
    function R(k) {
        if (k === null) {
            b(e.exit("chunkFlow"), !0), N(0), e.consume(k);
            return;
        }
        return $ef053115c0f9207e$var$H(k) ? (e.consume(k), b(e.exit("chunkFlow")), r = 0, t.interrupt = void 0, l) : (e.consume(k), R);
    }
    function b(k, v) {
        const K = t.sliceStream(k);
        if (v && K.push(null), k.previous = s, s && (s.next = k), s = k, i.defineSkip(k.start), i.write(K), t.parser.lazy[k.start.line]) {
            let A = i.events.length;
            for(; A--;)if (// The token starts before the line ending…
            i.events[A][1].start.offset < o && // …and either is not ended yet…
            (!i.events[A][1].end || // …or ends after it.
            i.events[A][1].end.offset > o)) return;
            const F = t.events.length;
            let $ = F, q, fe;
            for(; $--;)if (t.events[$][0] === "exit" && t.events[$][1].type === "chunkFlow") {
                if (q) {
                    fe = t.events[$][1].end;
                    break;
                }
                q = !0;
            }
            for(N(r), A = F; A < t.events.length;)t.events[A][1].end = Object.assign({}, fe), A++;
            $ef053115c0f9207e$var$Ze(t.events, $ + 1, 0, t.events.slice(F)), t.events.length = A;
        }
    }
    function N(k) {
        let v = n.length;
        for(; v-- > k;){
            const K = n[v];
            t.containerState = K[1], K[0].exit.call(t, e);
        }
        n.length = k;
    }
    function U() {
        i.write([
            null
        ]), s = void 0, i = void 0, t.containerState._closeFlow = void 0;
    }
}
function $ef053115c0f9207e$var$ml(e, t, n) {
    return $ef053115c0f9207e$var$Z(e, e.attempt(this.parser.constructs.document, t, n), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function $ef053115c0f9207e$var$Xr(e) {
    if (e === null || $ef053115c0f9207e$var$De(e) || $ef053115c0f9207e$var$ul(e)) return 1;
    if ($ef053115c0f9207e$var$cl(e)) return 2;
}
function $ef053115c0f9207e$var$rr(e, t, n) {
    const r = [];
    let i = -1;
    for(; ++i < e.length;){
        const s = e[i].resolveAll;
        s && !r.includes(s) && (t = s(t, n), r.push(s));
    }
    return t;
}
const $ef053115c0f9207e$var$Wn = {
    name: "attention",
    tokenize: $ef053115c0f9207e$var$El,
    resolveAll: $ef053115c0f9207e$var$pl
};
function $ef053115c0f9207e$var$pl(e, t) {
    let n = -1, r, i, s, o, l, u, c, h;
    for(; ++n < e.length;)if (e[n][0] === "enter" && e[n][1].type === "attentionSequence" && e[n][1]._close) {
        for(r = n; r--;)if (e[r][0] === "exit" && e[r][1].type === "attentionSequence" && e[r][1]._open && // If the markers are the same:
        t.sliceSerialize(e[r][1]).charCodeAt(0) === t.sliceSerialize(e[n][1]).charCodeAt(0)) {
            if ((e[r][1]._close || e[n][1]._open) && (e[n][1].end.offset - e[n][1].start.offset) % 3 && !((e[r][1].end.offset - e[r][1].start.offset + e[n][1].end.offset - e[n][1].start.offset) % 3)) continue;
            u = e[r][1].end.offset - e[r][1].start.offset > 1 && e[n][1].end.offset - e[n][1].start.offset > 1 ? 2 : 1;
            const p = Object.assign({}, e[r][1].end), _ = Object.assign({}, e[n][1].start);
            $ef053115c0f9207e$var$Jr(p, -u), $ef053115c0f9207e$var$Jr(_, u), o = {
                type: u > 1 ? "strongSequence" : "emphasisSequence",
                start: p,
                end: Object.assign({}, e[r][1].end)
            }, l = {
                type: u > 1 ? "strongSequence" : "emphasisSequence",
                start: Object.assign({}, e[n][1].start),
                end: _
            }, s = {
                type: u > 1 ? "strongText" : "emphasisText",
                start: Object.assign({}, e[r][1].end),
                end: Object.assign({}, e[n][1].start)
            }, i = {
                type: u > 1 ? "strong" : "emphasis",
                start: Object.assign({}, o.start),
                end: Object.assign({}, l.end)
            }, e[r][1].end = Object.assign({}, o.start), e[n][1].start = Object.assign({}, l.end), c = [], e[r][1].end.offset - e[r][1].start.offset && (c = $ef053115c0f9207e$var$Pe(c, [
                [
                    "enter",
                    e[r][1],
                    t
                ],
                [
                    "exit",
                    e[r][1],
                    t
                ]
            ])), c = $ef053115c0f9207e$var$Pe(c, [
                [
                    "enter",
                    i,
                    t
                ],
                [
                    "enter",
                    o,
                    t
                ],
                [
                    "exit",
                    o,
                    t
                ],
                [
                    "enter",
                    s,
                    t
                ]
            ]), c = $ef053115c0f9207e$var$Pe(c, $ef053115c0f9207e$var$rr(t.parser.constructs.insideSpan.null, e.slice(r + 1, n), t)), c = $ef053115c0f9207e$var$Pe(c, [
                [
                    "exit",
                    s,
                    t
                ],
                [
                    "enter",
                    l,
                    t
                ],
                [
                    "exit",
                    l,
                    t
                ],
                [
                    "exit",
                    i,
                    t
                ]
            ]), e[n][1].end.offset - e[n][1].start.offset ? (h = 2, c = $ef053115c0f9207e$var$Pe(c, [
                [
                    "enter",
                    e[n][1],
                    t
                ],
                [
                    "exit",
                    e[n][1],
                    t
                ]
            ])) : h = 0, $ef053115c0f9207e$var$Ze(e, r - 1, n - r + 3, c), n = r + c.length - h - 2;
            break;
        }
    }
    for(n = -1; ++n < e.length;)e[n][1].type === "attentionSequence" && (e[n][1].type = "data");
    return e;
}
function $ef053115c0f9207e$var$El(e, t) {
    const n = this.parser.constructs.attentionMarkers.null, r = this.previous, i = $ef053115c0f9207e$var$Xr(r);
    let s;
    return o;
    function o(u) {
        return e.enter("attentionSequence"), s = u, l(u);
    }
    function l(u) {
        if (u === s) return e.consume(u), l;
        const c = e.exit("attentionSequence"), h = $ef053115c0f9207e$var$Xr(u), p = !h || h === 2 && i || n.includes(u), _ = !i || i === 2 && h || n.includes(r);
        return c._open = !!(s === 42 ? p : p && (i || !_)), c._close = !!(s === 42 ? _ : _ && (h || !p)), t(u);
    }
}
function $ef053115c0f9207e$var$Jr(e, t) {
    e.column += t, e.offset += t, e._bufferIndex += t;
}
const $ef053115c0f9207e$var$_l = {
    name: "autolink",
    tokenize: $ef053115c0f9207e$var$gl
};
function $ef053115c0f9207e$var$gl(e, t, n) {
    let r = 1;
    return i;
    function i(S) {
        return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(S), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), s;
    }
    function s(S) {
        return $ef053115c0f9207e$var$Ve(S) ? (e.consume(S), o) : $ef053115c0f9207e$var$qr(S) ? c(S) : n(S);
    }
    function o(S) {
        return S === 43 || S === 45 || S === 46 || $ef053115c0f9207e$var$ze(S) ? l(S) : c(S);
    }
    function l(S) {
        return S === 58 ? (e.consume(S), u) : (S === 43 || S === 45 || S === 46 || $ef053115c0f9207e$var$ze(S)) && r++ < 32 ? (e.consume(S), l) : c(S);
    }
    function u(S) {
        return S === 62 ? (e.exit("autolinkProtocol"), E(S)) : S === null || S === 32 || S === 60 || $ef053115c0f9207e$var$Qn(S) ? n(S) : (e.consume(S), u);
    }
    function c(S) {
        return S === 64 ? (e.consume(S), r = 0, h) : $ef053115c0f9207e$var$qr(S) ? (e.consume(S), c) : n(S);
    }
    function h(S) {
        return $ef053115c0f9207e$var$ze(S) ? p(S) : n(S);
    }
    function p(S) {
        return S === 46 ? (e.consume(S), r = 0, h) : S === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", E(S)) : _(S);
    }
    function _(S) {
        return (S === 45 || $ef053115c0f9207e$var$ze(S)) && r++ < 63 ? (e.consume(S), S === 45 ? _ : p) : n(S);
    }
    function E(S) {
        return e.enter("autolinkMarker"), e.consume(S), e.exit("autolinkMarker"), e.exit("autolink"), t;
    }
}
const $ef053115c0f9207e$var$Zt = {
    tokenize: $ef053115c0f9207e$var$Al,
    partial: !0
};
function $ef053115c0f9207e$var$Al(e, t, n) {
    return $ef053115c0f9207e$var$Z(e, r, "linePrefix");
    function r(i) {
        return i === null || $ef053115c0f9207e$var$H(i) ? t(i) : n(i);
    }
}
const $ef053115c0f9207e$var$Ws = {
    name: "blockQuote",
    tokenize: $ef053115c0f9207e$var$Cl,
    continuation: {
        tokenize: $ef053115c0f9207e$var$Sl
    },
    exit: $ef053115c0f9207e$var$Nl
};
function $ef053115c0f9207e$var$Cl(e, t, n) {
    const r = this;
    return i;
    function i(o) {
        if (o === 62) {
            const l = r.containerState;
            return l.open || (e.enter("blockQuote", {
                _container: !0
            }), l.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(o), e.exit("blockQuoteMarker"), s;
        }
        return n(o);
    }
    function s(o) {
        return $ef053115c0f9207e$var$le(o) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(o), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), t) : (e.exit("blockQuotePrefix"), t(o));
    }
}
function $ef053115c0f9207e$var$Sl(e, t, n) {
    return $ef053115c0f9207e$var$Z(e, e.attempt($ef053115c0f9207e$var$Ws, t, n), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function $ef053115c0f9207e$var$Nl(e) {
    e.exit("blockQuote");
}
const $ef053115c0f9207e$var$qs = {
    name: "characterEscape",
    tokenize: $ef053115c0f9207e$var$Il
};
function $ef053115c0f9207e$var$Il(e, t, n) {
    return r;
    function r(s) {
        return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(s), e.exit("escapeMarker"), i;
    }
    function i(s) {
        return $ef053115c0f9207e$var$ll(s) ? (e.enter("characterEscapeValue"), e.consume(s), e.exit("characterEscapeValue"), e.exit("characterEscape"), t) : n(s);
    }
}
const $ef053115c0f9207e$var$Zr = document.createElement("i");
function $ef053115c0f9207e$var$ir(e) {
    const t = "&" + e + ";";
    $ef053115c0f9207e$var$Zr.innerHTML = t;
    const n = $ef053115c0f9207e$var$Zr.textContent;
    return n.charCodeAt(n.length - 1) === 59 && e !== "semi" || n === t ? !1 : n;
}
const $ef053115c0f9207e$var$Vs = {
    name: "characterReference",
    tokenize: $ef053115c0f9207e$var$Ol
};
function $ef053115c0f9207e$var$Ol(e, t, n) {
    const r = this;
    let i = 0, s, o;
    return l;
    function l(p) {
        return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(p), e.exit("characterReferenceMarker"), u;
    }
    function u(p) {
        return p === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(p), e.exit("characterReferenceMarkerNumeric"), c) : (e.enter("characterReferenceValue"), s = 31, o = $ef053115c0f9207e$var$ze, h(p));
    }
    function c(p) {
        return p === 88 || p === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(p), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), s = 6, o = $ef053115c0f9207e$var$al, h) : (e.enter("characterReferenceValue"), s = 7, o = $ef053115c0f9207e$var$$n, h(p));
    }
    function h(p) {
        let _;
        return p === 59 && i ? (_ = e.exit("characterReferenceValue"), o === $ef053115c0f9207e$var$ze && !$ef053115c0f9207e$var$ir(r.sliceSerialize(_)) ? n(p) : (e.enter("characterReferenceMarker"), e.consume(p), e.exit("characterReferenceMarker"), e.exit("characterReference"), t)) : o(p) && i++ < s ? (e.consume(p), h) : n(p);
    }
}
const $ef053115c0f9207e$var$ei = {
    name: "codeFenced",
    tokenize: $ef053115c0f9207e$var$Rl,
    concrete: !0
};
function $ef053115c0f9207e$var$Rl(e, t, n) {
    const r = this, i = {
        tokenize: K,
        partial: !0
    }, s = {
        tokenize: v,
        partial: !0
    }, o = this.events[this.events.length - 1], l = o && o[1].type === "linePrefix" ? o[2].sliceSerialize(o[1], !0).length : 0;
    let u = 0, c;
    return h;
    function h(A) {
        return e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), c = A, p(A);
    }
    function p(A) {
        return A === c ? (e.consume(A), u++, p) : (e.exit("codeFencedFenceSequence"), u < 3 ? n(A) : $ef053115c0f9207e$var$Z(e, _, "whitespace")(A));
    }
    function _(A) {
        return A === null || $ef053115c0f9207e$var$H(A) ? b(A) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
            contentType: "string"
        }), E(A));
    }
    function E(A) {
        return A === null || $ef053115c0f9207e$var$De(A) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), $ef053115c0f9207e$var$Z(e, S, "whitespace")(A)) : A === 96 && A === c ? n(A) : (e.consume(A), E);
    }
    function S(A) {
        return A === null || $ef053115c0f9207e$var$H(A) ? b(A) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
            contentType: "string"
        }), R(A));
    }
    function R(A) {
        return A === null || $ef053115c0f9207e$var$H(A) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), b(A)) : A === 96 && A === c ? n(A) : (e.consume(A), R);
    }
    function b(A) {
        return e.exit("codeFencedFence"), r.interrupt ? t(A) : N(A);
    }
    function N(A) {
        return A === null ? k(A) : $ef053115c0f9207e$var$H(A) ? e.attempt(s, e.attempt(i, k, l ? $ef053115c0f9207e$var$Z(e, N, "linePrefix", l + 1) : N), k)(A) : (e.enter("codeFlowValue"), U(A));
    }
    function U(A) {
        return A === null || $ef053115c0f9207e$var$H(A) ? (e.exit("codeFlowValue"), N(A)) : (e.consume(A), U);
    }
    function k(A) {
        return e.exit("codeFenced"), t(A);
    }
    function v(A, F, $) {
        const q = this;
        return fe;
        function fe(w) {
            return A.enter("lineEnding"), A.consume(w), A.exit("lineEnding"), M;
        }
        function M(w) {
            return q.parser.lazy[q.now().line] ? $(w) : F(w);
        }
    }
    function K(A, F, $) {
        let q = 0;
        return $ef053115c0f9207e$var$Z(A, fe, "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
        function fe(z) {
            return A.enter("codeFencedFence"), A.enter("codeFencedFenceSequence"), M(z);
        }
        function M(z) {
            return z === c ? (A.consume(z), q++, M) : q < u ? $(z) : (A.exit("codeFencedFenceSequence"), $ef053115c0f9207e$var$Z(A, w, "whitespace")(z));
        }
        function w(z) {
            return z === null || $ef053115c0f9207e$var$H(z) ? (A.exit("codeFencedFence"), F(z)) : $(z);
        }
    }
}
const $ef053115c0f9207e$var$An = {
    name: "codeIndented",
    tokenize: $ef053115c0f9207e$var$yl
}, $ef053115c0f9207e$var$xl = {
    tokenize: $ef053115c0f9207e$var$kl,
    partial: !0
};
function $ef053115c0f9207e$var$yl(e, t, n) {
    const r = this;
    return i;
    function i(c) {
        return e.enter("codeIndented"), $ef053115c0f9207e$var$Z(e, s, "linePrefix", 5)(c);
    }
    function s(c) {
        const h = r.events[r.events.length - 1];
        return h && h[1].type === "linePrefix" && h[2].sliceSerialize(h[1], !0).length >= 4 ? o(c) : n(c);
    }
    function o(c) {
        return c === null ? u(c) : $ef053115c0f9207e$var$H(c) ? e.attempt($ef053115c0f9207e$var$xl, o, u)(c) : (e.enter("codeFlowValue"), l(c));
    }
    function l(c) {
        return c === null || $ef053115c0f9207e$var$H(c) ? (e.exit("codeFlowValue"), o(c)) : (e.consume(c), l);
    }
    function u(c) {
        return e.exit("codeIndented"), t(c);
    }
}
function $ef053115c0f9207e$var$kl(e, t, n) {
    const r = this;
    return i;
    function i(o) {
        return r.parser.lazy[r.now().line] ? n(o) : $ef053115c0f9207e$var$H(o) ? (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), i) : $ef053115c0f9207e$var$Z(e, s, "linePrefix", 5)(o);
    }
    function s(o) {
        const l = r.events[r.events.length - 1];
        return l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? t(o) : $ef053115c0f9207e$var$H(o) ? i(o) : n(o);
    }
}
const $ef053115c0f9207e$var$Ll = {
    name: "codeText",
    tokenize: $ef053115c0f9207e$var$Pl,
    resolve: $ef053115c0f9207e$var$Ml,
    previous: $ef053115c0f9207e$var$bl
};
function $ef053115c0f9207e$var$Ml(e) {
    let t = e.length - 4, n = 3, r, i;
    if ((e[n][1].type === "lineEnding" || e[n][1].type === "space") && (e[t][1].type === "lineEnding" || e[t][1].type === "space")) {
        for(r = n; ++r < t;)if (e[r][1].type === "codeTextData") {
            e[n][1].type = "codeTextPadding", e[t][1].type = "codeTextPadding", n += 2, t -= 2;
            break;
        }
    }
    for(r = n - 1, t++; ++r <= t;)i === void 0 ? r !== t && e[r][1].type !== "lineEnding" && (i = r) : (r === t || e[r][1].type === "lineEnding") && (e[i][1].type = "codeTextData", r !== i + 2 && (e[i][1].end = e[r - 1][1].end, e.splice(i + 2, r - i - 2), t -= r - i - 2, r = i + 2), i = void 0);
    return e;
}
function $ef053115c0f9207e$var$bl(e) {
    return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function $ef053115c0f9207e$var$Pl(e, t, n) {
    let r = 0, i, s;
    return o;
    function o(p) {
        return e.enter("codeText"), e.enter("codeTextSequence"), l(p);
    }
    function l(p) {
        return p === 96 ? (e.consume(p), r++, l) : (e.exit("codeTextSequence"), u(p));
    }
    function u(p) {
        return p === null ? n(p) : p === 96 ? (s = e.enter("codeTextSequence"), i = 0, h(p)) : p === 32 ? (e.enter("space"), e.consume(p), e.exit("space"), u) : $ef053115c0f9207e$var$H(p) ? (e.enter("lineEnding"), e.consume(p), e.exit("lineEnding"), u) : (e.enter("codeTextData"), c(p));
    }
    function c(p) {
        return p === null || p === 32 || p === 96 || $ef053115c0f9207e$var$H(p) ? (e.exit("codeTextData"), u(p)) : (e.consume(p), c);
    }
    function h(p) {
        return p === 96 ? (e.consume(p), i++, h) : i === r ? (e.exit("codeTextSequence"), e.exit("codeText"), t(p)) : (s.type = "codeTextData", c(p));
    }
}
function $ef053115c0f9207e$var$Xs(e) {
    const t = {};
    let n = -1, r, i, s, o, l, u, c;
    for(; ++n < e.length;){
        for(; n in t;)n = t[n];
        if (r = e[n], n && r[1].type === "chunkFlow" && e[n - 1][1].type === "listItemPrefix" && (u = r[1]._tokenizer.events, s = 0, s < u.length && u[s][1].type === "lineEndingBlank" && (s += 2), s < u.length && u[s][1].type === "content")) for(; ++s < u.length && u[s][1].type !== "content";)u[s][1].type === "chunkText" && (u[s][1]._isInFirstContentOfListItem = !0, s++);
        if (r[0] === "enter") r[1].contentType && (Object.assign(t, $ef053115c0f9207e$var$Dl(e, n)), n = t[n], c = !0);
        else if (r[1]._container) {
            for(s = n, i = void 0; s-- && (o = e[s], o[1].type === "lineEnding" || o[1].type === "lineEndingBlank");)o[0] === "enter" && (i && (e[i][1].type = "lineEndingBlank"), o[1].type = "lineEnding", i = s);
            i && (r[1].end = Object.assign({}, e[i][1].start), l = e.slice(i, n), l.unshift(r), $ef053115c0f9207e$var$Ze(e, i, n - i + 1, l));
        }
    }
    return !c;
}
function $ef053115c0f9207e$var$Dl(e, t) {
    const n = e[t][1], r = e[t][2];
    let i = t - 1;
    const s = [], o = n._tokenizer || r.parser[n.contentType](n.start), l = o.events, u = [], c = {};
    let h, p, _ = -1, E = n, S = 0, R = 0;
    const b = [
        R
    ];
    for(; E;){
        for(; e[++i][1] !== E;);
        s.push(i), E._tokenizer || (h = r.sliceStream(E), E.next || h.push(null), p && o.defineSkip(E.start), E._isInFirstContentOfListItem && (o._gfmTasklistFirstContentOfListItem = !0), o.write(h), E._isInFirstContentOfListItem && (o._gfmTasklistFirstContentOfListItem = void 0)), p = E, E = E.next;
    }
    for(E = n; ++_ < l.length;)// Find a void token that includes a break.
    l[_][0] === "exit" && l[_ - 1][0] === "enter" && l[_][1].type === l[_ - 1][1].type && l[_][1].start.line !== l[_][1].end.line && (R = _ + 1, b.push(R), E._tokenizer = void 0, E.previous = void 0, E = E.next);
    for(o.events = [], E ? (E._tokenizer = void 0, E.previous = void 0) : b.pop(), _ = b.length; _--;){
        const N = l.slice(b[_], b[_ + 1]), U = s.pop();
        u.unshift([
            U,
            U + N.length - 1
        ]), $ef053115c0f9207e$var$Ze(e, U, 2, N);
    }
    for(_ = -1; ++_ < u.length;)c[S + u[_][0]] = S + u[_][1], S += u[_][1] - u[_][0] - 1;
    return c;
}
const $ef053115c0f9207e$var$wl = {
    tokenize: $ef053115c0f9207e$var$Bl,
    resolve: $ef053115c0f9207e$var$Hl
}, $ef053115c0f9207e$var$Fl = {
    tokenize: $ef053115c0f9207e$var$Ul,
    partial: !0
};
function $ef053115c0f9207e$var$Hl(e) {
    return $ef053115c0f9207e$var$Xs(e), e;
}
function $ef053115c0f9207e$var$Bl(e, t) {
    let n;
    return r;
    function r(l) {
        return e.enter("content"), n = e.enter("chunkContent", {
            contentType: "content"
        }), i(l);
    }
    function i(l) {
        return l === null ? s(l) : $ef053115c0f9207e$var$H(l) ? e.check($ef053115c0f9207e$var$Fl, o, s)(l) : (e.consume(l), i);
    }
    function s(l) {
        return e.exit("chunkContent"), e.exit("content"), t(l);
    }
    function o(l) {
        return e.consume(l), e.exit("chunkContent"), n.next = e.enter("chunkContent", {
            contentType: "content",
            previous: n
        }), n = n.next, i;
    }
}
function $ef053115c0f9207e$var$Ul(e, t, n) {
    const r = this;
    return i;
    function i(o) {
        return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), $ef053115c0f9207e$var$Z(e, s, "linePrefix");
    }
    function s(o) {
        if (o === null || $ef053115c0f9207e$var$H(o)) return n(o);
        const l = r.events[r.events.length - 1];
        return !r.parser.constructs.disable.null.includes("codeIndented") && l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? t(o) : e.interrupt(r.parser.constructs.flow, n, t)(o);
    }
}
function $ef053115c0f9207e$var$Js(e, t, n, r, i, s, o, l, u) {
    const c = u || Number.POSITIVE_INFINITY;
    let h = 0;
    return p;
    function p(N) {
        return N === 60 ? (e.enter(r), e.enter(i), e.enter(s), e.consume(N), e.exit(s), _) : N === null || N === 41 || $ef053115c0f9207e$var$Qn(N) ? n(N) : (e.enter(r), e.enter(o), e.enter(l), e.enter("chunkString", {
            contentType: "string"
        }), R(N));
    }
    function _(N) {
        return N === 62 ? (e.enter(s), e.consume(N), e.exit(s), e.exit(i), e.exit(r), t) : (e.enter(l), e.enter("chunkString", {
            contentType: "string"
        }), E(N));
    }
    function E(N) {
        return N === 62 ? (e.exit("chunkString"), e.exit(l), _(N)) : N === null || N === 60 || $ef053115c0f9207e$var$H(N) ? n(N) : (e.consume(N), N === 92 ? S : E);
    }
    function S(N) {
        return N === 60 || N === 62 || N === 92 ? (e.consume(N), E) : E(N);
    }
    function R(N) {
        return N === 40 ? ++h > c ? n(N) : (e.consume(N), R) : N === 41 ? h-- ? (e.consume(N), R) : (e.exit("chunkString"), e.exit(l), e.exit(o), e.exit(r), t(N)) : N === null || $ef053115c0f9207e$var$De(N) ? h ? n(N) : (e.exit("chunkString"), e.exit(l), e.exit(o), e.exit(r), t(N)) : $ef053115c0f9207e$var$Qn(N) ? n(N) : (e.consume(N), N === 92 ? b : R);
    }
    function b(N) {
        return N === 40 || N === 41 || N === 92 ? (e.consume(N), R) : R(N);
    }
}
function $ef053115c0f9207e$var$Zs(e, t, n, r, i, s) {
    const o = this;
    let l = 0, u;
    return c;
    function c(E) {
        return e.enter(r), e.enter(i), e.consume(E), e.exit(i), e.enter(s), h;
    }
    function h(E) {
        return E === null || E === 91 || E === 93 && !u || /* To do: remove in the future once we’ve switched from
     * `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
     * which doesn’t need this */ /* Hidden footnotes hook */ /* c8 ignore next 3 */ E === 94 && !l && "_hiddenFootnoteSupport" in o.parser.constructs || l > 999 ? n(E) : E === 93 ? (e.exit(s), e.enter(i), e.consume(E), e.exit(i), e.exit(r), t) : $ef053115c0f9207e$var$H(E) ? (e.enter("lineEnding"), e.consume(E), e.exit("lineEnding"), h) : (e.enter("chunkString", {
            contentType: "string"
        }), p(E));
    }
    function p(E) {
        return E === null || E === 91 || E === 93 || $ef053115c0f9207e$var$H(E) || l++ > 999 ? (e.exit("chunkString"), h(E)) : (e.consume(E), u = u || !$ef053115c0f9207e$var$le(E), E === 92 ? _ : p);
    }
    function _(E) {
        return E === 91 || E === 92 || E === 93 ? (e.consume(E), l++, p) : p(E);
    }
}
function $ef053115c0f9207e$var$eo(e, t, n, r, i, s) {
    let o;
    return l;
    function l(_) {
        return e.enter(r), e.enter(i), e.consume(_), e.exit(i), o = _ === 40 ? 41 : _, u;
    }
    function u(_) {
        return _ === o ? (e.enter(i), e.consume(_), e.exit(i), e.exit(r), t) : (e.enter(s), c(_));
    }
    function c(_) {
        return _ === o ? (e.exit(s), u(o)) : _ === null ? n(_) : $ef053115c0f9207e$var$H(_) ? (e.enter("lineEnding"), e.consume(_), e.exit("lineEnding"), $ef053115c0f9207e$var$Z(e, c, "linePrefix")) : (e.enter("chunkString", {
            contentType: "string"
        }), h(_));
    }
    function h(_) {
        return _ === o || _ === null || $ef053115c0f9207e$var$H(_) ? (e.exit("chunkString"), c(_)) : (e.consume(_), _ === 92 ? p : h);
    }
    function p(_) {
        return _ === o || _ === 92 ? (e.consume(_), h) : h(_);
    }
}
function $ef053115c0f9207e$var$lt(e, t) {
    let n;
    return r;
    function r(i) {
        return $ef053115c0f9207e$var$H(i) ? (e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), n = !0, r) : $ef053115c0f9207e$var$le(i) ? $ef053115c0f9207e$var$Z(e, r, n ? "linePrefix" : "lineSuffix")(i) : t(i);
    }
}
function $ef053115c0f9207e$var$z1(e) {
    return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const $ef053115c0f9207e$var$vl = {
    name: "definition",
    tokenize: $ef053115c0f9207e$var$Kl
}, $ef053115c0f9207e$var$Gl = {
    tokenize: $ef053115c0f9207e$var$zl,
    partial: !0
};
function $ef053115c0f9207e$var$Kl(e, t, n) {
    const r = this;
    let i;
    return s;
    function s(u) {
        return e.enter("definition"), $ef053115c0f9207e$var$Zs.call(r, e, o, n, "definitionLabel", "definitionLabelMarker", "definitionLabelString")(u);
    }
    function o(u) {
        return i = $ef053115c0f9207e$var$z1(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)), u === 58 ? (e.enter("definitionMarker"), e.consume(u), e.exit("definitionMarker"), $ef053115c0f9207e$var$lt(e, $ef053115c0f9207e$var$Js(e, e.attempt($ef053115c0f9207e$var$Gl, $ef053115c0f9207e$var$Z(e, l, "whitespace"), $ef053115c0f9207e$var$Z(e, l, "whitespace")), n, "definitionDestination", "definitionDestinationLiteral", "definitionDestinationLiteralMarker", "definitionDestinationRaw", "definitionDestinationString"))) : n(u);
    }
    function l(u) {
        return u === null || $ef053115c0f9207e$var$H(u) ? (e.exit("definition"), r.parser.defined.includes(i) || r.parser.defined.push(i), t(u)) : n(u);
    }
}
function $ef053115c0f9207e$var$zl(e, t, n) {
    return r;
    function r(o) {
        return $ef053115c0f9207e$var$De(o) ? $ef053115c0f9207e$var$lt(e, i)(o) : n(o);
    }
    function i(o) {
        return o === 34 || o === 39 || o === 40 ? $ef053115c0f9207e$var$eo(e, $ef053115c0f9207e$var$Z(e, s, "whitespace"), n, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(o) : n(o);
    }
    function s(o) {
        return o === null || $ef053115c0f9207e$var$H(o) ? t(o) : n(o);
    }
}
const $ef053115c0f9207e$var$Yl = {
    name: "hardBreakEscape",
    tokenize: $ef053115c0f9207e$var$jl
};
function $ef053115c0f9207e$var$jl(e, t, n) {
    return r;
    function r(s) {
        return e.enter("hardBreakEscape"), e.enter("escapeMarker"), e.consume(s), i;
    }
    function i(s) {
        return $ef053115c0f9207e$var$H(s) ? (e.exit("escapeMarker"), e.exit("hardBreakEscape"), t(s)) : n(s);
    }
}
const $ef053115c0f9207e$var$$l = {
    name: "headingAtx",
    tokenize: $ef053115c0f9207e$var$Wl,
    resolve: $ef053115c0f9207e$var$Ql
};
function $ef053115c0f9207e$var$Ql(e, t) {
    let n = e.length - 2, r = 3, i, s;
    return e[r][1].type === "whitespace" && (r += 2), n - 2 > r && e[n][1].type === "whitespace" && (n -= 2), e[n][1].type === "atxHeadingSequence" && (r === n - 1 || n - 4 > r && e[n - 2][1].type === "whitespace") && (n -= r + 1 === n ? 2 : 4), n > r && (i = {
        type: "atxHeadingText",
        start: e[r][1].start,
        end: e[n][1].end
    }, s = {
        type: "chunkText",
        start: e[r][1].start,
        end: e[n][1].end,
        // @ts-expect-error Constants are fine to assign.
        contentType: "text"
    }, $ef053115c0f9207e$var$Ze(e, r, n - r + 1, [
        [
            "enter",
            i,
            t
        ],
        [
            "enter",
            s,
            t
        ],
        [
            "exit",
            s,
            t
        ],
        [
            "exit",
            i,
            t
        ]
    ])), e;
}
function $ef053115c0f9207e$var$Wl(e, t, n) {
    const r = this;
    let i = 0;
    return s;
    function s(h) {
        return e.enter("atxHeading"), e.enter("atxHeadingSequence"), o(h);
    }
    function o(h) {
        return h === 35 && i++ < 6 ? (e.consume(h), o) : h === null || $ef053115c0f9207e$var$De(h) ? (e.exit("atxHeadingSequence"), r.interrupt ? t(h) : l(h)) : n(h);
    }
    function l(h) {
        return h === 35 ? (e.enter("atxHeadingSequence"), u(h)) : h === null || $ef053115c0f9207e$var$H(h) ? (e.exit("atxHeading"), t(h)) : $ef053115c0f9207e$var$le(h) ? $ef053115c0f9207e$var$Z(e, l, "whitespace")(h) : (e.enter("atxHeadingText"), c(h));
    }
    function u(h) {
        return h === 35 ? (e.consume(h), u) : (e.exit("atxHeadingSequence"), l(h));
    }
    function c(h) {
        return h === null || h === 35 || $ef053115c0f9207e$var$De(h) ? (e.exit("atxHeadingText"), l(h)) : (e.consume(h), c);
    }
}
const $ef053115c0f9207e$var$ql = [
    "address",
    "article",
    "aside",
    "base",
    "basefont",
    "blockquote",
    "body",
    "caption",
    "center",
    "col",
    "colgroup",
    "dd",
    "details",
    "dialog",
    "dir",
    "div",
    "dl",
    "dt",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "frame",
    "frameset",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hr",
    "html",
    "iframe",
    "legend",
    "li",
    "link",
    "main",
    "menu",
    "menuitem",
    "nav",
    "noframes",
    "ol",
    "optgroup",
    "option",
    "p",
    "param",
    "section",
    "summary",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "title",
    "tr",
    "track",
    "ul"
], $ef053115c0f9207e$var$ti = [
    "pre",
    "script",
    "style",
    "textarea"
], $ef053115c0f9207e$var$Vl = {
    name: "htmlFlow",
    tokenize: $ef053115c0f9207e$var$Zl,
    resolveTo: $ef053115c0f9207e$var$Jl,
    concrete: !0
}, $ef053115c0f9207e$var$Xl = {
    tokenize: $ef053115c0f9207e$var$eu,
    partial: !0
};
function $ef053115c0f9207e$var$Jl(e) {
    let t = e.length;
    for(; t-- && !(e[t][0] === "enter" && e[t][1].type === "htmlFlow"););
    return t > 1 && e[t - 2][1].type === "linePrefix" && (e[t][1].start = e[t - 2][1].start, e[t + 1][1].start = e[t - 2][1].start, e.splice(t - 2, 2)), e;
}
function $ef053115c0f9207e$var$Zl(e, t, n) {
    const r = this;
    let i, s, o, l, u;
    return c;
    function c(d) {
        return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(d), h;
    }
    function h(d) {
        return d === 33 ? (e.consume(d), p) : d === 47 ? (e.consume(d), S) : d === 63 ? (e.consume(d), i = 3, r.interrupt ? t : Se) : $ef053115c0f9207e$var$Ve(d) ? (e.consume(d), o = String.fromCharCode(d), s = !0, R) : n(d);
    }
    function p(d) {
        return d === 45 ? (e.consume(d), i = 2, _) : d === 91 ? (e.consume(d), i = 5, o = "CDATA[", l = 0, E) : $ef053115c0f9207e$var$Ve(d) ? (e.consume(d), i = 4, r.interrupt ? t : Se) : n(d);
    }
    function _(d) {
        return d === 45 ? (e.consume(d), r.interrupt ? t : Se) : n(d);
    }
    function E(d) {
        return d === o.charCodeAt(l++) ? (e.consume(d), l === o.length ? r.interrupt ? t : M : E) : n(d);
    }
    function S(d) {
        return $ef053115c0f9207e$var$Ve(d) ? (e.consume(d), o = String.fromCharCode(d), R) : n(d);
    }
    function R(d) {
        return d === null || d === 47 || d === 62 || $ef053115c0f9207e$var$De(d) ? d !== 47 && s && $ef053115c0f9207e$var$ti.includes(o.toLowerCase()) ? (i = 1, r.interrupt ? t(d) : M(d)) : $ef053115c0f9207e$var$ql.includes(o.toLowerCase()) ? (i = 6, d === 47 ? (e.consume(d), b) : r.interrupt ? t(d) : M(d)) : (i = 7, r.interrupt && !r.parser.lazy[r.now().line] ? n(d) : s ? U(d) : N(d)) : d === 45 || $ef053115c0f9207e$var$ze(d) ? (e.consume(d), o += String.fromCharCode(d), R) : n(d);
    }
    function b(d) {
        return d === 62 ? (e.consume(d), r.interrupt ? t : M) : n(d);
    }
    function N(d) {
        return $ef053115c0f9207e$var$le(d) ? (e.consume(d), N) : q(d);
    }
    function U(d) {
        return d === 47 ? (e.consume(d), q) : d === 58 || d === 95 || $ef053115c0f9207e$var$Ve(d) ? (e.consume(d), k) : $ef053115c0f9207e$var$le(d) ? (e.consume(d), U) : q(d);
    }
    function k(d) {
        return d === 45 || d === 46 || d === 58 || d === 95 || $ef053115c0f9207e$var$ze(d) ? (e.consume(d), k) : v(d);
    }
    function v(d) {
        return d === 61 ? (e.consume(d), K) : $ef053115c0f9207e$var$le(d) ? (e.consume(d), v) : U(d);
    }
    function K(d) {
        return d === null || d === 60 || d === 61 || d === 62 || d === 96 ? n(d) : d === 34 || d === 39 ? (e.consume(d), u = d, A) : $ef053115c0f9207e$var$le(d) ? (e.consume(d), K) : (u = null, F(d));
    }
    function A(d) {
        return d === null || $ef053115c0f9207e$var$H(d) ? n(d) : d === u ? (e.consume(d), $) : (e.consume(d), A);
    }
    function F(d) {
        return d === null || d === 34 || d === 39 || d === 60 || d === 61 || d === 62 || d === 96 || $ef053115c0f9207e$var$De(d) ? v(d) : (e.consume(d), F);
    }
    function $(d) {
        return d === 47 || d === 62 || $ef053115c0f9207e$var$le(d) ? U(d) : n(d);
    }
    function q(d) {
        return d === 62 ? (e.consume(d), fe) : n(d);
    }
    function fe(d) {
        return $ef053115c0f9207e$var$le(d) ? (e.consume(d), fe) : d === null || $ef053115c0f9207e$var$H(d) ? M(d) : n(d);
    }
    function M(d) {
        return d === 45 && i === 2 ? (e.consume(d), ke) : d === 60 && i === 1 ? (e.consume(d), $e) : d === 62 && i === 4 ? (e.consume(d), ue) : d === 63 && i === 3 ? (e.consume(d), Se) : d === 93 && i === 5 ? (e.consume(d), Te) : $ef053115c0f9207e$var$H(d) && (i === 6 || i === 7) ? e.check($ef053115c0f9207e$var$Xl, ue, w)(d) : d === null || $ef053115c0f9207e$var$H(d) ? w(d) : (e.consume(d), M);
    }
    function w(d) {
        return e.exit("htmlFlowData"), z(d);
    }
    function z(d) {
        return d === null ? m(d) : $ef053115c0f9207e$var$H(d) ? e.attempt({
            tokenize: ge,
            partial: !0
        }, z, m)(d) : (e.enter("htmlFlowData"), M(d));
    }
    function ge(d, L1, W1) {
        return M1;
        function M1(Qe) {
            return d.enter("lineEnding"), d.consume(Qe), d.exit("lineEnding"), ce;
        }
        function ce(Qe) {
            return r.parser.lazy[r.now().line] ? W1(Qe) : L1(Qe);
        }
    }
    function ke(d) {
        return d === 45 ? (e.consume(d), Se) : M(d);
    }
    function $e(d) {
        return d === 47 ? (e.consume(d), o = "", Ue) : M(d);
    }
    function Ue(d) {
        return d === 62 && $ef053115c0f9207e$var$ti.includes(o.toLowerCase()) ? (e.consume(d), ue) : $ef053115c0f9207e$var$Ve(d) && o.length < 8 ? (e.consume(d), o += String.fromCharCode(d), Ue) : M(d);
    }
    function Te(d) {
        return d === 93 ? (e.consume(d), Se) : M(d);
    }
    function Se(d) {
        return d === 62 ? (e.consume(d), ue) : d === 45 && i === 2 ? (e.consume(d), Se) : M(d);
    }
    function ue(d) {
        return d === null || $ef053115c0f9207e$var$H(d) ? (e.exit("htmlFlowData"), m(d)) : (e.consume(d), ue);
    }
    function m(d) {
        return e.exit("htmlFlow"), t(d);
    }
}
function $ef053115c0f9207e$var$eu(e, t, n) {
    return r;
    function r(i) {
        return e.exit("htmlFlowData"), e.enter("lineEndingBlank"), e.consume(i), e.exit("lineEndingBlank"), e.attempt($ef053115c0f9207e$var$Zt, t, n);
    }
}
const $ef053115c0f9207e$var$tu = {
    name: "htmlText",
    tokenize: $ef053115c0f9207e$var$nu
};
function $ef053115c0f9207e$var$nu(e, t, n) {
    const r = this;
    let i, s, o, l;
    return u;
    function u(m) {
        return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(m), c;
    }
    function c(m) {
        return m === 33 ? (e.consume(m), h) : m === 47 ? (e.consume(m), F) : m === 63 ? (e.consume(m), K) : $ef053115c0f9207e$var$Ve(m) ? (e.consume(m), fe) : n(m);
    }
    function h(m) {
        return m === 45 ? (e.consume(m), p) : m === 91 ? (e.consume(m), s = "CDATA[", o = 0, b) : $ef053115c0f9207e$var$Ve(m) ? (e.consume(m), v) : n(m);
    }
    function p(m) {
        return m === 45 ? (e.consume(m), _) : n(m);
    }
    function _(m) {
        return m === null || m === 62 ? n(m) : m === 45 ? (e.consume(m), E) : S(m);
    }
    function E(m) {
        return m === null || m === 62 ? n(m) : S(m);
    }
    function S(m) {
        return m === null ? n(m) : m === 45 ? (e.consume(m), R) : $ef053115c0f9207e$var$H(m) ? (l = S, Te(m)) : (e.consume(m), S);
    }
    function R(m) {
        return m === 45 ? (e.consume(m), ue) : S(m);
    }
    function b(m) {
        return m === s.charCodeAt(o++) ? (e.consume(m), o === s.length ? N : b) : n(m);
    }
    function N(m) {
        return m === null ? n(m) : m === 93 ? (e.consume(m), U) : $ef053115c0f9207e$var$H(m) ? (l = N, Te(m)) : (e.consume(m), N);
    }
    function U(m) {
        return m === 93 ? (e.consume(m), k) : N(m);
    }
    function k(m) {
        return m === 62 ? ue(m) : m === 93 ? (e.consume(m), k) : N(m);
    }
    function v(m) {
        return m === null || m === 62 ? ue(m) : $ef053115c0f9207e$var$H(m) ? (l = v, Te(m)) : (e.consume(m), v);
    }
    function K(m) {
        return m === null ? n(m) : m === 63 ? (e.consume(m), A) : $ef053115c0f9207e$var$H(m) ? (l = K, Te(m)) : (e.consume(m), K);
    }
    function A(m) {
        return m === 62 ? ue(m) : K(m);
    }
    function F(m) {
        return $ef053115c0f9207e$var$Ve(m) ? (e.consume(m), $) : n(m);
    }
    function $(m) {
        return m === 45 || $ef053115c0f9207e$var$ze(m) ? (e.consume(m), $) : q(m);
    }
    function q(m) {
        return $ef053115c0f9207e$var$H(m) ? (l = q, Te(m)) : $ef053115c0f9207e$var$le(m) ? (e.consume(m), q) : ue(m);
    }
    function fe(m) {
        return m === 45 || $ef053115c0f9207e$var$ze(m) ? (e.consume(m), fe) : m === 47 || m === 62 || $ef053115c0f9207e$var$De(m) ? M(m) : n(m);
    }
    function M(m) {
        return m === 47 ? (e.consume(m), ue) : m === 58 || m === 95 || $ef053115c0f9207e$var$Ve(m) ? (e.consume(m), w) : $ef053115c0f9207e$var$H(m) ? (l = M, Te(m)) : $ef053115c0f9207e$var$le(m) ? (e.consume(m), M) : ue(m);
    }
    function w(m) {
        return m === 45 || m === 46 || m === 58 || m === 95 || $ef053115c0f9207e$var$ze(m) ? (e.consume(m), w) : z(m);
    }
    function z(m) {
        return m === 61 ? (e.consume(m), ge) : $ef053115c0f9207e$var$H(m) ? (l = z, Te(m)) : $ef053115c0f9207e$var$le(m) ? (e.consume(m), z) : M(m);
    }
    function ge(m) {
        return m === null || m === 60 || m === 61 || m === 62 || m === 96 ? n(m) : m === 34 || m === 39 ? (e.consume(m), i = m, ke) : $ef053115c0f9207e$var$H(m) ? (l = ge, Te(m)) : $ef053115c0f9207e$var$le(m) ? (e.consume(m), ge) : (e.consume(m), i = void 0, Ue);
    }
    function ke(m) {
        return m === i ? (e.consume(m), $e) : m === null ? n(m) : $ef053115c0f9207e$var$H(m) ? (l = ke, Te(m)) : (e.consume(m), ke);
    }
    function $e(m) {
        return m === 62 || m === 47 || $ef053115c0f9207e$var$De(m) ? M(m) : n(m);
    }
    function Ue(m) {
        return m === null || m === 34 || m === 39 || m === 60 || m === 61 || m === 96 ? n(m) : m === 62 || $ef053115c0f9207e$var$De(m) ? M(m) : (e.consume(m), Ue);
    }
    function Te(m) {
        return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(m), e.exit("lineEnding"), $ef053115c0f9207e$var$Z(e, Se, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
    }
    function Se(m) {
        return e.enter("htmlTextData"), l(m);
    }
    function ue(m) {
        return m === 62 ? (e.consume(m), e.exit("htmlTextData"), e.exit("htmlText"), t) : n(m);
    }
}
const $ef053115c0f9207e$var$sr = {
    name: "labelEnd",
    tokenize: $ef053115c0f9207e$var$lu,
    resolveTo: $ef053115c0f9207e$var$au,
    resolveAll: $ef053115c0f9207e$var$ou
}, $ef053115c0f9207e$var$ru = {
    tokenize: $ef053115c0f9207e$var$uu
}, $ef053115c0f9207e$var$iu = {
    tokenize: $ef053115c0f9207e$var$cu
}, $ef053115c0f9207e$var$su = {
    tokenize: $ef053115c0f9207e$var$hu
};
function $ef053115c0f9207e$var$ou(e) {
    let t = -1, n;
    for(; ++t < e.length;)n = e[t][1], (n.type === "labelImage" || n.type === "labelLink" || n.type === "labelEnd") && (e.splice(t + 1, n.type === "labelImage" ? 4 : 2), n.type = "data", t++);
    return e;
}
function $ef053115c0f9207e$var$au(e, t) {
    let n = e.length, r = 0, i, s, o, l;
    for(; n--;)if (i = e[n][1], s) {
        if (i.type === "link" || i.type === "labelLink" && i._inactive) break;
        e[n][0] === "enter" && i.type === "labelLink" && (i._inactive = !0);
    } else if (o) {
        if (e[n][0] === "enter" && (i.type === "labelImage" || i.type === "labelLink") && !i._balanced && (s = n, i.type !== "labelLink")) {
            r = 2;
            break;
        }
    } else i.type === "labelEnd" && (o = n);
    const u = {
        type: e[s][1].type === "labelLink" ? "link" : "image",
        start: Object.assign({}, e[s][1].start),
        end: Object.assign({}, e[e.length - 1][1].end)
    }, c = {
        type: "label",
        start: Object.assign({}, e[s][1].start),
        end: Object.assign({}, e[o][1].end)
    }, h = {
        type: "labelText",
        start: Object.assign({}, e[s + r + 2][1].end),
        end: Object.assign({}, e[o - 2][1].start)
    };
    return l = [
        [
            "enter",
            u,
            t
        ],
        [
            "enter",
            c,
            t
        ]
    ], l = $ef053115c0f9207e$var$Pe(l, e.slice(s + 1, s + r + 3)), l = $ef053115c0f9207e$var$Pe(l, [
        [
            "enter",
            h,
            t
        ]
    ]), l = $ef053115c0f9207e$var$Pe(l, $ef053115c0f9207e$var$rr(t.parser.constructs.insideSpan.null, e.slice(s + r + 4, o - 3), t)), l = $ef053115c0f9207e$var$Pe(l, [
        [
            "exit",
            h,
            t
        ],
        e[o - 2],
        e[o - 1],
        [
            "exit",
            c,
            t
        ]
    ]), l = $ef053115c0f9207e$var$Pe(l, e.slice(o + 1)), l = $ef053115c0f9207e$var$Pe(l, [
        [
            "exit",
            u,
            t
        ]
    ]), $ef053115c0f9207e$var$Ze(e, s, e.length, l), e;
}
function $ef053115c0f9207e$var$lu(e, t, n) {
    const r = this;
    let i = r.events.length, s, o;
    for(; i--;)if ((r.events[i][1].type === "labelImage" || r.events[i][1].type === "labelLink") && !r.events[i][1]._balanced) {
        s = r.events[i][1];
        break;
    }
    return l;
    function l(h) {
        return s ? s._inactive ? c(h) : (o = r.parser.defined.includes($ef053115c0f9207e$var$z1(r.sliceSerialize({
            start: s.end,
            end: r.now()
        }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(h), e.exit("labelMarker"), e.exit("labelEnd"), u) : n(h);
    }
    function u(h) {
        return h === 40 ? e.attempt($ef053115c0f9207e$var$ru, t, o ? t : c)(h) : h === 91 ? e.attempt($ef053115c0f9207e$var$iu, t, o ? e.attempt($ef053115c0f9207e$var$su, t, c) : c)(h) : o ? t(h) : c(h);
    }
    function c(h) {
        return s._balanced = !0, n(h);
    }
}
function $ef053115c0f9207e$var$uu(e, t, n) {
    return r;
    function r(u) {
        return e.enter("resource"), e.enter("resourceMarker"), e.consume(u), e.exit("resourceMarker"), $ef053115c0f9207e$var$lt(e, i);
    }
    function i(u) {
        return u === 41 ? l(u) : $ef053115c0f9207e$var$Js(e, s, n, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(u);
    }
    function s(u) {
        return $ef053115c0f9207e$var$De(u) ? $ef053115c0f9207e$var$lt(e, o)(u) : l(u);
    }
    function o(u) {
        return u === 34 || u === 39 || u === 40 ? $ef053115c0f9207e$var$eo(e, $ef053115c0f9207e$var$lt(e, l), n, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(u) : l(u);
    }
    function l(u) {
        return u === 41 ? (e.enter("resourceMarker"), e.consume(u), e.exit("resourceMarker"), e.exit("resource"), t) : n(u);
    }
}
function $ef053115c0f9207e$var$cu(e, t, n) {
    const r = this;
    return i;
    function i(o) {
        return $ef053115c0f9207e$var$Zs.call(r, e, s, n, "reference", "referenceMarker", "referenceString")(o);
    }
    function s(o) {
        return r.parser.defined.includes($ef053115c0f9207e$var$z1(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1))) ? t(o) : n(o);
    }
}
function $ef053115c0f9207e$var$hu(e, t, n) {
    return r;
    function r(s) {
        return e.enter("reference"), e.enter("referenceMarker"), e.consume(s), e.exit("referenceMarker"), i;
    }
    function i(s) {
        return s === 93 ? (e.enter("referenceMarker"), e.consume(s), e.exit("referenceMarker"), e.exit("reference"), t) : n(s);
    }
}
const $ef053115c0f9207e$var$fu = {
    name: "labelStartImage",
    tokenize: $ef053115c0f9207e$var$Tu,
    resolveAll: $ef053115c0f9207e$var$sr.resolveAll
};
function $ef053115c0f9207e$var$Tu(e, t, n) {
    const r = this;
    return i;
    function i(l) {
        return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(l), e.exit("labelImageMarker"), s;
    }
    function s(l) {
        return l === 91 ? (e.enter("labelMarker"), e.consume(l), e.exit("labelMarker"), e.exit("labelImage"), o) : n(l);
    }
    function o(l) {
        return l === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(l) : t(l);
    }
}
const $ef053115c0f9207e$var$du = {
    name: "labelStartLink",
    tokenize: $ef053115c0f9207e$var$mu,
    resolveAll: $ef053115c0f9207e$var$sr.resolveAll
};
function $ef053115c0f9207e$var$mu(e, t, n) {
    const r = this;
    return i;
    function i(o) {
        return e.enter("labelLink"), e.enter("labelMarker"), e.consume(o), e.exit("labelMarker"), e.exit("labelLink"), s;
    }
    function s(o) {
        return o === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(o) : t(o);
    }
}
const $ef053115c0f9207e$var$Cn = {
    name: "lineEnding",
    tokenize: $ef053115c0f9207e$var$pu
};
function $ef053115c0f9207e$var$pu(e, t) {
    return n;
    function n(r) {
        return e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), $ef053115c0f9207e$var$Z(e, t, "linePrefix");
    }
}
const $ef053115c0f9207e$var$vt = {
    name: "thematicBreak",
    tokenize: $ef053115c0f9207e$var$Eu
};
function $ef053115c0f9207e$var$Eu(e, t, n) {
    let r = 0, i;
    return s;
    function s(u) {
        return e.enter("thematicBreak"), i = u, o(u);
    }
    function o(u) {
        return u === i ? (e.enter("thematicBreakSequence"), l(u)) : $ef053115c0f9207e$var$le(u) ? $ef053115c0f9207e$var$Z(e, o, "whitespace")(u) : r < 3 || u !== null && !$ef053115c0f9207e$var$H(u) ? n(u) : (e.exit("thematicBreak"), t(u));
    }
    function l(u) {
        return u === i ? (e.consume(u), r++, l) : (e.exit("thematicBreakSequence"), o(u));
    }
}
const $ef053115c0f9207e$var$Ne = {
    name: "list",
    tokenize: $ef053115c0f9207e$var$Au,
    continuation: {
        tokenize: $ef053115c0f9207e$var$Cu
    },
    exit: $ef053115c0f9207e$var$Nu
}, $ef053115c0f9207e$var$_u = {
    tokenize: $ef053115c0f9207e$var$Iu,
    partial: !0
}, $ef053115c0f9207e$var$gu = {
    tokenize: $ef053115c0f9207e$var$Su,
    partial: !0
};
function $ef053115c0f9207e$var$Au(e, t, n) {
    const r = this, i = r.events[r.events.length - 1];
    let s = i && i[1].type === "linePrefix" ? i[2].sliceSerialize(i[1], !0).length : 0, o = 0;
    return l;
    function l(E) {
        const S = r.containerState.type || (E === 42 || E === 43 || E === 45 ? "listUnordered" : "listOrdered");
        if (S === "listUnordered" ? !r.containerState.marker || E === r.containerState.marker : $ef053115c0f9207e$var$$n(E)) {
            if (r.containerState.type || (r.containerState.type = S, e.enter(S, {
                _container: !0
            })), S === "listUnordered") return e.enter("listItemPrefix"), E === 42 || E === 45 ? e.check($ef053115c0f9207e$var$vt, n, c)(E) : c(E);
            if (!r.interrupt || E === 49) return e.enter("listItemPrefix"), e.enter("listItemValue"), u(E);
        }
        return n(E);
    }
    function u(E) {
        return $ef053115c0f9207e$var$$n(E) && ++o < 10 ? (e.consume(E), u) : (!r.interrupt || o < 2) && (r.containerState.marker ? E === r.containerState.marker : E === 41 || E === 46) ? (e.exit("listItemValue"), c(E)) : n(E);
    }
    function c(E) {
        return e.enter("listItemMarker"), e.consume(E), e.exit("listItemMarker"), r.containerState.marker = r.containerState.marker || E, e.check($ef053115c0f9207e$var$Zt, // Can’t be empty when interrupting.
        r.interrupt ? n : h, e.attempt($ef053115c0f9207e$var$_u, _, p));
    }
    function h(E) {
        return r.containerState.initialBlankLine = !0, s++, _(E);
    }
    function p(E) {
        return $ef053115c0f9207e$var$le(E) ? (e.enter("listItemPrefixWhitespace"), e.consume(E), e.exit("listItemPrefixWhitespace"), _) : n(E);
    }
    function _(E) {
        return r.containerState.size = s + r.sliceSerialize(e.exit("listItemPrefix"), !0).length, t(E);
    }
}
function $ef053115c0f9207e$var$Cu(e, t, n) {
    const r = this;
    return r.containerState._closeFlow = void 0, e.check($ef053115c0f9207e$var$Zt, i, s);
    function i(l) {
        return r.containerState.furtherBlankLines = r.containerState.furtherBlankLines || r.containerState.initialBlankLine, $ef053115c0f9207e$var$Z(e, t, "listItemIndent", r.containerState.size + 1)(l);
    }
    function s(l) {
        return r.containerState.furtherBlankLines || !$ef053115c0f9207e$var$le(l) ? (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, o(l)) : (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, e.attempt($ef053115c0f9207e$var$gu, t, o)(l));
    }
    function o(l) {
        return r.containerState._closeFlow = !0, r.interrupt = void 0, $ef053115c0f9207e$var$Z(e, e.attempt($ef053115c0f9207e$var$Ne, t, n), "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(l);
    }
}
function $ef053115c0f9207e$var$Su(e, t, n) {
    const r = this;
    return $ef053115c0f9207e$var$Z(e, i, "listItemIndent", r.containerState.size + 1);
    function i(s) {
        const o = r.events[r.events.length - 1];
        return o && o[1].type === "listItemIndent" && o[2].sliceSerialize(o[1], !0).length === r.containerState.size ? t(s) : n(s);
    }
}
function $ef053115c0f9207e$var$Nu(e) {
    e.exit(this.containerState.type);
}
function $ef053115c0f9207e$var$Iu(e, t, n) {
    const r = this;
    return $ef053115c0f9207e$var$Z(e, i, "listItemPrefixWhitespace", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
    function i(s) {
        const o = r.events[r.events.length - 1];
        return !$ef053115c0f9207e$var$le(s) && o && o[1].type === "listItemPrefixWhitespace" ? t(s) : n(s);
    }
}
const $ef053115c0f9207e$var$ni = {
    name: "setextUnderline",
    tokenize: $ef053115c0f9207e$var$Ru,
    resolveTo: $ef053115c0f9207e$var$Ou
};
function $ef053115c0f9207e$var$Ou(e, t) {
    let n = e.length, r, i, s;
    for(; n--;)if (e[n][0] === "enter") {
        if (e[n][1].type === "content") {
            r = n;
            break;
        }
        e[n][1].type === "paragraph" && (i = n);
    } else e[n][1].type === "content" && e.splice(n, 1), !s && e[n][1].type === "definition" && (s = n);
    const o = {
        type: "setextHeading",
        start: Object.assign({}, e[i][1].start),
        end: Object.assign({}, e[e.length - 1][1].end)
    };
    return e[i][1].type = "setextHeadingText", s ? (e.splice(i, 0, [
        "enter",
        o,
        t
    ]), e.splice(s + 1, 0, [
        "exit",
        e[r][1],
        t
    ]), e[r][1].end = Object.assign({}, e[s][1].end)) : e[r][1] = o, e.push([
        "exit",
        o,
        t
    ]), e;
}
function $ef053115c0f9207e$var$Ru(e, t, n) {
    const r = this;
    let i = r.events.length, s, o;
    for(; i--;)if (r.events[i][1].type !== "lineEnding" && r.events[i][1].type !== "linePrefix" && r.events[i][1].type !== "content") {
        o = r.events[i][1].type === "paragraph";
        break;
    }
    return l;
    function l(h) {
        return !r.parser.lazy[r.now().line] && (r.interrupt || o) ? (e.enter("setextHeadingLine"), e.enter("setextHeadingLineSequence"), s = h, u(h)) : n(h);
    }
    function u(h) {
        return h === s ? (e.consume(h), u) : (e.exit("setextHeadingLineSequence"), $ef053115c0f9207e$var$Z(e, c, "lineSuffix")(h));
    }
    function c(h) {
        return h === null || $ef053115c0f9207e$var$H(h) ? (e.exit("setextHeadingLine"), t(h)) : n(h);
    }
}
const $ef053115c0f9207e$var$xu = {
    tokenize: $ef053115c0f9207e$var$yu
};
function $ef053115c0f9207e$var$yu(e) {
    const t = this, n = e.attempt(// Try to parse a blank line.
    $ef053115c0f9207e$var$Zt, r, // Try to parse initial flow (essentially, only code).
    e.attempt(this.parser.constructs.flowInitial, i, $ef053115c0f9207e$var$Z(e, e.attempt(this.parser.constructs.flow, i, e.attempt($ef053115c0f9207e$var$wl, i)), "linePrefix")));
    return n;
    function r(s) {
        if (s === null) {
            e.consume(s);
            return;
        }
        return e.enter("lineEndingBlank"), e.consume(s), e.exit("lineEndingBlank"), t.currentConstruct = void 0, n;
    }
    function i(s) {
        if (s === null) {
            e.consume(s);
            return;
        }
        return e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), t.currentConstruct = void 0, n;
    }
}
const $ef053115c0f9207e$var$ku = {
    resolveAll: $ef053115c0f9207e$var$no()
}, $ef053115c0f9207e$var$Lu = $ef053115c0f9207e$var$to("string"), $ef053115c0f9207e$var$Mu = $ef053115c0f9207e$var$to("text");
function $ef053115c0f9207e$var$to(e) {
    return {
        tokenize: t,
        resolveAll: $ef053115c0f9207e$var$no(e === "text" ? $ef053115c0f9207e$var$bu : void 0)
    };
    function t(n) {
        const r = this, i = this.parser.constructs[e], s = n.attempt(i, o, l);
        return o;
        function o(h) {
            return c(h) ? s(h) : l(h);
        }
        function l(h) {
            if (h === null) {
                n.consume(h);
                return;
            }
            return n.enter("data"), n.consume(h), u;
        }
        function u(h) {
            return c(h) ? (n.exit("data"), s(h)) : (n.consume(h), u);
        }
        function c(h) {
            if (h === null) return !0;
            const p = i[h];
            let _ = -1;
            if (p) for(; ++_ < p.length;){
                const E = p[_];
                if (!E.previous || E.previous.call(r, r.previous)) return !0;
            }
            return !1;
        }
    }
}
function $ef053115c0f9207e$var$no(e) {
    return t;
    function t(n, r) {
        let i = -1, s;
        for(; ++i <= n.length;)s === void 0 ? n[i] && n[i][1].type === "data" && (s = i, i++) : (!n[i] || n[i][1].type !== "data") && (i !== s + 2 && (n[s][1].end = n[i - 1][1].end, n.splice(s + 2, i - s - 2), i = s + 2), s = void 0);
        return e ? e(n, r) : n;
    }
}
function $ef053115c0f9207e$var$bu(e, t) {
    let n = 0;
    for(; ++n <= e.length;)if ((n === e.length || e[n][1].type === "lineEnding") && e[n - 1][1].type === "data") {
        const r = e[n - 1][1], i = t.sliceStream(r);
        let s = i.length, o = -1, l = 0, u;
        for(; s--;){
            const c = i[s];
            if (typeof c == "string") {
                for(o = c.length; c.charCodeAt(o - 1) === 32;)l++, o--;
                if (o) break;
                o = -1;
            } else if (c === -2) u = !0, l++;
            else if (c !== -1) {
                s++;
                break;
            }
        }
        if (l) {
            const c = {
                type: n === e.length || u || l < 2 ? "lineSuffix" : "hardBreakTrailing",
                start: {
                    line: r.end.line,
                    column: r.end.column - l,
                    offset: r.end.offset - l,
                    _index: r.start._index + s,
                    _bufferIndex: s ? o : r.start._bufferIndex + o
                },
                end: Object.assign({}, r.end)
            };
            r.end = Object.assign({}, c.start), r.start.offset === r.end.offset ? Object.assign(r, c) : (e.splice(n, 0, [
                "enter",
                c,
                t
            ], [
                "exit",
                c,
                t
            ]), n += 2);
        }
        n++;
    }
    return e;
}
function $ef053115c0f9207e$var$Pu(e, t, n) {
    let r = Object.assign(n ? Object.assign({}, n) : {
        line: 1,
        column: 1,
        offset: 0
    }, {
        _index: 0,
        _bufferIndex: -1
    });
    const i = {}, s = [];
    let o = [], l = [];
    const u = {
        consume: U,
        enter: k,
        exit: v,
        attempt: F(K),
        check: F(A),
        interrupt: F(A, {
            interrupt: !0
        })
    }, c = {
        previous: null,
        code: null,
        containerState: {},
        events: [],
        parser: e,
        sliceStream: E,
        sliceSerialize: _,
        now: S,
        defineSkip: R,
        write: p
    };
    let h = t.tokenize.call(c, u);
    return t.resolveAll && s.push(t), c;
    function p(M) {
        return o = $ef053115c0f9207e$var$Pe(o, M), b(), o[o.length - 1] !== null ? [] : ($(t, 0), c.events = $ef053115c0f9207e$var$rr(s, c.events, c), c.events);
    }
    function _(M, w) {
        return $ef053115c0f9207e$var$wu(E(M), w);
    }
    function E(M) {
        return $ef053115c0f9207e$var$Du(o, M);
    }
    function S() {
        return Object.assign({}, r);
    }
    function R(M) {
        i[M.line] = M.column, fe();
    }
    function b() {
        let M;
        for(; r._index < o.length;){
            const w = o[r._index];
            if (typeof w == "string") for(M = r._index, r._bufferIndex < 0 && (r._bufferIndex = 0); r._index === M && r._bufferIndex < w.length;)N(w.charCodeAt(r._bufferIndex));
            else N(w);
        }
    }
    function N(M) {
        h = h(M);
    }
    function U(M) {
        $ef053115c0f9207e$var$H(M) ? (r.line++, r.column = 1, r.offset += M === -3 ? 2 : 1, fe()) : M !== -1 && (r.column++, r.offset++), r._bufferIndex < 0 ? r._index++ : (r._bufferIndex++, r._bufferIndex === o[r._index].length && (r._bufferIndex = -1, r._index++)), c.previous = M;
    }
    function k(M, w) {
        const z = w || {};
        return z.type = M, z.start = S(), c.events.push([
            "enter",
            z,
            c
        ]), l.push(z), z;
    }
    function v(M) {
        const w = l.pop();
        return w.end = S(), c.events.push([
            "exit",
            w,
            c
        ]), w;
    }
    function K(M, w) {
        $(M, w.from);
    }
    function A(M, w) {
        w.restore();
    }
    function F(M, w) {
        return z;
        function z(ge, ke, $e) {
            let Ue, Te, Se, ue;
            return Array.isArray(ge) ? /* c8 ignore next 1 */ d(ge) : "tokenize" in ge ? d([
                ge
            ]) : m(ge);
            function m(ce) {
                return Qe;
                function Qe(e1) {
                    const b1 = e1 !== null && ce[e1], P1 = e1 !== null && ce.null, fn = [
                        // To do: add more extension tests.
                        /* c8 ignore next 2 */ ...Array.isArray(b1) ? b1 : b1 ? [
                            b1
                        ] : [],
                        ...Array.isArray(P1) ? P1 : P1 ? [
                            P1
                        ] : []
                    ];
                    return d(fn)(e1);
                }
            }
            function d(ce) {
                return Ue = ce, Te = 0, ce.length === 0 ? $e : L1(ce[Te]);
            }
            function L1(ce) {
                return Qe;
                function Qe(e1) {
                    return ue = q(), Se = ce, ce.partial || (c.currentConstruct = ce), ce.name && c.parser.constructs.disable.null.includes(ce.name) ? M1() : ce.tokenize.call(// If we do have fields, create an object w/ `context` as its
                    // prototype.
                    // This allows a “live binding”, which is needed for `interrupt`.
                    w ? Object.assign(Object.create(c), w) : c, u, W1, M1)(e1);
                }
            }
            function W1(ce) {
                return M(Se, ue), ke;
            }
            function M1(ce) {
                return ue.restore(), ++Te < Ue.length ? L1(Ue[Te]) : $e;
            }
        }
    }
    function $(M, w) {
        M.resolveAll && !s.includes(M) && s.push(M), M.resolve && $ef053115c0f9207e$var$Ze(c.events, w, c.events.length - w, M.resolve(c.events.slice(w), c)), M.resolveTo && (c.events = M.resolveTo(c.events, c));
    }
    function q() {
        const M = S(), w = c.previous, z = c.currentConstruct, ge = c.events.length, ke = Array.from(l);
        return {
            restore: $e,
            from: ge
        };
        function $e() {
            r = M, c.previous = w, c.currentConstruct = z, c.events.length = ge, l = ke, fe();
        }
    }
    function fe() {
        r.line in i && r.column < 2 && (r.column = i[r.line], r.offset += i[r.line] - 1);
    }
}
function $ef053115c0f9207e$var$Du(e, t) {
    const n = t.start._index, r = t.start._bufferIndex, i = t.end._index, s = t.end._bufferIndex;
    let o;
    return n === i ? o = [
        e[n].slice(r, s)
    ] : (o = e.slice(n, i), r > -1 && (o[0] = o[0].slice(r)), s > 0 && o.push(e[i].slice(0, s))), o;
}
function $ef053115c0f9207e$var$wu(e, t) {
    let n = -1;
    const r = [];
    let i;
    for(; ++n < e.length;){
        const s = e[n];
        let o;
        if (typeof s == "string") o = s;
        else switch(s){
            case -5:
                o = "\r";
                break;
            case -4:
                o = `
`;
                break;
            case -3:
                o = `\r
`;
                break;
            case -2:
                o = t ? " " : "	";
                break;
            case -1:
                if (!t && i) continue;
                o = " ";
                break;
            default:
                o = String.fromCharCode(s);
        }
        i = s === -2, r.push(o);
    }
    return r.join("");
}
const $ef053115c0f9207e$var$Fu = {
    [42]: $ef053115c0f9207e$var$Ne,
    [43]: $ef053115c0f9207e$var$Ne,
    [45]: $ef053115c0f9207e$var$Ne,
    [48]: $ef053115c0f9207e$var$Ne,
    [49]: $ef053115c0f9207e$var$Ne,
    [50]: $ef053115c0f9207e$var$Ne,
    [51]: $ef053115c0f9207e$var$Ne,
    [52]: $ef053115c0f9207e$var$Ne,
    [53]: $ef053115c0f9207e$var$Ne,
    [54]: $ef053115c0f9207e$var$Ne,
    [55]: $ef053115c0f9207e$var$Ne,
    [56]: $ef053115c0f9207e$var$Ne,
    [57]: $ef053115c0f9207e$var$Ne,
    [62]: $ef053115c0f9207e$var$Ws
}, $ef053115c0f9207e$var$Hu = {
    [91]: $ef053115c0f9207e$var$vl
}, $ef053115c0f9207e$var$Bu = {
    [-2]: $ef053115c0f9207e$var$An,
    [-1]: $ef053115c0f9207e$var$An,
    [32]: $ef053115c0f9207e$var$An
}, $ef053115c0f9207e$var$Uu = {
    [35]: $ef053115c0f9207e$var$$l,
    [42]: $ef053115c0f9207e$var$vt,
    [45]: [
        $ef053115c0f9207e$var$ni,
        $ef053115c0f9207e$var$vt
    ],
    [60]: $ef053115c0f9207e$var$Vl,
    [61]: $ef053115c0f9207e$var$ni,
    [95]: $ef053115c0f9207e$var$vt,
    [96]: $ef053115c0f9207e$var$ei,
    [126]: $ef053115c0f9207e$var$ei
}, $ef053115c0f9207e$var$vu = {
    [38]: $ef053115c0f9207e$var$Vs,
    [92]: $ef053115c0f9207e$var$qs
}, $ef053115c0f9207e$var$Gu = {
    [-5]: $ef053115c0f9207e$var$Cn,
    [-4]: $ef053115c0f9207e$var$Cn,
    [-3]: $ef053115c0f9207e$var$Cn,
    [33]: $ef053115c0f9207e$var$fu,
    [38]: $ef053115c0f9207e$var$Vs,
    [42]: $ef053115c0f9207e$var$Wn,
    [60]: [
        $ef053115c0f9207e$var$_l,
        $ef053115c0f9207e$var$tu
    ],
    [91]: $ef053115c0f9207e$var$du,
    [92]: [
        $ef053115c0f9207e$var$Yl,
        $ef053115c0f9207e$var$qs
    ],
    [93]: $ef053115c0f9207e$var$sr,
    [95]: $ef053115c0f9207e$var$Wn,
    [96]: $ef053115c0f9207e$var$Ll
}, $ef053115c0f9207e$var$Ku = {
    null: [
        $ef053115c0f9207e$var$Wn,
        $ef053115c0f9207e$var$ku
    ]
}, $ef053115c0f9207e$var$zu = {
    null: [
        42,
        95
    ]
}, $ef053115c0f9207e$var$Yu = {
    null: []
}, $ef053115c0f9207e$var$ju = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    attentionMarkers: $ef053115c0f9207e$var$zu,
    contentInitial: $ef053115c0f9207e$var$Hu,
    disable: $ef053115c0f9207e$var$Yu,
    document: $ef053115c0f9207e$var$Fu,
    flow: $ef053115c0f9207e$var$Uu,
    flowInitial: $ef053115c0f9207e$var$Bu,
    insideSpan: $ef053115c0f9207e$var$Ku,
    string: $ef053115c0f9207e$var$vu,
    text: $ef053115c0f9207e$var$Gu
}, Symbol.toStringTag, {
    value: "Module"
}));
function $ef053115c0f9207e$var$$u(e = {}) {
    const t = $ef053115c0f9207e$var$rl(// @ts-expect-error Same as above.
    [
        $ef053115c0f9207e$var$ju
    ].concat(e.extensions || [])), n = {
        defined: [],
        lazy: {},
        constructs: t,
        content: r($ef053115c0f9207e$var$hl),
        document: r($ef053115c0f9207e$var$Tl),
        flow: r($ef053115c0f9207e$var$xu),
        string: r($ef053115c0f9207e$var$Lu),
        text: r($ef053115c0f9207e$var$Mu)
    };
    return n;
    function r(i) {
        return s;
        function s(o) {
            return $ef053115c0f9207e$var$Pu(n, i, o);
        }
    }
}
const $ef053115c0f9207e$var$ri = /[\0\t\n\r]/g;
function $ef053115c0f9207e$var$Qu() {
    let e = 1, t = "", n = !0, r;
    return i;
    function i(s, o, l) {
        const u = [];
        let c, h, p, _, E;
        for(s = t + s.toString(o), p = 0, t = "", n && (s.charCodeAt(0) === 65279 && p++, n = void 0); p < s.length;){
            if ($ef053115c0f9207e$var$ri.lastIndex = p, c = $ef053115c0f9207e$var$ri.exec(s), _ = c && c.index !== void 0 ? c.index : s.length, E = s.charCodeAt(_), !c) {
                t = s.slice(p);
                break;
            }
            if (E === 10 && p === _ && r) u.push(-3), r = void 0;
            else switch(r && (u.push(-5), r = void 0), p < _ && (u.push(s.slice(p, _)), e += _ - p), E){
                case 0:
                    u.push(65533), e++;
                    break;
                case 9:
                    for(h = Math.ceil(e / 4) * 4, u.push(-2); e++ < h;)u.push(-1);
                    break;
                case 10:
                    u.push(-4), e = 1;
                    break;
                default:
                    r = !0, e = 1;
            }
            p = _ + 1;
        }
        return l && (r && u.push(-5), t && u.push(t), u.push(null)), u;
    }
}
function $ef053115c0f9207e$var$Wu(e) {
    for(; !$ef053115c0f9207e$var$Xs(e););
    return e;
}
function $ef053115c0f9207e$var$ro(e, t) {
    const n = Number.parseInt(e, t);
    return(// C0 except for HT, LF, FF, CR, space
    n < 9 || n === 11 || n > 13 && n < 32 || // Control character (DEL) of the basic block and C1 controls.
    n > 126 && n < 160 || // Lone high surrogates and low surrogates.
    n > 55295 && n < 57344 || // Noncharacters.
    n > 64975 && n < 65008 || (n & 65535) === 65535 || (n & 65535) === 65534 || // Out of range
    n > 1114111 ? "\uFFFD" : String.fromCharCode(n));
}
const $ef053115c0f9207e$var$qu = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function $ef053115c0f9207e$var$io(e) {
    return e.replace($ef053115c0f9207e$var$qu, $ef053115c0f9207e$var$Vu);
}
function $ef053115c0f9207e$var$Vu(e, t, n) {
    if (t) return t;
    if (n.charCodeAt(0) === 35) {
        const i = n.charCodeAt(1), s = i === 120 || i === 88;
        return $ef053115c0f9207e$var$ro(n.slice(s ? 2 : 1), s ? 16 : 10);
    }
    return $ef053115c0f9207e$var$ir(n) || e;
}
const $ef053115c0f9207e$var$qn = {}.hasOwnProperty, $ef053115c0f9207e$var$Xu = /**
   * @type {(
   *   ((value: Value, encoding: Encoding, options?: Options) => Root) &
   *   ((value: Value, options?: Options) => Root)
   * )}
   */ /**
   * @param {Value} value
   * @param {Encoding} [encoding]
   * @param {Options} [options]
   * @returns {Root}
   */ function(e, t, n) {
    return typeof t != "string" && (n = t, t = void 0), $ef053115c0f9207e$var$Ju(n)($ef053115c0f9207e$var$Wu($ef053115c0f9207e$var$$u(n).document().write($ef053115c0f9207e$var$Qu()(e, t, !0))));
};
function $ef053115c0f9207e$var$Ju(e = {}) {
    const t = $ef053115c0f9207e$var$so({
        transforms: [],
        canContainEols: [
            "emphasis",
            "fragment",
            "heading",
            "paragraph",
            "strong"
        ],
        enter: {
            autolink: u(br),
            autolinkProtocol: w,
            autolinkEmail: w,
            atxHeading: u(kr),
            blockQuote: u(ka),
            characterEscape: w,
            characterReference: w,
            codeFenced: u(yr),
            codeFencedFenceInfo: c,
            codeFencedFenceMeta: c,
            codeIndented: u(yr, c),
            codeText: u(La, c),
            codeTextData: w,
            data: w,
            codeFlowValue: w,
            definition: u(Ma),
            definitionDestinationString: c,
            definitionLabelString: c,
            definitionTitleString: c,
            emphasis: u(ba),
            hardBreakEscape: u(Lr),
            hardBreakTrailing: u(Lr),
            htmlFlow: u(Mr, c),
            htmlFlowData: w,
            htmlText: u(Mr, c),
            htmlTextData: w,
            image: u(Pa),
            label: c,
            link: u(br),
            listItem: u(Da),
            listItemValue: R,
            listOrdered: u(Pr, S),
            listUnordered: u(Pr),
            paragraph: u(wa),
            reference: ce,
            referenceString: c,
            resourceDestinationString: c,
            resourceTitleString: c,
            setextHeading: u(kr),
            strong: u(Fa),
            thematicBreak: u(Ba)
        },
        exit: {
            atxHeading: p(),
            atxHeadingSequence: $,
            autolink: p(),
            autolinkEmail: fn,
            autolinkProtocol: P1,
            blockQuote: p(),
            characterEscapeValue: z,
            characterReferenceMarkerHexadecimal: e1,
            characterReferenceMarkerNumeric: e1,
            characterReferenceValue: b1,
            codeFenced: p(k),
            codeFencedFence: U,
            codeFencedFenceInfo: b,
            codeFencedFenceMeta: N,
            codeFlowValue: z,
            codeIndented: p(v),
            codeText: p(Te),
            codeTextData: z,
            data: z,
            definition: p(),
            definitionDestinationString: F,
            definitionLabelString: K,
            definitionTitleString: A,
            emphasis: p(),
            hardBreakEscape: p(ke),
            hardBreakTrailing: p(ke),
            htmlFlow: p($e),
            htmlFlowData: z,
            htmlText: p(Ue),
            htmlTextData: z,
            image: p(ue),
            label: d,
            labelText: m,
            lineEnding: ge,
            link: p(Se),
            listItem: p(),
            listOrdered: p(),
            listUnordered: p(),
            paragraph: p(),
            referenceString: Qe,
            resourceDestinationString: L1,
            resourceTitleString: W1,
            resource: M1,
            setextHeading: p(M),
            setextHeadingLineSequence: fe,
            setextHeadingText: q,
            strong: p(),
            thematicBreak: p()
        }
    }, e.mdastExtensions || []), n = {};
    return r;
    function r(g) {
        let y = {
            type: "root",
            children: []
        };
        const B = [
            y
        ], V = [], Le = [], q1 = {
            stack: B,
            tokenStack: V,
            config: t,
            enter: h,
            exit: _,
            buffer: c,
            resume: E,
            setData: s,
            getData: o
        };
        let te = -1;
        for(; ++te < g.length;)if (g[te][1].type === "listOrdered" || g[te][1].type === "listUnordered") {
            if (g[te][0] === "enter") Le.push(te);
            else {
                const me = Le.pop();
                te = i(g, me, te);
            }
        }
        for(te = -1; ++te < g.length;){
            const me = t[g[te][0]];
            $ef053115c0f9207e$var$qn.call(me, g[te][1].type) && me[g[te][1].type].call(Object.assign({
                sliceSerialize: g[te][2].sliceSerialize
            }, q1), g[te][1]);
        }
        if (V.length > 0) {
            const me = V[V.length - 1];
            (me[1] || $ef053115c0f9207e$var$ii).call(q1, void 0, me[0]);
        }
        for(y.position = {
            start: l(g.length > 0 ? g[0][1].start : {
                line: 1,
                column: 1,
                offset: 0
            }),
            end: l(g.length > 0 ? g[g.length - 2][1].end : {
                line: 1,
                column: 1,
                offset: 0
            })
        }, te = -1; ++te < t.transforms.length;)y = t.transforms[te](y) || y;
        return y;
    }
    function i(g, y, B) {
        let V = y - 1, Le = -1, q1 = !1, te, me, D1, V1;
        for(; ++V <= B;){
            const oe = g[V];
            if (oe[1].type === "listUnordered" || oe[1].type === "listOrdered" || oe[1].type === "blockQuote" ? (oe[0] === "enter" ? Le++ : Le--, V1 = void 0) : oe[1].type === "lineEndingBlank" ? oe[0] === "enter" && (te && !V1 && !Le && !D1 && (D1 = V), V1 = void 0) : oe[1].type === "linePrefix" || oe[1].type === "listItemValue" || oe[1].type === "listItemMarker" || oe[1].type === "listItemPrefix" || oe[1].type === "listItemPrefixWhitespace" || (V1 = void 0), !Le && oe[0] === "enter" && oe[1].type === "listItemPrefix" || Le === -1 && oe[0] === "exit" && (oe[1].type === "listUnordered" || oe[1].type === "listOrdered")) {
                if (te) {
                    let Tn = V;
                    for(me = void 0; Tn--;){
                        const t1 = g[Tn];
                        if (t1[1].type === "lineEnding" || t1[1].type === "lineEndingBlank") {
                            if (t1[0] === "exit") continue;
                            me && (g[me][1].type = "lineEndingBlank", q1 = !0), t1[1].type = "lineEnding", me = Tn;
                        } else if (!(t1[1].type === "linePrefix" || t1[1].type === "blockQuotePrefix" || t1[1].type === "blockQuotePrefixWhitespace" || t1[1].type === "blockQuoteMarker" || t1[1].type === "listItemIndent")) break;
                    }
                    D1 && (!me || D1 < me) && (te._spread = !0), te.end = Object.assign({}, me ? g[me][1].start : oe[1].end), g.splice(me || V, 0, [
                        "exit",
                        te,
                        oe[2]
                    ]), V++, B++;
                }
                oe[1].type === "listItemPrefix" && (te = {
                    type: "listItem",
                    // @ts-expect-error Patched
                    _spread: !1,
                    start: Object.assign({}, oe[1].start)
                }, g.splice(V, 0, [
                    "enter",
                    te,
                    oe[2]
                ]), V++, B++, D1 = void 0, V1 = !0);
            }
        }
        return g[y][1]._spread = q1, B;
    }
    function s(g, y) {
        n[g] = y;
    }
    function o(g) {
        return n[g];
    }
    function l(g) {
        return {
            line: g.line,
            column: g.column,
            offset: g.offset
        };
    }
    function u(g, y) {
        return B;
        function B(V) {
            h.call(this, g(V), V), y && y.call(this, V);
        }
    }
    function c() {
        this.stack.push({
            type: "fragment",
            children: []
        });
    }
    function h(g, y, B) {
        return this.stack[this.stack.length - 1].children.push(g), this.stack.push(g), this.tokenStack.push([
            y,
            B
        ]), g.position = {
            start: l(y.start)
        }, g;
    }
    function p(g) {
        return y;
        function y(B) {
            g && g.call(this, B), _.call(this, B);
        }
    }
    function _(g, y) {
        const B = this.stack.pop(), V = this.tokenStack.pop();
        if (V) V[0].type !== g.type && (y ? y.call(this, g, V[0]) : (V[1] || $ef053115c0f9207e$var$ii).call(this, g, V[0]));
        else throw new Error("Cannot close `" + g.type + "` (" + $ef053115c0f9207e$var$at({
            start: g.start,
            end: g.end
        }) + "): it\u2019s not open");
        return B.position.end = l(g.end), B;
    }
    function E() {
        return $ef053115c0f9207e$var$Jt(this.stack.pop());
    }
    function S() {
        s("expectingFirstListItemValue", !0);
    }
    function R(g) {
        if (o("expectingFirstListItemValue")) {
            const y = /** @type {List} */ this.stack[this.stack.length - 2];
            y.start = Number.parseInt(this.sliceSerialize(g), 10), s("expectingFirstListItemValue");
        }
    }
    function b() {
        const g = this.resume(), y = /** @type {Code} */ this.stack[this.stack.length - 1];
        y.lang = g;
    }
    function N() {
        const g = this.resume(), y = /** @type {Code} */ this.stack[this.stack.length - 1];
        y.meta = g;
    }
    function U() {
        o("flowCodeInside") || (this.buffer(), s("flowCodeInside", !0));
    }
    function k() {
        const g = this.resume(), y = /** @type {Code} */ this.stack[this.stack.length - 1];
        y.value = g.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), s("flowCodeInside");
    }
    function v() {
        const g = this.resume(), y = /** @type {Code} */ this.stack[this.stack.length - 1];
        y.value = g.replace(/(\r?\n|\r)$/g, "");
    }
    function K(g) {
        const y = this.resume(), B = /** @type {Definition} */ this.stack[this.stack.length - 1];
        B.label = y, B.identifier = $ef053115c0f9207e$var$z1(this.sliceSerialize(g)).toLowerCase();
    }
    function A() {
        const g = this.resume(), y = /** @type {Definition} */ this.stack[this.stack.length - 1];
        y.title = g;
    }
    function F() {
        const g = this.resume(), y = /** @type {Definition} */ this.stack[this.stack.length - 1];
        y.url = g;
    }
    function $(g) {
        const y = /** @type {Heading} */ this.stack[this.stack.length - 1];
        if (!y.depth) {
            const B = this.sliceSerialize(g).length;
            y.depth = B;
        }
    }
    function q() {
        s("setextHeadingSlurpLineEnding", !0);
    }
    function fe(g) {
        const y = /** @type {Heading} */ this.stack[this.stack.length - 1];
        y.depth = this.sliceSerialize(g).charCodeAt(0) === 61 ? 1 : 2;
    }
    function M() {
        s("setextHeadingSlurpLineEnding");
    }
    function w(g) {
        const y = /** @type {Parent} */ this.stack[this.stack.length - 1];
        let B = y.children[y.children.length - 1];
        (!B || B.type !== "text") && (B = Ha(), B.position = {
            start: l(g.start)
        }, y.children.push(B)), this.stack.push(B);
    }
    function z(g) {
        const y = this.stack.pop();
        y.value += this.sliceSerialize(g), y.position.end = l(g.end);
    }
    function ge(g) {
        const y = this.stack[this.stack.length - 1];
        if (o("atHardBreak")) {
            const B = y.children[y.children.length - 1];
            B.position.end = l(g.end), s("atHardBreak");
            return;
        }
        !o("setextHeadingSlurpLineEnding") && t.canContainEols.includes(y.type) && (w.call(this, g), z.call(this, g));
    }
    function ke() {
        s("atHardBreak", !0);
    }
    function $e() {
        const g = this.resume(), y = /** @type {HTML} */ this.stack[this.stack.length - 1];
        y.value = g;
    }
    function Ue() {
        const g = this.resume(), y = /** @type {HTML} */ this.stack[this.stack.length - 1];
        y.value = g;
    }
    function Te() {
        const g = this.resume(), y = /** @type {InlineCode} */ this.stack[this.stack.length - 1];
        y.value = g;
    }
    function Se() {
        const g = /** @type {Link & {identifier: string, label: string}} */ this.stack[this.stack.length - 1];
        o("inReference") ? (g.type += "Reference", g.referenceType = o("referenceType") || "shortcut", delete g.url, delete g.title) : (delete g.identifier, delete g.label), s("referenceType");
    }
    function ue() {
        const g = /** @type {Image & {identifier: string, label: string}} */ this.stack[this.stack.length - 1];
        o("inReference") ? (g.type += "Reference", g.referenceType = o("referenceType") || "shortcut", delete g.url, delete g.title) : (delete g.identifier, delete g.label), s("referenceType");
    }
    function m(g) {
        const y = /** @type {(Link|Image) & {identifier: string, label: string}} */ this.stack[this.stack.length - 2], B = this.sliceSerialize(g);
        y.label = $ef053115c0f9207e$var$io(B), y.identifier = $ef053115c0f9207e$var$z1(B).toLowerCase();
    }
    function d() {
        const g = /** @type {Fragment} */ this.stack[this.stack.length - 1], y = this.resume(), B = /** @type {(Link|Image) & {identifier: string, label: string}} */ this.stack[this.stack.length - 1];
        s("inReference", !0), B.type === "link" ? B.children = g.children : B.alt = y;
    }
    function L1() {
        const g = this.resume(), y = /** @type {Link|Image} */ this.stack[this.stack.length - 1];
        y.url = g;
    }
    function W1() {
        const g = this.resume(), y = /** @type {Link|Image} */ this.stack[this.stack.length - 1];
        y.title = g;
    }
    function M1() {
        s("inReference");
    }
    function ce() {
        s("referenceType", "collapsed");
    }
    function Qe(g) {
        const y = this.resume(), B = /** @type {LinkReference|ImageReference} */ this.stack[this.stack.length - 1];
        B.label = y, B.identifier = $ef053115c0f9207e$var$z1(this.sliceSerialize(g)).toLowerCase(), s("referenceType", "full");
    }
    function e1(g) {
        s("characterReferenceType", g.type);
    }
    function b1(g) {
        const y = this.sliceSerialize(g), B = o("characterReferenceType");
        let V;
        B ? (V = $ef053115c0f9207e$var$ro(y, B === "characterReferenceMarkerNumeric" ? 10 : 16), s("characterReferenceType")) : V = $ef053115c0f9207e$var$ir(y);
        const Le = this.stack.pop();
        Le.value += V, Le.position.end = l(g.end);
    }
    function P1(g) {
        z.call(this, g);
        const y = /** @type {Link} */ this.stack[this.stack.length - 1];
        y.url = this.sliceSerialize(g);
    }
    function fn(g) {
        z.call(this, g);
        const y = /** @type {Link} */ this.stack[this.stack.length - 1];
        y.url = "mailto:" + this.sliceSerialize(g);
    }
    function ka() {
        return {
            type: "blockquote",
            children: []
        };
    }
    function yr() {
        return {
            type: "code",
            lang: null,
            meta: null,
            value: ""
        };
    }
    function La() {
        return {
            type: "inlineCode",
            value: ""
        };
    }
    function Ma() {
        return {
            type: "definition",
            identifier: "",
            label: null,
            title: null,
            url: ""
        };
    }
    function ba() {
        return {
            type: "emphasis",
            children: []
        };
    }
    function kr() {
        return {
            type: "heading",
            depth: void 0,
            children: []
        };
    }
    function Lr() {
        return {
            type: "break"
        };
    }
    function Mr() {
        return {
            type: "html",
            value: ""
        };
    }
    function Pa() {
        return {
            type: "image",
            title: null,
            url: "",
            alt: null
        };
    }
    function br() {
        return {
            type: "link",
            title: null,
            url: "",
            children: []
        };
    }
    function Pr(g) {
        return {
            type: "list",
            ordered: g.type === "listOrdered",
            start: null,
            // @ts-expect-error Patched.
            spread: g._spread,
            children: []
        };
    }
    function Da(g) {
        return {
            type: "listItem",
            // @ts-expect-error Patched.
            spread: g._spread,
            checked: null,
            children: []
        };
    }
    function wa() {
        return {
            type: "paragraph",
            children: []
        };
    }
    function Fa() {
        return {
            type: "strong",
            children: []
        };
    }
    function Ha() {
        return {
            type: "text",
            value: ""
        };
    }
    function Ba() {
        return {
            type: "thematicBreak"
        };
    }
}
function $ef053115c0f9207e$var$so(e, t) {
    let n = -1;
    for(; ++n < t.length;){
        const r = t[n];
        Array.isArray(r) ? $ef053115c0f9207e$var$so(e, r) : $ef053115c0f9207e$var$Zu(e, r);
    }
    return e;
}
function $ef053115c0f9207e$var$Zu(e, t) {
    let n;
    for(n in t)if ($ef053115c0f9207e$var$qn.call(t, n)) {
        const r = n === "canContainEols" || n === "transforms", s = ($ef053115c0f9207e$var$qn.call(e, n) ? e[n] : void 0) || (e[n] = r ? [] : {}), o = t[n];
        o && (r ? e[n] = [
            ...s,
            ...o
        ] : Object.assign(s, o));
    }
}
function $ef053115c0f9207e$var$ii(e, t) {
    throw e ? new Error("Cannot close `" + e.type + "` (" + $ef053115c0f9207e$var$at({
        start: e.start,
        end: e.end
    }) + "): a different token (`" + t.type + "`, " + $ef053115c0f9207e$var$at({
        start: t.start,
        end: t.end
    }) + ") is open") : new Error("Cannot close document, a token (`" + t.type + "`, " + $ef053115c0f9207e$var$at({
        start: t.start,
        end: t.end
    }) + ") is still open");
}
function $ef053115c0f9207e$var$e9(e) {
    Object.assign(this, {
        Parser: (n)=>{
            const r = /** @type {Options} */ this.data("settings");
            return $ef053115c0f9207e$var$Xu(n, Object.assign({}, r, e, {
                // Note: these options are not in the readme.
                // The goal is for them to be set by plugins on `data` instead of being
                // passed by users.
                extensions: this.data("micromarkExtensions") || [],
                mdastExtensions: this.data("fromMarkdownExtensions") || []
            }));
        }
    });
}
var $ef053115c0f9207e$var$si = {}.hasOwnProperty;
function $ef053115c0f9207e$var$t9(e, t) {
    var n = t || {};
    function r(i) {
        var s = r.invalid, o = r.handlers;
        if (i && $ef053115c0f9207e$var$si.call(i, e) && (s = $ef053115c0f9207e$var$si.call(o, i[e]) ? o[i[e]] : r.unknown), s) return s.apply(this, arguments);
    }
    return r.handlers = n.handlers || {}, r.invalid = n.invalid, r.unknown = n.unknown, r;
}
function $ef053115c0f9207e$var$Gt(e, t) {
    let n = -1, r;
    if (t.extensions) for(; ++n < t.extensions.length;)$ef053115c0f9207e$var$Gt(e, t.extensions[n]);
    for(r in t)r === "extensions" || (r === "unsafe" || r === "join" ? e[r] = [
        ...e[r] || [],
        ...t[r] || []
    ] : r === "handlers" ? e[r] = Object.assign(e[r], t[r] || {}) : e.options[r] = t[r]);
    return e;
}
function $ef053115c0f9207e$var$Re(e) {
    const t = e || {}, n = t.now || {};
    let r = t.lineShift || 0, i = n.line || 1, s = n.column || 1;
    return {
        move: u,
        current: o,
        shift: l
    };
    function o() {
        return {
            now: {
                line: i,
                column: s
            },
            lineShift: r
        };
    }
    function l(c) {
        r += c;
    }
    function u(c = "") {
        const h = c.split(/\r?\n|\r/g), p = h[h.length - 1];
        return i += h.length - 1, s = h.length === 1 ? s + p.length : 1 + p.length + r, c;
    }
}
function $ef053115c0f9207e$var$en(e, t, n) {
    const r = t.indexStack, i = e.children || [], s = $ef053115c0f9207e$var$Re(n), o = [];
    let l = -1;
    for(r.push(-1); ++l < i.length;){
        const c = i[l];
        r[r.length - 1] = l, o.push(s.move(t.handle(c, e, t, {
            before: `
`,
            after: `
`,
            ...s.current()
        }))), c.type !== "list" && (t.bulletLastUsed = void 0), l < i.length - 1 && o.push(s.move(u(c, i[l + 1])));
    }
    return r.pop(), o.join("");
    function u(c, h) {
        let p = t.join.length;
        for(; p--;){
            const _ = t.join[p](c, h, e, t);
            if (_ === !0 || _ === 1) break;
            if (typeof _ == "number") return `
`.repeat(1 + _);
            if (_ === !1) return `

<!---->

`;
        }
        return `

`;
    }
}
const $ef053115c0f9207e$var$n9 = /\r?\n|\r/g;
function $ef053115c0f9207e$var$or(e, t) {
    const n = [];
    let r = 0, i = 0, s;
    for(; s = $ef053115c0f9207e$var$n9.exec(e);)o(e.slice(r, s.index)), n.push(s[0]), r = s.index + s[0].length, i++;
    return o(e.slice(r)), n.join("");
    function o(l) {
        n.push(t(l, i, !l));
    }
}
function $ef053115c0f9207e$var$r9(e, t, n, r) {
    const i = n.enter("blockquote"), s = $ef053115c0f9207e$var$Re(r);
    s.move("> "), s.shift(2);
    const o = $ef053115c0f9207e$var$or($ef053115c0f9207e$var$en(e, n, s.current()), $ef053115c0f9207e$var$i9);
    return i(), o;
}
function $ef053115c0f9207e$var$i9(e, t, n) {
    return ">" + (n ? "" : " ") + e;
}
function $ef053115c0f9207e$var$oo(e, t) {
    return $ef053115c0f9207e$var$oi(e, t.inConstruct, !0) && !$ef053115c0f9207e$var$oi(e, t.notInConstruct, !1);
}
function $ef053115c0f9207e$var$oi(e, t, n) {
    if (!t) return n;
    typeof t == "string" && (t = [
        t
    ]);
    let r = -1;
    for(; ++r < t.length;)if (e.includes(t[r])) return !0;
    return !1;
}
function $ef053115c0f9207e$var$ai(e, t, n, r) {
    let i = -1;
    for(; ++i < n.unsafe.length;)if (n.unsafe[i].character === `
` && $ef053115c0f9207e$var$oo(n.stack, n.unsafe[i])) return /[ \t]/.test(r.before) ? "" : " ";
    return `\\
`;
}
function $ef053115c0f9207e$var$s9(e, t) {
    const n = String(e);
    let r = n.indexOf(t), i = r, s = 0, o = 0;
    if (typeof t != "string" || t.length !== 1) throw new Error("Expected character");
    for(; r !== -1;)r === i ? ++s > o && (o = s) : s = 1, i = r + 1, r = n.indexOf(t, i);
    return o;
}
function $ef053115c0f9207e$var$Vn(e, t) {
    return !!(!t.options.fences && e.value && // If there’s no info…
    !e.lang && // And there’s a non-whitespace character…
    /[^ \r\n]/.test(e.value) && // And the value doesn’t start or end in a blank…
    !/^[\t ]*(?:[\r\n]|$)|(?:^|[\r\n])[\t ]*$/.test(e.value));
}
function $ef053115c0f9207e$var$o9(e) {
    const t = e.options.fence || "`";
    if (t !== "`" && t !== "~") throw new Error("Cannot serialize code with `" + t + "` for `options.fence`, expected `` ` `` or `~`");
    return t;
}
function $ef053115c0f9207e$var$ao(e) {
    if (!e._compiled) {
        const t = (e.atBreak ? "[\\r\\n][\\t ]*" : "") + (e.before ? "(?:" + e.before + ")" : "");
        e._compiled = new RegExp((t ? "(" + t + ")" : "") + (/[|\\{}()[\]^$+*?.-]/.test(e.character) ? "\\" : "") + e.character + (e.after ? "(?:" + e.after + ")" : ""), "g");
    }
    return e._compiled;
}
function $ef053115c0f9207e$var$Ee(e, t, n) {
    const r = (n.before || "") + (t || "") + (n.after || ""), i = [], s = [], o = {};
    let l = -1;
    for(; ++l < e.unsafe.length;){
        const h = e.unsafe[l];
        if (!$ef053115c0f9207e$var$oo(e.stack, h)) continue;
        const p = $ef053115c0f9207e$var$ao(h);
        let _;
        for(; _ = p.exec(r);){
            const E = "before" in h || !!h.atBreak, S = "after" in h, R = _.index + (E ? _[1].length : 0);
            i.includes(R) ? (o[R].before && !E && (o[R].before = !1), o[R].after && !S && (o[R].after = !1)) : (i.push(R), o[R] = {
                before: E,
                after: S
            });
        }
    }
    i.sort($ef053115c0f9207e$var$a9);
    let u = n.before ? n.before.length : 0;
    const c = r.length - (n.after ? n.after.length : 0);
    for(l = -1; ++l < i.length;){
        const h = i[l];
        h < u || h >= c || h + 1 < c && i[l + 1] === h + 1 && o[h].after && !o[h + 1].before && !o[h + 1].after || i[l - 1] === h - 1 && o[h].before && !o[h - 1].before && !o[h - 1].after || (u !== h && s.push($ef053115c0f9207e$var$li(r.slice(u, h), "\\")), u = h, /[!-/:-@[-`{-~]/.test(r.charAt(h)) && (!n.encode || !n.encode.includes(r.charAt(h))) ? s.push("\\") : (s.push("&#x" + r.charCodeAt(h).toString(16).toUpperCase() + ";"), u++));
    }
    return s.push($ef053115c0f9207e$var$li(r.slice(u, c), n.after)), s.join("");
}
function $ef053115c0f9207e$var$a9(e, t) {
    return e - t;
}
function $ef053115c0f9207e$var$li(e, t) {
    const n = /\\(?=[!-/:-@[-`{-~])/g, r = [], i = [], s = e + t;
    let o = -1, l = 0, u;
    for(; u = n.exec(s);)r.push(u.index);
    for(; ++o < r.length;)l !== r[o] && i.push(e.slice(l, r[o])), i.push("\\"), l = r[o];
    return i.push(e.slice(l)), i.join("");
}
function $ef053115c0f9207e$var$l9(e, t, n, r) {
    const i = $ef053115c0f9207e$var$o9(n), s = e.value || "", o = i === "`" ? "GraveAccent" : "Tilde";
    if ($ef053115c0f9207e$var$Vn(e, n)) {
        const p = n.enter("codeIndented"), _ = $ef053115c0f9207e$var$or(s, $ef053115c0f9207e$var$u9);
        return p(), _;
    }
    const l = $ef053115c0f9207e$var$Re(r), u = i.repeat(Math.max($ef053115c0f9207e$var$s9(s, i) + 1, 3)), c = n.enter("codeFenced");
    let h = l.move(u);
    if (e.lang) {
        const p = n.enter("codeFencedLang" + o);
        h += l.move($ef053115c0f9207e$var$Ee(n, e.lang, {
            before: h,
            after: " ",
            encode: [
                "`"
            ],
            ...l.current()
        })), p();
    }
    if (e.lang && e.meta) {
        const p = n.enter("codeFencedMeta" + o);
        h += l.move(" "), h += l.move($ef053115c0f9207e$var$Ee(n, e.meta, {
            before: h,
            after: `
`,
            encode: [
                "`"
            ],
            ...l.current()
        })), p();
    }
    return h += l.move(`
`), s && (h += l.move(s + `
`)), h += l.move(u), c(), h;
}
function $ef053115c0f9207e$var$u9(e, t, n) {
    return (n ? "" : "    ") + e;
}
function $ef053115c0f9207e$var$ar(e) {
    return e.label || !e.identifier ? e.label || "" : $ef053115c0f9207e$var$io(e.identifier);
}
function $ef053115c0f9207e$var$lr(e) {
    const t = e.options.quote || '"';
    if (t !== '"' && t !== "'") throw new Error("Cannot serialize title with `" + t + "` for `options.quote`, expected `\"`, or `'`");
    return t;
}
function $ef053115c0f9207e$var$c9(e, t, n, r) {
    const i = $ef053115c0f9207e$var$lr(n), s = i === '"' ? "Quote" : "Apostrophe", o = n.enter("definition");
    let l = n.enter("label");
    const u = $ef053115c0f9207e$var$Re(r);
    let c = u.move("[");
    return c += u.move($ef053115c0f9207e$var$Ee(n, $ef053115c0f9207e$var$ar(e), {
        before: c,
        after: "]",
        ...u.current()
    })), c += u.move("]: "), l(), !e.url || // If there are control characters or whitespace.
    /[\0- \u007F]/.test(e.url) ? (l = n.enter("destinationLiteral"), c += u.move("<"), c += u.move($ef053115c0f9207e$var$Ee(n, e.url, {
        before: c,
        after: ">",
        ...u.current()
    })), c += u.move(">")) : (l = n.enter("destinationRaw"), c += u.move($ef053115c0f9207e$var$Ee(n, e.url, {
        before: c,
        after: e.title ? " " : `
`,
        ...u.current()
    }))), l(), e.title && (l = n.enter("title" + s), c += u.move(" " + i), c += u.move($ef053115c0f9207e$var$Ee(n, e.title, {
        before: c,
        after: i,
        ...u.current()
    })), c += u.move(i), l()), o(), c;
}
function $ef053115c0f9207e$var$h9(e) {
    const t = e.options.emphasis || "*";
    if (t !== "*" && t !== "_") throw new Error("Cannot serialize emphasis with `" + t + "` for `options.emphasis`, expected `*`, or `_`");
    return t;
}
function $ef053115c0f9207e$var$E1(e, t, n) {
    const r = t.indexStack, i = e.children || [], s = [];
    let o = -1, l = n.before;
    r.push(-1);
    let u = $ef053115c0f9207e$var$Re(n);
    for(; ++o < i.length;){
        const c = i[o];
        let h;
        if (r[r.length - 1] = o, o + 1 < i.length) {
            let p = t.handle.handlers[i[o + 1].type];
            p && p.peek && (p = p.peek), h = p ? p(i[o + 1], e, t, {
                before: "",
                after: "",
                ...u.current()
            }).charAt(0) : "";
        } else h = n.after;
        s.length > 0 && (l === "\r" || l === `
`) && c.type === "html" && (s[s.length - 1] = s[s.length - 1].replace(/(\r?\n|\r)$/, " "), l = " ", u = $ef053115c0f9207e$var$Re(n), u.move(s.join(""))), s.push(u.move(t.handle(c, e, t, {
            ...u.current(),
            before: l,
            after: h
        }))), l = s[s.length - 1].slice(-1);
    }
    return r.pop(), s.join("");
}
$ef053115c0f9207e$var$lo.peek = $ef053115c0f9207e$var$f9;
function $ef053115c0f9207e$var$lo(e, t, n, r) {
    const i = $ef053115c0f9207e$var$h9(n), s = n.enter("emphasis"), o = $ef053115c0f9207e$var$Re(r);
    let l = o.move(i);
    return l += o.move($ef053115c0f9207e$var$E1(e, n, {
        before: l,
        after: i,
        ...o.current()
    })), l += o.move(i), s(), l;
}
function $ef053115c0f9207e$var$f9(e, t, n) {
    return n.options.emphasis || "*";
}
const $ef053115c0f9207e$var$j1 = /**
   * @type {(
   *   (<T extends Node>(test: T['type']|Partial<T>|TestFunctionPredicate<T>) => AssertPredicate<T>) &
   *   ((test?: Test) => AssertAnything)
   * )}
   */ /**
   * Generate an assertion from a check.
   * @param {Test} [test]
   * When nullish, checks if `node` is a `Node`.
   * When `string`, works like passing `function (node) {return node.type === test}`.
   * When `function` checks if function passed the node is true.
   * When `object`, checks that all keys in test are in node, and that they have (strictly) equal values.
   * When `array`, checks any one of the subtests pass.
   * @returns {AssertAnything}
   */ function(e) {
    if (e == null) return $ef053115c0f9207e$var$p9;
    if (typeof e == "string") return $ef053115c0f9207e$var$m9(e);
    if (typeof e == "object") return Array.isArray(e) ? $ef053115c0f9207e$var$T9(e) : $ef053115c0f9207e$var$d9(e);
    if (typeof e == "function") return $ef053115c0f9207e$var$tn(e);
    throw new Error("Expected function, string, or object as test");
};
function $ef053115c0f9207e$var$T9(e) {
    const t = [];
    let n = -1;
    for(; ++n < e.length;)t[n] = $ef053115c0f9207e$var$j1(e[n]);
    return $ef053115c0f9207e$var$tn(r);
    function r(...i) {
        let s = -1;
        for(; ++s < t.length;)if (t[s].call(this, ...i)) return !0;
        return !1;
    }
}
function $ef053115c0f9207e$var$d9(e) {
    return $ef053115c0f9207e$var$tn(t);
    function t(n) {
        let r;
        for(r in e)if (n[r] !== e[r]) return !1;
        return !0;
    }
}
function $ef053115c0f9207e$var$m9(e) {
    return $ef053115c0f9207e$var$tn(t);
    function t(n) {
        return n && n.type === e;
    }
}
function $ef053115c0f9207e$var$tn(e) {
    return t;
    function t(...n) {
        return !!e.call(this, ...n);
    }
}
function $ef053115c0f9207e$var$p9() {
    return !0;
}
const $ef053115c0f9207e$var$E9 = !0, $ef053115c0f9207e$var$uo = "skip", $ef053115c0f9207e$var$$t = !1, $ef053115c0f9207e$var$_9 = /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: import('./complex-types.js').BuildVisitor<Tree, Check>, reverse?: boolean) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: import('./complex-types.js').BuildVisitor<Tree>, reverse?: boolean) => void)
   * )}
   */ /**
   * @param {Node} tree
   * @param {Test} test
   * @param {import('./complex-types.js').Visitor<Node>} visitor
   * @param {boolean} [reverse=false]
   */ function(e, t, n, r) {
    typeof t == "function" && typeof n != "function" && (r = n, n = t, t = null);
    const i = $ef053115c0f9207e$var$j1(t), s = r ? -1 : 1;
    o(e, null, [])();
    function o(l, u, c) {
        const h = typeof l == "object" && l !== null ? l : {};
        let p;
        return typeof h.type == "string" && (p = typeof h.tagName == "string" ? h.tagName : typeof h.name == "string" ? h.name : void 0, Object.defineProperty(_, "name", {
            value: "node (" + (h.type + (p ? "<" + p + ">" : "")) + ")"
        })), _;
        function _() {
            let E = [], S, R, b;
            if ((!t || i(l, u, c[c.length - 1] || null)) && (E = $ef053115c0f9207e$var$g9(n(l, c)), E[0] === $ef053115c0f9207e$var$$t)) return E;
            if (l.children && E[0] !== $ef053115c0f9207e$var$uo) for(R = (r ? l.children.length : -1) + s, b = c.concat(l); R > -1 && R < l.children.length;){
                if (S = o(l.children[R], R, b)(), S[0] === $ef053115c0f9207e$var$$t) return S;
                R = typeof S[1] == "number" ? S[1] : R + s;
            }
            return E;
        }
    }
};
function $ef053115c0f9207e$var$g9(e) {
    return Array.isArray(e) ? e : typeof e == "number" ? [
        $ef053115c0f9207e$var$E9,
        e
    ] : [
        e
    ];
}
const $ef053115c0f9207e$var$mt = /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: import('./complex-types.js').BuildVisitor<Tree, Check>, reverse?: boolean) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: import('./complex-types.js').BuildVisitor<Tree>, reverse?: boolean) => void)
   * )}
   */ /**
   * @param {Node} tree
   * @param {Test} test
   * @param {import('./complex-types.js').Visitor} visitor
   * @param {boolean} [reverse]
   */ function(e, t, n, r) {
    typeof t == "function" && typeof n != "function" && (r = n, n = t, t = null), $ef053115c0f9207e$var$_9(e, t, i, r);
    function i(s, o) {
        const l = o[o.length - 1];
        return n(s, l ? l.children.indexOf(s) : null, l);
    }
};
function $ef053115c0f9207e$var$co(e, t) {
    let n = !1;
    return $ef053115c0f9207e$var$mt(e, (r)=>{
        if ("value" in r && /\r?\n|\r/.test(r.value) || r.type === "break") return n = !0, $ef053115c0f9207e$var$$t;
    }), !!((!e.depth || e.depth < 3) && $ef053115c0f9207e$var$Jt(e) && (t.options.setext || n));
}
function $ef053115c0f9207e$var$A9(e, t, n, r) {
    const i = Math.max(Math.min(6, e.depth || 1), 1), s = $ef053115c0f9207e$var$Re(r);
    if ($ef053115c0f9207e$var$co(e, n)) {
        const h = n.enter("headingSetext"), p = n.enter("phrasing"), _ = $ef053115c0f9207e$var$E1(e, n, {
            ...s.current(),
            before: `
`,
            after: `
`
        });
        return p(), h(), _ + `
` + (i === 1 ? "=" : "-").repeat(// The whole size…
        _.length - // Minus the position of the character after the last EOL (or
        // 0 if there is none)…
        (Math.max(_.lastIndexOf("\r"), _.lastIndexOf(`
`)) + 1));
    }
    const o = "#".repeat(i), l = n.enter("headingAtx"), u = n.enter("phrasing");
    s.move(o + " ");
    let c = $ef053115c0f9207e$var$E1(e, n, {
        before: "# ",
        after: `
`,
        ...s.current()
    });
    return /^[\t ]/.test(c) && (c = "&#x" + c.charCodeAt(0).toString(16).toUpperCase() + ";" + c.slice(1)), c = c ? o + " " + c : o, n.options.closeAtx && (c += " " + o), u(), l(), c;
}
$ef053115c0f9207e$var$ho.peek = $ef053115c0f9207e$var$C9;
function $ef053115c0f9207e$var$ho(e) {
    return e.value || "";
}
function $ef053115c0f9207e$var$C9() {
    return "<";
}
$ef053115c0f9207e$var$fo.peek = $ef053115c0f9207e$var$S9;
function $ef053115c0f9207e$var$fo(e, t, n, r) {
    const i = $ef053115c0f9207e$var$lr(n), s = i === '"' ? "Quote" : "Apostrophe", o = n.enter("image");
    let l = n.enter("label");
    const u = $ef053115c0f9207e$var$Re(r);
    let c = u.move("![");
    return c += u.move($ef053115c0f9207e$var$Ee(n, e.alt, {
        before: c,
        after: "]",
        ...u.current()
    })), c += u.move("]("), l(), !e.url && e.title || // If there are control characters or whitespace.
    /[\0- \u007F]/.test(e.url) ? (l = n.enter("destinationLiteral"), c += u.move("<"), c += u.move($ef053115c0f9207e$var$Ee(n, e.url, {
        before: c,
        after: ">",
        ...u.current()
    })), c += u.move(">")) : (l = n.enter("destinationRaw"), c += u.move($ef053115c0f9207e$var$Ee(n, e.url, {
        before: c,
        after: e.title ? " " : ")",
        ...u.current()
    }))), l(), e.title && (l = n.enter("title" + s), c += u.move(" " + i), c += u.move($ef053115c0f9207e$var$Ee(n, e.title, {
        before: c,
        after: i,
        ...u.current()
    })), c += u.move(i), l()), c += u.move(")"), o(), c;
}
function $ef053115c0f9207e$var$S9() {
    return "!";
}
$ef053115c0f9207e$var$To.peek = $ef053115c0f9207e$var$N9;
function $ef053115c0f9207e$var$To(e, t, n, r) {
    const i = e.referenceType, s = n.enter("imageReference");
    let o = n.enter("label");
    const l = $ef053115c0f9207e$var$Re(r);
    let u = l.move("![");
    const c = $ef053115c0f9207e$var$Ee(n, e.alt, {
        before: u,
        after: "]",
        ...l.current()
    });
    u += l.move(c + "]["), o();
    const h = n.stack;
    n.stack = [], o = n.enter("reference");
    const p = $ef053115c0f9207e$var$Ee(n, $ef053115c0f9207e$var$ar(e), {
        before: u,
        after: "]",
        ...l.current()
    });
    return o(), n.stack = h, s(), i === "full" || !c || c !== p ? u += l.move(p + "]") : i === "shortcut" ? u = u.slice(0, -1) : u += l.move("]"), u;
}
function $ef053115c0f9207e$var$N9() {
    return "!";
}
$ef053115c0f9207e$var$mo.peek = $ef053115c0f9207e$var$I9;
function $ef053115c0f9207e$var$mo(e, t, n) {
    let r = e.value || "", i = "`", s = -1;
    for(; new RegExp("(^|[^`])" + i + "([^`]|$)").test(r);)i += "`";
    for(/[^ \r\n]/.test(r) && (/^[ \r\n]/.test(r) && /[ \r\n]$/.test(r) || /^`|`$/.test(r)) && (r = " " + r + " "); ++s < n.unsafe.length;){
        const o = n.unsafe[s], l = $ef053115c0f9207e$var$ao(o);
        let u;
        if (o.atBreak) for(; u = l.exec(r);){
            let c = u.index;
            r.charCodeAt(c) === 10 && r.charCodeAt(c - 1) === 13 && c--, r = r.slice(0, c) + " " + r.slice(u.index + 1);
        }
    }
    return i + r + i;
}
function $ef053115c0f9207e$var$I9() {
    return "`";
}
function $ef053115c0f9207e$var$po(e, t) {
    const n = $ef053115c0f9207e$var$Jt(e);
    return !!(!t.options.resourceLink && // If there’s a url…
    e.url && // And there’s a no title…
    !e.title && // And the content of `node` is a single text node…
    e.children && e.children.length === 1 && e.children[0].type === "text" && // And if the url is the same as the content…
    (n === e.url || "mailto:" + n === e.url) && // And that starts w/ a protocol…
    /^[a-z][a-z+.-]+:/i.test(e.url) && // And that doesn’t contain ASCII control codes (character escapes and
    // references don’t work), space, or angle brackets…
    !/[\0- <>\u007F]/.test(e.url));
}
$ef053115c0f9207e$var$Eo.peek = $ef053115c0f9207e$var$O9;
function $ef053115c0f9207e$var$Eo(e, t, n, r) {
    const i = $ef053115c0f9207e$var$lr(n), s = i === '"' ? "Quote" : "Apostrophe", o = $ef053115c0f9207e$var$Re(r);
    let l, u;
    if ($ef053115c0f9207e$var$po(e, n)) {
        const h = n.stack;
        n.stack = [], l = n.enter("autolink");
        let p = o.move("<");
        return p += o.move($ef053115c0f9207e$var$E1(e, n, {
            before: p,
            after: ">",
            ...o.current()
        })), p += o.move(">"), l(), n.stack = h, p;
    }
    l = n.enter("link"), u = n.enter("label");
    let c = o.move("[");
    return c += o.move($ef053115c0f9207e$var$E1(e, n, {
        before: c,
        after: "](",
        ...o.current()
    })), c += o.move("]("), u(), !e.url && e.title || // If there are control characters or whitespace.
    /[\0- \u007F]/.test(e.url) ? (u = n.enter("destinationLiteral"), c += o.move("<"), c += o.move($ef053115c0f9207e$var$Ee(n, e.url, {
        before: c,
        after: ">",
        ...o.current()
    })), c += o.move(">")) : (u = n.enter("destinationRaw"), c += o.move($ef053115c0f9207e$var$Ee(n, e.url, {
        before: c,
        after: e.title ? " " : ")",
        ...o.current()
    }))), u(), e.title && (u = n.enter("title" + s), c += o.move(" " + i), c += o.move($ef053115c0f9207e$var$Ee(n, e.title, {
        before: c,
        after: i,
        ...o.current()
    })), c += o.move(i), u()), c += o.move(")"), l(), c;
}
function $ef053115c0f9207e$var$O9(e, t, n) {
    return $ef053115c0f9207e$var$po(e, n) ? "<" : "[";
}
$ef053115c0f9207e$var$_o.peek = $ef053115c0f9207e$var$R9;
function $ef053115c0f9207e$var$_o(e, t, n, r) {
    const i = e.referenceType, s = n.enter("linkReference");
    let o = n.enter("label");
    const l = $ef053115c0f9207e$var$Re(r);
    let u = l.move("[");
    const c = $ef053115c0f9207e$var$E1(e, n, {
        before: u,
        after: "]",
        ...l.current()
    });
    u += l.move(c + "]["), o();
    const h = n.stack;
    n.stack = [], o = n.enter("reference");
    const p = $ef053115c0f9207e$var$Ee(n, $ef053115c0f9207e$var$ar(e), {
        before: u,
        after: "]",
        ...l.current()
    });
    return o(), n.stack = h, s(), i === "full" || !c || c !== p ? u += l.move(p + "]") : i === "shortcut" ? u = u.slice(0, -1) : u += l.move("]"), u;
}
function $ef053115c0f9207e$var$R9() {
    return "[";
}
function $ef053115c0f9207e$var$ur(e) {
    const t = e.options.bullet || "*";
    if (t !== "*" && t !== "+" && t !== "-") throw new Error("Cannot serialize items with `" + t + "` for `options.bullet`, expected `*`, `+`, or `-`");
    return t;
}
function $ef053115c0f9207e$var$x9(e) {
    const t = $ef053115c0f9207e$var$ur(e), n = e.options.bulletOther;
    if (!n) return t === "*" ? "-" : "*";
    if (n !== "*" && n !== "+" && n !== "-") throw new Error("Cannot serialize items with `" + n + "` for `options.bulletOther`, expected `*`, `+`, or `-`");
    if (n === t) throw new Error("Expected `bullet` (`" + t + "`) and `bulletOther` (`" + n + "`) to be different");
    return n;
}
function $ef053115c0f9207e$var$go(e) {
    const t = e.options.bulletOrdered || ".";
    if (t !== "." && t !== ")") throw new Error("Cannot serialize items with `" + t + "` for `options.bulletOrdered`, expected `.` or `)`");
    return t;
}
function $ef053115c0f9207e$var$y9(e) {
    const t = $ef053115c0f9207e$var$go(e), n = e.options.bulletOrderedOther;
    if (!n) return t === "." ? ")" : ".";
    if (n !== "." && n !== ")") throw new Error("Cannot serialize items with `" + n + "` for `options.bulletOrderedOther`, expected `*`, `+`, or `-`");
    if (n === t) throw new Error("Expected `bulletOrdered` (`" + t + "`) and `bulletOrderedOther` (`" + n + "`) to be different");
    return n;
}
function $ef053115c0f9207e$var$Ao(e) {
    const t = e.options.rule || "*";
    if (t !== "*" && t !== "-" && t !== "_") throw new Error("Cannot serialize rules with `" + t + "` for `options.rule`, expected `*`, `-`, or `_`");
    return t;
}
function $ef053115c0f9207e$var$k9(e, t, n, r) {
    const i = n.enter("list"), s = n.bulletCurrent;
    let o = e.ordered ? $ef053115c0f9207e$var$go(n) : $ef053115c0f9207e$var$ur(n);
    const l = e.ordered ? $ef053115c0f9207e$var$y9(n) : $ef053115c0f9207e$var$x9(n), u = n.bulletLastUsed;
    let c = !1;
    if (t && // Explicit `other` set.
    (e.ordered ? n.options.bulletOrderedOther : n.options.bulletOther) && u && o === u && (c = !0), !e.ordered) {
        const p = e.children ? e.children[0] : void 0;
        if (// Bullet could be used as a thematic break marker:
        (o === "*" || o === "-") && // Empty first list item:
        p && (!p.children || !p.children[0]) && // Directly in two other list items:
        n.stack[n.stack.length - 1] === "list" && n.stack[n.stack.length - 2] === "listItem" && n.stack[n.stack.length - 3] === "list" && n.stack[n.stack.length - 4] === "listItem" && // That are each the first child.
        n.indexStack[n.indexStack.length - 1] === 0 && n.indexStack[n.indexStack.length - 2] === 0 && n.indexStack[n.indexStack.length - 3] === 0 && (c = !0), $ef053115c0f9207e$var$Ao(n) === o && p) {
            let _ = -1;
            for(; ++_ < e.children.length;){
                const E = e.children[_];
                if (E && E.type === "listItem" && E.children && E.children[0] && E.children[0].type === "thematicBreak") {
                    c = !0;
                    break;
                }
            }
        }
    }
    c && (o = l), n.bulletCurrent = o;
    const h = $ef053115c0f9207e$var$en(e, n, r);
    return n.bulletLastUsed = o, n.bulletCurrent = s, i(), h;
}
function $ef053115c0f9207e$var$L9(e) {
    const t = e.options.listItemIndent || "tab";
    if (t === 1 || t === "1") return "one";
    if (t !== "tab" && t !== "one" && t !== "mixed") throw new Error("Cannot serialize items with `" + t + "` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`");
    return t;
}
function $ef053115c0f9207e$var$M9(e, t, n, r) {
    const i = $ef053115c0f9207e$var$L9(n);
    let s = n.bulletCurrent || $ef053115c0f9207e$var$ur(n);
    t && t.type === "list" && t.ordered && (s = (typeof t.start == "number" && t.start > -1 ? t.start : 1) + (n.options.incrementListMarker === !1 ? 0 : t.children.indexOf(e)) + s);
    let o = s.length + 1;
    (i === "tab" || i === "mixed" && (t && t.type === "list" && t.spread || e.spread)) && (o = Math.ceil(o / 4) * 4);
    const l = $ef053115c0f9207e$var$Re(r);
    l.move(s + " ".repeat(o - s.length)), l.shift(o);
    const u = n.enter("listItem"), c = $ef053115c0f9207e$var$or($ef053115c0f9207e$var$en(e, n, l.current()), h);
    return u(), c;
    function h(p, _, E) {
        return _ ? (E ? "" : " ".repeat(o)) + p : (E ? s : s + " ".repeat(o - s.length)) + p;
    }
}
function $ef053115c0f9207e$var$b9(e, t, n, r) {
    const i = n.enter("paragraph"), s = n.enter("phrasing"), o = $ef053115c0f9207e$var$E1(e, n, r);
    return s(), i(), o;
}
function $ef053115c0f9207e$var$P9(e, t, n, r) {
    return $ef053115c0f9207e$var$en(e, n, r);
}
function $ef053115c0f9207e$var$D9(e) {
    const t = e.options.strong || "*";
    if (t !== "*" && t !== "_") throw new Error("Cannot serialize strong with `" + t + "` for `options.strong`, expected `*`, or `_`");
    return t;
}
$ef053115c0f9207e$var$Co.peek = $ef053115c0f9207e$var$w9;
function $ef053115c0f9207e$var$Co(e, t, n, r) {
    const i = $ef053115c0f9207e$var$D9(n), s = n.enter("strong"), o = $ef053115c0f9207e$var$Re(r);
    let l = o.move(i + i);
    return l += o.move($ef053115c0f9207e$var$E1(e, n, {
        before: l,
        after: i,
        ...o.current()
    })), l += o.move(i + i), s(), l;
}
function $ef053115c0f9207e$var$w9(e, t, n) {
    return n.options.strong || "*";
}
function $ef053115c0f9207e$var$F9(e, t, n, r) {
    return $ef053115c0f9207e$var$Ee(n, e.value, r);
}
function $ef053115c0f9207e$var$H9(e) {
    const t = e.options.ruleRepetition || 3;
    if (t < 3) throw new Error("Cannot serialize rules with repetition `" + t + "` for `options.ruleRepetition`, expected `3` or more");
    return t;
}
function $ef053115c0f9207e$var$B9(e, t, n) {
    const r = ($ef053115c0f9207e$var$Ao(n) + (n.options.ruleSpaces ? " " : "")).repeat($ef053115c0f9207e$var$H9(n));
    return n.options.ruleSpaces ? r.slice(0, -1) : r;
}
const $ef053115c0f9207e$var$U9 = {
    blockquote: $ef053115c0f9207e$var$r9,
    break: $ef053115c0f9207e$var$ai,
    code: $ef053115c0f9207e$var$l9,
    definition: $ef053115c0f9207e$var$c9,
    emphasis: $ef053115c0f9207e$var$lo,
    hardBreak: $ef053115c0f9207e$var$ai,
    heading: $ef053115c0f9207e$var$A9,
    html: $ef053115c0f9207e$var$ho,
    image: $ef053115c0f9207e$var$fo,
    imageReference: $ef053115c0f9207e$var$To,
    inlineCode: $ef053115c0f9207e$var$mo,
    link: $ef053115c0f9207e$var$Eo,
    linkReference: $ef053115c0f9207e$var$_o,
    list: $ef053115c0f9207e$var$k9,
    listItem: $ef053115c0f9207e$var$M9,
    paragraph: $ef053115c0f9207e$var$b9,
    root: $ef053115c0f9207e$var$P9,
    strong: $ef053115c0f9207e$var$Co,
    text: $ef053115c0f9207e$var$F9,
    thematicBreak: $ef053115c0f9207e$var$B9
}, $ef053115c0f9207e$var$v9 = [
    $ef053115c0f9207e$var$G9
];
function $ef053115c0f9207e$var$G9(e, t, n, r) {
    if (t.type === "code" && $ef053115c0f9207e$var$Vn(t, r) && (e.type === "list" || e.type === t.type && $ef053115c0f9207e$var$Vn(e, r)) || e.type === "list" && e.type === t.type && !!e.ordered == !!t.ordered && !(e.ordered ? r.options.bulletOrderedOther : r.options.bulletOther)) return !1;
    if ("spread" in n && typeof n.spread == "boolean") return e.type === "paragraph" && // Two paragraphs.
    (e.type === t.type || t.type === "definition" || // Paragraph followed by a setext heading.
    t.type === "heading" && $ef053115c0f9207e$var$co(t, r)) ? void 0 : n.spread ? 1 : 0;
}
const $ef053115c0f9207e$var$A1 = [
    "autolink",
    "destinationLiteral",
    "destinationRaw",
    "reference",
    "titleQuote",
    "titleApostrophe"
], $ef053115c0f9207e$var$K9 = [
    {
        character: "	",
        after: "[\\r\\n]",
        inConstruct: "phrasing"
    },
    {
        character: "	",
        before: "[\\r\\n]",
        inConstruct: "phrasing"
    },
    {
        character: "	",
        inConstruct: [
            "codeFencedLangGraveAccent",
            "codeFencedLangTilde"
        ]
    },
    {
        character: "\r",
        inConstruct: [
            "codeFencedLangGraveAccent",
            "codeFencedLangTilde",
            "codeFencedMetaGraveAccent",
            "codeFencedMetaTilde",
            "destinationLiteral",
            "headingAtx"
        ]
    },
    {
        character: `
`,
        inConstruct: [
            "codeFencedLangGraveAccent",
            "codeFencedLangTilde",
            "codeFencedMetaGraveAccent",
            "codeFencedMetaTilde",
            "destinationLiteral",
            "headingAtx"
        ]
    },
    {
        character: " ",
        after: "[\\r\\n]",
        inConstruct: "phrasing"
    },
    {
        character: " ",
        before: "[\\r\\n]",
        inConstruct: "phrasing"
    },
    {
        character: " ",
        inConstruct: [
            "codeFencedLangGraveAccent",
            "codeFencedLangTilde"
        ]
    },
    // An exclamation mark can start an image, if it is followed by a link or
    // a link reference.
    {
        character: "!",
        after: "\\[",
        inConstruct: "phrasing",
        notInConstruct: $ef053115c0f9207e$var$A1
    },
    // A quote can break out of a title.
    {
        character: '"',
        inConstruct: "titleQuote"
    },
    // A number sign could start an ATX heading if it starts a line.
    {
        atBreak: !0,
        character: "#"
    },
    {
        character: "#",
        inConstruct: "headingAtx",
        after: `(?:[\r
]|$)`
    },
    // Dollar sign and percentage are not used in markdown.
    // An ampersand could start a character reference.
    {
        character: "&",
        after: "[#A-Za-z]",
        inConstruct: "phrasing"
    },
    // An apostrophe can break out of a title.
    {
        character: "'",
        inConstruct: "titleApostrophe"
    },
    // A left paren could break out of a destination raw.
    {
        character: "(",
        inConstruct: "destinationRaw"
    },
    // A left paren followed by `]` could make something into a link or image.
    {
        before: "\\]",
        character: "(",
        inConstruct: "phrasing",
        notInConstruct: $ef053115c0f9207e$var$A1
    },
    // A right paren could start a list item or break out of a destination
    // raw.
    {
        atBreak: !0,
        before: "\\d+",
        character: ")"
    },
    {
        character: ")",
        inConstruct: "destinationRaw"
    },
    // An asterisk can start thematic breaks, list items, emphasis, strong.
    {
        atBreak: !0,
        character: "*"
    },
    {
        character: "*",
        inConstruct: "phrasing",
        notInConstruct: $ef053115c0f9207e$var$A1
    },
    // A plus sign could start a list item.
    {
        atBreak: !0,
        character: "+"
    },
    // A dash can start thematic breaks, list items, and setext heading
    // underlines.
    {
        atBreak: !0,
        character: "-"
    },
    // A dot could start a list item.
    {
        atBreak: !0,
        before: "\\d+",
        character: ".",
        after: `(?:[ 	\r
]|$)`
    },
    // Slash, colon, and semicolon are not used in markdown for constructs.
    // A less than can start html (flow or text) or an autolink.
    // HTML could start with an exclamation mark (declaration, cdata, comment),
    // slash (closing tag), question mark (instruction), or a letter (tag).
    // An autolink also starts with a letter.
    // Finally, it could break out of a destination literal.
    {
        atBreak: !0,
        character: "<",
        after: "[!/?A-Za-z]"
    },
    {
        character: "<",
        after: "[!/?A-Za-z]",
        inConstruct: "phrasing",
        notInConstruct: $ef053115c0f9207e$var$A1
    },
    {
        character: "<",
        inConstruct: "destinationLiteral"
    },
    // An equals to can start setext heading underlines.
    {
        atBreak: !0,
        character: "="
    },
    // A greater than can start block quotes and it can break out of a
    // destination literal.
    {
        atBreak: !0,
        character: ">"
    },
    {
        character: ">",
        inConstruct: "destinationLiteral"
    },
    // Question mark and at sign are not used in markdown for constructs.
    // A left bracket can start definitions, references, labels,
    {
        atBreak: !0,
        character: "["
    },
    {
        character: "[",
        inConstruct: "phrasing",
        notInConstruct: $ef053115c0f9207e$var$A1
    },
    {
        character: "[",
        inConstruct: [
            "label",
            "reference"
        ]
    },
    // A backslash can start an escape (when followed by punctuation) or a
    // hard break (when followed by an eol).
    // Note: typical escapes are handled in `safe`!
    {
        character: "\\",
        after: "[\\r\\n]",
        inConstruct: "phrasing"
    },
    // A right bracket can exit labels.
    {
        character: "]",
        inConstruct: [
            "label",
            "reference"
        ]
    },
    // Caret is not used in markdown for constructs.
    // An underscore can start emphasis, strong, or a thematic break.
    {
        atBreak: !0,
        character: "_"
    },
    {
        character: "_",
        inConstruct: "phrasing",
        notInConstruct: $ef053115c0f9207e$var$A1
    },
    // A grave accent can start code (fenced or text), or it can break out of
    // a grave accent code fence.
    {
        atBreak: !0,
        character: "`"
    },
    {
        character: "`",
        inConstruct: [
            "codeFencedLangGraveAccent",
            "codeFencedMetaGraveAccent"
        ]
    },
    {
        character: "`",
        inConstruct: "phrasing",
        notInConstruct: $ef053115c0f9207e$var$A1
    },
    // Left brace, vertical bar, right brace are not used in markdown for
    // constructs.
    // A tilde can start code (fenced).
    {
        atBreak: !0,
        character: "~"
    }
];
function $ef053115c0f9207e$var$So(e, t = {}) {
    const n = {
        enter: i,
        stack: [],
        unsafe: [],
        join: [],
        handlers: {},
        options: {},
        indexStack: []
    };
    $ef053115c0f9207e$var$Gt(n, {
        unsafe: $ef053115c0f9207e$var$K9,
        join: $ef053115c0f9207e$var$v9,
        handlers: $ef053115c0f9207e$var$U9
    }), $ef053115c0f9207e$var$Gt(n, t), n.options.tightDefinitions && $ef053115c0f9207e$var$Gt(n, {
        join: [
            $ef053115c0f9207e$var$j9
        ]
    }), n.handle = $ef053115c0f9207e$var$t9("type", {
        invalid: $ef053115c0f9207e$var$z9,
        // @ts-expect-error: hush.
        unknown: $ef053115c0f9207e$var$Y9,
        // @ts-expect-error: hush.
        handlers: n.handlers
    });
    let r = n.handle(e, null, n, {
        before: `
`,
        after: `
`,
        now: {
            line: 1,
            column: 1
        },
        lineShift: 0
    });
    return r && r.charCodeAt(r.length - 1) !== 10 && r.charCodeAt(r.length - 1) !== 13 && (r += `
`), r;
    function i(s) {
        return n.stack.push(s), o;
        function o() {
            n.stack.pop();
        }
    }
}
function $ef053115c0f9207e$var$z9(e) {
    throw new Error("Cannot handle value `" + e + "`, expected node");
}
function $ef053115c0f9207e$var$Y9(e) {
    throw new Error("Cannot handle unknown node `" + e.type + "`");
}
function $ef053115c0f9207e$var$j9(e, t) {
    if (e.type === "definition" && e.type === t.type) return 0;
}
function $ef053115c0f9207e$var$$9(e) {
    Object.assign(this, {
        Compiler: (n)=>{
            const r = /** @type {Options} */ this.data("settings");
            return $ef053115c0f9207e$var$So(n, Object.assign({}, r, e, {
                // Note: this option is not in the readme.
                // The goal is for it to be set by plugins on `data` instead of being
                // passed by users.
                extensions: /** @type {ToMarkdownOptions['extensions']} */ this.data("toMarkdownExtensions") || []
            }));
        }
    });
}
const $ef053115c0f9207e$var$Q9 = $ef053115c0f9207e$var$nr().use($ef053115c0f9207e$var$e9).use($ef053115c0f9207e$var$$9).freeze();
function $ef053115c0f9207e$var$W9(e) {
    switch(e.level){
        case 1:
            return `# ${e.text}
`;
        case 2:
            return `## ${e.text}
`;
        case 3:
            return `### ${e.text}
`;
        case 4:
            return `#### ${e.text}
`;
        case 5:
            return `##### ${e.text}
`;
        case 6:
            return `###### ${e.text}
`;
    }
}
function $ef053115c0f9207e$var$q9(e) {
    let t = {};
    switch(e.depth){
        case 1:
            return e.children.forEach((n)=>{
                t = {
                    data: {
                        level: 1,
                        text: n.value
                    },
                    type: "header"
                };
            }), t;
        case 2:
            return e.children.forEach((n)=>{
                t = {
                    data: {
                        level: 2,
                        text: n.value
                    },
                    type: "header"
                };
            }), t;
        case 3:
            return e.children.forEach((n)=>{
                t = {
                    data: {
                        level: 3,
                        text: n.value
                    },
                    type: "header"
                };
            }), t;
        case 4:
            return e.children.forEach((n)=>{
                t = {
                    data: {
                        level: 4,
                        text: n.value
                    },
                    type: "header"
                };
            }), t;
        case 5:
            return e.children.forEach((n)=>{
                t = {
                    data: {
                        level: 5,
                        text: n.value
                    },
                    type: "header"
                };
            }), t;
        case 6:
            return e.children.forEach((n)=>{
                t = {
                    data: {
                        level: 6,
                        text: n.value
                    },
                    type: "header"
                };
            }), t;
    }
}
var $ef053115c0f9207e$var$Ye = {};
const $ef053115c0f9207e$var$V9 = [
    65534,
    65535,
    131070,
    131071,
    196606,
    196607,
    262142,
    262143,
    327678,
    327679,
    393214,
    393215,
    458750,
    458751,
    524286,
    524287,
    589822,
    589823,
    655358,
    655359,
    720894,
    720895,
    786430,
    786431,
    851966,
    851967,
    917502,
    917503,
    983038,
    983039,
    1048574,
    1048575,
    1114110,
    1114111
];
$ef053115c0f9207e$var$Ye.REPLACEMENT_CHARACTER = "\uFFFD";
$ef053115c0f9207e$var$Ye.CODE_POINTS = {
    EOF: -1,
    NULL: 0,
    TABULATION: 9,
    CARRIAGE_RETURN: 13,
    LINE_FEED: 10,
    FORM_FEED: 12,
    SPACE: 32,
    EXCLAMATION_MARK: 33,
    QUOTATION_MARK: 34,
    NUMBER_SIGN: 35,
    AMPERSAND: 38,
    APOSTROPHE: 39,
    HYPHEN_MINUS: 45,
    SOLIDUS: 47,
    DIGIT_0: 48,
    DIGIT_9: 57,
    SEMICOLON: 59,
    LESS_THAN_SIGN: 60,
    EQUALS_SIGN: 61,
    GREATER_THAN_SIGN: 62,
    QUESTION_MARK: 63,
    LATIN_CAPITAL_A: 65,
    LATIN_CAPITAL_F: 70,
    LATIN_CAPITAL_X: 88,
    LATIN_CAPITAL_Z: 90,
    RIGHT_SQUARE_BRACKET: 93,
    GRAVE_ACCENT: 96,
    LATIN_SMALL_A: 97,
    LATIN_SMALL_F: 102,
    LATIN_SMALL_X: 120,
    LATIN_SMALL_Z: 122,
    REPLACEMENT_CHARACTER: 65533
};
$ef053115c0f9207e$var$Ye.CODE_POINT_SEQUENCES = {
    DASH_DASH_STRING: [
        45,
        45
    ],
    //--
    DOCTYPE_STRING: [
        68,
        79,
        67,
        84,
        89,
        80,
        69
    ],
    //DOCTYPE
    CDATA_START_STRING: [
        91,
        67,
        68,
        65,
        84,
        65,
        91
    ],
    //[CDATA[
    SCRIPT_STRING: [
        115,
        99,
        114,
        105,
        112,
        116
    ],
    //script
    PUBLIC_STRING: [
        80,
        85,
        66,
        76,
        73,
        67
    ],
    //PUBLIC
    SYSTEM_STRING: [
        83,
        89,
        83,
        84,
        69,
        77
    ]
};
$ef053115c0f9207e$var$Ye.isSurrogate = function(e) {
    return e >= 55296 && e <= 57343;
};
$ef053115c0f9207e$var$Ye.isSurrogatePair = function(e) {
    return e >= 56320 && e <= 57343;
};
$ef053115c0f9207e$var$Ye.getSurrogatePairCodePoint = function(e, t) {
    return (e - 55296) * 1024 + 9216 + t;
};
$ef053115c0f9207e$var$Ye.isControlCodePoint = function(e) {
    return e !== 32 && e !== 10 && e !== 13 && e !== 9 && e !== 12 && e >= 1 && e <= 31 || e >= 127 && e <= 159;
};
$ef053115c0f9207e$var$Ye.isUndefinedCodePoint = function(e) {
    return e >= 64976 && e <= 65007 || $ef053115c0f9207e$var$V9.indexOf(e) > -1;
};
var $ef053115c0f9207e$var$cr = {
    controlCharacterInInputStream: "control-character-in-input-stream",
    noncharacterInInputStream: "noncharacter-in-input-stream",
    surrogateInInputStream: "surrogate-in-input-stream",
    nonVoidHtmlElementStartTagWithTrailingSolidus: "non-void-html-element-start-tag-with-trailing-solidus",
    endTagWithAttributes: "end-tag-with-attributes",
    endTagWithTrailingSolidus: "end-tag-with-trailing-solidus",
    unexpectedSolidusInTag: "unexpected-solidus-in-tag",
    unexpectedNullCharacter: "unexpected-null-character",
    unexpectedQuestionMarkInsteadOfTagName: "unexpected-question-mark-instead-of-tag-name",
    invalidFirstCharacterOfTagName: "invalid-first-character-of-tag-name",
    unexpectedEqualsSignBeforeAttributeName: "unexpected-equals-sign-before-attribute-name",
    missingEndTagName: "missing-end-tag-name",
    unexpectedCharacterInAttributeName: "unexpected-character-in-attribute-name",
    unknownNamedCharacterReference: "unknown-named-character-reference",
    missingSemicolonAfterCharacterReference: "missing-semicolon-after-character-reference",
    unexpectedCharacterAfterDoctypeSystemIdentifier: "unexpected-character-after-doctype-system-identifier",
    unexpectedCharacterInUnquotedAttributeValue: "unexpected-character-in-unquoted-attribute-value",
    eofBeforeTagName: "eof-before-tag-name",
    eofInTag: "eof-in-tag",
    missingAttributeValue: "missing-attribute-value",
    missingWhitespaceBetweenAttributes: "missing-whitespace-between-attributes",
    missingWhitespaceAfterDoctypePublicKeyword: "missing-whitespace-after-doctype-public-keyword",
    missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers: "missing-whitespace-between-doctype-public-and-system-identifiers",
    missingWhitespaceAfterDoctypeSystemKeyword: "missing-whitespace-after-doctype-system-keyword",
    missingQuoteBeforeDoctypePublicIdentifier: "missing-quote-before-doctype-public-identifier",
    missingQuoteBeforeDoctypeSystemIdentifier: "missing-quote-before-doctype-system-identifier",
    missingDoctypePublicIdentifier: "missing-doctype-public-identifier",
    missingDoctypeSystemIdentifier: "missing-doctype-system-identifier",
    abruptDoctypePublicIdentifier: "abrupt-doctype-public-identifier",
    abruptDoctypeSystemIdentifier: "abrupt-doctype-system-identifier",
    cdataInHtmlContent: "cdata-in-html-content",
    incorrectlyOpenedComment: "incorrectly-opened-comment",
    eofInScriptHtmlCommentLikeText: "eof-in-script-html-comment-like-text",
    eofInDoctype: "eof-in-doctype",
    nestedComment: "nested-comment",
    abruptClosingOfEmptyComment: "abrupt-closing-of-empty-comment",
    eofInComment: "eof-in-comment",
    incorrectlyClosedComment: "incorrectly-closed-comment",
    eofInCdata: "eof-in-cdata",
    absenceOfDigitsInNumericCharacterReference: "absence-of-digits-in-numeric-character-reference",
    nullCharacterReference: "null-character-reference",
    surrogateCharacterReference: "surrogate-character-reference",
    characterReferenceOutsideUnicodeRange: "character-reference-outside-unicode-range",
    controlCharacterReference: "control-character-reference",
    noncharacterCharacterReference: "noncharacter-character-reference",
    missingWhitespaceBeforeDoctypeName: "missing-whitespace-before-doctype-name",
    missingDoctypeName: "missing-doctype-name",
    invalidCharacterSequenceAfterDoctypeName: "invalid-character-sequence-after-doctype-name",
    duplicateAttribute: "duplicate-attribute",
    nonConformingDoctype: "non-conforming-doctype",
    missingDoctype: "missing-doctype",
    misplacedDoctype: "misplaced-doctype",
    endTagWithoutMatchingOpenElement: "end-tag-without-matching-open-element",
    closingOfElementWithOpenChildElements: "closing-of-element-with-open-child-elements",
    disallowedContentInNoscriptInHead: "disallowed-content-in-noscript-in-head",
    openElementsLeftAfterEof: "open-elements-left-after-eof",
    abandonedHeadElementChild: "abandoned-head-element-child",
    misplacedStartTagForHeadElement: "misplaced-start-tag-for-head-element",
    nestedNoscriptInHead: "nested-noscript-in-head",
    eofInElementThatCanContainOnlyText: "eof-in-element-that-can-contain-only-text"
};
const $ef053115c0f9207e$var$U1 = $ef053115c0f9207e$var$Ye, $ef053115c0f9207e$var$Sn = $ef053115c0f9207e$var$cr, $ef053115c0f9207e$var$C1 = $ef053115c0f9207e$var$U1.CODE_POINTS, $ef053115c0f9207e$var$X9 = 65536;
let $ef053115c0f9207e$var$J9 = class {
    constructor(){
        this.html = null, this.pos = -1, this.lastGapPos = -1, this.lastCharPos = -1, this.gapStack = [], this.skipNextNewLine = !1, this.lastChunkWritten = !1, this.endOfChunkHit = !1, this.bufferWaterline = $ef053115c0f9207e$var$X9;
    }
    _err() {}
    _addGap() {
        this.gapStack.push(this.lastGapPos), this.lastGapPos = this.pos;
    }
    _processSurrogate(t) {
        if (this.pos !== this.lastCharPos) {
            const n = this.html.charCodeAt(this.pos + 1);
            if ($ef053115c0f9207e$var$U1.isSurrogatePair(n)) return this.pos++, this._addGap(), $ef053115c0f9207e$var$U1.getSurrogatePairCodePoint(t, n);
        } else if (!this.lastChunkWritten) return this.endOfChunkHit = !0, $ef053115c0f9207e$var$C1.EOF;
        return this._err($ef053115c0f9207e$var$Sn.surrogateInInputStream), t;
    }
    dropParsedChunk() {
        this.pos > this.bufferWaterline && (this.lastCharPos -= this.pos, this.html = this.html.substring(this.pos), this.pos = 0, this.lastGapPos = -1, this.gapStack = []);
    }
    write(t, n) {
        this.html ? this.html += t : this.html = t, this.lastCharPos = this.html.length - 1, this.endOfChunkHit = !1, this.lastChunkWritten = n;
    }
    insertHtmlAtCurrentPos(t) {
        this.html = this.html.substring(0, this.pos + 1) + t + this.html.substring(this.pos + 1, this.html.length), this.lastCharPos = this.html.length - 1, this.endOfChunkHit = !1;
    }
    advance() {
        if (this.pos++, this.pos > this.lastCharPos) return this.endOfChunkHit = !this.lastChunkWritten, $ef053115c0f9207e$var$C1.EOF;
        let t = this.html.charCodeAt(this.pos);
        return this.skipNextNewLine && t === $ef053115c0f9207e$var$C1.LINE_FEED ? (this.skipNextNewLine = !1, this._addGap(), this.advance()) : t === $ef053115c0f9207e$var$C1.CARRIAGE_RETURN ? (this.skipNextNewLine = !0, $ef053115c0f9207e$var$C1.LINE_FEED) : (this.skipNextNewLine = !1, $ef053115c0f9207e$var$U1.isSurrogate(t) && (t = this._processSurrogate(t)), t > 31 && t < 127 || t === $ef053115c0f9207e$var$C1.LINE_FEED || t === $ef053115c0f9207e$var$C1.CARRIAGE_RETURN || t > 159 && t < 64976 || this._checkForProblematicCharacters(t), t);
    }
    _checkForProblematicCharacters(t) {
        $ef053115c0f9207e$var$U1.isControlCodePoint(t) ? this._err($ef053115c0f9207e$var$Sn.controlCharacterInInputStream) : $ef053115c0f9207e$var$U1.isUndefinedCodePoint(t) && this._err($ef053115c0f9207e$var$Sn.noncharacterInInputStream);
    }
    retreat() {
        this.pos === this.lastGapPos && (this.lastGapPos = this.gapStack.pop(), this.pos--), this.pos--;
    }
};
var $ef053115c0f9207e$var$Z9 = $ef053115c0f9207e$var$J9, $ef053115c0f9207e$var$e0 = new Uint16Array([
    4,
    52,
    65,
    66,
    67,
    68,
    69,
    70,
    71,
    72,
    73,
    74,
    75,
    76,
    77,
    78,
    79,
    80,
    81,
    82,
    83,
    84,
    85,
    86,
    87,
    88,
    89,
    90,
    97,
    98,
    99,
    100,
    101,
    102,
    103,
    104,
    105,
    106,
    107,
    108,
    109,
    110,
    111,
    112,
    113,
    114,
    115,
    116,
    117,
    118,
    119,
    120,
    121,
    122,
    106,
    303,
    412,
    810,
    1432,
    1701,
    1796,
    1987,
    2114,
    2360,
    2420,
    2484,
    3170,
    3251,
    4140,
    4393,
    4575,
    4610,
    5106,
    5512,
    5728,
    6117,
    6274,
    6315,
    6345,
    6427,
    6516,
    7002,
    7910,
    8733,
    9323,
    9870,
    10170,
    10631,
    10893,
    11318,
    11386,
    11467,
    12773,
    13092,
    14474,
    14922,
    15448,
    15542,
    16419,
    17666,
    18166,
    18611,
    19004,
    19095,
    19298,
    19397,
    4,
    16,
    69,
    77,
    97,
    98,
    99,
    102,
    103,
    108,
    109,
    110,
    111,
    112,
    114,
    115,
    116,
    117,
    140,
    150,
    158,
    169,
    176,
    194,
    199,
    210,
    216,
    222,
    226,
    242,
    256,
    266,
    283,
    294,
    108,
    105,
    103,
    5,
    198,
    1,
    59,
    148,
    1,
    198,
    80,
    5,
    38,
    1,
    59,
    156,
    1,
    38,
    99,
    117,
    116,
    101,
    5,
    193,
    1,
    59,
    167,
    1,
    193,
    114,
    101,
    118,
    101,
    59,
    1,
    258,
    4,
    2,
    105,
    121,
    182,
    191,
    114,
    99,
    5,
    194,
    1,
    59,
    189,
    1,
    194,
    59,
    1,
    1040,
    114,
    59,
    3,
    55349,
    56580,
    114,
    97,
    118,
    101,
    5,
    192,
    1,
    59,
    208,
    1,
    192,
    112,
    104,
    97,
    59,
    1,
    913,
    97,
    99,
    114,
    59,
    1,
    256,
    100,
    59,
    1,
    10835,
    4,
    2,
    103,
    112,
    232,
    237,
    111,
    110,
    59,
    1,
    260,
    102,
    59,
    3,
    55349,
    56632,
    112,
    108,
    121,
    70,
    117,
    110,
    99,
    116,
    105,
    111,
    110,
    59,
    1,
    8289,
    105,
    110,
    103,
    5,
    197,
    1,
    59,
    264,
    1,
    197,
    4,
    2,
    99,
    115,
    272,
    277,
    114,
    59,
    3,
    55349,
    56476,
    105,
    103,
    110,
    59,
    1,
    8788,
    105,
    108,
    100,
    101,
    5,
    195,
    1,
    59,
    292,
    1,
    195,
    109,
    108,
    5,
    196,
    1,
    59,
    301,
    1,
    196,
    4,
    8,
    97,
    99,
    101,
    102,
    111,
    114,
    115,
    117,
    321,
    350,
    354,
    383,
    388,
    394,
    400,
    405,
    4,
    2,
    99,
    114,
    327,
    336,
    107,
    115,
    108,
    97,
    115,
    104,
    59,
    1,
    8726,
    4,
    2,
    118,
    119,
    342,
    345,
    59,
    1,
    10983,
    101,
    100,
    59,
    1,
    8966,
    121,
    59,
    1,
    1041,
    4,
    3,
    99,
    114,
    116,
    362,
    369,
    379,
    97,
    117,
    115,
    101,
    59,
    1,
    8757,
    110,
    111,
    117,
    108,
    108,
    105,
    115,
    59,
    1,
    8492,
    97,
    59,
    1,
    914,
    114,
    59,
    3,
    55349,
    56581,
    112,
    102,
    59,
    3,
    55349,
    56633,
    101,
    118,
    101,
    59,
    1,
    728,
    99,
    114,
    59,
    1,
    8492,
    109,
    112,
    101,
    113,
    59,
    1,
    8782,
    4,
    14,
    72,
    79,
    97,
    99,
    100,
    101,
    102,
    104,
    105,
    108,
    111,
    114,
    115,
    117,
    442,
    447,
    456,
    504,
    542,
    547,
    569,
    573,
    577,
    616,
    678,
    784,
    790,
    796,
    99,
    121,
    59,
    1,
    1063,
    80,
    89,
    5,
    169,
    1,
    59,
    454,
    1,
    169,
    4,
    3,
    99,
    112,
    121,
    464,
    470,
    497,
    117,
    116,
    101,
    59,
    1,
    262,
    4,
    2,
    59,
    105,
    476,
    478,
    1,
    8914,
    116,
    97,
    108,
    68,
    105,
    102,
    102,
    101,
    114,
    101,
    110,
    116,
    105,
    97,
    108,
    68,
    59,
    1,
    8517,
    108,
    101,
    121,
    115,
    59,
    1,
    8493,
    4,
    4,
    97,
    101,
    105,
    111,
    514,
    520,
    530,
    535,
    114,
    111,
    110,
    59,
    1,
    268,
    100,
    105,
    108,
    5,
    199,
    1,
    59,
    528,
    1,
    199,
    114,
    99,
    59,
    1,
    264,
    110,
    105,
    110,
    116,
    59,
    1,
    8752,
    111,
    116,
    59,
    1,
    266,
    4,
    2,
    100,
    110,
    553,
    560,
    105,
    108,
    108,
    97,
    59,
    1,
    184,
    116,
    101,
    114,
    68,
    111,
    116,
    59,
    1,
    183,
    114,
    59,
    1,
    8493,
    105,
    59,
    1,
    935,
    114,
    99,
    108,
    101,
    4,
    4,
    68,
    77,
    80,
    84,
    591,
    596,
    603,
    609,
    111,
    116,
    59,
    1,
    8857,
    105,
    110,
    117,
    115,
    59,
    1,
    8854,
    108,
    117,
    115,
    59,
    1,
    8853,
    105,
    109,
    101,
    115,
    59,
    1,
    8855,
    111,
    4,
    2,
    99,
    115,
    623,
    646,
    107,
    119,
    105,
    115,
    101,
    67,
    111,
    110,
    116,
    111,
    117,
    114,
    73,
    110,
    116,
    101,
    103,
    114,
    97,
    108,
    59,
    1,
    8754,
    101,
    67,
    117,
    114,
    108,
    121,
    4,
    2,
    68,
    81,
    658,
    671,
    111,
    117,
    98,
    108,
    101,
    81,
    117,
    111,
    116,
    101,
    59,
    1,
    8221,
    117,
    111,
    116,
    101,
    59,
    1,
    8217,
    4,
    4,
    108,
    110,
    112,
    117,
    688,
    701,
    736,
    753,
    111,
    110,
    4,
    2,
    59,
    101,
    696,
    698,
    1,
    8759,
    59,
    1,
    10868,
    4,
    3,
    103,
    105,
    116,
    709,
    717,
    722,
    114,
    117,
    101,
    110,
    116,
    59,
    1,
    8801,
    110,
    116,
    59,
    1,
    8751,
    111,
    117,
    114,
    73,
    110,
    116,
    101,
    103,
    114,
    97,
    108,
    59,
    1,
    8750,
    4,
    2,
    102,
    114,
    742,
    745,
    59,
    1,
    8450,
    111,
    100,
    117,
    99,
    116,
    59,
    1,
    8720,
    110,
    116,
    101,
    114,
    67,
    108,
    111,
    99,
    107,
    119,
    105,
    115,
    101,
    67,
    111,
    110,
    116,
    111,
    117,
    114,
    73,
    110,
    116,
    101,
    103,
    114,
    97,
    108,
    59,
    1,
    8755,
    111,
    115,
    115,
    59,
    1,
    10799,
    99,
    114,
    59,
    3,
    55349,
    56478,
    112,
    4,
    2,
    59,
    67,
    803,
    805,
    1,
    8915,
    97,
    112,
    59,
    1,
    8781,
    4,
    11,
    68,
    74,
    83,
    90,
    97,
    99,
    101,
    102,
    105,
    111,
    115,
    834,
    850,
    855,
    860,
    865,
    888,
    903,
    916,
    921,
    1011,
    1415,
    4,
    2,
    59,
    111,
    840,
    842,
    1,
    8517,
    116,
    114,
    97,
    104,
    100,
    59,
    1,
    10513,
    99,
    121,
    59,
    1,
    1026,
    99,
    121,
    59,
    1,
    1029,
    99,
    121,
    59,
    1,
    1039,
    4,
    3,
    103,
    114,
    115,
    873,
    879,
    883,
    103,
    101,
    114,
    59,
    1,
    8225,
    114,
    59,
    1,
    8609,
    104,
    118,
    59,
    1,
    10980,
    4,
    2,
    97,
    121,
    894,
    900,
    114,
    111,
    110,
    59,
    1,
    270,
    59,
    1,
    1044,
    108,
    4,
    2,
    59,
    116,
    910,
    912,
    1,
    8711,
    97,
    59,
    1,
    916,
    114,
    59,
    3,
    55349,
    56583,
    4,
    2,
    97,
    102,
    927,
    998,
    4,
    2,
    99,
    109,
    933,
    992,
    114,
    105,
    116,
    105,
    99,
    97,
    108,
    4,
    4,
    65,
    68,
    71,
    84,
    950,
    957,
    978,
    985,
    99,
    117,
    116,
    101,
    59,
    1,
    180,
    111,
    4,
    2,
    116,
    117,
    964,
    967,
    59,
    1,
    729,
    98,
    108,
    101,
    65,
    99,
    117,
    116,
    101,
    59,
    1,
    733,
    114,
    97,
    118,
    101,
    59,
    1,
    96,
    105,
    108,
    100,
    101,
    59,
    1,
    732,
    111,
    110,
    100,
    59,
    1,
    8900,
    102,
    101,
    114,
    101,
    110,
    116,
    105,
    97,
    108,
    68,
    59,
    1,
    8518,
    4,
    4,
    112,
    116,
    117,
    119,
    1021,
    1026,
    1048,
    1249,
    102,
    59,
    3,
    55349,
    56635,
    4,
    3,
    59,
    68,
    69,
    1034,
    1036,
    1041,
    1,
    168,
    111,
    116,
    59,
    1,
    8412,
    113,
    117,
    97,
    108,
    59,
    1,
    8784,
    98,
    108,
    101,
    4,
    6,
    67,
    68,
    76,
    82,
    85,
    86,
    1065,
    1082,
    1101,
    1189,
    1211,
    1236,
    111,
    110,
    116,
    111,
    117,
    114,
    73,
    110,
    116,
    101,
    103,
    114,
    97,
    108,
    59,
    1,
    8751,
    111,
    4,
    2,
    116,
    119,
    1089,
    1092,
    59,
    1,
    168,
    110,
    65,
    114,
    114,
    111,
    119,
    59,
    1,
    8659,
    4,
    2,
    101,
    111,
    1107,
    1141,
    102,
    116,
    4,
    3,
    65,
    82,
    84,
    1117,
    1124,
    1136,
    114,
    114,
    111,
    119,
    59,
    1,
    8656,
    105,
    103,
    104,
    116,
    65,
    114,
    114,
    111,
    119,
    59,
    1,
    8660,
    101,
    101,
    59,
    1,
    10980,
    110,
    103,
    4,
    2,
    76,
    82,
    1149,
    1177,
    101,
    102,
    116,
    4,
    2,
    65,
    82,
    1158,
    1165,
    114,
    114,
    111,
    119,
    59,
    1,
    10232,
    105,
    103,
    104,
    116,
    65,
    114,
    114,
    111,
    119,
    59,
    1,
    10234,
    105,
    103,
    104,
    116,
    65,
    114,
    114,
    111,
    119,
    59,
    1,
    10233,
    105,
    103,
    104,
    116,
    4,
    2,
    65,
    84,
    1199,
    1206,
    114,
    114,
    111,
    119,
    59,
    1,
    8658,
    101,
    101,
    59,
    1,
    8872,
    112,
    4,
    2,
    65,
    68,
    1218,
    1225,
    114,
    114,
    111,
    119,
    59,
    1,
    8657,
    111,
    119,
    110,
    65,
    114,
    114,
    111,
    119,
    59,
    1,
    8661,
    101,
    114,
    116,
    105,
    99,
    97,
    108,
    66,
    97,
    114,
    59,
    1,
    8741,
    110,
    4,
    6,
    65,
    66,
    76,
    82,
    84,
    97,
    1264,
    1292,
    1299,
    1352,
    1391,
    1408,
    114,
    114,
    111,
    119,
    4,
    3,
    59,
    66,
    85,
    1276,
    1278,
    1283,
    1,
    8595,
    97,
    114,
    59,
    1,
    10515,
    112,
    65,
    114,
    114,
    111,
    119,
    59,
    1,
    8693,
    114,
    101,
    118,
    101,
    59,
    1,
    785,
    101,
    102,
    116,
    4,
    3,
    82,
    84,
    86,
    1310,
    1323,
    1334,
    105,
    103,
    104,
    116,
    86,
    101,
    99,
    116,
    111,
    114,
    59,
    1,
    10576,
    101,
    101,
    86,
    101,
    99,
    116,
    111,
    114,
    59,
    1,
    10590,
    101,
    99,
    116,
    111,
    114,
    4,
    2,
    59,
    66,
    1345,
    1347,
    1,
    8637,
    97,
    114,
    59,
    1,
    10582,
    105,
    103,
    104,
    116,
    4,
    2,
    84,
    86,
    1362,
    1373,
    101,
    101,
    86,
    101,
    99,
    116,
    111,
    114,
    59,
    1,
    10591,
    101,
    99,
    116,
    111,
    114,
    4,
    2,
    59,
    66,
    1384,
    1386,
    1,
    8641,
    97,
    114,
    59,
    1,
    10583,
    101,
    101,
    4,
    2,
    59,
    65,
    1399,
    1401,
    1,
    8868,
    114,
    114,
    111,
    119,
    59,
    1,
    8615,
    114,
    114,
    111,
    119,
    59,
    1,
    8659,
    4,
    2,
    99,
    116,
    1421,
    1426,
    114,
    59,
    3,
    55349,
    56479,
    114,
    111,
    107,
    59,
    1,
    272,
    4,
    16,
    78,
    84,
    97,
    99,
    100,
    102,
    103,
    108,
    109,
    111,
    112,
    113,
    115,
    116,
    117,
    120,
    1466,
    1470,
    1478,
    1489,
    1515,
    1520,
    1525,
    1536,
    1544,
    1593,
    1609,
    1617,
    1650,
    1664,
    1668,
    1677,
    71,
    59,
    1,
    330,
    72,
    5,
    208,
    1,
    59,
    1476,
    1,
    208,
    99,
    117,
    116,
    101,
    5,
    201,
    1,
    59,
    1487,
    1,
    201,
    4,
    3,
    97,
    105,
    121,
    1497,
    1503,
    1512,
    114,
    111,
    110,
    59,
    1,
    282,
    114,
    99,
    5,
    202,
    1,
    59,
    1510,
    1,
    202,
    59,
    1,
    1069,
    111,
    116,
    59,
    1,
    278,
    114,
    59,
    3,
    55349,
    56584,
    114,
    97,
    118,
    101,
    5,
    200,
    1,
    59,
    1534,
    1,
    200,
    101,
    109,
    101,
    110,
    116,
    59,
    1,
    8712,
    4,
    2,
    97,
    112,
    1550,
    1555,
    99,
    114,
    59,
    1,
    274,
    116,
    121,
    4,
    2,
    83,
    86,
    1563,
    1576,
    109,
    97,
    108,
    108,
    83,
    113,
    117,
    97,
    114,
    101,
    59,
    1,
    9723,
    101,
    114,
    121,
    83,
    109,
    97,
    108,
    108,
    83,
    113,
    117,
    97,
    114,
    101,
    59,
    1,
    9643,
    4,
    2,
    103,
    112,
    1599,
    1604,
    111,
    110,
    59,
    1,
    280,
    102,
    59,
    3,
    55349,
    56636,
    115,
    105,
    108,
    111,
    110,
    59,
    1,
    917,
    117,
    4,
    2,
    97,
    105,
    1624,
    1640,
    108,
    4,
    2,
    59,
    84,
    1631,
    1633,
    1,
    10869,
    105,
    108,
    100,
    101,
    59,
    1,
    8770,
    108,
    105,
    98,
    114,
    105,
    117,
    109,
    59,
    1,
    8652,
    4,
    2,
    99,
    105,
    1656,
    1660,
    114,
    59,
    1,
    8496,
    109,
    59,
    1,
    10867,
    97,
    59,
    1,
    919,
    109,
    108,
    5,
    203,
    1,
    59,
    1675,
    1,
    203,
    4,
    2,
    105,
    112,
    1683,
    1689,
    115,
    116,
    115,
    59,
    1,
    8707,
    111,
    110,
    101,
    110,
    116,
    105,
    97,
    108,
    69,
    59,
    1,
    8519,
    4,
    5,
    99,
    102,
    105,
    111,
    115,
    1713,
    1717,
    1722,
    1762,
    1791,
    121,
    59,
    1,
    1060,
    114,
    59,
    3,
    55349,
    56585,
    108,
    108,
    101,
    100,
    4,
    2,
    83,
    86,
    1732,
    1745,
    109,
    97,
    108,
    108,
    83,
    113,
    117,
    97,
    114,
    101,
    59,
    1,
    9724,
    101,
    114,
    121,
    83,
    109,
    97,
    108,
    108,
    83,
    113,
    117,
    97,
    114,
    101,
    59,
    1,
    9642,
    4,
    3,
    112,
    114,
    117,
    1770,
    1775,
    1781,
    102,
    59,
    3,
    55349,
    56637,
    65,
    108,
    108,
    59,
    1,
    8704,
    114,
    105,
    101,
    114,
    116,
    114,
    102,
    59,
    1,
    8497,
    99,
    114,
    59,
    1,
    8497,
    4,
    12,
    74,
    84,
    97,
    98,
    99,
    100,
    102,
    103,
    111,
    114,
    115,
    116,
    1822,
    1827,
    1834,
    1848,
    1855,
    1877,
    1882,
    1887,
    1890,
    1896,
    1978,
    1984,
    99,
    121,
    59,
    1,
    1027,
    5,
    62,
    1,
    59,
    1832,
    1,
    62,
    109,
    109,
    97,
    4,
    2,
    59,
    100,
    1843,
    1845,
    1,
    915,
    59,
    1,
    988,
    114,
    101,
    118,
    101,
    59,
    1,
    286,
    4,
    3,
    101,
    105,
    121,
    1863,
    1869,
    1874,
    100,
    105,
    108,
    59,
    1,
    290,
    114,
    99,
    59,
    1,
    284,
    59,
    1,
    1043,
    111,
    116,
    59,
    1,
    288,
    114,
    59,
    3,
    55349,
    56586,
    59,
    1,
    8921,
    112,
    102,
    59,
    3,
    55349,
    56638,
    101,
    97,
    116,
    101,
    114,
    4,
    6,
    69,
    70,
    71,
    76,
    83,
    84,
    1915,
    1933,
    1944,
    1953,
    1959,
    1971,
    113,
    117,
    97,
    108,
    4,
    2,
    59,
    76,
    1925,
    1927,
    1,
    8805,
    101,
    115,
    115,
    59,
    1,
    8923,
    117,
    108,
    108,
    69,
    113,
    117,
    97,
    108,
    59,
    1,
    8807,
    114,
    101,
    97,
    116,
    101,
    114,
    59,
    1,
    10914,
    101,
    115,
    115,
    59,
    1,
    8823,
    108,
    97,
    110,
    116,
    69,
    113,
    117,
    97,
    108,
    59,
    1,
    10878,
    105,
    108,
    100,
    101,
    59,
    1,
    8819,
    99,
    114,
    59,
    3,
    55349,
    56482,
    59,
    1,
    8811,
    4,
    8,
    65,
    97,
    99,
    102,
    105,
    111,
    115,
    117,
    2005,
    2012,
    2026,
    2032,
    2036,
    2049,
    2073,
    2089,
    82,
    68,
    99,
    121,
    59,
    1,
    1066,
    4,
    2,
    99,
    116,
    2018,
    2023,
    101,
    107,
    59,
    1,
    711,
    59,
    1,
    94,
    105,
    114,
    99,
    59,
    1,
    292,
    114,
    59,
    1,
    8460,
    108,
    98,
    101,
    114,
    116,
    83,
    112,
    97,
    99,
    101,
    59,
    1,
    8459,
    4,
    2,
    112,
    114,
    2055,
    2059,
    102,
    59,
    1,
    8461,
    105,
    122,
    111,
    110,
    116,
    97,
    108,
    76,
    105,
    110,
    101,
    59,
    1,
    9472,
    4,
    2,
    99,
    116,
    2079,
    2083,
    114,
    59,
    1,
    8459,
    114,
    111,
    107,
    59,
    1,
    294,
    109,
    112,
    4,
    2,
    68,
    69,
    2097,
    2107,
    111,
    119,
    110,
    72,
    117,
    109,
    112,
    59,
    1,
    8782,
    113,
    117,
    97,
    108,
    59,
    1,
    8783,
    4,
    14,
    69,
    74,
    79,
    97,
    99,
    100,
    102,
    103,
    109,
    110,
    111,
    115,
    116,
    117,
    2144,
    2149,
    2155,
    2160,
    2171,
    2189,
    2194,
    2198,
    2209,
    2245,
    2307,
    2329,
    2334,
    2341,
    99,
    121,
    59,
    1,
    1045,
    108,
    105,
    103,
    59,
    1,
    306,
    99,
    121,
    59,
    1,
    1025,
    99,
    117,
    116,
    101,
    5,
    205,
    1,
    59,
    2169,
    1,
    205,
    4,
    2,
    105,
    121,
    2177,
    2186,
    114,
    99,
    5,
    206,
    1,
    59,
    2184,
    1,
    206,
    59,
    1,
    1048,
    111,
    116,
    59,
    1,
    304,
    114,
    59,
    1,
    8465,
    114,
    97,
    118,
    101,
    5,
    204,
    1,
    59,
    2207,
    1,
    204,
    4,
    3,
    59,
    97,
    112,
    2217,
    2219,
    2238,
    1,
    8465,
    4,
    2,
    99,
    103,
    2225,
    2229,
    114,
    59,
    1,
    298,
    105,
    110,
    97,
    114,
    121,
    73,
    59,
    1,
    8520,
    108,
    105,
    101,
    115,
    59,
    1,
    8658,
    4,
    2,
    116,
    118,
    2251,
    2281,
    4,
    2,
    59,
    101,
    2257,
    2259,
    1,
    8748,
    4,
    2,
    103,
    114,
    2265,
    2271,
    114,
    97,
    108,
    59,
    1,
    8747,
    115,
    101,
    99,
    116,
    105,
    111,
    110,
    59,
    1,
    8898,
    105,
    115,
    105,
    98,
    108,
    101,
    4,
    2,
    67,
    84,
    2293,
    2300,
    111,
    109,
    109,
    97,
    59,
    1,
    8291,
    105,
    109,
    101,
    115,
    59,
    1,
    8290,
    4,
    3,
    103,
    112,
    116,
    2315,
    2320,
    2325,
    111,
    110,
    59,
    1,
    302,
    102,
    59,
    3,
    55349,
    56640,
    97,
    59,
    1,
    921,
    99,
    114,
    59,
    1,
    8464,
    105,
    108,
    100,
    101,
    59,
    1,
    296,
    4,
    2,
    107,
    109,
    2347,
    2352,
    99,
    121,
    59,
    1,
    1030,
    108,
    5,
    207,
    1,
    59,
    2358,
    1,
    207,
    4,
    5,
    99,
    102,
    111,
    115,
    117,
    2372,
    2386,
    2391,
    2397,
    2414,
    4,
    2,
    105,
    121,
    2378,
    2383,
    114,
    99,
    59,
    1,
    308,
    59,
    1,
    1049,
    114,
    59,
    3,
    55349,
    56589,
    112,
    102,
    59,
    3,
    55349,
    56641,
    4,
    2,
    99,
    101,
    2403,
    2408,
    114,
    59,
    3,
    55349,
    56485,
    114,
    99,
    121,
    59,
    1,
    1032,
    107,
    99,
    121,
    59,
    1,
    1028,
    4,
    7,
    72,
    74,
    97,
    99,
    102,
    111,
    115,
    2436,
    2441,
    2446,
    2452,
    2467,
    2472,
    2478,
    99,
    121,
    59,
    1,
    1061,
    99,
    121,
    59,
    1,
    1036,
    112,
    112,
    97,
    59,
    1,
    922,
    4,
    2,
    101,
    121,
    2458,
    2464,
    100,
    105,
    108,
    59,
    1,
    310,
    59,
    1,
    1050,
    114,
    59,
    3,
    55349,
    56590,
    112,
    102,
    59,
    3,
    55349,
    56642,
    99,
    114,
    59,
    3,
    55349,
    56486,
    4,
    11,
    74,
    84,
    97,
    99,
    101,
    102,
    108,
    109,
    111,
    115,
    116,
    2508,
    2513,
    2520,
    2562,
    2585,
    2981,
    2986,
    3004,
    3011,
    3146,
    3167,
    99,
    121,
    59,
    1,
    1033,
    5,
    60,
    1,
    59,
    2518,
    1,
    60,
    4,
    5,
    99,
    109,
    110,
    112,
    114,
    2532,
    2538,
    2544,
    2548,
    2558,
    117,
    116,
    101,
    59,
    1,
    313,
    98,
    100,
    97,
    59,
    1,
    923,
    103,
    59,
    1,
    10218,
    108,
    97,
    99,
    101,
    116,
    114,
    102,
    59,
    1,
    8466,
    114,
    59,
    1,
    8606,
    4,
    3,
    97,
    101,
    121,
    2570,
    2576,
    2582,
    114,
    111,
    110,
    59,
    1,
    317,
    100,
    105,
    108,
    59,
    1,
    315,
    59,
    1,
    1051,
    4,
    2,
    102,
    115,
    2591,
    2907,
    116,
    4,
    10,
    65,
    67,
    68,
    70,
    82,
    84,
    85,
    86,
    97,
    114,
    2614,
    2663,
    2672,
    2728,
    2735,
    2760,
    2820,
    2870,
    2888,
    2895,
    4,
    2,
    110,
    114,
    2620,
    2633,
    103,
    108,
    101,
    66,
    114,
    97,
    99,
    107,
    101,
    116,
    59,
    1,
    10216,
    114,
    111,
    119,
    4,
    3,
    59,
    66,
    82,
    2644,
    2646,
    2651,
    1,
    8592,
    97,
    114,
    59,
    1,
    8676,
    105,
    103,
    104,
    116,
    65,
    114,
    114,
    111,
    119,
    59,
    1,
    8646,
    101,
    105,
    108,
    105,
    110,
    103,
    59,
    1,
    8968,
    111,
    4,
    2,
    117,
    119,
    2679,
    2692,
    98,
    108,
    101,
    66,
    114,
    97,
    99,
    107,
    101,
    116,
    59,
    1,
    10214,
    110,
    4,
    2,
    84,
    86,
    2699,
    2710,
    101,
    101,
    86,
    101,
    99,
    116,
    111,
    114,
    59,
    1,
    10593,
    101,
    99,
    116,
    111,
    114,
    4,
    2,
    59,
    66,
    2721,
    2723,
    1,
    8643,
    97,
    114,
    59,
    1,
    10585,
    108,
    111,
    111,
    114,
    59,
    1,
    8970,
    105,
    103,
    104,
    116,
    4,
    2,
    65,
    86,
    2745,
    2752,
    114,
    114,
    111,
    119,
    59,
    1,
    8596,
    101,
    99,
    116,
    111,
    114,
    59,
    1,
    10574,
    4,
    2,
    101,
    114,
    2766,
    2792,
    101,
    4,
    3,
    59,
    65,
    86,
    2775,
    2777,
    2784,
    1,
    8867,
    114,
    114,
    111,
    119,
    59,
    1,
    8612,
    101,
    99,
    116,
    111,
    114,
    59,
    1,
    10586,
    105,
    97,
    110,
    103,
    108,
    101,
    4,
    3,
    59,
    66,
    69,
    2806,
    2808,
    2813,
    1,
    8882,
    97,
    114,
    59,
    1,
    10703,
    113,
    117,
    97,
    108,
    59,
    1,
    8884,
    112,
    4,
    3,
    68,
    84,
    86,
    2829,
    2841,
    2852,
    111,
    119,
    110,
    86,
    101,
    99,
    116,
    111,
    114,
    59,
    1,
    10577,
    101,
    101,
    86,
    101,
    99,
    116,
    111,
    114,
    59,
    1,
    10592,
    101,
    99,
    116,
    111,
    114,
    4,
    2,
    59,
    66,
    2863,
    2865,
    1,
    8639,
    97,
    114,
    59,
    1,
    10584,
    101,
    99,
    116,
    111,
    114,
    4,
    2,
    59,
    66,
    2881,
    2883,
    1,
    8636,
    97,
    114,
    59,
    1,
    10578,
    114,
    114,
    111,
    119,
    59,
    1,
    8656,
    105,
    103,
    104,
    116,
    97,
    114,
    114,
    111,
    119,
    59,
    1,
    8660,
    115,
    4,
    6,
    69,
    70,
    71,
    76,
    83,
    84,
    2922,
    2936,
    2947,
    2956,
    2962,
    2974,
    113,
    117,
    97,
    108,
    71,
    114,
    101,
    97,
    116,
    101,
    114,
    59,
    1,
    8922,
    117,
    108,
    108,
    69,
    113,
    117,
    97,
    108,
    59,
    1,
    8806,
    114,
    101,
    97,
    116,
    101,
    114,
    59,
    1,
    8822,
    101,
    115,
    115,
    59,
    1,
    10913,
    108,
    97,
    110,
    116,
    69,
    113,
    117,
    97,
    108,
    59,
    1,
    10877,
    105,
    108,
    100,
    101,
    59,
    1,
    8818,
    114,
    59,
    3,
    55349,
    56591,
    4,
    2,
    59,
    101,
    2992,
    2994,
    1,
    8920,
    102,
    116,
    97,
    114,
    114,
    111,
    119,
    59,
    1,
    8666,
    105,
    100,
    111,
    116,
    59,
    1,
    319,
    4,
    3,
    110,
    112,
    119,
    3019,
    3110,
    3115,
    103,
    4,
    4,
    76,
    82,
    108,
    114,
    3030,
    3058,
    3070,
    3098,
    101,
    102,
    116,
    4,
    2,
    65,
    82,
    3039,
    3046,
    114,
    114,
    111,
    119,
    59,
    1,
    10229,
    105,
    103,
    104,
    116,
    65,
    114,
    114,
    111,
    119,
    59,
    1,
    10231,
    105,
    103,
    104,
    116,
    65,
    114,
    114,
    111,
    119,
    59,
    1,
    10230,
    101,
    102,
    116,
    4,
    2,
    97,
    114,
    3079,
    3086,
    114,
    114,
    111,
    119,
    59,
    1,
    10232,
    105,
    103,
    104,
    116,
    97,
    114,
    114,
    111,
    119,
    59,
    1,
    10234,
    105,
    103,
    104,
    116,
    97,
    114,
    114,
    111,
    119,
    59,
    1,
    10233,
    102,
    59,
    3,
    55349,
    56643,
    101,
    114,
    4,
    2,
    76,
    82,
    3123,
    3134,
    101,
    102,
    116,
    65,
    114,
    114,
    111,
    119,
    59,
    1,
    8601,
    105,
    103,
    104,
    116,
    65,
    114,
    114,
    111,
    119,
    59,
    1,
    8600,
    4,
    3,
    99,
    104,
    116,
    3154,
    3158,
    3161,
    114,
    59,
    1,
    8466,
    59,
    1,
    8624,
    114,
    111,
    107,
    59,
    1,
    321,
    59,
    1,
    8810,
    4,
    8,
    97,
    99,
    101,
    102,
    105,
    111,
    115,
    117,
    3188,
    3192,
    3196,
    3222,
    3227,
    3237,
    3243,
    3248,
    112,
    59,
    1,
    10501,
    121,
    59,
    1,
    1052,
    4,
    2,
    100,
    108,
    3202,
    3213,
    105,
    117,
    109,
    83,
    112,
    97,
    99,
    101,
    59,
    1,
    8287,
    108,
    105,
    110,
    116,
    114,
    102,
    59,
    1,
    8499,
    114,
    59,
    3,
    55349,
    56592,
    110,
    117,
    115,
    80,
    108,
    117,
    115,
    59,
    1,
    8723,
    112,
    102,
    59,
    3,
    55349,
    56644,
    99,
    114,
    59,
    1,
    8499,
    59,
    1,
    924,
    4,
    9,
    74,
    97,
    99,
    101,
    102,
    111,
    115,
    116,
    117,
    3271,
    3276,
    3283,
    3306,
    3422,
    3427,
    4120,
    4126,
    4137,
    99,
    121,
    59,
    1,
    1034,
    99,
    117,
    116,
    101,
    59,
    1,
    323,
    4,
    3,
    97,
    101,
    121,
    3291,
    3297,
    3303,
    114,
    111,
    110,
    59,
    1,
    327,
    100,
    105,
    108,
    59,
    1,
    325,
    59,
    1,
    1053,
    4,
    3,
    103,
    115,
    119,
    3314,
    3380,
    3415,
    97,
    116,
    105,
    118,
    101,
    4,
    3,
    77,
    84,
    86,
    3327,
    3340,
    3365,
    101,
    100,
    105,
    117,
    109,
    83,
    112,
    97,
    99,
    101,
    59,
    1,
    8203,
    104,
    105,
    4,
    2,
    99,
    110,
    3348,
    3357,
    107,
    83,
    112,
    97,
    99,
    101,
    59,
    1,
    8203,
    83,
    112,
    97,
    99,
    101,
    59,
    1,
    8203,
    101,
    114,
    121,
    84,
    104,
    105,
    110,
    83,
    112,
    97,
    99,
    101,
    59,
    1,
    8203,
    116,
    101,
    100,
    4,
    2,
    71,
    76,
    3389,
    3405,
    114,
    101,
    97,
    116,
    101,
    114,
    71,
    114,
    101,
    97,
    116,
    101,
    114,
    59,
    1,
    8811,
    101,
    115,
    115,
    76,
    101,
    115,
    115,
    59,
    1,
    8810,
    76,
    105,
    110,
    101,
    59,
    1,
    10,
    114,
    59,
    3,
    55349,
    56593,
    4,
    4,
    66,
    110,
    112,
    116,
    3437,
    3444,
    3460,
    3464,
    114,
    101,
    97,
    107,
    59,
    1,
    8288,
    66,
    114,
    101,
    97,
    107,
    105,
    110,
    103,
    83,
    112,
    97,
    99,
    101,
    59,
    1,
    160,
    102,
    59,
    1,
    8469,
    4,
    13,
    59,
    67,
    68,
    69,
    71,
    72,
    76,
    78,
    80,
    82,
    83,
    84,
    86,
    3492,
    3494,
    3517,
    3536,
    3578,
    3657,
    3685,
    3784,
    3823,
    3860,
    3915,
    4066,
    4107,
    1,
    10988,
    4,
    2,
    111,
    117,
    3500,
    3510,
    110,
    103,
    114,
    117,
    101,
    110,
    116,
    59,
    1,
    8802,
    112,
    67,
    97,
    112,
    59,
    1,
    8813,
    111,
    117,
    98,
    108,
    101,
    86,
    101,
    114,
    116,
    105,
    99,
    97,
    108,
    66,
    97,
    114,
    59,
    1,
    8742,
    4,
    3,
    108,
    113,
    120,
    3544,
    3552,
    3571,
    101,
    109,
    101,
    110,
    116,
    59,
    1,
    8713,
    117,
    97,
    108,
    4,
    2,
    59,
    84,
    3561,
    3563,
    1,
    8800,
    105,
    108,
    100,
    101,
    59,
    3,
    8770,
    824,
    105,
    115,
    116,
    115,
    59,
    1,
    8708,
    114,
    101,
    97,
    116,
    101,
    114,
    4,
    7,
    59,
    69,
    70,
    71,
    76,
    83,
    84,
    3600,
    3602,
    3609,
    3621,
    3631,
    3637,
    3650,
    1,
    8815,
    113,
    117,
    97,
    108,
    59,
    1,
    8817,
    117,
    108,
    108,
    69,
    113,
    117,
    97,
    108,
    59,
    3,
    8807,
    824,
    114,
    101,
    97,
    116,
    101,
    114,
    59,
    3,
    8811,
    824,
    101,
    115,
    115,
    59,
    1,
    8825,
    108,
    97,
    110,
    116,
    69,
    113,
    117,
    97,
    108,
    59,
    3,
    10878,
    824,
    105,
    108,
    100,
    101,
    59,
    1,
    8821,
    117,
    109,
    112,
    4,
    2,
    68,
    69,
    3666,
    3677,
    111,
    119,
    110,
    72,
    117,
    109,
    112,
    59,
    3,
    8782,
    824,
    113,
    117,
    97,
    108,
    59,
    3,
    8783,
    824,
    101,
    4,
    2,
    102,
    115,
    3692,
    3724,
    116,
    84,
    114,
    105,
    97,
    110,
    103,
    108,
    101,
    4,
    3,
    59,
    66,
    69,
    3709,
    3711,
    3717,
    1,
    8938,
    97,
    114,
    59,
    3,
    10703,
    824,
    113,
    117,
    97,
    108,
    59,
    1,
    8940,
    115,
    4,
    6,
    59,
    69,
    71,
    76,
    83,
    84,
    3739,
    3741,
    3748,
    3757,
    3764,
    3777,
    1,
    8814,
    113,
    117,
    97,
    108,
    59,
    1,
    8816,
    114,
    101,
    97,
    116,
    101,
    114,
    59,
    1,
    8824,
    101,
    115,
    115,
    59,
    3,
    8810,
    824,
    108,
    97,
    110,
    116,
    69,
    113,
    117,
    97,
    108,
    59,
    3,
    10877,
    824,
    105,
    108,
    100,
    101,
    59,
    1,
    8820,
    101,
    115,
    116,
    101,
    100,
    4,
    2,
    71,
    76,
    3795,
    3812,
    114,
    101,
    97,
    116,
    101,
    114,
    71,
    114,
    101,
    97,
    116,
    101,
    114,
    59,
    3,
    10914,
    824,
    101,
    115,
    115,
    76,
    101,
    115,
    115,
    59,
    3,
    10913,
    824,
    114,
    101,
    99,
    101,
    100,
    101,
    115,
    4,
    3,
    59,
    69,
    83,
    3838,
    3840,
    3848,
    1,
    8832,
    113,
    117,
    97,
    108,
    59,
    3,
    10927,
    824,
    108,
    97,
    110,
    116,
    69,
    113,
    117,
    97,
    108,
    59,
    1,
    8928,
    4,
    2,
    101,
    105,
    3866,
    3881,
    118,
    101,
    114,
    115,
    101,
    69,
    108,
    101,
    109,
    101,
    110,
    116,
    59,
    1,
    8716,
    103,
    104,
    116,
    84,
    114,
    105,
    97,
    110,
    103,
    108,
    101,
    4,
    3,
    59,
    66,
    69,
    3900,
    3902,
    3908,
    1,
    8939,
    97,
    114,
    59,
    3,
    10704,
    824,
    113,
    117,
    97,
    108,
    59,
    1,
    8941,
    4,
    2,
    113,
    117,
    3921,
    3973,
    117,
    97,
    114,
    101,
    83,
    117,
    4,
    2,
    98,
    112,
    3933,
    3952,
    115,
    101,
    116,
    4,
    2,
    59,
    69,
    3942,
    3945,
    3,
    8847,
    824,
    113,
    117,
    97,
    108,
    59,
    1,
    8930,
    101,
    114,
    115,
    101,
    116,
    4,
    2,
    59,
    69,
    3963,
    3966,
    3,
    8848,
    824,
    113,
    117,
    97,
    108,
    59,
    1,
    8931,
    4,
    3,
    98,
    99,
    112,
    3981,
    4e3,
    4045,
    115,
    101,
    116,
    4,
    2,
    59,
    69,
    3990,
    3993,
    3,
    8834,
    8402,
    113,
    117,
    97,
    108,
    59,
    1,
    8840,
    99,
    101,
    101,
    100,
    115,
    4,
    4,
    59,
    69,
    83,
    84,
    4015,
    4017,
    4025,
    4037,
    1,
    8833,
    113,
    117,
    97,
    108,
    59,
    3,
    10928,
    824,
    108,
    97,
    110,
    116,
    69,
    113,
    117,
    97,
    108,
    59,
    1,
    8929,
    105,
    108,
    100,
    101,
    59,
    3,
    8831,
    824,
    101,
    114,
    115,
    101,
    116,
    4,
    2,
    59,
    69,
    4056,
    4059,
    3,
    8835,
    8402,
    113,
    117,
    97,
    108,
    59,
    1,
    8841,
    105,
    108,
    100,
    101,
    4,
    4,
    59,
    69,
    70,
    84,
    4080,
    4082,
    4089,
    4100,
    1,
    8769,
    113,
    117,
    97,
    108,
    59,
    1,
    8772,
    117,
    108,
    108,
    69,
    113,
    117,
    97,
    108,
    59,
    1,
    8775,
    105,
    108,
    100,
    101,
    59,
    1,
    8777,
    101,
    114,
    116,
    105,
    99,
    97,
    108,
    66,
    97,
    114,
    59,
    1,
    8740,
    99,
    114,
    59,
    3,
    55349,
    56489,
    105,
    108,
    100,
    101,
    5,
    209,
    1,
    59,
    4135,
    1,
    209,
    59,
    1,
    925,
    4,
    14,
    69,
    97,
    99,
    100,
    102,
    103,
    109,
    111,
    112,
    114,
    115,
    116,
    117,
    118,
    4170,
    4176,
    4187,
    4205,
    4212,
    4217,
    4228,
    4253,
    4259,
    4292,
    4295,
    4316,
    4337,
    4346,
    108,
    105,
    103,
    59,
    1,
    338,
    99,
    117,
    116,
    101,
    5,
    211,
    1,
    59,
    4185,
    1,
    211,
    4,
    2,
    105,
    121,
    4193,
    4202,
    114,
    99,
    5,
    212,
    1,
    59,
    4200,
    1,
    212,
    59,
    1,
    1054,
    98,
    108,
    97,
    99,
    59,
    1,
    336,
    114,
    59,
    3,
    55349,
    56594,
    114,
    97,
    118,
    101,
    5,
    210,
    1,
    59,
    4226,
    1,
    210,
    4,
    3,
    97,
    101,
    105,
    4236,
    4241,
    4246,
    99,
    114,
    59,
    1,
    332,
    103,
    97,
    59,
    1,
    937,
    99,
    114,
    111,
    110,
    59,
    1,
    927,
    112,
    102,
    59,
    3,
    55349,
    56646,
    101,
    110,
    67,
    117,
    114,
    108,
    121,
    4,
    2,
    68,
    81,
    4272,
    4285,
    111,
    117,
    98,
    108,
    101,
    81,
    117,
    111,
    116,
    101,
    59,
    1,
    8220,
    117,
    111,
    116,
    101,
    59,
    1,
    8216,
    59,
    1,
    10836,
    4,
    2,
    99,
    108,
    4301,
    4306,
    114,
    59,
    3,
    55349,
    56490,
    97,
    115,
    104,
    5,
    216,
    1,
    59,
    4314,
    1,
    216,
    105,
    4,
    2,
    108,
    109,
    4323,
    4332,
    100,
    101,
    5,
    213,
    1,
    59,
    4330,
    1,
    213,
    101,
    115,
    59,
    1,
    10807,
    109,
    108,
    5,
    214,
    1,
    59,
    4344,
    1,
    214,
    101,
    114,
    4,
    2,
    66,
    80,
    4354,
    4380,
    4,
    2,
    97,
    114,
    4360,
    4364,
    114,
    59,
    1,
    8254,
    97,
    99,
    4,
    2,
    101,
    107,
    4372,
    4375,
    59,
    1,
    9182,
    101,
    116,
    59,
    1,
    9140,
    97,
    114,
    101,
    110,
    116,
    104,
    101,
    115,
    105,
    115,
    59,
    1,
    9180,
    4,
    9,
    97,
    99,
    102,
    104,
    105,
    108,
    111,
    114,
    115,
    4413,
    4422,
    4426,
    4431,
    4435,
    4438,
    4448,
    4471,
    4561,
    114,
    116,
    105,
    97,
    108,
    68,
    59,
    1,
    8706,
    121,
    59,
    1,
    1055,
    114,
    59,
    3,
    55349,
    56595,
    105,
    59,
    1,
    934,
    59,
    1,
    928,
    117,
    115,
    77,
    105,
    110,
    117,
    115,
    59,
    1,
    177,
    4,
    2,
    105,
    112,
    4454,
    4467,
    110,
    99,
    97,
    114,
    101,
    112,
    108,
    97,
    110,
    101,
    59,
    1,
    8460,
    102,
    59,
    1,
    8473,
    4,
    4,
    59,
    101,
    105,
    111,
    4481,
    4483,
    4526,
    4531,
    1,
    10939,
    99,
    101,
    100,
    101,
    115,
    4,
    4,
    59,
    69,
    83,
    84,
    4498,
    4500,
    4507,
    4519,
    1,
    8826,
    113,
    117,
    97,
    108,
    59,
    1,
    10927,
    108,
    97,
    110,
    116,
    69,
    113,
    117,
    97,
    108,
    59,
    1,
    8828,
    105,
    108,
    100,
    101,
    59,
    1,
    8830,
    109,
    101,
    59,
    1,
    8243,
    4,
    2,
    100,
    112,
    4537,
    4543,
    117,
    99,
    116,
    59,
    1,
    8719,
    111,
    114,
    116,
    105,
    111,
    110,
    4,
    2,
    59,
    97,
    4555,
    4557,
    1,
    8759,
    108,
    59,
    1,
    8733,
    4,
    2,
    99,
    105,
    4567,
    4572,
    114,
    59,
    3,
    55349,
    56491,
    59,
    1,
    936,
    4,
    4,
    85,
    102,
    111,
    115,
    4585,
    4594,
    4599,
    4604,
    79,
    84,
    5,
    34,
    1,
    59,
    4592,
    1,
    34,
    114,
    59,
    3,
    55349,
    56596,
    112,
    102,
    59,
    1,
    8474,
    99,
    114,
    59,
    3,
    55349,
    56492,
    4,
    12,
    66,
    69,
    97,
    99,
    101,
    102,
    104,
    105,
    111,
    114,
    115,
    117,
    4636,
    4642,
    4650,
    4681,
    4704,
    4763,
    4767,
    4771,
    5047,
    5069,
    5081,
    5094,
    97,
    114,
    114,
    59,
    1,
    10512,
    71,
    5,
    174,
    1,
    59,
    4648,
    1,
    174,
    4,
    3,
    99,
    110,
    114,
    4658,
    4664,
    4668,
    117,
    116,
    101,
    59,
    1,
    340,
    103,
    59,
    1,
    10219,
    114,
    4,
    2,
    59,
    116,
    4675,
    4677,
    1,
    8608,
    108,
    59,
    1,
    10518,
    4,
    3,
    97,
    101,
    121,
    4689,
    4695,
    4701,
    114,
    111,
    110,
    59,
    1,
    344,
    100,
    105,
    108,
    59,
    1,
    342,
    59,
    1,
    1056,
    4,
    2,
    59,
    118,
    4710,
    4712,
    1,
    8476,
    101,
    114,
    115,
    101,
    4,
    2,
    69,
    85,
    4722,
    4748,
    4,
    2,
    108,
    113,
    4728,
    4736,
    101,
    109,
    101,
    110,
    116,
    59,
    1,
    8715,
    117,
    105,
    108,
    105,
    98,
    114,
    105,
    117,
    109,
    59,
    1,
    8651,
    112,
    69,
    113,
    117,
    105,
    108,
    105,
    98,
    114,
    105,
    117,
    109,
    59,
    1,
    10607,
    114,
    59,
    1,
    8476,
    111,
    59,
    1,
    929,
    103,
    104,
    116,
    4,
    8,
    65,
    67,
    68,
    70,
    84,
    85,
    86,
    97,
    4792,
    4840,
    4849,
    4905,
    4912,
    4972,
    5022,
    5040,
    4,
    2,
    110,
    114,
    4798,
    4811,
    103,
    108,
    101,
    66,
    114,
    97,
    99,
    107,
    101,
    116,
    59,
    1,
    10217,
    114,
    111,
    119,
    4,
    3,
    59,
    66,
    76,
    4822,
    4824,
    4829,
    1,
    8594,
    97,
    114,
    59,
    1,
    8677,
    101,
    102,
    116,
    65,
    114,
    114,
    111,
    119,
    59,
    1,
    8644,
    101,
    105,
    108,
    105,
    110,
    103,
    59,
    1,
    8969,
    111,
    4,
    2,
    117,
    119,
    4856,
    4869,
    98,
    108,
    101,
    66,
    114,
    97,
    99,
    107,
    101,
    116,
    59,
    1,
    10215,
    110,
    4,
    2,
    84,
    86,
    4876,
    4887,
    101,
    101,
    86,
    101,
    99,
    116,
    111,
    114,
    59,
    1,
    10589,
    101,
    99,
    116,
    111,
    114,
    4,
    2,
    59,
    66,
    4898,
    4900,
    1,
    8642,
    97,
    114,
    59,
    1,
    10581,
    108,
    111,
    111,
    114,
    59,
    1,
    8971,
    4,
    2,
    101,
    114,
    4918,
    4944,
    101,
    4,
    3,
    59,
    65,
    86,
    4927,
    4929,
    4936,
    1,
    8866,
    114,
    114,
    111,
    119,
    59,
    1,
    8614,
    101,
    99,
    116,
    111,
    114,
    59,
    1,
    10587,
    105,
    97,
    110,
    103,
    108,
    101,
    4,
    3,
    59,
    66,
    69,
    4958,
    4960,
    4965,
    1,
    8883,
    97,
    114,
    59,
    1,
    10704,
    113,
    117,
    97,
    108,
    59,
    1,
    8885,
    112,
    4,
    3,
    68,
    84,
    86,
    4981,
    4993,
    5004,
    111,
    119,
    110,
    86,
    101,
    99,
    116,
    111,
    114,
    59,
    1,
    10575,
    101,
    101,
    86,
    101,
    99,
    116,
    111,
    114,
    59,
    1,
    10588,
    101,
    99,
    116,
    111,
    114,
    4,
    2,
    59,
    66,
    5015,
    5017,
    1,
    8638,
    97,
    114,
    59,
    1,
    10580,
    101,
    99,
    116,
    111,
    114,
    4,
    2,
    59,
    66,
    5033,
    5035,
    1,
    8640,
    97,
    114,
    59,
    1,
    10579,
    114,
    114,
    111,
    119,
    59,
    1,
    8658,
    4,
    2,
    112,
    117,
    5053,
    5057,
    102,
    59,
    1,
    8477,
    110,
    100,
    73,
    109,
    112,
    108,
    105,
    101,
    115,
    59,
    1,
    10608,
    105,
    103,
    104,
    116,
    97,
    114,
    114,
    111,
    119,
    59,
    1,
    8667,
    4,
    2,
    99,
    104,
    5087,
    5091,
    114,
    59,
    1,
    8475,
    59,
    1,
    8625,
    108,
    101,
    68,
    101,
    108,
    97,
    121,
    101,
    100,
    59,
    1,
    10740,
    4,
    13,
    72,
    79,
    97,
    99,
    102,
    104,
    105,
    109,
    111,
    113,
    115,
    116,
    117,
    5134,
    5150,
    5157,
    5164,
    5198,
    5203,
    5259,
    5265,
    5277,
    5283,
    5374,
    5380,
    5385,
    4,
    2,
    67,
    99,
    5140,
    5146,
    72,
    99,
    121,
    59,
    1,
    1065,
    121,
    59,
    1,
    1064,
    70,
    84,
    99,
    121,
    59,
    1,
    1068,
    99,
    117,
    116,
    101,
    59,
    1,
    346,
    4,
    5,
    59,
    97,
    101,
    105,
    121,
    5176,
    5178,
    5184,
    5190,
    5195,
    1,
    10940,
    114,
    111,
    110,
    59,
    1,
    352,
    100,
    105,
    108,
    59,
    1,
    350,
    114,
    99,
    59,
    1,
    348,
    59,
    1,
    1057,
    114,
    59,
    3,
    55349,
    56598,
    111,
    114,
    116,
    4,
    4,
    68,
    76,
    82,
    85,
    5216,
    5227,
    5238,
    5250,
    111,
    119,
    110,
    65,
    114,
    114,
    111,
    119,
    59,
    1,
    8595,
    101,
    102,
    116,
    65,
    114,
    114,
    111,
    119,
    59,
    1,
    8592,
    105,
    103,
    104,
    116,
    65,
    114,
    114,
    111,
    119,
    59,
    1,
    8594,
    112,
    65,
    114,
    114,
    111,
    119,
    59,
    1,
    8593,
    103,
    109,
    97,
    59,
    1,
    931,
    97,
    108,
    108,
    67,
    105,
    114,
    99,
    108,
    101,
    59,
    1,
    8728,
    112,
    102,
    59,
    3,
    55349,
    56650,
    4,
    2,
    114,
    117,
    5289,
    5293,
    116,
    59,
    1,
    8730,
    97,
    114,
    101,
    4,
    4,
    59,
    73,
    83,
    85,
    5306,
    5308,
    5322,
    5367,
    1,
    9633,
    110,
    116,
    101,
    114,
    115,
    101,
    99,
    116,
    105,
    111,
    110,
    59,
    1,
    8851,
    117,
    4,
    2,
    98,
    112,
    5329,
    5347,
    115,
    101,
    116,
    4,
    2,
    59,
    69,
    5338,
    5340,
    1,
    8847,
    113,
    117,
    97,
    108,
    59,
    1,
    8849,
    101,
    114,
    115,
    101,
    116,
    4,
    2,
    59,
    69,
    5358,
    5360,
    1,
    8848,
    113,
    117,
    97,
    108,
    59,
    1,
    8850,
    110,
    105,
    111,
    110,
    59,
    1,
    8852,
    99,
    114,
    59,
    3,
    55349,
    56494,
    97,
    114,
    59,
    1,
    8902,
    4,
    4,
    98,
    99,
    109,
    112,
    5395,
    5420,
    5475,
    5478,
    4,
    2,
    59,
    115,
    5401,
    5403,
    1,
    8912,
    101,
    116,
    4,
    2,
    59,
    69,
    5411,
    5413,
    1,
    8912,
    113,
    117,
    97,
    108,
    59,
    1,
    8838,
    4,
    2,
    99,
    104,
    5426,
    5468,
    101,
    101,
    100,
    115,
    4,
    4,
    59,
    69,
    83,
    84,
    5440,
    5442,
    5449,
    5461,
    1,
    8827,
    113,
    117,
    97,
    108,
    59,
    1,
    10928,
    108,
    97,
    110,
    116,
    69,
    113,
    117,
    97,
    108,
    59,
    1,
    8829,
    105,
    108,
    100,
    101,
    59,
    1,
    8831,
    84,
    104,
    97,
    116,
    59,
    1,
    8715,
    59,
    1,
    8721,
    4,
    3,
    59,
    101,
    115,
    5486,
    5488,
    5507,
    1,
    8913,
    114,
    115,
    101,
    116,
    4,
    2,
    59,
    69,
    5498,
    5500,
    1,
    8835,
    113,
    117,
    97,
    108,
    59,
    1,
    8839,
    101,
    116,
    59,
    1,
    8913,
    4,
    11,
    72,
    82,
    83,
    97,
    99,
    102,
    104,
    105,
    111,
    114,
    115,
    5536,
    5546,
    5552,
    5567,
    5579,
    5602,
    5607,
    5655,
    5695,
    5701,
    5711,
    79,
    82,
    78,
    5,
    222,
    1,
    59,
    5544,
    1,
    222,
    65,
    68,
    69,
    59,
    1,
    8482,
    4,
    2,
    72,
    99,
    5558,
    5563,
    99,
    121,
    59,
    1,
    1035,
    121,
    59,
    1,
    1062,
    4,
    2,
    98,
    117,
    5573,
    5576,
    59,
    1,
    9,
    59,
    1,
    932,
    4,
    3,
    97,
    101,
    121,
    5587,
    5593,
    5599,
    114,
    111,
    110,
    59,
    1,
    356,
    100,
    105,
    108,
    59,
    1,
    354,
    59,
    1,
    1058,
    114,
    59,
    3,
    55349,
    56599,
    4,
    2,
    101,
    105,
    5613,
    5631,
    4,
    2,
    114,
    116,
    5619,
    5627,
    101,
    102,
    111,
    114,
    101,
    59,
    1,
    8756,
    97,
    59,
    1,
    920,
    4,
    2,
    99,
    110,
    5637,
    5647,
    107,
    83,
    112,
    97,
    99,
    101,
    59,
    3,
    8287,
    8202,
    83,
    112,
    97,
    99,
    101,
    59,
    1,
    8201,
    108,
    100,
    101,
    4,
    4,
    59,
    69,
    70,
    84,
    5668,
    5670,
    5677,
    5688,
    1,
    8764,
    113,
    117,
    97,
    108,
    59,
    1,
    8771,
    117,
    108,
    108,
    69,
    113,
    117,
    97,
    108,
    59,
    1,
    8773,
    105,
    108,
    100,
    101,
    59,
    1,
    8776,
    112,
    102,
    59,
    3,
    55349,
    56651,
    105,
    112,
    108,
    101,
    68,
    111,
    116,
    59,
    1,
    8411,
    4,
    2,
    99,
    116,
    5717,
    5722,
    114,
    59,
    3,
    55349,
    56495,
    114,
    111,
    107,
    59,
    1,
    358,
    4,
    14,
    97,
    98,
    99,
    100,
    102,
    103,
    109,
    110,
    111,
    112,
    114,
    115,
    116,
    117,
    5758,
    5789,
    5805,
    5823,
    5830,
    5835,
    5846,
    5852,
    5921,
    5937,
    6089,
    6095,
    6101,
    6108,
    4,
    2,
    99,
    114,
    5764,
    5774,
    117,
    116,
    101,
    5,
    218,
    1,
    59,
    5772,
    1,
    218,
    114,
    4,
    2,
    59,
    111,
    5781,
    5783,
    1,
    8607,
    99,
    105,
    114,
    59,
    1,
    10569,
    114,
    4,
    2,
    99,
    101,
    5796,
    5800,
    121,
    59,
    1,
    1038,
    118,
    101,
    59,
    1,
    364,
    4,
    2,
    105,
    121,
    5811,
    5820,
    114,
    99,
    5,
    219,
    1,
    59,
    5818,
    1,
    219,
    59,
    1,
    1059,
    98,
    108,
    97,
    99,
    59,
    1,
    368,
    114,
    59,
    3,
    55349,
    56600,
    114,
    97,
    118,
    101,
    5,
    217,
    1,
    59,
    5844,
    1,
    217,
    97,
    99,
    114,
    59,
    1,
    362,
    4,
    2,
    100,
    105,
    5858,
    5905,
    101,
    114,
    4,
    2,
    66,
    80,
    5866,
    5892,
    4,
    2,
    97,
    114,
    5872,
    5876,
    114,
    59,
    1,
    95,
    97,
    99,
    4,
    2,
    101,
    107,
    5884,
    5887,
    59,
    1,
    9183,
    101,
    116,
    59,
    1,
    9141,
    97,
    114,
    101,
    110,
    116,
    104,
    101,
    115,
    105,
    115,
    59,
    1,
    9181,
    111,
    110,
    4,
    2,
    59,
    80,
    5913,
    5915,
    1,
    8899,
    108,
    117,
    115,
    59,
    1,
    8846,
    4,
    2,
    103,
    112,
    5927,
    5932,
    111,
    110,
    59,
    1,
    370,
    102,
    59,
    3,
    55349,
    56652,
    4,
    8,
    65,
    68,
    69,
    84,
    97,
    100,
    112,
    115,
    5955,
    5985,
    5996,
    6009,
    6026,
    6033,
    6044,
    6075,
    114,
    114,
    111,
    119,
    4,
    3,
    59,
    66,
    68,
    5967,
    5969,
    5974,
    1,
    8593,
    97,
    114,
    59,
    1,
    10514,
    111,
    119,
    110,
    65,
    114,
    114,
    111,
    119,
    59,
    1,
    8645,
    111,
    119,
    110,
    65,
    114,
    114,
    111,
    119,
    59,
    1,
    8597,
    113,
    117,
    105,
    108,
    105,
    98,
    114,
    105,
    117,
    109,
    59,
    1,
    10606,
    101,
    101,
    4,
    2,
    59,
    65,
    6017,
    6019,
    1,
    8869,
    114,
    114,
    111,
    119,
    59,
    1,
    8613,
    114,
    114,
    111,
    119,
    59,
    1,
    8657,
    111,
    119,
    110,
    97,
    114,
    114,
    111,
    119,
    59,
    1,
    8661,
    101,
    114,
    4,
    2,
    76,
    82,
    6052,
    6063,
    101,
    102,
    116,
    65,
    114,
    114,
    111,
    119,
    59,
    1,
    8598,
    105,
    103,
    104,
    116,
    65,
    114,
    114,
    111,
    119,
    59,
    1,
    8599,
    105,
    4,
    2,
    59,
    108,
    6082,
    6084,
    1,
    978,
    111,
    110,
    59,
    1,
    933,
    105,
    110,
    103,
    59,
    1,
    366,
    99,
    114,
    59,
    3,
    55349,
    56496,
    105,
    108,
    100,
    101,
    59,
    1,
    360,
    109,
    108,
    5,
    220,
    1,
    59,
    6115,
    1,
    220,
    4,
    9,
    68,
    98,
    99,
    100,
    101,
    102,
    111,
    115,
    118,
    6137,
    6143,
    6148,
    6152,
    6166,
    6250,
    6255,
    6261,
    6267,
    97,
    115,
    104,
    59,
    1,
    8875,
    97,
    114,
    59,
    1,
    10987,
    121,
    59,
    1,
    1042,
    97,
    115,
    104,
    4,
    2,
    59,
    108,
    6161,
    6163,
    1,
    8873,
    59,
    1,
    10982,
    4,
    2,
    101,
    114,
    6172,
    6175,
    59,
    1,
    8897,
    4,
    3,
    98,
    116,
    121,
    6183,
    6188,
    6238,
    97,
    114,
    59,
    1,
    8214,
    4,
    2,
    59,
    105,
    6194,
    6196,
    1,
    8214,
    99,
    97,
    108,
    4,
    4,
    66,
    76,
    83,
    84,
    6209,
    6214,
    6220,
    6231,
    97,
    114,
    59,
    1,
    8739,
    105,
    110,
    101,
    59,
    1,
    124,
    101,
    112,
    97,
    114,
    97,
    116,
    111,
    114,
    59,
    1,
    10072,
    105,
    108,
    100,
    101,
    59,
    1,
    8768,
    84,
    104,
    105,
    110,
    83,
    112,
    97,
    99,
    101,
    59,
    1,
    8202,
    114,
    59,
    3,
    55349,
    56601,
    112,
    102,
    59,
    3,
    55349,
    56653,
    99,
    114,
    59,
    3,
    55349,
    56497,
    100,
    97,
    115,
    104,
    59,
    1,
    8874,
    4,
    5,
    99,
    101,
    102,
    111,
    115,
    6286,
    6292,
    6298,
    6303,
    6309,
    105,
    114,
    99,
    59,
    1,
    372,
    100,
    103,
    101,
    59,
    1,
    8896,
    114,
    59,
    3,
    55349,
    56602,
    112,
    102,
    59,
    3,
    55349,
    56654,
    99,
    114,
    59,
    3,
    55349,
    56498,
    4,
    4,
    102,
    105,
    111,
    115,
    6325,
    6330,
    6333,
    6339,
    114,
    59,
    3,
    55349,
    56603,
    59,
    1,
    926,
    112,
    102,
    59,
    3,
    55349,
    56655,
    99,
    114,
    59,
    3,
    55349,
    56499,
    4,
    9,
    65,
    73,
    85,
    97,
    99,
    102,
    111,
    115,
    117,
    6365,
    6370,
    6375,
    6380,
    6391,
    6405,
    6410,
    6416,
    6422,
    99,
    121,
    59,
    1,
    1071,
    99,
    121,
    59,
    1,
    1031,
    99,
    121,
    59,
    1,
    1070,
    99,
    117,
    116,
    101,
    5,
    221,
    1,
    59,
    6389,
    1,
    221,
    4,
    2,
    105,
    121,
    6397,
    6402,
    114,
    99,
    59,
    1,
    374,
    59,
    1,
    1067,
    114,
    59,
    3,
    55349,
    56604,
    112,
    102,
    59,
    3,
    55349,
    56656,
    99,
    114,
    59,
    3,
    55349,
    56500,
    109,
    108,
    59,
    1,
    376,
    4,
    8,
    72,
    97,
    99,
    100,
    101,
    102,
    111,
    115,
    6445,
    6450,
    6457,
    6472,
    6477,
    6501,
    6505,
    6510,
    99,
    121,
    59,
    1,
    1046,
    99,
    117,
    116,
    101,
    59,
    1,
    377,
    4,
    2,
    97,
    121,
    6463,
    6469,
    114,
    111,
    110,
    59,
    1,
    381,
    59,
    1,
    1047,
    111,
    116,
    59,
    1,
    379,
    4,
    2,
    114,
    116,
    6483,
    6497,
    111,
    87,
    105,
    100,
    116,
    104,
    83,
    112,
    97,
    99,
    101,
    59,
    1,
    8203,
    97,
    59,
    1,
    918,
    114,
    59,
    1,
    8488,
    112,
    102,
    59,
    1,
    8484,
    99,
    114,
    59,
    3,
    55349,
    56501,
    4,
    16,
    97,
    98,
    99,
    101,
    102,
    103,
    108,
    109,
    110,
    111,
    112,
    114,
    115,
    116,
    117,
    119,
    6550,
    6561,
    6568,
    6612,
    6622,
    6634,
    6645,
    6672,
    6699,
    6854,
    6870,
    6923,
    6933,
    6963,
    6974,
    6983,
    99,
    117,
    116,
    101,
    5,
    225,
    1,
    59,
    6559,
    1,
    225,
    114,
    101,
    118,
    101,
    59,
    1,
    259,
    4,
    6,
    59,
    69,
    100,
    105,
    117,
    121,
    6582,
    6584,
    6588,
    6591,
    6600,
    6609,
    1,
    8766,
    59,
    3,
    8766,
    819,
    59,
    1,
    8767,
    114,
    99,
    5,
    226,
    1,
    59,
    6598,
    1,
    226,
    116,
    101,
    5,
    180,
    1,
    59,
    6607,
    1,
    180,
    59,
    1,
    1072,
    108,
    105,
    103,
    5,
    230,
    1,
    59,
    6620,
    1,
    230,
    4,
    2,
    59,
    114,
    6628,
    6630,
    1,
    8289,
    59,
    3,
    55349,
    56606,
    114,
    97,
    118,
    101,
    5,
    224,
    1,
    59,
    6643,
    1,
    224,
    4,
    2,
    101,
    112,
    6651,
    6667,
    4,
    2,
    102,
    112,
    6657,
    6663,
    115,
    121,
    109,
    59,
    1,
    8501,
    104,
    59,
    1,
    8501,
    104,
    97,
    59,
    1,
    945,
    4,
    2,
    97,
    112,
    6678,
    6692,
    4,
    2,
    99,
    108,
    6684,
    6688,
    114,
    59,
    1,
    257,
    103,
    59,
    1,
    10815,
    5,
    38,
    1,
    59,
    6697,
    1,
    38,
    4,
    2,
    100,
    103,
    6705,
    6737,
    4,
    5,
    59,
    97,
    100,
    115,
    118,
    6717,
    6719,
    6724,
    6727,
    6734,
    1,
    8743,
    110,
    100,
    59,
    1,
    10837,
    59,
    1,
    10844,
    108,
    111,
    112,
    101,
    59,
    1,
    10840,
    59,
    1,
    10842,
    4,
    7,
    59,
    101,
    108,
    109,
    114,
    115,
    122,
    6753,
    6755,
    6758,
    6762,
    6814,
    6835,
    6848,
    1,
    8736,
    59,
    1,
    10660,
    101,
    59,
    1,
    8736,
    115,
    100,
    4,
    2,
    59,
    97,
    6770,
    6772,
    1,
    8737,
    4,
    8,
    97,
    98,
    99,
    100,
    101,
    102,
    103,
    104,
    6790,
    6793,
    6796,
    6799,
    6802,
    6805,
    6808,
    6811,
    59,
    1,
    10664,
    59,
    1,
    10665,
    59,
    1,
    10666,
    59,
    1,
    10667,
    59,
    1,
    10668,
    59,
    1,
    10669,
    59,
    1,
    10670,
    59,
    1,
    10671,
    116,
    4,
    2,
    59,
    118,
    6821,
    6823,
    1,
    8735,
    98,
    4,
    2,
    59,
    100,
    6830,
    6832,
    1,
    8894,
    59,
    1,
    10653,
    4,
    2,
    112,
    116,
    6841,
    6845,
    104,
    59,
    1,
    8738,
    59,
    1,
    197,
    97,
    114,
    114,
    59,
    1,
    9084,
    4,
    2,
    103,
    112,
    6860,
    6865,
    111,
    110,
    59,
    1,
    261,
    102,
    59,
    3,
    55349,
    56658,
    4,
    7,
    59,
    69,
    97,
    101,
    105,
    111,
    112,
    6886,
    6888,
    6891,
    6897,
    6900,
    6904,
    6908,
    1,
    8776,
    59,
    1,
    10864,
    99,
    105,
    114,
    59,
    1,
    10863,
    59,
    1,
    8778,
    100,
    59,
    1,
    8779,
    115,
    59,
    1,
    39,
    114,
    111,
    120,
    4,
    2,
    59,
    101,
    6917,
    6919,
    1,
    8776,
    113,
    59,
    1,
    8778,
    105,
    110,
    103,
    5,
    229,
    1,
    59,
    6931,
    1,
    229,
    4,
    3,
    99,
    116,
    121,
    6941,
    6946,
    6949,
    114,
    59,
    3,
    55349,
    56502,
    59,
    1,
    42,
    109,
    112,
    4,
    2,
    59,
    101,
    6957,
    6959,
    1,
    8776,
    113,
    59,
    1,
    8781,
    105,
    108,
    100,
    101,
    5,
    227,
    1,
    59,
    6972,
    1,
    227,
    109,
    108,
    5,
    228,
    1,
    59,
    6981,
    1,
    228,
    4,
    2,
    99,
    105,
    6989,
    6997,
    111,
    110,
    105,
    110,
    116,
    59,
    1,
    8755,
    110,
    116,
    59,
    1,
    10769,
    4,
    16,
    78,
    97,
    98,
    99,
    100,
    101,
    102,
    105,
    107,
    108,
    110,
    111,
    112,
    114,
    115,
    117,
    7036,
    7041,
    7119,
    7135,
    7149,
    7155,
    7219,
    7224,
    7347,
    7354,
    7463,
    7489,
    7786,
    7793,
    7814,
    7866,
    111,
    116,
    59,
    1,
    10989,
    4,
    2,
    99,
    114,
    7047,
    7094,
    107,
    4,
    4,
    99,
    101,
    112,
    115,
    7058,
    7064,
    7073,
    7080,
    111,
    110,
    103,
    59,
    1,
    8780,
    112,
    115,
    105,
    108,
    111,
    110,
    59,
    1,
    1014,
    114,
    105,
    109,
    101,
    59,
    1,
    8245,
    105,
    109,
    4,
    2,
    59,
    101,
    7088,
    7090,
    1,
    8765,
    113,
    59,
    1,
    8909,
    4,
    2,
    118,
    119,
    7100,
    7105,
    101,
    101,
    59,
    1,
    8893,
    101,
    100,
    4,
    2,
    59,
    103,
    7113,
    7115,
    1,
    8965,
    101,
    59,
    1,
    8965,
    114,
    107,
    4,
    2,
    59,
    116,
    7127,
    7129,
    1,
    9141,
    98,
    114,
    107,
    59,
    1,
    9142,
    4,
    2,
    111,
    121,
    7141,
    7146,
    110,
    103,
    59,
    1,
    8780,
    59,
    1,
    1073,
    113,
    117,
    111,
    59,
    1,
    8222,
    4,
    5,
    99,
    109,
    112,
    114,
    116,
    7167,
    7181,
    7188,
    7193,
    7199,
    97,
    117,
    115,
    4,
    2,
    59,
    101,
    7176,
    7178,
    1,
    8757,
    59,
    1,
    8757,
    112,
    116,
    121,
    118,
    59,
    1,
    10672,
    115,
    105,
    59,
    1,
    1014,
    110,
    111,
    117,
    59,
    1,
    8492,
    4,
    3,
    97,
    104,
    119,
    7207,
    7210,
    7213,
    59,
    1,
    946,
    59,
    1,
    8502,
    101,
    101,
    110,
    59,
    1,
    8812,
    114,
    59,
    3,
    55349,
    56607,
    103,
    4,
    7,
    99,
    111,
    115,
    116,
    117,
    118,
    119,
    7241,
    7262,
    7288,
    7305,
    7328,
    7335,
    7340,
    4,
    3,
    97,
    105,
    117,
    7249,
    7253,
    7258,
    112,
    59,
    1,
    8898,
    114,
    99,
    59,
    1,
    9711,
    112,
    59,
    1,
    8899,
    4,
    3,
    100,
    112,
    116,
    7270,
    7275,
    7281,
    111,
    116,
    59,
    1,
    10752,
    108,
    117,
    115,
    59,
    1,
    10753,
    105,
    109,
    101,
    115,
    59,
    1,
    10754,
    4,
    2,
    113,
    116,
    7294,
    7300,
    99,
    117,
    112,
    59,
    1,
    10758,
    97,
    114,
    59,
    1,
    9733,
    114,
    105,
    97,
    110,
    103,
    108,
    101,
    4,
    2,
    100,
    117,
    7318,
    7324,
    111,
    119,
    110,
    59,
    1,
    9661,
    112,
    59,
    1,
    9651,
    112,
    108,
    117,
    115,
    59,
    1,
    10756,
    101,
    101,
    59,
    1,
    8897,
    101,
    100,
    103,
    101,
    59,
    1,
    8896,
    97,
    114,
    111,
    119,
    59,
    1,
    10509,
    4,
    3,
    97,
    107,
    111,
    7362,
    7436,
    7458,
    4,
    2,
    99,
    110,
    7368,
    7432,
    107,
    4,
    3,
    108,
    115,
    116,
    7377,
    7386,
    7394,
    111,
    122,
    101,
    110,
    103,
    101,
    59,
    1,
    10731,
    113,
    117,
    97,
    114,
    101,
    59,
    1,
    9642,
    114,
    105,
    97,
    110,
    103,
    108,
    101,
    4,
    4,
    59,
    100,
    108,
    114,
    7411,
    7413,
    7419,
    7425,
    1,
    9652,
    111,
    119,
    110,
    59,
    1,
    9662,
    101,
    102,
    116,
    59,
    1,
    9666,
    105,
    103,
    104,
    116,
    59,
    1,
    9656,
    107,
    59,
    1,
    9251,
    4,
    2,
    49,
    51,
    7442,
    7454,
    4,
    2,
    50,
    52,
    7448,
    7451,
    59,
    1,
    9618,
    59,
    1,
    9617,
    52,
    59,
    1,
    9619,
    99,
    107,
    59,
    1,
    9608,
    4,
    2,
    101,
    111,
    7469,
    7485,
    4,
    2,
    59,
    113,
    7475,
    7478,
    3,
    61,
    8421,
    117,
    105,
    118,
    59,
    3,
    8801,
    8421,
    116,
    59,
    1,
    8976,
    4,
    4,
    112,
    116,
    119,
    120,
    7499,
    7504,
    7517,
    7523,
    102,
    59,
    3,
    55349,
    56659,
    4,
    2,
    59,
    116,
    7510,
    7512,
    1,
    8869,
    111,
    109,
    59,
    1,
    8869,
    116,
    105,
    101,
    59,
    1,
    8904,
    4,
    12,
    68,
    72,
    85,
    86,
    98,
    100,
    104,
    109,
    112,
    116,
    117,
    118,
    7549,
    7571,
    7597,
    7619,
    7655,
    7660,
    7682,
    7708,
    7715,
    7721,
    7728,
    7750,
    4,
    4,
    76,
    82,
    108,
    114,
    7559,
    7562,
    7565,
    7568,
    59,
    1,
    9559,
    59,
    1,
    9556,
    59,
    1,
    9558,
    59,
    1,
    9555,
    4,
    5,
    59,
    68,
    85,
    100,
    117,
    7583,
    7585,
    7588,
    7591,
    7594,
    1,
    9552,
    59,
    1,
    9574,
    59,
    1,
    9577,
    59,
    1,
    9572,
    59,
    1,
    9575,
    4,
    4,
    76,
    82,
    108,
    114,
    7607,
    7610,
    7613,
    7616,
    59,
    1,
    9565,
    59,
    1,
    9562,
    59,
    1,
    9564,
    59,
    1,
    9561,
    4,
    7,
    59,
    72,
    76,
    82,
    104,
    108,
    114,
    7635,
    7637,
    7640,
    7643,
    7646,
    7649,
    7652,
    1,
    9553,
    59,
    1,
    9580,
    59,
    1,
    9571,
    59,
    1,
    9568,
    59,
    1,
    9579,
    59,
    1,
    9570,
    59,
    1,
    9567,
    111,
    120,
    59,
    1,
    10697,
    4,
    4,
    76,
    82,
    108,
    114,
    7670,
    7673,
    7676,
    7679,
    59,
    1,
    9557,
    59,
    1,
    9554,
    59,
    1,
    9488,
    59,
    1,
    9484,
    4,
    5,
    59,
    68,
    85,
    100,
    117,
    7694,
    7696,
    7699,
    7702,
    7705,
    1,
    9472,
    59,
    1,
    9573,
    59,
    1,
    9576,
    59,
    1,
    9516,
    59,
    1,
    9524,
    105,
    110,
    117,
    115,
    59,
    1,
    8863,
    108,
    117,
    115,
    59,
    1,
    8862,
    105,
    109,
    101,
    115,
    59,
    1,
    8864,
    4,
    4,
    76,
    82,
    108,
    114,
    7738,
    7741,
    7744,
    7747,
    59,
    1,
    9563,
    59,
    1,
    9560,
    59,
    1,
    9496,
    59,
    1,
    9492,
    4,
    7,
    59,
    72,
    76,
    82,
    104,
    108,
    114,
    7766,
    7768,
    7771,
    7774,
    7777,
    7780,
    7783,
    1,
    9474,
    59,
    1,
    9578,
    59,
    1,
    9569,
    59,
    1,
    9566,
    59,
    1,
    9532,
    59,
    1,
    9508,
    59,
    1,
    9500,
    114,
    105,
    109,
    101,
    59,
    1,
    8245,
    4,
    2,
    101,
    118,
    7799,
    7804,
    118,
    101,
    59,
    1,
    728,
    98,
    97,
    114,
    5,
    166,
    1,
    59,
    7812,
    1,
    166,
    4,
    4,
    99,
    101,
    105,
    111,
    7824,
    7829,
    7834,
    7846,
    114,
    59,
    3,
    55349,
    56503,
    109,
    105,
    59,
    1,
    8271,
    109,
    4,
    2,
    59,
    101,
    7841,
    7843,
    1,
    8765,
    59,
    1,
    8909,
    108,
    4,
    3,
    59,
    98,
    104,
    7855,
    7857,
    7860,
    1,
    92,
    59,
    1,
    10693,
    115,
    117,
    98,
    59,
    1,
    10184,
    4,
    2,
    108,
    109,
    7872,
    7885,
    108,
    4,
    2,
    59,
    101,
    7879,
    7881,
    1,
    8226,
    116,
    59,
    1,
    8226,
    112,
    4,
    3,
    59,
    69,
    101,
    7894,
    7896,
    7899,
    1,
    8782,
    59,
    1,
    10926,
    4,
    2,
    59,
    113,
    7905,
    7907,
    1,
    8783,
    59,
    1,
    8783,
    4,
    15,
    97,
    99,
    100,
    101,
    102,
    104,
    105,
    108,
    111,
    114,
    115,
    116,
    117,
    119,
    121,
    7942,
    8021,
    8075,
    8080,
    8121,
    8126,
    8157,
    8279,
    8295,
    8430,
    8446,
    8485,
    8491,
    8707,
    8726,
    4,
    3,
    99,
    112,
    114,
    7950,
    7956,
    8007,
    117,
    116,
    101,
    59,
    1,
    263,
    4,
    6,
    59,
    97,
    98,
    99,
    100,
    115,
    7970,
    7972,
    7977,
    7984,
    7998,
    8003,
    1,
    8745,
    110,
    100,
    59,
    1,
    10820,
    114,
    99,
    117,
    112,
    59,
    1,
    10825,
    4,
    2,
    97,
    117,
    7990,
    7994,
    112,
    59,
    1,
    10827,
    112,
    59,
    1,
    10823,
    111,
    116,
    59,
    1,
    10816,
    59,
    3,
    8745,
    65024,
    4,
    2,
    101,
    111,
    8013,
    8017,
    116,
    59,
    1,
    8257,
    110,
    59,
    1,
    711,
    4,
    4,
    97,
    101,
    105,
    117,
    8031,
    8046,
    8056,
    8061,
    4,
    2,
    112,
    114,
    8037,
    8041,
    115,
    59,
    1,
    10829,
    111,
    110,
    59,
    1,
    269,
    100,
    105,
    108,
    5,
    231,
    1,
    59,
    8054,
    1,
    231,
    114,
    99,
    59,
    1,
    265,
    112,
    115,
    4,
    2,
    59,
    115,
    8069,
    8071,
    1,
    10828,
    109,
    59,
    1,
    10832,
    111,
    116,
    59,
    1,
    267,
    4,
    3,
    100,
    109,
    110,
    8088,
    8097,
    8104,
    105,
    108,
    5,
    184,
    1,
    59,
    8095,
    1,
    184,
    112,
    116,
    121,
    118,
    59,
    1,
    10674,
    116,
    5,
    162,
    2,
    59,
    101,
    8112,
    8114,
    1,
    162,
    114,
    100,
    111,
    116,
    59,
    1,
    183,
    114,
    59,
    3,
    55349,
    56608,
    4,
    3,
    99,
    101,
    105,
    8134,
    8138,
    8154,
    121,
    59,
    1,
    1095,
    99,
    107,
    4,
    2,
    59,
    109,
    8146,
    8148,
    1,
    10003,
    97,
    114,
    107,
    59,
    1,
    10003,
    59,
    1,
    967,
    114,
    4,
    7,
    59,
    69,
    99,
    101,
    102,
    109,
    115,
    8174,
    8176,
    8179,
    8258,
    8261,
    8268,
    8273,
    1,
    9675,
    59,
    1,
    10691,
    4,
    3,
    59,
    101,
    108,
    8187,
    8189,
    8193,
    1,
    710,
    113,
    59,
    1,
    8791,
    101,
    4,
    2,
    97,
    100,
    8200,
    8223,
    114,
    114,
    111,
    119,
    4,
    2,
    108,
    114,
    8210,
    8216,
    101,
    102,
    116,
    59,
    1,
    8634,
    105,
    103,
    104,
    116,
    59,
    1,
    8635,
    4,
    5,
    82,
    83,
    97,
    99,
    100,
    8235,
    8238,
    8241,
    8246,
    8252,
    59,
    1,
    174,
    59,
    1,
    9416,
    115,
    116,
    59,
    1,
    8859,
    105,
    114,
    99,
    59,
    1,
    8858,
    97,
    115,
    104,
    59,
    1,
    8861,
    59,
    1,
    8791,
    110,
    105,
    110,
    116,
    59,
    1,
    10768,
    105,
    100,
    59,
    1,
    10991,
    99,
    105,
    114,
    59,
    1,
    10690,
    117,
    98,
    115,
    4,
    2,
    59,
    117,
    8288,
    8290,
    1,
    9827,
    105,
    116,
    59,
    1,
    9827,
    4,
    4,
    108,
    109,
    110,
    112,
    8305,
    8326,
    8376,
    8400,
    111,
    110,
    4,
    2,
    59,
    101,
    8313,
    8315,
    1,
    58,
    4,
    2,
    59,
    113,
    8321,
    8323,
    1,
    8788,
    59,
    1,
    8788,
    4,
    2,
    109,
    112,
    8332,
    8344,
    97,
    4,
    2,
    59,
    116,
    8339,
    8341,
    1,
    44,
    59,
    1,
    64,
    4,
    3,
    59,
    102,
    108,
    8352,
    8354,
    8358,
    1,
    8705,
    110,
    59,
    1,
    8728,
    101,
    4,
    2,
    109,
    120,
    8365,
    8371,
    101,
    110,
    116,
    59,
    1,
    8705,
    101,
    115,
    59,
    1,
    8450,
    4,
    2,
    103,
    105,
    8382,
    8395,
    4,
    2,
    59,
    100,
    8388,
    8390,
    1,
    8773,
    111,
    116,
    59,
    1,
    10861,
    110,
    116,
    59,
    1,
    8750,
    4,
    3,
    102,
    114,
    121,
    8408,
    8412,
    8417,
    59,
    3,
    55349,
    56660,
    111,
    100,
    59,
    1,
    8720,
    5,
    169,
    2,
    59,
    115,
    8424,
    8426,
    1,
    169,
    114,
    59,
    1,
    8471,
    4,
    2,
    97,
    111,
    8436,
    8441,
    114,
    114,
    59,
    1,
    8629,
    115,
    115,
    59,
    1,
    10007,
    4,
    2,
    99,
    117,
    8452,
    8457,
    114,
    59,
    3,
    55349,
    56504,
    4,
    2,
    98,
    112,
    8463,
    8474,
    4,
    2,
    59,
    101,
    8469,
    8471,
    1,
    10959,
    59,
    1,
    10961,
    4,
    2,
    59,
    101,
    8480,
    8482,
    1,
    10960,
    59,
    1,
    10962,
    100,
    111,
    116,
    59,
    1,
    8943,
    4,
    7,
    100,
    101,
    108,
    112,
    114,
    118,
    119,
    8507,
    8522,
    8536,
    8550,
    8600,
    8697,
    8702,
    97,
    114,
    114,
    4,
    2,
    108,
    114,
    8516,
    8519,
    59,
    1,
    10552,
    59,
    1,
    10549,
    4,
    2,
    112,
    115,
    8528,
    8532,
    114,
    59,
    1,
    8926,
    99,
    59,
    1,
    8927,
    97,
    114,
    114,
    4,
    2,
    59,
    112,
    8545,
    8547,
    1,
    8630,
    59,
    1,
    10557,
    4,
    6,
    59,
    98,
    99,
    100,
    111,
    115,
    8564,
    8566,
    8573,
    8587,
    8592,
    8596,
    1,
    8746,
    114,
    99,
    97,
    112,
    59,
    1,
    10824,
    4,
    2,
    97,
    117,
    8579,
    8583,
    112,
    59,
    1,
    10822,
    112,
    59,
    1,
    10826,
    111,
    116,
    59,
    1,
    8845,
    114,
    59,
    1,
    10821,
    59,
    3,
    8746,
    65024,
    4,
    4,
    97,
    108,
    114,
    118,
    8610,
    8623,
    8663,
    8672,
    114,
    114,
    4,
    2,
    59,
    109,
    8618,
    8620,
    1,
    8631,
    59,
    1,
    10556,
    121,
    4,
    3,
    101,
    118,
    119,
    8632,
    8651,
    8656,
    113,
    4,
    2,
    112,
    115,
    8639,
    8645,
    114,
    101,
    99,
    59,
    1,
    8926,
    117,
    99,
    99,
    59,
    1,
    8927,
    101,
    101,
    59,
    1,
    8910,
    101,
    100,
    103,
    101,
    59,
    1,
    8911,
    101,
    110,
    5,
    164,
    1,
    59,
    8670,
    1,
    164,
    101,
    97,
    114,
    114,
    111,
    119,
    4,
    2,
    108,
    114,
    8684,
    8690,
    101,
    102,
    116,
    59,
    1,
    8630,
    105,
    103,
    104,
    116,
    59,
    1,
    8631,
    101,
    101,
    59,
    1,
    8910,
    101,
    100,
    59,
    1,
    8911,
    4,
    2,
    99,
    105,
    8713,
    8721,
    111,
    110,
    105,
    110,
    116,
    59,
    1,
    8754,
    110,
    116,
    59,
    1,
    8753,
    108,
    99,
    116,
    121,
    59,
    1,
    9005,
    4,
    19,
    65,
    72,
    97,
    98,
    99,
    100,
    101,
    102,
    104,
    105,
    106,
    108,
    111,
    114,
    115,
    116,
    117,
    119,
    122,
    8773,
    8778,
    8783,
    8821,
    8839,
    8854,
    8887,
    8914,
    8930,
    8944,
    9036,
    9041,
    9058,
    9197,
    9227,
    9258,
    9281,
    9297,
    9305,
    114,
    114,
    59,
    1,
    8659,
    97,
    114,
    59,
    1,
    10597,
    4,
    4,
    103,
    108,
    114,
    115,
    8793,
    8799,
    8805,
    8809,
    103,
    101,
    114,
    59,
    1,
    8224,
    101,
    116,
    104,
    59,
    1,
    8504,
    114,
    59,
    1,
    8595,
    104,
    4,
    2,
    59,
    118,
    8816,
    8818,
    1,
    8208,
    59,
    1,
    8867,
    4,
    2,
    107,
    108,
    8827,
    8834,
    97,
    114,
    111,
    119,
    59,
    1,
    10511,
    97,
    99,
    59,
    1,
    733,
    4,
    2,
    97,
    121,
    8845,
    8851,
    114,
    111,
    110,
    59,
    1,
    271,
    59,
    1,
    1076,
    4,
    3,
    59,
    97,
    111,
    8862,
    8864,
    8880,
    1,
    8518,
    4,
    2,
    103,
    114,
    8870,
    8876,
    103,
    101,
    114,
    59,
    1,
    8225,
    114,
    59,
    1,
    8650,
    116,
    115,
    101,
    113,
    59,
    1,
    10871,
    4,
    3,
    103,
    108,
    109,
    8895,
    8902,
    8907,
    5,
    176,
    1,
    59,
    8900,
    1,
    176,
    116,
    97,
    59,
    1,
    948,
    112,
    116,
    121,
    118,
    59,
    1,
    10673,
    4,
    2,
    105,
    114,
    8920,
    8926,
    115,
    104,
    116,
    59,
    1,
    10623,
    59,
    3,
    55349,
    56609,
    97,
    114,
    4,
    2,
    108,
    114,
    8938,
    8941,
    59,
    1,
    8643,
    59,
    1,
    8642,
    4,
    5,
    97,
    101,
    103,
    115,
    118,
    8956,
    8986,
    8989,
    8996,
    9001,
    109,
    4,
    3,
    59,
    111,
    115,
    8965,
    8967,
    8983,
    1,
    8900,
    110,
    100,
    4,
    2,
    59,
    115,
    8975,
    8977,
    1,
    8900,
    117,
    105,
    116,
    59,
    1,
    9830,
    59,
    1,
    9830,
    59,
    1,
    168,
    97,
    109,
    109,
    97,
    59,
    1,
    989,
    105,
    110,
    59,
    1,
    8946,
    4,
    3,
    59,
    105,
    111,
    9009,
    9011,
    9031,
    1,
    247,
    100,
    101,
    5,
    247,
    2,
    59,
    111,
    9020,
    9022,
    1,
    247,
    110,
    116,
    105,
    109,
    101,
    115,
    59,
    1,
    8903,
    110,
    120,
    59,
    1,
    8903,
    99,
    121,
    59,
    1,
    1106,
    99,
    4,
    2,
    111,
    114,
    9048,
    9053,
    114,
    110,
    59,
    1,
    8990,
    111,
    112,
    59,
    1,
    8973,
    4,
    5,
    108,
    112,
    116,
    117,
    119,
    9070,
    9076,
    9081,
    9130,
    9144,
    108,
    97,
    114,
    59,
    1,
    36,
    102,
    59,
    3,
    55349,
    56661,
    4,
    5,
    59,
    101,
    109,
    112,
    115,
    9093,
    9095,
    9109,
    9116,
    9122,
    1,
    729,
    113,
    4,
    2,
    59,
    100,
    9102,
    9104,
    1,
    8784,
    111,
    116,
    59,
    1,
    8785,
    105,
    110,
    117,
    115,
    59,
    1,
    8760,
    108,
    117,
    115,
    59,
    1,
    8724,
    113,
    117,
    97,
    114,
    101,
    59,
    1,
    8865,
    98,
    108,
    101,
    98,
    97,
    114,
    119,
    101,
    100,
    103,
    101,
    59,
    1,
    8966,
    110,
    4,
    3,
    97,
    100,
    104,
    9153,
    9160,
    9172,
    114,
    114,
    111,
    119,
    59,
    1,
    8595,
    111,
    119,
    110,
    97,
    114,
    114,
    111,
    119,
    115,
    59,
    1,
    8650,
    97,
    114,
    112,
    111,
    111,
    110,
    4,
    2,
    108,
    114,
    9184,
    9190,
    101,
    102,
    116,
    59,
    1,
    8643,
    105,
    103,
    104,
    116,
    59,
    1,
    8642,
    4,
    2,
    98,
    99,
    9203,
    9211,
    107,
    97,
    114,
    111,
    119,
    59,
    1,
    10512,
    4,
    2,
    111,
    114,
    9217,
    9222,
    114,
    110,
    59,
    1,
    8991,
    111,
    112,
    59,
    1,
    8972,
    4,
    3,
    99,
    111,
    116,
    9235,
    9248,
    9252,
    4,
    2,
    114,
    121,
    9241,
    9245,
    59,
    3,
    55349,
    56505,
    59,
    1,
    1109,
    108,
    59,
    1,
    10742,
    114,
    111,
    107,
    59,
    1,
    273,
    4,
    2,
    100,
    114,
    9264,
    9269,
    111,
    116,
    59,
    1,
    8945,
    105,
    4,
    2,
    59,
    102,
    9276,
    9278,
    1,
    9663,
    59,
    1,
    9662,
    4,
    2,
    97,
    104,
    9287,
    9292,
    114,
    114,
    59,
    1,
    8693,
    97,
    114,
    59,
    1,
    10607,
    97,
    110,
    103,
    108,
    101,
    59,
    1,
    10662,
    4,
    2,
    99,
    105,
    9311,
    9315,
    121,
    59,
    1,
    1119,
    103,
    114,
    97,
    114,
    114,
    59,
    1,
    10239,
    4,
    18,
    68,
    97,
    99,
    100,
    101,
    102,
    103,
    108,
    109,
    110,
    111,
    112,
    113,
    114,
    115,
    116,
    117,
    120,
    9361,
    9376,
    9398,
    9439,
    9444,
    9447,
    9462,
    9495,
    9531,
    9585,
    9598,
    9614,
    9659,
    9755,
    9771,
    9792,
    9808,
    9826,
    4,
    2,
    68,
    111,
    9367,
    9372,
    111,
    116,
    59,
    1,
    10871,
    116,
    59,
    1,
    8785,
    4,
    2,
    99,
    115,
    9382,
    9392,
    117,
    116,
    101,
    5,
    233,
    1,
    59,
    9390,
    1,
    233,
    116,
    101,
    114,
    59,
    1,
    10862,
    4,
    4,
    97,
    105,
    111,
    121,
    9408,
    9414,
    9430,
    9436,
    114,
    111,
    110,
    59,
    1,
    283,
    114,
    4,
    2,
    59,
    99,
    9421,
    9423,
    1,
    8790,
    5,
    234,
    1,
    59,
    9428,
    1,
    234,
    108,
    111,
    110,
    59,
    1,
    8789,
    59,
    1,
    1101,
    111,
    116,
    59,
    1,
    279,
    59,
    1,
    8519,
    4,
    2,
    68,
    114,
    9453,
    9458,
    111,
    116,
    59,
    1,
    8786,
    59,
    3,
    55349,
    56610,
    4,
    3,
    59,
    114,
    115,
    9470,
    9472,
    9482,
    1,
    10906,
    97,
    118,
    101,
    5,
    232,
    1,
    59,
    9480,
    1,
    232,
    4,
    2,
    59,
    100,
    9488,
    9490,
    1,
    10902,
    111,
    116,
    59,
    1,
    10904,
    4,
    4,
    59,
    105,
    108,
    115,
    9505,
    9507,
    9515,
    9518,
    1,
    10905,
    110,
    116,
    101,
    114,
    115,
    59,
    1,
    9191,
    59,
    1,
    8467,
    4,
    2,
    59,
    100,
    9524,
    9526,
    1,
    10901,
    111,
    116,
    59,
    1,
    10903,
    4,
    3,
    97,
    112,
    115,
    9539,
    9544,
    9564,
    99,
    114,
    59,
    1,
    275,
    116,
    121,
    4,
    3,
    59,
    115,
    118,
    9554,
    9556,
    9561,
    1,
    8709,
    101,
    116,
    59,
    1,
    8709,
    59,
    1,
    8709,
    112,
    4,
    2,
    49,
    59,
    9571,
    9583,
    4,
    2,
    51,
    52,
    9577,
    9580,
    59,
    1,
    8196,
    59,
    1,
    8197,
    1,
    8195,
    4,
    2,
    103,
    115,
    9591,
    9594,
    59,
    1,
    331,
    112,
    59,
    1,
    8194,
    4,
    2,
    103,
    112,
    9604,
    9609,
    111,
    110,
    59,
    1,
    281,
    102,
    59,
    3,
    55349,
    56662,
    4,
    3,
    97,
    108,
    115,
    9622,
    9635,
    9640,
    114,
    4,
    2,
    59,
    115,
    9629,
    9631,
    1,
    8917,
    108,
    59,
    1,
    10723,
    117,
    115,
    59,
    1,
    10865,
    105,
    4,
    3,
    59,
    108,
    118,
    9649,
    9651,
    9656,
    1,
    949,
    111,
    110,
    59,
    1,
    949,
    59,
    1,
    1013,
    4,
    4,
    99,
    115,
    117,
    118,
    9669,
    9686,
    9716,
    9747,
    4,
    2,
    105,
    111,
    9675,
    9680,
    114,
    99,
    59,
    1,
    8790,
    108,
    111,
    110,
    59,
    1,
    8789,
    4,
    2,
    105,
    108,
    9692,
    9696,
    109,
    59,
    1,
    8770,
    97,
    110,
    116,
    4,
    2,
    103,
    108,
    9705,
    9710,
    116,
    114,
    59,
    1,
    10902,
    101,
    115,
    115,
    59,
    1,
    10901,
    4,
    3,
    97,
    101,
    105,
    9724,
    9729,
    9734,
    108,
    115,
    59,
    1,
    61,
    115,
    116,
    59,
    1,
    8799,
    118,
    4,
    2,
    59,
    68,
    9741,
    9743,
    1,
    8801,
    68,
    59,
    1,
    10872,
    112,
    97,
    114,
    115,
    108,
    59,
    1,
    10725,
    4,
    2,
    68,
    97,
    9761,
    9766,
    111,
    116,
    59,
    1,
    8787,
    114,
    114,
    59,
    1,
    10609,
    4,
    3,
    99,
    100,
    105,
    9779,
    9783,
    9788,
    114,
    59,
    1,
    8495,
    111,
    116,
    59,
    1,
    8784,
    109,
    59,
    1,
    8770,
    4,
    2,
    97,
    104,
    9798,
    9801,
    59,
    1,
    951,
    5,
    240,
    1,
    59,
    9806,
    1,
    240,
    4,
    2,
    109,
    114,
    9814,
    9822,
    108,
    5,
    235,
    1,
    59,
    9820,
    1,
    235,
    111,
    59,
    1,
    8364,
    4,
    3,
    99,
    105,
    112,
    9834,
    9838,
    9843,
    108,
    59,
    1,
    33,
    115,
    116,
    59,
    1,
    8707,
    4,
    2,
    101,
    111,
    9849,
    9859,
    99,
    116,
    97,
    116,
    105,
    111,
    110,
    59,
    1,
    8496,
    110,
    101,
    110,
    116,
    105,
    97,
    108,
    101,
    59,
    1,
    8519,
    4,
    12,
    97,
    99,
    101,
    102,
    105,
    106,
    108,
    110,
    111,
    112,
    114,
    115,
    9896,
    9910,
    9914,
    9921,
    9954,
    9960,
    9967,
    9989,
    9994,
    10027,
    10036,
    10164,
    108,
    108,
    105,
    110,
    103,
    100,
    111,
    116,
    115,
    101,
    113,
    59,
    1,
    8786,
    121,
    59,
    1,
    1092,
    109,
    97,
    108,
    101,
    59,
    1,
    9792,
    4,
    3,
    105,
    108,
    114,
    9929,
    9935,
    9950,
    108,
    105,
    103,
    59,
    1,
    64259,
    4,
    2,
    105,
    108,
    9941,
    9945,
    103,
    59,
    1,
    64256,
    105,
    103,
    59,
    1,
    64260,
    59,
    3,
    55349,
    56611,
    108,
    105,
    103,
    59,
    1,
    64257,
    108,
    105,
    103,
    59,
    3,
    102,
    106,
    4,
    3,
    97,
    108,
    116,
    9975,
    9979,
    9984,
    116,
    59,
    1,
    9837,
    105,
    103,
    59,
    1,
    64258,
    110,
    115,
    59,
    1,
    9649,
    111,
    102,
    59,
    1,
    402,
    4,
    2,
    112,
    114,
    1e4,
    10005,
    102,
    59,
    3,
    55349,
    56663,
    4,
    2,
    97,
    107,
    10011,
    10016,
    108,
    108,
    59,
    1,
    8704,
    4,
    2,
    59,
    118,
    10022,
    10024,
    1,
    8916,
    59,
    1,
    10969,
    97,
    114,
    116,
    105,
    110,
    116,
    59,
    1,
    10765,
    4,
    2,
    97,
    111,
    10042,
    10159,
    4,
    2,
    99,
    115,
    10048,
    10155,
    4,
    6,
    49,
    50,
    51,
    52,
    53,
    55,
    10062,
    10102,
    10114,
    10135,
    10139,
    10151,
    4,
    6,
    50,
    51,
    52,
    53,
    54,
    56,
    10076,
    10083,
    10086,
    10093,
    10096,
    10099,
    5,
    189,
    1,
    59,
    10081,
    1,
    189,
    59,
    1,
    8531,
    5,
    188,
    1,
    59,
    10091,
    1,
    188,
    59,
    1,
    8533,
    59,
    1,
    8537,
    59,
    1,
    8539,
    4,
    2,
    51,
    53,
    10108,
    10111,
    59,
    1,
    8532,
    59,
    1,
    8534,
    4,
    3,
    52,
    53,
    56,
    10122,
    10129,
    10132,
    5,
    190,
    1,
    59,
    10127,
    1,
    190,
    59,
    1,
    8535,
    59,
    1,
    8540,
    53,
    59,
    1,
    8536,
    4,
    2,
    54,
    56,
    10145,
    10148,
    59,
    1,
    8538,
    59,
    1,
    8541,
    56,
    59,
    1,
    8542,
    108,
    59,
    1,
    8260,
    119,
    110,
    59,
    1,
    8994,
    99,
    114,
    59,
    3,
    55349,
    56507,
    4,
    17,
    69,
    97,
    98,
    99,
    100,
    101,
    102,
    103,
    105,
    106,
    108,
    110,
    111,
    114,
    115,
    116,
    118,
    10206,
    10217,
    10247,
    10254,
    10268,
    10273,
    10358,
    10363,
    10374,
    10380,
    10385,
    10406,
    10458,
    10464,
    10470,
    10497,
    10610,
    4,
    2,
    59,
    108,
    10212,
    10214,
    1,
    8807,
    59,
    1,
    10892,
    4,
    3,
    99,
    109,
    112,
    10225,
    10231,
    10244,
    117,
    116,
    101,
    59,
    1,
    501,
    109,
    97,
    4,
    2,
    59,
    100,
    10239,
    10241,
    1,
    947,
    59,
    1,
    989,
    59,
    1,
    10886,
    114,
    101,
    118,
    101,
    59,
    1,
    287,
    4,
    2,
    105,
    121,
    10260,
    10265,
    114,
    99,
    59,
    1,
    285,
    59,
    1,
    1075,
    111,
    116,
    59,
    1,
    289,
    4,
    4,
    59,
    108,
    113,
    115,
    10283,
    10285,
    10288,
    10308,
    1,
    8805,
    59,
    1,
    8923,
    4,
    3,
    59,
    113,
    115,
    10296,
    10298,
    10301,
    1,
    8805,
    59,
    1,
    8807,
    108,
    97,
    110,
    116,
    59,
    1,
    10878,
    4,
    4,
    59,
    99,
    100,
    108,
    10318,
    10320,
    10324,
    10345,
    1,
    10878,
    99,
    59,
    1,
    10921,
    111,
    116,
    4,
    2,
    59,
    111,
    10332,
    10334,
    1,
    10880,
    4,
    2,
    59,
    108,
    10340,
    10342,
    1,
    10882,
    59,
    1,
    10884,
    4,
    2,
    59,
    101,
    10351,
    10354,
    3,
    8923,
    65024,
    115,
    59,
    1,
    10900,
    114,
    59,
    3,
    55349,
    56612,
    4,
    2,
    59,
    103,
    10369,
    10371,
    1,
    8811,
    59,
    1,
    8921,
    109,
    101,
    108,
    59,
    1,
    8503,
    99,
    121,
    59,
    1,
    1107,
    4,
    4,
    59,
    69,
    97,
    106,
    10395,
    10397,
    10400,
    10403,
    1,
    8823,
    59,
    1,
    10898,
    59,
    1,
    10917,
    59,
    1,
    10916,
    4,
    4,
    69,
    97,
    101,
    115,
    10416,
    10419,
    10434,
    10453,
    59,
    1,
    8809,
    112,
    4,
    2,
    59,
    112,
    10426,
    10428,
    1,
    10890,
    114,
    111,
    120,
    59,
    1,
    10890,
    4,
    2,
    59,
    113,
    10440,
    10442,
    1,
    10888,
    4,
    2,
    59,
    113,
    10448,
    10450,
    1,
    10888,
    59,
    1,
    8809,
    105,
    109,
    59,
    1,
    8935,
    112,
    102,
    59,
    3,
    55349,
    56664,
    97,
    118,
    101,
    59,
    1,
    96,
    4,
    2,
    99,
    105,
    10476,
    10480,
    114,
    59,
    1,
    8458,
    109,
    4,
    3,
    59,
    101,
    108,
    10489,
    10491,
    10494,
    1,
    8819,
    59,
    1,
    10894,
    59,
    1,
    10896,
    5,
    62,
    6,
    59,
    99,
    100,
    108,
    113,
    114,
    10512,
    10514,
    10527,
    10532,
    10538,
    10545,
    1,
    62,
    4,
    2,
    99,
    105,
    10520,
    10523,
    59,
    1,
    10919,
    114,
    59,
    1,
    10874,
    111,
    116,
    59,
    1,
    8919,
    80,
    97,
    114,
    59,
    1,
    10645,
    117,
    101,
    115,
    116,
    59,
    1,
    10876,
    4,
    5,
    97,
    100,
    101,
    108,
    115,
    10557,
    10574,
    10579,
    10599,
    10605,
    4,
    2,
    112,
    114,
    10563,
    10570,
    112,
    114,
    111,
    120,
    59,
    1,
    10886,
    114,
    59,
    1,
    10616,
    111,
    116,
    59,
    1,
    8919,
    113,
    4,
    2,
    108,
    113,
    10586,
    10592,
    101,
    115,
    115,
    59,
    1,
    8923,
    108,
    101,
    115,
    115,
    59,
    1,
    10892,
    101,
    115,
    115,
    59,
    1,
    8823,
    105,
    109,
    59,
    1,
    8819,
    4,
    2,
    101,
    110,
    10616,
    10626,
    114,
    116,
    110,
    101,
    113,
    113,
    59,
    3,
    8809,
    65024,
    69,
    59,
    3,
    8809,
    65024,
    4,
    10,
    65,
    97,
    98,
    99,
    101,
    102,
    107,
    111,
    115,
    121,
    10653,
    10658,
    10713,
    10718,
    10724,
    10760,
    10765,
    10786,
    10850,
    10875,
    114,
    114,
    59,
    1,
    8660,
    4,
    4,
    105,
    108,
    109,
    114,
    10668,
    10674,
    10678,
    10684,
    114,
    115,
    112,
    59,
    1,
    8202,
    102,
    59,
    1,
    189,
    105,
    108,
    116,
    59,
    1,
    8459,
    4,
    2,
    100,
    114,
    10690,
    10695,
    99,
    121,
    59,
    1,
    1098,
    4,
    3,
    59,
    99,
    119,
    10703,
    10705,
    10710,
    1,
    8596,
    105,
    114,
    59,
    1,
    10568,
    59,
    1,
    8621,
    97,
    114,
    59,
    1,
    8463,
    105,
    114,
    99,
    59,
    1,
    293,
    4,
    3,
    97,
    108,
    114,
    10732,
    10748,
    10754,
    114,
    116,
    115,
    4,
    2,
    59,
    117,
    10741,
    10743,
    1,
    9829,
    105,
    116,
    59,
    1,
    9829,
    108,
    105,
    112,
    59,
    1,
    8230,
    99,
    111,
    110,
    59,
    1,
    8889,
    114,
    59,
    3,
    55349,
    56613,
    115,
    4,
    2,
    101,
    119,
    10772,
    10779,
    97,
    114,
    111,
    119,
    59,
    1,
    10533,
    97,
    114,
    111,
    119,
    59,
    1,
    10534,
    4,
    5,
    97,
    109,
    111,
    112,
    114,
    10798,
    10803,
    10809,
    10839,
    10844,
    114,
    114,
    59,
    1,
    8703,
    116,
    104,
    116,
    59,
    1,
    8763,
    107,
    4,
    2,
    108,
    114,
    10816,
    10827,
    101,
    102,
    116,
    97,
    114,
    114,
    111,
    119,
    59,
    1,
    8617,
    105,
    103,
    104,
    116,
    97,
    114,
    114,
    111,
    119,
    59,
    1,
    8618,
    102,
    59,
    3,
    55349,
    56665,
    98,
    97,
    114,
    59,
    1,
    8213,
    4,
    3,
    99,
    108,
    116,
    10858,
    10863,
    10869,
    114,
    59,
    3,
    55349,
    56509,
    97,
    115,
    104,
    59,
    1,
    8463,
    114,
    111,
    107,
    59,
    1,
    295,
    4,
    2,
    98,
    112,
    10881,
    10887,
    117,
    108,
    108,
    59,
    1,
    8259,
    104,
    101,
    110,
    59,
    1,
    8208,
    4,
    15,
    97,
    99,
    101,
    102,
    103,
    105,
    106,
    109,
    110,
    111,
    112,
    113,
    115,
    116,
    117,
    10925,
    10936,
    10958,
    10977,
    10990,
    11001,
    11039,
    11045,
    11101,
    11192,
    11220,
    11226,
    11237,
    11285,
    11299,
    99,
    117,
    116,
    101,
    5,
    237,
    1,
    59,
    10934,
    1,
    237,
    4,
    3,
    59,
    105,
    121,
    10944,
    10946,
    10955,
    1,
    8291,
    114,
    99,
    5,
    238,
    1,
    59,
    10953,
    1,
    238,
    59,
    1,
    1080,
    4,
    2,
    99,
    120,
    10964,
    10968,
    121,
    59,
    1,
    1077,
    99,
    108,
    5,
    161,
    1,
    59,
    10975,
    1,
    161,
    4,
    2,
    102,
    114,
    10983,
    10986,
    59,
    1,
    8660,
    59,
    3,
    55349,
    56614,
    114,
    97,
    118,
    101,
    5,
    236,
    1,
    59,
    10999,
    1,
    236,
    4,
    4,
    59,
    105,
    110,
    111,
    11011,
    11013,
    11028,
    11034,
    1,
    8520,
    4,
    2,
    105,
    110,
    11019,
    11024,
    110,
    116,
    59,
    1,
    10764,
    116,
    59,
    1,
    8749,
    102,
    105,
    110,
    59,
    1,
    10716,
    116,
    97,
    59,
    1,
    8489,
    108,
    105,
    103,
    59,
    1,
    307,
    4,
    3,
    97,
    111,
    112,
    11053,
    11092,
    11096,
    4,
    3,
    99,
    103,
    116,
    11061,
    11065,
    11088,
    114,
    59,
    1,
    299,
    4,
    3,
    101,
    108,
    112,
    11073,
    11076,
    11082,
    59,
    1,
    8465,
    105,
    110,
    101,
    59,
    1,
    8464,
    97,
    114,
    116,
    59,
    1,
    8465,
    104,
    59,
    1,
    305,
    102,
    59,
    1,
    8887,
    101,
    100,
    59,
    1,
    437,
    4,
    5,
    59,
    99,
    102,
    111,
    116,
    11113,
    11115,
    11121,
    11136,
    11142,
    1,
    8712,
    97,
    114,
    101,
    59,
    1,
    8453,
    105,
    110,
    4,
    2,
    59,
    116,
    11129,
    11131,
    1,
    8734,
    105,
    101,
    59,
    1,
    10717,
    100,
    111,
    116,
    59,
    1,
    305,
    4,
    5,
    59,
    99,
    101,
    108,
    112,
    11154,
    11156,
    11161,
    11179,
    11186,
    1,
    8747,
    97,
    108,
    59,
    1,
    8890,
    4,
    2,
    103,
    114,
    11167,
    11173,
    101,
    114,
    115,
    59,
    1,
    8484,
    99,
    97,
    108,
    59,
    1,
    8890,
    97,
    114,
    104,
    107,
    59,
    1,
    10775,
    114,
    111,
    100,
    59,
    1,
    10812,
    4,
    4,
    99,
    103,
    112,
    116,
    11202,
    11206,
    11211,
    11216,
    121,
    59,
    1,
    1105,
    111,
    110,
    59,
    1,
    303,
    102,
    59,
    3,
    55349,
    56666,
    97,
    59,
    1,
    953,
    114,
    111,
    100,
    59,
    1,
    10812,
    117,
    101,
    115,
    116,
    5,
    191,
    1,
    59,
    11235,
    1,
    191,
    4,
    2,
    99,
    105,
    11243,
    11248,
    114,
    59,
    3,
    55349,
    56510,
    110,
    4,
    5,
    59,
    69,
    100,
    115,
    118,
    11261,
    11263,
    11266,
    11271,
    11282,
    1,
    8712,
    59,
    1,
    8953,
    111,
    116,
    59,
    1,
    8949,
    4,
    2,
    59,
    118,
    11277,
    11279,
    1,
    8948,
    59,
    1,
    8947,
    59,
    1,
    8712,
    4,
    2,
    59,
    105,
    11291,
    11293,
    1,
    8290,
    108,
    100,
    101,
    59,
    1,
    297,
    4,
    2,
    107,
    109,
    11305,
    11310,
    99,
    121,
    59,
    1,
    1110,
    108,
    5,
    239,
    1,
    59,
    11316,
    1,
    239,
    4,
    6,
    99,
    102,
    109,
    111,
    115,
    117,
    11332,
    11346,
    11351,
    11357,
    11363,
    11380,
    4,
    2,
    105,
    121,
    11338,
    11343,
    114,
    99,
    59,
    1,
    309,
    59,
    1,
    1081,
    114,
    59,
    3,
    55349,
    56615,
    97,
    116,
    104,
    59,
    1,
    567,
    112,
    102,
    59,
    3,
    55349,
    56667,
    4,
    2,
    99,
    101,
    11369,
    11374,
    114,
    59,
    3,
    55349,
    56511,
    114,
    99,
    121,
    59,
    1,
    1112,
    107,
    99,
    121,
    59,
    1,
    1108,
    4,
    8,
    97,
    99,
    102,
    103,
    104,
    106,
    111,
    115,
    11404,
    11418,
    11433,
    11438,
    11445,
    11450,
    11455,
    11461,
    112,
    112,
    97,
    4,
    2,
    59,
    118,
    11413,
    11415,
    1,
    954,
    59,
    1,
    1008,
    4,
    2,
    101,
    121,
    11424,
    11430,
    100,
    105,
    108,
    59,
    1,
    311,
    59,
    1,
    1082,
    114,
    59,
    3,
    55349,
    56616,
    114,
    101,
    101,
    110,
    59,
    1,
    312,
    99,
    121,
    59,
    1,
    1093,
    99,
    121,
    59,
    1,
    1116,
    112,
    102,
    59,
    3,
    55349,
    56668,
    99,
    114,
    59,
    3,
    55349,
    56512,
    4,
    23,
    65,
    66,
    69,
    72,
    97,
    98,
    99,
    100,
    101,
    102,
    103,
    104,
    106,
    108,
    109,
    110,
    111,
    112,
    114,
    115,
    116,
    117,
    118,
    11515,
    11538,
    11544,
    11555,
    11560,
    11721,
    11780,
    11818,
    11868,
    12136,
    12160,
    12171,
    12203,
    12208,
    12246,
    12275,
    12327,
    12509,
    12523,
    12569,
    12641,
    12732,
    12752,
    4,
    3,
    97,
    114,
    116,
    11523,
    11528,
    11532,
    114,
    114,
    59,
    1,
    8666,
    114,
    59,
    1,
    8656,
    97,
    105,
    108,
    59,
    1,
    10523,
    97,
    114,
    114,
    59,
    1,
    10510,
    4,
    2,
    59,
    103,
    11550,
    11552,
    1,
    8806,
    59,
    1,
    10891,
    97,
    114,
    59,
    1,
    10594,
    4,
    9,
    99,
    101,
    103,
    109,
    110,
    112,
    113,
    114,
    116,
    11580,
    11586,
    11594,
    11600,
    11606,
    11624,
    11627,
    11636,
    11694,
    117,
    116,
    101,
    59,
    1,
    314,
    109,
    112,
    116,
    121,
    118,
    59,
    1,
    10676,
    114,
    97,
    110,
    59,
    1,
    8466,
    98,
    100,
    97,
    59,
    1,
    955,
    103,
    4,
    3,
    59,
    100,
    108,
    11615,
    11617,
    11620,
    1,
    10216,
    59,
    1,
    10641,
    101,
    59,
    1,
    10216,
    59,
    1,
    10885,
    117,
    111,
    5,
    171,
    1,
    59,
    11634,
    1,
    171,
    114,
    4,
    8,
    59,
    98,
    102,
    104,
    108,
    112,
    115,
    116,
    11655,
    11657,
    11669,
    11673,
    11677,
    11681,
    11685,
    11690,
    1,
    8592,
    4,
    2,
    59,
    102,
    11663,
    11665,
    1,
    8676,
    115,
    59,
    1,
    10527,
    115,
    59,
    1,
    10525,
    107,
    59,
    1,
    8617,
    112,
    59,
    1,
    8619,
    108,
    59,
    1,
    10553,
    105,
    109,
    59,
    1,
    10611,
    108,
    59,
    1,
    8610,
    4,
    3,
    59,
    97,
    101,
    11702,
    11704,
    11709,
    1,
    10923,
    105,
    108,
    59,
    1,
    10521,
    4,
    2,
    59,
    115,
    11715,
    11717,
    1,
    10925,
    59,
    3,
    10925,
    65024,
    4,
    3,
    97,
    98,
    114,
    11729,
    11734,
    11739,
    114,
    114,
    59,
    1,
    10508,
    114,
    107,
    59,
    1,
    10098,
    4,
    2,
    97,
    107,
    11745,
    11758,
    99,
    4,
    2,
    101,
    107,
    11752,
    11755,
    59,
    1,
    123,
    59,
    1,
    91,
    4,
    2,
    101,
    115,
    11764,
    11767,
    59,
    1,
    10635,
    108,
    4,
    2,
    100,
    117,
    11774,
    11777,
    59,
    1,
    10639,
    59,
    1,
    10637,
    4,
    4,
    97,
    101,
    117,
    121,
    11790,
    11796,
    11811,
    11815,
    114,
    111,
    110,
    59,
    1,
    318,
    4,
    2,
    100,
    105,
    11802,
    11807,
    105,
    108,
    59,
    1,
    316,
    108,
    59,
    1,
    8968,
    98,
    59,
    1,
    123,
    59,
    1,
    1083,
    4,
    4,
    99,
    113,
    114,
    115,
    11828,
    11832,
    11845,
    11864,
    97,
    59,
    1,
    10550,
    117,
    111,
    4,
    2,
    59,
    114,
    11840,
    11842,
    1,
    8220,
    59,
    1,
    8222,
    4,
    2,
    100,
    117,
    11851,
    11857,
    104,
    97,
    114,
    59,
    1,
    10599,
    115,
    104,
    97,
    114,
    59,
    1,
    10571,
    104,
    59,
    1,
    8626,
    4,
    5,
    59,
    102,
    103,
    113,
    115,
    11880,
    11882,
    12008,
    12011,
    12031,
    1,
    8804,
    116,
    4,
    5,
    97,
    104,
    108,
    114,
    116,
    11895,
    11913,
    11935,
    11947,
    11996,
    114,
    114,
    111,
    119,
    4,
    2,
    59,
    116,
    11905,
    11907,
    1,
    8592,
    97,
    105,
    108,
    59,
    1,
    8610,
    97,
    114,
    112,
    111,
    111,
    110,
    4,
    2,
    100,
    117,
    11925,
    11931,
    111,
    119,
    110,
    59,
    1,
    8637,
    112,
    59,
    1,
    8636,
    101,
    102,
    116,
    97,
    114,
    114,
    111,
    119,
    115,
    59,
    1,
    8647,
    105,
    103,
    104,
    116,
    4,
    3,
    97,
    104,
    115,
    11959,
    11974,
    11984,
    114,
    114,
    111,
    119,
    4,
    2,
    59,
    115,
    11969,
    11971,
    1,
    8596,
    59,
    1,
    8646,
    97,
    114,
    112,
    111,
    111,
    110,
    115,
    59,
    1,
    8651,
    113,
    117,
    105,
    103,
    97,
    114,
    114,
    111,
    119,
    59,
    1,
    8621,
    104,
    114,
    101,
    101,
    116,
    105,
    109,
    101,
    115,
    59,
    1,
    8907,
    59,
    1,
    8922,
    4,
    3,
    59,
    113,
    115,
    12019,
    12021,
    12024,
    1,
    8804,
    59,
    1,
    8806,
    108,
    97,
    110,
    116,
    59,
    1,
    10877,
    4,
    5,
    59,
    99,
    100,
    103,
    115,
    12043,
    12045,
    12049,
    12070,
    12083,
    1,
    10877,
    99,
    59,
    1,
    10920,
    111,
    116,
    4,
    2,
    59,
    111,
    12057,
    12059,
    1,
    10879,
    4,
    2,
    59,
    114,
    12065,
    12067,
    1,
    10881,
    59,
    1,
    10883,
    4,
    2,
    59,
    101,
    12076,
    12079,
    3,
    8922,
    65024,
    115,
    59,
    1,
    10899,
    4,
    5,
    97,
    100,
    101,
    103,
    115,
    12095,
    12103,
    12108,
    12126,
    12131,
    112,
    112,
    114,
    111,
    120,
    59,
    1,
    10885,
    111,
    116,
    59,
    1,
    8918,
    113,
    4,
    2,
    103,
    113,
    12115,
    12120,
    116,
    114,
    59,
    1,
    8922,
    103,
    116,
    114,
    59,
    1,
    10891,
    116,
    114,
    59,
    1,
    8822,
    105,
    109,
    59,
    1,
    8818,
    4,
    3,
    105,
    108,
    114,
    12144,
    12150,
    12156,
    115,
    104,
    116,
    59,
    1,
    10620,
    111,
    111,
    114,
    59,
    1,
    8970,
    59,
    3,
    55349,
    56617,
    4,
    2,
    59,
    69,
    12166,
    12168,
    1,
    8822,
    59,
    1,
    10897,
    4,
    2,
    97,
    98,
    12177,
    12198,
    114,
    4,
    2,
    100,
    117,
    12184,
    12187,
    59,
    1,
    8637,
    4,
    2,
    59,
    108,
    12193,
    12195,
    1,
    8636,
    59,
    1,
    10602,
    108,
    107,
    59,
    1,
    9604,
    99,
    121,
    59,
    1,
    1113,
    4,
    5,
    59,
    97,
    99,
    104,
    116,
    12220,
    12222,
    12227,
    12235,
    12241,
    1,
    8810,
    114,
    114,
    59,
    1,
    8647,
    111,
    114,
    110,
    101,
    114,
    59,
    1,
    8990,
    97,
    114,
    100,
    59,
    1,
    10603,
    114,
    105,
    59,
    1,
    9722,
    4,
    2,
    105,
    111,
    12252,
    12258,
    100,
    111,
    116,
    59,
    1,
    320,
    117,
    115,
    116,
    4,
    2,
    59,
    97,
    12267,
    12269,
    1,
    9136,
    99,
    104,
    101,
    59,
    1,
    9136,
    4,
    4,
    69,
    97,
    101,
    115,
    12285,
    12288,
    12303,
    12322,
    59,
    1,
    8808,
    112,
    4,
    2,
    59,
    112,
    12295,
    12297,
    1,
    10889,
    114,
    111,
    120,
    59,
    1,
    10889,
    4,
    2,
    59,
    113,
    12309,
    12311,
    1,
    10887,
    4,
    2,
    59,
    113,
    12317,
    12319,
    1,
    10887,
    59,
    1,
    8808,
    105,
    109,
    59,
    1,
    8934,
    4,
    8,
    97,
    98,
    110,
    111,
    112,
    116,
    119,
    122,
    12345,
    12359,
    12364,
    12421,
    12446,
    12467,
    12474,
    12490,
    4,
    2,
    110,
    114,
    12351,
    12355,
    103,
    59,
    1,
    10220,
    114,
    59,
    1,
    8701,
    114,
    107,
    59,
    1,
    10214,
    103,
    4,
    3,
    108,
    109,
    114,
    12373,
    12401,
    12409,
    101,
    102,
    116,
    4,
    2,
    97,
    114,
    12382,
    12389,
    114,
    114,
    111,
    119,
    59,
    1,
    10229,
    105,
    103,
    104,
    116,
    97,
    114,
    114,
    111,
    119,
    59,
    1,
    10231,
    97,
    112,
    115,
    116,
    111,
    59,
    1,
    10236,
    105,
    103,
    104,
    116,
    97,
    114,
    114,
    111,
    119,
    59,
    1,
    10230,
    112,
    97,
    114,
    114,
    111,
    119,
    4,
    2,
    108,
    114,
    12433,
    12439,
    101,
    102,
    116,
    59,
    1,
    8619,
    105,
    103,
    104,
    116,
    59,
    1,
    8620,
    4,
    3,
    97,
    102,
    108,
    12454,
    12458,
    12462,
    114,
    59,
    1,
    10629,
    59,
    3,
    55349,
    56669,
    117,
    115,
    59,
    1,
    10797,
    105,
    109,
    101,
    115,
    59,
    1,
    10804,
    4,
    2,
    97,
    98,
    12480,
    12485,
    115,
    116,
    59,
    1,
    8727,
    97,
    114,
    59,
    1,
    95,
    4,
    3,
    59,
    101,
    102,
    12498,
    12500,
    12506,
    1,
    9674,
    110,
    103,
    101,
    59,
    1,
    9674,
    59,
    1,
    10731,
    97,
    114,
    4,
    2,
    59,
    108,
    12517,
    12519,
    1,
    40,
    116,
    59,
    1,
    10643,
    4,
    5,
    97,
    99,
    104,
    109,
    116,
    12535,
    12540,
    12548,
    12561,
    12564,
    114,
    114,
    59,
    1,
    8646,
    111,
    114,
    110,
    101,
    114,
    59,
    1,
    8991,
    97,
    114,
    4,
    2,
    59,
    100,
    12556,
    12558,
    1,
    8651,
    59,
    1,
    10605,
    59,
    1,
    8206,
    114,
    105,
    59,
    1,
    8895,
    4,
    6,
    97,
    99,
    104,
    105,
    113,
    116,
    12583,
    12589,
    12594,
    12597,
    12614,
    12635,
    113,
    117,
    111,
    59,
    1,
    8249,
    114,
    59,
    3,
    55349,
    56513,
    59,
    1,
    8624,
    109,
    4,
    3,
    59,
    101,
    103,
    12606,
    12608,
    12611,
    1,
    8818,
    59,
    1,
    10893,
    59,
    1,
    10895,
    4,
    2,
    98,
    117,
    12620,
    12623,
    59,
    1,
    91,
    111,
    4,
    2,
    59,
    114,
    12630,
    12632,
    1,
    8216,
    59,
    1,
    8218,
    114,
    111,
    107,
    59,
    1,
    322,
    5,
    60,
    8,
    59,
    99,
    100,
    104,
    105,
    108,
    113,
    114,
    12660,
    12662,
    12675,
    12680,
    12686,
    12692,
    12698,
    12705,
    1,
    60,
    4,
    2,
    99,
    105,
    12668,
    12671,
    59,
    1,
    10918,
    114,
    59,
    1,
    10873,
    111,
    116,
    59,
    1,
    8918,
    114,
    101,
    101,
    59,
    1,
    8907,
    109,
    101,
    115,
    59,
    1,
    8905,
    97,
    114,
    114,
    59,
    1,
    10614,
    117,
    101,
    115,
    116,
    59,
    1,
    10875,
    4,
    2,
    80,
    105,
    12711,
    12716,
    97,
    114,
    59,
    1,
    10646,
    4,
    3,
    59,
    101,
    102,
    12724,
    12726,
    12729,
    1,
    9667,
    59,
    1,
    8884,
    59,
    1,
    9666,
    114,
    4,
    2,
    100,
    117,
    12739,
    12746,
    115,
    104,
    97,
    114,
    59,
    1,
    10570,
    104,
    97,
    114,
    59,
    1,
    10598,
    4,
    2,
    101,
    110,
    12758,
    12768,
    114,
    116,
    110,
    101,
    113,
    113,
    59,
    3,
    8808,
    65024,
    69,
    59,
    3,
    8808,
    65024,
    4,
    14,
    68,
    97,
    99,
    100,
    101,
    102,
    104,
    105,
    108,
    110,
    111,
    112,
    115,
    117,
    12803,
    12809,
    12893,
    12908,
    12914,
    12928,
    12933,
    12937,
    13011,
    13025,
    13032,
    13049,
    13052,
    13069,
    68,
    111,
    116,
    59,
    1,
    8762,
    4,
    4,
    99,
    108,
    112,
    114,
    12819,
    12827,
    12849,
    12887,
    114,
    5,
    175,
    1,
    59,
    12825,
    1,
    175,
    4,
    2,
    101,
    116,
    12833,
    12836,
    59,
    1,
    9794,
    4,
    2,
    59,
    101,
    12842,
    12844,
    1,
    10016,
    115,
    101,
    59,
    1,
    10016,
    4,
    2,
    59,
    115,
    12855,
    12857,
    1,
    8614,
    116,
    111,
    4,
    4,
    59,
    100,
    108,
    117,
    12869,
    12871,
    12877,
    12883,
    1,
    8614,
    111,
    119,
    110,
    59,
    1,
    8615,
    101,
    102,
    116,
    59,
    1,
    8612,
    112,
    59,
    1,
    8613,
    107,
    101,
    114,
    59,
    1,
    9646,
    4,
    2,
    111,
    121,
    12899,
    12905,
    109,
    109,
    97,
    59,
    1,
    10793,
    59,
    1,
    1084,
    97,
    115,
    104,
    59,
    1,
    8212,
    97,
    115,
    117,
    114,
    101,
    100,
    97,
    110,
    103,
    108,
    101,
    59,
    1,
    8737,
    114,
    59,
    3,
    55349,
    56618,
    111,
    59,
    1,
    8487,
    4,
    3,
    99,
    100,
    110,
    12945,
    12954,
    12985,
    114,
    111,
    5,
    181,
    1,
    59,
    12952,
    1,
    181,
    4,
    4,
    59,
    97,
    99,
    100,
    12964,
    12966,
    12971,
    12976,
    1,
    8739,
    115,
    116,
    59,
    1,
    42,
    105,
    114,
    59,
    1,
    10992,
    111,
    116,
    5,
    183,
    1,
    59,
    12983,
    1,
    183,
    117,
    115,
    4,
    3,
    59,
    98,
    100,
    12995,
    12997,
    13e3,
    1,
    8722,
    59,
    1,
    8863,
    4,
    2,
    59,
    117,
    13006,
    13008,
    1,
    8760,
    59,
    1,
    10794,
    4,
    2,
    99,
    100,
    13017,
    13021,
    112,
    59,
    1,
    10971,
    114,
    59,
    1,
    8230,
    112,
    108,
    117,
    115,
    59,
    1,
    8723,
    4,
    2,
    100,
    112,
    13038,
    13044,
    101,
    108,
    115,
    59,
    1,
    8871,
    102,
    59,
    3,
    55349,
    56670,
    59,
    1,
    8723,
    4,
    2,
    99,
    116,
    13058,
    13063,
    114,
    59,
    3,
    55349,
    56514,
    112,
    111,
    115,
    59,
    1,
    8766,
    4,
    3,
    59,
    108,
    109,
    13077,
    13079,
    13087,
    1,
    956,
    116,
    105,
    109,
    97,
    112,
    59,
    1,
    8888,
    97,
    112,
    59,
    1,
    8888,
    4,
    24,
    71,
    76,
    82,
    86,
    97,
    98,
    99,
    100,
    101,
    102,
    103,
    104,
    105,
    106,
    108,
    109,
    111,
    112,
    114,
    115,
    116,
    117,
    118,
    119,
    13142,
    13165,
    13217,
    13229,
    13247,
    13330,
    13359,
    13414,
    13420,
    13508,
    13513,
    13579,
    13602,
    13626,
    13631,
    13762,
    13767,
    13855,
    13936,
    13995,
    14214,
    14285,
    14312,
    14432,
    4,
    2,
    103,
    116,
    13148,
    13152,
    59,
    3,
    8921,
    824,
    4,
    2,
    59,
    118,
    13158,
    13161,
    3,
    8811,
    8402,
    59,
    3,
    8811,
    824,
    4,
    3,
    101,
    108,
    116,
    13173,
    13200,
    13204,
    102,
    116,
    4,
    2,
    97,
    114,
    13181,
    13188,
    114,
    114,
    111,
    119,
    59,
    1,
    8653,
    105,
    103,
    104,
    116,
    97,
    114,
    114,
    111,
    119,
    59,
    1,
    8654,
    59,
    3,
    8920,
    824,
    4,
    2,
    59,
    118,
    13210,
    13213,
    3,
    8810,
    8402,
    59,
    3,
    8810,
    824,
    105,
    103,
    104,
    116,
    97,
    114,
    114,
    111,
    119,
    59,
    1,
    8655,
    4,
    2,
    68,
    100,
    13235,
    13241,
    97,
    115,
    104,
    59,
    1,
    8879,
    97,
    115,
    104,
    59,
    1,
    8878,
    4,
    5,
    98,
    99,
    110,
    112,
    116,
    13259,
    13264,
    13270,
    13275,
    13308,
    108,
    97,
    59,
    1,
    8711,
    117,
    116,
    101,
    59,
    1,
    324,
    103,
    59,
    3,
    8736,
    8402,
    4,
    5,
    59,
    69,
    105,
    111,
    112,
    13287,
    13289,
    13293,
    13298,
    13302,
    1,
    8777,
    59,
    3,
    10864,
    824,
    100,
    59,
    3,
    8779,
    824,
    115,
    59,
    1,
    329,
    114,
    111,
    120,
    59,
    1,
    8777,
    117,
    114,
    4,
    2,
    59,
    97,
    13316,
    13318,
    1,
    9838,
    108,
    4,
    2,
    59,
    115,
    13325,
    13327,
    1,
    9838,
    59,
    1,
    8469,
    4,
    2,
    115,
    117,
    13336,
    13344,
    112,
    5,
    160,
    1,
    59,
    13342,
    1,
    160,
    109,
    112,
    4,
    2,
    59,
    101,
    13352,
    13355,
    3,
    8782,
    824,
    59,
    3,
    8783,
    824,
    4,
    5,
    97,
    101,
    111,
    117,
    121,
    13371,
    13385,
    13391,
    13407,
    13411,
    4,
    2,
    112,
    114,
    13377,
    13380,
    59,
    1,
    10819,
    111,
    110,
    59,
    1,
    328,
    100,
    105,
    108,
    59,
    1,
    326,
    110,
    103,
    4,
    2,
    59,
    100,
    13399,
    13401,
    1,
    8775,
    111,
    116,
    59,
    3,
    10861,
    824,
    112,
    59,
    1,
    10818,
    59,
    1,
    1085,
    97,
    115,
    104,
    59,
    1,
    8211,
    4,
    7,
    59,
    65,
    97,
    100,
    113,
    115,
    120,
    13436,
    13438,
    13443,
    13466,
    13472,
    13478,
    13494,
    1,
    8800,
    114,
    114,
    59,
    1,
    8663,
    114,
    4,
    2,
    104,
    114,
    13450,
    13454,
    107,
    59,
    1,
    10532,
    4,
    2,
    59,
    111,
    13460,
    13462,
    1,
    8599,
    119,
    59,
    1,
    8599,
    111,
    116,
    59,
    3,
    8784,
    824,
    117,
    105,
    118,
    59,
    1,
    8802,
    4,
    2,
    101,
    105,
    13484,
    13489,
    97,
    114,
    59,
    1,
    10536,
    109,
    59,
    3,
    8770,
    824,
    105,
    115,
    116,
    4,
    2,
    59,
    115,
    13503,
    13505,
    1,
    8708,
    59,
    1,
    8708,
    114,
    59,
    3,
    55349,
    56619,
    4,
    4,
    69,
    101,
    115,
    116,
    13523,
    13527,
    13563,
    13568,
    59,
    3,
    8807,
    824,
    4,
    3,
    59,
    113,
    115,
    13535,
    13537,
    13559,
    1,
    8817,
    4,
    3,
    59,
    113,
    115,
    13545,
    13547,
    13551,
    1,
    8817,
    59,
    3,
    8807,
    824,
    108,
    97,
    110,
    116,
    59,
    3,
    10878,
    824,
    59,
    3,
    10878,
    824,
    105,
    109,
    59,
    1,
    8821,
    4,
    2,
    59,
    114,
    13574,
    13576,
    1,
    8815,
    59,
    1,
    8815,
    4,
    3,
    65,
    97,
    112,
    13587,
    13592,
    13597,
    114,
    114,
    59,
    1,
    8654,
    114,
    114,
    59,
    1,
    8622,
    97,
    114,
    59,
    1,
    10994,
    4,
    3,
    59,
    115,
    118,
    13610,
    13612,
    13623,
    1,
    8715,
    4,
    2,
    59,
    100,
    13618,
    13620,
    1,
    8956,
    59,
    1,
    8954,
    59,
    1,
    8715,
    99,
    121,
    59,
    1,
    1114,
    4,
    7,
    65,
    69,
    97,
    100,
    101,
    115,
    116,
    13647,
    13652,
    13656,
    13661,
    13665,
    13737,
    13742,
    114,
    114,
    59,
    1,
    8653,
    59,
    3,
    8806,
    824,
    114,
    114,
    59,
    1,
    8602,
    114,
    59,
    1,
    8229,
    4,
    4,
    59,
    102,
    113,
    115,
    13675,
    13677,
    13703,
    13725,
    1,
    8816,
    116,
    4,
    2,
    97,
    114,
    13684,
    13691,
    114,
    114,
    111,
    119,
    59,
    1,
    8602,
    105,
    103,
    104,
    116,
    97,
    114,
    114,
    111,
    119,
    59,
    1,
    8622,
    4,
    3,
    59,
    113,
    115,
    13711,
    13713,
    13717,
    1,
    8816,
    59,
    3,
    8806,
    824,
    108,
    97,
    110,
    116,
    59,
    3,
    10877,
    824,
    4,
    2,
    59,
    115,
    13731,
    13734,
    3,
    10877,
    824,
    59,
    1,
    8814,
    105,
    109,
    59,
    1,
    8820,
    4,
    2,
    59,
    114,
    13748,
    13750,
    1,
    8814,
    105,
    4,
    2,
    59,
    101,
    13757,
    13759,
    1,
    8938,
    59,
    1,
    8940,
    105,
    100,
    59,
    1,
    8740,
    4,
    2,
    112,
    116,
    13773,
    13778,
    102,
    59,
    3,
    55349,
    56671,
    5,
    172,
    3,
    59,
    105,
    110,
    13787,
    13789,
    13829,
    1,
    172,
    110,
    4,
    4,
    59,
    69,
    100,
    118,
    13800,
    13802,
    13806,
    13812,
    1,
    8713,
    59,
    3,
    8953,
    824,
    111,
    116,
    59,
    3,
    8949,
    824,
    4,
    3,
    97,
    98,
    99,
    13820,
    13823,
    13826,
    59,
    1,
    8713,
    59,
    1,
    8951,
    59,
    1,
    8950,
    105,
    4,
    2,
    59,
    118,
    13836,
    13838,
    1,
    8716,
    4,
    3,
    97,
    98,
    99,
    13846,
    13849,
    13852,
    59,
    1,
    8716,
    59,
    1,
    8958,
    59,
    1,
    8957,
    4,
    3,
    97,
    111,
    114,
    13863,
    13892,
    13899,
    114,
    4,
    4,
    59,
    97,
    115,
    116,
    13874,
    13876,
    13883,
    13888,
    1,
    8742,
    108,
    108,
    101,
    108,
    59,
    1,
    8742,
    108,
    59,
    3,
    11005,
    8421,
    59,
    3,
    8706,
    824,
    108,
    105,
    110,
    116,
    59,
    1,
    10772,
    4,
    3,
    59,
    99,
    101,
    13907,
    13909,
    13914,
    1,
    8832,
    117,
    101,
    59,
    1,
    8928,
    4,
    2,
    59,
    99,
    13920,
    13923,
    3,
    10927,
    824,
    4,
    2,
    59,
    101,
    13929,
    13931,
    1,
    8832,
    113,
    59,
    3,
    10927,
    824,
    4,
    4,
    65,
    97,
    105,
    116,
    13946,
    13951,
    13971,
    13982,
    114,
    114,
    59,
    1,
    8655,
    114,
    114,
    4,
    3,
    59,
    99,
    119,
    13961,
    13963,
    13967,
    1,
    8603,
    59,
    3,
    10547,
    824,
    59,
    3,
    8605,
    824,
    103,
    104,
    116,
    97,
    114,
    114,
    111,
    119,
    59,
    1,
    8603,
    114,
    105,
    4,
    2,
    59,
    101,
    13990,
    13992,
    1,
    8939,
    59,
    1,
    8941,
    4,
    7,
    99,
    104,
    105,
    109,
    112,
    113,
    117,
    14011,
    14036,
    14060,
    14080,
    14085,
    14090,
    14106,
    4,
    4,
    59,
    99,
    101,
    114,
    14021,
    14023,
    14028,
    14032,
    1,
    8833,
    117,
    101,
    59,
    1,
    8929,
    59,
    3,
    10928,
    824,
    59,
    3,
    55349,
    56515,
    111,
    114,
    116,
    4,
    2,
    109,
    112,
    14045,
    14050,
    105,
    100,
    59,
    1,
    8740,
    97,
    114,
    97,
    108,
    108,
    101,
    108,
    59,
    1,
    8742,
    109,
    4,
    2,
    59,
    101,
    14067,
    14069,
    1,
    8769,
    4,
    2,
    59,
    113,
    14075,
    14077,
    1,
    8772,
    59,
    1,
    8772,
    105,
    100,
    59,
    1,
    8740,
    97,
    114,
    59,
    1,
    8742,
    115,
    117,
    4,
    2,
    98,
    112,
    14098,
    14102,
    101,
    59,
    1,
    8930,
    101,
    59,
    1,
    8931,
    4,
    3,
    98,
    99,
    112,
    14114,
    14157,
    14171,
    4,
    4,
    59,
    69,
    101,
    115,
    14124,
    14126,
    14130,
    14133,
    1,
    8836,
    59,
    3,
    10949,
    824,
    59,
    1,
    8840,
    101,
    116,
    4,
    2,
    59,
    101,
    14141,
    14144,
    3,
    8834,
    8402,
    113,
    4,
    2,
    59,
    113,
    14151,
    14153,
    1,
    8840,
    59,
    3,
    10949,
    824,
    99,
    4,
    2,
    59,
    101,
    14164,
    14166,
    1,
    8833,
    113,
    59,
    3,
    10928,
    824,
    4,
    4,
    59,
    69,
    101,
    115,
    14181,
    14183,
    14187,
    14190,
    1,
    8837,
    59,
    3,
    10950,
    824,
    59,
    1,
    8841,
    101,
    116,
    4,
    2,
    59,
    101,
    14198,
    14201,
    3,
    8835,
    8402,
    113,
    4,
    2,
    59,
    113,
    14208,
    14210,
    1,
    8841,
    59,
    3,
    10950,
    824,
    4,
    4,
    103,
    105,
    108,
    114,
    14224,
    14228,
    14238,
    14242,
    108,
    59,
    1,
    8825,
    108,
    100,
    101,
    5,
    241,
    1,
    59,
    14236,
    1,
    241,
    103,
    59,
    1,
    8824,
    105,
    97,
    110,
    103,
    108,
    101,
    4,
    2,
    108,
    114,
    14254,
    14269,
    101,
    102,
    116,
    4,
    2,
    59,
    101,
    14263,
    14265,
    1,
    8938,
    113,
    59,
    1,
    8940,
    105,
    103,
    104,
    116,
    4,
    2,
    59,
    101,
    14279,
    14281,
    1,
    8939,
    113,
    59,
    1,
    8941,
    4,
    2,
    59,
    109,
    14291,
    14293,
    1,
    957,
    4,
    3,
    59,
    101,
    115,
    14301,
    14303,
    14308,
    1,
    35,
    114,
    111,
    59,
    1,
    8470,
    112,
    59,
    1,
    8199,
    4,
    9,
    68,
    72,
    97,
    100,
    103,
    105,
    108,
    114,
    115,
    14332,
    14338,
    14344,
    14349,
    14355,
    14369,
    14376,
    14408,
    14426,
    97,
    115,
    104,
    59,
    1,
    8877,
    97,
    114,
    114,
    59,
    1,
    10500,
    112,
    59,
    3,
    8781,
    8402,
    97,
    115,
    104,
    59,
    1,
    8876,
    4,
    2,
    101,
    116,
    14361,
    14365,
    59,
    3,
    8805,
    8402,
    59,
    3,
    62,
    8402,
    110,
    102,
    105,
    110,
    59,
    1,
    10718,
    4,
    3,
    65,
    101,
    116,
    14384,
    14389,
    14393,
    114,
    114,
    59,
    1,
    10498,
    59,
    3,
    8804,
    8402,
    4,
    2,
    59,
    114,
    14399,
    14402,
    3,
    60,
    8402,
    105,
    101,
    59,
    3,
    8884,
    8402,
    4,
    2,
    65,
    116,
    14414,
    14419,
    114,
    114,
    59,
    1,
    10499,
    114,
    105,
    101,
    59,
    3,
    8885,
    8402,
    105,
    109,
    59,
    3,
    8764,
    8402,
    4,
    3,
    65,
    97,
    110,
    14440,
    14445,
    14468,
    114,
    114,
    59,
    1,
    8662,
    114,
    4,
    2,
    104,
    114,
    14452,
    14456,
    107,
    59,
    1,
    10531,
    4,
    2,
    59,
    111,
    14462,
    14464,
    1,
    8598,
    119,
    59,
    1,
    8598,
    101,
    97,
    114,
    59,
    1,
    10535,
    4,
    18,
    83,
    97,
    99,
    100,
    101,
    102,
    103,
    104,
    105,
    108,
    109,
    111,
    112,
    114,
    115,
    116,
    117,
    118,
    14512,
    14515,
    14535,
    14560,
    14597,
    14603,
    14618,
    14643,
    14657,
    14662,
    14701,
    14741,
    14747,
    14769,
    14851,
    14877,
    14907,
    14916,
    59,
    1,
    9416,
    4,
    2,
    99,
    115,
    14521,
    14531,
    117,
    116,
    101,
    5,
    243,
    1,
    59,
    14529,
    1,
    243,
    116,
    59,
    1,
    8859,
    4,
    2,
    105,
    121,
    14541,
    14557,
    114,
    4,
    2,
    59,
    99,
    14548,
    14550,
    1,
    8858,
    5,
    244,
    1,
    59,
    14555,
    1,
    244,
    59,
    1,
    1086,
    4,
    5,
    97,
    98,
    105,
    111,
    115,
    14572,
    14577,
    14583,
    14587,
    14591,
    115,
    104,
    59,
    1,
    8861,
    108,
    97,
    99,
    59,
    1,
    337,
    118,
    59,
    1,
    10808,
    116,
    59,
    1,
    8857,
    111,
    108,
    100,
    59,
    1,
    10684,
    108,
    105,
    103,
    59,
    1,
    339,
    4,
    2,
    99,
    114,
    14609,
    14614,
    105,
    114,
    59,
    1,
    10687,
    59,
    3,
    55349,
    56620,
    4,
    3,
    111,
    114,
    116,
    14626,
    14630,
    14640,
    110,
    59,
    1,
    731,
    97,
    118,
    101,
    5,
    242,
    1,
    59,
    14638,
    1,
    242,
    59,
    1,
    10689,
    4,
    2,
    98,
    109,
    14649,
    14654,
    97,
    114,
    59,
    1,
    10677,
    59,
    1,
    937,
    110,
    116,
    59,
    1,
    8750,
    4,
    4,
    97,
    99,
    105,
    116,
    14672,
    14677,
    14693,
    14698,
    114,
    114,
    59,
    1,
    8634,
    4,
    2,
    105,
    114,
    14683,
    14687,
    114,
    59,
    1,
    10686,
    111,
    115,
    115,
    59,
    1,
    10683,
    110,
    101,
    59,
    1,
    8254,
    59,
    1,
    10688,
    4,
    3,
    97,
    101,
    105,
    14709,
    14714,
    14719,
    99,
    114,
    59,
    1,
    333,
    103,
    97,
    59,
    1,
    969,
    4,
    3,
    99,
    100,
    110,
    14727,
    14733,
    14736,
    114,
    111,
    110,
    59,
    1,
    959,
    59,
    1,
    10678,
    117,
    115,
    59,
    1,
    8854,
    112,
    102,
    59,
    3,
    55349,
    56672,
    4,
    3,
    97,
    101,
    108,
    14755,
    14759,
    14764,
    114,
    59,
    1,
    10679,
    114,
    112,
    59,
    1,
    10681,
    117,
    115,
    59,
    1,
    8853,
    4,
    7,
    59,
    97,
    100,
    105,
    111,
    115,
    118,
    14785,
    14787,
    14792,
    14831,
    14837,
    14841,
    14848,
    1,
    8744,
    114,
    114,
    59,
    1,
    8635,
    4,
    4,
    59,
    101,
    102,
    109,
    14802,
    14804,
    14817,
    14824,
    1,
    10845,
    114,
    4,
    2,
    59,
    111,
    14811,
    14813,
    1,
    8500,
    102,
    59,
    1,
    8500,
    5,
    170,
    1,
    59,
    14822,
    1,
    170,
    5,
    186,
    1,
    59,
    14829,
    1,
    186,
    103,
    111,
    102,
    59,
    1,
    8886,
    114,
    59,
    1,
    10838,
    108,
    111,
    112,
    101,
    59,
    1,
    10839,
    59,
    1,
    10843,
    4,
    3,
    99,
    108,
    111,
    14859,
    14863,
    14873,
    114,
    59,
    1,
    8500,
    97,
    115,
    104,
    5,
    248,
    1,
    59,
    14871,
    1,
    248,
    108,
    59,
    1,
    8856,
    105,
    4,
    2,
    108,
    109,
    14884,
    14893,
    100,
    101,
    5,
    245,
    1,
    59,
    14891,
    1,
    245,
    101,
    115,
    4,
    2,
    59,
    97,
    14901,
    14903,
    1,
    8855,
    115,
    59,
    1,
    10806,
    109,
    108,
    5,
    246,
    1,
    59,
    14914,
    1,
    246,
    98,
    97,
    114,
    59,
    1,
    9021,
    4,
    12,
    97,
    99,
    101,
    102,
    104,
    105,
    108,
    109,
    111,
    114,
    115,
    117,
    14948,
    14992,
    14996,
    15033,
    15038,
    15068,
    15090,
    15189,
    15192,
    15222,
    15427,
    15441,
    114,
    4,
    4,
    59,
    97,
    115,
    116,
    14959,
    14961,
    14976,
    14989,
    1,
    8741,
    5,
    182,
    2,
    59,
    108,
    14968,
    14970,
    1,
    182,
    108,
    101,
    108,
    59,
    1,
    8741,
    4,
    2,
    105,
    108,
    14982,
    14986,
    109,
    59,
    1,
    10995,
    59,
    1,
    11005,
    59,
    1,
    8706,
    121,
    59,
    1,
    1087,
    114,
    4,
    5,
    99,
    105,
    109,
    112,
    116,
    15009,
    15014,
    15019,
    15024,
    15027,
    110,
    116,
    59,
    1,
    37,
    111,
    100,
    59,
    1,
    46,
    105,
    108,
    59,
    1,
    8240,
    59,
    1,
    8869,
    101,
    110,
    107,
    59,
    1,
    8241,
    114,
    59,
    3,
    55349,
    56621,
    4,
    3,
    105,
    109,
    111,
    15046,
    15057,
    15063,
    4,
    2,
    59,
    118,
    15052,
    15054,
    1,
    966,
    59,
    1,
    981,
    109,
    97,
    116,
    59,
    1,
    8499,
    110,
    101,
    59,
    1,
    9742,
    4,
    3,
    59,
    116,
    118,
    15076,
    15078,
    15087,
    1,
    960,
    99,
    104,
    102,
    111,
    114,
    107,
    59,
    1,
    8916,
    59,
    1,
    982,
    4,
    2,
    97,
    117,
    15096,
    15119,
    110,
    4,
    2,
    99,
    107,
    15103,
    15115,
    107,
    4,
    2,
    59,
    104,
    15110,
    15112,
    1,
    8463,
    59,
    1,
    8462,
    118,
    59,
    1,
    8463,
    115,
    4,
    9,
    59,
    97,
    98,
    99,
    100,
    101,
    109,
    115,
    116,
    15140,
    15142,
    15148,
    15151,
    15156,
    15168,
    15171,
    15179,
    15184,
    1,
    43,
    99,
    105,
    114,
    59,
    1,
    10787,
    59,
    1,
    8862,
    105,
    114,
    59,
    1,
    10786,
    4,
    2,
    111,
    117,
    15162,
    15165,
    59,
    1,
    8724,
    59,
    1,
    10789,
    59,
    1,
    10866,
    110,
    5,
    177,
    1,
    59,
    15177,
    1,
    177,
    105,
    109,
    59,
    1,
    10790,
    119,
    111,
    59,
    1,
    10791,
    59,
    1,
    177,
    4,
    3,
    105,
    112,
    117,
    15200,
    15208,
    15213,
    110,
    116,
    105,
    110,
    116,
    59,
    1,
    10773,
    102,
    59,
    3,
    55349,
    56673,
    110,
    100,
    5,
    163,
    1,
    59,
    15220,
    1,
    163,
    4,
    10,
    59,
    69,
    97,
    99,
    101,
    105,
    110,
    111,
    115,
    117,
    15244,
    15246,
    15249,
    15253,
    15258,
    15334,
    15347,
    15367,
    15416,
    15421,
    1,
    8826,
    59,
    1,
    10931,
    112,
    59,
    1,
    10935,
    117,
    101,
    59,
    1,
    8828,
    4,
    2,
    59,
    99,
    15264,
    15266,
    1,
    10927,
    4,
    6,
    59,
    97,
    99,
    101,
    110,
    115,
    15280,
    15282,
    15290,
    15299,
    15303,
    15329,
    1,
    8826,
    112,
    112,
    114,
    111,
    120,
    59,
    1,
    10935,
    117,
    114,
    108,
    121,
    101,
    113,
    59,
    1,
    8828,
    113,
    59,
    1,
    10927,
    4,
    3,
    97,
    101,
    115,
    15311,
    15319,
    15324,
    112,
    112,
    114,
    111,
    120,
    59,
    1,
    10937,
    113,
    113,
    59,
    1,
    10933,
    105,
    109,
    59,
    1,
    8936,
    105,
    109,
    59,
    1,
    8830,
    109,
    101,
    4,
    2,
    59,
    115,
    15342,
    15344,
    1,
    8242,
    59,
    1,
    8473,
    4,
    3,
    69,
    97,
    115,
    15355,
    15358,
    15362,
    59,
    1,
    10933,
    112,
    59,
    1,
    10937,
    105,
    109,
    59,
    1,
    8936,
    4,
    3,
    100,
    102,
    112,
    15375,
    15378,
    15404,
    59,
    1,
    8719,
    4,
    3,
    97,
    108,
    115,
    15386,
    15392,
    15398,
    108,
    97,
    114,
    59,
    1,
    9006,
    105,
    110,
    101,
    59,
    1,
    8978,
    117,
    114,
    102,
    59,
    1,
    8979,
    4,
    2,
    59,
    116,
    15410,
    15412,
    1,
    8733,
    111,
    59,
    1,
    8733,
    105,
    109,
    59,
    1,
    8830,
    114,
    101,
    108,
    59,
    1,
    8880,
    4,
    2,
    99,
    105,
    15433,
    15438,
    114,
    59,
    3,
    55349,
    56517,
    59,
    1,
    968,
    110,
    99,
    115,
    112,
    59,
    1,
    8200,
    4,
    6,
    102,
    105,
    111,
    112,
    115,
    117,
    15462,
    15467,
    15472,
    15478,
    15485,
    15491,
    114,
    59,
    3,
    55349,
    56622,
    110,
    116,
    59,
    1,
    10764,
    112,
    102,
    59,
    3,
    55349,
    56674,
    114,
    105,
    109,
    101,
    59,
    1,
    8279,
    99,
    114,
    59,
    3,
    55349,
    56518,
    4,
    3,
    97,
    101,
    111,
    15499,
    15520,
    15534,
    116,
    4,
    2,
    101,
    105,
    15506,
    15515,
    114,
    110,
    105,
    111,
    110,
    115,
    59,
    1,
    8461,
    110,
    116,
    59,
    1,
    10774,
    115,
    116,
    4,
    2,
    59,
    101,
    15528,
    15530,
    1,
    63,
    113,
    59,
    1,
    8799,
    116,
    5,
    34,
    1,
    59,
    15540,
    1,
    34,
    4,
    21,
    65,
    66,
    72,
    97,
    98,
    99,
    100,
    101,
    102,
    104,
    105,
    108,
    109,
    110,
    111,
    112,
    114,
    115,
    116,
    117,
    120,
    15586,
    15609,
    15615,
    15620,
    15796,
    15855,
    15893,
    15931,
    15977,
    16001,
    16039,
    16183,
    16204,
    16222,
    16228,
    16285,
    16312,
    16318,
    16363,
    16408,
    16416,
    4,
    3,
    97,
    114,
    116,
    15594,
    15599,
    15603,
    114,
    114,
    59,
    1,
    8667,
    114,
    59,
    1,
    8658,
    97,
    105,
    108,
    59,
    1,
    10524,
    97,
    114,
    114,
    59,
    1,
    10511,
    97,
    114,
    59,
    1,
    10596,
    4,
    7,
    99,
    100,
    101,
    110,
    113,
    114,
    116,
    15636,
    15651,
    15656,
    15664,
    15687,
    15696,
    15770,
    4,
    2,
    101,
    117,
    15642,
    15646,
    59,
    3,
    8765,
    817,
    116,
    101,
    59,
    1,
    341,
    105,
    99,
    59,
    1,
    8730,
    109,
    112,
    116,
    121,
    118,
    59,
    1,
    10675,
    103,
    4,
    4,
    59,
    100,
    101,
    108,
    15675,
    15677,
    15680,
    15683,
    1,
    10217,
    59,
    1,
    10642,
    59,
    1,
    10661,
    101,
    59,
    1,
    10217,
    117,
    111,
    5,
    187,
    1,
    59,
    15694,
    1,
    187,
    114,
    4,
    11,
    59,
    97,
    98,
    99,
    102,
    104,
    108,
    112,
    115,
    116,
    119,
    15721,
    15723,
    15727,
    15739,
    15742,
    15746,
    15750,
    15754,
    15758,
    15763,
    15767,
    1,
    8594,
    112,
    59,
    1,
    10613,
    4,
    2,
    59,
    102,
    15733,
    15735,
    1,
    8677,
    115,
    59,
    1,
    10528,
    59,
    1,
    10547,
    115,
    59,
    1,
    10526,
    107,
    59,
    1,
    8618,
    112,
    59,
    1,
    8620,
    108,
    59,
    1,
    10565,
    105,
    109,
    59,
    1,
    10612,
    108,
    59,
    1,
    8611,
    59,
    1,
    8605,
    4,
    2,
    97,
    105,
    15776,
    15781,
    105,
    108,
    59,
    1,
    10522,
    111,
    4,
    2,
    59,
    110,
    15788,
    15790,
    1,
    8758,
    97,
    108,
    115,
    59,
    1,
    8474,
    4,
    3,
    97,
    98,
    114,
    15804,
    15809,
    15814,
    114,
    114,
    59,
    1,
    10509,
    114,
    107,
    59,
    1,
    10099,
    4,
    2,
    97,
    107,
    15820,
    15833,
    99,
    4,
    2,
    101,
    107,
    15827,
    15830,
    59,
    1,
    125,
    59,
    1,
    93,
    4,
    2,
    101,
    115,
    15839,
    15842,
    59,
    1,
    10636,
    108,
    4,
    2,
    100,
    117,
    15849,
    15852,
    59,
    1,
    10638,
    59,
    1,
    10640,
    4,
    4,
    97,
    101,
    117,
    121,
    15865,
    15871,
    15886,
    15890,
    114,
    111,
    110,
    59,
    1,
    345,
    4,
    2,
    100,
    105,
    15877,
    15882,
    105,
    108,
    59,
    1,
    343,
    108,
    59,
    1,
    8969,
    98,
    59,
    1,
    125,
    59,
    1,
    1088,
    4,
    4,
    99,
    108,
    113,
    115,
    15903,
    15907,
    15914,
    15927,
    97,
    59,
    1,
    10551,
    100,
    104,
    97,
    114,
    59,
    1,
    10601,
    117,
    111,
    4,
    2,
    59,
    114,
    15922,
    15924,
    1,
    8221,
    59,
    1,
    8221,
    104,
    59,
    1,
    8627,
    4,
    3,
    97,
    99,
    103,
    15939,
    15966,
    15970,
    108,
    4,
    4,
    59,
    105,
    112,
    115,
    15950,
    15952,
    15957,
    15963,
    1,
    8476,
    110,
    101,
    59,
    1,
    8475,
    97,
    114,
    116,
    59,
    1,
    8476,
    59,
    1,
    8477,
    116,
    59,
    1,
    9645,
    5,
    174,
    1,
    59,
    15975,
    1,
    174,
    4,
    3,
    105,
    108,
    114,
    15985,
    15991,
    15997,
    115,
    104,
    116,
    59,
    1,
    10621,
    111,
    111,
    114,
    59,
    1,
    8971,
    59,
    3,
    55349,
    56623,
    4,
    2,
    97,
    111,
    16007,
    16028,
    114,
    4,
    2,
    100,
    117,
    16014,
    16017,
    59,
    1,
    8641,
    4,
    2,
    59,
    108,
    16023,
    16025,
    1,
    8640,
    59,
    1,
    10604,
    4,
    2,
    59,
    118,
    16034,
    16036,
    1,
    961,
    59,
    1,
    1009,
    4,
    3,
    103,
    110,
    115,
    16047,
    16167,
    16171,
    104,
    116,
    4,
    6,
    97,
    104,
    108,
    114,
    115,
    116,
    16063,
    16081,
    16103,
    16130,
    16143,
    16155,
    114,
    114,
    111,
    119,
    4,
    2,
    59,
    116,
    16073,
    16075,
    1,
    8594,
    97,
    105,
    108,
    59,
    1,
    8611,
    97,
    114,
    112,
    111,
    111,
    110,
    4,
    2,
    100,
    117,
    16093,
    16099,
    111,
    119,
    110,
    59,
    1,
    8641,
    112,
    59,
    1,
    8640,
    101,
    102,
    116,
    4,
    2,
    97,
    104,
    16112,
    16120,
    114,
    114,
    111,
    119,
    115,
    59,
    1,
    8644,
    97,
    114,
    112,
    111,
    111,
    110,
    115,
    59,
    1,
    8652,
    105,
    103,
    104,
    116,
    97,
    114,
    114,
    111,
    119,
    115,
    59,
    1,
    8649,
    113,
    117,
    105,
    103,
    97,
    114,
    114,
    111,
    119,
    59,
    1,
    8605,
    104,
    114,
    101,
    101,
    116,
    105,
    109,
    101,
    115,
    59,
    1,
    8908,
    103,
    59,
    1,
    730,
    105,
    110,
    103,
    100,
    111,
    116,
    115,
    101,
    113,
    59,
    1,
    8787,
    4,
    3,
    97,
    104,
    109,
    16191,
    16196,
    16201,
    114,
    114,
    59,
    1,
    8644,
    97,
    114,
    59,
    1,
    8652,
    59,
    1,
    8207,
    111,
    117,
    115,
    116,
    4,
    2,
    59,
    97,
    16214,
    16216,
    1,
    9137,
    99,
    104,
    101,
    59,
    1,
    9137,
    109,
    105,
    100,
    59,
    1,
    10990,
    4,
    4,
    97,
    98,
    112,
    116,
    16238,
    16252,
    16257,
    16278,
    4,
    2,
    110,
    114,
    16244,
    16248,
    103,
    59,
    1,
    10221,
    114,
    59,
    1,
    8702,
    114,
    107,
    59,
    1,
    10215,
    4,
    3,
    97,
    102,
    108,
    16265,
    16269,
    16273,
    114,
    59,
    1,
    10630,
    59,
    3,
    55349,
    56675,
    117,
    115,
    59,
    1,
    10798,
    105,
    109,
    101,
    115,
    59,
    1,
    10805,
    4,
    2,
    97,
    112,
    16291,
    16304,
    114,
    4,
    2,
    59,
    103,
    16298,
    16300,
    1,
    41,
    116,
    59,
    1,
    10644,
    111,
    108,
    105,
    110,
    116,
    59,
    1,
    10770,
    97,
    114,
    114,
    59,
    1,
    8649,
    4,
    4,
    97,
    99,
    104,
    113,
    16328,
    16334,
    16339,
    16342,
    113,
    117,
    111,
    59,
    1,
    8250,
    114,
    59,
    3,
    55349,
    56519,
    59,
    1,
    8625,
    4,
    2,
    98,
    117,
    16348,
    16351,
    59,
    1,
    93,
    111,
    4,
    2,
    59,
    114,
    16358,
    16360,
    1,
    8217,
    59,
    1,
    8217,
    4,
    3,
    104,
    105,
    114,
    16371,
    16377,
    16383,
    114,
    101,
    101,
    59,
    1,
    8908,
    109,
    101,
    115,
    59,
    1,
    8906,
    105,
    4,
    4,
    59,
    101,
    102,
    108,
    16394,
    16396,
    16399,
    16402,
    1,
    9657,
    59,
    1,
    8885,
    59,
    1,
    9656,
    116,
    114,
    105,
    59,
    1,
    10702,
    108,
    117,
    104,
    97,
    114,
    59,
    1,
    10600,
    59,
    1,
    8478,
    4,
    19,
    97,
    98,
    99,
    100,
    101,
    102,
    104,
    105,
    108,
    109,
    111,
    112,
    113,
    114,
    115,
    116,
    117,
    119,
    122,
    16459,
    16466,
    16472,
    16572,
    16590,
    16672,
    16687,
    16746,
    16844,
    16850,
    16924,
    16963,
    16988,
    17115,
    17121,
    17154,
    17206,
    17614,
    17656,
    99,
    117,
    116,
    101,
    59,
    1,
    347,
    113,
    117,
    111,
    59,
    1,
    8218,
    4,
    10,
    59,
    69,
    97,
    99,
    101,
    105,
    110,
    112,
    115,
    121,
    16494,
    16496,
    16499,
    16513,
    16518,
    16531,
    16536,
    16556,
    16564,
    16569,
    1,
    8827,
    59,
    1,
    10932,
    4,
    2,
    112,
    114,
    16505,
    16508,
    59,
    1,
    10936,
    111,
    110,
    59,
    1,
    353,
    117,
    101,
    59,
    1,
    8829,
    4,
    2,
    59,
    100,
    16524,
    16526,
    1,
    10928,
    105,
    108,
    59,
    1,
    351,
    114,
    99,
    59,
    1,
    349,
    4,
    3,
    69,
    97,
    115,
    16544,
    16547,
    16551,
    59,
    1,
    10934,
    112,
    59,
    1,
    10938,
    105,
    109,
    59,
    1,
    8937,
    111,
    108,
    105,
    110,
    116,
    59,
    1,
    10771,
    105,
    109,
    59,
    1,
    8831,
    59,
    1,
    1089,
    111,
    116,
    4,
    3,
    59,
    98,
    101,
    16582,
    16584,
    16587,
    1,
    8901,
    59,
    1,
    8865,
    59,
    1,
    10854,
    4,
    7,
    65,
    97,
    99,
    109,
    115,
    116,
    120,
    16606,
    16611,
    16634,
    16642,
    16646,
    16652,
    16668,
    114,
    114,
    59,
    1,
    8664,
    114,
    4,
    2,
    104,
    114,
    16618,
    16622,
    107,
    59,
    1,
    10533,
    4,
    2,
    59,
    111,
    16628,
    16630,
    1,
    8600,
    119,
    59,
    1,
    8600,
    116,
    5,
    167,
    1,
    59,
    16640,
    1,
    167,
    105,
    59,
    1,
    59,
    119,
    97,
    114,
    59,
    1,
    10537,
    109,
    4,
    2,
    105,
    110,
    16659,
    16665,
    110,
    117,
    115,
    59,
    1,
    8726,
    59,
    1,
    8726,
    116,
    59,
    1,
    10038,
    114,
    4,
    2,
    59,
    111,
    16679,
    16682,
    3,
    55349,
    56624,
    119,
    110,
    59,
    1,
    8994,
    4,
    4,
    97,
    99,
    111,
    121,
    16697,
    16702,
    16716,
    16739,
    114,
    112,
    59,
    1,
    9839,
    4,
    2,
    104,
    121,
    16708,
    16713,
    99,
    121,
    59,
    1,
    1097,
    59,
    1,
    1096,
    114,
    116,
    4,
    2,
    109,
    112,
    16724,
    16729,
    105,
    100,
    59,
    1,
    8739,
    97,
    114,
    97,
    108,
    108,
    101,
    108,
    59,
    1,
    8741,
    5,
    173,
    1,
    59,
    16744,
    1,
    173,
    4,
    2,
    103,
    109,
    16752,
    16770,
    109,
    97,
    4,
    3,
    59,
    102,
    118,
    16762,
    16764,
    16767,
    1,
    963,
    59,
    1,
    962,
    59,
    1,
    962,
    4,
    8,
    59,
    100,
    101,
    103,
    108,
    110,
    112,
    114,
    16788,
    16790,
    16795,
    16806,
    16817,
    16828,
    16832,
    16838,
    1,
    8764,
    111,
    116,
    59,
    1,
    10858,
    4,
    2,
    59,
    113,
    16801,
    16803,
    1,
    8771,
    59,
    1,
    8771,
    4,
    2,
    59,
    69,
    16812,
    16814,
    1,
    10910,
    59,
    1,
    10912,
    4,
    2,
    59,
    69,
    16823,
    16825,
    1,
    10909,
    59,
    1,
    10911,
    101,
    59,
    1,
    8774,
    108,
    117,
    115,
    59,
    1,
    10788,
    97,
    114,
    114,
    59,
    1,
    10610,
    97,
    114,
    114,
    59,
    1,
    8592,
    4,
    4,
    97,
    101,
    105,
    116,
    16860,
    16883,
    16891,
    16904,
    4,
    2,
    108,
    115,
    16866,
    16878,
    108,
    115,
    101,
    116,
    109,
    105,
    110,
    117,
    115,
    59,
    1,
    8726,
    104,
    112,
    59,
    1,
    10803,
    112,
    97,
    114,
    115,
    108,
    59,
    1,
    10724,
    4,
    2,
    100,
    108,
    16897,
    16900,
    59,
    1,
    8739,
    101,
    59,
    1,
    8995,
    4,
    2,
    59,
    101,
    16910,
    16912,
    1,
    10922,
    4,
    2,
    59,
    115,
    16918,
    16920,
    1,
    10924,
    59,
    3,
    10924,
    65024,
    4,
    3,
    102,
    108,
    112,
    16932,
    16938,
    16958,
    116,
    99,
    121,
    59,
    1,
    1100,
    4,
    2,
    59,
    98,
    16944,
    16946,
    1,
    47,
    4,
    2,
    59,
    97,
    16952,
    16954,
    1,
    10692,
    114,
    59,
    1,
    9023,
    102,
    59,
    3,
    55349,
    56676,
    97,
    4,
    2,
    100,
    114,
    16970,
    16985,
    101,
    115,
    4,
    2,
    59,
    117,
    16978,
    16980,
    1,
    9824,
    105,
    116,
    59,
    1,
    9824,
    59,
    1,
    8741,
    4,
    3,
    99,
    115,
    117,
    16996,
    17028,
    17089,
    4,
    2,
    97,
    117,
    17002,
    17015,
    112,
    4,
    2,
    59,
    115,
    17009,
    17011,
    1,
    8851,
    59,
    3,
    8851,
    65024,
    112,
    4,
    2,
    59,
    115,
    17022,
    17024,
    1,
    8852,
    59,
    3,
    8852,
    65024,
    117,
    4,
    2,
    98,
    112,
    17035,
    17062,
    4,
    3,
    59,
    101,
    115,
    17043,
    17045,
    17048,
    1,
    8847,
    59,
    1,
    8849,
    101,
    116,
    4,
    2,
    59,
    101,
    17056,
    17058,
    1,
    8847,
    113,
    59,
    1,
    8849,
    4,
    3,
    59,
    101,
    115,
    17070,
    17072,
    17075,
    1,
    8848,
    59,
    1,
    8850,
    101,
    116,
    4,
    2,
    59,
    101,
    17083,
    17085,
    1,
    8848,
    113,
    59,
    1,
    8850,
    4,
    3,
    59,
    97,
    102,
    17097,
    17099,
    17112,
    1,
    9633,
    114,
    4,
    2,
    101,
    102,
    17106,
    17109,
    59,
    1,
    9633,
    59,
    1,
    9642,
    59,
    1,
    9642,
    97,
    114,
    114,
    59,
    1,
    8594,
    4,
    4,
    99,
    101,
    109,
    116,
    17131,
    17136,
    17142,
    17148,
    114,
    59,
    3,
    55349,
    56520,
    116,
    109,
    110,
    59,
    1,
    8726,
    105,
    108,
    101,
    59,
    1,
    8995,
    97,
    114,
    102,
    59,
    1,
    8902,
    4,
    2,
    97,
    114,
    17160,
    17172,
    114,
    4,
    2,
    59,
    102,
    17167,
    17169,
    1,
    9734,
    59,
    1,
    9733,
    4,
    2,
    97,
    110,
    17178,
    17202,
    105,
    103,
    104,
    116,
    4,
    2,
    101,
    112,
    17188,
    17197,
    112,
    115,
    105,
    108,
    111,
    110,
    59,
    1,
    1013,
    104,
    105,
    59,
    1,
    981,
    115,
    59,
    1,
    175,
    4,
    5,
    98,
    99,
    109,
    110,
    112,
    17218,
    17351,
    17420,
    17423,
    17427,
    4,
    9,
    59,
    69,
    100,
    101,
    109,
    110,
    112,
    114,
    115,
    17238,
    17240,
    17243,
    17248,
    17261,
    17267,
    17279,
    17285,
    17291,
    1,
    8834,
    59,
    1,
    10949,
    111,
    116,
    59,
    1,
    10941,
    4,
    2,
    59,
    100,
    17254,
    17256,
    1,
    8838,
    111,
    116,
    59,
    1,
    10947,
    117,
    108,
    116,
    59,
    1,
    10945,
    4,
    2,
    69,
    101,
    17273,
    17276,
    59,
    1,
    10955,
    59,
    1,
    8842,
    108,
    117,
    115,
    59,
    1,
    10943,
    97,
    114,
    114,
    59,
    1,
    10617,
    4,
    3,
    101,
    105,
    117,
    17299,
    17335,
    17339,
    116,
    4,
    3,
    59,
    101,
    110,
    17308,
    17310,
    17322,
    1,
    8834,
    113,
    4,
    2,
    59,
    113,
    17317,
    17319,
    1,
    8838,
    59,
    1,
    10949,
    101,
    113,
    4,
    2,
    59,
    113,
    17330,
    17332,
    1,
    8842,
    59,
    1,
    10955,
    109,
    59,
    1,
    10951,
    4,
    2,
    98,
    112,
    17345,
    17348,
    59,
    1,
    10965,
    59,
    1,
    10963,
    99,
    4,
    6,
    59,
    97,
    99,
    101,
    110,
    115,
    17366,
    17368,
    17376,
    17385,
    17389,
    17415,
    1,
    8827,
    112,
    112,
    114,
    111,
    120,
    59,
    1,
    10936,
    117,
    114,
    108,
    121,
    101,
    113,
    59,
    1,
    8829,
    113,
    59,
    1,
    10928,
    4,
    3,
    97,
    101,
    115,
    17397,
    17405,
    17410,
    112,
    112,
    114,
    111,
    120,
    59,
    1,
    10938,
    113,
    113,
    59,
    1,
    10934,
    105,
    109,
    59,
    1,
    8937,
    105,
    109,
    59,
    1,
    8831,
    59,
    1,
    8721,
    103,
    59,
    1,
    9834,
    4,
    13,
    49,
    50,
    51,
    59,
    69,
    100,
    101,
    104,
    108,
    109,
    110,
    112,
    115,
    17455,
    17462,
    17469,
    17476,
    17478,
    17481,
    17496,
    17509,
    17524,
    17530,
    17536,
    17548,
    17554,
    5,
    185,
    1,
    59,
    17460,
    1,
    185,
    5,
    178,
    1,
    59,
    17467,
    1,
    178,
    5,
    179,
    1,
    59,
    17474,
    1,
    179,
    1,
    8835,
    59,
    1,
    10950,
    4,
    2,
    111,
    115,
    17487,
    17491,
    116,
    59,
    1,
    10942,
    117,
    98,
    59,
    1,
    10968,
    4,
    2,
    59,
    100,
    17502,
    17504,
    1,
    8839,
    111,
    116,
    59,
    1,
    10948,
    115,
    4,
    2,
    111,
    117,
    17516,
    17520,
    108,
    59,
    1,
    10185,
    98,
    59,
    1,
    10967,
    97,
    114,
    114,
    59,
    1,
    10619,
    117,
    108,
    116,
    59,
    1,
    10946,
    4,
    2,
    69,
    101,
    17542,
    17545,
    59,
    1,
    10956,
    59,
    1,
    8843,
    108,
    117,
    115,
    59,
    1,
    10944,
    4,
    3,
    101,
    105,
    117,
    17562,
    17598,
    17602,
    116,
    4,
    3,
    59,
    101,
    110,
    17571,
    17573,
    17585,
    1,
    8835,
    113,
    4,
    2,
    59,
    113,
    17580,
    17582,
    1,
    8839,
    59,
    1,
    10950,
    101,
    113,
    4,
    2,
    59,
    113,
    17593,
    17595,
    1,
    8843,
    59,
    1,
    10956,
    109,
    59,
    1,
    10952,
    4,
    2,
    98,
    112,
    17608,
    17611,
    59,
    1,
    10964,
    59,
    1,
    10966,
    4,
    3,
    65,
    97,
    110,
    17622,
    17627,
    17650,
    114,
    114,
    59,
    1,
    8665,
    114,
    4,
    2,
    104,
    114,
    17634,
    17638,
    107,
    59,
    1,
    10534,
    4,
    2,
    59,
    111,
    17644,
    17646,
    1,
    8601,
    119,
    59,
    1,
    8601,
    119,
    97,
    114,
    59,
    1,
    10538,
    108,
    105,
    103,
    5,
    223,
    1,
    59,
    17664,
    1,
    223,
    4,
    13,
    97,
    98,
    99,
    100,
    101,
    102,
    104,
    105,
    111,
    112,
    114,
    115,
    119,
    17694,
    17709,
    17714,
    17737,
    17742,
    17749,
    17754,
    17860,
    17905,
    17957,
    17964,
    18090,
    18122,
    4,
    2,
    114,
    117,
    17700,
    17706,
    103,
    101,
    116,
    59,
    1,
    8982,
    59,
    1,
    964,
    114,
    107,
    59,
    1,
    9140,
    4,
    3,
    97,
    101,
    121,
    17722,
    17728,
    17734,
    114,
    111,
    110,
    59,
    1,
    357,
    100,
    105,
    108,
    59,
    1,
    355,
    59,
    1,
    1090,
    111,
    116,
    59,
    1,
    8411,
    108,
    114,
    101,
    99,
    59,
    1,
    8981,
    114,
    59,
    3,
    55349,
    56625,
    4,
    4,
    101,
    105,
    107,
    111,
    17764,
    17805,
    17836,
    17851,
    4,
    2,
    114,
    116,
    17770,
    17786,
    101,
    4,
    2,
    52,
    102,
    17777,
    17780,
    59,
    1,
    8756,
    111,
    114,
    101,
    59,
    1,
    8756,
    97,
    4,
    3,
    59,
    115,
    118,
    17795,
    17797,
    17802,
    1,
    952,
    121,
    109,
    59,
    1,
    977,
    59,
    1,
    977,
    4,
    2,
    99,
    110,
    17811,
    17831,
    107,
    4,
    2,
    97,
    115,
    17818,
    17826,
    112,
    112,
    114,
    111,
    120,
    59,
    1,
    8776,
    105,
    109,
    59,
    1,
    8764,
    115,
    112,
    59,
    1,
    8201,
    4,
    2,
    97,
    115,
    17842,
    17846,
    112,
    59,
    1,
    8776,
    105,
    109,
    59,
    1,
    8764,
    114,
    110,
    5,
    254,
    1,
    59,
    17858,
    1,
    254,
    4,
    3,
    108,
    109,
    110,
    17868,
    17873,
    17901,
    100,
    101,
    59,
    1,
    732,
    101,
    115,
    5,
    215,
    3,
    59,
    98,
    100,
    17884,
    17886,
    17898,
    1,
    215,
    4,
    2,
    59,
    97,
    17892,
    17894,
    1,
    8864,
    114,
    59,
    1,
    10801,
    59,
    1,
    10800,
    116,
    59,
    1,
    8749,
    4,
    3,
    101,
    112,
    115,
    17913,
    17917,
    17953,
    97,
    59,
    1,
    10536,
    4,
    4,
    59,
    98,
    99,
    102,
    17927,
    17929,
    17934,
    17939,
    1,
    8868,
    111,
    116,
    59,
    1,
    9014,
    105,
    114,
    59,
    1,
    10993,
    4,
    2,
    59,
    111,
    17945,
    17948,
    3,
    55349,
    56677,
    114,
    107,
    59,
    1,
    10970,
    97,
    59,
    1,
    10537,
    114,
    105,
    109,
    101,
    59,
    1,
    8244,
    4,
    3,
    97,
    105,
    112,
    17972,
    17977,
    18082,
    100,
    101,
    59,
    1,
    8482,
    4,
    7,
    97,
    100,
    101,
    109,
    112,
    115,
    116,
    17993,
    18051,
    18056,
    18059,
    18066,
    18072,
    18076,
    110,
    103,
    108,
    101,
    4,
    5,
    59,
    100,
    108,
    113,
    114,
    18009,
    18011,
    18017,
    18032,
    18035,
    1,
    9653,
    111,
    119,
    110,
    59,
    1,
    9663,
    101,
    102,
    116,
    4,
    2,
    59,
    101,
    18026,
    18028,
    1,
    9667,
    113,
    59,
    1,
    8884,
    59,
    1,
    8796,
    105,
    103,
    104,
    116,
    4,
    2,
    59,
    101,
    18045,
    18047,
    1,
    9657,
    113,
    59,
    1,
    8885,
    111,
    116,
    59,
    1,
    9708,
    59,
    1,
    8796,
    105,
    110,
    117,
    115,
    59,
    1,
    10810,
    108,
    117,
    115,
    59,
    1,
    10809,
    98,
    59,
    1,
    10701,
    105,
    109,
    101,
    59,
    1,
    10811,
    101,
    122,
    105,
    117,
    109,
    59,
    1,
    9186,
    4,
    3,
    99,
    104,
    116,
    18098,
    18111,
    18116,
    4,
    2,
    114,
    121,
    18104,
    18108,
    59,
    3,
    55349,
    56521,
    59,
    1,
    1094,
    99,
    121,
    59,
    1,
    1115,
    114,
    111,
    107,
    59,
    1,
    359,
    4,
    2,
    105,
    111,
    18128,
    18133,
    120,
    116,
    59,
    1,
    8812,
    104,
    101,
    97,
    100,
    4,
    2,
    108,
    114,
    18143,
    18154,
    101,
    102,
    116,
    97,
    114,
    114,
    111,
    119,
    59,
    1,
    8606,
    105,
    103,
    104,
    116,
    97,
    114,
    114,
    111,
    119,
    59,
    1,
    8608,
    4,
    18,
    65,
    72,
    97,
    98,
    99,
    100,
    102,
    103,
    104,
    108,
    109,
    111,
    112,
    114,
    115,
    116,
    117,
    119,
    18204,
    18209,
    18214,
    18234,
    18250,
    18268,
    18292,
    18308,
    18319,
    18343,
    18379,
    18397,
    18413,
    18504,
    18547,
    18553,
    18584,
    18603,
    114,
    114,
    59,
    1,
    8657,
    97,
    114,
    59,
    1,
    10595,
    4,
    2,
    99,
    114,
    18220,
    18230,
    117,
    116,
    101,
    5,
    250,
    1,
    59,
    18228,
    1,
    250,
    114,
    59,
    1,
    8593,
    114,
    4,
    2,
    99,
    101,
    18241,
    18245,
    121,
    59,
    1,
    1118,
    118,
    101,
    59,
    1,
    365,
    4,
    2,
    105,
    121,
    18256,
    18265,
    114,
    99,
    5,
    251,
    1,
    59,
    18263,
    1,
    251,
    59,
    1,
    1091,
    4,
    3,
    97,
    98,
    104,
    18276,
    18281,
    18287,
    114,
    114,
    59,
    1,
    8645,
    108,
    97,
    99,
    59,
    1,
    369,
    97,
    114,
    59,
    1,
    10606,
    4,
    2,
    105,
    114,
    18298,
    18304,
    115,
    104,
    116,
    59,
    1,
    10622,
    59,
    3,
    55349,
    56626,
    114,
    97,
    118,
    101,
    5,
    249,
    1,
    59,
    18317,
    1,
    249,
    4,
    2,
    97,
    98,
    18325,
    18338,
    114,
    4,
    2,
    108,
    114,
    18332,
    18335,
    59,
    1,
    8639,
    59,
    1,
    8638,
    108,
    107,
    59,
    1,
    9600,
    4,
    2,
    99,
    116,
    18349,
    18374,
    4,
    2,
    111,
    114,
    18355,
    18369,
    114,
    110,
    4,
    2,
    59,
    101,
    18363,
    18365,
    1,
    8988,
    114,
    59,
    1,
    8988,
    111,
    112,
    59,
    1,
    8975,
    114,
    105,
    59,
    1,
    9720,
    4,
    2,
    97,
    108,
    18385,
    18390,
    99,
    114,
    59,
    1,
    363,
    5,
    168,
    1,
    59,
    18395,
    1,
    168,
    4,
    2,
    103,
    112,
    18403,
    18408,
    111,
    110,
    59,
    1,
    371,
    102,
    59,
    3,
    55349,
    56678,
    4,
    6,
    97,
    100,
    104,
    108,
    115,
    117,
    18427,
    18434,
    18445,
    18470,
    18475,
    18494,
    114,
    114,
    111,
    119,
    59,
    1,
    8593,
    111,
    119,
    110,
    97,
    114,
    114,
    111,
    119,
    59,
    1,
    8597,
    97,
    114,
    112,
    111,
    111,
    110,
    4,
    2,
    108,
    114,
    18457,
    18463,
    101,
    102,
    116,
    59,
    1,
    8639,
    105,
    103,
    104,
    116,
    59,
    1,
    8638,
    117,
    115,
    59,
    1,
    8846,
    105,
    4,
    3,
    59,
    104,
    108,
    18484,
    18486,
    18489,
    1,
    965,
    59,
    1,
    978,
    111,
    110,
    59,
    1,
    965,
    112,
    97,
    114,
    114,
    111,
    119,
    115,
    59,
    1,
    8648,
    4,
    3,
    99,
    105,
    116,
    18512,
    18537,
    18542,
    4,
    2,
    111,
    114,
    18518,
    18532,
    114,
    110,
    4,
    2,
    59,
    101,
    18526,
    18528,
    1,
    8989,
    114,
    59,
    1,
    8989,
    111,
    112,
    59,
    1,
    8974,
    110,
    103,
    59,
    1,
    367,
    114,
    105,
    59,
    1,
    9721,
    99,
    114,
    59,
    3,
    55349,
    56522,
    4,
    3,
    100,
    105,
    114,
    18561,
    18566,
    18572,
    111,
    116,
    59,
    1,
    8944,
    108,
    100,
    101,
    59,
    1,
    361,
    105,
    4,
    2,
    59,
    102,
    18579,
    18581,
    1,
    9653,
    59,
    1,
    9652,
    4,
    2,
    97,
    109,
    18590,
    18595,
    114,
    114,
    59,
    1,
    8648,
    108,
    5,
    252,
    1,
    59,
    18601,
    1,
    252,
    97,
    110,
    103,
    108,
    101,
    59,
    1,
    10663,
    4,
    15,
    65,
    66,
    68,
    97,
    99,
    100,
    101,
    102,
    108,
    110,
    111,
    112,
    114,
    115,
    122,
    18643,
    18648,
    18661,
    18667,
    18847,
    18851,
    18857,
    18904,
    18909,
    18915,
    18931,
    18937,
    18943,
    18949,
    18996,
    114,
    114,
    59,
    1,
    8661,
    97,
    114,
    4,
    2,
    59,
    118,
    18656,
    18658,
    1,
    10984,
    59,
    1,
    10985,
    97,
    115,
    104,
    59,
    1,
    8872,
    4,
    2,
    110,
    114,
    18673,
    18679,
    103,
    114,
    116,
    59,
    1,
    10652,
    4,
    7,
    101,
    107,
    110,
    112,
    114,
    115,
    116,
    18695,
    18704,
    18711,
    18720,
    18742,
    18754,
    18810,
    112,
    115,
    105,
    108,
    111,
    110,
    59,
    1,
    1013,
    97,
    112,
    112,
    97,
    59,
    1,
    1008,
    111,
    116,
    104,
    105,
    110,
    103,
    59,
    1,
    8709,
    4,
    3,
    104,
    105,
    114,
    18728,
    18732,
    18735,
    105,
    59,
    1,
    981,
    59,
    1,
    982,
    111,
    112,
    116,
    111,
    59,
    1,
    8733,
    4,
    2,
    59,
    104,
    18748,
    18750,
    1,
    8597,
    111,
    59,
    1,
    1009,
    4,
    2,
    105,
    117,
    18760,
    18766,
    103,
    109,
    97,
    59,
    1,
    962,
    4,
    2,
    98,
    112,
    18772,
    18791,
    115,
    101,
    116,
    110,
    101,
    113,
    4,
    2,
    59,
    113,
    18784,
    18787,
    3,
    8842,
    65024,
    59,
    3,
    10955,
    65024,
    115,
    101,
    116,
    110,
    101,
    113,
    4,
    2,
    59,
    113,
    18803,
    18806,
    3,
    8843,
    65024,
    59,
    3,
    10956,
    65024,
    4,
    2,
    104,
    114,
    18816,
    18822,
    101,
    116,
    97,
    59,
    1,
    977,
    105,
    97,
    110,
    103,
    108,
    101,
    4,
    2,
    108,
    114,
    18834,
    18840,
    101,
    102,
    116,
    59,
    1,
    8882,
    105,
    103,
    104,
    116,
    59,
    1,
    8883,
    121,
    59,
    1,
    1074,
    97,
    115,
    104,
    59,
    1,
    8866,
    4,
    3,
    101,
    108,
    114,
    18865,
    18884,
    18890,
    4,
    3,
    59,
    98,
    101,
    18873,
    18875,
    18880,
    1,
    8744,
    97,
    114,
    59,
    1,
    8891,
    113,
    59,
    1,
    8794,
    108,
    105,
    112,
    59,
    1,
    8942,
    4,
    2,
    98,
    116,
    18896,
    18901,
    97,
    114,
    59,
    1,
    124,
    59,
    1,
    124,
    114,
    59,
    3,
    55349,
    56627,
    116,
    114,
    105,
    59,
    1,
    8882,
    115,
    117,
    4,
    2,
    98,
    112,
    18923,
    18927,
    59,
    3,
    8834,
    8402,
    59,
    3,
    8835,
    8402,
    112,
    102,
    59,
    3,
    55349,
    56679,
    114,
    111,
    112,
    59,
    1,
    8733,
    116,
    114,
    105,
    59,
    1,
    8883,
    4,
    2,
    99,
    117,
    18955,
    18960,
    114,
    59,
    3,
    55349,
    56523,
    4,
    2,
    98,
    112,
    18966,
    18981,
    110,
    4,
    2,
    69,
    101,
    18973,
    18977,
    59,
    3,
    10955,
    65024,
    59,
    3,
    8842,
    65024,
    110,
    4,
    2,
    69,
    101,
    18988,
    18992,
    59,
    3,
    10956,
    65024,
    59,
    3,
    8843,
    65024,
    105,
    103,
    122,
    97,
    103,
    59,
    1,
    10650,
    4,
    7,
    99,
    101,
    102,
    111,
    112,
    114,
    115,
    19020,
    19026,
    19061,
    19066,
    19072,
    19075,
    19089,
    105,
    114,
    99,
    59,
    1,
    373,
    4,
    2,
    100,
    105,
    19032,
    19055,
    4,
    2,
    98,
    103,
    19038,
    19043,
    97,
    114,
    59,
    1,
    10847,
    101,
    4,
    2,
    59,
    113,
    19050,
    19052,
    1,
    8743,
    59,
    1,
    8793,
    101,
    114,
    112,
    59,
    1,
    8472,
    114,
    59,
    3,
    55349,
    56628,
    112,
    102,
    59,
    3,
    55349,
    56680,
    59,
    1,
    8472,
    4,
    2,
    59,
    101,
    19081,
    19083,
    1,
    8768,
    97,
    116,
    104,
    59,
    1,
    8768,
    99,
    114,
    59,
    3,
    55349,
    56524,
    4,
    14,
    99,
    100,
    102,
    104,
    105,
    108,
    109,
    110,
    111,
    114,
    115,
    117,
    118,
    119,
    19125,
    19146,
    19152,
    19157,
    19173,
    19176,
    19192,
    19197,
    19202,
    19236,
    19252,
    19269,
    19286,
    19291,
    4,
    3,
    97,
    105,
    117,
    19133,
    19137,
    19142,
    112,
    59,
    1,
    8898,
    114,
    99,
    59,
    1,
    9711,
    112,
    59,
    1,
    8899,
    116,
    114,
    105,
    59,
    1,
    9661,
    114,
    59,
    3,
    55349,
    56629,
    4,
    2,
    65,
    97,
    19163,
    19168,
    114,
    114,
    59,
    1,
    10234,
    114,
    114,
    59,
    1,
    10231,
    59,
    1,
    958,
    4,
    2,
    65,
    97,
    19182,
    19187,
    114,
    114,
    59,
    1,
    10232,
    114,
    114,
    59,
    1,
    10229,
    97,
    112,
    59,
    1,
    10236,
    105,
    115,
    59,
    1,
    8955,
    4,
    3,
    100,
    112,
    116,
    19210,
    19215,
    19230,
    111,
    116,
    59,
    1,
    10752,
    4,
    2,
    102,
    108,
    19221,
    19225,
    59,
    3,
    55349,
    56681,
    117,
    115,
    59,
    1,
    10753,
    105,
    109,
    101,
    59,
    1,
    10754,
    4,
    2,
    65,
    97,
    19242,
    19247,
    114,
    114,
    59,
    1,
    10233,
    114,
    114,
    59,
    1,
    10230,
    4,
    2,
    99,
    113,
    19258,
    19263,
    114,
    59,
    3,
    55349,
    56525,
    99,
    117,
    112,
    59,
    1,
    10758,
    4,
    2,
    112,
    116,
    19275,
    19281,
    108,
    117,
    115,
    59,
    1,
    10756,
    114,
    105,
    59,
    1,
    9651,
    101,
    101,
    59,
    1,
    8897,
    101,
    100,
    103,
    101,
    59,
    1,
    8896,
    4,
    8,
    97,
    99,
    101,
    102,
    105,
    111,
    115,
    117,
    19316,
    19335,
    19349,
    19357,
    19362,
    19367,
    19373,
    19379,
    99,
    4,
    2,
    117,
    121,
    19323,
    19332,
    116,
    101,
    5,
    253,
    1,
    59,
    19330,
    1,
    253,
    59,
    1,
    1103,
    4,
    2,
    105,
    121,
    19341,
    19346,
    114,
    99,
    59,
    1,
    375,
    59,
    1,
    1099,
    110,
    5,
    165,
    1,
    59,
    19355,
    1,
    165,
    114,
    59,
    3,
    55349,
    56630,
    99,
    121,
    59,
    1,
    1111,
    112,
    102,
    59,
    3,
    55349,
    56682,
    99,
    114,
    59,
    3,
    55349,
    56526,
    4,
    2,
    99,
    109,
    19385,
    19389,
    121,
    59,
    1,
    1102,
    108,
    5,
    255,
    1,
    59,
    19395,
    1,
    255,
    4,
    10,
    97,
    99,
    100,
    101,
    102,
    104,
    105,
    111,
    115,
    119,
    19419,
    19426,
    19441,
    19446,
    19462,
    19467,
    19472,
    19480,
    19486,
    19492,
    99,
    117,
    116,
    101,
    59,
    1,
    378,
    4,
    2,
    97,
    121,
    19432,
    19438,
    114,
    111,
    110,
    59,
    1,
    382,
    59,
    1,
    1079,
    111,
    116,
    59,
    1,
    380,
    4,
    2,
    101,
    116,
    19452,
    19458,
    116,
    114,
    102,
    59,
    1,
    8488,
    97,
    59,
    1,
    950,
    114,
    59,
    3,
    55349,
    56631,
    99,
    121,
    59,
    1,
    1078,
    103,
    114,
    97,
    114,
    114,
    59,
    1,
    8669,
    112,
    102,
    59,
    3,
    55349,
    56683,
    99,
    114,
    59,
    3,
    55349,
    56527,
    4,
    2,
    106,
    110,
    19498,
    19501,
    59,
    1,
    8205,
    106,
    59,
    1,
    8204
]);
const $ef053115c0f9207e$var$t0 = $ef053115c0f9207e$var$Z9, $ef053115c0f9207e$var$X = $ef053115c0f9207e$var$Ye, $ef053115c0f9207e$var$O1 = $ef053115c0f9207e$var$e0, $ef053115c0f9207e$var$C = $ef053115c0f9207e$var$cr, $ef053115c0f9207e$var$f = $ef053115c0f9207e$var$X.CODE_POINTS, $ef053115c0f9207e$var$S1 = $ef053115c0f9207e$var$X.CODE_POINT_SEQUENCES, $ef053115c0f9207e$var$n0 = {
    128: 8364,
    130: 8218,
    131: 402,
    132: 8222,
    133: 8230,
    134: 8224,
    135: 8225,
    136: 710,
    137: 8240,
    138: 352,
    139: 8249,
    140: 338,
    142: 381,
    145: 8216,
    146: 8217,
    147: 8220,
    148: 8221,
    149: 8226,
    150: 8211,
    151: 8212,
    152: 732,
    153: 8482,
    154: 353,
    155: 8250,
    156: 339,
    158: 382,
    159: 376
}, $ef053115c0f9207e$var$No = 1, $ef053115c0f9207e$var$Io = 2, $ef053115c0f9207e$var$Oo = 4, $ef053115c0f9207e$var$r0 = $ef053115c0f9207e$var$No | $ef053115c0f9207e$var$Io | $ef053115c0f9207e$var$Oo, $ef053115c0f9207e$var$j = "DATA_STATE", $ef053115c0f9207e$var$v1 = "RCDATA_STATE", $ef053115c0f9207e$var$ot = "RAWTEXT_STATE", $ef053115c0f9207e$var$a1 = "SCRIPT_DATA_STATE", $ef053115c0f9207e$var$Ro = "PLAINTEXT_STATE", $ef053115c0f9207e$var$ui = "TAG_OPEN_STATE", $ef053115c0f9207e$var$ci = "END_TAG_OPEN_STATE", $ef053115c0f9207e$var$Nn = "TAG_NAME_STATE", $ef053115c0f9207e$var$hi = "RCDATA_LESS_THAN_SIGN_STATE", $ef053115c0f9207e$var$fi = "RCDATA_END_TAG_OPEN_STATE", $ef053115c0f9207e$var$Ti = "RCDATA_END_TAG_NAME_STATE", $ef053115c0f9207e$var$di = "RAWTEXT_LESS_THAN_SIGN_STATE", $ef053115c0f9207e$var$mi = "RAWTEXT_END_TAG_OPEN_STATE", $ef053115c0f9207e$var$pi = "RAWTEXT_END_TAG_NAME_STATE", $ef053115c0f9207e$var$Ei = "SCRIPT_DATA_LESS_THAN_SIGN_STATE", $ef053115c0f9207e$var$_i = "SCRIPT_DATA_END_TAG_OPEN_STATE", $ef053115c0f9207e$var$gi = "SCRIPT_DATA_END_TAG_NAME_STATE", $ef053115c0f9207e$var$Ai = "SCRIPT_DATA_ESCAPE_START_STATE", $ef053115c0f9207e$var$Ci = "SCRIPT_DATA_ESCAPE_START_DASH_STATE", $ef053115c0f9207e$var$ve = "SCRIPT_DATA_ESCAPED_STATE", $ef053115c0f9207e$var$Si = "SCRIPT_DATA_ESCAPED_DASH_STATE", $ef053115c0f9207e$var$In = "SCRIPT_DATA_ESCAPED_DASH_DASH_STATE", $ef053115c0f9207e$var$St = "SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE", $ef053115c0f9207e$var$Ni = "SCRIPT_DATA_ESCAPED_END_TAG_OPEN_STATE", $ef053115c0f9207e$var$Ii = "SCRIPT_DATA_ESCAPED_END_TAG_NAME_STATE", $ef053115c0f9207e$var$Oi = "SCRIPT_DATA_DOUBLE_ESCAPE_START_STATE", $ef053115c0f9207e$var$n1 = "SCRIPT_DATA_DOUBLE_ESCAPED_STATE", $ef053115c0f9207e$var$Ri = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_STATE", $ef053115c0f9207e$var$xi = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH_STATE", $ef053115c0f9207e$var$Nt = "SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE", $ef053115c0f9207e$var$yi = "SCRIPT_DATA_DOUBLE_ESCAPE_END_STATE", $ef053115c0f9207e$var$We = "BEFORE_ATTRIBUTE_NAME_STATE", $ef053115c0f9207e$var$It = "ATTRIBUTE_NAME_STATE", $ef053115c0f9207e$var$On = "AFTER_ATTRIBUTE_NAME_STATE", $ef053115c0f9207e$var$Rn = "BEFORE_ATTRIBUTE_VALUE_STATE", $ef053115c0f9207e$var$Ot = "ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE", $ef053115c0f9207e$var$Rt = "ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE", $ef053115c0f9207e$var$xt = "ATTRIBUTE_VALUE_UNQUOTED_STATE", $ef053115c0f9207e$var$xn = "AFTER_ATTRIBUTE_VALUE_QUOTED_STATE", $ef053115c0f9207e$var$c1 = "SELF_CLOSING_START_TAG_STATE", $ef053115c0f9207e$var$J1 = "BOGUS_COMMENT_STATE", $ef053115c0f9207e$var$ki = "MARKUP_DECLARATION_OPEN_STATE", $ef053115c0f9207e$var$Li = "COMMENT_START_STATE", $ef053115c0f9207e$var$Mi = "COMMENT_START_DASH_STATE", $ef053115c0f9207e$var$h1 = "COMMENT_STATE", $ef053115c0f9207e$var$bi = "COMMENT_LESS_THAN_SIGN_STATE", $ef053115c0f9207e$var$Pi = "COMMENT_LESS_THAN_SIGN_BANG_STATE", $ef053115c0f9207e$var$Di = "COMMENT_LESS_THAN_SIGN_BANG_DASH_STATE", $ef053115c0f9207e$var$wi = "COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH_STATE", $ef053115c0f9207e$var$yt = "COMMENT_END_DASH_STATE", $ef053115c0f9207e$var$kt = "COMMENT_END_STATE", $ef053115c0f9207e$var$Fi = "COMMENT_END_BANG_STATE", $ef053115c0f9207e$var$Hi = "DOCTYPE_STATE", $ef053115c0f9207e$var$Lt = "BEFORE_DOCTYPE_NAME_STATE", $ef053115c0f9207e$var$Mt = "DOCTYPE_NAME_STATE", $ef053115c0f9207e$var$Bi = "AFTER_DOCTYPE_NAME_STATE", $ef053115c0f9207e$var$Ui = "AFTER_DOCTYPE_PUBLIC_KEYWORD_STATE", $ef053115c0f9207e$var$vi = "BEFORE_DOCTYPE_PUBLIC_IDENTIFIER_STATE", $ef053115c0f9207e$var$yn = "DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE", $ef053115c0f9207e$var$kn = "DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE", $ef053115c0f9207e$var$Ln = "AFTER_DOCTYPE_PUBLIC_IDENTIFIER_STATE", $ef053115c0f9207e$var$Gi = "BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE", $ef053115c0f9207e$var$Ki = "AFTER_DOCTYPE_SYSTEM_KEYWORD_STATE", $ef053115c0f9207e$var$zi = "BEFORE_DOCTYPE_SYSTEM_IDENTIFIER_STATE", $ef053115c0f9207e$var$Z1 = "DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE", $ef053115c0f9207e$var$et = "DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE", $ef053115c0f9207e$var$Mn = "AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE", $ef053115c0f9207e$var$r1 = "BOGUS_DOCTYPE_STATE", $ef053115c0f9207e$var$bt = "CDATA_SECTION_STATE", $ef053115c0f9207e$var$Yi = "CDATA_SECTION_BRACKET_STATE", $ef053115c0f9207e$var$ji = "CDATA_SECTION_END_STATE", $ef053115c0f9207e$var$w1 = "CHARACTER_REFERENCE_STATE", $ef053115c0f9207e$var$$i = "NAMED_CHARACTER_REFERENCE_STATE", $ef053115c0f9207e$var$Qi = "AMBIGUOS_AMPERSAND_STATE", $ef053115c0f9207e$var$Wi = "NUMERIC_CHARACTER_REFERENCE_STATE", $ef053115c0f9207e$var$qi = "HEXADEMICAL_CHARACTER_REFERENCE_START_STATE", $ef053115c0f9207e$var$Vi = "DECIMAL_CHARACTER_REFERENCE_START_STATE", $ef053115c0f9207e$var$Xi = "HEXADEMICAL_CHARACTER_REFERENCE_STATE", $ef053115c0f9207e$var$Ji = "DECIMAL_CHARACTER_REFERENCE_STATE", $ef053115c0f9207e$var$tt = "NUMERIC_CHARACTER_REFERENCE_END_STATE";
function $ef053115c0f9207e$var$ne(e) {
    return e === $ef053115c0f9207e$var$f.SPACE || e === $ef053115c0f9207e$var$f.LINE_FEED || e === $ef053115c0f9207e$var$f.TABULATION || e === $ef053115c0f9207e$var$f.FORM_FEED;
}
function $ef053115c0f9207e$var$ut(e) {
    return e >= $ef053115c0f9207e$var$f.DIGIT_0 && e <= $ef053115c0f9207e$var$f.DIGIT_9;
}
function $ef053115c0f9207e$var$Ge(e) {
    return e >= $ef053115c0f9207e$var$f.LATIN_CAPITAL_A && e <= $ef053115c0f9207e$var$f.LATIN_CAPITAL_Z;
}
function $ef053115c0f9207e$var$I1(e) {
    return e >= $ef053115c0f9207e$var$f.LATIN_SMALL_A && e <= $ef053115c0f9207e$var$f.LATIN_SMALL_Z;
}
function $ef053115c0f9207e$var$d1(e) {
    return $ef053115c0f9207e$var$I1(e) || $ef053115c0f9207e$var$Ge(e);
}
function $ef053115c0f9207e$var$bn(e) {
    return $ef053115c0f9207e$var$d1(e) || $ef053115c0f9207e$var$ut(e);
}
function $ef053115c0f9207e$var$xo(e) {
    return e >= $ef053115c0f9207e$var$f.LATIN_CAPITAL_A && e <= $ef053115c0f9207e$var$f.LATIN_CAPITAL_F;
}
function $ef053115c0f9207e$var$yo(e) {
    return e >= $ef053115c0f9207e$var$f.LATIN_SMALL_A && e <= $ef053115c0f9207e$var$f.LATIN_SMALL_F;
}
function $ef053115c0f9207e$var$i0(e) {
    return $ef053115c0f9207e$var$ut(e) || $ef053115c0f9207e$var$xo(e) || $ef053115c0f9207e$var$yo(e);
}
function $ef053115c0f9207e$var$Kt(e) {
    return e + 32;
}
function $ef053115c0f9207e$var$ie(e) {
    return e <= 65535 ? String.fromCharCode(e) : (e -= 65536, String.fromCharCode(e >>> 10 & 1023 | 55296) + String.fromCharCode(56320 | e & 1023));
}
function $ef053115c0f9207e$var$f1(e) {
    return String.fromCharCode($ef053115c0f9207e$var$Kt(e));
}
function $ef053115c0f9207e$var$Zi(e, t) {
    const n = $ef053115c0f9207e$var$O1[++e];
    let r = ++e, i = r + n - 1;
    for(; r <= i;){
        const s = r + i >>> 1, o = $ef053115c0f9207e$var$O1[s];
        if (o < t) r = s + 1;
        else if (o > t) i = s - 1;
        else return $ef053115c0f9207e$var$O1[s + n];
    }
    return -1;
}
let $ef053115c0f9207e$var$He = class Ie {
    constructor(){
        this.preprocessor = new $ef053115c0f9207e$var$t0(), this.tokenQueue = [], this.allowCDATA = !1, this.state = $ef053115c0f9207e$var$j, this.returnState = "", this.charRefCode = -1, this.tempBuff = [], this.lastStartTagName = "", this.consumedAfterSnapshot = -1, this.active = !1, this.currentCharacterToken = null, this.currentToken = null, this.currentAttr = null;
    }
    //Errors
    _err() {}
    _errOnNextCodePoint(t) {
        this._consume(), this._err(t), this._unconsume();
    }
    //API
    getNextToken() {
        for(; !this.tokenQueue.length && this.active;){
            this.consumedAfterSnapshot = 0;
            const t = this._consume();
            this._ensureHibernation() || this[this.state](t);
        }
        return this.tokenQueue.shift();
    }
    write(t, n) {
        this.active = !0, this.preprocessor.write(t, n);
    }
    insertHtmlAtCurrentPos(t) {
        this.active = !0, this.preprocessor.insertHtmlAtCurrentPos(t);
    }
    //Hibernation
    _ensureHibernation() {
        if (this.preprocessor.endOfChunkHit) {
            for(; this.consumedAfterSnapshot > 0; this.consumedAfterSnapshot--)this.preprocessor.retreat();
            return this.active = !1, this.tokenQueue.push({
                type: Ie.HIBERNATION_TOKEN
            }), !0;
        }
        return !1;
    }
    //Consumption
    _consume() {
        return this.consumedAfterSnapshot++, this.preprocessor.advance();
    }
    _unconsume() {
        this.consumedAfterSnapshot--, this.preprocessor.retreat();
    }
    _reconsumeInState(t) {
        this.state = t, this._unconsume();
    }
    _consumeSequenceIfMatch(t, n, r) {
        let i = 0, s = !0;
        const o = t.length;
        let l = 0, u = n, c;
        for(; l < o; l++){
            if (l > 0 && (u = this._consume(), i++), u === $ef053115c0f9207e$var$f.EOF) {
                s = !1;
                break;
            }
            if (c = t[l], u !== c && (r || u !== $ef053115c0f9207e$var$Kt(c))) {
                s = !1;
                break;
            }
        }
        if (!s) for(; i--;)this._unconsume();
        return s;
    }
    //Temp buffer
    _isTempBufferEqualToScriptString() {
        if (this.tempBuff.length !== $ef053115c0f9207e$var$S1.SCRIPT_STRING.length) return !1;
        for(let t = 0; t < this.tempBuff.length; t++)if (this.tempBuff[t] !== $ef053115c0f9207e$var$S1.SCRIPT_STRING[t]) return !1;
        return !0;
    }
    //Token creation
    _createStartTagToken() {
        this.currentToken = {
            type: Ie.START_TAG_TOKEN,
            tagName: "",
            selfClosing: !1,
            ackSelfClosing: !1,
            attrs: []
        };
    }
    _createEndTagToken() {
        this.currentToken = {
            type: Ie.END_TAG_TOKEN,
            tagName: "",
            selfClosing: !1,
            attrs: []
        };
    }
    _createCommentToken() {
        this.currentToken = {
            type: Ie.COMMENT_TOKEN,
            data: ""
        };
    }
    _createDoctypeToken(t) {
        this.currentToken = {
            type: Ie.DOCTYPE_TOKEN,
            name: t,
            forceQuirks: !1,
            publicId: null,
            systemId: null
        };
    }
    _createCharacterToken(t, n) {
        this.currentCharacterToken = {
            type: t,
            chars: n
        };
    }
    _createEOFToken() {
        this.currentToken = {
            type: Ie.EOF_TOKEN
        };
    }
    //Tag attributes
    _createAttr(t) {
        this.currentAttr = {
            name: t,
            value: ""
        };
    }
    _leaveAttrName(t) {
        Ie.getTokenAttr(this.currentToken, this.currentAttr.name) === null ? this.currentToken.attrs.push(this.currentAttr) : this._err($ef053115c0f9207e$var$C.duplicateAttribute), this.state = t;
    }
    _leaveAttrValue(t) {
        this.state = t;
    }
    //Token emission
    _emitCurrentToken() {
        this._emitCurrentCharacterToken();
        const t = this.currentToken;
        this.currentToken = null, t.type === Ie.START_TAG_TOKEN ? this.lastStartTagName = t.tagName : t.type === Ie.END_TAG_TOKEN && (t.attrs.length > 0 && this._err($ef053115c0f9207e$var$C.endTagWithAttributes), t.selfClosing && this._err($ef053115c0f9207e$var$C.endTagWithTrailingSolidus)), this.tokenQueue.push(t);
    }
    _emitCurrentCharacterToken() {
        this.currentCharacterToken && (this.tokenQueue.push(this.currentCharacterToken), this.currentCharacterToken = null);
    }
    _emitEOFToken() {
        this._createEOFToken(), this._emitCurrentToken();
    }
    //Characters emission
    //OPTIMIZATION: specification uses only one type of character tokens (one token per character).
    //This causes a huge memory overhead and a lot of unnecessary parser loops. parse5 uses 3 groups of characters.
    //If we have a sequence of characters that belong to the same group, parser can process it
    //as a single solid character token.
    //So, there are 3 types of character tokens in parse5:
    //1)NULL_CHARACTER_TOKEN - \u0000-character sequences (e.g. '\u0000\u0000\u0000')
    //2)WHITESPACE_CHARACTER_TOKEN - any whitespace/new-line character sequences (e.g. '\n  \r\t   \f')
    //3)CHARACTER_TOKEN - any character sequence which don't belong to groups 1 and 2 (e.g. 'abcdef1234@@#$%^')
    _appendCharToCurrentCharacterToken(t, n) {
        this.currentCharacterToken && this.currentCharacterToken.type !== t && this._emitCurrentCharacterToken(), this.currentCharacterToken ? this.currentCharacterToken.chars += n : this._createCharacterToken(t, n);
    }
    _emitCodePoint(t) {
        let n = Ie.CHARACTER_TOKEN;
        $ef053115c0f9207e$var$ne(t) ? n = Ie.WHITESPACE_CHARACTER_TOKEN : t === $ef053115c0f9207e$var$f.NULL && (n = Ie.NULL_CHARACTER_TOKEN), this._appendCharToCurrentCharacterToken(n, $ef053115c0f9207e$var$ie(t));
    }
    _emitSeveralCodePoints(t) {
        for(let n = 0; n < t.length; n++)this._emitCodePoint(t[n]);
    }
    //NOTE: used then we emit character explicitly. This is always a non-whitespace and a non-null character.
    //So we can avoid additional checks here.
    _emitChars(t) {
        this._appendCharToCurrentCharacterToken(Ie.CHARACTER_TOKEN, t);
    }
    // Character reference helpers
    _matchNamedCharacterReference(t) {
        let n = null, r = 1, i = $ef053115c0f9207e$var$Zi(0, t);
        for(this.tempBuff.push(t); i > -1;){
            const s = $ef053115c0f9207e$var$O1[i], o = s < $ef053115c0f9207e$var$r0;
            o && s & $ef053115c0f9207e$var$No && (n = s & $ef053115c0f9207e$var$Io ? [
                $ef053115c0f9207e$var$O1[++i],
                $ef053115c0f9207e$var$O1[++i]
            ] : [
                $ef053115c0f9207e$var$O1[++i]
            ], r = 0);
            const u = this._consume();
            if (this.tempBuff.push(u), r++, u === $ef053115c0f9207e$var$f.EOF) break;
            o ? i = s & $ef053115c0f9207e$var$Oo ? $ef053115c0f9207e$var$Zi(i, u) : -1 : i = u === s ? ++i : -1;
        }
        for(; r--;)this.tempBuff.pop(), this._unconsume();
        return n;
    }
    _isCharacterReferenceInAttribute() {
        return this.returnState === $ef053115c0f9207e$var$Ot || this.returnState === $ef053115c0f9207e$var$Rt || this.returnState === $ef053115c0f9207e$var$xt;
    }
    _isCharacterReferenceAttributeQuirk(t) {
        if (!t && this._isCharacterReferenceInAttribute()) {
            const n = this._consume();
            return this._unconsume(), n === $ef053115c0f9207e$var$f.EQUALS_SIGN || $ef053115c0f9207e$var$bn(n);
        }
        return !1;
    }
    _flushCodePointsConsumedAsCharacterReference() {
        if (this._isCharacterReferenceInAttribute()) for(let t = 0; t < this.tempBuff.length; t++)this.currentAttr.value += $ef053115c0f9207e$var$ie(this.tempBuff[t]);
        else this._emitSeveralCodePoints(this.tempBuff);
        this.tempBuff = [];
    }
    // State machine
    // Data state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$j](t) {
        this.preprocessor.dropParsedChunk(), t === $ef053115c0f9207e$var$f.LESS_THAN_SIGN ? this.state = $ef053115c0f9207e$var$ui : t === $ef053115c0f9207e$var$f.AMPERSAND ? (this.returnState = $ef053115c0f9207e$var$j, this.state = $ef053115c0f9207e$var$w1) : t === $ef053115c0f9207e$var$f.NULL ? (this._err($ef053115c0f9207e$var$C.unexpectedNullCharacter), this._emitCodePoint(t)) : t === $ef053115c0f9207e$var$f.EOF ? this._emitEOFToken() : this._emitCodePoint(t);
    }
    //  RCDATA state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$v1](t) {
        this.preprocessor.dropParsedChunk(), t === $ef053115c0f9207e$var$f.AMPERSAND ? (this.returnState = $ef053115c0f9207e$var$v1, this.state = $ef053115c0f9207e$var$w1) : t === $ef053115c0f9207e$var$f.LESS_THAN_SIGN ? this.state = $ef053115c0f9207e$var$hi : t === $ef053115c0f9207e$var$f.NULL ? (this._err($ef053115c0f9207e$var$C.unexpectedNullCharacter), this._emitChars($ef053115c0f9207e$var$X.REPLACEMENT_CHARACTER)) : t === $ef053115c0f9207e$var$f.EOF ? this._emitEOFToken() : this._emitCodePoint(t);
    }
    // RAWTEXT state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$ot](t) {
        this.preprocessor.dropParsedChunk(), t === $ef053115c0f9207e$var$f.LESS_THAN_SIGN ? this.state = $ef053115c0f9207e$var$di : t === $ef053115c0f9207e$var$f.NULL ? (this._err($ef053115c0f9207e$var$C.unexpectedNullCharacter), this._emitChars($ef053115c0f9207e$var$X.REPLACEMENT_CHARACTER)) : t === $ef053115c0f9207e$var$f.EOF ? this._emitEOFToken() : this._emitCodePoint(t);
    }
    // Script data state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$a1](t) {
        this.preprocessor.dropParsedChunk(), t === $ef053115c0f9207e$var$f.LESS_THAN_SIGN ? this.state = $ef053115c0f9207e$var$Ei : t === $ef053115c0f9207e$var$f.NULL ? (this._err($ef053115c0f9207e$var$C.unexpectedNullCharacter), this._emitChars($ef053115c0f9207e$var$X.REPLACEMENT_CHARACTER)) : t === $ef053115c0f9207e$var$f.EOF ? this._emitEOFToken() : this._emitCodePoint(t);
    }
    // PLAINTEXT state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$Ro](t) {
        this.preprocessor.dropParsedChunk(), t === $ef053115c0f9207e$var$f.NULL ? (this._err($ef053115c0f9207e$var$C.unexpectedNullCharacter), this._emitChars($ef053115c0f9207e$var$X.REPLACEMENT_CHARACTER)) : t === $ef053115c0f9207e$var$f.EOF ? this._emitEOFToken() : this._emitCodePoint(t);
    }
    // Tag open state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$ui](t) {
        t === $ef053115c0f9207e$var$f.EXCLAMATION_MARK ? this.state = $ef053115c0f9207e$var$ki : t === $ef053115c0f9207e$var$f.SOLIDUS ? this.state = $ef053115c0f9207e$var$ci : $ef053115c0f9207e$var$d1(t) ? (this._createStartTagToken(), this._reconsumeInState($ef053115c0f9207e$var$Nn)) : t === $ef053115c0f9207e$var$f.QUESTION_MARK ? (this._err($ef053115c0f9207e$var$C.unexpectedQuestionMarkInsteadOfTagName), this._createCommentToken(), this._reconsumeInState($ef053115c0f9207e$var$J1)) : t === $ef053115c0f9207e$var$f.EOF ? (this._err($ef053115c0f9207e$var$C.eofBeforeTagName), this._emitChars("<"), this._emitEOFToken()) : (this._err($ef053115c0f9207e$var$C.invalidFirstCharacterOfTagName), this._emitChars("<"), this._reconsumeInState($ef053115c0f9207e$var$j));
    }
    // End tag open state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$ci](t) {
        $ef053115c0f9207e$var$d1(t) ? (this._createEndTagToken(), this._reconsumeInState($ef053115c0f9207e$var$Nn)) : t === $ef053115c0f9207e$var$f.GREATER_THAN_SIGN ? (this._err($ef053115c0f9207e$var$C.missingEndTagName), this.state = $ef053115c0f9207e$var$j) : t === $ef053115c0f9207e$var$f.EOF ? (this._err($ef053115c0f9207e$var$C.eofBeforeTagName), this._emitChars("</"), this._emitEOFToken()) : (this._err($ef053115c0f9207e$var$C.invalidFirstCharacterOfTagName), this._createCommentToken(), this._reconsumeInState($ef053115c0f9207e$var$J1));
    }
    // Tag name state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$Nn](t) {
        $ef053115c0f9207e$var$ne(t) ? this.state = $ef053115c0f9207e$var$We : t === $ef053115c0f9207e$var$f.SOLIDUS ? this.state = $ef053115c0f9207e$var$c1 : t === $ef053115c0f9207e$var$f.GREATER_THAN_SIGN ? (this.state = $ef053115c0f9207e$var$j, this._emitCurrentToken()) : $ef053115c0f9207e$var$Ge(t) ? this.currentToken.tagName += $ef053115c0f9207e$var$f1(t) : t === $ef053115c0f9207e$var$f.NULL ? (this._err($ef053115c0f9207e$var$C.unexpectedNullCharacter), this.currentToken.tagName += $ef053115c0f9207e$var$X.REPLACEMENT_CHARACTER) : t === $ef053115c0f9207e$var$f.EOF ? (this._err($ef053115c0f9207e$var$C.eofInTag), this._emitEOFToken()) : this.currentToken.tagName += $ef053115c0f9207e$var$ie(t);
    }
    // RCDATA less-than sign state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$hi](t) {
        t === $ef053115c0f9207e$var$f.SOLIDUS ? (this.tempBuff = [], this.state = $ef053115c0f9207e$var$fi) : (this._emitChars("<"), this._reconsumeInState($ef053115c0f9207e$var$v1));
    }
    // RCDATA end tag open state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$fi](t) {
        $ef053115c0f9207e$var$d1(t) ? (this._createEndTagToken(), this._reconsumeInState($ef053115c0f9207e$var$Ti)) : (this._emitChars("</"), this._reconsumeInState($ef053115c0f9207e$var$v1));
    }
    // RCDATA end tag name state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$Ti](t) {
        if ($ef053115c0f9207e$var$Ge(t)) this.currentToken.tagName += $ef053115c0f9207e$var$f1(t), this.tempBuff.push(t);
        else if ($ef053115c0f9207e$var$I1(t)) this.currentToken.tagName += $ef053115c0f9207e$var$ie(t), this.tempBuff.push(t);
        else {
            if (this.lastStartTagName === this.currentToken.tagName) {
                if ($ef053115c0f9207e$var$ne(t)) {
                    this.state = $ef053115c0f9207e$var$We;
                    return;
                }
                if (t === $ef053115c0f9207e$var$f.SOLIDUS) {
                    this.state = $ef053115c0f9207e$var$c1;
                    return;
                }
                if (t === $ef053115c0f9207e$var$f.GREATER_THAN_SIGN) {
                    this.state = $ef053115c0f9207e$var$j, this._emitCurrentToken();
                    return;
                }
            }
            this._emitChars("</"), this._emitSeveralCodePoints(this.tempBuff), this._reconsumeInState($ef053115c0f9207e$var$v1);
        }
    }
    // RAWTEXT less-than sign state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$di](t) {
        t === $ef053115c0f9207e$var$f.SOLIDUS ? (this.tempBuff = [], this.state = $ef053115c0f9207e$var$mi) : (this._emitChars("<"), this._reconsumeInState($ef053115c0f9207e$var$ot));
    }
    // RAWTEXT end tag open state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$mi](t) {
        $ef053115c0f9207e$var$d1(t) ? (this._createEndTagToken(), this._reconsumeInState($ef053115c0f9207e$var$pi)) : (this._emitChars("</"), this._reconsumeInState($ef053115c0f9207e$var$ot));
    }
    // RAWTEXT end tag name state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$pi](t) {
        if ($ef053115c0f9207e$var$Ge(t)) this.currentToken.tagName += $ef053115c0f9207e$var$f1(t), this.tempBuff.push(t);
        else if ($ef053115c0f9207e$var$I1(t)) this.currentToken.tagName += $ef053115c0f9207e$var$ie(t), this.tempBuff.push(t);
        else {
            if (this.lastStartTagName === this.currentToken.tagName) {
                if ($ef053115c0f9207e$var$ne(t)) {
                    this.state = $ef053115c0f9207e$var$We;
                    return;
                }
                if (t === $ef053115c0f9207e$var$f.SOLIDUS) {
                    this.state = $ef053115c0f9207e$var$c1;
                    return;
                }
                if (t === $ef053115c0f9207e$var$f.GREATER_THAN_SIGN) {
                    this._emitCurrentToken(), this.state = $ef053115c0f9207e$var$j;
                    return;
                }
            }
            this._emitChars("</"), this._emitSeveralCodePoints(this.tempBuff), this._reconsumeInState($ef053115c0f9207e$var$ot);
        }
    }
    // Script data less-than sign state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$Ei](t) {
        t === $ef053115c0f9207e$var$f.SOLIDUS ? (this.tempBuff = [], this.state = $ef053115c0f9207e$var$_i) : t === $ef053115c0f9207e$var$f.EXCLAMATION_MARK ? (this.state = $ef053115c0f9207e$var$Ai, this._emitChars("<!")) : (this._emitChars("<"), this._reconsumeInState($ef053115c0f9207e$var$a1));
    }
    // Script data end tag open state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$_i](t) {
        $ef053115c0f9207e$var$d1(t) ? (this._createEndTagToken(), this._reconsumeInState($ef053115c0f9207e$var$gi)) : (this._emitChars("</"), this._reconsumeInState($ef053115c0f9207e$var$a1));
    }
    // Script data end tag name state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$gi](t) {
        if ($ef053115c0f9207e$var$Ge(t)) this.currentToken.tagName += $ef053115c0f9207e$var$f1(t), this.tempBuff.push(t);
        else if ($ef053115c0f9207e$var$I1(t)) this.currentToken.tagName += $ef053115c0f9207e$var$ie(t), this.tempBuff.push(t);
        else {
            if (this.lastStartTagName === this.currentToken.tagName) {
                if ($ef053115c0f9207e$var$ne(t)) {
                    this.state = $ef053115c0f9207e$var$We;
                    return;
                } else if (t === $ef053115c0f9207e$var$f.SOLIDUS) {
                    this.state = $ef053115c0f9207e$var$c1;
                    return;
                } else if (t === $ef053115c0f9207e$var$f.GREATER_THAN_SIGN) {
                    this._emitCurrentToken(), this.state = $ef053115c0f9207e$var$j;
                    return;
                }
            }
            this._emitChars("</"), this._emitSeveralCodePoints(this.tempBuff), this._reconsumeInState($ef053115c0f9207e$var$a1);
        }
    }
    // Script data escape start state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$Ai](t) {
        t === $ef053115c0f9207e$var$f.HYPHEN_MINUS ? (this.state = $ef053115c0f9207e$var$Ci, this._emitChars("-")) : this._reconsumeInState($ef053115c0f9207e$var$a1);
    }
    // Script data escape start dash state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$Ci](t) {
        t === $ef053115c0f9207e$var$f.HYPHEN_MINUS ? (this.state = $ef053115c0f9207e$var$In, this._emitChars("-")) : this._reconsumeInState($ef053115c0f9207e$var$a1);
    }
    // Script data escaped state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$ve](t) {
        t === $ef053115c0f9207e$var$f.HYPHEN_MINUS ? (this.state = $ef053115c0f9207e$var$Si, this._emitChars("-")) : t === $ef053115c0f9207e$var$f.LESS_THAN_SIGN ? this.state = $ef053115c0f9207e$var$St : t === $ef053115c0f9207e$var$f.NULL ? (this._err($ef053115c0f9207e$var$C.unexpectedNullCharacter), this._emitChars($ef053115c0f9207e$var$X.REPLACEMENT_CHARACTER)) : t === $ef053115c0f9207e$var$f.EOF ? (this._err($ef053115c0f9207e$var$C.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : this._emitCodePoint(t);
    }
    // Script data escaped dash state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$Si](t) {
        t === $ef053115c0f9207e$var$f.HYPHEN_MINUS ? (this.state = $ef053115c0f9207e$var$In, this._emitChars("-")) : t === $ef053115c0f9207e$var$f.LESS_THAN_SIGN ? this.state = $ef053115c0f9207e$var$St : t === $ef053115c0f9207e$var$f.NULL ? (this._err($ef053115c0f9207e$var$C.unexpectedNullCharacter), this.state = $ef053115c0f9207e$var$ve, this._emitChars($ef053115c0f9207e$var$X.REPLACEMENT_CHARACTER)) : t === $ef053115c0f9207e$var$f.EOF ? (this._err($ef053115c0f9207e$var$C.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : (this.state = $ef053115c0f9207e$var$ve, this._emitCodePoint(t));
    }
    // Script data escaped dash dash state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$In](t) {
        t === $ef053115c0f9207e$var$f.HYPHEN_MINUS ? this._emitChars("-") : t === $ef053115c0f9207e$var$f.LESS_THAN_SIGN ? this.state = $ef053115c0f9207e$var$St : t === $ef053115c0f9207e$var$f.GREATER_THAN_SIGN ? (this.state = $ef053115c0f9207e$var$a1, this._emitChars(">")) : t === $ef053115c0f9207e$var$f.NULL ? (this._err($ef053115c0f9207e$var$C.unexpectedNullCharacter), this.state = $ef053115c0f9207e$var$ve, this._emitChars($ef053115c0f9207e$var$X.REPLACEMENT_CHARACTER)) : t === $ef053115c0f9207e$var$f.EOF ? (this._err($ef053115c0f9207e$var$C.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : (this.state = $ef053115c0f9207e$var$ve, this._emitCodePoint(t));
    }
    // Script data escaped less-than sign state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$St](t) {
        t === $ef053115c0f9207e$var$f.SOLIDUS ? (this.tempBuff = [], this.state = $ef053115c0f9207e$var$Ni) : $ef053115c0f9207e$var$d1(t) ? (this.tempBuff = [], this._emitChars("<"), this._reconsumeInState($ef053115c0f9207e$var$Oi)) : (this._emitChars("<"), this._reconsumeInState($ef053115c0f9207e$var$ve));
    }
    // Script data escaped end tag open state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$Ni](t) {
        $ef053115c0f9207e$var$d1(t) ? (this._createEndTagToken(), this._reconsumeInState($ef053115c0f9207e$var$Ii)) : (this._emitChars("</"), this._reconsumeInState($ef053115c0f9207e$var$ve));
    }
    // Script data escaped end tag name state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$Ii](t) {
        if ($ef053115c0f9207e$var$Ge(t)) this.currentToken.tagName += $ef053115c0f9207e$var$f1(t), this.tempBuff.push(t);
        else if ($ef053115c0f9207e$var$I1(t)) this.currentToken.tagName += $ef053115c0f9207e$var$ie(t), this.tempBuff.push(t);
        else {
            if (this.lastStartTagName === this.currentToken.tagName) {
                if ($ef053115c0f9207e$var$ne(t)) {
                    this.state = $ef053115c0f9207e$var$We;
                    return;
                }
                if (t === $ef053115c0f9207e$var$f.SOLIDUS) {
                    this.state = $ef053115c0f9207e$var$c1;
                    return;
                }
                if (t === $ef053115c0f9207e$var$f.GREATER_THAN_SIGN) {
                    this._emitCurrentToken(), this.state = $ef053115c0f9207e$var$j;
                    return;
                }
            }
            this._emitChars("</"), this._emitSeveralCodePoints(this.tempBuff), this._reconsumeInState($ef053115c0f9207e$var$ve);
        }
    }
    // Script data double escape start state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$Oi](t) {
        $ef053115c0f9207e$var$ne(t) || t === $ef053115c0f9207e$var$f.SOLIDUS || t === $ef053115c0f9207e$var$f.GREATER_THAN_SIGN ? (this.state = this._isTempBufferEqualToScriptString() ? $ef053115c0f9207e$var$n1 : $ef053115c0f9207e$var$ve, this._emitCodePoint(t)) : $ef053115c0f9207e$var$Ge(t) ? (this.tempBuff.push($ef053115c0f9207e$var$Kt(t)), this._emitCodePoint(t)) : $ef053115c0f9207e$var$I1(t) ? (this.tempBuff.push(t), this._emitCodePoint(t)) : this._reconsumeInState($ef053115c0f9207e$var$ve);
    }
    // Script data double escaped state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$n1](t) {
        t === $ef053115c0f9207e$var$f.HYPHEN_MINUS ? (this.state = $ef053115c0f9207e$var$Ri, this._emitChars("-")) : t === $ef053115c0f9207e$var$f.LESS_THAN_SIGN ? (this.state = $ef053115c0f9207e$var$Nt, this._emitChars("<")) : t === $ef053115c0f9207e$var$f.NULL ? (this._err($ef053115c0f9207e$var$C.unexpectedNullCharacter), this._emitChars($ef053115c0f9207e$var$X.REPLACEMENT_CHARACTER)) : t === $ef053115c0f9207e$var$f.EOF ? (this._err($ef053115c0f9207e$var$C.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : this._emitCodePoint(t);
    }
    // Script data double escaped dash state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$Ri](t) {
        t === $ef053115c0f9207e$var$f.HYPHEN_MINUS ? (this.state = $ef053115c0f9207e$var$xi, this._emitChars("-")) : t === $ef053115c0f9207e$var$f.LESS_THAN_SIGN ? (this.state = $ef053115c0f9207e$var$Nt, this._emitChars("<")) : t === $ef053115c0f9207e$var$f.NULL ? (this._err($ef053115c0f9207e$var$C.unexpectedNullCharacter), this.state = $ef053115c0f9207e$var$n1, this._emitChars($ef053115c0f9207e$var$X.REPLACEMENT_CHARACTER)) : t === $ef053115c0f9207e$var$f.EOF ? (this._err($ef053115c0f9207e$var$C.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : (this.state = $ef053115c0f9207e$var$n1, this._emitCodePoint(t));
    }
    // Script data double escaped dash dash state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$xi](t) {
        t === $ef053115c0f9207e$var$f.HYPHEN_MINUS ? this._emitChars("-") : t === $ef053115c0f9207e$var$f.LESS_THAN_SIGN ? (this.state = $ef053115c0f9207e$var$Nt, this._emitChars("<")) : t === $ef053115c0f9207e$var$f.GREATER_THAN_SIGN ? (this.state = $ef053115c0f9207e$var$a1, this._emitChars(">")) : t === $ef053115c0f9207e$var$f.NULL ? (this._err($ef053115c0f9207e$var$C.unexpectedNullCharacter), this.state = $ef053115c0f9207e$var$n1, this._emitChars($ef053115c0f9207e$var$X.REPLACEMENT_CHARACTER)) : t === $ef053115c0f9207e$var$f.EOF ? (this._err($ef053115c0f9207e$var$C.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : (this.state = $ef053115c0f9207e$var$n1, this._emitCodePoint(t));
    }
    // Script data double escaped less-than sign state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$Nt](t) {
        t === $ef053115c0f9207e$var$f.SOLIDUS ? (this.tempBuff = [], this.state = $ef053115c0f9207e$var$yi, this._emitChars("/")) : this._reconsumeInState($ef053115c0f9207e$var$n1);
    }
    // Script data double escape end state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$yi](t) {
        $ef053115c0f9207e$var$ne(t) || t === $ef053115c0f9207e$var$f.SOLIDUS || t === $ef053115c0f9207e$var$f.GREATER_THAN_SIGN ? (this.state = this._isTempBufferEqualToScriptString() ? $ef053115c0f9207e$var$ve : $ef053115c0f9207e$var$n1, this._emitCodePoint(t)) : $ef053115c0f9207e$var$Ge(t) ? (this.tempBuff.push($ef053115c0f9207e$var$Kt(t)), this._emitCodePoint(t)) : $ef053115c0f9207e$var$I1(t) ? (this.tempBuff.push(t), this._emitCodePoint(t)) : this._reconsumeInState($ef053115c0f9207e$var$n1);
    }
    // Before attribute name state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$We](t) {
        $ef053115c0f9207e$var$ne(t) || (t === $ef053115c0f9207e$var$f.SOLIDUS || t === $ef053115c0f9207e$var$f.GREATER_THAN_SIGN || t === $ef053115c0f9207e$var$f.EOF ? this._reconsumeInState($ef053115c0f9207e$var$On) : t === $ef053115c0f9207e$var$f.EQUALS_SIGN ? (this._err($ef053115c0f9207e$var$C.unexpectedEqualsSignBeforeAttributeName), this._createAttr("="), this.state = $ef053115c0f9207e$var$It) : (this._createAttr(""), this._reconsumeInState($ef053115c0f9207e$var$It)));
    }
    // Attribute name state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$It](t) {
        $ef053115c0f9207e$var$ne(t) || t === $ef053115c0f9207e$var$f.SOLIDUS || t === $ef053115c0f9207e$var$f.GREATER_THAN_SIGN || t === $ef053115c0f9207e$var$f.EOF ? (this._leaveAttrName($ef053115c0f9207e$var$On), this._unconsume()) : t === $ef053115c0f9207e$var$f.EQUALS_SIGN ? this._leaveAttrName($ef053115c0f9207e$var$Rn) : $ef053115c0f9207e$var$Ge(t) ? this.currentAttr.name += $ef053115c0f9207e$var$f1(t) : t === $ef053115c0f9207e$var$f.QUOTATION_MARK || t === $ef053115c0f9207e$var$f.APOSTROPHE || t === $ef053115c0f9207e$var$f.LESS_THAN_SIGN ? (this._err($ef053115c0f9207e$var$C.unexpectedCharacterInAttributeName), this.currentAttr.name += $ef053115c0f9207e$var$ie(t)) : t === $ef053115c0f9207e$var$f.NULL ? (this._err($ef053115c0f9207e$var$C.unexpectedNullCharacter), this.currentAttr.name += $ef053115c0f9207e$var$X.REPLACEMENT_CHARACTER) : this.currentAttr.name += $ef053115c0f9207e$var$ie(t);
    }
    // After attribute name state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$On](t) {
        $ef053115c0f9207e$var$ne(t) || (t === $ef053115c0f9207e$var$f.SOLIDUS ? this.state = $ef053115c0f9207e$var$c1 : t === $ef053115c0f9207e$var$f.EQUALS_SIGN ? this.state = $ef053115c0f9207e$var$Rn : t === $ef053115c0f9207e$var$f.GREATER_THAN_SIGN ? (this.state = $ef053115c0f9207e$var$j, this._emitCurrentToken()) : t === $ef053115c0f9207e$var$f.EOF ? (this._err($ef053115c0f9207e$var$C.eofInTag), this._emitEOFToken()) : (this._createAttr(""), this._reconsumeInState($ef053115c0f9207e$var$It)));
    }
    // Before attribute value state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$Rn](t) {
        $ef053115c0f9207e$var$ne(t) || (t === $ef053115c0f9207e$var$f.QUOTATION_MARK ? this.state = $ef053115c0f9207e$var$Ot : t === $ef053115c0f9207e$var$f.APOSTROPHE ? this.state = $ef053115c0f9207e$var$Rt : t === $ef053115c0f9207e$var$f.GREATER_THAN_SIGN ? (this._err($ef053115c0f9207e$var$C.missingAttributeValue), this.state = $ef053115c0f9207e$var$j, this._emitCurrentToken()) : this._reconsumeInState($ef053115c0f9207e$var$xt));
    }
    // Attribute value (double-quoted) state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$Ot](t) {
        t === $ef053115c0f9207e$var$f.QUOTATION_MARK ? this.state = $ef053115c0f9207e$var$xn : t === $ef053115c0f9207e$var$f.AMPERSAND ? (this.returnState = $ef053115c0f9207e$var$Ot, this.state = $ef053115c0f9207e$var$w1) : t === $ef053115c0f9207e$var$f.NULL ? (this._err($ef053115c0f9207e$var$C.unexpectedNullCharacter), this.currentAttr.value += $ef053115c0f9207e$var$X.REPLACEMENT_CHARACTER) : t === $ef053115c0f9207e$var$f.EOF ? (this._err($ef053115c0f9207e$var$C.eofInTag), this._emitEOFToken()) : this.currentAttr.value += $ef053115c0f9207e$var$ie(t);
    }
    // Attribute value (single-quoted) state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$Rt](t) {
        t === $ef053115c0f9207e$var$f.APOSTROPHE ? this.state = $ef053115c0f9207e$var$xn : t === $ef053115c0f9207e$var$f.AMPERSAND ? (this.returnState = $ef053115c0f9207e$var$Rt, this.state = $ef053115c0f9207e$var$w1) : t === $ef053115c0f9207e$var$f.NULL ? (this._err($ef053115c0f9207e$var$C.unexpectedNullCharacter), this.currentAttr.value += $ef053115c0f9207e$var$X.REPLACEMENT_CHARACTER) : t === $ef053115c0f9207e$var$f.EOF ? (this._err($ef053115c0f9207e$var$C.eofInTag), this._emitEOFToken()) : this.currentAttr.value += $ef053115c0f9207e$var$ie(t);
    }
    // Attribute value (unquoted) state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$xt](t) {
        $ef053115c0f9207e$var$ne(t) ? this._leaveAttrValue($ef053115c0f9207e$var$We) : t === $ef053115c0f9207e$var$f.AMPERSAND ? (this.returnState = $ef053115c0f9207e$var$xt, this.state = $ef053115c0f9207e$var$w1) : t === $ef053115c0f9207e$var$f.GREATER_THAN_SIGN ? (this._leaveAttrValue($ef053115c0f9207e$var$j), this._emitCurrentToken()) : t === $ef053115c0f9207e$var$f.NULL ? (this._err($ef053115c0f9207e$var$C.unexpectedNullCharacter), this.currentAttr.value += $ef053115c0f9207e$var$X.REPLACEMENT_CHARACTER) : t === $ef053115c0f9207e$var$f.QUOTATION_MARK || t === $ef053115c0f9207e$var$f.APOSTROPHE || t === $ef053115c0f9207e$var$f.LESS_THAN_SIGN || t === $ef053115c0f9207e$var$f.EQUALS_SIGN || t === $ef053115c0f9207e$var$f.GRAVE_ACCENT ? (this._err($ef053115c0f9207e$var$C.unexpectedCharacterInUnquotedAttributeValue), this.currentAttr.value += $ef053115c0f9207e$var$ie(t)) : t === $ef053115c0f9207e$var$f.EOF ? (this._err($ef053115c0f9207e$var$C.eofInTag), this._emitEOFToken()) : this.currentAttr.value += $ef053115c0f9207e$var$ie(t);
    }
    // After attribute value (quoted) state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$xn](t) {
        $ef053115c0f9207e$var$ne(t) ? this._leaveAttrValue($ef053115c0f9207e$var$We) : t === $ef053115c0f9207e$var$f.SOLIDUS ? this._leaveAttrValue($ef053115c0f9207e$var$c1) : t === $ef053115c0f9207e$var$f.GREATER_THAN_SIGN ? (this._leaveAttrValue($ef053115c0f9207e$var$j), this._emitCurrentToken()) : t === $ef053115c0f9207e$var$f.EOF ? (this._err($ef053115c0f9207e$var$C.eofInTag), this._emitEOFToken()) : (this._err($ef053115c0f9207e$var$C.missingWhitespaceBetweenAttributes), this._reconsumeInState($ef053115c0f9207e$var$We));
    }
    // Self-closing start tag state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$c1](t) {
        t === $ef053115c0f9207e$var$f.GREATER_THAN_SIGN ? (this.currentToken.selfClosing = !0, this.state = $ef053115c0f9207e$var$j, this._emitCurrentToken()) : t === $ef053115c0f9207e$var$f.EOF ? (this._err($ef053115c0f9207e$var$C.eofInTag), this._emitEOFToken()) : (this._err($ef053115c0f9207e$var$C.unexpectedSolidusInTag), this._reconsumeInState($ef053115c0f9207e$var$We));
    }
    // Bogus comment state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$J1](t) {
        t === $ef053115c0f9207e$var$f.GREATER_THAN_SIGN ? (this.state = $ef053115c0f9207e$var$j, this._emitCurrentToken()) : t === $ef053115c0f9207e$var$f.EOF ? (this._emitCurrentToken(), this._emitEOFToken()) : t === $ef053115c0f9207e$var$f.NULL ? (this._err($ef053115c0f9207e$var$C.unexpectedNullCharacter), this.currentToken.data += $ef053115c0f9207e$var$X.REPLACEMENT_CHARACTER) : this.currentToken.data += $ef053115c0f9207e$var$ie(t);
    }
    // Markup declaration open state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$ki](t) {
        this._consumeSequenceIfMatch($ef053115c0f9207e$var$S1.DASH_DASH_STRING, t, !0) ? (this._createCommentToken(), this.state = $ef053115c0f9207e$var$Li) : this._consumeSequenceIfMatch($ef053115c0f9207e$var$S1.DOCTYPE_STRING, t, !1) ? this.state = $ef053115c0f9207e$var$Hi : this._consumeSequenceIfMatch($ef053115c0f9207e$var$S1.CDATA_START_STRING, t, !0) ? this.allowCDATA ? this.state = $ef053115c0f9207e$var$bt : (this._err($ef053115c0f9207e$var$C.cdataInHtmlContent), this._createCommentToken(), this.currentToken.data = "[CDATA[", this.state = $ef053115c0f9207e$var$J1) : this._ensureHibernation() || (this._err($ef053115c0f9207e$var$C.incorrectlyOpenedComment), this._createCommentToken(), this._reconsumeInState($ef053115c0f9207e$var$J1));
    }
    // Comment start state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$Li](t) {
        t === $ef053115c0f9207e$var$f.HYPHEN_MINUS ? this.state = $ef053115c0f9207e$var$Mi : t === $ef053115c0f9207e$var$f.GREATER_THAN_SIGN ? (this._err($ef053115c0f9207e$var$C.abruptClosingOfEmptyComment), this.state = $ef053115c0f9207e$var$j, this._emitCurrentToken()) : this._reconsumeInState($ef053115c0f9207e$var$h1);
    }
    // Comment start dash state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$Mi](t) {
        t === $ef053115c0f9207e$var$f.HYPHEN_MINUS ? this.state = $ef053115c0f9207e$var$kt : t === $ef053115c0f9207e$var$f.GREATER_THAN_SIGN ? (this._err($ef053115c0f9207e$var$C.abruptClosingOfEmptyComment), this.state = $ef053115c0f9207e$var$j, this._emitCurrentToken()) : t === $ef053115c0f9207e$var$f.EOF ? (this._err($ef053115c0f9207e$var$C.eofInComment), this._emitCurrentToken(), this._emitEOFToken()) : (this.currentToken.data += "-", this._reconsumeInState($ef053115c0f9207e$var$h1));
    }
    // Comment state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$h1](t) {
        t === $ef053115c0f9207e$var$f.HYPHEN_MINUS ? this.state = $ef053115c0f9207e$var$yt : t === $ef053115c0f9207e$var$f.LESS_THAN_SIGN ? (this.currentToken.data += "<", this.state = $ef053115c0f9207e$var$bi) : t === $ef053115c0f9207e$var$f.NULL ? (this._err($ef053115c0f9207e$var$C.unexpectedNullCharacter), this.currentToken.data += $ef053115c0f9207e$var$X.REPLACEMENT_CHARACTER) : t === $ef053115c0f9207e$var$f.EOF ? (this._err($ef053115c0f9207e$var$C.eofInComment), this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.data += $ef053115c0f9207e$var$ie(t);
    }
    // Comment less-than sign state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$bi](t) {
        t === $ef053115c0f9207e$var$f.EXCLAMATION_MARK ? (this.currentToken.data += "!", this.state = $ef053115c0f9207e$var$Pi) : t === $ef053115c0f9207e$var$f.LESS_THAN_SIGN ? this.currentToken.data += "!" : this._reconsumeInState($ef053115c0f9207e$var$h1);
    }
    // Comment less-than sign bang state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$Pi](t) {
        t === $ef053115c0f9207e$var$f.HYPHEN_MINUS ? this.state = $ef053115c0f9207e$var$Di : this._reconsumeInState($ef053115c0f9207e$var$h1);
    }
    // Comment less-than sign bang dash state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$Di](t) {
        t === $ef053115c0f9207e$var$f.HYPHEN_MINUS ? this.state = $ef053115c0f9207e$var$wi : this._reconsumeInState($ef053115c0f9207e$var$yt);
    }
    // Comment less-than sign bang dash dash state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$wi](t) {
        t !== $ef053115c0f9207e$var$f.GREATER_THAN_SIGN && t !== $ef053115c0f9207e$var$f.EOF && this._err($ef053115c0f9207e$var$C.nestedComment), this._reconsumeInState($ef053115c0f9207e$var$kt);
    }
    // Comment end dash state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$yt](t) {
        t === $ef053115c0f9207e$var$f.HYPHEN_MINUS ? this.state = $ef053115c0f9207e$var$kt : t === $ef053115c0f9207e$var$f.EOF ? (this._err($ef053115c0f9207e$var$C.eofInComment), this._emitCurrentToken(), this._emitEOFToken()) : (this.currentToken.data += "-", this._reconsumeInState($ef053115c0f9207e$var$h1));
    }
    // Comment end state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$kt](t) {
        t === $ef053115c0f9207e$var$f.GREATER_THAN_SIGN ? (this.state = $ef053115c0f9207e$var$j, this._emitCurrentToken()) : t === $ef053115c0f9207e$var$f.EXCLAMATION_MARK ? this.state = $ef053115c0f9207e$var$Fi : t === $ef053115c0f9207e$var$f.HYPHEN_MINUS ? this.currentToken.data += "-" : t === $ef053115c0f9207e$var$f.EOF ? (this._err($ef053115c0f9207e$var$C.eofInComment), this._emitCurrentToken(), this._emitEOFToken()) : (this.currentToken.data += "--", this._reconsumeInState($ef053115c0f9207e$var$h1));
    }
    // Comment end bang state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$Fi](t) {
        t === $ef053115c0f9207e$var$f.HYPHEN_MINUS ? (this.currentToken.data += "--!", this.state = $ef053115c0f9207e$var$yt) : t === $ef053115c0f9207e$var$f.GREATER_THAN_SIGN ? (this._err($ef053115c0f9207e$var$C.incorrectlyClosedComment), this.state = $ef053115c0f9207e$var$j, this._emitCurrentToken()) : t === $ef053115c0f9207e$var$f.EOF ? (this._err($ef053115c0f9207e$var$C.eofInComment), this._emitCurrentToken(), this._emitEOFToken()) : (this.currentToken.data += "--!", this._reconsumeInState($ef053115c0f9207e$var$h1));
    }
    // DOCTYPE state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$Hi](t) {
        $ef053115c0f9207e$var$ne(t) ? this.state = $ef053115c0f9207e$var$Lt : t === $ef053115c0f9207e$var$f.GREATER_THAN_SIGN ? this._reconsumeInState($ef053115c0f9207e$var$Lt) : t === $ef053115c0f9207e$var$f.EOF ? (this._err($ef053115c0f9207e$var$C.eofInDoctype), this._createDoctypeToken(null), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err($ef053115c0f9207e$var$C.missingWhitespaceBeforeDoctypeName), this._reconsumeInState($ef053115c0f9207e$var$Lt));
    }
    // Before DOCTYPE name state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$Lt](t) {
        $ef053115c0f9207e$var$ne(t) || ($ef053115c0f9207e$var$Ge(t) ? (this._createDoctypeToken($ef053115c0f9207e$var$f1(t)), this.state = $ef053115c0f9207e$var$Mt) : t === $ef053115c0f9207e$var$f.NULL ? (this._err($ef053115c0f9207e$var$C.unexpectedNullCharacter), this._createDoctypeToken($ef053115c0f9207e$var$X.REPLACEMENT_CHARACTER), this.state = $ef053115c0f9207e$var$Mt) : t === $ef053115c0f9207e$var$f.GREATER_THAN_SIGN ? (this._err($ef053115c0f9207e$var$C.missingDoctypeName), this._createDoctypeToken(null), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this.state = $ef053115c0f9207e$var$j) : t === $ef053115c0f9207e$var$f.EOF ? (this._err($ef053115c0f9207e$var$C.eofInDoctype), this._createDoctypeToken(null), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._createDoctypeToken($ef053115c0f9207e$var$ie(t)), this.state = $ef053115c0f9207e$var$Mt));
    }
    // DOCTYPE name state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$Mt](t) {
        $ef053115c0f9207e$var$ne(t) ? this.state = $ef053115c0f9207e$var$Bi : t === $ef053115c0f9207e$var$f.GREATER_THAN_SIGN ? (this.state = $ef053115c0f9207e$var$j, this._emitCurrentToken()) : $ef053115c0f9207e$var$Ge(t) ? this.currentToken.name += $ef053115c0f9207e$var$f1(t) : t === $ef053115c0f9207e$var$f.NULL ? (this._err($ef053115c0f9207e$var$C.unexpectedNullCharacter), this.currentToken.name += $ef053115c0f9207e$var$X.REPLACEMENT_CHARACTER) : t === $ef053115c0f9207e$var$f.EOF ? (this._err($ef053115c0f9207e$var$C.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.name += $ef053115c0f9207e$var$ie(t);
    }
    // After DOCTYPE name state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$Bi](t) {
        $ef053115c0f9207e$var$ne(t) || (t === $ef053115c0f9207e$var$f.GREATER_THAN_SIGN ? (this.state = $ef053115c0f9207e$var$j, this._emitCurrentToken()) : t === $ef053115c0f9207e$var$f.EOF ? (this._err($ef053115c0f9207e$var$C.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this._consumeSequenceIfMatch($ef053115c0f9207e$var$S1.PUBLIC_STRING, t, !1) ? this.state = $ef053115c0f9207e$var$Ui : this._consumeSequenceIfMatch($ef053115c0f9207e$var$S1.SYSTEM_STRING, t, !1) ? this.state = $ef053115c0f9207e$var$Ki : this._ensureHibernation() || (this._err($ef053115c0f9207e$var$C.invalidCharacterSequenceAfterDoctypeName), this.currentToken.forceQuirks = !0, this._reconsumeInState($ef053115c0f9207e$var$r1)));
    }
    // After DOCTYPE public keyword state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$Ui](t) {
        $ef053115c0f9207e$var$ne(t) ? this.state = $ef053115c0f9207e$var$vi : t === $ef053115c0f9207e$var$f.QUOTATION_MARK ? (this._err($ef053115c0f9207e$var$C.missingWhitespaceAfterDoctypePublicKeyword), this.currentToken.publicId = "", this.state = $ef053115c0f9207e$var$yn) : t === $ef053115c0f9207e$var$f.APOSTROPHE ? (this._err($ef053115c0f9207e$var$C.missingWhitespaceAfterDoctypePublicKeyword), this.currentToken.publicId = "", this.state = $ef053115c0f9207e$var$kn) : t === $ef053115c0f9207e$var$f.GREATER_THAN_SIGN ? (this._err($ef053115c0f9207e$var$C.missingDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this.state = $ef053115c0f9207e$var$j, this._emitCurrentToken()) : t === $ef053115c0f9207e$var$f.EOF ? (this._err($ef053115c0f9207e$var$C.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err($ef053115c0f9207e$var$C.missingQuoteBeforeDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState($ef053115c0f9207e$var$r1));
    }
    // Before DOCTYPE public identifier state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$vi](t) {
        $ef053115c0f9207e$var$ne(t) || (t === $ef053115c0f9207e$var$f.QUOTATION_MARK ? (this.currentToken.publicId = "", this.state = $ef053115c0f9207e$var$yn) : t === $ef053115c0f9207e$var$f.APOSTROPHE ? (this.currentToken.publicId = "", this.state = $ef053115c0f9207e$var$kn) : t === $ef053115c0f9207e$var$f.GREATER_THAN_SIGN ? (this._err($ef053115c0f9207e$var$C.missingDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this.state = $ef053115c0f9207e$var$j, this._emitCurrentToken()) : t === $ef053115c0f9207e$var$f.EOF ? (this._err($ef053115c0f9207e$var$C.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err($ef053115c0f9207e$var$C.missingQuoteBeforeDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState($ef053115c0f9207e$var$r1)));
    }
    // DOCTYPE public identifier (double-quoted) state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$yn](t) {
        t === $ef053115c0f9207e$var$f.QUOTATION_MARK ? this.state = $ef053115c0f9207e$var$Ln : t === $ef053115c0f9207e$var$f.NULL ? (this._err($ef053115c0f9207e$var$C.unexpectedNullCharacter), this.currentToken.publicId += $ef053115c0f9207e$var$X.REPLACEMENT_CHARACTER) : t === $ef053115c0f9207e$var$f.GREATER_THAN_SIGN ? (this._err($ef053115c0f9207e$var$C.abruptDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this.state = $ef053115c0f9207e$var$j) : t === $ef053115c0f9207e$var$f.EOF ? (this._err($ef053115c0f9207e$var$C.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.publicId += $ef053115c0f9207e$var$ie(t);
    }
    // DOCTYPE public identifier (single-quoted) state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$kn](t) {
        t === $ef053115c0f9207e$var$f.APOSTROPHE ? this.state = $ef053115c0f9207e$var$Ln : t === $ef053115c0f9207e$var$f.NULL ? (this._err($ef053115c0f9207e$var$C.unexpectedNullCharacter), this.currentToken.publicId += $ef053115c0f9207e$var$X.REPLACEMENT_CHARACTER) : t === $ef053115c0f9207e$var$f.GREATER_THAN_SIGN ? (this._err($ef053115c0f9207e$var$C.abruptDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this.state = $ef053115c0f9207e$var$j) : t === $ef053115c0f9207e$var$f.EOF ? (this._err($ef053115c0f9207e$var$C.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.publicId += $ef053115c0f9207e$var$ie(t);
    }
    // After DOCTYPE public identifier state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$Ln](t) {
        $ef053115c0f9207e$var$ne(t) ? this.state = $ef053115c0f9207e$var$Gi : t === $ef053115c0f9207e$var$f.GREATER_THAN_SIGN ? (this.state = $ef053115c0f9207e$var$j, this._emitCurrentToken()) : t === $ef053115c0f9207e$var$f.QUOTATION_MARK ? (this._err($ef053115c0f9207e$var$C.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), this.currentToken.systemId = "", this.state = $ef053115c0f9207e$var$Z1) : t === $ef053115c0f9207e$var$f.APOSTROPHE ? (this._err($ef053115c0f9207e$var$C.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), this.currentToken.systemId = "", this.state = $ef053115c0f9207e$var$et) : t === $ef053115c0f9207e$var$f.EOF ? (this._err($ef053115c0f9207e$var$C.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err($ef053115c0f9207e$var$C.missingQuoteBeforeDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState($ef053115c0f9207e$var$r1));
    }
    // Between DOCTYPE public and system identifiers state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$Gi](t) {
        $ef053115c0f9207e$var$ne(t) || (t === $ef053115c0f9207e$var$f.GREATER_THAN_SIGN ? (this._emitCurrentToken(), this.state = $ef053115c0f9207e$var$j) : t === $ef053115c0f9207e$var$f.QUOTATION_MARK ? (this.currentToken.systemId = "", this.state = $ef053115c0f9207e$var$Z1) : t === $ef053115c0f9207e$var$f.APOSTROPHE ? (this.currentToken.systemId = "", this.state = $ef053115c0f9207e$var$et) : t === $ef053115c0f9207e$var$f.EOF ? (this._err($ef053115c0f9207e$var$C.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err($ef053115c0f9207e$var$C.missingQuoteBeforeDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState($ef053115c0f9207e$var$r1)));
    }
    // After DOCTYPE system keyword state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$Ki](t) {
        $ef053115c0f9207e$var$ne(t) ? this.state = $ef053115c0f9207e$var$zi : t === $ef053115c0f9207e$var$f.QUOTATION_MARK ? (this._err($ef053115c0f9207e$var$C.missingWhitespaceAfterDoctypeSystemKeyword), this.currentToken.systemId = "", this.state = $ef053115c0f9207e$var$Z1) : t === $ef053115c0f9207e$var$f.APOSTROPHE ? (this._err($ef053115c0f9207e$var$C.missingWhitespaceAfterDoctypeSystemKeyword), this.currentToken.systemId = "", this.state = $ef053115c0f9207e$var$et) : t === $ef053115c0f9207e$var$f.GREATER_THAN_SIGN ? (this._err($ef053115c0f9207e$var$C.missingDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this.state = $ef053115c0f9207e$var$j, this._emitCurrentToken()) : t === $ef053115c0f9207e$var$f.EOF ? (this._err($ef053115c0f9207e$var$C.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err($ef053115c0f9207e$var$C.missingQuoteBeforeDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState($ef053115c0f9207e$var$r1));
    }
    // Before DOCTYPE system identifier state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$zi](t) {
        $ef053115c0f9207e$var$ne(t) || (t === $ef053115c0f9207e$var$f.QUOTATION_MARK ? (this.currentToken.systemId = "", this.state = $ef053115c0f9207e$var$Z1) : t === $ef053115c0f9207e$var$f.APOSTROPHE ? (this.currentToken.systemId = "", this.state = $ef053115c0f9207e$var$et) : t === $ef053115c0f9207e$var$f.GREATER_THAN_SIGN ? (this._err($ef053115c0f9207e$var$C.missingDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this.state = $ef053115c0f9207e$var$j, this._emitCurrentToken()) : t === $ef053115c0f9207e$var$f.EOF ? (this._err($ef053115c0f9207e$var$C.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err($ef053115c0f9207e$var$C.missingQuoteBeforeDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState($ef053115c0f9207e$var$r1)));
    }
    // DOCTYPE system identifier (double-quoted) state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$Z1](t) {
        t === $ef053115c0f9207e$var$f.QUOTATION_MARK ? this.state = $ef053115c0f9207e$var$Mn : t === $ef053115c0f9207e$var$f.NULL ? (this._err($ef053115c0f9207e$var$C.unexpectedNullCharacter), this.currentToken.systemId += $ef053115c0f9207e$var$X.REPLACEMENT_CHARACTER) : t === $ef053115c0f9207e$var$f.GREATER_THAN_SIGN ? (this._err($ef053115c0f9207e$var$C.abruptDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this.state = $ef053115c0f9207e$var$j) : t === $ef053115c0f9207e$var$f.EOF ? (this._err($ef053115c0f9207e$var$C.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.systemId += $ef053115c0f9207e$var$ie(t);
    }
    // DOCTYPE system identifier (single-quoted) state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$et](t) {
        t === $ef053115c0f9207e$var$f.APOSTROPHE ? this.state = $ef053115c0f9207e$var$Mn : t === $ef053115c0f9207e$var$f.NULL ? (this._err($ef053115c0f9207e$var$C.unexpectedNullCharacter), this.currentToken.systemId += $ef053115c0f9207e$var$X.REPLACEMENT_CHARACTER) : t === $ef053115c0f9207e$var$f.GREATER_THAN_SIGN ? (this._err($ef053115c0f9207e$var$C.abruptDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this.state = $ef053115c0f9207e$var$j) : t === $ef053115c0f9207e$var$f.EOF ? (this._err($ef053115c0f9207e$var$C.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.systemId += $ef053115c0f9207e$var$ie(t);
    }
    // After DOCTYPE system identifier state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$Mn](t) {
        $ef053115c0f9207e$var$ne(t) || (t === $ef053115c0f9207e$var$f.GREATER_THAN_SIGN ? (this._emitCurrentToken(), this.state = $ef053115c0f9207e$var$j) : t === $ef053115c0f9207e$var$f.EOF ? (this._err($ef053115c0f9207e$var$C.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err($ef053115c0f9207e$var$C.unexpectedCharacterAfterDoctypeSystemIdentifier), this._reconsumeInState($ef053115c0f9207e$var$r1)));
    }
    // Bogus DOCTYPE state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$r1](t) {
        t === $ef053115c0f9207e$var$f.GREATER_THAN_SIGN ? (this._emitCurrentToken(), this.state = $ef053115c0f9207e$var$j) : t === $ef053115c0f9207e$var$f.NULL ? this._err($ef053115c0f9207e$var$C.unexpectedNullCharacter) : t === $ef053115c0f9207e$var$f.EOF && (this._emitCurrentToken(), this._emitEOFToken());
    }
    // CDATA section state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$bt](t) {
        t === $ef053115c0f9207e$var$f.RIGHT_SQUARE_BRACKET ? this.state = $ef053115c0f9207e$var$Yi : t === $ef053115c0f9207e$var$f.EOF ? (this._err($ef053115c0f9207e$var$C.eofInCdata), this._emitEOFToken()) : this._emitCodePoint(t);
    }
    // CDATA section bracket state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$Yi](t) {
        t === $ef053115c0f9207e$var$f.RIGHT_SQUARE_BRACKET ? this.state = $ef053115c0f9207e$var$ji : (this._emitChars("]"), this._reconsumeInState($ef053115c0f9207e$var$bt));
    }
    // CDATA section end state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$ji](t) {
        t === $ef053115c0f9207e$var$f.GREATER_THAN_SIGN ? this.state = $ef053115c0f9207e$var$j : t === $ef053115c0f9207e$var$f.RIGHT_SQUARE_BRACKET ? this._emitChars("]") : (this._emitChars("]]"), this._reconsumeInState($ef053115c0f9207e$var$bt));
    }
    // Character reference state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$w1](t) {
        this.tempBuff = [
            $ef053115c0f9207e$var$f.AMPERSAND
        ], t === $ef053115c0f9207e$var$f.NUMBER_SIGN ? (this.tempBuff.push(t), this.state = $ef053115c0f9207e$var$Wi) : $ef053115c0f9207e$var$bn(t) ? this._reconsumeInState($ef053115c0f9207e$var$$i) : (this._flushCodePointsConsumedAsCharacterReference(), this._reconsumeInState(this.returnState));
    }
    // Named character reference state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$$i](t) {
        const n = this._matchNamedCharacterReference(t);
        if (this._ensureHibernation()) this.tempBuff = [
            $ef053115c0f9207e$var$f.AMPERSAND
        ];
        else if (n) {
            const r = this.tempBuff[this.tempBuff.length - 1] === $ef053115c0f9207e$var$f.SEMICOLON;
            this._isCharacterReferenceAttributeQuirk(r) || (r || this._errOnNextCodePoint($ef053115c0f9207e$var$C.missingSemicolonAfterCharacterReference), this.tempBuff = n), this._flushCodePointsConsumedAsCharacterReference(), this.state = this.returnState;
        } else this._flushCodePointsConsumedAsCharacterReference(), this.state = $ef053115c0f9207e$var$Qi;
    }
    // Ambiguos ampersand state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$Qi](t) {
        $ef053115c0f9207e$var$bn(t) ? this._isCharacterReferenceInAttribute() ? this.currentAttr.value += $ef053115c0f9207e$var$ie(t) : this._emitCodePoint(t) : (t === $ef053115c0f9207e$var$f.SEMICOLON && this._err($ef053115c0f9207e$var$C.unknownNamedCharacterReference), this._reconsumeInState(this.returnState));
    }
    // Numeric character reference state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$Wi](t) {
        this.charRefCode = 0, t === $ef053115c0f9207e$var$f.LATIN_SMALL_X || t === $ef053115c0f9207e$var$f.LATIN_CAPITAL_X ? (this.tempBuff.push(t), this.state = $ef053115c0f9207e$var$qi) : this._reconsumeInState($ef053115c0f9207e$var$Vi);
    }
    // Hexademical character reference start state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$qi](t) {
        $ef053115c0f9207e$var$i0(t) ? this._reconsumeInState($ef053115c0f9207e$var$Xi) : (this._err($ef053115c0f9207e$var$C.absenceOfDigitsInNumericCharacterReference), this._flushCodePointsConsumedAsCharacterReference(), this._reconsumeInState(this.returnState));
    }
    // Decimal character reference start state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$Vi](t) {
        $ef053115c0f9207e$var$ut(t) ? this._reconsumeInState($ef053115c0f9207e$var$Ji) : (this._err($ef053115c0f9207e$var$C.absenceOfDigitsInNumericCharacterReference), this._flushCodePointsConsumedAsCharacterReference(), this._reconsumeInState(this.returnState));
    }
    // Hexademical character reference state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$Xi](t) {
        $ef053115c0f9207e$var$xo(t) ? this.charRefCode = this.charRefCode * 16 + t - 55 : $ef053115c0f9207e$var$yo(t) ? this.charRefCode = this.charRefCode * 16 + t - 87 : $ef053115c0f9207e$var$ut(t) ? this.charRefCode = this.charRefCode * 16 + t - 48 : t === $ef053115c0f9207e$var$f.SEMICOLON ? this.state = $ef053115c0f9207e$var$tt : (this._err($ef053115c0f9207e$var$C.missingSemicolonAfterCharacterReference), this._reconsumeInState($ef053115c0f9207e$var$tt));
    }
    // Decimal character reference state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$Ji](t) {
        $ef053115c0f9207e$var$ut(t) ? this.charRefCode = this.charRefCode * 10 + t - 48 : t === $ef053115c0f9207e$var$f.SEMICOLON ? this.state = $ef053115c0f9207e$var$tt : (this._err($ef053115c0f9207e$var$C.missingSemicolonAfterCharacterReference), this._reconsumeInState($ef053115c0f9207e$var$tt));
    }
    // Numeric character reference end state
    //------------------------------------------------------------------
    [$ef053115c0f9207e$var$tt]() {
        if (this.charRefCode === $ef053115c0f9207e$var$f.NULL) this._err($ef053115c0f9207e$var$C.nullCharacterReference), this.charRefCode = $ef053115c0f9207e$var$f.REPLACEMENT_CHARACTER;
        else if (this.charRefCode > 1114111) this._err($ef053115c0f9207e$var$C.characterReferenceOutsideUnicodeRange), this.charRefCode = $ef053115c0f9207e$var$f.REPLACEMENT_CHARACTER;
        else if ($ef053115c0f9207e$var$X.isSurrogate(this.charRefCode)) this._err($ef053115c0f9207e$var$C.surrogateCharacterReference), this.charRefCode = $ef053115c0f9207e$var$f.REPLACEMENT_CHARACTER;
        else if ($ef053115c0f9207e$var$X.isUndefinedCodePoint(this.charRefCode)) this._err($ef053115c0f9207e$var$C.noncharacterCharacterReference);
        else if ($ef053115c0f9207e$var$X.isControlCodePoint(this.charRefCode) || this.charRefCode === $ef053115c0f9207e$var$f.CARRIAGE_RETURN) {
            this._err($ef053115c0f9207e$var$C.controlCharacterReference);
            const t = $ef053115c0f9207e$var$n0[this.charRefCode];
            t && (this.charRefCode = t);
        }
        this.tempBuff = [
            this.charRefCode
        ], this._flushCodePointsConsumedAsCharacterReference(), this._reconsumeInState(this.returnState);
    }
};
$ef053115c0f9207e$var$He.CHARACTER_TOKEN = "CHARACTER_TOKEN";
$ef053115c0f9207e$var$He.NULL_CHARACTER_TOKEN = "NULL_CHARACTER_TOKEN";
$ef053115c0f9207e$var$He.WHITESPACE_CHARACTER_TOKEN = "WHITESPACE_CHARACTER_TOKEN";
$ef053115c0f9207e$var$He.START_TAG_TOKEN = "START_TAG_TOKEN";
$ef053115c0f9207e$var$He.END_TAG_TOKEN = "END_TAG_TOKEN";
$ef053115c0f9207e$var$He.COMMENT_TOKEN = "COMMENT_TOKEN";
$ef053115c0f9207e$var$He.DOCTYPE_TOKEN = "DOCTYPE_TOKEN";
$ef053115c0f9207e$var$He.EOF_TOKEN = "EOF_TOKEN";
$ef053115c0f9207e$var$He.HIBERNATION_TOKEN = "HIBERNATION_TOKEN";
$ef053115c0f9207e$var$He.MODE = {
    DATA: $ef053115c0f9207e$var$j,
    RCDATA: $ef053115c0f9207e$var$v1,
    RAWTEXT: $ef053115c0f9207e$var$ot,
    SCRIPT_DATA: $ef053115c0f9207e$var$a1,
    PLAINTEXT: $ef053115c0f9207e$var$Ro
};
$ef053115c0f9207e$var$He.getTokenAttr = function(e, t) {
    for(let n = e.attrs.length - 1; n >= 0; n--)if (e.attrs[n].name === t) return e.attrs[n].value;
    return null;
};
var $ef053115c0f9207e$var$nn = $ef053115c0f9207e$var$He, $ef053115c0f9207e$var$je = {};
const $ef053115c0f9207e$var$Pn = $ef053115c0f9207e$var$je.NAMESPACES = {
    HTML: "http://www.w3.org/1999/xhtml",
    MATHML: "http://www.w3.org/1998/Math/MathML",
    SVG: "http://www.w3.org/2000/svg",
    XLINK: "http://www.w3.org/1999/xlink",
    XML: "http://www.w3.org/XML/1998/namespace",
    XMLNS: "http://www.w3.org/2000/xmlns/"
};
$ef053115c0f9207e$var$je.ATTRS = {
    TYPE: "type",
    ACTION: "action",
    ENCODING: "encoding",
    PROMPT: "prompt",
    NAME: "name",
    COLOR: "color",
    FACE: "face",
    SIZE: "size"
};
$ef053115c0f9207e$var$je.DOCUMENT_MODE = {
    NO_QUIRKS: "no-quirks",
    QUIRKS: "quirks",
    LIMITED_QUIRKS: "limited-quirks"
};
const $ef053115c0f9207e$var$O = $ef053115c0f9207e$var$je.TAG_NAMES = {
    A: "a",
    ADDRESS: "address",
    ANNOTATION_XML: "annotation-xml",
    APPLET: "applet",
    AREA: "area",
    ARTICLE: "article",
    ASIDE: "aside",
    B: "b",
    BASE: "base",
    BASEFONT: "basefont",
    BGSOUND: "bgsound",
    BIG: "big",
    BLOCKQUOTE: "blockquote",
    BODY: "body",
    BR: "br",
    BUTTON: "button",
    CAPTION: "caption",
    CENTER: "center",
    CODE: "code",
    COL: "col",
    COLGROUP: "colgroup",
    DD: "dd",
    DESC: "desc",
    DETAILS: "details",
    DIALOG: "dialog",
    DIR: "dir",
    DIV: "div",
    DL: "dl",
    DT: "dt",
    EM: "em",
    EMBED: "embed",
    FIELDSET: "fieldset",
    FIGCAPTION: "figcaption",
    FIGURE: "figure",
    FONT: "font",
    FOOTER: "footer",
    FOREIGN_OBJECT: "foreignObject",
    FORM: "form",
    FRAME: "frame",
    FRAMESET: "frameset",
    H1: "h1",
    H2: "h2",
    H3: "h3",
    H4: "h4",
    H5: "h5",
    H6: "h6",
    HEAD: "head",
    HEADER: "header",
    HGROUP: "hgroup",
    HR: "hr",
    HTML: "html",
    I: "i",
    IMG: "img",
    IMAGE: "image",
    INPUT: "input",
    IFRAME: "iframe",
    KEYGEN: "keygen",
    LABEL: "label",
    LI: "li",
    LINK: "link",
    LISTING: "listing",
    MAIN: "main",
    MALIGNMARK: "malignmark",
    MARQUEE: "marquee",
    MATH: "math",
    MENU: "menu",
    META: "meta",
    MGLYPH: "mglyph",
    MI: "mi",
    MO: "mo",
    MN: "mn",
    MS: "ms",
    MTEXT: "mtext",
    NAV: "nav",
    NOBR: "nobr",
    NOFRAMES: "noframes",
    NOEMBED: "noembed",
    NOSCRIPT: "noscript",
    OBJECT: "object",
    OL: "ol",
    OPTGROUP: "optgroup",
    OPTION: "option",
    P: "p",
    PARAM: "param",
    PLAINTEXT: "plaintext",
    PRE: "pre",
    RB: "rb",
    RP: "rp",
    RT: "rt",
    RTC: "rtc",
    RUBY: "ruby",
    S: "s",
    SCRIPT: "script",
    SECTION: "section",
    SELECT: "select",
    SOURCE: "source",
    SMALL: "small",
    SPAN: "span",
    STRIKE: "strike",
    STRONG: "strong",
    STYLE: "style",
    SUB: "sub",
    SUMMARY: "summary",
    SUP: "sup",
    TABLE: "table",
    TBODY: "tbody",
    TEMPLATE: "template",
    TEXTAREA: "textarea",
    TFOOT: "tfoot",
    TD: "td",
    TH: "th",
    THEAD: "thead",
    TITLE: "title",
    TR: "tr",
    TRACK: "track",
    TT: "tt",
    U: "u",
    UL: "ul",
    SVG: "svg",
    VAR: "var",
    WBR: "wbr",
    XMP: "xmp"
};
$ef053115c0f9207e$var$je.SPECIAL_ELEMENTS = {
    [$ef053115c0f9207e$var$Pn.HTML]: {
        [$ef053115c0f9207e$var$O.ADDRESS]: !0,
        [$ef053115c0f9207e$var$O.APPLET]: !0,
        [$ef053115c0f9207e$var$O.AREA]: !0,
        [$ef053115c0f9207e$var$O.ARTICLE]: !0,
        [$ef053115c0f9207e$var$O.ASIDE]: !0,
        [$ef053115c0f9207e$var$O.BASE]: !0,
        [$ef053115c0f9207e$var$O.BASEFONT]: !0,
        [$ef053115c0f9207e$var$O.BGSOUND]: !0,
        [$ef053115c0f9207e$var$O.BLOCKQUOTE]: !0,
        [$ef053115c0f9207e$var$O.BODY]: !0,
        [$ef053115c0f9207e$var$O.BR]: !0,
        [$ef053115c0f9207e$var$O.BUTTON]: !0,
        [$ef053115c0f9207e$var$O.CAPTION]: !0,
        [$ef053115c0f9207e$var$O.CENTER]: !0,
        [$ef053115c0f9207e$var$O.COL]: !0,
        [$ef053115c0f9207e$var$O.COLGROUP]: !0,
        [$ef053115c0f9207e$var$O.DD]: !0,
        [$ef053115c0f9207e$var$O.DETAILS]: !0,
        [$ef053115c0f9207e$var$O.DIR]: !0,
        [$ef053115c0f9207e$var$O.DIV]: !0,
        [$ef053115c0f9207e$var$O.DL]: !0,
        [$ef053115c0f9207e$var$O.DT]: !0,
        [$ef053115c0f9207e$var$O.EMBED]: !0,
        [$ef053115c0f9207e$var$O.FIELDSET]: !0,
        [$ef053115c0f9207e$var$O.FIGCAPTION]: !0,
        [$ef053115c0f9207e$var$O.FIGURE]: !0,
        [$ef053115c0f9207e$var$O.FOOTER]: !0,
        [$ef053115c0f9207e$var$O.FORM]: !0,
        [$ef053115c0f9207e$var$O.FRAME]: !0,
        [$ef053115c0f9207e$var$O.FRAMESET]: !0,
        [$ef053115c0f9207e$var$O.H1]: !0,
        [$ef053115c0f9207e$var$O.H2]: !0,
        [$ef053115c0f9207e$var$O.H3]: !0,
        [$ef053115c0f9207e$var$O.H4]: !0,
        [$ef053115c0f9207e$var$O.H5]: !0,
        [$ef053115c0f9207e$var$O.H6]: !0,
        [$ef053115c0f9207e$var$O.HEAD]: !0,
        [$ef053115c0f9207e$var$O.HEADER]: !0,
        [$ef053115c0f9207e$var$O.HGROUP]: !0,
        [$ef053115c0f9207e$var$O.HR]: !0,
        [$ef053115c0f9207e$var$O.HTML]: !0,
        [$ef053115c0f9207e$var$O.IFRAME]: !0,
        [$ef053115c0f9207e$var$O.IMG]: !0,
        [$ef053115c0f9207e$var$O.INPUT]: !0,
        [$ef053115c0f9207e$var$O.LI]: !0,
        [$ef053115c0f9207e$var$O.LINK]: !0,
        [$ef053115c0f9207e$var$O.LISTING]: !0,
        [$ef053115c0f9207e$var$O.MAIN]: !0,
        [$ef053115c0f9207e$var$O.MARQUEE]: !0,
        [$ef053115c0f9207e$var$O.MENU]: !0,
        [$ef053115c0f9207e$var$O.META]: !0,
        [$ef053115c0f9207e$var$O.NAV]: !0,
        [$ef053115c0f9207e$var$O.NOEMBED]: !0,
        [$ef053115c0f9207e$var$O.NOFRAMES]: !0,
        [$ef053115c0f9207e$var$O.NOSCRIPT]: !0,
        [$ef053115c0f9207e$var$O.OBJECT]: !0,
        [$ef053115c0f9207e$var$O.OL]: !0,
        [$ef053115c0f9207e$var$O.P]: !0,
        [$ef053115c0f9207e$var$O.PARAM]: !0,
        [$ef053115c0f9207e$var$O.PLAINTEXT]: !0,
        [$ef053115c0f9207e$var$O.PRE]: !0,
        [$ef053115c0f9207e$var$O.SCRIPT]: !0,
        [$ef053115c0f9207e$var$O.SECTION]: !0,
        [$ef053115c0f9207e$var$O.SELECT]: !0,
        [$ef053115c0f9207e$var$O.SOURCE]: !0,
        [$ef053115c0f9207e$var$O.STYLE]: !0,
        [$ef053115c0f9207e$var$O.SUMMARY]: !0,
        [$ef053115c0f9207e$var$O.TABLE]: !0,
        [$ef053115c0f9207e$var$O.TBODY]: !0,
        [$ef053115c0f9207e$var$O.TD]: !0,
        [$ef053115c0f9207e$var$O.TEMPLATE]: !0,
        [$ef053115c0f9207e$var$O.TEXTAREA]: !0,
        [$ef053115c0f9207e$var$O.TFOOT]: !0,
        [$ef053115c0f9207e$var$O.TH]: !0,
        [$ef053115c0f9207e$var$O.THEAD]: !0,
        [$ef053115c0f9207e$var$O.TITLE]: !0,
        [$ef053115c0f9207e$var$O.TR]: !0,
        [$ef053115c0f9207e$var$O.TRACK]: !0,
        [$ef053115c0f9207e$var$O.UL]: !0,
        [$ef053115c0f9207e$var$O.WBR]: !0,
        [$ef053115c0f9207e$var$O.XMP]: !0
    },
    [$ef053115c0f9207e$var$Pn.MATHML]: {
        [$ef053115c0f9207e$var$O.MI]: !0,
        [$ef053115c0f9207e$var$O.MO]: !0,
        [$ef053115c0f9207e$var$O.MN]: !0,
        [$ef053115c0f9207e$var$O.MS]: !0,
        [$ef053115c0f9207e$var$O.MTEXT]: !0,
        [$ef053115c0f9207e$var$O.ANNOTATION_XML]: !0
    },
    [$ef053115c0f9207e$var$Pn.SVG]: {
        [$ef053115c0f9207e$var$O.TITLE]: !0,
        [$ef053115c0f9207e$var$O.FOREIGN_OBJECT]: !0,
        [$ef053115c0f9207e$var$O.DESC]: !0
    }
};
const $ef053115c0f9207e$var$ko = $ef053115c0f9207e$var$je, $ef053115c0f9207e$var$x = $ef053115c0f9207e$var$ko.TAG_NAMES, $ef053115c0f9207e$var$J = $ef053115c0f9207e$var$ko.NAMESPACES;
function $ef053115c0f9207e$var$es(e) {
    switch(e.length){
        case 1:
            return e === $ef053115c0f9207e$var$x.P;
        case 2:
            return e === $ef053115c0f9207e$var$x.RB || e === $ef053115c0f9207e$var$x.RP || e === $ef053115c0f9207e$var$x.RT || e === $ef053115c0f9207e$var$x.DD || e === $ef053115c0f9207e$var$x.DT || e === $ef053115c0f9207e$var$x.LI;
        case 3:
            return e === $ef053115c0f9207e$var$x.RTC;
        case 6:
            return e === $ef053115c0f9207e$var$x.OPTION;
        case 8:
            return e === $ef053115c0f9207e$var$x.OPTGROUP;
    }
    return !1;
}
function $ef053115c0f9207e$var$s0(e) {
    switch(e.length){
        case 1:
            return e === $ef053115c0f9207e$var$x.P;
        case 2:
            return e === $ef053115c0f9207e$var$x.RB || e === $ef053115c0f9207e$var$x.RP || e === $ef053115c0f9207e$var$x.RT || e === $ef053115c0f9207e$var$x.DD || e === $ef053115c0f9207e$var$x.DT || e === $ef053115c0f9207e$var$x.LI || e === $ef053115c0f9207e$var$x.TD || e === $ef053115c0f9207e$var$x.TH || e === $ef053115c0f9207e$var$x.TR;
        case 3:
            return e === $ef053115c0f9207e$var$x.RTC;
        case 5:
            return e === $ef053115c0f9207e$var$x.TBODY || e === $ef053115c0f9207e$var$x.TFOOT || e === $ef053115c0f9207e$var$x.THEAD;
        case 6:
            return e === $ef053115c0f9207e$var$x.OPTION;
        case 7:
            return e === $ef053115c0f9207e$var$x.CAPTION;
        case 8:
            return e === $ef053115c0f9207e$var$x.OPTGROUP || e === $ef053115c0f9207e$var$x.COLGROUP;
    }
    return !1;
}
function $ef053115c0f9207e$var$Pt(e, t) {
    switch(e.length){
        case 2:
            if (e === $ef053115c0f9207e$var$x.TD || e === $ef053115c0f9207e$var$x.TH) return t === $ef053115c0f9207e$var$J.HTML;
            if (e === $ef053115c0f9207e$var$x.MI || e === $ef053115c0f9207e$var$x.MO || e === $ef053115c0f9207e$var$x.MN || e === $ef053115c0f9207e$var$x.MS) return t === $ef053115c0f9207e$var$J.MATHML;
            break;
        case 4:
            if (e === $ef053115c0f9207e$var$x.HTML) return t === $ef053115c0f9207e$var$J.HTML;
            if (e === $ef053115c0f9207e$var$x.DESC) return t === $ef053115c0f9207e$var$J.SVG;
            break;
        case 5:
            if (e === $ef053115c0f9207e$var$x.TABLE) return t === $ef053115c0f9207e$var$J.HTML;
            if (e === $ef053115c0f9207e$var$x.MTEXT) return t === $ef053115c0f9207e$var$J.MATHML;
            if (e === $ef053115c0f9207e$var$x.TITLE) return t === $ef053115c0f9207e$var$J.SVG;
            break;
        case 6:
            return (e === $ef053115c0f9207e$var$x.APPLET || e === $ef053115c0f9207e$var$x.OBJECT) && t === $ef053115c0f9207e$var$J.HTML;
        case 7:
            return (e === $ef053115c0f9207e$var$x.CAPTION || e === $ef053115c0f9207e$var$x.MARQUEE) && t === $ef053115c0f9207e$var$J.HTML;
        case 8:
            return e === $ef053115c0f9207e$var$x.TEMPLATE && t === $ef053115c0f9207e$var$J.HTML;
        case 13:
            return e === $ef053115c0f9207e$var$x.FOREIGN_OBJECT && t === $ef053115c0f9207e$var$J.SVG;
        case 14:
            return e === $ef053115c0f9207e$var$x.ANNOTATION_XML && t === $ef053115c0f9207e$var$J.MATHML;
    }
    return !1;
}
let $ef053115c0f9207e$var$o0 = class {
    constructor(t, n){
        this.stackTop = -1, this.items = [], this.current = t, this.currentTagName = null, this.currentTmplContent = null, this.tmplCount = 0, this.treeAdapter = n;
    }
    //Index of element
    _indexOf(t) {
        let n = -1;
        for(let r = this.stackTop; r >= 0; r--)if (this.items[r] === t) {
            n = r;
            break;
        }
        return n;
    }
    //Update current element
    _isInTemplate() {
        return this.currentTagName === $ef053115c0f9207e$var$x.TEMPLATE && this.treeAdapter.getNamespaceURI(this.current) === $ef053115c0f9207e$var$J.HTML;
    }
    _updateCurrentElement() {
        this.current = this.items[this.stackTop], this.currentTagName = this.current && this.treeAdapter.getTagName(this.current), this.currentTmplContent = this._isInTemplate() ? this.treeAdapter.getTemplateContent(this.current) : null;
    }
    //Mutations
    push(t) {
        this.items[++this.stackTop] = t, this._updateCurrentElement(), this._isInTemplate() && this.tmplCount++;
    }
    pop() {
        this.stackTop--, this.tmplCount > 0 && this._isInTemplate() && this.tmplCount--, this._updateCurrentElement();
    }
    replace(t, n) {
        const r = this._indexOf(t);
        this.items[r] = n, r === this.stackTop && this._updateCurrentElement();
    }
    insertAfter(t, n) {
        const r = this._indexOf(t) + 1;
        this.items.splice(r, 0, n), r === ++this.stackTop && this._updateCurrentElement();
    }
    popUntilTagNamePopped(t) {
        for(; this.stackTop > -1;){
            const n = this.currentTagName, r = this.treeAdapter.getNamespaceURI(this.current);
            if (this.pop(), n === t && r === $ef053115c0f9207e$var$J.HTML) break;
        }
    }
    popUntilElementPopped(t) {
        for(; this.stackTop > -1;){
            const n = this.current;
            if (this.pop(), n === t) break;
        }
    }
    popUntilNumberedHeaderPopped() {
        for(; this.stackTop > -1;){
            const t = this.currentTagName, n = this.treeAdapter.getNamespaceURI(this.current);
            if (this.pop(), t === $ef053115c0f9207e$var$x.H1 || t === $ef053115c0f9207e$var$x.H2 || t === $ef053115c0f9207e$var$x.H3 || t === $ef053115c0f9207e$var$x.H4 || t === $ef053115c0f9207e$var$x.H5 || t === $ef053115c0f9207e$var$x.H6 && n === $ef053115c0f9207e$var$J.HTML) break;
        }
    }
    popUntilTableCellPopped() {
        for(; this.stackTop > -1;){
            const t = this.currentTagName, n = this.treeAdapter.getNamespaceURI(this.current);
            if (this.pop(), t === $ef053115c0f9207e$var$x.TD || t === $ef053115c0f9207e$var$x.TH && n === $ef053115c0f9207e$var$J.HTML) break;
        }
    }
    popAllUpToHtmlElement() {
        this.stackTop = 0, this._updateCurrentElement();
    }
    clearBackToTableContext() {
        for(; this.currentTagName !== $ef053115c0f9207e$var$x.TABLE && this.currentTagName !== $ef053115c0f9207e$var$x.TEMPLATE && this.currentTagName !== $ef053115c0f9207e$var$x.HTML || this.treeAdapter.getNamespaceURI(this.current) !== $ef053115c0f9207e$var$J.HTML;)this.pop();
    }
    clearBackToTableBodyContext() {
        for(; this.currentTagName !== $ef053115c0f9207e$var$x.TBODY && this.currentTagName !== $ef053115c0f9207e$var$x.TFOOT && this.currentTagName !== $ef053115c0f9207e$var$x.THEAD && this.currentTagName !== $ef053115c0f9207e$var$x.TEMPLATE && this.currentTagName !== $ef053115c0f9207e$var$x.HTML || this.treeAdapter.getNamespaceURI(this.current) !== $ef053115c0f9207e$var$J.HTML;)this.pop();
    }
    clearBackToTableRowContext() {
        for(; this.currentTagName !== $ef053115c0f9207e$var$x.TR && this.currentTagName !== $ef053115c0f9207e$var$x.TEMPLATE && this.currentTagName !== $ef053115c0f9207e$var$x.HTML || this.treeAdapter.getNamespaceURI(this.current) !== $ef053115c0f9207e$var$J.HTML;)this.pop();
    }
    remove(t) {
        for(let n = this.stackTop; n >= 0; n--)if (this.items[n] === t) {
            this.items.splice(n, 1), this.stackTop--, this._updateCurrentElement();
            break;
        }
    }
    //Search
    tryPeekProperlyNestedBodyElement() {
        const t = this.items[1];
        return t && this.treeAdapter.getTagName(t) === $ef053115c0f9207e$var$x.BODY ? t : null;
    }
    contains(t) {
        return this._indexOf(t) > -1;
    }
    getCommonAncestor(t) {
        let n = this._indexOf(t);
        return --n >= 0 ? this.items[n] : null;
    }
    isRootHtmlElementCurrent() {
        return this.stackTop === 0 && this.currentTagName === $ef053115c0f9207e$var$x.HTML;
    }
    //Element in scope
    hasInScope(t) {
        for(let n = this.stackTop; n >= 0; n--){
            const r = this.treeAdapter.getTagName(this.items[n]), i = this.treeAdapter.getNamespaceURI(this.items[n]);
            if (r === t && i === $ef053115c0f9207e$var$J.HTML) return !0;
            if ($ef053115c0f9207e$var$Pt(r, i)) return !1;
        }
        return !0;
    }
    hasNumberedHeaderInScope() {
        for(let t = this.stackTop; t >= 0; t--){
            const n = this.treeAdapter.getTagName(this.items[t]), r = this.treeAdapter.getNamespaceURI(this.items[t]);
            if ((n === $ef053115c0f9207e$var$x.H1 || n === $ef053115c0f9207e$var$x.H2 || n === $ef053115c0f9207e$var$x.H3 || n === $ef053115c0f9207e$var$x.H4 || n === $ef053115c0f9207e$var$x.H5 || n === $ef053115c0f9207e$var$x.H6) && r === $ef053115c0f9207e$var$J.HTML) return !0;
            if ($ef053115c0f9207e$var$Pt(n, r)) return !1;
        }
        return !0;
    }
    hasInListItemScope(t) {
        for(let n = this.stackTop; n >= 0; n--){
            const r = this.treeAdapter.getTagName(this.items[n]), i = this.treeAdapter.getNamespaceURI(this.items[n]);
            if (r === t && i === $ef053115c0f9207e$var$J.HTML) return !0;
            if ((r === $ef053115c0f9207e$var$x.UL || r === $ef053115c0f9207e$var$x.OL) && i === $ef053115c0f9207e$var$J.HTML || $ef053115c0f9207e$var$Pt(r, i)) return !1;
        }
        return !0;
    }
    hasInButtonScope(t) {
        for(let n = this.stackTop; n >= 0; n--){
            const r = this.treeAdapter.getTagName(this.items[n]), i = this.treeAdapter.getNamespaceURI(this.items[n]);
            if (r === t && i === $ef053115c0f9207e$var$J.HTML) return !0;
            if (r === $ef053115c0f9207e$var$x.BUTTON && i === $ef053115c0f9207e$var$J.HTML || $ef053115c0f9207e$var$Pt(r, i)) return !1;
        }
        return !0;
    }
    hasInTableScope(t) {
        for(let n = this.stackTop; n >= 0; n--){
            const r = this.treeAdapter.getTagName(this.items[n]);
            if (this.treeAdapter.getNamespaceURI(this.items[n]) === $ef053115c0f9207e$var$J.HTML) {
                if (r === t) return !0;
                if (r === $ef053115c0f9207e$var$x.TABLE || r === $ef053115c0f9207e$var$x.TEMPLATE || r === $ef053115c0f9207e$var$x.HTML) return !1;
            }
        }
        return !0;
    }
    hasTableBodyContextInTableScope() {
        for(let t = this.stackTop; t >= 0; t--){
            const n = this.treeAdapter.getTagName(this.items[t]);
            if (this.treeAdapter.getNamespaceURI(this.items[t]) === $ef053115c0f9207e$var$J.HTML) {
                if (n === $ef053115c0f9207e$var$x.TBODY || n === $ef053115c0f9207e$var$x.THEAD || n === $ef053115c0f9207e$var$x.TFOOT) return !0;
                if (n === $ef053115c0f9207e$var$x.TABLE || n === $ef053115c0f9207e$var$x.HTML) return !1;
            }
        }
        return !0;
    }
    hasInSelectScope(t) {
        for(let n = this.stackTop; n >= 0; n--){
            const r = this.treeAdapter.getTagName(this.items[n]);
            if (this.treeAdapter.getNamespaceURI(this.items[n]) === $ef053115c0f9207e$var$J.HTML) {
                if (r === t) return !0;
                if (r !== $ef053115c0f9207e$var$x.OPTION && r !== $ef053115c0f9207e$var$x.OPTGROUP) return !1;
            }
        }
        return !0;
    }
    //Implied end tags
    generateImpliedEndTags() {
        for(; $ef053115c0f9207e$var$es(this.currentTagName);)this.pop();
    }
    generateImpliedEndTagsThoroughly() {
        for(; $ef053115c0f9207e$var$s0(this.currentTagName);)this.pop();
    }
    generateImpliedEndTagsWithExclusion(t) {
        for(; $ef053115c0f9207e$var$es(this.currentTagName) && this.currentTagName !== t;)this.pop();
    }
};
var $ef053115c0f9207e$var$a0 = $ef053115c0f9207e$var$o0;
const $ef053115c0f9207e$var$Dt = 3;
let $ef053115c0f9207e$var$hr = class m1 {
    constructor(t){
        this.length = 0, this.entries = [], this.treeAdapter = t, this.bookmark = null;
    }
    //Noah Ark's condition
    //OPTIMIZATION: at first we try to find possible candidates for exclusion using
    //lightweight heuristics without thorough attributes check.
    _getNoahArkConditionCandidates(t) {
        const n = [];
        if (this.length >= $ef053115c0f9207e$var$Dt) {
            const r = this.treeAdapter.getAttrList(t).length, i = this.treeAdapter.getTagName(t), s = this.treeAdapter.getNamespaceURI(t);
            for(let o = this.length - 1; o >= 0; o--){
                const l = this.entries[o];
                if (l.type === m1.MARKER_ENTRY) break;
                const u = l.element, c = this.treeAdapter.getAttrList(u);
                this.treeAdapter.getTagName(u) === i && this.treeAdapter.getNamespaceURI(u) === s && c.length === r && n.push({
                    idx: o,
                    attrs: c
                });
            }
        }
        return n.length < $ef053115c0f9207e$var$Dt ? [] : n;
    }
    _ensureNoahArkCondition(t) {
        const n = this._getNoahArkConditionCandidates(t);
        let r = n.length;
        if (r) {
            const i = this.treeAdapter.getAttrList(t), s = i.length, o = /* @__PURE__ */ Object.create(null);
            for(let l = 0; l < s; l++){
                const u = i[l];
                o[u.name] = u.value;
            }
            for(let l = 0; l < s; l++)for(let u = 0; u < r; u++){
                const c = n[u].attrs[l];
                if (o[c.name] !== c.value && (n.splice(u, 1), r--), n.length < $ef053115c0f9207e$var$Dt) return;
            }
            for(let l = r - 1; l >= $ef053115c0f9207e$var$Dt - 1; l--)this.entries.splice(n[l].idx, 1), this.length--;
        }
    }
    //Mutations
    insertMarker() {
        this.entries.push({
            type: m1.MARKER_ENTRY
        }), this.length++;
    }
    pushElement(t, n) {
        this._ensureNoahArkCondition(t), this.entries.push({
            type: m1.ELEMENT_ENTRY,
            element: t,
            token: n
        }), this.length++;
    }
    insertElementAfterBookmark(t, n) {
        let r = this.length - 1;
        for(; r >= 0 && this.entries[r] !== this.bookmark; r--);
        this.entries.splice(r + 1, 0, {
            type: m1.ELEMENT_ENTRY,
            element: t,
            token: n
        }), this.length++;
    }
    removeEntry(t) {
        for(let n = this.length - 1; n >= 0; n--)if (this.entries[n] === t) {
            this.entries.splice(n, 1), this.length--;
            break;
        }
    }
    clearToLastMarker() {
        for(; this.length;){
            const t = this.entries.pop();
            if (this.length--, t.type === m1.MARKER_ENTRY) break;
        }
    }
    //Search
    getElementEntryInScopeWithTagName(t) {
        for(let n = this.length - 1; n >= 0; n--){
            const r = this.entries[n];
            if (r.type === m1.MARKER_ENTRY) return null;
            if (this.treeAdapter.getTagName(r.element) === t) return r;
        }
        return null;
    }
    getElementEntry(t) {
        for(let n = this.length - 1; n >= 0; n--){
            const r = this.entries[n];
            if (r.type === m1.ELEMENT_ENTRY && r.element === t) return r;
        }
        return null;
    }
};
$ef053115c0f9207e$var$hr.MARKER_ENTRY = "MARKER_ENTRY";
$ef053115c0f9207e$var$hr.ELEMENT_ENTRY = "ELEMENT_ENTRY";
var $ef053115c0f9207e$var$l0 = $ef053115c0f9207e$var$hr;
let $ef053115c0f9207e$var$Lo = class {
    constructor(t){
        const n = {}, r = this._getOverriddenMethods(this, n);
        for (const i of Object.keys(r))typeof r[i] == "function" && (n[i] = t[i], t[i] = r[i]);
    }
    _getOverriddenMethods() {
        throw new Error("Not implemented");
    }
};
$ef053115c0f9207e$var$Lo.install = function(e, t, n) {
    e.__mixins || (e.__mixins = []);
    for(let i = 0; i < e.__mixins.length; i++)if (e.__mixins[i].constructor === t) return e.__mixins[i];
    const r = new t(e, n);
    return e.__mixins.push(r), r;
};
var $ef053115c0f9207e$var$u1 = $ef053115c0f9207e$var$Lo;
const $ef053115c0f9207e$var$u0 = $ef053115c0f9207e$var$u1;
let $ef053115c0f9207e$var$c0 = class extends $ef053115c0f9207e$var$u0 {
    constructor(t){
        super(t), this.preprocessor = t, this.isEol = !1, this.lineStartPos = 0, this.droppedBufferSize = 0, this.offset = 0, this.col = 0, this.line = 1;
    }
    _getOverriddenMethods(t, n) {
        return {
            advance () {
                const r = this.pos + 1, i = this.html[r];
                return t.isEol && (t.isEol = !1, t.line++, t.lineStartPos = r), (i === `
` || i === "\r" && this.html[r + 1] !== `
`) && (t.isEol = !0), t.col = r - t.lineStartPos + 1, t.offset = t.droppedBufferSize + r, n.advance.call(this);
            },
            retreat () {
                n.retreat.call(this), t.isEol = !1, t.col = this.pos - t.lineStartPos + 1;
            },
            dropParsedChunk () {
                const r = this.pos;
                n.dropParsedChunk.call(this);
                const i = r - this.pos;
                t.lineStartPos -= i, t.droppedBufferSize += i, t.offset = t.droppedBufferSize + this.pos;
            }
        };
    }
};
var $ef053115c0f9207e$var$Mo = $ef053115c0f9207e$var$c0;
const $ef053115c0f9207e$var$ts = $ef053115c0f9207e$var$u1, $ef053115c0f9207e$var$Dn = $ef053115c0f9207e$var$nn, $ef053115c0f9207e$var$h0 = $ef053115c0f9207e$var$Mo;
let $ef053115c0f9207e$var$f0 = class extends $ef053115c0f9207e$var$ts {
    constructor(t){
        super(t), this.tokenizer = t, this.posTracker = $ef053115c0f9207e$var$ts.install(t.preprocessor, $ef053115c0f9207e$var$h0), this.currentAttrLocation = null, this.ctLoc = null;
    }
    _getCurrentLocation() {
        return {
            startLine: this.posTracker.line,
            startCol: this.posTracker.col,
            startOffset: this.posTracker.offset,
            endLine: -1,
            endCol: -1,
            endOffset: -1
        };
    }
    _attachCurrentAttrLocationInfo() {
        this.currentAttrLocation.endLine = this.posTracker.line, this.currentAttrLocation.endCol = this.posTracker.col, this.currentAttrLocation.endOffset = this.posTracker.offset;
        const t = this.tokenizer.currentToken, n = this.tokenizer.currentAttr;
        t.location.attrs || (t.location.attrs = /* @__PURE__ */ Object.create(null)), t.location.attrs[n.name] = this.currentAttrLocation;
    }
    _getOverriddenMethods(t, n) {
        const r = {
            _createStartTagToken () {
                n._createStartTagToken.call(this), this.currentToken.location = t.ctLoc;
            },
            _createEndTagToken () {
                n._createEndTagToken.call(this), this.currentToken.location = t.ctLoc;
            },
            _createCommentToken () {
                n._createCommentToken.call(this), this.currentToken.location = t.ctLoc;
            },
            _createDoctypeToken (i) {
                n._createDoctypeToken.call(this, i), this.currentToken.location = t.ctLoc;
            },
            _createCharacterToken (i, s) {
                n._createCharacterToken.call(this, i, s), this.currentCharacterToken.location = t.ctLoc;
            },
            _createEOFToken () {
                n._createEOFToken.call(this), this.currentToken.location = t._getCurrentLocation();
            },
            _createAttr (i) {
                n._createAttr.call(this, i), t.currentAttrLocation = t._getCurrentLocation();
            },
            _leaveAttrName (i) {
                n._leaveAttrName.call(this, i), t._attachCurrentAttrLocationInfo();
            },
            _leaveAttrValue (i) {
                n._leaveAttrValue.call(this, i), t._attachCurrentAttrLocationInfo();
            },
            _emitCurrentToken () {
                const i = this.currentToken.location;
                this.currentCharacterToken && (this.currentCharacterToken.location.endLine = i.startLine, this.currentCharacterToken.location.endCol = i.startCol, this.currentCharacterToken.location.endOffset = i.startOffset), this.currentToken.type === $ef053115c0f9207e$var$Dn.EOF_TOKEN ? (i.endLine = i.startLine, i.endCol = i.startCol, i.endOffset = i.startOffset) : (i.endLine = t.posTracker.line, i.endCol = t.posTracker.col + 1, i.endOffset = t.posTracker.offset + 1), n._emitCurrentToken.call(this);
            },
            _emitCurrentCharacterToken () {
                const i = this.currentCharacterToken && this.currentCharacterToken.location;
                i && i.endOffset === -1 && (i.endLine = t.posTracker.line, i.endCol = t.posTracker.col, i.endOffset = t.posTracker.offset), n._emitCurrentCharacterToken.call(this);
            }
        };
        return Object.keys($ef053115c0f9207e$var$Dn.MODE).forEach((i)=>{
            const s = $ef053115c0f9207e$var$Dn.MODE[i];
            r[s] = function(o) {
                t.ctLoc = t._getCurrentLocation(), n[s].call(this, o);
            };
        }), r;
    }
};
var $ef053115c0f9207e$var$bo = $ef053115c0f9207e$var$f0;
const $ef053115c0f9207e$var$T0 = $ef053115c0f9207e$var$u1;
let $ef053115c0f9207e$var$d0 = class extends $ef053115c0f9207e$var$T0 {
    constructor(t, n){
        super(t), this.onItemPop = n.onItemPop;
    }
    _getOverriddenMethods(t, n) {
        return {
            pop () {
                t.onItemPop(this.current), n.pop.call(this);
            },
            popAllUpToHtmlElement () {
                for(let r = this.stackTop; r > 0; r--)t.onItemPop(this.items[r]);
                n.popAllUpToHtmlElement.call(this);
            },
            remove (r) {
                t.onItemPop(this.current), n.remove.call(this, r);
            }
        };
    }
};
var $ef053115c0f9207e$var$m0 = $ef053115c0f9207e$var$d0;
const $ef053115c0f9207e$var$wn = $ef053115c0f9207e$var$u1, $ef053115c0f9207e$var$ns = $ef053115c0f9207e$var$nn, $ef053115c0f9207e$var$p0 = $ef053115c0f9207e$var$bo, $ef053115c0f9207e$var$E0 = $ef053115c0f9207e$var$m0, $ef053115c0f9207e$var$_0 = $ef053115c0f9207e$var$je, $ef053115c0f9207e$var$Fn = $ef053115c0f9207e$var$_0.TAG_NAMES;
let $ef053115c0f9207e$var$g0 = class extends $ef053115c0f9207e$var$wn {
    constructor(t){
        super(t), this.parser = t, this.treeAdapter = this.parser.treeAdapter, this.posTracker = null, this.lastStartTagToken = null, this.lastFosterParentingLocation = null, this.currentToken = null;
    }
    _setStartLocation(t) {
        let n = null;
        this.lastStartTagToken && (n = Object.assign({}, this.lastStartTagToken.location), n.startTag = this.lastStartTagToken.location), this.treeAdapter.setNodeSourceCodeLocation(t, n);
    }
    _setEndLocation(t, n) {
        if (this.treeAdapter.getNodeSourceCodeLocation(t) && n.location) {
            const i = n.location, s = this.treeAdapter.getTagName(t), o = n.type === $ef053115c0f9207e$var$ns.END_TAG_TOKEN && s === n.tagName, l = {};
            o ? (l.endTag = Object.assign({}, i), l.endLine = i.endLine, l.endCol = i.endCol, l.endOffset = i.endOffset) : (l.endLine = i.startLine, l.endCol = i.startCol, l.endOffset = i.startOffset), this.treeAdapter.updateNodeSourceCodeLocation(t, l);
        }
    }
    _getOverriddenMethods(t, n) {
        return {
            _bootstrap (r, i) {
                n._bootstrap.call(this, r, i), t.lastStartTagToken = null, t.lastFosterParentingLocation = null, t.currentToken = null;
                const s = $ef053115c0f9207e$var$wn.install(this.tokenizer, $ef053115c0f9207e$var$p0);
                t.posTracker = s.posTracker, $ef053115c0f9207e$var$wn.install(this.openElements, $ef053115c0f9207e$var$E0, {
                    onItemPop: function(o) {
                        t._setEndLocation(o, t.currentToken);
                    }
                });
            },
            _runParsingLoop (r) {
                n._runParsingLoop.call(this, r);
                for(let i = this.openElements.stackTop; i >= 0; i--)t._setEndLocation(this.openElements.items[i], t.currentToken);
            },
            //Token processing
            _processTokenInForeignContent (r) {
                t.currentToken = r, n._processTokenInForeignContent.call(this, r);
            },
            _processToken (r) {
                if (t.currentToken = r, n._processToken.call(this, r), r.type === $ef053115c0f9207e$var$ns.END_TAG_TOKEN && (r.tagName === $ef053115c0f9207e$var$Fn.HTML || r.tagName === $ef053115c0f9207e$var$Fn.BODY && this.openElements.hasInScope($ef053115c0f9207e$var$Fn.BODY))) for(let s = this.openElements.stackTop; s >= 0; s--){
                    const o = this.openElements.items[s];
                    if (this.treeAdapter.getTagName(o) === r.tagName) {
                        t._setEndLocation(o, r);
                        break;
                    }
                }
            },
            //Doctype
            _setDocumentType (r) {
                n._setDocumentType.call(this, r);
                const i = this.treeAdapter.getChildNodes(this.document), s = i.length;
                for(let o = 0; o < s; o++){
                    const l = i[o];
                    if (this.treeAdapter.isDocumentTypeNode(l)) {
                        this.treeAdapter.setNodeSourceCodeLocation(l, r.location);
                        break;
                    }
                }
            },
            //Elements
            _attachElementToTree (r) {
                t._setStartLocation(r), t.lastStartTagToken = null, n._attachElementToTree.call(this, r);
            },
            _appendElement (r, i) {
                t.lastStartTagToken = r, n._appendElement.call(this, r, i);
            },
            _insertElement (r, i) {
                t.lastStartTagToken = r, n._insertElement.call(this, r, i);
            },
            _insertTemplate (r) {
                t.lastStartTagToken = r, n._insertTemplate.call(this, r);
                const i = this.treeAdapter.getTemplateContent(this.openElements.current);
                this.treeAdapter.setNodeSourceCodeLocation(i, null);
            },
            _insertFakeRootElement () {
                n._insertFakeRootElement.call(this), this.treeAdapter.setNodeSourceCodeLocation(this.openElements.current, null);
            },
            //Comments
            _appendCommentNode (r, i) {
                n._appendCommentNode.call(this, r, i);
                const s = this.treeAdapter.getChildNodes(i), o = s[s.length - 1];
                this.treeAdapter.setNodeSourceCodeLocation(o, r.location);
            },
            //Text
            _findFosterParentingLocation () {
                return t.lastFosterParentingLocation = n._findFosterParentingLocation.call(this), t.lastFosterParentingLocation;
            },
            _insertCharacters (r) {
                n._insertCharacters.call(this, r);
                const i = this._shouldFosterParentOnInsertion(), s = i && t.lastFosterParentingLocation.parent || this.openElements.currentTmplContent || this.openElements.current, o = this.treeAdapter.getChildNodes(s), l = i && t.lastFosterParentingLocation.beforeElement ? o.indexOf(t.lastFosterParentingLocation.beforeElement) - 1 : o.length - 1, u = o[l];
                if (this.treeAdapter.getNodeSourceCodeLocation(u)) {
                    const { endLine: h, endCol: p, endOffset: _ } = r.location;
                    this.treeAdapter.updateNodeSourceCodeLocation(u, {
                        endLine: h,
                        endCol: p,
                        endOffset: _
                    });
                } else this.treeAdapter.setNodeSourceCodeLocation(u, r.location);
            }
        };
    }
};
var $ef053115c0f9207e$var$A0 = $ef053115c0f9207e$var$g0;
const $ef053115c0f9207e$var$C0 = $ef053115c0f9207e$var$u1;
let $ef053115c0f9207e$var$S0 = class extends $ef053115c0f9207e$var$C0 {
    constructor(t, n){
        super(t), this.posTracker = null, this.onParseError = n.onParseError;
    }
    _setErrorLocation(t) {
        t.startLine = t.endLine = this.posTracker.line, t.startCol = t.endCol = this.posTracker.col, t.startOffset = t.endOffset = this.posTracker.offset;
    }
    _reportError(t) {
        const n = {
            code: t,
            startLine: -1,
            startCol: -1,
            startOffset: -1,
            endLine: -1,
            endCol: -1,
            endOffset: -1
        };
        this._setErrorLocation(n), this.onParseError(n);
    }
    _getOverriddenMethods(t) {
        return {
            _err (n) {
                t._reportError(n);
            }
        };
    }
};
var $ef053115c0f9207e$var$fr = $ef053115c0f9207e$var$S0;
const $ef053115c0f9207e$var$N0 = $ef053115c0f9207e$var$fr, $ef053115c0f9207e$var$I0 = $ef053115c0f9207e$var$Mo, $ef053115c0f9207e$var$O0 = $ef053115c0f9207e$var$u1;
let $ef053115c0f9207e$var$R0 = class extends $ef053115c0f9207e$var$N0 {
    constructor(t, n){
        super(t, n), this.posTracker = $ef053115c0f9207e$var$O0.install(t, $ef053115c0f9207e$var$I0), this.lastErrOffset = -1;
    }
    _reportError(t) {
        this.lastErrOffset !== this.posTracker.offset && (this.lastErrOffset = this.posTracker.offset, super._reportError(t));
    }
};
var $ef053115c0f9207e$var$x0 = $ef053115c0f9207e$var$R0;
const $ef053115c0f9207e$var$y0 = $ef053115c0f9207e$var$fr, $ef053115c0f9207e$var$k0 = $ef053115c0f9207e$var$x0, $ef053115c0f9207e$var$L0 = $ef053115c0f9207e$var$u1;
let $ef053115c0f9207e$var$M0 = class extends $ef053115c0f9207e$var$y0 {
    constructor(t, n){
        super(t, n);
        const r = $ef053115c0f9207e$var$L0.install(t.preprocessor, $ef053115c0f9207e$var$k0, n);
        this.posTracker = r.posTracker;
    }
};
var $ef053115c0f9207e$var$b0 = $ef053115c0f9207e$var$M0;
const $ef053115c0f9207e$var$P0 = $ef053115c0f9207e$var$fr, $ef053115c0f9207e$var$D0 = $ef053115c0f9207e$var$b0, $ef053115c0f9207e$var$w0 = $ef053115c0f9207e$var$bo, $ef053115c0f9207e$var$rs = $ef053115c0f9207e$var$u1;
let $ef053115c0f9207e$var$F0 = class extends $ef053115c0f9207e$var$P0 {
    constructor(t, n){
        super(t, n), this.opts = n, this.ctLoc = null, this.locBeforeToken = !1;
    }
    _setErrorLocation(t) {
        this.ctLoc && (t.startLine = this.ctLoc.startLine, t.startCol = this.ctLoc.startCol, t.startOffset = this.ctLoc.startOffset, t.endLine = this.locBeforeToken ? this.ctLoc.startLine : this.ctLoc.endLine, t.endCol = this.locBeforeToken ? this.ctLoc.startCol : this.ctLoc.endCol, t.endOffset = this.locBeforeToken ? this.ctLoc.startOffset : this.ctLoc.endOffset);
    }
    _getOverriddenMethods(t, n) {
        return {
            _bootstrap (r, i) {
                n._bootstrap.call(this, r, i), $ef053115c0f9207e$var$rs.install(this.tokenizer, $ef053115c0f9207e$var$D0, t.opts), $ef053115c0f9207e$var$rs.install(this.tokenizer, $ef053115c0f9207e$var$w0);
            },
            _processInputToken (r) {
                t.ctLoc = r.location, n._processInputToken.call(this, r);
            },
            _err (r, i) {
                t.locBeforeToken = i && i.beforeToken, t._reportError(r);
            }
        };
    }
};
var $ef053115c0f9207e$var$H0 = $ef053115c0f9207e$var$F0, $ef053115c0f9207e$var$W = {};
const { DOCUMENT_MODE: $ef053115c0f9207e$var$B0 } = $ef053115c0f9207e$var$je;
$ef053115c0f9207e$var$W.createDocument = function() {
    return {
        nodeName: "#document",
        mode: $ef053115c0f9207e$var$B0.NO_QUIRKS,
        childNodes: []
    };
};
$ef053115c0f9207e$var$W.createDocumentFragment = function() {
    return {
        nodeName: "#document-fragment",
        childNodes: []
    };
};
$ef053115c0f9207e$var$W.createElement = function(e, t, n) {
    return {
        nodeName: e,
        tagName: e,
        attrs: n,
        namespaceURI: t,
        childNodes: [],
        parentNode: null
    };
};
$ef053115c0f9207e$var$W.createCommentNode = function(e) {
    return {
        nodeName: "#comment",
        data: e,
        parentNode: null
    };
};
const $ef053115c0f9207e$var$Po = function(e) {
    return {
        nodeName: "#text",
        value: e,
        parentNode: null
    };
}, $ef053115c0f9207e$var$Do = $ef053115c0f9207e$var$W.appendChild = function(e, t) {
    e.childNodes.push(t), t.parentNode = e;
}, $ef053115c0f9207e$var$U0 = $ef053115c0f9207e$var$W.insertBefore = function(e, t, n) {
    const r = e.childNodes.indexOf(n);
    e.childNodes.splice(r, 0, t), t.parentNode = e;
};
$ef053115c0f9207e$var$W.setTemplateContent = function(e, t) {
    e.content = t;
};
$ef053115c0f9207e$var$W.getTemplateContent = function(e) {
    return e.content;
};
$ef053115c0f9207e$var$W.setDocumentType = function(e, t, n, r) {
    let i = null;
    for(let s = 0; s < e.childNodes.length; s++)if (e.childNodes[s].nodeName === "#documentType") {
        i = e.childNodes[s];
        break;
    }
    i ? (i.name = t, i.publicId = n, i.systemId = r) : $ef053115c0f9207e$var$Do(e, {
        nodeName: "#documentType",
        name: t,
        publicId: n,
        systemId: r
    });
};
$ef053115c0f9207e$var$W.setDocumentMode = function(e, t) {
    e.mode = t;
};
$ef053115c0f9207e$var$W.getDocumentMode = function(e) {
    return e.mode;
};
$ef053115c0f9207e$var$W.detachNode = function(e) {
    if (e.parentNode) {
        const t = e.parentNode.childNodes.indexOf(e);
        e.parentNode.childNodes.splice(t, 1), e.parentNode = null;
    }
};
$ef053115c0f9207e$var$W.insertText = function(e, t) {
    if (e.childNodes.length) {
        const n = e.childNodes[e.childNodes.length - 1];
        if (n.nodeName === "#text") {
            n.value += t;
            return;
        }
    }
    $ef053115c0f9207e$var$Do(e, $ef053115c0f9207e$var$Po(t));
};
$ef053115c0f9207e$var$W.insertTextBefore = function(e, t, n) {
    const r = e.childNodes[e.childNodes.indexOf(n) - 1];
    r && r.nodeName === "#text" ? r.value += t : $ef053115c0f9207e$var$U0(e, $ef053115c0f9207e$var$Po(t), n);
};
$ef053115c0f9207e$var$W.adoptAttributes = function(e, t) {
    const n = [];
    for(let r = 0; r < e.attrs.length; r++)n.push(e.attrs[r].name);
    for(let r = 0; r < t.length; r++)n.indexOf(t[r].name) === -1 && e.attrs.push(t[r]);
};
$ef053115c0f9207e$var$W.getFirstChild = function(e) {
    return e.childNodes[0];
};
$ef053115c0f9207e$var$W.getChildNodes = function(e) {
    return e.childNodes;
};
$ef053115c0f9207e$var$W.getParentNode = function(e) {
    return e.parentNode;
};
$ef053115c0f9207e$var$W.getAttrList = function(e) {
    return e.attrs;
};
$ef053115c0f9207e$var$W.getTagName = function(e) {
    return e.tagName;
};
$ef053115c0f9207e$var$W.getNamespaceURI = function(e) {
    return e.namespaceURI;
};
$ef053115c0f9207e$var$W.getTextNodeContent = function(e) {
    return e.value;
};
$ef053115c0f9207e$var$W.getCommentNodeContent = function(e) {
    return e.data;
};
$ef053115c0f9207e$var$W.getDocumentTypeNodeName = function(e) {
    return e.name;
};
$ef053115c0f9207e$var$W.getDocumentTypeNodePublicId = function(e) {
    return e.publicId;
};
$ef053115c0f9207e$var$W.getDocumentTypeNodeSystemId = function(e) {
    return e.systemId;
};
$ef053115c0f9207e$var$W.isTextNode = function(e) {
    return e.nodeName === "#text";
};
$ef053115c0f9207e$var$W.isCommentNode = function(e) {
    return e.nodeName === "#comment";
};
$ef053115c0f9207e$var$W.isDocumentTypeNode = function(e) {
    return e.nodeName === "#documentType";
};
$ef053115c0f9207e$var$W.isElementNode = function(e) {
    return !!e.tagName;
};
$ef053115c0f9207e$var$W.setNodeSourceCodeLocation = function(e, t) {
    e.sourceCodeLocation = t;
};
$ef053115c0f9207e$var$W.getNodeSourceCodeLocation = function(e) {
    return e.sourceCodeLocation;
};
$ef053115c0f9207e$var$W.updateNodeSourceCodeLocation = function(e, t) {
    e.sourceCodeLocation = Object.assign(e.sourceCodeLocation, t);
};
var $ef053115c0f9207e$var$v0 = function(t, n) {
    return n = n || /* @__PURE__ */ Object.create(null), [
        t,
        n
    ].reduce((r, i)=>(Object.keys(i).forEach((s)=>{
            r[s] = i[s];
        }), r), /* @__PURE__ */ Object.create(null));
}, $ef053115c0f9207e$var$rn = {};
const { DOCUMENT_MODE: $ef053115c0f9207e$var$F1 } = $ef053115c0f9207e$var$je, $ef053115c0f9207e$var$wo = "html", $ef053115c0f9207e$var$G0 = "about:legacy-compat", $ef053115c0f9207e$var$K0 = "http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd", $ef053115c0f9207e$var$Fo = [
    "+//silmaril//dtd html pro v0r11 19970101//",
    "-//as//dtd html 3.0 aswedit + extensions//",
    "-//advasoft ltd//dtd html 3.0 aswedit + extensions//",
    "-//ietf//dtd html 2.0 level 1//",
    "-//ietf//dtd html 2.0 level 2//",
    "-//ietf//dtd html 2.0 strict level 1//",
    "-//ietf//dtd html 2.0 strict level 2//",
    "-//ietf//dtd html 2.0 strict//",
    "-//ietf//dtd html 2.0//",
    "-//ietf//dtd html 2.1e//",
    "-//ietf//dtd html 3.0//",
    "-//ietf//dtd html 3.2 final//",
    "-//ietf//dtd html 3.2//",
    "-//ietf//dtd html 3//",
    "-//ietf//dtd html level 0//",
    "-//ietf//dtd html level 1//",
    "-//ietf//dtd html level 2//",
    "-//ietf//dtd html level 3//",
    "-//ietf//dtd html strict level 0//",
    "-//ietf//dtd html strict level 1//",
    "-//ietf//dtd html strict level 2//",
    "-//ietf//dtd html strict level 3//",
    "-//ietf//dtd html strict//",
    "-//ietf//dtd html//",
    "-//metrius//dtd metrius presentational//",
    "-//microsoft//dtd internet explorer 2.0 html strict//",
    "-//microsoft//dtd internet explorer 2.0 html//",
    "-//microsoft//dtd internet explorer 2.0 tables//",
    "-//microsoft//dtd internet explorer 3.0 html strict//",
    "-//microsoft//dtd internet explorer 3.0 html//",
    "-//microsoft//dtd internet explorer 3.0 tables//",
    "-//netscape comm. corp.//dtd html//",
    "-//netscape comm. corp.//dtd strict html//",
    "-//o'reilly and associates//dtd html 2.0//",
    "-//o'reilly and associates//dtd html extended 1.0//",
    "-//o'reilly and associates//dtd html extended relaxed 1.0//",
    "-//sq//dtd html 2.0 hotmetal + extensions//",
    "-//softquad software//dtd hotmetal pro 6.0::19990601::extensions to html 4.0//",
    "-//softquad//dtd hotmetal pro 4.0::19971010::extensions to html 4.0//",
    "-//spyglass//dtd html 2.0 extended//",
    "-//sun microsystems corp.//dtd hotjava html//",
    "-//sun microsystems corp.//dtd hotjava strict html//",
    "-//w3c//dtd html 3 1995-03-24//",
    "-//w3c//dtd html 3.2 draft//",
    "-//w3c//dtd html 3.2 final//",
    "-//w3c//dtd html 3.2//",
    "-//w3c//dtd html 3.2s draft//",
    "-//w3c//dtd html 4.0 frameset//",
    "-//w3c//dtd html 4.0 transitional//",
    "-//w3c//dtd html experimental 19960712//",
    "-//w3c//dtd html experimental 970421//",
    "-//w3c//dtd w3 html//",
    "-//w3o//dtd w3 html 3.0//",
    "-//webtechs//dtd mozilla html 2.0//",
    "-//webtechs//dtd mozilla html//"
], $ef053115c0f9207e$var$z0 = $ef053115c0f9207e$var$Fo.concat([
    "-//w3c//dtd html 4.01 frameset//",
    "-//w3c//dtd html 4.01 transitional//"
]), $ef053115c0f9207e$var$Y0 = [
    "-//w3o//dtd w3 html strict 3.0//en//",
    "-/w3c/dtd html 4.0 transitional/en",
    "html"
], $ef053115c0f9207e$var$Ho = [
    "-//w3c//dtd xhtml 1.0 frameset//",
    "-//w3c//dtd xhtml 1.0 transitional//"
], $ef053115c0f9207e$var$j0 = $ef053115c0f9207e$var$Ho.concat([
    "-//w3c//dtd html 4.01 frameset//",
    "-//w3c//dtd html 4.01 transitional//"
]);
function $ef053115c0f9207e$var$is(e) {
    const t = e.indexOf('"') !== -1 ? "'" : '"';
    return t + e + t;
}
function $ef053115c0f9207e$var$ss(e, t) {
    for(let n = 0; n < t.length; n++)if (e.indexOf(t[n]) === 0) return !0;
    return !1;
}
$ef053115c0f9207e$var$rn.isConforming = function(e) {
    return e.name === $ef053115c0f9207e$var$wo && e.publicId === null && (e.systemId === null || e.systemId === $ef053115c0f9207e$var$G0);
};
$ef053115c0f9207e$var$rn.getDocumentMode = function(e) {
    if (e.name !== $ef053115c0f9207e$var$wo) return $ef053115c0f9207e$var$F1.QUIRKS;
    const t = e.systemId;
    if (t && t.toLowerCase() === $ef053115c0f9207e$var$K0) return $ef053115c0f9207e$var$F1.QUIRKS;
    let n = e.publicId;
    if (n !== null) {
        if (n = n.toLowerCase(), $ef053115c0f9207e$var$Y0.indexOf(n) > -1) return $ef053115c0f9207e$var$F1.QUIRKS;
        let r = t === null ? $ef053115c0f9207e$var$z0 : $ef053115c0f9207e$var$Fo;
        if ($ef053115c0f9207e$var$ss(n, r)) return $ef053115c0f9207e$var$F1.QUIRKS;
        if (r = t === null ? $ef053115c0f9207e$var$Ho : $ef053115c0f9207e$var$j0, $ef053115c0f9207e$var$ss(n, r)) return $ef053115c0f9207e$var$F1.LIMITED_QUIRKS;
    }
    return $ef053115c0f9207e$var$F1.NO_QUIRKS;
};
$ef053115c0f9207e$var$rn.serializeContent = function(e, t, n) {
    let r = "!DOCTYPE ";
    return e && (r += e), t ? r += " PUBLIC " + $ef053115c0f9207e$var$is(t) : n && (r += " SYSTEM"), n !== null && (r += " " + $ef053115c0f9207e$var$is(n)), r;
};
var $ef053115c0f9207e$var$g1 = {};
const $ef053115c0f9207e$var$Hn = $ef053115c0f9207e$var$nn, $ef053115c0f9207e$var$Tr = $ef053115c0f9207e$var$je, $ef053115c0f9207e$var$P = $ef053115c0f9207e$var$Tr.TAG_NAMES, $ef053115c0f9207e$var$pe = $ef053115c0f9207e$var$Tr.NAMESPACES, $ef053115c0f9207e$var$zt = $ef053115c0f9207e$var$Tr.ATTRS, $ef053115c0f9207e$var$os = {
    TEXT_HTML: "text/html",
    APPLICATION_XML: "application/xhtml+xml"
}, $ef053115c0f9207e$var$$0 = "definitionurl", $ef053115c0f9207e$var$Q0 = "definitionURL", $ef053115c0f9207e$var$W0 = {
    attributename: "attributeName",
    attributetype: "attributeType",
    basefrequency: "baseFrequency",
    baseprofile: "baseProfile",
    calcmode: "calcMode",
    clippathunits: "clipPathUnits",
    diffuseconstant: "diffuseConstant",
    edgemode: "edgeMode",
    filterunits: "filterUnits",
    glyphref: "glyphRef",
    gradienttransform: "gradientTransform",
    gradientunits: "gradientUnits",
    kernelmatrix: "kernelMatrix",
    kernelunitlength: "kernelUnitLength",
    keypoints: "keyPoints",
    keysplines: "keySplines",
    keytimes: "keyTimes",
    lengthadjust: "lengthAdjust",
    limitingconeangle: "limitingConeAngle",
    markerheight: "markerHeight",
    markerunits: "markerUnits",
    markerwidth: "markerWidth",
    maskcontentunits: "maskContentUnits",
    maskunits: "maskUnits",
    numoctaves: "numOctaves",
    pathlength: "pathLength",
    patterncontentunits: "patternContentUnits",
    patterntransform: "patternTransform",
    patternunits: "patternUnits",
    pointsatx: "pointsAtX",
    pointsaty: "pointsAtY",
    pointsatz: "pointsAtZ",
    preservealpha: "preserveAlpha",
    preserveaspectratio: "preserveAspectRatio",
    primitiveunits: "primitiveUnits",
    refx: "refX",
    refy: "refY",
    repeatcount: "repeatCount",
    repeatdur: "repeatDur",
    requiredextensions: "requiredExtensions",
    requiredfeatures: "requiredFeatures",
    specularconstant: "specularConstant",
    specularexponent: "specularExponent",
    spreadmethod: "spreadMethod",
    startoffset: "startOffset",
    stddeviation: "stdDeviation",
    stitchtiles: "stitchTiles",
    surfacescale: "surfaceScale",
    systemlanguage: "systemLanguage",
    tablevalues: "tableValues",
    targetx: "targetX",
    targety: "targetY",
    textlength: "textLength",
    viewbox: "viewBox",
    viewtarget: "viewTarget",
    xchannelselector: "xChannelSelector",
    ychannelselector: "yChannelSelector",
    zoomandpan: "zoomAndPan"
}, $ef053115c0f9207e$var$q0 = {
    "xlink:actuate": {
        prefix: "xlink",
        name: "actuate",
        namespace: $ef053115c0f9207e$var$pe.XLINK
    },
    "xlink:arcrole": {
        prefix: "xlink",
        name: "arcrole",
        namespace: $ef053115c0f9207e$var$pe.XLINK
    },
    "xlink:href": {
        prefix: "xlink",
        name: "href",
        namespace: $ef053115c0f9207e$var$pe.XLINK
    },
    "xlink:role": {
        prefix: "xlink",
        name: "role",
        namespace: $ef053115c0f9207e$var$pe.XLINK
    },
    "xlink:show": {
        prefix: "xlink",
        name: "show",
        namespace: $ef053115c0f9207e$var$pe.XLINK
    },
    "xlink:title": {
        prefix: "xlink",
        name: "title",
        namespace: $ef053115c0f9207e$var$pe.XLINK
    },
    "xlink:type": {
        prefix: "xlink",
        name: "type",
        namespace: $ef053115c0f9207e$var$pe.XLINK
    },
    "xml:base": {
        prefix: "xml",
        name: "base",
        namespace: $ef053115c0f9207e$var$pe.XML
    },
    "xml:lang": {
        prefix: "xml",
        name: "lang",
        namespace: $ef053115c0f9207e$var$pe.XML
    },
    "xml:space": {
        prefix: "xml",
        name: "space",
        namespace: $ef053115c0f9207e$var$pe.XML
    },
    xmlns: {
        prefix: "",
        name: "xmlns",
        namespace: $ef053115c0f9207e$var$pe.XMLNS
    },
    "xmlns:xlink": {
        prefix: "xmlns",
        name: "xlink",
        namespace: $ef053115c0f9207e$var$pe.XMLNS
    }
}, $ef053115c0f9207e$var$V0 = $ef053115c0f9207e$var$g1.SVG_TAG_NAMES_ADJUSTMENT_MAP = {
    altglyph: "altGlyph",
    altglyphdef: "altGlyphDef",
    altglyphitem: "altGlyphItem",
    animatecolor: "animateColor",
    animatemotion: "animateMotion",
    animatetransform: "animateTransform",
    clippath: "clipPath",
    feblend: "feBlend",
    fecolormatrix: "feColorMatrix",
    fecomponenttransfer: "feComponentTransfer",
    fecomposite: "feComposite",
    feconvolvematrix: "feConvolveMatrix",
    fediffuselighting: "feDiffuseLighting",
    fedisplacementmap: "feDisplacementMap",
    fedistantlight: "feDistantLight",
    feflood: "feFlood",
    fefunca: "feFuncA",
    fefuncb: "feFuncB",
    fefuncg: "feFuncG",
    fefuncr: "feFuncR",
    fegaussianblur: "feGaussianBlur",
    feimage: "feImage",
    femerge: "feMerge",
    femergenode: "feMergeNode",
    femorphology: "feMorphology",
    feoffset: "feOffset",
    fepointlight: "fePointLight",
    fespecularlighting: "feSpecularLighting",
    fespotlight: "feSpotLight",
    fetile: "feTile",
    feturbulence: "feTurbulence",
    foreignobject: "foreignObject",
    glyphref: "glyphRef",
    lineargradient: "linearGradient",
    radialgradient: "radialGradient",
    textpath: "textPath"
}, $ef053115c0f9207e$var$X0 = {
    [$ef053115c0f9207e$var$P.B]: !0,
    [$ef053115c0f9207e$var$P.BIG]: !0,
    [$ef053115c0f9207e$var$P.BLOCKQUOTE]: !0,
    [$ef053115c0f9207e$var$P.BODY]: !0,
    [$ef053115c0f9207e$var$P.BR]: !0,
    [$ef053115c0f9207e$var$P.CENTER]: !0,
    [$ef053115c0f9207e$var$P.CODE]: !0,
    [$ef053115c0f9207e$var$P.DD]: !0,
    [$ef053115c0f9207e$var$P.DIV]: !0,
    [$ef053115c0f9207e$var$P.DL]: !0,
    [$ef053115c0f9207e$var$P.DT]: !0,
    [$ef053115c0f9207e$var$P.EM]: !0,
    [$ef053115c0f9207e$var$P.EMBED]: !0,
    [$ef053115c0f9207e$var$P.H1]: !0,
    [$ef053115c0f9207e$var$P.H2]: !0,
    [$ef053115c0f9207e$var$P.H3]: !0,
    [$ef053115c0f9207e$var$P.H4]: !0,
    [$ef053115c0f9207e$var$P.H5]: !0,
    [$ef053115c0f9207e$var$P.H6]: !0,
    [$ef053115c0f9207e$var$P.HEAD]: !0,
    [$ef053115c0f9207e$var$P.HR]: !0,
    [$ef053115c0f9207e$var$P.I]: !0,
    [$ef053115c0f9207e$var$P.IMG]: !0,
    [$ef053115c0f9207e$var$P.LI]: !0,
    [$ef053115c0f9207e$var$P.LISTING]: !0,
    [$ef053115c0f9207e$var$P.MENU]: !0,
    [$ef053115c0f9207e$var$P.META]: !0,
    [$ef053115c0f9207e$var$P.NOBR]: !0,
    [$ef053115c0f9207e$var$P.OL]: !0,
    [$ef053115c0f9207e$var$P.P]: !0,
    [$ef053115c0f9207e$var$P.PRE]: !0,
    [$ef053115c0f9207e$var$P.RUBY]: !0,
    [$ef053115c0f9207e$var$P.S]: !0,
    [$ef053115c0f9207e$var$P.SMALL]: !0,
    [$ef053115c0f9207e$var$P.SPAN]: !0,
    [$ef053115c0f9207e$var$P.STRONG]: !0,
    [$ef053115c0f9207e$var$P.STRIKE]: !0,
    [$ef053115c0f9207e$var$P.SUB]: !0,
    [$ef053115c0f9207e$var$P.SUP]: !0,
    [$ef053115c0f9207e$var$P.TABLE]: !0,
    [$ef053115c0f9207e$var$P.TT]: !0,
    [$ef053115c0f9207e$var$P.U]: !0,
    [$ef053115c0f9207e$var$P.UL]: !0,
    [$ef053115c0f9207e$var$P.VAR]: !0
};
$ef053115c0f9207e$var$g1.causesExit = function(e) {
    const t = e.tagName;
    return t === $ef053115c0f9207e$var$P.FONT && ($ef053115c0f9207e$var$Hn.getTokenAttr(e, $ef053115c0f9207e$var$zt.COLOR) !== null || $ef053115c0f9207e$var$Hn.getTokenAttr(e, $ef053115c0f9207e$var$zt.SIZE) !== null || $ef053115c0f9207e$var$Hn.getTokenAttr(e, $ef053115c0f9207e$var$zt.FACE) !== null) ? !0 : $ef053115c0f9207e$var$X0[t];
};
$ef053115c0f9207e$var$g1.adjustTokenMathMLAttrs = function(e) {
    for(let t = 0; t < e.attrs.length; t++)if (e.attrs[t].name === $ef053115c0f9207e$var$$0) {
        e.attrs[t].name = $ef053115c0f9207e$var$Q0;
        break;
    }
};
$ef053115c0f9207e$var$g1.adjustTokenSVGAttrs = function(e) {
    for(let t = 0; t < e.attrs.length; t++){
        const n = $ef053115c0f9207e$var$W0[e.attrs[t].name];
        n && (e.attrs[t].name = n);
    }
};
$ef053115c0f9207e$var$g1.adjustTokenXMLAttrs = function(e) {
    for(let t = 0; t < e.attrs.length; t++){
        const n = $ef053115c0f9207e$var$q0[e.attrs[t].name];
        n && (e.attrs[t].prefix = n.prefix, e.attrs[t].name = n.name, e.attrs[t].namespace = n.namespace);
    }
};
$ef053115c0f9207e$var$g1.adjustTokenSVGTagName = function(e) {
    const t = $ef053115c0f9207e$var$V0[e.tagName];
    t && (e.tagName = t);
};
function $ef053115c0f9207e$var$J0(e, t) {
    return t === $ef053115c0f9207e$var$pe.MATHML && (e === $ef053115c0f9207e$var$P.MI || e === $ef053115c0f9207e$var$P.MO || e === $ef053115c0f9207e$var$P.MN || e === $ef053115c0f9207e$var$P.MS || e === $ef053115c0f9207e$var$P.MTEXT);
}
function $ef053115c0f9207e$var$Z0(e, t, n) {
    if (t === $ef053115c0f9207e$var$pe.MATHML && e === $ef053115c0f9207e$var$P.ANNOTATION_XML) {
        for(let r = 0; r < n.length; r++)if (n[r].name === $ef053115c0f9207e$var$zt.ENCODING) {
            const i = n[r].value.toLowerCase();
            return i === $ef053115c0f9207e$var$os.TEXT_HTML || i === $ef053115c0f9207e$var$os.APPLICATION_XML;
        }
    }
    return t === $ef053115c0f9207e$var$pe.SVG && (e === $ef053115c0f9207e$var$P.FOREIGN_OBJECT || e === $ef053115c0f9207e$var$P.DESC || e === $ef053115c0f9207e$var$P.TITLE);
}
$ef053115c0f9207e$var$g1.isIntegrationPoint = function(e, t, n, r) {
    return !!((!r || r === $ef053115c0f9207e$var$pe.HTML) && $ef053115c0f9207e$var$Z0(e, t, n) || (!r || r === $ef053115c0f9207e$var$pe.MATHML) && $ef053115c0f9207e$var$J0(e, t));
};
const $ef053115c0f9207e$var$T = $ef053115c0f9207e$var$nn, $ef053115c0f9207e$var$ec = $ef053115c0f9207e$var$a0, $ef053115c0f9207e$var$as = $ef053115c0f9207e$var$l0, $ef053115c0f9207e$var$tc = $ef053115c0f9207e$var$A0, $ef053115c0f9207e$var$nc = $ef053115c0f9207e$var$H0, $ef053115c0f9207e$var$ls = $ef053115c0f9207e$var$u1, $ef053115c0f9207e$var$rc = $ef053115c0f9207e$var$W, $ef053115c0f9207e$var$ic = $ef053115c0f9207e$var$v0, $ef053115c0f9207e$var$us = $ef053115c0f9207e$var$rn, $ef053115c0f9207e$var$Xe = $ef053115c0f9207e$var$g1, $ef053115c0f9207e$var$_e = $ef053115c0f9207e$var$cr, $ef053115c0f9207e$var$sc = $ef053115c0f9207e$var$Ye, $ef053115c0f9207e$var$x1 = $ef053115c0f9207e$var$je, $ef053115c0f9207e$var$a = $ef053115c0f9207e$var$x1.TAG_NAMES, $ef053115c0f9207e$var$L = $ef053115c0f9207e$var$x1.NAMESPACES, $ef053115c0f9207e$var$Bo = $ef053115c0f9207e$var$x1.ATTRS, $ef053115c0f9207e$var$oc = {
    scriptingEnabled: !0,
    sourceCodeLocationInfo: !1,
    onParseError: null,
    treeAdapter: $ef053115c0f9207e$var$rc
}, $ef053115c0f9207e$var$Uo = "hidden", $ef053115c0f9207e$var$ac = 8, $ef053115c0f9207e$var$lc = 3, $ef053115c0f9207e$var$vo = "INITIAL_MODE", $ef053115c0f9207e$var$dr = "BEFORE_HTML_MODE", $ef053115c0f9207e$var$sn = "BEFORE_HEAD_MODE", $ef053115c0f9207e$var$$1 = "IN_HEAD_MODE", $ef053115c0f9207e$var$Go = "IN_HEAD_NO_SCRIPT_MODE", $ef053115c0f9207e$var$on = "AFTER_HEAD_MODE", $ef053115c0f9207e$var$Je = "IN_BODY_MODE", $ef053115c0f9207e$var$Qt = "TEXT_MODE", $ef053115c0f9207e$var$Ce = "IN_TABLE_MODE", $ef053115c0f9207e$var$Ko = "IN_TABLE_TEXT_MODE", $ef053115c0f9207e$var$an = "IN_CAPTION_MODE", $ef053115c0f9207e$var$_t = "IN_COLUMN_GROUP_MODE", $ef053115c0f9207e$var$we = "IN_TABLE_BODY_MODE", $ef053115c0f9207e$var$l1 = "IN_ROW_MODE", $ef053115c0f9207e$var$ln = "IN_CELL_MODE", $ef053115c0f9207e$var$mr = "IN_SELECT_MODE", $ef053115c0f9207e$var$pr = "IN_SELECT_IN_TABLE_MODE", $ef053115c0f9207e$var$Wt = "IN_TEMPLATE_MODE", $ef053115c0f9207e$var$Er = "AFTER_BODY_MODE", $ef053115c0f9207e$var$un = "IN_FRAMESET_MODE", $ef053115c0f9207e$var$zo = "AFTER_FRAMESET_MODE", $ef053115c0f9207e$var$Yo = "AFTER_AFTER_BODY_MODE", $ef053115c0f9207e$var$jo = "AFTER_AFTER_FRAMESET_MODE", $ef053115c0f9207e$var$uc = {
    [$ef053115c0f9207e$var$a.TR]: $ef053115c0f9207e$var$l1,
    [$ef053115c0f9207e$var$a.TBODY]: $ef053115c0f9207e$var$we,
    [$ef053115c0f9207e$var$a.THEAD]: $ef053115c0f9207e$var$we,
    [$ef053115c0f9207e$var$a.TFOOT]: $ef053115c0f9207e$var$we,
    [$ef053115c0f9207e$var$a.CAPTION]: $ef053115c0f9207e$var$an,
    [$ef053115c0f9207e$var$a.COLGROUP]: $ef053115c0f9207e$var$_t,
    [$ef053115c0f9207e$var$a.TABLE]: $ef053115c0f9207e$var$Ce,
    [$ef053115c0f9207e$var$a.BODY]: $ef053115c0f9207e$var$Je,
    [$ef053115c0f9207e$var$a.FRAMESET]: $ef053115c0f9207e$var$un
}, $ef053115c0f9207e$var$cc = {
    [$ef053115c0f9207e$var$a.CAPTION]: $ef053115c0f9207e$var$Ce,
    [$ef053115c0f9207e$var$a.COLGROUP]: $ef053115c0f9207e$var$Ce,
    [$ef053115c0f9207e$var$a.TBODY]: $ef053115c0f9207e$var$Ce,
    [$ef053115c0f9207e$var$a.TFOOT]: $ef053115c0f9207e$var$Ce,
    [$ef053115c0f9207e$var$a.THEAD]: $ef053115c0f9207e$var$Ce,
    [$ef053115c0f9207e$var$a.COL]: $ef053115c0f9207e$var$_t,
    [$ef053115c0f9207e$var$a.TR]: $ef053115c0f9207e$var$we,
    [$ef053115c0f9207e$var$a.TD]: $ef053115c0f9207e$var$l1,
    [$ef053115c0f9207e$var$a.TH]: $ef053115c0f9207e$var$l1
}, $ef053115c0f9207e$var$cs = {
    [$ef053115c0f9207e$var$vo]: {
        [$ef053115c0f9207e$var$T.CHARACTER_TOKEN]: $ef053115c0f9207e$var$rt,
        [$ef053115c0f9207e$var$T.NULL_CHARACTER_TOKEN]: $ef053115c0f9207e$var$rt,
        [$ef053115c0f9207e$var$T.WHITESPACE_CHARACTER_TOKEN]: $ef053115c0f9207e$var$Q,
        [$ef053115c0f9207e$var$T.COMMENT_TOKEN]: $ef053115c0f9207e$var$he,
        [$ef053115c0f9207e$var$T.DOCTYPE_TOKEN]: $ef053115c0f9207e$var$Ac,
        [$ef053115c0f9207e$var$T.START_TAG_TOKEN]: $ef053115c0f9207e$var$rt,
        [$ef053115c0f9207e$var$T.END_TAG_TOKEN]: $ef053115c0f9207e$var$rt,
        [$ef053115c0f9207e$var$T.EOF_TOKEN]: $ef053115c0f9207e$var$rt
    },
    [$ef053115c0f9207e$var$dr]: {
        [$ef053115c0f9207e$var$T.CHARACTER_TOKEN]: $ef053115c0f9207e$var$ct,
        [$ef053115c0f9207e$var$T.NULL_CHARACTER_TOKEN]: $ef053115c0f9207e$var$ct,
        [$ef053115c0f9207e$var$T.WHITESPACE_CHARACTER_TOKEN]: $ef053115c0f9207e$var$Q,
        [$ef053115c0f9207e$var$T.COMMENT_TOKEN]: $ef053115c0f9207e$var$he,
        [$ef053115c0f9207e$var$T.DOCTYPE_TOKEN]: $ef053115c0f9207e$var$Q,
        [$ef053115c0f9207e$var$T.START_TAG_TOKEN]: $ef053115c0f9207e$var$Cc,
        [$ef053115c0f9207e$var$T.END_TAG_TOKEN]: $ef053115c0f9207e$var$Sc,
        [$ef053115c0f9207e$var$T.EOF_TOKEN]: $ef053115c0f9207e$var$ct
    },
    [$ef053115c0f9207e$var$sn]: {
        [$ef053115c0f9207e$var$T.CHARACTER_TOKEN]: $ef053115c0f9207e$var$ht,
        [$ef053115c0f9207e$var$T.NULL_CHARACTER_TOKEN]: $ef053115c0f9207e$var$ht,
        [$ef053115c0f9207e$var$T.WHITESPACE_CHARACTER_TOKEN]: $ef053115c0f9207e$var$Q,
        [$ef053115c0f9207e$var$T.COMMENT_TOKEN]: $ef053115c0f9207e$var$he,
        [$ef053115c0f9207e$var$T.DOCTYPE_TOKEN]: $ef053115c0f9207e$var$wt,
        [$ef053115c0f9207e$var$T.START_TAG_TOKEN]: $ef053115c0f9207e$var$Nc,
        [$ef053115c0f9207e$var$T.END_TAG_TOKEN]: $ef053115c0f9207e$var$Ic,
        [$ef053115c0f9207e$var$T.EOF_TOKEN]: $ef053115c0f9207e$var$ht
    },
    [$ef053115c0f9207e$var$$1]: {
        [$ef053115c0f9207e$var$T.CHARACTER_TOKEN]: $ef053115c0f9207e$var$ft,
        [$ef053115c0f9207e$var$T.NULL_CHARACTER_TOKEN]: $ef053115c0f9207e$var$ft,
        [$ef053115c0f9207e$var$T.WHITESPACE_CHARACTER_TOKEN]: $ef053115c0f9207e$var$Oe,
        [$ef053115c0f9207e$var$T.COMMENT_TOKEN]: $ef053115c0f9207e$var$he,
        [$ef053115c0f9207e$var$T.DOCTYPE_TOKEN]: $ef053115c0f9207e$var$wt,
        [$ef053115c0f9207e$var$T.START_TAG_TOKEN]: $ef053115c0f9207e$var$de,
        [$ef053115c0f9207e$var$T.END_TAG_TOKEN]: $ef053115c0f9207e$var$y1,
        [$ef053115c0f9207e$var$T.EOF_TOKEN]: $ef053115c0f9207e$var$ft
    },
    [$ef053115c0f9207e$var$Go]: {
        [$ef053115c0f9207e$var$T.CHARACTER_TOKEN]: $ef053115c0f9207e$var$Tt,
        [$ef053115c0f9207e$var$T.NULL_CHARACTER_TOKEN]: $ef053115c0f9207e$var$Tt,
        [$ef053115c0f9207e$var$T.WHITESPACE_CHARACTER_TOKEN]: $ef053115c0f9207e$var$Oe,
        [$ef053115c0f9207e$var$T.COMMENT_TOKEN]: $ef053115c0f9207e$var$he,
        [$ef053115c0f9207e$var$T.DOCTYPE_TOKEN]: $ef053115c0f9207e$var$wt,
        [$ef053115c0f9207e$var$T.START_TAG_TOKEN]: $ef053115c0f9207e$var$Oc,
        [$ef053115c0f9207e$var$T.END_TAG_TOKEN]: $ef053115c0f9207e$var$Rc,
        [$ef053115c0f9207e$var$T.EOF_TOKEN]: $ef053115c0f9207e$var$Tt
    },
    [$ef053115c0f9207e$var$on]: {
        [$ef053115c0f9207e$var$T.CHARACTER_TOKEN]: $ef053115c0f9207e$var$dt,
        [$ef053115c0f9207e$var$T.NULL_CHARACTER_TOKEN]: $ef053115c0f9207e$var$dt,
        [$ef053115c0f9207e$var$T.WHITESPACE_CHARACTER_TOKEN]: $ef053115c0f9207e$var$Oe,
        [$ef053115c0f9207e$var$T.COMMENT_TOKEN]: $ef053115c0f9207e$var$he,
        [$ef053115c0f9207e$var$T.DOCTYPE_TOKEN]: $ef053115c0f9207e$var$wt,
        [$ef053115c0f9207e$var$T.START_TAG_TOKEN]: $ef053115c0f9207e$var$xc,
        [$ef053115c0f9207e$var$T.END_TAG_TOKEN]: $ef053115c0f9207e$var$yc,
        [$ef053115c0f9207e$var$T.EOF_TOKEN]: $ef053115c0f9207e$var$dt
    },
    [$ef053115c0f9207e$var$Je]: {
        [$ef053115c0f9207e$var$T.CHARACTER_TOKEN]: $ef053115c0f9207e$var$Ft,
        [$ef053115c0f9207e$var$T.NULL_CHARACTER_TOKEN]: $ef053115c0f9207e$var$Q,
        [$ef053115c0f9207e$var$T.WHITESPACE_CHARACTER_TOKEN]: $ef053115c0f9207e$var$N1,
        [$ef053115c0f9207e$var$T.COMMENT_TOKEN]: $ef053115c0f9207e$var$he,
        [$ef053115c0f9207e$var$T.DOCTYPE_TOKEN]: $ef053115c0f9207e$var$Q,
        [$ef053115c0f9207e$var$T.START_TAG_TOKEN]: $ef053115c0f9207e$var$xe,
        [$ef053115c0f9207e$var$T.END_TAG_TOKEN]: $ef053115c0f9207e$var$_r,
        [$ef053115c0f9207e$var$T.EOF_TOKEN]: $ef053115c0f9207e$var$s1
    },
    [$ef053115c0f9207e$var$Qt]: {
        [$ef053115c0f9207e$var$T.CHARACTER_TOKEN]: $ef053115c0f9207e$var$Oe,
        [$ef053115c0f9207e$var$T.NULL_CHARACTER_TOKEN]: $ef053115c0f9207e$var$Oe,
        [$ef053115c0f9207e$var$T.WHITESPACE_CHARACTER_TOKEN]: $ef053115c0f9207e$var$Oe,
        [$ef053115c0f9207e$var$T.COMMENT_TOKEN]: $ef053115c0f9207e$var$Q,
        [$ef053115c0f9207e$var$T.DOCTYPE_TOKEN]: $ef053115c0f9207e$var$Q,
        [$ef053115c0f9207e$var$T.START_TAG_TOKEN]: $ef053115c0f9207e$var$Q,
        [$ef053115c0f9207e$var$T.END_TAG_TOKEN]: $ef053115c0f9207e$var$s5,
        [$ef053115c0f9207e$var$T.EOF_TOKEN]: $ef053115c0f9207e$var$o5
    },
    [$ef053115c0f9207e$var$Ce]: {
        [$ef053115c0f9207e$var$T.CHARACTER_TOKEN]: $ef053115c0f9207e$var$o1,
        [$ef053115c0f9207e$var$T.NULL_CHARACTER_TOKEN]: $ef053115c0f9207e$var$o1,
        [$ef053115c0f9207e$var$T.WHITESPACE_CHARACTER_TOKEN]: $ef053115c0f9207e$var$o1,
        [$ef053115c0f9207e$var$T.COMMENT_TOKEN]: $ef053115c0f9207e$var$he,
        [$ef053115c0f9207e$var$T.DOCTYPE_TOKEN]: $ef053115c0f9207e$var$Q,
        [$ef053115c0f9207e$var$T.START_TAG_TOKEN]: $ef053115c0f9207e$var$gr,
        [$ef053115c0f9207e$var$T.END_TAG_TOKEN]: $ef053115c0f9207e$var$Ar,
        [$ef053115c0f9207e$var$T.EOF_TOKEN]: $ef053115c0f9207e$var$s1
    },
    [$ef053115c0f9207e$var$Ko]: {
        [$ef053115c0f9207e$var$T.CHARACTER_TOKEN]: $ef053115c0f9207e$var$p5,
        [$ef053115c0f9207e$var$T.NULL_CHARACTER_TOKEN]: $ef053115c0f9207e$var$Q,
        [$ef053115c0f9207e$var$T.WHITESPACE_CHARACTER_TOKEN]: $ef053115c0f9207e$var$m5,
        [$ef053115c0f9207e$var$T.COMMENT_TOKEN]: $ef053115c0f9207e$var$it,
        [$ef053115c0f9207e$var$T.DOCTYPE_TOKEN]: $ef053115c0f9207e$var$it,
        [$ef053115c0f9207e$var$T.START_TAG_TOKEN]: $ef053115c0f9207e$var$it,
        [$ef053115c0f9207e$var$T.END_TAG_TOKEN]: $ef053115c0f9207e$var$it,
        [$ef053115c0f9207e$var$T.EOF_TOKEN]: $ef053115c0f9207e$var$it
    },
    [$ef053115c0f9207e$var$an]: {
        [$ef053115c0f9207e$var$T.CHARACTER_TOKEN]: $ef053115c0f9207e$var$Ft,
        [$ef053115c0f9207e$var$T.NULL_CHARACTER_TOKEN]: $ef053115c0f9207e$var$Q,
        [$ef053115c0f9207e$var$T.WHITESPACE_CHARACTER_TOKEN]: $ef053115c0f9207e$var$N1,
        [$ef053115c0f9207e$var$T.COMMENT_TOKEN]: $ef053115c0f9207e$var$he,
        [$ef053115c0f9207e$var$T.DOCTYPE_TOKEN]: $ef053115c0f9207e$var$Q,
        [$ef053115c0f9207e$var$T.START_TAG_TOKEN]: $ef053115c0f9207e$var$E5,
        [$ef053115c0f9207e$var$T.END_TAG_TOKEN]: $ef053115c0f9207e$var$_5,
        [$ef053115c0f9207e$var$T.EOF_TOKEN]: $ef053115c0f9207e$var$s1
    },
    [$ef053115c0f9207e$var$_t]: {
        [$ef053115c0f9207e$var$T.CHARACTER_TOKEN]: $ef053115c0f9207e$var$qt,
        [$ef053115c0f9207e$var$T.NULL_CHARACTER_TOKEN]: $ef053115c0f9207e$var$qt,
        [$ef053115c0f9207e$var$T.WHITESPACE_CHARACTER_TOKEN]: $ef053115c0f9207e$var$Oe,
        [$ef053115c0f9207e$var$T.COMMENT_TOKEN]: $ef053115c0f9207e$var$he,
        [$ef053115c0f9207e$var$T.DOCTYPE_TOKEN]: $ef053115c0f9207e$var$Q,
        [$ef053115c0f9207e$var$T.START_TAG_TOKEN]: $ef053115c0f9207e$var$g5,
        [$ef053115c0f9207e$var$T.END_TAG_TOKEN]: $ef053115c0f9207e$var$A5,
        [$ef053115c0f9207e$var$T.EOF_TOKEN]: $ef053115c0f9207e$var$s1
    },
    [$ef053115c0f9207e$var$we]: {
        [$ef053115c0f9207e$var$T.CHARACTER_TOKEN]: $ef053115c0f9207e$var$o1,
        [$ef053115c0f9207e$var$T.NULL_CHARACTER_TOKEN]: $ef053115c0f9207e$var$o1,
        [$ef053115c0f9207e$var$T.WHITESPACE_CHARACTER_TOKEN]: $ef053115c0f9207e$var$o1,
        [$ef053115c0f9207e$var$T.COMMENT_TOKEN]: $ef053115c0f9207e$var$he,
        [$ef053115c0f9207e$var$T.DOCTYPE_TOKEN]: $ef053115c0f9207e$var$Q,
        [$ef053115c0f9207e$var$T.START_TAG_TOKEN]: $ef053115c0f9207e$var$C5,
        [$ef053115c0f9207e$var$T.END_TAG_TOKEN]: $ef053115c0f9207e$var$S5,
        [$ef053115c0f9207e$var$T.EOF_TOKEN]: $ef053115c0f9207e$var$s1
    },
    [$ef053115c0f9207e$var$l1]: {
        [$ef053115c0f9207e$var$T.CHARACTER_TOKEN]: $ef053115c0f9207e$var$o1,
        [$ef053115c0f9207e$var$T.NULL_CHARACTER_TOKEN]: $ef053115c0f9207e$var$o1,
        [$ef053115c0f9207e$var$T.WHITESPACE_CHARACTER_TOKEN]: $ef053115c0f9207e$var$o1,
        [$ef053115c0f9207e$var$T.COMMENT_TOKEN]: $ef053115c0f9207e$var$he,
        [$ef053115c0f9207e$var$T.DOCTYPE_TOKEN]: $ef053115c0f9207e$var$Q,
        [$ef053115c0f9207e$var$T.START_TAG_TOKEN]: $ef053115c0f9207e$var$N5,
        [$ef053115c0f9207e$var$T.END_TAG_TOKEN]: $ef053115c0f9207e$var$I5,
        [$ef053115c0f9207e$var$T.EOF_TOKEN]: $ef053115c0f9207e$var$s1
    },
    [$ef053115c0f9207e$var$ln]: {
        [$ef053115c0f9207e$var$T.CHARACTER_TOKEN]: $ef053115c0f9207e$var$Ft,
        [$ef053115c0f9207e$var$T.NULL_CHARACTER_TOKEN]: $ef053115c0f9207e$var$Q,
        [$ef053115c0f9207e$var$T.WHITESPACE_CHARACTER_TOKEN]: $ef053115c0f9207e$var$N1,
        [$ef053115c0f9207e$var$T.COMMENT_TOKEN]: $ef053115c0f9207e$var$he,
        [$ef053115c0f9207e$var$T.DOCTYPE_TOKEN]: $ef053115c0f9207e$var$Q,
        [$ef053115c0f9207e$var$T.START_TAG_TOKEN]: $ef053115c0f9207e$var$O5,
        [$ef053115c0f9207e$var$T.END_TAG_TOKEN]: $ef053115c0f9207e$var$R5,
        [$ef053115c0f9207e$var$T.EOF_TOKEN]: $ef053115c0f9207e$var$s1
    },
    [$ef053115c0f9207e$var$mr]: {
        [$ef053115c0f9207e$var$T.CHARACTER_TOKEN]: $ef053115c0f9207e$var$Oe,
        [$ef053115c0f9207e$var$T.NULL_CHARACTER_TOKEN]: $ef053115c0f9207e$var$Q,
        [$ef053115c0f9207e$var$T.WHITESPACE_CHARACTER_TOKEN]: $ef053115c0f9207e$var$Oe,
        [$ef053115c0f9207e$var$T.COMMENT_TOKEN]: $ef053115c0f9207e$var$he,
        [$ef053115c0f9207e$var$T.DOCTYPE_TOKEN]: $ef053115c0f9207e$var$Q,
        [$ef053115c0f9207e$var$T.START_TAG_TOKEN]: $ef053115c0f9207e$var$$o,
        [$ef053115c0f9207e$var$T.END_TAG_TOKEN]: $ef053115c0f9207e$var$Qo,
        [$ef053115c0f9207e$var$T.EOF_TOKEN]: $ef053115c0f9207e$var$s1
    },
    [$ef053115c0f9207e$var$pr]: {
        [$ef053115c0f9207e$var$T.CHARACTER_TOKEN]: $ef053115c0f9207e$var$Oe,
        [$ef053115c0f9207e$var$T.NULL_CHARACTER_TOKEN]: $ef053115c0f9207e$var$Q,
        [$ef053115c0f9207e$var$T.WHITESPACE_CHARACTER_TOKEN]: $ef053115c0f9207e$var$Oe,
        [$ef053115c0f9207e$var$T.COMMENT_TOKEN]: $ef053115c0f9207e$var$he,
        [$ef053115c0f9207e$var$T.DOCTYPE_TOKEN]: $ef053115c0f9207e$var$Q,
        [$ef053115c0f9207e$var$T.START_TAG_TOKEN]: $ef053115c0f9207e$var$x5,
        [$ef053115c0f9207e$var$T.END_TAG_TOKEN]: $ef053115c0f9207e$var$y5,
        [$ef053115c0f9207e$var$T.EOF_TOKEN]: $ef053115c0f9207e$var$s1
    },
    [$ef053115c0f9207e$var$Wt]: {
        [$ef053115c0f9207e$var$T.CHARACTER_TOKEN]: $ef053115c0f9207e$var$Ft,
        [$ef053115c0f9207e$var$T.NULL_CHARACTER_TOKEN]: $ef053115c0f9207e$var$Q,
        [$ef053115c0f9207e$var$T.WHITESPACE_CHARACTER_TOKEN]: $ef053115c0f9207e$var$N1,
        [$ef053115c0f9207e$var$T.COMMENT_TOKEN]: $ef053115c0f9207e$var$he,
        [$ef053115c0f9207e$var$T.DOCTYPE_TOKEN]: $ef053115c0f9207e$var$Q,
        [$ef053115c0f9207e$var$T.START_TAG_TOKEN]: $ef053115c0f9207e$var$k5,
        [$ef053115c0f9207e$var$T.END_TAG_TOKEN]: $ef053115c0f9207e$var$L5,
        [$ef053115c0f9207e$var$T.EOF_TOKEN]: $ef053115c0f9207e$var$Wo
    },
    [$ef053115c0f9207e$var$Er]: {
        [$ef053115c0f9207e$var$T.CHARACTER_TOKEN]: $ef053115c0f9207e$var$Vt,
        [$ef053115c0f9207e$var$T.NULL_CHARACTER_TOKEN]: $ef053115c0f9207e$var$Vt,
        [$ef053115c0f9207e$var$T.WHITESPACE_CHARACTER_TOKEN]: $ef053115c0f9207e$var$N1,
        [$ef053115c0f9207e$var$T.COMMENT_TOKEN]: $ef053115c0f9207e$var$gc,
        [$ef053115c0f9207e$var$T.DOCTYPE_TOKEN]: $ef053115c0f9207e$var$Q,
        [$ef053115c0f9207e$var$T.START_TAG_TOKEN]: $ef053115c0f9207e$var$M5,
        [$ef053115c0f9207e$var$T.END_TAG_TOKEN]: $ef053115c0f9207e$var$b5,
        [$ef053115c0f9207e$var$T.EOF_TOKEN]: $ef053115c0f9207e$var$nt
    },
    [$ef053115c0f9207e$var$un]: {
        [$ef053115c0f9207e$var$T.CHARACTER_TOKEN]: $ef053115c0f9207e$var$Q,
        [$ef053115c0f9207e$var$T.NULL_CHARACTER_TOKEN]: $ef053115c0f9207e$var$Q,
        [$ef053115c0f9207e$var$T.WHITESPACE_CHARACTER_TOKEN]: $ef053115c0f9207e$var$Oe,
        [$ef053115c0f9207e$var$T.COMMENT_TOKEN]: $ef053115c0f9207e$var$he,
        [$ef053115c0f9207e$var$T.DOCTYPE_TOKEN]: $ef053115c0f9207e$var$Q,
        [$ef053115c0f9207e$var$T.START_TAG_TOKEN]: $ef053115c0f9207e$var$P5,
        [$ef053115c0f9207e$var$T.END_TAG_TOKEN]: $ef053115c0f9207e$var$D5,
        [$ef053115c0f9207e$var$T.EOF_TOKEN]: $ef053115c0f9207e$var$nt
    },
    [$ef053115c0f9207e$var$zo]: {
        [$ef053115c0f9207e$var$T.CHARACTER_TOKEN]: $ef053115c0f9207e$var$Q,
        [$ef053115c0f9207e$var$T.NULL_CHARACTER_TOKEN]: $ef053115c0f9207e$var$Q,
        [$ef053115c0f9207e$var$T.WHITESPACE_CHARACTER_TOKEN]: $ef053115c0f9207e$var$Oe,
        [$ef053115c0f9207e$var$T.COMMENT_TOKEN]: $ef053115c0f9207e$var$he,
        [$ef053115c0f9207e$var$T.DOCTYPE_TOKEN]: $ef053115c0f9207e$var$Q,
        [$ef053115c0f9207e$var$T.START_TAG_TOKEN]: $ef053115c0f9207e$var$w5,
        [$ef053115c0f9207e$var$T.END_TAG_TOKEN]: $ef053115c0f9207e$var$F5,
        [$ef053115c0f9207e$var$T.EOF_TOKEN]: $ef053115c0f9207e$var$nt
    },
    [$ef053115c0f9207e$var$Yo]: {
        [$ef053115c0f9207e$var$T.CHARACTER_TOKEN]: $ef053115c0f9207e$var$Yt,
        [$ef053115c0f9207e$var$T.NULL_CHARACTER_TOKEN]: $ef053115c0f9207e$var$Yt,
        [$ef053115c0f9207e$var$T.WHITESPACE_CHARACTER_TOKEN]: $ef053115c0f9207e$var$N1,
        [$ef053115c0f9207e$var$T.COMMENT_TOKEN]: $ef053115c0f9207e$var$hs,
        [$ef053115c0f9207e$var$T.DOCTYPE_TOKEN]: $ef053115c0f9207e$var$Q,
        [$ef053115c0f9207e$var$T.START_TAG_TOKEN]: $ef053115c0f9207e$var$H5,
        [$ef053115c0f9207e$var$T.END_TAG_TOKEN]: $ef053115c0f9207e$var$Yt,
        [$ef053115c0f9207e$var$T.EOF_TOKEN]: $ef053115c0f9207e$var$nt
    },
    [$ef053115c0f9207e$var$jo]: {
        [$ef053115c0f9207e$var$T.CHARACTER_TOKEN]: $ef053115c0f9207e$var$Q,
        [$ef053115c0f9207e$var$T.NULL_CHARACTER_TOKEN]: $ef053115c0f9207e$var$Q,
        [$ef053115c0f9207e$var$T.WHITESPACE_CHARACTER_TOKEN]: $ef053115c0f9207e$var$N1,
        [$ef053115c0f9207e$var$T.COMMENT_TOKEN]: $ef053115c0f9207e$var$hs,
        [$ef053115c0f9207e$var$T.DOCTYPE_TOKEN]: $ef053115c0f9207e$var$Q,
        [$ef053115c0f9207e$var$T.START_TAG_TOKEN]: $ef053115c0f9207e$var$B5,
        [$ef053115c0f9207e$var$T.END_TAG_TOKEN]: $ef053115c0f9207e$var$Q,
        [$ef053115c0f9207e$var$T.EOF_TOKEN]: $ef053115c0f9207e$var$nt
    }
};
class $ef053115c0f9207e$var$hc {
    constructor(t){
        this.options = $ef053115c0f9207e$var$ic($ef053115c0f9207e$var$oc, t), this.treeAdapter = this.options.treeAdapter, this.pendingScript = null, this.options.sourceCodeLocationInfo && $ef053115c0f9207e$var$ls.install(this, $ef053115c0f9207e$var$tc), this.options.onParseError && $ef053115c0f9207e$var$ls.install(this, $ef053115c0f9207e$var$nc, {
            onParseError: this.options.onParseError
        });
    }
    // API
    parse(t) {
        const n = this.treeAdapter.createDocument();
        return this._bootstrap(n, null), this.tokenizer.write(t, !0), this._runParsingLoop(null), n;
    }
    parseFragment(t, n) {
        n || (n = this.treeAdapter.createElement($ef053115c0f9207e$var$a.TEMPLATE, $ef053115c0f9207e$var$L.HTML, []));
        const r = this.treeAdapter.createElement("documentmock", $ef053115c0f9207e$var$L.HTML, []);
        this._bootstrap(r, n), this.treeAdapter.getTagName(n) === $ef053115c0f9207e$var$a.TEMPLATE && this._pushTmplInsertionMode($ef053115c0f9207e$var$Wt), this._initTokenizerForFragmentParsing(), this._insertFakeRootElement(), this._resetInsertionMode(), this._findFormInFragmentContext(), this.tokenizer.write(t, !0), this._runParsingLoop(null);
        const i = this.treeAdapter.getFirstChild(r), s = this.treeAdapter.createDocumentFragment();
        return this._adoptNodes(i, s), s;
    }
    //Bootstrap parser
    _bootstrap(t, n) {
        this.tokenizer = new $ef053115c0f9207e$var$T(this.options), this.stopped = !1, this.insertionMode = $ef053115c0f9207e$var$vo, this.originalInsertionMode = "", this.document = t, this.fragmentContext = n, this.headElement = null, this.formElement = null, this.openElements = new $ef053115c0f9207e$var$ec(this.document, this.treeAdapter), this.activeFormattingElements = new $ef053115c0f9207e$var$as(this.treeAdapter), this.tmplInsertionModeStack = [], this.tmplInsertionModeStackTop = -1, this.currentTmplInsertionMode = null, this.pendingCharacterTokens = [], this.hasNonWhitespacePendingCharacterToken = !1, this.framesetOk = !0, this.skipNextNewLine = !1, this.fosterParentingEnabled = !1;
    }
    //Errors
    _err() {}
    //Parsing loop
    _runParsingLoop(t) {
        for(; !this.stopped;){
            this._setupTokenizerCDATAMode();
            const n = this.tokenizer.getNextToken();
            if (n.type === $ef053115c0f9207e$var$T.HIBERNATION_TOKEN) break;
            if (this.skipNextNewLine && (this.skipNextNewLine = !1, n.type === $ef053115c0f9207e$var$T.WHITESPACE_CHARACTER_TOKEN && n.chars[0] === `
`)) {
                if (n.chars.length === 1) continue;
                n.chars = n.chars.substr(1);
            }
            if (this._processInputToken(n), t && this.pendingScript) break;
        }
    }
    runParsingLoopForCurrentChunk(t, n) {
        if (this._runParsingLoop(n), n && this.pendingScript) {
            const r = this.pendingScript;
            this.pendingScript = null, n(r);
            return;
        }
        t && t();
    }
    //Text parsing
    _setupTokenizerCDATAMode() {
        const t = this._getAdjustedCurrentElement();
        this.tokenizer.allowCDATA = t && t !== this.document && this.treeAdapter.getNamespaceURI(t) !== $ef053115c0f9207e$var$L.HTML && !this._isIntegrationPoint(t);
    }
    _switchToTextParsing(t, n) {
        this._insertElement(t, $ef053115c0f9207e$var$L.HTML), this.tokenizer.state = n, this.originalInsertionMode = this.insertionMode, this.insertionMode = $ef053115c0f9207e$var$Qt;
    }
    switchToPlaintextParsing() {
        this.insertionMode = $ef053115c0f9207e$var$Qt, this.originalInsertionMode = $ef053115c0f9207e$var$Je, this.tokenizer.state = $ef053115c0f9207e$var$T.MODE.PLAINTEXT;
    }
    //Fragment parsing
    _getAdjustedCurrentElement() {
        return this.openElements.stackTop === 0 && this.fragmentContext ? this.fragmentContext : this.openElements.current;
    }
    _findFormInFragmentContext() {
        let t = this.fragmentContext;
        do {
            if (this.treeAdapter.getTagName(t) === $ef053115c0f9207e$var$a.FORM) {
                this.formElement = t;
                break;
            }
            t = this.treeAdapter.getParentNode(t);
        }while (t);
    }
    _initTokenizerForFragmentParsing() {
        if (this.treeAdapter.getNamespaceURI(this.fragmentContext) === $ef053115c0f9207e$var$L.HTML) {
            const t = this.treeAdapter.getTagName(this.fragmentContext);
            t === $ef053115c0f9207e$var$a.TITLE || t === $ef053115c0f9207e$var$a.TEXTAREA ? this.tokenizer.state = $ef053115c0f9207e$var$T.MODE.RCDATA : t === $ef053115c0f9207e$var$a.STYLE || t === $ef053115c0f9207e$var$a.XMP || t === $ef053115c0f9207e$var$a.IFRAME || t === $ef053115c0f9207e$var$a.NOEMBED || t === $ef053115c0f9207e$var$a.NOFRAMES || t === $ef053115c0f9207e$var$a.NOSCRIPT ? this.tokenizer.state = $ef053115c0f9207e$var$T.MODE.RAWTEXT : t === $ef053115c0f9207e$var$a.SCRIPT ? this.tokenizer.state = $ef053115c0f9207e$var$T.MODE.SCRIPT_DATA : t === $ef053115c0f9207e$var$a.PLAINTEXT && (this.tokenizer.state = $ef053115c0f9207e$var$T.MODE.PLAINTEXT);
        }
    }
    //Tree mutation
    _setDocumentType(t) {
        const n = t.name || "", r = t.publicId || "", i = t.systemId || "";
        this.treeAdapter.setDocumentType(this.document, n, r, i);
    }
    _attachElementToTree(t) {
        if (this._shouldFosterParentOnInsertion()) this._fosterParentElement(t);
        else {
            const n = this.openElements.currentTmplContent || this.openElements.current;
            this.treeAdapter.appendChild(n, t);
        }
    }
    _appendElement(t, n) {
        const r = this.treeAdapter.createElement(t.tagName, n, t.attrs);
        this._attachElementToTree(r);
    }
    _insertElement(t, n) {
        const r = this.treeAdapter.createElement(t.tagName, n, t.attrs);
        this._attachElementToTree(r), this.openElements.push(r);
    }
    _insertFakeElement(t) {
        const n = this.treeAdapter.createElement(t, $ef053115c0f9207e$var$L.HTML, []);
        this._attachElementToTree(n), this.openElements.push(n);
    }
    _insertTemplate(t) {
        const n = this.treeAdapter.createElement(t.tagName, $ef053115c0f9207e$var$L.HTML, t.attrs), r = this.treeAdapter.createDocumentFragment();
        this.treeAdapter.setTemplateContent(n, r), this._attachElementToTree(n), this.openElements.push(n);
    }
    _insertFakeRootElement() {
        const t = this.treeAdapter.createElement($ef053115c0f9207e$var$a.HTML, $ef053115c0f9207e$var$L.HTML, []);
        this.treeAdapter.appendChild(this.openElements.current, t), this.openElements.push(t);
    }
    _appendCommentNode(t, n) {
        const r = this.treeAdapter.createCommentNode(t.data);
        this.treeAdapter.appendChild(n, r);
    }
    _insertCharacters(t) {
        if (this._shouldFosterParentOnInsertion()) this._fosterParentText(t.chars);
        else {
            const n = this.openElements.currentTmplContent || this.openElements.current;
            this.treeAdapter.insertText(n, t.chars);
        }
    }
    _adoptNodes(t, n) {
        for(let r = this.treeAdapter.getFirstChild(t); r; r = this.treeAdapter.getFirstChild(t))this.treeAdapter.detachNode(r), this.treeAdapter.appendChild(n, r);
    }
    //Token processing
    _shouldProcessTokenInForeignContent(t) {
        const n = this._getAdjustedCurrentElement();
        if (!n || n === this.document) return !1;
        const r = this.treeAdapter.getNamespaceURI(n);
        if (r === $ef053115c0f9207e$var$L.HTML || this.treeAdapter.getTagName(n) === $ef053115c0f9207e$var$a.ANNOTATION_XML && r === $ef053115c0f9207e$var$L.MATHML && t.type === $ef053115c0f9207e$var$T.START_TAG_TOKEN && t.tagName === $ef053115c0f9207e$var$a.SVG) return !1;
        const i = t.type === $ef053115c0f9207e$var$T.CHARACTER_TOKEN || t.type === $ef053115c0f9207e$var$T.NULL_CHARACTER_TOKEN || t.type === $ef053115c0f9207e$var$T.WHITESPACE_CHARACTER_TOKEN;
        return (t.type === $ef053115c0f9207e$var$T.START_TAG_TOKEN && t.tagName !== $ef053115c0f9207e$var$a.MGLYPH && t.tagName !== $ef053115c0f9207e$var$a.MALIGNMARK || i) && this._isIntegrationPoint(n, $ef053115c0f9207e$var$L.MATHML) || (t.type === $ef053115c0f9207e$var$T.START_TAG_TOKEN || i) && this._isIntegrationPoint(n, $ef053115c0f9207e$var$L.HTML) ? !1 : t.type !== $ef053115c0f9207e$var$T.EOF_TOKEN;
    }
    _processToken(t) {
        $ef053115c0f9207e$var$cs[this.insertionMode][t.type](this, t);
    }
    _processTokenInBodyMode(t) {
        $ef053115c0f9207e$var$cs[$ef053115c0f9207e$var$Je][t.type](this, t);
    }
    _processTokenInForeignContent(t) {
        t.type === $ef053115c0f9207e$var$T.CHARACTER_TOKEN ? $ef053115c0f9207e$var$v5(this, t) : t.type === $ef053115c0f9207e$var$T.NULL_CHARACTER_TOKEN ? $ef053115c0f9207e$var$U5(this, t) : t.type === $ef053115c0f9207e$var$T.WHITESPACE_CHARACTER_TOKEN ? $ef053115c0f9207e$var$Oe(this, t) : t.type === $ef053115c0f9207e$var$T.COMMENT_TOKEN ? $ef053115c0f9207e$var$he(this, t) : t.type === $ef053115c0f9207e$var$T.START_TAG_TOKEN ? $ef053115c0f9207e$var$G5(this, t) : t.type === $ef053115c0f9207e$var$T.END_TAG_TOKEN && $ef053115c0f9207e$var$K5(this, t);
    }
    _processInputToken(t) {
        this._shouldProcessTokenInForeignContent(t) ? this._processTokenInForeignContent(t) : this._processToken(t), t.type === $ef053115c0f9207e$var$T.START_TAG_TOKEN && t.selfClosing && !t.ackSelfClosing && this._err($ef053115c0f9207e$var$_e.nonVoidHtmlElementStartTagWithTrailingSolidus);
    }
    //Integration points
    _isIntegrationPoint(t, n) {
        const r = this.treeAdapter.getTagName(t), i = this.treeAdapter.getNamespaceURI(t), s = this.treeAdapter.getAttrList(t);
        return $ef053115c0f9207e$var$Xe.isIntegrationPoint(r, i, s, n);
    }
    //Active formatting elements reconstruction
    _reconstructActiveFormattingElements() {
        const t = this.activeFormattingElements.length;
        if (t) {
            let n = t, r = null;
            do if (n--, r = this.activeFormattingElements.entries[n], r.type === $ef053115c0f9207e$var$as.MARKER_ENTRY || this.openElements.contains(r.element)) {
                n++;
                break;
            }
            while (n > 0);
            for(let i = n; i < t; i++)r = this.activeFormattingElements.entries[i], this._insertElement(r.token, this.treeAdapter.getNamespaceURI(r.element)), r.element = this.openElements.current;
        }
    }
    //Close elements
    _closeTableCell() {
        this.openElements.generateImpliedEndTags(), this.openElements.popUntilTableCellPopped(), this.activeFormattingElements.clearToLastMarker(), this.insertionMode = $ef053115c0f9207e$var$l1;
    }
    _closePElement() {
        this.openElements.generateImpliedEndTagsWithExclusion($ef053115c0f9207e$var$a.P), this.openElements.popUntilTagNamePopped($ef053115c0f9207e$var$a.P);
    }
    //Insertion modes
    _resetInsertionMode() {
        for(let t = this.openElements.stackTop, n = !1; t >= 0; t--){
            let r = this.openElements.items[t];
            t === 0 && (n = !0, this.fragmentContext && (r = this.fragmentContext));
            const i = this.treeAdapter.getTagName(r), s = $ef053115c0f9207e$var$uc[i];
            if (s) {
                this.insertionMode = s;
                break;
            } else if (!n && (i === $ef053115c0f9207e$var$a.TD || i === $ef053115c0f9207e$var$a.TH)) {
                this.insertionMode = $ef053115c0f9207e$var$ln;
                break;
            } else if (!n && i === $ef053115c0f9207e$var$a.HEAD) {
                this.insertionMode = $ef053115c0f9207e$var$$1;
                break;
            } else if (i === $ef053115c0f9207e$var$a.SELECT) {
                this._resetInsertionModeForSelect(t);
                break;
            } else if (i === $ef053115c0f9207e$var$a.TEMPLATE) {
                this.insertionMode = this.currentTmplInsertionMode;
                break;
            } else if (i === $ef053115c0f9207e$var$a.HTML) {
                this.insertionMode = this.headElement ? $ef053115c0f9207e$var$on : $ef053115c0f9207e$var$sn;
                break;
            } else if (n) {
                this.insertionMode = $ef053115c0f9207e$var$Je;
                break;
            }
        }
    }
    _resetInsertionModeForSelect(t) {
        if (t > 0) for(let n = t - 1; n > 0; n--){
            const r = this.openElements.items[n], i = this.treeAdapter.getTagName(r);
            if (i === $ef053115c0f9207e$var$a.TEMPLATE) break;
            if (i === $ef053115c0f9207e$var$a.TABLE) {
                this.insertionMode = $ef053115c0f9207e$var$pr;
                return;
            }
        }
        this.insertionMode = $ef053115c0f9207e$var$mr;
    }
    _pushTmplInsertionMode(t) {
        this.tmplInsertionModeStack.push(t), this.tmplInsertionModeStackTop++, this.currentTmplInsertionMode = t;
    }
    _popTmplInsertionMode() {
        this.tmplInsertionModeStack.pop(), this.tmplInsertionModeStackTop--, this.currentTmplInsertionMode = this.tmplInsertionModeStack[this.tmplInsertionModeStackTop];
    }
    //Foster parenting
    _isElementCausesFosterParenting(t) {
        const n = this.treeAdapter.getTagName(t);
        return n === $ef053115c0f9207e$var$a.TABLE || n === $ef053115c0f9207e$var$a.TBODY || n === $ef053115c0f9207e$var$a.TFOOT || n === $ef053115c0f9207e$var$a.THEAD || n === $ef053115c0f9207e$var$a.TR;
    }
    _shouldFosterParentOnInsertion() {
        return this.fosterParentingEnabled && this._isElementCausesFosterParenting(this.openElements.current);
    }
    _findFosterParentingLocation() {
        const t = {
            parent: null,
            beforeElement: null
        };
        for(let n = this.openElements.stackTop; n >= 0; n--){
            const r = this.openElements.items[n], i = this.treeAdapter.getTagName(r), s = this.treeAdapter.getNamespaceURI(r);
            if (i === $ef053115c0f9207e$var$a.TEMPLATE && s === $ef053115c0f9207e$var$L.HTML) {
                t.parent = this.treeAdapter.getTemplateContent(r);
                break;
            } else if (i === $ef053115c0f9207e$var$a.TABLE) {
                t.parent = this.treeAdapter.getParentNode(r), t.parent ? t.beforeElement = r : t.parent = this.openElements.items[n - 1];
                break;
            }
        }
        return t.parent || (t.parent = this.openElements.items[0]), t;
    }
    _fosterParentElement(t) {
        const n = this._findFosterParentingLocation();
        n.beforeElement ? this.treeAdapter.insertBefore(n.parent, t, n.beforeElement) : this.treeAdapter.appendChild(n.parent, t);
    }
    _fosterParentText(t) {
        const n = this._findFosterParentingLocation();
        n.beforeElement ? this.treeAdapter.insertTextBefore(n.parent, t, n.beforeElement) : this.treeAdapter.insertText(n.parent, t);
    }
    //Special elements
    _isSpecialElement(t) {
        const n = this.treeAdapter.getTagName(t), r = this.treeAdapter.getNamespaceURI(t);
        return $ef053115c0f9207e$var$x1.SPECIAL_ELEMENTS[r][n];
    }
}
var $ef053115c0f9207e$var$fc = $ef053115c0f9207e$var$hc;
function $ef053115c0f9207e$var$Tc(e, t) {
    let n = e.activeFormattingElements.getElementEntryInScopeWithTagName(t.tagName);
    return n ? e.openElements.contains(n.element) ? e.openElements.hasInScope(t.tagName) || (n = null) : (e.activeFormattingElements.removeEntry(n), n = null) : $ef053115c0f9207e$var$Ke(e, t), n;
}
function $ef053115c0f9207e$var$dc(e, t) {
    let n = null;
    for(let r = e.openElements.stackTop; r >= 0; r--){
        const i = e.openElements.items[r];
        if (i === t.element) break;
        e._isSpecialElement(i) && (n = i);
    }
    return n || (e.openElements.popUntilElementPopped(t.element), e.activeFormattingElements.removeEntry(t)), n;
}
function $ef053115c0f9207e$var$mc(e, t, n) {
    let r = t, i = e.openElements.getCommonAncestor(t);
    for(let s = 0, o = i; o !== n; s++, o = i){
        i = e.openElements.getCommonAncestor(o);
        const l = e.activeFormattingElements.getElementEntry(o), u = l && s >= $ef053115c0f9207e$var$lc;
        !l || u ? (u && e.activeFormattingElements.removeEntry(l), e.openElements.remove(o)) : (o = $ef053115c0f9207e$var$pc(e, l), r === t && (e.activeFormattingElements.bookmark = l), e.treeAdapter.detachNode(r), e.treeAdapter.appendChild(o, r), r = o);
    }
    return r;
}
function $ef053115c0f9207e$var$pc(e, t) {
    const n = e.treeAdapter.getNamespaceURI(t.element), r = e.treeAdapter.createElement(t.token.tagName, n, t.token.attrs);
    return e.openElements.replace(t.element, r), t.element = r, r;
}
function $ef053115c0f9207e$var$Ec(e, t, n) {
    if (e._isElementCausesFosterParenting(t)) e._fosterParentElement(n);
    else {
        const r = e.treeAdapter.getTagName(t), i = e.treeAdapter.getNamespaceURI(t);
        r === $ef053115c0f9207e$var$a.TEMPLATE && i === $ef053115c0f9207e$var$L.HTML && (t = e.treeAdapter.getTemplateContent(t)), e.treeAdapter.appendChild(t, n);
    }
}
function $ef053115c0f9207e$var$_c(e, t, n) {
    const r = e.treeAdapter.getNamespaceURI(n.element), i = n.token, s = e.treeAdapter.createElement(i.tagName, r, i.attrs);
    e._adoptNodes(t, s), e.treeAdapter.appendChild(t, s), e.activeFormattingElements.insertElementAfterBookmark(s, n.token), e.activeFormattingElements.removeEntry(n), e.openElements.remove(n.element), e.openElements.insertAfter(t, s);
}
function $ef053115c0f9207e$var$p1(e, t) {
    let n;
    for(let r = 0; r < $ef053115c0f9207e$var$ac && (n = $ef053115c0f9207e$var$Tc(e, t), !!n); r++){
        const i = $ef053115c0f9207e$var$dc(e, n);
        if (!i) break;
        e.activeFormattingElements.bookmark = n;
        const s = $ef053115c0f9207e$var$mc(e, i, n.element), o = e.openElements.getCommonAncestor(n.element);
        e.treeAdapter.detachNode(s), $ef053115c0f9207e$var$Ec(e, o, s), $ef053115c0f9207e$var$_c(e, i, n);
    }
}
function $ef053115c0f9207e$var$Q() {}
function $ef053115c0f9207e$var$wt(e) {
    e._err($ef053115c0f9207e$var$_e.misplacedDoctype);
}
function $ef053115c0f9207e$var$he(e, t) {
    e._appendCommentNode(t, e.openElements.currentTmplContent || e.openElements.current);
}
function $ef053115c0f9207e$var$gc(e, t) {
    e._appendCommentNode(t, e.openElements.items[0]);
}
function $ef053115c0f9207e$var$hs(e, t) {
    e._appendCommentNode(t, e.document);
}
function $ef053115c0f9207e$var$Oe(e, t) {
    e._insertCharacters(t);
}
function $ef053115c0f9207e$var$nt(e) {
    e.stopped = !0;
}
function $ef053115c0f9207e$var$Ac(e, t) {
    e._setDocumentType(t);
    const n = t.forceQuirks ? $ef053115c0f9207e$var$x1.DOCUMENT_MODE.QUIRKS : $ef053115c0f9207e$var$us.getDocumentMode(t);
    $ef053115c0f9207e$var$us.isConforming(t) || e._err($ef053115c0f9207e$var$_e.nonConformingDoctype), e.treeAdapter.setDocumentMode(e.document, n), e.insertionMode = $ef053115c0f9207e$var$dr;
}
function $ef053115c0f9207e$var$rt(e, t) {
    e._err($ef053115c0f9207e$var$_e.missingDoctype, {
        beforeToken: !0
    }), e.treeAdapter.setDocumentMode(e.document, $ef053115c0f9207e$var$x1.DOCUMENT_MODE.QUIRKS), e.insertionMode = $ef053115c0f9207e$var$dr, e._processToken(t);
}
function $ef053115c0f9207e$var$Cc(e, t) {
    t.tagName === $ef053115c0f9207e$var$a.HTML ? (e._insertElement(t, $ef053115c0f9207e$var$L.HTML), e.insertionMode = $ef053115c0f9207e$var$sn) : $ef053115c0f9207e$var$ct(e, t);
}
function $ef053115c0f9207e$var$Sc(e, t) {
    const n = t.tagName;
    (n === $ef053115c0f9207e$var$a.HTML || n === $ef053115c0f9207e$var$a.HEAD || n === $ef053115c0f9207e$var$a.BODY || n === $ef053115c0f9207e$var$a.BR) && $ef053115c0f9207e$var$ct(e, t);
}
function $ef053115c0f9207e$var$ct(e, t) {
    e._insertFakeRootElement(), e.insertionMode = $ef053115c0f9207e$var$sn, e._processToken(t);
}
function $ef053115c0f9207e$var$Nc(e, t) {
    const n = t.tagName;
    n === $ef053115c0f9207e$var$a.HTML ? $ef053115c0f9207e$var$xe(e, t) : n === $ef053115c0f9207e$var$a.HEAD ? (e._insertElement(t, $ef053115c0f9207e$var$L.HTML), e.headElement = e.openElements.current, e.insertionMode = $ef053115c0f9207e$var$$1) : $ef053115c0f9207e$var$ht(e, t);
}
function $ef053115c0f9207e$var$Ic(e, t) {
    const n = t.tagName;
    n === $ef053115c0f9207e$var$a.HEAD || n === $ef053115c0f9207e$var$a.BODY || n === $ef053115c0f9207e$var$a.HTML || n === $ef053115c0f9207e$var$a.BR ? $ef053115c0f9207e$var$ht(e, t) : e._err($ef053115c0f9207e$var$_e.endTagWithoutMatchingOpenElement);
}
function $ef053115c0f9207e$var$ht(e, t) {
    e._insertFakeElement($ef053115c0f9207e$var$a.HEAD), e.headElement = e.openElements.current, e.insertionMode = $ef053115c0f9207e$var$$1, e._processToken(t);
}
function $ef053115c0f9207e$var$de(e, t) {
    const n = t.tagName;
    n === $ef053115c0f9207e$var$a.HTML ? $ef053115c0f9207e$var$xe(e, t) : n === $ef053115c0f9207e$var$a.BASE || n === $ef053115c0f9207e$var$a.BASEFONT || n === $ef053115c0f9207e$var$a.BGSOUND || n === $ef053115c0f9207e$var$a.LINK || n === $ef053115c0f9207e$var$a.META ? (e._appendElement(t, $ef053115c0f9207e$var$L.HTML), t.ackSelfClosing = !0) : n === $ef053115c0f9207e$var$a.TITLE ? e._switchToTextParsing(t, $ef053115c0f9207e$var$T.MODE.RCDATA) : n === $ef053115c0f9207e$var$a.NOSCRIPT ? e.options.scriptingEnabled ? e._switchToTextParsing(t, $ef053115c0f9207e$var$T.MODE.RAWTEXT) : (e._insertElement(t, $ef053115c0f9207e$var$L.HTML), e.insertionMode = $ef053115c0f9207e$var$Go) : n === $ef053115c0f9207e$var$a.NOFRAMES || n === $ef053115c0f9207e$var$a.STYLE ? e._switchToTextParsing(t, $ef053115c0f9207e$var$T.MODE.RAWTEXT) : n === $ef053115c0f9207e$var$a.SCRIPT ? e._switchToTextParsing(t, $ef053115c0f9207e$var$T.MODE.SCRIPT_DATA) : n === $ef053115c0f9207e$var$a.TEMPLATE ? (e._insertTemplate(t, $ef053115c0f9207e$var$L.HTML), e.activeFormattingElements.insertMarker(), e.framesetOk = !1, e.insertionMode = $ef053115c0f9207e$var$Wt, e._pushTmplInsertionMode($ef053115c0f9207e$var$Wt)) : n === $ef053115c0f9207e$var$a.HEAD ? e._err($ef053115c0f9207e$var$_e.misplacedStartTagForHeadElement) : $ef053115c0f9207e$var$ft(e, t);
}
function $ef053115c0f9207e$var$y1(e, t) {
    const n = t.tagName;
    n === $ef053115c0f9207e$var$a.HEAD ? (e.openElements.pop(), e.insertionMode = $ef053115c0f9207e$var$on) : n === $ef053115c0f9207e$var$a.BODY || n === $ef053115c0f9207e$var$a.BR || n === $ef053115c0f9207e$var$a.HTML ? $ef053115c0f9207e$var$ft(e, t) : n === $ef053115c0f9207e$var$a.TEMPLATE && e.openElements.tmplCount > 0 ? (e.openElements.generateImpliedEndTagsThoroughly(), e.openElements.currentTagName !== $ef053115c0f9207e$var$a.TEMPLATE && e._err($ef053115c0f9207e$var$_e.closingOfElementWithOpenChildElements), e.openElements.popUntilTagNamePopped($ef053115c0f9207e$var$a.TEMPLATE), e.activeFormattingElements.clearToLastMarker(), e._popTmplInsertionMode(), e._resetInsertionMode()) : e._err($ef053115c0f9207e$var$_e.endTagWithoutMatchingOpenElement);
}
function $ef053115c0f9207e$var$ft(e, t) {
    e.openElements.pop(), e.insertionMode = $ef053115c0f9207e$var$on, e._processToken(t);
}
function $ef053115c0f9207e$var$Oc(e, t) {
    const n = t.tagName;
    n === $ef053115c0f9207e$var$a.HTML ? $ef053115c0f9207e$var$xe(e, t) : n === $ef053115c0f9207e$var$a.BASEFONT || n === $ef053115c0f9207e$var$a.BGSOUND || n === $ef053115c0f9207e$var$a.HEAD || n === $ef053115c0f9207e$var$a.LINK || n === $ef053115c0f9207e$var$a.META || n === $ef053115c0f9207e$var$a.NOFRAMES || n === $ef053115c0f9207e$var$a.STYLE ? $ef053115c0f9207e$var$de(e, t) : n === $ef053115c0f9207e$var$a.NOSCRIPT ? e._err($ef053115c0f9207e$var$_e.nestedNoscriptInHead) : $ef053115c0f9207e$var$Tt(e, t);
}
function $ef053115c0f9207e$var$Rc(e, t) {
    const n = t.tagName;
    n === $ef053115c0f9207e$var$a.NOSCRIPT ? (e.openElements.pop(), e.insertionMode = $ef053115c0f9207e$var$$1) : n === $ef053115c0f9207e$var$a.BR ? $ef053115c0f9207e$var$Tt(e, t) : e._err($ef053115c0f9207e$var$_e.endTagWithoutMatchingOpenElement);
}
function $ef053115c0f9207e$var$Tt(e, t) {
    const n = t.type === $ef053115c0f9207e$var$T.EOF_TOKEN ? $ef053115c0f9207e$var$_e.openElementsLeftAfterEof : $ef053115c0f9207e$var$_e.disallowedContentInNoscriptInHead;
    e._err(n), e.openElements.pop(), e.insertionMode = $ef053115c0f9207e$var$$1, e._processToken(t);
}
function $ef053115c0f9207e$var$xc(e, t) {
    const n = t.tagName;
    n === $ef053115c0f9207e$var$a.HTML ? $ef053115c0f9207e$var$xe(e, t) : n === $ef053115c0f9207e$var$a.BODY ? (e._insertElement(t, $ef053115c0f9207e$var$L.HTML), e.framesetOk = !1, e.insertionMode = $ef053115c0f9207e$var$Je) : n === $ef053115c0f9207e$var$a.FRAMESET ? (e._insertElement(t, $ef053115c0f9207e$var$L.HTML), e.insertionMode = $ef053115c0f9207e$var$un) : n === $ef053115c0f9207e$var$a.BASE || n === $ef053115c0f9207e$var$a.BASEFONT || n === $ef053115c0f9207e$var$a.BGSOUND || n === $ef053115c0f9207e$var$a.LINK || n === $ef053115c0f9207e$var$a.META || n === $ef053115c0f9207e$var$a.NOFRAMES || n === $ef053115c0f9207e$var$a.SCRIPT || n === $ef053115c0f9207e$var$a.STYLE || n === $ef053115c0f9207e$var$a.TEMPLATE || n === $ef053115c0f9207e$var$a.TITLE ? (e._err($ef053115c0f9207e$var$_e.abandonedHeadElementChild), e.openElements.push(e.headElement), $ef053115c0f9207e$var$de(e, t), e.openElements.remove(e.headElement)) : n === $ef053115c0f9207e$var$a.HEAD ? e._err($ef053115c0f9207e$var$_e.misplacedStartTagForHeadElement) : $ef053115c0f9207e$var$dt(e, t);
}
function $ef053115c0f9207e$var$yc(e, t) {
    const n = t.tagName;
    n === $ef053115c0f9207e$var$a.BODY || n === $ef053115c0f9207e$var$a.HTML || n === $ef053115c0f9207e$var$a.BR ? $ef053115c0f9207e$var$dt(e, t) : n === $ef053115c0f9207e$var$a.TEMPLATE ? $ef053115c0f9207e$var$y1(e, t) : e._err($ef053115c0f9207e$var$_e.endTagWithoutMatchingOpenElement);
}
function $ef053115c0f9207e$var$dt(e, t) {
    e._insertFakeElement($ef053115c0f9207e$var$a.BODY), e.insertionMode = $ef053115c0f9207e$var$Je, e._processToken(t);
}
function $ef053115c0f9207e$var$N1(e, t) {
    e._reconstructActiveFormattingElements(), e._insertCharacters(t);
}
function $ef053115c0f9207e$var$Ft(e, t) {
    e._reconstructActiveFormattingElements(), e._insertCharacters(t), e.framesetOk = !1;
}
function $ef053115c0f9207e$var$kc(e, t) {
    e.openElements.tmplCount === 0 && e.treeAdapter.adoptAttributes(e.openElements.items[0], t.attrs);
}
function $ef053115c0f9207e$var$Lc(e, t) {
    const n = e.openElements.tryPeekProperlyNestedBodyElement();
    n && e.openElements.tmplCount === 0 && (e.framesetOk = !1, e.treeAdapter.adoptAttributes(n, t.attrs));
}
function $ef053115c0f9207e$var$Mc(e, t) {
    const n = e.openElements.tryPeekProperlyNestedBodyElement();
    e.framesetOk && n && (e.treeAdapter.detachNode(n), e.openElements.popAllUpToHtmlElement(), e._insertElement(t, $ef053115c0f9207e$var$L.HTML), e.insertionMode = $ef053115c0f9207e$var$un);
}
function $ef053115c0f9207e$var$i1(e, t) {
    e.openElements.hasInButtonScope($ef053115c0f9207e$var$a.P) && e._closePElement(), e._insertElement(t, $ef053115c0f9207e$var$L.HTML);
}
function $ef053115c0f9207e$var$bc(e, t) {
    e.openElements.hasInButtonScope($ef053115c0f9207e$var$a.P) && e._closePElement();
    const n = e.openElements.currentTagName;
    (n === $ef053115c0f9207e$var$a.H1 || n === $ef053115c0f9207e$var$a.H2 || n === $ef053115c0f9207e$var$a.H3 || n === $ef053115c0f9207e$var$a.H4 || n === $ef053115c0f9207e$var$a.H5 || n === $ef053115c0f9207e$var$a.H6) && e.openElements.pop(), e._insertElement(t, $ef053115c0f9207e$var$L.HTML);
}
function $ef053115c0f9207e$var$fs(e, t) {
    e.openElements.hasInButtonScope($ef053115c0f9207e$var$a.P) && e._closePElement(), e._insertElement(t, $ef053115c0f9207e$var$L.HTML), e.skipNextNewLine = !0, e.framesetOk = !1;
}
function $ef053115c0f9207e$var$Pc(e, t) {
    const n = e.openElements.tmplCount > 0;
    (!e.formElement || n) && (e.openElements.hasInButtonScope($ef053115c0f9207e$var$a.P) && e._closePElement(), e._insertElement(t, $ef053115c0f9207e$var$L.HTML), n || (e.formElement = e.openElements.current));
}
function $ef053115c0f9207e$var$Dc(e, t) {
    e.framesetOk = !1;
    const n = t.tagName;
    for(let r = e.openElements.stackTop; r >= 0; r--){
        const i = e.openElements.items[r], s = e.treeAdapter.getTagName(i);
        let o = null;
        if (n === $ef053115c0f9207e$var$a.LI && s === $ef053115c0f9207e$var$a.LI ? o = $ef053115c0f9207e$var$a.LI : (n === $ef053115c0f9207e$var$a.DD || n === $ef053115c0f9207e$var$a.DT) && (s === $ef053115c0f9207e$var$a.DD || s === $ef053115c0f9207e$var$a.DT) && (o = s), o) {
            e.openElements.generateImpliedEndTagsWithExclusion(o), e.openElements.popUntilTagNamePopped(o);
            break;
        }
        if (s !== $ef053115c0f9207e$var$a.ADDRESS && s !== $ef053115c0f9207e$var$a.DIV && s !== $ef053115c0f9207e$var$a.P && e._isSpecialElement(i)) break;
    }
    e.openElements.hasInButtonScope($ef053115c0f9207e$var$a.P) && e._closePElement(), e._insertElement(t, $ef053115c0f9207e$var$L.HTML);
}
function $ef053115c0f9207e$var$wc(e, t) {
    e.openElements.hasInButtonScope($ef053115c0f9207e$var$a.P) && e._closePElement(), e._insertElement(t, $ef053115c0f9207e$var$L.HTML), e.tokenizer.state = $ef053115c0f9207e$var$T.MODE.PLAINTEXT;
}
function $ef053115c0f9207e$var$Fc(e, t) {
    e.openElements.hasInScope($ef053115c0f9207e$var$a.BUTTON) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped($ef053115c0f9207e$var$a.BUTTON)), e._reconstructActiveFormattingElements(), e._insertElement(t, $ef053115c0f9207e$var$L.HTML), e.framesetOk = !1;
}
function $ef053115c0f9207e$var$Hc(e, t) {
    const n = e.activeFormattingElements.getElementEntryInScopeWithTagName($ef053115c0f9207e$var$a.A);
    n && ($ef053115c0f9207e$var$p1(e, t), e.openElements.remove(n.element), e.activeFormattingElements.removeEntry(n)), e._reconstructActiveFormattingElements(), e._insertElement(t, $ef053115c0f9207e$var$L.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function $ef053115c0f9207e$var$H1(e, t) {
    e._reconstructActiveFormattingElements(), e._insertElement(t, $ef053115c0f9207e$var$L.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function $ef053115c0f9207e$var$Bc(e, t) {
    e._reconstructActiveFormattingElements(), e.openElements.hasInScope($ef053115c0f9207e$var$a.NOBR) && ($ef053115c0f9207e$var$p1(e, t), e._reconstructActiveFormattingElements()), e._insertElement(t, $ef053115c0f9207e$var$L.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function $ef053115c0f9207e$var$Ts(e, t) {
    e._reconstructActiveFormattingElements(), e._insertElement(t, $ef053115c0f9207e$var$L.HTML), e.activeFormattingElements.insertMarker(), e.framesetOk = !1;
}
function $ef053115c0f9207e$var$Uc(e, t) {
    e.treeAdapter.getDocumentMode(e.document) !== $ef053115c0f9207e$var$x1.DOCUMENT_MODE.QUIRKS && e.openElements.hasInButtonScope($ef053115c0f9207e$var$a.P) && e._closePElement(), e._insertElement(t, $ef053115c0f9207e$var$L.HTML), e.framesetOk = !1, e.insertionMode = $ef053115c0f9207e$var$Ce;
}
function $ef053115c0f9207e$var$G1(e, t) {
    e._reconstructActiveFormattingElements(), e._appendElement(t, $ef053115c0f9207e$var$L.HTML), e.framesetOk = !1, t.ackSelfClosing = !0;
}
function $ef053115c0f9207e$var$vc(e, t) {
    e._reconstructActiveFormattingElements(), e._appendElement(t, $ef053115c0f9207e$var$L.HTML);
    const n = $ef053115c0f9207e$var$T.getTokenAttr(t, $ef053115c0f9207e$var$Bo.TYPE);
    (!n || n.toLowerCase() !== $ef053115c0f9207e$var$Uo) && (e.framesetOk = !1), t.ackSelfClosing = !0;
}
function $ef053115c0f9207e$var$ds(e, t) {
    e._appendElement(t, $ef053115c0f9207e$var$L.HTML), t.ackSelfClosing = !0;
}
function $ef053115c0f9207e$var$Gc(e, t) {
    e.openElements.hasInButtonScope($ef053115c0f9207e$var$a.P) && e._closePElement(), e._appendElement(t, $ef053115c0f9207e$var$L.HTML), e.framesetOk = !1, t.ackSelfClosing = !0;
}
function $ef053115c0f9207e$var$Kc(e, t) {
    t.tagName = $ef053115c0f9207e$var$a.IMG, $ef053115c0f9207e$var$G1(e, t);
}
function $ef053115c0f9207e$var$zc(e, t) {
    e._insertElement(t, $ef053115c0f9207e$var$L.HTML), e.skipNextNewLine = !0, e.tokenizer.state = $ef053115c0f9207e$var$T.MODE.RCDATA, e.originalInsertionMode = e.insertionMode, e.framesetOk = !1, e.insertionMode = $ef053115c0f9207e$var$Qt;
}
function $ef053115c0f9207e$var$Yc(e, t) {
    e.openElements.hasInButtonScope($ef053115c0f9207e$var$a.P) && e._closePElement(), e._reconstructActiveFormattingElements(), e.framesetOk = !1, e._switchToTextParsing(t, $ef053115c0f9207e$var$T.MODE.RAWTEXT);
}
function $ef053115c0f9207e$var$jc(e, t) {
    e.framesetOk = !1, e._switchToTextParsing(t, $ef053115c0f9207e$var$T.MODE.RAWTEXT);
}
function $ef053115c0f9207e$var$ms(e, t) {
    e._switchToTextParsing(t, $ef053115c0f9207e$var$T.MODE.RAWTEXT);
}
function $ef053115c0f9207e$var$$c(e, t) {
    e._reconstructActiveFormattingElements(), e._insertElement(t, $ef053115c0f9207e$var$L.HTML), e.framesetOk = !1, e.insertionMode === $ef053115c0f9207e$var$Ce || e.insertionMode === $ef053115c0f9207e$var$an || e.insertionMode === $ef053115c0f9207e$var$we || e.insertionMode === $ef053115c0f9207e$var$l1 || e.insertionMode === $ef053115c0f9207e$var$ln ? e.insertionMode = $ef053115c0f9207e$var$pr : e.insertionMode = $ef053115c0f9207e$var$mr;
}
function $ef053115c0f9207e$var$ps(e, t) {
    e.openElements.currentTagName === $ef053115c0f9207e$var$a.OPTION && e.openElements.pop(), e._reconstructActiveFormattingElements(), e._insertElement(t, $ef053115c0f9207e$var$L.HTML);
}
function $ef053115c0f9207e$var$Es(e, t) {
    e.openElements.hasInScope($ef053115c0f9207e$var$a.RUBY) && e.openElements.generateImpliedEndTags(), e._insertElement(t, $ef053115c0f9207e$var$L.HTML);
}
function $ef053115c0f9207e$var$Qc(e, t) {
    e.openElements.hasInScope($ef053115c0f9207e$var$a.RUBY) && e.openElements.generateImpliedEndTagsWithExclusion($ef053115c0f9207e$var$a.RTC), e._insertElement(t, $ef053115c0f9207e$var$L.HTML);
}
function $ef053115c0f9207e$var$Wc(e, t) {
    e.openElements.hasInButtonScope($ef053115c0f9207e$var$a.P) && e._closePElement(), e._insertElement(t, $ef053115c0f9207e$var$L.HTML);
}
function $ef053115c0f9207e$var$qc(e, t) {
    e._reconstructActiveFormattingElements(), $ef053115c0f9207e$var$Xe.adjustTokenMathMLAttrs(t), $ef053115c0f9207e$var$Xe.adjustTokenXMLAttrs(t), t.selfClosing ? e._appendElement(t, $ef053115c0f9207e$var$L.MATHML) : e._insertElement(t, $ef053115c0f9207e$var$L.MATHML), t.ackSelfClosing = !0;
}
function $ef053115c0f9207e$var$Vc(e, t) {
    e._reconstructActiveFormattingElements(), $ef053115c0f9207e$var$Xe.adjustTokenSVGAttrs(t), $ef053115c0f9207e$var$Xe.adjustTokenXMLAttrs(t), t.selfClosing ? e._appendElement(t, $ef053115c0f9207e$var$L.SVG) : e._insertElement(t, $ef053115c0f9207e$var$L.SVG), t.ackSelfClosing = !0;
}
function $ef053115c0f9207e$var$Me(e, t) {
    e._reconstructActiveFormattingElements(), e._insertElement(t, $ef053115c0f9207e$var$L.HTML);
}
function $ef053115c0f9207e$var$xe(e, t) {
    const n = t.tagName;
    switch(n.length){
        case 1:
            n === $ef053115c0f9207e$var$a.I || n === $ef053115c0f9207e$var$a.S || n === $ef053115c0f9207e$var$a.B || n === $ef053115c0f9207e$var$a.U ? $ef053115c0f9207e$var$H1(e, t) : n === $ef053115c0f9207e$var$a.P ? $ef053115c0f9207e$var$i1(e, t) : n === $ef053115c0f9207e$var$a.A ? $ef053115c0f9207e$var$Hc(e, t) : $ef053115c0f9207e$var$Me(e, t);
            break;
        case 2:
            n === $ef053115c0f9207e$var$a.DL || n === $ef053115c0f9207e$var$a.OL || n === $ef053115c0f9207e$var$a.UL ? $ef053115c0f9207e$var$i1(e, t) : n === $ef053115c0f9207e$var$a.H1 || n === $ef053115c0f9207e$var$a.H2 || n === $ef053115c0f9207e$var$a.H3 || n === $ef053115c0f9207e$var$a.H4 || n === $ef053115c0f9207e$var$a.H5 || n === $ef053115c0f9207e$var$a.H6 ? $ef053115c0f9207e$var$bc(e, t) : n === $ef053115c0f9207e$var$a.LI || n === $ef053115c0f9207e$var$a.DD || n === $ef053115c0f9207e$var$a.DT ? $ef053115c0f9207e$var$Dc(e, t) : n === $ef053115c0f9207e$var$a.EM || n === $ef053115c0f9207e$var$a.TT ? $ef053115c0f9207e$var$H1(e, t) : n === $ef053115c0f9207e$var$a.BR ? $ef053115c0f9207e$var$G1(e, t) : n === $ef053115c0f9207e$var$a.HR ? $ef053115c0f9207e$var$Gc(e, t) : n === $ef053115c0f9207e$var$a.RB ? $ef053115c0f9207e$var$Es(e, t) : n === $ef053115c0f9207e$var$a.RT || n === $ef053115c0f9207e$var$a.RP ? $ef053115c0f9207e$var$Qc(e, t) : n !== $ef053115c0f9207e$var$a.TH && n !== $ef053115c0f9207e$var$a.TD && n !== $ef053115c0f9207e$var$a.TR && $ef053115c0f9207e$var$Me(e, t);
            break;
        case 3:
            n === $ef053115c0f9207e$var$a.DIV || n === $ef053115c0f9207e$var$a.DIR || n === $ef053115c0f9207e$var$a.NAV ? $ef053115c0f9207e$var$i1(e, t) : n === $ef053115c0f9207e$var$a.PRE ? $ef053115c0f9207e$var$fs(e, t) : n === $ef053115c0f9207e$var$a.BIG ? $ef053115c0f9207e$var$H1(e, t) : n === $ef053115c0f9207e$var$a.IMG || n === $ef053115c0f9207e$var$a.WBR ? $ef053115c0f9207e$var$G1(e, t) : n === $ef053115c0f9207e$var$a.XMP ? $ef053115c0f9207e$var$Yc(e, t) : n === $ef053115c0f9207e$var$a.SVG ? $ef053115c0f9207e$var$Vc(e, t) : n === $ef053115c0f9207e$var$a.RTC ? $ef053115c0f9207e$var$Es(e, t) : n !== $ef053115c0f9207e$var$a.COL && $ef053115c0f9207e$var$Me(e, t);
            break;
        case 4:
            n === $ef053115c0f9207e$var$a.HTML ? $ef053115c0f9207e$var$kc(e, t) : n === $ef053115c0f9207e$var$a.BASE || n === $ef053115c0f9207e$var$a.LINK || n === $ef053115c0f9207e$var$a.META ? $ef053115c0f9207e$var$de(e, t) : n === $ef053115c0f9207e$var$a.BODY ? $ef053115c0f9207e$var$Lc(e, t) : n === $ef053115c0f9207e$var$a.MAIN || n === $ef053115c0f9207e$var$a.MENU ? $ef053115c0f9207e$var$i1(e, t) : n === $ef053115c0f9207e$var$a.FORM ? $ef053115c0f9207e$var$Pc(e, t) : n === $ef053115c0f9207e$var$a.CODE || n === $ef053115c0f9207e$var$a.FONT ? $ef053115c0f9207e$var$H1(e, t) : n === $ef053115c0f9207e$var$a.NOBR ? $ef053115c0f9207e$var$Bc(e, t) : n === $ef053115c0f9207e$var$a.AREA ? $ef053115c0f9207e$var$G1(e, t) : n === $ef053115c0f9207e$var$a.MATH ? $ef053115c0f9207e$var$qc(e, t) : n === $ef053115c0f9207e$var$a.MENU ? $ef053115c0f9207e$var$Wc(e, t) : n !== $ef053115c0f9207e$var$a.HEAD && $ef053115c0f9207e$var$Me(e, t);
            break;
        case 5:
            n === $ef053115c0f9207e$var$a.STYLE || n === $ef053115c0f9207e$var$a.TITLE ? $ef053115c0f9207e$var$de(e, t) : n === $ef053115c0f9207e$var$a.ASIDE ? $ef053115c0f9207e$var$i1(e, t) : n === $ef053115c0f9207e$var$a.SMALL ? $ef053115c0f9207e$var$H1(e, t) : n === $ef053115c0f9207e$var$a.TABLE ? $ef053115c0f9207e$var$Uc(e, t) : n === $ef053115c0f9207e$var$a.EMBED ? $ef053115c0f9207e$var$G1(e, t) : n === $ef053115c0f9207e$var$a.INPUT ? $ef053115c0f9207e$var$vc(e, t) : n === $ef053115c0f9207e$var$a.PARAM || n === $ef053115c0f9207e$var$a.TRACK ? $ef053115c0f9207e$var$ds(e, t) : n === $ef053115c0f9207e$var$a.IMAGE ? $ef053115c0f9207e$var$Kc(e, t) : n !== $ef053115c0f9207e$var$a.FRAME && n !== $ef053115c0f9207e$var$a.TBODY && n !== $ef053115c0f9207e$var$a.TFOOT && n !== $ef053115c0f9207e$var$a.THEAD && $ef053115c0f9207e$var$Me(e, t);
            break;
        case 6:
            n === $ef053115c0f9207e$var$a.SCRIPT ? $ef053115c0f9207e$var$de(e, t) : n === $ef053115c0f9207e$var$a.CENTER || n === $ef053115c0f9207e$var$a.FIGURE || n === $ef053115c0f9207e$var$a.FOOTER || n === $ef053115c0f9207e$var$a.HEADER || n === $ef053115c0f9207e$var$a.HGROUP || n === $ef053115c0f9207e$var$a.DIALOG ? $ef053115c0f9207e$var$i1(e, t) : n === $ef053115c0f9207e$var$a.BUTTON ? $ef053115c0f9207e$var$Fc(e, t) : n === $ef053115c0f9207e$var$a.STRIKE || n === $ef053115c0f9207e$var$a.STRONG ? $ef053115c0f9207e$var$H1(e, t) : n === $ef053115c0f9207e$var$a.APPLET || n === $ef053115c0f9207e$var$a.OBJECT ? $ef053115c0f9207e$var$Ts(e, t) : n === $ef053115c0f9207e$var$a.KEYGEN ? $ef053115c0f9207e$var$G1(e, t) : n === $ef053115c0f9207e$var$a.SOURCE ? $ef053115c0f9207e$var$ds(e, t) : n === $ef053115c0f9207e$var$a.IFRAME ? $ef053115c0f9207e$var$jc(e, t) : n === $ef053115c0f9207e$var$a.SELECT ? $ef053115c0f9207e$var$$c(e, t) : n === $ef053115c0f9207e$var$a.OPTION ? $ef053115c0f9207e$var$ps(e, t) : $ef053115c0f9207e$var$Me(e, t);
            break;
        case 7:
            n === $ef053115c0f9207e$var$a.BGSOUND ? $ef053115c0f9207e$var$de(e, t) : n === $ef053115c0f9207e$var$a.DETAILS || n === $ef053115c0f9207e$var$a.ADDRESS || n === $ef053115c0f9207e$var$a.ARTICLE || n === $ef053115c0f9207e$var$a.SECTION || n === $ef053115c0f9207e$var$a.SUMMARY ? $ef053115c0f9207e$var$i1(e, t) : n === $ef053115c0f9207e$var$a.LISTING ? $ef053115c0f9207e$var$fs(e, t) : n === $ef053115c0f9207e$var$a.MARQUEE ? $ef053115c0f9207e$var$Ts(e, t) : n === $ef053115c0f9207e$var$a.NOEMBED ? $ef053115c0f9207e$var$ms(e, t) : n !== $ef053115c0f9207e$var$a.CAPTION && $ef053115c0f9207e$var$Me(e, t);
            break;
        case 8:
            n === $ef053115c0f9207e$var$a.BASEFONT ? $ef053115c0f9207e$var$de(e, t) : n === $ef053115c0f9207e$var$a.FRAMESET ? $ef053115c0f9207e$var$Mc(e, t) : n === $ef053115c0f9207e$var$a.FIELDSET ? $ef053115c0f9207e$var$i1(e, t) : n === $ef053115c0f9207e$var$a.TEXTAREA ? $ef053115c0f9207e$var$zc(e, t) : n === $ef053115c0f9207e$var$a.TEMPLATE ? $ef053115c0f9207e$var$de(e, t) : n === $ef053115c0f9207e$var$a.NOSCRIPT ? e.options.scriptingEnabled ? $ef053115c0f9207e$var$ms(e, t) : $ef053115c0f9207e$var$Me(e, t) : n === $ef053115c0f9207e$var$a.OPTGROUP ? $ef053115c0f9207e$var$ps(e, t) : n !== $ef053115c0f9207e$var$a.COLGROUP && $ef053115c0f9207e$var$Me(e, t);
            break;
        case 9:
            n === $ef053115c0f9207e$var$a.PLAINTEXT ? $ef053115c0f9207e$var$wc(e, t) : $ef053115c0f9207e$var$Me(e, t);
            break;
        case 10:
            n === $ef053115c0f9207e$var$a.BLOCKQUOTE || n === $ef053115c0f9207e$var$a.FIGCAPTION ? $ef053115c0f9207e$var$i1(e, t) : $ef053115c0f9207e$var$Me(e, t);
            break;
        default:
            $ef053115c0f9207e$var$Me(e, t);
    }
}
function $ef053115c0f9207e$var$Xc(e) {
    e.openElements.hasInScope($ef053115c0f9207e$var$a.BODY) && (e.insertionMode = $ef053115c0f9207e$var$Er);
}
function $ef053115c0f9207e$var$Jc(e, t) {
    e.openElements.hasInScope($ef053115c0f9207e$var$a.BODY) && (e.insertionMode = $ef053115c0f9207e$var$Er, e._processToken(t));
}
function $ef053115c0f9207e$var$T1(e, t) {
    const n = t.tagName;
    e.openElements.hasInScope(n) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(n));
}
function $ef053115c0f9207e$var$Zc(e) {
    const t = e.openElements.tmplCount > 0, n = e.formElement;
    t || (e.formElement = null), (n || t) && e.openElements.hasInScope($ef053115c0f9207e$var$a.FORM) && (e.openElements.generateImpliedEndTags(), t ? e.openElements.popUntilTagNamePopped($ef053115c0f9207e$var$a.FORM) : e.openElements.remove(n));
}
function $ef053115c0f9207e$var$e5(e) {
    e.openElements.hasInButtonScope($ef053115c0f9207e$var$a.P) || e._insertFakeElement($ef053115c0f9207e$var$a.P), e._closePElement();
}
function $ef053115c0f9207e$var$t5(e) {
    e.openElements.hasInListItemScope($ef053115c0f9207e$var$a.LI) && (e.openElements.generateImpliedEndTagsWithExclusion($ef053115c0f9207e$var$a.LI), e.openElements.popUntilTagNamePopped($ef053115c0f9207e$var$a.LI));
}
function $ef053115c0f9207e$var$n5(e, t) {
    const n = t.tagName;
    e.openElements.hasInScope(n) && (e.openElements.generateImpliedEndTagsWithExclusion(n), e.openElements.popUntilTagNamePopped(n));
}
function $ef053115c0f9207e$var$r5(e) {
    e.openElements.hasNumberedHeaderInScope() && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilNumberedHeaderPopped());
}
function $ef053115c0f9207e$var$_s(e, t) {
    const n = t.tagName;
    e.openElements.hasInScope(n) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(n), e.activeFormattingElements.clearToLastMarker());
}
function $ef053115c0f9207e$var$i5(e) {
    e._reconstructActiveFormattingElements(), e._insertFakeElement($ef053115c0f9207e$var$a.BR), e.openElements.pop(), e.framesetOk = !1;
}
function $ef053115c0f9207e$var$Ke(e, t) {
    const n = t.tagName;
    for(let r = e.openElements.stackTop; r > 0; r--){
        const i = e.openElements.items[r];
        if (e.treeAdapter.getTagName(i) === n) {
            e.openElements.generateImpliedEndTagsWithExclusion(n), e.openElements.popUntilElementPopped(i);
            break;
        }
        if (e._isSpecialElement(i)) break;
    }
}
function $ef053115c0f9207e$var$_r(e, t) {
    const n = t.tagName;
    switch(n.length){
        case 1:
            n === $ef053115c0f9207e$var$a.A || n === $ef053115c0f9207e$var$a.B || n === $ef053115c0f9207e$var$a.I || n === $ef053115c0f9207e$var$a.S || n === $ef053115c0f9207e$var$a.U ? $ef053115c0f9207e$var$p1(e, t) : n === $ef053115c0f9207e$var$a.P ? $ef053115c0f9207e$var$e5(e) : $ef053115c0f9207e$var$Ke(e, t);
            break;
        case 2:
            n === $ef053115c0f9207e$var$a.DL || n === $ef053115c0f9207e$var$a.UL || n === $ef053115c0f9207e$var$a.OL ? $ef053115c0f9207e$var$T1(e, t) : n === $ef053115c0f9207e$var$a.LI ? $ef053115c0f9207e$var$t5(e) : n === $ef053115c0f9207e$var$a.DD || n === $ef053115c0f9207e$var$a.DT ? $ef053115c0f9207e$var$n5(e, t) : n === $ef053115c0f9207e$var$a.H1 || n === $ef053115c0f9207e$var$a.H2 || n === $ef053115c0f9207e$var$a.H3 || n === $ef053115c0f9207e$var$a.H4 || n === $ef053115c0f9207e$var$a.H5 || n === $ef053115c0f9207e$var$a.H6 ? $ef053115c0f9207e$var$r5(e) : n === $ef053115c0f9207e$var$a.BR ? $ef053115c0f9207e$var$i5(e) : n === $ef053115c0f9207e$var$a.EM || n === $ef053115c0f9207e$var$a.TT ? $ef053115c0f9207e$var$p1(e, t) : $ef053115c0f9207e$var$Ke(e, t);
            break;
        case 3:
            n === $ef053115c0f9207e$var$a.BIG ? $ef053115c0f9207e$var$p1(e, t) : n === $ef053115c0f9207e$var$a.DIR || n === $ef053115c0f9207e$var$a.DIV || n === $ef053115c0f9207e$var$a.NAV || n === $ef053115c0f9207e$var$a.PRE ? $ef053115c0f9207e$var$T1(e, t) : $ef053115c0f9207e$var$Ke(e, t);
            break;
        case 4:
            n === $ef053115c0f9207e$var$a.BODY ? $ef053115c0f9207e$var$Xc(e) : n === $ef053115c0f9207e$var$a.HTML ? $ef053115c0f9207e$var$Jc(e, t) : n === $ef053115c0f9207e$var$a.FORM ? $ef053115c0f9207e$var$Zc(e) : n === $ef053115c0f9207e$var$a.CODE || n === $ef053115c0f9207e$var$a.FONT || n === $ef053115c0f9207e$var$a.NOBR ? $ef053115c0f9207e$var$p1(e, t) : n === $ef053115c0f9207e$var$a.MAIN || n === $ef053115c0f9207e$var$a.MENU ? $ef053115c0f9207e$var$T1(e, t) : $ef053115c0f9207e$var$Ke(e, t);
            break;
        case 5:
            n === $ef053115c0f9207e$var$a.ASIDE ? $ef053115c0f9207e$var$T1(e, t) : n === $ef053115c0f9207e$var$a.SMALL ? $ef053115c0f9207e$var$p1(e, t) : $ef053115c0f9207e$var$Ke(e, t);
            break;
        case 6:
            n === $ef053115c0f9207e$var$a.CENTER || n === $ef053115c0f9207e$var$a.FIGURE || n === $ef053115c0f9207e$var$a.FOOTER || n === $ef053115c0f9207e$var$a.HEADER || n === $ef053115c0f9207e$var$a.HGROUP || n === $ef053115c0f9207e$var$a.DIALOG ? $ef053115c0f9207e$var$T1(e, t) : n === $ef053115c0f9207e$var$a.APPLET || n === $ef053115c0f9207e$var$a.OBJECT ? $ef053115c0f9207e$var$_s(e, t) : n === $ef053115c0f9207e$var$a.STRIKE || n === $ef053115c0f9207e$var$a.STRONG ? $ef053115c0f9207e$var$p1(e, t) : $ef053115c0f9207e$var$Ke(e, t);
            break;
        case 7:
            n === $ef053115c0f9207e$var$a.ADDRESS || n === $ef053115c0f9207e$var$a.ARTICLE || n === $ef053115c0f9207e$var$a.DETAILS || n === $ef053115c0f9207e$var$a.SECTION || n === $ef053115c0f9207e$var$a.SUMMARY || n === $ef053115c0f9207e$var$a.LISTING ? $ef053115c0f9207e$var$T1(e, t) : n === $ef053115c0f9207e$var$a.MARQUEE ? $ef053115c0f9207e$var$_s(e, t) : $ef053115c0f9207e$var$Ke(e, t);
            break;
        case 8:
            n === $ef053115c0f9207e$var$a.FIELDSET ? $ef053115c0f9207e$var$T1(e, t) : n === $ef053115c0f9207e$var$a.TEMPLATE ? $ef053115c0f9207e$var$y1(e, t) : $ef053115c0f9207e$var$Ke(e, t);
            break;
        case 10:
            n === $ef053115c0f9207e$var$a.BLOCKQUOTE || n === $ef053115c0f9207e$var$a.FIGCAPTION ? $ef053115c0f9207e$var$T1(e, t) : $ef053115c0f9207e$var$Ke(e, t);
            break;
        default:
            $ef053115c0f9207e$var$Ke(e, t);
    }
}
function $ef053115c0f9207e$var$s1(e, t) {
    e.tmplInsertionModeStackTop > -1 ? $ef053115c0f9207e$var$Wo(e, t) : e.stopped = !0;
}
function $ef053115c0f9207e$var$s5(e, t) {
    t.tagName === $ef053115c0f9207e$var$a.SCRIPT && (e.pendingScript = e.openElements.current), e.openElements.pop(), e.insertionMode = e.originalInsertionMode;
}
function $ef053115c0f9207e$var$o5(e, t) {
    e._err($ef053115c0f9207e$var$_e.eofInElementThatCanContainOnlyText), e.openElements.pop(), e.insertionMode = e.originalInsertionMode, e._processToken(t);
}
function $ef053115c0f9207e$var$o1(e, t) {
    const n = e.openElements.currentTagName;
    n === $ef053115c0f9207e$var$a.TABLE || n === $ef053115c0f9207e$var$a.TBODY || n === $ef053115c0f9207e$var$a.TFOOT || n === $ef053115c0f9207e$var$a.THEAD || n === $ef053115c0f9207e$var$a.TR ? (e.pendingCharacterTokens = [], e.hasNonWhitespacePendingCharacterToken = !1, e.originalInsertionMode = e.insertionMode, e.insertionMode = $ef053115c0f9207e$var$Ko, e._processToken(t)) : $ef053115c0f9207e$var$be(e, t);
}
function $ef053115c0f9207e$var$a5(e, t) {
    e.openElements.clearBackToTableContext(), e.activeFormattingElements.insertMarker(), e._insertElement(t, $ef053115c0f9207e$var$L.HTML), e.insertionMode = $ef053115c0f9207e$var$an;
}
function $ef053115c0f9207e$var$l5(e, t) {
    e.openElements.clearBackToTableContext(), e._insertElement(t, $ef053115c0f9207e$var$L.HTML), e.insertionMode = $ef053115c0f9207e$var$_t;
}
function $ef053115c0f9207e$var$u5(e, t) {
    e.openElements.clearBackToTableContext(), e._insertFakeElement($ef053115c0f9207e$var$a.COLGROUP), e.insertionMode = $ef053115c0f9207e$var$_t, e._processToken(t);
}
function $ef053115c0f9207e$var$c5(e, t) {
    e.openElements.clearBackToTableContext(), e._insertElement(t, $ef053115c0f9207e$var$L.HTML), e.insertionMode = $ef053115c0f9207e$var$we;
}
function $ef053115c0f9207e$var$h5(e, t) {
    e.openElements.clearBackToTableContext(), e._insertFakeElement($ef053115c0f9207e$var$a.TBODY), e.insertionMode = $ef053115c0f9207e$var$we, e._processToken(t);
}
function $ef053115c0f9207e$var$f5(e, t) {
    e.openElements.hasInTableScope($ef053115c0f9207e$var$a.TABLE) && (e.openElements.popUntilTagNamePopped($ef053115c0f9207e$var$a.TABLE), e._resetInsertionMode(), e._processToken(t));
}
function $ef053115c0f9207e$var$T5(e, t) {
    const n = $ef053115c0f9207e$var$T.getTokenAttr(t, $ef053115c0f9207e$var$Bo.TYPE);
    n && n.toLowerCase() === $ef053115c0f9207e$var$Uo ? e._appendElement(t, $ef053115c0f9207e$var$L.HTML) : $ef053115c0f9207e$var$be(e, t), t.ackSelfClosing = !0;
}
function $ef053115c0f9207e$var$d5(e, t) {
    !e.formElement && e.openElements.tmplCount === 0 && (e._insertElement(t, $ef053115c0f9207e$var$L.HTML), e.formElement = e.openElements.current, e.openElements.pop());
}
function $ef053115c0f9207e$var$gr(e, t) {
    const n = t.tagName;
    switch(n.length){
        case 2:
            n === $ef053115c0f9207e$var$a.TD || n === $ef053115c0f9207e$var$a.TH || n === $ef053115c0f9207e$var$a.TR ? $ef053115c0f9207e$var$h5(e, t) : $ef053115c0f9207e$var$be(e, t);
            break;
        case 3:
            n === $ef053115c0f9207e$var$a.COL ? $ef053115c0f9207e$var$u5(e, t) : $ef053115c0f9207e$var$be(e, t);
            break;
        case 4:
            n === $ef053115c0f9207e$var$a.FORM ? $ef053115c0f9207e$var$d5(e, t) : $ef053115c0f9207e$var$be(e, t);
            break;
        case 5:
            n === $ef053115c0f9207e$var$a.TABLE ? $ef053115c0f9207e$var$f5(e, t) : n === $ef053115c0f9207e$var$a.STYLE ? $ef053115c0f9207e$var$de(e, t) : n === $ef053115c0f9207e$var$a.TBODY || n === $ef053115c0f9207e$var$a.TFOOT || n === $ef053115c0f9207e$var$a.THEAD ? $ef053115c0f9207e$var$c5(e, t) : n === $ef053115c0f9207e$var$a.INPUT ? $ef053115c0f9207e$var$T5(e, t) : $ef053115c0f9207e$var$be(e, t);
            break;
        case 6:
            n === $ef053115c0f9207e$var$a.SCRIPT ? $ef053115c0f9207e$var$de(e, t) : $ef053115c0f9207e$var$be(e, t);
            break;
        case 7:
            n === $ef053115c0f9207e$var$a.CAPTION ? $ef053115c0f9207e$var$a5(e, t) : $ef053115c0f9207e$var$be(e, t);
            break;
        case 8:
            n === $ef053115c0f9207e$var$a.COLGROUP ? $ef053115c0f9207e$var$l5(e, t) : n === $ef053115c0f9207e$var$a.TEMPLATE ? $ef053115c0f9207e$var$de(e, t) : $ef053115c0f9207e$var$be(e, t);
            break;
        default:
            $ef053115c0f9207e$var$be(e, t);
    }
}
function $ef053115c0f9207e$var$Ar(e, t) {
    const n = t.tagName;
    n === $ef053115c0f9207e$var$a.TABLE ? e.openElements.hasInTableScope($ef053115c0f9207e$var$a.TABLE) && (e.openElements.popUntilTagNamePopped($ef053115c0f9207e$var$a.TABLE), e._resetInsertionMode()) : n === $ef053115c0f9207e$var$a.TEMPLATE ? $ef053115c0f9207e$var$y1(e, t) : n !== $ef053115c0f9207e$var$a.BODY && n !== $ef053115c0f9207e$var$a.CAPTION && n !== $ef053115c0f9207e$var$a.COL && n !== $ef053115c0f9207e$var$a.COLGROUP && n !== $ef053115c0f9207e$var$a.HTML && n !== $ef053115c0f9207e$var$a.TBODY && n !== $ef053115c0f9207e$var$a.TD && n !== $ef053115c0f9207e$var$a.TFOOT && n !== $ef053115c0f9207e$var$a.TH && n !== $ef053115c0f9207e$var$a.THEAD && n !== $ef053115c0f9207e$var$a.TR && $ef053115c0f9207e$var$be(e, t);
}
function $ef053115c0f9207e$var$be(e, t) {
    const n = e.fosterParentingEnabled;
    e.fosterParentingEnabled = !0, e._processTokenInBodyMode(t), e.fosterParentingEnabled = n;
}
function $ef053115c0f9207e$var$m5(e, t) {
    e.pendingCharacterTokens.push(t);
}
function $ef053115c0f9207e$var$p5(e, t) {
    e.pendingCharacterTokens.push(t), e.hasNonWhitespacePendingCharacterToken = !0;
}
function $ef053115c0f9207e$var$it(e, t) {
    let n = 0;
    if (e.hasNonWhitespacePendingCharacterToken) for(; n < e.pendingCharacterTokens.length; n++)$ef053115c0f9207e$var$be(e, e.pendingCharacterTokens[n]);
    else for(; n < e.pendingCharacterTokens.length; n++)e._insertCharacters(e.pendingCharacterTokens[n]);
    e.insertionMode = e.originalInsertionMode, e._processToken(t);
}
function $ef053115c0f9207e$var$E5(e, t) {
    const n = t.tagName;
    n === $ef053115c0f9207e$var$a.CAPTION || n === $ef053115c0f9207e$var$a.COL || n === $ef053115c0f9207e$var$a.COLGROUP || n === $ef053115c0f9207e$var$a.TBODY || n === $ef053115c0f9207e$var$a.TD || n === $ef053115c0f9207e$var$a.TFOOT || n === $ef053115c0f9207e$var$a.TH || n === $ef053115c0f9207e$var$a.THEAD || n === $ef053115c0f9207e$var$a.TR ? e.openElements.hasInTableScope($ef053115c0f9207e$var$a.CAPTION) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped($ef053115c0f9207e$var$a.CAPTION), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = $ef053115c0f9207e$var$Ce, e._processToken(t)) : $ef053115c0f9207e$var$xe(e, t);
}
function $ef053115c0f9207e$var$_5(e, t) {
    const n = t.tagName;
    n === $ef053115c0f9207e$var$a.CAPTION || n === $ef053115c0f9207e$var$a.TABLE ? e.openElements.hasInTableScope($ef053115c0f9207e$var$a.CAPTION) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped($ef053115c0f9207e$var$a.CAPTION), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = $ef053115c0f9207e$var$Ce, n === $ef053115c0f9207e$var$a.TABLE && e._processToken(t)) : n !== $ef053115c0f9207e$var$a.BODY && n !== $ef053115c0f9207e$var$a.COL && n !== $ef053115c0f9207e$var$a.COLGROUP && n !== $ef053115c0f9207e$var$a.HTML && n !== $ef053115c0f9207e$var$a.TBODY && n !== $ef053115c0f9207e$var$a.TD && n !== $ef053115c0f9207e$var$a.TFOOT && n !== $ef053115c0f9207e$var$a.TH && n !== $ef053115c0f9207e$var$a.THEAD && n !== $ef053115c0f9207e$var$a.TR && $ef053115c0f9207e$var$_r(e, t);
}
function $ef053115c0f9207e$var$g5(e, t) {
    const n = t.tagName;
    n === $ef053115c0f9207e$var$a.HTML ? $ef053115c0f9207e$var$xe(e, t) : n === $ef053115c0f9207e$var$a.COL ? (e._appendElement(t, $ef053115c0f9207e$var$L.HTML), t.ackSelfClosing = !0) : n === $ef053115c0f9207e$var$a.TEMPLATE ? $ef053115c0f9207e$var$de(e, t) : $ef053115c0f9207e$var$qt(e, t);
}
function $ef053115c0f9207e$var$A5(e, t) {
    const n = t.tagName;
    n === $ef053115c0f9207e$var$a.COLGROUP ? e.openElements.currentTagName === $ef053115c0f9207e$var$a.COLGROUP && (e.openElements.pop(), e.insertionMode = $ef053115c0f9207e$var$Ce) : n === $ef053115c0f9207e$var$a.TEMPLATE ? $ef053115c0f9207e$var$y1(e, t) : n !== $ef053115c0f9207e$var$a.COL && $ef053115c0f9207e$var$qt(e, t);
}
function $ef053115c0f9207e$var$qt(e, t) {
    e.openElements.currentTagName === $ef053115c0f9207e$var$a.COLGROUP && (e.openElements.pop(), e.insertionMode = $ef053115c0f9207e$var$Ce, e._processToken(t));
}
function $ef053115c0f9207e$var$C5(e, t) {
    const n = t.tagName;
    n === $ef053115c0f9207e$var$a.TR ? (e.openElements.clearBackToTableBodyContext(), e._insertElement(t, $ef053115c0f9207e$var$L.HTML), e.insertionMode = $ef053115c0f9207e$var$l1) : n === $ef053115c0f9207e$var$a.TH || n === $ef053115c0f9207e$var$a.TD ? (e.openElements.clearBackToTableBodyContext(), e._insertFakeElement($ef053115c0f9207e$var$a.TR), e.insertionMode = $ef053115c0f9207e$var$l1, e._processToken(t)) : n === $ef053115c0f9207e$var$a.CAPTION || n === $ef053115c0f9207e$var$a.COL || n === $ef053115c0f9207e$var$a.COLGROUP || n === $ef053115c0f9207e$var$a.TBODY || n === $ef053115c0f9207e$var$a.TFOOT || n === $ef053115c0f9207e$var$a.THEAD ? e.openElements.hasTableBodyContextInTableScope() && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = $ef053115c0f9207e$var$Ce, e._processToken(t)) : $ef053115c0f9207e$var$gr(e, t);
}
function $ef053115c0f9207e$var$S5(e, t) {
    const n = t.tagName;
    n === $ef053115c0f9207e$var$a.TBODY || n === $ef053115c0f9207e$var$a.TFOOT || n === $ef053115c0f9207e$var$a.THEAD ? e.openElements.hasInTableScope(n) && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = $ef053115c0f9207e$var$Ce) : n === $ef053115c0f9207e$var$a.TABLE ? e.openElements.hasTableBodyContextInTableScope() && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = $ef053115c0f9207e$var$Ce, e._processToken(t)) : (n !== $ef053115c0f9207e$var$a.BODY && n !== $ef053115c0f9207e$var$a.CAPTION && n !== $ef053115c0f9207e$var$a.COL && n !== $ef053115c0f9207e$var$a.COLGROUP || n !== $ef053115c0f9207e$var$a.HTML && n !== $ef053115c0f9207e$var$a.TD && n !== $ef053115c0f9207e$var$a.TH && n !== $ef053115c0f9207e$var$a.TR) && $ef053115c0f9207e$var$Ar(e, t);
}
function $ef053115c0f9207e$var$N5(e, t) {
    const n = t.tagName;
    n === $ef053115c0f9207e$var$a.TH || n === $ef053115c0f9207e$var$a.TD ? (e.openElements.clearBackToTableRowContext(), e._insertElement(t, $ef053115c0f9207e$var$L.HTML), e.insertionMode = $ef053115c0f9207e$var$ln, e.activeFormattingElements.insertMarker()) : n === $ef053115c0f9207e$var$a.CAPTION || n === $ef053115c0f9207e$var$a.COL || n === $ef053115c0f9207e$var$a.COLGROUP || n === $ef053115c0f9207e$var$a.TBODY || n === $ef053115c0f9207e$var$a.TFOOT || n === $ef053115c0f9207e$var$a.THEAD || n === $ef053115c0f9207e$var$a.TR ? e.openElements.hasInTableScope($ef053115c0f9207e$var$a.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = $ef053115c0f9207e$var$we, e._processToken(t)) : $ef053115c0f9207e$var$gr(e, t);
}
function $ef053115c0f9207e$var$I5(e, t) {
    const n = t.tagName;
    n === $ef053115c0f9207e$var$a.TR ? e.openElements.hasInTableScope($ef053115c0f9207e$var$a.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = $ef053115c0f9207e$var$we) : n === $ef053115c0f9207e$var$a.TABLE ? e.openElements.hasInTableScope($ef053115c0f9207e$var$a.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = $ef053115c0f9207e$var$we, e._processToken(t)) : n === $ef053115c0f9207e$var$a.TBODY || n === $ef053115c0f9207e$var$a.TFOOT || n === $ef053115c0f9207e$var$a.THEAD ? (e.openElements.hasInTableScope(n) || e.openElements.hasInTableScope($ef053115c0f9207e$var$a.TR)) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = $ef053115c0f9207e$var$we, e._processToken(t)) : (n !== $ef053115c0f9207e$var$a.BODY && n !== $ef053115c0f9207e$var$a.CAPTION && n !== $ef053115c0f9207e$var$a.COL && n !== $ef053115c0f9207e$var$a.COLGROUP || n !== $ef053115c0f9207e$var$a.HTML && n !== $ef053115c0f9207e$var$a.TD && n !== $ef053115c0f9207e$var$a.TH) && $ef053115c0f9207e$var$Ar(e, t);
}
function $ef053115c0f9207e$var$O5(e, t) {
    const n = t.tagName;
    n === $ef053115c0f9207e$var$a.CAPTION || n === $ef053115c0f9207e$var$a.COL || n === $ef053115c0f9207e$var$a.COLGROUP || n === $ef053115c0f9207e$var$a.TBODY || n === $ef053115c0f9207e$var$a.TD || n === $ef053115c0f9207e$var$a.TFOOT || n === $ef053115c0f9207e$var$a.TH || n === $ef053115c0f9207e$var$a.THEAD || n === $ef053115c0f9207e$var$a.TR ? (e.openElements.hasInTableScope($ef053115c0f9207e$var$a.TD) || e.openElements.hasInTableScope($ef053115c0f9207e$var$a.TH)) && (e._closeTableCell(), e._processToken(t)) : $ef053115c0f9207e$var$xe(e, t);
}
function $ef053115c0f9207e$var$R5(e, t) {
    const n = t.tagName;
    n === $ef053115c0f9207e$var$a.TD || n === $ef053115c0f9207e$var$a.TH ? e.openElements.hasInTableScope(n) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(n), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = $ef053115c0f9207e$var$l1) : n === $ef053115c0f9207e$var$a.TABLE || n === $ef053115c0f9207e$var$a.TBODY || n === $ef053115c0f9207e$var$a.TFOOT || n === $ef053115c0f9207e$var$a.THEAD || n === $ef053115c0f9207e$var$a.TR ? e.openElements.hasInTableScope(n) && (e._closeTableCell(), e._processToken(t)) : n !== $ef053115c0f9207e$var$a.BODY && n !== $ef053115c0f9207e$var$a.CAPTION && n !== $ef053115c0f9207e$var$a.COL && n !== $ef053115c0f9207e$var$a.COLGROUP && n !== $ef053115c0f9207e$var$a.HTML && $ef053115c0f9207e$var$_r(e, t);
}
function $ef053115c0f9207e$var$$o(e, t) {
    const n = t.tagName;
    n === $ef053115c0f9207e$var$a.HTML ? $ef053115c0f9207e$var$xe(e, t) : n === $ef053115c0f9207e$var$a.OPTION ? (e.openElements.currentTagName === $ef053115c0f9207e$var$a.OPTION && e.openElements.pop(), e._insertElement(t, $ef053115c0f9207e$var$L.HTML)) : n === $ef053115c0f9207e$var$a.OPTGROUP ? (e.openElements.currentTagName === $ef053115c0f9207e$var$a.OPTION && e.openElements.pop(), e.openElements.currentTagName === $ef053115c0f9207e$var$a.OPTGROUP && e.openElements.pop(), e._insertElement(t, $ef053115c0f9207e$var$L.HTML)) : n === $ef053115c0f9207e$var$a.INPUT || n === $ef053115c0f9207e$var$a.KEYGEN || n === $ef053115c0f9207e$var$a.TEXTAREA || n === $ef053115c0f9207e$var$a.SELECT ? e.openElements.hasInSelectScope($ef053115c0f9207e$var$a.SELECT) && (e.openElements.popUntilTagNamePopped($ef053115c0f9207e$var$a.SELECT), e._resetInsertionMode(), n !== $ef053115c0f9207e$var$a.SELECT && e._processToken(t)) : (n === $ef053115c0f9207e$var$a.SCRIPT || n === $ef053115c0f9207e$var$a.TEMPLATE) && $ef053115c0f9207e$var$de(e, t);
}
function $ef053115c0f9207e$var$Qo(e, t) {
    const n = t.tagName;
    if (n === $ef053115c0f9207e$var$a.OPTGROUP) {
        const r = e.openElements.items[e.openElements.stackTop - 1], i = r && e.treeAdapter.getTagName(r);
        e.openElements.currentTagName === $ef053115c0f9207e$var$a.OPTION && i === $ef053115c0f9207e$var$a.OPTGROUP && e.openElements.pop(), e.openElements.currentTagName === $ef053115c0f9207e$var$a.OPTGROUP && e.openElements.pop();
    } else n === $ef053115c0f9207e$var$a.OPTION ? e.openElements.currentTagName === $ef053115c0f9207e$var$a.OPTION && e.openElements.pop() : n === $ef053115c0f9207e$var$a.SELECT && e.openElements.hasInSelectScope($ef053115c0f9207e$var$a.SELECT) ? (e.openElements.popUntilTagNamePopped($ef053115c0f9207e$var$a.SELECT), e._resetInsertionMode()) : n === $ef053115c0f9207e$var$a.TEMPLATE && $ef053115c0f9207e$var$y1(e, t);
}
function $ef053115c0f9207e$var$x5(e, t) {
    const n = t.tagName;
    n === $ef053115c0f9207e$var$a.CAPTION || n === $ef053115c0f9207e$var$a.TABLE || n === $ef053115c0f9207e$var$a.TBODY || n === $ef053115c0f9207e$var$a.TFOOT || n === $ef053115c0f9207e$var$a.THEAD || n === $ef053115c0f9207e$var$a.TR || n === $ef053115c0f9207e$var$a.TD || n === $ef053115c0f9207e$var$a.TH ? (e.openElements.popUntilTagNamePopped($ef053115c0f9207e$var$a.SELECT), e._resetInsertionMode(), e._processToken(t)) : $ef053115c0f9207e$var$$o(e, t);
}
function $ef053115c0f9207e$var$y5(e, t) {
    const n = t.tagName;
    n === $ef053115c0f9207e$var$a.CAPTION || n === $ef053115c0f9207e$var$a.TABLE || n === $ef053115c0f9207e$var$a.TBODY || n === $ef053115c0f9207e$var$a.TFOOT || n === $ef053115c0f9207e$var$a.THEAD || n === $ef053115c0f9207e$var$a.TR || n === $ef053115c0f9207e$var$a.TD || n === $ef053115c0f9207e$var$a.TH ? e.openElements.hasInTableScope(n) && (e.openElements.popUntilTagNamePopped($ef053115c0f9207e$var$a.SELECT), e._resetInsertionMode(), e._processToken(t)) : $ef053115c0f9207e$var$Qo(e, t);
}
function $ef053115c0f9207e$var$k5(e, t) {
    const n = t.tagName;
    if (n === $ef053115c0f9207e$var$a.BASE || n === $ef053115c0f9207e$var$a.BASEFONT || n === $ef053115c0f9207e$var$a.BGSOUND || n === $ef053115c0f9207e$var$a.LINK || n === $ef053115c0f9207e$var$a.META || n === $ef053115c0f9207e$var$a.NOFRAMES || n === $ef053115c0f9207e$var$a.SCRIPT || n === $ef053115c0f9207e$var$a.STYLE || n === $ef053115c0f9207e$var$a.TEMPLATE || n === $ef053115c0f9207e$var$a.TITLE) $ef053115c0f9207e$var$de(e, t);
    else {
        const r = $ef053115c0f9207e$var$cc[n] || $ef053115c0f9207e$var$Je;
        e._popTmplInsertionMode(), e._pushTmplInsertionMode(r), e.insertionMode = r, e._processToken(t);
    }
}
function $ef053115c0f9207e$var$L5(e, t) {
    t.tagName === $ef053115c0f9207e$var$a.TEMPLATE && $ef053115c0f9207e$var$y1(e, t);
}
function $ef053115c0f9207e$var$Wo(e, t) {
    e.openElements.tmplCount > 0 ? (e.openElements.popUntilTagNamePopped($ef053115c0f9207e$var$a.TEMPLATE), e.activeFormattingElements.clearToLastMarker(), e._popTmplInsertionMode(), e._resetInsertionMode(), e._processToken(t)) : e.stopped = !0;
}
function $ef053115c0f9207e$var$M5(e, t) {
    t.tagName === $ef053115c0f9207e$var$a.HTML ? $ef053115c0f9207e$var$xe(e, t) : $ef053115c0f9207e$var$Vt(e, t);
}
function $ef053115c0f9207e$var$b5(e, t) {
    t.tagName === $ef053115c0f9207e$var$a.HTML ? e.fragmentContext || (e.insertionMode = $ef053115c0f9207e$var$Yo) : $ef053115c0f9207e$var$Vt(e, t);
}
function $ef053115c0f9207e$var$Vt(e, t) {
    e.insertionMode = $ef053115c0f9207e$var$Je, e._processToken(t);
}
function $ef053115c0f9207e$var$P5(e, t) {
    const n = t.tagName;
    n === $ef053115c0f9207e$var$a.HTML ? $ef053115c0f9207e$var$xe(e, t) : n === $ef053115c0f9207e$var$a.FRAMESET ? e._insertElement(t, $ef053115c0f9207e$var$L.HTML) : n === $ef053115c0f9207e$var$a.FRAME ? (e._appendElement(t, $ef053115c0f9207e$var$L.HTML), t.ackSelfClosing = !0) : n === $ef053115c0f9207e$var$a.NOFRAMES && $ef053115c0f9207e$var$de(e, t);
}
function $ef053115c0f9207e$var$D5(e, t) {
    t.tagName === $ef053115c0f9207e$var$a.FRAMESET && !e.openElements.isRootHtmlElementCurrent() && (e.openElements.pop(), !e.fragmentContext && e.openElements.currentTagName !== $ef053115c0f9207e$var$a.FRAMESET && (e.insertionMode = $ef053115c0f9207e$var$zo));
}
function $ef053115c0f9207e$var$w5(e, t) {
    const n = t.tagName;
    n === $ef053115c0f9207e$var$a.HTML ? $ef053115c0f9207e$var$xe(e, t) : n === $ef053115c0f9207e$var$a.NOFRAMES && $ef053115c0f9207e$var$de(e, t);
}
function $ef053115c0f9207e$var$F5(e, t) {
    t.tagName === $ef053115c0f9207e$var$a.HTML && (e.insertionMode = $ef053115c0f9207e$var$jo);
}
function $ef053115c0f9207e$var$H5(e, t) {
    t.tagName === $ef053115c0f9207e$var$a.HTML ? $ef053115c0f9207e$var$xe(e, t) : $ef053115c0f9207e$var$Yt(e, t);
}
function $ef053115c0f9207e$var$Yt(e, t) {
    e.insertionMode = $ef053115c0f9207e$var$Je, e._processToken(t);
}
function $ef053115c0f9207e$var$B5(e, t) {
    const n = t.tagName;
    n === $ef053115c0f9207e$var$a.HTML ? $ef053115c0f9207e$var$xe(e, t) : n === $ef053115c0f9207e$var$a.NOFRAMES && $ef053115c0f9207e$var$de(e, t);
}
function $ef053115c0f9207e$var$U5(e, t) {
    t.chars = $ef053115c0f9207e$var$sc.REPLACEMENT_CHARACTER, e._insertCharacters(t);
}
function $ef053115c0f9207e$var$v5(e, t) {
    e._insertCharacters(t), e.framesetOk = !1;
}
function $ef053115c0f9207e$var$G5(e, t) {
    if ($ef053115c0f9207e$var$Xe.causesExit(t) && !e.fragmentContext) {
        for(; e.treeAdapter.getNamespaceURI(e.openElements.current) !== $ef053115c0f9207e$var$L.HTML && !e._isIntegrationPoint(e.openElements.current);)e.openElements.pop();
        e._processToken(t);
    } else {
        const n = e._getAdjustedCurrentElement(), r = e.treeAdapter.getNamespaceURI(n);
        r === $ef053115c0f9207e$var$L.MATHML ? $ef053115c0f9207e$var$Xe.adjustTokenMathMLAttrs(t) : r === $ef053115c0f9207e$var$L.SVG && ($ef053115c0f9207e$var$Xe.adjustTokenSVGTagName(t), $ef053115c0f9207e$var$Xe.adjustTokenSVGAttrs(t)), $ef053115c0f9207e$var$Xe.adjustTokenXMLAttrs(t), t.selfClosing ? e._appendElement(t, r) : e._insertElement(t, r), t.ackSelfClosing = !0;
    }
}
function $ef053115c0f9207e$var$K5(e, t) {
    for(let n = e.openElements.stackTop; n > 0; n--){
        const r = e.openElements.items[n];
        if (e.treeAdapter.getNamespaceURI(r) === $ef053115c0f9207e$var$L.HTML) {
            e._processToken(t);
            break;
        }
        if (e.treeAdapter.getTagName(r).toLowerCase() === t.tagName) {
            e.openElements.popUntilElementPopped(r);
            break;
        }
    }
}
const $ef053115c0f9207e$var$z5 = /* @__PURE__ */ $ef053115c0f9207e$var$tr($ef053115c0f9207e$var$fc);
class $ef053115c0f9207e$var$gt {
    /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */ constructor(t, n, r){
        this.property = t, this.normal = n, r && (this.space = r);
    }
}
$ef053115c0f9207e$var$gt.prototype.property = {};
$ef053115c0f9207e$var$gt.prototype.normal = {};
$ef053115c0f9207e$var$gt.prototype.space = null;
function $ef053115c0f9207e$var$qo(e, t) {
    const n = {}, r = {};
    let i = -1;
    for(; ++i < e.length;)Object.assign(n, e[i].property), Object.assign(r, e[i].normal);
    return new $ef053115c0f9207e$var$gt(n, r, t);
}
function $ef053115c0f9207e$var$pt(e) {
    return e.toLowerCase();
}
class $ef053115c0f9207e$var$Be {
    /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */ constructor(t, n){
        this.property = t, this.attribute = n;
    }
}
$ef053115c0f9207e$var$Be.prototype.space = null;
$ef053115c0f9207e$var$Be.prototype.boolean = !1;
$ef053115c0f9207e$var$Be.prototype.booleanish = !1;
$ef053115c0f9207e$var$Be.prototype.overloadedBoolean = !1;
$ef053115c0f9207e$var$Be.prototype.number = !1;
$ef053115c0f9207e$var$Be.prototype.commaSeparated = !1;
$ef053115c0f9207e$var$Be.prototype.spaceSeparated = !1;
$ef053115c0f9207e$var$Be.prototype.commaOrSpaceSeparated = !1;
$ef053115c0f9207e$var$Be.prototype.mustUseProperty = !1;
$ef053115c0f9207e$var$Be.prototype.defined = !1;
let $ef053115c0f9207e$var$Y5 = 0;
const $ef053115c0f9207e$var$G = $ef053115c0f9207e$var$k1(), $ef053115c0f9207e$var$ae = $ef053115c0f9207e$var$k1(), $ef053115c0f9207e$var$Vo = $ef053115c0f9207e$var$k1(), $ef053115c0f9207e$var$I = $ef053115c0f9207e$var$k1(), $ef053115c0f9207e$var$re = $ef053115c0f9207e$var$k1(), $ef053115c0f9207e$var$Y1 = $ef053115c0f9207e$var$k1(), $ef053115c0f9207e$var$ye = $ef053115c0f9207e$var$k1();
function $ef053115c0f9207e$var$k1() {
    return 2 ** ++$ef053115c0f9207e$var$Y5;
}
const $ef053115c0f9207e$var$Xn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    boolean: $ef053115c0f9207e$var$G,
    booleanish: $ef053115c0f9207e$var$ae,
    commaOrSpaceSeparated: $ef053115c0f9207e$var$ye,
    commaSeparated: $ef053115c0f9207e$var$Y1,
    number: $ef053115c0f9207e$var$I,
    overloadedBoolean: $ef053115c0f9207e$var$Vo,
    spaceSeparated: $ef053115c0f9207e$var$re
}, Symbol.toStringTag, {
    value: "Module"
})), $ef053115c0f9207e$var$Bn = Object.keys($ef053115c0f9207e$var$Xn);
class $ef053115c0f9207e$var$Cr extends $ef053115c0f9207e$var$Be {
    /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */ constructor(t, n, r, i){
        let s = -1;
        if (super(t, n), $ef053115c0f9207e$var$gs(this, "space", i), typeof r == "number") for(; ++s < $ef053115c0f9207e$var$Bn.length;){
            const o = $ef053115c0f9207e$var$Bn[s];
            $ef053115c0f9207e$var$gs(this, $ef053115c0f9207e$var$Bn[s], (r & $ef053115c0f9207e$var$Xn[o]) === $ef053115c0f9207e$var$Xn[o]);
        }
    }
}
$ef053115c0f9207e$var$Cr.prototype.defined = !0;
function $ef053115c0f9207e$var$gs(e, t, n) {
    n && (e[t] = n);
}
const $ef053115c0f9207e$var$j5 = {}.hasOwnProperty;
function $ef053115c0f9207e$var$Q1(e) {
    const t = {}, n = {};
    let r;
    for(r in e.properties)if ($ef053115c0f9207e$var$j5.call(e.properties, r)) {
        const i = e.properties[r], s = new $ef053115c0f9207e$var$Cr(r, e.transform(e.attributes || {}, r), i, e.space);
        e.mustUseProperty && e.mustUseProperty.includes(r) && (s.mustUseProperty = !0), t[r] = s, n[$ef053115c0f9207e$var$pt(r)] = r, n[$ef053115c0f9207e$var$pt(s.attribute)] = r;
    }
    return new $ef053115c0f9207e$var$gt(t, n, e.space);
}
const $ef053115c0f9207e$var$Xo = $ef053115c0f9207e$var$Q1({
    space: "xlink",
    transform (e, t) {
        return "xlink:" + t.slice(5).toLowerCase();
    },
    properties: {
        xLinkActuate: null,
        xLinkArcRole: null,
        xLinkHref: null,
        xLinkRole: null,
        xLinkShow: null,
        xLinkTitle: null,
        xLinkType: null
    }
}), $ef053115c0f9207e$var$Jo = $ef053115c0f9207e$var$Q1({
    space: "xml",
    transform (e, t) {
        return "xml:" + t.slice(3).toLowerCase();
    },
    properties: {
        xmlLang: null,
        xmlBase: null,
        xmlSpace: null
    }
});
function $ef053115c0f9207e$var$Zo(e, t) {
    return t in e ? e[t] : t;
}
function $ef053115c0f9207e$var$ea(e, t) {
    return $ef053115c0f9207e$var$Zo(e, t.toLowerCase());
}
const $ef053115c0f9207e$var$ta = $ef053115c0f9207e$var$Q1({
    space: "xmlns",
    attributes: {
        xmlnsxlink: "xmlns:xlink"
    },
    transform: $ef053115c0f9207e$var$ea,
    properties: {
        xmlns: null,
        xmlnsXLink: null
    }
}), $ef053115c0f9207e$var$na = $ef053115c0f9207e$var$Q1({
    transform (e, t) {
        return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
    },
    properties: {
        ariaActiveDescendant: null,
        ariaAtomic: $ef053115c0f9207e$var$ae,
        ariaAutoComplete: null,
        ariaBusy: $ef053115c0f9207e$var$ae,
        ariaChecked: $ef053115c0f9207e$var$ae,
        ariaColCount: $ef053115c0f9207e$var$I,
        ariaColIndex: $ef053115c0f9207e$var$I,
        ariaColSpan: $ef053115c0f9207e$var$I,
        ariaControls: $ef053115c0f9207e$var$re,
        ariaCurrent: null,
        ariaDescribedBy: $ef053115c0f9207e$var$re,
        ariaDetails: null,
        ariaDisabled: $ef053115c0f9207e$var$ae,
        ariaDropEffect: $ef053115c0f9207e$var$re,
        ariaErrorMessage: null,
        ariaExpanded: $ef053115c0f9207e$var$ae,
        ariaFlowTo: $ef053115c0f9207e$var$re,
        ariaGrabbed: $ef053115c0f9207e$var$ae,
        ariaHasPopup: null,
        ariaHidden: $ef053115c0f9207e$var$ae,
        ariaInvalid: null,
        ariaKeyShortcuts: null,
        ariaLabel: null,
        ariaLabelledBy: $ef053115c0f9207e$var$re,
        ariaLevel: $ef053115c0f9207e$var$I,
        ariaLive: null,
        ariaModal: $ef053115c0f9207e$var$ae,
        ariaMultiLine: $ef053115c0f9207e$var$ae,
        ariaMultiSelectable: $ef053115c0f9207e$var$ae,
        ariaOrientation: null,
        ariaOwns: $ef053115c0f9207e$var$re,
        ariaPlaceholder: null,
        ariaPosInSet: $ef053115c0f9207e$var$I,
        ariaPressed: $ef053115c0f9207e$var$ae,
        ariaReadOnly: $ef053115c0f9207e$var$ae,
        ariaRelevant: null,
        ariaRequired: $ef053115c0f9207e$var$ae,
        ariaRoleDescription: $ef053115c0f9207e$var$re,
        ariaRowCount: $ef053115c0f9207e$var$I,
        ariaRowIndex: $ef053115c0f9207e$var$I,
        ariaRowSpan: $ef053115c0f9207e$var$I,
        ariaSelected: $ef053115c0f9207e$var$ae,
        ariaSetSize: $ef053115c0f9207e$var$I,
        ariaSort: null,
        ariaValueMax: $ef053115c0f9207e$var$I,
        ariaValueMin: $ef053115c0f9207e$var$I,
        ariaValueNow: $ef053115c0f9207e$var$I,
        ariaValueText: null,
        role: null
    }
}), $ef053115c0f9207e$var$$5 = $ef053115c0f9207e$var$Q1({
    space: "html",
    attributes: {
        acceptcharset: "accept-charset",
        classname: "class",
        htmlfor: "for",
        httpequiv: "http-equiv"
    },
    transform: $ef053115c0f9207e$var$ea,
    mustUseProperty: [
        "checked",
        "multiple",
        "muted",
        "selected"
    ],
    properties: {
        // Standard Properties.
        abbr: null,
        accept: $ef053115c0f9207e$var$Y1,
        acceptCharset: $ef053115c0f9207e$var$re,
        accessKey: $ef053115c0f9207e$var$re,
        action: null,
        allow: null,
        allowFullScreen: $ef053115c0f9207e$var$G,
        allowPaymentRequest: $ef053115c0f9207e$var$G,
        allowUserMedia: $ef053115c0f9207e$var$G,
        alt: null,
        as: null,
        async: $ef053115c0f9207e$var$G,
        autoCapitalize: null,
        autoComplete: $ef053115c0f9207e$var$re,
        autoFocus: $ef053115c0f9207e$var$G,
        autoPlay: $ef053115c0f9207e$var$G,
        capture: $ef053115c0f9207e$var$G,
        charSet: null,
        checked: $ef053115c0f9207e$var$G,
        cite: null,
        className: $ef053115c0f9207e$var$re,
        cols: $ef053115c0f9207e$var$I,
        colSpan: null,
        content: null,
        contentEditable: $ef053115c0f9207e$var$ae,
        controls: $ef053115c0f9207e$var$G,
        controlsList: $ef053115c0f9207e$var$re,
        coords: $ef053115c0f9207e$var$I | $ef053115c0f9207e$var$Y1,
        crossOrigin: null,
        data: null,
        dateTime: null,
        decoding: null,
        default: $ef053115c0f9207e$var$G,
        defer: $ef053115c0f9207e$var$G,
        dir: null,
        dirName: null,
        disabled: $ef053115c0f9207e$var$G,
        download: $ef053115c0f9207e$var$Vo,
        draggable: $ef053115c0f9207e$var$ae,
        encType: null,
        enterKeyHint: null,
        form: null,
        formAction: null,
        formEncType: null,
        formMethod: null,
        formNoValidate: $ef053115c0f9207e$var$G,
        formTarget: null,
        headers: $ef053115c0f9207e$var$re,
        height: $ef053115c0f9207e$var$I,
        hidden: $ef053115c0f9207e$var$G,
        high: $ef053115c0f9207e$var$I,
        href: null,
        hrefLang: null,
        htmlFor: $ef053115c0f9207e$var$re,
        httpEquiv: $ef053115c0f9207e$var$re,
        id: null,
        imageSizes: null,
        imageSrcSet: null,
        inputMode: null,
        integrity: null,
        is: null,
        isMap: $ef053115c0f9207e$var$G,
        itemId: null,
        itemProp: $ef053115c0f9207e$var$re,
        itemRef: $ef053115c0f9207e$var$re,
        itemScope: $ef053115c0f9207e$var$G,
        itemType: $ef053115c0f9207e$var$re,
        kind: null,
        label: null,
        lang: null,
        language: null,
        list: null,
        loading: null,
        loop: $ef053115c0f9207e$var$G,
        low: $ef053115c0f9207e$var$I,
        manifest: null,
        max: null,
        maxLength: $ef053115c0f9207e$var$I,
        media: null,
        method: null,
        min: null,
        minLength: $ef053115c0f9207e$var$I,
        multiple: $ef053115c0f9207e$var$G,
        muted: $ef053115c0f9207e$var$G,
        name: null,
        nonce: null,
        noModule: $ef053115c0f9207e$var$G,
        noValidate: $ef053115c0f9207e$var$G,
        onAbort: null,
        onAfterPrint: null,
        onAuxClick: null,
        onBeforePrint: null,
        onBeforeUnload: null,
        onBlur: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onContextLost: null,
        onContextMenu: null,
        onContextRestored: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFormData: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLanguageChange: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadEnd: null,
        onLoadStart: null,
        onMessage: null,
        onMessageError: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRejectionHandled: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onSecurityPolicyViolation: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onSlotChange: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnhandledRejection: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onWheel: null,
        open: $ef053115c0f9207e$var$G,
        optimum: $ef053115c0f9207e$var$I,
        pattern: null,
        ping: $ef053115c0f9207e$var$re,
        placeholder: null,
        playsInline: $ef053115c0f9207e$var$G,
        poster: null,
        preload: null,
        readOnly: $ef053115c0f9207e$var$G,
        referrerPolicy: null,
        rel: $ef053115c0f9207e$var$re,
        required: $ef053115c0f9207e$var$G,
        reversed: $ef053115c0f9207e$var$G,
        rows: $ef053115c0f9207e$var$I,
        rowSpan: $ef053115c0f9207e$var$I,
        sandbox: $ef053115c0f9207e$var$re,
        scope: null,
        scoped: $ef053115c0f9207e$var$G,
        seamless: $ef053115c0f9207e$var$G,
        selected: $ef053115c0f9207e$var$G,
        shape: null,
        size: $ef053115c0f9207e$var$I,
        sizes: null,
        slot: null,
        span: $ef053115c0f9207e$var$I,
        spellCheck: $ef053115c0f9207e$var$ae,
        src: null,
        srcDoc: null,
        srcLang: null,
        srcSet: null,
        start: $ef053115c0f9207e$var$I,
        step: null,
        style: null,
        tabIndex: $ef053115c0f9207e$var$I,
        target: null,
        title: null,
        translate: null,
        type: null,
        typeMustMatch: $ef053115c0f9207e$var$G,
        useMap: null,
        value: $ef053115c0f9207e$var$ae,
        width: $ef053115c0f9207e$var$I,
        wrap: null,
        // Legacy.
        // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
        align: null,
        // Several. Use CSS `text-align` instead,
        aLink: null,
        // `<body>`. Use CSS `a:active {color}` instead
        archive: $ef053115c0f9207e$var$re,
        // `<object>`. List of URIs to archives
        axis: null,
        // `<td>` and `<th>`. Use `scope` on `<th>`
        background: null,
        // `<body>`. Use CSS `background-image` instead
        bgColor: null,
        // `<body>` and table elements. Use CSS `background-color` instead
        border: $ef053115c0f9207e$var$I,
        // `<table>`. Use CSS `border-width` instead,
        borderColor: null,
        // `<table>`. Use CSS `border-color` instead,
        bottomMargin: $ef053115c0f9207e$var$I,
        // `<body>`
        cellPadding: null,
        // `<table>`
        cellSpacing: null,
        // `<table>`
        char: null,
        // Several table elements. When `align=char`, sets the character to align on
        charOff: null,
        // Several table elements. When `char`, offsets the alignment
        classId: null,
        // `<object>`
        clear: null,
        // `<br>`. Use CSS `clear` instead
        code: null,
        // `<object>`
        codeBase: null,
        // `<object>`
        codeType: null,
        // `<object>`
        color: null,
        // `<font>` and `<hr>`. Use CSS instead
        compact: $ef053115c0f9207e$var$G,
        // Lists. Use CSS to reduce space between items instead
        declare: $ef053115c0f9207e$var$G,
        // `<object>`
        event: null,
        // `<script>`
        face: null,
        // `<font>`. Use CSS instead
        frame: null,
        // `<table>`
        frameBorder: null,
        // `<iframe>`. Use CSS `border` instead
        hSpace: $ef053115c0f9207e$var$I,
        // `<img>` and `<object>`
        leftMargin: $ef053115c0f9207e$var$I,
        // `<body>`
        link: null,
        // `<body>`. Use CSS `a:link {color: *}` instead
        longDesc: null,
        // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
        lowSrc: null,
        // `<img>`. Use a `<picture>`
        marginHeight: $ef053115c0f9207e$var$I,
        // `<body>`
        marginWidth: $ef053115c0f9207e$var$I,
        // `<body>`
        noResize: $ef053115c0f9207e$var$G,
        // `<frame>`
        noHref: $ef053115c0f9207e$var$G,
        // `<area>`. Use no href instead of an explicit `nohref`
        noShade: $ef053115c0f9207e$var$G,
        // `<hr>`. Use background-color and height instead of borders
        noWrap: $ef053115c0f9207e$var$G,
        // `<td>` and `<th>`
        object: null,
        // `<applet>`
        profile: null,
        // `<head>`
        prompt: null,
        // `<isindex>`
        rev: null,
        // `<link>`
        rightMargin: $ef053115c0f9207e$var$I,
        // `<body>`
        rules: null,
        // `<table>`
        scheme: null,
        // `<meta>`
        scrolling: $ef053115c0f9207e$var$ae,
        // `<frame>`. Use overflow in the child context
        standby: null,
        // `<object>`
        summary: null,
        // `<table>`
        text: null,
        // `<body>`. Use CSS `color` instead
        topMargin: $ef053115c0f9207e$var$I,
        // `<body>`
        valueType: null,
        // `<param>`
        version: null,
        // `<html>`. Use a doctype.
        vAlign: null,
        // Several. Use CSS `vertical-align` instead
        vLink: null,
        // `<body>`. Use CSS `a:visited {color}` instead
        vSpace: $ef053115c0f9207e$var$I,
        // `<img>` and `<object>`
        // Non-standard Properties.
        allowTransparency: null,
        autoCorrect: null,
        autoSave: null,
        disablePictureInPicture: $ef053115c0f9207e$var$G,
        disableRemotePlayback: $ef053115c0f9207e$var$G,
        prefix: null,
        property: null,
        results: $ef053115c0f9207e$var$I,
        security: null,
        unselectable: null
    }
}), $ef053115c0f9207e$var$Q5 = $ef053115c0f9207e$var$Q1({
    space: "svg",
    attributes: {
        accentHeight: "accent-height",
        alignmentBaseline: "alignment-baseline",
        arabicForm: "arabic-form",
        baselineShift: "baseline-shift",
        capHeight: "cap-height",
        className: "class",
        clipPath: "clip-path",
        clipRule: "clip-rule",
        colorInterpolation: "color-interpolation",
        colorInterpolationFilters: "color-interpolation-filters",
        colorProfile: "color-profile",
        colorRendering: "color-rendering",
        crossOrigin: "crossorigin",
        dataType: "datatype",
        dominantBaseline: "dominant-baseline",
        enableBackground: "enable-background",
        fillOpacity: "fill-opacity",
        fillRule: "fill-rule",
        floodColor: "flood-color",
        floodOpacity: "flood-opacity",
        fontFamily: "font-family",
        fontSize: "font-size",
        fontSizeAdjust: "font-size-adjust",
        fontStretch: "font-stretch",
        fontStyle: "font-style",
        fontVariant: "font-variant",
        fontWeight: "font-weight",
        glyphName: "glyph-name",
        glyphOrientationHorizontal: "glyph-orientation-horizontal",
        glyphOrientationVertical: "glyph-orientation-vertical",
        hrefLang: "hreflang",
        horizAdvX: "horiz-adv-x",
        horizOriginX: "horiz-origin-x",
        horizOriginY: "horiz-origin-y",
        imageRendering: "image-rendering",
        letterSpacing: "letter-spacing",
        lightingColor: "lighting-color",
        markerEnd: "marker-end",
        markerMid: "marker-mid",
        markerStart: "marker-start",
        navDown: "nav-down",
        navDownLeft: "nav-down-left",
        navDownRight: "nav-down-right",
        navLeft: "nav-left",
        navNext: "nav-next",
        navPrev: "nav-prev",
        navRight: "nav-right",
        navUp: "nav-up",
        navUpLeft: "nav-up-left",
        navUpRight: "nav-up-right",
        onAbort: "onabort",
        onActivate: "onactivate",
        onAfterPrint: "onafterprint",
        onBeforePrint: "onbeforeprint",
        onBegin: "onbegin",
        onCancel: "oncancel",
        onCanPlay: "oncanplay",
        onCanPlayThrough: "oncanplaythrough",
        onChange: "onchange",
        onClick: "onclick",
        onClose: "onclose",
        onCopy: "oncopy",
        onCueChange: "oncuechange",
        onCut: "oncut",
        onDblClick: "ondblclick",
        onDrag: "ondrag",
        onDragEnd: "ondragend",
        onDragEnter: "ondragenter",
        onDragExit: "ondragexit",
        onDragLeave: "ondragleave",
        onDragOver: "ondragover",
        onDragStart: "ondragstart",
        onDrop: "ondrop",
        onDurationChange: "ondurationchange",
        onEmptied: "onemptied",
        onEnd: "onend",
        onEnded: "onended",
        onError: "onerror",
        onFocus: "onfocus",
        onFocusIn: "onfocusin",
        onFocusOut: "onfocusout",
        onHashChange: "onhashchange",
        onInput: "oninput",
        onInvalid: "oninvalid",
        onKeyDown: "onkeydown",
        onKeyPress: "onkeypress",
        onKeyUp: "onkeyup",
        onLoad: "onload",
        onLoadedData: "onloadeddata",
        onLoadedMetadata: "onloadedmetadata",
        onLoadStart: "onloadstart",
        onMessage: "onmessage",
        onMouseDown: "onmousedown",
        onMouseEnter: "onmouseenter",
        onMouseLeave: "onmouseleave",
        onMouseMove: "onmousemove",
        onMouseOut: "onmouseout",
        onMouseOver: "onmouseover",
        onMouseUp: "onmouseup",
        onMouseWheel: "onmousewheel",
        onOffline: "onoffline",
        onOnline: "ononline",
        onPageHide: "onpagehide",
        onPageShow: "onpageshow",
        onPaste: "onpaste",
        onPause: "onpause",
        onPlay: "onplay",
        onPlaying: "onplaying",
        onPopState: "onpopstate",
        onProgress: "onprogress",
        onRateChange: "onratechange",
        onRepeat: "onrepeat",
        onReset: "onreset",
        onResize: "onresize",
        onScroll: "onscroll",
        onSeeked: "onseeked",
        onSeeking: "onseeking",
        onSelect: "onselect",
        onShow: "onshow",
        onStalled: "onstalled",
        onStorage: "onstorage",
        onSubmit: "onsubmit",
        onSuspend: "onsuspend",
        onTimeUpdate: "ontimeupdate",
        onToggle: "ontoggle",
        onUnload: "onunload",
        onVolumeChange: "onvolumechange",
        onWaiting: "onwaiting",
        onZoom: "onzoom",
        overlinePosition: "overline-position",
        overlineThickness: "overline-thickness",
        paintOrder: "paint-order",
        panose1: "panose-1",
        pointerEvents: "pointer-events",
        referrerPolicy: "referrerpolicy",
        renderingIntent: "rendering-intent",
        shapeRendering: "shape-rendering",
        stopColor: "stop-color",
        stopOpacity: "stop-opacity",
        strikethroughPosition: "strikethrough-position",
        strikethroughThickness: "strikethrough-thickness",
        strokeDashArray: "stroke-dasharray",
        strokeDashOffset: "stroke-dashoffset",
        strokeLineCap: "stroke-linecap",
        strokeLineJoin: "stroke-linejoin",
        strokeMiterLimit: "stroke-miterlimit",
        strokeOpacity: "stroke-opacity",
        strokeWidth: "stroke-width",
        tabIndex: "tabindex",
        textAnchor: "text-anchor",
        textDecoration: "text-decoration",
        textRendering: "text-rendering",
        typeOf: "typeof",
        underlinePosition: "underline-position",
        underlineThickness: "underline-thickness",
        unicodeBidi: "unicode-bidi",
        unicodeRange: "unicode-range",
        unitsPerEm: "units-per-em",
        vAlphabetic: "v-alphabetic",
        vHanging: "v-hanging",
        vIdeographic: "v-ideographic",
        vMathematical: "v-mathematical",
        vectorEffect: "vector-effect",
        vertAdvY: "vert-adv-y",
        vertOriginX: "vert-origin-x",
        vertOriginY: "vert-origin-y",
        wordSpacing: "word-spacing",
        writingMode: "writing-mode",
        xHeight: "x-height",
        // These were camelcased in Tiny. Now lowercased in SVG 2
        playbackOrder: "playbackorder",
        timelineBegin: "timelinebegin"
    },
    transform: $ef053115c0f9207e$var$Zo,
    properties: {
        about: $ef053115c0f9207e$var$ye,
        accentHeight: $ef053115c0f9207e$var$I,
        accumulate: null,
        additive: null,
        alignmentBaseline: null,
        alphabetic: $ef053115c0f9207e$var$I,
        amplitude: $ef053115c0f9207e$var$I,
        arabicForm: null,
        ascent: $ef053115c0f9207e$var$I,
        attributeName: null,
        attributeType: null,
        azimuth: $ef053115c0f9207e$var$I,
        bandwidth: null,
        baselineShift: null,
        baseFrequency: null,
        baseProfile: null,
        bbox: null,
        begin: null,
        bias: $ef053115c0f9207e$var$I,
        by: null,
        calcMode: null,
        capHeight: $ef053115c0f9207e$var$I,
        className: $ef053115c0f9207e$var$re,
        clip: null,
        clipPath: null,
        clipPathUnits: null,
        clipRule: null,
        color: null,
        colorInterpolation: null,
        colorInterpolationFilters: null,
        colorProfile: null,
        colorRendering: null,
        content: null,
        contentScriptType: null,
        contentStyleType: null,
        crossOrigin: null,
        cursor: null,
        cx: null,
        cy: null,
        d: null,
        dataType: null,
        defaultAction: null,
        descent: $ef053115c0f9207e$var$I,
        diffuseConstant: $ef053115c0f9207e$var$I,
        direction: null,
        display: null,
        dur: null,
        divisor: $ef053115c0f9207e$var$I,
        dominantBaseline: null,
        download: $ef053115c0f9207e$var$G,
        dx: null,
        dy: null,
        edgeMode: null,
        editable: null,
        elevation: $ef053115c0f9207e$var$I,
        enableBackground: null,
        end: null,
        event: null,
        exponent: $ef053115c0f9207e$var$I,
        externalResourcesRequired: null,
        fill: null,
        fillOpacity: $ef053115c0f9207e$var$I,
        fillRule: null,
        filter: null,
        filterRes: null,
        filterUnits: null,
        floodColor: null,
        floodOpacity: null,
        focusable: null,
        focusHighlight: null,
        fontFamily: null,
        fontSize: null,
        fontSizeAdjust: null,
        fontStretch: null,
        fontStyle: null,
        fontVariant: null,
        fontWeight: null,
        format: null,
        fr: null,
        from: null,
        fx: null,
        fy: null,
        g1: $ef053115c0f9207e$var$Y1,
        g2: $ef053115c0f9207e$var$Y1,
        glyphName: $ef053115c0f9207e$var$Y1,
        glyphOrientationHorizontal: null,
        glyphOrientationVertical: null,
        glyphRef: null,
        gradientTransform: null,
        gradientUnits: null,
        handler: null,
        hanging: $ef053115c0f9207e$var$I,
        hatchContentUnits: null,
        hatchUnits: null,
        height: null,
        href: null,
        hrefLang: null,
        horizAdvX: $ef053115c0f9207e$var$I,
        horizOriginX: $ef053115c0f9207e$var$I,
        horizOriginY: $ef053115c0f9207e$var$I,
        id: null,
        ideographic: $ef053115c0f9207e$var$I,
        imageRendering: null,
        initialVisibility: null,
        in: null,
        in2: null,
        intercept: $ef053115c0f9207e$var$I,
        k: $ef053115c0f9207e$var$I,
        k1: $ef053115c0f9207e$var$I,
        k2: $ef053115c0f9207e$var$I,
        k3: $ef053115c0f9207e$var$I,
        k4: $ef053115c0f9207e$var$I,
        kernelMatrix: $ef053115c0f9207e$var$ye,
        kernelUnitLength: null,
        keyPoints: null,
        // SEMI_COLON_SEPARATED
        keySplines: null,
        // SEMI_COLON_SEPARATED
        keyTimes: null,
        // SEMI_COLON_SEPARATED
        kerning: null,
        lang: null,
        lengthAdjust: null,
        letterSpacing: null,
        lightingColor: null,
        limitingConeAngle: $ef053115c0f9207e$var$I,
        local: null,
        markerEnd: null,
        markerMid: null,
        markerStart: null,
        markerHeight: null,
        markerUnits: null,
        markerWidth: null,
        mask: null,
        maskContentUnits: null,
        maskUnits: null,
        mathematical: null,
        max: null,
        media: null,
        mediaCharacterEncoding: null,
        mediaContentEncodings: null,
        mediaSize: $ef053115c0f9207e$var$I,
        mediaTime: null,
        method: null,
        min: null,
        mode: null,
        name: null,
        navDown: null,
        navDownLeft: null,
        navDownRight: null,
        navLeft: null,
        navNext: null,
        navPrev: null,
        navRight: null,
        navUp: null,
        navUpLeft: null,
        navUpRight: null,
        numOctaves: null,
        observer: null,
        offset: null,
        onAbort: null,
        onActivate: null,
        onAfterPrint: null,
        onBeforePrint: null,
        onBegin: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnd: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFocusIn: null,
        onFocusOut: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadStart: null,
        onMessage: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onMouseWheel: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRepeat: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onShow: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onZoom: null,
        opacity: null,
        operator: null,
        order: null,
        orient: null,
        orientation: null,
        origin: null,
        overflow: null,
        overlay: null,
        overlinePosition: $ef053115c0f9207e$var$I,
        overlineThickness: $ef053115c0f9207e$var$I,
        paintOrder: null,
        panose1: null,
        path: null,
        pathLength: $ef053115c0f9207e$var$I,
        patternContentUnits: null,
        patternTransform: null,
        patternUnits: null,
        phase: null,
        ping: $ef053115c0f9207e$var$re,
        pitch: null,
        playbackOrder: null,
        pointerEvents: null,
        points: null,
        pointsAtX: $ef053115c0f9207e$var$I,
        pointsAtY: $ef053115c0f9207e$var$I,
        pointsAtZ: $ef053115c0f9207e$var$I,
        preserveAlpha: null,
        preserveAspectRatio: null,
        primitiveUnits: null,
        propagate: null,
        property: $ef053115c0f9207e$var$ye,
        r: null,
        radius: null,
        referrerPolicy: null,
        refX: null,
        refY: null,
        rel: $ef053115c0f9207e$var$ye,
        rev: $ef053115c0f9207e$var$ye,
        renderingIntent: null,
        repeatCount: null,
        repeatDur: null,
        requiredExtensions: $ef053115c0f9207e$var$ye,
        requiredFeatures: $ef053115c0f9207e$var$ye,
        requiredFonts: $ef053115c0f9207e$var$ye,
        requiredFormats: $ef053115c0f9207e$var$ye,
        resource: null,
        restart: null,
        result: null,
        rotate: null,
        rx: null,
        ry: null,
        scale: null,
        seed: null,
        shapeRendering: null,
        side: null,
        slope: null,
        snapshotTime: null,
        specularConstant: $ef053115c0f9207e$var$I,
        specularExponent: $ef053115c0f9207e$var$I,
        spreadMethod: null,
        spacing: null,
        startOffset: null,
        stdDeviation: null,
        stemh: null,
        stemv: null,
        stitchTiles: null,
        stopColor: null,
        stopOpacity: null,
        strikethroughPosition: $ef053115c0f9207e$var$I,
        strikethroughThickness: $ef053115c0f9207e$var$I,
        string: null,
        stroke: null,
        strokeDashArray: $ef053115c0f9207e$var$ye,
        strokeDashOffset: null,
        strokeLineCap: null,
        strokeLineJoin: null,
        strokeMiterLimit: $ef053115c0f9207e$var$I,
        strokeOpacity: $ef053115c0f9207e$var$I,
        strokeWidth: null,
        style: null,
        surfaceScale: $ef053115c0f9207e$var$I,
        syncBehavior: null,
        syncBehaviorDefault: null,
        syncMaster: null,
        syncTolerance: null,
        syncToleranceDefault: null,
        systemLanguage: $ef053115c0f9207e$var$ye,
        tabIndex: $ef053115c0f9207e$var$I,
        tableValues: null,
        target: null,
        targetX: $ef053115c0f9207e$var$I,
        targetY: $ef053115c0f9207e$var$I,
        textAnchor: null,
        textDecoration: null,
        textRendering: null,
        textLength: null,
        timelineBegin: null,
        title: null,
        transformBehavior: null,
        type: null,
        typeOf: $ef053115c0f9207e$var$ye,
        to: null,
        transform: null,
        u1: null,
        u2: null,
        underlinePosition: $ef053115c0f9207e$var$I,
        underlineThickness: $ef053115c0f9207e$var$I,
        unicode: null,
        unicodeBidi: null,
        unicodeRange: null,
        unitsPerEm: $ef053115c0f9207e$var$I,
        values: null,
        vAlphabetic: $ef053115c0f9207e$var$I,
        vMathematical: $ef053115c0f9207e$var$I,
        vectorEffect: null,
        vHanging: $ef053115c0f9207e$var$I,
        vIdeographic: $ef053115c0f9207e$var$I,
        version: null,
        vertAdvY: $ef053115c0f9207e$var$I,
        vertOriginX: $ef053115c0f9207e$var$I,
        vertOriginY: $ef053115c0f9207e$var$I,
        viewBox: null,
        viewTarget: null,
        visibility: null,
        width: null,
        widths: null,
        wordSpacing: null,
        writingMode: null,
        x: null,
        x1: null,
        x2: null,
        xChannelSelector: null,
        xHeight: $ef053115c0f9207e$var$I,
        y: null,
        y1: null,
        y2: null,
        yChannelSelector: null,
        z: null,
        zoomAndPan: null
    }
}), $ef053115c0f9207e$var$W5 = /^data[-\w.:]+$/i, $ef053115c0f9207e$var$As = /-[a-z]/g, $ef053115c0f9207e$var$q5 = /[A-Z]/g;
function $ef053115c0f9207e$var$ra(e, t) {
    const n = $ef053115c0f9207e$var$pt(t);
    let r = t, i = $ef053115c0f9207e$var$Be;
    if (n in e.normal) return e.property[e.normal[n]];
    if (n.length > 4 && n.slice(0, 4) === "data" && $ef053115c0f9207e$var$W5.test(t)) {
        if (t.charAt(4) === "-") {
            const s = t.slice(5).replace($ef053115c0f9207e$var$As, $ef053115c0f9207e$var$X5);
            r = "data" + s.charAt(0).toUpperCase() + s.slice(1);
        } else {
            const s = t.slice(4);
            if (!$ef053115c0f9207e$var$As.test(s)) {
                let o = s.replace($ef053115c0f9207e$var$q5, $ef053115c0f9207e$var$V5);
                o.charAt(0) !== "-" && (o = "-" + o), t = "data" + o;
            }
        }
        i = $ef053115c0f9207e$var$Cr;
    }
    return new i(r, t);
}
function $ef053115c0f9207e$var$V5(e) {
    return "-" + e.toLowerCase();
}
function $ef053115c0f9207e$var$X5(e) {
    return e.charAt(1).toUpperCase();
}
const $ef053115c0f9207e$var$Sr = $ef053115c0f9207e$var$qo([
    $ef053115c0f9207e$var$Jo,
    $ef053115c0f9207e$var$Xo,
    $ef053115c0f9207e$var$ta,
    $ef053115c0f9207e$var$na,
    $ef053115c0f9207e$var$$5
], "html"), $ef053115c0f9207e$var$Nr = $ef053115c0f9207e$var$qo([
    $ef053115c0f9207e$var$Jo,
    $ef053115c0f9207e$var$Xo,
    $ef053115c0f9207e$var$ta,
    $ef053115c0f9207e$var$na,
    $ef053115c0f9207e$var$Q5
], "svg");
var $ef053115c0f9207e$var$Cs = /[#.]/g;
const $ef053115c0f9207e$var$J5 = /**
   * @type {(
   *  <Selector extends string, DefaultTagName extends string = 'div'>(selector?: Selector, defaultTagName?: DefaultTagName) => Element & {tagName: import('./extract.js').ExtractTagName<Selector, DefaultTagName>}
   * )}
   */ /**
   * @param {string} [selector]
   * @param {string} [defaultTagName='div']
   * @returns {Element}
   */ function(e, t = "div") {
    for(var n = e || "", r = {}, i = 0, s, o, l; i < n.length;)$ef053115c0f9207e$var$Cs.lastIndex = i, l = $ef053115c0f9207e$var$Cs.exec(n), s = n.slice(i, l ? l.index : n.length), s && (o ? o === "#" ? r.id = s : Array.isArray(r.className) ? r.className.push(s) : r.className = [
        s
    ] : t = s, i += s.length), l && (o = l[0], i++);
    return {
        type: "element",
        tagName: t,
        properties: r,
        children: []
    };
};
function $ef053115c0f9207e$var$Ss(e) {
    const t = String(e || "").trim();
    return t ? t.split(/[ \t\n\r\f]+/g) : [];
}
function $ef053115c0f9207e$var$Ns(e) {
    for(var t = [], n = String(e || ""), r = n.indexOf(","), i = 0, s, o; !s;)r === -1 && (r = n.length, s = !0), o = n.slice(i, r).trim(), (o || !s) && t.push(o), i = r + 1, r = n.indexOf(",", i);
    return t;
}
const $ef053115c0f9207e$var$Z5 = /* @__PURE__ */ new Set([
    "menu",
    "submit",
    "reset",
    "button"
]), $ef053115c0f9207e$var$Jn = {}.hasOwnProperty;
function $ef053115c0f9207e$var$ia(e, t, n) {
    const r = n && $ef053115c0f9207e$var$r4(n);
    return(/**
     * @type {{
     *   (): Root
     *   (selector: null|undefined, ...children: HChild[]): Root
     *   (selector: string, properties?: HProperties, ...children: HChild[]): Element
     *   (selector: string, ...children: HChild[]): Element
     * }}
     */ /**
     * Hyperscript compatible DSL for creating virtual hast trees.
     *
     * @param {string|null} [selector]
     * @param {HProperties|HChild} [properties]
     * @param {HChild[]} children
     * @returns {HResult}
     */ function(s, o, ...l) {
        let u = -1, c;
        if (s == null) c = {
            type: "root",
            children: []
        }, l.unshift(o);
        else if (c = $ef053115c0f9207e$var$J5(s, t), c.tagName = c.tagName.toLowerCase(), r && $ef053115c0f9207e$var$Jn.call(r, c.tagName) && (c.tagName = r[c.tagName]), $ef053115c0f9207e$var$e4(o, c.tagName)) {
            let h;
            for(h in o)$ef053115c0f9207e$var$Jn.call(o, h) && $ef053115c0f9207e$var$t4(e, c.properties, h, o[h]);
        } else l.unshift(o);
        for(; ++u < l.length;)$ef053115c0f9207e$var$Zn(c.children, l[u]);
        return c.type === "element" && c.tagName === "template" && (c.content = {
            type: "root",
            children: c.children
        }, c.children = []), c;
    });
}
function $ef053115c0f9207e$var$e4(e, t) {
    return e == null || typeof e != "object" || Array.isArray(e) ? !1 : t === "input" || !e.type || typeof e.type != "string" ? !0 : "children" in e && Array.isArray(e.children) ? !1 : t === "button" ? $ef053115c0f9207e$var$Z5.has(e.type.toLowerCase()) : !("value" in e);
}
function $ef053115c0f9207e$var$t4(e, t, n, r) {
    const i = $ef053115c0f9207e$var$ra(e, n);
    let s = -1, o;
    if (r != null) {
        if (typeof r == "number") {
            if (Number.isNaN(r)) return;
            o = r;
        } else typeof r == "boolean" ? o = r : typeof r == "string" ? i.spaceSeparated ? o = $ef053115c0f9207e$var$Ss(r) : i.commaSeparated ? o = $ef053115c0f9207e$var$Ns(r) : i.commaOrSpaceSeparated ? o = $ef053115c0f9207e$var$Ss($ef053115c0f9207e$var$Ns(r).join(" ")) : o = $ef053115c0f9207e$var$Is(i, i.property, r) : Array.isArray(r) ? o = r.concat() : o = i.property === "style" ? $ef053115c0f9207e$var$n4(r) : String(r);
        if (Array.isArray(o)) {
            const l = [];
            for(; ++s < o.length;)l[s] = $ef053115c0f9207e$var$Is(i, i.property, o[s]);
            o = l;
        }
        i.property === "className" && Array.isArray(t.className) && (o = t.className.concat(o)), t[i.property] = o;
    }
}
function $ef053115c0f9207e$var$Zn(e, t) {
    let n = -1;
    if (t != null) {
        if (typeof t == "string" || typeof t == "number") e.push({
            type: "text",
            value: String(t)
        });
        else if (Array.isArray(t)) for(; ++n < t.length;)$ef053115c0f9207e$var$Zn(e, t[n]);
        else if (typeof t == "object" && "type" in t) t.type === "root" ? $ef053115c0f9207e$var$Zn(e, t.children) : e.push(t);
        else throw new Error("Expected node, nodes, or string, got `" + t + "`");
    }
}
function $ef053115c0f9207e$var$Is(e, t, n) {
    if (typeof n == "string") {
        if (e.number && n && !Number.isNaN(Number(n))) return Number(n);
        if ((e.boolean || e.overloadedBoolean) && (n === "" || $ef053115c0f9207e$var$pt(n) === $ef053115c0f9207e$var$pt(t))) return !0;
    }
    return n;
}
function $ef053115c0f9207e$var$n4(e) {
    const t = [];
    let n;
    for(n in e)$ef053115c0f9207e$var$Jn.call(e, n) && t.push([
        n,
        e[n]
    ].join(": "));
    return t.join("; ");
}
function $ef053115c0f9207e$var$r4(e) {
    const t = {};
    let n = -1;
    for(; ++n < e.length;)t[e[n].toLowerCase()] = e[n];
    return t;
}
const $ef053115c0f9207e$var$i4 = $ef053115c0f9207e$var$ia($ef053115c0f9207e$var$Sr, "div"), $ef053115c0f9207e$var$s4 = [
    "altGlyph",
    "altGlyphDef",
    "altGlyphItem",
    "animateColor",
    "animateMotion",
    "animateTransform",
    "clipPath",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "foreignObject",
    "glyphRef",
    "linearGradient",
    "radialGradient",
    "solidColor",
    "textArea",
    "textPath"
], $ef053115c0f9207e$var$o4 = $ef053115c0f9207e$var$ia($ef053115c0f9207e$var$Nr, "g", $ef053115c0f9207e$var$s4);
function $ef053115c0f9207e$var$a4(e) {
    for(var t = String(e), n = [], r = /\r?\n|\r/g; r.test(t);)n.push(r.lastIndex);
    return n.push(t.length + 1), {
        toPoint: i,
        toOffset: s
    };
    function i(o) {
        var l = -1;
        if (o > -1 && o < n[n.length - 1]) {
            for(; ++l < n.length;)if (n[l] > o) return {
                line: l + 1,
                column: o - (n[l - 1] || 0) + 1,
                offset: o
            };
        }
        return {
            line: void 0,
            column: void 0,
            offset: void 0
        };
    }
    function s(o) {
        var l = o && o.line, u = o && o.column, c;
        return typeof l == "number" && typeof u == "number" && !Number.isNaN(l) && !Number.isNaN(u) && l - 1 in n && (c = (n[l - 2] || 0) + u - 1 || 0), c > -1 && c < n[n.length - 1] ? c : -1;
    }
}
const $ef053115c0f9207e$var$l4 = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg",
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
}, $ef053115c0f9207e$var$sa = {}.hasOwnProperty, $ef053115c0f9207e$var$Os = {
    "#document": $ef053115c0f9207e$var$Rs,
    "#document-fragment": $ef053115c0f9207e$var$Rs,
    "#text": $ef053115c0f9207e$var$f4,
    "#comment": $ef053115c0f9207e$var$T4,
    "#documentType": $ef053115c0f9207e$var$h4
};
function $ef053115c0f9207e$var$u4(e, t = {}) {
    let n, r;
    return $ef053115c0f9207e$var$p4(t) ? (r = t, n = {}) : (r = t.file, n = t), $ef053115c0f9207e$var$Ir({
        schema: n.space === "svg" ? $ef053115c0f9207e$var$Nr : $ef053115c0f9207e$var$Sr,
        file: r,
        verbose: n.verbose,
        location: !1
    }, e);
}
function $ef053115c0f9207e$var$Ir(e, t) {
    const n = e.schema, r = $ef053115c0f9207e$var$sa.call($ef053115c0f9207e$var$Os, t.nodeName) ? $ef053115c0f9207e$var$Os[t.nodeName] : $ef053115c0f9207e$var$d4;
    let i;
    "tagName" in t && (e.schema = t.namespaceURI === $ef053115c0f9207e$var$l4.svg ? $ef053115c0f9207e$var$Nr : $ef053115c0f9207e$var$Sr), "childNodes" in t && (i = $ef053115c0f9207e$var$c4(e, t.childNodes));
    const s = r(e, t, i);
    if ("sourceCodeLocation" in t && t.sourceCodeLocation && e.file) {
        const o = $ef053115c0f9207e$var$m4(e, s, t.sourceCodeLocation);
        o && (e.location = !0, s.position = o);
    }
    return e.schema = n, s;
}
function $ef053115c0f9207e$var$c4(e, t) {
    let n = -1;
    const r = [];
    for(; ++n < t.length;)r[n] = $ef053115c0f9207e$var$Ir(e, t[n]);
    return r;
}
function $ef053115c0f9207e$var$Rs(e, t, n) {
    const r = {
        type: "root",
        children: n,
        data: {
            quirksMode: t.mode === "quirks" || t.mode === "limited-quirks"
        }
    };
    if (e.file && e.location) {
        const i = String(e.file), s = $ef053115c0f9207e$var$a4(i);
        r.position = {
            start: s.toPoint(0),
            end: s.toPoint(i.length)
        };
    }
    return r;
}
function $ef053115c0f9207e$var$h4() {
    return {
        type: "doctype"
    };
}
function $ef053115c0f9207e$var$f4(e, t) {
    return {
        type: "text",
        value: t.value
    };
}
function $ef053115c0f9207e$var$T4(e, t) {
    return {
        type: "comment",
        value: t.data
    };
}
function $ef053115c0f9207e$var$d4(e, t, n) {
    const r = e.schema.space === "svg" ? $ef053115c0f9207e$var$o4 : $ef053115c0f9207e$var$i4;
    let i = -1;
    const s = {};
    for(; ++i < t.attrs.length;){
        const l = t.attrs[i];
        s[(l.prefix ? l.prefix + ":" : "") + l.name] = l.value;
    }
    const o = r(t.tagName, s, n);
    if (o.tagName === "template" && "content" in t) {
        const l = t.sourceCodeLocation, u = l && l.startTag && $ef053115c0f9207e$var$K1(l.startTag), c = l && l.endTag && $ef053115c0f9207e$var$K1(l.endTag), h = $ef053115c0f9207e$var$Ir(e, t.content);
        u && c && e.file && (h.position = {
            start: u.end,
            end: c.start
        }), o.content = h;
    }
    return o;
}
function $ef053115c0f9207e$var$m4(e, t, n) {
    const r = $ef053115c0f9207e$var$K1(n);
    if (t.type === "element") {
        const i = t.children[t.children.length - 1];
        if (r && !n.endTag && i && i.position && i.position.end && (r.end = Object.assign({}, i.position.end)), e.verbose) {
            const s = {};
            let o;
            for(o in n.attrs)$ef053115c0f9207e$var$sa.call(n.attrs, o) && (s[$ef053115c0f9207e$var$ra(e.schema, o).property] = $ef053115c0f9207e$var$K1(n.attrs[o]));
            t.data = {
                position: {
                    opening: $ef053115c0f9207e$var$K1(n.startTag),
                    closing: n.endTag ? $ef053115c0f9207e$var$K1(n.endTag) : null,
                    properties: s
                }
            };
        }
    }
    return r;
}
function $ef053115c0f9207e$var$K1(e) {
    const t = $ef053115c0f9207e$var$xs({
        line: e.startLine,
        column: e.startCol,
        offset: e.startOffset
    }), n = $ef053115c0f9207e$var$xs({
        line: e.endLine,
        column: e.endCol,
        offset: e.endOffset
    });
    return t || n ? {
        start: t,
        end: n
    } : null;
}
function $ef053115c0f9207e$var$xs(e) {
    return e.line && e.column ? e : null;
}
function $ef053115c0f9207e$var$p4(e) {
    return "messages" in e;
}
const $ef053115c0f9207e$var$E4 = {
    abandonedHeadElementChild: {
        reason: "Unexpected metadata element after head",
        description: "Unexpected element after head. Expected the element before `</head>`",
        url: !1
    },
    abruptClosingOfEmptyComment: {
        reason: "Unexpected abruptly closed empty comment",
        description: "Unexpected `>` or `->`. Expected `-->` to close comments"
    },
    abruptDoctypePublicIdentifier: {
        reason: "Unexpected abruptly closed public identifier",
        description: "Unexpected `>`. Expected a closing `\"` or `'` after the public identifier"
    },
    abruptDoctypeSystemIdentifier: {
        reason: "Unexpected abruptly closed system identifier",
        description: "Unexpected `>`. Expected a closing `\"` or `'` after the identifier identifier"
    },
    absenceOfDigitsInNumericCharacterReference: {
        reason: "Unexpected non-digit at start of numeric character reference",
        description: "Unexpected `%c`. Expected `[0-9]` for decimal references or `[0-9a-fA-F]` for hexadecimal references"
    },
    cdataInHtmlContent: {
        reason: "Unexpected CDATA section in HTML",
        description: "Unexpected `<![CDATA[` in HTML. Remove it, use a comment, or encode special characters instead"
    },
    characterReferenceOutsideUnicodeRange: {
        reason: "Unexpected too big numeric character reference",
        description: "Unexpectedly high character reference. Expected character references to be at most hexadecimal 10ffff (or decimal 1114111)"
    },
    closingOfElementWithOpenChildElements: {
        reason: "Unexpected closing tag with open child elements",
        description: "Unexpectedly closing tag. Expected other tags to be closed first",
        url: !1
    },
    controlCharacterInInputStream: {
        reason: "Unexpected control character",
        description: "Unexpected control character `%x`. Expected a non-control code point, 0x00, or ASCII whitespace"
    },
    controlCharacterReference: {
        reason: "Unexpected control character reference",
        description: "Unexpectedly control character in reference. Expected a non-control code point, 0x00, or ASCII whitespace"
    },
    disallowedContentInNoscriptInHead: {
        reason: "Disallowed content inside `<noscript>` in `<head>`",
        description: "Unexpected text character `%c`. Only use text in `<noscript>`s in `<body>`",
        url: !1
    },
    duplicateAttribute: {
        reason: "Unexpected duplicate attribute",
        description: "Unexpectedly double attribute. Expected attributes to occur only once"
    },
    endTagWithAttributes: {
        reason: "Unexpected attribute on closing tag",
        description: "Unexpected attribute. Expected `>` instead"
    },
    endTagWithTrailingSolidus: {
        reason: "Unexpected slash at end of closing tag",
        description: "Unexpected `%c-1`. Expected `>` instead"
    },
    endTagWithoutMatchingOpenElement: {
        reason: "Unexpected unopened end tag",
        description: "Unexpected end tag. Expected no end tag or another end tag",
        url: !1
    },
    eofBeforeTagName: {
        reason: "Unexpected end of file",
        description: "Unexpected end of file. Expected tag name instead"
    },
    eofInCdata: {
        reason: "Unexpected end of file in CDATA",
        description: "Unexpected end of file. Expected `]]>` to close the CDATA"
    },
    eofInComment: {
        reason: "Unexpected end of file in comment",
        description: "Unexpected end of file. Expected `-->` to close the comment"
    },
    eofInDoctype: {
        reason: "Unexpected end of file in doctype",
        description: "Unexpected end of file. Expected a valid doctype (such as `<!doctype html>`)"
    },
    eofInElementThatCanContainOnlyText: {
        reason: "Unexpected end of file in element that can only contain text",
        description: "Unexpected end of file. Expected text or a closing tag",
        url: !1
    },
    eofInScriptHtmlCommentLikeText: {
        reason: "Unexpected end of file in comment inside script",
        description: "Unexpected end of file. Expected `-->` to close the comment"
    },
    eofInTag: {
        reason: "Unexpected end of file in tag",
        description: "Unexpected end of file. Expected `>` to close the tag"
    },
    incorrectlyClosedComment: {
        reason: "Incorrectly closed comment",
        description: "Unexpected `%c-1`. Expected `-->` to close the comment"
    },
    incorrectlyOpenedComment: {
        reason: "Incorrectly opened comment",
        description: "Unexpected `%c`. Expected `<!--` to open the comment"
    },
    invalidCharacterSequenceAfterDoctypeName: {
        reason: "Invalid sequence after doctype name",
        description: "Unexpected sequence at `%c`. Expected `public` or `system`"
    },
    invalidFirstCharacterOfTagName: {
        reason: "Invalid first character in tag name",
        description: "Unexpected `%c`. Expected an ASCII letter instead"
    },
    misplacedDoctype: {
        reason: "Misplaced doctype",
        description: "Unexpected doctype. Expected doctype before head",
        url: !1
    },
    misplacedStartTagForHeadElement: {
        reason: "Misplaced `<head>` start tag",
        description: "Unexpected start tag `<head>`. Expected `<head>` directly after doctype",
        url: !1
    },
    missingAttributeValue: {
        reason: "Missing attribute value",
        description: "Unexpected `%c-1`. Expected an attribute value or no `%c-1` instead"
    },
    missingDoctype: {
        reason: "Missing doctype before other content",
        description: "Expected a `<!doctype html>` before anything else",
        url: !1
    },
    missingDoctypeName: {
        reason: "Missing doctype name",
        description: "Unexpected doctype end at `%c`. Expected `html` instead"
    },
    missingDoctypePublicIdentifier: {
        reason: "Missing public identifier in doctype",
        description: "Unexpected `%c`. Expected identifier for `public` instead"
    },
    missingDoctypeSystemIdentifier: {
        reason: "Missing system identifier in doctype",
        description: 'Unexpected `%c`. Expected identifier for `system` instead (suggested: `"about:legacy-compat"`)'
    },
    missingEndTagName: {
        reason: "Missing name in end tag",
        description: "Unexpected `%c`. Expected an ASCII letter instead"
    },
    missingQuoteBeforeDoctypePublicIdentifier: {
        reason: "Missing quote before public identifier in doctype",
        description: "Unexpected `%c`. Expected `\"` or `'` instead"
    },
    missingQuoteBeforeDoctypeSystemIdentifier: {
        reason: "Missing quote before system identifier in doctype",
        description: "Unexpected `%c`. Expected `\"` or `'` instead"
    },
    missingSemicolonAfterCharacterReference: {
        reason: "Missing semicolon after character reference",
        description: "Unexpected `%c`. Expected `;` instead"
    },
    missingWhitespaceAfterDoctypePublicKeyword: {
        reason: "Missing whitespace after public identifier in doctype",
        description: "Unexpected `%c`. Expected ASCII whitespace instead"
    },
    missingWhitespaceAfterDoctypeSystemKeyword: {
        reason: "Missing whitespace after system identifier in doctype",
        description: "Unexpected `%c`. Expected ASCII whitespace instead"
    },
    missingWhitespaceBeforeDoctypeName: {
        reason: "Missing whitespace before doctype name",
        description: "Unexpected `%c`. Expected ASCII whitespace instead"
    },
    missingWhitespaceBetweenAttributes: {
        reason: "Missing whitespace between attributes",
        description: "Unexpected `%c`. Expected ASCII whitespace instead"
    },
    missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers: {
        reason: "Missing whitespace between public and system identifiers in doctype",
        description: "Unexpected `%c`. Expected ASCII whitespace instead"
    },
    nestedComment: {
        reason: "Unexpected nested comment",
        description: "Unexpected `<!--`. Expected `-->`"
    },
    nestedNoscriptInHead: {
        reason: "Unexpected nested `<noscript>` in `<head>`",
        description: "Unexpected `<noscript>`. Expected a closing tag or a meta element",
        url: !1
    },
    nonConformingDoctype: {
        reason: "Unexpected non-conforming doctype declaration",
        description: 'Expected `<!doctype html>` or `<!doctype html system "about:legacy-compat">`',
        url: !1
    },
    nonVoidHtmlElementStartTagWithTrailingSolidus: {
        reason: "Unexpected trailing slash on start tag of non-void element",
        description: "Unexpected `/`. Expected `>` instead"
    },
    noncharacterCharacterReference: {
        reason: "Unexpected noncharacter code point referenced by character reference",
        description: "Unexpected code point. Do not use noncharacters in HTML"
    },
    noncharacterInInputStream: {
        reason: "Unexpected noncharacter character",
        description: "Unexpected code point `%x`. Do not use noncharacters in HTML"
    },
    nullCharacterReference: {
        reason: "Unexpected NULL character referenced by character reference",
        description: "Unexpected code point. Do not use NULL characters in HTML"
    },
    openElementsLeftAfterEof: {
        reason: "Unexpected end of file",
        description: "Unexpected end of file. Expected closing tag instead",
        url: !1
    },
    surrogateCharacterReference: {
        reason: "Unexpected surrogate character referenced by character reference",
        description: "Unexpected code point. Do not use lone surrogate characters in HTML"
    },
    surrogateInInputStream: {
        reason: "Unexpected surrogate character",
        description: "Unexpected code point `%x`. Do not use lone surrogate characters in HTML"
    },
    unexpectedCharacterAfterDoctypeSystemIdentifier: {
        reason: "Invalid character after system identifier in doctype",
        description: "Unexpected character at `%c`. Expected `>`"
    },
    unexpectedCharacterInAttributeName: {
        reason: "Unexpected character in attribute name",
        description: "Unexpected `%c`. Expected whitespace, `/`, `>`, `=`, or probably an ASCII letter"
    },
    unexpectedCharacterInUnquotedAttributeValue: {
        reason: "Unexpected character in unquoted attribute value",
        description: "Unexpected `%c`. Quote the attribute value to include it"
    },
    unexpectedEqualsSignBeforeAttributeName: {
        reason: "Unexpected equals sign before attribute name",
        description: "Unexpected `%c`. Add an attribute name before it"
    },
    unexpectedNullCharacter: {
        reason: "Unexpected NULL character",
        description: "Unexpected code point `%x`. Do not use NULL characters in HTML"
    },
    unexpectedQuestionMarkInsteadOfTagName: {
        reason: "Unexpected question mark instead of tag name",
        description: "Unexpected `%c`. Expected an ASCII letter instead"
    },
    unexpectedSolidusInTag: {
        reason: "Unexpected slash in tag",
        description: "Unexpected `%c-1`. Expected it followed by `>` or in a quoted attribute value"
    },
    unknownNamedCharacterReference: {
        reason: "Unexpected unknown named character reference",
        description: "Unexpected character reference. Expected known named character references"
    }
}, $ef053115c0f9207e$var$_4 = "https://html.spec.whatwg.org/multipage/parsing.html#parse-error-", $ef053115c0f9207e$var$g4 = {
    2: !0,
    1: !1,
    0: null
};
function $ef053115c0f9207e$var$oa(e) {
    const t = /** @type {Options} */ this.data("settings"), n = Object.assign({}, t, e);
    Object.assign(this, {
        Parser: r
    });
    function r(i, s) {
        const o = n.fragment ? "parseFragment" : "parse", l = n.emitParseErrors ? c : null, u = new $ef053115c0f9207e$var$z5({
            sourceCodeLocationInfo: !0,
            onParseError: l,
            scriptingEnabled: !1
        });
        return $ef053115c0f9207e$var$u4(u[o](i), {
            space: n.space,
            file: s,
            verbose: n.verbose
        });
        function c(h) {
            const p = h.code, _ = $ef053115c0f9207e$var$A4(p), E = n[_], S = E ?? !0, R = typeof S == "number" ? S : S ? 1 : 0, b = {
                line: h.startLine,
                column: h.startCol,
                offset: h.startOffset
            }, N = {
                line: h.endLine,
                column: h.endCol,
                offset: h.endOffset
            };
            if (R) {
                const k = $ef053115c0f9207e$var$E4[_] || {
                    reason: "",
                    description: "",
                    url: ""
                }, v = s.message(U(k.reason), {
                    start: b,
                    end: N
                });
                v.source = "parse-error", v.ruleId = p, v.fatal = $ef053115c0f9207e$var$g4[R], v.note = U(k.description), v.url = "url" in k && k.url === !1 ? null : $ef053115c0f9207e$var$_4 + p;
            }
            function U(k) {
                return k.replace(/%c(?:-(\d+))?/g, (v, K)=>{
                    const A = K ? -Number.parseInt(K, 10) : 0, F = i.charAt(h.startOffset + A);
                    return F === "`" ? "` ` `" : F;
                }).replace(/%x/g, ()=>"0x" + i.charCodeAt(h.startOffset).toString(16).toUpperCase());
            }
        }
    }
}
function $ef053115c0f9207e$var$A4(e) {
    return e.replace(/-[a-z]/g, (t)=>t.charAt(1).toUpperCase());
}
const $ef053115c0f9207e$var$cn = /**
   * Check if a node is an element and passes a test.
   * When a `parent` node is known the `index` of node should also be given.
   *
   * @type {(
   *   (() => false) &
   *   (<T extends Element = Element>(node: unknown, test?: PredicateTest<T>, index?: number, parent?: Parent, context?: unknown) => node is T) &
   *   ((node: unknown, test: Test, index?: number, parent?: Parent, context?: unknown) => boolean)
   * )}
   */ /**
   * Check if a node passes a test.
   * When a `parent` node is known the `index` of node should also be given.
   *
   * @param {unknown} [node] Node to check
   * @param {Test} [test] When nullish, checks if `node` is a `Node`.
   * When `string`, works like passing `function (node) {return node.type === test}`.
   * When `function` checks if function passed the node is true.
   * When `array`, checks any one of the subtests pass.
   * @param {number} [index] Position of `node` in `parent`
   * @param {Parent} [parent] Parent of `node`
   * @param {unknown} [context] Context object to invoke `test` with
   * @returns {boolean} Whether test passed and `node` is an `Element` (object with `type` set to `element` and `tagName` set to a non-empty string).
   */ // eslint-disable-next-line max-params
function(e, t, n, r, i) {
    const s = $ef053115c0f9207e$var$ee(t);
    if (n != null && (typeof n != "number" || n < 0 || n === Number.POSITIVE_INFINITY)) throw new Error("Expected positive finite index for child node");
    if (r != null && (!r.type || !r.children)) throw new Error("Expected parent node");
    if (!e || !e.type || typeof e.type != "string") return !1;
    if (r == null != (n == null)) throw new Error("Expected both parent and index");
    return s.call(i, e, n, r);
}, $ef053115c0f9207e$var$ee = /**
   * @type {(
   *   (<T extends Element>(test: T['tagName']|TestFunctionPredicate<T>) => AssertPredicate<T>) &
   *   ((test?: Test) => AssertAnything)
   * )}
   */ /**
   * Generate an assertion from a check.
   * @param {Test} [test]
   * When nullish, checks if `node` is a `Node`.
   * When `string`, works like passing `function (node) {return node.type === test}`.
   * When `function` checks if function passed the node is true.
   * When `object`, checks that all keys in test are in node, and that they have (strictly) equal values.
   * When `array`, checks any one of the subtests pass.
   * @returns {AssertAnything}
   */ function(e) {
    if (e == null) return $ef053115c0f9207e$var$Or;
    if (typeof e == "string") return $ef053115c0f9207e$var$S4(e);
    if (typeof e == "object") return $ef053115c0f9207e$var$C4(e);
    if (typeof e == "function") return $ef053115c0f9207e$var$aa(e);
    throw new Error("Expected function, string, or array as test");
};
function $ef053115c0f9207e$var$C4(e) {
    const t = [];
    let n = -1;
    for(; ++n < e.length;)t[n] = $ef053115c0f9207e$var$ee(e[n]);
    return $ef053115c0f9207e$var$aa(r);
    function r(...i) {
        let s = -1;
        for(; ++s < t.length;)if (t[s].call(this, ...i)) return !0;
        return !1;
    }
}
function $ef053115c0f9207e$var$S4(e) {
    return t;
    function t(n) {
        return $ef053115c0f9207e$var$Or(n) && n.tagName === e;
    }
}
function $ef053115c0f9207e$var$aa(e) {
    return t;
    function t(n, ...r) {
        return $ef053115c0f9207e$var$Or(n) && !!e.call(this, n, ...r);
    }
}
function $ef053115c0f9207e$var$Or(e) {
    return !!(e && typeof e == "object" && // @ts-expect-error Looks like a node.
    e.type === "element" && // @ts-expect-error Looks like an element.
    typeof e.tagName == "string");
}
const $ef053115c0f9207e$var$la = $ef053115c0f9207e$var$ee([
    "audio",
    "canvas",
    "embed",
    "iframe",
    "img",
    "math",
    "object",
    "picture",
    "svg",
    "video"
]);
function $ef053115c0f9207e$var$N4(e) {
    var t = // @ts-ignore looks like a node.
    e && typeof e == "object" && e.type === "text" ? // @ts-ignore looks like a text.
    e.value || "" : e;
    return typeof t == "string" && t.replace(/[ \t\n\f\r]/g, "") === "";
}
const $ef053115c0f9207e$var$I4 = [
    "address",
    // Flow content.
    "article",
    // Sections and headings.
    "aside",
    // Sections and headings.
    "blockquote",
    // Flow content.
    "body",
    // Page.
    "br",
    // Contribute whitespace intrinsically.
    "caption",
    // Similar to block.
    "center",
    // Flow content, legacy.
    "col",
    // Similar to block.
    "colgroup",
    // Similar to block.
    "dd",
    // Lists.
    "dialog",
    // Flow content.
    "dir",
    // Lists, legacy.
    "div",
    // Flow content.
    "dl",
    // Lists.
    "dt",
    // Lists.
    "figcaption",
    // Flow content.
    "figure",
    // Flow content.
    "footer",
    // Flow content.
    "form",
    // Flow content.
    "h1",
    // Sections and headings.
    "h2",
    // Sections and headings.
    "h3",
    // Sections and headings.
    "h4",
    // Sections and headings.
    "h5",
    // Sections and headings.
    "h6",
    // Sections and headings.
    "head",
    // Page.
    "header",
    // Flow content.
    "hgroup",
    // Sections and headings.
    "hr",
    // Flow content.
    "html",
    // Page.
    "legend",
    // Flow content.
    "li",
    // Block-like.
    "li",
    // Similar to block.
    "listing",
    // Flow content, legacy
    "main",
    // Flow content.
    "menu",
    // Lists.
    "nav",
    // Sections and headings.
    "ol",
    // Lists.
    "optgroup",
    // Similar to block.
    "option",
    // Similar to block.
    "p",
    // Flow content.
    "plaintext",
    // Flow content, legacy
    "pre",
    // Flow content.
    "section",
    // Sections and headings.
    "summary",
    // Similar to block.
    "table",
    // Similar to block.
    "tbody",
    // Similar to block.
    "td",
    // Block-like.
    "td",
    // Similar to block.
    "tfoot",
    // Similar to block.
    "th",
    // Block-like.
    "th",
    // Similar to block.
    "thead",
    // Similar to block.
    "tr",
    // Similar to block.
    "ul",
    // Lists.
    "wbr",
    // Contribute whitespace intrinsically.
    "xmp"
], $ef053115c0f9207e$var$O4 = [
    // Form.
    "button",
    "input",
    "select",
    "textarea"
], $ef053115c0f9207e$var$R4 = [
    "area",
    "base",
    "basefont",
    "dialog",
    "datalist",
    "head",
    "link",
    "meta",
    "noembed",
    "noframes",
    "param",
    "rp",
    "script",
    "source",
    "style",
    "template",
    "track",
    "title"
], $ef053115c0f9207e$var$Rr = $ef053115c0f9207e$var$j1([
    "doctype",
    "comment"
]);
function $ef053115c0f9207e$var$x4(e = {}) {
    const t = $ef053115c0f9207e$var$D4(e.newlines ? $ef053115c0f9207e$var$b4 : $ef053115c0f9207e$var$P4);
    return (n)=>{
        $ef053115c0f9207e$var$ua(n, {
            collapse: t,
            whitespace: "normal"
        });
    };
}
function $ef053115c0f9207e$var$ua(e, t) {
    if ("children" in e) {
        const n = Object.assign({}, t);
        return (e.type === "root" || $ef053115c0f9207e$var$fa(e)) && (n.before = !0, n.after = !0), n.whitespace = $ef053115c0f9207e$var$w4(e, t), $ef053115c0f9207e$var$k4(e, n);
    }
    if (e.type === "text") {
        if (t.whitespace === "normal") return $ef053115c0f9207e$var$y4(e, t);
        t.whitespace === "nowrap" && (e.value = t.collapse(e.value));
    }
    return {
        remove: !1,
        ignore: $ef053115c0f9207e$var$Rr(e),
        stripAtStart: !1
    };
}
function $ef053115c0f9207e$var$y4(e, t) {
    const n = t.collapse(e.value), r = {
        remove: !1,
        ignore: !1,
        stripAtStart: !1
    };
    let i = 0, s = n.length;
    return t.before && $ef053115c0f9207e$var$ys(n.charAt(0)) && i++, i !== s && $ef053115c0f9207e$var$ys(n.charAt(s - 1)) && (t.after ? s-- : r.stripAtStart = !0), i === s ? r.remove = !0 : e.value = n.slice(i, s), r;
}
function $ef053115c0f9207e$var$k4(e, t) {
    let n = t.before;
    const r = t.after, i = e.children;
    let s = i.length, o = -1;
    for(; ++o < s;){
        const l = $ef053115c0f9207e$var$ua(i[o], Object.assign({}, t, {
            before: n,
            after: $ef053115c0f9207e$var$ca(i, o, r)
        }));
        l.remove ? (i.splice(o, 1), o--, s--) : l.ignore || (n = l.stripAtStart), $ef053115c0f9207e$var$ha(i[o]) && (n = !1);
    }
    return {
        remove: !1,
        ignore: !1,
        stripAtStart: !!(n || r)
    };
}
function $ef053115c0f9207e$var$ca(e, t, n) {
    for(; ++t < e.length;){
        const r = e[t];
        let i = $ef053115c0f9207e$var$L4(r);
        if (i === void 0 && "children" in r && !$ef053115c0f9207e$var$M4(r) && (i = $ef053115c0f9207e$var$ca(r.children, -1)), typeof i == "boolean") return i;
    }
    return n;
}
function $ef053115c0f9207e$var$L4(e) {
    if (e.type === "element") {
        if ($ef053115c0f9207e$var$ha(e)) return !1;
        if ($ef053115c0f9207e$var$fa(e)) return !0;
    } else if (e.type === "text") {
        if (!$ef053115c0f9207e$var$N4(e)) return !1;
    } else if (!$ef053115c0f9207e$var$Rr(e)) return !1;
}
function $ef053115c0f9207e$var$ha(e) {
    return $ef053115c0f9207e$var$la(e) || $ef053115c0f9207e$var$cn(e, $ef053115c0f9207e$var$O4);
}
function $ef053115c0f9207e$var$fa(e) {
    return $ef053115c0f9207e$var$cn(e, $ef053115c0f9207e$var$I4);
}
function $ef053115c0f9207e$var$M4(e) {
    return !!("properties" in e && e.properties && e.properties.hidden) || $ef053115c0f9207e$var$Rr(e) || $ef053115c0f9207e$var$cn(e, $ef053115c0f9207e$var$R4);
}
function $ef053115c0f9207e$var$ys(e) {
    return e === " " || e === `
`;
}
function $ef053115c0f9207e$var$b4(e) {
    const t = /\r?\n|\r/.exec(e);
    return t ? t[0] : " ";
}
function $ef053115c0f9207e$var$P4() {
    return " ";
}
function $ef053115c0f9207e$var$D4(e) {
    return t;
    function t(n) {
        return String(n).replace(/[\t\n\v\f\r ]+/g, e);
    }
}
function $ef053115c0f9207e$var$w4(e, t) {
    if ("tagName" in e && e.properties) switch(e.tagName){
        case "listing":
        case "plaintext":
        case "script":
        case "style":
        case "xmp":
            return "pre";
        case "nobr":
            return "nowrap";
        case "pre":
            return e.properties.wrap ? "pre-wrap" : "pre";
        case "td":
        case "th":
            return e.properties.noWrap ? "nowrap" : t.whitespace;
        case "textarea":
            return "pre-wrap";
    }
    return t.whitespace;
}
function $ef053115c0f9207e$var$D(e, t) {
    const n = t.children || [], r = [];
    let i = -1, s = n.length, o = n[i + 1];
    for(; o && o.type === "element" && o.tagName === "br";)i++, o = n[i + 1];
    for(o = n[s - 1]; s - 1 > i && o && o.type === "element" && o.tagName === "br";)s--, o = n[s - 1];
    for(; ++i < s;){
        const l = $ef053115c0f9207e$var$Ta(e, n[i], t);
        Array.isArray(l) ? r.push(...l) : l && r.push(l);
    }
    return r;
}
const $ef053115c0f9207e$var$Xt = {}.hasOwnProperty;
function $ef053115c0f9207e$var$Ae(e, t) {
    return e.wrapText ? t : t.replace(/\r?\n|\r/g, " ");
}
function $ef053115c0f9207e$var$Ta(e, t, n) {
    let r;
    if (t.type === "element") {
        if (t.properties && t.properties.dataMdast === "ignore") return;
        $ef053115c0f9207e$var$Xt.call(e.handlers, t.tagName) && (r = e.handlers[t.tagName]);
    } else $ef053115c0f9207e$var$Xt.call(e.handlers, t.type) && (r = e.handlers[t.type]);
    return typeof r == "function" ? r(e, t, n) : $ef053115c0f9207e$var$F4(e, t);
}
function $ef053115c0f9207e$var$F4(e, t) {
    return typeof t.value == "string" ? e(t, "text", $ef053115c0f9207e$var$Ae(e, t.value)) : $ef053115c0f9207e$var$D(e, t);
}
var $ef053115c0f9207e$var$H4 = {}.hasOwnProperty;
function $ef053115c0f9207e$var$At(e, t) {
    var n = t && e && typeof e == "object" && // @ts-ignore Looks like a node.
    e.type === "element" && // @ts-ignore Looks like an element.
    e.properties && // @ts-ignore Looks like an element.
    $ef053115c0f9207e$var$H4.call(e.properties, t) && // @ts-ignore Looks like an element.
    e.properties[t];
    return n != null && n !== !1;
}
const $ef053115c0f9207e$var$B4 = /* @__PURE__ */ new Set([
    "pingback",
    "prefetch",
    "stylesheet"
]);
function $ef053115c0f9207e$var$U4(e) {
    if (!$ef053115c0f9207e$var$cn(e, "link")) return !1;
    if ($ef053115c0f9207e$var$At(e, "itemProp")) return !0;
    const n = (e.properties || {}).rel || [];
    let r = -1;
    if (!Array.isArray(n) || n.length === 0) return !1;
    for(; ++r < n.length;)if (!$ef053115c0f9207e$var$B4.has(String(n[r]))) return !1;
    return !0;
}
const $ef053115c0f9207e$var$v4 = $ef053115c0f9207e$var$ee([
    "a",
    "abbr",
    // `area` is in fact only phrasing if it is inside a `map` element.
    // However, since `area`s are required to be inside a `map` element, and it’s
    // a rather involved check, it’s ignored here for now.
    "area",
    "b",
    "bdi",
    "bdo",
    "br",
    "button",
    "cite",
    "code",
    "data",
    "datalist",
    "del",
    "dfn",
    "em",
    "i",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "map",
    "mark",
    "meter",
    "noscript",
    "output",
    "progress",
    "q",
    "ruby",
    "s",
    "samp",
    "script",
    "select",
    "small",
    "span",
    "strong",
    "sub",
    "sup",
    "template",
    "textarea",
    "time",
    "u",
    "var",
    "wbr"
]), $ef053115c0f9207e$var$G4 = $ef053115c0f9207e$var$ee("meta");
function $ef053115c0f9207e$var$K4(e) {
    return !!(e && e.type === "text" || $ef053115c0f9207e$var$v4(e) || $ef053115c0f9207e$var$la(e) || // @ts-expect-error Looks like a node.
    $ef053115c0f9207e$var$U4(e) || $ef053115c0f9207e$var$G4(e) && $ef053115c0f9207e$var$At(e, "itemProp"));
}
const $ef053115c0f9207e$var$z4 = $ef053115c0f9207e$var$j1([
    "break",
    "delete",
    "emphasis",
    "footnote",
    "footnoteReference",
    "image",
    "imageReference",
    "inlineCode",
    "link",
    "linkReference",
    "strong",
    "text"
]);
function $ef053115c0f9207e$var$da(e) {
    return $ef053115c0f9207e$var$ma(e, t);
    function t(n) {
        const r = n[0];
        return n.length === 1 && r.type === "text" && (r.value === " " || r.value === `
`) ? [] : {
            type: "paragraph",
            children: n
        };
    }
}
function $ef053115c0f9207e$var$hn(e) {
    let t = -1, n;
    for(; ++t < e.length;)if (n = e[t], !$ef053115c0f9207e$var$pa(n) || "children" in n && $ef053115c0f9207e$var$hn(n.children)) return !0;
    return !1;
}
function $ef053115c0f9207e$var$ma(e, t, n) {
    const r = n || $ef053115c0f9207e$var$$4, i = $ef053115c0f9207e$var$Y4(e);
    let s = [], o = -1, l, u;
    for(; ++o < i.length;)u = i[o], $ef053115c0f9207e$var$pa(u) ? (l || (l = []), l.push(u)) : (l && (s = s.concat(t(l)), l = void 0), s = s.concat(r(u)));
    return l && (s = s.concat(t(l))), s;
}
function $ef053115c0f9207e$var$Y4(e) {
    let t = [], n = -1, r;
    for(; ++n < e.length;)r = e[n], (r.type === "delete" || r.type === "link") && $ef053115c0f9207e$var$hn(r.children) ? t = t.concat($ef053115c0f9207e$var$j4(r)) : t.push(r);
    return t;
}
function $ef053115c0f9207e$var$j4(e) {
    return $ef053115c0f9207e$var$ma(e.children, n, t);
    function t(r) {
        if ("children" in r && "children" in e) {
            const { children: i, ...s } = e;
            return {
                ...r,
                // @ts-expect-error: assume matching parent & child.
                children: [
                    {
                        ...$ef053115c0f9207e$var$jt(!0, {}, s),
                        children: r.children
                    }
                ]
            };
        }
        return {
            ...r
        };
    }
    function n(r) {
        const { children: i, ...s } = e;
        return {
            ...$ef053115c0f9207e$var$jt(!0, {}, s),
            children: r
        };
    }
}
function $ef053115c0f9207e$var$pa(e) {
    return e.data && e.data.hName ? $ef053115c0f9207e$var$K4({
        type: "element",
        tagName: e.data.hName,
        properties: {},
        children: []
    }) : $ef053115c0f9207e$var$z4(e);
}
function $ef053115c0f9207e$var$$4(e) {
    return e;
}
function $ef053115c0f9207e$var$se(e, t) {
    return $ef053115c0f9207e$var$da($ef053115c0f9207e$var$D(e, t));
}
function $ef053115c0f9207e$var$R1(e, t) {
    return t == null ? "" : e.frozenBaseUrl ? String(new URL(t, e.frozenBaseUrl)) : t;
}
function $ef053115c0f9207e$var$Q4(e, t) {
    const n = t.properties;
    return e(t, "link", {
        title: n.title || null,
        url: $ef053115c0f9207e$var$R1(e, String(n.href || "") || null)
    }, $ef053115c0f9207e$var$D(e, t));
}
function $ef053115c0f9207e$var$W4(e, t) {
    e.baseFound || (e.frozenBaseUrl = String(t.properties && t.properties.href || "") || null, e.baseFound = !0);
}
function $ef053115c0f9207e$var$q4(e, t) {
    return e(t, "blockquote", $ef053115c0f9207e$var$se(e, t));
}
function $ef053115c0f9207e$var$V4(e, t) {
    return e.wrapText ? e(t, "break") : e(t, "text", " ");
}
var $ef053115c0f9207e$var$ks = /**
   * @type {(
   *  (<T extends Node>(node: Parent, index: Node|number, test: T['type']|Partial<T>|import('unist-util-is').TestFunctionPredicate<T>|Array.<T['type']|Partial<T>|import('unist-util-is').TestFunctionPredicate<T>>) => T|null) &
   *  ((node: Parent, index: Node|number, test?: null|undefined|Type|Props|TestFunctionAnything|Array<Type|Props|TestFunctionAnything>) => Node|null)
   * )}
   */ /**
   * @param {Parent} parent Parent node
   * @param {Node|number} index Child of `parent`, or it’s index
   * @param {null|undefined|Type|Props|TestFunctionAnything|Array<Type|Props|TestFunctionAnything>} [test] is-compatible test (such as a type)
   * @returns {Node|null}
   */ function(e, t, n) {
    var r = $ef053115c0f9207e$var$j1(n);
    if (!e || !e.type || !e.children) throw new Error("Expected parent node");
    if (typeof t == "number") {
        if (t < 0 || t === Number.POSITIVE_INFINITY) throw new Error("Expected positive finite number as index");
    } else if (t = e.children.indexOf(t), t < 0) throw new Error("Expected child node or index");
    for(; ++t < e.children.length;)if (r(e.children[t], t, e)) return e.children[t];
    return null;
};
const $ef053115c0f9207e$var$Ls = /\n/g, $ef053115c0f9207e$var$Ms = /[\t ]+/g, $ef053115c0f9207e$var$er = $ef053115c0f9207e$var$ee("br"), $ef053115c0f9207e$var$X4 = $ef053115c0f9207e$var$ee("p"), $ef053115c0f9207e$var$bs = $ef053115c0f9207e$var$ee([
    "th",
    "td"
]), $ef053115c0f9207e$var$Ps = $ef053115c0f9207e$var$ee("tr"), $ef053115c0f9207e$var$J4 = $ef053115c0f9207e$var$ee([
    // List from: <https://html.spec.whatwg.org/#hidden-elements>
    "datalist",
    "head",
    "noembed",
    "noframes",
    "noscript",
    // Act as if we support scripting.
    "rp",
    "script",
    "style",
    "template",
    "title",
    // Hidden attribute.
    $ef053115c0f9207e$var$nh,
    // From: <https://html.spec.whatwg.org/#flow-content-3>
    $ef053115c0f9207e$var$rh
]), $ef053115c0f9207e$var$Ea = $ef053115c0f9207e$var$ee([
    "address",
    // Flow content
    "article",
    // Sections and headings
    "aside",
    // Sections and headings
    "blockquote",
    // Flow content
    "body",
    // Page
    "caption",
    // `table-caption`
    "center",
    // Flow content (legacy)
    "dd",
    // Lists
    "dialog",
    // Flow content
    "dir",
    // Lists (legacy)
    "dl",
    // Lists
    "dt",
    // Lists
    "div",
    // Flow content
    "figure",
    // Flow content
    "figcaption",
    // Flow content
    "footer",
    // Flow content
    "form,",
    // Flow content
    "h1",
    // Sections and headings
    "h2",
    // Sections and headings
    "h3",
    // Sections and headings
    "h4",
    // Sections and headings
    "h5",
    // Sections and headings
    "h6",
    // Sections and headings
    "header",
    // Flow content
    "hgroup",
    // Sections and headings
    "hr",
    // Flow content
    "html",
    // Page
    "legend",
    // Flow content
    "listing",
    // Flow content (legacy)
    "main",
    // Flow content
    "menu",
    // Lists
    "nav",
    // Sections and headings
    "ol",
    // Lists
    "p",
    // Flow content
    "plaintext",
    // Flow content (legacy)
    "pre",
    // Flow content
    "section",
    // Sections and headings
    "ul",
    // Lists
    "xmp"
]);
function $ef053115c0f9207e$var$Ct(e, t = {}) {
    const n = e.children || [], r = $ef053115c0f9207e$var$Ea(e), i = $ef053115c0f9207e$var$Aa(e, {
        whitespace: t.whitespace || "normal",
        breakBefore: !1,
        breakAfter: !1
    });
    let s = -1, o, l, u;
    if (e.type === "text" || e.type === "comment") return $ef053115c0f9207e$var$ga(e, {
        whitespace: i,
        breakBefore: !0,
        breakAfter: !0
    });
    for(o = []; ++s < n.length;)o = o.concat(// @ts-ignore Looks like a parent.
    $ef053115c0f9207e$var$_a(n[s], e, {
        whitespace: i,
        breakBefore: s ? null : r,
        breakAfter: s < n.length - 1 ? $ef053115c0f9207e$var$er(n[s + 1]) : r
    }));
    s = -1;
    const c = [];
    for(; ++s < o.length;)l = o[s], typeof l == "number" ? u !== void 0 && l > u && (u = l) : l && (u && c.push(`
`.repeat(u)), u = 0, c.push(l));
    return c.join("");
}
function $ef053115c0f9207e$var$_a(e, t, n) {
    return e.type === "element" ? $ef053115c0f9207e$var$Z4(e, t, n) : e.type === "text" ? [
        n.whitespace === "normal" ? $ef053115c0f9207e$var$ga(e, n) : $ef053115c0f9207e$var$eh(e)
    ] : [];
}
function $ef053115c0f9207e$var$Z4(e, t, n) {
    const r = $ef053115c0f9207e$var$Aa(e, n), i = e.children || [];
    let s = -1, o = [], l, u;
    if ($ef053115c0f9207e$var$J4(e)) return o;
    for($ef053115c0f9207e$var$er(e) || $ef053115c0f9207e$var$Ps(e) && $ef053115c0f9207e$var$ks(t, e, $ef053115c0f9207e$var$Ps) ? u = `
` : $ef053115c0f9207e$var$X4(e) ? (l = 2, u = 2) : $ef053115c0f9207e$var$Ea(e) && (l = 1, u = 1); ++s < i.length;)o = o.concat($ef053115c0f9207e$var$_a(i[s], e, {
        whitespace: r,
        breakBefore: s ? void 0 : l,
        breakAfter: s < i.length - 1 ? $ef053115c0f9207e$var$er(i[s + 1]) : u
    }));
    return $ef053115c0f9207e$var$bs(e) && $ef053115c0f9207e$var$ks(t, e, $ef053115c0f9207e$var$bs) && o.push("	"), l && o.unshift(l), u && o.push(u), o;
}
function $ef053115c0f9207e$var$ga(e, t) {
    const n = String(e.value), r = [], i = [];
    let s = 0, o = -1, l, u, c;
    for(; s < n.length;)$ef053115c0f9207e$var$Ls.lastIndex = s, l = $ef053115c0f9207e$var$Ls.exec(n), u = l ? l.index : n.length, r.push(// Any sequence of collapsible spaces and tabs immediately preceding or
    // following a segment break is removed.
    $ef053115c0f9207e$var$th(// [...] ignoring bidi formatting characters (characters with the
    // Bidi_Control property [UAX9]: ALM, LTR, RTL, LRE-RLO, LRI-PDI) as if
    // they were not there.
    n.slice(s, u).replace(/[\u061C\u200E\u200F\u202A-\u202E\u2066-\u2069]/g, ""), t.breakBefore, t.breakAfter)), s = u + 1;
    for(; ++o < r.length;)r[o].charCodeAt(r[o].length - 1) === 8203 || o < r.length - 1 && r[o + 1].charCodeAt(0) === 8203 ? (i.push(r[o]), c = "") : r[o] && (c && i.push(c), i.push(r[o]), c = " ");
    return i.join("");
}
function $ef053115c0f9207e$var$eh(e) {
    return String(e.value);
}
function $ef053115c0f9207e$var$th(e, t, n) {
    const r = [];
    let i = 0, s, o;
    for(; i < e.length;)$ef053115c0f9207e$var$Ms.lastIndex = i, s = $ef053115c0f9207e$var$Ms.exec(e), o = s ? s.index : e.length, !i && !o && s && !t && r.push(""), i !== o && r.push(e.slice(i, o)), i = s ? o + s[0].length : o;
    return i !== o && !n && r.push(""), r.join(" ");
}
function $ef053115c0f9207e$var$Aa(e, t) {
    let n;
    if (e.type === "element") switch(n = e.properties || {}, e.tagName){
        case "listing":
        case "plaintext":
        case "xmp":
            return "pre";
        case "nobr":
            return "nowrap";
        case "pre":
            return n.wrap ? "pre-wrap" : "pre";
        case "td":
        case "th":
            return n.noWrap ? "nowrap" : t.whitespace;
        case "textarea":
            return "pre-wrap";
    }
    return t.whitespace;
}
function $ef053115c0f9207e$var$nh(e) {
    return !!(e.properties || {}).hidden;
}
function $ef053115c0f9207e$var$rh(e) {
    return e.tagName === "dialog" && !(e.properties || {}).open;
}
function $ef053115c0f9207e$var$ih(e) {
    return String(e).replace(/\n+$/, "");
}
const $ef053115c0f9207e$var$Un = "language-", $ef053115c0f9207e$var$sh = $ef053115c0f9207e$var$ee("pre"), $ef053115c0f9207e$var$oh = $ef053115c0f9207e$var$ee("code");
function $ef053115c0f9207e$var$Ht(e, t) {
    const n = t.children;
    let r = -1, i, s;
    if ($ef053115c0f9207e$var$sh(t)) for(; ++r < n.length;){
        const o = n[r];
        if ($ef053115c0f9207e$var$oh(o) && o.properties && o.properties.className && Array.isArray(o.properties.className)) {
            i = o.properties.className;
            break;
        }
    }
    if (i) {
        for(r = -1; ++r < i.length;)if (String(i[r]).slice(0, $ef053115c0f9207e$var$Un.length) === $ef053115c0f9207e$var$Un) {
            s = String(i[r]).slice($ef053115c0f9207e$var$Un.length);
            break;
        }
    }
    return e(t, "code", {
        lang: s || null,
        meta: null
    }, $ef053115c0f9207e$var$ih($ef053115c0f9207e$var$Ae(e, $ef053115c0f9207e$var$Ct(t))));
}
function $ef053115c0f9207e$var$ah(e, t) {
    return e(t, "html", "<!--" + $ef053115c0f9207e$var$Ae(e, t.value) + "-->");
}
function $ef053115c0f9207e$var$vn(e, t) {
    return e(t, "delete", $ef053115c0f9207e$var$D(e, t));
}
function $ef053115c0f9207e$var$xr(e) {
    let t = -1;
    if (e.length > 1) {
        for(; ++t < e.length;)if (e[t].spread) return !0;
    }
    return !1;
}
function $ef053115c0f9207e$var$Ca(e, t) {
    const n = $ef053115c0f9207e$var$D(e, t);
    let r = -1;
    for(; ++r < n.length;){
        const i = n[r];
        i.type !== "listItem" && (n[r] = {
            type: "listItem",
            spread: !1,
            checked: null,
            // @ts-expect-error Assume `children[index]` is block content.
            children: [
                i
            ]
        });
    }
    return n;
}
const $ef053115c0f9207e$var$lh = $ef053115c0f9207e$var$ee("div"), $ef053115c0f9207e$var$uh = $ef053115c0f9207e$var$ee("dt"), $ef053115c0f9207e$var$ch = $ef053115c0f9207e$var$ee("dd");
function $ef053115c0f9207e$var$hh(e, t) {
    const n = t.children;
    let r = -1, i = [];
    const s = [];
    let o = {
        titles: [],
        definitions: []
    }, l, u;
    for(; ++r < n.length;)l = n[r], i = i.concat($ef053115c0f9207e$var$lh(l) ? l.children : l);
    for(r = -1; ++r < i.length;)l = i[r], $ef053115c0f9207e$var$uh(l) ? ($ef053115c0f9207e$var$ch(i[r - 1]) && (s.push(o), o = {
        titles: [],
        definitions: []
    }), o.titles.push(l)) : o.definitions.push(l);
    s.push(o), r = -1;
    const c = [];
    for(; ++r < s.length;)u = [
        ...$ef053115c0f9207e$var$Ds(e, s[r].titles),
        ...$ef053115c0f9207e$var$Ds(e, s[r].definitions)
    ], u.length > 0 && c.push({
        type: "listItem",
        spread: u.length > 1,
        checked: null,
        children: u
    });
    if (c.length > 0) return e(t, "list", {
        ordered: !1,
        start: null,
        spread: $ef053115c0f9207e$var$xr(c)
    }, c);
}
function $ef053115c0f9207e$var$Ds(e, t) {
    const n = $ef053115c0f9207e$var$Ca(e, {
        type: "element",
        tagName: "x",
        children: t
    });
    return n.length === 0 ? [] : n.length === 1 ? n[0].children : [
        {
            type: "list",
            ordered: !1,
            start: null,
            spread: $ef053115c0f9207e$var$xr(n),
            children: n
        }
    ];
}
function $ef053115c0f9207e$var$Bt(e, t) {
    return e(t, "emphasis", $ef053115c0f9207e$var$D(e, t));
}
function $ef053115c0f9207e$var$B1(e, t) {
    const n = Number(t.tagName.charAt(1)) || 1, r = e.wrapText;
    e.wrapText = !1;
    const i = e(t, "heading", {
        depth: n
    }, $ef053115c0f9207e$var$D(e, t));
    return e.wrapText = r, i;
}
function $ef053115c0f9207e$var$fh(e, t) {
    return e(t, "thematicBreak");
}
function $ef053115c0f9207e$var$Th(e, t) {
    const n = t.properties, r = String(n.src || ""), i = String(n.title || "");
    if (r && i) return {
        type: "link",
        title: null,
        url: $ef053115c0f9207e$var$R1(e, r),
        children: [
            {
                type: "text",
                value: $ef053115c0f9207e$var$Ae(e, i)
            }
        ]
    };
}
function $ef053115c0f9207e$var$ws(e, t) {
    const n = t.properties;
    return e(t, "image", {
        url: $ef053115c0f9207e$var$R1(e, String(n.src || "") || null),
        title: n.title || null,
        alt: n.alt || ""
    });
}
function $ef053115c0f9207e$var$st(e, t) {
    return e(t, "inlineCode", $ef053115c0f9207e$var$Ae(e, $ef053115c0f9207e$var$Ct(t)));
}
const $ef053115c0f9207e$var$dh = $ef053115c0f9207e$var$ee("option");
function $ef053115c0f9207e$var$Sa(e, t, n) {
    const r = n || t.properties;
    let i = $ef053115c0f9207e$var$Na(t);
    const s = Math.min(Number.parseInt(String(r.size), 10), 0) || (r.multiple ? 4 : 1);
    let o = -1;
    const l = [], u = [];
    for(; ++o < i.length;)$ef053115c0f9207e$var$At(i[o], "selected") && l.push(i[o]);
    for(i = (l.length > 0 ? l : i).slice(0, s), o = -1; ++o < i.length;){
        const h = i[o], p = $ef053115c0f9207e$var$Ae(e, $ef053115c0f9207e$var$Ct(h)), _ = h.properties, E = p || String(_.label || ""), S = String(_.value || "") || p;
        u.push([
            S,
            E === S ? null : E
        ]);
    }
    return u;
}
function $ef053115c0f9207e$var$Na(e) {
    const t = e.children;
    let n = -1, r = [], i;
    for(; ++n < t.length;)i = t[n], Array.isArray(i.children) && (r = r.concat($ef053115c0f9207e$var$Na(i))), $ef053115c0f9207e$var$dh(i) && !$ef053115c0f9207e$var$At(i, "disabled") && r.push(i);
    return r;
}
const $ef053115c0f9207e$var$mh = $ef053115c0f9207e$var$ee("datalist");
function $ef053115c0f9207e$var$ph(e, t) {
    const n = t.properties;
    let r = String(n.value || n.placeholder || "");
    const i = [], s = [];
    let o = [], l = -1, u;
    if (!(n.disabled || n.type === "hidden" || n.type === "file")) {
        if (n.type === "checkbox" || n.type === "radio") return e(t, "text", $ef053115c0f9207e$var$Ae(e, e[n.checked ? "checked" : "unchecked"]));
        if (n.type === "image") return n.alt || r ? e(t, "image", {
            url: $ef053115c0f9207e$var$R1(e, String(n.src || "") || null),
            title: $ef053115c0f9207e$var$Ae(e, String(n.title || "")) || null,
            alt: $ef053115c0f9207e$var$Ae(e, String(n.alt || r))
        }) : [];
        if (r ? o = [
            [
                r,
                null
            ]
        ] : // `list` is not supported on these types:
        n.type !== "password" && n.type !== "file" && n.type !== "submit" && n.type !== "reset" && n.type !== "button" && n.list && (u = String(n.list).toUpperCase(), $ef053115c0f9207e$var$Xt.call(e.nodeById, u) && $ef053115c0f9207e$var$mh(e.nodeById[u]) && (o = $ef053115c0f9207e$var$Sa(e, e.nodeById[u], n))), o.length !== 0) {
            if (n.type === "password" && (o[0] = [
                "\u2022".repeat(o[0][0].length),
                null
            ]), n.type === "url" || n.type === "email") {
                for(; ++l < o.length;)r = $ef053115c0f9207e$var$R1(e, o[l][0]), i.push(e(t, "link", {
                    title: null,
                    url: $ef053115c0f9207e$var$Ae(e, n.type === "email" ? "mailto:" + r : r)
                }, [
                    {
                        type: "text",
                        value: $ef053115c0f9207e$var$Ae(e, o[l][1] || r)
                    }
                ])), l !== o.length - 1 && i.push({
                    type: "text",
                    value: ", "
                });
                return i;
            }
            for(; ++l < o.length;)s.push(o[l][1] ? o[l][1] + " (" + o[l][0] + ")" : o[l][0]);
            return e(t, "text", $ef053115c0f9207e$var$Ae(e, s.join(", ")));
        }
    }
}
const $ef053115c0f9207e$var$Eh = $ef053115c0f9207e$var$ee("p"), $ef053115c0f9207e$var$_h = $ef053115c0f9207e$var$ee("input");
function $ef053115c0f9207e$var$Gn(e, t) {
    const n = t.children[0];
    let r = null, i, s;
    $ef053115c0f9207e$var$Eh(n) && (i = n.children[0], $ef053115c0f9207e$var$_h(i) && i.properties && (i.properties.type === "checkbox" || i.properties.type === "radio") && (r = !!i.properties.checked, s = {
        ...t,
        children: [
            {
                ...n,
                children: n.children.slice(1)
            },
            ...t.children.slice(1)
        ]
    }));
    const o = $ef053115c0f9207e$var$se(e, s || t);
    return e(t, "listItem", {
        spread: o.length > 1,
        checked: r
    }, o);
}
const $ef053115c0f9207e$var$gh = $ef053115c0f9207e$var$ee("ol");
function $ef053115c0f9207e$var$Kn(e, t) {
    const n = $ef053115c0f9207e$var$gh(t), r = $ef053115c0f9207e$var$Ca(e, t);
    let i = null;
    return n && (i = $ef053115c0f9207e$var$At(t, "start") ? // @ts-expect-error: `props` exist.
    Number.parseInt(String(t.properties.start), 10) : 1), e(t, "list", {
        ordered: n,
        start: i,
        spread: $ef053115c0f9207e$var$xr(r)
    }, r);
}
const $ef053115c0f9207e$var$Ah = $ef053115c0f9207e$var$ee("source"), $ef053115c0f9207e$var$Ch = $ef053115c0f9207e$var$ee("video");
function $ef053115c0f9207e$var$Fs(e, t) {
    let n = $ef053115c0f9207e$var$D(e, t);
    const r = t.properties, i = $ef053115c0f9207e$var$Ch(t) && String(r.poster || "");
    let s = String(r.src || ""), o = -1, l = !1, u;
    if ($ef053115c0f9207e$var$mt({
        type: "root",
        children: n
    }, "link", c), l || $ef053115c0f9207e$var$hn(n)) return n;
    for(; !s && ++o < t.children.length;)u = t.children[o], $ef053115c0f9207e$var$Ah(u) && (s = String(u.properties.src || ""));
    return i && (n = [
        {
            type: "image",
            title: null,
            url: $ef053115c0f9207e$var$R1(e, i),
            alt: $ef053115c0f9207e$var$Jt({
                children: n
            })
        }
    ]), {
        type: "link",
        // @ts-expect-error Types are broken.
        title: t.properties.title || null,
        url: $ef053115c0f9207e$var$R1(e, s),
        // @ts-expect-error Assume phrasing content.
        children: n
    };
    function c() {
        return l = !0, $ef053115c0f9207e$var$$t;
    }
}
function $ef053115c0f9207e$var$Hs(e, t) {
    const n = $ef053115c0f9207e$var$D(e, t);
    if (n.length > 0) return e(t, "paragraph", n);
}
function $ef053115c0f9207e$var$Sh(e, t) {
    const n = e.quotes[e.qNesting % e.quotes.length];
    e.qNesting++;
    const r = $ef053115c0f9207e$var$D(e, t);
    return e.qNesting--, r.unshift({
        type: "text",
        value: n.charAt(0)
    }), r.push({
        type: "text",
        value: n.length > 1 ? n.charAt(1) : n
    }), r;
}
function $ef053115c0f9207e$var$Nh(e, t) {
    let n = $ef053115c0f9207e$var$D(e, t);
    return (e.document || $ef053115c0f9207e$var$hn(n)) && (n = $ef053115c0f9207e$var$da(n)), e(t, "root", n);
}
function $ef053115c0f9207e$var$Ih(e, t) {
    const n = $ef053115c0f9207e$var$Sa(e, t);
    let r = -1;
    const i = [];
    let s;
    for(; ++r < n.length;)s = n[r], i.push(s[1] ? s[1] + " (" + s[0] + ")" : s[0]);
    if (i.length > 0) return e(t, "text", $ef053115c0f9207e$var$Ae(e, i.join(", ")));
}
function $ef053115c0f9207e$var$Bs(e, t) {
    return e(t, "strong", $ef053115c0f9207e$var$D(e, t));
}
function $ef053115c0f9207e$var$Us(e, t) {
    const n = e.wrapText;
    e.wrapText = !1;
    const r = e(t, "tableCell", $ef053115c0f9207e$var$D(e, t));
    if (t.properties && (t.properties.rowSpan || t.properties.colSpan)) {
        const i = r.data || (r.data = {});
        t.properties.rowSpan && (i.rowSpan = t.properties.rowSpan), t.properties.colSpan && (i.colSpan = t.properties.colSpan);
    }
    return e.wrapText = n, r;
}
function $ef053115c0f9207e$var$Oh(e, t) {
    return e(t, "tableRow", $ef053115c0f9207e$var$D(e, t));
}
const $ef053115c0f9207e$var$Rh = $ef053115c0f9207e$var$ee("thead"), $ef053115c0f9207e$var$xh = $ef053115c0f9207e$var$ee("tr"), $ef053115c0f9207e$var$yh = $ef053115c0f9207e$var$ee([
    "th",
    "td"
]);
function $ef053115c0f9207e$var$kh(e, t) {
    if (e.inTable) return e(t, "text", $ef053115c0f9207e$var$Ae(e, $ef053115c0f9207e$var$Ct(t)));
    e.inTable = !0;
    const { headless: n, align: r } = $ef053115c0f9207e$var$Lh(t), i = $ef053115c0f9207e$var$Mh($ef053115c0f9207e$var$D(e, t), n);
    let s = 1, o = -1;
    for(; ++o < i.length;){
        const u = i[o].children;
        let c = -1;
        for(; ++c < u.length;){
            const h = u[c];
            if (h.data) {
                const p = Number.parseInt(String(h.data.colSpan), 10) || 1, _ = Number.parseInt(String(h.data.rowSpan), 10) || 1;
                if (p > 1 || _ > 1) {
                    let E = o - 1;
                    for(; ++E < o + _;){
                        let S = c - 1;
                        for(; ++S < c + p && i[E];){
                            const R = [];
                            (E !== o || S !== c) && R.push({
                                type: "tableCell",
                                children: []
                            }), i[E].children.splice(S, 0, ...R);
                        }
                    }
                }
                "colSpan" in h.data && delete h.data.colSpan, "rowSpan" in h.data && delete h.data.rowSpan, Object.keys(h.data).length === 0 && delete h.data;
            }
        }
        u.length > s && (s = u.length);
    }
    for(o = -1; ++o < i.length;){
        const u = i[o].children;
        let c = u.length - 1;
        for(; ++c < s;)u.push({
            type: "tableCell",
            children: []
        });
    }
    let l = r.length - 1;
    for(; ++l < s;)r.push(null);
    return e.inTable = !1, e(t, "table", {
        align: r
    }, i);
}
function $ef053115c0f9207e$var$Lh(e) {
    let t = !0, n = 0, r = 0;
    const i = [
        null
    ];
    return $ef053115c0f9207e$var$mt(e, "element", (s)=>{
        if (s.tagName === "table" && e !== s) return $ef053115c0f9207e$var$uo;
        $ef053115c0f9207e$var$yh(s) && s.properties ? (i[r] || (i[r] = String(s.properties.align || "") || null), t && n < 2 && s.tagName === "th" && (t = !1), r++) : $ef053115c0f9207e$var$Rh(s) ? t = !1 : $ef053115c0f9207e$var$xh(s) && (n++, r = 0);
    }), {
        align: i,
        headless: t
    };
}
function $ef053115c0f9207e$var$Mh(e, t) {
    let n = -1;
    const r = [];
    let i;
    for(t && r.push({
        type: "tableRow",
        children: []
    }); ++n < e.length;){
        const s = e[n];
        s.type === "tableRow" ? (i && (s.children.unshift(...i), i = void 0), r.push(s)) : (i || (i = []), i.push(s));
    }
    for(i && r[r.length - 1].children.push(...i), n = -1; ++n < r.length;)r[n].children = $ef053115c0f9207e$var$bh(r[n].children);
    return r;
}
function $ef053115c0f9207e$var$bh(e) {
    const t = [];
    let n = -1, r, i;
    for(; ++n < e.length;)r = e[n], r.type === "tableCell" ? (i && (r.children.unshift(...i), i = void 0), t.push(r)) : (i || (i = []), i.push(r));
    return i && (r = t[t.length - 1], r || (r = {
        type: "tableCell",
        children: []
    }, t.push(r)), r.children.push(...i)), t;
}
function $ef053115c0f9207e$var$Ph(e, t) {
    return e(t, "text", $ef053115c0f9207e$var$Ae(e, t.value));
}
function $ef053115c0f9207e$var$Dh(e, t) {
    return e(t, "text", $ef053115c0f9207e$var$Ae(e, $ef053115c0f9207e$var$Ct(t)));
}
function $ef053115c0f9207e$var$wh(e, t) {
    return e(t, "text", "\u200B");
}
const $ef053115c0f9207e$var$vs = {
    root: $ef053115c0f9207e$var$Nh,
    text: $ef053115c0f9207e$var$Ph,
    comment: $ef053115c0f9207e$var$ah,
    doctype: $ef053115c0f9207e$var$Y,
    applet: $ef053115c0f9207e$var$Y,
    area: $ef053115c0f9207e$var$Y,
    basefont: $ef053115c0f9207e$var$Y,
    bgsound: $ef053115c0f9207e$var$Y,
    caption: $ef053115c0f9207e$var$Y,
    col: $ef053115c0f9207e$var$Y,
    colgroup: $ef053115c0f9207e$var$Y,
    command: $ef053115c0f9207e$var$Y,
    content: $ef053115c0f9207e$var$Y,
    datalist: $ef053115c0f9207e$var$Y,
    dialog: $ef053115c0f9207e$var$Y,
    element: $ef053115c0f9207e$var$Y,
    embed: $ef053115c0f9207e$var$Y,
    frame: $ef053115c0f9207e$var$Y,
    frameset: $ef053115c0f9207e$var$Y,
    isindex: $ef053115c0f9207e$var$Y,
    keygen: $ef053115c0f9207e$var$Y,
    link: $ef053115c0f9207e$var$Y,
    math: $ef053115c0f9207e$var$Y,
    menu: $ef053115c0f9207e$var$Y,
    menuitem: $ef053115c0f9207e$var$Y,
    meta: $ef053115c0f9207e$var$Y,
    nextid: $ef053115c0f9207e$var$Y,
    noembed: $ef053115c0f9207e$var$Y,
    noframes: $ef053115c0f9207e$var$Y,
    optgroup: $ef053115c0f9207e$var$Y,
    option: $ef053115c0f9207e$var$Y,
    param: $ef053115c0f9207e$var$Y,
    script: $ef053115c0f9207e$var$Y,
    shadow: $ef053115c0f9207e$var$Y,
    source: $ef053115c0f9207e$var$Y,
    spacer: $ef053115c0f9207e$var$Y,
    style: $ef053115c0f9207e$var$Y,
    svg: $ef053115c0f9207e$var$Y,
    template: $ef053115c0f9207e$var$Y,
    title: $ef053115c0f9207e$var$Y,
    track: $ef053115c0f9207e$var$Y,
    abbr: $ef053115c0f9207e$var$D,
    acronym: $ef053115c0f9207e$var$D,
    bdi: $ef053115c0f9207e$var$D,
    bdo: $ef053115c0f9207e$var$D,
    big: $ef053115c0f9207e$var$D,
    blink: $ef053115c0f9207e$var$D,
    button: $ef053115c0f9207e$var$D,
    canvas: $ef053115c0f9207e$var$D,
    cite: $ef053115c0f9207e$var$D,
    data: $ef053115c0f9207e$var$D,
    details: $ef053115c0f9207e$var$D,
    dfn: $ef053115c0f9207e$var$D,
    font: $ef053115c0f9207e$var$D,
    ins: $ef053115c0f9207e$var$D,
    label: $ef053115c0f9207e$var$D,
    map: $ef053115c0f9207e$var$D,
    marquee: $ef053115c0f9207e$var$D,
    meter: $ef053115c0f9207e$var$D,
    nobr: $ef053115c0f9207e$var$D,
    noscript: $ef053115c0f9207e$var$D,
    object: $ef053115c0f9207e$var$D,
    output: $ef053115c0f9207e$var$D,
    progress: $ef053115c0f9207e$var$D,
    rb: $ef053115c0f9207e$var$D,
    rbc: $ef053115c0f9207e$var$D,
    rp: $ef053115c0f9207e$var$D,
    rt: $ef053115c0f9207e$var$D,
    rtc: $ef053115c0f9207e$var$D,
    ruby: $ef053115c0f9207e$var$D,
    slot: $ef053115c0f9207e$var$D,
    small: $ef053115c0f9207e$var$D,
    span: $ef053115c0f9207e$var$D,
    sup: $ef053115c0f9207e$var$D,
    sub: $ef053115c0f9207e$var$D,
    tbody: $ef053115c0f9207e$var$D,
    tfoot: $ef053115c0f9207e$var$D,
    thead: $ef053115c0f9207e$var$D,
    time: $ef053115c0f9207e$var$D,
    address: $ef053115c0f9207e$var$se,
    article: $ef053115c0f9207e$var$se,
    aside: $ef053115c0f9207e$var$se,
    body: $ef053115c0f9207e$var$se,
    center: $ef053115c0f9207e$var$se,
    div: $ef053115c0f9207e$var$se,
    fieldset: $ef053115c0f9207e$var$se,
    figcaption: $ef053115c0f9207e$var$se,
    figure: $ef053115c0f9207e$var$se,
    form: $ef053115c0f9207e$var$se,
    footer: $ef053115c0f9207e$var$se,
    header: $ef053115c0f9207e$var$se,
    hgroup: $ef053115c0f9207e$var$se,
    html: $ef053115c0f9207e$var$se,
    legend: $ef053115c0f9207e$var$se,
    main: $ef053115c0f9207e$var$se,
    multicol: $ef053115c0f9207e$var$se,
    nav: $ef053115c0f9207e$var$se,
    picture: $ef053115c0f9207e$var$se,
    section: $ef053115c0f9207e$var$se,
    a: $ef053115c0f9207e$var$Q4,
    audio: $ef053115c0f9207e$var$Fs,
    b: $ef053115c0f9207e$var$Bs,
    base: $ef053115c0f9207e$var$W4,
    blockquote: $ef053115c0f9207e$var$q4,
    br: $ef053115c0f9207e$var$V4,
    code: $ef053115c0f9207e$var$st,
    dir: $ef053115c0f9207e$var$Kn,
    dl: $ef053115c0f9207e$var$hh,
    dt: $ef053115c0f9207e$var$Gn,
    dd: $ef053115c0f9207e$var$Gn,
    del: $ef053115c0f9207e$var$vn,
    em: $ef053115c0f9207e$var$Bt,
    h1: $ef053115c0f9207e$var$B1,
    h2: $ef053115c0f9207e$var$B1,
    h3: $ef053115c0f9207e$var$B1,
    h4: $ef053115c0f9207e$var$B1,
    h5: $ef053115c0f9207e$var$B1,
    h6: $ef053115c0f9207e$var$B1,
    hr: $ef053115c0f9207e$var$fh,
    i: $ef053115c0f9207e$var$Bt,
    iframe: $ef053115c0f9207e$var$Th,
    img: $ef053115c0f9207e$var$ws,
    image: $ef053115c0f9207e$var$ws,
    input: $ef053115c0f9207e$var$ph,
    kbd: $ef053115c0f9207e$var$st,
    li: $ef053115c0f9207e$var$Gn,
    listing: $ef053115c0f9207e$var$Ht,
    mark: $ef053115c0f9207e$var$Bt,
    ol: $ef053115c0f9207e$var$Kn,
    p: $ef053115c0f9207e$var$Hs,
    plaintext: $ef053115c0f9207e$var$Ht,
    pre: $ef053115c0f9207e$var$Ht,
    q: $ef053115c0f9207e$var$Sh,
    s: $ef053115c0f9207e$var$vn,
    samp: $ef053115c0f9207e$var$st,
    select: $ef053115c0f9207e$var$Ih,
    strike: $ef053115c0f9207e$var$vn,
    strong: $ef053115c0f9207e$var$Bs,
    summary: $ef053115c0f9207e$var$Hs,
    table: $ef053115c0f9207e$var$kh,
    td: $ef053115c0f9207e$var$Us,
    textarea: $ef053115c0f9207e$var$Dh,
    th: $ef053115c0f9207e$var$Us,
    tr: $ef053115c0f9207e$var$Oh,
    tt: $ef053115c0f9207e$var$st,
    u: $ef053115c0f9207e$var$Bt,
    ul: $ef053115c0f9207e$var$Kn,
    var: $ef053115c0f9207e$var$st,
    video: $ef053115c0f9207e$var$Fs,
    wbr: $ef053115c0f9207e$var$wh,
    xmp: $ef053115c0f9207e$var$Ht
};
function $ef053115c0f9207e$var$Y() {}
const $ef053115c0f9207e$var$Fh = $ef053115c0f9207e$var$j1([
    "heading",
    "paragraph",
    "root"
]);
function $ef053115c0f9207e$var$Ia(e, t = {}) {
    const n = {};
    let r;
    const i = Object.assign(/**
     * @type {HWithProps & HWithoutProps}
     */ /**
     * @param {Node} node
     * @param {string} type
     * @param {Properties|string|Array<Node>} [props]
     * @param {string|Array<Node>} [children]
     */ (l, u, c, h)=>{
        let p;
        typeof c == "string" || Array.isArray(c) ? (h = c, p = {}) : p = c;
        const _ = {
            type: u,
            ...p
        };
        return typeof h == "string" ? _.value = h : h && (_.children = h), l.position && (_.position = l.position), _;
    }, {
        nodeById: n,
        baseFound: !1,
        inTable: !1,
        wrapText: !0,
        /** @type {string|null} */ frozenBaseUrl: null,
        qNesting: 0,
        handlers: t.handlers ? {
            ...$ef053115c0f9207e$var$vs,
            ...t.handlers
        } : $ef053115c0f9207e$var$vs,
        document: t.document,
        checked: t.checked || "[x]",
        unchecked: t.unchecked || "[ ]",
        quotes: t.quotes || [
            '"'
        ]
    });
    $ef053115c0f9207e$var$mt(e, "element", (l)=>{
        const u = l.properties && "id" in l.properties && String(l.properties.id).toUpperCase();
        u && !$ef053115c0f9207e$var$Xt.call(n, u) && (n[u] = l);
    }), $ef053115c0f9207e$var$x4({
        newlines: t.newlines === !0
    })(e);
    const s = $ef053115c0f9207e$var$Ta(i, e, void 0);
    return s ? Array.isArray(s) ? r = {
        type: "root",
        children: s
    } : r = s : r = {
        type: "root",
        children: []
    }, $ef053115c0f9207e$var$mt(r, "text", o), r;
    function o(l, u, c) {
        if (u === null || !c) return;
        const h = c.children[u - 1];
        if (h && h.type === l.type) return h.value += l.value, c.children.splice(u, 1), h.position && l.position && (h.position.end = l.position.end), u - 1;
        if (l.value = l.value.replace(/[\t ]*(\r?\n|\r)[\t ]*/, "$1"), c && $ef053115c0f9207e$var$Fh(c) && (u || (l.value = l.value.replace(/^[\t ]+/, "")), u === c.children.length - 1 && (l.value = l.value.replace(/[\t ]+$/, ""))), !l.value) return c.children.splice(u, 1), u;
    }
}
const $ef053115c0f9207e$var$Hh = /**
   * @type {(import('unified').Plugin<[Processor, Options?], HastRoot> & import('unified').Plugin<[Options?]|void[], HastRoot, MdastRoot>)}
   */ /**
   * @param {Processor|Options} [destination]
   * @param {Options} [options]
   */ function(e, t) {
    let n, r;
    return typeof e == "function" ? (r = e, n = t || {}) : n = e || {}, (n.document === void 0 || n.document === null) && (n = Object.assign({}, n, {
        document: !0
    })), r ? $ef053115c0f9207e$var$Bh(r, n) : $ef053115c0f9207e$var$Uh(n);
}, $ef053115c0f9207e$var$Oa = $ef053115c0f9207e$var$Hh;
function $ef053115c0f9207e$var$Bh(e, t) {
    return (n, r, i)=>{
        e.run($ef053115c0f9207e$var$Ia(n, t), r, (s)=>{
            i(s);
        });
    };
}
function $ef053115c0f9207e$var$Uh(e = {}) {
    return (t)=>/** @type {MdastRoot} */ $ef053115c0f9207e$var$Ia(t, e);
}
function $ef053115c0f9207e$var$Ra(e) {
    Object.assign(this, {
        Compiler: (n)=>{
            const r = /** @type {Options} */ this.data("settings");
            return $ef053115c0f9207e$var$So(n, Object.assign({}, r, e, {
                // Note: this option is not in the readme.
                // The goal is for it to be set by plugins on `data` instead of being
                // passed by users.
                extensions: /** @type {ToMarkdownOptions['extensions']} */ this.data("toMarkdownExtensions") || []
            }));
        }
    });
}
function $ef053115c0f9207e$var$vh(e) {
    return $ef053115c0f9207e$var$nr().use($ef053115c0f9207e$var$oa).use($ef053115c0f9207e$var$Oa).use($ef053115c0f9207e$var$Ra).processSync(e.text), `${e.text}
`;
}
function $ef053115c0f9207e$var$xa(e) {
    if (e.type === "text") return e.value;
    function t(r) {
        let i = "";
        return r.forEach((s)=>{
            i += $ef053115c0f9207e$var$xa(s);
        }), i;
    }
    let n = "";
    if (Array.isArray(e.children) && e.children.length > 0) switch(e.type){
        case "strong":
            n += `<b>${t(e.children)}</b>`;
            break;
        case "emphasis":
            n += `<i>${t(e.children)}</i>`;
            break;
        case "underline":
            n += `<u class="cdx-underline">${t(e.children)}</u>`;
            break;
    }
    return n;
}
function $ef053115c0f9207e$var$ya(e) {
    const t = [];
    let n = null;
    return e.children.forEach((r)=>{
        switch(r.type){
            case "text":
            case "strong":
            case "emphasis":
            case "underline":
                n && n.type === "image" && (t.push(n), n = null), n || (n = {
                    type: "paragraph",
                    data: {
                        text: ""
                    }
                }), n.data.text += $ef053115c0f9207e$var$xa(r);
                break;
            case "image":
                (n == null ? void 0 : n.type) === "paragraph" && (t.push(n), n = null), n || (n = {
                    type: "image",
                    data: {
                        caption: r.title,
                        stretched: !1,
                        url: r.url,
                        withBackground: !1,
                        withBorder: !1
                    }
                });
                break;
        }
    }), n && (t.push(n), n = null), t;
}
function $ef053115c0f9207e$var$Gs(e) {
    const t = $ef053115c0f9207e$var$nr().use($ef053115c0f9207e$var$oa).use($ef053115c0f9207e$var$Oa).use($ef053115c0f9207e$var$Ra).processSync(e);
    return String(t);
}
function $ef053115c0f9207e$var$Gh(e) {
    switch(e.style){
        case "unordered":
            return e.items.map((t)=>`* ${$ef053115c0f9207e$var$Gs(t)}`).join(`
`).concat(`
`);
        case "ordered":
            return e.items.map((t, n)=>`${n + 1} ${$ef053115c0f9207e$var$Gs(t)}`).join(`
`).concat(`
`);
    }
    return "";
}
function $ef053115c0f9207e$var$Kh(e) {
    const t = [];
    return e.children.forEach((n)=>{
        n.children.forEach((r)=>{
            const i = $ef053115c0f9207e$var$ya(r);
            t.push(...i.map((s)=>s.data.text));
        });
    }), {
        data: {
            items: t,
            style: e.ordered ? "ordered" : "unordered"
        },
        type: "list"
    };
}
function $ef053115c0f9207e$var$zh() {
    return "---".concat(`
`);
}
function $ef053115c0f9207e$var$Yh() {
    let e = {};
    return e = {
        data: {
            items: []
        },
        type: "delimiter"
    }, e;
}
function $ef053115c0f9207e$var$jh(e) {
    return `\`\`\`
${e.code}
\`\`\`
`;
}
function $ef053115c0f9207e$var$$h(e) {
    return {
        data: {
            code: e.value
        },
        type: "code"
    };
}
function $ef053115c0f9207e$var$Qh(e) {
    return `> ${e.text}
`;
}
function $ef053115c0f9207e$var$Wh(e) {
    let t = {};
    return e.children.forEach((n)=>{
        (n.type === "paragraph" || n.type === "heading") && n.children.forEach((r)=>{
            r.type === "text" && (t = {
                data: {
                    alignment: "left",
                    caption: "",
                    text: r.value
                },
                type: "quote"
            });
        });
    }), t;
}
function $ef053115c0f9207e$var$qh(e) {
    return `![${e.caption}](${e.url} "${e.caption}")`.concat(`
`);
}
function $ef053115c0f9207e$var$Ks(e) {
    let t = {};
    return t = e.items.map((n)=>n.checked === !0 ? `- [x] ${n.text}` : `- [ ] ${n.text}`), t.join(`
`);
}
class $ef053115c0f9207e$export$2e2bcd8739ae039 {
    static toBlocks(t) {
        const n = [];
        return $ef053115c0f9207e$var$Q9.parse(t).children.forEach((i)=>{
            switch(i.type){
                case "heading":
                    return n.push($ef053115c0f9207e$var$q9(i));
                case "paragraph":
                    return n.push(...$ef053115c0f9207e$var$ya(i));
                case "list":
                    return n.push($ef053115c0f9207e$var$Kh(i));
                case "thematicBreak":
                    return n.push($ef053115c0f9207e$var$Yh());
                case "code":
                    return n.push($ef053115c0f9207e$var$$h(i));
                case "blockquote":
                    return n.push($ef053115c0f9207e$var$Wh(i));
            }
        }), n.filter((i)=>typeof i < "u");
    }
    static toMarkdown(t) {
        return t.map((r)=>{
            switch(r.type){
                case "header":
                    return $ef053115c0f9207e$var$W9(r.data);
                case "paragraph":
                    return $ef053115c0f9207e$var$vh(r.data);
                case "list":
                    return $ef053115c0f9207e$var$Gh(r.data);
                case "delimiter":
                    return $ef053115c0f9207e$var$zh();
                case "image":
                    return $ef053115c0f9207e$var$qh(r.data);
                case "quote":
                    return $ef053115c0f9207e$var$Qh(r.data);
                case "checkbox":
                    return $ef053115c0f9207e$var$Ks(r.data);
                case "code":
                    return $ef053115c0f9207e$var$jh(r.data);
                case "checklist":
                    return $ef053115c0f9207e$var$Ks(r.data);
            }
        }).join(`
`);
    }
}

});


parcelRegister("csKGB", function(module, exports) {

$parcel$export(module.exports, "KnowledgeBaseMain", () => $912c5071d13f483c$export$30145419ae9c60a3);
$parcel$export(module.exports, "KbHeader", () => $912c5071d13f483c$export$7406bdfeab52446b);
$parcel$export(module.exports, "KbArticleGrid", () => $912c5071d13f483c$export$f2ecbe55bed21f59);
$parcel$export(module.exports, "KbArticleCard", () => $912c5071d13f483c$export$3e9b49a741a33e82);
// Knowledge Base view — categorized articles with search and browse.
// migrated 2026-04-27 to SDK route workspaceProject.documents.kb

var $3ihxA = parcelRequire("3ihxA");

var $6zlBP = parcelRequire("6zlBP");

var $bfqVY = parcelRequire("bfqVY");
const $912c5071d13f483c$var$_filteredArticles = (s)=>{
    const cat = s.root.selectedCategory || 'all';
    const q = (s.root.kbQuery || '').toLowerCase().trim();
    let articles = s.root.kbArticles || [];
    if (cat !== 'all') articles = articles.filter((a)=>a.category === cat);
    if (q) articles = articles.filter((a)=>(a.title || '').toLowerCase().includes(q) || (a.summary || '').toLowerCase().includes(q) || (a.author || '').toLowerCase().includes(q));
    return articles;
};
const $912c5071d13f483c$export$30145419ae9c60a3 = {
    extends: 'AppMain',
    padding: '0',
    Header: {
        extends: 'KbHeader'
    },
    Body: {
        padding: 'B C',
        overflow: 'auto',
        flow: 'y',
        gap: 'A',
        KbArticleGrid: {}
    }
};
const $912c5071d13f483c$export$7406bdfeab52446b = {
    extends: 'DocsContentHeader',
    LeftGroup: {
        Title: {
            text: (el, s)=>{
                const cat = (0, $3ihxA.KB_CATEGORIES).find((c)=>c.key === s.root.selectedCategory);
                return cat?.label || 'Knowledge Base';
            }
        },
        Count: {
            text: (el, s)=>{
                const n = $912c5071d13f483c$var$_filteredArticles(s).length;
                return `${n} article${n === 1 ? '' : 's'}`;
            }
        }
    },
    RightGroup: {
        Search: {
            placeholder: 'Search knowledge base...',
            value: (el, s)=>s.root.kbQuery || '',
            onInput: (e, el, s)=>{
                s.root.update({
                    kbQuery: e.target.value
                });
            }
        },
        PrimaryBtn: {
            text: '+ New article',
            onClick: async (e, el, s)=>{
                const cat = s.root.selectedCategory === 'all' ? 'getting-started' : s.root.selectedCategory;
                const row = {
                    title: 'Untitled article',
                    category: cat,
                    author: s.root.currentUserEmail || 'Unknown',
                    // Populate `author_email` for Phase E ownership-gated RLS (0069).
                    author_email: s.root.currentUserEmail || null,
                    summary: '',
                    content: {
                        blocks: []
                    }
                };
                let data;
                try {
                    // migrated 2026-04-27 to SDK route workspaceProject.documents.kb
                    const result = await (0, $bfqVY.getSDK)().execute('workspaceProject.documents.kb', 'create', {
                        payload: row
                    });
                    data = result?.data || result;
                } catch (err) {
                    console.error('[KB] Insert failed:', err);
                    return;
                }
                if (!data?.id) return;
                const articles = s.root.kbArticles || [];
                const article = {
                    ...row,
                    id: data.id,
                    updatedAt: new Date().toISOString().slice(0, 10)
                };
                s.root.update({
                    kbArticles: [
                        ...articles,
                        article
                    ],
                    editorDoc: {
                        id: data.id,
                        title: article.title,
                        content: {
                            blocks: []
                        },
                        source: 'kb'
                    },
                    activeSection: 'editor'
                });
                (0, $6zlBP._navigate)(el, '/documents/editor');
            }
        }
    }
};
const $912c5071d13f483c$export$f2ecbe55bed21f59 = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
    gap: 'A',
    childExtends: 'KbArticleCard',
    childrenAs: 'state',
    children: (el, s)=>$912c5071d13f483c$var$_filteredArticles(s)
};
const $912c5071d13f483c$export$3e9b49a741a33e82 = {
    extends: 'Link',
    href: (el, s)=>`/documents/editor#kb=${encodeURIComponent(s.id || '')}`,
    textDecoration: 'none',
    color: 'inherit',
    flow: 'y',
    gap: 'Z1',
    padding: 'A',
    round: 'A',
    borderWidth: '1px',
    borderColor: 'line',
    borderStyle: 'solid',
    background: 'overlayStrong',
    cursor: 'pointer',
    transition: 'A defaultBezier',
    ':hover': {
        borderColor: 'title',
        transform: 'translateY(-2px)'
    },
    onClick: (e, el, s)=>{
        e.preventDefault();
        const content = s.content && typeof s.content === 'object' ? s.content : {
            blocks: []
        };
        s.root.update({
            editorDoc: {
                id: s.id,
                title: s.title,
                content: content,
                source: 'kb'
            },
            editorMode: 'view',
            activeSection: 'editor'
        });
        (0, $6zlBP._navigate)(el, `/documents/editor#kb=${encodeURIComponent(s.id || '')}`);
    },
    Top: {
        flow: 'x',
        align: 'center left',
        gap: 'Z1',
        Icon: {
            icon: 'book',
            boxSize: 'A2 A2',
            color: 'caption'
        },
        Title: {
            tag: 'h3',
            margin: '0',
            fontSize: 'A',
            fontWeight: '600',
            color: 'title',
            flex: '1',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>s.title || 'Untitled'
        }
    },
    CategoryBadge: {
        tag: 'span',
        fontSize: 'Y1',
        fontWeight: '600',
        padding: 'V Z',
        round: 'Y',
        background: 'overlay',
        color: 'caption',
        textTransform: 'uppercase',
        letterSpacing: '.05em',
        alignSelf: 'flex-start',
        text: (el, s)=>{
            const cats = s.root?.kbCategories || [];
            const cat = cats.find((c)=>c.key === s.category);
            return cat?.label || s.category || '';
        }
    },
    Summary: {
        tag: 'p',
        margin: '0',
        fontSize: 'Z2',
        color: 'caption',
        lineHeight: '1.5',
        text: (el, s)=>s.summary || 'No description'
    },
    Meta: {
        flow: 'x',
        align: 'center space-between',
        gap: 'Z',
        marginTop: 'Z',
        fontSize: 'Y2',
        color: 'caption',
        Author: {
            tag: 'span',
            text: (el, s)=>s.author || ''
        },
        Updated: {
            tag: 'span',
            text: (el, s)=>s.updatedAt ? `Updated ${s.updatedAt}` : ''
        }
    }
};

});

parcelRegister("1Bm7R", function(module, exports) {

$parcel$export(module.exports, "CodeExample", () => $12aa68dc8040651e$export$5a24d46f71fcd15f);
const $12aa68dc8040651e$export$5a24d46f71fcd15f = {
    extends: 'Flex',
    round: 'A1',
    overflow: 'hidden',
    CodePreview: {}
};

});


parcelRegister("bPy8R", function(module, exports) {

var $dHPtV = parcelRequire("dHPtV");

var $3rFwI = parcelRequire("3rFwI");

var $1XN7N = parcelRequire("1XN7N");

var $aFnER = parcelRequire("aFnER");

var $4Q18q = parcelRequire("4Q18q");

var $9lpBv = parcelRequire("9lpBv");

var $9rrZ0 = parcelRequire("9rrZ0");

var $WT6Go = parcelRequire("WT6Go");

var $dyc8B = parcelRequire("dyc8B");

var $4X0TP = parcelRequire("4X0TP");

var $51fSV = parcelRequire("51fSV");

var $cy5cZ = parcelRequire("cy5cZ");

var $8NbKw = parcelRequire("8NbKw");

var $lyTci = parcelRequire("lyTci");
$parcel$exportWildcard(module.exports, $dHPtV);
$parcel$exportWildcard(module.exports, $3rFwI);
$parcel$exportWildcard(module.exports, $1XN7N);
$parcel$exportWildcard(module.exports, $aFnER);
$parcel$exportWildcard(module.exports, $4Q18q);
$parcel$exportWildcard(module.exports, $9lpBv);
$parcel$exportWildcard(module.exports, $9rrZ0);
$parcel$exportWildcard(module.exports, $WT6Go);
$parcel$exportWildcard(module.exports, $dyc8B);
$parcel$exportWildcard(module.exports, $4X0TP);
$parcel$exportWildcard(module.exports, $51fSV);
$parcel$exportWildcard(module.exports, $cy5cZ);
$parcel$exportWildcard(module.exports, $8NbKw);
$parcel$exportWildcard(module.exports, $lyTci);

});
parcelRegister("dHPtV", function(module, exports) {

$parcel$export(module.exports, "MeetSidebar", () => $9fa739b15420d702$export$7cd792898cc896a4);
// Meet sidebar — extends shared-gov's AppSidebar shell. Top slot has the
// "New call" button; Middle slot lists the user's rooms (with a live "in
// progress" indicator for rooms that have unended participants).
// PeopleSection is hidden — meet's primary surface is rooms, not people.
const $9fa739b15420d702$export$7cd792898cc896a4 = {
    extends: 'AppSidebar',
    PeopleSection: null,
    Top: {
        flow: 'y',
        padding: '0',
        gap: 'Z1',
        NewRoomBtn: {
            tag: 'button',
            text: '+ New call',
            padding: 'Z A',
            round: 'Z',
            border: 'none',
            theme: 'primary',
            cursor: 'pointer',
            fontSize: 'Z2',
            fontWeight: '600',
            ':hover': {
                opacity: '.9'
            },
            onClick: (e, el, s)=>{
                s.root?.update({
                    showNewRoom: true,
                    newRoomDraft: {
                        name: '',
                        kind: 'room',
                        isPrivate: false,
                        transcribeEnabled: true
                    }
                });
            }
        }
    },
    Middle: {
        flow: 'y',
        gap: 'B',
        RoomsGroup: {
            flow: 'y',
            gap: 'Z',
            Header: {
                flow: 'x',
                align: 'center left',
                gap: 'V',
                padding: 'V 0',
                CaptionTitle: {
                    fontSize: 'Y2',
                    flex: '1',
                    Text: {
                        text: 'CALLS'
                    }
                }
            },
            List: {
                extends: 'MeetRoomList'
            }
        }
    }
};

});

parcelRegister("3rFwI", function(module, exports) {

$parcel$export(module.exports, "MeetRoomList", () => $28241b118a14badc$export$60fbab041667e57d);
$parcel$export(module.exports, "MeetRoomRow", () => $28241b118a14badc$export$c909054b1af6d818);
// Reactive list of meet rooms keyed off root.rooms. Each row is a
// MeetRoomRow that navigates to /meet/:id on click. Live participant count
// (from root.liveParticipants) drives the "in progress" indicator.
// "Live" = has at least one meet_participants row with left_at IS NULL.
// The realtime subscription on meet_participants populates
// root.liveParticipants (keyed by roomId) across all rooms.
// `root` may be undefined during first-pass effect eval, so guard it.
const $28241b118a14badc$var$_isLive = (root, roomId)=>{
    const p = root?.liveParticipants?.[roomId] || [];
    return p.some((x)=>!x.leftAt);
};
const $28241b118a14badc$export$60fbab041667e57d = {
    flow: 'y',
    gap: 'V',
    childExtends: 'MeetRoomRow',
    childrenAs: 'state',
    children: (el, s)=>{
        const rooms = s.root?.rooms || [];
        // Live first, then not-ended, then ended. Within each group, most-recent
        // first. The _isLive check runs against realtime-populated state, so
        // rooms that just had their first join bubble up immediately.
        return rooms.slice().sort((a, b)=>{
            const aLive = s.root ? $28241b118a14badc$var$_isLive(s.root, a.id) : false;
            const bLive = s.root ? $28241b118a14badc$var$_isLive(s.root, b.id) : false;
            if (aLive !== bLive) return aLive ? -1 : 1;
            const aEnded = !!a.endedAt;
            const bEnded = !!b.endedAt;
            if (aEnded !== bEnded) return aEnded ? 1 : -1;
            return (b.createdAt || '').localeCompare(a.createdAt || '');
        });
    }
};
const $28241b118a14badc$export$c909054b1af6d818 = {
    flow: 'x',
    align: 'start',
    gap: 'Z1',
    padding: 'Z Z1',
    round: 'Z',
    cursor: 'pointer',
    background: (el, s)=>s.root?.activeRoomId === s.id ? 'overlay' : 'transparent',
    ':hover': {
        background: 'overlay'
    },
    onClick: (e, el, s)=>{
        const id = s.id;
        // Ended rooms go to the detail/list view — no call to connect.
        // Active rooms switch to call view and connect LiveKit imperatively
        // (page-level lifecycle hooks aren't reliable in DOMQL v3.14 for children
        // of if:/extends: wrappers, so the click handler drives the connect).
        if (s.endedAt) {
            s.root.update({
                activeRoomId: id,
                meetView: 'list'
            });
            if (typeof window !== 'undefined') history.replaceState(null, '', `#room=${id}`);
            return;
        }
        s.root.update({
            activeRoomId: id,
            meetView: 'call'
        });
        if (typeof window !== 'undefined') history.replaceState(null, '', `#room=${id}&view=call`);
        el.call('connectCall', id);
    },
    LiveDot: {
        tag: 'span',
        boxSize: 'X2',
        minWidth: 'X2',
        minHeight: 'X2',
        round: '100%',
        margin: 'Z - -',
        background: (el, s)=>{
            if (s.endedAt) return 'red';
            const live = (s.root?.liveParticipants?.[s.id] || []).filter((p)=>!p.leftAt);
            return live.length > 0 ? 'green' : 'gray';
        }
    },
    // Avatar stack of live participants (up to 5 + overflow count).
    // Reads from root.liveParticipants[roomId] filtered to unended entries,
    // then looks up each user_id in root.people for name/avatar.
    ParticipantStack: {
        flow: 'x',
        gap: 'V',
        align: 'center left',
        hide: (el, s)=>{
            if (s.endedAt) return true;
            const live = (s.root?.liveParticipants?.[s.id] || []).filter((p)=>!p.leftAt);
            return live.length === 0;
        },
        AvatarList: {
            flow: 'x',
            gap: '-V',
            childrenAs: 'state',
            children: (el, s)=>{
                const live = (s.root?.liveParticipants?.[s.id] || []).filter((p)=>!p.leftAt);
                const people = s.root?.people || [];
                return live.slice(0, 5).map((lp)=>{
                    const person = people.find((pp)=>pp.userId === lp.userId);
                    return {
                        id: lp.id,
                        name: person?.name || lp.identity || '?',
                        avatar: person?.avatar
                    };
                });
            },
            childExtends: {
                width: 'B',
                height: 'B',
                round: '100%',
                borderWidth: '2px',
                borderColor: 'document',
                borderStyle: 'solid',
                background: 'gray',
                color: 'white',
                fontSize: 'Y2',
                fontWeight: '700',
                align: 'center center',
                text: (el, s)=>{
                    const name = s.name || '';
                    return name.split(/\s+/).filter(Boolean).slice(0, 2).map((p)=>p[0]).join('').toUpperCase() || '?';
                }
            }
        },
        OverflowCount: {
            hide: (el, s)=>{
                const live = (s.root?.liveParticipants?.[s.id] || []).filter((p)=>!p.leftAt);
                return live.length <= 5;
            },
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            text: (el, s)=>{
                const live = (s.root?.liveParticipants?.[s.id] || []).filter((p)=>!p.leftAt);
                return `+${live.length - 5}`;
            }
        }
    },
    Info: {
        flow: 'y',
        gap: 'V',
        flex: '1',
        minWidth: '0',
        overflow: 'hidden',
        Name: {
            tag: 'span',
            fontSize: 'Z2',
            color: 'title',
            fontWeight: '500',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>s.name || 'Untitled'
        },
        Caption: {
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>{
                if (s.endedAt) return 'Ended';
                const live = (s.root?.liveParticipants?.[s.id] || []).filter((p)=>!p.leftAt);
                if (live.length > 0) return live.length === 1 ? '1 person in call' : `${live.length} people in call`;
                if (s.transcribeEnabled) return "Transcribed \xb7 idle";
                return s.kind || 'room';
            }
        }
    },
    // LIVE badge — only visible when there are connected participants right now.
    LiveBadge: {
        hide: (el, s)=>{
            if (s.endedAt) return true;
            const live = (s.root?.liveParticipants?.[s.id] || []).filter((p)=>!p.leftAt);
            return live.length === 0;
        },
        tag: 'span',
        padding: 'V Z',
        round: 'Y',
        background: 'red',
        color: 'white',
        fontSize: 'Y1',
        fontWeight: '700',
        letterSpacing: '.05em',
        textTransform: 'uppercase',
        text: 'Live'
    },
    TranscribeBadge: {
        hide: (el, s)=>!s.transcribeEnabled || s.endedAt,
        tag: 'span',
        fontSize: 'Y1',
        color: 'cyan',
        text: "\u25CF",
        title: 'Transcribed'
    },
    // Waiting badge — owner-only, shows when guests are waiting to join
    WaitingBadge: {
        hide: (el, s)=>{
            const n = (s.root?.waitingRoom?.[s.id] || []).filter((g)=>!g.admittedAt && !g.rejectedAt).length;
            return n === 0;
        },
        tag: 'span',
        padding: 'V Z',
        round: 'Y',
        background: 'orange',
        color: 'white',
        fontSize: 'Y1',
        fontWeight: '700',
        letterSpacing: '.05em',
        title: 'Guests waiting to join',
        text: (el, s)=>{
            const n = (s.root?.waitingRoom?.[s.id] || []).filter((g)=>!g.admittedAt && !g.rejectedAt).length;
            return `${n} waiting`;
        }
    }
};

});

parcelRegister("1XN7N", function(module, exports) {

$parcel$export(module.exports, "MeetNewRoomModal", () => $16e16848e63ad09c$export$fb09d3947d05850f);
// Modal for creating a new meet room. Extends shared-gov's Modal shell.
// Submit calls createRoom which inserts the row, optimistically merges
// into root.rooms, and routes to /meet/:id.
//
// IMPORTANT: reactive getters below route through `_draft(s)` so they
// never throw on the first-pass signal evaluation (when root state may
// not have `newRoomDraft` yet). Optional chaining on `s.root?.X` has
// still been observed to throw `Cannot read properties of undefined
// (reading 'newRoomDraft')` inside smbls v3.14 signal effects, which is
// why we explicitly guard with a try-block helper instead of relying on
// `?.` alone.
const $16e16848e63ad09c$var$_draft = (s)=>{
    try {
        if (!s) return {};
        const root = s.root;
        if (!root) return {};
        return root.newRoomDraft || {};
    } catch  {
        return {};
    }
};
const $16e16848e63ad09c$var$_patch = (s, patch)=>{
    try {
        if (!s || !s.root) return;
        const current = s.root.newRoomDraft || {};
        s.root.update({
            newRoomDraft: {
                ...current,
                ...patch
            }
        });
    } catch (err) {
        console.warn('[MeetNewRoomModal] patch failed', err);
    }
};
const $16e16848e63ad09c$export$fb09d3947d05850f = {
    extends: 'Modal',
    stateKey: 'showNewRoom',
    extraClose: {
        newRoomDraft: null
    },
    Window: {
        width: 'I',
        maxWidth: '90vw',
        gap: 'A',
        ModalHeader: {
            Hgroup: {
                H: {
                    text: 'New call'
                },
                P: {
                    text: "Start a video call. Optionally enable AI transcription \u2014 the call ends with a transcript page that proposes calendar events, tickets, notes, and DMs to follow up on."
                }
            }
        },
        NameField: {
            flow: 'y',
            gap: 'V',
            Label: {
                tag: 'span',
                fontSize: 'Y2',
                color: 'caption',
                text: 'NAME'
            },
            Input: {
                tag: 'input',
                padding: 'Z A',
                round: 'Z',
                borderWidth: '1px',
                borderColor: 'line',
                borderStyle: 'solid',
                background: 'document',
                color: 'title',
                fontSize: 'Z2',
                placeholder: 'e.g. Weekly product sync',
                value: (el, s)=>$16e16848e63ad09c$var$_draft(s).name || '',
                onInput: (e, el, s)=>$16e16848e63ad09c$var$_patch(s, {
                        name: e.target.value
                    })
            }
        },
        TranscribeField: {
            flow: 'x',
            align: 'center space-between',
            gap: 'Z1',
            padding: 'Z 0',
            Label: {
                flow: 'y',
                gap: 'V',
                flex: '1',
                Title: {
                    tag: 'span',
                    fontSize: 'Z2',
                    color: 'title',
                    fontWeight: '500',
                    text: 'AI transcription'
                },
                Caption: {
                    tag: 'span',
                    fontSize: 'Y2',
                    color: 'caption',
                    text: "Records text only \u2014 never raw audio. Decided at creation, not toggleable mid-call."
                }
            },
            Toggle: {
                tag: 'button',
                padding: 'V Z',
                round: 'Z',
                border: 'none',
                cursor: 'pointer',
                fontSize: 'Z2',
                fontWeight: '600',
                theme: (el, s)=>$16e16848e63ad09c$var$_draft(s).transcribeEnabled ? 'primary' : 'secondary',
                text: (el, s)=>$16e16848e63ad09c$var$_draft(s).transcribeEnabled ? 'On' : 'Off',
                onClick: (e, el, s)=>$16e16848e63ad09c$var$_patch(s, {
                        transcribeEnabled: !$16e16848e63ad09c$var$_draft(s).transcribeEnabled
                    })
            }
        },
        PrivateField: {
            flow: 'x',
            align: 'center space-between',
            gap: 'Z1',
            padding: 'Z 0',
            Label: {
                flow: 'y',
                gap: 'V',
                flex: '1',
                Title: {
                    tag: 'span',
                    fontSize: 'Z2',
                    color: 'title',
                    fontWeight: '500',
                    text: 'Private'
                },
                Caption: {
                    tag: 'span',
                    fontSize: 'Y2',
                    color: 'caption',
                    text: 'Only you and explicitly added members can join or read the transcript.'
                }
            },
            Toggle: {
                tag: 'button',
                padding: 'V Z',
                round: 'Z',
                border: 'none',
                cursor: 'pointer',
                fontSize: 'Z2',
                fontWeight: '600',
                theme: (el, s)=>$16e16848e63ad09c$var$_draft(s).isPrivate ? 'primary' : 'secondary',
                text: (el, s)=>$16e16848e63ad09c$var$_draft(s).isPrivate ? 'On' : 'Off',
                onClick: (e, el, s)=>$16e16848e63ad09c$var$_patch(s, {
                        isPrivate: !$16e16848e63ad09c$var$_draft(s).isPrivate
                    })
            }
        },
        ModalFooter: {
            flow: 'x',
            gap: 'Z1',
            StartBtn: {
                extends: 'Button',
                theme: 'primary',
                text: 'Start call',
                onClick: async (e, el, s)=>{
                    const d = $16e16848e63ad09c$var$_draft(s);
                    const name = (d.name || '').trim();
                    if (!name) return;
                    const id = await el.call('createRoom', {
                        name: name,
                        kind: 'room',
                        isPrivate: !!d.isPrivate,
                        transcribeEnabled: !!d.transcribeEnabled
                    });
                    if (!id) return;
                    if (s && s.root) s.root.update({
                        activeRoomId: id,
                        meetView: 'call'
                    });
                    if (typeof window !== 'undefined') history.replaceState(null, '', `#room=${id}&view=call`);
                    el.call('connectCall', id);
                }
            }
        }
    }
};

});

parcelRegister("aFnER", function(module, exports) {

$parcel$export(module.exports, "MeetRoomSettingsModal", () => $0201089bcfe66a90$export$b142495e234d1a9b);
// MeetRoomSettingsModal — owner-only modal for editing an existing room's
// guest-join requirements + privacy flag + name. Opens from the SettingsBtn
// on MeetControlBar (or from the list Detail — wherever we surface it).
//
// Draft is buffered into root.roomSettingsDraft so toggles feel immediate
// without write-on-every-click churn. Save button fires updateRoomSettings
// which hits meet_rooms via RLS. Cancel discards the draft.
//
// Invite link section shows the /meet-guest URL for public rooms and a
// note for private rooms explaining that guests can't join.
// Pull the currently-edited room out of state. When the modal opens we
// seed the draft from this room's current values; reactive getters on
// toggles read the draft (so user changes reflect instantly) and fall
// back to the room value if the draft hasn't been seeded yet.
const $0201089bcfe66a90$var$_editRoom = (root)=>(root?.rooms || []).find((r)=>r.id === root?.activeRoomId) || null;
const $0201089bcfe66a90$var$_draftValue = (root, key)=>{
    const draft = root?.roomSettingsDraft;
    if (draft && key in draft) return draft[key];
    return $0201089bcfe66a90$var$_editRoom(root)?.[key];
};
const $0201089bcfe66a90$var$_patchDraft = (root, patch)=>{
    const current = root?.roomSettingsDraft || {};
    root?.update({
        roomSettingsDraft: {
            ...current,
            ...patch
        }
    });
};
// Toggle row — shared shape for each boolean setting. We define it as a
// plain object factory (called at declaration time) rather than a
// child-extends so every field can pass its own label + key statically.
const $0201089bcfe66a90$var$_toggleField = (key, title, caption)=>({
        flow: 'x',
        align: 'center space-between',
        gap: 'Z1',
        padding: 'Z 0',
        Label: {
            flow: 'y',
            gap: 'V',
            flex: '1',
            Title: {
                tag: 'span',
                fontSize: 'Z2',
                color: 'title',
                fontWeight: '500',
                text: title
            },
            Caption: {
                tag: 'span',
                fontSize: 'Y2',
                color: 'caption',
                text: caption
            }
        },
        Toggle: {
            tag: 'button',
            padding: 'V Z',
            round: 'Z',
            border: 'none',
            cursor: 'pointer',
            fontSize: 'Z2',
            fontWeight: '600',
            theme: (el, s)=>$0201089bcfe66a90$var$_draftValue(s.root, key) ? 'primary' : 'secondary',
            text: (el, s)=>$0201089bcfe66a90$var$_draftValue(s.root, key) ? 'On' : 'Off',
            onClick: (e, el, s)=>$0201089bcfe66a90$var$_patchDraft(s.root, {
                    [key]: !$0201089bcfe66a90$var$_draftValue(s.root, key)
                })
        }
    });
const $0201089bcfe66a90$export$b142495e234d1a9b = {
    extends: 'Modal',
    stateKey: 'showRoomSettings',
    extraClose: {
        roomSettingsDraft: null
    },
    // Seed the draft from the room's current values on open. Modal's display
    // is driven by the stateKey, so onCreate fires once when the element
    // mounts; we check whether the draft is already set and initialize it.
    // The draft is cleared by extraClose when the modal closes.
    onUpdate: (el, s)=>{
        if (!s.root?.showRoomSettings) return;
        if (s.root?.roomSettingsDraft) return;
        const room = $0201089bcfe66a90$var$_editRoom(s.root);
        if (!room) return;
        s.root?.update({
            roomSettingsDraft: {
                name: room.name || '',
                isPrivate: !!room.isPrivate,
                guestRequireName: room.guestRequireName !== false,
                guestRequireEmail: !!room.guestRequireEmail,
                guestAutoAdmit: !!room.guestAutoAdmit,
                guestPassword: room.guestPassword || ''
            }
        });
    },
    Window: {
        width: 'I',
        maxWidth: '90vw',
        gap: 'A',
        ModalHeader: {
            Hgroup: {
                H: {
                    text: 'Room settings'
                },
                P: {
                    text: 'Configure guest join requirements, name, and privacy. Changes apply immediately for new joiners.'
                }
            }
        },
        NameField: {
            flow: 'y',
            gap: 'V',
            Label: {
                tag: 'span',
                fontSize: 'Y2',
                color: 'caption',
                text: 'NAME'
            },
            Input: {
                tag: 'input',
                padding: 'Z A',
                round: 'Z',
                borderWidth: '1px',
                borderColor: 'line',
                borderStyle: 'solid',
                background: 'document',
                color: 'title',
                fontSize: 'Z2',
                placeholder: 'e.g. Weekly product sync',
                value: (el, s)=>$0201089bcfe66a90$var$_draftValue(s.root, 'name') || '',
                onInput: (e, el, s)=>$0201089bcfe66a90$var$_patchDraft(s.root, {
                        name: e.target.value
                    })
            }
        },
        PrivateField: $0201089bcfe66a90$var$_toggleField('isPrivate', 'Private', 'Only members can join. No guest link, no waiting room.'),
        // Guest requirement toggles. Only visible when the room is public —
        // they're meaningless for private rooms where no one outside the
        // member list can get in regardless.
        GuestSection: {
            hide: (el, s)=>!!$0201089bcfe66a90$var$_draftValue(s.root, 'isPrivate'),
            flow: 'y',
            gap: 'Z',
            padding: 'A 0 0 0',
            borderTopWidth: '1px',
            borderTopColor: 'line',
            borderTopStyle: 'solid',
            SectionTitle: {
                tag: 'span',
                fontSize: 'Y2',
                fontWeight: '600',
                letterSpacing: '.07em',
                color: 'caption',
                text: 'GUEST JOIN'
            },
            RequireName: $0201089bcfe66a90$var$_toggleField('guestRequireName', 'Require name', 'Ask guests to enter a name before they can request to join.'),
            RequireEmail: $0201089bcfe66a90$var$_toggleField('guestRequireEmail', 'Require email', 'Ask guests to enter an email too. Stored with the waiting-room request.'),
            AutoAdmit: $0201089bcfe66a90$var$_toggleField('guestAutoAdmit', 'Auto-admit', "Skip the waiting room \u2014 anyone who fills the form joins immediately. Use for low-sensitivity public calls."),
            GuestPasswordField: {
                flow: 'y',
                gap: 'V',
                padding: 'V 0',
                Label: {
                    tag: 'span',
                    fontSize: 'Y2',
                    color: 'caption',
                    text: 'PASSWORD (optional)'
                },
                Input: {
                    tag: 'input',
                    type: 'text',
                    autocomplete: 'off',
                    padding: 'Z A',
                    round: 'Z',
                    borderWidth: '1px',
                    borderColor: 'line',
                    borderStyle: 'solid',
                    background: 'document',
                    color: 'title',
                    fontSize: 'Z2',
                    placeholder: 'Leave blank for no password',
                    value: (el, s)=>$0201089bcfe66a90$var$_draftValue(s.root, 'guestPassword') || '',
                    onInput: (e, el, s)=>$0201089bcfe66a90$var$_patchDraft(s.root, {
                            guestPassword: e.target.value
                        })
                },
                Hint: {
                    tag: 'span',
                    fontSize: 'Y2',
                    color: 'caption',
                    text: 'Guests must type this before the waiting-room request is accepted.'
                }
            },
            InviteLinkField: {
                flow: 'y',
                gap: 'V',
                padding: 'Z 0',
                Label: {
                    tag: 'span',
                    fontSize: 'Y2',
                    color: 'caption',
                    text: 'INVITE LINK'
                },
                Row: {
                    flow: 'x',
                    gap: 'V',
                    align: 'center left',
                    Link: {
                        tag: 'input',
                        flex: '1',
                        padding: 'Z A',
                        round: 'Z',
                        borderWidth: '1px',
                        borderColor: 'line',
                        borderStyle: 'solid',
                        background: 'overlay',
                        color: 'title',
                        fontSize: 'Y2',
                        readonly: 'true',
                        value: (el, s)=>{
                            const id = s.root?.activeRoomId;
                            if (!id || typeof window === 'undefined') return '';
                            return `${window.location.origin}/meet-guest#room=${id}`;
                        },
                        onClick: (e)=>{
                            e.target.select();
                        }
                    },
                    CopyBtn: {
                        tag: 'button',
                        padding: 'Z A',
                        round: 'Z',
                        border: 'none',
                        theme: 'secondary',
                        cursor: 'pointer',
                        fontSize: 'Z2',
                        fontWeight: '600',
                        text: (el, s)=>s.root?.inviteLinkCopied ? 'Copied' : 'Copy',
                        onClick: async (e, el, s)=>{
                            const id = s.root?.activeRoomId;
                            if (!id || typeof window === 'undefined') return;
                            const url = `${window.location.origin}/meet-guest#room=${id}`;
                            try {
                                await navigator.clipboard.writeText(url);
                                s.root?.update({
                                    inviteLinkCopied: true
                                });
                                setTimeout(()=>s.root?.update({
                                        inviteLinkCopied: false
                                    }), 1500);
                            } catch (err) {
                                console.warn('[MeetRoomSettingsModal] clipboard write failed', err);
                            }
                        }
                    }
                }
            }
        },
        PrivateNotice: {
            hide: (el, s)=>!$0201089bcfe66a90$var$_draftValue(s.root, 'isPrivate'),
            padding: 'Z A',
            round: 'Z',
            background: 'overlay',
            color: 'caption',
            fontSize: 'Y2',
            text: 'Private rooms don\'t accept guest joins. Add members explicitly instead.'
        },
        ModalFooter: {
            flow: 'x',
            gap: 'Z1',
            SaveBtn: {
                extends: 'Button',
                theme: 'primary',
                text: 'Save',
                onClick: async (e, el, s)=>{
                    const draft = s.root?.roomSettingsDraft;
                    if (!draft) return;
                    const ok = await el.call('updateRoomSettings', {
                        roomId: s.root?.activeRoomId,
                        name: (draft.name || '').trim() || undefined,
                        isPrivate: draft.isPrivate,
                        guestRequireName: draft.guestRequireName,
                        guestRequireEmail: draft.guestRequireEmail,
                        guestAutoAdmit: draft.guestAutoAdmit,
                        guestPassword: (draft.guestPassword || '').trim()
                    });
                    if (ok) s.root?.update({
                        showRoomSettings: false,
                        roomSettingsDraft: null
                    });
                }
            }
        }
    }
};

});

parcelRegister("4Q18q", function(module, exports) {

$parcel$export(module.exports, "MeetMain", () => $385ce61ff3d1fb21$export$d74df1d124d3de05);
// Right-hand main column for the /meet page. Switches between three views
// driven by root.meetView (list | call | transcript) — single /meet route
// architecture, no separate page files. VideoRoom and TranscriptPage are
// mount-controlled via `if:` so they get clean lifecycle hooks (onCreate
// connects LiveKit, onRemove disconnects).
// Pick the currently-focused room: explicit activeRoomId wins, otherwise
// fall back to the first row in root.rooms so landing on /meet without a
// hash shows real data (not a "pick a call" placeholder).
// Guard against rows with null ids — optimistic placeholders or partial
// realtime payloads can occasionally land in rooms[] before the real id
// arrives, and a fall-back to such a row produces #room=null URLs.
const $385ce61ff3d1fb21$var$_activeRoom = (root)=>{
    const rooms = (root?.rooms || []).filter((r)=>r && r.id);
    const activeId = root?.activeRoomId;
    if (activeId) {
        const explicit = rooms.find((r)=>r.id === activeId);
        if (explicit) return explicit;
    }
    return rooms[0] || null;
};
const $385ce61ff3d1fb21$export$d74df1d124d3de05 = {
    extends: 'AppMain',
    padding: '0',
    Header: {
        extends: 'PageHeader',
        padding: 'A B',
        hide: (el, s)=>s.root?.meetView === 'call',
        LeftGroup: {
            flow: 'y',
            align: 'flex-start left',
            gap: 'V',
            Title: {
                tag: 'h2',
                fontSize: 'B1',
                fontWeight: '600',
                margin: '0',
                color: 'title',
                text: (el, s)=>s.root?.meetView === 'transcript' ? 'Transcript' : 'Calls'
            },
            Caption: {
                tag: 'span',
                fontSize: 'Z2',
                color: 'caption',
                text: (el, s)=>{
                    if (s.root?.meetView === 'transcript') {
                        const room = (s.root?.rooms || []).find((r)=>r.id === s.root?.activeRoomId);
                        return room?.name || '';
                    }
                    const n = (s.root?.rooms || []).length;
                    return `${n} call${n === 1 ? '' : 's'}`;
                }
            }
        },
        RightGroup: {
            hide: (el, s)=>s.root?.meetView !== 'transcript',
            flow: 'x',
            gap: 'Z1',
            // End room from the transcript view — marks the DB row ended_at
            // (visible across the org via realtime) AND disconnects the local
            // LiveKit session if one's still up. Owner-only.
            EndRoomBtn: {
                hide: (el, s)=>{
                    const room = (s.root?.rooms || []).find((r)=>r.id === s.root?.activeRoomId);
                    if (!room) return true;
                    if (room.endedAt) return true;
                    if (room.createdBy && room.createdBy !== s.root?.currentUserId) return true;
                    return false;
                },
                tag: 'button',
                text: 'End room',
                padding: 'Z A',
                round: 'Z',
                borderWidth: '1px',
                borderColor: 'line',
                borderStyle: 'solid',
                background: 'transparent',
                color: 'caption',
                cursor: 'pointer',
                fontSize: 'Z2',
                onClick: async (e, el, s)=>{
                    await el.call('endRoom', s.root?.activeRoomId);
                    await el.call('disconnectCall');
                }
            },
            BackBtn: {
                tag: 'button',
                text: "\u2190 Back to calls",
                padding: 'Z A',
                round: 'Z',
                borderWidth: '1px',
                borderColor: 'line',
                borderStyle: 'solid',
                background: 'transparent',
                color: 'title',
                cursor: 'pointer',
                fontSize: 'Z2',
                onClick: (e, el, s)=>{
                    s.root?.update({
                        meetView: 'list'
                    });
                    if (typeof window !== 'undefined') history.replaceState(null, '', '');
                }
            }
        }
    },
    Body: {
        extends: 'CommonCard',
        padding: '0',
        flex: '1 1 0',
        minHeight: '0',
        overflow: 'hidden',
        flow: 'y',
        // ── Sub-view: transcript ──────────────────────────────────────
        TranscriptView: {
            hide: (el, s)=>!(s.root?.meetView === 'transcript' && !!s.root?.activeRoomId),
            extends: 'MeetTranscriptPage'
        },
        // ── Sub-view: in-call ─────────────────────────────────────────
        // `if:` mount-control so onCreate/onRemove fire on view switch and
        // LiveKit Room state is created/destroyed cleanly.
        // `hide:` keeps the element mounted but invisible when inactive —
        // `if:` + `extends:` does NOT fire onCreate in DOMQL v3.14, so lifecycle
        // hooks on children are unreliable. LiveKit Room connect/disconnect
        // is driven from pages/meet.js at the page level instead, which DOES
        // fire onCreate/onUpdate reliably.
        CallView: {
            hide: (el, s)=>!(s.root?.meetView === 'call' && !!s.root?.activeRoomId),
            extends: 'MeetVideoRoom'
        },
        // ── Sub-view: list (default) ──────────────────────────────────
        // When no activeRoomId is set (first landing), Detail falls back to
        // rooms[0] so the user sees real data instead of a "pick a call"
        // placeholder. Click handlers inside Detail read the same _activeRoom
        // helper and operate on whichever room is currently shown.
        ListView: {
            hide: (el, s)=>s.root?.meetView === 'call' || s.root?.meetView === 'transcript',
            flex: '1 1 0',
            minHeight: '0',
            overflow: 'auto',
            padding: 'B C',
            flow: 'y',
            gap: 'A',
            Empty: {
                hide: (el, s)=>(s.root?.rooms || []).length > 0,
                flow: 'y',
                align: 'center center',
                gap: 'A',
                padding: 'D B',
                color: 'caption',
                fontSize: 'Z2',
                Title: {
                    tag: 'h3',
                    text: 'No calls yet',
                    color: 'title',
                    fontSize: 'B',
                    margin: '0'
                },
                Caption: {
                    tag: 'p',
                    text: 'Click "+ New call" to start your first room.',
                    margin: '0'
                }
            },
            Detail: {
                hide: (el, s)=>!((s.root?.rooms || []).length > 0),
                flow: 'y',
                gap: 'Z1',
                padding: 'A',
                round: 'A',
                borderWidth: '1px',
                borderColor: 'line',
                borderStyle: 'solid',
                background: 'overlayStrong',
                Title: {
                    tag: 'h3',
                    fontSize: 'A',
                    fontWeight: '600',
                    color: 'title',
                    margin: '0',
                    text: (el, s)=>$385ce61ff3d1fb21$var$_activeRoom(s.root)?.name || 'No calls yet'
                },
                Caption: {
                    tag: 'p',
                    fontSize: 'Z2',
                    color: 'caption',
                    margin: '0',
                    hide: (el, s)=>!!$385ce61ff3d1fb21$var$_activeRoom(s.root)?.endedAt,
                    text: (el, s)=>{
                        const room = $385ce61ff3d1fb21$var$_activeRoom(s.root);
                        if (!room) return '';
                        const live = (s.root?.liveParticipants?.[room.id] || []).filter((p)=>!p.leftAt).length;
                        const parts = [];
                        if (live > 0) parts.push(`${live} participant${live === 1 ? '' : 's'} live`);
                        if (room.transcribeEnabled) parts.push('AI transcription on');
                        if (room.isPrivate) parts.push('Private');
                        return parts.join(" \xb7 ") || room.kind;
                    }
                },
                // Prominent banner shown when the room is ended.
                EndedNotice: {
                    hide: (el, s)=>!$385ce61ff3d1fb21$var$_activeRoom(s.root)?.endedAt,
                    flow: 'x',
                    align: 'center left',
                    gap: 'Z',
                    padding: 'Z A',
                    round: 'Z',
                    background: 'overlay',
                    borderWidth: '1px',
                    borderColor: 'line',
                    borderStyle: 'solid',
                    Icon: {
                        icon: 'recordstop',
                        boxSize: 'Z2'
                    },
                    Label: {
                        tag: 'span',
                        fontSize: 'Z2',
                        color: 'caption',
                        flex: '1',
                        text: 'This room has ended'
                    }
                },
                // Pending guests strip — owner-only. Visible in the list view so the
                // host knows guests are waiting even before joining the call.
                // Admit / Reject use the same MeetWaitingGuestRow registered component
                // as the in-call banner.
                WaitingSection: {
                    hide: (el, s)=>{
                        const room = $385ce61ff3d1fb21$var$_activeRoom(s.root);
                        if (!room) return true;
                        if (!room.createdBy || room.createdBy !== s.root?.currentUserId) return true;
                        const pending = (s.root?.waitingRoom?.[room.id] || []).filter((g)=>!g.admittedAt && !g.rejectedAt);
                        return pending.length === 0;
                    },
                    flow: 'y',
                    gap: 'Z',
                    padding: 'Z A',
                    round: 'Z',
                    background: 'overlay',
                    borderWidth: '1px',
                    borderColor: 'orange',
                    borderStyle: 'solid',
                    Header: {
                        flow: 'x',
                        align: 'center left',
                        gap: 'V',
                        Icon: {
                            tag: 'span',
                            text: "\uD83D\uDC4B",
                            fontSize: 'Z2'
                        },
                        Label: {
                            tag: 'span',
                            fontSize: 'Y2',
                            fontWeight: '600',
                            color: 'title',
                            text: (el, s)=>{
                                const room = $385ce61ff3d1fb21$var$_activeRoom(s.root);
                                const n = (s.root?.waitingRoom?.[room?.id] || []).filter((g)=>!g.admittedAt && !g.rejectedAt).length;
                                return `${n} guest${n === 1 ? '' : 's'} waiting`;
                            }
                        }
                    },
                    GuestList: {
                        flow: 'y',
                        gap: 'V',
                        childrenAs: 'state',
                        children: (el, s)=>{
                            const room = $385ce61ff3d1fb21$var$_activeRoom(s.root);
                            if (!room) return [];
                            return (s.root?.waitingRoom?.[room.id] || []).filter((g)=>!g.admittedAt && !g.rejectedAt);
                        },
                        childExtends: 'MeetWaitingGuestRow'
                    }
                },
                Actions: {
                    flow: 'x',
                    gap: 'Z1',
                    marginTop: 'Z',
                    Join: {
                        tag: 'button',
                        text: 'Join call',
                        padding: 'Z B',
                        round: 'Z',
                        border: 'none',
                        theme: 'primary',
                        cursor: 'pointer',
                        fontSize: 'Z2',
                        fontWeight: '600',
                        hide: (el, s)=>{
                            const room = $385ce61ff3d1fb21$var$_activeRoom(s.root);
                            if (!room) return true;
                            return !!room.endedAt;
                        },
                        onClick: (e, el, s)=>{
                            const room = $385ce61ff3d1fb21$var$_activeRoom(s.root);
                            if (!room) return;
                            s.root?.update({
                                activeRoomId: room.id,
                                meetView: 'call'
                            });
                            if (typeof window !== 'undefined') history.replaceState(null, '', `#room=${room.id}&view=call`);
                            el.call('connectCall', room.id);
                        }
                    },
                    Transcript: {
                        tag: 'button',
                        text: 'View transcript',
                        padding: 'Z B',
                        round: 'Z',
                        borderWidth: '1px',
                        borderColor: 'line',
                        borderStyle: 'solid',
                        background: 'transparent',
                        color: 'title',
                        cursor: 'pointer',
                        fontSize: 'Z2',
                        hide: (el, s)=>!$385ce61ff3d1fb21$var$_activeRoom(s.root)?.transcribeEnabled,
                        onClick: (e, el, s)=>{
                            const room = $385ce61ff3d1fb21$var$_activeRoom(s.root);
                            if (!room) return;
                            s.root?.update({
                                activeRoomId: room.id,
                                meetView: 'transcript'
                            });
                            if (typeof window !== 'undefined') history.replaceState(null, '', `#room=${room.id}&view=transcript`);
                        }
                    },
                    // End / Reopen room — owner-only (RLS enforces). For ended rooms,
                    // swap to a "Reopen" button so the same slot serves both states.
                    // Also fully disconnects the local LiveKit session — ending a
                    // room should log you out completely, not just switch state.
                    // Settings — owner-only. Opens the room settings modal; writes
                    // activeRoomId first so the modal seeds from the right room even
                    // when Detail is falling back to rooms[0].
                    SettingsBtn: {
                        hide: (el, s)=>{
                            const room = $385ce61ff3d1fb21$var$_activeRoom(s.root);
                            if (!room) return true;
                            if (room.createdBy && room.createdBy !== s.root?.currentUserId) return true;
                            return false;
                        },
                        tag: 'button',
                        text: 'Settings',
                        padding: 'Z B',
                        round: 'Z',
                        borderWidth: '1px',
                        borderColor: 'line',
                        borderStyle: 'solid',
                        background: 'transparent',
                        color: 'title',
                        cursor: 'pointer',
                        fontSize: 'Z2',
                        onClick: (e, el, s)=>{
                            const room = $385ce61ff3d1fb21$var$_activeRoom(s.root);
                            if (!room) return;
                            s.root?.update({
                                activeRoomId: room.id,
                                showRoomSettings: true
                            });
                        }
                    },
                    EndRoomBtn: {
                        hide: (el, s)=>{
                            const room = $385ce61ff3d1fb21$var$_activeRoom(s.root);
                            if (!room) return true;
                            if (room.endedAt) return true // ended → show Reopen instead
                            ;
                            if (room.createdBy && room.createdBy !== s.root?.currentUserId) return true;
                            return false;
                        },
                        tag: 'button',
                        text: 'End room',
                        padding: 'Z B',
                        round: 'Z',
                        borderWidth: '1px',
                        borderColor: 'red',
                        borderStyle: 'solid',
                        background: 'transparent',
                        color: 'red',
                        cursor: 'pointer',
                        fontSize: 'Z2',
                        fontWeight: '600',
                        onClick: async (e, el, s)=>{
                            const room = $385ce61ff3d1fb21$var$_activeRoom(s.root);
                            if (!room) return;
                            await el.call('endRoom', room.id);
                            await el.call('disconnectCall');
                        }
                    },
                    ReopenRoomBtn: {
                        hide: (el, s)=>{
                            const room = $385ce61ff3d1fb21$var$_activeRoom(s.root);
                            if (!room) return true;
                            if (!room.endedAt) return true;
                            if (room.createdBy && room.createdBy !== s.root?.currentUserId) return true;
                            return false;
                        },
                        tag: 'button',
                        text: 'Reopen',
                        padding: 'Z B',
                        round: 'Z',
                        border: 'none',
                        theme: 'secondary',
                        cursor: 'pointer',
                        fontSize: 'Z2',
                        fontWeight: '600',
                        onClick: async (e, el, s)=>{
                            const room = $385ce61ff3d1fb21$var$_activeRoom(s.root);
                            if (room) await el.call('reopenRoom', room.id);
                        }
                    },
                    // Recreate — visible to everyone when a room is ended. Creates a new
                    // room with the same name and settings (fresh ID, clean state) and
                    // immediately joins the call. Non-owners don't have Reopen, so this
                    // gives them a quick path to continue the conversation.
                    RecreateBtn: {
                        hide: (el, s)=>!$385ce61ff3d1fb21$var$_activeRoom(s.root)?.endedAt,
                        tag: 'button',
                        text: '+ New call',
                        padding: 'Z B',
                        round: 'Z',
                        borderWidth: '1px',
                        borderColor: 'line',
                        borderStyle: 'solid',
                        background: 'transparent',
                        color: 'title',
                        cursor: 'pointer',
                        fontSize: 'Z2',
                        onClick: async (e, el, s)=>{
                            const room = $385ce61ff3d1fb21$var$_activeRoom(s.root);
                            if (!room) return;
                            const newId = await el.call('createRoom', {
                                name: room.name,
                                kind: room.kind,
                                isPrivate: room.isPrivate,
                                transcribeEnabled: room.transcribeEnabled
                            });
                            if (!newId) return;
                            s.root?.update({
                                activeRoomId: newId,
                                meetView: 'call'
                            });
                            if (typeof window !== 'undefined') history.replaceState(null, '', `#room=${newId}&view=call`);
                            el.call('connectCall', newId);
                        }
                    }
                }
            }
        }
    }
};

});

parcelRegister("9lpBv", function(module, exports) {

$parcel$export(module.exports, "MeetVideoRoom", () => $6cd9ef9d4b189d92$export$b0815be782ee317e);
// MeetVideoRoom — renders the in-call UI tree (header, tile grid, captions,
// control bar). LiveKit Room construction + connect/disconnect lifecycle
// lives at the page level in pages/meet.js (DOMQL v3.14 doesn't fire onCreate
// reliably on `if:`/`extends:` children, so we can't do lifecycle here).
//
// The live Room instance is stashed on `root._livekitRoom` by the page, and
// participants are mirrored to `root.livekitParticipants`. This component
// just renders from that state.
const $6cd9ef9d4b189d92$export$b0815be782ee317e = {
    padding: '0',
    flow: 'y',
    flex: '1 1 0',
    minHeight: '0',
    position: 'relative',
    Header: {
        flow: 'x',
        align: 'center space-between',
        padding: 'A B1',
        borderBottomWidth: '1px',
        borderBottomColor: 'line',
        borderBottomStyle: 'solid',
        Title: {
            tag: 'h2',
            fontSize: 'A1',
            fontWeight: '600',
            margin: '0',
            color: 'title',
            text: (el, s)=>{
                const room = (s.root?.rooms || []).find((r)=>r.id === s.root?.activeRoomId);
                return room?.name || 'Call';
            }
        },
        TranscribeBadge: {
            hide: (el, s)=>{
                const room = (s.root?.rooms || []).find((r)=>r.id === s.root?.activeRoomId);
                return !room?.transcribeEnabled;
            },
            tag: 'span',
            padding: 'V Z',
            round: 'Y',
            background: 'cyan',
            color: 'white',
            fontSize: 'Y1',
            fontWeight: '600',
            letterSpacing: '.05em',
            textTransform: 'uppercase',
            text: "\u25CF Transcribing"
        }
    },
    // Waiting-room strip — pinned below the header. Owner-only; hidden when
    // no pending guest requests.
    MeetWaitingRoomBanner: {},
    // Reactive grid of tiles. Layout adapts via getRoomMode based on the
    // participant count — for the MVP we just use a flex wrap and let the
    // tiles size themselves.
    TileGrid: {
        flex: '1 1 0',
        minHeight: '0',
        overflow: 'auto',
        padding: 'Z1',
        display: 'grid',
        gap: 'A',
        gridTemplateColumns: (el, s)=>{
            const n = (s.root?.livekitParticipants || []).length || 1;
            if (n <= 1) return '1fr';
            if (n <= 4) return 'repeat(2, 1fr)';
            if (n <= 9) return 'repeat(3, 1fr)';
            return 'repeat(4, 1fr)';
        },
        childExtends: 'MeetParticipantTile',
        childrenAs: 'state',
        children: (el, s)=>s.root?.livekitParticipants || []
    },
    // Shown when the active room is ended (host ended it remotely while you're
    // still in the call view, or you navigated back into an ended room).
    EndedOverlay: {
        hide: (el, s)=>{
            const room = (s.root?.rooms || []).find((r)=>r.id === s.root?.activeRoomId);
            return !room?.endedAt;
        },
        position: 'absolute',
        inset: '0',
        align: 'center center',
        background: 'black.7',
        backdropFilter: 'blur(8px)',
        flow: 'y',
        gap: 'Z1',
        color: 'white',
        Icon: {
            icon: 'recordstop',
            boxSize: 'C'
        },
        Text: {
            tag: 'p',
            margin: '0',
            fontSize: 'A1',
            fontWeight: '600',
            text: 'This room has ended'
        },
        Sub: {
            tag: 'p',
            margin: '0',
            fontSize: 'Z2',
            color: 'white.6',
            text: 'The call has been closed by the host.'
        },
        Actions: {
            flow: 'x',
            gap: 'Z1',
            marginTop: 'Z',
            TranscriptBtn: {
                hide: (el, s)=>{
                    const id = s.root?.activeRoomId;
                    if (!id) return true;
                    const room = (s.root?.rooms || []).find((r)=>r.id === id);
                    return !room?.transcribeEnabled;
                },
                tag: 'button',
                text: 'View transcript',
                padding: 'Z B',
                round: 'Z',
                borderWidth: '1px',
                borderColor: 'white.3',
                borderStyle: 'solid',
                background: 'transparent',
                color: 'white',
                cursor: 'pointer',
                fontSize: 'Z2',
                onClick: (e, el, s)=>{
                    const id = s.root?.activeRoomId;
                    if (!id) return;
                    s.root?.update({
                        meetView: 'transcript'
                    });
                    if (typeof window !== 'undefined') history.replaceState(null, '', `#room=${id}&view=transcript`);
                }
            },
            BackBtn: {
                tag: 'button',
                text: 'Back to calls',
                padding: 'Z B',
                round: 'Z',
                border: 'none',
                theme: 'primary',
                cursor: 'pointer',
                fontSize: 'Z2',
                fontWeight: '600',
                onClick: (e, el, s)=>{
                    s.root?.update({
                        meetView: 'list',
                        activeRoomId: null
                    });
                    if (typeof window !== 'undefined') history.replaceState(null, '', '');
                }
            }
        }
    },
    ErrorOverlay: {
        hide: (el, s)=>!s.root?.meetCallError,
        position: 'absolute',
        inset: '0',
        align: 'center center',
        background: 'black.6',
        backdropFilter: 'blur(8px)',
        flow: 'y',
        gap: 'Z1',
        color: 'white',
        Text: {
            tag: 'p',
            margin: '0',
            fontSize: 'A',
            text: (el, s)=>`Couldn't join: ${s.root?.meetCallError}`
        },
        BackBtn: {
            tag: 'button',
            text: 'Back to calls',
            padding: 'Z B',
            round: 'Z',
            border: 'none',
            theme: 'primary',
            cursor: 'pointer',
            onClick: (e, el, s)=>{
                s.root?.update({
                    meetCallError: null,
                    meetView: 'list',
                    activeRoomId: null
                });
            }
        }
    },
    MeetLiveCaptions: {},
    MeetControlBar: {}
};

});

parcelRegister("9rrZ0", function(module, exports) {

$parcel$export(module.exports, "MeetParticipantTile", () => $6dfc577dd925c3b6$export$72ba11ad920fca94);
// MeetParticipantTile — renders one participant in the VideoRoom grid.
// Uses a real <video> element; on render attaches the participant's video
// track via livekit-client's track.attach() helper. The live Room instance
// comes from the connectCall module (NOT from state — smbls strips methods
// when objects go through the reactive proxy).

var $3q4bW = parcelRequire("3q4bW");
// Helper to iterate a participant's track publications. LiveKit's
// `videoTrackPublications` / `audioTrackPublications` may be a Map or a
// plain object depending on version — handle both.
const $6dfc577dd925c3b6$var$_iterPubs = (obj)=>{
    if (!obj) return [];
    if (typeof obj.values === 'function') return [
        ...obj.values()
    ];
    return Object.values(obj);
};
// Attach a track once. track.attach() reassigns srcObject with a fresh
// MediaStream every call, which causes visible flicker when onRender runs
// repeatedly. Tag the element with the last-attached trackSid and bail on
// matching calls. Detach + re-attach only when the track actually changes
// (e.g. participant republishes after a mute toggle).
const $6dfc577dd925c3b6$var$_attachVideoTrack = (videoEl, room, identity, isLocal)=>{
    if (!videoEl || !room) return;
    const participant = isLocal ? room.localParticipant : typeof room.remoteParticipants?.get === 'function' ? room.remoteParticipants.get(identity) : room.remoteParticipants?.[identity];
    if (!participant) return;
    let targetPub = null;
    for (const pub of $6dfc577dd925c3b6$var$_iterPubs(participant.videoTrackPublications))if (pub.track && (pub.source === 'camera' || pub.kind === 'video')) {
        targetPub = pub;
        break;
    }
    const currentSid = videoEl._lkTrackSid || null;
    const targetSid = targetPub?.trackSid || null;
    if (currentSid === targetSid) return; // already attached to this exact track
    // Track changed (or removed). Detach the old and attach the new.
    if (videoEl._lkTrack) try {
        videoEl._lkTrack.detach(videoEl);
    } catch  {}
    if (targetPub?.track) try {
        targetPub.track.attach(videoEl);
        videoEl._lkTrack = targetPub.track;
        videoEl._lkTrackSid = targetSid;
    } catch (err) {
        console.warn('[tile] video attach failed', err);
    }
    else {
        videoEl._lkTrack = null;
        videoEl._lkTrackSid = null;
    }
};
const $6dfc577dd925c3b6$var$_attachAudioTrack = (audioEl, room, identity, isLocal)=>{
    if (!audioEl || !room || isLocal) return; // never play back local audio
    const participant = typeof room.remoteParticipants?.get === 'function' ? room.remoteParticipants.get(identity) : room.remoteParticipants?.[identity];
    if (!participant) return;
    let targetPub = null;
    for (const pub of $6dfc577dd925c3b6$var$_iterPubs(participant.audioTrackPublications))if (pub.track) {
        targetPub = pub;
        break;
    }
    const currentSid = audioEl._lkTrackSid || null;
    const targetSid = targetPub?.trackSid || null;
    if (currentSid === targetSid) return;
    if (audioEl._lkTrack) try {
        audioEl._lkTrack.detach(audioEl);
    } catch  {}
    if (targetPub?.track) try {
        targetPub.track.attach(audioEl);
        audioEl._lkTrack = targetPub.track;
        audioEl._lkTrackSid = targetSid;
    } catch (err) {
        console.warn('[tile] audio attach failed', err);
    }
    else {
        audioEl._lkTrack = null;
        audioEl._lkTrackSid = null;
    }
};
const $6dfc577dd925c3b6$export$72ba11ad920fca94 = {
    flow: 'y',
    align: 'center center',
    position: 'relative',
    round: 'A',
    overflow: 'hidden',
    background: 'black',
    minHeight: 'F1',
    // Intentionally NO reactive border/transform/outline on the tile root —
    // any reactive prop at this level re-evaluates the whole element on
    // speaker-change events and can cascade into a video re-attach. The
    // speaker ring is an absolute-positioned overlay below, so toggling it
    // only touches that overlay's border, not the tile or the video element.
    onRender: (el, s)=>{
        // Re-attach tracks on every render. `track.attach()` is idempotent.
        const room = (0, $3q4bW.getLivekitRoom)();
        if (!room) return;
        const node = el.node;
        if (!node) return;
        const videoEl = node.querySelector('video');
        const audioEl = node.querySelector('audio');
        $6dfc577dd925c3b6$var$_attachVideoTrack(videoEl, room, s.identity, s.isLocal);
        $6dfc577dd925c3b6$var$_attachAudioTrack(audioEl, room, s.identity, s.isLocal);
    },
    VideoEl: {
        tag: 'video',
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        attr: {
            autoplay: 'autoplay',
            playsinline: 'playsinline',
            // Local video always muted (feedback prevention). Use `s.isLocal`
            // on the tile's own state — `s.parent?.state` was wrong; in smbls
            // child elements inherit the parent's state scope as `s` directly.
            muted: (el, s)=>s.isLocal ? 'muted' : null
        }
    },
    AudioEl: {
        tag: 'audio',
        hide: (el, s)=>!!s.isLocal,
        attr: {
            autoplay: 'autoplay'
        }
    },
    // Camera-off fallback: shows initials on a gray disc. Reads `s.name`
    // and `s.isLocal` directly from the tile's state — not `s.parent`.
    CameraOff: {
        hide: (el, s)=>!!s.isCameraEnabled,
        position: 'absolute',
        inset: '0',
        align: 'center center',
        flow: 'y',
        gap: 'Z1',
        color: 'white',
        background: 'black.7',
        InitialsCircle: {
            width: 'D',
            height: 'D',
            round: '100%',
            align: 'center center',
            background: 'gray',
            fontSize: 'B',
            fontWeight: '700',
            color: 'white',
            text: (el, s)=>{
                // The participant name is what LiveKit received (which is the
                // user's email for governance users, "Guest Name" for external
                // guests). Resolve via root.people → display name first so
                // initials come out correct for both.
                const people = s.root?.people || [];
                const match = people.find((p)=>p.email === s.name);
                const displayName = match?.name || s.name || s.identity || '';
                const initials = displayName.split(/\s+/).filter(Boolean).slice(0, 2).map((p)=>p[0]).join('').toUpperCase();
                return initials || '?';
            }
        }
    },
    // Active-speaker ring. Absolute-positioned overlay so toggling its
    // border doesn't touch the video element or the tile root — prevents
    // video re-attach on every spoken syllable.
    SpeakerRing: {
        position: 'absolute',
        inset: '0',
        round: 'A',
        pointerEvents: 'none',
        borderStyle: 'solid',
        borderWidth: '3px',
        borderColor: (el, s)=>s.root?.livekitSpeakers?.[s.identity] ? 'green' : 'transparent',
        transition: 'border-color .15s linear'
    },
    Footer: {
        position: 'absolute',
        bottom: '0',
        left: '0',
        right: '0',
        padding: 'V Z',
        flow: 'x',
        align: 'center space-between',
        gap: 'Z',
        background: 'black.6',
        color: 'white',
        fontSize: 'Z2',
        Name: {
            tag: 'span',
            flex: '1',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>{
                // Resolve to display name via root.people (falls back to the
                // raw participant name which is the email for governance users).
                const people = s.root?.people || [];
                const match = people.find((p)=>p.email === s.name);
                const display = match?.name || s.name || s.identity || '';
                return display + (s.isLocal ? ' (you)' : '');
            }
        },
        MicIcon: {
            tag: 'span',
            fontSize: 'Z',
            text: (el, s)=>s.isMicEnabled ? "\uD83C\uDFA4" : "\uD83D\uDEAB"
        }
    }
};

});

parcelRegister("WT6Go", function(module, exports) {

$parcel$export(module.exports, "MeetControlBarIconButton", () => $0b1029f453f285f8$export$bb6aa4513123b2a9);
$parcel$export(module.exports, "MeetControlBarTextButton", () => $0b1029f453f285f8$export$9d7df239912ff82d);
$parcel$export(module.exports, "MeetControlBar", () => $0b1029f453f285f8$export$1d9af737c9f9e7fd);
// MeetControlBar — bottom strip with mic / cam / leave controls. The live
// LiveKit Room is fetched via getLivekitRoom() from the connectCall module
// (storing the Room on reactive state strips its methods).
//
// Shared button styling:
//  - MeetControlBarIconButton: round icon-button base used by mic/cam/screen/
//    captions/share-link/settings. All circular 'C'x'C' with boxSize 'B' icons.
//  - MeetControlBarTextButton:  rectangular text-button base used by End / Leave.
// Both are registered via key name so `extends: 'MeetControlBarIconButton'`
// resolves through the smbls component registry.

var $3q4bW = parcelRequire("3q4bW");

var $bfqVY = parcelRequire("bfqVY");
const $0b1029f453f285f8$var$_findRoom = ()=>(0, $3q4bW.getLivekitRoom)();
const $0b1029f453f285f8$export$bb6aa4513123b2a9 = {
    tag: 'button',
    padding: 'Z',
    round: '100%',
    border: 'none',
    cursor: 'pointer',
    fontSize: 'A',
    width: 'C',
    height: 'C',
    align: 'center center',
    theme: 'secondary'
};
const $0b1029f453f285f8$export$9d7df239912ff82d = {
    tag: 'button',
    padding: 'Z B',
    round: 'Z',
    border: 'none',
    cursor: 'pointer',
    fontSize: 'Z2',
    fontWeight: '600'
};
const $0b1029f453f285f8$export$1d9af737c9f9e7fd = {
    flow: 'x',
    align: 'center center',
    gap: 'A',
    padding: 'A',
    borderTopWidth: '1px',
    borderTopColor: 'line',
    borderTopStyle: 'solid',
    background: 'overlayStrong',
    MicBtn: {
        extends: 'MeetControlBarIconButton',
        theme: (el, s)=>{
            const me = (s.root?.livekitParticipants || []).find((p)=>p.isLocal);
            return me?.isMicEnabled ? 'secondary' : 'tertiary';
        },
        Icon: {
            icon: (el, s)=>{
                const me = (s.root?.livekitParticipants || []).find((p)=>p.isLocal);
                return me?.isMicEnabled ? 'mic' : 'micOff';
            }
        },
        title: 'Toggle mic',
        onClick: async (e, el, s)=>{
            const room = $0b1029f453f285f8$var$_findRoom();
            if (!room) return;
            const enabled = room.localParticipant.isMicrophoneEnabled;
            await room.localParticipant.setMicrophoneEnabled(!enabled);
        }
    },
    CamBtn: {
        extends: 'MeetControlBarIconButton',
        theme: (el, s)=>{
            const me = (s.root?.livekitParticipants || []).find((p)=>p.isLocal);
            return me?.isCameraEnabled ? 'secondary' : 'tertiary';
        },
        Icon: {
            icon: (el, s)=>{
                const me = (s.root?.livekitParticipants || []).find((p)=>p.isLocal);
                return me?.isCameraEnabled ? 'video' : 'videoOff';
            }
        },
        title: 'Toggle camera',
        onClick: async (e, el, s)=>{
            const room = $0b1029f453f285f8$var$_findRoom();
            if (!room) return;
            const enabled = room.localParticipant.isCameraEnabled;
            await room.localParticipant.setCameraEnabled(!enabled);
        }
    },
    ScreenBtn: {
        extends: 'MeetControlBarIconButton',
        Icon: {
            icon: 'shareScreen'
        },
        title: 'Share screen',
        onClick: async (e, el, s)=>{
            const room = $0b1029f453f285f8$var$_findRoom();
            if (!room) return;
            try {
                const enabled = room.localParticipant.isScreenShareEnabled;
                await room.localParticipant.setScreenShareEnabled(!enabled);
            } catch (err) {
                console.warn('[MeetControlBar] screen share failed', err);
            }
        }
    },
    // Show/hide the live captions overlay. Only rendered when the room is
    // transcribed. Default state is "on" — initialized by pages/meet.js.
    CaptionsBtn: {
        extends: 'MeetControlBarIconButton',
        hide: (el, s)=>{
            const room = (s.root?.rooms || []).find((r)=>r.id === s.root?.activeRoomId);
            return !room?.transcribeEnabled;
        },
        theme: (el, s)=>s.root?.showLiveCaptions === false ? 'tertiary' : 'secondary',
        Icon: {
            icon: 'closedCaption'
        },
        title: 'Toggle captions',
        onClick: (e, el, s)=>{
            s.root?.update({
                showLiveCaptions: !(s.root?.showLiveCaptions !== false)
            });
        }
    },
    // Share-link button — only for public rooms, copies the /meet-guest link
    // to the clipboard so the host can send it to external attendees.
    ShareLinkBtn: {
        extends: 'MeetControlBarIconButton',
        hide: (el, s)=>{
            const room = (s.root?.rooms || []).find((r)=>r.id === s.root?.activeRoomId);
            return !room || room.isPrivate;
        },
        Icon: {
            icon: (el, s)=>s.root?.shareLinkCopied ? 'checkmark' : 'link'
        },
        title: 'Copy guest link',
        onClick: async (e, el, s)=>{
            const id = s.root?.activeRoomId;
            if (!id || typeof window === 'undefined') return;
            const url = `${window.location.origin}/meet-guest#room=${id}`;
            try {
                await navigator.clipboard.writeText(url);
                s.root?.update({
                    shareLinkCopied: true
                });
                setTimeout(()=>s.root?.update({
                        shareLinkCopied: false
                    }), 1500);
            } catch (err) {
                console.warn('[MeetControlBar] clipboard write failed', err);
            }
        }
    },
    // Open the room settings modal. Owner-only — non-owners can't modify
    // guest requirements. RLS enforces the write on the server anyway.
    SettingsBtn: {
        extends: 'MeetControlBarIconButton',
        hide: (el, s)=>{
            const room = (s.root?.rooms || []).find((r)=>r.id === s.root?.activeRoomId);
            if (!room) return true;
            if (room.createdBy && room.createdBy !== s.root?.currentUserId) return true;
            return false;
        },
        Icon: {
            icon: 'settings'
        },
        title: 'Room settings',
        onClick: (e, el, s)=>s.root?.update({
                showRoomSettings: true
            })
    },
    // End room — owner-only, distinct from Leave. "Leave" disconnects MY
    // local session but the room stays open for others. "End room" marks
    // the DB row ended_at so it drops out of the active list for everyone
    // (others still physically connected to LiveKit stay until they
    // individually disconnect — LiveKit doesn't auto-kick on ended_at;
    // that's a future enhancement via RoomServiceClient.deleteRoom).
    EndRoomBtn: {
        extends: 'MeetControlBarTextButton',
        hide: (el, s)=>{
            const room = (s.root?.rooms || []).find((r)=>r.id === s.root?.activeRoomId);
            if (!room) return true;
            if (room.endedAt) return true;
            // Owner-only. RLS enforces the write, but hide the button so non-owners
            // don't see a disabled-looking control.
            if (room.createdBy && room.createdBy !== s.root?.currentUserId) return true;
            return false;
        },
        border: null,
        borderWidth: '1px',
        borderColor: 'red',
        borderStyle: 'solid',
        background: 'transparent',
        color: 'red',
        text: 'End room',
        title: 'Mark the room as ended (owner only)',
        onClick: async (e, el, s)=>{
            const activeId = s.root?.activeRoomId;
            const isTranscribed = (s.root?.rooms || []).find((r)=>r.id === activeId)?.transcribeEnabled;
            // 1) Mark the row ended in the DB (visible across the org via realtime)
            await el.call('endRoom', activeId);
            // 2) Disconnect my own LiveKit session
            await el.call('disconnectCall');
            // 3) Route to transcript if there was transcription, otherwise back
            //    to the room list.
            s.root?.update({
                meetView: isTranscribed ? 'transcript' : 'list'
            });
            if (typeof window !== 'undefined') history.replaceState(null, '', isTranscribed ? `#room=${activeId}&view=transcript` : '');
        }
    },
    LeaveBtn: {
        extends: 'MeetControlBarTextButton',
        background: 'red',
        color: 'white',
        text: 'Leave',
        onClick: async (e, el, s)=>{
            const activeId = s.root?.activeRoomId;
            const isTranscribed = (s.root?.rooms || []).find((r)=>r.id === activeId)?.transcribeEnabled;
            await el.call('disconnectCall');
            s.root?.update({
                meetView: isTranscribed ? 'transcript' : 'list',
                analyzing: isTranscribed
            });
            if (typeof window !== 'undefined') history.replaceState(null, '', isTranscribed ? `#room=${activeId}&view=transcript` : '');
            if (isTranscribed) // Fetch transcript utterances + fire analysis, populate root state
            // directly (we can't rely on realtime subscription scope because
            // subscribeMeetRealtime scope isn't re-evaluated on view transitions).
            // migrated 2026-04-27 to SDK route workspaceProject.meet.utterances
            try {
                const utterances = await (0, $bfqVY.getSDK)().execute('workspaceProject.meet.utterances', 'list', {
                    roomId: activeId
                });
                s.root?.update({
                    utterances: (utterances || []).map((r)=>({
                            id: r.id,
                            roomId: r.room_id,
                            userId: r.user_id,
                            speakerName: r.speaker_name || '',
                            text: r.text || '',
                            startedAt: r.started_at,
                            endedAt: r.ended_at,
                            confidence: r.confidence
                        }))
                });
                const analysis = await el.call('analyzeTranscript', activeId);
                s.root?.update({
                    analyzing: false,
                    analysis: analysis
                });
            } catch (err) {
                console.error('[ControlBar.Leave] analysis load failed', err);
                s.root?.update({
                    analyzing: false,
                    analyzeError: err?.message || 'analysis failed'
                });
            }
        }
    }
};

});

parcelRegister("dyc8B", function(module, exports) {

$parcel$export(module.exports, "MeetWaitingRoomBanner", () => $9dd7dda38f4b15e8$export$b935441c486706a);
$parcel$export(module.exports, "MeetWaitingGuestRow", () => $9dd7dda38f4b15e8$export$89372136df411cce);
// MeetWaitingRoomBanner — pinned strip showing pending guest requests for
// the currently-active room. Host-only: visible when the current user is
// the room owner AND there's at least one unresolved meet_waiting_room row
// for this room in root.waitingRoom[roomId].
//
// Realtime subscription is set up in pages/meet.js via subscribeMeetRealtime
// with 'meet_waiting_room' in the tables list. The banner reads
// root.waitingRoom[roomId], filters to pending (no admitted_at, no rejected_at),
// and renders a row per guest with Admit / Reject buttons.
//
// Rendered inside VideoRoom so it appears in-call. For the list view we
// could surface a small indicator on the room row — future enhancement.
const $9dd7dda38f4b15e8$var$_pendingGuests = (root, roomId)=>{
    const list = root?.waitingRoom?.[roomId] || [];
    return list.filter((g)=>!g.admittedAt && !g.rejectedAt);
};
const $9dd7dda38f4b15e8$var$_isRoomOwner = (root)=>{
    const room = (root?.rooms || []).find((r)=>r.id === root?.activeRoomId);
    if (!room) return false;
    if (!room.createdBy) return false;
    return room.createdBy === root?.currentUserId;
};
const $9dd7dda38f4b15e8$export$b935441c486706a = {
    hide: (el, s)=>{
        if (!$9dd7dda38f4b15e8$var$_isRoomOwner(s.root)) return true;
        return $9dd7dda38f4b15e8$var$_pendingGuests(s.root, s.root?.activeRoomId).length === 0;
    },
    flow: 'y',
    gap: 'V',
    padding: 'Z A',
    borderBottomWidth: '1px',
    borderBottomColor: 'line',
    borderBottomStyle: 'solid',
    background: 'overlayStrong',
    Header: {
        flow: 'x',
        align: 'center left',
        gap: 'V',
        padding: 'V 0',
        Icon: {
            tag: 'span',
            text: "\uD83D\uDC4B",
            fontSize: 'Z2'
        },
        Label: {
            tag: 'span',
            fontSize: 'Y2',
            fontWeight: '600',
            letterSpacing: '.07em',
            color: 'caption',
            text: (el, s)=>{
                const n = $9dd7dda38f4b15e8$var$_pendingGuests(s.root, s.root?.activeRoomId).length;
                return `WAITING TO JOIN \xb7 ${n}`;
            }
        }
    },
    GuestList: {
        flow: 'y',
        gap: 'V',
        childrenAs: 'state',
        children: (el, s)=>$9dd7dda38f4b15e8$var$_pendingGuests(s.root, s.root?.activeRoomId),
        childExtends: 'MeetWaitingGuestRow'
    }
};
const $9dd7dda38f4b15e8$export$89372136df411cce = {
    flow: 'x',
    align: 'center space-between',
    gap: 'Z1',
    padding: 'V Z',
    round: 'Z',
    background: 'document',
    borderWidth: '1px',
    borderColor: 'line',
    borderStyle: 'solid',
    Info: {
        flow: 'y',
        gap: 'V',
        flex: '1',
        minWidth: '0',
        Name: {
            tag: 'span',
            fontSize: 'Z2',
            fontWeight: '500',
            color: 'title',
            text: (el, s)=>s.guestName || 'Guest'
        },
        Email: {
            hide: (el, s)=>!s.guestEmail,
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            text: (el, s)=>s.guestEmail
        }
    },
    Actions: {
        flow: 'x',
        gap: 'V',
        Admit: {
            tag: 'button',
            text: 'Admit',
            padding: 'Z A',
            round: 'Z',
            border: 'none',
            theme: 'primary',
            cursor: 'pointer',
            fontSize: 'Y2',
            fontWeight: '600',
            onClick: async (e, el, s)=>{
                await el.call('admitGuest', s.id);
            }
        },
        Reject: {
            tag: 'button',
            text: 'Reject',
            padding: 'Z A',
            round: 'Z',
            borderWidth: '1px',
            borderColor: 'line',
            borderStyle: 'solid',
            background: 'transparent',
            color: 'caption',
            cursor: 'pointer',
            fontSize: 'Y2',
            fontWeight: '600',
            onClick: async (e, el, s)=>{
                await el.call('rejectGuest', s.id);
            }
        }
    }
};

});

parcelRegister("4X0TP", function(module, exports) {

$parcel$export(module.exports, "MeetLiveCaptions", () => $39ad5eb39ee88812$export$d2eb868df360a3d8);
$parcel$export(module.exports, "MeetCaptionLine", () => $39ad5eb39ee88812$export$a642350e60b17ec0);
// MeetLiveCaptions — overlay at the bottom of VideoRoom that shows the most
// recent N transcript utterances for the active room. Reads directly from
// root.utterances which is populated by the page-level subscribeMeetRealtime
// (see pages/meet.js). Hidden when the active room isn't transcribed or
// when there are no utterances yet.

var $fM8BY = parcelRequire("fM8BY");
const $39ad5eb39ee88812$var$MAX_VISIBLE = 3;
const $39ad5eb39ee88812$export$d2eb868df360a3d8 = {
    hide: (el, s)=>{
        const room = (s.root?.rooms || []).find((r)=>r.id === s.root?.activeRoomId);
        if (!room?.transcribeEnabled) return true;
        if (s.root?.showLiveCaptions === false) return true;
        const utts = (s.root?.utterances || []).filter((u)=>u.roomId === s.root?.activeRoomId);
        return utts.length === 0;
    },
    position: 'absolute',
    bottom: 'D',
    left: 'A',
    right: 'A',
    pointerEvents: 'none',
    flow: 'y',
    gap: 'V',
    childExtends: 'MeetCaptionLine',
    childrenAs: 'state',
    children: (el, s)=>{
        const utts = (s.root?.utterances || []).filter((u)=>u.roomId === s.root?.activeRoomId);
        return utts.slice(-$39ad5eb39ee88812$var$MAX_VISIBLE);
    }
};
const $39ad5eb39ee88812$export$a642350e60b17ec0 = {
    flow: 'x',
    gap: 'Z',
    padding: 'Z A',
    round: 'Z',
    background: 'black.7',
    backdropFilter: 'blur(8px)',
    color: 'white',
    fontSize: 'Z2',
    alignSelf: 'center',
    maxWidth: 'I',
    Speaker: {
        tag: 'span',
        fontWeight: '600',
        color: 'cyan',
        text: (el, s)=>(0, $fM8BY.speakerDisplayName)(s.root, s.speakerEmail) + ':'
    },
    Text: {
        tag: 'span',
        flex: '1',
        text: (el, s)=>s.text || ''
    }
};

});

parcelRegister("51fSV", function(module, exports) {

$parcel$export(module.exports, "MeetTranscriptPage", () => $3a795e22e7c1bd30$export$853fb94952ae9236);
$parcel$export(module.exports, "MeetTranscriptUtterance", () => $3a795e22e7c1bd30$export$39863c6514857024);
// MeetTranscriptPage — post-call view for /meet (sub-view of pages/meet.js
// when root.meetView === 'transcript'). Three stacked panels:
//
//   1. SummaryHeader  — 2-3 sentence Gemini-extracted overview + Regenerate
//   2. TranscriptList — chronological utterances (read from root.utterances
//                       which is populated by subscribeMeetRealtime)
//   3. SuggestionsPanel — four buckets of clickable cards. Click → applySuggestion
//                       → existing creation flow on the target feature
//
// Analyze trigger: _maybeAnalyze closure stored on the element, called from
// onCreate AND onUpdate so it re-runs whenever fetch results land or
// realtime adds new utterances. No setInterval — realtime drives state
// transitions naturally.

var $fM8BY = parcelRequire("fM8BY");

var $bfqVY = parcelRequire("bfqVY");
// Normalize the `get_meet_transcript_view` RPC payload into the root
// state shape. Shared by the live fetch transform and the localStorage
// first-paint path so both produce identical state.
const $3a795e22e7c1bd30$var$_shapeTranscriptState = (data)=>({
        utterances: (data?.utterances || []).map((r)=>({
                id: r.id,
                roomId: r.room_id,
                speakerEmail: r.speaker_name || '',
                text: r.text || '',
                startedAt: r.started_at,
                endedAt: r.ended_at,
                confidence: r.confidence
            })),
        analysis: data?.analysis || null,
        transcriptLoaded: true
    });
// Factory: returns a per-bucket suggestion panel. Uses the NAMED
// `MeetSuggestionCard` component via `childExtends: 'MeetSuggestionCard'`
// (chat's working pattern — inline `childExtends: { ... }` wasn't binding
// onClick in DOMQL v3.14). The bucket name is injected into each child state
// as `meetBucket` (NOT `_bucket` — underscore-prefixed keys get stripped).
// Declared BEFORE MeetTranscriptPage to satisfy JS temporal-dead-zone.
const $3a795e22e7c1bd30$var$_section = (bucket)=>({
        flow: 'y',
        gap: 'Z1',
        padding: 'A',
        round: 'A',
        background: 'overlayStrong',
        borderWidth: '1px',
        borderColor: 'line',
        borderStyle: 'solid',
        hide: (el, s)=>{
            const items = s.root?.analysis?.suggestions?.[bucket];
            return !items?.length;
        },
        Header: {
            flow: 'x',
            align: 'center space-between',
            gap: 'Z',
            Title: {
                tag: 'h3',
                margin: '0',
                fontSize: 'A',
                fontWeight: '600',
                color: 'title',
                text: (0, $fM8BY.SUGGESTION_BUCKETS)[bucket]?.label || ''
            },
            Count: {
                tag: 'span',
                fontSize: 'Y2',
                color: 'caption',
                text: (el, s)=>{
                    const n = s.root?.analysis?.suggestions?.[bucket]?.length || 0;
                    return `${n} suggestion${n === 1 ? '' : 's'}`;
                }
            }
        },
        Cards: {
            flow: 'y',
            gap: 'Z',
            childExtends: 'MeetSuggestionCard',
            childrenAs: 'state',
            children: (el, s)=>{
                const items = s.root?.analysis?.suggestions?.[bucket] || [];
                // Attach the bucket name to each child state via a non-underscore
                // field so the card's onClick can dispatch correctly. Also attach
                // a deterministic `id` so smbls can diff the children stably across
                // re-renders (avoids tearing down card DOM on every analysis tick).
                return items.map((item, idx)=>({
                        ...item,
                        meetBucket: bucket,
                        id: `${bucket}-${idx}-${item.title || ''}`
                    }));
            }
        }
    });
const $3a795e22e7c1bd30$export$853fb94952ae9236 = {
    flow: 'y',
    flex: '1 1 0',
    minHeight: '0',
    overflow: 'auto',
    padding: 'B C',
    gap: 'B',
    // Single-RPC combined fetch: one round-trip returns both utterances and
    // the cached analysis. Backed by `public.get_meet_transcript_view(uuid)`
    // (migration 0032). Saves one REST RTT vs the old two-query pattern.
    //
    // `placeholderData` paints from localStorage on reload — instant first
    // paint (<10ms) while the RPC silently refreshes in the background. Uses
    // `placeholderData` not `initialData` because placeholderData doesn't mark
    // the cache as fresh, so the refetch always runs. `transform` writes fresh
    // results back so the next reload has something to paint from.
    // migrated 2026-04-27 to SDK route workspaceProject.meet.transcriptView (rpc)
    fetch: {
        method: 'rpc',
        from: 'workspaceProject.meet.transcriptView',
        // `as: '~/utterances'` targets root state. When the transform returns an
        // object whose keys include 'utterances', smbls spreads the whole object
        // onto root — so `analysis` and `transcriptLoaded` land on root too.
        as: '~/utterances',
        // Skip while activeRoomId is unseeded — otherwise the RPC errors on
        // the missing uuid param at the REST layer.
        skip: (el, s)=>!s.root?.activeRoomId,
        // Wrapper extracts `roomId` (or `p_room_id` for backwards compat) from
        // the params bag — see EntityDispatcher argMap for transcriptView.
        params: (el, s)=>({
                roomId: s.root?.activeRoomId,
                p_room_id: s.root?.activeRoomId
            }),
        cache: '30s',
        placeholderData: (el, s)=>{
            if (typeof localStorage === 'undefined') return undefined;
            const rid = s?.root?.activeRoomId;
            if (!rid) return undefined;
            try {
                const raw = localStorage.getItem(`meet-transcript:${rid}`);
                if (!raw) return undefined;
                const data = JSON.parse(raw);
                return $3a795e22e7c1bd30$var$_shapeTranscriptState(data);
            } catch  {
                return undefined;
            }
        },
        transform: (data, el, s)=>{
            const rid = s?.root?.activeRoomId;
            if (rid && typeof localStorage !== 'undefined') try {
                localStorage.setItem(`meet-transcript:${rid}`, JSON.stringify(data));
            } catch  {}
            return $3a795e22e7c1bd30$var$_shapeTranscriptState(data);
        },
        onFetchComplete: (data, el, s)=>{
            if (el._maybeAnalyze) el._maybeAnalyze();
        }
    },
    onCreate: (el, s)=>{
        // In DOMQL v3.14 this component is created before the parent page's onCreate
        // seeds activeRoomId, so the declarative `fetch.skip` guard short-circuits
        // on first evaluation. Kick a refetch only if that actually happened —
        // `transcriptLoaded` is set by the transform on success.
        if (s.root?.activeRoomId && !s.root?.transcriptLoaded && el.__ref?.refetch) el.__ref.refetch();
        // Re-scope realtime if landing directly on the transcript view via URL
        // hash (#room=<uuid>&view=transcript). For within-app navigation, onUpdate
        // catches the moment meetView flips to 'transcript'.
        if (s.root?.meetView === 'transcript' && s.root?.activeRoomId) el.call('subscribeMeetRealtime', {
            tables: [
                'meet_rooms',
                'meet_participants',
                'meet_waiting_room',
                'meet_transcripts',
                'meet_transcript_analyses'
            ],
            roomId: s.root.activeRoomId
        });
        // Closure pattern from pages/calendar.js:_tryJoinPresence — called from
        // onCreate once and from onUpdate every time fetch results or realtime
        // events change root state. Bails on no-op transitions.
        el._maybeAnalyze = async ()=>{
            const root = s.root;
            if (!root.activeRoomId) return;
            if (root.analysis || root.analyzeError || root._meetAnalyzeInFlight) return;
            // Wait for the cached analysis fetch to resolve before hitting the edge
            // function. `analysis` is `undefined` while the fetch is in-flight and
            // `null` once resolved with no row. Firing before resolution produces
            // a redundant round-trip — even though the server returns the cached
            // row cheaply, the extra request is avoidable.
            if (root.analysis === undefined) return;
            // Trust the server: analyzeTranscript returns 422 "no transcript
            // available yet" if rows aren't there yet. That maps to analyzeError
            // which the Body factory renders. Don't gate on a client-side filter
            // of root.utterances — that can desync with the real transcript rows
            // when the TranscriptPage fetch races with activeRoomId seeding.
            root.update({
                analyzing: true,
                transcriptPending: false,
                _meetAnalyzeInFlight: true
            });
            try {
                const res = await el.call('analyzeTranscript', root.activeRoomId);
                root.update({
                    analyzing: false,
                    analysis: res,
                    _meetAnalyzeInFlight: false
                });
            } catch (err) {
                const reason = err?.message || 'analysis failed';
                // 422 "no transcript available yet" is expected during a still-running
                // call. Surface it as `transcriptPending` instead of a hard error so
                // the auto-retry loop keeps polling for the transcript worker to land
                // rows. Anything else is a real failure and stops the poll.
                const isPending = err?.status === 422 || /no transcript/i.test(reason);
                root.update({
                    analyzing: false,
                    _meetAnalyzeInFlight: false,
                    transcriptPending: isPending ? true : false,
                    analyzeError: isPending ? null : reason
                });
            }
        };
        el._maybeAnalyze();
    },
    onUpdate: (el, s)=>{
        // Re-scope realtime to include transcripts whenever this view is active.
        // subscribeMeetRealtime is idempotent (same scope → instant no-op), so
        // calling on every update is safe. Covers within-app navigation and the
        // case where disconnectCall dropped the transcript subscription.
        if (s.root?.meetView === 'transcript' && s.root?.activeRoomId) el.call('subscribeMeetRealtime', {
            tables: [
                'meet_rooms',
                'meet_participants',
                'meet_waiting_room',
                'meet_transcripts',
                'meet_transcript_analyses'
            ],
            roomId: s.root.activeRoomId
        });
        if (el._maybeAnalyze) el._maybeAnalyze();
    },
    // ── Panel 2: Transcript list ─────────────────────────────────────
    Transcript: {
        flow: 'y',
        gap: 'V',
        padding: 'A',
        round: 'A',
        background: 'overlayStrong',
        borderWidth: '1px',
        borderColor: 'line',
        borderStyle: 'solid',
        maxHeight: 'H',
        overflow: 'auto',
        minHeight: 'G',
        CaptionTitle: {
            fontSize: 'Y2',
            Text: {
                text: 'Transcript'
            }
        },
        // Three shimmering rows while the fetch is in-flight. Hidden as soon as
        // the transform sets `transcriptLoaded: true` — at that point either the
        // real List takes over or Empty shows.
        Skeleton: {
            hide: (el, s)=>!!s.root?.transcriptLoaded,
            flow: 'y',
            gap: 'Z',
            Row_1: {
                height: 'B',
                round: 'V',
                background: 'overlay',
                opacity: '.6'
            },
            Row_2: {
                height: 'B',
                round: 'V',
                background: 'overlay',
                opacity: '.4',
                width: '80%'
            },
            Row_3: {
                height: 'B',
                round: 'V',
                background: 'overlay',
                opacity: '.3',
                width: '65%'
            }
        },
        Empty: {
            hide: (el, s)=>{
                if (!s.root?.transcriptLoaded) return true;
                const u = (s.root?.utterances || []).filter((x)=>x.roomId === s.root?.activeRoomId);
                return u.length > 0;
            },
            tag: 'p',
            margin: '0',
            fontSize: 'Z2',
            color: 'caption',
            text: 'No utterances captured yet.'
        },
        List: {
            hide: (el, s)=>!s.root?.transcriptLoaded,
            flow: 'y',
            gap: 'Z',
            childExtends: 'MeetTranscriptUtterance',
            childrenAs: 'state',
            children: (el, s)=>(s.root?.utterances || []).filter((u)=>u.roomId === s.root?.activeRoomId).sort((a, b)=>(a.startedAt || '').localeCompare(b.startedAt || ''))
        }
    },
    // ── Panel 1: Summary header ──────────────────────────────────────
    Summary: {
        flow: 'y',
        gap: 'Z1',
        padding: 'A',
        round: 'A',
        background: 'overlayStrong',
        borderWidth: '1px',
        borderColor: 'line',
        borderStyle: 'solid',
        HeaderRow: {
            flow: 'x',
            align: 'center space-between',
            gap: 'Z1',
            CaptionTitle: {
                fontSize: 'Y2',
                Text: {
                    text: 'Summary'
                }
            },
            Actions: {
                flow: 'x',
                gap: 'Z',
                SaveAsNoteBtn: {
                    hide: (el, s)=>!s.root?.analysis?.summary,
                    tag: 'button',
                    text: (el, s)=>{
                        // If this summary has already been saved as a note, the
                        // applied_items array holds a {bucket:'meet_summary'} entry.
                        // Relabel the button so the user knows re-clicking navigates
                        // instead of creating a duplicate.
                        const applied = s.root?.analysis?.applied_items || [];
                        const existing = applied.find((a)=>a.bucket === 'meet_summary');
                        return existing ? "\u2197 View note" : "\uFF0B Save to notes";
                    },
                    padding: 'V Z',
                    round: 'Z',
                    borderWidth: '1px',
                    borderColor: 'line',
                    borderStyle: 'solid',
                    background: 'transparent',
                    color: 'title',
                    cursor: 'pointer',
                    fontSize: 'Y2',
                    onClick: async (e, el, s)=>{
                        const root = s.root;
                        const roomId = root?.activeRoomId;
                        const applied = root?.analysis?.applied_items || [];
                        // Already saved? Just navigate — don't create a duplicate.
                        const existing = applied.find((a)=>a.bucket === 'meet_summary');
                        if (existing) {
                            root?.update({
                                selectedNoteId: existing.target_id
                            });
                            (0, $fM8BY.routeTo)(el, '/documents/notes');
                            return;
                        }
                        // First save: create + record in applied_items.
                        const room = (root?.rooms || []).find((r)=>r.id === roomId);
                        const title = (room?.name || 'Call') + " \u2014 summary";
                        const content = root?.analysis?.summary || '';
                        const noteId = await el.call('createNote', {
                            title: title,
                            content: content,
                            tags: [
                                'meet',
                                'summary'
                            ],
                            source: 'ai'
                        });
                        if (!noteId) return;
                        // Write the meet_summary entry to applied_items via the SDK
                        // route. The meet_analysis_update_applied RLS policy allows
                        // room members to patch this column.
                        // migrated 2026-04-27 to SDK route workspaceProject.meet.analysisAppliedItems
                        try {
                            const next = [
                                ...applied,
                                {
                                    bucket: 'meet_summary',
                                    fingerprint: 'summary',
                                    target_id: String(noteId),
                                    applied_at: new Date().toISOString()
                                }
                            ];
                            await (0, $bfqVY.getSDK)().execute('workspaceProject.meet.analysisAppliedItems', 'update', {
                                roomId: roomId,
                                appliedItems: next
                            });
                            root?.update({
                                analysis: {
                                    ...root.analysis,
                                    applied_items: next
                                }
                            });
                        } catch (err) {
                            console.warn('[SaveAsNoteBtn] applied_items write failed', err);
                        }
                        (0, $fM8BY.routeTo)(el, '/documents/notes');
                    }
                },
                RegenerateBtn: {
                    // Hidden only while an analyze call is in flight. Otherwise it's
                    // "Analyze" (no existing analysis) or "Regenerate" (existing one).
                    hide: (el, s)=>!!s.root?.analyzing,
                    tag: 'button',
                    text: (el, s)=>s.root?.analysis ? 'Regenerate' : 'Analyze',
                    padding: 'V Z',
                    round: 'Z',
                    borderWidth: '1px',
                    borderColor: 'line',
                    borderStyle: 'solid',
                    background: 'transparent',
                    color: 'title',
                    cursor: 'pointer',
                    fontSize: 'Y2',
                    onClick: async (e, el, s)=>{
                        const hadAnalysis = !!s.root?.analysis;
                        s.root?.update({
                            analyzing: true,
                            analysis: null,
                            analyzeError: null
                        });
                        try {
                            const res = await el.call('analyzeTranscript', s.root?.activeRoomId, hadAnalysis // force=true only when regenerating
                            );
                            s.root?.update({
                                analyzing: false,
                                analysis: res
                            });
                        } catch (err) {
                            s.root?.update({
                                analyzing: false,
                                analyzeError: err?.message
                            });
                        }
                    }
                }
            }
        },
        // Two shimmering lines while the cached analysis fetch is in-flight or
        // while the edge function is actively analyzing. Text body stays hidden
        // until we have something real (summary / error / pending / empty) to say.
        Skeleton: {
            hide: (el, s)=>{
                const loading = s.root?.analysis === undefined || !!s.root?.analyzing;
                return !loading;
            },
            flow: 'y',
            gap: 'Z',
            Row_1: {
                height: 'A',
                round: 'V',
                background: 'overlay',
                opacity: '.6'
            },
            Row_2: {
                height: 'A',
                round: 'V',
                background: 'overlay',
                opacity: '.4',
                width: '70%'
            }
        },
        Body: {
            hide: (el, s)=>s.root?.analysis === undefined || !!s.root?.analyzing,
            tag: 'p',
            margin: '0',
            fontSize: 'Z2',
            color: 'title',
            lineHeight: '1.6',
            text: (el, s)=>{
                if (s.root?.analyzeError) return `Couldn't analyze: ${s.root?.analyzeError}`;
                if (s.root?.transcriptPending) return "Transcription still processing \u2014 check back in a moment.";
                return s.root?.analysis?.summary || 'No analysis yet.';
            }
        }
    },
    // ── Panel 3: Suggestions ─────────────────────────────────────────
    Suggestions: {
        hide: (el, s)=>!s.root?.analysis,
        flow: 'y',
        gap: 'A',
        CaptionTitle: {
            fontSize: 'Y2',
            Text: {
                text: 'Apply to other features'
            }
        },
        // One section per bucket. Each is built via a factory that bakes the
        // bucket name into closures — avoiding the el.parent?.sectionBucket
        // lookup which was unreliable (underscore-prefixed state fields were
        // also getting stripped in child state merging).
        CalendarSection: $3a795e22e7c1bd30$var$_section('calendar_events'),
        TicketsSection: $3a795e22e7c1bd30$var$_section('tickets'),
        NotesSection: $3a795e22e7c1bd30$var$_section('notes'),
        KnowledgeBaseSection: $3a795e22e7c1bd30$var$_section('knowledge_base'),
        ChatSection: $3a795e22e7c1bd30$var$_section('chat_messages')
    }
};
const $3a795e22e7c1bd30$export$39863c6514857024 = {
    flow: 'x',
    gap: 'Z1',
    align: 'flex-start left',
    padding: 'V 0',
    Speaker: {
        tag: 'span',
        minWidth: 'D',
        fontSize: 'Z2',
        fontWeight: '600',
        color: 'cyan',
        text: (el, s)=>(0, $fM8BY.speakerDisplayName)(s.root, s.speakerEmail) + ':'
    },
    Text: {
        tag: 'span',
        flex: '1',
        fontSize: 'Z2',
        color: 'title',
        lineHeight: '1.5',
        text: (el, s)=>s.text || ''
    }
} // _section(bucket) is defined at the top of this file before
 // MeetTranscriptPage to satisfy JS temporal-dead-zone rules.
;

});

parcelRegister("cy5cZ", function(module, exports) {

$parcel$export(module.exports, "MeetSuggestionCard", () => $922cb3535d116663$export$ca572d6c25a69d5a);
// MeetSuggestionCard — ticket/event recommendation from AI transcript analysis.
// Styled like a mini ticket card. Clicking opens the creation flow.

var $fM8BY = parcelRequire("fM8BY");
const $922cb3535d116663$var$_appliedEntry = (el, s)=>{
    const applied = s?.root?.analysis?.applied_items || [];
    if (!applied.length || !el?._fingerprint) return null;
    return applied.find((a)=>a.fingerprint === el._fingerprint && a.bucket === s?.meetBucket) || null;
};
const $922cb3535d116663$var$_isApplied = (el, s)=>!!$922cb3535d116663$var$_appliedEntry(el, s);
const $922cb3535d116663$var$_openAppliedTarget = (el, s)=>{
    const cfg = (0, $fM8BY.SUGGESTION_BUCKETS)[s?.meetBucket];
    if (!cfg?.route) return;
    const targetId = $922cb3535d116663$var$_appliedEntry(el, s)?.target_id;
    if (targetId && cfg.stateKey && s?.root?.update) s.root.update({
        [cfg.stateKey]: targetId
    });
    (0, $fM8BY.routeTo)(el, cfg.route);
};
const $922cb3535d116663$var$_bucketIcon = (bucket)=>{
    if (bucket === 'tickets') return "\u25A0";
    if (bucket === 'calendar_events') return "\u25CB";
    if (bucket === 'notes') return "\u25C6";
    if (bucket === 'knowledge_base') return "\u25C7";
    return "\u2022";
};
const $922cb3535d116663$var$_bucketColor = (bucket)=>{
    if (bucket === 'tickets') return 'orange';
    if (bucket === 'calendar_events') return 'blue';
    if (bucket === 'notes') return 'green';
    if (bucket === 'knowledge_base') return 'cyan';
    return 'caption';
};
const $922cb3535d116663$export$ca572d6c25a69d5a = {
    flow: 'y',
    gap: 'Z',
    padding: 'A',
    round: 'A',
    borderWidth: '1px',
    borderColor: (el, s)=>$922cb3535d116663$var$_isApplied(el, s) ? 'green.24' : 'line',
    borderStyle: 'solid',
    background: (el, s)=>$922cb3535d116663$var$_isApplied(el, s) ? 'green.04' : 'white.04',
    cursor: 'pointer',
    position: 'relative',
    transition: 'transform 200ms ease, border-color 200ms ease, box-shadow 200ms ease',
    ':hover': {
        transform: 'translateY(-2px)',
        boxShadow: (el, s)=>$922cb3535d116663$var$_isApplied(el, s) ? '0 8px 24px -8px rgba(34,197,94,.25)' : '0 8px 24px -8px var(--color-shadow)'
    },
    onCreate: async (el, s)=>{
        try {
            el._fingerprint = await (0, $fM8BY.fingerprintSuggestion)(s || {});
        } catch  {
            el._fingerprint = null;
        }
    },
    onClick: (e, el, s)=>{
        const bucket = s?.meetBucket;
        if (!bucket) return;
        if ($922cb3535d116663$var$_isApplied(el, s)) {
            $922cb3535d116663$var$_openAppliedTarget(el, s);
            return;
        }
        el.call('openSuggestionModal', bucket, s);
    },
    // Top row: bucket icon + title + applied check
    TopRow: {
        flow: 'x',
        align: 'center left',
        gap: 'Z',
        BucketIcon: {
            tag: 'span',
            fontSize: 'Z2',
            color: (el, s)=>$922cb3535d116663$var$_bucketColor(s?.meetBucket),
            text: (el, s)=>$922cb3535d116663$var$_bucketIcon(s?.meetBucket)
        },
        Title: {
            tag: 'h4',
            margin: '0',
            fontSize: 'Z2',
            fontWeight: '600',
            color: (el, s)=>$922cb3535d116663$var$_isApplied(el, s) ? 'caption' : 'title',
            textDecoration: (el, s)=>$922cb3535d116663$var$_isApplied(el, s) ? 'line-through' : 'none',
            flex: '1',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>s?.title || s?.body || 'Untitled'
        },
        Check: {
            hide: (el, s)=>!$922cb3535d116663$var$_isApplied(el, s),
            tag: 'span',
            flow: 'x',
            align: 'center center',
            gap: 'V',
            padding: 'V Z',
            round: 'C',
            background: 'green.12',
            color: 'green',
            fontSize: 'Y2',
            fontWeight: '700',
            text: "\u2713 Created"
        }
    },
    // Description
    Body: {
        tag: 'p',
        margin: '0',
        fontSize: 'Y2',
        color: 'caption',
        lineHeight: '1.5',
        text: (el, s)=>s?.description || s?.summary || s?.content || s?.body || ''
    },
    // Meta: date suggestion, assignee, tags
    Meta: {
        flow: 'x wrap',
        gap: 'Z',
        fontSize: 'Y2',
        align: 'center left',
        DateBadge: {
            display: (el, s)=>s?.proposed_time || s?.date || s?.due_date ? 'inline-flex' : 'none',
            flow: 'x',
            align: 'center center',
            gap: 'V',
            padding: 'V Z',
            round: 'C',
            background: 'blue.12',
            color: 'blue',
            fontWeight: '600',
            Icon: {
                extends: 'Icon',
                icon: 'clock',
                boxSize: 'Y2'
            },
            Text: {
                tag: 'span',
                text: (el, s)=>s?.proposed_time || s?.date || s?.due_date || ''
            }
        },
        AssigneeBadge: {
            display: (el, s)=>s?.assignee_email ? 'inline-flex' : 'none',
            flow: 'x',
            align: 'center center',
            gap: 'V',
            padding: 'V Z',
            round: 'C',
            background: 'overlay',
            color: 'caption',
            fontWeight: '500',
            text: (el, s)=>s?.assignee_email ? `\u{2192} ${s.assignee_email.split('@')[0]}` : ''
        },
        Tags: {
            display: (el, s)=>Array.isArray(s?.tags) && s.tags.length ? 'inline' : 'none',
            tag: 'span',
            color: 'caption',
            text: (el, s)=>Array.isArray(s?.tags) ? s.tags.map((t)=>`#${t}`).join(' ') : ''
        }
    },
    // CTA button at bottom — create-state
    CreateBtn: {
        hide: (el, s)=>$922cb3535d116663$var$_isApplied(el, s),
        tag: 'button',
        type: 'button',
        display: 'flex',
        align: 'center center',
        width: '100%',
        padding: 'Z',
        marginTop: 'V',
        fontSize: 'Y2',
        fontWeight: '600',
        border: 'none',
        cursor: 'pointer',
        round: 'Z',
        background: (el, s)=>`${$922cb3535d116663$var$_bucketColor(s?.meetBucket)}.12`,
        color: (el, s)=>$922cb3535d116663$var$_bucketColor(s?.meetBucket),
        text: (el, s)=>{
            const b = s?.meetBucket;
            if (b === 'tickets') return 'Create ticket';
            if (b === 'calendar_events') return 'Create event';
            if (b === 'notes') return 'Create note';
            if (b === 'knowledge_base') return 'Add to KB';
            return 'Create';
        },
        ':hover': {
            opacity: '.85'
        },
        onClick: (e, el, s)=>{
            e.stopPropagation();
            if ($922cb3535d116663$var$_isApplied(el, s)) return;
            const bucket = s?.meetBucket;
            if (!bucket) return;
            el.call('openSuggestionModal', bucket, s);
        }
    },
    // Applied-state bar — takes CreateBtn's slot, deep-links to the target
    ViewBtn: {
        hide: (el, s)=>!$922cb3535d116663$var$_isApplied(el, s),
        tag: 'button',
        type: 'button',
        display: 'flex',
        align: 'center center',
        width: '100%',
        padding: 'Z',
        marginTop: 'V',
        fontSize: 'Y2',
        fontWeight: '600',
        border: 'none',
        cursor: 'pointer',
        round: 'Z',
        background: 'green.12',
        color: 'green',
        text: (el, s)=>(0, $fM8BY.SUGGESTION_BUCKETS)[s?.meetBucket]?.viewLabel || "View \u2192",
        ':hover': {
            opacity: '.85'
        },
        onClick: (e, el, s)=>{
            e.stopPropagation();
            $922cb3535d116663$var$_openAppliedTarget(el, s);
        }
    }
};

});

parcelRegister("8NbKw", function(module, exports) {

$parcel$export(module.exports, "MeetSuggestionConfirmModal", () => $666c037e4b9eddd8$export$35b1733777fe2596);
// MeetSuggestionConfirmModal — review-before-save dialog for AI-extracted
// suggestions on the transcript page.
//
// Flow:
//  1. User clicks a MeetSuggestionCard → root.suggestionConfirm = { bucket, item }
//  2. This modal opens, showing the extracted data.
//  3. User can edit the title (most common tweak) and reads description/meta.
//  4. "Create" / "Update" button calls applySuggestion with the (possibly edited)
//     item, then routes to the target feature.
//  5. "Cancel" (or backdrop/X) clears root.suggestionConfirm.
//
// stateKey: 'suggestionConfirm' — the Modal base component reads this as a
// truthy-check to show/hide, so any non-null value opens the modal.

var $fM8BY = parcelRequire("fM8BY");
// Verb + label for the confirm button and modal title
const $666c037e4b9eddd8$var$_verbLabel = (bucket, action)=>{
    const label = ((0, $fM8BY.SUGGESTION_BUCKETS)[bucket]?.label || bucket).toLowerCase().replace(/s$/, '') // "tickets" → "ticket", "notes" → "note"
    ;
    const verb = action === 'update' ? 'Update' : 'Create';
    return {
        verb: verb,
        label: label
    };
};
// One-line metadata strip shown under the body preview
const $666c037e4b9eddd8$var$_metaLine = (bucket, item)=>{
    if (!item) return '';
    if (bucket === 'calendar_events') {
        const parts = [];
        if (item.proposed_time) parts.push(`\u{23F0} ${item.proposed_time}`);
        if (Array.isArray(item.attendees) && item.attendees.length) parts.push(item.attendees.join(', '));
        return parts.join(" \xb7 ");
    }
    if (bucket === 'tickets') return item.assignee_email ? `\u{2192} ${item.assignee_email}` : '';
    if (bucket === 'notes') return Array.isArray(item.tags) && item.tags.length ? item.tags.map((t)=>`#${t}`).join(' ') : '';
    if (bucket === 'knowledge_base') return item.category || '';
    if (bucket === 'chat_messages') return item.to_email ? `To: ${item.to_email}` : '';
    return '';
};
// The "body" field to display as a read-only preview
const $666c037e4b9eddd8$var$_bodyText = (item)=>item?.description || item?.content || item?.summary || item?.body || '';
const $666c037e4b9eddd8$export$35b1733777fe2596 = {
    extends: 'Modal',
    stateKey: 'suggestionConfirm',
    // extraClose clears the editable-title slot when the modal is dismissed
    // via the backdrop or X button (as opposed to our own buttons that clear it).
    extraClose: {
        suggestionConfirmTitle: null
    },
    Window: {
        width: 'I',
        maxWidth: '90vw',
        gap: 'A',
        ModalHeader: {
            Hgroup: {
                H: {
                    text: (el, s)=>{
                        const c = s.root?.suggestionConfirm;
                        if (!c) return 'Review suggestion';
                        const { verb: verb, label: label } = $666c037e4b9eddd8$var$_verbLabel(c.bucket, c.item?.action);
                        return `${verb} ${label}`;
                    }
                },
                P: {
                    text: (el, s)=>{
                        const c = s.root?.suggestionConfirm;
                        if (!c) return '';
                        const { verb: verb, label: label } = $666c037e4b9eddd8$var$_verbLabel(c.bucket, c.item?.action);
                        return `${verb} a new ${label} from this transcript suggestion.`;
                    }
                }
            }
        },
        // "Will update existing" badge for update-action items
        ActionBadge: {
            hide: (el, s)=>s.root?.suggestionConfirm?.item?.action !== 'update',
            padding: 'V Z',
            round: 'Y',
            background: 'cyan',
            color: 'black',
            fontSize: 'Y1',
            fontWeight: '700',
            letterSpacing: '.05em',
            textTransform: 'uppercase',
            text: 'Will update existing'
        },
        // Editable title (or message body for chat suggestions)
        TitleField: {
            flow: 'y',
            gap: 'V',
            Label: {
                tag: 'span',
                fontSize: 'Y2',
                color: 'caption',
                text: (el, s)=>s.root?.suggestionConfirm?.bucket === 'chat_messages' ? 'MESSAGE' : 'TITLE'
            },
            Input: {
                tag: 'input',
                padding: 'Z A',
                round: 'Z',
                borderWidth: '1px',
                borderColor: 'line',
                borderStyle: 'solid',
                background: 'document',
                color: 'title',
                fontSize: 'Z2',
                value: (el, s)=>s.root?.suggestionConfirmTitle || '',
                onInput: (e, el, s)=>s.root?.update({
                        suggestionConfirmTitle: e.target.value
                    })
            }
        },
        // Read-only description / body preview
        BodyPreview: {
            hide: (el, s)=>!$666c037e4b9eddd8$var$_bodyText(s.root?.suggestionConfirm?.item),
            flow: 'y',
            gap: 'V',
            Label: {
                tag: 'span',
                fontSize: 'Y2',
                color: 'caption',
                text: 'DETAILS'
            },
            Text: {
                tag: 'p',
                margin: '0',
                padding: 'Z A',
                round: 'Z',
                background: 'overlay',
                fontSize: 'Z2',
                color: 'caption',
                lineHeight: '1.5',
                text: (el, s)=>$666c037e4b9eddd8$var$_bodyText(s.root?.suggestionConfirm?.item)
            }
        },
        // One-line metadata: time, assignee, tags, recipient, etc.
        MetaLine: {
            hide: (el, s)=>!$666c037e4b9eddd8$var$_metaLine(s.root?.suggestionConfirm?.bucket, s.root?.suggestionConfirm?.item),
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            text: (el, s)=>$666c037e4b9eddd8$var$_metaLine(s.root?.suggestionConfirm?.bucket, s.root?.suggestionConfirm?.item)
        },
        ModalFooter: {
            flow: 'x',
            gap: 'Z1',
            ConfirmBtn: {
                extends: 'Button',
                theme: 'primary',
                text: (el, s)=>{
                    const c = s.root?.suggestionConfirm;
                    if (!c) return 'Confirm';
                    const { verb: verb, label: label } = $666c037e4b9eddd8$var$_verbLabel(c.bucket, c.item?.action);
                    return `${verb} ${label}`;
                },
                onClick: async (e, el, s)=>{
                    const c = s.root?.suggestionConfirm;
                    if (!c) return;
                    // Merge user's title edit back into the item before forwarding
                    const editedItem = {
                        ...c.item
                    };
                    const custom = (s.root?.suggestionConfirmTitle || '').trim();
                    if (c.bucket === 'chat_messages') {
                        if (custom) editedItem.body = custom;
                    } else if (custom) editedItem.title = custom;
                    const targetId = await el.call('applySuggestion', c.bucket, editedItem);
                    if (!targetId) return; // applySuggestion failed — keep modal open
                    s.root?.update({
                        suggestionConfirm: null,
                        suggestionConfirmTitle: null
                    });
                    const route = (0, $fM8BY.SUGGESTION_BUCKETS)[c.bucket]?.route;
                    if (route) (0, $fM8BY.routeTo)(el, route);
                }
            }
        }
    }
};

});

parcelRegister("lyTci", function(module, exports) {

$parcel$export(module.exports, "MeetCallWidget", () => $fb2796fe9cfde86e$export$493ad18cf0a2276);
// MeetCallWidget — picture-in-picture mini widget mounted at the intranet
// app level (not the page level) so it persists across route navigation.
// Visible whenever a LiveKit Room is connected AND the user is NOT currently
// on the /meet call view. Lets the user return to the call or leave from
// anywhere in the intranet.
//
// The LiveKit Room itself is a module variable in connectCall.js, so the
// call stays connected even when the user navigates away from /meet.
// This widget just renders a live view of that persistent Room.

var $3q4bW = parcelRequire("3q4bW");

var $fM8BY = parcelRequire("fM8BY");
// Attach-once helper — same idempotent pattern as ParticipantTile.js.
const $fb2796fe9cfde86e$var$_attachLocalVideo = (videoEl)=>{
    if (!videoEl) return;
    const room = (0, $3q4bW.getLivekitRoom)();
    if (!room?.localParticipant) return;
    const pubs = typeof room.localParticipant.videoTrackPublications?.values === 'function' ? [
        ...room.localParticipant.videoTrackPublications.values()
    ] : Object.values(room.localParticipant.videoTrackPublications || {});
    let targetPub = null;
    for (const pub of pubs)if (pub.track && (pub.source === 'camera' || pub.kind === 'video')) {
        targetPub = pub;
        break;
    }
    const currentSid = videoEl._lkTrackSid || null;
    const targetSid = targetPub?.trackSid || null;
    if (currentSid === targetSid) return;
    if (videoEl._lkTrack) try {
        videoEl._lkTrack.detach(videoEl);
    } catch  {}
    if (targetPub?.track) try {
        targetPub.track.attach(videoEl);
        videoEl._lkTrack = targetPub.track;
        videoEl._lkTrackSid = targetSid;
    } catch (err) {
        console.warn('[widget] attach failed', err);
    }
};
const $fb2796fe9cfde86e$export$493ad18cf0a2276 = {
    // Hide unless there's an active LiveKit connection AND we're off the call view.
    hide: (el, s)=>{
        if (!s.root?.livekitConnected) return true;
        if (s.root?.meetView === 'call') return true;
        return false;
    },
    position: 'fixed',
    bottom: 'B',
    right: 'B',
    width: 'H',
    height: 'G1',
    zIndex: '1500',
    flow: 'y',
    round: 'A',
    overflow: 'hidden',
    background: 'black',
    borderWidth: '2px',
    borderColor: 'cyan',
    borderStyle: 'solid',
    // A subtle glow to signal "call in progress".
    shadow: 'D1 cyan',
    onRender: (el)=>{
        // Re-attach the local video track on every render (idempotent).
        const node = el.node;
        if (!node) return;
        const videoEl = node.querySelector('video');
        $fb2796fe9cfde86e$var$_attachLocalVideo(videoEl);
    },
    VideoTile: {
        position: 'relative',
        flex: '1 1 0',
        minHeight: '0',
        align: 'center center',
        VideoEl: {
            tag: 'video',
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            attr: {
                autoplay: 'autoplay',
                playsinline: 'playsinline',
                muted: 'muted'
            }
        },
        LiveBadge: {
            position: 'absolute',
            top: 'V',
            left: 'V',
            padding: 'V Z',
            round: 'Y',
            background: 'red',
            color: 'white',
            fontSize: 'Y1',
            fontWeight: '700',
            letterSpacing: '.05em',
            textTransform: 'uppercase',
            text: "\u25CF Live"
        }
    },
    Footer: {
        flow: 'x',
        align: 'center space-between',
        gap: 'Z',
        padding: 'V Z',
        background: 'overlayStrong',
        RoomName: {
            tag: 'span',
            flex: '1',
            fontSize: 'Y2',
            color: 'title',
            fontWeight: '500',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>{
                const room = (s.root?.rooms || []).find((r)=>r.id === s.root?.activeRoomId);
                return room?.name || 'Call';
            }
        },
        ReturnBtn: {
            tag: 'button',
            text: "\u2197",
            title: 'Return to call',
            padding: 'V Z',
            round: 'Z',
            border: 'none',
            background: 'cyan',
            color: 'black',
            cursor: 'pointer',
            fontSize: 'Z2',
            fontWeight: '700',
            onClick: (e, el, s)=>{
                const id = s.root?.activeRoomId;
                if (!id) return;
                s.root?.update({
                    meetView: 'call'
                });
                if (typeof window !== 'undefined') history.replaceState(null, '', `#room=${id}&view=call`);
                (0, $fM8BY.routeTo)(el, '/meet');
            }
        },
        LeaveBtn: {
            tag: 'button',
            text: "\xd7",
            title: 'Leave call',
            padding: 'V Z',
            round: 'Z',
            border: 'none',
            background: 'red',
            color: 'white',
            cursor: 'pointer',
            fontSize: 'Z2',
            fontWeight: '700',
            onClick: async (e, el, s)=>{
                await el.call('disconnectCall');
                s.root?.update({
                    meetView: 'list'
                });
            }
        }
    }
};

});



parcelRegister("1zOuk", function(module, exports) {

});

parcelRegister("8ePfR", function(module, exports) {

$parcel$export(module.exports, "WorkspaceRow", () => (parcelRequire("3c42Q")).WorkspaceRow);
$parcel$export(module.exports, "WorkspaceThumb", () => (parcelRequire("3c42Q")).WorkspaceThumb);
$parcel$export(module.exports, "WorkspaceRowButton", () => (parcelRequire("3c42Q")).WorkspaceRowButton);
$parcel$export(module.exports, "OrgRow", () => (parcelRequire("3c42Q")).OrgRow);
$parcel$export(module.exports, "OrgProjectRow", () => (parcelRequire("3c42Q")).OrgProjectRow);
$parcel$export(module.exports, "OrgMemberRow", () => (parcelRequire("3c42Q")).OrgMemberRow);
$parcel$export(module.exports, "WorkspaceChip", () => (parcelRequire("3c42Q")).WorkspaceChip);
$parcel$export(module.exports, "MarketplaceKindLink", () => (parcelRequire("3c42Q")).MarketplaceKindLink);
$parcel$export(module.exports, "ProjectNode", () => (parcelRequire("ecua9")).ProjectNode);
$parcel$export(module.exports, "LibraryPickerItem", () => (parcelRequire("ecua9")).LibraryPickerItem);
$parcel$export(module.exports, "IntegrationNode", () => (parcelRequire("ecua9")).IntegrationNode);
$parcel$export(module.exports, "IntegrationChip", () => (parcelRequire("ecua9")).IntegrationChip);
$parcel$export(module.exports, "IntegrationKindRow", () => (parcelRequire("ecua9")).IntegrationKindRow);
$parcel$export(module.exports, "IntegrationFormField", () => (parcelRequire("ecua9")).IntegrationFormField);
$parcel$export(module.exports, "SettingsModal", () => (parcelRequire("ecua9")).SettingsModal);
$parcel$export(module.exports, "IntegrationPickerOverlay", () => (parcelRequire("ecua9")).IntegrationPickerOverlay);
$parcel$export(module.exports, "LibraryPickerOverlay", () => (parcelRequire("ecua9")).LibraryPickerOverlay);
$parcel$export(module.exports, "NewProjectPickerOverlay", () => (parcelRequire("ecua9")).NewProjectPickerOverlay);
$parcel$export(module.exports, "NpTemplateCard", () => (parcelRequire("ecua9")).NpTemplateCard);
$parcel$export(module.exports, "NpLibItem", () => (parcelRequire("ecua9")).NpLibItem);
$parcel$export(module.exports, "StudiosEmbed", () => (parcelRequire("ecua9")).studios);
$parcel$export(module.exports, "ScopeRailChip", () => (parcelRequire("ecua9")).ScopeRailChip);
$parcel$export(module.exports, "WorkspaceIntegrationRail", () => (parcelRequire("ecua9")).WorkspaceIntegrationRail);
$parcel$export(module.exports, "OrgIntegrationRail", () => (parcelRequire("ecua9")).OrgIntegrationRail);
$parcel$export(module.exports, "prependProjectToCache", () => (parcelRequire("ecua9")).prependProjectToCache);
$parcel$export(module.exports, "appendOrgToCache", () => (parcelRequire("ecua9")).appendOrgToCache);
$parcel$export(module.exports, "ProjectDeleteConfirmModal", () => (parcelRequire("ecua9")).ProjectDeleteConfirmModal);
$parcel$export(module.exports, "ProjectDuplicateModal", () => (parcelRequire("ecua9")).ProjectDuplicateModal);
$parcel$export(module.exports, "ProjectEditMetadataModal", () => (parcelRequire("ecua9")).ProjectEditMetadataModal);
$parcel$export(module.exports, "MCPConnectorChip", () => (parcelRequire("ecua9")).MCPConnectorChip);
$parcel$export(module.exports, "MCPConnectorRail", () => (parcelRequire("ecua9")).MCPConnectorRail);
$parcel$export(module.exports, "LibraryNode", () => (parcelRequire("ecua9")).LibraryNode);
$parcel$export(module.exports, "MCPNode", () => (parcelRequire("ecua9")).MCPNode);
$parcel$export(module.exports, "PluginNode", () => (parcelRequire("ecua9")).PluginNode);
$parcel$export(module.exports, "InstallableNode", () => (parcelRequire("ecua9")).InstallableNode);
$parcel$export(module.exports, "LabEmptyTutorial", () => (parcelRequire("ecua9")).LabEmptyTutorial);
$parcel$export(module.exports, "NotFoundPage", () => (parcelRequire("7tPFF")).notFound);

var $eGIso = parcelRequire("eGIso");

var $dQZNw = parcelRequire("dQZNw");

var $ghlaN = parcelRequire("ghlaN");

var $3DktE = parcelRequire("3DktE");

var $1dOQU = parcelRequire("1dOQU");

var $iHQuC = parcelRequire("iHQuC");

var $92iQu = parcelRequire("92iQu");

var $7OI8V = parcelRequire("7OI8V");

var $3c42Q = parcelRequire("3c42Q");

var $ecua9 = parcelRequire("ecua9");

var $dlKjK = parcelRequire("dlKjK");

var $kuZDh = parcelRequire("kuZDh");

var $5OU8f = parcelRequire("5OU8f");

var $7tPFF = parcelRequire("7tPFF");

var $ippGX = parcelRequire("ippGX");

var $6A0iP = parcelRequire("6A0iP");
$parcel$exportWildcard(module.exports, $eGIso);
$parcel$exportWildcard(module.exports, $dQZNw);
$parcel$exportWildcard(module.exports, $ghlaN);
$parcel$exportWildcard(module.exports, $3DktE);
$parcel$exportWildcard(module.exports, $1dOQU);
$parcel$exportWildcard(module.exports, $iHQuC);
$parcel$exportWildcard(module.exports, $92iQu);
$parcel$exportWildcard(module.exports, $7OI8V);
$parcel$exportWildcard(module.exports, $dlKjK);
$parcel$exportWildcard(module.exports, $kuZDh);
$parcel$exportWildcard(module.exports, $5OU8f);
$parcel$exportWildcard(module.exports, $ippGX);
$parcel$exportWildcard(module.exports, $6A0iP);

});
parcelRegister("eGIso", function(module, exports) {

$parcel$export(module.exports, "Canvas", () => $ab17792370c8714f$export$8d01c972ee8b14a9);
// Canvas wrapper. Hosts either the v1 gridstack scene or the v2
// state-driven surface based on `isCanvasV2`. v1-era input handlers
// (cursor toggling, panningMode flag) are gated so they don't fight
// the v2 pointer pipeline.
const $ab17792370c8714f$var$v1Only = (handler)=>(ev, el, s)=>{
        if (el.call('isCanvasV2')) return;
        return handler(ev, el, s);
    };
const $ab17792370c8714f$export$8d01c972ee8b14a9 = {
    tag: 'main',
    position: 'absolute',
    inset: '0',
    overflow: 'hidden',
    boxSize: '100%',
    overscrollBehavior: 'none',
    userSelect: 'none',
    theme: 'document',
    background: '#8a9096',
    // v1 dotted background. v2 renders its own grid inside CanvasSurface
    // so it pans/zooms with the viewport.
    Dots: {
        if: (el)=>!el.call('isCanvasV2'),
        position: 'absolute',
        inset: '0',
        display: 'block',
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        style: {
            backgroundPosition: '0 0',
            backgroundRepeat: 'repeat',
            backgroundSize: '20px 20px',
            backgroundImage: 'radial-gradient(circle, rgba(255,255,255,0.15) 1px, transparent 1px)'
        }
    },
    CanvasScene: {
        if: (el)=>!el.call('isCanvasV2')
    },
    CanvasSurface: {
        if: (el)=>el.call('isCanvasV2')
    },
    onRender: (el)=>{
        if (el.__scrollPrevented) return;
        el.__scrollPrevented = true;
        const gs = el.context?.globalScope;
        if (gs) {
            gs.canvasElement = el;
            window.__canvasGlobalScope = gs;
        }
        el.context.document.documentElement.setAttribute('data-theme', 'dark');
        const preventScroll = (e)=>e.preventDefault();
        document.body.addEventListener('wheel', preventScroll, {
            passive: false
        });
        document.body.addEventListener('touchmove', preventScroll, {
            passive: false
        });
    },
    onClick: $ab17792370c8714f$var$v1Only((ev, el)=>{
        const gs = el.context?.globalScope;
        if (gs) {
            gs.selected = null;
            gs.selectedKey = null;
            gs.hovered = null;
            gs.hoveredKey = null;
        }
    }),
    onContextmenu: (ev)=>ev.preventDefault(),
    onMousemove: $ab17792370c8714f$var$v1Only((ev, el)=>{
        const gs = el.context?.globalScope;
        if (gs) gs.positions = {
            ...gs.positions,
            mouseX: ev.clientX,
            mouseY: ev.clientY
        };
    }),
    onKeydown: $ab17792370c8714f$var$v1Only((ev, el)=>{
        if (ev.code === 'Space' && !ev.repeat) {
            ev.preventDefault();
            const gs = el.context?.globalScope;
            if (gs) gs.panningMode = true;
            el.node.style.cursor = 'grab';
        }
    }),
    onKeyup: $ab17792370c8714f$var$v1Only((ev, el)=>{
        if (ev.code === 'Space') {
            const gs = el.context?.globalScope;
            if (gs) {
                gs.panningMode = false;
                gs.isGrabbing = false;
            }
            el.node.style.cursor = 'auto';
        }
    }),
    onMousedown: $ab17792370c8714f$var$v1Only((ev, el)=>{
        const gs = el.context?.globalScope;
        if (gs?.panningMode) {
            gs.isGrabbing = true;
            el.node.style.cursor = 'grabbing';
        }
    }),
    onMouseup: $ab17792370c8714f$var$v1Only((ev, el)=>{
        const gs = el.context?.globalScope;
        if (gs?.isGrabbing) {
            gs.isGrabbing = false;
            el.node.style.cursor = gs.panningMode ? 'grab' : 'auto';
        }
    })
};

});

parcelRegister("dQZNw", function(module, exports) {

$parcel$export(module.exports, "TransportModeBtn", () => $a160116fadad3783$export$387cbfbdfffbdfd6);
$parcel$export(module.exports, "AuthModeBtn", () => $a160116fadad3783$export$d8eaf47ea8b703ae);
$parcel$export(module.exports, "MCPConnectorPickerOverlay", () => $a160116fadad3783$export$910983601c018775);
// MCPConnectorPickerOverlay — first-class MCP connector creation overlay.
//
// Mounted at canvas root (CanvasEditor) alongside IntegrationPickerOverlay.
// Root state contract:
//   root._mcpConnectorPickerOpen  boolean — toggle visibility
//   root._mcpConnectorDraft       object  — form draft state
//   root._mcpConnectorSaving      boolean — in-flight flag
//
// On submit: calls el.call('saveMcpConnector', draft) — registered by the
// host page. Server discovers capabilities (tools/list + resources/list)
// and caches in the capabilities jsonb column.
//
// Design tokens and v3.14 syntax per CLAUDE.md:
//   - No raw CSS values — all tokens.
//   - Flat props access. Event handlers: onClick, onInput, onRender, onDestroy.
//   - placeholder: directly on input elements (no attr wrapper).
//   - Reactive CSS uses prop functions: background: (el, s) => ...
//   - State flag naming mirrors _genericIntFormOpen / _genericIntDraft.
const $a160116fadad3783$var$_DRAFT_KEY = '_mcpConnectorDraft';
// Derive a default connector name from a URL (hostname without www).
const $a160116fadad3783$var$_nameFromUrl = (url)=>{
    try {
        const host = new URL(url).hostname.replace(/^www\./, '');
        return host.charAt(0).toUpperCase() + host.slice(1);
    } catch  {
        return '';
    }
};
// Toast helper — mirrors IntegrationConfigureForm pattern.
const $a160116fadad3783$var$_toast = (el, payload)=>{
    try {
        el.call('openNotification', payload);
    } catch (err) {
        console.warn('[mcp-connector]', payload.title, payload.message || '', err);
    }
};
// Submit handler. Delegates to registered project function 'saveMcpConnector'.
const $a160116fadad3783$var$_submit = async (el, s)=>{
    const draft = s.root?.[$a160116fadad3783$var$_DRAFT_KEY] || {};
    if (!draft.url) {
        $a160116fadad3783$var$_toast(el, {
            title: 'URL required',
            message: 'Enter the MCP server URL.',
            type: 'error'
        });
        return;
    }
    s.root.update({
        _mcpConnectorSaving: true
    });
    try {
        await el.call('saveMcpConnector', draft);
        s.root.update({
            _mcpConnectorPickerOpen: false,
            [$a160116fadad3783$var$_DRAFT_KEY]: null,
            _mcpConnectorSaving: false
        });
        $a160116fadad3783$var$_toast(el, {
            title: `Connected ${draft.name || $a160116fadad3783$var$_nameFromUrl(draft.url)}`,
            type: 'success'
        });
        // Reload connector list if host exposes a loader.
        try {
            await el.call('reloadMcpConnectors');
        } catch  {}
    } catch (err) {
        s.root.update({
            _mcpConnectorSaving: false
        });
        $a160116fadad3783$var$_toast(el, {
            title: 'Connect failed',
            message: err?.message || 'Unknown error',
            type: 'error'
        });
    }
};
// ── Transport mode buttons ────────────────────────────────────────────────────
const $a160116fadad3783$var$_transportModes = [
    'sse',
    'websocket',
    'http'
];
const $a160116fadad3783$var$_transportLabels = {
    sse: 'SSE',
    websocket: 'WebSocket',
    http: 'HTTP'
};
const $a160116fadad3783$export$387cbfbdfffbdfd6 = {
    tag: 'button',
    type: 'button',
    padding: 'V Z',
    round: 'Y',
    borderWidth: '1px',
    borderStyle: 'solid',
    fontSize: 'Y2',
    fontWeight: '700',
    cursor: 'pointer',
    'aria-pressed': (el, s)=>{
        const active = (s.root?.[$a160116fadad3783$var$_DRAFT_KEY]?.transport || 'sse') === s._mode;
        return String(active);
    },
    'aria-label': (el, s)=>`Transport: ${s._label || s._mode || ''}`,
    background: (el, s)=>{
        const active = (s.root?.[$a160116fadad3783$var$_DRAFT_KEY]?.transport || 'sse') === s._mode;
        return active ? 'blue' : 'transparent';
    },
    color: (el, s)=>{
        const active = (s.root?.[$a160116fadad3783$var$_DRAFT_KEY]?.transport || 'sse') === s._mode;
        return active ? 'white' : 'title';
    },
    borderColor: 'line',
    text: (el, s)=>s._label || '',
    onClick: (e, el, s)=>{
        s.root.update({
            [$a160116fadad3783$var$_DRAFT_KEY]: {
                ...s.root?.[$a160116fadad3783$var$_DRAFT_KEY] || {},
                transport: s._mode
            }
        });
    }
};
// ── Auth kind mode buttons ────────────────────────────────────────────────────
const $a160116fadad3783$var$_authModes = [
    'none',
    'bearer',
    'api-key',
    'oauth'
];
const $a160116fadad3783$var$_authLabels = {
    none: 'None',
    bearer: 'Bearer',
    'api-key': 'API key',
    oauth: 'OAuth'
};
const $a160116fadad3783$export$d8eaf47ea8b703ae = {
    tag: 'button',
    type: 'button',
    padding: 'V Z',
    round: 'Y',
    borderWidth: '1px',
    borderStyle: 'solid',
    fontSize: 'Y2',
    fontWeight: '700',
    cursor: 'pointer',
    'aria-pressed': (el, s)=>{
        const active = (s.root?.[$a160116fadad3783$var$_DRAFT_KEY]?.authKind || 'none') === s._mode;
        return String(active);
    },
    'aria-label': (el, s)=>`Authentication: ${s._label || s._mode || ''}`,
    background: (el, s)=>{
        const active = (s.root?.[$a160116fadad3783$var$_DRAFT_KEY]?.authKind || 'none') === s._mode;
        return active ? 'blue' : 'transparent';
    },
    color: (el, s)=>{
        const active = (s.root?.[$a160116fadad3783$var$_DRAFT_KEY]?.authKind || 'none') === s._mode;
        return active ? 'white' : 'title';
    },
    borderColor: 'line',
    text: (el, s)=>s._label || '',
    onClick: (e, el, s)=>{
        s.root.update({
            [$a160116fadad3783$var$_DRAFT_KEY]: {
                ...s.root?.[$a160116fadad3783$var$_DRAFT_KEY] || {},
                authKind: s._mode
            }
        });
    }
};
const $a160116fadad3783$export$910983601c018775 = {
    // Visibility: mirrors IntegrationPickerOverlay positioning.
    display: (el, s)=>s.root?._mcpConnectorPickerOpen ? 'flex' : 'none',
    position: 'fixed',
    top: '0',
    left: '56px',
    minWidth: '280px',
    maxWidth: '400px',
    flow: 'y',
    gap: 'Z1',
    padding: 'A',
    round: 'Z1',
    theme: 'canvas-card-glass',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'line',
    boxShadow: '0 10px 30px rgba(0,0,0,0.45)',
    zIndex: 40,
    // Trap focus: close on Esc, return focus to AddBtn.
    onRender: (el, s)=>{
        if (typeof window === 'undefined') return;
        el._mcpEscHandler = (e)=>{
            if (e.key === 'Escape' && s.root?._mcpConnectorPickerOpen) {
                s.root.update({
                    _mcpConnectorPickerOpen: false,
                    [$a160116fadad3783$var$_DRAFT_KEY]: null
                });
                try {
                    const addBtn = document.querySelector('[aria-label="Create project or library"]');
                    if (addBtn) addBtn.focus();
                } catch  {}
            }
        };
        window.addEventListener('keydown', el._mcpEscHandler);
    },
    onDestroy: (el, s)=>{
        if (typeof window !== 'undefined' && el._mcpEscHandler) window.removeEventListener('keydown', el._mcpEscHandler);
    },
    FormTitle: {
        tag: 'h3',
        fontSize: 'A',
        fontWeight: '700',
        color: 'title',
        margin: '0',
        text: 'New MCP connector'
    },
    // One-click pre-fill for Symbols MCP — the primary novel design element.
    // Background cerulean.1 (cerulean accent per design brief).
    SymbolsMcpSuggest: {
        tag: 'button',
        type: 'button',
        flow: 'x',
        gap: 'Z',
        align: 'center',
        padding: 'V Z',
        round: 'Y',
        background: 'cerulean.1',
        color: 'cerulean',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'cerulean',
        fontSize: 'Y2',
        fontWeight: '700',
        cursor: 'pointer',
        title: "Connect Symbols MCP \u2014 pre-fills URL and name",
        Icon: {
            tag: 'span',
            text: "\u26A1",
            fontSize: 'Y2'
        },
        Label: {
            tag: 'span',
            text: 'Connect Symbols MCP',
            fontSize: 'Y2'
        },
        Hint: {
            tag: 'span',
            text: 'mcp.symbols.app',
            fontSize: 'Y1',
            color: 'cerulean',
            opacity: '0.75'
        },
        onClick: (e, el, s)=>{
            s.root.update({
                [$a160116fadad3783$var$_DRAFT_KEY]: {
                    ...s.root?.[$a160116fadad3783$var$_DRAFT_KEY] || {},
                    url: 'https://mcp.symbols.app',
                    name: 'Symbols MCP',
                    transport: 'sse',
                    authKind: 'oauth'
                }
            });
        }
    },
    // ── Name field ──────────────────────────────────────────────────────
    NameField: {
        flow: 'y',
        gap: 'V',
        NameLabel: {
            tag: 'label',
            for: 'mcp-connector-name',
            fontSize: 'Y2',
            fontWeight: '700',
            color: 'caption',
            text: 'Name'
        },
        NameInput: {
            tag: 'input',
            id: 'mcp-connector-name',
            type: 'text',
            width: '100%',
            padding: 'Z',
            round: 'Y',
            theme: 'field',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'line',
            color: 'title',
            fontSize: 'Z2',
            placeholder: 'e.g. Symbols MCP',
            value: (el, s)=>s.root?.[$a160116fadad3783$var$_DRAFT_KEY]?.name || '',
            // Imperatively sync DOM input.value on every render so controlled-input
            // reactivity works in v3.14 (state-driven value updates are not automatically
            // reflected by the browser's input.value property without an explicit write).
            onRender: (el, s)=>{
                if (el.node && document.activeElement !== el.node) el.node.value = s.root?.[$a160116fadad3783$var$_DRAFT_KEY]?.name || '';
            },
            onInput: (e, el, s)=>{
                s.root.update({
                    [$a160116fadad3783$var$_DRAFT_KEY]: {
                        ...s.root?.[$a160116fadad3783$var$_DRAFT_KEY] || {},
                        name: e.target.value
                    }
                });
            }
        }
    },
    // ── URL field ───────────────────────────────────────────────────────
    UrlField: {
        flow: 'y',
        gap: 'V',
        UrlLabel: {
            tag: 'label',
            for: 'mcp-connector-url',
            fontSize: 'Y2',
            fontWeight: '700',
            color: 'caption',
            text: 'Server URL'
        },
        UrlInput: {
            tag: 'input',
            id: 'mcp-connector-url',
            type: 'url',
            width: '100%',
            padding: 'Z',
            round: 'Y',
            theme: 'field',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'line',
            color: 'title',
            fontSize: 'Z2',
            placeholder: 'https://mcp.symbols.app',
            value: (el, s)=>s.root?.[$a160116fadad3783$var$_DRAFT_KEY]?.url || '',
            // Imperatively sync DOM input.value on every render so controlled-input
            // reactivity works in v3.14 (state-driven value updates are not automatically
            // reflected by the browser's input.value property without an explicit write).
            onRender: (el, s)=>{
                if (el.node && document.activeElement !== el.node) el.node.value = s.root?.[$a160116fadad3783$var$_DRAFT_KEY]?.url || '';
            },
            onInput: (e, el, s)=>{
                const url = e.target.value;
                const draft = s.root?.[$a160116fadad3783$var$_DRAFT_KEY] || {};
                // Auto-derive name from URL if the user hasn't set one yet.
                const autoName = draft.name || $a160116fadad3783$var$_nameFromUrl(url);
                s.root.update({
                    [$a160116fadad3783$var$_DRAFT_KEY]: {
                        ...draft,
                        url: url,
                        name: autoName
                    }
                });
            }
        }
    },
    // ── Transport picker ────────────────────────────────────────────────
    TransportField: {
        flow: 'y',
        gap: 'V',
        TransportLabel: {
            tag: 'label',
            id: 'mcp-transport-label',
            fontSize: 'Y2',
            fontWeight: '700',
            color: 'caption',
            text: 'Transport'
        },
        TransportModes: {
            flow: 'x',
            gap: 'Z',
            role: 'group',
            'aria-labelledby': 'mcp-transport-label',
            childExtends: 'TransportModeBtn',
            childrenAs: 'state',
            children: $a160116fadad3783$var$_transportModes.map((m)=>({
                    _mode: m,
                    _label: $a160116fadad3783$var$_transportLabels[m]
                }))
        }
    },
    // ── Auth kind picker ────────────────────────────────────────────────
    AuthField: {
        flow: 'y',
        gap: 'V',
        AuthLabel: {
            tag: 'label',
            id: 'mcp-auth-label',
            fontSize: 'Y2',
            fontWeight: '700',
            color: 'caption',
            text: 'Authentication'
        },
        AuthModes: {
            flow: 'x',
            gap: 'Z',
            flexWrap: 'wrap',
            role: 'group',
            'aria-labelledby': 'mcp-auth-label',
            childExtends: 'AuthModeBtn',
            childrenAs: 'state',
            children: $a160116fadad3783$var$_authModes.map((m)=>({
                    _mode: m,
                    _label: $a160116fadad3783$var$_authLabels[m]
                }))
        }
    },
    // ── Auth token input (visible for bearer/api-key) ───────────────────
    AuthTokenField: {
        flow: 'y',
        gap: 'V',
        hide: (el, s)=>{
            const kind = s.root?.[$a160116fadad3783$var$_DRAFT_KEY]?.authKind || 'none';
            return kind !== 'bearer' && kind !== 'api-key';
        },
        TokenLabel: {
            tag: 'label',
            for: 'mcp-connector-auth-token',
            fontSize: 'Y2',
            fontWeight: '700',
            color: 'caption',
            text: (el, s)=>{
                const kind = s.root?.[$a160116fadad3783$var$_DRAFT_KEY]?.authKind || 'none';
                return kind === 'bearer' ? 'Bearer token' : 'API key';
            }
        },
        TokenInput: {
            tag: 'input',
            id: 'mcp-connector-auth-token',
            type: 'password',
            width: '100%',
            padding: 'Z',
            round: 'Y',
            theme: 'field',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'line',
            color: 'title',
            fontSize: 'Z2',
            placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022",
            value: (el, s)=>s.root?.[$a160116fadad3783$var$_DRAFT_KEY]?.authToken || '',
            onRender: (el, s)=>{
                if (el.node && document.activeElement !== el.node) el.node.value = s.root?.[$a160116fadad3783$var$_DRAFT_KEY]?.authToken || '';
            },
            onInput: (e, el, s)=>{
                s.root.update({
                    [$a160116fadad3783$var$_DRAFT_KEY]: {
                        ...s.root?.[$a160116fadad3783$var$_DRAFT_KEY] || {},
                        authToken: e.target.value
                    }
                });
            }
        }
    },
    // ── Scope picker — reuses IntegrationScopePicker verbatim ───────────
    IntegrationScopePicker: {
        draftKey: $a160116fadad3783$var$_DRAFT_KEY,
        defaultScopeType: 'workspace'
    },
    // ── Actions row ─────────────────────────────────────────────────────
    Actions: {
        flow: 'x',
        gap: 'Z',
        align: 'center flex-end',
        marginTop: 'Z',
        CancelBtn: {
            tag: 'button',
            type: 'button',
            padding: 'V A',
            round: 'Y',
            background: 'transparent',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'line',
            color: 'title',
            fontSize: 'Y2',
            cursor: 'pointer',
            text: 'Cancel',
            onClick: (e, el, s)=>{
                s.root.update({
                    _mcpConnectorPickerOpen: false,
                    [$a160116fadad3783$var$_DRAFT_KEY]: null
                });
                try {
                    const addBtn = document.querySelector('[aria-label="Create project or library"]');
                    if (addBtn) addBtn.focus();
                } catch  {}
            }
        },
        ConnectBtn: {
            tag: 'button',
            type: 'button',
            padding: 'V A',
            round: 'Y',
            background: 'blue',
            color: 'white',
            fontSize: 'Y2',
            fontWeight: '700',
            cursor: 'pointer',
            border: 'none',
            disabled: (el, s)=>!!s.root?._mcpConnectorSaving,
            text: (el, s)=>s.root?._mcpConnectorSaving ? "Connecting\u2026" : 'Connect',
            onClick: async (e, el, s)=>{
                await $a160116fadad3783$var$_submit(el, s);
            }
        }
    }
};

});

parcelRegister("ghlaN", function(module, exports) {

$parcel$export(module.exports, "CanvasScene", () => $bd9ea86a04bf130e$export$30eb528180283bad);
$parcel$export(module.exports, "Collection", () => (parcelRequire("2lV69")).Collection);

var $kN9I2 = parcelRequire("kN9I2");

var $2lV69 = parcelRequire("2lV69");
function $bd9ea86a04bf130e$var$updateDots(root) {
    const dotsEl = root?.Dots;
    if (!dotsEl?.node) return;
    const gs = root.context?.globalScope;
    const { positions: positions } = gs || {};
    if (!positions) return;
    const { x: x, y: y, scale: scale } = positions;
    const baseSize = 20;
    const bgSize = scale * baseSize;
    dotsEl.node.style.backgroundPosition = `${x % bgSize}px ${y % bgSize}px`;
    dotsEl.node.style.backgroundSize = `${bgSize}px ${bgSize}px`;
}
const $bd9ea86a04bf130e$export$30eb528180283bad = {
    minWidth: `${(0, $2lV69.CANVAS_GRID_COLUMNS_COUNT) * 574}px`,
    minHeight: '55000px',
    userSelect: 'none',
    position: 'relative',
    Collection: $2lV69.Collection,
    onRender: (el)=>{
        if (el.__panzoomInitialized) return;
        el.__panzoomInitialized = true;
        const root = el.parent;
        const gs = el.context?.globalScope || {};
        const instance = (0, (/*@__PURE__*/$parcel$interopDefault($kN9I2)))(el.node, {
            minZoom: 0.035,
            maxZoom: 1.99,
            zoomSpeed: 1,
            bounds: true,
            boundsPadding: 0.25,
            onDoubleClick: (e)=>{
                e.preventDefault();
                e.stopPropagation();
                return false;
            },
            beforeMouseDown: ()=>!gs.panningMode,
            beforeWheel: (e)=>{
                e.preventDefault();
                e.stopPropagation();
                const { x: x, y: y, scale: scale } = instance.getTransform();
                const isPinch = e.metaKey || e.ctrlKey || gs.panningMode;
                if (!isPinch) instance.moveTo(x - e.deltaX, y - e.deltaY);
                gs.positions = {
                    ...gs.positions,
                    x: x,
                    y: y,
                    scale: scale
                };
                $bd9ea86a04bf130e$var$updateDots(root);
                return !isPinch;
            }
        });
        gs.panzoomInstance = instance;
        const saved = localStorage.getItem('canvas_position');
        if (saved) try {
            const { x: x, y: y, scale: scale } = JSON.parse(saved);
            instance.moveTo(x || 0, y || 0);
            instance.zoomAbs(x || 0, y || 0, scale || 0.35);
        } catch (e) {}
        else {
            // Seed both the library's internal state (so wheel/drag start from
            // the right transform) AND the element's style via DOMQL: panzoom's
            // rAF loop defers the first DOM write until a transform *changes*,
            // which leaves the 55k × 55k scene at identity until the user
            // interacts and the viewport is filled by a single 1722×1722
            // thumbnail. Writing via `el.update({style})` keeps the DOM update
            // inside DOMQL's v3.14 update channel instead of reaching for
            // `el.node.style` directly.
            instance.zoomAbs(0, 0, 0.35);
            instance.moveTo(40, 40);
            // `transform` / `transformOrigin` aren't in DOMQL v3.14's CSS_PROPS
            // registry, so they must go through the `style:` channel to reach
            // the DOM.
            el.update({
                style: {
                    transformOrigin: '0 0',
                    transform: 'matrix(0.35, 0, 0, 0.35, 40, 40)'
                }
            });
        }
        // Center on first box after thumbnails render
        setTimeout(()=>{
            if (saved) return;
            const first = el.Collection?.node?.children?.[0];
            if (!first) return;
            const rect = first.getBoundingClientRect();
            const { x: x, y: y } = instance.getTransform();
            instance.moveTo(x - rect.left + 40, y - rect.top + 40);
        }, 3000);
        instance.on('transform', ()=>{
            const { x: x, y: y, scale: scale } = instance.getTransform();
            gs.positions = {
                ...gs.positions,
                x: x,
                y: y,
                scale: scale
            };
            gs.isPanning = true;
            clearTimeout(gs._panEndTimeout);
            gs._panEndTimeout = setTimeout(()=>{
                gs.isPanning = false;
            }, 65);
            $bd9ea86a04bf130e$var$updateDots(root);
            gs._panStoreLimit = (gs._panStoreLimit || 0) + 1;
            if (gs._panStoreLimit > 15) {
                gs._panStoreLimit = 0;
                localStorage.setItem('canvas_position', JSON.stringify({
                    x: x,
                    y: y,
                    scale: scale
                }));
            }
        });
        $bd9ea86a04bf130e$var$updateDots(root);
    }
};

});
parcelRegister("2lV69", function(module, exports) {

$parcel$export(module.exports, "CANVAS_GRID_COLUMNS_COUNT", () => $1b69d56eb37691c6$export$cca0565183279949);
$parcel$export(module.exports, "Collection", () => $1b69d56eb37691c6$export$fb8073518f34e6ec);

var $9TU80 = parcelRequire("9TU80");

var $3DktE = parcelRequire("3DktE");
const $1b69d56eb37691c6$var$CANVAS_GRID_COLUMNS = 96;
function $1b69d56eb37691c6$var$getCollectionItems(el) {
    // Canvas chrome routes (workspace, wildcard, etc.) live on `context.pages`
    // so smbls' router can find them. The Collection thumbnails must only
    // show the LOADED PROJECT's pages — read them from `context.projectPages`
    // to avoid recursive thumbnails of the canvas itself.
    const pages = el.context?.projectPages || {};
    return Object.entries(pages).map(([key, v])=>({
            value: v,
            key: key,
            type: 'pages',
            title: key,
            settings: {
                gridOptions: {
                    w: 3,
                    h: 3
                }
            }
        }));
}
function $1b69d56eb37691c6$var$generateGrid(n) {
    const obj = {
        '& > .grid-stack-item': {
            width: `${100 / n}%`
        },
        '& > .grid-stack-item[gs-x="1"]': {
            left: `${100 / n}%`
        }
    };
    for(let i = 1; i <= n; i++){
        const pct = `${100 / n * i}%`;
        obj[`& > .grid-stack-item[gs-w="${i}"]`] = {
            width: pct
        };
        obj[`& > .grid-stack-item[gs-x="${i}"]`] = {
            left: pct
        };
    }
    return obj;
}
const $1b69d56eb37691c6$export$cca0565183279949 = $1b69d56eb37691c6$var$CANVAS_GRID_COLUMNS;
const $1b69d56eb37691c6$export$fb8073518f34e6ec = {
    tag: 'div',
    minWidth: '100%',
    minHeight: '1618em',
    class: 'grid-stack',
    style: {
        [`&.gs-${$1b69d56eb37691c6$var$CANVAS_GRID_COLUMNS}`]: $1b69d56eb37691c6$var$generateGrid($1b69d56eb37691c6$var$CANVAS_GRID_COLUMNS)
    },
    childExtends: (0, $3DktE.ComponentThumbnail),
    childrenAs: 'state',
    childProps: {},
    preventContentRecreate: true,
    children: (el)=>$1b69d56eb37691c6$var$getCollectionItems(el),
    onRender: (el)=>{
        if (el.__gridInitialized) return;
        el.__gridInitialized = true;
        const gs = el.context?.globalScope;
        setTimeout(()=>{
            const gridInst = (0, $9TU80.GridStack).addGrid(el.node, {
                column: $1b69d56eb37691c6$var$CANVAS_GRID_COLUMNS,
                float: true,
                margin: '6.235em',
                resizable: {
                    handles: 'all'
                }
            });
            gs.gridStackInstance = gridInst;
            // Forward mouse events from iframe doc to parent for GridStack drag
            const iframeDoc = el.node.ownerDocument;
            if (iframeDoc !== document) {
                const forward = (e)=>document.dispatchEvent(new e.constructor(e.type, e));
                iframeDoc.addEventListener('mousemove', forward, {
                    capture: true,
                    passive: true
                });
                iframeDoc.addEventListener('mouseup', forward, true);
            }
            gridInst.on('change', (event, items)=>{
                if (items) gs.gridChanged = items;
            });
        }, 50);
    }
};

});
parcelRegister("9TU80", function(module, exports) {

$parcel$export(module.exports, "GridStack", () => $7354c9fbc1d6b705$export$19e521a31019cf9d);
/*!
 * GridStack 12.4.2
 * https://gridstackjs.com/
 *
 * Copyright (c) 2021-2025  Alain Dumesny
 * see root license https://github.com/gridstack/gridstack.js/tree/master/LICENSE
 */ 
var $7aq4W = parcelRequire("7aq4W");

var $2wHnB = parcelRequire("2wHnB");

var $9oh67 = parcelRequire("9oh67");

var $aXmGc = parcelRequire("aXmGc");

var $hEwAF = parcelRequire("hEwAF");

var $8OXYl = parcelRequire("8OXYl");
parcelRequire("9nvPp");
parcelRequire("1ozke");
parcelRequire("6fHe9");
parcelRequire("2aRd2");
parcelRequire("eeEhl");
parcelRequire("cT03x");
const $7354c9fbc1d6b705$var$dd = new (0, $aXmGc.DDGridStack);
/**
 * Main gridstack class - you will need to call `GridStack.init()` first to initialize your grid.
 * Note: your grid elements MUST have the following classes for the CSS layout to work:
 * @example
 * <div class="grid-stack">
 *   <div class="grid-stack-item">
 *     <div class="grid-stack-item-content">Item 1</div>
 *   </div>
 * </div>
 */ class $7354c9fbc1d6b705$export$19e521a31019cf9d {
    /**
     * initializing the HTML element, or selector string, into a grid will return the grid. Calling it again will
     * simply return the existing instance (ignore any passed options). There is also an initAll() version that support
     * multiple grids initialization at once. Or you can use addGrid() to create the entire grid from JSON.
     * @param options grid options (optional)
     * @param elOrString element or CSS selector (first one used) to convert to a grid (default to '.grid-stack' class selector)
     *
     * @example
     * const grid = GridStack.init();
     *
     * Note: the HTMLElement (of type GridHTMLElement) will store a `gridstack: GridStack` value that can be retrieve later
     * const grid = document.querySelector('.grid-stack').gridstack;
     */ static init(options = {}, elOrString = '.grid-stack') {
        if (typeof document === 'undefined') return null; // temp workaround SSR
        const el = $7354c9fbc1d6b705$export$19e521a31019cf9d.getGridElement(elOrString);
        if (!el) {
            if (typeof elOrString === 'string') console.error('GridStack.initAll() no grid was found with selector "' + elOrString + '" - element missing or wrong selector ?' + '\nNote: ".grid-stack" is required for proper CSS styling and drag/drop, and is the default selector.');
            else console.error('GridStack.init() no grid element was passed.');
            return null;
        }
        if (!el.gridstack) el.gridstack = new $7354c9fbc1d6b705$export$19e521a31019cf9d(el, (0, $2wHnB.Utils).cloneDeep(options));
        return el.gridstack;
    }
    /**
     * Will initialize a list of elements (given a selector) and return an array of grids.
     * @param options grid options (optional)
     * @param selector elements selector to convert to grids (default to '.grid-stack' class selector)
     *
     * @example
     * const grids = GridStack.initAll();
     * grids.forEach(...)
     */ static initAll(options = {}, selector = '.grid-stack') {
        const grids = [];
        if (typeof document === 'undefined') return grids; // temp workaround SSR
        $7354c9fbc1d6b705$export$19e521a31019cf9d.getGridElements(selector).forEach((el)=>{
            if (!el.gridstack) el.gridstack = new $7354c9fbc1d6b705$export$19e521a31019cf9d(el, (0, $2wHnB.Utils).cloneDeep(options));
            grids.push(el.gridstack);
        });
        if (grids.length === 0) console.error('GridStack.initAll() no grid was found with selector "' + selector + '" - element missing or wrong selector ?' + '\nNote: ".grid-stack" is required for proper CSS styling and drag/drop, and is the default selector.');
        return grids;
    }
    /**
     * call to create a grid with the given options, including loading any children from JSON structure. This will call GridStack.init(), then
     * grid.load() on any passed children (recursively). Great alternative to calling init() if you want entire grid to come from
     * JSON serialized data, including options.
     * @param parent HTML element parent to the grid
     * @param opt grids options used to initialize the grid, and list of children
     */ static addGrid(parent, opt = {}) {
        if (!parent) return null;
        let el = parent;
        if (el.gridstack) {
            // already a grid - set option and load data
            const grid = el.gridstack;
            if (opt) grid.opts = {
                ...grid.opts,
                ...opt
            };
            if (opt.children !== undefined) grid.load(opt.children);
            return grid;
        }
        // create the grid element, but check if the passed 'parent' already has grid styling and should be used instead
        const parentIsGrid = parent.classList.contains('grid-stack');
        if (!parentIsGrid || $7354c9fbc1d6b705$export$19e521a31019cf9d.addRemoveCB) {
            if ($7354c9fbc1d6b705$export$19e521a31019cf9d.addRemoveCB) el = $7354c9fbc1d6b705$export$19e521a31019cf9d.addRemoveCB(parent, opt, true, true);
            else el = (0, $2wHnB.Utils).createDiv([
                'grid-stack',
                opt.class
            ], parent);
        }
        // create grid class and load any children
        const grid = $7354c9fbc1d6b705$export$19e521a31019cf9d.init(opt, el);
        return grid;
    }
    /** call this method to register your engine instead of the default one.
     * See instead `GridStackOptions.engineClass` if you only need to
     * replace just one instance.
     */ static registerEngine(engineClass) {
        $7354c9fbc1d6b705$export$19e521a31019cf9d.engineClass = engineClass;
    }
    /**
     * @internal create placeholder DIV as needed
     * @returns the placeholder element for indicating drop zones during drag operations
     */ get placeholder() {
        if (!this._placeholder) {
            this._placeholder = (0, $2wHnB.Utils).createDiv([
                this.opts.placeholderClass,
                (0, $9oh67.gridDefaults).itemClass,
                this.opts.itemClass
            ]);
            const placeholderChild = (0, $2wHnB.Utils).createDiv([
                'placeholder-content'
            ], this._placeholder);
            if (this.opts.placeholderText) placeholderChild.textContent = this.opts.placeholderText;
        }
        return this._placeholder;
    }
    /**
     * Construct a grid item from the given element and options
     * @param el the HTML element tied to this grid after it's been initialized
     * @param opts grid options - public for classes to access, but use methods to modify!
     */ constructor(el, opts = {}){
        this.el = el;
        this.opts = opts;
        /** time to wait for animation (if enabled) to be done so content sizing can happen */ this.animationDelay = 310;
        /** @internal */ this._gsEventHandler = {};
        /** @internal extra row added when dragging at the bottom of the grid */ this._extraDragRow = 0;
        /** @internal meant to store the scale of the active grid */ this.dragTransform = {
            xScale: 1,
            yScale: 1,
            xOffset: 0,
            yOffset: 0
        };
        el.gridstack = this;
        this.opts = opts = opts || {}; // handles null/undefined/0
        if (!el.classList.contains('grid-stack')) this.el.classList.add('grid-stack');
        // if row property exists, replace minRow and maxRow instead
        if (opts.row) {
            opts.minRow = opts.maxRow = opts.row;
            delete opts.row;
        }
        const rowAttr = (0, $2wHnB.Utils).toNumber(el.getAttribute('gs-row'));
        // flag only valid in sub-grids (handled by parent, not here)
        if (opts.column === 'auto') delete opts.column;
        // save original setting so we can restore on save
        if (opts.alwaysShowResizeHandle !== undefined) opts._alwaysShowResizeHandle = opts.alwaysShowResizeHandle;
        // cleanup responsive opts (must have columnWidth | breakpoints) then sort breakpoints by size (so we can match during resize)
        const resp = opts.columnOpts;
        if (resp) {
            const bk = resp.breakpoints;
            if (!resp.columnWidth && !bk?.length) delete opts.columnOpts;
            else {
                resp.columnMax = resp.columnMax || 12;
                if (bk?.length > 1) bk.sort((a, b)=>(b.w || 0) - (a.w || 0));
            }
        }
        // elements DOM attributes override any passed options (like CSS style) - merge the two together
        const defaults = {
            ...(0, $2wHnB.Utils).cloneDeep((0, $9oh67.gridDefaults)),
            column: (0, $2wHnB.Utils).toNumber(el.getAttribute('gs-column')) || (0, $9oh67.gridDefaults).column,
            minRow: rowAttr ? rowAttr : (0, $2wHnB.Utils).toNumber(el.getAttribute('gs-min-row')) || (0, $9oh67.gridDefaults).minRow,
            maxRow: rowAttr ? rowAttr : (0, $2wHnB.Utils).toNumber(el.getAttribute('gs-max-row')) || (0, $9oh67.gridDefaults).maxRow,
            staticGrid: (0, $2wHnB.Utils).toBool(el.getAttribute('gs-static')) || (0, $9oh67.gridDefaults).staticGrid,
            sizeToContent: (0, $2wHnB.Utils).toBool(el.getAttribute('gs-size-to-content')) || undefined,
            draggable: {
                handle: (opts.handleClass ? '.' + opts.handleClass : opts.handle ? opts.handle : '') || (0, $9oh67.gridDefaults).draggable.handle
            },
            removableOptions: {
                accept: opts.itemClass || (0, $9oh67.gridDefaults).removableOptions.accept,
                decline: (0, $9oh67.gridDefaults).removableOptions.decline
            }
        };
        if (el.getAttribute('gs-animate')) defaults.animate = (0, $2wHnB.Utils).toBool(el.getAttribute('gs-animate'));
        opts = (0, $2wHnB.Utils).defaults(opts, defaults);
        this._initMargin(); // part of settings defaults...
        // Now check if we're loading into !12 column mode FIRST so we don't do un-necessary work (like cellHeight = width / 12 then go 1 column)
        this.checkDynamicColumn();
        this._updateColumnVar(opts);
        if (opts.rtl === 'auto') opts.rtl = el.style.direction === 'rtl';
        if (opts.rtl) this.el.classList.add('grid-stack-rtl');
        // check if we're been nested, and if so update our style and keep pointer around (used during save)
        const parentGridItem = this.el.closest('.' + (0, $9oh67.gridDefaults).itemClass);
        const parentNode = parentGridItem?.gridstackNode;
        if (parentNode) {
            parentNode.subGrid = this;
            this.parentGridNode = parentNode;
            this.el.classList.add('grid-stack-nested');
            parentNode.el.classList.add('grid-stack-sub-grid');
        }
        this._isAutoCellHeight = opts.cellHeight === 'auto';
        if (this._isAutoCellHeight || opts.cellHeight === 'initial') // make the cell content square initially (will use resize/column event to keep it square)
        this.cellHeight(undefined);
        else {
            // append unit if any are set
            if (typeof opts.cellHeight == 'number' && opts.cellHeightUnit && opts.cellHeightUnit !== (0, $9oh67.gridDefaults).cellHeightUnit) {
                opts.cellHeight = opts.cellHeight + opts.cellHeightUnit;
                delete opts.cellHeightUnit;
            }
            const val = opts.cellHeight;
            delete opts.cellHeight; // force initial cellHeight() call to set the value
            this.cellHeight(val);
        }
        // see if we need to adjust auto-hide
        if (opts.alwaysShowResizeHandle === 'mobile') opts.alwaysShowResizeHandle = (0, $hEwAF.isTouch);
        this._setStaticClass();
        const engineClass = opts.engineClass || $7354c9fbc1d6b705$export$19e521a31019cf9d.engineClass || (0, $7aq4W.GridStackEngine);
        this.engine = new engineClass({
            column: this.getColumn(),
            float: opts.float,
            maxRow: opts.maxRow,
            onChange: (cbNodes)=>{
                cbNodes.forEach((n)=>{
                    const el = n.el;
                    if (!el) return;
                    if (n._removeDOM) {
                        if (el) el.remove();
                        delete n._removeDOM;
                    } else this._writePosAttr(el, n);
                });
                this._updateContainerHeight();
            }
        });
        if (opts.auto) {
            this.batchUpdate(); // prevent in between re-layout #1535 TODO: this only set float=true, need to prevent collision check...
            this.engine._loading = true; // loading collision check
            this.getGridItems().forEach((el)=>this._prepareElement(el));
            delete this.engine._loading;
            this.batchUpdate(false);
        }
        // load any passed in children as well, which overrides any DOM layout done above
        if (opts.children) {
            const children = opts.children;
            delete opts.children;
            if (children.length) this.load(children); // don't load empty
        }
        this.setAnimation();
        // dynamic grids require pausing during drag to detect over to nest vs push
        if (opts.subGridDynamic && !(0, $8OXYl.DDManager).pauseDrag) (0, $8OXYl.DDManager).pauseDrag = true;
        if (opts.draggable?.pause !== undefined) (0, $8OXYl.DDManager).pauseDrag = opts.draggable.pause;
        this._setupRemoveDrop();
        this._setupAcceptWidget();
        this._updateResizeEvent();
    }
    _updateColumnVar(opts = this.opts) {
        this.el.classList.add('gs-' + opts.column);
        if (typeof opts.column === 'number') this.el.style.setProperty('--gs-column-width', `${100 / opts.column}%`);
    }
    /**
     * add a new widget and returns it.
     *
     * Widget will be always placed even if result height is more than actual grid height.
     * You need to use `willItFit()` before calling addWidget for additional check.
     * See also `makeWidget(el)` for DOM element.
     *
     * @example
     * const grid = GridStack.init();
     * grid.addWidget({w: 3, content: 'hello'});
     *
     * @param w GridStackWidget definition. used MakeWidget(el) if you have dom element instead.
     */ addWidget(w) {
        if (!w) return;
        if (typeof w === 'string') {
            console.error('V11: GridStack.addWidget() does not support string anymore. see #2736');
            return;
        }
        if (w.ELEMENT_NODE) {
            console.error('V11: GridStack.addWidget() does not support HTMLElement anymore. use makeWidget()');
            return this.makeWidget(w);
        }
        let el;
        let node = w;
        node.grid = this;
        if (node.el) el = node.el; // re-use element stored in the node
        else if ($7354c9fbc1d6b705$export$19e521a31019cf9d.addRemoveCB) el = $7354c9fbc1d6b705$export$19e521a31019cf9d.addRemoveCB(this.el, w, true, false);
        else el = this.createWidgetDivs(node);
        if (!el) return;
        // if the caller ended up initializing the widget in addRemoveCB, or we stared with one already, skip the rest
        node = el.gridstackNode;
        if (node && el.parentElement === this.el && this.engine.nodes.find((n)=>n._id === node._id)) return el;
        // Tempting to initialize the passed in opt with default and valid values, but this break knockout demos
        // as the actual value are filled in when _prepareElement() calls el.getAttribute('gs-xyz') before adding the node.
        // So make sure we load any DOM attributes that are not specified in passed in options (which override)
        const domAttr = this._readAttr(el);
        (0, $2wHnB.Utils).defaults(w, domAttr);
        this.engine.prepareNode(w);
        // this._writeAttr(el, w); why write possibly incorrect values back when makeWidget() will ?
        this.el.appendChild(el);
        this.makeWidget(el, w);
        return el;
    }
    /**
     * Create the default grid item divs and content (possibly lazy loaded) by using GridStack.renderCB().
     *
     * @param n GridStackNode definition containing widget configuration
     * @returns the created HTML element with proper grid item structure
     *
     * @example
     * const element = grid.createWidgetDivs({ w: 2, h: 1, content: 'Hello World' });
     */ createWidgetDivs(n) {
        const el = (0, $2wHnB.Utils).createDiv([
            'grid-stack-item',
            this.opts.itemClass
        ]);
        const cont = (0, $2wHnB.Utils).createDiv([
            'grid-stack-item-content'
        ], el);
        if ((0, $2wHnB.Utils).lazyLoad(n)) {
            if (!n.visibleObservable) {
                n.visibleObservable = new IntersectionObserver(([entry])=>{
                    if (entry.isIntersecting) {
                        n.visibleObservable?.disconnect();
                        delete n.visibleObservable;
                        $7354c9fbc1d6b705$export$19e521a31019cf9d.renderCB(cont, n);
                        n.grid?.prepareDragDrop(n.el);
                    }
                });
                window.setTimeout(()=>n.visibleObservable?.observe(el)); // wait until callee sets position attributes
            }
        } else $7354c9fbc1d6b705$export$19e521a31019cf9d.renderCB(cont, n);
        return el;
    }
    /**
     * Convert an existing gridItem element into a sub-grid with the given (optional) options, else inherit them
     * from the parent's subGrid options.
     * @param el gridItem element to convert
     * @param ops (optional) sub-grid options, else default to node, then parent settings, else defaults
     * @param nodeToAdd (optional) node to add to the newly created sub grid (used when dragging over existing regular item)
     * @param saveContent if true (default) the html inside .grid-stack-content will be saved to child widget
     * @returns newly created grid
     */ makeSubGrid(el, ops, nodeToAdd, saveContent = true) {
        let node = el.gridstackNode;
        if (!node) node = this.makeWidget(el).gridstackNode;
        if (node.subGrid?.el) return node.subGrid; // already done
        // find the template subGrid stored on a parent as fallback...
        let subGridTemplate; // eslint-disable-next-line @typescript-eslint/no-this-alias
        let grid = this;
        while(grid && !subGridTemplate){
            subGridTemplate = grid.opts?.subGridOpts;
            grid = grid.parentGridNode?.grid;
        }
        //... and set the create options
        ops = (0, $2wHnB.Utils).cloneDeep({
            // by default sub-grid inherit from us | parent, other than id, children, etc...
            ...this.opts,
            id: undefined,
            children: undefined,
            column: 'auto',
            columnOpts: undefined,
            layout: 'list',
            subGridOpts: undefined,
            ...subGridTemplate || {},
            ...ops || node.subGridOpts || {}
        });
        node.subGridOpts = ops;
        // if column special case it set, remember that flag and set default
        let autoColumn;
        if (ops.column === 'auto') {
            autoColumn = true;
            ops.column = Math.max(node.w || 1, nodeToAdd?.w || 1);
            delete ops.columnOpts; // driven by parent
        }
        // if we're converting an existing full item, move over the content to be the first sub item in the new grid
        let content = node.el.querySelector('.grid-stack-item-content');
        let newItem;
        let newItemOpt;
        if (saveContent) {
            this._removeDD(node.el); // remove D&D since it's set on content div
            newItemOpt = {
                ...node,
                x: 0,
                y: 0
            };
            (0, $2wHnB.Utils).removeInternalForSave(newItemOpt);
            delete newItemOpt.subGridOpts;
            if (node.content) {
                newItemOpt.content = node.content;
                delete node.content;
            }
            if ($7354c9fbc1d6b705$export$19e521a31019cf9d.addRemoveCB) newItem = $7354c9fbc1d6b705$export$19e521a31019cf9d.addRemoveCB(this.el, newItemOpt, true, false);
            else {
                newItem = (0, $2wHnB.Utils).createDiv([
                    'grid-stack-item'
                ]);
                newItem.appendChild(content);
                content = (0, $2wHnB.Utils).createDiv([
                    'grid-stack-item-content'
                ], node.el);
            }
            this.prepareDragDrop(node.el); // ... and restore original D&D
        }
        // if we're adding an additional item, make the container large enough to have them both
        if (nodeToAdd) {
            const w = autoColumn ? ops.column : node.w;
            const h = node.h + nodeToAdd.h;
            const style = node.el.style;
            style.transition = 'none'; // show up instantly so we don't see scrollbar with nodeToAdd
            this.update(node.el, {
                w: w,
                h: h
            });
            setTimeout(()=>style.transition = null); // recover animation
        }
        const subGrid = node.subGrid = $7354c9fbc1d6b705$export$19e521a31019cf9d.addGrid(content, ops);
        if (nodeToAdd?._moving) subGrid._isTemp = true; // prevent re-nesting as we add over
        if (autoColumn) subGrid._autoColumn = true;
        // add the original content back as a child of the newly created grid
        if (saveContent) subGrid.makeWidget(newItem, newItemOpt);
        // now add any additional node
        if (nodeToAdd) {
            if (nodeToAdd._moving) // create an artificial event even for the just created grid to receive this item
            window.setTimeout(()=>(0, $2wHnB.Utils).simulateMouseEvent(nodeToAdd._event, 'mouseenter', subGrid.el), 0);
            else subGrid.makeWidget(node.el, node);
        }
        // if sizedToContent, we need to re-calc the size of ourself
        this.resizeToContentCheck(false, node);
        return subGrid;
    }
    /**
     * called when an item was converted into a nested grid to accommodate a dragged over item, but then item leaves - return back
     * to the original grid-item. Also called to remove empty sub-grids when last item is dragged out (since re-creating is simple)
     */ removeAsSubGrid(nodeThatRemoved) {
        const pGrid = this.parentGridNode?.grid;
        if (!pGrid) return;
        pGrid.batchUpdate();
        pGrid.removeWidget(this.parentGridNode.el, true, true);
        this.engine.nodes.forEach((n)=>{
            // migrate any children over and offsetting by our location
            n.x += this.parentGridNode.x;
            n.y += this.parentGridNode.y;
            pGrid.makeWidget(n.el, n);
        });
        pGrid.batchUpdate(false);
        if (this.parentGridNode) delete this.parentGridNode.subGrid;
        delete this.parentGridNode;
        // create an artificial event for the original grid now that this one is gone (got a leave, but won't get enter)
        if (nodeThatRemoved) window.setTimeout(()=>(0, $2wHnB.Utils).simulateMouseEvent(nodeThatRemoved._event, 'mouseenter', pGrid.el), 0);
    }
    /**
     * saves the current layout returning a list of widgets for serialization which might include any nested grids.
     * @param saveContent if true (default) the latest html inside .grid-stack-content will be saved to GridStackWidget.content field, else it will
     * be removed.
     * @param saveGridOpt if true (default false), save the grid options itself, so you can call the new GridStack.addGrid()
     * to recreate everything from scratch. GridStackOptions.children would then contain the widget list instead.
     * @param saveCB callback for each node -> widget, so application can insert additional data to be saved into the widget data structure.
     * @param column if provided, the grid will be saved for the given column size (IFF we have matching internal saved layout, or current layout).
     * Otherwise it will use the largest possible layout (say 12 even if rendering at 1 column) so we can restore to all layouts.
     * NOTE: if you want to save to currently display layout, pass this.getColumn() as column.
     * NOTE2: nested grids will ALWAYS save to the container size to be in sync with parent.
     * @returns list of widgets or full grid option, including .children list of widgets
     */ save(saveContent = true, saveGridOpt = false, saveCB = $7354c9fbc1d6b705$export$19e521a31019cf9d.saveCB, column) {
        // return copied GridStackWidget (with optionally .el) we can modify at will...
        const list = this.engine.save(saveContent, saveCB, column);
        // check for HTML content and nested grids
        list.forEach((n)=>{
            if (saveContent && n.el && !n.subGrid && !saveCB) {
                const itemContent = n.el.querySelector('.grid-stack-item-content');
                n.content = itemContent?.innerHTML;
                if (!n.content) delete n.content;
            } else {
                if (!saveContent && !saveCB) delete n.content;
                // check for nested grid - make sure it saves to the given container size to be consistent
                if (n.subGrid?.el) {
                    const column = n.w || n.subGrid.getColumn();
                    const listOrOpt = n.subGrid.save(saveContent, saveGridOpt, saveCB, column);
                    n.subGridOpts = saveGridOpt ? listOrOpt : {
                        children: listOrOpt
                    };
                    delete n.subGrid;
                }
            }
            delete n.el;
        });
        // check if save entire grid options (needed for recursive) + children...
        if (saveGridOpt) {
            const o = (0, $2wHnB.Utils).cloneDeep(this.opts);
            // delete default values that will be recreated on launch
            if (o.marginBottom === o.marginTop && o.marginRight === o.marginLeft && o.marginTop === o.marginRight) {
                o.margin = o.marginTop;
                delete o.marginTop;
                delete o.marginRight;
                delete o.marginBottom;
                delete o.marginLeft;
            }
            if (o.rtl === (this.el.style.direction === 'rtl')) o.rtl = 'auto';
            if (this._isAutoCellHeight) o.cellHeight = 'auto';
            if (this._autoColumn) o.column = 'auto';
            const origShow = o._alwaysShowResizeHandle;
            delete o._alwaysShowResizeHandle;
            if (origShow !== undefined) o.alwaysShowResizeHandle = origShow;
            else delete o.alwaysShowResizeHandle;
            (0, $2wHnB.Utils).removeInternalAndSame(o, (0, $9oh67.gridDefaults));
            o.children = list;
            return o;
        }
        return list;
    }
    /**
     * Load widgets from a list. This will call update() on each (matching by id) or add/remove widgets that are not there.
     * Used to restore a grid layout for a saved layout list (see `save()`).
     *
     * @param items list of widgets definition to update/create
     * @param addRemove boolean (default true) or callback method can be passed to control if and how missing widgets can be added/removed, giving
     * the user control of insertion.
     * @returns the grid instance for chaining
     *
     * @example
     * // Basic usage with saved layout
     * const savedLayout = grid.save(); // Save current layout
     * // ... later restore it
     * grid.load(savedLayout);
     *
     * // Load with custom add/remove callback
     * grid.load(layout, (items, grid, add) => {
     *   if (add) {
     *     // Custom logic for adding new widgets
     *     items.forEach(item => {
     *       const el = document.createElement('div');
     *       el.innerHTML = item.content || '';
     *       grid.addWidget(el, item);
     *     });
     *   } else {
     *     // Custom logic for removing widgets
     *     items.forEach(item => grid.removeWidget(item.el));
     *   }
     * });
     *
     * // Load without adding/removing missing widgets
     * grid.load(layout, false);
     *
     * @see {@link http://gridstackjs.com/demo/serialization.html} for complete example
     */ load(items, addRemove = $7354c9fbc1d6b705$export$19e521a31019cf9d.addRemoveCB || true) {
        items = (0, $2wHnB.Utils).cloneDeep(items); // so we can mod
        const column = this.getColumn();
        // make sure size 1x1 (default) is present as it may need to override current sizes
        items.forEach((n)=>{
            n.w = n.w || n.minW || 1;
            n.h = n.h || n.minH || 1;
        });
        // sort items. those without coord will be appended last
        items = (0, $2wHnB.Utils).sort(items);
        this.engine.skipCacheUpdate = this._ignoreLayoutsNodeChange = true; // skip layout update
        // if we're loading a layout into for example 1 column and items don't fit, make sure to save
        // the original wanted layout so we can scale back up correctly #1471
        let maxColumn = 0;
        items.forEach((n)=>{
            maxColumn = Math.max(maxColumn, (n.x || 0) + n.w);
        });
        if (maxColumn > this.engine.defaultColumn) this.engine.defaultColumn = maxColumn;
        if (maxColumn > column) {
            // if we're loading (from empty) into a smaller column, check for special responsive layout
            if (this.engine.nodes.length === 0 && this.responseLayout) {
                this.engine.nodes = items;
                this.engine.columnChanged(maxColumn, column, this.responseLayout);
                items = this.engine.nodes;
                this.engine.nodes = [];
                delete this.responseLayout;
            } else this.engine.cacheLayout(items, maxColumn, true);
        }
        // if given a different callback, temporally set it as global option so creating will use it
        const prevCB = $7354c9fbc1d6b705$export$19e521a31019cf9d.addRemoveCB;
        if (typeof addRemove === 'function') $7354c9fbc1d6b705$export$19e521a31019cf9d.addRemoveCB = addRemove;
        const removed = [];
        this.batchUpdate();
        // if we are loading from empty temporarily remove animation
        const blank = !this.engine.nodes.length;
        const noAnim = blank && this.opts.animate;
        if (noAnim) this.setAnimation(false);
        // see if any items are missing from new layout and need to be removed first
        if (!blank && addRemove) {
            const copyNodes = [
                ...this.engine.nodes
            ]; // don't loop through array you modify
            copyNodes.forEach((n)=>{
                if (!n.id) return;
                const item = (0, $2wHnB.Utils).find(items, n.id);
                if (!item) {
                    if ($7354c9fbc1d6b705$export$19e521a31019cf9d.addRemoveCB) $7354c9fbc1d6b705$export$19e521a31019cf9d.addRemoveCB(this.el, n, false, false);
                    removed.push(n); // batch keep track
                    this.removeWidget(n.el, true, false);
                }
            });
        }
        // now add/update the widgets - starting with removing items in the new layout we will reposition
        // to reduce collision and add no-coord ones at next available spot
        this.engine._loading = true; // help with collision
        const updateNodes = [];
        this.engine.nodes = this.engine.nodes.filter((n)=>{
            if ((0, $2wHnB.Utils).find(items, n.id)) {
                updateNodes.push(n);
                return false;
            } // remove if found from list
            return true;
        });
        items.forEach((w)=>{
            const item = (0, $2wHnB.Utils).find(updateNodes, w.id);
            if (item) {
                // if item sizes to content, re-use the exiting height so it's a better guess at the final size (same if width doesn't change)
                if ((0, $2wHnB.Utils).shouldSizeToContent(item)) w.h = item.h;
                // check if missing coord, in which case find next empty slot with new (or old if missing) sizes
                this.engine.nodeBoundFix(w);
                if (w.autoPosition || w.x === undefined || w.y === undefined) {
                    w.w = w.w || item.w;
                    w.h = w.h || item.h;
                    this.engine.findEmptyPosition(w);
                }
                // add back to current list BUT force a collision check if it 'appears' we didn't change to make sure we don't overlap others now
                this.engine.nodes.push(item);
                if ((0, $2wHnB.Utils).samePos(item, w) && this.engine.nodes.length > 1) {
                    this.moveNode(item, {
                        ...w,
                        forceCollide: true
                    });
                    (0, $2wHnB.Utils).copyPos(w, item); // use possily updated values before update() is called next (no-op since already moved)
                }
                this.update(item.el, w);
                if (w.subGridOpts?.children) {
                    const sub = item.el.querySelector('.grid-stack');
                    if (sub && sub.gridstack) sub.gridstack.load(w.subGridOpts.children); // TODO: support updating grid options ?
                }
            } else if (addRemove) this.addWidget(w);
        });
        delete this.engine._loading; // done loading
        this.engine.removedNodes = removed;
        this.batchUpdate(false);
        // after commit, clear that flag
        delete this._ignoreLayoutsNodeChange;
        delete this.engine.skipCacheUpdate;
        prevCB ? $7354c9fbc1d6b705$export$19e521a31019cf9d.addRemoveCB = prevCB : delete $7354c9fbc1d6b705$export$19e521a31019cf9d.addRemoveCB;
        if (noAnim) this.setAnimation(true, true); // delay adding animation back
        return this;
    }
    /**
     * use before calling a bunch of `addWidget()` to prevent un-necessary relayouts in between (more efficient)
     * and get a single event callback. You will see no changes until `batchUpdate(false)` is called.
     */ batchUpdate(flag = true) {
        this.engine.batchUpdate(flag);
        if (!flag) {
            this._updateContainerHeight();
            this._triggerRemoveEvent();
            this._triggerAddEvent();
            this._triggerChangeEvent();
        }
        return this;
    }
    /**
     * Gets the current cell height in pixels. This takes into account the unit type and converts to pixels if necessary.
     *
     * @param forcePixel if true, forces conversion to pixels even when cellHeight is specified in other units
     * @returns the cell height in pixels
     *
     * @example
     * const height = grid.getCellHeight();
     * console.log('Cell height:', height, 'px');
     *
     * // Force pixel conversion
     * const pixelHeight = grid.getCellHeight(true);
     */ getCellHeight(forcePixel = false) {
        if (this.opts.cellHeight && this.opts.cellHeight !== 'auto' && (!forcePixel || !this.opts.cellHeightUnit || this.opts.cellHeightUnit === 'px')) return this.opts.cellHeight;
        // do rem/em/cm/mm to px conversion
        if (this.opts.cellHeightUnit === 'rem') return this.opts.cellHeight * parseFloat(getComputedStyle(document.documentElement).fontSize);
        if (this.opts.cellHeightUnit === 'em') return this.opts.cellHeight * parseFloat(getComputedStyle(this.el).fontSize);
        if (this.opts.cellHeightUnit === 'cm') // 1cm = 96px/2.54. See https://www.w3.org/TR/css-values-3/#absolute-lengths
        return this.opts.cellHeight * (96 / 2.54);
        if (this.opts.cellHeightUnit === 'mm') return this.opts.cellHeight * (96 / 2.54) / 10;
        // else get first cell height
        const el = this.el.querySelector('.' + this.opts.itemClass);
        if (el) {
            const h = (0, $2wHnB.Utils).toNumber(el.getAttribute('gs-h')) || 1; // since we don't write 1 anymore
            return Math.round(el.offsetHeight / h);
        }
        // else do entire grid and # of rows (but doesn't work if min-height is the actual constrain)
        const rows = parseInt(this.el.getAttribute('gs-current-row'));
        return rows ? Math.round(this.el.getBoundingClientRect().height / rows) : this.opts.cellHeight;
    }
    /**
     * Update current cell height - see `GridStackOptions.cellHeight` for format by updating eh Browser CSS variable.
     *
     * @param val the cell height. Options:
     *   - `undefined`: cells content will be made square (match width minus margin)
     *   - `0`: the CSS will be generated by the application instead
     *   - number: height in pixels
     *   - string: height with units (e.g., '70px', '5rem', '2em')
     * @returns the grid instance for chaining
     *
     * @example
     * grid.cellHeight(100);     // 100px height
     * grid.cellHeight('70px');  // explicit pixel height
     * grid.cellHeight('5rem');  // relative to root font size
     * grid.cellHeight(grid.cellWidth() * 1.2); // aspect ratio
     * grid.cellHeight('auto');  // auto-size based on content
     */ cellHeight(val) {
        // if not called internally, check if we're changing mode
        if (val !== undefined) {
            if (this._isAutoCellHeight !== (val === 'auto')) {
                this._isAutoCellHeight = val === 'auto';
                this._updateResizeEvent();
            }
        }
        if (val === 'initial' || val === 'auto') val = undefined;
        // make item content be square
        if (val === undefined) {
            const marginDiff = -this.opts.marginRight - this.opts.marginLeft + this.opts.marginTop + this.opts.marginBottom;
            val = this.cellWidth() + marginDiff;
        }
        const data = (0, $2wHnB.Utils).parseHeight(val);
        if (this.opts.cellHeightUnit === data.unit && this.opts.cellHeight === data.h) return this;
        this.opts.cellHeightUnit = data.unit;
        this.opts.cellHeight = data.h;
        // finally update var and container
        this.el.style.setProperty('--gs-cell-height', `${this.opts.cellHeight}${this.opts.cellHeightUnit}`);
        this._updateContainerHeight();
        this.resizeToContentCheck();
        return this;
    }
    /** Gets current cell width. */ /**
     * Gets the current cell width in pixels. This is calculated based on the grid container width divided by the number of columns.
     *
     * @returns the cell width in pixels
     *
     * @example
     * const width = grid.cellWidth();
     * console.log('Cell width:', width, 'px');
     *
     * // Use cell width to calculate widget dimensions
     * const widgetWidth = width * 3; // For a 3-column wide widget
     */ cellWidth() {
        return this._widthOrContainer() / this.getColumn();
    }
    /** return our expected width (or parent) , and optionally of window for dynamic column check */ _widthOrContainer(forBreakpoint = false) {
        // use `offsetWidth` or `clientWidth` (no scrollbar) ?
        // https://stackoverflow.com/questions/21064101/understanding-offsetwidth-clientwidth-scrollwidth-and-height-respectively
        return forBreakpoint && this.opts.columnOpts?.breakpointForWindow ? window.innerWidth : this.el.clientWidth || this.el.parentElement.clientWidth || window.innerWidth;
    }
    /** checks for dynamic column count for our current size, returning true if changed */ checkDynamicColumn() {
        const resp = this.opts.columnOpts;
        if (!resp || !resp.columnWidth && !resp.breakpoints?.length) return false;
        const column = this.getColumn();
        let newColumn = column;
        const w = this._widthOrContainer(true);
        if (resp.columnWidth) newColumn = Math.min(Math.round(w / resp.columnWidth) || 1, resp.columnMax);
        else {
            // find the closest breakpoint (already sorted big to small) that matches
            newColumn = resp.columnMax;
            let i = 0;
            while(i < resp.breakpoints.length && w <= resp.breakpoints[i].w)newColumn = resp.breakpoints[i++].c || column;
        }
        if (newColumn !== column) {
            const bk = resp.breakpoints?.find((b)=>b.c === newColumn);
            this.column(newColumn, bk?.layout || resp.layout);
            return true;
        }
        return false;
    }
    /**
     * Re-layout grid items to reclaim any empty space. This is useful after removing widgets
     * or when you want to optimize the layout.
     *
     * @param layout layout type. Options:
     *   - 'compact' (default): might re-order items to fill any empty space
     *   - 'list': keep the widget left->right order the same, even if that means leaving an empty slot if things don't fit
     * @param doSort re-sort items first based on x,y position. Set to false to do your own sorting ahead (default: true)
     * @returns the grid instance for chaining
     *
     * @example
     * // Compact layout after removing widgets
     * grid.removeWidget('.widget-to-remove');
     * grid.compact();
     *
     * // Use list layout (preserve order)
     * grid.compact('list');
     *
     * // Compact without sorting first
     * grid.compact('compact', false);
     */ compact(layout = 'compact', doSort = true) {
        this.engine.compact(layout, doSort);
        this._triggerChangeEvent();
        return this;
    }
    /**
     * Set the number of columns in the grid. Will update existing widgets to conform to new number of columns,
     * as well as cache the original layout so you can revert back to previous positions without loss.
     *
     * Requires `gridstack-extra.css` or `gridstack-extra.min.css` for [2-11] columns,
     * else you will need to generate correct CSS.
     * See: https://github.com/gridstack/gridstack.js#change-grid-columns
     *
     * @param column Integer > 0 (default 12)
     * @param layout specify the type of re-layout that will happen. Options:
     *   - 'moveScale' (default): scale widget positions and sizes
     *   - 'move': keep widget sizes, only move positions
     *   - 'scale': keep widget positions, only scale sizes
     *   - 'none': don't change widget positions or sizes
     *   Note: items will never be outside of the current column boundaries.
     *   Ignored for `column=1` as we always want to vertically stack.
     * @returns the grid instance for chaining
     *
     * @example
     * // Change to 6 columns with default scaling
     * grid.column(6);
     *
     * // Change to 4 columns, only move positions
     * grid.column(4, 'move');
     *
     * // Single column layout (vertical stack)
     * grid.column(1);
     */ column(column, layout = 'moveScale') {
        if (!column || column < 1 || this.opts.column === column) return this;
        const oldColumn = this.getColumn();
        this.opts.column = column;
        if (!this.engine) {
            // called in constructor, noting else to do but remember that breakpoint layout
            this.responseLayout = layout;
            return this;
        }
        this.engine.column = column;
        this.el.classList.remove('gs-' + oldColumn);
        this._updateColumnVar();
        // update the items now
        this.engine.columnChanged(oldColumn, column, layout);
        if (this._isAutoCellHeight) this.cellHeight();
        this.resizeToContentCheck(true); // wait for width resizing
        // and trigger our event last...
        this._ignoreLayoutsNodeChange = true; // skip layout update
        this._triggerChangeEvent();
        delete this._ignoreLayoutsNodeChange;
        return this;
    }
    /**
     * Get the number of columns in the grid (default 12).
     *
     * @returns the current number of columns in the grid
     *
     * @example
     * const columnCount = grid.getColumn(); // returns 12 by default
     */ getColumn() {
        return this.opts.column;
    }
    /**
     * Returns an array of grid HTML elements (no placeholder) - used to iterate through our children in DOM order.
     * This method excludes placeholder elements and returns only actual grid items.
     *
     * @returns array of GridItemHTMLElement instances representing all grid items
     *
     * @example
     * const items = grid.getGridItems();
     * items.forEach(item => {
     *   console.log('Item ID:', item.gridstackNode.id);
     * });
     */ getGridItems() {
        return Array.from(this.el.children).filter((el)=>el.matches('.' + this.opts.itemClass) && !el.matches('.' + this.opts.placeholderClass));
    }
    /**
     * Returns true if change callbacks should be ignored due to column change, sizeToContent, loading, etc.
     * This is useful for callers who want to implement dirty flag functionality.
     *
     * @returns true if change callbacks are currently being ignored
     *
     * @example
     * if (!grid.isIgnoreChangeCB()) {
     *   // Process the change event
     *   console.log('Grid layout changed');
     * }
     */ isIgnoreChangeCB() {
        return this._ignoreLayoutsNodeChange;
    }
    /**
     * Destroys a grid instance. DO NOT CALL any methods or access any vars after this as it will free up members.
     * @param removeDOM if `false` grid and items HTML elements will not be removed from the DOM (Optional. Default `true`).
     */ destroy(removeDOM = true) {
        if (!this.el) return; // prevent multiple calls
        this.offAll();
        this._updateResizeEvent(true);
        this.setStatic(true, false); // permanently removes DD but don't set CSS class (we're going away)
        this.setAnimation(false);
        if (!removeDOM) {
            this.removeAll(removeDOM);
            this.el.removeAttribute('gs-current-row');
        } else this.el.parentNode.removeChild(this.el);
        if (this.parentGridNode) delete this.parentGridNode.subGrid;
        delete this.parentGridNode;
        delete this.opts;
        delete this._placeholder?.gridstackNode;
        delete this._placeholder;
        delete this.engine;
        delete this.el.gridstack; // remove circular dependency that would prevent a freeing
        delete this.el;
        return this;
    }
    /**
     * Enable/disable floating widgets (default: `false`). When enabled, widgets can float up to fill empty spaces.
     * See [example](http://gridstackjs.com/demo/float.html)
     *
     * @param val true to enable floating, false to disable
     * @returns the grid instance for chaining
     *
     * @example
     * grid.float(true);  // Enable floating
     * grid.float(false); // Disable floating (default)
     */ float(val) {
        if (this.opts.float !== val) {
            this.opts.float = this.engine.float = val;
            this._triggerChangeEvent();
        }
        return this;
    }
    /**
     * Get the current float mode setting.
     *
     * @returns true if floating is enabled, false otherwise
     *
     * @example
     * const isFloating = grid.getFloat();
     * console.log('Floating enabled:', isFloating);
     */ getFloat() {
        return this.engine.float;
    }
    /**
     * Get the position of the cell under a pixel on screen.
     * @param position the position of the pixel to resolve in
     * absolute coordinates, as an object with top and left properties
     * @param useDocRelative if true, value will be based on document position vs parent position (Optional. Default false).
     * Useful when grid is within `position: relative` element
     *
     * Returns an object with properties `x` and `y` i.e. the column and row in the grid.
     */ getCellFromPixel(position, useDocRelative = false) {
        const box = this.el.getBoundingClientRect();
        // console.log(`getBoundingClientRect left: ${box.left} top: ${box.top} w: ${box.w} h: ${box.h}`)
        let containerPos;
        if (useDocRelative) containerPos = {
            top: box.top + document.documentElement.scrollTop,
            left: box.left
        };
        else containerPos = {
            top: this.el.offsetTop,
            left: this.el.offsetLeft
        };
        const relativeLeft = position.left - containerPos.left;
        const relativeTop = position.top - containerPos.top;
        const columnWidth = box.width / this.getColumn();
        const rowHeight = box.height / parseInt(this.el.getAttribute('gs-current-row'));
        return {
            x: Math.floor(relativeLeft / columnWidth),
            y: Math.floor(relativeTop / rowHeight)
        };
    }
    /**
     * Returns the current number of rows, which will be at least `minRow` if set.
     * The row count is based on the highest positioned widget in the grid.
     *
     * @returns the current number of rows in the grid
     *
     * @example
     * const rowCount = grid.getRow();
     * console.log('Grid has', rowCount, 'rows');
     */ getRow() {
        return Math.max(this.engine.getRow(), this.opts.minRow || 0);
    }
    /**
     * Checks if the specified rectangular area is empty (no widgets occupy any part of it).
     *
     * @param x the x coordinate (column) of the area to check
     * @param y the y coordinate (row) of the area to check
     * @param w the width in columns of the area to check
     * @param h the height in rows of the area to check
     * @returns true if the area is completely empty, false if any widget overlaps
     *
     * @example
     * // Check if a 2x2 area at position (1,1) is empty
     * if (grid.isAreaEmpty(1, 1, 2, 2)) {
     *   console.log('Area is available for placement');
     * }
     */ isAreaEmpty(x, y, w, h) {
        return this.engine.isAreaEmpty(x, y, w, h);
    }
    /**
     * If you add elements to your grid by hand (or have some framework creating DOM), you have to tell gridstack afterwards to make them widgets.
     * If you want gridstack to add the elements for you, use `addWidget()` instead.
     * Makes the given element a widget and returns it.
     *
     * @param els widget or single selector to convert.
     * @param options widget definition to use instead of reading attributes or using default sizing values
     * @returns the converted GridItemHTMLElement
     *
     * @example
     * const grid = GridStack.init();
     *
     * // Create HTML content manually, possibly looking like:
     * // <div id="item-1" gs-x="0" gs-y="0" gs-w="3" gs-h="2"></div>
     * grid.el.innerHTML = '<div id="item-1" gs-w="3"></div><div id="item-2"></div>';
     *
     * // Convert existing elements to widgets
     * grid.makeWidget('#item-1'); // Uses gs-* attributes from DOM
     * grid.makeWidget('#item-2', {w: 2, h: 1, content: 'Hello World'});
     *
     * // Or pass DOM element directly
     * const element = document.getElementById('item-3');
     * grid.makeWidget(element, {x: 0, y: 1, w: 4, h: 2});
     */ makeWidget(els, options) {
        const el = $7354c9fbc1d6b705$export$19e521a31019cf9d.getElement(els);
        if (!el || el.gridstackNode) return el;
        if (!el.parentElement) this.el.appendChild(el);
        this._prepareElement(el, true, options);
        const node = el.gridstackNode;
        this._updateContainerHeight();
        // see if there is a sub-grid to create
        if (node.subGridOpts) this.makeSubGrid(el, node.subGridOpts, undefined, false); // node.subGrid will be used as option in method, no need to pass
        // if we're adding an item into 1 column make sure
        // we don't override the larger 12 column layout that was already saved. #1985
        let resetIgnoreLayoutsNodeChange;
        if (this.opts.column === 1 && !this._ignoreLayoutsNodeChange) resetIgnoreLayoutsNodeChange = this._ignoreLayoutsNodeChange = true;
        this._triggerAddEvent();
        this._triggerChangeEvent();
        if (resetIgnoreLayoutsNodeChange) delete this._ignoreLayoutsNodeChange;
        return el;
    }
    on(name, callback) {
        // check for array of names being passed instead
        if (name.indexOf(' ') !== -1) {
            const names = name.split(' ');
            names.forEach((name)=>this.on(name, callback));
            return this;
        }
        // native CustomEvent handlers - cash the generic handlers so we can easily remove
        if (name === 'change' || name === 'added' || name === 'removed' || name === 'enable' || name === 'disable') {
            const noData = name === 'enable' || name === 'disable';
            if (noData) this._gsEventHandler[name] = (event)=>callback(event);
            else this._gsEventHandler[name] = (event)=>{
                if (event.detail) callback(event, event.detail);
            };
            this.el.addEventListener(name, this._gsEventHandler[name]);
        } else if (name === 'drag' || name === 'dragstart' || name === 'dragstop' || name === 'resizestart' || name === 'resize' || name === 'resizestop' || name === 'dropped' || name === 'resizecontent') // drag&drop stop events NEED to be call them AFTER we update node attributes so handle them ourself.
        // do same for start event to make it easier...
        this._gsEventHandler[name] = callback;
        else console.error('GridStack.on(' + name + ') event not supported');
        return this;
    }
    /**
     * unsubscribe from the 'on' event GridStackEvent
     * @param name of the event (see possible values) or list of names space separated
     */ off(name) {
        // check for array of names being passed instead
        if (name.indexOf(' ') !== -1) {
            const names = name.split(' ');
            names.forEach((name)=>this.off(name));
            return this;
        }
        if (name === 'change' || name === 'added' || name === 'removed' || name === 'enable' || name === 'disable') // remove native CustomEvent handlers
        {
            if (this._gsEventHandler[name]) this.el.removeEventListener(name, this._gsEventHandler[name]);
        }
        delete this._gsEventHandler[name];
        return this;
    }
    /**
     * Remove all event handlers from the grid. This is useful for cleanup when destroying a grid.
     *
     * @returns the grid instance for chaining
     *
     * @example
     * grid.offAll(); // Remove all event listeners
     */ offAll() {
        Object.keys(this._gsEventHandler).forEach((key)=>this.off(key));
        return this;
    }
    /**
     * Removes widget from the grid.
     * @param el  widget or selector to modify
     * @param removeDOM if `false` DOM element won't be removed from the tree (Default? true).
     * @param triggerEvent if `false` (quiet mode) element will not be added to removed list and no 'removed' callbacks will be called (Default? true).
     */ removeWidget(els, removeDOM = true, triggerEvent = true) {
        if (!els) {
            console.error('Error: GridStack.removeWidget(undefined) called');
            return this;
        }
        $7354c9fbc1d6b705$export$19e521a31019cf9d.getElements(els).forEach((el)=>{
            if (el.parentElement && el.parentElement !== this.el) return; // not our child!
            let node = el.gridstackNode;
            // For Meteor support: https://github.com/gridstack/gridstack.js/pull/272
            if (!node) node = this.engine.nodes.find((n)=>el === n.el);
            if (!node) return;
            if (removeDOM && $7354c9fbc1d6b705$export$19e521a31019cf9d.addRemoveCB) $7354c9fbc1d6b705$export$19e521a31019cf9d.addRemoveCB(this.el, node, false, false);
            // remove our DOM data (circular link) and drag&drop permanently
            delete el.gridstackNode;
            this._removeDD(el);
            this.engine.removeNode(node, removeDOM, triggerEvent);
            if (removeDOM && el.parentElement) el.remove(); // in batch mode engine.removeNode doesn't call back to remove DOM
        });
        if (triggerEvent) {
            this._triggerRemoveEvent();
            this._triggerChangeEvent();
        }
        return this;
    }
    /**
     * Removes all widgets from the grid.
     * @param removeDOM if `false` DOM elements won't be removed from the tree (Default? `true`).
     * @param triggerEvent if `false` (quiet mode) element will not be added to removed list and no 'removed' callbacks will be called (Default? true).
     */ removeAll(removeDOM = true, triggerEvent = true) {
        // always remove our DOM data (circular link) before list gets emptied and drag&drop permanently
        this.engine.nodes.forEach((n)=>{
            if (removeDOM && $7354c9fbc1d6b705$export$19e521a31019cf9d.addRemoveCB) $7354c9fbc1d6b705$export$19e521a31019cf9d.addRemoveCB(this.el, n, false, false);
            delete n.el.gridstackNode;
            if (!this.opts.staticGrid) this._removeDD(n.el);
        });
        this.engine.removeAll(removeDOM, triggerEvent);
        if (triggerEvent) this._triggerRemoveEvent();
        return this;
    }
    /**
     * Toggle the grid animation state.  Toggles the `grid-stack-animate` class.
     * @param doAnimate if true the grid will animate.
     * @param delay if true setting will be set on next event loop.
     */ setAnimation(doAnimate = this.opts.animate, delay) {
        if (delay) // delay, but check to make sure grid (opt) is still around
        setTimeout(()=>{
            if (this.opts) this.setAnimation(doAnimate);
        });
        else if (doAnimate) this.el.classList.add('grid-stack-animate');
        else this.el.classList.remove('grid-stack-animate');
        this.opts.animate = doAnimate;
        return this;
    }
    /** @internal */ hasAnimationCSS() {
        return this.el.classList.contains('grid-stack-animate');
    }
    /**
     * Toggle the grid static state, which permanently removes/add Drag&Drop support, unlike disable()/enable() that just turns it off/on.
     * Also toggle the grid-stack-static class.
     * @param val if true the grid become static.
     * @param updateClass true (default) if css class gets updated
     * @param recurse true (default) if sub-grids also get updated
     */ setStatic(val, updateClass = true, recurse = true) {
        if (!!this.opts.staticGrid === val) return this;
        val ? this.opts.staticGrid = true : delete this.opts.staticGrid;
        this._setupRemoveDrop();
        this._setupAcceptWidget();
        this.engine.nodes.forEach((n)=>{
            this.prepareDragDrop(n.el); // either delete or init Drag&drop
            if (n.subGrid && recurse) n.subGrid.setStatic(val, updateClass, recurse);
        });
        if (updateClass) this._setStaticClass();
        return this;
    }
    /**
     * Updates the passed in options on the grid (similar to update(widget) for for the grid options).
     * @param options PARTIAL grid options to update - only items specified will be updated.
     * NOTE: not all options updating are currently supported (lot of code, unlikely to change)
     */ updateOptions(o) {
        const opts = this.opts;
        if (o === opts) return this; // nothing to do
        if (o.acceptWidgets !== undefined) {
            opts.acceptWidgets = o.acceptWidgets;
            this._setupAcceptWidget();
        }
        if (o.animate !== undefined) this.setAnimation(o.animate);
        if (o.cellHeight) this.cellHeight(o.cellHeight);
        if (o.class !== undefined && o.class !== opts.class) {
            if (opts.class) this.el.classList.remove(opts.class);
            if (o.class) this.el.classList.add(o.class);
        }
        // responsive column take over actual count (keep what we have now)
        if (o.columnOpts) {
            this.opts.columnOpts = o.columnOpts;
            this.checkDynamicColumn();
        } else if (o.columnOpts === null && this.opts.columnOpts) {
            delete this.opts.columnOpts;
            this._updateResizeEvent();
        } else if (typeof o.column === 'number') this.column(o.column);
        if (o.margin !== undefined) this.margin(o.margin);
        if (o.staticGrid !== undefined) this.setStatic(o.staticGrid);
        if (o.disableDrag !== undefined && !o.staticGrid) this.enableMove(!o.disableDrag);
        if (o.disableResize !== undefined && !o.staticGrid) this.enableResize(!o.disableResize);
        if (o.float !== undefined) this.float(o.float);
        if (o.row !== undefined) {
            opts.minRow = opts.maxRow = opts.row = o.row;
            this._updateContainerHeight();
        } else {
            if (o.minRow !== undefined) {
                opts.minRow = o.minRow;
                this._updateContainerHeight();
            }
            if (o.maxRow !== undefined) opts.maxRow = o.maxRow;
        }
        if (o.lazyLoad !== undefined) opts.lazyLoad = o.lazyLoad;
        if (o.children?.length) this.load(o.children);
        // TBD if we have a real need for these (more complex code)
        // alwaysShowResizeHandle, draggable, handle, handleClass, itemClass, layout, placeholderClass, placeholderText, resizable, removable, row,...
        return this;
    }
    /**
     * Updates widget position/size and other info. This is used to change widget properties after creation.
     * Can update position, size, content, and other widget properties.
     *
     * Note: If you need to call this on all nodes, use load() instead which will update what changed.
     * Setting the same x,y for multiple items will be indeterministic and likely unwanted.
     *
     * @param els widget element(s) or selector to modify
     * @param opt new widget options (x,y,w,h, etc.). Only those set will be updated.
     * @returns the grid instance for chaining
     *
     * @example
     * // Update widget size and position
     * grid.update('.my-widget', { x: 2, y: 1, w: 3, h: 2 });
     *
     * // Update widget content
     * grid.update(widget, { content: '<p>New content</p>' });
     *
     * // Update multiple properties
     * grid.update('#my-widget', {
     *   w: 4,
     *   h: 3,
     *   noResize: true,
     *   locked: true
     * });
     */ update(els, opt) {
        $7354c9fbc1d6b705$export$19e521a31019cf9d.getElements(els).forEach((el)=>{
            const n = el?.gridstackNode;
            if (!n) return;
            const w = {
                ...(0, $2wHnB.Utils).copyPos({}, n),
                ...(0, $2wHnB.Utils).cloneDeep(opt)
            }; // make a copy we can modify in case they re-use it or multiple items
            this.engine.nodeBoundFix(w);
            delete w.autoPosition;
            // move/resize widget if anything changed
            const keys = [
                'x',
                'y',
                'w',
                'h'
            ];
            let m;
            if (keys.some((k)=>w[k] !== undefined && w[k] !== n[k])) {
                m = {};
                keys.forEach((k)=>{
                    m[k] = w[k] !== undefined ? w[k] : n[k];
                    delete w[k];
                });
            }
            // for a move as well IFF there is any min/max fields set
            if (!m && (w.minW || w.minH || w.maxW || w.maxH)) m = {}; // will use node position but validate values
            // check for content changing
            if (w.content !== undefined) {
                const itemContent = el.querySelector('.grid-stack-item-content');
                if (itemContent && itemContent.textContent !== w.content) {
                    n.content = w.content;
                    $7354c9fbc1d6b705$export$19e521a31019cf9d.renderCB(itemContent, w);
                    // restore any sub-grid back
                    if (n.subGrid?.el) {
                        itemContent.appendChild(n.subGrid.el);
                        n.subGrid._updateContainerHeight();
                    }
                }
                delete w.content;
            }
            // any remaining fields are assigned, but check for dragging changes, resize constrain
            let changed = false;
            let ddChanged = false;
            for(const key in w)if (key[0] !== '_' && n[key] !== w[key]) {
                n[key] = w[key];
                changed = true;
                ddChanged = ddChanged || !this.opts.staticGrid && (key === 'noResize' || key === 'noMove' || key === 'locked');
            }
            (0, $2wHnB.Utils).sanitizeMinMax(n);
            // finally move the widget and update attr
            if (m) {
                const widthChanged = m.w !== undefined && m.w !== n.w;
                this.moveNode(n, m);
                if (widthChanged && n.subGrid) // if we're animating the client size hasn't changed yet, so force a change (not exact size)
                n.subGrid.onResize(this.hasAnimationCSS() ? n.w : undefined);
                else this.resizeToContentCheck(widthChanged, n);
                delete n._orig; // clear out original position now that we moved #2669
            }
            if (m || changed) this._writeAttr(el, n);
            if (ddChanged) this.prepareDragDrop(n.el);
            if ($7354c9fbc1d6b705$export$19e521a31019cf9d.updateCB) $7354c9fbc1d6b705$export$19e521a31019cf9d.updateCB(n); // call user callback so they know widget got updated
        });
        return this;
    }
    moveNode(n, m) {
        const wasUpdating = n._updating;
        if (!wasUpdating) this.engine.cleanNodes().beginUpdate(n);
        this.engine.moveNode(n, m);
        this._updateContainerHeight();
        if (!wasUpdating) {
            this._triggerChangeEvent();
            this.engine.endUpdate();
        }
    }
    /**
     * Updates widget height to match the content height to avoid vertical scrollbars or dead space.
     * This automatically adjusts the widget height based on its content size.
     *
     * Note: This assumes only 1 child under resizeToContentParent='.grid-stack-item-content'
     * (sized to gridItem minus padding) that represents the entire content size.
     *
     * @param el the grid item element to resize
     *
     * @example
     * // Resize a widget to fit its content
     * const widget = document.querySelector('.grid-stack-item');
     * grid.resizeToContent(widget);
     *
     * // This is commonly used with dynamic content:
     * widget.querySelector('.content').innerHTML = 'New longer content...';
     * grid.resizeToContent(widget);
     */ resizeToContent(el) {
        if (!el) return;
        el.classList.remove('size-to-content-max');
        if (!el.clientHeight) return; // 0 when hidden, skip
        const n = el.gridstackNode;
        if (!n) return;
        const grid = n.grid;
        if (!grid || el.parentElement !== grid.el) return; // skip if we are not inside a grid
        const cell = grid.getCellHeight(true);
        if (!cell) return;
        let height = n.h ? n.h * cell : el.clientHeight; // getBoundingClientRect().height seem to flicker back and forth
        let item;
        if (n.resizeToContentParent) item = el.querySelector(n.resizeToContentParent);
        if (!item) item = el.querySelector($7354c9fbc1d6b705$export$19e521a31019cf9d.resizeToContentParent);
        if (!item) return;
        const padding = el.clientHeight - item.clientHeight; // full - available height to our child (minus border, padding...)
        const itemH = n.h ? n.h * cell - padding : item.clientHeight; // calculated to what cellHeight is or will become (rather than actual to prevent waiting for animation to finish)
        let wantedH;
        if (n.subGrid) {
            // sub-grid - use their actual row count * their cell height, BUT append any content outside of the grid (eg: above text)
            wantedH = n.subGrid.getRow() * n.subGrid.getCellHeight(true);
            const subRec = n.subGrid.el.getBoundingClientRect();
            const parentRec = el.getBoundingClientRect();
            wantedH += subRec.top - parentRec.top;
        } else if (n.subGridOpts?.children?.length) // not sub-grid just yet (case above) wait until we do
        return;
        else {
            // NOTE: clientHeight & getBoundingClientRect() is undefined for text and other leaf nodes. use <div> container!
            const child = item.firstElementChild;
            if (!child) {
                console.error(`Error: GridStack.resizeToContent() widget id:${n.id} '${$7354c9fbc1d6b705$export$19e521a31019cf9d.resizeToContentParent}'.firstElementChild is null, make sure to have a div like container. Skipping sizing.`);
                return;
            }
            wantedH = child.getBoundingClientRect().height || itemH;
        }
        if (itemH === wantedH) return;
        height += wantedH - itemH;
        let h = Math.ceil(height / cell);
        // check for min/max and special sizing
        const softMax = Number.isInteger(n.sizeToContent) ? n.sizeToContent : 0;
        if (softMax && h > softMax) {
            h = softMax;
            el.classList.add('size-to-content-max'); // get v-scroll back
        }
        if (n.minH && h < n.minH) h = n.minH;
        else if (n.maxH && h > n.maxH) h = n.maxH;
        if (h !== n.h) {
            grid._ignoreLayoutsNodeChange = true;
            grid.moveNode(n, {
                h: h
            });
            delete grid._ignoreLayoutsNodeChange;
        }
    }
    /** call the user resize (so they can do extra work) else our build in version */ resizeToContentCBCheck(el) {
        if ($7354c9fbc1d6b705$export$19e521a31019cf9d.resizeToContentCB) $7354c9fbc1d6b705$export$19e521a31019cf9d.resizeToContentCB(el);
        else this.resizeToContent(el);
    }
    /**
     * Rotate widgets by swapping their width and height. This is typically called when the user presses 'r' during dragging.
     * The rotation swaps the w/h dimensions and adjusts min/max constraints accordingly.
     *
     * @param els widget element(s) or selector to rotate
     * @param relative optional pixel coordinate relative to upper/left corner to rotate around (keeps that cell under cursor)
     * @returns the grid instance for chaining
     *
     * @example
     * // Rotate a specific widget
     * grid.rotate('.my-widget');
     *
     * // Rotate with relative positioning during drag
     * grid.rotate(widget, { left: 50, top: 30 });
     */ rotate(els, relative) {
        $7354c9fbc1d6b705$export$19e521a31019cf9d.getElements(els).forEach((el)=>{
            const n = el.gridstackNode;
            if (!(0, $2wHnB.Utils).canBeRotated(n)) return;
            const rot = {
                w: n.h,
                h: n.w,
                minH: n.minW,
                minW: n.minH,
                maxH: n.maxW,
                maxW: n.maxH
            };
            // if given an offset, adjust x/y by column/row bounds when user presses 'r' during dragging
            if (relative) {
                const pivotX = relative.left > 0 ? Math.floor(relative.left / this.cellWidth()) : 0;
                const pivotY = relative.top > 0 ? Math.floor(relative.top / this.opts.cellHeight) : 0;
                rot.x = n.x + pivotX - (n.h - (pivotY + 1));
                rot.y = n.y + pivotY - pivotX;
            }
            Object.keys(rot).forEach((k)=>{
                if (rot[k] === undefined) delete rot[k];
            });
            const _orig = n._orig;
            this.update(el, rot);
            n._orig = _orig; // restore as move() will delete it
        });
        return this;
    }
    /**
     * Updates the margins which will set all 4 sides at once - see `GridStackOptions.margin` for format options.
     * Supports CSS string format of 1, 2, or 4 values or a single number.
     *
     * @param value margin value - can be:
     *   - Single number: `10` (applies to all sides)
     *   - Two values: `'10px 20px'` (top/bottom, left/right)
     *   - Four values: `'10px 20px 5px 15px'` (top, right, bottom, left)
     * @returns the grid instance for chaining
     *
     * @example
     * grid.margin(10);           // 10px all sides
     * grid.margin('10px 20px');  // 10px top/bottom, 20px left/right
     * grid.margin('5px 10px 15px 20px'); // Different for each side
     */ margin(value) {
        const isMultiValue = typeof value === 'string' && value.split(' ').length > 1;
        // check if we can skip... won't check if multi values (too much hassle)
        if (!isMultiValue) {
            const data = (0, $2wHnB.Utils).parseHeight(value);
            if (this.opts.marginUnit === data.unit && this.opts.margin === data.h) return;
        }
        // re-use existing margin handling
        this.opts.margin = value;
        this.opts.marginTop = this.opts.marginBottom = this.opts.marginLeft = this.opts.marginRight = undefined;
        this._initMargin();
        return this;
    }
    /**
     * Returns the current margin value as a number (undefined if the 4 sides don't match).
     * This only returns a number if all sides have the same margin value.
     *
     * @returns the margin value in pixels, or undefined if sides have different values
     *
     * @example
     * const margin = grid.getMargin();
     * if (margin !== undefined) {
     *   console.log('Uniform margin:', margin, 'px');
     * } else {
     *   console.log('Margins are different on different sides');
     * }
     */ getMargin() {
        return this.opts.margin;
    }
    /**
     * Returns true if the height of the grid will be less than the vertical
     * constraint. Always returns true if grid doesn't have height constraint.
     * @param node contains x,y,w,h,auto-position options
     *
     * @example
     * if (grid.willItFit(newWidget)) {
     *   grid.addWidget(newWidget);
     * } else {
     *   alert('Not enough free space to place the widget');
     * }
     */ willItFit(node) {
        return this.engine.willItFit(node);
    }
    /** @internal */ _triggerChangeEvent() {
        if (this.engine.batchMode) return this;
        const elements = this.engine.getDirtyNodes(true); // verify they really changed
        if (elements && elements.length) {
            if (!this._ignoreLayoutsNodeChange) this.engine.layoutsNodesChange(elements);
            this._triggerEvent('change', elements);
        }
        this.engine.saveInitial(); // we called, now reset initial values & dirty flags
        return this;
    }
    /** @internal */ _triggerAddEvent() {
        if (this.engine.batchMode) return this;
        if (this.engine.addedNodes?.length) {
            if (!this._ignoreLayoutsNodeChange) this.engine.layoutsNodesChange(this.engine.addedNodes);
            // prevent added nodes from also triggering 'change' event (which is called next)
            this.engine.addedNodes.forEach((n)=>{
                delete n._dirty;
            });
            const addedNodes = [
                ...this.engine.addedNodes
            ];
            this.engine.addedNodes = [];
            this._triggerEvent('added', addedNodes);
        }
        return this;
    }
    /** @internal */ _triggerRemoveEvent() {
        if (this.engine.batchMode) return this;
        if (this.engine.removedNodes?.length) {
            const removedNodes = [
                ...this.engine.removedNodes
            ];
            this.engine.removedNodes = [];
            this._triggerEvent('removed', removedNodes);
        }
        return this;
    }
    /** @internal */ _triggerEvent(type, data) {
        const event = data ? new CustomEvent(type, {
            bubbles: false,
            detail: data
        }) : new Event(type);
        // check if we're nested, and if so call the outermost grid to trigger the event
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        let grid = this;
        while(grid.parentGridNode)grid = grid.parentGridNode.grid;
        grid.el.dispatchEvent(event);
        return this;
    }
    /** @internal */ _updateContainerHeight() {
        if (!this.engine || this.engine.batchMode) return this;
        const parent = this.parentGridNode;
        let row = this.getRow() + this._extraDragRow; // this checks for minRow already
        const cellHeight = this.opts.cellHeight;
        const unit = this.opts.cellHeightUnit;
        if (!cellHeight) return this;
        // check for css min height (non nested grid). TODO: support mismatch, say: min % while unit is px.
        // If `minRow` was applied, don't override it with this check, and avoid performance issues
        // (reflows) using `getComputedStyle`
        if (!parent && !this.opts.minRow) {
            const cssMinHeight = (0, $2wHnB.Utils).parseHeight(getComputedStyle(this.el)['minHeight']);
            if (cssMinHeight.h > 0 && cssMinHeight.unit === unit) {
                const minRow = Math.floor(cssMinHeight.h / cellHeight);
                if (row < minRow) row = minRow;
            }
        }
        this.el.setAttribute('gs-current-row', String(row));
        this.el.style.removeProperty('min-height');
        this.el.style.removeProperty('height');
        if (row) // nested grids have 'insert:0' to fill the space of parent by default, but we may be taller so use min-height for possible scrollbars
        this.el.style[parent ? 'minHeight' : 'height'] = row * cellHeight + unit;
        // if we're a nested grid inside an sizeToContent item, tell it to resize itself too
        if (parent && (0, $2wHnB.Utils).shouldSizeToContent(parent)) parent.grid.resizeToContentCBCheck(parent.el);
        return this;
    }
    /** @internal */ _prepareElement(el, triggerAddEvent = false, node) {
        node = node || this._readAttr(el);
        el.gridstackNode = node;
        node.el = el;
        node.grid = this;
        node = this.engine.addNode(node, triggerAddEvent);
        // write the dom sizes and class
        this._writeAttr(el, node);
        el.classList.add((0, $9oh67.gridDefaults).itemClass, this.opts.itemClass);
        const sizeToContent = (0, $2wHnB.Utils).shouldSizeToContent(node);
        sizeToContent ? el.classList.add('size-to-content') : el.classList.remove('size-to-content');
        if (sizeToContent) this.resizeToContentCheck(false, node);
        if (!(0, $2wHnB.Utils).lazyLoad(node)) this.prepareDragDrop(node.el);
        return this;
    }
    /** @internal write position CSS vars and x,y,w,h attributes (not used for CSS but by users) back to element */ _writePosAttr(el, n) {
        // Avoid overwriting the inline style of the element during drag/resize, but always update the placeholder
        if (!n._moving && !n._resizing || this._placeholder === el) {
            // width/height:1 x/y:0 is set by default in the main CSS, so no need to set inlined vars
            el.style.top = n.y ? n.y === 1 ? `var(--gs-cell-height)` : `calc(${n.y} * var(--gs-cell-height))` : null;
            el.style.left = n.x ? n.x === 1 ? `var(--gs-column-width)` : `calc(${n.x} * var(--gs-column-width))` : null;
            el.style.width = n.w > 1 ? `calc(${n.w} * var(--gs-column-width))` : null;
            el.style.height = n.h > 1 ? `calc(${n.h} * var(--gs-cell-height))` : null;
        }
        // NOTE: those are technically not needed anymore (v12+) as we have CSS vars for everything, but some users depends on them to render item size using CSS
        // ALways write x,y otherwise it could be autoPositioned incorrectly #3181
        el.setAttribute('gs-x', String(n.x));
        el.setAttribute('gs-y', String(n.y));
        n.w > 1 ? el.setAttribute('gs-w', String(n.w)) : el.removeAttribute('gs-w');
        n.h > 1 ? el.setAttribute('gs-h', String(n.h)) : el.removeAttribute('gs-h');
        return this;
    }
    /** @internal call to write any default attributes back to element */ _writeAttr(el, node) {
        if (!node) return this;
        this._writePosAttr(el, node);
        const attrs /*: GridStackWidget but strings */  = {
            // autoPosition: 'gs-auto-position', // no need to write out as already in node and doesn't affect CSS
            noResize: 'gs-no-resize',
            noMove: 'gs-no-move',
            locked: 'gs-locked',
            id: 'gs-id',
            sizeToContent: 'gs-size-to-content'
        };
        for(const key in attrs)if (node[key]) el.setAttribute(attrs[key], String(node[key]));
        else el.removeAttribute(attrs[key]);
        return this;
    }
    /** @internal call to read any default attributes from element */ _readAttr(el, clearDefaultAttr = true) {
        const n = {};
        n.x = (0, $2wHnB.Utils).toNumber(el.getAttribute('gs-x'));
        n.y = (0, $2wHnB.Utils).toNumber(el.getAttribute('gs-y'));
        n.w = (0, $2wHnB.Utils).toNumber(el.getAttribute('gs-w'));
        n.h = (0, $2wHnB.Utils).toNumber(el.getAttribute('gs-h'));
        n.autoPosition = (0, $2wHnB.Utils).toBool(el.getAttribute('gs-auto-position'));
        n.noResize = (0, $2wHnB.Utils).toBool(el.getAttribute('gs-no-resize'));
        n.noMove = (0, $2wHnB.Utils).toBool(el.getAttribute('gs-no-move'));
        n.locked = (0, $2wHnB.Utils).toBool(el.getAttribute('gs-locked'));
        const attr = el.getAttribute('gs-size-to-content');
        if (attr) {
            if (attr === 'true' || attr === 'false') n.sizeToContent = (0, $2wHnB.Utils).toBool(attr);
            else n.sizeToContent = parseInt(attr, 10);
        }
        n.id = el.getAttribute('gs-id');
        // read but never written out
        n.maxW = (0, $2wHnB.Utils).toNumber(el.getAttribute('gs-max-w'));
        n.minW = (0, $2wHnB.Utils).toNumber(el.getAttribute('gs-min-w'));
        n.maxH = (0, $2wHnB.Utils).toNumber(el.getAttribute('gs-max-h'));
        n.minH = (0, $2wHnB.Utils).toNumber(el.getAttribute('gs-min-h'));
        // v8.x optimization to reduce un-needed attr that don't render or are default CSS
        if (clearDefaultAttr) {
            if (n.w === 1) el.removeAttribute('gs-w');
            if (n.h === 1) el.removeAttribute('gs-h');
            if (n.maxW) el.removeAttribute('gs-max-w');
            if (n.minW) el.removeAttribute('gs-min-w');
            if (n.maxH) el.removeAttribute('gs-max-h');
            if (n.minH) el.removeAttribute('gs-min-h');
        }
        // remove any key not found (null or false which is default, unless sizeToContent=false override)
        for(const key in n){
            if (!n.hasOwnProperty(key)) return;
            if (!n[key] && n[key] !== 0 && key !== 'sizeToContent') delete n[key];
        }
        return n;
    }
    /** @internal */ _setStaticClass() {
        const classes = [
            'grid-stack-static'
        ];
        if (this.opts.staticGrid) {
            this.el.classList.add(...classes);
            this.el.setAttribute('gs-static', 'true');
        } else {
            this.el.classList.remove(...classes);
            this.el.removeAttribute('gs-static');
        }
        return this;
    }
    /**
     * called when we are being resized - check if the one Column Mode needs to be turned on/off
     * and remember the prev columns we used, or get our count from parent, as well as check for cellHeight==='auto' (square)
     * or `sizeToContent` gridItem options.
     */ onResize(clientWidth = this.el?.clientWidth) {
        if (!clientWidth) return; // return if we're gone or no size yet (will get called again)
        if (this.prevWidth === clientWidth) return; // no-op
        this.prevWidth = clientWidth;
        // console.log('onResize ', clientWidth);
        this.batchUpdate();
        // see if we're nested and take our column count from our parent....
        let columnChanged = false;
        if (this._autoColumn && this.parentGridNode) {
            if (this.opts.column !== this.parentGridNode.w) {
                this.column(this.parentGridNode.w, this.opts.layout || 'list');
                columnChanged = true;
            }
        } else // else check for dynamic column
        columnChanged = this.checkDynamicColumn();
        // make the cells content square again
        if (this._isAutoCellHeight) this.cellHeight();
        // update any nested grids, or items size
        this.engine.nodes.forEach((n)=>{
            if (n.subGrid) n.subGrid.onResize();
        });
        if (!this._skipInitialResize) this.resizeToContentCheck(columnChanged); // wait for anim of column changed (DOM reflow before we can size correctly)
        delete this._skipInitialResize;
        this.batchUpdate(false);
        return this;
    }
    /** resizes content for given node (or all) if shouldSizeToContent() is true */ resizeToContentCheck(delay = false, n) {
        if (!this.engine) return; // we've been deleted in between!
        // update any gridItem height with sizeToContent, but wait for DOM $animation_speed to settle if we changed column count
        // TODO: is there a way to know what the final (post animation) size of the content will be so we can animate the column width and height together rather than sequentially ?
        if (delay && this.hasAnimationCSS()) return setTimeout(()=>this.resizeToContentCheck(false, n), this.animationDelay);
        if (n) {
            if ((0, $2wHnB.Utils).shouldSizeToContent(n)) this.resizeToContentCBCheck(n.el);
        } else if (this.engine.nodes.some((n)=>(0, $2wHnB.Utils).shouldSizeToContent(n))) {
            const nodes = [
                ...this.engine.nodes
            ]; // in case order changes while resizing one
            this.batchUpdate();
            nodes.forEach((n)=>{
                if ((0, $2wHnB.Utils).shouldSizeToContent(n)) this.resizeToContentCBCheck(n.el);
            });
            this._ignoreLayoutsNodeChange = true; // loop through each node will set/reset around each move, so set it here again
            this.batchUpdate(false);
            this._ignoreLayoutsNodeChange = false;
        }
        // call this regardless of shouldSizeToContent because widget might need to stretch to take available space after a resize
        if (this._gsEventHandler['resizecontent']) this._gsEventHandler['resizecontent'](null, n ? [
            n
        ] : this.engine.nodes);
    }
    /** add or remove the grid element size event handler */ _updateResizeEvent(forceRemove = false) {
        // only add event if we're not nested (parent will call us) and we're auto sizing cells or supporting dynamic column (i.e. doing work)
        // or supporting new sizeToContent option.
        const trackSize = !this.parentGridNode && (this._isAutoCellHeight || this.opts.sizeToContent || this.opts.columnOpts || this.engine.nodes.find((n)=>n.sizeToContent));
        if (!forceRemove && trackSize && !this.resizeObserver) {
            this._sizeThrottle = (0, $2wHnB.Utils).throttle(()=>this.onResize(), this.opts.cellHeightThrottle);
            this.resizeObserver = new ResizeObserver(()=>this._sizeThrottle());
            this.resizeObserver.observe(this.el);
            this._skipInitialResize = true; // makeWidget will originally have called on startup
        } else if ((forceRemove || !trackSize) && this.resizeObserver) {
            this.resizeObserver.disconnect();
            delete this.resizeObserver;
            delete this._sizeThrottle;
        }
        return this;
    }
    /** @internal convert a potential selector into actual element */ static getElement(els = '.grid-stack-item') {
        return (0, $2wHnB.Utils).getElement(els);
    }
    /** @internal */ static getElements(els = '.grid-stack-item') {
        return (0, $2wHnB.Utils).getElements(els);
    }
    /** @internal */ static getGridElement(els) {
        return $7354c9fbc1d6b705$export$19e521a31019cf9d.getElement(els);
    }
    /** @internal */ static getGridElements(els) {
        return (0, $2wHnB.Utils).getElements(els);
    }
    /** @internal initialize margin top/bottom/left/right and units */ _initMargin() {
        let data;
        let margin = 0;
        // support passing multiple values like CSS (ex: '5px 10px 0 20px')
        let margins = [];
        if (typeof this.opts.margin === 'string') margins = this.opts.margin.split(' ');
        if (margins.length === 2) {
            this.opts.marginTop = this.opts.marginBottom = margins[0];
            this.opts.marginLeft = this.opts.marginRight = margins[1];
        } else if (margins.length === 4) {
            this.opts.marginTop = margins[0];
            this.opts.marginRight = margins[1];
            this.opts.marginBottom = margins[2];
            this.opts.marginLeft = margins[3];
        } else {
            data = (0, $2wHnB.Utils).parseHeight(this.opts.margin);
            this.opts.marginUnit = data.unit;
            margin = this.opts.margin = data.h;
        }
        // see if top/bottom/left/right need to be set as well
        const keys = [
            'marginTop',
            'marginRight',
            'marginBottom',
            'marginLeft'
        ];
        keys.forEach((k)=>{
            if (this.opts[k] === undefined) this.opts[k] = margin;
            else {
                data = (0, $2wHnB.Utils).parseHeight(this.opts[k]);
                this.opts[k] = data.h;
                delete this.opts.margin;
            }
        });
        this.opts.marginUnit = data.unit; // in case side were spelled out, use those units instead...
        if (this.opts.marginTop === this.opts.marginBottom && this.opts.marginLeft === this.opts.marginRight && this.opts.marginTop === this.opts.marginRight) this.opts.margin = this.opts.marginTop; // makes it easier to check for no-ops in setMargin()
        // finally Update the CSS margin variables (inside the cell height) */
        const style = this.el.style;
        style.setProperty('--gs-item-margin-top', `${this.opts.marginTop}${this.opts.marginUnit}`);
        style.setProperty('--gs-item-margin-bottom', `${this.opts.marginBottom}${this.opts.marginUnit}`);
        style.setProperty('--gs-item-margin-right', `${this.opts.marginRight}${this.opts.marginUnit}`);
        style.setProperty('--gs-item-margin-left', `${this.opts.marginLeft}${this.opts.marginUnit}`);
        return this;
    }
    /* ===========================================================================================
     * drag&drop methods that used to be stubbed out and implemented in dd-gridstack.ts
     * but caused loading issues in prod - see https://github.com/gridstack/gridstack.js/issues/2039
     * ===========================================================================================
     */ /**
     * Get the global drag & drop implementation instance.
     * This provides access to the underlying drag & drop functionality.
     *
     * @returns the DDGridStack instance used for drag & drop operations
     *
     * @example
     * const dd = GridStack.getDD();
     * // Access drag & drop functionality
     */ static getDD() {
        return $7354c9fbc1d6b705$var$dd;
    }
    /**
     * call to setup dragging in from the outside (say toolbar), by specifying the class selection and options.
     * Called during GridStack.init() as options, but can also be called directly (last param are used) in case the toolbar
     * is dynamically create and needs to be set later.
     * @param dragIn string selector (ex: '.sidebar-item') or list of dom elements
     * @param dragInOptions options - see DDDragOpt. (default: {handle: '.grid-stack-item-content', appendTo: 'body'}
     * @param widgets GridStackWidget def to assign to each element which defines what to create on drop
     * @param root optional root which defaults to document (for shadow dom pass the parent HTMLDocument)
     */ static setupDragIn(dragIn, dragInOptions, widgets, root = document) {
        if (dragInOptions?.pause !== undefined) (0, $8OXYl.DDManager).pauseDrag = dragInOptions.pause;
        dragInOptions = {
            appendTo: 'body',
            helper: 'clone',
            ...dragInOptions || {}
        }; // default to handle:undefined = drag by the whole item
        const els = typeof dragIn === 'string' ? (0, $2wHnB.Utils).getElements(dragIn, root) : dragIn;
        els.forEach((el, i)=>{
            if (!$7354c9fbc1d6b705$var$dd.isDraggable(el)) $7354c9fbc1d6b705$var$dd.dragIn(el, dragInOptions);
            if (widgets?.[i]) el.gridstackNode = widgets[i];
        });
    }
    /**
     * Enables/Disables dragging by the user for specific grid elements.
     * For all items and future items, use enableMove() instead. No-op for static grids.
     *
     * Note: If you want to prevent an item from moving due to being pushed around by another
     * during collision, use the 'locked' property instead.
     *
     * @param els widget element(s) or selector to modify
     * @param val if true widget will be draggable, assuming the parent grid isn't noMove or static
     * @returns the grid instance for chaining
     *
     * @example
     * // Make specific widgets draggable
     * grid.movable('.my-widget', true);
     *
     * // Disable dragging for specific widgets
     * grid.movable('#fixed-widget', false);
     */ movable(els, val) {
        if (this.opts.staticGrid) return this; // can't move a static grid!
        $7354c9fbc1d6b705$export$19e521a31019cf9d.getElements(els).forEach((el)=>{
            const n = el.gridstackNode;
            if (!n) return;
            val ? delete n.noMove : n.noMove = true;
            this.prepareDragDrop(n.el); // init DD if need be, and adjust
        });
        return this;
    }
    /**
     * Enables/Disables user resizing for specific grid elements.
     * For all items and future items, use enableResize() instead. No-op for static grids.
     *
     * @param els widget element(s) or selector to modify
     * @param val if true widget will be resizable, assuming the parent grid isn't noResize or static
     * @returns the grid instance for chaining
     *
     * @example
     * // Make specific widgets resizable
     * grid.resizable('.my-widget', true);
     *
     * // Disable resizing for specific widgets
     * grid.resizable('#fixed-size-widget', false);
     */ resizable(els, val) {
        if (this.opts.staticGrid) return this; // can't resize a static grid!
        $7354c9fbc1d6b705$export$19e521a31019cf9d.getElements(els).forEach((el)=>{
            const n = el.gridstackNode;
            if (!n) return;
            val ? delete n.noResize : n.noResize = true;
            this.prepareDragDrop(n.el); // init DD if need be, and adjust
        });
        return this;
    }
    /**
     * Temporarily disables widgets moving/resizing.
     * If you want a more permanent way (which freezes up resources) use `setStatic(true)` instead.
     *
     * Note: This is a no-op for static grids.
     *
     * This is a shortcut for:
     * ```typescript
     * grid.enableMove(false);
     * grid.enableResize(false);
     * ```
     *
     * @param recurse if true (default), sub-grids also get updated
     * @returns the grid instance for chaining
     *
     * @example
     * // Disable all interactions
     * grid.disable();
     *
     * // Disable only this grid, not sub-grids
     * grid.disable(false);
     */ disable(recurse = true) {
        if (this.opts.staticGrid) return;
        this.enableMove(false, recurse);
        this.enableResize(false, recurse);
        this._triggerEvent('disable');
        return this;
    }
    /**
     * Re-enables widgets moving/resizing - see disable().
     * Note: This is a no-op for static grids.
     *
     * This is a shortcut for:
     * ```typescript
     * grid.enableMove(true);
     * grid.enableResize(true);
     * ```
     *
     * @param recurse if true (default), sub-grids also get updated
     * @returns the grid instance for chaining
     *
     * @example
     * // Re-enable all interactions
     * grid.enable();
     *
     * // Enable only this grid, not sub-grids
     * grid.enable(false);
     */ enable(recurse = true) {
        if (this.opts.staticGrid) return;
        this.enableMove(true, recurse);
        this.enableResize(true, recurse);
        this._triggerEvent('enable');
        return this;
    }
    /**
     * Enables/disables widget moving for all widgets. No-op for static grids.
     * Note: locally defined items (with noMove property) still override this setting.
     *
     * @param doEnable if true widgets will be movable, if false moving is disabled
     * @param recurse if true (default), sub-grids also get updated
     * @returns the grid instance for chaining
     *
     * @example
     * // Enable moving for all widgets
     * grid.enableMove(true);
     *
     * // Disable moving for all widgets
     * grid.enableMove(false);
     *
     * // Enable only this grid, not sub-grids
     * grid.enableMove(true, false);
     */ enableMove(doEnable, recurse = true) {
        if (this.opts.staticGrid) return this; // can't move a static grid!
        doEnable ? delete this.opts.disableDrag : this.opts.disableDrag = true; // FIRST before we update children as grid overrides #1658
        this.engine.nodes.forEach((n)=>{
            this.prepareDragDrop(n.el);
            if (n.subGrid && recurse) n.subGrid.enableMove(doEnable, recurse);
        });
        return this;
    }
    /**
     * Enables/disables widget resizing for all widgets. No-op for static grids.
     * Note: locally defined items (with noResize property) still override this setting.
     *
     * @param doEnable if true widgets will be resizable, if false resizing is disabled
     * @param recurse if true (default), sub-grids also get updated
     * @returns the grid instance for chaining
     *
     * @example
     * // Enable resizing for all widgets
     * grid.enableResize(true);
     *
     * // Disable resizing for all widgets
     * grid.enableResize(false);
     *
     * // Enable only this grid, not sub-grids
     * grid.enableResize(true, false);
     */ enableResize(doEnable, recurse = true) {
        if (this.opts.staticGrid) return this; // can't size a static grid!
        doEnable ? delete this.opts.disableResize : this.opts.disableResize = true; // FIRST before we update children as grid overrides #1658
        this.engine.nodes.forEach((n)=>{
            this.prepareDragDrop(n.el);
            if (n.subGrid && recurse) n.subGrid.enableResize(doEnable, recurse);
        });
        return this;
    }
    /** @internal call when drag (and drop) needs to be cancelled (Esc key) */ cancelDrag() {
        const n = this._placeholder?.gridstackNode;
        if (!n) return;
        if (n._isExternal) {
            // remove any newly inserted nodes (from outside)
            n._isAboutToRemove = true;
            this.engine.removeNode(n);
        } else if (n._isAboutToRemove) // restore any temp removed (dragged over trash)
        $7354c9fbc1d6b705$export$19e521a31019cf9d._itemRemoving(n.el, false);
        this.engine.restoreInitial();
    }
    /** @internal removes any drag&drop present (called during destroy) */ _removeDD(el) {
        $7354c9fbc1d6b705$var$dd.draggable(el, 'destroy').resizable(el, 'destroy');
        if (el.gridstackNode) delete el.gridstackNode._initDD; // reset our DD init flag
        delete el.ddElement;
        return this;
    }
    /** @internal called to add drag over to support widgets being added externally */ _setupAcceptWidget() {
        // check if we need to disable things
        if (this.opts.staticGrid || !this.opts.acceptWidgets && !this.opts.removable) {
            $7354c9fbc1d6b705$var$dd.droppable(this.el, 'destroy');
            return this;
        }
        // vars shared across all methods
        let cellHeight, cellWidth;
        const onDrag = (event, el, helper)=>{
            helper = helper || el;
            const node = helper.gridstackNode;
            if (!node) return;
            // if the element is being dragged from outside, scale it down to match the grid's scale
            // and slightly adjust its position relative to the mouse
            if (!node.grid?.el) {
                // this scales the helper down
                helper.style.transform = `scale(${1 / this.dragTransform.xScale},${1 / this.dragTransform.yScale})`;
                // this makes it so that the helper is well positioned relative to the mouse after scaling
                const helperRect = helper.getBoundingClientRect();
                helper.style.left = helperRect.x + (this.dragTransform.xScale - 1) * (event.clientX - helperRect.x) / this.dragTransform.xScale + 'px';
                helper.style.top = helperRect.y + (this.dragTransform.yScale - 1) * (event.clientY - helperRect.y) / this.dragTransform.yScale + 'px';
                helper.style.transformOrigin = `0px 0px`;
            }
            let { top: top, left: left } = helper.getBoundingClientRect();
            const rect = this.el.getBoundingClientRect();
            left -= rect.left;
            top -= rect.top;
            const ui = {
                position: {
                    top: top * this.dragTransform.xScale,
                    left: left * this.dragTransform.yScale
                }
            };
            if (node._temporaryRemoved) {
                node.x = Math.max(0, Math.round(left / cellWidth));
                node.y = Math.max(0, Math.round(top / cellHeight));
                delete node.autoPosition;
                this.engine.nodeBoundFix(node);
                // don't accept *initial* location if doesn't fit #1419 (locked drop region, or can't grow), but maybe try if it will go somewhere
                if (!this.engine.willItFit(node)) {
                    node.autoPosition = true; // ignore x,y and try for any slot...
                    if (!this.engine.willItFit(node)) {
                        $7354c9fbc1d6b705$var$dd.off(el, 'drag'); // stop calling us
                        return; // full grid or can't grow
                    }
                    if (node._willFitPos) {
                        // use the auto position instead #1687
                        (0, $2wHnB.Utils).copyPos(node, node._willFitPos);
                        delete node._willFitPos;
                    }
                }
                // re-use the existing node dragging method
                this._onStartMoving(helper, event, ui, node, cellWidth, cellHeight);
            } else // re-use the existing node dragging that does so much of the collision detection
            this._dragOrResize(helper, event, ui, node, cellWidth, cellHeight);
        };
        $7354c9fbc1d6b705$var$dd.droppable(this.el, {
            accept: (el)=>{
                const node = el.gridstackNode || this._readAttr(el, false);
                // set accept drop to true on ourself (which we ignore) so we don't get "can't drop" icon in HTML5 mode while moving
                if (node?.grid === this) return true;
                if (!this.opts.acceptWidgets) return false;
                // check for accept method or class matching
                let canAccept = true;
                if (typeof this.opts.acceptWidgets === 'function') canAccept = this.opts.acceptWidgets(el);
                else {
                    const selector = this.opts.acceptWidgets === true ? '.grid-stack-item' : this.opts.acceptWidgets;
                    canAccept = el.matches(selector);
                }
                // finally check to make sure we actually have space left #1571 #2633
                if (canAccept && node && this.opts.maxRow) {
                    const n = {
                        w: node.w,
                        h: node.h,
                        minW: node.minW,
                        minH: node.minH
                    }; // only width/height matters and autoPosition
                    canAccept = this.engine.willItFit(n);
                }
                return canAccept;
            }
        })/**
             * entering our grid area
             */ .on(this.el, 'dropover', (event, el, helper)=>{
            // console.log(`over ${this.el.gridstack.opts.id} ${count++}`); // TEST
            let node = helper?.gridstackNode || el.gridstackNode;
            // ignore drop enter on ourself (unless we temporarily removed) which happens on a simple drag of our item
            if (node?.grid === this && !node._temporaryRemoved) // delete node._added; // reset this to track placeholder again in case we were over other grid #1484 (dropout doesn't always clear)
            return false; // prevent parent from receiving msg (which may be a grid as well)
            // If sidebar item, restore the sidebar node size to ensure consistent behavior when dragging between grids
            if (node?._sidebarOrig) {
                node.w = node._sidebarOrig.w;
                node.h = node._sidebarOrig.h;
            }
            // fix #1578 when dragging fast, we may not get a leave on the previous grid so force one now
            if (node?.grid && node.grid !== this && !node._temporaryRemoved) {
                // console.log('dropover without leave'); // TEST
                const otherGrid = node.grid;
                otherGrid._leave(el, helper);
            }
            helper = helper || el;
            // cache cell dimensions (which don't change), position can animate if we removed an item in otherGrid that affects us...
            cellWidth = this.cellWidth();
            cellHeight = this.getCellHeight(true);
            // sidebar items: load any element attributes if we don't have a node on first enter from the sidebar
            if (!node) {
                const attr = helper.getAttribute('data-gs-widget') || helper.getAttribute('gridstacknode'); // TBD: temp support for old V11.0.0 attribute
                if (attr) {
                    try {
                        node = JSON.parse(attr);
                    } catch (error) {
                        console.error("Gridstack dropover: Bad JSON format: ", attr);
                    }
                    helper.removeAttribute('data-gs-widget');
                    helper.removeAttribute('gridstacknode');
                }
                if (!node) node = this._readAttr(helper); // used to pass false for #2354, but now we clone top level node
                // On first grid enter from sidebar, set the initial sidebar item size properties for the node
                node._sidebarOrig = {
                    w: node.w,
                    h: node.h
                };
            }
            if (!node.grid) {
                if (!node.el) node = {
                    ...node
                }; // clone first time we're coming from sidebar (since 'clone' doesn't copy vars)
                node._isExternal = true;
                helper.gridstackNode = node;
            }
            // calculate the grid size based on element outer size
            const w = node.w || Math.round(helper.offsetWidth / cellWidth) || 1;
            const h = node.h || Math.round(helper.offsetHeight / cellHeight) || 1;
            // if the item came from another grid, make a copy and save the original info in case we go back there
            if (node.grid && node.grid !== this) {
                // copy the node original values (min/max/id/etc...) but override width/height/other flags which are this grid specific
                // console.log('dropover cloning node'); // TEST
                if (!el._gridstackNodeOrig) el._gridstackNodeOrig = node; // shouldn't have multiple nested!
                el.gridstackNode = node = {
                    ...node,
                    w: w,
                    h: h,
                    grid: this
                };
                delete node.x;
                delete node.y;
                this.engine.cleanupNode(node).nodeBoundFix(node);
                // restore some internal fields we need after clearing them all
                node._initDD = node._isExternal = node._temporaryRemoved = true; // so it can be inserted onDrag below
            } else {
                node.w = w;
                node.h = h;
                node._temporaryRemoved = true; // so we can insert it
            }
            // clear any marked for complete removal (Note: don't check _isAboutToRemove as that is cleared above - just do it)
            $7354c9fbc1d6b705$export$19e521a31019cf9d._itemRemoving(node.el, false);
            $7354c9fbc1d6b705$var$dd.on(el, 'drag', onDrag);
            // make sure this is called at least once when going fast #1578
            onDrag(event, el, helper);
            return false; // prevent parent from receiving msg (which may be a grid as well)
        })/**
             * Leaving our grid area...
             */ .on(this.el, 'dropout', (event, el, helper)=>{
            // console.log(`out ${this.el.gridstack.opts.id} ${count++}`); // TEST
            const node = helper?.gridstackNode || el.gridstackNode;
            if (!node) return false;
            // fix #1578 when dragging fast, we might get leave after other grid gets enter (which calls us to clean)
            // so skip this one if we're not the active grid really..
            if (!node.grid || node.grid === this) {
                this._leave(el, helper);
                // if we were created as temporary nested grid, go back to before state
                if (this._isTemp) this.removeAsSubGrid(node);
            }
            return false; // prevent parent from receiving msg (which may be grid as well)
        })/**
             * end - releasing the mouse
             */ .on(this.el, 'drop', (event, el, helper)=>{
            const node = helper?.gridstackNode || el.gridstackNode;
            // ignore drop on ourself from ourself that didn't come from the outside - dragend will handle the simple move instead
            if (node?.grid === this && !node._isExternal) return false;
            const wasAdded = !!this.placeholder.parentElement; // skip items not actually added to us because of constrains, but do cleanup #1419
            const wasSidebar = el !== helper;
            this.placeholder.remove();
            delete this.placeholder.gridstackNode;
            // disable animation when replacing a placeholder (already positioned) with actual content
            if (wasAdded && this.opts.animate) {
                this.setAnimation(false);
                this.setAnimation(true, true); // delay adding back
            }
            // notify previous grid of removal
            // console.log('drop delete _gridstackNodeOrig') // TEST
            const origNode = el._gridstackNodeOrig;
            delete el._gridstackNodeOrig;
            if (wasAdded && origNode?.grid && origNode.grid !== this) {
                const oGrid = origNode.grid;
                oGrid.engine.removeNodeFromLayoutCache(origNode);
                oGrid.engine.removedNodes.push(origNode);
                oGrid._triggerRemoveEvent()._triggerChangeEvent();
                // if it's an empty sub-grid that got auto-created, nuke it
                if (oGrid.parentGridNode && !oGrid.engine.nodes.length && oGrid.opts.subGridDynamic) oGrid.removeAsSubGrid();
            }
            if (!node) return false;
            // use existing placeholder node as it's already in our list with drop location
            if (wasAdded) {
                this.engine.cleanupNode(node); // removes all internal _xyz values
                node.grid = this;
            }
            delete node.grid?._isTemp;
            $7354c9fbc1d6b705$var$dd.off(el, 'drag');
            // if we made a copy insert that instead of the original (sidebar item)
            if (helper !== el) {
                helper.remove();
                el = helper;
            } else el.remove(); // reduce flicker as we change depth here, and size further down
            this._removeDD(el);
            if (!wasAdded) return false;
            const subGrid = node.subGrid?.el?.gridstack; // set when actual sub-grid present
            (0, $2wHnB.Utils).copyPos(node, this._readAttr(this.placeholder)); // placeholder values as moving VERY fast can throw things off #1578
            (0, $2wHnB.Utils).removePositioningStyles(el);
            // give the user a chance to alter the widget that will get inserted if new sidebar item
            if (wasSidebar && (node.content || node.subGridOpts || $7354c9fbc1d6b705$export$19e521a31019cf9d.addRemoveCB)) {
                delete node.el;
                el = this.addWidget(node);
            } else {
                this._prepareElement(el, true, node);
                this.el.appendChild(el);
                // resizeToContent is skipped in _prepareElement() until node is visible (clientHeight=0) so call it now
                this.resizeToContentCheck(false, node);
                if (subGrid) subGrid.parentGridNode = node;
                this._updateContainerHeight();
            }
            this.engine.addedNodes.push(node);
            this._triggerAddEvent();
            this._triggerChangeEvent();
            this.engine.endUpdate();
            if (this._gsEventHandler['dropped']) this._gsEventHandler['dropped']({
                ...event,
                type: 'dropped'
            }, origNode && origNode.grid ? origNode : undefined, node);
            return false; // prevent parent from receiving msg (which may be grid as well)
        });
        return this;
    }
    /** @internal mark item for removal */ static _itemRemoving(el, remove) {
        if (!el) return;
        const node = el ? el.gridstackNode : undefined;
        if (!node?.grid || el.classList.contains(node.grid.opts.removableOptions.decline)) return;
        remove ? node._isAboutToRemove = true : delete node._isAboutToRemove;
        remove ? el.classList.add('grid-stack-item-removing') : el.classList.remove('grid-stack-item-removing');
    }
    /** @internal called to setup a trash drop zone if the user specifies it */ _setupRemoveDrop() {
        if (typeof this.opts.removable !== 'string') return this;
        const trashEl = document.querySelector(this.opts.removable);
        if (!trashEl) return this;
        // only register ONE static drop-over/dropout callback for the 'trash', and it will
        // update the passed in item and parent grid because the '.trash' is a shared resource anyway,
        // and Native DD only has 1 event CB (having a list and technically a per grid removableOptions complicates things greatly)
        if (!this.opts.staticGrid && !$7354c9fbc1d6b705$var$dd.isDroppable(trashEl)) $7354c9fbc1d6b705$var$dd.droppable(trashEl, this.opts.removableOptions).on(trashEl, 'dropover', (event, el)=>$7354c9fbc1d6b705$export$19e521a31019cf9d._itemRemoving(el, true)).on(trashEl, 'dropout', (event, el)=>$7354c9fbc1d6b705$export$19e521a31019cf9d._itemRemoving(el, false));
        return this;
    }
    /**
     * prepares the element for drag&drop - this is normally called by makeWidget() unless are are delay loading
     * @param el GridItemHTMLElement of the widget
     * @param [force=false]
     * */ prepareDragDrop(el, force = false) {
        const node = el?.gridstackNode;
        if (!node) return;
        const noMove = node.noMove || this.opts.disableDrag;
        const noResize = node.noResize || this.opts.disableResize;
        // check for disabled grid first
        const disable = this.opts.staticGrid || noMove && noResize;
        if (force || disable) {
            if (node._initDD) {
                this._removeDD(el); // nukes everything instead of just disable, will add some styles back next
                delete node._initDD;
            }
            if (disable) el.classList.add('ui-draggable-disabled', 'ui-resizable-disabled'); // add styles one might depend on #1435
            if (!force) return this;
        }
        if (!node._initDD) {
            // variables used/cashed between the 3 start/move/end methods, in addition to node passed above
            let cellWidth;
            let cellHeight;
            /** called when item starts moving/resizing */ const onStartMoving = (event, ui)=>{
                // trigger any 'dragstart' / 'resizestart' manually
                this.triggerEvent(event, event.target);
                cellWidth = this.cellWidth();
                cellHeight = this.getCellHeight(true); // force pixels for calculations
                this._onStartMoving(el, event, ui, node, cellWidth, cellHeight);
            };
            /** called when item is being dragged/resized */ const dragOrResize = (event, ui)=>{
                this._dragOrResize(el, event, ui, node, cellWidth, cellHeight);
            };
            /** called when the item stops moving/resizing */ const onEndMoving = (event)=>{
                this.placeholder.remove();
                delete this.placeholder.gridstackNode;
                delete node._moving;
                delete node._resizing;
                delete node._event;
                delete node._lastTried;
                const widthChanged = node.w !== node._orig.w;
                // if the item has moved to another grid, we're done here
                const target = event.target;
                if (!target.gridstackNode || target.gridstackNode.grid !== this) return;
                node.el = target;
                if (node._isAboutToRemove) {
                    const grid = el.gridstackNode.grid;
                    if (grid._gsEventHandler[event.type]) grid._gsEventHandler[event.type](event, target);
                    grid.engine.nodes.push(node); // temp add it back so we can proper remove it next
                    grid.removeWidget(el, true, true);
                } else {
                    (0, $2wHnB.Utils).removePositioningStyles(target);
                    if (node._temporaryRemoved) {
                        // use last position we were at (not _orig as we may have pushed others and moved) and add it back
                        this._writePosAttr(target, node);
                        this.engine.addNode(node);
                    } else // move to new placeholder location
                    this._writePosAttr(target, node);
                    this.triggerEvent(event, target);
                }
                // @ts-ignore
                this._extraDragRow = 0; // @ts-ignore
                this._updateContainerHeight(); // @ts-ignore
                this._triggerChangeEvent();
                this.engine.endUpdate();
                if (event.type === 'resizestop') {
                    if (Number.isInteger(node.sizeToContent)) node.sizeToContent = node.h; // new soft limit
                    this.resizeToContentCheck(widthChanged, node); // wait for width animation if changed
                }
            };
            $7354c9fbc1d6b705$var$dd.draggable(el, {
                start: onStartMoving,
                stop: onEndMoving,
                drag: dragOrResize
            }).resizable(el, {
                start: onStartMoving,
                stop: onEndMoving,
                resize: dragOrResize
            });
            node._initDD = true; // we've set DD support now
        }
        // finally fine tune move vs resize by disabling any part...
        $7354c9fbc1d6b705$var$dd.draggable(el, noMove ? 'disable' : 'enable').resizable(el, noResize ? 'disable' : 'enable');
        return this;
    }
    /** @internal handles actual drag/resize start */ _onStartMoving(el, event, ui, node, cellWidth, cellHeight) {
        this.engine.cleanNodes().beginUpdate(node);
        // @ts-ignore
        this._writePosAttr(this.placeholder, node);
        this.el.appendChild(this.placeholder);
        this.placeholder.gridstackNode = node;
        // console.log('_onStartMoving placeholder') // TEST
        // if the element is inside a grid, it has already been scaled
        // we can use that as a scale reference
        if (node.grid?.el) this.dragTransform = (0, $2wHnB.Utils).getValuesFromTransformedElement(el);
        else if (this.placeholder && this.placeholder.closest('.grid-stack')) {
            const gridEl = this.placeholder.closest('.grid-stack');
            this.dragTransform = (0, $2wHnB.Utils).getValuesFromTransformedElement(gridEl);
        } else this.dragTransform = {
            xScale: 1,
            xOffset: 0,
            yScale: 1,
            yOffset: 0
        };
        node.el = this.placeholder;
        node._lastUiPosition = ui.position;
        node._prevYPix = ui.position.top;
        node._moving = event.type === 'dragstart'; // 'dropover' are not initially moving so they can go exactly where they enter (will push stuff out of the way)
        node._resizing = event.type === 'resizestart';
        delete node._lastTried;
        if (event.type === 'dropover' && node._temporaryRemoved) {
            // console.log('engine.addNode x=' + node.x); // TEST
            this.engine.addNode(node); // will add, fix collisions, update attr and clear _temporaryRemoved
            node._moving = true; // AFTER, mark as moving object (wanted fix location before)
        }
        // set the min/max resize info taking into account the column count and position (so we don't resize outside the grid)
        this.engine.cacheRects(cellWidth, cellHeight, this.opts.marginTop, this.opts.marginRight, this.opts.marginBottom, this.opts.marginLeft);
        if (event.type === 'resizestart') {
            const colLeft = this.getColumn() - node.x;
            const rowLeft = (this.opts.maxRow || Number.MAX_SAFE_INTEGER) - node.y;
            $7354c9fbc1d6b705$var$dd.resizable(el, 'option', 'minWidth', cellWidth * Math.min(node.minW || 1, colLeft)).resizable(el, 'option', 'minHeight', cellHeight * Math.min(node.minH || 1, rowLeft)).resizable(el, 'option', 'maxWidth', cellWidth * Math.min(node.maxW || Number.MAX_SAFE_INTEGER, colLeft)).resizable(el, 'option', 'maxWidthMoveLeft', cellWidth * Math.min(node.maxW || Number.MAX_SAFE_INTEGER, node.x + node.w)).resizable(el, 'option', 'maxHeight', cellHeight * Math.min(node.maxH || Number.MAX_SAFE_INTEGER, rowLeft)).resizable(el, 'option', 'maxHeightMoveUp', cellHeight * Math.min(node.maxH || Number.MAX_SAFE_INTEGER, node.y + node.h));
        }
    }
    /** @internal handles actual drag/resize */ _dragOrResize(el, event, ui, node, cellWidth, cellHeight) {
        const p = {
            ...node._orig
        }; // could be undefined (_isExternal) which is ok (drag only set x,y and w,h will default to node value)
        let resizing;
        let mLeft = this.opts.marginLeft, mRight = this.opts.marginRight, mTop = this.opts.marginTop, mBottom = this.opts.marginBottom;
        // if margins (which are used to pass mid point by) are large relative to cell height/width, reduce them down #1855
        const mHeight = Math.round(cellHeight * 0.1), mWidth = Math.round(cellWidth * 0.1);
        mLeft = Math.min(mLeft, mWidth);
        mRight = Math.min(mRight, mWidth);
        mTop = Math.min(mTop, mHeight);
        mBottom = Math.min(mBottom, mHeight);
        if (event.type === 'drag') {
            if (node._temporaryRemoved) return; // handled by dropover
            const distance = ui.position.top - node._prevYPix;
            node._prevYPix = ui.position.top;
            if (this.opts.draggable.scroll !== false) (0, $2wHnB.Utils).updateScrollPosition(el, ui.position, distance);
            // get new position taking into account the margin in the direction we are moving! (need to pass mid point by margin)
            const left = ui.position.left + (ui.position.left > node._lastUiPosition.left ? -mRight : mLeft);
            const top = ui.position.top + (ui.position.top > node._lastUiPosition.top ? -mBottom : mTop);
            p.x = Math.round(left / cellWidth);
            p.y = Math.round(top / cellHeight);
            // @ts-ignore// if we're at the bottom hitting something else, grow the grid so cursor doesn't leave when trying to place below others
            const prev = this._extraDragRow;
            if (this.engine.collide(node, p)) {
                const row = this.getRow();
                let extra = Math.max(0, p.y + node.h - row);
                if (this.opts.maxRow && row + extra > this.opts.maxRow) extra = Math.max(0, this.opts.maxRow - row);
                 // @ts-ignore
                this._extraDragRow = extra; // @ts-ignore
            } else this._extraDragRow = 0; // @ts-ignore
            if (this._extraDragRow !== prev) this._updateContainerHeight();
            if (node.x === p.x && node.y === p.y) return; // skip same
        // DON'T skip one we tried as we might have failed because of coverage <50% before
        // if (node._lastTried && node._lastTried.x === x && node._lastTried.y === y) return;
        } else if (event.type === 'resize') {
            if (p.x < 0) return;
            // Scrolling page if needed
            (0, $2wHnB.Utils).updateScrollResize(event, el, cellHeight);
            // get new size
            p.w = Math.round((ui.size.width - mLeft) / cellWidth);
            p.h = Math.round((ui.size.height - mTop) / cellHeight);
            if (node.w === p.w && node.h === p.h) return;
            if (node._lastTried && node._lastTried.w === p.w && node._lastTried.h === p.h) return; // skip one we tried (but failed)
            // if we size on left/top side this might move us, so get possible new position as well
            const left = ui.position.left + mLeft;
            const top = ui.position.top + mTop;
            p.x = Math.round(left / cellWidth);
            p.y = Math.round(top / cellHeight);
            resizing = true;
        }
        node._event = event;
        node._lastTried = p; // set as last tried (will nuke if we go there)
        const rect = {
            x: ui.position.left + mLeft,
            y: ui.position.top + mTop,
            w: (ui.size ? ui.size.width : node.w * cellWidth) - mLeft - mRight,
            h: (ui.size ? ui.size.height : node.h * cellHeight) - mTop - mBottom
        };
        if (this.engine.moveNodeCheck(node, {
            ...p,
            cellWidth: cellWidth,
            cellHeight: cellHeight,
            rect: rect,
            resizing: resizing
        })) {
            node._lastUiPosition = ui.position;
            this.engine.cacheRects(cellWidth, cellHeight, mTop, mRight, mBottom, mLeft);
            delete node._skipDown;
            if (resizing && node.subGrid) node.subGrid.onResize();
            this._extraDragRow = 0; // @ts-ignore
            this._updateContainerHeight();
            const target = event.target; // @ts-ignore
            // Do not write sidebar item attributes back to the original sidebar el
            if (!node._sidebarOrig) this._writePosAttr(target, node);
            this.triggerEvent(event, target);
        }
    }
    /** call given event callback on our main top-most grid (if we're nested) */ triggerEvent(event, target) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        let grid = this;
        while(grid.parentGridNode)grid = grid.parentGridNode.grid;
        if (grid._gsEventHandler[event.type]) grid._gsEventHandler[event.type](event, target);
    }
    /** @internal called when item leaving our area by either cursor dropout event
     * or shape is outside our boundaries. remove it from us, and mark temporary if this was
     * our item to start with else restore prev node values from prev grid it came from.
     */ _leave(el, helper) {
        helper = helper || el;
        const node = helper.gridstackNode;
        if (!node) return;
        // remove the scale of the helper on leave
        helper.style.transform = helper.style.transformOrigin = null;
        $7354c9fbc1d6b705$var$dd.off(el, 'drag'); // no need to track while being outside
        // this gets called when cursor leaves and shape is outside, so only do this once
        if (node._temporaryRemoved) return;
        node._temporaryRemoved = true;
        this.engine.removeNode(node); // remove placeholder as well, otherwise it's a sign node is not in our list, which is a bigger issue
        node.el = node._isExternal && helper ? helper : el; // point back to real item being dragged
        const sidebarOrig = node._sidebarOrig;
        if (node._isExternal) this.engine.cleanupNode(node);
        // Restore sidebar item initial size info to stay consistent when dragging between multiple grids
        node._sidebarOrig = sidebarOrig;
        if (this.opts.removable === true) // item leaving us and we are supposed to remove on leave (no need to drag onto trash) mark it so
        $7354c9fbc1d6b705$export$19e521a31019cf9d._itemRemoving(el, true);
        // finally if item originally came from another grid, but left us, restore things back to prev info
        if (el._gridstackNodeOrig) {
            // console.log('leave delete _gridstackNodeOrig') // TEST
            el.gridstackNode = el._gridstackNodeOrig;
            delete el._gridstackNodeOrig;
        } else if (node._isExternal) // item came from outside restore all nodes back to original
        this.engine.restoreInitial();
    }
}
/**
 * callback to create the content of widgets so the app can control how to store and restore it
 * By default this lib will do 'el.textContent = w.content' forcing text only support for avoiding potential XSS issues.
 */ $7354c9fbc1d6b705$export$19e521a31019cf9d.renderCB = (el, w)=>{
    if (el && w?.content) el.textContent = w.content;
};
/** parent class for sizing content. defaults to '.grid-stack-item-content' */ $7354c9fbc1d6b705$export$19e521a31019cf9d.resizeToContentParent = '.grid-stack-item-content';
/** scoping so users can call GridStack.Utils.sort() for example */ $7354c9fbc1d6b705$export$19e521a31019cf9d.Utils = (0, $2wHnB.Utils);
/** scoping so users can call new GridStack.Engine(12) for example */ $7354c9fbc1d6b705$export$19e521a31019cf9d.Engine = (0, $7aq4W.GridStackEngine);
/** @internal current version compiled in code */ $7354c9fbc1d6b705$export$19e521a31019cf9d.GDRev = '12.4.2';

});
parcelRegister("7aq4W", function(module, exports) {

$parcel$export(module.exports, "GridStackEngine", () => $537db24912b4f7e1$export$c0882fbd3b4aaa0f);
/**
 * gridstack-engine.ts 12.4.2
 * Copyright (c) 2021-2025  Alain Dumesny - see GridStack root license
 */ 
var $2wHnB = parcelRequire("2wHnB");
/**
 * Defines the GridStack engine that handles all grid layout calculations and node positioning.
 * This is the core engine that performs grid manipulation without any DOM operations.
 *
 * The engine manages:
 * - Node positioning and collision detection
 * - Layout algorithms (compact, float, etc.)
 * - Grid resizing and column changes
 * - Widget movement and resizing logic
 *
 * NOTE: Values should not be modified directly - use the main GridStack API instead
 * to ensure proper DOM updates and event triggers.
 */ class $537db24912b4f7e1$export$c0882fbd3b4aaa0f {
    constructor(opts = {}){
        this.addedNodes = [];
        this.removedNodes = [];
        this.defaultColumn = 12;
        this.column = opts.column || this.defaultColumn;
        if (this.column > this.defaultColumn) this.defaultColumn = this.column;
        this.maxRow = opts.maxRow;
        this._float = opts.float;
        this.nodes = opts.nodes || [];
        this.onChange = opts.onChange;
    }
    /**
     * Enable/disable batch mode for multiple operations to optimize performance.
     * When enabled, layout updates are deferred until batch mode is disabled.
     *
     * @param flag true to enable batch mode, false to disable and apply changes
     * @param doPack if true (default), pack/compact nodes when disabling batch mode
     * @returns the engine instance for chaining
     *
     * @example
     * // Start batch mode for multiple operations
     * engine.batchUpdate(true);
     * engine.addNode(node1);
     * engine.addNode(node2);
     * engine.batchUpdate(false); // Apply all changes at once
     */ batchUpdate(flag = true, doPack = true) {
        if (!!this.batchMode === flag) return this;
        this.batchMode = flag;
        if (flag) {
            this._prevFloat = this._float;
            this._float = true; // let things go anywhere for now... will restore and possibly reposition later
            this.cleanNodes();
            this.saveInitial(); // since begin update (which is called multiple times) won't do this
        } else {
            this._float = this._prevFloat;
            delete this._prevFloat;
            if (doPack) this._packNodes();
            this._notify();
        }
        return this;
    }
    // use entire row for hitting area (will use bottom reverse sorted first) if we not actively moving DOWN and didn't already skip
    _useEntireRowArea(node, nn) {
        return (!this.float || this.batchMode && !this._prevFloat) && !this._hasLocked && (!node._moving || node._skipDown || nn.y <= node.y);
    }
    /** @internal fix collision on given 'node', going to given new location 'nn', with optional 'collide' node already found.
     * return true if we moved. */ _fixCollisions(node, nn = node, collide, opt = {}) {
        this.sortNodes(-1); // from last to first, so recursive collision move items in the right order
        collide = collide || this.collide(node, nn); // REAL area collide for swap and skip if none...
        if (!collide) return false;
        // swap check: if we're actively moving in gravity mode, see if we collide with an object the same size
        if (node._moving && !opt.nested && !this.float) {
            if (this.swap(node, collide)) return true;
        }
        // during while() collisions MAKE SURE to check entire row so larger items don't leap frog small ones (push them all down starting last in grid)
        let area = nn;
        if (!this._loading && this._useEntireRowArea(node, nn)) {
            area = {
                x: 0,
                w: this.column,
                y: nn.y,
                h: nn.h
            };
            collide = this.collide(node, area, opt.skip); // force new hit
        }
        let didMove = false;
        const newOpt = {
            nested: true,
            pack: false
        };
        let counter = 0;
        while(collide = collide || this.collide(node, area, opt.skip)){
            if (counter++ > this.nodes.length * 2) throw new Error("Infinite collide check");
            let moved;
            // if colliding with a locked item OR loading (move after) OR moving down with top gravity (and collide could move up) -> skip past the collide,
            // but remember that skip down so we only do this once (and push others otherwise).
            if (collide.locked || this._loading || node._moving && !node._skipDown && nn.y > node.y && !this.float && // can take space we had, or before where we're going
            (!this.collide(collide, {
                ...collide,
                y: node.y
            }, node) || !this.collide(collide, {
                ...collide,
                y: nn.y - collide.h
            }, node))) {
                node._skipDown = node._skipDown || nn.y > node.y;
                const newNN = {
                    ...nn,
                    y: collide.y + collide.h,
                    ...newOpt
                };
                // pretent we moved to where we are now so we can continue any collision checks #2492
                moved = this._loading && (0, $2wHnB.Utils).samePos(node, newNN) ? true : this.moveNode(node, newNN);
                if ((collide.locked || this._loading) && moved) (0, $2wHnB.Utils).copyPos(nn, node); // moving after lock become our new desired location
                else if (!collide.locked && moved && opt.pack) {
                    // we moved after and will pack: do it now and keep the original drop location, but past the old collide to see what else we might push way
                    this._packNodes();
                    nn.y = collide.y + collide.h;
                    (0, $2wHnB.Utils).copyPos(node, nn);
                }
                didMove = didMove || moved;
            } else // move collide down *after* where we will be, ignoring where we are now (don't collide with us)
            moved = this.moveNode(collide, {
                ...collide,
                y: nn.y + nn.h,
                skip: node,
                ...newOpt
            });
            if (!moved) return didMove; // break inf loop if we couldn't move after all (ex: maxRow, fixed)
            collide = undefined;
        }
        return didMove;
    }
    /**
     * Return the first node that intercepts/collides with the given node or area.
     * Used for collision detection during drag and drop operations.
     *
     * @param skip the node to skip in collision detection (usually the node being moved)
     * @param area the area to check for collisions (defaults to skip node's area)
     * @param skip2 optional second node to skip in collision detection
     * @returns the first colliding node, or undefined if no collision
     *
     * @example
     * const colliding = engine.collide(draggedNode, {x: 2, y: 1, w: 2, h: 1});
     * if (colliding) {
     *   console.log('Would collide with:', colliding.id);
     * }
     */ collide(skip, area = skip, skip2) {
        const skipId = skip._id;
        const skip2Id = skip2?._id;
        return this.nodes.find((n)=>n._id !== skipId && n._id !== skip2Id && (0, $2wHnB.Utils).isIntercepted(n, area));
    }
    /**
     * Return all nodes that intercept/collide with the given node or area.
     * Similar to collide() but returns all colliding nodes instead of just the first.
     *
     * @param skip the node to skip in collision detection
     * @param area the area to check for collisions (defaults to skip node's area)
     * @param skip2 optional second node to skip in collision detection
     * @returns array of all colliding nodes
     *
     * @example
     * const allCollisions = engine.collideAll(draggedNode);
     * console.log('Colliding with', allCollisions.length, 'nodes');
     */ collideAll(skip, area = skip, skip2) {
        const skipId = skip._id;
        const skip2Id = skip2?._id;
        return this.nodes.filter((n)=>n._id !== skipId && n._id !== skip2Id && (0, $2wHnB.Utils).isIntercepted(n, area));
    }
    /** does a pixel coverage collision based on where we started, returning the node that has the most coverage that is >50% mid line */ directionCollideCoverage(node, o, collides) {
        if (!o.rect || !node._rect) return;
        const r0 = node._rect; // where started
        const r = {
            ...o.rect
        }; // where we are
        // update dragged rect to show where it's coming from (above or below, etc...)
        if (r.y > r0.y) {
            r.h += r.y - r0.y;
            r.y = r0.y;
        } else r.h += r0.y - r.y;
        if (r.x > r0.x) {
            r.w += r.x - r0.x;
            r.x = r0.x;
        } else r.w += r0.x - r.x;
        let collide;
        let overMax = 0.5; // need >50%
        for (let n of collides){
            if (n.locked || !n._rect) break;
            const r2 = n._rect; // overlapping target
            let yOver = Number.MAX_VALUE, xOver = Number.MAX_VALUE;
            // depending on which side we started from, compute the overlap % of coverage
            // (ex: from above/below we only compute the max horizontal line coverage)
            if (r0.y < r2.y) yOver = (r.y + r.h - r2.y) / r2.h;
            else if (r0.y + r0.h > r2.y + r2.h) yOver = (r2.y + r2.h - r.y) / r2.h;
            if (r0.x < r2.x) xOver = (r.x + r.w - r2.x) / r2.w;
            else if (r0.x + r0.w > r2.x + r2.w) xOver = (r2.x + r2.w - r.x) / r2.w;
            const over = Math.min(xOver, yOver);
            if (over > overMax) {
                overMax = over;
                collide = n;
            }
        }
        o.collide = collide; // save it so we don't have to find it again
        return collide;
    }
    /** does a pixel coverage returning the node that has the most coverage by area */ /*
    protected collideCoverage(r: GridStackPosition, collides: GridStackNode[]): {collide: GridStackNode, over: number} {
      const collide: GridStackNode;
      const overMax = 0;
      collides.forEach(n => {
        if (n.locked || !n._rect) return;
        const over = Utils.areaIntercept(r, n._rect);
        if (over > overMax) {
          overMax = over;
          collide = n;
        }
      });
      return {collide, over: overMax};
    }
    */ /**
     * Cache the pixel rectangles for all nodes used for collision detection during drag operations.
     * This optimization converts grid coordinates to pixel coordinates for faster collision detection.
     *
     * @param w width of a single grid cell in pixels
     * @param h height of a single grid cell in pixels
     * @param top top margin/padding in pixels
     * @param right right margin/padding in pixels
     * @param bottom bottom margin/padding in pixels
     * @param left left margin/padding in pixels
     * @returns the engine instance for chaining
     *
     * @internal This is typically called by GridStack during resize events
     */ cacheRects(w, h, top, right, bottom, left) {
        this.nodes.forEach((n)=>n._rect = {
                y: n.y * h + top,
                x: n.x * w + left,
                w: n.w * w - left - right,
                h: n.h * h - top - bottom
            });
        return this;
    }
    /**
     * Attempt to swap the positions of two nodes if they meet swapping criteria.
     * Nodes can swap if they are the same size or in the same column/row, not locked, and touching.
     *
     * @param a first node to swap
     * @param b second node to swap
     * @returns true if swap was successful, false if not possible, undefined if not applicable
     *
     * @example
     * const swapped = engine.swap(nodeA, nodeB);
     * if (swapped) {
     *   console.log('Nodes swapped successfully');
     * }
     */ swap(a, b) {
        if (!b || b.locked || !a || a.locked) return false;
        function _doSwap() {
            const x = b.x, y = b.y;
            b.x = a.x;
            b.y = a.y; // b -> a position
            if (a.h != b.h) {
                a.x = x;
                a.y = b.y + b.h; // a -> goes after b
            } else if (a.w != b.w) {
                a.x = b.x + b.w;
                a.y = y; // a -> goes after b
            } else {
                a.x = x;
                a.y = y; // a -> old b position
            }
            a._dirty = b._dirty = true;
            return true;
        }
        let touching; // remember if we called it (vs undefined)
        // same size and same row or column, and touching
        if (a.w === b.w && a.h === b.h && (a.x === b.x || a.y === b.y) && (touching = (0, $2wHnB.Utils).isTouching(a, b))) return _doSwap();
        if (touching === false) return; // IFF ran test and fail, bail out
        // check for taking same columns (but different height) and touching
        if (a.w === b.w && a.x === b.x && (touching || (touching = (0, $2wHnB.Utils).isTouching(a, b)))) {
            if (b.y < a.y) {
                const t = a;
                a = b;
                b = t;
            } // swap a <-> b vars so a is first
            return _doSwap();
        }
        if (touching === false) return;
        // check if taking same row (but different width) and touching
        if (a.h === b.h && a.y === b.y && (touching || (touching = (0, $2wHnB.Utils).isTouching(a, b)))) {
            if (b.x < a.x) {
                const t = a;
                a = b;
                b = t;
            } // swap a <-> b vars so a is first
            return _doSwap();
        }
        return false;
    }
    /**
     * Check if the specified rectangular area is empty (no nodes occupy any part of it).
     *
     * @param x the x coordinate (column) of the area to check
     * @param y the y coordinate (row) of the area to check
     * @param w the width in columns of the area to check
     * @param h the height in rows of the area to check
     * @returns true if the area is completely empty, false if any node overlaps
     *
     * @example
     * if (engine.isAreaEmpty(2, 1, 3, 2)) {
     *   console.log('Area is available for placement');
     * }
     */ isAreaEmpty(x, y, w, h) {
        const nn = {
            x: x || 0,
            y: y || 0,
            w: w || 1,
            h: h || 1
        };
        return !this.collide(nn);
    }
    /**
     * Re-layout grid items to reclaim any empty space.
     * This optimizes the grid layout by moving items to fill gaps.
     *
     * @param layout layout algorithm to use:
     *   - 'compact' (default): find truly empty spaces, may reorder items
     *   - 'list': keep the sort order exactly the same, move items up sequentially
     * @param doSort if true (default), sort nodes by position before compacting
     * @returns the engine instance for chaining
     *
     * @example
     * // Compact to fill empty spaces
     * engine.compact();
     *
     * // Compact preserving item order
     * engine.compact('list');
     */ compact(layout = 'compact', doSort = true) {
        if (this.nodes.length === 0) return this;
        if (doSort) this.sortNodes();
        const wasBatch = this.batchMode;
        if (!wasBatch) this.batchUpdate();
        const wasColumnResize = this._inColumnResize;
        if (!wasColumnResize) this._inColumnResize = true; // faster addNode()
        const copyNodes = this.nodes;
        this.nodes = []; // pretend we have no nodes to conflict layout to start with...
        copyNodes.forEach((n, index, list)=>{
            let after;
            if (!n.locked) {
                n.autoPosition = true;
                if (layout === 'list' && index) after = list[index - 1];
            }
            this.addNode(n, false, after); // 'false' for add event trigger
        });
        if (!wasColumnResize) delete this._inColumnResize;
        if (!wasBatch) this.batchUpdate(false);
        return this;
    }
    /**
     * Enable/disable floating widgets (default: `false`).
     * When floating is enabled, widgets can move up to fill empty spaces.
     * See [example](http://gridstackjs.com/demo/float.html)
     *
     * @param val true to enable floating, false to disable
     *
     * @example
     * engine.float = true;  // Enable floating
     * engine.float = false; // Disable floating (default)
     */ set float(val) {
        if (this._float === val) return;
        this._float = val || false;
        if (!val) this._packNodes()._notify();
    }
    /**
     * Get the current floating mode setting.
     *
     * @returns true if floating is enabled, false otherwise
     *
     * @example
     * const isFloating = engine.float;
     * console.log('Floating enabled:', isFloating);
     */ get float() {
        return this._float || false;
    }
    /**
     * Sort the nodes array from first to last, or reverse.
     * This is called during collision/placement operations to enforce a specific order.
     *
     * @param dir sort direction: 1 for ascending (first to last), -1 for descending (last to first)
     * @returns the engine instance for chaining
     *
     * @example
     * engine.sortNodes();    // Sort ascending (default)
     * engine.sortNodes(-1);  // Sort descending
     */ sortNodes(dir = 1) {
        this.nodes = (0, $2wHnB.Utils).sort(this.nodes, dir);
        return this;
    }
    /** @internal called to top gravity pack the items back OR revert back to original Y positions when floating */ _packNodes() {
        if (this.batchMode) return this;
        this.sortNodes(); // first to last
        if (this.float) // restore original Y pos
        this.nodes.forEach((n)=>{
            if (n._updating || n._orig === undefined || n.y === n._orig.y) return;
            let newY = n.y;
            while(newY > n._orig.y){
                --newY;
                const collide = this.collide(n, {
                    x: n.x,
                    y: newY,
                    w: n.w,
                    h: n.h
                });
                if (!collide) {
                    n._dirty = true;
                    n.y = newY;
                }
            }
        });
        else // top gravity pack
        this.nodes.forEach((n, i)=>{
            if (n.locked) return;
            while(n.y > 0){
                const newY = i === 0 ? 0 : n.y - 1;
                const canBeMoved = i === 0 || !this.collide(n, {
                    x: n.x,
                    y: newY,
                    w: n.w,
                    h: n.h
                });
                if (!canBeMoved) break;
                // Note: must be dirty (from last position) for GridStack::OnChange CB to update positions
                // and move items back. The user 'change' CB should detect changes from the original
                // starting position instead.
                n._dirty = n.y !== newY;
                n.y = newY;
            }
        });
        return this;
    }
    /**
     * Prepare and validate a node's coordinates and values for the current grid.
     * This ensures the node has valid position, size, and properties before being added to the grid.
     *
     * @param node the node to prepare and validate
     * @param resizing if true, resize the node down if it's out of bounds; if false, move it to fit
     * @returns the prepared node with valid coordinates
     *
     * @example
     * const node = { w: 3, h: 2, content: 'Hello' };
     * const prepared = engine.prepareNode(node);
     * console.log('Node prepared at:', prepared.x, prepared.y);
     */ prepareNode(node, resizing) {
        node._id = node._id ?? $537db24912b4f7e1$export$c0882fbd3b4aaa0f._idSeq++;
        // make sure USER supplied id are unique in our list, else assign a new one as it will create issues during load/update/etc...
        const id = node.id;
        if (id) {
            let count = 1; // append nice _n rather than some random number
            while(this.nodes.find((n)=>n.id === node.id && n !== node))node.id = id + '_' + count++;
        }
        // if we're missing position, have the grid position us automatically (before we set them to 0,0)
        if (node.x === undefined || node.y === undefined || node.x === null || node.y === null) node.autoPosition = true;
        // assign defaults for missing required fields
        const defaults = {
            x: 0,
            y: 0,
            w: 1,
            h: 1
        };
        (0, $2wHnB.Utils).defaults(node, defaults);
        if (!node.autoPosition) delete node.autoPosition;
        if (!node.noResize) delete node.noResize;
        if (!node.noMove) delete node.noMove;
        (0, $2wHnB.Utils).sanitizeMinMax(node);
        // check for NaN (in case messed up strings were passed. can't do parseInt() || defaults.x above as 0 is valid #)
        if (typeof node.x == 'string') node.x = Number(node.x);
        if (typeof node.y == 'string') node.y = Number(node.y);
        if (typeof node.w == 'string') node.w = Number(node.w);
        if (typeof node.h == 'string') node.h = Number(node.h);
        if (isNaN(node.x)) {
            node.x = defaults.x;
            node.autoPosition = true;
        }
        if (isNaN(node.y)) {
            node.y = defaults.y;
            node.autoPosition = true;
        }
        if (isNaN(node.w)) node.w = defaults.w;
        if (isNaN(node.h)) node.h = defaults.h;
        this.nodeBoundFix(node, resizing);
        return node;
    }
    /**
     * Part 2 of preparing a node to fit inside the grid - validates and fixes coordinates and dimensions.
     * This ensures the node fits within grid boundaries and respects min/max constraints.
     *
     * @param node the node to validate and fix
     * @param resizing if true, resize the node to fit; if false, move the node to fit
     * @returns the engine instance for chaining
     *
     * @example
     * // Fix a node that might be out of bounds
     * engine.nodeBoundFix(node, true); // Resize to fit
     * engine.nodeBoundFix(node, false); // Move to fit
     */ nodeBoundFix(node, resizing) {
        const before = node._orig || (0, $2wHnB.Utils).copyPos({}, node);
        if (node.maxW) node.w = Math.min(node.w || 1, node.maxW);
        if (node.maxH) node.h = Math.min(node.h || 1, node.maxH);
        if (node.minW) node.w = Math.max(node.w || 1, node.minW);
        if (node.minH) node.h = Math.max(node.h || 1, node.minH);
        // if user loaded a larger than allowed widget for current # of columns,
        // remember it's position & width so we can restore back (1 -> 12 column) #1655 #1985
        // IFF we're not in the middle of column resizing!
        const saveOrig = (node.x || 0) + (node.w || 1) > this.column;
        if (saveOrig && this.column < this.defaultColumn && !this._inColumnResize && !this.skipCacheUpdate && node._id != null && this.findCacheLayout(node, this.defaultColumn) === -1) {
            const copy = {
                ...node
            }; // need _id + positions
            if (copy.autoPosition || copy.x === undefined) {
                delete copy.x;
                delete copy.y;
            } else copy.x = Math.min(this.defaultColumn - 1, copy.x);
            copy.w = Math.min(this.defaultColumn, copy.w || 1);
            this.cacheOneLayout(copy, this.defaultColumn);
        }
        if (node.w > this.column) node.w = this.column;
        else if (node.w < 1) node.w = 1;
        if (this.maxRow && node.h > this.maxRow) node.h = this.maxRow;
        else if (node.h < 1) node.h = 1;
        if (node.x < 0) node.x = 0;
        if (node.y < 0) node.y = 0;
        if (node.x + node.w > this.column) {
            if (resizing) node.w = this.column - node.x;
            else node.x = this.column - node.w;
        }
        if (this.maxRow && node.y + node.h > this.maxRow) {
            if (resizing) node.h = this.maxRow - node.y;
            else node.y = this.maxRow - node.h;
        }
        if (!(0, $2wHnB.Utils).samePos(node, before)) node._dirty = true;
        return this;
    }
    /**
     * Returns a list of nodes that have been modified from their original values.
     * This is used to track which nodes need DOM updates.
     *
     * @param verify if true, performs additional verification by comparing current vs original positions
     * @returns array of nodes that have been modified
     *
     * @example
     * const changed = engine.getDirtyNodes();
     * console.log('Modified nodes:', changed.length);
     *
     * // Get verified dirty nodes
     * const verified = engine.getDirtyNodes(true);
     */ getDirtyNodes(verify) {
        // compare original x,y,w,h instead as _dirty can be a temporary state
        if (verify) return this.nodes.filter((n)=>n._dirty && !(0, $2wHnB.Utils).samePos(n, n._orig));
        return this.nodes.filter((n)=>n._dirty);
    }
    /** @internal call this to call onChange callback with dirty nodes so DOM can be updated */ _notify(removedNodes) {
        if (this.batchMode || !this.onChange) return this;
        const dirtyNodes = (removedNodes || []).concat(this.getDirtyNodes());
        this.onChange(dirtyNodes);
        return this;
    }
    /**
     * Clean all dirty and last tried information from nodes.
     * This resets the dirty state tracking for all nodes.
     *
     * @returns the engine instance for chaining
     *
     * @internal
     */ cleanNodes() {
        if (this.batchMode) return this;
        this.nodes.forEach((n)=>{
            delete n._dirty;
            delete n._lastTried;
        });
        return this;
    }
    /**
     * Save the initial position/size of all nodes to track real dirty state.
     * This creates a snapshot of current positions that can be restored later.
     *
     * Note: Should be called right after change events and before move/resize operations.
     *
     * @returns the engine instance for chaining
     *
     * @internal
     */ saveInitial() {
        this.nodes.forEach((n)=>{
            n._orig = (0, $2wHnB.Utils).copyPos({}, n);
            delete n._dirty;
        });
        this._hasLocked = this.nodes.some((n)=>n.locked);
        return this;
    }
    /**
     * Restore all nodes back to their initial values.
     * This is typically called when canceling an operation (e.g., Esc key during drag).
     *
     * @returns the engine instance for chaining
     *
     * @internal
     */ restoreInitial() {
        this.nodes.forEach((n)=>{
            if (!n._orig || (0, $2wHnB.Utils).samePos(n, n._orig)) return;
            (0, $2wHnB.Utils).copyPos(n, n._orig);
            n._dirty = true;
        });
        this._notify();
        return this;
    }
    /**
     * Find the first available empty spot for the given node dimensions.
     * Updates the node's x,y attributes with the found position.
     *
     * @param node the node to find a position for (w,h must be set)
     * @param nodeList optional list of nodes to check against (defaults to engine nodes)
     * @param column optional column count (defaults to engine column count)
     * @param after optional node to start search after (maintains order)
     * @returns true if an empty position was found and node was updated
     *
     * @example
     * const node = { w: 2, h: 1 };
     * if (engine.findEmptyPosition(node)) {
     *   console.log('Found position at:', node.x, node.y);
     * }
     */ findEmptyPosition(node, nodeList = this.nodes, column = this.column, after) {
        const start = after ? after.y * column + (after.x + after.w) : 0;
        let found = false;
        for(let i = start; !found; ++i){
            const x = i % column;
            const y = Math.floor(i / column);
            if (x + node.w > column) continue;
            const box = {
                x: x,
                y: y,
                w: node.w,
                h: node.h
            };
            if (!nodeList.find((n)=>(0, $2wHnB.Utils).isIntercepted(box, n))) {
                if (node.x !== x || node.y !== y) node._dirty = true;
                node.x = x;
                node.y = y;
                delete node.autoPosition;
                found = true;
            }
        }
        return found;
    }
    /**
     * Add the given node to the grid, handling collision detection and re-packing.
     * This is the main method for adding new widgets to the engine.
     *
     * @param node the node to add to the grid
     * @param triggerAddEvent if true, adds node to addedNodes list for event triggering
     * @param after optional node to place this node after (for ordering)
     * @returns the added node (or existing node if duplicate)
     *
     * @example
     * const node = { x: 0, y: 0, w: 2, h: 1, content: 'Hello' };
     * const added = engine.addNode(node, true);
     */ addNode(node, triggerAddEvent = false, after) {
        const dup = this.nodes.find((n)=>n._id === node._id);
        if (dup) return dup; // prevent inserting twice! return it instead.
        // skip prepareNode if we're in middle of column resize (not new) but do check for bounds!
        this._inColumnResize ? this.nodeBoundFix(node) : this.prepareNode(node);
        delete node._temporaryRemoved;
        delete node._removeDOM;
        let skipCollision;
        if (node.autoPosition && this.findEmptyPosition(node, this.nodes, this.column, after)) {
            delete node.autoPosition; // found our slot
            skipCollision = true;
        }
        this.nodes.push(node);
        if (triggerAddEvent) this.addedNodes.push(node);
        if (!skipCollision) this._fixCollisions(node);
        if (!this.batchMode) this._packNodes()._notify();
        return node;
    }
    /**
     * Remove the given node from the grid.
     *
     * @param node the node to remove
     * @param removeDOM if true (default), marks node for DOM removal
     * @param triggerEvent if true, adds node to removedNodes list for event triggering
     * @returns the engine instance for chaining
     *
     * @example
     * engine.removeNode(node, true, true);
     */ removeNode(node, removeDOM = true, triggerEvent = false) {
        if (!this.nodes.find((n)=>n._id === node._id)) // TEST console.log(`Error: GridStackEngine.removeNode() node._id=${node._id} not found!`)
        return this;
        if (triggerEvent) this.removedNodes.push(node);
        if (removeDOM) node._removeDOM = true; // let CB remove actual HTML (used to set _id to null, but then we loose layout info)
        // don't use 'faster' .splice(findIndex(),1) in case node isn't in our list, or in multiple times.
        this.nodes = this.nodes.filter((n)=>n._id !== node._id);
        if (!node._isAboutToRemove) this._packNodes(); // if dragged out, no need to relayout as already done...
        this._notify([
            node
        ]);
        return this;
    }
    /**
     * Remove all nodes from the grid.
     *
     * @param removeDOM if true (default), marks all nodes for DOM removal
     * @param triggerEvent if true (default), triggers removal events
     * @returns the engine instance for chaining
     *
     * @example
     * engine.removeAll(); // Remove all nodes
     */ removeAll(removeDOM = true, triggerEvent = true) {
        delete this._layouts;
        if (!this.nodes.length) return this;
        removeDOM && this.nodes.forEach((n)=>n._removeDOM = true); // let CB remove actual HTML (used to set _id to null, but then we loose layout info)
        const removedNodes = this.nodes;
        this.removedNodes = triggerEvent ? removedNodes : [];
        this.nodes = [];
        return this._notify(removedNodes);
    }
    /**
     * Check if a node can be moved to a new position, considering layout constraints.
     * This is a safer version of moveNode() that validates the move first.
     *
     * For complex cases (like maxRow constraints), it simulates the move in a clone first,
     * then applies the changes only if they meet all specifications.
     *
     * @param node the node to move
     * @param o move options including target position
     * @returns true if the node was successfully moved
     *
     * @example
     * const canMove = engine.moveNodeCheck(node, { x: 2, y: 1 });
     * if (canMove) {
     *   console.log('Node moved successfully');
     * }
     */ moveNodeCheck(node, o) {
        // if (node.locked) return false;
        if (!this.changedPosConstrain(node, o)) return false;
        o.pack = true;
        // simpler case: move item directly...
        if (!this.maxRow) return this.moveNode(node, o);
        // complex case: create a clone with NO maxRow (will check for out of bounds at the end)
        let clonedNode;
        const clone = new $537db24912b4f7e1$export$c0882fbd3b4aaa0f({
            column: this.column,
            float: this.float,
            nodes: this.nodes.map((n)=>{
                if (n._id === node._id) {
                    clonedNode = {
                        ...n
                    };
                    return clonedNode;
                }
                return {
                    ...n
                };
            })
        });
        if (!clonedNode) return false;
        // check if we're covering 50% collision and could move, while still being under maxRow or at least not making it worse
        // (case where widget was somehow added past our max #2449)
        const canMove = clone.moveNode(clonedNode, o) && clone.getRow() <= Math.max(this.getRow(), this.maxRow);
        // else check if we can force a swap (float=true, or different shapes) on non-resize
        if (!canMove && !o.resizing && o.collide) {
            const collide = o.collide.el.gridstackNode; // find the source node the clone collided with at 50%
            if (this.swap(node, collide)) {
                this._notify();
                return true;
            }
        }
        if (!canMove) return false;
        // if clone was able to move, copy those mods over to us now instead of caller trying to do this all over!
        // Note: we can't use the list directly as elements and other parts point to actual node, so copy content
        clone.nodes.filter((n)=>n._dirty).forEach((c)=>{
            const n = this.nodes.find((a)=>a._id === c._id);
            if (!n) return;
            (0, $2wHnB.Utils).copyPos(n, c);
            n._dirty = true;
        });
        this._notify();
        return true;
    }
    /** return true if can fit in grid height constrain only (always true if no maxRow) */ willItFit(node) {
        delete node._willFitPos;
        if (!this.maxRow) return true;
        // create a clone with NO maxRow and check if still within size
        const clone = new $537db24912b4f7e1$export$c0882fbd3b4aaa0f({
            column: this.column,
            float: this.float,
            nodes: this.nodes.map((n)=>{
                return {
                    ...n
                };
            })
        });
        const n = {
            ...node
        }; // clone node so we don't mod any settings on it but have full autoPosition and min/max as well! #1687
        this.cleanupNode(n);
        delete n.el;
        delete n._id;
        delete n.content;
        delete n.grid;
        clone.addNode(n);
        if (clone.getRow() <= this.maxRow) {
            node._willFitPos = (0, $2wHnB.Utils).copyPos({}, n);
            return true;
        }
        return false;
    }
    /** true if x,y or w,h are different after clamping to min/max */ changedPosConstrain(node, p) {
        // first make sure w,h are set for caller
        p.w = p.w || node.w;
        p.h = p.h || node.h;
        if (node.x !== p.x || node.y !== p.y) return true;
        // check constrained w,h
        if (node.maxW) p.w = Math.min(p.w, node.maxW);
        if (node.maxH) p.h = Math.min(p.h, node.maxH);
        if (node.minW) p.w = Math.max(p.w, node.minW);
        if (node.minH) p.h = Math.max(p.h, node.minH);
        return node.w !== p.w || node.h !== p.h;
    }
    /** return true if the passed in node was actually moved (checks for no-op and locked) */ moveNode(node, o) {
        if (!node || /*node.locked ||*/ !o) return false;
        let wasUndefinedPack;
        if (o.pack === undefined && !this.batchMode) wasUndefinedPack = o.pack = true;
        // constrain the passed in values and check if we're still changing our node
        if (typeof o.x !== 'number') o.x = node.x;
        if (typeof o.y !== 'number') o.y = node.y;
        if (typeof o.w !== 'number') o.w = node.w;
        if (typeof o.h !== 'number') o.h = node.h;
        const resizing = node.w !== o.w || node.h !== o.h;
        const nn = (0, $2wHnB.Utils).copyPos({}, node, true); // get min/max out first, then opt positions next
        (0, $2wHnB.Utils).copyPos(nn, o);
        this.nodeBoundFix(nn, resizing);
        (0, $2wHnB.Utils).copyPos(o, nn);
        if (!o.forceCollide && (0, $2wHnB.Utils).samePos(node, o)) return false;
        const prevPos = (0, $2wHnB.Utils).copyPos({}, node);
        // check if we will need to fix collision at our new location
        const collides = this.collideAll(node, nn, o.skip);
        let needToMove = true;
        if (collides.length) {
            const activeDrag = node._moving && !o.nested;
            // check to make sure we actually collided over 50% surface area while dragging
            let collide = activeDrag ? this.directionCollideCoverage(node, o, collides) : collides[0];
            // if we're enabling creation of sub-grids on the fly, see if we're covering 80% of either one, if we didn't already do that
            if (activeDrag && collide && node.grid?.opts?.subGridDynamic && !node.grid._isTemp) {
                const over = (0, $2wHnB.Utils).areaIntercept(o.rect, collide._rect);
                const a1 = (0, $2wHnB.Utils).area(o.rect);
                const a2 = (0, $2wHnB.Utils).area(collide._rect);
                const perc = over / (a1 < a2 ? a1 : a2);
                if (perc > .8) {
                    collide.grid.makeSubGrid(collide.el, undefined, node);
                    collide = undefined;
                }
            }
            if (collide) needToMove = !this._fixCollisions(node, nn, collide, o); // check if already moved...
            else {
                needToMove = false; // we didn't cover >50% for a move, skip...
                if (wasUndefinedPack) delete o.pack;
            }
        }
        // now move (to the original ask vs the collision version which might differ) and repack things
        if (needToMove && !(0, $2wHnB.Utils).samePos(node, nn)) {
            node._dirty = true;
            (0, $2wHnB.Utils).copyPos(node, nn);
        }
        if (o.pack) this._packNodes()._notify();
        return !(0, $2wHnB.Utils).samePos(node, prevPos); // pack might have moved things back
    }
    getRow() {
        return this.nodes.reduce((row, n)=>Math.max(row, n.y + n.h), 0);
    }
    beginUpdate(node) {
        if (!node._updating) {
            node._updating = true;
            delete node._skipDown;
            if (!this.batchMode) this.saveInitial();
        }
        return this;
    }
    endUpdate() {
        const n = this.nodes.find((n)=>n._updating);
        if (n) {
            delete n._updating;
            delete n._skipDown;
        }
        return this;
    }
    /** saves a copy of the largest column layout (eg 12 even when rendering 1 column) so we don't loose orig layout, unless explicity column
     * count to use is given. returning a list of widgets for serialization
     * @param saveElement if true (default), the element will be saved to GridStackWidget.el field, else it will be removed.
     * @param saveCB callback for each node -> widget, so application can insert additional data to be saved into the widget data structure.
     * @param column if provided, the grid will be saved for the given column count (IFF we have matching internal saved layout, or current layout).
     * Note: nested grids will ALWAYS save the container w to match overall layouts (parent + child) to be consistent.
    */ save(saveElement = true, saveCB, column) {
        // use the highest layout for any saved info so we can have full detail on reload #1849
        // unless we're given a column to match (always set for nested grids)
        const len = this._layouts?.length || 0;
        let layout;
        if (len) {
            if (column) {
                if (column !== this.column) layout = this._layouts[column];
            } else if (this.column !== len - 1) layout = this._layouts[len - 1];
        }
        const list = [];
        this.sortNodes();
        this.nodes.forEach((n)=>{
            const wl = layout?.find((l)=>l._id === n._id);
            // use layout info fields instead if set
            const w = {
                ...n,
                ...wl || {}
            };
            (0, $2wHnB.Utils).removeInternalForSave(w, !saveElement);
            if (saveCB) saveCB(n, w);
            list.push(w);
        });
        return list;
    }
    /** @internal called whenever a node is added or moved - updates the cached layouts */ layoutsNodesChange(nodes) {
        if (!this._layouts || this._inColumnResize) return this;
        // remove smaller layouts - we will re-generate those on the fly... larger ones need to update
        this._layouts.forEach((layout, column)=>{
            if (!layout || column === this.column) return this;
            if (column < this.column) this._layouts[column] = undefined;
            else {
                // we save the original x,y,w (h isn't cached) to see what actually changed to propagate better.
                // NOTE: we don't need to check against out of bound scaling/moving as that will be done when using those cache values. #1785
                const ratio = column / this.column;
                nodes.forEach((node)=>{
                    if (!node._orig) return; // didn't change (newly added ?)
                    const n = layout.find((l)=>l._id === node._id);
                    if (!n) return; // no cache for new nodes. Will use those values.
                    // Y changed, push down same amount
                    // TODO: detect doing item 'swaps' will help instead of move (especially in 1 column mode)
                    if (n.y >= 0 && node.y !== node._orig.y) {
                        n.y += node.y - node._orig.y;
                        if (n.y < 0) n.y = 0;
                    }
                    // X changed, scale from new position
                    if (node.x !== node._orig.x) {
                        n.x = Math.round(node.x * ratio);
                        if (n.x < 0) n.x = 0;
                    }
                    // width changed, scale from new width
                    if (node.w !== node._orig.w) {
                        n.w = Math.round(node.w * ratio);
                        if (n.w < 1) n.w = 1;
                    }
                // ...height always carries over from cache
                });
            }
        });
        return this;
    }
    /**
     * @internal Called to scale the widget width & position up/down based on the column change.
     * Note we store previous layouts (especially original ones) to make it possible to go
     * from say 12 -> 1 -> 12 and get back to where we were.
     *
     * @param prevColumn previous number of columns
     * @param column  new column number
     * @param layout specify the type of re-layout that will happen (position, size, etc...).
     * Note: items will never be outside of the current column boundaries. default (moveScale). Ignored for 1 column
     */ columnChanged(prevColumn, column, layout = 'moveScale') {
        if (!this.nodes.length || !column || prevColumn === column) return this;
        // simpler shortcuts layouts
        const doCompact = layout === 'compact' || layout === 'list';
        if (doCompact) this.sortNodes(1); // sort with original layout once and only once (new column will affect order otherwise)
        // cache the current layout in case they want to go back (like 12 -> 1 -> 12) as it requires original data IFF we're sizing down (see below)
        if (column < prevColumn) this.cacheLayout(this.nodes, prevColumn);
        this.batchUpdate(); // do this EARLY as it will call saveInitial() so we can detect where we started for _dirty and collision
        let newNodes = [];
        let nodes = doCompact ? this.nodes : (0, $2wHnB.Utils).sort(this.nodes, -1); // current column reverse sorting so we can insert last to front (limit collision)
        // see if we have cached previous layout IFF we are going up in size (restore) otherwise always
        // generate next size down from where we are (looks more natural as you gradually size down).
        if (column > prevColumn && this._layouts) {
            const cacheNodes = this._layouts[column] || [];
            // ...if not, start with the largest layout (if not already there) as down-scaling is more accurate
            // by pretending we came from that larger column by assigning those values as starting point
            const lastIndex = this._layouts.length - 1;
            if (!cacheNodes.length && prevColumn !== lastIndex && this._layouts[lastIndex]?.length) {
                prevColumn = lastIndex;
                this._layouts[lastIndex].forEach((cacheNode)=>{
                    const n = nodes.find((n)=>n._id === cacheNode._id);
                    if (n) {
                        // still current, use cache info positions
                        if (!doCompact && !cacheNode.autoPosition) {
                            n.x = cacheNode.x ?? n.x;
                            n.y = cacheNode.y ?? n.y;
                        }
                        n.w = cacheNode.w ?? n.w;
                        if (cacheNode.x == undefined || cacheNode.y === undefined) n.autoPosition = true;
                    }
                });
            }
            // if we found cache re-use those nodes that are still current
            cacheNodes.forEach((cacheNode)=>{
                const j = nodes.findIndex((n)=>n._id === cacheNode._id);
                if (j !== -1) {
                    const n = nodes[j];
                    // still current, use cache info positions
                    if (doCompact) {
                        n.w = cacheNode.w; // only w is used, and don't trim the list
                        return;
                    }
                    if (cacheNode.autoPosition || isNaN(cacheNode.x) || isNaN(cacheNode.y)) this.findEmptyPosition(cacheNode, newNodes);
                    if (!cacheNode.autoPosition) {
                        n.x = cacheNode.x ?? n.x;
                        n.y = cacheNode.y ?? n.y;
                        n.w = cacheNode.w ?? n.w;
                        newNodes.push(n);
                    }
                    nodes.splice(j, 1);
                }
            });
        }
        // much simpler layout that just compacts
        if (doCompact) this.compact(layout, false);
        else {
            // ...and add any extra non-cached ones
            if (nodes.length) {
                if (typeof layout === 'function') layout(column, prevColumn, newNodes, nodes);
                else {
                    const ratio = doCompact || layout === 'none' ? 1 : column / prevColumn;
                    const move = layout === 'move' || layout === 'moveScale';
                    const scale = layout === 'scale' || layout === 'moveScale';
                    nodes.forEach((node)=>{
                        // NOTE: x + w could be outside of the grid, but addNode() below will handle that
                        node.x = column === 1 ? 0 : move ? Math.round(node.x * ratio) : Math.min(node.x, column - 1);
                        node.w = column === 1 || prevColumn === 1 ? 1 : scale ? Math.round(node.w * ratio) || 1 : Math.min(node.w, column);
                        newNodes.push(node);
                    });
                    nodes = [];
                }
            }
            // finally re-layout them in reverse order (to get correct placement)
            newNodes = (0, $2wHnB.Utils).sort(newNodes, -1);
            this._inColumnResize = true; // prevent cache update
            this.nodes = []; // pretend we have no nodes to start with (add() will use same structures) to simplify layout
            newNodes.forEach((node)=>{
                this.addNode(node, false); // 'false' for add event trigger
                delete node._orig; // make sure the commit doesn't try to restore things back to original
            });
        }
        this.nodes.forEach((n)=>delete n._orig); // clear _orig before batch=false so it doesn't handle float=true restore
        this.batchUpdate(false, !doCompact);
        delete this._inColumnResize;
        return this;
    }
    /**
     * call to cache the given layout internally to the given location so we can restore back when column changes size
     * @param nodes list of nodes
     * @param column corresponding column index to save it under
     * @param clear if true, will force other caches to be removed (default false)
     */ cacheLayout(nodes, column, clear = false) {
        const copy = [];
        nodes.forEach((n, i)=>{
            // make sure we have an id in case this is new layout, else re-use id already set
            if (n._id === undefined) {
                const existing = n.id ? this.nodes.find((n2)=>n2.id === n.id) : undefined; // find existing node using users id
                n._id = existing?._id ?? $537db24912b4f7e1$export$c0882fbd3b4aaa0f._idSeq++;
            }
            copy[i] = {
                x: n.x,
                y: n.y,
                w: n.w,
                _id: n._id
            }; // only thing we change is x,y,w and id to find it back
        });
        this._layouts = clear ? [] : this._layouts || []; // use array to find larger quick
        this._layouts[column] = copy;
        return this;
    }
    /**
     * call to cache the given node layout internally to the given location so we can restore back when column changes size
     * @param node single node to cache
     * @param column corresponding column index to save it under
     */ cacheOneLayout(n, column) {
        n._id = n._id ?? $537db24912b4f7e1$export$c0882fbd3b4aaa0f._idSeq++;
        const l = {
            x: n.x,
            y: n.y,
            w: n.w,
            _id: n._id
        };
        if (n.autoPosition || n.x === undefined) {
            delete l.x;
            delete l.y;
            if (n.autoPosition) l.autoPosition = true;
        }
        this._layouts = this._layouts || [];
        this._layouts[column] = this._layouts[column] || [];
        const index = this.findCacheLayout(n, column);
        if (index === -1) this._layouts[column].push(l);
        else this._layouts[column][index] = l;
        return this;
    }
    findCacheLayout(n, column) {
        return this._layouts?.[column]?.findIndex((l)=>l._id === n._id) ?? -1;
    }
    removeNodeFromLayoutCache(n) {
        if (!this._layouts) return;
        for(let i = 0; i < this._layouts.length; i++){
            const index = this.findCacheLayout(n, i);
            if (index !== -1) this._layouts[i].splice(index, 1);
        }
    }
    /** called to remove all internal values but the _id */ cleanupNode(node) {
        for(const prop in node)if (prop[0] === '_' && prop !== '_id') delete node[prop];
        return this;
    }
}
/** @internal unique global internal _id counter */ $537db24912b4f7e1$export$c0882fbd3b4aaa0f._idSeq = 0;

});
parcelRegister("2wHnB", function(module, exports) {

$parcel$export(module.exports, "Utils", () => $1d70383541c5f548$export$d2ca453b913dcdea);
/**
 * utils.ts 12.4.2
 * Copyright (c) 2021-2025 Alain Dumesny - see GridStack root license
 */ // /**
//  * Checks for obsolete method names and provides deprecation warnings.
//  * Creates a wrapper function that logs a deprecation warning when called.
//  *
//  * @param self the object context to apply the function to
//  * @param f the new function to call
//  * @param oldName the deprecated method name
//  * @param newName the new method name to use instead
//  * @param rev the version when the deprecation was introduced
//  * @returns a wrapper function that warns about deprecation
//  */
// eslint-disable-next-line
// export function obsolete(self, f, oldName: string, newName: string, rev: string): (...args: any[]) => any {
//   const wrapper = (...args) => {
//     console.warn('gridstack.js: Function `' + oldName + '` is deprecated in ' + rev + ' and has been replaced ' +
//     'with `' + newName + '`. It will be **removed** in a future release');
//     return f.apply(self, args);
//   }
//   wrapper.prototype = f.prototype;
//   return wrapper;
// }
// /**
//  * Checks for obsolete grid options and migrates them to new names.
//  * Automatically copies old option values to new option names and shows deprecation warnings.
//  *
//  * @param opts the options object to check and migrate
//  * @param oldName the deprecated option name
//  * @param newName the new option name to use instead
//  * @param rev the version when the deprecation was introduced
//  */
// export function obsoleteOpts(opts: GridStackOptions, oldName: string, newName: string, rev: string): void {
//   if (opts[oldName] !== undefined) {
//     opts[newName] = opts[oldName];
//     console.warn('gridstack.js: Option `' + oldName + '` is deprecated in ' + rev + ' and has been replaced with `' +
//       newName + '`. It will be **removed** in a future release');
//   }
// }
// /**
//  * Checks for obsolete grid options that have been completely removed.
//  * Shows deprecation warnings for options that are no longer supported.
//  *
//  * @param opts the options object to check
//  * @param oldName the removed option name
//  * @param rev the version when the option was removed
//  * @param info additional information about the removal
//  */
// export function obsoleteOptsDel(opts: GridStackOptions, oldName: string, rev: string, info: string): void {
//   if (opts[oldName] !== undefined) {
//     console.warn('gridstack.js: Option `' + oldName + '` is deprecated in ' + rev + info);
//   }
// }
// /**
//  * Checks for obsolete HTML element attributes and migrates them.
//  * Automatically copies old attribute values to new attribute names and shows deprecation warnings.
//  *
//  * @param el the HTML element to check and migrate
//  * @param oldName the deprecated attribute name
//  * @param newName the new attribute name to use instead
//  * @param rev the version when the deprecation was introduced
//  */
// export function obsoleteAttr(el: HTMLElement, oldName: string, newName: string, rev: string): void {
//   const oldAttr = el.getAttribute(oldName);
//   if (oldAttr !== null) {
//     el.setAttribute(newName, oldAttr);
//     console.warn('gridstack.js: attribute `' + oldName + '`=' + oldAttr + ' is deprecated on this object in ' + rev + ' and has been replaced with `' +
//       newName + '`. It will be **removed** in a future release');
//   }
// }
/**
 * Collection of utility methods used throughout GridStack.
 * These are general-purpose helper functions for DOM manipulation,
 * positioning calculations, object operations, and more.
 */ class $1d70383541c5f548$export$d2ca453b913dcdea {
    /**
     * Convert a potential selector into an actual list of HTML elements.
     * Supports CSS selectors, element references, and special ID handling.
     *
     * @param els selector string, HTMLElement, or array of elements
     * @param root optional root element to search within (defaults to document, useful for shadow DOM)
     * @returns array of HTML elements matching the selector
     *
     * @example
     * const elements = Utils.getElements('.grid-item');
     * const byId = Utils.getElements('#myWidget');
     * const fromShadow = Utils.getElements('.item', shadowRoot);
     */ static getElements(els, root = document) {
        if (typeof els === 'string') {
            const doc = 'getElementById' in root ? root : undefined;
            // Note: very common for people use to id='1,2,3' which is only legal as HTML5 id, but not CSS selectors
            // so if we start with a number, assume it's an id and just return that one item...
            // see https://github.com/gridstack/gridstack.js/issues/2234#issuecomment-1523796562
            if (doc && !isNaN(+els[0])) {
                const el = doc.getElementById(els);
                return el ? [
                    el
                ] : [];
            }
            let list = root.querySelectorAll(els);
            if (!list.length && els[0] !== '.' && els[0] !== '#') {
                // see if mean to be a class
                list = root.querySelectorAll('.' + els);
                // else if mean to be an id
                if (!list.length) list = root.querySelectorAll('#' + els);
                // else see if gs-id attribute
                if (!list.length) {
                    const el = root.querySelector(`[gs-id="${els}"]`);
                    return el ? [
                        el
                    ] : [];
                }
            }
            return Array.from(list);
        }
        return [
            els
        ];
    }
    /**
     * Convert a potential selector into a single HTML element.
     * Similar to getElements() but returns only the first match.
     *
     * @param els selector string or HTMLElement
     * @param root optional root element to search within (defaults to document)
     * @returns the first HTML element matching the selector, or null if not found
     *
     * @example
     * const element = Utils.getElement('#myWidget');
     * const first = Utils.getElement('.grid-item');
     */ static getElement(els, root = document) {
        if (typeof els === 'string') {
            const doc = 'getElementById' in root ? root : undefined;
            if (!els.length) return null;
            if (doc && els[0] === '#') return doc.getElementById(els.substring(1));
            if (els[0] === '#' || els[0] === '.' || els[0] === '[') return root.querySelector(els);
            // if we start with a digit, assume it's an id (error calling querySelector('#1')) as class are not valid CSS
            if (doc && !isNaN(+els[0])) return doc.getElementById(els);
            // finally try string, then id, then class
            let el = root.querySelector(els);
            if (doc && !el) el = doc.getElementById(els);
            if (!el) el = root.querySelector('.' + els);
            return el;
        }
        return els;
    }
    /**
     * Check if a widget should be lazy loaded based on node or grid settings.
     *
     * @param n the grid node to check
     * @returns true if the item should be lazy loaded
     *
     * @example
     * if (Utils.lazyLoad(node)) {
     *   // Set up intersection observer for lazy loading
     * }
     */ static lazyLoad(n) {
        return n.lazyLoad || n.grid?.opts?.lazyLoad && n.lazyLoad !== false;
    }
    /**
     * Create a div element with the specified CSS classes.
     *
     * @param classes array of CSS class names to add
     * @param parent optional parent element to append the div to
     * @returns the created div element
     *
     * @example
     * const div = Utils.createDiv(['grid-item', 'draggable']);
     * const nested = Utils.createDiv(['content'], parentDiv);
     */ static createDiv(classes, parent) {
        const el = document.createElement('div');
        classes.forEach((c)=>{
            if (c) el.classList.add(c);
        });
        parent?.appendChild(el);
        return el;
    }
    /**
     * Check if a widget should resize to fit its content.
     *
     * @param n the grid node to check (can be undefined)
     * @param strict if true, only returns true for explicit sizeToContent:true (not numbers)
     * @returns true if the widget should resize to content
     *
     * @example
     * if (Utils.shouldSizeToContent(node)) {
     *   // Trigger content-based resizing
     * }
     */ static shouldSizeToContent(n, strict = false) {
        return n?.grid && (strict ? n.sizeToContent === true || n.grid.opts.sizeToContent === true && n.sizeToContent === undefined : !!n.sizeToContent || n.grid.opts.sizeToContent && n.sizeToContent !== false);
    }
    /**
     * Check if two grid positions overlap/intersect.
     *
     * @param a first position with x, y, w, h properties
     * @param b second position with x, y, w, h properties
     * @returns true if the positions overlap
     *
     * @example
     * const overlaps = Utils.isIntercepted(
     *   {x: 0, y: 0, w: 2, h: 1},
     *   {x: 1, y: 0, w: 2, h: 1}
     * ); // true - they overlap
     */ static isIntercepted(a, b) {
        return !(a.y >= b.y + b.h || a.y + a.h <= b.y || a.x + a.w <= b.x || a.x >= b.x + b.w);
    }
    /**
     * Check if two grid positions are touching (edges or corners).
     *
     * @param a first position
     * @param b second position
     * @returns true if the positions are touching
     *
     * @example
     * const touching = Utils.isTouching(
     *   {x: 0, y: 0, w: 2, h: 1},
     *   {x: 2, y: 0, w: 1, h: 1}
     * ); // true - they share an edge
     */ static isTouching(a, b) {
        return $1d70383541c5f548$export$d2ca453b913dcdea.isIntercepted(a, {
            x: b.x - 0.5,
            y: b.y - 0.5,
            w: b.w + 1,
            h: b.h + 1
        });
    }
    /**
     * Calculate the overlapping area between two grid positions.
     *
     * @param a first position
     * @param b second position
     * @returns the area of overlap (0 if no overlap)
     *
     * @example
     * const overlap = Utils.areaIntercept(
     *   {x: 0, y: 0, w: 3, h: 2},
     *   {x: 1, y: 0, w: 3, h: 2}
     * ); // returns 4 (2x2 overlap)
     */ static areaIntercept(a, b) {
        const x0 = a.x > b.x ? a.x : b.x;
        const x1 = a.x + a.w < b.x + b.w ? a.x + a.w : b.x + b.w;
        if (x1 <= x0) return 0; // no overlap
        const y0 = a.y > b.y ? a.y : b.y;
        const y1 = a.y + a.h < b.y + b.h ? a.y + a.h : b.y + b.h;
        if (y1 <= y0) return 0; // no overlap
        return (x1 - x0) * (y1 - y0);
    }
    /**
     * Calculate the total area of a grid position.
     *
     * @param a position with width and height
     * @returns the total area (width * height)
     *
     * @example
     * const area = Utils.area({x: 0, y: 0, w: 3, h: 2}); // returns 6
     */ static area(a) {
        return a.w * a.h;
    }
    /**
     * Sort an array of grid nodes by position (y first, then x).
     *
     * @param nodes array of nodes to sort
     * @param dir sort direction: 1 for ascending (top-left first), -1 for descending
     * @returns the sorted array (modifies original)
     *
     * @example
     * const sorted = Utils.sort(nodes); // Sort top-left to bottom-right
     * const reverse = Utils.sort(nodes, -1); // Sort bottom-right to top-left
     */ static sort(nodes, dir = 1) {
        const und = 10000;
        return nodes.sort((a, b)=>{
            const diffY = dir * ((a.y ?? und) - (b.y ?? und));
            if (diffY === 0) return dir * ((a.x ?? und) - (b.x ?? und));
            return diffY;
        });
    }
    /**
     * Find a grid node by its ID.
     *
     * @param nodes array of nodes to search
     * @param id the ID to search for
     * @returns the node with matching ID, or undefined if not found
     *
     * @example
     * const node = Utils.find(nodes, 'widget-1');
     * if (node) console.log('Found node at:', node.x, node.y);
     */ static find(nodes, id) {
        return id ? nodes.find((n)=>n.id === id) : undefined;
    }
    /**
     * Convert various value types to boolean.
     * Handles strings like 'false', 'no', '0' as false.
     *
     * @param v value to convert
     * @returns boolean representation
     *
     * @example
     * Utils.toBool('true');  // true
     * Utils.toBool('false'); // false
     * Utils.toBool('no');    // false
     * Utils.toBool('1');     // true
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static toBool(v) {
        if (typeof v === 'boolean') return v;
        if (typeof v === 'string') {
            v = v.toLowerCase();
            return !(v === '' || v === 'no' || v === 'false' || v === '0');
        }
        return Boolean(v);
    }
    /**
     * Convert a string value to a number, handling null and empty strings.
     *
     * @param value string or null value to convert
     * @returns number value, or undefined for null/empty strings
     *
     * @example
     * Utils.toNumber('42');  // 42
     * Utils.toNumber('');    // undefined
     * Utils.toNumber(null);  // undefined
     */ static toNumber(value) {
        return value === null || value.length === 0 ? undefined : Number(value);
    }
    /**
     * Parse a height value with units into numeric value and unit string.
     * Supports px, em, rem, vh, vw, %, cm, mm units.
     *
     * @param val height value as number or string with units
     * @returns object with h (height) and unit properties
     *
     * @example
     * Utils.parseHeight('100px');  // {h: 100, unit: 'px'}
     * Utils.parseHeight('2rem');   // {h: 2, unit: 'rem'}
     * Utils.parseHeight(50);       // {h: 50, unit: 'px'}
     */ static parseHeight(val) {
        let h;
        let unit = 'px';
        if (typeof val === 'string') {
            if (val === 'auto' || val === '') h = 0;
            else {
                const match = val.match(/^(-[0-9]+\.[0-9]+|[0-9]*\.[0-9]+|-[0-9]+|[0-9]+)(px|em|rem|vh|vw|%|cm|mm)?$/);
                if (!match) throw new Error(`Invalid height val = ${val}`);
                unit = match[2] || 'px';
                h = parseFloat(match[1]);
            }
        } else h = val;
        return {
            h: h,
            unit: unit
        };
    }
    /**
     * Copy unset fields from source objects to target object (shallow merge with defaults).
     * Similar to Object.assign but only sets undefined/null fields.
     *
     * @param target the object to copy defaults into
     * @param sources one or more source objects to copy defaults from
     * @returns the modified target object
     *
     * @example
     * const config = { width: 100 };
     * Utils.defaults(config, { width: 200, height: 50 });
     * // config is now { width: 100, height: 50 }
     */ // eslint-disable-next-line
    static defaults(target, ...sources) {
        sources.forEach((source)=>{
            for(const key in source){
                if (!source.hasOwnProperty(key)) return;
                if (target[key] === null || target[key] === undefined) target[key] = source[key];
                else if (typeof source[key] === 'object' && typeof target[key] === 'object') // property is an object, recursively add it's field over... #1373
                $1d70383541c5f548$export$d2ca453b913dcdea.defaults(target[key], source[key]);
            }
        });
        return target;
    }
    /**
     * Compare two objects for equality (shallow comparison).
     * Checks if objects have the same fields and values at one level deep.
     *
     * @param a first object to compare
     * @param b second object to compare
     * @returns true if objects have the same values
     *
     * @example
     * Utils.same({x: 1, y: 2}, {x: 1, y: 2}); // true
     * Utils.same({x: 1}, {x: 1, y: 2}); // false
     */ static same(a, b) {
        if (typeof a !== 'object') return a == b;
        if (typeof a !== typeof b) return false;
        // else we have object, check just 1 level deep for being same things...
        if (Object.keys(a).length !== Object.keys(b).length) return false;
        for(const key in a){
            if (a[key] !== b[key]) return false;
        }
        return true;
    }
    /**
     * Copy position and size properties from one widget to another.
     * Copies x, y, w, h and optionally min/max constraints.
     *
     * @param a target widget to copy to
     * @param b source widget to copy from
     * @param doMinMax if true, also copy min/max width/height constraints
     * @returns the target widget (a)
     *
     * @example
     * Utils.copyPos(widget1, widget2); // Copy position/size
     * Utils.copyPos(widget1, widget2, true); // Also copy constraints
     */ static copyPos(a, b, doMinMax = false) {
        if (b.x !== undefined) a.x = b.x;
        if (b.y !== undefined) a.y = b.y;
        if (b.w !== undefined) a.w = b.w;
        if (b.h !== undefined) a.h = b.h;
        if (doMinMax) {
            if (b.minW) a.minW = b.minW;
            if (b.minH) a.minH = b.minH;
            if (b.maxW) a.maxW = b.maxW;
            if (b.maxH) a.maxH = b.maxH;
        }
        return a;
    }
    /** true if a and b has same size & position */ static samePos(a, b) {
        return a && b && a.x === b.x && a.y === b.y && (a.w || 1) === (b.w || 1) && (a.h || 1) === (b.h || 1);
    }
    /** given a node, makes sure it's min/max are valid */ static sanitizeMinMax(node) {
        // remove 0, undefine, null
        if (!node.minW) delete node.minW;
        if (!node.minH) delete node.minH;
        if (!node.maxW) delete node.maxW;
        if (!node.maxH) delete node.maxH;
    }
    /** removes field from the first object if same as the second objects (like diffing) and internal '_' for saving */ static removeInternalAndSame(a, b) {
        if (typeof a !== 'object' || typeof b !== 'object') return;
        // skip arrays as we don't know how to hydrate them (unlike object spread operator)
        if (Array.isArray(a) || Array.isArray(b)) return;
        for(let key in a){
            const aVal = a[key];
            const bVal = b[key];
            if (key[0] === '_' || aVal === bVal) delete a[key];
            else if (aVal && typeof aVal === 'object' && bVal !== undefined) {
                $1d70383541c5f548$export$d2ca453b913dcdea.removeInternalAndSame(aVal, bVal);
                if (!Object.keys(aVal).length) delete a[key];
            }
        }
    }
    /** removes internal fields '_' and default values for saving */ static removeInternalForSave(n, removeEl = true) {
        for(let key in n)if (key[0] === '_' || n[key] === null || n[key] === undefined) delete n[key];
        delete n.grid;
        if (removeEl) delete n.el;
        // delete default values (will be re-created on read)
        if (!n.autoPosition) delete n.autoPosition;
        if (!n.noResize) delete n.noResize;
        if (!n.noMove) delete n.noMove;
        if (!n.locked) delete n.locked;
        if (n.w === 1 || n.w === n.minW) delete n.w;
        if (n.h === 1 || n.h === n.minH) delete n.h;
    }
    /** return the closest parent (or itself) matching the given class */ // static closestUpByClass(el: HTMLElement, name: string): HTMLElement {
    //   while (el) {
    //     if (el.classList.contains(name)) return el;
    //     el = el.parentElement
    //   }
    //   return null;
    // }
    /** delay calling the given function for given delay, preventing new calls from happening while waiting */ static throttle(func, delay) {
        let isWaiting = false;
        return (...args)=>{
            if (!isWaiting) {
                isWaiting = true;
                setTimeout(()=>{
                    func(...args);
                    isWaiting = false;
                }, delay);
            }
        };
    }
    static removePositioningStyles(el) {
        const style = el.style;
        if (style.position) style.removeProperty('position');
        if (style.left) style.removeProperty('left');
        if (style.top) style.removeProperty('top');
        if (style.width) style.removeProperty('width');
        if (style.height) style.removeProperty('height');
    }
    /** @internal returns the passed element if scrollable, else the closest parent that will, up to the entire document scrolling element */ static getScrollElement(el) {
        if (!el) return document.scrollingElement || document.documentElement; // IE support
        const style = getComputedStyle(el);
        const overflowRegex = /(auto|scroll)/;
        if (overflowRegex.test(style.overflow + style.overflowY)) return el;
        else return $1d70383541c5f548$export$d2ca453b913dcdea.getScrollElement(el.parentElement);
    }
    /** @internal */ static updateScrollPosition(el, position, distance) {
        const scrollEl = $1d70383541c5f548$export$d2ca453b913dcdea.getScrollElement(el);
        if (!scrollEl) return;
        const elRect = el.getBoundingClientRect();
        const scrollRect = scrollEl.getBoundingClientRect();
        const innerHeightOrClientHeight = window.innerHeight || document.documentElement.clientHeight;
        const offsetDiffDown = elRect.bottom - Math.min(scrollRect.bottom, innerHeightOrClientHeight);
        const offsetDiffUp = elRect.top - Math.max(scrollRect.top, 0);
        const prevScroll = scrollEl.scrollTop;
        if (offsetDiffUp < 0 && distance < 0) {
            // scroll up
            if (el.offsetHeight > scrollRect.height) scrollEl.scrollTop += distance;
            else scrollEl.scrollTop += Math.abs(offsetDiffUp) > Math.abs(distance) ? distance : offsetDiffUp;
        } else if (offsetDiffDown > 0 && distance > 0) {
            // scroll down
            if (el.offsetHeight > scrollRect.height) scrollEl.scrollTop += distance;
            else scrollEl.scrollTop += offsetDiffDown > distance ? distance : offsetDiffDown;
        }
        position.top += scrollEl.scrollTop - prevScroll;
    }
    /**
     * @internal Function used to scroll the page.
     *
     * @param event `MouseEvent` that triggers the resize
     * @param el `HTMLElement` that's being resized
     * @param distance Distance from the V edges to start scrolling
     */ static updateScrollResize(event, el, distance) {
        const scrollEl = $1d70383541c5f548$export$d2ca453b913dcdea.getScrollElement(el);
        const height = scrollEl.clientHeight;
        // #1727 event.clientY is relative to viewport, so must compare this against position of scrollEl getBoundingClientRect().top
        // #1745 Special situation if scrollEl is document 'html': here browser spec states that
        // clientHeight is height of viewport, but getBoundingClientRect() is rectangle of html element;
        // this discrepancy arises because in reality scrollbar is attached to viewport, not html element itself.
        const offsetTop = scrollEl === $1d70383541c5f548$export$d2ca453b913dcdea.getScrollElement() ? 0 : scrollEl.getBoundingClientRect().top;
        const pointerPosY = event.clientY - offsetTop;
        const top = pointerPosY < distance;
        const bottom = pointerPosY > height - distance;
        if (top) // This also can be done with a timeout to keep scrolling while the mouse is
        // in the scrolling zone. (will have smoother behavior)
        scrollEl.scrollBy({
            behavior: 'smooth',
            top: pointerPosY - distance
        });
        else if (bottom) scrollEl.scrollBy({
            behavior: 'smooth',
            top: distance - (height - pointerPosY)
        });
    }
    /** single level clone, returning a new object with same top fields. This will share sub objects and arrays */ static clone(obj) {
        if (obj === null || obj === undefined || typeof obj !== 'object') return obj;
        // return Object.assign({}, obj);
        if (obj instanceof Array) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return [
            ...obj
        ];
        return {
            ...obj
        };
    }
    /**
     * Recursive clone version that returns a full copy, checking for nested objects and arrays ONLY.
     * Note: this will use as-is any key starting with double __ (and not copy inside) some lib have circular dependencies.
     */ static cloneDeep(obj) {
        // list of fields we will skip during cloneDeep (nested objects, other internal)
        const skipFields = [
            'parentGrid',
            'el',
            'grid',
            'subGrid',
            'engine'
        ];
        // return JSON.parse(JSON.stringify(obj)); // doesn't work with date format ?
        const ret = $1d70383541c5f548$export$d2ca453b913dcdea.clone(obj);
        for(const key in ret)// NOTE: we don't support function/circular dependencies so skip those properties for now...
        if (ret.hasOwnProperty(key) && typeof ret[key] === 'object' && key.substring(0, 2) !== '__' && !skipFields.find((k)=>k === key)) ret[key] = $1d70383541c5f548$export$d2ca453b913dcdea.cloneDeep(obj[key]);
        return ret;
    }
    /** deep clone the given HTML node, removing teh unique id field */ static cloneNode(el) {
        const node = el.cloneNode(true);
        node.removeAttribute('id');
        return node;
    }
    static appendTo(el, parent) {
        let parentNode;
        if (typeof parent === 'string') parentNode = $1d70383541c5f548$export$d2ca453b913dcdea.getElement(parent);
        else parentNode = parent;
        if (parentNode) parentNode.appendChild(el);
    }
    // public static setPositionRelative(el: HTMLElement): void {
    //   if (!(/^(?:r|a|f)/).test(getComputedStyle(el).position)) {
    //     el.style.position = "relative";
    //   }
    // }
    static addElStyles(el, styles) {
        if (styles instanceof Object) {
            for(const s in styles)if (styles.hasOwnProperty(s)) {
                if (Array.isArray(styles[s])) // support fallback value
                styles[s].forEach((val)=>{
                    el.style[s] = val;
                });
                else el.style[s] = styles[s];
            }
        }
    }
    static initEvent(e, info) {
        const evt = {
            type: info.type
        };
        const obj = {
            button: 0,
            which: 0,
            buttons: 1,
            bubbles: true,
            cancelable: true,
            target: info.target ? info.target : e.target
        };
        [
            'altKey',
            'ctrlKey',
            'metaKey',
            'shiftKey'
        ].forEach((p)=>evt[p] = e[p]); // keys
        [
            'pageX',
            'pageY',
            'clientX',
            'clientY',
            'screenX',
            'screenY'
        ].forEach((p)=>evt[p] = e[p]); // point info
        return {
            ...evt,
            ...obj
        };
    }
    /** copies the MouseEvent (or convert Touch) properties and sends it as another event to the given target */ static simulateMouseEvent(e, simulatedType, target) {
        const me = e;
        const simulatedEvent = new MouseEvent(simulatedType, {
            bubbles: true,
            composed: true,
            cancelable: true,
            view: window,
            detail: 1,
            screenX: e.screenX,
            screenY: e.screenY,
            clientX: e.clientX,
            clientY: e.clientY,
            ctrlKey: me.ctrlKey ?? false,
            altKey: me.altKey ?? false,
            shiftKey: me.shiftKey ?? false,
            metaKey: me.metaKey ?? false,
            button: 0,
            relatedTarget: e.target
        });
        (target || e.target).dispatchEvent(simulatedEvent);
    }
    /**
     * defines an element that is used to get the offset and scale from grid transforms
     * returns the scale and offsets from said element
    */ static getValuesFromTransformedElement(parent) {
        const transformReference = document.createElement('div');
        $1d70383541c5f548$export$d2ca453b913dcdea.addElStyles(transformReference, {
            opacity: '0',
            position: 'fixed',
            top: "0px",
            left: "0px",
            width: '1px',
            height: '1px',
            zIndex: '-999999'
        });
        parent.appendChild(transformReference);
        const transformValues = transformReference.getBoundingClientRect();
        parent.removeChild(transformReference);
        transformReference.remove();
        return {
            xScale: 1 / transformValues.width,
            yScale: 1 / transformValues.height,
            xOffset: transformValues.left,
            yOffset: transformValues.top
        };
    }
    /** swap the given object 2 field values */ static swap(o, a, b) {
        if (!o) return;
        const tmp = o[a];
        o[a] = o[b];
        o[b] = tmp;
    }
    /** returns true if event is inside the given element rectangle */ // Note: Safari Mac has null event.relatedTarget which causes #1684 so check if DragEvent is inside the coordinates instead
    //    Utils.el.contains(event.relatedTarget as HTMLElement)
    // public static inside(e: MouseEvent, el: HTMLElement): boolean {
    //   // srcElement, toElement, target: all set to placeholder when leaving simple grid, so we can't use that (Chrome)
    //   const target: HTMLElement = e.relatedTarget || (e as any).fromElement;
    //   if (!target) {
    //     const { bottom, left, right, top } = el.getBoundingClientRect();
    //     return (e.x < right && e.x > left && e.y < bottom && e.y > top);
    //   }
    //   return el.contains(target);
    // }
    /** true if the item can be rotated (checking for prop, not space available) */ static canBeRotated(n) {
        return !(!n || n.w === n.h || n.locked || n.noResize || n.grid?.opts.disableResize || n.minW && n.minW === n.maxW || n.minH && n.minH === n.maxH);
    }
}

});


parcelRegister("9oh67", function(module, exports) {

$parcel$export(module.exports, "gridDefaults", () => $6d639e358c232638$export$598200e4a2a2021);
/**
 * types.ts 12.4.2
 * Copyright (c) 2021-2025 Alain Dumesny - see GridStack root license
 */ /**
 * Default values for grid options - used during initialization and when saving out grid configuration.
 * These values are applied when options are not explicitly provided.
 */ const $6d639e358c232638$export$598200e4a2a2021 = {
    alwaysShowResizeHandle: 'mobile',
    animate: true,
    auto: true,
    cellHeight: 'auto',
    cellHeightThrottle: 100,
    cellHeightUnit: 'px',
    column: 12,
    draggable: {
        handle: '.grid-stack-item-content',
        appendTo: 'body',
        scroll: true
    },
    handle: '.grid-stack-item-content',
    itemClass: 'grid-stack-item',
    margin: 10,
    marginUnit: 'px',
    maxRow: 0,
    minRow: 0,
    placeholderClass: 'grid-stack-placeholder',
    placeholderText: '',
    removableOptions: {
        accept: 'grid-stack-item',
        decline: 'grid-stack-non-removable'
    },
    resizable: {
        handles: 'se'
    },
    rtl: 'auto'
};

});

parcelRegister("aXmGc", function(module, exports) {

$parcel$export(module.exports, "DDGridStack", () => $7fa101c2912790dd$export$4b78f443e2596246);
/**
 * dd-gridstack.ts 12.4.2
 * Copyright (c) 2021-2025 Alain Dumesny - see GridStack root license
 */ 
var $2wHnB = parcelRequire("2wHnB");

var $8OXYl = parcelRequire("8OXYl");

var $9nvPp = parcelRequire("9nvPp");
class $7fa101c2912790dd$export$4b78f443e2596246 {
    /**
     * Enable/disable/configure resizing for grid elements.
     *
     * @param el - Grid item element(s) to configure
     * @param opts - Resize options or command ('enable', 'disable', 'destroy', 'option', or config object)
     * @param key - Option key when using 'option' command
     * @param value - Option value when using 'option' command
     * @returns this instance for chaining
     *
     * @example
     * dd.resizable(element, 'enable');  // Enable resizing
     * dd.resizable(element, 'option', 'minWidth', 100);  // Set minimum width
     */ resizable(el, opts, key, value) {
        this._getDDElements(el, opts).forEach((dEl)=>{
            if (opts === 'disable' || opts === 'enable') dEl.ddResizable && dEl.ddResizable[opts](); // can't create DD as it requires options for setupResizable()
            else if (opts === 'destroy') dEl.ddResizable && dEl.cleanResizable();
            else if (opts === 'option') dEl.setupResizable({
                [key]: value
            });
            else {
                const n = dEl.el.gridstackNode;
                const grid = n.grid;
                let handles = dEl.el.getAttribute('gs-resize-handles') || grid.opts.resizable.handles || 'e,s,se';
                if (handles === 'all') handles = 'n,e,s,w,se,sw,ne,nw';
                // NOTE: keep the resize handles as e,w don't have enough space (10px) to show resize corners anyway. limit during drag instead
                // restrict vertical resize if height is done to match content anyway... odd to have it spring back
                // if (Utils.shouldSizeToContent(n, true)) {
                //   const doE = handles.indexOf('e') !== -1;
                //   const doW = handles.indexOf('w') !== -1;
                //   handles = doE ? (doW ? 'e,w' : 'e') : (doW ? 'w' : '');
                // }
                const autoHide = !grid.opts.alwaysShowResizeHandle;
                dEl.setupResizable({
                    ...grid.opts.resizable,
                    handles: handles,
                    autoHide: autoHide,
                    start: opts.start,
                    stop: opts.stop,
                    resize: opts.resize
                });
            }
        });
        return this;
    }
    /**
     * Enable/disable/configure dragging for grid elements.
     *
     * @param el - Grid item element(s) to configure
     * @param opts - Drag options or command ('enable', 'disable', 'destroy', 'option', or config object)
     * @param key - Option key when using 'option' command
     * @param value - Option value when using 'option' command
     * @returns this instance for chaining
     *
     * @example
     * dd.draggable(element, 'enable');  // Enable dragging
     * dd.draggable(element, {handle: '.drag-handle'});  // Configure drag handle
     */ draggable(el, opts, key, value) {
        this._getDDElements(el, opts).forEach((dEl)=>{
            if (opts === 'disable' || opts === 'enable') dEl.ddDraggable && dEl.ddDraggable[opts](); // can't create DD as it requires options for setupDraggable()
            else if (opts === 'destroy') dEl.ddDraggable && dEl.cleanDraggable();
            else if (opts === 'option') dEl.setupDraggable({
                [key]: value
            });
            else {
                const grid = dEl.el.gridstackNode.grid;
                dEl.setupDraggable({
                    ...grid.opts.draggable,
                    // containment: (grid.parentGridNode && grid.opts.dragOut === false) ? grid.el.parentElement : (grid.opts.draggable.containment || null),
                    start: opts.start,
                    stop: opts.stop,
                    drag: opts.drag
                });
            }
        });
        return this;
    }
    dragIn(el, opts) {
        this._getDDElements(el).forEach((dEl)=>dEl.setupDraggable(opts));
        return this;
    }
    droppable(el, opts, key, value) {
        if (typeof opts.accept === 'function' && !opts._accept) {
            opts._accept = opts.accept;
            opts.accept = (el)=>opts._accept(el);
        }
        this._getDDElements(el, opts).forEach((dEl)=>{
            if (opts === 'disable' || opts === 'enable') dEl.ddDroppable && dEl.ddDroppable[opts]();
            else if (opts === 'destroy') dEl.ddDroppable && dEl.cleanDroppable();
            else if (opts === 'option') dEl.setupDroppable({
                [key]: value
            });
            else dEl.setupDroppable(opts);
        });
        return this;
    }
    /** true if element is droppable */ isDroppable(el) {
        return !!(el?.ddElement?.ddDroppable && !el.ddElement.ddDroppable.disabled);
    }
    /** true if element is draggable */ isDraggable(el) {
        return !!(el?.ddElement?.ddDraggable && !el.ddElement.ddDraggable.disabled);
    }
    /** true if element is draggable */ isResizable(el) {
        return !!(el?.ddElement?.ddResizable && !el.ddElement.ddResizable.disabled);
    }
    on(el, name, callback) {
        this._getDDElements(el).forEach((dEl)=>dEl.on(name, (event)=>{
                callback(event, (0, $8OXYl.DDManager).dragElement ? (0, $8OXYl.DDManager).dragElement.el : event.target, (0, $8OXYl.DDManager).dragElement ? (0, $8OXYl.DDManager).dragElement.helper : null);
            }));
        return this;
    }
    off(el, name) {
        this._getDDElements(el).forEach((dEl)=>dEl.off(name));
        return this;
    }
    /** @internal returns a list of DD elements, creating them on the fly by default unless option is to destroy or disable */ _getDDElements(els, opts) {
        // don't force create if we're going to destroy it, unless it's a grid which is used as drop target for it's children
        const create = els.gridstack || opts !== 'destroy' && opts !== 'disable';
        const hosts = (0, $2wHnB.Utils).getElements(els);
        if (!hosts.length) return [];
        const list = hosts.map((e)=>e.ddElement || (create ? (0, $9nvPp.DDElement).init(e) : null)).filter((d)=>d); // remove nulls
        return list;
    }
}

});
parcelRegister("8OXYl", function(module, exports) {

$parcel$export(module.exports, "DDManager", () => $66c1837e85445cf1$export$ec9fb03c7081ea89);
/**
 * dd-manager.ts 12.4.2
 * Copyright (c) 2021-2025 Alain Dumesny - see GridStack root license
 */ /**
 * Global state manager for all Drag & Drop instances.
 *
 * This class maintains shared state across all drag & drop operations,
 * ensuring proper coordination between multiple grids and drag/drop elements.
 * All properties are static to provide global access throughout the DD system.
 */ class $66c1837e85445cf1$export$ec9fb03c7081ea89 {
}

});

parcelRegister("9nvPp", function(module, exports) {

$parcel$export(module.exports, "DDElement", () => $6d3ef378470a38d4$export$58cab262e087f5c7);
/**
 * dd-elements.ts 12.4.2
 * Copyright (c) 2021-2025 Alain Dumesny - see GridStack root license
 */ 
var $2aRd2 = parcelRequire("2aRd2");

var $1ozke = parcelRequire("1ozke");

var $6fHe9 = parcelRequire("6fHe9");
class $6d3ef378470a38d4$export$58cab262e087f5c7 {
    static init(el) {
        if (!el.ddElement) el.ddElement = new $6d3ef378470a38d4$export$58cab262e087f5c7(el);
        return el.ddElement;
    }
    constructor(el){
        this.el = el;
    }
    on(eventName, callback) {
        if (this.ddDraggable && [
            'drag',
            'dragstart',
            'dragstop'
        ].indexOf(eventName) > -1) this.ddDraggable.on(eventName, callback);
        else if (this.ddDroppable && [
            'drop',
            'dropover',
            'dropout'
        ].indexOf(eventName) > -1) this.ddDroppable.on(eventName, callback);
        else if (this.ddResizable && [
            'resizestart',
            'resize',
            'resizestop'
        ].indexOf(eventName) > -1) this.ddResizable.on(eventName, callback);
        return this;
    }
    off(eventName) {
        if (this.ddDraggable && [
            'drag',
            'dragstart',
            'dragstop'
        ].indexOf(eventName) > -1) this.ddDraggable.off(eventName);
        else if (this.ddDroppable && [
            'drop',
            'dropover',
            'dropout'
        ].indexOf(eventName) > -1) this.ddDroppable.off(eventName);
        else if (this.ddResizable && [
            'resizestart',
            'resize',
            'resizestop'
        ].indexOf(eventName) > -1) this.ddResizable.off(eventName);
        return this;
    }
    setupDraggable(opts) {
        if (!this.ddDraggable) this.ddDraggable = new (0, $1ozke.DDDraggable)(this.el, opts);
        else this.ddDraggable.updateOption(opts);
        return this;
    }
    cleanDraggable() {
        if (this.ddDraggable) {
            this.ddDraggable.destroy();
            delete this.ddDraggable;
        }
        return this;
    }
    setupResizable(opts) {
        if (!this.ddResizable) this.ddResizable = new (0, $2aRd2.DDResizable)(this.el, opts);
        else this.ddResizable.updateOption(opts);
        return this;
    }
    cleanResizable() {
        if (this.ddResizable) {
            this.ddResizable.destroy();
            delete this.ddResizable;
        }
        return this;
    }
    setupDroppable(opts) {
        if (!this.ddDroppable) this.ddDroppable = new (0, $6fHe9.DDDroppable)(this.el, opts);
        else this.ddDroppable.updateOption(opts);
        return this;
    }
    cleanDroppable() {
        if (this.ddDroppable) {
            this.ddDroppable.destroy();
            delete this.ddDroppable;
        }
        return this;
    }
}

});
parcelRegister("2aRd2", function(module, exports) {

$parcel$export(module.exports, "DDResizable", () => $1955ca3220440835$export$164b6dff86382acc);
/**
 * dd-resizable.ts 12.4.2
 * Copyright (c) 2021-2025  Alain Dumesny - see GridStack root license
 */ 
var $eeEhl = parcelRequire("eeEhl");

var $cT03x = parcelRequire("cT03x");

var $2wHnB = parcelRequire("2wHnB");

var $8OXYl = parcelRequire("8OXYl");
class $1955ca3220440835$export$164b6dff86382acc extends (0, $cT03x.DDBaseImplement) {
    // have to be public else complains for HTMLElementExtendOpt ?
    constructor(el, option = {}){
        super();
        this.el = el;
        this.option = option;
        /** @internal */ this.rectScale = {
            x: 1,
            y: 1
        };
        /** @internal */ this._ui = ()=>{
            const containmentEl = this.el.parentElement;
            const containmentRect = containmentEl.getBoundingClientRect();
            const newRect = {
                width: this.originalRect.width,
                height: this.originalRect.height + this.scrolled,
                left: this.originalRect.left,
                top: this.originalRect.top - this.scrolled
            };
            const rect = this.temporalRect || newRect;
            return {
                position: {
                    left: (rect.left - containmentRect.left) * this.rectScale.x,
                    top: (rect.top - containmentRect.top) * this.rectScale.y
                },
                size: {
                    width: rect.width * this.rectScale.x,
                    height: rect.height * this.rectScale.y
                }
            };
        };
        // create var event binding so we can easily remove and still look like TS methods (unlike anonymous functions)
        this._mouseOver = this._mouseOver.bind(this);
        this._mouseOut = this._mouseOut.bind(this);
        this.enable();
        this._setupAutoHide(this.option.autoHide);
        this._setupHandlers();
    }
    on(event, callback) {
        super.on(event, callback);
    }
    off(event) {
        super.off(event);
    }
    enable() {
        super.enable();
        this.el.classList.remove('ui-resizable-disabled');
        this._setupAutoHide(this.option.autoHide);
    }
    disable() {
        super.disable();
        this.el.classList.add('ui-resizable-disabled');
        this._setupAutoHide(false);
    }
    destroy() {
        this._removeHandlers();
        this._setupAutoHide(false);
        delete this.el;
        super.destroy();
    }
    updateOption(opts) {
        const updateHandles = opts.handles && opts.handles !== this.option.handles;
        const updateAutoHide = opts.autoHide && opts.autoHide !== this.option.autoHide;
        Object.keys(opts).forEach((key)=>this.option[key] = opts[key]);
        if (updateHandles) {
            this._removeHandlers();
            this._setupHandlers();
        }
        if (updateAutoHide) this._setupAutoHide(this.option.autoHide);
        return this;
    }
    /** @internal turns auto hide on/off */ _setupAutoHide(auto) {
        if (auto) {
            this.el.classList.add('ui-resizable-autohide');
            // use mouseover and not mouseenter to get better performance and track for nested cases
            this.el.addEventListener('mouseover', this._mouseOver);
            this.el.addEventListener('mouseout', this._mouseOut);
        } else {
            this.el.classList.remove('ui-resizable-autohide');
            this.el.removeEventListener('mouseover', this._mouseOver);
            this.el.removeEventListener('mouseout', this._mouseOut);
            if ((0, $8OXYl.DDManager).overResizeElement === this) delete (0, $8OXYl.DDManager).overResizeElement;
        }
        return this;
    }
    /** @internal */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _mouseOver(e) {
        // console.log(`${count++} pre-enter ${(this.el as GridItemHTMLElement).gridstackNode._id}`)
        // already over a child, ignore. Ideally we just call e.stopPropagation() but see https://github.com/gridstack/gridstack.js/issues/2018
        if ((0, $8OXYl.DDManager).overResizeElement || (0, $8OXYl.DDManager).dragElement) return;
        (0, $8OXYl.DDManager).overResizeElement = this;
        // console.log(`${count++} enter ${(this.el as GridItemHTMLElement).gridstackNode._id}`)
        this.el.classList.remove('ui-resizable-autohide');
    }
    /** @internal */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _mouseOut(e) {
        // console.log(`${count++} pre-leave ${(this.el as GridItemHTMLElement).gridstackNode._id}`)
        if ((0, $8OXYl.DDManager).overResizeElement !== this) return;
        delete (0, $8OXYl.DDManager).overResizeElement;
        // console.log(`${count++} leave ${(this.el as GridItemHTMLElement).gridstackNode._id}`)
        this.el.classList.add('ui-resizable-autohide');
    }
    /** @internal */ _setupHandlers() {
        this.handlers = this.option.handles.split(',').map((dir)=>dir.trim()).map((dir)=>new (0, $eeEhl.DDResizableHandle)(this.el, dir, {
                element: this.option.element,
                start: (event)=>this._resizeStart(event),
                stop: (event)=>this._resizeStop(event),
                move: (event)=>this._resizing(event, dir)
            }));
        return this;
    }
    /** @internal */ _resizeStart(event) {
        this.sizeToContent = (0, $2wHnB.Utils).shouldSizeToContent(this.el.gridstackNode, true); // strick true only and not number
        this.originalRect = this.el.getBoundingClientRect();
        this.scrollEl = (0, $2wHnB.Utils).getScrollElement(this.el);
        this.scrollY = this.scrollEl.scrollTop;
        this.scrolled = 0;
        this.startEvent = event;
        this._setupHelper();
        this._applyChange();
        const ev = (0, $2wHnB.Utils).initEvent(event, {
            type: 'resizestart',
            target: this.el
        });
        if (this.option.start) this.option.start(ev, this._ui());
        this.el.classList.add('ui-resizable-resizing');
        this.triggerEvent('resizestart', ev);
        return this;
    }
    /** @internal */ _resizing(event, dir) {
        this.scrolled = this.scrollEl.scrollTop - this.scrollY;
        this.temporalRect = this._getChange(event, dir);
        this._applyChange();
        const ev = (0, $2wHnB.Utils).initEvent(event, {
            type: 'resize',
            target: this.el
        });
        if (this.option.resize) this.option.resize(ev, this._ui());
        this.triggerEvent('resize', ev);
        return this;
    }
    /** @internal */ _resizeStop(event) {
        const ev = (0, $2wHnB.Utils).initEvent(event, {
            type: 'resizestop',
            target: this.el
        });
        // Remove style attr now, so the stop handler can rebuild style attrs
        this._cleanHelper();
        if (this.option.stop) this.option.stop(ev); // Note: ui() not used by gridstack so don't pass
        this.el.classList.remove('ui-resizable-resizing');
        this.triggerEvent('resizestop', ev);
        delete this.startEvent;
        delete this.originalRect;
        delete this.temporalRect;
        delete this.scrollY;
        delete this.scrolled;
        return this;
    }
    /** @internal */ _setupHelper() {
        this.elOriginStyleVal = $1955ca3220440835$export$164b6dff86382acc._originStyleProp.map((prop)=>this.el.style[prop]);
        this.parentOriginStylePosition = this.el.parentElement.style.position;
        const parent = this.el.parentElement;
        const dragTransform = (0, $2wHnB.Utils).getValuesFromTransformedElement(parent);
        this.rectScale = {
            x: dragTransform.xScale,
            y: dragTransform.yScale
        };
        if (getComputedStyle(this.el.parentElement).position.match(/static/)) this.el.parentElement.style.position = 'relative';
        this.el.style.position = 'absolute';
        this.el.style.opacity = '0.8';
        return this;
    }
    /** @internal */ _cleanHelper() {
        $1955ca3220440835$export$164b6dff86382acc._originStyleProp.forEach((prop, i)=>{
            this.el.style[prop] = this.elOriginStyleVal[i] || null;
        });
        this.el.parentElement.style.position = this.parentOriginStylePosition || null;
        return this;
    }
    /** @internal */ _getChange(event, dir) {
        const oEvent = this.startEvent;
        const newRect = {
            width: this.originalRect.width,
            height: this.originalRect.height + this.scrolled,
            left: this.originalRect.left,
            top: this.originalRect.top - this.scrolled
        };
        const offsetX = event.clientX - oEvent.clientX;
        const offsetY = this.sizeToContent ? 0 : event.clientY - oEvent.clientY; // prevent vert resize
        let moveLeft;
        let moveUp;
        if (dir.indexOf('e') > -1) newRect.width += offsetX;
        else if (dir.indexOf('w') > -1) {
            newRect.width -= offsetX;
            newRect.left += offsetX;
            moveLeft = true;
        }
        if (dir.indexOf('s') > -1) newRect.height += offsetY;
        else if (dir.indexOf('n') > -1) {
            newRect.height -= offsetY;
            newRect.top += offsetY;
            moveUp = true;
        }
        const constrain = this._constrainSize(newRect.width, newRect.height, moveLeft, moveUp);
        if (Math.round(newRect.width) !== Math.round(constrain.width)) {
            if (dir.indexOf('w') > -1) newRect.left += newRect.width - constrain.width;
            newRect.width = constrain.width;
        }
        if (Math.round(newRect.height) !== Math.round(constrain.height)) {
            if (dir.indexOf('n') > -1) newRect.top += newRect.height - constrain.height;
            newRect.height = constrain.height;
        }
        return newRect;
    }
    /** @internal constrain the size to the set min/max values */ _constrainSize(oWidth, oHeight, moveLeft, moveUp) {
        const o = this.option;
        const maxWidth = (moveLeft ? o.maxWidthMoveLeft : o.maxWidth) || Number.MAX_SAFE_INTEGER;
        const minWidth = o.minWidth / this.rectScale.x || oWidth;
        const maxHeight = (moveUp ? o.maxHeightMoveUp : o.maxHeight) || Number.MAX_SAFE_INTEGER;
        const minHeight = o.minHeight / this.rectScale.y || oHeight;
        const width = Math.min(maxWidth, Math.max(minWidth, oWidth));
        const height = Math.min(maxHeight, Math.max(minHeight, oHeight));
        return {
            width: width,
            height: height
        };
    }
    /** @internal */ _applyChange() {
        let containmentRect = {
            left: 0,
            top: 0,
            width: 0,
            height: 0
        };
        if (this.el.style.position === 'absolute') {
            const containmentEl = this.el.parentElement;
            const { left: left, top: top } = containmentEl.getBoundingClientRect();
            containmentRect = {
                left: left,
                top: top,
                width: 0,
                height: 0
            };
        }
        if (!this.temporalRect) return this;
        Object.keys(this.temporalRect).forEach((key)=>{
            const value = this.temporalRect[key];
            const scaleReciprocal = key === 'width' || key === 'left' ? this.rectScale.x : key === 'height' || key === 'top' ? this.rectScale.y : 1;
            this.el.style[key] = (value - containmentRect[key]) * scaleReciprocal + 'px';
        });
        return this;
    }
    /** @internal */ _removeHandlers() {
        this.handlers.forEach((handle)=>handle.destroy());
        delete this.handlers;
        return this;
    }
}
/** @internal */ $1955ca3220440835$export$164b6dff86382acc._originStyleProp = [
    'width',
    'height',
    'position',
    'left',
    'top',
    'opacity',
    'zIndex'
];

});
parcelRegister("eeEhl", function(module, exports) {

$parcel$export(module.exports, "DDResizableHandle", () => $a5d19e06dddc0d8d$export$e692947b96fe8155);
/**
 * dd-resizable-handle.ts 12.4.2
 * Copyright (c) 2021-2025  Alain Dumesny - see GridStack root license
 */ 
var $hEwAF = parcelRequire("hEwAF");
class $a5d19e06dddc0d8d$export$e692947b96fe8155 {
    constructor(host, dir, option){
        this.host = host;
        this.dir = dir;
        this.option = option;
        /** @internal true after we've moved enough pixels to start a resize */ this.moving = false;
        // create var event binding so we can easily remove and still look like TS methods (unlike anonymous functions)
        this._mouseDown = this._mouseDown.bind(this);
        this._mouseMove = this._mouseMove.bind(this);
        this._mouseUp = this._mouseUp.bind(this);
        this._keyEvent = this._keyEvent.bind(this);
        this._init();
    }
    /** @internal */ _init() {
        if (this.option.element) try {
            this.el = this.option.element instanceof HTMLElement ? this.option.element : this.host.querySelector(this.option.element);
        } catch (error) {
            this.option.element = undefined; // make sure destroy handles it correctly
            console.error("Query for resizeable handle failed, falling back", error);
        }
        if (!this.el) {
            this.el = document.createElement('div');
            this.host.appendChild(this.el);
        }
        this.el.classList.add('ui-resizable-handle');
        this.el.classList.add(`${$a5d19e06dddc0d8d$export$e692947b96fe8155.prefix}${this.dir}`);
        this.el.style.zIndex = '100';
        this.el.style.userSelect = 'none';
        this.el.addEventListener('mousedown', this._mouseDown);
        if (0, $hEwAF.isTouch) {
            this.el.addEventListener('touchstart', (0, $hEwAF.touchstart));
            this.el.addEventListener('pointerdown', (0, $hEwAF.pointerdown));
        // this.el.style.touchAction = 'none'; // not needed unlike pointerdown doc comment
        }
        return this;
    }
    /** call this when resize handle needs to be removed and cleaned up */ destroy() {
        if (this.moving) this._mouseUp(this.mouseDownEvent);
        this.el.removeEventListener('mousedown', this._mouseDown);
        if (0, $hEwAF.isTouch) {
            this.el.removeEventListener('touchstart', (0, $hEwAF.touchstart));
            this.el.removeEventListener('pointerdown', (0, $hEwAF.pointerdown));
        }
        if (!this.option.element) this.host.removeChild(this.el);
        delete this.el;
        delete this.host;
        return this;
    }
    /** @internal called on mouse down on us: capture move on the entire document (mouse might not stay on us) until we release the mouse */ _mouseDown(e) {
        this.mouseDownEvent = e;
        document.addEventListener('mousemove', this._mouseMove, {
            capture: true,
            passive: true
        }); // capture, not bubble
        document.addEventListener('mouseup', this._mouseUp, true);
        if (0, $hEwAF.isTouch) {
            this.el.addEventListener('touchmove', (0, $hEwAF.touchmove));
            this.el.addEventListener('touchend', (0, $hEwAF.touchend));
        }
        e.stopPropagation();
        e.preventDefault();
    }
    /** @internal */ _mouseMove(e) {
        const s = this.mouseDownEvent;
        if (this.moving) this._triggerEvent('move', e);
        else if (Math.abs(e.x - s.x) + Math.abs(e.y - s.y) > 2) {
            // don't start unless we've moved at least 3 pixels
            this.moving = true;
            this._triggerEvent('start', this.mouseDownEvent);
            this._triggerEvent('move', e);
            // now track keyboard events to cancel
            document.addEventListener('keydown', this._keyEvent);
        }
        e.stopPropagation();
    // e.preventDefault(); passive = true
    }
    /** @internal */ _mouseUp(e) {
        if (this.moving) {
            this._triggerEvent('stop', e);
            document.removeEventListener('keydown', this._keyEvent);
        }
        document.removeEventListener('mousemove', this._mouseMove, true);
        document.removeEventListener('mouseup', this._mouseUp, true);
        if (0, $hEwAF.isTouch) {
            this.el.removeEventListener('touchmove', (0, $hEwAF.touchmove));
            this.el.removeEventListener('touchend', (0, $hEwAF.touchend));
        }
        delete this.moving;
        delete this.mouseDownEvent;
        e.stopPropagation();
        e.preventDefault();
    }
    /** @internal call when keys are being pressed - use Esc to cancel */ _keyEvent(e) {
        if (e.key === 'Escape') {
            this.host.gridstackNode?.grid?.engine.restoreInitial();
            this._mouseUp(this.mouseDownEvent);
        }
    }
    /** @internal */ _triggerEvent(name, event) {
        if (this.option[name]) this.option[name](event);
        return this;
    }
}
/** @internal */ $a5d19e06dddc0d8d$export$e692947b96fe8155.prefix = 'ui-resizable-';

});
parcelRegister("hEwAF", function(module, exports) {

$parcel$export(module.exports, "isTouch", () => $cd9f73da3ad91631$export$971e5333ff27c622);
$parcel$export(module.exports, "DDTouch", () => $cd9f73da3ad91631$export$1a483566044e6645);
$parcel$export(module.exports, "touchstart", () => $cd9f73da3ad91631$export$9f22968b38117503);
$parcel$export(module.exports, "touchmove", () => $cd9f73da3ad91631$export$3086217c4efdbcc9);
$parcel$export(module.exports, "touchend", () => $cd9f73da3ad91631$export$3c6ab5207a63e8f7);
$parcel$export(module.exports, "pointerdown", () => $cd9f73da3ad91631$export$1078257c7fa11553);
$parcel$export(module.exports, "pointerenter", () => $cd9f73da3ad91631$export$41e94434a5c0bbb3);
$parcel$export(module.exports, "pointerleave", () => $cd9f73da3ad91631$export$add80b47302f701d);
/**
 * touch.ts 12.4.2
 * Copyright (c) 2021-2025 Alain Dumesny - see GridStack root license
 */ 
var $8OXYl = parcelRequire("8OXYl");

var $2wHnB = parcelRequire("2wHnB");
const $cd9f73da3ad91631$export$971e5333ff27c622 = typeof window !== 'undefined' && typeof document !== 'undefined' && ('ontouchstart' in document || 'ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0);
class $cd9f73da3ad91631$export$1a483566044e6645 {
}
/**
* Get the x,y position of a touch event
*/ // function getTouchCoords(e: TouchEvent): TouchCoord {
//   return {
//     x: e.changedTouches[0].pageX,
//     y: e.changedTouches[0].pageY
//   };
// }
/**
 * Simulate a mouse event based on a corresponding touch event
 * @param {Object} e A touch event
 * @param {String} simulatedType The corresponding mouse event
 */ function $cd9f73da3ad91631$var$simulateMouseEvent(e, simulatedType) {
    // Ignore multi-touch events
    if (e.touches.length > 1) return;
    // Prevent "Ignored attempt to cancel a touchmove event with cancelable=false" errors
    if (e.cancelable) e.preventDefault();
    // Dispatch the simulated event to the target element
    (0, $2wHnB.Utils).simulateMouseEvent(e.changedTouches[0], simulatedType);
}
/**
 * Simulate a mouse event based on a corresponding Pointer event
 * @param {Object} e A pointer event
 * @param {String} simulatedType The corresponding mouse event
 */ function $cd9f73da3ad91631$var$simulatePointerMouseEvent(e, simulatedType) {
    // Prevent "Ignored attempt to cancel a touchmove event with cancelable=false" errors
    if (e.cancelable) e.preventDefault();
    // Dispatch the simulated event to the target element
    (0, $2wHnB.Utils).simulateMouseEvent(e, simulatedType);
}
function $cd9f73da3ad91631$export$9f22968b38117503(e) {
    // Ignore the event if another widget is already being handled
    if ($cd9f73da3ad91631$export$1a483566044e6645.touchHandled) return;
    $cd9f73da3ad91631$export$1a483566044e6645.touchHandled = true;
    // Simulate the mouse events
    // simulateMouseEvent(e, 'mouseover');
    // simulateMouseEvent(e, 'mousemove');
    $cd9f73da3ad91631$var$simulateMouseEvent(e, 'mousedown');
}
function $cd9f73da3ad91631$export$3086217c4efdbcc9(e) {
    // Ignore event if not handled by us
    if (!$cd9f73da3ad91631$export$1a483566044e6645.touchHandled) return;
    $cd9f73da3ad91631$var$simulateMouseEvent(e, 'mousemove');
}
function $cd9f73da3ad91631$export$3c6ab5207a63e8f7(e) {
    // Ignore event if not handled
    if (!$cd9f73da3ad91631$export$1a483566044e6645.touchHandled) return;
    // cancel delayed leave event when we release on ourself which happens BEFORE we get this!
    if ($cd9f73da3ad91631$export$1a483566044e6645.pointerLeaveTimeout) {
        window.clearTimeout($cd9f73da3ad91631$export$1a483566044e6645.pointerLeaveTimeout);
        delete $cd9f73da3ad91631$export$1a483566044e6645.pointerLeaveTimeout;
    }
    const wasDragging = !!(0, $8OXYl.DDManager).dragElement;
    // Simulate the mouseup event
    $cd9f73da3ad91631$var$simulateMouseEvent(e, 'mouseup');
    // simulateMouseEvent(event, 'mouseout');
    // If the touch interaction did not move, it should trigger a click
    if (!wasDragging) $cd9f73da3ad91631$var$simulateMouseEvent(e, 'click');
    // Unset the flag to allow other widgets to inherit the touch event
    $cd9f73da3ad91631$export$1a483566044e6645.touchHandled = false;
}
function $cd9f73da3ad91631$export$1078257c7fa11553(e) {
    // console.log("pointer down")
    if (e.pointerType === 'mouse') return;
    e.target.releasePointerCapture(e.pointerId); // <- Important!
}
function $cd9f73da3ad91631$export$41e94434a5c0bbb3(e) {
    // ignore the initial one we get on pointerdown on ourself
    if (!(0, $8OXYl.DDManager).dragElement) // console.log('pointerenter ignored');
    return;
    // console.log('pointerenter');
    if (e.pointerType === 'mouse') return;
    $cd9f73da3ad91631$var$simulatePointerMouseEvent(e, 'mouseenter');
}
function $cd9f73da3ad91631$export$add80b47302f701d(e) {
    // ignore the leave on ourself we get before releasing the mouse over ourself
    // by delaying sending the event and having the up event cancel us
    if (!(0, $8OXYl.DDManager).dragElement) // console.log('pointerleave ignored');
    return;
    if (e.pointerType === 'mouse') return;
    $cd9f73da3ad91631$export$1a483566044e6645.pointerLeaveTimeout = window.setTimeout(()=>{
        delete $cd9f73da3ad91631$export$1a483566044e6645.pointerLeaveTimeout;
        // console.log('pointerleave delayed');
        $cd9f73da3ad91631$var$simulatePointerMouseEvent(e, 'mouseleave');
    }, 10);
}

});


parcelRegister("cT03x", function(module, exports) {

$parcel$export(module.exports, "DDBaseImplement", () => $961aaa378df7559f$export$f7f86c6c46dbe9d7);
/**
 * dd-base-impl.ts 12.4.2
 * Copyright (c) 2021-2025  Alain Dumesny - see GridStack root license
 */ /**
 * Abstract base class for all drag & drop implementations.
 * Provides common functionality for event handling, enable/disable state,
 * and lifecycle management used by draggable, droppable, and resizable implementations.
 */ class $961aaa378df7559f$export$f7f86c6c46dbe9d7 {
    constructor(){
        /** @internal */ this._eventRegister = {};
    }
    /**
     * Returns the current disabled state.
     * Note: Use enable()/disable() methods to change state as other operations need to happen.
     */ get disabled() {
        return this._disabled;
    }
    /**
     * Register an event callback for the specified event.
     *
     * @param event - Event name to listen for
     * @param callback - Function to call when event occurs
     */ on(event, callback) {
        this._eventRegister[event] = callback;
    }
    /**
     * Unregister an event callback for the specified event.
     *
     * @param event - Event name to stop listening for
     */ off(event) {
        delete this._eventRegister[event];
    }
    /**
     * Enable this drag & drop implementation.
     * Subclasses should override to perform additional setup.
     */ enable() {
        this._disabled = false;
    }
    /**
     * Disable this drag & drop implementation.
     * Subclasses should override to perform additional cleanup.
     */ disable() {
        this._disabled = true;
    }
    /**
     * Destroy this drag & drop implementation and clean up resources.
     * Removes all event handlers and clears internal state.
     */ destroy() {
        delete this._eventRegister;
    }
    /**
     * Trigger a registered event callback if one exists and the implementation is enabled.
     *
     * @param eventName - Name of the event to trigger
     * @param event - DOM event object to pass to the callback
     * @returns Result from the callback function, if any
     */ triggerEvent(eventName, event) {
        if (!this.disabled && this._eventRegister && this._eventRegister[eventName]) return this._eventRegister[eventName](event);
    }
}

});


parcelRegister("1ozke", function(module, exports) {

$parcel$export(module.exports, "DDDraggable", () => $10436f347516b066$export$302055fe0edcc75e);
/**
 * dd-draggable.ts 12.4.2
 * Copyright (c) 2021-2025  Alain Dumesny - see GridStack root license
 */ 
var $8OXYl = parcelRequire("8OXYl");

var $2wHnB = parcelRequire("2wHnB");

var $cT03x = parcelRequire("cT03x");

var $hEwAF = parcelRequire("hEwAF");
// make sure we are not clicking on known object that handles mouseDown
const $10436f347516b066$var$skipMouseDown = 'input,textarea,button,select,option,[contenteditable="true"],.ui-resizable-handle';
// let count = 0; // TEST
class $10436f347516b066$export$302055fe0edcc75e extends (0, $cT03x.DDBaseImplement) {
    constructor(el, option = {}){
        super();
        this.el = el;
        this.option = option;
        /** @internal */ this.dragTransform = {
            xScale: 1,
            yScale: 1,
            xOffset: 0,
            yOffset: 0
        };
        // get the element that is actually supposed to be dragged by
        const handleName = option?.handle?.substring(1);
        const n = el.gridstackNode;
        this.dragEls = !handleName || el.classList.contains(handleName) ? [
            el
        ] : n?.subGrid ? [
            el.querySelector(option.handle) || el
        ] : Array.from(el.querySelectorAll(option.handle));
        if (this.dragEls.length === 0) this.dragEls = [
            el
        ];
        // create var event binding so we can easily remove and still look like TS methods (unlike anonymous functions)
        this._mouseDown = this._mouseDown.bind(this);
        this._mouseMove = this._mouseMove.bind(this);
        this._mouseUp = this._mouseUp.bind(this);
        this._keyEvent = this._keyEvent.bind(this);
        this.enable();
    }
    on(event, callback) {
        super.on(event, callback);
    }
    off(event) {
        super.off(event);
    }
    enable() {
        if (this.disabled === false) return;
        super.enable();
        this.dragEls.forEach((dragEl)=>{
            dragEl.addEventListener('mousedown', this._mouseDown);
            if (0, $hEwAF.isTouch) {
                dragEl.addEventListener('touchstart', (0, $hEwAF.touchstart));
                dragEl.addEventListener('pointerdown', (0, $hEwAF.pointerdown));
            // dragEl.style.touchAction = 'none'; // not needed unlike pointerdown doc comment
            }
        });
        this.el.classList.remove('ui-draggable-disabled');
    }
    disable(forDestroy = false) {
        if (this.disabled === true) return;
        super.disable();
        this.dragEls.forEach((dragEl)=>{
            dragEl.removeEventListener('mousedown', this._mouseDown);
            if (0, $hEwAF.isTouch) {
                dragEl.removeEventListener('touchstart', (0, $hEwAF.touchstart));
                dragEl.removeEventListener('pointerdown', (0, $hEwAF.pointerdown));
            }
        });
        if (!forDestroy) this.el.classList.add('ui-draggable-disabled');
    }
    destroy() {
        if (this.dragTimeout) window.clearTimeout(this.dragTimeout);
        delete this.dragTimeout;
        if (this.mouseDownEvent) this._mouseUp(this.mouseDownEvent);
        this.disable(true);
        delete this.el;
        delete this.helper;
        delete this.option;
        super.destroy();
    }
    updateOption(opts) {
        Object.keys(opts).forEach((key)=>this.option[key] = opts[key]);
        return this;
    }
    /** @internal call when mouse goes down before a dragstart happens */ _mouseDown(e) {
        // if real brower event (trusted:true vs false for our simulated ones) and we didn't correctly clear the last touch event, clear things up
        if ((0, $hEwAF.DDTouch).touchHandled && e.isTrusted) (0, $hEwAF.DDTouch).touchHandled = false;
        // don't let more than one widget handle mouseStart
        if ((0, $8OXYl.DDManager).mouseHandled) return;
        if (e.button !== 0) return true; // only left click
        // make sure we are not clicking on known object that handles mouseDown, or ones supplied by the user
        if (!this.dragEls.find((el)=>el === e.target) && e.target.closest($10436f347516b066$var$skipMouseDown)) return true;
        if (this.option.cancel) {
            if (e.target.closest(this.option.cancel)) return true;
        }
        this.mouseDownEvent = e;
        delete this.dragging;
        delete (0, $8OXYl.DDManager).dragElement;
        delete (0, $8OXYl.DDManager).dropElement;
        // document handler so we can continue receiving moves as the item is 'fixed' position, and capture=true so WE get a first crack
        document.addEventListener('mousemove', this._mouseMove, {
            capture: true,
            passive: true
        }); // true=capture, not bubble
        document.addEventListener('mouseup', this._mouseUp, true);
        if (0, $hEwAF.isTouch) {
            e.currentTarget.addEventListener('touchmove', (0, $hEwAF.touchmove));
            e.currentTarget.addEventListener('touchend', (0, $hEwAF.touchend));
        }
        e.preventDefault();
        // preventDefault() prevents blur event which occurs just after mousedown event.
        // if an editable content has focus, then blur must be call
        if (document.activeElement) document.activeElement.blur();
        (0, $8OXYl.DDManager).mouseHandled = true;
        return true;
    }
    /** @internal method to call actual drag event */ _callDrag(e) {
        if (!this.dragging) return;
        const ev = (0, $2wHnB.Utils).initEvent(e, {
            target: this.el,
            type: 'drag'
        });
        if (this.option.drag) this.option.drag(ev, this.ui());
        this.triggerEvent('drag', ev);
    }
    /** @internal called when the main page (after successful mousedown) receives a move event to drag the item around the screen */ _mouseMove(e) {
        // console.log(`${count++} move ${e.x},${e.y}`)
        const s = this.mouseDownEvent;
        this.lastDrag = e;
        if (this.dragging) {
            this._dragFollow(e);
            // delay actual grid handling drag until we pause for a while if set
            if ((0, $8OXYl.DDManager).pauseDrag) {
                const pause = Number.isInteger((0, $8OXYl.DDManager).pauseDrag) ? (0, $8OXYl.DDManager).pauseDrag : 100;
                if (this.dragTimeout) window.clearTimeout(this.dragTimeout);
                this.dragTimeout = window.setTimeout(()=>this._callDrag(e), pause);
            } else this._callDrag(e);
        } else if (Math.abs(e.x - s.x) + Math.abs(e.y - s.y) > 3) {
            /**
             * don't start unless we've moved at least 3 pixels
             */ this.dragging = true;
            (0, $8OXYl.DDManager).dragElement = this;
            // if we're dragging an actual grid item, set the current drop as the grid (to detect enter/leave)
            const grid = this.el.gridstackNode?.grid;
            if (grid) (0, $8OXYl.DDManager).dropElement = grid.el.ddElement.ddDroppable;
            else delete (0, $8OXYl.DDManager).dropElement;
            this.helper = this._createHelper();
            this._setupHelperContainmentStyle();
            this.dragTransform = (0, $2wHnB.Utils).getValuesFromTransformedElement(this.helperContainment);
            this.dragOffset = this._getDragOffset(e, this.el, this.helperContainment);
            this._setupHelperStyle(e);
            const ev = (0, $2wHnB.Utils).initEvent(e, {
                target: this.el,
                type: 'dragstart'
            });
            if (this.option.start) this.option.start(ev, this.ui());
            this.triggerEvent('dragstart', ev);
            // now track keyboard events to cancel or rotate
            document.addEventListener('keydown', this._keyEvent);
        }
        // e.preventDefault(); // passive = true. OLD: was needed otherwise we get text sweep text selection as we drag around
        return true;
    }
    /** @internal call when the mouse gets released to drop the item at current location */ _mouseUp(e) {
        document.removeEventListener('mousemove', this._mouseMove, true);
        document.removeEventListener('mouseup', this._mouseUp, true);
        if ((0, $hEwAF.isTouch) && e.currentTarget) {
            e.currentTarget.removeEventListener('touchmove', (0, $hEwAF.touchmove), true);
            e.currentTarget.removeEventListener('touchend', (0, $hEwAF.touchend), true);
        }
        if (this.dragging) {
            delete this.dragging;
            delete this.el.gridstackNode?._origRotate;
            document.removeEventListener('keydown', this._keyEvent);
            // reset the drop target if dragging over ourself (already parented, just moving during stop callback below)
            if ((0, $8OXYl.DDManager).dropElement?.el === this.el.parentElement) delete (0, $8OXYl.DDManager).dropElement;
            this.helperContainment.style.position = this.parentOriginStylePosition || null;
            if (this.helper !== this.el) this.helper.remove(); // hide now
            this._removeHelperStyle();
            const ev = (0, $2wHnB.Utils).initEvent(e, {
                target: this.el,
                type: 'dragstop'
            });
            if (this.option.stop) this.option.stop(ev); // NOTE: destroy() will be called when removing item, so expect NULL ptr after!
            this.triggerEvent('dragstop', ev);
            // call the droppable method to receive the item
            if ((0, $8OXYl.DDManager).dropElement) (0, $8OXYl.DDManager).dropElement.drop(e);
        }
        delete this.helper;
        delete this.mouseDownEvent;
        delete (0, $8OXYl.DDManager).dragElement;
        delete (0, $8OXYl.DDManager).dropElement;
        delete (0, $8OXYl.DDManager).mouseHandled;
        e.preventDefault();
    }
    /** @internal call when keys are being pressed - use Esc to cancel, R to rotate */ _keyEvent(e) {
        const n = this.el.gridstackNode;
        const grid = n?.grid || (0, $8OXYl.DDManager).dropElement?.el?.gridstack;
        if (e.key === 'Escape') {
            if (n && n._origRotate) {
                n._orig = n._origRotate;
                delete n._origRotate;
            }
            grid?.cancelDrag();
            this._mouseUp(this.mouseDownEvent);
        } else if (n && grid && (e.key === 'r' || e.key === 'R')) {
            if (!(0, $2wHnB.Utils).canBeRotated(n)) return;
            n._origRotate = n._origRotate || {
                ...n._orig
            }; // store the real orig size in case we Esc after doing rotation
            delete n._moving; // force rotate to happen (move waits for >50% coverage otherwise)
            grid.setAnimation(false) // immediate rotate so _getDragOffset() gets the right dom size below
            .rotate(n.el, {
                top: -this.dragOffset.offsetTop,
                left: -this.dragOffset.offsetLeft
            }).setAnimation();
            n._moving = true;
            this.dragOffset = this._getDragOffset(this.lastDrag, n.el, this.helperContainment);
            this.helper.style.width = this.dragOffset.width + 'px';
            this.helper.style.height = this.dragOffset.height + 'px';
            (0, $2wHnB.Utils).swap(n._orig, 'w', 'h');
            delete n._rect;
            this._mouseMove(this.lastDrag);
        }
    }
    /** @internal create a clone copy (or user defined method) of the original drag item if set */ _createHelper() {
        let helper = this.el;
        if (typeof this.option.helper === 'function') helper = this.option.helper(this.el);
        else if (this.option.helper === 'clone') helper = (0, $2wHnB.Utils).cloneNode(this.el);
        if (!helper.parentElement) (0, $2wHnB.Utils).appendTo(helper, this.option.appendTo === 'parent' ? this.el.parentElement : this.option.appendTo);
        this.dragElementOriginStyle = $10436f347516b066$export$302055fe0edcc75e.originStyleProp.map((prop)=>this.el.style[prop]);
        return helper;
    }
    /** @internal set the fix position of the dragged item */ _setupHelperStyle(e) {
        this.helper.classList.add('ui-draggable-dragging');
        this.el.gridstackNode?.grid?.el.classList.add('grid-stack-dragging');
        // TODO: set all at once with style.cssText += ... ? https://stackoverflow.com/questions/3968593
        const style = this.helper.style;
        style.pointerEvents = 'none'; // needed for over items to get enter/leave
        // style.cursor = 'move'; //  TODO: can't set with pointerEvents=none ! (no longer in CSS either as no-op)
        style.width = this.dragOffset.width + 'px';
        style.height = this.dragOffset.height + 'px';
        style.willChange = 'left, top';
        style.position = 'fixed'; // let us drag between grids by not clipping as parent .grid-stack is position: 'relative'
        this._dragFollow(e); // now position it
        style.transition = 'none'; // show up instantly
        setTimeout(()=>{
            if (this.helper) style.transition = null; // recover animation
        }, 0);
        return this;
    }
    /** @internal restore back the original style before dragging */ _removeHelperStyle() {
        this.helper.classList.remove('ui-draggable-dragging');
        this.el.gridstackNode?.grid?.el.classList.remove('grid-stack-dragging');
        const node = this.helper?.gridstackNode;
        // don't bother restoring styles if we're gonna remove anyway...
        if (!node?._isAboutToRemove && this.dragElementOriginStyle) {
            const helper = this.helper;
            // don't animate, otherwise we animate offseted when switching back to 'absolute' from 'fixed'.
            // TODO: this also removes resizing animation which doesn't have this issue, but others.
            // Ideally both would animate ('move' would immediately restore 'absolute' and adjust coordinate to match,
            // then trigger a delay (repaint) to restore to final dest with animate) but then we need to make sure 'resizestop'
            // is called AFTER 'transitionend' event is received (see https://github.com/gridstack/gridstack.js/issues/2033)
            const transition = this.dragElementOriginStyle['transition'] || null;
            helper.style.transition = this.dragElementOriginStyle['transition'] = 'none'; // can't be NULL #1973
            $10436f347516b066$export$302055fe0edcc75e.originStyleProp.forEach((prop)=>helper.style[prop] = this.dragElementOriginStyle[prop] || null);
            setTimeout(()=>helper.style.transition = transition, 50); // recover animation from saved vars after a pause (0 isn't enough #1973)
        }
        delete this.dragElementOriginStyle;
        return this;
    }
    /** @internal updates the top/left position to follow the mouse */ _dragFollow(e) {
        const containmentRect = {
            left: 0,
            top: 0
        };
        // if (this.helper.style.position === 'absolute') { // we use 'fixed'
        //   const { left, top } = this.helperContainment.getBoundingClientRect();
        //   containmentRect = { left, top };
        // }
        const style = this.helper.style;
        const offset = this.dragOffset;
        style.left = (e.clientX + offset.offsetLeft - containmentRect.left) * this.dragTransform.xScale + 'px';
        style.top = (e.clientY + offset.offsetTop - containmentRect.top) * this.dragTransform.yScale + 'px';
    }
    /** @internal */ _setupHelperContainmentStyle() {
        this.helperContainment = this.helper.parentElement;
        if (this.helper.style.position !== 'fixed') {
            this.parentOriginStylePosition = this.helperContainment.style.position;
            if (getComputedStyle(this.helperContainment).position.match(/static/)) this.helperContainment.style.position = 'relative';
        }
        return this;
    }
    /** @internal */ _getDragOffset(event, el, parent) {
        // in case ancestor has transform/perspective css properties that change the viewpoint
        let xformOffsetX = 0;
        let xformOffsetY = 0;
        if (parent) {
            xformOffsetX = this.dragTransform.xOffset;
            xformOffsetY = this.dragTransform.yOffset;
        }
        const targetOffset = el.getBoundingClientRect();
        return {
            left: targetOffset.left,
            top: targetOffset.top,
            offsetLeft: -event.clientX + targetOffset.left - xformOffsetX,
            offsetTop: -event.clientY + targetOffset.top - xformOffsetY,
            width: targetOffset.width * this.dragTransform.xScale,
            height: targetOffset.height * this.dragTransform.yScale
        };
    }
    /** @internal TODO: set to public as called by DDDroppable! */ ui() {
        const containmentEl = this.el.parentElement;
        const containmentRect = containmentEl.getBoundingClientRect();
        const offset = this.helper.getBoundingClientRect();
        return {
            position: {
                top: (offset.top - containmentRect.top) * this.dragTransform.yScale,
                left: (offset.left - containmentRect.left) * this.dragTransform.xScale
            }
        };
    }
}
/** @internal properties we change during dragging, and restore back */ $10436f347516b066$export$302055fe0edcc75e.originStyleProp = [
    'width',
    'height',
    'transform',
    'transform-origin',
    'transition',
    'pointerEvents',
    'position',
    'left',
    'top',
    'minWidth',
    'willChange'
];

});

parcelRegister("6fHe9", function(module, exports) {

$parcel$export(module.exports, "DDDroppable", () => $48d5accd6460ea9c$export$e8fa4202baef0811);
/**
 * dd-droppable.ts 12.4.2
 * Copyright (c) 2021-2025  Alain Dumesny - see GridStack root license
 */ 
var $8OXYl = parcelRequire("8OXYl");

var $cT03x = parcelRequire("cT03x");

var $2wHnB = parcelRequire("2wHnB");

var $hEwAF = parcelRequire("hEwAF");
class $48d5accd6460ea9c$export$e8fa4202baef0811 extends (0, $cT03x.DDBaseImplement) {
    constructor(el, option = {}){
        super();
        this.el = el;
        this.option = option;
        // create var event binding so we can easily remove and still look like TS methods (unlike anonymous functions)
        this._mouseEnter = this._mouseEnter.bind(this);
        this._mouseLeave = this._mouseLeave.bind(this);
        this.enable();
        this._setupAccept();
    }
    on(event, callback) {
        super.on(event, callback);
    }
    off(event) {
        super.off(event);
    }
    enable() {
        if (this.disabled === false) return;
        super.enable();
        this.el.classList.add('ui-droppable');
        this.el.classList.remove('ui-droppable-disabled');
        this.el.addEventListener('mouseenter', this._mouseEnter);
        this.el.addEventListener('mouseleave', this._mouseLeave);
        if (0, $hEwAF.isTouch) {
            this.el.addEventListener('pointerenter', (0, $hEwAF.pointerenter));
            this.el.addEventListener('pointerleave', (0, $hEwAF.pointerleave));
        }
    }
    disable(forDestroy = false) {
        if (this.disabled === true) return;
        super.disable();
        this.el.classList.remove('ui-droppable');
        if (!forDestroy) this.el.classList.add('ui-droppable-disabled');
        this.el.removeEventListener('mouseenter', this._mouseEnter);
        this.el.removeEventListener('mouseleave', this._mouseLeave);
        if (0, $hEwAF.isTouch) {
            this.el.removeEventListener('pointerenter', (0, $hEwAF.pointerenter));
            this.el.removeEventListener('pointerleave', (0, $hEwAF.pointerleave));
        }
    }
    destroy() {
        this.disable(true);
        this.el.classList.remove('ui-droppable');
        this.el.classList.remove('ui-droppable-disabled');
        super.destroy();
    }
    updateOption(opts) {
        Object.keys(opts).forEach((key)=>this.option[key] = opts[key]);
        this._setupAccept();
        return this;
    }
    /** @internal called when the cursor enters our area - prepare for a possible drop and track leaving */ _mouseEnter(e) {
        // console.log(`${count++} Enter ${this.el.id || (this.el as GridHTMLElement).gridstack.opts.id}`); // TEST
        if (!(0, $8OXYl.DDManager).dragElement) return;
        // During touch drag operations, ignore real browser-generated mouseenter events (isTrusted:true) vs our simulated ones (isTrusted:false).
        // The browser can fire spurious mouseenter events when we dispatch simulated mousemove events.
        if ((0, $hEwAF.DDTouch).touchHandled && e.isTrusted) return;
        if (!this._canDrop((0, $8OXYl.DDManager).dragElement.el)) return;
        e.preventDefault();
        e.stopPropagation();
        // make sure when we enter this, that the last one gets a leave FIRST to correctly cleanup as we don't always do
        if ((0, $8OXYl.DDManager).dropElement && (0, $8OXYl.DDManager).dropElement !== this) (0, $8OXYl.DDManager).dropElement._mouseLeave(e, true); // calledByEnter = true
        (0, $8OXYl.DDManager).dropElement = this;
        const ev = (0, $2wHnB.Utils).initEvent(e, {
            target: this.el,
            type: 'dropover'
        });
        if (this.option.over) this.option.over(ev, this._ui((0, $8OXYl.DDManager).dragElement));
        this.triggerEvent('dropover', ev);
        this.el.classList.add('ui-droppable-over');
    // console.log('tracking'); // TEST
    }
    /** @internal called when the item is leaving our area, stop tracking if we had moving item */ _mouseLeave(e, calledByEnter = false) {
        // console.log(`${count++} Leave ${this.el.id || (this.el as GridHTMLElement).gridstack.opts.id}`); // TEST
        if (!(0, $8OXYl.DDManager).dragElement || (0, $8OXYl.DDManager).dropElement !== this) return;
        e.preventDefault();
        e.stopPropagation();
        const ev = (0, $2wHnB.Utils).initEvent(e, {
            target: this.el,
            type: 'dropout'
        });
        if (this.option.out) this.option.out(ev, this._ui((0, $8OXYl.DDManager).dragElement));
        this.triggerEvent('dropout', ev);
        if ((0, $8OXYl.DDManager).dropElement === this) {
            delete (0, $8OXYl.DDManager).dropElement;
            // console.log('not tracking'); // TEST
            // if we're still over a parent droppable, send it an enter as we don't get one from leaving nested children
            if (!calledByEnter) {
                let parentDrop;
                let parent = this.el.parentElement;
                while(!parentDrop && parent){
                    parentDrop = parent.ddElement?.ddDroppable;
                    parent = parent.parentElement;
                }
                if (parentDrop) parentDrop._mouseEnter(e);
            }
        }
    }
    /** item is being dropped on us - called by the drag mouseup handler - this calls the client drop event */ drop(e) {
        e.preventDefault();
        const ev = (0, $2wHnB.Utils).initEvent(e, {
            target: this.el,
            type: 'drop'
        });
        if (this.option.drop) this.option.drop(ev, this._ui((0, $8OXYl.DDManager).dragElement));
        this.triggerEvent('drop', ev);
    }
    /** @internal true if element matches the string/method accept option */ _canDrop(el) {
        return el && (!this.accept || this.accept(el));
    }
    /** @internal */ _setupAccept() {
        if (!this.option.accept) return this;
        if (typeof this.option.accept === 'string') this.accept = (el)=>el.classList.contains(this.option.accept) || el.matches(this.option.accept);
        else this.accept = this.option.accept;
        return this;
    }
    /** @internal */ _ui(drag) {
        return {
            draggable: drag.el,
            ...drag.ui()
        };
    }
}

});




parcelRegister("3DktE", function(module, exports) {

$parcel$export(module.exports, "ComponentThumbnail", () => $2a54e5f6133dedb5$export$25eb192f81208a13);
parcelRequire("iun8M");
var $1NDED = parcelRequire("1NDED");
const $2a54e5f6133dedb5$export$25eb192f81208a13 = {
    isArtboard: true,
    class: 'grid-stack-item',
    round: 'Z2',
    position: 'relative',
    opacity: 1,
    fontWeight: '400',
    textDecoration: 'none',
    maxWidth: '100%',
    outline: '1px solid line',
    overflow: 'hidden',
    fontSize: '1rem',
    isPage: (el, s)=>s.type === 'pages',
    '.isPage': {
        '::before': {
            content: '""',
            inset: 'D1',
            round: 'B',
            position: 'absolute',
            zIndex: 0,
            '@dark': {
                background: '#c9ccd0ff'
            },
            '@light': {
                background: '#e9eceeff'
            }
        }
    },
    isSelected: (el)=>el.call('getSelected') === el,
    ':hover > span': {
        transform: 'translate3d(0, 0, 0)',
        opacity: 1
    },
    // Set `interactive: true` on a node to let the embedded project inside
    // the thumbnail receive pointer events (clicks, hover, scroll) just
    // like a live preview. Default is preview-only: all descendants except
    // the top-right `Label` span are click-blocked so the tile behaves as
    // a single selectable artboard on the canvas board.
    style: (el, s)=>s.interactive ? {} : {
            '& *:not(> span)': {
                pointerEvents: 'none !important'
            }
        },
    attr: {
        'gs-w': (el, s)=>s.settings?.gridOptions?.w ?? 3,
        'gs-h': (el, s)=>s.settings?.gridOptions?.h ?? 2,
        'gs-x': (el, s)=>s.settings?.gridOptions?.x,
        'gs-y': (el, s)=>s.settings?.gridOptions?.y
    },
    Flex: {
        theme: 'document',
        class: 'grid-stack-item-content',
        round: 'Z2',
        border: '0',
        zIndex: 1,
        clip: 'rect(0, auto, auto, 0)',
        overflow: 'auto',
        maxHeight: '100%',
        width: '100%',
        style: {
            '&::-webkit-scrollbar': {
                width: '24px'
            },
            '&::-webkit-scrollbar-track': {
                background: 'transparent'
            },
            '&::-webkit-scrollbar-thumb': {
                background: 'rgba(0,0,0,0.3)',
                borderRadius: '12px',
                border: '8px solid transparent',
                backgroundClip: 'padding-box'
            },
            scrollbarWidth: 'auto'
        },
        // Frame every tile so the project's Scratch config is scoped to its
        // iframe realm and can't override canvas chrome themes on hard-refresh.
        onRender: (el, s)=>{
            if (el.__contentSet) return;
            const data = s?.root?.data;
            if (!data || !s?.key) return;
            el.set({
                width: '100%',
                height: '100%',
                FrameHost: {
                    tag: 'iframe',
                    width: '100%',
                    height: '100%',
                    border: '0',
                    display: 'block',
                    attr: {
                        'data-canvas-frame': s.key
                    },
                    onRender: (fel)=>{
                        if (fel.__mounted) return;
                        fel.__mounted = true;
                        (0, $1NDED.embedComponent)(fel.node, data, {
                            key: s.key,
                            fullsize: true
                        }).catch((err)=>console.warn('[thumbnail frame] failed for', s.key, err));
                    }
                }
            });
            el.__contentSet = true;
        },
        onWheel: (ev, el)=>{
            if (!el.node) return;
            const { scrollTop: scrollTop, clientHeight: clientHeight, scrollHeight: scrollHeight } = el.node;
            const isScrollable = scrollHeight > clientHeight;
            if (!isScrollable) return;
            const atTop = scrollTop === 0;
            const atBottom = scrollTop + clientHeight >= scrollHeight - 1;
            const shouldStop = ev.deltaY < 0 && !atTop || ev.deltaY > 0 && !atBottom;
            if (shouldStop) {
                ev.preventDefault();
                ev.stopPropagation();
                el.node.scrollTop += ev.deltaY;
            }
        }
    },
    Label: {
        extends: 'Span',
        position: 'absolute',
        bottom: 'Z',
        left: 'Z',
        padding: 'W X',
        background: 'rgba(0,0,0,0.65)',
        color: 'white',
        round: 'Y',
        fontSize: 'Z',
        opacity: 0,
        transition: 'opacity 150ms',
        text: (el, s)=>s.title || s.key
    },
    ':hover > span': {
        opacity: 1
    },
    onMouseenter: (ev, el, s)=>{
        const scope = el.call('getCanvasScope');
        if (!scope) return;
        scope.layerHostComponent = s.key;
        el.call('activateHovered');
    },
    onMouseleave: (ev, el)=>{
        const scope = el.call('getCanvasScope');
        if (!scope) return;
        scope.hoverLayer = null;
        el.call('activateHovered', null);
    },
    onMousemove: (ev, el)=>{
        if (el.call('isCanvasMode', 'inspectMode')) {
            if (!ev.target?.ref) return;
            const path = [
                ...ev.target.ref.__ref.path
            ];
            path.splice(0, 8);
            const scope = el.call('getCanvasScope');
            scope.hoverLayer = path.filter((key)=>key[0] !== key[0].toLowerCase());
        }
    },
    onClick: (ev, el, s)=>{
        ev.stopPropagation();
        el.call('activateSelected');
    },
    onDblclick: (ev, el)=>{
        ev.stopPropagation();
    // TODO: activate chosen mode for component editing
    },
    onContextmenu: (ev, el, s)=>{
        ev.preventDefault();
        ev.stopPropagation();
    }
};

});
parcelRegister("iun8M", function(module, exports) {

$parcel$export(module.exports, "createIframeApp", () => (parcelRequire("iX8xq")).createIframeApp);
$parcel$export(module.exports, "embedComponent", () => (parcelRequire("1NDED")).embedComponent);
$parcel$export(module.exports, "embedDesignSystem", () => (parcelRequire("pb5Og")).embedDesignSystem);

var $iX8xq = parcelRequire("iX8xq");

var $1NDED = parcelRequire("1NDED");

var $pb5Og = parcelRequire("pb5Og");

});
parcelRegister("iX8xq", function(module, exports) {

$parcel$export(module.exports, "createIframeApp", () => $dcc45c332a697fba$export$7d37ad3c60bb445b);
parcelRequire("8augU");
var $6T8Dr = parcelRequire("6T8Dr");parcelRequire("2oe0q");
var $bmfNh = parcelRequire("bmfNh");
parcelRequire("aTPvW");
var $iIypr = parcelRequire("iIypr");
const $dcc45c332a697fba$var$NATIVE_RE = /\{\s*\[native code\]\s*\}/;
const $dcc45c332a697fba$var$GLOBAL_REF_RE = /\b(window|document)\s*\./;
function $dcc45c332a697fba$export$dd44eb2b526e2bbf(node, frameWindow, seen = new WeakSet()) {
    if (!node || typeof node !== 'object') return;
    if (seen.has(node)) return;
    seen.add(node);
    for(const key in node){
        if (!Object.prototype.hasOwnProperty.call(node, key)) continue;
        const v = node[key];
        if (typeof v === 'function') {
            if (v.__rerealmed) continue;
            let src;
            try {
                src = Function.prototype.toString.call(v);
            } catch  {
                continue;
            }
            if ($dcc45c332a697fba$var$NATIVE_RE.test(src) || !$dcc45c332a697fba$var$GLOBAL_REF_RE.test(src)) continue;
            let reFn;
            try {
                reFn = frameWindow.eval('(' + src + ')');
            } catch  {
                continue;
            }
            const wrapped = function(...args) {
                try {
                    return reFn.apply(this, args);
                } catch (e) {
                    if (e instanceof ReferenceError) return v.apply(this, args);
                    throw e;
                }
            };
            wrapped.__rerealmed = true;
            node[key] = wrapped;
        } else if (v && typeof v === 'object') $dcc45c332a697fba$export$dd44eb2b526e2bbf(v, frameWindow, seen);
    }
}
function $dcc45c332a697fba$export$4cdd3228a542c759(doc, designSystem) {
    if (!doc?.body || !designSystem) return;
    let spriteHtml = '';
    if (designSystem.icons) for(const key in designSystem.icons)spriteHtml += (0, $iIypr.convertSvgToSymbol)(key, designSystem.icons[key]);
    if (designSystem.svg) for(const key in designSystem.svg)spriteHtml += (0, $iIypr.convertSvgToSymbol)(key, designSystem.svg[key]);
    if (spriteHtml) doc.body.insertAdjacentHTML('afterbegin', `<svg aria-hidden="true" width="0" height="0" style="position:absolute" id="svgSprite">${spriteHtml}</svg>`);
}
async function $dcc45c332a697fba$export$dbc8bcae50ddde2e(iframeNode) {
    // A freshly-mounted iframe (no explicit `src` OR still on about:blank)
    // already has its contentDocument ready and `readyState: 'complete'`.
    // Listening for a `load` event after that point hangs forever —
    // canvas-side tile frames hit this because DOMQL creates the <iframe>
    // synchronously before our handler attaches. Only do the reload dance
    // when the iframe is currently pointed somewhere else.
    const currentSrc = iframeNode.getAttribute('src') || '';
    const needsReload = currentSrc && currentSrc !== 'about:blank';
    if (needsReload) {
        iframeNode.src = 'about:blank';
        await new Promise((resolve)=>{
            iframeNode.addEventListener('load', resolve, {
                once: true
            });
        });
    }
    const frameWindow = iframeNode.contentWindow;
    const doc = iframeNode.contentDocument || frameWindow.document;
    doc.open();
    doc.write('<!DOCTYPE html><html><head><meta name="color-scheme" content="light dark"><style>*{margin:0;padding:0;box-sizing:border-box}html,body{width:100%;height:100%;overflow:auto}</style></head><body></body></html>');
    doc.close();
    return {
        frameWindow: frameWindow,
        doc: doc
    };
}
async function $dcc45c332a697fba$export$7d37ad3c60bb445b(iframeNode, data, shell, { path: path = '/', contextOverrides: contextOverrides = {}, resetDocument: resetDocument = true } = {}) {
    if (!iframeNode || !data) return null;
    let frameWindow, doc;
    if (resetDocument) ({ frameWindow: frameWindow, doc: doc } = await $dcc45c332a697fba$export$dbc8bcae50ddde2e(iframeNode));
    else {
        frameWindow = iframeNode.contentWindow;
        doc = iframeNode.contentDocument || frameWindow.document;
    }
    if (!frameWindow) return null;
    try {
        frameWindow.history.replaceState(null, '', path);
    } catch  {}
    const hasRealFunctions = typeof data.app?.onRender === 'function';
    const project = hasRealFunctions ? data : (0, $bmfNh.deepClone)(data, {
        window: frameWindow
    });
    $dcc45c332a697fba$export$dd44eb2b526e2bbf(project, frameWindow);
    $dcc45c332a697fba$export$4cdd3228a542c759(doc, project.designSystem);
    const result = await (0, $6T8Dr.create)(shell, {
        ...project,
        ...contextOverrides,
        themeRoot: doc.documentElement,
        document: doc,
        window: frameWindow,
        parent: doc.body
    });
    const appEl = doc.querySelector('[data-smbls-app]') || doc.documentElement;
    let theme = data.globalTheme || 'auto';
    if (theme === 'auto') theme = frameWindow.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    appEl.setAttribute('data-theme', theme);
    if (doc.documentElement !== appEl) doc.documentElement.removeAttribute('data-theme');
    if (result?.context?.designSystem) {
        result.context.designSystem.themeRoot = appEl;
        iframeNode.__projectConfig = result.context.designSystem;
    }
    return result;
}

});

parcelRegister("1NDED", function(module, exports) {

$parcel$export(module.exports, "embedComponent", () => $14f920969a1d3776$export$670fba6793be99dd);

var $iX8xq = parcelRequire("iX8xq");
async function $14f920969a1d3776$export$670fba6793be99dd(iframeNode, data, opts = {}) {
    if (!iframeNode || !data) return;
    const { key: key, width: width, height: height, fullsize: fullsize = false, shareContext: // Canvas "convert to frame" mode: share the parent's chrome context
    // (designSystem, methods, functions) with the embedded frame so its
    // tokens resolve the same way canvas chrome does, and canvas's own
    // chrome-level helpers remain reachable via el.call / methods.
    // Pass `shareContext: { designSystem, methods?, functions? }` to opt in.
    shareContext } = opts;
    if (!key) return;
    // Resolve the component/page schema off the raw project data before we
    // hand it to createIframeApp (the helper deep-clones into the iframe
    // realm, so resolving after would operate on a clone — equivalent but
    // needlessly indirect).
    const factory = key.startsWith('/') ? 'pages' : 'components';
    const schema = data[factory]?.[key] || data.components?.[key];
    const hasExplicitBox = width != null || height != null;
    const inner = schema ? fullsize ? {
        ...schema.props?.demoComponent || schema,
        boxSize: '100dvh 100dvw'
    } : schema.props?.demoComponent || schema : {
        tag: 'div',
        text: `No ${factory.slice(0, -1)} registered for key "${key}"`,
        style: {
            padding: '24px',
            font: '14px system-ui',
            color: '#999'
        }
    };
    // DOMQL treats `/…` child keys as router paths rather than components,
    // so a page whose key starts with `/` (e.g. `/transactions`) wouldn't
    // mount under its own key. Wrap it under a valid identifier and let
    // the page schema itself render underneath.
    const shellKey = schema ? key.startsWith('/') ? 'Page' : key : 'Fallback';
    const shell = {
        flow: 'x',
        align: 'center center',
        boxSize: hasExplicitBox ? `${height || '100dvh'} ${width || '100dvw'}` : '100dvh 100dvw',
        overflow: 'auto',
        theme: 'document',
        // Hoist `data.app.fetch` onto the root shell. The fetch plugin reads
        // `element.fetch` in its `create` hook; without this, embedded pages
        // mount but their project-level queries never fire (canvas tiles show
        // "Loading…" while preview renders real data through the same data).
        ...data.app?.fetch ? {
            fetch: data.app.fetch
        } : {},
        [shellKey]: inner
    };
    const contextOverrides = {
        pages: undefined,
        app: undefined,
        router: false
    };
    if (shareContext) {
        // Explicit non-isolation — frame inherits the caller's designSystem /
        // methods / functions. This breaks the preview-iframe isolation
        // contract on purpose: canvas needs tile frames to keep canvas chrome
        // tooling reachable, which requires the shared objects.
        if (shareContext.designSystem) contextOverrides.designSystem = shareContext.designSystem;
        if (shareContext.methods) contextOverrides.methods = {
            ...data.methods || {},
            ...shareContext.methods
        };
        if (shareContext.functions) contextOverrides.functions = {
            ...data.functions || {},
            ...shareContext.functions
        };
    }
    return (0, $iX8xq.createIframeApp)(iframeNode, data, shell, {
        path: '/component/' + key,
        contextOverrides: contextOverrides
    });
}

});

parcelRegister("pb5Og", function(module, exports) {

$parcel$export(module.exports, "embedDesignSystem", () => $04baf0b1a42e6416$export$8cfe6d8004adff25);

var $iX8xq = parcelRequire("iX8xq");
// DS app shell. Hosted inside the project's own context so tokens, themes,
// shared libraries, and functions all come from the project being previewed.
// `DesignSystemNavbar` / `DesignSystemScene` are expected to be registered
// via the project's sharedLibraries (brand/shared) — we do NOT merge in the
// outer editor's ds components, same isolation contract as renderProject.
const $04baf0b1a42e6416$var$dsShell = {
    flow: 'column',
    height: '100vh',
    width: '100vw',
    gap: '0',
    overflow: 'hidden',
    DesignSystemNavbar: {},
    DesignSystemScene: {
        flex: '1'
    }
};
async function $04baf0b1a42e6416$export$8cfe6d8004adff25(iframeNode, data, initialState = {}) {
    const result = await (0, $iX8xq.createIframeApp)(iframeNode, data, $04baf0b1a42e6416$var$dsShell, {
        path: '/',
        contextOverrides: {
            pages: undefined,
            app: undefined,
            router: false,
            state: {
                ...data.state || {},
                ...initialState
            }
        }
    });
    if (result) {
        iframeNode.__dsRootState = result.state;
        iframeNode.__dsApp = result;
    }
    return result;
}

});





parcelRegister("1dOQU", function(module, exports) {

$parcel$export(module.exports, "CanvasEditor", () => $0e3e739102887048$export$e11337932570a9ce);
const $0e3e739102887048$export$e11337932570a9ce = {
    position: 'fixed',
    inset: '0',
    pointerEvents: 'none',
    zIndex: 100,
    fontSize: 'Z1',
    DropOverlay: {
        if: (el)=>Boolean(el.getRootContext('methods')?.sdk)
    },
    TutorialGifNotification: null,
    TutorialGifsNotificationStack: null,
    Chosen: null,
    QuickEditor: {
        pointerEvents: 'auto',
        if: (el)=>!el.call('isCanvasV2')
    },
    DynamicIsland: null,
    MainCanvasNavbar: null,
    Tabs: null,
    ComponentFrameCanvasTooltip: null,
    FloatingPanel: null,
    LoadingGifSection: null,
    ContextMenu: {},
    CanvasOverlay: {},
    CommandBar: null,
    Zoombar: {
        fontSize: 'Z1',
        position: 'absolute',
        bottom: 'X2',
        right: 'X2',
        top: 'auto',
        width: 'auto',
        pointerEvents: 'auto',
        NavbarButtonSet: {
            // Hook the Settings button into the unified SettingsModal instead
            // of the legacy `/settings` modal routed through `openModal`.
            Settings: {
                onClick: (ev, el, s)=>{
                    ev.stopPropagation();
                    const root = s.root;
                    if (!root) return;
                    root.update({
                        settingsOpen: true,
                        settingsTab: root.settingsTab || 'project'
                    });
                }
            }
        }
    },
    CanvasPromptTextarea: {},
    // Unified settings modal (auto-extends from the registered SettingsModal
    // component) — shared with the workspace page so the Project and
    // Workspace tabs live under a single surface.
    SettingsModal: {},
    // Canvas v2 chrome — selection box, handles, marquee, rulers, snap
    // lines, guides, SelectedNavbar host. All in screen-space px so
    // they don't scale with viewport zoom.
    CanvasOverlayV2: {},
    // Picker overlays — surface-agnostic modals that appear on BOTH
    // /workspaces/<slug> AND /<owner>/<key> project pages without redirect.
    // State lives on s.root (integrationPicker, libraryPickerFor,
    // newProjectPicker) so WorkspaceNavbar's openers write once and either
    // surface reacts.
    IntegrationPickerOverlay: {},
    LibraryPickerOverlay: {},
    // Template-picker modal — opened by WorkspaceNavbar "New project" /
    // "New library" items. State key: root.newProjectPicker.
    NewProjectPickerOverlay: {},
    // MCP connector picker — opened by WorkspaceNavbar "New MCP connector".
    // State keys: root._mcpConnectorPickerOpen, root._mcpConnectorDraft.
    MCPConnectorPickerOverlay: {}
};

});

parcelRegister("iHQuC", function(module, exports) {

$parcel$export(module.exports, "CanvasPromptTextarea", () => $d9e4f6252e26db0e$export$99d37c5a2e6ee365);
const $d9e4f6252e26db0e$export$99d37c5a2e6ee365 = {
    extends: 'PromptTextarea',
    pointerEvents: 'auto',
    state: {
        size: 'small',
        images: []
    },
    position: 'absolute',
    bottom: 'X2',
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 10,
    theme: 'canvas-card-glass',
    minHeight: 'auto',
    boxSize: 'auto',
    overflow: 'hidden',
    transition: 'B all defaultBezier',
    width: (el, s)=>({
            small: 'H',
            normal: 'H2',
            large: 'I'
        })[s.size],
    height: (el, s)=>s.size === 'large' ? '75dvh' : 'auto',
    maxHeight: (el, s)=>s.size === 'large' ? '75dvh' : s.size === 'normal' ? '35dvh' : 'auto',
    isSmall: (el, s)=>s.size === 'small',
    '.isSmall': {
        flow: 'x',
        align: 'center start',
        gap: '0',
        padding: '0',
        minHeight: '0',
        boxSize: 'auto'
    },
    PromptGallery: {
        show: (el, s)=>(s.images || []).length > 0 && s.size !== 'small',
        gap: 'Z',
        margin: '0',
        childProps: {
            boxSize: 'D'
        }
    },
    Textarea: {
        minWidth: (el, s)=>s.size === 'small' ? 'auto' : '100%',
        resize: 'none',
        height: (el, s)=>s.size === 'small' ? 'auto' : '100%',
        overflow: (el, s)=>s.size === 'small' ? 'hidden' : 'auto',
        transition: 'B all defaultBezier',
        minHeight: (el, s)=>{
            if (s.size === 'small') return 'auto';
            return s.size === 'large' ? '75dvh' : 'E';
        },
        maxHeight: (el, s)=>{
            if (s.size === 'small') return '35dvh';
            return s.size === 'large' ? '75dvh' : '35dvh';
        },
        paddingTop: (el, s)=>s.size === 'small' ? 'Y' : 'A',
        paddingBottom: (el, s)=>s.size === 'small' ? 'Y' : 'C',
        paddingLeft: (el, s)=>s.size === 'small' ? 'A' : 'A',
        paddingRight: (el, s)=>s.size === 'small' ? 'A' : 'A2',
        fontSize: (el, s)=>s.size === 'small' ? 'Z2' : 'A',
        flexGrow: (el, s)=>s.size === 'small' ? '1' : undefined,
        onRender: (el)=>{
            if (el.__taInit) return;
            el.__taInit = true;
            el.node.rows = 1;
        },
        onInput: (e, el, s)=>{
            if (s.size === 'small') {
                el.node.style.height = 'auto';
                el.node.style.height = Math.min(el.node.scrollHeight, window.innerHeight * 0.35) + 'px';
                return;
            }
            const maxH = s.size === 'normal' ? 0.35 : 0.65;
            el.node.style.minHeight = '';
            const scrollH = el.node.scrollHeight;
            const cap = window.innerHeight * maxH;
            if (scrollH > el.node.clientHeight) el.node.style.minHeight = Math.min(scrollH, cap) + 'px';
        },
        onPaste: (e, el, s)=>{
            const items = e.clipboardData?.items;
            if (!items) return;
            for(let i = 0; i < items.length; i++)if (items[i].type.indexOf('image') !== -1) {
                e.preventDefault();
                const blob = items[i].getAsFile();
                if (!blob) continue;
                const reader = new FileReader();
                reader.onloadend = ()=>{
                    const images = [
                        ...s.images || [],
                        reader.result
                    ];
                    s.update({
                        images: images
                    });
                };
                reader.readAsDataURL(blob);
            }
        }
    },
    PromptButtons: {
        flow: 'x',
        align: 'center start',
        gap: (el, s)=>s.size === 'small' ? 'X' : 'Z',
        fontSize: 'Z1',
        transition: 'B all defaultBezier',
        childExtends: 'NavbarButton',
        childProps: {
            padding: (el, s)=>s.size === 'small' ? 'Y' : 'Y2',
            transition: 'B all defaultBezier'
        },
        position: (el, s)=>s.size === 'small' ? 'static' : 'absolute',
        bottom: (el, s)=>s.size === 'small' ? 'auto' : 'Z',
        left: (el, s)=>s.size === 'small' ? 'auto' : 'A',
        right: (el, s)=>s.size === 'small' ? 'auto' : 'C2',
        marginRight: (el, s)=>s.size === 'small' ? 'X' : undefined,
        flexShrink: '0',
        InspectBtn: {
            icon: 'sf cursor',
            title: 'Inspect mode',
            onClick: (ev, el)=>{
                el.setCanvasMode('inspectMode');
            }
        },
        UploadBtn: {
            // `extends: 'UploadThreadImageIcon'` pointed at a non-existent
            // component → the button rendered with no icon and the wrong
            // box-model. NavbarButton (inherited via PromptButtons.childExtends)
            // already gives us the toolbar style; we just add an upload icon
            // and a hidden file input layered on top of the button surface.
            tag: 'label',
            icon: 'uploadOutline',
            title: 'Upload image',
            position: 'relative',
            cursor: 'pointer',
            Input: {
                tag: 'input',
                type: 'file',
                accept: 'image/*',
                position: 'absolute',
                inset: '0',
                opacity: '0',
                cursor: 'pointer',
                onChange: (e, el, s)=>{
                    const file = e.target.files[0];
                    if (!file || !file.type.startsWith('image/')) return;
                    const reader = new FileReader();
                    reader.onloadend = ()=>{
                        const root = s.parent?.parent || s;
                        const images = [
                            ...root.images || [],
                            reader.result
                        ];
                        root.update({
                            images: images
                        });
                        el.node.value = '';
                    };
                    reader.readAsDataURL(file);
                }
            }
        },
        ExpandBtn: {
            icon: 'arrowAngleUp',
            show: (el, s)=>s.size === 'small',
            onClick: (e, el, s)=>{
                s.update({
                    size: 'normal'
                });
            }
        }
    },
    Flex: null,
    Button: null,
    ExpandCornerBtn: {
        extends: 'NavbarButton',
        if: (el, s)=>s.size !== 'small',
        icon: (el, s)=>s.size === 'large' ? 'arrowAngleDiagonalRight' : 'arrowAngleDiagonalLeft',
        position: 'absolute',
        top: 'Z',
        right: 'Z',
        padding: 'Y2',
        fontSize: 'Z1',
        opacity: '.5',
        ':hover': {
            opacity: '1'
        },
        onClick: (e, el, s)=>{
            if (s.size === 'normal') s.update({
                size: 'large'
            });
            else s.update({
                size: 'normal'
            });
        }
    },
    MinimizeBtn: {
        extends: 'NavbarButton',
        if: (el, s)=>s.size !== 'small',
        icon: 'arrowAngleDown',
        position: 'absolute',
        bottom: 'Z',
        right: 'D',
        padding: 'Y2',
        fontSize: 'Z1',
        onClick: (e, el, s)=>{
            s.update({
                size: 'small'
            });
        }
    },
    CircleButton: {
        position: (el, s)=>s.size === 'small' ? 'relative' : 'absolute',
        bottom: (el, s)=>s.size === 'small' ? 'auto' : 'Z',
        right: (el, s)=>s.size === 'small' ? 'auto' : 'Z',
        marginRight: (el, s)=>s.size === 'small' ? 'X' : undefined,
        flexShrink: '0',
        icon: 'chevronUp',
        padding: (el, s)=>s.size === 'small' ? 'Y' : 'Z',
        theme: 'canvas-card-glass-reversed',
        Icon: {
            transform: 'rotate(45deg)'
        }
    }
};

});

parcelRegister("92iQu", function(module, exports) {

$parcel$export(module.exports, "LabsNavbar", () => $6942eb4b381ca30d$export$e7ec09455dd158ec);
// Floating "+" navbar. Appears on the workspace page and on canvas
// project pages so "create" is one click away regardless of route.
// Canvas route is `/:owner/:project`; workspace route is `/workspaces/:slug`.
//
// Picker overlays (IntegrationPickerOverlay / LibraryPickerOverlay /
// NewProjectPickerOverlay) are mounted in CanvasEditor so they appear on
// BOTH /workspaces/<slug> AND /<owner>/<key>. Setting root state is all
// that's needed — no redirects.
const $6942eb4b381ca30d$var$openPicker = (el, s, state)=>{
    s.root?.update({
        createMenuOpen: false,
        ...state
    });
};
// Open the template-picker modal.
// `opts.templateId` pre-selects a template card (default: 'blank').
// `opts.projectType` is 'library' when "New library" is clicked — we pre-set
// the templateId to 'library' so the card starts highlighted.
const $6942eb4b381ca30d$var$openNewProjectPicker = (el, s, opts)=>{
    s.root?.update({
        createMenuOpen: false,
        newProjectPicker: {
            open: true,
            tab: 'featured',
            templateId: opts && opts.templateId || 'blank',
            templateProject: opts && opts.templateProject || null,
            projectType: opts && opts.projectType || null,
            name: '',
            creating: false,
            error: null,
            _libList: null,
            _libQuery: '' // search query for library tab picker
        }
    });
};
// orgIdFromCaches is no longer called from WorkspaceNavbar directly
// (moved into NewProjectPickerOverlay's submitNewProjectPicker in workspace.js),
// but keep the helper here for any downstream callers that might reference it.
const $6942eb4b381ca30d$var$menuItem = (label, hint, iconName, onClick)=>({
        tag: 'button',
        type: 'button',
        attr: {
            role: 'menuitem'
        },
        title: label,
        display: 'flex',
        flow: 'y',
        gap: '2px',
        padding: 'Y Z',
        round: 'Z',
        border: '0',
        background: 'transparent',
        color: 'white',
        textAlign: 'left',
        cursor: 'pointer',
        ':hover': {
            background: 'gray6.05'
        },
        Name: {
            tag: 'span',
            display: 'flex',
            flow: 'x',
            gap: 'Y',
            align: 'center left',
            Icon: {
                icon: iconName,
                fontSize: 'Z2',
                opacity: '0.65',
                ariaHidden: 'true'
            },
            Label: {
                tag: 'span',
                text: label,
                fontSize: 'Z2',
                fontWeight: '600'
            }
        },
        Hint: {
            tag: 'span',
            text: hint,
            fontSize: 'Z',
            color: 'white.55'
        },
        onClick: onClick
    });
const $6942eb4b381ca30d$export$e7ec09455dd158ec = {
    position: 'absolute',
    top: '50%',
    left: 'V',
    transform: 'translateY(-50%)',
    zIndex: 30,
    padding: 'V',
    round: 'C1',
    theme: 'canvas-card-glass',
    border: '1px solid rgba(255,255,255,0.08)',
    flow: 'y',
    gap: 'V',
    align: 'center',
    pointerEvents: 'auto',
    boxShadow: '0 8px 24px rgba(0,0,0,0.35)',
    AddBtn: {
        tag: 'button',
        type: 'button',
        width: '36px',
        height: '36px',
        round: '50%',
        border: '0',
        background: 'rgba(255,255,255,0.08)',
        color: 'white',
        fontSize: 'B',
        fontWeight: '300',
        lineHeight: '1',
        cursor: 'pointer',
        title: 'Create',
        ariaLabel: 'Create project or library',
        ariaHaspopup: 'true',
        ariaExpanded: (el, s)=>s.root?.createMenuOpen ? 'true' : 'false',
        text: '+',
        ':hover': {
            background: 'rgba(255,255,255,0.18)'
        },
        onClick: (e, el, s)=>{
            e.stopPropagation();
            s.root?.update({
                createMenuOpen: !s.root?.createMenuOpen
            });
        }
    },
    CreateMenu: {
        display: (el, s)=>s.root?.createMenuOpen ? 'flex' : 'none',
        position: 'absolute',
        top: '50%',
        left: '100%',
        marginLeft: 'V',
        transform: 'translateY(-50%)',
        minWidth: '220px',
        maxHeight: 'min(60vh, calc(100vh - Z1))',
        overflowX: 'hidden',
        overflowY: 'auto',
        padding: 'V',
        round: 'Z1',
        theme: 'canvas-card-glass',
        shape: 'tooltip',
        shapeDirection: 'left',
        border: '1px solid rgba(255,255,255,0.08)',
        boxShadow: '0 10px 30px rgba(0,0,0,0.45)',
        flow: 'y',
        gap: '2px',
        role: 'menu',
        ariaLabel: "Create new\u2026",
        onKeyDown: (e, el, s)=>{
            const items = el.node.querySelectorAll('[role="menuitem"]');
            const idx = Array.from(items).indexOf(document.activeElement);
            if (e.key === 'ArrowDown') {
                e.preventDefault();
                const next = items[(idx + 1) % items.length];
                next && next.focus();
            } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                const prev = items[(idx - 1 + items.length) % items.length];
                prev && prev.focus();
            } else if (e.key === 'Home') {
                e.preventDefault();
                items[0] && items[0].focus();
            } else if (e.key === 'End') {
                e.preventDefault();
                items[items.length - 1] && items[items.length - 1].focus();
            } else if (e.key === 'Escape' || e.key === 'Tab') s.root?.update({
                createMenuOpen: false
            });
        },
        // --- Section 1: Project type quick-creates ---
        NewApp: $6942eb4b381ca30d$var$menuItem('New app', 'Blank web app project.', 'globe', (e, el, s)=>$6942eb4b381ca30d$var$openNewProjectPicker(el, s, {
                templateId: 'blank',
                projectType: 'app'
            })),
        NewPresentation: $6942eb4b381ca30d$var$menuItem('New Presentation', 'Slide deck (Symbols deck template).', 'copy', (e, el, s)=>$6942eb4b381ca30d$var$openNewProjectPicker(el, s, {
                templateId: 'deck',
                projectType: 'deck',
                templateProject: 'commercials/deck'
            })),
        NewMobile: $6942eb4b381ca30d$var$menuItem('New Mobile app', 'Mobile-first project.', 'deviceMobile', (e, el, s)=>$6942eb4b381ca30d$var$openNewProjectPicker(el, s, {
                templateId: 'blank',
                projectType: 'mobile'
            })),
        NewDesktop: $6942eb4b381ca30d$var$menuItem('New Desktop app', 'Desktop application project.', 'deviceSmallScreen', (e, el, s)=>$6942eb4b381ca30d$var$openNewProjectPicker(el, s, {
                templateId: 'blank',
                projectType: 'desktop'
            })),
        NewTV: $6942eb4b381ca30d$var$menuItem('New TV app', 'TV / large-screen project.', 'deviceBigScreen', (e, el, s)=>$6942eb4b381ca30d$var$openNewProjectPicker(el, s, {
                templateId: 'blank',
                projectType: 'tv'
            })),
        NewLibrary: $6942eb4b381ca30d$var$menuItem('New Library', 'Reusable component library.', 'library', (e, el, s)=>$6942eb4b381ca30d$var$openNewProjectPicker(el, s, {
                templateId: 'library',
                projectType: 'library'
            })),
        // --- Divider between creates and utilities ---
        Divider: {
            extends: 'Line',
            role: 'separator',
            margin: 'V 0'
        },
        // --- Section 2: Utilities ---
        LinkLibrary: $6942eb4b381ca30d$var$menuItem('Link library', 'Import an existing project as a shared library.', 'globeOutline', (e, el, s)=>$6942eb4b381ca30d$var$openPicker(el, s, {
                libraryPickerFor: '__standalone__',
                libraryPickerQuery: ''
            })),
        NewIntegration: $6942eb4b381ca30d$var$menuItem('New integration', "Connect a service (Supabase, GitHub, \u2026).", 'plus', (e, el, s)=>$6942eb4b381ca30d$var$openPicker(el, s, {
                integrationPicker: {
                    open: true,
                    step: 'kind',
                    kinds: s.root?.integrationPicker?.kinds || null,
                    query: '',
                    selectedKind: null,
                    form: {}
                }
            })),
        NewMcpConnector: $6942eb4b381ca30d$var$menuItem('New MCP connector', 'Add an MCP server (tools, resources).', 'terminal', (e, el, s)=>s.root?.update({
                createMenuOpen: false,
                _mcpConnectorPickerOpen: true,
                _mcpConnectorDraft: {
                    transport: 'sse',
                    authKind: 'none',
                    scopeType: 'workspace',
                    scopeId: null
                }
            }))
    }
};

});

parcelRegister("7OI8V", function(module, exports) {

$parcel$export(module.exports, "CanvasMainNavbar", () => $5b0f71c52fc3b122$export$7bfaa16643f463da);
// Right-side floating island navbar for the canvas PROJECT page (/<owner>/<key>).
// ONLY mounts on project canvas — never on /workspaces/* (guarded in main.js).
// Mirrors WorkspaceNavbar (left-side create pill) in visual treatment — same
// glass theme, vertical pill at viewport center-right.
//
// Islands (top → bottom):
//   PagesIsland    — active canvas page + dropdown to switch pages
//   ModesIsland    — Default / Inspect / Pan mode toggle
//   PublishIsland  — Publish button + status; wires to sdk.publishVersion
//   EnvsIsland     — dev/staging/prod env badge
//   HistoryIsland  — Undo / Redo / History panel toggle; wires to el.sdk
//   SearchIsland   — opens CommandBar search (⌘K)
//   MembersIsland  — avatar stack + invite; wires to sdk.getProjectMembers
//   SharingIsland  — share / invite link
//
// Responsive: collapses to a single dot-menu below 820 px viewport width.
//
// Design tokens used:
//   round: 'C1'        – pill rounding matching left navbar
//   theme: 'canvas-card-glass' – frosted glass (dark/light handled by DS)
//   padding: 'V'       – standard navbar padding
//   gap: 'V'           – spacing between islands
//   zIndex: 30         – same layer as WorkspaceNavbar
// ── helpers ─────────────────────────────────────────────────────────────────
// Icon-only round button — reusable island atom.
const $5b0f71c52fc3b122$var$islandBtn = (title, text, onClick)=>({
        tag: 'button',
        type: 'button',
        width: '36px',
        height: '36px',
        round: '50%',
        border: '0',
        color: 'white',
        fontSize: 'Z',
        fontWeight: '400',
        lineHeight: '1',
        cursor: 'pointer',
        title: title,
        'aria-label': title,
        text: text,
        display: 'flex',
        align: 'center center',
        background: 'transparent',
        ':hover': {
            background: 'gray1+4'
        },
        onClick: onClick
    });
// Hairline divider between island groups.
const $5b0f71c52fc3b122$var$divider = {
    tag: 'hr',
    width: '24px',
    height: '1px',
    border: '0',
    background: 'gray1+10',
    margin: '0',
    flexShrink: '0'
};
// Resolve projectId from root state (set by canvas bootstrap on project page).
const $5b0f71c52fc3b122$var$getProjectId = (s)=>s.root?.projectId || s.root?.data?._id || s.root?.data?.id || null;
const $5b0f71c52fc3b122$export$7bfaa16643f463da = {
    position: 'absolute',
    top: '50%',
    right: 'V',
    transform: 'translateY(-50%)',
    zIndex: 30,
    padding: 'V',
    round: 'C1',
    theme: 'canvas-card-glass',
    flow: 'y',
    gap: 'V',
    align: 'center',
    pointerEvents: 'auto',
    // ── Pages island ──────────────────────────────────────────────────────────
    // Shows the active canvas page name; clicking opens a dropdown to switch.
    // Wires to el.getActiveCanvasPage() / el.openCanvasPage() / el.getCanvasPages().
    PagesIsland: {
        display: 'flex',
        flow: 'y',
        gap: 'W',
        align: 'center',
        PagesLabel: {
            tag: 'span',
            fontSize: 'Z',
            color: 'gray',
            text: 'PAGE',
            letterSpacing: '.04em',
            fontWeight: '700',
            userSelect: 'none'
        },
        PagesBtn: {
            tag: 'button',
            type: 'button',
            minWidth: '56px',
            maxWidth: '80px',
            padding: 'W A',
            round: 'Z',
            border: '0',
            background: 'gray1+4',
            color: 'white',
            fontSize: 'Y1',
            fontWeight: '600',
            cursor: 'pointer',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            title: 'Switch canvas page',
            'aria-label': 'Switch canvas page',
            ':hover': {
                background: 'gray1+8'
            },
            text: (el)=>el.call('getActiveCanvasPage') || 'Default',
            onClick: (e, el, s)=>{
                e.stopPropagation();
                // Toggle the pages dropdown panel.
                s.root?.update({
                    canvasPagesOpen: !s.root?.canvasPagesOpen
                });
            }
        },
        // Pages dropdown panel — lists available canvas pages.
        PagesPanel: {
            display: (el, s)=>s.root?.canvasPagesOpen ? 'flex' : 'none',
            position: 'absolute',
            top: '0',
            right: '56px',
            minWidth: '160px',
            maxHeight: 'K',
            overflow: 'hidden auto',
            padding: 'V',
            round: 'Z1',
            theme: 'canvas-card-glass',
            flow: 'y',
            gap: 'W',
            PanelTitle: {
                tag: 'span',
                text: 'Pages',
                fontSize: 'Z1',
                fontWeight: '700',
                color: 'white',
                padding: '0 0 W'
            },
            PagesList: {
                flow: 'y',
                gap: 'W',
                onRender: (el, s)=>{
                    // Build page list from root state. Canvas pages are stored under
                    // getRootState().canvas.pages (keyed by page title).
                    const rootState = el.getRootState?.();
                    const pages = rootState?.canvas?.pages;
                    const pageKeys = pages ? Object.keys(pages) : [];
                    const all = [
                        'Default',
                        ...pageKeys.filter((k)=>k !== 'Default')
                    ];
                    const active = el.call('getActiveCanvasPage') || 'Default';
                    // Clear existing children before rebuilding.
                    if (el.node) el.node.innerHTML = '';
                    all.forEach((key)=>{
                        const isActive = key === active;
                        const item = document.createElement('button');
                        item.type = 'button';
                        item.textContent = key;
                        item.style.cssText = [
                            'display:block',
                            'width:100%',
                            'text-align:left',
                            'padding:4px 8px',
                            'border:0',
                            'border-radius:4px',
                            'font-size:12px',
                            'font-weight:' + (isActive ? '700' : '400'),
                            'cursor:pointer',
                            'background:' + (isActive ? 'rgba(255,255,255,0.1)' : 'transparent'),
                            'color:white'
                        ].join(';');
                        item.addEventListener('click', (e)=>{
                            e.stopPropagation();
                            el.call('openCanvasPage', key);
                            s.root?.update({
                                canvasPagesOpen: false
                            });
                        });
                        el.node.appendChild(item);
                    });
                }
            },
            ClosePages: {
                tag: 'button',
                type: 'button',
                text: 'Close',
                padding: 'W A',
                round: 'Z',
                border: '0',
                background: 'transparent',
                color: 'gray',
                fontSize: 'Z',
                cursor: 'pointer',
                textAlign: 'right',
                ':hover': {
                    color: 'white'
                },
                onClick: (e, el, s)=>{
                    e.stopPropagation();
                    s.root?.update({
                        canvasPagesOpen: false
                    });
                }
            }
        }
    },
    Divider0: {
        ...$5b0f71c52fc3b122$var$divider
    },
    // ── Modes island ──────────────────────────────────────────────────────────
    // Default / Inspect / Pan mode toggle. Wires to el.setCanvasMode / el.isCanvasMode.
    ModesIsland: {
        display: 'flex',
        flow: 'y',
        gap: 'W',
        align: 'center',
        ModesLabel: {
            tag: 'span',
            fontSize: 'Z',
            color: 'gray',
            text: 'MODE',
            letterSpacing: '.04em',
            fontWeight: '700',
            userSelect: 'none'
        },
        ModeDefault: {
            tag: 'button',
            type: 'button',
            title: 'Default mode',
            'aria-label': 'Default mode',
            text: "\u2196",
            width: '28px',
            height: '28px',
            round: 'Z',
            border: '0',
            fontSize: 'Z1',
            cursor: 'pointer',
            display: 'flex',
            align: 'center center',
            background: (el)=>el.call('isCanvasMode', 'defaultMode') ? 'blue.3' : 'transparent',
            color: (el)=>el.call('isCanvasMode', 'defaultMode') ? 'blue' : 'gray',
            ':hover': {
                background: 'gray1+6'
            },
            onClick: (e, el)=>{
                e.stopPropagation();
                el.call('setCanvasMode', 'defaultMode');
            }
        },
        ModeInspect: {
            tag: 'button',
            type: 'button',
            title: 'Inspect mode',
            'aria-label': 'Inspect mode',
            text: "\u2316",
            width: '28px',
            height: '28px',
            round: 'Z',
            border: '0',
            fontSize: 'Z1',
            cursor: 'pointer',
            display: 'flex',
            align: 'center center',
            background: (el)=>el.call('isCanvasMode', 'inspectMode') ? 'purple.2' : 'transparent',
            color: (el)=>el.call('isCanvasMode', 'inspectMode') ? 'purple' : 'gray',
            ':hover': {
                background: 'gray1+6'
            },
            onClick: (e, el)=>{
                e.stopPropagation();
                el.call('setCanvasMode', 'inspectMode');
            }
        },
        ModePan: {
            tag: 'button',
            type: 'button',
            title: 'Pan mode',
            'aria-label': 'Pan mode',
            text: "\u2725",
            width: '28px',
            height: '28px',
            round: 'Z',
            border: '0',
            fontSize: 'Z1',
            cursor: 'pointer',
            display: 'flex',
            align: 'center center',
            background: (el)=>el.call('isCanvasMode', 'panningMode') ? 'green.2' : 'transparent',
            color: (el)=>el.call('isCanvasMode', 'panningMode') ? 'green' : 'gray',
            ':hover': {
                background: 'gray1+6'
            },
            onClick: (e, el)=>{
                e.stopPropagation();
                el.call('setCanvasMode', 'panningMode');
            }
        }
    },
    Divider1: {
        ...$5b0f71c52fc3b122$var$divider
    },
    // ── Publish island ────────────────────────────────────────────────────────
    // Green pill: "Publish". On canvas project pages wires to sdk.publishVersion.
    PublishIsland: {
        display: 'flex',
        flow: 'y',
        gap: 'W',
        align: 'center',
        PublishBtn: {
            tag: 'button',
            type: 'button',
            height: '36px',
            minWidth: '72px',
            round: 'C1',
            border: '0',
            theme: 'success',
            color: 'white',
            fontSize: 'Z1',
            fontWeight: '700',
            padding: 'W A',
            cursor: 'pointer',
            title: 'Publish project',
            'aria-label': 'Publish project',
            text: 'Publish',
            ':hover': {
                opacity: '.88'
            },
            ':active': {
                opacity: '.78'
            },
            onClick: async (e, el, s)=>{
                e.stopPropagation();
                const sdk = el.context?.methods?.sdk;
                const projectId = $5b0f71c52fc3b122$var$getProjectId(s);
                if (!sdk?.publishVersion || !projectId) {
                    el.call('openNotification', {
                        title: 'Cannot publish',
                        message: 'No project context loaded.',
                        type: 'warning'
                    });
                    return;
                }
                try {
                    await sdk.publishVersion(projectId, {});
                    el.call('openNotification', {
                        title: 'Published',
                        message: 'Project published successfully.',
                        type: 'success'
                    });
                } catch (err) {
                    el.call('openNotification', {
                        title: 'Publish failed',
                        message: err?.message || String(err),
                        type: 'error'
                    });
                }
            }
        },
        // Status badge — shows draft / publishing / published based on root state.
        PublishStatus: {
            tag: 'span',
            fontSize: 'Z',
            fontWeight: '500',
            textAlign: 'center',
            padding: '0 A',
            color: (el, s)=>{
                const status = s.root?.publishStatus;
                if (status === 'published') return 'green';
                if (status === 'publishing') return 'yellow';
                return 'gray';
            },
            text: (el, s)=>{
                const status = s.root?.publishStatus;
                if (status === 'published') return 'published';
                if (status === 'publishing') return "publishing\u2026";
                return 'draft';
            }
        }
    },
    Divider2: {
        ...$5b0f71c52fc3b122$var$divider
    },
    // ── Envs island ───────────────────────────────────────────────────────────
    // Three environment pills: dev / staging / prod.
    // Active env highlighted; switching updates root.activeEnv.
    EnvsIsland: {
        display: 'flex',
        flow: 'y',
        gap: 'W',
        align: 'center',
        EnvLabel: {
            tag: 'span',
            fontSize: 'Z',
            color: 'gray',
            text: 'ENV',
            letterSpacing: '.04em',
            fontWeight: '700',
            userSelect: 'none'
        },
        EnvDev: {
            tag: 'button',
            type: 'button',
            text: 'dev',
            title: 'Switch to development environment',
            'aria-label': 'Development environment',
            padding: 'W',
            round: 'Z',
            border: '0',
            fontSize: 'Z',
            fontWeight: '600',
            cursor: 'pointer',
            background: (el, s)=>(s.root?.activeEnv || 'development') === 'development' ? 'blue.3' : 'transparent',
            color: (el, s)=>(s.root?.activeEnv || 'development') === 'development' ? 'blue' : 'gray',
            ':hover': {
                background: 'blue.1'
            },
            onClick: (e, el, s)=>{
                e.stopPropagation();
                s.root?.update({
                    activeEnv: 'development'
                });
            }
        },
        EnvStaging: {
            tag: 'button',
            type: 'button',
            text: 'stg',
            title: 'Switch to staging environment',
            'aria-label': 'Staging environment',
            padding: 'W',
            round: 'Z',
            border: '0',
            fontSize: 'Z',
            fontWeight: '600',
            cursor: 'pointer',
            background: (el, s)=>s.root?.activeEnv === 'staging' ? 'orange.2' : 'transparent',
            color: (el, s)=>s.root?.activeEnv === 'staging' ? 'orange' : 'gray',
            ':hover': {
                background: 'orange.1'
            },
            onClick: (e, el, s)=>{
                e.stopPropagation();
                s.root?.update({
                    activeEnv: 'staging'
                });
            }
        },
        EnvProd: {
            tag: 'button',
            type: 'button',
            text: 'prod',
            title: 'Switch to production environment',
            'aria-label': 'Production environment',
            padding: 'W',
            round: 'Z',
            border: '0',
            fontSize: 'Z',
            fontWeight: '600',
            cursor: 'pointer',
            background: (el, s)=>s.root?.activeEnv === 'production' ? 'green.2' : 'transparent',
            color: (el, s)=>s.root?.activeEnv === 'production' ? 'green' : 'gray',
            ':hover': {
                background: 'green.1'
            },
            onClick: (e, el, s)=>{
                e.stopPropagation();
                s.root?.update({
                    activeEnv: 'production'
                });
            }
        }
    },
    Divider3: {
        ...$5b0f71c52fc3b122$var$divider
    },
    // ── History island ────────────────────────────────────────────────────────
    // Undo / Redo wire directly to el.sdk.undo/redo. History toggle opens
    // the VersionsAside panel (same pattern as old MainCanvasNavbar.js).
    HistoryIsland: {
        display: 'flex',
        flow: 'y',
        gap: 'W',
        align: 'center',
        UndoBtn: {
            ...$5b0f71c52fc3b122$var$islandBtn("Undo  \u2318Z", "\u21B6", async (e, el)=>{
                e.stopPropagation();
                try {
                    await el.sdk.undo();
                } catch  {}
            })
        },
        RedoBtn: {
            ...$5b0f71c52fc3b122$var$islandBtn("Redo  \u2318\u21E7Z", "\u21B7", async (e, el)=>{
                e.stopPropagation();
                try {
                    await el.sdk.redo();
                } catch  {}
            })
        },
        HistoryBtn: {
            ...$5b0f71c52fc3b122$var$islandBtn('Version history', "\u25F7", (e, el, s)=>{
                e.stopPropagation();
                const rootState = el.getRootState?.();
                if (rootState?.toggle) rootState.toggle('isVersionsOpen', {
                    preventUpdate: true
                });
                else s.root?.update({
                    isVersionsOpen: !s.root?.isVersionsOpen
                });
            })
        }
    },
    Divider4: {
        ...$5b0f71c52fc3b122$var$divider
    },
    // ── Search island ─────────────────────────────────────────────────────────
    // Opens the canvas CommandBar / search overlay (⌘K).
    SearchIsland: {
        display: 'flex',
        flow: 'y',
        align: 'center',
        SearchBtn: {
            ...$5b0f71c52fc3b122$var$islandBtn("Search  \u2318K", "\u2315", (e, el)=>{
                e.stopPropagation();
                if (el.call('isCanvasV2')) {
                    el.call('toggleShortcutsOverlay');
                    return;
                }
                const evt = new KeyboardEvent('keydown', {
                    key: 'k',
                    metaKey: true,
                    bubbles: true,
                    cancelable: true
                });
                document.dispatchEvent(evt);
            })
        }
    },
    Divider5: {
        ...$5b0f71c52fc3b122$var$divider
    },
    // ── Members island ────────────────────────────────────────────────────────
    // Shows online-member count badge and opens member management panel.
    MembersIsland: {
        display: 'flex',
        flow: 'y',
        align: 'center',
        MembersBtn: {
            tag: 'button',
            type: 'button',
            width: '36px',
            height: '36px',
            round: '50%',
            border: '0',
            color: 'white',
            fontSize: 'Z',
            cursor: 'pointer',
            title: 'Members',
            'aria-label': 'Project members',
            display: 'flex',
            align: 'center center',
            position: 'relative',
            background: 'transparent',
            ':hover': {
                background: 'gray1+4'
            },
            onClick: (e, el, s)=>{
                e.stopPropagation();
                s.root?.update({
                    membersOpen: !s.root?.membersOpen
                });
            },
            Icon: {
                tag: 'span',
                text: "\uD83D\uDC65",
                fontSize: 'Z1',
                lineHeight: '1',
                pointerEvents: 'none'
            },
            CountBadge: {
                tag: 'span',
                position: 'absolute',
                top: '1px',
                right: '1px',
                minWidth: '14px',
                height: '14px',
                round: 'C1',
                background: 'blue',
                color: 'white',
                fontSize: 'Y',
                fontWeight: '700',
                display: 'flex',
                align: 'center center',
                padding: '0 3px',
                pointerEvents: 'none',
                text: (el, s)=>{
                    const count = s.root?.activeMembers || 0;
                    return count > 0 ? String(count) : '';
                },
                hide: (el, s)=>!(s.root?.activeMembers > 0)
            }
        },
        MembersPanel: {
            display: (el, s)=>s.root?.membersOpen ? 'flex' : 'none',
            position: 'absolute',
            top: '0',
            right: '56px',
            minWidth: '220px',
            maxHeight: 'K',
            overflow: 'hidden auto',
            padding: 'V',
            round: 'Z1',
            theme: 'canvas-card-glass',
            flow: 'y',
            gap: 'V',
            PanelTitle: {
                tag: 'span',
                text: 'Members',
                fontSize: 'Z1',
                fontWeight: '700',
                color: 'white'
            },
            MembersList: {
                flow: 'y',
                gap: 'W',
                tag: 'ul',
                padding: '0',
                margin: '0',
                style: {
                    listStyle: 'none'
                },
                children: (el, s)=>{
                    const members = s.root?.projectMembers || [];
                    if (!members.length) return [
                        {
                            tag: 'li',
                            text: 'No members loaded.',
                            fontSize: 'Z',
                            color: 'gray',
                            padding: 'W 0'
                        }
                    ];
                    return members.map((m)=>({
                            tag: 'li',
                            display: 'flex',
                            flow: 'x',
                            gap: 'A',
                            align: 'center',
                            padding: 'W 0',
                            fontSize: 'Z',
                            color: 'white',
                            Avatar: {
                                tag: 'span',
                                width: '24px',
                                height: '24px',
                                round: '50%',
                                background: 'blue.4',
                                display: 'flex',
                                align: 'center center',
                                fontSize: 'Y',
                                fontWeight: '700',
                                color: 'white',
                                text: (m.name || m.email || '?')[0].toUpperCase(),
                                flexShrink: '0'
                            },
                            Name: {
                                tag: 'span',
                                text: m.name || m.email || 'Unknown',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                            }
                        }));
                },
                onRender: async (el, s)=>{
                    if (el.__membersFetched) return;
                    const sdk = el.context?.methods?.sdk;
                    const projectId = $5b0f71c52fc3b122$var$getProjectId(s);
                    if (!sdk?.getProjectMembers || !projectId) return;
                    el.__membersFetched = true;
                    try {
                        const result = await sdk.getProjectMembers(projectId);
                        const members = result?.data || result || [];
                        s.root?.update({
                            projectMembers: members
                        });
                    } catch  {}
                }
            },
            InviteBtn: {
                tag: 'button',
                type: 'button',
                text: '+ Invite',
                fontSize: 'Z1',
                fontWeight: '600',
                padding: 'W A',
                round: 'Z',
                border: '0',
                background: 'blue.2',
                color: 'blue',
                cursor: 'pointer',
                ':hover': {
                    background: 'blue.3'
                },
                onClick: (e, el, s)=>{
                    e.stopPropagation();
                    s.root?.update({
                        membersOpen: false,
                        sharingOpen: true
                    });
                }
            }
        }
    },
    Divider6: {
        ...$5b0f71c52fc3b122$var$divider
    },
    // ── Sharing island ────────────────────────────────────────────────────────
    // Share icon → opens sharing/invite-link dialog.
    SharingIsland: {
        display: 'flex',
        flow: 'y',
        align: 'center',
        ShareBtn: {
            ...$5b0f71c52fc3b122$var$islandBtn('Share project', "\u2B06", (e, el, s)=>{
                e.stopPropagation();
                s.root?.update({
                    sharingOpen: !s.root?.sharingOpen
                });
            })
        },
        SharePanel: {
            display: (el, s)=>s.root?.sharingOpen ? 'flex' : 'none',
            position: 'absolute',
            bottom: '0',
            right: '56px',
            minWidth: '280px',
            padding: 'V',
            round: 'Z1',
            theme: 'canvas-card-glass',
            flow: 'y',
            gap: 'V',
            PanelTitle: {
                tag: 'span',
                text: 'Share',
                fontSize: 'Z1',
                fontWeight: '700',
                color: 'white'
            },
            LinkRow: {
                display: 'flex',
                flow: 'x',
                gap: 'V',
                align: 'center',
                LinkInput: {
                    tag: 'input',
                    type: 'text',
                    readOnly: true,
                    flex: '1',
                    padding: 'W A',
                    round: 'Z',
                    borderWidth: '1px',
                    borderStyle: 'solid',
                    borderColor: 'line',
                    background: 'gray1+3',
                    color: 'white',
                    fontSize: 'Z',
                    value: (el)=>{
                        if (typeof window === 'undefined') return '';
                        return window.location.href;
                    },
                    onClick: (e, el)=>{
                        try {
                            el.node.select();
                        } catch  {}
                    }
                },
                CopyBtn: {
                    tag: 'button',
                    type: 'button',
                    text: 'Copy',
                    padding: 'W A',
                    round: 'Z',
                    border: '0',
                    background: 'blue.2',
                    color: 'blue',
                    fontSize: 'Z',
                    fontWeight: '700',
                    cursor: 'pointer',
                    ':hover': {
                        background: 'blue.3'
                    },
                    onClick: async (e, el)=>{
                        e.stopPropagation();
                        try {
                            await navigator.clipboard.writeText(window.location.href);
                            el.node.textContent = 'Copied!';
                            setTimeout(()=>{
                                if (el.node) el.node.textContent = 'Copy';
                            }, 1800);
                        } catch  {
                            el.call('openNotification', {
                                title: 'Copy failed',
                                message: 'Please copy the URL manually.',
                                type: 'error'
                            });
                        }
                    }
                }
            },
            CloseShare: {
                tag: 'button',
                type: 'button',
                text: 'Close',
                padding: 'W A',
                round: 'Z',
                border: '0',
                background: 'transparent',
                color: 'gray',
                fontSize: 'Z',
                cursor: 'pointer',
                textAlign: 'right',
                ':hover': {
                    color: 'white'
                },
                onClick: (e, el, s)=>{
                    e.stopPropagation();
                    s.root?.update({
                        sharingOpen: false
                    });
                }
            }
        }
    },
    // ── Responsive collapse ───────────────────────────────────────────────────
    // Below 820 px the full pill collapses to a single DotMenu button.
    DotMenu: {
        tag: 'button',
        type: 'button',
        width: '36px',
        height: '36px',
        round: '50%',
        border: '0',
        color: 'white',
        fontSize: 'B',
        cursor: 'pointer',
        title: 'Canvas actions',
        'aria-label': 'Canvas actions menu',
        text: "\u22EE",
        display: 'none',
        background: 'transparent',
        ':hover': {
            background: 'gray1+4'
        },
        style: {
            '@media (max-width: 820px)': {
                display: 'flex'
            }
        },
        onClick: (e, el, s)=>{
            e.stopPropagation();
            s.root?.update({
                canvasRightMenuOpen: !s.root?.canvasRightMenuOpen
            });
        }
    }
};

});

parcelRegister("dlKjK", function(module, exports) {

$parcel$export(module.exports, "CanvasOverlay", () => $9b812a37ea87faef$export$31faf58a4a93e543);
$parcel$export(module.exports, "DropOverlay", () => $9b812a37ea87faef$export$c89bedeb4ad1e44c);
const $9b812a37ea87faef$var$applyRect = (node, targetEl, titleNode, label)=>{
    const target = targetEl?.Flex?.node || targetEl?.node;
    if (!target?.getBoundingClientRect) {
        node.style.display = 'none';
        return false;
    }
    const { x: x, y: y, width: width, height: height } = target.getBoundingClientRect();
    node.style.display = 'block';
    node.style.transform = `translate3d(${x}px, ${y}px, 0)`;
    node.style.width = `${width}px`;
    node.style.height = `${height}px`;
    if (titleNode) titleNode.textContent = label || '';
    return true;
};
const $9b812a37ea87faef$export$31faf58a4a93e543 = {
    position: 'fixed',
    inset: '0',
    pointerEvents: 'none',
    overflow: 'hidden',
    childExtends: {
        data: {},
        position: 'absolute',
        round: 'W'
    },
    Hovered: {
        outline: '#2485F0 1.5px solid',
        display: 'none',
        Title: {
            tag: 'span',
            position: 'absolute',
            top: '-A2',
            left: '0',
            fontSize: 'Z',
            fontFamily: 'smbls',
            color: 'title',
            whiteSpace: 'nowrap',
            pointerEvents: 'none',
            textShadow: '0 2px 2px rgba(35, 35, 35, 0.5)',
            transformOrigin: '0 0',
            transform: 'translate3d(0, -40%, 0)'
        },
        DragHandler: {}
    },
    Selected: {
        display: 'none',
        SelectedNavbar: {},
        Rect: {
            position: 'absolute',
            inset: '0',
            outline: '#2485F0 2.25px solid',
            DragHandler: {}
        },
        ResizeOverlay: {}
    },
    LayerHovered: {
        outline: '#2485F0CC 1px solid',
        display: 'none'
    },
    LayerSelected: {
        outline: '#2485F0 2.5px solid',
        display: 'none',
        SelectedLayerNavbar: null
    },
    HoveredExtendComponent: {
        outline: '#E9823222 1px solid',
        background: '#E9823222',
        display: 'none'
    },
    SelectedExtendComponent: {
        outline: '#E9823222 2.25px solid',
        background: '#E9823222',
        display: 'none'
    },
    onFrame: (el)=>{
        const gs = window.__canvasGlobalScope || el.context?.globalScope;
        if (!gs) return;
        const { hovered: hovered, hoveredKey: hoveredKey, selected: selected, selectedKey: selectedKey } = gs;
        const isPanning = gs.panningMode || gs.isGrabbing;
        // --- Hovered ---
        if (isPanning || !hovered || hovered === selected) {
            if (el.Hovered.node.style.display !== 'none') el.Hovered.node.style.display = 'none';
        } else $9b812a37ea87faef$var$applyRect(el.Hovered.node, hovered, el.Hovered.Title?.node, hoveredKey);
        // --- Selected ---
        if (!selected || isPanning) {
            if (el.Selected.node.style.display !== 'none') el.Selected.node.style.display = 'none';
        } else {
            $9b812a37ea87faef$var$applyRect(el.Selected.node, selected, null, selectedKey);
            // Always sync navbar title — reactive effect has no sources from creation
            const navbar = el.Selected.SelectedNavbar;
            const textEl = navbar?.NavbarButtonSet_title?.Text;
            if (textEl?.node && textEl.node.textContent !== selectedKey) {
                if (navbar?.state) {
                    navbar.state.key = selectedKey;
                    // Ensure isEditMode stays false (it's set to true on element.update({force:true}))
                    if (navbar.state.isEditMode) navbar.state.isEditMode = false;
                }
                textEl.node.textContent = selectedKey || '';
            }
        }
        // --- Layer hover (inspect mode) ---
        if (gs.inspectMode && gs.hoverLayer && gs.layerHostComponent) {
            const collection = el.call('getCanvasCollection');
            if (collection) {
                let target = collection.lookdown?.((child)=>child.state?.key === gs.layerHostComponent);
                if (target) {
                    for (const key of gs.hoverLayer)if (target[key]) target = target[key];
                    if (target?.node) $9b812a37ea87faef$var$applyRect(el.LayerHovered.node, target);
                    else el.LayerHovered.node.style.display = 'none';
                }
            }
        } else if (el.LayerHovered?.node?.style.display !== 'none') el.LayerHovered.node.style.display = 'none';
    }
};
const $9b812a37ea87faef$export$c89bedeb4ad1e44c = {
    position: 'absolute',
    inset: 'X',
    round: 'Z2',
    outline: '#2485F099 2px solid',
    background: '#2485F026',
    opacity: '0',
    visibility: 'hidden',
    pointerEvents: 'none',
    zIndex: 1,
    transition: 'B2 defaultBezier',
    transitionProperty: 'visibility, opacity'
};

});

parcelRegister("kuZDh", function(module, exports) {

$parcel$export(module.exports, "CanvasOverlayV2", () => $eec66af0b573ade4$export$2fcc538eeb74edc8);
// Canvas v2 chrome overlay. Lives inside CanvasEditor (`position:fixed,
// inset:0, pointerEvents:none, zIndex:100`). Every layer here is in
// SCREEN-SPACE pixels — they do not zoom with the canvas. State lives
// in v2 reactive store; positions update imperatively from
// state.js / pointer.js / selection.js so 60fps gestures don't trigger
// re-renders.
//
// Layer keys use a `Cv` prefix so PascalCase auto-extend doesn't
// accidentally pull in shared/preview/brand components.
//
// Layer stack (bottom → top):
//   CvConnectors   — future: arrows between artboards (SVG)
//   CvGuidesLayer  — user-drawn ruler guides
//   CvSnapLines    — fixed pool of 4 snap-feedback lines
//   CvMarquee      — selection rect during marquee drag
//   CvSelectionBox — outline around selection bbox
//   CvHandle*      — 8 resize handles
//   CvSelectedHost — wraps shared SelectedNavbar above selection
//   CvRulerTop/Left/Corner — drag-to-spawn guides
//   CvModesBar     — V/H/I mode toolbar
//   CvCanvasSettingsModal — opens from chrome trigger; toggles snap/grid
// Inset so screen-space chrome (rulers, drag marquee) doesn't visually
// overlap the fixed CanvasAppHeader (top) or floating WorkspaceNavbar
// (left). Use DS spacing token `D` (67px) — clears the 56px header and
// the 36px-wide left navbar with ~8px breathing room.
const $eec66af0b573ade4$var$NAV_INSET = 'D';
// Ruler corner / strip thickness — DS token `A` (16px). Used for both
// the corner square and the ruler strip width.
const $eec66af0b573ade4$var$RULER_THICKNESS = 'A';
// Plain CSS-variable forms for use inside CSS function args (clip-path,
// calc) where the DOMQL token resolver doesn't reach.
const $eec66af0b573ade4$var$NAV_INSET_VAR = 'var(--spacing-d)';
const $eec66af0b573ade4$var$RULER_THICKNESS_VAR = 'var(--spacing-a)';
const $eec66af0b573ade4$var$handleBase = {
    tag: 'div',
    position: 'absolute',
    width: '14px',
    height: '14px',
    background: 'rgba(64,156,255,1)',
    pointerEvents: 'auto',
    touchAction: 'none',
    boxSizing: 'border-box'
};
const $eec66af0b573ade4$var$handle = (handleKey, cursor)=>({
        ...$eec66af0b573ade4$var$handleBase,
        attr: {
            'data-handle': handleKey,
            'aria-label': `Resize ${handleKey.toUpperCase()}`
        },
        style: {
            display: 'none',
            border: '2px solid white',
            borderRadius: '3px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.4)',
            transform: 'translate(-50%, -50%)',
            transition: 'transform 80ms ease, box-shadow 80ms ease',
            cursor: cursor,
            ':hover': {
                transform: 'translate(-50%, -50%) scale(1.25)',
                boxShadow: '0 2px 6px rgba(0,0,0,0.5)'
            }
        },
        onPointerDown: (ev, el)=>{
            ev.stopPropagation();
            const v2 = el.call('getCanvasV2');
            const key = v2?.selection?.primary;
            if (!key) return;
            el.call('beginResize', ev, key, handleKey);
        },
        onPointerMove: (ev, el)=>el.call('trackPointerMove', ev),
        onPointerUp: (ev, el)=>el.call('trackPointerEnd', ev),
        onPointerCancel: (ev, el)=>el.call('trackPointerEnd', ev)
    });
const $eec66af0b573ade4$var$ruler = (axis)=>({
        tag: 'div',
        position: 'absolute',
        pointerEvents: 'auto',
        touchAction: 'none',
        background: 'rgba(0,0,0,0.6)',
        style: {
            cursor: axis === 'h' ? 'ns-resize' : 'ew-resize',
            backgroundImage: axis === 'h' ? 'repeating-linear-gradient(to right, rgba(255,255,255,0.25) 0 1px, transparent 1px 50px)' : 'repeating-linear-gradient(to bottom, rgba(255,255,255,0.25) 0 1px, transparent 1px 50px)',
            [axis === 'h' ? 'borderBottom' : 'borderRight']: '1px solid rgba(255,255,255,0.15)'
        },
        onPointerDown: (ev, el)=>el.call('spawnGuide', axis, ev),
        onPointerMove: (ev, el)=>el.call('trackPointerMove', ev),
        onPointerUp: (ev, el)=>el.call('trackPointerEnd', ev),
        onPointerCancel: (ev, el)=>el.call('trackPointerEnd', ev)
    });
const $eec66af0b573ade4$var$modeBtn = (mode, label, key)=>({
        tag: 'button',
        type: 'button',
        text: `${label}  ${key.toUpperCase()}`,
        attr: {
            'data-mode': mode,
            title: `${label} (${key.toUpperCase()})`,
            'aria-label': label
        },
        background: 'transparent',
        border: '0',
        color: 'white',
        fontSize: 'Y',
        padding: 'W A',
        round: 'Y',
        cursor: 'pointer',
        pointerEvents: 'auto',
        isActive: (el)=>el.call('getCanvasMode') === mode,
        '.isActive': {
            background: 'rgba(64,156,255,0.4)'
        },
        onClick: (ev, el)=>{
            ev.stopPropagation();
            el.call('setCanvasV2Mode', mode);
        }
    });
const $eec66af0b573ade4$var$settingsRow = (label, control)=>({
        tag: 'label',
        display: 'flex',
        flow: 'x',
        align: 'center space-between',
        gap: 'A',
        padding: 'W 0',
        fontSize: 'Y',
        CvLabel: {
            tag: 'span',
            text: label,
            color: 'white',
            opacity: '.85'
        },
        CvControl: control
    });
const $eec66af0b573ade4$export$2fcc538eeb74edc8 = {
    tag: 'div',
    position: 'absolute',
    inset: '0',
    pointerEvents: 'none',
    if: (el)=>el.call('isCanvasV2'),
    onRender: (el)=>{
        if (el.__cvChromeInit) return;
        el.__cvChromeInit = true;
        el.call('refreshCanvasChrome');
    },
    CvConnectors: {
        tag: 'svg',
        position: 'absolute',
        inset: '0',
        pointerEvents: 'none',
        style: {
            display: 'block',
            width: '100%',
            height: '100%'
        }
    },
    CvGuidesLayer: {
        tag: 'div',
        position: 'absolute',
        inset: '0',
        pointerEvents: 'none',
        children: (el)=>{
            const v2 = el.call('getCanvasV2');
            if (!v2) return [];
            const h = (v2.guides.horizontal || []).map((pos, i)=>({
                    axis: 'h',
                    pos: pos,
                    index: i
                }));
            const v = (v2.guides.vertical || []).map((pos, i)=>({
                    axis: 'v',
                    pos: pos,
                    index: i
                }));
            return [
                ...h,
                ...v
            ];
        },
        childrenAs: 'state',
        childExtends: 'CanvasGuide'
    },
    CvSnapLines: {
        tag: 'div',
        position: 'absolute',
        inset: '0',
        pointerEvents: 'none',
        Line1: {
            tag: 'div',
            position: 'absolute',
            background: 'rgba(64,156,255,1)',
            style: {
                display: 'none'
            }
        },
        Line2: {
            tag: 'div',
            position: 'absolute',
            background: 'rgba(64,156,255,1)',
            style: {
                display: 'none'
            }
        },
        Line3: {
            tag: 'div',
            position: 'absolute',
            background: 'rgba(64,156,255,1)',
            style: {
                display: 'none'
            }
        },
        Line4: {
            tag: 'div',
            position: 'absolute',
            background: 'rgba(64,156,255,1)',
            style: {
                display: 'none'
            }
        }
    },
    // Viewport-sized clip wrapper so the drag-to-select marquee is
    // visually clipped to the non-nav region. CvMarquee's imperative
    // `left/top` remain in screen coords; the clip-path on this parent
    // hides whatever bleeds into the top header or left floating navbar.
    CvDragAreaClip: {
        tag: 'div',
        position: 'absolute',
        inset: '0',
        pointerEvents: 'none',
        style: {
            clipPath: `inset(${$eec66af0b573ade4$var$NAV_INSET_VAR} 0 0 ${$eec66af0b573ade4$var$NAV_INSET_VAR})`
        },
        CvMarquee: {
            tag: 'div',
            position: 'absolute',
            pointerEvents: 'none',
            background: 'rgba(64,156,255,0.12)',
            style: {
                outline: '1px solid rgba(64,156,255,0.9)',
                display: 'none',
                left: '0',
                top: '0',
                width: '0',
                height: '0'
            }
        }
    },
    // Group bounding boxes — dashed outlines drawn behind selection. One
    // div per group, populated imperatively by refreshCanvasChrome.
    CvGroupsLayer: {
        tag: 'div',
        position: 'absolute',
        inset: '0',
        pointerEvents: 'none'
    },
    CvSelectionBox: {
        tag: 'div',
        position: 'absolute',
        pointerEvents: 'auto',
        touchAction: 'none',
        boxSizing: 'border-box',
        style: {
            display: 'none',
            outline: '2px solid rgba(64,156,255,1)',
            outlineOffset: '0px',
            background: 'rgba(64,156,255,0.04)',
            boxShadow: '0 0 0 1px rgba(255,255,255,0.15) inset',
            cursor: 'move',
            left: '0',
            top: '0',
            width: '0',
            height: '0'
        },
        onPointerDown: (ev, el)=>{
            ev.stopPropagation();
            const v2 = el.call('getCanvasV2');
            const primary = v2?.selection?.primary;
            if (primary) el.call('beginDrag', ev, primary);
        },
        onPointerMove: (ev, el)=>el.call('trackPointerMove', ev),
        onPointerUp: (ev, el)=>el.call('trackPointerEnd', ev),
        onPointerCancel: (ev, el)=>el.call('trackPointerEnd', ev)
    },
    CvHandleNW: $eec66af0b573ade4$var$handle('nw', 'nwse-resize'),
    CvHandleN: $eec66af0b573ade4$var$handle('n', 'ns-resize'),
    CvHandleNE: $eec66af0b573ade4$var$handle('ne', 'nesw-resize'),
    CvHandleE: $eec66af0b573ade4$var$handle('e', 'ew-resize'),
    CvHandleSE: $eec66af0b573ade4$var$handle('se', 'nwse-resize'),
    CvHandleS: $eec66af0b573ade4$var$handle('s', 'ns-resize'),
    CvHandleSW: $eec66af0b573ade4$var$handle('sw', 'nesw-resize'),
    CvHandleW: $eec66af0b573ade4$var$handle('w', 'ew-resize'),
    // Per-item titles in screen-space — populated imperatively by
    // refreshCanvasChrome. Each title sits just above its item.
    CvItemTitles: {
        tag: 'div',
        position: 'absolute',
        inset: '0',
        pointerEvents: 'none'
    },
    CvSelectedHost: {
        tag: 'div',
        position: 'absolute',
        pointerEvents: 'none',
        style: {
            display: 'none',
            left: '0',
            top: '0',
            width: '0',
            height: '0'
        },
        SelectedNavbar: {
            pointerEvents: 'auto'
        }
    },
    CvRulerCorner: {
        tag: 'div',
        position: 'absolute',
        top: $eec66af0b573ade4$var$NAV_INSET,
        left: $eec66af0b573ade4$var$NAV_INSET,
        width: $eec66af0b573ade4$var$RULER_THICKNESS,
        height: $eec66af0b573ade4$var$RULER_THICKNESS,
        pointerEvents: 'none',
        background: 'rgba(0,0,0,0.7)',
        show: (el)=>!!el.call('getCanvasV2')?.showRulers,
        style: {
            borderRight: '1px solid rgba(255,255,255,0.15)',
            borderBottom: '1px solid rgba(255,255,255,0.15)'
        }
    },
    CvRulerTop: {
        ...$eec66af0b573ade4$var$ruler('h'),
        top: $eec66af0b573ade4$var$NAV_INSET,
        left: `calc(${$eec66af0b573ade4$var$NAV_INSET_VAR} + ${$eec66af0b573ade4$var$RULER_THICKNESS_VAR})`,
        right: '0',
        height: $eec66af0b573ade4$var$RULER_THICKNESS,
        show: (el)=>!!el.call('getCanvasV2')?.showRulers
    },
    CvRulerLeft: {
        ...$eec66af0b573ade4$var$ruler('v'),
        top: `calc(${$eec66af0b573ade4$var$NAV_INSET_VAR} + ${$eec66af0b573ade4$var$RULER_THICKNESS_VAR})`,
        left: $eec66af0b573ade4$var$NAV_INSET,
        bottom: '0',
        width: $eec66af0b573ade4$var$RULER_THICKNESS,
        show: (el)=>!!el.call('getCanvasV2')?.showRulers
    },
    CvModesBar: {
        tag: 'div',
        position: 'absolute',
        bottom: 'X2',
        left: 'X2',
        pointerEvents: 'auto',
        display: 'flex',
        flow: 'x',
        gap: 'W',
        padding: 'W',
        round: 'Z',
        background: 'rgba(0,0,0,0.7)',
        style: {
            backdropFilter: 'blur(8px)'
        },
        CvModeMove: $eec66af0b573ade4$var$modeBtn('default', "\u2725 Move", 'v'),
        CvModePan: $eec66af0b573ade4$var$modeBtn('pan', "\u270B Pan", 'h'),
        CvModeInteract: $eec66af0b573ade4$var$modeBtn('interact', "\u261E Interact", 'u'),
        CvModeInspect: $eec66af0b573ade4$var$modeBtn('inspect', "\u2316 Inspect", 'i')
    },
    // Replaced by the unified `SettingsModal` mounted from CanvasEditor.
    // Kept as `null` so the legacy key in the parent tree explicitly opts
    // out of re-creating the old v2-scoped modal.
    CvCanvasSettingsModal: null,
    // Right-click context menu — positioned imperatively at click point.
    CvContextMenu: {
        tag: 'div',
        position: 'absolute',
        pointerEvents: 'auto',
        background: '#1c1f24',
        color: 'white',
        round: 'W',
        padding: 'W',
        fontSize: 'Y',
        style: {
            display: 'none',
            left: '0',
            top: '0',
            minWidth: '180px',
            boxShadow: '0 8px 24px rgba(0,0,0,0.6)',
            border: '1px solid rgba(255,255,255,0.1)',
            zIndex: '210'
        },
        onPointerDown: (ev)=>ev.stopPropagation(),
        Duplicate: {
            tag: 'div',
            text: "Duplicate  \u2318D",
            padding: 'W A',
            cursor: 'pointer',
            round: 'W',
            style: {
                ':hover': {
                    background: 'rgba(255,255,255,0.08)'
                }
            },
            onClick: (ev, el)=>{
                ev.stopPropagation();
                el.call('duplicateSelection');
                el.call('hideContextMenu');
            }
        },
        Delete: {
            tag: 'div',
            text: "Delete  \u232B",
            padding: 'W A',
            cursor: 'pointer',
            round: 'W',
            style: {
                ':hover': {
                    background: 'rgba(255,255,255,0.08)'
                }
            },
            onClick: (ev, el)=>{
                ev.stopPropagation();
                el.call('deleteSelection');
                el.call('hideContextMenu');
            }
        },
        GroupBtn: {
            tag: 'div',
            text: "Group  \u2318G",
            padding: 'W A',
            cursor: 'pointer',
            round: 'W',
            style: {
                ':hover': {
                    background: 'rgba(255,255,255,0.08)'
                }
            },
            onClick: (ev, el)=>{
                ev.stopPropagation();
                el.call('group');
                el.call('hideContextMenu');
            }
        },
        UngroupBtn: {
            tag: 'div',
            text: "Ungroup  \u2318\u21E7G",
            padding: 'W A',
            cursor: 'pointer',
            round: 'W',
            style: {
                ':hover': {
                    background: 'rgba(255,255,255,0.08)'
                }
            },
            onClick: (ev, el)=>{
                ev.stopPropagation();
                const v2 = el.call('getCanvasV2');
                const ids = v2?.selection?.ids || [];
                Object.entries(v2?.groups || {}).filter(([, g])=>g.children.some((c)=>ids.includes(c))).forEach(([gid])=>el.call('ungroup', gid));
                el.call('hideContextMenu');
            }
        },
        Sep1: {
            tag: 'div',
            height: '1px',
            background: 'rgba(255,255,255,0.1)',
            margin: 'W 0'
        },
        SelectAll: {
            tag: 'div',
            text: "Select all  \u2318A",
            padding: 'W A',
            cursor: 'pointer',
            round: 'W',
            style: {
                ':hover': {
                    background: 'rgba(255,255,255,0.08)'
                }
            },
            onClick: (ev, el)=>{
                ev.stopPropagation();
                el.call('selectMany', Object.keys(el.call('getCanvasV2')?.items || {}));
                el.call('hideContextMenu');
            }
        },
        AutoLayout: {
            tag: 'div',
            text: "Auto-layout  \u2318L",
            padding: 'W A',
            cursor: 'pointer',
            round: 'W',
            style: {
                ':hover': {
                    background: 'rgba(255,255,255,0.08)'
                }
            },
            onClick: (ev, el)=>{
                ev.stopPropagation();
                el.call('autoLayout');
                el.call('hideContextMenu');
            }
        },
        ResetView: {
            tag: 'div',
            text: "Reset view  \u23180",
            padding: 'W A',
            cursor: 'pointer',
            round: 'W',
            style: {
                ':hover': {
                    background: 'rgba(255,255,255,0.08)'
                }
            },
            onClick: (ev, el)=>{
                ev.stopPropagation();
                el.call('resetCanvasView');
                el.call('hideContextMenu');
            }
        }
    },
    // Minimap — small bottom-left overview of all items + viewport rect.
    // Rendered imperatively by refreshCanvasChrome.
    CvMinimap: {
        tag: 'div',
        position: 'absolute',
        bottom: '12px',
        left: '12px',
        width: '180px',
        height: '120px',
        pointerEvents: 'auto',
        cursor: 'pointer',
        background: 'rgba(0,0,0,0.55)',
        show: (el)=>!!el.call('getCanvasV2')?.showMinimap,
        style: {
            border: '1px solid rgba(255,255,255,0.15)',
            borderRadius: '4px',
            overflow: 'hidden'
        },
        onClick: (ev, el)=>{
            ev.stopPropagation();
            el.call('fitToSelection');
        }
    },
    CvShortcutsOverlay: {
        tag: 'div',
        position: 'absolute',
        inset: '0',
        pointerEvents: 'auto',
        background: 'rgba(0,0,0,0.6)',
        display: 'flex',
        align: 'center center',
        show: (el)=>!!el.call('getCanvasV2')?.shortcutsOpen,
        style: {
            backdropFilter: 'blur(4px)',
            zIndex: '210'
        },
        onPointerDown: (ev, el)=>{
            if (ev.target === el.node) el.call('toggleShortcutsOverlay');
        },
        Card: {
            tag: 'div',
            width: 'I',
            maxWidth: '92%',
            background: '#1c1f24',
            color: 'white',
            round: 'A',
            padding: 'B',
            style: {
                boxShadow: '0 30px 80px rgba(0,0,0,0.6)'
            },
            onPointerDown: (ev)=>ev.stopPropagation(),
            Title: {
                tag: 'h3',
                text: 'Keyboard shortcuts',
                fontSize: 'A',
                margin: '0 0 A'
            },
            List: {
                display: 'grid',
                style: {
                    gridTemplateColumns: 'auto 1fr',
                    gap: '8px 24px',
                    fontSize: '13px'
                },
                children: [
                    [
                        'V',
                        'Move tool'
                    ],
                    [
                        'H',
                        'Pan tool'
                    ],
                    [
                        'U',
                        'Interact tool'
                    ],
                    [
                        'I',
                        'Inspect tool'
                    ],
                    [
                        'Space (hold)',
                        'Temporary pan'
                    ],
                    [
                        "\u2318A",
                        'Select all'
                    ],
                    [
                        "\u2318D",
                        'Duplicate'
                    ],
                    [
                        'Delete',
                        'Delete'
                    ],
                    [
                        "\u2318G",
                        'Group'
                    ],
                    [
                        "\u2318\u21E7G",
                        'Ungroup'
                    ],
                    [
                        "\u2318L",
                        'Auto-layout'
                    ],
                    [
                        "\u2318Z",
                        'Undo'
                    ],
                    [
                        "\u2318\u21E7Z",
                        'Redo'
                    ],
                    [
                        'Arrows',
                        'Nudge 1px'
                    ],
                    [
                        'Shift+Arrows',
                        'Nudge 10px'
                    ],
                    [
                        "\u23180",
                        'Reset view'
                    ],
                    [
                        "\u23181",
                        'Fit selection'
                    ],
                    [
                        'Ctrl+Wheel',
                        'Zoom around cursor'
                    ],
                    [
                        'Wheel',
                        'Pan'
                    ],
                    [
                        "\u2318,",
                        'Settings'
                    ],
                    [
                        "\u2318/",
                        'This dialog'
                    ],
                    [
                        'Esc',
                        'Clear / close'
                    ]
                ].flatMap(([k, v])=>[
                        {
                            tag: 'kbd',
                            text: k,
                            padding: '2px 6px',
                            round: 'W',
                            background: 'rgba(255,255,255,0.1)',
                            fontSize: '11px',
                            style: {
                                fontFamily: 'monospace'
                            }
                        },
                        {
                            tag: 'div',
                            text: v,
                            opacity: '.85'
                        }
                    ])
            },
            Close: {
                tag: 'button',
                type: 'button',
                text: 'Close',
                cursor: 'pointer',
                marginTop: 'A',
                background: 'rgba(255,255,255,0.08)',
                color: 'white',
                padding: 'W A',
                round: 'W',
                style: {
                    border: '1px solid rgba(255,255,255,0.2)'
                },
                onClick: (ev, el)=>{
                    ev.stopPropagation();
                    el.call('toggleShortcutsOverlay');
                }
            }
        }
    },
    CvInspectOverlay: {
        tag: 'div',
        position: 'absolute',
        inset: '0',
        pointerEvents: 'none',
        show: (el)=>el.call('getCanvasMode') === 'inspect',
        style: {
            boxShadow: 'inset 0 0 0 3px rgba(64,156,255,0.55)'
        }
    }
};

});

parcelRegister("5OU8f", function(module, exports) {

$parcel$export(module.exports, "CanvasAppHeader", () => $43cd29e7a71aee67$export$792ccb0bbb7500d3);
// Canvas/workspace header. Shares every icon and slot with the intranet
// navbar via the common `AppHeader` base — only canvas-specific bits
// diverge: floating position on the panzoom board, `CommandBar` in place
// of `SearchBar`, and an SDK-driven sign-out flow.
const $43cd29e7a71aee67$var$CHROME_PATHS = new Set([
    '/dashboard',
    '/marketplace',
    '/account'
]);
const $43cd29e7a71aee67$var$isChromeRoute = (s)=>$43cd29e7a71aee67$var$CHROME_PATHS.has(s.root?.currentPath);
// Canvas chrome routes that need a specific H1 title in the AppHeader.
// The shared AppHeader.pageTitle() falls back to 'Canvas' for unrecognised
// paths — /marketplace is canvas-only so it isn't in the shared TITLES map.
// List all canvas chrome paths here so PageTitle always renders a meaningful
// H1: heading hierarchy = H1 (AppHeader.PageTitle) → H2/H3 in page content.
const $43cd29e7a71aee67$var$canvasPageTitle = (path)=>{
    if (path === '/marketplace') return 'Marketplace';
    if (path === '/dashboard') return 'Dashboard';
    if (path === '/account') return 'Account';
    // Project canvas routes (/:owner/:key) — "Canvas" is correct.
    return 'Canvas';
};
const $43cd29e7a71aee67$export$792ccb0bbb7500d3 = {
    extends: 'AppHeader',
    position: (el, s)=>$43cd29e7a71aee67$var$isChromeRoute(s) ? 'sticky' : 'fixed',
    top: '0',
    left: (el, s)=>$43cd29e7a71aee67$var$isChromeRoute(s) ? 'auto' : '0',
    right: (el, s)=>$43cd29e7a71aee67$var$isChromeRoute(s) ? 'auto' : '0',
    zIndex: '100',
    paddingLeft: 'A',
    paddingRight: 'A',
    // Override PageTitle so canvas-specific chrome routes show a correct H1.
    // The base AppHeader renders PageTitle as `tag: 'span'` (semantic-neutral
    // for the intranet where a separate H1 lives elsewhere). On canvas chrome
    // routes (/marketplace, /dashboard, /account) this IS the page-level
    // heading, so we promote it to `tag: 'h1'` to satisfy heading hierarchy:
    //   H1 = AppHeader.PageTitle → H2/H3 = section titles in page content.
    //
    // Exception: when the 404 / not-found page is active (projectNotFound or
    // single-segment dead route), the notFound page itself owns the H1
    // (StatusCode). Demote PageTitle to a non-heading so there is exactly
    // one H1 on the page.
    PageTitle: {
        tag: (el, s)=>{
            if (!s) return 'h1';
            if (s.root?.projectNotFound) return 'span';
            const path = typeof window !== 'undefined' ? window.location.pathname : s.root?.currentPath || '';
            const segs = path.split('/').filter(Boolean);
            if (segs.length === 1) return 'span';
            return 'h1';
        },
        text: (el, s)=>$43cd29e7a71aee67$var$canvasPageTitle(s.root?.currentPath || s.root?.route || '')
    },
    SearchBar: null,
    CommandBar: {
        order: '1',
        flex: '1',
        maxWidth: 'H',
        margin: '- auto'
    },
    UserActions: {
        MeWrapper: {
            MeMenu: {
                SignOutItem: {
                    // `href` is kept for native middle-/right-click ("Open in new tab")
                    // and for screen-reader announcement of the destination — but
                    // we preventDefault so the browser doesn't race ahead and
                    // navigate before sdk.logout() clears the tokens. After the
                    // logout resolves (or fails), SPA-nav to /signin so the redirect
                    // happens with the tokens already gone.
                    href: '/signin',
                    onClick: async (ev, el)=>{
                        ev.preventDefault();
                        const sdk = el.context?.methods?.sdk;
                        try {
                            await sdk?.logout?.();
                        } catch  {}
                        el.router('/signin', el.getRoot());
                    }
                }
            }
        }
    }
};

});

parcelRegister("ippGX", function(module, exports) {

$parcel$export(module.exports, "ProjectTileFrame", () => $d66e7daea463a14c$export$fad626001af4450d);
// ProjectTileFrame.js
// Base tile wrapper that provides type-aware visual framing for workspace
// project nodes. Renders all frame variants and gates visibility with
// `if:` so only the matching frame shows.
//
// Consumed as: TypeFrame: { extends: 'ProjectTileFrame' }
// in ProjectNode.Thumbnail (workspace.js).
//
// DOMQL v3.14 note: `extends` must be a static string; dynamic frame
// selection is handled via per-frame `if:` conditions keyed on
// s.projectType. This is fully reactive — state changes re-evaluate
// the `if:` prop functions and show the correct frame.
const $d66e7daea463a14c$export$fad626001af4450d = {
    position: 'absolute',
    inset: '0',
    overflow: 'hidden',
    round: 'inherit',
    pointerEvents: 'none',
    // App / website frame (default for unknown types too)
    AppFrameLayer: {
        extends: 'AppFrame',
        if: (el, s)=>!s.projectType || s.projectType === 'app' || s.projectType === 'website',
        position: 'absolute',
        inset: '0',
        round: 'inherit',
        pointerEvents: 'none'
    },
    DeckFrameLayer: {
        extends: 'DeckFrame',
        if: (el, s)=>s.projectType === 'deck',
        position: 'absolute',
        inset: '0',
        round: 'inherit',
        pointerEvents: 'none'
    },
    MobileFrameLayer: {
        extends: 'MobileFrame',
        if: (el, s)=>s.projectType === 'mobile',
        position: 'absolute',
        inset: '0',
        round: 'inherit',
        pointerEvents: 'none'
    },
    DesktopFrameLayer: {
        extends: 'DesktopFrame',
        if: (el, s)=>s.projectType === 'desktop',
        position: 'absolute',
        inset: '0',
        round: 'inherit',
        pointerEvents: 'none'
    },
    TVFrameLayer: {
        extends: 'TVFrame',
        if: (el, s)=>s.projectType === 'tv',
        position: 'absolute',
        inset: '0',
        round: 'inherit',
        pointerEvents: 'none'
    },
    LibraryFrameLayer: {
        extends: 'LibraryFrame',
        if: (el, s)=>s.projectType === 'library',
        position: 'absolute',
        inset: '0',
        round: 'inherit',
        pointerEvents: 'none'
    },
    PlatformFrameLayer: {
        extends: 'PlatformFrame',
        if: (el, s)=>s.projectType === 'platform',
        position: 'absolute',
        inset: '0',
        round: 'inherit',
        pointerEvents: 'none'
    }
};

});

parcelRegister("6A0iP", function(module, exports) {

$parcel$export(module.exports, "AppFrame", () => (parcelRequire("z2Fy0")).AppFrame);
$parcel$export(module.exports, "DeckFrame", () => (parcelRequire("bWGaY")).DeckFrame);
$parcel$export(module.exports, "MobileFrame", () => (parcelRequire("ckAr0")).MobileFrame);
$parcel$export(module.exports, "DesktopFrame", () => (parcelRequire("6fz5W")).DesktopFrame);
$parcel$export(module.exports, "TVFrame", () => (parcelRequire("jewaw")).TVFrame);
$parcel$export(module.exports, "LibraryFrame", () => (parcelRequire("b04AR")).LibraryFrame);
$parcel$export(module.exports, "PlatformFrame", () => (parcelRequire("cjt4V")).PlatformFrame);
// tile-frames/index.js
// Exports all type-specific frame components.
// ProjectTileFrame uses `if:` conditions to gate which frame renders
// based on s.projectType — no helper needed at import time.

var $z2Fy0 = parcelRequire("z2Fy0");

var $bWGaY = parcelRequire("bWGaY");

var $ckAr0 = parcelRequire("ckAr0");

var $6fz5W = parcelRequire("6fz5W");

var $jewaw = parcelRequire("jewaw");

var $b04AR = parcelRequire("b04AR");

var $cjt4V = parcelRequire("cjt4V");

});
parcelRegister("z2Fy0", function(module, exports) {

$parcel$export(module.exports, "AppFrame", () => $069557080041ec4e$export$6f788ef2c6236129);
// AppFrame — browser-window chrome for projectType='app' and 'website'.
// Shows a URL bar with dot controls, 16:10 aspect, primary-brand accent.
// The viewport area is where thumbnails inset; a faint globe glyph shows
// for empty-content state.
const $069557080041ec4e$export$6f788ef2c6236129 = {
    flow: 'column',
    width: '100%',
    height: '100%',
    round: 'inherit',
    overflow: 'hidden',
    position: 'relative',
    // Browser chrome header strip
    Chrome: {
        flexShrink: '0',
        flow: 'x',
        align: 'center',
        gap: 'V',
        padding: 'V A',
        borderBottom: '1px solid',
        borderColor: 'white.08',
        background: 'gray1.35',
        height: 'B',
        // Traffic-light dots
        Dots: {
            flow: 'x',
            gap: 'W',
            align: 'center',
            Dot_1: {
                width: 'W',
                height: 'W',
                round: '50%',
                background: 'red.85',
                flexShrink: '0'
            },
            Dot_2: {
                width: 'W',
                height: 'W',
                round: '50%',
                background: 'yellow.85',
                flexShrink: '0'
            },
            Dot_3: {
                width: 'W',
                height: 'W',
                round: '50%',
                background: 'green.85',
                flexShrink: '0'
            }
        },
        // URL bar — decorative placeholder bar
        UrlBar: {
            flexGrow: '1',
            height: 'Y',
            round: 'Z',
            background: 'white.07',
            maxWidth: 'F',
            margin: '0 auto'
        },
        // Globe indicator dot
        GlobeIcon: {
            width: 'Y',
            height: 'Y',
            round: '50%',
            background: 'blue.45',
            flexShrink: '0'
        }
    },
    // Viewport — thumbnail slots here, empty-state shows globe glyph
    Viewport: {
        flexGrow: '1',
        position: 'relative',
        overflow: 'hidden',
        background: 'black.2',
        EmptyState: {
            if: (el, s)=>!s.screenshot && !s.screenshotDev && !s.icon,
            position: 'absolute',
            inset: '0',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 'Y',
            pointerEvents: 'none',
            Glyph: {
                width: 'B',
                height: 'B',
                opacity: '0.18',
                fontSize: 'B',
                color: 'blue',
                textAlign: 'center',
                lineHeight: '1',
                text: "\u2295"
            },
            Hint: {
                tag: 'span',
                text: 'Web app',
                fontSize: 'Z1',
                color: 'white.22',
                fontStyle: 'italic'
            }
        }
    },
    // Left-border accent (primary blue)
    AccentBorder: {
        position: 'absolute',
        top: '0',
        left: '0',
        width: 'V',
        height: '100%',
        background: 'blue',
        opacity: '0.7',
        pointerEvents: 'none'
    }
};

});

parcelRegister("bWGaY", function(module, exports) {

$parcel$export(module.exports, "DeckFrame", () => $8b25d3c58ccc9765$export$dd7d44d46b12ce51);
// DeckFrame — slide-deck chrome for projectType='deck'.
// Renders a presentation slide frame: subtle shadow-stack hint at bottom,
// 16:9 proportions, warm-orange accent border.
const $8b25d3c58ccc9765$export$dd7d44d46b12ce51 = {
    flow: 'column',
    width: '100%',
    height: '100%',
    round: 'inherit',
    overflow: 'visible',
    position: 'relative',
    // Shadow stack beneath — two ghost card layers suggesting a slide deck
    ShadowCard_1: {
        position: 'absolute',
        bottom: '-V',
        left: 'V',
        right: 'V',
        height: '100%',
        round: 'inherit',
        background: 'orange.08',
        border: '1px solid',
        borderColor: 'orange.12',
        zIndex: '-2',
        pointerEvents: 'none'
    },
    ShadowCard_2: {
        position: 'absolute',
        bottom: '-Y',
        left: 'W',
        right: 'W',
        height: '100%',
        round: 'inherit',
        background: 'orange.04',
        border: '1px solid',
        borderColor: 'orange.08',
        zIndex: '-3',
        pointerEvents: 'none'
    },
    // Main slide surface
    Slide: {
        flow: 'column',
        width: '100%',
        height: '100%',
        round: 'inherit',
        overflow: 'hidden',
        position: 'relative',
        zIndex: '1',
        // Slide header bar — slide controls / speaker icon
        ChromeBar: {
            flexShrink: '0',
            flow: 'x',
            align: 'center space-between',
            padding: 'V A',
            height: 'A2',
            background: 'black.3',
            borderBottom: '1px solid',
            borderColor: 'white.06',
            SlideIndicator: {
                flow: 'x',
                gap: 'W',
                align: 'center',
                Pip_1: {
                    width: 'W',
                    height: 'W',
                    round: '50%',
                    background: 'orange.85',
                    flexShrink: '0'
                },
                Pip_2: {
                    width: 'V',
                    height: 'V',
                    round: '50%',
                    background: 'white.2',
                    flexShrink: '0'
                },
                Pip_3: {
                    width: 'V',
                    height: 'V',
                    round: '50%',
                    background: 'white.2',
                    flexShrink: '0'
                }
            },
            PageCount: {
                tag: 'span',
                text: '1 / ?',
                fontSize: 'Z1',
                color: 'white.25'
            }
        },
        // Slide canvas — thumbnail insets here
        Canvas: {
            flexGrow: '1',
            position: 'relative',
            overflow: 'hidden',
            background: 'black.18',
            EmptyState: {
                if: (el, s)=>!s.screenshot && !s.screenshotDev && !s.icon,
                position: 'absolute',
                inset: '0',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 'Y',
                pointerEvents: 'none',
                Glyph: {
                    fontSize: 'B2',
                    color: 'orange.35',
                    text: "\u2590\u258C",
                    letterSpacing: '-0.05em'
                },
                Hint: {
                    tag: 'span',
                    text: 'First slide',
                    fontSize: 'Z1',
                    color: 'white.22',
                    fontStyle: 'italic'
                }
            }
        }
    },
    // Left-border accent (orange)
    AccentBorder: {
        position: 'absolute',
        top: '0',
        left: '0',
        width: 'V',
        height: '100%',
        background: 'orange',
        opacity: '0.7',
        pointerEvents: 'none',
        zIndex: '2'
    }
};

});

parcelRegister("ckAr0", function(module, exports) {

$parcel$export(module.exports, "MobileFrame", () => $8fa39d6e8c844755$export$a441b687ed4eaca2);
// MobileFrame — phone bezel for projectType='mobile'.
// Renders a phone silhouette with notch and home-indicator bar.
// Green accent; thumbnail insets in the screen area.
const $8fa39d6e8c844755$export$a441b687ed4eaca2 = {
    flow: 'column',
    width: '100%',
    height: '100%',
    position: 'relative',
    round: 'inherit',
    overflow: 'hidden',
    alignItems: 'center',
    justifyContent: 'center',
    // Phone outline container
    PhoneOuter: {
        position: 'relative',
        width: 'D',
        height: 'E1',
        round: 'C',
        border: '2px solid',
        borderColor: 'green.35',
        background: 'black.4',
        overflow: 'hidden',
        flexShrink: '0',
        margin: 'auto',
        boxShadow: '0 0 0 0',
        // Notch
        Notch: {
            position: 'absolute',
            top: '0',
            left: '50%',
            transform: 'translateX(-50%)',
            width: 'A2',
            height: 'W',
            background: 'black.7',
            borderBottomLeftRadius: 'W',
            borderBottomRightRadius: 'W',
            zIndex: '3',
            pointerEvents: 'none'
        },
        // Screen — thumbnail insets here
        Screen: {
            position: 'absolute',
            inset: '0',
            overflow: 'hidden',
            background: 'green.06',
            EmptyState: {
                if: (el, s)=>!s.screenshot && !s.screenshotDev && !s.icon,
                position: 'absolute',
                inset: '0',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 'W',
                padding: 'A',
                pointerEvents: 'none',
                Glyph: {
                    fontSize: 'A',
                    color: 'green.5',
                    text: "\u2630",
                    marginTop: 'W'
                },
                Hint: {
                    tag: 'span',
                    text: 'Tap to design',
                    fontSize: 'Z1',
                    color: 'white.2',
                    fontStyle: 'italic',
                    textAlign: 'center',
                    lineHeight: '1.3'
                }
            }
        },
        // Home bar
        HomeBar: {
            position: 'absolute',
            bottom: 'V',
            left: '50%',
            transform: 'translateX(-50%)',
            width: 'A2',
            height: 'Z',
            round: 'Z',
            background: 'white.25',
            zIndex: '3',
            pointerEvents: 'none'
        }
    },
    // Accent border on tile
    AccentBorder: {
        position: 'absolute',
        top: '0',
        left: '0',
        width: 'V',
        height: '100%',
        background: 'green',
        opacity: '0.7',
        pointerEvents: 'none'
    }
};

});

parcelRegister("6fz5W", function(module, exports) {

$parcel$export(module.exports, "DesktopFrame", () => $48cf5de40af447d6$export$d432d3818cbe843e);
// DesktopFrame — macOS-style window chrome for projectType='desktop'.
// Traffic-light header (red/yellow/green), 16:10 aspect, gray accent.
const $48cf5de40af447d6$export$d432d3818cbe843e = {
    flow: 'column',
    width: '100%',
    height: '100%',
    round: 'inherit',
    overflow: 'hidden',
    position: 'relative',
    // macOS-style title bar
    TitleBar: {
        flexShrink: '0',
        flow: 'x',
        align: 'center',
        padding: 'V A',
        height: 'B',
        background: 'gray2.9',
        borderBottom: '1px solid',
        borderColor: 'white.06',
        gap: 'V',
        // Traffic-light buttons
        Controls: {
            flow: 'x',
            gap: 'W',
            align: 'center',
            BtnClose: {
                width: 'Y',
                height: 'Y',
                round: '50%',
                background: 'red.85',
                flexShrink: '0'
            },
            BtnMin: {
                width: 'Y',
                height: 'Y',
                round: '50%',
                background: 'yellow.85',
                flexShrink: '0'
            },
            BtnMax: {
                width: 'Y',
                height: 'Y',
                round: '50%',
                background: 'green.85',
                flexShrink: '0'
            }
        },
        // Window title (centered)
        WinTitle: {
            flexGrow: '1',
            textAlign: 'center',
            fontSize: 'Z1',
            color: 'white.28',
            text: (el, s)=>s.name || 'Desktop App',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            paddingRight: 'A'
        }
    },
    // Content area — thumbnail insets here
    ContentArea: {
        flexGrow: '1',
        position: 'relative',
        overflow: 'hidden',
        background: 'black.2',
        EmptyState: {
            if: (el, s)=>!s.screenshot && !s.screenshotDev && !s.icon,
            position: 'absolute',
            inset: '0',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 'Y',
            pointerEvents: 'none',
            Glyph: {
                fontSize: 'B',
                color: 'gray12.2',
                text: "\u2B1C"
            },
            Hint: {
                tag: 'span',
                text: 'Desktop app',
                fontSize: 'Z1',
                color: 'white.22',
                fontStyle: 'italic'
            }
        }
    },
    // Gray accent border
    AccentBorder: {
        position: 'absolute',
        top: '0',
        left: '0',
        width: 'V',
        height: '100%',
        background: 'gray9',
        opacity: '0.8',
        pointerEvents: 'none'
    }
};

});

parcelRegister("jewaw", function(module, exports) {

$parcel$export(module.exports, "TVFrame", () => $e0084727d4d79e2b$export$67f119808900c15);
// TVFrame — big-screen panel for projectType='tv'.
// Wide panel silhouette with stand, deep-blue accent.
// Thumbnail insets in the screen area.
const $e0084727d4d79e2b$export$67f119808900c15 = {
    flow: 'column',
    width: '100%',
    height: '100%',
    position: 'relative',
    round: 'inherit',
    overflow: 'hidden',
    alignItems: 'center',
    justifyContent: 'center',
    // TV outer housing
    TVPanel: {
        position: 'relative',
        width: '100%',
        height: '100%',
        flow: 'column',
        // Screen bezel
        Bezel: {
            flexGrow: '1',
            position: 'relative',
            round: 'W',
            border: '1px solid',
            borderColor: 'electricBlue.45',
            background: 'black.5',
            overflow: 'hidden',
            // Screen content — thumbnail insets here
            Screen: {
                position: 'absolute',
                inset: '0',
                overflow: 'hidden',
                background: 'electricBlue.06',
                EmptyState: {
                    if: (el, s)=>!s.screenshot && !s.screenshotDev && !s.icon,
                    position: 'absolute',
                    inset: '0',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 'Y',
                    pointerEvents: 'none',
                    Glyph: {
                        fontSize: 'B2',
                        color: 'electricBlue.3',
                        text: "\u25AC"
                    },
                    Hint: {
                        tag: 'span',
                        text: 'TV app',
                        fontSize: 'Z1',
                        color: 'white.22',
                        fontStyle: 'italic'
                    }
                }
            },
            // Power indicator LED
            PowerDot: {
                position: 'absolute',
                bottom: 'V',
                right: 'W',
                width: 'V',
                height: 'V',
                round: '50%',
                background: 'electricBlue.85',
                zIndex: '2',
                pointerEvents: 'none'
            }
        },
        // Stand neck
        Stand: {
            flexShrink: '0',
            alignSelf: 'center',
            width: 'B',
            height: 'W',
            background: 'electricBlue.3',
            borderBottomLeftRadius: 'V',
            borderBottomRightRadius: 'V'
        },
        // Stand base
        StandBase: {
            flexShrink: '0',
            alignSelf: 'center',
            width: 'C',
            height: 'V',
            round: 'Z',
            background: 'electricBlue.2'
        }
    },
    // Deep-blue accent border
    AccentBorder: {
        position: 'absolute',
        top: '0',
        left: '0',
        width: 'V',
        height: '100%',
        background: 'electricBlue',
        opacity: '0.6',
        pointerEvents: 'none'
    }
};

});

parcelRegister("b04AR", function(module, exports) {

$parcel$export(module.exports, "LibraryFrame", () => $802341faff92b43c$export$aa4348650673c7af);
// LibraryFrame — stacked-cards frame for projectType='library'.
// Shows a z-stacked card hint suggesting a reusable component collection.
// Neutral accent.
const $802341faff92b43c$export$aa4348650673c7af = {
    flow: 'column',
    width: '100%',
    height: '100%',
    position: 'relative',
    round: 'inherit',
    overflow: 'visible',
    alignItems: 'center',
    justifyContent: 'center',
    // Ghost stack layers behind main card
    Stack_3: {
        position: 'absolute',
        inset: '0',
        round: 'inherit',
        background: 'white.02',
        border: '1px solid',
        borderColor: 'white.05',
        transform: 'translateY(8px) scale(0.92)',
        zIndex: '-3',
        pointerEvents: 'none',
        overflow: 'hidden'
    },
    Stack_2: {
        position: 'absolute',
        inset: '0',
        round: 'inherit',
        background: 'white.03',
        border: '1px solid',
        borderColor: 'white.07',
        transform: 'translateY(4px) scale(0.96)',
        zIndex: '-2',
        pointerEvents: 'none',
        overflow: 'hidden'
    },
    // Main card surface
    MainCard: {
        position: 'absolute',
        inset: '0',
        round: 'inherit',
        overflow: 'hidden',
        zIndex: '1',
        background: 'black.1',
        // Library-type header strip
        HeaderStrip: {
            flexShrink: '0',
            flow: 'x',
            align: 'center',
            gap: 'V',
            padding: 'V A',
            height: 'A2',
            background: 'black.25',
            borderBottom: '1px solid',
            borderColor: 'white.05',
            Dot: {
                width: 'W',
                height: 'W',
                round: '50%',
                background: 'gray8',
                flexShrink: '0'
            },
            Label: {
                tag: 'span',
                text: 'Library',
                fontSize: 'Z1',
                color: 'white.25',
                fontWeight: '600',
                letterSpacing: '0.04em'
            }
        },
        // Content area
        Content: {
            flexGrow: '1',
            position: 'relative',
            overflow: 'hidden',
            background: 'black.12',
            EmptyState: {
                if: (el, s)=>!s.screenshot && !s.screenshotDev && !s.icon,
                position: 'absolute',
                inset: '0',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 'Y',
                pointerEvents: 'none',
                // Mini component grid glyph
                Grid: {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(3,Y)',
                    gridTemplateRows: 'repeat(2,Y)',
                    gap: 'W',
                    opacity: '0.18',
                    Cell_1: {
                        width: 'Y',
                        height: 'Y',
                        round: 'Z',
                        background: 'gray9'
                    },
                    Cell_2: {
                        width: 'Y',
                        height: 'Y',
                        round: 'Z',
                        background: 'gray9'
                    },
                    Cell_3: {
                        width: 'Y',
                        height: 'Y',
                        round: 'Z',
                        background: 'gray9'
                    },
                    Cell_4: {
                        width: 'Y',
                        height: 'Y',
                        round: 'Z',
                        background: 'gray9'
                    },
                    Cell_5: {
                        width: 'Y',
                        height: 'Y',
                        round: 'Z',
                        background: 'gray9'
                    },
                    Cell_6: {
                        width: 'Y',
                        height: 'Y',
                        round: 'Z',
                        background: 'gray7'
                    }
                },
                Hint: {
                    tag: 'span',
                    text: 'No exports yet',
                    fontSize: 'Z1',
                    color: 'white.22',
                    fontStyle: 'italic'
                }
            }
        }
    },
    // Neutral gray accent border
    AccentBorder: {
        position: 'absolute',
        top: '0',
        left: '0',
        width: 'V',
        height: '100%',
        background: 'gray8',
        opacity: '0.7',
        pointerEvents: 'none',
        zIndex: '2'
    }
};

});

parcelRegister("cjt4V", function(module, exports) {

$parcel$export(module.exports, "PlatformFrame", () => $8f6dd0c69edf65f9$export$e5a8213002db947e);
// PlatformFrame — Symbols-brand-mark chrome for projectType='platform'.
// Features the lambda/Symbols brand mark, 16:10 aspect, brand-accent color.
const $8f6dd0c69edf65f9$export$e5a8213002db947e = {
    flow: 'column',
    width: '100%',
    height: '100%',
    round: 'inherit',
    overflow: 'hidden',
    position: 'relative',
    // Header with Symbols brand mark
    BrandHeader: {
        flexShrink: '0',
        flow: 'x',
        align: 'center',
        padding: 'V A',
        height: 'B',
        background: 'electricBlue.12',
        borderBottom: '1px solid',
        borderColor: 'electricBlue.2',
        gap: 'V',
        // Lambda mark
        Lambda: {
            width: 'Y',
            height: 'Y',
            flexShrink: '0',
            fontSize: 'Z2',
            color: 'electricBlue.85',
            lineHeight: '1',
            text: "\u03BB",
            fontWeight: '700',
            fontFamily: 'monospace'
        },
        Label: {
            tag: 'span',
            text: 'Platform',
            fontSize: 'Z1',
            color: 'electricBlue.6',
            fontWeight: '600',
            letterSpacing: '0.04em'
        }
    },
    // Viewport — thumbnail insets here
    Viewport: {
        flexGrow: '1',
        position: 'relative',
        overflow: 'hidden',
        background: 'electricBlue.04',
        EmptyState: {
            if: (el, s)=>!s.screenshot && !s.screenshotDev && !s.icon,
            position: 'absolute',
            inset: '0',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 'Y',
            pointerEvents: 'none',
            Mark: {
                fontSize: 'B2',
                color: 'electricBlue.2',
                text: "\u03BB",
                fontWeight: '700',
                fontFamily: 'monospace'
            },
            Hint: {
                tag: 'span',
                text: 'Platform project',
                fontSize: 'Z1',
                color: 'white.22',
                fontStyle: 'italic'
            }
        }
    },
    // Electric-blue accent border
    AccentBorder: {
        position: 'absolute',
        top: '0',
        left: '0',
        width: 'V',
        height: '100%',
        background: 'electricBlue',
        opacity: '0.8',
        pointerEvents: 'none'
    }
};

});



parcelRegister("1NMvY", function(module, exports) {

$parcel$export(module.exports, "getSideBarContextMenu", () => (parcelRequire("70tHb")).getSideBarContextMenu);
$parcel$export(module.exports, "updateOverlay", () => (parcelRequire("luAS5")).updateOverlay);
$parcel$export(module.exports, "avatarUrl", () => (parcelRequire("grwvk")).avatarUrl);
$parcel$export(module.exports, "avatarUrlFor", () => (parcelRequire("grwvk")).avatarUrlFor);
$parcel$export(module.exports, "buildProjectUrls", () => (parcelRequire("3HmWC")).buildProjectUrls);
$parcel$export(module.exports, "normalizeProjectKey", () => (parcelRequire("3HmWC")).normalizeProjectKey);
$parcel$export(module.exports, "patchCanvas", () => (parcelRequire("14e0k")).patchCanvas);
$parcel$export(module.exports, "patchCanvasItem", () => (parcelRequire("14e0k")).patchCanvasItem);
$parcel$export(module.exports, "getCanvasV2", () => (parcelRequire("14e0k")).getCanvasV2);
$parcel$export(module.exports, "isCanvasV2", () => (parcelRequire("14e0k")).isCanvasV2);
$parcel$export(module.exports, "getCanvasItem", () => (parcelRequire("14e0k")).getCanvasItem);
$parcel$export(module.exports, "getCanvasSelection", () => (parcelRequire("14e0k")).getCanvasSelection);
$parcel$export(module.exports, "getCanvasMode", () => (parcelRequire("14e0k")).getCanvasMode);
$parcel$export(module.exports, "setCanvasV2Mode", () => (parcelRequire("14e0k")).setCanvasV2Mode);
$parcel$export(module.exports, "setViewport", () => (parcelRequire("14e0k")).setViewport);
$parcel$export(module.exports, "applyViewport", () => (parcelRequire("14e0k")).applyViewport);
$parcel$export(module.exports, "resetCanvasView", () => (parcelRequire("14e0k")).resetCanvasView);
$parcel$export(module.exports, "initCanvasV2", () => (parcelRequire("14e0k")).initCanvasV2);
$parcel$export(module.exports, "toggleCanvasSettings", () => (parcelRequire("14e0k")).toggleCanvasSettings);
$parcel$export(module.exports, "setCanvasSettings", () => (parcelRequire("14e0k")).setCanvasSettings);
$parcel$export(module.exports, "refreshCanvasChrome", () => (parcelRequire("14e0k")).refreshCanvasChrome);
$parcel$export(module.exports, "canvasToScreen", () => (parcelRequire("14e0k")).canvasToScreen);
$parcel$export(module.exports, "screenToCanvas", () => (parcelRequire("14e0k")).screenToCanvas);
$parcel$export(module.exports, "patchSnap", () => (parcelRequire("14e0k")).patchSnap);
$parcel$export(module.exports, "fitToSelection", () => (parcelRequire("14e0k")).fitToSelection);
$parcel$export(module.exports, "toggleShortcutsOverlay", () => (parcelRequire("14e0k")).toggleShortcutsOverlay);
$parcel$export(module.exports, "persistCanvasLayout", () => (parcelRequire("14e0k")).persistCanvasLayout);
$parcel$export(module.exports, "addConnection", () => (parcelRequire("14e0k")).addConnection);
$parcel$export(module.exports, "removeConnection", () => (parcelRequire("14e0k")).removeConnection);
$parcel$export(module.exports, "selectOne", () => (parcelRequire("7eH5h")).selectOne);
$parcel$export(module.exports, "toggleSelection", () => (parcelRequire("7eH5h")).toggleSelection);
$parcel$export(module.exports, "selectMany", () => (parcelRequire("7eH5h")).selectMany);
$parcel$export(module.exports, "clearSelection", () => (parcelRequire("7eH5h")).clearSelection);
$parcel$export(module.exports, "isSelected", () => (parcelRequire("7eH5h")).isSelected);
$parcel$export(module.exports, "bboxForSelection", () => (parcelRequire("6Gi6J")).bboxForSelection);
$parcel$export(module.exports, "bboxForGroup", () => (parcelRequire("6Gi6J")).bboxForGroup);
$parcel$export(module.exports, "itemsInMarqueeRect", () => (parcelRequire("6Gi6J")).itemsInMarqueeRect);
$parcel$export(module.exports, "snapRect", () => (parcelRequire("6Gi6J")).snapRect);
$parcel$export(module.exports, "trackPointerDown", () => (parcelRequire("lbCRy")).trackPointerDown);
$parcel$export(module.exports, "trackPointerMove", () => (parcelRequire("lbCRy")).trackPointerMove);
$parcel$export(module.exports, "trackPointerEnd", () => (parcelRequire("lbCRy")).trackPointerEnd);
$parcel$export(module.exports, "beginDrag", () => (parcelRequire("lbCRy")).beginDrag);
$parcel$export(module.exports, "applyDragMove", () => (parcelRequire("lbCRy")).applyDragMove);
$parcel$export(module.exports, "beginResize", () => (parcelRequire("lbCRy")).beginResize);
$parcel$export(module.exports, "applyResizeMove", () => (parcelRequire("lbCRy")).applyResizeMove);
$parcel$export(module.exports, "beginMarquee", () => (parcelRequire("lbCRy")).beginMarquee);
$parcel$export(module.exports, "applyMarqueeMove", () => (parcelRequire("lbCRy")).applyMarqueeMove);
$parcel$export(module.exports, "commitMarquee", () => (parcelRequire("lbCRy")).commitMarquee);
$parcel$export(module.exports, "beginPan", () => (parcelRequire("lbCRy")).beginPan);
$parcel$export(module.exports, "applyPanMove", () => (parcelRequire("lbCRy")).applyPanMove);
$parcel$export(module.exports, "beginPinch", () => (parcelRequire("lbCRy")).beginPinch);
$parcel$export(module.exports, "applyPinchMove", () => (parcelRequire("lbCRy")).applyPinchMove);
$parcel$export(module.exports, "onCanvasWheel", () => (parcelRequire("lbCRy")).onCanvasWheel);
$parcel$export(module.exports, "spawnGuide", () => (parcelRequire("lbCRy")).spawnGuide);
$parcel$export(module.exports, "applySpawnGuideMove", () => (parcelRequire("lbCRy")).applySpawnGuideMove);
$parcel$export(module.exports, "beginGuideDrag", () => (parcelRequire("lbCRy")).beginGuideDrag);
$parcel$export(module.exports, "commitTransient", () => (parcelRequire("lbCRy")).commitTransient);
$parcel$export(module.exports, "forgetItemRefs", () => (parcelRequire("lbCRy")).forgetItemRefs);
$parcel$export(module.exports, "group", () => (parcelRequire("gIQ4T")).group);
$parcel$export(module.exports, "ungroup", () => (parcelRequire("gIQ4T")).ungroup);
$parcel$export(module.exports, "collapseGroup", () => (parcelRequire("gIQ4T")).collapseGroup);
$parcel$export(module.exports, "groupBbox", () => (parcelRequire("6Gi6J")).bboxForGroup);
$parcel$export(module.exports, "inspectHover", () => (parcelRequire("ixb4M")).inspectHover);
$parcel$export(module.exports, "onCanvasKeydown", () => (parcelRequire("6uiEy")).onCanvasKeydown);
$parcel$export(module.exports, "onCanvasKeyup", () => (parcelRequire("6uiEy")).onCanvasKeyup);
$parcel$export(module.exports, "duplicateSelection", () => (parcelRequire("k7a70")).duplicateSelection);
$parcel$export(module.exports, "deleteSelection", () => (parcelRequire("k7a70")).deleteSelection);
$parcel$export(module.exports, "autoLayout", () => (parcelRequire("cQbHL")).autoLayout);
$parcel$export(module.exports, "showContextMenu", () => (parcelRequire("8ZnIy")).showContextMenu);
$parcel$export(module.exports, "hideContextMenu", () => (parcelRequire("8ZnIy")).hideContextMenu);
$parcel$export(module.exports, "pushHistory", () => (parcelRequire("5wc4W")).pushHistory);
$parcel$export(module.exports, "undo", () => (parcelRequire("5wc4W")).undo);
$parcel$export(module.exports, "redo", () => (parcelRequire("5wc4W")).redo);
$parcel$export(module.exports, "ensureProjectLoaded", () => (parcelRequire("7GIyE")).ensureProjectLoaded);
$parcel$export(module.exports, "reloadPage", () => (parcelRequire("7GIyE")).reloadPage);
$parcel$export(module.exports, "saveMcpConnector", () => (parcelRequire("aIuhw")).saveMcpConnector);
$parcel$export(module.exports, "reloadMcpConnectors", () => (parcelRequire("aIuhw")).reloadMcpConnectors);

var $70tHb = parcelRequire("70tHb");

var $luAS5 = parcelRequire("luAS5");

var $grwvk = parcelRequire("grwvk");

var $3HmWC = parcelRequire("3HmWC");

var $14e0k = parcelRequire("14e0k");

var $7eH5h = parcelRequire("7eH5h");

var $6Gi6J = parcelRequire("6Gi6J");

var $lbCRy = parcelRequire("lbCRy");

var $gIQ4T = parcelRequire("gIQ4T");
var $6Gi6J = parcelRequire("6Gi6J");

var $ixb4M = parcelRequire("ixb4M");

var $6uiEy = parcelRequire("6uiEy");

var $k7a70 = parcelRequire("k7a70");

var $cQbHL = parcelRequire("cQbHL");

var $8ZnIy = parcelRequire("8ZnIy");

var $5wc4W = parcelRequire("5wc4W");

var $7GIyE = parcelRequire("7GIyE");

var $aIuhw = parcelRequire("aIuhw");

});
parcelRegister("70tHb", function(module, exports) {

$parcel$export(module.exports, "getSideBarContextMenu", () => $519f916191a6d06c$export$113b505c11c23a9d);
// TODO: import from platform-utils when available
const $519f916191a6d06c$var$copyFromClipboard = async ()=>{
    try {
        return await navigator.clipboard.readText();
    } catch  {
        return '';
    }
};
const $519f916191a6d06c$var$ADD_PROPERTY = 'add-property';
const $519f916191a6d06c$var$PASTE_PROPERTY = 'paste-property';
const $519f916191a6d06c$var$ADD_CHILDREN = 'add-children';
const $519f916191a6d06c$var$EDIT_CHILDREN = 'edit-children';
const $519f916191a6d06c$var$DEL_CHILDREN = 'del-children';
const $519f916191a6d06c$var$COPY_CHILDREN = 'copy-children';
const $519f916191a6d06c$var$PASTE_CHILDREN = 'paste-children';
const $519f916191a6d06c$var$DUP_CHILDREN = 'dup-children';
const $519f916191a6d06c$export$113b505c11c23a9d = (el, s, sharedProps, currentLayer)=>{
    const childrenOptions = [
        {
            key: $519f916191a6d06c$var$ADD_PROPERTY,
            text: 'Add Property'
        },
        {
            key: $519f916191a6d06c$var$PASTE_PROPERTY,
            text: 'Paste Property'
        },
        {
            key: $519f916191a6d06c$var$ADD_CHILDREN,
            text: 'Add Children'
        },
        {
            key: $519f916191a6d06c$var$EDIT_CHILDREN,
            text: 'Edit Children'
        },
        {
            key: $519f916191a6d06c$var$DEL_CHILDREN,
            text: 'Delete Children'
        },
        {
            key: $519f916191a6d06c$var$COPY_CHILDREN,
            text: 'Copy Children'
        },
        {
            key: $519f916191a6d06c$var$PASTE_CHILDREN,
            text: 'Paste Children'
        },
        {
            key: $519f916191a6d06c$var$DUP_CHILDREN,
            text: 'Duplicate Children'
        }
    ];
    return {
        ...sharedProps,
        options: childrenOptions,
        DropdownHeader: {
            hide: false,
            text: s.key || s.title
        },
        onChoose: async function(ev, el, s, ctx, calleeElement) {
            const actionKey = calleeElement.state.key;
            const { key: sidebarKey, type: sidebarType } = currentLayer.lookup((el)=>el.sidebarItem)?.state || {
                key: null,
                type: null
            };
            const layerPath = currentLayer.call('getTargetLayerPath', currentLayer.state, sidebarKey, sidebarType)?.filter(Boolean) || [];
            if (actionKey === $519f916191a6d06c$var$PASTE_PROPERTY || actionKey === $519f916191a6d06c$var$PASTE_CHILDREN) {
                const sourceLayerPath = await $519f916191a6d06c$var$copyFromClipboard();
                if (!sourceLayerPath) console.warn('No clipboard data found', sourceLayerPath);
                const copiedKeyName = `${sourceLayerPath[sourceLayerPath.length - 1]}_copy`;
                const propOrChildName = sourceLayerPath[sourceLayerPath.length - 1];
                const isProperty = /^[a-z]/.test(propOrChildName[0]);
                if (isProperty && actionKey === $519f916191a6d06c$var$PASTE_CHILDREN) return;
                currentLayer.call('addClonedPropOrChild', sourceLayerPath, layerPath, copiedKeyName);
                return;
            }
            if (actionKey === $519f916191a6d06c$var$ADD_PROPERTY || actionKey === $519f916191a6d06c$var$ADD_CHILDREN) {
                const newPropName = 'propName';
                const newChildName = 'NewChild';
                const propOrChildName = actionKey === $519f916191a6d06c$var$ADD_PROPERTY ? newPropName : newChildName;
                const calculatedNewName = currentLayer.call('getAvailableNamesOnLayer', layerPath, propOrChildName);
                if (actionKey === $519f916191a6d06c$var$ADD_PROPERTY) await currentLayer.call('addLayerProp', calculatedNewName, 'propValue');
                else await currentLayer.call('addLayerChildren', calculatedNewName);
                return;
            }
            if (actionKey === $519f916191a6d06c$var$DEL_CHILDREN) {
                const confirmMsg = `Do you want to remove "${layerPath.join(' > ')}"?`;
                if (!window.confirm(confirmMsg)) return false;
                el.sdk.updateData([
                    [
                        'delete',
                        layerPath,
                        null
                    ],
                    [
                        'delete',
                        [
                            'schema',
                            ...layerPath,
                            'code'
                        ]
                    ]
                ], {
                    preventItemSidebarElementUpdate: true
                });
                currentLayer.remove();
                return;
            }
            if (actionKey === $519f916191a6d06c$var$EDIT_CHILDREN) {
                // currentLayer.setWindow('componentEditor', 'code')
                // currentLayer.activateSelected(sidebarKey)
                const data = currentLayer.getCanvasScope();
                data.componentEditor = 'code';
                currentLayer.changeCodePriority('component');
                data.activeLayer = layerPath;
                currentLayer.syncCanvas();
                currentLayer.getComponentCodeEditor().update({}, {
                    preventUpdate: true,
                    allowCodeSelection: true
                });
                return;
            }
            if (actionKey === $519f916191a6d06c$var$COPY_CHILDREN) {
                el.call('copyStringToClipboard', JSON.stringify(layerPath));
                return;
            }
            if (actionKey === $519f916191a6d06c$var$DUP_CHILDREN) {
                const childrenPath = layerPath;
                const keyName = `${childrenPath[childrenPath.length - 1]}_duplicate`;
                const duplicatedKey = currentLayer.call('getAvailableNamesOnLayer', layerPath, keyName);
                const currentComponent = el.call('getDataItemByLayerPath', childrenPath);
                if (!currentComponent) {
                    console.error('No component found at the specified path:', childrenPath);
                    return;
                }
                let duplicatedComponent = el.call('deepClone', currentComponent);
                const newLayerPath = [
                    ...childrenPath.slice(0, childrenPath.length - 1),
                    duplicatedKey
                ];
                el.sdk.updateData([
                    [
                        'update',
                        newLayerPath,
                        duplicatedComponent
                    ],
                    [
                        'delete',
                        [
                            'schema',
                            ...newLayerPath.slice(0, 2),
                            'code'
                        ]
                    ]
                ]);
                return;
            }
            el.activateContext(null);
        }
    };
};

});

parcelRegister("luAS5", function(module, exports) {

$parcel$export(module.exports, "updateOverlay", () => $0409b18d46a11c1c$export$528cfc9a70bfdd24);
/* eslint-disable init-declarations */ /* eslint-disable prefer-const */ /* eslint-disable no-shadow */ const $0409b18d46a11c1c$export$528cfc9a70bfdd24 = (el)=>{
    const data = el.getCanvasScope();
    const rootState = el.getRootState();
    if (!data) return;
    const { selected: selected, hovered: hovered, positions: positions, inContext: inContext, Collection: Collection } = data;
    const isPanning = el.isCanvasMode('panningMode');
    const selectedKey = el.getSelectedKey();
    const hoveredKey = el.getHoveredKey();
    const chosenKey = el.getChosenKey();
    const preventUnchangedLoop = ()=>{
        if (!positions) return;
        if (!el.data.__positions) el.data.__positions = {};
        const __positions = el.data.__positions;
        if (positions.x === __positions.x && positions.y === __positions.y && positions.scale === __positions.scale && positions.mouseX === __positions.mouseX && positions.mouseY === __positions.mouseY) return;
        el.data.__positions = positions;
        return true;
    };
    const positionsChanged = preventUnchangedLoop();
    return {
        hover: ()=>{
            if (!positionsChanged && !el.data.previousHovered && !hoveredKey || isPanning && isPanning === el.data.previousIsPanning) return;
            el.data.previousHovered = hoveredKey;
            el.data.previousIsPanning = isPanning;
            el.call('updateLocked', 'hovered');
            if (!hovered || selected === hovered || isPanning) {
                el.Hovered.node.style = 'display: none';
                // el.Hovered.Title.setNodeStyles({
                //   transform: 'translate3d(0, -1em, 1px)',
                //   opacity: '0'
                // })
                return;
            }
            // console.warn(hovered.state)
            const { node: node } = hovered.Flex || hovered;
            if (!el.call('isFunction', node?.getBoundingClientRect)) return;
            const rect = node?.getBoundingClientRect();
            if (!rect) return;
            const { x: x, y: y, width: width, height: height } = rect;
            el.Hovered.setNodeStyles({
                display: 'block',
                transform: `translate3d(${x}px, ${y}px, 1px)`,
                width: `${width}px`,
                height: `${height}px`
            });
            if (el.getUserSettings('allowTitleOnArtboard') //&&
            ) // el.Hovered.Title.setNodeStyles({
            //   transform: 'none',
            //   opacity: '1'
            // })
            el.Hovered.Title.update();
        // clearTimeout(hoverTitleTimeout)
        // hoverTitleTimeout = setTimeout(() => {
        // }, 1000) // 2000 milliseconds (2 seconds)
        },
        select: ()=>{
            // if (!el.data.previousSelected && !el.getSelectedKey()) {
            //   return
            // }
            if (!el.data.previousSelected && !selectedKey || isPanning && isPanning === el.data.previousSelectIsPanning) return;
            el.data.previousSelected = selectedKey;
            el.data.previousSelectIsPanning = isPanning;
            el.call('updateLocked', 'selected');
            if (!selected || el.getRootState('followingUser')) return el.Selected.node.style = 'display: none';
            if (isPanning) {
                el.Selected.Rect.node.style.opacity = '0';
                el.Selected.ResizeOverlay.node.style.opacity = '0';
                el.Selected.SelectedNavbar.node.style.opacity = '0';
                return;
            } else {
                el.Selected.Rect.node.style.opacity = '1';
                el.Selected.ResizeOverlay.node.style.opacity = '1';
                el.Selected.SelectedNavbar.node.style.opacity = '1';
            }
            const { node: node } = selected.Flex || selected;
            if (!el.call('isFunction', node?.getBoundingClientRect)) return;
            const rect = node?.getBoundingClientRect();
            if (!rect) return;
            const { x: x, y: y, width: width, height: height } = rect;
            if (!el.Selected) return;
            el.Selected.setNodeStyles({
                display: 'block',
                transform: `translate3d(${x}px, ${y}px, 1px)`,
                width: `${width}px`,
                height: `${height}px`
            });
            const { activeLayer: activeLayer } = data;
            if (el.data.previousActiveLayer !== activeLayer) {
                el.data.previousActiveLayer = activeLayer;
                if (activeLayer) el.Selected.Rect.setNodeStyles({
                    outline: '#2485F0CC 0.5px solid'
                });
                else el.Selected.Rect.setNodeStyles({
                    outline: '#2485F0 2.25px solid'
                });
            }
            const { SelectedNavbar: SelectedNavbar } = el.Selected;
            const title = SelectedNavbar.NavbarButtonSet_title.Text.text;
            if (el.getUserSettings('allowTitleOnArtboard') && title !== selectedKey) el.Selected.SelectedNavbar.update();
        },
        hoverLayer: ()=>{
            const { layerHostComponent: layerHostComponent } = data;
            if (isPanning) {
                el.LayerHovered.node.style = 'display: none';
                return;
            }
            let elemToFind = chosenKey ? el.getChosenData('chosen')?.demoComponent : layerHostComponent && el.findComponentOnCanvas(layerHostComponent);
            const { hoverLayer: hoverLayer } = data;
            if (!hoverLayer || !elemToFind) {
                const isChanged = hoverLayer !== el.data.previousLayer;
                const isSelectedChanged = layerHostComponent !== el.data.previousComponent;
                if (!isChanged && !isSelectedChanged && el.data.isHoverLayerHidden) return;
                el.data.previousLayer = hoverLayer;
                el.data.previousComponent = layerHostComponent;
                el.data.isHoverLayerHidden = true;
                return el.LayerHovered.node.style = 'display: none';
            }
            if (!chosenKey) {
                if (!el.data.previousComponent && !layerHostComponent) {
                    if (el.data.isHoverLayerHidden) return;
                }
                el.data.previousComponent = layerHostComponent;
            }
            const arrayPath = el.call('joinArrays', [
                'Flex',
                'content'
            ], hoverLayer);
            arrayPath.forEach((item)=>{
                const elem = elemToFind[item];
                if (elem) elemToFind = elem;
            });
            if (!elemToFind || !elemToFind.node) return;
            if (!el.call('isFunction', elemToFind.node?.getBoundingClientRect)) return;
            const { x: x, y: y, width: width, height: height } = elemToFind.node.getBoundingClientRect();
            el.data.isHoverLayerHidden = false;
            if (!el.LayerHovered) return;
            el.LayerHovered.setNodeStyles({
                display: 'block',
                transform: `translate3d(${x}px, ${y}px, 1px)`,
                width: `${width}px`,
                height: `${height}px`
            });
        },
        selectLayer: ()=>{
            const { layerHostComponent: layerHostComponent } = data;
            let elemToFind = chosenKey ? el.getChosenData('chosen')?.demoComponent : layerHostComponent && el.findComponentOnCanvas(layerHostComponent);
            const { activeLayer: activeLayer } = data;
            if (!activeLayer || !elemToFind) {
                const isChanged = activeLayer !== el.data.previousLayer;
                const isSelectedChanged = layerHostComponent !== el.data.previousComponent;
                if (!isChanged && !isSelectedChanged && el.data.isSelectedLayerHidden) return;
                el.data.previousLayer = activeLayer;
                el.data.previousComponent = layerHostComponent;
                el.data.isSelectedLayerHidden = true;
                return el.LayerSelected.node.style = 'display: none';
            }
            if (!chosenKey) {
                if (!el.data.previousComponent && !layerHostComponent && el.data.isSelectedLayerHidden) return;
                el.data.previousComponent = layerHostComponent;
            }
            const arrayPath = chosenKey ? activeLayer : el.call('joinArrays', [
                'Flex',
                'content'
            ], activeLayer);
            arrayPath.forEach((item)=>{
                const elem = elemToFind[item];
                if (elem) elemToFind = elem;
            });
            if (!elemToFind || !elemToFind.node) return el.LayerSelected.node.style = 'display: none';
            if (!el.call('isFunction', elemToFind.node?.getBoundingClientRect)) return;
            const { x: x, y: y, width: width, height: height } = elemToFind.node.getBoundingClientRect();
            el.LayerSelected.setNodeStyles({
                display: 'block',
                transform: `translate3d(${x}px, ${y}px, 1px)`,
                width: `${width}px`,
                height: `${height}px`
            });
            el.data.isSelectedLayerHidden = false;
        },
        hoverOriginalReference: ()=>{
            if (data.chosen || !el.getUserSettings('showReferences')) return;
            if (!el.HoveredExtendComponent || !el.data.previousComponent && !selectedKey) return;
            el.data.previousComponent = selectedKey;
            const { hoverLayer: hoverLayer } = data;
            const activeComponent = hoverLayer && hoverLayer[hoverLayer?.length - 1];
            const isComponent = el.call('matchesComponentNaming', activeComponent);
            if (!hoverLayer || !selected || !isComponent) return el.HoveredExtendComponent.node.style = 'display: none';
            const extendedFound = Collection?.lookdown((el)=>el.state?.key === activeComponent);
            if (!extendedFound?.Flex?.node || !el.call('isFunction', extendedFound.Flex.node.getBoundingClientRect)) return;
            const { x: x, y: y, width: width, height: height } = extendedFound.Flex.node.getBoundingClientRect();
            el.HoveredExtendComponent.setNodeStyles({
                display: 'block',
                transform: `translate3d(${x}px, ${y}px, 1px)`,
                width: `${width}px`,
                height: `${height}px`
            });
        },
        selectIOriginalReference: ()=>{
            if (data.chosen || !el.getUserSettings('showReferences')) return;
            if (!el.data.previousComponent && !selectedKey) return;
            el.data.previousComponent = selectedKey;
            const { activeLayer: activeLayer } = data;
            const activeComponent = activeLayer && activeLayer[activeLayer?.length - 1];
            const isComponent = el.call('matchesComponentNaming', activeComponent);
            if (!activeLayer || !selected || !isComponent) return el.SelectedExtendComponent.node.style = 'display: none';
            const lookup = selected.lookup('Collection');
            const extendedFound = lookup?.lookdown((el)=>el.state?.key === activeComponent);
            if (!extendedFound?.Flex?.node) return;
            if (!el.call('isFunction', extendedFound.node?.getBoundingClientRect)) return;
            const { x: x, y: y, width: width, height: height } = extendedFound.Flex.node.getBoundingClientRect();
            el.SelectedExtendComponent.setNodeStyles({
                display: 'block',
                transform: `translate3d(${x}px, ${y}px, 1px)`,
                width: `${width}px`,
                height: `${height}px`
            });
        },
        drawPeers: ()=>{
            if (data.chosen || !el.getUserSettings('allowTeamCursors')) return;
            const { clients: clients, userId: userId } = rootState;
            const currentClients = Object.keys(clients).filter((v)=>v !== userId && v.length === userId.length);
            const usersCached = currentClients.join('+');
            if (usersCached === el.data.usersCached) return;
            el.data.usersCached = usersCached;
            if (el.Peers.content) el.Peers.removeContent();
            el.Peers.set({
                tag: 'fragment',
                ...currentClients.map((value)=>({
                        state: {
                            value: value
                        }
                    }))
            });
        },
        contextmenu: ()=>{
            el.variables({
                inContextKey: el.getInContextKey(),
                previousX: positions?.contextX
            }).changed(()=>{
                const Canvas = el.getCanvas();
                const { ContextMenu: ContextMenu } = Canvas.parent;
                if (!ContextMenu?.setNodeStyles) return;
                if (!positions?.contextX || !inContext) return ContextMenu.setNodeStyles({
                    visibility: 'hidden',
                    opacity: '0',
                    pointerEvents: 'none',
                    display: 'none',
                    Dropdown: {
                        pointerEvents: 'none'
                    },
                    SubDropdown: {
                        pointerEvents: 'none',
                        visibility: 'hidden',
                        opacity: '0'
                    }
                });
                if (inContext.state) ContextMenu.state.set(el.call('deepClone', inContext.state.parse()));
                else if (hovered) ContextMenu.state.set(el.call('deepClone', hovered.state?.parse()));
                const { contextX: contextX, contextY: contextY } = positions;
                const { width: width, height: height } = ContextMenu.Dropdown.node.getBoundingClientRect();
                const { innerWidth: innerWidth, innerHeight: innerHeight } = window;
                const diffX = contextX + width > innerWidth ? Math.abs(innerWidth - contextX - width - 16) : 0;
                const diffY = contextY + height > innerHeight ? Math.abs(innerHeight - contextY - height - 16) : 0;
                ContextMenu.setNodeStyles({
                    visibility: 'visible',
                    opacity: '1',
                    pointerEvents: 'auto',
                    display: 'flex',
                    transform: `translate3d(${contextX - diffX}px, ${contextY - diffY}px, 1px)`,
                    Dropdown: {
                        visibility: 'visible',
                        opacity: '1',
                        pointerEvents: 'auto'
                    }
                });
            });
        },
        findAllExtends: ()=>{
            if (data.chosen || !el.getUserSettings('showReferences')) return;
            const { SelectedFindAllExtends: SelectedFindAllExtends } = el;
            if (selected?.state?.key?.startsWith('/')) {
                if (SelectedFindAllExtends.content) SelectedFindAllExtends.removeContent();
                return;
            }
            let extendedFounds;
            if (hovered && selected && hovered !== selected) {
                if (!hovered.state || !selected.state) return;
                if (el.data.previousHoveredAllExtends === hovered.state.key) return;
                el.data.previousSelectedInAllExtends = null;
                el.data.previousHoveredAllExtends = hovered.state.key;
                extendedFounds = hovered?.lookdownAll((el)=>{
                    if (!el.__ref || el.__ref.path.length < 9) return;
                    return el.call('getChildrenComponentsByKey', selectedKey) && selectedKey !== el.state.key;
                });
            } else {
                el.data.previousHoveredAllExtends = null;
                if (!selected || !el.data.previousSelectedInAllExtends && !selectedKey) {
                    if (SelectedFindAllExtends.content) SelectedFindAllExtends.removeContent();
                    el.data.previousSelectedInAllExtends = null;
                    return;
                }
                if (el.data.previousSelectedInAllExtends === selectedKey) return;
                el.data.previousSelectedInAllExtends = selectedKey;
                extendedFounds = Collection?.lookdownAll((el)=>{
                    if (!el.__ref || el.__ref.path.length < 9) return;
                    return el.call('getChildrenComponentsByKey', selectedKey, el) && el.getSelectedKey() !== el.state.key;
                });
            }
            if (!extendedFounds || !extendedFounds.length) {
                if (SelectedFindAllExtends.content) SelectedFindAllExtends.removeContent();
                return;
            }
            SelectedFindAllExtends.set({
                tag: 'fragment',
                ...extendedFounds.map((ref)=>({
                        ref: ref,
                        parentRef: ref.lookup((el)=>el.state.key && el.Handler) || {}
                    })).filter(({ ref: ref, parentRef: parentRef })=>ref.node && parentRef.node).map(({ ref: ref, parentRef: parentRef })=>{
                    const { x: x, y: y, width: width, height: height } = parentRef.node.getBoundingClientRect();
                    return {
                        data: {
                            ref: ref,
                            parentRef: parentRef,
                            parentPos: {
                                x: x,
                                y: y,
                                width: width,
                                height: height
                            }
                        }
                    };
                })
            });
        }
    };
};
const $0409b18d46a11c1c$export$5e78d58193167152 = (document, frameDocument)=>{
    const docActivenode = document.activeElement;
    const frameActivenode = frameDocument.activeElement;
    const docSelection = document.getSelection();
    const frameSelection = frameDocument.getSelection();
    const isTextSelectedInDoc = docSelection && docSelection.toString().length > 0;
    const isTextSelectedInFrame = frameSelection && frameSelection.toString().length > 0;
    return docActivenode.tagName === 'INPUT' || frameActivenode.tagName === 'INPUT' || docActivenode.tagName === 'TEXTAREA' || frameActivenode.tagName === 'TEXTAREA' || docActivenode.tagName === 'SELECT' || frameActivenode.tagName === 'SELECT' || docActivenode.isContentEditable || frameActivenode.isContentEditable || isTextSelectedInDoc || isTextSelectedInFrame;
};

});

parcelRegister("grwvk", function(module, exports) {

$parcel$export(module.exports, "avatarUrl", () => $bf88619c7cf32c75$export$3e7937c9301724ed);
$parcel$export(module.exports, "avatarUrlFor", () => $bf88619c7cf32c75$export$a2abf70522ed0b3b);
// Canvas-local avatar URL helpers. Intranet has a richer version in
// `peopleUtils.js` that looks the person up in `root.people` first — on
// canvas there's no `people` table, so we just return a deterministic
// dicebear initials SVG seeded by the email (or any string). Same service
// intranet ultimately falls back to, so avatars look identical across
// apps when the person isn't in governance's directory.
const $bf88619c7cf32c75$var$DICEBEAR = 'https://api.dicebear.com/7.x/initials/svg?seed=';
const $bf88619c7cf32c75$export$3e7937c9301724ed = (seed)=>`${$bf88619c7cf32c75$var$DICEBEAR}${encodeURIComponent(seed || '?')}`;
function $bf88619c7cf32c75$export$a2abf70522ed0b3b(root, email) {
    let e = email;
    if (typeof root === 'string' && email === undefined) e = root;
    return $bf88619c7cf32c75$export$3e7937c9301724ed(e);
}

});

parcelRegister("14e0k", function(module, exports) {

$parcel$export(module.exports, "patchCanvas", () => $0c71072679a558bf$export$c6060c797f7285e8);
$parcel$export(module.exports, "patchSnap", () => $0c71072679a558bf$export$e8e5bb5e0085bdab);
$parcel$export(module.exports, "patchCanvasItem", () => $0c71072679a558bf$export$fc74201dfb2fdf44);
$parcel$export(module.exports, "persistCanvasLayout", () => $0c71072679a558bf$export$53fec6eb7cf69810);
$parcel$export(module.exports, "getCanvasV2", () => $0c71072679a558bf$export$652848ce464c7201);
$parcel$export(module.exports, "isCanvasV2", () => $0c71072679a558bf$export$23addae0858e64b6);
$parcel$export(module.exports, "getCanvasItem", () => $0c71072679a558bf$export$d431ee287d504f08);
$parcel$export(module.exports, "getCanvasSelection", () => $0c71072679a558bf$export$3c60c95440d052ea);
$parcel$export(module.exports, "getCanvasMode", () => $0c71072679a558bf$export$202b2cd3c1634e12);
$parcel$export(module.exports, "setCanvasV2Mode", () => $0c71072679a558bf$export$bce0c42665baf125);
$parcel$export(module.exports, "toggleCanvasSettings", () => $0c71072679a558bf$export$4216e9bb03ab4201);
$parcel$export(module.exports, "setCanvasSettings", () => $0c71072679a558bf$export$d81c309e40ced94b);
$parcel$export(module.exports, "setViewport", () => $0c71072679a558bf$export$c1fc9211e25f81c5);
$parcel$export(module.exports, "applyViewport", () => $0c71072679a558bf$export$b978854ee8173e4d);
$parcel$export(module.exports, "canvasToScreen", () => $0c71072679a558bf$export$74ce37ffcd467e42);
$parcel$export(module.exports, "screenToCanvas", () => $0c71072679a558bf$export$fe6875ec1b5fc6b6);
$parcel$export(module.exports, "refreshCanvasChrome", () => $0c71072679a558bf$export$32d404dd66fcf9d6);
$parcel$export(module.exports, "resetCanvasView", () => $0c71072679a558bf$export$2ba1bffa7d2b4003);
$parcel$export(module.exports, "fitToSelection", () => $0c71072679a558bf$export$fc2e72651871d0dd);
$parcel$export(module.exports, "addConnection", () => $0c71072679a558bf$export$3d65ce36f6b7b45d);
$parcel$export(module.exports, "removeConnection", () => $0c71072679a558bf$export$c4b227a68608c05e);
$parcel$export(module.exports, "toggleShortcutsOverlay", () => $0c71072679a558bf$export$15cf46b46ecd97d0);
$parcel$export(module.exports, "initCanvasV2", () => $0c71072679a558bf$export$94a74e8616390e7c);
// Canvas v2 state. Lives on the root reactive store so prop functions
// re-evaluate on mutation. Writes funnel through `patchCanvas` so the
// backing store can later swap to project.settings.canvas without
// touching components.

var $6k38k = parcelRequire("6k38k");
const $0c71072679a558bf$var$DEFAULTS = ()=>({
        viewport: {
            x: 40,
            y: 40,
            scale: 0.35
        },
        items: {},
        groups: {},
        guides: {
            horizontal: [],
            vertical: []
        },
        selection: {
            ids: [],
            primary: null
        },
        marquee: null,
        mode: 'default',
        snap: {
            enabled: true,
            threshold: 6,
            toGrid: true,
            gridStep: 64,
            toItems: true,
            toGuides: true
        },
        // Per project_canvas_ds_fetch_fix.md: per-tile iframes are the proven
        // path — they isolate scratch's module-level FACTORY and give the
        // page its own state tree (so fetch queries that need projectId etc.
        // work correctly). Inline mounting is the lighter-weight default —
        // `?frameMode=1` opts into per-tile iframes for full project isolation.
        // Visual connections between items — arrows from one item to another.
        // Stored as `[{ from: pageKey, to: pageKey, label?: string }]`. Rendered
        // by `refreshCanvasChrome` into the `CvConnectors` SVG layer.
        connections: [],
        // Off by default. Toggled from the settings modal.
        showRulers: false,
        showMinimap: false,
        frameMode: (()=>{
            try {
                if (typeof window === 'undefined') return false;
                const sp = new URLSearchParams(window.location.search);
                if (sp.get('frameMode') === '1') return true;
                return false;
            } catch  {
                return false;
            }
        })(),
        settingsOpen: false,
        session: null
    });
function $0c71072679a558bf$var$rootState(el) {
    return el?.state?.root || el?.getRootState?.() || el?.getRoot?.()?.state;
}
const $0c71072679a558bf$var$STORAGE_KEY = 'cv2_settings';
function $0c71072679a558bf$var$loadStored() {
    try {
        return JSON.parse(window.localStorage?.getItem($0c71072679a558bf$var$STORAGE_KEY) || '{}');
    } catch  {
        return {};
    }
}
function $0c71072679a558bf$var$persistSettings(canvas) {
    try {
        const slim = {
            snap: canvas.snap,
            frameMode: canvas.frameMode,
            showRulers: canvas.showRulers,
            showMinimap: canvas.showMinimap
        };
        window.localStorage?.setItem($0c71072679a558bf$var$STORAGE_KEY, JSON.stringify(slim));
    } catch  {}
}
function $0c71072679a558bf$export$c6060c797f7285e8(patch, opts) {
    const root = $0c71072679a558bf$var$rootState(this);
    if (!root?.update) return;
    const prev = root.canvas || $0c71072679a558bf$var$DEFAULTS();
    const next = {
        ...prev,
        ...patch
    };
    root.update({
        canvas: next
    }, opts);
    if ('snap' in patch || 'frameMode' in patch || 'showRulers' in patch || 'showMinimap' in patch) $0c71072679a558bf$var$persistSettings(next);
}
function $0c71072679a558bf$export$e8e5bb5e0085bdab(patch) {
    const v2 = this.call('getCanvasV2');
    if (!v2) return;
    this.call('patchCanvas', {
        snap: {
            ...v2.snap,
            ...patch
        }
    });
}
function $0c71072679a558bf$export$fc74201dfb2fdf44(key, itemPatch) {
    const root = $0c71072679a558bf$var$rootState(this);
    const canvas = root?.canvas;
    if (!canvas || !key) return;
    canvas.items = canvas.items || {};
    canvas.items[key] = {
        ...canvas.items[key] || {},
        ...itemPatch
    };
}
// Debounced project write. The `canvas` field is a recognized
// contentField — the server stores it in the ProjectData document and
// includes it in subsequent project reads. `settings` is also a
// contentField but many project reads strip it, so we keep the layout
// at the top level to match Workspace's `canvasPosition` pattern.
let $0c71072679a558bf$var$_persistTimer = null;
function $0c71072679a558bf$export$53fec6eb7cf69810() {
    const v2 = this.call('getCanvasV2');
    if (!v2) return;
    const ctx = this.context || this.getRootContext?.() || {};
    const sdk = ctx.methods?.sdk;
    if (!sdk?.isReady?.()) return;
    const data = $0c71072679a558bf$var$rootState(this)?.data;
    const projectId = data?._id;
    if (!projectId) return;
    const payload = {
        items: v2.items,
        guides: v2.guides,
        groups: v2.groups,
        viewport: v2.viewport
    };
    if ($0c71072679a558bf$var$_persistTimer) clearTimeout($0c71072679a558bf$var$_persistTimer);
    $0c71072679a558bf$var$_persistTimer = setTimeout(async ()=>{
        $0c71072679a558bf$var$_persistTimer = null;
        try {
            await sdk.updateProject(projectId, {
                canvas: payload
            });
        } catch (err) {
            console.warn('[canvas v2] persist failed', err?.message || err);
        }
    }, 800);
}
function $0c71072679a558bf$export$652848ce464c7201() {
    return $0c71072679a558bf$var$rootState(this)?.canvas;
}
function $0c71072679a558bf$export$23addae0858e64b6() {
    return !!this.call('getCanvasScope')?.canvasV2;
}
function $0c71072679a558bf$export$d431ee287d504f08(key) {
    return this.call('getCanvasV2')?.items?.[key];
}
function $0c71072679a558bf$export$3c60c95440d052ea() {
    return this.call('getCanvasV2')?.selection || {
        ids: [],
        primary: null
    };
}
function $0c71072679a558bf$export$202b2cd3c1634e12() {
    return this.call('getCanvasV2')?.mode || 'default';
}
function $0c71072679a558bf$export$bce0c42665baf125(mode) {
    const v2 = this.call('getCanvasV2');
    if (!v2) return;
    v2.mode = mode;
    const scope = this.call('getCanvasScope');
    if (scope) {
        scope.defaultMode = mode === 'default';
        scope.inspectMode = mode === 'inspect';
        scope.panningMode = mode === 'pan';
    }
    // Re-render the modes bar + inspect overlay (uses reactive `show:`).
    this.call('patchCanvas', {
        mode: mode
    });
    this.call('refreshCanvasChrome');
}
function $0c71072679a558bf$export$4216e9bb03ab4201() {
    const v2 = this.call('getCanvasV2');
    if (!v2) return;
    this.call('patchCanvas', {
        settingsOpen: !v2.settingsOpen
    });
}
function $0c71072679a558bf$export$d81c309e40ced94b(open) {
    this.call('patchCanvas', {
        settingsOpen: !!open
    });
}
function $0c71072679a558bf$export$c1fc9211e25f81c5(patch) {
    const canvas = $0c71072679a558bf$var$rootState(this)?.canvas;
    if (!canvas) return;
    canvas.viewport = {
        ...canvas.viewport || {},
        ...patch
    };
}
function $0c71072679a558bf$export$b978854ee8173e4d(viewport) {
    this.call('setViewport', viewport);
    const scope = this.call('getCanvasScope');
    if (scope) scope.positions = {
        ...scope.positions,
        x: viewport.x,
        y: viewport.y,
        scale: viewport.scale
    };
    try {
        (0, $6k38k.resolveTopWindow)().__cvViewport = {
            x: viewport.x,
            y: viewport.y,
            scale: viewport.scale
        };
    } catch  {}
    const root = this.getRoot?.();
    const scene = root?.lookdown?.('CvScene');
    if (scene?.update) scene.update({
        style: {
            transform: `translate3d(${viewport.x}px, ${viewport.y}px, 0) scale(${viewport.scale})`
        }
    });
    const grid = root?.lookdown?.('CvGrid');
    if (grid?.update) {
        const size = 20 * (viewport.scale || 1);
        const px = (viewport.x % size + size) % size;
        const py = (viewport.y % size + size) % size;
        grid.update({
            style: {
                backgroundSize: `${size}px ${size}px`,
                backgroundPosition: `${px}px ${py}px`
            }
        });
    }
    this.call('refreshCanvasChrome');
    this.call('syncCanvas');
}
function $0c71072679a558bf$export$74ce37ffcd467e42(cx, cy) {
    const vp = this.call('getCanvasV2')?.viewport || {
        x: 0,
        y: 0,
        scale: 1
    };
    return {
        x: cx * vp.scale + vp.x,
        y: cy * vp.scale + vp.y
    };
}
function $0c71072679a558bf$export$fe6875ec1b5fc6b6(sx, sy) {
    const vp = this.call('getCanvasV2')?.viewport || {
        x: 0,
        y: 0,
        scale: 1
    };
    return {
        x: (sx - vp.x) / vp.scale,
        y: (sy - vp.y) / vp.scale
    };
}
// --- chrome updater -----------------------------------------------------
// rAF-coalesces: callers tag the chrome dirty; the actual layout work
// runs once per browser frame even if called 100×/frame during gesture.
// Cache last applied geom per element so unchanged frames skip the
// `el.update` (a no-op write still allocates DOMQL diff overhead).
let $0c71072679a558bf$var$_chromeRafId = null;
let $0c71072679a558bf$var$_chromeLastEl = null;
const $0c71072679a558bf$var$_lastGeom = new WeakMap();
function $0c71072679a558bf$var$geomChanged(el, next) {
    const prev = $0c71072679a558bf$var$_lastGeom.get(el);
    if (!prev) {
        $0c71072679a558bf$var$_lastGeom.set(el, next);
        return true;
    }
    for(const k in next)if (next[k] !== prev[k]) {
        $0c71072679a558bf$var$_lastGeom.set(el, next);
        return true;
    }
    return false;
}
function $0c71072679a558bf$export$32d404dd66fcf9d6() {
    $0c71072679a558bf$var$_chromeLastEl = this;
    if ($0c71072679a558bf$var$_chromeRafId) return;
    const raf = typeof requestAnimationFrame !== 'undefined' ? requestAnimationFrame : (cb)=>setTimeout(cb, 16);
    $0c71072679a558bf$var$_chromeRafId = raf(()=>{
        $0c71072679a558bf$var$_chromeRafId = null;
        try {
            $0c71072679a558bf$var$refreshCanvasChromeNow.call($0c71072679a558bf$var$_chromeLastEl);
        } catch (err) {
            console.error('[canvas v2] refreshCanvasChrome error', err);
        }
    });
}
function $0c71072679a558bf$var$refreshCanvasChromeNow() {
    const v2 = this.call('getCanvasV2');
    if (!v2) return;
    const root = this.getRoot?.();
    if (!root) return;
    const overlay = root.lookdown?.('CanvasOverlayV2');
    if (!overlay) return;
    const el = this;
    const vp = v2.viewport;
    // Selection box + handles
    const box = overlay.CvSelectionBox;
    const ids = v2.selection.ids;
    if (ids.length && box?.update) {
        const bbox = el.call('bboxForSelection');
        if (bbox) {
            const x = bbox.x * vp.scale + vp.x;
            const y = bbox.y * vp.scale + vp.y;
            const w = bbox.w * vp.scale;
            const h = bbox.h * vp.scale;
            box.update({
                style: {
                    display: 'block',
                    left: x + 'px',
                    top: y + 'px',
                    width: w + 'px',
                    height: h + 'px'
                }
            });
            // Handles — only for single selection
            const showHandles = ids.length === 1;
            const handlePoints = [
                [
                    (0, $6k38k.HANDLE_NAMES)[0],
                    x,
                    y
                ],
                [
                    (0, $6k38k.HANDLE_NAMES)[1],
                    x + w / 2,
                    y
                ],
                [
                    (0, $6k38k.HANDLE_NAMES)[2],
                    x + w,
                    y
                ],
                [
                    (0, $6k38k.HANDLE_NAMES)[3],
                    x + w,
                    y + h / 2
                ],
                [
                    (0, $6k38k.HANDLE_NAMES)[4],
                    x + w,
                    y + h
                ],
                [
                    (0, $6k38k.HANDLE_NAMES)[5],
                    x + w / 2,
                    y + h
                ],
                [
                    (0, $6k38k.HANDLE_NAMES)[6],
                    x,
                    y + h
                ],
                [
                    (0, $6k38k.HANDLE_NAMES)[7],
                    x,
                    y + h / 2
                ]
            ];
            for (const [name, hx, hy] of handlePoints){
                const h = overlay[name];
                if (!h?.update) continue;
                const next = {
                    display: showHandles ? 'block' : 'none',
                    left: hx,
                    top: hy
                };
                if (!$0c71072679a558bf$var$geomChanged(h, next)) continue;
                h.update({
                    style: {
                        display: next.display,
                        left: hx + 'px',
                        top: hy + 'px',
                        transform: 'translate(-50%, -50%)'
                    }
                });
            }
            // SelectedNavbar host — only when exactly 1 selected
            const host = overlay.CvSelectedHost;
            if (host?.update) host.update({
                style: showHandles ? {
                    display: 'block',
                    left: x + 'px',
                    top: y + 'px',
                    width: w + 'px',
                    height: h + 'px'
                } : {
                    display: 'none'
                }
            });
        }
    } else {
        box?.update?.({
            style: {
                display: 'none'
            }
        });
        for (const name of (0, $6k38k.HANDLE_NAMES))overlay[name]?.update?.({
            style: {
                display: 'none'
            }
        });
        overlay.CvSelectedHost?.update?.({
            style: {
                display: 'none'
            }
        });
    }
    // Marquee
    const marq = overlay.CvDragAreaClip?.CvMarquee || overlay.CvMarquee;
    if (marq?.update) {
        const m = v2.marquee;
        if (m) marq.update({
            style: {
                display: 'block',
                left: m.x * vp.scale + vp.x + 'px',
                top: m.y * vp.scale + vp.y + 'px',
                width: m.w * vp.scale + 'px',
                height: m.h * vp.scale + 'px'
            }
        });
        else marq.update({
            style: {
                display: 'none'
            }
        });
    }
    // Connector arrows — render as bezier paths in CvConnectors SVG.
    const conn = overlay.CvConnectors;
    const connNode = conn?.node;
    if (connNode) {
        const list = v2.connections || [];
        const dom = connNode.ownerDocument;
        while(connNode.firstChild)connNode.removeChild(connNode.firstChild);
        if (list.length) {
            // Marker for arrowhead.
            const defs = dom.createElementNS('http://www.w3.org/2000/svg', 'defs');
            defs.innerHTML = '<marker id="cvArrow" viewBox="0 0 10 10" refX="9" refY="5" markerWidth="8" markerHeight="8" orient="auto-start-reverse"><path d="M0,0 L10,5 L0,10 z" fill="rgba(64,156,255,0.9)"/></marker>';
            connNode.appendChild(defs);
            for (const c of list){
                const a = v2.items[c.from];
                const b = v2.items[c.to];
                if (!a || !b) continue;
                const ax = (a.x + a.w) * vp.scale + vp.x;
                const ay = (a.y + a.h / 2) * vp.scale + vp.y;
                const bx = b.x * vp.scale + vp.x;
                const by = (b.y + b.h / 2) * vp.scale + vp.y;
                const cx = (ax + bx) / 2;
                const path = dom.createElementNS('http://www.w3.org/2000/svg', 'path');
                path.setAttribute('d', `M${ax},${ay} C${cx},${ay} ${cx},${by} ${bx},${by}`);
                path.setAttribute('fill', 'none');
                path.setAttribute('stroke', 'rgba(64,156,255,0.85)');
                path.setAttribute('stroke-width', '2');
                path.setAttribute('marker-end', 'url(#cvArrow)');
                connNode.appendChild(path);
            }
        }
    }
    // Group dashed outlines — one screen-space rect per group.
    const groupsHost = overlay.CvGroupsLayer;
    const groupsNode = groupsHost?.node;
    if (groupsNode) {
        const groups = v2.groups || {};
        const existing = new Map();
        Array.from(groupsNode.children).forEach((c)=>{
            const k = c.getAttribute('data-group-for');
            if (k) existing.set(k, c);
        });
        const seen = new Set();
        for (const [gid, g] of Object.entries(groups)){
            seen.add(gid);
            const bbox = el.call('bboxForGroup', gid);
            if (!bbox) continue;
            let box = existing.get(gid);
            if (!box) {
                box = groupsNode.ownerDocument.createElement('div');
                box.setAttribute('data-group-for', gid);
                box.style.position = 'absolute';
                box.style.border = '1px dashed rgba(64,156,255,0.85)';
                box.style.borderRadius = '4px';
                box.style.pointerEvents = 'none';
                groupsNode.appendChild(box);
            }
            const sx = bbox.x * vp.scale + vp.x;
            const sy = bbox.y * vp.scale + vp.y;
            box.style.left = sx - 4 + 'px';
            box.style.top = sy - 4 + 'px';
            box.style.width = bbox.w * vp.scale + 8 + 'px';
            box.style.height = bbox.h * vp.scale + 8 + 'px';
        }
        for (const [gid, box] of existing)if (!seen.has(gid)) box.remove();
    }
    // Minimap — render items + viewport rect in a 180x120 box.
    const minimap = overlay.CvMinimap;
    const mmNode = minimap?.node;
    if (mmNode) {
        const surf = root.lookdown?.('CanvasSurface')?.node;
        const rect = surf?.getBoundingClientRect();
        let mmMinX = Infinity, mmMinY = Infinity, mmMaxX = -Infinity, mmMaxY = -Infinity;
        for (const it of Object.values(v2.items)){
            if (it.x < mmMinX) mmMinX = it.x;
            if (it.y < mmMinY) mmMinY = it.y;
            if (it.x + it.w > mmMaxX) mmMaxX = it.x + it.w;
            if (it.y + it.h > mmMaxY) mmMaxY = it.y + it.h;
        }
        if (Number.isFinite(mmMinX) && rect) {
            const PAD = 8;
            const W = mmNode.clientWidth - PAD * 2;
            const H = mmNode.clientHeight - PAD * 2;
            const cw = mmMaxX - mmMinX;
            const ch = mmMaxY - mmMinY;
            const mScale = Math.min(W / cw, H / ch);
            const ox = PAD - mmMinX * mScale;
            const oy = PAD - mmMinY * mScale;
            const dom = mmNode.ownerDocument;
            const have = new Map();
            Array.from(mmNode.children).forEach((c)=>{
                const k = c.getAttribute('data-mm-for');
                if (k) have.set(k, c);
            });
            const seen = new Set();
            for (const [key, it] of Object.entries(v2.items)){
                seen.add(key);
                let dot = have.get(key);
                if (!dot) {
                    dot = dom.createElement('div');
                    dot.setAttribute('data-mm-for', key);
                    dot.style.position = 'absolute';
                    dot.style.background = 'rgba(255,255,255,0.6)';
                    dot.style.borderRadius = '1px';
                    mmNode.appendChild(dot);
                }
                dot.style.left = it.x * mScale + ox + 'px';
                dot.style.top = it.y * mScale + oy + 'px';
                dot.style.width = it.w * mScale + 'px';
                dot.style.height = it.h * mScale + 'px';
            }
            for (const [key, dot] of have)if (!seen.has(key) && key !== '__viewport__') dot.remove();
            // Viewport rect in canvas-space: [-vp.x/scale, -vp.y/scale] sized [rect.w/scale, rect.h/scale]
            let vpEl = have.get('__viewport__');
            if (!vpEl) {
                vpEl = dom.createElement('div');
                vpEl.setAttribute('data-mm-for', '__viewport__');
                vpEl.style.position = 'absolute';
                vpEl.style.border = '1px solid rgba(64,156,255,0.95)';
                vpEl.style.background = 'rgba(64,156,255,0.15)';
                vpEl.style.pointerEvents = 'none';
                mmNode.appendChild(vpEl);
            }
            const vx = -vp.x / vp.scale;
            const vy = -vp.y / vp.scale;
            const vw = rect.width / vp.scale;
            const vh = rect.height / vp.scale;
            vpEl.style.left = vx * mScale + ox + 'px';
            vpEl.style.top = vy * mScale + oy + 'px';
            vpEl.style.width = vw * mScale + 'px';
            vpEl.style.height = vh * mScale + 'px';
        }
    }
    // Item titles — one screen-space label per item, positioned just above.
    const titlesHost = overlay.CvItemTitles;
    const titlesNode = titlesHost?.node;
    if (titlesNode) {
        const existing = new Map();
        Array.from(titlesNode.children).forEach((c)=>{
            const k = c.getAttribute('data-title-for');
            if (k) existing.set(k, c);
        });
        const seen = new Set();
        for (const [key, it] of Object.entries(v2.items)){
            seen.add(key);
            let lbl = existing.get(key);
            if (!lbl) {
                lbl = titlesNode.ownerDocument.createElement('div');
                lbl.setAttribute('data-title-for', key);
                lbl.style.position = 'absolute';
                lbl.style.color = 'white';
                lbl.style.fontSize = '11px';
                lbl.style.fontWeight = '500';
                lbl.style.padding = '2px 6px';
                lbl.style.background = 'rgba(0,0,0,0.6)';
                lbl.style.borderRadius = '3px';
                lbl.style.transform = 'translateY(-100%)';
                lbl.style.marginTop = '-4px';
                lbl.style.pointerEvents = 'none';
                lbl.style.whiteSpace = 'nowrap';
                lbl.textContent = key;
                titlesNode.appendChild(lbl);
            }
            const sx = it.x * vp.scale + vp.x;
            const sy = it.y * vp.scale + vp.y;
            lbl.style.left = sx + 'px';
            lbl.style.top = sy + 'px';
        }
        // Remove labels for items that no longer exist.
        for (const [key, lbl] of existing)if (!seen.has(key)) lbl.remove();
    }
}
function $0c71072679a558bf$export$2ba1bffa7d2b4003() {
    this.call('applyViewport', {
        x: 40,
        y: 40,
        scale: 0.35
    });
}
function $0c71072679a558bf$export$fc2e72651871d0dd() {
    const v2 = this.call('getCanvasV2');
    if (!v2) return;
    const ids = v2.selection.ids;
    const bbox = ids.length ? this.call('bboxForSelection') : (()=>{
        const all = Object.keys(v2.items);
        if (!all.length) return null;
        return this.call('bboxForGroup', '__all__') || (()=>{
            let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
            for (const it of Object.values(v2.items)){
                if (it.x < minX) minX = it.x;
                if (it.y < minY) minY = it.y;
                if (it.x + it.w > maxX) maxX = it.x + it.w;
                if (it.y + it.h > maxY) maxY = it.y + it.h;
            }
            return Number.isFinite(minX) ? {
                x: minX,
                y: minY,
                w: maxX - minX,
                h: maxY - minY
            } : null;
        })();
    })();
    if (!bbox) return;
    const root = this.getRoot?.();
    const surf = root?.lookdown?.('CanvasSurface');
    const rect = surf?.node?.getBoundingClientRect();
    if (!rect) return;
    const PAD = 60;
    const sx = (rect.width - 2 * PAD) / bbox.w;
    const sy = (rect.height - 2 * PAD) / bbox.h;
    const scale = Math.max(0.05, Math.min(2, Math.min(sx, sy)));
    const x = (rect.width - bbox.w * scale) / 2 - bbox.x * scale;
    const y = (rect.height - bbox.h * scale) / 2 - bbox.y * scale;
    this.call('applyViewport', {
        x: x,
        y: y,
        scale: scale
    });
}
function $0c71072679a558bf$export$3d65ce36f6b7b45d(from, to, label) {
    const v2 = this.call('getCanvasV2');
    if (!v2 || !from || !to) return;
    const next = [
        ...v2.connections || [],
        {
            from: from,
            to: to,
            label: label
        }
    ];
    this.call('patchCanvas', {
        connections: next
    });
    this.call('refreshCanvasChrome');
    this.call('persistCanvasLayout');
}
function $0c71072679a558bf$export$c4b227a68608c05e(from, to) {
    const v2 = this.call('getCanvasV2');
    if (!v2) return;
    const next = (v2.connections || []).filter((c)=>!(c.from === from && c.to === to));
    this.call('patchCanvas', {
        connections: next
    });
    this.call('refreshCanvasChrome');
    this.call('persistCanvasLayout');
}
function $0c71072679a558bf$export$15cf46b46ecd97d0() {
    const v2 = this.call('getCanvasV2');
    if (!v2) return;
    this.call('patchCanvas', {
        shortcutsOpen: !v2.shortcutsOpen
    });
}
function $0c71072679a558bf$export$94a74e8616390e7c() {
    const root = $0c71072679a558bf$var$rootState(this);
    // Restore previously persisted layout from the top-level `canvas`
    // field, with fallbacks for older saves. Only honour it if it
    // actually has items — a bare `canvas: {}` falls through to seed.
    const persistedRaw = root?.data?.canvas || root?.data?.canvasLayout || root?.data?.settings?.canvas;
    const persisted = persistedRaw?.items && Object.keys(persistedRaw.items).length ? persistedRaw : null;
    if (persisted && root?.update && !Object.keys(root.canvas?.items || {}).length) {
        const stored = $0c71072679a558bf$var$loadStored();
        const base = $0c71072679a558bf$var$DEFAULTS();
        if (stored.snap) base.snap = {
            ...base.snap,
            ...stored.snap
        };
        if (typeof stored.frameMode === 'boolean') base.frameMode = stored.frameMode;
        root.update({
            canvas: {
                ...base,
                items: persisted.items || {},
                guides: persisted.guides || base.guides,
                groups: persisted.groups || {},
                viewport: persisted.viewport || base.viewport
            }
        });
        this.call('pushHistory');
        return;
    }
    if (!root?.update) return;
    if (root.canvas && Object.keys(root.canvas.items || {}).length) return;
    const ctx = this.context || this.getRootContext?.() || {};
    const pages = ctx.projectPages || {};
    const entries = Object.entries(pages);
    // 4-col layout at 1722×1722 canvas-space px per thumbnail with 256 gap.
    const W = 1722;
    const GAP = 256;
    const COLS = 4;
    const items = {};
    entries.forEach(([key, v], i)=>{
        const col = i % COLS;
        const row = Math.floor(i / COLS);
        const saved = v?.settings?.gridOptions || {};
        const usingSaved = saved.x != null && saved.y != null;
        items[key] = {
            x: usingSaved ? saved.x * (W + GAP) / 3 : col * (W + GAP),
            y: usingSaved ? saved.y * (W + GAP) / 3 : row * (W + GAP),
            w: usingSaved ? (saved.w || 3) * (W / 3) : W,
            h: usingSaved ? (saved.h || 3) * (W / 3) : W,
            pageKey: key
        };
    });
    // Restore persisted snap + frameMode settings.
    const stored = $0c71072679a558bf$var$loadStored();
    const base = $0c71072679a558bf$var$DEFAULTS();
    if (stored.snap) base.snap = {
        ...base.snap,
        ...stored.snap
    };
    if (typeof stored.frameMode === 'boolean') base.frameMode = stored.frameMode;
    if (typeof stored.showRulers === 'boolean') base.showRulers = stored.showRulers;
    if (typeof stored.showMinimap === 'boolean') base.showMinimap = stored.showMinimap;
    root.update({
        canvas: {
            ...base,
            items: items
        }
    });
    this.call('pushHistory');
}

});
parcelRegister("6k38k", function(module, exports) {

$parcel$export(module.exports, "resolveTopWindow", () => $49a70a86c991cea2$export$d32a259a84a71c23);
$parcel$export(module.exports, "MODES", () => $49a70a86c991cea2$export$240b20df485e8ed6);
$parcel$export(module.exports, "HANDLE_NAMES", () => $49a70a86c991cea2$export$386b472623695903);
$parcel$export(module.exports, "default", () => $49a70a86c991cea2$export$2e2bcd8739ae039);
// Shared via top-level window so both editor and canvas iframe bundles
// reference the same object (Parcel creates separate module instances,
// and iframe has its own window).
// Walk up to the topmost same-origin ancestor so cross-origin embed
// (landing → editor → canvas) still shares scope between editor chrome
// and canvas iframe.
// Walk to the topmost same-origin ancestor window. Exported so other
// modules (state.js, methods/index.js) don't redefine it.
const $49a70a86c991cea2$export$d32a259a84a71c23 = ()=>{
    if (typeof window === 'undefined') return globalThis;
    let w = window;
    while(w.parent && w.parent !== w)try {
        w.parent.document;
        w = w.parent;
    } catch  {
        break;
    }
    return w;
};
const $49a70a86c991cea2$var$topWindow = $49a70a86c991cea2$export$d32a259a84a71c23();
const $49a70a86c991cea2$export$240b20df485e8ed6 = Object.freeze({
    DEFAULT: 'default',
    PAN: 'pan',
    INSPECT: 'inspect',
    INTERACT: 'interact'
});
const $49a70a86c991cea2$export$386b472623695903 = Object.freeze([
    'CvHandleNW',
    'CvHandleN',
    'CvHandleNE',
    'CvHandleE',
    'CvHandleSE',
    'CvHandleS',
    'CvHandleSW',
    'CvHandleW'
]);
// Live v2 viewport mirror — written by state.js applyViewport, read by
// the panzoom shim below so the outer chrome's animation-frame loop
// always sees fresh values without waiting for component init.
if (typeof $49a70a86c991cea2$var$topWindow !== 'undefined' && !$49a70a86c991cea2$var$topWindow.__cvViewport) $49a70a86c991cea2$var$topWindow.__cvViewport = {
    x: 40,
    y: 40,
    scale: 0.35
};
if (!$49a70a86c991cea2$var$topWindow.__canvasGlobalScope) $49a70a86c991cea2$var$topWindow.__canvasGlobalScope = {
    // Panzoom (v1)
    panningMode: false,
    isPanning: false,
    isGrabbing: false,
    positions: {
        x: 0,
        y: 0,
        scale: 0.35
    },
    panzoomInstance: null,
    // Selection state (element refs — NOT stored in reactive store)
    selected: null,
    selectedKey: null,
    hovered: null,
    hoveredKey: null,
    canvasElement: null,
    // Modes (v1)
    defaultMode: true,
    inspectMode: false,
    editorActive: true,
    // Inspect layers
    hoverLayer: null,
    activeLayer: null,
    layerHostComponent: null,
    inContext: null,
    _syncCounter: 0,
    // Canvas v2 feature flag — v2 state itself lives on reactive root
    // state (see functions/canvas/state.js). This scope only carries the
    // flag because it's read by both editor chrome and iframe.
    // Canvas v2 is now the default. Legacy gridstack canvas (v1) is
    // opt-in via `?canvasOld=true` or `?canvasV2=0`; also kept
    // overridable via localStorage `canvasOld` for stable bookmarks.
    canvasV2: (()=>{
        try {
            if (typeof window === 'undefined') return true;
            const sp = new URLSearchParams(window.location.search);
            if (sp.get('canvasV2') === '1') return true;
            if (sp.get('canvasV2') === '0') return false;
            if (sp.get('canvasOld') === 'true' || sp.get('canvasOld') === '1') return false;
            if (window.localStorage?.getItem('canvasOld')) return false;
            return true;
        } catch  {
            return true;
        }
    })()
};
// Install the v1-shaped panzoom shim eagerly when v2 is on so the
// shared Zoombar's per-frame loop always has something to read. The
// shim reads `topWindow.__cvViewport`, which `applyViewport` keeps
// fresh.
if ($49a70a86c991cea2$var$topWindow.__canvasGlobalScope.canvasV2 && !$49a70a86c991cea2$var$topWindow.__canvasGlobalScope.panzoomInstance?.__v2) {
    const vp = ()=>$49a70a86c991cea2$var$topWindow.__cvViewport || {
            x: 40,
            y: 40,
            scale: 0.35
        };
    $49a70a86c991cea2$var$topWindow.__canvasGlobalScope.panzoomInstance = {
        __v2: true,
        getTransform: ()=>({
                ...vp()
            }),
        moveTo: (x, y)=>{
            $49a70a86c991cea2$var$topWindow.__cvViewport = {
                ...vp(),
                x: x,
                y: y
            };
        },
        moveBy: (dx, dy)=>{
            const v = vp();
            $49a70a86c991cea2$var$topWindow.__cvViewport = {
                ...v,
                x: v.x + dx,
                y: v.y + dy
            };
        },
        zoomAbs: (_x, _y, scale)=>{
            $49a70a86c991cea2$var$topWindow.__cvViewport = {
                ...vp(),
                scale: scale
            };
        },
        smoothZoom: (cx, cy, factor)=>{
            const v = vp();
            const ns = Math.max(0.035, Math.min(2.5, v.scale * factor));
            $49a70a86c991cea2$var$topWindow.__cvViewport = {
                x: cx - (cx - v.x) * (ns / v.scale),
                y: cy - (cy - v.y) * (ns / v.scale),
                scale: ns
            };
        },
        smoothZoomAbs: (_x, _y, scale)=>{
            $49a70a86c991cea2$var$topWindow.__cvViewport = {
                ...vp(),
                scale: scale
            };
        },
        on: ()=>{},
        off: ()=>{},
        dispose: ()=>{}
    };
}
var $49a70a86c991cea2$export$2e2bcd8739ae039 = $49a70a86c991cea2$var$topWindow.__canvasGlobalScope;

});


parcelRegister("7eH5h", function(module, exports) {

$parcel$export(module.exports, "selectOne", () => $544b42cded6cd5af$export$9633ae49ba77655e);
$parcel$export(module.exports, "toggleSelection", () => $544b42cded6cd5af$export$6853837031592033);
$parcel$export(module.exports, "selectMany", () => $544b42cded6cd5af$export$83a7763534d1d7a0);
$parcel$export(module.exports, "clearSelection", () => $544b42cded6cd5af$export$a3d02541b0ebf605);
$parcel$export(module.exports, "isSelected", () => $544b42cded6cd5af$export$e4d153b3e021fb47);
// Canvas v2 selection. Mutates `v2.selection` in place; chrome
// (selection box, handles, navbar) is updated imperatively via
// `refreshCanvasChrome` in the CanvasEditor overlay. Item DOM also
// gets `data-selected="1"` toggled for any item-local styling hooks.
function $544b42cded6cd5af$var$applyItemSelectedAttr(el, prevIds, nextIds, primary) {
    const items = el.getRoot?.()?.lookdown?.('CvItems');
    if (!items) return;
    const prev = new Set(prevIds);
    const next = new Set(nextIds);
    for (const child of Object.values(items)){
        const k = child?.state?.key;
        if (!k) continue;
        const was = prev.has(k);
        const is = next.has(k);
        if (was === is) {
            // Primary may have changed even if membership didn't.
            if (is && child.update) child.update({
                attr: {
                    'data-selected': k === primary ? 'primary' : '1'
                }
            });
            continue;
        }
        child.update?.({
            attr: {
                'data-selected': is ? k === primary ? 'primary' : '1' : null
            }
        });
    }
}
function $544b42cded6cd5af$var$setSel(el, ids, primary) {
    const v2 = el.call('getCanvasV2');
    if (!v2) return;
    const prev = v2.selection.ids;
    const nextIds = Array.from(new Set(ids));
    const nextPrimary = primary ?? (nextIds.length ? nextIds[nextIds.length - 1] : null);
    v2.selection = {
        ids: nextIds,
        primary: nextPrimary
    };
    $544b42cded6cd5af$var$applyItemSelectedAttr(el, prev, nextIds, nextPrimary);
    // Mirror to v1 scope for legacy chrome.
    const scope = el.call('getCanvasScope');
    if (scope) scope.selectedKey = nextPrimary;
    el.call('refreshCanvasChrome');
    el.call('syncCanvas');
}
function $544b42cded6cd5af$export$9633ae49ba77655e(key) {
    $544b42cded6cd5af$var$setSel(this, key ? [
        key
    ] : [], key || null);
}
function $544b42cded6cd5af$export$6853837031592033(key) {
    const v2 = this.call('getCanvasV2');
    if (!v2 || !key) return;
    const present = v2.selection.ids.includes(key);
    const next = present ? v2.selection.ids.filter((k)=>k !== key) : [
        ...v2.selection.ids,
        key
    ];
    $544b42cded6cd5af$var$setSel(this, next, present ? null : key);
}
function $544b42cded6cd5af$export$83a7763534d1d7a0(keys) {
    $544b42cded6cd5af$var$setSel(this, keys || [], null);
}
function $544b42cded6cd5af$export$a3d02541b0ebf605() {
    $544b42cded6cd5af$var$setSel(this, [], null);
}
function $544b42cded6cd5af$export$e4d153b3e021fb47(key) {
    return !!this.call('getCanvasV2')?.selection?.ids?.includes(key);
}

});

parcelRegister("6Gi6J", function(module, exports) {

$parcel$export(module.exports, "bboxOfRects", () => $4dd4b61f9f3d84f2$export$aa8dba1727a226a7);
$parcel$export(module.exports, "bboxForSelection", () => $4dd4b61f9f3d84f2$export$1f5a3daed4f807fd);
$parcel$export(module.exports, "bboxForGroup", () => $4dd4b61f9f3d84f2$export$ef99114cd76bb152);
$parcel$export(module.exports, "itemsInMarqueeRect", () => $4dd4b61f9f3d84f2$export$6cc1c4b0b28a57fc);
$parcel$export(module.exports, "snapRect", () => $4dd4b61f9f3d84f2$export$4b1a46b94038ab1d);
// Pure geometry helpers — no DOM, no state mutation. Components call
// these to derive values for reactive props.
function $4dd4b61f9f3d84f2$var$itemRect(it) {
    return {
        x: it.x || 0,
        y: it.y || 0,
        w: it.w || 0,
        h: it.h || 0
    };
}
function $4dd4b61f9f3d84f2$export$aa8dba1727a226a7(rects) {
    let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
    for (const r of rects){
        if (!r) continue;
        if (r.x < minX) minX = r.x;
        if (r.y < minY) minY = r.y;
        if (r.x + r.w > maxX) maxX = r.x + r.w;
        if (r.y + r.h > maxY) maxY = r.y + r.h;
    }
    if (!Number.isFinite(minX)) return null;
    return {
        x: minX,
        y: minY,
        w: maxX - minX,
        h: maxY - minY
    };
}
function $4dd4b61f9f3d84f2$var$bboxOfItems(items, ids) {
    return $4dd4b61f9f3d84f2$export$aa8dba1727a226a7(ids.map((id)=>items[id] && $4dd4b61f9f3d84f2$var$itemRect(items[id])));
}
function $4dd4b61f9f3d84f2$export$1f5a3daed4f807fd() {
    const v2 = this.call('getCanvasV2');
    if (!v2) return null;
    return $4dd4b61f9f3d84f2$var$bboxOfItems(v2.items, v2.selection.ids);
}
function $4dd4b61f9f3d84f2$export$ef99114cd76bb152(groupId) {
    const v2 = this.call('getCanvasV2');
    const g = v2?.groups?.[groupId];
    if (!g) return null;
    return $4dd4b61f9f3d84f2$var$bboxOfItems(v2.items, g.children);
}
function $4dd4b61f9f3d84f2$export$6cc1c4b0b28a57fc(m) {
    const v2 = this.call('getCanvasV2');
    if (!v2 || !m) return [];
    const mx2 = m.x + m.w, my2 = m.y + m.h;
    const hits = [];
    for (const [id, it] of Object.entries(v2.items)){
        const r = $4dd4b61f9f3d84f2$var$itemRect(it);
        const intersects = !(r.x + r.w < m.x || r.x > mx2 || r.y + r.h < m.y || r.y > my2);
        if (intersects) hits.push(id);
    }
    return hits;
}
function $4dd4b61f9f3d84f2$export$4b1a46b94038ab1d(opts) {
    const v2 = this.call('getCanvasV2');
    if (!v2 || !v2.snap.enabled) return {
        dx: 0,
        dy: 0,
        lines: []
    };
    const { rect: rect, movingIds: movingIds = [] } = opts || {};
    if (!rect) return {
        dx: 0,
        dy: 0,
        lines: []
    };
    const threshold = (v2.snap.threshold || 6) / (v2.viewport.scale || 1);
    const lines = [];
    let dx = 0, dy = 0;
    let bestX = threshold, bestY = threshold;
    const rxs = [
        rect.x,
        rect.x + rect.w / 2,
        rect.x + rect.w
    ];
    const rys = [
        rect.y,
        rect.y + rect.h / 2,
        rect.y + rect.h
    ];
    const considerX = (target, source, kind)=>{
        const d = target - source;
        if (Math.abs(d) <= bestX) {
            bestX = Math.abs(d);
            dx = d;
            lines.push({
                axis: 'v',
                pos: target,
                kind: kind
            });
        }
    };
    const considerY = (target, source, kind)=>{
        const d = target - source;
        if (Math.abs(d) <= bestY) {
            bestY = Math.abs(d);
            dy = d;
            lines.push({
                axis: 'h',
                pos: target,
                kind: kind
            });
        }
    };
    if (v2.snap.toItems) {
        const moving = new Set(movingIds);
        for (const [id, it] of Object.entries(v2.items)){
            if (moving.has(id)) continue;
            const txs = [
                it.x,
                it.x + it.w / 2,
                it.x + it.w
            ];
            for (const t of txs)for (const s of rxs)considerX(t, s, 'item');
            const tys = [
                it.y,
                it.y + it.h / 2,
                it.y + it.h
            ];
            for (const t of tys)for (const s of rys)considerY(t, s, 'item');
        }
    }
    if (v2.snap.toGuides) {
        for (const gx of v2.guides.vertical || [])for (const s of rxs)considerX(gx, s, 'guide');
        for (const gy of v2.guides.horizontal || [])for (const s of rys)considerY(gy, s, 'guide');
    }
    if (v2.snap.toGrid) {
        const step = v2.snap.gridStep || 64;
        for (const s of rxs){
            const t = Math.round(s / step) * step;
            considerX(t, s, 'grid');
        }
        for (const s of rys){
            const t = Math.round(s / step) * step;
            considerY(t, s, 'grid');
        }
    }
    return {
        dx: dx,
        dy: dy,
        lines: lines
    };
}

});

parcelRegister("lbCRy", function(module, exports) {

$parcel$export(module.exports, "trackPointerDown", () => $f6c8c56a0d8e8337$export$a553193fd4c06b9a);
$parcel$export(module.exports, "forgetItemRefs", () => $f6c8c56a0d8e8337$export$f18031d34514af2b);
$parcel$export(module.exports, "trackPointerMove", () => $f6c8c56a0d8e8337$export$71f75065f080cb5b);
$parcel$export(module.exports, "trackPointerEnd", () => $f6c8c56a0d8e8337$export$cd1d1f168cf6aaab);
$parcel$export(module.exports, "beginDrag", () => $f6c8c56a0d8e8337$export$f2c4658bfb249ab);
$parcel$export(module.exports, "applyDragMove", () => $f6c8c56a0d8e8337$export$4c2f7f54a7902fe6);
$parcel$export(module.exports, "beginResize", () => $f6c8c56a0d8e8337$export$ac28acc9818ac98a);
$parcel$export(module.exports, "applyResizeMove", () => $f6c8c56a0d8e8337$export$d091f4ca78360b90);
$parcel$export(module.exports, "commitTransient", () => $f6c8c56a0d8e8337$export$2bf32010eca5c0c7);
$parcel$export(module.exports, "beginMarquee", () => $f6c8c56a0d8e8337$export$54fe589791f85cde);
$parcel$export(module.exports, "applyMarqueeMove", () => $f6c8c56a0d8e8337$export$1a08599f01281e4e);
$parcel$export(module.exports, "commitMarquee", () => $f6c8c56a0d8e8337$export$eebde3dbedcf1ab6);
$parcel$export(module.exports, "beginPan", () => $f6c8c56a0d8e8337$export$b0feeea444f8863d);
$parcel$export(module.exports, "applyPanMove", () => $f6c8c56a0d8e8337$export$eca6ba76b8fc0686);
$parcel$export(module.exports, "beginPinch", () => $f6c8c56a0d8e8337$export$514c4ddc4009b8ca);
$parcel$export(module.exports, "applyPinchMove", () => $f6c8c56a0d8e8337$export$a1decde8cee15169);
$parcel$export(module.exports, "onCanvasWheel", () => $f6c8c56a0d8e8337$export$7e0f78147dcb004d);
$parcel$export(module.exports, "spawnGuide", () => $f6c8c56a0d8e8337$export$13b5713586603623);
$parcel$export(module.exports, "applySpawnGuideMove", () => $f6c8c56a0d8e8337$export$383d26ffd4abbb7f);
$parcel$export(module.exports, "beginGuideDrag", () => $f6c8c56a0d8e8337$export$9f86ef1744b65470);
// Canvas v2 pointer interaction. Transient gesture state lives in this
// module (not root state) so drag/resize can update DOM imperatively
// via `el.update({ style: {...} })` without cascading full re-renders.
// Final positions commit to root state on pointerup.

var $6Gi6J = parcelRequire("6Gi6J");
const $f6c8c56a0d8e8337$var$SESSION = {
    current: null,
    pointers: {},
    itemRefs: {},
    sceneRef: null,
    surfaceRef: null
};
function $f6c8c56a0d8e8337$var$ensureSceneRefs(el) {
    const root = el.getRoot?.();
    if (!$f6c8c56a0d8e8337$var$SESSION.surfaceRef) $f6c8c56a0d8e8337$var$SESSION.surfaceRef = root?.lookdown?.('CanvasSurface') || null;
    if (!$f6c8c56a0d8e8337$var$SESSION.sceneRef) $f6c8c56a0d8e8337$var$SESSION.sceneRef = root?.lookdown?.('CvScene') || null;
}
function $f6c8c56a0d8e8337$var$itemRefByKey(el, key) {
    if ($f6c8c56a0d8e8337$var$SESSION.itemRefs[key]) return $f6c8c56a0d8e8337$var$SESSION.itemRefs[key];
    const root = el.getRoot?.();
    const items = root?.lookdown?.('CvItems');
    if (items?.__ref?.children) {
        for (const child of Object.values(items))if (child?.state?.key === key) {
            $f6c8c56a0d8e8337$var$SESSION.itemRefs[key] = child;
            return child;
        }
    }
    return null;
}
function $f6c8c56a0d8e8337$var$surfaceRect(el) {
    $f6c8c56a0d8e8337$var$ensureSceneRefs(el);
    return ($f6c8c56a0d8e8337$var$SESSION.surfaceRef?.node || el.node).getBoundingClientRect();
}
function $f6c8c56a0d8e8337$var$toCanvas(v2, clientX, clientY, rect) {
    const { x: x, y: y, scale: scale } = v2.viewport;
    return {
        x: (clientX - rect.left - x) / scale,
        y: (clientY - rect.top - y) / scale
    };
}
function $f6c8c56a0d8e8337$var$updateItemStyle(el, key, it) {
    const ref = $f6c8c56a0d8e8337$var$itemRefByKey(el, key);
    if (!ref?.update) return;
    ref.update({
        style: {
            left: (it.x ?? 0) + 'px',
            top: (it.y ?? 0) + 'px',
            width: (it.w ?? 0) + 'px',
            height: (it.h ?? 0) + 'px'
        }
    });
}
// Snap lines render in the editor overlay (screen-space). `lines` are
// canvas-space — convert via current viewport.
function $f6c8c56a0d8e8337$var$updateSnapLinesDOM(el, lines) {
    const overlay = el.getRoot?.()?.lookdown?.('CanvasOverlayV2');
    const layer = overlay?.CvSnapLines;
    if (!layer) return;
    const v2 = el.call('getCanvasV2');
    const vp = v2?.viewport || {
        x: 0,
        y: 0,
        scale: 1
    };
    for(let i = 0; i < 4; i++){
        const line = layer[`Line${i + 1}`];
        if (!line?.update) continue;
        const def = lines[i];
        if (!def) {
            line.update({
                style: {
                    display: 'none'
                }
            });
            continue;
        }
        const base = {
            display: 'block',
            position: 'absolute',
            background: 'rgba(64,156,255,1)'
        };
        if (def.axis === 'h') {
            const screenY = def.pos * vp.scale + vp.y;
            line.update({
                style: {
                    ...base,
                    left: '0',
                    right: '0',
                    top: screenY + 'px',
                    height: '1px'
                }
            });
        } else {
            const screenX = def.pos * vp.scale + vp.x;
            line.update({
                style: {
                    ...base,
                    top: '0',
                    bottom: '0',
                    left: screenX + 'px',
                    width: '1px'
                }
            });
        }
    }
}
// Anchored zoom — returns { x, y, scale } so the world-point under
// (clientCx, clientCy) stays pinned.
function $f6c8c56a0d8e8337$var$anchoredZoom(viewport, clientCx, clientCy, newScale, rect) {
    const worldX = (clientCx - rect.left - viewport.x) / viewport.scale;
    const worldY = (clientCy - rect.top - viewport.y) / viewport.scale;
    return {
        x: clientCx - rect.left - worldX * newScale,
        y: clientCy - rect.top - worldY * newScale,
        scale: newScale
    };
}
// Capture on a stable element (the canvas surface) so pointermove
// events keep flowing even when the pointer leaves the original target
// — `ev.currentTarget` is unreliable under DOMQL's delegated handlers.
function $f6c8c56a0d8e8337$var$capture(el, ev) {
    try {
        const target = $f6c8c56a0d8e8337$var$SESSION.surfaceRef?.node || el?.node || ev.target;
        target?.setPointerCapture?.(ev.pointerId);
    } catch  {}
}
function $f6c8c56a0d8e8337$var$recordPointer(ev) {
    $f6c8c56a0d8e8337$var$SESSION.pointers[ev.pointerId] = {
        id: ev.pointerId,
        type: ev.pointerType,
        x: ev.clientX,
        y: ev.clientY,
        startX: ev.clientX,
        startY: ev.clientY
    };
}
function $f6c8c56a0d8e8337$var$activePointers() {
    return Object.values($f6c8c56a0d8e8337$var$SESSION.pointers);
}
function $f6c8c56a0d8e8337$export$a553193fd4c06b9a(ev) {
    $f6c8c56a0d8e8337$var$recordPointer(ev);
}
function $f6c8c56a0d8e8337$export$f18031d34514af2b(ids) {
    if (!Array.isArray(ids)) return;
    for (const id of ids)delete $f6c8c56a0d8e8337$var$SESSION.itemRefs[id];
}
function $f6c8c56a0d8e8337$export$71f75065f080cb5b(ev) {
    const p = $f6c8c56a0d8e8337$var$SESSION.pointers[ev.pointerId];
    // Browsers emit zero-delta pointermove on some trackpads; skip.
    if (p && p.x === ev.clientX && p.y === ev.clientY && $f6c8c56a0d8e8337$var$SESSION.current) return;
    if (p) {
        p.x = ev.clientX;
        p.y = ev.clientY;
    }
    const s = $f6c8c56a0d8e8337$var$SESSION.current;
    if (!s) {
        if ($f6c8c56a0d8e8337$var$activePointers().length === 2) this.call('beginPinch');
        return;
    }
    if (s.type === 'drag') this.call('applyDragMove', ev);
    else if (s.type === 'resize') this.call('applyResizeMove', ev);
    else if (s.type === 'marquee') this.call('applyMarqueeMove', ev);
    else if (s.type === 'pan') this.call('applyPanMove', ev);
    else if (s.type === 'pinch') this.call('applyPinchMove', ev);
    else if (s.type === 'spawnGuide') this.call('applySpawnGuideMove', ev);
}
function $f6c8c56a0d8e8337$export$cd1d1f168cf6aaab(ev) {
    delete $f6c8c56a0d8e8337$var$SESSION.pointers[ev.pointerId];
    const s = $f6c8c56a0d8e8337$var$SESSION.current;
    if (!s) return;
    if (s.type === 'drag' || s.type === 'resize') this.call('commitTransient');
    else if (s.type === 'marquee') this.call('commitMarquee');
    $f6c8c56a0d8e8337$var$SESSION.current = null;
    // Clear transient chrome imperatively (no patchCanvas → no re-render).
    $f6c8c56a0d8e8337$var$updateSnapLinesDOM(this, []);
    // Marquee box hides via chrome refresh after we clear v2.marquee
    // below. Clear in-memory v2.marquee directly (already done in
    // commitMarquee) — refresh runs via patchCanvas there.
    const v2 = this.call('getCanvasV2');
    if (v2 && v2.marquee) {
        v2.marquee = null;
        this.call('refreshCanvasChrome');
    }
}
function $f6c8c56a0d8e8337$export$f2c4658bfb249ab(ev, key) {
    const v2 = this.call('getCanvasV2');
    if (!v2) return;
    ev.preventDefault?.();
    $f6c8c56a0d8e8337$var$capture(this, ev);
    $f6c8c56a0d8e8337$var$recordPointer(ev);
    const sel = v2.selection;
    const movingIds = sel.ids.includes(key) ? [
        ...sel.ids
    ] : [
        key
    ];
    const movingSet = new Set(movingIds);
    const start = {};
    movingIds.forEach((id)=>{
        const it = v2.items[id];
        if (it) start[id] = {
            x: it.x,
            y: it.y,
            w: it.w,
            h: it.h
        };
    });
    // Precompute snap targets once per gesture — the items list and
    // guide positions don't change during a drag.
    const snapTargets = v2.snap.enabled && v2.snap.toItems ? Object.entries(v2.items).filter(([id])=>!movingSet.has(id)).map(([, it])=>it) : [];
    // Anchor the drag to the cursor's offset within the primary item so
    // the cursor stays at the same relative point throughout the drag.
    const primaryItem = v2.items[key];
    const v2Vp = v2.viewport;
    const primaryScreen = primaryItem ? {
        x: primaryItem.x * v2Vp.scale + v2Vp.x,
        y: primaryItem.y * v2Vp.scale + v2Vp.y
    } : {
        x: ev.clientX,
        y: ev.clientY
    };
    const cursorOffset = {
        x: ev.clientX - primaryScreen.x,
        y: ev.clientY - primaryScreen.y
    };
    $f6c8c56a0d8e8337$var$SESSION.current = {
        type: 'drag',
        pointerId: ev.pointerId,
        startClient: {
            x: ev.clientX,
            y: ev.clientY
        },
        movingIds: movingIds,
        start: start,
        live: {
            ...start
        },
        snapTargets: snapTargets,
        cursorOffset: cursorOffset
    };
}
// Auto-pan threshold (screen px) when dragging near surface edge.
const $f6c8c56a0d8e8337$var$EDGE_BAND = 40;
const $f6c8c56a0d8e8337$var$EDGE_PAN_PER_FRAME = 12;
function $f6c8c56a0d8e8337$var$maybeAutoPan(el, ev) {
    const rect = $f6c8c56a0d8e8337$var$surfaceRect(el);
    let dx = 0, dy = 0;
    if (ev.clientX - rect.left < $f6c8c56a0d8e8337$var$EDGE_BAND) dx = $f6c8c56a0d8e8337$var$EDGE_PAN_PER_FRAME;
    else if (rect.right - ev.clientX < $f6c8c56a0d8e8337$var$EDGE_BAND) dx = -$f6c8c56a0d8e8337$var$EDGE_PAN_PER_FRAME;
    if (ev.clientY - rect.top < $f6c8c56a0d8e8337$var$EDGE_BAND) dy = $f6c8c56a0d8e8337$var$EDGE_PAN_PER_FRAME;
    else if (rect.bottom - ev.clientY < $f6c8c56a0d8e8337$var$EDGE_BAND) dy = -$f6c8c56a0d8e8337$var$EDGE_PAN_PER_FRAME;
    if (!dx && !dy) return;
    const v2 = el.call('getCanvasV2');
    if (!v2) return;
    const vp = v2.viewport;
    el.call('applyViewport', {
        ...vp,
        x: vp.x + dx,
        y: vp.y + dy
    });
}
function $f6c8c56a0d8e8337$export$4c2f7f54a7902fe6(ev) {
    const v2 = this.call('getCanvasV2');
    const s = $f6c8c56a0d8e8337$var$SESSION.current;
    if (!s || s.type !== 'drag' || s.pointerId !== ev.pointerId) return;
    $f6c8c56a0d8e8337$var$maybeAutoPan(this, ev);
    const scale = v2.viewport.scale || 1;
    const rawDx = (ev.clientX - s.startClient.x) / scale;
    const rawDy = (ev.clientY - s.startClient.y) / scale;
    const bbox = (0, $6Gi6J.bboxOfRects)(s.movingIds.map((id)=>{
        const st = s.start[id];
        return st && {
            x: st.x + rawDx,
            y: st.y + rawDy,
            w: st.w,
            h: st.h
        };
    }));
    const snap = bbox ? this.call('snapRect', {
        rect: bbox,
        movingIds: s.movingIds
    }) : {
        dx: 0,
        dy: 0,
        lines: []
    };
    s.movingIds.forEach((id)=>{
        const st = s.start[id];
        if (!st) return;
        s.live[id] = {
            x: st.x + rawDx + snap.dx,
            y: st.y + rawDy + snap.dy,
            w: st.w,
            h: st.h
        };
        $f6c8c56a0d8e8337$var$updateItemStyle(this, id, s.live[id]);
        // Mirror to v2.items so refreshCanvasChrome reads live coords.
        const it = v2.items[id];
        if (it) {
            it.x = s.live[id].x;
            it.y = s.live[id].y;
        }
    });
    $f6c8c56a0d8e8337$var$updateSnapLinesDOM(this, snap.lines);
    this.call('refreshCanvasChrome');
}
function $f6c8c56a0d8e8337$export$ac28acc9818ac98a(ev, key, handle) {
    const v2 = this.call('getCanvasV2');
    if (!v2) return;
    ev.preventDefault?.();
    ev.stopPropagation?.();
    $f6c8c56a0d8e8337$var$capture(this, ev);
    $f6c8c56a0d8e8337$var$recordPointer(ev);
    const it = v2.items[key];
    if (!it) return;
    $f6c8c56a0d8e8337$var$SESSION.current = {
        type: 'resize',
        pointerId: ev.pointerId,
        key: key,
        handle: handle,
        startClient: {
            x: ev.clientX,
            y: ev.clientY
        },
        start: {
            x: it.x,
            y: it.y,
            w: it.w,
            h: it.h
        },
        live: {
            x: it.x,
            y: it.y,
            w: it.w,
            h: it.h
        }
    };
}
function $f6c8c56a0d8e8337$export$d091f4ca78360b90(ev) {
    const v2 = this.call('getCanvasV2');
    const s = $f6c8c56a0d8e8337$var$SESSION.current;
    if (!s || s.type !== 'resize' || s.pointerId !== ev.pointerId) return;
    const scale = v2.viewport.scale || 1;
    const dx = (ev.clientX - s.startClient.x) / scale;
    const dy = (ev.clientY - s.startClient.y) / scale;
    const { handle: handle, start: start, key: key } = s;
    const MIN = 80;
    let nx = start.x, ny = start.y, nw = start.w, nh = start.h;
    if (handle.includes('w')) {
        nx = start.x + dx;
        nw = start.w - dx;
    }
    if (handle.includes('e')) nw = start.w + dx;
    if (handle.includes('n')) {
        ny = start.y + dy;
        nh = start.h - dy;
    }
    if (handle.includes('s')) nh = start.h + dy;
    if (nw < MIN) {
        if (handle.includes('w')) nx = start.x + start.w - MIN;
        nw = MIN;
    }
    if (nh < MIN) {
        if (handle.includes('n')) ny = start.y + start.h - MIN;
        nh = MIN;
    }
    const snap = this.call('snapRect', {
        rect: {
            x: nx,
            y: ny,
            w: nw,
            h: nh
        },
        movingIds: [
            key
        ]
    });
    if (handle.includes('w')) {
        nx += snap.dx;
        nw -= snap.dx;
    } else if (handle.includes('e')) nw += snap.dx;
    if (handle.includes('n')) {
        ny += snap.dy;
        nh -= snap.dy;
    } else if (handle.includes('s')) nh += snap.dy;
    s.live = {
        x: nx,
        y: ny,
        w: nw,
        h: nh
    };
    $f6c8c56a0d8e8337$var$updateItemStyle(this, key, s.live);
    // Mirror to v2.items for refreshCanvasChrome live read.
    const itLive = v2.items[key];
    if (itLive) {
        itLive.x = nx;
        itLive.y = ny;
        itLive.w = nw;
        itLive.h = nh;
    }
    $f6c8c56a0d8e8337$var$updateSnapLinesDOM(this, snap.lines || []);
    this.call('refreshCanvasChrome');
}
function $f6c8c56a0d8e8337$export$2bf32010eca5c0c7() {
    const s = $f6c8c56a0d8e8337$var$SESSION.current;
    if (!s) return;
    if (s.type === 'drag') s.movingIds.forEach((id)=>{
        const live = s.live[id];
        if (live) this.call('patchCanvasItem', id, {
            x: live.x,
            y: live.y
        });
    });
    else if (s.type === 'resize') this.call('patchCanvasItem', s.key, s.live);
    // Items moved → reposition all chrome (selection box, handles, navbar).
    this.call('refreshCanvasChrome');
    this.call('pushHistory');
    this.call('persistCanvasLayout');
}
function $f6c8c56a0d8e8337$export$54fe589791f85cde(ev) {
    const v2 = this.call('getCanvasV2');
    if (!v2) return;
    if (ev.button === 2) return;
    if ($f6c8c56a0d8e8337$var$activePointers().length >= 1) {
        $f6c8c56a0d8e8337$var$recordPointer(ev);
        if ($f6c8c56a0d8e8337$var$activePointers().length === 2) this.call('beginPinch');
        return;
    }
    $f6c8c56a0d8e8337$var$capture(this, ev);
    $f6c8c56a0d8e8337$var$recordPointer(ev);
    const rect = $f6c8c56a0d8e8337$var$surfaceRect(this);
    const p = $f6c8c56a0d8e8337$var$toCanvas(v2, ev.clientX, ev.clientY, rect);
    if (!ev.shiftKey && !ev.metaKey && !ev.ctrlKey) this.call('clearSelection');
    $f6c8c56a0d8e8337$var$SESSION.current = {
        type: 'marquee',
        pointerId: ev.pointerId,
        origin: p,
        current: p,
        additive: ev.shiftKey || ev.metaKey || ev.ctrlKey,
        rect: rect
    };
    v2.marquee = {
        x: p.x,
        y: p.y,
        w: 0,
        h: 0
    };
    this.call('refreshCanvasChrome');
}
function $f6c8c56a0d8e8337$export$1a08599f01281e4e(ev) {
    const v2 = this.call('getCanvasV2');
    const s = $f6c8c56a0d8e8337$var$SESSION.current;
    if (!s || s.type !== 'marquee') return;
    const p = $f6c8c56a0d8e8337$var$toCanvas(v2, ev.clientX, ev.clientY, s.rect);
    s.current = p;
    v2.marquee = {
        x: Math.min(s.origin.x, p.x),
        y: Math.min(s.origin.y, p.y),
        w: Math.abs(p.x - s.origin.x),
        h: Math.abs(p.y - s.origin.y)
    };
    this.call('refreshCanvasChrome');
}
function $f6c8c56a0d8e8337$export$eebde3dbedcf1ab6() {
    const v2 = this.call('getCanvasV2');
    const s = $f6c8c56a0d8e8337$var$SESSION.current;
    if (!v2 || !s) return;
    // marqueeRect for itemsInMarquee — read from session, not state.
    const rect = {
        x: Math.min(s.origin.x, s.current.x),
        y: Math.min(s.origin.y, s.current.y),
        w: Math.abs(s.current.x - s.origin.x),
        h: Math.abs(s.current.y - s.origin.y)
    };
    const hits = this.call('itemsInMarqueeRect', rect);
    if (s.additive) {
        const merged = Array.from(new Set([
            ...v2.selection.ids || [],
            ...hits
        ]));
        this.call('selectMany', merged);
    } else this.call('selectMany', hits);
}
function $f6c8c56a0d8e8337$export$b0feeea444f8863d(ev) {
    const v2 = this.call('getCanvasV2');
    if (!v2) return;
    $f6c8c56a0d8e8337$var$capture(this, ev);
    $f6c8c56a0d8e8337$var$recordPointer(ev);
    $f6c8c56a0d8e8337$var$SESSION.current = {
        type: 'pan',
        pointerId: ev.pointerId,
        startClient: {
            x: ev.clientX,
            y: ev.clientY
        },
        startViewport: {
            ...v2.viewport
        }
    };
}
function $f6c8c56a0d8e8337$export$eca6ba76b8fc0686(ev) {
    const s = $f6c8c56a0d8e8337$var$SESSION.current;
    if (!s || s.type !== 'pan' || s.pointerId !== ev.pointerId) return;
    const dx = ev.clientX - s.startClient.x;
    const dy = ev.clientY - s.startClient.y;
    this.call('applyViewport', {
        ...s.startViewport,
        x: s.startViewport.x + dx,
        y: s.startViewport.y + dy
    });
}
function $f6c8c56a0d8e8337$export$514c4ddc4009b8ca() {
    const v2 = this.call('getCanvasV2');
    if (!v2) return;
    const pts = $f6c8c56a0d8e8337$var$activePointers();
    if (pts.length < 2) return;
    const [a, b] = pts;
    $f6c8c56a0d8e8337$var$SESSION.current = {
        type: 'pinch',
        ids: [
            a.id,
            b.id
        ],
        startDist: Math.hypot(b.x - a.x, b.y - a.y),
        startCenter: {
            x: (a.x + b.x) / 2,
            y: (a.y + b.y) / 2
        },
        startViewport: {
            ...v2.viewport
        },
        rect: $f6c8c56a0d8e8337$var$surfaceRect(this)
    };
    this.call('patchCanvas', {
        marquee: null
    });
}
function $f6c8c56a0d8e8337$export$a1decde8cee15169() {
    const s = $f6c8c56a0d8e8337$var$SESSION.current;
    if (!s || s.type !== 'pinch') return;
    const pts = (s.ids || []).map((id)=>$f6c8c56a0d8e8337$var$SESSION.pointers[id]).filter(Boolean);
    if (pts.length < 2) return;
    const [a, b] = pts;
    const cx = (a.x + b.x) / 2, cy = (a.y + b.y) / 2;
    const dist = Math.hypot(b.x - a.x, b.y - a.y);
    const factor = Math.max(0.02, Math.min(10, dist / (s.startDist || 1)));
    const newScale = Math.max(0.035, Math.min(2.5, s.startViewport.scale * factor));
    this.call('applyViewport', $f6c8c56a0d8e8337$var$anchoredZoom(s.startViewport, cx, cy, newScale, s.rect));
}
function $f6c8c56a0d8e8337$export$7e0f78147dcb004d(ev) {
    const v2 = this.call('getCanvasV2');
    if (!v2) return;
    const rect = $f6c8c56a0d8e8337$var$surfaceRect(this);
    const vp = v2.viewport;
    if (ev.ctrlKey || ev.metaKey) {
        const factor = Math.exp(-ev.deltaY * 0.0025);
        const newScale = Math.max(0.035, Math.min(2.5, vp.scale * factor));
        this.call('applyViewport', $f6c8c56a0d8e8337$var$anchoredZoom(vp, ev.clientX, ev.clientY, newScale, rect));
    } else this.call('applyViewport', {
        ...vp,
        x: vp.x - ev.deltaX,
        y: vp.y - ev.deltaY
    });
}
function $f6c8c56a0d8e8337$export$13b5713586603623(axis, ev) {
    const v2 = this.call('getCanvasV2');
    if (!v2) return;
    $f6c8c56a0d8e8337$var$capture(this, ev);
    $f6c8c56a0d8e8337$var$recordPointer(ev);
    const rect = $f6c8c56a0d8e8337$var$surfaceRect(this);
    const p = $f6c8c56a0d8e8337$var$toCanvas(v2, ev.clientX, ev.clientY, rect);
    const prev = v2.guides || {
        horizontal: [],
        vertical: []
    };
    const horizontal = axis === 'h' ? [
        ...prev.horizontal,
        p.y
    ] : [
        ...prev.horizontal
    ];
    const vertical = axis === 'v' ? [
        ...prev.vertical,
        p.x
    ] : [
        ...prev.vertical
    ];
    const index = axis === 'h' ? horizontal.length - 1 : vertical.length - 1;
    $f6c8c56a0d8e8337$var$SESSION.current = {
        type: 'spawnGuide',
        axis: axis,
        pointerId: ev.pointerId,
        index: index,
        rect: rect
    };
    // Single state.update — re-renders CvGuidesLayer children.
    this.call('patchCanvas', {
        guides: {
            horizontal: horizontal,
            vertical: vertical
        }
    });
}
function $f6c8c56a0d8e8337$export$383d26ffd4abbb7f(ev) {
    const v2 = this.call('getCanvasV2');
    const s = $f6c8c56a0d8e8337$var$SESSION.current;
    if (!s || s.type !== 'spawnGuide' || s.pointerId !== ev.pointerId) return;
    const p = $f6c8c56a0d8e8337$var$toCanvas(v2, ev.clientX, ev.clientY, s.rect);
    // Mutate in place — no state.update during drag for smoothness.
    const arr = s.axis === 'h' ? v2.guides.horizontal : v2.guides.vertical;
    if (s.index < 0 || s.index >= arr.length) return;
    arr[s.index] = s.axis === 'h' ? p.y : p.x;
    // Imperative DOM update on the matching CanvasGuide element.
    const layer = this.getRoot?.()?.lookdown?.('CvGuidesLayer');
    if (layer) {
        for (const child of Object.values(layer))if (child?.state?.axis === s.axis && child?.state?.index === s.index && child?.update) {
            // Position is canvas-space → screen via viewport for chrome rendering.
            const vp = v2.viewport;
            if (s.axis === 'h') {
                const screenY = p.y * vp.scale + vp.y;
                child.update({
                    style: {
                        top: screenY + 'px'
                    }
                });
            } else {
                const screenX = p.x * vp.scale + vp.x;
                child.update({
                    style: {
                        left: screenX + 'px'
                    }
                });
            }
            break;
        }
    }
}
function $f6c8c56a0d8e8337$export$9f86ef1744b65470(ev, axis, index) {
    const v2 = this.call('getCanvasV2');
    if (!v2) return;
    ev.preventDefault?.();
    ev.stopPropagation?.();
    $f6c8c56a0d8e8337$var$capture(this, ev);
    $f6c8c56a0d8e8337$var$recordPointer(ev);
    const rect = $f6c8c56a0d8e8337$var$surfaceRect(this);
    $f6c8c56a0d8e8337$var$SESSION.current = {
        type: 'spawnGuide',
        axis: axis,
        pointerId: ev.pointerId,
        index: index,
        rect: rect
    };
}

});

parcelRegister("gIQ4T", function(module, exports) {

$parcel$export(module.exports, "group", () => $c2c9270151f2beda$export$e5e25fbcc1f7affe);
$parcel$export(module.exports, "ungroup", () => $c2c9270151f2beda$export$bfd8e2c61190db1c);
$parcel$export(module.exports, "collapseGroup", () => $c2c9270151f2beda$export$ed59a9341da2b6cf);
$parcel$export(module.exports, "groupBbox", () => (parcelRequire("6Gi6J")).bboxForGroup);
// Canvas v2 grouping. Project-scoped groups under
// `v2.groups = { [groupId]: { name, children: [pageKey…], collapsed } }`.

var $6Gi6J = parcelRequire("6Gi6J");
function $c2c9270151f2beda$var$makeGroupId() {
    return 'g_' + Math.random().toString(36).slice(2, 10);
}
function $c2c9270151f2beda$export$e5e25fbcc1f7affe() {
    const v2 = this.call('getCanvasV2');
    if (!v2) return;
    const ids = v2.selection.ids;
    if (ids.length < 2) return;
    const id = $c2c9270151f2beda$var$makeGroupId();
    v2.groups = {
        ...v2.groups || {},
        [id]: {
            name: 'Group',
            children: [
                ...ids
            ],
            collapsed: false
        }
    };
    this.call('refreshCanvasChrome');
    this.call('persistCanvasLayout');
    this.call('syncCanvas');
}
function $c2c9270151f2beda$export$bfd8e2c61190db1c(groupId) {
    const v2 = this.call('getCanvasV2');
    if (!v2 || !groupId) return;
    const next = {
        ...v2.groups || {}
    };
    delete next[groupId];
    v2.groups = next;
    this.call('refreshCanvasChrome');
    this.call('persistCanvasLayout');
    this.call('syncCanvas');
}
function $c2c9270151f2beda$export$ed59a9341da2b6cf(groupId) {
    const v2 = this.call('getCanvasV2');
    const g = v2?.groups?.[groupId];
    if (!g) return;
    g.collapsed = !g.collapsed;
    this.call('syncCanvas');
}

});

parcelRegister("ixb4M", function(module, exports) {

$parcel$export(module.exports, "inspectHover", () => $d7e3e68b5e02fbfa$export$5d23695e0b3b07de);
// Canvas v2 inspect-mode hover. Reads the DOMQL ref path from a
// forwarded pointer event and writes it to scope for the overlay to
// render from. No DOM probing — the ref is whatever DOMQL already
// attached during render.
function $d7e3e68b5e02fbfa$export$5d23695e0b3b07de(ev) {
    const scope = this.call('getCanvasScope');
    if (!scope) return;
    if (!ev?.target?.ref) {
        scope.hoverLayer = null;
        return;
    }
    const path = [
        ...ev.target.ref.__ref.path
    ];
    path.splice(0, 8);
    scope.hoverLayer = path.filter((key)=>key[0] !== key[0].toLowerCase());
}

});

parcelRegister("6uiEy", function(module, exports) {

$parcel$export(module.exports, "onCanvasKeydown", () => $4b940384074e562f$export$c9472c14d842c413);
$parcel$export(module.exports, "onCanvasKeyup", () => $4b940384074e562f$export$71b19c545e3b1149);
// Canvas v2 keyboard shortcuts.

var $6k38k = parcelRequire("6k38k");
function $4b940384074e562f$export$c9472c14d842c413(ev) {
    const v2 = this.call('getCanvasV2');
    if (!v2) return;
    const meta = ev.metaKey || ev.ctrlKey;
    const k = ev.key;
    if (meta && k.toLowerCase() === 'a') {
        ev.preventDefault();
        this.call('selectMany', Object.keys(v2.items));
        return;
    }
    if (k === 'Escape') {
        if (v2.settingsOpen) {
            this.call('setCanvasSettings', false);
            return;
        }
        this.call('clearSelection');
        return;
    }
    if (meta && k.toLowerCase() === 'g') {
        ev.preventDefault();
        if (ev.shiftKey) {
            const ids = v2.selection.ids;
            Object.entries(v2.groups || {}).filter(([, g])=>g.children.some((c)=>ids.includes(c))).forEach(([gid])=>this.call('ungroup', gid));
        } else this.call('group');
        return;
    }
    if (meta && k === ',') {
        ev.preventDefault();
        this.call('toggleCanvasSettings');
        return;
    }
    if (meta && k.toLowerCase() === 'd') {
        ev.preventDefault();
        this.call('duplicateSelection');
        return;
    }
    if (k === 'Delete' || k === 'Backspace') {
        if (!v2.selection.ids.length) return;
        ev.preventDefault();
        this.call('deleteSelection');
        return;
    }
    if (meta && k.toLowerCase() === 'z') {
        ev.preventDefault();
        if (ev.shiftKey) this.call('redo');
        else this.call('undo');
        return;
    }
    // Nudge selected items in place (no remount).
    const arrows = {
        ArrowLeft: [
            -1,
            0
        ],
        ArrowRight: [
            1,
            0
        ],
        ArrowUp: [
            0,
            -1
        ],
        ArrowDown: [
            0,
            1
        ]
    };
    const d = arrows[k];
    if (d) {
        if (!v2.selection.ids.length) return;
        ev.preventDefault();
        const step = (ev.shiftKey ? 10 : 1) / (v2.viewport.scale || 1);
        const items = this.getRoot?.()?.lookdown?.('CvItems');
        v2.selection.ids.forEach((id)=>{
            const it = v2.items[id];
            if (!it) return;
            const nx = it.x + d[0] * step;
            const ny = it.y + d[1] * step;
            this.call('patchCanvasItem', id, {
                x: nx,
                y: ny
            });
            if (items) {
                for (const child of Object.values(items))if (child?.state?.key === id && child?.update) {
                    child.update({
                        style: {
                            left: nx + 'px',
                            top: ny + 'px'
                        }
                    });
                    break;
                }
            }
        });
        this.call('refreshCanvasChrome');
        this.call('pushHistory');
        this.call('persistCanvasLayout');
        return;
    }
    if (meta && k === '0' || k === 'Home') {
        ev.preventDefault();
        this.call('resetCanvasView');
        return;
    }
    if (meta && k === '1') {
        ev.preventDefault();
        this.call('fitToSelection');
        return;
    }
    if (meta && k === '/') {
        ev.preventDefault();
        this.call('toggleShortcutsOverlay');
        return;
    }
    if (meta && k.toLowerCase() === 'l') {
        ev.preventDefault();
        this.call('autoLayout');
        return;
    }
    if (k === 'v' || k === 'V') this.call('setCanvasV2Mode', (0, $6k38k.MODES).DEFAULT);
    if (k === 'h' || k === 'H') this.call('setCanvasV2Mode', (0, $6k38k.MODES).PAN);
    if (k === 'i' || k === 'I') this.call('setCanvasV2Mode', (0, $6k38k.MODES).INSPECT);
    if (k === 'u' || k === 'U') this.call('setCanvasV2Mode', (0, $6k38k.MODES).INTERACT);
    if (k === ' ' && !ev.repeat) {
        ev.preventDefault();
        if (v2.mode !== (0, $6k38k.MODES).PAN) {
            this.call('setCanvasV2Mode', (0, $6k38k.MODES).PAN);
            const scope = this.call('getCanvasScope');
            if (scope) scope._spaceModeFrom = 'space';
        }
    }
}
function $4b940384074e562f$export$71b19c545e3b1149(ev) {
    const v2 = this.call('getCanvasV2');
    if (!v2) return;
    if (ev.key === ' ') {
        const scope = this.call('getCanvasScope');
        if (scope?._spaceModeFrom === 'space') {
            scope._spaceModeFrom = null;
            this.call('setCanvasV2Mode', (0, $6k38k.MODES).DEFAULT);
        }
    }
}

});

parcelRegister("k7a70", function(module, exports) {

$parcel$export(module.exports, "duplicateSelection", () => $ea4c4e1e8991ffd6$export$3c0bb68e76442a1e);
$parcel$export(module.exports, "deleteSelection", () => $ea4c4e1e8991ffd6$export$e9a518a637d1e641);
// Duplicate / delete selected canvas items.
function $ea4c4e1e8991ffd6$var$nextKey(items, base) {
    let i = 1;
    while(items[`${base}_copy${i > 1 ? i : ''}`])i++;
    return `${base}_copy${i > 1 ? i : ''}`;
}
function $ea4c4e1e8991ffd6$export$3c0bb68e76442a1e() {
    const v2 = this.call('getCanvasV2');
    if (!v2) return;
    const ids = v2.selection.ids;
    if (!ids.length) return;
    const newIds = [];
    ids.forEach((id)=>{
        const it = v2.items[id];
        if (!it) return;
        const k = $ea4c4e1e8991ffd6$var$nextKey(v2.items, id);
        v2.items[k] = {
            ...it,
            x: it.x + 40,
            y: it.y + 40,
            pageKey: it.pageKey
        };
        newIds.push(k);
    });
    // Re-render Items children + select the new ones.
    this.call('patchCanvas', {
        items: {
            ...v2.items
        }
    });
    this.call('selectMany', newIds);
    this.call('pushHistory');
    this.call('persistCanvasLayout');
}
function $ea4c4e1e8991ffd6$export$e9a518a637d1e641() {
    const v2 = this.call('getCanvasV2');
    if (!v2) return;
    const ids = v2.selection.ids;
    if (!ids.length) return;
    const items = {
        ...v2.items
    };
    ids.forEach((id)=>{
        delete items[id];
    });
    this.call('clearSelection');
    this.call('patchCanvas', {
        items: items
    });
    this.call('forgetItemRefs', ids);
    this.call('pushHistory');
    this.call('persistCanvasLayout');
}

});

parcelRegister("cQbHL", function(module, exports) {

$parcel$export(module.exports, "autoLayout", () => $95936bba77964bda$export$bbaa3df4f15e0faf);
// Cluster items by route prefix and tile into a clean grid. Each
// cluster (e.g. `/admin/*`) gets its own block; clusters lay out in
// rows of 4 cluster-columns. Items inside a cluster tile in 4 columns.
const $95936bba77964bda$var$ITEM_W = 1722;
const $95936bba77964bda$var$ITEM_GAP = 256;
const $95936bba77964bda$var$CLUSTER_GAP = 640;
const $95936bba77964bda$var$ITEMS_PER_ROW = 4;
function $95936bba77964bda$var$clusterKey(pageKey) {
    if (!pageKey) return '';
    // `/admin/users` → `/admin`; `/dashboard` → `/dashboard`; non-routes use `'_components'`.
    if (!pageKey.startsWith('/')) return '_components';
    const parts = pageKey.split('/').filter(Boolean);
    return parts.length > 1 ? '/' + parts[0] : pageKey;
}
function $95936bba77964bda$export$bbaa3df4f15e0faf() {
    const v2 = this.call('getCanvasV2');
    if (!v2) return;
    const entries = Object.entries(v2.items || {});
    if (!entries.length) return;
    // Bucket by cluster key, sorted alphabetically within each.
    const buckets = new Map();
    for (const [key, it] of entries){
        const ck = $95936bba77964bda$var$clusterKey(it.pageKey || key);
        if (!buckets.has(ck)) buckets.set(ck, []);
        buckets.get(ck).push([
            key,
            it
        ]);
    }
    for (const arr of buckets.values())arr.sort((a, b)=>a[0].localeCompare(b[0]));
    // Lay clusters out left-to-right; wrap to a new cluster-row when the
    // running width exceeds a sensible page width (~6 items wide).
    const clusterKeys = Array.from(buckets.keys()).sort();
    let cursorX = 0;
    let cursorY = 0;
    let rowMaxH = 0;
    const ROW_WRAP_X = 4 * ($95936bba77964bda$var$ITEM_W + $95936bba77964bda$var$ITEM_GAP) * 2 // ~8 items wide before wrap
    ;
    for (const ck of clusterKeys){
        const arr = buckets.get(ck);
        const cols = Math.min($95936bba77964bda$var$ITEMS_PER_ROW, arr.length);
        const rows = Math.ceil(arr.length / $95936bba77964bda$var$ITEMS_PER_ROW);
        const blockW = cols * $95936bba77964bda$var$ITEM_W + (cols - 1) * $95936bba77964bda$var$ITEM_GAP;
        const blockH = rows * $95936bba77964bda$var$ITEM_W + (rows - 1) * $95936bba77964bda$var$ITEM_GAP;
        if (cursorX > 0 && cursorX + blockW > ROW_WRAP_X) {
            cursorX = 0;
            cursorY += rowMaxH + $95936bba77964bda$var$CLUSTER_GAP;
            rowMaxH = 0;
        }
        arr.forEach(([key], i)=>{
            const col = i % $95936bba77964bda$var$ITEMS_PER_ROW;
            const row = Math.floor(i / $95936bba77964bda$var$ITEMS_PER_ROW);
            const it = v2.items[key];
            it.x = cursorX + col * ($95936bba77964bda$var$ITEM_W + $95936bba77964bda$var$ITEM_GAP);
            it.y = cursorY + row * ($95936bba77964bda$var$ITEM_W + $95936bba77964bda$var$ITEM_GAP);
            it.w = $95936bba77964bda$var$ITEM_W;
            it.h = $95936bba77964bda$var$ITEM_W;
            // Imperative DOM update for the item so the change is visible
            // without forcing a children re-render.
            const node = document.querySelector(`[data-canvas-item="${CSS.escape(key)}"]`);
            if (node) {
                node.style.left = it.x + 'px';
                node.style.top = it.y + 'px';
                node.style.width = it.w + 'px';
                node.style.height = it.h + 'px';
            }
        });
        cursorX += blockW + $95936bba77964bda$var$CLUSTER_GAP;
        if (blockH > rowMaxH) rowMaxH = blockH;
    }
    // Refresh chrome + persist + frame the result.
    this.call('refreshCanvasChrome');
    this.call('pushHistory');
    this.call('persistCanvasLayout');
    // Select all, fit to selection, then clear.
    const allKeys = Object.keys(v2.items);
    this.call('selectMany', allKeys);
    this.call('fitToSelection');
    this.call('clearSelection');
}

});

parcelRegister("8ZnIy", function(module, exports) {

$parcel$export(module.exports, "showContextMenu", () => $68b66b10e3ac1f41$export$565dd6bf3240914a);
$parcel$export(module.exports, "hideContextMenu", () => $68b66b10e3ac1f41$export$a70b79ee19e88cfe);
// Right-click context menu helpers. The menu element lives in
// CanvasOverlayV2 (`CvContextMenu`) and is repositioned imperatively.
function $68b66b10e3ac1f41$export$565dd6bf3240914a(ev, key) {
    const menu = this.getRoot?.()?.lookdown?.('CvContextMenu');
    if (!menu?.update) return;
    ev.preventDefault?.();
    ev.stopPropagation?.();
    // If clicked on an item, ensure that item is selected (single-select
    // unless it's already part of multi-select).
    if (key) {
        const v2 = this.call('getCanvasV2');
        if (v2 && !v2.selection.ids.includes(key)) this.call('selectOne', key);
    }
    menu.update({
        style: {
            display: 'block',
            left: ev.clientX + 'px',
            top: ev.clientY + 'px'
        }
    });
    // Auto-hide on next outside click.
    if (!menu.__cmDocListener) {
        menu.__cmDocListener = true;
        const close = (e)=>{
            if (menu.node?.contains?.(e.target)) return;
            this.call('hideContextMenu');
        };
        document.addEventListener('mousedown', close, {
            capture: true,
            once: true
        });
    }
}
function $68b66b10e3ac1f41$export$a70b79ee19e88cfe() {
    const menu = this.getRoot?.()?.lookdown?.('CvContextMenu');
    if (!menu?.update) return;
    menu.__cmDocListener = false;
    menu.update({
        style: {
            display: 'none'
        }
    });
}

});

parcelRegister("5wc4W", function(module, exports) {

$parcel$export(module.exports, "pushHistory", () => $40494f79a653d73f$export$afeb74aab3cee3ac);
$parcel$export(module.exports, "undo", () => $40494f79a653d73f$export$21f930c44940fd98);
$parcel$export(module.exports, "redo", () => $40494f79a653d73f$export$1688e416fee0a49e);
// Canvas v2 undo/redo. Snapshots the layout-relevant slice
// (items + guides + groups + selection) on every committed mutation.
// Transient drag state lives in pointer.js SESSION (not snapshotted).
const $40494f79a653d73f$var$STACK = {
    past: [],
    future: [],
    suspended: 0
};
const $40494f79a653d73f$var$MAX = 100;
function $40494f79a653d73f$var$snapshot(canvas) {
    return JSON.stringify({
        items: canvas.items,
        guides: canvas.guides,
        groups: canvas.groups,
        selection: canvas.selection
    });
}
function $40494f79a653d73f$var$restore(el, snap) {
    const v2 = el.call('getCanvasV2');
    if (!v2) return;
    const data = JSON.parse(snap);
    $40494f79a653d73f$var$STACK.suspended++;
    try {
        el.call('patchCanvas', {
            items: data.items,
            guides: data.guides,
            groups: data.groups,
            selection: data.selection
        });
        el.call('refreshCanvasChrome');
    } finally{
        $40494f79a653d73f$var$STACK.suspended--;
    }
}
function $40494f79a653d73f$export$afeb74aab3cee3ac() {
    if ($40494f79a653d73f$var$STACK.suspended) return;
    const v2 = this.call('getCanvasV2');
    if (!v2) return;
    const snap = $40494f79a653d73f$var$snapshot(v2);
    const top = $40494f79a653d73f$var$STACK.past[$40494f79a653d73f$var$STACK.past.length - 1];
    if (top === snap) return;
    $40494f79a653d73f$var$STACK.past.push(snap);
    if ($40494f79a653d73f$var$STACK.past.length > $40494f79a653d73f$var$MAX) $40494f79a653d73f$var$STACK.past.shift();
    $40494f79a653d73f$var$STACK.future.length = 0;
}
function $40494f79a653d73f$export$21f930c44940fd98() {
    if ($40494f79a653d73f$var$STACK.past.length < 2) return;
    const cur = $40494f79a653d73f$var$STACK.past.pop();
    $40494f79a653d73f$var$STACK.future.push(cur);
    $40494f79a653d73f$var$restore(this, $40494f79a653d73f$var$STACK.past[$40494f79a653d73f$var$STACK.past.length - 1]);
}
function $40494f79a653d73f$export$1688e416fee0a49e() {
    const next = $40494f79a653d73f$var$STACK.future.pop();
    if (!next) return;
    $40494f79a653d73f$var$STACK.past.push(next);
    $40494f79a653d73f$var$restore(this, next);
}

});

parcelRegister("7GIyE", function(module, exports) {

$parcel$export(module.exports, "ensureProjectLoaded", () => $598f04e4751504b8$export$b51decd890f3043a);
$parcel$export(module.exports, "reloadPage", () => $598f04e4751504b8$export$da22d4a5076a7905);
// SPA navigation helpers. Previously used to force a full reload when
// the URL pointed to a project but `root.data` didn't match — the
// reload re-ran the bootstrap in canvas/index.js. That shortcut made
// `workspace → project` feel like a refresh instead of an SPA jump.
// Now we fetch the project at runtime, rerun the same split + adapter
// pipeline, and swap `context.projectPages` + `root.data` in place.
parcelRequire("2oe0q");
var $bmfNh = parcelRequire("bmfNh");

var $8ANMJ = parcelRequire("8ANMJ");

var $9PrrW = parcelRequire("9PrrW");

var $gKMYv = parcelRequire("gKMYv");

var $90r0q = parcelRequire("90r0q");
let $598f04e4751504b8$var$_loadInFlight = null;
async function $598f04e4751504b8$export$b51decd890f3043a(el, s) {
    const { owner: owner, key: key } = (0, $8ANMJ.resolveProjectParams)();
    const root = s.root || s;
    const current = root?.data;
    const currentKey = current?.key || current?.projectKey;
    // URL has no project params — either a back-navigation to a known chrome
    // route (dashboard / workspace / etc.) or a dead unknown route.
    // Known chrome routes are handled by their own route entries in pages/index.js
    // so they never reach `main`. Any single-segment path that lands here is
    // an unknown route: show the 404 page instead of blank canvas chrome.
    if (!owner || !key) {
        const path = (typeof window !== 'undefined' ? window.location.pathname : '') || '';
        const segs = path.split('/').filter(Boolean);
        // A single unknown segment (e.g. /notFound, /foo) is a dead route.
        // Two or more segments without valid owner+key means the reserved-path
        // check fired — treat those as chrome (clear project state, no error).
        const isDeadRoute = segs.length === 1;
        if (isDeadRoute) root.update({
            data: null,
            projectNotFound: true,
            notFoundStatus: 404,
            notFoundTitle: 'Page not found',
            notFoundMessage: "The page you're looking for doesn't exist. It may have been moved or the URL may be incorrect."
        });
        else if (current && current.key) root.update({
            data: null,
            projectNotFound: null
        });
        return;
    }
    // Already loaded and matches URL: nothing to do. Clear any prior
    // not-found flag since a retry-by-reload equivalent would reset it.
    if (currentKey && currentKey === key) {
        if (root.projectNotFound) root.update({
            projectNotFound: null
        });
        return;
    }
    // Dedupe parallel onRender invocations — DOMQL can re-render before
    // the first fetch resolves.
    const tag = `${owner}/${key}`;
    if ($598f04e4751504b8$var$_loadInFlight === tag) return;
    $598f04e4751504b8$var$_loadInFlight = tag;
    try {
        const data = await (0, $9PrrW.getProjectData)({
            owner: owner,
            key: key
        });
        if ($598f04e4751504b8$var$_loadInFlight !== tag) return; // URL changed mid-flight
        if (!data) {
            root.update({
                data: null,
                projectNotFound: true,
                notFoundStatus: 404,
                notFoundTitle: `${owner}/${key} not found`,
                notFoundMessage: "We couldn't find this project. It may have been moved, deleted, or not yet synced."
            });
            return;
        }
        const project = (0, $gKMYv.attachDbAdapters)((0, $bmfNh.deepClone)(data, {
            window: window
        }));
        const { projectPages: projectPages } = (0, $90r0q.splitProjectForEditor)(project);
        // Mutate context.projectPages in place so downstream readers
        // (embed/Collection.js, functions/canvas/state.js) pick up the
        // new pages on their next read without needing a fresh context.
        if (el.context) el.context.projectPages = projectPages;
        root.update({
            data: project,
            projectNotFound: null,
            notFoundStatus: null,
            notFoundTitle: null,
            notFoundMessage: null
        });
    } catch (err) {
        console.warn('[ensureProjectLoaded] fetch failed:', err?.message || err);
        if ($598f04e4751504b8$var$_loadInFlight !== tag) return;
        root.update({
            data: null,
            projectNotFound: true,
            notFoundStatus: 503,
            notFoundTitle: `Couldn't open ${owner}/${key}`,
            notFoundMessage: err?.message || 'Failed to load project'
        });
    } finally{
        if ($598f04e4751504b8$var$_loadInFlight === tag) $598f04e4751504b8$var$_loadInFlight = null;
    }
}
function $598f04e4751504b8$export$da22d4a5076a7905() {
    if (typeof window !== 'undefined') window.location.reload();
}

});
parcelRegister("8ANMJ", function(module, exports) {

$parcel$export(module.exports, "resolveProjectParams", () => $64184dc7eb60d467$export$67df3ea6e237ebef);
// Single source of truth for "which project are we loading?" — used by
// every editor surface (canvas, preview, future embeds). Resolves in
// priority order:
//
//   1. Explicit URL params: `?owner=…&key=…[&env=…&branch=…&version=…]`
//   2. Preview-subdomain hostname: `{owner}--{key}.preview.symbols.app`
//      (or `…preview.localhost` for local dev)
//   3. Edit-domain pathname: `edit.symbols.app/{owner}/{key}/…`
//   4. Canvas-style pathname: `/{owner}/{key}/…` (excluding reserved
//      chrome routes like `/dashboard`, `/signin`, etc.)
//
// Each source is tried independently — the first non-empty value wins
// per field. Callers can pass their own `reservedPathSegments` set when
// their surface has different chrome routes from canvas; default covers
// the current canvas set.
const $64184dc7eb60d467$export$691784a43a42339d = new Set([
    'workspaces',
    'dashboard',
    'signin',
    'signup',
    'signup-confirmation',
    'reset-password',
    'waitlist'
]);
// Matches the preview-host shapes:
//   {owner}--{key}.preview.symbols.app           (prod)
//   {owner}--{key}.<tier>.preview.symbols.app    (tier — next/dev/staging/upcoming/...)
//   {owner}--{key}.preview.localhost             (local)
//   {owner}--{key}.<tier>.preview.localhost      (local tier — rare)
// The optional `<tier>.` segment lives between the project slug and the
// literal `preview.` apex, so each tier can serve its own preview surface
// without tier-specific URL rewriters.
const $64184dc7eb60d467$var$PREVIEW_SUBDOMAIN_RE = /^([^.]+)--([^.]+)(?:\.[a-z0-9-]+)?\.preview\.(symbols\.app|localhost)$/;
const $64184dc7eb60d467$var$EDIT_DOMAIN = 'edit.symbols.app';
function $64184dc7eb60d467$var$fromParams(params) {
    return {
        owner: params.get('owner') || null,
        key: params.get('key') || null,
        env: params.get('env') || null,
        branch: params.get('branch') || null,
        version: params.get('version') || null
    };
}
function $64184dc7eb60d467$var$fromHost(hostname) {
    const match = hostname.match($64184dc7eb60d467$var$PREVIEW_SUBDOMAIN_RE);
    if (match) return {
        owner: match[1],
        key: match[2]
    };
    return {};
}
function $64184dc7eb60d467$var$fromPath(hostname, pathname, reserved) {
    const segs = pathname.split('/').filter(Boolean);
    if (!segs.length) return {};
    // `edit.symbols.app` uses the first two path segments regardless of
    // reservation (it's a single-purpose host for the editor).
    if (hostname === $64184dc7eb60d467$var$EDIT_DOMAIN) {
        if (segs.length >= 2) return {
            owner: segs[0],
            key: segs[1]
        };
        return {};
    }
    // Canvas-style: first two segments unless the first is a reserved
    // chrome route (dashboard / signin / etc.).
    if (segs.length >= 2 && !reserved.has(segs[0])) return {
        owner: segs[0],
        key: segs[1]
    };
    return {};
}
function $64184dc7eb60d467$export$67df3ea6e237ebef({ loc: loc = typeof window !== 'undefined' ? window.location : null, reservedPathSegments: reservedPathSegments = $64184dc7eb60d467$export$691784a43a42339d } = {}) {
    if (!loc) return {
        owner: null,
        key: null,
        env: null,
        branch: null,
        version: null,
        sources: {}
    };
    const params = new URLSearchParams(loc.search);
    const p = $64184dc7eb60d467$var$fromParams(params);
    const h = $64184dc7eb60d467$var$fromHost(loc.hostname || '');
    const pa = $64184dc7eb60d467$var$fromPath(loc.hostname || '', loc.pathname || '', reservedPathSegments);
    return {
        owner: p.owner || h.owner || pa.owner || null,
        key: p.key || h.key || pa.key || null,
        env: p.env || null,
        branch: p.branch || null,
        version: p.version || null,
        sources: {
            params: p,
            host: h,
            path: pa
        }
    };
}

});

parcelRegister("9PrrW", function(module, exports) {

$parcel$export(module.exports, "getProjectData", () => $727e2b66d08e69dd$export$c0e4867bec971477);
$parcel$export(module.exports, "unlockProjectData", () => $727e2b66d08e69dd$export$5736b143a6fd0e95);

var $bfqVY = parcelRequire("bfqVY");

var $8ANMJ = parcelRequire("8ANMJ");
function $727e2b66d08e69dd$export$cadf04fe41567a91(err) {
    if (!err) return null;
    if (typeof err.status === 'number') return err.status;
    if (typeof err.statusCode === 'number') return err.statusCode;
    if (typeof err.response?.status === 'number') return err.response.status;
    if (typeof err.cause?.status === 'number') return err.cause.status;
    const msg = (err.message || '') + ' ' + (err.cause?.message || '');
    const match = msg.match(/\b([4-5]\d{2})\b/);
    return match ? parseInt(match[1], 10) : null;
}
const $727e2b66d08e69dd$var$TRUE_VALUES = new Set([
    'true',
    '1',
    'on',
    'yes'
]);
const $727e2b66d08e69dd$var$FALSE_VALUES = new Set([
    'false',
    '0',
    'off',
    'no'
]);
function $727e2b66d08e69dd$var$parseFlag(v) {
    if (v === true) return true;
    if (v === false) return false;
    if (v == null) return null;
    const lower = String(v).toLowerCase();
    if ($727e2b66d08e69dd$var$TRUE_VALUES.has(lower)) return true;
    if ($727e2b66d08e69dd$var$FALSE_VALUES.has(lower)) return false;
    return null;
}
const $727e2b66d08e69dd$var$SDK_TIMEOUT_MS = 3000;
const $727e2b66d08e69dd$var$withTimeout = (p, ms = $727e2b66d08e69dd$var$SDK_TIMEOUT_MS)=>{
    let id;
    return Promise.race([
        p,
        new Promise((r)=>{
            id = setTimeout(()=>r(null), ms);
        })
    ]).finally(()=>clearTimeout(id));
};
const $727e2b66d08e69dd$var$params = new URLSearchParams(window.location.search);
const $727e2b66d08e69dd$var$resolved = (0, $8ANMJ.resolveProjectParams)();
// Cheap synchronous check for "user has SDK tokens in localStorage on
// THIS origin" — used to decide whether to attempt an authed fallback
// for private projects after the public route 403s. No network call.
const $727e2b66d08e69dd$var$_hasSdkAccessToken = ()=>{
    try {
        return typeof window !== 'undefined' && !!window.localStorage.getItem('symbols_access_token');
    } catch  {
        return false;
    }
};
async function $727e2b66d08e69dd$export$c0e4867bec971477({ owner: owner = $727e2b66d08e69dd$var$resolved.owner, key: key = $727e2b66d08e69dd$var$resolved.key, branch: branch = $727e2b66d08e69dd$var$resolved.branch || 'main', useLocal: useLocal = $727e2b66d08e69dd$var$parseFlag($727e2b66d08e69dd$var$params.get('useLocal')) === true, useNext: useNext = $727e2b66d08e69dd$var$parseFlag($727e2b66d08e69dd$var$params.get('useNext')) !== false, env: env = $727e2b66d08e69dd$var$resolved.env } = {}) {
    if (!owner || !key) throw new Error('Provide both owner and key');
    const projectKey = `${owner}/${key}`;
    const sdkBase = {
        useLocal: useLocal,
        useNext: useNext
    };
    // `env` maps to one of the project's configured environments
    // (listEnvironments → each with its own mode/branch/version). When no env
    // config is found, fall back to treating the env name as a branch.
    let envOpts = {
        branch: branch,
        version: $727e2b66d08e69dd$var$resolved.version || 'latest'
    };
    if (env) {
        const resolved = await $727e2b66d08e69dd$var$withTimeout((0, $bfqVY.resolveEnvPublishConfig)(projectKey, env, sdkBase).catch(()=>null));
        envOpts = resolved || {
            branch: env,
            version: 'latest'
        };
    }
    // Preview domains serve CONSUMPTION (visibility-gated public snapshots) —
    // never the editor's authed data route. If the project isn't public the
    // loader surfaces that state rather than silently falling through to auth,
    // which would blur the orthogonality of access (editor authz) vs
    // visibility (preview serving).
    //
    // Matches production (`*.preview.symbols.app`) AND local dev
    // (`preview.localhost`, `*.preview.localhost`) so the `preview.` subdomain
    // convention stays consistent across environments.
    const host = window.location.hostname;
    const isPreviewHost = host.endsWith('.preview.symbols.app') || host === 'preview.localhost' || host.endsWith('.preview.localhost');
    if (isPreviewHost) {
        // Build a fallback chain so that if the explicitly-requested env (or the
        // default "production") isn't published, we try less-formal envs in order.
        // First non-null result wins and its env key is surfaced as `_resolvedEnv`
        // so the preview chrome can show "Showing development env" banner.
        const envOrder = env ? [
            ...new Set([
                env,
                'production',
                'staging',
                'development'
            ])
        ] : [
            'production',
            'staging',
            'development'
        ];
        let pub = null;
        let resolvedEnv = null;
        let passwordRequiredEnv = null;
        for (const tryEnv of envOrder)try {
            pub = await (0, $bfqVY.fetchPublicProjectFromSDK)(owner, key, {
                envKey: tryEnv,
                ...sdkBase
            });
            if (pub) {
                resolvedEnv = tryEnv;
                break;
            }
        } catch (e) {
            // Password-protected short-circuits the fallback chain — the
            // project IS published in this env, the caller just lacks the
            // password. Remember the first env that demanded one so the
            // unlock POST targets the right env config.
            if (e?.code === 'password_required') {
                passwordRequiredEnv = tryEnv;
                break;
            }
            throw e;
        }
        if (pub) {
            // Surface the resolved env so PreviewNavbar's env switcher shows the
            // correct active env and can display a fallback banner when the
            // originally-requested env differed from what was actually served.
            const requestedEnv = env || 'production';
            return {
                ...pub,
                _resolvedEnv: resolvedEnv,
                _requestedEnv: requestedEnv,
                _usedFallback: resolvedEnv !== requestedEnv
            };
        }
        // Probe visibility so the error path can route to the correct UI:
        //   public            → genuine "no env published" (legacy message)
        //   private           → cross-domain login redirect
        //   password-protected → password card (or already known from 401)
        let visibility = passwordRequiredEnv ? 'password-protected' : null;
        if (!visibility) visibility = await (0, $bfqVY.fetchPublicProjectVisibilityFromSDK)(owner, key, sdkBase);
        // Authed-fallback path for PRIVATE projects: when the user has just
        // returned from the cross-origin handoff (or already has SDK tokens
        // on the preview origin from a prior session), try the AUTHED data
        // route. If they're a member with read access, the preview renders
        // without round-tripping through the workspace shell again.
        if (visibility === 'private' && $727e2b66d08e69dd$var$_hasSdkAccessToken()) try {
            const authed = await (0, $bfqVY.fetchProjectFromSDK)(owner, key, {
                ...sdkBase,
                ...envOpts
            });
            if (authed) {
                const requestedEnv = env || 'production';
                return {
                    ...authed,
                    _resolvedEnv: env || envOpts.branch || 'main',
                    _requestedEnv: requestedEnv,
                    _usedFallback: false,
                    _authed: true
                };
            }
        } catch (e) {
        // Token present but no project access → still surface the
        // private-project error so the UI prompts to switch accounts.
        // Don't break the visibility-routing branch below.
        }
        const err = new Error(visibility === 'private' ? `Project "${projectKey}" is private` : visibility === 'password-protected' ? `Project "${projectKey}" is password-protected` : `Project "${projectKey}" has no public env (tried ${envOrder.join(', ')})`);
        err.code = visibility === 'private' ? 'project_private' : visibility === 'password-protected' ? 'project_password_protected' : 'project_not_public';
        err.visibility = visibility || 'public';
        err.triedEnvs = envOrder;
        err.owner = owner;
        err.key = key;
        err.passwordEnv = passwordRequiredEnv || envOrder[0];
        err.signedIn = $727e2b66d08e69dd$var$_hasSdkAccessToken();
        throw err;
    }
    const data = await (0, $bfqVY.fetchProjectFromSDK)(owner, key, {
        ...sdkBase,
        ...envOpts
    });
    if (data) return data;
    throw new Error(`No data returned for project "${projectKey}"`);
}
async function $727e2b66d08e69dd$export$5736b143a6fd0e95({ owner: owner = $727e2b66d08e69dd$var$resolved.owner, key: key = $727e2b66d08e69dd$var$resolved.key, envKey: envKey, password: password, useLocal: useLocal = $727e2b66d08e69dd$var$parseFlag($727e2b66d08e69dd$var$params.get('useLocal')) === true, useNext: useNext = $727e2b66d08e69dd$var$parseFlag($727e2b66d08e69dd$var$params.get('useNext')) !== false } = {}) {
    if (!owner || !key) throw new Error('Provide both owner and key');
    if (!envKey) throw new Error('envKey required');
    if (!password) throw new Error('password required');
    const data = await (0, $bfqVY.unlockPublicProjectFromSDK)(owner, key, {
        envKey: envKey,
        password: password,
        useLocal: useLocal,
        useNext: useNext
    });
    if (!data) return null;
    return {
        ...data,
        _resolvedEnv: envKey,
        _requestedEnv: envKey,
        _usedFallback: false,
        _unlocked: true
    };
}

});

parcelRegister("gKMYv", function(module, exports) {

$parcel$export(module.exports, "attachDbAdapters", () => $c326ee9fb35d45dd$export$8fb36661b90e648);

var $dNnfS = parcelRequire("dNnfS");
// Runtime adapter registry. The CLI push pipeline deliberately strips
// `createClient` before transport (it's a live function, not serializable),
// so every editor surface has to re-attach factories here at load time
// before handing `project` off to the fetch plugin.
//
// Extend this map when the project runtime grows a new data backend —
// adding an entry is the single change required; every editor surface
// picks it up automatically because they all call `attachDbAdapters`.
const $c326ee9fb35d45dd$var$ADAPTER_FACTORIES = Object.freeze({
    supabase: (0, $dNnfS.createClient)
});
function $c326ee9fb35d45dd$export$8fb36661b90e648(project) {
    if (!project) return project;
    $c326ee9fb35d45dd$var$attachOne(project.db);
    $c326ee9fb35d45dd$var$attachOne(project.fetch);
    return project;
}
function $c326ee9fb35d45dd$var$attachOne(cfg) {
    if (!cfg || cfg.__adapterAttached) return;
    const factory = $c326ee9fb35d45dd$var$ADAPTER_FACTORIES[cfg.adapter];
    // Incomplete configs (missing adapter or url) are left bare — the fetch
    // plugin's adapter resolver will surface the missing field.
    if (!factory || !cfg.url) return;
    cfg.createClient = factory;
    cfg.__adapterAttached = true;
}

});

parcelRegister("90r0q", function(module, exports) {

$parcel$export(module.exports, "splitProjectForEditor", () => $68e90feb732d3424$export$49e4924cb0ffbea4);
// Separates the app-level build/runtime flags (useReset, useVariable,
// globalTheme, ...) from the content-facing project context. Editor
// surfaces that render inside their OWN chrome (canvas, future embeds)
// must keep these flags out of the merged context — the chrome owns its
// own CSS reset / icon sprites / theme, and the project's values would
// override the chrome.
//
// For surfaces that mount the project as a standalone app (preview
// iframe, mermaid SSR), the flags stay with the project and this split
// isn't needed — createIframeApp + bundle.js apply them as-is.
//
// `pages` is split out separately because canvas routes project pages
// through its Collection grid (as thumbnails) rather than its own router.
function $68e90feb732d3424$export$49e4924cb0ffbea4(project) {
    if (!project || typeof project !== 'object') return {
        chromeFlags: {},
        projectContent: {},
        projectPages: {}
    };
    const { useReset: useReset, useVariable: useVariable, useFontImport: useFontImport, useIconSprite: useIconSprite, useSvgSprite: useSvgSprite, useDocumentTheme: useDocumentTheme, useDefaultIcons: useDefaultIcons, useDefaultConfig: useDefaultConfig, globalTheme: globalTheme, pages: pages, ...projectContent } = project;
    return {
        chromeFlags: {
            useReset: useReset,
            useVariable: useVariable,
            useFontImport: useFontImport,
            useIconSprite: useIconSprite,
            useSvgSprite: useSvgSprite,
            useDocumentTheme: useDocumentTheme,
            useDefaultIcons: useDefaultIcons,
            useDefaultConfig: useDefaultConfig,
            globalTheme: globalTheme
        },
        projectContent: projectContent,
        projectPages: pages || {}
    };
}

});


parcelRegister("aIuhw", function(module, exports) {

$parcel$export(module.exports, "saveMcpConnector", () => $7cd580ba3ef2ee88$export$9ca20373711d1316);
$parcel$export(module.exports, "reloadMcpConnectors", () => $7cd580ba3ef2ee88$export$67e623d9e5ef719b);
// MCP connector functions for the canvas workspace project registry.
//
// Registered via canvas/functions/index.js so MCPConnectorPickerOverlay can
// call them via el.call('saveMcpConnector', draft) and
// el.call('reloadMcpConnectors').
//
// DOMQL v3.14 call convention: method.call(element, ...args)
//   — `this` inside each function IS the calling element.
//   — Access root state via this.getRoot() (same as getRoot() in v3.14).
//   — No el.props.X — flat access only.
// ── Workspace ID helper ───────────────────────────────────────────────────────
// Derive the active workspace ID from the governance Supabase session's
// app_metadata claims. Returns null when not authenticated or claims absent.

async function $7cd580ba3ef2ee88$var$_getWorkspaceId() {
    try {
        const mod = await Promise.resolve((parcelRequire("8RlGv")));
        const client = mod.getClient?.();
        if (!client?.auth?.getSession) return null;
        const { data: data } = await client.auth.getSession();
        return data?.session?.user?.app_metadata?.active_workspace_id || null;
    } catch  {
        return null;
    }
}


async function $7cd580ba3ef2ee88$export$9ca20373711d1316(draft) {
    if (!draft?.url) throw new Error('URL required');
    const workspaceId = await $7cd580ba3ef2ee88$var$_getWorkspaceId();
    if (!workspaceId) throw new Error("Not authenticated \u2014 no active workspace");
    const scopeType = draft.scopeType || 'workspace';
    const scopeId = draft.scopeId || null;
    const name = draft.name || draft.url;
    const transport = draft.transport || 'sse';
    const authKind = draft.authKind || 'none';
    const authToken = draft.authToken;
    // installConnector lives in shared/mcp; the Supabase fallback insert
    // below goes through governanceBridge.getClient. Pull both in parallel.
    const [mcpMod, bridgeMod] = await Promise.all([
        Promise.resolve((parcelRequire("arUsX"))),
        Promise.resolve((parcelRequire("8RlGv")))
    ]);
    const mod = {
        ...bridgeMod,
        ...mcpMod
    };
    // Primary path: server-side install (Vault secret + capability discovery).
    if (typeof mod.installConnector === 'function') {
        const res = await mod.installConnector({
            workspaceId: workspaceId,
            scopeType: scopeType,
            scopeId: scopeId,
            name: name,
            url: draft.url,
            transport: transport,
            authKind: authKind,
            authToken: authToken
        });
        if (res?.ok) return;
        // Propagate hard auth errors immediately.
        if (res?.error && String(res.error).includes('not authenticated')) throw new Error(res.error);
        // 404 / "Cannot POST" → server route not yet deployed. Fall through to
        // direct Supabase insert so QA is unblocked.
        const looksLikeNotFound = String(res?.error || '').includes('404') || String(res?.error || '').includes('Cannot POST') || String(res?.error || '').includes('not found') || String(res?.error || '').includes('network error');
        if (!looksLikeNotFound) throw new Error(res?.error || 'installConnector failed');
    // Fall through to direct insert below.
    }
    // Fallback: direct Supabase insert (no Vault / no capability discovery).
    // Works for local dev and early QA where /core/mcp-connectors isn't deployed.
    //
    // TODO[sdk-mcp-route]: wire `getSDK().execute('mcp.connectors', 'create', ...)`
    // once a dedicated MCP entity route is added to EntityDispatcher.js. The
    // sdk-bridge `installConnector` path above already routes through
    // /core/mcp-connectors — once that endpoint is fully deployed across
    // every environment, the fallback can be removed entirely.
    const client = mod.getClient?.();
    if (!client) throw new Error('sdk-bridge governance client not configured');
    const { error: error } = await client.from('mcp_connectors').insert({
        workspace_id: workspaceId,
        scope_type: scopeType,
        scope_id: scopeId,
        name: name,
        url: draft.url,
        transport: transport,
        auth_kind: authKind,
        status: 'enabled',
        capabilities: {},
        metadata: {}
    });
    if (error) throw new Error(error.message);
}

async function $7cd580ba3ef2ee88$export$67e623d9e5ef719b() {
    try {
        const mod = await Promise.resolve((parcelRequire("arUsX")));
        if (typeof mod.listConnectors !== 'function') return;
        const { data: data, error: error } = await mod.listConnectors();
        if (error) {
            console.warn('[mcp] reloadMcpConnectors error:', error);
            return;
        }
        // `this` is the element that called el.call('reloadMcpConnectors').
        // Walk to root and update _mcpConnectors.
        const root = typeof this?.getRoot === 'function' ? this.getRoot() : null;
        if (root?.update) root.update({
            _mcpConnectors: data || []
        });
        else console.warn('[mcp] reloadMcpConnectors: could not resolve root element');
    } catch (err) {
        console.warn('[mcp] reloadMcpConnectors threw:', err?.message || err);
    }
}

});


parcelRegister("jZHKS", function(module, exports) {

$parcel$export(module.exports, "getCanvasScope", () => $e8e5a7aba985cb43$export$e41dec7c3fe21e0c);
$parcel$export(module.exports, "getCanvasPositions", () => $e8e5a7aba985cb43$export$6de35af35122548e);
$parcel$export(module.exports, "zoomToNode", () => $e8e5a7aba985cb43$export$886850766e7c8c8a);
$parcel$export(module.exports, "zoomIn", () => $e8e5a7aba985cb43$export$3b71758b3ed5255f);
$parcel$export(module.exports, "zoomOut", () => $e8e5a7aba985cb43$export$9fdb0a49c6b4b521);
$parcel$export(module.exports, "zoomReset", () => $e8e5a7aba985cb43$export$4caffb2cc31472b8);
$parcel$export(module.exports, "getZoomLevel", () => $e8e5a7aba985cb43$export$deb0f277a5f91a79);
$parcel$export(module.exports, "findBoxByRoute", () => $e8e5a7aba985cb43$export$dbd9a7c480819872);
$parcel$export(module.exports, "navigateCanvas", () => $e8e5a7aba985cb43$export$4a86703d82697c4d);
$parcel$export(module.exports, "activateHovered", () => $e8e5a7aba985cb43$export$df8deee90ac9730f);
$parcel$export(module.exports, "activateSelected", () => $e8e5a7aba985cb43$export$a59929d167d5c2f9);
$parcel$export(module.exports, "getSelected", () => $e8e5a7aba985cb43$export$f9f1f4119b3df74);
$parcel$export(module.exports, "getSelectedKey", () => $e8e5a7aba985cb43$export$38aa77eb6c41796a);
$parcel$export(module.exports, "getHoveredKey", () => $e8e5a7aba985cb43$export$42d819922815686c);
$parcel$export(module.exports, "isCanvasMode", () => $e8e5a7aba985cb43$export$e879ea454dfd6c45);
$parcel$export(module.exports, "setCanvasMode", () => $e8e5a7aba985cb43$export$844705008a2b92c9);
$parcel$export(module.exports, "openModal", () => $e8e5a7aba985cb43$export$a7f6cffb6b8ba11c);
$parcel$export(module.exports, "openKeyboardShortcuts", () => $e8e5a7aba985cb43$export$bcb7ebbe82ecdf67);
$parcel$export(module.exports, "setWindow", () => $e8e5a7aba985cb43$export$b4ab31529663b75b);
$parcel$export(module.exports, "openArtboardItem", () => $e8e5a7aba985cb43$export$3d3b80abf1b8cb0e);
$parcel$export(module.exports, "openItem", () => $e8e5a7aba985cb43$export$a7233d6c7db5231a);
$parcel$export(module.exports, "activateChosen", () => $e8e5a7aba985cb43$export$3baf42b730f3a265);
$parcel$export(module.exports, "activateFunction", () => $e8e5a7aba985cb43$export$39492a7fcc4c80a4);
$parcel$export(module.exports, "setSidebarContent", () => $e8e5a7aba985cb43$export$78d0518ff2f2c912);
$parcel$export(module.exports, "toggleTheme", () => $e8e5a7aba985cb43$export$f543642fc33c1018);
$parcel$export(module.exports, "setCookie", () => $e8e5a7aba985cb43$export$110700823644f4a6);
$parcel$export(module.exports, "syncCanvas", () => $e8e5a7aba985cb43$export$f16968e19f652651);
$parcel$export(module.exports, "getCanvasCollection", () => $e8e5a7aba985cb43$export$cf71fa492b882840);
$parcel$export(module.exports, "isReadOnly", () => $e8e5a7aba985cb43$export$2498094d90b6ac72);
$parcel$export(module.exports, "isEditMode", () => $e8e5a7aba985cb43$export$57957ca6633a6742);
$parcel$export(module.exports, "isEmbed", () => $e8e5a7aba985cb43$export$6a4806a2b2fc6ddd);
$parcel$export(module.exports, "isPlatform", () => $e8e5a7aba985cb43$export$1ecc6bcd755eeb80);
$parcel$export(module.exports, "getChosen", () => $e8e5a7aba985cb43$export$b51c8bb4f98e1ce);
$parcel$export(module.exports, "getChosenKey", () => $e8e5a7aba985cb43$export$9082a963fd1a7ffc);
$parcel$export(module.exports, "getInContextKey", () => $e8e5a7aba985cb43$export$e35504bd645ff8bf);
$parcel$export(module.exports, "activateContext", () => $e8e5a7aba985cb43$export$76345b94baed9730);
$parcel$export(module.exports, "openEditor", () => $e8e5a7aba985cb43$export$2b9f6e10153464f5);
$parcel$export(module.exports, "getRootState", () => $e8e5a7aba985cb43$export$c305c0c9c017efe7);
$parcel$export(module.exports, "getRootContext", () => $e8e5a7aba985cb43$export$f9271aefaf51c600);
// Reads top-window scope so the editor chrome and canvas iframe share
// the same source (DOMQL clones context.globalScope per create()).

var $6k38k = parcelRequire("6k38k");
function $e8e5a7aba985cb43$export$e41dec7c3fe21e0c(childKey) {
    const topWindow = (0, $6k38k.resolveTopWindow)();
    const scope = topWindow?.__canvasGlobalScope || this.context?.globalScope;
    return childKey ? scope?.[childKey] : scope;
}
function $e8e5a7aba985cb43$export$6de35af35122548e() {
    const scope = this.call('getCanvasScope');
    return scope?.positions || {
        x: 0,
        y: 0,
        scale: 0.35
    };
}
// Zoom methods. When the canvas v2 surface is active these branch off
// to the v2 viewport pipeline so the existing outer chrome (shared
// Zoombar, command bar, etc.) drives v2 transparently.
function $e8e5a7aba985cb43$var$v2ZoomAroundCenter(el, factor) {
    const v2 = el.call('getCanvasV2');
    if (!v2) return;
    const surf = el.getRoot?.()?.lookdown?.('CanvasSurface');
    const rect = surf?.node?.getBoundingClientRect();
    if (!rect) return;
    const cx = rect.width / 2;
    const cy = rect.height / 2;
    const sv = v2.viewport;
    const newScale = Math.max(0.035, Math.min(2.5, sv.scale * factor));
    const worldX = (cx - sv.x) / sv.scale;
    const worldY = (cy - sv.y) / sv.scale;
    el.call('applyViewport', {
        x: cx - worldX * newScale,
        y: cy - worldY * newScale,
        scale: newScale
    });
}
function $e8e5a7aba985cb43$export$886850766e7c8c8a(targetNode, opts = {}) {
    const scope = this.call('getCanvasScope');
    if (!scope?.panzoomInstance || !targetNode) return;
    const panzoom = scope.panzoomInstance;
    if (opts.useZoom) {
        const { x: x, y: y } = panzoom.getTransform();
        panzoom.zoomAbs(x, y, opts.zoom || 0.65);
    }
    setTimeout(()=>{
        const node = targetNode.node || targetNode;
        const { x: x, y: y, width: width, height: height } = node.getBoundingClientRect();
        const panToX = x - (window.innerWidth - width) / 2;
        const panToY = y - (window.innerHeight - height) / 2;
        panzoom.moveBy(-panToX, -panToY, true);
    }, 50);
}
function $e8e5a7aba985cb43$export$3b71758b3ed5255f() {
    if (this.call('isCanvasV2')) return $e8e5a7aba985cb43$var$v2ZoomAroundCenter(this, 1.25);
    const scope = this.call('getCanvasScope');
    if (!scope?.panzoomInstance) return;
    const { x: x, y: y } = scope.positions;
    scope.panzoomInstance.smoothZoom(x + window.innerWidth / 2, y + window.innerHeight / 2, 1.25);
}
function $e8e5a7aba985cb43$export$9fdb0a49c6b4b521() {
    if (this.call('isCanvasV2')) return $e8e5a7aba985cb43$var$v2ZoomAroundCenter(this, 0.8);
    const scope = this.call('getCanvasScope');
    if (!scope?.panzoomInstance) return;
    const { x: x, y: y } = scope.positions;
    scope.panzoomInstance.smoothZoom(x + window.innerWidth / 2, y + window.innerHeight / 2, 0.75);
}
function $e8e5a7aba985cb43$export$4caffb2cc31472b8() {
    if (this.call('isCanvasV2')) return this.call('resetCanvasView');
    const scope = this.call('getCanvasScope');
    if (!scope?.panzoomInstance) return;
    const { x: x, y: y } = scope.positions;
    scope.panzoomInstance.smoothZoomAbs(x + window.innerWidth / 2, y + window.innerHeight / 2, 1);
}
function $e8e5a7aba985cb43$export$deb0f277a5f91a79() {
    if (this.call('isCanvasV2')) return this.call('getCanvasV2')?.viewport?.scale || 0.35;
    const scope = this.call('getCanvasScope');
    return scope?.positions?.scale || 0.35;
}
function $e8e5a7aba985cb43$export$dbd9a7c480819872(route) {
    const root = this.__ref?.root || this;
    const collection = root?.CanvasScene?.Collection;
    if (!collection?.node) return null;
    const key = route === '/' ? '/' : '/' + route.split('/').filter(Boolean)[0];
    const children = collection.node.children;
    for(let i = 0; i < children.length; i++){
        if (children[i].ref?.scope?.key === key) return children[i].ref;
    }
    return null;
}
function $e8e5a7aba985cb43$export$4a86703d82697c4d(path) {
    const box = this.call('findBoxByRoute', path);
    if (box) this.call('zoomToNode', box);
}
function $e8e5a7aba985cb43$export$df8deee90ac9730f(key) {
    const scope = this.call('getCanvasScope');
    if (!scope) return;
    if (key === null) {
        scope.hovered = null;
        scope.hoveredKey = null;
    } else {
        scope.hovered = this;
        scope.hoveredKey = typeof key === 'string' ? key : this.state?.key;
    }
}
function $e8e5a7aba985cb43$export$a59929d167d5c2f9(key) {
    if (this.call('isCanvasV2')) {
        if (key === null) this.call('clearSelection');
        else this.call('selectOne', typeof key === 'string' ? key : this.state?.key);
        return;
    }
    const scope = this.call('getCanvasScope');
    if (!scope) return;
    if (key === null) {
        scope.selected = null;
        scope.selectedKey = null;
    } else {
        scope.selected = this;
        scope.selectedKey = typeof key === 'string' ? key : this.state?.key;
    }
}
function $e8e5a7aba985cb43$export$f9f1f4119b3df74() {
    if (this.call('isCanvasV2')) {
        const key = this.call('getCanvasV2')?.selection?.primary;
        if (!key) return null;
        const items = this.getRoot?.()?.lookdown?.('CvItems');
        if (!items) return null;
        for (const child of Object.values(items)){
            if (child?.state?.key === key) return child;
        }
        return null;
    }
    const scope = this.call('getCanvasScope');
    return scope?.selected;
}
function $e8e5a7aba985cb43$export$38aa77eb6c41796a() {
    if (this.call('isCanvasV2')) return this.call('getCanvasV2')?.selection?.primary || null;
    const scope = this.call('getCanvasScope');
    return scope?.selectedKey;
}
function $e8e5a7aba985cb43$export$42d819922815686c() {
    const scope = this.call('getCanvasScope');
    return scope?.hoveredKey;
}
// The shared chrome speaks the v1 mode names (inspectMode / panningMode
// / defaultMode). When v2 is active we map each to the v2 mode and also
// mirror the v1 flags on scope so any polling consumer stays in sync.
const $e8e5a7aba985cb43$var$V1_TO_V2 = {
    inspectMode: 'inspect',
    panningMode: 'pan',
    defaultMode: 'default',
    interactMode: 'interact'
};
function $e8e5a7aba985cb43$export$e879ea454dfd6c45(mode) {
    if (this.call('isCanvasV2')) {
        const target = $e8e5a7aba985cb43$var$V1_TO_V2[mode];
        if (!target) return false;
        return this.call('getCanvasV2')?.mode === target;
    }
    const scope = this.call('getCanvasScope');
    return scope?.[mode] || false;
}
function $e8e5a7aba985cb43$export$844705008a2b92c9(mode) {
    if (this.call('isCanvasV2')) {
        const target = $e8e5a7aba985cb43$var$V1_TO_V2[mode] || mode;
        this.call('setCanvasV2Mode', target);
        return;
    }
    const scope = this.call('getCanvasScope');
    if (!scope) return;
    scope.defaultMode = mode === 'defaultMode';
    scope.inspectMode = mode === 'inspectMode';
    scope.panningMode = mode === 'panningMode';
}
function $e8e5a7aba985cb43$export$a7f6cffb6b8ba11c(route) {
    if (this.call('isCanvasV2') && route === '/settings') {
        this.call('toggleCanvasSettings');
        return;
    }
}
function $e8e5a7aba985cb43$export$bcb7ebbe82ecdf67() {
    if (this.call('isCanvasV2')) this.call('toggleShortcutsOverlay');
}
function $e8e5a7aba985cb43$export$b4ab31529663b75b(window1, arg) {
    if (this.call('isCanvasV2')) {
        if (window1 === 'explorer' && arg && typeof arg === 'string') {
            // `arg` may be a page/component key or `'search:<query>'`.
            if (arg === 'onboarding') {
                this.call('toggleShortcutsOverlay');
                return;
            }
            if (arg.startsWith('search:')) return;
            this.call('selectOne', arg);
            this.call('fitToSelection');
            this.call('clearSelection');
        }
    }
}
function $e8e5a7aba985cb43$export$3d3b80abf1b8cb0e(type, key) {
    if (this.call('isCanvasV2') && key) {
        this.call('selectOne', key);
        this.call('fitToSelection');
    }
}
function $e8e5a7aba985cb43$export$a7233d6c7db5231a(type, key) {
    this.call('openArtboardItem', type, key);
}
function $e8e5a7aba985cb43$export$3baf42b730f3a265(key, type) {
    this.call('openArtboardItem', type, key);
}
function $e8e5a7aba985cb43$export$39492a7fcc4c80a4(_key) {}
function $e8e5a7aba985cb43$export$78d0518ff2f2c912(_kind) {
    if (this.call('isCanvasV2')) this.call('toggleCanvasSettings');
}
function $e8e5a7aba985cb43$export$f543642fc33c1018(target) {
    const doc = this.context?.document || document;
    const cur = doc.documentElement.getAttribute('data-theme') || 'dark';
    const next = target || (cur === 'dark' ? 'light' : 'dark');
    doc.documentElement.setAttribute('data-theme', next);
}
function $e8e5a7aba985cb43$export$110700823644f4a6(name, value) {
    try {
        document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; path=/; max-age=31536000`;
    } catch  {}
}
function $e8e5a7aba985cb43$export$f16968e19f652651() {
    // Trigger re-render of overlay by bumping a counter
    const scope = this.call('getCanvasScope');
    if (scope) scope._syncCounter = (scope._syncCounter || 0) + 1;
}
function $e8e5a7aba985cb43$export$cf71fa492b882840() {
    const root = this?.getRoot?.();
    const scene = root?.lookdown?.((el)=>el.key === 'CanvasScene');
    return scene?.Collection || scene;
}
function $e8e5a7aba985cb43$export$2498094d90b6ac72() {
    return false;
}
function $e8e5a7aba985cb43$export$57957ca6633a6742() {
    return false;
}
function $e8e5a7aba985cb43$export$6a4806a2b2fc6ddd() {
    return false;
}
function $e8e5a7aba985cb43$export$1ecc6bcd755eeb80() {
    return false;
}
function $e8e5a7aba985cb43$export$b51c8bb4f98e1ce() {
    return null;
}
function $e8e5a7aba985cb43$export$9082a963fd1a7ffc() {
    return null;
}
function $e8e5a7aba985cb43$export$e35504bd645ff8bf() {
    return null;
}
function $e8e5a7aba985cb43$export$76345b94baed9730() {}
function $e8e5a7aba985cb43$export$2b9f6e10153464f5() {}
function $e8e5a7aba985cb43$export$c305c0c9c017efe7(key) {
    const root = this?.state?.root;
    return key ? root?.[key] : root;
}
function $e8e5a7aba985cb43$export$f9271aefaf51c600(key) {
    const ctx = this?.context;
    return key ? ctx?.[key] : ctx;
}

});

parcelRegister("cEU2a", function(module, exports) {

var $bxMeP = parcelRequire("bxMeP");

var $j9WSE = parcelRequire("j9WSE");

var $f6MQQ = parcelRequire("f6MQQ");

var $1MVaW = parcelRequire("1MVaW");

var $100us = parcelRequire("100us");

var $6dNaP = parcelRequire("6dNaP");

var $Te4Rx = parcelRequire("Te4Rx");

var $Hhpts = parcelRequire("Hhpts");

var $EqTeH = parcelRequire("EqTeH");

var $iVz3O = parcelRequire("iVz3O");

var $4NYjs = parcelRequire("4NYjs");

var $9otbD = parcelRequire("9otbD");

var $a4sGk = parcelRequire("a4sGk");

var $bLoDH = parcelRequire("bLoDH");

var $5Of0N = parcelRequire("5Of0N");

var $3axkl = parcelRequire("3axkl");

var $gZ7FK = parcelRequire("gZ7FK");

var $gvTn1 = parcelRequire("gvTn1");

var $54WKS = parcelRequire("54WKS");

var $8cCSZ = parcelRequire("8cCSZ");

var $fn7Fn = parcelRequire("fn7Fn");

var $aBrDT = parcelRequire("aBrDT");

var $hpfWl = parcelRequire("hpfWl");

var $69pM8 = parcelRequire("69pM8");
$parcel$exportWildcard(module.exports, $bxMeP);
$parcel$exportWildcard(module.exports, $j9WSE);
$parcel$exportWildcard(module.exports, $f6MQQ);
$parcel$exportWildcard(module.exports, $1MVaW);
$parcel$exportWildcard(module.exports, $100us);
$parcel$exportWildcard(module.exports, $6dNaP);
$parcel$exportWildcard(module.exports, $Te4Rx);
$parcel$exportWildcard(module.exports, $Hhpts);
$parcel$exportWildcard(module.exports, $EqTeH);
$parcel$exportWildcard(module.exports, $iVz3O);
$parcel$exportWildcard(module.exports, $4NYjs);
$parcel$exportWildcard(module.exports, $9otbD);
$parcel$exportWildcard(module.exports, $a4sGk);
$parcel$exportWildcard(module.exports, $bLoDH);
$parcel$exportWildcard(module.exports, $5Of0N);
$parcel$exportWildcard(module.exports, $3axkl);
$parcel$exportWildcard(module.exports, $gZ7FK);
$parcel$exportWildcard(module.exports, $gvTn1);
$parcel$exportWildcard(module.exports, $54WKS);
$parcel$exportWildcard(module.exports, $8cCSZ);
$parcel$exportWildcard(module.exports, $fn7Fn);
$parcel$exportWildcard(module.exports, $aBrDT);
$parcel$exportWildcard(module.exports, $hpfWl);
$parcel$exportWildcard(module.exports, $69pM8);

});
parcelRegister("bxMeP", function(module, exports) {

$parcel$export(module.exports, "MarketplaceInstallConfigField", () => $867831e1284dae53$export$322c305f07beb9e);
$parcel$export(module.exports, "MarketplaceInstallCatalogError", () => $867831e1284dae53$export$a516a07bb949ae10);
$parcel$export(module.exports, "MarketplaceInstallScopeStep", () => $867831e1284dae53$export$29686b5965d79c5);
$parcel$export(module.exports, "MarketplaceInstallConfigStep", () => $867831e1284dae53$export$23944cfbd6ba6614);
$parcel$export(module.exports, "MarketplaceInstallModal", () => $867831e1284dae53$export$851b556ef3d420d2);
// Install modal for marketplace integration / registrar kinds.
//
// Triggered by clicking "Install" on any integration or registrar tile,
// or by `el.call('openInstallableModal', opts)` from any surface.
// Keeps the user on the current page (no full-page navigation) and
// walks through:
//
//   Step 1 — Scope selection (org / workspace / project). Auto-skips
//   steps when the user has a single org or the chosen org has a single
//   workspace. Project selection is always optional. Skipped entirely
//   when `defaultScope` is pre-filled by the caller.
//
//   Step 2 — Configuration form (integration-specific fields + API key).
//   Uses IntegrationScopePicker (shared) for scope and mirrors the
//   GenericIntNewForm field pattern for config fields.
//
// Phase 4 extensibility props (NEW):
//   preselectedKind   – string slug — opens modal pre-selected on this kind,
//                       skipping the browse step. Validated against live
//                       catalogue at mount; error shown when not found.
//   defaultScope      – { type: 'org'|'workspace'|'project', id: string } —
//                       pre-fills the scope picker, skipping manual selection.
//   catalogFilter     – { category?, applicable_to_types?, applicable_to_scopes? }
//                       — constrains which catalogue kinds the user can pick.
//                       If preselectedKind violates catalogFilter, error is shown.
//   onInstalled       – (instance) => void — callback fired after a successful
//                       install (optimistic). The instance is the raw API
//                       response body. Roll-back happens if the server later
//                       rejects.
//   domain            – 'integration'|'library'|'mcp'|'plugin'|'template' —
//                       used by domain-aware write target selection in
//                       `submitInstallModal`.
//
// State lives on the marketplace host (island or canvas page):
//   host.installModal: null | { item, step:'scope'|'config', draft:{},
//                               preselectedKind?, defaultScope?,
//                               catalogFilter?, onInstalled?, domain? }
//   host._installModalSaving: bool
//   host._installModalError: string | null
//
// The modal is gated by `host.installModal` (null → hidden). It uses the
// same `Modal` overlay pattern as the rest of the editor (Modal.js in
// shared/components): fixed inset, black.45 backdrop, Esc-closes.
//
// All functions are accessed via el.call('fnName', ...) per CLAUDE.md
// rule — no imports between project files.
// ── Scope wizard helpers ────────────────────────────────────────────────
// Resolve the org list. Marketplace mirrors _authClaims; governance
// exposes jwtClaims.orgs. Try both.
const $867831e1284dae53$var$_getOrgs = (host)=>{
    const claims = host?._authClaims || host?.root?._authClaims || {};
    const jwtOrgs = host?.root?.jwtClaims?.orgs || [];
    const metaOrg = claims.workspace_org_id ? [
        {
            id: claims.workspace_org_id,
            name: claims.workspace_org_id
        }
    ] : [];
    return jwtOrgs.length ? jwtOrgs : metaOrg;
};
// Resolve workspace list — same dual-source as IntegrationScopePicker.
const $867831e1284dae53$var$_getWorkspaces = (host)=>{
    const orgId = host?._authClaims?.workspace_org_id || host?.root?.jwtClaims?.workspace_org_id;
    const list = Array.isArray(host?.root?.workspaces) ? host.root.workspaces : host?.root?.jwtClaims?.workspaces || [];
    return orgId ? list.filter((w)=>!w.org_id || w.org_id === orgId) : list;
};
// Resolve project list — same dual-source as IntegrationScopePicker.
const $867831e1284dae53$var$_getProjects = (host)=>{
    const orgId = host?._authClaims?.workspace_org_id || host?.root?.jwtClaims?.workspace_org_id;
    if (Array.isArray(host?.root?.projects) && host.root.projects.length) return host.root.projects.map((p)=>({
            id: p.id || p._id || p.key,
            key: p.key || p.slug,
            name: p.name || p.displayName || p.key
        }));
    if (orgId) {
        const cache = (host?.root?._scopeProjectsByOrg || {})[orgId];
        if (Array.isArray(cache)) return cache;
    }
    return [];
};
const $867831e1284dae53$export$322c305f07beb9e = {
    flow: 'y',
    gap: 'V',
    FieldLabel: {
        tag: 'label',
        fontSize: 'Y2',
        color: 'caption',
        fontWeight: '700',
        text: (el, s)=>{
            const req = s.required ? ' *' : '';
            return (s.label || s.key || '') + req;
        }
    },
    FieldInput: {
        tag: 'input',
        type: (el, s)=>s.key && (s.key.includes('secret') || s.key.includes('key') || s.key.includes('token')) ? 'password' : 'text',
        width: '100%',
        padding: 'Z',
        borderRadius: 'Y',
        background: 'document',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'line',
        color: 'title',
        fontSize: 'Z2',
        placeholder: (el, s)=>s.placeholder || '',
        value: (el, s)=>{
            const host = el.call('marketplaceHostOf', el);
            return host?.installModal?.draft?.[s.key] || '';
        },
        onInput: (e, el, s)=>{
            const host = el.call('marketplaceHostOf', el);
            if (!host?.installModal) return;
            host.update?.({
                installModal: {
                    ...host.installModal,
                    draft: {
                        ...host.installModal.draft || {},
                        [s.key]: e.target.value
                    }
                }
            });
        }
    }
};
const $867831e1284dae53$export$a516a07bb949ae10 = {
    flow: 'y',
    gap: 'Z',
    padding: 'A',
    borderRadius: 'Z',
    background: 'red.1',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'red.3',
    hide: (el)=>{
        const host = el.call('marketplaceHostOf', el);
        return !host?.installModal?._catalogError;
    },
    ErrorIcon: {
        tag: 'span',
        fontSize: 'Z2',
        fontWeight: '700',
        color: 'red',
        text: '!'
    },
    ErrorText: {
        tag: 'p',
        fontSize: 'Y',
        color: 'red',
        margin: '0',
        text: (el)=>{
            const host = el.call('marketplaceHostOf', el);
            return host?.installModal?._catalogError || '';
        }
    }
};
const $867831e1284dae53$export$29686b5965d79c5 = {
    flow: 'y',
    gap: 'A',
    ScopeTitle: {
        tag: 'h4',
        text: 'Where should this integration be installed?',
        fontSize: 'Z',
        fontWeight: '600',
        color: 'title',
        margin: '0'
    },
    ScopeHint: {
        tag: 'p',
        fontSize: 'Y',
        color: 'caption',
        margin: '0',
        text: 'Choose the org, workspace, and optionally a project to scope this integration.'
    },
    // Org-missing guard: user has no org → block with message.
    NoOrgWarning: {
        flow: 'y',
        gap: 'Z',
        padding: 'A',
        borderRadius: 'Z',
        background: 'red.1',
        border: '1px solid red.3',
        hide: (el)=>{
            const host = el.call('marketplaceHostOf', el);
            const orgs = $867831e1284dae53$var$_getOrgs(host);
            return orgs.length > 0;
        },
        NoOrgText: {
            tag: 'p',
            fontSize: 'Y',
            color: 'red',
            margin: '0',
            text: 'You need an organisation before installing integrations. Create one in your account settings.'
        }
    },
    ScopeForm: {
        flow: 'y',
        gap: 'A',
        hide: (el)=>{
            const host = el.call('marketplaceHostOf', el);
            const orgs = $867831e1284dae53$var$_getOrgs(host);
            return orgs.length === 0;
        },
        // Scope mode buttons (org / workspace / project) — mirrors IntegrationScopePicker.Modes.
        ScopeModes: {
            flow: 'x',
            gap: 'Z',
            ScopeModeOrg: {
                extends: 'Button',
                text: 'Org',
                background: (el)=>{
                    const host = el.call('marketplaceHostOf', el);
                    const scopeType = host?.installModal?.draft?.scopeType || 'org';
                    return scopeType === 'org' ? 'blue' : 'transparent';
                },
                color: (el)=>{
                    const host = el.call('marketplaceHostOf', el);
                    const scopeType = host?.installModal?.draft?.scopeType || 'org';
                    return scopeType === 'org' ? 'white' : 'title';
                },
                borderColor: 'line',
                onClick: (e, el)=>{
                    const host = el.call('marketplaceHostOf', el);
                    if (!host?.installModal) return;
                    host.update?.({
                        installModal: {
                            ...host.installModal,
                            draft: {
                                ...host.installModal.draft || {},
                                scopeType: 'org',
                                scopeId: null
                            }
                        },
                        _scopeWsQuery: '',
                        _scopeProjQuery: ''
                    });
                }
            },
            ScopeModeWorkspace: {
                extends: 'Button',
                text: 'Workspace',
                background: (el)=>{
                    const host = el.call('marketplaceHostOf', el);
                    const scopeType = host?.installModal?.draft?.scopeType || 'org';
                    return scopeType === 'workspace' ? 'blue' : 'transparent';
                },
                color: (el)=>{
                    const host = el.call('marketplaceHostOf', el);
                    const scopeType = host?.installModal?.draft?.scopeType || 'org';
                    return scopeType === 'workspace' ? 'white' : 'title';
                },
                borderColor: 'line',
                onClick: (e, el)=>{
                    const host = el.call('marketplaceHostOf', el);
                    if (!host?.installModal) return;
                    host.update?.({
                        installModal: {
                            ...host.installModal,
                            draft: {
                                ...host.installModal.draft || {},
                                scopeType: 'workspace',
                                scopeId: (()=>{
                                    const ws = $867831e1284dae53$var$_getWorkspaces(host);
                                    return ws.length === 1 ? ws[0].id || ws[0].workspace_id || ws[0]._id : null;
                                })()
                            }
                        },
                        _scopeWsQuery: ''
                    });
                }
            },
            ScopeModeProject: {
                extends: 'Button',
                text: 'Project (optional)',
                background: (el)=>{
                    const host = el.call('marketplaceHostOf', el);
                    const scopeType = host?.installModal?.draft?.scopeType || 'org';
                    return scopeType === 'project' ? 'blue' : 'transparent';
                },
                color: (el)=>{
                    const host = el.call('marketplaceHostOf', el);
                    const scopeType = host?.installModal?.draft?.scopeType || 'org';
                    return scopeType === 'project' ? 'white' : 'title';
                },
                borderColor: 'line',
                onClick: (e, el)=>{
                    const host = el.call('marketplaceHostOf', el);
                    if (!host?.installModal) return;
                    host.update?.({
                        installModal: {
                            ...host.installModal,
                            draft: {
                                ...host.installModal.draft || {},
                                scopeType: 'project',
                                scopeId: null
                            }
                        },
                        _scopeProjQuery: ''
                    });
                }
            }
        },
        // Workspace picker — visible when scopeType === 'workspace'.
        WorkspacePicker: {
            flow: 'y',
            gap: 'Z',
            hide: (el)=>{
                const host = el.call('marketplaceHostOf', el);
                return (host?.installModal?.draft?.scopeType || 'org') !== 'workspace';
            },
            WorkspacePickerLabel: {
                tag: 'label',
                fontSize: 'Y2',
                color: 'caption',
                fontWeight: '600',
                text: 'Select workspace'
            },
            WorkspaceList: {
                flow: 'y',
                maxHeight: 'E',
                overflowY: 'auto',
                borderRadius: 'Y',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: 'line',
                background: 'document',
                childrenAs: 'state',
                childExtends: {
                    tag: 'button',
                    type: 'button',
                    display: 'grid',
                    gridTemplateColumns: '1fr auto',
                    gap: 'Z',
                    align: 'center left',
                    width: '100%',
                    padding: 'V Z1',
                    border: 'none',
                    background: (el, s)=>s._selected ? 'blue.1' : 'transparent',
                    color: (el, s)=>s._selected ? 'blue' : 'title',
                    cursor: 'pointer',
                    fontSize: 'Z2',
                    textAlign: 'left',
                    ':hover': {
                        background: 'overlayStrong'
                    },
                    WsLabel: {
                        tag: 'span',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        text: (el, s)=>s._label || ''
                    },
                    WsCheck: {
                        tag: 'span',
                        fontSize: 'Y1',
                        color: 'blue',
                        hide: (el, s)=>!s._selected,
                        text: "\u2713"
                    },
                    onClick: (e, el, s)=>{
                        const host = el.call('marketplaceHostOf', el);
                        if (!host?.installModal) return;
                        host.update?.({
                            installModal: {
                                ...host.installModal,
                                draft: {
                                    ...host.installModal.draft || {},
                                    scopeType: 'workspace',
                                    scopeId: s._value || null
                                }
                            }
                        });
                    }
                },
                children: (el)=>{
                    const host = el.call('marketplaceHostOf', el);
                    const curId = host?.installModal?.draft?.scopeId || '';
                    const ws = $867831e1284dae53$var$_getWorkspaces(host).map((w)=>({
                            id: w.id || w.workspace_id || w._id,
                            name: w.name || w.id || w.workspace_id
                        }));
                    if (!ws.length) return [];
                    return ws.map((w)=>({
                            _value: w.id,
                            _label: w.name,
                            _selected: w.id === curId
                        }));
                },
                WorkspaceEmpty: {
                    tag: 'span',
                    padding: 'V Z1',
                    fontSize: 'Z2',
                    color: 'caption',
                    fontStyle: 'italic',
                    hide: (el)=>{
                        const host = el.call('marketplaceHostOf', el);
                        return $867831e1284dae53$var$_getWorkspaces(host).length > 0;
                    },
                    text: 'No workspaces found in this org.'
                }
            }
        },
        // Project picker — visible when scopeType === 'project'.
        ProjectPicker: {
            flow: 'y',
            gap: 'Z',
            hide: (el)=>{
                const host = el.call('marketplaceHostOf', el);
                return (host?.installModal?.draft?.scopeType || 'org') !== 'project';
            },
            ProjectPickerLabel: {
                tag: 'label',
                fontSize: 'Y2',
                color: 'caption',
                fontWeight: '600',
                text: 'Select project (optional)'
            },
            ProjectList: {
                flow: 'y',
                maxHeight: 'E',
                overflowY: 'auto',
                borderRadius: 'Y',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: 'line',
                background: 'document',
                childrenAs: 'state',
                childExtends: {
                    tag: 'button',
                    type: 'button',
                    display: 'grid',
                    gridTemplateColumns: '1fr auto',
                    gap: 'Z',
                    align: 'center left',
                    width: '100%',
                    padding: 'V Z1',
                    border: 'none',
                    background: (el, s)=>s._selected ? 'blue.1' : 'transparent',
                    color: (el, s)=>s._selected ? 'blue' : 'title',
                    cursor: 'pointer',
                    fontSize: 'Z2',
                    textAlign: 'left',
                    ':hover': {
                        background: 'overlayStrong'
                    },
                    ProjLabel: {
                        tag: 'span',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        text: (el, s)=>s._label || ''
                    },
                    ProjCheck: {
                        tag: 'span',
                        fontSize: 'Y1',
                        color: 'blue',
                        hide: (el, s)=>!s._selected,
                        text: "\u2713"
                    },
                    onClick: (e, el, s)=>{
                        const host = el.call('marketplaceHostOf', el);
                        if (!host?.installModal) return;
                        const curId = host.installModal.draft?.scopeId || '';
                        // Clicking the already-selected project deselects (no project).
                        const nextId = s._value === curId ? null : s._value || null;
                        host.update?.({
                            installModal: {
                                ...host.installModal,
                                draft: {
                                    ...host.installModal.draft || {},
                                    scopeType: 'project',
                                    scopeId: nextId
                                }
                            }
                        });
                    }
                },
                children: (el)=>{
                    const host = el.call('marketplaceHostOf', el);
                    const curId = host?.installModal?.draft?.scopeId || '';
                    const projects = $867831e1284dae53$var$_getProjects(host);
                    if (!projects.length) return [];
                    return projects.map((p)=>({
                            _value: p.id || p.key,
                            _label: p.name || p.key || p.id,
                            _selected: (p.id || p.key) === curId
                        }));
                },
                ProjectEmpty: {
                    tag: 'span',
                    padding: 'V Z1',
                    fontSize: 'Z2',
                    color: 'caption',
                    fontStyle: 'italic',
                    hide: (el)=>{
                        const host = el.call('marketplaceHostOf', el);
                        return $867831e1284dae53$var$_getProjects(host).length > 0;
                    },
                    text: 'No projects found. You can install at workspace level.'
                }
            }
        }
    }
};
const $867831e1284dae53$export$23944cfbd6ba6614 = {
    flow: 'y',
    gap: 'A',
    ConfigTitle: {
        tag: 'h4',
        text: (el)=>{
            const host = el.call('marketplaceHostOf', el);
            const item = host?.installModal?.item;
            return `Configure ${item?.name || 'integration'}`;
        },
        fontSize: 'Z',
        fontWeight: '600',
        color: 'title',
        margin: '0'
    },
    // Display name field — only shown when allows_multiple.
    DisplayNameField: {
        flow: 'y',
        gap: 'V',
        hide: (el)=>{
            const host = el.call('marketplaceHostOf', el);
            const item = host?.installModal?.item;
            return !item?._liveKind?.allows_multiple;
        },
        DisplayNameLabel: {
            tag: 'label',
            fontSize: 'Y2',
            color: 'caption',
            fontWeight: '700',
            text: 'Display name'
        },
        DisplayNameInput: {
            tag: 'input',
            type: 'text',
            width: '100%',
            padding: 'Z',
            borderRadius: 'Y',
            background: 'document',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'line',
            color: 'title',
            fontSize: 'Z2',
            placeholder: (el)=>{
                const host = el.call('marketplaceHostOf', el);
                return host?.installModal?.item?._liveKind?.label || 'My integration';
            },
            value: (el)=>{
                const host = el.call('marketplaceHostOf', el);
                return host?.installModal?.draft?.displayName || '';
            },
            onInput: (e, el)=>{
                const host = el.call('marketplaceHostOf', el);
                if (!host?.installModal) return;
                host.update?.({
                    installModal: {
                        ...host.installModal,
                        draft: {
                            ...host.installModal.draft || {},
                            displayName: e.target.value
                        }
                    }
                });
            }
        }
    },
    // Dynamic config fields from config_schema.fields.
    DynamicConfigFields: {
        flow: 'y',
        gap: 'A',
        hide: (el)=>{
            const host = el.call('marketplaceHostOf', el);
            const item = host?.installModal?.item;
            const fields = (item?._liveKind?.config_schema?.fields || []).filter((f)=>f.key !== 'display_name');
            return fields.length === 0;
        },
        childrenAs: 'state',
        childExtends: 'MarketplaceInstallConfigField',
        children: (el)=>{
            const host = el.call('marketplaceHostOf', el);
            const item = host?.installModal?.item;
            return (item?._liveKind?.config_schema?.fields || []).filter((f)=>f.key !== 'display_name');
        }
    },
    // API key / secret field — hidden for oauth2 / webhook / none auth models.
    SecretField: {
        flow: 'y',
        gap: 'V',
        hide: (el)=>{
            const host = el.call('marketplaceHostOf', el);
            const item = host?.installModal?.item;
            const kr = item?._liveKind;
            if (!kr || kr.auth_model === 'none') return true;
            const flow = kr.ui_flow || 'credential';
            return flow === 'oauth2' || flow === 'webhook';
        },
        SecretLabel: {
            tag: 'label',
            fontSize: 'Y2',
            color: 'caption',
            fontWeight: '700',
            text: (el)=>{
                const host = el.call('marketplaceHostOf', el);
                const item = host?.installModal?.item;
                return item?._liveKind?.secret_label || 'API key / Secret';
            }
        },
        SecretHint: {
            tag: 'p',
            fontSize: 'Y1',
            color: 'caption',
            margin: '0 0 V 0',
            hide: (el)=>{
                const host = el.call('marketplaceHostOf', el);
                const item = host?.installModal?.item;
                return !item?._liveKind?.secret_hint;
            },
            text: (el)=>{
                const host = el.call('marketplaceHostOf', el);
                const item = host?.installModal?.item;
                return item?._liveKind?.secret_hint || '';
            }
        },
        SecretInput: {
            tag: 'input',
            type: 'password',
            width: '100%',
            padding: 'Z',
            borderRadius: 'Y',
            background: 'document',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'line',
            color: 'title',
            fontSize: 'Z2',
            placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022",
            value: (el)=>{
                const host = el.call('marketplaceHostOf', el);
                return host?.installModal?.draft?.secret || '';
            },
            onInput: (e, el)=>{
                const host = el.call('marketplaceHostOf', el);
                if (!host?.installModal) return;
                host.update?.({
                    installModal: {
                        ...host.installModal,
                        draft: {
                            ...host.installModal.draft || {},
                            secret: e.target.value
                        }
                    }
                });
            }
        }
    },
    // No-config notice for integrations that need no configuration.
    NoConfigNotice: {
        tag: 'p',
        fontSize: 'Y',
        color: 'caption',
        margin: '0',
        fontStyle: 'italic',
        hide: (el)=>{
            const host = el.call('marketplaceHostOf', el);
            const item = host?.installModal?.item;
            const kr = item?._liveKind;
            if (!kr) return false;
            const fields = (kr.config_schema?.fields || []).filter((f)=>f.key !== 'display_name');
            const authModel = kr.auth_model || 'none';
            const flow = kr.ui_flow || 'credential';
            const needsSecret = authModel !== 'none' && flow !== 'oauth2' && flow !== 'webhook';
            return fields.length > 0 || needsSecret;
        },
        text: 'No configuration required. Click Install to complete the setup.'
    }
};
const $867831e1284dae53$export$851b556ef3d420d2 = {
    // Visibility gated on host.installModal — follows the Modal.js pattern
    // (stateKey drives display) but reads from the marketplace host state
    // directly since the marketplace host may be a sub-state (island),
    // not root.
    display: (el)=>{
        const host = el.call('marketplaceHostOf', el);
        return host?.installModal ? 'flex' : 'none';
    },
    position: 'fixed',
    inset: '0',
    zIndex: '2000',
    align: 'center center',
    background: 'black.45',
    backdropFilter: 'blur(4px)',
    padding: 'A',
    // Esc closes the modal via the global keydown listener registered
    // in registerEscHandler. For additional safety we also handle it here
    // in case the listener context doesn't reach.
    onKeydown: (e, el)=>{
        if (e.key !== 'Escape') return;
        const host = el.call('marketplaceHostOf', el);
        el.call('closeInstallModal', host);
        e.preventDefault();
    },
    // Click on backdrop (not window) closes without saving.
    onClick: (e, el)=>{
        if (e.target !== el.node) return;
        const host = el.call('marketplaceHostOf', el);
        el.call('closeInstallModal', host);
    },
    ModalWindow: {
        theme: 'modal',
        flow: 'y',
        gap: 'A',
        padding: 'B',
        borderRadius: 'A',
        minWidth: 'G',
        maxWidth: 'J',
        width: '100%',
        maxHeight: '90vh',
        overflowY: 'auto',
        background: 'dialog',
        boxShadow: '0 8px 48px black.3',
        // Tab-trapping for a11y — focus stays inside the modal.
        tabindex: '-1',
        // Header: integration logo + name + close button.
        ModalTop: {
            flow: 'x',
            align: 'center space-between',
            gap: 'A',
            ModalTitleRow: {
                flow: 'x',
                align: 'center',
                gap: 'Z',
                ModalIcon: {
                    align: 'center center',
                    width: 'C',
                    height: 'C',
                    minWidth: 'C',
                    borderRadius: 'Y',
                    overflow: 'hidden',
                    fontWeight: '700',
                    fontSize: 'B',
                    background: (el)=>{
                        const host = el.call('marketplaceHostOf', el);
                        const item = host?.installModal?.item;
                        return item?.logo ? 'white' : el.call('getKindAccent', item?.kind, 'bg');
                    },
                    color: (el)=>{
                        const host = el.call('marketplaceHostOf', el);
                        const item = host?.installModal?.item;
                        return el.call('getKindAccent', item?.kind, 'fg');
                    },
                    ModalIconImg: {
                        hide: (el)=>{
                            const host = el.call('marketplaceHostOf', el);
                            const item = host?.installModal?.item;
                            return !item?.logo || el.parent._imgFailed;
                        },
                        tag: 'img',
                        src: (el)=>{
                            const host = el.call('marketplaceHostOf', el);
                            const slug = host?.installModal?.item?.logo;
                            return slug ? `https://cdn.simpleicons.org/${slug}` : '';
                        },
                        alt: (el)=>{
                            const host = el.call('marketplaceHostOf', el);
                            return host?.installModal?.item?.name || '';
                        },
                        width: '60%',
                        height: '60%',
                        objectFit: 'contain',
                        onRender: (el)=>{
                            if (!el.node) return;
                            el.node.onerror = ()=>{
                                el.parent._imgFailed = true;
                                el.node.style.display = 'none';
                                const letter = el.parent.ModalIconLetter;
                                if (letter?.node) letter.node.style.display = '';
                            };
                        }
                    },
                    ModalIconLetter: {
                        hide: (el)=>{
                            const host = el.call('marketplaceHostOf', el);
                            const item = host?.installModal?.item;
                            return !!item?.logo && !el.parent._imgFailed;
                        },
                        tag: 'span',
                        text: (el)=>{
                            const host = el.call('marketplaceHostOf', el);
                            const name = host?.installModal?.item?.name || '';
                            return name[0]?.toUpperCase() || '?';
                        }
                    }
                },
                ModalTitle: {
                    flow: 'y',
                    gap: 'V',
                    ModalName: {
                        tag: 'h3',
                        text: (el)=>{
                            const host = el.call('marketplaceHostOf', el);
                            return `Install ${host?.installModal?.item?.name || ''}`;
                        },
                        fontSize: 'B',
                        fontWeight: '700',
                        color: 'title',
                        margin: '0'
                    },
                    ModalStepLabel: {
                        tag: 'span',
                        fontSize: 'Y',
                        color: 'caption',
                        text: (el)=>{
                            const host = el.call('marketplaceHostOf', el);
                            const modal = host?.installModal;
                            const step = modal?.step || 'scope';
                            // When defaultScope is pre-filled, we skip scope step — show single-step label
                            if (modal?.defaultScope && step === 'config') return 'Configure';
                            if (modal?._catalogError) return 'Catalog error';
                            return step === 'scope' ? 'Step 1 of 2: Select scope' : 'Step 2 of 2: Configure';
                        }
                    }
                }
            },
            ModalCloseBtn: {
                extends: 'Button',
                text: "\u2715",
                ariaLabel: 'Close install modal',
                flexShrink: '0',
                onClick: (e, el)=>{
                    const host = el.call('marketplaceHostOf', el);
                    el.call('closeInstallModal', host);
                }
            }
        },
        // Divider.
        ModalDivider: {
            borderTop: '1px solid line',
            margin: '0 -B'
        },
        // Step body — swaps between scope and config.
        ModalBody: {
            flow: 'y',
            gap: 'A',
            flex: '1',
            // Catalog validation error — shown when preselectedKind doesn't exist
            // in catalogue or violates catalogFilter. Replaces both steps.
            MarketplaceInstallCatalogError: {},
            // Step 1: scope selection. Hidden when defaultScope is pre-filled
            // (openInstallableModal pre-validates the scope) or catalog error exists.
            MarketplaceInstallScopeStep: {
                hide: (el)=>{
                    const host = el.call('marketplaceHostOf', el);
                    const modal = host?.installModal;
                    if (!modal || modal._catalogError) return true;
                    if (modal.defaultScope) return true // scope step skipped when pre-filled
                    ;
                    return modal.step !== 'scope';
                }
            },
            // Step 2: configuration form.
            MarketplaceInstallConfigStep: {
                hide: (el)=>{
                    const host = el.call('marketplaceHostOf', el);
                    const modal = host?.installModal;
                    if (!modal || modal._catalogError) return true;
                    // When defaultScope pre-fills scope, skip directly to config
                    if (modal.defaultScope) return modal.step !== 'config';
                    return modal.step !== 'config';
                }
            },
            // Error display — shown on any step when an error exists.
            ModalError: {
                tag: 'p',
                padding: 'Y A',
                borderRadius: 'Y',
                background: 'red.1',
                border: '1px solid red.3',
                fontSize: 'Y',
                color: 'red',
                margin: '0',
                hide: (el)=>{
                    const host = el.call('marketplaceHostOf', el);
                    return !host?._installModalError;
                },
                text: (el)=>{
                    const host = el.call('marketplaceHostOf', el);
                    return host?._installModalError || '';
                }
            }
        },
        // Footer with navigation / action buttons.
        ModalFooter: {
            flow: 'x',
            align: 'center flex-end',
            gap: 'Z',
            borderTop: '1px solid line',
            margin: '0 -B -B',
            padding: 'A B',
            // Cancel button — always visible.
            CancelBtn: {
                extends: 'Button',
                text: 'Cancel',
                onClick: (e, el)=>{
                    const host = el.call('marketplaceHostOf', el);
                    el.call('closeInstallModal', host);
                }
            },
            // Back button — config step only; hidden when defaultScope pre-fills
            // scope (nowhere to go back to) or when catalog error is shown.
            BackBtn: {
                extends: 'Button',
                text: "\u2190 Back",
                hide: (el)=>{
                    const host = el.call('marketplaceHostOf', el);
                    const modal = host?.installModal;
                    if (!modal || modal._catalogError) return true;
                    if (modal.defaultScope) return true // no scope step to go back to
                    ;
                    return modal.step !== 'config';
                },
                onClick: (e, el)=>{
                    const host = el.call('marketplaceHostOf', el);
                    if (!host?.installModal) return;
                    host.update?.({
                        installModal: {
                            ...host.installModal,
                            step: 'scope'
                        },
                        _installModalError: null
                    });
                }
            },
            // Next button — scope step → config step. Hidden when defaultScope
            // is pre-filled (modal opens directly on config step) or catalog error shown.
            NextBtn: {
                extends: 'Button',
                theme: 'primary',
                text: "Next: Configure \u2192",
                hide: (el)=>{
                    const host = el.call('marketplaceHostOf', el);
                    const modal = host?.installModal;
                    if (!modal || modal._catalogError) return true;
                    if (modal.defaultScope) return true // scope step is skipped entirely
                    ;
                    if (modal.step !== 'scope') return true;
                    // Hide if org list is empty (blocked).
                    const orgs = $867831e1284dae53$var$_getOrgs(host);
                    return orgs.length === 0;
                },
                onClick: (e, el)=>{
                    const host = el.call('marketplaceHostOf', el);
                    if (!host?.installModal) return;
                    host.update?.({
                        installModal: {
                            ...host.installModal,
                            step: 'config'
                        },
                        _installModalError: null
                    });
                }
            },
            // Install button — config step only; submits the form.
            // When defaultScope is pre-filled we open directly to config, so
            // this button is visible from the moment the modal opens.
            InstallBtn: {
                extends: 'Button',
                theme: 'primary',
                text: (el)=>{
                    const host = el.call('marketplaceHostOf', el);
                    return host?._installModalSaving ? "Installing\u2026" : 'Install';
                },
                disabled: (el)=>{
                    const host = el.call('marketplaceHostOf', el);
                    return !!host?._installModalSaving;
                },
                hide: (el)=>{
                    const host = el.call('marketplaceHostOf', el);
                    const modal = host?.installModal;
                    if (!modal || modal._catalogError) return true;
                    if (modal.defaultScope) return modal.step !== 'config';
                    return modal.step !== 'config';
                },
                onClick: async (e, el)=>{
                    const host = el.call('marketplaceHostOf', el);
                    await el.call('submitInstallModal', host, el);
                }
            }
        }
    }
};

});

parcelRegister("j9WSE", function(module, exports) {

$parcel$export(module.exports, "MarketplaceIsland", () => $df2c880354ec775c$export$554b623e53c3e9df);
// MarketplaceIsland — self-contained, embeddable marketplace surface.
//
// Standalone marketplace (marketplace.localhost) mounts the pieces at
// the app root directly; there, `marketplaceHostOf(el)` finds the root
// (flagged `_marketplaceHost: true` on the app state) and reads
// `catalog` / `selectedItem` / `installed` from there.
//
// Other surfaces (canvas.localhost/marketplace, landing `/apps/...`)
// import this island and mount it anywhere. The island owns the
// catalog state locally so two embeds on the same page don't share
// `selectedItem`. The helper walks `el.parent` until it finds this
// island (flagged) — that becomes the host for all state reads/writes.
parcelRequire("8eaF7");
var $cNJPN = parcelRequire("cNJPN");
const $df2c880354ec775c$export$554b623e53c3e9df = {
    // `flow: 'y'` already emits `display: flex` (see css-in-props/flex.js)
    // so `extends: 'Flex'` would be redundant.
    flow: 'y',
    flex: '1',
    width: '100%',
    overflow: 'hidden',
    // Toast floats via `position: absolute` relative to the Island, so
    // the Island must establish a positioning context.
    position: 'relative',
    // Marker: marketplaceHostOf(el) looks for this flag walking up the
    // parent chain; first match wins.
    _marketplaceHost: true,
    // Bind the global Esc-to-close-detail listener. Idempotent — only
    // the first mount attaches the document listener; later mounts just
    // update `_lastMarketplaceHost` so Escape targets the latest host.
    // Also applies deep-linked URL filters + registers a popstate
    // listener so back/forward navigation re-applies URL state on
    // landing + standalone surfaces. (Canvas page uses its own
    // `root.currentSearch` reader instead and doesn't need these.)
    onCreate: (el)=>{
        el.call('registerEscHandler', el.state);
        el.call('hydrateFiltersFromLocation', el.state);
        el.call('bindPopstateFilters', el.state);
    },
    // Sync host filter state back to the address bar on every change.
    // `writeFiltersToUrl` diff-gates so no replaceState fires when the
    // composed URL already matches — preventing the onUpdate → URL →
    // popstate → onUpdate loop. Canvas page has the equivalent already.
    onUpdate: (el)=>{
        el.call('writeFiltersToUrl', el.state);
    },
    state: {
        // Multi-select: empty array === match every category. Clicking a
        // chip toggles membership; clicking `all` empties the array. See
        // `toggleCategory` in functions/index.js.
        activeCategories: [],
        activeKind: 'all',
        activePricing: 'all',
        activeSort: 'name',
        // 'comfortable' | 'compact' — hydrated from localStorage on mount.
        gridDensity: 'comfortable',
        query: '',
        selectedItem: null,
        // Stack of prior selectedItems for Back-button navigation when the
        // user clicks through "Similar items" rows. Cleared on Close (✕)
        // or grid-card click (a fresh journey). See `selectItemWithHistory`
        // helper in functions/index.js.
        selectedHistory: [],
        sidebarMode: false,
        installing: null,
        installed: [],
        // User-curated favorites — hydrated from localStorage on Grid mount.
        pinnedIds: [],
        // Recently-viewed item ids — capped at RECENT_LIMIT in
        // `trackRecent`; hydrated from localStorage on Grid mount.
        recentIds: [],
        // Transient toast — populated by `flashToast`, cleared after 4s.
        toastMessage: null,
        toastUndoItemId: null,
        // Toggled by `?` key via the global keydown listener; cleared by
        // Esc or by clicking the overlay backdrop.
        shortcutsOpen: false,
        catalog: $cNJPN.default,
        // Install modal state — null when closed, { item, step, draft,
        //   preselectedKind?, defaultScope?, catalogFilter?, onInstalled?,
        //   domain?, _catalogError? } when open.
        installModal: null,
        _installModalSaving: false,
        _installModalError: null
    },
    // Composable chrome — consumers can override `showSidebar` /
    // `showFilters` / `showNavbar` via props to slim down the embed.
    MarketplaceNavbar: {
        hide: (el)=>el.parent?.showNavbar === false
    },
    MarketplaceBody: {
        flow: 'x',
        flex: '1',
        overflow: 'hidden',
        minHeight: '0',
        MarketplaceSidebar: {
            hide: (el)=>el.parent?.parent?.showSidebar === false
        },
        MarketplaceContent: {
            flow: 'y',
            flex: '1',
            overflow: 'hidden',
            MarketplaceFilters: {
                hide: (el)=>el.parent?.parent?.parent?.showFilters === false
            },
            // Thin summary between filter chips and the grid. Same hide
            // gate as filters — embeds that opted out of filters also get
            // a cleaner layout.
            MarketplaceResultsBar: {
                hide: (el)=>el.parent?.parent?.parent?.showFilters === false
            },
            MarketplaceGrid: {
                flex: '1',
                overflow: 'y auto'
            }
        },
        MarketplaceDetail: {}
    },
    // Transient feedback (install confirmation, Undo). Absolute-positioned
    // via `MarketplaceToast` so it overlays the body without reflowing it.
    MarketplaceToast: {},
    // Help overlay for keyboard shortcuts, toggled via `?` key.
    MarketplaceShortcutsOverlay: {},
    // Install modal — fixed overlay, gated on host.installModal. Sits at
    // the island level so it correctly uses `marketplaceHostOf` and stays
    // anchored to the island's state (not canvas root state).
    MarketplaceInstallModal: {}
};

});
parcelRegister("8eaF7", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("cNJPN")).default);
// Marketplace seed catalog moved to shared/data/marketplaceCatalog.js so
// canvas's /marketplace preview surface and the marketplace sub-app
// import from one source instead of cross-importing each other (Phase 10
// no-restricted-imports). This file remains as a re-export shim — drop
// it once consumers are migrated to import directly from shared/.

var $cNJPN = parcelRequire("cNJPN");

});


parcelRegister("f6MQQ", function(module, exports) {

$parcel$export(module.exports, "MarketplaceNavbar", () => $affd4f6c7b22d373$export$150c04f340f4d5ca);
const $affd4f6c7b22d373$export$150c04f340f4d5ca = {
    flow: 'x',
    align: 'center space-between',
    padding: 'Y A',
    borderBottom: '1px solid line',
    gap: 'A',
    MarketplaceTitle: {
        tag: 'h2',
        text: 'Marketplace',
        fontSize: 'B',
        fontWeight: '700',
        color: 'title'
    },
    // Search input wrapped so the Clear (×) button can overlay the
    // right edge. `position: relative` on the wrap anchors the absolute
    // button; `flex: 1` + `maxWidth: 'H'` move from the input up to the
    // wrap so layout stays identical.
    SearchWrap: {
        flex: '1',
        maxWidth: 'H',
        position: 'relative',
        SearchInput: {
            extends: 'Input',
            width: '100%',
            placeholder: "Search libraries, templates, integrations\u2026",
            value: (el, s)=>s.query,
            onInput: (e, el, s)=>s.update({
                    query: e.target.value
                }),
            // Reserve room on the right for the × button so text doesn't
            // collide with it when filled.
            paddingRight: 'B',
            // Marker for the global `/` and Cmd/Ctrl+K shortcuts (see
            // `registerEscHandler` in functions/index.js). `attr: {}` is the
            // right wrapper here — `data-*` is not surfaced as a first-class
            // DOMQL prop.
            attr: {
                'data-marketplace-search': '1'
            }
        },
        // × appears only when there's a query to clear. Sits inside the
        // input's reserved right padding. Clicking clears + refocuses the
        // input so the user can immediately type a new query.
        SearchClearBtn: {
            extends: 'Button',
            hide: (el, s)=>!s.query,
            text: "\u2715",
            title: 'Clear search',
            ariaLabel: 'Clear search',
            position: 'absolute',
            right: 'X',
            top: '50%',
            transform: 'translateY(-50%)',
            padding: 'X Y',
            background: 'transparent',
            color: 'caption',
            fontSize: 'Y',
            onClick: (e, el, s)=>{
                s.update({
                    query: ''
                });
                // Refocus via registered function — keeps the component free
                // of raw DOM queries (Rule 30).
                el.call('focusSearchInput');
            }
        }
    },
    PricingTabs: {
        flow: 'x',
        gap: 'Y',
        childExtends: 'MarketplacePricingTab',
        // Labels + "Installed (N)" / "Pinned (N)" counters live in
        // MarketplacePricingTab itself so they can be reactive. Installed
        // + Pinned are virtual pricing-tabs — filter is `state.activePricing
        // === '<tab>'` + `matchesFilters` (functions/index.js) checks the
        // corresponding `host.installed` / `host.pinnedIds` list.
        children: {
            all: {},
            free: {},
            paid: {},
            installed: {},
            pinned: {}
        }
    },
    // Sort controls — `state.activeSort` ∈ 'name' | 'priceAsc' | 'priceDesc'.
    // MarketplaceGrid.children applies the sort after filter; see
    // functions/index.js#sortItems.
    SortTabs: {
        flow: 'x',
        gap: 'Y',
        childExtends: 'MarketplaceSortTab',
        children: {
            name: {},
            priceAsc: {},
            priceDesc: {}
        }
    },
    // Random item picker. Opens detail for a random visible item —
    // respects active filters so the pick stays relevant to the current
    // browse. Hidden when nothing matches current filters.
    SurpriseBtn: {
        extends: 'Button',
        hide: (el)=>{
            const host = el.call('marketplaceHostOf', el);
            return el.call('resultsCountLabel', host).startsWith('0');
        },
        text: "\uD83C\uDFB2 Surprise me",
        title: 'Open a random visible item',
        ariaLabel: 'Open random item',
        fontSize: 'Y',
        padding: 'X A',
        background: 'transparent',
        color: 'caption',
        onClick: (e, el)=>{
            const host = el.call('marketplaceHostOf', el);
            el.call('surpriseMe', host);
        }
    },
    // Density toggle: Comfortable ↔ Compact. Label is bidirectional —
    // shows the OTHER option so users know what clicking will do
    // ("Compact" button while in Comfortable mode).
    DensityToggleBtn: {
        extends: 'Button',
        text: (el)=>{
            const host = el.call('marketplaceHostOf', el);
            return host?.gridDensity === 'compact' ? 'Comfortable' : 'Compact';
        },
        title: 'Toggle grid density',
        fontSize: 'Y',
        padding: 'X A',
        background: 'transparent',
        color: 'caption',
        onClick: (e, el)=>{
            const host = el.call('marketplaceHostOf', el);
            el.call('toggleGridDensity', host);
        }
    },
    // One-click reset for kind + categories + pricing + query. Sort
    // is preserved (user's explicit sort intent). Hidden when nothing
    // is filtered — no clutter on the default view.
    ClearAllBtn: {
        extends: 'Button',
        hide: (el)=>{
            const host = el.call('marketplaceHostOf', el);
            return !el.call('hasActiveFilters', host);
        },
        text: 'Clear all',
        title: 'Reset every filter to its default',
        fontSize: 'Y',
        padding: 'X A',
        background: 'transparent',
        color: 'caption',
        onClick: (e, el)=>{
            const host = el.call('marketplaceHostOf', el);
            el.call('clearAllFilters', host);
        }
    },
    // Compose current filter state into a shareable URL (canvas page's
    // `_applyFiltersFromUrl` consumes the same keys). See
    // `composeShareUrl` + `copyLinkToClipboard` in functions/index.js.
    MarketplaceCopyLinkBtn: {}
};

});

parcelRegister("1MVaW", function(module, exports) {

$parcel$export(module.exports, "MarketplaceSidebar", () => $14d69ffea8bfdedf$export$4520e0bb92cd2861);
const $14d69ffea8bfdedf$var$KINDS = {
    all: {
        label: 'All'
    },
    library: {
        label: 'Libraries'
    },
    template: {
        label: 'Templates'
    },
    integration: {
        label: 'Integrations'
    },
    registrar: {
        label: 'Domain Registrars'
    },
    plugin: {
        label: 'Plugins'
    }
};
const $14d69ffea8bfdedf$export$4520e0bb92cd2861 = {
    flow: 'y',
    gap: 'A',
    padding: 'A',
    width: 'F',
    minWidth: 'F',
    CaptionTitle: {
        Text: {
            text: 'Browse'
        }
    },
    KindList: {
        flow: 'y',
        gap: 'X',
        childExtends: 'MarketplaceKindItem',
        children: $14d69ffea8bfdedf$var$KINDS
    },
    // User-curated pins — surface above recents since they're
    // intentional favorites. Hidden when no pins yet. Caption gets a
    // count + Clear button, parity with RecentCaption.
    PinnedCaption: {
        flow: 'x',
        align: 'center space-between',
        hide: (el)=>{
            const host = el.call('marketplaceHostOf', el);
            return !host?.pinnedIds?.length;
        },
        Text: {
            tag: 'span',
            text: (el)=>{
                const host = el.call('marketplaceHostOf', el);
                const n = host?.pinnedIds?.length || 0;
                return `Pinned (${n})`;
            },
            fontSize: 'Y',
            color: 'caption',
            textTransform: 'uppercase',
            letterSpacing: 'X'
        },
        PinnedClearBtn: {
            extends: 'Button',
            text: 'Clear',
            title: 'Clear every pinned item',
            fontSize: 'X',
            padding: 'X Y',
            background: 'transparent',
            color: 'caption',
            onClick: (e, el)=>{
                const host = el.call('marketplaceHostOf', el);
                el.call('clearPinned', host);
            }
        }
    },
    PinnedList: {
        flow: 'y',
        gap: 'X',
        hide: (el)=>{
            const host = el.call('marketplaceHostOf', el);
            return !host?.pinnedIds?.length;
        },
        children: (el)=>{
            const host = el.call('marketplaceHostOf', el);
            const ids = host?.pinnedIds || [];
            const catalog = host?.catalog || [];
            const byId = new Map(catalog.map((i)=>[
                    i.id,
                    i
                ]));
            return ids.map((id)=>byId.get(id)).filter(Boolean);
        },
        // Reuse MarketplaceRecentItem — same compact logo+name shape.
        childExtends: 'MarketplaceRecentItem'
    },
    // Recently-viewed: up to 8 items. Hidden when the list is empty
    // (first session + no drills yet) so the sidebar doesn't show an
    // empty stub. Children fn resolves `host.recentIds` against the
    // catalog so the row has the full item shape.
    RecentCaption: {
        flow: 'x',
        align: 'center space-between',
        hide: (el)=>{
            const host = el.call('marketplaceHostOf', el);
            return !host?.recentIds?.length;
        },
        Text: {
            tag: 'span',
            text: 'Recently viewed',
            fontSize: 'Y',
            color: 'caption',
            textTransform: 'uppercase',
            letterSpacing: 'X'
        },
        // Wipe the list in one click. Discoverable affordance — users
        // know what "Clear" means in this caption.
        RecentClearBtn: {
            extends: 'Button',
            text: 'Clear',
            title: 'Clear the recently-viewed list',
            fontSize: 'X',
            padding: 'X Y',
            background: 'transparent',
            color: 'caption',
            onClick: (e, el)=>{
                const host = el.call('marketplaceHostOf', el);
                el.call('clearRecent', host);
            }
        }
    },
    RecentList: {
        flow: 'y',
        gap: 'X',
        hide: (el)=>{
            const host = el.call('marketplaceHostOf', el);
            return !host?.recentIds?.length;
        },
        children: (el)=>{
            const host = el.call('marketplaceHostOf', el);
            const ids = host?.recentIds || [];
            const catalog = host?.catalog || [];
            const byId = new Map(catalog.map((i)=>[
                    i.id,
                    i
                ]));
            return ids.map((id)=>byId.get(id)).filter(Boolean);
        },
        childExtends: 'MarketplaceRecentItem'
    }
};

});

parcelRegister("100us", function(module, exports) {

$parcel$export(module.exports, "MarketplaceFilters", () => $0ba62be8e30f2cb6$export$39de1bf44919aeea);
const $0ba62be8e30f2cb6$var$CATEGORIES = {
    all: {},
    analytics: {},
    backend: {},
    database: {},
    automation: {},
    auth: {},
    payments: {},
    ai: {},
    messaging: {},
    storage: {},
    observability: {},
    ui: {},
    system: {},
    starter: {},
    marketing: {},
    docs: {},
    commerce: {},
    content: {},
    quality: {},
    editor: {},
    domains: {}
};
const $0ba62be8e30f2cb6$export$39de1bf44919aeea = {
    flow: 'x',
    gap: 'Y',
    padding: 'Y A',
    overflow: 'x auto',
    borderBottom: '1px solid line',
    childExtends: 'MarketplaceCategoryItem',
    children: $0ba62be8e30f2cb6$var$CATEGORIES
};

});

parcelRegister("6dNaP", function(module, exports) {

$parcel$export(module.exports, "MarketplaceGrid", () => $487a19d2c54fcdf5$export$4fc05e0acce71cf5);
const $487a19d2c54fcdf5$export$4fc05e0acce71cf5 = {
    display: 'grid',
    padding: 'A',
    // Density-driven spacing: 'compact' yields a tighter 'Z' gap, any
    // other value (including the default 'comfortable' / undefined)
    // uses 'A'. Same shape on minmax() — 240px vs 320px min width.
    gap: (el)=>{
        const host = el.call('marketplaceHostOf', el);
        return host?.gridDensity === 'compact' ? 'Z' : 'A';
    },
    gridTemplateColumns: (el)=>{
        const host = el.call('marketplaceHostOf', el);
        const min = host?.gridDensity === 'compact' ? '240px' : '320px';
        return `repeat(auto-fill, minmax(${min}, 1fr))`;
    },
    alignContent: 'start',
    // Kick off the live catalogue fetch + persisted-install hydration on
    // mount. The host is either the nearest `MarketplaceIsland` or the
    // app root (see `marketplaceHostOf` in functions/index.js) — this lets
    // canvas + landing embed the grid without polluting their app roots
    // with marketplace state. `hydrateLiveCatalog` merges
    // `integration_kinds` rows from governance into host.catalog;
    // `hydrateInstalledFromPrefs` restores the installed-items list from
    // sdk-bridge prefs so the "Installed" button state survives reloads.
    onCreate: (el)=>{
        const host = el.call('marketplaceHostOf', el);
        if (!host) return;
        el.call('hydrateLiveCatalog', host);
        el.call('hydrateInstalledFromPrefs', host);
        el.call('hydrateSortFromPrefs', host);
        el.call('hydrateRecentFromPrefs', host);
        el.call('hydrateDensityFromPrefs', host);
        el.call('hydratePinnedFromPrefs', host);
    },
    // Each visible child carries its own `extends` so the grid can render
    // two different templates in the same array: `MarketplaceCard`
    // (16:9 thumbnail hero) for library + template,
    // `MarketplaceIntegrationRow` (horizontal row with logo only) for
    // integration + registrar + plugin. Per-child extends is merged with
    // childExtends by the framework, so the catalog-driven choice wins.
    //
    // Filter lifted out of per-card `hide:` functions — `matchesFilters`
    // (functions/index.js) is the single source of truth. Grid filters
    // catalog → visible items here; cards + rows render only what passes.
    //
    // Empty-state: when the filter returns zero items, short-circuit to
    // a single `MarketplaceEmptyState` element. Named siblings inside the
    // grid don't work because `children: fn` fully owns rendering per
    // smbls/packages/element/src/create.js:1461-1463.
    children: (el)=>{
        const host = el.call('marketplaceHostOf', el);
        const items = host?.catalog || [];
        const visible = items.filter((item)=>el.call('matchesFilters', item, host));
        if (visible.length === 0) return [
            {
                extends: 'MarketplaceEmptyState'
            }
        ];
        const sorted = el.call('sortItems', visible, host?.activeSort, host?.query);
        return sorted.map((item)=>({
                ...item,
                extends: item.kind === 'integration' || item.kind === 'plugin' || item.kind === 'registrar' ? 'MarketplaceIntegrationRow' : 'MarketplaceCard'
            }));
    }
};

});

parcelRegister("Te4Rx", function(module, exports) {

$parcel$export(module.exports, "MarketplaceEmptyState", () => $0a600ea711bef3a2$export$c3050d3856907c6a);
// Empty-state placeholder shown in the marketplace grid when filters
// leave nothing to render.
//
// Rendering approach: `MarketplaceGrid.children` short-circuits to a
// single `{extends: 'MarketplaceEmptyState'}` descriptor instead of the
// catalog array. Per smbls v3.14 (packages/element/src/create.js:1461-1463),
// a `children: fn` return value fully owns rendering — named siblings
// like `EmptyState:` inside the grid would be silently skipped. Using a
// single-item array with `MarketplaceEmptyState` as the child works.
//
// Spans the full grid width (4 columns on canvas + standalone layouts)
// so the message centers in the viewport rather than squeezing into one
// card slot.
const $0a600ea711bef3a2$export$c3050d3856907c6a = {
    flow: 'y',
    align: 'center center',
    gap: 'Z',
    padding: 'C A',
    gridColumn: '1 / -1',
    textAlign: 'center',
    EmptyStateTitle: {
        tag: 'h4',
        text: (el)=>{
            const host = el.call('marketplaceHostOf', el);
            if (host?.activePricing === 'installed') return 'Nothing installed yet';
            const q = (host?.query || '').trim();
            if (q) return `No matches for "${q}"`;
            return 'No items match your filters';
        },
        fontSize: 'A',
        fontWeight: '600',
        color: 'title',
        margin: '0'
    },
    EmptyStateHint: {
        tag: 'p',
        text: (el)=>{
            const host = el.call('marketplaceHostOf', el);
            if (host?.activePricing === 'installed') return 'Install a library, template, or plugin to see it here. Integrations added via your organization show up automatically.';
            return 'Try broadening your filters \u2014 pick "All" kinds, clear the category chip, or remove the search term.';
        },
        fontSize: 'Z',
        color: 'caption',
        margin: '0',
        maxWidth: 'J'
    }
};

});

parcelRegister("Hhpts", function(module, exports) {

$parcel$export(module.exports, "MarketplaceCard", () => $082185814d97197b$export$484539b24f30e800);
// Thumbnail-hero card for `library` and `template` kinds. Integrations
// and plugins use `MarketplaceIntegrationRow` (row layout, logo-only).
// Templates/libraries are visual artifacts and deserve a 16:9 preview;
// integrations are service connectors and read better as rows.
//
// Empty `thumbnail` → `transparentBg` checker so the slot still reads
// as "image goes here". Thumbnails uploaded manually per item.
// Filter logic lives in functions/index.js#matchesFilters — the grid
// children function projects catalog → visible items upstream, so this
// component renders only if the filter passed. No `hide:` predicate
// needed.
const $082185814d97197b$export$484539b24f30e800 = {
    flow: 'y',
    cursor: 'pointer',
    padding: 'A',
    gap: 'Z',
    borderRadius: 'Z',
    border: '1px solid',
    overflow: 'hidden',
    transition: 'Z defaultBezier border-color, Z defaultBezier transform',
    // A11y + keyboard: tabindex=0 makes the card focusable via Tab;
    // role=button conveys "this does something when pressed" to screen
    // readers. Enter/Space trigger the same handler as onClick (see
    // openDetailFromEl in functions/index.js).
    tabindex: '0',
    role: 'button',
    background: (el)=>{
        const host = el.call('marketplaceHostOf', el);
        return host?.selectedItem?.id === el.id ? 'blue.1' : 'dialog';
    },
    borderColor: (el)=>{
        const host = el.call('marketplaceHostOf', el);
        return host?.selectedItem?.id === el.id ? 'blue' : 'line';
    },
    ':hover': {
        borderColor: 'blue'
    },
    // focus-visible shows the outline on keyboard focus but NOT on
    // mouse click — standard modern a11y pattern.
    ':focus-visible': {
        outline: '2px solid blue',
        outlineOffset: '2px'
    },
    // Grid card click starts a fresh detail-pane journey — clears any
    // lingering `selectedHistory` so the Back button hides. Use
    // `selectItemFresh`; `selectItemWithHistory` is for similar-item
    // clicks inside the detail pane.
    onClick: (e, el)=>el.call('openDetailFromEl', el),
    onKeydown: (e, el)=>{
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        el.call('openDetailFromEl', el);
    },
    // 16:9 hero bleeds into the card's padding so the image is flush with
    // the card edges. Two static children keyed on thumbnail presence —
    // no reactive background-* churn per card. Mirrors DetailHero.
    CardThumb: {
        margin: '-A -A 0',
        aspectRatio: '16 / 9',
        borderBottom: '1px solid line',
        position: 'relative',
        CardThumbImage: {
            hide: (el)=>!el.parent.parent.thumbnail,
            width: '100%',
            height: '100%',
            background: (el)=>`url("${el.parent.parent.thumbnail}") center / cover no-repeat`,
            backgroundColor: 'dialog',
            __order: [
                'hide',
                'width',
                'height',
                'background',
                'backgroundColor'
            ]
        },
        // Transparent-canvas checker. `background: 'transparentBg'` hooks
        // the DS gradient table; longhands shape the 4-layer checker.
        // `__order` keeps the shorthand from wiping longhands (ColorField.js).
        CardThumbPlaceholder: {
            hide: (el)=>!!el.parent.parent.thumbnail,
            width: '100%',
            height: '100%',
            background: 'transparentBg',
            backgroundColor: 'document',
            backgroundSize: '20px 20px',
            backgroundPosition: '0 0, 0 10px, 10px -10px, -10px 0px',
            backgroundRepeat: 'repeat',
            __order: [
                'hide',
                'width',
                'height',
                'background',
                'backgroundColor',
                'backgroundSize',
                'backgroundPosition',
                'backgroundRepeat'
            ]
        },
        // Pin / unpin star, overlaid top-left of the thumbnail so it's
        // always reachable without entering the card. Click stops
        // propagation so it doesn't also open the detail. ★ = pinned,
        // ☆ = not pinned.
        CardPinBtn: {
            extends: 'Button',
            position: 'absolute',
            top: 'Z',
            left: 'Z',
            padding: 'X Y',
            borderRadius: 'Y',
            background: 'black.55',
            color: (el)=>el.call('isPinned', el.call('marketplaceHostOf', el), el.parent.parent.id) ? 'yellow' : 'white',
            fontSize: 'Y',
            backdropFilter: 'blur(4px)',
            text: (el)=>el.call('isPinned', el.call('marketplaceHostOf', el), el.parent.parent.id) ? "\u2605" : "\u2606",
            title: 'Pin to sidebar',
            ariaLabel: 'Toggle pin',
            onClick: (e, el)=>{
                e.stopPropagation();
                const host = el.call('marketplaceHostOf', el);
                el.call('togglePin', host, el.parent.parent.id);
            }
        },
        // Kind badge overlaid on top-right of the thumbnail. Gives each
        // card an at-a-glance kind label without stealing a row in the
        // content area below. `black.55` = DS-token alpha modifier
        // (Color API: dot-notation opacity) — same pattern as AppNavbar's
        // `black.2` hover / LoginWindow's `black.65`.
        CardThumbBadge: {
            tag: 'span',
            position: 'absolute',
            top: 'Z',
            right: 'Z',
            padding: 'X Y',
            borderRadius: 'Y',
            fontSize: 'Y',
            fontWeight: '500',
            background: 'black.55',
            color: 'white',
            textTransform: 'capitalize',
            backdropFilter: 'blur(4px)',
            text: (el)=>el.parent.parent.kind,
            // Native HTML `title` attr — browser surfaces the full text on
            // hover. A11y + discoverability for kind filtering.
            title: (el)=>`${el.parent.parent.kind} \xb7 click card to see details`
        }
    },
    CardTitle: {
        tag: 'h5',
        text: (el)=>el.parent.name,
        fontSize: 'Z',
        fontWeight: '600',
        color: 'title',
        margin: '0'
    },
    CardDesc: {
        tag: 'p',
        text: (el)=>el.parent.description,
        fontSize: 'Y',
        color: 'caption',
        margin: '0',
        flex: '1'
    },
    CardFooter: {
        flow: 'x',
        align: 'center space-between',
        gap: 'Z',
        marginTop: 'auto',
        CardPrice: {
            tag: 'span',
            text: (el)=>el.parent.parent.price > 0 ? `$${el.parent.parent.price}` : 'Free',
            fontSize: 'Y',
            fontWeight: '500',
            color: (el)=>el.parent.parent.price > 0 ? 'title' : 'green'
        },
        CardInstall: {
            extends: 'Button',
            text: (el)=>{
                const host = el.call('marketplaceHostOf', el);
                return el.call('installButtonText', el.parent.parent, host);
            },
            disabled: (el)=>{
                const host = el.call('marketplaceHostOf', el);
                return el.call('installButtonDisabled', el.parent.parent, host);
            },
            onClick: (e, el)=>{
                e.stopPropagation();
                const host = el.call('marketplaceHostOf', el);
                return el.call('dispatchInstallAndMark', el.parent.parent, host);
            }
        }
    }
};

});

parcelRegister("EqTeH", function(module, exports) {

$parcel$export(module.exports, "MarketplaceIntegrationRow", () => $07989851068faa3a$export$1c8f09a99868bd90);
// Row layout for `integration` + `plugin` kinds (MarketplaceCard handles
// library + template with thumbnails). Integrations are service
// connectors — name + logo + one-line description + Configure button
// reads cleanly as a scannable row.
//
// `gridColumn: 'span 2'` pairs two rows per grid row in the
// marketplace's 4-column grid, giving rows breathing space without
// collapsing to a single item per row.
const $07989851068faa3a$export$1c8f09a99868bd90 = {
    // `flow` already emits `display: flex` — no need to extends Flex.
    flow: 'x',
    align: 'center',
    gap: 'Z',
    padding: 'Z A',
    gridColumn: 'span 2',
    borderRadius: 'Z',
    border: '1px solid',
    cursor: 'pointer',
    transition: 'Z defaultBezier border-color, Z defaultBezier background',
    background: (el)=>{
        const host = el.call('marketplaceHostOf', el);
        return host?.selectedItem?.id === el.id ? 'blue.1' : 'dialog';
    },
    borderColor: (el)=>{
        const host = el.call('marketplaceHostOf', el);
        return host?.selectedItem?.id === el.id ? 'blue' : 'line';
    },
    ':hover': {
        borderColor: 'blue',
        background: 'dialog'
    },
    // Filter lives in functions/index.js#matchesFilters — the grid's
    // children function projects catalog → visible items upstream.
    // No `hide:` predicate needed here.
    // A11y + keyboard: tabindex=0 + role=button so Tab reaches the row
    // and assistive tech announces it. Enter/Space open detail.
    tabindex: '0',
    role: 'button',
    ':focus-visible': {
        outline: '2px solid blue',
        outlineOffset: '2px'
    },
    // Fresh journey from the grid — clears selectedHistory. Similar-item
    // clicks in the detail pane use selectItemWithHistory instead.
    onClick: (e, el)=>el.call('openDetailFromEl', el),
    onKeydown: (e, el)=>{
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        el.call('openDetailFromEl', el);
    },
    RowLogo: {
        align: 'center center',
        width: 'B',
        height: 'B',
        minWidth: 'B',
        borderRadius: 'Y',
        overflow: 'hidden',
        fontWeight: '700',
        fontSize: 'A',
        background: (el)=>el.parent.logo ? 'white' : el.call('getKindAccent', el.parent.kind, 'bg'),
        color: (el)=>el.call('getKindAccent', el.parent.kind, 'fg'),
        // Nested DOMQL img/letter pattern — Rule 31 (no html: strings with
        // inline style=). Mirrors MarketplaceDetailSimilarItem.SimilarLogo.
        RowLogoImg: {
            // Guard: logo must be a non-null, non-empty string.
            hide: (el)=>!el.parent.parent.logo || el.parent._imgFailed,
            tag: 'img',
            src: (el)=>{
                const slug = el.parent.parent.logo;
                return slug ? `https://cdn.simpleicons.org/${slug}` : '';
            },
            alt: (el)=>el.parent.parent.name,
            width: '60%',
            height: '60%',
            objectFit: 'contain',
            // onerror fallback: CDN 404 → flag the parent logo container so
            // the reactive `hide` on both img and letter re-evaluates correctly
            // on the next render cycle. DOM-level fallback ensures immediate
            // visual correction even before the next DOMQL render pass.
            onRender: (el)=>{
                if (!el.node) return;
                el.node.onerror = ()=>{
                    el.parent._imgFailed = true;
                    el.node.style.display = 'none';
                    const letter = el.parent.RowLogoLetter;
                    if (letter?.node) letter.node.style.display = '';
                };
            }
        },
        RowLogoLetter: {
            // Show when there's no logo OR when the img errored out.
            hide: (el)=>!!el.parent.parent.logo && !el.parent._imgFailed,
            tag: 'span',
            text: (el)=>(el.parent.parent.name || '')[0]?.toUpperCase() || '?'
        }
    },
    RowInfo: {
        flow: 'y',
        gap: 'V',
        flex: '1',
        minWidth: '0',
        RowTitle: {
            tag: 'h5',
            text: (el)=>el.parent.parent.name,
            fontSize: 'Z',
            fontWeight: '600',
            color: 'title',
            margin: '0',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        },
        RowDesc: {
            tag: 'p',
            text: (el)=>el.parent.parent.description,
            fontSize: 'Y',
            color: 'caption',
            margin: '0',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        }
    },
    RowActions: {
        flow: 'x',
        align: 'center',
        gap: 'Z',
        flexShrink: '0',
        // Pin / unpin star. Pattern mirrors CardPinBtn on the card; this
        // row layout has no thumbnail overlay so the star sits inline
        // with the price + install button actions.
        RowPinBtn: {
            extends: 'Button',
            padding: 'X Y',
            borderRadius: 'Y',
            background: 'transparent',
            color: (el)=>el.call('isPinned', el.call('marketplaceHostOf', el), el.parent.parent.id) ? 'yellow' : 'caption',
            fontSize: 'Z',
            text: (el)=>el.call('isPinned', el.call('marketplaceHostOf', el), el.parent.parent.id) ? "\u2605" : "\u2606",
            title: 'Pin to sidebar',
            ariaLabel: 'Toggle pin',
            onClick: (e, el)=>{
                e.stopPropagation();
                const host = el.call('marketplaceHostOf', el);
                el.call('togglePin', host, el.parent.parent.id);
            }
        },
        RowPrice: {
            tag: 'span',
            hide: (el)=>!el.parent.parent.price,
            text: (el)=>`$${el.parent.parent.price}`,
            fontSize: 'Y',
            fontWeight: '500',
            color: 'title'
        },
        RowInstall: {
            extends: 'Button',
            text: (el)=>{
                const host = el.call('marketplaceHostOf', el);
                return el.call('installButtonText', el.parent.parent, host);
            },
            disabled: (el)=>{
                const host = el.call('marketplaceHostOf', el);
                return el.call('installButtonDisabled', el.parent.parent, host);
            },
            onClick: (e, el)=>{
                e.stopPropagation();
                const host = el.call('marketplaceHostOf', el);
                return el.call('dispatchInstallAndMark', el.parent.parent, host);
            }
        }
    }
};

});

parcelRegister("iVz3O", function(module, exports) {

$parcel$export(module.exports, "MarketplaceDetail", () => $dc78bf2b6f82de9f$export$5f2fa4c0548cf8a6);
// Host-scoped reads: `marketplaceHostOf(el)` returns the nearest
// island's state (or app root state in standalone mode), so `host.selectedItem`
// / `host.update(...)` / etc. stay isolated when multiple marketplace
// embeds share a page.
//
// `isThumbKind` + `getKindAccent` are registered marketplace functions
// (exported from functions/index.js + bundled via context.js) — reach
// them via `el.call(...)` per CLAUDE.md rule: no function imports
// between project files.
const $dc78bf2b6f82de9f$export$5f2fa4c0548cf8a6 = {
    flow: 'y',
    hide: (el)=>{
        const host = el.call('marketplaceHostOf', el);
        return !host?.selectedItem;
    },
    width: 'H',
    minWidth: 'H',
    borderLeft: '1px solid line',
    overflow: 'y auto',
    // Reset the pane's scroll position whenever `selectedItem` changes —
    // fresh item, fresh view. Without this, clicking Back / a breadcrumb
    // / a Similar row keeps the previous item's scrollTop, so users may
    // land mid-way through the new item's About section. Caches the
    // last id on the element so we don't scroll when other reactive
    // props (hover, etc.) trigger onUpdate.
    onUpdate: (el)=>{
        const host = el.call('marketplaceHostOf', el);
        const id = host?.selectedItem?.id || null;
        if (el._lastSelectedId === id) return;
        el._lastSelectedId = id;
        if (typeof el.scrollTo === 'function') el.scrollTo(0, 0);
    },
    DetailTopBar: {
        flow: 'x',
        align: 'center space-between',
        padding: 'Y A',
        borderBottom: '1px solid line',
        // Sticky so Close/Back stay visible as the user scrolls through
        // long descriptions + similar-items lists. Pane scrolls via the
        // root's `overflow: y auto` so `top: 0` anchors to the pane.
        position: 'sticky',
        top: '0',
        background: 'dialog',
        zIndex: '2',
        // Left-side row: Back arrow (hidden when history empty) + close.
        DetailTopLeft: {
            flow: 'x',
            gap: 'Y',
            align: 'center',
            // Appears after clicking through a "Similar item" — lets the user
            // retrace their steps. Pops the last selectedItem off history.
            // Hidden when `selectedHistory` is empty (i.e. fresh navigation
            // from the grid).
            DetailBackBtn: {
                extends: 'Button',
                text: "\u2190 Back",
                ariaLabel: 'Go back to previous item',
                hide: (el)=>{
                    const host = el.call('marketplaceHostOf', el);
                    return !host?.selectedHistory?.length;
                },
                onClick: (e, el)=>{
                    const host = el.call('marketplaceHostOf', el);
                    el.call('popSelectedHistory', host);
                }
            },
            // Breadcrumb trail of prior selections when the user has
            // drilled in via "Similar items" ≥2 levels. Each chip jumps
            // directly to that item + truncates the stack — faster than
            // repeated Back clicks for deep trails. Hidden when history
            // has 0 or 1 entry (Back alone covers 1 step).
            DetailBreadcrumb: {
                flow: 'x',
                gap: 'Y',
                align: 'center',
                hide: (el)=>{
                    const host = el.call('marketplaceHostOf', el);
                    return !(host?.selectedHistory?.length > 1);
                },
                children: (el)=>{
                    const host = el.call('marketplaceHostOf', el);
                    const history = host?.selectedHistory || [];
                    return history.map((item, idx)=>({
                            ...item,
                            _historyIndex: idx
                        }));
                },
                childExtends: 'MarketplaceBreadcrumbItem'
            },
            // Pin / unpin the open detail item — mirrors the card/row star
            // so users don't need to close to pin. Star is yellow/filled
            // when pinned, outlined otherwise.
            DetailPinBtn: {
                extends: 'Button',
                text: (el)=>{
                    const host = el.call('marketplaceHostOf', el);
                    return el.call('isPinned', host, host?.selectedItem?.id) ? "\u2605" : "\u2606";
                },
                color: (el)=>{
                    const host = el.call('marketplaceHostOf', el);
                    return el.call('isPinned', host, host?.selectedItem?.id) ? 'yellow' : 'caption';
                },
                title: 'Pin to sidebar',
                ariaLabel: 'Toggle pin',
                onClick: (e, el)=>{
                    const host = el.call('marketplaceHostOf', el);
                    el.call('togglePin', host, host?.selectedItem?.id);
                }
            },
            DetailCloseBtn: {
                extends: 'Button',
                text: "\u2715",
                ariaLabel: 'Close detail pane',
                onClick: (e, el)=>{
                    const host = el.call('marketplaceHostOf', el);
                    // `closeDetail` clears both selectedItem + selectedHistory
                    // AND restores focus to the card the user originally opened,
                    // preserving the Tab loop for keyboard users.
                    el.call('closeDetail', host);
                }
            }
        }
    },
    DetailHero: {
        hide: (el)=>{
            const host = el.call('marketplaceHostOf', el);
            return !el.call('isThumbKind', host?.selectedItem?.kind);
        },
        aspectRatio: '16 / 9',
        borderBottom: '1px solid line',
        DetailHeroImage: {
            hide: (el)=>{
                const host = el.call('marketplaceHostOf', el);
                return !host?.selectedItem?.thumbnail;
            },
            width: '100%',
            height: '100%',
            background: (el)=>{
                const host = el.call('marketplaceHostOf', el);
                return `url("${host?.selectedItem?.thumbnail || ''}") center / cover no-repeat`;
            },
            backgroundColor: 'dialog',
            __order: [
                'hide',
                'width',
                'height',
                'background',
                'backgroundColor'
            ]
        },
        DetailHeroPlaceholder: {
            hide: (el)=>{
                const host = el.call('marketplaceHostOf', el);
                return !!host?.selectedItem?.thumbnail;
            },
            width: '100%',
            height: '100%',
            background: 'transparentBg',
            backgroundColor: 'document',
            backgroundSize: '20px 20px',
            backgroundPosition: '0 0, 0 10px, 10px -10px, -10px 0px',
            backgroundRepeat: 'repeat',
            __order: [
                'hide',
                'width',
                'height',
                'background',
                'backgroundColor',
                'backgroundSize',
                'backgroundPosition',
                'backgroundRepeat'
            ]
        }
    },
    DetailBody: {
        flow: 'y',
        padding: 'A',
        gap: 'B',
        DetailHeader: {
            flow: 'x',
            gap: 'A',
            align: 'flex-start',
            DetailAvatar: {
                hide: (el)=>{
                    const host = el.call('marketplaceHostOf', el);
                    return el.call('isThumbKind', host?.selectedItem?.kind);
                },
                align: 'center center',
                width: 'C',
                height: 'C',
                minWidth: 'C',
                borderRadius: 'Z',
                fontWeight: '700',
                fontSize: 'B',
                overflow: 'hidden',
                background: (el)=>{
                    const host = el.call('marketplaceHostOf', el);
                    return host?.selectedItem?.logo ? 'white' : el.call('getKindAccent', host?.selectedItem?.kind, 'bg');
                },
                color: (el)=>{
                    const host = el.call('marketplaceHostOf', el);
                    return el.call('getKindAccent', host?.selectedItem?.kind, 'fg');
                },
                // Nested DOMQL img/letter pattern — Rule 31 (no html: strings
                // with inline style=). Host is read once per child via
                // `marketplaceHostOf`; each child hide-gates on selectedItem.logo.
                DetailAvatarImg: {
                    hide: (el)=>{
                        const host = el.call('marketplaceHostOf', el);
                        return !host?.selectedItem?.logo || el.parent._imgFailed;
                    },
                    tag: 'img',
                    src: (el)=>{
                        const host = el.call('marketplaceHostOf', el);
                        const slug = host?.selectedItem?.logo;
                        return slug ? `https://cdn.simpleicons.org/${slug}` : '';
                    },
                    alt: (el)=>{
                        const host = el.call('marketplaceHostOf', el);
                        return host?.selectedItem?.name || '';
                    },
                    width: '60%',
                    height: '60%',
                    objectFit: 'contain',
                    onRender: (el)=>{
                        if (!el.node) return;
                        el.node.onerror = ()=>{
                            el.parent._imgFailed = true;
                            el.node.style.display = 'none';
                            const letter = el.parent.DetailAvatarLetter;
                            if (letter?.node) letter.node.style.display = '';
                        };
                    }
                },
                DetailAvatarLetter: {
                    hide: (el)=>{
                        const host = el.call('marketplaceHostOf', el);
                        return !!host?.selectedItem?.logo && !el.parent._imgFailed;
                    },
                    tag: 'span',
                    text: (el)=>{
                        const host = el.call('marketplaceHostOf', el);
                        const name = host?.selectedItem?.name || '';
                        return name[0]?.toUpperCase() || '?';
                    }
                }
            },
            DetailMeta: {
                flow: 'y',
                gap: 'Y',
                flex: '1',
                DetailName: {
                    tag: 'h3',
                    text: (el)=>{
                        const host = el.call('marketplaceHostOf', el);
                        return host?.selectedItem?.name;
                    },
                    fontSize: 'B',
                    fontWeight: '700',
                    color: 'title'
                },
                DetailTagRow: {
                    flow: 'x',
                    gap: 'Y',
                    DetailKindTag: {
                        tag: 'span',
                        text: (el)=>{
                            const host = el.call('marketplaceHostOf', el);
                            return host?.selectedItem?.kind;
                        },
                        // Native HTML title — mirrors MarketplaceCard.CardThumbBadge
                        // tooltip pattern (tick 9).
                        title: (el)=>{
                            const host = el.call('marketplaceHostOf', el);
                            return `Kind: ${host?.selectedItem?.kind || ''}`;
                        },
                        padding: 'X Y',
                        borderRadius: 'Y',
                        fontSize: 'Y',
                        background: 'line',
                        color: 'caption',
                        textTransform: 'capitalize'
                    },
                    DetailCategoryTag: {
                        tag: 'span',
                        text: (el)=>{
                            const host = el.call('marketplaceHostOf', el);
                            return host?.selectedItem?.category;
                        },
                        title: (el)=>{
                            const host = el.call('marketplaceHostOf', el);
                            return `Category: ${host?.selectedItem?.category || ''}`;
                        },
                        padding: 'X Y',
                        borderRadius: 'Y',
                        fontSize: 'Y',
                        background: 'line',
                        color: 'caption',
                        textTransform: 'capitalize'
                    }
                }
            }
        },
        DetailAbout: {
            flow: 'y',
            gap: 'Y',
            DetailAboutTitle: {
                tag: 'h4',
                text: 'About',
                fontSize: 'Z',
                fontWeight: '600',
                color: 'title'
            },
            DetailAboutText: {
                tag: 'p',
                text: (el)=>{
                    const host = el.call('marketplaceHostOf', el);
                    return host?.selectedItem?.description;
                },
                fontSize: 'Z',
                color: 'paragraph'
            }
        },
        DetailInstallInfo: {
            flow: 'y',
            gap: 'Y',
            DetailInstallTitle: {
                tag: 'h4',
                text: 'How it installs',
                fontSize: 'Z',
                fontWeight: '600',
                color: 'title'
            },
            DetailInstallNote: {
                tag: 'p',
                text: (el)=>{
                    const host = el.call('marketplaceHostOf', el);
                    const k = host?.selectedItem?.kind;
                    if (k === 'library') return 'Added to sharedLibraries.js and immediately available as shared components across your project.';
                    if (k === 'template') return 'Copies pages, components, and design system files into your project source, then compiles with frank.';
                    if (k === 'integration') return 'Adds the required npm dependencies, env variable stubs, and registers the integration functions so you can call them via el.call().';
                    if (k === 'registrar') return "Connects your registrar account so you can search, register, and manage domains \u2014 plus configure DNS \u2014 from inside the editor.";
                    if (k === 'plugin') return 'Registers the plugin in the editor plugin registry and activates it on the next editor reload.';
                    return '';
                },
                fontSize: 'Y',
                color: 'caption'
            }
        },
        DetailPriceCard: {
            flow: 'x',
            align: 'center space-between',
            padding: 'A',
            borderRadius: 'Z',
            border: '1px solid line',
            background: 'dialog',
            gap: 'A',
            DetailPriceInfo: {
                flow: 'y',
                gap: 'X',
                DetailPriceValue: {
                    tag: 'h3',
                    text: (el)=>{
                        const host = el.call('marketplaceHostOf', el);
                        return host?.selectedItem?.price > 0 ? `$${host?.selectedItem?.price}` : 'Free';
                    },
                    fontSize: 'B',
                    fontWeight: '700',
                    color: (el)=>{
                        const host = el.call('marketplaceHostOf', el);
                        return host?.selectedItem?.price > 0 ? 'title' : 'green';
                    }
                },
                DetailPriceNote: {
                    text: (el)=>{
                        const host = el.call('marketplaceHostOf', el);
                        return host?.selectedItem?.price > 0 ? 'One-time purchase' : 'Open source';
                    },
                    fontSize: 'Y',
                    color: 'caption'
                }
            },
            DetailInstallBtn: {
                extends: 'Button',
                theme: 'primary',
                text: (el)=>{
                    const host = el.call('marketplaceHostOf', el);
                    return el.call('installButtonText', host?.selectedItem, host);
                },
                disabled: (el)=>{
                    const host = el.call('marketplaceHostOf', el);
                    return el.call('installButtonDisabled', host?.selectedItem, host);
                },
                onClick: (e, el)=>{
                    const host = el.call('marketplaceHostOf', el);
                    return el.call('dispatchInstallAndMark', host?.selectedItem, host);
                }
            }
        },
        // "Similar items" — up to 4 items with the same category as the
        // current selection, excluding self. Clicking one becomes the new
        // `selectedItem`. Hidden when no similar items exist.
        DetailSimilar: {
            flow: 'y',
            gap: 'Y',
            hide: (el)=>{
                const host = el.call('marketplaceHostOf', el);
                const cur = host?.selectedItem;
                if (!cur) return true;
                const count = (host?.catalog || []).filter((i)=>i.id !== cur.id && i.category === cur.category).length;
                return count === 0;
            },
            DetailSimilarTitle: {
                tag: 'h4',
                text: 'Similar items',
                fontSize: 'Z',
                fontWeight: '600',
                color: 'title'
            },
            DetailSimilarList: {
                flow: 'y',
                gap: 'Y',
                children: (el)=>{
                    const host = el.call('marketplaceHostOf', el);
                    const cur = host?.selectedItem;
                    if (!cur) return [];
                    return (host?.catalog || []).filter((i)=>i.id !== cur.id && i.category === cur.category).slice(0, 4);
                },
                childExtends: 'MarketplaceDetailSimilarItem'
            }
        }
    }
};

});

parcelRegister("4NYjs", function(module, exports) {

$parcel$export(module.exports, "MarketplaceDetailSimilarItem", () => $37fa85ec911a8b16$export$553c164a49a90bad);
// Mini-item row inside the "Similar items" section of MarketplaceDetail.
// Renders logo/letter + name + kind badge. Clicking replaces the host's
// selectedItem so the detail pane transitions to the new item without
// closing + reopening.
const $37fa85ec911a8b16$export$553c164a49a90bad = {
    flow: 'x',
    align: 'center',
    gap: 'Z',
    padding: 'Y A',
    borderRadius: 'Y',
    cursor: 'pointer',
    transition: 'Z defaultBezier background',
    background: 'transparent',
    ':hover': {
        background: 'line'
    },
    // Clicking a similar item pushes the current `selectedItem` onto
    // `selectedHistory` so the Back button in DetailTopBar can restore
    // it. Grid/row clicks use `selectItemFresh` instead (clears stack).
    onClick: (e, el)=>{
        const host = el.call('marketplaceHostOf', el);
        el.call('selectItemWithHistory', host, {
            id: el.id,
            kind: el.kind,
            category: el.category,
            name: el.name,
            description: el.description,
            price: el.price,
            logo: el.logo,
            thumbnail: el.thumbnail,
            _liveKind: el._liveKind
        });
    },
    SimilarLogo: {
        align: 'center center',
        width: 'A',
        height: 'A',
        minWidth: 'A',
        borderRadius: 'Y',
        overflow: 'hidden',
        fontWeight: '700',
        fontSize: 'Y',
        background: (el)=>el.parent.logo ? 'white' : el.call('getKindAccent', el.parent.kind, 'bg'),
        color: (el)=>el.call('getKindAccent', el.parent.kind, 'fg'),
        // Brand img when logo is present, otherwise letter chip. Nested
        // DOMQL elements — no `html:` string with inline `style=` (Rule 31).
        SimilarLogoImg: {
            hide: (el)=>!el.parent.parent.logo || el.parent._imgFailed,
            tag: 'img',
            src: (el)=>{
                const slug = el.parent.parent.logo;
                return slug ? `https://cdn.simpleicons.org/${slug}` : '';
            },
            alt: (el)=>el.parent.parent.name,
            width: '60%',
            height: '60%',
            objectFit: 'contain',
            onRender: (el)=>{
                if (!el.node) return;
                el.node.onerror = ()=>{
                    el.parent._imgFailed = true;
                    el.node.style.display = 'none';
                    const letter = el.parent.SimilarLogoLetter;
                    if (letter?.node) letter.node.style.display = '';
                };
            }
        },
        SimilarLogoLetter: {
            hide: (el)=>!!el.parent.parent.logo && !el.parent._imgFailed,
            tag: 'span',
            text: (el)=>(el.parent.parent.name || '')[0]?.toUpperCase() || '?'
        }
    },
    SimilarName: {
        tag: 'span',
        // `el.parent` IS the mini-item root where the catalog spread lives
        // (name/kind/logo/...). One level of `.parent`, not two — the
        // SimilarLogo nested img/letter pattern walks two levels because
        // they live ONE deeper inside SimilarLogo.
        text: (el)=>el.parent.name,
        fontSize: 'Y',
        fontWeight: '500',
        color: 'title',
        flex: '1',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    },
    SimilarKindTag: {
        tag: 'span',
        text: (el)=>el.parent.kind,
        padding: 'X Y',
        borderRadius: 'Y',
        fontSize: 'X',
        background: 'line',
        color: 'caption',
        textTransform: 'capitalize'
    }
};

});

parcelRegister("9otbD", function(module, exports) {

$parcel$export(module.exports, "MarketplaceKindItem", () => $6d6cfec9706f778d$export$4488fb979f954f1);
// Sidebar kind item. Switched from `s.activeKind` state-walk reads to
// `marketplaceHostOf(el)` so the host is explicit + matches other
// newer components. Label reads `Foo (N)` — count mirrors the
// category-chip pattern (see `kindCount` in functions/index.js).
// Zero-count kinds fade to 0.4 opacity (still clickable for symmetry
// with category chips).
const $6d6cfec9706f778d$export$4488fb979f954f1 = {
    extends: 'Button',
    width: '100%',
    textAlign: 'left',
    align: 'start',
    padding: 'Z A',
    borderRadius: 'Z',
    background: (el)=>{
        const host = el.call('marketplaceHostOf', el);
        return host?.activeKind === el.key ? 'blue.1' : 'transparent';
    },
    color: (el)=>{
        const host = el.call('marketplaceHostOf', el);
        return host?.activeKind === el.key ? 'blue' : 'paragraph';
    },
    fontWeight: (el)=>{
        const host = el.call('marketplaceHostOf', el);
        return host?.activeKind === el.key ? '600' : '400';
    },
    opacity: (el)=>{
        const host = el.call('marketplaceHostOf', el);
        if (host?.activeKind === el.key) return '1';
        const n = el.call('kindCount', host, el.key);
        return n === 0 ? '0.4' : '1';
    },
    text: (el)=>{
        const host = el.call('marketplaceHostOf', el);
        const n = el.call('kindCount', host, el.key);
        const label = el.label || el.key;
        return `${label} (${n})`;
    },
    ':hover': {
        background: 'line'
    },
    onClick: (e, el)=>{
        const host = el.call('marketplaceHostOf', el);
        host?.update?.({
            activeKind: el.key
        });
    }
};

});

parcelRegister("a4sGk", function(module, exports) {

$parcel$export(module.exports, "MarketplaceCategoryItem", () => $755086b637abd87e$export$178ead228629cb91);
// Chips are multi-select. Clicking a non-`all` chip toggles it in/out
// of `activeCategories`. `'all'` is a virtual clear-all — active when
// nothing else is. Label shows `(N)` match count under current
// kind/pricing/query filters (see `categoryCount`). Zero-match chips
// fade to opacity 0.4 so they read as "probably not useful" without
// being disabled.
const $755086b637abd87e$export$178ead228629cb91 = {
    extends: 'Button',
    padding: 'X A',
    borderRadius: 'C',
    background: (el)=>{
        const host = el.call('marketplaceHostOf', el);
        return el.call('isCategoryActive', host, el.key) ? 'blue' : 'line';
    },
    color: (el)=>{
        const host = el.call('marketplaceHostOf', el);
        return el.call('isCategoryActive', host, el.key) ? 'white' : 'caption';
    },
    fontWeight: (el)=>{
        const host = el.call('marketplaceHostOf', el);
        return el.call('isCategoryActive', host, el.key) ? '600' : '400';
    },
    opacity: (el)=>{
        const host = el.call('marketplaceHostOf', el);
        if (el.call('isCategoryActive', host, el.key)) return '1';
        const n = el.call('categoryCount', host, el.key);
        return n === 0 ? '0.4' : '1';
    },
    fontSize: 'Y',
    whiteSpace: 'nowrap',
    text: (el)=>{
        const host = el.call('marketplaceHostOf', el);
        const n = el.call('categoryCount', host, el.key);
        if (el.key === 'all') return `all (${n})`;
        return n > 0 ? `${el.key} (${n})` : el.key;
    },
    ':hover': {
        opacity: '0.8'
    },
    onClick: (e, el)=>{
        const host = el.call('marketplaceHostOf', el);
        el.call('toggleCategory', host, el.key);
    }
};

});

parcelRegister("bLoDH", function(module, exports) {

$parcel$export(module.exports, "MarketplacePricingTab", () => $8907325f552e5d43$export$39afe86ab41bae66);
// Pricing-row tab: All / Free / Paid / Installed / Pinned. Labels
// live here (not in the Navbar's children map) so the Installed /
// Pinned tabs can append reactive counts — child-config `text` values
// would survive the merge as static strings, but this component's
// `text: (el, s) => …` runs reactively.
const $8907325f552e5d43$var$LABELS = {
    all: 'All',
    free: 'Free',
    paid: 'Paid',
    installed: 'Installed',
    pinned: 'Pinned'
};
const $8907325f552e5d43$export$39afe86ab41bae66 = {
    extends: 'Button',
    padding: 'Y A',
    borderRadius: 'Z',
    background: (el, s)=>s.activePricing === el.key ? 'blue' : 'transparent',
    color: (el, s)=>s.activePricing === el.key ? 'white' : 'caption',
    fontWeight: (el, s)=>s.activePricing === el.key ? '600' : '400',
    text: (el, s)=>{
        const base = $8907325f552e5d43$var$LABELS[el.key] || el.key;
        if (el.key === 'installed') {
            const n = s.installed?.length || 0;
            return n > 0 ? `${base} (${n})` : base;
        }
        if (el.key === 'pinned') {
            const n = s.pinnedIds?.length || 0;
            return n > 0 ? `${base} (${n})` : base;
        }
        return base;
    },
    ':hover': {
        background: 'line'
    },
    onClick: (e, el, s)=>s.update({
            activePricing: el.key
        })
};

});

parcelRegister("5Of0N", function(module, exports) {

$parcel$export(module.exports, "MarketplaceSortTab", () => $43ad444f796d5027$export$81e98542e73d2ba5);
// Sort tab — mirrors MarketplacePricingTab shape + state handling.
// Controls grid sort: `host.activeSort` ∈ 'name' | 'priceAsc' | 'priceDesc'.
const $43ad444f796d5027$var$LABELS = {
    name: 'Name',
    priceAsc: "Price \u2191",
    priceDesc: "Price \u2193"
};
const $43ad444f796d5027$export$81e98542e73d2ba5 = {
    extends: 'Button',
    padding: 'Y A',
    borderRadius: 'Z',
    background: (el, s)=>s.activeSort === el.key ? 'blue' : 'transparent',
    color: (el, s)=>s.activeSort === el.key ? 'white' : 'caption',
    fontWeight: (el, s)=>s.activeSort === el.key ? '600' : '400',
    text: (el)=>$43ad444f796d5027$var$LABELS[el.key] || el.key,
    ':hover': {
        background: 'line'
    },
    onClick: (e, el, s)=>{
        s.update({
            activeSort: el.key
        });
        el.call('persistSort', el.key);
    }
};

});

parcelRegister("3axkl", function(module, exports) {

$parcel$export(module.exports, "MarketplaceCopyLinkBtn", () => $24ec28573d19b5ba$export$e546841910f29748);
// Copies the host's current filter view as a shareable URL (see
// `composeShareUrl` in functions/index.js). Label toggles to "Copied!"
// for 2s after a successful write (driven by `host.linkCopyFlash`
// which `copyLinkToClipboard` sets/resets).
const $24ec28573d19b5ba$export$e546841910f29748 = {
    extends: 'Button',
    text: (el)=>{
        const host = el.call('marketplaceHostOf', el);
        return host?.linkCopyFlash ? 'Copied!' : 'Copy link';
    },
    fontSize: 'Y',
    padding: 'X A',
    // `title` attr native tooltip — see CardThumbBadge / DetailKindTag for
    // the same pattern; no `attr: {}` wrapper needed (CLAUDE.md HTML attr
    // rule).
    title: 'Copy a link that reproduces this filtered view',
    onClick: (e, el)=>{
        const host = el.call('marketplaceHostOf', el);
        el.call('copyLinkToClipboard', host);
    }
};

});

parcelRegister("gZ7FK", function(module, exports) {

$parcel$export(module.exports, "MarketplaceToast", () => $c5d84b6e7bc96d62$export$4901cb7629b0ccca);
// Transient feedback toast. Shows when `host.toastMessage` is set —
// driven by `flashToast` in functions/index.js. Auto-dismisses after
// 4s via the same helper. When `host.toastUndoItemId` is non-null,
// an Undo button renders alongside the message (reverses the install
// via `undoInstall`). Hidden when no toast active.
//
// Absolute-positioned relative to the Island so it floats above the
// grid + detail pane. `pointer-events: none` on the outer shell +
// restored on the inner wrapper so invisible toasts don't block
// clicks on the grid behind them.
const $c5d84b6e7bc96d62$export$4901cb7629b0ccca = {
    hide: (el)=>{
        const host = el.call('marketplaceHostOf', el);
        return !host?.toastMessage;
    },
    position: 'absolute',
    bottom: 'A',
    right: 'A',
    flow: 'x',
    gap: 'Z',
    align: 'center',
    padding: 'Z A',
    borderRadius: 'Z',
    border: '1px solid line',
    background: 'dialog',
    // DS-token boxShadow — see design-system/pages/transitions.js and
    // canvas/components/DesignSystemPanel.js for the same pattern:
    // `0 <offsetY> <blur> <color>` where offsets/blur use spacing tokens
    // and color uses a DS alpha modifier.
    boxShadow: '0 Z A black.2',
    zIndex: '10',
    ToastText: {
        tag: 'span',
        text: (el)=>{
            const host = el.call('marketplaceHostOf', el);
            return host?.toastMessage || '';
        },
        fontSize: 'Y',
        color: 'title',
        fontWeight: '500'
    },
    ToastUndoBtn: {
        extends: 'Button',
        hide: (el)=>{
            const host = el.call('marketplaceHostOf', el);
            return !host?.toastUndoItemId;
        },
        text: 'Undo',
        fontSize: 'Y',
        padding: 'X Z',
        background: 'transparent',
        color: 'blue',
        fontWeight: '600',
        onClick: (e, el)=>{
            const host = el.call('marketplaceHostOf', el);
            el.call('undoInstall', host, host?.toastUndoItemId);
        }
    }
};

});

parcelRegister("gvTn1", function(module, exports) {

$parcel$export(module.exports, "MarketplaceBreadcrumbItem", () => $c05a7df99caa42b8$export$12ae34691083810f);
// One chip in the detail-pane breadcrumb trail. Rendered from
// `host.selectedHistory` — each entry's shape matches the catalog
// item (`id`, `name`, etc.) plus a `_historyIndex` injected by the
// parent breadcrumb's `children` function so click handlers know
// where to truncate the stack (see `jumpToHistoryIndex`).
const $c05a7df99caa42b8$export$12ae34691083810f = {
    tag: 'span',
    cursor: 'pointer',
    color: 'caption',
    fontSize: 'Y',
    fontWeight: '500',
    // `name ›` — the trailing chevron visually separates each chip.
    // Every chip carries one so the rightmost chevron points toward
    // the CURRENT item (which isn't itself in the breadcrumb).
    text: (el)=>`${el.name || ''} \u{203A}`,
    ':hover': {
        color: 'blue'
    },
    onClick: (e, el)=>{
        const host = el.call('marketplaceHostOf', el);
        el.call('jumpToHistoryIndex', host, el._historyIndex);
    }
};

});

parcelRegister("54WKS", function(module, exports) {

$parcel$export(module.exports, "MarketplaceRecentItem", () => $3b2ae707defefeef$export$d354ce5806d16ec8);
// Compact row inside MarketplaceSidebar's RecentList — one per id
// in `host.recentIds`. Resolves the id to a catalog item inside the
// parent's `children` fn + spreads the item props, so this component
// receives `name`, `logo`, `kind`, etc. directly as el.* keys (same
// pattern as similar-item rows).
//
// Click opens detail via selectItemFresh (clears history — the
// recent list isn't a journey-entry, it's a leap back).
const $3b2ae707defefeef$export$d354ce5806d16ec8 = {
    flow: 'x',
    align: 'center',
    gap: 'Y',
    padding: 'X Y',
    borderRadius: 'Y',
    cursor: 'pointer',
    background: 'transparent',
    ':hover': {
        background: 'line'
    },
    // Native browser tooltip — shows the full description on hover
    // since the compact row only has space for the name.
    title: (el)=>el.description || el.name || '',
    onClick: (e, el)=>el.call('openDetailFromEl', el),
    RecentLogo: {
        align: 'center center',
        width: 'Y2',
        height: 'Y2',
        minWidth: 'Y2',
        borderRadius: 'X',
        overflow: 'hidden',
        fontWeight: '700',
        fontSize: 'X',
        background: (el)=>el.parent.logo ? 'white' : el.call('getKindAccent', el.parent.kind, 'bg'),
        color: (el)=>el.call('getKindAccent', el.parent.kind, 'fg'),
        RecentLogoImg: {
            hide: (el)=>!el.parent.parent.logo || el.parent._imgFailed,
            tag: 'img',
            src: (el)=>{
                const slug = el.parent.parent.logo;
                return slug ? `https://cdn.simpleicons.org/${slug}` : '';
            },
            alt: (el)=>el.parent.parent.name,
            width: '60%',
            height: '60%',
            objectFit: 'contain',
            onRender: (el)=>{
                if (!el.node) return;
                el.node.onerror = ()=>{
                    el.parent._imgFailed = true;
                    el.node.style.display = 'none';
                    const letter = el.parent.RecentLogoLetter;
                    if (letter?.node) letter.node.style.display = '';
                };
            }
        },
        RecentLogoLetter: {
            hide: (el)=>!!el.parent.parent.logo && !el.parent._imgFailed,
            tag: 'span',
            text: (el)=>(el.parent.parent.name || '')[0]?.toUpperCase() || '?'
        }
    },
    RecentName: {
        tag: 'span',
        text: (el)=>el.parent.name,
        fontSize: 'Y',
        color: 'paragraph',
        flex: '1',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }
};

});

parcelRegister("8cCSZ", function(module, exports) {

$parcel$export(module.exports, "MarketplaceResultsBar", () => $5f8d9bab5cf12fa9$export$3e2835cc1f4ce86a);
// Thin summary bar between the category filter row and the grid.
// Shows `X of Y items` when any filter is active, `Y items` at rest.
// Count mirrors MarketplaceGrid's children projection so the number
// matches what's actually rendered (see `resultsCountLabel` →
// `matchesFilters`).
const $5f8d9bab5cf12fa9$export$3e2835cc1f4ce86a = {
    flow: 'x',
    align: 'center',
    gap: 'Z',
    padding: 'Y A',
    borderBottom: '1px solid line',
    // Chip wrap on narrow viewports so the bar doesn't force horizontal
    // scroll when many filters are active.
    flexWrap: 'wrap',
    ResultsCountText: {
        tag: 'span',
        text: (el)=>{
            const host = el.call('marketplaceHostOf', el);
            return el.call('resultsCountLabel', host);
        },
        fontSize: 'Y',
        color: 'caption'
    },
    // Active-filter summary. Each chip is dismissable — click × (or
    // anywhere on the chip) to remove that filter. See
    // `activeFilterChips` + `removeFilterChip` in functions/index.js.
    ActiveChipList: {
        flow: 'x',
        align: 'center',
        gap: 'Y',
        flexWrap: 'wrap',
        children: (el)=>{
            const host = el.call('marketplaceHostOf', el);
            return el.call('activeFilterChips', host);
        },
        childExtends: 'MarketplaceFilterChip'
    }
};

});

parcelRegister("fn7Fn", function(module, exports) {

$parcel$export(module.exports, "MarketplaceFilterChip", () => $b30ef361ef27a617$export$f9ddea75736b2ed4);
// One dismissable summary chip rendered inside MarketplaceResultsBar.
// Each chip carries the spread result from `activeFilterChips`
// (`id` + `label`); click fires `removeFilterChip(host, id)` which
// branches by id prefix (`kind` / `pricing` / `query` / `cat:<value>`).
const $b30ef361ef27a617$export$f9ddea75736b2ed4 = {
    flow: 'x',
    align: 'center',
    gap: 'X',
    padding: 'X Y',
    borderRadius: 'Y',
    background: 'line',
    color: 'title',
    fontSize: 'Y',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    ':hover': {
        background: 'blue.2'
    },
    onClick: (e, el)=>{
        const host = el.call('marketplaceHostOf', el);
        el.call('removeFilterChip', host, el.id);
    },
    ChipLabel: {
        tag: 'span',
        text: (el)=>el.parent.label
    },
    ChipX: {
        tag: 'span',
        text: "\u2715",
        color: 'caption',
        fontSize: 'X'
    }
};

});

parcelRegister("aBrDT", function(module, exports) {

$parcel$export(module.exports, "MarketplaceShortcutsOverlay", () => $7b82cd4a23b6df45$export$14cba5298832b2e1);
$parcel$export(module.exports, "MarketplaceShortcutsRow", () => $7b82cd4a23b6df45$export$12227a9f64c8534d);
// Shortcut help overlay toggled by `?` (see `registerEscHandler` in
// functions/index.js). Centered modal-style card listing every
// marketplace keyboard shortcut. Click the backdrop or press Esc to
// close — Esc priority is handled in the global keydown listener so
// it beats the detail-pane Esc close when both are open.
const $7b82cd4a23b6df45$var$SHORTCUTS = [
    {
        keys: '/',
        label: 'Focus search'
    },
    {
        keys: "\u2318 K / Ctrl+K",
        label: 'Focus search'
    },
    {
        keys: 'Tab / Shift+Tab',
        label: 'Move between cards'
    },
    {
        keys: 'Enter / Space',
        label: 'Open focused item'
    },
    {
        keys: "\u2318 Enter / Ctrl+Enter",
        label: 'Install / Configure open item'
    },
    {
        keys: 'R',
        label: "Surprise me \u2014 open a random visible item"
    },
    {
        keys: 'P',
        label: 'Toggle pin on open detail'
    },
    {
        keys: 'S',
        label: 'Copy shareable URL to clipboard'
    },
    {
        keys: 'Esc',
        label: 'Close this help, then detail pane'
    },
    {
        keys: '?',
        label: 'Toggle this help'
    }
];
const $7b82cd4a23b6df45$export$14cba5298832b2e1 = {
    hide: (el)=>{
        const host = el.call('marketplaceHostOf', el);
        return !host?.shortcutsOpen;
    },
    // Fixed over the whole marketplace host so it floats above every
    // sibling — Island declares `position: relative` for the toast
    // already; the overlay uses absolute to match it but sizes to the
    // full host via inset 0.
    position: 'absolute',
    inset: '0',
    zIndex: '20',
    align: 'center center',
    background: 'black.55',
    backdropFilter: 'blur(4px)',
    // Click the backdrop (but not the inner card) to close.
    onClick: (e, el)=>{
        if (e.target !== el.node) return;
        const host = el.call('marketplaceHostOf', el);
        host?.update?.({
            shortcutsOpen: false
        });
    },
    ShortcutsCard: {
        flow: 'y',
        gap: 'A',
        padding: 'B',
        minWidth: 'H',
        maxWidth: 'I',
        borderRadius: 'A',
        background: 'dialog',
        border: '1px solid line',
        boxShadow: '0 A B black.35',
        CardTitle: {
            tag: 'h3',
            text: 'Keyboard shortcuts',
            fontSize: 'B',
            fontWeight: '700',
            color: 'title',
            margin: '0'
        },
        ShortcutsList: {
            flow: 'y',
            gap: 'Z',
            childExtends: 'MarketplaceShortcutsRow',
            children: $7b82cd4a23b6df45$var$SHORTCUTS
        },
        CloseHint: {
            tag: 'p',
            text: 'Press Esc or ? to close.',
            fontSize: 'Y',
            color: 'caption',
            margin: '0'
        }
    }
};
const $7b82cd4a23b6df45$export$12227a9f64c8534d = {
    flow: 'x',
    align: 'center space-between',
    gap: 'A',
    KeyCombo: {
        tag: 'span',
        text: (el)=>el.parent.keys,
        padding: 'X Z',
        borderRadius: 'Y',
        background: 'line',
        color: 'title',
        fontSize: 'Y',
        fontWeight: '600',
        whiteSpace: 'nowrap'
    },
    RowLabel: {
        tag: 'span',
        text: (el)=>el.parent.label,
        fontSize: 'Y',
        color: 'paragraph',
        flex: '1',
        textAlign: 'right'
    }
};

});

parcelRegister("hpfWl", function(module, exports) {

$parcel$export(module.exports, "PromptGalleryChip", () => $cac122cdbda18fe6$export$125c0a5a3b7b94e7);
// Filter chip for /prompt-gallery. Rendered via `MarketplaceFilters`-style
// pattern: parent passes `children: PROMPT_CATEGORIES` (object-keyed),
// so each chip element receives `el.key` (the category id) and the
// entry's `label` as a flat prop.
//
// Reads/writes `s.activeCategory` directly — `s` resolves to the page
// `state` block declared on `promptGallery`. Single-select (chip toggle
// replaces, doesn't union) — gallery is small enough that AND-style
// multi-select would just confuse the rail.
const $cac122cdbda18fe6$export$125c0a5a3b7b94e7 = {
    tag: 'button',
    type: 'button',
    flow: 'x',
    align: 'center center',
    gap: 'X',
    padding: 'Y A',
    borderRadius: 'D',
    border: '1px solid',
    cursor: 'pointer',
    fontSize: 'Y2',
    fontWeight: '600',
    whiteSpace: 'nowrap',
    transition: 'X defaultBezier background-color, X defaultBezier color, X defaultBezier border-color',
    background: (el, s)=>s.activeCategory === el.key ? 'blue' : 'transparent',
    color: (el, s)=>s.activeCategory === el.key ? 'white' : 'title',
    borderColor: (el, s)=>s.activeCategory === el.key ? 'blue' : 'line',
    ':hover': {
        borderColor: 'blue'
    },
    text: (el)=>el.label || el.key,
    onClick: (e, el, s)=>{
        s.update({
            activeCategory: el.key
        });
    }
};

});

parcelRegister("69pM8", function(module, exports) {

$parcel$export(module.exports, "PromptGalleryCard", () => $47a793ca1b9fb58e$export$f83bb7fbbca9fe26);
// Prompt card for /prompt-gallery. Rendered via `Grid.children` returning
// the PROMPTS array — each prompt object's properties (id, category,
// title, tagline, prompt) merge onto the card root, so children read
// them via `el.parent.X` (the standard MarketplaceCard pattern).
//
// "Copied!" feedback flashes through the page state key
// `_promptGalleryCopiedId` (set on click, cleared 1.6s later). Single
// shared key is fine because copying a second card before the first
// timer fires is exactly the case where the new flash should win.
const $47a793ca1b9fb58e$var$_flashCopied = (el, s, id)=>{
    s.update({
        _promptGalleryCopiedId: id
    });
    if (el.__copyTimer) clearTimeout(el.__copyTimer);
    el.__copyTimer = setTimeout(()=>{
        s.update({
            _promptGalleryCopiedId: null
        });
    }, 1600);
};
const $47a793ca1b9fb58e$export$f83bb7fbbca9fe26 = {
    flow: 'y',
    gap: 'Z',
    padding: 'A',
    borderRadius: 'A',
    border: '1px solid line',
    background: 'dialog',
    transition: 'Z defaultBezier border-color',
    ':hover': {
        borderColor: 'blue'
    },
    CardCategory: {
        tag: 'span',
        text: (el)=>{
            const id = el.parent.category;
            // Capitalize for display — categories are stored as kebab-case slugs.
            return id.replace(/-/g, ' ').replace(/\b\w/g, (c)=>c.toUpperCase());
        },
        fontSize: 'X',
        fontWeight: '600',
        color: 'blue',
        textTransform: 'uppercase',
        letterSpacing: 'X'
    },
    CardTitle: {
        tag: 'h4',
        margin: '0',
        fontSize: 'A',
        fontWeight: '700',
        color: 'title',
        text: (el)=>el.parent.title
    },
    CardTagline: {
        tag: 'p',
        margin: '0',
        fontSize: 'Y2',
        color: 'caption',
        lineHeight: '1.4',
        text: (el)=>el.parent.tagline
    },
    // Pre block keeps newlines/code fences in the prompt readable.
    // `whiteSpace: pre-wrap` lets long lines wrap; `maxHeight` + `overflow:
    // auto` caps height so the grid stays balanced — clicking Copy still
    // grabs the full prompt.
    CardPromptBox: {
        tag: 'pre',
        margin: '0',
        padding: 'Z',
        borderRadius: 'Z',
        background: 'document',
        border: '1px solid line',
        fontSize: 'Y',
        color: 'title',
        fontFamily: 'monospace',
        lineHeight: '1.5',
        whiteSpace: 'pre-wrap',
        overflow: 'auto',
        maxHeight: 'F',
        text: (el)=>el.parent.prompt
    },
    CardFooter: {
        flow: 'x',
        align: 'center space-between',
        gap: 'Z',
        marginTop: 'auto',
        CardCharCount: {
            tag: 'span',
            fontSize: 'X',
            color: 'caption',
            text: (el)=>`${el.parent.parent.prompt.length} chars`
        },
        CopyBtn: {
            extends: 'Button',
            type: 'button',
            text: (el, s)=>s._promptGalleryCopiedId === el.parent.parent.id ? 'Copied!' : 'Copy prompt',
            title: 'Copy prompt to clipboard',
            onClick: async (e, el, s)=>{
                e.stopPropagation();
                const card = el.parent.parent;
                const text = card.prompt;
                if (!text || typeof navigator === 'undefined') return;
                try {
                    await navigator.clipboard.writeText(text);
                    $47a793ca1b9fb58e$var$_flashCopied(el, s, card.id);
                } catch  {
                // Clipboard permission may be denied — silently no-op so the
                // user notices the click did nothing rather than a false success.
                }
            }
        }
    }
};

});


parcelRegister("aRHVO", function(module, exports) {

$parcel$export(module.exports, "KIND_ACCENT", () => $7e90ee7b24b5ffe5$export$29d29b2cad52f705);
$parcel$export(module.exports, "getKindAccent", () => $7e90ee7b24b5ffe5$export$8b14c59c35e752b9);
$parcel$export(module.exports, "isThumbKind", () => $7e90ee7b24b5ffe5$export$d694d31d5f5fe12b);
$parcel$export(module.exports, "isExternalServiceKind", () => $7e90ee7b24b5ffe5$export$680e363af3f9db8c);
$parcel$export(module.exports, "slugForId", () => $7e90ee7b24b5ffe5$export$336f22c0aad4048e);
$parcel$export(module.exports, "SIMPLEICONS_404", () => $7e90ee7b24b5ffe5$export$51fdc4c3fcec3f69);
$parcel$export(module.exports, "sanitiseIconSlug", () => $7e90ee7b24b5ffe5$export$fa7b7a36a21c8db);
$parcel$export(module.exports, "idForSlug", () => $7e90ee7b24b5ffe5$export$cfe24d2ff86afcbe);
$parcel$export(module.exports, "marketplaceHostOf", () => $7e90ee7b24b5ffe5$export$e0fe8faeb74c5ac2);
$parcel$export(module.exports, "sortItems", () => $7e90ee7b24b5ffe5$export$6b06fb9375cf2225);
$parcel$export(module.exports, "isCategoryActive", () => $7e90ee7b24b5ffe5$export$89db77de98034e0d);
$parcel$export(module.exports, "kindCount", () => $7e90ee7b24b5ffe5$export$d2f0f85fe8da1ad7);
$parcel$export(module.exports, "categoryCount", () => $7e90ee7b24b5ffe5$export$f6ed13d65e267d11);
$parcel$export(module.exports, "matchesFilters", () => $7e90ee7b24b5ffe5$export$752301f7aa22f3fd);
$parcel$export(module.exports, "hydrateLiveCatalog", () => $7e90ee7b24b5ffe5$export$a976bb8e8d68ea12);
$parcel$export(module.exports, "dispatchInstall", () => $7e90ee7b24b5ffe5$export$76cf8c97ef019739);
$parcel$export(module.exports, "installButtonText", () => $7e90ee7b24b5ffe5$export$b5f882e584fc8174);
$parcel$export(module.exports, "installButtonDisabled", () => $7e90ee7b24b5ffe5$export$324a63f1359e1dc);
$parcel$export(module.exports, "hydrateInstalledFromPrefs", () => $7e90ee7b24b5ffe5$export$c898a01490232a36);
$parcel$export(module.exports, "hydratePinnedFromPrefs", () => $7e90ee7b24b5ffe5$export$ffd6ba8a762c0b96);
$parcel$export(module.exports, "togglePin", () => $7e90ee7b24b5ffe5$export$14f2f3b8de00530c);
$parcel$export(module.exports, "isPinned", () => $7e90ee7b24b5ffe5$export$1466786e40868dda);
$parcel$export(module.exports, "clearPinned", () => $7e90ee7b24b5ffe5$export$529fd25de7586f6c);
$parcel$export(module.exports, "hydrateRecentFromPrefs", () => $7e90ee7b24b5ffe5$export$b49034169ef5111c);
$parcel$export(module.exports, "clearRecent", () => $7e90ee7b24b5ffe5$export$d0ef0d71a3b4ed0e);
$parcel$export(module.exports, "trackRecent", () => $7e90ee7b24b5ffe5$export$bd43f95a48ab53df);
$parcel$export(module.exports, "hydrateSortFromPrefs", () => $7e90ee7b24b5ffe5$export$e68aebb138146e65);
$parcel$export(module.exports, "persistSort", () => $7e90ee7b24b5ffe5$export$a500e0d08b69bc09);
$parcel$export(module.exports, "hydrateDensityFromPrefs", () => $7e90ee7b24b5ffe5$export$ec0e0e4b68c19ff);
$parcel$export(module.exports, "toggleGridDensity", () => $7e90ee7b24b5ffe5$export$4046bcb17848caf5);
$parcel$export(module.exports, "parseFiltersFromSearch", () => $7e90ee7b24b5ffe5$export$f400f8b25c79b066);
$parcel$export(module.exports, "hydrateFiltersFromLocation", () => $7e90ee7b24b5ffe5$export$3913f296596b7d9f);
$parcel$export(module.exports, "bindPopstateFilters", () => $7e90ee7b24b5ffe5$export$3defbcb72f1ed980);
$parcel$export(module.exports, "registerEscHandler", () => $7e90ee7b24b5ffe5$export$bc87eb37e8a5fabf);
$parcel$export(module.exports, "closeInstallModal", () => $7e90ee7b24b5ffe5$export$148922b34a27bd3d);
$parcel$export(module.exports, "closeDetail", () => $7e90ee7b24b5ffe5$export$244479cb6b33d791);
$parcel$export(module.exports, "focusSearchInput", () => $7e90ee7b24b5ffe5$export$e1f69f3cd9c6349a);
$parcel$export(module.exports, "installSelectedItem", () => $7e90ee7b24b5ffe5$export$eb25966eda3c7d3);
$parcel$export(module.exports, "surpriseMe", () => $7e90ee7b24b5ffe5$export$d11171b94e174fec);
$parcel$export(module.exports, "copyLinkToClipboard", () => $7e90ee7b24b5ffe5$export$7ace34f0f1e14a04);
$parcel$export(module.exports, "flashToast", () => $7e90ee7b24b5ffe5$export$64e543ce526ea9e2);
$parcel$export(module.exports, "undoInstall", () => $7e90ee7b24b5ffe5$export$32ca1285eddb4ec);
$parcel$export(module.exports, "dispatchInstallAndMark", () => $7e90ee7b24b5ffe5$export$1aa4ec2817ba68dc);
$parcel$export(module.exports, "openInstallableModal", () => $7e90ee7b24b5ffe5$export$3f6180825f28be87);
$parcel$export(module.exports, "submitInstallModal", () => $7e90ee7b24b5ffe5$export$7a9f8e92a90fc617);
$parcel$export(module.exports, "callCapabilityAndSet", () => $7e90ee7b24b5ffe5$export$b0b62e307f79b4ef);
$parcel$export(module.exports, "selectItemFresh", () => $7e90ee7b24b5ffe5$export$148ccffcc2abbed5);
$parcel$export(module.exports, "openDetailFromEl", () => $7e90ee7b24b5ffe5$export$ea722c6b908ba83f);
$parcel$export(module.exports, "selectItemWithHistory", () => $7e90ee7b24b5ffe5$export$8134de7f2ec35348);
$parcel$export(module.exports, "composeShareUrl", () => $7e90ee7b24b5ffe5$export$599bdd072218bd26);
$parcel$export(module.exports, "writeFiltersToUrl", () => $7e90ee7b24b5ffe5$export$15d321fad3bdd920);
$parcel$export(module.exports, "activeFilterChips", () => $7e90ee7b24b5ffe5$export$a60b13a15d8ccb53);
$parcel$export(module.exports, "removeFilterChip", () => $7e90ee7b24b5ffe5$export$ab90925518abd2cf);
$parcel$export(module.exports, "resultsCountLabel", () => $7e90ee7b24b5ffe5$export$3fa96c667ea7da39);
$parcel$export(module.exports, "hasActiveFilters", () => $7e90ee7b24b5ffe5$export$a15c90bdf31a4ff3);
$parcel$export(module.exports, "clearAllFilters", () => $7e90ee7b24b5ffe5$export$a718e009635f235b);
$parcel$export(module.exports, "toggleCategory", () => $7e90ee7b24b5ffe5$export$b3f9a24570744f2f);
$parcel$export(module.exports, "jumpToHistoryIndex", () => $7e90ee7b24b5ffe5$export$d2604060080e8b50);
$parcel$export(module.exports, "popSelectedHistory", () => $7e90ee7b24b5ffe5$export$8775840b16d7f38f);
parcelRequire("8eaF7");
var $cNJPN = parcelRequire("cNJPN");

var $h5wPI = parcelRequire("h5wPI");
const $7e90ee7b24b5ffe5$export$29d29b2cad52f705 = {
    library: {
        fg: 'blue',
        bg: 'blue.2'
    },
    template: {
        fg: 'green',
        bg: 'green.2'
    },
    integration: {
        fg: 'orange',
        bg: 'orange.2'
    },
    registrar: {
        fg: 'purple',
        bg: 'purple.2'
    },
    plugin: {
        fg: 'red',
        bg: 'red.2'
    }
};
const $7e90ee7b24b5ffe5$export$8b14c59c35e752b9 = (kind, slot)=>($7e90ee7b24b5ffe5$export$29d29b2cad52f705[kind] || $7e90ee7b24b5ffe5$export$29d29b2cad52f705.plugin)[slot];
const $7e90ee7b24b5ffe5$export$d694d31d5f5fe12b = (kind)=>kind === 'library' || kind === 'template';
const $7e90ee7b24b5ffe5$export$680e363af3f9db8c = (kind)=>kind === 'integration' || kind === 'registrar';
// Map marketplace catalogue `id` ↔ governance `integration_kinds.kind`.
// Default: strip the `int.` / `reg.` prefix, swap hyphens for underscores.
// Overrides cover kinds whose marketplace id doesn't match the canonical
// slug (supabase → supabase_project, ga4 → google_analytics).
const $7e90ee7b24b5ffe5$var$SLUG_OVERRIDES = {
    'int.ga4': 'google_analytics',
    'int.supabase': 'supabase_project',
    'int.s3': 'aws_s3',
    'int.r2': 'cloudflare_r2'
};
const $7e90ee7b24b5ffe5$var$SLUG_OVERRIDES_REVERSE = Object.fromEntries(Object.entries($7e90ee7b24b5ffe5$var$SLUG_OVERRIDES).map(([id, slug])=>[
        slug,
        id
    ]));
const $7e90ee7b24b5ffe5$export$336f22c0aad4048e = (id)=>{
    if ($7e90ee7b24b5ffe5$var$SLUG_OVERRIDES[id]) return $7e90ee7b24b5ffe5$var$SLUG_OVERRIDES[id];
    return String(id || '').replace(/^(int|reg|plg|tpl|lib)\./, '').replace(/-/g, '_');
};
const $7e90ee7b24b5ffe5$export$51fdc4c3fcec3f69 = new Set([
    'amazonwebservices',
    'amazons3',
    'openai',
    'slack',
    'twilio',
    'sendgrid',
    'segment',
    'neon',
    'workos',
    'pinecone',
    'logrocket',
    'uploadthing',
    'server',
    'mic' // generic name, not in simpleicons (livekit placeholder)
]);
const $7e90ee7b24b5ffe5$export$fa7b7a36a21c8db = (raw)=>{
    if (!raw || raw === 'undefined' || raw === 'null') return null;
    return $7e90ee7b24b5ffe5$export$51fdc4c3fcec3f69.has(raw) ? null : raw;
};
const $7e90ee7b24b5ffe5$export$cfe24d2ff86afcbe = (slug)=>$7e90ee7b24b5ffe5$var$SLUG_OVERRIDES_REVERSE[slug] || `int.${String(slug || '').replace(/_/g, '-')}`;
const $7e90ee7b24b5ffe5$var$_mergeCatalogues = (staticList, liveKinds)=>{
    const bySlug = new Map((liveKinds || []).map((k)=>[
            k.kind,
            k
        ]));
    const seen = new Set();
    const merged = staticList.map((item)=>{
        if (item.kind !== 'integration') return item;
        const slug = $7e90ee7b24b5ffe5$export$336f22c0aad4048e(item.id);
        const live = bySlug.get(slug);
        if (!live) return item;
        seen.add(slug);
        return {
            ...item,
            name: live.label || item.name,
            description: live.description || item.description,
            category: live.category || item.category,
            // Sanitise the DB icon slug: if it's in the known-404 denylist or
            // blank, fall back to the static catalog's logo (which is already
            // verified-good or absent). This prevents the DB overwriting a
            // working static logo with a 404 slug, and prevents entries that
            // had no static logo from emitting a broken <img>.
            logo: $7e90ee7b24b5ffe5$export$fa7b7a36a21c8db(live.icon) || item.logo || null,
            _liveKind: live
        };
    });
    for (const k of liveKinds || []){
        if (seen.has(k.kind)) continue;
        merged.push({
            id: $7e90ee7b24b5ffe5$export$cfe24d2ff86afcbe(k.kind),
            kind: 'integration',
            category: k.category || 'custom',
            name: k.label || k.kind,
            description: k.description || '',
            price: 0,
            // Null (not undefined) so template literals don't produce "undefined".
            logo: $7e90ee7b24b5ffe5$export$fa7b7a36a21c8db(k.icon) || null,
            _liveKind: k
        });
    }
    return merged;
};
const $7e90ee7b24b5ffe5$export$e0fe8faeb74c5ac2 = (el)=>{
    let cur = el;
    let lastWithState = null;
    while(cur){
        if (cur._marketplaceHost && cur.state) return cur.state;
        if (cur.state) lastWithState = cur;
        if (!cur.parent) break;
        cur = cur.parent;
    }
    return lastWithState?.state || el?.state || null;
};
// Score an item against a lowercase query. Higher = better match. Used
// to rank search results when activeSort === 'name' and query is
// non-empty. Buckets are deliberately coarse — ties break by alpha so
// the order is stable/predictable.
//   name starts with query          → 100
//   name has query at word boundary → 80   (e.g. "AWS S3" for query "s3")
//   name includes query anywhere    → 60
//   description includes query      → 20
//   no match                        → 0
const $7e90ee7b24b5ffe5$var$_searchScore = (item, q)=>{
    if (!q) return 0;
    const n = (item.name || '').toLowerCase();
    if (n.startsWith(q)) return 100;
    if (n.includes(` ${q}`) || n.includes(`-${q}`) || n.includes(`.${q}`)) return 80;
    if (n.includes(q)) return 60;
    const d = (item.description || '').toLowerCase();
    if (d.includes(q)) return 20;
    return 0;
};
const $7e90ee7b24b5ffe5$export$6b06fb9375cf2225 = (items, activeSort, query)=>{
    const mode = activeSort || 'name';
    const q = (query || '').trim().toLowerCase();
    if (mode === 'name' && q) return [
        ...items
    ].sort((a, b)=>{
        const diff = $7e90ee7b24b5ffe5$var$_searchScore(b, q) - $7e90ee7b24b5ffe5$var$_searchScore(a, q);
        if (diff !== 0) return diff;
        return (a.name || '').localeCompare(b.name || '');
    });
    if (mode === 'name') return [
        ...items
    ].sort((a, b)=>(a.name || '').localeCompare(b.name || ''));
    if (mode === 'priceAsc') return [
        ...items
    ].sort((a, b)=>(a.price || 0) - (b.price || 0));
    if (mode === 'priceDesc') return [
        ...items
    ].sort((a, b)=>(b.price || 0) - (a.price || 0));
    return items;
};
const $7e90ee7b24b5ffe5$export$89db77de98034e0d = (host, key)=>{
    const cats = Array.isArray(host?.activeCategories) ? host.activeCategories : [];
    return key === 'all' ? cats.length === 0 : cats.includes(key);
};
const $7e90ee7b24b5ffe5$export$d2f0f85fe8da1ad7 = (host, kind)=>{
    if (!host) return 0;
    const items = host.catalog || [];
    let count = 0;
    for (const item of items){
        if (host.activePricing === 'free' && item.price > 0) continue;
        if (host.activePricing === 'paid' && !(item.price > 0)) continue;
        if (host.activePricing === 'installed' && !(host.installed || []).includes(item.id)) continue;
        const q = (host.query || '').trim().toLowerCase();
        if (q) {
            const name = (item.name || '').toLowerCase();
            const desc = (item.description || '').toLowerCase();
            if (!name.includes(q) && !desc.includes(q)) continue;
        }
        if (kind === 'all' || item.kind === kind) count++;
    }
    return count;
};
const $7e90ee7b24b5ffe5$export$f6ed13d65e267d11 = (host, category)=>{
    if (!host) return 0;
    const items = host.catalog || [];
    let count = 0;
    for (const item of items){
        if (host.activeKind !== 'all' && item.kind !== host.activeKind) continue;
        if (host.activePricing === 'free' && item.price > 0) continue;
        if (host.activePricing === 'paid' && !(item.price > 0)) continue;
        if (host.activePricing === 'installed' && !(host.installed || []).includes(item.id)) continue;
        const q = (host.query || '').trim().toLowerCase();
        if (q) {
            const name = (item.name || '').toLowerCase();
            const desc = (item.description || '').toLowerCase();
            if (!name.includes(q) && !desc.includes(q)) continue;
        }
        if (category === 'all' || item.category === category) count++;
    }
    return count;
};
const $7e90ee7b24b5ffe5$export$752301f7aa22f3fd = (item, host)=>{
    if (!host) return true;
    if (host.activeKind !== 'all' && item.kind !== host.activeKind) return false;
    const cats = Array.isArray(host.activeCategories) ? host.activeCategories : [];
    if (cats.length > 0 && !cats.includes(item.category)) return false;
    if (host.activePricing === 'free' && item.price > 0) return false;
    if (host.activePricing === 'paid' && !(item.price > 0)) return false;
    if (host.activePricing === 'installed' && !(host.installed || []).includes(item.id)) return false;
    if (host.activePricing === 'pinned' && !(host.pinnedIds || []).includes(item.id)) return false;
    const q = (host.query || '').trim().toLowerCase();
    if (q) {
        const name = (item.name || '').toLowerCase();
        const desc = (item.description || '').toLowerCase();
        if (!name.includes(q) && !desc.includes(q)) return false;
    }
    return true;
};
// Read orgId straight from the Supabase session. Marketplace doesn't
// run the governance bridge's `subscribeAuthSession` flow, so
// `root.jwtClaims` never gets populated here — we must consult the
// session directly. Returns null when no session or client isn't ready.
const $7e90ee7b24b5ffe5$var$_sessionOrgId = async (mod)=>{
    const client = mod.getClient?.();
    if (!client?.auth?.getSession) return null;
    try {
        const { data: data } = await client.auth.getSession();
        return data?.session?.user?.app_metadata?.workspace_org_id || null;
    } catch  {
        return null;
    }
};
// Fetch catalogue (+ instances when authenticated) and merge into the
// static list. Keyed by orgId so switching workspaces refetches; anon
// and authenticated calls can both succeed without fighting each other.
const $7e90ee7b24b5ffe5$var$_runHydrate = async (root, mod)=>{
    if (!root || root._liveFetchInFlight) return;
    const orgId = await $7e90ee7b24b5ffe5$var$_sessionOrgId(mod);
    if (root._liveCatalogHydratedFor === (orgId || 'anon')) return;
    root._liveFetchInFlight = true;
    try {
        let kinds = [];
        let installedIds = [];
        if (orgId && mod.loadIntegrationCatalogue) {
            const hub = await mod.loadIntegrationCatalogue(orgId);
            kinds = hub?.kinds || [];
            installedIds = (hub?.integrations || []).map((i)=>$7e90ee7b24b5ffe5$export$cfe24d2ff86afcbe(i.kind));
            root._integrationHub = hub;
            // Mirror claims onto root so `_scopeParams` + any future marketplace
            // surface can read workspace_org_id / active_workspace_id without
            // re-fetching the session.
            const client = mod.getClient?.();
            if (client?.auth?.getSession) {
                const { data: data } = await client.auth.getSession();
                root._authClaims = data?.session?.user?.app_metadata || {};
            }
        } else if (mod.listIntegrationKinds) kinds = await mod.listIntegrationKinds() || [];
        root.update?.({
            catalog: $7e90ee7b24b5ffe5$var$_mergeCatalogues((0, $cNJPN.default), kinds),
            installed: installedIds,
            _liveCatalogHydratedFor: orgId || 'anon'
        });
    } catch  {
    // Silent fail — marketplace keeps serving the static list.
    } finally{
        root._liveFetchInFlight = false;
    }
};


const $7e90ee7b24b5ffe5$export$a976bb8e8d68ea12 = async (root)=>{
    if (!root || root._liveCatalogSubscribed) return;
    root._liveCatalogSubscribed = true;
    // Bridge gives `getClient`; integrations gives `loadIntegrationCatalogue`
    // / `listIntegrationKinds`. Merge so `_runHydrate` keeps its existing
    // single-`mod` shape without churn.
    const [bridge, integrations] = await Promise.all([
        Promise.resolve((parcelRequire("8RlGv"))),
        Promise.resolve((parcelRequire("e92gD")))
    ]);
    const mod = {
        ...bridge,
        ...integrations
    };
    await $7e90ee7b24b5ffe5$var$_runHydrate(root, mod);
    const client = mod.getClient?.();
    if (!client?.auth?.onAuthStateChange) return;
    client.auth.onAuthStateChange((event)=>{
        if (event === 'SIGNED_IN' || event === 'SIGNED_OUT' || event === 'TOKEN_REFRESHED') $7e90ee7b24b5ffe5$var$_runHydrate(root, mod);
    });
};
// Governance host resolution — portless in dev, us-at.symbols.app in
// prod. Cross-origin: marketplace's localStorage isn't shared with
// the workspace app, so the user authenticates on the other side on arrival.
const $7e90ee7b24b5ffe5$var$_workspaceUrl = (path)=>{
    if (typeof window === 'undefined') return path;
    const { protocol: protocol, hostname: hostname } = window.location;
    const isLocal = hostname === 'localhost' || hostname.endsWith('.localhost');
    const host = isLocal ? 'workspace.localhost:1355' : 'us-at.symbols.app';
    return `${protocol}//${host}${path}`;
};
const $7e90ee7b24b5ffe5$var$_NON_INTEGRATION_KINDS = new Set([
    'library',
    'template',
    'plugin',
    'registrar'
]);
// Resolve scope defaults from the live kind row + current workspace/
// project context. Governance pre-fills the scope picker so the user
// doesn't have to repeat what marketplace already knew. Reads from
// `root._authClaims` (mirrored during hydrate) since marketplace has no
// bridge-auth flow to populate `jwtClaims`.
const $7e90ee7b24b5ffe5$var$_scopeParams = (item, root)=>{
    const kind = item?._liveKind;
    const defaultScope = kind?.default_scope || 'org';
    const params = new URLSearchParams({
        install: '1',
        scopeType: defaultScope
    });
    const claims = root?._authClaims || {};
    if (defaultScope === 'workspace' && claims.active_workspace_id) params.set('scopeId', claims.active_workspace_id);
    if (defaultScope === 'project' && root?._activeProjectId) params.set('scopeId', root._activeProjectId);
    return params.toString();
};
const $7e90ee7b24b5ffe5$export$76cf8c97ef019739 = async (item, root)=>{
    const kind = item.kind;
    // Paid items: intercept before the free deep-link. `_liveKind.pricing`
    // is non-null when the seller opts into pricing (D13 resolution,
    // 2026-04-24 — migration 0075). Phase 2 wires Stripe Checkout here
    // via `purchaseIntegration` (§P5, blocked on first 3rd-party seller).
    // Today all 46 DB rows have pricing=NULL, so this branch never fires.
    if (item._liveKind?.pricing) {
        console.warn(`[marketplace] paid install for kind=${kind} (${item.id}) \u{2014} Stripe Checkout flow pending (\xa7P5/Phase 2)`);
        return {
            ok: false,
            reason: 'payment_pending',
            kind: kind,
            id: item.id,
            message: "Paid integrations coming soon \u2014 Checkout flow not yet wired."
        };
    }
    // Integrations + registrars share the governance admin-integrations
    // flow — both are external services with credentials, not project
    // assets. Registrars are `integration_kinds` rows with `category =
    // 'registrar'` (per INTEGRATIONS architecture) and governance's
    // `admin-integrations-generic` page renders the config form from
    // `config_schema` + branches UX on `ui_flow = 'registrar'` (shipped by
    // INTEGRATIONS in migration 0074). Unified route per DOMAIN's
    // 2026-04-24 response to my REQUEST → DOMAIN option A.
    if (kind === 'integration' || kind === 'registrar') {
        const slug = $7e90ee7b24b5ffe5$export$336f22c0aad4048e(item.id);
        const qs = root ? $7e90ee7b24b5ffe5$var$_scopeParams(item, root) : 'install=1';
        const url = $7e90ee7b24b5ffe5$var$_workspaceUrl(`/admin/integrations/${slug}?${qs}`);
        if (typeof window !== 'undefined') window.location.href = url;
        return {
            ok: true,
            kind: kind,
            id: item.id,
            routed_to: slug,
            url: url
        };
    }
    if ($7e90ee7b24b5ffe5$var$_NON_INTEGRATION_KINDS.has(kind)) return {
        ok: true,
        kind: kind,
        id: item.id
    };
    return {
        ok: false,
        reason: 'unknown kind'
    };
};
const $7e90ee7b24b5ffe5$export$b5f882e584fc8174 = (item, state)=>{
    if (!item) return '';
    if (state?.installing && state.installing === item.id) return "Installing\u2026";
    const installed = state?.installed?.includes(item.id);
    const external = $7e90ee7b24b5ffe5$export$680e363af3f9db8c(item.kind);
    const multi = item._liveKind?.allows_multiple;
    const paidKind = !!item._liveKind?.pricing;
    if (installed && external && multi) return 'Add another';
    if (installed && external) return 'Manage';
    if (installed) return 'Uninstall';
    // Paid kinds (DB row has non-null `pricing`, per D13 / migration 0075).
    // `metered` model means usage-based billing — the user still "installs"
    // the integration to connect it; billing starts after use. Don't
    // surface the billing model as a verb. `subscription` and one-time
    // `purchase` keep their distinct labels for future Phase 2 / 3rd-party
    // seller opt-in; metered falls through to the shared "Install" default.
    if (paidKind) {
        const model = item._liveKind?.pricing?.model;
        if (model === 'subscription') return 'Subscribe';
        if (model === 'metered') return 'Install';
        return 'Purchase';
    }
    // Both external (integration/registrar) and local non-paid kinds
    // use "Install" — external opens the scope modal, local installs directly.
    return item.price > 0 ? 'Purchase & Install' : 'Install';
};
const $7e90ee7b24b5ffe5$export$324a63f1359e1dc = (item, state)=>!!item && !!state?.installing && state.installing === item.id;
// localStorage key — list of marketplace item ids the user has installed.
// Per-origin persistence survives reloads but not cross-app; sdk-bridge's
// cookie-based `setPref` can't cross the `.localhost` public-suffix in
// dev, so we use localStorage directly. Will graduate to an SDK-level
// install contract (project updateProject({useLibraries})) once the
// editor-side install contract is wired up.
const $7e90ee7b24b5ffe5$var$INSTALLED_KEY = 'marketplace.installed';
const $7e90ee7b24b5ffe5$var$_readInstalled = ()=>{
    try {
        const raw = typeof localStorage !== 'undefined' && localStorage.getItem($7e90ee7b24b5ffe5$var$INSTALLED_KEY);
        if (!raw) return [];
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [];
    } catch  {
        return [];
    }
};
const $7e90ee7b24b5ffe5$var$_writeInstalled = (list)=>{
    try {
        localStorage.setItem($7e90ee7b24b5ffe5$var$INSTALLED_KEY, JSON.stringify(list));
    } catch  {}
};
const $7e90ee7b24b5ffe5$export$c898a01490232a36 = (root)=>{
    if (!root || root._installedHydrated) return;
    root._installedHydrated = true;
    const saved = $7e90ee7b24b5ffe5$var$_readInstalled();
    if (!saved.length) return;
    const merged = Array.from(new Set([
        ...root.installed || [],
        ...saved
    ]));
    root.update?.({
        installed: merged
    });
};
// Pinned-ids persistence — user-curated favorites, distinct from
// `installed` (added to project) and `recentIds` (auto-tracked).
// Persisted under `marketplace.pinnedIds`; hydrated on Grid mount.
// Unlike recents there's no cap — users decide what to pin, and
// they're few enough that a cap isn't necessary.
const $7e90ee7b24b5ffe5$var$PINNED_KEY = 'marketplace.pinnedIds';
const $7e90ee7b24b5ffe5$var$_readPinned = ()=>{
    try {
        const raw = typeof localStorage !== 'undefined' && localStorage.getItem($7e90ee7b24b5ffe5$var$PINNED_KEY);
        if (!raw) return [];
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [];
    } catch  {
        return [];
    }
};
const $7e90ee7b24b5ffe5$var$_writePinned = (list)=>{
    try {
        localStorage.setItem($7e90ee7b24b5ffe5$var$PINNED_KEY, JSON.stringify(list));
    } catch  {}
};
const $7e90ee7b24b5ffe5$export$ffd6ba8a762c0b96 = (host)=>{
    if (!host || host._pinnedHydrated) return;
    host._pinnedHydrated = true;
    const saved = $7e90ee7b24b5ffe5$var$_readPinned();
    if (!saved.length) return;
    host.update?.({
        pinnedIds: saved
    });
};
const $7e90ee7b24b5ffe5$export$14f2f3b8de00530c = (host, itemId)=>{
    if (!host || !itemId) return;
    const cur = Array.isArray(host.pinnedIds) ? host.pinnedIds : [];
    const next = cur.includes(itemId) ? cur.filter((id)=>id !== itemId) : [
        itemId,
        ...cur
    ];
    host.update?.({
        pinnedIds: next
    });
    $7e90ee7b24b5ffe5$var$_writePinned(next);
};
const $7e90ee7b24b5ffe5$export$1466786e40868dda = (host, itemId)=>{
    if (!host || !itemId) return false;
    const list = Array.isArray(host.pinnedIds) ? host.pinnedIds : [];
    return list.includes(itemId);
};
const $7e90ee7b24b5ffe5$export$529fd25de7586f6c = (host)=>{
    if (!host) return;
    host.update?.({
        pinnedIds: []
    });
    $7e90ee7b24b5ffe5$var$_writePinned([]);
};
// Recently-viewed list persistence — mirrors the installed-list
// pattern. Each `selectItemFresh`/`selectItemWithHistory` call
// tracks the item; sidebar renders up to `RECENT_LIMIT` items.
// localStorage key scoped per-origin same as installed.
const $7e90ee7b24b5ffe5$var$RECENT_KEY = 'marketplace.recentIds';
const $7e90ee7b24b5ffe5$var$RECENT_LIMIT = 8;
const $7e90ee7b24b5ffe5$var$_readRecent = ()=>{
    try {
        const raw = typeof localStorage !== 'undefined' && localStorage.getItem($7e90ee7b24b5ffe5$var$RECENT_KEY);
        if (!raw) return [];
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [];
    } catch  {
        return [];
    }
};
const $7e90ee7b24b5ffe5$var$_writeRecent = (list)=>{
    try {
        localStorage.setItem($7e90ee7b24b5ffe5$var$RECENT_KEY, JSON.stringify(list));
    } catch  {}
};
const $7e90ee7b24b5ffe5$export$b49034169ef5111c = (host)=>{
    if (!host || host._recentHydrated) return;
    host._recentHydrated = true;
    const saved = $7e90ee7b24b5ffe5$var$_readRecent();
    if (!saved.length) return;
    host.update?.({
        recentIds: saved
    });
};
const $7e90ee7b24b5ffe5$export$d0ef0d71a3b4ed0e = (host)=>{
    if (!host) return;
    host.update?.({
        recentIds: []
    });
    $7e90ee7b24b5ffe5$var$_writeRecent([]);
};
const $7e90ee7b24b5ffe5$export$bd43f95a48ab53df = (host, item)=>{
    if (!host || !item?.id) return;
    const prev = Array.isArray(host.recentIds) ? host.recentIds : [];
    const next = [
        item.id,
        ...prev.filter((id)=>id !== item.id)
    ].slice(0, $7e90ee7b24b5ffe5$var$RECENT_LIMIT);
    host.update?.({
        recentIds: next
    });
    $7e90ee7b24b5ffe5$var$_writeRecent(next);
};
// Sort preference persistence — mirrors the installed-list pattern.
// Reads `activeSort` from localStorage on mount; writes on every tab
// click via MarketplaceSortTab.onClick side-effect (below).
const $7e90ee7b24b5ffe5$var$SORT_KEY = 'marketplace.activeSort';
const $7e90ee7b24b5ffe5$var$VALID_SORTS = new Set([
    'name',
    'priceAsc',
    'priceDesc'
]);
const $7e90ee7b24b5ffe5$var$_readSort = ()=>{
    try {
        const raw = typeof localStorage !== 'undefined' && localStorage.getItem($7e90ee7b24b5ffe5$var$SORT_KEY);
        return $7e90ee7b24b5ffe5$var$VALID_SORTS.has(raw) ? raw : null;
    } catch  {
        return null;
    }
};
const $7e90ee7b24b5ffe5$var$_writeSort = (value)=>{
    try {
        localStorage.setItem($7e90ee7b24b5ffe5$var$SORT_KEY, String(value));
    } catch  {}
};
const $7e90ee7b24b5ffe5$export$e68aebb138146e65 = (host)=>{
    if (!host || host._sortHydrated) return;
    host._sortHydrated = true;
    const saved = $7e90ee7b24b5ffe5$var$_readSort();
    if (saved && saved !== host.activeSort) host.update?.({
        activeSort: saved
    });
};
const $7e90ee7b24b5ffe5$export$a500e0d08b69bc09 = (value)=>$7e90ee7b24b5ffe5$var$_writeSort(value);
// Grid density preference — 'comfortable' (default, 320px min +
// 'A' gap) or 'compact' (240px min + 'Z' gap). Stored in localStorage
// so it persists across reloads, mirrors the sort-persistence pattern.
const $7e90ee7b24b5ffe5$var$DENSITY_KEY = 'marketplace.gridDensity';
const $7e90ee7b24b5ffe5$var$VALID_DENSITIES = new Set([
    'comfortable',
    'compact'
]);
const $7e90ee7b24b5ffe5$var$_readDensity = ()=>{
    try {
        const raw = typeof localStorage !== 'undefined' && localStorage.getItem($7e90ee7b24b5ffe5$var$DENSITY_KEY);
        return $7e90ee7b24b5ffe5$var$VALID_DENSITIES.has(raw) ? raw : null;
    } catch  {
        return null;
    }
};
const $7e90ee7b24b5ffe5$var$_writeDensity = (value)=>{
    try {
        localStorage.setItem($7e90ee7b24b5ffe5$var$DENSITY_KEY, String(value));
    } catch  {}
};
const $7e90ee7b24b5ffe5$export$ec0e0e4b68c19ff = (host)=>{
    if (!host || host._densityHydrated) return;
    host._densityHydrated = true;
    const saved = $7e90ee7b24b5ffe5$var$_readDensity();
    if (saved && saved !== host.gridDensity) host.update?.({
        gridDensity: saved
    });
};
const $7e90ee7b24b5ffe5$export$4046bcb17848caf5 = (host)=>{
    if (!host) return;
    const next = host.gridDensity === 'compact' ? 'comfortable' : 'compact';
    host.update?.({
        gridDensity: next
    });
    $7e90ee7b24b5ffe5$var$_writeDensity(next);
};
const $7e90ee7b24b5ffe5$var$_arrEq = (a, b)=>Array.isArray(a) && Array.isArray(b) && a.length === b.length && a.every((x, i)=>x === b[i]);
const $7e90ee7b24b5ffe5$export$f400f8b25c79b066 = (0, $h5wPI.parseFiltersFromSearch);
// Apply a parsed filter diff to host state, resolving `_itemId`
// against the catalog into a proper `selectedItem` mutation. Shared
// by the Island-level URL reader and popstate handler.
const $7e90ee7b24b5ffe5$var$_applyFilterDiff = (host, parsed)=>{
    if (!host) return;
    const next = {
        ...parsed
    };
    if (next.activeKind === undefined) next.activeKind = 'all';
    const itemId = next._itemId;
    delete next._itemId;
    const currentItemId = host.selectedItem?.id || null;
    let itemDiff = null;
    if (itemId && itemId !== currentItemId) {
        const found = (host.catalog || []).find((i)=>i.id === itemId);
        if (found) itemDiff = {
            selectedItem: found,
            selectedHistory: []
        };
    } else if (!itemId && currentItemId) itemDiff = {
        selectedItem: null,
        selectedHistory: []
    };
    const diff = {};
    for (const [k, v] of Object.entries(next)){
        if (k === 'activeCategories') {
            if (!$7e90ee7b24b5ffe5$var$_arrEq(v, host[k])) diff[k] = v;
        } else if (host[k] !== v) diff[k] = v;
    }
    const merged = {
        ...diff,
        ...itemDiff || {}
    };
    if (Object.keys(merged).length > 0) host.update?.(merged);
};
const $7e90ee7b24b5ffe5$export$3913f296596b7d9f = (host)=>{
    if (!host || typeof window === 'undefined') return;
    const parsed = $7e90ee7b24b5ffe5$export$f400f8b25c79b066(window.location.search);
    $7e90ee7b24b5ffe5$var$_applyFilterDiff(host, parsed);
};
const $7e90ee7b24b5ffe5$export$3defbcb72f1ed980 = (host)=>{
    if (!host || typeof window === 'undefined') return;
    $7e90ee7b24b5ffe5$var$_lastMarketplaceHost = host;
    if (window.__marketplacePopstateBound) return;
    window.__marketplacePopstateBound = true;
    window.addEventListener('popstate', ()=>{
        const h = $7e90ee7b24b5ffe5$var$_lastMarketplaceHost;
        if (!h) return;
        const parsed = $7e90ee7b24b5ffe5$export$f400f8b25c79b066(window.location.search);
        $7e90ee7b24b5ffe5$var$_applyFilterDiff(h, parsed);
    });
};
// Module-level reference to the most recently mounted marketplace
// host. The global Escape listener below reads this to figure out
// which host's detail pane to close — mirrors the single-bound
// pattern used by `workspace/packages/shared/components/Modal.js`
// (window.__modalEscBound flag, single document listener, module-level
// top-element ref). Multiple marketplace embeds on the same page
// share the listener + always close the most recently mounted one.
let $7e90ee7b24b5ffe5$var$_lastMarketplaceHost = null;
const $7e90ee7b24b5ffe5$export$bc87eb37e8a5fabf = (host)=>{
    if (!host || typeof window === 'undefined') return;
    $7e90ee7b24b5ffe5$var$_lastMarketplaceHost = host;
    if (window.__marketplaceEscBound) return;
    window.__marketplaceEscBound = true;
    document.addEventListener('keydown', (e)=>{
        const h = $7e90ee7b24b5ffe5$var$_lastMarketplaceHost;
        if (!h) return;
        // Esc priority: (1) close install modal if open, (2) close shortcut
        // overlay if open, (3) close detail pane if open, (4) pass through.
        if (e.key === 'Escape') {
            if (h.installModal) {
                $7e90ee7b24b5ffe5$export$148922b34a27bd3d(h);
                e.preventDefault();
                return;
            }
            if (h.shortcutsOpen) {
                h.update?.({
                    shortcutsOpen: false
                });
                e.preventDefault();
                return;
            }
            if (h.selectedItem) {
                $7e90ee7b24b5ffe5$export$244479cb6b33d791(h);
                e.preventDefault();
                return;
            }
        }
        // '?' toggles the keyboard shortcut overlay. Skip when in an
        // input field so '?' remains typeable mid-query.
        const activeForShortcuts = document.activeElement;
        const inFieldForShortcuts = activeForShortcuts && /^(input|textarea)$/i.test(activeForShortcuts.tagName);
        if (e.key === '?' && !inFieldForShortcuts) {
            h.update?.({
                shortcutsOpen: !h.shortcutsOpen
            });
            e.preventDefault();
            return;
        }
        // '/' or Cmd/Ctrl+K focuses the marketplace search input. Skip
        // when already typing into an input/textarea so `/` remains usable
        // as literal text mid-query. Same convention used by GitHub /
        // Linear / etc.
        const active = document.activeElement;
        const inField = active && /^(input|textarea)$/i.test(active.tagName);
        const isSlash = e.key === '/' && !inField;
        const isCmdK = (e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k';
        if (isSlash || isCmdK) {
            $7e90ee7b24b5ffe5$export$e1f69f3cd9c6349a();
            e.preventDefault();
            return;
        }
        // Cmd/Ctrl+Enter triggers install on the open detail pane —
        // completes the keyboard flow Tab → Enter → Cmd+Enter → Esc.
        const isCmdEnter = (e.metaKey || e.ctrlKey) && e.key === 'Enter';
        if (isCmdEnter && h.selectedItem) {
            $7e90ee7b24b5ffe5$export$eb25966eda3c7d3(h);
            e.preventDefault();
            return;
        }
        // `R` opens a random visible item — fast serendipity shortcut,
        // companion to the 🎲 Surprise-me button. Skip when in a text
        // field so `r` stays typeable mid-query.
        if (e.key === 'r' && !inField && !e.metaKey && !e.ctrlKey && !e.altKey) {
            $7e90ee7b24b5ffe5$export$d11171b94e174fec(h);
            e.preventDefault();
            return;
        }
        // `P` toggles pin on the open detail item. No-op when no detail
        // is open — keeps `p` typeable outside the marketplace context.
        if (e.key === 'p' && !inField && !e.metaKey && !e.ctrlKey && !e.altKey) {
            if (h.selectedItem?.id) {
                $7e90ee7b24b5ffe5$export$14f2f3b8de00530c(h, h.selectedItem.id);
                e.preventDefault();
            }
            return;
        }
        // `S` copies the current shareable URL — faster than mousing to
        // the Copy-link button. Works regardless of whether a detail is
        // open (the URL composer includes item= when appropriate).
        if (e.key === 's' && !inField && !e.metaKey && !e.ctrlKey && !e.altKey) {
            $7e90ee7b24b5ffe5$export$7ace34f0f1e14a04(h);
            e.preventDefault();
        }
    });
};
const $7e90ee7b24b5ffe5$export$64e543ce526ea9e2 = (host, message, undoItemId)=>{
    if (!host) return;
    host.update?.({
        toastMessage: message || null,
        toastUndoItemId: undoItemId || null
    });
    setTimeout(()=>{
        // Guard: only clear if THIS toast is still showing. If another
        // toast fired in the meantime, its own timer owns the clear.
        if (host.toastMessage === message) host.update?.({
            toastMessage: null,
            toastUndoItemId: null
        });
    }, 4000);
};
const $7e90ee7b24b5ffe5$export$32ca1285eddb4ec = (host, itemId)=>{
    if (!host || !itemId) return;
    const installed = (host.installed || []).filter((id)=>id !== itemId);
    host.update?.({
        installed: installed,
        toastMessage: null,
        toastUndoItemId: null
    });
    $7e90ee7b24b5ffe5$var$_writeInstalled(installed);
};
const $7e90ee7b24b5ffe5$export$1aa4ec2817ba68dc = async (item, root)=>{
    if (!item || !root) return;
    const alreadyInstalled = (root.installed || []).includes(item.id);
    const external = $7e90ee7b24b5ffe5$export$680e363af3f9db8c(item.kind);
    const multi = item._liveKind?.allows_multiple;
    // Optimistic uninstall for local kinds — no network round-trip.
    if (alreadyInstalled && !external) {
        const installed = (root.installed || []).filter((id)=>id !== item.id);
        root.update({
            installed: installed
        });
        $7e90ee7b24b5ffe5$var$_writeInstalled(installed);
        return;
    }
    // Single-slot external already installed → route to governance to
    // manage the existing instance instead of duplicating it.
    if (alreadyInstalled && external && !multi) {
        await $7e90ee7b24b5ffe5$export$76cf8c97ef019739({
            ...item,
            _manage: true
        }, root);
        return;
    }
    // External kinds (integration / registrar): open the install modal so
    // the user selects org / workspace / project scope and fills the config
    // form without leaving the marketplace page. The modal's submit button
    // completes the actual install via saveIntegration (sdk-bridge) and
    // closes the modal — navigation only happens for "Manage" (above).
    if (external) {
        root.update({
            installModal: {
                item: item,
                step: 'scope',
                draft: {}
            }
        });
        return;
    }
    // Local kinds (library / template / plugin): optimistic install.
    const installed = Array.from(new Set([
        ...root.installed || [],
        item.id
    ]));
    root.update({
        installing: item.id
    });
    await $7e90ee7b24b5ffe5$export$76cf8c97ef019739(item, root);
    root.update({
        installing: null,
        installed: installed
    });
    $7e90ee7b24b5ffe5$var$_writeInstalled(installed);
    // Confirm + offer Undo.
    $7e90ee7b24b5ffe5$export$64e543ce526ea9e2(root, `Installed ${item.name || item.id}`, item.id);
};
const $7e90ee7b24b5ffe5$export$148922b34a27bd3d = (host)=>{
    if (!host) return;
    host.update?.({
        installModal: null,
        _installModalSaving: false,
        _installModalError: null,
        _scopeWsQuery: '',
        _scopeProjQuery: ''
    });
};

// ── Domain-aware write targets (Phase 4) ───────────────────────────────
//
// Maps domain → sdk-bridge call. Each domain has a distinct endpoint
// per INSTALLABLES_ARCHITECTURE.md Phase 4:
//
//   integration → POST /core/org-integrations  (existing saveIntegration)
//   library     → POST /core/library-attachments
//   mcp         → POST /core/mcp-connectors
//   plugin      → POST /core/plugin-installs
//   template    → triggers project clone (existing flow / scaffoldFromTemplate)
//
// All return { ok: bool, body: object }. Callers (submitInstallModal)
// call the correct dispatcher based on modal.domain or item.kind.
const $7e90ee7b24b5ffe5$var$_submitIntegrationDomain = async ({ orgId: orgId, kind: kind, slug: slug, displayName: displayName, config: config, secret: secret, scopeType: scopeType, scopeId: scopeId })=>{
    const { saveIntegration: saveIntegration } = await Promise.resolve((parcelRequire("e92gD")));
    const result = await saveIntegration({
        orgId: orgId,
        kind: kind,
        slug: slug,
        displayName: displayName,
        config: config,
        secret: secret || undefined,
        scopeType: scopeType,
        scopeId: scopeId,
        enabled: true
    });
    return result;
};

const $7e90ee7b24b5ffe5$var$_submitLibraryDomain = async ({ orgId: orgId, kind: kind, slug: slug, displayName: displayName, config: config, scopeType: scopeType, scopeId: scopeId })=>{
    // Library attachments — sdk-bridge endpoint: POST /core/library-attachments.
    // Stub for when the endpoint ships; falls back to saveIntegration shape
    // so the function contract remains consistent.
    try {
        const mod = await Promise.resolve((parcelRequire("8RlGv")));
        if (mod.attachLibrary) {
            const result = await mod.attachLibrary({
                orgId: orgId,
                kind: kind,
                slug: slug,
                displayName: displayName,
                config: config,
                scopeType: scopeType,
                scopeId: scopeId
            });
            return result;
        }
        // Fallback stub — treats the attachment as a local install
        return {
            ok: true,
            body: {
                kind: kind,
                slug: slug,
                displayName: displayName,
                scopeType: scopeType,
                scopeId: scopeId,
                domain: 'library'
            }
        };
    } catch  {
        return {
            ok: true,
            body: {
                kind: kind,
                slug: slug,
                displayName: displayName,
                scopeType: scopeType,
                scopeId: scopeId,
                domain: 'library'
            }
        };
    }
};

const $7e90ee7b24b5ffe5$var$_submitMcpDomain = async ({ orgId: orgId, kind: kind, slug: slug, displayName: displayName, config: config, scopeType: scopeType, scopeId: scopeId })=>{
    // MCP connectors — sdk-bridge endpoint: POST /core/mcp-connectors.
    // #4531 MCP connectors first-class depends on this for install UX.
    try {
        const mod = await Promise.resolve((parcelRequire("8RlGv")));
        if (mod.saveMcpConnector) {
            const result = await mod.saveMcpConnector({
                orgId: orgId,
                kind: kind,
                slug: slug,
                displayName: displayName,
                config: config,
                scopeType: scopeType,
                scopeId: scopeId
            });
            return result;
        }
        // Fallback stub — accepted by consuming surfaces until endpoint ships.
        return {
            ok: true,
            body: {
                kind: kind,
                slug: slug,
                displayName: displayName,
                scopeType: scopeType,
                scopeId: scopeId,
                domain: 'mcp'
            }
        };
    } catch  {
        return {
            ok: true,
            body: {
                kind: kind,
                slug: slug,
                displayName: displayName,
                scopeType: scopeType,
                scopeId: scopeId,
                domain: 'mcp'
            }
        };
    }
};

const $7e90ee7b24b5ffe5$var$_submitPluginDomain = async ({ orgId: orgId, kind: kind, slug: slug, displayName: displayName, config: config, scopeType: scopeType, scopeId: scopeId })=>{
    // Plugin installs — sdk-bridge endpoint: POST /core/plugin-installs.
    try {
        const mod = await Promise.resolve((parcelRequire("8RlGv")));
        if (mod.installPlugin) {
            const result = await mod.installPlugin({
                orgId: orgId,
                kind: kind,
                slug: slug,
                displayName: displayName,
                config: config,
                scopeType: scopeType,
                scopeId: scopeId
            });
            return result;
        }
        return {
            ok: true,
            body: {
                kind: kind,
                slug: slug,
                displayName: displayName,
                scopeType: scopeType,
                scopeId: scopeId,
                domain: 'plugin'
            }
        };
    } catch  {
        return {
            ok: true,
            body: {
                kind: kind,
                slug: slug,
                displayName: displayName,
                scopeType: scopeType,
                scopeId: scopeId,
                domain: 'plugin'
            }
        };
    }
};

const $7e90ee7b24b5ffe5$var$_submitTemplateDomain = async ({ orgId: orgId, kind: kind, slug: slug, displayName: displayName, config: config, scopeType: scopeType, scopeId: scopeId })=>{
    // Template — triggers project clone via scaffoldFromTemplate.
    // Existing flow shipped by #4408 scaffold-from-template.
    try {
        const mod = await Promise.resolve((parcelRequire("8RlGv")));
        if (mod.scaffoldFromTemplate) {
            const result = await mod.scaffoldFromTemplate({
                orgId: orgId,
                templateKind: kind,
                displayName: displayName,
                config: config,
                scopeType: scopeType,
                scopeId: scopeId
            });
            return result;
        }
        return {
            ok: true,
            body: {
                kind: kind,
                slug: slug,
                displayName: displayName,
                scopeType: scopeType,
                scopeId: scopeId,
                domain: 'template'
            }
        };
    } catch  {
        return {
            ok: true,
            body: {
                kind: kind,
                slug: slug,
                displayName: displayName,
                scopeType: scopeType,
                scopeId: scopeId,
                domain: 'template'
            }
        };
    }
};
// Route a submit payload to the correct domain dispatcher.
const $7e90ee7b24b5ffe5$var$_dispatchByDomain = (domain, payload)=>{
    switch(domain){
        case 'library':
            return $7e90ee7b24b5ffe5$var$_submitLibraryDomain(payload);
        case 'mcp':
            return $7e90ee7b24b5ffe5$var$_submitMcpDomain(payload);
        case 'plugin':
            return $7e90ee7b24b5ffe5$var$_submitPluginDomain(payload);
        case 'template':
            return $7e90ee7b24b5ffe5$var$_submitTemplateDomain(payload);
        case 'integration':
        default:
            return $7e90ee7b24b5ffe5$var$_submitIntegrationDomain(payload);
    }
};
// Resolve effective domain from modal opts, falling back to item.kind
// (marketplace catalog kind ≈ domain for integration/library/template/plugin;
// mcp is new and must come from opts.domain explicitly).
const $7e90ee7b24b5ffe5$var$_resolveDomain = (modal)=>{
    if (modal?.domain) return modal.domain;
    const kind = modal?.item?.kind;
    if (!kind) return 'integration';
    if (kind === 'registrar') return 'integration';
    return kind;
};
// ── catalogFilter validation ────────────────────────────────────────────
//
// Checks whether a catalogue item passes the catalogFilter provided in
// the modal opts. The filter is an object with optional keys:
//   category             – string; item.category must match
//   applicable_to_types  – string[]; item._liveKind?.applicable_to_types must overlap
//   applicable_to_scopes – string[]; item._liveKind?.applicable_to_scopes must overlap
//
// Returns null when the item passes, or an error message string when it fails.
const $7e90ee7b24b5ffe5$var$_checkCatalogFilter = (item, catalogFilter)=>{
    if (!catalogFilter || !item) return null;
    if (catalogFilter.category && item.category !== catalogFilter.category) return `This item is in the "${item.category}" category, not "${catalogFilter.category}".`;
    if (Array.isArray(catalogFilter.applicable_to_types) && catalogFilter.applicable_to_types.length > 0) {
        const itemTypes = item._liveKind?.applicable_to_types || [];
        const overlap = catalogFilter.applicable_to_types.some((t)=>itemTypes.includes(t));
        if (!overlap) return `This item does not apply to the required type(s): ${catalogFilter.applicable_to_types.join(', ')}.`;
    }
    if (Array.isArray(catalogFilter.applicable_to_scopes) && catalogFilter.applicable_to_scopes.length > 0) {
        const itemScopes = item._liveKind?.applicable_to_scopes || [];
        const overlap = catalogFilter.applicable_to_scopes.some((s)=>itemScopes.includes(s));
        if (!overlap) return `This item does not apply to the required scope(s): ${catalogFilter.applicable_to_scopes.join(', ')}.`;
    }
    return null;
};
const $7e90ee7b24b5ffe5$export$3f6180825f28be87 = function(opts) {
    const el = this;
    const domain = opts?.domain || null;
    const kind = opts?.kind || opts?.preselectedKind || null;
    const installed = !!opts?.installed;
    const defaultScope = opts?.defaultScope || null;
    const catalogFilter = opts?.catalogFilter || null;
    const onInstalled = typeof opts?.onInstalled === 'function' ? opts.onInstalled : null;
    // Resolve host via marketplaceHostOf (walks parent chain) or root state.
    let host = null;
    try {
        host = $7e90ee7b24b5ffe5$export$e0fe8faeb74c5ac2(el);
    } catch  {}
    if (!host) // Fallback: try root state (outside marketplace island)
    try {
        const root = el.getRoot?.();
        if (root?.state) host = root.state;
    } catch  {}
    if (!host) {
        console.warn("[openInstallableModal] Could not resolve host state \u2014 cannot open modal. opts:", opts);
        return;
    }
    // Find the item in catalogue by kind slug.
    let item = null;
    if (kind) {
        const catalog = host.catalog || [];
        item = catalog.find((i)=>{
            const s = $7e90ee7b24b5ffe5$export$336f22c0aad4048e(i.id);
            return s === kind || i.id === kind || i.id === `int.${kind}` || i.id === `plg.${kind}` || i.id === `lib.${kind}` || i.id === `tpl.${kind}`;
        });
        if (!item) {
            // Kind not found in catalogue — show modal with catalogError.
            host.update?.({
                installModal: {
                    item: {
                        name: kind,
                        id: kind,
                        kind: domain || 'integration'
                    },
                    step: 'config',
                    draft: {},
                    domain: domain,
                    defaultScope: defaultScope,
                    catalogFilter: catalogFilter,
                    onInstalled: onInstalled,
                    _catalogError: `"${kind}" is not available in the current catalogue. See /admin-integration-kinds if you need to add it.`
                },
                _installModalError: null
            });
            return;
        }
        // Validate catalogFilter against the found item.
        const filterError = $7e90ee7b24b5ffe5$var$_checkCatalogFilter(item, catalogFilter);
        if (filterError) {
            host.update?.({
                installModal: {
                    item: item,
                    step: 'config',
                    draft: {},
                    domain: domain,
                    defaultScope: defaultScope,
                    catalogFilter: catalogFilter,
                    onInstalled: onInstalled,
                    _catalogError: filterError
                },
                _installModalError: null
            });
            return;
        }
    }
    // Build initial draft — apply defaultScope if provided.
    const draft = {};
    if (defaultScope?.type) {
        draft.scopeType = defaultScope.type;
        if (defaultScope.id) draft.scopeId = defaultScope.id;
    } else if (item?._liveKind?.default_scope) draft.scopeType = item._liveKind.default_scope;
    // Determine opening step:
    //   - defaultScope pre-filled → jump to config step directly
    //   - installed + single-slot external → open config step for management
    //   - else → scope step
    const openStep = defaultScope || installed ? 'config' : 'scope';
    host.update?.({
        installModal: {
            item: item || null,
            step: openStep,
            draft: draft,
            domain: domain,
            defaultScope: defaultScope,
            catalogFilter: catalogFilter,
            onInstalled: onInstalled,
            _catalogError: null
        },
        _installModalError: null
    });
};
const $7e90ee7b24b5ffe5$export$7a9f8e92a90fc617 = async (host, el)=>{
    if (!host) return;
    const modal = host.installModal;
    if (!modal?.item) return;
    // Block submit when catalog error is present.
    if (modal._catalogError) {
        host.update?.({
            _installModalError: modal._catalogError
        });
        return;
    }
    const item = modal.item;
    const draft = modal.draft || {};
    const kindRow = item._liveKind || null;
    // Resolve orgId: marketplace mirrors _authClaims during hydrate;
    // governance populates jwtClaims via the bridge auth flow.
    const orgId = host._authClaims?.workspace_org_id || host.root?.jwtClaims?.workspace_org_id || null;
    if (!orgId) {
        host.update?.({
            _installModalError: 'No active organisation. Please sign in.'
        });
        return;
    }
    const fields = kindRow?.config_schema?.fields || [];
    for (const f of fields)if (f.required && !draft[f.key]) {
        host.update?.({
            _installModalError: `"${f.label || f.key}" is required.`
        });
        return;
    }
    const config = {};
    for (const f of fields)if (draft[f.key] != null && draft[f.key] !== '') config[f.key] = draft[f.key];
    const kind = item._liveKind?.kind || $7e90ee7b24b5ffe5$export$336f22c0aad4048e(item.id);
    const displayName = draft.displayName || config.display_name || kind;
    const slug = kindRow?.allows_multiple ? $7e90ee7b24b5ffe5$var$slugify(draft.slug || draft.displayName || kind) : 'default';
    // Scope — modal.defaultScope takes precedence over draft (pre-fill from caller).
    const preScope = modal.defaultScope;
    const scopeType = preScope?.type || draft.scopeType || kindRow?.default_scope || 'org';
    const scopeId = scopeType === 'org' ? null : preScope?.id || draft.scopeId || null;
    if ((scopeType === 'workspace' || scopeType === 'project') && !scopeId) {
        host.update?.({
            _installModalError: `Select or enter a ${scopeType} ID.`
        });
        return;
    }
    // Validate catalogFilter one more time at submit (defensive — UI should have
    // blocked earlier, but server-side catalogue may have changed).
    const filterError = $7e90ee7b24b5ffe5$var$_checkCatalogFilter(item, modal.catalogFilter);
    if (filterError) {
        host.update?.({
            _installModalError: filterError
        });
        return;
    }
    host.update?.({
        _installModalSaving: true,
        _installModalError: null
    });
    // Capture onInstalled before the state update wipes modal.
    const onInstalled = typeof modal.onInstalled === 'function' ? modal.onInstalled : null;
    // Resolve domain for write target.
    const domain = $7e90ee7b24b5ffe5$var$_resolveDomain(modal);
    try {
        const payload = {
            orgId: orgId,
            kind: kind,
            slug: slug,
            displayName: displayName,
            config: config,
            secret: draft.secret || undefined,
            scopeType: scopeType,
            scopeId: scopeId
        };
        const { ok: ok, body: body } = await $7e90ee7b24b5ffe5$var$_dispatchByDomain(domain, payload);
        if (ok) {
            const installed = Array.from(new Set([
                ...host.installed || [],
                item.id
            ]));
            host.update?.({
                installed: installed,
                _installModalSaving: false,
                installModal: null,
                _installModalError: null
            });
            $7e90ee7b24b5ffe5$var$_writeInstalled(installed);
            $7e90ee7b24b5ffe5$export$64e543ce526ea9e2(host, `Installed ${displayName}`, item.id);
            // Fire onInstalled callback AFTER server confirmation (post-confirm, not optimistic).
            // The server response body is passed as the instance so the caller receives
            // the persisted record.  onInstalled fires only when ok:true is returned by
            // _dispatchByDomain — there is no rollback path here.
            // AC5 note: spec originally described optimistic firing; the safer post-confirm
            // approach was chosen instead.  synchronous: false — fires after the host state
            // update that clears the modal, so any handler that re-reads installModal will
            // see it as null.
            if (onInstalled) try {
                onInstalled(body || {
                    kind: kind,
                    slug: slug,
                    displayName: displayName,
                    scopeType: scopeType,
                    scopeId: scopeId,
                    domain: domain
                });
            } catch  {}
            // Notify the canvas tab (and any other listening tab) that a new
            // integration was installed so it can refresh without a manual reload.
            // The canvas tab registers a `message` listener for this type — see
            // workspace/packages/canvas/pages/workspace.js (onInstallMessage).
            if (typeof window !== 'undefined') window.postMessage({
                type: 'symbols:integration-installed',
                kind: kind,
                orgId: orgId,
                domain: domain
            }, '*');
        } else host.update?.({
            _installModalSaving: false,
            _installModalError: body?.error || 'Install failed. Please try again.'
        });
    } catch (err) {
        host.update?.({
            _installModalSaving: false,
            _installModalError: err?.message || 'Unexpected error.'
        });
    }
};
// slugify helper for install modal (mirrors the one in IntegrationConfigureForm).
const $7e90ee7b24b5ffe5$var$slugify = (str)=>String(str || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 48) || 'default';
const $7e90ee7b24b5ffe5$export$eb25966eda3c7d3 = (host)=>{
    const item = host?.selectedItem;
    if (!item) return;
    return $7e90ee7b24b5ffe5$export$1aa4ec2817ba68dc(item, host);
};

const $7e90ee7b24b5ffe5$export$b0b62e307f79b4ef = async (inflightKey, resultKey, errorKey, capability, args, state)=>{
    if (!state) return {
        ok: false,
        error: 'no state provided'
    };
    state.update?.({
        [inflightKey]: true,
        [errorKey]: null
    });
    try {
        const mod = await Promise.resolve((parcelRequire("e92gD")));
        const orgId = state.orgId || state.root?._authClaims?.workspace_org_id || null;
        if (!orgId) {
            state.update?.({
                [inflightKey]: false,
                [errorKey]: 'not signed in to an organization'
            });
            return {
                ok: false,
                error: 'no orgId'
            };
        }
        const ref = {
            orgId: orgId,
            kind: state.kind,
            slug: state.slug || 'default',
            scopeType: state.scopeType || 'org',
            scopeId: state.scopeId ?? null
        };
        const res = await mod.callCapability?.(ref, capability, args);
        if (!res || res.ok === false || res.error) {
            state.update?.({
                [inflightKey]: false,
                [errorKey]: res?.error || 'capability call failed'
            });
            return res || {
                ok: false,
                error: 'no response'
            };
        }
        state.update?.({
            [inflightKey]: false,
            [resultKey]: res.result ?? res,
            [errorKey]: null
        });
        return res;
    } catch (err) {
        state.update?.({
            [inflightKey]: false,
            [errorKey]: err?.message || 'capability threw'
        });
        return {
            ok: false,
            error: err?.message || String(err)
        };
    }
};
const $7e90ee7b24b5ffe5$export$e1f69f3cd9c6349a = ()=>{
    if (typeof document === 'undefined') return;
    const input = document.querySelector('input[data-marketplace-search]');
    input?.focus?.();
    input?.select?.();
};
// Remembered focus target so `closeDetail` can return focus to the
// card/row the user opened, preserving the Tab loop for keyboard
// users. Mirrors the single-element pattern from Modal.js's
// `_topModalEl`.
let $7e90ee7b24b5ffe5$var$_lastFocusedBeforeDetail = null;
const $7e90ee7b24b5ffe5$export$d11171b94e174fec = (host)=>{
    if (!host) return;
    const catalog = host.catalog || [];
    const visible = catalog.filter((item)=>$7e90ee7b24b5ffe5$export$752301f7aa22f3fd(item, host));
    if (visible.length === 0) return;
    const pick = visible[Math.floor(Math.random() * visible.length)];
    $7e90ee7b24b5ffe5$export$148ccffcc2abbed5(host, pick);
};
const $7e90ee7b24b5ffe5$export$ea722c6b908ba83f = (el)=>{
    if (!el) return;
    const host = $7e90ee7b24b5ffe5$export$e0fe8faeb74c5ac2(el);
    if (typeof document !== 'undefined') $7e90ee7b24b5ffe5$var$_lastFocusedBeforeDetail = document.activeElement;
    $7e90ee7b24b5ffe5$export$148ccffcc2abbed5(host, {
        id: el.id,
        kind: el.kind,
        category: el.category,
        name: el.name,
        description: el.description,
        price: el.price,
        logo: el.logo,
        thumbnail: el.thumbnail,
        _liveKind: el._liveKind
    });
};
const $7e90ee7b24b5ffe5$export$244479cb6b33d791 = (host)=>{
    if (!host) return;
    host.update?.({
        selectedItem: null,
        selectedHistory: []
    });
    const prev = $7e90ee7b24b5ffe5$var$_lastFocusedBeforeDetail;
    $7e90ee7b24b5ffe5$var$_lastFocusedBeforeDetail = null;
    if (prev && typeof prev.focus === 'function') prev.focus();
};
const $7e90ee7b24b5ffe5$export$8134de7f2ec35348 = (host, nextItem)=>{
    if (!host || !nextItem) return;
    const cur = host.selectedItem;
    const stack = Array.isArray(host.selectedHistory) ? host.selectedHistory : [];
    host.update?.({
        selectedItem: nextItem,
        selectedHistory: cur ? [
            ...stack,
            cur
        ] : stack
    });
    $7e90ee7b24b5ffe5$export$bd43f95a48ab53df(host, nextItem);
};
const $7e90ee7b24b5ffe5$export$148ccffcc2abbed5 = (host, nextItem)=>{
    if (!host) return;
    host.update?.({
        selectedItem: nextItem || null,
        selectedHistory: []
    });
    if (nextItem) $7e90ee7b24b5ffe5$export$bd43f95a48ab53df(host, nextItem);
};
const $7e90ee7b24b5ffe5$export$599bdd072218bd26 = (host)=>{
    if (typeof window === 'undefined') return '';
    const sp = new URLSearchParams();
    if (host?.activeKind && host.activeKind !== 'all') sp.set('kind', host.activeKind);
    if (host?.activePricing && host.activePricing !== 'all') sp.set('pricing', host.activePricing);
    if (host?.activeSort && host.activeSort !== 'name') sp.set('sort', host.activeSort);
    const q = (host?.query || '').trim();
    if (q) sp.set('q', q);
    const cats = Array.isArray(host?.activeCategories) ? host.activeCategories : [];
    if (cats.length > 0) sp.set('categories', cats.join(','));
    if (host?.selectedItem?.id) sp.set('item', host.selectedItem.id);
    const qs = sp.toString();
    const { origin: origin, pathname: pathname } = window.location;
    return qs ? `${origin}${pathname}?${qs}` : `${origin}${pathname}`;
};
const $7e90ee7b24b5ffe5$export$15d321fad3bdd920 = (host)=>{
    if (!host || typeof window === 'undefined') return;
    const target = $7e90ee7b24b5ffe5$export$599bdd072218bd26(host);
    if (!target) return;
    const current = `${window.location.origin}${window.location.pathname}${window.location.search}`;
    if (target === current) return;
    const pathAndSearch = target.slice(window.location.origin.length);
    try {
        window.history.replaceState(window.history.state, '', pathAndSearch);
    } catch  {
    // replaceState can throw on cross-origin paths; our path is always
    // same-origin so this is defensive.
    }
};
const $7e90ee7b24b5ffe5$export$7ace34f0f1e14a04 = async (host)=>{
    if (!host || typeof navigator === 'undefined') return;
    const url = $7e90ee7b24b5ffe5$export$599bdd072218bd26(host);
    if (!url) return;
    try {
        await navigator.clipboard.writeText(url);
        host.update?.({
            linkCopyFlash: true
        });
        setTimeout(()=>host.update?.({
                linkCopyFlash: false
            }), 2000);
    } catch  {
    // No clipboard permission (rare on localhost) — leave flash off so
    // the user notices the click did nothing, rather than silently
    // claim success.
    }
};
const $7e90ee7b24b5ffe5$export$a60b13a15d8ccb53 = (host)=>{
    if (!host) return [];
    const chips = [];
    if (host.activeKind && host.activeKind !== 'all') chips.push({
        id: 'kind',
        label: `Kind: ${host.activeKind}`
    });
    const cats = Array.isArray(host.activeCategories) ? host.activeCategories : [];
    for (const cat of cats)chips.push({
        id: `cat:${cat}`,
        label: cat
    });
    if (host.activePricing && host.activePricing !== 'all') chips.push({
        id: 'pricing',
        label: host.activePricing
    });
    const q = (host.query || '').trim();
    if (q) chips.push({
        id: 'query',
        label: `"${q}"`
    });
    return chips;
};
const $7e90ee7b24b5ffe5$export$ab90925518abd2cf = (host, chipId)=>{
    if (!host || !chipId) return;
    if (chipId === 'kind') {
        host.update?.({
            activeKind: 'all'
        });
        return;
    }
    if (chipId === 'pricing') {
        host.update?.({
            activePricing: 'all'
        });
        return;
    }
    if (chipId === 'query') {
        host.update?.({
            query: ''
        });
        return;
    }
    if (chipId.startsWith('cat:')) {
        const cat = chipId.slice(4);
        const cur = Array.isArray(host.activeCategories) ? host.activeCategories : [];
        host.update?.({
            activeCategories: cur.filter((c)=>c !== cat)
        });
    }
};
const $7e90ee7b24b5ffe5$export$3fa96c667ea7da39 = (host)=>{
    if (!host) return '';
    const catalog = host.catalog || [];
    const total = catalog.length;
    if (total === 0) return '0 items';
    if (!$7e90ee7b24b5ffe5$export$a15c90bdf31a4ff3(host)) return `${total} ${total === 1 ? 'item' : 'items'}`;
    let visible = 0;
    for (const item of catalog)if ($7e90ee7b24b5ffe5$export$752301f7aa22f3fd(item, host)) visible++;
    return `${visible} of ${total} ${total === 1 ? 'item' : 'items'}`;
};
const $7e90ee7b24b5ffe5$export$a15c90bdf31a4ff3 = (host)=>{
    if (!host) return false;
    if (host.activeKind && host.activeKind !== 'all') return true;
    if (host.activePricing && host.activePricing !== 'all') return true;
    if (Array.isArray(host.activeCategories) && host.activeCategories.length > 0) return true;
    if ((host.query || '').trim()) return true;
    return false;
};
const $7e90ee7b24b5ffe5$export$a718e009635f235b = (host)=>{
    if (!host) return;
    host.update?.({
        activeKind: 'all',
        activePricing: 'all',
        activeCategories: [],
        query: ''
    });
};
const $7e90ee7b24b5ffe5$export$b3f9a24570744f2f = (host, key)=>{
    if (!host) return;
    if (key === 'all') {
        host.update?.({
            activeCategories: []
        });
        return;
    }
    const cur = Array.isArray(host.activeCategories) ? host.activeCategories : [];
    const next = cur.includes(key) ? cur.filter((c)=>c !== key) : [
        ...cur,
        key
    ];
    host.update?.({
        activeCategories: next
    });
};
const $7e90ee7b24b5ffe5$export$d2604060080e8b50 = (host, index)=>{
    if (!host) return;
    const history = Array.isArray(host.selectedHistory) ? host.selectedHistory : [];
    if (index < 0 || index >= history.length) return;
    const target = history[index];
    host.update?.({
        selectedItem: target,
        selectedHistory: history.slice(0, index)
    });
};
const $7e90ee7b24b5ffe5$export$8775840b16d7f38f = (host)=>{
    if (!host) return;
    const stack = Array.isArray(host.selectedHistory) ? host.selectedHistory : [];
    if (stack.length === 0) return;
    const prev = stack[stack.length - 1];
    host.update?.({
        selectedItem: prev,
        selectedHistory: stack.slice(0, -1)
    });
};

});

parcelRegister("21yLX", function(module, exports) {

var $52cYw = parcelRequire("52cYw");

var $bIBpJ = parcelRequire("bIBpJ");

var $9a79B = parcelRequire("9a79B");

var $6wNuf = parcelRequire("6wNuf");

var $g3ldd = parcelRequire("g3ldd");

var $c1JIl = parcelRequire("c1JIl");
$parcel$exportWildcard(module.exports, $52cYw);
$parcel$exportWildcard(module.exports, $bIBpJ);
$parcel$exportWildcard(module.exports, $9a79B);
$parcel$exportWildcard(module.exports, $6wNuf);
$parcel$exportWildcard(module.exports, $g3ldd);
$parcel$exportWildcard(module.exports, $c1JIl);

});
parcelRegister("52cYw", function(module, exports) {

$parcel$export(module.exports, "Scene", () => $3aa73446a7e3f134$export$38af1803e3442a7f);

var $hVlzD = parcelRequire("hVlzD");
const $3aa73446a7e3f134$var$DEVICES = {
    screenL: [
        1920,
        1024
    ],
    screenM: [
        1680,
        1024
    ],
    tabletL: [
        1366,
        926
    ],
    tabletS: [
        1024,
        768
    ],
    mobileXS: [
        375,
        768
    ]
};
const $3aa73446a7e3f134$export$38af1803e3442a7f = {
    extends: 'SceneTemplate',
    margin: '- auto',
    boxSize: '100%',
    position: 'relative',
    align: 'center center',
    padding: 0,
    A11yFilterDefs: {
        tag: 'svg',
        width: '0',
        height: '0',
        position: 'absolute',
        html: (0, $hVlzD.svgDefs)
    },
    IframeContainer: {
        // Outer clipping box wraps BOTH the app iframe and the design-system
        // iframe so device presets (previewSize) scale whichever is visible. Parent `Scene` is `align: center center` so the
        // container sits in the middle of the preview area. We size it to the
        // VISUAL (post-scale) footprint so it can never exceed the parent, no
        // matter which device preset is active. The inner `AppIframe` then
        // renders at the FULL device resolution and scales down via `transform`
        // so the embedded app's own media queries see the real device width
        // (e.g. 1920 for ScreenL, 375 for MobileXS) while the on-screen box
        // never overflows the preview.
        position: 'relative',
        flexShrink: '0',
        overflow: 'hidden',
        transition: 'A2 defaultBezier',
        transitionProperty: 'max-width, max-height, width, height, transform',
        style: (el, s)=>{
            const size = s.previewSize;
            const a11y = s.a11yFilter ? (0, $hVlzD.filters)[s.a11yFilter] : null;
            const filterStyle = {
                filter: a11y || 'none'
            };
            if (!size) return {
                width: '100%',
                height: '100%',
                ...filterStyle
            };
            if (size === 'resizable') return {
                width: '85%',
                height: '75%',
                resize: 'both',
                transition: 'none',
                ...filterStyle
            };
            const breakpoint = $3aa73446a7e3f134$var$DEVICES[size];
            if (!breakpoint) return {
                width: '100%',
                height: '100%',
                ...filterStyle
            };
            const [w, h] = breakpoint;
            const parent = el.node?.parentElement;
            const availW = parent ? parent.clientWidth : 1920;
            const availH = parent ? parent.clientHeight : 1080;
            const scale = Math.min(availW / w, availH / h, 1);
            return {
                width: Math.round(w * scale) + 'px',
                height: Math.round(h * scale) + 'px',
                ...filterStyle
            };
        },
        AppIframe: {
            tag: 'iframe',
            id: 'preview-app-iframe',
            border: '0',
            position: 'absolute',
            top: '0',
            left: '0',
            transformOrigin: '0 0',
            display: (_, s)=>s.viewMode === 'designSystem' ? 'none' : 'block',
            style: (el, s)=>$3aa73446a7e3f134$var$sizeForDevice(el, s),
            allow: 'accelerometer; camera; encrypted-media; geolocation; gyroscope; hid; microphone; midi; clipboard-write'
        },
        DesignSystemIframe: {
            tag: 'iframe',
            id: 'preview-ds-iframe',
            border: '0',
            position: 'absolute',
            top: '0',
            left: '0',
            transformOrigin: '0 0',
            display: (_, s)=>s.viewMode === 'designSystem' ? 'block' : 'none',
            style: (el, s)=>$3aa73446a7e3f134$var$sizeForDevice(el, s)
        }
    }
};
function $3aa73446a7e3f134$var$sizeForDevice(el, s) {
    const size = s.previewSize;
    if (!size || size === 'resizable') return {
        width: '100%',
        height: '100%',
        transform: 'none'
    };
    const bp = $3aa73446a7e3f134$var$DEVICES[size];
    if (!bp) return {
        width: '100%',
        height: '100%',
        transform: 'none'
    };
    const [w, h] = bp;
    const outer = el.parent?.node;
    const availW = outer?.parentElement ? outer.parentElement.clientWidth : 1920;
    const availH = outer?.parentElement ? outer.parentElement.clientHeight : 1080;
    const scale = Math.min(availW / w, availH / h, 1);
    return {
        width: w + 'px',
        height: h + 'px',
        transform: scale < 1 ? 'scale(' + scale + ')' : 'none'
    };
}

});

parcelRegister("bIBpJ", function(module, exports) {

$parcel$export(module.exports, "SceneTemplate", () => $8880d3668baf234a$export$4f26b12548d0d678);
const $8880d3668baf234a$export$4f26b12548d0d678 = {
    display: 'flex',
    round: 'A',
    padding: 'A',
    theme: (el)=>`scene @${el.getRootState('sceneTheme')}`,
    transition: 'B defaultBezier',
    transitionProperty: 'max-width, background',
    backdropFilter: 'blur(5px)',
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    position: 'relative',
    scene: {
        position: 'absolute',
        inset: '0 0 0 0',
        boxSize: '100%',
        round: 'A',
        flow: 'y',
        align: 'center center'
    },
    ':before': {
        content: '""',
        // Decoration-only layer — take out of flex flow so the real content
        // (IframeContainer) centers inside the preview box. Previously this
        // `:before` ran as a flex item with `width: 100%` and shoved every
        // sibling off-axis, which showed up as the iframe being right-aligned
        // at smaller device presets.
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        boxSizing: 'border-box',
        theme: (el)=>`dots @${el.getRootState('sceneTheme')}`,
        backgroundPosition: `top`,
        backgroundRepeat: `repeat`,
        backgroundSize: '20px 20px'
    }
};

});

parcelRegister("9a79B", function(module, exports) {

$parcel$export(module.exports, "SceneNavbar", () => $6aba98d87f4f0152$export$9645d10786ea8f63);
const $6aba98d87f4f0152$export$9645d10786ea8f63 = {
    minWidth: '-webkit-fill-available',
    Space: {
        if: (el)=>el.isEmbed(),
        width: 'B2',
        height: 'A'
    },
    NavbarButtonSet_copy: {
        padding: '0',
        Text: {
            ignoreChildExtends: true,
            text: '{{ key }}'
        },
        CopyButton: {
            value: (el, s)=>s.parent.key
        }
    },
    EditorTools: {
        margin: '- - - C1',
        color: 'dim',
        fontSize: 'Z1'
    },
    ResponsiveSwitching: {
        margin: '0 auto',
        color: 'dim',
        fontSize: 'Z1',
        align: 'center'
    },
    EditorPositionNavbar: {
        margin: '- A - -',
        isDisabled: (el)=>!Boolean(el.scope.componentEditor),
        '.isDisabled': {
            opacity: '.35',
            pointerEvents: 'none'
        }
    },
    NavbarButtonSet: {
        color: 'dim',
        fontSize: 'Z1',
        Fullscreen: {
            title: 'Fullscreen',
            icon: (el)=>!el.getRootState('isFullscreen') ? 'fullscreen' : 'fullscreen exit',
            onClick: async (ev, el)=>{
                const Canvas = el.getCanvas();
                await Canvas.call('toggleFullscreen');
                el.getRootState().isFullscreen = Boolean(document.fullscreenElement);
                el.update();
            }
        },
        Minimize: {
            title: 'Minimize',
            icon: 'minus',
            onClick: (ev, el)=>{
                el.activateChosen(null);
            }
        },
        Close: {
            title: 'Close',
            icon: 'crossmark',
            onClick: (ev, el, s)=>{
                el.activateChosen(null);
            }
        }
    },
    NavbarTooltip: {
        '&': {
            pointerEvents: 'none'
        }
    },
    extends: 'Navbar',
    width: 'max-content',
    padding: 'W X W Z2',
    position: 'relative',
    round: 'Z2 Z2 X2 X2',
    backdropFilter: 'none',
    alignSelf: 'start',
    borderWidth: '0',
    zIndex: 1001,
    height: 'auto',
    margin: '0',
    transform: 'translate3d(0, 0, 1px)',
    align: 'center space-between',
    fontSize: 'Y1',
    onClick: (ev)=>ev.stopPropagation()
};

});

parcelRegister("6wNuf", function(module, exports) {

$parcel$export(module.exports, "PreviewNavbar", () => $4c0c1e46193cc835$export$3e761320fc431861);
parcelRequire("8augU");
var $5SInI = parcelRequire("5SInI");

var $3WCJD = parcelRequire("3WCJD");

var $hVlzD = parcelRequire("hVlzD");

var $8ANMJ = parcelRequire("8ANMJ");
// Active indicator lives on the SVG sprite itself (filled vs outline)
// and on the icon's color — verified to render, unlike background, which
// this pipeline keeps stuck on the atomic-class value regardless of the
// rule specificity or `!important`.
const $4c0c1e46193cc835$var$paintToggleActive = (el, active)=>{
    if (!el?.node) return;
    const iconNode = el.Icon?.node;
    const useEl = iconNode?.querySelector('use');
    if (useEl) useEl.setAttribute('xlink:href', active ? '#sidebarLeftFill' : '#sidebarLeft');
    if (iconNode) {
        iconNode.style.color = active ? 'var(--color-title)' : '';
        iconNode.style.opacity = active ? '1' : '0.65';
    }
};
const $4c0c1e46193cc835$var$getProjectConfig = (el)=>{
    const doc = el.context?.document;
    if (!doc?.getElementById) return null;
    // Target whichever iframe is currently visible so the ThemeSwitcher
    // flips the theme of the app the user is looking at (project app in
    // `app` view, design-system app in `designSystem` view).
    const viewMode = el.getRootState?.()?.viewMode;
    const id = viewMode === 'designSystem' ? 'preview-ds-iframe' : 'preview-app-iframe';
    return doc.getElementById(id)?.__projectConfig;
};
// Dropdown open/close driven by root state.
// `DropdownField` alone renders the trigger shell; each specific dropdown
// guards its own `Dropdown` subtree with `if:` keyed off `openDropdown` on
// root state. `DropdownParent(Focus)` proved unreliable here because the
// `_op-0`/`_vis-hidden` atomic classes intercept opacity before the
// `:focus-within` rule can win, and inline style overrides fail the same
// way — something in the atomic-css pipeline short-circuits this element.
const $4c0c1e46193cc835$var$dropdownTrigger = (key)=>({
        extends: 'DropdownField',
        // `DropdownField.tag` is `<button>`. Nesting `<section>` (the Dropdown)
        // inside `<button>` is invalid HTML and Chrome seems to force-hide
        // descendants regardless of inline `!important` styles — verified by
        // finding no CSS rule that should beat the inline but computed still
        // showed `opacity:0; visibility:hidden` on the dropdown. Override to a
        // plain `<div>` so the nested section is valid.
        tag: 'div',
        theme: 'quaternary',
        padding: 'X X X Z2',
        align: 'center start',
        gap: 'X',
        fontSize: 'Z2',
        round: 'C',
        // Anchor the absolutely-positioned `Dropdown` subtree to the trigger —
        // otherwise it snaps to the viewport's left edge.
        position: 'relative',
        onClick: (ev, el)=>{
            if (ev.target.closest('[dropdown]')) return;
            const s = el.getRootState();
            s.update({
                openDropdown: s.openDropdown === key ? null : key
            });
        },
        Buttons: {
            margin: '- - - auto',
            Arrow: {
                theme: 'transparent'
            }
        }
    });
const $4c0c1e46193cc835$var$dropdownOpenIf = (key)=>(el)=>el.getRootState('openDropdown') === key;
const $4c0c1e46193cc835$var$closeDropdown = (el)=>el.getRootState().update({
        openDropdown: null
    });
// Don't inherit the default `Dropdown` component — its baked-in
// `opacity:0; visibility:hidden` atomic classes refuse to yield to even
// `!important` inline styles in this pipeline. Roll our own positioned
// panel and drive open/close via reactive `hide:` which DOMQL tracks.
const $4c0c1e46193cc835$var$dropdownVisible = (key)=>({
        extends: null,
        attr: {
            dropdown: true
        },
        position: 'absolute',
        top: '110%',
        right: '0',
        zIndex: 1000,
        theme: 'quaternary',
        padding: 'Y',
        round: 'Z2',
        flow: 'column',
        gap: 'X',
        minWidth: 'F1',
        transition: 'B defaultBezier',
        transitionProperty: 'transform, opacity',
        hide: (el)=>el.getRootState('openDropdown') !== key
    });

const $4c0c1e46193cc835$export$3e761320fc431861 = {
    extends: 'Navbar',
    // Hide the chrome when project data isn't loaded — the iframe Frame
    // doesn't exist, so the env switcher / sidebar toggle / sharing
    // affordances have nothing to operate on. PreviewErrorBoundary
    // renders its own minimal chrome (Logo + retry actions) instead.
    hide: (el, s)=>!!s.root?.fetchError,
    gap: 'A2',
    userSelect: 'none',
    theme: 'common-box',
    margin: 'X2 X2 -',
    round: 'C1',
    padding: 'X X2',
    // Override the shared Logo's default `position: fixed`; in the preview
    // navbar the logo flows inline with the other chrome buttons (sibling
    // of SidebarToggle / EnvSwitcher) instead of pinning to the viewport.
    Logo: {
        position: 'relative',
        top: 'auto',
        left: 'auto',
        zIndex: 'auto'
    },
    // Canvas link — opens the project in the canvas editor. Resolves
    // owner/key from URL params (preview can be reached either via
    // `?owner=X&key=Y` query or `{owner}--{key}.preview.symbols.app`
    // subdomain). Targets `canvas.localhost:1355` when previewing on
    // localhost; `edit.symbols.app` otherwise, matching the URLs the
    // `smbls publish` CLI prints. Propagates `?env=…` so clicking from a
    // preview of `staging` lands on the same env in canvas.
    CanvasLink: {
        tag: 'a',
        attr: {
            title: 'Open in Canvas editor'
        },
        padding: 'Y2',
        round: 'C1',
        background: 'transparent',
        cursor: 'pointer',
        color: 'currentColor',
        align: 'center center',
        transition: 'B defaultBezier',
        transitionProperty: 'background, color, opacity',
        opacity: 0.65,
        ':hover': {
            background: 'rgba(255,255,255,0.04)',
            opacity: 1
        },
        href: (el, s)=>{
            const { owner: owner, key: key } = (0, $8ANMJ.resolveProjectParams)();
            if (!owner || !key) return '#';
            const isLocal = window.location.hostname.endsWith('.localhost') || window.location.hostname === 'localhost';
            const origin = isLocal ? 'https://canvas.localhost:1355' : 'https://edit.symbols.app';
            const env = s?.root?.env || s?.env;
            const qs = env && env !== 'development' ? `?env=${env}` : '';
            return `${origin}/${owner}/${key}${qs}`;
        },
        target: '_blank',
        Icon: {
            extends: 'Icon',
            icon: 'layout',
            boxSize: 'A A'
        }
    },
    // Sidebar toggle — flips `root.sidebarOpen`. The explorer buttons
    // (Pages / Components / Design System) live inside `PreviewSidebar`
    // itself, not here.
    SidebarToggle: {
        // Rendered as a `<div role=button>` (not `<button>`) because Chrome's
        // UA form-control pipeline drops inline `!important` backgrounds on
        // native `<button>` elements in this context — same quirk we hit on
        // the dropdown visibility earlier. A styled div with role=button is
        // accessible and doesn't suffer the cascade override.
        tag: 'div',
        role: 'button',
        tabindex: '0',
        title: 'Toggle sidebar',
        padding: 'Y2',
        round: 'C1',
        background: 'transparent',
        cursor: 'pointer',
        color: 'currentColor',
        align: 'center center',
        transition: 'B defaultBezier',
        transitionProperty: 'background, color',
        ':hover': {
            background: 'rgba(255,255,255,0.04)'
        },
        // Paint the active state directly on the DOM node. Must use
        // `setProperty(..., 'important')` because the element's own atomic
        // `background: transparent` class beats inline styles in this
        // pipeline (same cascade quirk that forced the dropdown visibility
        // fix earlier).
        onRender: (el, s)=>{
            $4c0c1e46193cc835$var$paintToggleActive(el, !!s.root?.sidebarOpen);
        },
        onClick: (ev, el)=>{
            const s = el.getRootState();
            const nextOpen = !s.sidebarOpen;
            s.update({
                sidebarOpen: nextOpen
            });
            // Defer paint past DOMQL's reactive pass — calling immediately
            // loses the race (the post-state repaint clears our inline).
            setTimeout(()=>$4c0c1e46193cc835$var$paintToggleActive(el, nextOpen), 0);
        },
        Icon: {
            extends: 'Icon',
            icon: 'sidebarLeft',
            boxSize: 'A A'
        }
    },
    // Environment switcher — sits on the left next to the sidebar toggle.
    // Each option's `enabled` state is read off the loaded project's
    // `environments[envKey].enabled` flag. Disabled envs (either not on
    // the plan or explicitly turned off for this project) render dimmed
    // with an "Upgrade" suffix; clicking them opens the upgrade URL
    // instead of firing a doomed fetch.
    EnvSwitcher: {
        ...$4c0c1e46193cc835$var$dropdownTrigger('env'),
        Value: {
            Text: {
                text: (el, s)=>{
                    const env = s.env || 'development';
                    const label = env.charAt(0).toUpperCase() + env.slice(1);
                    return s.isLoadingProject ? `${label} \xb7 loading\u{2026}` : label;
                },
                opacity: (_, s)=>s.isLoadingProject ? '0.6' : '1'
            }
        },
        Dropdown: {
            ...$4c0c1e46193cc835$var$dropdownVisible('env'),
            ListInDropdown: {
                childrenAs: 'state',
                children: [
                    {
                        key: 'development',
                        text: 'Development'
                    },
                    {
                        key: 'production',
                        text: 'Production'
                    },
                    {
                        key: 'staging',
                        text: 'Staging'
                    }
                ],
                childProps: {
                    // Flips `.isActive` class on the currently-selected env so
                    // DropdownItem's existing cascade can light up the checkmark
                    // icon + bold the label. Falls back to `development` when
                    // root.env isn't yet set (initial render).
                    isActive: (el, s)=>(s.root?.env || 'development') === s.key,
                    // Flips `.isDisabled` class when the env isn't enabled on the
                    // loaded project — the class hook below dims it and opens the
                    // upgrade URL on click instead of firing a doomed fetch.
                    isDisabled: (el, s)=>{
                        const envs = s.root?.data?.environments;
                        if (!envs) return false;
                        const cfg = envs[s.key];
                        return !cfg || cfg.enabled === false;
                    },
                    '.isDisabled': {
                        opacity: '0.5',
                        cursor: 'not-allowed',
                        ':hover': {
                            opacity: '0.5'
                        }
                    },
                    // Reactive checkmark — DropdownItem's default `& svg { opacity:
                    // 0.5 }` cascade under `.isActive` gets outrun by Icon's own
                    // `opacity: 0` atomic class (same specificity, later applied).
                    // Setting opacity on the nested Icon here is what actually
                    // flips the checkmark for the selected env.
                    Icon: {
                        opacity: (el, s)=>(s.root?.env || 'development') === s.key ? '1' : '0'
                    },
                    // Append " · Upgrade" to the visible label when the env is
                    // disabled. Targets the nested `Text` slot rather than the
                    // button root — the root inherits `text` from the state, so
                    // setting `text` here would double up the label.
                    Text: {
                        text: (el, s)=>{
                            const envs = s.root?.data?.environments;
                            const cfg = envs?.[s.key];
                            const disabled = !!envs && (!cfg || cfg.enabled === false);
                            return disabled ? `${s.text} \xb7 Upgrade` : s.text || s.key;
                        }
                    },
                    onClick: async (ev, el, s)=>{
                        $4c0c1e46193cc835$var$closeDropdown(el);
                        const envs = s.root?.data?.environments;
                        const cfg = envs?.[s.key];
                        const disabled = !!envs && (!cfg || cfg.enabled === false);
                        if (disabled) {
                            // Take the user to the upgrade flow — same convention the
                            // InNewTab button uses for its owner/key URL resolution.
                            const params = new URLSearchParams(window.location.search);
                            const owner = params.get('owner') || '';
                            const key = params.get('key') || '';
                            const hash = owner && key ? `?owner=${owner}&key=${key}` : '';
                            window.open(`https://symbols.app/pricing${hash}`, '_blank', 'noopener');
                            return;
                        }
                        const rootState = el.getRootState();
                        if (rootState.env === s.key) return;
                        rootState.update({
                            env: s.key,
                            isLoadingProject: true
                        });
                        try {
                            const { getProjectData: getProjectData } = await Promise.resolve((parcelRequire("9PrrW")));
                            const project = await getProjectData({
                                env: s.key
                            });
                            rootState.update({
                                data: project,
                                isLoadingProject: false
                            }, {
                                forcePreviewUpdate: true
                            });
                        } catch (e) {
                            console.error('[preview] Failed to reload project:', e);
                            rootState.update({
                                isLoadingProject: false
                            });
                        }
                    }
                }
            }
        }
    },
    ResponsiveSwitching: {
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
        color: 'dim',
        fontSize: 'Z1',
        align: 'center',
        children: ()=>[
                {
                    key: 'screenL',
                    icon: 'deviceBigScreen',
                    title: "Large Screen (1920\xd71024)"
                },
                {
                    key: 'screenM',
                    icon: 'deviceSmallScreen',
                    title: "Medium Screen (1680\xd71024)"
                },
                {
                    key: 'tabletL',
                    icon: 'deviceTabletLandscape',
                    title: "Tablet Landscape (1366\xd7926)"
                },
                {
                    key: 'tabletS',
                    icon: 'deviceTabletPortrait',
                    title: "Tablet Portrait (1024\xd7768)"
                },
                {
                    key: 'mobileXS',
                    icon: 'deviceMobile',
                    title: "Mobile (375\xd7768)"
                },
                {
                    key: 'resizable',
                    icon: 'dimensionsAlt',
                    title: 'Resizable'
                }
            ],
        childProps: {
            title: (el, s)=>s.title,
            onClick: (ev, el, s)=>{
                const parent = el.parent;
                const scope = parent.scope;
                if (!scope) return;
                const newSize = scope.previewSize !== s.key ? s.key : null;
                scope.previewSize = newSize;
                // Update button icons
                for (const key of parent.__ref.__children){
                    const child = parent[key];
                    if (!child?.Icon?.node) continue;
                    const isActive = child.state.key === newSize;
                    const iconBase = child.state.icon;
                    const outlineId = iconBase + 'Outline';
                    const hasOutline = !!child.Icon.node.ownerDocument.getElementById(outlineId);
                    const spriteId = isActive ? iconBase : hasOutline ? outlineId : iconBase;
                    const useEl = child.Icon.node.querySelector('use');
                    if (useEl) useEl.setAttribute('xlink:href', '#' + spriteId);
                    child.update();
                }
                el.getRootState().update({
                    previewSize: newSize
                });
            }
        }
    },
    ThemeSwitcher: {
        extends: 'NavbarButtonSet',
        margin: '- - - auto',
        gap: 'W2',
        childrenAs: 'state',
        children: [
            {
                key: 'light',
                icon: 'sun',
                title: 'Light mode'
            },
            {
                key: 'dark',
                icon: 'moon',
                title: 'Dark mode'
            }
        ],
        childProps: {
            theme: 'sepia',
            title: (el, s)=>s.title,
            icon: (el, s)=>el.getRootState('sceneTheme') === s.key ? s.icon : s.icon + ' outline',
            isActive: (el, s)=>el.getRootState('sceneTheme') === s.key,
            onClick: (ev, el, s)=>{
                const newKey = s.key;
                el.getRootState().update({
                    sceneTheme: newKey
                });
                const cfg = $4c0c1e46193cc835$var$getProjectConfig(el);
                if (cfg) (0, $5SInI.changeGlobalTheme)(newKey, cfg);
                // Mirror ResponsiveSwitching: swap sprite hrefs manually since
                // reactive icon props don't re-evaluate on parent state change.
                const parent = el.parent;
                for (const k of parent.__ref.__children){
                    const child = parent[k];
                    if (!child?.Icon?.node) continue;
                    const base = child.state.icon;
                    const outlineId = base + 'Outline';
                    const isActive = child.state.key === newKey;
                    const ownerDoc = child.Icon.node.ownerDocument;
                    const hasOutline = !!ownerDoc.getElementById(outlineId);
                    const spriteId = isActive ? base : hasOutline ? outlineId : base;
                    const useEl = child.Icon.node.querySelector('use');
                    if (useEl) useEl.setAttribute('xlink:href', '#' + spriteId);
                }
            }
        }
    },
    A11yFilter: {
        ...$4c0c1e46193cc835$var$dropdownTrigger('a11y'),
        title: 'Accessibility simulation',
        StartButtons: {
            children: [
                {
                    icon: 'accessibility'
                }
            ]
        },
        Value: {
            Text: {
                text: (el, s)=>{
                    const active = s.a11yFilter || 'none';
                    return (0, $hVlzD.options).find((o)=>o.key === active)?.label || 'None';
                }
            }
        },
        Dropdown: {
            ...$4c0c1e46193cc835$var$dropdownVisible("a11y"),
            ListInDropdown: {
                childrenAs: 'state',
                children: (0, $hVlzD.options).map((o)=>({
                        key: o.key,
                        text: o.label
                    })),
                childProps: {
                    onClick: (ev, el, s)=>{
                        $4c0c1e46193cc835$var$closeDropdown(el);
                        const val = s.key;
                        el.getRootState().update({
                            a11yFilter: val === 'none' ? null : val
                        });
                    }
                }
            }
        }
    },
    Meta: {
        extends: 'NavbarButtonSet',
        gap: 'W2',
        InNewTab: {
            icon: 'sf arrow up right',
            title: 'Open in new tab',
            // URL composition lives in @symbo.ls/channels mermaidUrl —
            // composes user-env (`--<env>` segment) + system-env (channel
            // apex) into the canonical published URL. Same source the
            // Mermaid edge worker, CLI publish, and project cards use.
            onClick: (ev, el, s)=>{
                const { owner: owner, key: key } = (0, $8ANMJ.resolveProjectParams)();
                if (!owner || !key) return;
                const env = s.env || 'production';
                const url = (0, $3WCJD.mermaidUrl)({
                    owner: owner,
                    key: key,
                    env: env
                }, (0, $3WCJD.currentChannel)());
                if (url) window.open(url);
            }
        },
        CodeToggle: {
            hide: true,
            icon: 'code',
            round: 'C1',
            padding: 'Y2',
            '.isCodeOpen': {
                theme: 'navbarButton-active'
            },
            isCodeOpen: (_, s)=>s.isCodeOpen,
            onClick: (ev, el, s)=>{
                s.update({
                    isCodeOpen: !s.isCodeOpen
                });
                el.getRoot().update();
            }
        }
    }
};

});

parcelRegister("g3ldd", function(module, exports) {

$parcel$export(module.exports, "DS_PAGES", () => $bafd6174f417a959$export$e39db91b3f7376e9);
$parcel$export(module.exports, "PreviewSidebar", () => $bafd6174f417a959$export$4583b0ee0e0b8b81);
// Left-hand sidebar mounted inside the main Content flex row so opening
// it shrinks the Scene's width rather than overlaying.
//
// Layout:
//   [CategoryNavbar]  — icon-only row, mirrors ResponsiveSwitching
//   [active list]     — Pages | Components | DesignSystemPages
//
// State contract:
//   root.sidebarOpen       → slide in/out (via `hide:`)
//   root.explorerContent   → which category list is shown
//   root.activePage        → currently-previewed page route
//   root.activeComponent   → currently-previewed component key
//   root.dsPage            → currently-picked ds sub-page
const $bafd6174f417a959$export$e39db91b3f7376e9 = [
    {
        key: 'colors',
        icon: 'color',
        title: 'Colors',
        dsPage: '/colors'
    },
    {
        key: 'typography',
        icon: 'typography',
        title: 'Typography',
        dsPage: '/typography'
    },
    {
        key: 'spacing',
        icon: 'space',
        title: 'Spacing',
        dsPage: '/spacing'
    },
    {
        key: 'icons',
        icon: 'star',
        title: 'Icons',
        dsPage: '/icons'
    },
    {
        key: 'transitions',
        icon: 'play',
        title: 'Transitions',
        dsPage: '/transitions'
    },
    {
        key: 'layout',
        icon: 'grid',
        title: 'Layout',
        dsPage: '/layout'
    },
    {
        key: 'misc',
        icon: 'settings',
        title: 'Misc',
        dsPage: '/misc'
    }
];
// Mirrors the ResponsiveSwitching shape: each entry carries its own
// sprite id. Icons with an `Outline` variant toggle filled↔outline on
// active like ResponsiveSwitching does; the rest fall back to a theme
// swap.
// Icons paired with explicit `Outline` variants so the active-state
// sprite swap has somewhere to go (pages↔pagesOutline,
// layers↔layersOutline, color↔colorOutline).
const $bafd6174f417a959$var$CATEGORIES = [
    {
        key: 'pages',
        icon: 'pages',
        title: 'Pages'
    },
    {
        key: 'components',
        icon: 'layers',
        title: 'Components'
    },
    {
        key: 'designSystem',
        icon: 'color',
        title: 'Design System'
    }
];
const $bafd6174f417a959$var$navigateIframeTo = (el, route)=>{
    const doc = el.context?.document || document;
    const iframe = doc.getElementById('preview-app-iframe');
    const iwin = iframe?.contentWindow;
    if (!iwin) return;
    try {
        iwin.history.pushState(null, '', route);
        iwin.dispatchEvent(new iwin.PopStateEvent('popstate'));
    } catch (e) {
        console.warn('[PreviewSidebar] iframe navigation failed:', e);
    }
};

const $bafd6174f417a959$var$ensureDsEmbedded = async (el, initialState)=>{
    const doc = el.context?.document || document;
    const rootEl = el.getRoot();
    const data = rootEl?.state?.data;
    if (!data) return null;
    let iframe = null;
    for(let i = 0; i < 20; i++){
        iframe = doc.getElementById('preview-ds-iframe');
        if (iframe) break;
        await new Promise((r)=>setTimeout(r, 50));
    }
    if (!iframe) return null;
    const { embedDesignSystem: embedDesignSystem } = await Promise.resolve((parcelRequire("iun8M")));
    await embedDesignSystem(iframe, data, initialState);
    return iframe;
};

const $bafd6174f417a959$var$previewComponent = async (el, key)=>{
    const doc = el.context?.document || document;
    const rootEl = el.getRoot();
    if (!rootEl?.state?.data) return;
    if (rootEl.state.viewMode === 'designSystem') {
        rootEl.state.update({
            viewMode: 'app'
        });
        if (rootEl.Scene) rootEl.Scene.update();
    }
    const iframe = doc.getElementById('preview-app-iframe');
    if (!iframe) return;
    const { embedComponent: embedComponent } = await Promise.resolve((parcelRequire("iun8M")));
    await embedComponent(iframe, rootEl.state.data, {
        key: key
    });
};
// Swap Icon sprite href between filled and outline on sibling children,
// matching ResponsiveSwitching. Skips children whose `icon` has no
// `iconOutline` variant (e.g. `sfComponents`).
const $bafd6174f417a959$var$swapSiblingIcons = (parent, activeKey)=>{
    for (const childKey of parent.__ref?.__children || []){
        const child = parent[childKey];
        if (!child?.Icon?.node) continue;
        const base = child.state?.icon;
        if (!base) continue;
        const outlineId = base + 'Outline';
        const ownerDoc = child.Icon.node.ownerDocument;
        const hasOutline = !!ownerDoc.getElementById(outlineId);
        const isActive = child.state?.key === activeKey;
        const spriteId = isActive ? base : hasOutline ? outlineId : base;
        const useEl = child.Icon.node.querySelector('use');
        if (useEl) useEl.setAttribute('xlink:href', '#' + spriteId);
    }
};
// Pretty list-row. Active-state done via direct DOM class toggle in
// onClick (rather than reactive factories) because DOMQL v3.14's signal
// system doesn't track mutations to parent-scope plain objects, so
// sibling re-renders don't see updated `scope.activeKey` values. Same
// visual result, without the dependency-tracking fragility.
const $bafd6174f417a959$var$ACTIVE_BG = 'rgba(255,255,255,0.08)';
const $bafd6174f417a959$var$HOVER_BG = 'rgba(255,255,255,0.04)';
const $bafd6174f417a959$var$applyActiveStyles = (node, active)=>{
    if (!node) return;
    node.style.background = active ? $bafd6174f417a959$var$ACTIVE_BG : '';
    node.style.color = active ? 'var(--color-title)' : 'var(--color-caption)';
};
const $bafd6174f417a959$var$listRow = ({ keyOf: keyOf, iconFn: iconFn, textFn: textFn, onClick: onClick })=>({
        tag: 'button',
        type: 'button',
        flow: 'x',
        align: 'center',
        gap: 'Y',
        padding: 'Y Z',
        round: 'Z',
        border: 'none',
        cursor: 'pointer',
        textAlign: 'left',
        fontSize: 'Z',
        background: 'transparent',
        color: 'caption',
        transition: 'B defaultBezier',
        transitionProperty: 'background, color',
        ':hover': {
            background: $bafd6174f417a959$var$HOVER_BG,
            color: 'title'
        },
        // First paint: if the parent list already has a seeded active key,
        // apply the active styling directly to the matching node.
        onRender: (el, s)=>{
            const activeKey = el.parent?.scope?.activeKey;
            if (activeKey != null && activeKey === keyOf(s)) $bafd6174f417a959$var$applyActiveStyles(el.node, true);
        },
        Icon: iconFn ? {
            extends: 'Icon',
            icon: iconFn,
            boxSize: 'Z2',
            opacity: '0.75'
        } : null,
        Label: {
            tag: 'span',
            flex: '1',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: textFn
        },
        onClick (ev, el, s) {
            const parent = el.parent;
            const myKey = keyOf(s);
            // Sweep siblings back to default, light up the clicked node.
            for (const k of parent?.__ref?.__children || []){
                const child = parent[k];
                if (!child?.node) continue;
                $bafd6174f417a959$var$applyActiveStyles(child.node, child === el);
            }
            if (parent?.scope) parent.scope.activeKey = myKey;
            return onClick?.(ev, el, s);
        }
    });
const $bafd6174f417a959$export$4583b0ee0e0b8b81 = {
    extends: 'AppSidebar',
    hide: (el, s)=>!s.root?.sidebarOpen,
    width: 'F2',
    minWidth: 'F2',
    fontSize: 'Z',
    padding: '0',
    gap: '0',
    Content: {
        flex: '1',
        overflow: 'auto',
        flow: 'column',
        gap: '0',
        padding: '0',
        // Category navbar — mirrors ResponsiveSwitching exactly:
        //   extends: 'NavbarButtonSet' → children become NavbarButtons
        //   reactive `icon` prop swaps filled↔outline on active
        //   manual sprite swap on click so the `use href=…` updates
        CategoryNavbar: {
            extends: 'NavbarButtonSet',
            color: 'dim',
            fontSize: 'Z1',
            align: 'center',
            padding: 'Y Z',
            gap: 'W2',
            width: '100%',
            borderBottom: '1px solid',
            borderBottomColor: 'line',
            childrenAs: 'state',
            children: $bafd6174f417a959$var$CATEGORIES,
            childProps: {
                isActive: (el, s)=>s.key === s.root?.explorerContent,
                icon: (el, s)=>{
                    const active = s.key === s.root?.explorerContent;
                    return active ? s.icon : s.icon + ' outline';
                },
                title: (el, s)=>s.title,
                '.isActive': {
                    theme: 'navbarButton-active'
                },
                '!isActive': {
                    theme: 'navbarButton'
                },
                onClick: async (ev, el, s)=>{
                    const rs = el.getRootState();
                    const next = {
                        explorerContent: s.key
                    };
                    if (s.key === 'designSystem') next.viewMode = 'designSystem';
                    else if (rs.viewMode === 'designSystem') next.viewMode = 'app';
                    rs.update(next);
                    const rootEl = el.getRoot();
                    if (rootEl?.Scene) rootEl.Scene.update();
                    const sidebar = rootEl?.PreviewSidebar;
                    const listEl = sidebar?.Content?.List;
                    // Category switch — seed the list's active-key from whichever
                    // root field applies so the relevant row is highlighted.
                    if (listEl?.scope) {
                        if (s.key === 'designSystem') listEl.scope.activeKey = rs.dsPage;
                        else if (s.key === 'components') listEl.scope.activeKey = rs.activeComponent;
                        else listEl.scope.activeKey = rs.activePage;
                    }
                    // Force the list wrapper to re-run its `children:` factory and
                    // every category button to re-evaluate its reactive props.
                    listEl?.update?.();
                    for (const k of el.parent?.__ref?.__children || [])el.parent[k]?.update?.();
                    $bafd6174f417a959$var$swapSiblingIcons(el.parent, s.key);
                    if (s.key === 'designSystem') await $bafd6174f417a959$var$ensureDsEmbedded(el, {
                        dsPage: rs.dsPage,
                        dsNav: rs.dsNav
                    });
                }
            }
        },
        // Single reactive list — swaps its children based on which
        // category is active. Avoids the DOMQL-v3.14 gotcha where multiple
        // sibling children with `if:` don't all re-evaluate on root-state
        // changes; one `children:` factory always re-runs.
        List: {
            flow: 'column',
            gap: 'V',
            padding: 'Y Y2',
            flex: '1',
            overflow: 'auto',
            // `activeKey` is mutated inside list-item onClicks (same pattern
            // ResponsiveSwitching uses with `scope.previewSize`). Scope gives
            // us a stable per-list signal children can read locally.
            scope: {
                activeKey: null
            },
            onRender: (el, s)=>{
                // Seed `activeKey` from root state so a reload remembers the
                // last picked item in each category.
                const cat = s.root?.explorerContent || 'pages';
                if (!el.scope) el.scope = {
                    activeKey: null
                };
                if (el.scope.activeKey != null) return;
                if (cat === 'designSystem') el.scope.activeKey = s.root?.dsPage;
                else if (cat === 'components') el.scope.activeKey = s.root?.activeComponent;
                else el.scope.activeKey = s.root?.activePage;
            },
            childrenAs: 'state',
            children: (el, s)=>{
                const cat = s.root?.explorerContent || 'pages';
                if (cat === 'designSystem') return $bafd6174f417a959$export$e39db91b3f7376e9.map((p)=>({
                        ...p,
                        _kind: 'ds'
                    }));
                if (cat === 'components') {
                    const comps = s.root?.data?.components || {};
                    return Object.keys(comps).map((key)=>({
                            key: key,
                            _kind: 'comp'
                        }));
                }
                const pages = s.root?.data?.pages || {};
                return Object.keys(pages).map((route)=>({
                        key: route,
                        route: route,
                        _kind: 'page'
                    }));
            },
            childProps: $bafd6174f417a959$var$listRow({
                // `keyOf` picks the identity each list item uses against
                // `scope.activeKey`. Using `_kind` to branch avoids the
                // state-proxy falling through to root's `title` when the row
                // doesn't own a matching field.
                keyOf: (s)=>{
                    if (s._kind === 'ds') return s.dsPage;
                    if (s._kind === 'comp') return s.key;
                    return s.route;
                },
                iconFn: (el, s)=>{
                    if (s._kind === 'ds') return s.icon;
                    if (s._kind === 'comp') return 'layers';
                    return 'document';
                },
                textFn: (el, s)=>{
                    if (s._kind === 'ds') return s.title;
                    if (s._kind === 'comp') return s.key;
                    return s.route;
                },
                onClick: async (ev, el, s)=>{
                    if (s._kind === 'ds') {
                        const rs = el.getRootState();
                        const nextDsNav = (rs.dsNav || 0) + 1;
                        rs.update({
                            dsPage: s.dsPage,
                            dsNav: nextDsNav,
                            viewMode: 'designSystem'
                        });
                        const doc = el.context?.document || document;
                        const dsIframe = doc.getElementById('preview-ds-iframe');
                        const innerRs = dsIframe?.__dsRootState;
                        if (innerRs?.update) innerRs.update({
                            dsPage: s.dsPage,
                            dsNav: nextDsNav
                        });
                        else await $bafd6174f417a959$var$ensureDsEmbedded(el, {
                            dsPage: s.dsPage,
                            dsNav: nextDsNav
                        });
                    } else if (s._kind === 'comp') {
                        el.getRootState().update({
                            activeComponent: s.key
                        });
                        await $bafd6174f417a959$var$previewComponent(el, s.key);
                    } else {
                        el.getRootState().update({
                            activePage: s.route
                        });
                        $bafd6174f417a959$var$navigateIframeTo(el, s.route);
                    }
                    // DOMQL v3.14 doesn't always re-evaluate reactive `background` /
                    // `color` factories on nested children when root-state keys
                    // they read change. Same workaround ThemeSwitcher /
                    // ResponsiveSwitching use: manually call `update()` on every
                    // sibling so the active-state styling refreshes.
                    const parent = el.parent;
                    for (const k of parent?.__ref?.__children || [])parent[k]?.update?.();
                }
            })
        }
    }
};

});

parcelRegister("c1JIl", function(module, exports) {

$parcel$export(module.exports, "PreviewErrorBoundary", () => $8c1909efff1782f9$export$1683e01c0b9ac7b6);

var $9PrrW = parcelRequire("9PrrW");

var $8x1wG = parcelRequire("8x1wG");

var $17kPZ = parcelRequire("17kPZ");

var $bZEG1 = parcelRequire("bZEG1");
// PreviewErrorBoundary — rendered whenever getProjectData() throws.
// Branches on `fetchError.code`:
//   project_not_public         → legacy "no env published" copy + env picker
//   project_private            → "Sign in to view" CTA (cross-domain handoff)
//   project_password_protected → password card (anon unlock via unlockProjectData)
//   <anything else>            → generic error
// Uses only design-system tokens (no raw px / hex / rem).
const $8c1909efff1782f9$var$_redirectToWorkspaceLogin = ()=>{
    if (typeof window === 'undefined') return;
    const here = window.location.href;
    // Target hardcoded to the trusted preview surface — defensive even
    // though we already gate on `isTrustedHandoffTarget` server-side in
    // signin.js. Caller would have to actively misconfigure to reach an
    // untrusted host.
    if (!(0, $8x1wG.isTrustedHandoffTarget)(here)) console.warn('[preview/auth] current URL not a trusted handoff target');
    const url = (0, $8x1wG.buildLoginRedirectUrl)((0, $17kPZ.workspaceOrigin)(), here);
    window.location.replace(url);
};
const $8c1909efff1782f9$export$1683e01c0b9ac7b6 = {
    flow: 'column',
    align: 'center center',
    width: '100%',
    height: '100%',
    background: 'document',
    padding: 'D',
    gap: 'C',
    position: 'relative',
    // Brand placeholder that replaces PreviewNavbar in the error state.
    // Pinned to top-center of the viewport — independent of the centered
    // content column below. Click routes to https://symbols.app.
    Logo: {
        extends: 'Logo',
        tag: 'a',
        attr: {
            href: 'https://symbols.app'
        },
        position: 'absolute',
        top: 'B',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: '2',
        cursor: 'pointer'
    },
    Inner: {
        flow: 'column',
        align: 'center center',
        gap: 'B',
        maxWidth: 'H2',
        width: '100%',
        IconWrapper: {
            align: 'center center',
            boxSize: 'E E',
            round: 'D',
            background: (el, s)=>{
                const code = s.root?.fetchError?.code;
                if (code === 'project_private') return 'blue.05';
                if (code === 'project_password_protected') return 'blue.05';
                return 'red.05';
            },
            Icon: {
                extends: 'Icon',
                // `warning` was never published in the brand sprite, so the
                // generic-error fallback rendered an empty placeholder. Use
                // `xCircleFill` (registered in `company/packages/brand/
                // designSystem/icons.js`) so failed-fetch states actually show
                // an icon.
                icon: (el, s)=>{
                    const code = s.root?.fetchError?.code;
                    if (code === 'project_private') return 'lock';
                    if (code === 'project_password_protected') return 'lock';
                    return 'xCircleFill';
                },
                boxSize: 'C C',
                color: (el, s)=>{
                    const code = s.root?.fetchError?.code;
                    if (code === 'project_private') return 'blue';
                    if (code === 'project_password_protected') return 'blue';
                    return 'red';
                }
            }
        },
        Heading: {
            flow: 'column',
            align: 'center center',
            gap: 'X2',
            textAlign: 'center',
            Title: {
                tag: 'h2',
                text: (el, s)=>{
                    const err = s.root?.fetchError;
                    if (!err) return 'Preview unavailable';
                    if (err.code === 'project_private') return err.signedIn ? 'No access to this project' : 'Sign in to view';
                    if (err.code === 'project_password_protected') return 'Password required';
                    if (err.code === 'project_not_public') return 'Project not published';
                    return 'Preview failed to load';
                },
                fontSize: 'D',
                fontWeight: '600',
                color: 'title',
                lineHeight: '1.3'
            },
            Subtitle: {
                tag: 'p',
                text: (el, s)=>{
                    const err = s.root?.fetchError;
                    if (!err) return 'An unexpected error occurred.';
                    const owner = err.owner || '';
                    const key = err.key || '';
                    const slug = owner && key ? `${owner}/${key}` : 'this project';
                    if (err.code === 'project_private') return err.signedIn ? `You don't have access to ${slug}. Switch accounts or ask the owner for an invite.` : `${slug} is private. Sign in with an account that has access.`;
                    if (err.code === 'project_password_protected') return `${slug} is password-protected. Enter the password to view.`;
                    if (owner && key) return slug;
                    return 'Unable to load project data.';
                },
                fontSize: 'Z1',
                color: 'caption',
                textAlign: 'center'
            }
        },
        // Generic error / not-public path — keeps the legacy details block.
        // Hidden for private + password-protected since the heading + CTA
        // already explain the state.
        ErrorDetail: {
            hide: (el, s)=>{
                const code = s.root?.fetchError?.code;
                return code === 'project_private' || code === 'project_password_protected';
            },
            flow: 'column',
            gap: 'X',
            width: '100%',
            padding: 'A B',
            background: 'overlay',
            round: 'C',
            border: '1px solid',
            borderColor: 'line',
            CodeLine: {
                tag: 'code',
                text: (el, s)=>{
                    const err = s.root?.fetchError;
                    if (!err) return 'Unknown error';
                    const code = err.code ? `[${err.code}] ` : '';
                    return `${code}${err.message || 'Unknown error'}`;
                },
                fontSize: 'Z2',
                color: 'red',
                fontFamily: 'monospace',
                wordBreak: 'break-all'
            },
            TriedEnvs: {
                hide: (el, s)=>{
                    const err = s.root?.fetchError;
                    return !err?.triedEnvs?.length;
                },
                flow: 'row',
                gap: 'X',
                align: 'center start',
                flexWrap: 'wrap',
                Label: {
                    text: 'Tried:',
                    fontSize: 'Z2',
                    color: 'paragraph',
                    lineHeight: '1.6'
                },
                EnvChips: {
                    flow: 'row',
                    gap: 'X',
                    flexWrap: 'wrap',
                    children: (el, s)=>{
                        const envs = s.root?.fetchError?.triedEnvs || [];
                        return envs.map((e)=>({
                                key: e,
                                text: e
                            }));
                    },
                    childrenAs: 'state',
                    childExtends: 'Chip',
                    childProps: {
                        fontSize: 'Z2',
                        padding: 'W X',
                        round: 'B',
                        background: 'overlay',
                        color: 'paragraph',
                        text: (el, s)=>s.text || s.key
                    }
                }
            }
        },
        // Private project — sign-in CTA. The button bounces through
        // my.symbols.app/signin?redirect=<here>; signin.js will mint an
        // auth-handoff fragment and replace location back here.
        PrivateActions: {
            hide: (el, s)=>s.root?.fetchError?.code !== 'project_private',
            flow: 'row',
            gap: 'X',
            align: 'center center',
            flexWrap: 'wrap',
            width: '100%',
            SignInButton: {
                extends: 'Button',
                text: (el, s)=>s.root?.fetchError?.signedIn ? 'Switch account' : 'Sign in',
                theme: 'primary',
                padding: 'Y2 B',
                round: 'C',
                fontSize: 'Z1',
                fontWeight: '500',
                minHeight: 'B',
                cursor: 'pointer',
                align: 'center center',
                onClick: ()=>$8c1909efff1782f9$var$_redirectToWorkspaceLogin()
            },
            OpenInEditorButton: {
                extends: 'Link',
                tag: 'a',
                href: (el, s)=>{
                    const err = s.root?.fetchError;
                    const owner = err?.owner || '';
                    const key = err?.key || '';
                    if (!owner || !key) return 'https://edit.symbols.app';
                    return `https://edit.symbols.app/${owner}/${key}`;
                },
                target: '_blank',
                text: 'Open in editor',
                theme: 'secondary',
                padding: 'Y2 B',
                round: 'C',
                fontSize: 'Z1',
                fontWeight: '500',
                minHeight: 'B',
                cursor: 'pointer',
                align: 'center center'
            }
        },
        // Password-protected project — inline form. On submit, hash the
        // value, POST to /unlock, and replace state.data on success.
        // Inline form state lives on a sub-state to keep the unlock flow
        // self-contained — root state only flips when the unlock succeeds.
        PasswordCard: {
            hide: (el, s)=>s.root?.fetchError?.code !== 'project_password_protected',
            tag: 'form',
            flow: 'column',
            gap: 'A',
            width: '100%',
            padding: 'B',
            background: 'overlay',
            round: 'C',
            border: '1px solid',
            borderColor: 'line',
            state: {
                loading: false,
                errorMessage: ''
            },
            onSubmit: async (ev, el, s)=>{
                ev.preventDefault();
                const root = el.node;
                const value = root.querySelector('input[name="password"]')?.value || '';
                if (!value) {
                    s.update({
                        errorMessage: 'Password is required.'
                    });
                    return;
                }
                s.update({
                    loading: true,
                    errorMessage: ''
                });
                try {
                    const err = s.root?.fetchError;
                    const hashed = await (0, $bZEG1.sha256)(value);
                    const data = await (0, $9PrrW.unlockProjectData)({
                        owner: err?.owner,
                        key: err?.key,
                        envKey: err?.passwordEnv || err?.triedEnvs?.[0] || 'production',
                        password: hashed
                    });
                    if (!data) {
                        s.update({
                            loading: false,
                            errorMessage: 'Incorrect password. Try again.'
                        });
                        return;
                    }
                    // Swap the root state so PreviewNavbar + Scene re-read and
                    // the boundary hides itself (its parent's `hide` watches
                    // `s.root?.fetchError`).
                    s.root.update({
                        data: data,
                        fetchError: null,
                        resolvedEnv: data._resolvedEnv,
                        requestedEnv: data._requestedEnv,
                        usedFallback: false,
                        env: data._resolvedEnv
                    });
                } catch (e) {
                    s.update({
                        loading: false,
                        errorMessage: e?.message || 'Failed to unlock.'
                    });
                }
            },
            PasswordLabel: {
                tag: 'label',
                // `for` is a reserved word in JS — DOMQL surfaces it via the
                // `attr` escape hatch (matches AppLoginCard's pattern).
                attr: {
                    for: 'preview-password'
                },
                fontSize: 'Z2',
                fontWeight: '500',
                color: 'title',
                text: 'Password'
            },
            PasswordInput: {
                tag: 'input',
                id: 'preview-password',
                type: 'password',
                name: 'password',
                autocomplete: 'current-password',
                placeholder: 'Enter project password',
                width: '100%',
                padding: 'Y2 A',
                round: 'B',
                background: 'document',
                border: '1px solid',
                borderColor: 'line',
                color: 'title',
                fontSize: 'Z1',
                boxSizing: 'border-box',
                ':focus-visible': {
                    outline: 'none',
                    borderColor: 'blue',
                    boxShadow: '0 0 0 2px var(--color-blue-05)'
                },
                // Clear any previous "incorrect password" message as the user
                // starts typing again — the form will re-validate on submit.
                onInput: (ev, el, s)=>{
                    if (s.errorMessage) s.update({
                        errorMessage: ''
                    });
                }
            },
            ErrorLine: {
                hide: (el, s)=>!s.errorMessage,
                tag: 'p',
                text: (el, s)=>s.errorMessage,
                fontSize: 'Z2',
                color: 'red',
                margin: '0'
            },
            SubmitRow: {
                flow: 'row',
                gap: 'X',
                align: 'center center',
                UnlockButton: {
                    extends: 'Button',
                    tag: 'button',
                    type: 'submit',
                    text: (el, s)=>s.loading ? "Unlocking\u2026" : 'Unlock',
                    theme: 'primary',
                    padding: 'Y2 B',
                    round: 'C',
                    fontSize: 'Z1',
                    fontWeight: '500',
                    minHeight: 'B',
                    cursor: 'pointer',
                    align: 'center center',
                    flex: '1',
                    disabled: (el, s)=>!!s.loading
                },
                SignInLink: {
                    extends: 'Link',
                    tag: 'button',
                    type: 'button',
                    text: 'Sign in instead',
                    theme: 'transparent',
                    padding: 'Y2 B',
                    round: 'C',
                    fontSize: 'Z1',
                    color: 'paragraph',
                    background: 'transparent',
                    border: 'none',
                    cursor: 'pointer',
                    onClick: ()=>$8c1909efff1782f9$var$_redirectToWorkspaceLogin()
                }
            }
        },
        // Two rows of actions, each with internally-consistent button sizing.
        // Row 1 — primary actions (Open in editor, Retry). Theme-tinted.
        // Row 2 — env-switch picker (Label + 3 chip buttons). Smaller chip
        //         sizing is intentional (these are quick-toggle pills, not
        //         primary CTAs) but ALL three chips are identical to each other.
        Actions: {
            hide: (el, s)=>{
                const code = s.root?.fetchError?.code;
                return code === 'project_private' || code === 'project_password_protected';
            },
            flow: 'column',
            gap: 'A',
            align: 'center center',
            width: '100%',
            // Shared sizing token applied to both primary actions so they
            // visually match exactly (was: same `padding: 'A B'` but different
            // `extends` gave different intrinsic heights).
            PrimaryRow: {
                flow: 'row',
                gap: 'X',
                align: 'center center',
                flexWrap: 'wrap',
                OpenInEditor: {
                    extends: 'Link',
                    tag: 'a',
                    href: (el, s)=>{
                        const err = s.root?.fetchError;
                        const owner = err?.owner || '';
                        const key = err?.key || '';
                        if (!owner || !key) return 'https://edit.symbols.app';
                        const env = err?.triedEnvs?.[0] || 'development';
                        return `https://edit.symbols.app/${owner}/${key}?env=${env}`;
                    },
                    target: '_blank',
                    text: 'Open in editor',
                    theme: 'primary',
                    padding: 'Y2 B',
                    round: 'C',
                    fontSize: 'Z1',
                    fontWeight: '500',
                    minHeight: 'B',
                    cursor: 'pointer',
                    align: 'center center'
                },
                RetryButton: {
                    extends: 'Button',
                    text: 'Retry',
                    theme: 'secondary',
                    padding: 'Y2 B',
                    round: 'C',
                    fontSize: 'Z1',
                    fontWeight: '500',
                    minHeight: 'B',
                    cursor: 'pointer',
                    align: 'center center',
                    onClick: (ev, el)=>{
                        window.location.reload();
                    }
                }
            },
            // Row 2 — env switcher. Label + identically-sized chips.
            SwitchEnvButtons: {
                flow: 'row',
                gap: 'X',
                align: 'center center',
                flexWrap: 'wrap',
                Label: {
                    text: 'Try env:',
                    fontSize: 'Z2',
                    color: 'paragraph'
                },
                Envs: {
                    flow: 'row',
                    gap: 'X',
                    align: 'center center',
                    children: [
                        {
                            key: 'development',
                            text: 'Dev'
                        },
                        {
                            key: 'staging',
                            text: 'Staging'
                        },
                        {
                            key: 'production',
                            text: 'Prod'
                        }
                    ],
                    childrenAs: 'state',
                    childExtends: 'Button',
                    childProps: {
                        text: (el, s)=>s.text || s.key,
                        theme: 'secondary',
                        padding: 'W A',
                        round: 'C',
                        fontSize: 'Z2',
                        fontWeight: '500',
                        minHeight: 'A2',
                        cursor: 'pointer',
                        align: 'center center',
                        onClick: (ev, el, s)=>{
                            if (!s?.key) return;
                            const url = new URL(window.location.href);
                            url.searchParams.set('env', s.key);
                            window.location.href = url.toString();
                        }
                    }
                }
            }
        }
    }
};

});


parcelRegister("5fy2E", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d28c26e8a74dbc6$export$2e2bcd8739ae039);

var $bxJHt = parcelRequire("bxJHt");

var $io8lZ = parcelRequire("io8lZ");

var $4IUh2 = parcelRequire("4IUh2");

var $kQgyO = parcelRequire("kQgyO");

var $rcE6Y = parcelRequire("rcE6Y");

var $4Q0A9 = parcelRequire("4Q0A9");

var $jVwWk = parcelRequire("jVwWk");

var $5cjxH = parcelRequire("5cjxH");

var $gD9bk = parcelRequire("gD9bk");

var $ecBWt = parcelRequire("ecBWt");

var $3OWNy = parcelRequire("3OWNy");

var $fCCqU = parcelRequire("fCCqU");

var $6lcti = parcelRequire("6lcti");

var $bnYmV = parcelRequire("bnYmV");

var $6JsA3 = parcelRequire("6JsA3");
var $3d28c26e8a74dbc6$export$2e2bcd8739ae039 = {
    color: $bxJHt.default,
    gradient: $io8lZ.default,
    theme: $4IUh2.default,
    font: $kQgyO.default,
    fontFamily: $rcE6Y.default,
    typography: $4Q0A9.default,
    spacing: $jVwWk.default,
    timing: $5cjxH.default,
    class: (0, $gD9bk.default),
    grid: $ecBWt.default,
    icons: $3OWNy.default,
    shape: $fCCqU.default,
    reset: $6lcti.default,
    animation: $bnYmV.default,
    media: $6JsA3.default
};

});
parcelRegister("bxJHt", function(module, exports) {

$parcel$export(module.exports, "default", () => $867639ddecbeaadf$export$2e2bcd8739ae039);
var $867639ddecbeaadf$export$2e2bcd8739ae039 = {
    // Calendar-specific: adaptive day selection highlight.
    selectedDay: [
        '--blue .12',
        '--blue .18'
    ]
};

});

parcelRegister("io8lZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d630f2c5d8d60876$export$2e2bcd8739ae039);
var $d630f2c5d8d60876$export$2e2bcd8739ae039 = {};

});

parcelRegister("4IUh2", function(module, exports) {

$parcel$export(module.exports, "default", () => $3706ec492d7a9e31$export$2e2bcd8739ae039);
var $3706ec492d7a9e31$export$2e2bcd8739ae039 = {};

});

parcelRegister("kQgyO", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2c5828828dafcfe$export$2e2bcd8739ae039);
var $f2c5828828dafcfe$export$2e2bcd8739ae039 = {};

});

parcelRegister("rcE6Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $051c54f4951fcac0$export$2e2bcd8739ae039);
var $051c54f4951fcac0$export$2e2bcd8739ae039 = {};

});

parcelRegister("4Q0A9", function(module, exports) {

$parcel$export(module.exports, "default", () => $385c785858f6ccd4$export$2e2bcd8739ae039);
var $385c785858f6ccd4$export$2e2bcd8739ae039 = {};

});

parcelRegister("jVwWk", function(module, exports) {

$parcel$export(module.exports, "default", () => $e81ce4563f9699c1$export$2e2bcd8739ae039);
var $e81ce4563f9699c1$export$2e2bcd8739ae039 = {};

});

parcelRegister("5cjxH", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c8d3b801dc31b36$export$2e2bcd8739ae039);
var $3c8d3b801dc31b36$export$2e2bcd8739ae039 = {};

});

parcelRegister("gD9bk", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1b76924d48efdc5$export$2e2bcd8739ae039);
var $c1b76924d48efdc5$export$2e2bcd8739ae039 = {};

});

parcelRegister("ecBWt", function(module, exports) {

$parcel$export(module.exports, "default", () => $a56f9e2e49eb5339$export$2e2bcd8739ae039);
var $a56f9e2e49eb5339$export$2e2bcd8739ae039 = {};

});

parcelRegister("3OWNy", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c83a6b6f0f71322$export$2e2bcd8739ae039);
var $2c83a6b6f0f71322$export$2e2bcd8739ae039 = {
    add: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M12 3.25C12.4142 3.25 12.75 3.58579 12.75 4V11.25H20C20.4142 11.25 20.75 11.5858 20.75 12C20.75 12.4142 20.4142 12.75 20 12.75H12.75V20C12.75 20.4142 12.4142 20.75 12 20.75C11.5858 20.75 11.25 20.4142 11.25 20V12.75H4C3.58579 12.75 3.25 12.4142 3.25 12C3.25 11.5858 3.58579 11.25 4 11.25H11.25V4C11.25 3.58579 11.5858 3.25 12 3.25Z" fill="currentColor"/>\\n</svg>',
    arrowDown: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M19.7905 13.2673C20.0762 12.9674 20.0646 12.4926 19.7647 12.2069C19.4648 11.9212 18.99 11.9328 18.7043 12.2327L12.7498 18.484V3.75C12.7498 3.33579 12.4141 3 11.9998 3C11.5856 3 11.2498 3.33579 11.2498 3.75V18.4844L5.29502 12.2327C5.00933 11.9328 4.5346 11.9212 4.23467 12.2069C3.93475 12.4926 3.9232 12.9674 4.20889 13.2673L11.2756 20.6862C11.4366 20.8553 11.642 20.9552 11.8556 20.9861C11.9023 20.9952 11.9505 21 11.9998 21C12.0495 21 12.0981 20.9952 12.1451 20.9859C12.3582 20.9548 12.5631 20.8549 12.7238 20.6862L19.7905 13.2673Z" fill="currentColor"/>\\n</svg>',
    arrowLeft: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M10.7327 19.7905C11.0326 20.0762 11.5074 20.0646 11.7931 19.7647C12.0788 19.4648 12.0672 18.99 11.7673 18.7043L5.51587 12.7497L20.25 12.7497C20.6642 12.7497 21 12.4139 21 11.9997C21 11.5855 20.6642 11.2497 20.25 11.2497L5.51577 11.2497L11.7673 5.29502C12.0672 5.00933 12.0787 4.5346 11.7931 4.23467C11.5074 3.93475 11.0326 3.9232 10.7327 4.20889L3.31379 11.2756C3.14486 11.4365 3.04491 11.6417 3.01393 11.8551C3.00479 11.9019 3 11.9503 3 11.9997C3 12.0493 3.00481 12.0977 3.01398 12.1446C3.04502 12.3579 3.14496 12.563 3.31379 12.7238L10.7327 19.7905Z" fill="currentColor"/>\\n</svg>',
    arrowRight: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M13.2673 4.20889C12.9674 3.9232 12.4926 3.93475 12.2069 4.23467C11.9212 4.5346 11.9328 5.00933 12.2327 5.29502L18.4841 11.2496H3.75C3.33579 11.2496 3 11.5854 3 11.9996C3 12.4138 3.33579 12.7496 3.75 12.7496H18.4842L12.2327 18.7043C11.9328 18.99 11.9212 19.4648 12.2069 19.7647C12.4926 20.0646 12.9674 20.0762 13.2673 19.7905L20.6862 12.7238C20.8551 12.5629 20.9551 12.3576 20.9861 12.1443C20.9952 12.0975 21 12.0491 21 11.9996C21 11.9501 20.9952 11.9016 20.986 11.8547C20.955 11.6415 20.855 11.4364 20.6862 11.2756L13.2673 4.20889Z" fill="currentColor"/>\\n</svg>',
    arrowUp: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M4.20889 10.7327C3.9232 11.0326 3.93475 11.5074 4.23467 11.7931C4.5346 12.0788 5.00933 12.0672 5.29502 11.7673L11.2495 5.516V20.25C11.2495 20.6642 11.5853 21 11.9995 21C12.4137 21 12.7495 20.6642 12.7495 20.25V5.51565L18.7043 11.7673C18.99 12.0672 19.4648 12.0788 19.7647 11.7931C20.0646 11.5074 20.0762 11.0326 19.7905 10.7327L12.7238 3.31379C12.5627 3.14474 12.3573 3.04477 12.1438 3.01386C12.0971 3.00477 12.0489 3 11.9995 3C11.9498 3 11.9012 3.00483 11.8543 3.01406C11.6412 3.04518 11.4363 3.14509 11.2756 3.31379L4.20889 10.7327Z" fill="currentColor"/>\\n</svg>',
    attachment: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M11.7722 3.74407C14.1136 1.40049 17.9126 1.40049 20.2558 3.74363C22.5388 6.0267 22.5974 9.69191 20.4314 12.0458L20.2432 12.2432L11.4432 21.0414L11.4066 21.0717C9.94541 22.3884 7.69141 22.3437 6.28404 20.9363C4.96502 19.6173 4.8429 17.5546 5.91769 16.0979C5.94103 16.0525 5.96928 16.0088 6.00249 15.9677L6.05605 15.908L6.14295 15.8203L6.28404 15.6724L6.28695 15.6753L13.7227 8.22096C13.9886 7.95434 14.4052 7.92958 14.6991 8.14704L14.7834 8.21955C15.05 8.48546 15.0747 8.90209 14.8573 9.19599L14.7848 9.28021L7.19015 16.8933C6.47251 17.7689 6.52239 19.0632 7.33979 19.8806C8.16885 20.7096 9.4885 20.7491 10.3643 19.999L19.197 11.1685C20.9525 9.41089 20.9525 6.56165 19.1951 4.80429C17.4927 3.10185 14.7655 3.04865 12.999 4.64469L12.8312 4.80429L12.8186 4.8186L3.28228 14.3549C2.98939 14.6478 2.51452 14.6478 2.22162 14.3549C1.95536 14.0887 1.93115 13.672 2.149 13.3784L2.22162 13.2943L11.7705 3.74363L11.7722 3.74407Z" fill="currentColor"/>\\n</svg>',
    bold: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M6.93514 4.43963C7.21647 4.15815 7.59813 4 7.99609 4H12.3795C15.0161 4 16.9995 6.18211 16.9995 8.62541C16.9995 9.60205 16.6828 10.5367 16.1341 11.307C17.211 12.134 17.9995 13.4274 17.9995 15.12C17.9995 18.2315 15.301 20 13.1195 20H7.99951C7.17108 20 6.49951 19.3284 6.49951 18.5L6.49609 5.50082C6.49588 5.10285 6.65382 4.72111 6.93514 4.43963ZM9.49869 10.2499H12.3795C13.2824 10.2499 13.9995 9.49051 13.9995 8.62541C13.9995 7.76 13.2814 7 12.3795 7H9.49691L9.49869 10.2499ZM9.49951 13.2499V17H13.1195C13.9927 17 14.9995 16.2464 14.9995 15.12C14.9995 13.9901 14.0248 13.2499 13.1195 13.2499H9.49951Z" fill="currentColor"/>\\n</svg>',
    bookmark: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M6.19094 21.8547C5.6948 22.2117 5.00293 21.8571 5.00293 21.2459V6.25C5.00293 4.45507 6.458 3 8.25293 3H15.7513C17.5462 3 19.0013 4.45507 19.0013 6.25V21.2459C19.0013 21.8571 18.3094 22.2117 17.8133 21.8547L12.0021 17.6738L6.19094 21.8547ZM17.5013 6.25C17.5013 5.2835 16.7178 4.5 15.7513 4.5H8.25293C7.28643 4.5 6.50293 5.2835 6.50293 6.25V19.7824L11.5641 16.141C11.8258 15.9528 12.1785 15.9528 12.4401 16.141L17.5013 19.7824V6.25Z" fill="currentColor"/>\\n</svg>',
    chat: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C10.3817 22 8.81782 21.6146 7.41286 20.888L3.58704 21.9553C2.92212 22.141 2.23258 21.7525 2.04691 21.0876C1.98546 20.8676 1.98549 20.6349 2.04695 20.4151L3.11461 16.5922C2.38637 15.186 2 13.6203 2 12C2 6.47715 6.47715 2 12 2ZM12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 13.4696 3.87277 14.8834 4.57303 16.1375L4.72368 16.4072L3.61096 20.3914L7.59755 19.2792L7.86709 19.4295C9.12006 20.1281 10.5322 20.5 12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5ZM8.75 13H13.2483C13.6625 13 13.9983 13.3358 13.9983 13.75C13.9983 14.1297 13.7161 14.4435 13.35 14.4932L13.2483 14.5H8.75C8.33579 14.5 8 14.1642 8 13.75C8 13.3703 8.28215 13.0565 8.64823 13.0068L8.75 13H13.2483H8.75ZM8.75 9.5H15.2545C15.6687 9.5 16.0045 9.83579 16.0045 10.25C16.0045 10.6297 15.7223 10.9435 15.3563 10.9932L15.2545 11H8.75C8.33579 11 8 10.6642 8 10.25C8 9.8703 8.28215 9.55651 8.64823 9.50685L8.75 9.5H15.2545H8.75Z" fill="currentColor"/>\\n</svg>',
    check: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5ZM10.75 13.4393L15.2197 8.96967C15.5126 8.67678 15.9874 8.67678 16.2803 8.96967C16.5466 9.23594 16.5708 9.6526 16.3529 9.94621L16.2803 10.0303L11.2803 15.0303C11.0141 15.2966 10.5974 15.3208 10.3038 15.1029L10.2197 15.0303L7.71967 12.5303C7.42678 12.2374 7.42678 11.7626 7.71967 11.4697C7.98594 11.2034 8.4026 11.1792 8.69621 11.3971L8.78033 11.4697L10.75 13.4393L15.2197 8.96967L10.75 13.4393Z" fill="currentColor"/>\\n</svg>',
    checkmark: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M4.53033 12.9697C4.23744 12.6768 3.76256 12.6768 3.46967 12.9697C3.17678 13.2626 3.17678 13.7374 3.46967 14.0303L7.96967 18.5303C8.26256 18.8232 8.73744 18.8232 9.03033 18.5303L20.0303 7.53033C20.3232 7.23744 20.3232 6.76256 20.0303 6.46967C19.7374 6.17678 19.2626 6.17678 18.9697 6.46967L8.5 16.9393L4.53033 12.9697Z" fill="currentColor"/>\\n</svg>',
    chevronDown: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M4.21967 8.46967C4.51256 8.17678 4.98744 8.17678 5.28033 8.46967L12 15.1893L18.7197 8.46967C19.0126 8.17678 19.4874 8.17678 19.7803 8.46967C20.0732 8.76256 20.0732 9.23744 19.7803 9.53033L12.5303 16.7803C12.2374 17.0732 11.7626 17.0732 11.4697 16.7803L4.21967 9.53033C3.92678 9.23744 3.92678 8.76256 4.21967 8.46967Z" fill="currentColor"/>\\n</svg>',
    chevronLeft: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M15.5303 4.21967C15.8232 4.51256 15.8232 4.98744 15.5303 5.28033L8.81066 12L15.5303 18.7197C15.8232 19.0126 15.8232 19.4874 15.5303 19.7803C15.2374 20.0732 14.7626 20.0732 14.4697 19.7803L7.21967 12.5303C6.92678 12.2374 6.92678 11.7626 7.21967 11.4697L14.4697 4.21967C14.7626 3.92678 15.2374 3.92678 15.5303 4.21967Z" fill="currentColor"/>\\n</svg>',
    chevronRight: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M8.46967 4.21967C8.17678 4.51256 8.17678 4.98744 8.46967 5.28033L15.1893 12L8.46967 18.7197C8.17678 19.0126 8.17678 19.4874 8.46967 19.7803C8.76256 20.0732 9.23744 20.0732 9.53033 19.7803L16.7803 12.5303C17.0732 12.2374 17.0732 11.7626 16.7803 11.4697L9.53033 4.21967C9.23744 3.92678 8.76256 3.92678 8.46967 4.21967Z" fill="currentColor"/>\\n</svg>',
    chevronUp: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M4.21967 15.5303C4.51256 15.8232 4.98744 15.8232 5.28033 15.5303L12 8.81066L18.7197 15.5303C19.0126 15.8232 19.4874 15.8232 19.7803 15.5303C20.0732 15.2374 20.0732 14.7626 19.7803 14.4697L12.5303 7.21967C12.2374 6.92678 11.7626 6.92678 11.4697 7.21967L4.21967 14.4697C3.92678 14.7626 3.92678 15.2374 4.21967 15.5303Z" fill="currentColor"/>\\n</svg>',
    close: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M4.39705 4.55379L4.46967 4.46967C4.73594 4.2034 5.1526 4.1792 5.44621 4.39705L5.53033 4.46967L12 10.939L18.4697 4.46967C18.7626 4.17678 19.2374 4.17678 19.5303 4.46967C19.8232 4.76256 19.8232 5.23744 19.5303 5.53033L13.061 12L19.5303 18.4697C19.7966 18.7359 19.8208 19.1526 19.6029 19.4462L19.5303 19.5303C19.2641 19.7966 18.8474 19.8208 18.5538 19.6029L18.4697 19.5303L12 13.061L5.53033 19.5303C5.23744 19.8232 4.76256 19.8232 4.46967 19.5303C4.17678 19.2374 4.17678 18.7626 4.46967 18.4697L10.939 12L4.46967 5.53033C4.2034 5.26406 4.1792 4.8474 4.39705 4.55379L4.46967 4.46967L4.39705 4.55379Z" fill="currentColor"/>\\n</svg>',
    code: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M8.06562 18.9434L14.5656 4.44339C14.7351 4.06542 15.1788 3.89637 15.5568 4.0658C15.9033 4.22112 16.0742 4.60695 15.9698 4.96131L15.9344 5.05698L9.43438 19.557C9.26495 19.935 8.82118 20.104 8.44321 19.9346C8.09673 19.7793 7.92581 19.3934 8.03024 19.0391L8.06562 18.9434L14.5656 4.44339L8.06562 18.9434ZM2.21967 11.4699L6.46967 7.21986C6.76256 6.92696 7.23744 6.92696 7.53033 7.21986C7.7966 7.48612 7.8208 7.90279 7.60295 8.1964L7.53033 8.28052L3.81066 12.0002L7.53033 15.7199C7.82322 16.0127 7.82322 16.4876 7.53033 16.7805C7.26406 17.0468 6.8474 17.071 6.55379 16.8531L6.46967 16.7805L2.21967 12.5305C1.9534 12.2642 1.9292 11.8476 2.14705 11.554L2.21967 11.4699L6.46967 7.21986L2.21967 11.4699ZM16.4697 7.21986C16.7359 6.95359 17.1526 6.92938 17.4462 7.14724L17.5303 7.21986L21.7803 11.4699C22.0466 11.7361 22.0708 12.1528 21.8529 12.4464L21.7803 12.5305L17.5303 16.7805C17.2374 17.0734 16.7626 17.0734 16.4697 16.7805C16.2034 16.5143 16.1792 16.0976 16.3971 15.804L16.4697 15.7199L20.1893 12.0002L16.4697 8.28052C16.1768 7.98762 16.1768 7.51275 16.4697 7.21986Z" fill="currentColor"/>\\n</svg>',
    codeBlock: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M6.25 3C4.45507 3 3 4.45507 3 6.25V17.75C3 19.5449 4.45507 21 6.25 21H17.75C19.5449 21 21 19.5449 21 17.75V6.25C21 4.45507 19.5449 3 17.75 3H6.25ZM4.5 6.25C4.5 5.2835 5.2835 4.5 6.25 4.5H17.75C18.7165 4.5 19.5 5.2835 19.5 6.25V17.75C19.5 18.7165 18.7165 19.5 17.75 19.5H6.25C5.2835 19.5 4.5 18.7165 4.5 17.75V6.25ZM10.5303 9.28033C10.8232 8.98744 10.8232 8.51256 10.5303 8.21967C10.2374 7.92678 9.76256 7.92678 9.46967 8.21967L6.21967 11.4697C5.92678 11.7626 5.92678 12.2374 6.21967 12.5303L9.46967 15.7803C9.76256 16.0732 10.2374 16.0732 10.5303 15.7803C10.8232 15.4874 10.8232 15.0126 10.5303 14.7197L7.81066 12L10.5303 9.28033ZM14.5303 8.21967C14.2374 7.92678 13.7626 7.92678 13.4697 8.21967C13.1768 8.51256 13.1768 8.98744 13.4697 9.28033L16.1893 12L13.4697 14.7197C13.1768 15.0126 13.1768 15.4874 13.4697 15.7803C13.7626 16.0732 14.2374 16.0732 14.5303 15.7803L17.7803 12.5303C18.0732 12.2374 18.0732 11.7626 17.7803 11.4697L14.5303 8.21967Z" fill="currentColor"/>\\n</svg>',
    copy: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M5.5028 4.62704L5.5 6.75V17.2542C5.5 19.0491 6.95507 20.5042 8.75 20.5042L17.3663 20.5045C17.0573 21.3782 16.224 22.0042 15.2444 22.0042H8.75C6.12665 22.0042 4 19.8776 4 17.2542V6.75C4 5.76929 4.62745 4.93512 5.5028 4.62704ZM17.75 2C18.9926 2 20 3.00736 20 4.25V17.25C20 18.4926 18.9926 19.5 17.75 19.5H8.75C7.50736 19.5 6.5 18.4926 6.5 17.25V4.25C6.5 3.00736 7.50736 2 8.75 2H17.75ZM17.75 3.5H8.75C8.33579 3.5 8 3.83579 8 4.25V17.25C8 17.6642 8.33579 18 8.75 18H17.75C18.1642 18 18.5 17.6642 18.5 17.25V4.25C18.5 3.83579 18.1642 3.5 17.75 3.5Z" fill="currentColor"/>\\n</svg>',
    delete: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M10 5H14C14 3.89543 13.1046 3 12 3C10.8954 3 10 3.89543 10 5ZM8.5 5C8.5 3.067 10.067 1.5 12 1.5C13.933 1.5 15.5 3.067 15.5 5H21.25C21.6642 5 22 5.33579 22 5.75C22 6.16421 21.6642 6.5 21.25 6.5H19.9309L18.7589 18.6112C18.5729 20.5334 16.9575 22 15.0263 22H8.97369C7.04254 22 5.42715 20.5334 5.24113 18.6112L4.06908 6.5H2.75C2.33579 6.5 2 6.16421 2 5.75C2 5.33579 2.33579 5 2.75 5H8.5ZM10.5 9.75C10.5 9.33579 10.1642 9 9.75 9C9.33579 9 9 9.33579 9 9.75V17.25C9 17.6642 9.33579 18 9.75 18C10.1642 18 10.5 17.6642 10.5 17.25V9.75ZM14.25 9C14.6642 9 15 9.33579 15 9.75V17.25C15 17.6642 14.6642 18 14.25 18C13.8358 18 13.5 17.6642 13.5 17.25V9.75C13.5 9.33579 13.8358 9 14.25 9ZM6.73416 18.4667C6.84577 19.62 7.815 20.5 8.97369 20.5H15.0263C16.185 20.5 17.1542 19.62 17.2658 18.4667L18.4239 6.5H5.57608L6.73416 18.4667Z" fill="currentColor"/>\\n</svg>',
    dismiss: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M4.39705 4.55379L4.46967 4.46967C4.73594 4.2034 5.1526 4.1792 5.44621 4.39705L5.53033 4.46967L12 10.939L18.4697 4.46967C18.7626 4.17678 19.2374 4.17678 19.5303 4.46967C19.8232 4.76256 19.8232 5.23744 19.5303 5.53033L13.061 12L19.5303 18.4697C19.7966 18.7359 19.8208 19.1526 19.6029 19.4462L19.5303 19.5303C19.2641 19.7966 18.8474 19.8208 18.5538 19.6029L18.4697 19.5303L12 13.061L5.53033 19.5303C5.23744 19.8232 4.76256 19.8232 4.46967 19.5303C4.17678 19.2374 4.17678 18.7626 4.46967 18.4697L10.939 12L4.46967 5.53033C4.2034 5.26406 4.1792 4.8474 4.39705 4.55379L4.46967 4.46967L4.39705 4.55379Z" fill="currentColor"/>\\n</svg>',
    document: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M6 2C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V9.82777C20 9.29733 19.7893 8.78863 19.4142 8.41355L13.5864 2.58579C13.2114 2.21071 12.7027 2 12.1722 2H6ZM5.5 4C5.5 3.72386 5.72386 3.5 6 3.5H12V8C12 9.10457 12.8954 10 14 10H18.5V20C18.5 20.2761 18.2761 20.5 18 20.5H6C5.72386 20.5 5.5 20.2761 5.5 20V4ZM17.3793 8.5H14C13.7239 8.5 13.5 8.27614 13.5 8V4.62066L17.3793 8.5Z" fill="currentColor"/>\\n</svg>',
    edit: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M20.9519 3.0481C19.5543 1.65058 17.2885 1.65064 15.8911 3.04825L3.94103 14.9997C3.5347 15.4061 3.2491 15.9172 3.116 16.4762L2.02041 21.0777C1.96009 21.3311 2.03552 21.5976 2.21968 21.7817C2.40385 21.9659 2.67037 22.0413 2.92373 21.981L7.52498 20.8855C8.08418 20.7523 8.59546 20.4666 9.00191 20.0601L20.952 8.10861C22.3493 6.71112 22.3493 4.4455 20.9519 3.0481ZM16.9518 4.10884C17.7634 3.29709 19.0795 3.29705 19.8912 4.10876C20.7028 4.9204 20.7029 6.23632 19.8913 7.04801L19 7.93946L16.0606 5.00012L16.9518 4.10884ZM15 6.06084L17.9394 9.00018L7.94119 18.9995C7.73104 19.2097 7.46668 19.3574 7.17755 19.4263L3.76191 20.2395L4.57521 16.8237C4.64402 16.5346 4.79168 16.2704 5.00175 16.0603L15 6.06084Z" fill="currentColor"/>\\n</svg>',
    emoji: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M12 1.99805C17.5237 1.99805 22.0015 6.47589 22.0015 11.9996C22.0015 17.5233 17.5237 22.0011 12 22.0011C6.47626 22.0011 1.99841 17.5233 1.99841 11.9996C1.99841 6.47589 6.47626 1.99805 12 1.99805ZM12 3.49805C7.30469 3.49805 3.49841 7.30432 3.49841 11.9996C3.49841 16.6949 7.30469 20.5011 12 20.5011C16.6952 20.5011 20.5015 16.6949 20.5015 11.9996C20.5015 7.30432 16.6952 3.49805 12 3.49805ZM8.4617 14.7829C9.31084 15.8606 10.6019 16.5012 11.9999 16.5012C13.3962 16.5012 14.6856 15.8624 15.5349 14.7871C15.7916 14.462 16.2633 14.4066 16.5883 14.6634C16.9134 14.9201 16.9688 15.3917 16.712 15.7168C15.5813 17.1485 13.8601 18.0012 11.9999 18.0012C10.1373 18.0012 8.41408 17.1462 7.28348 15.7112C7.02713 15.3859 7.08307 14.9143 7.40843 14.658C7.73379 14.4016 8.20535 14.4576 8.4617 14.7829ZM9.00041 8.75024C9.69037 8.75024 10.2497 9.30956 10.2497 9.99953C10.2497 10.6895 9.69037 11.2488 9.00041 11.2488C8.31045 11.2488 7.75112 10.6895 7.75112 9.99953C7.75112 9.30956 8.31045 8.75024 9.00041 8.75024ZM15.0004 8.75024C15.6904 8.75024 16.2497 9.30956 16.2497 9.99953C16.2497 10.6895 15.6904 11.2488 15.0004 11.2488C14.3104 11.2488 13.7511 10.6895 13.7511 9.99953C13.7511 9.30956 14.3104 8.75024 15.0004 8.75024Z" fill="currentColor"/>\\n</svg>',
    eye: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M11.9999 9.00462C14.209 9.00462 15.9999 10.7955 15.9999 13.0046C15.9999 15.2138 14.209 17.0046 11.9999 17.0046C9.79073 17.0046 7.99987 15.2138 7.99987 13.0046C7.99987 10.7955 9.79073 9.00462 11.9999 9.00462ZM11.9999 10.5046C10.6192 10.5046 9.49987 11.6239 9.49987 13.0046C9.49987 14.3853 10.6192 15.5046 11.9999 15.5046C13.3806 15.5046 14.4999 14.3853 14.4999 13.0046C14.4999 11.6239 13.3806 10.5046 11.9999 10.5046ZM11.9999 5.5C16.6134 5.5 20.596 8.65001 21.701 13.0644C21.8016 13.4662 21.5574 13.8735 21.1556 13.9741C20.7537 14.0746 20.3465 13.8305 20.2459 13.4286C19.307 9.67796 15.9212 7 11.9999 7C8.07681 7 4.68997 9.68026 3.75273 13.4332C3.65237 13.835 3.24523 14.0794 2.84336 13.9791C2.44149 13.8787 2.19707 13.4716 2.29743 13.0697C3.40052 8.65272 7.38436 5.5 11.9999 5.5Z" fill="currentColor"/>\\n</svg>',
    filter: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M13.5 16C13.9142 16 14.25 16.3358 14.25 16.75C14.25 17.1642 13.9142 17.5 13.5 17.5H10.5C10.0858 17.5 9.75 17.1642 9.75 16.75C9.75 16.3358 10.0858 16 10.5 16H13.5ZM16.5 11C16.9142 11 17.25 11.3358 17.25 11.75C17.25 12.1642 16.9142 12.5 16.5 12.5H7.5C7.08579 12.5 6.75 12.1642 6.75 11.75C6.75 11.3358 7.08579 11 7.5 11H16.5ZM19.5 6C19.9142 6 20.25 6.33579 20.25 6.75C20.25 7.16421 19.9142 7.5 19.5 7.5H4.5C4.08579 7.5 3.75 7.16421 3.75 6.75C3.75 6.33579 4.08579 6 4.5 6H19.5Z" fill="currentColor"/>\\n</svg>',
    flag: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M3 3.74805C3 3.33383 3.33579 2.99805 3.75 2.99805H20.2541C20.8722 2.99805 21.225 3.70369 20.8541 4.19811L16.6898 9.74927L20.8541 15.3004C21.225 15.7948 20.8722 16.5005 20.2541 16.5005L4.5 16.5V21.2499C4.5 21.6296 4.21785 21.9434 3.85177 21.993L3.75 21.9999C3.3703 21.9999 3.05651 21.7177 3.00685 21.3517L3 21.2499V3.74805ZM18.7539 4.49805H4.5V15.0005H18.7539L15.1522 10.1993C14.9522 9.93264 14.9522 9.5659 15.1522 9.29921L18.7539 4.49805Z" fill="currentColor"/>\\n</svg>',
    folder: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M3.5 6.25V8H8.12868C8.32759 8 8.51836 7.92098 8.65901 7.78033L10.1893 6.25L8.65901 4.71967C8.51836 4.57902 8.32759 4.5 8.12868 4.5H5.25C4.2835 4.5 3.5 5.2835 3.5 6.25ZM2 6.25C2 4.45507 3.45507 3 5.25 3H8.12868C8.72542 3 9.29771 3.23705 9.71967 3.65901L11.5607 5.5H18.75C20.5449 5.5 22 6.95507 22 8.75V17.75C22 19.5449 20.5449 21 18.75 21H5.25C3.45507 21 2 19.5449 2 17.75V6.25ZM3.5 9.5V17.75C3.5 18.7165 4.2835 19.5 5.25 19.5H18.75C19.7165 19.5 20.5 18.7165 20.5 17.75V8.75C20.5 7.7835 19.7165 7 18.75 7H11.5607L9.71967 8.84099C9.29771 9.26295 8.72542 9.5 8.12868 9.5H3.5Z" fill="currentColor"/>\\n</svg>',
    heading: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M2.75 17H15.25C15.6642 17 16 17.3358 16 17.75C16 18.1297 15.7178 18.4435 15.3518 18.4932L15.25 18.5H2.75C2.33579 18.5 2 18.1642 2 17.75C2 17.3703 2.28215 17.0565 2.64823 17.0068L2.75 17H15.25H2.75ZM2.75 13H21.25C21.6642 13 22 13.3358 22 13.75C22 14.1297 21.7178 14.4435 21.3518 14.4932L21.25 14.5H2.75C2.33579 14.5 2 14.1642 2 13.75C2 13.3703 2.28215 13.0565 2.64823 13.0068L2.75 13H21.25H2.75ZM2.75 9H21.25C21.6642 9 22 9.33579 22 9.75C22 10.1297 21.7178 10.4435 21.3518 10.4932L21.25 10.5H2.75C2.33579 10.5 2 10.1642 2 9.75C2 9.3703 2.28215 9.05651 2.64823 9.00685L2.75 9H21.25H2.75ZM2.75 5H21.25C21.6642 5 22 5.33579 22 5.75C22 6.1297 21.7178 6.44349 21.3518 6.49315L21.25 6.5H2.75C2.33579 6.5 2 6.16421 2 5.75C2 5.3703 2.28215 5.05651 2.64823 5.00685L2.75 5H21.25H2.75Z" fill="currentColor"/>\\n</svg>',
    image: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M17.75 3C19.5449 3 21 4.45507 21 6.25V17.75C21 19.5449 19.5449 21 17.75 21H6.25C4.45507 21 3 19.5449 3 17.75V6.25C3 4.45507 4.45507 3 6.25 3H17.75ZM18.3305 19.4014L12.5247 13.7148C12.2596 13.4553 11.8501 13.4316 11.5588 13.644L11.4752 13.7148L5.66845 19.4011C5.8504 19.4651 6.04613 19.5 6.25 19.5H17.75C17.9535 19.5 18.1489 19.4653 18.3305 19.4014L12.5247 13.7148L18.3305 19.4014ZM17.75 4.5H6.25C5.2835 4.5 4.5 5.2835 4.5 6.25V17.75C4.5 17.9584 4.53643 18.1583 4.60326 18.3437L10.4258 12.643C11.2589 11.8273 12.5675 11.7885 13.4458 12.5266L13.5742 12.6431L19.3964 18.3447C19.4634 18.159 19.5 17.9588 19.5 17.75V6.25C19.5 5.2835 18.7165 4.5 17.75 4.5ZM15.2521 6.5C16.4959 6.5 17.5042 7.50831 17.5042 8.75212C17.5042 9.99592 16.4959 11.0042 15.2521 11.0042C14.0083 11.0042 13 9.99592 13 8.75212C13 7.50831 14.0083 6.5 15.2521 6.5ZM15.2521 8C14.8367 8 14.5 8.33673 14.5 8.75212C14.5 9.1675 14.8367 9.50423 15.2521 9.50423C15.6675 9.50423 16.0042 9.1675 16.0042 8.75212C16.0042 8.33673 15.6675 8 15.2521 8Z" fill="currentColor"/>\\n</svg>',
    italic: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M9.75084 4H18.2544C18.6683 4 19.0039 4.33565 19.0039 4.74969C19.0039 5.12923 18.7219 5.4429 18.3561 5.49254L18.2544 5.49938L15.0569 5.499L10.0369 18.5H14.2497C14.6291 18.5 14.9427 18.7823 14.9923 19.1483L14.9992 19.25C14.9992 19.6295 14.7172 19.9435 14.3514 19.9932L14.2497 20H4.75037C4.33642 20 4.00391 19.664 4.00391 19.25C4.00391 18.8705 4.28331 18.5565 4.64872 18.5068L4.75037 18.5H8.43491L8.45616 18.4349L13.4499 5.499L9.75084 5.49938C9.37138 5.49938 9.05739 5.21735 9.00769 4.85142L9.00084 4.74969C9.00084 4.37015 9.28321 4.05649 9.64912 4.00684L9.75084 4H18.2544H9.75084Z" fill="currentColor"/>\\n</svg>',
    link: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M9.25 7C9.66421 7 10 7.33579 10 7.75C10 8.12656 9.72249 8.4383 9.36083 8.49187L9.25 8.5H7C5.067 8.5 3.5 10.067 3.5 12C3.5 13.864 4.95707 15.3876 6.79435 15.4941L7 15.5H9.25C9.66421 15.5 10 15.8358 10 16.25C10 16.6266 9.72249 16.9383 9.36083 16.9919L9.25 17H7C4.23858 17 2 14.7614 2 12C2 9.32226 4.10496 7.13615 6.75045 7.00612L7 7H9.25ZM17 7C19.7614 7 22 9.23858 22 12C22 14.6777 19.895 16.8638 17.2495 16.9939L17 17H14.75C14.3358 17 14 16.6642 14 16.25C14 15.8734 14.2775 15.5617 14.6392 15.5081L14.75 15.5H17C18.933 15.5 20.5 13.933 20.5 12C20.5 10.136 19.0429 8.6124 17.2057 8.50594L17 8.5H14.75C14.3358 8.5 14 8.16421 14 7.75C14 7.37344 14.2775 7.0617 14.6392 7.00813L14.75 7H17ZM7 11.25H17C17.4142 11.25 17.75 11.5858 17.75 12C17.75 12.3797 17.4678 12.6935 17.1018 12.7432L17 12.75H7C6.58579 12.75 6.25 12.4142 6.25 12C6.25 11.6203 6.53215 11.3065 6.89823 11.2568L7 11.25H17H7Z" fill="currentColor"/>\\n</svg>',
    listBulleted: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M3.24929 17.5C3.93925 17.5 4.49858 18.0593 4.49858 18.7493C4.49858 19.4393 3.93925 19.9986 3.24929 19.9986C2.55933 19.9986 2 19.4393 2 18.7493C2 18.0593 2.55933 17.5 3.24929 17.5ZM6.75 18H21.25C21.6642 18 22 18.3358 22 18.75C22 19.1297 21.7178 19.4435 21.3518 19.4932L21.25 19.5H6.75C6.33579 19.5 6 19.1642 6 18.75C6 18.3703 6.28215 18.0565 6.64823 18.0068L6.75 18H21.25H6.75ZM3.24929 11C3.93925 11 4.49858 11.5593 4.49858 12.2493C4.49858 12.9393 3.93925 13.4986 3.24929 13.4986C2.55933 13.4986 2 12.9393 2 12.2493C2 11.5593 2.55933 11 3.24929 11ZM6.75 11.5H21.25C21.6642 11.5 22 11.8358 22 12.25C22 12.6297 21.7178 12.9435 21.3518 12.9932L21.25 13H6.75C6.33579 13 6 12.6642 6 12.25C6 11.8703 6.28215 11.5565 6.64823 11.5068L6.75 11.5H21.25H6.75ZM3.24929 4.5C3.93925 4.5 4.49858 5.05933 4.49858 5.74929C4.49858 6.43925 3.93925 6.99858 3.24929 6.99858C2.55933 6.99858 2 6.43925 2 5.74929C2 5.05933 2.55933 4.5 3.24929 4.5ZM6.75 5H21.25C21.6642 5 22 5.33579 22 5.75C22 6.1297 21.7178 6.44349 21.3518 6.49315L21.25 6.5H6.75C6.33579 6.5 6 6.16421 6 5.75C6 5.3703 6.28215 5.05651 6.64823 5.00685L6.75 5H21.25H6.75Z" fill="currentColor"/>\\n</svg>',
    listNumbered: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M6.0001 2.75007C6.0001 2.39585 5.75227 2.08992 5.40576 2.0164C5.06011 1.94307 4.7103 2.12094 4.5658 2.44311L4.56426 2.44645C4.56226 2.45075 4.55842 2.45889 4.55275 2.47049C4.5414 2.49373 4.52282 2.53063 4.49704 2.57815C4.44527 2.67364 4.36584 2.80953 4.2594 2.96255C4.04176 3.27544 3.73538 3.62496 3.35275 3.86399C3.00144 4.08344 2.89456 4.54613 3.11401 4.89743C3.33346 5.24873 3.79615 5.35562 4.14746 5.13616C4.27205 5.05833 4.38956 4.97481 4.5001 4.88772V7.25007C4.5001 7.66429 4.83589 8.00007 5.2501 8.00007C5.66431 8.00007 6.0001 7.66429 6.0001 7.25007V2.75007ZM20.4995 18.7501C20.4995 18.3359 20.1637 18.0001 19.7495 18.0001H10.7495C10.3353 18.0001 9.99951 18.3359 9.99951 18.7501C9.99951 19.1643 10.3353 19.5001 10.7495 19.5001H19.7495C20.1637 19.5001 20.4995 19.1643 20.4995 18.7501ZM20.4995 12.2437C20.4995 11.8295 20.1637 11.4937 19.7495 11.4937H10.7495C10.3353 11.4937 9.99951 11.8295 9.99951 12.2437C9.99951 12.658 10.3353 12.9937 10.7495 12.9937H19.7495C20.1637 12.9937 20.4995 12.658 20.4995 12.2437ZM20.4995 5.75008C20.4995 5.33586 20.1637 5.00008 19.7495 5.00008H10.7495C10.3353 5.00008 9.99951 5.33586 9.99951 5.75008C9.99951 6.16429 10.3353 6.50008 10.7495 6.50008H19.7495C20.1637 6.50008 20.4995 6.16429 20.4995 5.75008ZM5.15093 10.52C4.84957 10.4668 4.47444 10.5864 4.28031 10.7805C3.98741 11.0733 3.51253 11.0733 3.21965 10.7804C2.92677 10.4875 2.92678 10.0127 3.21969 9.71977C3.77556 9.16393 4.65044 8.90848 5.41157 9.04278C5.809 9.11291 6.2173 9.29717 6.52722 9.64842C6.8426 10.0058 7 10.4727 7 11.0001C7 11.6195 6.72895 12.0801 6.39406 12.4206C6.1163 12.7029 5.76315 12.9311 5.48826 13.1087L5.40874 13.1602C5.21348 13.2871 5.05428 13.3971 4.92686 13.5001H6.25C6.66421 13.5001 7 13.8359 7 14.2501C7 14.6643 6.6642 15.0001 6.24999 15.0001H3.75C3.33579 15.0001 3 14.6643 3 14.2501C3 12.9365 3.98385 12.2972 4.57505 11.913L4.63522 11.8739C4.95259 11.6678 5.16843 11.5275 5.32469 11.3687C5.45855 11.2326 5.5 11.1307 5.5 11.0001C5.5 10.7775 5.43865 10.6819 5.40247 10.6409C5.36083 10.5937 5.28475 10.5436 5.15093 10.52ZM2.96967 21.2804C2.96967 21.2804 3.06251 21.3641 2.97426 21.2849L2.97962 21.2902L2.9929 21.3028C3.00287 21.3122 3.01509 21.3233 3.02956 21.336C3.05848 21.3613 3.09653 21.3928 3.14375 21.4282C3.2381 21.499 3.36996 21.5861 3.53959 21.6709C3.88131 21.8418 4.37043 22.0001 5 22.0001C5.63921 22.0001 6.19596 21.8187 6.60132 21.4606C7.00922 21.1001 7.21163 20.6032 7.19553 20.1011C7.18219 19.6847 7.02903 19.3054 6.76986 19.0001C7.02903 18.6948 7.18219 18.3155 7.19553 17.8991C7.21163 17.3969 7.00922 16.9 6.60132 16.5396C6.19596 16.1814 5.63921 16.0001 5 16.0001C4.37043 16.0001 3.88131 16.1584 3.53959 16.3293C3.36996 16.4141 3.2381 16.5012 3.14375 16.572C3.09653 16.6074 3.05848 16.6389 3.02956 16.6642C3.01509 16.6768 3.00287 16.688 2.9929 16.6973L2.97962 16.71L2.97423 16.7152L2.97189 16.7176L2.97091 16.7185L2.96967 16.7197C2.67678 17.0126 2.67678 17.4875 2.96967 17.7804C3.2586 18.0693 3.72462 18.0732 4.01834 17.7921C4.0217 17.7892 4.03018 17.7821 4.04375 17.772C4.0744 17.749 4.13004 17.7111 4.21041 17.6709C4.36869 17.5918 4.62957 17.5001 5 17.5001C5.36079 17.5001 5.53601 17.6 5.60812 17.6637C5.67768 17.7251 5.69823 17.7907 5.6963 17.8511C5.69423 17.9156 5.66403 18.0028 5.57278 18.0819C5.4845 18.1585 5.30962 18.2501 5 18.2501C4.58579 18.2501 4.25 18.5859 4.25 19.0001C4.25 19.4143 4.58579 19.7501 5 19.7501C5.30962 19.7501 5.4845 19.8417 5.57278 19.9183C5.66403 19.9974 5.69423 20.0845 5.6963 20.1491C5.69823 20.2094 5.67768 20.275 5.60812 20.3365C5.53601 20.4002 5.36079 20.5001 5 20.5001C4.62957 20.5001 4.36869 20.4084 4.21041 20.3293C4.13004 20.2891 4.0744 20.2512 4.04375 20.2282C4.03018 20.218 4.0217 20.2109 4.01834 20.208C3.72462 19.9269 3.2586 19.9308 2.96967 20.2197C2.67678 20.5126 2.67678 20.9875 2.96967 21.2804ZM2.97189 16.7176L2.97091 16.7185C2.9776 16.713 3.17182 16.5516 2.97189 16.7176Z" fill="currentColor"/>\\n</svg>',
    mention: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M12 2C17.5226 2.00016 21.9999 6.47737 22 12C22 15.0893 20.3198 17.0254 18.25 17.0254C16.9541 17.0254 15.8114 16.2662 15.1377 14.9404C14.3338 16.173 13.0311 17 11.5 17C8.92926 17 7 14.6705 7 12C7 9.32955 8.92926 7 11.5 7C12.6753 7 13.7159 7.48764 14.5 8.27148V7.75C14.5 7.33579 14.8358 7 15.25 7C15.6642 7 16 7.33579 16 7.75V12C16 14.6107 17.3198 15.5254 18.25 15.5254C19.1802 15.5254 20.5 14.6107 20.5 12C20.4999 7.30579 16.6942 3.50016 12 3.5C7.30566 3.5 3.50013 7.30569 3.5 12C3.50016 16.6943 7.30568 20.5 12 20.5C13.0151 20.5 13.9884 20.3201 14.8906 19.9932C15.189 19.8853 15.5266 19.9466 15.751 20.1709C16.1231 20.5431 16.0216 21.1702 15.5293 21.3564C14.4319 21.7717 13.2428 22 12 22C6.47725 22 2.00016 17.5227 2 12C2.00013 6.47726 6.47723 2 12 2ZM11.5 8.5C9.92861 8.5 8.5 9.97603 8.5 12C8.5 14.024 9.92861 15.5 11.5 15.5C13.0714 15.5 14.5 14.024 14.5 12C14.5 9.97603 13.0714 8.5 11.5 8.5Z" fill="currentColor"/>\\n</svg>',
    minus: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M3.75391 12.5H20.2458C20.66 12.5 20.9958 12.1642 20.9958 11.75C20.9958 11.3358 20.66 11 20.2458 11H3.75391C3.33969 11 3.00391 11.3358 3.00391 11.75C3.00391 12.1642 3.33969 12.5 3.75391 12.5Z" fill="currentColor"/>\\n</svg>',
    more: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M7.75 12C7.75 12.9665 6.9665 13.75 6 13.75C5.0335 13.75 4.25 12.9665 4.25 12C4.25 11.0335 5.0335 10.25 6 10.25C6.9665 10.25 7.75 11.0335 7.75 12ZM13.75 12C13.75 12.9665 12.9665 13.75 12 13.75C11.0335 13.75 10.25 12.9665 10.25 12C10.25 11.0335 11.0335 10.25 12 10.25C12.9665 10.25 13.75 11.0335 13.75 12ZM18 13.75C18.9665 13.75 19.75 12.9665 19.75 12C19.75 11.0335 18.9665 10.25 18 10.25C17.0335 10.25 16.25 11.0335 16.25 12C16.25 12.9665 17.0335 13.75 18 13.75Z" fill="currentColor"/>\\n</svg>',
    moreVertical: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M12 7.75C11.0335 7.75 10.25 6.9665 10.25 6C10.25 5.0335 11.0335 4.25 12 4.25C12.9665 4.25 13.75 5.0335 13.75 6C13.75 6.9665 12.9665 7.75 12 7.75ZM12 13.75C11.0335 13.75 10.25 12.9665 10.25 12C10.25 11.0335 11.0335 10.25 12 10.25C12.9665 10.25 13.75 11.0335 13.75 12C13.75 12.9665 12.9665 13.75 12 13.75ZM10.25 18C10.25 18.9665 11.0335 19.75 12 19.75C12.9665 19.75 13.75 18.9665 13.75 18C13.75 17.0335 12.9665 16.25 12 16.25C11.0335 16.25 10.25 17.0335 10.25 18Z" fill="currentColor"/>\\n</svg>',
    people: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M5.5 8C5.5 6.61929 6.61929 5.5 8 5.5C9.38071 5.5 10.5 6.61929 10.5 8C10.5 9.38071 9.38071 10.5 8 10.5C6.61929 10.5 5.5 9.38071 5.5 8ZM8 4C5.79086 4 4 5.79086 4 8C4 10.2091 5.79086 12 8 12C10.2091 12 12 10.2091 12 8C12 5.79086 10.2091 4 8 4ZM15.5 9C15.5 8.17157 16.1716 7.5 17 7.5C17.8284 7.5 18.5 8.17157 18.5 9C18.5 9.82843 17.8284 10.5 17 10.5C16.1716 10.5 15.5 9.82843 15.5 9ZM17 6C15.3431 6 14 7.34315 14 9C14 10.6569 15.3431 12 17 12C18.6569 12 20 10.6569 20 9C20 7.34315 18.6569 6 17 6ZM14.2484 19.0377C14.9507 19.3232 15.8517 19.5 17.001 19.5C19.2833 19.5 20.5867 18.8027 21.2979 17.9421C21.643 17.5244 21.8186 17.1027 21.9077 16.7795C21.9521 16.6181 21.9754 16.48 21.9875 16.377C21.9936 16.3254 21.997 16.2821 21.9988 16.2487C21.9997 16.232 22.0003 16.2177 22.0006 16.2059L22.0009 16.1903L22.001 16.1839L22.001 16.1811L22.001 16.1786C22.001 14.9754 21.0256 14 19.8224 14H14.1796C14.1521 14 14.1248 14.0005 14.0977 14.0015C14.4916 14.4126 14.7787 14.927 14.914 15.5H19.8224C20.194 15.5 20.4958 15.7986 20.5009 16.1689C20.5006 16.1746 20.4997 16.1855 20.4979 16.2011C20.4934 16.2387 20.4835 16.3015 20.4615 16.3812C20.4177 16.5402 20.3277 16.7613 20.1416 16.9865C19.7903 17.4116 18.9687 18 17.001 18C16.0209 18 15.3252 17.854 14.8302 17.655C14.7231 18.0551 14.5452 18.5378 14.2484 19.0377ZM4.25 14C3.00736 14 2 15.0074 2 16.25V16.5011L2 16.5022L2.00001 16.5048L2.00007 16.5111L2.00035 16.5277C2.00064 16.5406 2.00117 16.5571 2.0021 16.5771C2.00396 16.6169 2.00745 16.6705 2.01398 16.7358C2.02701 16.8661 2.05233 17.045 2.10165 17.2564C2.19995 17.6776 2.39654 18.2404 2.79183 18.8051C3.61066 19.9749 5.17178 21 8 21C10.8282 21 12.3893 19.9749 13.2082 18.8051C13.6035 18.2404 13.8001 17.6776 13.8983 17.2564C13.9477 17.045 13.973 16.8661 13.986 16.7358C13.9926 16.6705 13.996 16.6169 13.9979 16.5771C13.9988 16.5571 13.9994 16.5406 13.9996 16.5277L13.9999 16.5111L14 16.5048L14 16.5022L14 16.25C14 15.0074 12.9926 14 11.75 14H4.25ZM3.50047 16.5072L3.5 16.4947V16.25C3.5 15.8358 3.83579 15.5 4.25 15.5H11.75C12.1642 15.5 12.5 15.8358 12.5 16.25V16.4946L12.4995 16.5072C12.4988 16.5222 12.4972 16.5493 12.4935 16.5865C12.486 16.6612 12.4703 16.7753 12.4376 16.9155C12.3718 17.1974 12.2403 17.5721 11.9793 17.9449C11.4857 18.6501 10.4218 19.5 8 19.5C5.57822 19.5 4.51434 18.6501 4.02067 17.9449C3.75971 17.5721 3.62818 17.1974 3.56241 16.9155C3.5297 16.7753 3.514 16.6612 3.50653 16.5865C3.50281 16.5493 3.50117 16.5222 3.50047 16.5072Z" fill="currentColor"/>\\n</svg>',
    person: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M17.7545 14.0002C18.9966 14.0002 20.0034 15.007 20.0034 16.2491V16.8245C20.0034 17.7188 19.6838 18.5836 19.1023 19.263C17.5329 21.0965 15.1457 22.0013 12.0004 22.0013C8.8545 22.0013 6.46849 21.0962 4.90219 19.2619C4.32242 18.583 4.00391 17.7195 4.00391 16.8267V16.2491C4.00391 15.007 5.01076 14.0002 6.25278 14.0002H17.7545ZM17.7545 15.5002H6.25278C5.83919 15.5002 5.50391 15.8355 5.50391 16.2491V16.8267C5.50391 17.3624 5.69502 17.8805 6.04287 18.2878C7.29618 19.7555 9.26206 20.5013 12.0004 20.5013C14.7387 20.5013 16.7063 19.7555 17.9627 18.2876C18.3117 17.8799 18.5034 17.361 18.5034 16.8245V16.2491C18.5034 15.8355 18.1681 15.5002 17.7545 15.5002ZM12.0004 2.00488C14.7618 2.00488 17.0004 4.24346 17.0004 7.00488C17.0004 9.76631 14.7618 12.0049 12.0004 12.0049C9.23894 12.0049 7.00036 9.76631 7.00036 7.00488C7.00036 4.24346 9.23894 2.00488 12.0004 2.00488ZM12.0004 3.50488C10.0674 3.50488 8.50036 5.07189 8.50036 7.00488C8.50036 8.93788 10.0674 10.5049 12.0004 10.5049C13.9334 10.5049 15.5004 8.93788 15.5004 7.00488C15.5004 5.07189 13.9334 3.50488 12.0004 3.50488Z" fill="currentColor"/>\\n</svg>',
    pin: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M16.2425 2.93189L21.0682 7.75765C22.3955 9.08491 22.0324 11.3224 20.3535 12.1619L15.4826 14.5973C15.3073 14.685 15.1732 14.8379 15.1092 15.0232L13.6699 19.1895C13.3684 20.0622 12.2574 20.3181 11.6045 19.6653L8.50002 16.5607L4.06074 21.0001H3L3.00008 19.9394L7.43936 15.5001L4.33487 12.3956C3.682 11.7427 3.93791 10.6317 4.81061 10.3302L8.97688 8.89096C9.16223 8.82694 9.31512 8.69287 9.40281 8.51748L11.8382 3.6466C12.6777 1.96772 14.9152 1.60462 16.2425 2.93189ZM20.0076 8.81831L15.1818 3.99255C14.5785 3.38924 13.5614 3.55429 13.1799 4.31742L10.7445 9.18829C10.4814 9.71446 10.0227 10.1167 9.46666 10.3087L5.67812 11.6175L12.3826 18.322L13.6914 14.5335C13.8835 13.9774 14.2857 13.5188 14.8118 13.2557L19.6827 10.8202C20.4458 10.4387 20.6109 9.42161 20.0076 8.81831Z" fill="currentColor"/>\\n</svg>',
    quote: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M8 5C9.62875 5 10.9526 6.29802 10.9971 7.91602C11.0002 7.94363 11.0029 7.97156 11.0029 8C11.0029 10.9327 9.936 13.3818 8.88965 15.0811C8.3651 15.9329 7.84001 16.6051 7.44434 17.0664C7.24631 17.2973 7.0797 17.4767 6.96094 17.5996C6.9017 17.6609 6.85398 17.7081 6.82031 17.7412C6.80346 17.7578 6.78999 17.771 6.78027 17.7803C6.77548 17.7849 6.77151 17.7892 6.76855 17.792C6.76721 17.7933 6.76558 17.794 6.76465 17.7949L6.76367 17.7969C6.46146 18.08 5.98635 18.0648 5.70312 17.7627C5.41997 17.4605 5.4352 16.9863 5.7373 16.7031C5.73816 16.7023 5.73972 16.7006 5.74219 16.6982C5.74761 16.693 5.75709 16.6841 5.76953 16.6719C5.79442 16.6474 5.83279 16.6084 5.88281 16.5566C5.98286 16.4531 6.12878 16.2961 6.30566 16.0898C6.6604 15.6762 7.1363 15.067 7.6123 14.2939C8.19982 13.3398 8.77816 12.1484 9.1377 10.7754C8.78672 10.9194 8.40287 11 8 11C6.34315 11 5 9.65685 5 8C5 6.34315 6.34315 5 8 5ZM16 5C17.6288 5 18.9526 6.29802 18.9971 7.91602C19.0002 7.94363 19.0029 7.97156 19.0029 8C19.0029 10.9327 17.936 13.3818 16.8896 15.0811C16.3651 15.9329 15.84 16.6051 15.4443 17.0664C15.2463 17.2973 15.0797 17.4767 14.9609 17.5996C14.9017 17.6609 14.854 17.7081 14.8203 17.7412C14.8035 17.7578 14.79 17.771 14.7803 17.7803C14.7755 17.7849 14.7715 17.7892 14.7686 17.792C14.7672 17.7933 14.7656 17.794 14.7646 17.7949L14.7637 17.7969C14.4615 18.08 13.9863 18.0648 13.7031 17.7627C13.42 17.4605 13.4352 16.9863 13.7373 16.7031C13.7382 16.7023 13.7397 16.7006 13.7422 16.6982C13.7476 16.693 13.7571 16.6841 13.7695 16.6719C13.7944 16.6474 13.8328 16.6084 13.8828 16.5566C13.9829 16.4531 14.1288 16.2961 14.3057 16.0898C14.6604 15.6762 15.1363 15.067 15.6123 14.2939C16.1998 13.3398 16.7782 12.1484 17.1377 10.7754C16.7867 10.9194 16.4029 11 16 11C14.3431 11 13 9.65685 13 8C13 6.34315 14.3431 5 16 5ZM8 6.5C7.17157 6.5 6.5 7.17157 6.5 8C6.5 8.82843 7.17157 9.5 8 9.5C8.82843 9.5 9.5 8.82843 9.5 8C9.5 7.17157 8.82843 6.5 8 6.5ZM16 6.5C15.1716 6.5 14.5 7.17157 14.5 8C14.5 8.82843 15.1716 9.5 16 9.5C16.8284 9.5 17.5 8.82843 17.5 8C17.5 7.17157 16.8284 6.5 16 6.5Z" fill="currentColor"/>\\n</svg>',
    reply: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M9.28033 6.28033C9.57322 5.98744 9.57322 5.51256 9.28033 5.21967C8.98744 4.92678 8.51256 4.92678 8.21967 5.21967L3.21967 10.2197C2.92678 10.5126 2.92678 10.9874 3.21967 11.2803L8.21967 16.2803C8.51256 16.5732 8.98744 16.5732 9.28033 16.2803C9.57322 15.9874 9.57322 15.5126 9.28033 15.2197L5.56066 11.5H13.25C16.7018 11.5 19.5 14.2982 19.5 17.75V18.25C19.5 18.6642 19.8358 19 20.25 19C20.6642 19 21 18.6642 21 18.25V17.75C21 13.4698 17.5302 10 13.25 10H5.56066L9.28033 6.28033Z" fill="currentColor"/>\\n</svg>',
    save: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M3 5.75C3 4.23122 4.23122 3 5.75 3H15.7145C16.5764 3 17.4031 3.34241 18.0126 3.9519L20.0481 5.98744C20.6576 6.59693 21 7.42358 21 8.28553V18.25C21 19.7688 19.7688 21 18.25 21H5.75C4.23122 21 3 19.7688 3 18.25V5.75ZM5.75 4.5C5.05964 4.5 4.5 5.05964 4.5 5.75V18.25C4.5 18.9404 5.05964 19.5 5.75 19.5H6V14.25C6 13.0074 7.00736 12 8.25 12H15.75C16.9926 12 18 13.0074 18 14.25V19.5H18.25C18.9404 19.5 19.5 18.9404 19.5 18.25V8.28553C19.5 7.8214 19.3156 7.37629 18.9874 7.0481L16.9519 5.01256C16.6918 4.75246 16.3582 4.58269 16 4.52344V7.25C16 8.49264 14.9926 9.5 13.75 9.5H9.25C8.00736 9.5 7 8.49264 7 7.25V4.5H5.75ZM16.5 19.5V14.25C16.5 13.8358 16.1642 13.5 15.75 13.5H8.25C7.83579 13.5 7.5 13.8358 7.5 14.25V19.5H16.5ZM8.5 4.5V7.25C8.5 7.66421 8.83579 8 9.25 8H13.75C14.1642 8 14.5 7.66421 14.5 7.25V4.5H8.5Z" fill="currentColor"/>\\n</svg>',
    search: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M16.1017 17.1624C14.717 18.3101 12.9391 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11C19 12.9391 18.3101 14.717 17.1624 16.1018L21.7803 20.7197C22.0732 21.0126 22.0732 21.4874 21.7803 21.7803C21.4874 22.0732 21.0125 22.0732 20.7196 21.7803L16.1017 17.1624ZM17.5 11C17.5 7.41015 14.5899 4.5 11 4.5C7.41015 4.5 4.5 7.41015 4.5 11C4.5 14.5899 7.41015 17.5 11 17.5C14.5899 17.5 17.5 14.5899 17.5 11Z" fill="currentColor"/>\\n</svg>',
    send: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M5.69362 11.9997L2.29933 3.2715C2.0631 2.66403 2.65544 2.08309 3.2414 2.28959L3.33375 2.32885L21.3337 11.3288C21.852 11.588 21.8844 12.2975 21.4309 12.6129L21.3337 12.6705L3.33375 21.6705C2.75077 21.962 2.11746 21.426 2.2688 20.8234L2.29933 20.7278L5.69362 11.9997L2.29933 3.2715L5.69362 11.9997ZM4.4021 4.54007L7.01109 11.2491L13.6387 11.2497C14.0184 11.2497 14.3322 11.5318 14.3818 11.8979L14.3887 11.9997C14.3887 12.3794 14.1065 12.6932 13.7404 12.7428L13.6387 12.7497L7.01109 12.7491L4.4021 19.4593L19.3213 11.9997L4.4021 4.54007Z" fill="currentColor"/>\\n</svg>',
    settings: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M12.0122 2.25C12.7462 2.25846 13.4773 2.34326 14.1937 2.50304C14.5064 2.57279 14.7403 2.83351 14.7758 3.15196L14.946 4.67881C15.0231 5.37986 15.615 5.91084 16.3206 5.91158C16.5103 5.91188 16.6979 5.87238 16.8732 5.79483L18.2738 5.17956C18.5651 5.05159 18.9055 5.12136 19.1229 5.35362C20.1351 6.43464 20.8889 7.73115 21.3277 9.14558C21.4223 9.45058 21.3134 9.78203 21.0564 9.9715L19.8149 10.8866C19.4607 11.1468 19.2516 11.56 19.2516 11.9995C19.2516 12.4389 19.4607 12.8521 19.8157 13.1129L21.0582 14.0283C21.3153 14.2177 21.4243 14.5492 21.3297 14.8543C20.8911 16.2685 20.1377 17.5649 19.1261 18.6461C18.9089 18.8783 18.5688 18.9483 18.2775 18.8206L16.8712 18.2045C16.4688 18.0284 16.0068 18.0542 15.6265 18.274C15.2463 18.4937 14.9933 18.8812 14.945 19.3177L14.7759 20.8444C14.741 21.1592 14.5122 21.4182 14.204 21.4915C12.7556 21.8361 11.2465 21.8361 9.79803 21.4915C9.48991 21.4182 9.26105 21.1592 9.22618 20.8444L9.05736 19.32C9.00777 18.8843 8.75434 18.498 8.37442 18.279C7.99451 18.06 7.5332 18.0343 7.1322 18.2094L5.72557 18.8256C5.43422 18.9533 5.09403 18.8833 4.87678 18.6509C3.86462 17.5685 3.11119 16.2705 2.6732 14.8548C2.57886 14.5499 2.68786 14.2186 2.94485 14.0293L4.18818 13.1133C4.54232 12.8531 4.75147 12.4399 4.75147 12.0005C4.75147 11.561 4.54232 11.1478 4.18771 10.8873L2.94516 9.97285C2.6878 9.78345 2.5787 9.45178 2.67337 9.14658C3.11212 7.73215 3.86594 6.43564 4.87813 5.35462C5.09559 5.12236 5.43594 5.05259 5.72724 5.18056L7.12762 5.79572C7.53056 5.97256 7.9938 5.94585 8.37577 5.72269C8.75609 5.50209 9.00929 5.11422 9.05817 4.67764L9.22824 3.15196C9.26376 2.83335 9.49786 2.57254 9.8108 2.50294C10.5281 2.34342 11.26 2.25865 12.0122 2.25ZM12.0124 3.7499C11.5583 3.75524 11.1056 3.79443 10.6578 3.86702L10.5489 4.84418C10.4471 5.75368 9.92003 6.56102 9.13042 7.01903C8.33597 7.48317 7.36736 7.53903 6.52458 7.16917L5.62629 6.77456C5.05436 7.46873 4.59914 8.25135 4.27852 9.09168L5.07632 9.67879C5.81513 10.2216 6.25147 11.0837 6.25147 12.0005C6.25147 12.9172 5.81513 13.7793 5.0771 14.3215L4.27805 14.9102C4.59839 15.752 5.05368 16.5361 5.626 17.2316L6.53113 16.8351C7.36923 16.4692 8.33124 16.5227 9.12353 16.9794C9.91581 17.4361 10.4443 18.2417 10.548 19.1526L10.657 20.1365C11.5466 20.2878 12.4555 20.2878 13.3451 20.1365L13.4541 19.1527C13.5549 18.2421 14.0828 17.4337 14.876 16.9753C15.6692 16.5168 16.6332 16.463 17.4728 16.8305L18.3772 17.2267C18.949 16.5323 19.4041 15.7495 19.7247 14.909L18.9267 14.3211C18.1879 13.7783 17.7516 12.9162 17.7516 11.9995C17.7516 11.0827 18.1879 10.2206 18.9258 9.67847L19.7227 9.09109C19.4021 8.25061 18.9468 7.46784 18.3748 6.77356L17.4783 7.16737C17.113 7.32901 16.7178 7.4122 16.3187 7.41158C14.849 7.41004 13.6155 6.30355 13.4551 4.84383L13.3462 3.8667C12.9007 3.7942 12.4526 3.75512 12.0124 3.7499ZM11.9997 8.24995C14.0708 8.24995 15.7497 9.92888 15.7497 12C15.7497 14.071 14.0708 15.75 11.9997 15.75C9.92863 15.75 8.2497 14.071 8.2497 12C8.2497 9.92888 9.92863 8.24995 11.9997 8.24995ZM11.9997 9.74995C10.7571 9.74995 9.7497 10.7573 9.7497 12C9.7497 13.2426 10.7571 14.25 11.9997 14.25C13.2423 14.25 14.2497 13.2426 14.2497 12C14.2497 10.7573 13.2423 9.74995 11.9997 9.74995Z" fill="currentColor"/>\\n</svg>',
    star: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M10.7878 3.10215C11.283 2.09877 12.7138 2.09876 13.209 3.10215L15.567 7.87987L20.8395 8.64601C21.9468 8.80691 22.3889 10.1677 21.5877 10.9487L17.7724 14.6676L18.6731 19.9189C18.8622 21.0217 17.7047 21.8627 16.7143 21.342L11.9984 18.8627L7.28252 21.342C6.29213 21.8627 5.13459 21.0217 5.32374 19.9189L6.2244 14.6676L2.40916 10.9487C1.60791 10.1677 2.05005 8.80691 3.15735 8.64601L8.42988 7.87987L10.7878 3.10215ZM11.9984 4.03854L9.74008 8.61443C9.54344 9.01288 9.16332 9.28904 8.72361 9.35294L3.67382 10.0867L7.32788 13.6486C7.64606 13.9587 7.79125 14.4055 7.71614 14.8435L6.85353 19.8729L11.3702 17.4983C11.7635 17.2915 12.2333 17.2915 12.6266 17.4983L17.1433 19.8729L16.2807 14.8435C16.2056 14.4055 16.3508 13.9587 16.6689 13.6486L20.323 10.0867L15.2732 9.35294C14.8335 9.28904 14.4534 9.01288 14.2568 8.61443L11.9984 4.03854Z" fill="currentColor"/>\\n</svg>',
    strikethrough: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M4.75 12.0002H19.2507C19.6649 12.0002 20.0007 12.3359 20.0007 12.7502C20.0007 13.1299 19.7185 13.4437 19.3524 13.4933L19.2507 13.5002L16.2763 13.5001C17.1552 14.3132 17.6124 15.2931 17.6124 16.4347C17.6124 19.2599 14.3804 21.0745 10.8577 20.6651C8.6233 20.4054 7.04896 19.5095 6.22285 17.9632C6.02767 17.5978 6.16562 17.1434 6.53097 16.9482C6.89632 16.7531 7.35071 16.891 7.54589 17.2564C8.11607 18.3236 9.2483 18.968 11.0308 19.1751C13.7738 19.4939 16.1124 18.1809 16.1124 16.4347C16.1124 15.2627 15.3072 14.3077 13.547 13.5485L13.431 13.5L4.75 13.5002C4.3703 13.5002 4.05651 13.218 4.00685 12.8519L4 12.7502C4 12.3705 4.28215 12.0567 4.64823 12.007L4.75 12.0002H19.2507H4.75ZM6.26098 8.12336C6.41313 5.29223 9.08273 3.65466 12.5845 4.06162C14.7732 4.31598 16.4484 5.11481 17.5674 6.47091C17.8311 6.79039 17.7858 7.2631 17.4663 7.52674C17.1469 7.79038 16.6742 7.74512 16.4105 7.42564C15.5584 6.393 14.2394 5.76405 12.4113 5.55159C9.69368 5.23576 7.76098 6.35648 7.76098 8.12336C7.76098 8.89538 7.99478 9.47149 8.59075 10.1045L8.71896 10.2372C8.81323 10.3327 8.91566 10.4324 8.96956 10.4763L9 10.4979H7.08082L7.05613 10.4589C6.91314 10.2526 6.1997 9.26354 6.26098 8.12336Z" fill="currentColor"/>\\n</svg>',
    underline: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M6.75001 19H17.25C17.6642 19 18 19.3358 18 19.75C18 20.1297 17.7179 20.4435 17.3518 20.4932L17.25 20.5H6.75001C6.33579 20.5 6.00001 20.1642 6.00001 19.75C6.00001 19.3703 6.28216 19.0565 6.64824 19.0068L6.75001 19H17.25H6.75001ZM17.25 4C17.6297 4 17.9435 4.28215 17.9932 4.64823L18 4.75V10.75C18 15.1437 15.9371 17.5 11.9971 17.5C8.14241 17.5 6.08619 15.2446 6.00265 11.0336L6 10.75V4.75C6 4.33579 6.33579 4 6.75001 4C7.1297 4 7.44349 4.28215 7.49315 4.64823L7.5 4.75V10.7507C7.49647 14.3568 8.93346 16 11.9971 16C14.9824 16 16.4251 14.4395 16.4972 11.0235L16.5 10.75V4.75C16.5 4.33579 16.8358 4 17.25 4Z" fill="currentColor"/>\\n</svg>',
    recordstop: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM8 9.5C8 8.67157 8.67157 8 9.5 8H14.5C15.3284 8 16 8.67157 16 9.5V14.5C16 15.3284 15.3284 16 14.5 16H9.5C8.67157 16 8 15.3284 8 14.5V9.5Z" fill="currentColor"/>\\n</svg>',
    mic: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M18.25 11C18.6297 11 18.9435 11.2822 18.9932 11.6482L19 11.75V12.25C19 15.8094 16.245 18.7254 12.751 18.9817L12.75 21.25C12.75 21.6642 12.4142 22 12 22C11.6203 22 11.3065 21.7178 11.2568 21.3518L11.25 21.25L11.25 18.9818C7.83323 18.7316 5.12283 15.938 5.00406 12.4863L5 12.25V11.75C5 11.3358 5.33579 11 5.75 11C6.1297 11 6.44349 11.2822 6.49315 11.6482L6.5 11.75V12.25C6.5 15.077 8.73445 17.3821 11.5336 17.4956L11.75 17.5H12.25C15.077 17.5 17.3821 15.2656 17.4956 12.4664L17.5 12.25V11.75C17.5 11.3358 17.8358 11 18.25 11ZM12 2C14.2091 2 16 3.79086 16 6V12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12V6C8 3.79086 9.79086 2 12 2ZM12 3.5C10.6193 3.5 9.5 4.61929 9.5 6V12C9.5 13.3807 10.6193 14.5 12 14.5C13.3807 14.5 14.5 13.3807 14.5 12V6C14.5 4.61929 13.3807 3.5 12 3.5Z" fill="currentColor"/>\\n</svg>',
    micOff: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M3.28034 2.21968C2.98745 1.92678 2.51257 1.92677 2.21968 2.21966C1.92678 2.51255 1.92677 2.98743 2.21966 3.28032L8 9.06078V12C8 14.2091 9.79086 16 12 16C12.8335 16 13.6074 15.7451 14.2481 15.309L15.394 16.4549C14.5176 17.1112 13.4292 17.5 12.25 17.5H11.75L11.5336 17.4956C8.73445 17.3821 6.5 15.077 6.5 12.25V11.75L6.49315 11.6482C6.44349 11.2822 6.1297 11 5.75 11C5.33579 11 5 11.3358 5 11.75V12.25L5.00406 12.4863C5.12283 15.938 7.83323 18.7316 11.25 18.9818L11.25 21.25L11.2568 21.3518C11.3065 21.7178 11.6203 22 12 22C12.4142 22 12.75 21.6642 12.75 21.25L12.751 18.9817C14.15 18.8791 15.4305 18.35 16.4631 17.5241L20.7194 21.7805C21.0123 22.0734 21.4872 22.0734 21.7801 21.7805C22.073 21.4876 22.073 21.0127 21.7801 20.7198L3.28034 2.21968ZM13.1562 14.2171C12.8105 14.3978 12.4172 14.5 12 14.5C10.6193 14.5 9.5 13.3807 9.5 12V10.5608L13.1562 14.2171ZM14.5 6V11.3182L15.9301 12.7483C15.976 12.5059 16 12.2558 16 12V6C16 3.79086 14.2091 2 12 2C10.1521 2 8.59692 3.25302 8.13768 4.95575L9.5 6.3181V6C9.5 4.61929 10.6193 3.5 12 3.5C13.3807 3.5 14.5 4.61929 14.5 6ZM17.1962 14.0144L18.3421 15.1604C18.7638 14.2791 19 13.2921 19 12.25V11.75L18.9932 11.6482C18.9435 11.2822 18.6297 11 18.25 11C17.8358 11 17.5 11.3358 17.5 11.75V12.25L17.4956 12.4664C17.4737 13.0075 17.3698 13.5276 17.1962 14.0144Z" fill="currentColor"/>\\n</svg>',
    video: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M5.25 5C3.45507 5 2 6.45507 2 8.25V15.75C2 17.5449 3.45507 19 5.25 19H12.75C14.5449 19 16 17.5449 16 15.75V15.438L19.2575 17.6872C20.4183 18.4887 22.0018 17.6578 22.0018 16.2471V7.75204C22.0018 6.34137 20.4183 5.51044 19.2575 6.31197L16 8.56118V8.25C16 6.45507 14.5449 5 12.75 5H5.25ZM16 10.384L20.1098 7.54632C20.2756 7.43181 20.5018 7.55051 20.5018 7.75204V16.2471C20.5018 16.4486 20.2756 16.5673 20.1098 16.4528L16 13.6151V10.384ZM3.5 8.25C3.5 7.2835 4.2835 6.5 5.25 6.5H12.75C13.7165 6.5 14.5 7.2835 14.5 8.25V15.75C14.5 16.7165 13.7165 17.5 12.75 17.5H5.25C4.2835 17.5 3.5 16.7165 3.5 15.75V8.25Z" fill="currentColor"/>\\n</svg>',
    videoOff: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M3.28034 2.21968C2.98745 1.92678 2.51257 1.92677 2.21968 2.21966C1.92678 2.51255 1.92677 2.98743 2.21966 3.28032L4.13545 5.19615C2.88949 5.651 2 6.84662 2 8.25V15.75C2 17.5449 3.45507 19 5.25 19H12.75C14.1533 19 15.3489 18.1106 15.8038 16.8647L20.7194 21.7805C21.0123 22.0734 21.4872 22.0734 21.7801 21.7805C22.073 21.4876 22.073 21.0127 21.7801 20.7198L3.28034 2.21968ZM14.5 15.5609V15.75C14.5 16.7165 13.7165 17.5 12.75 17.5H5.25C4.2835 17.5 3.5 16.7165 3.5 15.75V8.25C3.5 7.2835 4.2835 6.5 5.25 6.5H5.43928L14.5 15.5609ZM14.5 8.25V11.3181L16 12.8181V10.384L20.1098 7.54632C20.2756 7.43181 20.5018 7.55052 20.5018 7.75204V16.2471C20.5018 16.4486 20.2756 16.5673 20.1098 16.4528L18.5749 15.393L21.0074 17.8256C21.5776 17.5521 22.0018 16.9772 22.0018 16.2471V7.75204C22.0018 6.34137 20.4183 5.51044 19.2575 6.31197L16 8.56118V8.25C16 6.45507 14.5449 5 12.75 5H8.18205L9.68202 6.5H12.75C13.7165 6.5 14.5 7.2835 14.5 8.25Z" fill="currentColor"/>\\n</svg>',
    shareScreen: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M2 6.25C2 5.00736 3.00736 4 4.25 4H19.75C20.9926 4 22 5.00736 22 6.25V17.75C22 18.9926 20.9926 20 19.75 20H4.25C3.00736 20 2 18.9926 2 17.75V6.25ZM4.25 5.5C3.83579 5.5 3.5 5.83579 3.5 6.25V17.75C3.5 18.1642 3.83579 18.5 4.25 18.5H19.75C20.1642 18.5 20.5 18.1642 20.5 17.75V6.25C20.5 5.83579 20.1642 5.5 19.75 5.5H4.25ZM11.9997 7.24547C12.1987 7.2454 12.3896 7.32443 12.5303 7.46514L15.7848 10.7197C16.0777 11.0126 16.0777 11.4874 15.7848 11.7803C15.4919 12.0732 15.0171 12.0732 14.7242 11.7803L12.75 9.80613V16.2528C12.75 16.667 12.4142 17.0028 12 17.0028C11.5858 17.0028 11.25 16.667 11.25 16.2528V9.80791L9.2807 11.7799C8.98801 12.073 8.51314 12.0734 8.22004 11.7807C7.92694 11.488 7.92661 11.0131 8.2193 10.72L11.4693 7.46551C11.6099 7.3247 11.8007 7.24554 11.9997 7.24547Z" fill="currentColor"/>\\n</svg>',
    closedCaption: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M18.75 4C20.5449 4 22 5.45507 22 7.25V16.7546C22 18.5495 20.5449 20.0046 18.75 20.0046H5.25C3.45507 20.0046 2 18.5495 2 16.7546V7.25C2 5.51697 3.35645 4.10075 5.06558 4.00514L5.25 4H18.75ZM18.75 5.5H5.25L5.10647 5.5058C4.20711 5.57881 3.5 6.33183 3.5 7.25V16.7546C3.5 17.7211 4.2835 18.5046 5.25 18.5046H18.75C19.7165 18.5046 20.5 17.7211 20.5 16.7546V7.25C20.5 6.2835 19.7165 5.5 18.75 5.5ZM5.5 12C5.5 8.85442 8.21322 7.22469 10.6216 8.59854C10.9814 8.80378 11.1067 9.26183 10.9015 9.62162C10.6962 9.98141 10.2382 10.1067 9.87838 9.90146C8.48071 9.10417 7 9.99357 7 12C7 14.0046 8.48411 14.8962 9.8792 14.1027C10.2392 13.8979 10.6971 14.0238 10.9019 14.3838C11.1067 14.7439 10.9808 15.2018 10.6208 15.4066C8.21539 16.7747 5.5 15.1433 5.5 12ZM13 12C13 8.85442 15.7132 7.22469 18.1216 8.59854C18.4814 8.80378 18.6067 9.26183 18.4015 9.62162C18.1962 9.98141 17.7382 10.1067 17.3784 9.90146C15.9807 9.10417 14.5 9.99357 14.5 12C14.5 14.0046 15.9841 14.8962 17.3792 14.1027C17.7392 13.8979 18.1971 14.0238 18.4019 14.3838C18.6067 14.7439 18.4808 15.2018 18.1208 15.4066C15.7154 16.7747 13 15.1433 13 12Z" fill="currentColor"/>\\n</svg>',
    archive: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M10.25 11C9.83579 11 9.5 11.3358 9.5 11.75C9.5 12.1642 9.83579 12.5 10.25 12.5H13.75C14.1642 12.5 14.5 12.1642 14.5 11.75C14.5 11.3358 14.1642 11 13.75 11H10.25ZM3 5.25C3 4.00736 4.00736 3 5.25 3H18.75C19.9926 3 21 4.00736 21 5.25V6.75C21 7.5301 20.603 8.21748 20 8.62111V17.25C20 19.3211 18.3211 21 16.25 21H7.75C5.67893 21 4 19.3211 4 17.25V8.62111C3.39701 8.21748 3 7.5301 3 6.75V5.25ZM5.5 9V17.25C5.5 18.4926 6.50736 19.5 7.75 19.5H16.25C17.4926 19.5 18.5 18.4926 18.5 17.25V9H5.5ZM5.25 4.5C4.83579 4.5 4.5 4.83579 4.5 5.25V6.75C4.5 7.16421 4.83579 7.5 5.25 7.5H18.75C19.1642 7.5 19.5 7.16421 19.5 6.75V5.25C19.5 4.83579 19.1642 4.5 18.75 4.5H5.25Z" fill="currentColor"/>\\n</svg>',
    warning: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M12.9993 17C12.9993 16.4484 12.5522 16.0013 12.0006 16.0013C11.4491 16.0013 11.002 16.4484 11.002 17C11.002 17.5515 11.4491 17.9986 12.0006 17.9986C12.5522 17.9986 12.9993 17.5515 12.9993 17ZM12.7401 9.1467C12.6901 8.78066 12.3761 8.49876 11.9964 8.49906C11.5822 8.49939 11.2467 8.83545 11.247 9.24966L11.2506 13.7513L11.2575 13.853C11.3075 14.2191 11.6215 14.501 12.0012 14.5007C12.4154 14.5003 12.7509 14.1643 12.7506 13.7501L12.747 9.24846L12.7401 9.1467ZM13.9693 3.65888C13.113 2.11108 10.8878 2.1111 10.0316 3.65893L2.28634 17.6604C1.45678 19.16 2.5414 20.9995 4.25518 20.9995H19.7462C21.46 20.9995 22.5446 19.16 21.715 17.6603L13.9693 3.65888ZM11.3442 4.38501C11.6296 3.86907 12.3713 3.86906 12.6567 4.38499L20.4025 18.3865C20.679 18.8863 20.3175 19.4995 19.7462 19.4995H4.25518C3.68392 19.4995 3.32238 18.8863 3.5989 18.3865L11.3442 4.38501Z" fill="currentColor"/>\\n</svg>'
};

});

parcelRegister("fCCqU", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5f8379bfab20d8c$export$2e2bcd8739ae039);
var $b5f8379bfab20d8c$export$2e2bcd8739ae039 = {};

});

parcelRegister("6lcti", function(module, exports) {

$parcel$export(module.exports, "default", () => $49de60d5d4f6abf9$export$2e2bcd8739ae039);
var $49de60d5d4f6abf9$export$2e2bcd8739ae039 = {};

});

parcelRegister("bnYmV", function(module, exports) {

$parcel$export(module.exports, "default", () => $84a0abb16d5b174f$export$2e2bcd8739ae039);
var $84a0abb16d5b174f$export$2e2bcd8739ae039 = {};

});

parcelRegister("6JsA3", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e6d1d8697baa3ed$export$2e2bcd8739ae039);
var $4e6d1d8697baa3ed$export$2e2bcd8739ae039 = {};

});


parcelRegister("2cgfT", function(module, exports) {

$parcel$export(module.exports, "default", () => $19994fc143223303$export$2e2bcd8739ae039);
// Workspace app envs. Resolves the workspace wrapper URL by environment.
//
// Single source of truth for the wrapper base lives at
// `shared/functions/workspaceApiBase.js` — every consumer (SDK init,
// Supabase passthrough, this file) calls through it so a single override
// flips every endpoint at once.

var $3WCJD = parcelRequire("3WCJD");

var $ccUH0 = parcelRequire("ccUH0");
const $19994fc143223303$var$RESOLVE_API_URL = ()=>(0, $ccUH0.workspaceApiBase)();
var $19994fc143223303$export$2e2bcd8739ae039 = {
    workspaceApiUrl: $19994fc143223303$var$RESOLVE_API_URL(),
    symbolsApiUrl: (0, $3WCJD.apiUrl)()
};

});

parcelRegister("1bum8", function(module, exports) {

$parcel$export(module.exports, "workspaceTokenProvider", () => $0dce5d92d418f38a$export$8b2072aeb6489469);
// Workspace JWT provider for @symbo.ls/sdk WorkspaceProjectService.
//
// The wrapper at next.api.symbols.app/workspace authenticates each
// request by reading `Authorization: Bearer <jwt>`. The wrapper extracts
// `workspace_id` (or `app_metadata.workspace_id`) from the JWT to scope
// RLS server-side. The Symbols SDK's own token (`/core/auth/login`) does
// NOT carry that claim — only the GOVERNANCE Supabase JWT does. The
// federation layer (sdk-bridge `loginAll`) signs the user into BOTH
// systems and writes the governance JWT to localStorage under
// `sb-<governance-ref>-auth-token`; we read it from there directly so
// the workspace wrapper accepts our calls.
//
// SDK boot wires this via context.workspaceProjectTokenProvider, so every
// `sdk.workspaceProject.*` call inherits the token automatically.

var $ghHor = parcelRequire("ghHor");

var $iikzf = parcelRequire("iikzf");
let $0dce5d92d418f38a$var$_cachedToken = null;
let $0dce5d92d418f38a$var$_cachedAt = 0;
let $0dce5d92d418f38a$var$_missingWarned = false;
let $0dce5d92d418f38a$var$_expiredWarned = false;
const $0dce5d92d418f38a$var$CACHE_TTL_MS = 30000;
async function $0dce5d92d418f38a$export$8b2072aeb6489469() {
    const now = Date.now();
    if ($0dce5d92d418f38a$var$_cachedToken && now - $0dce5d92d418f38a$var$_cachedAt < $0dce5d92d418f38a$var$CACHE_TTL_MS) return $0dce5d92d418f38a$var$_cachedToken;
    try {
        const token = (0, $ghHor.governanceSessionAccessToken)();
        if (!token) {
            if (!$0dce5d92d418f38a$var$_missingWarned) {
                $0dce5d92d418f38a$var$_missingWarned = true;
                console.warn('[workspaceTokenProvider] No governance Supabase JWT in localStorage \u2014 /workspace/* calls will 401 with "missing bearer token". The Symbols SDK token does NOT carry the workspace_id claim required by the wrapper. Sign in via the federated login flow (loginAll) to write sb-<governance-ref>-auth-token. Run `__auth.diagnose()` for a full snapshot.');
            }
            return null;
        }
        const expSec = (0, $iikzf.readGovernanceClaims)().exp;
        if (expSec && expSec * 1000 < now) {
            if (!$0dce5d92d418f38a$var$_expiredWarned) {
                $0dce5d92d418f38a$var$_expiredWarned = true;
                console.warn("[workspaceTokenProvider] Governance Supabase JWT in localStorage is expired \u2014 " + `expired at ${new Date(expSec * 1000).toISOString()}. ` + '/workspace/* calls will 401. Sign out + sign in again to refresh, or rely on Supabase auth-js auto-refresh. ' + 'Run `__auth.diagnose()` for a full snapshot.');
            }
            return null;
        }
        $0dce5d92d418f38a$var$_missingWarned = false;
        $0dce5d92d418f38a$var$_expiredWarned = false;
        $0dce5d92d418f38a$var$_cachedToken = token;
        $0dce5d92d418f38a$var$_cachedAt = now;
        return $0dce5d92d418f38a$var$_cachedToken;
    } catch (err) {
        console.warn('[workspaceTokenProvider] unexpected error:', err?.message || err);
        return null;
    }
}
function $0dce5d92d418f38a$export$3723d1654f7e67cf() {
    $0dce5d92d418f38a$var$_cachedToken = null;
    $0dce5d92d418f38a$var$_cachedAt = 0;
    $0dce5d92d418f38a$var$_missingWarned = false;
    $0dce5d92d418f38a$var$_expiredWarned = false;
}

});

parcelRegister("gPZqo", function(module, exports) {
module.exports = Promise.all([
    import("9YFPt"),
    import("hGTya"),
    import("4H5dc")
]).then(()=>parcelRequire('h8E5D'));

});

parcelRegister("538pd", function(module, exports) {
module.exports = Promise.all([
    import("dUX7Y"),
    import("9B0SM")
]).then(()=>parcelRequire('kqtSr'));

});

parcelRegister("leBEJ", function(module, exports) {
module.exports = import("9YFPt").then(()=>parcelRequire('8P2Kd'));

});

parcelRegister("WNFkw", function(module, exports) {
module.exports = import("hGTya").then(()=>parcelRequire('dzkt5'));

});

/**
 * Workspace shell — unified Parcel entry.
 *
 * Boot sequence (mirrors RUNNER_ARCHITECTURE.md §Boot sequence):
 *  1. Early lang/theme from localStorage (synchronous, first-paint)
 *  2. bootShell: polyglot init → ensureSDKInit → registerSdkAdapter
 *     → auth gate → eager USER/ORG/WORKSPACE/WP fetch → mount shell
 *  3. dispatchUrl: initial route → lazy-load sub-app or shared page into Slot
 *  4. wireGlobalListeners: popstate + cross-tab storage events
 *
 * Phase 8: app manifests imported from each sub-app package.
 * Each manifest declares key, routes, i18nNamespaces, app/context lazy
 * imports, and optional fetchOnMount / onParamsChange lifecycle hooks.
 */ 
var $9XTDn = parcelRequire("9XTDn");
/**
 * wireGlobalListeners — popstate handler + cross-tab storage events.
 *
 * Called once after the shell mounts and the initial dispatch has run.
 *
 * Handles:
 *   - popstate: re-dispatch on browser back/forward
 *   - storage 'activeOrg': switchOrg (cross-tab)
 *   - storage 'activeWorkspace': switchWorkspace (cross-tab)
 *   - storage 'activeWorkspaceProject': switchWorkspaceProject (cross-tab)
 *   - storage 'logout': clear all state + redirect to /login
 *   - storage 'themeMode': update <html data-theme> + state
 *   - storage 'lang': call setLang with skipPersist (avoid echo loop)
 */ parcelRequire("8augU");
var $5SInI = parcelRequire("5SInI");
// APP_DISPATCH table — flat URL → page lookup.
// First match wins. Rules are ordered from most specific to most general.
//
// Sub-app pages live in the unified `pages` map (built in context.js from
// every sub-app's pages/index.js) and the smbls 3.14 auto-router mounts
// the matched page directly into Slot via `customRouterElement: ['Slot']`.
// dispatchUrl no longer Slot.set()s sub-app wrappers — that double-mount
// was burying matched pages under the wrapper's own children (e.g. canvas
// /studio/* rendered only the canvas wrapper chrome, never the studios
// page itself). Wrappers' cross-cutting chrome (AppAssistant, ChatDrawer,
// InstallableModalStub) lives on the workspace shell's app.js so it's
// available regardless of which sub-app's page is active.
//
// dispatchUrl keeps `page:` entries for shell-direct shared pages that
// AREN'T in the sub-app pages map (auth, account, admin, etc.).
const $f815ab4ab17a8889$export$1cb272df1e4c0433 = [
    // Shell-direct pages — these aren't in sub-app pages maps because
    // they're shared chrome surfaces (login, account settings, admin).
    {
        match: [
            '/login',
            '/signup',
            '/forgot-password',
            '/verify-email'
        ],
        page: 'auth'
    },
    {
        match: [
            '/profile',
            '/orgs'
        ],
        page: 'account'
    },
    {
        match: /^\/account(\/|$)/,
        page: 'account'
    },
    {
        match: /^\/admin(\/|$)/,
        page: 'admin'
    },
    {
        match: [
            '/workspaces'
        ],
        page: 'workspaces'
    },
    {
        match: [
            '/projects'
        ],
        page: 'projects'
    }
];
const $f815ab4ab17a8889$export$127cac04d022610d = (path, table = $f815ab4ab17a8889$export$1cb272df1e4c0433)=>{
    for (const entry of table){
        const m = entry.match;
        if (Array.isArray(m) && m.includes(path)) return entry;
        if (typeof m === 'string' && m === path) return entry;
        if (m instanceof RegExp && m.test(path)) return entry;
    }
    return null;
};





const $f815ab4ab17a8889$export$ccd9f85f09e2ee22 = {
    auth: ()=>Promise.resolve((parcelRequire("2ruDb"))).then((m)=>m.login),
    account: ()=>(parcelRequire("2qyIL")).then((m)=>m.account),
    admin: ()=>(parcelRequire("1YTED")).then((m)=>m.admin),
    workspaces: ()=>Promise.resolve((parcelRequire("la1ZO"))).then((m)=>m.profile),
    projects: ()=>Promise.resolve((parcelRequire("la1ZO"))).then((m)=>m.profile)
};




const $f815ab4ab17a8889$export$9c874e9767e86747 = {
    workspaceProject: ()=>(parcelRequire("kIp89")).then((m)=>m.default || m),
    canvas: ()=>(parcelRequire("2Wz2s")).then((m)=>m.default || m),
    marketplace: ()=>(parcelRequire("e2TcQ")).then((m)=>m.default || m),
    preview: ()=>(parcelRequire("jyJ3a")).then((m)=>m.default || m)
};
const $f815ab4ab17a8889$export$4edaf5fea8e0a2d4 = async (shell, path)=>{
    const target = $f815ab4ab17a8889$export$127cac04d022610d(path);
    if (!target) // 404: render nothing (slot is empty)
    return;
    if (target.page) {
        const importFn = $f815ab4ab17a8889$export$ccd9f85f09e2ee22[target.page];
        if (importFn) {
            const page = await importFn().catch(()=>null);
            if (page && shell.Slot) shell.Slot.set?.(page);
        }
        return;
    }
    if (target.app) {
        const importFn = $f815ab4ab17a8889$export$9c874e9767e86747[target.app];
        if (importFn) {
            const appDef = await importFn().catch(()=>null);
            if (appDef && shell.Slot) shell.Slot.set?.(appDef);
        }
    }
};



var $f4Q74 = parcelRequire("f4Q74");

var $hN8C9 = parcelRequire("hN8C9");

var $5NIGv = parcelRequire("5NIGv");

var $KNDYr = parcelRequire("KNDYr");
// Resolve the scratch theme token to a concrete 'light' | 'dark' value.
// 'auto' defers to the OS preference.
const $4a243cc9d43c5a33$var$resolveTheme = (mode)=>{
    if (mode === 'dark') return 'dark';
    if (mode === 'light') return 'light';
    // 'auto'
    return window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
};
const $4a243cc9d43c5a33$export$65f3055c61a76812 = (shell, { apps: apps, fallbackRoute: fallbackRoute = '/' } = {})=>{
    // --- popstate ---
    window.addEventListener('popstate', async ()=>{
        const path = window.location.pathname + window.location.search;
        await (0, $f815ab4ab17a8889$export$4edaf5fea8e0a2d4)(shell, path);
    });
    // --- cross-tab storage events ---
    window.addEventListener('storage', async (e)=>{
        // Null new value means the key was removed — ignore.
        if (e.newValue === null) return;
        const state = shell.state?.root || shell.state;
        // Lazy-resolve SDK + queryClient from context so we don't need to pass
        // them as parameters. The shell's context is attached by bootShell.
        const sdk = shell.context?.sdk || null;
        const queryClient = shell.context?.queryClient || null;
        if (e.key === 'activeOrg' && state?.org?.id !== e.newValue) {
            if (sdk && queryClient) await (0, $f4Q74.switchOrg)(state, sdk, queryClient, e.newValue);
        }
        if (e.key === 'activeWorkspace' && state?.workspace?.id !== e.newValue) {
            if (sdk && queryClient) await (0, $hN8C9.switchWorkspace)(state, sdk, queryClient, e.newValue);
        }
        if (e.key === 'activeWorkspaceProject' && state?.workspaceProject?.id !== e.newValue) {
            if (sdk && queryClient) await (0, $5NIGv.switchWorkspaceProject)(state, sdk, queryClient, e.newValue);
        }
        if (e.key === 'logout') {
            // Another tab signed out — mirror the logout locally.
            if (sdk && queryClient) await (0, $KNDYr.logout)(state, sdk, queryClient);
            else window.history.replaceState(null, '', '/login');
        }
        if (e.key === 'themeMode') {
            const resolved = $4a243cc9d43c5a33$var$resolveTheme(e.newValue);
            (0, $5SInI.changeGlobalTheme)(resolved);
            if (state) state.themeMode = e.newValue;
        }
        if (e.key === 'lang' && e.newValue && state?.lang !== e.newValue) {
            // setLang is a shared function — invoke via el.call convention once
            // the shell is fully mounted. For cross-tab events we call it directly.
            const setLang = shell.context?.methods?.setLang;
            if (typeof setLang === 'function') await setLang(e.newValue, {
                skipPersist: true
            });
            else if (state) state.lang = e.newValue;
        }
    });
};


// Unified shell context — composed from all sub-app registries.
//
// Why pages must be here (not just in each sub-app context):
//   The smbls router calls `matchRoute(pathname, element.routes)` where
//   `element.routes` is populated from `context.pages` during preparePages().
//   `element` is the ROOT element created by `create(shellApp, context)`.
//   When dispatchUrl() mounts a sub-app via shell.Slot.set(appDef), that sub-app
//   shares the shell's context — its `extends: 'Page'` triggers the router on
//   the root context's pages map. So ALL routes from ALL sub-apps must live here.
//
// Merge precedence (last writer wins for duplicate paths):
//   1. canvas      — /dashboard, /studio/*, /:owner/:projectKey catchall
//   2. marketplace — /marketplace
//   3. preview     — /preview
//   4. cms         — /cms
//   5. workspace-project — / and all workspace routes (highest priority, wins conflicts)
//
// Auth pages (login, signup, etc.) are included in workspace-project's pages
// via identity-index.js, so they don't need a separate import here.
//
// Components/functions/methods: workspace-project is the primary sub-app.
// Its context is the most complete registry; canvas and others supplement via
// their own sharedLibraries. The shell inherits shared/ via sharedLibraries
// (AppNavbar, AppShell, etc.) — workspace-project adds intranet-specific pieces.
//
// SDK wiring: workspaceApiUrl + workspaceProjectTokenProvider are exported
// so bootShell's Pattern B (extended) can auto-instantiate the SDK even
// for multi-app shells. See shared/functions/bootShell.js.

var $iP3Sw = parcelRequire("iP3Sw");

var $hmqhZ = parcelRequire("hmqhZ");
var $1ab92f2a34297c1f$export$2e2bcd8739ae039 = [
    (0, $iP3Sw.default),
    (0, $hmqhZ.default)
];


// Shell state schema — all four scope tiers in a single flat object.
//
// Scope cascade (larger scope clears smaller when switching):
//   USER → ORG → ┬── WORKSPACE → PROJECT
//                └── WORKSPACE PROJECT
//
// Switcher functions in shared/functions/switchers/ manage clearing.
// Activity entities (tickets, chats) are NOT stored here — they are
// fetched declaratively via fetch: props and cached by the fetch plugin.
var $48195c38f06bffa3$export$2e2bcd8739ae039 = {
    // USER scope — logout invalidates
    user: null,
    preferences: {},
    themeMode: 'auto',
    lang: 'en',
    // ORG scope — switchOrg invalidates (cascades to all below)
    // `orgs` is the membership list (from JWT app_metadata.orgs); `org` is
    // the active one. AppWorkspaceSwitcher reads from JWT claims directly;
    // shell-state copies are the canonical "you're signed in to N orgs"
    // surface for everywhere else.
    orgs: [],
    org: null,
    permissions: null,
    orgMembers: null,
    orgRoles: null,
    orgTeams: null,
    // WORKSPACE scope — switchWorkspace invalidates
    // `workspaces` is the membership list (from JWT app_metadata.workspaces);
    // `workspace` is the active one matching `active_workspace_id`.
    workspaces: [],
    workspace: null,
    workspaceMembers: null,
    workspaceIntegrations: null,
    workspaceBilling: null,
    // Org-switcher transient UI flags. Declared explicitly because smbls
    // 3.14 root.update() drops keys not in the schema (treats state as a
    // typed bag). `_wsSwitching` drives AppWorkspaceSwitchOverlay;
    // `_wsMenuOpen` controls the org dropdown's open/close state.
    // `_pendingActiveOrgId` is the optimistic-pick override the org
    // switcher reads so the dropdown reflects the click instantly,
    // without waiting on the server JWT refresh round-trip.
    _wsSwitching: null,
    _wsMenuOpen: false,
    _pendingActiveOrgId: null,
    _loginLoading: false,
    // Workspace-project private data — populated by `loadPrivateData`
    // (workspace-project/functions/loadPrivateData.js) on every sign-in
    // and re-fetched on org-switch. Must be declared here because the
    // smbls 3.14 router mounts pages directly into Slot without
    // instantiating the workspace-project wrapper that previously owned
    // these keys via its `fetch: [...]` transform / per-app state.js.
    peopleAll: [],
    teamsByEmail: {},
    orgMembersByOrgId: {},
    userDocs: null,
    userPrefs: null,
    companySettings: null,
    userGrants: [],
    valuations: [],
    resourceLinks: [],
    intranetEvents: [],
    jwtClaims: null,
    signedIn: false,
    currentUserEmail: '',
    currentUserId: '',
    orgNotifCount: {},
    // PROJECT scope — canvas-internal switchProject invalidates
    project: null,
    projectComponents: null,
    projectPages: null,
    projectState: null,
    // WORKSPACE PROJECT scope — switchWorkspaceProject invalidates
    workspaceProject: null,
    // Navigation
    currentPath: '/',
    currentSearch: '',
    // Unified-shell flag — sub-apps (workspace-project, canvas, …) read this
    // to hide their own IntranetAppHeader / CanvasAppHeader when they're
    // mounted INSIDE the shell, since the shell already renders the global
    // AppHeader. Standalone wrappers (workspace.localhost, canvas.localhost)
    // do not set this flag, so their app-specific headers keep rendering.
    _inShell: true
};



var $7MJvY = parcelRequire("7MJvY");

var $jcSut = parcelRequire("jcSut");
// Workspace-project private-data loader.
//
// Drives the workspace-project app's data hydration in response to auth
// transitions. Extracted from the app.js root onCreate closure because
// the smbls 3.14 auto-router mounts page DOMQL components directly into
// `Slot` from the shell's pages registry — the workspace-project wrapper
// never instantiates, so its `onCreate` never fires. The shell's
// `subscribeAuthSession` runs these callbacks instead. Kept as plain
// functions (not lifecycle hooks) so either entry point — shell auth
// subscription or sub-app onCreate when run standalone — can invoke them.
//
// `loadPrivateData` runs once per sign-in transition and hydrates
// people/teams/roles/userDocs/userPrefs + financials. `onWorkspaceChange`
// runs when the JWT's `active_workspace_id` flips for the same user
// (org switch); it re-fetches workspace-scoped tables in place + rebinds
// realtime channels so the UI never has to full-page-reload.

var $chzVb = parcelRequire("chzVb");

var $erP2O = parcelRequire("erP2O");

var $55iQs = parcelRequire("55iQs");
parcelRequire("g3lIy");
var $7m9HM = parcelRequire("7m9HM");

var $gu4Va = parcelRequire("gu4Va");

var $1o8nJ = parcelRequire("1o8nJ");

var $bdIjZ = parcelRequire("bdIjZ");

var $iikzf = parcelRequire("iikzf");
// Fresh-login race fix: SDK fires onAuthStateChange when symbols_access_token
// lands, BEFORE _fanOutBridgeLogin mints the governance JWT. Without the gov
// JWT, every /workspace/* call 401s ("missing bearer token"). Poll briefly
// for the gov JWT to land before starting the data hydration.
const $d3b12b37d39a471c$var$_waitForGovernanceJWT = async (timeoutMs = 10000, intervalMs = 100)=>{
    const claims = (0, $iikzf.readGovernanceClaims)();
    if (claims?.sub) return true;
    const deadline = Date.now() + timeoutMs;
    while(Date.now() < deadline){
        await new Promise((r)=>setTimeout(r, intervalMs));
        const c = (0, $iikzf.readGovernanceClaims)();
        if (c?.sub) return true;
    }
    return false;
};
// Symbols org — Mongo ObjectId. Currently a constant; will come from the
// JWT's active_workspace_id → workspace_org_id once the dual-source
// migration window closes.
const $d3b12b37d39a471c$var$SYMBOLS_ORG_ID = '69b77a61e0e0de1aa47d01cb';
const $d3b12b37d39a471c$var$_person = (r)=>({
        userId: r.user_id,
        email: r.email,
        name: r.name || 'Unknown',
        avatar: r.avatar || (0, $chzVb.initials)(r.name),
        position: r.position,
        location: r.location,
        timezone: r.timezone,
        github: r.github,
        linkedin: r.linkedin,
        twitter: r.twitter,
        birthday: r.birthday,
        start_date: r.start_date,
        end_date: r.end_date,
        status: r.status,
        monthly_stocks: r.monthly_stocks,
        stocks: r.stocks,
        bio: r.bio,
        pronouns: r.pronouns,
        startDate: r.start_date,
        endDate: r.end_date,
        monthlyStocks: r.monthly_stocks
    });
const $d3b12b37d39a471c$var$filterToActiveOrg = (peopleAll, root)=>{
    const orgMembersByOrgId = root?.orgMembersByOrgId || {};
    const activeOrgId = root?.org?.id || root?.jwtClaims?.workspace_org_id;
    const memberSet = activeOrgId ? orgMembersByOrgId[activeOrgId] : null;
    if (memberSet && typeof memberSet === 'object') {
        const set = memberSet instanceof Set ? memberSet : new Set(Object.keys(memberSet));
        if (set.size > 0) {
            const lower = new Set(Array.from(set).map((e)=>String(e || '').toLowerCase()));
            return peopleAll.filter((p)=>lower.has(String(p?.email || '').toLowerCase()));
        }
    }
    // Fallback: only return self when no member set is loaded
    const myEmail = String(root?.currentUserEmail || '').toLowerCase();
    if (!myEmail) return [];
    return peopleAll.filter((p)=>String(p?.email || '').toLowerCase() === myEmail);
};
const $d3b12b37d39a471c$var$_loadRoles = async (root, sdk)=>{
    try {
        const orgId = root?.jwtClaims?.workspace_org_id;
        if (!orgId) return;
        const result = await sdk.getOrgMemberRoles(orgId).catch(()=>null);
        const { members: members = [] } = result || {};
        const emailToUserId = {};
        for (const p of root.peopleAll || [])if (p.email && p.userId) emailToUserId[p.email.toLowerCase()] = p.userId;
        const byUser = {};
        for (const m of members){
            const uid = emailToUserId[(m.email || '').toLowerCase()];
            if (uid) byUser[uid] = m.role;
        }
        const prev = root.roles || {
            byUser: {},
            version: 0
        };
        root.update({
            roles: {
                ...prev,
                byUser: byUser,
                version: (prev.version || 0) + 1
            }
        });
    } catch (e) {
        console.warn('[workspace-project] member-roles fetch failed', e);
    }
};
const $d3b12b37d39a471c$export$e3141ac8004c427e = async (root, sdk)=>{
    if (!root || !sdk) return;
    // Wait for the governance JWT before any /workspace/* calls — SDK
    // login fires onAuthStateChange the moment symbols_access_token
    // lands, but federation (sdk-bridge loginAll) mints the governance
    // JWT a few hundred ms later. Without it, every workspace call 401s
    // because WorkspaceProjectService._resolveAuthHeader prefers the
    // governance JWT and the fallback path is intentionally rejected by
    // the wrapper for workspace-scoped routes.
    const govReady = await $d3b12b37d39a471c$var$_waitForGovernanceJWT();
    if (!govReady) console.warn("[workspace-project] governance JWT did not land within 10s \u2014 continuing with calls that may 401");
    // People + announcements + stories + resourceLinks come from the
    // workspace-project app's declarative `fetch: [...]` array, which only
    // runs when the wrapper component mounts. With the smbls auto-router
    // mounting pages directly into Slot the wrapper never instantiates, so
    // we hydrate those tables here. Run people first so `loadAllTeams`
    // (org-member filter) and `_loadRoles` (email→userId map) see the data.
    try {
        const data = await sdk.execute('workspaceProject.people', 'list');
        if (data) {
            const all = (data || []).map($d3b12b37d39a471c$var$_person);
            root.update({
                peopleAll: all,
                people: $d3b12b37d39a471c$var$filterToActiveOrg(all, root)
            });
        }
    } catch (e) {
        console.warn('[workspace-project] people fetch failed', e);
    }
    const me = (root.peopleAll || []).find((p)=>p.email === root.currentUserEmail);
    if (me && me.status === 'left') {
        await sdk.logout();
        if (typeof window !== 'undefined') window.location.reload();
        return;
    }
    await Promise.all([
        $d3b12b37d39a471c$var$_loadRoles(root, sdk),
        sdk.execute('workspaceProject.announcements', 'list', {
            order: 'date'
        }).then((data)=>{
            if (!data) return;
            root.update({
                announcements: data.map((r)=>({
                        id: r.id,
                        title: r.title,
                        author: r.author,
                        authorAvatar: r.author_avatar || (0, $chzVb.initials)(r.author),
                        authorRole: r.author_role,
                        date: r.date,
                        readTime: r.read_time,
                        tag: r.tag,
                        cover: r.cover,
                        excerpt: r.excerpt,
                        body: r.body,
                        reactions: r.reactions || {}
                    }))
            });
        }).catch((e)=>console.warn('[workspace-project] announcements fetch failed', e)),
        sdk.execute('workspaceProject.stories', 'list', {
            order: 'id'
        }).then((data)=>{
            if (data) root.update({
                stories: data
            });
        }).catch((e)=>console.warn('[workspace-project] stories fetch failed', e)),
        sdk.execute('workspaceProject.documents.resourceLinks', 'list').then((data)=>{
            if (data) root.update({
                resourceLinks: data
            });
        }).catch((e)=>console.warn('[workspace-project] resource_links fetch failed', e)),
        (0, $erP2O.loadAllTeams)(root).then((result)=>{
            const { teams: teams = [], teamsByEmail: teamsByEmail = {}, orgMembersByOrgId: orgMembersByOrgId = {} } = result || {};
            const people = $d3b12b37d39a471c$var$filterToActiveOrg(root.peopleAll || [], {
                ...root,
                orgMembersByOrgId: orgMembersByOrgId
            });
            root.update({
                teams: teams,
                teamsByEmail: teamsByEmail,
                orgMembersByOrgId: orgMembersByOrgId,
                people: people
            });
        }).catch((e)=>console.warn('[workspace-project] teams load failed', e)),
        sdk.execute('workspaceProject.documents.userDocuments', 'list', {
            userId: root.currentUserId
        }).then((data)=>{
            if (data) root.update({
                userDocs: data
            });
        }).catch((e)=>console.warn('[workspace-project] user_documents fetch failed', e)),
        sdk.execute('workspaceProject.userPreferences', 'get').then((data)=>{
            if (data) root.update({
                userPrefs: data
            });
        }).catch((e)=>console.warn('[workspace-project] user_preferences fetch failed', e)),
        (0, $bdIjZ.USE_FINANCIALS_PROJECT) ? (0, $7m9HM).getCompanySettings($d3b12b37d39a471c$var$SYMBOLS_ORG_ID).then(({ data: data })=>{
            if (data) root.update({
                companySettings: data
            });
        }).catch((e)=>console.warn('[workspace-project] financials.company_settings fetch failed', e)) : sdk.execute('workspaceProject.companySettings', 'get').then((data)=>{
            if (data) root.update({
                companySettings: data
            });
        }).catch((e)=>console.warn('[workspace-project] company_settings fetch failed', e)),
        (0, $bdIjZ.USE_FINANCIALS_PROJECT) ? (0, $7m9HM).listGrants({
            orgId: $d3b12b37d39a471c$var$SYMBOLS_ORG_ID
        }).then(({ data: data })=>{
            if (data) root.update({
                userGrants: data
            });
        }).catch((e)=>console.warn('[workspace-project] financials.grants fetch failed', e)) : sdk.execute('workspaceProject.userGrants', 'list', {
            order: 'vesting_start'
        }).then((data)=>{
            if (data) root.update({
                userGrants: data
            });
        }).catch((e)=>console.warn('[workspace-project] user_grants fetch failed', e)),
        (0, $bdIjZ.USE_FINANCIALS_PROJECT) ? (0, $7m9HM).listValuations($d3b12b37d39a471c$var$SYMBOLS_ORG_ID).then(({ data: data })=>{
            if (data) root.update({
                valuations: data
            });
        }).catch((e)=>console.warn('[workspace-project] financials.valuations fetch failed', e)) : sdk.execute('workspaceProject.valuations', 'list', {
            order: 'amount'
        }).then((data)=>{
            if (data) root.update({
                valuations: data
            });
        }).catch((e)=>console.warn('[workspace-project] valuations fetch failed', e)),
        (0, $55iQs.fetchOrgNotifCount)(root).catch((e)=>console.warn('[workspace-project] org-notifications fetch failed', e))
    ]);
};
const $d3b12b37d39a471c$export$430bd0b9e6ef441d = async (root, sdk, _newClaims)=>{
    if (!root || !sdk) return;
    (0, $1o8nJ.clearWorkspaceSwitchFallback)();
    try {
        const { teams: teams = [], teamsByEmail: teamsByEmail = {}, orgMembersByOrgId: orgMembersByOrgId = {} } = await (0, $erP2O.loadAllTeams)(root);
        const people = $d3b12b37d39a471c$var$filterToActiveOrg(root.peopleAll || [], {
            ...root,
            orgMembersByOrgId: orgMembersByOrgId
        });
        root.update({
            teams: teams,
            teamsByEmail: teamsByEmail,
            orgMembersByOrgId: orgMembersByOrgId,
            people: people
        });
    } catch (e) {
        console.warn('[workspace-project] workspace-change: teams reload failed', e);
    }
    await Promise.all([
        sdk.execute('workspaceProject.people', 'list').then((data)=>{
            if (!data) return;
            const all = data.map($d3b12b37d39a471c$var$_person);
            const people = $d3b12b37d39a471c$var$filterToActiveOrg(all, root);
            root.update({
                peopleAll: all,
                people: people
            });
        }).catch((e)=>console.warn('[workspace-project] workspace-change: people fetch failed', e)),
        sdk.execute('workspaceProject.announcements', 'list', {
            order: 'date'
        }).then((data)=>{
            if (!data) return;
            root.update({
                announcements: data.map((r)=>({
                        id: r.id,
                        title: r.title,
                        author: r.author,
                        authorAvatar: r.author_avatar || (0, $chzVb.initials)(r.author),
                        authorRole: r.author_role,
                        date: r.date,
                        readTime: r.read_time,
                        tag: r.tag,
                        cover: r.cover,
                        excerpt: r.excerpt,
                        body: r.body,
                        reactions: r.reactions || {}
                    }))
            });
        }).catch((e)=>console.warn('[workspace-project] workspace-change: announcements fetch failed', e)),
        (()=>{
            const min = new Date(Date.now() - 86400000).toISOString();
            const max = new Date(Date.now() + 1209600000).toISOString();
            return sdk.execute('workspaceProject.calendar', 'list', {
                filter: {
                    deleted: false,
                    start_at: {
                        gte: min,
                        lte: max
                    }
                },
                order: 'start_at',
                limit: 500
            }).then((data)=>{
                if (!data) return;
                const me = root.currentUserEmail || '';
                const byKey = new Map();
                for (const r of data){
                    const key = r.google_event_id || `local-${r.id}`;
                    const existing = byKey.get(key);
                    if (!existing) {
                        byKey.set(key, r);
                        continue;
                    }
                    if (r.google_calendar_id === me && existing.google_calendar_id !== me) byKey.set(key, r);
                }
                root.update({
                    intranetEvents: [
                        ...byKey.values()
                    ].map((r)=>({
                            id: r.id,
                            title: r.title,
                            startAt: r.start_at,
                            endAt: r.end_at,
                            location: r.description ? r.description.slice(0, 60) : '',
                            attendees: Array.isArray(r.invitees) ? r.invitees : [],
                            organizerEmail: r.organizer_email
                        }))
                });
            }).catch((e)=>console.warn('[workspace-project] workspace-change: calendar_events fetch failed', e));
        })(),
        sdk.execute('workspaceProject.stories', 'list', {
            order: 'id'
        }).then((data)=>{
            if (data) root.update({
                stories: data
            });
        }).catch((e)=>console.warn('[workspace-project] workspace-change: stories fetch failed', e)),
        sdk.execute('workspaceProject.documents.resourceLinks', 'list').then((data)=>{
            if (data) root.update({
                resourceLinks: data
            });
        }).catch((e)=>console.warn('[workspace-project] workspace-change: resource_links fetch failed', e)),
        sdk.execute('workspaceProject.documents.userDocuments', 'list', {
            userId: root.currentUserId
        }).then((data)=>{
            if (data) root.update({
                userDocs: data
            });
        }).catch((e)=>console.warn('[workspace-project] workspace-change: user_documents fetch failed', e)),
        (0, $55iQs.fetchOrgNotifCount)(root).catch((e)=>console.warn('[workspace-project] workspace-change: org-notifications fetch failed', e))
    ]);
    try {
        const mgr = (0, $gu4Va.getRealtimeManager)(root);
        mgr.rebindAll();
    } catch (e) {
        console.warn('[workspace-project] workspace-change: realtime rebind failed', e);
    }
    // Clear both the switch overlay AND the optimistic-pick override now
    // that the JWT refresh + data reload completed. `_pendingActiveOrgId`
    // is what `_activeOrg` reads to keep the dropdown looking switched
    // during the round-trip; once the real `jwtClaims.active_workspace_id`
    // catches up we let the JWT-derived path own the truth again.
    root.update({
        _wsSwitching: null,
        _pendingActiveOrgId: null
    });
};


// Shell DOMQL — AppHeader + smbls-default content + TranslationWatcher.
//
// AppHeader: persistent top header. Hidden on auth routes via `hide:`.
// content: smbls router renders the matched page here automatically —
//   no explicit Slot element needed. The default router places content
//   as row 2 (1fr) in the AppShell grid.
// TranslationWatcher: hidden i18n subscription (position:fixed, no grid row).
//
// AppShell grid (from appShellStyles):
//   gridTemplateRows: 'auto 1fr'
//   AppHeader → row 1 (auto). smbls content → row 2 (1fr, fills viewport).
//   When AppHeader is hidden (display:none on auth routes) it leaves the
//   grid — content expands to fill the full viewport automatically.
const $bf600ca7fd507110$var$AUTH_PATHS = /^\/(login|signin|signup|signup-confirmation|reset-password|forgot-password|verify-email)(\/|$)/;
const $bf600ca7fd507110$var$shellApp = {
    ...(0, $7MJvY.appShellStyles),
    height: '100dvh',
    overflow: 'hidden',
    onCreate: (el, s)=>{
        el.call?.('installAppShellSync', s);
        // The smbls default router mounts pages into a 'content' div that sits in
        // the grid's 1fr row. That div has display:flex with overflow:visible by
        // default — it expands beyond the grid cell and the shell clips it, making
        // pages unscrollable. overflow:auto + min-height:0 constrain content to
        // the grid cell so the user can scroll within it.
        if (typeof document !== 'undefined' && !document.getElementById('__shell-content-scroll')) {
            const s = document.createElement('style');
            s.id = '__shell-content-scroll';
            s.textContent = '[data-key="content"]{overflow:auto;min-height:0}';
            document.head.appendChild(s);
        }
        const resolveSdk = ()=>el.sdk || el.context?.methods?.sdk || null;
        el._unsubShellAuth = (0, $jcSut.subscribeAuthSession)(s.root, ()=>(0, $d3b12b37d39a471c$export$e3141ac8004c427e)(s.root, resolveSdk()), (claims)=>(0, $d3b12b37d39a471c$export$430bd0b9e6ef441d)(s.root, resolveSdk(), claims));
    },
    onRemove: (el)=>{
        el.call?.('uninstallAppShellSync');
        if (typeof el._unsubShellAuth === 'function') try {
            el._unsubShellAuth();
        } catch (_) {}
    },
    AppHeader: {
        hide: (el, s)=>{
            const path = s.root?.currentPath;
            return $bf600ca7fd507110$var$AUTH_PATHS.test(typeof path === 'string' ? path : typeof window !== 'undefined' ? window.location.pathname : '/');
        }
    },
    TranslationWatcher: {
        visibility: 'hidden',
        position: 'fixed',
        pointerEvents: 'none',
        width: '0',
        height: '0',
        overflow: 'hidden',
        fetch: {
            from: 'i18n.translations',
            method: 'subscribe',
            params: (el, s)=>({
                    lang: s.root?.lang || 'en',
                    namespace: 'all'
                })
        }
    },
    // Full-viewport "Switching to <org>…" overlay. Mounted at shell scope
    // (not inside a sub-app) so it covers the entire UI during the JWT
    // refresh round-trip. Driven by `root._wsSwitching`.
    AppWorkspaceSwitchOverlay: {}
};
var $bf600ca7fd507110$export$2e2bcd8739ae039 = $bf600ca7fd507110$var$shellApp;



var $3ihxA = parcelRequire("3ihxA");

var $81UX8 = parcelRequire("81UX8");

var $9KJq4 = parcelRequire("9KJq4");

var $7rj4F = parcelRequire("7rj4F");

var $1H7QU = parcelRequire("1H7QU");

var $88ocU = parcelRequire("88ocU");

var $chzVb = parcelRequire("chzVb");

var $1zOuk = parcelRequire("1zOuk");

var $8ePfR = parcelRequire("8ePfR");

var $1NMvY = parcelRequire("1NMvY");

var $jZHKS = parcelRequire("jZHKS");

var $cEU2a = parcelRequire("cEU2a");

var $aRHVO = parcelRequire("aRHVO");

var $21yLX = parcelRequire("21yLX");

var $ac7NT = parcelRequire("ac7NT");

var $5fy2E = parcelRequire("5fy2E");

var $2cgfT = parcelRequire("2cgfT");

var $3WCJD = parcelRequire("3WCJD");

var $1bum8 = parcelRequire("1bum8");
// Compose the full pages map.
// Order: canvas → marketplace → preview → workspace-project.
// workspace-project wins on conflicting routes (e.g. / resolves to wp main,
// not canvas's rootRedirect). Canvas auth routes (signin/signup) are
// overridden by wp identity pages so the intranet auth flow is consistent.
const $f4c2714a15e52021$var$pages = {
    ...(0, $9KJq4.default),
    ...(0, $7rj4F.default),
    ...(0, $1H7QU.default),
    ...(0, $81UX8.default)
};
// Merge sub-app state schema into the shell's. Shell keys win on
// conflicting schema names (the shell's `org`, `orgs`, `workspace`, …
// are JWT-derived; wp's older copies were org-switcher-internal and are
// superseded). Order: wp first → shell overrides.
const $f4c2714a15e52021$var$state = {
    ...(0, $3ihxA.default),
    ...(0, $48195c38f06bffa3$export$2e2bcd8739ae039)
};
var $f4c2714a15e52021$export$2e2bcd8739ae039 = {
    // smbls config flags + Supabase fetch adapter
    ...(0, $ac7NT.default),
    app: $bf600ca7fd507110$export$2e2bcd8739ae039,
    state: $f4c2714a15e52021$var$state,
    sharedLibraries: $1ab92f2a34297c1f$export$2e2bcd8739ae039,
    pages: // Unified route map — required for smbls router to match any path
    $f4c2714a15e52021$var$pages,
    // Component / function / method registries — merged from EVERY sub-app
    // because the shell's smbls router mounts each sub-app's pages directly
    // into Slot from the unified `pages` map. Each page references its own
    // sub-app's components by name (e.g. canvas's `WorkspaceRowButton`,
    // workspace-project's `IntranetAppHeader`); without this merge the
    // first-loaded sub-app's pages render correctly while every other
    // sub-app's pages render as bare chrome.
    // Order: canvas → marketplace → preview → workspace-project so
    // workspace-project's overrides win on key conflicts (matches the
    // pages-map precedence above).
    components: {
        ...$8ePfR,
        ...$cEU2a,
        ...$21yLX,
        ...$88ocU
    },
    // Order: canvas → marketplace → workspace-project so wp overrides win on
    // key conflicts (same precedence as components and pages above).
    functions: {
        ...$1NMvY,
        ...$aRHVO,
        ...$chzVb
    },
    methods: {
        ...$jZHKS,
        ...$1zOuk
    },
    // workspace-project's designSystem (icons, colors, fonts, spacing,
    // …). Must live under the `designSystem` key — smbls's
    // mergeSharedLibraries calls `deepDefaults(context.designSystem,
    // sharedLib.designSystem)`, so brand fills gaps under this exact
    // path. Spreading at top level would route brand's icons into
    // designSystem.icons while ours sit on context.icons (orphaned, not
    // in the sprite). Target wins on conflicts: workspace-project icons
    // override brand on shared keys; brand fills the rest.
    designSystem: (0, $5fy2E.default),
    // SDK contracts — consumed by bootShell (Pattern B extended) and
    // @symbo.ls/sdk WorkspaceDataService init
    workspaceApiUrl: (0, $2cgfT.default)?.workspaceApiUrl || (0, $2cgfT.default)?.symbolsApiUrl || (0, $3WCJD.apiUrl)(),
    workspaceProjectTokenProvider: $1bum8.workspaceTokenProvider
};




var $138cf877e1ab6db2$export$2e2bcd8739ae039 = {
    key: 'system--canvas',
    routes: [
        /^\/dashboard$/,
        /^\/profile$/,
        /^\/studio$/,
        /^\/[^/]+\/[^/]+/
    ],
    i18nNamespaces: [
        'canvas'
    ],
    app: ()=>(parcelRequire("2Wz2s")).then((m)=>m.default),
    context: ()=>(parcelRequire("gPZqo")).then((m)=>m.default),
    fetchOnMount: ({ state: state, sdk: sdk, params: params })=>{
        if (params?.owner && params?.project) return sdk.project.getProjectByKey({
            owner: params.owner,
            key: params.project
        }).then((p)=>{
            state.project = p;
        });
    },
    onParamsChange: ({ newParams: newParams, oldParams: oldParams, state: state, sdk: sdk })=>{
        if (newParams?.project !== oldParams?.project && newParams?.owner && newParams?.project) {
            state.project = null;
            state.projectComponents = null;
            state.projectPages = null;
            state.projectState = null;
            return sdk.project.getProjectByKey({
                owner: newParams.owner,
                key: newParams.project
            }).then((p)=>{
                state.project = p;
            });
        }
    }
};




var $206dadb06d39f2b6$export$2e2bcd8739ae039 = {
    key: 'system--workspace-project',
    routes: [
        /^\/$/,
        /^\/(login|signin|signup|signup-confirmation|reset-password)(\/|$)/,
        /^\/(tickets|chat|chats|calendar|inbox|epics|teams|meet|documents)(\/|$)/
    ],
    i18nNamespaces: [
        'workspace-project'
    ],
    app: ()=>(parcelRequire("kIp89")).then((m)=>m.default),
    context: ()=>(parcelRequire("538pd")).then((m)=>m.default),
    fetchOnMount: ({ state: state, sdk: sdk })=>{
        return sdk.workspaceProject?.notifications?.unreadCount()?.then((n)=>{
            state.notificationsUnread = n;
        });
    }
};




var $9de2cccf9bf743b4$export$2e2bcd8739ae039 = {
    key: 'system--marketplace',
    routes: [
        /^\/marketplace(\/|$)/
    ],
    i18nNamespaces: [
        'marketplace'
    ],
    app: ()=>(parcelRequire("e2TcQ")).then((m)=>m.default),
    context: ()=>(parcelRequire("leBEJ")).then((m)=>m.default)
};




var $49d193a3bb1b68c7$export$2e2bcd8739ae039 = {
    key: 'system--preview',
    routes: [
        /^\/preview(\/|$)/
    ],
    i18nNamespaces: [
        'preview'
    ],
    app: ()=>(parcelRequire("jyJ3a")).then((m)=>m.default),
    context: ()=>(parcelRequire("WNFkw")).then((m)=>m.default)
};


// Phase 8: full manifests replace Phase 7 stubs.
// Keyed by the app identifier used in APP_DISPATCH ('app' field).
// (cms/inspect/gazer packages aren't on disk in this branch — re-add the
// imports when those sub-apps land.)
const $913cff646c2976b1$var$apps = {
    workspaceProject: (0, $206dadb06d39f2b6$export$2e2bcd8739ae039),
    canvas: (0, $138cf877e1ab6db2$export$2e2bcd8739ae039),
    marketplace: (0, $9de2cccf9bf743b4$export$2e2bcd8739ae039),
    preview: (0, $49d193a3bb1b68c7$export$2e2bcd8739ae039)
};


(async ()=>{
    const shell = await (0, $9XTDn.bootShell)({
        apps: $913cff646c2976b1$var$apps,
        defaultApp: 'workspaceProject',
        fallbackRoute: '/',
        context: $f4c2714a15e52021$export$2e2bcd8739ae039
    });
    if (!shell) {
        // Auth gate bounced — bootShell already set URL to /login and returned null.
        // Mount the shell manually so auth pages (login, signup, etc.) render.
        // The smbls router fires onRenderRouter during create() and auto-routes
        // to /login (which is in context.pages via wpPages), so no manual
        // dispatchUrl call is needed.
        const { create: create } = await Promise.resolve((parcelRequire("8augU")));
        const { getSDK: getSDK } = await Promise.resolve((parcelRequire("bfqVY")));
        try {
            const sdk = getSDK();
            if (!(0, $f4c2714a15e52021$export$2e2bcd8739ae039).methods) (0, $f4c2714a15e52021$export$2e2bcd8739ae039).methods = {};
            (0, $f4c2714a15e52021$export$2e2bcd8739ae039).methods.sdk = sdk;
        } catch (e) {
            console.warn('[workspace-shell] auth-bounce SDK init failed:', e?.message || e);
        }
        if ((0, $f4c2714a15e52021$export$2e2bcd8739ae039).state && !Array.isArray((0, $f4c2714a15e52021$export$2e2bcd8739ae039).state.notifications)) (0, $f4c2714a15e52021$export$2e2bcd8739ae039).state.notifications = [];
        const authShell = await create((0, $f4c2714a15e52021$export$2e2bcd8739ae039).app, (0, $f4c2714a15e52021$export$2e2bcd8739ae039));
        (0, $4a243cc9d43c5a33$export$65f3055c61a76812)(authShell, {
            apps: $913cff646c2976b1$var$apps,
            fallbackRoute: '/login'
        });
        return;
    }
    (0, $4a243cc9d43c5a33$export$65f3055c61a76812)(shell, {
        apps: $913cff646c2976b1$var$apps,
        fallbackRoute: '/'
    });
})();


//# sourceMappingURL=workspace.61345c0e.js.map
